/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(45);
	
	var _frame = __webpack_require__(46);
	
	var _frame2 = _interopRequireDefault(_frame);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	var _componentsCommonAuthenticatedComponent = __webpack_require__(435);
	
	var _componentsCommonRoleBasedRoute = __webpack_require__(436);
	
	var _containersLogin = __webpack_require__(437);
	
	var _containersLogin2 = _interopRequireDefault(_containersLogin);
	
	var _containersForgot = __webpack_require__(438);
	
	var _containersForgot2 = _interopRequireDefault(_containersForgot);
	
	var _containersResetpassword = __webpack_require__(440);
	
	var _containersResetpassword2 = _interopRequireDefault(_containersResetpassword);
	
	var _containersRegister = __webpack_require__(441);
	
	var _containersRegister2 = _interopRequireDefault(_containersRegister);
	
	//import Maintenance from 'components/pages/maintenance';
	//----------- Pages are inside frame
	
	var _componentsPagesOverview = __webpack_require__(442);
	
	var _componentsPagesOverview2 = _interopRequireDefault(_componentsPagesOverview);
	
	var _componentsPagesLocations = __webpack_require__(1258);
	
	var _componentsPagesLocations2 = _interopRequireDefault(_componentsPagesLocations);
	
	var _componentsPagesComparison = __webpack_require__(1270);
	
	var _componentsPagesComparison2 = _interopRequireDefault(_componentsPagesComparison);
	
	var _componentsPagesStats = __webpack_require__(1287);
	
	var _componentsPagesStats2 = _interopRequireDefault(_componentsPagesStats);
	
	var _componentsPagesLive = __webpack_require__(1303);
	
	var _componentsPagesLive2 = _interopRequireDefault(_componentsPagesLive);
	
	var _componentsPagesHeatmap = __webpack_require__(1315);
	
	var _componentsPagesHeatmap2 = _interopRequireDefault(_componentsPagesHeatmap);
	
	var _componentsPagesDevicemanagement = __webpack_require__(1884);
	
	var _componentsPagesDevicemanagement2 = _interopRequireDefault(_componentsPagesDevicemanagement);
	
	var _componentsPagesUser = __webpack_require__(1900);
	
	var _componentsPagesUser2 = _interopRequireDefault(_componentsPagesUser);
	
	var _componentsPagesFaq = __webpack_require__(1904);
	
	var _componentsPagesFaq2 = _interopRequireDefault(_componentsPagesFaq);
	
	var _componentsPagesApi = __webpack_require__(1906);
	
	var _componentsPagesApi2 = _interopRequireDefault(_componentsPagesApi);
	
	var _componentsPagesLivefeed = __webpack_require__(1908);
	
	var _componentsPagesLivefeed2 = _interopRequireDefault(_componentsPagesLivefeed);
	
	var _componentsPagesLivefeedEditor = __webpack_require__(1920);
	
	var _componentsPagesLivefeedEditor2 = _interopRequireDefault(_componentsPagesLivefeedEditor);
	
	//------------settings
	
	var _componentsPagesDefaultsettings = __webpack_require__(2293);
	
	var _componentsPagesDefaultsettings2 = _interopRequireDefault(_componentsPagesDefaultsettings);
	
	var _componentsPagesSensorsettings = __webpack_require__(2297);
	
	var _componentsPagesSensorsettings2 = _interopRequireDefault(_componentsPagesSensorsettings);
	
	var _componentsPagesSettingsMyaccount = __webpack_require__(2302);
	
	var _componentsPagesSettingsMyaccount2 = _interopRequireDefault(_componentsPagesSettingsMyaccount);
	
	var _countriesAndTimezones = __webpack_require__(1263);
	
	var _countriesAndTimezones2 = _interopRequireDefault(_countriesAndTimezones);
	
	var _uifabricIcons = __webpack_require__(2304);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	_toastr2['default'].options = {
		"closeButton": true,
		"debug": true,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toast-bottom-right",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "300",
		"timeOut": "3000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	};
	
	_countriesAndTimezones2['default'].getAllCountries()["--"] = {
		"id": "--",
		"name": "--",
		"timezones": ["UTC"]
	};
	_countriesAndTimezones2['default'].getAllTimezones()["UTC"] = {
		"name": "UTC",
		"utcOffset": 0,
		"offsetStr": "00:00",
		"countries": ["--"]
	};
	document.charts = {};
	
	(0, _uifabricIcons.initializeIcons)();
	_reactDom2['default'].render(_react2['default'].createElement(
		_reactRedux.Provider,
		{ store: _store2['default'] },
		_react2['default'].createElement(
			_reactRouter.Router,
			{ history: _componentsCommonAppHistory2['default'], onUpdate: function () {
					return window.scrollTo(0, 0);
				} },
			_react2['default'].createElement(
				_reactRouter.Route,
				{ path: '/', component: (0, _componentsCommonAuthenticatedComponent.requireAuthentication)(_frame2['default']) },
				_react2['default'].createElement(_reactRouter.IndexRoute, { component: _componentsPagesOverview2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/comparison', component: _componentsPagesComparison2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/statistic/:id', component: _componentsPagesStats2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/live/:id', component: _componentsPagesLive2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/heatmap/:id', component: _componentsPagesHeatmap2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/user', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesUser2['default']) }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/faq', component: _componentsPagesFaq2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/locations', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesLocations2['default']) }),
				' ',
				_react2['default'].createElement(_reactRouter.Route, { path: '/devicemanagement/:id', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesDevicemanagement2['default']) }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/api', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesApi2['default']) }),
				' ',
				_react2['default'].createElement(_reactRouter.Route, { path: '/livefeed', component: _componentsPagesLivefeed2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/livefeed/editor', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesLivefeedEditor2['default']) }),
				' ',
				_react2['default'].createElement(
					_reactRouter.Route,
					{ path: '/settings' },
					_react2['default'].createElement(_reactRouter.Route, { path: '/settings/default', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesDefaultsettings2['default']) }),
					' ',
					_react2['default'].createElement(_reactRouter.Route, { path: '/settings/sensor', component: (0, _componentsCommonRoleBasedRoute.roleBasedRoute)(_componentsPagesSensorsettings2['default']) }),
					_react2['default'].createElement(_reactRouter.Route, { path: '/settings/ownaccount', component: _componentsPagesSettingsMyaccount2['default'] })
				)
			),
			_react2['default'].createElement(_reactRouter.Route, { path: '/login', component: _containersLogin2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/forgot', component: _containersForgot2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/resetpassword', component: _containersResetpassword2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/invitation', component: _containersRegister2['default'] })
		)
	), document.getElementById('app'));
	{/*false ?
	 		<Router history={appHistory}>
	 			<Route path="/" component={Maintenance} />
	 			<Redirect from="*" to="/" />
	 		</Router>
	 		:
	 	*/}
	/* not for local user*/ /* only for company admin*/ /* not for local user*/ /* not for local user*/ /* not for local user*/ /* not for local user*/

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(39);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(40),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(42);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(38),n=__webpack_require__(40),r=__webpack_require__(43);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(44);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa4c14e77a2a7086691bec6af01f8b8d.ico";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var _actionsOverview = __webpack_require__(200);
	
	__webpack_require__(379);
	
	var _actionsDefaultsettings = __webpack_require__(362);
	
	var _actionsNode = __webpack_require__(202);
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var _actionsDevicemanagement = __webpack_require__(350);
	
	var _componentsCommonLoading = __webpack_require__(412);
	
	var _componentsCommonLoading2 = _interopRequireDefault(_componentsCommonLoading);
	
	var _containersToolbar = __webpack_require__(413);
	
	var _containersToolbar2 = _interopRequireDefault(_containersToolbar);
	
	var _componentsCommonScrolltop = __webpack_require__(434);
	
	var _componentsCommonScrolltop2 = _interopRequireDefault(_componentsCommonScrolltop);
	
	var Frame = (function (_React$Component) {
	    _inherits(Frame, _React$Component);
	
	    function Frame(props) {
	        _classCallCheck(this, Frame);
	
	        _get(Object.getPrototypeOf(Frame.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            cardLoaded: false,
	            treeLoaded: false,
	            liveLoaded: false,
	            imageLoaded: false,
	            configLoaded: false
	        };
	    }
	
	    _createClass(Frame, [{
	        key: 'handleTreeClick',
	        value: function handleTreeClick(node) {
	            if (this.props.location.pathname.includes("/statistic") || this.props.location.pathname == "/" || this.props.location.pathname.includes("/comparison") || this.props.location.pathname.includes("/settings/sensor")) {
	                _componentsCommonAppHistory2['default'].push('/statistic/' + node.id);
	            } else if (this.props.location.pathname.includes("/live")) {
	                _componentsCommonAppHistory2['default'].push('/live/' + node.id);
	            } else if (this.props.location.pathname.includes("/heatmap")) {
	                _componentsCommonAppHistory2['default'].push('/heatmap/' + node.id);
	            } else {
	                this.props.dispatch((0, _actionsOverview.setCurrentNode)(node));
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var chain = function chain() {
	                return _this.props.dispatch((0, _actionsMyaccount.fetchCurrentUser)()).then(function (res) {
	                    console.log("res", res);
	                    _this.props.dispatch((0, _actionsDefaultsettings.fetchCard)()).then(function () {
	                        return _this.setState({ cardLoaded: true });
	                    });
	                    _this.props.dispatch((0, _actionsOverview.fetchCustomerOverview)()).then(function () {
	                        return _this.setState({ treeLoaded: true });
	                    });
	                    _this.props.dispatch((0, _actionsNode.fetchLiveData)()).then(function () {
	                        return _this.setState({ liveLoaded: true });
	                    });
	                    _this.props.dispatch((0, _actionsFloorplan.fetchImage)()).then(function () {
	                        return _this.setState({ imageLoaded: true });
	                    });
	                    _this.props.dispatch((0, _actionsDevicemanagement.fetchConfig)());
	                })['catch'](function (err) {
	                    console.log(err);
	                });
	            };
	
	            console.log(this.props.location.query);
	            if (this.props.apikey != this.props.location.query["apikey"]) {
	                this.props.dispatch((0, _actionsAuthentication.setAPIKey)(this.props.location.query["apikey"])).then(function () {
	                    return chain();
	                });
	            } else {
	                chain();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // return (!this.props.loading && this.props.user && this.props.tree && this.props.cards && this.props.sensorMap && this.props.images) ?
	            return this.state.cardLoaded && this.state.treeLoaded && this.state.liveLoaded && this.state.imageLoaded && this.props.user && this.props.tree && this.props.cards && this.props.sensorMap && this.props.images ? _react2['default'].createElement(
	                'div',
	                { className: 'app_container' },
	                _react2['default'].createElement(_containersToolbar2['default'], {
	                    actions: { logout: this.props.logout },
	                    statistic: this.handleTreeClick.bind(this),
	                    location: this.props.location
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__content' },
	                    this.props.children,
	                    _react2['default'].createElement(_componentsCommonScrolltop2['default'], null)
	                )
	            ) : _react2['default'].createElement(_componentsCommonLoading2['default'], null);
	        }
	    }]);
	
	    return Frame;
	})(_react2['default'].Component);
	
	exports.Frame = Frame;
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        apikey: state.myAccountReducer.apikey,
	        tree: state.overviewReducer.customerOverview,
	        cards: state.defaultSettingsReducer.card,
	        sensorMap: state.nodeReducer.map,
	        images: state.floorPlanReducer.images
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        logout: function logout() {
	            dispatch((0, _actionsAuthentication.clearToken)());
	        },
	        setCurrentNode: function setCurrentNode(node) {
	            dispatch((0, _actionsOverview.setCurrentNode)(node));
	        }
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Frame);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  batch: true
	};
	
	var _exports = __webpack_require__(48);
	
	Object.keys(_exports).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _exports[key]) return;
	  exports[key] = _exports[key];
	});
	
	var _reactBatchedUpdates = __webpack_require__(84);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _batch = __webpack_require__(58);
	
	// Enable batched updates in our subscriptions for use
	// with standard React renderers (ReactDOM, React Native)
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(50));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(60));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(56);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(68));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(80);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(83);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(81);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(69));
	
	exports.shallowEqual = _shallowEqual["default"];

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	var _interopRequireWildcard = __webpack_require__(51)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(53));
	
	var _Context = __webpack_require__(56);
	
	var _Subscription = __webpack_require__(57);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(59);
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = (0, _Subscription.createSubscription)(store);
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(52)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(54)();
	}


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(55);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSubscription = createSubscription;
	
	var _batch = __webpack_require__(58);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var nullListeners = {
	  notify: function notify() {},
	  get: function get() {
	    return [];
	  }
	};
	
	function createSubscription(store, parentSub) {
	  var unsubscribe;
	  var listeners = nullListeners;
	
	  function addNestedSub(listener) {
	    trySubscribe();
	    return listeners.subscribe(listener);
	  }
	
	  function notifyNestedSubs() {
	    listeners.notify();
	  }
	
	  function handleChangeWrapper() {
	    if (subscription.onStateChange) {
	      subscription.onStateChange();
	    }
	  }
	
	  function isSubscribed() {
	    return Boolean(unsubscribe);
	  }
	
	  function trySubscribe() {
	    if (!unsubscribe) {
	      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
	      listeners = createListenerCollection();
	    }
	  }
	
	  function tryUnsubscribe() {
	    if (unsubscribe) {
	      unsubscribe();
	      unsubscribe = undefined;
	      listeners.clear();
	      listeners = nullListeners;
	    }
	  }
	
	  var subscription = {
	    addNestedSub: addNestedSub,
	    notifyNestedSubs: notifyNestedSubs,
	    handleChangeWrapper: handleChangeWrapper,
	    isSubscribed: isSubscribed,
	    trySubscribe: trySubscribe,
	    tryUnsubscribe: tryUnsubscribe,
	    getListeners: function getListeners() {
	      return listeners;
	    }
	  };
	  return subscription;
	}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.setBatch = exports.getBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(38);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	var _interopRequireWildcard = __webpack_require__(51)["default"];
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(61));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(62));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(63));
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _reactIs = __webpack_require__(66);
	
	var _Subscription = __webpack_require__(57);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(59);
	
	var _Context = __webpack_require__(56);
	
	var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
	    _excluded2 = ["reactReduxForwardedRef"];
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	      export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = ConnectFunction.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(64);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 64 */
[2369, 65],
/* 65 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 66 */
[2369, 67],
/* 67 */
/***/ (function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(61));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(62));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(60));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(69));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(70));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(76));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(77));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(78));
	
	var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _bindActionCreators = _interopRequireDefault(__webpack_require__(71));
	
	var _wrapMapToProps = __webpack_require__(72);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	
	function bindActionCreators(actionCreators, dispatch) {
	  var boundActionCreators = {};
	
	  var _loop = function _loop(key) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = function () {
	        return dispatch(actionCreator.apply(void 0, arguments));
	      };
	    }
	  };
	
	  for (var key in actionCreators) {
	    _loop(key);
	  }
	
	  return boundActionCreators;
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(73));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(74));
	
	var _warning = _interopRequireDefault(__webpack_require__(75));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(72);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.defaultMergeProps = defaultMergeProps;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(61));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(73));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = finalPropsSelectorFactory;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(62));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(79));
	
	var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(49)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(75));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(56);
	
	var _useStore = __webpack_require__(81);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(38);
	
	var _Context = __webpack_require__(56);
	
	var _useReduxContext2 = __webpack_require__(82);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(38);
	
	var _Context = __webpack_require__(56);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(38);
	
	var _useReduxContext2 = __webpack_require__(82);
	
	var _Subscription = __webpack_require__(57);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(59);
	
	var _Context = __webpack_require__(56);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return (0, _Subscription.createSubscription)(store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
	
	      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
	        selectedState = newSelectedState;
	      } else {
	        selectedState = latestSelectedState.current;
	      }
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
	
	        if (newStoreState === latestStoreState.current) {
	          return;
	        }
	
	        var _newSelectedState = latestSelector.current(newStoreState);
	
	        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = _newSelectedState;
	        latestStoreState.current = newStoreState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      if (!selector) {
	        throw new Error("You must pass a selector to useSelector");
	      }
	
	      if (typeof selector !== 'function') {
	        throw new Error("You must pass a function as a selector to useSelector");
	      }
	
	      if (typeof equalityFn !== 'function') {
	        throw new Error("You must pass a function as an equality function to useSelector");
	      }
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(41);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(86);
	
	var _history = __webpack_require__(142);
	
	var appHistory = (0, _reactRouter.useRouterHistory)(_history.createHashHistory)();
	exports['default'] = appHistory;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(87);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(88);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(89);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(91);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(109);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(110);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(111);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(112);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(114);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(113);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(115);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(105);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(116);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(129);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(130);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(131);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(139);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(118);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(53);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _createTransitionManager2 = __webpack_require__(94);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(104);
	
	var _RouterContext = __webpack_require__(105);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(87);
	
	var _RouterUtils = __webpack_require__(108);
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(38);
	var factory = __webpack_require__(93);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(97);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(98);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(100);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(101);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(103);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(89);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(99);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(89);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(99);
	
	var _PromiseUtils = __webpack_require__(102);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(99);
	
	var _PromiseUtils = __webpack_require__(102);
	
	var _PatternUtils = __webpack_require__(89);
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(53);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(64);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _getRouteParams = __webpack_require__(106);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(107);
	
	var _RouteUtils = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(89);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(88);
	
	var _ContextUtils = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(109);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(63);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(107);
	
	var _PropTypes = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(113);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(87);
	
	var _PatternUtils = __webpack_require__(89);
	
	var _InternalPropTypes = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(87);
	
	var _InternalPropTypes = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(92);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(53);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(87);
	
	var _InternalPropTypes = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(117);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(118);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(94);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(87);
	
	var _RouterUtils = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(119);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(125);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(126);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(120);
	
	var _runTransitionHook = __webpack_require__(122);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(121);
	var objectAssign = __webpack_require__(40);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(124);
	
	var _Actions = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(122);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(124);
	
	var _createHistory = __webpack_require__(127);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(128);
	
	var _PathUtils = __webpack_require__(124);
	
	var _runTransitionHook = __webpack_require__(122);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(117);
	
	var _LocationUtils = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(119);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(125);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(105);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(95);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(132);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(138);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(133);
	
	var _BrowserProtocol = __webpack_require__(134);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(137);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(135);
	
	var _createHistory = __webpack_require__(127);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(123);
	
	var _DOMUtils = __webpack_require__(135);
	
	var _DOMStateStorage = __webpack_require__(136);
	
	var _PathUtils = __webpack_require__(124);
	
	var _ExecutionEnvironment = __webpack_require__(133);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(134);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(124);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(129);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(140);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(138);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(133);
	
	var _DOMUtils = __webpack_require__(135);
	
	var _HashProtocol = __webpack_require__(141);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(127);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(134);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(96);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _DOMUtils = __webpack_require__(135);
	
	var _DOMStateStorage = __webpack_require__(136);
	
	var _PathUtils = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;
	
	var _LocationUtils = __webpack_require__(123);
	
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _createBrowserHistory = __webpack_require__(132);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createHashHistory2 = __webpack_require__(140);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(126);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	var _useBasename2 = __webpack_require__(125);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	var _useBeforeUnload2 = __webpack_require__(143);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	var _useQueries2 = __webpack_require__(119);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	var _Actions2 = __webpack_require__(117);
	
	var _Actions = _interopRequireWildcard(_Actions2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createHistory = _createBrowserHistory2.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;
	exports.useBasename = _useBasename3.default;
	exports.useBeforeUnload = _useBeforeUnload3.default;
	exports.useQueries = _useQueries3.default;
	exports.Actions = _Actions;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(90);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _DOMUtils = __webpack_require__(135);
	
	var _ExecutionEnvironment = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startListener = function startListener(getPromptMessage) {
	  var handleBeforeUnload = function handleBeforeUnload(event) {
	    var message = getPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	
	    return undefined;
	  };
	
	  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
	  };
	};
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	var useBeforeUnload = function useBeforeUnload(createHistory) {
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;
	
	  return function (options) {
	    var history = createHistory(options);
	
	    var listeners = [];
	    var stopListener = void 0;
	
	    var getPromptMessage = function getPromptMessage() {
	      var message = void 0;
	      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
	        message = listeners[i].call();
	      }return message;
	    };
	
	    var listenBeforeUnload = function listenBeforeUnload(listener) {
	      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	
	        if (listeners.length === 0 && stopListener) {
	          stopListener();
	          stopListener = null;
	        }
	      };
	    };
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload
	    });
	  };
	};
	
	exports.default = useBeforeUnload;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.checkIfAuthenticated = checkIfAuthenticated;
	exports.clearToken = clearToken;
	exports.loginOk = loginOk;
	exports.login = login;
	exports.setAPIKey = setAPIKey;
	exports.sendResetPWOk = sendResetPWOk;
	exports.sendResetPWFailed = sendResetPWFailed;
	exports.sendResetPW = sendResetPW;
	exports.resetPWGetUserOk = resetPWGetUserOk;
	exports.resetPWGetUserFailed = resetPWGetUserFailed;
	exports.resetPWGetUser = resetPWGetUser;
	exports.resetPassword = resetPassword;
	exports.redirectToLogin = redirectToLogin;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var CHECK_IF_AUTHENTICATED = 'CHECK_IF_AUTHENTICATED';
	exports.CHECK_IF_AUTHENTICATED = CHECK_IF_AUTHENTICATED;
	var CLEAR_TOKEN = 'CLEAR_TOKEN';
	
	exports.CLEAR_TOKEN = CLEAR_TOKEN;
	var LOGIN = 'LOGIN';
	exports.LOGIN = LOGIN;
	var LOGIN_OK = 'LOGIN_OK';
	exports.LOGIN_OK = LOGIN_OK;
	var LOGIN_FAILED = 'LOGIN_FAILED';
	
	exports.LOGIN_FAILED = LOGIN_FAILED;
	var SEND_RESET_PW = 'SEND_RESET_PW';
	exports.SEND_RESET_PW = SEND_RESET_PW;
	var SEND_RESET_PW_OK = 'SEND_RESET_PW_OK';
	exports.SEND_RESET_PW_OK = SEND_RESET_PW_OK;
	var SEND_RESET_PW_FAILED = 'SEND_RESET_PW_FAILED';
	
	exports.SEND_RESET_PW_FAILED = SEND_RESET_PW_FAILED;
	var RESET_PW_GET_USER = 'RESET_PW_GET_USER';
	exports.RESET_PW_GET_USER = RESET_PW_GET_USER;
	var RESET_PW_GET_USER_OK = 'RESET_PW_GET_USER_OK';
	exports.RESET_PW_GET_USER_OK = RESET_PW_GET_USER_OK;
	var RESET_PW_GET_USER_FAILED = 'RESET_PW_GET_USER_FAILED';
	
	exports.RESET_PW_GET_USER_FAILED = RESET_PW_GET_USER_FAILED;
	var RESET_PASSWORD = 'RESET_PASSWORD';
	
	exports.RESET_PASSWORD = RESET_PASSWORD;
	
	function checkIfAuthenticated() {
	  return {
	    type: CHECK_IF_AUTHENTICATED
	  };
	}
	
	function clearToken() {
	  return {
	    type: CLEAR_TOKEN
	  };
	}
	
	// Login
	
	function loginOk(token) {
	  return {
	    type: LOGIN_OK,
	    token: token
	  };
	}
	
	function loginFailed(data) {
	  return {
	    type: LOGIN_FAILED,
	    data: data
	  };
	}
	
	function login(credentials) {
	  return function (dispatch) {
	    dispatch({ type: LOGIN, credentials: credentials });
	    return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/login'), credentials).then(function (response) {
	      dispatch(loginOk(response.data.token));
	      _componentsCommonAppHistory2['default'].push('/');
	    })['catch'](function (response) {
	      dispatch(loginFailed(response.data || response.statusText));
	    });
	  };
	}
	
	var SET_API_KEY = "SET_API_KEY";
	exports.SET_API_KEY = SET_API_KEY;
	
	function setAPIKey(apikey) {
	  return {
	    type: SET_API_KEY,
	    apikey: apikey
	  };
	}
	
	// Forgot password
	
	function sendResetPWOk(data) {
	  return {
	    type: SEND_RESET_PW_OK,
	    data: data
	  };
	}
	
	function sendResetPWFailed(data) {
	  return {
	    type: SEND_RESET_PW_FAILED,
	    data: data
	  };
	}
	
	function sendResetPW(data) {
	  return function (dispatch) {
	    dispatch({ type: SEND_RESET_PW, data: data });
	    return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/resetpassword/send'), data).then(function (response) {
	      dispatch(sendResetPWOk(response));
	      return response;
	    })['catch'](function (response) {
	      dispatch(sendResetPWFailed(response.data || response.statusText.data));
	      return response;
	    });
	  };
	}
	
	// Get user to reset Password
	
	function resetPWGetUserOk(data) {
	  return {
	    type: RESET_PW_GET_USER_OK,
	    data: data
	  };
	}
	
	function resetPWGetUserFailed(data) {
	  return {
	    type: RESET_PW_GET_USER_FAILED,
	    data: data
	  };
	}
	
	function resetPWGetUser(key) {
	  return function (dispatch) {
	    dispatch({ type: RESET_PW_GET_USER, key: key });
	    return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/resetpassword/check/' + key)).then(function (response) {
	      dispatch(resetPWGetUserOk(response.data));
	      return response;
	    })['catch'](function (response) {
	      console.log(response);
	      dispatch(resetPWGetUserFailed(response.data));
	      return response;
	    });
	  };
	}
	
	// Reset password
	
	function resetPassword(key, username, newPassword) {
	  return function (dispatch) {
	    dispatch({ type: RESET_PASSWORD, key: key, newPassword: newPassword });
	    return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/resetpassword/reset/' + key), { 'new': newPassword }).then(function (response) {
	      dispatch(login({ username: username, password: newPassword }));
	      return response;
	    })['catch'](function (response) {
	      console.log(response);
	      _toastr2['default'].error(response.data);
	      return response;
	    });
	  };
	}
	
	// ---
	
	function redirectToLogin() {
	  return function (dispatch) {
	    _componentsCommonAppHistory2['default'].push('/login');
	  };
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(146);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(147);
	var utils = __webpack_require__(148);
	var dispatchRequest = __webpack_require__(149);
	var InterceptorManager = __webpack_require__(158);
	var isAbsoluteURL = __webpack_require__(159);
	var combineURLs = __webpack_require__(160);
	var bind = __webpack_require__(161);
	var transformData = __webpack_require__(154);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose defaults
	axios.defaults = defaultInstance.defaults;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(162);
	
	// Expose interceptors
	axios.interceptors = defaultInstance.interceptors;
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function transformResponseJSON(data, headers) {
	    if (utils.isFormData(data)) {
	      return data;
	    }
	    if (utils.isArrayBuffer(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function processContentTypeHeader(val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponseJSON(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN'
	};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(151);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(151);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)))

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	var buildURL = __webpack_require__(152);
	var parseHeaders = __webpack_require__(153);
	var transformData = __webpack_require__(154);
	var isURLSameOrigin = __webpack_require__(155);
	var btoa = window.btoa || __webpack_require__(156);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  if (window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request.onload = function handleLoad() {
	    if (!request) {
	      return;
	    }
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config
	    };
	
	    // Resolve or reject the Promise based on the status
	    ((response.status >= 200 && response.status < 300) ||
	     (!('status' in request) && response.responseText) ?
	      resolve :
	      reject)(response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(157);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  if (utils.isArrayBuffer(requestData)) {
	    requestData = new DataView(requestData);
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.code = 5;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new InvalidCharacterError('INVALID_CHARACTER_ERR: DOM Exception 5');
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(148);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _base = __webpack_require__(164);
	
	var _base2 = _interopRequireDefault(_base);
	
	exports['default'] = Object.assign(_base2['default'], {
	  api: {
	    //toggle between the environment you want to use by commenting the url
	    // root: 'https://backend.senzodata.com/api'
	    //root: 'https://backend-dev.senzodata.com/api'
	    root: "/api"
	    // local: 'http://localhost/api'
	  },
	  livefeed: {
	    // root: 'https://livefeed.senzolive.com'
	    root: 'https://devlivefeed.senzolive.com'
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  floorplanURLBase: "/floorplans-v2/",
	  time: {
	    period: {
	      DAY: {
	        format: "HH:mm",
	        code: "day",
	        title: "Today so far",
	        prevTitle: "Yesterday"
	      },
	      WEEK: {
	        format: "ddd",
	        code: "week",
	        title: "This week so far",
	        prevTitle: "Last week"
	      },
	      MONTH: {
	        format: "MMM",
	        code: "month",
	        title: "Monthly utilization",
	        prevTitle: ""
	      },
	      CUSTOM: {
	        format: "MMM",
	        code: "custom",
	        title: "Custom timeframe",
	        prevTitle: ""
	      }
	    }
	  },
	  mode: {
	    AVERAGE: {
	      code: "Average",
	      title: "AVERAGE UTILIZATION"
	    },
	    PEAK: {
	      code: "Peak",
	      title: "PEAK UTILIZATION"
	    }
	  },
	  room: {
	    MEETINGROOM: {
	      type: "Meeting rooms",
	      code: 'meeting_room',
	      occupancyTag: 'MRO',
	      efficiencyTag: 'MRE'
	    },
	    OPENAREA: {
	      type: "Open areas",
	      code: "open_area",
	      occupancyTag: "OAO"
	    },
	    ALLAREA: {
	      type: "All areas",
	      code: 'all_areas',
	      occupancyTag: "TTO"
	    }
	  },
	  textOf: {
	    meeting_room: "meeting room",
	    open_area: "working area",
	    location: "location",
	    customer: "company"
	  },
	  nodeType: {
	    customer: {
	      code: "customer",
	      text: "Company"
	    }
	  },
	  tag: {
	    OCCUPANCY: {
	      type: 'Occupancy'
	    },
	    EFFICIENCY: {
	      type: 'Efficiency'
	    }
	  },
	  day: ["Sundays", "Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays"],
	  viewFilter: [{ code: "ALL", text: "Show All" }, { code: "LIVE", text: "Live View" }, { code: "MAINTENANCE", text: "Maintenance View" }, { code: "CONFIGURATION", text: "Configuration View" }],
	  userTypeFilter: [{ code: "ALL", text: "All Users" }, { code: "CADMIN", text: "Company Admins" }, { code: "LADMIN", text: "Local Admins" }, { code: "LUSER", text: "Local Users" }, { code: "SUSER", text: "Support Users" }],
	  sensorStatusFilter: [{ code: "ALL", text: "All sensors" }, { code: "ONLINE", text: "Online sensors" }, { code: "MAINTENANCE", text: "Offline sensors" }
	  // {code:"UNREG", text:"Unregistered sensors"},
	  ],
	  roles: [{ code: "!ADMIN", rolecode: "ADMIN", text: "Company administrator", singular: "a company administrator" }, { code: ".ADMIN", rolecode: "ADMIN", text: "Local administrator", singular: "a local administrator" }, { code: ".LOCALUSER", rolecode: "LOCALUSER", text: "Local user", singular: "a local user" }, { code: ".SUPPORTUSER", rolecode: "SUPPORTUSER", text: "Support user", singular: "a support user" }]
	};
	module.exports = exports["default"];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	(function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.4',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass);
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	                    closeOnHover: true,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    closeClass: 'toast-close-button',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false,
	                    progressClass: 'toast-progress',
	                    rtl: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null) {
	                        source = '';
	                    }
	
	                    return source
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setRTL();
	                    setSequence();
	                    setAria();
	                }
	
	                function setAria() {
	                    var ariaValue = '';
	                    switch (map.iconClass) {
	                        case 'toast-success':
	                        case 'toast-info':
	                            ariaValue =  'polite';
	                            break;
	                        default:
	                            ariaValue = 'assertive';
	                    }
	                    $toastElement.attr('aria-live', ariaValue);
	                }
	
	                function handleEvents() {
	                    if (options.closeOnHover) {
	                        $toastElement.hover(stickAround, delayedHideToast);
	                    }
	
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	
	                            if (options.onCloseClick) {
	                                options.onCloseClick(event);
	                            }
	
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        var suffix = map.title;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.title);
	                        }
	                        $titleElement.append(suffix).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        var suffix = map.message;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.message);
	                        }
	                        $messageElement.append(suffix).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass(options.closeClass).attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass(options.progressClass);
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function setRTL() {
	                    if (options.rtl) {
	                        $toastElement.addClass('rtl');
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            clearTimeout(intervalId);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(167)));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.finalize = finalize;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	function finalize(url) {
		var apikey = _store2["default"].getState().authReducer.apikey;
		if (apikey && apikey.length > 0) {
			if (url.indexOf("?") == -1) {
				return url + ("?apikey=" + apikey);
			} else {
				return url + ("&apikey=" + apikey);
			}
		} else {
			return url;
		}
	}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(170);
	
	var _reduxThunk = __webpack_require__(190);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reducersAuth = __webpack_require__(198);
	
	var _reducersAuth2 = _interopRequireDefault(_reducersAuth);
	
	var _reducersOverview = __webpack_require__(199);
	
	var _reducersOverview2 = _interopRequireDefault(_reducersOverview);
	
	var _reducersNode = __webpack_require__(201);
	
	var _reducersNode2 = _interopRequireDefault(_reducersNode);
	
	var _reducersComparison = __webpack_require__(204);
	
	var _reducersComparison2 = _interopRequireDefault(_reducersComparison);
	
	var _reducersStats = __webpack_require__(206);
	
	var _reducersStats2 = _interopRequireDefault(_reducersStats);
	
	var _reducersQuerysettings = __webpack_require__(208);
	
	var _reducersQuerysettings2 = _interopRequireDefault(_reducersQuerysettings);
	
	var _reducersLive = __webpack_require__(347);
	
	var _reducersLive2 = _interopRequireDefault(_reducersLive);
	
	var _reducersDevicemanagement = __webpack_require__(349);
	
	var _reducersDevicemanagement2 = _interopRequireDefault(_reducersDevicemanagement);
	
	var _reducersFloorplansensor = __webpack_require__(351);
	
	var _reducersFloorplansensor2 = _interopRequireDefault(_reducersFloorplansensor);
	
	var _reducersFloorplan = __webpack_require__(352);
	
	var _reducersFloorplan2 = _interopRequireDefault(_reducersFloorplan);
	
	var _reducersMyaccount = __webpack_require__(353);
	
	var _reducersMyaccount2 = _interopRequireDefault(_reducersMyaccount);
	
	var _reducersUserAdministration = __webpack_require__(355);
	
	var _reducersUserAdministration2 = _interopRequireDefault(_reducersUserAdministration);
	
	var _reducersUserInvite = __webpack_require__(357);
	
	var _reducersUserInvite2 = _interopRequireDefault(_reducersUserInvite);
	
	var _reducersUserRegister = __webpack_require__(358);
	
	var _reducersUserRegister2 = _interopRequireDefault(_reducersUserRegister);
	
	var _reducersSensorsettings = __webpack_require__(359);
	
	var _reducersSensorsettings2 = _interopRequireDefault(_reducersSensorsettings);
	
	var _reducersDefaultsettings = __webpack_require__(361);
	
	var _reducersDefaultsettings2 = _interopRequireDefault(_reducersDefaultsettings);
	
	var _reducersLivefeedapi = __webpack_require__(363);
	
	var _reducersLivefeedapi2 = _interopRequireDefault(_reducersLivefeedapi);
	
	var _reducersLivefeededitor = __webpack_require__(369);
	
	var _reducersLivefeededitor2 = _interopRequireDefault(_reducersLivefeededitor);
	
	//import appHistory from 'components/common/appHistory';
	
	var appReducer = (0, _reduxLoop.combineReducers)({
	  authReducer: _reducersAuth2['default'],
	  overviewReducer: _reducersOverview2['default'],
	  nodeReducer: _reducersNode2['default'],
	
	  comparisonReducer: _reducersComparison2['default'],
	  statsReducer: _reducersStats2['default'],
	  querySettingsReducer: _reducersQuerysettings2['default'],
	  liveReducer: _reducersLive2['default'],
	  devManReducer: _reducersDevicemanagement2['default'],
	
	  floorPlanSensorReducer: _reducersFloorplansensor2['default'],
	  floorPlanReducer: _reducersFloorplan2['default'],
	
	  myAccountReducer: _reducersMyaccount2['default'],
	  userAdminReducer: _reducersUserAdministration2['default'],
	  userInviteReducer: _reducersUserInvite2['default'],
	  userRegisterReducer: _reducersUserRegister2['default'],
	
	  sensorSettingsReducer: _reducersSensorsettings2['default'],
	  defaultSettingsReducer: _reducersDefaultsettings2['default'],
	  livefeedAPIReducer: _reducersLivefeedapi2['default'],
	
	  livefeededitor: _reducersLivefeededitor2['default']
	});
	
	var reducer = function reducer(state, action) {
	  if (action.type == _actionsAuthentication.CLEAR_TOKEN) {
	    state = undefined;
	  }
	  return appReducer(state, action);
	};
	
	var store = (0, _redux.createStore)(reducer, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2['default']), (0, _reduxLoop.install)()));
	
	_axios2['default'].interceptors.request.use(function (config) {
	  config.headers['Authorization'] = 'Bearer ' + store.getState().authReducer.token;
	  return config;
	});
	
	_axios2['default'].interceptors.response.use(function (response) {
	  return response;
	}, function (error) {
	  if (error.status == 401) {
	    store.dispatch((0, _actionsAuthentication.clearToken)());
	  } else if (error.status > 400) {
	    return Promise.reject(error);
	  } else {
	    return Promise.reject({ statusText: error });
	  }
	});
	
	exports['default'] = store;
	module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(171);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(185);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(187);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(188);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(189);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(186);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(172);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(182);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    getPrototype = __webpack_require__(179),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(174),
	    getRawTag = __webpack_require__(177),
	    objectToString = __webpack_require__(178);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(175);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(176);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(174);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(180);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(184);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(183)(module)))

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(171);
	
	var _isPlainObject = __webpack_require__(172);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(186);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(189);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEffect = exports.getModel = exports.liftState = exports.isLoop = exports.loop = exports.install = exports.Effects = exports.combineReducers = undefined;
	
	var _loop = __webpack_require__(192);
	
	var _effects = __webpack_require__(194);
	
	var _install = __webpack_require__(195);
	
	var _combineReducers = __webpack_require__(197);
	
	var Effects = {
	  constant: _effects.constant,
	  promise: _effects.promise,
	  call: _effects.call,
	  batch: _effects.batch,
	  none: _effects.none,
	  lift: _effects.lift
	};
	
	exports.combineReducers = _combineReducers.combineReducers;
	exports.Effects = Effects;
	exports.install = _install.install;
	exports.loop = _loop.loop;
	exports.isLoop = _loop.isLoop;
	exports.liftState = _loop.liftState;
	exports.getModel = _loop.getModel;
	exports.getEffect = _loop.getEffect;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.liftState = exports.loop = exports.getModel = exports.getEffect = exports.isLoop = undefined;
	
	var _utils = __webpack_require__(193);
	
	var _effects = __webpack_require__(194);
	
	/**
	 * Determines if the object is an array created via `loop()`.
	 */
	var isLoop = exports.isLoop = function isLoop(array) {
	  return Array.isArray(array) && array.length === 2 && (0, _effects.isEffect)(array[1]);
	};
	
	/**
	 * Returns the effect from the loop if it is a loop, otherwise null
	 */
	var getEffect = exports.getEffect = function getEffect(loop) {
	  if (!isLoop(loop)) {
	    return null;
	  }
	
	  return loop[1];
	};
	
	/**
	 * Returns the model from the loop if it is a loop, otherwise identity
	 */
	var getModel = exports.getModel = function getModel(loop) {
	  if (!isLoop(loop)) {
	    return loop;
	  }
	
	  return loop[0];
	};
	
	/**
	 * Attaches an effect to the model.
	 *
	 *   function reducerWithSingleEffect(state, action) {
	 *     // ...
	 *     return loop(
	 *       newState,
	 *       fetchSomeStuff() // returns a promise
	 *     );
	 *   }
	 *
	 *   function reducerWithManyEffectsOneAsyncOneNot(state, action) {
	 *     // ...
	 *     return loop(
	 *       newState,
	 *       Promise.all([
	 *         fetchSomeStuff(),
	 *         Promise.resolve(someActionCreator())
	 *       ])
	 *     );
	 *   }
	 */
	var loop = exports.loop = function loop(model, effect) {
	  if (false) {
	    (0, _utils.throwInvariant)((0, _effects.isEffect)(effect), 'Given effect is not an effect instance.');
	  }
	
	  return [model, effect];
	};
	
	/**
	* Lifts a state to a looped state if it is not already.
	*/
	var liftState = exports.liftState = function liftState(state) {
	  return isLoop(state) ? state : loop(state, (0, _effects.none)());
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatten = flatten;
	exports.throwInvariant = throwInvariant;
	exports.mapValues = mapValues;
	var concat = Array.prototype.concat;
	
	/**
	 * Flattens an array one level
	 */
	function flatten(array) {
	  return concat.apply([], array);
	}
	
	/**
	 * Throws with message if condition is false.
	 * @param {Boolean} condition The condition to assert.
	 * @param {String} message The message of the error to throw.
	 */
	function throwInvariant(condition, message) {
	  if (!condition) {
	    throw Error(message);
	  }
	}
	
	/**
	 * Maps over each value in an object and creates a new object with the mapped
	 * values assigned to each key.
	 * @param {Object} object The source object.
	 * @param {Function} mapper The mapper function that receives the value and the key.
	 * @returns {Object} A new object that contains the mapped values for the keys.
	 */
	function mapValues(object, mapper) {
	  return Object.keys(object).reduce(function (current, key) {
	    current[key] = mapper(object[key], key);
	    return current;
	  }, {});
	}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.effectToPromise = effectToPromise;
	exports.isEffect = isEffect;
	exports.isNone = isNone;
	exports.none = none;
	exports.promise = promise;
	exports.call = call;
	exports.batch = batch;
	exports.constant = constant;
	exports.lift = lift;
	
	var _utils = __webpack_require__(193);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isEffectSymbol = Symbol('isEffect');
	
	var effectTypes = {
	  PROMISE: 'PROMISE',
	  CALL: 'CALL',
	  BATCH: 'BATCH',
	  CONSTANT: 'CONSTANT',
	  NONE: 'NONE',
	  LIFT: 'LIFT'
	};
	
	/**
	* Runs an effect and returns the Promise for its completion.
	* @param {Object} effect The effect to convert to a Promise.
	* @returns {Promise} The converted effect Promise.
	*/
	function effectToPromise(effect) {
	  if (false) {
	    (0, _utils.throwInvariant)(isEffect(effect), 'Given effect is not an effect instance.');
	  }
	
	  switch (effect.type) {
	    case effectTypes.PROMISE:
	      return effect.factory.apply(effect, _toConsumableArray(effect.args)).then(function (action) {
	        return [action];
	      });
	    case effectTypes.CALL:
	      return Promise.resolve([effect.factory.apply(effect, _toConsumableArray(effect.args))]);
	    case effectTypes.BATCH:
	      return Promise.all(effect.effects.map(effectToPromise)).then(_utils.flatten);
	    case effectTypes.CONSTANT:
	      return Promise.resolve([effect.action]);
	    case effectTypes.NONE:
	      return Promise.resolve([]);
	    case effectTypes.LIFT:
	      return effectToPromise(effect.effect).then(function (actions) {
	        return actions.map(function (action) {
	          return effect.factory.apply(effect, _toConsumableArray(effect.args).concat([action]));
	        });
	      });
	  }
	}
	
	/**
	 * Determines if the object was created with an effect creator.
	 * @param {Object} object The object to inspect.
	 * @returns {Boolean} Whether the object is an effect.
	 */
	function isEffect(object) {
	  return object ? object[isEffectSymbol] : false;
	}
	
	/**
	 * Determines id the effect object is of type none
	 * @param {Object} The object to inspect.
	 * @returns {Boolean} Whether the object is a none effect.
	 */
	function isNone(object) {
	  return object ? object.type === effectTypes.NONE : false;
	}
	
	/**
	 * Creates a noop effect.
	 * @returns {Object} An effect of type NONE, essentially a no-op.
	 */
	function none() {
	  return _defineProperty({
	    type: effectTypes.NONE
	  }, isEffectSymbol, true);
	}
	
	/**
	 * Creates an effect for a function that returns a Promise.
	 * @param {Function} factory The function to invoke with the given args that returns a Promise for an action.
	 * @returns {Object} The wrapped effect of type PROMISE.
	 */
	function promise(factory) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return _defineProperty({
	    factory: factory,
	    args: args,
	    type: effectTypes.PROMISE
	  }, isEffectSymbol, true);
	}
	
	/**
	 * Creates an effect for a function that returns an action.
	 * @param {Function} factory The function to invoke with the given args that returns an action.
	 * @returns {Object} The wrapped effect of type CALL.
	 */
	function call(factory) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return _defineProperty({
	    factory: factory,
	    args: args,
	    type: effectTypes.CALL
	  }, isEffectSymbol, true);
	}
	
	/**
	 * Composes an array of effects together.
	 */
	function batch(effects) {
	  return _defineProperty({
	    effects: effects,
	    type: effectTypes.BATCH
	  }, isEffectSymbol, true);
	}
	
	/**
	 * Creates an effect for an already-available action.
	 */
	function constant(action) {
	  return _defineProperty({
	    action: action,
	    type: effectTypes.CONSTANT
	  }, isEffectSymbol, true);
	}
	
	/**
	 * Transform the return type of a bunch of `Effects`. This is primarily useful for adding tags to route `Actions` to the right place
	 */
	function lift(effect, factory) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	    args[_key3 - 2] = arguments[_key3];
	  }
	
	  return _defineProperty({
	    effect: effect,
	    factory: factory,
	    args: args,
	    type: effectTypes.LIFT
	  }, isEffectSymbol, true);
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.install = install;
	
	var _utils = __webpack_require__(193);
	
	var _errors = __webpack_require__(196);
	
	var _loop = __webpack_require__(192);
	
	var _effects = __webpack_require__(194);
	
	/**
	 * Installs a new dispatch function which will attempt to execute any effects
	 * attached to the current model as established by the original dispatch.
	 */
	function install() {
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var currentEffect = (0, _effects.none)();
	
	      var _liftState = (0, _loop.liftState)(initialState);
	
	      var _liftState2 = _slicedToArray(_liftState, 2);
	
	      var initialModel = _liftState2[0];
	      var initialEffect = _liftState2[1];
	
	
	      var liftReducer = function liftReducer(reducer) {
	        return function (state, action) {
	          var result = reducer(state, action);
	
	          var _liftState3 = (0, _loop.liftState)(result);
	
	          var _liftState4 = _slicedToArray(_liftState3, 2);
	
	          var model = _liftState4[0];
	          var effect = _liftState4[1];
	
	          if ((0, _effects.isNone)(currentEffect)) {
	            currentEffect = effect;
	          } else {
	            currentEffect = (0, _effects.batch)([currentEffect, effect]);
	          }
	          return model;
	        };
	      };
	
	      var store = next(liftReducer(reducer), initialModel, enhancer);
	
	      var runEffect = function runEffect(originalAction, effect) {
	        return (0, _effects.effectToPromise)(effect).then(function (actions) {
	          return Promise.all(actions.map(dispatch));
	        })['catch'](function (error) {
	          console.error((0, _errors.loopPromiseCaughtError)(originalAction.type));
	          throw error;
	        });
	      };
	
	      var dispatch = function dispatch(action) {
	        store.dispatch(action);
	        var effectToRun = currentEffect;
	        currentEffect = (0, _effects.none)();
	        return runEffect(action, effectToRun);
	      };
	
	      var replaceReducer = function replaceReducer(reducer) {
	        return store.replaceReducer(liftReducer(reducer));
	      };
	
	      runEffect({ type: '@@ReduxLoop/INIT' }, initialEffect);
	
	      return _extends({}, store, {
	        dispatch: dispatch,
	        replaceReducer: replaceReducer
	      });
	    };
	  };
	}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopPromiseCaughtError = exports.loopPromiseCaughtError = function loopPromiseCaughtError(originalActionType) {
	  return "\nloop Promise caught when returned from action of type " + originalActionType + ".\nloop Promises must not throw!\n\nDid you forget to do one of the following?\n\n- Call `.catch` on a Promise in a function passed to `Effects.promise`\n\n  const asyncEffect = (val) => {\n    return api.doStuff(val)\n      .then((stuff) => Actions.success(stuff))\n      .catch((error) => Actions.failure(error)); // <-- You have to do this!\n  };\n\n- Return an action from a `.catch` callback\n\n  const asyncEffect = (val) => {\n    return api.doStuff(val)\n      .then((stuff) => {\n        return Actions.success(stuff); // <-- Make sure to return here!\n      })\n      .catch((error) => {\n        return Actions.failure(error): // <-- And return here!\n      });\n  };\n\nDon't see the problem here? Please report the issue at <https://github.com/raisemarketplace/redux-loop/issues/new>\n";
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.combineReducers = combineReducers;
	
	var _loop = __webpack_require__(192);
	
	var _effects = __webpack_require__(194);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function optimizeBatch(effects) {
	  switch (effects.length) {
	    case 0:
	      return (0, _effects.none)();
	    case 1:
	      return effects[0];
	    default:
	      return (0, _effects.batch)(effects);
	  }
	}
	
	var defaultAccessor = function defaultAccessor(state, key) {
	  return state[key];
	};
	
	var defaultMutator = function defaultMutator(state, key, value) {
	  return _extends({}, state, _defineProperty({}, key, value));
	};
	
	function combineReducers(reducerMap) {
	  var rootState = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var accessor = arguments.length <= 2 || arguments[2] === undefined ? defaultAccessor : arguments[2];
	  var mutator = arguments.length <= 3 || arguments[3] === undefined ? defaultMutator : arguments[3];
	
	  return function finalReducer() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? rootState : arguments[0];
	    var action = arguments[1];
	
	    var hasChanged = false;
	    var effects = [];
	
	    var model = Object.keys(reducerMap).reduce(function (model, key) {
	      var reducer = reducerMap[key];
	      var previousStateForKey = accessor(state, key);
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if ((0, _loop.isLoop)(nextStateForKey)) {
	        effects.push((0, _loop.getEffect)(nextStateForKey));
	        nextStateForKey = (0, _loop.getModel)(nextStateForKey);
	      }
	
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	      return mutator(model, key, nextStateForKey);
	    }, rootState);
	
	    return (0, _loop.loop)(hasChanged ? model : state, optimizeBatch(effects));
	  };
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	//import jwtDecode from 'jwt-decode';
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var initialState = {
	  token: localStorage.getItem("token"),
	  apikey: localStorage.getItem("apikey"),
	  loginInProgress: false,
	
	  sendResetPWInProgress: false,
	  sendResetPWDone: false,
	
	  resetPWUser: null,
	  resetPWBadKey: false,
	
	  error: false,
	  errorMessage: ''
	};
	
	// Reducing function
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    // Login
	    case _actionsAuthentication.LOGIN:
	      {
	        return Object.assign({}, state, {
	          loginInProgress: true
	        });
	      }
	    case _actionsAuthentication.LOGIN_OK:
	      {
	        localStorage.setItem("token", action.token);
	        return Object.assign({}, state, {
	          token: action.token,
	          loginInProgress: false
	        });
	      }
	    case _actionsAuthentication.LOGIN_FAILED:
	      {
	        _toastr2['default'].error(action.data);
	        return Object.assign({}, state, initialState, {
	          loginInProgress: false,
	          error: true,
	          errorMessage: action.data
	        });
	      }
	
	    case _actionsAuthentication.SET_API_KEY:
	      {
	        localStorage.setItem("apikey", action.apikey);
	        return Object.assign({}, state, {
	          apikey: action.apikey
	        });
	      }
	
	    // Reset password
	    case _actionsAuthentication.SEND_RESET_PW:
	      {
	        return Object.assign({}, state, {
	          sendResetPWInProgress: true,
	          sendResetPWDone: false
	        });
	      }
	    case _actionsAuthentication.SEND_RESET_PW_OK:
	      {
	        _toastr2['default'].success("Email has been sent !");
	        return Object.assign({}, state, {
	          sendResetPWInProgress: false,
	          sendResetPWDone: true
	        });
	      }
	    case _actionsAuthentication.SEND_RESET_PW_FAILED:
	      {
	        if (action.data == "sql: no rows in result set\n") {
	          _toastr2['default'].error("User not found !");
	        } else {
	          _toastr2['default'].error("Error: " + action.data);
	        }
	        return Object.assign({}, state, initialState, {
	          sendResetPWInProgress: false,
	          sendResetPWDone: false,
	          error: true,
	          errorMessage: action.data
	        });
	      }
	
	    // Get user to reset password
	    case _actionsAuthentication.RESET_PW_GET_USER:
	      {
	        return Object.assign({}, state, {});
	      }
	    case _actionsAuthentication.RESET_PW_GET_USER_OK:
	      {
	        return Object.assign({}, state, {
	          resetPWUser: action.data,
	          resetPWBadKey: false
	        });
	      }
	    case _actionsAuthentication.RESET_PW_GET_USER_FAILED:
	      {
	        return Object.assign({}, state, initialState, {
	          resetPWUser: null,
	          resetPWBadKey: true,
	          error: true,
	          errorMessage: action.data
	        });
	      }
	
	    // ---
	    case _actionsAuthentication.CLEAR_TOKEN:
	      {
	        localStorage.removeItem("token");
	        localStorage.removeItem("apikey");
	        _componentsCommonAppHistory2['default'].push('/login');
	        return Object.assign({}, initialState, {
	          token: null,
	          apikey: null
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _actionsOverview = __webpack_require__(200);
	
	var a = _interopRequireWildcard(_actionsOverview);
	
	var initialState = {
	  loading: false,
	  currentNode: null,
	  customerOverview: null,
	  nodeMap: {},
	  MACMap: {},
	  widgets: [],
	  card: {}
	};
	
	function fetchCustomerOverview(id) {
	  if (!id) {
	    id = _store2['default'].getState().myAccountReducer.user.companyid;
	  }
	  return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/structure/' + id))).then(function (response) {
	    return a.receiveCustomerOverview(response);
	  })['catch'](function (error) {
	    console.log(error);
	    return a.fetchingFailed(error);
	  });
	}
	
	/*function fetchCard() {
	  return axios.get(finalize(config.api.root + `/card`))
	    .then((response) => {
	      return a.fetchCardOk(response);
	    }).catch((error) => {
	      console.log(error);
	      return a.fetchingFailed(error);
	    });
	}*/
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case a.FETCH_CUSTOMER_OVERVIEW:
	      {
	        return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(fetchCustomerOverview, action.id));
	      }
	
	    case a.RECEIVE_CUSTOMER_OVERVIEW:
	      {
	        return Object.assign({}, state, {
	          loading: false,
	          customerOverview: action.data,
	          widgets: [].concat(_toConsumableArray(state.widgets), [action.data]),
	          currentNode: action.data,
	          nodeMap: action.nodeMap,
	          MACMap: action.MACMap
	        });
	      }
	
	    case a.SET_CURRENT_NODE:
	      {
	        return Object.assign({}, state, {
	          currentNode: action.node
	        });
	      }
	
	    case a.ADD_NODE_WIDGET:
	      {
	        return Object.assign({}, state, {
	          widgets: [].concat(_toConsumableArray(state.widgets), [action.node])
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setCurrentNode = setCurrentNode;
	exports.addNodeWidget = addNodeWidget;
	exports.fetchCustomerOverview = fetchCustomerOverview;
	exports.receiveCustomerOverview = receiveCustomerOverview;
	exports.fetchingFailed = fetchingFailed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var SET_CURRENT_NODE = 'SET_CURRENT_NODE';
	exports.SET_CURRENT_NODE = SET_CURRENT_NODE;
	
	function setCurrentNode(node) {
	  return {
	    type: SET_CURRENT_NODE,
	    node: node
	  };
	}
	
	var ADD_NODE_WIDGET = 'ADD_NODE_WIDGET';
	exports.ADD_NODE_WIDGET = ADD_NODE_WIDGET;
	
	function addNodeWidget(node) {
	  return {
	    type: ADD_NODE_WIDGET,
	    node: node
	  };
	}
	
	var FETCH_CUSTOMER_OVERVIEW = 'FETCH_CUSTOMER_OVERVIEW';
	exports.FETCH_CUSTOMER_OVERVIEW = FETCH_CUSTOMER_OVERVIEW;
	
	function fetchCustomerOverview(id) {
	  return {
	    type: FETCH_CUSTOMER_OVERVIEW,
	    id: id
	  };
	}
	
	function addParent(root) {
	  root.children.map(function (x) {
	    x.parent = root;
	    addParent(x);
	  });
	}
	
	function makeNodeMap(root, map) {
	  map[root.id] = root;
	  root.children.map(function (x) {
	    makeNodeMap(x, map);
	  });
	}
	function makeMACMap(root, map) {
	  if (root.type == "sensor") {
	    map[root.info.details.macaddress] = root;
	  }
	  root.children.map(function (x) {
	    makeMACMap(x, map);
	  });
	}
	
	var RECEIVE_CUSTOMER_OVERVIEW = 'RECEIVE_CUSTOMER_OVERVIEW';
	exports.RECEIVE_CUSTOMER_OVERVIEW = RECEIVE_CUSTOMER_OVERVIEW;
	
	function receiveCustomerOverview(result) {
	  addParent(result.data);
	  var nodeMap = {},
	      MACMap = {};
	  makeNodeMap(result.data, nodeMap);
	  makeMACMap(result.data, MACMap);
	  return {
	    type: RECEIVE_CUSTOMER_OVERVIEW,
	    data: result.data,
	    nodeMap: nodeMap,
	    MACMap: MACMap
	  };
	}
	
	var FETCHING_FAILED = 'FETCHING_FAILED';
	exports.FETCHING_FAILED = FETCHING_FAILED;
	
	function fetchingFailed() {
	  return {
	    type: FETCHING_FAILED
	  };
	}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actionsNode = __webpack_require__(202);
	
	var Node = _interopRequireWildcard(_actionsNode);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var initialState = {
	  loading: false,
	  roomInUse: 0,
	  deskInUse: 0,
	  map: null
	};
	
	function fetchLiveData(id) {
	  if (!id) {
	    id = _store2['default'].getState().myAccountReducer.user.companyid;
	  }
	  return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/sensor/live/' + id))).then(Node.receiveLiveData)['catch'](Node.fetchFailed);
	}
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case Node.FETCH_LIVE_DATA:
	      {
	        return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(fetchLiveData, action.id));
	      }
	
	    case Node.RECEIVE_LIVE_DATA:
	      {
	        var _ret = (function () {
	          var map = new Map();
	          action.data.forEach(function (element) {
	            // Dummy test...
	            // if (element.id%3==0) {
	            //   element.inuse = true;
	            // } else if (element.id%3==1) {
	            //   element.standby = true;
	            // }
	            map.set(element.id, element);
	          });
	          return {
	            v: Object.assign({}, state, {
	              map: map
	            })
	          };
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	      }
	
	    case Node.FETCH_FAILED:
	      {
	        return Object.assign({}, state, {
	          error: action.data
	        });
	      }
	
	    case Node.SELECT_NODE_STATS:
	      {
	        return Object.assign({}, state, {
	          loading: true
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setParentInProgess = setParentInProgess;
	exports.setParentSuccessfully = setParentSuccessfully;
	exports.setParentFailed = setParentFailed;
	exports.updateNodeInProgress = updateNodeInProgress;
	exports.updateFailed = updateFailed;
	exports.updateNodeSuccessfully = updateNodeSuccessfully;
	exports.createNodeInProgress = createNodeInProgress;
	exports.createFailed = createFailed;
	exports.createNodeSuccessfully = createNodeSuccessfully;
	exports.deleteNodeInProgress = deleteNodeInProgress;
	exports.deleteFailed = deleteFailed;
	exports.deleteNodeSuccessfully = deleteNodeSuccessfully;
	exports.uploadImage = uploadImage;
	exports.uploadImageFailed = uploadImageFailed;
	exports.uploadImageSuccessful = uploadImageSuccessful;
	exports.updateNode = updateNode;
	exports.createNode = createNode;
	exports.deleteNode = deleteNode;
	exports.uploadFloorplanView = uploadFloorplanView;
	exports.selectNodeStats = selectNodeStats;
	exports.fetchLiveData = fetchLiveData;
	exports.receiveLiveData = receiveLiveData;
	exports.fetchFailed = fetchFailed;
	exports.setParent = setParent;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _overview = __webpack_require__(200);
	
	var overviewAction = _interopRequireWildcard(_overview);
	
	var _floorplan = __webpack_require__(203);
	
	var floorplanAction = _interopRequireWildcard(_floorplan);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var FETCH_LIVE_DATA = "FETCH_LIVE_DATA";
	exports.FETCH_LIVE_DATA = FETCH_LIVE_DATA;
	var RECEIVE_LIVE_DATA = "RECEIVE_LIVE_DATA";
	exports.RECEIVE_LIVE_DATA = RECEIVE_LIVE_DATA;
	var FETCH_FAILED = "FETCH_FAILED";
	exports.FETCH_FAILED = FETCH_FAILED;
	var SELECT_NODE_STATS = "SELECT_NODE_STATS";
	exports.SELECT_NODE_STATS = SELECT_NODE_STATS;
	var UPDATE_NODE_IN_PROGRESS = "UPDATE_NODE_IN_PROGRESS";
	exports.UPDATE_NODE_IN_PROGRESS = UPDATE_NODE_IN_PROGRESS;
	var UPDATE_FAILED = "UPDATE_FAILED";
	exports.UPDATE_FAILED = UPDATE_FAILED;
	var UPDATE_NODE_SUCCESSFULLY = "UPDATE_NODE_SUCCESSFULLY";
	exports.UPDATE_NODE_SUCCESSFULLY = UPDATE_NODE_SUCCESSFULLY;
	var CREATE_NODE_IN_PROGRESS = "CREATE_NODE_IN_PROGRESS";
	exports.CREATE_NODE_IN_PROGRESS = CREATE_NODE_IN_PROGRESS;
	var CREATE_NODE_SUCCESSFULLY = "CREATE_NODE_SUCCESSFULLY";
	exports.CREATE_NODE_SUCCESSFULLY = CREATE_NODE_SUCCESSFULLY;
	var CREATE_FAILED = "CREATED_FAILED";
	exports.CREATE_FAILED = CREATE_FAILED;
	var DELETE_NODE_IN_PROGRESS = "DELETE_NODE_IN_PROGRESS";
	exports.DELETE_NODE_IN_PROGRESS = DELETE_NODE_IN_PROGRESS;
	var DELETE_NODE_SUCCESSFULLY = "DELETE_NODE_SUCCESSFULLY";
	exports.DELETE_NODE_SUCCESSFULLY = DELETE_NODE_SUCCESSFULLY;
	var DELETE_FAILED = "DELETE_FAILED";
	exports.DELETE_FAILED = DELETE_FAILED;
	var ADD_FLOORPLAN_IN_PROGRESS = "ADD_FLOORPLAN_IN_PROGRESS";
	exports.ADD_FLOORPLAN_IN_PROGRESS = ADD_FLOORPLAN_IN_PROGRESS;
	var ADD_FLOORPLAN_SUCCESSFULLY = "ADD_FLOORPLAN_SUCCESSFULLY";
	exports.ADD_FLOORPLAN_SUCCESSFULLY = ADD_FLOORPLAN_SUCCESSFULLY;
	var ADD_FLOORPLAN_FAILED = "ADD_FLOORPLAN_FAILED";
	exports.ADD_FLOORPLAN_FAILED = ADD_FLOORPLAN_FAILED;
	var UPLOAD_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';
	exports.UPLOAD_IMAGE_FAILED = UPLOAD_IMAGE_FAILED;
	var UPLOAD_IMAGE_SUCCESSFUL = 'UPLOAD_SUCCESSFUL';
	exports.UPLOAD_IMAGE_SUCCESSFUL = UPLOAD_IMAGE_SUCCESSFUL;
	var UPLOAD_IMAGE = 'UPLOAD_IMAGE';
	exports.UPLOAD_IMAGE = UPLOAD_IMAGE;
	var SET_PARENT_IN_PROGRESS = 'SET_PARENT_IN_PROGRESS';
	exports.SET_PARENT_IN_PROGRESS = SET_PARENT_IN_PROGRESS;
	var SET_PARENT_SUCCESSFULLY = 'SET_PARENT_SUCCESSFULLY';
	exports.SET_PARENT_SUCCESSFULLY = SET_PARENT_SUCCESSFULLY;
	var SET_PARENT_FAILED = 'SET_PARENT_FAILED';
	
	exports.SET_PARENT_FAILED = SET_PARENT_FAILED;
	
	function setParentInProgess() {
		return {
			type: SET_PARENT_IN_PROGRESS
		};
	}
	
	function setParentSuccessfully(data) {
		return {
			type: SET_PARENT_SUCCESSFULLY,
			data: data
		};
	}
	
	function setParentFailed(data) {
		return {
			type: SET_PARENT_FAILED,
			data: data
		};
	}
	
	function updateNodeInProgress() {
		return {
			type: UPDATE_NODE_IN_PROGRESS
		};
	}
	
	function updateFailed(data) {
		return {
			type: UPDATE_FAILED,
			data: data
		};
	}
	
	function updateNodeSuccessfully(data) {
		return {
			type: UPDATE_NODE_SUCCESSFULLY,
			data: data
		};
	}
	
	function createNodeInProgress() {
		return {
			type: CREATE_NODE_IN_PROGRESS
		};
	}
	
	function createFailed(data) {
		return {
			type: CREATE_FAILED,
			data: data
		};
	}
	
	function createNodeSuccessfully(data) {
		return {
			type: CREATE_NODE_SUCCESSFULLY,
			data: data
		};
	}
	
	function deleteNodeInProgress() {
		return {
			type: DELETE_NODE_IN_PROGRESS
		};
	}
	
	function deleteFailed(data) {
		return {
			type: DELETE_FAILED,
			data: data
		};
	}
	
	function deleteNodeSuccessfully(data) {
		return {
			type: DELETE_NODE_SUCCESSFULLY,
			data: data
		};
	}
	
	function uploadImage(data) {
		return {
			type: UPLOAD_IMAGE,
			data: data
		};
	}
	
	function uploadImageFailed() {
		return {
			type: UPLOAD_IMAGE_FAILED
		};
	}
	
	function uploadImageSuccessful() {
		return {
			type: UPLOAD_IMAGE_SUCCESSFUL
		};
	}
	
	function updateNode(node) {
		return function (dispatch) {
			dispatch(updateNodeInProgress());
			return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/update/' + node.id)), node).then(function (response) {
				// Dirty hack !
				var oldNode = _store2['default'].getState().overviewReducer.nodeMap[node.id];
				Object.assign(oldNode, node, {
					info: _extends({}, oldNode.info, node.info)
				});
	
				_toastr2['default'].success(node.info.name + ' has been updated');
				dispatch(fetchLiveData());
				dispatch(overviewAction.fetchCustomerOverview());
				return response;
			})['catch'](function (response) {
				console.log(response);
				_toastr2['default'].error("Update node failed: ", response);
				dispatch(updateFailed(response.data));
				return response;
			});
		};
	}
	
	function createNode(id, node) {
		return function (dispatch) {
			dispatch(createNodeInProgress());
			return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/create/' + id)), node).then(function (response) {
				dispatch(createNodeSuccessfully(response.data));
				return response.data;
			})['catch'](function (response) {
				dispatch(createFailed(response.data));
			});
		};
	}
	
	function deleteNode(node) {
		return function (dispatch) {
			dispatch(deleteNodeInProgress());
			return _axios2['default']['delete']((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/delete/' + node.id))).then(function (response) {
				dispatch(deleteNodeSuccessfully(response.data));
				return response;
			})['catch'](function (response) {
				dispatch(deleteFailed(response.data));
				return response;
			});
		};
	}
	
	function uploadFloorplanView(node, image, type) {
		return function (dispatch) {
			var formData = new FormData();
			formData.append('floorplan', image);
			var axiosConfig = {
				headers: { 'Content-Type': 'multipart/form-data' },
				onUploadProgress: function onUploadProgress(e) {
					console.log(e);
				}
			};
			var newNode = {
				id: node.id,
				type: type
			};
			return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/update/' + node.id)), newNode).then(function (response) {
				return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/image/upload/' + node.id)), formData, axiosConfig).then(function (response) {
					_toastr2['default'].success("Edit floor plan successfully @@!");
					dispatch(overviewAction.fetchCustomerOverview());
					dispatch(floorplanAction.fetchImage());
				})['catch'](function (response) {
					_toastr2['default'].error("Edit floor plan failed : " + response.data);
				});
			})['catch'](function (response) {
				_toastr2['default'].error("Edit floor plan failed : " + response.data);
			});
		};
	}
	
	function selectNodeStats(node) {
		_componentsCommonAppHistory2['default'].push("/statistic");
	}
	
	function fetchLiveData(id) {
		return {
			type: FETCH_LIVE_DATA,
			id: id
		};
	}
	
	function receiveLiveData(response) {
		return {
			type: RECEIVE_LIVE_DATA,
			data: response.data
		};
	}
	
	function fetchFailed(data) {
		return {
			type: FETCH_FAILED,
			data: data
		};
	}
	
	function setParent(id1, id2) {
		return function (dispatch) {
			dispatch(setParentInProgess());
			return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/setparent/' + id1 + '/' + id2))).then(function (response) {
				dispatch(setParentSuccessfully(response.data));
				return response;
			})['catch'](function (response) {
				dispatch(setParentFailed(response.data));
				return response;
			});
		};
	}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports.fetchImage = fetchImage;
	exports.receiveImage = receiveImage;
	exports.updateSensor = updateSensor;
	exports.updateSensorInProgress = updateSensorInProgress;
	exports.updateSensorFailed = updateSensorFailed;
	exports.updateSensorCompleted = updateSensorCompleted;
	exports.saveSensor = saveSensor;
	exports.saveSensorCompleted = saveSensorCompleted;
	exports.saveSensorFailed = saveSensorFailed;
	exports.createSensor = createSensor;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _overview = __webpack_require__(200);
	
	var overviewAction = _interopRequireWildcard(_overview);
	
	var _node = __webpack_require__(202);
	
	var nodeAction = _interopRequireWildcard(_node);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	/**
	 * Floorplan image related
	 */
	var FETCH_IMAGE = 'FETCH_IMAGE';
	exports.FETCH_IMAGE = FETCH_IMAGE;
	var RECEIVE_IMAGE = 'RECEIVE_IMAGE';
	
	exports.RECEIVE_IMAGE = RECEIVE_IMAGE;
	
	function fetchImage(id) {
		return {
			type: FETCH_IMAGE,
			id: id
		};
	}
	
	function receiveImage(result) {
		return {
			type: RECEIVE_IMAGE,
			data: result.data
		};
	}
	
	/**
	 * Floorplan sensor related
	//  */
	var SAVE_SENSOR = 'SAVE_SENSOR';
	exports.SAVE_SENSOR = SAVE_SENSOR;
	var SAVE_SENSOR_COMPLETED = 'SAVE_SENSOR_COMPLETED';
	exports.SAVE_SENSOR_COMPLETED = SAVE_SENSOR_COMPLETED;
	var SAVE_SENSOR_FAILED = 'SAVE_SENSOR_FAILED';
	exports.SAVE_SENSOR_FAILED = SAVE_SENSOR_FAILED;
	var UPDATE_SENSOR = 'UPDATE_SENSOR';
	exports.UPDATE_SENSOR = UPDATE_SENSOR;
	var UPDATE_SENSOR_COMPLETED = 'UPDATE_SENSOR_COMPLETED';
	exports.UPDATE_SENSOR_COMPLETED = UPDATE_SENSOR_COMPLETED;
	var UPDATE_SENSOR_FAILED = 'UPDATE_SENSOR_FAILED';
	
	exports.UPDATE_SENSOR_FAILED = UPDATE_SENSOR_FAILED;
	
	function updateSensor(sensor) {
		return function (dispatch) {
			dispatch(updateSensorInProgress(sensor));
			return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/sensor/update/' + sensor.id)), sensor).then(function (response) {
				// Dirty hack !
				var ss = Object.assign({}, _store2['default'].getState().nodeReducer.map.get(sensor.id), sensor);
				_store2['default'].getState().nodeReducer.map.set(sensor.id, ss);
	
				dispatch(nodeAction.fetchLiveData());
				dispatch(overviewAction.fetchCustomerOverview());
				return response;
			})['catch'](function (response) {
				_toastr2['default'].error("Move sensor failed : ", response);
				dispatch(updateSensorFailed(response.data));
				return response;
			});
		};
	}
	
	function updateSensorInProgress(sensor) {
		return {
			type: UPDATE_SENSOR,
			sensor: sensor
		};
	}
	
	function updateSensorFailed(data) {
		return {
			type: UPDATE_SENSOR_FAILED,
			data: data
		};
	}
	
	function updateSensorCompleted() {
		return {
			type: UPDATE_SENSOR_COMPLETED
		};
	}
	
	function saveSensor(sensor) {
		return {
			type: SAVE_SENSOR,
			sensor: sensor
		};
	}
	
	function saveSensorCompleted(sensor) {
		return {
			type: SAVE_SENSOR_COMPLETED,
			sensor: sensor
		};
	}
	
	function saveSensorFailed() {
		return {
			type: SAVE_SENSOR_FAILED
		};
	}
	
	function createSensor(id, sensor) {
		return function (dispatch) {
			dispatch(saveSensor(sensor));
			return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/sensor/create/0/' + id)), sensor).then(function (response) {
				dispatch(saveSensorCompleted(response.data));
				return response;
			})['catch'](function (response) {
				dispatch(saveSensorFailed());
				return response;
			});
		};
	}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsComparison = __webpack_require__(205);
	
	var Comparison = _interopRequireWildcard(_actionsComparison);
	
	var initialState = {
	    nodes: [null, null],
	    daily: [],
	    total: [],
	    range: []
	};
	
	exports['default'] = function (state, action) {
	    if (state === undefined) state = initialState;
	
	    switch (action.type) {
	        case Comparison.COMPARISON_PUT_NODE:
	            {
	                // set nodes[action.pos] = action.node
	                return Object.assign({}, state, {
	                    nodes: Object.assign([].concat(_toConsumableArray(state.nodes)), _defineProperty({}, action.pos, action.node))
	                });
	            }
	
	        case Comparison.RECEIVE_FIRST_LOCATION_TOTAL:
	            {
	                state.total[0] = { data: action.data };
	                return Object.assign({}, state, {
	                    total: [].concat(_toConsumableArray(state.total))
	                });
	            }
	
	        case Comparison.RECEIVE_SECOND_LOCATION_TOTAL:
	            {
	                state.total[1] = { data: action.data };
	                return Object.assign({}, state, {
	                    total: [].concat(_toConsumableArray(state.total))
	                });
	            }
	
	        case Comparison.RECEIVE_FIRST_LOCATION_RANGE:
	            {
	                state.range[0] = { data: action.data };
	                return Object.assign({}, state, {
	                    range: [].concat(_toConsumableArray(state.range))
	                });
	            }
	
	        case Comparison.RECEIVE_SECOND_LOCATION_RANGE:
	            {
	                state.range[1] = { data: action.data };
	                return Object.assign({}, state, {
	                    range: [].concat(_toConsumableArray(state.range))
	                });
	            }
	
	        case Comparison.RECEIVE_FIRST_LOCATION_DAILY:
	            {
	                state.daily[0] = { data: action.data };
	                return Object.assign({}, state, {
	                    daily: [].concat(_toConsumableArray(state.daily))
	                });
	            }
	
	        case Comparison.RECEIVE_SECOND_LOCATION_DAILY:
	            {
	                state.daily[1] = { data: action.data };
	                return Object.assign({}, state, {
	                    daily: [].concat(_toConsumableArray(state.daily))
	                });
	            }
	
	        default:
	            return state;
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.putNode = putNode;
	exports.receiveFirstLocationTotal = receiveFirstLocationTotal;
	exports.receiveSecondLocationTotal = receiveSecondLocationTotal;
	exports.receiveFirstLocationRange = receiveFirstLocationRange;
	exports.receiveSecondLocationRange = receiveSecondLocationRange;
	exports.receiveFirstLocationDaily = receiveFirstLocationDaily;
	exports.receiveSecondLocationDaily = receiveSecondLocationDaily;
	var RECEIVE_FIRST_LOCATION_TOTAL = 'RECEIVE_FIRST_LOCATION_TOTAL';
	exports.RECEIVE_FIRST_LOCATION_TOTAL = RECEIVE_FIRST_LOCATION_TOTAL;
	var RECEIVE_SECOND_LOCATION_TOTAL = 'RECEIVE_SECOND_LOCATION_TOTAL';
	exports.RECEIVE_SECOND_LOCATION_TOTAL = RECEIVE_SECOND_LOCATION_TOTAL;
	var RECEIVE_FIRST_LOCATION_RANGE = 'RECEIVE_FIRST_LOCATION_RANGE';
	exports.RECEIVE_FIRST_LOCATION_RANGE = RECEIVE_FIRST_LOCATION_RANGE;
	var RECEIVE_SECOND_LOCATION_RANGE = 'RECEIVE_SECOND_LOCATION_RANGE';
	exports.RECEIVE_SECOND_LOCATION_RANGE = RECEIVE_SECOND_LOCATION_RANGE;
	var RECEIVE_FIRST_LOCATION_DAILY = 'RECEIVE_FIRST_LOCATION_DAILY';
	exports.RECEIVE_FIRST_LOCATION_DAILY = RECEIVE_FIRST_LOCATION_DAILY;
	var RECEIVE_SECOND_LOCATION_DAILY = 'RECEIVE_SECOND_LOCATION_DAILY';
	
	exports.RECEIVE_SECOND_LOCATION_DAILY = RECEIVE_SECOND_LOCATION_DAILY;
	var COMPARISON_PUT_NODE = "COMPARISON_PUT_NODE";
	exports.COMPARISON_PUT_NODE = COMPARISON_PUT_NODE;
	
	function putNode(node, pos) {
	    return {
	        type: COMPARISON_PUT_NODE,
	        node: node, pos: pos
	    };
	}
	
	function receiveFirstLocationTotal(data) {
	    return {
	        type: RECEIVE_FIRST_LOCATION_TOTAL,
	        data: data
	    };
	}
	
	function receiveSecondLocationTotal(data) {
	    return {
	        type: RECEIVE_SECOND_LOCATION_TOTAL,
	        data: data
	    };
	}
	
	function receiveFirstLocationRange(data) {
	    return {
	        type: RECEIVE_FIRST_LOCATION_RANGE,
	        data: data
	    };
	}
	
	function receiveSecondLocationRange(data) {
	    return {
	        type: RECEIVE_SECOND_LOCATION_RANGE,
	        data: data
	    };
	}
	
	function receiveFirstLocationDaily(data) {
	    return {
	        type: RECEIVE_FIRST_LOCATION_DAILY,
	        data: data
	    };
	}
	
	function receiveSecondLocationDaily(data) {
	    return {
	        type: RECEIVE_SECOND_LOCATION_DAILY,
	        data: data
	    };
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsStats = __webpack_require__(207);
	
	var Stats = _interopRequireWildcard(_actionsStats);
	
	//import store from '../store';
	
	var initialState = {
	    loading: false,
	    overviewMap: {},
	    stats: {
	        constraint: {
	            startdate: "13-11-2017",
	            enddate: "18-11-2017",
	            starthour: 8,
	            endhour: 17,
	            weekdaymask: "0111110"
	        },
	        points: []
	    },
	    range: {
	        points: []
	    },
	    breakdown: [],
	    daily: {},
	    sensorAverage: {
	        values: {},
	        constraint: {}
	    }
	};
	
	exports["default"] = function (state, action) {
	    if (state === undefined) state = initialState;
	
	    console.log(action);
	    switch (action.type) {
	        case Stats.FETCH_OCCUPANCY_OVERVIEW:
	            var map = _extends({}, state.overviewMap, _defineProperty({}, action.node.id, {
	                loading: true
	            }));
	            return Object.assign({}, state, {
	                overviewMap: map
	            });
	
	        case Stats.RECEIVE_OCCUPANCY_OVERVIEW:
	            map = _extends({}, state.overviewMap, _defineProperty({}, action.node.id, {
	                params: action.params,
	                data: action.data,
	                loading: false
	            }));
	            return Object.assign({}, state, {
	                overviewMap: map
	            });
	
	        case Stats.RECEIVE_NODE_STATS:
	            return Object.assign({}, state, {
	                stats: action.data
	            });
	
	        case Stats.RECEIVE_OCCUPANCY_RANGE:
	            {
	                return Object.assign({}, state, {
	                    range: action.data
	                });
	            }
	
	        case Stats.RECEIVE_STATS_BREAKDOWN:
	            {
	                return Object.assign({}, state, {
	                    breakdown: action.data
	                });
	            }
	
	        case Stats.RECEIVE_STATS_DAILY:
	            {
	                return Object.assign({}, state, {
	                    daily: action.data
	                });
	            }
	
	        case Stats.RECEIVE_SENSOR_AVERAGE:
	            {
	                return Object.assign({}, state, {
	                    sensorAverage: action.data
	                });
	            }
	
	        default:
	            return state;
	    }
	};
	
	module.exports = exports["default"];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.fetchOccupancyOverview = fetchOccupancyOverview;
	exports.receiveOccupancyOverview = receiveOccupancyOverview;
	exports.fetchFailed = fetchFailed;
	exports.receiveOccupancyRange = receiveOccupancyRange;
	exports.fetchNodeStats = fetchNodeStats;
	exports.receiveNodeStats = receiveNodeStats;
	exports.fetchStatsDaily = fetchStatsDaily;
	exports.receiveStatsDaily = receiveStatsDaily;
	exports.fetchStatsBreakdown = fetchStatsBreakdown;
	exports.receiveStatsBreakdown = receiveStatsBreakdown;
	exports.fetchSensorAverage = fetchSensorAverage;
	exports.receiveSensorAverage = receiveSensorAverage;
	exports.checkWeekdayMask = checkWeekdayMask;
	exports.getParams = getParams;
	exports.getComparisonParams = getComparisonParams;
	exports.findOccupancyTag = findOccupancyTag;
	exports.findEfficiencyTag = findEfficiencyTag;
	exports.getOccupancyOverview = getOccupancyOverview;
	exports.getNodeSeriesStats = getNodeSeriesStats;
	exports.getStatsDaily = getStatsDaily;
	exports.getStatsBreakdown = getStatsBreakdown;
	exports.downloadCSV = downloadCSV;
	exports.getSensorAverage = getSensorAverage;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsComparison = __webpack_require__(205);
	
	var Comparison = _interopRequireWildcard(_actionsComparison);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var FETCH_OCCUPANCY_OVERVIEW = 'FETCH_OCCUPANCY_OVERVIEW';
	exports.FETCH_OCCUPANCY_OVERVIEW = FETCH_OCCUPANCY_OVERVIEW;
	var RECEIVE_OCCUPANCY_OVERVIEW = 'RECEIVE_OCCUPANCY_OVERVIEW';
	
	exports.RECEIVE_OCCUPANCY_OVERVIEW = RECEIVE_OCCUPANCY_OVERVIEW;
	var FETCH_STATS_DAILY = 'FETCH_STATS_DAILY';
	exports.FETCH_STATS_DAILY = FETCH_STATS_DAILY;
	var RECEIVE_STATS_DAILY = 'RECEIVE_STATS_DAILY';
	exports.RECEIVE_STATS_DAILY = RECEIVE_STATS_DAILY;
	var RECEIVE_OCCUPANCY_RANGE = 'RECEIVE_OCCUPANCY_RANGE';
	
	exports.RECEIVE_OCCUPANCY_RANGE = RECEIVE_OCCUPANCY_RANGE;
	var FETCH_STATS_BREAKDOWN = 'FETCH_STATS_BREAKDOWN';
	exports.FETCH_STATS_BREAKDOWN = FETCH_STATS_BREAKDOWN;
	var RECEIVE_STATS_BREAKDOWN = 'RECEIVE_STATS_BREAKDOWN';
	
	exports.RECEIVE_STATS_BREAKDOWN = RECEIVE_STATS_BREAKDOWN;
	var FETCH_NODE_STATS = "FETCH_NODE_STATS";
	exports.FETCH_NODE_STATS = FETCH_NODE_STATS;
	var RECEIVE_NODE_STATS = "RECEIVE_NODE_STATS";
	
	exports.RECEIVE_NODE_STATS = RECEIVE_NODE_STATS;
	var FETCH_SENSOR_AVERAGE = 'FETCH_SENSOR_AVERAGE';
	exports.FETCH_SENSOR_AVERAGE = FETCH_SENSOR_AVERAGE;
	var RECEIVE_SENSOR_AVERAGE = 'RECEIVE_SENSOR_AVERAGE';
	
	exports.RECEIVE_SENSOR_AVERAGE = RECEIVE_SENSOR_AVERAGE;
	var FETCH_FAILED = 'FETCH_FAILED';
	
	exports.FETCH_FAILED = FETCH_FAILED;
	
	function fetchOccupancyOverview(params, node) {
	    return {
	        type: FETCH_OCCUPANCY_OVERVIEW,
	        node: node,
	        params: params
	    };
	}
	
	function receiveOccupancyOverview(node, params, data) {
	    return {
	        type: RECEIVE_OCCUPANCY_OVERVIEW,
	        node: node,
	        params: params,
	        data: data
	    };
	}
	
	function fetchFailed(data) {
	    return {
	        type: FETCH_FAILED,
	        data: data
	    };
	}
	
	function receiveOccupancyRange(data) {
	    return {
	        type: RECEIVE_OCCUPANCY_RANGE,
	        data: data
	    };
	}
	
	function fetchNodeStats(params) {
	    return {
	        type: FETCH_NODE_STATS,
	        params: params
	    };
	}
	
	function receiveNodeStats(data) {
	    return {
	        type: RECEIVE_NODE_STATS,
	        data: data
	    };
	}
	
	function fetchStatsDaily(params) {
	    return {
	        type: FETCH_STATS_DAILY,
	        params: params
	    };
	}
	
	function receiveStatsDaily(data) {
	    return {
	        type: RECEIVE_STATS_DAILY,
	        data: data
	    };
	}
	
	function fetchStatsBreakdown(params) {
	    return {
	        type: FETCH_STATS_BREAKDOWN,
	        params: params
	    };
	}
	
	function receiveStatsBreakdown(data) {
	    return {
	        type: RECEIVE_STATS_BREAKDOWN,
	        data: data
	    };
	}
	
	function fetchSensorAverage(params, node) {
	    return {
	        type: FETCH_SENSOR_AVERAGE,
	        node: node,
	        params: params
	    };
	}
	
	function receiveSensorAverage(node, params, data) {
	    return {
	        type: RECEIVE_SENSOR_AVERAGE,
	        node: node,
	        params: params,
	        data: data
	    };
	}
	
	function checkWeekdayMask(mask) {
	    if (!mask || mask.length != 7) {
	        return false;
	    }
	    for (var i = 0; i < mask.length; i++) {
	        if (mask[i] != "1" && mask[i] != "0") {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getParams(nextProps) {
	    var params = {
	        id: nextProps.currentNode.id,
	        startdate: nextProps.querySettings.startdate,
	        enddate: nextProps.querySettings.enddate,
	        starthour: nextProps.querySettings.starthour,
	        endhour: nextProps.querySettings.endhour,
	        weekdaymask: nextProps.querySettings.weekdaymask,
	        marks: nextProps.querySettings.marks,
	        groupby: nextProps.querySettings.groupby
	    };
	    var cards = _store2['default'].getState().defaultSettingsReducer.card;
	    var card = cards[nextProps.currentNode.info.cardid];
	
	    if (card) {
	        if (!(params.starthour != null && 0 <= params.starthour && params.starthour <= 23)) {
	            params.starthour = card.starthour;
	        }
	        if (!(params.endhour != null && 0 <= params.endhour && params.endhour <= 23)) {
	            params.endhour = card.endhour;
	        }
	        if (!checkWeekdayMask(params.weekdaymask)) {
	            params.weekdaymask = card.weekdaymask;
	        }
	    }
	
	    if (nextProps.querySettings.tag === 'Occupancy') {
	        params.tag = nextProps.querySettings.room.occupancyTag;
	    } else {
	        params.tag = nextProps.querySettings.room.efficiencyTag || nextProps.querySettings.room.occupancyTag;
	    }
	    return params;
	}
	
	function getComparisonParams(nextProps, id, card, tagType) {
	    var params = {
	        id: id,
	        startdate: nextProps.querySettings.startdate,
	        enddate: nextProps.querySettings.enddate,
	        starthour: nextProps.querySettings.starthour,
	        endhour: nextProps.querySettings.endhour,
	        weekdaymask: nextProps.querySettings.weekdaymask,
	        marks: nextProps.querySettings.marks,
	        groupby: nextProps.querySettings.groupby
	    };
	
	    if (card) {
	        if (!(params.starthour != null && 0 <= params.starthour && params.starthour <= 23)) {
	            params.starthour = card.starthour;
	        }
	        if (!(params.endhour != null && 0 <= params.endhour && params.endhour <= 23)) {
	            params.endhour = card.endhour;
	        }
	        if (!checkWeekdayMask(params.weekdaymask)) {
	            params.weekdaymask = card.weekdaymask;
	        }
	    }
	    if (tagType === "meeting_room") {
	        params.room = _config2['default'].room.MEETINGROOM;
	        params.tag = _config2['default'].room.MEETINGROOM.occupancyTag || _config2['default'].room.MEETINGROOM.efficiencyTag;
	    } else if (tagType === "open_area") {
	        params.room = _config2['default'].room.OPENAREA;
	        params.tag = _config2['default'].room.OPENAREA.occupancyTag;
	    } else {
	        params.room = _config2['default'].room.ALLAREA;
	        params.tag = _config2['default'].room.ALLAREA.occupancyTag;
	    }
	
	    return params;
	}
	
	function findOccupancyTag(node) {
	    if (node.type == 'meeting_room') {
	        return 'MRO';
	    } else if (node.type == 'open_area') {
	        return 'OAO';
	    } else {
	        return 'TTO';
	    }
	}
	
	function findEfficiencyTag(node) {
	    if (node.type == 'meeting_room') {
	        return 'MRE';
	    } else {
	        return findOccupancyTag(node);
	    }
	}
	
	function getOccupancyOverview(params, node) {
	    return function (dispatch) {
	        dispatch(fetchOccupancyOverview(params, node));
	        _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/stats/overview/' + params.id + '/' + params.tag + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask + '&marks=' + JSON.stringify(params.marks)))).then(function (response) {
	            dispatch(receiveOccupancyOverview(node, params, response.data));
	        })['catch'](function (response) {
	            console.log(response);
	            dispatch(fetchFailed(response.data));
	        });
	    };
	}
	
	function getNodeSeriesStats(params) {
	    return function (dispatch) {
	        dispatch(fetchNodeStats(params));
	        _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/stats/series/' + params.id + '/' + params.tag + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask + '&marks=' + JSON.stringify(params.marks) + '&groupby=' + params.groupby))).then(function (response) {
	            if (params.action == Comparison.RECEIVE_FIRST_LOCATION_TOTAL) {
	                dispatch(Comparison.receiveFirstLocationTotal(response.data));
	            } else if (params.action == Comparison.RECEIVE_SECOND_LOCATION_TOTAL) {
	                dispatch(Comparison.receiveSecondLocationTotal(response.data));
	            } else if (params.action == Comparison.RECEIVE_FIRST_LOCATION_RANGE) {
	                dispatch(Comparison.receiveFirstLocationRange(response.data));
	            } else if (params.action == Comparison.RECEIVE_SECOND_LOCATION_RANGE) {
	                dispatch(Comparison.receiveSecondLocationRange(response.data));
	            } else if (params.chart == 'range') {
	                dispatch(receiveOccupancyRange(response.data));
	            } else {
	                dispatch(receiveNodeStats(response.data));
	            }
	        })['catch'](function (response) {
	            dispatch(fetchFailed(response.data));
	        });
	    };
	}
	
	function getStatsDaily(params) {
	    return function (dispatch) {
	        dispatch(fetchStatsDaily(params));
	        _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/stats/weekdayXhour/' + params.id + '/' + params.tag + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask + '&marks=' + JSON.stringify(params.marks)))).then(function (response) {
	            if (params.action == Comparison.RECEIVE_FIRST_LOCATION_DAILY) {
	                dispatch(Comparison.receiveFirstLocationDaily(response.data));
	            } else if (params.action == Comparison.RECEIVE_SECOND_LOCATION_DAILY) {
	                dispatch(Comparison.receiveSecondLocationDaily(response.data));
	            } else {
	                dispatch(receiveStatsDaily(response.data));
	            }
	        })['catch'](function (response) {
	            dispatch(fetchFailed(response.data));
	        });
	    };
	}
	
	function getStatsBreakdown(params) {
	    return function (dispatch) {
	        dispatch(fetchStatsBreakdown(params));
	        _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/stats/overviewlist/' + JSON.stringify(params.id) + '/' + params.tag + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask + '&marks=' + JSON.stringify(params.marks)))).then(function (response) {
	            dispatch(receiveStatsBreakdown(response.data));
	        })['catch'](function (response) {
	            dispatch(fetchFailed(response.data));
	        });
	    };
	}
	
	function downloadCSV(node, querySettings, callbacks) {
	    var params = Object.assign({}, {
	        currentNode: node,
	        querySettings: querySettings
	    });
	    params = getParams(params);
	
	    var url = (0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/csv/sensor/raw/' + node.id + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask));
	
	    var cf = {
	        onDownloadProgress: function onDownloadProgress(e) {
	            console.log(e);
	        }
	    };
	
	    _axios2['default'].get(url, cf).then(function (response) {
	        var file = new Blob([response.data], { type: 'text/plain' });
	        var objectUrl = window.URL.createObjectURL(file);
	
	        var anchor = document.createElement("a");
	        anchor.href = objectUrl;
	        anchor.download = 'sensor-records.csv';
	        anchor.click();
	
	        window.URL.revokeObjectURL(objectUrl);
	        callbacks();
	    })['catch'](function (error) {
	        callbacks();
	    });
	}
	
	function getSensorAverage(params, node) {
	    return function (dispatch) {
	        dispatch(fetchSensorAverage(params, node));
	        _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/stats/sensoraverage/' + params.id + '?startdate=' + params.startdate + '&enddate=' + params.enddate + '&starthour=' + params.starthour + '&endhour=' + params.endhour + '&weekdaymask=' + params.weekdaymask))).then(function (response) {
	            dispatch(receiveSensorAverage(node, params, response.data));
	        })['catch'](function (response) {
	            console.log(response);
	            dispatch(fetchFailed(response.data));
	        });
	    };
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _actionsQuerysettings = __webpack_require__(346);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var initialState = {
	  room: _config2['default'].room.ALLAREA,
	  tag: 'Occupancy',
	  startdate: (0, _moment2['default'])().subtract(1, "weeks").add(1, "days").format('DD-MM-YYYY'),
	  enddate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	  id: -1,
	  starthour: null,
	  endhour: null,
	  marks: [0.25, 0.75],
	  groupby: 'day',
	  active: 'This week'
	};
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsQuerysettings.SELECT_ROOM_TYPE:
	      {
	        return Object.assign({}, state, {
	          room: action.room
	        });
	      }
	
	    case _actionsQuerysettings.SELECT_TAG:
	      {
	        return Object.assign({}, state, {
	          tag: action.tag
	        });
	      }
	
	    case _actionsQuerysettings.SELECT_PERIOD:
	      {
	        return Object.assign({}, state, {
	          startdate: action.period.startdate,
	          enddate: action.period.enddate,
	          starthour: action.period.starthour,
	          endhour: action.period.endhour,
	          groupby: action.period.groupby,
	          active: action.period.active
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	module.exports = exports['default'];
	/*SELECT_MODE,*/

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.3
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(210)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.3';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 211,
		"./af.js": 211,
		"./ar": 212,
		"./ar-dz": 213,
		"./ar-dz.js": 213,
		"./ar-kw": 214,
		"./ar-kw.js": 214,
		"./ar-ly": 215,
		"./ar-ly.js": 215,
		"./ar-ma": 216,
		"./ar-ma.js": 216,
		"./ar-sa": 217,
		"./ar-sa.js": 217,
		"./ar-tn": 218,
		"./ar-tn.js": 218,
		"./ar.js": 212,
		"./az": 219,
		"./az.js": 219,
		"./be": 220,
		"./be.js": 220,
		"./bg": 221,
		"./bg.js": 221,
		"./bm": 222,
		"./bm.js": 222,
		"./bn": 223,
		"./bn-bd": 224,
		"./bn-bd.js": 224,
		"./bn.js": 223,
		"./bo": 225,
		"./bo.js": 225,
		"./br": 226,
		"./br.js": 226,
		"./bs": 227,
		"./bs.js": 227,
		"./ca": 228,
		"./ca.js": 228,
		"./cs": 229,
		"./cs.js": 229,
		"./cv": 230,
		"./cv.js": 230,
		"./cy": 231,
		"./cy.js": 231,
		"./da": 232,
		"./da.js": 232,
		"./de": 233,
		"./de-at": 234,
		"./de-at.js": 234,
		"./de-ch": 235,
		"./de-ch.js": 235,
		"./de.js": 233,
		"./dv": 236,
		"./dv.js": 236,
		"./el": 237,
		"./el.js": 237,
		"./en-au": 238,
		"./en-au.js": 238,
		"./en-ca": 239,
		"./en-ca.js": 239,
		"./en-gb": 240,
		"./en-gb.js": 240,
		"./en-ie": 241,
		"./en-ie.js": 241,
		"./en-il": 242,
		"./en-il.js": 242,
		"./en-in": 243,
		"./en-in.js": 243,
		"./en-nz": 244,
		"./en-nz.js": 244,
		"./en-sg": 245,
		"./en-sg.js": 245,
		"./eo": 246,
		"./eo.js": 246,
		"./es": 247,
		"./es-do": 248,
		"./es-do.js": 248,
		"./es-mx": 249,
		"./es-mx.js": 249,
		"./es-us": 250,
		"./es-us.js": 250,
		"./es.js": 247,
		"./et": 251,
		"./et.js": 251,
		"./eu": 252,
		"./eu.js": 252,
		"./fa": 253,
		"./fa.js": 253,
		"./fi": 254,
		"./fi.js": 254,
		"./fil": 255,
		"./fil.js": 255,
		"./fo": 256,
		"./fo.js": 256,
		"./fr": 257,
		"./fr-ca": 258,
		"./fr-ca.js": 258,
		"./fr-ch": 259,
		"./fr-ch.js": 259,
		"./fr.js": 257,
		"./fy": 260,
		"./fy.js": 260,
		"./ga": 261,
		"./ga.js": 261,
		"./gd": 262,
		"./gd.js": 262,
		"./gl": 263,
		"./gl.js": 263,
		"./gom-deva": 264,
		"./gom-deva.js": 264,
		"./gom-latn": 265,
		"./gom-latn.js": 265,
		"./gu": 266,
		"./gu.js": 266,
		"./he": 267,
		"./he.js": 267,
		"./hi": 268,
		"./hi.js": 268,
		"./hr": 269,
		"./hr.js": 269,
		"./hu": 270,
		"./hu.js": 270,
		"./hy-am": 271,
		"./hy-am.js": 271,
		"./id": 272,
		"./id.js": 272,
		"./is": 273,
		"./is.js": 273,
		"./it": 274,
		"./it-ch": 275,
		"./it-ch.js": 275,
		"./it.js": 274,
		"./ja": 276,
		"./ja.js": 276,
		"./jv": 277,
		"./jv.js": 277,
		"./ka": 278,
		"./ka.js": 278,
		"./kk": 279,
		"./kk.js": 279,
		"./km": 280,
		"./km.js": 280,
		"./kn": 281,
		"./kn.js": 281,
		"./ko": 282,
		"./ko.js": 282,
		"./ku": 283,
		"./ku.js": 283,
		"./ky": 284,
		"./ky.js": 284,
		"./lb": 285,
		"./lb.js": 285,
		"./lo": 286,
		"./lo.js": 286,
		"./lt": 287,
		"./lt.js": 287,
		"./lv": 288,
		"./lv.js": 288,
		"./me": 289,
		"./me.js": 289,
		"./mi": 290,
		"./mi.js": 290,
		"./mk": 291,
		"./mk.js": 291,
		"./ml": 292,
		"./ml.js": 292,
		"./mn": 293,
		"./mn.js": 293,
		"./mr": 294,
		"./mr.js": 294,
		"./ms": 295,
		"./ms-my": 296,
		"./ms-my.js": 296,
		"./ms.js": 295,
		"./mt": 297,
		"./mt.js": 297,
		"./my": 298,
		"./my.js": 298,
		"./nb": 299,
		"./nb.js": 299,
		"./ne": 300,
		"./ne.js": 300,
		"./nl": 301,
		"./nl-be": 302,
		"./nl-be.js": 302,
		"./nl.js": 301,
		"./nn": 303,
		"./nn.js": 303,
		"./oc-lnc": 304,
		"./oc-lnc.js": 304,
		"./pa-in": 305,
		"./pa-in.js": 305,
		"./pl": 306,
		"./pl.js": 306,
		"./pt": 307,
		"./pt-br": 308,
		"./pt-br.js": 308,
		"./pt.js": 307,
		"./ro": 309,
		"./ro.js": 309,
		"./ru": 310,
		"./ru.js": 310,
		"./sd": 311,
		"./sd.js": 311,
		"./se": 312,
		"./se.js": 312,
		"./si": 313,
		"./si.js": 313,
		"./sk": 314,
		"./sk.js": 314,
		"./sl": 315,
		"./sl.js": 315,
		"./sq": 316,
		"./sq.js": 316,
		"./sr": 317,
		"./sr-cyrl": 318,
		"./sr-cyrl.js": 318,
		"./sr.js": 317,
		"./ss": 319,
		"./ss.js": 319,
		"./sv": 320,
		"./sv.js": 320,
		"./sw": 321,
		"./sw.js": 321,
		"./ta": 322,
		"./ta.js": 322,
		"./te": 323,
		"./te.js": 323,
		"./tet": 324,
		"./tet.js": 324,
		"./tg": 325,
		"./tg.js": 325,
		"./th": 326,
		"./th.js": 326,
		"./tk": 327,
		"./tk.js": 327,
		"./tl-ph": 328,
		"./tl-ph.js": 328,
		"./tlh": 329,
		"./tlh.js": 329,
		"./tr": 330,
		"./tr.js": 330,
		"./tzl": 331,
		"./tzl.js": 331,
		"./tzm": 332,
		"./tzm-latn": 333,
		"./tzm-latn.js": 333,
		"./tzm.js": 332,
		"./ug-cn": 334,
		"./ug-cn.js": 334,
		"./uk": 335,
		"./uk.js": 335,
		"./ur": 336,
		"./ur.js": 336,
		"./uz": 337,
		"./uz-latn": 338,
		"./uz-latn.js": 338,
		"./uz.js": 337,
		"./vi": 339,
		"./vi.js": 339,
		"./x-pseudo": 340,
		"./x-pseudo.js": 340,
		"./yo": 341,
		"./yo.js": 341,
		"./zh-cn": 342,
		"./zh-cn.js": 342,
		"./zh-hk": 343,
		"./zh-hk.js": 343,
		"./zh-mo": 344,
		"./zh-mo.js": 344,
		"./zh-tw": 345,
		"./zh-tw.js": 345
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 210;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(209)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.selectTag = selectTag;
	exports.selectPeriod = selectPeriod;
	exports.selectRoomType = selectRoomType;
	var SELECT_PERIOD = 'SELECT_PERIOD';
	exports.SELECT_PERIOD = SELECT_PERIOD;
	var SELECT_MODE = 'SELECT_MODE';
	exports.SELECT_MODE = SELECT_MODE;
	var SELECT_TAG = 'SELECT_TAG';
	exports.SELECT_TAG = SELECT_TAG;
	var SELECT_ROOM_TYPE = 'SELECT_ROOM_TYPE';
	
	exports.SELECT_ROOM_TYPE = SELECT_ROOM_TYPE;
	
	function selectTag(tag) {
	  return {
	    type: SELECT_TAG,
	    tag: tag
	  };
	}
	
	function selectPeriod(period) {
	  return {
	    type: SELECT_PERIOD,
	    period: period
	  };
	}
	
	function selectRoomType(room) {
	  return {
	    type: SELECT_ROOM_TYPE,
	    room: room
	  };
	}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var initialState = {
		nodeFilter: {
			info: {
				name: "",
				empty: true
			},
			children: [],
			type: null
		},
		viewFilter: _config2['default'].viewFilter[0]
	};
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			case _actionsLiveFilter.SELECT_NODE:
				{
					return Object.assign({}, state, {
						nodeFilter: action.node
					});
				}
	
			case _actionsLiveFilter.SELECT_VIEW:
				{
					return Object.assign({}, state, {
						viewFilter: action.view
					});
				}
	
			default:
				return state;
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.selectNodeFilter = selectNodeFilter;
	exports.selectViewFilter = selectViewFilter;
	var SELECT_NODE = 'SELECT_NODE';
	exports.SELECT_NODE = SELECT_NODE;
	var SELECT_VIEW = 'SELECT_VIEW';
	
	exports.SELECT_VIEW = SELECT_VIEW;
	
	function selectNodeFilter(node) {
	  return {
	    type: SELECT_NODE,
	    node: node
	  };
	}
	
	function selectViewFilter(view) {
	  return {
	    type: SELECT_VIEW,
	    view: view
	  };
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	var _actionsDevicemanagement = __webpack_require__(350);
	
	var a = _interopRequireWildcard(_actionsDevicemanagement);
	
	var initialState = {
		configMap: null
	};
	
	function serialize(obj) {
		// deep deterministic serialize.
		// used to generate hash of nested config objects.
	
		if (obj !== Object(obj)) {
			// obj is primitive
			// https://stackoverflow.com/questions/31538010/test-if-a-variable-is-a-primitive-rather-than-an-object
			return JSON.stringify(obj);
		} else {
			// obj is an object
			var keys = Object.keys(obj).sort();
			var res = "{";
			keys.forEach(function (key) {
				res += JSON.stringify(key) + ":" + serialize(obj[key]) + ",";
			});
			res += "}";
			return res;
		}
	}
	
	function generateColor(configMap) {
		var macs = Object.keys(configMap);
		var mac2hash = {};
		var hash2color = {};
		var mac2color = {};
		macs.forEach(function (mac) {
			var hash = serialize(configMap[mac].currentConfig); // TODO : use md5 hash of serialized string instead of raw serialized string, to achieve limited length, better performace.
			mac2hash[mac] = hash;
			hash2color[hash] = null;
		});
	
		var hashs = Object.keys(hash2color);
		var numColors = hashs.length;
		hashs.forEach(function (hash, idx) {
			var i = idx * 360 / numColors;
			var hue = i;
			var saturation = 90 + Math.random() * 10;
			var lightness = 50 + Math.random() * 10;
			hash2color[hash] = "hsl(" + hue + "," + saturation + "%," + lightness + "%)";
		});
	
		macs.forEach(function (mac) {
			var hash = mac2hash[mac];
			var color = hash2color[hash];
			mac2color[mac] = color;
		});
		return mac2color;
	}
	
	exports["default"] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			case a.RECEIVE_CONFIG:
				{
					var colors = generateColor(action.data);
					return Object.assign({}, state, {
						configMap: action.data,
						colors: colors
					});
				}
			default:
				return state;
		}
	};
	
	module.exports = exports["default"];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports.receiveConfig = receiveConfig;
	exports.receiveConfigFail = receiveConfigFail;
	exports.fetchConfig = fetchConfig;
	exports.updateConfig = updateConfig;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var RECEIVE_CONFIG = "RECEIVE_CONFIG";
	exports.RECEIVE_CONFIG = RECEIVE_CONFIG;
	
	function receiveConfig(data) {
		return {
			type: RECEIVE_CONFIG,
			data: data
		};
	}
	
	var RECEIVE_CONFIG_FAIL = "RECEIVE_CONFIG_FAIL";
	exports.RECEIVE_CONFIG_FAIL = RECEIVE_CONFIG_FAIL;
	
	function receiveConfigFail(data) {
		return {
			type: RECEIVE_CONFIG_FAIL,
			data: data
		};
	}
	
	var FETCH_CONFIG = "FETCH_CONFIG";
	exports.FETCH_CONFIG = FETCH_CONFIG;
	
	function fetchConfig(id) {
		if (!id) {
			id = _store2['default'].getState().myAccountReducer.user.rootnodeid;
		}
	
		return function (dispatch) {
			dispatch({ type: FETCH_CONFIG, id: id });
			return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/devicemanagement/mqttsensor/batch-config/' + id))).then(function (response) {
				dispatch(receiveConfig(response.data));
				return response;
			})['catch'](function (response) {
				dispatch(receiveConfigFail(response));
				return response;
			});
		};
	}
	
	var UPDATE_CONFIG = "UPDATE_CONFIG";
	exports.UPDATE_CONFIG = UPDATE_CONFIG;
	
	function updateConfig(mac, data, fClose) {
		return function (dispatch) {
			dispatch({ type: UPDATE_CONFIG, mac: mac, data: data });
	
			return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/devicemanagement/mqttsensor/config-nonblocking/' + mac)), data).then(function (response) {
				fClose();
				return response;
			})['catch'](function (response) {
				console.log(response);
				fClose();
				return response;
			});
		};
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//import axios from 'axios';
	//import config from 'config';
	//import { Effects, loop } from 'redux-loop';
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var a = _interopRequireWildcard(_actionsFloorplan);
	
	var initialState = {
	  loading: false,
	  selectedSensor: undefined,
	  sensors: []
	};
	
	// Reducing function
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	
	    case a.MOVE_SENSOR:
	      {
	        action.sensor.xpercent = action.x;
	        action.sensor.ypercent = action.y;
	        return Object.assign({}, state, {
	          selectedSensor: {}
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var initialState = {
	  loading: false,
	  uploadImageSuccessful: false,
	  uploadImageFailed: false,
	  images: null
	};
	
	function _fetchImage(id) {
	  if (!id) {
	    id = _store2['default'].getState().myAccountReducer.user.companyid;
	  }
	  return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/node/image/' + id)).then(_actionsFloorplan.receiveImage)['catch']((0, _actionsFloorplan.fetchImage)(id));
	}
	
	// Reducing function
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsFloorplan.FETCH_IMAGE:
	      {
	        return (0, _reduxLoop.loop)(Object.assign({}, initialState), _reduxLoop.Effects.promise(_fetchImage, action.id));
	      }
	    case _actionsFloorplan.RECEIVE_IMAGE:
	      {
	        return Object.assign({}, initialState, { images: action.data });
	      }
	    default:
	      {
	        return state;
	      }
	
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/*import axios from 'axios';
	import config from 'config';
	import { Effects, loop } from 'redux-loop';
	import { finalize } from "actions/URLfinalizer";*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _actionsMyaccount = __webpack_require__(
	//updateFailed,
	//updateCompleted,
	
	//DELETE_WIDGET,
	354);
	
	var initialState = {
	  loading: false,
	  user: null
	};
	
	/*function updateUser(user) {
	  return axios.post(finalize(config.api.root + `/api/user/${user.id}`))
	    .then(updateCompleted)
	    .catch(updateFailed)
	}*/
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    //case UPDATE_USER: {
	    //  return loop (
	    //    Object.assign({}, initialState, {loading: true}),
	    //    Effects.promise(updateUser)
	    //  )
	    //}
	
	    case _actionsMyaccount.USER_UPDATE_COMPLETED:
	      {
	        return Object.assign({}, state, {
	          loading: false,
	          user: action.data
	        });
	      }
	
	    case _actionsMyaccount.RECEIVE_USER:
	      {
	        return Object.assign({}, state, {
	          user: action.data
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};
	
	module.exports = exports['default'];

	//UPDATE_USER,

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setWidgets = setWidgets;
	exports.deleteWidget = deleteWidget;
	exports.editWidget = editWidget;
	exports.updateInProgress = updateInProgress;
	exports.updateFailed = updateFailed;
	exports.updateCompleted = updateCompleted;
	exports.updatePasswordInProgress = updatePasswordInProgress;
	exports.updatePasswordFailed = updatePasswordFailed;
	exports.updatePasswordCompleted = updatePasswordCompleted;
	exports.updateUser = updateUser;
	exports.updatePassword = updatePassword;
	exports.fetchUser = fetchUser;
	exports.receiveUser = receiveUser;
	exports.fetchUserFailed = fetchUserFailed;
	exports.fetchCurrentUser = fetchCurrentUser;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS';
	exports.UPDATE_IN_PROGRESS = UPDATE_IN_PROGRESS;
	var UPDATE_FAILED = 'UPDATE_FAILED';
	exports.UPDATE_FAILED = UPDATE_FAILED;
	var USER_UPDATE_COMPLETED = 'USER_UPDATE_COMPLETED';
	exports.USER_UPDATE_COMPLETED = USER_UPDATE_COMPLETED;
	var UPDATE_PASSWORD_IN_PROGRESS = 'UPDATE_PASSWORD_IN_PROGRESS';
	exports.UPDATE_PASSWORD_IN_PROGRESS = UPDATE_PASSWORD_IN_PROGRESS;
	var UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED';
	exports.UPDATE_PASSWORD_FAILED = UPDATE_PASSWORD_FAILED;
	var UPDATE_PASSWORD_COMPLETED = 'UPDATE_PASSWORD_COMPLETED';
	exports.UPDATE_PASSWORD_COMPLETED = UPDATE_PASSWORD_COMPLETED;
	var FETCH_USER = 'FETCH_USER';
	exports.FETCH_USER = FETCH_USER;
	var RECEIVE_USER = 'RECEIVE_USER';
	exports.RECEIVE_USER = RECEIVE_USER;
	var FETCH_USER_FAILED = 'FECTH_USER_FAILED';
	
	exports.FETCH_USER_FAILED = FETCH_USER_FAILED;
	var SET_WIDGETS = "SET_WIDGETS";
	exports.SET_WIDGETS = SET_WIDGETS;
	
	function setWidgets(nodes) {
	  return {
	    type: SET_WIDGETS,
	    widgets: widgets
	  };
	}
	
	var DELETE_WIDGET = 'DELETE_WIDGET';
	exports.DELETE_WIDGET = DELETE_WIDGET;
	
	function deleteWidget(nodeId) {
	  return {
	    type: DELETE_WIDGET,
	    nodeId: nodeId
	  };
	}
	
	var EDIT_WIDGET = 'EDIT_WDIGET';
	exports.EDIT_WIDGET = EDIT_WIDGET;
	
	function editWidget(nodeId1, nodeId2) {
	  return {
	    type: EDIT_WIDGET,
	    nodeId1: nodeId1,
	    nodeId2: nodeId2
	  };
	}
	
	function updateInProgress() {
	  return {
	    type: UPDATE_IN_PROGRESS
	  };
	}
	
	function updateFailed(data) {
	  return {
	    type: UPDATE_FAILED,
	    data: data
	  };
	}
	
	function updateCompleted(data) {
	  return {
	    type: USER_UPDATE_COMPLETED,
	    data: data
	  };
	}
	
	function updatePasswordInProgress() {
	  return {
	    type: UPDATE_PASSWORD_IN_PROGRESS
	  };
	}
	
	function updatePasswordFailed(data) {
	  return {
	    type: UPDATE_PASSWORD_FAILED,
	    data: data
	  };
	}
	
	function updatePasswordCompleted(data) {
	  return {
	    type: UPDATE_PASSWORD_COMPLETED,
	    data: data
	  };
	}
	
	function updateUser(username, user) {
	  return function (dispatch) {
	    dispatch(updateInProgress());
	    return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/update/' + username), user).then(function (response) {
	      dispatch(updateCompleted(response.data));
	    })['catch'](function (response) {
	      dispatch(updateFailed(response.data));
	    });
	  };
	}
	
	function updatePassword(user) {
	  return function (dispatch) {
	    dispatch(updatePasswordInProgress());
	    return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/password'), user).then(function (response) {
	      _toastr2['default'].success('Update password successfully !');
	      return response;
	    })['catch'](function (response) {
	      console.log(response);
	      _toastr2['default'].error(response.data || response.statusText.data);
	      return response;
	    });
	  };
	}
	
	function fetchUser() {
	  return {
	    type: FETCH_USER
	  };
	}
	
	function receiveUser(data) {
	  return {
	    type: RECEIVE_USER,
	    data: data
	  };
	}
	
	function fetchUserFailed(data) {
	  return {
	    type: FETCH_USER_FAILED,
	    data: data
	  };
	}
	
	function fetchCurrentUser() {
	  return function (dispatch) {
	    dispatch(fetchUser());
	    return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/me')).then(function (response) {
	      dispatch(receiveUser(response.data));
	      return response;
	    })['catch'](function (response) {
	      dispatch(fetchUserFailed(response.data || response.statusText));
	      throw response;
	    });
	  };
	}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _actionsUser = __webpack_require__(356);
	
	var a = _interopRequireWildcard(_actionsUser);
	
	var initialState = {
		contact: {},
		contactFetched: false,
		nodeFilter: {
			id: -2,
			info: {
				name: "",
				empty: true
			},
			children: [],
			type: null
		},
		userTypeFilter: _config2['default'].userTypeFilter[0],
	
		selectedUser: {},
		EAstage: "nothing", // EA = edit account
		EArespond: {}
	
	};
	
	function listContact() {
		return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/contact')).then(function (res) {
			return a.listContactOk(res);
		})['catch'](function (error) {
			return a.listContactFail(error);
		});
	}
	function editUser(user) {
		return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/update/' + user.username), user).then(function (res) {
			return a.editUserOk(res);
		})['catch'](function (error) {
			return a.editUserFail(error);
		});
	}
	function deleteUser(user) {
		return _axios2['default']['delete']((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/delete/' + user.username)).then(function (res) {
			return a.listContact();
		})['catch'](function (error) {
			return a.deleteUserFail(error);
		});
	}
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			// List contact
			case a.LIST_CONTACT:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { contactFetched: false }), _reduxLoop.Effects.promise(listContact));
				}
			case a.LIST_CONTACT_OK:
				{
					return Object.assign({}, state, {
						contact: action.e.data,
						contactFetched: true
					});
				}
			case a.LIST_CONTACT_FAIL:
			case a.NEED_CONTACT:
				{
					return Object.assign({}, state, {
						contactFetched: false
					});
				}
			// Select
			case a.SELECT_USER:
				{
					return Object.assign({}, state, {
						selectedUser: action.user,
						EAstage: "nothing",
						EArespond: {},
						DAstage: "nothing",
						DArespond: {}
					});
				}
			// Edit
			case a.EDIT_USER:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {
						EAstage: "editing",
						EArespond: {}
					}), _reduxLoop.Effects.promise(editUser, action.username));
				}
			case a.EDIT_USER_OK:
				{
					return Object.assign({}, state, {
						EAstage: "edited",
						EArespond: {}
					});
				}
			case a.EDIT_USER_FAIL:
				{
					return Object.assign({}, state, {
						EAstage: "edit-failed",
						EArespond: action.e
					});
				}
			// Delete
			case a.DELETE_USER:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {}), _reduxLoop.Effects.promise(deleteUser, action.username));
				}
			case a.DELETE_USER_OK:
				{
					return Object.assign({}, state, {});
				}
			case a.DELETE_USER_FAIL:
				{
					return Object.assign({}, state, {});
				}
			// Filters
			case a.USERAD_SELECT_NODE:
				{
					return Object.assign({}, state, {
						nodeFilter: action.node
					});
				}
	
			case a.USERAD_SELECT_TYPE:
				{
					return Object.assign({}, state, {
						userTypeFilter: action.code
					});
				}
	
			default:
				return state;
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	// Invite new user
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.inviteUser = inviteUser;
	exports.inviteUserOk = inviteUserOk;
	exports.inviteUserFail = inviteUserFail;
	exports.resetInviteStatus = resetInviteStatus;
	exports.checkInviteKey = checkInviteKey;
	exports.checkInviteKeyOk = checkInviteKeyOk;
	exports.checkInviteKeyFail = checkInviteKeyFail;
	exports.createUser = createUser;
	exports.createUserOk = createUserOk;
	exports.createUserFail = createUserFail;
	exports.listContact = listContact;
	exports.listContactOk = listContactOk;
	exports.listContactFail = listContactFail;
	exports.needContact = needContact;
	exports.selectUser = selectUser;
	exports.deleteUser = deleteUser;
	exports.deleteUserOk = deleteUserOk;
	exports.deleteUserFail = deleteUserFail;
	exports.useradSelectNode = useradSelectNode;
	exports.useradSelectType = useradSelectType;
	exports.editUser = editUser;
	exports.editUserOk = editUserOk;
	exports.editUserFail = editUserFail;
	var INVITE_USER = 'INVITE_USER';
	exports.INVITE_USER = INVITE_USER;
	var INVITE_USER_OK = 'INVITE_USER_OK';
	exports.INVITE_USER_OK = INVITE_USER_OK;
	var INVITE_USER_FAIL = 'INVITE_USER_FAIL';
	
	exports.INVITE_USER_FAIL = INVITE_USER_FAIL;
	
	function inviteUser(inv, successCB, failCB) {
	  return {
	    type: INVITE_USER,
	    inv: inv,
	    successCB: successCB,
	    failCB: failCB
	  };
	}
	
	function inviteUserOk(e, successCB) {
	  return {
	    type: INVITE_USER_OK,
	    e: e,
	    successCB: successCB
	  };
	}
	
	function inviteUserFail(e, failCB) {
	  return {
	    type: INVITE_USER_FAIL,
	    e: e,
	    failCB: failCB
	  };
	}
	
	// Reset invitation status text
	var RESET_INVITE_STATUS = "RESET_INVITE_STATUS";
	exports.RESET_INVITE_STATUS = RESET_INVITE_STATUS;
	
	function resetInviteStatus() {
	  return {
	    type: RESET_INVITE_STATUS
	  };
	}
	
	// Check invite key valid or not.
	var CHECK_INVITE_KEY = 'GET_INVITE_KEY';
	exports.CHECK_INVITE_KEY = CHECK_INVITE_KEY;
	var CHECK_INVITE_KEY_OK = 'GET_INVITE_KEY_OK';
	exports.CHECK_INVITE_KEY_OK = CHECK_INVITE_KEY_OK;
	var CHECK_INVITE_KEY_FAIL = 'GET_INVITE_KEY_FAIL';
	
	exports.CHECK_INVITE_KEY_FAIL = CHECK_INVITE_KEY_FAIL;
	
	function checkInviteKey(key) {
	  return {
	    type: CHECK_INVITE_KEY,
	    key: key
	  };
	}
	
	function checkInviteKeyOk(e) {
	  return {
	    type: CHECK_INVITE_KEY_OK,
	    e: e
	  };
	}
	
	function checkInviteKeyFail(e) {
	  return {
	    type: CHECK_INVITE_KEY_FAIL,
	    e: e
	  };
	}
	
	// Create new user
	var CREATE_USER = 'CREATE_USER';
	exports.CREATE_USER = CREATE_USER;
	var CREATE_USER_OK = 'CREATE_USER_OK';
	exports.CREATE_USER_OK = CREATE_USER_OK;
	var CREATE_USER_FAIL = 'CREATE_USER_FAIL';
	
	exports.CREATE_USER_FAIL = CREATE_USER_FAIL;
	
	function createUser(key, user) {
	  return {
	    type: CREATE_USER,
	    user: user,
	    key: key
	  };
	}
	
	function createUserOk(e) {
	  return {
	    type: CREATE_USER_OK,
	    e: e
	  };
	}
	
	function createUserFail(e) {
	  return {
	    type: CREATE_USER_FAIL,
	    e: e
	  };
	}
	
	// List contacts
	var LIST_CONTACT = "LIST_CONTACT";
	exports.LIST_CONTACT = LIST_CONTACT;
	var LIST_CONTACT_OK = "LIST_CONTACT_OK";
	exports.LIST_CONTACT_OK = LIST_CONTACT_OK;
	var LIST_CONTACT_FAIL = "LIST_CONTACT_FAIL";
	
	exports.LIST_CONTACT_FAIL = LIST_CONTACT_FAIL;
	
	function listContact() {
	  return {
	    type: LIST_CONTACT
	  };
	}
	
	function listContactOk(e) {
	  return {
	    type: LIST_CONTACT_OK,
	    e: e
	  };
	}
	
	function listContactFail(e) {
	  return {
	    type: LIST_CONTACT_FAIL,
	    e: e
	  };
	}
	
	// Set contactFetched to false
	var NEED_CONTACT = "NEED_CONTACT";
	exports.NEED_CONTACT = NEED_CONTACT;
	
	function needContact() {
	  return {
	    type: NEED_CONTACT
	  };
	}
	
	// Select a user to delete
	var SELECT_USER = "SELECT_USER";
	
	exports.SELECT_USER = SELECT_USER;
	
	function selectUser(user) {
	  return {
	    type: SELECT_USER,
	    user: user
	  };
	}
	
	var RECEIVE_RESPOND = 'RECEIVE_RESPOND';
	
	exports.RECEIVE_RESPOND = RECEIVE_RESPOND;
	// Delete a user
	var DELETE_USER = 'DELETE_USER';
	exports.DELETE_USER = DELETE_USER;
	var DELETE_USER_OK = 'DELETE_USER_OK';
	exports.DELETE_USER_OK = DELETE_USER_OK;
	var DELETE_USER_FAIL = 'DELETE_USER_FAIL';
	
	exports.DELETE_USER_FAIL = DELETE_USER_FAIL;
	
	function deleteUser(username) {
	  return {
	    type: DELETE_USER,
	    username: username
	  };
	}
	
	function deleteUserOk(e) {
	  return {
	    type: DELETE_USER_OK,
	    e: e
	  };
	}
	
	function deleteUserFail(e) {
	  return {
	    type: DELETE_USER_FAIL,
	    e: e
	  };
	}
	
	// Select node filter
	var USERAD_SELECT_NODE = "USERAD_SELECT_NODE";
	
	exports.USERAD_SELECT_NODE = USERAD_SELECT_NODE;
	
	function useradSelectNode(node) {
	  return {
	    type: USERAD_SELECT_NODE,
	    node: node
	  };
	}
	
	//Select user filter
	var USERAD_SELECT_TYPE = "USERAD_SELECT_TYPE";
	
	exports.USERAD_SELECT_TYPE = USERAD_SELECT_TYPE;
	
	function useradSelectType(code) {
	  return {
	    type: USERAD_SELECT_TYPE,
	    code: code
	  };
	}
	
	// Edit user
	var EDIT_USER = 'EDIT_USER';
	exports.EDIT_USER = EDIT_USER;
	var EDIT_USER_OK = 'EDIT_USER_OK';
	exports.EDIT_USER_OK = EDIT_USER_OK;
	var EDIT_USER_FAIL = 'EDIT_USER_FAIL';
	
	exports.EDIT_USER_FAIL = EDIT_USER_FAIL;
	
	function editUser(username) {
	  return {
	    type: EDIT_USER,
	    username: username
	  };
	}
	
	function editUserOk(e) {
	  return {
	    type: EDIT_USER_OK,
	    e: e
	  };
	}
	
	function editUserFail(e) {
	  return {
	    type: EDIT_USER_FAIL,
	    e: e
	  };
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _actionsUser = __webpack_require__(356);
	
	var a = _interopRequireWildcard(_actionsUser);
	
	var initialState = {
	  stage: "nothing",
	  respond: {}
	};
	
	function inviteUser(inv, successCB, failCB) {
	  return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/invite'), inv).then(function (res) {
	    return a.inviteUserOk(res, successCB);
	  })['catch'](function (error) {
	    return a.inviteUserFail(error, failCB);
	  });
	}
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case a.INVITE_USER:
	      {
	        return (0, _reduxLoop.loop)(Object.assign({}, state, {
	          stage: "inviting",
	          respond: {}
	        }), _reduxLoop.Effects.promise(inviteUser, action.inv, action.successCB, action.failCB));
	      }
	    case a.INVITE_USER_OK:
	      {
	        if (typeof action.successCB == "function") {
	          console.log("Okay1");
	          action.successCB();
	        }
	        return Object.assign({}, state, {
	          stage: "invited",
	          respond: {}
	        });
	      }
	    case a.INVITE_USER_FAIL:
	      {
	        console.log(action);
	        if (typeof action.failCB == "function") {
	          console.log("Okay2");
	          action.failCB();
	        }
	        return Object.assign({}, state, {
	          stage: "invite-failed",
	          respond: action.e
	        });
	      }
	    case a.RESET_INVITE_STATUS:
	      {
	        return Object.assign({}, state, {
	          stage: "nothing",
	          respond: {}
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _actionsUser = __webpack_require__(356);
	
	var a = _interopRequireWildcard(_actionsUser);
	
	var initialState = {
		stage: "nothing",
		invitation: {},
		respond: {}
	};
	
	function checkInviteKey(key) {
		return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/invite/check/' + key)).then(function (res) {
			return a.checkInviteKeyOk(res);
		})['catch'](function (error) {
			return a.checkInviteKeyFail(error);
		});
	}
	function createUser(key, user) {
		return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/create/' + key), user).then(function (res) {
			return a.createUserOk(res);
		})['catch'](function (error) {
			return a.createUserFail(error);
		});
	}
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			// Check invitation key
			case a.CHECK_INVITE_KEY:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {
						stage: "keychecking",
						respond: {}
					}), _reduxLoop.Effects.promise(checkInviteKey, action.key));
				}
			case a.CHECK_INVITE_KEY_OK:
				{
					return Object.assign({}, state, {
						stage: "keychecked",
						invitation: action.e.data,
						respond: action.e
					});
				}
			case a.CHECK_INVITE_KEY_FAIL:
				{
					return Object.assign({}, state, {
						stage: "keycheck-failed",
						respond: action.e
					});
				}
	
			// Create user
			case a.CREATE_USER:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {
						stage: "creating",
						respond: {}
					}), _reduxLoop.Effects.promise(createUser, action.key, action.user));
				}
			case a.CREATE_USER_OK:
				{
					return Object.assign({}, state, {
						stage: "created",
						respond: action.e
					});
				}
			case a.CREATE_USER_FAIL:
				{
					return Object.assign({}, state, {
						stage: "create-failed",
						respond: action.e
					});
				}
			default:
				return state;
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _actionsSensorsettings = __webpack_require__(360);
	
	var a = _interopRequireWildcard(_actionsSensorsettings);
	
	var _actionsNode = __webpack_require__(202);
	
	var aNode = _interopRequireWildcard(_actionsNode);
	
	var initialState = {
		fetched: false,
		nodeFilter: {
			id: -2,
			info: {
				name: "",
				empty: true
			},
			children: [],
			type: null
		},
		sensorStatusFilter: _config2['default'].sensorStatusFilter[0],
		selectedSensor: {},
		Dstage: "nothing", // D = delete (sensor)
		Drespond: {},
	
		Estage: "nothing", // E = edit (sensor)
		Erespond: {}
	};
	
	function editSensor(ss) {
		return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/sensor/update/' + ss.id), ss).then(function (res) {
			return a.editSensorOk(res);
		})['catch'](function (error) {
			return a.editSensorFail(error);
		});
	}
	function deleteSensor(ss) {
		return _axios2['default']['delete']((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/node/delete/' + ss.id)).then(function (res) {
			return a.deleteSensorOk(res);
		})['catch'](function (error) {
			return a.deleteSensorFail(error);
		});
	}
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			// Fetching data
			case aNode.FETCH_LIVE_DATA:
				{
					return Object.assign({}, state, { fetched: false });
				}
			case aNode.RECEIVE_LIVE_DATA:
				{
					return Object.assign({}, state, { fetched: true });
				}
			case aNode.FETCH_FAILED:
			case a.NEED_DATA:
				{
					return Object.assign({}, state, { fetched: false });
				}
			// Filters
			case a.SELECT_NODE_FILTER:
				{
					return Object.assign({}, state, {
						nodeFilter: action.node
					});
				}
			case a.SELECT_SENSOR_STATUS_FILTER:
				{
					return Object.assign({}, state, {
						sensorStatusFilter: action.code
					});
				}
	
			// Pick sensor for edit / delete
			case a.SELECT_SENSOR_BUTTON:
				{
					return Object.assign({}, state, {
						selectedSensor: action.sensor,
						Estage: "nothing",
						Erespond: {},
						Dstage: "nothing",
						Drespond: {}
					});
				}
	
			// Edit
			case a.EDIT_SENSOR:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {
						Estage: "editing",
						Erespond: {}
					}), _reduxLoop.Effects.promise(editSensor, action.sensor));
				}
			case a.EDIT_SENSOR_OK:
				{
					return Object.assign({}, state, {
						Estage: "edited",
						Erespond: {}
					});
				}
			case a.EDIT_SENSOR_FAIL:
				{
					return Object.assign({}, state, {
						Estage: "edit-failed",
						Erespond: action.e
					});
				}
			// Delete
			case a.DELETE_SENSOR:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, {
						Dstage: "deleting",
						Drespond: {}
					}), _reduxLoop.Effects.promise(deleteSensor, action.sensor));
				}
			case a.DELETE_SENSOR_OK:
				{
					return Object.assign({}, state, {
						Dstage: "deleted",
						Drespond: {}
					});
				}
			case a.DELETE_SENSOR_FAIL:
				{
					return Object.assign({}, state, {
						Dstage: "delete-failed",
						Drespond: action.e
					});
				}
	
			default:
				return state;
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	
	
	// Select a node to filter sensors
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectNodeFilter = selectNodeFilter;
	exports.selectSensorStatusFilter = selectSensorStatusFilter;
	exports.selectSensorButton = selectSensorButton;
	exports.editSensor = editSensor;
	exports.editSensorOk = editSensorOk;
	exports.editSensorFail = editSensorFail;
	exports.deleteSensor = deleteSensor;
	exports.deleteSensorOk = deleteSensorOk;
	exports.deleteSensorFail = deleteSensorFail;
	exports.needData = needData;
	var SELECT_NODE_FILTER = "SELECT_NODE_FILTER";
	
	exports.SELECT_NODE_FILTER = SELECT_NODE_FILTER;
	
	function selectNodeFilter(node) {
	  return {
	    type: SELECT_NODE_FILTER,
	    node: node
	  };
	}
	
	// Select a type to filter sensors
	var SELECT_SENSOR_STATUS_FILTER = "SELECT_SENSOR_STATUS_FILTER";
	
	exports.SELECT_SENSOR_STATUS_FILTER = SELECT_SENSOR_STATUS_FILTER;
	
	function selectSensorStatusFilter(code) {
	  return {
	    type: SELECT_SENSOR_STATUS_FILTER,
	    code: code
	  };
	}
	
	// Select a sensor to edit/delete by pressing edit/delete buttons
	var SELECT_SENSOR_BUTTON = "SELECT_SENSOR_BUTTON";
	
	exports.SELECT_SENSOR_BUTTON = SELECT_SENSOR_BUTTON;
	
	function selectSensorButton(sensor) {
	  return {
	    type: SELECT_SENSOR_BUTTON,
	    sensor: sensor
	  };
	}
	
	// Edit sensor
	var EDIT_SENSOR = "EDIT_SENSOR";
	exports.EDIT_SENSOR = EDIT_SENSOR;
	var EDIT_SENSOR_OK = "EDIT_SENSOR_OK";
	exports.EDIT_SENSOR_OK = EDIT_SENSOR_OK;
	var EDIT_SENSOR_FAIL = "EDIT_SENSOR_FAIL";
	exports.EDIT_SENSOR_FAIL = EDIT_SENSOR_FAIL;
	
	function editSensor(sensor) {
	  return {
	    type: EDIT_SENSOR,
	    sensor: sensor
	  };
	}
	
	function editSensorOk(e) {
	  return {
	    type: EDIT_SENSOR_OK,
	    e: e
	  };
	}
	
	function editSensorFail(e) {
	  return {
	    type: EDIT_SENSOR_FAIL,
	    e: e
	  };
	}
	
	// Delete sensor
	var DELETE_SENSOR = "DELETE_SENSOR";
	exports.DELETE_SENSOR = DELETE_SENSOR;
	var DELETE_SENSOR_OK = "DELETE_SENSOR_OK";
	exports.DELETE_SENSOR_OK = DELETE_SENSOR_OK;
	var DELETE_SENSOR_FAIL = "DELETE_SENSOR_FAIL";
	exports.DELETE_SENSOR_FAIL = DELETE_SENSOR_FAIL;
	
	function deleteSensor(sensor) {
	  return {
	    type: DELETE_SENSOR,
	    sensor: sensor
	  };
	}
	
	function deleteSensorOk(e) {
	  return {
	    type: DELETE_SENSOR_OK,
	    e: e
	  };
	}
	
	function deleteSensorFail(e) {
	  return {
	    type: DELETE_SENSOR_FAIL,
	    e: e
	  };
	}
	
	// Set fetched to false
	var NEED_DATA = "NEED_DATA";
	exports.NEED_DATA = NEED_DATA;
	
	function needData() {
	  return {
	    type: NEED_DATA
	  };
	}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actionsDefaultsettings = __webpack_require__(362);
	
	var a = _interopRequireWildcard(_actionsDefaultsettings);
	
	var _actionsOverview = __webpack_require__(200);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var initialState = {
		card: null
	};
	
	function fetchCard() {
		return _axios2['default'].get((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/card')).then(function (response) {
			return a.fetchCardOk(response);
		})['catch'](function (error) {
			console.log(error);
			return a.fetchCardFail(error);
		});
	}
	function updateCard(card) {
		return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/card/update/' + card.id)), card).then(function (response) {
			_toastr2['default'].success("Saved !");
			return a.fetchCard();
		})['catch'](function (error) {
			console.log(error);
			return a.updateCardFail(error);
		});
	}
	function addCard(card) {
		return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/card/create'), card).then(function (response) {
			return a.fetchCard();
		})['catch'](function (error) {
			console.log(error);
			return a.addCardFail(error);
		});
	}
	function addNodeToCard(node, card) {
		var newNode = { info: { cardid: card.id } };
		return _axios2['default'].put((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/node/update/' + node.id)), newNode).then(function (response) {
			return (0, _actionsOverview.fetchCustomerOverview)();
		})['catch'](function (error) {
			console.log(error);
			return a.addNodeToCardFail(error);
		});
	}
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			case a.FETCH_CARD:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(fetchCard));
				}
	
			case a.FETCH_CARD_OK:
				{
					return Object.assign({}, state, {
						loading: false,
						card: action.cardMap
					});
				}
	
			case a.UPDATE_CARD:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(updateCard, action.card));
				}
	
			case a.ADD_CARD:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(addCard, action.card));
				}
	
			case a.DELETE_CARD:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(deleteCard, action.card));
				}
	
			case a.ADD_NODE_TO_CARD:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), _reduxLoop.Effects.promise(addNodeToCard, action.node, action.card));
				}
	
			default:
				{
					return state;
				}
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.fetchCard = fetchCard;
	exports.fetchCardOk = fetchCardOk;
	exports.fetchCardFail = fetchCardFail;
	exports.updateCard = updateCard;
	exports.updateCardOk = updateCardOk;
	exports.updateCardFail = updateCardFail;
	exports.addCard = addCard;
	exports.addCardOk = addCardOk;
	exports.addCardFail = addCardFail;
	exports.deleteCard = deleteCard;
	exports.addNodeToCard = addNodeToCard;
	exports.addNodeToCardOk = addNodeToCardOk;
	exports.addNodeToCardFail = addNodeToCardFail;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _actionsOverview = __webpack_require__(200);
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var FETCH_CARD = "FETCH_CARD";
	exports.FETCH_CARD = FETCH_CARD;
	var FETCH_CARD_OK = "FETCH_CARD_OK";
	exports.FETCH_CARD_OK = FETCH_CARD_OK;
	var FETCH_CARD_FAIL = "FETCH_CARD_FAIL";
	exports.FETCH_CARD_FAIL = FETCH_CARD_FAIL;
	
	function fetchCard() {
	  return {
	    type: FETCH_CARD
	  };
	}
	
	function makeCardMap(data) {
	  var map = {};
	  data.map(function (x) {
	    if (x.isdefault) {
	      map['default'] = x;
	    }
	    map[x.id] = x;
	  });
	  return map;
	}
	
	function fetchCardOk(result) {
	  return {
	    type: FETCH_CARD_OK,
	    cardMap: makeCardMap(result.data)
	  };
	}
	
	function fetchCardFail(result) {
	  return {
	    type: FETCH_CARD_FAIL,
	    e: result
	  };
	}
	
	var UPDATE_CARD = "UPDATE_CARD";
	exports.UPDATE_CARD = UPDATE_CARD;
	var UPDATE_CARD_OK = "UPDATE_CARD_OK";
	exports.UPDATE_CARD_OK = UPDATE_CARD_OK;
	var UPDATE_CARD_FAIL = "UPDATE_CARD_FAIL";
	exports.UPDATE_CARD_FAIL = UPDATE_CARD_FAIL;
	
	function updateCard(card) {
	  return {
	    type: UPDATE_CARD,
	    card: card
	  };
	}
	
	function updateCardOk(result) {
	  return {
	    type: UPDATE_CARD_OK,
	    e: result
	  };
	}
	
	function updateCardFail(result) {
	  return {
	    type: UPDATE_CARD_FAIL,
	    e: result
	  };
	}
	
	var ADD_CARD = "ADD_CARD";
	exports.ADD_CARD = ADD_CARD;
	var ADD_CARD_OK = "ADD_CARD_OK";
	exports.ADD_CARD_OK = ADD_CARD_OK;
	var ADD_CARD_FAIL = "ADD_CARD_FAIL";
	exports.ADD_CARD_FAIL = ADD_CARD_FAIL;
	
	function addCard(card) {
	  return {
	    type: ADD_CARD,
	    card: card
	  };
	}
	
	function addCardOk(result) {
	  return {
	    type: ADD_CARD_OK,
	    e: result
	  };
	}
	
	function addCardFail(result) {
	  return {
	    type: ADD_CARD_FAIL,
	    e: result
	  };
	}
	
	function deleteCard(card) {
	  return function (dispatch) {
	    _axios2['default']['delete']((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + ('/card/delete/' + card.id))).then(function (response) {
	      dispatch((0, _actionsOverview.fetchCustomerOverview)());
	      dispatch(fetchCard());
	      _toastr2['default'].success("Delete successfully !");
	      return response;
	    })['catch'](function (error) {
	      console.log(error);
	      _toastr2['default'].error(error.statusText.data);
	      return error;
	    });
	  };
	}
	
	var ADD_NODE_TO_CARD = "ADD_NODE_TO_CARD";
	exports.ADD_NODE_TO_CARD = ADD_NODE_TO_CARD;
	var ADD_NODE_TO_CARD_OK = "ADD_NODE_TO_CARD_OK";
	exports.ADD_NODE_TO_CARD_OK = ADD_NODE_TO_CARD_OK;
	var ADD_NODE_TO_CARD_FAIL = "ADD_NODE_TO_CARD_FAIL";
	exports.ADD_NODE_TO_CARD_FAIL = ADD_NODE_TO_CARD_FAIL;
	
	function addNodeToCard(node, card) {
	  return {
	    type: ADD_NODE_TO_CARD,
	    node: node,
	    card: card
	  };
	}
	
	function addNodeToCardOk(result) {
	  return {
	    type: ADD_NODE_TO_CARD_OK,
	    e: result
	  };
	}
	
	function addNodeToCardFail(result) {
	  return {
	    type: ADD_NODE_TO_CARD_FAIL,
	    e: result
	  };
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reduxLoop = __webpack_require__(191);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var initialState = {
		apikey: "%YOUR_API_KEY%",
		generated: false,
		wrongPassword: false,
		templates: [],
		urls: [],
		isAddUserSuccess: false,
		isDeleteUserSuccess: false
	};
	
	function generateAPIKey(auth) {
		return _axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/user/apikey'), auth).then(function (response) {
			return a.generateAPIKeyOk(response);
		})['catch'](function (error) {
			console.log(error);
			return a.generateAPIKeyFail(error);
		});
	}
	
	exports['default'] = function (state, action) {
		if (state === undefined) state = initialState;
	
		switch (action.type) {
			case a.GENERATE_API_KEY:
				{
					return (0, _reduxLoop.loop)(Object.assign({}, state), _reduxLoop.Effects.promise(generateAPIKey, action.auth));
				}
	
			case a.GENERATE_API_KEY_OK:
				{
					_toastr2['default'].remove();
					_toastr2['default'].success("API key generated !");
					return Object.assign({}, state, {
						generated: true,
						apikey: action.apikey,
						wrongPassword: false
					});
				}
	
			case a.GENERATE_API_KEY_FAIL:
				{
					_toastr2['default'].remove();
					_toastr2['default'].error("Wrong password !");
					return Object.assign({}, state, {
						wrongPassword: true
					});
				}
	
			case a.CLEAR_API_KEY:
				{
					return Object.assign({}, state, {
						generated: false,
						apikey: "%YOUR_API_KEY%",
						wrongPassword: false
					});
				}
	
			case a.RECEIVE_TEMPLATE:
				{
					return Object.assign({}, state, {
						templates: action.data
					});
				}
	
			case a.RECEIVE_LIVEFEED:
				{
					return Object.assign({}, state, {
						urls: action.data
					});
				}
			case a.ADD_USERS_TO_URL_STATUS:
				{
					return Object.assign({}, state, {
						isAddUserSuccess: action.bool
					});
				}
			case a.REMOVE_USER_FROM_URL_STATUS:
				{
					return Object.assign({}, state, {
						isDeleteUserSuccess: action.bool
					});
				}
	
			default:
				{
					return state;
				}
		}
	};
	
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports.generateAPIKey = generateAPIKey;
	exports.generateAPIKeyOk = generateAPIKeyOk;
	exports.generateAPIKeyFail = generateAPIKeyFail;
	exports.clearAPIKey = clearAPIKey;
	exports.fetchTemplate = fetchTemplate;
	exports.receiveTemplate = receiveTemplate;
	exports.createTemplate = createTemplate;
	exports.updateTemplate = updateTemplate;
	exports.deleteTemplate = deleteTemplate;
	exports.uploadLogo = uploadLogo;
	exports.deleteLogo = deleteLogo;
	exports.fetchLivefeed = fetchLivefeed;
	exports.receiveLivefeed = receiveLivefeed;
	exports.createLivefeed = createLivefeed;
	exports.updateLivefeed = updateLivefeed;
	exports.deleteLivefeed = deleteLivefeed;
	exports.addUsersToURL = addUsersToURL;
	exports.removeUserFromURL = removeUserFromURL;
	exports.previewLivefeed = previewLivefeed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	/*
		API
	*/
	
	var GENERATE_API_KEY = "GENERATE_API_KEY";
	exports.GENERATE_API_KEY = GENERATE_API_KEY;
	
	function generateAPIKey(auth) {
		return {
			type: GENERATE_API_KEY,
			auth: auth
		};
	}
	
	var GENERATE_API_KEY_OK = "GENERATE_API_KEY_OK";
	exports.GENERATE_API_KEY_OK = GENERATE_API_KEY_OK;
	
	function generateAPIKeyOk(result) {
		return {
			type: GENERATE_API_KEY_OK,
			apikey: result.data
		};
	}
	
	var GENERATE_API_KEY_FAIL = "GENERATE_API_KEY_FAIL";
	exports.GENERATE_API_KEY_FAIL = GENERATE_API_KEY_FAIL;
	
	function generateAPIKeyFail(result) {
		return {
			type: GENERATE_API_KEY_FAIL,
			e: result
		};
	}
	
	var CLEAR_API_KEY = "CLEAR_API_KEY";
	exports.CLEAR_API_KEY = CLEAR_API_KEY;
	
	function clearAPIKey() {
		return {
			type: CLEAR_API_KEY
		};
	}
	
	/*
		LIVEFEED
	*/
	
	var FETCH_TEMPLATE = "FETCH_TEMPLATE";
	exports.FETCH_TEMPLATE = FETCH_TEMPLATE;
	
	function fetchTemplate() {
		return function (dispatch) {
			dispatch({ type: FETCH_TEMPLATE });
			return _axios2['default'].get(_config2['default'].api.root + '/livefeed/template').then(function (response) {
				dispatch(receiveTemplate(response.data));
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var RECEIVE_TEMPLATE = "RECEIVE_TEMPLATE";
	exports.RECEIVE_TEMPLATE = RECEIVE_TEMPLATE;
	
	function receiveTemplate(data) {
		return {
			type: RECEIVE_TEMPLATE,
			data: data
		};
	}
	
	var CREATE_TEMPLATE = "CREATE_TEMPLATE";
	exports.CREATE_TEMPLATE = CREATE_TEMPLATE;
	
	function createTemplate(template, fClose) {
		return function (dispatch) {
			dispatch({ type: CREATE_TEMPLATE, template: template });
			console.log("template", template);
			return _axios2['default'].post(_config2['default'].api.root + '/livefeed/template/create', template).then(function (response) {
				_toastr2['default'].success("Template is created successfully !");
				if (typeof fClose == "function") {
					fClose();
				}
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
	exports.UPDATE_TEMPLATE = UPDATE_TEMPLATE;
	
	function updateTemplate(url, fClose) {
		return function (dispatch) {
			dispatch({ type: UPDATE_TEMPLATE, url: url });
			return _axios2['default'].put(_config2['default'].api.root + ('/livefeed/template/update/' + url.key), url).then(function (response) {
				dispatch(fetchTemplate()).then(function () {
					_toastr2['default'].success("Template edited successfully !");
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			})['catch'](function (error) {
				console.log(error);
				var concatMessage = error.statusText.data.concat(' Someone in your team has deleted this template');
				console.log(concatMessage);
	
				_toastr2['default'].error(concatMessage);
				return error;
			});
		};
	}
	
	var DELETE_TEMPLATE = "DELETE_TEMPLATE";
	exports.DELETE_TEMPLATE = DELETE_TEMPLATE;
	
	function deleteTemplate(tplId, fClose) {
		return function (dispatch) {
			dispatch({ type: DELETE_TEMPLATE, tplId: tplId });
			return _axios2['default']['delete'](_config2['default'].api.root + ('/livefeed/template/delete/' + tplId)).then(function (response) {
				dispatch(fetchTemplate()).then(function () {
					_toastr2['default'].success("Template deleted successfully!");
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			})['catch'](function (error) {
				console.log(error);
				var concatMessage = error.statusText.data.concat(' Someone in your team has deleted this template');
				_toastr2['default'].error(concatMessage);
				return error;
			});
		};
	}
	
	var UPLOAD_LOGO = "UPLOAD_LOGO";
	exports.UPLOAD_LOGO = UPLOAD_LOGO;
	
	function uploadLogo(image) {
		return function (dispatch, getState) {
			var _getState$livefeededitor = getState().livefeededitor;
			var livefeedSlides = _getState$livefeededitor.livefeedSlides;
			var slideCurrentIndex = _getState$livefeededitor.slideCurrentIndex;
			var logoState = livefeedSlides.slice()[slideCurrentIndex].logoState;
	
			var formData = new FormData();
			formData.append('logo', image);
			var axiosConfig = {
				headers: { 'Content-Type': 'multipart/form-data' },
				onUploadProgress: function onUploadProgress(e) {
					console.log(e);
				}
			};
			dispatch({ type: UPLOAD_LOGO, image: image });
			_toastr2['default'].info("Logo uploading !");
			return _axios2['default'].put(_config2['default'].api.root + '/livefeed/template/logo', formData, axiosConfig).then(function (response) {
				_toastr2['default'].success("Logo uploaded successfully !");
				// update local state
				var newLogoState = (0, _immutabilityHelper2['default'])(logoState, {
					slideCurrentIndex: { $set: slideCurrentIndex },
					url: { $set: response.data },
					show: { $set: true },
					activeToolbarItems: _defineProperty({}, 1, { deletable: { $set: true } })
				});
				dispatch((0, _actionsLivefeed.updateLogo)(newLogoState));
				for (var i = 0; i < livefeedSlides.length; i++) {
					// Also update logo to other slides if it doesnt have a logo yet
					if (livefeedSlides[i].logoState.url === null) {
						var copyLogo = (0, _immutabilityHelper2['default'])(livefeedSlides[i].logoState, {
							slideCurrentIndex: { $set: i },
							show: { $set: true },
							url: { $set: response.data },
							activeToolbarItems: _defineProperty({}, 1, { deletable: { $set: true } })
						});
						dispatch((0, _actionsLivefeed.setLogo)(copyLogo));
					}
				}
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var DELETE_LOGO = "DELETE_LOGO";
	
	exports.DELETE_LOGO = DELETE_LOGO;
	
	function deleteLogo(logoId, slideCurrentIndex) {
		return function (dispatch) {
			dispatch({ type: DELETE_LOGO });
			return _axios2['default']['delete'](_config2['default'].api.root + ('/livefeed/template/logo/' + logoId)).then(function (response) {
				_toastr2['default'].success("Logo deleted successfully!");
				dispatch((0, _actionsLivefeed.removeLogo)(slideCurrentIndex)); // update local logoState
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var FETCH_LIVEFEED = "FETCH_LIVEFEED";
	exports.FETCH_LIVEFEED = FETCH_LIVEFEED;
	
	function fetchLivefeed() {
		return function (dispatch) {
			dispatch({ type: FETCH_LIVEFEED });
			return _axios2['default'].get(_config2['default'].api.root + '/livefeed').then(function (response) {
				dispatch(receiveLivefeed(response.data));
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var RECEIVE_LIVEFEED = "RECEIVE_LIVEFEED";
	exports.RECEIVE_LIVEFEED = RECEIVE_LIVEFEED;
	
	function receiveLivefeed(data) {
		return {
			type: RECEIVE_LIVEFEED,
			data: data
		};
	}
	
	var CREATE_LIVEFEED = "CREATE_LIVEFEED";
	exports.CREATE_LIVEFEED = CREATE_LIVEFEED;
	
	function createLivefeed(url, emails, fClose) {
		return function (dispatch) {
			dispatch({ type: CREATE_LIVEFEED, url: url, emails: emails });
			return _axios2['default'].post(_config2['default'].api.root + '/livefeed/create', url).then(function (response) {
				console.log("response", response);
				var key = response.data.key;
	
				dispatch(addUsersToURL(key, emails));
	
				_toastr2['default'].success("Livefeed created successfully !");
				if (typeof fClose == "function") {
					fClose();
				}
	
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var UPDATE_LIVEFEED = "UPDATE_LIVEFEED";
	exports.UPDATE_LIVEFEED = UPDATE_LIVEFEED;
	
	function updateLivefeed(url, fClose) {
		return function (dispatch) {
			dispatch({ type: UPDATE_LIVEFEED, url: url });
			return _axios2['default'].put(_config2['default'].api.root + ('/livefeed/update/' + url.key), url).then(function (response) {
	
				dispatch(fetchLivefeed()).then(function () {
					_toastr2['default'].success("Livefeed edited successfully !");
					if (typeof fClose == "function") {
						fClose();
					}
				});
	
				return response;
			})['catch'](function (error) {
				console.log(error);
				var concatMessage = error.statusText.data.concat(' Someone in your team has deleted this livefeed');
				_toastr2['default'].error(concatMessage);
				return error;
			});
		};
	}
	
	var DELETE_LIVEFEED = "DELETE_LIVEFEED";
	exports.DELETE_LIVEFEED = DELETE_LIVEFEED;
	
	function deleteLivefeed(urlkey, fClose) {
		return function (dispatch) {
			dispatch({ type: DELETE_LIVEFEED, urlkey: urlkey });
			return _axios2['default']['delete'](_config2['default'].api.root + ('/livefeed/delete/' + urlkey)).then(function (response) {
				dispatch(fetchLivefeed()).then(function () {
					_toastr2['default'].success("Livefeed deleted successfully!");
					if (typeof fClose == "function") {
						fClose();
					}
				});
	
				return response;
			})['catch'](function (error) {
				console.log(error);
				var concatMessage = error.statusText.data.concat(' Someone in your team has deleted this livefeed');
				_toastr2['default'].error(concatMessage);
				return error;
			});
		};
	}
	
	var ADD_USERS_TO_URL = "ADD_USERS_TO_URL";
	exports.ADD_USERS_TO_URL = ADD_USERS_TO_URL;
	var ADD_USERS_TO_URL_STATUS = "ADD_USERS_TO_URL_STATUS";
	
	exports.ADD_USERS_TO_URL_STATUS = ADD_USERS_TO_URL_STATUS;
	
	function addUsersToURL(key, emails, fClose) {
		return function (dispatch) {
			if (emails.length == 0) {
				return null;
			}
			var email = emails[0];
			dispatch({ type: ADD_USERS_TO_URL, key: key, email: email });
			var userurl = {
				email: email,
				urlkey: key
			};
			var send = function send() {
				if (emails.length > 1) {
					dispatch(addUsersToURL(key, emails.slice(1), fClose));
				} else {
					// reload Livefeed list
					dispatch(fetchLivefeed()).then(function () {
						if (typeof fClose == "function") {
							fClose();
						}
					});
				}
			};
			return _axios2['default'].post(_config2['default'].api.root + '/livefeed/userurl', userurl).then(function (response) {
				_toastr2['default'].success('Sent livefeed invitation to ' + email + ' successfully!');
				dispatch({ type: ADD_USERS_TO_URL_STATUS, bool: true });
				send();
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.data);
				dispatch({ type: ADD_USERS_TO_URL_STATUS, bool: false });
				send();
				return error;
			});
		};
	}
	
	var REMOVE_USER_FROM_URL = "REMOVE_USER_FROM_URL";
	exports.REMOVE_USER_FROM_URL = REMOVE_USER_FROM_URL;
	var REMOVE_USER_FROM_URL_STATUS = "REMOVE_USER_FROM_URL_STATUS";
	exports.REMOVE_USER_FROM_URL_STATUS = REMOVE_USER_FROM_URL_STATUS;
	
	function removeUserFromURL(key, email, fClose) {
		return function (dispatch) {
			dispatch({ type: REMOVE_USER_FROM_URL, key: key, email: email });
			var userurl = {
				email: email,
				urlkey: key
			};
			return _axios2['default']['delete'](_config2['default'].api.root + ('/livefeed/userurl/' + key + '/' + email), userurl).then(function (response) {
				_toastr2['default'].success('Removed ' + email + ' from livefeed users successfully!');
				dispatch({ type: REMOVE_USER_FROM_URL_STATUS, bool: true });
				dispatch(fetchLivefeed()).then(function () {
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			})['catch'](function (error) {
				console.log(error);
				dispatch({ type: REMOVE_USER_FROM_URL_STATUS, bool: false });
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}
	
	var PREVIEW_LIVEFEED = "PREVIEW_LIVEFEED";
	exports.PREVIEW_LIVEFEED = PREVIEW_LIVEFEED;
	
	function previewLivefeed(url) {
		return function (dispatch) {
			dispatch({ type: PREVIEW_LIVEFEED, url: url });
			return _axios2['default'].post(_config2['default'].api.root + ('/livefeed/preview/' + url.key)).then(function (response) {
				console.log(response);
				var previewUrl = _config2['default'].livefeed.root + "/#/url?k=" + url.key + "&apikey=" + response.data.token;
				var win = window.open(previewUrl, '_blank');
				win.focus();
				// console.log(config.livefeed.root + "/#/url?k="+url.key+"&apikey="+response.data.token)
				return response;
			})['catch'](function (error) {
				console.log(error);
				_toastr2['default'].error(error.statusText.data);
				return error;
			});
		};
	}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function stringifiable(obj) {
	    // Safely stringify Object.create(null)
	    /* istanbul ignore next */
	    return typeof obj === 'object' && !('toString' in obj) ?
	        Object.prototype.toString.call(obj).slice(8, -1) :
	        obj;
	}
	var isProduction = typeof process === 'object' && ("production") === 'production';
	function invariant(condition, message) {
	    if (!condition) {
	        /* istanbul ignore next */
	        if (isProduction) {
	            throw new Error('Invariant failed');
	        }
	        throw new Error(message());
	    }
	}
	exports.invariant = invariant;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	var toString = Object.prototype.toString;
	function type(obj) {
	    return toString.call(obj).slice(8, -1);
	}
	var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
	    getAllKeys(source).forEach(function (key) {
	        if (hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	        }
	    });
	    return target;
	});
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
	    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
	    /* istanbul ignore next */
	    : function (obj) { return Object.keys(obj); };
	function copy(object) {
	    return Array.isArray(object)
	        ? assign(object.constructor(object.length), object)
	        : (type(object) === 'Map')
	            ? new Map(object)
	            : (type(object) === 'Set')
	                ? new Set(object)
	                : (object && typeof object === 'object')
	                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
	                    /* istanbul ignore next */
	                    : object;
	}
	var Context = /** @class */ (function () {
	    function Context() {
	        this.commands = assign({}, defaultCommands);
	        this.update = this.update.bind(this);
	        // Deprecated: update.extend, update.isEquals and update.newContext
	        this.update.extend = this.extend = this.extend.bind(this);
	        this.update.isEquals = function (x, y) { return x === y; };
	        this.update.newContext = function () { return new Context().update; };
	    }
	    Object.defineProperty(Context.prototype, "isEquals", {
	        get: function () {
	            return this.update.isEquals;
	        },
	        set: function (value) {
	            this.update.isEquals = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Context.prototype.extend = function (directive, fn) {
	        this.commands[directive] = fn;
	    };
	    Context.prototype.update = function (object, $spec) {
	        var _this = this;
	        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
	        if (!(Array.isArray(object) && Array.isArray(spec))) {
	            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
	                "not contain an array except as the value of $set, $push, $unshift, " +
	                "$splice or any custom command allowing an array value."; });
	        }
	        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
	            "every included key path must be plain objects containing one of the " +
	            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
	        var nextObject = object;
	        getAllKeys(spec).forEach(function (key) {
	            if (hasOwnProperty.call(_this.commands, key)) {
	                var objectWasNextObject = object === nextObject;
	                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
	                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
	                    nextObject = object;
	                }
	            }
	            else {
	                var nextValueForKey = type(object) === 'Map'
	                    ? _this.update(object.get(key), spec[key])
	                    : _this.update(object[key], spec[key]);
	                var nextObjectValue = type(nextObject) === 'Map'
	                    ? nextObject.get(key)
	                    : nextObject[key];
	                if (!_this.isEquals(nextValueForKey, nextObjectValue)
	                    || typeof nextValueForKey === 'undefined'
	                        && !hasOwnProperty.call(object, key)) {
	                    if (nextObject === object) {
	                        nextObject = copy(object);
	                    }
	                    if (type(nextObject) === 'Map') {
	                        nextObject.set(key, nextValueForKey);
	                    }
	                    else {
	                        nextObject[key] = nextValueForKey;
	                    }
	                }
	            }
	        });
	        return nextObject;
	    };
	    return Context;
	}());
	exports.Context = Context;
	var defaultCommands = {
	    $push: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$push');
	        return value.length ? nextObject.concat(value) : nextObject;
	    },
	    $unshift: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$unshift');
	        return value.length ? value.concat(nextObject) : nextObject;
	    },
	    $splice: function (value, nextObject, spec, originalObject) {
	        invariantSplices(nextObject, spec);
	        value.forEach(function (args) {
	            invariantSplice(args);
	            if (nextObject === originalObject && args.length) {
	                nextObject = copy(originalObject);
	            }
	            splice.apply(nextObject, args);
	        });
	        return nextObject;
	    },
	    $set: function (value, _nextObject, spec) {
	        invariantSet(spec);
	        return value;
	    },
	    $toggle: function (targets, nextObject) {
	        invariantSpecArray(targets, '$toggle');
	        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	        targets.forEach(function (target) {
	            nextObjectCopy[target] = !nextObject[target];
	        });
	        return nextObjectCopy;
	    },
	    $unset: function (value, nextObject, _spec, originalObject) {
	        invariantSpecArray(value, '$unset');
	        value.forEach(function (key) {
	            if (Object.hasOwnProperty.call(nextObject, key)) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                delete nextObject[key];
	            }
	        });
	        return nextObject;
	    },
	    $add: function (values, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$add');
	        invariantSpecArray(values, '$add');
	        if (type(nextObject) === 'Map') {
	            values.forEach(function (_a) {
	                var key = _a[0], value = _a[1];
	                if (nextObject === originalObject && nextObject.get(key) !== value) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.set(key, value);
	            });
	        }
	        else {
	            values.forEach(function (value) {
	                if (nextObject === originalObject && !nextObject.has(value)) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.add(value);
	            });
	        }
	        return nextObject;
	    },
	    $remove: function (value, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$remove');
	        invariantSpecArray(value, '$remove');
	        value.forEach(function (key) {
	            if (nextObject === originalObject && nextObject.has(key)) {
	                nextObject = copy(originalObject);
	            }
	            nextObject.delete(key);
	        });
	        return nextObject;
	    },
	    $merge: function (value, nextObject, _spec, originalObject) {
	        invariantMerge(nextObject, value);
	        getAllKeys(value).forEach(function (key) {
	            if (value[key] !== nextObject[key]) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject[key] = value[key];
	            }
	        });
	        return nextObject;
	    },
	    $apply: function (value, original) {
	        invariantApply(value);
	        return value(original);
	    },
	};
	var defaultContext = new Context();
	exports.isEquals = defaultContext.update.isEquals;
	exports.extend = defaultContext.extend;
	exports.default = defaultContext.update;
	// @ts-ignore
	exports.default.default = module.exports = assign(exports.default, exports);
	// invariants
	function invariantPushAndUnshift(value, spec, command) {
	    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
	    invariantSpecArray(spec[command], command);
	}
	function invariantSpecArray(spec, command) {
	    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
	        "Did you forget to wrap your parameter in an array?"; });
	}
	function invariantSplices(value, spec) {
	    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
	    invariantSplice(spec.$splice);
	}
	function invariantSplice(value) {
	    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
	        "Did you forget to wrap your parameters in an array?"; });
	}
	function invariantApply(fn) {
	    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
	}
	function invariantSet(spec) {
	    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
	}
	function invariantMerge(target, specValue) {
	    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
	    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
	}
	function invariantMapOrSet(target, command) {
	    var typeOfTarget = type(target);
	    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.mergeSlidesData = mergeSlidesData;
	exports.mergeLayout = mergeLayout;
	exports.setLivefeedName = setLivefeedName;
	exports.updateColorPickerPos = updateColorPickerPos;
	exports.setEditorView = setEditorView;
	exports.setEditorDefaultState = setEditorDefaultState;
	exports.setFontFamily = setFontFamily;
	exports.setLogo = setLogo;
	exports.removeLogo = removeLogo;
	exports.removeLogoPlaceholder = removeLogoPlaceholder;
	exports.setLine = setLine;
	exports.removeLine = removeLine;
	exports.addText = addText;
	exports.removeText = removeText;
	exports.setText = setText;
	exports.setSlideBg = setSlideBg;
	exports.setLeftPanelBg = setLeftPanelBg;
	exports.setRightPanelBg = setRightPanelBg;
	exports.setGauge = setGauge;
	exports.setLocationsListStyle = setLocationsListStyle;
	exports.setGaugleTitle = setGaugleTitle;
	exports.setGaugeLabel = setGaugeLabel;
	exports.setGaugeOccupiedBg = setGaugeOccupiedBg;
	exports.setGaugeOffsetBg = setGaugeOffsetBg;
	exports.setGaugeNeedleBg = setGaugeNeedleBg;
	exports.updateEmptyEntity = updateEmptyEntity;
	exports.updateFontFamily = updateFontFamily;
	exports.updateEntityFont = updateEntityFont;
	exports.updateSlideBg = updateSlideBg;
	exports.updateLeftPanelBg = updateLeftPanelBg;
	exports.updateRightPanelBg = updateRightPanelBg;
	exports.updateLogo = updateLogo;
	exports.addTextBox = addTextBox;
	exports.updateLine = updateLine;
	exports.updateText = updateText;
	exports.updateGauge = updateGauge;
	exports.updateLocationsListStyle = updateLocationsListStyle;
	exports.updateGaugleTitle = updateGaugleTitle;
	exports.updateGaugeLabel = updateGaugeLabel;
	exports.updateGaugeOccupiedBg = updateGaugeOccupiedBg;
	exports.updateGaugeOffsetBg = updateGaugeOffsetBg;
	exports.updateGaugeNeedleBg = updateGaugeNeedleBg;
	exports.removeEntity = removeEntity;
	exports.addEntity = addEntity;
	exports.alignEntity = alignEntity;
	exports.colorisingEntity = colorisingEntity;
	exports.stylingText = stylingText;
	exports.alignGaugeCards = alignGaugeCards;
	exports.textboxAlignRespond = textboxAlignRespond;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedDefaultstate2 = _interopRequireDefault(_componentsPagesLivefeedDefaultstate);
	
	var _historyActions = __webpack_require__(368);
	
	var _livefeedapi = __webpack_require__(364);
	
	//  Merge data from API
	var MERGE_SLIDES_DATA = 'MERGE_SLIDES_DATA';
	exports.MERGE_SLIDES_DATA = MERGE_SLIDES_DATA;
	
	function mergeSlidesData(data) {
	    return function (dispatch) {
	        dispatch({
	            type: MERGE_SLIDES_DATA,
	            data: data
	        });
	    };
	}
	
	var MERGE_LAYOUT = 'MERGE_LAYOUT';
	exports.MERGE_LAYOUT = MERGE_LAYOUT;
	
	function mergeLayout(slideCurrentIndex, payload) {
	    return {
	        type: MERGE_LAYOUT,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SET_LIVEFEED_NAME = 'SET_LIVEFEED_NAME';
	exports.SET_LIVEFEED_NAME = SET_LIVEFEED_NAME;
	
	function setLivefeedName(livefeedName) {
	    return {
	        type: SET_LIVEFEED_NAME,
	        livefeedName: livefeedName
	    };
	}
	
	var UPDATE_COLOR_PICKER_POS = 'UPDATE_COLOR_PICKER_POS';
	exports.UPDATE_COLOR_PICKER_POS = UPDATE_COLOR_PICKER_POS;
	
	function updateColorPickerPos(pos) {
	    return {
	        type: UPDATE_COLOR_PICKER_POS,
	        pos: pos
	    };
	}
	
	var SET_EDITOR_VIEW = 'SET_EDITOR_VIEW';
	exports.SET_EDITOR_VIEW = SET_EDITOR_VIEW;
	
	function setEditorView(boolean) {
	    return {
	        type: SET_EDITOR_VIEW,
	        boolean: boolean
	    };
	}
	
	// called this function when create new livefeed
	var DEFAULT_STATE = 'DEFAULT_STATE';
	exports.DEFAULT_STATE = DEFAULT_STATE;
	
	function setEditorDefaultState() {
	    return {
	        type: DEFAULT_STATE
	    };
	}
	
	// ------------------------------------Livefeed and Toolbar editor  set function
	var SET_FONT_FAMILY = 'SET_FONT_FAMILY';
	exports.SET_FONT_FAMILY = SET_FONT_FAMILY;
	
	function setFontFamily(slideCurrentIndex, font) {
	    return {
	        type: SET_FONT_FAMILY,
	        slideCurrentIndex: slideCurrentIndex,
	        font: font
	    };
	}
	
	//Logo CRUD
	var SET_LOGO = 'SET_LOGO';
	exports.SET_LOGO = SET_LOGO;
	
	function setLogo(payload) {
	    return {
	        type: SET_LOGO,
	        payload: payload
	    };
	}
	
	var REMOVE_LOGO = 'REMOVE_LOGO';
	exports.REMOVE_LOGO = REMOVE_LOGO;
	
	function removeLogo(slideCurrentIndex) {
	    return {
	        type: REMOVE_LOGO,
	        slideCurrentIndex: slideCurrentIndex
	    };
	}
	
	var REMOVE_LOGO_PLACEHOLDER = 'REMOVE_LOGO_PLACEHOLDER';
	exports.REMOVE_LOGO_PLACEHOLDER = REMOVE_LOGO_PLACEHOLDER;
	
	function removeLogoPlaceholder(slideCurrentIndex) {
	    return {
	        type: REMOVE_LOGO_PLACEHOLDER,
	        slideCurrentIndex: slideCurrentIndex
	    };
	}
	
	// Line CRUD
	var SET_LINE = 'SET_LINE';
	exports.SET_LINE = SET_LINE;
	
	function setLine(payload) {
	    return {
	        type: SET_LINE,
	        payload: payload
	    };
	}
	
	var REMOVE_LINE = 'REMOVE_LINE';
	exports.REMOVE_LINE = REMOVE_LINE;
	
	function removeLine(slideCurrentIndex) {
	    return {
	        type: REMOVE_LINE,
	        slideCurrentIndex: slideCurrentIndex
	    };
	}
	
	// Text CRUD
	var ADD_TEXT = 'ADD_TEXT';
	exports.ADD_TEXT = ADD_TEXT;
	
	function addText(payload) {
	    return {
	        type: ADD_TEXT,
	        payload: payload
	    };
	}
	
	var REMOVE_TEXT = 'REMOVE_TEXT';
	exports.REMOVE_TEXT = REMOVE_TEXT;
	
	function removeText(payload) {
	    return {
	        type: REMOVE_TEXT,
	        payload: payload
	    };
	}
	
	var SET_TEXT = 'SET_TEXT';
	exports.SET_TEXT = SET_TEXT;
	
	function setText(payload) {
	    return {
	        type: SET_TEXT,
	        payload: payload
	    };
	}
	
	// Set Background color
	var SET_SLIDE_BG = 'SET_SLIDE_BG';
	exports.SET_SLIDE_BG = SET_SLIDE_BG;
	
	function setSlideBg(payload) {
	    return {
	        type: SET_SLIDE_BG,
	        payload: payload
	    };
	}
	
	var SET_LEFT_PANEL_BG = 'SET_LEFT_PANEL_BG';
	exports.SET_LEFT_PANEL_BG = SET_LEFT_PANEL_BG;
	
	function setLeftPanelBg(payload) {
	    return {
	        type: SET_LEFT_PANEL_BG,
	        payload: payload
	    };
	}
	
	var SET_RIGHT_PANEL_BG = 'SET_RIGHT_PANEL_BG';
	exports.SET_RIGHT_PANEL_BG = SET_RIGHT_PANEL_BG;
	
	function setRightPanelBg(payload) {
	    return {
	        type: SET_RIGHT_PANEL_BG,
	        payload: payload
	    };
	}
	
	// gauge
	var SET_GAUGE = 'SET_GAUGE';
	exports.SET_GAUGE = SET_GAUGE;
	
	function setGauge(payload) {
	    return {
	        type: SET_GAUGE,
	        payload: payload
	    };
	}
	
	// Locations List Style
	var SET_LOCATIONS_LIST_STYLE = 'SET_LOCATIONS_LIST_STYLE';
	exports.SET_LOCATIONS_LIST_STYLE = SET_LOCATIONS_LIST_STYLE;
	
	function setLocationsListStyle(payload) {
	    return {
	        type: SET_LOCATIONS_LIST_STYLE,
	        payload: payload
	    };
	}
	
	//Right Panel Text title
	var SET_GAUGE_TITLE = 'SET_GAUGE_TITLE';
	exports.SET_GAUGE_TITLE = SET_GAUGE_TITLE;
	
	function setGaugleTitle(payload) {
	    return {
	        type: SET_GAUGE_TITLE,
	        payload: payload
	    };
	}
	
	// Gauge Value Label
	var SET_GAUGE_LABEL = 'SET_GAUGE_LABEL';
	exports.SET_GAUGE_LABEL = SET_GAUGE_LABEL;
	
	function setGaugeLabel(payload) {
	    return {
	        type: SET_GAUGE_LABEL,
	        payload: payload
	    };
	}
	
	// Gauge Occupied Background color
	var SET_GAUGE_OCCUPIED_BG = 'SET_GAUGE_OCCUPIED_BG';
	exports.SET_GAUGE_OCCUPIED_BG = SET_GAUGE_OCCUPIED_BG;
	
	function setGaugeOccupiedBg(payload) {
	    return {
	        type: SET_GAUGE_OCCUPIED_BG,
	        payload: payload
	    };
	}
	
	// Gauge Offset Background color
	var SET_GAUGE_OFFSET_BG = 'SET_GAUGE_OFFSET_BG';
	exports.SET_GAUGE_OFFSET_BG = SET_GAUGE_OFFSET_BG;
	
	function setGaugeOffsetBg(payload) {
	    return {
	        type: SET_GAUGE_OFFSET_BG,
	        payload: payload
	    };
	}
	
	// Gauge Needle Background color
	var SET_GAUGE_NEEDLE_BG = 'SET_GAUGE_NEEDLE_BG';
	exports.SET_GAUGE_NEEDLE_BG = SET_GAUGE_NEEDLE_BG;
	
	function setGaugeNeedleBg(payload) {
	    return {
	        type: SET_GAUGE_NEEDLE_BG,
	        payload: payload
	    };
	}
	
	//---------------------------------------------------------thunk action creators switch (Wrapper function ) ----------------------------------------------
	
	/* Update Function ( function start with updateXYZ word will be handled by handleOverwriteHistory
	    On the other hand, function call updateXYZ also will be handled )
	*/
	
	function updateEmptyEntity() {
	    return (0, _historyActions.handleOverwriteHistory)(updateEmptyEntity, _historyActions.setEmptyEntity, false, false);
	}
	
	function updateFontFamily(font) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	
	        dispatch(setFontFamily(slideCurrentIndex, font));
	        var entityFont = {
	            slideCurrentIndex: slideCurrentIndex,
	            id: null,
	            fontFamily: font
	        };
	        dispatch(updateEntityFont(entityFont));
	    };
	}
	
	function updateEntityFont(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateEntityFont, _historyActions.setEntityFont, entity, false);
	}
	
	function updateSlideBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateSlideBg, setSlideBg, entity, false);
	}
	
	function updateLeftPanelBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateLeftPanelBg, setLeftPanelBg, entity, false);
	}
	
	function updateRightPanelBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateRightPanelBg, setRightPanelBg, entity, false);
	}
	
	function updateLogo(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateLogo, setLogo, entity, false);
	}
	
	function addTextBox(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(addTextBox, addText, entity, false);
	}
	
	function updateLine(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateLine, setLine, entity, false);
	}
	
	function updateText(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateText, setText, entity, false);
	}
	
	function updateGauge(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGauge, setGauge, entity, false);
	}
	
	function updateLocationsListStyle(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateLocationsListStyle, setLocationsListStyle, entity, false);
	}
	
	function updateGaugleTitle(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGaugleTitle, setGaugleTitle, entity, false);
	}
	
	function updateGaugeLabel(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGaugeLabel, setGaugeLabel, entity, false);
	}
	
	function updateGaugeOccupiedBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGaugeOccupiedBg, setGaugeOccupiedBg, entity, false);
	}
	
	function updateGaugeOffsetBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGaugeOffsetBg, setGaugeOffsetBg, entity, false);
	}
	
	function updateGaugeNeedleBg(entity) {
	    return (0, _historyActions.handleOverwriteHistory)(updateGaugeNeedleBg, setGaugeNeedleBg, entity, false);
	}
	
	//------------------------------- toolbar action switch ------------------------------
	
	function removeEntity(id) {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor = getState().livefeededitor;
	        var slideCurrentIndex = _getState$livefeededitor.slideCurrentIndex;
	        var livefeedSlides = _getState$livefeededitor.livefeedSlides;
	
	        switch (id) {
	            case "logo":
	                {
	                    var logoState = livefeedSlides.slice()[slideCurrentIndex].logoState;
	
	                    // remove logo or logoplaceholder
	                    if (logoState.url !== null) {
	                        // Call deleteLogo to delete logo from database
	                        // dispatch(a.deleteLogo(logoId, slideCurrentIndex))
	                        var logoId = logoState.url.split('/').pop();
	                        console.log("logoId", logoId);
	                        dispatch(removeLogo(slideCurrentIndex));
	                        dispatch(removeLogoPlaceholder(slideCurrentIndex));
	                    } else {
	                        console.log("remove logo placeholder");
	                        dispatch(removeLogoPlaceholder(slideCurrentIndex));
	                    }
	                }
	                break;
	            case "line":
	                dispatch(removeLine(slideCurrentIndex));
	                break;
	        }
	        var slidePayload = { slideCurrentIndex: slideCurrentIndex, id: id };
	        typeof id == 'number' && dispatch(removeText(slidePayload)); // if entity is an obj in textContainer arr
	        dispatch(updateEmptyEntity());
	    };
	}
	
	function addEntity(e, type) {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor2 = getState().livefeededitor;
	        var slideCurrentIndex = _getState$livefeededitor2.slideCurrentIndex;
	        var livefeedSlides = _getState$livefeededitor2.livefeedSlides;
	        ;
	        var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	        var fontFamily = _livefeedSlides$slideCurrentIndex.fontFamily;
	        var textContainer = _livefeedSlides$slideCurrentIndex.textContainer;
	
	        switch (type) {
	            case "line":
	                {
	                    var defaultLine = (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].lineState, {
	                        slideCurrentIndex: { $set: slideCurrentIndex }
	                    });
	                    dispatch(updateLine(defaultLine));
	                }
	                break;
	            case "logo":
	                {
	                    var defaultLogoPlaceholder = (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].logoState, {
	                        slideCurrentIndex: { $set: slideCurrentIndex }
	                    });
	                    dispatch(updateLogo(defaultLogoPlaceholder));
	                    var reader = new FileReader();
	                    var file = e.target.files[0];
	                    reader.onloadend = function () {
	                        dispatch((0, _livefeedapi.uploadLogo)(file));
	                    };
	                    file && reader.readAsDataURL(file);
	                }
	                break;
	            case "textObj":
	                {
	                    // default
	                    var newTextObj = (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].textContainer[0], {
	                        slideCurrentIndex: { $set: slideCurrentIndex },
	                        fontFamily: { $set: fontFamily }
	                    });
	
	                    // if textContainer>0 copy first textObj
	                    if (textContainer.length > 0) {
	                        newTextObj = (0, _immutabilityHelper2['default'])(textContainer[0], {
	                            slideCurrentIndex: { $set: slideCurrentIndex },
	                            align: { $set: "left" },
	                            width: { $set: 83 },
	                            content: { $set: 'Text box' },
	                            left: { $set: 33 },
	                            size: { $set: 20 },
	                            top: { $set: 55 },
	                            show: { $set: true },
	                            activeToolbarItems: _defineProperty({}, 0, {
	                                align: { $set: "left" }
	                            })
	                        });
	                    }
	                    dispatch(addTextBox(newTextObj));
	                }
	                break;
	            default:
	        }
	    };
	}
	
	function alignEntity(entityId, mode) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var _getState$livefeededitor$livefeedSlides$slice$slideCurrentIndex = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
	        var slideType = _getState$livefeededitor$livefeedSlides$slice$slideCurrentIndex.slideType;
	        var historyEntities = _getState$livefeededitor$livefeedSlides$slice$slideCurrentIndex.historyEntities;
	
	        var history = historyEntities.slice();
	        var currentEntity = history[history.length - 1];
	        var livefeedAlignCenter = undefined;
	        if (slideType === "summary" || slideType === "locationsList") {
	            livefeedAlignCenter = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryCenter;
	        } else {
	            livefeedAlignCenter = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.center;
	        }
	        var livefeedAlignRight = undefined;
	        if (slideType === "summary" || slideType === "locationsList") {
	            livefeedAlignRight = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryRight;
	        } else {
	            livefeedAlignRight = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.right;
	        }
	        var newLeft = undefined; // little hack when using react-rnd
	        if (mode === "center") {
	            newLeft = currentEntity.id === "line" ? livefeedAlignCenter - currentEntity.length / 2 : livefeedAlignCenter - currentEntity.width / 2;
	        } else if (mode === "right") {
	            newLeft = currentEntity.id === "line" ? livefeedAlignRight - currentEntity.length : livefeedAlignRight - currentEntity.width;
	        } else if (mode === "left") {
	            newLeft = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.left;
	        }
	        var newState = (0, _immutabilityHelper2['default'])(currentEntity, {
	            left: { $set: newLeft },
	            align: { $set: mode },
	            activeToolbarItems: _defineProperty({}, 0, { align: { $set: mode } })
	        });
	        switch (entityId) {
	            case "logo":
	                dispatch(updateLogo(newState));
	                break;
	            case "line":
	                dispatch(updateLine(newState));
	                break;
	            case "gauge0":
	                dispatch(updateGauge(newState));
	                break;
	            case "gauge1":
	                dispatch(updateGauge(newState));
	                break;
	            case "gauge2":
	                dispatch(updateGauge(newState));
	                break;
	            case "rightPanelTextTitle":
	                dispatch(updateGaugleTitle(newState));
	                break;
	            case "rightPanelGaugeValueLabel":
	                dispatch(updateGaugeLabel(newState));
	                break;
	            case "locationsListStyle":
	                dispatch(updateLocationsListStyle(newState));
	                break;
	        }
	        if (typeof entityId == 'number') {
	            if (mode === "right" || mode === "center") {
	                newState.left = newState.left + 10; // padding issue
	            }
	            dispatch(updateText(newState)); // if entity is an obj in textContainer arr
	        }
	    };
	}
	
	function colorisingEntity(entityId, value) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var historyEntities = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].historyEntities;
	
	        var history = historyEntities.slice();
	        var currentEntity = history[history.length - 1];
	        var newState = (0, _immutabilityHelper2['default'])(currentEntity, {
	            color: { $set: value }
	        });
	        switch (entityId) {
	            case "line":
	                dispatch(updateLine(newState));
	                break;
	            case "slideBg":
	                dispatch(updateSlideBg(newState));
	                break;
	            case "leftPanelBg":
	                dispatch(updateLeftPanelBg(newState));
	                break;
	            case "rightPanelBg":
	                dispatch(updateRightPanelBg(newState));
	                break;
	            case "rightPanelTextTitle":
	                dispatch(updateGaugleTitle(newState));
	                break;
	            case "rightPanelGaugeValueLabel":
	                dispatch(updateGaugeLabel(newState));
	                break;
	            case "rightPanelGaugeOccupiedBg":
	                dispatch(updateGaugeOccupiedBg(newState));
	                break;
	            case "rightPanelGaugeOffsetdBg":
	                dispatch(updateGaugeOffsetBg(newState));
	                break;
	            case "rightPanelGaugeNeedle":
	                dispatch(updateGaugeNeedleBg(newState));
	                break;
	            case "locationsListStyle":
	                dispatch(updateLocationsListStyle(newState));
	                break;
	        }
	        typeof entityId == 'number' && dispatch(updateText(newState)); // if entity is an obj in textContainer arr
	    };
	}
	
	function stylingText(textStyle) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var historyEntities = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].historyEntities;
	
	        var history = historyEntities.slice();
	        var currentEntity = history[history.length - 1];
	        var newState = (0, _immutabilityHelper2['default'])(currentEntity, {
	            textStyle: { $merge: textStyle },
	            activeToolbarItems: _defineProperty({}, 2, { $merge: textStyle })
	        });
	        switch (currentEntity.id) {
	            case "rightPanelTextTitle":
	                dispatch(updateGaugleTitle(newState));
	                break;
	            case "rightPanelGaugeValueLabel":
	                dispatch(updateGaugeLabel(newState));
	                break;
	            case "locationsListStyle":
	                dispatch(updateLocationsListStyle(newState));
	                break;
	            default:
	                dispatch(updateText(newState));
	        }
	    };
	}
	
	function alignGaugeCards(type, sumPageIndex) {
	    return function (dispatch, getState) {
	        var livefeedSlides = getState().livefeededitor.livefeedSlides;
	        var _livefeedSlides$sumPageIndex = livefeedSlides[sumPageIndex];
	        var gauge0 = _livefeedSlides$sumPageIndex.gauge0;
	        var gauge1 = _livefeedSlides$sumPageIndex.gauge1;
	        var gauge2 = _livefeedSlides$sumPageIndex.gauge2;
	
	        switch (type) {
	            case "all":
	                {
	                    var newGauge0 = (0, _immutabilityHelper2['default'])(gauge0, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.left }
	                    });
	                    var newGauge1 = (0, _immutabilityHelper2['default'])(gauge1, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge1.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge1.left }
	                    });
	                    var newGauge2 = (0, _immutabilityHelper2['default'])(gauge2, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge2.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge2.left }
	                    });
	                    dispatch(setGauge(newGauge0));
	                    dispatch(setGauge(newGauge1));
	                    dispatch(setGauge(newGauge2));
	                }
	                break;
	            case "mr":
	                {
	                    var newGauge0 = (0, _immutabilityHelper2['default'])(gauge0, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.left + gauge0.width / 1.5 }
	                    });
	                    var newGauge2 = (0, _immutabilityHelper2['default'])(gauge2, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge2.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge2.left - gauge2.width / 1.5 }
	                    });
	                    dispatch(setGauge(newGauge0));
	                    dispatch(setGauge(newGauge2));
	                }
	                break;
	            case "oa":
	                {
	                    var newGauge0 = (0, _immutabilityHelper2['default'])(gauge0, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge0.left + gauge0.width / 1.5 }
	                    });
	                    var newGauge1 = (0, _immutabilityHelper2['default'])(gauge1, {
	                        top: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge1.top },
	                        left: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].gauge1.left + gauge1.width / 1.5 }
	                    });
	                    dispatch(setGauge(newGauge0));
	                    dispatch(setGauge(newGauge1));
	                }
	        }
	    };
	}
	
	// for Textbox only
	
	function textboxAlignRespond(entity, newWidth) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var slideType = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].slideType;
	
	        var livefeedAlignCenter = slideType === "summary" ? _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryCenter : _componentsPagesLivefeedDefaultstate.livefeedStyle.align.center;
	        var livefeedAlignRight = slideType === "summary" ? _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryRight : _componentsPagesLivefeedDefaultstate.livefeedStyle.align.right;
	        var newLeft = undefined; // little hack when using react-rnd
	        switch (entity.align) {
	            case "center":
	                newLeft = livefeedAlignCenter - (newWidth - 20) / 2; // padding issue
	                break;
	            case "right":
	                newLeft = livefeedAlignRight - newWidth + 10; // padding issue
	                break;
	            case "left":
	                newLeft = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.left;
	                break;
	        }
	        var newState = (0, _immutabilityHelper2['default'])(entity, {
	            width: { $set: newWidth },
	            left: { $set: newLeft !== undefined ? newLeft : entity.left }
	        });
	        dispatch(setText(newState));
	    };
	}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ratio = 16 / 9;
	var containerWidth = 800;
	var containerHeight = containerWidth * 1 / ratio;
	
	var leftPaneWidth = 75;
	var rightPaneWidth = 25;
	
	var floorplanWidth = containerWidth * leftPaneWidth / 100 - 33 * 2; // 534
	
	// ----------------------------------------------------------------------------------------------------------
	var livefeedStyle = {
	    ratio: ratio,
	    containerWidth: containerWidth,
	    containerHeight: containerHeight,
	    leftPaneWidth: leftPaneWidth,
	    rightPaneWidth: rightPaneWidth,
	    floorplanWidth: floorplanWidth,
	    floorplanStyle: {
	        // FLOORPLAN PREVIEW (Used for snapping)
	        // Convert 80px to 33px from 1920x1080 to 800x450
	        // All are converted into top-left coordinates
	        // For styling floorplan
	        top: containerHeight * 0.28 + "px",
	        bottom: "33px",
	        left: "33px",
	        right: "33px"
	    },
	    // Entity style, use for aligning
	    align: {
	        top: containerHeight * 0.28,
	        bottom: containerHeight - 33,
	        left: 33,
	        right: containerWidth * leftPaneWidth / 100 - 33,
	        center: 33 + (containerWidth * leftPaneWidth / 100 - 33 * 2) / 2,
	        summaryCenter: 33 + (containerWidth * (leftPaneWidth + rightPaneWidth) / 100 - 33 * 2) / 2,
	        summaryRight: containerWidth * (leftPaneWidth + rightPaneWidth) / 100 - 33
	    }
	};
	exports.livefeedStyle = livefeedStyle;
	// ----------------------------------------------------------------------------------------------------------
	var defaultEditorState = {
	    colorPickerPos: { x: 0, y: 0 },
	    mapConfigMode: "user_input",
	    slideCurrentIndex: 0, // editor slide changes handle
	    editorView: true, // editor view handle
	    stepNumberState: 0, // use for manipulate redo undo
	    // below property will be received from backend || or send to backend
	    containerWidth: containerWidth, // use for display livefeed with correct ratio
	    containerHeight: containerHeight, // use for display livefeed with correct ratio
	    livefeedName: "Livefeed Name",
	    livefeedSlides: [{
	        slideType: 'summary',
	        floorplanOptions: {
	            locationsID: [],
	            duration: 5,
	            widgetLabelType: true, //false means display one value only 50, if true, 50/100
	            sensorFilterType: "occupied-unOccupied", // occupied or occupied-unOccupied,
	            isStandbyAsUnOccupied: false // treat standby sensors as UnOccupied sensor
	        },
	        historyEntities: [{ id: null }],
	        fontFamily: "GTWalsheimProRegular",
	        logoState: {
	            slideCurrentIndex: 0,
	            id: "logo",
	            width: 125,
	            top: 15,
	            left: 33,
	            align: "left",
	            url: null,
	            show: true,
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        lineState: {
	            id: "line",
	            slideCurrentIndex: 0,
	            show: true,
	            color: "#4a4a4a",
	            thickness: 2,
	            length: 734,
	            top: 42,
	            left: 33,
	            align: "left",
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        textContainer: [{
	            slideCurrentIndex: 0,
	            align: "left",
	            width: 83,
	            height: 36,
	            color: "#4a4a4a",
	            content: "Text box",
	            left: 33,
	            size: 20,
	            top: 55,
	            show: true,
	            textStyle: {},
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
	        }],
	        slideBg: {
	            slideCurrentIndex: 0,
	            id: "slideBg",
	            color: "#ffffff",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        }, // only on summary page
	        gauge0: {
	            slideCurrentIndex: 0,
	            id: "gauge0",
	            width: 190,
	            top: 160,
	            left: 33,
	            label: "Available Desks",
	            align: "left",
	            activeToolbarItems: [{ align: "left" }, { deletable: false }, { isText: false }]
	        }, // only on summary page
	        gauge1: {
	            slideCurrentIndex: 0,
	            id: "gauge1",
	            width: 190,
	            top: 160,
	            left: 305,
	            label: "Available Open Area Rooms",
	            align: "center",
	            activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: false }]
	        }, // only on summary page
	        gauge2: {
	            slideCurrentIndex: 0,
	            id: "gauge2",
	            width: 190,
	            top: 160,
	            left: 577,
	            label: "Available Meeting Rooms",
	            align: "right",
	            activeToolbarItems: [{ align: "right" }, { deletable: false }, { isText: false }]
	        }, // only on summary page
	        rightPanelTextTitle: {
	            id: "rightPanelTextTitle",
	            slideCurrentIndex: 0,
	            size: 17,
	            contents: ["Available desks", "Available meeting rooms"],
	            align: "center",
	            color: "#000000",
	            textStyle: {},
	            activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
	        },
	        rightPanelGaugeValueLabel: {
	            id: "rightPanelGaugeValueLabel",
	            slideCurrentIndex: 0,
	            size: 28,
	            align: "center",
	            color: "#000000",
	            textStyle: {},
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
	        },
	        rightPanelGaugeOccupiedBg: {
	            id: "rightPanelGaugeOccupiedBg",
	            slideCurrentIndex: 0,
	            color: "#3cb449",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelGaugeOffsetdBg: {
	            id: "rightPanelGaugeOffsetdBg",
	            slideCurrentIndex: 0,
	            color: "#EEEEEE",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelGaugeNeedle: {
	            id: "rightPanelGaugeNeedle",
	            slideCurrentIndex: 0,
	            color: "#EEEEEE",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        }
	    }, {
	        slideType: 'locationsList',
	        floorplanOptions: {
	            duration: 5
	        },
	        historyEntities: [{ id: null }],
	        fontFamily: "GTWalsheimProRegular",
	        logoState: {
	            slideCurrentIndex: 1,
	            id: "logo",
	            width: 125,
	            top: 15,
	            left: 33,
	            align: "left",
	            url: null,
	            show: true,
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        lineState: {
	            id: "line",
	            slideCurrentIndex: 1,
	            show: true,
	            color: "#4a4a4a",
	            thickness: 2,
	            length: 734,
	            top: 42,
	            left: 33,
	            align: "left",
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        textContainer: [{
	            slideCurrentIndex: 1,
	            align: "left",
	            width: 303,
	            height: 36,
	            color: "#4a4a4a",
	            content: "Locations chosen on this livefeed",
	            left: 33,
	            size: 20,
	            top: 55,
	            show: true,
	            textStyle: {},
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
	        }],
	        slideBg: {
	            slideCurrentIndex: 1,
	            id: "slideBg",
	            color: "#ffffff",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        locationsListStyle: {
	            slideCurrentIndex: 1,
	            id: "locationsListStyle",
	            color: "#000000",
	            left: 33,
	            size: 22,
	            width: 734,
	            top: 100,
	            locationCol: 4,
	            textStyle: {},
	            activeToolbarItems: [{ align: "left" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
	        }
	    }, {
	        slideType: 'slideshow',
	        floorplanOptions: {
	            locationsID: [],
	            duration: 5,
	            lockScroll: false,
	            widgetLabelType: true, //false means display one value only 50, if true, 50/100
	            sensorFilterType: "occupied-unOccupied", // occupied or occupied-unOccupied,
	            isStandbyAsUnOccupied: false, // treat standby sensors as UnOccupied sensor,
	            liveApiKey: "",
	            mapApiKey: "",
	            mapConfig: {
	                container: 'mapboxMap',
	                center: [0, 0], // [24.8123896, 60.2209478],
	                zoom: 0,
	                bearing: 0,
	                pitch: 0,
	                hash: false,
	                attributionControl: false,
	                bearingSnap: 0,
	                aniDuration: 2,
	                use3dMap: true,
	                animationType: { value: "flyTo", label: "flyTo" }
	            }
	        },
	        historyEntities: [{ id: null }],
	        fontFamily: "GTWalsheimProRegular",
	        logoState: {
	            slideCurrentIndex: 2,
	            id: "logo",
	            width: 125,
	            top: 15,
	            left: 33,
	            align: "left",
	            url: null,
	            show: true,
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        lineState: {
	            id: "line",
	            slideCurrentIndex: 2,
	            show: true,
	            color: "#4a4a4a",
	            thickness: 2,
	            length: livefeedStyle.floorplanWidth,
	            top: 42,
	            left: 33,
	            align: "left",
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
	        },
	        textContainer: [{
	            slideCurrentIndex: 2,
	            align: "left",
	            width: 83,
	            height: 36,
	            color: "#4a4a4a",
	            content: "Text box",
	            left: 33,
	            size: 20,
	            top: 55,
	            show: true,
	            textStyle: {},
	            activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
	        }],
	        leftPanelBg: {
	            slideCurrentIndex: 2,
	            id: "leftPanelBg",
	            color: "#ffffff",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelBg: {
	            slideCurrentIndex: 2,
	            id: "rightPanelBg",
	            color: "#3f5043",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelTextTitle: {
	            id: "rightPanelTextTitle",
	            slideCurrentIndex: 2,
	            size: 17,
	            contents: ["Available desks", "Available meeting rooms"],
	            align: "center",
	            color: "#ffffff",
	            textStyle: {},
	            activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
	        },
	        rightPanelGaugeValueLabel: {
	            id: "rightPanelGaugeValueLabel",
	            slideCurrentIndex: 2,
	            size: 28,
	            align: "center",
	            color: "#ffffff",
	            textStyle: {},
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
	        },
	        rightPanelGaugeOccupiedBg: {
	            id: "rightPanelGaugeOccupiedBg",
	            slideCurrentIndex: 2,
	            color: "#3cb449",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelGaugeOffsetdBg: {
	            id: "rightPanelGaugeOffsetdBg",
	            slideCurrentIndex: 2,
	            color: "#EEEEEE",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        },
	        rightPanelGaugeNeedle: {
	            id: "rightPanelGaugeNeedle",
	            slideCurrentIndex: 2,
	            color: "#EEEEEE",
	            activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
	        }
	    }]
	};
	exports["default"] = defaultEditorState;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.setEntity = setEntity;
	exports.setEntityFont = setEntityFont;
	exports.emptyEntity = emptyEntity;
	exports.setStepNumberState = setStepNumberState;
	exports.clearHistory = clearHistory;
	exports.overWriteHistory = overWriteHistory;
	exports.setCurrentEntity = setCurrentEntity;
	exports.setEmptyEntity = setEmptyEntity;
	exports.updateCurrentEntity = updateCurrentEntity;
	exports.handleClearHistory = handleClearHistory;
	exports.handleOverwriteHistory = handleOverwriteHistory;
	exports.changeHistory = changeHistory;
	exports.updateEntityState = updateEntityState;
	
	var _index = __webpack_require__(366);
	
	// ------------------------------------History handle set function
	var SET_ENTITY = 'SET_ENTITY';
	exports.SET_ENTITY = SET_ENTITY;
	
	function setEntity(entity) {
	    return {
	        type: SET_ENTITY,
	        entity: entity
	    };
	}
	
	var SET_ENTITY_FONT = 'SET_ENTITY_FONT';
	exports.SET_ENTITY_FONT = SET_ENTITY_FONT;
	
	function setEntityFont(entity) {
	    return {
	        type: SET_ENTITY_FONT,
	        entity: entity
	    };
	}
	
	var EMPTY_ENTITY = 'EMPTY_ENTITY';
	exports.EMPTY_ENTITY = EMPTY_ENTITY;
	
	function emptyEntity(slideCurrentIndex, entity) {
	    return {
	        type: EMPTY_ENTITY,
	        slideCurrentIndex: slideCurrentIndex,
	        entity: entity
	    };
	}
	
	var SET_STEP_NUMBER_STATE = 'SET_STEP_NUMBER_STATE';
	exports.SET_STEP_NUMBER_STATE = SET_STEP_NUMBER_STATE;
	
	function setStepNumberState(step) {
	    return {
	        type: SET_STEP_NUMBER_STATE,
	        step: step
	    };
	}
	
	var CLEAR_HISTORY = 'CLEAR_HISTORY';
	exports.CLEAR_HISTORY = CLEAR_HISTORY;
	
	function clearHistory(slideCurrentIndex, payload) {
	    return {
	        type: CLEAR_HISTORY,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var OVERWRITE_HISTORY = 'OVERWRITE_HISTORY';
	exports.OVERWRITE_HISTORY = OVERWRITE_HISTORY;
	
	function overWriteHistory(slideCurrentIndex, payload) {
	    return {
	        type: OVERWRITE_HISTORY,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	// ------------------------------------History handle set function
	
	function setCurrentEntity(entity) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var historyEntities = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].historyEntities;
	
	        entity.slideCurrentIndex = slideCurrentIndex;
	        dispatch(setEntity(entity));
	        dispatch(setStepNumberState(historyEntities.length));
	    };
	}
	
	function setEmptyEntity() {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor = getState().livefeededitor;
	        var slideCurrentIndex = _getState$livefeededitor.slideCurrentIndex;
	        var livefeedSlides = _getState$livefeededitor.livefeedSlides;
	        var _livefeedSlides$slice$slideCurrentIndex = livefeedSlides.slice()[slideCurrentIndex];
	        var historyEntities = _livefeedSlides$slice$slideCurrentIndex.historyEntities;
	        var fontFamily = _livefeedSlides$slice$slideCurrentIndex.fontFamily;
	
	        var entity = {
	            id: null,
	            fontFamily: fontFamily
	        };
	        dispatch(emptyEntity(slideCurrentIndex, entity));
	        dispatch(setStepNumberState(historyEntities.length));
	    };
	}
	
	function updateCurrentEntity(entity) {
	    return handleOverwriteHistory(updateCurrentEntity, setCurrentEntity, entity, true);
	}
	
	function handleClearHistory(slideCurrentIndex) {
	    return function (dispatch, getState) {
	        var livefeedSlides = getState().livefeededitor.livefeedSlides;
	        var fontFamily = livefeedSlides.slice()[slideCurrentIndex].fontFamily;
	
	        var payload = [{
	            id: null,
	            fontFamily: fontFamily
	        }];
	        dispatch(clearHistory(slideCurrentIndex, payload));
	    };
	}
	
	//----------------------- Handle OverWrite History --------------------------
	
	function handleOverwriteHistory(recursionFn, callbackSetFn, entity, isSetCurrentEntity) {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor2 = getState().livefeededitor;
	        var slideCurrentIndex = _getState$livefeededitor2.slideCurrentIndex;
	        var stepNumberState = _getState$livefeededitor2.stepNumberState;
	        var historyEntities = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].historyEntities;
	
	        var history = historyEntities.slice(0);
	        // If current stepNumberState < historyEntities last index, activate overWriteHistory
	        if (stepNumberState < history.length - 1) {
	            dispatch(overWriteHistory(slideCurrentIndex, history.slice(0, stepNumberState + 1)));
	            entity !== false ? dispatch(recursionFn(entity)) : dispatch(recursionFn());
	        } else {
	            // no enity means callbackSetFn is updateEmptyEntity
	            if (entity !== false) {
	                dispatch(callbackSetFn(entity));
	                // check if is updateCurrentEntity which already have setCurrentEntity
	                if (!isSetCurrentEntity) {
	                    // payload.id = null mean that is an entityFont hence no need to setCurrentEntity but need to setStepNumberState
	                    entity.id !== null ? dispatch(setCurrentEntity(entity)) : dispatch(setStepNumberState(historyEntities.length));
	                }
	            } else {
	                dispatch(callbackSetFn());
	            }
	        }
	    };
	}
	
	// undo/redo handle here
	
	function changeHistory(step) {
	    return function (dispatch) {
	        dispatch(setStepNumberState(step));
	        dispatch(updateEntityState(step));
	    };
	}
	
	// call this function when change history of move
	
	function updateEntityState(step) {
	    return function (dispatch, getState) {
	        var slideCurrentIndex = getState().livefeededitor.slideCurrentIndex;
	        var historyEntities = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex].historyEntities;
	
	        var history = historyEntities.slice(0, step + 1);
	        var currentEntity = history[step];
	        switch (currentEntity.id) {
	            case "logo":
	                dispatch((0, _index.setLogo)(currentEntity));
	                break;
	            case "line":
	                dispatch((0, _index.setLine)(currentEntity));
	                break;
	            case null:
	                {
	                    var font = currentEntity.fontFamily === undefined ? "GTWalsheimProRegular" : currentEntity.fontFamily;
	                    dispatch((0, _index.setFontFamily)(slideCurrentIndex, font));
	                }
	                break;
	            case "locationsListStyle":
	                dispatch((0, _index.setLocationsListStyle)(currentEntity));
	                break;
	            case "leftPanelBg":
	                dispatch((0, _index.setLeftPanelBg)(currentEntity));
	                break;
	            case "rightPanelBg":
	                dispatch((0, _index.setRightPanelBg)(currentEntity));
	                break;
	            case "gauge0":
	                dispatch((0, _index.setGauge)(currentEntity));
	                break;
	            case "gauge1":
	                dispatch((0, _index.setGauge)(currentEntity));
	                break;
	            case "gauge2":
	                dispatch((0, _index.setGauge)(currentEntity));
	                break;
	            case "rightPanelTextTitle":
	                dispatch((0, _index.setGaugleTitle)(currentEntity));
	                break;
	            case "rightPanelGaugeValueLabel":
	                dispatch((0, _index.setGaugeLabel)(currentEntity));
	                break;
	            case "rightPanelGaugeOccupiedBg":
	                dispatch((0, _index.setGaugeOccupiedBg)(currentEntity));
	                break;
	            case "rightPanelGaugeOffsetdBg":
	                dispatch((0, _index.setGaugeOffsetBg)(currentEntity));
	                break;
	            case "rightPanelGaugeNeedle":
	                dispatch((0, _index.setGaugeNeedleBg)(currentEntity));
	                break;
	
	        }
	        typeof currentEntity.id == 'number' && dispatch((0, _index.setText)(currentEntity)); // if entity is an obj in textContainer arr
	    };
	}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reduceReducers = __webpack_require__(370);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedDefaultstate2 = _interopRequireDefault(_componentsPagesLivefeedDefaultstate);
	
	var _slideCrudReducer = __webpack_require__(371);
	
	var _slideCrudReducer2 = _interopRequireDefault(_slideCrudReducer);
	
	var _editorReducer = __webpack_require__(373);
	
	var _editorReducer2 = _interopRequireDefault(_editorReducer);
	
	var _steerpathMapReducer = __webpack_require__(374);
	
	var _steerpathMapReducer2 = _interopRequireDefault(_steerpathMapReducer);
	
	var _livefeedOptionsReducer = __webpack_require__(376);
	
	var _livefeedOptionsReducer2 = _interopRequireDefault(_livefeedOptionsReducer);
	
	var _historyReducer = __webpack_require__(378);
	
	var _historyReducer2 = _interopRequireDefault(_historyReducer);
	
	var initialState = _componentsPagesLivefeedDefaultstate2['default'];
	
	var livefeededitor = (0, _reduceReducers2['default'])(initialState, _editorReducer2['default'], _slideCrudReducer2['default'], _steerpathMapReducer2['default'], _livefeedOptionsReducer2['default'], _historyReducer2['default']);
	exports['default'] = livefeededitor;
	module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var initialState = typeof args[0] !== 'function' && args.shift();
	  var reducers = args;
	
	  if (typeof initialState === 'undefined') {
	    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
	  }
	
	  return function (prevState, value) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var prevStateIsUndefined = typeof prevState === 'undefined';
	    var valueIsUndefined = typeof value === 'undefined';
	
	    if (prevStateIsUndefined && valueIsUndefined && initialState) {
	      return initialState;
	    }
	
	    return reducers.reduce(function (newState, reducer, index) {
	      if (typeof reducer === 'undefined') {
	        throw new TypeError('An undefined reducer was passed in at index ' + index);
	      }
	
	      return reducer.apply(undefined, [newState, value].concat(args));
	    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _actionsLivefeedSlideCrudActions = __webpack_require__(372);
	
	var slideCrudActions = _interopRequireWildcard(_actionsLivefeedSlideCrudActions);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedDefaultstate2 = _interopRequireDefault(_componentsPagesLivefeedDefaultstate);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var initialState = _componentsPagesLivefeedDefaultstate2['default'];
	
	exports['default'] = function (state, action) {
	    if (state === undefined) state = initialState;
	
	    switch (action.type) {
	        // ------------------------------------slide state update
	        case slideCrudActions.GO_TO_SLIDE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    slideCurrentIndex: { $set: action.index }
	                });
	            }
	        case slideCrudActions.ADD_SLIDE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: { $push: [action.objectSlide] }
	                });
	            }
	        case slideCrudActions.ADD_SUM_SLIDE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: { $unshift: [action.objectSlide] }
	                });
	            }
	        case slideCrudActions.REMOVE_SLIDE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: { $splice: [[action.slideIndex, 1]] }
	                });
	            }
	        case slideCrudActions.SORT_SLIDE_ORDER:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: { $set: action.newOrder }
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.goToSlide = goToSlide;
	exports.addSlide = addSlide;
	exports.addSumSlide = addSumSlide;
	exports.removeSlide = removeSlide;
	exports.sortSlide = sortSlide;
	exports.setNewSlideOrder = setNewSlideOrder;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var GO_TO_SLIDE = 'GO_TO_SLIDE';
	exports.GO_TO_SLIDE = GO_TO_SLIDE;
	
	function goToSlide(index) {
	    return {
	        type: GO_TO_SLIDE,
	        index: index
	    };
	}
	
	var ADD_SLIDE = 'ADD_SLIDE';
	exports.ADD_SLIDE = ADD_SLIDE;
	
	function addSlide(objectSlide) {
	    return {
	        type: ADD_SLIDE,
	        objectSlide: objectSlide
	    };
	}
	
	var ADD_SUM_SLIDE = 'ADD_SUM_SLIDE';
	exports.ADD_SUM_SLIDE = ADD_SUM_SLIDE;
	
	function addSumSlide(objectSlide) {
	    return {
	        type: ADD_SUM_SLIDE,
	        objectSlide: objectSlide
	    };
	}
	
	var REMOVE_SLIDE = 'REMOVE_SLIDE';
	exports.REMOVE_SLIDE = REMOVE_SLIDE;
	
	function removeSlide(slideIndex) {
	    return {
	        type: REMOVE_SLIDE,
	        slideIndex: slideIndex
	    };
	}
	
	var SORT_SLIDE_ORDER = 'SORT_SLIDE_ORDER';
	exports.SORT_SLIDE_ORDER = SORT_SLIDE_ORDER;
	
	function sortSlide(newOrder) {
	    return {
	        type: SORT_SLIDE_ORDER,
	        newOrder: newOrder
	    };
	}
	
	// ------------------------------------slide function
	
	function setNewSlideOrder(payload) {
	    return function (dispatch) {
	        var emptyHistory = [{ id: null, fontFamily: payload[0].fontFamily }]; // get fontFamily of summary slide
	        var newArrWithEmptyHistory = payload;
	        for (var i = 0; i < payload.length; i++) {
	            newArrWithEmptyHistory = (0, _immutabilityHelper2['default'])(newArrWithEmptyHistory, _defineProperty({}, i, {
	                historyEntities: {
	                    $set: emptyHistory
	                }
	            }));
	        }
	        dispatch((0, _actionsLivefeedHistoryActions.setStepNumberState)(0));
	        dispatch(sortSlide(newArrWithEmptyHistory));
	    };
	}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var a = _interopRequireWildcard(_actionsLivefeed);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedDefaultstate2 = _interopRequireDefault(_componentsPagesLivefeedDefaultstate);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	exports['default'] = function (state, action) {
	    switch (action.type) {
	        //Merge data
	        case a.MERGE_SLIDES_DATA:
	            {
	                return (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'], {
	                    $merge: action.data
	                });
	            }
	        case a.MERGE_LAYOUT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { $merge: action.payload })
	                });
	            }
	        // -------------------------- livefeed state update
	        case a.SET_LIVEFEED_NAME:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedName: { $set: action.livefeedName }
	                });
	            }
	        case a.UPDATE_COLOR_PICKER_POS:
	            {
	                return _extends({}, state, {
	                    colorPickerPos: action.pos
	                });
	            }
	        case a.SET_EDITOR_VIEW:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    editorView: { $set: action.boolean }
	                });
	            }
	        case a.DEFAULT_STATE:
	            {
	                return _componentsPagesLivefeedDefaultstate2['default'];
	            }
	        // ------------------------------------Livefeed and Toolbar editor state update
	        // Font
	        case a.SET_FONT_FAMILY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { fontFamily: { $set: action.font } })
	                });
	            }
	        // Logo
	        case a.SET_LOGO:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { logoState: { $set: action.payload } })
	                });
	            }
	        case a.REMOVE_LOGO:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { logoState: { $set: _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].logoState } })
	                });
	            }
	        case a.REMOVE_LOGO_PLACEHOLDER:
	            {
	                var _activeToolbarItems;
	
	                var hideLogoPlaceholder = (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].logoState, {
	                    show: { $set: false },
	                    activeToolbarItems: (_activeToolbarItems = {}, _defineProperty(_activeToolbarItems, 0, { align: { $set: "" } }), _defineProperty(_activeToolbarItems, 1, { deletable: { $set: false } }), _activeToolbarItems)
	                });
	
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { logoState: { $set: hideLogoPlaceholder } })
	                });
	            }
	        // Line
	        case a.SET_LINE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { lineState: { $set: action.payload } })
	                });
	            }
	        case a.REMOVE_LINE:
	            {
	                var _activeToolbarItems2;
	
	                var hideLine = (0, _immutabilityHelper2['default'])(_componentsPagesLivefeedDefaultstate2['default'].livefeedSlides[0].lineState, {
	                    show: { $set: false },
	                    activeToolbarItems: (_activeToolbarItems2 = {}, _defineProperty(_activeToolbarItems2, 0, { align: { $set: "" } }), _defineProperty(_activeToolbarItems2, 1, { deletable: { $set: false } }), _activeToolbarItems2)
	                });
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { lineState: { $set: hideLine } })
	                });
	            }
	        // Text
	        case a.ADD_TEXT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { textContainer: { $push: [action.payload] } })
	                });
	            }
	        case a.REMOVE_TEXT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { textContainer: { $splice: [[action.payload.id, 1]] } }) // payload is an index number
	                });
	            }
	        case a.SET_TEXT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { textContainer: _defineProperty({}, action.payload.id, { $set: action.payload }) }) // payload is an index number
	                });
	            }
	        // Set Background color
	        case a.SET_SLIDE_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { slideBg: { $set: action.payload } })
	                });
	            }
	        case a.SET_LEFT_PANEL_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { leftPanelBg: { $set: action.payload } })
	                });
	            }
	        case a.SET_RIGHT_PANEL_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelBg: { $set: action.payload } })
	                });
	            }
	        // gauge
	        case a.SET_GAUGE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, _defineProperty({}, action.payload.id, { $set: action.payload }))
	                });
	            }
	        // Locations List Style
	        case a.SET_LOCATIONS_LIST_STYLE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { locationsListStyle: { $set: action.payload } })
	                });
	            }
	        //Right Panel Text title
	        case a.SET_GAUGE_TITLE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelTextTitle: { $set: action.payload } })
	                });
	            }
	        //Right Panel Gauge Value Label
	        case a.SET_GAUGE_LABEL:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelGaugeValueLabel: { $set: action.payload } })
	                });
	            }
	        //Right Panel Gauge Occupied Background color
	        case a.SET_GAUGE_OCCUPIED_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelGaugeOccupiedBg: { $set: action.payload } })
	                });
	            }
	        //Right Panel Gauge Offset Background color
	        case a.SET_GAUGE_OFFSET_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelGaugeOffsetdBg: { $set: action.payload } })
	                });
	            }
	        //Right Panel Gauge Needle Background color
	        case a.SET_GAUGE_NEEDLE_BG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.payload.slideCurrentIndex, { rightPanelGaugeNeedle: { $set: action.payload } })
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	var a = _interopRequireWildcard(_actionsLivefeedSteerpathMapActions);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	exports['default'] = function (state, action) {
	    switch (action.type) {
	        //Map
	        case a.SET_MAP_CONFIG_MODE:
	            {
	                return _extends({}, state, {
	                    mapConfigMode: action.mapConfigMode
	                });
	            }
	        case a.SET_MAP_API_KEY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, {
	                        floorplanOptions: {
	                            mapApiKey: { $set: action.mapApiKey }
	                        }
	                    })
	                });
	            }
	        case a.SET_LIVE_API_KEY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, {
	                        floorplanOptions: {
	                            liveApiKey: { $set: action.liveApiKey }
	                        }
	                    })
	                });
	            }
	        case a.SET_MAP_CONFIG:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, {
	                        floorplanOptions: {
	                            mapConfig: { $set: action.config }
	                        }
	                    })
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.setMapConfigMode = setMapConfigMode;
	exports.setMapApiKey = setMapApiKey;
	exports.setLiveApiKey = setLiveApiKey;
	exports.setMapConfig = setMapConfig;
	var SET_MAP_CONFIG_MODE = 'SET_MAP_CONFIG_MODE';
	exports.SET_MAP_CONFIG_MODE = SET_MAP_CONFIG_MODE;
	
	function setMapConfigMode(mapConfigMode) {
	    return {
	        type: SET_MAP_CONFIG_MODE,
	        mapConfigMode: mapConfigMode
	    };
	}
	
	var SET_MAP_API_KEY = 'SET_MAP_API_KEY';
	exports.SET_MAP_API_KEY = SET_MAP_API_KEY;
	
	function setMapApiKey(slideCurrentIndex, mapApiKey) {
	    return {
	        type: SET_MAP_API_KEY,
	        slideCurrentIndex: slideCurrentIndex,
	        mapApiKey: mapApiKey
	    };
	}
	
	var SET_LIVE_API_KEY = 'SET_LIVE_API_KEY';
	exports.SET_LIVE_API_KEY = SET_LIVE_API_KEY;
	
	function setLiveApiKey(slideCurrentIndex, liveApiKey) {
	    return {
	        type: SET_LIVE_API_KEY,
	        slideCurrentIndex: slideCurrentIndex,
	        liveApiKey: liveApiKey
	    };
	}
	
	var SET_MAP_CONFIG = 'SET_MAP_CONFIG';
	exports.SET_MAP_CONFIG = SET_MAP_CONFIG;
	
	function setMapConfig(slideCurrentIndex, config) {
	    return {
	        type: SET_MAP_CONFIG,
	        slideCurrentIndex: slideCurrentIndex,
	        config: config
	    };
	}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsLivefeedLivefeedOptions = __webpack_require__(377);
	
	var a = _interopRequireWildcard(_actionsLivefeedLivefeedOptions);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	exports['default'] = function (state, action) {
	    switch (action.type) {
	        // ------------------------------------Livefeed option state update
	        case a.SET_LOCATIONS:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { locationsID: { $set: action.payload } } })
	                });
	            }
	        case a.SET_DURATION:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { duration: { $set: action.payload } } })
	                });
	            }
	        case a.SET_LOCK_SCROLL:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { lockScroll: { $set: action.payload } } })
	                });
	            }
	        case a.SET_WIDGET_LABEL_TYPE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { widgetLabelType: { $set: action.payload } } })
	                });
	            }
	        case a.SENSOR_FILTER_TYPE:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { sensorFilterType: { $set: action.payload } } })
	                });
	            }
	        case a.SET_STANDBY_SENSOR_TREATMENT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { floorplanOptions: { isStandbyAsUnOccupied: { $set: action.payload } } })
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.setLocations = setLocations;
	exports.setDuration = setDuration;
	exports.setLockScroll = setLockScroll;
	exports.setWidgetLabelType = setWidgetLabelType;
	exports.setSensorFilterType = setSensorFilterType;
	exports.setStandbySensorTreatment = setStandbySensorTreatment;
	exports.setLivefeedGlobalOptions = setLivefeedGlobalOptions;
	exports.setLivefeedOptions = setLivefeedOptions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _steerpathMapActions = __webpack_require__(375);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	//---------------------------------------------------------action creators ----------------------------------------------
	var SET_LOCATIONS = 'SET_LOCATIONS';
	exports.SET_LOCATIONS = SET_LOCATIONS;
	
	function setLocations(slideCurrentIndex, payload) {
	    return {
	        type: SET_LOCATIONS,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SET_DURATION = 'SET_DURATION';
	exports.SET_DURATION = SET_DURATION;
	
	function setDuration(slideCurrentIndex, payload) {
	    return {
	        type: SET_DURATION,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SET_LOCK_SCROLL = 'SET_LOCK_SCROLL';
	exports.SET_LOCK_SCROLL = SET_LOCK_SCROLL;
	
	function setLockScroll(slideCurrentIndex, payload) {
	    return {
	        type: SET_LOCK_SCROLL,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SET_WIDGET_LABEL_TYPE = 'SET_WIDGET_LABEL_TYPE';
	exports.SET_WIDGET_LABEL_TYPE = SET_WIDGET_LABEL_TYPE;
	
	function setWidgetLabelType(slideCurrentIndex, payload) {
	    return {
	        type: SET_WIDGET_LABEL_TYPE,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SENSOR_FILTER_TYPE = 'SENSOR_FILTER_TYPE';
	exports.SENSOR_FILTER_TYPE = SENSOR_FILTER_TYPE;
	
	function setSensorFilterType(slideCurrentIndex, payload) {
	    return {
	        type: SENSOR_FILTER_TYPE,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	var SET_STANDBY_SENSOR_TREATMENT = 'SET_STANDBY_SENSOR_TREATMENT';
	exports.SET_STANDBY_SENSOR_TREATMENT = SET_STANDBY_SENSOR_TREATMENT;
	
	function setStandbySensorTreatment(slideCurrentIndex, payload) {
	    return {
	        type: SET_STANDBY_SENSOR_TREATMENT,
	        slideCurrentIndex: slideCurrentIndex,
	        payload: payload
	    };
	}
	
	//---------------------------------------------------------thunk action creators switch (Wrapper function ) ----------------------------------------------
	
	function setLivefeedGlobalOptions(type, payload) {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor = getState().livefeededitor;
	        var livefeedSlides = _getState$livefeededitor.livefeedSlides;
	        var slideCurrentIndex = _getState$livefeededitor.slideCurrentIndex;
	        var _livefeedSlides$slideCurrentIndex$floorplanOptions = livefeedSlides[slideCurrentIndex].floorplanOptions;
	        var liveApiKey = _livefeedSlides$slideCurrentIndex$floorplanOptions.liveApiKey;
	        var mapApiKey = _livefeedSlides$slideCurrentIndex$floorplanOptions.mapApiKey;
	
	        var length = livefeedSlides.length;
	        switch (type) {
	            case "globalSlideDuration":
	                for (var i = 0; i < length; i++) {
	                    if (i !== slideCurrentIndex) {
	                        dispatch(setDuration(i, payload));
	                    }
	                }
	                break;
	            case "globalLockScroll":
	                for (var i = 0; i < length; i++) {
	                    if (livefeedSlides[i].slideType !== "summary" && livefeedSlides[i].slideType !== "locationsList") {
	                        if (i !== slideCurrentIndex) {
	                            dispatch(setLockScroll(i, payload));
	                        }
	                    }
	                }
	                break;
	            case "globalWidget":
	                for (var i = 0; i < length; i++) {
	                    if (livefeedSlides[i].slideType !== "locationsList") {
	                        if (i !== slideCurrentIndex) {
	                            dispatch(setWidgetLabelType(i, payload));
	                        }
	                    }
	                }
	                break;
	            case "globalSensorFilter":
	                for (var i = 0; i < length; i++) {
	                    if (livefeedSlides[i].slideType !== "locationsList") {
	                        if (i !== slideCurrentIndex) {
	                            dispatch(setSensorFilterType(i, payload.sensorFilterType));
	                            dispatch(setStandbySensorTreatment(i, payload.isStandbyAsUnOccupied));
	                        }
	                    }
	                }
	                break;
	            case "globalMapConfig":
	                for (var i = 0; i < length; i++) {
	                    if (i !== slideCurrentIndex) {
	                        dispatch((0, _steerpathMapActions.setMapConfig)(i, payload));
	                        dispatch((0, _steerpathMapActions.setMapApiKey)(i, mapApiKey));
	                        dispatch((0, _steerpathMapActions.setLiveApiKey)(i, liveApiKey));
	                    }
	                }
	                break;
	
	        }
	    };
	}
	
	function setLivefeedOptions(type, payload) {
	    return function (dispatch, getState) {
	        var _getState$livefeededitor2 = getState().livefeededitor;
	        var slideCurrentIndex = _getState$livefeededitor2.slideCurrentIndex;
	        var livefeedSlides = _getState$livefeededitor2.livefeedSlides;
	        var mapConfig = livefeedSlides[slideCurrentIndex].floorplanOptions.mapConfig;
	
	        switch (type) {
	            case "summaryLocations":
	                {
	                    for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	                        dispatch(setLocations(i, payload));
	                    }
	                }
	                break;
	            case "slideshowLocations":
	                dispatch(setLocations(slideCurrentIndex, payload));
	                break;
	            case "slideDuration":
	                dispatch(setDuration(slideCurrentIndex, payload));
	                break;
	            case "lockscroll":
	                dispatch(setLockScroll(slideCurrentIndex, payload));
	                break;
	            case "widgetLabelType":
	                dispatch(setWidgetLabelType(slideCurrentIndex, payload));
	                break;
	            case "sensorFilterType":
	                dispatch(setSensorFilterType(slideCurrentIndex, payload));
	                break;
	            case "treatStandbySensor":
	                dispatch(setStandbySensorTreatment(slideCurrentIndex, payload));
	                break;
	            case "mapApiKey":
	                dispatch((0, _steerpathMapActions.setMapApiKey)(slideCurrentIndex, payload));
	                break;
	            case "liveApiKey":
	                dispatch((0, _steerpathMapActions.setLiveApiKey)(slideCurrentIndex, payload));
	                break;
	            case "mapConfig":
	                {
	                    var newMapConfig = (0, _immutabilityHelper2['default'])(mapConfig, { $merge: payload });
	                    dispatch((0, _steerpathMapActions.setMapConfig)(slideCurrentIndex, newMapConfig));
	                }
	        }
	    };
	}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var a = _interopRequireWildcard(_actionsLivefeedHistoryActions);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	exports['default'] = function (state, action) {
	    switch (action.type) {
	        // ------------------------------------History state update
	        case a.SET_ENTITY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.entity.slideCurrentIndex, { historyEntities: { $push: [action.entity] } })
	                });
	            }
	        case a.SET_ENTITY_FONT:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.entity.slideCurrentIndex, { historyEntities: { $push: [action.entity] } })
	                });
	            }
	        case a.EMPTY_ENTITY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { historyEntities: { $push: [action.entity] } })
	                });
	            }
	        case a.SET_STEP_NUMBER_STATE:
	            {
	                return _extends({}, state, {
	                    stepNumberState: action.step
	                });
	            }
	        case a.CLEAR_HISTORY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { historyEntities: { $set: action.payload } })
	                });
	            }
	        case a.OVERWRITE_HISTORY:
	            {
	                return (0, _immutabilityHelper2['default'])(state, {
	                    livefeedSlides: _defineProperty({}, action.slideCurrentIndex, { historyEntities: { $set: action.payload } })
	                });
	            }
	        default:
	            {
	                return state;
	            }
	    }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(380);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/src/index.js!../../node_modules/less-loader/index.js!./main.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/src/index.js!../../node_modules/less-loader/index.js!./main.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	exports.i(__webpack_require__(382), "");
	exports.i(__webpack_require__(383), "");
	exports.i(__webpack_require__(389), "");
	exports.i(__webpack_require__(390), "");
	exports.i(__webpack_require__(391), "");
	exports.i(__webpack_require__(392), "");
	
	// module
	exports.push([module.id, "@font-face{font-family:GTWalsheimProBold;src:url(" + __webpack_require__(398) + "),url(" + __webpack_require__(399) + ") format(\"woff\"),url(" + __webpack_require__(400) + ") format(\"truetype\");font-weight:700;font-style:normal;font-stretch:normal}@font-face{font-family:GTWalsheimProRegular;src:url(" + __webpack_require__(401) + "),url(" + __webpack_require__(402) + ") format(\"woff\"),url(" + __webpack_require__(403) + ") format(\"truetype\");font-weight:400;font-style:normal;font-stretch:normal}@font-face{font-family:GTWalsheimProLight;src:url(" + __webpack_require__(404) + "),url(" + __webpack_require__(405) + ") format(\"woff\"),url(" + __webpack_require__(406) + ") format(\"truetype\");font-weight:400;font-style:normal;font-stretch:normal}@font-face{font-family:icomoon;src:url(" + __webpack_require__(407) + ");src:url(" + __webpack_require__(407) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(408) + ") format(\"truetype\"),url(" + __webpack_require__(409) + ") format(\"woff\"),url(" + __webpack_require__(410) + ") format(\"svg\");font-weight:400;font-style:normal}h1,h2,h3,h4,h5,h6{font-family:GTWalsheimProLight;margin:0;padding:0;color:inherit;line-height:1.1;font-weight:700}h1{font-size:36px}h2{font-size:30px}h3{font-size:24px}h4{font-size:18px}h5{font-size:14px}h6{font-size:12px}#app,body,html{width:100%;height:100%;margin:0;background-color:#c6c6c6;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;font-weight:400;font-style:normal;font-stretch:normal;font-family:GTWalsheimProRegular;color:#000}a:active,a:focus,a:hover{text-decoration:none;color:#9b9b9b}a{color:inherit;text-decoration:none}*,:after,:before{box-sizing:border-box}.material-icons,img{vertical-align:middle}.material-icons{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-variant-ligatures:none;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale}.page-content{padding:60px 0 10px}.page-content_padding-modifier{padding:60px 40px 70px}.white-box-container{background-color:#fff;width:100%;padding:30px}.box--shadow{box-shadow:20px 20px #e1e1e1}.row.no-pad{margin-right:0;margin-left:0}.row.no-pad>[class*=col-]{padding-right:0;padding-left:0}@media (min-width:128px) and (max-width:1199px){.box--shadow{box-shadow:none}.page-content{padding:50px 0 10px}.page-content_padding-modifier{padding:50px 10px 70px}}#toast-container .toast-success{background-color:#3cb449}#toast-container .toast-info{background-color:#60aff4}#toast-container .toast-error{background-color:#ef5350}#toast-container .toast-warning{background-color:#eca657}.red-500{color:#ef5350}.cursor--pointer{cursor:pointer}.no--cursor--pointer{cursor:default!important}.no--padding{padding:0}.font--bold{font-family:GTWalsheimProBold}.font--bold,.font--proLight{font-weight:700;font-style:normal;font-stretch:normal}.font--proLight{font-family:GTWalsheimProLight}.text--center{text-align:center}.text--right{text-align:right}.bg--white{background-color:#fff}.bg--green{background-color:#3f5043}.display--flex{display:flex}.display--flex__flex--start--center{flex:1;display:flex;justify-content:flex-start;align-items:center}.display--flex__flex--center{flex:1;display:flex;justify-content:center;align-items:center}.display--flex__flex--end--center{flex:1;display:flex;justify-content:flex-end;align-items:center}.display--flex--in-row{display:flex;flex-direction:row}.flex--vertical--horizontal{display:flex;flex-direction:column;justify-content:center;align-items:center}.flex--center{flex-wrap:wrap}.flex--center,.justify-center{display:flex;align-items:center}.justify-center{justify-content:center}.row-eq-height{display:flex;flex-wrap:wrap}[data-tooltip]:after{z-index:7089!important}.app_container .app_header--sticky{z-index:7091!important}.app_container .header-items .header-items__user-setting .dropdown-list{z-index:7092!important}.app_container .app__content .sticky-menu{z-index:7090!important}.app_container .app__content .sticky-menu .overview-grid-widget .grid-widget-card .widget-card .widget-card__bottom-menu .row .widget-setting .widget-setting__faulty-number{z-index:300!important}.app_container .app__content .sticky-menu .overview-grid-widget .grid-widget-card .widget-card__buttons{z-index:5!important}.app_container .app__content .comparison__search-container{z-index:1001}.edit-widget-dropdown{z-index:7094!important}.dropdown{background:transparent;width:100%;z-index:1000}.header-items__location__dropdown-root,.settings-location__dropdown{z-index:7094!important}.modals__overlay{z-index:1001!important}.overwrite--modal--depth .modals__overlay{z-index:7091!important}.modals__content{z-index:7093!important}.popup-color-note,.popup-device-management{z-index:49!important}.datepicker--popup{z-index:1008!important}.btn-success{background-color:#3cb449;border-color:#3cb449}.btn{outline:0!important}.btn-disabled{cursor:not-allowed;pointer-events:none;background:#e1e1e1;border-color:#e1e1e1}.btn-success:hover{color:#fff;background-color:#449d44;border-color:#449d44}.btn--green,.btn--green:active,.btn--green:hover,.btn--green:visited,.button{color:#3cb449}.button{border:none}.btn-small,.button{cursor:pointer;font-size:16px;padding:4px 10px 2px;text-align:center}.btn-small{border:1px solid #c6c6c6;transition:all .3s;border-radius:4px}.btn-small:hover{color:#3cb449;border:1px solid #3cb449;transition:all .3s;cursor:pointer}.btn-small,button{outline:0}.scroll-top-button.scroll--show{opacity:1;cursor:pointer;z-index:2203}.scroll-top-button{display:block;position:fixed;bottom:30px;right:30px;outline:none;background-color:#3cb449;padding:12px;border-radius:50%;box-shadow:0 4px 12px 0 rgba(0,0,0,.2);z-index:-1000;cursor:default;opacity:0;transition:box-shadow .2s,opacity .4s}.scroll-top-button:hover{box-shadow:0 4px 12px 0 rgba(0,0,0,.5)}.stats-menu-btn{font-size:12px;font-family:GTWalsheimProBold;letter-spacing:0;color:#939598}.add--loc--btn__icon--text{margin-left:10px;display:flex;align-items:center}.add--loc--btn__icon--text:hover{color:#297b32!important}.add--loc--btn__icon--text:hover .icon-addicon:before{color:#297b32}.add--loc--btn__icon--text .icon-addicon{font-size:27px;margin-right:8px}.stats-menu-btn:hover .icon-addicon:before{color:#297b32}.stats-menu-btn:hover__label{color:#4a4a4a}.datepicker--popup .close{margin-top:-20px;margin-right:-10px}.authentication-wrapper input[type=button]{font-size:16px;padding:8px 18px;margin-top:17px}.form__authentication-btn:hover,.form__login-btn:hover{background-color:#3cb449;border:1px solid #3cb449;color:#fff;transition:all .3s;cursor:pointer}@media (min-width:128px) and (max-width:1199px){.scroll-top-button{bottom:20px;right:15px;padding:8px}}.live-stats-card .table>tbody>tr td,.live-stats-card .table>tbody>tr th{border-top:none;border-bottom:1px solid #c6c6c6}.flat-table{width:100%;border-collapse:collapse}.flat-table tr:hover td{background-color:rgba(99,99,99,.1)}td,th{text-align:left;padding:8px;border:none}th{font-size:14px;letter-spacing:.04em;color:#939598;margin-bottom:6px}.table-header-row h4,th{font-family:GTWalsheimProBold}.table-header-row h4{font-size:17px;letter-spacing:0}.table-spacing{height:20px;border:none;opacity:0}.users--section{width:80%}.user-table td i{margin-left:-3px}.user-table .table-header-row th:first-child{width:25%}.user-table .table-header-row th:nth-child(2){width:22%}.user-table .table-header-row th:nth-child(3){width:14%}.user-table .table-header-row th:nth-child(4){width:auto}.user-table .table-header-row th:nth-child(5){width:8%}.sensors-table-wrapper{width:77%}.sensor-table td i{margin-left:-3px}.sensor-table tr td:not(.button-holder) a{color:#337ab7!important}.sensor-table .table-header-row th:first-child{width:3%}.sensor-table .table-header-row th:nth-child(2){width:17%}.sensor-table .table-header-row th:nth-child(3){width:15%}.sensor-table .table-header-row th:nth-child(4){width:auto}.sensor-table .table-header-row th:nth-child(5){width:19%}.sensor-table .table-header-row th:nth-child(6){width:12%}.lds-spinner{color:official;display:inline-block;position:relative;width:64px;height:64px}.lds-spinner div{transform-origin:32px 32px;-webkit-animation:lds-spinner 1.2s linear infinite;animation:lds-spinner 1.2s linear infinite}.lds-spinner div:after{content:\" \";display:block;position:absolute;top:3px;left:29px;width:5px;height:14px;border-radius:20%;background:#3cb449}.lds-spinner div:first-child{transform:rotate(0deg);-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.lds-spinner div:nth-child(2){transform:rotate(30deg);-webkit-animation-delay:-1s;animation-delay:-1s}.lds-spinner div:nth-child(3){transform:rotate(60deg);-webkit-animation-delay:-.9s;animation-delay:-.9s}.lds-spinner div:nth-child(4){transform:rotate(90deg);-webkit-animation-delay:-.8s;animation-delay:-.8s}.lds-spinner div:nth-child(5){transform:rotate(120deg);-webkit-animation-delay:-.7s;animation-delay:-.7s}.lds-spinner div:nth-child(6){transform:rotate(150deg);-webkit-animation-delay:-.6s;animation-delay:-.6s}.lds-spinner div:nth-child(7){transform:rotate(180deg);-webkit-animation-delay:-.5s;animation-delay:-.5s}.lds-spinner div:nth-child(8){transform:rotate(210deg);-webkit-animation-delay:-.4s;animation-delay:-.4s}.lds-spinner div:nth-child(9){transform:rotate(240deg);-webkit-animation-delay:-.3s;animation-delay:-.3s}.lds-spinner div:nth-child(10){transform:rotate(270deg);-webkit-animation-delay:-.2s;animation-delay:-.2s}.lds-spinner div:nth-child(11){transform:rotate(300deg);-webkit-animation-delay:-.1s;animation-delay:-.1s}.lds-spinner div:nth-child(12){transform:rotate(330deg);-webkit-animation-delay:0s;animation-delay:0s}@-webkit-keyframes lds-spinner{0%{opacity:1}to{opacity:0}}@keyframes lds-spinner{0%{opacity:1}to{opacity:0}}.material-icons_size{font-size:30px;margin-left:5px;cursor:pointer}.save--icons{color:#3cb449}.cancel--icons,.save--icons{margin-left:0!important;margin-right:5px}.add--loc--icons,.edit--icons,.info-icons,.layers--icons,.preview--icons,.users--icons{transition:all .2s ease;color:#3f5043}.add--loc--icons:hover,.edit--icons:hover,.info-icons:hover,.layers--icons:hover,.preview--icons:hover,.users--icons:hover{color:#000}.delete--icons{transition:all .2s ease;color:#ef5350}.delete--icons:hover{color:#c71612}.stats-menu__list-item .stats-export__container{display:inline-block}.stats-menu__list-item .stats-export img{width:27px}.stats-menu__list-item .stats-export .icon-export{font-size:24px}.stats-menu__list-item:hover .icon-devicem:before,.stats-menu__list-item:hover .icon-export:before,.stats-menu__list-item:hover .icon-heatmap:before,.stats-menu__list-item:hover .icon-live:before,.stats-menu__list-item:hover .icon-stats:before{color:#297b32}.heatmap-export{height:50px}.heatmap-export img{width:27px;line-height:50px}.heatmap-export .icon-export{line-height:50px;font-size:24px}.heatmap-export:hover .icon-export:before{color:#297b32}.font-icon{font-family:icomoon!important;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;cursor:pointer;transition:all .2s ease}.icon-infoIcon:before{content:\"\\E90D\";color:#3f5043}.icon-infoIcon:hover:before{color:#000}.icon-addicon:before{content:\"\\E90C\"}.icon-export:before{content:\"\\E908\"}.icon-heatmap:before{content:\"\\E909\"}.icon-live:before{content:\"\\E90A\"}.icon-stats:before{content:\"\\E901\"}.icon-devicem:before{content:\"\\E900\"}.icon-widgetsetting:before{content:\"\\E90B\"}.icon-maintenance:before{content:\"\\E907\"}.icon-user-settings:before{content:\"\\E903\";font-size:17px;color:#9b9b9b}.icon-user-settings:hover:before{color:#757575}.icon-location-hamburger:before{content:\"\\E902\";font-size:17px;color:#9b9b9b}.icon-location-hamburger:hover:before{color:#757575}.icon-addicon:before,.icon-devicem:before,.icon-export:before,.icon-heatmap:before,.icon-live:before,.icon-maintenance:before,.icon-stats:before,.icon-widgetsetting:before{color:#3cb449}.icon-addicon:hover:before,.icon-devicem:hover:before,.icon-export:hover:before,.icon-heatmap:hover:before,.icon-live:hover:before,.icon-maintenance:hover:before,.icon-stats:hover:before,.icon-widgetsetting:hover:before{color:#297b32}.icon-heatmap,.icon-live,.icon-stats{font-size:18px}.icon-addicon,.icon-devicem,.icon-export{font-size:24px}.icon-widgetsetting{display:block;margin-top:6px;font-size:22px}.icon-maintenance{display:block;margin-top:5px;font-size:25px}.widget-export .icon-export,.widget-export img{display:block;margin-top:4px;width:25px;font-size:25px}.tooltip-header{width:100%;text-align:center}[data-tooltip]{position:relative;display:inline-block}[data-tooltip]:after{display:none;box-sizing:content-box;text-align:center;font-family:GTWalsheimProRegular;text-transform:none;content:attr(data-tooltip);font-size:12px;position:absolute;color:#fff;background-color:hsla(0,0%,8%,.9);padding:6px 8px;width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:220px;opacity:0;pointer-events:none;left:50%;top:0;transform:translate3d(-50%,-20px,0);white-space:pre-line;line-height:normal}[data-tooltip]:hover:after{box-shadow:0 4px 6px rgba(0,0,0,.3);opacity:1;transform:translate3d(-50%,calc(-100% - 20px),0);display:inline-block}.app_header{height:65px;background-color:#fff}.app_header--sticky{width:100%;position:fixed}.app_header--spacing-active{display:block;height:65px}.header-items{padding:18px 20px 19px;display:flex}.header-items .header-btn{color:#9b9b9b;text-transform:uppercase}.header-items .header-btn:hover,.header-items .header-btn:hover .icon-location-hamburger:before,.header-items .header-btn:hover .icon-user-settings:before{color:#686868}.header-items .header-btn__label{margin-left:10px;font-size:10px;line-height:normal;letter-spacing:1.4px}.header-items__logo{width:161px;height:28px;-o-object-fit:contain;object-fit:contain}.header-items__user-setting .dropdown-list{box-shadow:0 2px 8px 0 rgba(0,0,0,.4);visibility:hidden;position:absolute;background:#fff;z-index:1009;top:48px;right:12px;width:180px}.header-items__user-setting .dropdown-list_show{visibility:visible}.header-items__user-setting .dropdown-list ul{border-top:3px solid #3cb449;box-shadow:0 2px 3px 0 hsla(0,0%,82%,.5);margin:0;padding:0}.header-items__user-setting .dropdown-list ul li{list-style:none;margin:0;padding:0;background:#fff}.header-items__user-setting .dropdown-list ul li:hover{background-color:#3cb449}.header-items__user-setting .dropdown-list ul li:hover a{color:#fff}.header-items__user-setting .dropdown-list ul li a{color:#585e66;line-height:160%;padding:6px 8px 6px 18px;display:inline-block}.normal__menu,.sticky-menu{background-color:#f9f9f9}.sticky-menu{top:65px;position:fixed;max-height:100%;width:100vw;box-shadow:2px 4px 10px rgba(0,0,0,.2)}.main-menu{height:60px;flex-wrap:wrap}.main-menu .active,.stats-menu .active{padding-bottom:3px!important;border-bottom:2px solid #4a4a4a;color:#4a4a4a;transition:all 0s!important}.main-menu__quicknav,.main-menu__times{margin:0 20px}.main-menu__times .datepicker--parent{position:relative}.main-menu__times .datepicker--popup{position:absolute;top:54px;right:10px;background:#fff;box-shadow:10px 10px #e1e1e1;padding:20px 15px 15px;margin-top:10px;margin-right:15px}.main-menu__times .datepicker--popup .date--divider{color:#4a4a4a;margin:-4px 6px 0;font-size:30px}.main-menu__times .datepicker--popup .end--date,.main-menu__times .datepicker--popup .start--date{line-height:normal!important;width:120px}.main-menu__times .datepicker--popup .end--date input,.main-menu__times .datepicker--popup .start--date input{cursor:pointer}.main-menu__times .datepicker--popup .end--date:focus,.main-menu__times .datepicker--popup .start--date:focus{outline-color:#3cb449}.main-menu__times .datepicker--popup .timepicker{margin-left:15px;margin-right:15px}.main-menu__times .datepicker--popup .timepicker-icon{margin-left:8px;margin-top:4px}.main-menu__times .datepicker--popup .timepicker-body{position:relative;background:#c6c6c6;height:8px;width:100%;border-radius:20px;margin-top:10px;margin-bottom:20px}.main-menu__times .datepicker--popup .timepicker-range{position:absolute;background:#3cb449;height:8px;border-radius:20px}.main-menu__times .datepicker--popup .timepicker-mark{position:absolute;top:6px;height:9px;width:2px;background:#c6c6c6}.main-menu__times .datepicker--popup .range-dot{position:absolute;height:20px;width:20px;bottom:-6px;background:#fff;border-radius:80px;box-shadow:0 0 4px 0 rgba(0,0,0,.4);transform:translate(-50%);cursor:pointer}.main-menu__times .datepicker--popup .range-value{position:absolute;top:24px;transform:translate(-25%)}.main-menu__quicknav__item,.main-menu__times__item{cursor:pointer;text-transform:uppercase;font-size:10px;line-height:normal;letter-spacing:1.4px;color:#9b9b9b;padding-bottom:5px;display:block;float:left;text-align:center}.main-menu__quicknav__item:hover,.main-menu__times__item:hover{color:#4a4a4a;transition:all .3s}.main-menu__quicknav__item:not(:last-child),.main-menu__times__item:not(:last-child){margin-right:30px}.ms-Callout{font-weight:400!important;font-style:normal!important;font-stretch:normal!important;font-family:GTWalsheimProRegular!important}.ms-Callout td,.ms-Callout th{text-align:center!important}.ms-Callout td{padding:0!important}.stats-menu{clear:both;height:45px;background-Color:#f0f0f0}.stats-menu__list{flex-flow:row wrap;list-style:none;height:45px}.stats-menu__list-item{line-height:45px;font-size:12px;font-family:GTWalsheimProBold;padding:0 20px}.stats-menu__list-item:not(:last-child){border-right:2px solid #f9f9f9}.stats-menu__list-item_link{display:flex;justify-content:center;align-items:center}.stats-menu__list-item_link .text{font-size:12px;color:#939598;margin-left:15px}.stats-menu__list-item:hover{transition:all .2s ease}.stats-menu__list-item:hover .dropdown__toggle,.stats-menu__list-item:hover span{color:#4a4a4a}.stats-menu__list-item:hover .save--icons{transition:all .2s ease;color:#297b32}.stats-menu__list-item_active{background-color:#f9f9f9;transition:background .2s ease}.stats-menu__list-item_active.stats-menu__list-item_link .text,.stats-menu__list-item_active span{color:#4a4a4a}.stats-menu__list .stats-menu__list-item_bold{font-size:18px;font-family:GTWalsheimProBold}.breadcrumbs{height:45px;padding:12.5px 26px}.breadcrumbs .breadcrumb__element--off,.breadcrumbs .breadcrumb__root{color:#9b9b9b}.breadcrumbs a{font-size:12px;letter-spacing:.5px}.breadcrumbs .breadcrumb--divider{padding:0 5px;color:#9b9b9b}.breadcrumbs .breadcrumb__element--on{cursor:pointer;color:#9b9b9b}.breadcrumbs .breadcrumb__element--on:hover,.breadcrumbs .breadcrumb__element--on:last-of-type{font-weight:700;font-style:normal;font-stretch:normal;font-family:GTWalsheimProBold;color:#4a4a4a}.widget-card__header{display:flex;justify-content:space-between;align-items:center}.widget-card__header h3{overflow:hidden;font-size:20px;line-height:1.46;color:#3f5043;text-overflow:ellipsis;max-width:215px;white-space:nowrap}.widget-card__header-info{width:18px}.widget-card__buttons{display:flex;justify-content:space-between;align-items:center;margin-top:10px;border-top:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1;padding:0}.widget-card__buttons__location-select{position:relative;line-height:32px}.widget-card__buttons .widget-btn,.widget-card__buttons__quickaccess{display:flex;justify-content:center;align-items:center}.widget-card__buttons .widget-btn{margin-left:18px;cursor:pointer}.widget-card__buttons .widget-btn_disabled .icon-heatmap:before,.widget-card__buttons .widget-btn_disabled .icon-live:before,.widget-card__buttons .widget-btn_disabled:hover .icon-heatmap:hover:before,.widget-card__buttons .widget-btn_disabled:hover .icon-live:hover:before{color:#e1e1e1}.widget-card .clock{margin-top:5px}.widget-card .clock__arc{position:relative}.widget-card .clock__arc-svg{position:absolute;left:0;top:0;stroke-linecap:round;transform-origin:center center}.widget-card .clock__arc-svg circle{fill:none;transform-origin:center center;transition-property:stroke-dashArray;transition-duration:1s;transition-timing-function:ease-in-out}.widget-card .clock__arc-svg-label{font-size:12px;line-height:normal;letter-spacing:0;fill:#3f5043}.widget-card .clock__arc-needle{position:absolute;left:0;top:0}.widget-card .clock__arc-needle .have-trans{transition-property:transform;transition-duration:1s;transition-timing-function:ease-in-out}.widget-card .clock__arc-needle .no-trans{transition-property:none}.widget-card .clock__info{position:absolute;width:245px}.widget-card .clock__info-label{font-size:22px;line-height:1.44;letter-spacing:0;display:inline-block;text-align:center;color:#3f5043}.widget-card .clock__info-label b{font-size:22px;line-height:1.44}.widget-card .clock__info-label .small-label{font-size:12px;line-height:normal;letter-spacing:0}.widget-card .clock__info-label_left{float:left}.widget-card .clock__info-label_right{float:right}.widget-card .clock__info-label_text_green{color:#3cb449}.widget-card .clock__info .label{font-size:.8em;width:100%;text-align:center;margin:15px 0 0;transform:translateY(90px)}.widget-card .clock__markers{transform:scale(.75);top:0;position:absolute;width:245px;height:245px}.widget-card .clock__markers p{text-align:center;position:absolute;color:#bdbdbd;height:49.1%;top:0;left:0;right:0;transform-origin:50% 102.5%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.widget-card .clock__markers p .ticks{color:#eee;font-size:1.8em;line-height:1.3em;font-weight:bolder}.widget-card__stacked-bar{position:relative;width:100%}.widget-card__stacked-bar .bar-svg{margin:0;width:100%;height:70px;z-index:-1}.widget-card__stacked-bar .bar-info{cursor:pointer;margin:0;width:100%;position:relative;height:60px;transform:translateY(-125%);z-index:1}.widget-card__stacked-bar .bar-info_top{top:0}.widget-card__stacked-bar .bar-info_have_trans{position:absolute;text-align:center;transition-property:all;transition-duration:1s;transition-timing-function:ease}.widget-card__stacked-bar .bar-info_no_trans{position:absolute;text-align:center}.widget-card__stacked-bar .bar-info__label{font-size:11px;line-height:normal;letter-spacing:0;text-align:center;color:#3f5043;bottom:0}.widget-card__stats-block{display:flex}.widget-card__stats-block .stats-block__total-desks,.widget-card__stats-block .stats-block__total-rooms{margin:1.25px;padding:10px;background-color:#f2f2f2;flex:1}.widget-card__stats-block .total-desks__title,.widget-card__stats-block .total-rooms__title{font-size:14px;line-height:normal;letter-spacing:-.1px;color:#3f5043}.widget-card__stats-block .total-desks__number,.widget-card__stats-block .total-rooms__number{font-size:20px;line-height:1.46;letter-spacing:0;color:#3f5043}.widget-card__stats-block .total-desks__desks-inuse,.widget-card__stats-block .total-rooms__rooms-inuse{font-size:10px;line-height:normal;letter-spacing:0;color:#939598}.widget-card__bottom-menu{margin-bottom:0;padding:22px 40px 0}.widget-card__bottom-menu .widget-setting{position:relative;height:25px}.widget-card__bottom-menu .widget-setting svg{margin-top:4px;width:25px;height:25px}.widget-card__bottom-menu .widget-setting .widget-setting__faulty-number{position:absolute;right:-12px;top:-7px;width:20px;border-radius:50%;text-align:center;color:#fff;font-size:14px}.widget-card__bottom-menu .widget-setting .background--red{background-color:#ef5350}.widget-card__bottom-menu .widget-setting .background--brown{background-color:#795548}.widget-card__bottom-menu .edit-widget-dropdown{left:26px;bottom:-75px;position:absolute;min-width:100px;z-index:1000;color:#000;background-color:#fff;border:1px solid rgba(0,0,0,.1);box-shadow:-5px -5px #e1e1e1}.widget-card__bottom-menu .edit-widget-dropdown ul{padding:0;text-align:left;margin:0}.widget-card__bottom-menu .edit-widget-dropdown ul li{padding:6px 0 6px 30px;list-style-type:none}.widget-card__bottom-menu .edit-widget-dropdown ul li:hover{background-color:#3cb449;color:#fff}.stacked-bar-legends__header{text-align:center;display:block;padding:3px 0;font-size:12px;line-height:normal;letter-spacing:0}.stacked-bar-legends__info{font-size:10px;max-width:200px;display:block;margin-bottom:5px}.stacked-bar-legends__wrapper{display:flex;justify-content:center;align-items:center;align-self:center}.stacked-bar-legends__wrapper span{padding:5px;font-size:10px;display:flex;line-height:normal;letter-spacing:0}.stacked-bar-legends__wrapper span:before{content:\"\";display:inline-block;width:12px;height:12px;margin-right:5px;background:#c4d79b}.stacked-bar-legends__wrapper span:first-of-type:before{background:#ebf1de}.stacked-bar-legends__wrapper span:last-of-type:before{background:#4f6229}.dropdown-btn{font-size:16px;position:relative}.modals__content{width:300px;left:50%;top:125px;right:auto;transform:translate(-50%);position:fixed;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 2px 8px 0 rgba(0,0,0,.4);outline:0}.modals__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.5)}.modals__content__header{padding:15px;border-bottom:1px solid #e1e1e1}.modals__content__header__title{margin:0;line-height:1.42857143;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.modals__content__body{position:relative;padding:15px}.modals__content__footer{padding:15px;text-align:right;border-top:1px solid #e1e1e1}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.close,button.close{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.close{float:right;font-size:24px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.modals__content__header .close{margin-bottom:2px}.close:hover{filter:alpha(opacity=100);opacity:1}.modals__content.open{-webkit-animation:fadeInA .3s linear forwards;animation:fadeInA .3s linear forwards;-webkit-animation-iteration-count:1;animation-iteration-count:1}.modals__overlay.open{-webkit-animation:fadeInB .3s linear forwards;animation:fadeInB .3s linear forwards;-webkit-animation-iteration-count:1;animation-iteration-count:1}.modals__content.closed{-webkit-animation:fadeOutA .3s linear forwards;animation:fadeOutA .3s linear forwards;-webkit-animation-iteration-count:1;animation-iteration-count:1}.modals__overlay.closed{-webkit-animation:fadeOutB .3s linear forwards;animation:fadeOutB .3s linear forwards;-webkit-animation-iteration-count:1;animation-iteration-count:1}.modals__content__footer .btn+.btn{margin-bottom:0;margin-left:5px}@-webkit-keyframes fadeOutA{0%{opacity:1}to{opacity:0;top:-100%}}@keyframes fadeOutA{0%{opacity:1}to{opacity:0;top:-100%}}@-webkit-keyframes fadeInA{0%{opacity:0;top:-100%}}@keyframes fadeInA{0%{opacity:0;top:-100%}}@-webkit-keyframes fadeOutB{0%{opacity:1;bottom:0}99%{opacity:0;bottom:0}to{opacity:0;bottom:100%}}@keyframes fadeOutB{0%{opacity:1;bottom:0}99%{opacity:0;bottom:0}to{opacity:0;bottom:100%}}@-webkit-keyframes fadeInB{0%{opacity:0;bottom:0}}@keyframes fadeInB{0%{opacity:0;bottom:0}}.text-red{color:#ef5350}.text-green{color:#3cb449}.register-message{margin:0 10px 10px}.border-red{border:1px solid #ef5350!important}.modals__content select,.settings-add-location-wrapper select{width:230px;height:36px;margin-bottom:18px;border:1px solid #c6c6c6;border-radius:4px;background:#fff}.modals__content select:focus,.settings-add-location-wrapper select:focus{outline-color:#3cb449}.modals__content select:disabled,.settings-add-location-wrapper select:disabled{color:#e1e1e1}.change-pwd-wrapper label,.edit-sensor-wrapper label,.modals__content label,.settings-add-location-wrapper label{display:block;text-align:left;font-size:16px;font-weight:400}.zone-type{margin-bottom:20px}.zone-type input[type=radio]{margin-right:6px}.zone-type span{margin-left:5px}.page-content_padding-modifier .create--modal .Select,.page-content_padding-modifier .live-feed-form .Select,.page-content_padding-modifier .save-modal .Select,.page-content_padding-modifier .template-modal .Select{margin:9px 0}.page-content_padding-modifier .create--modal .Select .Select-placeholder,.page-content_padding-modifier .live-feed-form .Select .Select-placeholder,.page-content_padding-modifier .save-modal .Select .Select-placeholder,.page-content_padding-modifier .template-modal .Select .Select-placeholder{cursor:pointer}.page-content_padding-modifier .create--modal .Select .add-template,.page-content_padding-modifier .live-feed-form .Select .add-template,.page-content_padding-modifier .save-modal .Select .add-template,.page-content_padding-modifier .template-modal .Select .add-template{color:#3cb449;font-weight:700}.page-content_padding-modifier .create--modal .Select .Select-control:focus,.page-content_padding-modifier .live-feed-form .Select .Select-control:focus,.page-content_padding-modifier .save-modal .Select .Select-control:focus,.page-content_padding-modifier .template-modal .Select .Select-control:focus{outline:none;border:1px solid #3cb449;box-shadow:inset 0 0 0 1px #3cb449}.page-content_padding-modifier .create--modal .Select .Select-menu-outer,.page-content_padding-modifier .live-feed-form .Select .Select-menu-outer,.page-content_padding-modifier .save-modal .Select .Select-menu-outer,.page-content_padding-modifier .template-modal .Select .Select-menu-outer{position:relative;box-shadow:0 4px 12px 0 rgba(50,50,50,.4)}.page-content_padding-modifier .create--modal .Select .Select-menu,.page-content_padding-modifier .live-feed-form .Select .Select-menu,.page-content_padding-modifier .save-modal .Select .Select-menu,.page-content_padding-modifier .template-modal .Select .Select-menu{z-index:7094}select{cursor:pointer}input[type=email],input[type=password],input[type=tel],input[type=text]:not(.ms-TextField-field),input[type=username]{width:230px;font-size:18px;height:36px;padding-left:10px;margin-top:9px;margin-bottom:9px;border:1px solid #c6c6c6;border-radius:4px;font-family:GTWalsheimProRegular;line-height:26px}input[type=checkbox]{margin-right:6px;font-size:18px}input[disabled]{background:#e1e1e1}.editable{background:#fff!important}.uneditable{border:none!important}input:focus,textarea:focus{outline-color:#3cb449}.forgot-password{margin-top:20px}.forgot-password a{color:#337ab7;font-size:18px}input[type=email].has-error,input[type=password].has-error,input[type=text].has-error,input[type=username].has-error,textarea.has-error{border-color:#ef5350!important}.authentication-wrapper input[type=email],.authentication-wrapper input[type=password],.authentication-wrapper input[type=username]{width:260px}.account-form input[type=email],.account-form input[type=password],.account-form input[type=tel],.account-form input[type=text],.account-form select{width:230px;height:36px;padding-left:10px;margin-bottom:18px;border:1px solid #c6c6c6;border-radius:4px}.register-form input[type=password]{margin-top:0!important}.popup-color-note{background-color:#fff;position:fixed;top:50%;transform:translateY(-50%);right:40px;box-shadow:10px 10px #e1e1e1}.popup-color-note:hover{z-index:9999}.popup-color-note tbody{display:block;padding:5px 0}.popup-color-note td{display:inline-block}.popup-color-note tr{padding:0 20px;width:100%;display:block}.popup-color-note span{height:20px}.popup-color-note .popup-color-note-td:before{content:\" \";margin-right:2px;float:left;height:20px;width:20px;border-radius:50%;transform:scale(.7)}.popup-color-note .red:before{background-color:#ef5350}.popup-color-note .yellow:before{background-color:#eca657}.popup-color-note .green:before{background-color:#3cb449}.heatmap-content .popup-color-note .green:before{background-color:#3f3}.popup-color-note .blue:before{background-color:#1a237e}.popup-color-note .brown:before{background-color:#795548}.header-items__location__dropdown-root{display:block;position:absolute;background:#fff;top:48px;box-shadow:0 2px 8px 0 rgba(0,0,0,.4);min-width:250px;max-height:560px;overflow-y:auto;overflow-x:hidden;box-sizing:content-box}.header-items__location__dropdown-root a,.search-dropdown-root a{display:inline-block;text-decoration:none;color:#585e66;padding:12px 10px;transition:box-shadow .2s,font-weight .2s}.header-items__location__dropdown-root a:hover,.search-dropdown-root a:hover{font-weight:700;cursor:pointer;box-shadow:inset 2px 0 0 0 #3cb449}.header-items__location__dropdown-root .dropdown-div,.search-dropdown-root .dropdown-div{white-space:nowrap}.header-items__location__dropdown-root .dropdown-button,.header-items__location__dropdown-root a,.search-dropdown-root .dropdown-button,.search-dropdown-root a{line-height:24px!important;padding-top:12px!important;padding-bottom:12px!important}.header-items__location__dropdown-root .dropdown-container,.search-dropdown-root .dropdown-container{margin-left:0;background-color:transparent}.header-items__location__dropdown-root .dropdown-container .dropdown-container,.search-dropdown-root .dropdown-container .dropdown-container{margin-left:10px;background-color:rgba(0,0,0,.03)}.dropdown-scroll{overflow-y:auto;overflow-x:hidden;max-height:200px}.search-dropdown-root .dropdown-button{margin-right:0}.search-dropdown-root .dropdown-div{text-align:left}.dropdown-button{float:right;background:none;color:#585e66;border:none;border-radius:4px;text-align:center;vertical-align:middle;margin-right:10px;padding:0;min-width:15px;transform-origin:50% 50%;transition:transform .4s ease-in-out,font-weight .2s}.dropdown-button:hover{font-weight:700}.dropdown--active{transform:scaleX(-1)}.dropdown-button:active,.dropdown-button:focus{outline:none;border:none}.Select-control{cursor:pointer}.Select.is-focused .Select-control{box-shadow:none!important;border-color:#c6c6c6!important}.location-dropdown-search-container{padding:12px 10px}.location-dropdown-search-container .Select-menu-outer{position:relative}.location-dropdown-search-container .Select-menu{max-height:180px;margin-left:-1px}.location-dropdown-search-container .Select-option{border-left:1px solid #c6c6c6;transition:all .2s}.location-dropdown-search-container .Select-option.is-focused{background:none;color:#9b9b9b}.location-dropdown-search-container .Select-option:hover{font-weight:700;box-shadow:inset 2px 0 0 0 #3cb449}.dropdown{position:relative;background-color:transparent;cursor:pointer}.dropdown.open .dropdown__items{display:block;box-shadow:0 2px 5px 0 rgba(0,0,0,.4)}.dropdown .dropdown__toggle{background-color:transparent;border:none;width:100%;color:#9b9b9b;text-align:left;font-size:12px}.dropdown .dropdown__toggle .dropdown__toggle__arrow{margin-left:10px;width:14px}.dropdown .dropdown__toggle .loading{cursor:progress}.dropdown .dropdown__toggle:focus{outline:none}.dropdown .dropdown__toggle .icon{height:1em;width:1em;float:right}.dropdown .dropdown__items{display:none;position:absolute;left:0;top:100%;max-height:400px;overflow-y:auto;background-color:#fff;box-sizing:border-box}.dropdown .dropdown__items .dropdown__item{text-align:left;line-height:20px;white-space:nowrap}.dropdown .dropdown__items .dropdown__item_selected{background-color:#e8f7ea;font-weight:700}.dropdown .dropdown__items .dropdown__item *{padding:6px 12px}.dropdown .dropdown__items .dropdown__item:hover{cursor:pointer;color:#fff;background-color:#3cb449}.dropdown-default-text{font-size:12px;letter-spacing:0;color:#9b9b9b}.stats-menu__select .dropdown-default-text{font-size:12px;font-family:GTWalsheimProBold}.stats-menu__select .dropdown__items{left:-20px;font-size:14px;color:#000!important;font-family:GTWalsheimProRegular!important}.stats-card .dropdown__toggle{font-size:18px}.stats-card .dropdown__items{font-size:16px}.stats-card .dropdown__items .dropdown__item *{padding:6px 15px}.dropdown-menu{display:block;padding:0!important}.settings-location__dropdown{left:auto;right:0;min-width:130px}.settings-location__dropdown ul{margin:0!important}.settings-location__dropdown ul li{padding:6px 12px!important;list-style:none;margin:0;padding:0}.settings-location__dropdown ul li:hover{cursor:pointer;color:#fff;background-color:#3cb449}.settings-location__dropdown ul li:hover a{color:#fff}.location__list ul{margin-left:18px;padding:0}.stats-card{margin-bottom:50px;margin-left:auto;margin-right:auto;min-height:400px;max-width:1200px}.card__graph{padding:25px 10px}.card__graph .graph__header{padding:0 20px}.graph__header__title h2{font-size:28px;padding-left:35px;text-align:center}.header__options__child{margin-left:15px;height:36px;display:flex;align-items:center}.graph__body{margin:10px 0 10px 15px}.graph__body-legend-wrapper{display:flex;justify-content:center}.stats--info--wrapper{margin:0 0 0 20px;height:30px;display:flex;align-items:center}.breakdown-chart-select{display:inline-block!important}.breakdown-chart-select .Select{width:240px;display:inline-block}.breakdown-chart-select .Select.is-focused{z-index:10000}.breakdown-chart-select .Select .Select-option .multi-option-container .multi-label,.breakdown-chart-select .Select .Select-option .multi-option-container .multi-label-selected{display:inline-block;max-width:200px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.breakdown-chart-select .Select .Select-option .multi-option-container .multi-label-selected{font-weight:700}.breakdown-chart-select .Select .Select-option .multi-option-container .multi-indicator,.breakdown-chart-select .Select .Select-option .multi-option-container .multi-indicator-selected{float:right;width:20px;color:#3cb449}.multi--select--clear{cursor:pointer;color:#ef5350;margin-left:5px!important;font-size:20px}.legend__location{margin-right:20px}.legend__location__square{height:40px;width:40px}.legend__location__square--green{background:#3cb449}.legend__location__square--blue{background:#60aff4}.legend__location__name{font-size:18px;margin-left:8px}.zc-data-table{margin-left:40px}.overview-page{overflow:visible}.overview-grid-widget{padding:60px 90px;display:grid;grid-template-columns:repeat(auto-fit,minmax(285px,1fr));grid-column-gap:40px;grid-row-gap:60px}.grid-widget-card{text-align:center}.grid-widget-card .widget-card{width:285px;display:inline-block;position:relative;padding:15px 20px 30px;background:#fff}.grid-widget-card .widget-card-add{position:relative;padding:0;transition:box-shadow .2s ease;box-shadow:none}.grid-widget-card .widget-card-add .icon-addicon{font-size:64px}.grid-widget-card .widget-card-add:hover{box-shadow:20px 20px #e1e1e1}.grid-widget-card .widget-card-add:hover .icon-addicon:before{color:#297b32}@media (min-width:128px) and (max-width:1199px){.overview-grid-widget{padding:60px 0;grid-column-gap:20px;grid-row-gap:30px}}h3.page--title{margin-top:20px;margin-left:20px}.account-form .form-col{justify-content:center;align-items:flex-end;display:inline-flex;flex-direction:column;flex-wrap:wrap}.account-form .form-col:first-of-type{padding-right:50px}.account-form label{font-size:16px;font-weight:400;margin-right:15px}.account-form select{background:#fff}.account-form select:focus{outline-color:#3cb449}.account--btn__flat{display:inline-block;padding:4px 18px;margin-bottom:18px;font-size:18px}.active-user:before{background:#3cb449}.active-user:before,.pending-user:before{content:\"\";float:left;height:18px;width:18px;border-radius:20px;margin-right:4px}.pending-user:before{background:#795548}.table-email:hover{color:#337ab7}.location__list{margin:15px 0 0 18px;padding:0}.location__list,.location__list .location__list__item-wrapper{list-style-type:none}.location__list .location__list__item-wrapper .location__list__item{border-top:1px solid rgba(0,0,0,.5);padding:10px 0}.location__list .location__list__item-wrapper .location__list__item .list__item__name{font-size:18px;font-weight:700;font-weight:400;cursor:pointer}.location__list .location__list__item-wrapper .location__list__item .list__item__name img{float:left}.location__list .location__list__item-wrapper .location__list__item:hover{background-color:rgba(99,99,99,.1)}.edit__btn{position:relative}.default-settings-card{padding:30px 50px;width:60%;background-color:#fff}.default-settings-card:not(:last-of-type){margin-bottom:50px}.location-picker{position:relative}.location-picker a{cursor:pointer;line-height:38px;color:#585e66}.location-picker label{display:block;font-size:16px;font-weight:400;white-space:nowrap;cursor:pointer}.location-picker label .disabled{cursor:not-allowed;color:#e1e1e1}.location-picker-dropdown{padding:10px 20px}.box-settings,.working-days,.working-hours{margin-top:20px}.box-settings{display:flex;align-items:flex-start}.box-settings__child{flex-direction:column}.box-settings__child__dropdown{width:90px}.box-settings__child__dropdown i{margin-right:-6px}.box-settings__child__dropdown.open i{transform:rotate(180deg)}.box-settings__child__dropdown .dropdown__toggle{font-size:14px;color:#000;display:flex;justify-content:center;align-items:center;border:1px solid #eee}.box-settings__child__dropdown .dropdown__items{width:88px}.box-settings label{display:block}.days-picker label{width:100px}.days-picker{margin-top:14px}.days-picker input[type=checkbox]{display:none;margin-right:6px;font-size:16px}.days-picker input[type=checkbox],.days-picker input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}.custom-checkbox{position:relative;width:25px;height:25px;border:1px solid #c6c6c6;border-radius:8px;display:inline-block;cursor:pointer}.chbx:checked+.custom-checkbox:before{content:\"\";display:block;position:absolute;top:4px;right:4px;bottom:4px;left:4px;background:#3cb449;border-radius:8px}.week-day{display:block;font-weight:400;font-size:16px}.bin{height:22px;display:block;cursor:pointer}.hours-picker{width:100%;margin-top:24px;margin-bottom:36px}.hours-picker .timepicker-body{position:relative;background:#c6c6c6;height:18px;width:100%;border-radius:20px;margin-top:10px;margin-bottom:20px}.hours-picker .timepicker-range{position:absolute;background:#3cb449;height:18px;border-radius:20px}.hours-picker .range-dot{position:absolute;height:30px;width:30px;bottom:-5px;background:#fff;border-radius:80px;box-shadow:0 0 4px 0 #c6c6c6;transform:translate(-50%);cursor:pointer;text-align:center}.hours-picker .range-value{font-size:20px;position:relative;top:40px;display:flex;justify-content:center;align-items:center;margin:auto}.hours-picker .timepicker-mark{position:absolute;top:10px;height:22px;width:4px;background:#c6c6c6;transform:translate(-50%)}.api--box{width:60%;margin-left:20%;padding-bottom:65px}.current--api--key{margin-top:15px}.generate--api--btn{margin-top:5px;padding:4px 18px}.faq-page .faq-header{font-size:17px;font-family:GTWalsheimProBold;text-align:center;width:100%;margin:auto}.faq-page .faq-table{padding:10px;margin-bottom:50px}@media (min-width:1200px){.faq-page .faq-table{padding:20px 30px 30px;margin-bottom:0}}.faq-page .faq-table tr:not(:last-child){border-top:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1}.faq-page .faq-table td{width:50%}.faq-page .faq-table td:first-child{vertical-align:top;font-family:GTWalsheimProRegular;font-size:14px;font-weight:700;line-height:20px;letter-spacing:0;color:#000}.faq-page .faq-table td:nth-child(2){font-family:GTWalsheimProRegular;font-size:14px;letter-spacing:.4px;color:#000}.faq-page .feedback--container{width:270px;margin:auto}@media (min-width:1200px){.faq-page .feedback--container{position:absolute;min-width:270px;max-width:270px;right:20px}}.faq-page .feedback--container .feedback--container--padding{padding:20px}.faq-page .feedback--container label{display:block;width:95px;font-size:16px;font-weight:400}.faq-page .feedback--container .required{color:#ef5350}.faq-page .feedback--container input[type=text]{width:230px;height:36px;padding-left:10px;margin-bottom:18px;border:1px solid #c6c6c6;border-radius:4px}.faq-page .feedback-submit input[type=submit]{background:#3cb449;color:#fff;border:none;width:230px;margin-top:0}.faq-page .feedback--container textarea{overflow:auto;resize:vertical;width:230px;padding-left:10px;margin-bottom:18px;border:1px solid #c6c6c6;border-radius:4px}.faq-page .feedback{margin-top:20px}.authentication__card__logo{width:200px}.authentication-wrapper{display:flex;align-items:center;justify-content:center;height:100vh;background-color:#c6c6c6}.authentication__card{padding:27px 26px 22px;background:#fff;width:480px;margin-top:-60px}.authentication__card__welcome-message{font-size:16px;font-weight:400;font-family:GTWalsheimProRegular;line-height:33px;margin-bottom:10px}.form__reset-pw-recaptcha{transform:scale(.85573913);display:inline-block}.login--now{color:#337ab7}.login--now:hover{color:#337ab7;font-family:GTWalsheimProBold}.comparison-page .comparison-grid-widget{margin:60px 80px;display:grid;grid-template-columns:repeat(auto-fit,minmax(350px,1fr));grid-column-gap:15px;grid-row-gap:15px}.comparison-page .comparison-grid-widget .comparison__search-container{position:relative;padding:12px 10px;margin-bottom:0;background-color:#fff}.comparison-page .comparison-grid-widget .comparison__search-container .Select-control{border-radius:4px}.comparison-page .comparison-grid-widget .comparison__search-container .Select-menu-outer{position:absolute}.comparison-page .comparison-grid-widget .comparison__search-container .Select-menu{max-height:360px;margin-left:-1px}.comparison-page .comparison-grid-widget .comparison__search-container .Select-option{border-left:1px solid #c6c6c6;transition:box-shadow .2s,font-weight .2s;background-color:#fff}.comparison-page .comparison-grid-widget .comparison__search-container .Select-option:hover{font-weight:700;box-shadow:inset 2px 0 0 0 #3cb449}.comparison-page .comparison-grid-widget .grid-widget__first-location{min-width:350px;grid-column-start:1;grid-column-end:2;grid-row:1;margin:auto auto 0}.comparison-page .comparison-grid-widget .grid-widget__second-location{min-width:350px;grid-column-start:2;grid-column-end:3;grid-row:1;margin:auto auto 0}.comparison-page .comparison-grid-widget .grid-widget-card{grid-row:2}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card{box-shadow:none;min-width:350px;max-width:350px}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats{min-width:350px;max-width:350px;margin-left:40px;padding:19px 10px}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats .widget-card__comparison-stats__title{font-size:26px;color:#3f5043}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats .widget-card__comparison-stats__body{text-align:left;padding:30px;font-weight:700;font-size:20px}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats .widget-card__comparison-stats__body span{font-weight:400;float:right;margin-right:20px}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats .widget-card__comparison-stats__body .comparison--export{margin-top:20px}.comparison-page .comparison-grid-widget .grid-widget-card .widget-card__comparison-stats .widget-card__comparison-stats__body .comparison--export img{width:34px}.comparison-page .graph__header__title--comparison-title{font-size:22px;padding-left:50px}.comparison-page .header__options__child{height:24px}.floorplan-outer-container{position:relative;display:inline-block}.floorplan-outer-container.not-thumbnail{width:925px;margin-left:50px;margin-bottom:50px;box-shadow:20px 20px #e1e1e1}.floorplan-outer-container .floorplan-options-container{background-color:#fff;padding:0 5px 10px}.floorplan-outer-container .floorplan-options-container .floorplan-options{display:flex;flex-wrap:wrap;padding-left:10px}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help{margin:0 10px 0 0;flex:1;align-items:center;display:flex;min-width:400px;position:relative;color:#939598}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-icon{display:inline-block;transition:opacity .3s ease-out;margin-right:6px;font-size:16px}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-icon_modal h4,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-icon_modal p{color:#000}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-icon i{vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:16px}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-icon.hi-hide{opacity:1;opacity:0}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-text{display:inline-block;vertical-align:middle;transition:font-size .3s ease-out,opacity .3s ease-out}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-text.ht-show{font-size:16px;opacity:1}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-help .help-text.ht-hide{font-size:0;opacity:0}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container{display:flex;flex:auto}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .options-buttons-wrapper{display:inherit;margin-left:auto}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .options-buttons-wrapper .options-buttons{display:inherit;width:50px;height:50px;line-height:50px;vertical-align:middle;background-color:#fff;cursor:pointer;color:#3cb449;transition:color .2s ease}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .options-buttons-wrapper .options-buttons:hover{color:#297b32;cursor:pointer}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .options-buttons-wrapper .options-buttons i{z-index:4;font-size:34px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:34px;margin-top:8px}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .heatmap-filter,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .view-filter{display:inline-block;vertical-align:middle;margin-right:15px;height:100%}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .heatmap-filter .dropdown,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .view-filter .dropdown{z-index:10;height:100%;display:flex;align-items:center}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .heatmap-filter .dropdown.open,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .view-filter .dropdown.open{z-index:1000}.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .heatmap-filter .dropdown__items,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .heatmap-filter .dropdown__toggle,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .view-filter .dropdown__items,.floorplan-outer-container .floorplan-options-container .floorplan-options .options-buttons-container .view-filter .dropdown__toggle{font-size:16px}.floorplan-outer-container .floorplan-options-container .floorplan--divider{height:1px;background-color:rgba(0,0,0,.4)}.floorplan-container,.floorplan-container-thumbnail{position:relative;display:inline-block;width:925px}.floorplan-container-thumbnail img,.floorplan-container img{position:relative;z-index:2}.floorplan-container-thumbnail{width:400px}.floorplan-container-thumbnail .point{width:10px;height:10px}.floorplan-error{margin-bottom:20px;margin-left:50px;display:inline-block;height:100%}.floorplan-image{width:100%;display:inline-block;vertical-align:middle;background-repeat:no-repeat;background-size:contain;background-position:50%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.objects-list td:first-of-type{text-align:left}.live-stats-card{width:925px;background:#fff;box-shadow:20px 20px #e1e1e1;padding:12px 26px 20px;margin-left:50px;margin-bottom:50px}.live-stats-card td{border-top:none}.live-stats-heading{font-weight:700;font-size:16px}.sensor-color-note__td{position:relative;width:30px;min-width:10px}.hidden{display:none}.show-hide-details{width:105px}.point{z-index:3;background-color:#3cb449;width:12px;height:12px;position:absolute;border-radius:30px;transform:translate(-50%,-50%);transition:background-color .1s linear}.point.faulty{background-color:#1a237e}.point.unregistered{background-color:#795548}.point.inuse{background-color:#ef5350;-webkit-animation:pip .75s ease-out infinite;animation:pip .75s ease-out infinite}.point.standby{background-color:#eca657}.point:hover{cursor:pointer}.point.selected{box-shadow:0 0 10px 2px rgba(0,0,0,.8)}.point.pending{-webkit-animation:blinker 1.7s linear infinite;animation:blinker 1.7s linear infinite}@-webkit-keyframes blinker{50%{opacity:.4}}@keyframes blinker{50%{opacity:.4}}.circle{z-index:3;background-color:#3cb449;width:25px;height:25px;line-height:25px;position:absolute;border-radius:30px;text-align:center;vertical-align:middle;color:#eee;font-weight:700;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transform:translate(-50%,-50%)}.circle.faulty{background-color:#1a237e}.circle.unregistered{background-color:#795548}.circle.inuse{background-color:#ef5350;-webkit-animation:pipbig .75s ease-out infinite;animation:pipbig .75s ease-out infinite}.circle.standby{background-color:#eca657}.circle:hover{cursor:pointer}.circle.selected{-webkit-animation:fade .5s ease-out infinite;animation:fade .5s ease-out infinite}.sensor-heatnode{cursor:pointer;position:absolute;display:block;border-radius:50%;transform:translate(-50%,-50%);z-index:4;width:15px;height:15px;opacity:1;transition:opacity .3s ease,width .3s ease,height .3s ease}.sensor-heatnode:hover{z-index:5}.sensor-heatnode.heat-show-hidden{box-shadow:none!important;-webkit-animation:fadeHeatNodes .8s ease-in;animation:fadeHeatNodes .8s ease-in;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}@-webkit-keyframes fadeHeatNodes{0%{background-color:#212121}50%{background-color:#b3b3b3}to{background-color:#212121}}@keyframes fadeHeatNodes{0%{background-color:#212121}50%{background-color:#b3b3b3}to{background-color:#212121}}@-webkit-keyframes blink{0%{width:12px;height:12px}50%{width:16px;height:16px}to{width:12px;height:12px}}@keyframes blink{0%{width:12px;height:12px}50%{width:16px;height:16px}to{width:12px;height:12px}}@-webkit-keyframes pip{0%{transform:scale(1) translate(-50%,-50%)}50%{transform:scale(1.2) translate(-40%,-40%)}to{transform:scale(1) translate(-50%,-50%)}}@keyframes pip{0%{transform:scale(1) translate(-50%,-50%)}50%{transform:scale(1.2) translate(-40%,-40%)}to{transform:scale(1) translate(-50%,-50%)}}@-webkit-keyframes pipbig{0%{transform:scale(1) translate(-50%,-50%)}50%{transform:scale(1.05) translate(-47.5%,-47.5%)}to{transform:scale(1) translate(-50%,-50%)}}@keyframes pipbig{0%{transform:scale(1) translate(-50%,-50%)}50%{transform:scale(1.05) translate(-47.5%,-47.5%)}to{transform:scale(1) translate(-50%,-50%)}}@-webkit-keyframes fade{0%{opacity:.6}50%{opacity:1}to{opacity:.6}}@keyframes fade{0%{opacity:.6}50%{opacity:1}to{opacity:.6}}.maintenance-page{height:100vh;text-align:center;background-color:#fff;position:relative;background-image:url(/src/assets/images/server-bg.png);background-repeat:no-repeat;background-size:cover;background-position:50%;background-attachment:fixed}.maintenance-page .maintenance-container{display:inline-block;position:absolute;width:100%;max-width:800px;margin:auto;padding:0 12px;left:50%;top:50%;transform:translate(-50%,-50%)}.maintenance-page .maintenance-container .maintenance-img{width:100%;max-width:500px;min-width:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block}.maintenance-page .maintenance-container .maintenance-text{display:inline-block;margin-top:32px;color:#000;text-align:left}.maintenance-page .maintenance-container .maintenance-text h1{font-size:26px;color:#ef5350;margin-bottom:14px}.maintenance-page .maintenance-container .maintenance-text p{font-size:16px;margin-bottom:6px}.maintenance-page .maintenance-container .maintenance-text .social-container{text-align:center;margin-top:10px}.maintenance-page .maintenance-container .maintenance-text .social-container .social-icons{background-color:#fff;border-radius:2px;display:inline-block;width:48px;margin:16px;box-shadow:0 0 0 0 rgba(0,0,0,.6);transition:box-shadow .2s ease}.maintenance-page .maintenance-container .maintenance-text .social-container .social-icons:hover{box-shadow:4px 4px 0 0 rgba(0,0,0,.4)}.device-management-content{margin-bottom:50px}.device-management-content .row{padding-left:25px;padding-right:25px}.device-management-content .row:after,.device-management-content .row:before{display:inline-block}.device-management-content .popup-device-management{width:100%;padding:8px 14px;position:relative;box-shadow:0 2px 14px 0 rgba(0,0,0,.2);transition:all .6s linear;min-width:500px}.device-management-content .popup-device-management.popup-device-management_active{height:100%;display:flex;justify-content:center;align-items:center;transition:all .6s linear}.device-management-content .popup-device-management.popup-device-management_active h3{color:#fff;font-size:30px}.device-management-content .popup-device-management.popup-device-management_active p{color:#939598;font-size:20px;text-align:center}.device-management-content .popup-device-management h3{margin:20px 0;text-align:center;color:#939598}.device-management-content .popup-device-management table{border-collapse:collapse;width:100%}.device-management-content .popup-device-management table .header-tr{box-shadow:0 2px 15px 0 rgba(0,0,0,.15)}.device-management-content .popup-device-management table th{border:1px solid #c6c6c6;padding:8px;width:30%}.device-management-content .popup-device-management table th:first-of-type{width:unset}.device-management-content .popup-device-management table td{padding-left:4px;padding-right:4px;padding-bottom:0}.device-management-content .popup-device-management table td .parameter{margin:0;padding-left:5px;padding-right:5px;border:1px solid #c6c6c6;border-radius:0;width:100%;font-size:16px;font-weight:400;min-height:30px;display:flex;justify-content:center;align-content:center;word-break:break-word;align-items:center}.device-management-content .popup-device-management table td .parameter span{text-align:center}.device-management-content .popup-device-management table td .disabled{cursor:default;background:#e1e1e1}.device-management-content .popup-device-management table td input{margin:0;height:auto;padding-left:5px;padding-right:5px;border:1px solid #c6c6c6;border-radius:0;width:100%;font-size:16px}.device-management-content .popup-device-management .dev-manage-btn{margin-top:18px;display:block;float:right;padding:4px 18px;margin-bottom:18px;font-size:18px}.device-management-content .floorplan-outer-container.not-thumbnail_device-managment{margin-bottom:0;box-shadow:0 2px 14px 0 rgba(0,0,0,.2);width:925px}.device-management-content .floorplan-outer-container.not-thumbnail_device-managment .floorplan-container,.device-management-content .floorplan-outer-container.not-thumbnail_device-managment .floorplan-options-container{width:100%}.device-management-content .device-management-floorplan .selectbox-device{background-color:rgba(0,0,0,.2);border:2px solid #3cb449}.livefeed-page .page-content_livefeed{display:flex;justify-content:center;flex-direction:column;align-items:center;position:relative}.livefeed-page .page-content_livefeed .switch-tab{width:65%;height:40px;display:flex;justify-content:center;align-items:center;position:relative}.livefeed-page .page-content_livefeed .switch-tab .tab-divider{background:rgba(0,0,0,.3);height:100%;display:inline-flex;width:6px}.livefeed-page .page-content_livefeed .switch-tab span{cursor:pointer;display:inline-flex;height:100%;justify-content:center;align-items:center;width:calc(50% - 3px);transition:all .3s linear;color:#fff;font-size:14px;color:#000;background:#fff;transform:translateY(6px)}.livefeed-page .page-content_livefeed .switch-tab span.tab_active{color:#fff;background:#3cb449;transform:translateY(0)}.livefeed-page .page-content_livefeed .table-livefeed-wrapper{position:relative;width:100%;display:flex;justify-content:center;height:498px}.livefeed-page .page-content_livefeed .white-box-container_livefeed{width:65%;opacity:0;transition:opacity .4s linear;position:absolute;pointer-events:none}.livefeed-page .page-content_livefeed .white-box-container_livefeed_active{opacity:1;pointer-events:all}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body{max-height:80vh;overflow-y:auto;overflow-x:hidden}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .add-feed-modal .Select .Select-menu-outer{position:relative}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .add-feed-modal .Select .add-template{color:#3cb449;font-weight:700}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .add-feed-modal .add-template{color:#3cb449;font-weight:700;cursor:pointer}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .add-feed-modal .add-template:hover{color:#297b32}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .delete-template-modal ul{margin-top:12px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .modals__content__body .delete-template-modal ul li{list-style:disc}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-title{display:inline-block}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn{float:right;display:flex;align-items:center;transition:all .2s ease}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn .icon-addicon{font-size:27px;margin-right:8px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn:hover,.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn:hover .icon-addicon:before{color:#297b32}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn_disabled{cursor:not-allowed;color:#c6c6c6}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn_disabled:hover{color:#c6c6c6}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn_disabled svg{pointer-events:none}.livefeed-page .page-content_livefeed .white-box-container_livefeed .add-livefeed-btn_disabled svg g{stroke:#c6c6c6}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container{margin-top:12px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .rt-td:has(.livefeed-crud){padding:0}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .expand-btn{transition:all .4s ease-in-out}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .expand-btn_active{transform:scaleX(-1)}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .location-list{overflow-y:scroll;max-height:200px;padding:5px 35px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table input{width:100%}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-crud{display:inline-block;height:100%}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-crud .livefeed-child{width:50px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child{align-items:center;display:flex;height:100%;justify-content:center}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child a{color:#337ab7;cursor:pointer}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child a:hover{font-weight:700;color:#173853}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_name{padding-left:7px;justify-content:flex-start;color:#337ab7;cursor:pointer}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_name:hover,.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_name a:hover{font-weight:700;color:#173853}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child .ellipsis{font-size:16px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child .ellipsis:hover{font-weight:700}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_icons{justify-content:center;display:inline-flex}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_icons i{font-size:30px;cursor:pointer}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_icons:not(:last-child){border-right:1px solid rgba(0,0,0,.02)}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_disabled{cursor:not-allowed;display:inline-flex;height:100%}.livefeed-page .page-content_livefeed .white-box-container_livefeed .all-feed-container .livefeed-list-table .livefeed-child_disabled i{pointer-events:none;color:#c6c6c6}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form>div{margin-bottom:14px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form .input-current-container{overflow:auto;max-height:200px}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form .input-current-container .input-current-user{line-height:26px;font-size:14px;padding:0 4px;vertical-align:middle}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form .input-current-container .input-current-user:hover{background-color:#f2f2f2}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form .input-current-container .input-current-user i{line-height:26px;vertical-align:middle;color:#ef5350;float:right;font-size:16px;margin-left:8px;cursor:pointer}.livefeed-page .page-content_livefeed .white-box-container_livefeed .live-feed-form .input-current-container .input-current-user i:hover{color:#de1814}.template-editor-page .page-content_template-editor_padding{padding:60px 50px 70px;display:flex;justify-content:center;align-items:center}.template-editor-page .page-content_template-editor_padding .editor-box{padding:30px;margin-left:-20px}.template-editor-page .page-content_template-editor_padding .slide-preview{width:190px;display:inline-grid;vertical-align:middle}.template-editor-page .page-content_template-editor_padding .slide-preview .slide-scroll{max-height:calc(100vh - 437px);overflow-y:auto;overflow-x:hidden;padding-right:20px}.template-editor-page .page-content_template-editor_padding .slide-preview .slide-header{text-align:center;font-size:22px;font-weight:700;margin-bottom:4px}.template-editor-page .page-content_template-editor_padding .slide-preview .opacity-ghost{transition:all .18s ease;opacity:.8;transform:rotate(5deg);background-color:#6495ed;box-shadow:3px 3px 10px 3px rgba(0,0,0,.3);cursor:ns-resize}.template-editor-page .page-content_template-editor_padding .slide-preview .opacity-ghost-drop{opacity:1;transform:rotate(0deg);background-color:#fff;box-shadow:3px 3px 10px 3px transparent}.template-editor-page .page-content_template-editor_padding .slide-preview .drop-preview{background-color:rgba(150,150,200,.1);border:1px dashed #3cb449;margin:5px}.template-editor-page .page-content_template-editor_padding .slide-preview .column-drag-handle{position:absolute;left:0;cursor:move;padding:0 10px}.template-editor-page .page-content_template-editor_padding .slide-preview .slide{width:170px;height:95.625px;background-color:#f2f2f2;color:#585858;border:1px solid rgba(0,0,0,.2);text-align:center;vertical-align:middle;font-size:18px;position:relative;z-index:0;margin:0 0 10px;display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.template-editor-page .page-content_template-editor_padding .slide-preview .slide:hover{transition:all .2s linear;box-shadow:inset 0 0 0 1px #3cb449;cursor:pointer}.template-editor-page .page-content_template-editor_padding .slide-preview .slide.current{box-shadow:inset 0 0 0 2px #3cb449}.template-editor-page .page-content_template-editor_padding .slide-preview .slide_delete{position:absolute;top:5px;right:5px;font-size:18px;color:rgba(0,0,0,.5)}.template-editor-page .page-content_template-editor_padding .slide-preview .slide_delete:hover{color:#ef5350}.template-editor-page .page-content_template-editor_padding .slide-preview .slide_add{z-index:1}.template-editor-page .page-content_template-editor_padding .slide-preview .slide_add .icon-addicon{font-size:36px;position:absolute}.template-editor-page .page-content_template-editor_padding .slide-preview .slide_add:hover .icon-addicon:before{color:#297b32}.template-editor-page .livefeed-preview-wrapper,.template-editor-page .livefeed-preview-wrapper-scaleMode{padding-left:6px;margin-left:4px;height:456.75px;background-color:transparent;box-shadow:none;position:relative;display:inline-grid;vertical-align:middle;padding-top:6px;width:812px}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview,.template-editor-page .livefeed-preview-wrapper .livefeed-preview{width:800px;height:450px;position:relative;display:inline-block;box-shadow:0 4px 12px 1px rgba(0,0,0,.5)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-text-area_disable:after,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-text-area_disable:after{content:\"\";pointer-events:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable{width:100%;padding:5px;z-index:1;border:1px dotted #60aff4;box-sizing:border-box}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable_no_padding,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable_no_padding{padding:0;border:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable_location-list,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable_location-list{background:transparent}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable.entity-active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable.entity-active{box-shadow:0 3px 10px 0 #000;border:1px solid #60aff4;z-index:3;background:#fff}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable_bg,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable_bg{background-color:#fff;cursor:pointer!important}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .line-wrapper,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .line-wrapper,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper{width:100%;display:flex;justify-content:center;align-items:center}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper img,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper img{width:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn{font-family:GTWalsheimProBold;color:#4a4a4a;position:relative;overflow:hidden;cursor:pointer}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn input[type=file],.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn input[type=file]{display:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn label,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn label{margin:0;padding:0}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn i,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn i{cursor:pointer;margin-left:10px;display:inline-block}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn i:hover,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .logo-wrapper.upload-btn span:hover,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn i:hover,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .logo-wrapper.upload-btn span:hover{color:#000}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable.input-entity-active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable.input-entity-active{z-index:2}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable.input-entity-active input,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable.input-entity-active input{box-shadow:0 3px 10px 0 #000}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable input,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable input{position:absolute;color:#4a4a4a}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .measure,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable input,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .measure,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable input{padding:0 5px;font-size:2.3rem;white-space:pre;border:none;margin:0}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .measure,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .measure{color:transparent;background:transparent;left:-9999px;top:-9999px}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable input[disabled],.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable input[disabled]{background:hsla(0,0%,88%,.7)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable.editor-view_false,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .entity-resizable .editor-view_false input,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable.editor-view_false,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .entity-resizable .editor-view_false input{border-color:transparent;background:transparent}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane{height:100%;position:relative}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left{float:left}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview{position:absolute;z-index:0;display:flex;justify-content:center;align-items:center}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-container,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-container{overflow:hidden;text-align:center;position:relative;height:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-container .point,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-container .point{width:8px;height:8px;border-radius:50%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-container .point.inuse,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-container .point.inuse{-webkit-animation:none;animation:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-container .circle,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-container .circle{width:20px;height:20px;line-height:20px;border-radius:50%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-container .circle.inuse,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-container .circle.inuse{-webkit-animation:none;animation:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-no-scroll,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-no-scroll{display:inline-block;position:relative;height:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-no-scroll img,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-no-scroll img{height:100%;opacity:.7;max-width:100%;margin:auto;display:inline-block;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-scroll,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-scroll{position:relative}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-scroll img,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-scroll img{opacity:.7;overflow:hidden;display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-info,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-info{position:absolute;z-index:5;top:50%;transform:translateY(-50%);text-align:center;width:80%;margin:auto;white-space:normal;cursor:pointer;color:#fff;background-color:rgba(0,0,0,.5)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.left .floorplan-preview .floorplan-info:hover,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.left .floorplan-preview .floorplan-info:hover{color:#3cb449}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right{float:right}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container{display:flex;flex-wrap:wrap;justify-content:center;width:100%;position:relative;align-items:center}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container{text-align:center;vertical-align:middle;width:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-top,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-top{padding:0 10px;margin-bottom:10px}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label{transform:translateY(-10%)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-title,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-title,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label{position:relative;display:inline-block;transition:all .2s ease;cursor:pointer;padding:5px;line-height:100%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-title__editor-border,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__editor-border,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-title__editor-border,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__editor-border{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px dotted;display:block}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-title__editor-border_active,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__editor-border_active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-title__editor-border_active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__editor-border_active{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px solid}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-title__preview,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__preview,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-title__preview,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .gaugle-label__preview{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px dotted;border-color:transparent!important}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg{display:flex;align-items:center;position:relative;margin:auto;transition:all .2s ease;width:62%}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor{width:115%;height:110%;border-width:1px;border-style:dotted;position:absolute}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle{width:30%;position:absolute;transition:all .2s ease;display:inline-flex;justify-content:center;z-index:3;height:65%;top:0;left:35%;cursor:pointer}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle:hover,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle_active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle:hover,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .needle_active{background:hsla(0,0%,100%,.5)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect{height:100%;width:35%;position:absolute;right:0;top:0;z-index:3;transition:all .2s ease;cursor:pointer}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect:hover,.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect:hover,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_active{background:hsla(0,0%,100%,.5)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_occupied,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_occupied{left:0}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_occupied_active,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__editor .rect_occupied_active{background:hsla(0,0%,100%,.5)}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__preview,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .card-outer-container .card-container .card-svg__preview{width:115%;height:110%;border-width:1px;border-style:dotted;position:absolute;border-color:transparent!important}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .logo-outer-container,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .logo-outer-container{display:inline-block;text-align:center;width:100%;position:absolute;left:0}.template-editor-page .livefeed-preview-wrapper-scaleMode .livefeed-preview .pane.right .logo-outer-container img,.template-editor-page .livefeed-preview-wrapper .livefeed-preview .pane.right .logo-outer-container img{vertical-align:middle;display:inline-block}.template-editor-page .dropdown-save .dropdown__items{width:132px;margin-left:-20px}.template-editor-page .save-form{white-space:normal}.template-editor-page .save-form>div{margin-bottom:20px}.template-editor-page .save-form .input-label{display:block}.template-editor-page .save-form .save-note.bad{color:#ef5350}.template-editor-page .save-form .save-note.good{color:#36a141}.template-editor-page .save-form .save-point{display:block;margin-top:6px;margin-left:6px}.template-editor-page .save-form .save-point i{font-size:20px;margin-right:4px}.template-editor-page .save-form .save-point.bad i{color:#ffb347}.template-editor-page .save-form .save-point.good i{color:#3cb449}.reactSelect-dropdown-wrapper .reactSelect-fontFamily-dropdown .Select-menu-outer{z-index:7091}.reactSelect-dropdown-wrapper .Select .Select-control{border-radius:0}.reactSelect-dropdown-wrapper .Select .Select-control .Select-placeholder{padding-right:20px;color:#3f5043}.reactSelect-dropdown-wrapper .Select .Select-option{color:#3f5043;transition:all .2s}.reactSelect-dropdown-wrapper .Select .Select-option.is-focused{background:none;color:#3f5043}.reactSelect-dropdown-wrapper .Select .Select-option:hover{color:#fff;font-weight:700;background:#3cb449}.reactSelect-dropdown-wrapper_disable{cursor:not-allowed}.reactSelect-dropdown-wrapper_disable .Select{width:120px}.reactSelect-dropdown-wrapper_disable .Select .Select-control{cursor:not-allowed;pointer-events:none}.reactSelect-dropdown-wrapper_disable .Select .Select-control .Select-placeholder,.reactSelect-dropdown-wrapper_disable:hover{color:#aaa}", ""]);
	
	// exports


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReactTable{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border:1px solid rgba(0,0,0,.1)}.ReactTable *{box-sizing:border-box}.ReactTable .rt-table{-ms-flex:auto 1;flex:auto 1;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto}.ReactTable .rt-table,.ReactTable .rt-thead{-webkit-box-flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal}.ReactTable .rt-thead{-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ReactTable .rt-thead.-headerGroups{background:rgba(0,0,0,.03)}.ReactTable .rt-thead.-filters,.ReactTable .rt-thead.-headerGroups{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-thead.-filters input,.ReactTable .rt-thead.-filters select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline-width:0}.ReactTable .rt-thead.-filters .rt-th{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-thead.-header{box-shadow:0 2px 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-thead .rt-tr{text-align:center}.ReactTable .rt-thead .rt-td,.ReactTable .rt-thead .rt-th{padding:5px;line-height:normal;position:relative;border-right:1px solid rgba(0,0,0,.05);transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);box-shadow:inset 0 0 0 0 transparent}.ReactTable .rt-thead .rt-td.-sort-asc,.ReactTable .rt-thead .rt-th.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-sort-desc,.ReactTable .rt-thead .rt-th.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-cursor-pointer,.ReactTable .rt-thead .rt-th.-cursor-pointer{cursor:pointer}.ReactTable .rt-thead .rt-td:last-child,.ReactTable .rt-thead .rt-th:last-child{border-right:0}.ReactTable .rt-thead .rt-th:focus{outline-width:0}.ReactTable .rt-thead .rt-resizable-header{overflow:visible}.ReactTable .rt-thead .rt-resizable-header:last-child{overflow:hidden}.ReactTable .rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis}.ReactTable .rt-thead .rt-header-pivot{border-right-color:#f7f7f7}.ReactTable .rt-thead .rt-header-pivot:after,.ReactTable .rt-thead .rt-header-pivot:before{left:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.ReactTable .rt-thead .rt-header-pivot:after{border-color:hsla(0,0%,100%,0);border-left-color:#fff;border-width:8px;margin-top:-8px}.ReactTable .rt-thead .rt-header-pivot:before{border-color:hsla(0,0%,40%,0);border-left-color:#f7f7f7;border-width:10px;margin-top:-10px}.ReactTable .rt-tbody{-webkit-box-flex:99999;-ms-flex:99999 1 auto;flex:99999 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto}.ReactTable .rt-tbody .rt-tr-group{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tbody .rt-tr-group:last-child{border-bottom:0}.ReactTable .rt-tbody .rt-td{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-tbody .rt-td:last-child{border-right:0}.ReactTable .rt-tbody .rt-expandable{cursor:pointer;text-overflow:clip}.ReactTable .rt-tr-group{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.ReactTable .rt-tr{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ReactTable .rt-td,.ReactTable .rt-th{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:.3s ease;transition-property:width,min-width,padding,opacity}.ReactTable .rt-td.-hidden,.ReactTable .rt-th.-hidden{width:0!important;min-width:0!important;padding:0!important;border:0!important;opacity:0!important}.ReactTable .rt-expander{display:inline-block;position:relative;margin:0;color:transparent;margin:0 10px}.ReactTable .rt-expander:after{content:\"\";position:absolute;width:0;height:0;top:50%;left:50%;-webkit-transform:translate(-50%,-50%) rotate(-90deg);transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,.8);transition:all .3s cubic-bezier(.175,.885,.32,1.275);cursor:pointer}.ReactTable .rt-expander.-open:after{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}.ReactTable .rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10}.ReactTable .rt-tfoot{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-tfoot .rt-td{border-right:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tfoot .rt-td:last-child{border-right:0}.ReactTable.-striped .rt-tr.-odd{background:rgba(0,0,0,.03)}.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{background:rgba(0,0,0,.05)}.ReactTable .-pagination{z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:3px;box-shadow:0 0 15px 0 rgba(0,0,0,.1);border-top:2px solid rgba(0,0,0,.1)}.ReactTable .-pagination input,.ReactTable .-pagination select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline-width:0}.ReactTable .-pagination .-btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,.6);background:rgba(0,0,0,.1);transition:all .1s ease;cursor:pointer;outline-width:0}.ReactTable .-pagination .-btn[disabled]{opacity:.5;cursor:default}.ReactTable .-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,.3);color:#fff}.ReactTable .-pagination .-next,.ReactTable .-pagination .-previous{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.ReactTable .-pagination .-center{-webkit-box-flex:1.5;-ms-flex:1.5;flex:1.5;text-align:center;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.ReactTable .-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap}.ReactTable .-pagination .-pageJump{display:inline-block}.ReactTable .-pagination .-pageJump input{width:70px;text-align:center}.ReactTable .-pagination .-pageSizeOptions{margin:3px 10px}.ReactTable .rt-noData{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:1;padding:20px;color:rgba(0,0,0,.5)}.ReactTable .-loading,.ReactTable .rt-noData{display:block;position:absolute;background:hsla(0,0%,100%,.8);transition:all .3s ease;pointer-events:none}.ReactTable .-loading{left:0;right:0;top:0;bottom:0;z-index:-1;opacity:0}.ReactTable .-loading>div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,.6);-webkit-transform:translateY(-52%);transform:translateY(-52%);transition:all .3s cubic-bezier(.25,.46,.45,.94)}.ReactTable .-loading.-active{opacity:1;z-index:2;pointer-events:all}.ReactTable .-loading.-active>div{-webkit-transform:translateY(50%);transform:translateY(50%)}.ReactTable .rt-resizing .rt-td,.ReactTable .rt-resizing .rt-th{transition:none!important;cursor:col-resize;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
	
	// exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;-moz-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(384) + ");src:url(" + __webpack_require__(384) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(385) + ") format(\"woff2\"),url(" + __webpack_require__(386) + ") format(\"woff\"),url(" + __webpack_require__(387) + ") format(\"truetype\"),url(" + __webpack_require__(388) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;-webkit-box-shadow:none;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;background-image:none;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary:hover{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;background-image:none;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success:hover{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;background-image:none;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;background-image:none;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;background-image:none;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;background-image:none;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-right:15px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out,-o-transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:12px;filter:alpha(opacity=0);opacity:0}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover>.arrow{border-width:11px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out,-o-transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;filter:alpha(opacity=90);opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46661d6d65debc63884004fed6e37e5c.svg";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80);line-height:1}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}.rtl .toast-close-button{left:-.3em;float:left;right:.3em}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999;pointer-events:none}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{position:relative;pointer-events:auto;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;background-position:15px;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>div.rtl{direction:rtl;padding:15px 50px 15px 15px;background-position:right 15px center}#toast-container>div:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-center>div,#toast-container.toast-top-center>div{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}@media (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}#toast-container>div.rtl{padding:15px 50px 15px 15px}}", ""]);
	
	// exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", ""]);
	
	// exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".slick-loading .slick-list{background:#fff url(" + __webpack_require__(393) + ") 50% no-repeat}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(" + __webpack_require__(394) + ");src:url(" + __webpack_require__(394) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(395) + ") format(\"woff\"),url(" + __webpack_require__(396) + ") format(\"truetype\"),url(" + __webpack_require__(397) + "#slick) format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;opacity:.75;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\2190\"}[dir=rtl] .slick-prev:before{content:\"\\2192\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\2192\"}[dir=rtl] .slick-next:before{content:\"\\2190\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}", ""]);
	
	// exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "68b0c4fcb84d239f261c1a5e65818142.gif";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ced611daf7709cc778da928fec876475.eot";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,d09GRk9UVE8AAAVkAAsAAAAAB1wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAABCAAAAi4AAAKbH/pWDkZGVE0AAAM4AAAAGgAAABxt0civR0RFRgAAA1QAAAAcAAAAIAAyAARPUy8yAAADcAAAAFIAAABgUBj/rmNtYXAAAAPEAAAAUAAAAWIiC0SwaGVhZAAABBQAAAAuAAAANgABMftoaGVhAAAERAAAABwAAAAkA+UCA2htdHgAAARgAAAADgAAAA4ESgBKbWF4cAAABHAAAAAGAAAABgAFUABuYW1lAAAEeAAAANwAAAFuBSeBwnBvc3QAAAVUAAAAEAAAACAAAwABeJw9ks9vEkEUx2cpWyeUoFYgNkHi2Wt7N3rVm3cTs3UVLC4LxIWEQvi1P3i7O1tYLJDAmlgKGEhQrsajf0j7J3jYTXrQWUrMJG+++b55n5e8NwwKBhHDMLv5kxT3ATEBxKBn3qOAl9zxHgb1MAPhHQgHkyF08Gr/L8B/Eb6zWnmCJ7AJVLubQOheArXvJ1A4EXi6j4I+Zg9F0QFKvsnlBCmXeve+sFEnb/nCptdtQ4QYhVFRAT1HrF8UQK/RL/SbmUbclsvGVFXRZKDHUE38cc4qpkbAAsuwiImvro+ufcfaOIQ6szlrmjRJDaKZKnbjN3GWKIbiIzRFUfCffuxxKOL+3LDlDVvx2TdxN84qZEsnhNBa6pgm2dAsnzbLsETdsmRFxUeHV4e+I2/ptN8TyqV8T3Dt29t7EYOuajVIw2y1Wy3M86w0zg/Fz2IvawmQAUHOVrPVfLkoScVynsqsTG0MGUs4z55nh3mnOJa+li+rl9WpPIcFfDubDeaDC+fLBdYN3QADzLauGfj4B6sZmq6CCpqmtSvF0qlUl2qf5AJIUCSlTqlb7lUG+LRfGzZGzZEyBgccMu6MuqPecNDvD4Y9Kjtj4gD+DsvKVMTcMdtqtZtmkzQstQvYje7Syep0PDSAhSOeHYXYWThEF//A/0YvYV1fSQtpKU5STtrhbQ444OtpKSWJIg3pOg8cBs7maTY1EZf07aq+hjWs7IWzdCYTGhb2CtZ47x+Uhx28AAB4nGNgYGBkAIJz765vANHnCyvqYTQAWnkHswAAeJxjYGRgYOADYgkGEGBiYARCFjAG8RgABHYAN3icY2BmYmCcwMDKwMHow5jGwMDgDqW/MkgytDAwMDGwcjKAQQMDAyOQUmCAgoA01xQGB4ZExUmMD/4/YNBjvP3/NgNEDQPjbbBKBQZGADfLDgsAAHicY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQzMCQqKClOUJz0/z9YHRLv/+L7D+8V3cuHmgAHjGwM6ELUByxUMIOZCmbgAAA5LQ8XeJxjYGRgYABiO68w73h+m68M3EwMIHC+sKIeTqsyqDLeZrwN5HIwgKUB/aYJUgAAeJxjYGRgYLzNwMCgx8QAAkA2IwMqYAIAMGIB7QIAAAACAAAlACUAJQAlAAAAAFAAAAUAAHicbY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV4nGNgZkAGjAxoAAAAjgAF"

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d41f55a78e6f49a5512878df1737e58a.ttf";

/***/ }),
/* 397 */
388,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "797bcd86f3ed9b7d70f260c9bc27b26f.eot";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22d4c95c8961c976d4df945b3564cd87.woff";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b5f81509d576b9d80df256b1f9a5943.ttf";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fc00a347b85e6074fbd0c40208ba271.eot";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0590abfab50c58b19845d45a039c430b.woff";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b12f165f887adde4d4ac9362603489d.ttf";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "225d27daa435181537351b18f1dfdd04.eot";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7049acb0cb69a64c06bd37bd2f5ffe34.woff";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abace7c4c10633419a04871934226bac.ttf";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42f5fa1bb3054e6de4605adea8a1e86c.eot";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dffb37a0bb01626e43c30095a6ebce7d.ttf";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7e1bd167e12e6714780fec7ca22fc0ed.woff";

/***/ }),
/* 410 */
388,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Loading = function Loading() {
	    function renderDivs() {
	        var array = [];
	        for (var i = 0; i < 12; i++) {
	            array.push(_react2["default"].createElement("div", { key: i }));
	        }
	        return array;
	    }
	    function renderLoader() {
	
	        return _react2["default"].createElement(
	            "div",
	            { style: {
	                    height: "100vh",
	                    width: "100vw",
	                    display: 'flex',
	                    alignSelf: 'center',
	                    alignItems: 'center',
	                    justifyContent: 'center',
	                    zIndex: 9999
	                } },
	            _react2["default"].createElement(
	                "div",
	                { className: "lds-spinner", style: { transform: "translate(-50%,-50%)" } },
	                renderDivs()
	            )
	        );
	    }
	    return _react2["default"].createElement(
	        _react.Fragment,
	        null,
	        renderLoader()
	    );
	};
	
	exports["default"] = Loading;
	module.exports = exports["default"];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _containersTree = __webpack_require__(414);
	
	var _containersTree2 = _interopRequireDefault(_containersTree);
	
	var _componentsCommonSearchbardropdown = __webpack_require__(416);
	
	var _componentsCommonSearchbardropdown2 = _interopRequireDefault(_componentsCommonSearchbardropdown);
	
	var _componentsCommonAppheader = __webpack_require__(433);
	
	var _componentsCommonAppheader2 = _interopRequireDefault(_componentsCommonAppheader);
	
	var ToolBar = (function (_React$Component) {
	    _inherits(ToolBar, _React$Component);
	
	    function ToolBar(props, context) {
	        _classCallCheck(this, ToolBar);
	
	        _get(Object.getPrototypeOf(ToolBar.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            showLocation: false,
	            showSetting: false,
	            searchActive: false
	        };
	    }
	
	    _createClass(ToolBar, [{
	        key: 'closeAll',
	        value: function closeAll() {
	            this.setState({
	                showLocation: false,
	                showSetting: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _componentsCommonAppheader2['default'],
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'header-items' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'header-items__location display--flex__flex--start--center' },
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    _this.setState({ showLocation: true });
	                                },
	                                className: 'header-btn justify-center cursor--pointer' },
	                            _react2['default'].createElement('span', { className: 'font-icon icon-location-hamburger' }),
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'header-btn__label font--bold' },
	                                this.props.tree.info.name
	                            )
	                        ),
	                        this.state.showLocation && _react2['default'].createElement(
	                            'div',
	                            { className: 'header-items__location__dropdown-root' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'location-dropdown-search-container' },
	                                _react2['default'].createElement(_componentsCommonSearchbardropdown2['default'], {
	                                    querySettings: this.props.querySettings,
	                                    onChange: function (node) {
	                                        _this.props.statistic(node);_this.closeAll();
	                                    },
	                                    onFocus: function () {},
	                                    onClose: function () {},
	                                    tree: this.props.tree
	                                })
	                            ),
	                            _react2['default'].createElement(_containersTree2['default'], { tree: this.props.tree, statistic: function (node) {
	                                    _this.props.statistic(node);_this.closeAll();
	                                } })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'header-items__logo justify-center cursor--pointer' },
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { to: '/' },
	                            _react2['default'].createElement('img', { src: 'src/assets/icons/senzolive-software-logo.svg', alt: 'SenzoLive' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'header-items__user-setting overwrite--modal--depth display--flex__flex--end--center' },
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    _this.setState({ showSetting: true });
	                                },
	                                className: 'header-btn justify-center cursor--pointer' },
	                            _react2['default'].createElement(
	                                'span',
	                                { style: { marginRight: 10 }, className: 'header-btn__label font--bold' },
	                                this.props.user.firstname + " " + this.props.user.lastname
	                            ),
	                            _react2['default'].createElement('span', { className: 'font-icon icon-user-settings' })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'dropdown-list ' + (this.state.showSetting ? "dropdown-list_show" : "") },
	                            _react2['default'].createElement(
	                                'ul',
	                                null,
	                                _react2['default'].createElement(
	                                    'li',
	                                    null,
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { to: '/settings/ownaccount', onClick: function () {
	                                                _this.closeAll();
	                                            } },
	                                        'Own Account'
	                                    )
	                                ),
	                                this.props.user.role == "ADMIN" && _react2['default'].createElement(
	                                    'li',
	                                    null,
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { to: '/user', onClick: function () {
	                                                _this.closeAll();
	                                            } },
	                                        'User Administration'
	                                    )
	                                ),
	                                this.props.user.role == "ADMIN" ? [_react2['default'].createElement(
	                                    'li',
	                                    { key: '0' },
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: 'locations' },
	                                        'Locations Settings'
	                                    )
	                                ), _react2['default'].createElement(
	                                    'li',
	                                    { key: '1' },
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: '/settings/sensor' },
	                                        'Sensor Settings'
	                                    )
	                                ), _react2['default'].createElement(
	                                    'li',
	                                    { key: '2' },
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: '/api' },
	                                        'SenzoAPI'
	                                    )
	                                ), _react2['default'].createElement(
	                                    'li',
	                                    { key: '3' },
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: '/settings/default' },
	                                        'Default Settings'
	                                    )
	                                )] : null,
	                                _react2['default'].createElement(
	                                    'li',
	                                    { key: '4' },
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: '/livefeed' },
	                                        'Livefeed'
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'li',
	                                    null,
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { onClick: function () {
	                                                _this.closeAll();
	                                            }, to: '/faq' },
	                                        'FAQ'
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'li',
	                                    null,
	                                    _react2['default'].createElement(
	                                        _reactRouter.Link,
	                                        { className: 'cursor--pointer', onClick: this.props.actions.logout },
	                                        'Log Out'
	                                    )
	                                )
	                            )
	                        ),
	                        (this.state.showLocation || this.state.showSetting) && _react2['default'].createElement('div', { className: "modals__overlay" + (this.state.showLocation || this.state.showSetting ? " open" : " closed"), onClick: this.closeAll.bind(this) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ToolBar;
	})(_react2['default'].Component);
	
	exports.ToolBar = ToolBar;
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        tree: state.overviewReducer.customerOverview,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToolBar);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _containersNode = __webpack_require__(415);
	
	var _containersNode2 = _interopRequireDefault(_containersNode);
	
	var Tree = (function (_React$Component) {
	    _inherits(Tree, _React$Component);
	
	    function Tree(props, context) {
	        _classCallCheck(this, Tree);
	
	        _get(Object.getPrototypeOf(Tree.prototype), 'constructor', this).call(this, props, context);
	        this.state = { show: true };
	    }
	
	    _createClass(Tree, [{
	        key: 'openChildren',
	        value: function openChildren() {
	            if (!this.state.show) {
	                this.setState({ show: true });
	            }
	        }
	    }, {
	        key: 'onClose',
	        value: function onClose() {
	            this.setState({ show: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var childNodes;
	            var className = "dropdown-container";
	            var self = this;
	            var showAllNodes = this.props.showAllNodes;
	            if (this.props.tree.children != null && this.props.tree.type != 'meeting_room' && this.props.tree.type != 'open_area') {
	                if (this.props.tree.children.length > 7) {
	                    className = "dropdown-container dropdown-scroll";
	                }
	                childNodes = this.props.tree.children.map(function (node, index) {
	                    return _react2['default'].createElement(
	                        _containersNode2['default'],
	                        { showAllNodes: showAllNodes, node: node, key: index, statistic: self.props.statistic.bind(self) },
	                        _react2['default'].createElement(Tree, { statistic: self.props.statistic.bind(self), tree: node })
	                    );
	                });
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: className },
	                this.state.show && childNodes
	            );
	        }
	    }]);
	
	    return Tree;
	})(_react2['default'].Component);
	
	exports['default'] = Tree;
	module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Node = (function (_React$Component) {
	    _inherits(Node, _React$Component);
	
	    function Node(props, context) {
	        _classCallCheck(this, Node);
	
	        _get(Object.getPrototypeOf(Node.prototype), "constructor", this).call(this, props, context);
	        this.state = {
	            show: false,
	            icon: "add_circle_outline",
	            className: ""
	        };
	    }
	
	    _createClass(Node, [{
	        key: "toggleChildren",
	        value: function toggleChildren() {
	            if (!this.state.show) {
	                this.setState({
	                    show: true,
	                    icon: "remove_circle_outline",
	                    className: "dropdown--active"
	                });
	            } else {
	                this.setState({
	                    show: false,
	                    icon: "add_circle_outline",
	                    className: ""
	                });
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.showAllNodes !== nextProps.showAllNodes && nextProps.showAllNodes === false) {
	                this.setState({
	                    show: false,
	                    icon: "add_circle_outline",
	                    className: ""
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this = this;
	
	            var renderChild = this.props.node.type == "location" || this.props.node.type == "customer" || this.props.node.type == "multicountry";
	            return _react2["default"].createElement(
	                "div",
	                { className: "dropdown-div" },
	                _react2["default"].createElement(
	                    "a",
	                    { onClick: function () {
	                            _this.props.statistic(_this.props.node);
	                        } },
	                    this.props.node.info.name
	                ),
	                renderChild && this.props.node.children.length > 0 && _react2["default"].createElement(
	                    "i",
	                    { onClick: this.toggleChildren.bind(this), className: this.state.className + " dropdown-button material-icons cursor--pointer" },
	                    this.state.icon
	                ),
	                this.state.show && this.props.children
	            );
	        }
	    }]);
	
	    return Node;
	})(_react2["default"].Component);
	
	exports["default"] = Node;
	module.exports = exports["default"];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	/* This component is used in
	components/pages/comparison/comparisoncard/index.jsx
	components/pages/overview/searchcontainer.jsx
	containers/toolbar.jsx
	*/
	var constructOptions = function constructOptions(tree, options) {
	    if (tree.type !== 'customer') {
	        options.push({ label: tree.info.name, values: tree });
	    }
	    if (tree.children && tree.type !== 'meeting_room' && tree.type !== 'open_area') {
	        tree.children.forEach(function (element) {
	            if (element.type !== "sensor") {
	                constructOptions(element, options);
	            }
	        });
	    }
	};
	var SearchBarDropDown = function SearchBarDropDown(props) {
	    var options = [];
	    constructOptions(props.tree, options);
	
	    return _react2['default'].createElement(_reactSelect2['default'], {
	        options: options,
	        onBlurResetsInput: true,
	        onSelectResetsInput: true,
	        onChange: function (val) {
	            props.onChange(val.values);
	        },
	        onOpen: props.onOpen,
	        onFocus: props.onFocus,
	        onClose: props.onClose,
	        placeholder: 'Search...',
	        value: props.value,
	        clearable: false,
	        openOnFocus: true,
	        openOnClick: true
	    });
	};
	
	exports['default'] = SearchBarDropDown;
	module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(418);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(430);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(431);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(432);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(429);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(427);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(426);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(421);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(422);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(423);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(419);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _defaultArrowRenderer = __webpack_require__(421);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(422);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(423);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(426);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(427);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(429);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(424);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(425);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(428);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(418);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(424);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(430);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(432);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(418);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(423);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(426);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(418);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var AppHeader = (function (_Component) {
	    _inherits(AppHeader, _Component);
	
	    function AppHeader(props, context) {
	        _classCallCheck(this, AppHeader);
	
	        _get(Object.getPrototypeOf(AppHeader.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            headerClass: "app_header",
	            spacingClass: false
	        };
	    }
	
	    _createClass(AppHeader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkStatic();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            this.checkStatic();
	        }
	    }, {
	        key: 'checkStatic',
	        value: function checkStatic() {
	            var comparisonPage = window.location.href.split('#')[1].match(/^\/comparison\/$/ig);
	            var overviewPage = window.location.href.split('#')[1].match(/^\/$/ig);
	            if (comparisonPage || overviewPage) {
	                this.setState({
	                    headerClass: "app_header app_header--sticky",
	                    spacingClass: true
	                });
	            } else {
	                this.setState({
	                    headerClass: "app_header",
	                    spacingClass: false
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { id: 'app-header-id', className: this.state.headerClass },
	                    this.props.children
	                ),
	                this.state.spacingClass && _react2['default'].createElement('div', { className: 'app_header--spacing-active' })
	            );
	        }
	    }]);
	
	    return AppHeader;
	})(_react.Component);
	
	exports['default'] = AppHeader;
	module.exports = exports['default'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	// This component is used in frame.jsx
	
	var ScrollTop = (function (_React$Component) {
	    _inherits(ScrollTop, _React$Component);
	
	    function ScrollTop(props) {
	        var _this = this;
	
	        _classCallCheck(this, ScrollTop);
	
	        _get(Object.getPrototypeOf(ScrollTop.prototype), "constructor", this).call(this, props);
	        this.state = {
	            show: false
	        };
	        this.checkScroll = this.checkScroll.bind(this);
	        this.scrollToTop = function () {
	            var c = document.documentElement.scrollTop || document.body.scrollTop;
	            if (c > 0) {
	                window.requestAnimationFrame(_this.scrollToTop);
	                window.scrollTo(0, c - c / 8);
	            }
	        };
	    }
	
	    _createClass(ScrollTop, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            window.addEventListener("scroll", this.checkScroll);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener("scroll", this.checkScroll);
	        }
	    }, {
	        key: "checkScroll",
	        value: function checkScroll() {
	            var show;
	            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	                show = true;
	            } else {
	                show = false;
	            }
	            this.setState({
	                show: show
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2["default"].createElement(
	                "div",
	                { className: (this.state.show ? "scroll--show" : "") + " scroll-top-button", onClick: this.state.show ? function () {
	                        _this2.scrollToTop();
	                    } : null },
	                _react2["default"].createElement("img", { src: "src/assets/icons/baseline-keyboard_arrow_up-24px.svg", alt: "toTopArrowUp" })
	            );
	        }
	    }]);
	
	    return ScrollTop;
	})(_react2["default"].Component);
	
	exports["default"] = ScrollTop;
	module.exports = exports["default"];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports.requireAuthentication = requireAuthentication;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	function requireAuthentication(Component) {
	  var AuthenticatedComponent = (function (_React$Component) {
	    _inherits(AuthenticatedComponent, _React$Component);
	
	    function AuthenticatedComponent() {
	      _classCallCheck(this, AuthenticatedComponent);
	
	      _get(Object.getPrototypeOf(AuthenticatedComponent.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(AuthenticatedComponent, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.checkAuth();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps() {
	        this.checkAuth();
	      }
	    }, {
	      key: 'checkAuth',
	      value: function checkAuth() {
	        var token = this.props.token;
	        var localToken = localStorage.token;
	
	        var apikey = this.props.location.query["apikey"];
	        var localApikey = localStorage.apikey;
	        var hasAPIKey = apikey && apikey.length > 0 || localApikey && localApikey.length > 0;
	        var hasToken = !(token == undefined || token === null || localToken == undefined || localToken === null);
	        if (!hasToken && !hasAPIKey) {
	          this.props.dispatch((0, _actionsAuthentication.redirectToLogin)());
	          console.log("token", token);
	          console.log("localToken", localToken);
	          console.log("apikey", apikey);
	          console.log("localApikey", localApikey);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2['default'].createElement(
	          _react2['default'].Fragment,
	          null,
	          _react2['default'].createElement(Component, this.props)
	        );
	      }
	    }]);
	
	    return AuthenticatedComponent;
	  })(_react2['default'].Component);
	
	  var mapStateToProps = function mapStateToProps(state) {
	    return {
	      token: state.authReducer.token
	    };
	  };
	
	  function mapDispatchToProps(dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }
	
	  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);
	}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.roleBasedRoute = roleBasedRoute;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonAppHistory = __webpack_require__(85);
	
	var _componentsCommonAppHistory2 = _interopRequireDefault(_componentsCommonAppHistory);
	
	function roleBasedRoute(Component) {
	
	    var RoleBasedRouteComponent = function RoleBasedRouteComponent(props) {
	        var user = (0, _reactRedux.useSelector)(function (state) {
	            return state.myAccountReducer.user;
	        });
	        var tree = (0, _reactRedux.useSelector)(function (state) {
	            return state.overviewReducer.customerOverview;
	        });
	        var devicemanagementPage = window.location.href.split('#')[1].match(/^\/devicemanagement\//ig);
	        var isDeviceManPage = false;
	        if (devicemanagementPage) {
	            '/devicemanagement/' === devicemanagementPage[0] && (isDeviceManPage = true);
	        }
	        // role based authenticated route check
	        _react2['default'].useEffect(function () {
	            // Allow access to DeviceManagementPage only for Company administrator
	            // Only Company administrator will receive tree has type "customer"
	            if (isDeviceManPage && tree.type !== "customer") {
	                _componentsCommonAppHistory2['default'].push({
	                    pathname: '/'
	                });
	            }
	            // is local user ?
	            if (user.role !== _config2['default'].roles[0].rolecode) {
	                _componentsCommonAppHistory2['default'].push({
	                    pathname: '/'
	                });
	            }
	        }, [user, isDeviceManPage, tree.type]);
	
	        return _react2['default'].createElement(
	            _react2['default'].Fragment,
	            null,
	            _react2['default'].createElement(Component, props)
	        );
	    };
	    return RoleBasedRouteComponent;
	}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    _get(Object.getPrototypeOf(Login.prototype), 'constructor', this).call(this);
	    this.submit = this.submit.bind(this);
	    this.displayName = 'Login-Page';
	    this.state = { username: '', password: '' };
	  }
	
	  _createClass(Login, [{
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var key = e.target.id;
	      var value = e.target.value;
	      this.setState(_defineProperty({}, key, value));
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      if (e.key === 'Enter') {
	        this.submit();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'authentication-wrapper' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'authentication__card box--shadow bg--white text--center' },
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            _react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg', className: 'authentication__card__logo' })
	          ),
	          _react2['default'].createElement(
	            'h2',
	            { className: 'authentication__card__welcome-message' },
	            'Welcome to your dashboard'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'authentication__card__form-wrapper' },
	            _react2['default'].createElement(
	              'form',
	              { action: '#' },
	              _react2['default'].createElement('input', { type: 'username', id: 'username', placeholder: 'Username', onKeyDown: this.handleKeyDown.bind(this), onChange: this.handleChange.bind(this), required: true }),
	              _react2['default'].createElement('input', { type: 'password', placeholder: 'Password', id: 'password', onKeyDown: this.handleKeyDown.bind(this), onChange: this.handleChange.bind(this), required: true }),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement('input', { className: 'btn-small form__login-btn', type: 'button', name: 'user_submit', value: 'Log in', onClick: this.submit }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'red-500' },
	                this.props.auth.errorMessage
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'forgot-password' },
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { to: '/forgot' },
	                  ' Forgot your password?'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.props.dispatch((0, _actionsAuthentication.login)(this.state));
	    }
	  }]);
	
	  return Login;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.authReducer
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _reactRecaptcha = __webpack_require__(439);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var ForgotForm = (function (_React$Component) {
	  _inherits(ForgotForm, _React$Component);
	
	  function ForgotForm() {
	    _classCallCheck(this, ForgotForm);
	
	    _get(Object.getPrototypeOf(ForgotForm.prototype), 'constructor', this).call(this);
	    this.submit = this.submit.bind(this);
	    this.displayName = 'LoginPage';
	    this.state = { username: '', response: null };
	  }
	
	  _createClass(ForgotForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Sending email failed
	      if (this.props.auth.sendResetPWInProgress && !nextProps.auth.sendResetPWInProgress && !nextProps.auth.sendResetPWDone) {
	        this.recaptcha.reset();
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var key = e.target.id;
	      var value = e.target.value;
	      this.setState(_defineProperty({}, key, value));
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      if (e.key === 'Enter') {
	        this.submit();
	      }
	    }
	  }, {
	    key: 'verified',
	    value: function verified(response) {
	      this.setState({ response: response });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var done = !this.props.auth.sendResetPWInProgress && this.props.auth.sendResetPWDone;
	      var waiting = this.props.auth.sendResetPWInProgress && !this.props.auth.sendResetPWDone;
	      return _react2['default'].createElement(
	        'div',
	        { className: 'authentication-wrapper' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'authentication__card box--shadow bg--white text--center' },
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            _react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg', className: 'authentication__card__logo' })
	          ),
	          _react2['default'].createElement(
	            'h2',
	            { className: 'authentication__card__welcome-message' },
	            'Welcome to SenzoLive software'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'authentication__card__form-wrapper' },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              'Reset Password'
	            ),
	            !done ? _react2['default'].createElement(
	              'form',
	              null,
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement('input', { type: 'username', id: 'username', placeholder: 'Username', onKeyDown: this.handleKeyDown.bind(this), onChange: this.handleChange.bind(this), required: true }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'form__reset-pw-recaptcha' },
	                _react2['default'].createElement(_reactRecaptcha2['default'], {
	                  ref: function (e) {
	                    return _this.recaptcha = e;
	                  },
	                  sitekey: '6LefkksUAAAAALFa1vdNevTFeJF7Q_C8U0o_IKYj',
	                  verifyCallback: function (response) {
	                    return _this.verified(response);
	                  }
	                })
	              ),
	              _react2['default'].createElement('input', { className: 'btn-small form__authentication-btn', type: 'button', name: 'user_submit', value: waiting ? "Please wait..." : "Reset Password", onClick: this.submit, disabled: waiting }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'forgot-password' },
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { to: '/login' },
	                  ' Back to login page.'
	                )
	              )
	            ) : _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement('br', null),
	              'An email has been sent to this account\'s email address.',
	              _react2['default'].createElement('br', null),
	              'Please follow the instruction in the email.'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.props.dispatch((0, _actionsAuthentication.sendResetPW)(this.state));
	    }
	  }]);
	
	  return ForgotForm;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.authReducer
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForgotForm);
	module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(38)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),s=a(6),c=r(s),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.oneOf(["onload","explicit"]),sitekey:u.default.string,theme:u.default.oneOf(["light","dark"]),type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.oneOf(["invisible","compact","normal"]),tabindex:u.default.string,hl:u.default.string,badge:u.default.oneOf(["bottomright","bottomleft","inline"])},f={elementID:"g-recaptcha",className:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha&&"function"==typeof window.grecaptcha.render},y=void 0,b=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||"undefined"==typeof window||(y=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),l(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(y)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"execute",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.execute(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(y))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:this.props.className,"data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(s.Component);t.default=b,b.propTypes=d,b.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,l,s){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,l,s],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,l){l!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAuthentication = __webpack_require__(144);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var ResetPasswordForm = (function (_React$Component) {
	  _inherits(ResetPasswordForm, _React$Component);
	
	  function ResetPasswordForm() {
	    _classCallCheck(this, ResetPasswordForm);
	
	    _get(Object.getPrototypeOf(ResetPasswordForm.prototype), 'constructor', this).call(this);
	    this.submit = this.submit.bind(this);
	    this.displayName = 'LoginPage';
	    this.state = {
	      'new': '',
	      new2: ''
	    };
	  }
	
	  _createClass(ResetPasswordForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var key = this.props.location.query.k;
	      this.props.dispatch((0, _actionsAuthentication.resetPWGetUser)(key));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var key = e.target.id;
	      var value = e.target.value;
	      this.setState(_defineProperty({}, key, value));
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      if (e.key === 'Enter') {
	        this.submit();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var invalidKey = this.props.auth.resetPWBadKey;
	      var validKey = !invalidKey && this.props.auth.resetPWUser;
	      if (validKey) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'authentication-wrapper form-reset-password-page' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'authentication__card box--shadow  bg--white text--center' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' },
	              _react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg', className: 'authentication__card__logo' })
	            ),
	            _react2['default'].createElement(
	              'h2',
	              { className: 'authentication__card__welcome-message' },
	              'Welcome to Senzo Live!'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'authentication__card__form-wrapper' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                'Reset Password'
	              ),
	              _react2['default'].createElement(
	                'form',
	                null,
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement('input', { type: 'username', value: this.props.auth.resetPWUser.username, disabled: true }),
	                _react2['default'].createElement('input', { type: 'email', value: this.props.auth.resetPWUser.email, disabled: true }),
	                _react2['default'].createElement('input', { type: 'password', id: 'new', placeholder: 'New Password', className: this.state["newError"] ? "has-error" : "", onKeyDown: this.handleKeyDown.bind(this), onChange: this.handleChange.bind(this), required: true }),
	                _react2['default'].createElement('input', { type: 'password', id: 'new2', placeholder: 'Retype Password', className: this.state["new2Error"] ? "has-error" : "", onKeyDown: this.handleKeyDown.bind(this), onChange: this.handleChange.bind(this), required: true }),
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement('input', { className: 'btn-small form__authentication-btn', type: 'button', name: 'user_submit', value: 'Reset Password', onClick: this.submit })
	              )
	            )
	          )
	        );
	      } else if (invalidKey) {
	        return _react2['default'].createElement(
	          _react2['default'].Fragment,
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'app_container' },
	            _react2['default'].createElement(
	              'header',
	              { className: 'header' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'header-items' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'header-items__logo display--flex__flex--center cursor--pointer' },
	                  _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/' },
	                    _react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg' })
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'app__content' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'page-content page-content_padding-modifier' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'display--flex__flex--center' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'box--shadow bg--white reset--pwd--wrapper text--center ', style: { padding: "30px" } },
	                  _react2['default'].createElement(
	                    'p',
	                    { style: { margin: 0, fontSize: "18px" } },
	                    'It seems that this link has expired or invalid.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    { style: { margin: 0, fontSize: "18px" } },
	                    'Please make another password resetting request.'
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'forgot-password' },
	                    _react2['default'].createElement(
	                      _reactRouter.Link,
	                      { to: '/forgot' },
	                      ' Request here'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        // Loading...
	        return null;
	      }
	    }
	  }, {
	    key: 'checkForm',
	    value: function checkForm(data) {
	      var ok = true;
	      var badKeys = {};
	      Object.keys(data).map(function (key) {
	        if (data[key] === "") {
	          badKeys[key + "Error"] = true;
	          ok = false;
	        } else {
	          badKeys[key + "Error"] = false;
	        }
	      });
	      if (data['new'] != data.new2) {
	        badKeys["new2" + "Error"] = true;
	      }
	      this.setState(badKeys);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.checkForm({
	        'new': this.state['new'],
	        new2: this.state.new2
	      });
	      if (this.state['new'] == "") {
	        _toastr2['default'].error("Please provide new password.");
	      } else if (this.state['new'] != this.state.new2) {
	        _toastr2['default'].error("Password doesn't match.");
	      } else {
	        var key = this.props.location.query.k;
	        this.props.dispatch((0, _actionsAuthentication.resetPassword)(key, this.props.auth.resetPWUser.username, this.state['new']));
	      }
	    }
	  }]);
	
	  return ResetPasswordForm;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	  return {
	    auth: state.authReducer
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsUser = __webpack_require__(356);
	
	var a = _interopRequireWildcard(_actionsUser);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var Register = (function (_React$Component) {
		_inherits(Register, _React$Component);
	
		function Register(props, context) {
			_classCallCheck(this, Register);
	
			_get(Object.getPrototypeOf(Register.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				message: "",
				messageClass: ""
			};
		}
	
		_createClass(Register, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var key = this.props.location.query.k;
				this.props.dispatch(a.checkInviteKey(key));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				switch (nextProps.stage) {
					case "create-failed":
						this.setState({
							message: "Create new account failed : " + nextProps.respond.statusText.data,
							messageClass: "text-red"
						});
						break;
					default:
						this.setState({
							message: "",
							messageClass: ""
						});
				}
			}
		}, {
			key: 'getInvitor',
			value: function getInvitor() {
				var invitor = this.props.invitation.invitor;
				var name = invitor.firstname + " " + invitor.lastname;
				if (name.length <= 1) {
					name = invitor.username;
				}
				return name;
			}
		}, {
			key: 'getRole',
			value: function getRole() {
				var _this = this;
	
				var role = this.props.invitation.role;
				var res = "";
				_config2['default'].roles.forEach(function (r, idx) {
					if (idx == 0) {
						if (role == "ADMIN" && _this.props.invitation.rootnode.type == "customer") {
							res = r.singular;
						}
					} else {
						if (res == "" && r.code.substring(1) == role) {
							res = r.singular;
						}
					}
				});
				return res;
			}
		}, {
			key: 'getLocation',
			value: function getLocation() {
				return this.props.invitation.rootnode.info.name;
			}
		}, {
			key: 'getEmail',
			value: function getEmail() {
				return this.props.invitation.email;
			}
		}, {
			key: 'checkUser',
			value: function checkUser(user) {
				var ok = true;
				var badKeys = {};
				Object.keys(user).map(function (key) {
					if (user[key] === "") {
						badKeys[key] = true;
						ok = false;
					} else {
						badKeys[key] = false;
					}
				});
				if (user.password != user.password2) {
					badKeys["password2"] = true;
				}
				this.setState(badKeys);
				return ok;
			}
		}, {
			key: 'submit',
			value: function submit(key, refs) {
				var user = {};
				user.username = refs["username"].value;
				user.password = refs["password"].value;
				user.password2 = refs["password2"].value;
				user.email = refs["email"].value;
				user.title = refs["title"].value;
				user.firstname = refs["firstname"].value;
				user.lastname = refs["lastname"].value;
				user.phone = refs["phone"].value;
				user.position = refs["position"].value;
				user.address = refs["address"].value;
				user.rootnodeid = 0; // server won't use this value anyway.
				user.companyid = 0; // server won't use this value anyway.
				user.role = "ADMIN"; // server won't use this value anyway.
				if (this.checkUser(user)) {
					this.props.dispatch(a.createUser(key, user));
				} else {
					_toastr2['default'].error("Please provide all missing fields !");
				}
			}
		}, {
			key: 'render',
			value: function render() {
				switch (this.props.stage) {
					case "keychecked":
					case "creating":
					case "create-failed":
						return _react2['default'].createElement(Form, {
							inviteKey: this.props.location.query.k,
							invitor: this.getInvitor(),
							role: this.getRole(),
							location: this.getLocation(),
							submit: this.submit.bind(this),
							email: this.getEmail(),
							message: this.state.message,
							messageClass: this.state.messageClass,
							badKeys: this.state
						});
					case "created":
						return _react2['default'].createElement(Success, null);
					default:
						return _react2['default'].createElement(Expired, null);
				}
			}
		}]);
	
		return Register;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			stage: state.userRegisterReducer.stage,
			invitation: state.userRegisterReducer.invitation,
			respond: state.userRegisterReducer.respond
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Register);
	
	// Child comps
	
	var Form = (function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form() {
			_classCallCheck(this, Form);
	
			_get(Object.getPrototypeOf(Form.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Form, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var badKeys = this.props.badKeys;
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement(
						'div',
						{ className: 'app_container' },
						_react2['default'].createElement(
							'header',
							{ className: 'header' },
							_react2['default'].createElement(
								'div',
								{ className: 'header-items' },
								_react2['default'].createElement(
									'div',
									{ className: 'header-items__logo display--flex__flex--center cursor--pointer' },
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: '/' },
										_react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg' })
									)
								)
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'app__content' },
						_react2['default'].createElement(
							'div',
							{ className: 'page-content' },
							_react2['default'].createElement(
								'div',
								{ className: 'invitation-page text-center display--flex__flex--center' },
								_react2['default'].createElement(
									'div',
									null,
									_react2['default'].createElement(
										'div',
										{ className: 'white-box-container box--shadow bg--white', style: { padding: "30px 45px" } },
										_react2['default'].createElement(
											'h2',
											{ className: '' },
											'Welcome to SenzoLive software'
										),
										_react2['default'].createElement(
											'p',
											null,
											_react2['default'].createElement(
												'b',
												null,
												this.props.invitor
											),
											' has added you as ',
											_react2['default'].createElement(
												'b',
												null,
												this.props.role
											),
											' of ',
											_react2['default'].createElement(
												'b',
												null,
												this.props.location
											),
											'.',
											_react2['default'].createElement('br', null),
											_react2['default'].createElement(
												'span',
												null,
												'Please fill in following information to finalize your account.'
											)
										),
										_react2['default'].createElement(
											'form',
											{ className: 'account-form register-form clearfix' },
											_react2['default'].createElement(
												'div',
												{ className: 'col-lg-6 clearfix no--padding' },
												_react2['default'].createElement(
													'div',
													{ className: 'account-email' },
													_react2['default'].createElement(
														'label',
														null,
														'Email Address'
													),
													_react2['default'].createElement('input', { type: 'email', value: this.props.email, disabled: 'disabled', ref: 'email', className: badKeys.email ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-username' },
													_react2['default'].createElement(
														'label',
														null,
														'Username'
													),
													_react2['default'].createElement('input', { type: 'text', ref: 'username', className: badKeys.username ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-password' },
													_react2['default'].createElement(
														'label',
														null,
														'Password'
													),
													_react2['default'].createElement('input', { type: 'password', ref: 'password', className: badKeys.password ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-password' },
													_react2['default'].createElement(
														'label',
														null,
														'Retype Password'
													),
													_react2['default'].createElement('input', { type: 'password', ref: 'password2', className: badKeys.password2 ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account--form__title' },
													_react2['default'].createElement(
														'label',
														null,
														'Title'
													),
													_react2['default'].createElement(
														'select',
														{ ref: 'title' },
														_react2['default'].createElement(
															'option',
															{ value: 'Mr.', 'default': 'default' },
															'Mr.'
														),
														_react2['default'].createElement(
															'option',
															{ value: 'Ms/Mrs.' },
															'Ms/Mrs.'
														)
													)
												)
											),
											_react2['default'].createElement(
												'div',
												{ className: 'col-lg-6 clearfix no--padding' },
												_react2['default'].createElement(
													'div',
													{ style: { marginTop: "9px" }, className: 'account-position' },
													_react2['default'].createElement(
														'label',
														null,
														'Job Title'
													),
													_react2['default'].createElement('input', { type: 'text', ref: 'position', className: badKeys.position ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-firstname' },
													_react2['default'].createElement(
														'label',
														null,
														'First Name  '
													),
													_react2['default'].createElement('input', { type: 'text', ref: 'firstname', className: badKeys.firstname ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-lastname' },
													_react2['default'].createElement(
														'label',
														null,
														'Last Name'
													),
													_react2['default'].createElement('input', { type: 'text', ref: 'lastname', className: badKeys.lastname ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-phone' },
													_react2['default'].createElement(
														'label',
														null,
														'Phone  '
													),
													_react2['default'].createElement('input', { type: 'tel', ref: 'phone', className: badKeys.phone ? "border-red" : "" })
												),
												_react2['default'].createElement(
													'div',
													{ className: 'account-location' },
													_react2['default'].createElement(
														'label',
														null,
														'Location'
													),
													_react2['default'].createElement('input', { type: 'text', ref: 'address', className: badKeys.address ? "border-red" : "" })
												),
												this.props.message !== "" && _react2['default'].createElement(
													'div',
													{ className: 'register-message' },
													_react2['default'].createElement('label', null),
													_react2['default'].createElement(
														'span',
														{ className: this.props.messageClass },
														' ',
														this.props.message,
														' '
													)
												),
												_react2['default'].createElement(
													'div',
													{ className: 'text--right' },
													_react2['default'].createElement('label', null),
													_react2['default'].createElement(
														'span',
														{ className: 'btn-small form__authentication-btn', style: { padding: "8px 18px", display: "inline-block" }, onClick: function () {
																return _this2.props.submit(_this2.props.inviteKey, _this2.refs);
															} },
														'Sign Up'
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Form;
	})(_react2['default'].Component);
	
	var Expired = (function (_React$Component3) {
		_inherits(Expired, _React$Component3);
	
		function Expired() {
			_classCallCheck(this, Expired);
	
			_get(Object.getPrototypeOf(Expired.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Expired, [{
			key: 'render',
			value: function render() {
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement(
						'div',
						{ className: 'app_container' },
						_react2['default'].createElement(
							'div',
							{ className: 'header' },
							_react2['default'].createElement(
								'div',
								{ className: 'header-items' },
								_react2['default'].createElement(
									'div',
									{ className: 'header-items__logo display--flex__flex--center cursor--pointer' },
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: '/' },
										_react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg' })
									)
								)
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'app__content' },
						_react2['default'].createElement(
							'div',
							{ className: 'page-content' },
							_react2['default'].createElement(
								'div',
								{ className: 'expired-page display--flex__flex--center' },
								_react2['default'].createElement(
									'div',
									{ className: 'box--shadow bg--white reset--pwd--wrapper text--center ', style: { padding: "30px" } },
									_react2['default'].createElement(
										'p',
										{ style: { margin: 0, fontSize: "18px" } },
										'It seems that this link has expired or invalid.'
									),
									_react2['default'].createElement(
										'p',
										{ style: { margin: 0, fontSize: "18px" } },
										'Please contact your company\'s SenzoLive administrator and ask for a new invitation.'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Expired;
	})(_react2['default'].Component);
	
	var Success = (function (_React$Component4) {
		_inherits(Success, _React$Component4);
	
		function Success() {
			_classCallCheck(this, Success);
	
			_get(Object.getPrototypeOf(Success.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Success, [{
			key: 'render',
			value: function render() {
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement(
						'div',
						{ className: 'app_container' },
						_react2['default'].createElement(
							'div',
							{ className: 'header' },
							_react2['default'].createElement(
								'div',
								{ className: 'header-items' },
								_react2['default'].createElement(
									'div',
									{ 'class': 'header-items__logo display--flex__flex--center cursor--pointer' },
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: '/' },
										_react2['default'].createElement('img', { src: '/src/assets/icons/senzolive-software-logo.svg' })
									)
								)
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'app__content' },
						_react2['default'].createElement(
							'div',
							{ className: 'page-content' },
							_react2['default'].createElement(
								'div',
								{ className: 'register-success-page display--flex__flex--center' },
								_react2['default'].createElement(
									'div',
									{ className: 'box--shadow bg--white reset--pwd--wrapper text--center ', style: { padding: "30px" } },
									_react2['default'].createElement(
										'h3',
										{ className: 'page--title text-green' },
										'Registered successfully !'
									),
									_react2['default'].createElement(
										'p',
										{ style: { margin: "10px 0 0 0", fontSize: "18px" } },
										'Let\'s ',
										_react2['default'].createElement(
											_reactRouter.Link,
											{ className: 'login--now', to: '/login' },
											'login'
										),
										' now !'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Success;
	})(_react2['default'].Component);
	
	module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsPagesOverviewOverviewcontainer = __webpack_require__(454);
	
	var _componentsPagesOverviewOverviewcontainer2 = _interopRequireDefault(_componentsPagesOverviewOverviewcontainer);
	
	var Overview = (function (_React$Component) {
	    _inherits(Overview, _React$Component);
	
	    function Overview() {
	        _classCallCheck(this, Overview);
	
	        _get(Object.getPrototypeOf(Overview.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Overview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // let seenPopup = sessionStorage.getItem('seenPopup');
	            // if (!seenPopup) {
	            //     this.popupModal.open();
	            //     sessionStorage.setItem('seenPopup', true);
	            // }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(_componentsPagesOverviewOverviewcontainer2['default'], null),
	                _react2['default'].createElement(
	                    _componentsCommonModal2['default'],
	                    {
	                        ref: function (elem) {
	                            _this.popupModal = elem;
	                        },
	                        clickButton: function (e) {
	                            _this.popupModal.close();
	                        },
	                        header: "New website",
	                        buttonText: "Got it",
	                        buttonClass: 'btn-success',
	                        entry: null,
	                        onClose: function () {}
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        'Dear clients,',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement('br', null),
	                        'Please take note:',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement('br', null),
	                        'On ',
	                        _react2['default'].createElement(
	                            'b',
	                            null,
	                            'Friday 27th July 2018'
	                        ),
	                        ', the SenzoLive software URL will be changed to ',
	                        _react2['default'].createElement(
	                            'b',
	                            null,
	                            'https://software.senzolive.com'
	                        ),
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement('br', null),
	                        'The current https://senzolive.com will become the URL for our new website. You will be able to access the software by clicking the login button on the website.',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement('br', null),
	                        'We apologise for any inconvenience caused. If you have any questions, please send us an email via ',
	                        _react2['default'].createElement(
	                            'a',
	                            null,
	                            'support@senzolive.com'
	                        ),
	                        ' ',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement('br', null),
	                        'Thank you.'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Overview;
	})(_react2['default'].Component);
	
	exports['default'] = Overview;
	module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	/*
	This component is used in
	components/pages/api/api.jsx
	components/pages/defaultsettings/card.jsx
	components/pages/live/floorplan.jsx
	components/pages/live/sensorform.jsx
	components/pages/overview/index.jsx
	components/pages/settings/myaccount/password.jsx
	components/pages/user/userlist.jsx
	*/
	
	var _componentsCommonUtilsJs = __webpack_require__(444);
	
	var Modal = (function (_React$Component) {
		_inherits(Modal, _React$Component);
	
		function Modal(props, context) {
			_classCallCheck(this, Modal);
	
			_get(Object.getPrototypeOf(Modal.prototype), "constructor", this).call(this, props, context);
			this.state = {
				loaded: false,
				open: false,
				modalTopPosition: 0
			};
			this.offsetTop = this.offsetTop.bind(this);
		}
	
		_createClass(Modal, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				var offsetTop = (0, _componentsCommonUtilsJs.getMenuHeight)("app_header") + (0, _componentsCommonUtilsJs.getMenuHeight)("sticky-menu");
				this.setState({
					modalTopPosition: offsetTop
				});
				window.addEventListener("scroll", this.offsetTop);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.removeEventListener("scroll", this.offsetTop);
			}
		}, {
			key: "offsetTop",
			value: function offsetTop() {
				/* check if the app header contains app_header--sticky, no need to update the state
	    if the app header is sticky*/
				if (!document.getElementById("app-header-id").classList.contains("app_header--sticky")) {
					var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
					var offsetTop = Math.max(65 - scrollTop, 0);
					this.setState({
						modalTopPosition: offsetTop + (0, _componentsCommonUtilsJs.getMenuHeight)("sticky-menu")
					});
				}
			}
		}, {
			key: "toggle",
			value: function toggle(e) {
				if (this.state.open) {
					this.close(e);
				} else {
					this.open(e);
				}
			}
		}, {
			key: "open",
			value: function open(e) {
				if (!this.state.open) {
					if (typeof this.props.onOpen == "function") {
						this.props.onOpen(e);
					}
				}
				this.setState({ open: true, loaded: true });
			}
		}, {
			key: "close",
			value: function close(e) {
				if (this.state.open) {
					if (typeof this.props.onClose == "function") {
						this.props.onClose(e);
					}
				}
				this.setState({ open: false, loaded: true });
			}
		}, {
			key: "render",
			value: function render() {
				var type = "hidden";
				if (this.state.loaded) {
					type = this.state.open ? "open" : "closed";
				}
	
				return _react2["default"].createElement(
					"div",
					{ className: "modals " + (this.props.className ? this.props.className : '') },
					this.props.entry && _react2["default"].createElement(
						"div",
						{ className: "modals__entry", onClick: this.toggle.bind(this) },
						this.props.entry
					),
					_react2["default"].createElement("div", { className: "modals__overlay " + type, onClick: this.toggle.bind(this) }),
					_react2["default"].createElement(
						"div",
						{ className: "modals__content " + type, style: { top: this.state.modalTopPosition + "px" } },
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__header" },
							_react2["default"].createElement(
								"button",
								{ className: "close", onClick: this.toggle.bind(this) },
								"×"
							),
							_react2["default"].createElement(
								"h4",
								{ className: "modals__content__header__title" },
								this.props.header
							)
						),
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__body" },
							this.props.children
						),
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__footer" },
							!this.props.disableCloseButton && _react2["default"].createElement(
								"button",
								{ className: "btn btn-default", type: "button", onClick: this.toggle.bind(this) },
								"Cancel"
							),
							_react2["default"].createElement(
								"button",
								{ className: "btn " + this.props.buttonClass || "", type: "button", onClick: this.props.clickButton },
								this.props.buttonText
							)
						)
					)
				);
			}
		}]);
	
		return Modal;
	})(_react2["default"].Component);
	
	exports["default"] = Modal;
	module.exports = exports["default"];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isLightColor = isLightColor;
	exports.generateBgAndTextColor = generateBgAndTextColor;
	exports.getMenuHeight = getMenuHeight;
	exports.requiredIf = requiredIf;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _color = __webpack_require__(445);
	
	var _color2 = _interopRequireDefault(_color);
	
	function isLightColor(color) {
	    var colorObjHandle = (0, _color2["default"])(color).alpha(1);
	    return colorObjHandle.isLight() ? true : false;
	}
	
	function generateBgAndTextColor(color) {
	    var colorObjHandle = (0, _color2["default"])(color).alpha(1);
	    var textColor = undefined,
	        bgColor = undefined,
	        colorObj = undefined;
	    if (colorObjHandle.isLight()) {
	        textColor = colorObjHandle.mix((0, _color2["default"])("white")).hsl().string();
	        bgColor = colorObjHandle.mix((0, _color2["default"])("black")).hsl().string();
	    } else {
	        textColor = "white";
	        bgColor = colorObjHandle.mix((0, _color2["default"])("white")).hsl().string();
	    }
	    colorObj = { textColor: textColor, bgColor: bgColor };
	    return colorObj;
	}
	
	function getMenuHeight(className) {
	    var eleHeight = Array.from(document.querySelectorAll("." + className), function (el) {
	        return el.clientHeight;
	    });
	    return eleHeight[0];
	}
	
	function requiredIf(type, condition) {
	    return function (props, componentName) {
	        if (typeof type !== "function") {
	            return new Error('Invalid react-required-if prop type supplied to ' + componentName + '. Validation failed.');
	        }
	
	        if (typeof condition !== "function") {
	            return new Error('Invalid react-required-if condition supplied to ' + componentName + '. Validation failed.');
	        }
	
	        var test = condition(props) ? type.isRequired : type;
	        return test.apply(this, arguments);
	    };
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(446);
	var convert = __webpack_require__(450);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (obj == null) { // eslint-disable-line no-eq-null,eqeqeq
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		isDark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		isLight: function () {
			return !this.isDark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			if (!mixinColor || !mixinColor.rgb) {
				throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
			}
			var color1 = mixinColor.rgb();
			var color2 = this.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(447);
	var swizzle = __webpack_require__(448);
	var hasOwnProperty = Object.hasOwnProperty;
	
	var reverseNames = Object.create(null);
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (hasOwnProperty.call(colorNames, name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {},
		get: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
		var keyword = /^(\w+)$/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = parseInt(hexAlpha, 16) / 255;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				if (match[5]) {
					rgb[3] = parseFloat(match[4]) * 0.01;
				} else {
					rgb[3] = parseFloat(match[4]);
				}
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				if (match[5]) {
					rgb[3] = parseFloat(match[4]) * 0.01;
				} else {
					rgb[3] = parseFloat(match[4]);
				}
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			if (!hasOwnProperty.call(colorNames, match[1])) {
				return null;
			}
	
			rgb = colorNames[match[1]];
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = Math.round(num).toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(449);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(451);
	var route = __webpack_require__(453);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(452);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),
/* 452 */
447,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(451);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsNode = __webpack_require__(202);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _componentsPagesOverviewWidgets = __webpack_require__(1236);
	
	var _componentsPagesOverviewWidgets2 = _interopRequireDefault(_componentsPagesOverviewWidgets);
	
	var _componentsPagesOverviewSearchcontainer = __webpack_require__(1254);
	
	var _componentsPagesOverviewSearchcontainer2 = _interopRequireDefault(_componentsPagesOverviewSearchcontainer);
	
	var _commonStickymenu = __webpack_require__(1257);
	
	var _commonStickymenu2 = _interopRequireDefault(_commonStickymenu);
	
	var OverViewContainer = (function (_React$Component) {
	    _inherits(OverViewContainer, _React$Component);
	
	    function OverViewContainer(props, context) {
	        _classCallCheck(this, OverViewContainer);
	
	        _get(Object.getPrototypeOf(OverViewContainer.prototype), 'constructor', this).call(this, props, context);
	    }
	
	    _createClass(OverViewContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _actionsNode.fetchLiveData)());
	            this.props.dispatch((0, _actionsMyaccount.fetchCurrentUser)());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'overview-page' },
	                _react2['default'].createElement(
	                    _commonStickymenu2['default'],
	                    {
	                        withStickyHeader: true
	                    },
	                    _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                        overviewIsActive: true,
	                        comparisonIsActive: false,
	                        onlyLeftMenu: false
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'overview-grid-widget overwrite--modal--depth ' },
	                        _react2['default'].createElement(_componentsPagesOverviewWidgets2['default'], { tree: this.props.tree, querySettings: this.props.querySettings, allSensors: this.props.currentSensor }),
	                        _react2['default'].createElement(_componentsPagesOverviewSearchcontainer2['default'], { tree: this.props.tree, querySettings: this.props.querySettings })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OverViewContainer;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        loggedIn: state.authReducer.loggedIn,
	        user: state.myAccountReducer.user,
	        currentSensor: state.nodeReducer.map,
	        currentNode: state.overviewReducer.currentNode,
	        querySettings: state.querySettingsReducer,
	        tree: state.overviewReducer.customerOverview,
	        nodeMap: state.overviewReducer.nodeMap
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OverViewContainer);
	module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDateselector = __webpack_require__(456);
	
	var _componentsCommonDateselector2 = _interopRequireDefault(_componentsCommonDateselector);
	
	var _reactRouter = __webpack_require__(86);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var MainMenu = function MainMenu(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'main-menu display--flex' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'main-menu__quicknav display--flex__flex--start--center' },
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { className: 'font--bold main-menu__quicknav__item ' + (props.overviewIsActive ? 'active' : ''), to: '/' },
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    ' Overview'
	                )
	            ),
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { className: 'font--bold main-menu__quicknav__item ' + (props.comparisonIsActive ? 'active' : ''), to: '/comparison/' },
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    ' Comparison'
	                )
	            )
	        ),
	        !props.onlyLeftMenu && _react2['default'].createElement(_componentsCommonDateselector2['default'], { className: 'display--flex__flex--end--center' })
	    );
	};
	
	MainMenu.propTypes = {
	    overviewIsActive: _propTypes2['default'].bool.isRequired,
	    onlyLeftMenu: _propTypes2['default'].bool.isRequired,
	    comparisonIsActive: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = MainMenu;
	module.exports = exports['default'];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _officeUiFabricReact = __webpack_require__(457);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsQuerysettings = __webpack_require__(346);
	
	var _componentsCommonDateselectorStrings = __webpack_require__(1233);
	
	var _componentsCommonDateselectorStrings2 = _interopRequireDefault(_componentsCommonDateselectorStrings);
	
	var _componentsCommonTimepicker = __webpack_require__(1234);
	
	var _componentsCommonTimepicker2 = _interopRequireDefault(_componentsCommonTimepicker);
	
	var _componentsCommonDateselectorPeriodbutton = __webpack_require__(1235);
	
	var _componentsCommonDateselectorPeriodbutton2 = _interopRequireDefault(_componentsCommonDateselectorPeriodbutton);
	
	/* This component is used in
	components/pages/comparison/index.jsx
	components/pages/live/index.jsx
	components/pages/overview/overviewcontainer.jsx
	components/pages/stats/index.jsx
	*/
	
	var DateSelector = (function (_React$Component) {
	  _inherits(DateSelector, _React$Component);
	
	  function DateSelector(props, context) {
	    _classCallCheck(this, DateSelector);
	
	    _get(Object.getPrototypeOf(DateSelector.prototype), 'constructor', this).call(this, props, context);
	    this.state = {
	      startdate: this.props.query.startdate,
	      enddate: this.props.query.enddate,
	      starthour: this.props.card['default'].starthour,
	      endhour: this.props.card['default'].endhour,
	      active: this.props.query.active,
	      groupby: this.props.query.groupby,
	      show: false,
	      timePickerEnabled: false
	    };
	    this.handleClick = this.handleClick.bind(this);
	    this.dispatchPeriod = this.dispatchPeriod.bind(this);
	  }
	
	  _createClass(DateSelector, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.startdate != this.state.startdate || nextProps.enddate != this.state.enddate) {
	        this.setState({
	          startdate: nextProps.query.startdate,
	          enddate: nextProps.query.enddate,
	          starthour: nextProps.query.starthour || this.state.starthour,
	          endhour: nextProps.query.endhour || this.state.endhour,
	          active: nextProps.query.active,
	          groupby: nextProps.query.groupby
	        });
	      }
	    }
	  }, {
	    key: 'showDatePickers',
	    value: function showDatePickers() {
	      this.setState({
	        active: "Custom",
	        show: !this.state.show
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(value) {
	      var _this = this;
	
	      this.setState({ active: value });
	      if (value == "Today") {
	        this.setState({
	          startdate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	          enddate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	          groupby: 'hour'
	        }, function () {
	          return _this.dispatchPeriod();
	        });
	      } else if (value == "This week") {
	        this.setState({
	          startdate: (0, _moment2['default'])().subtract(1, "weeks").add(1, "days").format('DD-MM-YYYY'),
	          enddate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	          groupby: 'day'
	        }, function () {
	          return _this.dispatchPeriod();
	        });
	      } else if (value == "This month") {
	        this.setState({
	          startdate: (0, _moment2['default'])().subtract(1, "months").add(1, "days").format('DD-MM-YYYY'),
	          enddate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	          groupby: 'day'
	        }, function () {
	          return _this.dispatchPeriod();
	        });
	      } else if (value == "This year") {
	        this.setState({
	          startdate: (0, _moment2['default'])().subtract(1, "years").add(1, "days").format('DD-MM-YYYY'),
	          enddate: (0, _moment2['default'])().format('DD-MM-YYYY'),
	          groupby: 'day'
	        }, function () {
	          return _this.dispatchPeriod();
	        });
	      }
	    }
	  }, {
	    key: 'dispatchPeriod',
	    value: function dispatchPeriod() {
	      this.props.dispatch((0, _actionsQuerysettings.selectPeriod)({
	        startdate: this.state.startdate,
	        enddate: this.state.enddate,
	        starthour: this.state.timePickerEnabled ? this.state.starthour : null,
	        endhour: this.state.timePickerEnabled ? this.state.endhour : null,
	        groupby: this.state.groupby,
	        active: this.state.active
	      }));
	    }
	  }, {
	    key: 'onFormatDate',
	    value: function onFormatDate(date) {
	      var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
	      var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
	      var d = day + '-' + month + '-' + date.getFullYear();
	      return d;
	    }
	  }, {
	    key: 'onParseDateFromString',
	    value: function onParseDateFromString(value) {
	      if (typeof value == 'string') {
	        var values = (value || '').split('-');
	        var day = Math.max(1, Math.min(31, parseInt(values[0], 10)));
	        var month = Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1;
	        var year = parseInt(values[2], 10);
	        if (year < 100) {
	          year += date.getFullYear();
	        }
	        return new Date(year, month, day);
	      } else {
	        return value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var from = this.onParseDateFromString(this.state.startdate);
	      var to = this.onParseDateFromString(this.state.enddate);
	      var title = "";
	      if (this.state.timePickerEnabled) {
	        title = "ON : custom hour range.";
	      } else {
	        title = "OFF : each location uses its own hour range specified in default settings.";
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'main-menu__times ' + (this.props.className !== undefined ? this.props.className : "") },
	        _react2['default'].createElement(_componentsCommonDateselectorPeriodbutton2['default'], { handleClick: this.handleClick, active: this.state.active, value: 'Today' }),
	        _react2['default'].createElement(_componentsCommonDateselectorPeriodbutton2['default'], { handleClick: this.handleClick, active: this.state.active, value: 'This week' }),
	        _react2['default'].createElement(_componentsCommonDateselectorPeriodbutton2['default'], { handleClick: this.handleClick, active: this.state.active, value: 'This month' }),
	        _react2['default'].createElement(_componentsCommonDateselectorPeriodbutton2['default'], { handleClick: this.handleClick, active: this.state.active, value: 'This year' }),
	        _react2['default'].createElement(
	          'span',
	          { className: 'datepicker--parent' },
	          _react2['default'].createElement(
	            'span',
	            { onClick: this.showDatePickers.bind(this), className: "font--bold main-menu__times__item " + (this.state.active === "Custom" ? " active" : "") },
	            'Custom'
	          )
	        ),
	        this.state.show && _react2['default'].createElement(
	          'div',
	          { className: 'datepicker--popup' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'display--flex' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'display--flex__flex--end--center' },
	              _react2['default'].createElement(
	                'button',
	                { onClick: this.showDatePickers.bind(this), className: 'close' },
	                '×'
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'display--flex', style: { margin: "-10px 6px 0px" } },
	            _react2['default'].createElement(
	              'div',
	              { className: 'display--flex__flex--start--center' },
	              _react2['default'].createElement(_officeUiFabricReact.DatePicker, { className: 'start--date',
	                formatDate: function (date) {
	                  return _this2.onFormatDate(date);
	                },
	                onSelectDate: this.setStartDate.bind(this),
	                value: from,
	                firstDayOfWeek: _officeUiFabricReact.DayOfWeek.Monday,
	                strings: _componentsCommonDateselectorStrings2['default'],
	                showGoToToday: true
	
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'date--divider display--flex__flex--center' },
	              '-'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'display--flex__flex--end--center' },
	              _react2['default'].createElement(_officeUiFabricReact.DatePicker, { className: 'end--date',
	                formatDate: function (date) {
	                  return _this2.onFormatDate(date);
	                },
	                onSelectDate: this.setEndDate.bind(this),
	                value: to,
	                firstDayOfWeek: _officeUiFabricReact.DayOfWeek.Monday,
	                strings: _componentsCommonDateselectorStrings2['default'],
	                showGoToToday: true
	              })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { style: { marginTop: "10px", display: "flex" } },
	            _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement('input', { type: 'checkbox', checked: this.state.timePickerEnabled, onChange: this.onToggleTimePicker.bind(this), title: title })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: { flex: 1, opacity: this.state.timePickerEnabled ? "1" : "0.3" } },
	              _react2['default'].createElement(_componentsCommonTimepicker2['default'], {
	                nSegments: 24,
	                values: [this.state.starthour, this.state.endhour + 1],
	                onChange: this.setRangehour.bind(this),
	                disabled: !this.state.timePickerEnabled
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'onToggleTimePicker',
	    value: function onToggleTimePicker(e) {
	      var _this3 = this;
	
	      this.setState({ timePickerEnabled: !this.state.timePickerEnabled }, function () {
	        return _this3.dispatchPeriod();
	      });
	    }
	
	    // Set state is asynchronous, apply update in callback where state is properly updated.
	  }, {
	    key: 'setStartDate',
	    value: function setStartDate(date) {
	      var d = this.onFormatDate(date);
	      var self = this;
	      this.setState({ startdate: d, groupby: 'day' }, function () {
	        return self.dispatchPeriod();
	      });
	    }
	  }, {
	    key: 'setEndDate',
	    value: function setEndDate(date) {
	      var d = this.onFormatDate(date);
	      var self = this;
	      this.setState({ enddate: d, groupby: 'day' }, function () {
	        return self.dispatchPeriod();
	      });
	    }
	  }, {
	    key: 'setRangehour',
	    value: function setRangehour(values) {
	      var self = this;
	      this.setState({ starthour: values[0], endhour: values[1] == null ? null : values[1] - 1 }, function () {
	        return self.dispatchPeriod();
	      });
	    }
	  }]);
	
	  return DateSelector;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	  return {
	    query: state.querySettingsReducer,
	    card: state.defaultSettingsReducer.card
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DateSelector);
	module.exports = exports['default'];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(459), exports);
	tslib_1.__exportStar(__webpack_require__(664), exports);
	tslib_1.__exportStar(__webpack_require__(667), exports);
	tslib_1.__exportStar(__webpack_require__(672), exports);
	tslib_1.__exportStar(__webpack_require__(691), exports);
	tslib_1.__exportStar(__webpack_require__(746), exports);
	tslib_1.__exportStar(__webpack_require__(603), exports);
	tslib_1.__exportStar(__webpack_require__(757), exports);
	tslib_1.__exportStar(__webpack_require__(762), exports);
	tslib_1.__exportStar(__webpack_require__(767), exports);
	tslib_1.__exportStar(__webpack_require__(781), exports);
	tslib_1.__exportStar(__webpack_require__(782), exports);
	tslib_1.__exportStar(__webpack_require__(792), exports);
	tslib_1.__exportStar(__webpack_require__(818), exports);
	tslib_1.__exportStar(__webpack_require__(836), exports);
	tslib_1.__exportStar(__webpack_require__(849), exports);
	tslib_1.__exportStar(__webpack_require__(694), exports);
	tslib_1.__exportStar(__webpack_require__(859), exports);
	tslib_1.__exportStar(__webpack_require__(864), exports);
	tslib_1.__exportStar(__webpack_require__(914), exports);
	tslib_1.__exportStar(__webpack_require__(713), exports);
	tslib_1.__exportStar(__webpack_require__(939), exports);
	tslib_1.__exportStar(__webpack_require__(973), exports);
	tslib_1.__exportStar(__webpack_require__(986), exports);
	tslib_1.__exportStar(__webpack_require__(621), exports);
	tslib_1.__exportStar(__webpack_require__(995), exports);
	tslib_1.__exportStar(__webpack_require__(1003), exports);
	tslib_1.__exportStar(__webpack_require__(630), exports);
	tslib_1.__exportStar(__webpack_require__(676), exports);
	tslib_1.__exportStar(__webpack_require__(1039), exports);
	tslib_1.__exportStar(__webpack_require__(1046), exports);
	tslib_1.__exportStar(__webpack_require__(875), exports);
	tslib_1.__exportStar(__webpack_require__(1052), exports);
	tslib_1.__exportStar(__webpack_require__(643), exports);
	tslib_1.__exportStar(__webpack_require__(1066), exports);
	tslib_1.__exportStar(__webpack_require__(658), exports);
	tslib_1.__exportStar(__webpack_require__(1088), exports);
	tslib_1.__exportStar(__webpack_require__(684), exports);
	tslib_1.__exportStar(__webpack_require__(1094), exports);
	tslib_1.__exportStar(__webpack_require__(771), exports);
	tslib_1.__exportStar(__webpack_require__(617), exports);
	tslib_1.__exportStar(__webpack_require__(680), exports);
	tslib_1.__exportStar(__webpack_require__(845), exports);
	tslib_1.__exportStar(__webpack_require__(1101), exports);
	tslib_1.__exportStar(__webpack_require__(1105), exports);
	tslib_1.__exportStar(__webpack_require__(919), exports);
	tslib_1.__exportStar(__webpack_require__(1111), exports);
	tslib_1.__exportStar(__webpack_require__(853), exports);
	tslib_1.__exportStar(__webpack_require__(924), exports);
	tslib_1.__exportStar(__webpack_require__(979), exports);
	tslib_1.__exportStar(__webpack_require__(594), exports);
	tslib_1.__exportStar(__webpack_require__(954), exports);
	// export * from './PersonaPresence'; (Exported as part of Persona)
	tslib_1.__exportStar(__webpack_require__(1009), exports);
	tslib_1.__exportStar(__webpack_require__(1116), exports);
	tslib_1.__exportStar(__webpack_require__(613), exports);
	tslib_1.__exportStar(__webpack_require__(1123), exports);
	tslib_1.__exportStar(__webpack_require__(1124), exports);
	tslib_1.__exportStar(__webpack_require__(1129), exports);
	tslib_1.__exportStar(__webpack_require__(740), exports);
	tslib_1.__exportStar(__webpack_require__(1135), exports);
	tslib_1.__exportStar(__webpack_require__(1141), exports);
	tslib_1.__exportStar(__webpack_require__(1146), exports);
	tslib_1.__exportStar(__webpack_require__(1147), exports);
	tslib_1.__exportStar(__webpack_require__(990), exports);
	tslib_1.__exportStar(__webpack_require__(1156), exports);
	tslib_1.__exportStar(__webpack_require__(1161), exports);
	tslib_1.__exportStar(__webpack_require__(1179), exports);
	tslib_1.__exportStar(__webpack_require__(1183), exports);
	tslib_1.__exportStar(__webpack_require__(1188), exports);
	tslib_1.__exportStar(__webpack_require__(885), exports);
	tslib_1.__exportStar(__webpack_require__(1193), exports);
	tslib_1.__exportStar(__webpack_require__(1200), exports);
	tslib_1.__exportStar(__webpack_require__(463), exports);
	tslib_1.__exportStar(__webpack_require__(1204), exports);
	tslib_1.__exportStar(__webpack_require__(1212), exports);
	tslib_1.__exportStar(__webpack_require__(1219), exports);
	tslib_1.__exportStar(__webpack_require__(822), exports);
	tslib_1.__exportStar(__webpack_require__(1224), exports);
	tslib_1.__exportStar(__webpack_require__(1228), exports);
	tslib_1.__exportStar(__webpack_require__(598), exports);
	tslib_1.__exportStar(__webpack_require__(592), exports);
	__webpack_require__(464);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(460), exports);
	//# sourceMappingURL=ActivityItem.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(461), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var ActivityItem_classNames_1 = __webpack_require__(462);
	var ActivityItem_styles_1 = __webpack_require__(593);
	var Persona_1 = __webpack_require__(594);
	/**
	 * {@docCategory ActivityItem}
	 */
	var ActivityItem = /** @class */ (function (_super) {
	    tslib_1.__extends(ActivityItem, _super);
	    function ActivityItem(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onRenderIcon = function (props) {
	            if (props.activityPersonas) {
	                return _this._onRenderPersonaArray(props);
	            }
	            else {
	                return _this.props.activityIcon;
	            }
	        };
	        _this._onRenderActivityDescription = function (props) {
	            var classNames = _this._getClassNames(props);
	            var activityDescription = props.activityDescription || props.activityDescriptionText;
	            if (activityDescription) {
	                return React.createElement("span", { className: classNames.activityText }, activityDescription);
	            }
	            return null;
	        };
	        _this._onRenderComments = function (props) {
	            var classNames = _this._getClassNames(props);
	            var comments = props.comments || props.commentText;
	            if (!props.isCompact && comments) {
	                return React.createElement("div", { className: classNames.commentText }, comments);
	            }
	            return null;
	        };
	        _this._onRenderTimeStamp = function (props) {
	            var classNames = _this._getClassNames(props);
	            if (!props.isCompact && props.timeStamp) {
	                return React.createElement("div", { className: classNames.timeStamp }, props.timeStamp);
	            }
	            return null;
	        };
	        // If activityPersonas is an array of persona props, build the persona cluster element.
	        _this._onRenderPersonaArray = function (props) {
	            var classNames = _this._getClassNames(props);
	            var personaElement = null;
	            var activityPersonas = props.activityPersonas;
	            if (activityPersonas[0].imageUrl || activityPersonas[0].imageInitials) {
	                var personaList_1 = [];
	                var showSize16Personas_1 = activityPersonas.length > 1 || props.isCompact;
	                var personaLimit_1 = props.isCompact ? 3 : 4;
	                var style_1 = undefined;
	                if (props.isCompact) {
	                    style_1 = {
	                        display: 'inline-block',
	                        width: '10px',
	                        minWidth: '10px',
	                        overflow: 'visible'
	                    };
	                }
	                activityPersonas
	                    .filter(function (person, index) { return index < personaLimit_1; })
	                    .forEach(function (person, index) {
	                    personaList_1.push(React.createElement(Persona_1.PersonaCoin, tslib_1.__assign({}, person, { 
	                        // tslint:disable-next-line:no-string-literal
	                        key: person['key'] ? person['key'] : index, className: classNames.activityPersona, size: showSize16Personas_1 ? Persona_1.PersonaSize.size16 : Persona_1.PersonaSize.size32, style: style_1 })));
	                });
	                personaElement = React.createElement("div", { className: classNames.personaContainer }, personaList_1);
	            }
	            return personaElement;
	        };
	        return _this;
	    }
	    ActivityItem.prototype.render = function () {
	        var _a = this.props, _b = _a.onRenderIcon, onRenderIcon = _b === void 0 ? this._onRenderIcon : _b, _c = _a.onRenderActivityDescription, onRenderActivityDescription = _c === void 0 ? this._onRenderActivityDescription : _c, _d = _a.onRenderComments, onRenderComments = _d === void 0 ? this._onRenderComments : _d, _e = _a.onRenderTimeStamp, onRenderTimeStamp = _e === void 0 ? this._onRenderTimeStamp : _e, animateBeaconSignal = _a.animateBeaconSignal, isCompact = _a.isCompact;
	        var classNames = this._getClassNames(this.props);
	        return (React.createElement("div", { className: classNames.root, style: this.props.style },
	            (this.props.activityPersonas || this.props.activityIcon || this.props.onRenderIcon) && (React.createElement("div", { className: classNames.activityTypeIcon },
	                animateBeaconSignal && isCompact && React.createElement("div", { className: classNames.pulsingBeacon }),
	                onRenderIcon(this.props))),
	            React.createElement("div", { className: classNames.activityContent },
	                onRenderActivityDescription(this.props, this._onRenderActivityDescription),
	                onRenderComments(this.props, this._onRenderComments),
	                onRenderTimeStamp(this.props, this._onRenderTimeStamp))));
	    };
	    ActivityItem.prototype._getClassNames = function (props) {
	        return ActivityItem_classNames_1.getClassNames(ActivityItem_styles_1.getStyles(undefined, props.styles, props.animateBeaconSignal, props.beaconColorOne, props.beaconColorTwo, props.isCompact), props.className, props.activityPersonas, props.isCompact);
	    };
	    return ActivityItem;
	}(React.Component));
	exports.ActivityItem = ActivityItem;
	//# sourceMappingURL=ActivityItem.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	exports.getClassNames = Utilities_1.memoizeFunction(function (styles, className, activityPersonas, isCompact) {
	    return {
	        root: Styling_1.mergeStyles('ms-ActivityItem', className, styles.root, isCompact && styles.isCompactRoot),
	        pulsingBeacon: Styling_1.mergeStyles('ms-ActivityItem-pulsingBeacon', styles.pulsingBeacon),
	        personaContainer: Styling_1.mergeStyles('ms-ActivityItem-personaContainer', styles.personaContainer, isCompact && styles.isCompactPersonaContainer),
	        activityPersona: Styling_1.mergeStyles('ms-ActivityItem-activityPersona', styles.activityPersona, isCompact && styles.isCompactPersona, !isCompact && activityPersonas && activityPersonas.length === 2 && styles.doublePersona),
	        activityTypeIcon: Styling_1.mergeStyles('ms-ActivityItem-activityTypeIcon', styles.activityTypeIcon, isCompact && styles.isCompactIcon),
	        activityContent: Styling_1.mergeStyles('ms-ActivityItem-activityContent', styles.activityContent, isCompact && styles.isCompactContent),
	        activityText: Styling_1.mergeStyles('ms-ActivityItem-activityText', styles.activityText),
	        commentText: Styling_1.mergeStyles('ms-ActivityItem-commentText', styles.commentText),
	        timeStamp: Styling_1.mergeStyles('ms-ActivityItem-timeStamp', styles.timeStamp, isCompact && styles.isCompactTimeStamp)
	    };
	});
	//# sourceMappingURL=ActivityItem.classNames.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	__webpack_require__(464);
	tslib_1.__exportStar(__webpack_require__(467), exports);
	//# sourceMappingURL=Styling.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// office-ui-fabric-react@6.214.0
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('office-ui-fabric-react', '6.214.0');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var setVersion_1 = __webpack_require__(466);
	exports.setVersion = setVersion_1.setVersion;
	setVersion_1.setVersion('@uifabric/set-version', '6.0.0');
	//# sourceMappingURL=index.js.map

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
	// this cache is local to the module closure inside this bundle
	var packagesCache = {};
	function setVersion(packageName, packageVersion) {
	    if (typeof window !== 'undefined') {
	        // tslint:disable-next-line:no-any
	        var packages = (window.__packages__ = window.__packages__ || {});
	        // We allow either the global packages or local packages caches to invalidate so testing can just clear the global to set this state
	        if (!packages[packageName] || !packagesCache[packageName]) {
	            packagesCache[packageName] = packageVersion;
	            var versions = (packages[packageName] = packages[packageName] || []);
	            versions.push(packageVersion);
	        }
	    }
	}
	exports.setVersion = setVersion;
	//# sourceMappingURL=setVersion.js.map

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(468), exports);
	tslib_1.__exportStar(__webpack_require__(570), exports);
	tslib_1.__exportStar(__webpack_require__(470), exports);
	tslib_1.__exportStar(__webpack_require__(472), exports);
	__webpack_require__(591);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AnimationClassNames_1 = __webpack_require__(469);
	exports.AnimationClassNames = AnimationClassNames_1.AnimationClassNames;
	var FontClassNames_1 = __webpack_require__(589);
	exports.FontClassNames = FontClassNames_1.FontClassNames;
	var ColorClassNames_1 = __webpack_require__(590);
	exports.ColorClassNames = ColorClassNames_1.ColorClassNames;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(470);
	var index_2 = __webpack_require__(570);
	/**
	 * {@docCategory AnimationClassNames}
	 */
	exports.AnimationClassNames = index_1.buildClassMap(index_2.AnimationStyles);
	//# sourceMappingURL=AnimationClassNames.js.map

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var buildClassMap_1 = __webpack_require__(471);
	exports.buildClassMap = buildClassMap_1.buildClassMap;
	var icons_1 = __webpack_require__(488);
	exports.getIcon = icons_1.getIcon;
	exports.registerIcons = icons_1.registerIcons;
	exports.registerIconAlias = icons_1.registerIconAlias;
	exports.unregisterIcons = icons_1.unregisterIcons;
	exports.setIconOptions = icons_1.setIconOptions;
	var getIconClassName_1 = __webpack_require__(569);
	exports.getIconClassName = getIconClassName_1.getIconClassName;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MergeStyles_1 = __webpack_require__(472);
	/**
	 * Builds a class names object from a given map.
	 *
	 * @param styles - Map of unprocessed styles.
	 * @returns Map of property name to class name.
	 */
	function buildClassMap(styles) {
	    var classes = {};
	    var _loop_1 = function (styleName) {
	        if (styles.hasOwnProperty(styleName)) {
	            var className_1;
	            Object.defineProperty(classes, styleName, {
	                get: function () {
	                    if (className_1 === undefined) {
	                        // tslint:disable-next-line:no-any
	                        className_1 = MergeStyles_1.mergeStyles(styles[styleName]).toString();
	                    }
	                    return className_1;
	                },
	                enumerable: true,
	                configurable: true
	            });
	        }
	    };
	    for (var styleName in styles) {
	        _loop_1(styleName);
	    }
	    return classes;
	}
	exports.buildClassMap = buildClassMap;
	//# sourceMappingURL=buildClassMap.js.map

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	exports.InjectionMode = merge_styles_1.InjectionMode;
	exports.Stylesheet = merge_styles_1.Stylesheet;
	exports.concatStyleSets = merge_styles_1.concatStyleSets;
	exports.fontFace = merge_styles_1.fontFace;
	exports.keyframes = merge_styles_1.keyframes;
	exports.mergeStyleSets = merge_styles_1.mergeStyleSets;
	exports.mergeStyles = merge_styles_1.mergeStyles;
	//# sourceMappingURL=MergeStyles.js.map

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeStyles_1 = __webpack_require__(474);
	exports.mergeStyles = mergeStyles_1.mergeStyles;
	var mergeStyleSets_1 = __webpack_require__(483);
	exports.mergeStyleSets = mergeStyleSets_1.mergeStyleSets;
	var concatStyleSets_1 = __webpack_require__(484);
	exports.concatStyleSets = concatStyleSets_1.concatStyleSets;
	var fontFace_1 = __webpack_require__(485);
	exports.fontFace = fontFace_1.fontFace;
	var keyframes_1 = __webpack_require__(486);
	exports.keyframes = keyframes_1.keyframes;
	var Stylesheet_1 = __webpack_require__(476);
	exports.InjectionMode = Stylesheet_1.InjectionMode;
	exports.Stylesheet = Stylesheet_1.Stylesheet;
	var rtlifyRules_1 = __webpack_require__(481);
	exports.setRTL = rtlifyRules_1.setRTL;
	__webpack_require__(487);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var styleToClassName_1 = __webpack_require__(475);
	var extractStyleParts_1 = __webpack_require__(482);
	/**
	 * Concatination helper, which can merge class names together. Skips over falsey values.
	 *
	 * @public
	 */
	function mergeStyles() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var _a = extractStyleParts_1.extractStyleParts(args), classes = _a.classes, objects = _a.objects;
	    if (objects.length) {
	        classes.push(styleToClassName_1.styleToClassName(objects));
	    }
	    return classes.join(' ');
	}
	exports.mergeStyles = mergeStyles;
	//# sourceMappingURL=mergeStyles.js.map

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(476);
	var kebabRules_1 = __webpack_require__(477);
	var prefixRules_1 = __webpack_require__(478);
	var provideUnits_1 = __webpack_require__(480);
	var rtlifyRules_1 = __webpack_require__(481);
	var DISPLAY_NAME = 'displayName';
	function getDisplayName(rules) {
	    var rootStyle = rules && rules['&'];
	    return rootStyle ? rootStyle.displayName : undefined;
	}
	var globalSelectorRegExp = /\:global\((.+?)\)/g;
	/**
	 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
	 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
	 *
	 * @param selectorWithGlobals The selector to process
	 * @returns The updated selector
	 */
	function expandCommaSeparatedGlobals(selectorWithGlobals) {
	    // We the selector does not have a :global() we can shortcut
	    if (!globalSelectorRegExp.test(selectorWithGlobals)) {
	        return selectorWithGlobals;
	    }
	    var replacementInfo = [];
	    var findGlobal = /\:global\((.+?)\)/g;
	    var match = null;
	    // Create a result list for global selectors so we can replace them.
	    while ((match = findGlobal.exec(selectorWithGlobals))) {
	        // Only if the found selector is a comma separated list we'll process it.
	        if (match[1].indexOf(',') > -1) {
	            replacementInfo.push([
	                match.index,
	                match.index + match[0].length,
	                // Wrap each of the found selectors in :global()
	                match[1]
	                    .split(',')
	                    .map(function (v) { return ":global(" + v.trim() + ")"; })
	                    .join(', ')
	            ]);
	        }
	    }
	    // Replace the found selectors with their wrapped variants in reverse order
	    return replacementInfo.reverse().reduce(function (selector, _a) {
	        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
	        var prefix = selector.slice(0, matchIndex);
	        var suffix = selector.slice(matchEndIndex);
	        return prefix + replacement + suffix;
	    }, selectorWithGlobals);
	}
	function expandSelector(newSelector, currentSelector) {
	    if (newSelector.indexOf(':global(') >= 0) {
	        return newSelector.replace(globalSelectorRegExp, '$1');
	    }
	    else if (newSelector.indexOf(':') === 0) {
	        return currentSelector + newSelector;
	    }
	    else if (newSelector.indexOf('&') < 0) {
	        return currentSelector + ' ' + newSelector;
	    }
	    return newSelector;
	}
	function extractRules(args, rules, currentSelector) {
	    if (rules === void 0) { rules = { __order: [] }; }
	    if (currentSelector === void 0) { currentSelector = '&'; }
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var currentRules = rules[currentSelector];
	    if (!currentRules) {
	        currentRules = {};
	        rules[currentSelector] = currentRules;
	        rules.__order.push(currentSelector);
	    }
	    for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
	        var arg = args_1[_i];
	        // If the arg is a string, we need to look up the class map and merge.
	        if (typeof arg === 'string') {
	            var expandedRules = stylesheet.argsFromClassName(arg);
	            if (expandedRules) {
	                extractRules(expandedRules, rules, currentSelector);
	            }
	            // Else if the arg is an array, we need to recurse in.
	        }
	        else if (Array.isArray(arg)) {
	            extractRules(arg, rules, currentSelector);
	        }
	        else {
	            // tslint:disable-next-line:no-any
	            for (var prop in arg) {
	                if (prop === 'selectors') {
	                    // tslint:disable-next-line:no-any
	                    var selectors = arg.selectors;
	                    for (var newSelector in selectors) {
	                        if (selectors.hasOwnProperty(newSelector)) {
	                            var selectorValue = selectors[newSelector];
	                            if (newSelector.indexOf('@') === 0) {
	                                newSelector = newSelector + '{' + currentSelector;
	                                extractRules([selectorValue], rules, newSelector);
	                            }
	                            else if (newSelector.indexOf(',') > -1) {
	                                var commaSeparatedSelectors = expandCommaSeparatedGlobals(newSelector)
	                                    .split(/,/g)
	                                    .map(function (s) { return s.trim(); });
	                                extractRules([selectorValue], rules, commaSeparatedSelectors
	                                    .map(function (commaSeparatedSelector) { return expandSelector(commaSeparatedSelector, currentSelector); })
	                                    .join(', '));
	                            }
	                            else {
	                                extractRules([selectorValue], rules, expandSelector(newSelector, currentSelector));
	                            }
	                        }
	                    }
	                }
	                else {
	                    if (arg[prop] !== undefined) {
	                        // Else, add the rule to the currentSelector.
	                        if (prop === 'margin' || prop === 'padding') {
	                            // tslint:disable-next-line:no-any
	                            expandQuads(currentRules, prop, arg[prop]);
	                        }
	                        else {
	                            // tslint:disable-next-line:no-any
	                            currentRules[prop] = arg[prop];
	                        }
	                    }
	                }
	            }
	        }
	    }
	    return rules;
	}
	function expandQuads(currentRules, name, value) {
	    var parts = typeof value === 'string' ? value.split(' ') : [value];
	    currentRules[name + 'Top'] = parts[0];
	    currentRules[name + 'Right'] = parts[1] || parts[0];
	    currentRules[name + 'Bottom'] = parts[2] || parts[0];
	    currentRules[name + 'Left'] = parts[3] || parts[1] || parts[0];
	}
	function getKeyForRules(rules) {
	    var serialized = [];
	    var hasProps = false;
	    for (var _i = 0, _a = rules.__order; _i < _a.length; _i++) {
	        var selector = _a[_i];
	        serialized.push(selector);
	        var rulesForSelector = rules[selector];
	        for (var propName in rulesForSelector) {
	            if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
	                hasProps = true;
	                serialized.push(propName, rulesForSelector[propName]);
	            }
	        }
	    }
	    return hasProps ? serialized.join('') : undefined;
	}
	function serializeRuleEntries(ruleEntries) {
	    if (!ruleEntries) {
	        return '';
	    }
	    var allEntries = [];
	    for (var entry in ruleEntries) {
	        if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME && ruleEntries[entry] !== undefined) {
	            allEntries.push(entry, ruleEntries[entry]);
	        }
	    }
	    // Apply transforms.
	    for (var i = 0; i < allEntries.length; i += 2) {
	        kebabRules_1.kebabRules(allEntries, i);
	        provideUnits_1.provideUnits(allEntries, i);
	        rtlifyRules_1.rtlifyRules(allEntries, i);
	        prefixRules_1.prefixRules(allEntries, i);
	    }
	    // Apply punctuation.
	    for (var i = 1; i < allEntries.length; i += 4) {
	        allEntries.splice(i, 1, ':', allEntries[i], ';');
	    }
	    return allEntries.join('');
	}
	exports.serializeRuleEntries = serializeRuleEntries;
	function styleToRegistration() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var rules = extractRules(args);
	    var key = getKeyForRules(rules);
	    if (key) {
	        var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	        var registration = {
	            className: stylesheet.classNameFromKey(key),
	            key: key,
	            args: args
	        };
	        if (!registration.className) {
	            registration.className = stylesheet.getClassName(getDisplayName(rules));
	            var rulesToInsert = [];
	            for (var _a = 0, _b = rules.__order; _a < _b.length; _a++) {
	                var selector = _b[_a];
	                rulesToInsert.push(selector, serializeRuleEntries(rules[selector]));
	            }
	            registration.rulesToInsert = rulesToInsert;
	        }
	        return registration;
	    }
	}
	exports.styleToRegistration = styleToRegistration;
	function applyRegistration(registration, classMap) {
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
	    if (rulesToInsert) {
	        // rulesToInsert is an ordered array of selector/rule pairs.
	        for (var i = 0; i < rulesToInsert.length; i += 2) {
	            var rules = rulesToInsert[i + 1];
	            if (rules) {
	                var selector = rulesToInsert[i];
	                // Fix selector using map.
	                selector = selector.replace(/(&)|\$([\w-]+)\b/g, function (match, amp, cn) {
	                    if (amp) {
	                        return '.' + registration.className;
	                    }
	                    else if (cn) {
	                        return '.' + ((classMap && classMap[cn]) || cn);
	                    }
	                    return '';
	                });
	                // Insert. Note if a media query, we must close the query with a final bracket.
	                var processedRule = selector + "{" + rules + "}" + (selector.indexOf('@') === 0 ? '}' : '');
	                stylesheet.insertRule(processedRule);
	            }
	        }
	        stylesheet.cacheClassName(className, key, args, rulesToInsert);
	    }
	}
	exports.applyRegistration = applyRegistration;
	function styleToClassName() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var registration = styleToRegistration.apply(void 0, args);
	    if (registration) {
	        applyRegistration(registration);
	        return registration.className;
	    }
	    return '';
	}
	exports.styleToClassName = styleToClassName;
	//# sourceMappingURL=styleToClassName.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	exports.InjectionMode = {
	    /**
	     * Avoids style injection, use getRules() to read the styles.
	     */
	    none: 0,
	    /**
	     * Inserts rules using the insertRule api.
	     */
	    insertNode: 1,
	    /**
	     * Appends rules using appendChild.
	     */
	    appendChild: 2
	};
	var STYLESHEET_SETTING = '__stylesheet__';
	// tslint:disable-next-line:no-any
	var _global = {};
	// Grab window.
	try {
	    _global = window;
	}
	catch (_a) {
	    /* leave as blank object */
	}
	var _stylesheet;
	/**
	 * Represents the state of styles registered in the page. Abstracts
	 * the surface for adding styles to the stylesheet, exposes helpers
	 * for reading the styles registered in server rendered scenarios.
	 *
	 * @public
	 */
	var Stylesheet = /** @class */ (function () {
	    function Stylesheet(config) {
	        this._rules = [];
	        this._preservedRules = [];
	        this._rulesToInsert = [];
	        this._counter = 0;
	        this._keyToClassName = {};
	        this._onResetCallbacks = [];
	        // tslint:disable-next-line:no-any
	        this._classNameToArgs = {};
	        this._config = tslib_1.__assign({ injectionMode: exports.InjectionMode.insertNode, defaultPrefix: 'css', namespace: undefined, cspSettings: undefined }, config);
	    }
	    /**
	     * Gets the singleton instance.
	     */
	    Stylesheet.getInstance = function () {
	        // tslint:disable-next-line:no-any
	        _stylesheet = _global[STYLESHEET_SETTING];
	        if (!_stylesheet || (_stylesheet._lastStyleElement && _stylesheet._lastStyleElement.ownerDocument !== document)) {
	            // tslint:disable-next-line:no-string-literal
	            var fabricConfig = (_global && _global['FabricConfig']) || {};
	            _stylesheet = _global[STYLESHEET_SETTING] = new Stylesheet(fabricConfig.mergeStyles);
	        }
	        return _stylesheet;
	    };
	    /**
	     * Configures the stylesheet.
	     */
	    Stylesheet.prototype.setConfig = function (config) {
	        this._config = tslib_1.__assign({}, this._config, config);
	    };
	    /**
	     * Configures a reset callback.
	     *
	     * @param callback - A callback which will be called when the Stylesheet is reset.
	     */
	    Stylesheet.prototype.onReset = function (callback) {
	        this._onResetCallbacks.push(callback);
	    };
	    /**
	     * Generates a unique classname.
	     *
	     * @param displayName - Optional value to use as a prefix.
	     */
	    Stylesheet.prototype.getClassName = function (displayName) {
	        var namespace = this._config.namespace;
	        var prefix = displayName || this._config.defaultPrefix;
	        return "" + (namespace ? namespace + '-' : '') + prefix + "-" + this._counter++;
	    };
	    /**
	     * Used internally to cache information about a class which was
	     * registered with the stylesheet.
	     */
	    Stylesheet.prototype.cacheClassName = function (className, key, args, rules) {
	        this._keyToClassName[key] = className;
	        this._classNameToArgs[className] = {
	            args: args,
	            rules: rules
	        };
	    };
	    /**
	     * Gets the appropriate classname given a key which was previously
	     * registered using cacheClassName.
	     */
	    Stylesheet.prototype.classNameFromKey = function (key) {
	        return this._keyToClassName[key];
	    };
	    /**
	     * Gets the arguments associated with a given classname which was
	     * previously registered using cacheClassName.
	     */
	    Stylesheet.prototype.argsFromClassName = function (className) {
	        var entry = this._classNameToArgs[className];
	        return entry && entry.args;
	    };
	    /**
	     * Gets the arguments associated with a given classname which was
	     * previously registered using cacheClassName.
	     */
	    Stylesheet.prototype.insertedRulesFromClassName = function (className) {
	        var entry = this._classNameToArgs[className];
	        return entry && entry.rules;
	    };
	    /**
	     * Inserts a css rule into the stylesheet.
	     * @param preserve - Preserves the rule beyond a reset boundary.
	     */
	    Stylesheet.prototype.insertRule = function (rule, preserve) {
	        var injectionMode = this._config.injectionMode;
	        var element = injectionMode !== exports.InjectionMode.none ? this._getStyleElement() : undefined;
	        if (preserve) {
	            this._preservedRules.push(rule);
	        }
	        if (element) {
	            switch (this._config.injectionMode) {
	                case exports.InjectionMode.insertNode:
	                    var sheet = element.sheet;
	                    try {
	                        sheet.insertRule(rule, sheet.cssRules.length);
	                    }
	                    catch (e) {
	                        // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
	                        // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
	                        // which could be slower and bulkier.
	                    }
	                    break;
	                case exports.InjectionMode.appendChild:
	                    element.appendChild(document.createTextNode(rule));
	                    break;
	            }
	        }
	        else {
	            this._rules.push(rule);
	        }
	        if (this._config.onInsertRule) {
	            this._config.onInsertRule(rule);
	        }
	    };
	    /**
	     * Gets all rules registered with the stylesheet; only valid when
	     * using InsertionMode.none.
	     */
	    Stylesheet.prototype.getRules = function (includePreservedRules) {
	        return (includePreservedRules ? this._preservedRules.join('') : '') + this._rules.join('') + this._rulesToInsert.join('');
	    };
	    /**
	     * Resets the internal state of the stylesheet. Only used in server
	     * rendered scenarios where we're using InsertionMode.none.
	     */
	    Stylesheet.prototype.reset = function () {
	        this._rules = [];
	        this._rulesToInsert = [];
	        this._counter = 0;
	        this._classNameToArgs = {};
	        this._keyToClassName = {};
	        this._onResetCallbacks.forEach(function (callback) { return callback(); });
	    };
	    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
	    Stylesheet.prototype.resetKeys = function () {
	        this._keyToClassName = {};
	    };
	    Stylesheet.prototype._getStyleElement = function () {
	        var _this = this;
	        if (!this._styleElement && typeof document !== 'undefined') {
	            this._styleElement = this._createStyleElement();
	            // Reset the style element on the next frame.
	            window.requestAnimationFrame(function () {
	                _this._styleElement = undefined;
	            });
	        }
	        return this._styleElement;
	    };
	    Stylesheet.prototype._createStyleElement = function () {
	        var styleElement = document.createElement('style');
	        styleElement.setAttribute('data-merge-styles', 'true');
	        styleElement.type = 'text/css';
	        var cspSettings = this._config.cspSettings;
	        if (cspSettings) {
	            if (cspSettings.nonce) {
	                styleElement.setAttribute('nonce', cspSettings.nonce);
	            }
	        }
	        if (this._lastStyleElement && this._lastStyleElement.nextElementSibling) {
	            document.head.insertBefore(styleElement, this._lastStyleElement.nextElementSibling);
	        }
	        else {
	            document.head.appendChild(styleElement);
	        }
	        this._lastStyleElement = styleElement;
	        return styleElement;
	    };
	    return Stylesheet;
	}());
	exports.Stylesheet = Stylesheet;
	//# sourceMappingURL=Stylesheet.js.map

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rules = {
	    MozOsxFontSmoothing: '-moz-osx-font-smoothing',
	    MsHighContrastAdjust: '-ms-high-contrast-adjust',
	    WebkitFontSmoothing: '-webkit-font-smoothing',
	    WebkitOverflowScrolling: '-webkit-overflow-scrolling',
	    WebkitTapHighlightColor: '-webkit-tap-highlight-color',
	    alignContent: 'align-content',
	    alignItems: 'align-items',
	    alignSelf: 'align-self',
	    animation: 'animation',
	    animationDelay: 'animation-delay',
	    animationDirection: 'animation-direction',
	    animationDuration: 'animation-duration',
	    animationFillMode: 'animation-fill-mode',
	    animationIterationCount: 'animation-iteration-count',
	    animationName: 'animation-name',
	    animationTimingFunction: 'animation-timing-function',
	    background: 'background',
	    backgroundClip: 'background-clip',
	    backgroundColor: 'background-color',
	    backgroundImage: 'background-image',
	    backgroundPosition: 'background-position',
	    border: 'border',
	    borderBottom: 'border-bottom',
	    borderBottomColor: 'border-bottom-color',
	    borderBottomStyle: 'border-bottom-style',
	    borderBottomWidth: 'border-bottom-width',
	    borderCollapse: 'border-collapse',
	    borderColor: 'border-color',
	    borderLeft: 'border-left',
	    borderRadius: 'border-radius',
	    borderRight: 'border-right',
	    borderStyle: 'border-style',
	    borderTop: 'border-top',
	    borderTopColor: 'border-top-color',
	    borderTopLeftRadius: 'border-top-left-radius',
	    borderTopRightRadius: 'border-top-right-radius',
	    borderTopStyle: 'border-top-style',
	    borderTopWidth: 'border-top-width',
	    borderWidth: 'border-width',
	    bordercolor: 'bordercolor',
	    bottom: 'bottom',
	    boxShadow: 'box-shadow',
	    boxSizing: 'box-sizing',
	    clear: 'clear',
	    color: 'color',
	    content: 'content',
	    cursor: 'cursor',
	    display: 'display',
	    fill: 'fill',
	    flex: 'flex',
	    flexBasis: 'flex-basis',
	    flexDirection: 'flex-direction',
	    flexGrow: 'flex-grow',
	    flexShrink: 'flex-shrink',
	    flexWrap: 'flex-wrap',
	    float: 'float',
	    font: 'font',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontStyle: 'font-style',
	    fontWeight: 'font-weight',
	    height: 'height',
	    justifyContent: 'justify-content',
	    left: 'left',
	    lineHeight: 'line-height',
	    listStyle: 'list-style',
	    listStyleType: 'list-style-type',
	    marginBottom: 'margin-bottom',
	    marginLeft: 'margin-left',
	    marginRight: 'margin-right',
	    marginTop: 'margin-top',
	    maxHeight: 'max-height',
	    maxWidth: 'max-width',
	    minHeight: 'min-height',
	    minWidth: 'min-width',
	    mozOsxFontSmoothing: 'moz-osx-font-smoothing',
	    objectFit: 'object-fit',
	    opacity: 'opacity',
	    order: 'order',
	    outline: 'outline',
	    outlineColor: 'outline-color',
	    outlineOffset: 'outline-offset',
	    overflow: 'overflow',
	    overflowWrap: 'overflow-wrap',
	    overflowX: 'overflow-x',
	    overflowY: 'overflow-y',
	    paddingBottom: 'padding-bottom',
	    paddingLeft: 'padding-left',
	    paddingRight: 'padding-right',
	    paddingTop: 'padding-top',
	    perspective: 'perspective',
	    pointerEvents: 'pointer-events',
	    position: 'position',
	    resize: 'resize',
	    right: 'right',
	    speak: 'speak',
	    src: 'src',
	    tableLayout: 'table-layout',
	    textAlign: 'text-align',
	    textDecoration: 'text-decoration',
	    textOverflow: 'text-overflow',
	    textTransform: 'text-transform',
	    top: 'top',
	    transform: 'transform',
	    transformOrigin: 'transform-origin',
	    transition: 'transition',
	    transitionDelay: 'transition-delay',
	    transitionDuration: 'transition-duration',
	    transitionProperty: 'transition-property',
	    transitionTimingFunction: 'transition-timing-function',
	    userSelect: 'user-select',
	    verticalAlign: 'vertical-align',
	    visibility: 'visibility',
	    webkitFontSmoothing: 'webkit-font-smoothing',
	    whiteSpace: 'white-space',
	    width: 'width',
	    wordBreak: 'word-break',
	    wordWrap: 'word-wrap',
	    zIndex: 'z-index'
	};
	function kebabRules(rulePairs, index) {
	    var rule = rulePairs[index];
	    rulePairs[index] = rules[rule] = rules[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
	}
	exports.kebabRules = kebabRules;
	//# sourceMappingURL=kebabRules.js.map

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getVendorSettings_1 = __webpack_require__(479);
	var autoPrefixNames = {
	    'user-select': 1
	};
	function prefixRules(rulePairs, index) {
	    var vendorSettings = getVendorSettings_1.getVendorSettings();
	    var name = rulePairs[index];
	    if (autoPrefixNames[name]) {
	        var value = rulePairs[index + 1];
	        if (autoPrefixNames[name]) {
	            if (vendorSettings.isWebkit) {
	                rulePairs.push('-webkit-' + name, value);
	            }
	            if (vendorSettings.isMoz) {
	                rulePairs.push('-moz-' + name, value);
	            }
	            if (vendorSettings.isMs) {
	                rulePairs.push('-ms-' + name, value);
	            }
	            if (vendorSettings.isOpera) {
	                rulePairs.push('-o-' + name, value);
	            }
	        }
	    }
	}
	exports.prefixRules = prefixRules;
	//# sourceMappingURL=prefixRules.js.map

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _vendorSettings;
	function getVendorSettings() {
	    if (!_vendorSettings) {
	        var doc = typeof document !== 'undefined' ? document : undefined;
	        var nav = typeof navigator !== 'undefined' ? navigator : undefined;
	        var userAgent = nav ? nav.userAgent.toLowerCase() : undefined;
	        if (!doc) {
	            _vendorSettings = {
	                isWebkit: true,
	                isMoz: true,
	                isOpera: true,
	                isMs: true
	            };
	        }
	        else {
	            _vendorSettings = {
	                isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
	                isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
	                isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
	                isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
	            };
	        }
	    }
	    return _vendorSettings;
	}
	exports.getVendorSettings = getVendorSettings;
	/**
	 * Sets the vendor settings for prefixing and vendor specific operations.
	 */
	function setVendorSettings(vendorSettings) {
	    _vendorSettings = vendorSettings;
	}
	exports.setVendorSettings = setVendorSettings;
	//# sourceMappingURL=getVendorSettings.js.map

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NON_PIXEL_NUMBER_PROPS = [
	    'column-count',
	    'font-weight',
	    'flex-basis',
	    'flex',
	    'flex-grow',
	    'flex-shrink',
	    'fill-opacity',
	    'opacity',
	    'order',
	    'z-index',
	    'zoom'
	];
	function provideUnits(rulePairs, index) {
	    var name = rulePairs[index];
	    var value = rulePairs[index + 1];
	    if (typeof value === 'number') {
	        var unit = NON_PIXEL_NUMBER_PROPS.indexOf(name) === -1 ? 'px' : '';
	        rulePairs[index + 1] = "" + value + unit;
	    }
	}
	exports.provideUnits = provideUnits;
	//# sourceMappingURL=provideUnits.js.map

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(476);
	var LEFT = 'left';
	var RIGHT = 'right';
	var NO_FLIP = '@noflip';
	var NAME_REPLACEMENTS = (_a = {},
	    _a[LEFT] = RIGHT,
	    _a[RIGHT] = LEFT,
	    _a);
	var VALUE_REPLACEMENTS = {
	    'w-resize': 'e-resize',
	    'sw-resize': 'se-resize',
	    'nw-resize': 'ne-resize'
	};
	var _rtl = getRTL();
	/**
	 * Sets the current RTL value.
	 */
	function setRTL(isRTL) {
	    if (_rtl !== isRTL) {
	        Stylesheet_1.Stylesheet.getInstance().resetKeys();
	        _rtl = isRTL;
	    }
	}
	exports.setRTL = setRTL;
	/**
	 * Gets the current RTL value.
	 */
	function getRTL() {
	    if (_rtl === undefined) {
	        _rtl = typeof document !== 'undefined' && !!document.documentElement && document.documentElement.getAttribute('dir') === 'rtl';
	    }
	    return _rtl;
	}
	exports.getRTL = getRTL;
	/**
	 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
	 * reasons.
	 */
	function rtlifyRules(rulePairs, index) {
	    if (getRTL()) {
	        var name_1 = rulePairs[index];
	        if (!name_1) {
	            return;
	        }
	        var value = rulePairs[index + 1];
	        if (typeof value === 'string' && value.indexOf(NO_FLIP) >= 0) {
	            rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
	        }
	        else if (name_1.indexOf(LEFT) >= 0) {
	            rulePairs[index] = name_1.replace(LEFT, RIGHT);
	        }
	        else if (name_1.indexOf(RIGHT) >= 0) {
	            rulePairs[index] = name_1.replace(RIGHT, LEFT);
	        }
	        else if (String(value).indexOf(LEFT) >= 0) {
	            rulePairs[index + 1] = value.replace(LEFT, RIGHT);
	        }
	        else if (String(value).indexOf(RIGHT) >= 0) {
	            rulePairs[index + 1] = value.replace(RIGHT, LEFT);
	        }
	        else if (NAME_REPLACEMENTS[name_1]) {
	            rulePairs[index] = NAME_REPLACEMENTS[name_1];
	        }
	        else if (VALUE_REPLACEMENTS[value]) {
	            rulePairs[index + 1] = VALUE_REPLACEMENTS[value];
	        }
	        else {
	            switch (name_1) {
	                case 'margin':
	                case 'padding':
	                    rulePairs[index + 1] = flipQuad(value);
	                    break;
	                case 'box-shadow':
	                    rulePairs[index + 1] = negateNum(value, 0);
	                    break;
	            }
	        }
	    }
	}
	exports.rtlifyRules = rtlifyRules;
	/**
	 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
	 */
	function negateNum(value, partIndex) {
	    var parts = value.split(' ');
	    var numberVal = parseInt(parts[partIndex], 10);
	    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
	    return parts.join(' ');
	}
	/**
	 * Given a string quad, flips the left and right values.
	 */
	function flipQuad(value) {
	    if (typeof value === 'string') {
	        var parts = value.split(' ');
	        if (parts.length === 4) {
	            return parts[0] + " " + parts[3] + " " + parts[2] + " " + parts[1];
	        }
	    }
	    return value;
	}
	var _a;
	//# sourceMappingURL=rtlifyRules.js.map

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(476);
	/**
	 * Separates the classes and style objects. Any classes that are pre-registered
	 * args are auto expanded into objects.
	 */
	function extractStyleParts() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    var objects = [];
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    function _processArgs(argsList) {
	        for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
	            var arg = argsList_1[_i];
	            if (arg) {
	                if (typeof arg === 'string') {
	                    if (arg.indexOf(' ') >= 0) {
	                        _processArgs(arg.split(' '));
	                    }
	                    else {
	                        var translatedArgs = stylesheet.argsFromClassName(arg);
	                        if (translatedArgs) {
	                            _processArgs(translatedArgs);
	                        }
	                        else {
	                            // Avoid adding the same class twice.
	                            if (classes.indexOf(arg) === -1) {
	                                classes.push(arg);
	                            }
	                        }
	                    }
	                }
	                else if (Array.isArray(arg)) {
	                    _processArgs(arg);
	                }
	                else if (typeof arg === 'object') {
	                    objects.push(arg);
	                }
	            }
	        }
	    }
	    _processArgs(args);
	    return {
	        classes: classes,
	        objects: objects
	    };
	}
	exports.extractStyleParts = extractStyleParts;
	//# sourceMappingURL=extractStyleParts.js.map

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var extractStyleParts_1 = __webpack_require__(482);
	var concatStyleSets_1 = __webpack_require__(484);
	var styleToClassName_1 = __webpack_require__(475);
	/**
	 * Takes in one or more style set objects, each consisting of a set of areas,
	 * each which will produce a class name. Using this is analogous to calling
	 * `mergeStyles` for each property in the object, but ensures we maintain the
	 * set ordering when multiple style sets are merged.
	 *
	 * @param styleSets - One or more style sets to be merged.
	 */
	function mergeStyleSets() {
	    var styleSets = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        styleSets[_i] = arguments[_i];
	    }
	    // tslint:disable-next-line:no-any
	    var classNameSet = { subComponentStyles: {} };
	    var classMap = {};
	    var styleSet = styleSets[0];
	    if (!styleSet && styleSets.length <= 1) {
	        return { subComponentStyles: {} };
	    }
	    var concatenatedStyleSet = 
	    // we have guarded against falsey values just above.
	    styleSet;
	    concatenatedStyleSet = concatStyleSets_1.concatStyleSets.apply(void 0, styleSets);
	    var registrations = [];
	    for (var styleSetArea in concatenatedStyleSet) {
	        if (concatenatedStyleSet.hasOwnProperty(styleSetArea)) {
	            if (styleSetArea === 'subComponentStyles') {
	                classNameSet.subComponentStyles = concatenatedStyleSet.subComponentStyles || {};
	                continue;
	            }
	            var styles = concatenatedStyleSet[styleSetArea];
	            var _a = extractStyleParts_1.extractStyleParts(styles), classes = _a.classes, objects = _a.objects;
	            var registration = styleToClassName_1.styleToRegistration({ displayName: styleSetArea }, objects);
	            registrations.push(registration);
	            if (registration) {
	                classMap[styleSetArea] = registration.className;
	                // as any cast not needed in ts >=2.9
	                classNameSet[styleSetArea] = classes.concat([registration.className]).join(' ');
	            }
	        }
	    }
	    for (var _b = 0, registrations_1 = registrations; _b < registrations_1.length; _b++) {
	        var registration = registrations_1[_b];
	        if (registration) {
	            styleToClassName_1.applyRegistration(registration, classMap);
	        }
	    }
	    return classNameSet;
	}
	exports.mergeStyleSets = mergeStyleSets;
	//# sourceMappingURL=mergeStyleSets.js.map

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Combine a set of styles together (but does not register css classes).
	 * @param styleSets - One or more stylesets to be merged (each param can also be falsy).
	 */
	function concatStyleSets() {
	    var styleSets = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        styleSets[_i] = arguments[_i];
	    }
	    if (styleSets && styleSets.length === 1 && styleSets[0] && !styleSets[0].subComponentStyles) {
	        return styleSets[0];
	    }
	    var mergedSet = {};
	    // We process sub component styles in two phases. First we collect them, then we combine them into 1 style function.
	    var workingSubcomponentStyles = {};
	    for (var _a = 0, styleSets_1 = styleSets; _a < styleSets_1.length; _a++) {
	        var currentSet = styleSets_1[_a];
	        if (currentSet) {
	            for (var prop in currentSet) {
	                if (currentSet.hasOwnProperty(prop)) {
	                    if (prop === 'subComponentStyles' && currentSet.subComponentStyles !== undefined) {
	                        // subcomponent styles - style functions or objects
	                        var currentComponentStyles = currentSet.subComponentStyles;
	                        for (var subCompProp in currentComponentStyles) {
	                            if (currentComponentStyles.hasOwnProperty(subCompProp)) {
	                                if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
	                                    workingSubcomponentStyles[subCompProp].push(currentComponentStyles[subCompProp]);
	                                }
	                                else {
	                                    workingSubcomponentStyles[subCompProp] = [currentComponentStyles[subCompProp]];
	                                }
	                            }
	                        }
	                        continue;
	                    }
	                    // the as any casts below is a workaround for ts 2.8.
	                    // todo: remove cast to any in ts 2.9.
	                    var mergedValue = mergedSet[prop];
	                    var currentValue = currentSet[prop];
	                    if (mergedValue === undefined) {
	                        mergedSet[prop] = currentValue;
	                    }
	                    else {
	                        mergedSet[prop] = (Array.isArray(mergedValue) ? mergedValue : [mergedValue]).concat((Array.isArray(currentValue) ? currentValue : [currentValue]));
	                    }
	                }
	            }
	        }
	    }
	    if (Object.keys(workingSubcomponentStyles).length > 0) {
	        mergedSet.subComponentStyles = {};
	        var mergedSubStyles = mergedSet.subComponentStyles;
	        var _loop_1 = function (subCompProp) {
	            if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
	                var workingSet_1 = workingSubcomponentStyles[subCompProp];
	                mergedSubStyles[subCompProp] = function (styleProps) {
	                    return concatStyleSets.apply(void 0, workingSet_1.map(function (styleFunctionOrObject) {
	                        return typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject;
	                    }));
	                };
	            }
	        };
	        // now we process the subcomponent styles if there are any
	        for (var subCompProp in workingSubcomponentStyles) {
	            _loop_1(subCompProp);
	        }
	    }
	    return mergedSet;
	}
	exports.concatStyleSets = concatStyleSets;
	//# sourceMappingURL=concatStyleSets.js.map

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(476);
	var styleToClassName_1 = __webpack_require__(475);
	/**
	 * Registers a font face.
	 * @public
	 */
	function fontFace(font) {
	    Stylesheet_1.Stylesheet.getInstance().insertRule("@font-face{" + styleToClassName_1.serializeRuleEntries(font) + "}", true);
	}
	exports.fontFace = fontFace;
	//# sourceMappingURL=fontFace.js.map

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(476);
	var styleToClassName_1 = __webpack_require__(475);
	/**
	 * Registers keyframe definitions.
	 *
	 * @public
	 */
	function keyframes(timeline) {
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var name = stylesheet.getClassName();
	    var rulesArray = [];
	    for (var prop in timeline) {
	        if (timeline.hasOwnProperty(prop)) {
	            rulesArray.push(prop, '{', styleToClassName_1.serializeRuleEntries(timeline[prop]), '}');
	        }
	    }
	    var rules = rulesArray.join('');
	    stylesheet.insertRule("@keyframes " + name + "{" + rules + "}", true);
	    stylesheet.cacheClassName(name, rules, [], ['keyframes', rules]);
	    return name;
	}
	exports.keyframes = keyframes;
	//# sourceMappingURL=keyframes.js.map

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// @uifabric/merge-styles@6.19.3
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('@uifabric/merge-styles', '6.19.3');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var utilities_1 = __webpack_require__(489);
	var merge_styles_1 = __webpack_require__(473);
	var ICON_SETTING_NAME = 'icons';
	var _iconSettings = utilities_1.GlobalSettings.getValue(ICON_SETTING_NAME, {
	    __options: {
	        disableWarnings: false,
	        warnOnMissingIcons: true
	    },
	    __remapped: {}
	});
	// Reset icon registration on stylesheet resets.
	var stylesheet = merge_styles_1.Stylesheet.getInstance();
	if (stylesheet && stylesheet.onReset) {
	    stylesheet.onReset(function () {
	        for (var name_1 in _iconSettings) {
	            if (_iconSettings.hasOwnProperty(name_1) && !!_iconSettings[name_1].subset) {
	                _iconSettings[name_1].subset.className = undefined;
	            }
	        }
	    });
	}
	/**
	 * Normalizes an icon name for consistent mapping.
	 * Current implementation is to convert the icon name to lower case.
	 *
	 * @param name - Icon name to normalize.
	 * @returns {string} Normalized icon name to use for indexing and mapping.
	 */
	var normalizeIconName = function (name) { return name.toLowerCase(); };
	/**
	 * Registers a given subset of icons.
	 *
	 * @param iconSubset - the icon subset definition.
	 */
	function registerIcons(iconSubset, options) {
	    var subset = tslib_1.__assign({}, iconSubset, { isRegistered: false, className: undefined });
	    var icons = iconSubset.icons;
	    // Grab options, optionally mix user provided ones on top.
	    options = options ? tslib_1.__assign({}, _iconSettings.__options, options) : _iconSettings.__options;
	    for (var iconName in icons) {
	        if (icons.hasOwnProperty(iconName)) {
	            var code = icons[iconName];
	            var normalizedIconName = normalizeIconName(iconName);
	            if (_iconSettings[normalizedIconName]) {
	                _warnDuplicateIcon(iconName);
	            }
	            else {
	                _iconSettings[normalizedIconName] = {
	                    code: code,
	                    subset: subset
	                };
	            }
	        }
	    }
	}
	exports.registerIcons = registerIcons;
	/**
	 * Unregisters icons by name.
	 *
	 * @param iconNames - List of icons to unregister.
	 */
	function unregisterIcons(iconNames) {
	    var options = _iconSettings.__options;
	    var _loop_1 = function (iconName) {
	        var normalizedIconName = normalizeIconName(iconName);
	        if (_iconSettings[normalizedIconName]) {
	            delete _iconSettings[normalizedIconName];
	        }
	        else {
	            // Warn that we are trying to delete an icon that doesn't exist
	            if (!options.disableWarnings) {
	                utilities_1.warn("The icon \"" + iconName + "\" tried to unregister but was not registered.");
	            }
	        }
	        // Delete any aliases for this iconName
	        if (_iconSettings.__remapped[normalizedIconName]) {
	            delete _iconSettings.__remapped[normalizedIconName];
	        }
	        // Delete any items that were an alias for this iconName
	        Object.keys(_iconSettings.__remapped).forEach(function (key) {
	            if (_iconSettings.__remapped[key] === normalizedIconName) {
	                delete _iconSettings.__remapped[key];
	            }
	        });
	    };
	    for (var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++) {
	        var iconName = iconNames_1[_i];
	        _loop_1(iconName);
	    }
	}
	exports.unregisterIcons = unregisterIcons;
	/**
	 * Remaps one icon name to another.
	 */
	function registerIconAlias(iconName, mappedToName) {
	    _iconSettings.__remapped[normalizeIconName(iconName)] = normalizeIconName(mappedToName);
	}
	exports.registerIconAlias = registerIconAlias;
	/**
	 * Gets an icon definition. If an icon is requested but the subset has yet to be registered,
	 * it will get registered immediately.
	 *
	 * @public
	 * @param name - Name of icon.
	 */
	function getIcon(name) {
	    var icon = undefined;
	    var options = _iconSettings.__options;
	    name = name ? normalizeIconName(name) : '';
	    name = _iconSettings.__remapped[name] || name;
	    if (name) {
	        icon = _iconSettings[name];
	        if (icon) {
	            var subset = icon.subset;
	            if (subset && subset.fontFace) {
	                if (!subset.isRegistered) {
	                    merge_styles_1.fontFace(subset.fontFace);
	                    subset.isRegistered = true;
	                }
	                if (!subset.className) {
	                    subset.className = merge_styles_1.mergeStyles(subset.style, {
	                        fontFamily: subset.fontFace.fontFamily,
	                        fontWeight: subset.fontFace.fontWeight || 'normal',
	                        fontStyle: subset.fontFace.fontStyle || 'normal'
	                    });
	                }
	            }
	        }
	        else {
	            if (!options.disableWarnings && options.warnOnMissingIcons) {
	                utilities_1.warn("The icon \"" + name + "\" was used but not registered. See http://aka.ms/fabric-icon-usage for more information.");
	            }
	        }
	    }
	    return icon;
	}
	exports.getIcon = getIcon;
	/**
	 * Sets the icon options.
	 *
	 * @public
	 */
	function setIconOptions(options) {
	    _iconSettings.__options = tslib_1.__assign({}, _iconSettings.__options, options);
	}
	exports.setIconOptions = setIconOptions;
	var _missingIcons = [];
	var _missingIconsTimer = undefined;
	function _warnDuplicateIcon(iconName) {
	    var options = _iconSettings.__options;
	    var warningDelay = 2000;
	    var maxIconsInMessage = 10;
	    if (!options.disableWarnings) {
	        _missingIcons.push(iconName);
	        if (_missingIconsTimer === undefined) {
	            _missingIconsTimer = setTimeout(function () {
	                utilities_1.warn("Some icons were re-registered. Applications should only call registerIcons for any given " +
	                    "icon once. Redefining what an icon is may have unintended consequences. Duplicates " +
	                    "include: \n" +
	                    _missingIcons.slice(0, maxIconsInMessage).join(', ') +
	                    (_missingIcons.length > maxIconsInMessage ? " (+ " + (_missingIcons.length - maxIconsInMessage) + " more)" : ''));
	                _missingIconsTimer = undefined;
	                _missingIcons = [];
	            }, warningDelay);
	        }
	    }
	}
	//# sourceMappingURL=icons.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(490), exports);
	tslib_1.__exportStar(__webpack_require__(493), exports);
	tslib_1.__exportStar(__webpack_require__(499), exports);
	tslib_1.__exportStar(__webpack_require__(508), exports);
	tslib_1.__exportStar(__webpack_require__(509), exports);
	tslib_1.__exportStar(__webpack_require__(494), exports);
	tslib_1.__exportStar(__webpack_require__(510), exports);
	tslib_1.__exportStar(__webpack_require__(511), exports);
	tslib_1.__exportStar(__webpack_require__(506), exports);
	tslib_1.__exportStar(__webpack_require__(512), exports);
	tslib_1.__exportStar(__webpack_require__(513), exports);
	tslib_1.__exportStar(__webpack_require__(514), exports);
	tslib_1.__exportStar(__webpack_require__(515), exports);
	tslib_1.__exportStar(__webpack_require__(516), exports);
	tslib_1.__exportStar(__webpack_require__(517), exports);
	tslib_1.__exportStar(__webpack_require__(518), exports);
	tslib_1.__exportStar(__webpack_require__(519), exports);
	tslib_1.__exportStar(__webpack_require__(520), exports);
	tslib_1.__exportStar(__webpack_require__(521), exports);
	tslib_1.__exportStar(__webpack_require__(522), exports);
	tslib_1.__exportStar(__webpack_require__(523), exports);
	tslib_1.__exportStar(__webpack_require__(524), exports);
	tslib_1.__exportStar(__webpack_require__(527), exports);
	tslib_1.__exportStar(__webpack_require__(525), exports);
	tslib_1.__exportStar(__webpack_require__(526), exports);
	tslib_1.__exportStar(__webpack_require__(529), exports);
	tslib_1.__exportStar(__webpack_require__(542), exports);
	tslib_1.__exportStar(__webpack_require__(543), exports);
	tslib_1.__exportStar(__webpack_require__(544), exports);
	tslib_1.__exportStar(__webpack_require__(528), exports);
	tslib_1.__exportStar(__webpack_require__(545), exports);
	tslib_1.__exportStar(__webpack_require__(504), exports);
	tslib_1.__exportStar(__webpack_require__(546), exports);
	tslib_1.__exportStar(__webpack_require__(505), exports);
	tslib_1.__exportStar(__webpack_require__(547), exports);
	tslib_1.__exportStar(__webpack_require__(549), exports);
	tslib_1.__exportStar(__webpack_require__(550), exports);
	tslib_1.__exportStar(__webpack_require__(551), exports);
	tslib_1.__exportStar(__webpack_require__(552), exports);
	tslib_1.__exportStar(__webpack_require__(495), exports);
	tslib_1.__exportStar(__webpack_require__(553), exports);
	tslib_1.__exportStar(__webpack_require__(554), exports);
	tslib_1.__exportStar(__webpack_require__(555), exports);
	tslib_1.__exportStar(__webpack_require__(556), exports);
	tslib_1.__exportStar(__webpack_require__(557), exports);
	tslib_1.__exportStar(__webpack_require__(559), exports);
	tslib_1.__exportStar(__webpack_require__(560), exports);
	tslib_1.__exportStar(__webpack_require__(496), exports);
	tslib_1.__exportStar(__webpack_require__(561), exports);
	tslib_1.__exportStar(__webpack_require__(564), exports);
	tslib_1.__exportStar(__webpack_require__(565), exports);
	tslib_1.__exportStar(__webpack_require__(566), exports);
	var setFocusVisibility_1 = __webpack_require__(567);
	exports.setFocusVisibility = setFocusVisibility_1.setFocusVisibility;
	var setSSR_1 = __webpack_require__(492);
	exports.setSSR = setSSR_1.setSSR;
	__webpack_require__(568);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	/**
	 * Bugs often appear in async code when stuff gets disposed, but async operations don't get canceled.
	 * This Async helper class solves these issues by tying async code to the lifetime of a disposable object.
	 *
	 * Usage: Anything class extending from BaseModel can access this helper via this.async. Otherwise create a
	 * new instance of the class and remember to call dispose() during your code's dispose handler.
	 *
	 * @public
	 */
	var Async = /** @class */ (function () {
	    // tslint:disable-next-line:no-any
	    function Async(parent, onError) {
	        this._timeoutIds = null;
	        this._immediateIds = null;
	        this._intervalIds = null;
	        this._animationFrameIds = null;
	        this._isDisposed = false;
	        this._parent = parent || null;
	        this._onErrorHandler = onError;
	        this._noop = function () {
	            /* do nothing */
	        };
	    }
	    /**
	     * Dispose function, clears all async operations.
	     */
	    Async.prototype.dispose = function () {
	        var id;
	        this._isDisposed = true;
	        this._parent = null;
	        // Clear timeouts.
	        if (this._timeoutIds) {
	            for (id in this._timeoutIds) {
	                if (this._timeoutIds.hasOwnProperty(id)) {
	                    this.clearTimeout(parseInt(id, 10));
	                }
	            }
	            this._timeoutIds = null;
	        }
	        // Clear immediates.
	        if (this._immediateIds) {
	            for (id in this._immediateIds) {
	                if (this._immediateIds.hasOwnProperty(id)) {
	                    this.clearImmediate(parseInt(id, 10));
	                }
	            }
	            this._immediateIds = null;
	        }
	        // Clear intervals.
	        if (this._intervalIds) {
	            for (id in this._intervalIds) {
	                if (this._intervalIds.hasOwnProperty(id)) {
	                    this.clearInterval(parseInt(id, 10));
	                }
	            }
	            this._intervalIds = null;
	        }
	        // Clear animation frames.
	        if (this._animationFrameIds) {
	            for (id in this._animationFrameIds) {
	                if (this._animationFrameIds.hasOwnProperty(id)) {
	                    this.cancelAnimationFrame(parseInt(id, 10));
	                }
	            }
	            this._animationFrameIds = null;
	        }
	    };
	    /**
	     * SetTimeout override, which will auto cancel the timeout during dispose.
	     * @param callback - Callback to execute.
	     * @param duration - Duration in milliseconds.
	     * @returns The setTimeout id.
	     */
	    Async.prototype.setTimeout = function (callback, duration) {
	        var _this = this;
	        var timeoutId = 0;
	        if (!this._isDisposed) {
	            if (!this._timeoutIds) {
	                this._timeoutIds = {};
	            }
	            /* tslint:disable:ban-native-functions */
	            timeoutId = setTimeout(function () {
	                // Time to execute the timeout, enqueue it as a foreground task to be executed.
	                try {
	                    // Now delete the record and call the callback.
	                    if (_this._timeoutIds) {
	                        delete _this._timeoutIds[timeoutId];
	                    }
	                    callback.apply(_this._parent);
	                }
	                catch (e) {
	                    if (_this._onErrorHandler) {
	                        _this._onErrorHandler(e);
	                    }
	                }
	            }, duration);
	            /* tslint:enable:ban-native-functions */
	            this._timeoutIds[timeoutId] = true;
	        }
	        return timeoutId;
	    };
	    /**
	     * Clears the timeout.
	     * @param id - Id to cancel.
	     */
	    Async.prototype.clearTimeout = function (id) {
	        if (this._timeoutIds && this._timeoutIds[id]) {
	            /* tslint:disable:ban-native-functions */
	            clearTimeout(id);
	            delete this._timeoutIds[id];
	            /* tslint:enable:ban-native-functions */
	        }
	    };
	    /**
	     * SetImmediate override, which will auto cancel the immediate during dispose.
	     * @param callback - Callback to execute.
	     * @param targetElement - Optional target element to use for identifying the correct window.
	     * @returns The setTimeout id.
	     */
	    Async.prototype.setImmediate = function (callback, targetElement) {
	        var _this = this;
	        var immediateId = 0;
	        var win = getWindow_1.getWindow(targetElement);
	        if (!this._isDisposed) {
	            if (!this._immediateIds) {
	                this._immediateIds = {};
	            }
	            /* tslint:disable:ban-native-functions */
	            var setImmediateCallback = function () {
	                // Time to execute the timeout, enqueue it as a foreground task to be executed.
	                try {
	                    // Now delete the record and call the callback.
	                    if (_this._immediateIds) {
	                        delete _this._immediateIds[immediateId];
	                    }
	                    callback.apply(_this._parent);
	                }
	                catch (e) {
	                    _this._logError(e);
	                }
	            };
	            immediateId = win.setTimeout(setImmediateCallback, 0);
	            /* tslint:enable:ban-native-functions */
	            this._immediateIds[immediateId] = true;
	        }
	        return immediateId;
	    };
	    /**
	     * Clears the immediate.
	     * @param id - Id to cancel.
	     * @param targetElement - Optional target element to use for identifying the correct window.
	     */
	    Async.prototype.clearImmediate = function (id, targetElement) {
	        var win = getWindow_1.getWindow(targetElement);
	        if (this._immediateIds && this._immediateIds[id]) {
	            /* tslint:disable:ban-native-functions */
	            win.clearTimeout(id);
	            delete this._immediateIds[id];
	            /* tslint:enable:ban-native-functions */
	        }
	    };
	    /**
	     * SetInterval override, which will auto cancel the timeout during dispose.
	     * @param callback - Callback to execute.
	     * @param duration - Duration in milliseconds.
	     * @returns The setTimeout id.
	     */
	    Async.prototype.setInterval = function (callback, duration) {
	        var _this = this;
	        var intervalId = 0;
	        if (!this._isDisposed) {
	            if (!this._intervalIds) {
	                this._intervalIds = {};
	            }
	            /* tslint:disable:ban-native-functions */
	            intervalId = setInterval(function () {
	                // Time to execute the interval callback, enqueue it as a foreground task to be executed.
	                try {
	                    callback.apply(_this._parent);
	                }
	                catch (e) {
	                    _this._logError(e);
	                }
	            }, duration);
	            /* tslint:enable:ban-native-functions */
	            this._intervalIds[intervalId] = true;
	        }
	        return intervalId;
	    };
	    /**
	     * Clears the interval.
	     * @param id - Id to cancel.
	     */
	    Async.prototype.clearInterval = function (id) {
	        if (this._intervalIds && this._intervalIds[id]) {
	            /* tslint:disable:ban-native-functions */
	            clearInterval(id);
	            delete this._intervalIds[id];
	            /* tslint:enable:ban-native-functions */
	        }
	    };
	    /**
	     * Creates a function that, when executed, will only call the func function at most once per
	     * every wait milliseconds. Provide an options object to indicate that func should be invoked
	     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
	     * function will return the result of the last func call.
	     *
	     * Note: If leading and trailing options are true func will be called on the trailing edge of
	     * the timeout only if the the throttled function is invoked more than once during the wait timeout.
	     *
	     * @param func - The function to throttle.
	     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
	     * @param options - The options object.
	     * @returns The new throttled function.
	     */
	    Async.prototype.throttle = function (func, wait, options) {
	        var _this = this;
	        if (this._isDisposed) {
	            return this._noop;
	        }
	        var waitMS = wait || 0;
	        var leading = true;
	        var trailing = true;
	        var lastExecuteTime = 0;
	        var lastResult;
	        // tslint:disable-next-line:no-any
	        var lastArgs;
	        var timeoutId = null;
	        if (options && typeof options.leading === 'boolean') {
	            leading = options.leading;
	        }
	        if (options && typeof options.trailing === 'boolean') {
	            trailing = options.trailing;
	        }
	        var callback = function (userCall) {
	            var now = new Date().getTime();
	            var delta = now - lastExecuteTime;
	            var waitLength = leading ? waitMS - delta : waitMS;
	            if (delta >= waitMS && (!userCall || leading)) {
	                lastExecuteTime = now;
	                if (timeoutId) {
	                    _this.clearTimeout(timeoutId);
	                    timeoutId = null;
	                }
	                lastResult = func.apply(_this._parent, lastArgs);
	            }
	            else if (timeoutId === null && trailing) {
	                timeoutId = _this.setTimeout(callback, waitLength);
	            }
	            return lastResult;
	        };
	        // tslint:disable-next-line:no-any
	        var resultFunction = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            lastArgs = args;
	            return callback(true);
	        };
	        return resultFunction;
	    };
	    /**
	     * Creates a function that will delay the execution of func until after wait milliseconds have
	     * elapsed since the last time it was invoked. Provide an options object to indicate that func
	     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
	     * to the debounced function will return the result of the last func call.
	     *
	     * Note: If leading and trailing options are true func will be called on the trailing edge of
	     * the timeout only if the the debounced function is invoked more than once during the wait
	     * timeout.
	     *
	     * @param func - The function to debounce.
	     * @param wait - The number of milliseconds to delay.
	     * @param options - The options object.
	     * @returns The new debounced function.
	     */
	    Async.prototype.debounce = function (func, wait, options) {
	        var _this = this;
	        if (this._isDisposed) {
	            var noOpFunction = (function () {
	                /** Do nothing */
	            });
	            noOpFunction.cancel = function () {
	                return;
	            };
	            /* tslint:disable:no-any */
	            noOpFunction.flush = (function () { return null; });
	            /* tslint:enable:no-any */
	            noOpFunction.pending = function () { return false; };
	            return noOpFunction;
	        }
	        var waitMS = wait || 0;
	        var leading = false;
	        var trailing = true;
	        var maxWait = null;
	        var lastCallTime = 0;
	        var lastExecuteTime = new Date().getTime();
	        var lastResult;
	        // tslint:disable-next-line:no-any
	        var lastArgs;
	        var timeoutId = null;
	        if (options && typeof options.leading === 'boolean') {
	            leading = options.leading;
	        }
	        if (options && typeof options.trailing === 'boolean') {
	            trailing = options.trailing;
	        }
	        if (options && typeof options.maxWait === 'number' && !isNaN(options.maxWait)) {
	            maxWait = options.maxWait;
	        }
	        var markExecuted = function (time) {
	            if (timeoutId) {
	                _this.clearTimeout(timeoutId);
	                timeoutId = null;
	            }
	            lastExecuteTime = time;
	        };
	        var invokeFunction = function (time) {
	            markExecuted(time);
	            lastResult = func.apply(_this._parent, lastArgs);
	        };
	        var callback = function (userCall) {
	            var now = new Date().getTime();
	            var executeImmediately = false;
	            if (userCall) {
	                if (leading && now - lastCallTime >= waitMS) {
	                    executeImmediately = true;
	                }
	                lastCallTime = now;
	            }
	            var delta = now - lastCallTime;
	            var waitLength = waitMS - delta;
	            var maxWaitDelta = now - lastExecuteTime;
	            var maxWaitExpired = false;
	            if (maxWait !== null) {
	                // maxWait only matters when there is a pending callback
	                if (maxWaitDelta >= maxWait && timeoutId) {
	                    maxWaitExpired = true;
	                }
	                else {
	                    waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
	                }
	            }
	            if (delta >= waitMS || maxWaitExpired || executeImmediately) {
	                invokeFunction(now);
	            }
	            else if ((timeoutId === null || !userCall) && trailing) {
	                timeoutId = _this.setTimeout(callback, waitLength);
	            }
	            return lastResult;
	        };
	        var pending = function () {
	            return !!timeoutId;
	        };
	        var cancel = function () {
	            if (pending()) {
	                // Mark the debounced function as having executed
	                markExecuted(new Date().getTime());
	            }
	        };
	        var flush = function () {
	            if (pending()) {
	                invokeFunction(new Date().getTime());
	            }
	            return lastResult;
	        };
	        // tslint:disable-next-line:no-any
	        var resultFunction = (function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            lastArgs = args;
	            return callback(true);
	        });
	        resultFunction.cancel = cancel;
	        resultFunction.flush = flush;
	        resultFunction.pending = pending;
	        return resultFunction;
	    };
	    Async.prototype.requestAnimationFrame = function (callback, targetElement) {
	        var _this = this;
	        var animationFrameId = 0;
	        var win = getWindow_1.getWindow(targetElement);
	        if (!this._isDisposed) {
	            if (!this._animationFrameIds) {
	                this._animationFrameIds = {};
	            }
	            /* tslint:disable:ban-native-functions */
	            var animationFrameCallback = function () {
	                try {
	                    // Now delete the record and call the callback.
	                    if (_this._animationFrameIds) {
	                        delete _this._animationFrameIds[animationFrameId];
	                    }
	                    callback.apply(_this._parent);
	                }
	                catch (e) {
	                    _this._logError(e);
	                }
	            };
	            animationFrameId = win.requestAnimationFrame
	                ? win.requestAnimationFrame(animationFrameCallback)
	                : win.setTimeout(animationFrameCallback, 0);
	            /* tslint:enable:ban-native-functions */
	            this._animationFrameIds[animationFrameId] = true;
	        }
	        return animationFrameId;
	    };
	    Async.prototype.cancelAnimationFrame = function (id, targetElement) {
	        var win = getWindow_1.getWindow(targetElement);
	        if (this._animationFrameIds && this._animationFrameIds[id]) {
	            /* tslint:disable:ban-native-functions */
	            win.cancelAnimationFrame ? win.cancelAnimationFrame(id) : win.clearTimeout(id);
	            /* tslint:enable:ban-native-functions */
	            delete this._animationFrameIds[id];
	        }
	    };
	    // tslint:disable-next-line:no-any
	    Async.prototype._logError = function (e) {
	        if (this._onErrorHandler) {
	            this._onErrorHandler(e);
	        }
	    };
	    return Async;
	}());
	exports.Async = Async;
	//# sourceMappingURL=Async.js.map

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var setSSR_1 = __webpack_require__(492);
	var _window = undefined;
	// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
	// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
	// Caching the window value at the file scope lets us minimize the impact.
	try {
	    _window = window;
	}
	catch (e) {
	    /* no-op */
	}
	/**
	 * Helper to get the window object. The helper will make sure to use a cached variable
	 * of "window", to avoid overhead and memory leaks in IE11. Note that in popup scenarios the
	 * window object won't match the "global" window object, and for these scenarios, you should
	 * pass in an element hosted within the popup.
	 *
	 * @public
	 */
	function getWindow(rootElement) {
	    if (setSSR_1._isSSR || typeof _window === 'undefined') {
	        return undefined;
	    }
	    else {
	        var el = rootElement;
	        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : _window;
	    }
	}
	exports.getWindow = getWindow;
	//# sourceMappingURL=getWindow.js.map

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports._isSSR = false;
	/**
	 * Helper to set ssr mode to simulate no window object returned from getWindow helper.
	 *
	 * @public
	 */
	function setSSR(isEnabled) {
	    exports._isSSR = isEnabled;
	}
	exports.setSSR = setSSR;
	//# sourceMappingURL=setSSR.js.map

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventGroup_1 = __webpack_require__(494);
	var scroll_1 = __webpack_require__(496);
	var getRect_1 = __webpack_require__(498);
	var SCROLL_ITERATION_DELAY = 16;
	var SCROLL_GUTTER_HEIGHT = 100;
	var MAX_SCROLL_VELOCITY = 15;
	/**
	 * AutoScroll simply hooks up mouse events given a parent element, and scrolls the container
	 * up/down depending on how close the mouse is to the top/bottom of the container.
	 *
	 * Once you don't want autoscroll any more, just dispose the helper and it will unhook events.
	 *
	 * @public
	 * {@docCategory AutoScroll}
	 */
	var AutoScroll = /** @class */ (function () {
	    function AutoScroll(element) {
	        this._events = new EventGroup_1.EventGroup(this);
	        this._scrollableParent = scroll_1.findScrollableParent(element);
	        this._incrementScroll = this._incrementScroll.bind(this);
	        this._scrollRect = getRect_1.getRect(this._scrollableParent);
	        // tslint:disable-next-line:no-any
	        if (this._scrollableParent === window) {
	            this._scrollableParent = document.body;
	        }
	        if (this._scrollableParent) {
	            this._events.on(window, 'mousemove', this._onMouseMove, true);
	            this._events.on(window, 'touchmove', this._onTouchMove, true);
	        }
	    }
	    AutoScroll.prototype.dispose = function () {
	        this._events.dispose();
	        this._stopScroll();
	    };
	    AutoScroll.prototype._onMouseMove = function (ev) {
	        this._computeScrollVelocity(ev.clientY);
	    };
	    AutoScroll.prototype._onTouchMove = function (ev) {
	        if (ev.touches.length > 0) {
	            this._computeScrollVelocity(ev.touches[0].clientY);
	        }
	    };
	    AutoScroll.prototype._computeScrollVelocity = function (clientY) {
	        if (!this._scrollRect) {
	            return;
	        }
	        var scrollRectTop = this._scrollRect.top;
	        var scrollClientBottom = scrollRectTop + this._scrollRect.height - SCROLL_GUTTER_HEIGHT;
	        if (clientY < scrollRectTop + SCROLL_GUTTER_HEIGHT) {
	            this._scrollVelocity = Math.max(-MAX_SCROLL_VELOCITY, -MAX_SCROLL_VELOCITY * ((SCROLL_GUTTER_HEIGHT - (clientY - scrollRectTop)) / SCROLL_GUTTER_HEIGHT));
	        }
	        else if (clientY > scrollClientBottom) {
	            this._scrollVelocity = Math.min(MAX_SCROLL_VELOCITY, MAX_SCROLL_VELOCITY * ((clientY - scrollClientBottom) / SCROLL_GUTTER_HEIGHT));
	        }
	        else {
	            this._scrollVelocity = 0;
	        }
	        if (this._scrollVelocity) {
	            this._startScroll();
	        }
	        else {
	            this._stopScroll();
	        }
	    };
	    AutoScroll.prototype._startScroll = function () {
	        if (!this._timeoutId) {
	            this._incrementScroll();
	        }
	    };
	    AutoScroll.prototype._incrementScroll = function () {
	        if (this._scrollableParent) {
	            this._scrollableParent.scrollTop += Math.round(this._scrollVelocity);
	        }
	        this._timeoutId = setTimeout(this._incrementScroll, SCROLL_ITERATION_DELAY);
	    };
	    AutoScroll.prototype._stopScroll = function () {
	        if (this._timeoutId) {
	            clearTimeout(this._timeoutId);
	            delete this._timeoutId;
	        }
	    };
	    return AutoScroll;
	}());
	exports.AutoScroll = AutoScroll;
	//# sourceMappingURL=AutoScroll.js.map

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:no-string-literal */
	var object_1 = __webpack_require__(495);
	/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
	 *  If the target is an HTMLElement, the event will be attached to the element and can be
	 *  triggered as usual (like clicking for onclick).
	 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
	 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
	 *  handled here in EventGroup, and the handler is called in the context of the parent
	 *  (which is passed in in the constructor).
	 *
	 * @public
	 * {@docCategory EventGroup}
	 */
	var EventGroup = /** @class */ (function () {
	    /** parent: the context in which events attached to non-HTMLElements are called */
	    // tslint:disable-next-line:no-any
	    function EventGroup(parent) {
	        this._id = EventGroup._uniqueId++;
	        this._parent = parent;
	        this._eventRecords = [];
	    }
	    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
	     *  Events raised here by default have bubbling set to false and cancelable set to true.
	     *  This applies also to built-in events being raised manually here on HTMLElements,
	     *  which may lead to unexpected behavior if it differs from the defaults.
	     *
	     */
	    EventGroup.raise = function (
	    // tslint:disable-next-line:no-any
	    target, eventName, 
	    // tslint:disable-next-line:no-any
	    eventArgs, bubbleEvent) {
	        var retVal;
	        if (EventGroup._isElement(target)) {
	            if (typeof document !== 'undefined' && document.createEvent) {
	                var ev = document.createEvent('HTMLEvents');
	                ev.initEvent(eventName, bubbleEvent || false, true);
	                object_1.assign(ev, eventArgs);
	                retVal = target.dispatchEvent(ev);
	                // tslint:disable-next-line:no-any
	            }
	            else if (typeof document !== 'undefined' && document['createEventObject']) {
	                // IE8
	                // tslint:disable-next-line:no-any
	                var evObj = document['createEventObject'](eventArgs);
	                // cannot set cancelBubble on evObj, fireEvent will overwrite it
	                target.fireEvent('on' + eventName, evObj);
	            }
	        }
	        else {
	            while (target && retVal !== false) {
	                var events = target.__events__;
	                var eventRecords = events ? events[eventName] : null;
	                if (eventRecords) {
	                    for (var id in eventRecords) {
	                        if (eventRecords.hasOwnProperty(id)) {
	                            var eventRecordList = eventRecords[id];
	                            for (var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++) {
	                                var record = eventRecordList[listIndex];
	                                if (record.objectCallback) {
	                                    retVal = record.objectCallback.call(record.parent, eventArgs);
	                                }
	                            }
	                        }
	                    }
	                }
	                // If the target has a parent, bubble the event up.
	                target = bubbleEvent ? target.parent : null;
	            }
	        }
	        return retVal;
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.isObserved = function (target, eventName) {
	        var events = target && target.__events__;
	        return !!events && !!events[eventName];
	    };
	    /** Check to see if the target has declared support of the given event. */
	    // tslint:disable-next-line:no-any
	    EventGroup.isDeclared = function (target, eventName) {
	        var declaredEvents = target && target.__declaredEvents;
	        return !!declaredEvents && !!declaredEvents[eventName];
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.stopPropagation = function (event) {
	        if (event.stopPropagation) {
	            event.stopPropagation();
	        }
	        else {
	            // IE8
	            event.cancelBubble = true;
	        }
	    };
	    EventGroup._isElement = function (target) {
	        return !!target && (!!target.addEventListener || (typeof HTMLElement !== 'undefined' && target instanceof HTMLElement));
	    };
	    EventGroup.prototype.dispose = function () {
	        if (!this._isDisposed) {
	            this._isDisposed = true;
	            this.off();
	            this._parent = null;
	        }
	    };
	    /** On the target, attach a set of events, where the events object is a name to function mapping. */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.onAll = function (target, events, useCapture) {
	        for (var eventName in events) {
	            if (events.hasOwnProperty(eventName)) {
	                this.on(target, eventName, events[eventName], useCapture);
	            }
	        }
	    };
	    /** On the target, attach an event whose handler will be called in the context of the parent
	     * of this instance of EventGroup.
	     */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.on = function (target, eventName, callback, options) {
	        var _this = this;
	        if (eventName.indexOf(',') > -1) {
	            var events = eventName.split(/[ ,]+/);
	            for (var i = 0; i < events.length; i++) {
	                this.on(target, events[i], callback, options);
	            }
	        }
	        else {
	            var parent_1 = this._parent;
	            var eventRecord = {
	                target: target,
	                eventName: eventName,
	                parent: parent_1,
	                callback: callback,
	                options: options
	            };
	            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
	            var events = (target.__events__ = target.__events__ || {});
	            events[eventName] =
	                events[eventName] ||
	                    {
	                        count: 0
	                    };
	            events[eventName][this._id] = events[eventName][this._id] || [];
	            events[eventName][this._id].push(eventRecord);
	            events[eventName].count++;
	            if (EventGroup._isElement(target)) {
	                // tslint:disable-next-line:no-any
	                var processElementEvent = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    if (_this._isDisposed) {
	                        return;
	                    }
	                    var result;
	                    try {
	                        result = callback.apply(parent_1, args);
	                        if (result === false && args[0]) {
	                            var e = args[0];
	                            if (e.preventDefault) {
	                                e.preventDefault();
	                            }
	                            if (e.stopPropagation) {
	                                e.stopPropagation();
	                            }
	                            e.cancelBubble = true;
	                        }
	                    }
	                    catch (e) {
	                        /* ErrorHelper.log(e); */
	                    }
	                    return result;
	                };
	                eventRecord.elementCallback = processElementEvent;
	                if (target.addEventListener) {
	                    /* tslint:disable:ban-native-functions */
	                    target.addEventListener(eventName, processElementEvent, options);
	                    /* tslint:enable:ban-native-functions */
	                }
	                else if (target.attachEvent) {
	                    // IE8
	                    target.attachEvent('on' + eventName, processElementEvent);
	                }
	            }
	            else {
	                // tslint:disable-next-line:no-any
	                var processObjectEvent = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    if (_this._isDisposed) {
	                        return;
	                    }
	                    return callback.apply(parent_1, args);
	                };
	                eventRecord.objectCallback = processObjectEvent;
	            }
	            // Remember the record locally, so that it can be removed.
	            this._eventRecords.push(eventRecord);
	        }
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.off = function (target, eventName, callback, options) {
	        for (var i = 0; i < this._eventRecords.length; i++) {
	            var eventRecord = this._eventRecords[i];
	            if ((!target || target === eventRecord.target) &&
	                (!eventName || eventName === eventRecord.eventName) &&
	                (!callback || callback === eventRecord.callback) &&
	                (typeof options !== 'boolean' || options === eventRecord.options)) {
	                var events = eventRecord.target.__events__;
	                var targetArrayLookup = events[eventRecord.eventName];
	                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
	                // We may have already target's entries, so check for null.
	                if (targetArray) {
	                    if (targetArray.length === 1 || !callback) {
	                        targetArrayLookup.count -= targetArray.length;
	                        delete events[eventRecord.eventName][this._id];
	                    }
	                    else {
	                        targetArrayLookup.count--;
	                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
	                    }
	                    if (!targetArrayLookup.count) {
	                        delete events[eventRecord.eventName];
	                    }
	                }
	                if (eventRecord.elementCallback) {
	                    if (eventRecord.target.removeEventListener) {
	                        eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.options);
	                    }
	                    else if (eventRecord.target.detachEvent) {
	                        // IE8
	                        eventRecord.target.detachEvent('on' + eventRecord.eventName, eventRecord.elementCallback);
	                    }
	                }
	                this._eventRecords.splice(i--, 1);
	            }
	        }
	    };
	    /** Trigger the given event in the context of this instance of EventGroup. */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.raise = function (eventName, eventArgs, bubbleEvent) {
	        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
	    };
	    /** Declare an event as being supported by this instance of EventGroup. */
	    EventGroup.prototype.declare = function (event) {
	        var declaredEvents = (this._parent.__declaredEvents = this._parent.__declaredEvents || {});
	        if (typeof event === 'string') {
	            declaredEvents[event] = true;
	        }
	        else {
	            for (var i = 0; i < event.length; i++) {
	                declaredEvents[event[i]] = true;
	            }
	        }
	    };
	    // tslint:disable-next-line:no-inferrable-types
	    EventGroup._uniqueId = 0;
	    return EventGroup;
	}());
	exports.EventGroup = EventGroup;
	//# sourceMappingURL=EventGroup.js.map

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var getWindow_1 = __webpack_require__(491);
	// Initialize global window id.
	var CURRENT_ID_PROPERTY = '__currentId__';
	var DEFAULT_ID_STRING = 'id__';
	// tslint:disable-next-line:no-any
	var _global = getWindow_1.getWindow() || {};
	if (_global[CURRENT_ID_PROPERTY] === undefined) {
	    _global[CURRENT_ID_PROPERTY] = 0;
	}
	// tslint:disable-next-line:no-any
	function checkProperties(a, b) {
	    for (var propName in a) {
	        if (a.hasOwnProperty(propName)) {
	            if (!b.hasOwnProperty(propName) || b[propName] !== a[propName]) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	/**
	 * Compares a to b and b to a.
	 *
	 * @public
	 */
	function shallowCompare(a, b) {
	    return checkProperties(a, b) && checkProperties(b, a);
	}
	exports.shallowCompare = shallowCompare;
	/**
	 * Makes a resulting merge of a bunch of objects. Pass in the target object followed by 1 or more
	 * objects as arguments and they will be merged sequentially into the target. Note that this will
	 * shallow merge; it will not create new cloned values for target members.
	 *
	 * @public
	 * @param target - Target object to merge following object arguments into.
	 * @param args - One or more objects that will be mixed into the target in the order they are provided.
	 * @returns Resulting merged target.
	 */
	// tslint:disable-next-line:no-any
	function assign(target) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    return filteredAssign.apply(this, [null, target].concat(args));
	}
	exports.assign = assign;
	/**
	 * Makes a resulting merge of a bunch of objects, but allows a filter function to be passed in to filter
	 * the resulting merges. This allows for scenarios where you want to merge "everything except that one thing"
	 * or "properties that start with data-". Note that this will shallow merge; it will not create new cloned
	 * values for target members.
	 *
	 * @public
	 * @param isAllowed - Callback to determine if the given propName is allowed in the result.
	 * @param target - Target object to merge following object arguments into.
	 * @param args - One or more objects that will be mixed into the target in the order they are provided.
	 * @returns Resulting merged target.
	 */
	// tslint:disable-next-line:no-any
	function filteredAssign(isAllowed, target) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    target = target || {};
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var sourceObject = args_1[_a];
	        if (sourceObject) {
	            for (var propName in sourceObject) {
	                if (sourceObject.hasOwnProperty(propName) && (!isAllowed || isAllowed(propName))) {
	                    target[propName] = sourceObject[propName];
	                }
	            }
	        }
	    }
	    return target;
	}
	exports.filteredAssign = filteredAssign;
	// Configure ids to reset on stylesheet resets.
	var stylesheet = merge_styles_1.Stylesheet.getInstance();
	if (stylesheet && stylesheet.onReset) {
	    stylesheet.onReset(resetIds);
	}
	/**
	 * Generates a unique id in the global scope (this spans across duplicate copies of the same library.)
	 *
	 * @public
	 */
	function getId(prefix) {
	    var index = _global[CURRENT_ID_PROPERTY]++;
	    return (prefix || DEFAULT_ID_STRING) + index;
	}
	exports.getId = getId;
	/**
	 * Resets id counter to an (optional) number.
	 *
	 * @public
	 */
	function resetIds(counter) {
	    if (counter === void 0) { counter = 0; }
	    _global[CURRENT_ID_PROPERTY] = counter;
	}
	exports.resetIds = resetIds;
	/* Takes an enum and iterates over each value of the enum (as a string), running the callback on each, returning a mapped array.
	 * The callback takes as a first parameter the string that represents the name of the entry, and the second parameter is the
	 * value of that entry, which is the value you'd normally use when using the enum (usually a number).
	 * */
	function mapEnumByName(
	// tslint:disable-next-line:no-any
	theEnum, callback) {
	    // map<any> to satisfy compiler since it doesn't realize we strip out undefineds in the .filter() call
	    return Object.keys(theEnum)
	        .map(function (p) {
	        // map on each property name as a string
	        if (String(Number(p)) !== p) {
	            // if the property is not just a number (because enums in TypeScript will map both ways)
	            return callback(p, theEnum[p]);
	        }
	    })
	        .filter(function (v) { return !!v; }); // only return elements with values
	}
	exports.mapEnumByName = mapEnumByName;
	/**
	 * Get all values in an object dictionary
	 *
	 * @param obj - The dictionary to get values for
	 */
	// tslint:disable-next-line:no-any
	function values(obj) {
	    return Object.keys(obj).reduce(function (arr, key) {
	        arr.push(obj[key]);
	        return arr;
	    }, []);
	}
	exports.values = values;
	//# sourceMappingURL=object.js.map

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getDocument_1 = __webpack_require__(497);
	var merge_styles_1 = __webpack_require__(473);
	var getWindow_1 = __webpack_require__(491);
	var _scrollbarWidth;
	var _bodyScrollDisabledCount = 0;
	var DisabledScrollClassName = merge_styles_1.mergeStyles({
	    overflow: 'hidden !important'
	});
	/**
	 * Placing this attribute on scrollable divs optimizes detection to know
	 * if the div is scrollable or not (given we can avoid expensive operations
	 * like getComputedStyle.)
	 *
	 * @public
	 */
	exports.DATA_IS_SCROLLABLE_ATTRIBUTE = 'data-is-scrollable';
	/**
	 * Allows the user to scroll within a element,
	 * while preventing the user from scrolling the body
	 */
	exports.allowScrollOnElement = function (element, events) {
	    if (!element) {
	        return;
	    }
	    var _previousClientY = 0;
	    var _element = null;
	    // remember the clientY for future calls of _preventOverscrolling
	    var _saveClientY = function (event) {
	        if (event.targetTouches.length === 1) {
	            _previousClientY = event.targetTouches[0].clientY;
	        }
	    };
	    // prevent the body from scrolling when the user attempts
	    // to scroll past the top or bottom of the element
	    var _preventOverscrolling = function (event) {
	        // only respond to a single-finger touch
	        if (event.targetTouches.length !== 1) {
	            return;
	        }
	        // prevent the body touchmove handler from firing
	        // so that scrolling is allowed within the element
	        event.stopPropagation();
	        if (!_element) {
	            return;
	        }
	        var clientY = event.targetTouches[0].clientY - _previousClientY;
	        var scrollableParent = findScrollableParent(event.target);
	        if (scrollableParent) {
	            _element = scrollableParent;
	        }
	        // if the element is scrolled to the top,
	        // prevent the user from scrolling up
	        if (_element.scrollTop === 0 && clientY > 0) {
	            event.preventDefault();
	        }
	        // if the element is scrolled to the bottom,
	        // prevent the user from scrolling down
	        if (_element.scrollHeight - _element.scrollTop <= _element.clientHeight && clientY < 0) {
	            event.preventDefault();
	        }
	    };
	    events.on(element, 'touchstart', _saveClientY, { passive: false });
	    events.on(element, 'touchmove', _preventOverscrolling, { passive: false });
	    _element = element;
	};
	var _disableIosBodyScroll = function (event) {
	    event.preventDefault();
	};
	/**
	 * Disables the body scrolling.
	 *
	 * @public
	 */
	function disableBodyScroll() {
	    var doc = getDocument_1.getDocument();
	    if (doc && doc.body && !_bodyScrollDisabledCount) {
	        doc.body.classList.add(DisabledScrollClassName);
	        doc.body.addEventListener('touchmove', _disableIosBodyScroll, { passive: false, capture: false });
	    }
	    _bodyScrollDisabledCount++;
	}
	exports.disableBodyScroll = disableBodyScroll;
	/**
	 * Enables the body scrolling.
	 *
	 * @public
	 */
	function enableBodyScroll() {
	    if (_bodyScrollDisabledCount > 0) {
	        var doc = getDocument_1.getDocument();
	        if (doc && doc.body && _bodyScrollDisabledCount === 1) {
	            doc.body.classList.remove(DisabledScrollClassName);
	            doc.body.removeEventListener('touchmove', _disableIosBodyScroll);
	        }
	        _bodyScrollDisabledCount--;
	    }
	}
	exports.enableBodyScroll = enableBodyScroll;
	/**
	 * Calculates the width of a scrollbar for the browser/os.
	 *
	 * @public
	 */
	function getScrollbarWidth() {
	    if (_scrollbarWidth === undefined) {
	        var scrollDiv = document.createElement('div');
	        scrollDiv.style.setProperty('width', '100px');
	        scrollDiv.style.setProperty('height', '100px');
	        scrollDiv.style.setProperty('overflow', 'scroll');
	        scrollDiv.style.setProperty('position', 'absolute');
	        scrollDiv.style.setProperty('top', '-9999px');
	        document.body.appendChild(scrollDiv);
	        // Get the scrollbar width
	        _scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        // Delete the DIV
	        document.body.removeChild(scrollDiv);
	    }
	    return _scrollbarWidth;
	}
	exports.getScrollbarWidth = getScrollbarWidth;
	/**
	 * Traverses up the DOM for the element with the data-is-scrollable=true attribute, or returns
	 * document.body.
	 *
	 * @public
	 */
	function findScrollableParent(startingElement) {
	    var el = startingElement;
	    var doc = getDocument_1.getDocument(startingElement);
	    // First do a quick scan for the scrollable attribute.
	    while (el && el !== doc.body) {
	        if (el.getAttribute(exports.DATA_IS_SCROLLABLE_ATTRIBUTE) === 'true') {
	            return el;
	        }
	        el = el.parentElement;
	    }
	    // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.
	    el = startingElement;
	    while (el && el !== doc.body) {
	        if (el.getAttribute(exports.DATA_IS_SCROLLABLE_ATTRIBUTE) !== 'false') {
	            var computedStyles = getComputedStyle(el);
	            var overflowY = computedStyles ? computedStyles.getPropertyValue('overflow-y') : '';
	            if (overflowY && (overflowY === 'scroll' || overflowY === 'auto')) {
	                return el;
	            }
	        }
	        el = el.parentElement;
	    }
	    // Fall back to window scroll.
	    if (!el || el === doc.body) {
	        // tslint:disable-next-line:no-any
	        el = getWindow_1.getWindow(startingElement);
	    }
	    return el;
	}
	exports.findScrollableParent = findScrollableParent;
	//# sourceMappingURL=scroll.js.map

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var setSSR_1 = __webpack_require__(492);
	/**
	 * Helper to get the document object. Note that in popup window cases, document
	 * might be the wrong document, which is why we look at ownerDocument for the
	 * truth. Also note that the SSR flag is used to test ssr scenarios even if
	 * document is defined (from JSDOM for example.)
	 *
	 * @public
	 */
	function getDocument(rootElement) {
	    if (setSSR_1._isSSR || typeof document === 'undefined') {
	        return undefined;
	    }
	    else {
	        var el = rootElement;
	        return el && el.ownerDocument ? el.ownerDocument : document;
	    }
	}
	exports.getDocument = getDocument;
	//# sourceMappingURL=getDocument.js.map

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to get bounding client rect. Passing in window will get the window size.
	 *
	 * @public
	 */
	function getRect(element) {
	    var rect;
	    if (element) {
	        if (element === window) {
	            rect = {
	                left: 0,
	                top: 0,
	                width: window.innerWidth,
	                height: window.innerHeight,
	                right: window.innerWidth,
	                bottom: window.innerHeight
	            };
	        }
	        else if (element.getBoundingClientRect) {
	            rect = element.getBoundingClientRect();
	        }
	    }
	    return rect;
	}
	exports.getRect = getRect;
	//# sourceMappingURL=getRect.js.map

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Async_1 = __webpack_require__(490);
	var EventGroup_1 = __webpack_require__(494);
	var warnConditionallyRequiredProps_1 = __webpack_require__(500);
	var warnMutuallyExclusive_1 = __webpack_require__(502);
	var warnDeprecations_1 = __webpack_require__(503);
	var initializeFocusRects_1 = __webpack_require__(504);
	var initializeDir_1 = __webpack_require__(507);
	/**
	 * BaseComponent class, which provides basic helpers for all components.
	 *
	 * @public
	 * {@docCategory BaseComponent}
	 */
	var BaseComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseComponent, _super);
	    // tslint:enable:variable-name
	    /**
	     * BaseComponent constructor
	     * @param props - The props for the component.
	     * @param context - The context for the component.
	     */
	    // tslint:disable-next-line:no-any
	    function BaseComponent(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        // Ensure basic assumptions about the environment.
	        initializeFocusRects_1.initializeFocusRects();
	        initializeDir_1.initializeDir();
	        _makeAllSafe(_this, BaseComponent.prototype, [
	            'componentDidMount',
	            'shouldComponentUpdate',
	            'getSnapshotBeforeUpdate',
	            'render',
	            'componentDidUpdate',
	            'componentWillUnmount'
	        ]);
	        return _this;
	    }
	    /**
	     * When the component receives props, make sure the componentRef is updated.
	     */
	    BaseComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
	        this._updateComponentRef(prevProps, this.props);
	    };
	    /**
	     * When the component has mounted, update the componentRef.
	     */
	    BaseComponent.prototype.componentDidMount = function () {
	        this._setComponentRef(this.props.componentRef, this);
	    };
	    /**
	     * If we have disposables, dispose them automatically on unmount.
	     */
	    BaseComponent.prototype.componentWillUnmount = function () {
	        this._setComponentRef(this.props.componentRef, null);
	        if (this.__disposables) {
	            for (var i = 0, len = this._disposables.length; i < len; i++) {
	                var disposable = this.__disposables[i];
	                if (disposable.dispose) {
	                    disposable.dispose();
	                }
	            }
	            this.__disposables = null;
	        }
	    };
	    Object.defineProperty(BaseComponent.prototype, "className", {
	        /**
	         * Gets the object's class name.
	         */
	        get: function () {
	            if (!this.__className) {
	                var funcNameRegex = /function (.{1,})\(/;
	                var results = funcNameRegex.exec(this.constructor.toString());
	                this.__className = results && results.length > 1 ? results[1] : '';
	            }
	            return this.__className;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseComponent.prototype, "_disposables", {
	        /**
	         * Allows subclasses to push things to this._disposables to be auto disposed.
	         */
	        get: function () {
	            if (!this.__disposables) {
	                this.__disposables = [];
	            }
	            return this.__disposables;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseComponent.prototype, "_async", {
	        /**
	         * Gets the async instance associated with the component, created on demand. The async instance gives
	         * subclasses a way to execute setTimeout/setInterval async calls safely, where the callbacks
	         * will be cleared/ignored automatically after unmounting. The helpers within the async object also
	         * preserve the this pointer so that you don't need to "bind" the callbacks.
	         */
	        get: function () {
	            if (!this.__async) {
	                this.__async = new Async_1.Async(this);
	                this._disposables.push(this.__async);
	            }
	            return this.__async;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseComponent.prototype, "_events", {
	        /**
	         * Gets the event group instance assocaited with the component, created on demand. The event instance
	         * provides on/off methods for listening to DOM (or regular javascript object) events. The event callbacks
	         * will be automatically disconnected after unmounting. The helpers within the events object also
	         * preserve the this reference so that you don't need to "bind" the callbacks.
	         */
	        get: function () {
	            if (!this.__events) {
	                this.__events = new EventGroup_1.EventGroup(this);
	                this._disposables.push(this.__events);
	            }
	            return this.__events;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Helper to return a memoized ref resolver function.
	     * @param refName - Name of the member to assign the ref to.
	     * @returns A function instance keyed from the given refname.
	     * @deprecated Use `createRef` from React.createRef.
	     */
	    BaseComponent.prototype._resolveRef = function (refName) {
	        var _this = this;
	        if (!this.__resolves) {
	            this.__resolves = {};
	        }
	        if (!this.__resolves[refName]) {
	            // tslint:disable-next-line:no-any
	            this.__resolves[refName] = function (ref) {
	                // tslint:disable-next-line:no-any
	                return (_this[refName] = ref);
	            };
	        }
	        return this.__resolves[refName];
	    };
	    /**
	     * Updates the componentRef (by calling it with "this" when necessary.)
	     */
	    BaseComponent.prototype._updateComponentRef = function (currentProps, newProps) {
	        if (newProps === void 0) { newProps = {}; }
	        // currentProps *should* always be defined, but verify that just in case a subclass is manually
	        // calling a lifecycle method with no parameters (which has happened) or other odd usage.
	        if (currentProps && newProps && currentProps.componentRef !== newProps.componentRef) {
	            this._setComponentRef(currentProps.componentRef, null);
	            this._setComponentRef(newProps.componentRef, this);
	        }
	    };
	    /**
	     * Warns when a deprecated props are being used.
	     *
	     * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
	     * either null or a replacement prop name.
	     */
	    BaseComponent.prototype._warnDeprecations = function (deprecationMap) {
	        warnDeprecations_1.warnDeprecations(this.className, this.props, deprecationMap);
	    };
	    /**
	     * Warns when props which are mutually exclusive with each other are both used.
	     *
	     * @param mutuallyExclusiveMap - The map of mutually exclusive props.
	     */
	    BaseComponent.prototype._warnMutuallyExclusive = function (mutuallyExclusiveMap) {
	        warnMutuallyExclusive_1.warnMutuallyExclusive(this.className, this.props, mutuallyExclusiveMap);
	    };
	    /**
	     * Warns when props are required if a condition is met.
	     *
	     * @param requiredProps - The name of the props that are required when the condition is met.
	     * @param conditionalPropName - The name of the prop that the condition is based on.
	     * @param condition - Whether the condition is met.
	     */
	    BaseComponent.prototype._warnConditionallyRequiredProps = function (requiredProps, conditionalPropName, condition) {
	        warnConditionallyRequiredProps_1.warnConditionallyRequiredProps(this.className, this.props, requiredProps, conditionalPropName, condition);
	    };
	    BaseComponent.prototype._setComponentRef = function (ref, value) {
	        if (!this._skipComponentRefResolution && ref) {
	            if (typeof ref === 'function') {
	                ref(value);
	            }
	            if (typeof ref === 'object') {
	                // tslint:disable:no-any
	                ref.current = value;
	            }
	        }
	    };
	    return BaseComponent;
	}(React.Component));
	exports.BaseComponent = BaseComponent;
	/**
	 * Helper to override a given method with a wrapper method that can try/catch the original, but also
	 * ensures that the BaseComponent's methods are called before the subclass's. This ensures that
	 * componentWillUnmount in the base is called and that things in the _disposables array are disposed.
	 */
	function _makeAllSafe(obj, prototype, methodNames) {
	    for (var i = 0, len = methodNames.length; i < len; i++) {
	        _makeSafe(obj, prototype, methodNames[i]);
	    }
	}
	function _makeSafe(obj, prototype, methodName) {
	    // tslint:disable:no-any
	    var classMethod = obj[methodName];
	    var prototypeMethod = prototype[methodName];
	    // tslint:enable:no-any
	    if (classMethod || prototypeMethod) {
	        // tslint:disable-next-line:no-any
	        obj[methodName] = function () {
	            var retVal;
	            if (prototypeMethod) {
	                retVal = prototypeMethod.apply(this, arguments);
	            }
	            if (classMethod !== prototypeMethod) {
	                retVal = classMethod.apply(this, arguments);
	            }
	            return retVal;
	        };
	    }
	}
	/**
	 * Simple constant function for returning null, used to render empty templates in JSX.
	 *
	 * @public
	 */
	function nullRender() {
	    return null;
	}
	exports.nullRender = nullRender;
	//# sourceMappingURL=BaseComponent.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var warn_1 = __webpack_require__(501);
	/**
	 * Warns when props are required if a condition is met.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param requiredProps - The name of the props that are required when the condition is met.
	 * @param conditionalPropName - The name of the prop that the condition is based on.
	 * @param condition - Whether the condition is met.
	 */
	function warnConditionallyRequiredProps(componentName, props, requiredProps, conditionalPropName, condition) {
	    if (condition === true && ("production") !== 'production') {
	        for (var _i = 0, requiredProps_1 = requiredProps; _i < requiredProps_1.length; _i++) {
	            var requiredPropName = requiredProps_1[_i];
	            if (!(requiredPropName in props)) {
	                warn_1.warn(componentName + " property '" + requiredPropName + "' is required when '" + conditionalPropName + "' is used.'");
	            }
	        }
	    }
	}
	exports.warnConditionallyRequiredProps = warnConditionallyRequiredProps;
	//# sourceMappingURL=warnConditionallyRequiredProps.js.map

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _warningCallback = undefined;
	/**
	 * Sends a warning to console, if the api is present.
	 *
	 * @public
	 * @param message - Warning message.
	 */
	function warn(message) {
	    if (_warningCallback && ("production") !== 'production') {
	        _warningCallback(message);
	    }
	    else if (console && console.warn) {
	        console.warn(message);
	    }
	}
	exports.warn = warn;
	/**
	 * Configures the warning callback. Passing in undefined will reset it to use the default
	 * console.warn function.
	 *
	 * @public
	 * @param warningCallback - Callback to override the generated warnings.
	 */
	function setWarningCallback(warningCallback) {
	    _warningCallback = warningCallback;
	}
	exports.setWarningCallback = setWarningCallback;
	//# sourceMappingURL=warn.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var warn_1 = __webpack_require__(501);
	/**
	 * Warns when two props which are mutually exclusive are both being used.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param exclusiveMap - A map where the key is a parameter, and the value is the other parameter.
	 */
	function warnMutuallyExclusive(componentName, props, exclusiveMap) {
	    if (false) {
	        for (var propName in exclusiveMap) {
	            if (props && props[propName] !== undefined) {
	                var propInExclusiveMapValue = exclusiveMap[propName];
	                if (propInExclusiveMapValue && props[propInExclusiveMapValue] !== undefined) {
	                    warn_1.warn(componentName + " property '" + propName + "' is mutually exclusive with '" + exclusiveMap[propName] + "'. Use one or the other.");
	                }
	            }
	        }
	    }
	}
	exports.warnMutuallyExclusive = warnMutuallyExclusive;
	//# sourceMappingURL=warnMutuallyExclusive.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var warn_1 = __webpack_require__(501);
	/**
	 * Warns when a deprecated props are being used.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
	 * either null or a replacement prop name.
	 */
	function warnDeprecations(componentName, props, deprecationMap) {
	    if (false) {
	        for (var propName in deprecationMap) {
	            if (props && propName in props) {
	                var deprecationMessage = componentName + " property '" + propName + "' was used but has been deprecated.";
	                var replacementPropName = deprecationMap[propName];
	                if (replacementPropName) {
	                    deprecationMessage += " Use '" + replacementPropName + "' instead.";
	                }
	                warn_1.warn(deprecationMessage);
	            }
	        }
	    }
	}
	exports.warnDeprecations = warnDeprecations;
	//# sourceMappingURL=warnDeprecations.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	var keyboard_1 = __webpack_require__(505);
	exports.IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
	/**
	 * Initializes the logic which:
	 *
	 * 1. Subscribes keydown and mousedown events. (It will only do it once per window,
	 *    so it's safe to call this method multiple times.)
	 * 2. When the user presses directional keyboard keys, adds the 'ms-Fabric--isFocusVisible' classname
	 *    to the document body.
	 * 3. When the user clicks a mouse button, we remove the classname if it exists.
	 *
	 * This logic allows components on the page to conditionally render focus treatments only
	 * if the global classname exists, which simplifies logic overall.
	 *
	 * @param window - the window used to add the event listeners
	 */
	function initializeFocusRects(window) {
	    var win = (window || getWindow_1.getWindow());
	    if (win && !win.__hasInitializeFocusRects__) {
	        win.__hasInitializeFocusRects__ = true;
	        win.addEventListener('mousedown', _onMouseDown, true);
	        win.addEventListener('keydown', _onKeyDown, true);
	    }
	}
	exports.initializeFocusRects = initializeFocusRects;
	function _onMouseDown(ev) {
	    var win = getWindow_1.getWindow(ev.target);
	    if (win) {
	        var classList = win.document.body.classList;
	        if (classList.contains(exports.IsFocusVisibleClassName)) {
	            classList.remove(exports.IsFocusVisibleClassName);
	        }
	    }
	}
	function _onKeyDown(ev) {
	    var win = getWindow_1.getWindow(ev.target);
	    if (win) {
	        var classList = win.document.body.classList;
	        if (keyboard_1.isDirectionalKeyCode(ev.which) && !classList.contains(exports.IsFocusVisibleClassName)) {
	            classList.add(exports.IsFocusVisibleClassName);
	        }
	    }
	}
	//# sourceMappingURL=initializeFocusRects.js.map

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KeyCodes_1 = __webpack_require__(506);
	var DirectionalKeyCodes = (_a = {},
	    _a[KeyCodes_1.KeyCodes.up] = 1,
	    _a[KeyCodes_1.KeyCodes.down] = 1,
	    _a[KeyCodes_1.KeyCodes.left] = 1,
	    _a[KeyCodes_1.KeyCodes.right] = 1,
	    _a[KeyCodes_1.KeyCodes.home] = 1,
	    _a[KeyCodes_1.KeyCodes.end] = 1,
	    _a[KeyCodes_1.KeyCodes.tab] = 1,
	    _a[KeyCodes_1.KeyCodes.pageUp] = 1,
	    _a[KeyCodes_1.KeyCodes.pageDown] = 1,
	    _a);
	/**
	 * Returns true if the keycode is a directional keyboard key.
	 */
	function isDirectionalKeyCode(which) {
	    return !!DirectionalKeyCodes[which];
	}
	exports.isDirectionalKeyCode = isDirectionalKeyCode;
	/**
	 * Adds a keycode to the list of keys that, when pressed, should cause the focus outlines to be visible.
	 * This can be used to add global shortcut keys that directionally move from section to section within
	 * an app or between focus trap zones.
	 */
	function addDirectionalKeyCode(which) {
	    DirectionalKeyCodes[which] = 1;
	}
	exports.addDirectionalKeyCode = addDirectionalKeyCode;
	var _a;
	//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
	 *
	 * @public
	 * {@docCategory KeyCodes}
	 */
	exports.KeyCodes = {
	    backspace: 8,
	    tab: 9,
	    enter: 13,
	    shift: 16,
	    ctrl: 17,
	    alt: 18,
	    pauseBreak: 19,
	    capslock: 20,
	    escape: 27,
	    space: 32,
	    pageUp: 33,
	    pageDown: 34,
	    end: 35,
	    home: 36,
	    left: 37,
	    up: 38,
	    right: 39,
	    down: 40,
	    insert: 45,
	    del: 46,
	    zero: 48,
	    one: 49,
	    two: 50,
	    three: 51,
	    four: 52,
	    five: 53,
	    six: 54,
	    seven: 55,
	    eight: 56,
	    nine: 57,
	    a: 65,
	    b: 66,
	    c: 67,
	    d: 68,
	    e: 69,
	    f: 70,
	    g: 71,
	    h: 72,
	    i: 73,
	    j: 74,
	    k: 75,
	    l: 76,
	    m: 77,
	    n: 78,
	    o: 79,
	    p: 80,
	    q: 81,
	    r: 82,
	    s: 83,
	    t: 84,
	    u: 85,
	    v: 86,
	    w: 87,
	    x: 88,
	    y: 89,
	    z: 90,
	    leftWindow: 91,
	    rightWindow: 92,
	    select: 93,
	    zero_numpad: 96,
	    one_numpad: 97,
	    two_numpad: 98,
	    three_numpad: 99,
	    four_numpad: 100,
	    five_numpad: 101,
	    six_numpad: 102,
	    seven_numpad: 103,
	    eight_numpad: 104,
	    nine_numpad: 105,
	    multiply: 106,
	    add: 107,
	    subtract: 109,
	    decimalPoint: 110,
	    divide: 111,
	    f1: 112,
	    f2: 113,
	    f3: 114,
	    f4: 115,
	    f5: 116,
	    f6: 117,
	    f7: 118,
	    f8: 119,
	    f9: 120,
	    f10: 121,
	    f11: 122,
	    f12: 123,
	    numlock: 144,
	    scrollLock: 145,
	    semicolon: 186,
	    equalSign: 187,
	    comma: 188,
	    dash: 189,
	    period: 190,
	    forwardSlash: 191,
	    graveAccent: 192,
	    openBracket: 219,
	    backSlash: 220,
	    closeBracket: 221,
	    singleQuote: 222
	};
	//# sourceMappingURL=KeyCodes.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	function initializeDir(win) {
	    var w = (win || getWindow_1.getWindow());
	    if (w && !w.__hasInitializedDir__) {
	        w.__hasInitializedDir__ = true;
	        // Ensure that the documentElement has a 'dir' attribute.
	        var documentElement = w.document.documentElement;
	        if (!documentElement.hasAttribute('dir')) {
	            documentElement.setAttribute('dir', 'ltr');
	        }
	    }
	}
	exports.initializeDir = initializeDir;
	//# sourceMappingURL=initializeDir.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	/**
	 * @deprecated This function uses the legacy context API, which is deprecated and should not be
	 * used in new code. Please migrate to the new context API. https://reactjs.org/docs/context.html
	 */
	function provideContext(contextTypes, mapPropsToContext) {
	    var Provider = /** @class */ (function (_super) {
	        tslib_1.__extends(Provider, _super);
	        function Provider() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        Provider.prototype.getChildContext = function () {
	            return mapPropsToContext(this.props);
	        };
	        Provider.prototype.render = function () {
	            return React.Children.only(this.props.children);
	        };
	        Provider.childContextTypes = contextTypes;
	        return Provider;
	    }(React.Component));
	    return Provider;
	}
	exports.provideContext = provideContext;
	//# sourceMappingURL=Context.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	/**
	 * Utility component for delaying the render of a child component after a given delay. This component
	 * requires a single child component; don't pass in many components. Wrap multiple components in a DIV
	 * if necessary.
	 *
	 * @public
	 * {@docCategory DelayedRender}
	 */
	var DelayedRender = /** @class */ (function (_super) {
	    tslib_1.__extends(DelayedRender, _super);
	    function DelayedRender(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            isRendered: false
	        };
	        return _this;
	    }
	    DelayedRender.prototype.componentDidMount = function () {
	        var _this = this;
	        var delay = this.props.delay;
	        this._timeoutId = setTimeout(function () {
	            _this.setState({
	                isRendered: true
	            });
	        }, delay);
	    };
	    DelayedRender.prototype.componentWillUnmount = function () {
	        if (this._timeoutId) {
	            clearTimeout(this._timeoutId);
	        }
	    };
	    DelayedRender.prototype.render = function () {
	        return this.state.isRendered ? React.Children.only(this.props.children) : null;
	    };
	    DelayedRender.defaultProps = {
	        delay: 0
	    };
	    return DelayedRender;
	}(React.Component));
	exports.DelayedRender = DelayedRender;
	//# sourceMappingURL=DelayedRender.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var now = function () { return (typeof performance !== 'undefined' && !!performance.now ? performance.now() : Date.now()); };
	var RESET_INTERVAL = 3 * 60 * 1000; // auto reset every 3 minutes
	/**
	 * Performance helper class for measuring things.
	 *
	 * @public
	 * {@docCategory FabricPerformance}
	 */
	var FabricPerformance = /** @class */ (function () {
	    function FabricPerformance() {
	    }
	    /**
	     * Measures execution time of the given syncronous function. If the same logic is executed multiple times,
	     * each individual measurement will be collected as well the overall numbers.
	     * @param name - The name of this measurement
	     * @param func - The logic to be measured for execution time
	     */
	    FabricPerformance.measure = function (name, func) {
	        if (FabricPerformance._timeoutId) {
	            FabricPerformance.setPeriodicReset();
	        }
	        var start = now();
	        func();
	        var end = now();
	        var measurement = FabricPerformance.summary[name] || {
	            totalDuration: 0,
	            count: 0,
	            all: []
	        };
	        var duration = end - start;
	        measurement.totalDuration += duration;
	        measurement.count++;
	        measurement.all.push({
	            duration: duration,
	            timeStamp: end
	        });
	        FabricPerformance.summary[name] = measurement;
	    };
	    FabricPerformance.reset = function () {
	        FabricPerformance.summary = {};
	        clearTimeout(FabricPerformance._timeoutId);
	        FabricPerformance._timeoutId = NaN;
	    };
	    FabricPerformance.setPeriodicReset = function () {
	        FabricPerformance._timeoutId = setTimeout(function () { return FabricPerformance.reset(); }, RESET_INTERVAL);
	    };
	    FabricPerformance.summary = {};
	    return FabricPerformance;
	}());
	exports.FabricPerformance = FabricPerformance;
	//# sourceMappingURL=FabricPerformance.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	/**
	 * Storing global state in local module variables has issues when more than one copy
	 * if the module gets loaded on the page (due to a bundling error or simply by consuming
	 * a prebundled script.)
	 *
	 * This file contains helpers to deal with the getting and setting local state, and allows
	 * callers to get called back when it mutates.
	 */
	// tslint:disable:no-any
	var GLOBAL_SETTINGS_PROP_NAME = '__globalSettings__';
	var CALLBACK_STATE_PROP_NAME = '__callbacks__';
	var _counter = 0;
	/**
	 * Global settings helper, which stores settings in the global (window) namespace.
	 * If window is not provided, it will store settings in module scope. Provides a
	 * way to observe changes as well when their values change.
	 *
	 * @public
	 * {@docCategory GlobalSettings}
	 */
	var GlobalSettings = /** @class */ (function () {
	    function GlobalSettings() {
	    }
	    GlobalSettings.getValue = function (key, defaultValue) {
	        var globalSettings = _getGlobalSettings();
	        if (globalSettings[key] === undefined) {
	            globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
	        }
	        return globalSettings[key];
	    };
	    GlobalSettings.setValue = function (key, value) {
	        var globalSettings = _getGlobalSettings();
	        var callbacks = globalSettings[CALLBACK_STATE_PROP_NAME];
	        var oldValue = globalSettings[key];
	        if (value !== oldValue) {
	            globalSettings[key] = value;
	            var changeDescription = {
	                oldValue: oldValue,
	                value: value,
	                key: key
	            };
	            for (var id in callbacks) {
	                if (callbacks.hasOwnProperty(id)) {
	                    callbacks[id](changeDescription);
	                }
	            }
	        }
	        return value;
	    };
	    GlobalSettings.addChangeListener = function (cb) {
	        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
	        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
	        var id = cb.__id__;
	        var callbacks = _getCallbacks();
	        if (!id) {
	            id = cb.__id__ = String(_counter++);
	        }
	        callbacks[id] = cb;
	    };
	    GlobalSettings.removeChangeListener = function (cb) {
	        var callbacks = _getCallbacks();
	        delete callbacks[cb.__id__];
	    };
	    return GlobalSettings;
	}());
	exports.GlobalSettings = GlobalSettings;
	function _getGlobalSettings() {
	    var win = getWindow_1.getWindow();
	    var globalObj = win || {};
	    if (!globalObj[GLOBAL_SETTINGS_PROP_NAME]) {
	        globalObj[GLOBAL_SETTINGS_PROP_NAME] = (_a = {},
	            _a[CALLBACK_STATE_PROP_NAME] = {},
	            _a);
	    }
	    return globalObj[GLOBAL_SETTINGS_PROP_NAME];
	    var _a;
	}
	function _getCallbacks() {
	    var globalSettings = _getGlobalSettings();
	    return globalSettings[CALLBACK_STATE_PROP_NAME];
	}
	//# sourceMappingURL=GlobalSettings.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Rectangle helper class.
	 *
	 * @public
	 * {@docCategory Rectangle}
	 */
	var Rectangle = /** @class */ (function () {
	    function Rectangle(left, right, top, bottom) {
	        if (left === void 0) { left = 0; }
	        if (right === void 0) { right = 0; }
	        if (top === void 0) { top = 0; }
	        if (bottom === void 0) { bottom = 0; }
	        this.top = top;
	        this.bottom = bottom;
	        this.left = left;
	        this.right = right;
	    }
	    Object.defineProperty(Rectangle.prototype, "width", {
	        /**
	         * Calculated automatically by subtracting the right from left
	         */
	        get: function () {
	            return this.right - this.left;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Rectangle.prototype, "height", {
	        /**
	         * Calculated automatically by subtracting the bottom from top.
	         */
	        get: function () {
	            return this.bottom - this.top;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Tests if another rect is approximately equal to this rect (within 4 decimal places.)
	     */
	    Rectangle.prototype.equals = function (rect) {
	        // I'm fixing it to 4 decimal places because it allows enough precision and will handle cases when something should be rounded,
	        // like .999999 should round to 1.
	        return (parseFloat(this.top.toFixed(4)) === parseFloat(rect.top.toFixed(4)) &&
	            parseFloat(this.bottom.toFixed(4)) === parseFloat(rect.bottom.toFixed(4)) &&
	            parseFloat(this.left.toFixed(4)) === parseFloat(rect.left.toFixed(4)) &&
	            parseFloat(this.right.toFixed(4)) === parseFloat(rect.right.toFixed(4)));
	    };
	    return Rectangle;
	}());
	exports.Rectangle = Rectangle;
	//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	"use strict";
	// tslint:disable:no-any
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns a single function which will call each of the given functions in the context of the
	 * parent.
	 */
	function appendFunction(parent) {
	    var functions = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        functions[_i - 1] = arguments[_i];
	    }
	    if (functions.length < 2) {
	        return functions[0];
	    }
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        functions.forEach(function (f) { return f && f.apply(parent, args); });
	    };
	}
	exports.appendFunction = appendFunction;
	//# sourceMappingURL=appendFunction.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * ARIA helper to concatenate attributes, returning undefined if all attributes
	 * are undefined. (Empty strings are not a valid ARIA attribute value.)
	 *
	 * @param ariaAttributes - ARIA attributes to merge
	 */
	function mergeAriaAttributeValues() {
	    var ariaAttributes = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        ariaAttributes[_i] = arguments[_i];
	    }
	    var mergedAttribute = ariaAttributes
	        .filter(function (arg) { return arg; })
	        .join(' ')
	        .trim();
	    return mergedAttribute === '' ? undefined : mergedAttribute;
	}
	exports.mergeAriaAttributeValues = mergeAriaAttributeValues;
	//# sourceMappingURL=aria.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to find the index of an item within an array, using a callback to
	 * determine the match.
	 *
	 * @public
	 * @param array - Array to search.
	 * @param cb - Callback which returns true on matches.
	 */
	function findIndex(array, cb) {
	    var index = -1;
	    for (var i = 0; array && i < array.length; i++) {
	        if (cb(array[i], i)) {
	            index = i;
	            break;
	        }
	    }
	    return index;
	}
	exports.findIndex = findIndex;
	/**
	 * Helper to find the first item within an array that satisfies the callback.
	 * @param array - Array to search
	 * @param cb - Callback which returns true on matches
	 */
	function find(array, cb) {
	    var index = findIndex(array, cb);
	    if (index < 0) {
	        return undefined;
	    }
	    return array[index];
	}
	exports.find = find;
	/**
	 * Creates an array of a given size and helper method to populate.
	 *
	 * @public
	 * @param size - Size of array.
	 * @param getItem - Callback to populate given cell index.
	 */
	function createArray(size, getItem) {
	    var array = [];
	    for (var i = 0; i < size; i++) {
	        array.push(getItem(i));
	    }
	    return array;
	}
	exports.createArray = createArray;
	/**
	 * Convert the given array to a matrix with columnCount number
	 * of columns.
	 *
	 * @public
	 * @param items - The array to convert
	 * @param columnCount - The number of columns for the resulting matrix
	 * @returns A matrix of items
	 */
	function toMatrix(items, columnCount) {
	    return items.reduce(function (rows, currentValue, index) {
	        if (index % columnCount === 0) {
	            rows.push([currentValue]);
	        }
	        else {
	            rows[rows.length - 1].push(currentValue);
	        }
	        return rows;
	    }, []);
	}
	exports.toMatrix = toMatrix;
	/**
	 * Given an array, it returns a new array that does not contain the item at the given index.
	 * @param array - The array to operate on
	 * @param index - The index of the element to remove
	 */
	function removeIndex(array, index) {
	    return array.filter(function (_, i) { return index !== i; });
	}
	exports.removeIndex = removeIndex;
	/**
	 * Given an array, this function returns a new array where the element at a given index has been replaced.
	 * @param array - The array to operate on
	 * @param newElement - The element that will be placed in the new array
	 * @param index - The index of the element that should be replaced
	 */
	function replaceElement(array, newElement, index) {
	    var copy = array.slice();
	    copy[index] = newElement;
	    return copy;
	}
	exports.replaceElement = replaceElement;
	/**
	 * Given an array, this function returns a new array where an element has been inserted at the given index.
	 * @param array - The array to operate on
	 * @param index - The index where an element should be inserted
	 * @param itemToAdd - The element to insert
	 */
	function addElementAtIndex(array, index, itemToAdd) {
	    var copy = array.slice();
	    copy.splice(index, 0, itemToAdd);
	    return copy;
	}
	exports.addElementAtIndex = addElementAtIndex;
	/**
	 * Given an array where each element is of type T or T[], flatten it into an array of T
	 * @param array - The array where each element can optionally also be an array
	 */
	function flatten(array) {
	    var result = [];
	    array.forEach(function (item) { return (result = result.concat(item)); });
	    return result;
	}
	exports.flatten = flatten;
	/**
	 * Returns a boolean indicating if the two given arrays are equal in length and values.
	 *
	 * @param array1 - First array to compare
	 * @param array2 - Second array to compare
	 * @returns True if the arrays are the same length and have the same values in the same positions, false otherwise.
	 */
	function arraysEqual(array1, array2) {
	    if (array1.length !== array2.length) {
	        return false;
	    }
	    for (var i = 0; i < array1.length; i++) {
	        if (array1[i] !== array2[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.arraysEqual = arraysEqual;
	//# sourceMappingURL=array.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * asAsync - a HOC for async loading components.
	 *
	 * Usage:
	 *
	 * const AsyncDialog = asAsync({
	 *   load: () => import('Dialog').then(result => result.default),
	 * });
	 *
	 * React.render(domElement, <AsyncDialog asyncPlaceholder={ () => <Spinner/> } { ...dialogProps } />);
	 *
	 * Note the `asyncPlaceholder` prop will be respected when rendering the async component and it hasn't
	 * been loaded yet.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	/**
	 * If possible, use a WeakMap to maintain a cache of loaded components.
	 * This can be used to synchronously render components that have already been loaded,
	 * rather than having to wait for at least one async tick.
	 */
	var _syncModuleCache = typeof WeakMap !== 'undefined'
	    ? // tslint:disable-next-line:no-any
	        new WeakMap()
	    : undefined;
	/**
	 * Produces a component which internally loads the target component before first mount.
	 * The component passes all props through to the loaded component.
	 *
	 * This overload accepts a module with a default export for the component.
	 */
	function asAsync(options) {
	    var Async = /** @class */ (function (_super) {
	        tslib_1.__extends(Async, _super);
	        function Async() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.state = {
	                Component: _syncModuleCache ? _syncModuleCache.get(options.load) : undefined
	            };
	            return _this;
	        }
	        Async.prototype.render = function () {
	            // Typescript issue: the rest can't be pulled without the any cast, as TypeScript fails with rest on generics.
	            // tslint:disable-next-line:no-any
	            var _a = this.props, forwardedRef = _a.forwardedRef, Placeholder = _a.asyncPlaceholder, rest = tslib_1.__rest(_a, ["forwardedRef", "asyncPlaceholder"]);
	            var Component = this.state.Component;
	            return Component ? React.createElement(Component, tslib_1.__assign({ ref: forwardedRef }, rest)) : Placeholder ? React.createElement(Placeholder, null) : null;
	        };
	        Async.prototype.componentDidMount = function () {
	            var _this = this;
	            var Component = this.state.Component;
	            if (!Component) {
	                options
	                    .load()
	                    .then(function (LoadedComponent) {
	                    if (LoadedComponent) {
	                        // Cache component for future reference.
	                        _syncModuleCache && _syncModuleCache.set(options.load, LoadedComponent);
	                        // Set state.
	                        _this.setState({
	                            Component: LoadedComponent
	                        }, options.onLoad);
	                    }
	                })
	                    .catch(options.onError);
	            }
	        };
	        return Async;
	    }(React.Component));
	    return React.forwardRef(function (props, ref) { return (React.createElement(Async, tslib_1.__assign({}, props, { forwardedRef: ref }))); });
	}
	exports.asAsync = asAsync;
	//# sourceMappingURL=asAsync.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * AssertNever is a utility function that can be used for exhaustiveness checks in switch statements.
	 *
	 * @public
	 */
	function assertNever(x) {
	    throw new Error('Unexpected object: ' + x);
	}
	exports.assertNever = assertNever;
	//# sourceMappingURL=assertNever.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Autobind is a utility for binding methods in a class. This simplifies tagging methods as being "bound" to the this pointer
	 * so that they can be used in scenarios that simply require a function callback.
	 * @deprecated This has been deprecated in favor of using arrow function properties
	 */
	function autobind(
	// tslint:disable-next-line:no-any
	target, key, descriptor) {
	    var fn = descriptor.value;
	    var defining = false;
	    return {
	        configurable: true,
	        get: function () {
	            if (defining || (fn && this === fn.prototype) || this.hasOwnProperty(key)) {
	                return fn;
	            }
	            // Bind method only once, and update the property to return the bound value from now on
	            var fnBound = fn && fn.bind(this);
	            defining = true;
	            Object.defineProperty(this, key, {
	                configurable: true,
	                writable: true,
	                enumerable: true,
	                value: fnBound
	            });
	            defining = false;
	            return fnBound;
	        },
	        // tslint:disable-next-line:no-any
	        set: function (newValue) {
	            Object.defineProperty(this, key, {
	                configurable: true,
	                writable: true,
	                enumerable: true,
	                value: newValue
	            });
	        }
	    };
	}
	exports.autobind = autobind;
	//# sourceMappingURL=autobind.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var MAX_CACHE_COUNT = 50;
	var _memoizedClassNames = 0;
	var stylesheet = merge_styles_1.Stylesheet.getInstance();
	if (stylesheet && stylesheet.onReset) {
	    stylesheet.onReset(function () { return _memoizedClassNames++; });
	}
	// Note that because of the caching nature within the classNames memoization,
	// I've disabled this rule to simply be able to work with any types.
	// tslint:disable:no-any
	// This represents a prop we attach to each Map to indicate the cached return value
	// associated with the graph node.
	var RetVal = '__retval__';
	/**
	 * Creates a getClassNames function which calls getStyles given the props, and injects them
	 * into mergeStyleSets.
	 *
	 * Note that the props you pass in on every render should be in the same order and
	 * immutable (numbers, strings, and booleans). This will allow the results to be memoized. Violating
	 * these will cause extra recalcs to occur.
	 */
	function classNamesFunction(options) {
	    // We build a trie where each node is a Map. The map entry key represents an argument
	    // value, and the entry value is another node (Map). Each node has a `__retval__`
	    // property which is used to hold the cached response.
	    if (options === void 0) { options = {}; }
	    // To derive the response, we can simply ensure the arguments are added or already
	    // exist in the trie. At the last node, if there is a `__retval__` we return that. Otherwise
	    // we call the `getStyles` api to evaluate, cache on the property, and return that.
	    var map = new Map();
	    var resultCount = 0;
	    var currentMemoizedClassNames = _memoizedClassNames;
	    var getClassNames = function (styleFunctionOrObject, styleProps) {
	        if (styleProps === void 0) { styleProps = {}; }
	        var current = map;
	        var disableCaching = options.disableCaching;
	        // On reset of our stylesheet, reset memoized cache.
	        if (currentMemoizedClassNames !== _memoizedClassNames) {
	            currentMemoizedClassNames = _memoizedClassNames;
	            map = new Map();
	            resultCount = 0;
	        }
	        if (!options.disableCaching) {
	            current = _traverseMap(map, styleFunctionOrObject);
	            current = _traverseMap(current, styleProps);
	        }
	        if (disableCaching || !current[RetVal]) {
	            if (styleFunctionOrObject === undefined) {
	                current[RetVal] = {};
	            }
	            else {
	                current[RetVal] = merge_styles_1.mergeStyleSets(typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject);
	            }
	            if (!disableCaching) {
	                resultCount++;
	            }
	        }
	        if (resultCount > MAX_CACHE_COUNT) {
	            map.clear();
	            resultCount = 0;
	            // Mutate the options passed in, that's all we can do.
	            options.disableCaching = true;
	            // Note: this code is great for debugging problems with styles being recaculated, but commenting it out
	            // to avoid confusing consumers.
	            // if (process.env.NODE_ENV !== 'production') {
	            //  console.log('Styles are being recalculated far too frequently. Something is mutating the class over and over.');
	            //  // tslint:disable-next-line:no-console
	            //  console.trace();
	            // }
	        }
	        // Note: the RetVal is an attached property on the Map; not a key in the Map. We use this attached property to
	        // cache the return value for this branch of the graph.
	        return current[RetVal];
	    };
	    return getClassNames;
	}
	exports.classNamesFunction = classNamesFunction;
	function _derive(obj) {
	    return typeof obj === 'function' ? obj(this) : obj;
	}
	function _traverseEdge(current, value) {
	    value = _normalizeValue(value);
	    if (!current.has(value)) {
	        current.set(value, new Map());
	    }
	    return current.get(value);
	}
	function _traverseMap(current, inputs) {
	    // The styled helper will generate the styles function and will attach the cached
	    // inputs (consisting of the default styles, customzied styles, and user provided styles.)
	    // These should be used as cache keys for deriving the memoized value.
	    if (typeof inputs === 'function' && inputs.__cachedInputs__) {
	        for (var _i = 0, _a = inputs.__cachedInputs__; _i < _a.length; _i++) {
	            var input = _a[_i];
	            current = _traverseEdge(current, input);
	        }
	    }
	    else if (typeof inputs === 'object') {
	        for (var propName in inputs) {
	            if (inputs.hasOwnProperty(propName)) {
	                current = _traverseEdge(current, inputs[propName]);
	            }
	        }
	    }
	    return current;
	}
	function _normalizeValue(value) {
	    switch (value) {
	        case undefined:
	            return '__undefined__';
	        case null:
	            return '__null__';
	        default:
	            return value;
	    }
	}
	//# sourceMappingURL=classNamesFunction.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @deprecated Use React.createRef.
	 * May be removed in 6 months (Jan '19).
	 */
	function createRef() {
	    var refObject = (function (element) {
	        refObject.current = element;
	    });
	    // This getter is here to support the deprecated value prop on the refObject.
	    Object.defineProperty(refObject, 'value', {
	        get: function () {
	            return refObject.current;
	        }
	    });
	    refObject.current = null;
	    return refObject;
	}
	exports.createRef = createRef;
	//# sourceMappingURL=createRef.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Concatination helper, which can merge class names together. Skips over falsey values.
	 *
	 * @public
	 */
	function css() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var arg = args_1[_a];
	        if (arg) {
	            if (typeof arg === 'string') {
	                classes.push(arg);
	            }
	            else if (arg.hasOwnProperty('toString') && typeof arg.toString === 'function') {
	                classes.push(arg.toString());
	            }
	            else {
	                // tslint:disable-next-line:no-any
	                for (var key in arg) {
	                    // tslint:disable-next-line:no-any
	                    if (arg[key]) {
	                        classes.push(key);
	                    }
	                }
	            }
	        }
	    }
	    return classes.join(' ');
	}
	exports.css = css;
	//# sourceMappingURL=css.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var GlobalSettings_1 = __webpack_require__(511);
	var CustomizationsGlobalKey = 'customizations';
	var NO_CUSTOMIZATIONS = { settings: {}, scopedSettings: {}, inCustomizerContext: false };
	var _allSettings = GlobalSettings_1.GlobalSettings.getValue(CustomizationsGlobalKey, {
	    settings: {},
	    scopedSettings: {},
	    inCustomizerContext: false
	});
	var _events = [];
	var Customizations = /** @class */ (function () {
	    function Customizations() {
	    }
	    Customizations.reset = function () {
	        _allSettings.settings = {};
	        _allSettings.scopedSettings = {};
	    };
	    /** Apply global Customization settings.
	     * @example Customizations.applySettings(\{ theme: \{...\} \});
	     */
	    Customizations.applySettings = function (settings) {
	        _allSettings.settings = tslib_1.__assign({}, _allSettings.settings, settings);
	        Customizations._raiseChange();
	    };
	    /** Apply Customizations to a particular named scope, like a component.
	     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
	     */
	    Customizations.applyScopedSettings = function (scopeName, settings) {
	        _allSettings.scopedSettings[scopeName] = tslib_1.__assign({}, _allSettings.scopedSettings[scopeName], settings);
	        Customizations._raiseChange();
	    };
	    Customizations.getSettings = function (properties, scopeName, localSettings
	    // tslint:disable-next-line:no-any
	    ) {
	        if (localSettings === void 0) { localSettings = NO_CUSTOMIZATIONS; }
	        var settings = {};
	        var localScopedSettings = (scopeName && localSettings.scopedSettings[scopeName]) || {};
	        var globalScopedSettings = (scopeName && _allSettings.scopedSettings[scopeName]) || {};
	        for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
	            var property = properties_1[_i];
	            settings[property] =
	                localScopedSettings[property] ||
	                    localSettings.settings[property] ||
	                    globalScopedSettings[property] ||
	                    _allSettings.settings[property];
	        }
	        return settings;
	    };
	    /** Used to run some code that sets Customizations without triggering an update until the end.
	     * Useful for applying Customizations that don't affect anything currently rendered, or for
	     * applying many customizations at once.
	     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
	     */
	    Customizations.applyBatchedUpdates = function (code, suppressUpdate) {
	        Customizations._suppressUpdates = true;
	        try {
	            code();
	        }
	        catch ( /* do nothing */_a) { /* do nothing */ }
	        Customizations._suppressUpdates = false;
	        if (!suppressUpdate) {
	            Customizations._raiseChange();
	        }
	    };
	    Customizations.observe = function (onChange) {
	        _events.push(onChange);
	    };
	    Customizations.unobserve = function (onChange) {
	        _events = _events.filter(function (cb) { return cb !== onChange; });
	    };
	    Customizations._raiseChange = function () {
	        if (!Customizations._suppressUpdates) {
	            _events.forEach(function (cb) { return cb(); });
	        }
	    };
	    return Customizations;
	}());
	exports.Customizations = Customizations;
	//# sourceMappingURL=Customizations.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Customizations_1 = __webpack_require__(522);
	var CustomizerContext_1 = __webpack_require__(524);
	var mergeCustomizations_1 = __webpack_require__(525);
	/**
	 * The Customizer component allows for default props to be mixed into components which
	 * are decorated with the customizable() decorator, or use the styled HOC. This enables
	 * injection scenarios like:
	 *
	 * 1. render svg icons instead of the icon font within all buttons
	 * 2. inject a custom theme object into a component
	 *
	 * Props are provided via the settings prop which should be one of the following:
	 * - A json map which contains 1 or more name/value pairs representing injectable props.
	 * - A function that receives the current settings and returns the new ones that apply to the scope
	 *
	 * @public
	 */
	var Customizer = /** @class */ (function (_super) {
	    tslib_1.__extends(Customizer, _super);
	    function Customizer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onCustomizationChange = function () { return _this.forceUpdate(); };
	        return _this;
	    }
	    Customizer.prototype.componentDidMount = function () {
	        Customizations_1.Customizations.observe(this._onCustomizationChange);
	    };
	    Customizer.prototype.componentWillUnmount = function () {
	        Customizations_1.Customizations.unobserve(this._onCustomizationChange);
	    };
	    Customizer.prototype.render = function () {
	        var _this = this;
	        var contextTransform = this.props.contextTransform;
	        return (React.createElement(CustomizerContext_1.CustomizerContext.Consumer, null, function (parentContext) {
	            var newContext = mergeCustomizations_1.mergeCustomizations(_this.props, parentContext);
	            if (contextTransform) {
	                newContext = contextTransform(newContext);
	            }
	            return React.createElement(CustomizerContext_1.CustomizerContext.Provider, { value: newContext }, _this.props.children);
	        }));
	    };
	    return Customizer;
	}(React.Component));
	exports.Customizer = Customizer;
	//# sourceMappingURL=Customizer.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	exports.CustomizerContext = React.createContext({
	    customizations: {
	        inCustomizerContext: false,
	        settings: {},
	        scopedSettings: {}
	    }
	});
	//# sourceMappingURL=CustomizerContext.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeSettings_1 = __webpack_require__(526);
	/**
	 * Merge props and customizations giving priority to props over context.
	 * NOTE: This function will always perform multiple merge operations. Use with caution.
	 * @param props - New settings to merge in.
	 * @param parentContext - Context containing current settings.
	 * @returns Merged customizations.
	 */
	function mergeCustomizations(props, parentContext) {
	    var _a = (parentContext || {}).customizations, customizations = _a === void 0 ? { settings: {}, scopedSettings: {} } : _a;
	    return {
	        customizations: {
	            settings: mergeSettings_1.mergeSettings(customizations.settings, props.settings),
	            scopedSettings: mergeSettings_1.mergeScopedSettings(customizations.scopedSettings, props.scopedSettings),
	            inCustomizerContext: true
	        }
	    };
	}
	exports.mergeCustomizations = mergeCustomizations;
	//# sourceMappingURL=mergeCustomizations.js.map

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/**
	 * Merge new and old settings, giving priority to new settings.
	 * New settings is optional in which case oldSettings is returned as-is.
	 * @param oldSettings - Old settings to fall back to.
	 * @param newSettings - New settings that will be merged over oldSettings.
	 * @returns Merged settings.
	 */
	function mergeSettings(oldSettings, newSettings) {
	    if (oldSettings === void 0) { oldSettings = {}; }
	    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _settingsMergeWith(newSettings);
	    return mergeSettingsWith(oldSettings);
	}
	exports.mergeSettings = mergeSettings;
	function mergeScopedSettings(oldSettings, newSettings) {
	    if (oldSettings === void 0) { oldSettings = {}; }
	    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _scopedSettingsMergeWith(newSettings);
	    return mergeSettingsWith(oldSettings);
	}
	exports.mergeScopedSettings = mergeScopedSettings;
	function _isSettingsFunction(settings) {
	    return typeof settings === 'function';
	}
	function _settingsMergeWith(newSettings) {
	    return function (settings) { return (newSettings ? tslib_1.__assign({}, settings, newSettings) : settings); };
	}
	function _scopedSettingsMergeWith(scopedSettingsFromProps) {
	    if (scopedSettingsFromProps === void 0) { scopedSettingsFromProps = {}; }
	    return function (oldScopedSettings) {
	        var newScopedSettings = tslib_1.__assign({}, oldScopedSettings);
	        for (var scopeName in scopedSettingsFromProps) {
	            if (scopedSettingsFromProps.hasOwnProperty(scopeName)) {
	                newScopedSettings[scopeName] = tslib_1.__assign({}, oldScopedSettings[scopeName], scopedSettingsFromProps[scopeName]);
	            }
	        }
	        return newScopedSettings;
	    };
	}
	//# sourceMappingURL=mergeSettings.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Customizations_1 = __webpack_require__(522);
	var hoistStatics_1 = __webpack_require__(528);
	var CustomizerContext_1 = __webpack_require__(524);
	var merge_styles_1 = __webpack_require__(473);
	function customizable(scope, fields, concatStyles
	// tslint:disable-next-line:no-any
	) {
	    // tslint:disable-next-line:no-shadowed-variable
	    return function customizableFactory(
	    // tslint:disable-next-line:no-any
	    ComposedComponent
	    // tslint:disable-next-line:no-any
	    ) {
	        var resultClass = (_a = /** @class */ (function (_super) {
	                tslib_1.__extends(ComponentWithInjectedProps, _super);
	                // tslint:disable-next-line:no-any
	                function ComponentWithInjectedProps(props) {
	                    var _this = _super.call(this, props) || this;
	                    _this._onSettingChanged = _this._onSettingChanged.bind(_this);
	                    return _this;
	                }
	                ComponentWithInjectedProps.prototype.componentDidMount = function () {
	                    Customizations_1.Customizations.observe(this._onSettingChanged);
	                };
	                ComponentWithInjectedProps.prototype.componentWillUnmount = function () {
	                    Customizations_1.Customizations.unobserve(this._onSettingChanged);
	                };
	                ComponentWithInjectedProps.prototype.render = function () {
	                    var _this = this;
	                    return (React.createElement(CustomizerContext_1.CustomizerContext.Consumer, null, function (context) {
	                        var defaultProps = Customizations_1.Customizations.getSettings(fields, scope, context.customizations);
	                        // tslint:disable-next-line:no-any
	                        var componentProps = _this.props;
	                        // If defaultProps.styles is a function, evaluate it before calling concatStyleSets
	                        if (defaultProps.styles && typeof defaultProps.styles === 'function') {
	                            defaultProps.styles = defaultProps.styles(tslib_1.__assign({}, defaultProps, componentProps));
	                        }
	                        // If concatStyles is true and custom styles have been defined compute those styles
	                        if (concatStyles && (defaultProps.styles || componentProps.styles)) {
	                            var mergedStyles = merge_styles_1.concatStyleSets(defaultProps.styles, componentProps.styles);
	                            return React.createElement(ComposedComponent, tslib_1.__assign({}, defaultProps, componentProps, { styles: mergedStyles }));
	                        }
	                        return React.createElement(ComposedComponent, tslib_1.__assign({}, defaultProps, componentProps));
	                    }));
	                };
	                ComponentWithInjectedProps.prototype._onSettingChanged = function () {
	                    this.forceUpdate();
	                };
	                return ComponentWithInjectedProps;
	            }(React.Component)),
	            _a.displayName = 'Customized' + scope,
	            _a);
	        return hoistStatics_1.hoistStatics(ComposedComponent, resultClass);
	        var _a;
	    };
	}
	exports.customizable = customizable;
	//# sourceMappingURL=customizable.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Allows you to hoist static functions in components.
	 * Created for the purpose of fixing broken static functions in classes
	 * that utilize decorators.
	 *
	 * @public
	 * @param source - The object where the methods are hoisted from.
	 * @param dest - The object to hoist the methods onto.
	 * @returns The dest object with methods added
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function hoistStatics(source, dest) {
	    for (var name_1 in source) {
	        if (source.hasOwnProperty(name_1)) {
	            // tslint:disable-next-line:no-any
	            dest[name_1] = source[name_1];
	        }
	    }
	    return dest;
	}
	exports.hoistStatics = hoistStatics;
	//# sourceMappingURL=hoistStatics.js.map

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(530), exports);
	tslib_1.__exportStar(__webpack_require__(534), exports);
	tslib_1.__exportStar(__webpack_require__(535), exports);
	tslib_1.__exportStar(__webpack_require__(536), exports);
	tslib_1.__exportStar(__webpack_require__(497), exports);
	tslib_1.__exportStar(__webpack_require__(531), exports);
	tslib_1.__exportStar(__webpack_require__(498), exports);
	tslib_1.__exportStar(__webpack_require__(532), exports);
	tslib_1.__exportStar(__webpack_require__(491), exports);
	tslib_1.__exportStar(__webpack_require__(533), exports);
	tslib_1.__exportStar(__webpack_require__(537), exports);
	tslib_1.__exportStar(__webpack_require__(538), exports);
	tslib_1.__exportStar(__webpack_require__(540), exports);
	tslib_1.__exportStar(__webpack_require__(539), exports);
	tslib_1.__exportStar(__webpack_require__(541), exports);
	//# sourceMappingURL=dom.js.map

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getParent_1 = __webpack_require__(531);
	/**
	 * Determines whether or not a parent element contains a given child element.
	 * If `allowVirtualParents` is true, this method may return `true` if the child
	 * has the parent in its virtual element hierarchy.
	 *
	 * @public
	 */
	function elementContains(parent, child, allowVirtualParents) {
	    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
	    var isContained = false;
	    if (parent && child) {
	        if (allowVirtualParents) {
	            isContained = false;
	            while (child) {
	                var nextParent = getParent_1.getParent(child);
	                if (nextParent === parent) {
	                    isContained = true;
	                    break;
	                }
	                child = nextParent;
	            }
	        }
	        else if (parent.contains) {
	            isContained = parent.contains(child);
	        }
	    }
	    return isContained;
	}
	exports.elementContains = elementContains;
	//# sourceMappingURL=elementContains.js.map

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getVirtualParent_1 = __webpack_require__(532);
	/**
	 * Gets the element which is the parent of a given element.
	 * If `allowVirtuaParents` is `true`, this method prefers the virtual parent over
	 * real DOM parent when present.
	 *
	 * @public
	 */
	function getParent(child, allowVirtualParents) {
	    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
	    return child && ((allowVirtualParents && getVirtualParent_1.getVirtualParent(child)) || (child.parentNode && child.parentNode));
	}
	exports.getParent = getParent;
	//# sourceMappingURL=getParent.js.map

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isVirtualElement_1 = __webpack_require__(533);
	/**
	 * Gets the virtual parent given the child element, if it exists.
	 *
	 * @public
	 */
	function getVirtualParent(child) {
	    var parent;
	    if (child && isVirtualElement_1.isVirtualElement(child)) {
	        parent = child._virtual.parent;
	    }
	    return parent;
	}
	exports.getVirtualParent = getVirtualParent;
	//# sourceMappingURL=getVirtualParent.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Determines whether or not an element has the virtual hierarchy extension.
	 *
	 * @public
	 */
	function isVirtualElement(element) {
	    return element && !!element._virtual;
	}
	exports.isVirtualElement = isVirtualElement;
	//# sourceMappingURL=isVirtualElement.js.map

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var findElementRecursive_1 = __webpack_require__(535);
	/**
	 * Determines if an element, or any of its ancestors, contain the given attribute
	 * @param element - element to start searching at
	 * @param attribute - the attribute to search for
	 * @returns the value of the first instance found
	 */
	function elementContainsAttribute(element, attribute) {
	    var elementMatch = findElementRecursive_1.findElementRecursive(element, function (testElement) { return testElement.hasAttribute(attribute); });
	    return elementMatch && elementMatch.getAttribute(attribute);
	}
	exports.elementContainsAttribute = elementContainsAttribute;
	//# sourceMappingURL=elementContainsAttribute.js.map

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getParent_1 = __webpack_require__(531);
	/**
	 * Finds the first parent element where the matchFunction returns true
	 * @param element - element to start searching at
	 * @param matchFunction - the function that determines if the element is a match
	 * @returns the matched element or null no match was found
	 */
	function findElementRecursive(element, matchFunction) {
	    if (!element || element === document.body) {
	        return null;
	    }
	    return matchFunction(element) ? element : findElementRecursive(getParent_1.getParent(element), matchFunction);
	}
	exports.findElementRecursive = findElementRecursive;
	//# sourceMappingURL=findElementRecursive.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isVirtualElement_1 = __webpack_require__(533);
	/**
	 * Gets the elements which are child elements of the given element.
	 * If `allowVirtualChildren` is `true`, this method enumerates virtual child elements
	 * after the original children.
	 * @param parent - The element to get the children of.
	 * @param allowVirtualChildren - true if the method should enumerate virtual child elements.
	 */
	function getChildren(parent, allowVirtualChildren) {
	    if (allowVirtualChildren === void 0) { allowVirtualChildren = true; }
	    var children = [];
	    if (parent) {
	        for (var i = 0; i < parent.children.length; i++) {
	            children.push(parent.children.item(i));
	        }
	        if (allowVirtualChildren && isVirtualElement_1.isVirtualElement(parent)) {
	            children.push.apply(children, parent._virtual.children);
	        }
	    }
	    return children;
	}
	exports.getChildren = getChildren;
	//# sourceMappingURL=getChildren.js.map

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function on(element, eventName, callback, options) {
	    element.addEventListener(eventName, callback, options);
	    return function () { return element.removeEventListener(eventName, callback, options); };
	}
	exports.on = on;
	//# sourceMappingURL=on.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var findElementRecursive_1 = __webpack_require__(535);
	var setPortalAttribute_1 = __webpack_require__(539);
	/**
	 * Determine whether a target is within a portal from perspective of root or optional parent.
	 * This function only works against portal components that use the setPortalAttribute function.
	 * If both parent and child are within the same portal this function will return false.
	 * @param target - Element to query portal containment status of.
	 * @param parent - Optional parent perspective. Search for containing portal stops at parent (or root if parent is undefined or invalid.)
	 */
	function portalContainsElement(target, parent) {
	    var elementMatch = findElementRecursive_1.findElementRecursive(target, function (testElement) { return parent === testElement || testElement.hasAttribute(setPortalAttribute_1.DATA_PORTAL_ATTRIBUTE); });
	    return elementMatch !== null && elementMatch.hasAttribute(setPortalAttribute_1.DATA_PORTAL_ATTRIBUTE);
	}
	exports.portalContainsElement = portalContainsElement;
	//# sourceMappingURL=portalContainsElement.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DATA_PORTAL_ATTRIBUTE = 'data-portal-element';
	/**
	 * Identify element as a portal by setting an attribute.
	 * @param element - Element to mark as a portal.
	 */
	function setPortalAttribute(element) {
	    element.setAttribute(exports.DATA_PORTAL_ATTRIBUTE, 'true');
	}
	exports.setPortalAttribute = setPortalAttribute;
	//# sourceMappingURL=setPortalAttribute.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Raises a click event. */
	function raiseClick(target) {
	    var event = createNewEvent('MouseEvents');
	    event.initEvent('click', true, true);
	    target.dispatchEvent(event);
	}
	exports.raiseClick = raiseClick;
	function createNewEvent(eventName) {
	    var event;
	    if (typeof Event === 'function') {
	        // Chrome, Opera, Firefox
	        event = new Event(eventName);
	    }
	    else {
	        // IE
	        event = document.createEvent('Event');
	        event.initEvent(eventName, true, true);
	    }
	    return event;
	}
	//# sourceMappingURL=raiseClick.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Sets the virtual parent of an element.
	 * Pass `undefined` as the `parent` to clear the virtual parent.
	 *
	 * @public
	 */
	function setVirtualParent(child, parent) {
	    var virtualChild = child;
	    var virtualParent = parent;
	    if (!virtualChild._virtual) {
	        virtualChild._virtual = {
	            children: []
	        };
	    }
	    var oldParent = virtualChild._virtual.parent;
	    if (oldParent && oldParent !== parent) {
	        // Remove the child from its old parent.
	        var index = oldParent._virtual.children.indexOf(virtualChild);
	        if (index > -1) {
	            oldParent._virtual.children.splice(index, 1);
	        }
	    }
	    virtualChild._virtual.parent = virtualParent || undefined;
	    if (virtualParent) {
	        if (!virtualParent._virtual) {
	            virtualParent._virtual = {
	                children: []
	            };
	        }
	        virtualParent._virtual.children.push(virtualChild);
	    }
	}
	exports.setVirtualParent = setVirtualParent;
	//# sourceMappingURL=setVirtualParent.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var appendFunction_1 = __webpack_require__(513);
	/**
	 * Extends a component's lifetime methods by appending new functions to the existing lifetime functions.
	 */
	function extendComponent(parent, methods) {
	    for (var name_1 in methods) {
	        if (methods.hasOwnProperty(name_1)) {
	            // tslint:disable-next-line:no-any
	            parent[name_1] = appendFunction_1.appendFunction(parent, parent[name_1], methods[name_1]);
	        }
	    }
	}
	exports.extendComponent = extendComponent;
	//# sourceMappingURL=extendComponent.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var elementContainsAttribute_1 = __webpack_require__(534);
	var elementContains_1 = __webpack_require__(530);
	var getParent_1 = __webpack_require__(531);
	var getWindow_1 = __webpack_require__(491);
	var getDocument_1 = __webpack_require__(497);
	var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
	var IS_VISIBLE_ATTRIBUTE = 'data-is-visible';
	var FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
	var FOCUSZONE_SUB_ATTRIBUTE = 'data-is-sub-focuszone';
	/**
	 * Gets the first focusable element.
	 *
	 * @public
	 */
	function getFirstFocusable(rootElement, currentElement, includeElementsInFocusZones) {
	    return getNextElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones);
	}
	exports.getFirstFocusable = getFirstFocusable;
	/**
	 * Gets the last focusable element.
	 *
	 * @public
	 */
	function getLastFocusable(rootElement, currentElement, includeElementsInFocusZones) {
	    return getPreviousElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones);
	}
	exports.getLastFocusable = getLastFocusable;
	/**
	 * Gets the first tabbable element.
	 * The difference between focusable and tabbable is that tabbable elements are focusable elements that also have tabIndex != -1.
	 * @param rootElement - The parent element to search beneath.
	 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
	 * and iteration continues forward.  Typical use passes rootElement.firstChild.
	 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
	 * @param checkNode - Include currentElement in search when true. Defaults to true.
	 * @public
	 */
	function getFirstTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
	    if (checkNode === void 0) { checkNode = true; }
	    return getNextElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/);
	}
	exports.getFirstTabbable = getFirstTabbable;
	/**
	 * Gets the last tabbable element.
	 * The difference between focusable and tabbable is that tabbable elements are focusable elements that also have tabIndex != -1.
	 * @param rootElement - The parent element to search beneath.
	 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
	 * and iteration continues in reverse.  Typical use passes rootElement.lastChild.
	 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
	 * @param checkNode - Include currentElement in search when true. Defaults to true.
	 * @public
	 */
	function getLastTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
	    if (checkNode === void 0) { checkNode = true; }
	    return getPreviousElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/);
	}
	exports.getLastTabbable = getLastTabbable;
	/**
	 * Attempts to focus the first focusable element that is a child or child's child of the rootElement.
	 *
	 * @public
	 * @param rootElement - Element to start the search for a focusable child.
	 * @returns True if focus was set, false if it was not.
	 */
	function focusFirstChild(rootElement) {
	    var element = getNextElement(rootElement, rootElement, true, false, false, true);
	    if (element) {
	        focusAsync(element);
	        return true;
	    }
	    return false;
	}
	exports.focusFirstChild = focusFirstChild;
	/**
	 * Traverse to find the previous element.
	 * If tabbable is true, the element must have tabIndex != -1.
	 *
	 * @public
	 */
	function getPreviousElement(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable) {
	    if (!currentElement || (!allowFocusRoot && currentElement === rootElement)) {
	        return null;
	    }
	    var isCurrentElementVisible = isElementVisible(currentElement);
	    // Check its children.
	    if (traverseChildren &&
	        isCurrentElementVisible &&
	        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
	        var childMatch = getPreviousElement(rootElement, currentElement.lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
	        if (childMatch) {
	            if ((tabbable && isElementTabbable(childMatch, true)) || !tabbable) {
	                return childMatch;
	            }
	            var childMatchSiblingMatch = getPreviousElement(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
	            if (childMatchSiblingMatch) {
	                return childMatchSiblingMatch;
	            }
	            var childMatchParent = childMatch.parentElement;
	            // At this point if we have not found any potential matches
	            // start looking at the rest of the subtree under the currentParent.
	            // NOTE: We do not want to recurse here because doing so could
	            // cause elements to get skipped.
	            while (childMatchParent && childMatchParent !== currentElement) {
	                var childMatchParentMatch = getPreviousElement(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
	                if (childMatchParentMatch) {
	                    return childMatchParentMatch;
	                }
	                childMatchParent = childMatchParent.parentElement;
	            }
	        }
	    }
	    // Check the current node, if it's not the first traversal.
	    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
	        return currentElement;
	    }
	    // Check its previous sibling.
	    var siblingMatch = getPreviousElement(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
	    if (siblingMatch) {
	        return siblingMatch;
	    }
	    // Check its parent.
	    if (!suppressParentTraversal) {
	        return getPreviousElement(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
	    }
	    return null;
	}
	exports.getPreviousElement = getPreviousElement;
	/**
	 * Traverse to find the next focusable element.
	 * If tabbable is true, the element must have tabIndex != -1.
	 *
	 * @public
	 * @param checkNode - Include currentElement in search when true.
	 */
	function getNextElement(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable) {
	    if (!currentElement || (currentElement === rootElement && suppressChildTraversal && !allowFocusRoot)) {
	        return null;
	    }
	    var isCurrentElementVisible = isElementVisible(currentElement);
	    // Check the current node, if it's not the first traversal.
	    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
	        return currentElement;
	    }
	    // Check its children.
	    if (!suppressChildTraversal &&
	        isCurrentElementVisible &&
	        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
	        var childMatch = getNextElement(rootElement, currentElement.firstElementChild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
	        if (childMatch) {
	            return childMatch;
	        }
	    }
	    if (currentElement === rootElement) {
	        return null;
	    }
	    // Check its sibling.
	    var siblingMatch = getNextElement(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
	    if (siblingMatch) {
	        return siblingMatch;
	    }
	    if (!suppressParentTraversal) {
	        return getNextElement(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
	    }
	    return null;
	}
	exports.getNextElement = getNextElement;
	/**
	 * Determines if an element is visible.
	 *
	 * @public
	 */
	function isElementVisible(element) {
	    // If the element is not valid, return false.
	    if (!element || !element.getAttribute) {
	        return false;
	    }
	    var visibilityAttribute = element.getAttribute(IS_VISIBLE_ATTRIBUTE);
	    // If the element is explicitly marked with the visibility attribute, return that value as boolean.
	    if (visibilityAttribute !== null && visibilityAttribute !== undefined) {
	        return visibilityAttribute === 'true';
	    }
	    // Fallback to other methods of determining actual visibility.
	    return (element.offsetHeight !== 0 ||
	        element.offsetParent !== null ||
	        // tslint:disable-next-line:no-any
	        element.isVisible === true); // used as a workaround for testing.
	}
	exports.isElementVisible = isElementVisible;
	/**
	 * Determines if an element can receive focus programmatically or via a mouse click.
	 * If checkTabIndex is true, additionally checks to ensure the element can be focused with the tab key, meaning tabIndex != -1.
	 *
	 * @public
	 */
	function isElementTabbable(element, checkTabIndex) {
	    // If this element is null or is disabled, it is not considered tabbable.
	    if (!element || element.disabled) {
	        return false;
	    }
	    var tabIndex = 0;
	    var tabIndexAttributeValue = null;
	    if (element && element.getAttribute) {
	        tabIndexAttributeValue = element.getAttribute('tabIndex');
	        if (tabIndexAttributeValue) {
	            tabIndex = parseInt(tabIndexAttributeValue, 10);
	        }
	    }
	    var isFocusableAttribute = element.getAttribute ? element.getAttribute(IS_FOCUSABLE_ATTRIBUTE) : null;
	    var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
	    var result = !!element &&
	        isFocusableAttribute !== 'false' &&
	        (element.tagName === 'A' ||
	            element.tagName === 'BUTTON' ||
	            element.tagName === 'INPUT' ||
	            element.tagName === 'TEXTAREA' ||
	            isFocusableAttribute === 'true' ||
	            isTabIndexSet);
	    return checkTabIndex ? tabIndex !== -1 && result : result;
	}
	exports.isElementTabbable = isElementTabbable;
	/**
	 * Determines if a given element is a focus zone.
	 *
	 * @public
	 */
	function isElementFocusZone(element) {
	    return !!(element && element.getAttribute && !!element.getAttribute(FOCUSZONE_ID_ATTRIBUTE));
	}
	exports.isElementFocusZone = isElementFocusZone;
	/**
	 * Determines if a given element is a focus sub zone.
	 *
	 * @public
	 */
	function isElementFocusSubZone(element) {
	    return !!(element && element.getAttribute && element.getAttribute(FOCUSZONE_SUB_ATTRIBUTE) === 'true');
	}
	exports.isElementFocusSubZone = isElementFocusSubZone;
	/**
	 * Determines if an element, or any of its children, contain focus.
	 *
	 * @public
	 */
	function doesElementContainFocus(element) {
	    var document = getDocument_1.getDocument(element);
	    var currentActiveElement = document && document.activeElement;
	    if (currentActiveElement && elementContains_1.elementContains(element, currentActiveElement)) {
	        return true;
	    }
	    return false;
	}
	exports.doesElementContainFocus = doesElementContainFocus;
	/**
	 * Determines if an, or any of its ancestors, sepcificies that it doesn't want focus to wrap
	 * @param element - element to start searching from
	 * @param noWrapDataAttribute - the no wrap data attribute to match (either)
	 * @returns true if focus should wrap, false otherwise
	 */
	function shouldWrapFocus(element, noWrapDataAttribute) {
	    return elementContainsAttribute_1.elementContainsAttribute(element, noWrapDataAttribute) === 'true' ? false : true;
	}
	exports.shouldWrapFocus = shouldWrapFocus;
	var targetToFocusOnNextRepaint = undefined;
	/**
	 * Sets focus to an element asynchronously. The focus will be set at the next browser repaint,
	 * meaning it won't cause any extra recalculations. If more than one focusAsync is called during one frame,
	 * only the latest called focusAsync element will actually be focused
	 * @param element - The element to focus
	 */
	function focusAsync(element) {
	    if (element) {
	        // An element was already queued to be focused, so replace that one with the new element
	        if (targetToFocusOnNextRepaint) {
	            targetToFocusOnNextRepaint = element;
	            return;
	        }
	        targetToFocusOnNextRepaint = element;
	        var win = getWindow_1.getWindow(element);
	        if (win) {
	            // element.focus() is a no-op if the element is no longer in the DOM, meaning this is always safe
	            win.requestAnimationFrame(function () {
	                targetToFocusOnNextRepaint && targetToFocusOnNextRepaint.focus();
	                // We are done focusing for this frame, so reset the queued focus element
	                targetToFocusOnNextRepaint = undefined;
	            });
	        }
	    }
	}
	exports.focusAsync = focusAsync;
	/**
	 * Finds the closest focusable element via an index path from a parent. See
	 * `getElementIndexPath` for getting an index path from an element to a child.
	 */
	function getFocusableByIndexPath(parent, path) {
	    var element = parent;
	    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
	        var index = path_1[_i];
	        var nextChild = element.children[Math.min(index, element.children.length - 1)];
	        if (!nextChild) {
	            break;
	        }
	        element = nextChild;
	    }
	    element =
	        isElementTabbable(element) && isElementVisible(element)
	            ? element
	            : getNextElement(parent, element, true) || getPreviousElement(parent, element);
	    return element;
	}
	exports.getFocusableByIndexPath = getFocusableByIndexPath;
	/**
	 * Finds the element index path from a parent element to a child element.
	 *
	 * If you had this node structure: "A has children [B, C] and C has child D",
	 * the index path from A to D would be [1, 0], or `parent.chidren[1].children[0]`.
	 */
	function getElementIndexPath(fromElement, toElement) {
	    var path = [];
	    while (toElement && fromElement && toElement !== fromElement) {
	        var parent_1 = getParent_1.getParent(toElement, true);
	        if (parent_1 === null) {
	            return [];
	        }
	        path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
	        toElement = parent_1;
	    }
	    return path;
	}
	exports.getElementIndexPath = getElementIndexPath;
	//# sourceMappingURL=focus.js.map

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var REACT_LIFECYCLE_EXCLUSIONS = [
	    'setState',
	    'render',
	    'componentWillMount',
	    'UNSAFE_componentWillMount',
	    'componentDidMount',
	    'componentWillReceiveProps',
	    'UNSAFE_componentWillReceiveProps',
	    'shouldComponentUpdate',
	    'componentWillUpdate',
	    'getSnapshotBeforeUpdate',
	    'UNSAFE_componentWillUpdate',
	    'componentDidUpdate',
	    'componentWillUnmount'
	];
	/**
	 * Allows you to hoist methods, except those in an exclusion set from a source object into a destination object.
	 *
	 * @public
	 * @param destination - The instance of the object to hoist the methods onto.
	 * @param source - The instance of the object where the methods are hoisted from.
	 * @param exclusions - (Optional) What methods to exclude from being hoisted.
	 * @returns An array of names of methods that were hoisted.
	 */
	function hoistMethods(
	// tslint:disable-next-line:no-any
	destination, 
	// tslint:disable-next-line:no-any
	source, exclusions) {
	    if (exclusions === void 0) { exclusions = REACT_LIFECYCLE_EXCLUSIONS; }
	    var hoisted = [];
	    var _loop_1 = function (methodName) {
	        if (typeof source[methodName] === 'function' &&
	            destination[methodName] === undefined &&
	            (!exclusions || exclusions.indexOf(methodName) === -1)) {
	            hoisted.push(methodName);
	            /* tslint:disable:no-function-expression */
	            destination[methodName] = function () {
	                source[methodName].apply(source, arguments);
	            };
	            /* tslint:enable */
	        }
	    };
	    for (var methodName in source) {
	        _loop_1(methodName);
	    }
	    return hoisted;
	}
	exports.hoistMethods = hoistMethods;
	/**
	 * Provides a method for convenience to unhoist hoisted methods.
	 *
	 * @public
	 * @param source - The source object upon which methods were hoisted.
	 * @param methodNames - An array of method names to unhoist.
	 */
	// tslint:disable-next-line:no-any
	function unhoistMethods(source, methodNames) {
	    methodNames.forEach(function (methodName) { return delete source[methodName]; });
	}
	exports.unhoistMethods = unhoistMethods;
	//# sourceMappingURL=hoist.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var extendComponent_1 = __webpack_require__(542);
	/**
	 * Helper to manage componentRef resolution. Internally appends logic to
	 * lifetime methods to resolve componentRef to the passed in object.
	 *
	 * Usage: call initializeComponentRef(this) in the constructor,
	 */
	function initializeComponentRef(obj) {
	    extendComponent_1.extendComponent(obj, {
	        componentDidMount: _onMount,
	        componentDidUpdate: _onUpdate,
	        componentWillUnmount: _onUnmount
	    });
	}
	exports.initializeComponentRef = initializeComponentRef;
	function _onMount() {
	    _setComponentRef(this.props.componentRef, this);
	}
	function _onUpdate(prevProps) {
	    if (prevProps.componentRef !== this.props.componentRef) {
	        // tslint:disable-next-line:no-any
	        _setComponentRef(prevProps.componentRef, null);
	        _setComponentRef(this.props.componentRef, this);
	    }
	}
	function _onUnmount() {
	    _setComponentRef(this.props.componentRef, null);
	}
	function _setComponentRef(componentRef, value) {
	    if (componentRef) {
	        if (typeof componentRef === 'object') {
	            componentRef.current = value;
	        }
	        else if (typeof componentRef === 'function') {
	            componentRef(value);
	        }
	    }
	}
	//# sourceMappingURL=initializeComponentRef.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Regular expression matching characters to ignore when calculating the initials.
	 * The first part matches characters within parenthesis, including the parenthesis.
	 * The second part matches special ASCII characters except space, plus some unicode special characters.
	 */
	var UNWANTED_CHARS_REGEX = /\([^)]*\)|[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g;
	/**
	 * Regular expression matching phone numbers. Applied after chars matching UNWANTED_CHARS_REGEX have been removed
	 * and number has been trimmed for whitespaces
	 */
	var PHONENUMBER_REGEX = /^\d+[\d\s]*(:?ext|x|)\s*\d+$/i;
	/** Regular expression matching one or more spaces. */
	var MULTIPLE_WHITESPACES_REGEX = /\s+/g;
	/**
	 * Regular expression matching languages for which we currently don't support initials.
	 * Arabic:   Arabic, Arabic Supplement, Arabic Extended-A.
	 * Korean:   Hangul Jamo, Hangul Compatibility Jamo, Hangul Jamo Extended-A, Hangul Syllables, Hangul Jamo Extended-B.
	 * Japanese: Hiragana, Katakana.
	 * CJK:      CJK Unified Ideographs Extension A, CJK Unified Ideographs, CJK Compatibility Ideographs, CJK Unified Ideographs Extension B
	 */
	/* tslint:disable:max-line-length */
	var UNSUPPORTED_TEXT_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD869][\uDC00-\uDED6]/;
	/* tslint:enable:max-line-length */
	function getInitialsLatin(displayName, isRtl) {
	    var initials = '';
	    var splits = displayName.split(' ');
	    if (splits.length === 2) {
	        initials += splits[0].charAt(0).toUpperCase();
	        initials += splits[1].charAt(0).toUpperCase();
	    }
	    else if (splits.length === 3) {
	        initials += splits[0].charAt(0).toUpperCase();
	        initials += splits[2].charAt(0).toUpperCase();
	    }
	    else if (splits.length !== 0) {
	        initials += splits[0].charAt(0).toUpperCase();
	    }
	    if (isRtl && initials.length > 1) {
	        return initials.charAt(1) + initials.charAt(0);
	    }
	    return initials;
	}
	function cleanupDisplayName(displayName) {
	    displayName = displayName.replace(UNWANTED_CHARS_REGEX, '');
	    displayName = displayName.replace(MULTIPLE_WHITESPACES_REGEX, ' ');
	    displayName = displayName.trim();
	    return displayName;
	}
	/**
	 * Get (up to 2 characters) initials based on display name of the persona.
	 *
	 * @public
	 */
	function getInitials(displayName, isRtl, allowPhoneInitials) {
	    if (!displayName) {
	        return '';
	    }
	    displayName = cleanupDisplayName(displayName);
	    // For names containing CJK characters, and phone numbers, we don't display initials
	    if (UNSUPPORTED_TEXT_REGEX.test(displayName) || (!allowPhoneInitials && PHONENUMBER_REGEX.test(displayName))) {
	        return '';
	    }
	    return getInitialsLatin(displayName, isRtl);
	}
	exports.getInitials = getInitials;
	//# sourceMappingURL=initials.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getDocument_1 = __webpack_require__(497);
	var localStorage_1 = __webpack_require__(548);
	// Default to undefined so that we initialize on first read.
	var _language;
	/**
	 * Gets the rtl state of the page (returns true if in rtl.)
	 *
	 * @public
	 */
	function getLanguage() {
	    if (_language === undefined) {
	        var doc = getDocument_1.getDocument();
	        var savedLanguage = localStorage_1.getItem('language');
	        if (savedLanguage !== null) {
	            _language = savedLanguage;
	        }
	        if (_language === undefined && doc) {
	            _language = doc.documentElement.getAttribute('lang');
	        }
	        if (_language === undefined) {
	            _language = 'en';
	        }
	    }
	    return _language;
	}
	exports.getLanguage = getLanguage;
	/**
	 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
	 *
	 * @public
	 */
	function setLanguage(language, avoidPersisting) {
	    if (avoidPersisting === void 0) { avoidPersisting = false; }
	    var doc = getDocument_1.getDocument();
	    if (doc) {
	        doc.documentElement.setAttribute('lang', language);
	    }
	    if (!avoidPersisting) {
	        localStorage_1.setItem('language', language);
	    }
	    _language = language;
	}
	exports.setLanguage = setLanguage;
	//# sourceMappingURL=language.js.map

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	/**
	 * Fetches an item from local storage without throwing an exception
	 * @param key The key of the item to fetch from local storage
	 */
	function getItem(key) {
	    var result = null;
	    try {
	        var win = getWindow_1.getWindow();
	        result = win ? win.localStorage.getItem(key) : null;
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	    return result;
	}
	exports.getItem = getItem;
	/**
	 * Inserts an item into local storage without throwing an exception
	 * @param key The key of the item to add to local storage
	 * @param data The data to put into local storage
	 */
	function setItem(key, data) {
	    try {
	        var win = getWindow_1.getWindow();
	        win && win.localStorage.setItem(key, data);
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	}
	exports.setItem = setItem;
	//# sourceMappingURL=localStorage.js.map

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Determines the distance between two points.
	 *
	 * @public
	 */
	function getDistanceBetweenPoints(point1, point2) {
	    var distance = Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
	    return distance;
	}
	exports.getDistanceBetweenPoints = getDistanceBetweenPoints;
	/**
	 * Produces a proportionally-scaled version of an input content size when fit to a bounding size.
	 * Given a `contentSize` and a `boundsSize`, this function scales `contentSize` proportionally
	 * using either `contain` or `cover` fit behaviors.
	 * Use this function to pre-calculate the layout for the CSS `object-fit` and `background-fit` behaviors.
	 * With `contain`, the output size must be the largest it can be while completely within the `boundsSize`.
	 * With `cover`, the output size must be the smallest it can be while completely around the `boundsSize`.
	 * By default, there is a `maxScale` value of 1, which prevents the `contentSize` from being scaled larger.
	 *
	 * @param options - the options for the bounds fit operation
	 */
	function fitContentToBounds(options) {
	    var contentSize = options.contentSize, boundsSize = options.boundsSize, _a = options.mode, mode = _a === void 0 ? 'contain' : _a, _b = options.maxScale, maxScale = _b === void 0 ? 1 : _b;
	    var contentAspectRatio = contentSize.width / contentSize.height;
	    var boundsAspectRatio = boundsSize.width / boundsSize.height;
	    var scale;
	    if (mode === 'contain' ? contentAspectRatio > boundsAspectRatio : contentAspectRatio < boundsAspectRatio) {
	        scale = boundsSize.width / contentSize.width;
	    }
	    else {
	        scale = boundsSize.height / contentSize.height;
	    }
	    var finalScale = Math.min(maxScale, scale);
	    return {
	        width: contentSize.width * finalScale,
	        height: contentSize.height * finalScale
	    };
	}
	exports.fitContentToBounds = fitContentToBounds;
	/**
	 * Calculates a number's precision based on the number of trailing
	 * zeros if the number does not have a decimal indicated by a negative
	 * precision. Otherwise, it calculates the number of digits after
	 * the decimal point indicated by a positive precision.
	 * @param value - the value to determine the precision of
	 */
	function calculatePrecision(value) {
	    /**
	     * Group 1:
	     * [1-9]([0]+$) matches trailing zeros
	     * Group 2:
	     * \.([0-9]*) matches all digits after a decimal point.
	     */
	    var groups = /[1-9]([0]+$)|\.([0-9]*)/.exec(String(value));
	    if (!groups) {
	        return 0;
	    }
	    if (groups[1]) {
	        return -groups[1].length;
	    }
	    if (groups[2]) {
	        return groups[2].length;
	    }
	    return 0;
	}
	exports.calculatePrecision = calculatePrecision;
	/**
	 * Rounds a number to a certain level of precision. Accepts negative precision.
	 * @param value - The value that is being rounded.
	 * @param precision - The number of decimal places to round the number to
	 */
	function precisionRound(value, precision, base) {
	    if (base === void 0) { base = 10; }
	    var exp = Math.pow(base, precision);
	    return Math.round(value * exp) / exp;
	}
	exports.precisionRound = precisionRound;
	//# sourceMappingURL=math.js.map

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var stylesheet = merge_styles_1.Stylesheet.getInstance();
	if (stylesheet && stylesheet.onReset) {
	    merge_styles_1.Stylesheet.getInstance().onReset(resetMemoizations);
	}
	var _resetCounter = 0;
	var _emptyObject = { empty: true };
	var _dictionary = {};
	var _weakMap = typeof WeakMap === 'undefined' ? null : WeakMap;
	/**
	 *  Test utility for providing a custom weakmap.
	 *
	 * @internal
	 * */
	function setMemoizeWeakMap(weakMap) {
	    _weakMap = weakMap;
	}
	exports.setMemoizeWeakMap = setMemoizeWeakMap;
	/**
	 * Reset memoizations.
	 */
	function resetMemoizations() {
	    _resetCounter++;
	}
	exports.resetMemoizations = resetMemoizations;
	/**
	 * Memoize decorator to be used on class methods. WARNING: the `this` reference
	 * will be inaccessible within a memoized method, given that a cached method's `this`
	 * would not be instance-specific.
	 *
	 * @public
	 */
	function memoize(target, key, descriptor) {
	    // We bind to "null" to prevent people from inadvertently pulling values from "this",
	    // rather than passing them in as input values which can be memoized.
	    var fn = memoizeFunction(descriptor.value && descriptor.value.bind(null));
	    return {
	        configurable: true,
	        get: function () {
	            return fn;
	        }
	    };
	}
	exports.memoize = memoize;
	/**
	 * Memoizes a function; when you pass in the same parameters multiple times, it returns a cached result.
	 * Be careful when passing in objects, you need to pass in the same INSTANCE for caching to work. Otherwise
	 * it will grow the cache unnecessarily. Also avoid using default values that evaluate functions; passing in
	 * undefined for a value and relying on a default function will execute it the first time, but will not
	 * re-evaluate subsequent times which may have been unexpected.
	 *
	 * By default, the cache will reset after 100 permutations, to avoid abuse cases where the function is
	 * unintendedly called with unique objects. Without a reset, the cache could grow infinitely, so we safeguard
	 * by resetting. To override this behavior, pass a value of 0 to the maxCacheSize parameter.
	 *
	 * @public
	 * @param cb - The function to memoize.
	 * @param maxCacheSize - Max results to cache. If the cache exceeds this value, it will reset on the next call.
	 * @returns A memoized version of the function.
	 */
	function memoizeFunction(cb, maxCacheSize) {
	    if (maxCacheSize === void 0) { maxCacheSize = 100; }
	    // Avoid breaking scenarios which don't have weak map.
	    if (!_weakMap) {
	        return cb;
	    }
	    var rootNode;
	    var cacheSize = 0;
	    var localResetCounter = _resetCounter;
	    // tslint:disable-next-line:no-function-expression
	    return function memoizedFunction() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var currentNode = rootNode;
	        if (rootNode === undefined || localResetCounter !== _resetCounter || (maxCacheSize > 0 && cacheSize > maxCacheSize)) {
	            rootNode = _createNode();
	            cacheSize = 0;
	            localResetCounter = _resetCounter;
	        }
	        currentNode = rootNode;
	        // Traverse the tree until we find the match.
	        for (var i = 0; i < args.length; i++) {
	            var arg = _normalizeArg(args[i]);
	            if (!currentNode.map.has(arg)) {
	                currentNode.map.set(arg, _createNode());
	            }
	            currentNode = currentNode.map.get(arg);
	        }
	        if (!currentNode.hasOwnProperty('value')) {
	            currentNode.value = cb.apply(void 0, args);
	            cacheSize++;
	        }
	        return currentNode.value;
	    };
	}
	exports.memoizeFunction = memoizeFunction;
	function _normalizeArg(val) {
	    if (!val) {
	        return _emptyObject;
	    }
	    else if (typeof val === 'object' || typeof val === 'function') {
	        return val;
	    }
	    else if (!_dictionary[val]) {
	        _dictionary[val] = { val: val };
	    }
	    return _dictionary[val];
	}
	function _createNode() {
	    return {
	        map: _weakMap ? new _weakMap() : null
	    };
	}
	//# sourceMappingURL=memoize.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
	 * together in the order provided. If an object creates a circular reference, it will assign the
	 * original reference.
	 */
	function merge(target) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var arg = args_1[_a];
	        _merge(target || {}, arg);
	    }
	    return target;
	}
	exports.merge = merge;
	/**
	 * The _merge helper iterates through all props on source and assigns them to target.
	 * When the value is an object, we will create a deep clone of the object. However if
	 * there is a circular reference, the value will not be deep cloned and will persist
	 * the reference.
	 */
	// tslint:disable-next-line:no-any
	function _merge(target, source, circularReferences) {
	    if (circularReferences === void 0) { circularReferences = []; }
	    circularReferences.push(source);
	    for (var name_1 in source) {
	        if (source.hasOwnProperty(name_1)) {
	            var value = source[name_1];
	            if (typeof value === 'object') {
	                var isCircularReference = circularReferences.indexOf(value) > -1;
	                // tslint:disable-next-line:no-any
	                target[name_1] = isCircularReference ? value : _merge(target[name_1] || {}, value, circularReferences);
	            }
	            else {
	                target[name_1] = value;
	            }
	        }
	    }
	    circularReferences.pop();
	    return target;
	}
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true if and only if the user is on a iOS device.
	 * Used to determine whether iOS-specific behavior should be applied.
	 */
	exports.isIOS = function () {
	    if (!window || !window.navigator || !window.navigator.userAgent) {
	        return false;
	    }
	    return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
	};
	//# sourceMappingURL=mobileDetector.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	var isMacResult;
	/**
	 * Returns true if the user is on a Mac. Caches the result value.
	 * @param reset - Reset the cached result value (mainly for testing).
	 */
	function isMac(reset) {
	    if (typeof isMacResult === 'undefined' || reset) {
	        var win = getWindow_1.getWindow();
	        var userAgent = win && win.navigator.userAgent;
	        isMacResult = !!userAgent && userAgent.indexOf('Macintosh') !== -1;
	    }
	    return !!isMacResult;
	}
	exports.isMac = isMac;
	//# sourceMappingURL=osDetector.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Detects whether an element's content has horizontal overflow
	 *
	 * @public
	 * @param element - Element to check for overflow
	 * @returns True if element's content overflows
	 */
	function hasHorizontalOverflow(element) {
	    return element.clientWidth < element.scrollWidth;
	}
	exports.hasHorizontalOverflow = hasHorizontalOverflow;
	/**
	 * Detects whether an element's content has vertical overflow
	 *
	 * @public
	 * @param element - Element to check for overflow
	 * @returns True if element's content overflows
	 */
	function hasVerticalOverflow(element) {
	    return element.clientHeight < element.scrollHeight;
	}
	exports.hasVerticalOverflow = hasVerticalOverflow;
	/**
	 * Detects whether an element's content has overflow in any direction
	 *
	 * @public
	 * @param element - Element to check for overflow
	 * @returns True if element's content overflows
	 */
	function hasOverflow(element) {
	    return hasHorizontalOverflow(element) || hasVerticalOverflow(element);
	}
	exports.hasOverflow = hasOverflow;
	//# sourceMappingURL=overflow.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var object_1 = __webpack_require__(495);
	/**
	 * An array of events that are allowed on every html element type.
	 *
	 * @public
	 */
	exports.baseElementEvents = [
	    'onCopy',
	    'onCut',
	    'onPaste',
	    'onCompositionEnd',
	    'onCompositionStart',
	    'onCompositionUpdate',
	    'onFocus',
	    'onFocusCapture',
	    'onBlur',
	    'onBlurCapture',
	    'onChange',
	    'onInput',
	    'onSubmit',
	    'onLoad',
	    'onError',
	    'onKeyDown',
	    'onKeyDownCapture',
	    'onKeyPress',
	    'onKeyUp',
	    'onAbort',
	    'onCanPlay',
	    'onCanPlayThrough',
	    'onDurationChange',
	    'onEmptied',
	    'onEncrypted',
	    'onEnded',
	    'onLoadedData',
	    'onLoadedMetadata',
	    'onLoadStart',
	    'onPause',
	    'onPlay',
	    'onPlaying',
	    'onProgress',
	    'onRateChange',
	    'onSeeked',
	    'onSeeking',
	    'onStalled',
	    'onSuspend',
	    'onTimeUpdate',
	    'onVolumeChange',
	    'onWaiting',
	    'onClick',
	    'onClickCapture',
	    'onContextMenu',
	    'onDoubleClick',
	    'onDrag',
	    'onDragEnd',
	    'onDragEnter',
	    'onDragExit',
	    'onDragLeave',
	    'onDragOver',
	    'onDragStart',
	    'onDrop',
	    'onMouseDown',
	    'onMouseDownCapture',
	    'onMouseEnter',
	    'onMouseLeave',
	    'onMouseMove',
	    'onMouseOut',
	    'onMouseOver',
	    'onMouseUp',
	    'onMouseUpCapture',
	    'onSelect',
	    'onTouchCancel',
	    'onTouchEnd',
	    'onTouchMove',
	    'onTouchStart',
	    'onScroll',
	    'onWheel',
	    'onPointerCancel',
	    'onPointerDown',
	    'onPointerEnter',
	    'onPointerLeave',
	    'onPointerMove',
	    'onPointerOut',
	    'onPointerOver',
	    'onPointerUp',
	    'onGotPointerCapture',
	    'onLostPointerCapture'
	];
	/**
	 * An array of element attributes which are allowed on every html element type.
	 *
	 * @public
	 */
	exports.baseElementProperties = [
	    'accessKey',
	    'children',
	    'className',
	    'contentEditable',
	    'dir',
	    'draggable',
	    'hidden',
	    'htmlFor',
	    'id',
	    'lang',
	    'role',
	    'style',
	    'tabIndex',
	    'title',
	    'translate',
	    'spellCheck',
	    'name' // global
	];
	/**
	 * An array of HTML element properties and events.
	 *
	 * @public
	 */
	exports.htmlElementProperties = exports.baseElementProperties.concat(exports.baseElementEvents);
	/**
	 * An array of LABEL tag properties and events.
	 *
	 * @public
	 */
	exports.labelProperties = exports.htmlElementProperties.concat([
	    'form' // button, fieldset, input, label, meter, object, output, select, textarea
	]);
	/**
	 * An array of AUDIO tag properties and events.
	 *
	 * @public
	 */
	exports.audioProperties = exports.htmlElementProperties.concat([
	    'height',
	    'loop',
	    'muted',
	    'preload',
	    'src',
	    'width' // canvas, embed, iframe, img, input, object, video
	]);
	/**
	 * An array of VIDEO tag properties and events.
	 *
	 * @public
	 */
	exports.videoProperties = exports.audioProperties.concat([
	    'poster' // video
	]);
	/**
	 * An array of OL tag properties and events.
	 *
	 * @public
	 */
	exports.olProperties = exports.htmlElementProperties.concat([
	    'start' // ol
	]);
	/**
	 * An array of LI tag properties and events.
	 *
	 * @public
	 */
	exports.liProperties = exports.htmlElementProperties.concat([
	    'value' // button, input, li, option, meter, progress, param
	]);
	/**
	 * An array of A tag properties and events.
	 *
	 * @public
	 */
	exports.anchorProperties = exports.htmlElementProperties.concat([
	    'download',
	    'href',
	    'hrefLang',
	    'media',
	    'rel',
	    'target',
	    'type' // a, button, input, link, menu, object, script, source, style
	]);
	/**
	 * An array of BUTTON tag properties and events.
	 *
	 * @public
	 */
	exports.buttonProperties = exports.htmlElementProperties.concat([
	    'autoFocus',
	    'disabled',
	    'form',
	    'formAction',
	    'formEncType',
	    'formMethod',
	    'formNoValidate',
	    'formTarget',
	    'type',
	    'value' // button, input, li, option, meter, progress, param,
	]);
	/**
	 * An array of INPUT tag properties and events.
	 *
	 * @public
	 */
	exports.inputProperties = exports.buttonProperties.concat([
	    'accept',
	    'alt',
	    'autoComplete',
	    'checked',
	    'dirname',
	    'form',
	    'height',
	    'inputMode',
	    'list',
	    'max',
	    'maxLength',
	    'min',
	    'multiple',
	    'pattern',
	    'placeholder',
	    'readOnly',
	    'required',
	    'src',
	    'step',
	    'size',
	    'type',
	    'value',
	    'width' // canvas, embed, iframe, img, input, object, video
	]);
	/**
	 * An array of TEXTAREA tag properties and events.
	 *
	 * @public
	 */
	exports.textAreaProperties = exports.buttonProperties.concat([
	    'cols',
	    'dirname',
	    'form',
	    'maxLength',
	    'placeholder',
	    'readOnly',
	    'required',
	    'rows',
	    'wrap' // textarea
	]);
	/**
	 * An array of SELECT tag properties and events.
	 *
	 * @public
	 */
	exports.selectProperties = exports.buttonProperties.concat([
	    'form',
	    'multiple',
	    'required' // input, select, textarea
	]);
	exports.optionProperties = exports.htmlElementProperties.concat([
	    'selected',
	    'value' // button, input, li, option, meter, progress, param
	]);
	/**
	 * An array of TABLE tag properties and events.
	 *
	 * @public
	 */
	exports.tableProperties = exports.htmlElementProperties.concat([
	    'cellPadding',
	    'cellSpacing' // table
	]);
	/**
	 * An array of TR tag properties and events.
	 *
	 * @public
	 */
	exports.trProperties = exports.htmlElementProperties;
	/**
	 * An array of TH tag properties and events.
	 *
	 * @public
	 */
	exports.thProperties = exports.htmlElementProperties.concat([
	    'rowSpan',
	    'scope' // th
	]);
	/**
	 * An array of TD tag properties and events.
	 *
	 * @public
	 */
	exports.tdProperties = exports.htmlElementProperties.concat([
	    'colSpan',
	    'headers',
	    'rowSpan',
	    'scope' // th
	]);
	exports.colGroupProperties = exports.htmlElementProperties.concat([
	    'span' // col, colgroup
	]);
	exports.colProperties = exports.htmlElementProperties.concat([
	    'span' // col, colgroup
	]);
	/**
	 * An array of FORM tag properties and events.
	 *
	 * @public
	 */
	exports.formProperties = exports.htmlElementProperties.concat([
	    'acceptCharset',
	    'action',
	    'encType',
	    'encType',
	    'method',
	    'noValidate',
	    'target' // form
	]);
	/**
	 * An array of IFRAME tag properties and events.
	 *
	 * @public
	 */
	exports.iframeProperties = exports.htmlElementProperties.concat([
	    'allow',
	    'allowFullScreen',
	    'allowPaymentRequest',
	    'allowTransparency',
	    'csp',
	    'height',
	    'importance',
	    'referrerPolicy',
	    'sandbox',
	    'src',
	    'srcDoc',
	    'width' // canvas, embed, iframe, img, input, object, video,
	]);
	/**
	 * An array of IMAGE tag properties and events.
	 *
	 * @public
	 */
	exports.imgProperties = exports.htmlElementProperties.concat([
	    'alt',
	    'crossOrigin',
	    'height',
	    'src',
	    'srcSet',
	    'useMap',
	    'width' // canvas, embed, iframe, img, input, object, video
	]);
	/**
	 * @deprecated Use imgProperties for img elements.
	 */
	exports.imageProperties = exports.imgProperties;
	/**
	 * An array of DIV tag properties and events.
	 *
	 * @public
	 */
	exports.divProperties = exports.htmlElementProperties;
	/**
	 * Gets native supported props for an html element provided the allowance set. Use one of the property
	 * sets defined (divProperties, buttonPropertes, etc) to filter out supported properties from a given
	 * props set. Note that all data- and aria- prefixed attributes will be allowed.
	 * NOTE: getNativeProps should always be applied first when adding props to a react component. The
	 * non-native props should be applied second. This will prevent getNativeProps from overriding your custom props.
	 * For example, if props passed to getNativeProps has an onClick function and getNativeProps is added to
	 * the component after an onClick function is added, then the getNativeProps onClick will override it.
	 *
	 * @public
	 * @param props - The unfiltered input props
	 * @param allowedPropsNames-  The array of allowed propnames.
	 * @returns The filtered props
	 */
	function getNativeProps(props, allowedPropNames, excludedPropNames) {
	    return object_1.filteredAssign(function (propName) {
	        return ((!excludedPropNames || excludedPropNames.indexOf(propName) < 0) &&
	            (propName.indexOf('data-') === 0 || propName.indexOf('aria-') === 0 || allowedPropNames.indexOf(propName) >= 0));
	    }, {}, props);
	}
	exports.getNativeProps = getNativeProps;
	//# sourceMappingURL=properties.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _baseUrl = '';
	/** Sets the current base url used for fetching images. */
	function getResourceUrl(url) {
	    return _baseUrl + url;
	}
	exports.getResourceUrl = getResourceUrl;
	/** Gets the current base url used for fetching images. */
	function setBaseUrl(baseUrl) {
	    _baseUrl = baseUrl;
	}
	exports.setBaseUrl = setBaseUrl;
	//# sourceMappingURL=resources.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KeyCodes_1 = __webpack_require__(506);
	var getDocument_1 = __webpack_require__(497);
	var sessionStorage_1 = __webpack_require__(558);
	var merge_styles_1 = __webpack_require__(473);
	var RTL_LOCAL_STORAGE_KEY = 'isRTL';
	// Default to undefined so that we initialize on first read.
	var _isRTL;
	/**
	 * Gets the rtl state of the page (returns true if in rtl.)
	 */
	function getRTL() {
	    if (_isRTL === undefined) {
	        // Fabric supports persisting the RTL setting between page refreshes via session storage
	        var savedRTL = sessionStorage_1.getItem(RTL_LOCAL_STORAGE_KEY);
	        if (savedRTL !== null) {
	            _isRTL = savedRTL === '1';
	            setRTL(_isRTL);
	        }
	        var doc = getDocument_1.getDocument();
	        if (_isRTL === undefined && doc) {
	            _isRTL = ((doc.body && doc.body.getAttribute('dir')) || doc.documentElement.getAttribute('dir')) === 'rtl';
	            merge_styles_1.setRTL(_isRTL);
	        }
	    }
	    return !!_isRTL;
	}
	exports.getRTL = getRTL;
	/**
	 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
	 */
	function setRTL(isRTL, persistSetting) {
	    if (persistSetting === void 0) { persistSetting = false; }
	    var doc = getDocument_1.getDocument();
	    if (doc) {
	        doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
	    }
	    if (persistSetting) {
	        sessionStorage_1.setItem(RTL_LOCAL_STORAGE_KEY, isRTL ? '1' : '0');
	    }
	    _isRTL = isRTL;
	    merge_styles_1.setRTL(_isRTL);
	}
	exports.setRTL = setRTL;
	/**
	 * Returns the given key, but flips right/left arrows if necessary.
	 */
	function getRTLSafeKeyCode(key) {
	    if (getRTL()) {
	        if (key === KeyCodes_1.KeyCodes.left) {
	            key = KeyCodes_1.KeyCodes.right;
	        }
	        else if (key === KeyCodes_1.KeyCodes.right) {
	            key = KeyCodes_1.KeyCodes.left;
	        }
	    }
	    return key;
	}
	exports.getRTLSafeKeyCode = getRTLSafeKeyCode;
	//# sourceMappingURL=rtl.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Fetches an item from session storage without throwing an exception
	 * @param key The key of the item to fetch from session storage
	 */
	function getItem(key) {
	    var result = null;
	    try {
	        result = window.sessionStorage.getItem(key);
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	    return result;
	}
	exports.getItem = getItem;
	/**
	 * Inserts an item into session storage without throwing an exception
	 * @param key The key of the item to add to session storage
	 * @param data The data to put into session storage
	 */
	function setItem(key, data) {
	    try {
	        window.sessionStorage.setItem(key, data);
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	}
	exports.setItem = setItem;
	//# sourceMappingURL=sessionStorage.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var extendComponent_1 = __webpack_require__(542);
	/**
	 * Generates a function to be attached to a React component, which can be called
	 * as a replacement to RAF. In-flight async calls will be auto canceled if the component
	 * is unmounting before the async code is executed, preventing bugs where code
	 * accesses things within the component after being unmounted.
	 */
	exports.safeRequestAnimationFrame = function (component) {
	    var activeTimeouts;
	    return function (cb) {
	        if (!activeTimeouts) {
	            activeTimeouts = new Set();
	            extendComponent_1.extendComponent(component, {
	                componentWillUnmount: function () {
	                    activeTimeouts.forEach(function (id) { return cancelAnimationFrame(id); });
	                }
	            });
	        }
	        var timeoutId = requestAnimationFrame(function () {
	            activeTimeouts.delete(timeoutId);
	            cb();
	        });
	        activeTimeouts.add(timeoutId);
	    };
	};
	//# sourceMappingURL=safeRequestAnimationFrame.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var extendComponent_1 = __webpack_require__(542);
	/**
	 * Generates a function to be attached to a React component, which can be called
	 * as a replacement to setTimeout. In-flight async calls will be auto canceled if the component
	 * is unmounting before the async code is executed, preventing bugs where code
	 * accesses things within the component after being unmounted.
	 */
	exports.safeSetTimeout = function (component) {
	    var activeTimeouts;
	    return function (cb, duration) {
	        if (!activeTimeouts) {
	            activeTimeouts = new Set();
	            extendComponent_1.extendComponent(component, {
	                componentWillUnmount: function () {
	                    activeTimeouts.forEach(function (id) { return clearTimeout(id); });
	                }
	            });
	        }
	        var timeoutId = setTimeout(function () {
	            activeTimeouts.delete(timeoutId);
	            cb();
	        }, duration);
	        activeTimeouts.add(timeoutId);
	    };
	};
	//# sourceMappingURL=safeSetTimeout.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(562), exports);
	tslib_1.__exportStar(__webpack_require__(563), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SELECTION_CHANGE = 'change';
	/**
	 * {@docCategory Selection}
	 */
	var SelectionMode;
	(function (SelectionMode) {
	    SelectionMode[SelectionMode["none"] = 0] = "none";
	    SelectionMode[SelectionMode["single"] = 1] = "single";
	    SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
	})(SelectionMode = exports.SelectionMode || (exports.SelectionMode = {}));
	/**
	 * {@docCategory Selection}
	 */
	var SelectionDirection;
	(function (SelectionDirection) {
	    SelectionDirection[SelectionDirection["horizontal"] = 0] = "horizontal";
	    SelectionDirection[SelectionDirection["vertical"] = 1] = "vertical";
	})(SelectionDirection = exports.SelectionDirection || (exports.SelectionDirection = {}));
	//# sourceMappingURL=Selection.types.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Selection_types_1 = __webpack_require__(562);
	var EventGroup_1 = __webpack_require__(494);
	/**
	 * {@docCategory Selection}
	 */
	var Selection = /** @class */ (function () {
	    function Selection(options) {
	        if (options === void 0) { options = {}; }
	        var onSelectionChanged = options.onSelectionChanged, getKey = options.getKey, _a = options.canSelectItem, canSelectItem = _a === void 0 ? function (item) { return true; } : _a, _b = options.selectionMode, selectionMode = _b === void 0 ? Selection_types_1.SelectionMode.multiple : _b;
	        this.mode = selectionMode;
	        this._getKey = getKey || defaultGetKey;
	        this._changeEventSuppressionCount = 0;
	        this._exemptedCount = 0;
	        this._anchoredIndex = 0;
	        this._unselectableCount = 0;
	        this._onSelectionChanged = onSelectionChanged;
	        this._canSelectItem = canSelectItem;
	        this._isModal = false;
	        this.setItems([], true);
	        this.count = this.getSelectedCount();
	    }
	    Selection.prototype.canSelectItem = function (item, index) {
	        if (typeof index === 'number' && index < 0) {
	            return false;
	        }
	        return this._canSelectItem(item, index);
	    };
	    Selection.prototype.getKey = function (item, index) {
	        var key = this._getKey(item, index);
	        return typeof key === 'number' || key ? "" + key : '';
	    };
	    Selection.prototype.setChangeEvents = function (isEnabled, suppressChange) {
	        this._changeEventSuppressionCount += isEnabled ? -1 : 1;
	        if (this._changeEventSuppressionCount === 0 && this._hasChanged) {
	            this._hasChanged = false;
	            if (!suppressChange) {
	                this._change();
	            }
	        }
	    };
	    Selection.prototype.isModal = function () {
	        return this._isModal;
	    };
	    Selection.prototype.setModal = function (isModal) {
	        if (this._isModal !== isModal) {
	            this.setChangeEvents(false);
	            this._isModal = isModal;
	            if (!isModal) {
	                this.setAllSelected(false);
	            }
	            this._change();
	            this.setChangeEvents(true);
	        }
	    };
	    /**
	     * Selection needs the items, call this method to set them. If the set
	     * of items is the same, this will re-evaluate selection and index maps.
	     * Otherwise, shouldClear should be set to true, so that selection is
	     * cleared.
	     */
	    Selection.prototype.setItems = function (items, shouldClear) {
	        if (shouldClear === void 0) { shouldClear = true; }
	        var newKeyToIndexMap = {};
	        var newUnselectableIndices = {};
	        var hasSelectionChanged = false;
	        this.setChangeEvents(false);
	        // Reset the unselectable count.
	        this._unselectableCount = 0;
	        // Build lookup table for quick selection evaluation.
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            if (item) {
	                var key = this.getKey(item, i);
	                if (key) {
	                    newKeyToIndexMap[key] = i;
	                }
	            }
	            newUnselectableIndices[i] = item && !this.canSelectItem(item);
	            if (newUnselectableIndices[i]) {
	                this._unselectableCount++;
	            }
	        }
	        if (shouldClear || items.length === 0) {
	            this._setAllSelected(false, true);
	        }
	        // Check the exemption list for discrepencies.
	        var newExemptedIndicies = {};
	        var newExemptedCount = 0;
	        for (var indexProperty in this._exemptedIndices) {
	            if (this._exemptedIndices.hasOwnProperty(indexProperty)) {
	                var index = Number(indexProperty);
	                var item = this._items[index];
	                var exemptKey = item ? this.getKey(item, Number(index)) : undefined;
	                var newIndex = exemptKey ? newKeyToIndexMap[exemptKey] : index;
	                if (newIndex === undefined) {
	                    // The item has likely been replaced or removed.
	                    hasSelectionChanged = true;
	                }
	                else {
	                    // We know the new index of the item. update the existing exemption table.
	                    newExemptedIndicies[newIndex] = true;
	                    newExemptedCount++;
	                    hasSelectionChanged = hasSelectionChanged || newIndex !== index;
	                }
	            }
	        }
	        if (this._items && this._exemptedCount === 0 && items.length !== this._items.length && this._isAllSelected) {
	            // If everything was selected but the number of items has changed, selection has changed.
	            hasSelectionChanged = true;
	        }
	        this._exemptedIndices = newExemptedIndicies;
	        this._exemptedCount = newExemptedCount;
	        this._keyToIndexMap = newKeyToIndexMap;
	        this._unselectableIndices = newUnselectableIndices;
	        this._items = items;
	        this._selectedItems = null;
	        if (hasSelectionChanged) {
	            this._updateCount();
	            this._change();
	        }
	        this.setChangeEvents(true);
	    };
	    Selection.prototype.getItems = function () {
	        return this._items;
	    };
	    Selection.prototype.getSelection = function () {
	        if (!this._selectedItems) {
	            this._selectedItems = [];
	            var items = this._items;
	            if (items) {
	                for (var i = 0; i < items.length; i++) {
	                    if (this.isIndexSelected(i)) {
	                        this._selectedItems.push(items[i]);
	                    }
	                }
	            }
	        }
	        return this._selectedItems;
	    };
	    Selection.prototype.getSelectedCount = function () {
	        return this._isAllSelected ? this._items.length - this._exemptedCount - this._unselectableCount : this._exemptedCount;
	    };
	    Selection.prototype.getSelectedIndices = function () {
	        if (!this._selectedIndices) {
	            this._selectedIndices = [];
	            var items = this._items;
	            if (items) {
	                for (var i = 0; i < items.length; i++) {
	                    if (this.isIndexSelected(i)) {
	                        this._selectedIndices.push(i);
	                    }
	                }
	            }
	        }
	        return this._selectedIndices;
	    };
	    Selection.prototype.isRangeSelected = function (fromIndex, count) {
	        if (count === 0) {
	            return false;
	        }
	        var endIndex = fromIndex + count;
	        for (var i = fromIndex; i < endIndex; i++) {
	            if (!this.isIndexSelected(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Selection.prototype.isAllSelected = function () {
	        var selectableCount = this._items.length - this._unselectableCount;
	        // In single mode, we can only have a max of 1 item.
	        if (this.mode === Selection_types_1.SelectionMode.single) {
	            selectableCount = Math.min(selectableCount, 1);
	        }
	        return ((this.count > 0 && (this._isAllSelected && this._exemptedCount === 0)) ||
	            (!this._isAllSelected && this._exemptedCount === selectableCount && selectableCount > 0));
	    };
	    Selection.prototype.isKeySelected = function (key) {
	        var index = this._keyToIndexMap[key];
	        return this.isIndexSelected(index);
	    };
	    Selection.prototype.isIndexSelected = function (index) {
	        return !!((this.count > 0 && (this._isAllSelected && !this._exemptedIndices[index] && !this._unselectableIndices[index])) ||
	            (!this._isAllSelected && this._exemptedIndices[index]));
	    };
	    Selection.prototype.setAllSelected = function (isAllSelected) {
	        if (isAllSelected && this.mode !== Selection_types_1.SelectionMode.multiple) {
	            return;
	        }
	        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
	        this.setChangeEvents(false);
	        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
	            this._exemptedIndices = {};
	            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
	                this._exemptedCount = 0;
	                this._isAllSelected = isAllSelected;
	                this._change();
	            }
	            this._updateCount();
	        }
	        this.setChangeEvents(true);
	    };
	    Selection.prototype.setKeySelected = function (key, isSelected, shouldAnchor) {
	        var index = this._keyToIndexMap[key];
	        if (index >= 0) {
	            this.setIndexSelected(index, isSelected, shouldAnchor);
	        }
	    };
	    Selection.prototype.setIndexSelected = function (index, isSelected, shouldAnchor) {
	        if (this.mode === Selection_types_1.SelectionMode.none) {
	            return;
	        }
	        // Clamp the index.
	        index = Math.min(Math.max(0, index), this._items.length - 1);
	        // No-op on out of bounds selections.
	        if (index < 0 || index >= this._items.length) {
	            return;
	        }
	        this.setChangeEvents(false);
	        var isExempt = this._exemptedIndices[index];
	        var canSelect = !this._unselectableIndices[index];
	        if (canSelect) {
	            if (isSelected && this.mode === Selection_types_1.SelectionMode.single) {
	                // If this is single-select, the previous selection should be removed.
	                this._setAllSelected(false, true);
	            }
	            // Determine if we need to remove the exemption.
	            if (isExempt && ((isSelected && this._isAllSelected) || (!isSelected && !this._isAllSelected))) {
	                delete this._exemptedIndices[index];
	                this._exemptedCount--;
	            }
	            // Determine if we need to add the exemption.
	            if (!isExempt && ((isSelected && !this._isAllSelected) || (!isSelected && this._isAllSelected))) {
	                this._exemptedIndices[index] = true;
	                this._exemptedCount++;
	            }
	            if (shouldAnchor) {
	                this._anchoredIndex = index;
	            }
	        }
	        this._updateCount();
	        this.setChangeEvents(true);
	    };
	    Selection.prototype.selectToKey = function (key, clearSelection) {
	        this.selectToIndex(this._keyToIndexMap[key], clearSelection);
	    };
	    Selection.prototype.selectToIndex = function (index, clearSelection) {
	        if (this.mode === Selection_types_1.SelectionMode.none) {
	            return;
	        }
	        if (this.mode === Selection_types_1.SelectionMode.single) {
	            this.setIndexSelected(index, true, true);
	            return;
	        }
	        var anchorIndex = this._anchoredIndex || 0;
	        var startIndex = Math.min(index, anchorIndex);
	        var endIndex = Math.max(index, anchorIndex);
	        this.setChangeEvents(false);
	        if (clearSelection) {
	            this._setAllSelected(false, true);
	        }
	        for (; startIndex <= endIndex; startIndex++) {
	            this.setIndexSelected(startIndex, true, false);
	        }
	        this.setChangeEvents(true);
	    };
	    Selection.prototype.toggleAllSelected = function () {
	        this.setAllSelected(!this.isAllSelected());
	    };
	    Selection.prototype.toggleKeySelected = function (key) {
	        this.setKeySelected(key, !this.isKeySelected(key), true);
	    };
	    Selection.prototype.toggleIndexSelected = function (index) {
	        this.setIndexSelected(index, !this.isIndexSelected(index), true);
	    };
	    Selection.prototype.toggleRangeSelected = function (fromIndex, count) {
	        if (this.mode === Selection_types_1.SelectionMode.none) {
	            return;
	        }
	        var isRangeSelected = this.isRangeSelected(fromIndex, count);
	        var endIndex = fromIndex + count;
	        if (this.mode === Selection_types_1.SelectionMode.single && count > 1) {
	            return;
	        }
	        this.setChangeEvents(false);
	        for (var i = fromIndex; i < endIndex; i++) {
	            this.setIndexSelected(i, !isRangeSelected, false);
	        }
	        this.setChangeEvents(true);
	    };
	    Selection.prototype._updateCount = function (preserveModalState) {
	        if (preserveModalState === void 0) { preserveModalState = false; }
	        var count = this.getSelectedCount();
	        if (count !== this.count) {
	            this.count = count;
	            this._change();
	        }
	        if (!this.count && !preserveModalState) {
	            this.setModal(false);
	        }
	    };
	    Selection.prototype._setAllSelected = function (isAllSelected, preserveModalState) {
	        if (preserveModalState === void 0) { preserveModalState = false; }
	        if (isAllSelected && this.mode !== Selection_types_1.SelectionMode.multiple) {
	            return;
	        }
	        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
	        this.setChangeEvents(false);
	        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
	            this._exemptedIndices = {};
	            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
	                this._exemptedCount = 0;
	                this._isAllSelected = isAllSelected;
	                this._change();
	            }
	            this._updateCount(preserveModalState);
	        }
	        this.setChangeEvents(true);
	    };
	    Selection.prototype._change = function () {
	        if (this._changeEventSuppressionCount === 0) {
	            this._selectedItems = null;
	            this._selectedIndices = undefined;
	            EventGroup_1.EventGroup.raise(this, Selection_types_1.SELECTION_CHANGE);
	            if (this._onSelectionChanged) {
	                this._onSelectionChanged();
	            }
	        }
	        else {
	            this._hasChanged = true;
	        }
	    };
	    return Selection;
	}());
	exports.Selection = Selection;
	function defaultGetKey(item, index) {
	    return item && item.key ? item.key : "" + index;
	}
	//# sourceMappingURL=Selection.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Regex that finds { and } so they can be removed on a lookup for string format
	var FORMAT_ARGS_REGEX = /[\{\}]/g;
	// Regex that finds {#} so it can be replaced by the arguments in string format
	var FORMAT_REGEX = /\{\d+\}/g;
	/**
	 * String format method, used for scenarios where at runtime you
	 * need to evaluate a formatted string given a tokenized string. This
	 * usually only is needed in localization scenarios.
	
	 * @example
	 * ```tsx
	 * "I love {0} every {1}".format("CXP")
	 * ```
	 * will result in a Debug Exception.
	 *
	 * @public
	 */
	// tslint:disable-next-line:no-any
	function format(s) {
	    'use strict';
	    var values = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        values[_i - 1] = arguments[_i];
	    }
	    var args = values;
	    // Callback match function
	    function replace_func(match) {
	        // looks up in the args
	        // tslint:disable-next-line:no-any
	        var replacement = args[match.replace(FORMAT_ARGS_REGEX, '')];
	        // catches undefined in nondebug and null in debug and nondebug
	        if (replacement === null || replacement === undefined) {
	            replacement = '';
	        }
	        return replacement;
	    }
	    return s.replace(FORMAT_REGEX, replace_func);
	}
	exports.format = format;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var merge_styles_1 = __webpack_require__(473);
	var Customizations_1 = __webpack_require__(522);
	var CustomizerContext_1 = __webpack_require__(524);
	var DefaultFields = ['theme', 'styles'];
	/**
	 * The styled HOC wrapper allows you to create a functional wrapper around a given component which will resolve
	 * getStyles functional props, and mix customized props passed in using concatStyleSets.
	 *
	 * @example
	 * ```tsx
	 * export const Toggle = styled(
	 *   ToggleBase,
	 *   props => ({ root: { background: 'red' }})
	 * );
	 * ```
	 * @param Component - The unstyled base component to render, which receives styles.
	 * @param baseStyles - The styles which should be curried with the component.
	 * @param getProps - A helper which provides default props.
	 * @param customizable - An object which defines which props can be customized using the Customizer.
	 * @param pure - A boolean indicating if the component should avoid re-rendering when props haven't changed.
	 * Note that pure should not be used on components which allow children, or take in complex objects or
	 * arrays as props which could mutate on every render.
	 */
	function styled(Component, baseStyles, getProps, customizable, pure) {
	    customizable = customizable || { scope: '', fields: undefined };
	    var scope = customizable.scope, _a = customizable.fields, fields = _a === void 0 ? DefaultFields : _a;
	    var ParentComponent = pure ? React.PureComponent : React.Component;
	    var Wrapped = /** @class */ (function (_super) {
	        tslib_1.__extends(Wrapped, _super);
	        function Wrapped() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this._inCustomizerContext = false;
	            _this._renderContent = function (context) {
	                _this._inCustomizerContext = !!context.customizations.inCustomizerContext;
	                var settings = Customizations_1.Customizations.getSettings(fields, scope, context.customizations);
	                var customizedStyles = settings.styles, dir = settings.dir, rest = tslib_1.__rest(settings, ["styles", "dir"]);
	                var additionalProps = getProps ? getProps(_this.props) : undefined;
	                _this._updateStyles(customizedStyles);
	                return React.createElement(Component, tslib_1.__assign({}, rest, additionalProps, _this.props, { styles: _this._styles }));
	            };
	            _this._onSettingsChanged = function () { return _this.forceUpdate(); };
	            return _this;
	        }
	        Wrapped.prototype.render = function () {
	            return React.createElement(CustomizerContext_1.CustomizerContext.Consumer, null, this._renderContent);
	        };
	        Wrapped.prototype.componentDidMount = function () {
	            if (!this._inCustomizerContext) {
	                Customizations_1.Customizations.observe(this._onSettingsChanged);
	            }
	        };
	        Wrapped.prototype.componentWillUnmount = function () {
	            if (!this._inCustomizerContext) {
	                Customizations_1.Customizations.unobserve(this._onSettingsChanged);
	            }
	        };
	        Wrapped.prototype._updateStyles = function (customizedStyles) {
	            var _this = this;
	            // tslint:disable-next-line:no-any
	            if (!this._styles || customizedStyles !== this._styles.__cachedInputs__[1] || !!this.props.styles) {
	                // Cache the customized styles.
	                // this._customizedStyles = customizedStyles;
	                // Using styled components as the Component arg will result in nested styling arrays.
	                this._styles = function (styleProps) { return _resolve(styleProps, baseStyles, customizedStyles, _this.props.styles); };
	                // The __cachedInputs__ array is attached to the function and consumed by the
	                // classNamesFunction as a list of keys to include for memoizing classnames.
	                // tslint:disable-next-line:no-any
	                this._styles.__cachedInputs__ = [baseStyles, customizedStyles, this.props.styles];
	            }
	        };
	        // Function.prototype.name is an ES6 feature, so the cast to any is required until we're
	        // able to drop IE 11 support and compile with ES6 libs
	        // tslint:disable-next-line:no-any
	        Wrapped.displayName = "Styled" + (Component.displayName || Component.name);
	        return Wrapped;
	    }(ParentComponent));
	    // This preserves backwards compatibility.
	    // tslint:disable-next-line:no-any
	    return Wrapped;
	}
	exports.styled = styled;
	function _resolve(styleProps) {
	    var allStyles = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        allStyles[_i - 1] = arguments[_i];
	    }
	    var result = [];
	    for (var _a = 0, allStyles_1 = allStyles; _a < allStyles_1.length; _a++) {
	        var styles = allStyles_1[_a];
	        if (styles) {
	            result.push(typeof styles === 'function' ? styles(styleProps) : styles);
	        }
	    }
	    if (result.length === 1) {
	        return result[0];
	    }
	    else if (result.length) {
	        // cliffkoh: I cannot figure out how to avoid the cast to any here.
	        // It is something to do with the use of Omit in IStyleSet.
	        // It might not be necessary once  Omit becomes part of lib.d.ts (when we remove our own Omit and rely on
	        // the official version).
	        // tslint:disable-next-line:no-any
	        return merge_styles_1.concatStyleSets.apply(void 0, result);
	    }
	    return {};
	}
	//# sourceMappingURL=styled.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(501), exports);
	tslib_1.__exportStar(__webpack_require__(500), exports);
	tslib_1.__exportStar(__webpack_require__(503), exports);
	tslib_1.__exportStar(__webpack_require__(502), exports);
	//# sourceMappingURL=warn.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getWindow_1 = __webpack_require__(491);
	exports.IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
	/**
	 * Sets the visibility of focus styling.
	 * By default, focus styling (the box surrounding a focused Button, for example) only show up when navigational
	 * keypresses occur (through TAB, arrows, pgup/down, home and end), and are hidden when mouse interactions occur.
	 * This API provides an imperative way to turn them on/off.
	 * A use case might be when you have a keypress like ctrl-f6 navigate to a particular region on the page, and want focus to show up.
	 *
	 * @param enabled - whether to remove or add focus
	 * @param target - optional target
	 */
	function setFocusVisibility(enabled, target) {
	    var win = target ? getWindow_1.getWindow(target) : getWindow_1.getWindow();
	    if (win) {
	        var classList = win.document.body.classList;
	        if (enabled) {
	            classList.add(exports.IsFocusVisibleClassName);
	        }
	        else {
	            classList.remove(exports.IsFocusVisibleClassName);
	        }
	    }
	}
	exports.setFocusVisibility = setFocusVisibility;
	//# sourceMappingURL=setFocusVisibility.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// @uifabric/utilities@6.45.1
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('@uifabric/utilities', '6.45.1');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var icons_1 = __webpack_require__(488);
	var defaultIconStyles = {
	    display: 'inline-block'
	};
	/**
	 * Gets an icon classname. You should be able to add this classname to an I tag with no
	 * additional classnames, and render the icon.
	 *
	 * @public
	 */
	function getIconClassName(name) {
	    var className = '';
	    var icon = icons_1.getIcon(name);
	    if (icon) {
	        className = merge_styles_1.mergeStyles(icon.subset.className, defaultIconStyles, {
	            selectors: {
	                '::before': {
	                    content: "\"" + icon.code + "\""
	                }
	            }
	        });
	    }
	    return className;
	}
	exports.getIconClassName = getIconClassName;
	//# sourceMappingURL=getIconClassName.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var AnimationStyles_1 = __webpack_require__(571);
	exports.AnimationStyles = AnimationStyles_1.AnimationStyles;
	exports.AnimationVariables = AnimationStyles_1.AnimationVariables;
	var DefaultPalette_1 = __webpack_require__(572);
	exports.DefaultPalette = DefaultPalette_1.DefaultPalette;
	var DefaultFontStyles_1 = __webpack_require__(573);
	exports.DefaultFontStyles = DefaultFontStyles_1.DefaultFontStyles;
	exports.registerDefaultFontFaces = DefaultFontStyles_1.registerDefaultFontFaces;
	var fonts_1 = __webpack_require__(574);
	exports.FontSizes = fonts_1.FontSizes;
	exports.FontWeights = fonts_1.FontWeights;
	exports.IconFontSizes = fonts_1.IconFontSizes;
	exports.createFontStyles = fonts_1.createFontStyles;
	tslib_1.__exportStar(__webpack_require__(575), exports);
	var hiddenContentStyle_1 = __webpack_require__(578);
	exports.hiddenContentStyle = hiddenContentStyle_1.hiddenContentStyle;
	var PulsingBeaconAnimationStyles_1 = __webpack_require__(579);
	exports.PulsingBeaconAnimationStyles = PulsingBeaconAnimationStyles_1.PulsingBeaconAnimationStyles;
	var getGlobalClassNames_1 = __webpack_require__(580);
	exports.getGlobalClassNames = getGlobalClassNames_1.getGlobalClassNames;
	tslib_1.__exportStar(__webpack_require__(581), exports);
	var theme_1 = __webpack_require__(582);
	exports.ThemeSettingName = theme_1.ThemeSettingName;
	exports.getTheme = theme_1.getTheme;
	exports.loadTheme = theme_1.loadTheme;
	exports.createTheme = theme_1.createTheme;
	exports.registerOnThemeChangeCallback = theme_1.registerOnThemeChangeCallback;
	exports.removeOnThemeChangeCallback = theme_1.removeOnThemeChangeCallback;
	tslib_1.__exportStar(__webpack_require__(576), exports);
	tslib_1.__exportStar(__webpack_require__(586), exports);
	tslib_1.__exportStar(__webpack_require__(587), exports);
	tslib_1.__exportStar(__webpack_require__(588), exports);
	tslib_1.__exportStar(__webpack_require__(577), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	/* Register the keyframes */
	var EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
	var EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
	var DURATION_1 = '0.167s';
	var DURATION_2 = '0.267s';
	var DURATION_3 = '0.367s';
	var DURATION_4 = '0.467s';
	var FADE_IN = merge_styles_1.keyframes({
	    from: { opacity: 0 },
	    to: { opacity: 1 }
	});
	var FADE_OUT = merge_styles_1.keyframes({
	    from: { opacity: 1 },
	    to: { opacity: 0 }
	});
	var SLIDE_RIGHT_IN10 = _createSlideInX(-10);
	var SLIDE_RIGHT_IN20 = _createSlideInX(-20);
	var SLIDE_RIGHT_IN40 = _createSlideInX(-40);
	var SLIDE_RIGHT_IN400 = _createSlideInX(-400);
	var SLIDE_LEFT_IN10 = _createSlideInX(10);
	var SLIDE_LEFT_IN20 = _createSlideInX(20);
	var SLIDE_LEFT_IN40 = _createSlideInX(40);
	var SLIDE_LEFT_IN400 = _createSlideInX(400);
	var SLIDE_UP_IN10 = _createSlideInY(10);
	var SLIDE_UP_IN20 = _createSlideInY(20);
	var SLIDE_DOWN_IN10 = _createSlideInY(-10);
	var SLIDE_DOWN_IN20 = _createSlideInY(-20);
	var SLIDE_RIGHT_OUT10 = _createSlideOutX(10);
	var SLIDE_RIGHT_OUT20 = _createSlideOutX(20);
	var SLIDE_RIGHT_OUT40 = _createSlideOutX(40);
	var SLIDE_RIGHT_OUT400 = _createSlideOutX(400);
	var SLIDE_LEFT_OUT10 = _createSlideOutX(-10);
	var SLIDE_LEFT_OUT20 = _createSlideOutX(-20);
	var SLIDE_LEFT_OUT40 = _createSlideOutX(-40);
	var SLIDE_LEFT_OUT400 = _createSlideOutX(-400);
	var SLIDE_UP_OUT10 = _createSlideOutY(-10);
	var SLIDE_UP_OUT20 = _createSlideOutY(-20);
	var SLIDE_DOWN_OUT10 = _createSlideOutY(10);
	var SLIDE_DOWN_OUT20 = _createSlideOutY(20);
	var SCALE_UP100 = merge_styles_1.keyframes({
	    from: { transform: 'scale3d(.98,.98,1)' },
	    to: { transform: 'scale3d(1,1,1)' }
	});
	var SCALE_DOWN98 = merge_styles_1.keyframes({
	    from: { transform: 'scale3d(1,1,1)' },
	    to: { transform: 'scale3d(.98,.98,1)' }
	});
	var SCALE_DOWN100 = merge_styles_1.keyframes({
	    from: { transform: 'scale3d(1.03,1.03,1)' },
	    to: { transform: 'scale3d(1,1,1)' }
	});
	var SCALE_UP103 = merge_styles_1.keyframes({
	    from: { transform: 'scale3d(1,1,1)' },
	    to: { transform: 'scale3d(1.03,1.03,1)' }
	});
	var ROTATE90 = merge_styles_1.keyframes({
	    from: { transform: 'rotateZ(0deg)' },
	    to: { transform: 'rotateZ(90deg)' }
	});
	var ROTATE_N90 = merge_styles_1.keyframes({
	    from: { transform: 'rotateZ(0deg)' },
	    to: { transform: 'rotateZ(-90deg)' }
	});
	/**
	 * Exporting raw duraction values and easing functions to be used in custom animations
	 */
	exports.AnimationVariables = {
	    easeFunction1: EASING_FUNCTION_1,
	    easeFunction2: EASING_FUNCTION_2,
	    durationValue1: DURATION_1,
	    durationValue2: DURATION_2,
	    durationValue3: DURATION_3,
	    durationValue4: DURATION_4
	};
	/**
	 * All Fabric standard animations, exposed as json objects referencing predefined
	 * keyframes. These objects can be mixed in with other class definitions.
	 */
	exports.AnimationStyles = {
	    slideRightIn10: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn20: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn40: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN40, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn400: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN400, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn10: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn20: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn40: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN40, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn400: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN400, DURATION_3, EASING_FUNCTION_1),
	    slideUpIn10: _createAnimation(FADE_IN + "," + SLIDE_UP_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideUpIn20: _createAnimation(FADE_IN + "," + SLIDE_UP_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideDownIn10: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideDownIn20: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut10: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut20: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut40: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT40, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut400: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT400, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut10: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut20: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut40: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT40, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut400: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT400, DURATION_3, EASING_FUNCTION_1),
	    slideUpOut10: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideUpOut20: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideDownOut10: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideDownOut20: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT20, DURATION_3, EASING_FUNCTION_1),
	    scaleUpIn100: _createAnimation(FADE_IN + "," + SCALE_UP100, DURATION_3, EASING_FUNCTION_1),
	    scaleDownIn100: _createAnimation(FADE_IN + "," + SCALE_DOWN100, DURATION_3, EASING_FUNCTION_1),
	    scaleUpOut103: _createAnimation(FADE_OUT + "," + SCALE_UP103, DURATION_1, EASING_FUNCTION_2),
	    scaleDownOut98: _createAnimation(FADE_OUT + "," + SCALE_DOWN98, DURATION_1, EASING_FUNCTION_2),
	    fadeIn100: _createAnimation(FADE_IN, DURATION_1, EASING_FUNCTION_2),
	    fadeIn200: _createAnimation(FADE_IN, DURATION_2, EASING_FUNCTION_2),
	    fadeIn400: _createAnimation(FADE_IN, DURATION_3, EASING_FUNCTION_2),
	    fadeIn500: _createAnimation(FADE_IN, DURATION_4, EASING_FUNCTION_2),
	    fadeOut100: _createAnimation(FADE_OUT, DURATION_1, EASING_FUNCTION_2),
	    fadeOut200: _createAnimation(FADE_OUT, DURATION_2, EASING_FUNCTION_2),
	    fadeOut400: _createAnimation(FADE_OUT, DURATION_3, EASING_FUNCTION_2),
	    fadeOut500: _createAnimation(FADE_OUT, DURATION_4, EASING_FUNCTION_2),
	    rotate90deg: _createAnimation(ROTATE90, '0.1s', EASING_FUNCTION_2),
	    rotateN90deg: _createAnimation(ROTATE_N90, '0.1s', EASING_FUNCTION_2)
	    // expandCollapse 100/200/400, delay 100/200
	};
	function _createAnimation(animationName, animationDuration, animationTimingFunction) {
	    return {
	        animationName: animationName,
	        animationDuration: animationDuration,
	        animationTimingFunction: animationTimingFunction,
	        animationFillMode: 'both'
	    };
	}
	function _createSlideInX(fromX) {
	    return merge_styles_1.keyframes({
	        from: { transform: "translate3d(" + fromX + "px,0,0)" },
	        to: { transform: "translate3d(0,0,0)" }
	    });
	}
	function _createSlideInY(fromY) {
	    return merge_styles_1.keyframes({
	        from: { transform: "translate3d(0," + fromY + "px,0)" },
	        to: { transform: "translate3d(0,0,0)" }
	    });
	}
	function _createSlideOutX(toX) {
	    return merge_styles_1.keyframes({
	        from: { transform: "translate3d(0,0,0)" },
	        to: { transform: "translate3d(" + toX + "px,0,0)" }
	    });
	}
	function _createSlideOutY(toY) {
	    return merge_styles_1.keyframes({
	        from: { transform: "translate3d(0,0,0)" },
	        to: { transform: "translate3d(0," + toY + "px,0)" }
	    });
	}
	//# sourceMappingURL=AnimationStyles.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// When adding or removing a color, make sure you keep this consistent with IColorClassNames by adding the color variants.
	exports.DefaultPalette = {
	    themeDarker: '#004578',
	    themeDark: '#005a9e',
	    themeDarkAlt: '#106ebe',
	    themePrimary: '#0078d4',
	    themeSecondary: '#2b88d8',
	    themeTertiary: '#71afe5',
	    themeLight: '#c7e0f4',
	    themeLighter: '#deecf9',
	    themeLighterAlt: '#eff6fc',
	    black: '#000000',
	    blackTranslucent40: 'rgba(0,0,0,.4)',
	    neutralDark: '#212121',
	    neutralPrimary: '#333333',
	    neutralPrimaryAlt: '#3c3c3c',
	    neutralSecondary: '#666666',
	    neutralSecondaryAlt: '#767676',
	    neutralTertiary: '#a6a6a6',
	    neutralTertiaryAlt: '#c8c8c8',
	    neutralQuaternary: '#d0d0d0',
	    neutralQuaternaryAlt: '#dadada',
	    neutralLight: '#eaeaea',
	    neutralLighter: '#f4f4f4',
	    neutralLighterAlt: '#f8f8f8',
	    accent: '#0078d4',
	    white: '#ffffff',
	    whiteTranslucent40: 'rgba(255,255,255,.4)',
	    yellowDark: '#d29200',
	    yellow: '#ffb900',
	    yellowLight: '#fff100',
	    orange: '#d83b01',
	    orangeLight: '#ea4300',
	    orangeLighter: '#ff8c00',
	    redDark: '#a80000',
	    red: '#e81123',
	    magentaDark: '#5c005c',
	    magenta: '#b4009e',
	    magentaLight: '#e3008c',
	    purpleDark: '#32145a',
	    purple: '#5c2d91',
	    purpleLight: '#b4a0ff',
	    blueDark: '#002050',
	    blueMid: '#00188f',
	    blue: '#0078d4',
	    blueLight: '#00bcf2',
	    tealDark: '#004b50',
	    teal: '#008272',
	    tealLight: '#00b294',
	    greenDark: '#004b1c',
	    green: '#107c10',
	    greenLight: '#bad80a'
	};
	//# sourceMappingURL=DefaultPalette.js.map

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var fonts_1 = __webpack_require__(574);
	var utilities_1 = __webpack_require__(489);
	// Default urls.
	var DefaultBaseUrl = 'https://static2.sharepointonline.com/files/fabric/assets';
	// Standard font styling.
	exports.DefaultFontStyles = fonts_1.createFontStyles(utilities_1.getLanguage());
	function _registerFontFace(fontFamily, url, fontWeight, localFontName) {
	    fontFamily = "'" + fontFamily + "'";
	    var localFontSrc = localFontName !== undefined ? "local('" + localFontName + "')," : '';
	    merge_styles_1.fontFace({
	        fontFamily: fontFamily,
	        src: localFontSrc + ("url('" + url + ".woff2') format('woff2'),") + ("url('" + url + ".woff') format('woff')"),
	        fontWeight: fontWeight,
	        fontStyle: 'normal'
	    });
	}
	function _registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
	    if (cdnFontName === void 0) { cdnFontName = 'segoeui'; }
	    var urlBase = baseUrl + "/" + cdnFolder + "/" + cdnFontName;
	    _registerFontFace(fontFamily, urlBase + '-light', fonts_1.FontWeights.light, localFontName && localFontName + ' Light');
	    _registerFontFace(fontFamily, urlBase + '-semilight', fonts_1.FontWeights.semilight, localFontName && localFontName + ' SemiLight');
	    _registerFontFace(fontFamily, urlBase + '-regular', fonts_1.FontWeights.regular, localFontName);
	    _registerFontFace(fontFamily, urlBase + '-semibold', fonts_1.FontWeights.semibold, localFontName && localFontName + ' SemiBold');
	}
	function registerDefaultFontFaces(baseUrl) {
	    if (baseUrl) {
	        var fontUrl = baseUrl + "/fonts";
	        // Produce @font-face definitions for all supported web fonts.
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Thai, 'leelawadeeui-thai', 'leelawadeeui');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Arabic, 'segoeui-arabic');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Cyrillic, 'segoeui-cyrillic');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.EastEuropean, 'segoeui-easteuropean');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Greek, 'segoeui-greek');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Hebrew, 'segoeui-hebrew');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Vietnamese, 'segoeui-vietnamese');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontFamilies.Selawik, 'selawik', 'selawik');
	        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
	        // the font-face generated above to use the 'semilight' weight instead.
	        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-semilight", fonts_1.FontWeights.light);
	        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
	        // the font-face generated above to use the 'bold' weight instead.
	        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-bold", fonts_1.FontWeights.semibold);
	    }
	}
	exports.registerDefaultFontFaces = registerDefaultFontFaces;
	/**
	 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
	 */
	function _getFontBaseUrl() {
	    var win = utilities_1.getWindow();
	    // tslint:disable-next-line:no-string-literal no-any
	    var fabricConfig = win ? win['FabricConfig'] : undefined;
	    return fabricConfig && fabricConfig.fontBaseUrl !== undefined ? fabricConfig.fontBaseUrl : DefaultBaseUrl;
	}
	/**
	 * Register the font faces.
	 */
	registerDefaultFontFaces(_getFontBaseUrl());
	//# sourceMappingURL=DefaultFontStyles.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Fallback fonts, if specified system or web fonts are unavailable.
	var FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
	// Font face names to be registered.
	var LocalizedFontNames;
	(function (LocalizedFontNames) {
	    LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
	    LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
	    LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
	    LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
	    LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
	    LocalizedFontNames.Thai = 'Leelawadee UI Web';
	    LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
	    LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
	    LocalizedFontNames.Selawik = 'Selawik Web';
	})(LocalizedFontNames = exports.LocalizedFontNames || (exports.LocalizedFontNames = {}));
	// Font families with fallbacks, for the general regions.
	var LocalizedFontFamilies;
	(function (LocalizedFontFamilies) {
	    LocalizedFontFamilies.Arabic = "'" + LocalizedFontNames.Arabic + "'";
	    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
	    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
	    LocalizedFontFamilies.Cyrillic = "'" + LocalizedFontNames.Cyrillic + "'";
	    LocalizedFontFamilies.EastEuropean = "'" + LocalizedFontNames.EastEuropean + "'";
	    LocalizedFontFamilies.Greek = "'" + LocalizedFontNames.Greek + "'";
	    LocalizedFontFamilies.Hebrew = "'" + LocalizedFontNames.Hebrew + "'";
	    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
	    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
	    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
	    LocalizedFontFamilies.Selawik = "'" + LocalizedFontNames.Selawik + "'";
	    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
	    LocalizedFontFamilies.Vietnamese = "'" + LocalizedFontNames.Vietnamese + "'";
	    LocalizedFontFamilies.WestEuropean = "'" + LocalizedFontNames.WestEuropean + "'";
	})(LocalizedFontFamilies = exports.LocalizedFontFamilies || (exports.LocalizedFontFamilies = {}));
	// By default, we favor system fonts for the default.
	// All localized fonts use a web font and never use the system font.
	var defaultFontFamily = "'Segoe UI', '" + LocalizedFontNames.WestEuropean + "'";
	// Mapping of language prefix to to font family.
	var LanguageToFontMap = {
	    ar: LocalizedFontFamilies.Arabic,
	    bg: LocalizedFontFamilies.Cyrillic,
	    cs: LocalizedFontFamilies.EastEuropean,
	    el: LocalizedFontFamilies.Greek,
	    et: LocalizedFontFamilies.EastEuropean,
	    he: LocalizedFontFamilies.Hebrew,
	    hi: LocalizedFontFamilies.Hindi,
	    hr: LocalizedFontFamilies.EastEuropean,
	    hu: LocalizedFontFamilies.EastEuropean,
	    ja: LocalizedFontFamilies.Japanese,
	    kk: LocalizedFontFamilies.EastEuropean,
	    ko: LocalizedFontFamilies.Korean,
	    lt: LocalizedFontFamilies.EastEuropean,
	    lv: LocalizedFontFamilies.EastEuropean,
	    pl: LocalizedFontFamilies.EastEuropean,
	    ru: LocalizedFontFamilies.Cyrillic,
	    sk: LocalizedFontFamilies.EastEuropean,
	    'sr-latn': LocalizedFontFamilies.EastEuropean,
	    th: LocalizedFontFamilies.Thai,
	    tr: LocalizedFontFamilies.EastEuropean,
	    uk: LocalizedFontFamilies.Cyrillic,
	    vi: LocalizedFontFamilies.Vietnamese,
	    'zh-hans': LocalizedFontFamilies.ChineseSimplified,
	    'zh-hant': LocalizedFontFamilies.ChineseTraditional
	};
	// Standard font sizes.
	var FontSizes;
	(function (FontSizes) {
	    FontSizes.mini = '10px';
	    FontSizes.xSmall = '11px';
	    FontSizes.small = '12px';
	    FontSizes.smallPlus = '13px';
	    FontSizes.medium = '14px';
	    FontSizes.mediumPlus = '15px';
	    FontSizes.icon = '16px';
	    FontSizes.large = '17px';
	    FontSizes.xLarge = '21px';
	    FontSizes.xLargePlus = '21px';
	    FontSizes.xxLarge = '28px';
	    FontSizes.xxLargePlus = '28px';
	    FontSizes.superLarge = '42px';
	    FontSizes.mega = '72px';
	})(FontSizes = exports.FontSizes || (exports.FontSizes = {}));
	// Standard font weights.
	var FontWeights;
	(function (FontWeights) {
	    FontWeights.light = 100;
	    FontWeights.semilight = 300;
	    FontWeights.regular = 400;
	    FontWeights.semibold = 600;
	    FontWeights.bold = 700;
	})(FontWeights = exports.FontWeights || (exports.FontWeights = {}));
	// Standard Icon Sizes.
	var IconFontSizes;
	(function (IconFontSizes) {
	    IconFontSizes.xSmall = '10px';
	    IconFontSizes.small = '12px';
	    IconFontSizes.medium = '16px';
	    IconFontSizes.large = '20px';
	})(IconFontSizes = exports.IconFontSizes || (exports.IconFontSizes = {}));
	function _fontFamilyWithFallbacks(fontFamily) {
	    return fontFamily + ", " + FontFamilyFallbacks;
	}
	function createFontStyles(localeCode) {
	    var localizedFont = _getLocalizedFontFamily(localeCode);
	    var fontFamilyWithFallback = _fontFamilyWithFallbacks(localizedFont);
	    var semilightFontFamilyWithFallback = fontFamilyWithFallback;
	    // Chrome has a bug where it does not render Segoe UI Semilight correctly, so we force the webfont to be used in that case
	    if (localizedFont === defaultFontFamily) {
	        semilightFontFamilyWithFallback = _fontFamilyWithFallbacks(LocalizedFontFamilies.WestEuropean);
	    }
	    var fontStyles = {
	        tiny: _createFont(FontSizes.mini, FontWeights.semibold, fontFamilyWithFallback),
	        xSmall: _createFont(FontSizes.xSmall, FontWeights.regular, fontFamilyWithFallback),
	        small: _createFont(FontSizes.small, FontWeights.regular, fontFamilyWithFallback),
	        smallPlus: _createFont(FontSizes.smallPlus, FontWeights.regular, fontFamilyWithFallback),
	        medium: _createFont(FontSizes.medium, FontWeights.regular, fontFamilyWithFallback),
	        mediumPlus: _createFont(FontSizes.mediumPlus, FontWeights.regular, fontFamilyWithFallback),
	        large: _createFont(FontSizes.large, FontWeights.semilight, semilightFontFamilyWithFallback),
	        xLarge: _createFont(FontSizes.xLarge, FontWeights.light, fontFamilyWithFallback),
	        xLargePlus: _createFont(FontSizes.xLargePlus, FontWeights.light, fontFamilyWithFallback),
	        xxLarge: _createFont(FontSizes.xxLarge, FontWeights.light, fontFamilyWithFallback),
	        xxLargePlus: _createFont(FontSizes.xxLargePlus, FontWeights.light, fontFamilyWithFallback),
	        superLarge: _createFont(FontSizes.superLarge, FontWeights.light, fontFamilyWithFallback),
	        mega: _createFont(FontSizes.mega, FontWeights.light, fontFamilyWithFallback)
	    };
	    return fontStyles;
	}
	exports.createFontStyles = createFontStyles;
	/**
	 * If there is a localized font for this language, return that. Returns undefined if there is no localized font for that language.
	 */
	function _getLocalizedFontFamily(language) {
	    for (var lang in LanguageToFontMap) {
	        if (LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
	            // tslint:disable-next-line:no-any
	            return LanguageToFontMap[lang];
	        }
	    }
	    return defaultFontFamily;
	}
	function _createFont(size, weight, fontFamily) {
	    return {
	        fontFamily: fontFamily,
	        MozOsxFontSmoothing: 'grayscale',
	        WebkitFontSmoothing: 'antialiased',
	        fontSize: size,
	        fontWeight: weight
	    };
	}
	//# sourceMappingURL=fonts.js.map

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommonStyles_1 = __webpack_require__(576);
	var utilities_1 = __webpack_require__(489);
	var zIndexes_1 = __webpack_require__(577);
	function getFocusStyle(theme, insetOrOptions, position, highContrastStyle, borderColor, outlineColor, isFocusedOnly) {
	    if (typeof insetOrOptions === 'number' || !insetOrOptions) {
	        return _getFocusStyleInternal(theme, { inset: insetOrOptions, position: position, highContrastStyle: highContrastStyle, borderColor: borderColor, outlineColor: outlineColor, isFocusedOnly: isFocusedOnly });
	    }
	    else {
	        return _getFocusStyleInternal(theme, insetOrOptions);
	    }
	}
	exports.getFocusStyle = getFocusStyle;
	function _getFocusStyleInternal(theme, options) {
	    if (options === void 0) { options = {}; }
	    var _a = options.inset, inset = _a === void 0 ? 0 : _a, _b = options.width, width = _b === void 0 ? 1 : _b, _c = options.position, position = _c === void 0 ? 'relative' : _c, highContrastStyle = options.highContrastStyle, _d = options.borderColor, borderColor = _d === void 0 ? theme.palette.white : _d, _e = options.outlineColor, outlineColor = _e === void 0 ? theme.palette.neutralSecondary : _e, _f = options.isFocusedOnly, isFocusedOnly = _f === void 0 ? true : _f;
	    return {
	        // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
	        outline: 'transparent',
	        // Requirement because pseudo-element is absolutely positioned.
	        position: position,
	        selectors: (_g = {
	                // Clear the focus border in Firefox.
	                // Reference: http://stackoverflow.com/a/199319/1436671
	                '::-moz-focus-inner': {
	                    border: '0'
	                }
	            },
	            // When the element that uses this mixin is in a :focus state, add a pseudo-element to
	            // create a border.
	            _g["." + utilities_1.IsFocusVisibleClassName + " &" + (isFocusedOnly ? ':focus' : '') + ":after"] = {
	                content: '""',
	                position: 'absolute',
	                left: inset + 1,
	                top: inset + 1,
	                bottom: inset + 1,
	                right: inset + 1,
	                border: width + "px solid " + borderColor,
	                outline: width + "px solid " + outlineColor,
	                zIndex: zIndexes_1.ZIndexes.FocusStyle,
	                selectors: (_h = {},
	                    _h[CommonStyles_1.HighContrastSelector] = highContrastStyle,
	                    _h)
	            },
	            _g)
	    };
	    var _g, _h;
	}
	/**
	 * Generates style to clear browser specific focus styles.
	 */
	function focusClear() {
	    return {
	        selectors: {
	            '&::-moz-focus-inner': {
	                // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
	                border: 0
	            },
	            '&': {
	                // Clear browser specific focus styles and use transparent as placeholder for focus style
	                outline: 'transparent'
	            }
	        }
	    };
	}
	exports.focusClear = focusClear;
	/**
	 * Generates a style which can be used to set a border on focus.
	 *
	 * @param theme - The theme object to use.
	 * @param inset - The number of pixels to inset the border (default 0)
	 * @param width - The border width in pixels (default 1)
	 * @param color - Color of the outline (default `theme.palette.neutralSecondary`)
	 * @returns The style object.
	 */
	function getFocusOutlineStyle(theme, inset, width, color) {
	    if (inset === void 0) { inset = 0; }
	    if (width === void 0) { width = 1; }
	    return {
	        selectors: (_a = {},
	            _a[":global(" + utilities_1.IsFocusVisibleClassName + ") &:focus"] = {
	                outline: width + " solid " + (color || theme.palette.neutralSecondary),
	                outlineOffset: -inset + "px"
	            },
	            _a)
	    };
	    var _a;
	}
	exports.getFocusOutlineStyle = getFocusOutlineStyle;
	//# sourceMappingURL=getFocusStyle.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HighContrastSelector = '@media screen and (-ms-high-contrast: active)';
	exports.HighContrastSelectorWhite = '@media screen and (-ms-high-contrast: black-on-white)';
	exports.HighContrastSelectorBlack = '@media screen and (-ms-high-contrast: white-on-black)';
	exports.ScreenWidthMinSmall = 320;
	exports.ScreenWidthMinMedium = 480;
	exports.ScreenWidthMinLarge = 640;
	exports.ScreenWidthMinXLarge = 1024;
	exports.ScreenWidthMinXXLarge = 1366;
	exports.ScreenWidthMinXXXLarge = 1920;
	exports.ScreenWidthMaxSmall = exports.ScreenWidthMinMedium - 1;
	exports.ScreenWidthMaxMedium = exports.ScreenWidthMinLarge - 1;
	exports.ScreenWidthMaxLarge = exports.ScreenWidthMinXLarge - 1;
	exports.ScreenWidthMaxXLarge = exports.ScreenWidthMinXXLarge - 1;
	exports.ScreenWidthMaxXXLarge = exports.ScreenWidthMinXXXLarge - 1;
	exports.ScreenWidthMinUhfMobile = 768;
	function getScreenSelector(min, max) {
	    return "@media only screen and (min-width: " + min + "px) and (max-width: " + max + "px)";
	}
	exports.getScreenSelector = getScreenSelector;
	//# sourceMappingURL=CommonStyles.js.map

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ZIndexes;
	(function (ZIndexes) {
	    ZIndexes.Nav = 1;
	    /**
	     * @deprecated ScrollablePane
	     */
	    ZIndexes.ScrollablePane = 1;
	    ZIndexes.FocusStyle = 1;
	    ZIndexes.Coachmark = 1000;
	    ZIndexes.Layer = 1000000;
	    ZIndexes.KeytipLayer = 1000001;
	})(ZIndexes = exports.ZIndexes || (exports.ZIndexes = {}));
	//# sourceMappingURL=zIndexes.js.map

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.hiddenContentStyle = {
	    position: 'absolute',
	    width: 1,
	    height: 1,
	    margin: -1,
	    padding: 0,
	    border: 0,
	    overflow: 'hidden'
	};
	//# sourceMappingURL=hiddenContentStyle.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var merge_styles_1 = __webpack_require__(473);
	var DEFAULT_DURATION = '14s';
	var DEFAULT_DELAY = '2s';
	var DEFAULT_ITERATION_COUNT = '1';
	function _continuousPulseStepOne(beaconColorOne, innerDimension) {
	    return {
	        borderColor: beaconColorOne,
	        borderWidth: '0px',
	        width: innerDimension,
	        height: innerDimension
	    };
	}
	function _continuousPulseStepTwo(borderWidth) {
	    return {
	        opacity: 1,
	        borderWidth: borderWidth
	    };
	}
	function _continuousPulseStepThree() {
	    return {
	        opacity: 1
	    };
	}
	function _continuousPulseStepFour(beaconColorTwo, outerDimension) {
	    return {
	        borderWidth: '0',
	        width: outerDimension,
	        height: outerDimension,
	        opacity: 0,
	        borderColor: beaconColorTwo
	    };
	}
	function _continuousPulseStepFive(beaconColorOne, innerDimension) {
	    return tslib_1.__assign({}, _continuousPulseStepOne(beaconColorOne, innerDimension), {
	        opacity: 0
	    });
	}
	function _continuousPulseAnimationDouble(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
	    return merge_styles_1.keyframes({
	        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '1.42%': _continuousPulseStepTwo(borderWidth),
	        '3.57%': _continuousPulseStepThree(),
	        '7.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '8%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '29.99%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '30%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '31.42%': _continuousPulseStepTwo(borderWidth),
	        '33.57%': _continuousPulseStepThree(),
	        '37.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '38%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '79.42%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '79.43': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '81.85': _continuousPulseStepTwo(borderWidth),
	        '83.42': _continuousPulseStepThree(),
	        '87%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '100%': {}
	    });
	}
	function _continuousPulseAnimationSingle(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
	    return merge_styles_1.keyframes({
	        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '14.2%': _continuousPulseStepTwo(borderWidth),
	        '35.7%': _continuousPulseStepThree(),
	        '71.4%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '100%': {}
	    });
	}
	function _createDefaultAnimation(animationName, delayLength) {
	    return {
	        animationName: animationName,
	        animationIterationCount: DEFAULT_ITERATION_COUNT,
	        animationDuration: DEFAULT_DURATION,
	        animationDelay: delayLength || DEFAULT_DELAY
	    };
	}
	exports.PulsingBeaconAnimationStyles = {
	    continuousPulseAnimationDouble: _continuousPulseAnimationDouble,
	    continuousPulseAnimationSingle: _continuousPulseAnimationSingle,
	    createDefaultAnimation: _createDefaultAnimation
	};
	//# sourceMappingURL=PulsingBeaconAnimationStyles.js.map

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var utilities_1 = __webpack_require__(489);
	/**
	 * Internal memoized function which simply takes in the class map and the
	 * disable boolean. These immutable values can be memoized.
	 */
	var _getGlobalClassNames = utilities_1.memoizeFunction(function (classNames, disableGlobalClassNames) {
	    var styleSheet = merge_styles_1.Stylesheet.getInstance();
	    if (disableGlobalClassNames) {
	        // disable global classnames
	        return Object.keys(classNames).reduce(function (acc, className) {
	            acc[className] = styleSheet.getClassName(classNames[className]);
	            return acc;
	        }, {});
	    }
	    // use global classnames
	    return classNames;
	});
	/**
	 * Checks for the `disableGlobalClassNames` property on the `theme` to determine if it should return `classNames`
	 * Note that calls to this function are memoized.
	 *
	 * @param classNames - The collection of global class names that apply when the flag is false. Make sure to pass in
	 * the same instance on each call to benefit from memoization.
	 * @param theme - The theme to check the flag on
	 * @param disableGlobalClassNames - Optional. Explicitly opt in/out of disabling global classnames. Defaults to false.
	 */
	function getGlobalClassNames(classNames, theme, disableGlobalClassNames) {
	    return _getGlobalClassNames(classNames, disableGlobalClassNames !== undefined ? disableGlobalClassNames : theme.disableGlobalClassNames);
	}
	exports.getGlobalClassNames = getGlobalClassNames;
	//# sourceMappingURL=getGlobalClassNames.js.map

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utilities_1 = __webpack_require__(489);
	/**
	 * @internal
	 * This function is still in experimental phase in support of Foundation experimental development. Its API signature and existence
	 * are subject to change.
	 *
	 * Modify context to activate the specified scheme or theme. For schemes, look in context (if available) and fall back to global
	 * Customizations. If both scheme and theme are specified, scheme will be looked up in theme. In this case, scheme must be
	 * present in theme arg, otherwise new context will default to theme arg (there is no fallback to settings to look up scheme.)
	 *
	 * @param context - Context in which to get schemed customizations.
	 * @param scheme - Scheme to get customizations for from theme arg (if supplied) OR from context and global settings.
	 * @param theme - Theme to merge into context.
	 * @returns modified schemed context if scheme is valid and not already applied, unmodified context otherwise.
	 */
	function getThemedContext(context, scheme, theme) {
	    var newContext = context;
	    var newSettings;
	    // Only fall back to context and customizations when theme arg is not provided.
	    var schemeSource = theme || utilities_1.Customizations.getSettings(['theme'], undefined, context.customizations).theme;
	    if (theme) {
	        newSettings = { theme: theme };
	    }
	    var schemeTheme = scheme && schemeSource && schemeSource.schemes && schemeSource.schemes[scheme];
	    // These first two checks are logically redundant but TS doesn't infer schemeSource.schemes is defined when schemeTheme is defined.
	    if (schemeSource && schemeTheme && schemeSource !== schemeTheme) {
	        newSettings = { theme: schemeTheme };
	        newSettings.theme.schemes = schemeSource.schemes;
	    }
	    if (newSettings) {
	        newContext = {
	            customizations: {
	                settings: utilities_1.mergeSettings(context.customizations.settings, newSettings),
	                scopedSettings: context.customizations.scopedSettings
	            }
	        };
	    }
	    return newContext;
	}
	exports.getThemedContext = getThemedContext;
	//# sourceMappingURL=scheme.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var utilities_1 = __webpack_require__(489);
	var DefaultFontStyles_1 = __webpack_require__(573);
	var DefaultPalette_1 = __webpack_require__(572);
	var DefaultSpacing_1 = __webpack_require__(583);
	var load_themed_styles_1 = __webpack_require__(584);
	var DefaultEffects_1 = __webpack_require__(585);
	var _theme = createTheme({
	    palette: DefaultPalette_1.DefaultPalette,
	    semanticColors: _makeSemanticColorsFromPalette(DefaultPalette_1.DefaultPalette, false, false),
	    fonts: DefaultFontStyles_1.DefaultFontStyles,
	    isInverted: false,
	    disableGlobalClassNames: false
	});
	var _onThemeChangeCallbacks = [];
	exports.ThemeSettingName = 'theme';
	if (!utilities_1.Customizations.getSettings([exports.ThemeSettingName]).theme) {
	    var win = utilities_1.getWindow();
	    // tslint:disable:no-string-literal no-any
	    if (win && win['FabricConfig'] && win['FabricConfig'].theme) {
	        _theme = createTheme(win['FabricConfig'].theme);
	    }
	    // tslint:enable:no-string-literal no-any
	    // Set the default theme.
	    utilities_1.Customizations.applySettings((_a = {}, _a[exports.ThemeSettingName] = _theme, _a));
	}
	/**
	 * Gets the theme object
	 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function getTheme(depComments) {
	    if (depComments === void 0) { depComments = false; }
	    if (depComments === true) {
	        _theme = createTheme({}, depComments);
	    }
	    return _theme;
	}
	exports.getTheme = getTheme;
	/**
	 * Registers a callback that gets called whenever the theme changes.
	 * This should only be used when the component cannot automatically get theme changes through its state.
	 * This will not register duplicate callbacks.
	 */
	function registerOnThemeChangeCallback(callback) {
	    if (_onThemeChangeCallbacks.indexOf(callback) === -1) {
	        _onThemeChangeCallbacks.push(callback);
	    }
	}
	exports.registerOnThemeChangeCallback = registerOnThemeChangeCallback;
	/**
	 * See registerOnThemeChangeCallback().
	 * Removes previously registered callbacks.
	 */
	function removeOnThemeChangeCallback(callback) {
	    var i = _onThemeChangeCallbacks.indexOf(callback);
	    if (i === -1) {
	        return;
	    }
	    _onThemeChangeCallbacks.splice(i, 1);
	}
	exports.removeOnThemeChangeCallback = removeOnThemeChangeCallback;
	/**
	 * Applies the theme, while filling in missing slots.
	 * @param theme - Partial theme object.
	 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function loadTheme(theme, depComments) {
	    if (depComments === void 0) { depComments = false; }
	    _theme = createTheme(theme, depComments);
	    // Invoke the legacy method of theming the page as well.
	    load_themed_styles_1.loadTheme(tslib_1.__assign({}, _theme.palette, _theme.semanticColors, _theme.effects, _loadFonts(_theme)));
	    utilities_1.Customizations.applySettings((_a = {}, _a[exports.ThemeSettingName] = _theme, _a));
	    _onThemeChangeCallbacks.forEach(function (callback) {
	        try {
	            callback(_theme);
	        }
	        catch (e) {
	            // don't let a bad callback break everything else
	        }
	    });
	    return _theme;
	    var _a;
	}
	exports.loadTheme = loadTheme;
	/**
	 * Loads font variables into a JSON object.
	 * @param theme - The theme object
	 */
	function _loadFonts(theme) {
	    var lines = {};
	    for (var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++) {
	        var fontName = _a[_i];
	        var font = theme.fonts[fontName];
	        for (var _b = 0, _c = Object.keys(font); _b < _c.length; _b++) {
	            var propName = _c[_b];
	            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
	            var value = font[propName];
	            if (propName === 'fontSize' && typeof value === 'number') {
	                value = value + 'px';
	            }
	            lines[name_1] = value;
	        }
	    }
	    return lines;
	}
	/**
	 * Creates a custom theme definition which can be used with the Customizer.
	 * @param theme - Partial theme object.
	 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function createTheme(theme, depComments) {
	    if (depComments === void 0) { depComments = false; }
	    var newPalette = tslib_1.__assign({}, DefaultPalette_1.DefaultPalette, theme.palette);
	    if (!theme.palette || !theme.palette.accent) {
	        newPalette.accent = newPalette.themePrimary;
	    }
	    // mix in custom overrides with good slots first, since custom overrides might be used in fixing deprecated slots
	    var newSemanticColors = tslib_1.__assign({}, _makeSemanticColorsFromPalette(newPalette, !!theme.isInverted, depComments), theme.semanticColors);
	    var defaultFontStyles = tslib_1.__assign({}, DefaultFontStyles_1.DefaultFontStyles);
	    if (theme.defaultFontStyle) {
	        for (var _i = 0, _a = Object.keys(defaultFontStyles); _i < _a.length; _i++) {
	            var fontStyle = _a[_i];
	            defaultFontStyles[fontStyle] = utilities_1.merge({}, defaultFontStyles[fontStyle], theme.defaultFontStyle);
	        }
	    }
	    if (theme.fonts) {
	        for (var _b = 0, _c = Object.keys(theme.fonts); _b < _c.length; _b++) {
	            var fontStyle = _c[_b];
	            defaultFontStyles[fontStyle] = utilities_1.merge({}, defaultFontStyles[fontStyle], theme.fonts[fontStyle]);
	        }
	    }
	    return {
	        palette: newPalette,
	        fonts: tslib_1.__assign({}, defaultFontStyles),
	        semanticColors: newSemanticColors,
	        isInverted: !!theme.isInverted,
	        disableGlobalClassNames: !!theme.disableGlobalClassNames,
	        spacing: tslib_1.__assign({}, DefaultSpacing_1.DefaultSpacing, theme.spacing),
	        effects: tslib_1.__assign({}, DefaultEffects_1.DefaultEffects, theme.effects)
	    };
	}
	exports.createTheme = createTheme;
	/**
	 * Helper to pull a given property name from a given set of sources, in order, if available. Otherwise returns the property name.
	 */
	function _expandFrom(propertyName) {
	    var maps = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        maps[_i - 1] = arguments[_i];
	    }
	    if (propertyName) {
	        for (var _a = 0, maps_1 = maps; _a < maps_1.length; _a++) {
	            var map = maps_1[_a];
	            if (map[propertyName]) {
	                return map[propertyName];
	            }
	        }
	    }
	    return propertyName;
	}
	// Generates all the semantic slot colors based on the Fabric palette.
	// We'll use these as fallbacks for semantic slots that the passed in theme did not define.
	function _makeSemanticColorsFromPalette(p, isInverted, depComments) {
	    var toReturn = {
	        bodyBackground: p.white,
	        bodyStandoutBackground: p.neutralLighterAlt,
	        bodyFrameBackground: p.white,
	        bodyFrameDivider: p.neutralLight,
	        bodyText: p.neutralPrimary,
	        bodyTextChecked: p.black,
	        bodySubtext: p.neutralSecondary,
	        bodyDivider: p.neutralLight,
	        disabledBackground: p.neutralLighter,
	        disabledText: p.neutralTertiary,
	        disabledBodyText: p.neutralTertiary,
	        disabledSubtext: p.neutralQuaternary,
	        disabledBodySubtext: p.neutralTertiaryAlt,
	        focusBorder: p.neutralSecondary,
	        variantBorder: p.neutralLight,
	        variantBorderHovered: p.neutralTertiary,
	        defaultStateBackground: p.neutralLighterAlt,
	        errorText: !isInverted ? p.redDark : '#ff5f5f',
	        warningText: !isInverted ? '#333333' : '#ffffff',
	        successText: !isInverted ? '#107C10' : '#92c353',
	        errorBackground: !isInverted ? 'rgba(232, 17, 35, .2)' : 'rgba(232, 17, 35, .5)',
	        blockingBackground: !isInverted ? 'rgba(234, 67, 0, .2)' : 'rgba(234, 67, 0, .5)',
	        warningBackground: !isInverted ? 'rgba(255, 185, 0, .2)' : 'rgba(255, 251, 0, .6)',
	        warningHighlight: !isInverted ? '#ffb900' : '#fff100',
	        successBackground: !isInverted ? 'rgba(186, 216, 10, .2)' : 'rgba(186, 216, 10, .4)',
	        inputBorder: p.neutralTertiary,
	        inputBorderHovered: p.neutralPrimary,
	        inputBackground: p.white,
	        inputBackgroundChecked: p.themePrimary,
	        inputBackgroundCheckedHovered: p.themeDarkAlt,
	        inputForegroundChecked: p.white,
	        inputFocusBorderAlt: p.themePrimary,
	        smallInputBorder: p.neutralSecondary,
	        inputText: p.neutralPrimary,
	        inputTextHovered: p.neutralDark,
	        inputPlaceholderText: p.neutralSecondary,
	        buttonBackground: p.neutralLighter,
	        buttonBackgroundChecked: p.neutralTertiaryAlt,
	        buttonBackgroundHovered: p.neutralLight,
	        buttonBackgroundCheckedHovered: p.neutralLight,
	        buttonBackgroundPressed: p.neutralLight,
	        buttonBackgroundDisabled: p.neutralLighter,
	        buttonBorder: 'transparent',
	        buttonText: p.neutralPrimary,
	        buttonTextHovered: p.neutralDark,
	        buttonTextChecked: p.neutralDark,
	        buttonTextCheckedHovered: p.black,
	        buttonTextPressed: p.neutralDark,
	        buttonTextDisabled: p.neutralTertiary,
	        buttonBorderDisabled: 'transparent',
	        primaryButtonBackground: p.themePrimary,
	        primaryButtonBackgroundHovered: p.themeDarkAlt,
	        primaryButtonBackgroundPressed: p.themeDark,
	        primaryButtonBackgroundDisabled: p.neutralLighter,
	        primaryButtonBorder: 'transparent',
	        primaryButtonText: p.white,
	        primaryButtonTextHovered: p.white,
	        primaryButtonTextPressed: p.white,
	        primaryButtonTextDisabled: p.neutralQuaternary,
	        accentButtonBackground: p.accent,
	        accentButtonText: p.white,
	        menuBackground: p.white,
	        menuDivider: p.neutralTertiaryAlt,
	        menuIcon: p.themePrimary,
	        menuHeader: p.themePrimary,
	        menuItemBackgroundHovered: p.neutralLighter,
	        menuItemBackgroundPressed: p.neutralLight,
	        menuItemText: p.neutralPrimary,
	        menuItemTextHovered: p.neutralDark,
	        listBackground: p.white,
	        listText: p.neutralPrimary,
	        listItemBackgroundHovered: p.neutralLighter,
	        listItemBackgroundChecked: p.neutralLight,
	        listItemBackgroundCheckedHovered: p.neutralQuaternaryAlt,
	        listHeaderBackgroundHovered: p.neutralLighter,
	        listHeaderBackgroundPressed: p.neutralLight,
	        actionLink: p.neutralPrimary,
	        actionLinkHovered: p.neutralDark,
	        link: p.themePrimary,
	        linkHovered: p.themeDarker,
	        // Deprecated slots, second pass by _fixDeprecatedSlots() later for self-referential slots
	        listTextColor: '',
	        menuItemBackgroundChecked: p.neutralLight
	    };
	    return _fixDeprecatedSlots(toReturn, depComments);
	}
	function _fixDeprecatedSlots(s, depComments) {
	    // Add @deprecated tag as comment if enabled
	    var dep = '';
	    if (depComments === true) {
	        dep = ' /* @deprecated */';
	    }
	    s.listTextColor = s.listText + dep;
	    s.menuItemBackgroundChecked += dep;
	    return s;
	}
	var _a;
	//# sourceMappingURL=theme.js.map

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultSpacing = {
	    s2: '4px',
	    s1: '8px',
	    m: '16px',
	    l1: '20px',
	    l2: '32px'
	};
	//# sourceMappingURL=DefaultSpacing.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
	// See LICENSE in the project root for license information.
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.splitStyles = exports.detokenize = exports.clearStyles = exports.loadTheme = exports.flush = exports.configureRunMode = exports.configureLoadStyles = exports.loadStyles = void 0;
	// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
	// load-themed-styles hosted on the page.
	var _root = typeof window === 'undefined' ? global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
	// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
	var _styleNonce = _root && _root.CSPSettings && _root.CSPSettings.nonce;
	var _themeState = initializeThemeState();
	/**
	 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
	 */
	var _themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
	var now = function () {
	    return typeof performance !== 'undefined' && !!performance.now ? performance.now() : Date.now();
	};
	function measure(func) {
	    var start = now();
	    func();
	    var end = now();
	    _themeState.perf.duration += end - start;
	}
	/**
	 * initialize global state object
	 */
	function initializeThemeState() {
	    var state = _root.__themeState__ || {
	        theme: undefined,
	        lastStyleElement: undefined,
	        registeredStyles: []
	    };
	    if (!state.runState) {
	        state = __assign(__assign({}, state), { perf: {
	                count: 0,
	                duration: 0
	            }, runState: {
	                flushTimer: 0,
	                mode: 0 /* sync */,
	                buffer: []
	            } });
	    }
	    if (!state.registeredThemableStyles) {
	        state = __assign(__assign({}, state), { registeredThemableStyles: [] });
	    }
	    _root.__themeState__ = state;
	    return state;
	}
	/**
	 * Loads a set of style text. If it is registered too early, we will register it when the window.load
	 * event is fired.
	 * @param {string | ThemableArray} styles Themable style text to register.
	 * @param {boolean} loadAsync When true, always load styles in async mode, irrespective of current sync mode.
	 */
	function loadStyles(styles, loadAsync) {
	    if (loadAsync === void 0) { loadAsync = false; }
	    measure(function () {
	        var styleParts = Array.isArray(styles) ? styles : splitStyles(styles);
	        var _a = _themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
	        if (loadAsync || mode === 1 /* async */) {
	            buffer.push(styleParts);
	            if (!flushTimer) {
	                _themeState.runState.flushTimer = asyncLoadStyles();
	            }
	        }
	        else {
	            applyThemableStyles(styleParts);
	        }
	    });
	}
	exports.loadStyles = loadStyles;
	/**
	 * Allows for customizable loadStyles logic. e.g. for server side rendering application
	 * @param {(processedStyles: string, rawStyles?: string | ThemableArray) => void}
	 * a loadStyles callback that gets called when styles are loaded or reloaded
	 */
	function configureLoadStyles(loadStylesFn) {
	    _themeState.loadStyles = loadStylesFn;
	}
	exports.configureLoadStyles = configureLoadStyles;
	/**
	 * Configure run mode of load-themable-styles
	 * @param mode load-themable-styles run mode, async or sync
	 */
	function configureRunMode(mode) {
	    _themeState.runState.mode = mode;
	}
	exports.configureRunMode = configureRunMode;
	/**
	 * external code can call flush to synchronously force processing of currently buffered styles
	 */
	function flush() {
	    measure(function () {
	        var styleArrays = _themeState.runState.buffer.slice();
	        _themeState.runState.buffer = [];
	        var mergedStyleArray = [].concat.apply([], styleArrays);
	        if (mergedStyleArray.length > 0) {
	            applyThemableStyles(mergedStyleArray);
	        }
	    });
	}
	exports.flush = flush;
	/**
	 * register async loadStyles
	 */
	function asyncLoadStyles() {
	    return setTimeout(function () {
	        _themeState.runState.flushTimer = 0;
	        flush();
	    }, 0);
	}
	/**
	 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
	 * is fired.
	 * @param {string} styleText Style to register.
	 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
	 */
	function applyThemableStyles(stylesArray, styleRecord) {
	    if (_themeState.loadStyles) {
	        _themeState.loadStyles(resolveThemableArray(stylesArray).styleString, stylesArray);
	    }
	    else {
	        registerStyles(stylesArray);
	    }
	}
	/**
	 * Registers a set theme tokens to find and replace. If styles were already registered, they will be
	 * replaced.
	 * @param {theme} theme JSON object of theme tokens to values.
	 */
	function loadTheme(theme) {
	    _themeState.theme = theme;
	    // reload styles.
	    reloadStyles();
	}
	exports.loadTheme = loadTheme;
	/**
	 * Clear already registered style elements and style records in theme_State object
	 * @param option - specify which group of registered styles should be cleared.
	 * Default to be both themable and non-themable styles will be cleared
	 */
	function clearStyles(option) {
	    if (option === void 0) { option = 3 /* all */; }
	    if (option === 3 /* all */ || option === 2 /* onlyNonThemable */) {
	        clearStylesInternal(_themeState.registeredStyles);
	        _themeState.registeredStyles = [];
	    }
	    if (option === 3 /* all */ || option === 1 /* onlyThemable */) {
	        clearStylesInternal(_themeState.registeredThemableStyles);
	        _themeState.registeredThemableStyles = [];
	    }
	}
	exports.clearStyles = clearStyles;
	function clearStylesInternal(records) {
	    records.forEach(function (styleRecord) {
	        var styleElement = styleRecord && styleRecord.styleElement;
	        if (styleElement && styleElement.parentElement) {
	            styleElement.parentElement.removeChild(styleElement);
	        }
	    });
	}
	/**
	 * Reloads styles.
	 */
	function reloadStyles() {
	    if (_themeState.theme) {
	        var themableStyles = [];
	        for (var _i = 0, _a = _themeState.registeredThemableStyles; _i < _a.length; _i++) {
	            var styleRecord = _a[_i];
	            themableStyles.push(styleRecord.themableStyle);
	        }
	        if (themableStyles.length > 0) {
	            clearStyles(1 /* onlyThemable */);
	            applyThemableStyles([].concat.apply([], themableStyles));
	        }
	    }
	}
	/**
	 * Find theme tokens and replaces them with provided theme values.
	 * @param {string} styles Tokenized styles to fix.
	 */
	function detokenize(styles) {
	    if (styles) {
	        styles = resolveThemableArray(splitStyles(styles)).styleString;
	    }
	    return styles;
	}
	exports.detokenize = detokenize;
	/**
	 * Resolves ThemingInstruction objects in an array and joins the result into a string.
	 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
	 */
	function resolveThemableArray(splitStyleArray) {
	    var theme = _themeState.theme;
	    var themable = false;
	    // Resolve the array of theming instructions to an array of strings.
	    // Then join the array to produce the final CSS string.
	    var resolvedArray = (splitStyleArray || []).map(function (currentValue) {
	        var themeSlot = currentValue.theme;
	        if (themeSlot) {
	            themable = true;
	            // A theming annotation. Resolve it.
	            var themedValue = theme ? theme[themeSlot] : undefined;
	            var defaultValue = currentValue.defaultValue || 'inherit';
	            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
	            // Allow the themedValue to be undefined to explicitly request the default value.
	            if (theme &&
	                !themedValue &&
	                console &&
	                !(themeSlot in theme) &&
	                "boolean" !== 'undefined' &&
	                (false)) {
	                console.warn("Theming value not provided for \"".concat(themeSlot, "\". Falling back to \"").concat(defaultValue, "\"."));
	            }
	            return themedValue || defaultValue;
	        }
	        else {
	            // A non-themable string. Preserve it.
	            return currentValue.rawString;
	        }
	    });
	    return {
	        styleString: resolvedArray.join(''),
	        themable: themable
	    };
	}
	/**
	 * Split tokenized CSS into an array of strings and theme specification objects
	 * @param {string} styles Tokenized styles to split.
	 */
	function splitStyles(styles) {
	    var result = [];
	    if (styles) {
	        var pos = 0; // Current position in styles.
	        var tokenMatch = void 0;
	        while ((tokenMatch = _themeTokenRegex.exec(styles))) {
	            var matchIndex = tokenMatch.index;
	            if (matchIndex > pos) {
	                result.push({
	                    rawString: styles.substring(pos, matchIndex)
	                });
	            }
	            result.push({
	                theme: tokenMatch[1],
	                defaultValue: tokenMatch[2] // May be undefined
	            });
	            // index of the first character after the current match
	            pos = _themeTokenRegex.lastIndex;
	        }
	        // Push the rest of the string after the last match.
	        result.push({
	            rawString: styles.substring(pos)
	        });
	    }
	    return result;
	}
	exports.splitStyles = splitStyles;
	/**
	 * Registers a set of style text. If it is registered too early, we will register it when the
	 * window.load event is fired.
	 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
	 * @param {IStyleRecord} styleRecord May specify a style Element to update.
	 */
	function registerStyles(styleArray) {
	    if (typeof document === 'undefined') {
	        return;
	    }
	    var head = document.getElementsByTagName('head')[0];
	    var styleElement = document.createElement('style');
	    var _a = resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
	    styleElement.setAttribute('data-load-themed-styles', 'true');
	    if (_styleNonce) {
	        styleElement.setAttribute('nonce', _styleNonce);
	    }
	    styleElement.appendChild(document.createTextNode(styleString));
	    _themeState.perf.count++;
	    head.appendChild(styleElement);
	    var ev = document.createEvent('HTMLEvents');
	    ev.initEvent('styleinsert', true /* bubbleEvent */, false /* cancelable */);
	    ev.args = {
	        newStyle: styleElement
	    };
	    document.dispatchEvent(ev);
	    var record = {
	        styleElement: styleElement,
	        themableStyle: styleArray
	    };
	    if (themable) {
	        _themeState.registeredThemableStyles.push(record);
	    }
	    else {
	        _themeState.registeredStyles.push(record);
	    }
	}
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultEffects = {
	    // commented values are the defaults for Fluent
	    elevation4: '0 0 5px 0 rgba(0,0,0,.4)',
	    elevation8: '0 0 5px 0 rgba(0,0,0,.4)',
	    elevation16: '0 0 5px 0 rgba(0,0,0,.4)',
	    elevation64: '0 0 5px 0 rgba(0,0,0,.4)',
	    roundedCorner2: '0px' // 2
	};
	//# sourceMappingURL=DefaultEffects.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	"use strict";
	// This file mimics styles and mixins from _General.Mixins.scss
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.normalize = {
	    boxShadow: 'none',
	    margin: 0,
	    padding: 0,
	    boxSizing: 'border-box'
	};
	exports.noWrap = {
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	};
	//# sourceMappingURL=GeneralStyles.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DEFAULT_HEIGHT = '50%';
	var DEFAULT_WIDTH = 20;
	/**
	 * - Generates a style used to fade out an overflowing content by defining a style for an :after pseudo element.
	 * - Apply it to the :after selector for all combination of states the parent of content might have (normal, hover, selected, focus).
	 * - Requires the target to have position set to relative and overflow set to hidden.
	 *
	 * @example
	 * ```tsx
	 * // Assuming the following DOM structure and the different background colors coming from the parent holding the content.
	 * <div className={classNames.parent}>
	 *   <span className={classNames.content}>Overflown Content</span>
	 * </div>
	 * ```
	 * ```ts
	 * // This is how the style set would look in Component.styles.ts
	 * const { bodyBackground } = theme.semanticColors;
	 * const { neutralLighter } = theme.palette;
	 *
	 * // The second argument of getFadedOverflowStyle function is a string representing a key of ISemanticColors or IPalette.
	 *
	 * const styles = {
	 *   parent: [
	 *     backgroundColor: bodyBackground,
	 *     selectors: {
	 *       '&:hover: {
	 *         backgroundColor: neutralLighter
	 *       },
	 *       '$content:after': {
	 *         ...getFadedOverflowStyle(theme, 'bodyBackground')
	 *       },
	 *       '&:hover $content:after': {
	 *         ...getFadedOverflowStyle(theme, 'neutralLighter')
	 *       }
	 *     }
	 *   ],
	 *   content: [
	 *     width: '100%',
	 *     display: 'inline-block',
	 *     position: 'relative',
	 *     overflow: 'hidden'
	 *   ]
	 * }
	 * ```
	 * @param theme - The theme object to use.
	 * @param color - The background color to fade out to. Accepts only keys of ISemanticColors or IPalette. Defaults to 'bodyBackground'.
	 * @param direction - The direction of the overflow. Defaults to horizontal.
	 * @param width - The width of the fading overflow. Vertical direction defaults it to 100% vs 20px when horizontal.
	 * @param height - The Height of the fading overflow. Vertical direction defaults it to 50% vs 100% when horizontal.
	 * @returns The style object.
	 */
	function getFadedOverflowStyle(theme, color, direction, width, height) {
	    if (color === void 0) { color = 'bodyBackground'; }
	    if (direction === void 0) { direction = 'horizontal'; }
	    if (width === void 0) { width = getDefaultValue('width', direction); }
	    if (height === void 0) { height = getDefaultValue('height', direction); }
	    // Get the color value string from the theme semanticColors or palette.
	    var colorValue = theme.semanticColors[color] || theme.palette[color];
	    // Get the red, green, blue values of the colorValue.
	    var rgbColor = color2rgb(colorValue);
	    // Apply opacity 0 to serve as a start color of the gradient.
	    var rgba = "rgba(" + rgbColor.r + ", " + rgbColor.g + ", " + rgbColor.b + ", 0)";
	    // Get the direction of the gradient.
	    var gradientDirection = direction === 'vertical' ? 'to bottom' : 'to right'; // mergeStyles take care of RTL direction.
	    return {
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        bottom: 0,
	        width: width,
	        height: height,
	        pointerEvents: 'none',
	        backgroundImage: "linear-gradient(" + gradientDirection + ", " + rgba + " 0%, " + colorValue + " 100%)"
	    };
	}
	exports.getFadedOverflowStyle = getFadedOverflowStyle;
	// TODO consider moving this to a separate module along with some more color functions from OUFR/utilities.
	/**
	 * Helper function to convert a string hex color to an RGB object.
	 *
	 * @param colorValue - Color to be converted from hex to rgba.
	 */
	function color2rgb(colorValue) {
	    if (colorValue[0] === '#') {
	        // If it's a hex code
	        return {
	            r: parseInt(colorValue.slice(1, 3), 16),
	            g: parseInt(colorValue.slice(3, 5), 16),
	            b: parseInt(colorValue.slice(5, 7), 16)
	        };
	    }
	    else if (colorValue.indexOf('rgba(') === 0) {
	        // If it's an rgba color string
	        colorValue = colorValue.match(/rgba\(([^)]+)\)/)[1];
	        var parts = colorValue.split(/ *, */).map(Number);
	        return {
	            r: parts[0],
	            g: parts[1],
	            b: parts[2]
	        };
	    }
	    // The only remaining possibility is transparent.
	    return {
	        r: 255,
	        g: 255,
	        b: 255
	    };
	}
	/**
	 * Helper function to get the default values for parameters of main function.
	 *
	 * @param style - Which style to get the default value for.
	 * @param direction - What direction to take into consideration.
	 */
	function getDefaultValue(style, direction) {
	    if (style === 'width') {
	        return direction === 'horizontal' ? DEFAULT_WIDTH : '100%';
	    }
	    else {
	        return direction === 'vertical' ? DEFAULT_HEIGHT : '100%';
	    }
	}
	//# sourceMappingURL=getFadedOverflowStyle.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Generates placeholder style for each of the browsers supported by office-ui-fabric-react.
	 * @param styles - The style to use.
	 * @returns The placeholder style object for each browser depending on the placeholder directive it uses.
	 */
	function getPlaceholderStyles(styles) {
	    return {
	        selectors: {
	            '::placeholder': styles,
	            ':-ms-input-placeholder': styles,
	            '::-ms-input-placeholder': styles // Edge
	        }
	    };
	}
	exports.getPlaceholderStyles = getPlaceholderStyles;
	//# sourceMappingURL=getPlaceholderStyles.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var buildClassMap_1 = __webpack_require__(471);
	var DefaultFontStyles_1 = __webpack_require__(573);
	/**
	 * {@docCategory FontClassNames}
	 */
	exports.FontClassNames = buildClassMap_1.buildClassMap(DefaultFontStyles_1.DefaultFontStyles);
	//# sourceMappingURL=FontClassNames.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_styles_1 = __webpack_require__(473);
	var DefaultPalette_1 = __webpack_require__(572);
	var index_1 = __webpack_require__(570);
	exports.ColorClassNames = {};
	for (var colorName in DefaultPalette_1.DefaultPalette) {
	    if (DefaultPalette_1.DefaultPalette.hasOwnProperty(colorName)) {
	        // Foreground color
	        _defineGetter(exports.ColorClassNames, colorName, '', false, 'color');
	        // Hover color
	        _defineGetter(exports.ColorClassNames, colorName, 'Hover', true, 'color');
	        // Background color
	        _defineGetter(exports.ColorClassNames, colorName, 'Background', false, 'background');
	        // Background hover
	        _defineGetter(exports.ColorClassNames, colorName, 'BackgroundHover', true, 'background');
	        // Border color
	        _defineGetter(exports.ColorClassNames, colorName, 'Border', false, 'borderColor');
	        // Border hover color
	        _defineGetter(exports.ColorClassNames, colorName, 'BorderHover', true, 'borderColor');
	    }
	}
	/**
	 * Defines a getter for the given class configuration.
	 */
	function _defineGetter(obj, colorName, suffix, isHover, cssProperty) {
	    Object.defineProperty(obj, colorName + suffix, {
	        get: function () {
	            // tslint:disable-next-line:no-any
	            var style = (_a = {}, _a[cssProperty] = index_1.getTheme().palette[colorName], _a);
	            return merge_styles_1.mergeStyles(isHover ? { selectors: { ':hover': style } } : style).toString();
	            var _a;
	        },
	        enumerable: true,
	        configurable: true
	    });
	}
	//# sourceMappingURL=ColorClassNames.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// @uifabric/styling@6.50.6
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('@uifabric/styling', '6.50.6');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	__webpack_require__(464);
	tslib_1.__exportStar(__webpack_require__(489), exports);
	//# sourceMappingURL=Utilities.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var DEFAULT_PERSONA_SIZE = '32px';
	var COMPACT_PERSONA_SIZE = '16px';
	var DEFAULT_ICON_SIZE = '16px';
	var COMPACT_ICON_SIZE = '13px';
	var ANIMATION_INNER_DIMENSION = '4px';
	var ANIMATION_OUTER_DIMENSION = '28px';
	var ANIMATION_BORDER_WIDTH = '4px';
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, animateBeaconSignal, beaconColorOne, beaconColorTwo, isCompact) {
	    if (theme === void 0) { theme = Styling_1.getTheme(); }
	    var continuousPulse = Styling_1.PulsingBeaconAnimationStyles.continuousPulseAnimationSingle(beaconColorOne ? beaconColorOne : theme.palette.themePrimary, beaconColorTwo ? beaconColorTwo : theme.palette.themeTertiary, ANIMATION_INNER_DIMENSION, ANIMATION_OUTER_DIMENSION, ANIMATION_BORDER_WIDTH);
	    var fadeIn = Styling_1.keyframes({
	        from: { opacity: 0 },
	        to: { opacity: 1 }
	    });
	    var slideIn = Styling_1.keyframes({
	        from: { transform: 'translateX(-10px)' },
	        to: { transform: 'translateX(0)' }
	    });
	    var continuousPulseAnimation = {
	        animationName: continuousPulse,
	        animationIterationCount: '1',
	        animationDuration: '.8s',
	        zIndex: 1
	    };
	    var slideInAnimation = {
	        animationName: slideIn,
	        animationIterationCount: '1',
	        animationDuration: '.5s'
	    };
	    var fadeInAnimation = {
	        animationName: fadeIn,
	        animationIterationCount: '1',
	        animationDuration: '.5s'
	    };
	    var ActivityItemStyles = {
	        root: [
	            theme.fonts.small,
	            {
	                display: 'flex',
	                justifyContent: 'flex-start',
	                alignItems: 'flex-start',
	                boxSizing: 'border-box',
	                color: theme.palette.neutralSecondary
	            },
	            isCompact && animateBeaconSignal && fadeInAnimation
	        ],
	        pulsingBeacon: [
	            {
	                position: 'absolute',
	                top: '50%',
	                left: '50%',
	                transform: 'translate(-50%, -50%)',
	                width: '0px',
	                height: '0px',
	                borderRadius: '225px',
	                borderStyle: 'solid',
	                opacity: 0
	            },
	            isCompact && animateBeaconSignal && continuousPulseAnimation
	        ],
	        isCompactRoot: {
	            alignItems: 'center'
	        },
	        personaContainer: {
	            display: 'flex',
	            flexWrap: 'wrap',
	            minWidth: DEFAULT_PERSONA_SIZE,
	            width: DEFAULT_PERSONA_SIZE,
	            height: DEFAULT_PERSONA_SIZE
	        },
	        isCompactPersonaContainer: {
	            display: 'inline-flex',
	            flexWrap: 'nowrap',
	            flexBasis: 'auto',
	            height: COMPACT_PERSONA_SIZE,
	            width: 'auto',
	            minWidth: '0',
	            paddingRight: '6px'
	        },
	        activityTypeIcon: {
	            height: DEFAULT_PERSONA_SIZE,
	            fontSize: DEFAULT_ICON_SIZE,
	            lineHeight: DEFAULT_ICON_SIZE,
	            marginTop: '3px'
	        },
	        isCompactIcon: {
	            height: COMPACT_PERSONA_SIZE,
	            minWidth: COMPACT_PERSONA_SIZE,
	            fontSize: COMPACT_ICON_SIZE,
	            lineHeight: COMPACT_ICON_SIZE,
	            color: theme.palette.themePrimary,
	            marginTop: '1px',
	            position: 'relative',
	            display: 'flex',
	            justifyContent: 'center',
	            alignItems: 'center',
	            selectors: {
	                '.ms-Persona-imageArea': {
	                    margin: '-2px 0 0 -2px',
	                    border: '2px solid' + theme.palette.white,
	                    borderRadius: '50%',
	                    selectors: (_a = {},
	                        _a[Styling_1.HighContrastSelector] = {
	                            border: 'none',
	                            margin: '0'
	                        },
	                        _a)
	                }
	            }
	        },
	        activityPersona: {
	            display: 'block'
	        },
	        doublePersona: {
	            selectors: {
	                ':first-child': {
	                    alignSelf: 'flex-end'
	                }
	            }
	        },
	        isCompactPersona: {
	            display: 'inline-block',
	            width: '8px',
	            minWidth: '8px',
	            overflow: 'visible'
	        },
	        activityContent: [
	            {
	                padding: '0 8px'
	            },
	            isCompact && animateBeaconSignal && slideInAnimation
	        ],
	        activityText: {
	            display: 'inline'
	        },
	        isCompactContent: {
	            flex: '1',
	            padding: '0 4px',
	            whiteSpace: 'nowrap',
	            textOverflow: 'ellipsis',
	            overflowX: 'hidden'
	        },
	        commentText: {
	            color: theme.palette.neutralPrimary
	        },
	        timeStamp: [
	            theme.fonts.tiny,
	            {
	                fontWeight: 400,
	                color: theme.palette.neutralSecondary
	            }
	        ],
	        isCompactTimeStamp: {
	            display: 'inline-block',
	            paddingLeft: '0.3em',
	            fontSize: '1em'
	        }
	    };
	    return Styling_1.concatStyleSets(ActivityItemStyles, customStyles);
	    var _a;
	});
	//# sourceMappingURL=ActivityItem.styles.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(595), exports);
	//# sourceMappingURL=Persona.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(596), exports);
	tslib_1.__exportStar(__webpack_require__(597), exports);
	tslib_1.__exportStar(__webpack_require__(655), exports);
	tslib_1.__exportStar(__webpack_require__(663), exports);
	tslib_1.__exportStar(__webpack_require__(656), exports);
	// Exporting in case someone would like to track the current color of a persona
	var PersonaInitialsColor_1 = __webpack_require__(660);
	exports.getPersonaInitialsColor = PersonaInitialsColor_1.getPersonaInitialsColor;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Persona_base_1 = __webpack_require__(597);
	var Persona_styles_1 = __webpack_require__(662);
	/**
	 * Personas are used for rendering an individual's avatar, presence and details.
	 * They are used within the PeoplePicker components.
	 */
	exports.Persona = Utilities_1.styled(Persona_base_1.PersonaBase, Persona_styles_1.getStyles, undefined, {
	    scope: 'Persona'
	});
	//# sourceMappingURL=Persona.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Tooltip_1 = __webpack_require__(598);
	var PersonaCoin_1 = __webpack_require__(638);
	var Persona_types_1 = __webpack_require__(655);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * Persona with no default styles.
	 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
	 */
	var PersonaBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PersonaBase, _super);
	    function PersonaBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._warnDeprecations({ primaryText: 'text' });
	        return _this;
	    }
	    PersonaBase.prototype.render = function () {
	        // wrapping default render behavior based on various this.props properties
	        var _onRenderPrimaryText = this._onRenderText(this._getText()), _onRenderSecondaryText = this._onRenderText(this.props.secondaryText), _onRenderTertiaryText = this._onRenderText(this.props.tertiaryText), _onRenderOptionalText = this._onRenderText(this.props.optionalText);
	        var _a = this.props, hidePersonaDetails = _a.hidePersonaDetails, _b = _a.onRenderOptionalText, onRenderOptionalText = _b === void 0 ? _onRenderOptionalText : _b, _c = _a.onRenderPrimaryText, onRenderPrimaryText = _c === void 0 ? _onRenderPrimaryText : _c, _d = _a.onRenderSecondaryText, onRenderSecondaryText = _d === void 0 ? _onRenderSecondaryText : _d, _e = _a.onRenderTertiaryText, onRenderTertiaryText = _e === void 0 ? _onRenderTertiaryText : _e;
	        var size = this.props.size;
	        // These properties are to be explicitly passed into PersonaCoin because they are the only props directly used
	        var _f = this.props, allowPhoneInitials = _f.allowPhoneInitials, className = _f.className, coinProps = _f.coinProps, showUnknownPersonaCoin = _f.showUnknownPersonaCoin, coinSize = _f.coinSize, styles = _f.styles, imageAlt = _f.imageAlt, imageInitials = _f.imageInitials, imageShouldFadeIn = _f.imageShouldFadeIn, imageShouldStartVisible = _f.imageShouldStartVisible, imageUrl = _f.imageUrl, initialsColor = _f.initialsColor, isOutOfOffice = _f.isOutOfOffice, onPhotoLoadingStateChange = _f.onPhotoLoadingStateChange, onRenderCoin = _f.onRenderCoin, onRenderInitials = _f.onRenderInitials, presence = _f.presence, presenceTitle = _f.presenceTitle, showInitialsUntilImageLoads = _f.showInitialsUntilImageLoads, showSecondaryText = _f.showSecondaryText, theme = _f.theme;
	        var personaCoinProps = tslib_1.__assign({ allowPhoneInitials: allowPhoneInitials,
	            showUnknownPersonaCoin: showUnknownPersonaCoin,
	            coinSize: coinSize,
	            imageAlt: imageAlt,
	            imageInitials: imageInitials,
	            imageShouldFadeIn: imageShouldFadeIn,
	            imageShouldStartVisible: imageShouldStartVisible,
	            imageUrl: imageUrl,
	            initialsColor: initialsColor,
	            onPhotoLoadingStateChange: onPhotoLoadingStateChange,
	            onRenderCoin: onRenderCoin,
	            onRenderInitials: onRenderInitials,
	            presence: presence,
	            presenceTitle: presenceTitle,
	            showInitialsUntilImageLoads: showInitialsUntilImageLoads,
	            size: size, text: this._getText(), isOutOfOffice: isOutOfOffice }, coinProps);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            showSecondaryText: showSecondaryText,
	            presence: presence,
	            size: size
	        });
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        var personaDetails = (React.createElement("div", { className: classNames.details },
	            this._renderElement(classNames.primaryText, onRenderPrimaryText, _onRenderPrimaryText),
	            this._renderElement(classNames.secondaryText, onRenderSecondaryText, _onRenderSecondaryText),
	            this._renderElement(classNames.tertiaryText, onRenderTertiaryText, _onRenderTertiaryText),
	            this._renderElement(classNames.optionalText, onRenderOptionalText, _onRenderOptionalText),
	            this.props.children));
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: classNames.root, style: coinSize ? { height: coinSize, minWidth: coinSize } : undefined }),
	            React.createElement(PersonaCoin_1.PersonaCoin, tslib_1.__assign({}, personaCoinProps)),
	            (!hidePersonaDetails || (size === Persona_types_1.PersonaSize.size10 || size === Persona_types_1.PersonaSize.tiny)) && personaDetails));
	    };
	    /**
	     * Renders various types of Text (primaryText, secondaryText, etc)
	     * based on the classNames passed
	     * @param classNames - element className
	     * @param renderFunction - render function
	     * @param defaultRenderFunction - default render function
	     */
	    PersonaBase.prototype._renderElement = function (classNames, renderFunction, defaultRenderFunction) {
	        return (React.createElement("div", { dir: "auto", className: classNames }, renderFunction && renderFunction(this.props, defaultRenderFunction)));
	    };
	    /**
	     * Deprecation helper for getting text.
	     */
	    PersonaBase.prototype._getText = function () {
	        return this.props.text || this.props.primaryText || '';
	    };
	    /**
	     * using closure to wrap the default render behavior
	     * to make it independent of the type of text passed
	     * @param text - text to render
	     */
	    PersonaBase.prototype._onRenderText = function (text) {
	        // return default render behaviour for valid text or undefined
	        return text
	            ? function () {
	                // default onRender behaviour
	                return (React.createElement(Tooltip_1.TooltipHost, { content: text, overflowMode: Tooltip_1.TooltipOverflowMode.Parent, directionalHint: Tooltip_1.DirectionalHint.topLeftEdge }, text));
	            }
	            : undefined;
	    };
	    PersonaBase.defaultProps = {
	        size: Persona_types_1.PersonaSize.size48,
	        presence: Persona_types_1.PersonaPresence.none,
	        imageAlt: ''
	    };
	    return PersonaBase;
	}(Utilities_1.BaseComponent));
	exports.PersonaBase = PersonaBase;
	//# sourceMappingURL=Persona.base.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(599), exports);
	//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(600), exports);
	tslib_1.__exportStar(__webpack_require__(601), exports);
	tslib_1.__exportStar(__webpack_require__(602), exports);
	tslib_1.__exportStar(__webpack_require__(634), exports);
	tslib_1.__exportStar(__webpack_require__(635), exports);
	tslib_1.__exportStar(__webpack_require__(636), exports);
	tslib_1.__exportStar(__webpack_require__(608), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Tooltip_base_1 = __webpack_require__(601);
	var Tooltip_styles_1 = __webpack_require__(633);
	exports.Tooltip = Utilities_1.styled(Tooltip_base_1.TooltipBase, Tooltip_styles_1.getStyles, undefined, {
	    scope: 'Tooltip'
	});
	//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Tooltip_types_1 = __webpack_require__(602);
	var Callout_1 = __webpack_require__(603);
	var DirectionalHint_1 = __webpack_require__(608);
	var getClassNames = Utilities_1.classNamesFunction();
	var TooltipBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TooltipBase, _super);
	    function TooltipBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onRenderContent = function (props) {
	            return React.createElement("p", { className: _this._classNames.subText }, props.content);
	        };
	        return _this;
	    }
	    TooltipBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, calloutProps = _a.calloutProps, delay = _a.delay, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, styles = _a.styles, id = _a.id, maxWidth = _a.maxWidth, _b = _a.onRenderContent, onRenderContent = _b === void 0 ? this._onRenderContent : _b, targetElement = _a.targetElement, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className || (calloutProps && calloutProps.className),
	            delay: delay,
	            beakWidth: calloutProps && calloutProps.beakWidth,
	            gapSpace: calloutProps && calloutProps.gapSpace,
	            maxWidth: maxWidth
	        });
	        return (React.createElement(Callout_1.Callout, tslib_1.__assign({ target: targetElement, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL }, calloutProps, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['id']), { className: this._classNames.root }),
	            React.createElement("div", { className: this._classNames.content, id: id, role: "tooltip", onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave }, onRenderContent(this.props, this._onRenderContent))));
	    };
	    // Specify default props values
	    TooltipBase.defaultProps = {
	        directionalHint: DirectionalHint_1.DirectionalHint.topCenter,
	        delay: Tooltip_types_1.TooltipDelay.medium,
	        maxWidth: '364px',
	        calloutProps: {
	            isBeakVisible: true,
	            beakWidth: 16,
	            gapSpace: 0,
	            setInitialFocus: true,
	            doNotLayer: false
	        }
	    };
	    return TooltipBase;
	}(React.Component));
	exports.TooltipBase = TooltipBase;
	//# sourceMappingURL=Tooltip.base.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Tooltip}
	 */
	var TooltipDelay;
	(function (TooltipDelay) {
	    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
	    TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
	    TooltipDelay[TooltipDelay["long"] = 2] = "long";
	})(TooltipDelay = exports.TooltipDelay || (exports.TooltipDelay = {}));
	//# sourceMappingURL=Tooltip.types.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(604), exports);
	//# sourceMappingURL=Callout.js.map

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(605), exports);
	tslib_1.__exportStar(__webpack_require__(629), exports);
	tslib_1.__exportStar(__webpack_require__(608), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var CalloutContent_1 = __webpack_require__(606);
	var Layer_1 = __webpack_require__(617);
	var Callout = /** @class */ (function (_super) {
	    tslib_1.__extends(Callout, _super);
	    function Callout() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Callout.prototype.render = function () {
	        var _a = this.props, layerProps = _a.layerProps, rest = tslib_1.__rest(_a, ["layerProps"]);
	        var content = React.createElement(CalloutContent_1.CalloutContent, tslib_1.__assign({}, rest));
	        return this.props.doNotLayer ? content : React.createElement(Layer_1.Layer, tslib_1.__assign({}, layerProps), content);
	    };
	    return Callout;
	}(React.Component));
	exports.Callout = Callout;
	//# sourceMappingURL=Callout.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var CalloutContent_base_1 = __webpack_require__(607);
	var CalloutContent_styles_1 = __webpack_require__(616);
	exports.CalloutContent = Utilities_1.styled(CalloutContent_base_1.CalloutContentBase, CalloutContent_styles_1.getStyles, undefined, { scope: 'CalloutContent' });
	//# sourceMappingURL=CalloutContent.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var DirectionalHint_1 = __webpack_require__(608);
	var Utilities_1 = __webpack_require__(592);
	var positioning_1 = __webpack_require__(609);
	var Popup_1 = __webpack_require__(613);
	var Utilities_2 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	var ANIMATIONS = (_a = {},
	    _a[positioning_1.RectangleEdge.top] = Styling_1.AnimationClassNames.slideUpIn10,
	    _a[positioning_1.RectangleEdge.bottom] = Styling_1.AnimationClassNames.slideDownIn10,
	    _a[positioning_1.RectangleEdge.left] = Styling_1.AnimationClassNames.slideLeftIn10,
	    _a[positioning_1.RectangleEdge.right] = Styling_1.AnimationClassNames.slideRightIn10,
	    _a);
	var getClassNames = Utilities_2.classNamesFunction({
	    disableCaching: true
	});
	var BORDER_WIDTH = 1;
	var BEAK_ORIGIN_POSITION = { top: 0, left: 0 };
	// Microsoft Edge will overwrite inline styles if there is an animation pertaining to that style.
	// To help ensure that edge will respect the offscreen style opacity
	// filter needs to be added as an additional way to set opacity.
	var OFF_SCREEN_STYLE = { opacity: 0, filter: 'opacity(0)' };
	// role and role description go hand-in-hand. Both would be included by spreading getNativeProps for a basic element
	// This constant array can be used to filter these out of native props spread on callout root and apply them together on
	// calloutMain (the Popup component within the callout)
	var ARIA_ROLE_ATTRIBUTES = ['role', 'aria-roledescription'];
	var CalloutContentBase = /** @class */ (function (_super) {
	    tslib_1.__extends(CalloutContentBase, _super);
	    function CalloutContentBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._hostElement = React.createRef();
	        _this._calloutElement = React.createRef();
	        _this._hasListeners = false;
	        _this._disposables = [];
	        _this.dismiss = function (ev) {
	            var onDismiss = _this.props.onDismiss;
	            if (onDismiss) {
	                onDismiss(ev);
	            }
	        };
	        _this._dismissOnScroll = function (ev) {
	            var preventDismissOnScroll = _this.props.preventDismissOnScroll;
	            if (_this.state.positions && !preventDismissOnScroll) {
	                _this._dismissOnClickOrScroll(ev);
	            }
	        };
	        _this._dismissOnResize = function (ev) {
	            var preventDismissOnResize = _this.props.preventDismissOnResize;
	            if (!preventDismissOnResize) {
	                _this.dismiss(ev);
	            }
	        };
	        _this._dismissOnLostFocus = function (ev) {
	            var preventDismissOnLostFocus = _this.props.preventDismissOnLostFocus;
	            if (!preventDismissOnLostFocus) {
	                _this._dismissOnClickOrScroll(ev);
	            }
	        };
	        _this._setInitialFocus = function () {
	            if (_this.props.setInitialFocus && !_this._didSetInitialFocus && _this.state.positions && _this._calloutElement.current) {
	                _this._didSetInitialFocus = true;
	                _this._async.requestAnimationFrame(function () { return Utilities_1.focusFirstChild(_this._calloutElement.current); }, _this._calloutElement.current);
	            }
	        };
	        _this._onComponentDidMount = function () {
	            _this._addListeners();
	            if (_this.props.onLayerMounted) {
	                _this.props.onLayerMounted();
	            }
	            _this._updateAsyncPosition();
	            _this._setHeightOffsetEveryFrame();
	        };
	        _this._async = new Utilities_1.Async(_this);
	        _this._didSetInitialFocus = false;
	        _this.state = {
	            positions: undefined,
	            slideDirectionalClassName: undefined,
	            // @TODO it looks like this is not even being used anymore.
	            calloutElementRect: undefined,
	            heightOffset: 0
	        };
	        _this._positionAttempts = 0;
	        return _this;
	    }
	    CalloutContentBase.prototype.componentDidUpdate = function () {
	        if (!this.props.hidden) {
	            this._setInitialFocus();
	            if (!this._hasListeners) {
	                this._addListeners();
	            }
	            this._updateAsyncPosition();
	        }
	        else {
	            if (this._hasListeners) {
	                this._removeListeners();
	            }
	        }
	    };
	    CalloutContentBase.prototype.shouldComponentUpdate = function (newProps, newState) {
	        if (this.props.hidden && newProps.hidden) {
	            // Do not update when hidden.
	            return false;
	        }
	        return !Utilities_1.shallowCompare(this.props, newProps) || !Utilities_1.shallowCompare(this.state, newState);
	    };
	    CalloutContentBase.prototype.componentWillMount = function () {
	        this._setTargetWindowAndElement(this._getTarget());
	    };
	    CalloutContentBase.prototype.componentWillUnmount = function () {
	        this._async.dispose();
	        this._disposables.forEach(function (dispose) { return dispose(); });
	    };
	    CalloutContentBase.prototype.componentWillUpdate = function (newProps) {
	        // If the target element changed, find the new one. If we are tracking target with class name, always find element because we
	        // do not know if fabric has rendered a new element and disposed the old element.
	        var newTarget = this._getTarget(newProps);
	        var oldTarget = this._getTarget();
	        if ((newTarget !== oldTarget || typeof newTarget === 'string' || newTarget instanceof String) && !this._blockResetHeight) {
	            this._maxHeight = undefined;
	            this._setTargetWindowAndElement(newTarget);
	        }
	        if (newProps.gapSpace !== this.props.gapSpace || this.props.beakWidth !== newProps.beakWidth) {
	            this._maxHeight = undefined;
	        }
	        if (newProps.finalHeight !== this.props.finalHeight) {
	            this._setHeightOffsetEveryFrame();
	        }
	        // Ensure positioning is recalculated when we are about to show a persisted menu.
	        if (!newProps.hidden && newProps.hidden !== this.props.hidden) {
	            this._maxHeight = undefined;
	            // Target might have been updated while hidden.
	            this._setTargetWindowAndElement(newTarget);
	            this.setState({
	                positions: undefined
	            });
	            this._didSetInitialFocus = false;
	            this._bounds = undefined;
	        }
	        this._blockResetHeight = false;
	    };
	    CalloutContentBase.prototype.componentDidMount = function () {
	        if (!this.props.hidden) {
	            this._onComponentDidMount();
	        }
	    };
	    CalloutContentBase.prototype.render = function () {
	        // If there is no target window then we are likely in server side rendering and we should not render anything.
	        if (!this._targetWindow) {
	            return null;
	        }
	        var target = this.props.target;
	        var _a = this.props, styles = _a.styles, style = _a.style, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className, isBeakVisible = _a.isBeakVisible, children = _a.children, beakWidth = _a.beakWidth, calloutWidth = _a.calloutWidth, calloutMaxWidth = _a.calloutMaxWidth, finalHeight = _a.finalHeight, _b = _a.hideOverflow, hideOverflow = _b === void 0 ? !!finalHeight : _b, backgroundColor = _a.backgroundColor, calloutMaxHeight = _a.calloutMaxHeight, onScroll = _a.onScroll, _c = _a.shouldRestoreFocus, shouldRestoreFocus = _c === void 0 ? true : _c;
	        target = this._getTarget();
	        var positions = this.state.positions;
	        var getContentMaxHeight = this._getMaxHeight() ? this._getMaxHeight() + this.state.heightOffset : undefined;
	        var contentMaxHeight = calloutMaxHeight && getContentMaxHeight && calloutMaxHeight < getContentMaxHeight ? calloutMaxHeight : getContentMaxHeight;
	        var overflowYHidden = hideOverflow;
	        var beakVisible = isBeakVisible && !!target;
	        this._classNames = getClassNames(styles, {
	            theme: this.props.theme,
	            className: className,
	            overflowYHidden: overflowYHidden,
	            calloutWidth: calloutWidth,
	            positions: positions,
	            beakWidth: beakWidth,
	            backgroundColor: backgroundColor,
	            calloutMaxWidth: calloutMaxWidth
	        });
	        var overflowStyle = tslib_1.__assign({}, style, { maxHeight: contentMaxHeight }, (overflowYHidden && { overflowY: 'hidden' }));
	        var visibilityStyle = this.props.hidden ? { visibility: 'hidden' } : undefined;
	        // React.CSSProperties does not understand IRawStyle, so the inline animations will need to be cast as any for now.
	        var content = (React.createElement("div", { ref: this._hostElement, className: this._classNames.container, style: visibilityStyle },
	            React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ARIA_ROLE_ATTRIBUTES), { className: Utilities_1.css(this._classNames.root, positions && positions.targetEdge && ANIMATIONS[positions.targetEdge]), style: positions ? positions.elementPosition : OFF_SCREEN_STYLE, tabIndex: -1, 
	                // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
	                ref: this._calloutElement }),
	                beakVisible && React.createElement("div", { className: this._classNames.beak, style: this._getBeakPosition() }),
	                beakVisible && React.createElement("div", { className: this._classNames.beakCurtain }),
	                React.createElement(Popup_1.Popup, tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, ARIA_ROLE_ATTRIBUTES), { ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, ariaLabelledBy: ariaLabelledBy, className: this._classNames.calloutMain, onDismiss: this.dismiss, onScroll: onScroll, shouldRestoreFocus: shouldRestoreFocus, style: overflowStyle }), children))));
	        return content;
	    };
	    CalloutContentBase.prototype._dismissOnClickOrScroll = function (ev) {
	        var target = ev.target;
	        var isEventTargetOutsideCallout = this._hostElement.current && !Utilities_1.elementContains(this._hostElement.current, target);
	        if ((!this._target && isEventTargetOutsideCallout) ||
	            (ev.target !== this._targetWindow &&
	                isEventTargetOutsideCallout &&
	                (this._target.stopPropagation ||
	                    (!this._target || (target !== this._target && !Utilities_1.elementContains(this._target, target)))))) {
	            this.dismiss(ev);
	        }
	    };
	    CalloutContentBase.prototype._addListeners = function () {
	        var _this = this;
	        // This is added so the callout will dismiss when the window is scrolled
	        // but not when something inside the callout is scrolled. The delay seems
	        // to be required to avoid React firing an async focus event in IE from
	        // the target changing focus quickly prior to rendering the callout.
	        this._async.setTimeout(function () {
	            _this._disposables.push(Utilities_1.on(_this._targetWindow, 'scroll', _this._dismissOnScroll, true), Utilities_1.on(_this._targetWindow, 'resize', _this._dismissOnResize, true), Utilities_1.on(_this._targetWindow.document.documentElement, 'focus', _this._dismissOnLostFocus, true), Utilities_1.on(_this._targetWindow.document.documentElement, 'click', _this._dismissOnLostFocus, true));
	            _this._hasListeners = true;
	        }, 0);
	    };
	    CalloutContentBase.prototype._removeListeners = function () {
	        this._disposables.forEach(function (dispose) { return dispose(); });
	        this._disposables = [];
	        this._hasListeners = false;
	    };
	    CalloutContentBase.prototype._updateAsyncPosition = function () {
	        var _this = this;
	        this._async.requestAnimationFrame(function () { return _this._updatePosition(); }, this._calloutElement.current);
	    };
	    CalloutContentBase.prototype._getBeakPosition = function () {
	        var positions = this.state.positions;
	        var beakPostionStyle = tslib_1.__assign({}, (positions && positions.beakPosition ? positions.beakPosition.elementPosition : null));
	        if (!beakPostionStyle.top && !beakPostionStyle.bottom && !beakPostionStyle.left && !beakPostionStyle.right) {
	            beakPostionStyle.left = BEAK_ORIGIN_POSITION.left;
	            beakPostionStyle.top = BEAK_ORIGIN_POSITION.top;
	        }
	        return beakPostionStyle;
	    };
	    CalloutContentBase.prototype._updatePosition = function () {
	        // Try to update the target, page might have changed
	        this._setTargetWindowAndElement(this._getTarget());
	        var positions = this.state.positions;
	        var hostElement = this._hostElement.current;
	        var calloutElement = this._calloutElement.current;
	        // If we expect a target element to position against, we need to wait until `this._target` is resolved. Otherwise
	        // we can try to position.
	        var expectsTarget = !!this.props.target;
	        if (hostElement && calloutElement && (!expectsTarget || this._target)) {
	            var currentProps = void 0;
	            currentProps = Utilities_1.assign(currentProps, this.props);
	            currentProps.bounds = this._getBounds();
	            currentProps.target = this._target;
	            // If there is a finalHeight given then we assume that the user knows and will handle
	            // additional positioning adjustments so we should call positionCard
	            var newPositions = this.props.finalHeight
	                ? positioning_1.positionCard(currentProps, hostElement, calloutElement, positions)
	                : positioning_1.positionCallout(currentProps, hostElement, calloutElement, positions);
	            // Set the new position only when the positions are not exists or one of the new callout positions are different.
	            // The position should not change if the position is within 2 decimal places.
	            if ((!positions && newPositions) ||
	                (positions && newPositions && !this._arePositionsEqual(positions, newPositions) && this._positionAttempts < 5)) {
	                // We should not reposition the callout more than a few times, if it is then the content is likely resizing
	                // and we should stop trying to reposition to prevent a stack overflow.
	                this._positionAttempts++;
	                this.setState({
	                    positions: newPositions
	                });
	            }
	            else if (this._positionAttempts > 0) {
	                // Only call the onPositioned callback if the callout has been re-positioned at least once.
	                this._positionAttempts = 0;
	                if (this.props.onPositioned) {
	                    this.props.onPositioned(this.state.positions);
	                }
	            }
	        }
	    };
	    CalloutContentBase.prototype._getBounds = function () {
	        if (!this._bounds) {
	            var currentBounds = this.props.bounds;
	            if (!currentBounds) {
	                currentBounds = {
	                    top: 0 + this.props.minPagePadding,
	                    left: 0 + this.props.minPagePadding,
	                    right: this._targetWindow.innerWidth - this.props.minPagePadding,
	                    bottom: this._targetWindow.innerHeight - this.props.minPagePadding,
	                    width: this._targetWindow.innerWidth - this.props.minPagePadding * 2,
	                    height: this._targetWindow.innerHeight - this.props.minPagePadding * 2
	                };
	            }
	            this._bounds = currentBounds;
	        }
	        return this._bounds;
	    };
	    // Max height should remain as synchronous as possible, which is why it is not done using set state.
	    // It needs to be synchronous since it will impact the ultimate position of the callout.
	    CalloutContentBase.prototype._getMaxHeight = function () {
	        var _this = this;
	        if (!this._maxHeight) {
	            if (this.props.directionalHintFixed && this._target) {
	                var beakWidth = this.props.isBeakVisible ? this.props.beakWidth : 0;
	                var gapSpace = this.props.gapSpace ? this.props.gapSpace : 0;
	                // Since the callout cannot measure it's border size it must be taken into account here. Otherwise it will
	                // overlap with the target.
	                var totalGap_1 = gapSpace + beakWidth + BORDER_WIDTH * 2;
	                this._async.requestAnimationFrame(function () {
	                    if (_this._target) {
	                        _this._maxHeight = positioning_1.getMaxHeight(_this._target, _this.props.directionalHint, totalGap_1, _this._getBounds(), _this.props.coverTarget);
	                        _this._blockResetHeight = true;
	                        _this.forceUpdate();
	                    }
	                }, this._target);
	            }
	            else {
	                this._maxHeight = this._getBounds().height - BORDER_WIDTH * 2;
	            }
	        }
	        return this._maxHeight;
	    };
	    CalloutContentBase.prototype._arePositionsEqual = function (positions, newPosition) {
	        return (this._comparePositions(positions.elementPosition, newPosition.elementPosition) &&
	            this._comparePositions(positions.beakPosition.elementPosition, newPosition.beakPosition.elementPosition));
	    };
	    CalloutContentBase.prototype._comparePositions = function (oldPositions, newPositions) {
	        for (var key in newPositions) {
	            // This needs to be checked here and below because there is a linting error if for in does not immediately have an if statement
	            if (newPositions.hasOwnProperty(key)) {
	                var oldPositionEdge = oldPositions[key];
	                var newPositionEdge = newPositions[key];
	                if (oldPositionEdge !== undefined && newPositionEdge !== undefined) {
	                    if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
	                        return false;
	                    }
	                }
	                else {
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    CalloutContentBase.prototype._setTargetWindowAndElement = function (target) {
	        var currentElement = this._calloutElement.current;
	        if (target) {
	            if (typeof target === 'string') {
	                var currentDoc = Utilities_1.getDocument(currentElement);
	                this._target = currentDoc ? currentDoc.querySelector(target) : null;
	                this._targetWindow = Utilities_1.getWindow(currentElement);
	            }
	            else if (target.stopPropagation) {
	                this._targetWindow = Utilities_1.getWindow(target.toElement);
	                this._target = target;
	            }
	            else if (target.getBoundingClientRect) {
	                var targetElement = target;
	                this._targetWindow = Utilities_1.getWindow(targetElement);
	                this._target = target;
	                // HTMLImgElements can have x and y values. The check for it being a point must go last.
	            }
	            else {
	                this._targetWindow = Utilities_1.getWindow(currentElement);
	                this._target = target;
	            }
	        }
	        else {
	            this._targetWindow = Utilities_1.getWindow(currentElement);
	        }
	    };
	    CalloutContentBase.prototype._setHeightOffsetEveryFrame = function () {
	        var _this = this;
	        if (this._calloutElement.current && this.props.finalHeight) {
	            this._setHeightOffsetTimer = this._async.requestAnimationFrame(function () {
	                var calloutMainElem = _this._calloutElement.current && _this._calloutElement.current.lastChild;
	                if (!calloutMainElem) {
	                    return;
	                }
	                var cardScrollHeight = calloutMainElem.scrollHeight;
	                var cardCurrHeight = calloutMainElem.offsetHeight;
	                var scrollDiff = cardScrollHeight - cardCurrHeight;
	                _this.setState({
	                    heightOffset: _this.state.heightOffset + scrollDiff
	                });
	                if (calloutMainElem.offsetHeight < _this.props.finalHeight) {
	                    _this._setHeightOffsetEveryFrame();
	                }
	                else {
	                    _this._async.cancelAnimationFrame(_this._setHeightOffsetTimer, _this._calloutElement.current);
	                }
	            }, this._calloutElement.current);
	        }
	    };
	    CalloutContentBase.prototype._getTarget = function (props) {
	        if (props === void 0) { props = this.props; }
	        var target = props.target;
	        return target;
	    };
	    CalloutContentBase.defaultProps = {
	        preventDismissOnLostFocus: false,
	        preventDismissOnScroll: false,
	        preventDismissOnResize: false,
	        isBeakVisible: true,
	        beakWidth: 16,
	        gapSpace: 0,
	        minPagePadding: 8,
	        directionalHint: DirectionalHint_1.DirectionalHint.bottomAutoEdge
	    };
	    return CalloutContentBase;
	}(React.Component));
	exports.CalloutContentBase = CalloutContentBase;
	var _a;
	//# sourceMappingURL=CalloutContent.base.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DirectionalHint = {
	    /**
	     * Appear above the target element, with the left edges of the callout and target aligning.
	     */
	    topLeftEdge: 0,
	    /**
	     * Appear above the target element, with the centers of the callout and target aligning.
	     */
	    topCenter: 1,
	    /**
	     * Appear above the target element, with the right edges of the callout and target aligning.
	     */
	    topRightEdge: 2,
	    /**
	     * Appear above the target element, aligning with the target element such that the callout tends toward the center of the screen.
	     */
	    topAutoEdge: 3,
	    /**
	     * Appear below the target element, with the left edges of the callout and target aligning.
	     */
	    bottomLeftEdge: 4,
	    /**
	     * Appear below the target element, with the centers of the callout and target aligning.
	     */
	    bottomCenter: 5,
	    /**
	     * Appear below the target element, with the right edges of the callout and target aligning.
	     */
	    bottomRightEdge: 6,
	    /**
	     * Appear below the target element, aligning with the target element such that the callout tends toward the center of the screen.
	     */
	    bottomAutoEdge: 7,
	    /**
	     * Appear to the left of the target element, with the top edges of the callout and target aligning.
	     */
	    leftTopEdge: 8,
	    /**
	     * Appear to the left of the target element, with the centers of the callout and target aligning.
	     */
	    leftCenter: 9,
	    /**
	     * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
	     */
	    leftBottomEdge: 10,
	    /**
	     * Appear to the right of the target element, with the top edges of the callout and target aligning.
	     */
	    rightTopEdge: 11,
	    /**
	     * Appear to the right of the target element, with the centers of the callout and target aligning.
	     */
	    rightCenter: 12,
	    /**
	     * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
	     */
	    rightBottomEdge: 13
	};
	//# sourceMappingURL=DirectionalHint.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(610), exports);
	//# sourceMappingURL=positioning.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(611), exports);
	tslib_1.__exportStar(__webpack_require__(612), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var DirectionalHint_1 = __webpack_require__(608);
	var Utilities_1 = __webpack_require__(592);
	var positioning_types_1 = __webpack_require__(612);
	var Rectangle = /** @class */ (function (_super) {
	    tslib_1.__extends(Rectangle, _super);
	    function Rectangle() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return Rectangle;
	}(Utilities_1.Rectangle));
	exports.Rectangle = Rectangle;
	function _createPositionData(targetEdge, alignmentEdge, isAuto) {
	    return {
	        targetEdge: targetEdge,
	        alignmentEdge: alignmentEdge,
	        isAuto: isAuto
	    };
	}
	// Currently the beakPercent is set to 50 for all positions meaning that it should tend to the center of the target
	var DirectionalDictionary = (_a = {},
	    _a[DirectionalHint_1.DirectionalHint.topLeftEdge] = _createPositionData(positioning_types_1.RectangleEdge.top, positioning_types_1.RectangleEdge.left),
	    _a[DirectionalHint_1.DirectionalHint.topCenter] = _createPositionData(positioning_types_1.RectangleEdge.top),
	    _a[DirectionalHint_1.DirectionalHint.topRightEdge] = _createPositionData(positioning_types_1.RectangleEdge.top, positioning_types_1.RectangleEdge.right),
	    _a[DirectionalHint_1.DirectionalHint.topAutoEdge] = _createPositionData(positioning_types_1.RectangleEdge.top, undefined, true),
	    _a[DirectionalHint_1.DirectionalHint.bottomLeftEdge] = _createPositionData(positioning_types_1.RectangleEdge.bottom, positioning_types_1.RectangleEdge.left),
	    _a[DirectionalHint_1.DirectionalHint.bottomCenter] = _createPositionData(positioning_types_1.RectangleEdge.bottom),
	    _a[DirectionalHint_1.DirectionalHint.bottomRightEdge] = _createPositionData(positioning_types_1.RectangleEdge.bottom, positioning_types_1.RectangleEdge.right),
	    _a[DirectionalHint_1.DirectionalHint.bottomAutoEdge] = _createPositionData(positioning_types_1.RectangleEdge.bottom, undefined, true),
	    _a[DirectionalHint_1.DirectionalHint.leftTopEdge] = _createPositionData(positioning_types_1.RectangleEdge.left, positioning_types_1.RectangleEdge.top),
	    _a[DirectionalHint_1.DirectionalHint.leftCenter] = _createPositionData(positioning_types_1.RectangleEdge.left),
	    _a[DirectionalHint_1.DirectionalHint.leftBottomEdge] = _createPositionData(positioning_types_1.RectangleEdge.left, positioning_types_1.RectangleEdge.bottom),
	    _a[DirectionalHint_1.DirectionalHint.rightTopEdge] = _createPositionData(positioning_types_1.RectangleEdge.right, positioning_types_1.RectangleEdge.top),
	    _a[DirectionalHint_1.DirectionalHint.rightCenter] = _createPositionData(positioning_types_1.RectangleEdge.right),
	    _a[DirectionalHint_1.DirectionalHint.rightBottomEdge] = _createPositionData(positioning_types_1.RectangleEdge.right, positioning_types_1.RectangleEdge.bottom),
	    _a);
	function _isRectangleWithinBounds(rect, boundingRect) {
	    if (rect.top < boundingRect.top) {
	        return false;
	    }
	    if (rect.bottom > boundingRect.bottom) {
	        return false;
	    }
	    if (rect.left < boundingRect.left) {
	        return false;
	    }
	    if (rect.right > boundingRect.right) {
	        return false;
	    }
	    return true;
	}
	/**
	 * Gets all of the edges of a rectangle that are outside of the given bounds.
	 * If there are no out of bounds edges it returns an empty array.
	 */
	function _getOutOfBoundsEdges(rect, boundingRect) {
	    var outOfBounds = new Array();
	    if (rect.top < boundingRect.top) {
	        outOfBounds.push(positioning_types_1.RectangleEdge.top);
	    }
	    if (rect.bottom > boundingRect.bottom) {
	        outOfBounds.push(positioning_types_1.RectangleEdge.bottom);
	    }
	    if (rect.left < boundingRect.left) {
	        outOfBounds.push(positioning_types_1.RectangleEdge.left);
	    }
	    if (rect.right > boundingRect.right) {
	        outOfBounds.push(positioning_types_1.RectangleEdge.right);
	    }
	    return outOfBounds;
	}
	function _getEdgeValue(rect, edge) {
	    return rect[positioning_types_1.RectangleEdge[edge]];
	}
	function _setEdgeValue(rect, edge, value) {
	    rect[positioning_types_1.RectangleEdge[edge]] = value;
	    return rect;
	}
	/**
	 * Returns the middle value of an edge. Only returns 1 value rather than xy coordinates as
	 * the itself already contains the other coordinate.
	 * For instance, a bottom edge's current value is it's y coordinate, so the number returned is the x.
	 *
	 * @param {Rectangle} rect
	 * @param {RectangleEdge} edge
	 * @returns {number}
	 */
	function _getCenterValue(rect, edge) {
	    var edges = _getFlankingEdges(edge);
	    return (_getEdgeValue(rect, edges.positiveEdge) + _getEdgeValue(rect, edges.negativeEdge)) / 2;
	}
	/**
	 * Flips the value depending on the edge.
	 * If the edge is a "positive" edge, Top or Left, then the value should stay as it is.
	 * If the edge is a "negative" edge, Bottom or Right, then the value should be flipped.
	 * This is to account for the fact that the coordinates are effectively reveserved in certain cases for the "negative" edges.
	 * For example, when testing to see if a bottom edge 1 is within the bounds of another bottom edge 2.
	 * If edge 1 is greater than edge 2 then it is out of bounds. This is reversed for top edge 1 and top edge 2.
	 * If top edge 1 is less than edge 2 then it is out of bounds.
	 *
	 *
	 * @param {RectangleEdge} edge
	 * @param {number} value
	 * @returns {number}
	 */
	function _getRelativeEdgeValue(edge, value) {
	    if (edge > 0) {
	        return value;
	    }
	    else {
	        return value * -1;
	    }
	}
	function _getRelativeRectEdgeValue(edge, rect) {
	    return _getRelativeEdgeValue(edge, _getEdgeValue(rect, edge));
	}
	function _getRelativeEdgeDifference(rect, hostRect, edge) {
	    var edgeDifference = _getEdgeValue(rect, edge) - _getEdgeValue(hostRect, edge);
	    return _getRelativeEdgeValue(edge, edgeDifference);
	}
	/**
	 * Moves the edge of a rectangle to the value given. It only moves the edge in a linear direction based on that edge.
	 * For example, if it's a bottom edge it will only change y coordinates.
	 *
	 * @param {Rectangle} rect
	 * @param {RectangleEdge} edge
	 * @param {number} newValue
	 * @returns {Rectangle}
	 */
	function _moveEdge(rect, edge, newValue) {
	    var difference = _getEdgeValue(rect, edge) - newValue;
	    rect = _setEdgeValue(rect, edge, newValue);
	    rect = _setEdgeValue(rect, edge * -1, _getEdgeValue(rect, edge * -1) - difference);
	    return rect;
	}
	/**
	 * Aligns the edge on the passed in rect to the target. If there is a gap then it will have that space between the two.
	 *
	 * @param {Rectangle} rect
	 * @param {Rectangle} target
	 * @param {RectangleEdge} edge
	 * @param {number} [gap=0]
	 * @returns {Rectangle}
	 */
	function _alignEdges(rect, target, edge, gap) {
	    if (gap === void 0) { gap = 0; }
	    return _moveEdge(rect, edge, _getEdgeValue(target, edge) + _getRelativeEdgeValue(edge, gap));
	}
	/**
	 * Aligns the targetEdge on the passed in target to the rects corresponding opposite edge.
	 * For instance if targetEdge is bottom, then the rects top will be moved to match it.
	 *
	 * @param {Rectangle} rect
	 * @param {Rectangle} target
	 * @param {RectangleEdge} targetEdge
	 * @param {number} [gap=0]
	 * @returns {Rectangle}
	 */
	function _alignOppositeEdges(rect, target, targetEdge, gap) {
	    if (gap === void 0) { gap = 0; }
	    var oppositeEdge = targetEdge * -1;
	    var adjustedGap = _getRelativeEdgeValue(oppositeEdge, gap);
	    return _moveEdge(rect, targetEdge * -1, _getEdgeValue(target, targetEdge) + adjustedGap);
	}
	/**
	 * Tests to see if the given edge is within the bounds of the given rectangle.
	 *
	 * @param {Rectangle} rect
	 * @param {Rectangle} bounds
	 * @param {RectangleEdge} edge
	 * @returns {boolean}
	 */
	function _isEdgeInBounds(rect, bounds, edge) {
	    var adjustedRectValue = _getRelativeRectEdgeValue(edge, rect);
	    return adjustedRectValue > _getRelativeRectEdgeValue(edge, bounds);
	}
	/**
	 * Attempts to move the rectangle through various sides of the target to find a place to fit.
	 * If no fit is found, the original position should be returned.
	 *
	 * @param {Rectangle} rect
	 * @param {Rectangle} target
	 * @param {Rectangle} bounding
	 * @param {IPositionDirectionalHintData} positionData
	 * @param {number} [gap=0]
	 * @returns {IElementPosition}
	 */
	function _flipToFit(rect, target, bounding, positionData, gap) {
	    if (gap === void 0) { gap = 0; }
	    var directions = [positioning_types_1.RectangleEdge.left, positioning_types_1.RectangleEdge.right, positioning_types_1.RectangleEdge.bottom, positioning_types_1.RectangleEdge.top];
	    var currentEstimate = rect;
	    var currentEdge = positionData.targetEdge;
	    var currentAlignment = positionData.alignmentEdge;
	    // Keep switching sides until one is found with enough space. If all sides don't fit then return the unmodified element.
	    for (var i = 0; i < 4; i++) {
	        if (!_isEdgeInBounds(currentEstimate, bounding, currentEdge)) {
	            directions.splice(directions.indexOf(currentEdge), 1);
	            if (directions.indexOf(currentEdge * -1) > -1) {
	                currentEdge = currentEdge * -1;
	            }
	            else {
	                currentAlignment = currentEdge;
	                currentEdge = directions.slice(-1)[0];
	            }
	            currentEstimate = _estimatePosition(rect, target, { targetEdge: currentEdge, alignmentEdge: currentAlignment }, gap);
	        }
	        else {
	            return {
	                elementRectangle: currentEstimate,
	                targetEdge: currentEdge,
	                alignmentEdge: currentAlignment
	            };
	        }
	    }
	    return {
	        elementRectangle: rect,
	        targetEdge: positionData.targetEdge,
	        alignmentEdge: currentAlignment
	    };
	}
	/**
	 * Flips only the alignment edge of an element rectangle. This is used instead of nudging the alignment edges into position,
	 * when alignTargetEdge is specified.
	 * @param elementEstimate
	 * @param target
	 * @param bounding
	 * @param gap
	 */
	function _flipAlignmentEdge(elementEstimate, target, gap, coverTarget) {
	    var alignmentEdge = elementEstimate.alignmentEdge, targetEdge = elementEstimate.targetEdge, elementRectangle = elementEstimate.elementRectangle;
	    var oppositeEdge = alignmentEdge * -1;
	    var newEstimate = _estimatePosition(elementRectangle, target, { targetEdge: targetEdge, alignmentEdge: oppositeEdge }, gap, coverTarget);
	    return {
	        elementRectangle: newEstimate,
	        targetEdge: targetEdge,
	        alignmentEdge: oppositeEdge
	    };
	}
	/**
	 * Adjusts a element rectangle to fit within the bounds given. If directionalHintFixed or covertarget is passed in
	 * then the element will not flip sides on the target. They will, however, be nudged to fit within the bounds given.
	 *
	 * @param {Rectangle} element
	 * @param {Rectangle} target
	 * @param {Rectangle} bounding
	 * @param {IPositionDirectionalHintData} positionData
	 * @param {number} [gap=0]
	 * @param {boolean} [directionalHintFixed]
	 * @param {boolean} [coverTarget]
	 * @returns {IElementPosition}
	 */
	function _adjustFitWithinBounds(element, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
	    if (gap === void 0) { gap = 0; }
	    var alignmentEdge = positionData.alignmentEdge, alignTargetEdge = positionData.alignTargetEdge;
	    var elementEstimate = {
	        elementRectangle: element,
	        targetEdge: positionData.targetEdge,
	        alignmentEdge: alignmentEdge
	    };
	    if (!directionalHintFixed && !coverTarget) {
	        elementEstimate = _flipToFit(element, target, bounding, positionData, gap);
	    }
	    var outOfBounds = _getOutOfBoundsEdges(element, bounding);
	    if (alignTargetEdge) {
	        // The edge opposite to the alignment edge might be out of bounds. Flip alignment to see if we can get it within bounds.
	        if (elementEstimate.alignmentEdge && outOfBounds.indexOf(elementEstimate.alignmentEdge * -1) > -1) {
	            var flippedElementEstimate = _flipAlignmentEdge(elementEstimate, target, gap, coverTarget);
	            if (_isRectangleWithinBounds(flippedElementEstimate.elementRectangle, bounding)) {
	                return flippedElementEstimate;
	            }
	        }
	    }
	    else {
	        for (var _i = 0, outOfBounds_1 = outOfBounds; _i < outOfBounds_1.length; _i++) {
	            var direction = outOfBounds_1[_i];
	            elementEstimate.elementRectangle = _alignEdges(elementEstimate.elementRectangle, bounding, direction);
	        }
	    }
	    return elementEstimate;
	}
	/**
	 * Moves the middle point on an edge to the point given.
	 * Only moves in one direction. For instance if a bottom edge is passed in, then
	 * the bottom edge will be moved in the x axis to match the point.
	 *
	 * @param {Rectangle} rect
	 * @param {RectangleEdge} edge
	 * @param {number} point
	 * @returns {Rectangle}
	 */
	function _centerEdgeToPoint(rect, edge, point) {
	    var positiveEdge = _getFlankingEdges(edge).positiveEdge;
	    var elementMiddle = _getCenterValue(rect, edge);
	    var distanceToMiddle = elementMiddle - _getEdgeValue(rect, positiveEdge);
	    return _moveEdge(rect, positiveEdge, point - distanceToMiddle);
	}
	/**
	 * Moves the element rectangle to be appropriately positioned relative to a given target.
	 * Does not flip or adjust the element.
	 *
	 * @param {Rectangle} elementToPosition
	 * @param {Rectangle} target
	 * @param {IPositionDirectionalHintData} positionData
	 * @param {number} [gap=0]
	 * @param {boolean} [coverTarget]
	 * @returns {Rectangle}
	 */
	function _estimatePosition(elementToPosition, target, positionData, gap, coverTarget) {
	    if (gap === void 0) { gap = 0; }
	    var estimatedElementPosition;
	    var alignmentEdge = positionData.alignmentEdge, targetEdge = positionData.targetEdge;
	    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
	    estimatedElementPosition = coverTarget
	        ? _alignEdges(elementToPosition, target, targetEdge, gap)
	        : _alignOppositeEdges(elementToPosition, target, targetEdge, gap);
	    // if no alignment edge is provided it's supposed to be centered.
	    if (!alignmentEdge) {
	        var targetMiddlePoint = _getCenterValue(target, targetEdge);
	        estimatedElementPosition = _centerEdgeToPoint(estimatedElementPosition, elementEdge, targetMiddlePoint);
	    }
	    else {
	        estimatedElementPosition = _alignEdges(estimatedElementPosition, target, alignmentEdge);
	    }
	    return estimatedElementPosition;
	}
	/**
	 * Returns the non-opposite edges of the target edge.
	 * For instance if bottom is passed in then left and right will be returned.
	 *
	 * @param {RectangleEdge} edge
	 * @returns {{ firstEdge: RectangleEdge, secondEdge: RectangleEdge }}
	 */
	function _getFlankingEdges(edge) {
	    if (edge === positioning_types_1.RectangleEdge.top || edge === positioning_types_1.RectangleEdge.bottom) {
	        return {
	            positiveEdge: positioning_types_1.RectangleEdge.left,
	            negativeEdge: positioning_types_1.RectangleEdge.right
	        };
	    }
	    else {
	        return {
	            positiveEdge: positioning_types_1.RectangleEdge.top,
	            negativeEdge: positioning_types_1.RectangleEdge.bottom
	        };
	    }
	}
	/**
	 * Retrieve the final value for the return edge of elementRectangle.
	 * If the elementRectangle is closer to one side of the bounds versus the other, the return edge is flipped to grow inward.
	 *
	 * @param elementRectangle
	 * @param targetEdge
	 * @param bounds
	 */
	function _finalizeReturnEdge(elementRectangle, returnEdge, bounds) {
	    if (bounds &&
	        Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge)) >
	            Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge * -1))) {
	        return returnEdge * -1;
	    }
	    return returnEdge;
	}
	/**
	 * Finalizes the element positon based on the hostElement. Only returns the
	 * rectangle values to position such that they are anchored to the target.
	 * This helps prevent resizing from looking very strange.
	 * For instance, if the target edge is top and aligned with the left side then
	 * the bottom and left values are returned so as the callou shrinks it shrinks towards that corner.
	 *
	 * @param {Rectangle} elementRectangle
	 * @param {HTMLElement} hostElement
	 * @param {RectangleEdge} targetEdge
	 * @param {RectangleEdge} bounds
	 * @param {RectangleEdge} [alignmentEdge]
	 * @param {boolean} coverTarget
	 * @param {boolean} doNotFinalizeReturnEdge
	 * @returns {IPartialIRectangle}
	 */
	function _finalizeElementPosition(elementRectangle, hostElement, targetEdge, bounds, alignmentEdge, coverTarget, doNotFinalizeReturnEdge) {
	    var returnValue = {};
	    var hostRect = _getRectangleFromElement(hostElement);
	    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
	    var elementEdgeString = positioning_types_1.RectangleEdge[elementEdge];
	    var returnEdge = alignmentEdge ? alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge;
	    if (!doNotFinalizeReturnEdge) {
	        returnEdge = _finalizeReturnEdge(elementRectangle, returnEdge, bounds);
	    }
	    returnValue[elementEdgeString] = _getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge);
	    returnValue[positioning_types_1.RectangleEdge[returnEdge]] = _getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge);
	    return returnValue;
	}
	// Since the beak is rotated 45 degrees the actual height/width is the length of the diagonal.
	// We still want to position the beak based on it's midpoint which does not change. It will
	// be at (beakwidth / 2, beakwidth / 2)
	function _calculateActualBeakWidthInPixels(beakWidth) {
	    return Math.sqrt(beakWidth * beakWidth * 2);
	}
	/**
	 * Returns the appropriate IPositionData based on the props altered for RTL.
	 * If directionalHintForRTL is passed in that is used if the page is RTL.
	 * If a directionalHint is specified and no directionalHintForRTL is available and the page is RTL the hint will be flipped.
	 * For instance bottomLeftEdge would become bottomRightEdge.
	 * If there is no directionalHint passed in bottomAutoEdge is chosen automatically.
	 *
	 * @param {IPositionProps} props
	 * @returns {IPositionDirectionalHintData}
	 */
	function _getPositionData(directionalHint, directionalHintForRTL, previousPositions) {
	    if (directionalHint === void 0) { directionalHint = DirectionalHint_1.DirectionalHint.bottomAutoEdge; }
	    if (previousPositions) {
	        return {
	            alignmentEdge: previousPositions.alignmentEdge,
	            isAuto: previousPositions.isAuto,
	            targetEdge: previousPositions.targetEdge
	        };
	    }
	    var positionInformation = tslib_1.__assign({}, DirectionalDictionary[directionalHint]);
	    if (Utilities_1.getRTL()) {
	        // If alignment edge exists and that alignment edge is -2 or 2, right or left, then flip it.
	        if (positionInformation.alignmentEdge && positionInformation.alignmentEdge % 2 === 0) {
	            positionInformation.alignmentEdge = positionInformation.alignmentEdge * -1;
	        }
	        return directionalHintForRTL !== undefined ? DirectionalDictionary[directionalHintForRTL] : positionInformation;
	    }
	    return positionInformation;
	}
	/**
	 * Get's the alignment data for the given information. This only really matters if the positioning is Auto.
	 * If it is auto then the alignmentEdge should be chosen based on the target edge's position relative to
	 * the center of the page.
	 *
	 * @param {IPositionDirectionalHintData} positionData
	 * @param {Rectangle} target
	 * @param {Rectangle} boundingRect
	 * @param {boolean} [coverTarget]
	 * @returns {IPositionDirectionalHintData}
	 */
	function _getAlignmentData(positionData, target, boundingRect, coverTarget, alignTargetEdge) {
	    if (positionData.isAuto) {
	        positionData.alignmentEdge = getClosestEdge(positionData.targetEdge, target, boundingRect);
	    }
	    positionData.alignTargetEdge = alignTargetEdge;
	    return positionData;
	}
	function getClosestEdge(targetEdge, target, boundingRect) {
	    var targetCenter = _getCenterValue(target, targetEdge);
	    var boundingCenter = _getCenterValue(boundingRect, targetEdge);
	    var _a = _getFlankingEdges(targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
	    if (targetCenter <= boundingCenter) {
	        return positiveEdge;
	    }
	    else {
	        return negativeEdge;
	    }
	}
	function _positionElementWithinBounds(elementToPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
	    var estimatedElementPosition = _estimatePosition(elementToPosition, target, positionData, gap, coverTarget);
	    if (_isRectangleWithinBounds(estimatedElementPosition, bounding)) {
	        return {
	            elementRectangle: estimatedElementPosition,
	            targetEdge: positionData.targetEdge,
	            alignmentEdge: positionData.alignmentEdge
	        };
	    }
	    else {
	        return _adjustFitWithinBounds(elementToPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget);
	    }
	}
	function _finalizeBeakPosition(elementPosition, positionedBeak, bounds) {
	    var targetEdge = elementPosition.targetEdge * -1;
	    // The "host" element that we will use to help position the beak.
	    var actualElement = new Rectangle(0, elementPosition.elementRectangle.width, 0, elementPosition.elementRectangle.height);
	    var returnValue = {};
	    var returnEdge = _finalizeReturnEdge(elementPosition.elementRectangle, elementPosition.alignmentEdge ? elementPosition.alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge, bounds);
	    returnValue[positioning_types_1.RectangleEdge[targetEdge]] = _getEdgeValue(positionedBeak, targetEdge);
	    returnValue[positioning_types_1.RectangleEdge[returnEdge]] = _getRelativeEdgeDifference(positionedBeak, actualElement, returnEdge);
	    return {
	        elementPosition: tslib_1.__assign({}, returnValue),
	        closestEdge: getClosestEdge(elementPosition.targetEdge, positionedBeak, actualElement),
	        targetEdge: targetEdge
	    };
	}
	function _positionBeak(beakWidth, elementPosition) {
	    var target = elementPosition.targetRectangle;
	    /**
	     * Note about beak positioning: The actual beak width only matters for getting the gap between the callout and
	     * target, it does not impact the beak placement within the callout. For example example, if the beakWidth is 8,
	     * then the actual beakWidth is sqrroot(8^2 + 8^2) = 11.31x11.31. So the callout will need to be an extra 3 pixels
	     * away from its target. While the beak is being positioned in the callout it still acts as though it were 8x8.
	     * */
	    var _a = _getFlankingEdges(elementPosition.targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
	    var beakTargetPoint = _getCenterValue(target, elementPosition.targetEdge);
	    var elementBounds = new Rectangle(beakWidth / 2, elementPosition.elementRectangle.width - beakWidth / 2, beakWidth / 2, elementPosition.elementRectangle.height - beakWidth / 2);
	    var beakPosition = new Rectangle(0, beakWidth, 0, beakWidth);
	    beakPosition = _moveEdge(beakPosition, elementPosition.targetEdge * -1, -beakWidth / 2);
	    beakPosition = _centerEdgeToPoint(beakPosition, elementPosition.targetEdge * -1, beakTargetPoint - _getRelativeRectEdgeValue(positiveEdge, elementPosition.elementRectangle));
	    if (!_isEdgeInBounds(beakPosition, elementBounds, positiveEdge)) {
	        beakPosition = _alignEdges(beakPosition, elementBounds, positiveEdge);
	    }
	    else if (!_isEdgeInBounds(beakPosition, elementBounds, negativeEdge)) {
	        beakPosition = _alignEdges(beakPosition, elementBounds, negativeEdge);
	    }
	    return beakPosition;
	}
	function _getRectangleFromElement(element) {
	    var clientRect = element.getBoundingClientRect();
	    return new Rectangle(clientRect.left, clientRect.right, clientRect.top, clientRect.bottom);
	}
	function _getRectangleFromIRect(rect) {
	    return new Rectangle(rect.left, rect.right, rect.top, rect.bottom);
	}
	function _getTargetRect(bounds, target) {
	    var targetRectangle;
	    if (target) {
	        if (target.preventDefault) {
	            var ev = target;
	            targetRectangle = new Rectangle(ev.clientX, ev.clientX, ev.clientY, ev.clientY);
	        }
	        else if (target.getBoundingClientRect) {
	            targetRectangle = _getRectangleFromElement(target);
	            // HTMLImgElements can have x and y values. The check for it being a point must go last.
	        }
	        else {
	            var point = target;
	            targetRectangle = new Rectangle(point.x, point.x, point.y, point.y);
	        }
	        if (!_isRectangleWithinBounds(targetRectangle, bounds)) {
	            var outOfBounds = _getOutOfBoundsEdges(targetRectangle, bounds);
	            for (var _i = 0, outOfBounds_2 = outOfBounds; _i < outOfBounds_2.length; _i++) {
	                var direction = outOfBounds_2[_i];
	                targetRectangle[positioning_types_1.RectangleEdge[direction]] = bounds[positioning_types_1.RectangleEdge[direction]];
	            }
	        }
	    }
	    else {
	        targetRectangle = new Rectangle(0, 0, 0, 0);
	    }
	    return targetRectangle;
	}
	/**
	 * If max height is less than zero it returns the bounds height instead.
	 */
	function _getMaxHeightFromTargetRectangle(targetRectangle, targetEdge, gapSpace, bounds, coverTarget) {
	    var maxHeight = 0;
	    var directionalHint = DirectionalDictionary[targetEdge];
	    // If cover target is set, then the max height should be calculated using the opposite of the target edge since
	    // that's the direction that the callout will expand in.
	    // For instance, if the directionalhint is bottomLeftEdge then the callout will position so it's bottom edge
	    // is aligned with the bottom of the target and expand up towards the top of the screen and the calculated max height
	    // is (bottom of target) - (top of screen) - gapSpace.
	    var target = coverTarget ? directionalHint.targetEdge * -1 : directionalHint.targetEdge;
	    if (target === positioning_types_1.RectangleEdge.top) {
	        maxHeight = _getEdgeValue(targetRectangle, directionalHint.targetEdge) - bounds.top - gapSpace;
	    }
	    else if (target === positioning_types_1.RectangleEdge.bottom) {
	        maxHeight = bounds.bottom - _getEdgeValue(targetRectangle, directionalHint.targetEdge) - gapSpace;
	    }
	    else {
	        maxHeight = bounds.bottom - targetRectangle.top - gapSpace;
	    }
	    return maxHeight > 0 ? maxHeight : bounds.height;
	}
	function _positionElementRelative(props, elementToPosition, boundingRect, previousPositions) {
	    var gap = props.gapSpace ? props.gapSpace : 0;
	    var targetRect = _getTargetRect(boundingRect, props.target);
	    var positionData = _getAlignmentData(_getPositionData(props.directionalHint, props.directionalHintForRTL, previousPositions), targetRect, boundingRect, props.coverTarget, props.alignTargetEdge);
	    var positionedElement = _positionElementWithinBounds(_getRectangleFromElement(elementToPosition), targetRect, boundingRect, positionData, gap, props.directionalHintFixed, props.coverTarget);
	    return tslib_1.__assign({}, positionedElement, { targetRectangle: targetRect });
	}
	function _finalizePositionData(positionedElement, hostElement, bounds, coverTarget, doNotFinalizeReturnEdge) {
	    var finalizedElement = _finalizeElementPosition(positionedElement.elementRectangle, hostElement, positionedElement.targetEdge, bounds, positionedElement.alignmentEdge, coverTarget, doNotFinalizeReturnEdge);
	    return {
	        elementPosition: finalizedElement,
	        targetEdge: positionedElement.targetEdge,
	        alignmentEdge: positionedElement.alignmentEdge
	    };
	}
	function _positionElement(props, hostElement, elementToPosition, previousPositions) {
	    var boundingRect = props.bounds
	        ? _getRectangleFromIRect(props.bounds)
	        : new Rectangle(0, window.innerWidth - Utilities_1.getScrollbarWidth(), 0, window.innerHeight);
	    var positionedElement = _positionElementRelative(props, elementToPosition, boundingRect, previousPositions);
	    return _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget);
	}
	function _positionCallout(props, hostElement, callout, previousPositions, doNotFinalizeReturnEdge) {
	    var beakWidth = props.isBeakVisible ? props.beakWidth || 0 : 0;
	    var gap = _calculateActualBeakWidthInPixels(beakWidth) / 2 + (props.gapSpace ? props.gapSpace : 0);
	    var positionProps = props;
	    positionProps.gapSpace = gap;
	    var boundingRect = props.bounds
	        ? _getRectangleFromIRect(props.bounds)
	        : new Rectangle(0, window.innerWidth - Utilities_1.getScrollbarWidth(), 0, window.innerHeight);
	    var positionedElement = _positionElementRelative(positionProps, callout, boundingRect, previousPositions);
	    var beakPositioned = _positionBeak(beakWidth, positionedElement);
	    var finalizedBeakPosition = _finalizeBeakPosition(positionedElement, beakPositioned, boundingRect);
	    return tslib_1.__assign({}, _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget, doNotFinalizeReturnEdge), { beakPosition: finalizedBeakPosition });
	}
	function _positionCard(props, hostElement, callout, previousPositions) {
	    return _positionCallout(props, hostElement, callout, previousPositions, true);
	}
	// END PRIVATE FUNCTIONS
	/* tslint:disable:variable-name */
	exports.__positioningTestPackage = {
	    _finalizePositionData: _finalizePositionData,
	    _finalizeBeakPosition: _finalizeBeakPosition,
	    _calculateActualBeakWidthInPixels: _calculateActualBeakWidthInPixels,
	    _positionElementWithinBounds: _positionElementWithinBounds,
	    _positionBeak: _positionBeak,
	    _getPositionData: _getPositionData,
	    _getMaxHeightFromTargetRectangle: _getMaxHeightFromTargetRectangle
	};
	/* tslint:enable:variable-name */
	/**
	 * Used to position an element relative to the given positioning props.
	 * If positioning has been completed before, previousPositioningData
	 * can be passed to ensure that the positioning element repositions based on
	 * its previous targets rather than starting with directionalhint.
	 *
	 * @export
	 * @param {IPositionProps} props
	 * @param {HTMLElement} hostElement
	 * @param {HTMLElement} elementToPosition
	 * @param {IPositionedData} previousPositions
	 * @returns
	 */
	function positionElement(props, hostElement, elementToPosition, previousPositions) {
	    return _positionElement(props, hostElement, elementToPosition, previousPositions);
	}
	exports.positionElement = positionElement;
	function positionCallout(props, hostElement, elementToPosition, previousPositions) {
	    return _positionCallout(props, hostElement, elementToPosition, previousPositions);
	}
	exports.positionCallout = positionCallout;
	function positionCard(props, hostElement, elementToPosition, previousPositions) {
	    return _positionCard(props, hostElement, elementToPosition, previousPositions);
	}
	exports.positionCard = positionCard;
	/**
	 * Get's the maximum height that a rectangle can have in order to fit below or above a target.
	 * If the directional hint specifies a left or right edge (i.e. leftCenter) it will limit the height to the topBorder
	 * of the target given.
	 * If no bounds are provided then the window is treated as the bounds.
	 */
	function getMaxHeight(target, targetEdge, gapSpace, bounds, coverTarget) {
	    if (gapSpace === void 0) { gapSpace = 0; }
	    var mouseTarget = target;
	    var elementTarget = target;
	    var pointTarget = target;
	    var targetRect;
	    var boundingRectangle = bounds
	        ? _getRectangleFromIRect(bounds)
	        : new Rectangle(0, window.innerWidth - Utilities_1.getScrollbarWidth(), 0, window.innerHeight);
	    if (mouseTarget.stopPropagation) {
	        targetRect = new Rectangle(mouseTarget.clientX, mouseTarget.clientX, mouseTarget.clientY, mouseTarget.clientY);
	    }
	    else if (pointTarget.x !== undefined && pointTarget.y !== undefined) {
	        targetRect = new Rectangle(pointTarget.x, pointTarget.x, pointTarget.y, pointTarget.y);
	    }
	    else {
	        targetRect = _getRectangleFromElement(elementTarget);
	    }
	    return _getMaxHeightFromTargetRectangle(targetRect, targetEdge, gapSpace, boundingRectangle, coverTarget);
	}
	exports.getMaxHeight = getMaxHeight;
	/**
	 * Returns the opposite edge of the given RectangleEdge.
	 */
	function getOppositeEdge(edge) {
	    return edge * -1;
	}
	exports.getOppositeEdge = getOppositeEdge;
	var _a;
	//# sourceMappingURL=positioning.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RectangleEdge;
	(function (RectangleEdge) {
	    RectangleEdge[RectangleEdge["top"] = 1] = "top";
	    RectangleEdge[RectangleEdge["bottom"] = -1] = "bottom";
	    RectangleEdge[RectangleEdge["left"] = 2] = "left";
	    RectangleEdge[RectangleEdge["right"] = -2] = "right";
	})(RectangleEdge = exports.RectangleEdge || (exports.RectangleEdge = {}));
	var Position;
	(function (Position) {
	    Position[Position["top"] = 0] = "top";
	    Position[Position["bottom"] = 1] = "bottom";
	    Position[Position["start"] = 2] = "start";
	    Position[Position["end"] = 3] = "end";
	})(Position = exports.Position || (exports.Position = {}));
	//# sourceMappingURL=positioning.types.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(614), exports);
	//# sourceMappingURL=Popup.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(615), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	/**
	 * This adds accessibility to Dialog and Panel controls
	 */
	var Popup = /** @class */ (function (_super) {
	    tslib_1.__extends(Popup, _super);
	    function Popup(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._disposables = [];
	        _this._onKeyDown = function (ev) {
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.escape:
	                    if (_this.props.onDismiss) {
	                        _this.props.onDismiss(ev);
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                    }
	                    break;
	            }
	        };
	        _this._onFocus = function () {
	            _this._containsFocus = true;
	        };
	        _this._onBlur = function (ev) {
	            if (_this._root.current && _this._root.current.contains(ev.relatedTarget)) {
	                _this._containsFocus = false;
	            }
	        };
	        _this._async = new Utilities_1.Async(_this);
	        _this.state = { needsVerticalScrollBar: false };
	        return _this;
	    }
	    Popup.prototype.componentWillMount = function () {
	        this._originalFocusedElement = Utilities_1.getDocument().activeElement;
	    };
	    Popup.prototype.componentDidMount = function () {
	        if (this._root.current) {
	            this._disposables.push(Utilities_1.on(this._root.current, 'focus', this._onFocus, true), Utilities_1.on(this._root.current, 'blur', this._onBlur, true));
	            if (Utilities_1.doesElementContainFocus(this._root.current)) {
	                this._containsFocus = true;
	            }
	        }
	        this._updateScrollBarAsync();
	    };
	    Popup.prototype.componentDidUpdate = function () {
	        this._updateScrollBarAsync();
	        this._async.dispose();
	    };
	    Popup.prototype.componentWillUnmount = function () {
	        this._disposables.forEach(function (dispose) { return dispose(); });
	        if (this.props.shouldRestoreFocus &&
	            this._originalFocusedElement &&
	            this._containsFocus &&
	            this._originalFocusedElement !== window) {
	            // This slight delay is required so that we can unwind the stack, let react try to mess with focus, and then
	            // apply the correct focus. Without the setTimeout, we end up focusing the correct thing, and then React wants
	            // to reset the focus back to the thing it thinks should have been focused.
	            if (this._originalFocusedElement) {
	                this._originalFocusedElement.focus();
	            }
	        }
	    };
	    Popup.prototype.render = function () {
	        var _a = this.props, role = _a.role, className = _a.className, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, style = _a.style;
	        return (React.createElement("div", tslib_1.__assign({ ref: this._root }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { className: className, role: role, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onKeyDown: this._onKeyDown, style: tslib_1.__assign({ overflowY: this.state.needsVerticalScrollBar ? 'scroll' : undefined, outline: 'none' }, style) }), this.props.children));
	    };
	    Popup.prototype._updateScrollBarAsync = function () {
	        var _this = this;
	        this._async.requestAnimationFrame(function () {
	            _this._getScrollBar();
	        });
	    };
	    Popup.prototype._getScrollBar = function () {
	        // If overflowY is overriden, don't waste time calculating whether the scrollbar is necessary.
	        if (this.props.style && this.props.style.overflowY) {
	            return;
	        }
	        var needsVerticalScrollBar = false;
	        if (this._root && this._root.current && this._root.current.firstElementChild) {
	            // ClientHeight returns the client height of an element rounded to an
	            // integer. On some browsers at different zoom levels this rounding
	            // can generate different results for the root container and child even
	            // though they are the same height. This causes us to show a scroll bar
	            // when not needed. Ideally we would use BoundingClientRect().height
	            // instead however seems that the API is 90% slower than using ClientHeight.
	            // Therefore instead we will calculate the difference between heights and
	            // allow for a 1px difference to still be considered ok and not show the
	            // scroll bar.
	            var rootHeight = this._root.current.clientHeight;
	            var firstChildHeight = this._root.current.firstElementChild.clientHeight;
	            if (rootHeight > 0 && firstChildHeight > rootHeight) {
	                needsVerticalScrollBar = firstChildHeight - rootHeight > 1;
	            }
	        }
	        if (this.state.needsVerticalScrollBar !== needsVerticalScrollBar) {
	            this.setState({
	                needsVerticalScrollBar: needsVerticalScrollBar
	            });
	        }
	    };
	    Popup.defaultProps = {
	        shouldRestoreFocus: true
	    };
	    return Popup;
	}(React.Component));
	exports.Popup = Popup;
	//# sourceMappingURL=Popup.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	function getBeakStyle(beakWidth) {
	    return {
	        height: beakWidth,
	        width: beakWidth
	    };
	}
	var GlobalClassNames = {
	    container: 'ms-Callout-container',
	    root: 'ms-Callout',
	    beak: 'ms-Callout-beak',
	    beakCurtain: 'ms-Callout-beakCurtain',
	    calloutMain: 'ms-Callout-main'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, overflowYHidden = props.overflowYHidden, calloutWidth = props.calloutWidth, beakWidth = props.beakWidth, backgroundColor = props.backgroundColor, calloutMaxWidth = props.calloutMaxWidth;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var palette = theme.palette;
	    return {
	        container: [
	            classNames.container,
	            {
	                position: 'relative'
	            }
	        ],
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                position: 'absolute',
	                boxSizing: 'border-box',
	                borderWidth: 1,
	                borderStyle: 'solid',
	                borderColor: palette.neutralLight,
	                boxShadow: '0 0 5px 0px rgba(0,0,0,0.4)',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderWidth: 1,
	                        borderStyle: 'solid',
	                        borderColor: 'WindowText'
	                    },
	                    _a)
	            },
	            Styling_1.focusClear(),
	            className,
	            !!calloutWidth && { width: calloutWidth },
	            !!calloutMaxWidth && { maxWidth: calloutMaxWidth }
	        ],
	        beak: [
	            classNames.beak,
	            {
	                position: 'absolute',
	                backgroundColor: palette.white,
	                boxShadow: 'inherit',
	                border: 'inherit',
	                boxSizing: 'border-box',
	                transform: 'rotate(45deg)'
	            },
	            getBeakStyle(beakWidth),
	            backgroundColor && {
	                backgroundColor: backgroundColor
	            }
	        ],
	        beakCurtain: [
	            classNames.beakCurtain,
	            {
	                position: 'absolute',
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0,
	                backgroundColor: palette.white
	            }
	        ],
	        calloutMain: [
	            classNames.calloutMain,
	            {
	                backgroundColor: palette.white,
	                overflowX: 'hidden',
	                overflowY: 'auto',
	                position: 'relative'
	            },
	            overflowYHidden && {
	                overflowY: 'hidden'
	            },
	            backgroundColor && {
	                backgroundColor: backgroundColor
	            }
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=CalloutContent.styles.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	__webpack_require__(464);
	tslib_1.__exportStar(__webpack_require__(618), exports);
	//# sourceMappingURL=Layer.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(619), exports);
	tslib_1.__exportStar(__webpack_require__(620), exports);
	tslib_1.__exportStar(__webpack_require__(628), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Layer_base_1 = __webpack_require__(620);
	var Layer_styles_1 = __webpack_require__(627);
	exports.Layer = Utilities_1.styled(Layer_base_1.LayerBase, Layer_styles_1.getStyles, undefined, {
	    scope: 'Layer',
	    fields: ['hostId', 'theme', 'styles']
	});
	//# sourceMappingURL=Layer.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var ReactDOM = __webpack_require__(41);
	var Fabric_1 = __webpack_require__(621);
	var Utilities_1 = __webpack_require__(592);
	var Layer_notification_1 = __webpack_require__(626);
	var getClassNames = Utilities_1.classNamesFunction();
	var LayerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(LayerBase, _super);
	    function LayerBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._rootRef = React.createRef();
	        _this._createLayerElement = function () {
	            var hostId = _this.props.hostId;
	            var doc = Utilities_1.getDocument(_this._rootRef.current);
	            var host = _this._getHost();
	            if (!doc || !host) {
	                return;
	            }
	            // If one was already existing, remove.
	            _this._removeLayerElement();
	            var layerElement = doc.createElement('div');
	            var classNames = _this._getClassNames();
	            layerElement.className = classNames.root;
	            Utilities_1.setPortalAttribute(layerElement);
	            Utilities_1.setVirtualParent(layerElement, _this._rootRef.current);
	            _this.props.insertFirst ? host.insertBefore(layerElement, host.firstChild) : host.appendChild(layerElement);
	            _this.setState({
	                hostId: hostId,
	                layerElement: layerElement
	            }, function () {
	                var _a = _this.props, onLayerDidMount = _a.onLayerDidMount, onLayerMounted = _a.onLayerMounted;
	                if (onLayerMounted) {
	                    onLayerMounted();
	                }
	                if (onLayerDidMount) {
	                    onLayerDidMount();
	                }
	            });
	        };
	        _this.state = {};
	        if (false) {
	            Utilities_1.warnDeprecations('Layer', props, {
	                onLayerMounted: 'onLayerDidMount'
	            });
	        }
	        return _this;
	    }
	    LayerBase.prototype.componentDidMount = function () {
	        var hostId = this.props.hostId;
	        this._createLayerElement();
	        if (hostId) {
	            Layer_notification_1.registerLayer(hostId, this._createLayerElement);
	        }
	    };
	    LayerBase.prototype.render = function () {
	        var layerElement = this.state.layerElement;
	        var classNames = this._getClassNames();
	        var eventBubblingEnabled = this.props.eventBubblingEnabled;
	        return (React.createElement("span", { className: "ms-layer", ref: this._rootRef }, layerElement &&
	            ReactDOM.createPortal(React.createElement(Fabric_1.Fabric, tslib_1.__assign({}, (!eventBubblingEnabled && _getFilteredEvents()), { className: classNames.content }), this.props.children), layerElement)));
	    };
	    LayerBase.prototype.componentDidUpdate = function () {
	        if (this.props.hostId !== this.state.hostId) {
	            this._createLayerElement();
	        }
	    };
	    LayerBase.prototype.componentWillUnmount = function () {
	        var hostId = this.props.hostId;
	        this._removeLayerElement();
	        if (hostId) {
	            Layer_notification_1.unregisterLayer(hostId, this._createLayerElement);
	        }
	    };
	    LayerBase.prototype._removeLayerElement = function () {
	        var onLayerWillUnmount = this.props.onLayerWillUnmount;
	        var layerElement = this.state.layerElement;
	        if (onLayerWillUnmount) {
	            onLayerWillUnmount();
	        }
	        if (layerElement && layerElement.parentNode) {
	            var parentNode = layerElement.parentNode;
	            if (parentNode) {
	                parentNode.removeChild(layerElement);
	            }
	        }
	    };
	    LayerBase.prototype._getClassNames = function () {
	        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            isNotHost: !this.props.hostId
	        });
	        return classNames;
	    };
	    LayerBase.prototype._getHost = function () {
	        var hostId = this.props.hostId;
	        var doc = Utilities_1.getDocument(this._rootRef.current);
	        if (!doc) {
	            return undefined;
	        }
	        if (hostId) {
	            return doc.getElementById(hostId);
	        }
	        else {
	            var defaultHostSelector = Layer_notification_1.getDefaultTarget();
	            return defaultHostSelector ? doc.querySelector(defaultHostSelector) : doc.body;
	        }
	    };
	    LayerBase.defaultProps = {
	        onLayerDidMount: function () { return undefined; },
	        onLayerWillUnmount: function () { return undefined; }
	    };
	    LayerBase = tslib_1.__decorate([
	        Utilities_1.customizable('Layer', ['theme', 'hostId'])
	    ], LayerBase);
	    return LayerBase;
	}(React.Component));
	exports.LayerBase = LayerBase;
	var _onFilterEvent = function (ev) {
	    // We should just be able to check ev.bubble here and only stop events that are bubbling up. However, even though mouseenter and
	    //    mouseleave do NOT bubble up, they are showing up as bubbling. Therefore we stop events based on event name rather than ev.bubble.
	    if (ev.eventPhase === Event.BUBBLING_PHASE && ev.type !== 'mouseenter' && ev.type !== 'mouseleave') {
	        ev.stopPropagation();
	    }
	};
	var _filteredEventProps;
	function _getFilteredEvents() {
	    if (!_filteredEventProps) {
	        _filteredEventProps = {};
	        [
	            'onClick',
	            'onContextMenu',
	            'onDoubleClick',
	            'onDrag',
	            'onDragEnd',
	            'onDragEnter',
	            'onDragExit',
	            'onDragLeave',
	            'onDragOver',
	            'onDragStart',
	            'onDrop',
	            'onMouseDown',
	            'onMouseEnter',
	            'onMouseLeave',
	            'onMouseMove',
	            'onMouseOver',
	            'onMouseOut',
	            'onMouseUp',
	            'onKeyDown',
	            'onKeyPress',
	            'onKeyUp',
	            'onFocus',
	            'onBlur',
	            'onChange',
	            'onInput',
	            'onInvalid',
	            'onSubmit'
	        ].forEach(function (name) { return (_filteredEventProps[name] = _onFilterEvent); });
	    }
	    return _filteredEventProps;
	}
	//# sourceMappingURL=Layer.base.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(622), exports);
	//# sourceMappingURL=Fabric.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(623), exports);
	tslib_1.__exportStar(__webpack_require__(624), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Fabric_base_1 = __webpack_require__(624);
	var Fabric_styles_1 = __webpack_require__(625);
	exports.Fabric = Utilities_1.styled(Fabric_base_1.FabricBase, Fabric_styles_1.getStyles, undefined, {
	    scope: 'Fabric'
	});
	//# sourceMappingURL=Fabric.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Fabric_styles_1 = __webpack_require__(625);
	var getClassNames = Utilities_1.classNamesFunction();
	var FabricBase = /** @class */ (function (_super) {
	    tslib_1.__extends(FabricBase, _super);
	    function FabricBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._rootElement = React.createRef();
	        _this._disposables = [];
	        _this._onMouseDown = function (ev) {
	            _this.setState({ isFocusVisible: false });
	        };
	        _this._onKeyDown = function (ev) {
	            if (Utilities_1.isDirectionalKeyCode(ev.which)) {
	                _this.setState({ isFocusVisible: true });
	            }
	        };
	        _this.state = { isFocusVisible: false };
	        return _this;
	    }
	    FabricBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, rest = tslib_1.__rest(_a, ["className"]);
	        var classNames = getClassNames(Fabric_styles_1.getStyles, {
	            theme: this.props.theme,
	            className: className,
	            isFocusVisible: this.state.isFocusVisible
	        });
	        var divProps = Utilities_1.getNativeProps(rest, Utilities_1.divProperties);
	        return React.createElement("div", tslib_1.__assign({}, divProps, { className: classNames.root, ref: this._rootElement }));
	    };
	    FabricBase.prototype.componentDidMount = function () {
	        var win = Utilities_1.getWindow(this._rootElement.current);
	        if (win) {
	            this._disposables.push(Utilities_1.on(win, 'mousedown', this._onMouseDown, true), Utilities_1.on(win, 'keydown', this._onKeyDown, true));
	        }
	    };
	    FabricBase.prototype.componentWillUnmount = function () {
	        this._disposables.forEach(function (dispose) { return dispose(); });
	    };
	    return FabricBase;
	}(React.Component));
	exports.FabricBase = FabricBase;
	//# sourceMappingURL=Fabric.base.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var inheritFont = { fontFamily: 'inherit' };
	var GlobalClassNames = {
	    root: 'ms-Fabric'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, isFocusVisible = props.isFocusVisible;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            isFocusVisible && 'is-focusVisible ms-Fabric--isFocusVisible',
	            theme.fonts.medium,
	            {
	                color: theme.palette.neutralPrimary,
	                selectors: {
	                    '& button': inheritFont,
	                    '& input': inheritFont,
	                    '& textarea': inheritFont
	                }
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=Fabric.styles.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _layersByHostId = {};
	var _defaultHostSelector;
	/**
	 * Register a layer for a given host id
	 * @param hostId Id of the layer host
	 * @param layer Layer instance
	 */
	function registerLayer(hostId, callback) {
	    if (!_layersByHostId[hostId]) {
	        _layersByHostId[hostId] = [];
	    }
	    _layersByHostId[hostId].push(callback);
	}
	exports.registerLayer = registerLayer;
	/**
	 * Unregister a layer for a given host id
	 * @param hostId Id of the layer host
	 * @param layer Layer instance
	 */
	function unregisterLayer(hostId, callback) {
	    if (_layersByHostId[hostId]) {
	        var idx = _layersByHostId[hostId].indexOf(callback);
	        if (idx >= 0) {
	            _layersByHostId[hostId].splice(idx, 1);
	            if (_layersByHostId[hostId].length === 0) {
	                delete _layersByHostId[hostId];
	            }
	        }
	    }
	}
	exports.unregisterLayer = unregisterLayer;
	/**
	 * Used for notifying applicable Layers that a host is available/unavailable and to re-evaluate Layers that
	 * care about the specific host.
	 */
	function notifyHostChanged(id) {
	    if (_layersByHostId[id]) {
	        _layersByHostId[id].forEach(function (callback) { return callback(); });
	    }
	}
	exports.notifyHostChanged = notifyHostChanged;
	/**
	 * Sets the default target selector to use when determining the host in which
	 * Layered content will be injected into. If not provided, an element will be
	 * created at the end of the document body.
	 *
	 * Passing in a falsey value will clear the default target and reset back to
	 * using a created element at the end of document body.
	 */
	function setDefaultTarget(selector) {
	    _defaultHostSelector = selector;
	}
	exports.setDefaultTarget = setDefaultTarget;
	/**
	 * Get the default target selector when determining a host
	 */
	function getDefaultTarget() {
	    return _defaultHostSelector;
	}
	exports.getDefaultTarget = getDefaultTarget;
	//# sourceMappingURL=Layer.notification.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Layer',
	    rootNoHost: 'ms-Layer--fixed',
	    content: 'ms-Layer-content'
	};
	exports.getStyles = function (props) {
	    var className = props.className, isNotHost = props.isNotHost, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            isNotHost && [
	                classNames.rootNoHost,
	                {
	                    position: 'fixed',
	                    zIndex: Styling_1.ZIndexes.Layer,
	                    top: 0,
	                    left: 0,
	                    bottom: 0,
	                    right: 0,
	                    visibility: 'hidden'
	                }
	            ],
	            className
	        ],
	        content: [
	            classNames.content,
	            {
	                visibility: 'visible'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=Layer.styles.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Layer_notification_1 = __webpack_require__(626);
	var LayerHost = /** @class */ (function (_super) {
	    tslib_1.__extends(LayerHost, _super);
	    function LayerHost() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LayerHost.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    LayerHost.prototype.componentDidMount = function () {
	        Layer_notification_1.notifyHostChanged(this.props.id);
	    };
	    LayerHost.prototype.componentWillUnmount = function () {
	        Layer_notification_1.notifyHostChanged(this.props.id);
	    };
	    LayerHost.prototype.render = function () {
	        return React.createElement("div", tslib_1.__assign({}, this.props, { className: Utilities_1.css('ms-LayerHost', this.props.className) }));
	    };
	    return LayerHost;
	}(React.Component));
	exports.LayerHost = LayerHost;
	//# sourceMappingURL=LayerHost.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Callout_1 = __webpack_require__(605);
	var FocusTrapZone_1 = __webpack_require__(630);
	/**
	 * A special Callout that uses FocusTrapZone to trap focus
	 * @param props - Props for the component
	 */
	exports.FocusTrapCallout = function (props) {
	    return (React.createElement(Callout_1.Callout, tslib_1.__assign({}, props),
	        React.createElement(FocusTrapZone_1.FocusTrapZone, tslib_1.__assign({ disabled: props.hidden }, props.focusTrapProps), props.children)));
	};
	//# sourceMappingURL=FocusTrapCallout.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(631), exports);
	//# sourceMappingURL=FocusTrapZone.js.map

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(632), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusTrapZone = /** @class */ (function (_super) {
	    tslib_1.__extends(FocusTrapZone, _super);
	    function FocusTrapZone(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._firstBumper = React.createRef();
	        _this._lastBumper = React.createRef();
	        _this._hasFocus = false;
	        _this._onRootFocus = function (ev) {
	            if (_this.props.onFocus) {
	                _this.props.onFocus(ev);
	            }
	            _this._hasFocus = true;
	        };
	        _this._onRootBlur = function (ev) {
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	            var relatedTarget = ev.relatedTarget;
	            if (ev.relatedTarget === null) {
	                // In IE11, due to lack of support, event.relatedTarget is always
	                // null making every onBlur call to be "outside" of the ComboBox
	                // even when it's not. Using document.activeElement is another way
	                // for us to be able to get what the relatedTarget without relying
	                // on the event
	                relatedTarget = document.activeElement;
	            }
	            if (!Utilities_1.elementContains(_this._root.current, relatedTarget)) {
	                _this._hasFocus = false;
	            }
	        };
	        _this._onFirstBumperFocus = function () {
	            _this._onBumperFocus(true);
	        };
	        _this._onLastBumperFocus = function () {
	            _this._onBumperFocus(false);
	        };
	        _this._onBumperFocus = function (isFirstBumper) {
	            if (_this.props.disabled) {
	                return;
	            }
	            var currentBumper = (isFirstBumper === _this._hasFocus ? _this._lastBumper.current : _this._firstBumper.current);
	            if (_this._root.current) {
	                var nextFocusable = isFirstBumper === _this._hasFocus
	                    ? Utilities_1.getLastTabbable(_this._root.current, currentBumper, true, false)
	                    : Utilities_1.getFirstTabbable(_this._root.current, currentBumper, true, false);
	                if (nextFocusable) {
	                    if (_this._isBumper(nextFocusable)) {
	                        // This can happen when FTZ contains no tabbable elements. focus will take care of finding a focusable element in FTZ.
	                        _this.focus();
	                    }
	                    else {
	                        nextFocusable.focus();
	                    }
	                }
	            }
	        };
	        _this._onFocusCapture = function (ev) {
	            if (_this.props.onFocusCapture) {
	                _this.props.onFocusCapture(ev);
	            }
	            if (ev.target !== ev.currentTarget && !_this._isBumper(ev.target)) {
	                // every time focus changes within the trap zone, remember the focused element so that
	                // it can be restored if focus leaves the pane and returns via keystroke (i.e. via a call to this.focus(true))
	                _this._previouslyFocusedElementInTrapZone = ev.target;
	            }
	        };
	        _this._forceFocusInTrap = function (ev) {
	            if (_this.props.disabled) {
	                return;
	            }
	            if (FocusTrapZone._focusStack.length && _this === FocusTrapZone._focusStack[FocusTrapZone._focusStack.length - 1]) {
	                var focusedElement = document.activeElement;
	                if (!Utilities_1.elementContains(_this._root.current, focusedElement)) {
	                    _this.focus();
	                    _this._hasFocus = true; // set focus here since we stop event propagation
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        _this._forceClickInTrap = function (ev) {
	            if (_this.props.disabled) {
	                return;
	            }
	            if (FocusTrapZone._focusStack.length && _this === FocusTrapZone._focusStack[FocusTrapZone._focusStack.length - 1]) {
	                var clickedElement = ev.target;
	                if (clickedElement && !Utilities_1.elementContains(_this._root.current, clickedElement)) {
	                    _this.focus();
	                    _this._hasFocus = true; // set focus here since we stop event propagation
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        Utilities_1.initializeComponentRef(_this);
	        return _this;
	    }
	    FocusTrapZone.prototype.componentDidMount = function () {
	        this._bringFocusIntoZone();
	        this._updateEventHandlers(this.props);
	    };
	    FocusTrapZone.prototype.componentWillReceiveProps = function (nextProps) {
	        var elementToFocusOnDismiss = nextProps.elementToFocusOnDismiss;
	        if (elementToFocusOnDismiss && this._previouslyFocusedElementOutsideTrapZone !== elementToFocusOnDismiss) {
	            this._previouslyFocusedElementOutsideTrapZone = elementToFocusOnDismiss;
	        }
	        this._updateEventHandlers(nextProps);
	    };
	    FocusTrapZone.prototype.componentDidUpdate = function (prevProps) {
	        var prevForceFocusInsideTrap = prevProps.forceFocusInsideTrap !== undefined ? prevProps.forceFocusInsideTrap : true;
	        var newForceFocusInsideTrap = this.props.forceFocusInsideTrap !== undefined ? this.props.forceFocusInsideTrap : true;
	        var prevDisabled = prevProps.disabled !== undefined ? prevProps.disabled : false;
	        var newDisabled = this.props.disabled !== undefined ? this.props.disabled : false;
	        if ((!prevForceFocusInsideTrap && newForceFocusInsideTrap) || (prevDisabled && !newDisabled)) {
	            // Transition from forceFocusInsideTrap / FTZ disabled to enabled.
	            // Emulate what happens when a FocusTrapZone gets mounted.
	            this._bringFocusIntoZone();
	        }
	        else if ((prevForceFocusInsideTrap && !newForceFocusInsideTrap) || (!prevDisabled && newDisabled)) {
	            // Transition from forceFocusInsideTrap / FTZ enabled to disabled.
	            // Emulate what happens when a FocusTrapZone gets unmounted.
	            this._returnFocusToInitiator();
	        }
	    };
	    FocusTrapZone.prototype.componentWillUnmount = function () {
	        // don't handle return focus unless forceFocusInsideTrap is true or focus is still within FocusTrapZone
	        if (!this.props.disabled ||
	            this.props.forceFocusInsideTrap ||
	            !Utilities_1.elementContains(this._root.current, document.activeElement)) {
	            this._returnFocusToInitiator();
	        }
	    };
	    FocusTrapZone.prototype.render = function () {
	        var _a = this.props, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, ariaLabelledBy = _a.ariaLabelledBy;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        var bumperProps = {
	            style: {
	                pointerEvents: 'none',
	                position: 'fixed' // 'fixed' prevents browsers from scrolling to bumpers when viewport does not contain them
	            },
	            tabIndex: disabled ? -1 : 0,
	            'data-is-visible': true
	        };
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: className, ref: this._root, "aria-labelledby": ariaLabelledBy, onFocusCapture: this._onFocusCapture, onFocus: this._onRootFocus, onBlur: this._onRootBlur }),
	            React.createElement("div", tslib_1.__assign({}, bumperProps, { ref: this._firstBumper, onFocus: this._onFirstBumperFocus })),
	            this.props.children,
	            React.createElement("div", tslib_1.__assign({}, bumperProps, { ref: this._lastBumper, onFocus: this._onLastBumperFocus }))));
	    };
	    FocusTrapZone.prototype.focus = function () {
	        var _a = this.props, focusPreviouslyFocusedInnerElement = _a.focusPreviouslyFocusedInnerElement, firstFocusableSelector = _a.firstFocusableSelector;
	        if (focusPreviouslyFocusedInnerElement &&
	            this._previouslyFocusedElementInTrapZone &&
	            Utilities_1.elementContains(this._root.current, this._previouslyFocusedElementInTrapZone)) {
	            // focus on the last item that had focus in the zone before we left the zone
	            this._focusAsync(this._previouslyFocusedElementInTrapZone);
	            return;
	        }
	        var focusSelector = typeof firstFocusableSelector === 'string' ? firstFocusableSelector : firstFocusableSelector && firstFocusableSelector();
	        var _firstFocusableChild;
	        if (this._root.current) {
	            if (focusSelector) {
	                _firstFocusableChild = this._root.current.querySelector('.' + focusSelector);
	            }
	            // Fall back to first element if query selector did not match any elements.
	            if (!_firstFocusableChild) {
	                _firstFocusableChild = Utilities_1.getNextElement(this._root.current, this._root.current.firstChild, false, false, false, true);
	            }
	        }
	        if (_firstFocusableChild) {
	            this._focusAsync(_firstFocusableChild);
	        }
	    };
	    FocusTrapZone.prototype._focusAsync = function (element) {
	        if (!this._isBumper(element)) {
	            Utilities_1.focusAsync(element);
	        }
	    };
	    FocusTrapZone.prototype._bringFocusIntoZone = function () {
	        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.disableFirstFocus, disableFirstFocus = _c === void 0 ? false : _c;
	        if (disabled) {
	            return;
	        }
	        FocusTrapZone._focusStack.push(this);
	        this._previouslyFocusedElementOutsideTrapZone = elementToFocusOnDismiss
	            ? elementToFocusOnDismiss
	            : document.activeElement;
	        if (!disableFirstFocus && !Utilities_1.elementContains(this._root.current, this._previouslyFocusedElementOutsideTrapZone)) {
	            this.focus();
	        }
	    };
	    FocusTrapZone.prototype._returnFocusToInitiator = function () {
	        var _this = this;
	        var ignoreExternalFocusing = this.props.ignoreExternalFocusing;
	        FocusTrapZone._focusStack = FocusTrapZone._focusStack.filter(function (value) {
	            return _this !== value;
	        });
	        var activeElement = document.activeElement;
	        if (!ignoreExternalFocusing &&
	            this._previouslyFocusedElementOutsideTrapZone &&
	            typeof this._previouslyFocusedElementOutsideTrapZone.focus === 'function' &&
	            (Utilities_1.elementContains(this._root.current, activeElement) || activeElement === document.body)) {
	            this._focusAsync(this._previouslyFocusedElementOutsideTrapZone);
	        }
	    };
	    FocusTrapZone.prototype._updateEventHandlers = function (newProps) {
	        var _a = newProps.isClickableOutsideFocusTrap, isClickableOutsideFocusTrap = _a === void 0 ? false : _a, _b = newProps.forceFocusInsideTrap, forceFocusInsideTrap = _b === void 0 ? true : _b;
	        if (forceFocusInsideTrap && !this._disposeFocusHandler) {
	            this._disposeFocusHandler = Utilities_1.on(window, 'focus', this._forceFocusInTrap, true);
	        }
	        else if (!forceFocusInsideTrap && this._disposeFocusHandler) {
	            this._disposeFocusHandler();
	            this._disposeFocusHandler = undefined;
	        }
	        if (!isClickableOutsideFocusTrap && !this._disposeClickHandler) {
	            this._disposeClickHandler = Utilities_1.on(window, 'click', this._forceClickInTrap, true);
	        }
	        else if (isClickableOutsideFocusTrap && this._disposeClickHandler) {
	            this._disposeClickHandler();
	            this._disposeClickHandler = undefined;
	        }
	    };
	    FocusTrapZone.prototype._isBumper = function (element) {
	        return element === this._firstBumper.current || element === this._lastBumper.current;
	    };
	    FocusTrapZone._focusStack = [];
	    return FocusTrapZone;
	}(React.Component));
	exports.FocusTrapZone = FocusTrapZone;
	//# sourceMappingURL=FocusTrapZone.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Tooltip_types_1 = __webpack_require__(602);
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var className = props.className, delay = props.delay, _a = props.beakWidth, beakWidth = _a === void 0 ? 16 : _a, _b = props.gapSpace, gapSpace = _b === void 0 ? 0 : _b, maxWidth = props.maxWidth, theme = props.theme;
	    var palette = theme.palette, fonts = theme.fonts;
	    // The math here is done to account for the 45 degree rotation of the beak
	    var tooltipGapSpace = -(Math.sqrt((beakWidth * beakWidth) / 2) + gapSpace);
	    return {
	        root: [
	            'ms-Tooltip',
	            theme.fonts.medium,
	            Styling_1.AnimationClassNames.fadeIn200,
	            {
	                background: palette.white,
	                padding: '8px',
	                animationDelay: '300ms',
	                maxWidth: maxWidth,
	                selectors: {
	                    ':after': {
	                        content: "''",
	                        position: 'absolute',
	                        bottom: tooltipGapSpace,
	                        left: tooltipGapSpace,
	                        right: tooltipGapSpace,
	                        top: tooltipGapSpace,
	                        zIndex: 0
	                    }
	                }
	            },
	            delay === Tooltip_types_1.TooltipDelay.zero && {
	                animationDelay: '0s'
	            },
	            delay === Tooltip_types_1.TooltipDelay.long && {
	                animationDelay: '500ms'
	            },
	            className
	        ],
	        content: [
	            'ms-Tooltip-content',
	            fonts.small,
	            {
	                position: 'relative',
	                zIndex: 1,
	                color: palette.neutralPrimary,
	                wordWrap: 'break-word',
	                overflowWrap: 'break-word',
	                overflow: 'hidden'
	            }
	        ],
	        subText: [
	            'ms-Tooltip-subtext',
	            {
	                // Using inherit here to avoid unintentional global overrides of the <p> tag.
	                fontSize: 'inherit',
	                fontWeight: 'inherit',
	                color: 'inherit',
	                margin: 0
	            }
	        ]
	    };
	};
	//# sourceMappingURL=Tooltip.styles.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var TooltipHost_base_1 = __webpack_require__(635);
	var TooltipHost_styles_1 = __webpack_require__(637);
	exports.TooltipHost = Utilities_1.styled(TooltipHost_base_1.TooltipHostBase, TooltipHost_styles_1.getStyles, undefined, {
	    scope: 'TooltipHost'
	});
	//# sourceMappingURL=TooltipHost.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var TooltipHost_types_1 = __webpack_require__(636);
	var Tooltip_1 = __webpack_require__(600);
	var Tooltip_types_1 = __webpack_require__(602);
	var getClassNames = Utilities_1.classNamesFunction();
	var TooltipHostBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TooltipHostBase, _super);
	    // Constructor
	    function TooltipHostBase(props) {
	        var _this = _super.call(this, props) || this;
	        // The wrapping div that gets the hover events
	        _this._tooltipHost = React.createRef();
	        // The ID of the setTimeout that will eventually close the tooltip if the
	        // the tooltip isn't hovered over.
	        _this._closingTimer = -1;
	        _this.show = function () {
	            _this._toggleTooltip(true);
	        };
	        _this.dismiss = function () {
	            _this._hideTooltip();
	        };
	        // Show Tooltip
	        _this._onTooltipMouseEnter = function (ev) {
	            var overflowMode = _this.props.overflowMode;
	            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) {
	                TooltipHostBase._currentVisibleTooltip.dismiss();
	            }
	            TooltipHostBase._currentVisibleTooltip = _this;
	            if (overflowMode !== undefined) {
	                var overflowElement = _this._getTargetElement();
	                if (overflowElement && !Utilities_1.hasOverflow(overflowElement)) {
	                    return;
	                }
	            }
	            _this._clearDismissTimer();
	            if (ev.target && Utilities_1.portalContainsElement(ev.target, _this._getTargetElement())) {
	                // Do not show tooltip when target is inside a portal relative to TooltipHost.
	                return;
	            }
	            _this._toggleTooltip(true);
	        };
	        // Hide Tooltip
	        _this._onTooltipMouseLeave = function (ev) {
	            if (_this.props.closeDelay) {
	                _this._clearDismissTimer();
	                _this._closingTimer = _this._async.setTimeout(function () {
	                    _this._toggleTooltip(false);
	                }, _this.props.closeDelay);
	            }
	            else {
	                _this._toggleTooltip(false);
	            }
	            if (TooltipHostBase._currentVisibleTooltip === _this) {
	                TooltipHostBase._currentVisibleTooltip = undefined;
	            }
	        };
	        _this._onTooltipKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.escape) {
	                _this._hideTooltip();
	            }
	        };
	        _this._clearDismissTimer = function () {
	            _this._async.clearTimeout(_this._closingTimer);
	        };
	        // Hide Tooltip
	        _this._hideTooltip = function () {
	            _this._toggleTooltip(false);
	        };
	        _this.state = {
	            isTooltipVisible: false
	        };
	        return _this;
	    }
	    // Render
	    TooltipHostBase.prototype.render = function () {
	        var _a = this.props, calloutProps = _a.calloutProps, children = _a.children, content = _a.content, delay = _a.delay, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, className = _a.hostClassName, id = _a.id, _b = _a.setAriaDescribedBy, setAriaDescribedBy = _b === void 0 ? true : _b, tooltipProps = _a.tooltipProps, styles = _a.styles, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        var isTooltipVisible = this.state.isTooltipVisible;
	        var tooltipId = id || Utilities_1.getId('tooltip');
	        var isContentPresent = !!(content || (tooltipProps && tooltipProps.onRenderContent && tooltipProps.onRenderContent()));
	        var showTooltip = isTooltipVisible && isContentPresent;
	        var ariaDescribedBy = setAriaDescribedBy && isTooltipVisible && isContentPresent ? tooltipId : undefined;
	        return (React.createElement("div", tslib_1.__assign({ className: this._classNames.root, ref: this._tooltipHost }, { onFocusCapture: this._onTooltipMouseEnter }, { onBlurCapture: this._hideTooltip }, { onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave, onKeyDown: this._onTooltipKeyDown, "aria-describedby": ariaDescribedBy }),
	            children,
	            showTooltip && (React.createElement(Tooltip_1.Tooltip, tslib_1.__assign({ id: tooltipId, delay: delay, content: content, targetElement: this._getTargetElement(), directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, calloutProps: Utilities_1.assign({}, calloutProps, {
	                    onMouseEnter: this._onTooltipMouseEnter,
	                    onMouseLeave: this._onTooltipMouseLeave
	                }), onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), tooltipProps)))));
	    };
	    TooltipHostBase.prototype.componentWillUnmount = function () {
	        if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip === this) {
	            TooltipHostBase._currentVisibleTooltip = undefined;
	        }
	    };
	    TooltipHostBase.prototype._getTargetElement = function () {
	        if (!this._tooltipHost.current) {
	            return undefined;
	        }
	        var overflowMode = this.props.overflowMode;
	        // Select target element based on overflow mode. For parent mode, you want to position the tooltip relative
	        // to the parent element, otherwise it might look off.
	        if (overflowMode !== undefined) {
	            switch (overflowMode) {
	                case TooltipHost_types_1.TooltipOverflowMode.Parent:
	                    return this._tooltipHost.current.parentElement;
	                case TooltipHost_types_1.TooltipOverflowMode.Self:
	                    return this._tooltipHost.current;
	            }
	        }
	        return this._tooltipHost.current;
	    };
	    TooltipHostBase.prototype._toggleTooltip = function (isTooltipVisible) {
	        var _this = this;
	        if (this.state.isTooltipVisible !== isTooltipVisible) {
	            this.setState({ isTooltipVisible: isTooltipVisible }, function () { return _this.props.onTooltipToggle && _this.props.onTooltipToggle(_this.state.isTooltipVisible); });
	        }
	    };
	    TooltipHostBase.defaultProps = {
	        delay: Tooltip_types_1.TooltipDelay.medium
	    };
	    return TooltipHostBase;
	}(Utilities_1.BaseComponent));
	exports.TooltipHostBase = TooltipHostBase;
	//# sourceMappingURL=TooltipHost.base.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Tooltip}
	 */
	var TooltipOverflowMode;
	(function (TooltipOverflowMode) {
	    /** Only show tooltip if parent DOM element is overflowing */
	    TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
	    /** Only show tooltip if tooltip host's content is overflowing */
	    TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
	})(TooltipOverflowMode = exports.TooltipOverflowMode || (exports.TooltipOverflowMode = {}));
	//# sourceMappingURL=TooltipHost.types.js.map

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-TooltipHost'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                display: 'inline'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=TooltipHost.styles.js.map

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var PersonaCoin_base_1 = __webpack_require__(639);
	var PersonaCoin_styles_1 = __webpack_require__(661);
	/**
	 * PersonaCoin is used to render an individual's avatar and presence.
	 */
	exports.PersonaCoin = Utilities_1.styled(PersonaCoin_base_1.PersonaCoinBase, PersonaCoin_styles_1.getStyles, undefined, {
	    scope: 'PersonaCoin'
	});
	//# sourceMappingURL=PersonaCoin.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	var index_1 = __webpack_require__(640);
	var Icon_1 = __webpack_require__(643);
	var Image_1 = __webpack_require__(658);
	var Persona_types_1 = __webpack_require__(655);
	var PersonaInitialsColor_1 = __webpack_require__(660);
	var PersonaConsts_1 = __webpack_require__(656);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * PersonaCoin with no default styles.
	 * [Use the `getStyles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
	 */
	var PersonaCoinBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PersonaCoinBase, _super);
	    function PersonaCoinBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onRenderCoin = function (props) {
	            var _a = _this.props, coinSize = _a.coinSize, styles = _a.styles, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, imageShouldFadeIn = _a.imageShouldFadeIn, imageShouldStartVisible = _a.imageShouldStartVisible, theme = _a.theme, showUnknownPersonaCoin = _a.showUnknownPersonaCoin;
	            // Render the Image component only if an image URL is provided
	            if (!imageUrl) {
	                return null;
	            }
	            var size = _this.props.size;
	            var classNames = getClassNames(styles, {
	                theme: theme,
	                size: size,
	                showUnknownPersonaCoin: showUnknownPersonaCoin
	            });
	            var dimension = coinSize || PersonaConsts_1.sizeToPixels[size];
	            return (React.createElement(Image_1.Image, { className: classNames.image, imageFit: Image_1.ImageFit.cover, src: imageUrl, width: dimension, height: dimension, alt: imageAlt, shouldFadeIn: imageShouldFadeIn, shouldStartVisible: imageShouldStartVisible, onLoadingStateChange: _this._onPhotoLoadingStateChange }));
	        };
	        _this._onRenderInitials = function (props) {
	            var imageInitials = props.imageInitials;
	            var allowPhoneInitials = props.allowPhoneInitials, showUnknownPersonaCoin = props.showUnknownPersonaCoin;
	            if (showUnknownPersonaCoin) {
	                return React.createElement(Icon_1.Icon, { iconName: "Help" });
	            }
	            var isRTL = Utilities_1.getRTL();
	            imageInitials = imageInitials || Utilities_1.getInitials(_this._getText(), isRTL, allowPhoneInitials);
	            return imageInitials !== '' ? React.createElement("span", null, imageInitials) : React.createElement(Icon_1.Icon, { iconName: "Contact" });
	        };
	        _this._onPhotoLoadingStateChange = function (loadState) {
	            _this.setState({
	                isImageLoaded: loadState === Image_1.ImageLoadState.loaded,
	                isImageError: loadState === Image_1.ImageLoadState.error
	            });
	            _this.props.onPhotoLoadingStateChange && _this.props.onPhotoLoadingStateChange(loadState);
	        };
	        _this._warnDeprecations({ primaryText: 'text' });
	        _this.state = {
	            isImageLoaded: false,
	            isImageError: false
	        };
	        return _this;
	    }
	    PersonaCoinBase.prototype.componentWillReceiveProps = function (nextProps) {
	        if (nextProps.imageUrl !== this.props.imageUrl) {
	            this.setState({
	                isImageLoaded: false,
	                isImageError: false
	            });
	        }
	    };
	    PersonaCoinBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, coinProps = _a.coinProps, showUnknownPersonaCoin = _a.showUnknownPersonaCoin, coinSize = _a.coinSize, styles = _a.styles, imageUrl = _a.imageUrl, isOutOfOffice = _a.isOutOfOffice, _b = _a.onRenderCoin, onRenderCoin = _b === void 0 ? this._onRenderCoin : _b, _c = _a.onRenderInitials, onRenderInitials = _c === void 0 ? this._onRenderInitials : _c, presence = _a.presence, presenceTitle = _a.presenceTitle, showInitialsUntilImageLoads = _a.showInitialsUntilImageLoads, theme = _a.theme;
	        var size = this.props.size;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        var divCoinProps = Utilities_1.getNativeProps(coinProps || {}, Utilities_1.divProperties);
	        var coinSizeStyle = coinSize ? { width: coinSize, height: coinSize } : undefined;
	        var hideImage = showUnknownPersonaCoin;
	        var personaPresenceProps = {
	            coinSize: coinSize,
	            isOutOfOffice: isOutOfOffice,
	            presence: presence,
	            presenceTitle: presenceTitle,
	            size: size,
	            theme: theme
	        };
	        // Use getStyles from props, or fall back to getStyles from styles file.
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: coinProps && coinProps.className ? coinProps.className : className,
	            size: size,
	            coinSize: coinSize,
	            showUnknownPersonaCoin: showUnknownPersonaCoin
	        });
	        var shouldRenderInitials = Boolean(!this.state.isImageLoaded && ((showInitialsUntilImageLoads && imageUrl) || !imageUrl || this.state.isImageError || hideImage));
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: classNames.coin }),
	            size !== Persona_types_1.PersonaSize.size10 && size !== Persona_types_1.PersonaSize.tiny ? (React.createElement("div", tslib_1.__assign({}, divCoinProps, { className: classNames.imageArea, style: coinSizeStyle }),
	                shouldRenderInitials && (React.createElement("div", { className: Styling_1.mergeStyles(classNames.initials, !showUnknownPersonaCoin && { backgroundColor: PersonaInitialsColor_1.getPersonaInitialsColor(this.props) }), style: coinSizeStyle, "aria-hidden": "true" }, onRenderInitials(this.props, this._onRenderInitials))),
	                !hideImage && onRenderCoin(this.props, this._onRenderCoin),
	                React.createElement(index_1.PersonaPresence, tslib_1.__assign({}, personaPresenceProps)))) : // Otherwise, render just PersonaPresence.
	                this.props.presence ? (React.createElement(index_1.PersonaPresence, tslib_1.__assign({}, personaPresenceProps))) : (
	                // Just render Contact Icon if there isn't a Presence prop.
	                React.createElement(Icon_1.Icon, { iconName: "Contact", className: classNames.size10WithoutPresenceIcon })),
	            this.props.children));
	    };
	    /**
	     * Deprecation helper for getting text.
	     */
	    PersonaCoinBase.prototype._getText = function () {
	        return this.props.text || this.props.primaryText || '';
	    };
	    PersonaCoinBase.defaultProps = {
	        size: Persona_types_1.PersonaSize.size48,
	        presence: Persona_types_1.PersonaPresence.none,
	        imageAlt: ''
	    };
	    return PersonaCoinBase;
	}(Utilities_1.BaseComponent));
	exports.PersonaCoinBase = PersonaCoinBase;
	//# sourceMappingURL=PersonaCoin.base.js.map

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(641), exports);
	tslib_1.__exportStar(__webpack_require__(642), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var PersonaPresence_base_1 = __webpack_require__(642);
	var PersonaPresence_styles_1 = __webpack_require__(657);
	/**
	 * PersonaPresence is used to render an individual's presence.
	 */
	exports.PersonaPresence = Utilities_1.styled(PersonaPresence_base_1.PersonaPresenceBase, PersonaPresence_styles_1.getStyles, undefined, { scope: 'PersonaPresence' });
	//# sourceMappingURL=PersonaPresence.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var Persona_types_1 = __webpack_require__(655);
	var PersonaConsts_1 = __webpack_require__(656);
	var coinSizeFontScaleFactor = 6;
	var coinSizePresenceScaleFactor = 3;
	var presenceMaxSize = 40;
	var presenceFontMaxSize = 20;
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * PersonaPresence with no default styles.
	 * [Use the `getStyles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
	 */
	var PersonaPresenceBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PersonaPresenceBase, _super);
	    function PersonaPresenceBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onRenderIcon = function (className, style) { return (React.createElement(Icon_1.Icon, { className: className, iconName: determineIcon(_this.props.presence, _this.props.isOutOfOffice), style: style })); };
	        return _this;
	    }
	    PersonaPresenceBase.prototype.render = function () {
	        var _a = this.props, coinSize = _a.coinSize, isOutOfOffice = _a.isOutOfOffice, styles = _a.styles, // Use getStyles from props.
	        presence = _a.presence, theme = _a.theme, presenceTitle = _a.presenceTitle;
	        var size = PersonaConsts_1.sizeBoolean(this.props.size);
	        // Render Presence Icon if Persona is above size 32.
	        var renderIcon = !(size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) && (coinSize ? coinSize > 32 : true);
	        var presenceHeightWidth = coinSize
	            ? coinSize / coinSizePresenceScaleFactor < presenceMaxSize
	                ? coinSize / coinSizePresenceScaleFactor + 'px'
	                : presenceMaxSize + 'px'
	            : '';
	        var presenceFontSize = coinSize
	            ? coinSize / coinSizeFontScaleFactor < presenceFontMaxSize
	                ? coinSize / coinSizeFontScaleFactor + 'px'
	                : presenceFontMaxSize + 'px'
	            : '';
	        var coinSizeWithPresenceIconStyle = coinSize ? { fontSize: presenceFontSize, lineHeight: presenceHeightWidth } : undefined;
	        var coinSizeWithPresenceStyle = coinSize ? { width: presenceHeightWidth, height: presenceHeightWidth } : undefined;
	        // Use getStyles from props, or fall back to getStyles from styles file.
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            presence: presence,
	            size: this.props.size,
	            isOutOfOffice: isOutOfOffice
	        });
	        if (presence === Persona_types_1.PersonaPresence.none) {
	            return null;
	        }
	        return (React.createElement("div", { className: classNames.presence, style: coinSizeWithPresenceStyle, title: presenceTitle }, renderIcon && this._onRenderIcon(classNames.presenceIcon, coinSizeWithPresenceIconStyle)));
	    };
	    return PersonaPresenceBase;
	}(Utilities_1.BaseComponent));
	exports.PersonaPresenceBase = PersonaPresenceBase;
	function determineIcon(presence, isOutOfOffice) {
	    if (!presence) {
	        return undefined;
	    }
	    var oofIcon = 'SkypeArrow';
	    switch (Persona_types_1.PersonaPresence[presence]) {
	        case 'online':
	            return 'SkypeCheck';
	        case 'away':
	            return isOutOfOffice ? oofIcon : 'SkypeClock';
	        case 'dnd':
	            return 'SkypeMinus';
	        case 'offline':
	            return isOutOfOffice ? oofIcon : '';
	    }
	    return '';
	}
	//# sourceMappingURL=PersonaPresence.base.js.map

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(644), exports);
	//# sourceMappingURL=Icon.js.map

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(645), exports);
	tslib_1.__exportStar(__webpack_require__(646), exports);
	tslib_1.__exportStar(__webpack_require__(647), exports);
	tslib_1.__exportStar(__webpack_require__(652), exports);
	tslib_1.__exportStar(__webpack_require__(654), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Icon_base_1 = __webpack_require__(646);
	var Icon_styles_1 = __webpack_require__(653);
	/**
	 * Icons are used for rendering an individual's avatar, presence and details.
	 * They are used within the PeoplePicker components.
	 */
	exports.Icon = Utilities_1.styled(Icon_base_1.IconBase, Icon_styles_1.getStyles, undefined, {
	    scope: 'Icon'
	}, true);
	//# sourceMappingURL=Icon.js.map

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_types_1 = __webpack_require__(647);
	var Image_1 = __webpack_require__(648);
	var Image_types_1 = __webpack_require__(650);
	var Utilities_1 = __webpack_require__(592);
	var FontIcon_1 = __webpack_require__(652);
	var getClassNames = Utilities_1.classNamesFunction({
	    disableCaching: true
	});
	var IconBase = /** @class */ (function (_super) {
	    tslib_1.__extends(IconBase, _super);
	    function IconBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onImageLoadingStateChange = function (state) {
	            if (_this.props.imageProps && _this.props.imageProps.onLoadingStateChange) {
	                _this.props.imageProps.onLoadingStateChange(state);
	            }
	            if (state === Image_types_1.ImageLoadState.error) {
	                _this.setState({ imageLoadError: true });
	            }
	        };
	        _this.state = {
	            imageLoadError: false
	        };
	        return _this;
	    }
	    IconBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, styles = _a.styles, iconName = _a.iconName, imageErrorAs = _a.imageErrorAs, theme = _a.theme;
	        var isPlaceholder = typeof iconName === 'string' && iconName.length === 0;
	        var isImage = this.props.iconType === Icon_types_1.IconType.image || this.props.iconType === Icon_types_1.IconType.Image || !!this.props.imageProps;
	        var _b = FontIcon_1.getIconContent(iconName), iconClassName = _b.iconClassName, children = _b.children;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            iconClassName: iconClassName,
	            isImage: isImage,
	            isPlaceholder: isPlaceholder
	        });
	        var RootType = isImage ? 'div' : 'i';
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.htmlElementProperties, ['aria-label']);
	        var imageLoadError = this.state.imageLoadError;
	        var imageProps = tslib_1.__assign({}, this.props.imageProps, { onLoadingStateChange: this.onImageLoadingStateChange });
	        var ImageType = (imageLoadError && imageErrorAs) || Image_1.Image;
	        var ariaLabel = this.props.ariaLabel || this.props['aria-label'];
	        var containerProps = ariaLabel
	            ? {
	                'aria-label': ariaLabel
	            }
	            : {
	                role: 'presentation',
	                'aria-hidden': imageProps.alt || imageProps['aria-labelledby'] ? false : true
	            };
	        return (React.createElement(RootType, tslib_1.__assign({ "data-icon-name": iconName }, containerProps, nativeProps, { className: classNames.root }), isImage ? React.createElement(ImageType, tslib_1.__assign({}, imageProps)) : children));
	    };
	    return IconBase;
	}(React.Component));
	exports.IconBase = IconBase;
	//# sourceMappingURL=Icon.base.js.map

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
	 */
	var IconType;
	(function (IconType) {
	    /**
	     * Render using the fabric icon font.
	     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
	     */
	    IconType[IconType["default"] = 0] = "default";
	    /**
	     * Render using an image, where imageProps would be used.
	     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
	     */
	    IconType[IconType["image"] = 1] = "image";
	    /**
	     * Deprecated, use `default`.
	     * @deprecated Use `default`.
	     */
	    IconType[IconType["Default"] = 100000] = "Default";
	    /**
	     * Deprecated, use `image`.
	     * @deprecated Use `image`.
	     */
	    IconType[IconType["Image"] = 100001] = "Image";
	})(IconType = exports.IconType || (exports.IconType = {}));
	//# sourceMappingURL=Icon.types.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Image_base_1 = __webpack_require__(649);
	var Image_styles_1 = __webpack_require__(651);
	exports.Image = Utilities_1.styled(Image_base_1.ImageBase, Image_styles_1.getStyles, undefined, {
	    scope: 'Image'
	}, true);
	//# sourceMappingURL=Image.js.map

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Image_types_1 = __webpack_require__(650);
	var getClassNames = Utilities_1.classNamesFunction();
	var KEY_PREFIX = 'fabricImage';
	var ImageBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ImageBase, _super);
	    function ImageBase(props) {
	        var _this = _super.call(this, props) || this;
	        // Make an initial assumption about the image layout until we can
	        // check the rendered element. The value here only takes effect when
	        // shouldStartVisible is true.
	        _this._coverStyle = Image_types_1.ImageCoverStyle.portrait;
	        _this._imageElement = React.createRef();
	        _this._frameElement = React.createRef();
	        _this._onImageLoaded = function (ev) {
	            var _a = _this.props, src = _a.src, onLoad = _a.onLoad;
	            if (onLoad) {
	                onLoad(ev);
	            }
	            _this._computeCoverStyle(_this.props);
	            if (src) {
	                _this.setState({
	                    loadState: Image_types_1.ImageLoadState.loaded
	                });
	            }
	        };
	        _this._onImageError = function (ev) {
	            if (_this.props.onError) {
	                _this.props.onError(ev);
	            }
	            _this.setState({
	                loadState: Image_types_1.ImageLoadState.error
	            });
	        };
	        _this.state = {
	            loadState: Image_types_1.ImageLoadState.notLoaded
	        };
	        return _this;
	    }
	    ImageBase.prototype.componentWillReceiveProps = function (nextProps) {
	        if (nextProps.src !== this.props.src) {
	            this.setState({
	                loadState: Image_types_1.ImageLoadState.notLoaded
	            });
	        }
	        else if (this.state.loadState === Image_types_1.ImageLoadState.loaded) {
	            this._computeCoverStyle(nextProps);
	        }
	    };
	    ImageBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        this._checkImageLoaded();
	        if (this.props.onLoadingStateChange && prevState.loadState !== this.state.loadState) {
	            this.props.onLoadingStateChange(this.state.loadState);
	        }
	    };
	    ImageBase.prototype.render = function () {
	        var imageProps = Utilities_1.getNativeProps(this.props, Utilities_1.imageProperties, ['width', 'height']);
	        var _a = this.props, src = _a.src, alt = _a.alt, width = _a.width, height = _a.height, shouldFadeIn = _a.shouldFadeIn, shouldStartVisible = _a.shouldStartVisible, className = _a.className, imageFit = _a.imageFit, role = _a.role, maximizeFrame = _a.maximizeFrame, styles = _a.styles, theme = _a.theme;
	        var loadState = this.state.loadState;
	        var coverStyle = this.props.coverStyle !== undefined ? this.props.coverStyle : this._coverStyle;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            width: width,
	            height: height,
	            maximizeFrame: maximizeFrame,
	            shouldFadeIn: shouldFadeIn,
	            shouldStartVisible: shouldStartVisible,
	            isLoaded: loadState === Image_types_1.ImageLoadState.loaded || (loadState === Image_types_1.ImageLoadState.notLoaded && this.props.shouldStartVisible),
	            isLandscape: coverStyle === Image_types_1.ImageCoverStyle.landscape,
	            isCenter: imageFit === Image_types_1.ImageFit.center,
	            isCenterContain: imageFit === Image_types_1.ImageFit.centerContain,
	            isCenterCover: imageFit === Image_types_1.ImageFit.centerCover,
	            isContain: imageFit === Image_types_1.ImageFit.contain,
	            isCover: imageFit === Image_types_1.ImageFit.cover,
	            isNone: imageFit === Image_types_1.ImageFit.none,
	            isError: loadState === Image_types_1.ImageLoadState.error,
	            isNotImageFit: imageFit === undefined
	        });
	        // If image dimensions aren't specified, the natural size of the image is used.
	        return (React.createElement("div", { className: classNames.root, style: { width: width, height: height }, ref: this._frameElement },
	            React.createElement("img", tslib_1.__assign({}, imageProps, { onLoad: this._onImageLoaded, onError: this._onImageError, key: KEY_PREFIX + this.props.src || '', className: classNames.image, ref: this._imageElement, src: src, alt: alt, role: role }))));
	    };
	    ImageBase.prototype._checkImageLoaded = function () {
	        var src = this.props.src;
	        var loadState = this.state.loadState;
	        if (loadState === Image_types_1.ImageLoadState.notLoaded) {
	            // testing if naturalWidth and naturalHeight are greater than zero is better than checking
	            // .complete, because .complete will also be set to true if the image breaks. However,
	            // for some browsers, SVG images do not have a naturalWidth or naturalHeight, so fall back
	            // to checking .complete for these images.
	            var isLoaded = this._imageElement.current
	                ? (src && (this._imageElement.current.naturalWidth > 0 && this._imageElement.current.naturalHeight > 0)) ||
	                    (this._imageElement.current.complete && ImageBase._svgRegex.test(src))
	                : false;
	            if (isLoaded) {
	                this._computeCoverStyle(this.props);
	                this.setState({
	                    loadState: Image_types_1.ImageLoadState.loaded
	                });
	            }
	        }
	    };
	    ImageBase.prototype._computeCoverStyle = function (props) {
	        var imageFit = props.imageFit, width = props.width, height = props.height;
	        // Do not compute cover style if it was already specified in props
	        if ((imageFit === Image_types_1.ImageFit.cover ||
	            imageFit === Image_types_1.ImageFit.contain ||
	            imageFit === Image_types_1.ImageFit.centerContain ||
	            imageFit === Image_types_1.ImageFit.centerCover) &&
	            this.props.coverStyle === undefined &&
	            this._imageElement.current &&
	            this._frameElement.current) {
	            // Determine the desired ratio using the width and height props.
	            // If those props aren't available, measure measure the frame.
	            var desiredRatio = void 0;
	            if (!!width && !!height && imageFit !== Image_types_1.ImageFit.centerContain && imageFit !== Image_types_1.ImageFit.centerCover) {
	                desiredRatio = width / height;
	            }
	            else {
	                desiredRatio = this._frameElement.current.clientWidth / this._frameElement.current.clientHeight;
	            }
	            // Examine the source image to determine its original ratio.
	            var naturalRatio = this._imageElement.current.naturalWidth / this._imageElement.current.naturalHeight;
	            // Should we crop from the top or the sides?
	            if (naturalRatio > desiredRatio) {
	                this._coverStyle = Image_types_1.ImageCoverStyle.landscape;
	            }
	            else {
	                this._coverStyle = Image_types_1.ImageCoverStyle.portrait;
	            }
	        }
	    };
	    ImageBase.defaultProps = {
	        shouldFadeIn: true
	    };
	    ImageBase._svgRegex = /\.svg$/i;
	    return ImageBase;
	}(React.Component));
	exports.ImageBase = ImageBase;
	//# sourceMappingURL=Image.base.js.map

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The possible methods that can be used to fit the image.
	 * {@docCategory Image}
	 */
	var ImageFit;
	(function (ImageFit) {
	    /**
	     * The image is not scaled. The image is centered and cropped within the content box.
	     */
	    ImageFit[ImageFit["center"] = 0] = "center";
	    /**
	     * The image is scaled to maintain its aspect ratio while being fully contained within the frame. The image will
	     * be centered horizontally and vertically within the frame. The space in the top and bottom or in the sides of
	     * the frame will be empty depending on the difference in aspect ratio between the image and the frame.
	     */
	    ImageFit[ImageFit["contain"] = 1] = "contain";
	    /**
	     * The image is scaled to maintain its aspect ratio while filling the frame. Portions of the image will be cropped from
	     * the top and bottom, or from the sides, depending on the difference in aspect ratio between the image and the frame.
	     */
	    ImageFit[ImageFit["cover"] = 2] = "cover";
	    /**
	     * Neither the image nor the frame are scaled. If their sizes do not match, the image will either be cropped or the
	     * frame will have empty space.
	     */
	    ImageFit[ImageFit["none"] = 3] = "none";
	    /**
	     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
	     * behave as ImageFit.center if the image's natural height or width is less than the Image frame's height or width,
	     * but if both natural height and width are larger than the frame it will behave as ImageFit.cover.
	     */
	    ImageFit[ImageFit["centerCover"] = 4] = "centerCover";
	    /**
	     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
	     * behave as ImageFit.center if the image's natural height and width is less than the Image frame's height and width,
	     * but if either natural height or width are larger than the frame it will behave as ImageFit.contain.
	     */
	    ImageFit[ImageFit["centerContain"] = 5] = "centerContain";
	})(ImageFit = exports.ImageFit || (exports.ImageFit = {}));
	/**
	 * The cover style to be used on the image
	 * {@docCategory Image}
	 */
	var ImageCoverStyle;
	(function (ImageCoverStyle) {
	    /**
	     * The image will be shown at 100% height of container and the width will be scaled accordingly
	     */
	    ImageCoverStyle[ImageCoverStyle["landscape"] = 0] = "landscape";
	    /**
	     * The image will be shown at 100% width of container and the height will be scaled accordingly
	     */
	    ImageCoverStyle[ImageCoverStyle["portrait"] = 1] = "portrait";
	})(ImageCoverStyle = exports.ImageCoverStyle || (exports.ImageCoverStyle = {}));
	/**
	 * {@docCategory Image}
	 */
	var ImageLoadState;
	(function (ImageLoadState) {
	    /**
	     * The image has not yet been loaded, and there is no error yet.
	     */
	    ImageLoadState[ImageLoadState["notLoaded"] = 0] = "notLoaded";
	    /**
	     * The image has been loaded successfully.
	     */
	    ImageLoadState[ImageLoadState["loaded"] = 1] = "loaded";
	    /**
	     * An error has been encountered while loading the image.
	     */
	    ImageLoadState[ImageLoadState["error"] = 2] = "error";
	    /**
	     * Deprecated at v1.3.6, to replace the src in case of errors, use `onLoadingStateChange` instead
	     * and rerender the Image with a difference src.
	     * @deprecated Use `onLoadingStateChange` instead
	     * and rerender the Image with a difference src.
	     */
	    ImageLoadState[ImageLoadState["errorLoaded"] = 3] = "errorLoaded";
	})(ImageLoadState = exports.ImageLoadState || (exports.ImageLoadState = {}));
	//# sourceMappingURL=Image.types.js.map

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var GlobalClassNames = {
	    root: 'ms-Image',
	    rootMaximizeFrame: 'ms-Image--maximizeFrame',
	    image: 'ms-Image-image',
	    imageCenter: 'ms-Image-image--center',
	    imageContain: 'ms-Image-image--contain',
	    imageCover: 'ms-Image-image--cover',
	    imageCenterContain: 'ms-Image-image--centerContain',
	    imageCenterCover: 'ms-Image-image--centerCover',
	    imageNone: 'ms-Image-image--none',
	    imageLandscape: 'ms-Image-image--landscape',
	    imagePortrait: 'ms-Image-image--portrait'
	};
	exports.getStyles = function (props) {
	    var className = props.className, width = props.width, height = props.height, maximizeFrame = props.maximizeFrame, isLoaded = props.isLoaded, shouldFadeIn = props.shouldFadeIn, shouldStartVisible = props.shouldStartVisible, isLandscape = props.isLandscape, isCenter = props.isCenter, isContain = props.isContain, isCover = props.isCover, isCenterContain = props.isCenterContain, isCenterCover = props.isCenterCover, isNone = props.isNone, isError = props.isError, isNotImageFit = props.isNotImageFit, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var ImageFitStyles = {
	        position: 'absolute',
	        left: '50% /* @noflip */',
	        top: '50%',
	        transform: 'translate(-50%,-50%)' // @todo test RTL renders transform: translate(50%,-50%);
	    };
	    // Cut the mustard using msMaxTouchPoints to detect IE11 which does not support CSS object-fit
	    var window = Utilities_1.getWindow();
	    var supportsObjectFit = window !== undefined && window.navigator.msMaxTouchPoints === undefined;
	    var fallbackObjectFitStyles = (isContain && isLandscape) || (isCover && !isLandscape) ? { width: '100%', height: 'auto' } : { width: 'auto', height: '100%' };
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                overflow: 'hidden'
	            },
	            maximizeFrame && [
	                classNames.rootMaximizeFrame,
	                {
	                    height: '100%',
	                    width: '100%'
	                }
	            ],
	            isLoaded && shouldFadeIn && !shouldStartVisible && Styling_1.AnimationClassNames.fadeIn400,
	            (isCenter || isContain || isCover || isCenterContain || isCenterCover) && {
	                position: 'relative'
	            },
	            className
	        ],
	        image: [
	            classNames.image,
	            {
	                display: 'block',
	                opacity: 0
	            },
	            isLoaded && [
	                'is-loaded',
	                {
	                    opacity: 1
	                }
	            ],
	            isCenter && [classNames.imageCenter, ImageFitStyles],
	            isContain && [
	                classNames.imageContain,
	                supportsObjectFit && {
	                    width: '100%',
	                    height: '100%',
	                    objectFit: 'contain'
	                },
	                !supportsObjectFit && fallbackObjectFitStyles,
	                ImageFitStyles
	            ],
	            isCover && [
	                classNames.imageCover,
	                supportsObjectFit && {
	                    width: '100%',
	                    height: '100%',
	                    objectFit: 'cover'
	                },
	                !supportsObjectFit && fallbackObjectFitStyles,
	                ImageFitStyles
	            ],
	            isCenterContain && [
	                classNames.imageCenterContain,
	                isLandscape && {
	                    maxWidth: '100%'
	                },
	                !isLandscape && {
	                    maxHeight: '100%'
	                },
	                ImageFitStyles
	            ],
	            isCenterCover && [
	                classNames.imageCenterCover,
	                isLandscape && {
	                    maxHeight: '100%'
	                },
	                !isLandscape && {
	                    maxWidth: '100%'
	                },
	                ImageFitStyles
	            ],
	            isNone && [
	                classNames.imageNone,
	                {
	                    width: 'auto',
	                    height: 'auto'
	                }
	            ],
	            isNotImageFit && [
	                !!width &&
	                    !height && {
	                    height: 'auto',
	                    width: '100%'
	                },
	                !width &&
	                    !!height && {
	                    height: '100%',
	                    width: 'auto'
	                },
	                !!width &&
	                    !!height && {
	                    height: '100%',
	                    width: '100%'
	                }
	            ],
	            isLandscape && classNames.imageLandscape,
	            !isLandscape && classNames.imagePortrait,
	            !isLoaded && 'is-notLoaded',
	            shouldFadeIn && 'is-fadeIn',
	            isError && 'is-error'
	        ]
	    };
	};
	//# sourceMappingURL=Image.styles.js.map

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_styles_1 = __webpack_require__(653);
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	exports.getIconContent = Utilities_1.memoizeFunction(function (iconName) {
	    var iconDefinition = Styling_1.getIcon(iconName) || {
	        subset: {
	            className: undefined
	        },
	        code: undefined
	    };
	    return {
	        children: iconDefinition.code,
	        iconClassName: iconDefinition.subset.className
	    };
	});
	/**
	 * Fast icon component which only supports font glyphs (not images) and isn't themeable.
	 * To style the icon, use `className` or reference `ms-Icon` in CSS.
	 */
	exports.FontIcon = function (props) {
	    var iconName = props.iconName, className = props.className;
	    var _a = exports.getIconContent(iconName), iconClassName = _a.iconClassName, children = _a.children;
	    var nativeProps = Utilities_1.getNativeProps(props, Utilities_1.htmlElementProperties);
	    var containerProps = props['aria-label']
	        ? {}
	        : {
	            role: 'presentation',
	            'aria-hidden': true
	        };
	    return (React.createElement("i", tslib_1.__assign({ "data-icon-name": iconName }, containerProps, nativeProps, { className: Utilities_1.css(Icon_styles_1.MS_ICON, Icon_styles_1.classNames.root, iconClassName, !iconName && Icon_styles_1.classNames.placeholder, className) }), children));
	};
	/**
	 * Memoized helper for rendering a FontIcon.
	 * @param iconName - The name of the icon to use from the icon font.
	 * @param className - Class name for styling the icon.
	 * @param ariaLabel - Label for the icon for the benefit of screen readers.
	 */
	exports.getFontIcon = Utilities_1.memoizeFunction(function (iconName, className, ariaLabel) {
	    return exports.FontIcon({ iconName: iconName, className: className, 'aria-label': ariaLabel });
	});
	//# sourceMappingURL=FontIcon.js.map

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	/** Class names used in themeable and non-themeable Icon components */
	exports.classNames = Styling_1.mergeStyleSets({
	    root: {
	        display: 'inline-block'
	    },
	    placeholder: [
	        'ms-Icon-placeHolder',
	        {
	            width: '1em'
	        }
	    ],
	    image: [
	        'ms-Icon-imageContainer',
	        {
	            overflow: 'hidden'
	        }
	    ]
	});
	/** Class name used only in non-themeable Icon components */
	exports.MS_ICON = 'ms-Icon';
	exports.getStyles = function (props) {
	    var className = props.className, iconClassName = props.iconClassName, isPlaceholder = props.isPlaceholder, isImage = props.isImage, styles = props.styles;
	    return {
	        root: [
	            isPlaceholder && exports.classNames.placeholder,
	            exports.classNames.root,
	            isImage && exports.classNames.image,
	            iconClassName,
	            className,
	            styles && styles.root,
	            styles && styles.imageContainer
	        ]
	    };
	};
	//# sourceMappingURL=Icon.styles.js.map

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Image_1 = __webpack_require__(648);
	var Utilities_1 = __webpack_require__(592);
	var Icon_styles_1 = __webpack_require__(653);
	exports.ImageIcon = function (props) {
	    var className = props.className, imageProps = props.imageProps;
	    var nativeProps = Utilities_1.getNativeProps(props, Utilities_1.htmlElementProperties);
	    var containerProps = props['aria-label']
	        ? {}
	        : {
	            role: 'presentation',
	            'aria-hidden': imageProps.alt || imageProps['aria-labelledby'] ? false : true
	        };
	    return (React.createElement("div", tslib_1.__assign({}, containerProps, nativeProps, { className: Utilities_1.css(Icon_styles_1.MS_ICON, Icon_styles_1.classNames.root, Icon_styles_1.classNames.image, className) }),
	        React.createElement(Image_1.Image, tslib_1.__assign({}, imageProps))));
	};
	//# sourceMappingURL=ImageIcon.js.map

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Persona}
	 */
	var PersonaSize;
	(function (PersonaSize) {
	    /**
	     * tiny size has been deprecated in favor of standardized numeric sizing. Use `size10` instead.
	     * @deprecated Use `size10` instead.
	     */
	    PersonaSize[PersonaSize["tiny"] = 0] = "tiny";
	    /**
	     *
	     * extraExtraSmall size has been deprecated in favor of standardized numeric sizing. Use `size24` instead.
	     * @deprecated Use `size24` instead.
	     */
	    PersonaSize[PersonaSize["extraExtraSmall"] = 1] = "extraExtraSmall";
	    /**
	     * extraSmall size has been deprecated in favor of standardized numeric sizing. Use `size32` instead.
	     * @deprecated Use `size32` instead.
	     */
	    PersonaSize[PersonaSize["extraSmall"] = 2] = "extraSmall";
	    /**
	     * small size has been deprecated in favor of standardized numeric sizing. Use `size40` instead.
	     * @deprecated Use `size40` instead.
	     */
	    PersonaSize[PersonaSize["small"] = 3] = "small";
	    /**
	     * regular size has been deprecated in favor of standardized numeric sizing. Use `size48` instead.
	     * @deprecated Use `size48` instead.
	     */
	    PersonaSize[PersonaSize["regular"] = 4] = "regular";
	    /**
	     * large size has been deprecated in favor of standardized numeric sizing. Use `size72` instead.
	     * @deprecated Use `size72` instead.
	     */
	    PersonaSize[PersonaSize["large"] = 5] = "large";
	    /**
	     * extraLarge size has been deprecated in favor of standardized numeric sizing. Use `size100` instead.
	     * @deprecated Use `size100` instead.
	     */
	    PersonaSize[PersonaSize["extraLarge"] = 6] = "extraLarge";
	    PersonaSize[PersonaSize["size28"] = 7] = "size28";
	    PersonaSize[PersonaSize["size16"] = 8] = "size16";
	    PersonaSize[PersonaSize["size10"] = 9] = "size10";
	    PersonaSize[PersonaSize["size24"] = 10] = "size24";
	    PersonaSize[PersonaSize["size32"] = 11] = "size32";
	    PersonaSize[PersonaSize["size40"] = 12] = "size40";
	    PersonaSize[PersonaSize["size48"] = 13] = "size48";
	    PersonaSize[PersonaSize["size72"] = 14] = "size72";
	    PersonaSize[PersonaSize["size100"] = 15] = "size100";
	})(PersonaSize = exports.PersonaSize || (exports.PersonaSize = {}));
	/**
	 * {@docCategory Persona}
	 */
	var PersonaPresence;
	(function (PersonaPresence) {
	    PersonaPresence[PersonaPresence["none"] = 0] = "none";
	    PersonaPresence[PersonaPresence["offline"] = 1] = "offline";
	    PersonaPresence[PersonaPresence["online"] = 2] = "online";
	    PersonaPresence[PersonaPresence["away"] = 3] = "away";
	    PersonaPresence[PersonaPresence["dnd"] = 4] = "dnd";
	    PersonaPresence[PersonaPresence["blocked"] = 5] = "blocked";
	    PersonaPresence[PersonaPresence["busy"] = 6] = "busy";
	})(PersonaPresence = exports.PersonaPresence || (exports.PersonaPresence = {}));
	/**
	 * {@docCategory Persona}
	 */
	var PersonaInitialsColor;
	(function (PersonaInitialsColor) {
	    PersonaInitialsColor[PersonaInitialsColor["lightBlue"] = 0] = "lightBlue";
	    PersonaInitialsColor[PersonaInitialsColor["blue"] = 1] = "blue";
	    PersonaInitialsColor[PersonaInitialsColor["darkBlue"] = 2] = "darkBlue";
	    PersonaInitialsColor[PersonaInitialsColor["teal"] = 3] = "teal";
	    PersonaInitialsColor[PersonaInitialsColor["lightGreen"] = 4] = "lightGreen";
	    PersonaInitialsColor[PersonaInitialsColor["green"] = 5] = "green";
	    PersonaInitialsColor[PersonaInitialsColor["darkGreen"] = 6] = "darkGreen";
	    PersonaInitialsColor[PersonaInitialsColor["lightPink"] = 7] = "lightPink";
	    PersonaInitialsColor[PersonaInitialsColor["pink"] = 8] = "pink";
	    PersonaInitialsColor[PersonaInitialsColor["magenta"] = 9] = "magenta";
	    PersonaInitialsColor[PersonaInitialsColor["purple"] = 10] = "purple";
	    /**
	     * `black` is a color that can result in offensive persona coins with some initials combinations, so it can only be set with overrides.
	     * @deprecated will be removed in a future major release.
	     */
	    PersonaInitialsColor[PersonaInitialsColor["black"] = 11] = "black";
	    PersonaInitialsColor[PersonaInitialsColor["orange"] = 12] = "orange";
	    /**
	     * `red` is a color that often has a special meaning, so it is considered a reserved color and can only be set with overrides
	     * @deprecated will be removed in a future major release.
	     */
	    PersonaInitialsColor[PersonaInitialsColor["red"] = 13] = "red";
	    PersonaInitialsColor[PersonaInitialsColor["darkRed"] = 14] = "darkRed";
	    /**
	     * Transparent is not intended to be used with typical initials due to accessibility issues.
	     * Its primary use is for overflow buttons, so it is considered a reserved color and can only be set with overrides.
	     */
	    PersonaInitialsColor[PersonaInitialsColor["transparent"] = 15] = "transparent";
	    PersonaInitialsColor[PersonaInitialsColor["violet"] = 16] = "violet";
	    PersonaInitialsColor[PersonaInitialsColor["lightRed"] = 17] = "lightRed";
	    PersonaInitialsColor[PersonaInitialsColor["gold"] = 18] = "gold";
	    PersonaInitialsColor[PersonaInitialsColor["burgundy"] = 19] = "burgundy";
	    PersonaInitialsColor[PersonaInitialsColor["warmGray"] = 20] = "warmGray";
	    PersonaInitialsColor[PersonaInitialsColor["coolGray"] = 21] = "coolGray";
	    /**
	     * `gray` is a color that can result in offensive persona coins with some initials combinations, so it can only be set with overrides
	     */
	    PersonaInitialsColor[PersonaInitialsColor["gray"] = 22] = "gray";
	    PersonaInitialsColor[PersonaInitialsColor["cyan"] = 23] = "cyan";
	    PersonaInitialsColor[PersonaInitialsColor["rust"] = 24] = "rust";
	})(PersonaInitialsColor = exports.PersonaInitialsColor || (exports.PersonaInitialsColor = {}));
	//# sourceMappingURL=Persona.types.js.map

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Persona_types_1 = __webpack_require__(655);
	// Persona Sizes
	var personaSize;
	(function (personaSize) {
	    personaSize.size10 = '20px';
	    personaSize.size16 = '16px';
	    personaSize.size24 = '24px';
	    personaSize.size28 = '28px';
	    personaSize.size32 = '32px';
	    personaSize.size40 = '40px';
	    personaSize.size48 = '48px';
	    personaSize.size72 = '72px';
	    personaSize.size100 = '100px';
	})(personaSize = exports.personaSize || (exports.personaSize = {}));
	// Persona Presence Sizes
	var personaPresenceSize;
	(function (personaPresenceSize) {
	    personaPresenceSize.size6 = '6px';
	    personaPresenceSize.size8 = '8px';
	    personaPresenceSize.size12 = '12px';
	    personaPresenceSize.size20 = '20px';
	    personaPresenceSize.size28 = '28px';
	    /**
	     * @deprecated This is now unused
	     */
	    personaPresenceSize.border = '2px';
	})(personaPresenceSize = exports.personaPresenceSize || (exports.personaPresenceSize = {}));
	exports.sizeBoolean = function (size) { return ({
	    isSize10: size === Persona_types_1.PersonaSize.size10 || size === Persona_types_1.PersonaSize.tiny,
	    isSize16: size === Persona_types_1.PersonaSize.size16,
	    isSize24: size === Persona_types_1.PersonaSize.size24 || size === Persona_types_1.PersonaSize.extraExtraSmall,
	    isSize28: size === Persona_types_1.PersonaSize.size28 || size === Persona_types_1.PersonaSize.extraSmall,
	    isSize32: size === Persona_types_1.PersonaSize.size32,
	    isSize40: size === Persona_types_1.PersonaSize.size40 || size === Persona_types_1.PersonaSize.small,
	    isSize48: size === Persona_types_1.PersonaSize.size48 || size === Persona_types_1.PersonaSize.regular,
	    isSize72: size === Persona_types_1.PersonaSize.size72 || size === Persona_types_1.PersonaSize.large,
	    isSize100: size === Persona_types_1.PersonaSize.size100 || size === Persona_types_1.PersonaSize.extraLarge
	}); };
	exports.sizeToPixels = (_a = {},
	    _a[Persona_types_1.PersonaSize.tiny] = 10,
	    _a[Persona_types_1.PersonaSize.extraExtraSmall] = 24,
	    _a[Persona_types_1.PersonaSize.extraSmall] = 28,
	    _a[Persona_types_1.PersonaSize.small] = 40,
	    _a[Persona_types_1.PersonaSize.regular] = 48,
	    _a[Persona_types_1.PersonaSize.large] = 72,
	    _a[Persona_types_1.PersonaSize.extraLarge] = 100,
	    _a[Persona_types_1.PersonaSize.size10] = 10,
	    _a[Persona_types_1.PersonaSize.size16] = 16,
	    _a[Persona_types_1.PersonaSize.size24] = 24,
	    _a[Persona_types_1.PersonaSize.size28] = 28,
	    _a[Persona_types_1.PersonaSize.size32] = 32,
	    _a[Persona_types_1.PersonaSize.size40] = 40,
	    _a[Persona_types_1.PersonaSize.size48] = 48,
	    _a[Persona_types_1.PersonaSize.size72] = 72,
	    _a[Persona_types_1.PersonaSize.size100] = 100,
	    _a);
	exports.presenceBoolean = function (presence) { return ({
	    isAvailable: presence === Persona_types_1.PersonaPresence.online,
	    isAway: presence === Persona_types_1.PersonaPresence.away,
	    isBlocked: presence === Persona_types_1.PersonaPresence.blocked,
	    isBusy: presence === Persona_types_1.PersonaPresence.busy,
	    isDoNotDisturb: presence === Persona_types_1.PersonaPresence.dnd,
	    isOffline: presence === Persona_types_1.PersonaPresence.offline
	}); };
	var _a;
	//# sourceMappingURL=PersonaConsts.js.map

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var PersonaConsts_1 = __webpack_require__(656);
	var GlobalClassNames = {
	    presence: 'ms-Persona-presence',
	    presenceIcon: 'ms-Persona-presenceIcon'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme;
	    var semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var size = PersonaConsts_1.sizeBoolean(props.size);
	    var presence = PersonaConsts_1.presenceBoolean(props.presence);
	    // Presence colors
	    var presenceColorAvailable = '#7FBA00';
	    var presenceColorAway = '#FCD116';
	    var presenceColorBusy = '#D93B3B';
	    var presenceColorDnd = '#E81123';
	    var presenceColorOffline = '#93ABBD';
	    var presenceColorOof = '#B4009E';
	    var isOpenCirclePresence = presence.isOffline || (props.isOutOfOffice && (presence.isAvailable || presence.isBusy || presence.isAway || presence.isDoNotDisturb));
	    var borderSizeForSmallPersonas = '1px';
	    var borderSizeForLargePersonas = '2px';
	    var borderSize = size.isSize72 || size.isSize100 ? borderSizeForLargePersonas : borderSizeForSmallPersonas;
	    return {
	        presence: [
	            classNames.presence,
	            {
	                position: 'absolute',
	                height: PersonaConsts_1.personaPresenceSize.size12,
	                width: PersonaConsts_1.personaPresenceSize.size12,
	                borderRadius: '50%',
	                top: 'auto',
	                right: '-2px',
	                bottom: '-2px',
	                border: "2px solid " + semanticColors.bodyBackground,
	                textAlign: 'center',
	                boxSizing: 'content-box',
	                backgroundClip: 'content-box',
	                MsHighContrastAdjust: 'none',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Window',
	                        backgroundColor: 'WindowText'
	                    },
	                    _a)
	            },
	            size.isSize10 && {
	                right: 'auto',
	                top: '7px',
	                left: 0,
	                border: 0,
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        top: '9px',
	                        border: '1px solid WindowText'
	                    },
	                    _b)
	            },
	            (size.isSize10 || size.isSize24 || size.isSize28 || size.isSize32) && makeSizeStyle(PersonaConsts_1.personaPresenceSize.size8),
	            (size.isSize40 || size.isSize48) && makeSizeStyle(PersonaConsts_1.personaPresenceSize.size12),
	            size.isSize16 && {
	                height: PersonaConsts_1.personaPresenceSize.size6,
	                width: PersonaConsts_1.personaPresenceSize.size6,
	                borderWidth: '1.5px'
	            },
	            size.isSize72 && makeSizeStyle(PersonaConsts_1.personaPresenceSize.size20),
	            size.isSize100 && makeSizeStyle(PersonaConsts_1.personaPresenceSize.size28),
	            presence.isAvailable && {
	                backgroundColor: presenceColorAvailable,
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = backgroundColor('Highlight'),
	                    _c)
	            },
	            presence.isAway && backgroundColor(presenceColorAway),
	            presence.isBlocked && [
	                {
	                    selectors: (_d = {
	                            // Only show :after at larger sizes
	                            ':after': size.isSize40 || size.isSize48 || size.isSize72 || size.isSize100
	                                ? {
	                                    content: '""',
	                                    width: '100%',
	                                    height: borderSize,
	                                    backgroundColor: presenceColorBusy,
	                                    transform: 'translateY(-50%) rotate(-45deg)',
	                                    position: 'absolute',
	                                    top: '50%',
	                                    left: 0
	                                }
	                                : undefined
	                        },
	                        _d[Styling_1.HighContrastSelector] = {
	                            selectors: {
	                                ':after': {
	                                    width: "calc(100% - 4px)",
	                                    left: '2px',
	                                    backgroundColor: 'Window'
	                                }
	                            }
	                        },
	                        _d)
	                }
	            ],
	            presence.isBusy && backgroundColor(presenceColorBusy),
	            presence.isDoNotDisturb && backgroundColor(presenceColorDnd),
	            presence.isOffline && backgroundColor(presenceColorOffline),
	            (isOpenCirclePresence || presence.isBlocked) && [
	                {
	                    backgroundColor: semanticColors.bodyBackground,
	                    selectors: (_e = {
	                            ':before': {
	                                content: '""',
	                                width: '100%',
	                                height: '100%',
	                                position: 'absolute',
	                                top: 0,
	                                left: 0,
	                                border: borderSize + " solid " + presenceColorBusy,
	                                borderRadius: '50%',
	                                boxSizing: 'border-box'
	                            }
	                        },
	                        _e[Styling_1.HighContrastSelector] = {
	                            backgroundColor: 'WindowText',
	                            selectors: {
	                                ':before': {
	                                    width: "calc(100% - 2px)",
	                                    height: "calc(100% - 2px)",
	                                    top: '1px',
	                                    left: '1px',
	                                    borderColor: 'Window'
	                                }
	                            }
	                        },
	                        _e)
	                }
	            ],
	            isOpenCirclePresence && presence.isAvailable && makeBeforeBorderStyle(borderSize, presenceColorAvailable),
	            isOpenCirclePresence && presence.isBusy && makeBeforeBorderStyle(borderSize, presenceColorBusy),
	            isOpenCirclePresence && presence.isAway && makeBeforeBorderStyle(borderSize, presenceColorOof),
	            isOpenCirclePresence && presence.isDoNotDisturb && makeBeforeBorderStyle(borderSize, presenceColorDnd),
	            isOpenCirclePresence && presence.isOffline && makeBeforeBorderStyle(borderSize, presenceColorOffline),
	            isOpenCirclePresence && presence.isOffline && props.isOutOfOffice && makeBeforeBorderStyle(borderSize, presenceColorOof)
	        ],
	        presenceIcon: [
	            classNames.presenceIcon,
	            {
	                color: semanticColors.bodyBackground,
	                fontSize: '6px',
	                lineHeight: PersonaConsts_1.personaPresenceSize.size12,
	                verticalAlign: 'top',
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        color: 'Window'
	                    },
	                    _f)
	            },
	            size.isSize72 && {
	                fontSize: Styling_1.FontSizes.small,
	                lineHeight: PersonaConsts_1.personaPresenceSize.size20
	            },
	            size.isSize100 && {
	                fontSize: Styling_1.FontSizes.medium,
	                lineHeight: PersonaConsts_1.personaPresenceSize.size28
	            },
	            presence.isAway && {
	                position: 'relative',
	                left: isOpenCirclePresence ? undefined : '1px'
	            },
	            isOpenCirclePresence && presence.isAvailable && makeOpenCircleIconStyle(presenceColorAvailable),
	            isOpenCirclePresence && presence.isBusy && makeOpenCircleIconStyle(presenceColorBusy),
	            isOpenCirclePresence && presence.isAway && makeOpenCircleIconStyle(presenceColorOof),
	            isOpenCirclePresence && presence.isDoNotDisturb && makeOpenCircleIconStyle(presenceColorDnd),
	            isOpenCirclePresence && presence.isOffline && makeOpenCircleIconStyle(presenceColorOffline),
	            isOpenCirclePresence && presence.isOffline && props.isOutOfOffice && makeOpenCircleIconStyle(presenceColorOof)
	        ]
	    };
	    var _a, _b, _c, _d, _e, _f;
	};
	function makeOpenCircleIconStyle(color) {
	    return {
	        color: color,
	        borderColor: color
	    };
	}
	function makeBeforeBorderStyle(borderSize, color) {
	    return {
	        selectors: {
	            ':before': {
	                border: borderSize + " solid " + color
	            }
	        }
	    };
	}
	function makeSizeStyle(size) {
	    return {
	        height: size,
	        width: size
	    };
	}
	function backgroundColor(color) {
	    return { backgroundColor: color };
	}
	//# sourceMappingURL=PersonaPresence.styles.js.map

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(659), exports);
	//# sourceMappingURL=Image.js.map

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(648), exports);
	tslib_1.__exportStar(__webpack_require__(649), exports);
	tslib_1.__exportStar(__webpack_require__(650), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Persona_types_1 = __webpack_require__(655);
	/**
	 * Following colors are considered reserved colors and can only be set with overrides, so they are excluded from this set:
	 * - `gray` and `black` are colors that can result in offensive persona coins with some initials combinations,
	 *   so it can only be set with overrides.
	 * - `red` is a color that often has a special meaning, so it is considered a reserved color and can only be set with overrides.
	 * - `transparent` is not intended to be used with typical initials due to accessibility issues,
	 *   its primary use is for Facepile overflow buttons.
	 */
	var COLOR_SWATCHES_LOOKUP = [
	    Persona_types_1.PersonaInitialsColor.lightBlue,
	    Persona_types_1.PersonaInitialsColor.blue,
	    Persona_types_1.PersonaInitialsColor.darkBlue,
	    Persona_types_1.PersonaInitialsColor.teal,
	    Persona_types_1.PersonaInitialsColor.green,
	    Persona_types_1.PersonaInitialsColor.darkGreen,
	    Persona_types_1.PersonaInitialsColor.lightPink,
	    Persona_types_1.PersonaInitialsColor.pink,
	    Persona_types_1.PersonaInitialsColor.magenta,
	    Persona_types_1.PersonaInitialsColor.purple,
	    Persona_types_1.PersonaInitialsColor.orange,
	    Persona_types_1.PersonaInitialsColor.lightRed,
	    Persona_types_1.PersonaInitialsColor.darkRed,
	    Persona_types_1.PersonaInitialsColor.violet,
	    Persona_types_1.PersonaInitialsColor.gold,
	    Persona_types_1.PersonaInitialsColor.burgundy,
	    Persona_types_1.PersonaInitialsColor.warmGray,
	    Persona_types_1.PersonaInitialsColor.cyan,
	    Persona_types_1.PersonaInitialsColor.rust,
	    Persona_types_1.PersonaInitialsColor.coolGray
	];
	var COLOR_SWATCHES_NUM_ENTRIES = COLOR_SWATCHES_LOOKUP.length;
	function getInitialsColorFromName(displayName) {
	    var color = Persona_types_1.PersonaInitialsColor.blue;
	    if (!displayName) {
	        return color;
	    }
	    var hashCode = 0;
	    for (var iLen = displayName.length - 1; iLen >= 0; iLen--) {
	        var ch = displayName.charCodeAt(iLen);
	        var shift = iLen % 8;
	        // tslint:disable-next-line:no-bitwise
	        hashCode ^= (ch << shift) + (ch >> (8 - shift));
	    }
	    color = COLOR_SWATCHES_LOOKUP[hashCode % COLOR_SWATCHES_NUM_ENTRIES];
	    return color;
	}
	function personaInitialsColorToHexCode(personaInitialsColor) {
	    switch (personaInitialsColor) {
	        case Persona_types_1.PersonaInitialsColor.lightBlue:
	            return '#4F6BED';
	        case Persona_types_1.PersonaInitialsColor.blue:
	            return '#0078D4';
	        case Persona_types_1.PersonaInitialsColor.darkBlue:
	            return '#004E8C';
	        case Persona_types_1.PersonaInitialsColor.teal:
	            return '#038387';
	        case Persona_types_1.PersonaInitialsColor.lightGreen:
	        case Persona_types_1.PersonaInitialsColor.green:
	            return '#498205';
	        case Persona_types_1.PersonaInitialsColor.darkGreen:
	            return '#0B6A0B';
	        case Persona_types_1.PersonaInitialsColor.lightPink:
	            return '#C239B3';
	        case Persona_types_1.PersonaInitialsColor.pink:
	            return '#E3008C';
	        case Persona_types_1.PersonaInitialsColor.magenta:
	            return '#881798';
	        case Persona_types_1.PersonaInitialsColor.purple:
	            return '#5C2E91';
	        case Persona_types_1.PersonaInitialsColor.orange:
	            return '#CA5010';
	        case Persona_types_1.PersonaInitialsColor.red:
	            return '#EE1111';
	        case Persona_types_1.PersonaInitialsColor.lightRed:
	            return '#D13438';
	        case Persona_types_1.PersonaInitialsColor.darkRed:
	            return '#A4262C';
	        case Persona_types_1.PersonaInitialsColor.transparent:
	            return 'transparent';
	        case Persona_types_1.PersonaInitialsColor.violet:
	            return '#8764B8';
	        case Persona_types_1.PersonaInitialsColor.gold:
	            return '#986F0B';
	        case Persona_types_1.PersonaInitialsColor.burgundy:
	            return '#750B1C';
	        case Persona_types_1.PersonaInitialsColor.warmGray:
	            return '#7A7574';
	        case Persona_types_1.PersonaInitialsColor.cyan:
	            return '#005B70';
	        case Persona_types_1.PersonaInitialsColor.rust:
	            return '#8E562E';
	        case Persona_types_1.PersonaInitialsColor.coolGray:
	            return '#69797E';
	        case Persona_types_1.PersonaInitialsColor.black:
	            return '#1D1D1D';
	        case Persona_types_1.PersonaInitialsColor.gray:
	            return '#393939';
	    }
	}
	/** @deprecated Use `getPersonaInitialsColor` */
	function initialsColorPropToColorCode(props) {
	    return getPersonaInitialsColor(props);
	}
	exports.initialsColorPropToColorCode = initialsColorPropToColorCode;
	/**
	 * Gets the hex color string (prefixed with #) for the given persona props.
	 * This is the logic used internally by the Persona control.
	 * @param props - Current persona props
	 * @returns Hex color string prefixed with #
	 */
	function getPersonaInitialsColor(props) {
	    var primaryText = props.primaryText, text = props.text;
	    var initialsColor = props.initialsColor;
	    var initialsColorCode;
	    if (typeof initialsColor === 'string') {
	        initialsColorCode = initialsColor;
	    }
	    else {
	        initialsColor = initialsColor !== undefined ? initialsColor : getInitialsColorFromName(text || primaryText);
	        initialsColorCode = personaInitialsColorToHexCode(initialsColor);
	    }
	    return initialsColorCode;
	}
	exports.getPersonaInitialsColor = getPersonaInitialsColor;
	//# sourceMappingURL=PersonaInitialsColor.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var PersonaConsts_1 = __webpack_require__(656);
	var GlobalClassNames = {
	    coin: 'ms-Persona-coin',
	    imageArea: 'ms-Persona-imageArea',
	    image: 'ms-Persona-image',
	    initials: 'ms-Persona-initials',
	    size10: 'ms-Persona--size10',
	    size16: 'ms-Persona--size16',
	    size24: 'ms-Persona--size24',
	    size28: 'ms-Persona--size28',
	    size32: 'ms-Persona--size32',
	    size40: 'ms-Persona--size40',
	    size48: 'ms-Persona--size48',
	    size72: 'ms-Persona--size72',
	    size100: 'ms-Persona--size100'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, coinSize = props.coinSize;
	    var palette = theme.palette;
	    var size = PersonaConsts_1.sizeBoolean(props.size);
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    // Static colors used when displaying 'unknown persona' coin
	    var unknownPersonaBackgroundColor = 'rgb(234, 234, 234)';
	    var unknownPersonaFontColor = 'rgb(168, 0, 0)';
	    var dimension = coinSize || (props.size && PersonaConsts_1.sizeToPixels[props.size]) || 48;
	    return {
	        coin: [
	            classNames.coin,
	            theme.fonts.medium,
	            size.isSize10 && classNames.size10,
	            size.isSize16 && classNames.size16,
	            size.isSize24 && classNames.size24,
	            size.isSize28 && classNames.size28,
	            size.isSize32 && classNames.size32,
	            size.isSize40 && classNames.size40,
	            size.isSize48 && classNames.size48,
	            size.isSize72 && classNames.size72,
	            size.isSize100 && classNames.size100,
	            className
	        ],
	        size10WithoutPresenceIcon: {
	            fontSize: '10px',
	            position: 'absolute',
	            top: '5px',
	            right: 'auto',
	            left: 0
	        },
	        imageArea: [
	            classNames.imageArea,
	            {
	                position: 'relative',
	                textAlign: 'center',
	                flex: '0 0 auto',
	                height: dimension,
	                width: dimension
	            },
	            dimension <= 10 && {
	                overflow: 'visible',
	                background: 'transparent',
	                height: 0,
	                width: 0
	            }
	        ],
	        image: [
	            classNames.image,
	            {
	                marginRight: '10px',
	                position: 'absolute',
	                top: 0,
	                left: 0,
	                width: '100%',
	                height: '100%',
	                border: 0,
	                borderRadius: '50%',
	                perspective: '1px'
	            },
	            dimension <= 10 && {
	                overflow: 'visible',
	                background: 'transparent',
	                height: 0,
	                width: 0
	            },
	            dimension > 10 && {
	                height: dimension,
	                width: dimension
	            }
	        ],
	        initials: [
	            classNames.initials,
	            {
	                borderRadius: '50%',
	                color: props.showUnknownPersonaCoin ? unknownPersonaFontColor : palette.white,
	                fontSize: Styling_1.FontSizes.large,
	                fontWeight: Styling_1.FontWeights.regular,
	                lineHeight: dimension === 48 ? 46 : dimension,
	                height: dimension,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText',
	                        MsHighContrastAdjust: 'none',
	                        color: 'WindowText',
	                        boxSizing: 'border-box',
	                        backgroundColor: 'Window !important'
	                    },
	                    _a)
	            },
	            props.showUnknownPersonaCoin && {
	                backgroundColor: unknownPersonaBackgroundColor
	            },
	            dimension < 32 && {
	                fontSize: Styling_1.FontSizes.xSmall
	            },
	            dimension >= 32 &&
	                dimension < 48 && {
	                fontSize: Styling_1.FontSizes.medium
	            },
	            dimension >= 72 &&
	                dimension < 100 && {
	                fontSize: Styling_1.FontSizes.xxLarge
	            },
	            dimension >= 100 && {
	                fontSize: Styling_1.FontSizes.superLarge
	            }
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=PersonaCoin.styles.js.map

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var PersonaConsts_1 = __webpack_require__(656);
	var GlobalClassNames = {
	    root: 'ms-Persona',
	    size10: 'ms-Persona--size10',
	    size16: 'ms-Persona--size16',
	    size24: 'ms-Persona--size24',
	    size28: 'ms-Persona--size28',
	    size32: 'ms-Persona--size32',
	    size40: 'ms-Persona--size40',
	    size48: 'ms-Persona--size48',
	    size72: 'ms-Persona--size72',
	    size100: 'ms-Persona--size100',
	    available: 'ms-Persona--online',
	    away: 'ms-Persona--away',
	    blocked: 'ms-Persona--blocked',
	    busy: 'ms-Persona--busy',
	    doNotDisturb: 'ms-Persona--donotdisturb',
	    offline: 'ms-Persona--offline',
	    details: 'ms-Persona-details',
	    primaryText: 'ms-Persona-primaryText',
	    secondaryText: 'ms-Persona-secondaryText',
	    tertiaryText: 'ms-Persona-tertiaryText',
	    optionalText: 'ms-Persona-optionalText',
	    textContent: 'ms-Persona-textContent'
	};
	exports.getStyles = function (props) {
	    var className = props.className, showSecondaryText = props.showSecondaryText, theme = props.theme;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var size = PersonaConsts_1.sizeBoolean(props.size);
	    var presence = PersonaConsts_1.presenceBoolean(props.presence);
	    var showSecondaryTextDefaultHeight = '16px';
	    var sharedTextStyles = {
	        color: palette.neutralSecondary,
	        fontWeight: Styling_1.FontWeights.regular,
	        fontSize: Styling_1.FontSizes.small
	    };
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            Styling_1.normalize,
	            {
	                color: palette.neutralPrimary,
	                fontSize: Styling_1.FontSizes.medium,
	                fontWeight: Styling_1.FontWeights.regular,
	                position: 'relative',
	                height: PersonaConsts_1.personaSize.size48,
	                minWidth: PersonaConsts_1.personaSize.size48,
	                display: 'flex',
	                alignItems: 'center',
	                selectors: {
	                    '.contextualHost': {
	                        display: 'none'
	                    },
	                    ':hover': {
	                        selectors: {
	                            $primaryText: {
	                                color: palette.neutralDark
	                            }
	                        }
	                    }
	                }
	            },
	            size.isSize10 && [
	                classNames.size10,
	                {
	                    height: PersonaConsts_1.personaSize.size10,
	                    minWidth: PersonaConsts_1.personaSize.size10
	                }
	            ],
	            size.isSize16 && [
	                classNames.size16,
	                {
	                    height: PersonaConsts_1.personaSize.size16,
	                    minWidth: PersonaConsts_1.personaSize.size16
	                }
	            ],
	            size.isSize24 && [
	                classNames.size24,
	                {
	                    height: PersonaConsts_1.personaSize.size24,
	                    minWidth: PersonaConsts_1.personaSize.size24
	                }
	            ],
	            size.isSize24 &&
	                showSecondaryText && {
	                height: '36px'
	            },
	            size.isSize28 && [
	                classNames.size28,
	                {
	                    height: PersonaConsts_1.personaSize.size28,
	                    minWidth: PersonaConsts_1.personaSize.size28
	                }
	            ],
	            size.isSize28 &&
	                showSecondaryText && {
	                height: '32px'
	            },
	            size.isSize32 && [
	                classNames.size32,
	                {
	                    height: PersonaConsts_1.personaSize.size32,
	                    minWidth: PersonaConsts_1.personaSize.size32
	                }
	            ],
	            size.isSize40 && [
	                classNames.size40,
	                {
	                    height: PersonaConsts_1.personaSize.size40,
	                    minWidth: PersonaConsts_1.personaSize.size40
	                }
	            ],
	            size.isSize48 && classNames.size48,
	            size.isSize72 && [
	                classNames.size72,
	                {
	                    height: PersonaConsts_1.personaSize.size72,
	                    minWidth: PersonaConsts_1.personaSize.size72
	                }
	            ],
	            size.isSize100 && [
	                classNames.size100,
	                {
	                    height: PersonaConsts_1.personaSize.size100,
	                    minWidth: PersonaConsts_1.personaSize.size100
	                }
	            ],
	            /**
	             * Modifiers: presence
	             */
	            presence.isAvailable && classNames.available,
	            presence.isAway && classNames.away,
	            presence.isBlocked && classNames.blocked,
	            presence.isBusy && classNames.busy,
	            presence.isDoNotDisturb && classNames.doNotDisturb,
	            presence.isOffline && classNames.offline,
	            className
	        ],
	        details: [
	            classNames.details,
	            {
	                padding: '0 24px 0 16px',
	                minWidth: 0,
	                width: '100%',
	                textAlign: 'left',
	                display: 'flex',
	                flexDirection: 'column',
	                justifyContent: 'space-around'
	            },
	            size.isSize10 && {
	                paddingLeft: '17px'
	            },
	            (size.isSize24 || size.isSize28) && {
	                padding: '0 12px'
	            }
	        ],
	        primaryText: [
	            classNames.primaryText,
	            Styling_1.noWrap,
	            {
	                color: palette.neutralPrimary,
	                fontWeight: Styling_1.FontWeights.regular,
	                fontSize: Styling_1.FontSizes.large
	            },
	            showSecondaryText && {
	                height: showSecondaryTextDefaultHeight,
	                lineHeight: showSecondaryTextDefaultHeight,
	                overflowX: 'hidden'
	            },
	            size.isSize10 && {
	                fontSize: Styling_1.FontSizes.small,
	                lineHeight: PersonaConsts_1.personaSize.size10
	            },
	            (size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32 || size.isSize40) && {
	                fontSize: Styling_1.FontSizes.medium
	            },
	            size.isSize16 && {
	                lineHeight: PersonaConsts_1.personaSize.size28
	            },
	            (size.isSize24 || size.isSize28 || size.isSize32 || size.isSize40) &&
	                showSecondaryText && {
	                height: '18px'
	            },
	            size.isSize72 && {
	                fontSize: Styling_1.FontSizes.xLarge
	            },
	            size.isSize100 && {
	                fontSize: Styling_1.FontSizes.xLarge,
	                fontWeight: Styling_1.FontWeights.semilight
	            }
	        ],
	        secondaryText: [
	            classNames.secondaryText,
	            Styling_1.noWrap,
	            sharedTextStyles,
	            (size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) && {
	                display: 'none'
	            },
	            size.isSize24 &&
	                showSecondaryText && {
	                height: '18px'
	            },
	            (size.isSize72 || size.isSize100) && {
	                fontSize: Styling_1.FontSizes.medium
	            },
	            showSecondaryText && {
	                display: 'block',
	                height: showSecondaryTextDefaultHeight,
	                lineHeight: showSecondaryTextDefaultHeight,
	                overflowX: 'hidden'
	            }
	        ],
	        tertiaryText: [
	            classNames.tertiaryText,
	            Styling_1.noWrap,
	            sharedTextStyles,
	            {
	                display: 'none'
	            },
	            (size.isSize72 || size.isSize100) && {
	                display: 'block'
	            }
	        ],
	        optionalText: [
	            classNames.optionalText,
	            Styling_1.noWrap,
	            sharedTextStyles,
	            {
	                display: 'none'
	            },
	            size.isSize100 && {
	                display: 'block'
	            }
	        ],
	        textContent: [classNames.textContent, Styling_1.noWrap]
	    };
	};
	//# sourceMappingURL=Persona.styles.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(638), exports);
	tslib_1.__exportStar(__webpack_require__(639), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(665), exports);
	//# sourceMappingURL=Autofill.js.map

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(666), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var SELECTION_FORWARD = 'forward';
	var SELECTION_BACKWARD = 'backward';
	/**
	 * {@docCategory Autofill}
	 */
	var Autofill = /** @class */ (function (_super) {
	    tslib_1.__extends(Autofill, _super);
	    function Autofill(props) {
	        var _this = _super.call(this, props) || this;
	        _this._inputElement = React.createRef();
	        _this._autoFillEnabled = true;
	        // Composition events are used when the character/text requires several keystrokes to be completed.
	        // Some examples of this are mobile text input and languages like Japanese or Arabic.
	        // Find out more at https://developer.mozilla.org/en-US/docs/Web/Events/compositionstart
	        _this._onCompositionStart = function (ev) {
	            _this._autoFillEnabled = false;
	        };
	        // Composition events are used when the character/text requires several keystrokes to be completed.
	        // Some examples of this are mobile text input and languages like Japanese or Arabic.
	        // Find out more at https://developer.mozilla.org/en-US/docs/Web/Events/compositionstart
	        _this._onCompositionEnd = function (ev) {
	            var inputValue = _this._getCurrentInputValue();
	            _this._tryEnableAutofill(inputValue, _this.value, false, true);
	            // Korean characters typing issue has been addressed in React 16.5
	            // TODO: revert back below lines when we upgrade to React 16.5
	            // Find out at https://github.com/facebook/react/pull/12563/commits/06524c6c542c571705c0fd7df61ac48f3d5ce244
	            var isKorean = ev.nativeEvent.locale === 'ko';
	            // Due to timing, this needs to be async, otherwise no text will be selected.
	            _this._async.setTimeout(function () {
	                // Call getCurrentInputValue here again since there can be a race condition where this value has changed during the async call
	                var updatedInputValue = isKorean ? _this.value : _this._getCurrentInputValue();
	                _this._updateValue(updatedInputValue);
	            }, 0);
	        };
	        _this._onClick = function () {
	            if (_this._value && _this._value !== '' && _this._autoFillEnabled) {
	                _this._autoFillEnabled = false;
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            if (_this.props.onKeyDown) {
	                _this.props.onKeyDown(ev);
	            }
	            // If the event is actively being composed, then don't alert autofill.
	            // Right now typing does not have isComposing, once that has been fixed any should be removed.
	            if (!ev.nativeEvent.isComposing) {
	                switch (ev.which) {
	                    case Utilities_1.KeyCodes.backspace:
	                        _this._autoFillEnabled = false;
	                        break;
	                    case Utilities_1.KeyCodes.left:
	                    case Utilities_1.KeyCodes.right:
	                        if (_this._autoFillEnabled) {
	                            _this._value = _this.state.displayValue;
	                            _this._autoFillEnabled = false;
	                        }
	                        break;
	                    default:
	                        if (!_this._autoFillEnabled) {
	                            if (_this.props.enableAutofillOnKeyPress.indexOf(ev.which) !== -1) {
	                                _this._autoFillEnabled = true;
	                            }
	                        }
	                        break;
	                }
	            }
	        };
	        _this._onInputChanged = function (ev) {
	            var value = _this._getCurrentInputValue(ev);
	            // Right now typing does not have isComposing, once that has been fixed any should be removed.
	            _this._tryEnableAutofill(value, _this._value, ev.nativeEvent.isComposing);
	            _this._updateValue(value);
	        };
	        _this._onChanged = function () {
	            // Swallow this event, we don't care about it
	            // We must provide it because React PropTypes marks it as required, but onInput serves the correct purpose
	            return;
	        };
	        /**
	         * Updates the current input value as well as getting a new display value.
	         * @param newValue - The new value from the input
	         */
	        _this._updateValue = function (newValue) {
	            // Only proceed if the value is nonempty and is different from the old value
	            // This is to work around the fact that, in IE 11, inputs with a placeholder fire an onInput event on focus
	            if (!newValue && newValue === _this._value) {
	                return;
	            }
	            _this._value = _this.props.onInputChange ? _this.props.onInputChange(newValue) : newValue;
	            _this.setState({
	                displayValue: _this._getDisplayValue(_this._value, _this.props.suggestedDisplayValue)
	            }, function () { return _this._notifyInputChange(_this._value); });
	        };
	        _this._value = props.defaultVisibleValue || '';
	        _this.state = {
	            displayValue: props.defaultVisibleValue || ''
	        };
	        return _this;
	    }
	    Object.defineProperty(Autofill.prototype, "cursorLocation", {
	        get: function () {
	            if (this._inputElement.current) {
	                var inputElement = this._inputElement.current;
	                if (inputElement.selectionDirection !== SELECTION_FORWARD) {
	                    return inputElement.selectionEnd;
	                }
	                else {
	                    return inputElement.selectionStart;
	                }
	            }
	            else {
	                return -1;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Autofill.prototype, "isValueSelected", {
	        get: function () {
	            return Boolean(this.inputElement && this.inputElement.selectionStart !== this.inputElement.selectionEnd);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Autofill.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Autofill.prototype, "selectionStart", {
	        get: function () {
	            return this._inputElement.current ? this._inputElement.current.selectionStart : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Autofill.prototype, "selectionEnd", {
	        get: function () {
	            return this._inputElement.current ? this._inputElement.current.selectionEnd : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Autofill.prototype, "inputElement", {
	        get: function () {
	            return this._inputElement.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Autofill.prototype.componentWillReceiveProps = function (nextProps) {
	        var newValue;
	        if (this.props.updateValueInWillReceiveProps) {
	            newValue = this.props.updateValueInWillReceiveProps();
	        }
	        newValue = this._getDisplayValue(newValue ? newValue : this._value, nextProps.suggestedDisplayValue);
	        if (typeof newValue === 'string') {
	            this.setState({ displayValue: newValue });
	        }
	    };
	    Autofill.prototype.componentDidUpdate = function () {
	        var value = this._value;
	        var _a = this.props, suggestedDisplayValue = _a.suggestedDisplayValue, shouldSelectFullInputValueInComponentDidUpdate = _a.shouldSelectFullInputValueInComponentDidUpdate, preventValueSelection = _a.preventValueSelection;
	        var differenceIndex = 0;
	        if (preventValueSelection) {
	            return;
	        }
	        if (this._autoFillEnabled && value && suggestedDisplayValue && this._doesTextStartWith(suggestedDisplayValue, value)) {
	            var shouldSelectFullRange = false;
	            if (shouldSelectFullInputValueInComponentDidUpdate) {
	                shouldSelectFullRange = shouldSelectFullInputValueInComponentDidUpdate();
	            }
	            if (shouldSelectFullRange && this._inputElement.current) {
	                this._inputElement.current.setSelectionRange(0, suggestedDisplayValue.length, SELECTION_BACKWARD);
	            }
	            else {
	                while (differenceIndex < value.length &&
	                    value[differenceIndex].toLocaleLowerCase() === suggestedDisplayValue[differenceIndex].toLocaleLowerCase()) {
	                    differenceIndex++;
	                }
	                if (differenceIndex > 0 && this._inputElement.current) {
	                    this._inputElement.current.setSelectionRange(differenceIndex, suggestedDisplayValue.length, SELECTION_BACKWARD);
	                }
	            }
	        }
	    };
	    Autofill.prototype.render = function () {
	        var displayValue = this.state.displayValue;
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties);
	        return (React.createElement("input", tslib_1.__assign({ autoCapitalize: "off", autoComplete: "off", "aria-autocomplete": 'both' }, nativeProps, { ref: this._inputElement, value: displayValue, onCompositionStart: this._onCompositionStart, onCompositionEnd: this._onCompositionEnd, onChange: this._onChanged, onInput: this._onInputChanged, onKeyDown: this._onKeyDown, onClick: this.props.onClick ? this.props.onClick : this._onClick, "data-lpignore": true })));
	    };
	    Autofill.prototype.focus = function () {
	        this._inputElement.current && this._inputElement.current.focus();
	    };
	    Autofill.prototype.clear = function () {
	        this._autoFillEnabled = true;
	        this._updateValue('');
	        this._inputElement.current && this._inputElement.current.setSelectionRange(0, 0);
	    };
	    Autofill.prototype._getCurrentInputValue = function (ev) {
	        if (ev && ev.target && ev.target.value) {
	            return ev.target.value;
	        }
	        else if (this.inputElement && this.inputElement.value) {
	            return this.inputElement.value;
	        }
	        else {
	            return '';
	        }
	    };
	    /**
	     * Attempts to enable autofill. Whether or not autofill is enabled depends on the input value,
	     * whether or not any text is selected, and only if the new input value is longer than the old input value.
	     * Autofill should never be set to true if the value is composing. Once compositionEnd is called, then
	     * it should be completed.
	     * See https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent for more information on composition.
	     * @param newValue - new input value
	     * @param oldValue - old input value
	     * @param isComposing - if true then the text is actively being composed and it has not completed.
	     * @param isComposed - if the text is a composed text value.
	     */
	    Autofill.prototype._tryEnableAutofill = function (newValue, oldValue, isComposing, isComposed) {
	        if (!isComposing &&
	            newValue &&
	            this._inputElement.current &&
	            this._inputElement.current.selectionStart === newValue.length &&
	            !this._autoFillEnabled &&
	            (newValue.length > oldValue.length || isComposed)) {
	            this._autoFillEnabled = true;
	        }
	    };
	    Autofill.prototype._notifyInputChange = function (newValue) {
	        if (this.props.onInputValueChange) {
	            this.props.onInputValueChange(newValue);
	        }
	    };
	    /**
	     * Returns a string that should be used as the display value.
	     * It evaluates this based on whether or not the suggested value starts with the input value
	     * and whether or not autofill is enabled.
	     * @param inputValue - the value that the input currently has.
	     * @param suggestedDisplayValue - the possible full value
	     */
	    Autofill.prototype._getDisplayValue = function (inputValue, suggestedDisplayValue) {
	        var displayValue = inputValue;
	        if (suggestedDisplayValue && inputValue && this._doesTextStartWith(suggestedDisplayValue, displayValue) && this._autoFillEnabled) {
	            displayValue = suggestedDisplayValue;
	        }
	        return displayValue;
	    };
	    Autofill.prototype._doesTextStartWith = function (text, startWith) {
	        if (!text || !startWith) {
	            return false;
	        }
	        return text.toLocaleLowerCase().indexOf(startWith.toLocaleLowerCase()) === 0;
	    };
	    Autofill.defaultProps = {
	        enableAutofillOnKeyPress: [Utilities_1.KeyCodes.down, Utilities_1.KeyCodes.up]
	    };
	    return Autofill;
	}(Utilities_1.BaseComponent));
	exports.Autofill = Autofill;
	/**
	 *  @deprecated do not use.
	 * {@docCategory Autofill}
	 */
	var BaseAutoFill = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseAutoFill, _super);
	    function BaseAutoFill() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BaseAutoFill;
	}(Autofill));
	exports.BaseAutoFill = BaseAutoFill;
	//# sourceMappingURL=Autofill.js.map

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(668), exports);
	//# sourceMappingURL=Announced.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(669), exports);
	tslib_1.__exportStar(__webpack_require__(670), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Announced_base_1 = __webpack_require__(670);
	var Announced_styles_1 = __webpack_require__(671);
	exports.Announced = Utilities_1.styled(Announced_base_1.AnnouncedBase, Announced_styles_1.getStyles);
	//# sourceMappingURL=Announced.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Announced}
	 */
	var AnnouncedBase = /** @class */ (function (_super) {
	    tslib_1.__extends(AnnouncedBase, _super);
	    function AnnouncedBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnnouncedBase.prototype.render = function () {
	        var _a = this.props, message = _a.message, styles = _a.styles;
	        this._classNames = getClassNames(styles);
	        return (React.createElement("div", tslib_1.__assign({ role: "status" }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties)),
	            React.createElement(Utilities_1.DelayedRender, null,
	                React.createElement("div", { className: this._classNames.screenReaderText }, message))));
	    };
	    AnnouncedBase.defaultProps = {
	        'aria-live': 'assertive'
	    };
	    return AnnouncedBase;
	}(React.Component));
	exports.AnnouncedBase = AnnouncedBase;
	//# sourceMappingURL=Announced.base.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function () {
	    return {
	        screenReaderText: Styling_1.hiddenContentStyle
	    };
	};
	//# sourceMappingURL=Announced.styles.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(673), exports);
	//# sourceMappingURL=Breadcrumb.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(674), exports);
	tslib_1.__exportStar(__webpack_require__(675), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Breadcrumb_base_1 = __webpack_require__(675);
	var Breadcrumb_styles_1 = __webpack_require__(745);
	exports.Breadcrumb = Utilities_1.styled(Breadcrumb_base_1.BreadcrumbBase, Breadcrumb_styles_1.getStyles, undefined, { scope: 'Breadcrumb' });
	//# sourceMappingURL=Breadcrumb.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var Link_1 = __webpack_require__(680);
	var Icon_1 = __webpack_require__(643);
	var Button_1 = __webpack_require__(691);
	var DirectionalHint_1 = __webpack_require__(608);
	var ResizeGroup_1 = __webpack_require__(740);
	var Tooltip_1 = __webpack_require__(598);
	var getClassNames = Utilities_1.classNamesFunction();
	var OVERFLOW_KEY = 'overflow';
	var nullFunction = function () { return null; };
	/**
	 * {@docCategory Breadcrumb}
	 */
	var BreadcrumbBase = /** @class */ (function (_super) {
	    tslib_1.__extends(BreadcrumbBase, _super);
	    function BreadcrumbBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._focusZone = React.createRef();
	        _this._onReduceData = function (data) {
	            var renderedItems = data.renderedItems, renderedOverflowItems = data.renderedOverflowItems;
	            var overflowIndex = data.props.overflowIndex;
	            var movedItem = renderedItems[overflowIndex];
	            renderedItems = renderedItems.slice();
	            renderedItems.splice(overflowIndex, 1);
	            renderedOverflowItems = renderedOverflowItems.concat([movedItem]);
	            if (movedItem !== undefined) {
	                return tslib_1.__assign({}, data, { renderedItems: renderedItems, renderedOverflowItems: renderedOverflowItems });
	            }
	        };
	        _this._onRenderBreadcrumb = function (data) {
	            var _a = data.props, ariaLabel = _a.ariaLabel, _b = _a.dividerAs, DividerType = _b === void 0 ? Icon_1.Icon : _b, _c = _a.onRenderItem, onRenderItem = _c === void 0 ? _this._onRenderItem : _c, overflowAriaLabel = _a.overflowAriaLabel, overflowIndex = _a.overflowIndex, onRenderOverflowIcon = _a.onRenderOverflowIcon;
	            var renderedOverflowItems = data.renderedOverflowItems, renderedItems = data.renderedItems;
	            var contextualItems = renderedOverflowItems.map(function (item, index) { return ({
	                name: item.text,
	                key: item.key,
	                onClick: item.onClick ? _this._onBreadcrumbClicked.bind(_this, item) : null,
	                href: item.href
	            }); });
	            // Find index of last rendered item so the divider icon
	            // knows not to render on that item
	            var lastItemIndex = renderedItems.length - 1;
	            var hasOverflowItems = renderedOverflowItems && renderedOverflowItems.length !== 0;
	            var itemElements = renderedItems.map(function (item, index) { return (React.createElement("li", { className: _this._classNames.listItem, key: item.key || String(index) },
	                onRenderItem(item, _this._onRenderItem),
	                (index !== lastItemIndex || (hasOverflowItems && index === overflowIndex - 1)) && (React.createElement(DividerType, { className: _this._classNames.chevron, iconName: Utilities_1.getRTL() ? 'ChevronLeft' : 'ChevronRight', item: item })))); });
	            if (hasOverflowItems) {
	                var iconProps = !onRenderOverflowIcon ? { iconName: 'More' } : {};
	                var onRenderMenuIcon = onRenderOverflowIcon ? onRenderOverflowIcon : nullFunction;
	                itemElements.splice(overflowIndex, 0, React.createElement("li", { className: _this._classNames.overflow, key: OVERFLOW_KEY },
	                    React.createElement(Button_1.IconButton, { className: _this._classNames.overflowButton, iconProps: iconProps, role: "button", "aria-haspopup": "true", ariaLabel: overflowAriaLabel, onRenderMenuIcon: onRenderMenuIcon, menuProps: {
	                            items: contextualItems,
	                            directionalHint: DirectionalHint_1.DirectionalHint.bottomLeftEdge
	                        } }),
	                    overflowIndex !== lastItemIndex + 1 && (React.createElement(DividerType, { className: _this._classNames.chevron, iconName: Utilities_1.getRTL() ? 'ChevronLeft' : 'ChevronRight', item: renderedOverflowItems[renderedOverflowItems.length - 1] }))));
	            }
	            var nativeProps = Utilities_1.getNativeProps(_this.props, Utilities_1.htmlElementProperties, ['className']);
	            return (React.createElement("div", tslib_1.__assign({ className: _this._classNames.root, role: "navigation", "aria-label": ariaLabel }, nativeProps),
	                React.createElement(FocusZone_1.FocusZone, tslib_1.__assign({ componentRef: _this._focusZone, direction: FocusZone_1.FocusZoneDirection.horizontal }, _this.props.focusZoneProps),
	                    React.createElement("ol", { className: _this._classNames.list }, itemElements))));
	        };
	        _this._onRenderItem = function (item) {
	            if (item.onClick || item.href) {
	                return (React.createElement(Link_1.Link, { className: _this._classNames.itemLink, href: item.href, "aria-current": item.isCurrentItem ? 'page' : undefined, onClick: _this._onBreadcrumbClicked.bind(_this, item) },
	                    React.createElement(Tooltip_1.TooltipHost, tslib_1.__assign({ content: item.text, overflowMode: Tooltip_1.TooltipOverflowMode.Parent }, _this.props.tooltipHostProps), item.text)));
	            }
	            else {
	                return (React.createElement("span", { className: _this._classNames.item },
	                    React.createElement(Tooltip_1.TooltipHost, tslib_1.__assign({ content: item.text, overflowMode: Tooltip_1.TooltipOverflowMode.Parent }, _this.props.tooltipHostProps), item.text)));
	            }
	        };
	        _this._onBreadcrumbClicked = function (item, ev) {
	            if (item.onClick) {
	                item.onClick(ev, item);
	            }
	        };
	        _this._validateProps(props);
	        return _this;
	    }
	    /**
	     * Sets focus to the first breadcrumb link.
	     */
	    BreadcrumbBase.prototype.focus = function () {
	        if (this._focusZone.current) {
	            this._focusZone.current.focus();
	        }
	    };
	    BreadcrumbBase.prototype.render = function () {
	        var _a = this.props, _b = _a.onReduceData, onReduceData = _b === void 0 ? this._onReduceData : _b, overflowIndex = _a.overflowIndex, maxDisplayedItems = _a.maxDisplayedItems, items = _a.items, className = _a.className, theme = _a.theme, styles = _a.styles;
	        var renderedItems = items.slice();
	        var renderedOverflowItems = renderedItems.splice(overflowIndex, renderedItems.length - maxDisplayedItems);
	        var breadcrumbData = {
	            props: this.props,
	            renderedItems: renderedItems,
	            renderedOverflowItems: renderedOverflowItems
	        };
	        this._classNames = getClassNames(styles, {
	            className: className,
	            theme: theme
	        });
	        return React.createElement(ResizeGroup_1.ResizeGroup, { onRenderData: this._onRenderBreadcrumb, onReduceData: onReduceData, data: breadcrumbData });
	    };
	    BreadcrumbBase.prototype.componentWillReceiveProps = function (nextProps) {
	        this._validateProps(nextProps);
	    };
	    /**
	     * Validate incoming props
	     * @param props - Props to validate
	     */
	    BreadcrumbBase.prototype._validateProps = function (props) {
	        var maxDisplayedItems = props.maxDisplayedItems, overflowIndex = props.overflowIndex, items = props.items;
	        if (overflowIndex < 0 ||
	            (maxDisplayedItems > 1 && overflowIndex > maxDisplayedItems - 1) ||
	            (items.length > 0 && overflowIndex > items.length - 1)) {
	            throw new Error('Breadcrumb: overflowIndex out of range');
	        }
	    };
	    BreadcrumbBase.defaultProps = {
	        items: [],
	        maxDisplayedItems: 999,
	        overflowIndex: 0
	    };
	    return BreadcrumbBase;
	}(Utilities_1.BaseComponent));
	exports.BreadcrumbBase = BreadcrumbBase;
	//# sourceMappingURL=Breadcrumb.base.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(677), exports);
	//# sourceMappingURL=FocusZone.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(678), exports);
	tslib_1.__exportStar(__webpack_require__(679), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var FocusZone_types_1 = __webpack_require__(679);
	var Utilities_1 = __webpack_require__(592);
	var merge_styles_1 = __webpack_require__(473);
	var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
	var IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';
	var FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
	var TABINDEX = 'tabindex';
	var NO_VERTICAL_WRAP = 'data-no-vertical-wrap';
	var NO_HORIZONTAL_WRAP = 'data-no-horizontal-wrap';
	var LARGE_DISTANCE_FROM_CENTER = 999999999;
	var LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
	var focusZoneStyles;
	var focusZoneClass = 'ms-FocusZone';
	// Helper function that will return a class for when the root is focused
	function getRootClass() {
	    if (!focusZoneStyles) {
	        focusZoneStyles = merge_styles_1.mergeStyles({
	            selectors: {
	                ':focus': {
	                    outline: 'none',
	                },
	            },
	        }, focusZoneClass);
	    }
	    return focusZoneStyles;
	}
	var _allInstances = {};
	var _outerZones = new Set();
	var ALLOWED_INPUT_TYPES = ['text', 'number', 'password', 'email', 'tel', 'url', 'search'];
	var ALLOW_VIRTUAL_ELEMENTS = false;
	var FocusZone = /** @class */ (function (_super) {
	    tslib_1.__extends(FocusZone, _super);
	    function FocusZone(props) {
	        var _this = _super.call(this, props) || this;
	        _this._disposables = [];
	        _this._root = React.createRef();
	        _this._onFocus = function (ev) {
	            if (_this._portalContainsElement(ev.target)) {
	                // If the event target is inside a portal do not process the event.
	                return;
	            }
	            var _a = _this.props, onActiveElementChanged = _a.onActiveElementChanged, doNotAllowFocusEventToPropagate = _a.doNotAllowFocusEventToPropagate, onFocusNotification = _a.onFocusNotification;
	            var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);
	            var newActiveElement;
	            if (onFocusNotification) {
	                onFocusNotification();
	            }
	            if (isImmediateDescendant) {
	                newActiveElement = ev.target;
	            }
	            else {
	                var parentElement = ev.target;
	                while (parentElement && parentElement !== _this._root.current) {
	                    if (Utilities_1.isElementTabbable(parentElement) && _this._isImmediateDescendantOfZone(parentElement)) {
	                        newActiveElement = parentElement;
	                        break;
	                    }
	                    parentElement = Utilities_1.getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
	                }
	            }
	            var initialElementFocused = !_this._activeElement;
	            // If the new active element is a child of this zone and received focus,
	            // update alignment an immediate descendant
	            if (newActiveElement && newActiveElement !== _this._activeElement) {
	                if (isImmediateDescendant || initialElementFocused) {
	                    _this._setFocusAlignment(newActiveElement, initialElementFocused);
	                }
	                _this._activeElement = newActiveElement;
	                if (initialElementFocused) {
	                    _this._updateTabIndexes();
	                }
	            }
	            if (onActiveElementChanged) {
	                onActiveElementChanged(_this._activeElement, ev);
	            }
	            if (doNotAllowFocusEventToPropagate) {
	                ev.stopPropagation();
	            }
	        };
	        _this._onBlur = function () {
	            _this._setParkedFocus(false);
	        };
	        _this._onMouseDown = function (ev) {
	            if (_this._portalContainsElement(ev.target)) {
	                // If the event target is inside a portal do not process the event.
	                return;
	            }
	            var disabled = _this.props.disabled;
	            if (disabled) {
	                return;
	            }
	            var target = ev.target;
	            var path = [];
	            while (target && target !== _this._root.current) {
	                path.push(target);
	                target = Utilities_1.getParent(target, ALLOW_VIRTUAL_ELEMENTS);
	            }
	            while (path.length) {
	                target = path.pop();
	                if (target && Utilities_1.isElementTabbable(target)) {
	                    _this._setActiveElement(target, true);
	                }
	                if (Utilities_1.isElementFocusZone(target)) {
	                    // Stop here since the focus zone will take care of its own children.
	                    break;
	                }
	            }
	        };
	        /**
	         * Handle the keystrokes.
	         */
	        _this._onKeyDown = function (ev) {
	            if (_this._portalContainsElement(ev.target)) {
	                // If the event target is inside a portal do not process the event.
	                return;
	            }
	            var _a = _this.props, direction = _a.direction, disabled = _a.disabled, isInnerZoneKeystroke = _a.isInnerZoneKeystroke;
	            if (disabled) {
	                return;
	            }
	            if (_this.props.onKeyDown) {
	                _this.props.onKeyDown(ev);
	            }
	            // If the default has been prevented, do not process keyboard events.
	            if (ev.isDefaultPrevented()) {
	                return;
	            }
	            if (document.activeElement === _this._root.current && _this._isInnerZone) {
	                // If this element has focus, it is being controlled by a parent.
	                // Ignore the keystroke.
	                return;
	            }
	            if (isInnerZoneKeystroke && isInnerZoneKeystroke(ev) && _this._isImmediateDescendantOfZone(ev.target)) {
	                // Try to focus
	                var innerZone = _this._getFirstInnerZone();
	                if (innerZone) {
	                    if (!innerZone.focus(true)) {
	                        return;
	                    }
	                }
	                else if (Utilities_1.isElementFocusSubZone(ev.target)) {
	                    if (!_this.focusElement(Utilities_1.getNextElement(ev.target, ev.target.firstChild, true))) {
	                        return;
	                    }
	                }
	                else {
	                    return;
	                }
	            }
	            else if (ev.altKey) {
	                return;
	            }
	            else {
	                switch (ev.which) {
	                    case Utilities_1.KeyCodes.space:
	                        if (_this._tryInvokeClickForFocusable(ev.target)) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.left:
	                        if (direction !== FocusZone_types_1.FocusZoneDirection.vertical && _this._moveFocusLeft()) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.right:
	                        if (direction !== FocusZone_types_1.FocusZoneDirection.vertical && _this._moveFocusRight()) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.up:
	                        if (direction !== FocusZone_types_1.FocusZoneDirection.horizontal && _this._moveFocusUp()) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.down:
	                        if (direction !== FocusZone_types_1.FocusZoneDirection.horizontal && _this._moveFocusDown()) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.pageDown:
	                        if (_this._moveFocusPaging(true)) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.pageUp:
	                        if (_this._moveFocusPaging(false)) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.tab:
	                        if (_this.props.allowTabKey ||
	                            _this.props.handleTabKey === FocusZone_types_1.FocusZoneTabbableElements.all ||
	                            (_this.props.handleTabKey === FocusZone_types_1.FocusZoneTabbableElements.inputOnly && _this._isElementInput(ev.target))) {
	                            var focusChanged = false;
	                            _this._processingTabKey = true;
	                            if (direction === FocusZone_types_1.FocusZoneDirection.vertical ||
	                                !_this._shouldWrapFocus(_this._activeElement, NO_HORIZONTAL_WRAP)) {
	                                focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
	                            }
	                            else if (direction === FocusZone_types_1.FocusZoneDirection.horizontal || direction === FocusZone_types_1.FocusZoneDirection.bidirectional) {
	                                var tabWithDirection = Utilities_1.getRTL() ? !ev.shiftKey : ev.shiftKey;
	                                focusChanged = tabWithDirection ? _this._moveFocusLeft() : _this._moveFocusRight();
	                            }
	                            _this._processingTabKey = false;
	                            if (focusChanged) {
	                                break;
	                            }
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.home:
	                        if (_this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) {
	                            return false;
	                        }
	                        var firstChild = _this._root.current && _this._root.current.firstChild;
	                        if (_this._root.current && firstChild && _this.focusElement(Utilities_1.getNextElement(_this._root.current, firstChild, true))) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.end:
	                        if (_this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) {
	                            return false;
	                        }
	                        var lastChild = _this._root.current && _this._root.current.lastChild;
	                        if (_this._root.current && _this.focusElement(Utilities_1.getPreviousElement(_this._root.current, lastChild, true, true, true))) {
	                            break;
	                        }
	                        return;
	                    case Utilities_1.KeyCodes.enter:
	                        if (_this._tryInvokeClickForFocusable(ev.target)) {
	                            break;
	                        }
	                        return;
	                    default:
	                        return;
	                }
	            }
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._getHorizontalDistanceFromCenter = function (isForward, activeRect, targetRect) {
	            var leftAlignment = _this._focusAlignment.x;
	            // ClientRect values can be floats that differ by very small fractions of a decimal.
	            // If the difference between top and bottom are within a pixel then we should treat
	            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
	            // but without Math.Floor they will be handled incorrectly
	            var targetRectTop = Math.floor(targetRect.top);
	            var activeRectBottom = Math.floor(activeRect.bottom);
	            var targetRectBottom = Math.floor(targetRect.bottom);
	            var activeRectTop = Math.floor(activeRect.top);
	            var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
	            var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;
	            if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
	                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
	                    return 0;
	                }
	                return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
	            }
	            else {
	                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
	                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
	                }
	                return LARGE_DISTANCE_FROM_CENTER;
	            }
	        };
	        // Manage componentRef resolution.
	        Utilities_1.initializeComponentRef(_this);
	        if (false) {
	            Utilities_1.warnDeprecations('FocusZone', props, {
	                rootProps: undefined,
	                allowTabKey: 'handleTabKey',
	                elementType: 'as',
	                ariaDescribedBy: 'aria-describedby',
	                ariaLabelledBy: 'aria-labelledby',
	            });
	        }
	        _this._id = Utilities_1.getId('FocusZone');
	        _this._focusAlignment = {
	            x: 0,
	            y: 0,
	        };
	        _this._processingTabKey = false;
	        return _this;
	    }
	    /** Used for testing purposes only. */
	    FocusZone.getOuterZones = function () {
	        return _outerZones.size;
	    };
	    /**
	     * Handle global tab presses so that we can patch tabindexes on the fly.
	     * HEADS UP: This must not be an arrow function in order to be referentially equal among instances
	     * for ref counting to work correctly!
	     */
	    FocusZone._onKeyDownCapture = function (ev) {
	        if (ev.which === Utilities_1.KeyCodes.tab) {
	            _outerZones.forEach(function (zone) { return zone._updateTabIndexes(); });
	        }
	    };
	    FocusZone.prototype.componentDidMount = function () {
	        var root = this._root.current;
	        _allInstances[this._id] = this;
	        if (root) {
	            var windowElement = root.ownerDocument.defaultView;
	            var parentElement = Utilities_1.getParent(root, ALLOW_VIRTUAL_ELEMENTS);
	            while (parentElement && parentElement !== document.body && parentElement.nodeType === 1) {
	                if (Utilities_1.isElementFocusZone(parentElement)) {
	                    this._isInnerZone = true;
	                    break;
	                }
	                parentElement = Utilities_1.getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
	            }
	            if (!this._isInnerZone) {
	                _outerZones.add(this);
	                if (windowElement && _outerZones.size === 1) {
	                    this._disposables.push(Utilities_1.on(windowElement, 'keydown', FocusZone._onKeyDownCapture, true));
	                }
	            }
	            this._disposables.push(Utilities_1.on(root, 'blur', this._onBlur, true));
	            // Assign initial tab indexes so that we can set initial focus as appropriate.
	            this._updateTabIndexes();
	            if (this.props.defaultActiveElement) {
	                this._activeElement = Utilities_1.getDocument().querySelector(this.props.defaultActiveElement);
	                this.focus();
	            }
	        }
	    };
	    FocusZone.prototype.componentDidUpdate = function () {
	        var root = this._root.current;
	        var doc = Utilities_1.getDocument(root);
	        if (doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === root)) {
	            // The element has been removed after the render, attempt to restore focus.
	            var elementToFocus = Utilities_1.getFocusableByIndexPath(root, this._lastIndexPath);
	            if (elementToFocus) {
	                this._setActiveElement(elementToFocus, true);
	                elementToFocus.focus();
	                this._setParkedFocus(false);
	            }
	            else {
	                // We had a focus path to restore, but now that path is unresolvable. Park focus
	                // on the container until we can try again.
	                this._setParkedFocus(true);
	            }
	        }
	    };
	    FocusZone.prototype.componentWillUnmount = function () {
	        delete _allInstances[this._id];
	        if (!this._isInnerZone) {
	            _outerZones.delete(this);
	        }
	        // Dispose all events.
	        this._disposables.forEach(function (d) { return d(); });
	        // Clear function references so their closures can be garbage-collected.
	        delete this._disposables;
	    };
	    FocusZone.prototype.render = function () {
	        var _a = this.props, rootProps = _a.rootProps, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.htmlElementProperties);
	        var Tag = this.props.as || this.props.elementType || 'div';
	        // Note, right before rendering/reconciling proceeds, we need to record if focus
	        // was in the zone before the update. This helper will track this and, if focus
	        // was actually in the zone, what the index path to the element is at this time.
	        // Then, later in componentDidUpdate, we can evaluate if we need to restore it in
	        // the case the element was removed.
	        this._evaluateFocusBeforeRender();
	        return (React.createElement(Tag, tslib_1.__assign({ role: "presentation", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, divProps, rootProps, { 
	            // Once the getClassName correctly memoizes inputs this should
	            // be replaced so that className is passed to getRootClass and is included there so
	            // the class names will always be in the same order.
	            className: Utilities_1.css(getRootClass(), className), ref: this._root, "data-focuszone-id": this._id, onKeyDown: this._onKeyDown, onFocus: this._onFocus, onMouseDownCapture: this._onMouseDown }), this.props.children));
	    };
	    /**
	     * Sets focus to the first tabbable item in the zone.
	     * @param forceIntoFirstElement - If true, focus will be forced into the first element, even
	     * if focus is already in the focus zone.
	     * @returns True if focus could be set to an active element, false if no operation was taken.
	     */
	    FocusZone.prototype.focus = function (forceIntoFirstElement) {
	        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
	        if (this._root.current) {
	            if (!forceIntoFirstElement && this._root.current.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true' && this._isInnerZone) {
	                var ownerZoneElement = this._getOwnerZone(this._root.current);
	                if (ownerZoneElement !== this._root.current) {
	                    var ownerZone = _allInstances[ownerZoneElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
	                    return !!ownerZone && ownerZone.focusElement(this._root.current);
	                }
	                return false;
	            }
	            else if (!forceIntoFirstElement &&
	                this._activeElement &&
	                Utilities_1.elementContains(this._root.current, this._activeElement) &&
	                Utilities_1.isElementTabbable(this._activeElement)) {
	                this._activeElement.focus();
	                return true;
	            }
	            else {
	                var firstChild = this._root.current.firstChild;
	                return this.focusElement(Utilities_1.getNextElement(this._root.current, firstChild, true));
	            }
	        }
	        return false;
	    };
	    /**
	     * Sets focus to a specific child element within the zone. This can be used in conjunction with
	     * onBeforeFocus to created delayed focus scenarios (like animate the scroll position to the correct
	     * location and then focus.)
	     * @param element - The child element within the zone to focus.
	     * @returns True if focus could be set to an active element, false if no operation was taken.
	     */
	    FocusZone.prototype.focusElement = function (element) {
	        var onBeforeFocus = this.props.onBeforeFocus;
	        if (onBeforeFocus && !onBeforeFocus(element)) {
	            return false;
	        }
	        if (element) {
	            // when we Set focus to a specific child, we should recalculate the alignment depend on its position
	            this._setActiveElement(element);
	            if (this._activeElement) {
	                this._activeElement.focus();
	            }
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Forces horizontal alignment in the context of vertical arrowing to use specific point as the reference, rather than a center based on
	     * the last horizontal motion.
	     * @param point - the new reference point.
	     */
	    FocusZone.prototype.setFocusAlignment = function (point) {
	        this._focusAlignment = point;
	    };
	    FocusZone.prototype._evaluateFocusBeforeRender = function () {
	        var root = this._root.current;
	        var doc = Utilities_1.getDocument(root);
	        if (doc) {
	            var focusedElement = doc.activeElement;
	            // Only update the index path if we are not parked on the root.
	            if (focusedElement !== root) {
	                var shouldRestoreFocus = Utilities_1.elementContains(root, focusedElement, false);
	                this._lastIndexPath = shouldRestoreFocus ? Utilities_1.getElementIndexPath(root, doc.activeElement) : undefined;
	            }
	        }
	    };
	    /**
	     * When focus is in the zone at render time but then all focusable elements are removed,
	     * we "park" focus temporarily on the root. Once we update with focusable children, we restore
	     * focus to the closest path from previous. If the user tabs away from the parked container,
	     * we restore focusability to the pre-parked state.
	     */
	    FocusZone.prototype._setParkedFocus = function (isParked) {
	        var root = this._root.current;
	        if (root && this._isParked !== isParked) {
	            this._isParked = isParked;
	            if (isParked) {
	                if (!this.props.allowFocusRoot) {
	                    this._parkedTabIndex = root.getAttribute('tabindex');
	                    root.setAttribute('tabindex', '-1');
	                }
	                root.focus();
	            }
	            else {
	                if (!this.props.allowFocusRoot) {
	                    if (this._parkedTabIndex) {
	                        root.setAttribute('tabindex', this._parkedTabIndex);
	                        this._parkedTabIndex = undefined;
	                    }
	                    else {
	                        root.removeAttribute('tabindex');
	                    }
	                }
	            }
	        }
	    };
	    FocusZone.prototype._setActiveElement = function (element, forceAlignment) {
	        var previousActiveElement = this._activeElement;
	        this._activeElement = element;
	        if (previousActiveElement) {
	            if (Utilities_1.isElementFocusZone(previousActiveElement)) {
	                this._updateTabIndexes(previousActiveElement);
	            }
	            previousActiveElement.tabIndex = -1;
	        }
	        if (this._activeElement) {
	            if (!this._focusAlignment || forceAlignment) {
	                this._setFocusAlignment(element, true, true);
	            }
	            this._activeElement.tabIndex = 0;
	        }
	    };
	    /**
	     * Walk up the dom try to find a focusable element.
	     */
	    FocusZone.prototype._tryInvokeClickForFocusable = function (target) {
	        if (target === this._root.current) {
	            return false;
	        }
	        do {
	            if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
	                return false;
	            }
	            if (this._isImmediateDescendantOfZone(target) &&
	                target.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true' &&
	                target.getAttribute(IS_ENTER_DISABLED_ATTRIBUTE) !== 'true') {
	                Utilities_1.raiseClick(target);
	                return true;
	            }
	            target = Utilities_1.getParent(target, ALLOW_VIRTUAL_ELEMENTS);
	        } while (target !== this._root.current);
	        return false;
	    };
	    /**
	     * Traverse to find first child zone.
	     */
	    FocusZone.prototype._getFirstInnerZone = function (rootElement) {
	        rootElement = rootElement || this._activeElement || this._root.current;
	        if (!rootElement) {
	            return null;
	        }
	        if (Utilities_1.isElementFocusZone(rootElement)) {
	            return _allInstances[rootElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
	        }
	        var child = rootElement.firstElementChild;
	        while (child) {
	            if (Utilities_1.isElementFocusZone(child)) {
	                return _allInstances[child.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
	            }
	            var match = this._getFirstInnerZone(child);
	            if (match) {
	                return match;
	            }
	            child = child.nextElementSibling;
	        }
	        return null;
	    };
	    FocusZone.prototype._moveFocus = function (isForward, getDistanceFromCenter, ev, useDefaultWrap) {
	        if (useDefaultWrap === void 0) { useDefaultWrap = true; }
	        var element = this._activeElement;
	        var candidateDistance = -1;
	        var candidateElement = undefined;
	        var changedFocus = false;
	        var isBidirectional = this.props.direction === FocusZone_types_1.FocusZoneDirection.bidirectional;
	        if (!element || !this._root.current) {
	            return false;
	        }
	        if (this._isElementInput(element)) {
	            if (!this._shouldInputLoseFocus(element, isForward)) {
	                return false;
	            }
	        }
	        var activeRect = isBidirectional ? element.getBoundingClientRect() : null;
	        do {
	            element = (isForward ? Utilities_1.getNextElement(this._root.current, element) : Utilities_1.getPreviousElement(this._root.current, element));
	            if (isBidirectional) {
	                if (element) {
	                    var targetRect = element.getBoundingClientRect();
	                    var elementDistance = getDistanceFromCenter(activeRect, targetRect);
	                    if (elementDistance === -1 && candidateDistance === -1) {
	                        candidateElement = element;
	                        break;
	                    }
	                    if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
	                        candidateDistance = elementDistance;
	                        candidateElement = element;
	                    }
	                    if (candidateDistance >= 0 && elementDistance < 0) {
	                        break;
	                    }
	                }
	            }
	            else {
	                candidateElement = element;
	                break;
	            }
	        } while (element);
	        // Focus the closest candidate
	        if (candidateElement && candidateElement !== this._activeElement) {
	            changedFocus = true;
	            this.focusElement(candidateElement);
	        }
	        else if (this.props.isCircularNavigation && useDefaultWrap) {
	            if (isForward) {
	                return this.focusElement(Utilities_1.getNextElement(this._root.current, this._root.current.firstElementChild, true));
	            }
	            else {
	                return this.focusElement(Utilities_1.getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
	            }
	        }
	        return changedFocus;
	    };
	    FocusZone.prototype._moveFocusDown = function () {
	        var _this = this;
	        var targetTop = -1;
	        var leftAlignment = this._focusAlignment.x;
	        if (this._moveFocus(true, function (activeRect, targetRect) {
	            var distance = -1;
	            // ClientRect values can be floats that differ by very small fractions of a decimal.
	            // If the difference between top and bottom are within a pixel then we should treat
	            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
	            // but without Math.Floor they will be handled incorrectly.
	            var targetRectTop = Math.floor(targetRect.top);
	            var activeRectBottom = Math.floor(activeRect.bottom);
	            if (targetRectTop < activeRectBottom) {
	                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
	                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
	                }
	                return LARGE_DISTANCE_FROM_CENTER;
	            }
	            if ((targetTop === -1 && targetRectTop >= activeRectBottom) || targetRectTop === targetTop) {
	                targetTop = targetRectTop;
	                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
	                    distance = 0;
	                }
	                else {
	                    distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
	                }
	            }
	            return distance;
	        })) {
	            this._setFocusAlignment(this._activeElement, false, true);
	            return true;
	        }
	        return false;
	    };
	    FocusZone.prototype._moveFocusUp = function () {
	        var _this = this;
	        var targetTop = -1;
	        var leftAlignment = this._focusAlignment.x;
	        if (this._moveFocus(false, function (activeRect, targetRect) {
	            var distance = -1;
	            // ClientRect values can be floats that differ by very small fractions of a decimal.
	            // If the difference between top and bottom are within a pixel then we should treat
	            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
	            // but without Math.Floor they will be handled incorrectly.
	            var targetRectBottom = Math.floor(targetRect.bottom);
	            var targetRectTop = Math.floor(targetRect.top);
	            var activeRectTop = Math.floor(activeRect.top);
	            if (targetRectBottom > activeRectTop) {
	                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
	                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
	                }
	                return LARGE_DISTANCE_FROM_CENTER;
	            }
	            if ((targetTop === -1 && targetRectBottom <= activeRectTop) || targetRectTop === targetTop) {
	                targetTop = targetRectTop;
	                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
	                    distance = 0;
	                }
	                else {
	                    distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
	                }
	            }
	            return distance;
	        })) {
	            this._setFocusAlignment(this._activeElement, false, true);
	            return true;
	        }
	        return false;
	    };
	    FocusZone.prototype._moveFocusLeft = function () {
	        var _this = this;
	        var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
	        if (this._moveFocus(Utilities_1.getRTL(), function (activeRect, targetRect) {
	            var distance = -1;
	            var topBottomComparison;
	            if (Utilities_1.getRTL()) {
	                // When in RTL, this comparison should be the same as the one in _moveFocusRight for LTR.
	                // Going left at a leftmost rectangle will go down a line instead of up a line like in LTR.
	                // This is important, because we want to be comparing the top of the target rect
	                // with the bottom of the active rect.
	                topBottomComparison = targetRect.top.toFixed(3) < activeRect.bottom.toFixed(3);
	            }
	            else {
	                topBottomComparison = targetRect.bottom.toFixed(3) > activeRect.top.toFixed(3);
	            }
	            if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== FocusZone_types_1.FocusZoneDirection.vertical) {
	                distance = activeRect.right - targetRect.right;
	            }
	            else {
	                if (!shouldWrap) {
	                    distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
	                }
	            }
	            return distance;
	        }, undefined /*ev*/, shouldWrap)) {
	            this._setFocusAlignment(this._activeElement, true, false);
	            return true;
	        }
	        return false;
	    };
	    FocusZone.prototype._moveFocusRight = function () {
	        var _this = this;
	        var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
	        if (this._moveFocus(!Utilities_1.getRTL(), function (activeRect, targetRect) {
	            var distance = -1;
	            var topBottomComparison;
	            if (Utilities_1.getRTL()) {
	                // When in RTL, this comparison should be the same as the one in _moveFocusLeft for LTR.
	                // Going right at a rightmost rectangle will go up a line instead of down a line like in LTR.
	                // This is important, because we want to be comparing the bottom of the target rect
	                // with the top of the active rect.
	                topBottomComparison = targetRect.bottom.toFixed(3) > activeRect.top.toFixed(3);
	            }
	            else {
	                topBottomComparison = targetRect.top.toFixed(3) < activeRect.bottom.toFixed(3);
	            }
	            if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== FocusZone_types_1.FocusZoneDirection.vertical) {
	                distance = targetRect.left - activeRect.left;
	            }
	            else if (!shouldWrap) {
	                distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
	            }
	            return distance;
	        }, undefined /*ev*/, shouldWrap)) {
	            this._setFocusAlignment(this._activeElement, true, false);
	            return true;
	        }
	        return false;
	    };
	    FocusZone.prototype._moveFocusPaging = function (isForward, useDefaultWrap) {
	        if (useDefaultWrap === void 0) { useDefaultWrap = true; }
	        if (useDefaultWrap === void 0) {
	            useDefaultWrap = true;
	        }
	        var element = this._activeElement;
	        if (!element || !this._root.current) {
	            return false;
	        }
	        if (this._isElementInput(element)) {
	            if (!this._shouldInputLoseFocus(element, isForward)) {
	                return false;
	            }
	        }
	        var scrollableParent = Utilities_1.findScrollableParent(element);
	        if (!scrollableParent) {
	            return false;
	        }
	        var candidateDistance = -1;
	        var candidateElement = undefined;
	        var targetTop = -1;
	        var targetBottom = -1;
	        var pagesize = scrollableParent.clientHeight;
	        var activeRect = element.getBoundingClientRect();
	        do {
	            element = isForward ? Utilities_1.getNextElement(this._root.current, element) : Utilities_1.getPreviousElement(this._root.current, element);
	            if (element) {
	                var targetRect = element.getBoundingClientRect();
	                var targetRectTop = Math.floor(targetRect.top);
	                var activeRectBottom = Math.floor(activeRect.bottom);
	                var targetRectBottom = Math.floor(targetRect.bottom);
	                var activeRectTop = Math.floor(activeRect.top);
	                var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);
	                var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
	                var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;
	                if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) {
	                    break;
	                }
	                if (elementDistance > -1) {
	                    // for paging down
	                    if (isForward && targetRectTop > targetTop) {
	                        targetTop = targetRectTop;
	                        candidateDistance = elementDistance;
	                        candidateElement = element;
	                    }
	                    else if (!isForward && targetRectBottom < targetBottom) {
	                        // for paging up
	                        targetBottom = targetRectBottom;
	                        candidateDistance = elementDistance;
	                        candidateElement = element;
	                    }
	                    else {
	                        if (candidateDistance === -1 || elementDistance <= candidateDistance) {
	                            candidateDistance = elementDistance;
	                            candidateElement = element;
	                        }
	                    }
	                }
	            }
	        } while (element);
	        var changedFocus = false;
	        // Focus the closest candidate
	        if (candidateElement && candidateElement !== this._activeElement) {
	            changedFocus = true;
	            this.focusElement(candidateElement);
	            this._setFocusAlignment(candidateElement, false, true);
	        }
	        else if (this.props.isCircularNavigation && useDefaultWrap) {
	            if (isForward) {
	                return this.focusElement(Utilities_1.getNextElement(this._root.current, this._root.current.firstElementChild, true));
	            }
	            return this.focusElement(Utilities_1.getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
	        }
	        return changedFocus;
	    };
	    FocusZone.prototype._setFocusAlignment = function (element, isHorizontal, isVertical) {
	        if (this.props.direction === FocusZone_types_1.FocusZoneDirection.bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
	            var rect = element.getBoundingClientRect();
	            var left = rect.left + rect.width / 2;
	            var top_1 = rect.top + rect.height / 2;
	            if (!this._focusAlignment) {
	                this._focusAlignment = {
	                    x: left,
	                    y: top_1,
	                };
	            }
	            if (isHorizontal) {
	                this._focusAlignment.x = left;
	            }
	            if (isVertical) {
	                this._focusAlignment.y = top_1;
	            }
	        }
	    };
	    FocusZone.prototype._isImmediateDescendantOfZone = function (element) {
	        return this._getOwnerZone(element) === this._root.current;
	    };
	    FocusZone.prototype._getOwnerZone = function (element) {
	        var parentElement = Utilities_1.getParent(element, ALLOW_VIRTUAL_ELEMENTS);
	        while (parentElement && parentElement !== this._root.current && parentElement !== document.body) {
	            if (Utilities_1.isElementFocusZone(parentElement)) {
	                return parentElement;
	            }
	            parentElement = Utilities_1.getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
	        }
	        return parentElement;
	    };
	    FocusZone.prototype._updateTabIndexes = function (element) {
	        if (!element && this._root.current) {
	            this._defaultFocusElement = null;
	            element = this._root.current;
	            if (this._activeElement && !Utilities_1.elementContains(element, this._activeElement)) {
	                this._activeElement = null;
	            }
	        }
	        // If active element changes state to disabled, set it to null.
	        // Otherwise, we lose keyboard accessibility to other elements in focus zone.
	        if (this._activeElement && !Utilities_1.isElementTabbable(this._activeElement)) {
	            this._activeElement = null;
	        }
	        var childNodes = element && element.children;
	        for (var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++) {
	            var child = childNodes[childIndex];
	            if (!Utilities_1.isElementFocusZone(child)) {
	                // If the item is explicitly set to not be focusable then TABINDEX needs to be set to -1.
	                if (child.getAttribute && child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'false') {
	                    child.setAttribute(TABINDEX, '-1');
	                }
	                if (Utilities_1.isElementTabbable(child)) {
	                    if (this.props.disabled) {
	                        child.setAttribute(TABINDEX, '-1');
	                    }
	                    else if (!this._isInnerZone && ((!this._activeElement && !this._defaultFocusElement) || this._activeElement === child)) {
	                        this._defaultFocusElement = child;
	                        if (child.getAttribute(TABINDEX) !== '0') {
	                            child.setAttribute(TABINDEX, '0');
	                        }
	                    }
	                    else if (child.getAttribute(TABINDEX) !== '-1') {
	                        child.setAttribute(TABINDEX, '-1');
	                    }
	                }
	                else if (child.tagName === 'svg' && child.getAttribute('focusable') !== 'false') {
	                    // Disgusting IE hack. Sad face.
	                    child.setAttribute('focusable', 'false');
	                }
	            }
	            else if (child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true') {
	                if (!this._isInnerZone && ((!this._activeElement && !this._defaultFocusElement) || this._activeElement === child)) {
	                    this._defaultFocusElement = child;
	                    if (child.getAttribute(TABINDEX) !== '0') {
	                        child.setAttribute(TABINDEX, '0');
	                    }
	                }
	                else if (child.getAttribute(TABINDEX) !== '-1') {
	                    child.setAttribute(TABINDEX, '-1');
	                }
	            }
	            this._updateTabIndexes(child);
	        }
	    };
	    FocusZone.prototype._isElementInput = function (element) {
	        if (element && element.tagName && (element.tagName.toLowerCase() === 'input' || element.tagName.toLowerCase() === 'textarea')) {
	            return true;
	        }
	        return false;
	    };
	    FocusZone.prototype._shouldInputLoseFocus = function (element, isForward) {
	        // If a tab was used, we want to focus on the next element.
	        if (!this._processingTabKey && element && element.type && ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
	            var selectionStart = element.selectionStart;
	            var selectionEnd = element.selectionEnd;
	            var isRangeSelected = selectionStart !== selectionEnd;
	            var inputValue = element.value;
	            // We shouldn't lose focus in the following cases:
	            // 1. There is range selected.
	            // 2. When selection start is larger than 0 and it is backward.
	            // 3. when selection start is not the end of length and it is forward.
	            // 4. We press any of the arrow keys when our handleTabKey isn't none or undefined (only losing focus if we hit tab)
	            // and if shouldInputLoseFocusOnArrowKey is defined, if scenario prefers to not loose the focus which is determined by calling the
	            // callback shouldInputLoseFocusOnArrowKey
	            if (isRangeSelected ||
	                (selectionStart > 0 && !isForward) ||
	                (selectionStart !== inputValue.length && isForward) ||
	                (!!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element)))) {
	                return false;
	            }
	        }
	        return true;
	    };
	    FocusZone.prototype._shouldWrapFocus = function (element, noWrapDataAttribute) {
	        return !!this.props.checkForNoWrap ? Utilities_1.shouldWrapFocus(element, noWrapDataAttribute) : true;
	    };
	    /**
	     * Returns true if the element is a descendant of the FocusZone through a React portal.
	     */
	    FocusZone.prototype._portalContainsElement = function (element) {
	        return element && !!this._root.current && Utilities_1.portalContainsElement(element, this._root.current);
	    };
	    FocusZone.defaultProps = {
	        isCircularNavigation: false,
	        direction: FocusZone_types_1.FocusZoneDirection.bidirectional,
	    };
	    return FocusZone;
	}(React.Component));
	exports.FocusZone = FocusZone;
	//# sourceMappingURL=FocusZone.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory FocusZone}
	 */
	exports.FocusZoneTabbableElements = {
	    /** Tabbing is not allowed */
	    none: 0,
	    /** All tabbing action is allowed */
	    all: 1,
	    /** Tabbing is allowed only on input elements */
	    inputOnly: 2
	};
	/**
	 * {@docCategory FocusZone}
	 */
	var FocusZoneDirection;
	(function (FocusZoneDirection) {
	    /** Only react to up/down arrows. */
	    FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
	    /** Only react to left/right arrows. */
	    FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
	    /** React to all arrows. */
	    FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
	})(FocusZoneDirection = exports.FocusZoneDirection || (exports.FocusZoneDirection = {}));
	//# sourceMappingURL=FocusZone.types.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(681), exports);
	//# sourceMappingURL=Link.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(682), exports);
	tslib_1.__exportStar(__webpack_require__(683), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Link_base_1 = __webpack_require__(683);
	var Link_styles_1 = __webpack_require__(690);
	exports.Link = Utilities_1.styled(Link_base_1.LinkBase, Link_styles_1.getStyles, undefined, {
	    scope: 'Link'
	});
	//# sourceMappingURL=Link.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var KeytipData_1 = __webpack_require__(684);
	var getClassNames = Utilities_1.classNamesFunction();
	var LinkBase = /** @class */ (function (_super) {
	    tslib_1.__extends(LinkBase, _super);
	    function LinkBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._link = React.createRef();
	        _this._onClick = function (ev) {
	            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
	            if (disabled) {
	                ev.preventDefault();
	            }
	            else if (onClick) {
	                onClick(ev);
	            }
	        };
	        return _this;
	    }
	    LinkBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, disabled = _a.disabled, children = _a.children, className = _a.className, href = _a.href, theme = _a.theme, styles = _a.styles, keytipProps = _a.keytipProps;
	        var classNames = getClassNames(styles, {
	            className: className,
	            isButton: !href,
	            isDisabled: disabled,
	            theme: theme
	        });
	        var RootType = this._getRootType(this.props);
	        return (React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, ariaDescribedBy: this.props['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (React.createElement(RootType, tslib_1.__assign({}, keytipAttributes, _this._adjustPropsForRootType(RootType, _this.props), { className: classNames.root, onClick: _this._onClick, ref: _this._link, "aria-disabled": disabled }), children)); }));
	    };
	    LinkBase.prototype.focus = function () {
	        var current = this._link.current;
	        if (current && current.focus) {
	            current.focus();
	        }
	    };
	    LinkBase.prototype._adjustPropsForRootType = function (RootType, props) {
	        // Deconstruct the props so we remove props like `as`, `theme` and `styles`
	        // as those will always be removed. We also take some props that are optional
	        // based on the RootType.
	        var children = props.children, as = props.as, disabled = props.disabled, target = props.target, href = props.href, theme = props.theme, getStyles = props.getStyles, styles = props.styles, componentRef = props.componentRef, restProps = tslib_1.__rest(props, ["children", "as", "disabled", "target", "href", "theme", "getStyles", "styles", "componentRef"]);
	        // RootType will be a string if we're dealing with an html component
	        if (typeof RootType === 'string') {
	            // Remove the disabled prop for anchor elements
	            if (RootType === 'a') {
	                return tslib_1.__assign({ target: target, href: disabled ? undefined : href }, restProps);
	            }
	            // Add the type='button' prop for button elements
	            if (RootType === 'button') {
	                return tslib_1.__assign({ type: 'button', disabled: disabled }, restProps);
	            }
	            // Remove the target and href props for all other non anchor elements
	            return tslib_1.__assign({}, restProps, { disabled: disabled });
	        }
	        // Retain all props except 'as' for ReactComponents
	        return tslib_1.__assign({ target: target, href: href, disabled: disabled }, restProps);
	    };
	    LinkBase.prototype._getRootType = function (props) {
	        if (props.as) {
	            return props.as;
	        }
	        if (props.href) {
	            return 'a';
	        }
	        return 'button';
	    };
	    return LinkBase;
	}(Utilities_1.BaseComponent));
	exports.LinkBase = LinkBase;
	//# sourceMappingURL=Link.base.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(685), exports);
	//# sourceMappingURL=KeytipData.js.map

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(686), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var KeytipManager_1 = __webpack_require__(687);
	var KeytipUtils_1 = __webpack_require__(689);
	/**
	 * A small element to help the target component correctly read out its aria-describedby for its Keytip
	 * {@docCategory Keytips}
	 */
	var KeytipData = /** @class */ (function (_super) {
	    tslib_1.__extends(KeytipData, _super);
	    function KeytipData() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._keytipManager = KeytipManager_1.KeytipManager.getInstance();
	        return _this;
	    }
	    KeytipData.prototype.componentDidMount = function () {
	        // Register Keytip in KeytipManager
	        if (this.props.keytipProps) {
	            this._uniqueId = this._keytipManager.register(this._getKtpProps());
	        }
	    };
	    KeytipData.prototype.componentWillUnmount = function () {
	        // Unregister Keytip in KeytipManager
	        this.props.keytipProps && this._keytipManager.unregister(this._getKtpProps(), this._uniqueId);
	    };
	    KeytipData.prototype.componentDidUpdate = function () {
	        // Update Keytip in KeytipManager
	        this.props.keytipProps && this._keytipManager.update(this._getKtpProps(), this._uniqueId);
	    };
	    KeytipData.prototype.render = function () {
	        var _a = this.props, children = _a.children, keytipProps = _a.keytipProps, ariaDescribedBy = _a.ariaDescribedBy;
	        var nativeKeytipProps = {};
	        if (keytipProps) {
	            nativeKeytipProps = this._getKtpAttrs(keytipProps, ariaDescribedBy);
	        }
	        return children(nativeKeytipProps);
	    };
	    KeytipData.prototype._getKtpProps = function () {
	        return tslib_1.__assign({ disabled: this.props.disabled }, this.props.keytipProps);
	    };
	    /**
	     * Gets the aria- and data- attributes to attach to the component
	     * @param keytipProps - props for Keytip
	     * @param describedByPrepend - ariaDescribedBy value to prepend
	     */
	    KeytipData.prototype._getKtpAttrs = function (keytipProps, describedByPrepend) {
	        if (keytipProps) {
	            // Add the parent overflow sequence if necessary
	            var newKeytipProps = this._keytipManager.addParentOverflow(keytipProps);
	            // Construct aria-describedby and data-ktp-id attributes and return
	            var ariaDescribedBy = KeytipUtils_1.getAriaDescribedBy(newKeytipProps.keySequences);
	            var keySequences = newKeytipProps.keySequences.slice();
	            if (newKeytipProps.overflowSetSequence) {
	                keySequences = KeytipUtils_1.mergeOverflows(keySequences, newKeytipProps.overflowSetSequence);
	            }
	            var ktpId = KeytipUtils_1.sequencesToID(keySequences);
	            return {
	                'aria-describedby': Utilities_1.mergeAriaAttributeValues(describedByPrepend, ariaDescribedBy),
	                'data-ktp-target': ktpId,
	                'data-ktp-execute-target': ktpId
	            };
	        }
	        return undefined;
	    };
	    return KeytipData;
	}(React.Component));
	exports.KeytipData = KeytipData;
	//# sourceMappingURL=KeytipData.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Utilities_1 = __webpack_require__(592);
	var KeytipConstants_1 = __webpack_require__(688);
	/**
	 * This class is responsible for handling registering, updating, and unregistering of keytips
	 */
	var KeytipManager = /** @class */ (function () {
	    function KeytipManager() {
	        this.keytips = [];
	        this.persistedKeytips = [];
	        // This is (and should be) updated and kept in sync
	        // with the inKeytipMode in KeytipLayer.
	        this.inKeytipMode = false;
	        // Boolean that gets checked before entering keytip mode by the KeytipLayer
	        // Used for an override in special cases (e.g. Disable entering keytip mode when a modal is shown)
	        this.shouldEnterKeytipMode = true;
	    }
	    /**
	     * Static function to get singleton KeytipManager instance
	     *
	     * @returns {KeytipManager} Singleton KeytipManager instance
	     */
	    KeytipManager.getInstance = function () {
	        return this._instance;
	    };
	    /**
	     * Registers a keytip
	     *
	     * @param keytipProps - Keytip to register
	     * @param persisted - T/F if this keytip should be persisted, default is false
	     * @returns {string} Unique ID for this keytip
	     */
	    KeytipManager.prototype.register = function (keytipProps, persisted) {
	        if (persisted === void 0) { persisted = false; }
	        var props = keytipProps;
	        if (!persisted) {
	            // Add the overflowSetSequence if necessary
	            props = this.addParentOverflow(keytipProps);
	        }
	        // Create a unique keytip
	        var uniqueKeytip = this._getUniqueKtp(props);
	        // Add to array
	        persisted ? this.persistedKeytips.push(uniqueKeytip) : this.keytips.push(uniqueKeytip);
	        var event = persisted ? KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_ADDED : KeytipConstants_1.KeytipEvents.KEYTIP_ADDED;
	        Utilities_1.EventGroup.raise(this, event, {
	            keytip: props,
	            uniqueID: uniqueKeytip.uniqueID
	        });
	        return uniqueKeytip.uniqueID;
	    };
	    /**
	     * Update a keytip
	     *
	     * @param keytipProps - Keytip to update
	     * @param uniqueID - Unique ID of this keytip
	     */
	    KeytipManager.prototype.update = function (keytipProps, uniqueID) {
	        var newKeytipProps = this.addParentOverflow(keytipProps);
	        var uniqueKeytip = this._getUniqueKtp(newKeytipProps, uniqueID);
	        var keytipIndex = Utilities_1.findIndex(this.keytips, function (ktp) {
	            return ktp.uniqueID === uniqueID;
	        });
	        if (keytipIndex >= 0) {
	            // Update everything except 'visible'
	            uniqueKeytip.keytip.visible = this.keytips[keytipIndex].keytip.visible;
	            // Update keytip in this.keytips
	            this.keytips = Utilities_1.replaceElement(this.keytips, uniqueKeytip, keytipIndex);
	            // Raise event
	            Utilities_1.EventGroup.raise(this, KeytipConstants_1.KeytipEvents.KEYTIP_UPDATED, {
	                keytip: uniqueKeytip.keytip,
	                uniqueID: uniqueKeytip.uniqueID
	            });
	        }
	    };
	    /**
	     * Unregisters a keytip
	     *
	     * @param keytipToRemove - IKeytipProps of the keytip to remove
	     * @param uniqueID - Unique ID of this keytip
	     * @param persisted - T/F if this keytip should be persisted, default is false
	     */
	    KeytipManager.prototype.unregister = function (keytipToRemove, uniqueID, persisted) {
	        if (persisted === void 0) { persisted = false; }
	        if (persisted) {
	            // Remove keytip from this.persistedKeytips
	            this.persistedKeytips = this.persistedKeytips.filter(function (uniqueKtp) {
	                return uniqueKtp.uniqueID !== uniqueID;
	            });
	        }
	        else {
	            // Remove keytip from this.keytips
	            this.keytips = this.keytips.filter(function (uniqueKtp) {
	                return uniqueKtp.uniqueID !== uniqueID;
	            });
	        }
	        var event = persisted ? KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_REMOVED : KeytipConstants_1.KeytipEvents.KEYTIP_REMOVED;
	        Utilities_1.EventGroup.raise(this, event, {
	            keytip: keytipToRemove,
	            uniqueID: uniqueID
	        });
	    };
	    /**
	     * Manual call to enter keytip mode
	     */
	    KeytipManager.prototype.enterKeytipMode = function () {
	        Utilities_1.EventGroup.raise(this, KeytipConstants_1.KeytipEvents.ENTER_KEYTIP_MODE);
	    };
	    /**
	     * Manual call to exit keytip mode
	     */
	    KeytipManager.prototype.exitKeytipMode = function () {
	        Utilities_1.EventGroup.raise(this, KeytipConstants_1.KeytipEvents.EXIT_KEYTIP_MODE);
	    };
	    /**
	     * Gets all IKeytipProps from this.keytips
	     *
	     * @returns {IKeytipProps[]} All keytips stored in the manager
	     */
	    KeytipManager.prototype.getKeytips = function () {
	        return this.keytips.map(function (uniqueKeytip) {
	            return uniqueKeytip.keytip;
	        });
	    };
	    /**
	     * Adds the overflowSetSequence to the keytipProps if its parent keytip also has it
	     *
	     * @param keytipProps - Keytip props to add overflowSetSequence to if necessary
	     * @returns {IKeytipProps} - Modified keytip props, if needed to be modified
	     */
	    KeytipManager.prototype.addParentOverflow = function (keytipProps) {
	        var fullSequence = keytipProps.keySequences.slice();
	        fullSequence.pop();
	        if (fullSequence.length !== 0) {
	            var parentKeytip = Utilities_1.find(this.getKeytips(), function (keytip) {
	                return Utilities_1.arraysEqual(fullSequence, keytip.keySequences);
	            });
	            if (parentKeytip && parentKeytip.overflowSetSequence) {
	                return tslib_1.__assign({}, keytipProps, { overflowSetSequence: parentKeytip.overflowSetSequence });
	            }
	        }
	        return keytipProps;
	    };
	    /**
	     * Public function to bind for overflow items that have a submenu
	     *
	     * @param overflowButtonSequences
	     * @param keytipSequences
	     */
	    KeytipManager.prototype.menuExecute = function (overflowButtonSequences, keytipSequences) {
	        Utilities_1.EventGroup.raise(this, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_EXECUTE, {
	            overflowButtonSequences: overflowButtonSequences,
	            keytipSequences: keytipSequences
	        });
	    };
	    /**
	     * Creates an IUniqueKeytip object
	     *
	     * @param keytipProps - IKeytipProps
	     * @param uniqueID - Unique ID, will default to the next unique ID if not passed
	     * @returns {IUniqueKeytip} IUniqueKeytip object
	     */
	    KeytipManager.prototype._getUniqueKtp = function (keytipProps, uniqueID) {
	        if (uniqueID === void 0) { uniqueID = Utilities_1.getId(); }
	        return { keytip: tslib_1.__assign({}, keytipProps), uniqueID: uniqueID };
	    };
	    KeytipManager._instance = new KeytipManager();
	    return KeytipManager;
	}());
	exports.KeytipManager = KeytipManager;
	//# sourceMappingURL=KeytipManager.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.KTP_PREFIX = 'ktp';
	exports.KTP_SEPARATOR = '-';
	exports.KTP_FULL_PREFIX = exports.KTP_PREFIX + exports.KTP_SEPARATOR;
	exports.DATAKTP_TARGET = 'data-ktp-target';
	exports.DATAKTP_EXECUTE_TARGET = 'data-ktp-execute-target';
	exports.KTP_LAYER_ID = 'ktp-layer-id';
	exports.KTP_ARIA_SEPARATOR = ', ';
	// Events
	var KeytipEvents;
	(function (KeytipEvents) {
	    KeytipEvents.KEYTIP_ADDED = 'keytipAdded';
	    KeytipEvents.KEYTIP_REMOVED = 'keytipRemoved';
	    KeytipEvents.KEYTIP_UPDATED = 'keytipUpdated';
	    KeytipEvents.PERSISTED_KEYTIP_ADDED = 'persistedKeytipAdded';
	    KeytipEvents.PERSISTED_KEYTIP_REMOVED = 'persistedKeytipRemoved';
	    KeytipEvents.PERSISTED_KEYTIP_EXECUTE = 'persistedKeytipExecute';
	    KeytipEvents.ENTER_KEYTIP_MODE = 'enterKeytipMode';
	    KeytipEvents.EXIT_KEYTIP_MODE = 'exitKeytipMode';
	})(KeytipEvents = exports.KeytipEvents || (exports.KeytipEvents = {}));
	//# sourceMappingURL=KeytipConstants.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KeytipConstants_1 = __webpack_require__(688);
	var Utilities_1 = __webpack_require__(592);
	/**
	 * Converts a whole set of KeySequences into one keytip ID, which will be the ID for the last keytip sequence specified
	 * keySequences should not include the initial keytip 'start' sequence.
	 *
	 * @param keySequences - Full path of IKeySequences for one keytip.
	 * @returns {string} String to use for the keytip ID.
	 */
	function sequencesToID(keySequences) {
	    return keySequences.reduce(function (prevValue, keySequence) {
	        return prevValue + KeytipConstants_1.KTP_SEPARATOR + keySequence.split('').join(KeytipConstants_1.KTP_SEPARATOR);
	    }, KeytipConstants_1.KTP_PREFIX);
	}
	exports.sequencesToID = sequencesToID;
	/**
	 * Merges an overflow sequence with a key sequence.
	 *
	 * @param keySequences - Full sequence for one keytip.
	 * @param overflowKeySequences - Full overflow keytip sequence.
	 * @returns {string[]} Sequence that will be used by the keytip when in the overflow.
	 */
	function mergeOverflows(keySequences, overflowKeySequences) {
	    var overflowSequenceLen = overflowKeySequences.length;
	    var overflowSequence = overflowKeySequences.slice().pop();
	    var newKeySequences = keySequences.slice();
	    return Utilities_1.addElementAtIndex(newKeySequences, overflowSequenceLen - 1, overflowSequence);
	}
	exports.mergeOverflows = mergeOverflows;
	/**
	 * Constructs the data-ktp-target attribute selector from a full key sequence.
	 *
	 * @param keySequences - Full string[] for a Keytip.
	 * @returns {string} String selector to use to query for the keytip target.
	 */
	function ktpTargetFromSequences(keySequences) {
	    return '[' + KeytipConstants_1.DATAKTP_TARGET + '="' + sequencesToID(keySequences) + '"]';
	}
	exports.ktpTargetFromSequences = ktpTargetFromSequences;
	/**
	 * Constructs the data-ktp-execute-target attribute selector from a keytip ID.
	 *
	 * @param keytipId - ID of the Keytip.
	 * @returns {string} String selector to use to query for the keytip execute target.
	 */
	function ktpTargetFromId(keytipId) {
	    return '[' + KeytipConstants_1.DATAKTP_EXECUTE_TARGET + '="' + keytipId + '"]';
	}
	exports.ktpTargetFromId = ktpTargetFromId;
	/**
	 * Gets the aria-describedby value to put on the component with this keytip.
	 *
	 * @param keySequences - KeySequences of the keytip.
	 * @returns {string} The aria-describedby value to set on the component with this keytip.
	 */
	function getAriaDescribedBy(keySequences) {
	    var describedby = ' ' + KeytipConstants_1.KTP_LAYER_ID;
	    if (!keySequences.length) {
	        // Return just the layer ID
	        return describedby;
	    }
	    return describedby + ' ' + sequencesToID(keySequences);
	}
	exports.getAriaDescribedBy = getAriaDescribedBy;
	//# sourceMappingURL=KeytipUtils.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Link'
	};
	exports.getStyles = function (props) {
	    var className = props.className, isButton = props.isButton, isDisabled = props.isDisabled, theme = props.theme;
	    var semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                color: semanticColors.link,
	                outline: 'none',
	                fontSize: 'inherit',
	                fontWeight: 'inherit',
	                selectors: (_a = {
	                        '.ms-Fabric--isFocusVisible &:focus': {
	                            // Can't use getFocusStyle because it doesn't support wrapping links
	                            // https://github.com/OfficeDev/office-ui-fabric-react/issues/4883#issuecomment-406743543
	                            // A box-shadow allows the focus rect to wrap links that span multiple lines
	                            // and helps the focus rect avoid getting clipped.
	                            boxShadow: "0 0 0 1px " + theme.palette.neutralSecondary + " inset",
	                            selectors: (_b = {},
	                                _b[Styling_1.HighContrastSelector] = {
	                                    outline: '1px solid WindowText'
	                                },
	                                _b)
	                        }
	                    },
	                    _a[Styling_1.HighContrastSelector] = {
	                        // For IE high contrast mode
	                        borderBottom: 'none'
	                    },
	                    _a)
	            },
	            isButton && {
	                background: 'none',
	                backgroundColor: 'transparent',
	                border: 'none',
	                cursor: 'pointer',
	                display: 'inline',
	                margin: 0,
	                overflow: 'inherit',
	                padding: 0,
	                textAlign: 'left',
	                textOverflow: 'inherit',
	                userSelect: 'text',
	                borderBottom: '1px solid transparent',
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelectorBlack] = {
	                        color: '#FFFF00'
	                    },
	                    _c[Styling_1.HighContrastSelectorWhite] = {
	                        color: '#00009F'
	                    },
	                    _c)
	            },
	            !isButton && {
	                textDecoration: 'none'
	            },
	            isDisabled && [
	                'is-disabled',
	                {
	                    color: semanticColors.disabledText,
	                    cursor: 'default'
	                },
	                {
	                    selectors: {
	                        '&:link, &:visited': {
	                            pointerEvents: 'none'
	                        }
	                    }
	                }
	            ],
	            !isDisabled && {
	                selectors: {
	                    '&:active, &:hover, &:active:hover': {
	                        color: semanticColors.linkHovered,
	                        selectors: (_d = {},
	                            _d[Styling_1.HighContrastSelector] = {
	                                textDecoration: 'underline'
	                            },
	                            _d)
	                    },
	                    '&:focus': {
	                        color: semanticColors.link
	                    }
	                }
	            },
	            classNames.root,
	            className
	        ]
	    };
	    var _a, _b, _c, _d;
	};
	//# sourceMappingURL=Link.styles.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(692), exports);
	//# sourceMappingURL=Button.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(693), exports);
	tslib_1.__exportStar(__webpack_require__(721), exports);
	tslib_1.__exportStar(__webpack_require__(722), exports);
	tslib_1.__exportStar(__webpack_require__(728), exports);
	tslib_1.__exportStar(__webpack_require__(735), exports);
	tslib_1.__exportStar(__webpack_require__(737), exports);
	tslib_1.__exportStar(__webpack_require__(730), exports);
	tslib_1.__exportStar(__webpack_require__(723), exports);
	tslib_1.__exportStar(__webpack_require__(738), exports);
	tslib_1.__exportStar(__webpack_require__(734), exports);
	tslib_1.__exportStar(__webpack_require__(732), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var DirectionalHint_1 = __webpack_require__(608);
	var ContextualMenu_1 = __webpack_require__(694);
	var BaseButton_classNames_1 = __webpack_require__(719);
	var SplitButton_classNames_1 = __webpack_require__(720);
	var KeytipData_1 = __webpack_require__(684);
	var TouchIdleDelay = 500; /* ms */
	/**
	 * {@docCategory Button}
	 */
	var BaseButton = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseButton, _super);
	    function BaseButton(props, rootClassName) {
	        var _this = _super.call(this, props) || this;
	        _this._buttonElement = React.createRef();
	        _this._splitButtonContainer = React.createRef();
	        _this._renderedPersistentMenu = false;
	        _this._onRenderIcon = function (buttonProps, defaultRender) {
	            var iconProps = _this.props.iconProps;
	            if (iconProps && (iconProps.iconName !== undefined || iconProps.imageProps)) {
	                var className = iconProps.className, rest = tslib_1.__rest(iconProps, ["className"]);
	                return React.createElement(Icon_1.Icon, tslib_1.__assign({ className: Utilities_1.css(_this._classNames.icon, className) }, rest));
	            }
	            return null;
	        };
	        _this._onRenderTextContents = function () {
	            var _a = _this.props, text = _a.text, children = _a.children, _b = _a.secondaryText, secondaryText = _b === void 0 ? _this.props.description : _b, _c = _a.onRenderText, onRenderText = _c === void 0 ? _this._onRenderText : _c, _d = _a.onRenderDescription, onRenderDescription = _d === void 0 ? _this._onRenderDescription : _d;
	            if (text || typeof children === 'string' || secondaryText) {
	                return (React.createElement("div", { className: _this._classNames.textContainer },
	                    onRenderText(_this.props, _this._onRenderText),
	                    onRenderDescription(_this.props, _this._onRenderDescription)));
	            }
	            return [onRenderText(_this.props, _this._onRenderText), onRenderDescription(_this.props, _this._onRenderDescription)];
	        };
	        _this._onRenderText = function () {
	            var text = _this.props.text;
	            var children = _this.props.children;
	            // For backwards compat, we should continue to take in the text content from children.
	            if (text === undefined && typeof children === 'string') {
	                text = children;
	            }
	            if (_this._hasText()) {
	                return (React.createElement("div", { key: _this._labelId, className: _this._classNames.label, id: _this._labelId }, text));
	            }
	            return null;
	        };
	        _this._onRenderChildren = function () {
	            var children = _this.props.children;
	            // If children is just a string, either it or the text will be rendered via onRenderLabel
	            // If children is another component, it will be rendered after text
	            if (typeof children === 'string') {
	                return null;
	            }
	            return children;
	        };
	        _this._onRenderDescription = function (props) {
	            var _a = props.secondaryText, secondaryText = _a === void 0 ? _this.props.description : _a;
	            // ms-Button-description is only shown when the button type is compound.
	            // In other cases it will not be displayed.
	            return secondaryText ? (React.createElement("div", { key: _this._descriptionId, className: _this._classNames.description, id: _this._descriptionId }, secondaryText)) : null;
	        };
	        _this._onRenderAriaDescription = function () {
	            var ariaDescription = _this.props.ariaDescription;
	            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
	            // otherwise it will be assigned to descriptionSpan.
	            return ariaDescription ? (React.createElement("span", { className: _this._classNames.screenReaderText, id: _this._ariaDescriptionId }, ariaDescription)) : null;
	        };
	        _this._onRenderMenuIcon = function (props) {
	            var menuIconProps = _this.props.menuIconProps;
	            return React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: "ChevronDown" }, menuIconProps, { className: _this._classNames.menuIcon }));
	        };
	        _this._onRenderMenu = function (menuProps) {
	            var _a = menuProps.onDismiss, onDismiss = _a === void 0 ? _this._dismissMenu : _a;
	            var MenuType = _this.props.menuAs || ContextualMenu_1.ContextualMenu;
	            // the accessible menu label (accessible name) has a relationship to the button.
	            // If the menu props do not specify an explicit value for aria-label or aria-labelledBy,
	            // AND the button has text, we'll set the menu aria-labelledBy to the text element id.
	            if (!menuProps.ariaLabel && !menuProps.labelElementId && _this._hasText()) {
	                menuProps = tslib_1.__assign({}, menuProps, { labelElementId: _this._labelId });
	            }
	            return (React.createElement(MenuType, tslib_1.__assign({ id: _this._labelId + '-menu', directionalHint: DirectionalHint_1.DirectionalHint.bottomLeftEdge }, menuProps, { shouldFocusOnContainer: _this.state.menuProps ? _this.state.menuProps.shouldFocusOnContainer : undefined, shouldFocusOnMount: _this.state.menuProps ? _this.state.menuProps.shouldFocusOnMount : undefined, hidden: _this.state.menuProps ? _this.state.menuProps.hidden : undefined, className: Utilities_1.css('ms-BaseButton-menuhost', menuProps.className), target: _this._isSplitButton ? _this._splitButtonContainer.current : _this._buttonElement.current, onDismiss: onDismiss })));
	        };
	        _this._dismissMenu = function () {
	            var menuProps = null;
	            if (_this.props.persistMenu && _this.state.menuProps) {
	                // Create a new object to trigger componentDidUpdate
	                menuProps = tslib_1.__assign({}, _this.state.menuProps, { hidden: true });
	            }
	            _this.setState({ menuProps: menuProps });
	        };
	        _this._openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
	            if (shouldFocusOnMount === void 0) { shouldFocusOnMount = true; }
	            if (_this.props.menuProps) {
	                var menuProps = tslib_1.__assign({}, _this.props.menuProps, { shouldFocusOnContainer: shouldFocusOnContainer, shouldFocusOnMount: shouldFocusOnMount });
	                if (_this.props.persistMenu) {
	                    _this._renderedPersistentMenu = true;
	                    menuProps.hidden = false;
	                }
	                _this.setState({ menuProps: menuProps });
	            }
	        };
	        _this._onToggleMenu = function (shouldFocusOnContainer) {
	            var currentMenuProps = _this.state.menuProps;
	            var shouldFocusOnMount = true;
	            if (_this.props.menuProps && _this.props.menuProps.shouldFocusOnMount === false) {
	                shouldFocusOnMount = false;
	            }
	            if (_this.props.persistMenu) {
	                // _renderedPersistentMenu ensures that the first rendering of
	                // the menu happens on-screen, as edge's scrollbar calcuations are off if done while hidden.
	                !_this._renderedPersistentMenu || (currentMenuProps && currentMenuProps.hidden)
	                    ? _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount)
	                    : _this._dismissMenu();
	            }
	            else {
	                currentMenuProps ? _this._dismissMenu() : _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
	            }
	        };
	        _this._onSplitContainerFocusCapture = function (ev) {
	            var container = _this._splitButtonContainer.current;
	            // If the target is coming from the portal we do not need to set focus on the container.
	            if (!container || (ev.target && Utilities_1.portalContainsElement(ev.target, container))) {
	                return;
	            }
	            // We should never be able to focus the individual buttons in a split button. Focus
	            // should always remain on the container.
	            container.focus();
	        };
	        _this._onSplitButtonPrimaryClick = function (ev) {
	            if (_this._isExpanded) {
	                _this._dismissMenu();
	            }
	            if (!_this._processingTouch && _this.props.onClick) {
	                _this.props.onClick(ev);
	            }
	            else if (_this._processingTouch) {
	                _this._onMenuClick(ev);
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            // explicity cancelling event so click won't fire after this
	            if (_this.props.disabled && (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space)) {
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	            else if (!_this.props.disabled) {
	                if (_this.props.menuProps) {
	                    _this._onMenuKeyDown(ev);
	                }
	                else if (_this.props.onKeyDown !== undefined) {
	                    _this.props.onKeyDown(ev); // not cancelling event because it's not disabled
	                }
	            }
	        };
	        _this._onKeyUp = function (ev) {
	            if (!_this.props.disabled && _this.props.onKeyUp !== undefined) {
	                _this.props.onKeyUp(ev); // not cancelling event because it's not disabled
	            }
	        };
	        _this._onKeyPress = function (ev) {
	            if (!_this.props.disabled && _this.props.onKeyPress !== undefined) {
	                _this.props.onKeyPress(ev); // not cancelling event because it's not disabled
	            }
	        };
	        _this._onMouseUp = function (ev) {
	            if (!_this.props.disabled && _this.props.onMouseUp !== undefined) {
	                _this.props.onMouseUp(ev); // not cancelling event because it's not disabled
	            }
	        };
	        _this._onMouseDown = function (ev) {
	            if (!_this.props.disabled && _this.props.onMouseDown !== undefined) {
	                _this.props.onMouseDown(ev); // not cancelling event because it's not disabled
	            }
	        };
	        _this._onClick = function (ev) {
	            if (!_this.props.disabled) {
	                if (_this.props.menuProps) {
	                    _this._onMenuClick(ev);
	                }
	                else if (_this.props.onClick !== undefined) {
	                    _this.props.onClick(ev); // not cancelling event because it's not disabled
	                }
	            }
	        };
	        _this._onSplitButtonContainerKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                if (_this._buttonElement.current) {
	                    _this._buttonElement.current.click();
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	            else {
	                _this._onMenuKeyDown(ev);
	            }
	        };
	        _this._onMenuKeyDown = function (ev) {
	            if (_this.props.disabled) {
	                return;
	            }
	            if (_this.props.onKeyDown) {
	                _this.props.onKeyDown(ev);
	            }
	            var isUp = ev.which === Utilities_1.KeyCodes.up;
	            var isDown = ev.which === Utilities_1.KeyCodes.down;
	            if (!ev.defaultPrevented && _this._isValidMenuOpenKey(ev)) {
	                var onMenuClick = _this.props.onMenuClick;
	                if (onMenuClick) {
	                    onMenuClick(ev, _this);
	                }
	                _this._onToggleMenu(false);
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	            if (!(ev.altKey || ev.metaKey) && (isUp || isDown)) {
	                _this.setState(function (state) {
	                    if (state.menuProps && !state.menuProps.shouldFocusOnMount) {
	                        return { menuProps: tslib_1.__assign({}, state.menuProps, { shouldFocusOnMount: true }) };
	                    }
	                    return state;
	                });
	                // This should be done in the setStateCallback but because preventDefault
	                // needs to be called, we have to evaluate the current state, even though
	                // it might not be 100% accurate;
	                if (_this.state.menuProps && !_this.state.menuProps.shouldFocusOnMount) {
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        _this._onTouchStart = function () {
	            if (_this._isSplitButton && _this._splitButtonContainer.current && !('onpointerdown' in _this._splitButtonContainer.current)) {
	                _this._handleTouchAndPointerEvent();
	            }
	        };
	        _this._onMenuClick = function (ev) {
	            var onMenuClick = _this.props.onMenuClick;
	            if (onMenuClick) {
	                onMenuClick(ev, _this);
	            }
	            if (!ev.defaultPrevented) {
	                // When Edge + Narrator are used together (regardless of if the button is in a form or not), pressing
	                // "Enter" fires this method and not _onMenuKeyDown. Checking ev.nativeEvent.detail differentiates
	                // between a real click event and a keypress event (detail should be the number of mouse clicks).
	                // ...Plot twist! For a real click event in IE 11, detail is always 0 (Edge sets it properly to 1).
	                // So we also check the pointerType property, which both Edge and IE set to "mouse" for real clicks
	                // and "" for pressing "Enter" with Narrator on.
	                var shouldFocusOnContainer = ev.nativeEvent.detail !== 0 || ev.nativeEvent.pointerType === 'mouse';
	                _this._onToggleMenu(shouldFocusOnContainer);
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	        };
	        _this._warnConditionallyRequiredProps(['menuProps', 'onClick'], 'split', _this.props.split);
	        _this._warnDeprecations({
	            rootProps: undefined,
	            description: 'secondaryText',
	            toggled: 'checked'
	        });
	        _this._labelId = Utilities_1.getId();
	        _this._descriptionId = Utilities_1.getId();
	        _this._ariaDescriptionId = Utilities_1.getId();
	        _this.state = {
	            menuProps: null
	        };
	        return _this;
	    }
	    Object.defineProperty(BaseButton.prototype, "_isSplitButton", {
	        get: function () {
	            return !!this.props.menuProps && !!this.props.onClick && this.props.split === true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseButton.prototype, "_isExpanded", {
	        get: function () {
	            var menuProps = this.state.menuProps;
	            if (this.props.persistMenu) {
	                return !!menuProps && !menuProps.hidden;
	            }
	            return !!menuProps;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseButton.prototype.render = function () {
	        var _a = this.props, ariaDescription = _a.ariaDescription, ariaLabel = _a.ariaLabel, ariaHidden = _a.ariaHidden, className = _a.className, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, primaryDisabled = _a.primaryDisabled, _b = _a.secondaryText, secondaryText = _b === void 0 ? this.props.description : _b, href = _a.href, iconProps = _a.iconProps, menuIconProps = _a.menuIconProps, styles = _a.styles, checked = _a.checked, variantClassName = _a.variantClassName, theme = _a.theme, toggle = _a.toggle, getClassNames = _a.getClassNames;
	        // Button is disabled if the whole button (in case of splitbutton is disabled) or if the primary action is disabled
	        var isPrimaryButtonDisabled = disabled || primaryDisabled;
	        this._classNames = getClassNames
	            ? getClassNames(theme, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, this._isExpanded, this.props.split, !!allowDisabledFocus)
	            : BaseButton_classNames_1.getBaseButtonClassNames(theme, styles, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, this._isExpanded, this.props.split);
	        var _c = this, _ariaDescriptionId = _c._ariaDescriptionId, _labelId = _c._labelId, _descriptionId = _c._descriptionId;
	        // Anchor tag cannot be disabled hence in disabled state rendering
	        // anchor button as normal button
	        var renderAsAnchor = !isPrimaryButtonDisabled && !!href;
	        var tag = renderAsAnchor ? 'a' : 'button';
	        var nativeProps = Utilities_1.getNativeProps(Utilities_1.assign(renderAsAnchor ? {} : { type: 'button' }, this.props.rootProps, this.props), renderAsAnchor ? Utilities_1.anchorProperties : Utilities_1.buttonProperties, [
	            'disabled' // let disabled buttons be focused and styled as disabled.
	        ]);
	        // Check for ariaLabel passed in via Button props, and fall back to aria-label passed in via native props
	        var resolvedAriaLabel = ariaLabel || nativeProps['aria-label'];
	        // Check for ariaDescription, secondaryText or aria-describedby in the native props to determine source of aria-describedby
	        // otherwise default to undefined so property does not appear in output.
	        var ariaDescribedBy = undefined;
	        if (ariaDescription) {
	            ariaDescribedBy = _ariaDescriptionId;
	        }
	        else if (secondaryText) {
	            ariaDescribedBy = _descriptionId;
	        }
	        else if (nativeProps['aria-describedby']) {
	            ariaDescribedBy = nativeProps['aria-describedby'];
	        }
	        // If an explicit ariaLabel is given, use that as the label and we're done.
	        // If an explicit aria-labelledby is given, use that and we're done.
	        // If any kind of description is given (which will end up as an aria-describedby attribute),
	        // set the labelledby element. Otherwise, the button is labeled implicitly by the descendent
	        // text on the button (if it exists). Never set both aria-label and aria-labelledby.
	        var ariaLabelledBy = undefined;
	        if (!resolvedAriaLabel) {
	            if (nativeProps['aria-labelledby']) {
	                ariaLabelledBy = nativeProps['aria-labelledby'];
	            }
	            else if (ariaDescribedBy) {
	                ariaLabelledBy = this._hasText() ? _labelId : undefined;
	            }
	        }
	        var dataIsFocusable = this.props['data-is-focusable'] === false || (disabled && !allowDisabledFocus) || this._isSplitButton ? false : true;
	        var buttonProps = Utilities_1.assign(nativeProps, {
	            className: this._classNames.root,
	            ref: this._buttonElement,
	            disabled: isPrimaryButtonDisabled && !allowDisabledFocus,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseDown: this._onMouseDown,
	            onMouseUp: this._onMouseUp,
	            onClick: this._onClick,
	            'aria-label': resolvedAriaLabel,
	            'aria-labelledby': ariaLabelledBy,
	            'aria-describedby': ariaDescribedBy,
	            'aria-disabled': isPrimaryButtonDisabled,
	            'data-is-focusable': dataIsFocusable,
	            'aria-pressed': toggle ? !!checked : undefined // aria-pressed attribute should only be present for toggle buttons
	        });
	        if (ariaHidden) {
	            buttonProps['aria-hidden'] = true;
	        }
	        if (this._isSplitButton) {
	            return this._onRenderSplitButtonContent(tag, buttonProps);
	        }
	        else if (this.props.menuProps) {
	            Utilities_1.assign(buttonProps, {
	                'aria-expanded': this._isExpanded,
	                'aria-owns': this.state.menuProps ? this._labelId + '-menu' : null,
	                'aria-haspopup': true
	            });
	        }
	        return this._onRenderContent(tag, buttonProps);
	    };
	    BaseButton.prototype.componentDidMount = function () {
	        // For split buttons, touching anywhere in the button should drop the dropdown, which should contain the primary action.
	        // This gives more hit target space for touch environments. We're setting the onpointerdown here, because React
	        // does not support Pointer events yet.
	        if (this._isSplitButton && this._splitButtonContainer.current && 'onpointerdown' in this._splitButtonContainer.current) {
	            this._events.on(this._splitButtonContainer.current, 'pointerdown', this._onPointerDown, true);
	        }
	    };
	    BaseButton.prototype.componentDidUpdate = function (prevProps, prevState) {
	        // If Button's menu was closed, run onAfterMenuDismiss. If the menu is being persisted
	        // this condition is tested by checking on a change on the menuProps hidden value.
	        if (this.props.onAfterMenuDismiss && prevState.menuProps) {
	            if (!this.state.menuProps || (this.props.persistMenu && !prevState.menuProps.hidden && this.state.menuProps.hidden)) {
	                this.props.onAfterMenuDismiss();
	            }
	        }
	    };
	    BaseButton.prototype.focus = function () {
	        if (this._isSplitButton && this._splitButtonContainer.current) {
	            this._splitButtonContainer.current.focus();
	        }
	        else if (this._buttonElement.current) {
	            this._buttonElement.current.focus();
	        }
	    };
	    BaseButton.prototype.dismissMenu = function () {
	        this._dismissMenu();
	    };
	    BaseButton.prototype.openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
	        this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
	    };
	    BaseButton.prototype._onRenderContent = function (tag, buttonProps) {
	        var _this = this;
	        var props = this.props;
	        var Tag = tag;
	        var menuIconProps = props.menuIconProps, menuProps = props.menuProps, _a = props.onRenderIcon, onRenderIcon = _a === void 0 ? this._onRenderIcon : _a, _b = props.onRenderAriaDescription, onRenderAriaDescription = _b === void 0 ? this._onRenderAriaDescription : _b, _c = props.onRenderChildren, onRenderChildren = _c === void 0 ? this._onRenderChildren : _c, _d = props.onRenderMenu, onRenderMenu = _d === void 0 ? this._onRenderMenu : _d, _e = props.onRenderMenuIcon, onRenderMenuIcon = _e === void 0 ? this._onRenderMenuIcon : _e, disabled = props.disabled;
	        var keytipProps = props.keytipProps;
	        if (keytipProps && menuProps) {
	            keytipProps = tslib_1.__assign({}, keytipProps, { hasMenu: true });
	        }
	        var Content = (
	        // If we're making a split button, we won't put the keytip here
	        React.createElement(KeytipData_1.KeytipData, { keytipProps: !this._isSplitButton ? keytipProps : undefined, ariaDescribedBy: buttonProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (React.createElement(Tag, tslib_1.__assign({}, buttonProps, keytipAttributes),
	            React.createElement("div", { className: _this._classNames.flexContainer },
	                onRenderIcon(props, _this._onRenderIcon),
	                _this._onRenderTextContents(),
	                onRenderAriaDescription(props, _this._onRenderAriaDescription),
	                onRenderChildren(props, _this._onRenderChildren),
	                !_this._isSplitButton &&
	                    (menuProps || menuIconProps || _this.props.onRenderMenuIcon) &&
	                    onRenderMenuIcon(_this.props, _this._onRenderMenuIcon),
	                _this.state.menuProps && !_this.state.menuProps.doNotLayer && onRenderMenu(menuProps, _this._onRenderMenu)))); }));
	        if (menuProps && menuProps.doNotLayer) {
	            return (React.createElement("div", { style: { display: 'inline-block' } },
	                Content,
	                this.state.menuProps && onRenderMenu(menuProps, this._onRenderMenu)));
	        }
	        return Content;
	    };
	    BaseButton.prototype._hasText = function () {
	        // _onRenderTextContents and _onRenderText do not perform the same checks. Below is parity with what _onRenderText used to have
	        // before the refactor that introduced this function. _onRenderTextContents does not require props.text to be undefined in order
	        // for props.children to be used as a fallback. Purely a code maintainability/reuse issue, but logged as Issue #4979
	        return this.props.text !== null && (this.props.text !== undefined || typeof this.props.children === 'string');
	    };
	    BaseButton.prototype._onRenderSplitButtonContent = function (tag, buttonProps) {
	        var _this = this;
	        var _a = this.props, _b = _a.styles, styles = _b === void 0 ? {} : _b, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, getSplitButtonClassNames = _a.getSplitButtonClassNames, primaryDisabled = _a.primaryDisabled, menuProps = _a.menuProps, toggle = _a.toggle;
	        var keytipProps = this.props.keytipProps;
	        var classNames = getSplitButtonClassNames
	            ? getSplitButtonClassNames(!!disabled, this._isExpanded, !!checked, !!allowDisabledFocus)
	            : styles && SplitButton_classNames_1.getClassNames(styles, !!disabled, this._isExpanded, !!checked, !!primaryDisabled);
	        Utilities_1.assign(buttonProps, {
	            onClick: undefined,
	            tabIndex: -1,
	            'data-is-focusable': false
	        });
	        var ariaDescribedBy = buttonProps.ariaDescription;
	        if (keytipProps && menuProps) {
	            keytipProps = tslib_1.__assign({}, keytipProps, { hasMenu: true });
	        }
	        var containerProps = Utilities_1.getNativeProps(buttonProps, [], ['disabled']);
	        return (React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (React.createElement("div", tslib_1.__assign({}, containerProps, { "data-ktp-target": keytipAttributes['data-ktp-target'], role: 'button', "aria-disabled": disabled, "aria-haspopup": true, "aria-expanded": _this._isExpanded, "aria-pressed": toggle ? !!checked : undefined, "aria-describedby": Utilities_1.mergeAriaAttributeValues(ariaDescribedBy, keytipAttributes['aria-describedby']), className: classNames && classNames.splitButtonContainer, onKeyDown: _this._onSplitButtonContainerKeyDown, onTouchStart: _this._onTouchStart, ref: _this._splitButtonContainer, "data-is-focusable": true, onClick: !disabled && !primaryDisabled ? _this._onSplitButtonPrimaryClick : undefined, tabIndex: !disabled || allowDisabledFocus ? 0 : undefined, "aria-roledescription": buttonProps['aria-roledescription'], onFocusCapture: _this._onSplitContainerFocusCapture }),
	            React.createElement("span", { style: { display: 'flex' } },
	                _this._onRenderContent(tag, buttonProps),
	                _this._onRenderSplitButtonMenuButton(classNames, keytipAttributes),
	                _this._onRenderSplitButtonDivider(classNames)))); }));
	    };
	    BaseButton.prototype._onRenderSplitButtonDivider = function (classNames) {
	        if (classNames && classNames.divider) {
	            return React.createElement("span", { className: classNames.divider, "aria-hidden": true });
	        }
	        return null;
	    };
	    BaseButton.prototype._onRenderSplitButtonMenuButton = function (classNames, keytipAttributes) {
	        var _a = this.props, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, disabled = _a.disabled;
	        var menuIconProps = this.props.menuIconProps;
	        var splitButtonAriaLabel = this.props.splitButtonAriaLabel;
	        if (menuIconProps === undefined) {
	            menuIconProps = {
	                iconName: 'ChevronDown'
	            };
	        }
	        var splitButtonProps = {
	            styles: classNames,
	            checked: checked,
	            disabled: disabled,
	            allowDisabledFocus: allowDisabledFocus,
	            onClick: this._onMenuClick,
	            menuProps: undefined,
	            iconProps: tslib_1.__assign({}, menuIconProps, { className: this._classNames.menuIcon }),
	            ariaLabel: splitButtonAriaLabel,
	            'aria-haspopup': true,
	            'aria-expanded': this._isExpanded,
	            'data-is-focusable': false
	        };
	        // Add data-ktp-execute-target to the split button if the keytip is defined
	        return (React.createElement(BaseButton, tslib_1.__assign({}, splitButtonProps, { "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'], onMouseDown: this._onMouseDown, tabIndex: -1 })));
	    };
	    BaseButton.prototype._onPointerDown = function (ev) {
	        if (ev.pointerType === 'touch') {
	            this._handleTouchAndPointerEvent();
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	        }
	    };
	    BaseButton.prototype._handleTouchAndPointerEvent = function () {
	        var _this = this;
	        // If we already have an existing timeeout from a previous touch and pointer event
	        // cancel that timeout so we can set a nwe one.
	        if (this._lastTouchTimeoutId !== undefined) {
	            this._async.clearTimeout(this._lastTouchTimeoutId);
	            this._lastTouchTimeoutId = undefined;
	        }
	        this._processingTouch = true;
	        this._lastTouchTimeoutId = this._async.setTimeout(function () {
	            _this._processingTouch = false;
	            _this._lastTouchTimeoutId = undefined;
	        }, TouchIdleDelay);
	    };
	    /**
	     * Returns if the user hits a valid keyboard key to open the menu
	     * @param ev - the keyboard event
	     * @returns True if user clicks on custom trigger key if enabled or alt + down arrow if not. False otherwise.
	     */
	    BaseButton.prototype._isValidMenuOpenKey = function (ev) {
	        if (this.props.menuTriggerKeyCode) {
	            return ev.which === this.props.menuTriggerKeyCode;
	        }
	        else if (this.props.menuProps) {
	            return ev.which === Utilities_1.KeyCodes.down && (ev.altKey || ev.metaKey);
	        }
	        // Note: When enter is pressed, we will let the event continue to propagate
	        // to trigger the onClick event on the button
	        return false;
	    };
	    BaseButton.defaultProps = {
	        baseClassName: 'ms-Button',
	        styles: {},
	        split: false
	    };
	    return BaseButton;
	}(Utilities_1.BaseComponent));
	exports.BaseButton = BaseButton;
	//# sourceMappingURL=BaseButton.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(695), exports);
	//# sourceMappingURL=ContextualMenu.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(696), exports);
	tslib_1.__exportStar(__webpack_require__(697), exports);
	tslib_1.__exportStar(__webpack_require__(698), exports);
	tslib_1.__exportStar(__webpack_require__(703), exports);
	tslib_1.__exportStar(__webpack_require__(704), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenu_base_1 = __webpack_require__(697);
	var ContextualMenu_styles_1 = __webpack_require__(718);
	// This is to prevent cyclic import with ContextualMenu.base.tsx.
	var LocalContextualMenu;
	function onRenderSubMenu(subMenuProps) {
	    return React.createElement(LocalContextualMenu, tslib_1.__assign({}, subMenuProps));
	}
	LocalContextualMenu = Utilities_1.styled(ContextualMenu_base_1.ContextualMenuBase, ContextualMenu_styles_1.getStyles, function () {
	    return {
	        onRenderSubMenu: onRenderSubMenu
	    };
	}, { scope: 'ContextualMenu' });
	/**
	 * ContextualMenu description
	 */
	exports.ContextualMenu = LocalContextualMenu;
	//# sourceMappingURL=ContextualMenu.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var ContextualMenu_types_1 = __webpack_require__(698);
	var DirectionalHint_1 = __webpack_require__(608);
	var FocusZone_1 = __webpack_require__(676);
	var Utilities_1 = __webpack_require__(592);
	var Utilities_2 = __webpack_require__(592);
	var index_1 = __webpack_require__(699);
	var withResponsiveMode_1 = __webpack_require__(701);
	var Callout_1 = __webpack_require__(603);
	var ContextualMenuItem_1 = __webpack_require__(703);
	var index_2 = __webpack_require__(708);
	var Styling_1 = __webpack_require__(463);
	var ContextualMenu_classNames_1 = __webpack_require__(705);
	var getClassNames = Utilities_2.classNamesFunction({
	    disableCaching: true
	});
	var getContextualMenuItemClassNames = Utilities_2.classNamesFunction({
	    disableCaching: true
	});
	function getSubmenuItems(item) {
	    return item.subMenuProps ? item.subMenuProps.items : item.items;
	}
	exports.getSubmenuItems = getSubmenuItems;
	/**
	 * Returns true if a list of menu items can contain a checkbox
	 */
	function canAnyMenuItemsCheck(items) {
	    return items.some(function (item) {
	        if (item.canCheck) {
	            return true;
	        }
	        // If the item is a section, check if any of the items in the section can check.
	        if (item.sectionProps && item.sectionProps.items.some(function (submenuItem) { return submenuItem.canCheck === true; })) {
	            return true;
	        }
	        return false;
	    });
	}
	exports.canAnyMenuItemsCheck = canAnyMenuItemsCheck;
	var NavigationIdleDelay = 250 /* ms */;
	var ContextualMenuBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuBase, _super);
	    function ContextualMenuBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._mounted = false;
	        _this.dismiss = function (ev, dismissAll) {
	            var onDismiss = _this.props.onDismiss;
	            if (onDismiss) {
	                onDismiss(ev, dismissAll);
	            }
	        };
	        _this._onRenderMenuList = function (menuListProps, defaultRender) {
	            var indexCorrection = 0;
	            return (React.createElement("ul", { className: _this._classNames.list, onKeyDown: _this._onKeyDown, onKeyUp: _this._onKeyUp, role: "menu" }, menuListProps.items.map(function (item, index) {
	                var menuItem = _this._renderMenuItem(item, index, indexCorrection, menuListProps.totalItemCount, menuListProps.hasCheckmarks, menuListProps.hasIcons);
	                if (item.itemType !== ContextualMenu_types_1.ContextualMenuItemType.Divider && item.itemType !== ContextualMenu_types_1.ContextualMenuItemType.Header) {
	                    var indexIncrease = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
	                    indexCorrection += indexIncrease;
	                }
	                return menuItem;
	            })));
	        };
	        _this._onKeyDown = function (ev) {
	            // Take note if we are processing an alt (option) or meta (command) keydown.
	            // See comment in _shouldHandleKeyUp for reasoning.
	            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
	            // On Mac, pressing escape dismisses all levels of native context menus
	            var dismissAllMenus = ev.which === Utilities_2.KeyCodes.escape && (Utilities_2.isMac() || Utilities_2.isIOS());
	            return _this._keyHandler(ev, _this._shouldHandleKeyDown, dismissAllMenus);
	        };
	        _this._shouldHandleKeyDown = function (ev) {
	            return ev.which === Utilities_2.KeyCodes.escape || _this._shouldCloseSubMenu(ev) || (ev.which === Utilities_2.KeyCodes.up && (ev.altKey || ev.metaKey));
	        };
	        _this._onMenuFocusCapture = function (ev) {
	            if (_this.props.delayUpdateFocusOnHover) {
	                _this._shouldUpdateFocusOnMouseEvent = true;
	            }
	        };
	        _this._onKeyUp = function (ev) {
	            return _this._keyHandler(ev, _this._shouldHandleKeyUp, true /* dismissAllMenus */);
	        };
	        /**
	         * We close the menu on key up only if ALL of the following are true:
	         * - Most recent key down was alt or meta (command)
	         * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
	         *   expand/collapse the menu)
	         * - We're not on a Mac (or iOS)
	         *
	         * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
	         * closing any open context menus. There is not a similar behavior on Macs.
	         */
	        _this._shouldHandleKeyUp = function (ev) {
	            var keyPressIsAltOrMetaAlone = _this._lastKeyDownWasAltOrMeta && _this._isAltOrMeta(ev);
	            _this._lastKeyDownWasAltOrMeta = false;
	            return !!keyPressIsAltOrMetaAlone && !(Utilities_2.isIOS() || Utilities_2.isMac());
	        };
	        /**
	         * Calls `shouldHandleKey` to determine whether the keyboard event should be handled;
	         * if so, stops event propagation and dismisses menu(s).
	         * @param ev - The keyboard event.
	         * @param shouldHandleKey - Returns whether we should handle this keyboard event.
	         * @param dismissAllMenus - If true, dismiss all menus. Otherwise, dismiss only the current menu.
	         * Only does anything if `shouldHandleKey` returns true.
	         * @returns Whether the event was handled.
	         */
	        _this._keyHandler = function (ev, shouldHandleKey, dismissAllMenus) {
	            var handled = false;
	            if (shouldHandleKey(ev)) {
	                _this._isFocusingPreviousElement = true;
	                ev.preventDefault();
	                ev.stopPropagation();
	                _this.dismiss(ev, dismissAllMenus);
	                handled = true;
	            }
	            return handled;
	        };
	        /**
	         * Checks if the submenu should be closed
	         */
	        _this._shouldCloseSubMenu = function (ev) {
	            var submenuCloseKey = Utilities_2.getRTL() ? Utilities_2.KeyCodes.right : Utilities_2.KeyCodes.left;
	            if (ev.which !== submenuCloseKey || !_this.props.isSubMenu) {
	                return false;
	            }
	            return (_this._adjustedFocusZoneProps.direction === FocusZone_1.FocusZoneDirection.vertical ||
	                (!!_this._adjustedFocusZoneProps.checkForNoWrap && !Utilities_2.shouldWrapFocus(ev.target, 'data-no-horizontal-wrap')));
	        };
	        _this._onMenuKeyDown = function (ev) {
	            // Mark as handled if onKeyDown returns true (for handling collapse cases)
	            // or if we are attempting to expand a submenu
	            var handled = _this._onKeyDown(ev);
	            if (handled || !_this._host) {
	                return;
	            }
	            // If we have a modifier key being pressed, we do not want to move focus.
	            // Otherwise, handle up and down keys.
	            var hasModifier = !!(ev.altKey || ev.metaKey);
	            var isUp = ev.which === Utilities_2.KeyCodes.up;
	            var isDown = ev.which === Utilities_2.KeyCodes.down;
	            if (!hasModifier && (isUp || isDown)) {
	                var elementToFocus = isUp
	                    ? Utilities_2.getLastFocusable(_this._host, _this._host.lastChild, true)
	                    : Utilities_2.getFirstFocusable(_this._host, _this._host.firstChild, true);
	                if (elementToFocus) {
	                    elementToFocus.focus();
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        /**
	         * Scroll handler for the callout to make sure the mouse events
	         * for updating focus are not interacting during scroll
	         */
	        _this._onScroll = function () {
	            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
	                _this._async.clearTimeout(_this._scrollIdleTimeoutId);
	                _this._scrollIdleTimeoutId = undefined;
	            }
	            else {
	                _this._isScrollIdle = false;
	            }
	            _this._scrollIdleTimeoutId = _this._async.setTimeout(function () {
	                _this._isScrollIdle = true;
	            }, NavigationIdleDelay);
	        };
	        _this._onItemMouseEnterBase = function (item, ev, target) {
	            if (_this._shouldIgnoreMouseEvent()) {
	                return;
	            }
	            _this._updateFocusOnMouseEvent(item, ev, target);
	        };
	        _this._onItemMouseMoveBase = function (item, ev, target) {
	            var targetElement = ev.currentTarget;
	            // Always do this check to make sure we record a mouseMove if needed (even if we are timed out)
	            if (_this._shouldUpdateFocusOnMouseEvent) {
	                _this._gotMouseMove = true;
	            }
	            else {
	                return;
	            }
	            if (!_this._isScrollIdle ||
	                _this._enterTimerId !== undefined ||
	                targetElement === _this._targetWindow.document.activeElement) {
	                return;
	            }
	            _this._updateFocusOnMouseEvent(item, ev, target);
	        };
	        _this._onMouseItemLeave = function (item, ev) {
	            if (_this._shouldIgnoreMouseEvent()) {
	                return;
	            }
	            if (_this._enterTimerId !== undefined) {
	                _this._async.clearTimeout(_this._enterTimerId);
	                _this._enterTimerId = undefined;
	            }
	            if (_this.state.expandedMenuItemKey !== undefined) {
	                return;
	            }
	            /**
	             * IE11 focus() method forces parents to scroll to top of element.
	             * Edge and IE expose a setActive() function for focusable divs that
	             * sets the page focus but does not scroll the parent element.
	             */
	            if (_this._host.setActive) {
	                try {
	                    _this._host.setActive();
	                }
	                catch (e) {
	                    /* no-op */
	                }
	            }
	            else {
	                _this._host.focus();
	            }
	        };
	        _this._onItemMouseDown = function (item, ev) {
	            if (item.onMouseDown) {
	                item.onMouseDown(item, ev);
	            }
	        };
	        _this._onItemClick = function (item, ev) {
	            _this._onItemClickBase(item, ev, ev.currentTarget);
	        };
	        _this._onItemClickBase = function (item, ev, target) {
	            var items = getSubmenuItems(item);
	            // Cancel a async menu item hover timeout action from being taken and instead
	            // just trigger the click event instead.
	            _this._cancelSubMenuTimer();
	            if (!index_1.hasSubmenu(item) && (!items || !items.length)) {
	                // This is an item without a menu. Click it.
	                _this._executeItemClick(item, ev);
	            }
	            else {
	                if (item.key !== _this.state.expandedMenuItemKey) {
	                    // This has a collapsed sub menu. Expand it.
	                    _this.setState({
	                        // When Edge + Narrator are used together (regardless of if the button is in a form or not), pressing
	                        // "Enter" fires this method and not _onMenuKeyDown. Checking ev.nativeEvent.detail differentiates
	                        // between a real click event and a keypress event (detail should be the number of mouse clicks).
	                        // ...Plot twist! For a real click event in IE 11, detail is always 0 (Edge sets it properly to 1).
	                        // So we also check the pointerType property, which both Edge and IE set to "mouse" for real clicks
	                        // and "" for pressing "Enter" with Narrator on.
	                        expandedByMouseClick: ev.nativeEvent.detail !== 0 || ev.nativeEvent.pointerType === 'mouse'
	                    });
	                    _this._onItemSubMenuExpand(item, target);
	                }
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        _this._onAnchorClick = function (item, ev) {
	            _this._executeItemClick(item, ev);
	            ev.stopPropagation();
	        };
	        _this._executeItemClick = function (item, ev) {
	            if (item.disabled || item.isDisabled) {
	                return;
	            }
	            var dismiss = false;
	            if (item.onClick) {
	                dismiss = !!item.onClick(ev, item);
	            }
	            else if (_this.props.onItemClick) {
	                dismiss = !!_this.props.onItemClick(ev, item);
	            }
	            (dismiss || !ev.defaultPrevented) && _this.dismiss(ev, true);
	        };
	        _this._onItemKeyDown = function (item, ev) {
	            var openKey = Utilities_2.getRTL() ? Utilities_2.KeyCodes.left : Utilities_2.KeyCodes.right;
	            if (!item.disabled &&
	                (ev.which === openKey || ev.which === Utilities_2.KeyCodes.enter || (ev.which === Utilities_2.KeyCodes.down && (ev.altKey || ev.metaKey)))) {
	                _this.setState({
	                    expandedByMouseClick: false
	                });
	                _this._onItemSubMenuExpand(item, ev.currentTarget);
	                ev.preventDefault();
	            }
	        };
	        // Cancel a async menu item hover timeout action from being taken and instead
	        // do new upcoming behavior
	        _this._cancelSubMenuTimer = function () {
	            if (_this._enterTimerId !== undefined) {
	                _this._async.clearTimeout(_this._enterTimerId);
	                _this._enterTimerId = undefined;
	            }
	        };
	        _this._onItemSubMenuExpand = function (item, target) {
	            if (_this.state.expandedMenuItemKey !== item.key) {
	                if (_this.state.expandedMenuItemKey) {
	                    _this._onSubMenuDismiss();
	                }
	                // Focus the target to ensure when we close it, we're focusing on the correct element.
	                target.focus();
	                _this.setState({
	                    expandedMenuItemKey: item.key,
	                    submenuTarget: target
	                });
	            }
	        };
	        /**
	         * This function is called ASYNCHRONOUSLY, and so there is a chance it is called
	         * after the component is unmounted. The _mounted property is added to prevent
	         * from calling setState() after unmount. Do NOT copy this pattern in synchronous
	         * code.
	         */
	        _this._onSubMenuDismiss = function (ev, dismissAll) {
	            if (dismissAll) {
	                _this.dismiss(ev, dismissAll);
	            }
	            else if (_this._mounted) {
	                _this.setState({
	                    dismissedMenuItemKey: _this.state.expandedMenuItemKey,
	                    expandedMenuItemKey: undefined,
	                    submenuTarget: undefined
	                });
	            }
	        };
	        _this._getSubMenuId = function (item) {
	            var subMenuId = _this.state.subMenuId;
	            if (item.subMenuProps && item.subMenuProps.id) {
	                subMenuId = item.subMenuProps.id;
	            }
	            return subMenuId;
	        };
	        _this._onPointerAndTouchEvent = function (ev) {
	            _this._cancelSubMenuTimer();
	        };
	        _this.state = {
	            contextualMenuItems: undefined,
	            subMenuId: Utilities_2.getId('ContextualMenu')
	        };
	        _this._warnDeprecations({
	            getMenuClassNames: 'styles'
	        });
	        _this._isFocusingPreviousElement = false;
	        _this._isScrollIdle = true;
	        _this._shouldUpdateFocusOnMouseEvent = !_this.props.delayUpdateFocusOnHover;
	        _this._gotMouseMove = false;
	        return _this;
	    }
	    ContextualMenuBase.prototype.shouldComponentUpdate = function (newProps, newState) {
	        if (this.props.hidden && newProps.hidden) {
	            // Do not update when hidden.
	            return false;
	        }
	        return !Utilities_1.shallowCompare(this.props, newProps) || !Utilities_1.shallowCompare(this.state, newState);
	    };
	    ContextualMenuBase.prototype.componentWillUpdate = function (newProps) {
	        if (newProps.target !== this.props.target) {
	            var newTarget = newProps.target;
	            this._setTargetWindowAndElement(newTarget);
	        }
	        if (newProps.hidden !== this.props.hidden) {
	            if (newProps.hidden) {
	                this._onMenuClosed();
	            }
	            else {
	                this._onMenuOpened();
	                this._previousActiveElement = this._targetWindow ? this._targetWindow.document.activeElement : null;
	            }
	        }
	        if (newProps.delayUpdateFocusOnHover !== this.props.delayUpdateFocusOnHover) {
	            // update shouldUpdateFocusOnMouseEvent to follow what was passed in
	            this._shouldUpdateFocusOnMouseEvent = !newProps.delayUpdateFocusOnHover;
	            // If shouldUpdateFocusOnMouseEvent is false, we need to reset gotMouseMove to false
	            this._gotMouseMove = this._shouldUpdateFocusOnMouseEvent && this._gotMouseMove;
	        }
	    };
	    // Invoked once, both on the client and server, immediately before the initial rendering occurs.
	    ContextualMenuBase.prototype.componentWillMount = function () {
	        var target = this.props.target;
	        this._setTargetWindowAndElement(target);
	        if (!this.props.hidden) {
	            this._previousActiveElement = this._targetWindow ? this._targetWindow.document.activeElement : null;
	        }
	    };
	    // Invoked once, only on the client (not on the server), immediately after the initial rendering occurs.
	    ContextualMenuBase.prototype.componentDidMount = function () {
	        if (!this.props.hidden) {
	            this._onMenuOpened();
	        }
	        this._mounted = true;
	    };
	    // Invoked immediately before a component is unmounted from the DOM.
	    ContextualMenuBase.prototype.componentWillUnmount = function () {
	        this._tryFocusPreviousActiveElement();
	        if (this.props.onMenuDismissed) {
	            this.props.onMenuDismissed(this.props);
	        }
	        this._events.dispose();
	        this._async.dispose();
	        this._mounted = false;
	    };
	    ContextualMenuBase.prototype.render = function () {
	        var _this = this;
	        var isBeakVisible = this.props.isBeakVisible;
	        var _a = this.props, items = _a.items, labelElementId = _a.labelElementId, id = _a.id, className = _a.className, beakWidth = _a.beakWidth, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, alignTargetEdge = _a.alignTargetEdge, gapSpace = _a.gapSpace, coverTarget = _a.coverTarget, ariaLabel = _a.ariaLabel, doNotLayer = _a.doNotLayer, target = _a.target, bounds = _a.bounds, useTargetWidth = _a.useTargetWidth, useTargetAsMinWidth = _a.useTargetAsMinWidth, directionalHintFixed = _a.directionalHintFixed, shouldFocusOnMount = _a.shouldFocusOnMount, shouldFocusOnContainer = _a.shouldFocusOnContainer, title = _a.title, styles = _a.styles, theme = _a.theme, calloutProps = _a.calloutProps, _b = _a.onRenderSubMenu, onRenderSubMenu = _b === void 0 ? this._onRenderSubMenu : _b, _c = _a.onRenderMenuList, onRenderMenuList = _c === void 0 ? this._onRenderMenuList : _c, focusZoneProps = _a.focusZoneProps, getMenuClassNames = _a.getMenuClassNames;
	        this._classNames = getMenuClassNames
	            ? getMenuClassNames(theme, className)
	            : getClassNames(styles, {
	                theme: theme,
	                className: className
	            });
	        var hasIcons = itemsHaveIcons(items);
	        function itemsHaveIcons(contextualMenuItems) {
	            for (var _i = 0, contextualMenuItems_1 = contextualMenuItems; _i < contextualMenuItems_1.length; _i++) {
	                var item = contextualMenuItems_1[_i];
	                if (!!item.iconProps) {
	                    return true;
	                }
	                if (item.itemType === ContextualMenu_types_1.ContextualMenuItemType.Section && item.sectionProps && itemsHaveIcons(item.sectionProps.items)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        this._adjustedFocusZoneProps = tslib_1.__assign({}, focusZoneProps, { direction: this._getFocusZoneDirection() });
	        var hasCheckmarks = canAnyMenuItemsCheck(items);
	        var submenuProps = this.state.expandedMenuItemKey && this.props.hidden !== true ? this._getSubmenuProps() : null;
	        isBeakVisible = isBeakVisible === undefined ? this.props.responsiveMode <= withResponsiveMode_1.ResponsiveMode.medium : isBeakVisible;
	        /**
	         * When useTargetWidth is true, get the width of the target element and apply it for the context menu container
	         */
	        var contextMenuStyle;
	        var targetAsHtmlElement = this._target;
	        if ((useTargetWidth || useTargetAsMinWidth) && targetAsHtmlElement && targetAsHtmlElement.offsetWidth) {
	            var targetBoundingRect = targetAsHtmlElement.getBoundingClientRect();
	            var targetWidth = targetBoundingRect.width - 2 /* Accounts for 1px border */;
	            if (useTargetWidth) {
	                contextMenuStyle = {
	                    width: targetWidth
	                };
	            }
	            else if (useTargetAsMinWidth) {
	                contextMenuStyle = {
	                    minWidth: targetWidth
	                };
	            }
	        }
	        // The menu should only return if items were provided, if no items were provided then it should not appear.
	        if (items && items.length > 0) {
	            var totalItemCount = 0;
	            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
	                var item = items_1[_i];
	                if (item.itemType !== ContextualMenu_types_1.ContextualMenuItemType.Divider && item.itemType !== ContextualMenu_types_1.ContextualMenuItemType.Header) {
	                    var itemCount = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
	                    totalItemCount += itemCount;
	                }
	            }
	            var calloutStyles = !getMenuClassNames && this._classNames.subComponentStyles
	                ? this._classNames.subComponentStyles.callout
	                : undefined;
	            return (React.createElement(Callout_1.Callout, tslib_1.__assign({ styles: calloutStyles }, calloutProps, { target: target, isBeakVisible: isBeakVisible, beakWidth: beakWidth, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, gapSpace: gapSpace, coverTarget: coverTarget, doNotLayer: doNotLayer, className: Utilities_2.css('ms-ContextualMenu-Callout', calloutProps && calloutProps.className), setInitialFocus: shouldFocusOnMount, onDismiss: this.props.onDismiss, onScroll: this._onScroll, bounds: bounds, directionalHintFixed: directionalHintFixed, alignTargetEdge: alignTargetEdge, hidden: this.props.hidden }),
	                React.createElement("div", { "aria-label": ariaLabel, "aria-labelledby": labelElementId, style: contextMenuStyle, ref: function (host) { return (_this._host = host); }, id: id, className: this._classNames.container, tabIndex: shouldFocusOnContainer ? 0 : -1, onKeyDown: this._onMenuKeyDown, onKeyUp: this._onKeyUp, onFocusCapture: this._onMenuFocusCapture },
	                    title && React.createElement("div", { className: this._classNames.title },
	                        " ",
	                        title,
	                        " "),
	                    items && items.length ? (React.createElement(FocusZone_1.FocusZone, tslib_1.__assign({}, this._adjustedFocusZoneProps, { className: this._classNames.root, isCircularNavigation: true, handleTabKey: FocusZone_1.FocusZoneTabbableElements.all }), onRenderMenuList({
	                        items: items,
	                        totalItemCount: totalItemCount,
	                        hasCheckmarks: hasCheckmarks,
	                        hasIcons: hasIcons
	                    }, this._onRenderMenuList))) : null,
	                    submenuProps && onRenderSubMenu(submenuProps, this._onRenderSubMenu))));
	        }
	        else {
	            return null;
	        }
	    };
	    ContextualMenuBase.prototype._onMenuOpened = function () {
	        this._events.on(this._targetWindow, 'resize', this.dismiss);
	        this._shouldUpdateFocusOnMouseEvent = !this.props.delayUpdateFocusOnHover;
	        this._gotMouseMove = false;
	        this.props.onMenuOpened && this.props.onMenuOpened(this.props);
	    };
	    ContextualMenuBase.prototype._onMenuClosed = function () {
	        this._events.off(this._targetWindow, 'resize', this.dismiss);
	        this._tryFocusPreviousActiveElement();
	        if (this.props.onMenuDismissed) {
	            this.props.onMenuDismissed(this.props);
	        }
	        this._shouldUpdateFocusOnMouseEvent = !this.props.delayUpdateFocusOnHover;
	        // We need to dismiss any submenu related state properties,
	        // so that when the menu is shown again, the submenu is collapsed
	        this.setState({
	            expandedByMouseClick: undefined,
	            dismissedMenuItemKey: undefined,
	            expandedMenuItemKey: undefined,
	            submenuTarget: undefined
	        });
	    };
	    ContextualMenuBase.prototype._tryFocusPreviousActiveElement = function () {
	        var _this = this;
	        if (this._isFocusingPreviousElement && this._previousActiveElement) {
	            // This slight delay is required so that we can unwind the stack, const react try to mess with focus, and then
	            // apply the correct focus. Without the setTimeout, we end up focusing the correct thing, and then React wants
	            // to reset the focus back to the thing it thinks should have been focused.
	            // Note: Cannot be replaced by this._async.setTimout because those will be removed by the time this is called.
	            setTimeout(function () {
	                _this._previousActiveElement && _this._previousActiveElement.focus();
	            }, 0);
	        }
	    };
	    /**
	     * Gets the focusZoneDirection by using the arrowDirection if specified,
	     * the direction specificed in the focusZoneProps, or defaults to FocusZoneDirection.vertical
	     */
	    ContextualMenuBase.prototype._getFocusZoneDirection = function () {
	        var focusZoneProps = this.props.focusZoneProps;
	        return focusZoneProps && focusZoneProps.direction !== undefined ? focusZoneProps.direction : FocusZone_1.FocusZoneDirection.vertical;
	    };
	    ContextualMenuBase.prototype._onRenderSubMenu = function (subMenuProps, defaultRender) {
	        throw Error('ContextualMenuBase: onRenderSubMenu callback is null or undefined. ' +
	            'Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.');
	    };
	    ContextualMenuBase.prototype._renderMenuItem = function (item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
	        var renderedItems = [];
	        var iconProps = item.iconProps || { iconName: 'None' };
	        var getItemClassNames = item.getItemClassNames, itemProps = item.itemProps;
	        var styles = itemProps ? itemProps.styles : undefined;
	        // We only send a dividerClassName when the item to be rendered is a divider. For all other cases, the default divider style is used.
	        var dividerClassName = item.itemType === ContextualMenu_types_1.ContextualMenuItemType.Divider ? item.className : undefined;
	        var subMenuIconClassName = item.submenuIconProps ? item.submenuIconProps.className : '';
	        var itemClassNames;
	        // IContextualMenuItem#getItemClassNames for backwards compatibility
	        // otherwise uses mergeStyles for class names.
	        if (getItemClassNames) {
	            itemClassNames = getItemClassNames(this.props.theme, index_1.isItemDisabled(item), this.state.expandedMenuItemKey === item.key, !!index_1.getIsChecked(item), !!item.href, iconProps.iconName !== 'None', item.className, dividerClassName, iconProps.className, subMenuIconClassName, item.primaryDisabled);
	        }
	        else {
	            var itemStyleProps = {
	                theme: this.props.theme,
	                disabled: index_1.isItemDisabled(item),
	                expanded: this.state.expandedMenuItemKey === item.key,
	                checked: !!index_1.getIsChecked(item),
	                isAnchorLink: !!item.href,
	                knownIcon: iconProps.iconName !== 'None',
	                itemClassName: item.className,
	                dividerClassName: dividerClassName,
	                iconClassName: iconProps.className,
	                subMenuClassName: subMenuIconClassName,
	                primaryDisabled: item.primaryDisabled
	            };
	            var menuItemStyles = this._classNames.subComponentStyles
	                ? this._classNames.subComponentStyles.menuItem
	                : undefined;
	            // We need to generate default styles then override if styles are provided
	            // since the ContextualMenu currently handles item classNames.
	            itemClassNames = Styling_1.mergeStyleSets(getContextualMenuItemClassNames(ContextualMenu_classNames_1.getItemStyles, itemStyleProps), getContextualMenuItemClassNames(menuItemStyles, itemStyleProps), getContextualMenuItemClassNames(styles, itemStyleProps));
	        }
	        if (item.text === '-' || item.name === '-') {
	            item.itemType = ContextualMenu_types_1.ContextualMenuItemType.Divider;
	        }
	        switch (item.itemType) {
	            case ContextualMenu_types_1.ContextualMenuItemType.Divider:
	                renderedItems.push(this._renderSeparator(index, itemClassNames));
	                break;
	            case ContextualMenu_types_1.ContextualMenuItemType.Header:
	                renderedItems.push(this._renderSeparator(index, itemClassNames));
	                var headerItem = this._renderHeaderMenuItem(item, itemClassNames, index, hasCheckmarks, hasIcons);
	                renderedItems.push(this._renderListItem(headerItem, item.key || index, itemClassNames, item.title));
	                break;
	            case ContextualMenu_types_1.ContextualMenuItemType.Section:
	                renderedItems.push(this._renderSectionItem(item, itemClassNames, index, hasCheckmarks, hasIcons));
	                break;
	            default:
	                var menuItem = this._renderNormalItem(item, itemClassNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
	                renderedItems.push(this._renderListItem(menuItem, item.key || index, itemClassNames, item.title));
	                break;
	        }
	        return renderedItems;
	    };
	    ContextualMenuBase.prototype._renderSectionItem = function (sectionItem, menuClassNames, index, hasCheckmarks, hasIcons) {
	        var _this = this;
	        var sectionProps = sectionItem.sectionProps;
	        if (!sectionProps) {
	            return;
	        }
	        var headerItem;
	        if (sectionProps.title) {
	            var headerContextualMenuItem = {
	                key: "section-" + sectionProps.title + "-title",
	                itemType: ContextualMenu_types_1.ContextualMenuItemType.Header,
	                text: sectionProps.title
	            };
	            headerItem = this._renderHeaderMenuItem(headerContextualMenuItem, menuClassNames, index, hasCheckmarks, hasIcons);
	        }
	        if (sectionProps.items && sectionProps.items.length > 0) {
	            return (React.createElement("li", { role: "presentation", key: sectionProps.key || sectionItem.key || "section-" + index },
	                React.createElement("div", { role: "group" },
	                    React.createElement("ul", { className: this._classNames.list },
	                        sectionProps.topDivider && this._renderSeparator(index, menuClassNames, true, true),
	                        headerItem && this._renderListItem(headerItem, sectionItem.key || index, menuClassNames, sectionItem.title),
	                        sectionProps.items.map(function (contextualMenuItem, itemsIndex) {
	                            return _this._renderMenuItem(contextualMenuItem, itemsIndex, itemsIndex, sectionProps.items.length, hasCheckmarks, hasIcons);
	                        }),
	                        sectionProps.bottomDivider && this._renderSeparator(index, menuClassNames, false, true)))));
	        }
	    };
	    ContextualMenuBase.prototype._renderListItem = function (content, key, classNames, title) {
	        return (React.createElement("li", { role: "presentation", title: title, key: key, className: classNames.item }, content));
	    };
	    ContextualMenuBase.prototype._renderSeparator = function (index, classNames, top, fromSection) {
	        if (fromSection || index > 0) {
	            return (React.createElement("li", { role: "separator", key: 'separator-' + index + (top === undefined ? '' : top ? '-top' : '-bottom'), className: classNames.divider, "aria-hidden": "true" }));
	        }
	        return null;
	    };
	    ContextualMenuBase.prototype._renderNormalItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
	        if (item.onRender) {
	            return item.onRender(tslib_1.__assign({ 'aria-posinset': focusableElementIndex + 1, 'aria-setsize': totalItemCount }, item), this.dismiss);
	        }
	        if (item.href) {
	            return this._renderAnchorMenuItem(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
	        }
	        if (item.split && index_1.hasSubmenu(item)) {
	            return this._renderSplitButton(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
	        }
	        return this._renderButtonItem(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
	    };
	    ContextualMenuBase.prototype._renderHeaderMenuItem = function (item, classNames, index, hasCheckmarks, hasIcons) {
	        var _a = this.props.contextualMenuItemAs, ChildrenRenderer = _a === void 0 ? ContextualMenuItem_1.ContextualMenuItem : _a;
	        var itemProps = item.itemProps;
	        var divHtmlProperties = itemProps && Utilities_1.getNativeProps(itemProps, Utilities_1.divProperties);
	        return (React.createElement("div", tslib_1.__assign({ className: this._classNames.header }, divHtmlProperties, { style: item.style }),
	            React.createElement(ChildrenRenderer, tslib_1.__assign({ item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks ? this._onItemClick : undefined, hasIcons: hasIcons }, itemProps))));
	    };
	    ContextualMenuBase.prototype._renderAnchorMenuItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
	        var contextualMenuItemAs = this.props.contextualMenuItemAs;
	        var expandedMenuItemKey = this.state.expandedMenuItemKey;
	        return (React.createElement(index_2.ContextualMenuAnchor, { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onAnchorClick, onItemKeyDown: this._onItemKeyDown, getSubMenuId: this._getSubMenuId, expandedMenuItemKey: expandedMenuItemKey, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss }));
	    };
	    ContextualMenuBase.prototype._renderButtonItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
	        var contextualMenuItemAs = this.props.contextualMenuItemAs;
	        var expandedMenuItemKey = this.state.expandedMenuItemKey;
	        return (React.createElement(index_2.ContextualMenuButton, { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onItemClick, onItemClickBase: this._onItemClickBase, onItemKeyDown: this._onItemKeyDown, getSubMenuId: this._getSubMenuId, expandedMenuItemKey: expandedMenuItemKey, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss }));
	    };
	    ContextualMenuBase.prototype._renderSplitButton = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
	        var contextualMenuItemAs = this.props.contextualMenuItemAs;
	        var expandedMenuItemKey = this.state.expandedMenuItemKey;
	        return (React.createElement(index_2.ContextualMenuSplitButton, { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onItemClick, onItemClickBase: this._onItemClickBase, onItemKeyDown: this._onItemKeyDown, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss, expandedMenuItemKey: expandedMenuItemKey, onTap: this._onPointerAndTouchEvent }));
	    };
	    /**
	     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
	     */
	    ContextualMenuBase.prototype._isAltOrMeta = function (ev) {
	        return ev.which === Utilities_2.KeyCodes.alt || ev.key === 'Meta';
	    };
	    ContextualMenuBase.prototype._shouldIgnoreMouseEvent = function () {
	        return !this._isScrollIdle || !this._gotMouseMove;
	    };
	    /**
	     * Handles updating focus when mouseEnter or mouseMove fire.
	     * As part of updating focus, This function will also update
	     * the expand/collapse state accordingly.
	     */
	    ContextualMenuBase.prototype._updateFocusOnMouseEvent = function (item, ev, target) {
	        var _this = this;
	        var targetElement = target ? target : ev.currentTarget;
	        var _a = this.props.subMenuHoverDelay, timeoutDuration = _a === void 0 ? NavigationIdleDelay : _a;
	        if (item.key === this.state.expandedMenuItemKey) {
	            return;
	        }
	        if (this._enterTimerId !== undefined) {
	            this._async.clearTimeout(this._enterTimerId);
	            this._enterTimerId = undefined;
	        }
	        // If the menu is not expanded we can update focus without any delay
	        if (this.state.expandedMenuItemKey === undefined) {
	            targetElement.focus();
	        }
	        // Delay updating expanding/dismissing the submenu
	        // and only set focus if we have not already done so
	        if (index_1.hasSubmenu(item)) {
	            ev.stopPropagation();
	            this._enterTimerId = this._async.setTimeout(function () {
	                targetElement.focus();
	                _this.setState({
	                    expandedByMouseClick: true
	                });
	                _this._onItemSubMenuExpand(item, targetElement);
	                _this._enterTimerId = undefined;
	            }, timeoutDuration);
	        }
	        else {
	            this._enterTimerId = this._async.setTimeout(function () {
	                _this._onSubMenuDismiss(ev);
	                targetElement.focus();
	                _this._enterTimerId = undefined;
	            }, timeoutDuration);
	        }
	    };
	    ContextualMenuBase.prototype._getSubmenuProps = function () {
	        var _a = this.state, submenuTarget = _a.submenuTarget, expandedMenuItemKey = _a.expandedMenuItemKey;
	        var item = this._findItemByKey(expandedMenuItemKey);
	        var submenuProps = null;
	        if (item) {
	            submenuProps = {
	                items: getSubmenuItems(item),
	                target: submenuTarget,
	                onDismiss: this._onSubMenuDismiss,
	                isSubMenu: true,
	                id: this.state.subMenuId,
	                shouldFocusOnMount: true,
	                shouldFocusOnContainer: this.state.expandedByMouseClick,
	                directionalHint: Utilities_2.getRTL() ? DirectionalHint_1.DirectionalHint.leftTopEdge : DirectionalHint_1.DirectionalHint.rightTopEdge,
	                className: this.props.className,
	                gapSpace: 0,
	                isBeakVisible: false
	            };
	            if (item.subMenuProps) {
	                Utilities_2.assign(submenuProps, item.subMenuProps);
	            }
	        }
	        return submenuProps;
	    };
	    ContextualMenuBase.prototype._findItemByKey = function (key) {
	        var items = this.props.items;
	        return this._findItemByKeyFromItems(key, items);
	    };
	    /**
	     * Returns the item that mathes a given key if any.
	     * @param key - The key of the item to match
	     * @param items - The items to look for the key
	     */
	    ContextualMenuBase.prototype._findItemByKeyFromItems = function (key, items) {
	        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
	            var item = items_2[_i];
	            if (item.itemType === ContextualMenu_types_1.ContextualMenuItemType.Section && item.sectionProps) {
	                var match = this._findItemByKeyFromItems(key, item.sectionProps.items);
	                if (match) {
	                    return match;
	                }
	            }
	            else if (item.key && item.key === key) {
	                return item;
	            }
	        }
	    };
	    ContextualMenuBase.prototype._setTargetWindowAndElement = function (target) {
	        var currentElement = this._host;
	        if (target) {
	            if (typeof target === 'string') {
	                var currentDoc = Utilities_2.getDocument(currentElement);
	                this._target = currentDoc ? currentDoc.querySelector(target) : null;
	                this._targetWindow = Utilities_2.getWindow(currentElement);
	            }
	            else if (target.stopPropagation) {
	                this._targetWindow = Utilities_2.getWindow(target.toElement);
	                this._target = target;
	            }
	            else if (target.x !== undefined && target.y !== undefined) {
	                this._targetWindow = Utilities_2.getWindow(currentElement);
	                this._target = target;
	            }
	            else {
	                var targetElement = target;
	                this._targetWindow = Utilities_2.getWindow(targetElement);
	                this._target = target;
	            }
	        }
	        else {
	            this._targetWindow = Utilities_2.getWindow(currentElement);
	        }
	    };
	    // The default ContextualMenu properties have no items and beak, the default submenu direction is right and top.
	    ContextualMenuBase.defaultProps = {
	        items: [],
	        shouldFocusOnMount: true,
	        gapSpace: 0,
	        directionalHint: DirectionalHint_1.DirectionalHint.bottomAutoEdge,
	        beakWidth: 16
	    };
	    ContextualMenuBase = tslib_1.__decorate([
	        withResponsiveMode_1.withResponsiveMode
	    ], ContextualMenuBase);
	    return ContextualMenuBase;
	}(Utilities_2.BaseComponent));
	exports.ContextualMenuBase = ContextualMenuBase;
	//# sourceMappingURL=ContextualMenu.base.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DirectionalHint_1 = __webpack_require__(608);
	exports.DirectionalHint = DirectionalHint_1.DirectionalHint;
	/**
	 * {@docCategory ContextualMenu}
	 */
	var ContextualMenuItemType;
	(function (ContextualMenuItemType) {
	    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
	    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
	    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
	    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
	})(ContextualMenuItemType = exports.ContextualMenuItemType || (exports.ContextualMenuItemType = {}));
	//# sourceMappingURL=ContextualMenu.types.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(700), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Determines the effective checked state of a menu item.
	 *
	 * @param item {IContextualMenuItem} to get the check state of.
	 * @returns {true} if the item is checked.
	 * @returns {false} if the item is unchecked.
	 * @returns {null} if the item is not checkable.
	 */
	function getIsChecked(item) {
	    if (item.canCheck) {
	        return !!(item.isChecked || item.checked);
	    }
	    if (typeof item.isChecked === 'boolean') {
	        return item.isChecked;
	    }
	    if (typeof item.checked === 'boolean') {
	        return item.checked;
	    }
	    // Item is not checkable.
	    return null;
	}
	exports.getIsChecked = getIsChecked;
	function hasSubmenu(item) {
	    return !!(item.subMenuProps || item.items);
	}
	exports.hasSubmenu = hasSubmenu;
	function isItemDisabled(item) {
	    return !!(item.isDisabled || item.disabled);
	}
	exports.isItemDisabled = isItemDisabled;
	//# sourceMappingURL=contextualMenuUtility.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var react_dom_1 = __webpack_require__(41);
	var BaseDecorator_1 = __webpack_require__(702);
	var Utilities_1 = __webpack_require__(592);
	var ResponsiveMode;
	(function (ResponsiveMode) {
	    ResponsiveMode[ResponsiveMode["small"] = 0] = "small";
	    ResponsiveMode[ResponsiveMode["medium"] = 1] = "medium";
	    ResponsiveMode[ResponsiveMode["large"] = 2] = "large";
	    ResponsiveMode[ResponsiveMode["xLarge"] = 3] = "xLarge";
	    ResponsiveMode[ResponsiveMode["xxLarge"] = 4] = "xxLarge";
	    ResponsiveMode[ResponsiveMode["xxxLarge"] = 5] = "xxxLarge";
	    ResponsiveMode[ResponsiveMode["unknown"] = 999] = "unknown";
	})(ResponsiveMode = exports.ResponsiveMode || (exports.ResponsiveMode = {}));
	var RESPONSIVE_MAX_CONSTRAINT = [479, 639, 1023, 1365, 1919, 99999999];
	/**
	 * User specified mode to default to, useful for server side rendering scenarios.
	 */
	var _defaultMode;
	/**
	 * Tracking the last mode we successfully rendered, which allows us to
	 * paint initial renders with the correct size.
	 */
	var _lastMode;
	/**
	 * Allows a server rendered scenario to provide a default responsive mode.
	 */
	function setResponsiveMode(responsiveMode) {
	    _defaultMode = responsiveMode;
	}
	exports.setResponsiveMode = setResponsiveMode;
	/**
	 * Initializes the responsive mode to the current window size. This can be used to avoid
	 * a re-render during first component mount since the window would otherwise not be measured
	 * until after mounting.
	 */
	function initializeResponsiveMode(element) {
	    if (typeof window !== 'undefined') {
	        var currentWindow = (element && Utilities_1.getWindow(element)) || window;
	        getResponsiveMode(currentWindow);
	    }
	}
	exports.initializeResponsiveMode = initializeResponsiveMode;
	function withResponsiveMode(ComposedComponent) {
	    var resultClass = /** @class */ (function (_super) {
	        tslib_1.__extends(WithResponsiveMode, _super);
	        function WithResponsiveMode(props) {
	            var _this = _super.call(this, props) || this;
	            _this._onResize = function () {
	                var element = react_dom_1.findDOMNode(_this);
	                var currentWindow = (element && Utilities_1.getWindow(element)) || window;
	                var responsiveMode = getResponsiveMode(currentWindow);
	                if (responsiveMode !== _this.state.responsiveMode) {
	                    _this.setState({
	                        responsiveMode: responsiveMode
	                    });
	                }
	            };
	            _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
	            _this.state = {
	                responsiveMode: _defaultMode || _lastMode || ResponsiveMode.large
	            };
	            return _this;
	        }
	        WithResponsiveMode.prototype.componentDidMount = function () {
	            this._events.on(window, 'resize', this._onResize);
	            this._onResize();
	        };
	        WithResponsiveMode.prototype.componentWillUnmount = function () {
	            this._events.dispose();
	        };
	        WithResponsiveMode.prototype.render = function () {
	            var responsiveMode = this.state.responsiveMode;
	            return responsiveMode === ResponsiveMode.unknown ? null : (React.createElement(ComposedComponent, tslib_1.__assign({ ref: this._updateComposedComponentRef, responsiveMode: responsiveMode }, this.props)));
	        };
	        return WithResponsiveMode;
	    }(BaseDecorator_1.BaseDecorator));
	    return Utilities_1.hoistStatics(ComposedComponent, resultClass);
	}
	exports.withResponsiveMode = withResponsiveMode;
	function getResponsiveMode(currentWindow) {
	    var responsiveMode = ResponsiveMode.small;
	    if (currentWindow) {
	        try {
	            while (currentWindow.innerWidth > RESPONSIVE_MAX_CONSTRAINT[responsiveMode]) {
	                responsiveMode++;
	            }
	        }
	        catch (e) {
	            // Return a best effort result in cases where we're in the browser but it throws on getting innerWidth.
	            responsiveMode = _defaultMode || _lastMode || ResponsiveMode.large;
	        }
	        // Tracking last mode just gives us a better default in future renders,
	        // which avoids starting with the wrong value if we've measured once.
	        _lastMode = responsiveMode;
	    }
	    else {
	        if (_defaultMode !== undefined) {
	            responsiveMode = _defaultMode;
	        }
	        else {
	            throw new Error('Content was rendered in a server environment without providing a default responsive mode. ' +
	                'Call setResponsiveMode to define what the responsive mode is.');
	        }
	    }
	    return responsiveMode;
	}
	//# sourceMappingURL=withResponsiveMode.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Utilities_1 = __webpack_require__(592);
	var BaseDecorator = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseDecorator, _super);
	    function BaseDecorator(props) {
	        var _this = _super.call(this, props) || this;
	        // tslint:disable-next-line:typedef
	        _this._skipComponentRefResolution = true;
	        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
	        return _this;
	    }
	    /**
	     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
	     * (and unhoisting as appropriate) methods from said component.
	     *
	     * Pass this method as the argument to the 'ref' property of the composed component.
	     */
	    BaseDecorator.prototype._updateComposedComponentRef = function (composedComponentInstance) {
	        this._composedComponentInstance = composedComponentInstance;
	        if (composedComponentInstance) {
	            this._hoisted = Utilities_1.hoistMethods(this, composedComponentInstance);
	        }
	        else if (this._hoisted) {
	            Utilities_1.unhoistMethods(this, this._hoisted);
	        }
	    };
	    return BaseDecorator;
	}(Utilities_1.BaseComponent));
	exports.BaseDecorator = BaseDecorator;
	//# sourceMappingURL=BaseDecorator.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenuItem_base_1 = __webpack_require__(704);
	var ContextualMenu_classNames_1 = __webpack_require__(705);
	/**
	 * ContextualMenuItem description
	 */
	exports.ContextualMenuItem = Utilities_1.styled(ContextualMenuItem_base_1.ContextualMenuItemBase, ContextualMenu_classNames_1.getItemStyles, undefined, { scope: 'ContextualMenuItem' });
	//# sourceMappingURL=ContextualMenuItem.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var index_1 = __webpack_require__(699);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var renderItemIcon = function (props) {
	    var item = props.item, hasIcons = props.hasIcons, classNames = props.classNames;
	    var iconProps = item.iconProps;
	    if (!hasIcons) {
	        return null;
	    }
	    if (item.onRenderIcon) {
	        return item.onRenderIcon(props);
	    }
	    return React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps, { className: classNames.icon }));
	};
	var renderCheckMarkIcon = function (_a) {
	    var onCheckmarkClick = _a.onCheckmarkClick, item = _a.item, classNames = _a.classNames;
	    var isItemChecked = index_1.getIsChecked(item);
	    if (onCheckmarkClick) {
	        // Ensures that the item is passed as the first argument to the checkmark click callback.
	        var onClick = function (e) { return onCheckmarkClick(item, e); };
	        return React.createElement(Icon_1.Icon, { iconName: isItemChecked ? 'CheckMark' : '', className: classNames.checkmarkIcon, onClick: onClick });
	    }
	    return null;
	};
	var renderItemName = function (_a) {
	    var item = _a.item, classNames = _a.classNames;
	    if (item.text || item.name) {
	        return React.createElement("span", { className: classNames.label }, item.text || item.name);
	    }
	    return null;
	};
	var renderSecondaryText = function (_a) {
	    var item = _a.item, classNames = _a.classNames;
	    if (item.secondaryText) {
	        return React.createElement("span", { className: classNames.secondaryText }, item.secondaryText);
	    }
	    return null;
	};
	var renderSubMenuIcon = function (_a) {
	    var item = _a.item, classNames = _a.classNames;
	    if (index_1.hasSubmenu(item)) {
	        return React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: Utilities_1.getRTL() ? 'ChevronLeft' : 'ChevronRight' }, item.submenuIconProps, { className: classNames.subMenuIcon }));
	    }
	    return null;
	};
	var ContextualMenuItemBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuItemBase, _super);
	    function ContextualMenuItemBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.openSubMenu = function () {
	            var _a = _this.props, item = _a.item, openSubMenu = _a.openSubMenu, getSubmenuTarget = _a.getSubmenuTarget;
	            if (getSubmenuTarget) {
	                var submenuTarget = getSubmenuTarget();
	                if (index_1.hasSubmenu(item) && openSubMenu && submenuTarget) {
	                    openSubMenu(item, submenuTarget);
	                }
	            }
	        };
	        _this.dismissSubMenu = function () {
	            var _a = _this.props, item = _a.item, dismissSubMenu = _a.dismissSubMenu;
	            if (index_1.hasSubmenu(item) && dismissSubMenu) {
	                dismissSubMenu();
	            }
	        };
	        _this.dismissMenu = function (dismissAll) {
	            var dismissMenu = _this.props.dismissMenu;
	            if (dismissMenu) {
	                dismissMenu(undefined /* ev */, dismissAll);
	            }
	        };
	        return _this;
	    }
	    ContextualMenuItemBase.prototype.render = function () {
	        var _a = this.props, item = _a.item, classNames = _a.classNames;
	        return (React.createElement("div", { className: item.split ? classNames.linkContentMenu : classNames.linkContent },
	            renderCheckMarkIcon(this.props),
	            renderItemIcon(this.props),
	            renderItemName(this.props),
	            renderSecondaryText(this.props),
	            renderSubMenuIcon(this.props)));
	    };
	    return ContextualMenuItemBase;
	}(Utilities_1.BaseComponent));
	exports.ContextualMenuItemBase = ContextualMenuItemBase;
	//# sourceMappingURL=ContextualMenuItem.base.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var VerticalDivider_classNames_1 = __webpack_require__(706);
	var ContextualMenu_cnstyles_1 = __webpack_require__(707);
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var MediumScreenSelector = Styling_1.getScreenSelector(0, Styling_1.ScreenWidthMaxMedium);
	exports.getSplitButtonVerticalDividerClassNames = Utilities_1.memoizeFunction(function (theme) {
	    return Styling_1.mergeStyleSets(VerticalDivider_classNames_1.getDividerClassNames(theme), {
	        wrapper: {
	            position: 'absolute',
	            right: 28,
	            selectors: (_a = {},
	                _a[MediumScreenSelector] = {
	                    right: 32 // fontSize of the icon increased from 12px to 16px
	                },
	                _a)
	        },
	        divider: {
	            height: 16,
	            width: 1
	        }
	    });
	    var _a;
	});
	var GlobalClassNames = {
	    item: 'ms-ContextualMenu-item',
	    divider: 'ms-ContextualMenu-divider',
	    root: 'ms-ContextualMenu-link',
	    isChecked: 'is-checked',
	    isExpanded: 'is-expanded',
	    isDisabled: 'is-disabled',
	    linkContent: 'ms-ContextualMenu-linkContent',
	    linkContentMenu: 'ms-ContextualMenu-linkContent',
	    icon: 'ms-ContextualMenu-icon',
	    iconColor: 'ms-ContextualMenu-iconColor',
	    checkmarkIcon: 'ms-ContextualMenu-checkmarkIcon',
	    subMenuIcon: 'ms-ContextualMenu-submenuIcon',
	    label: 'ms-ContextualMenu-itemText',
	    secondaryText: 'ms-ContextualMenu-secondaryText'
	};
	/**
	 * @deprecated To be removed in 7.0.
	 * @internal
	 * This is a package-internal method that has been depended on.
	 * It is being kept in this form for backwards compatibility.
	 * It should be cleaned up in 7.0.
	 *
	 * TODO: Audit perf. impact of and potentially remove memoizeFunction.
	 * https://github.com/OfficeDev/office-ui-fabric-react/issues/5534
	 */
	exports.getItemClassNames = Utilities_1.memoizeFunction(function (theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className) {
	    var styles = ContextualMenu_cnstyles_1.getMenuItemStyles(theme);
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return Styling_1.mergeStyleSets({
	        item: [classNames.item, styles.item, itemClassName],
	        divider: [classNames.divider, styles.divider, dividerClassName],
	        root: [
	            classNames.root,
	            styles.root,
	            checked && [classNames.isChecked, styles.rootChecked],
	            isAnchorLink && styles.anchorLink,
	            expanded && [classNames.isExpanded, styles.rootExpanded],
	            disabled && [classNames.isDisabled, styles.rootDisabled],
	            !disabled &&
	                !expanded && [
	                {
	                    selectors: (_a = {
	                            ':hover': styles.rootHovered,
	                            ':active': styles.rootPressed
	                        },
	                        _a["." + Utilities_1.IsFocusVisibleClassName + " &:focus, ." + Utilities_1.IsFocusVisibleClassName + " &:focus:hover"] = styles.rootFocused,
	                        _a["." + Utilities_1.IsFocusVisibleClassName + " &:hover"] = { background: 'inherit;' },
	                        _a)
	                }
	            ],
	            className
	        ],
	        splitPrimary: [
	            styles.root,
	            checked && ['is-checked', styles.rootChecked],
	            (disabled || primaryDisabled) && ['is-disabled', styles.rootDisabled],
	            !(disabled || primaryDisabled) &&
	                !checked && [
	                {
	                    selectors: (_b = {
	                            ':hover': styles.rootHovered,
	                            ':hover ~ $splitMenu': styles.rootHovered,
	                            ':active': styles.rootPressed
	                        },
	                        _b["." + Utilities_1.IsFocusVisibleClassName + " &:focus, ." + Utilities_1.IsFocusVisibleClassName + " &:focus:hover"] = styles.rootFocused,
	                        _b["." + Utilities_1.IsFocusVisibleClassName + " &:hover"] = { background: 'inherit;' },
	                        _b)
	                }
	            ]
	        ],
	        splitMenu: [
	            styles.root,
	            {
	                flexBasis: '0',
	                padding: '0 8px',
	                minWidth: 28
	            },
	            expanded && ['is-expanded', styles.rootExpanded],
	            disabled && ['is-disabled', styles.rootDisabled],
	            !disabled &&
	                !expanded && [
	                {
	                    selectors: (_c = {
	                            ':hover': styles.rootHovered,
	                            ':active': styles.rootPressed
	                        },
	                        _c["." + Utilities_1.IsFocusVisibleClassName + " &:focus, ." + Utilities_1.IsFocusVisibleClassName + " &:focus:hover"] = styles.rootFocused,
	                        _c["." + Utilities_1.IsFocusVisibleClassName + " &:hover"] = { background: 'inherit;' },
	                        _c)
	                }
	            ]
	        ],
	        anchorLink: styles.anchorLink,
	        linkContent: [classNames.linkContent, styles.linkContent],
	        linkContentMenu: [
	            classNames.linkContentMenu,
	            styles.linkContent,
	            {
	                justifyContent: 'center'
	            }
	        ],
	        icon: [
	            classNames.icon,
	            knownIcon && styles.iconColor,
	            styles.icon,
	            iconClassName,
	            disabled && [classNames.isDisabled, styles.iconDisabled]
	        ],
	        iconColor: styles.iconColor,
	        checkmarkIcon: [classNames.checkmarkIcon, knownIcon && styles.checkmarkIcon, styles.icon, iconClassName],
	        subMenuIcon: [classNames.subMenuIcon, styles.subMenuIcon, subMenuClassName],
	        label: [classNames.label, styles.label],
	        secondaryText: [classNames.secondaryText, styles.secondaryText],
	        splitContainer: [
	            styles.splitButtonFlexContainer,
	            {
	                alignItems: 'flex-start'
	            },
	            !disabled &&
	                !checked && [
	                {
	                    selectors: (_d = {},
	                        _d["." + Utilities_1.IsFocusVisibleClassName + " &:focus, ." + Utilities_1.IsFocusVisibleClassName + " &:focus:hover"] = styles.rootFocused,
	                        _d)
	                }
	            ]
	        ]
	    });
	    var _a, _b, _c, _d;
	});
	/**
	 * Wrapper function for generating ContextualMenuItem classNames which adheres to
	 * the getStyles API, but invokes memoized className generator function with
	 * primitive values.
	 *
	 * @param props the ContextualMenuItem style props used to generate its styles.
	 */
	exports.getItemStyles = function (props) {
	    var theme = props.theme, disabled = props.disabled, expanded = props.expanded, checked = props.checked, isAnchorLink = props.isAnchorLink, knownIcon = props.knownIcon, itemClassName = props.itemClassName, dividerClassName = props.dividerClassName, iconClassName = props.iconClassName, subMenuClassName = props.subMenuClassName, primaryDisabled = props.primaryDisabled, className = props.className;
	    return exports.getItemClassNames(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className);
	};
	//# sourceMappingURL=ContextualMenu.classNames.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	/**
	 * @deprecated use getStyles exported from VerticalDivider.styles.ts
	 */
	exports.getDividerClassNames = Utilities_1.memoizeFunction(function (theme) {
	    return Styling_1.mergeStyleSets({
	        wrapper: {
	            display: 'inline-flex',
	            height: '100%',
	            alignItems: 'center'
	        },
	        divider: {
	            width: 1,
	            height: '100%',
	            backgroundColor: theme.palette.neutralTertiaryAlt
	        }
	    });
	});
	//# sourceMappingURL=VerticalDivider.classNames.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	exports.CONTEXTUAL_MENU_ITEM_HEIGHT = '32px';
	var MediumScreenSelector = Styling_1.getScreenSelector(0, Styling_1.ScreenWidthMaxMedium);
	var getItemHighContrastStyles = Utilities_1.memoizeFunction(function () {
	    return {
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                backgroundColor: 'Highlight',
	                borderColor: 'Highlight',
	                color: 'HighlightText',
	                MsHighContrastAdjust: 'none'
	            },
	            _a)
	    };
	    var _a;
	});
	exports.getMenuItemStyles = Utilities_1.memoizeFunction(function (theme) {
	    var semanticColors = theme.semanticColors, fonts = theme.fonts;
	    var ContextualMenuItemBackgroundHoverColor = semanticColors.menuItemBackgroundHovered;
	    var ContextualMenuItemBackgroundSelectedColor = semanticColors.menuItemBackgroundChecked;
	    var ContextualMenuItemDividerColor = semanticColors.bodyDivider;
	    var menuItemStyles = {
	        item: [
	            fonts.medium,
	            {
	                color: semanticColors.bodyText,
	                position: 'relative',
	                boxSizing: 'border-box'
	            }
	        ],
	        divider: {
	            display: 'block',
	            height: '1px',
	            backgroundColor: ContextualMenuItemDividerColor,
	            position: 'relative'
	        },
	        root: [
	            Styling_1.getFocusStyle(theme),
	            fonts.medium,
	            {
	                color: semanticColors.bodyText,
	                backgroundColor: 'transparent',
	                border: 'none',
	                width: '100%',
	                height: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	                lineHeight: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	                display: 'block',
	                cursor: 'pointer',
	                padding: '0px 8px 0 4px',
	                textAlign: 'left'
	            }
	        ],
	        rootDisabled: {
	            color: semanticColors.disabledBodyText,
	            cursor: 'default',
	            pointerEvents: 'none',
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText',
	                    opacity: 1
	                },
	                _a)
	        },
	        rootHovered: tslib_1.__assign({ backgroundColor: ContextualMenuItemBackgroundHoverColor }, getItemHighContrastStyles()),
	        rootFocused: tslib_1.__assign({ backgroundColor: ContextualMenuItemBackgroundHoverColor }, getItemHighContrastStyles()),
	        rootChecked: tslib_1.__assign({}, getItemHighContrastStyles()),
	        rootPressed: tslib_1.__assign({ backgroundColor: ContextualMenuItemBackgroundSelectedColor }, getItemHighContrastStyles()),
	        rootExpanded: tslib_1.__assign({ backgroundColor: ContextualMenuItemBackgroundSelectedColor, color: semanticColors.bodyTextChecked }, getItemHighContrastStyles()),
	        linkContent: {
	            whiteSpace: 'nowrap',
	            height: 'inherit',
	            display: 'flex',
	            alignItems: 'center',
	            maxWidth: '100%'
	        },
	        anchorLink: {
	            padding: '0px 8px 0 4px',
	            textRendering: 'auto',
	            color: 'inherit',
	            letterSpacing: 'normal',
	            wordSpacing: 'normal',
	            textTransform: 'none',
	            textIndent: '0px',
	            textShadow: 'none',
	            textDecoration: 'none',
	            boxSizing: 'border-box'
	        },
	        label: {
	            margin: '0 4px',
	            verticalAlign: 'middle',
	            display: 'inline-block',
	            flexGrow: '1',
	            textOverflow: 'ellipsis',
	            overflow: 'hidden',
	            whiteSpace: 'nowrap'
	        },
	        secondaryText: {
	            color: theme.palette.neutralSecondary,
	            paddingLeft: '20px',
	            textAlign: 'right'
	        },
	        icon: {
	            display: 'inline-block',
	            minHeight: '1px',
	            maxHeight: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	            width: '14px',
	            margin: '0 4px',
	            verticalAlign: 'middle',
	            flexShrink: '0'
	        },
	        iconColor: {
	            color: semanticColors.menuIcon,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'inherit'
	                },
	                _b['$root:hover &'] = {
	                    selectors: (_c = {},
	                        _c[Styling_1.HighContrastSelector] = {
	                            color: 'HighlightText'
	                        },
	                        _c)
	                },
	                _b['$root:focus &'] = {
	                    selectors: (_d = {},
	                        _d[Styling_1.HighContrastSelector] = {
	                            color: 'HighlightText'
	                        },
	                        _d)
	                },
	                _b)
	        },
	        iconDisabled: {
	            color: semanticColors.disabledBodyText
	        },
	        checkmarkIcon: {
	            color: semanticColors.bodySubtext,
	            selectors: (_e = {},
	                _e[Styling_1.HighContrastSelector] = {
	                    color: 'HighlightText'
	                },
	                _e)
	        },
	        subMenuIcon: {
	            height: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	            lineHeight: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	            textAlign: 'center',
	            display: 'inline-block',
	            verticalAlign: 'middle',
	            flexShrink: '0',
	            fontSize: Styling_1.FontSizes.small,
	            selectors: (_f = {},
	                _f[MediumScreenSelector] = {
	                    fontSize: Styling_1.FontSizes.icon // 16px
	                },
	                _f)
	        },
	        splitButtonFlexContainer: [
	            Styling_1.getFocusStyle(theme),
	            {
	                display: 'flex',
	                height: exports.CONTEXTUAL_MENU_ITEM_HEIGHT,
	                flexWrap: 'nowrap',
	                justifyContent: 'center',
	                alignItems: 'center'
	            }
	        ]
	    };
	    return Styling_1.concatStyleSets(menuItemStyles);
	    var _a, _b, _c, _d, _e, _f;
	});
	//# sourceMappingURL=ContextualMenu.cnstyles.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(709), exports);
	tslib_1.__exportStar(__webpack_require__(711), exports);
	tslib_1.__exportStar(__webpack_require__(712), exports);
	tslib_1.__exportStar(__webpack_require__(710), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenuItemWrapper_1 = __webpack_require__(710);
	var KeytipData_1 = __webpack_require__(684);
	var index_1 = __webpack_require__(699);
	var ContextualMenuItem_1 = __webpack_require__(703);
	var ContextualMenuAnchor = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuAnchor, _super);
	    function ContextualMenuAnchor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._anchor = React.createRef();
	        _this._getSubmenuTarget = function () {
	            return _this._anchor.current ? _this._anchor.current : undefined;
	        };
	        _this._onItemClick = function (ev) {
	            var _a = _this.props, item = _a.item, onItemClick = _a.onItemClick;
	            if (onItemClick) {
	                onItemClick(item, ev);
	            }
	        };
	        return _this;
	    }
	    ContextualMenuAnchor.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? ContextualMenuItem_1.ContextualMenuItem : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
	        var anchorRel = item.rel;
	        if (item.target && item.target.toLowerCase() === '_blank') {
	            anchorRel = anchorRel ? anchorRel : 'nofollow noopener noreferrer'; // Safe default to prevent tabjacking
	        }
	        var subMenuId = this._getSubMenuId(item);
	        var itemHasSubmenu = index_1.hasSubmenu(item);
	        var nativeProps = Utilities_1.getNativeProps(item, Utilities_1.anchorProperties);
	        var disabled = index_1.isItemDisabled(item);
	        var itemProps = item.itemProps;
	        var keytipProps = item.keytipProps;
	        if (keytipProps && itemHasSubmenu) {
	            keytipProps = tslib_1.__assign({}, keytipProps, { hasMenu: true });
	        }
	        return (React.createElement("div", null,
	            React.createElement(KeytipData_1.KeytipData, { keytipProps: item.keytipProps, ariaDescribedBy: nativeProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (React.createElement("a", tslib_1.__assign({}, nativeProps, keytipAttributes, { ref: _this._anchor, href: item.href, target: item.target, rel: anchorRel, className: classNames.root, role: "menuitem", "aria-owns": item.key === expandedMenuItemKey ? subMenuId : undefined, "aria-haspopup": itemHasSubmenu || undefined, "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, "aria-disabled": index_1.isItemDisabled(item), style: item.style, onClick: _this._onItemClick, onMouseEnter: _this._onItemMouseEnter, onMouseLeave: _this._onItemMouseLeave, onMouseMove: _this._onItemMouseMove, onKeyDown: itemHasSubmenu ? _this._onItemKeyDown : undefined }),
	                React.createElement(ChildrenRenderer, tslib_1.__assign({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)))); })));
	    };
	    return ContextualMenuAnchor;
	}(ContextualMenuItemWrapper_1.ContextualMenuItemWrapper));
	exports.ContextualMenuAnchor = ContextualMenuAnchor;
	//# sourceMappingURL=ContextualMenuAnchor.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenuItemWrapper = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuItemWrapper, _super);
	    function ContextualMenuItemWrapper() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onItemMouseEnter = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
	            if (onItemMouseEnter) {
	                onItemMouseEnter(item, ev, ev.currentTarget);
	            }
	        };
	        _this._onItemClick = function (ev) {
	            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
	            if (onItemClickBase) {
	                onItemClickBase(item, ev, ev.currentTarget);
	            }
	        };
	        _this._onItemMouseLeave = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseLeave = _a.onItemMouseLeave;
	            if (onItemMouseLeave) {
	                onItemMouseLeave(item, ev);
	            }
	        };
	        _this._onItemKeyDown = function (ev) {
	            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
	            if (onItemKeyDown) {
	                onItemKeyDown(item, ev);
	            }
	        };
	        _this._onItemMouseMove = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
	            if (onItemMouseMove) {
	                onItemMouseMove(item, ev, ev.currentTarget);
	            }
	        };
	        _this._getSubMenuId = function (item) {
	            var getSubMenuId = _this.props.getSubMenuId;
	            if (getSubMenuId) {
	                return getSubMenuId(item);
	            }
	        };
	        _this._getSubmenuTarget = function () {
	            return undefined;
	        };
	        return _this;
	    }
	    ContextualMenuItemWrapper.prototype.shouldComponentUpdate = function (newProps) {
	        return !Utilities_1.shallowCompare(newProps, this.props);
	    };
	    return ContextualMenuItemWrapper;
	}(Utilities_1.BaseComponent));
	exports.ContextualMenuItemWrapper = ContextualMenuItemWrapper;
	//# sourceMappingURL=ContextualMenuItemWrapper.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenuItemWrapper_1 = __webpack_require__(710);
	var KeytipData_1 = __webpack_require__(684);
	var index_1 = __webpack_require__(699);
	var ContextualMenuItem_1 = __webpack_require__(703);
	var ContextualMenuButton = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuButton, _super);
	    function ContextualMenuButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._btn = React.createRef();
	        _this._getSubmenuTarget = function () {
	            return _this._btn.current ? _this._btn.current : undefined;
	        };
	        return _this;
	    }
	    ContextualMenuButton.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? ContextualMenuItem_1.ContextualMenuItem : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemMouseDown = _a.onItemMouseDown, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
	        var subMenuId = this._getSubMenuId(item);
	        var isChecked = index_1.getIsChecked(item);
	        var canCheck = isChecked !== null;
	        var defaultRole = canCheck ? 'menuitemcheckbox' : 'menuitem';
	        var itemHasSubmenu = index_1.hasSubmenu(item);
	        var itemProps = item.itemProps, ariaLabel = item.ariaLabel;
	        var buttonNativeProperties = Utilities_1.getNativeProps(item, Utilities_1.buttonProperties);
	        // Do not add the disabled attribute to the button so that it is focusable
	        delete buttonNativeProperties.disabled;
	        var itemButtonProperties = {
	            className: classNames.root,
	            onClick: this._onItemClick,
	            onKeyDown: itemHasSubmenu ? this._onItemKeyDown : undefined,
	            onMouseEnter: this._onItemMouseEnter,
	            onMouseLeave: this._onItemMouseLeave,
	            onMouseDown: function (ev) { return (onItemMouseDown ? onItemMouseDown(item, ev) : undefined); },
	            onMouseMove: this._onItemMouseMove,
	            href: item.href,
	            title: item.title,
	            'aria-label': ariaLabel,
	            'aria-haspopup': itemHasSubmenu || undefined,
	            'aria-owns': item.key === expandedMenuItemKey ? subMenuId : undefined,
	            'aria-expanded': itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
	            'aria-checked': canCheck ? !!isChecked : undefined,
	            'aria-posinset': focusableElementIndex + 1,
	            'aria-setsize': totalItemCount,
	            'aria-disabled': index_1.isItemDisabled(item),
	            role: item.role || defaultRole,
	            style: item.style
	        };
	        var keytipProps = item.keytipProps;
	        if (keytipProps && itemHasSubmenu) {
	            keytipProps = tslib_1.__assign({}, keytipProps, { hasMenu: true });
	        }
	        return (React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, ariaDescribedBy: buttonNativeProperties['aria-describedby'], disabled: index_1.isItemDisabled(item) }, function (keytipAttributes) { return (React.createElement("button", tslib_1.__assign({ ref: _this._btn }, buttonNativeProperties, itemButtonProperties, keytipAttributes),
	            React.createElement(ChildrenRenderer, tslib_1.__assign({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)))); }));
	    };
	    return ContextualMenuButton;
	}(ContextualMenuItemWrapper_1.ContextualMenuItemWrapper));
	exports.ContextualMenuButton = ContextualMenuButton;
	//# sourceMappingURL=ContextualMenuButton.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenuItem_1 = __webpack_require__(703);
	var ContextualMenu_classNames_1 = __webpack_require__(705);
	var KeytipData_1 = __webpack_require__(684);
	var index_1 = __webpack_require__(699);
	var Divider_1 = __webpack_require__(713);
	var ContextualMenuItemWrapper_1 = __webpack_require__(710);
	var TouchIdleDelay = 500; /* ms */
	var ContextualMenuSplitButton = /** @class */ (function (_super) {
	    tslib_1.__extends(ContextualMenuSplitButton, _super);
	    function ContextualMenuSplitButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onItemKeyDown = function (ev) {
	            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._executeItemClick(ev);
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	            else if (onItemKeyDown) {
	                onItemKeyDown(item, ev);
	            }
	        };
	        _this._getSubmenuTarget = function () {
	            return _this._splitButton;
	        };
	        _this._onItemMouseEnterPrimary = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
	            if (onItemMouseEnter) {
	                onItemMouseEnter(tslib_1.__assign({}, item, { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
	            }
	        };
	        _this._onItemMouseEnterIcon = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
	            if (onItemMouseEnter) {
	                onItemMouseEnter(item, ev, _this._splitButton);
	            }
	        };
	        _this._onItemMouseMovePrimary = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
	            if (onItemMouseMove) {
	                onItemMouseMove(tslib_1.__assign({}, item, { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
	            }
	        };
	        _this._onItemMouseMoveIcon = function (ev) {
	            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
	            if (onItemMouseMove) {
	                onItemMouseMove(item, ev, _this._splitButton);
	            }
	        };
	        _this._onIconItemClick = function (ev) {
	            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
	            if (onItemClickBase) {
	                onItemClickBase(item, ev, (_this._splitButton ? _this._splitButton : ev.currentTarget));
	            }
	        };
	        _this._executeItemClick = function (ev) {
	            var _a = _this.props, item = _a.item, executeItemClick = _a.executeItemClick, onItemClick = _a.onItemClick;
	            if (item.disabled || item.isDisabled) {
	                return;
	            }
	            if (_this._processingTouch && onItemClick) {
	                return onItemClick(item, ev);
	            }
	            if (executeItemClick) {
	                executeItemClick(item, ev);
	            }
	        };
	        _this._onTouchStart = function (ev) {
	            if (_this._splitButton && !('onpointerdown' in _this._splitButton)) {
	                _this._handleTouchAndPointerEvent(ev);
	            }
	        };
	        _this._onPointerDown = function (ev) {
	            if (ev.pointerType === 'touch') {
	                _this._handleTouchAndPointerEvent(ev);
	                ev.preventDefault();
	                ev.stopImmediatePropagation();
	            }
	        };
	        return _this;
	    }
	    ContextualMenuSplitButton.prototype.componentDidMount = function () {
	        if (this._splitButton && 'onpointerdown' in this._splitButton) {
	            this._events.on(this._splitButton, 'pointerdown', this._onPointerDown, true);
	        }
	    };
	    ContextualMenuSplitButton.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, onItemMouseLeave = _a.onItemMouseLeave, expandedMenuItemKey = _a.expandedMenuItemKey;
	        var itemHasSubmenu = index_1.hasSubmenu(item);
	        var keytipProps = item.keytipProps;
	        if (keytipProps) {
	            keytipProps = tslib_1.__assign({}, keytipProps, { hasMenu: true });
	        }
	        return (React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: index_1.isItemDisabled(item) }, function (keytipAttributes) { return (React.createElement("div", { "data-ktp-target": keytipAttributes['data-ktp-target'], ref: function (splitButton) { return (_this._splitButton = splitButton); }, role: 'menuitem', "aria-label": item.ariaLabel, className: classNames.splitContainer, "aria-disabled": index_1.isItemDisabled(item), "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-haspopup": true, "aria-describedby": Utilities_1.mergeAriaAttributeValues(item.ariaDescription, keytipAttributes['aria-describedby']), "aria-checked": item.isChecked || item.checked, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, onMouseEnter: _this._onItemMouseEnterPrimary, onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(_this, tslib_1.__assign({}, item, { subMenuProps: null, items: null })) : undefined, onMouseMove: _this._onItemMouseMovePrimary, onKeyDown: _this._onItemKeyDown, onClick: _this._executeItemClick, onTouchStart: _this._onTouchStart, tabIndex: 0, "data-is-focusable": true, "aria-roledescription": item['aria-roledescription'] },
	            _this._renderSplitPrimaryButton(item, classNames, index, hasCheckmarks, hasIcons),
	            _this._renderSplitDivider(item),
	            _this._renderSplitIconButton(item, classNames, index, keytipAttributes))); }));
	    };
	    ContextualMenuSplitButton.prototype._renderSplitPrimaryButton = function (item, classNames, index, hasCheckmarks, hasIcons) {
	        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? ContextualMenuItem_1.ContextualMenuItem : _b, onItemClick = _a.onItemClick;
	        var itemProps = {
	            key: item.key,
	            disabled: index_1.isItemDisabled(item) || item.primaryDisabled,
	            name: item.name,
	            text: item.text || item.name,
	            className: classNames.splitPrimary,
	            canCheck: item.canCheck,
	            isChecked: item.isChecked,
	            checked: item.checked,
	            iconProps: item.iconProps,
	            'data-is-focusable': false,
	            'aria-hidden': true
	        };
	        var itemComponentProps = item.itemProps;
	        return (React.createElement("button", tslib_1.__assign({}, Utilities_1.getNativeProps(itemProps, Utilities_1.buttonProperties)),
	            React.createElement(ChildrenRenderer, tslib_1.__assign({ "data-is-focusable": false, item: itemProps, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons }, itemComponentProps))));
	    };
	    ContextualMenuSplitButton.prototype._renderSplitDivider = function (item) {
	        var getDividerClassNames = item.getSplitButtonVerticalDividerClassNames || ContextualMenu_classNames_1.getSplitButtonVerticalDividerClassNames;
	        return React.createElement(Divider_1.VerticalDivider, { getClassNames: getDividerClassNames });
	    };
	    ContextualMenuSplitButton.prototype._renderSplitIconButton = function (item, classNames, index, keytipAttributes) {
	        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? ContextualMenuItem_1.ContextualMenuItem : _b, onItemMouseLeave = _a.onItemMouseLeave, onItemMouseDown = _a.onItemMouseDown, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
	        var itemProps = {
	            onClick: this._onIconItemClick,
	            disabled: index_1.isItemDisabled(item),
	            className: classNames.splitMenu,
	            subMenuProps: item.subMenuProps,
	            submenuIconProps: item.submenuIconProps,
	            split: true,
	            key: item.key
	        };
	        var buttonProps = tslib_1.__assign({}, Utilities_1.getNativeProps(itemProps, Utilities_1.buttonProperties), {
	            onMouseEnter: this._onItemMouseEnterIcon,
	            onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(this, item) : undefined,
	            onMouseDown: function (ev) { return (onItemMouseDown ? onItemMouseDown(item, ev) : undefined); },
	            onMouseMove: this._onItemMouseMoveIcon,
	            'data-is-focusable': false,
	            'data-ktp-execute-target': keytipAttributes['data-ktp-execute-target'],
	            'aria-hidden': true
	        });
	        var itemComponentProps = item.itemProps;
	        return (React.createElement("button", tslib_1.__assign({}, buttonProps),
	            React.createElement(ChildrenRenderer, tslib_1.__assign({ componentRef: item.componentRef, item: itemProps, classNames: classNames, index: index, hasIcons: false, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: this._getSubmenuTarget }, itemComponentProps))));
	    };
	    ContextualMenuSplitButton.prototype._handleTouchAndPointerEvent = function (ev) {
	        var _this = this;
	        var onTap = this.props.onTap;
	        if (onTap) {
	            onTap(ev);
	        }
	        // If we already have an existing timeout from a previous touch/pointer event
	        // cancel that timeout so we can set a new one.
	        if (this._lastTouchTimeoutId) {
	            this._async.clearTimeout(this._lastTouchTimeoutId);
	            this._lastTouchTimeoutId = undefined;
	        }
	        this._processingTouch = true;
	        this._lastTouchTimeoutId = this._async.setTimeout(function () {
	            _this._processingTouch = false;
	            _this._lastTouchTimeoutId = undefined;
	        }, TouchIdleDelay);
	    };
	    return ContextualMenuSplitButton;
	}(ContextualMenuItemWrapper_1.ContextualMenuItemWrapper));
	exports.ContextualMenuSplitButton = ContextualMenuSplitButton;
	//# sourceMappingURL=ContextualMenuSplitButton.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(714), exports);
	//# sourceMappingURL=Divider.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(715), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var VerticalDivider_styles_1 = __webpack_require__(716);
	var VerticalDivider_base_1 = __webpack_require__(717);
	var Utilities_1 = __webpack_require__(592);
	exports.VerticalDivider = Utilities_1.styled(VerticalDivider_base_1.VerticalDividerBase, VerticalDivider_styles_1.getStyles, undefined, {
	    scope: 'VerticalDivider'
	});
	//# sourceMappingURL=VerticalDivider.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    var theme = props.theme, getClassNames = props.getClassNames, className = props.className;
	    if (!theme) {
	        throw new Error('Theme is undefined or null.');
	    }
	    if (getClassNames) {
	        var names = getClassNames(theme);
	        return {
	            wrapper: [names.wrapper],
	            divider: [names.divider]
	        };
	    }
	    return {
	        wrapper: [
	            {
	                display: 'inline-flex',
	                height: '100%',
	                alignItems: 'center'
	            },
	            className
	        ],
	        divider: [
	            {
	                width: 1,
	                height: '100%',
	                backgroundColor: theme.palette.neutralTertiaryAlt
	            }
	        ]
	    };
	};
	//# sourceMappingURL=VerticalDivider.styles.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.VerticalDividerBase = function (props) {
	    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
	    var classNames = getClassNames(styles, { theme: theme, getClassNames: deprecatedGetClassNames, className: className });
	    return (React.createElement("span", { className: classNames.wrapper },
	        React.createElement("span", { className: classNames.divider })));
	};
	//# sourceMappingURL=VerticalDivider.base.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var ContextualMenu_cnstyles_1 = __webpack_require__(707);
	var GlobalClassNames = {
	    root: 'ms-ContextualMenu',
	    container: 'ms-ContextualMenu-container',
	    list: 'ms-ContextualMenu-list',
	    header: 'ms-ContextualMenu-header',
	    title: 'ms-ContextualMenu-title',
	    isopen: 'is-open'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var palette = theme.palette, fonts = theme.fonts, semanticColors = theme.semanticColors;
	    return {
	        root: [
	            theme.fonts.medium,
	            classNames.root,
	            classNames.isopen,
	            {
	                backgroundColor: semanticColors.bodyBackground,
	                minWidth: '180px'
	            },
	            className
	        ],
	        container: [
	            classNames.container,
	            {
	                selectors: {
	                    ':focus': { outline: 0 }
	                }
	            }
	        ],
	        list: [
	            classNames.list,
	            classNames.isopen,
	            {
	                listStyleType: 'none',
	                margin: '0',
	                padding: '0'
	            }
	        ],
	        header: [
	            classNames.header,
	            fonts.small,
	            {
	                fontWeight: Styling_1.FontWeights.semibold,
	                color: semanticColors.menuHeader,
	                background: 'none',
	                backgroundColor: 'transparent',
	                border: 'none',
	                height: ContextualMenu_cnstyles_1.CONTEXTUAL_MENU_ITEM_HEIGHT,
	                lineHeight: ContextualMenu_cnstyles_1.CONTEXTUAL_MENU_ITEM_HEIGHT,
	                cursor: 'default',
	                padding: '0px 6px',
	                userSelect: 'none',
	                textAlign: 'left'
	            }
	        ],
	        title: [
	            classNames.title,
	            {
	                fontSize: '16px',
	                paddingRight: '14px',
	                paddingLeft: '14px',
	                paddingBottom: '5px',
	                paddingTop: '5px',
	                backgroundColor: palette.neutralLight
	            }
	        ],
	        subComponentStyles: { callout: {}, menuItem: {} }
	    };
	};
	//# sourceMappingURL=ContextualMenu.styles.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	var Styling_2 = __webpack_require__(463);
	exports.ButtonGlobalClassNames = {
	    msButton: 'ms-Button',
	    msButtonIcon: 'ms-Button-icon',
	    msButtonMenuIcon: 'ms-Button-menuIcon',
	    msButtonLabel: 'ms-Button-label',
	    msButtonDescription: 'ms-Button-description',
	    msButtonScreenReaderText: 'ms-Button-screenReaderText',
	    msButtonFlexContainer: 'ms-Button-flexContainer',
	    msButtonTextContainer: 'ms-Button-textContainer'
	};
	exports.getBaseButtonClassNames = Utilities_1.memoizeFunction(function (theme, styles, className, variantClassName, iconClassName, menuIconClassName, disabled, checked, expanded, isSplit) {
	    var classNames = Styling_2.getGlobalClassNames(exports.ButtonGlobalClassNames, theme || {});
	    var isExpanded = expanded && !isSplit;
	    return Styling_1.mergeStyleSets({
	        root: [
	            classNames.msButton,
	            styles.root,
	            variantClassName,
	            checked && ['is-checked', styles.rootChecked],
	            isExpanded && [
	                'is-expanded',
	                styles.rootExpanded,
	                {
	                    selectors: (_a = {},
	                        _a[":hover ." + classNames.msButtonIcon] = styles.iconExpandedHovered,
	                        // menuIcon falls back to rootExpandedHovered to support original behavior
	                        _a[":hover ." + classNames.msButtonMenuIcon] = styles.menuIconExpandedHovered || styles.rootExpandedHovered,
	                        _a[':hover'] = styles.rootExpandedHovered,
	                        _a)
	                }
	            ],
	            disabled && ['is-disabled', styles.rootDisabled],
	            !disabled &&
	                !isExpanded &&
	                !checked && {
	                selectors: (_b = {
	                        ':hover': styles.rootHovered
	                    },
	                    _b[":hover ." + classNames.msButtonLabel] = styles.labelHovered,
	                    _b[":hover ." + classNames.msButtonIcon] = styles.iconHovered,
	                    _b[":hover ." + classNames.msButtonDescription] = styles.descriptionHovered,
	                    _b[":hover ." + classNames.msButtonMenuIcon] = styles.menuIconHovered,
	                    _b[':focus'] = styles.rootFocused,
	                    _b[':active'] = styles.rootPressed,
	                    _b[":active ." + classNames.msButtonIcon] = styles.iconPressed,
	                    _b[":active ." + classNames.msButtonDescription] = styles.descriptionPressed,
	                    _b[":active ." + classNames.msButtonMenuIcon] = styles.menuIconPressed,
	                    _b)
	            },
	            disabled && checked && [styles.rootCheckedDisabled],
	            !disabled &&
	                checked && {
	                selectors: {
	                    ':hover': styles.rootCheckedHovered,
	                    ':active': styles.rootCheckedPressed
	                }
	            },
	            className
	        ],
	        flexContainer: [classNames.msButtonFlexContainer, styles.flexContainer],
	        textContainer: [classNames.msButtonTextContainer, styles.textContainer],
	        icon: [
	            classNames.msButtonIcon,
	            iconClassName,
	            styles.icon,
	            isExpanded && styles.iconExpanded,
	            checked && styles.iconChecked,
	            disabled && styles.iconDisabled
	        ],
	        label: [classNames.msButtonLabel, styles.label, checked && styles.labelChecked, disabled && styles.labelDisabled],
	        menuIcon: [
	            classNames.msButtonMenuIcon,
	            menuIconClassName,
	            styles.menuIcon,
	            checked && styles.menuIconChecked,
	            disabled && !isSplit && styles.menuIconDisabled,
	            !disabled &&
	                !isExpanded &&
	                !checked && {
	                selectors: {
	                    ':hover': styles.menuIconHovered,
	                    ':active': styles.menuIconPressed
	                }
	            },
	            isExpanded && ['is-expanded', styles.menuIconExpanded]
	        ],
	        description: [
	            classNames.msButtonDescription,
	            styles.description,
	            checked && styles.descriptionChecked,
	            disabled && styles.descriptionDisabled
	        ],
	        screenReaderText: [classNames.msButtonScreenReaderText, styles.screenReaderText]
	    });
	    var _a, _b;
	});
	//# sourceMappingURL=BaseButton.classNames.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, expanded, checked, primaryDisabled) {
	    return {
	        root: Styling_1.mergeStyles(styles.splitButtonMenuButton, expanded && [styles.splitButtonMenuButtonExpanded], disabled && [styles.splitButtonMenuButtonDisabled], checked && !disabled && [styles.splitButtonMenuButtonChecked]),
	        splitButtonContainer: Styling_1.mergeStyles(styles.splitButtonContainer, checked &&
	            !disabled && [
	            styles.splitButtonContainerChecked,
	            {
	                selectors: {
	                    ':hover': styles.splitButtonContainerCheckedHovered
	                }
	            }
	        ], !disabled &&
	            !checked && [
	            {
	                selectors: {
	                    ':hover': styles.splitButtonContainerHovered,
	                    ':focus': styles.splitButtonContainerFocused
	                }
	            }
	        ], disabled && styles.splitButtonContainerDisabled),
	        icon: Styling_1.mergeStyles(styles.splitButtonMenuIcon, disabled && styles.splitButtonMenuIconDisabled, !disabled && primaryDisabled && styles.splitButtonMenuIcon),
	        flexContainer: Styling_1.mergeStyles(styles.splitButtonFlexContainer),
	        divider: Styling_1.mergeStyles(styles.splitButtonDivider, (primaryDisabled || disabled) && styles.splitButtonDividerDisabled)
	    };
	});
	//# sourceMappingURL=SplitButton.classNames.js.map

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Button}
	 */
	var ElementType;
	(function (ElementType) {
	    /** <button> element. */
	    ElementType[ElementType["button"] = 0] = "button";
	    /** <a> element. */
	    ElementType[ElementType["anchor"] = 1] = "anchor";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	 * {@docCategory Button}
	 */
	var ButtonType;
	(function (ButtonType) {
	    ButtonType[ButtonType["normal"] = 0] = "normal";
	    ButtonType[ButtonType["primary"] = 1] = "primary";
	    ButtonType[ButtonType["hero"] = 2] = "hero";
	    ButtonType[ButtonType["compound"] = 3] = "compound";
	    ButtonType[ButtonType["command"] = 4] = "command";
	    ButtonType[ButtonType["icon"] = 5] = "icon";
	    ButtonType[ButtonType["default"] = 6] = "default";
	})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
	//# sourceMappingURL=Button.types.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_types_1 = __webpack_require__(721);
	var DefaultButton_1 = __webpack_require__(723);
	var ActionButton_1 = __webpack_require__(728);
	var CompoundButton_1 = __webpack_require__(730);
	var IconButton_1 = __webpack_require__(732);
	var PrimaryButton_1 = __webpack_require__(734);
	/**
	 * This class is deprecated. Use the individual *Button components instead.
	 * @deprecated Use the individual *Button components instead.
	 * {@docCategory Button}
	 */
	var Button = /** @class */ (function (_super) {
	    tslib_1.__extends(Button, _super);
	    function Button(props) {
	        var _this = _super.call(this, props) || this;
	        /**
	         * Set this BaseComponent._skipComponentRefResolution to true, bypassing resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        Utilities_1.warn("The Button component has been deprecated. Use specific variants instead. " +
	            "(PrimaryButton, DefaultButton, IconButton, ActionButton, etc.)");
	        return _this;
	    }
	    Button.prototype.render = function () {
	        var props = this.props;
	        switch (props.buttonType) {
	            case Button_types_1.ButtonType.command:
	                return React.createElement(ActionButton_1.ActionButton, tslib_1.__assign({}, props));
	            case Button_types_1.ButtonType.compound:
	                return React.createElement(CompoundButton_1.CompoundButton, tslib_1.__assign({}, props));
	            case Button_types_1.ButtonType.icon:
	                return React.createElement(IconButton_1.IconButton, tslib_1.__assign({}, props));
	            case Button_types_1.ButtonType.primary:
	                return React.createElement(PrimaryButton_1.PrimaryButton, tslib_1.__assign({}, props));
	            default:
	                return React.createElement(DefaultButton_1.DefaultButton, tslib_1.__assign({}, props));
	        }
	    };
	    return Button;
	}(Utilities_1.BaseComponent));
	exports.Button = Button;
	//# sourceMappingURL=Button.js.map

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseButton_1 = __webpack_require__(693);
	var Utilities_1 = __webpack_require__(592);
	var DefaultButton_styles_1 = __webpack_require__(724);
	/**
	 * {@docCategory Button}
	 */
	var DefaultButton = /** @class */ (function (_super) {
	    tslib_1.__extends(DefaultButton, _super);
	    function DefaultButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    DefaultButton.prototype.render = function () {
	        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
	        return (React.createElement(BaseButton_1.BaseButton, tslib_1.__assign({}, this.props, { variantClassName: primary ? 'ms-Button--primary' : 'ms-Button--default', styles: DefaultButton_styles_1.getStyles(theme, styles, primary), onRenderDescription: Utilities_1.nullRender })));
	    };
	    DefaultButton = tslib_1.__decorate([
	        Utilities_1.customizable('DefaultButton', ['theme', 'styles'], true)
	    ], DefaultButton);
	    return DefaultButton;
	}(Utilities_1.BaseComponent));
	exports.DefaultButton = DefaultButton;
	//# sourceMappingURL=DefaultButton.js.map

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	var SplitButton_styles_1 = __webpack_require__(726);
	var ButtonThemes_1 = __webpack_require__(727);
	var DEFAULT_BUTTON_HEIGHT = '32px';
	var DEFAULT_BUTTON_MINWIDTH = '80px';
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, primary) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var splitButtonStyles = SplitButton_styles_1.getStyles(theme);
	    var defaultButtonStyles = {
	        root: {
	            minWidth: DEFAULT_BUTTON_MINWIDTH,
	            height: DEFAULT_BUTTON_HEIGHT
	        },
	        label: {
	            fontWeight: Styling_1.FontWeights.semibold
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, defaultButtonStyles, primary ? ButtonThemes_1.primaryStyles(theme) : ButtonThemes_1.standardStyles(theme), splitButtonStyles, customStyles);
	});
	//# sourceMappingURL=DefaultButton.styles.js.map

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	var noOutline = {
	    outline: 0
	};
	var iconStyle = {
	    fontSize: Styling_1.FontSizes.icon,
	    margin: '0 4px',
	    height: '16px',
	    lineHeight: '16px',
	    textAlign: 'center',
	    verticalAlign: 'middle',
	    flexShrink: 0
	};
	/**
	 * Gets the base button styles. Note: because it is a base class to be used with the `mergeRules`
	 * helper, it should have values for all class names in the interface. This let `mergeRules` optimize
	 * mixing class names together.
	 */
	exports.getStyles = Utilities_1.memoizeFunction(function (theme) {
	    var semanticColors = theme.semanticColors;
	    var border = semanticColors.buttonBorder;
	    var disabledBackground = semanticColors.disabledBackground;
	    var disabledText = semanticColors.disabledText;
	    var buttonHighContrastFocus = {
	        left: -2,
	        top: -2,
	        bottom: -2,
	        right: -2,
	        border: 'none',
	        outlineColor: 'ButtonText'
	    };
	    return {
	        root: [
	            Styling_1.getFocusStyle(theme, { inset: -1, highContrastStyle: buttonHighContrastFocus }),
	            theme.fonts.medium,
	            {
	                boxSizing: 'border-box',
	                border: '1px solid ' + border,
	                userSelect: 'none',
	                display: 'inline-block',
	                textDecoration: 'none',
	                textAlign: 'center',
	                cursor: 'pointer',
	                verticalAlign: 'top',
	                padding: '0 16px',
	                borderRadius: 0,
	                margin: 0,
	                selectors: {
	                    // IE11 workaround for preventing shift of child elements of a button when active.
	                    ':active > *': {
	                        position: 'relative',
	                        left: 0,
	                        top: 0
	                    }
	                }
	            }
	        ],
	        rootDisabled: [
	            Styling_1.getFocusStyle(theme, { inset: -1, highContrastStyle: buttonHighContrastFocus }),
	            {
	                backgroundColor: disabledBackground,
	                color: disabledText,
	                cursor: 'default',
	                pointerEvents: 'none',
	                selectors: (_a = {
	                        ':hover': noOutline,
	                        ':focus': noOutline
	                    },
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'grayText',
	                        bordercolor: 'grayText'
	                    },
	                    _a)
	            }
	        ],
	        iconDisabled: {
	            color: disabledText
	        },
	        menuIconDisabled: {
	            color: disabledText
	        },
	        flexContainer: {
	            display: 'flex',
	            height: '100%',
	            flexWrap: 'nowrap',
	            justifyContent: 'center',
	            alignItems: 'center'
	        },
	        textContainer: {
	            flexGrow: 1
	        },
	        icon: iconStyle,
	        menuIcon: [
	            iconStyle,
	            {
	                fontSize: Styling_1.FontSizes.small
	            }
	        ],
	        label: {
	            margin: '0 4px',
	            lineHeight: '100%'
	        },
	        screenReaderText: Styling_1.hiddenContentStyle
	    };
	    var _a;
	});
	//# sourceMappingURL=BaseButton.styles.js.map

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
	    var buttonHighContrastFocus = {
	        left: -2,
	        top: -2,
	        bottom: -2,
	        right: -2,
	        border: 'none'
	    };
	    var splitButtonDivider = {
	        position: 'absolute',
	        width: 1,
	        right: 31,
	        top: 8,
	        bottom: 8
	    };
	    var splitButtonDividerDisabled = {
	        position: 'absolute',
	        width: 1,
	        right: 31,
	        top: 8,
	        bottom: 8,
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                backgroundColor: 'GrayText'
	            },
	            _a)
	    };
	    var splitButtonStyles = {
	        splitButtonContainer: [
	            Styling_1.getFocusStyle(theme, { highContrastStyle: buttonHighContrastFocus }),
	            {
	                display: 'inline-flex',
	                selectors: {
	                    '.ms-Button--default, .ms-Button--primary': {
	                        borderRight: 'none'
	                    }
	                }
	            }
	        ],
	        splitButtonContainerFocused: {
	            outline: 'none!important'
	        },
	        splitButtonMenuButton: {
	            padding: 6,
	            height: 'auto',
	            boxSizing: 'border-box',
	            border: 0,
	            borderRadius: 0,
	            outline: 'transparent',
	            userSelect: 'none',
	            display: 'inline-block',
	            textDecoration: 'none',
	            textAlign: 'center',
	            cursor: 'pointer',
	            verticalAlign: 'top',
	            width: 32,
	            marginLeft: -1,
	            marginTop: 0,
	            marginRight: 0,
	            marginBottom: 0,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    border: "1px solid white",
	                    borderLeft: 'none'
	                },
	                _b)
	        },
	        splitButtonDivider: splitButtonDivider,
	        splitButtonDividerDisabled: splitButtonDividerDisabled,
	        splitButtonMenuButtonDisabled: {
	            pointerEvents: 'none',
	            selectors: (_c = {
	                    ':hover': {
	                        cursor: 'default'
	                    }
	                },
	                _c[Styling_1.HighContrastSelector] = {
	                    border: "1px solid GrayText",
	                    color: 'GrayText',
	                    backgroundColor: 'Window'
	                },
	                _c)
	        },
	        splitButtonFlexContainer: {
	            display: 'flex',
	            height: '100%',
	            flexWrap: 'nowrap',
	            justifyContent: 'center',
	            alignItems: 'center'
	        },
	        splitButtonContainerDisabled: {
	            outline: 'none',
	            border: 'none'
	        }
	    };
	    return Styling_1.concatStyleSets(splitButtonStyles, customStyles);
	    var _a, _b, _c;
	});
	//# sourceMappingURL=SplitButton.styles.js.map

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	function standardStyles(theme) {
	    var s = theme.semanticColors;
	    var buttonBackground = s.buttonBackground;
	    var buttonBackgroundChecked = s.buttonBackgroundChecked;
	    var buttonBackgroundHovered = s.buttonBackgroundHovered;
	    var buttonText = s.buttonText;
	    var buttonTextHovered = s.buttonTextHovered;
	    var buttonTextChecked = s.buttonTextChecked;
	    var buttonTextCheckedHovered = s.buttonTextCheckedHovered;
	    return {
	        root: {
	            backgroundColor: buttonBackground,
	            color: buttonText
	        },
	        rootHovered: {
	            backgroundColor: buttonBackgroundHovered,
	            color: buttonTextHovered,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight',
	                    color: 'Highlight'
	                },
	                _a)
	        },
	        rootPressed: {
	            backgroundColor: buttonBackgroundChecked,
	            color: buttonTextChecked
	        },
	        rootExpanded: {
	            backgroundColor: buttonBackgroundChecked,
	            color: buttonTextChecked
	        },
	        rootChecked: {
	            backgroundColor: buttonBackgroundChecked,
	            color: buttonTextChecked
	        },
	        rootCheckedHovered: {
	            backgroundColor: theme.palette.neutralLight,
	            color: buttonTextCheckedHovered
	        },
	        // Split button styles
	        splitButtonContainer: {
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    border: 'none'
	                },
	                _b)
	        },
	        splitButtonMenuButton: {
	            color: theme.palette.white,
	            backgroundColor: theme.palette.neutralLighter,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralLight,
	                    selectors: (_c = {},
	                        _c[Styling_1.HighContrastSelector] = {
	                            color: 'Highlight'
	                        },
	                        _c)
	                }
	            }
	        },
	        splitButtonMenuButtonDisabled: {
	            backgroundColor: theme.palette.neutralLighter,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralLighter
	                }
	            }
	        },
	        splitButtonDivider: {
	            backgroundColor: theme.palette.neutralTertiaryAlt,
	            position: 'absolute',
	            width: 1,
	            right: 31,
	            top: 8,
	            bottom: 8,
	            selectors: (_d = {},
	                _d[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'WindowText'
	                },
	                _d)
	        },
	        splitButtonDividerDisabled: {
	            backgroundColor: theme.palette.neutralTertiaryAlt
	        },
	        splitButtonMenuButtonChecked: {
	            backgroundColor: theme.palette.themePrimary
	        },
	        splitButtonMenuButtonExpanded: {
	            backgroundColor: theme.palette.neutralLight
	        },
	        splitButtonMenuIcon: {
	            color: theme.palette.neutralPrimary
	        },
	        splitButtonMenuIconDisabled: {
	            color: theme.palette.neutralTertiary
	        }
	    };
	    var _a, _b, _c, _d;
	}
	exports.standardStyles = standardStyles;
	function primaryStyles(theme) {
	    return {
	        root: {
	            backgroundColor: theme.palette.themePrimary,
	            color: theme.palette.white,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'Window',
	                    backgroundColor: 'WindowText',
	                    MsHighContrastAdjust: 'none'
	                },
	                _a)
	        },
	        rootHovered: {
	            backgroundColor: theme.palette.themeDarkAlt,
	            color: theme.palette.white,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'Window',
	                    backgroundColor: 'Highlight'
	                },
	                _b)
	        },
	        rootPressed: {
	            backgroundColor: theme.palette.themeDark,
	            color: theme.palette.white,
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    color: 'Window',
	                    backgroundColor: 'WindowText',
	                    MsHighContrastAdjust: 'none'
	                },
	                _c)
	        },
	        rootExpanded: {
	            backgroundColor: theme.palette.themeDark,
	            color: theme.palette.white
	        },
	        rootChecked: {
	            backgroundColor: theme.palette.themeDark,
	            color: theme.palette.white
	        },
	        rootCheckedHovered: {
	            backgroundColor: theme.palette.themePrimary,
	            color: theme.palette.white
	        },
	        rootDisabled: {
	            selectors: (_d = {},
	                _d[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText',
	                    borderColor: 'GrayText',
	                    backgroundColor: 'Window'
	                },
	                _d)
	        },
	        // Split button styles
	        splitButtonContainer: {
	            selectors: (_e = {},
	                _e[Styling_1.HighContrastSelector] = {
	                    border: 'none'
	                },
	                _e)
	        },
	        splitButtonDivider: {
	            backgroundColor: theme.palette.white,
	            position: 'absolute',
	            width: 1,
	            right: 31,
	            top: 8,
	            bottom: 8,
	            selectors: (_f = {},
	                _f[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'Window'
	                },
	                _f)
	        },
	        splitButtonDividerDisabled: {
	            backgroundColor: theme.palette.neutralTertiaryAlt
	        },
	        splitButtonMenuButton: {
	            backgroundColor: theme.palette.themePrimary,
	            color: theme.palette.white,
	            selectors: (_g = {},
	                _g[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'WindowText'
	                },
	                _g[':hover'] = {
	                    backgroundColor: theme.palette.themeDark,
	                    selectors: (_h = {},
	                        _h[Styling_1.HighContrastSelector] = {
	                            color: 'Highlight'
	                        },
	                        _h)
	                },
	                _g)
	        },
	        splitButtonMenuButtonDisabled: {
	            backgroundColor: theme.palette.neutralLighter,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralLighter
	                }
	            }
	        },
	        splitButtonMenuButtonChecked: {
	            backgroundColor: theme.palette.themeDark
	        },
	        splitButtonMenuButtonExpanded: {
	            backgroundColor: theme.palette.themeDark
	        },
	        splitButtonMenuIcon: {
	            color: theme.palette.white
	        },
	        splitButtonMenuIconDisabled: {
	            color: theme.palette.neutralTertiary
	        }
	    };
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}
	exports.primaryStyles = primaryStyles;
	//# sourceMappingURL=ButtonThemes.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseButton_1 = __webpack_require__(693);
	var Utilities_1 = __webpack_require__(592);
	var ActionButton_styles_1 = __webpack_require__(729);
	/**
	 * {@docCategory Button}
	 */
	var ActionButton = /** @class */ (function (_super) {
	    tslib_1.__extends(ActionButton, _super);
	    function ActionButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    ActionButton.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, theme = _a.theme;
	        return (React.createElement(BaseButton_1.BaseButton, tslib_1.__assign({}, this.props, { variantClassName: "ms-Button--action ms-Button--command", styles: ActionButton_styles_1.getStyles(theme, styles), onRenderDescription: Utilities_1.nullRender })));
	    };
	    ActionButton = tslib_1.__decorate([
	        Utilities_1.customizable('ActionButton', ['theme', 'styles'], true)
	    ], ActionButton);
	    return ActionButton;
	}(Utilities_1.BaseComponent));
	exports.ActionButton = ActionButton;
	//# sourceMappingURL=ActionButton.js.map

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	var DEFAULT_BUTTON_HEIGHT = '40px';
	var DEFAULT_PADDING = '0 4px';
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var actionButtonStyles = {
	        root: {
	            padding: DEFAULT_PADDING,
	            height: DEFAULT_BUTTON_HEIGHT,
	            color: theme.palette.neutralPrimary,
	            backgroundColor: 'transparent',
	            border: '1px solid transparent'
	        },
	        rootHovered: {
	            color: theme.palette.themePrimary,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight',
	                    color: 'Highlight'
	                },
	                _a)
	        },
	        iconHovered: {
	            color: theme.palette.themePrimary
	        },
	        rootPressed: {
	            color: theme.palette.black
	        },
	        rootExpanded: {
	            color: theme.palette.themePrimary
	        },
	        iconPressed: {
	            color: theme.palette.themeDarker
	        },
	        rootDisabled: {
	            color: theme.palette.neutralTertiary,
	            backgroundColor: 'transparent'
	        },
	        rootChecked: {
	            color: theme.palette.black
	        },
	        iconChecked: {
	            color: theme.palette.themeDarker
	        },
	        flexContainer: {
	            justifyContent: 'flex-start'
	        },
	        icon: {
	            color: theme.palette.themeDarkAlt
	        },
	        iconDisabled: {
	            color: 'inherit'
	        },
	        menuIcon: {
	            color: theme.palette.neutralSecondary
	        },
	        textContainer: {
	            flexGrow: 0
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, actionButtonStyles, customStyles);
	    var _a;
	});
	//# sourceMappingURL=ActionButton.styles.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseButton_1 = __webpack_require__(693);
	var Utilities_1 = __webpack_require__(592);
	var CompoundButton_styles_1 = __webpack_require__(731);
	/**
	 * {@docCategory Button}
	 */
	var CompoundButton = /** @class */ (function (_super) {
	    tslib_1.__extends(CompoundButton, _super);
	    function CompoundButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    CompoundButton.prototype.render = function () {
	        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
	        return (React.createElement(BaseButton_1.BaseButton, tslib_1.__assign({}, this.props, { variantClassName: primary ? 'ms-Button--compoundPrimary' : 'ms-Button--compound', styles: CompoundButton_styles_1.getStyles(theme, styles, primary) })));
	    };
	    CompoundButton = tslib_1.__decorate([
	        Utilities_1.customizable('CompoundButton', ['theme', 'styles'], true)
	    ], CompoundButton);
	    return CompoundButton;
	}(Utilities_1.BaseComponent));
	exports.CompoundButton = CompoundButton;
	//# sourceMappingURL=CompoundButton.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	var SplitButton_styles_1 = __webpack_require__(726);
	var ButtonThemes_1 = __webpack_require__(727);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, primary) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var splitButtonStyles = SplitButton_styles_1.getStyles(theme);
	    var compoundButtonStyles = {
	        root: {
	            maxWidth: '280px',
	            minHeight: '72px',
	            height: 'auto',
	            padding: '20px'
	        },
	        flexContainer: {
	            flexDirection: 'row',
	            alignItems: 'flex-start',
	            minWidth: '100%',
	            margin: ''
	        },
	        textContainer: {
	            textAlign: 'left'
	        },
	        icon: {
	            fontSize: '2em',
	            lineHeight: '1em',
	            height: '1em',
	            margin: '0px 8px 0px 0px',
	            flexBasis: '1em',
	            flexShrink: '0'
	        },
	        label: {
	            margin: '0 0 5px',
	            lineHeight: '100%',
	            fontWeight: Styling_1.FontWeights.semibold
	        },
	        description: [
	            theme.fonts.small,
	            {
	                lineHeight: '100%'
	            }
	        ]
	    };
	    var standardCompoundTheme = {
	        description: {
	            color: theme.palette.neutralSecondary
	        },
	        descriptionHovered: {
	            color: theme.palette.neutralDark
	        },
	        descriptionPressed: {
	            color: 'inherit'
	        },
	        descriptionChecked: {
	            color: 'inherit'
	        },
	        descriptionDisabled: {
	            color: 'inherit'
	        }
	    };
	    var primaryCompoundTheme = {
	        description: {
	            color: theme.palette.white,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'Window',
	                    backgroundColor: 'WindowText',
	                    MsHighContrastAdjust: 'none'
	                },
	                _a)
	        },
	        descriptionHovered: {
	            color: theme.palette.white,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'Window',
	                    backgroundColor: 'Highlight',
	                    MsHighContrastAdjust: 'none'
	                },
	                _b)
	        },
	        descriptionPressed: {
	            color: 'inherit'
	        },
	        descriptionChecked: {
	            color: 'inherit'
	        },
	        descriptionDisabled: {
	            color: 'inherit',
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    color: 'inherit'
	                },
	                _c)
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, compoundButtonStyles, primary ? ButtonThemes_1.primaryStyles(theme) : ButtonThemes_1.standardStyles(theme), primary ? primaryCompoundTheme : standardCompoundTheme, splitButtonStyles, customStyles);
	    var _a, _b, _c;
	});
	//# sourceMappingURL=CompoundButton.styles.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseButton_1 = __webpack_require__(693);
	var Utilities_1 = __webpack_require__(592);
	var IconButton_styles_1 = __webpack_require__(733);
	/**
	 * {@docCategory Button}
	 */
	var IconButton = /** @class */ (function (_super) {
	    tslib_1.__extends(IconButton, _super);
	    function IconButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    IconButton.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, theme = _a.theme;
	        return (React.createElement(BaseButton_1.BaseButton, tslib_1.__assign({}, this.props, { variantClassName: "ms-Button--icon", styles: IconButton_styles_1.getStyles(theme, styles), onRenderText: Utilities_1.nullRender, onRenderDescription: Utilities_1.nullRender })));
	    };
	    IconButton = tslib_1.__decorate([
	        Utilities_1.customizable('IconButton', ['theme', 'styles'], true)
	    ], IconButton);
	    return IconButton;
	}(Utilities_1.BaseComponent));
	exports.IconButton = IconButton;
	//# sourceMappingURL=IconButton.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	var SplitButton_styles_1 = __webpack_require__(726);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var splitButtonStyles = SplitButton_styles_1.getStyles(theme);
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var iconButtonStyles = {
	        root: {
	            padding: '0 4px',
	            width: '32px',
	            height: '32px',
	            backgroundColor: 'transparent',
	            border: 'none',
	            color: semanticColors.actionLink
	        },
	        rootHovered: {
	            color: semanticColors.actionLinkHovered,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight',
	                    color: 'Highlight'
	                },
	                _a)
	        },
	        rootPressed: {
	            color: palette.themePrimary
	        },
	        rootExpanded: {
	            color: palette.themePrimary
	        },
	        rootChecked: {
	            backgroundColor: semanticColors.buttonBackgroundChecked
	        },
	        rootCheckedHovered: {
	            backgroundColor: semanticColors.buttonBackgroundHovered
	        },
	        rootDisabled: {
	            color: semanticColors.disabledText
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, iconButtonStyles, splitButtonStyles, customStyles);
	    var _a;
	});
	//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DefaultButton_1 = __webpack_require__(723);
	/**
	 * {@docCategory Button}
	 */
	var PrimaryButton = /** @class */ (function (_super) {
	    tslib_1.__extends(PrimaryButton, _super);
	    function PrimaryButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Set this BaseComponent._skipComponentRefResolution to true, bypassing resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    PrimaryButton.prototype.render = function () {
	        return React.createElement(DefaultButton_1.DefaultButton, tslib_1.__assign({}, this.props, { primary: true, onRenderDescription: Utilities_1.nullRender }));
	    };
	    PrimaryButton = tslib_1.__decorate([
	        Utilities_1.customizable('PrimaryButton', ['theme', 'styles'], true)
	    ], PrimaryButton);
	    return PrimaryButton;
	}(Utilities_1.BaseComponent));
	exports.PrimaryButton = PrimaryButton;
	//# sourceMappingURL=PrimaryButton.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseButton_1 = __webpack_require__(693);
	var Utilities_1 = __webpack_require__(592);
	var CommandBarButton_styles_1 = __webpack_require__(736);
	/**
	 * {@docCategory Button}
	 */
	var CommandBarButton = /** @class */ (function (_super) {
	    tslib_1.__extends(CommandBarButton, _super);
	    function CommandBarButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    CommandBarButton.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, theme = _a.theme;
	        return (React.createElement(BaseButton_1.BaseButton, tslib_1.__assign({}, this.props, { variantClassName: "ms-Button--commandBar", styles: CommandBarButton_styles_1.getStyles(theme, styles), onRenderDescription: Utilities_1.nullRender })));
	    };
	    CommandBarButton = tslib_1.__decorate([
	        Utilities_1.customizable('CommandBarButton', ['theme', 'styles'], true)
	    ], CommandBarButton);
	    return CommandBarButton;
	}(Utilities_1.BaseComponent));
	exports.CommandBarButton = CommandBarButton;
	//# sourceMappingURL=CommandBarButton.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	var SplitButton_styles_1 = __webpack_require__(726);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, focusInset, focusColor) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var baseSplitButtonStyles = SplitButton_styles_1.getStyles(theme);
	    var commandButtonHighContrastFocus = {
	        left: 4,
	        top: 4,
	        bottom: 4,
	        right: 4,
	        border: 'none'
	    };
	    var commandButtonStyles = {
	        root: [
	            Styling_1.getFocusStyle(theme, { inset: -1, highContrastStyle: commandButtonHighContrastFocus }),
	            theme.fonts.medium,
	            {
	                minWidth: '40px',
	                backgroundColor: theme.palette.neutralLighter,
	                color: theme.palette.neutralPrimary,
	                padding: '0 4px',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: 'none'
	                    },
	                    _a)
	            }
	        ],
	        rootHovered: {
	            backgroundColor: theme.palette.neutralLight,
	            color: theme.palette.neutralDark,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'Highlight'
	                },
	                _b)
	        },
	        rootPressed: {
	            backgroundColor: theme.palette.neutralQuaternaryAlt,
	            color: theme.palette.black
	        },
	        rootChecked: {
	            backgroundColor: theme.palette.neutralQuaternaryAlt,
	            color: theme.palette.black
	        },
	        rootExpanded: {
	            backgroundColor: theme.palette.neutralQuaternaryAlt,
	            color: theme.palette.black
	        },
	        rootCheckedHovered: {
	            backgroundColor: theme.palette.neutralQuaternary,
	            color: theme.palette.black
	        },
	        // Split button styles
	        splitButtonContainer: {
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    border: 'none'
	                },
	                _c)
	        },
	        splitButtonDivider: {
	            backgroundColor: theme.palette.neutralTertiaryAlt,
	            marginTop: 4,
	            marginBottom: 4
	        },
	        splitButtonMenuButton: {
	            backgroundColor: theme.palette.neutralLighter,
	            color: theme.palette.neutralPrimary,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralLight,
	                    color: theme.palette.neutralDark,
	                    selectors: (_d = {},
	                        _d[Styling_1.HighContrastSelector] = {
	                            color: 'Highlight'
	                        },
	                        _d)
	                }
	            }
	        },
	        splitButtonMenuButtonDisabled: {
	            backgroundColor: theme.palette.neutralLighter,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralLighter
	                }
	            }
	        },
	        splitButtonMenuButtonChecked: {
	            backgroundColor: theme.palette.neutralQuaternaryAlt,
	            color: theme.palette.black,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralQuaternaryAlt
	                }
	            }
	        },
	        splitButtonMenuButtonExpanded: {
	            backgroundColor: theme.palette.neutralQuaternaryAlt,
	            color: theme.palette.black,
	            selectors: {
	                ':hover': {
	                    backgroundColor: theme.palette.neutralQuaternaryAlt
	                }
	            }
	        },
	        splitButtonMenuIcon: {
	            color: theme.palette.neutralPrimary
	        },
	        splitButtonMenuIconDisabled: {
	            color: theme.palette.neutralTertiary
	        },
	        label: {
	            fontWeight: 'normal' // theme.fontWeights.semibold,
	        },
	        icon: {
	            color: theme.palette.themeDarkAlt
	        },
	        menuIcon: {
	            color: theme.palette.neutralSecondary
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, commandButtonStyles, baseSplitButtonStyles, customStyles);
	    var _a, _b, _c, _d;
	});
	//# sourceMappingURL=CommandBarButton.styles.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ActionButton_1 = __webpack_require__(728);
	/**
	 * {@docCategory Button}
	 */
	exports.CommandButton = ActionButton_1.ActionButton;
	//# sourceMappingURL=CommandButton.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var DefaultButton_1 = __webpack_require__(723);
	var Utilities_1 = __webpack_require__(592);
	var MessageBarButton_styles_1 = __webpack_require__(739);
	/**
	 * {@docCategory MessageBar}
	 */
	var MessageBarButton = /** @class */ (function (_super) {
	    tslib_1.__extends(MessageBarButton, _super);
	    function MessageBarButton() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MessageBarButton.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, theme = _a.theme;
	        return React.createElement(DefaultButton_1.DefaultButton, tslib_1.__assign({}, this.props, { styles: MessageBarButton_styles_1.getStyles(theme, styles), onRenderDescription: Utilities_1.nullRender }));
	    };
	    MessageBarButton = tslib_1.__decorate([
	        Utilities_1.customizable('MessageBarButton', ['theme', 'styles'], true)
	    ], MessageBarButton);
	    return MessageBarButton;
	}(Utilities_1.BaseComponent));
	exports.MessageBarButton = MessageBarButton;
	//# sourceMappingURL=MessageBarButton.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, focusInset, focusColor) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var messageBarButtonStyles = {
	        root: [
	            Styling_1.getFocusStyle(theme, {
	                inset: 1,
	                highContrastStyle: {
	                    outlineOffset: '-4px',
	                    outlineColor: 'ActiveBorder'
	                },
	                borderColor: 'transparent'
	            }),
	            {
	                backgroundColor: theme.palette.neutralQuaternaryAlt,
	                color: theme.palette.neutralPrimary
	            }
	        ],
	        rootHovered: {
	            backgroundColor: theme.palette.neutralTertiaryAlt,
	            color: theme.palette.neutralDark
	        },
	        rootPressed: {
	            backgroundColor: theme.palette.neutralTertiary,
	            color: theme.palette.neutralDark
	        }
	    };
	    return Styling_1.concatStyleSets(baseButtonStyles, messageBarButtonStyles, customStyles);
	});
	//# sourceMappingURL=MessageBarButton.styles.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(741), exports);
	//# sourceMappingURL=ResizeGroup.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(742), exports);
	tslib_1.__exportStar(__webpack_require__(743), exports);
	tslib_1.__exportStar(__webpack_require__(744), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeGroup_base_1 = __webpack_require__(743);
	exports.ResizeGroup = ResizeGroup_base_1.ResizeGroupBase;
	//# sourceMappingURL=ResizeGroup.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var PropTypes = __webpack_require__(53);
	var Utilities_1 = __webpack_require__(592);
	var ResizeGroup_types_1 = __webpack_require__(744);
	var RESIZE_DELAY = 16;
	/**
	 * Returns a simple object is able to store measurements with a given key.
	 */
	exports.getMeasurementCache = function () {
	    var measurementsCache = {};
	    return {
	        /**
	         * Checks if the provided data has a cacheKey. If it has a cacheKey and there is a
	         * corresponding entry in the measurementsCache, then it will return that value.
	         * Returns undefined otherwise.
	         */
	        getCachedMeasurement: function (data) {
	            if (data && data.cacheKey && measurementsCache.hasOwnProperty(data.cacheKey)) {
	                return measurementsCache[data.cacheKey];
	            }
	            return undefined;
	        },
	        /**
	         * Should be called whenever there is a new measurement associated with a given data object.
	         * If the data has a cacheKey, store that measurement in the measurementsCache.
	         */
	        addMeasurementToCache: function (data, measurement) {
	            if (data.cacheKey) {
	                measurementsCache[data.cacheKey] = measurement;
	            }
	        }
	    };
	};
	/**
	 * Returns a function that is able to compute the next state for the ResizeGroup given the current
	 * state and any measurement updates.
	 */
	exports.getNextResizeGroupStateProvider = function (measurementCache) {
	    if (measurementCache === void 0) { measurementCache = exports.getMeasurementCache(); }
	    var _measurementCache = measurementCache;
	    var _containerDimension;
	    /**
	     * Gets the width/height of the data rendered in a hidden div.
	     * @param measuredData - The data corresponding to the measurement we wish to take.
	     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
	     * is not in the cache.
	     */
	    function _getMeasuredDimension(measuredData, getElementToMeasureDimension) {
	        var cachedDimension = _measurementCache.getCachedMeasurement(measuredData);
	        if (cachedDimension !== undefined) {
	            return cachedDimension;
	        }
	        var measuredDimension = getElementToMeasureDimension();
	        _measurementCache.addMeasurementToCache(measuredData, measuredDimension);
	        return measuredDimension;
	    }
	    /**
	     * Will get the next IResizeGroupState based on the current data while trying to shrink contents
	     * to fit in the container.
	     * @param data - The initial data point to start measuring.
	     * @param onReduceData - Function that transforms the data into something that should render with less width/height.
	     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
	     * is not in the cache.
	     */
	    function _shrinkContentsUntilTheyFit(data, onReduceData, getElementToMeasureDimension) {
	        var dataToMeasure = data;
	        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
	        while (measuredDimension > _containerDimension) {
	            var nextMeasuredData = onReduceData(dataToMeasure);
	            // We don't want to get stuck in an infinite render loop when there are no more
	            // scaling steps, so implementations of onReduceData should return undefined when
	            // there are no more scaling states to apply.
	            if (nextMeasuredData === undefined) {
	                return {
	                    renderedData: dataToMeasure,
	                    resizeDirection: undefined,
	                    dataToMeasure: undefined
	                };
	            }
	            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
	            // If the measurement isn't in the cache, we need to rerender with some data in a hidden div
	            if (measuredDimension === undefined) {
	                return {
	                    dataToMeasure: nextMeasuredData,
	                    resizeDirection: 'shrink'
	                };
	            }
	            dataToMeasure = nextMeasuredData;
	        }
	        return {
	            renderedData: dataToMeasure,
	            resizeDirection: undefined,
	            dataToMeasure: undefined
	        };
	    }
	    /**
	     * This function should be called when the state changes in a manner that might allow for more content to fit
	     * on the screen, such as the window width/height growing.
	     * @param data - The initial data point to start measuring.
	     * @param onGrowData - Function that transforms the data into something that may take up more space when rendering.
	     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
	     * is not in the cache.
	     */
	    function _growDataUntilItDoesNotFit(data, onGrowData, getElementToMeasureDimension, onReduceData) {
	        var dataToMeasure = data;
	        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
	        while (measuredDimension < _containerDimension) {
	            var nextMeasuredData = onGrowData(dataToMeasure);
	            // We don't want to get stuck in an infinite render loop when there are no more
	            // scaling steps, so implementations of onGrowData should return undefined when
	            // there are no more scaling states to apply.
	            if (nextMeasuredData === undefined) {
	                return {
	                    renderedData: dataToMeasure,
	                    resizeDirection: undefined,
	                    dataToMeasure: undefined
	                };
	            }
	            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
	            // If the measurement isn't in the cache, we need to rerender with some data in a hidden div
	            if (measuredDimension === undefined) {
	                return {
	                    dataToMeasure: nextMeasuredData
	                };
	            }
	            dataToMeasure = nextMeasuredData;
	        }
	        // Once the loop is done, we should now shrink until the contents fit.
	        return tslib_1.__assign({ resizeDirection: 'shrink' }, _shrinkContentsUntilTheyFit(dataToMeasure, onReduceData, getElementToMeasureDimension));
	    }
	    /**
	     * Handles an update to the container width/eheight. Should only be called when we knew the previous container width/height.
	     * @param newDimension - The new width/height of the container.
	     * @param fullDimensionData - The initial data passed in as a prop to resizeGroup.
	     * @param renderedData - The data that was rendered prior to the container size changing.
	     * @param onGrowData - Set to true if the Resize group has an onGrowData function.
	     */
	    function _updateContainerDimension(newDimension, fullDimensionData, renderedData, onGrowData) {
	        var nextState;
	        if (newDimension > _containerDimension) {
	            if (onGrowData) {
	                nextState = {
	                    resizeDirection: 'grow',
	                    dataToMeasure: onGrowData(renderedData)
	                };
	            }
	            else {
	                nextState = {
	                    resizeDirection: 'shrink',
	                    dataToMeasure: fullDimensionData
	                };
	            }
	        }
	        else {
	            nextState = {
	                resizeDirection: 'shrink',
	                dataToMeasure: renderedData
	            };
	        }
	        _containerDimension = newDimension;
	        return tslib_1.__assign({}, nextState, { measureContainer: false });
	    }
	    function getNextState(props, currentState, getElementToMeasureDimension, newContainerDimension) {
	        // If there is no new container width/height or data to measure, there is no need for a new state update
	        if (newContainerDimension === undefined && currentState.dataToMeasure === undefined) {
	            return undefined;
	        }
	        if (newContainerDimension) {
	            // If we know what the last container size was and we rendered data at that width/height, we can do an optimized render
	            if (_containerDimension && currentState.renderedData && !currentState.dataToMeasure) {
	                return tslib_1.__assign({}, currentState, _updateContainerDimension(newContainerDimension, props.data, currentState.renderedData, props.onGrowData));
	            }
	            // If we are just setting the container width/height for the first time, we can't do any optimizations
	            _containerDimension = newContainerDimension;
	        }
	        var nextState = tslib_1.__assign({}, currentState, { measureContainer: false });
	        if (currentState.dataToMeasure) {
	            if (currentState.resizeDirection === 'grow' && props.onGrowData) {
	                nextState = tslib_1.__assign({}, nextState, _growDataUntilItDoesNotFit(currentState.dataToMeasure, props.onGrowData, getElementToMeasureDimension, props.onReduceData));
	            }
	            else {
	                nextState = tslib_1.__assign({}, nextState, _shrinkContentsUntilTheyFit(currentState.dataToMeasure, props.onReduceData, getElementToMeasureDimension));
	            }
	        }
	        return nextState;
	    }
	    /** Function that determines if we need to render content for measurement based on the measurement cache contents. */
	    function shouldRenderDataForMeasurement(dataToMeasure) {
	        if (!dataToMeasure || _measurementCache.getCachedMeasurement(dataToMeasure) !== undefined) {
	            return false;
	        }
	        return true;
	    }
	    function getInitialResizeGroupState(data) {
	        return {
	            dataToMeasure: tslib_1.__assign({}, data),
	            resizeDirection: 'grow',
	            measureContainer: true
	        };
	    }
	    return {
	        getNextState: getNextState,
	        shouldRenderDataForMeasurement: shouldRenderDataForMeasurement,
	        getInitialResizeGroupState: getInitialResizeGroupState
	    };
	};
	// Provides a context property that (if true) tells any child components that
	// they are only being used for measurement purposes and will not be visible.
	var MeasuredContext = Utilities_1.provideContext({
	    isMeasured: PropTypes.bool
	}, function () {
	    return { isMeasured: true };
	});
	// Styles for the hidden div used for measurement
	var hiddenDivStyles = { position: 'fixed', visibility: 'hidden' };
	var hiddenParentStyles = { position: 'relative' };
	var ResizeGroupBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ResizeGroupBase, _super);
	    function ResizeGroupBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._nextResizeGroupStateProvider = exports.getNextResizeGroupStateProvider();
	        // The root div which is the container inside of which we are trying to fit content.
	        _this._root = React.createRef();
	        // A div that can be used for the initial measurement so that we can avoid mounting a second instance
	        // of the component being measured for the initial render.
	        _this._initialHiddenDiv = React.createRef();
	        // A hidden div that is used for mounting a new instance of the component for measurement in a hidden
	        // div without unmounting the currently visible content.
	        _this._updateHiddenDiv = React.createRef();
	        // Tracks if any content has been rendered to the user. This enables us to do some performance optimizations
	        // for the initial render.
	        _this._hasRenderedContent = false;
	        _this.state = _this._nextResizeGroupStateProvider.getInitialResizeGroupState(_this.props.data);
	        _this._warnDeprecations({
	            styles: 'className'
	        });
	        return _this;
	    }
	    ResizeGroupBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, onRenderData = _a.onRenderData;
	        var _b = this.state, dataToMeasure = _b.dataToMeasure, renderedData = _b.renderedData;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['data']);
	        var dataNeedsMeasuring = this._nextResizeGroupStateProvider.shouldRenderDataForMeasurement(dataToMeasure);
	        var isInitialMeasure = !this._hasRenderedContent && dataNeedsMeasuring;
	        // We only ever render the final content to the user. All measurements are done in a hidden div.
	        // For the initial render, we want this to be as fast as possible, so we need to make sure that we only mount one version of the
	        // component for measurement and the final render. For renders that update what is on screen, we want to make sure that
	        // there are no jarring effects such as the screen flashing as we apply scaling steps for meassurement. In the update case,
	        // we mount a second version of the component just for measurement purposes and leave the rendered content untouched until we know the
	        // next state sto show to the user.
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: className, ref: this._root }),
	            React.createElement("div", { style: hiddenParentStyles },
	                dataNeedsMeasuring && !isInitialMeasure && (React.createElement("div", { style: hiddenDivStyles, ref: this._updateHiddenDiv },
	                    React.createElement(MeasuredContext, null, onRenderData(dataToMeasure)))),
	                React.createElement("div", { ref: this._initialHiddenDiv, style: isInitialMeasure ? hiddenDivStyles : undefined, "data-automation-id": "visibleContent" }, isInitialMeasure ? onRenderData(dataToMeasure) : renderedData && onRenderData(renderedData)))));
	    };
	    ResizeGroupBase.prototype.componentDidMount = function () {
	        this._afterComponentRendered(this.props.direction);
	        this._events.on(window, 'resize', this._async.debounce(this._onResize, RESIZE_DELAY, { leading: true }));
	    };
	    ResizeGroupBase.prototype.componentWillReceiveProps = function (nextProps) {
	        this.setState({
	            dataToMeasure: tslib_1.__assign({}, nextProps.data),
	            resizeDirection: 'grow',
	            measureContainer: true // Receiving new props means the parent might rerender and the root width/height might change
	        });
	    };
	    ResizeGroupBase.prototype.componentDidUpdate = function (prevProps) {
	        if (this.state.renderedData) {
	            this._hasRenderedContent = true;
	            if (this.props.dataDidRender) {
	                this.props.dataDidRender(this.state.renderedData);
	            }
	        }
	        this._afterComponentRendered(this.props.direction);
	    };
	    ResizeGroupBase.prototype.remeasure = function () {
	        if (this._root.current) {
	            this.setState({ measureContainer: true });
	        }
	    };
	    ResizeGroupBase.prototype._afterComponentRendered = function (direction) {
	        var _this = this;
	        this._async.requestAnimationFrame(function () {
	            var containerDimension = undefined;
	            if (_this.state.measureContainer && _this._root.current) {
	                var boundingRect = _this._root.current.getBoundingClientRect();
	                containerDimension = direction && direction === ResizeGroup_types_1.ResizeGroupDirection.vertical ? boundingRect.height : boundingRect.width;
	            }
	            var nextState = _this._nextResizeGroupStateProvider.getNextState(_this.props, _this.state, function () {
	                var refToMeasure = !_this._hasRenderedContent ? _this._initialHiddenDiv : _this._updateHiddenDiv;
	                if (!refToMeasure.current) {
	                    return 0;
	                }
	                return direction && direction === ResizeGroup_types_1.ResizeGroupDirection.vertical
	                    ? refToMeasure.current.scrollHeight
	                    : refToMeasure.current.scrollWidth;
	            }, containerDimension);
	            if (nextState) {
	                _this.setState(nextState);
	            }
	        });
	    };
	    ResizeGroupBase.prototype._onResize = function () {
	        if (this._root.current) {
	            this.setState({ measureContainer: true });
	        }
	    };
	    return ResizeGroupBase;
	}(Utilities_1.BaseComponent));
	exports.ResizeGroupBase = ResizeGroupBase;
	//# sourceMappingURL=ResizeGroup.base.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory ResizeGroup}
	 */
	var ResizeGroupDirection;
	(function (ResizeGroupDirection) {
	    ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
	    ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
	})(ResizeGroupDirection = exports.ResizeGroupDirection || (exports.ResizeGroupDirection = {}));
	//# sourceMappingURL=ResizeGroup.types.js.map

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var SingleLineTextStyle = {
	    whiteSpace: 'nowrap',
	    textOverflow: 'ellipsis',
	    overflow: 'hidden'
	};
	var MinimumScreenSelector = Styling_1.getScreenSelector(0, Styling_1.ScreenWidthMaxSmall);
	var MediumScreenSelector = Styling_1.getScreenSelector(Styling_1.ScreenWidthMinMedium, Styling_1.ScreenWidthMaxMedium);
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var overflowButtonFontSize = 16;
	    var chevronSmallFontSize = 8;
	    return {
	        root: [
	            'ms-Breadcrumb',
	            theme.fonts.medium,
	            {
	                margin: '23px 0 1px'
	            },
	            className
	        ],
	        list: [
	            'ms-Breadcrumb-list',
	            {
	                whiteSpace: 'nowrap',
	                padding: 0,
	                margin: 0,
	                display: 'flex',
	                alignItems: 'stretch'
	            }
	        ],
	        listItem: [
	            'ms-Breadcrumb-listItem',
	            {
	                listStyleType: 'none',
	                margin: '0',
	                padding: '0',
	                display: 'flex',
	                position: 'relative',
	                alignItems: 'center'
	            }
	        ],
	        chevron: [
	            'ms-Breadcrumb-chevron',
	            {
	                color: theme.palette.neutralSecondary,
	                fontSize: theme.fonts.small.fontSize,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'WindowText',
	                        MsHighContrastAdjust: 'none'
	                    },
	                    _a[MediumScreenSelector] = {
	                        fontSize: chevronSmallFontSize
	                    },
	                    _a[MinimumScreenSelector] = {
	                        fontSize: chevronSmallFontSize
	                    },
	                    _a)
	            }
	        ],
	        overflow: [
	            'ms-Breadcrumb-overflow',
	            {
	                position: 'relative',
	                display: 'flex',
	                alignItems: 'center'
	            }
	        ],
	        overflowButton: [
	            'ms-Breadcrumb-overflowButton',
	            Styling_1.getFocusStyle(theme),
	            SingleLineTextStyle,
	            {
	                fontSize: overflowButtonFontSize,
	                height: '100%',
	                cursor: 'pointer',
	                selectors: (_b = {
	                        ':hover': {
	                            backgroundColor: theme.palette.neutralLighter
	                        },
	                        ':active': {
	                            backgroundColor: theme.palette.neutralTertiaryAlt,
	                            color: theme.semanticColors.bodyText
	                        },
	                        ':hover:active': {
	                            // This seems unnecessary.
	                            backgroundColor: theme.palette.neutralQuaternary
	                        }
	                    },
	                    _b[MinimumScreenSelector] = {
	                        padding: '4px 6px'
	                    },
	                    _b[MediumScreenSelector] = {
	                        fontSize: theme.fonts.mediumPlus.fontSize
	                    },
	                    _b)
	            }
	        ],
	        itemLink: [
	            'ms-Breadcrumb-itemLink',
	            Styling_1.getFocusStyle(theme),
	            SingleLineTextStyle,
	            theme.fonts.xLarge,
	            {
	                textDecoration: 'none',
	                color: theme.semanticColors.bodyText,
	                padding: '0 8px',
	                selectors: (_c = {
	                        ':hover': {
	                            backgroundColor: theme.semanticColors.menuItemBackgroundHovered,
	                            color: 'initial',
	                            cursor: 'pointer',
	                            selectors: (_d = {},
	                                _d[Styling_1.HighContrastSelector] = {
	                                    color: 'Highlight'
	                                },
	                                _d)
	                        },
	                        ':focus': {
	                            color: theme.palette.neutralDark
	                        },
	                        ':active': {
	                            backgroundColor: theme.palette.neutralTertiaryAlt,
	                            color: theme.palette.neutralPrimary
	                        }
	                    },
	                    _c[MediumScreenSelector] = theme.fonts.large,
	                    _c[MinimumScreenSelector] = [theme.fonts.medium],
	                    _c["." + Utilities_1.IsFocusVisibleClassName + " &:focus"] = {
	                        outline: "none"
	                    },
	                    _c)
	            }
	        ],
	        item: [
	            'ms-Breadcrumb-item',
	            theme.fonts.xLarge,
	            {
	                color: theme.semanticColors.bodyText,
	                padding: '0 8px',
	                selectors: {
	                    ':hover': {
	                        cursor: 'default'
	                    }
	                }
	            }
	        ]
	    };
	    var _a, _b, _c, _d;
	};
	//# sourceMappingURL=Breadcrumb.styles.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(747), exports);
	//# sourceMappingURL=Calendar.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(748), exports);
	tslib_1.__exportStar(__webpack_require__(756), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var DateValues_1 = __webpack_require__(749);
	var CalendarDay_1 = __webpack_require__(750);
	var CalendarMonth_1 = __webpack_require__(754);
	var DateMath_1 = __webpack_require__(751);
	var Utilities_1 = __webpack_require__(592);
	var stylesImport = __webpack_require__(753);
	var styles = stylesImport;
	var leftArrow = 'Up';
	var rightArrow = 'Down';
	var closeIcon = 'CalculatorMultiply';
	var iconStrings = {
	    leftNavigation: leftArrow,
	    rightNavigation: rightArrow,
	    closeIcon: closeIcon
	};
	var defaultWorkWeekDays = [DateValues_1.DayOfWeek.Monday, DateValues_1.DayOfWeek.Tuesday, DateValues_1.DayOfWeek.Wednesday, DateValues_1.DayOfWeek.Thursday, DateValues_1.DayOfWeek.Friday];
	var dateTimeFormatterCallbacks = {
	    formatMonthDayYear: function (date, strings) {
	        return strings.months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
	    },
	    formatMonthYear: function (date, strings) { return strings.months[date.getMonth()] + ' ' + date.getFullYear(); },
	    formatDay: function (date) { return date.getDate().toString(); },
	    formatYear: function (date) { return date.getFullYear().toString(); }
	};
	var Calendar = /** @class */ (function (_super) {
	    tslib_1.__extends(Calendar, _super);
	    function Calendar(props) {
	        var _this = _super.call(this, props) || this;
	        _this._dayPicker = React.createRef();
	        _this._monthPicker = React.createRef();
	        _this._navigateDayPickerDay = function (date) {
	            _this.setState({
	                navigatedDayDate: date,
	                navigatedMonthDate: date
	            });
	        };
	        _this._navigateMonthPickerDay = function (date) {
	            _this.setState({
	                navigatedMonthDate: date
	            });
	        };
	        _this._onNavigateDayDate = function (date, focusOnNavigatedDay) {
	            _this._navigateDayPickerDay(date);
	            _this._focusOnUpdate = focusOnNavigatedDay;
	        };
	        _this._onNavigateMonthDate = function (date, focusOnNavigatedDay) {
	            if (!focusOnNavigatedDay) {
	                _this._navigateMonthPickerDay(date);
	                _this._focusOnUpdate = focusOnNavigatedDay;
	                return;
	            }
	            var monthPickerOnly = !_this.props.showMonthPickerAsOverlay && !_this.props.isDayPickerVisible;
	            if (monthPickerOnly) {
	                _this._onSelectDate(date);
	            }
	            _this._navigateDayPickerDay(date);
	        };
	        _this._onSelectDate = function (date, selectedDateRangeArray) {
	            var onSelectDate = _this.props.onSelectDate;
	            _this.setState({
	                selectedDate: date
	            });
	            if (onSelectDate) {
	                onSelectDate(date, selectedDateRangeArray);
	            }
	        };
	        _this._onHeaderSelect = function (focus) {
	            _this.setState({
	                isDayPickerVisible: !_this.state.isDayPickerVisible,
	                isMonthPickerVisible: !_this.state.isMonthPickerVisible
	            });
	            if (focus) {
	                _this._focusOnUpdate = true;
	            }
	        };
	        _this._onGotoToday = function () {
	            var _a = _this.props, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, today = _a.today, workWeekDays = _a.workWeekDays, selectDateOnClick = _a.selectDateOnClick;
	            if (selectDateOnClick) {
	                // When using Defaultprops, TypeScript doesn't know that React is going to inject defaults
	                // so we use exclamation mark as a hint to the type checker (see link below)
	                // https://decembersoft.com/posts/error-ts2532-optional-react-component-props-in-typescript/
	                var dates = DateMath_1.getDateRangeArray(today, dateRangeType, firstDayOfWeek, workWeekDays);
	                _this._onSelectDate(today, dates);
	            }
	            _this._navigateDayPickerDay(today);
	            _this._focusOnUpdate = true;
	        };
	        _this._onGotoTodayClick = function (ev) {
	            _this._onGotoToday();
	        };
	        _this._onGotoTodayKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                ev.preventDefault();
	                _this._onGotoToday();
	            }
	        };
	        _this._onDatePickerPopupKeyDown = function (ev) {
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.enter:
	                    ev.preventDefault();
	                    break;
	                case Utilities_1.KeyCodes.backspace:
	                    ev.preventDefault();
	                    break;
	                case Utilities_1.KeyCodes.escape:
	                    _this._handleEscKey(ev);
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this._handleEscKey = function (ev) {
	            if (_this.props.onDismiss) {
	                _this.props.onDismiss();
	            }
	        };
	        var currentDate = props.value && !isNaN(props.value.getTime()) ? props.value : props.today || new Date();
	        _this.state = {
	            selectedDate: currentDate,
	            navigatedDayDate: currentDate,
	            navigatedMonthDate: currentDate,
	            /** When showMonthPickerAsOverlay is active it overrides isMonthPickerVisible/isDayPickerVisible props
	             (These props permanently set the visibility of their respective calendars). */
	            isMonthPickerVisible: _this.props.showMonthPickerAsOverlay ? false : _this.props.isMonthPickerVisible,
	            isDayPickerVisible: _this.props.showMonthPickerAsOverlay ? true : _this.props.isDayPickerVisible
	        };
	        _this._focusOnUpdate = false;
	        return _this;
	    }
	    Calendar.prototype.componentWillReceiveProps = function (nextProps) {
	        var autoNavigateOnSelection = nextProps.autoNavigateOnSelection, value = nextProps.value, _a = nextProps.today, today = _a === void 0 ? new Date() : _a;
	        // Make sure auto-navigation is supported for programmatic changes to selected date, i.e.,
	        // if selected date is updated via props, we may need to modify the navigated date
	        var overrideNavigatedDate = autoNavigateOnSelection && !DateMath_1.compareDates(value, this.props.value);
	        if (overrideNavigatedDate) {
	            this.setState({
	                navigatedMonthDate: value,
	                navigatedDayDate: value
	            });
	        }
	        this.setState({
	            selectedDate: value || today
	        });
	    };
	    Calendar.prototype.componentDidUpdate = function () {
	        if (this._focusOnUpdate) {
	            this.focus();
	            this._focusOnUpdate = false;
	        }
	    };
	    Calendar.prototype.render = function () {
	        var rootClass = 'ms-DatePicker';
	        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, dateRangeType = _a.dateRangeType, strings = _a.strings, showMonthPickerAsOverlay = _a.showMonthPickerAsOverlay, autoNavigateOnSelection = _a.autoNavigateOnSelection, showGoToToday = _a.showGoToToday, highlightCurrentMonth = _a.highlightCurrentMonth, highlightSelectedMonth = _a.highlightSelectedMonth, navigationIcons = _a.navigationIcons, minDate = _a.minDate, maxDate = _a.maxDate, restrictedDates = _a.restrictedDates, className = _a.className, showCloseButton = _a.showCloseButton, allFocusable = _a.allFocusable, yearPickerHidden = _a.yearPickerHidden, today = _a.today;
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['value']);
	        var _b = this.state, selectedDate = _b.selectedDate, navigatedDayDate = _b.navigatedDayDate, navigatedMonthDate = _b.navigatedMonthDate, isMonthPickerVisible = _b.isMonthPickerVisible, isDayPickerVisible = _b.isDayPickerVisible;
	        var onHeaderSelect = showMonthPickerAsOverlay ? this._onHeaderSelect : undefined;
	        var monthPickerOnly = !showMonthPickerAsOverlay && !isDayPickerVisible;
	        var overlayedWithButton = showMonthPickerAsOverlay && showGoToToday;
	        var goTodayEnabled = showGoToToday;
	        if (goTodayEnabled && navigatedDayDate && navigatedMonthDate && today) {
	            goTodayEnabled =
	                navigatedDayDate.getFullYear() !== today.getFullYear() ||
	                    navigatedDayDate.getMonth() !== today.getMonth() ||
	                    navigatedMonthDate.getFullYear() !== today.getFullYear() ||
	                    navigatedMonthDate.getMonth() !== today.getMonth();
	        }
	        return (React.createElement("div", { className: Utilities_1.css(rootClass, styles.root, className), role: "application" },
	            React.createElement("div", tslib_1.__assign({}, nativeProps, { className: Utilities_1.css('ms-DatePicker-picker ms-DatePicker-picker--opened ms-DatePicker-picker--focused', styles.picker, styles.pickerIsOpened, styles.pickerIsFocused, isMonthPickerVisible && 'ms-DatePicker-monthPickerVisible ' + styles.monthPickerVisible, isMonthPickerVisible && isDayPickerVisible && 'ms-DatePicker-calendarsInline ' + styles.calendarsInline, monthPickerOnly && 'ms-DatePicker-monthPickerOnly ' + styles.monthPickerOnly, showMonthPickerAsOverlay && 'ms-DatePicker-monthPickerAsOverlay ' + styles.monthPickerAsOverlay) }),
	                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-holder ms-slideDownIn10', styles.holder, overlayedWithButton && styles.holderWithButton), onKeyDown: this._onDatePickerPopupKeyDown },
	                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-frame', styles.frame) },
	                        React.createElement("div", { className: Utilities_1.css('ms-DatePicker-wrap', styles.wrap, showGoToToday && styles.goTodaySpacing) },
	                            isDayPickerVisible && (React.createElement(CalendarDay_1.CalendarDay, { selectedDate: selectedDate, navigatedDate: navigatedDayDate, today: this.props.today, onSelectDate: this._onSelectDate, onNavigateDate: this._onNavigateDayDate, onDismiss: this.props.onDismiss, firstDayOfWeek: firstDayOfWeek, dateRangeType: dateRangeType, autoNavigateOnSelection: autoNavigateOnSelection, strings: strings, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, dateTimeFormatter: this.props.dateTimeFormatter, showSixWeeksByDefault: this.props.showSixWeeksByDefault, minDate: minDate, maxDate: maxDate, restrictedDates: restrictedDates, workWeekDays: this.props.workWeekDays, componentRef: this._dayPicker, showCloseButton: showCloseButton, allFocusable: allFocusable })),
	                            isDayPickerVisible && isMonthPickerVisible && React.createElement("div", { className: styles.divider }),
	                            isMonthPickerVisible && (React.createElement(CalendarMonth_1.CalendarMonth, { navigatedDate: navigatedMonthDate, selectedDate: navigatedDayDate, strings: strings, onNavigateDate: this._onNavigateMonthDate, today: this.props.today, highlightCurrentMonth: highlightCurrentMonth, highlightSelectedMonth: highlightSelectedMonth, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, componentRef: this._monthPicker, yearPickerHidden: yearPickerHidden || showMonthPickerAsOverlay })),
	                            showGoToToday && (React.createElement("button", { role: "button", className: Utilities_1.css('ms-DatePicker-goToday js-goToday', styles.goToday, (_c = {},
	                                    _c[styles.goTodayInlineMonth] = isMonthPickerVisible,
	                                    _c[styles.goToTodayIsDisabled] = !goTodayEnabled,
	                                    _c)), onClick: this._onGotoTodayClick, onKeyDown: this._onGotoTodayKeyDown, tabIndex: 0, disabled: !goTodayEnabled, type: "button" }, strings.goToToday))))))));
	        var _c;
	    };
	    Calendar.prototype.focus = function () {
	        if (this.state.isDayPickerVisible && this._dayPicker.current) {
	            this._dayPicker.current.focus();
	        }
	        else if (this.state.isMonthPickerVisible && this._monthPicker.current) {
	            this._monthPicker.current.focus();
	        }
	    };
	    Calendar.defaultProps = {
	        onSelectDate: undefined,
	        onDismiss: undefined,
	        isMonthPickerVisible: true,
	        isDayPickerVisible: true,
	        showMonthPickerAsOverlay: false,
	        value: undefined,
	        today: new Date(),
	        firstDayOfWeek: DateValues_1.DayOfWeek.Sunday,
	        dateRangeType: DateValues_1.DateRangeType.Day,
	        autoNavigateOnSelection: false,
	        showGoToToday: true,
	        strings: null,
	        highlightCurrentMonth: false,
	        highlightSelectedMonth: false,
	        navigationIcons: iconStrings,
	        showWeekNumbers: false,
	        firstWeekOfYear: DateValues_1.FirstWeekOfYear.FirstDay,
	        dateTimeFormatter: dateTimeFormatterCallbacks,
	        showSixWeeksByDefault: false,
	        workWeekDays: defaultWorkWeekDays,
	        showCloseButton: false,
	        allFocusable: false
	    };
	    return Calendar;
	}(Utilities_1.BaseComponent));
	exports.Calendar = Calendar;
	//# sourceMappingURL=Calendar.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The days of the week
	 * {@docCategory DayOfWeek}
	 */
	var DayOfWeek;
	(function (DayOfWeek) {
	    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
	    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
	    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
	    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
	    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
	    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
	    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
	})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
	/**
	 * The months
	 * {@docCategory MonthOfYear}
	 */
	var MonthOfYear;
	(function (MonthOfYear) {
	    MonthOfYear[MonthOfYear["January"] = 0] = "January";
	    MonthOfYear[MonthOfYear["February"] = 1] = "February";
	    MonthOfYear[MonthOfYear["March"] = 2] = "March";
	    MonthOfYear[MonthOfYear["April"] = 3] = "April";
	    MonthOfYear[MonthOfYear["May"] = 4] = "May";
	    MonthOfYear[MonthOfYear["June"] = 5] = "June";
	    MonthOfYear[MonthOfYear["July"] = 6] = "July";
	    MonthOfYear[MonthOfYear["August"] = 7] = "August";
	    MonthOfYear[MonthOfYear["September"] = 8] = "September";
	    MonthOfYear[MonthOfYear["October"] = 9] = "October";
	    MonthOfYear[MonthOfYear["November"] = 10] = "November";
	    MonthOfYear[MonthOfYear["December"] = 11] = "December";
	})(MonthOfYear = exports.MonthOfYear || (exports.MonthOfYear = {}));
	/**
	 * First week of the year settings types
	 * {@docCategory FirstWeekOfYear}
	 */
	var FirstWeekOfYear;
	(function (FirstWeekOfYear) {
	    FirstWeekOfYear[FirstWeekOfYear["FirstDay"] = 0] = "FirstDay";
	    FirstWeekOfYear[FirstWeekOfYear["FirstFullWeek"] = 1] = "FirstFullWeek";
	    FirstWeekOfYear[FirstWeekOfYear["FirstFourDayWeek"] = 2] = "FirstFourDayWeek";
	})(FirstWeekOfYear = exports.FirstWeekOfYear || (exports.FirstWeekOfYear = {}));
	/**
	 * The supported date range types
	 * {@docCategory DateRangeType}
	 */
	var DateRangeType;
	(function (DateRangeType) {
	    DateRangeType[DateRangeType["Day"] = 0] = "Day";
	    DateRangeType[DateRangeType["Week"] = 1] = "Week";
	    DateRangeType[DateRangeType["Month"] = 2] = "Month";
	    DateRangeType[DateRangeType["WorkWeek"] = 3] = "WorkWeek";
	})(DateRangeType = exports.DateRangeType || (exports.DateRangeType = {}));
	//# sourceMappingURL=DateValues.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DateValues_1 = __webpack_require__(749);
	var FocusZone_1 = __webpack_require__(676);
	var Icon_1 = __webpack_require__(643);
	var DateMath_1 = __webpack_require__(751);
	var stylesImport = __webpack_require__(753);
	var styles = stylesImport;
	var DAYS_IN_WEEK = 7;
	var CalendarDay = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarDay, _super);
	    function CalendarDay(props) {
	        var _this = _super.call(this, props) || this;
	        _this.days = {};
	        _this._onKeyDown = function (callback, ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space) {
	                callback();
	            }
	        };
	        _this._onDayKeyDown = function (originalDate, weekIndex, dayIndex) {
	            return function (ev) {
	                if (ev.which === Utilities_1.KeyCodes.enter) {
	                    _this._onSelectDate(originalDate, ev);
	                }
	                else {
	                    _this._navigateMonthEdge(ev, originalDate, weekIndex, dayIndex);
	                }
	            };
	        };
	        _this._onDayMouseDown = function (originalDate, weekIndex, dayIndex, dateRangeType) {
	            return function (ev) {
	                // set the press styling
	                if (dateRangeType === DateValues_1.DateRangeType.Month) {
	                    _this._applyFunctionToDayRefs(function (ref, day) {
	                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
	                            ref.classList.add(styles.dayPress);
	                        }
	                    });
	                }
	                else {
	                    // week or work week view
	                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
	                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
	                            ref.classList.add(styles.dayPress);
	                            ref.classList.add(styles.dayIsHighlighted);
	                        }
	                        else if (ref) {
	                            ref.classList.remove(styles.dayIsHighlighted);
	                        }
	                    });
	                }
	            };
	        };
	        _this._onDayMouseUp = function (originalDate, weekIndex, dayIndex, dateRangeType) {
	            return function (ev) {
	                // remove press styling
	                if (dateRangeType === DateValues_1.DateRangeType.Month) {
	                    _this._applyFunctionToDayRefs(function (ref, day) {
	                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
	                            ref.classList.remove(styles.dayPress);
	                        }
	                    });
	                }
	                else {
	                    // week or work week view
	                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
	                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
	                            ref.classList.remove(styles.dayPress);
	                        }
	                    });
	                }
	            };
	        };
	        _this._onDayMouseOver = function (originalDate, weekIndex, dayIndex, dateRangeType) {
	            return function (ev) {
	                // set the hover styling on every day in the same month
	                if (dateRangeType === DateValues_1.DateRangeType.Month) {
	                    _this._applyFunctionToDayRefs(function (ref, day) {
	                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
	                            ref.classList.add(styles.dayHover);
	                        }
	                    });
	                }
	                else {
	                    // week or work week view
	                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
	                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
	                            ref.classList.add(styles.dayHover);
	                        }
	                    });
	                }
	            };
	        };
	        _this._onDayMouseLeave = function (originalDate, weekIndex, dayIndex, dateRangeType) {
	            return function (ev) {
	                // remove the hover and pressed styling
	                if (dateRangeType === DateValues_1.DateRangeType.Month) {
	                    _this._applyFunctionToDayRefs(function (ref, day) {
	                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
	                            ref.classList.remove(styles.dayHover);
	                        }
	                    });
	                }
	                else {
	                    // week or work week view
	                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
	                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
	                            ref.classList.remove(styles.dayHover);
	                        }
	                    });
	                }
	            };
	        };
	        _this._onTableMouseLeave = function (ev) {
	            if (ev.target.contains &&
	                ev.relatedTarget &&
	                ev.relatedTarget.contains &&
	                ev.target.contains(ev.relatedTarget)) {
	                return;
	            }
	            _this._applyFunctionToDayRefs(function (ref, day) {
	                if (ref) {
	                    ref.classList.remove(styles.dayHover);
	                    ref.classList.remove(styles.dayPress);
	                }
	            });
	        };
	        _this._onTableMouseUp = function (ev) {
	            if (ev.target.contains &&
	                ev.relatedTarget &&
	                ev.relatedTarget.contains &&
	                ev.target.contains(ev.relatedTarget)) {
	                return;
	            }
	            _this._applyFunctionToDayRefs(function (ref, day) {
	                if (ref) {
	                    ref.classList.remove(styles.dayPress);
	                }
	            });
	        };
	        _this._onSelectDate = function (selectedDate, ev) {
	            var _a = _this.props, onSelectDate = _a.onSelectDate, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, navigatedDate = _a.navigatedDate, autoNavigateOnSelection = _a.autoNavigateOnSelection, minDate = _a.minDate, maxDate = _a.maxDate, workWeekDays = _a.workWeekDays;
	            if (ev) {
	                ev.stopPropagation();
	            }
	            var dateRange = DateMath_1.getDateRangeArray(selectedDate, dateRangeType, firstDayOfWeek, workWeekDays);
	            if (dateRangeType !== DateValues_1.DateRangeType.Day) {
	                dateRange = _this._getBoundedDateRange(dateRange, minDate, maxDate);
	            }
	            dateRange = dateRange.filter(function (d) {
	                return !_this._getIsRestrictedDate(d);
	            });
	            if (onSelectDate) {
	                onSelectDate(selectedDate, dateRange);
	            }
	            // Navigate to next or previous month if needed
	            if (autoNavigateOnSelection && selectedDate.getMonth() !== navigatedDate.getMonth()) {
	                var compareResult = DateMath_1.compareDatePart(selectedDate, navigatedDate);
	                if (compareResult < 0) {
	                    _this._onSelectPrevMonth();
	                }
	                else if (compareResult > 0) {
	                    _this._onSelectNextMonth();
	                }
	            }
	        };
	        _this._onSelectNextMonth = function () {
	            _this.props.onNavigateDate(DateMath_1.addMonths(_this.props.navigatedDate, 1), false);
	        };
	        _this._onSelectPrevMonth = function () {
	            _this.props.onNavigateDate(DateMath_1.addMonths(_this.props.navigatedDate, -1), false);
	        };
	        _this._onClose = function () {
	            if (_this.props.onDismiss) {
	                _this.props.onDismiss();
	            }
	        };
	        _this._onHeaderSelect = function () {
	            var onHeaderSelect = _this.props.onHeaderSelect;
	            if (onHeaderSelect) {
	                onHeaderSelect(true);
	            }
	        };
	        _this._onHeaderKeyDown = function (ev) {
	            var onHeaderSelect = _this.props.onHeaderSelect;
	            if (onHeaderSelect && (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space)) {
	                onHeaderSelect(true);
	            }
	        };
	        _this._onPrevMonthKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onKeyDown(_this._onSelectPrevMonth, ev);
	            }
	        };
	        _this._onNextMonthKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onKeyDown(_this._onSelectNextMonth, ev);
	            }
	        };
	        _this._onCloseButtonKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onKeyDown(_this._onClose, ev);
	            }
	        };
	        _this.state = {
	            activeDescendantId: Utilities_1.getId('DatePickerDay-active'),
	            weeks: _this._getWeeks(props)
	        };
	        _this._onSelectNextMonth = _this._onSelectNextMonth.bind(_this);
	        _this._onSelectPrevMonth = _this._onSelectPrevMonth.bind(_this);
	        _this._onClose = _this._onClose.bind(_this);
	        return _this;
	    }
	    CalendarDay.prototype.componentWillReceiveProps = function (nextProps) {
	        this.setState({
	            weeks: this._getWeeks(nextProps)
	        });
	    };
	    CalendarDay.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, activeDescendantId = _a.activeDescendantId, weeks = _a.weeks;
	        var _b = this.props, firstDayOfWeek = _b.firstDayOfWeek, strings = _b.strings, navigatedDate = _b.navigatedDate, selectedDate = _b.selectedDate, dateRangeType = _b.dateRangeType, navigationIcons = _b.navigationIcons, showWeekNumbers = _b.showWeekNumbers, firstWeekOfYear = _b.firstWeekOfYear, dateTimeFormatter = _b.dateTimeFormatter, minDate = _b.minDate, maxDate = _b.maxDate, showCloseButton = _b.showCloseButton, allFocusable = _b.allFocusable;
	        var dayPickerId = Utilities_1.getId('DatePickerDay-dayPicker');
	        var monthAndYearId = Utilities_1.getId('DatePickerDay-monthAndYear');
	        var leftNavigationIcon = navigationIcons.leftNavigation;
	        var rightNavigationIcon = navigationIcons.rightNavigation;
	        var closeNavigationIcon = navigationIcons.closeIcon;
	        var weekNumbers = showWeekNumbers ? DateMath_1.getWeekNumbersInMonth(weeks.length, firstDayOfWeek, firstWeekOfYear, navigatedDate) : null;
	        var selectedDateWeekNumber = showWeekNumbers ? DateMath_1.getWeekNumber(selectedDate, firstDayOfWeek, firstWeekOfYear) : undefined;
	        // When the month is highlighted get the corner dates so that styles can be added to them
	        var weekCorners = this._getWeekCornerStyles(weeks, dateRangeType);
	        // determine if previous/next months are in bounds
	        var prevMonthInBounds = minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getMonthStart(navigatedDate)) < 0 : true;
	        var nextMonthInBounds = maxDate ? DateMath_1.compareDatePart(DateMath_1.getMonthEnd(navigatedDate), maxDate) < 0 : true;
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-dayPicker', styles.dayPicker, showWeekNumbers && 'ms-DatePicker-showWeekNumbers' && (Utilities_1.getRTL() ? styles.showWeekNumbersRTL : styles.showWeekNumbers)), id: dayPickerId },
	            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-header', styles.header) },
	                React.createElement("div", { "aria-live": "polite", "aria-relevant": "text", "aria-atomic": "true", id: monthAndYearId, className: styles.monthAndYear }, this.props.onHeaderSelect ? (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthAndYear js-showMonthPicker', styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatMonthYear(navigatedDate, strings), role: "button", tabIndex: 0 }, dateTimeFormatter.formatMonthYear(navigatedDate, strings))) : (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthAndYear', styles.monthAndYear) }, dateTimeFormatter.formatMonthYear(navigatedDate, strings)))),
	                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthComponents', styles.monthComponents) },
	                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-navContainer', styles.navContainer) },
	                        React.createElement("button", { className: Utilities_1.css('ms-DatePicker-prevMonth js-prevMonth', styles.prevMonth, (_c = {},
	                                _c['ms-DatePicker-prevMonth--disabled ' + styles.prevMonthIsDisabled] = !prevMonthInBounds,
	                                _c)), disabled: !allFocusable && !prevMonthInBounds, "aria-disabled": !prevMonthInBounds, onClick: prevMonthInBounds ? this._onSelectPrevMonth : undefined, onKeyDown: prevMonthInBounds ? this._onPrevMonthKeyDown : undefined, "aria-controls": dayPickerId, title: strings.prevMonthAriaLabel
	                                ? strings.prevMonthAriaLabel + ' ' + strings.months[DateMath_1.addMonths(navigatedDate, -1).getMonth()]
	                                : undefined, role: "button", type: "button" },
	                            React.createElement(Icon_1.Icon, { iconName: leftNavigationIcon })),
	                        React.createElement("button", { className: Utilities_1.css('ms-DatePicker-nextMonth js-nextMonth', styles.nextMonth, (_d = {},
	                                _d['ms-DatePicker-nextMonth--disabled ' + styles.nextMonthIsDisabled] = !nextMonthInBounds,
	                                _d)), disabled: !allFocusable && !nextMonthInBounds, "aria-disabled": !nextMonthInBounds, onClick: nextMonthInBounds ? this._onSelectNextMonth : undefined, onKeyDown: nextMonthInBounds ? this._onNextMonthKeyDown : undefined, "aria-controls": dayPickerId, title: strings.nextMonthAriaLabel
	                                ? strings.nextMonthAriaLabel + ' ' + strings.months[DateMath_1.addMonths(navigatedDate, 1).getMonth()]
	                                : undefined, role: "button", type: "button" },
	                            React.createElement(Icon_1.Icon, { iconName: rightNavigationIcon })),
	                        showCloseButton && (React.createElement("button", { className: Utilities_1.css('ms-DatePicker-closeButton js-closeButton', styles.closeButton), onClick: this._onClose, onKeyDown: this._onCloseButtonKeyDown, title: strings.closeButtonAriaLabel, role: "button", type: "button" },
	                            React.createElement(Icon_1.Icon, { iconName: closeNavigationIcon })))))),
	            React.createElement(FocusZone_1.FocusZone, null,
	                React.createElement("table", { className: Utilities_1.css('ms-DatePicker-table', styles.table), "aria-readonly": "true", "aria-multiselectable": "false", "aria-labelledby": monthAndYearId, "aria-activedescendant": activeDescendantId, role: "grid" },
	                    React.createElement("thead", null,
	                        React.createElement("tr", null,
	                            showWeekNumbers && React.createElement("th", { className: Utilities_1.css('ms-DatePicker-weekday', styles.weekday) }),
	                            strings.shortDays.map(function (val, index) { return (React.createElement("th", { className: Utilities_1.css('ms-DatePicker-weekday', styles.weekday), role: "columnheader", scope: "col", key: index, title: strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK], "aria-label": strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK], "data-is-focusable": allFocusable ? true : undefined }, strings.shortDays[(index + firstDayOfWeek) % DAYS_IN_WEEK])); }))),
	                    React.createElement("tbody", { onMouseLeave: dateRangeType !== DateValues_1.DateRangeType.Day ? this._onTableMouseLeave : undefined, onMouseUp: dateRangeType !== DateValues_1.DateRangeType.Day ? this._onTableMouseUp : undefined }, weeks.map(function (week, weekIndex) {
	                        return (React.createElement("tr", { key: weekNumbers ? weekNumbers[weekIndex] : weekIndex },
	                            showWeekNumbers && weekNumbers && (React.createElement("th", { className: Utilities_1.css('ms-DatePicker-weekNumbers', 'ms-DatePicker-weekday', styles.weekday, styles.weekNumbers), key: weekIndex, title: weekNumbers && strings.weekNumberFormatString && Utilities_1.format(strings.weekNumberFormatString, weekNumbers[weekIndex]), "aria-label": weekNumbers && strings.weekNumberFormatString && Utilities_1.format(strings.weekNumberFormatString, weekNumbers[weekIndex]), scope: "row" },
	                                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-day', styles.day, (_a = {},
	                                        _a['ms-DatePicker-week--highlighted ' + styles.weekIsHighlighted] = selectedDateWeekNumber === weekNumbers[weekIndex],
	                                        _a)) },
	                                    React.createElement("span", null, weekNumbers[weekIndex])))),
	                            week.map(function (day, dayIndex) {
	                                var isNavigatedDate = DateMath_1.compareDates(navigatedDate, day.originalDate);
	                                return (React.createElement("td", { key: day.key, onClick: day.isInBounds ? day.onSelected : undefined, className: Utilities_1.css(styles.dayWrapper, 'ms-DatePicker-day', _this._getHighlightedCornerStyle(weekCorners, dayIndex, weekIndex), (_a = {},
	                                        _a['ms-DatePicker-weekBackground ' + styles.weekBackground] = day.isSelected && (dateRangeType === DateValues_1.DateRangeType.Week || dateRangeType === DateValues_1.DateRangeType.WorkWeek),
	                                        _a['ms-DatePicker-dayBackground ' + styles.dayBackground] = dateRangeType === DateValues_1.DateRangeType.Day,
	                                        _a['ms-DatePicker-day--highlighted ' + styles.dayIsHighlighted] = day.isSelected && dateRangeType === DateValues_1.DateRangeType.Day,
	                                        _a['ms-DatePicker-day--infocus ' + styles.dayIsFocused] = day.isInBounds && day.isInMonth,
	                                        _a['ms-DatePicker-day--outfocus ' + styles.dayIsUnfocused] = day.isInBounds && !day.isInMonth,
	                                        _a[styles.daySelection] = dateRangeType === DateValues_1.DateRangeType.Day,
	                                        _a[styles.weekSelection] = dateRangeType === DateValues_1.DateRangeType.Week || dateRangeType === DateValues_1.DateRangeType.WorkWeek,
	                                        _a[styles.monthSelection] = dateRangeType === DateValues_1.DateRangeType.Month,
	                                        _a)), ref: function (element) { return _this._setDayCellRef(element, day, isNavigatedDate); }, onMouseOver: dateRangeType !== DateValues_1.DateRangeType.Day && day.isInBounds
	                                        ? _this._onDayMouseOver(day.originalDate, weekIndex, dayIndex, dateRangeType)
	                                        : undefined, onMouseLeave: dateRangeType !== DateValues_1.DateRangeType.Day && day.isInBounds
	                                        ? _this._onDayMouseLeave(day.originalDate, weekIndex, dayIndex, dateRangeType)
	                                        : undefined, onMouseDown: dateRangeType !== DateValues_1.DateRangeType.Day && day.isInBounds
	                                        ? _this._onDayMouseDown(day.originalDate, weekIndex, dayIndex, dateRangeType)
	                                        : undefined, onMouseUp: dateRangeType !== DateValues_1.DateRangeType.Day && day.isInBounds
	                                        ? _this._onDayMouseUp(day.originalDate, weekIndex, dayIndex, dateRangeType)
	                                        : undefined, role: 'gridcell' },
	                                    React.createElement("button", { key: day.key + 'button', onClick: day.isInBounds ? day.onSelected : undefined, className: Utilities_1.css(styles.day, 'ms-DatePicker-day-button', (_b = {},
	                                            _b['ms-DatePicker-day--disabled ' + styles.dayIsDisabled] = !day.isInBounds,
	                                            _b['ms-DatePicker-day--today ' + styles.dayIsToday] = day.isToday,
	                                            _b)), role: "gridcell", onKeyDown: _this._onDayKeyDown(day.originalDate, weekIndex, dayIndex), "aria-label": dateTimeFormatter.formatMonthDayYear(day.originalDate, strings), id: isNavigatedDate ? activeDescendantId : undefined, "aria-readonly": true, "aria-selected": day.isInBounds ? day.isSelected : undefined, "data-is-focusable": allFocusable || (day.isInBounds ? true : undefined), ref: function (element) { return _this._setDayRef(element, day, isNavigatedDate); }, disabled: !allFocusable && !day.isInBounds, "aria-disabled": !day.isInBounds, type: "button" },
	                                        React.createElement("span", { "aria-hidden": "true" }, dateTimeFormatter.formatDay(day.originalDate)))));
	                                var _a, _b;
	                            })));
	                        var _a;
	                    }))))));
	        var _c, _d;
	    };
	    CalendarDay.prototype.focus = function () {
	        if (this.navigatedDay) {
	            this.navigatedDay.tabIndex = 0;
	            this.navigatedDay.focus();
	        }
	    };
	    CalendarDay.prototype._setDayRef = function (element, day, isNavigatedDate) {
	        if (isNavigatedDate) {
	            this.navigatedDay = element;
	        }
	    };
	    CalendarDay.prototype._setDayCellRef = function (element, day, isNavigatedDate) {
	        this.days[day.key] = element;
	    };
	    CalendarDay.prototype._getWeekCornerStyles = function (weeks, dateRangeType) {
	        var _this = this;
	        var weekCornersStyled = {};
	        switch (dateRangeType) {
	            case DateValues_1.DateRangeType.Month:
	                /* need to handle setting all of the corners on arbitrarily shaped blobs
	                      __
	                   __|A |
	                  |B |C |__
	                  |D |E |F |
	        
	                  in this case, A needs top left rounded, top right rounded
	                  B needs top left rounded
	                  C doesn't need any rounding
	                  D needs bottom left rounded
	                  E doesn't need any rounding
	                  F needs top right rounding
	                */
	                // if there's an item above, lose both top corners. Item below, lose both bottom corners, etc.
	                weeks.forEach(function (week, weekIndex) {
	                    week.forEach(function (day, dayIndex) {
	                        var above = weeks[weekIndex - 1] &&
	                            weeks[weekIndex - 1][dayIndex] &&
	                            weeks[weekIndex - 1][dayIndex].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
	                        var below = weeks[weekIndex + 1] &&
	                            weeks[weekIndex + 1][dayIndex] &&
	                            weeks[weekIndex + 1][dayIndex].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
	                        var left = weeks[weekIndex][dayIndex - 1] &&
	                            weeks[weekIndex][dayIndex - 1].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
	                        var right = weeks[weekIndex][dayIndex + 1] &&
	                            weeks[weekIndex][dayIndex + 1].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
	                        var roundedTopLeft = !above && !left;
	                        var roundedTopRight = !above && !right;
	                        var roundedBottomLeft = !below && !left;
	                        var roundedBottomRight = !below && !right;
	                        var style = '';
	                        if (roundedTopLeft) {
	                            style = Utilities_1.getRTL() ? style.concat(styles.topRightCornerDate + ' ') : style.concat(styles.topLeftCornerDate + ' ');
	                        }
	                        if (roundedTopRight) {
	                            style = Utilities_1.getRTL() ? style.concat(styles.topLeftCornerDate + ' ') : style.concat(styles.topRightCornerDate + ' ');
	                        }
	                        if (roundedBottomLeft) {
	                            style = Utilities_1.getRTL() ? style.concat(styles.bottomRightCornerDate + ' ') : style.concat(styles.bottomLeftCornerDate + ' ');
	                        }
	                        if (roundedBottomRight) {
	                            style = Utilities_1.getRTL() ? style.concat(styles.bottomLeftCornerDate + ' ') : style.concat(styles.bottomRightCornerDate + ' ');
	                        }
	                        if (!above) {
	                            style = style.concat(styles.topDate + ' ');
	                        }
	                        if (!below) {
	                            style = style.concat(styles.bottomDate + ' ');
	                        }
	                        if (!right) {
	                            style = style.concat(styles.rightDate + ' ');
	                        }
	                        if (!left) {
	                            style = style.concat(styles.leftdate + ' ');
	                        }
	                        weekCornersStyled[weekIndex + '_' + dayIndex] = style;
	                    });
	                });
	                break;
	            case DateValues_1.DateRangeType.Week:
	            case DateValues_1.DateRangeType.WorkWeek:
	                weeks.forEach(function (week, weekIndex) {
	                    var minIndex = Utilities_1.findIndex(week, function (item) {
	                        return item.isInBounds;
	                    });
	                    var maxIndex = _this._findLastIndex(week, function (item) {
	                        return item.isInBounds;
	                    });
	                    var leftStyle = styles.topLeftCornerDate + ' ' + styles.bottomLeftCornerDate;
	                    var rightStyle = styles.topRightCornerDate + ' ' + styles.bottomRightCornerDate;
	                    weekCornersStyled[weekIndex + '_' + minIndex] = Utilities_1.getRTL() ? rightStyle : leftStyle;
	                    weekCornersStyled[weekIndex + '_' + maxIndex] = Utilities_1.getRTL() ? leftStyle : rightStyle;
	                });
	                break;
	        }
	        return weekCornersStyled;
	    };
	    CalendarDay.prototype._getHighlightedCornerStyle = function (weekCorners, dayIndex, weekIndex) {
	        var cornerStyle = weekCorners[weekIndex + '_' + dayIndex] ? weekCorners[weekIndex + '_' + dayIndex] : '';
	        return cornerStyle;
	    };
	    CalendarDay.prototype._navigateMonthEdge = function (ev, date, weekIndex, dayIndex) {
	        var _a = this.props, minDate = _a.minDate, maxDate = _a.maxDate;
	        var targetDate = undefined;
	        if (weekIndex === 0 && ev.which === Utilities_1.KeyCodes.up) {
	            targetDate = DateMath_1.addWeeks(date, -1);
	        }
	        else if (weekIndex === this.state.weeks.length - 1 && ev.which === Utilities_1.KeyCodes.down) {
	            targetDate = DateMath_1.addWeeks(date, 1);
	        }
	        else if (dayIndex === 0 && ev.which === Utilities_1.getRTLSafeKeyCode(Utilities_1.KeyCodes.left)) {
	            targetDate = DateMath_1.addDays(date, -1);
	        }
	        else if (dayIndex === DAYS_IN_WEEK - 1 && ev.which === Utilities_1.getRTLSafeKeyCode(Utilities_1.KeyCodes.right)) {
	            targetDate = DateMath_1.addDays(date, 1);
	        }
	        // Don't navigate to out-of-bounds date
	        if (targetDate &&
	            (minDate ? DateMath_1.compareDatePart(minDate, targetDate) < 1 : true) &&
	            (maxDate ? DateMath_1.compareDatePart(targetDate, maxDate) < 1 : true)) {
	            this.props.onNavigateDate(targetDate, true);
	            ev.preventDefault();
	        }
	    };
	    CalendarDay.prototype._applyFunctionToDayRefs = function (func) {
	        var _this = this;
	        if (this.state.weeks) {
	            this.state.weeks.map(function (week, weekIndex) {
	                week.map(function (day) {
	                    var ref = _this.days[day.key];
	                    func(ref, day, weekIndex);
	                });
	            });
	        }
	    };
	    CalendarDay.prototype._getWeeks = function (propsToUse) {
	        var navigatedDate = propsToUse.navigatedDate, selectedDate = propsToUse.selectedDate, dateRangeType = propsToUse.dateRangeType, firstDayOfWeek = propsToUse.firstDayOfWeek, today = propsToUse.today, minDate = propsToUse.minDate, maxDate = propsToUse.maxDate, showSixWeeksByDefault = propsToUse.showSixWeeksByDefault, workWeekDays = propsToUse.workWeekDays;
	        var date = new Date(navigatedDate.getFullYear(), navigatedDate.getMonth(), 1);
	        var todaysDate = today || new Date();
	        var weeks = [];
	        // Cycle the date backwards to get to the first day of the week.
	        while (date.getDay() !== firstDayOfWeek) {
	            date.setDate(date.getDate() - 1);
	        }
	        // a flag to indicate whether all days of the week are in the month
	        var isAllDaysOfWeekOutOfMonth = false;
	        // in work week view we want to select the whole week
	        var selectedDateRangeType = dateRangeType === DateValues_1.DateRangeType.WorkWeek ? DateValues_1.DateRangeType.Week : dateRangeType;
	        var selectedDates = DateMath_1.getDateRangeArray(selectedDate, selectedDateRangeType, firstDayOfWeek, workWeekDays);
	        if (dateRangeType !== DateValues_1.DateRangeType.Day) {
	            selectedDates = this._getBoundedDateRange(selectedDates, minDate, maxDate);
	        }
	        var shouldGetWeeks = true;
	        for (var weekIndex = 0; shouldGetWeeks; weekIndex++) {
	            var week = [];
	            isAllDaysOfWeekOutOfMonth = true;
	            for (var dayIndex = 0; dayIndex < DAYS_IN_WEEK; dayIndex++) {
	                var originalDate = new Date(date.toString());
	                var dayInfo = {
	                    key: date.toString(),
	                    date: date.getDate().toString(),
	                    originalDate: originalDate,
	                    isInMonth: date.getMonth() === navigatedDate.getMonth(),
	                    isToday: DateMath_1.compareDates(todaysDate, date),
	                    isSelected: DateMath_1.isInDateRangeArray(date, selectedDates),
	                    onSelected: this._onSelectDate.bind(this, originalDate),
	                    isInBounds: (minDate ? DateMath_1.compareDatePart(minDate, date) < 1 : true) &&
	                        (maxDate ? DateMath_1.compareDatePart(date, maxDate) < 1 : true) &&
	                        !this._getIsRestrictedDate(date)
	                };
	                week.push(dayInfo);
	                if (dayInfo.isInMonth) {
	                    isAllDaysOfWeekOutOfMonth = false;
	                }
	                date.setDate(date.getDate() + 1);
	            }
	            // We append the condition of the loop depending upon the showSixWeeksByDefault prop.
	            shouldGetWeeks = showSixWeeksByDefault ? !isAllDaysOfWeekOutOfMonth || weekIndex <= 5 : !isAllDaysOfWeekOutOfMonth;
	            if (shouldGetWeeks) {
	                weeks.push(week);
	            }
	        }
	        return weeks;
	    };
	    CalendarDay.prototype._getIsRestrictedDate = function (date) {
	        var restrictedDates = this.props.restrictedDates;
	        if (!restrictedDates) {
	            return false;
	        }
	        var restrictedDate = Utilities_1.find(restrictedDates, function (rd) {
	            return DateMath_1.compareDates(rd, date);
	        });
	        return restrictedDate ? true : false;
	    };
	    CalendarDay.prototype._getBoundedDateRange = function (dateRange, minDate, maxDate) {
	        var boundedDateRange = dateRange.slice();
	        if (minDate) {
	            boundedDateRange = boundedDateRange.filter(function (date) { return DateMath_1.compareDatePart(date, minDate) >= 0; });
	        }
	        if (maxDate) {
	            boundedDateRange = boundedDateRange.filter(function (date) { return DateMath_1.compareDatePart(date, maxDate) <= 0; });
	        }
	        return boundedDateRange;
	    };
	    /**
	     * Returns the index of the last element in the array where the predicate is true, and -1
	     * otherwise
	     * @param items Array of items to be iterated over using the predicate
	     * @param predicate find calls predicate once for each element of the array, in descending
	     * order, until it finds one where predicate returns true if such an element is found.
	     */
	    CalendarDay.prototype._findLastIndex = function (items, predicate) {
	        for (var i = items.length - 1; i >= 0; i--) {
	            var item = items[i];
	            if (predicate(item)) {
	                return i;
	            }
	        }
	        return -1;
	    };
	    return CalendarDay;
	}(Utilities_1.BaseComponent));
	exports.CalendarDay = CalendarDay;
	//# sourceMappingURL=CalendarDay.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DateValues_1 = __webpack_require__(749);
	var TimeConstants_1 = __webpack_require__(752);
	var Utilities_1 = __webpack_require__(592);
	/**
	 * Returns a date offset from the given date by the specified number of days.
	 * @param {Date} date - The origin date
	 * @param {number} days - The number of days to offset. 'days' can be negative.
	 * @return {Date} A new Date object offset from the origin date by the given number of days
	 */
	function addDays(date, days) {
	    var result = new Date(date.getTime());
	    result.setDate(result.getDate() + days);
	    return result;
	}
	exports.addDays = addDays;
	/**
	 * Returns a date offset from the given date by the specified number of weeks.
	 * @param {Date} date - The origin date
	 * @param {number} weeks - The number of weeks to offset. 'weeks' can be negative.
	 * @return {Date} A new Date object offset from the origin date by the given number of weeks
	 */
	function addWeeks(date, weeks) {
	    return addDays(date, weeks * TimeConstants_1.default.DaysInOneWeek);
	}
	exports.addWeeks = addWeeks;
	/**
	 * Returns a date offset from the given date by the specified number of months.
	 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
	 * to contain the original day-of-month, we'll use the last day of the new month.
	 * @param {Date} date - The origin date
	 * @param {number} months - The number of months to offset. 'months' can be negative.
	 * @return {Date} A new Date object offset from the origin date by the given number of months
	 */
	function addMonths(date, months) {
	    var result = new Date(date.getTime());
	    var newMonth = result.getMonth() + months;
	    result.setMonth(newMonth);
	    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
	    // Loop until we back up to a day the new month has.
	    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
	    if (result.getMonth() !== ((newMonth % TimeConstants_1.default.MonthInOneYear) + TimeConstants_1.default.MonthInOneYear) % TimeConstants_1.default.MonthInOneYear) {
	        result = addDays(result, -result.getDate());
	    }
	    return result;
	}
	exports.addMonths = addMonths;
	/**
	 * Returns a date offset from the given date by the specified number of years.
	 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
	 * to contain the original day-of-month, we'll use the last day of the new month.
	 * @param {Date} date - The origin date
	 * @param {number} years - The number of years to offset. 'years' can be negative.
	 * @return {Date} A new Date object offset from the origin date by the given number of years
	 */
	function addYears(date, years) {
	    var result = new Date(date.getTime());
	    result.setFullYear(date.getFullYear() + years);
	    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
	    // Loop until we back up to a day the new month has.
	    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
	    if (result.getMonth() !==
	        ((date.getMonth() % TimeConstants_1.default.MonthInOneYear) + TimeConstants_1.default.MonthInOneYear) % TimeConstants_1.default.MonthInOneYear) {
	        result = addDays(result, -result.getDate());
	    }
	    return result;
	}
	exports.addYears = addYears;
	/**
	 * Returns a date that is the first day of the month of the provided date.
	 * @param {Date} date - The origin date
	 * @return {Date} A new Date object with the day set to the first day of the month.
	 */
	function getMonthStart(date) {
	    return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
	}
	exports.getMonthStart = getMonthStart;
	/**
	 * Returns a date that is the last day of the month of the provided date.
	 * @param {Date} date - The origin date
	 * @return {Date} A new Date object with the day set to the last day of the month.
	 */
	function getMonthEnd(date) {
	    return new Date(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0, 0);
	}
	exports.getMonthEnd = getMonthEnd;
	/**
	 * Returns a date that is the first day of the year of the provided date.
	 * @param {Date} date - The origin date
	 * @return {Date} A new Date object with the day set to the first day of the year.
	 */
	function getYearStart(date) {
	    return new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
	}
	exports.getYearStart = getYearStart;
	/**
	 * Returns a date that is the last day of the year of the provided date.
	 * @param {Date} date - The origin date
	 * @return {Date} A new Date object with the day set to the last day of the year.
	 */
	function getYearEnd(date) {
	    return new Date(date.getFullYear() + 1, 0, 0, 0, 0, 0, 0);
	}
	exports.getYearEnd = getYearEnd;
	/**
	 * Returns a date that is a copy of the given date, aside from the month changing to the given month.
	 *  The method tries to preserve the day-of-month; however, if the new month does not have enough days
	 * to contain the original day-of-month, we'll use the last day of the new month.
	 * @param {Date} date - The origin date
	 * @param {number} month - The 0-based index of the month to set on the date.
	 * @return {Date} A new Date object with the given month set.
	 */
	function setMonth(date, month) {
	    return addMonths(date, month - date.getMonth());
	}
	exports.setMonth = setMonth;
	/**
	 * Compares two dates, and returns true if the two dates (not accounting for time-of-day) are equal.
	 * @return {boolean} True if the two dates represent the same date (regardless of time-of-day), false otherwise.
	 */
	function compareDates(date1, date2) {
	    if (!date1 && !date2) {
	        return true;
	    }
	    else if (!date1 || !date2) {
	        return false;
	    }
	    else {
	        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
	    }
	}
	exports.compareDates = compareDates;
	/**
	 * Compare the date parts of two dates
	 * @param {Date} date1 - The first date to compare
	 * @param {Date} date2 - The second date to compare
	 * @returns {Number} A negative value if date1 is earlier than date2, 0 if the dates are equal, or a positive value
	 * if date1 is later than date2.
	 */
	function compareDatePart(date1, date2) {
	    return getDatePartHashValue(date1) - getDatePartHashValue(date2);
	}
	exports.compareDatePart = compareDatePart;
	/**
	 * Gets the date range array including the specified date. The date range array is calculated as the list
	 * of dates accounting for the specified first day of the week and date range type.
	 * @param {Date} date - The input date
	 * @param {DateRangeType} dateRangeType - The desired date range type, i.e., day, week, month, etc.
	 * @param {DayOfWeek} firstDayOfWeek - The first day of the week.
	 * @param {DayOfWeek[]} workWeekDays - The allowed days in work week. If not provided, assumes all days are allowed.
	 * @returns {Date[]} An array of dates representing the date range containing the specified date.
	 */
	function getDateRangeArray(date, dateRangeType, firstDayOfWeek, workWeekDays) {
	    var datesArray = new Array();
	    var startDate;
	    var endDate = null;
	    if (!workWeekDays) {
	        workWeekDays = [DateValues_1.DayOfWeek.Monday, DateValues_1.DayOfWeek.Tuesday, DateValues_1.DayOfWeek.Wednesday, DateValues_1.DayOfWeek.Thursday, DateValues_1.DayOfWeek.Friday];
	    }
	    switch (dateRangeType) {
	        case DateValues_1.DateRangeType.Day:
	            startDate = getDatePart(date);
	            endDate = addDays(startDate, 1);
	            break;
	        case DateValues_1.DateRangeType.Week:
	        case DateValues_1.DateRangeType.WorkWeek:
	            startDate = getStartDateOfWeek(getDatePart(date), firstDayOfWeek);
	            endDate = addDays(startDate, TimeConstants_1.default.DaysInOneWeek);
	            break;
	        case DateValues_1.DateRangeType.Month:
	            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
	            endDate = addMonths(startDate, 1);
	            break;
	        default:
	            return Utilities_1.assertNever(dateRangeType);
	    }
	    // Populate the dates array with the dates in range
	    var nextDate = startDate;
	    do {
	        if (dateRangeType !== DateValues_1.DateRangeType.WorkWeek) {
	            // push all days not in work week view
	            datesArray.push(nextDate);
	        }
	        else if (workWeekDays.indexOf(nextDate.getDay()) !== -1) {
	            datesArray.push(nextDate);
	        }
	        nextDate = addDays(nextDate, 1);
	    } while (!compareDates(nextDate, endDate));
	    return datesArray;
	}
	exports.getDateRangeArray = getDateRangeArray;
	/**
	 * Checks whether the specified date is in the given date range.
	 * @param {Date} date - The origin date
	 * @param {Date[]} dateRange - An array of dates to do the lookup on
	 * @returns {bool} True if the date matches one of the dates in the specified array, false otherwise.
	 */
	function isInDateRangeArray(date, dateRange) {
	    for (var _i = 0, dateRange_1 = dateRange; _i < dateRange_1.length; _i++) {
	        var dateInRange = dateRange_1[_i];
	        if (compareDates(date, dateInRange)) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.isInDateRangeArray = isInDateRangeArray;
	/**
	 * Returns the week number for a date.
	 * Week numbers are 1 - 52 (53) in a year
	 * @param {navigatedDate} Date - A date to find the week number for.
	 * @param {firstDayOfWeek} DayOfWeek - The first day of the week (0-6, Sunday = 0)
	 * @param {firstWeekOfYear} FirstWeekOfYear - The first week of the year (1-2)
	 * @return {weeksArray} The weeks number array for the current month.
	 */
	function getWeekNumbersInMonth(weeksInMonth, firstDayOfWeek, firstWeekOfYear, navigatedDate) {
	    var selectedYear = navigatedDate.getFullYear();
	    var selectedMonth = navigatedDate.getMonth();
	    var dayOfMonth = 1;
	    var fistDayOfMonth = new Date(selectedYear, selectedMonth, dayOfMonth);
	    var endOfFirstWeek = dayOfMonth + (firstDayOfWeek + TimeConstants_1.default.DaysInOneWeek - 1) - adjustWeekDay(firstDayOfWeek, fistDayOfMonth.getDay());
	    var endOfWeekRange = new Date(selectedYear, selectedMonth, endOfFirstWeek);
	    dayOfMonth = endOfWeekRange.getDate();
	    var weeksArray = [];
	    for (var i = 0; i < weeksInMonth; i++) {
	        // Get week number for end of week
	        weeksArray.push(getWeekNumber(endOfWeekRange, firstDayOfWeek, firstWeekOfYear));
	        dayOfMonth += TimeConstants_1.default.DaysInOneWeek;
	        endOfWeekRange = new Date(selectedYear, selectedMonth, dayOfMonth);
	    }
	    return weeksArray;
	}
	exports.getWeekNumbersInMonth = getWeekNumbersInMonth;
	/**
	 * Returns the week number for a date.
	 * Week numbers are 1 - 52 (53) in a year
	 * @param {Date} date - A date to find the week number for.
	 * @param {DayOfWeek} firstDayOfWeek - The first day of the week (0-6, Sunday = 0)
	 * @param {firstWeekOfYear} firstWeekOfYear - The first week of the year (1-2)
	 * @return {Number} The week's number in the year.
	 */
	function getWeekNumber(date, firstDayOfWeek, firstWeekOfYear) {
	    // First four-day week of the year - minumum days count
	    var fourDayWeek = 4;
	    switch (firstWeekOfYear) {
	        case DateValues_1.FirstWeekOfYear.FirstFullWeek:
	            return getWeekOfYearFullDays(date, firstDayOfWeek, TimeConstants_1.default.DaysInOneWeek);
	        case DateValues_1.FirstWeekOfYear.FirstFourDayWeek:
	            return getWeekOfYearFullDays(date, firstDayOfWeek, fourDayWeek);
	        default:
	            return getFirstDayWeekOfYear(date, firstDayOfWeek);
	    }
	}
	exports.getWeekNumber = getWeekNumber;
	/**
	 * Gets a new date with the time portion zeroed out, i.e., set to midnight
	 * @param {Date} date - The origin date
	 * @returns {Date} A new date with the time set to midnight
	 */
	function getDatePart(date) {
	    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}
	/**
	 * Gets the date for the first day of the week based on the given date assuming
	 * the specified first day of the week.
	 * @param {Date} date - The date to find the beginning of the week date for.
	 * @return {Date} A new date object representing the first day of the week containing the input date.
	 */
	function getStartDateOfWeek(date, firstDayOfWeek) {
	    var daysOffset = firstDayOfWeek - date.getDay();
	    if (daysOffset > 0) {
	        // If first day of week is > date, go 1 week back, to ensure resulting date is in the past.
	        daysOffset -= TimeConstants_1.default.DaysInOneWeek;
	    }
	    return addDays(date, daysOffset);
	}
	/**
	 * Helper function to assist in date comparisons
	 */
	function getDatePartHashValue(date) {
	    // Generate date hash value created as sum of Date (up to 31 = 5 bits), Month (up to 11 = 4 bits) and Year.
	    /* tslint:disable:no-bitwise */
	    return date.getDate() + (date.getMonth() << 5) + (date.getFullYear() << 9);
	    /* tslint:enable:no-bitwise */
	}
	/**
	 * Helper function for getWeekNumber.
	 * Returns week number for a date
	 * @param {date} Date - current selected date.
	 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
	 * @param {numberOfFullDays} number - week settings.
	 * @return {Number} The week's number in the year.
	 */
	function getWeekOfYearFullDays(date, firstDayOfWeek, numberOfFullDays) {
	    var dayOfYear = getDayOfYear(date) - 1;
	    var num = date.getDay() - (dayOfYear % TimeConstants_1.default.DaysInOneWeek);
	    var lastDayOfPrevYear = new Date(date.getFullYear() - 1, DateValues_1.MonthOfYear.December, 31);
	    var daysInYear = getDayOfYear(lastDayOfPrevYear) - 1;
	    var num2 = (firstDayOfWeek - num + 2 * TimeConstants_1.default.DaysInOneWeek) % TimeConstants_1.default.DaysInOneWeek;
	    if (num2 !== 0 && num2 >= numberOfFullDays) {
	        num2 -= TimeConstants_1.default.DaysInOneWeek;
	    }
	    var num3 = dayOfYear - num2;
	    if (num3 < 0) {
	        num -= daysInYear % TimeConstants_1.default.DaysInOneWeek;
	        num2 = (firstDayOfWeek - num + 2 * TimeConstants_1.default.DaysInOneWeek) % TimeConstants_1.default.DaysInOneWeek;
	        if (num2 !== 0 && num2 + 1 >= numberOfFullDays) {
	            num2 -= TimeConstants_1.default.DaysInOneWeek;
	        }
	        num3 = daysInYear - num2;
	    }
	    return Math.floor(num3 / TimeConstants_1.default.DaysInOneWeek + 1);
	}
	/**
	 * Helper function for getWeekNumber.
	 * Returns week number for a date
	 * @param {date} Date - current selected date.
	 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
	 * @return {Number} The week's number in the year.
	 */
	function getFirstDayWeekOfYear(date, firstDayOfWeek) {
	    var num = getDayOfYear(date) - 1;
	    var num2 = date.getDay() - (num % TimeConstants_1.default.DaysInOneWeek);
	    var num3 = (num2 - firstDayOfWeek + 2 * TimeConstants_1.default.DaysInOneWeek) % TimeConstants_1.default.DaysInOneWeek;
	    return Math.floor((num + num3) / TimeConstants_1.default.DaysInOneWeek + 1);
	}
	/**
	 * Helper function for getWeekNumber.
	 * Returns adjusted week day number when firstDayOfWeek is other than Sunday
	 * For Week Day Number comparison checks
	 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
	 * @param {dateWeekDay} DayOfWeek - shifts number forward to 1 week in case passed as true
	 * @return {DayOfWeek} The day of week adjusted to firstDayOfWeek. E.g. when FirstDyOfWeek is Monday (1), Sunday becomes = 7 (7 > 1).
	 */
	function adjustWeekDay(firstDayOfWeek, dateWeekDay) {
	    return firstDayOfWeek !== DateValues_1.DayOfWeek.Sunday && dateWeekDay < firstDayOfWeek ? dateWeekDay + TimeConstants_1.default.DaysInOneWeek : dateWeekDay;
	}
	/**
	 * Returns the day number for a date in a year
	 * The number of days since January 1st in the particular year.
	 * @param {Date} date - A date to find the day number for.
	 * @return {Number} The day's number in the year.
	 */
	function getDayOfYear(date) {
	    var month = date.getMonth();
	    var year = date.getFullYear();
	    var daysUntilDate = 0;
	    for (var i = 0; i < month; i++) {
	        daysUntilDate += daysInMonth(i + 1, year);
	    }
	    daysUntilDate += date.getDate();
	    return daysUntilDate;
	}
	/**
	 * Returns the number of days in the month
	 * @param {number} month - The month number to target (months 1-12).
	 * @param {number} year - The year to target.
	 * @return {Number} The number of days in the month.
	 */
	function daysInMonth(month, year) {
	    return new Date(year, month, 0).getDate();
	}
	//# sourceMappingURL=DateMath.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Common constants and methods
	 */
	var TimeConstants = {
	    MillisecondsInOneDay: 86400000,
	    MillisecondsIn1Sec: 1000,
	    MillisecondsIn1Min: 60000,
	    MillisecondsIn30Mins: 1800000,
	    MillisecondsIn1Hour: 3600000,
	    MinutesInOneDay: 1440,
	    MinutesInOneHour: 60,
	    DaysInOneWeek: 7,
	    MonthInOneYear: 12
	};
	exports.default = TimeConstants;
	//# sourceMappingURL=TimeConstants.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".root_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0}.root_8e9f232b *{overflow:visible}.root_8e9f232b *::-moz-focus-inner{border:0}.root_8e9f232b *{outline:transparent}.root_8e9f232b *{position:relative}.ms-Fabric--isFocusVisible .root_8e9f232b *:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid " }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.picker_8e9f232b{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";font-size:14px;position:relative}html[dir='ltr'] .picker_8e9f232b{text-align:left}html[dir='rtl'] .picker_8e9f232b{text-align:right}.holder_8e9f232b{-webkit-overflow-scrolling:touch;-webkit-box-sizing:border-box;box-sizing:border-box;display:none}.picker_8e9f232b.pickerIsOpened_8e9f232b .holder_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block}.pickerIsOpened_8e9f232b{position:relative}.frame_8e9f232b{position:relative}.wrap_8e9f232b{min-height:212px;padding:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:content-box;box-sizing:content-box}.wrap_8e9f232b.goTodaySpacing_8e9f232b{min-height:228px}.dayPicker_8e9f232b{display:block}.header_8e9f232b{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:28px;line-height:44px;width:100%}.divider_8e9f232b{top:0;margin-top:-12px;margin-bottom:-12px}html[dir='ltr'] .divider_8e9f232b{border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}html[dir='rtl'] .divider_8e9f232b{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.monthAndYear_8e9f232b,.year_8e9f232b,.decade_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:14px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600;padding:0 5px}.monthAndYear_8e9f232b:hover,.currentYear_8e9f232b:hover,.currentDecade_8e9f232b:hover{cursor:default}.table_8e9f232b{text-align:center;border-collapse:collapse;border-spacing:0;table-layout:fixed;font-size:inherit;margin-top:4px;width:197px}.table_8e9f232b td{margin:0;padding:0}.dayWrapper_8e9f232b,.weekday_8e9f232b{width:28px;height:28px;padding:0;line-height:28px;font-size:12px;font-size:15px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:default}.dayWrapper_8e9f232b *::-moz-focus-inner,.weekday_8e9f232b *::-moz-focus-inner{border:0}.dayWrapper_8e9f232b *,.weekday_8e9f232b *{outline:transparent}.dayWrapper_8e9f232b *,.weekday_8e9f232b *{position:relative}.ms-Fabric--isFocusVisible .dayWrapper_8e9f232b *:focus:after,.ms-Fabric--isFocusVisible .weekday_8e9f232b *:focus:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:1px solid " }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.day_8e9f232b{width:24px;height:24px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none;padding:0;background-color:transparent;line-height:100%;font-size:inherit;color:inherit;font-weight:inherit}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b .day_8e9f232b:hover,.daySelection_8e9f232b .day_8e9f232b:active{outline:1px solid highlight}}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b .day_8e9f232b:active{color:highlight}}.dayIsToday_8e9f232b,.dayIsToday_8e9f232b:hover{position:relative;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.dayIsToday_8e9f232b,.dayIsToday_8e9f232b:hover{background-color:highlight;border-radius:2px}}@media screen and (-ms-high-contrast: active){.dayIsToday_8e9f232b span,.dayIsToday_8e9f232b:hover span{-ms-high-contrast-adjust:none;color:window}}.dayIsToday_8e9f232b:hover,.dayIsToday_8e9f232b:hover:hover{border-radius:0px}.dayIsDisabled_8e9f232b:before{border-top-color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayIsUnfocused_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-weight:400}.dayIsFocused_8e9f232b:hover,.dayIsUnfocused_8e9f232b:hover{cursor:pointer;background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b{cursor:pointer}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b{border:2px solid Highlight}.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover :not(.dayIsToday_8e9f232b) span,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b :not(.dayIsToday_8e9f232b) span{color:Highlight}}@media screen and (-ms-high-contrast: active){.dayIsHighlighted_8e9f232b button.dayIsToday_8e9f232b{border-radius:0px}}@media screen and (-ms-high-contrast: active){.dayIsHighlighted_8e9f232b button.dayIsToday_8e9f232b span{color:Window}}.dayIsFocused_8e9f232b:active,.dayIsHighlighted_8e9f232b{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.dayIsFocused_8e9f232b:active.day_8e9f232b,.dayIsHighlighted_8e9f232b.day_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600}.dayIsHighlighted_8e9f232b.dayDisabled_8e9f232b,.dayIsHighlighted_8e9f232b.dayDisabled_8e9f232b:hover{background:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayBackground_8e9f232b,.dayBackground_8e9f232b:hover,.dayBackground_8e9f232b:active{border-radius:2px}.dayHover_8e9f232b,.dayHover_8e9f232b:hover{cursor:pointer;background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.dayPress_8e9f232b,.dayPress_8e9f232b:hover{cursor:pointer;font-weight:600;background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.dayPress_8e9f232b .dayIsToday_8e9f232b,.dayPress_8e9f232b:hover .dayIsToday_8e9f232b{background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.dayIsUnfocused_8e9f232b:active,.dayIsFocused_8e9f232b:active,.dayIsHighlighted_8e9f232b,.dayIsHighlighted_8e9f232b:hover,.dayIsHighlighted_8e9f232b:active,.weekBackground_8e9f232b,.weekBackground_8e9f232b:hover,.weekBackground_8e9f232b:active{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600}.dayIsToday_8e9f232b,.pickerIsFocused_8e9f232b .dayIsToday_8e9f232b,.dayIsToday_8e9f232b.day_8e9f232b:active{position:relative;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";font-weight:600;background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b{border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;width:28px;padding:0}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b.weekIsHighlighted_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.showWeekNumbers_8e9f232b .table_8e9f232b{width:225px}.showWeekNumbers_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbers_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:30px}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b.weekIsHighlighted_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.showWeekNumbersRTL_8e9f232b .table_8e9f232b{width:225px}.showWeekNumbersRTL_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbersRTL_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:30px}.monthComponents_8e9f232b,.yearComponents_8e9f232b,.decadeComponents_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:end;align-self:flex-end}.closeButton_8e9f232b,.prevMonth_8e9f232b,.nextMonth_8e9f232b,.prevYear_8e9f232b,.nextYear_8e9f232b,.prevDecade_8e9f232b,.nextDecade_8e9f232b{width:28px;height:28px;display:block;text-align:center;line-height:28px;text-align:center;font-size:12px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";border-radius:2px;position:relative;background-color:transparent;border:none;padding:0}.closeButton_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevDecade_8e9f232b:hover,.nextDecade_8e9f232b:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";cursor:pointer;outline:1px solid transparent}.prevMonthIsDisabled_8e9f232b,.nextMonthIsDisabled_8e9f232b,.prevYearIsDisabled_8e9f232b,.nextYearIsDisabled_8e9f232b,.prevDecadeIsDisabled_8e9f232b,.nextDecadeIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.headerToggleView_8e9f232b{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 8px}.headerToggleView_8e9f232b:hover{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";cursor:pointer}@media screen and (-ms-high-contrast: active){.headerToggleView_8e9f232b:hover{outline:1px solid highlight}}@media screen and (-ms-high-contrast: active){.headerToggleView_8e9f232b:hover:active{color:highlight}}.currentYear_8e9f232b,.currentDecade_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:0 5px;font-size:14px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:28px;line-height:28px;font-weight:600}html[dir='ltr'] .currentYear_8e9f232b,html[dir='ltr'] .currentDecade_8e9f232b{margin-left:5px}html[dir='rtl'] .currentYear_8e9f232b,html[dir='rtl'] .currentDecade_8e9f232b{margin-right:5px}.optionGrid_8e9f232b{position:relative;height:210px;width:196px;margin:4px 0 0 0}html[dir='rtl'] .optionGrid_8e9f232b{margin:4px 0 0 0}.monthOption_8e9f232b,.yearOption_8e9f232b{width:60px;height:60px;line-height:100%;cursor:pointer;margin:0 10px 10px 0;font-size:13px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";text-align:center;border:none;padding:0;background-color:transparent;border-radius:2px}html[dir='ltr'] .monthOption_8e9f232b,html[dir='ltr'] .yearOption_8e9f232b{float:left}html[dir='rtl'] .monthOption_8e9f232b,html[dir='rtl'] .yearOption_8e9f232b{float:right}html[dir='rtl'] .monthOption_8e9f232b,html[dir='rtl'] .yearOption_8e9f232b{margin:0 0 10px 10px}.monthOption_8e9f232b:hover,.yearOption_8e9f232b:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";outline:1px solid transparent}@media screen and (-ms-high-contrast: active){.monthOption_8e9f232b:hover,.yearOption_8e9f232b:hover{outline-color:highlight}}@media screen and (-ms-high-contrast: active){.monthOption_8e9f232b:active,.yearOption_8e9f232b:active{color:highlight}}.monthOption_8e9f232b.isHighlighted_8e9f232b,.yearOption_8e9f232b.isHighlighted_8e9f232b{background-color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.dayIsDisabled_8e9f232b,.monthOptionIsDisabled_8e9f232b,.yearOptionIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.goToday_8e9f232b{bottom:0;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";cursor:pointer;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:30px;line-height:30px;padding:0 10px;background-color:transparent;border:none;position:absolute !important;-webkit-box-sizing:content-box;box-sizing:content-box}[dir='ltr'] .goToday_8e9f232b{right:13px}[dir='rtl'] .goToday_8e9f232b{left:13px}.goToday_8e9f232b:hover{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";outline:1px solid transparent}@media screen and (-ms-high-contrast: active){.goToday_8e9f232b:hover{outline-color:highlight}}.goToday_8e9f232b:active{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.goToday_8e9f232b:active{color:highlight}}.goToTodayIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.goTodayInlineMonth_8e9f232b{top:212px}.wrap_8e9f232b.goTodaySpacing_8e9f232b{padding-bottom:28px}.root_8e9f232b.isPickingYears_8e9f232b .dayPicker_8e9f232b,.root_8e9f232b.isPickingYears_8e9f232b .monthComponents_8e9f232b{display:none}.root_8e9f232b.isPickingYears_8e9f232b .monthPicker_8e9f232b{display:none}.root_8e9f232b.isPickingYears_8e9f232b .yearPicker_8e9f232b{display:block}@media (min-device-width: 460px){.wrap_8e9f232b{padding:12px}.dayPicker_8e9f232b,.monthPicker_8e9f232b{min-height:200px}.header_8e9f232b{height:28px;line-height:28px;width:100%}.dayWrapper_8e9f232b,.weekday_8e9f232b{width:28px;height:28px;line-height:28px;font-size:12px}.closeButton_8e9f232b,.prevMonth_8e9f232b,.nextMonth_8e9f232b,.prevYear_8e9f232b,.nextYear_8e9f232b,.prevDecade_8e9f232b,.nextDecade_8e9f232b{font-size:12px;width:28px;height:28px;line-height:28px}.holder_8e9f232b{display:inline-block;height:auto;overflow:hidden}.monthAndYear_8e9f232b,.year_8e9f232b,.decade_8e9f232b{font-size:14px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.yearComponents_8e9f232b{margin-left:1px}.goToday_8e9f232b{padding:0 3px}[dir='ltr'] .goToday_8e9f232b{right:20px}[dir='rtl'] .goToday_8e9f232b{left:20px}.showWeekNumbers_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbers_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:28px}.showWeekNumbersRTL_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbersRTL_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:28px}.monthPickerVisible_8e9f232b .wrap_8e9f232b{padding:12px}.monthPickerVisible_8e9f232b .dayPicker_8e9f232b{margin:-10px 0;padding:10px 0}.monthPickerVisible_8e9f232b .dayPicker_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;width:212px;min-height:200px}.monthPickerVisible_8e9f232b .monthPicker_8e9f232b{display:block}.monthPickerVisible_8e9f232b .optionGrid_8e9f232b{height:150px;width:196px}.monthPickerVisible_8e9f232b .toggleMonthView_8e9f232b{display:none}.monthPickerVisible_8e9f232b .currentYear_8e9f232b,.monthPickerVisible_8e9f232b .currentDecade_8e9f232b{font-size:14px;margin:0;height:28px;line-height:28px;display:inline-block}.monthPickerVisible_8e9f232b .monthOption_8e9f232b,.monthPickerVisible_8e9f232b .yearOption_8e9f232b{width:40px;height:40px;line-height:100%;font-size:12px;margin:0 12px 16px 0}html[dir='rtl'] .monthPickerVisible_8e9f232b .monthOption_8e9f232b,html[dir='rtl'] .monthPickerVisible_8e9f232b .yearOption_8e9f232b{margin:0 0 16px 12px}.monthPickerVisible_8e9f232b .monthOption_8e9f232b:hover,.monthPickerVisible_8e9f232b .yearOption_8e9f232b:hover{outline:1px solid transparent}.monthPickerVisible_8e9f232b .monthOption_8e9f232b:nth-child(4n+4),.monthPickerVisible_8e9f232b .yearOption_8e9f232b:nth-child(4n+4){margin:0 0px 16px 0}html[dir='rtl'] .monthPickerVisible_8e9f232b .monthOption_8e9f232b:nth-child(4n+4),html[dir='rtl'] .monthPickerVisible_8e9f232b .yearOption_8e9f232b:nth-child(4n+4){margin:0 0 16px 0px}.monthPickerVisible_8e9f232b .goToday_8e9f232b{font-size:12px;height:28px;line-height:28px;padding:0 10px}[dir='ltr'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{right:8px}[dir='rtl'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{left:8px}html[dir='ltr'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{text-align:right}html[dir='rtl'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{text-align:left}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .dayPicker_8e9f232b,.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .monthComponents_8e9f232b{display:block}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .monthPicker_8e9f232b{display:none}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .yearPicker_8e9f232b{display:block}.calendarsInline_8e9f232b .wrap_8e9f232b{padding:12px}.calendarsInline_8e9f232b .holder_8e9f232b{height:auto}html[dir='ltr'] .calendarsInline_8e9f232b .table_8e9f232b{margin-right:12px}html[dir='rtl'] .calendarsInline_8e9f232b .table_8e9f232b{margin-left:12px}.calendarsInline_8e9f232b .dayPicker_8e9f232b{width:auto}html[dir='ltr'] .calendarsInline_8e9f232b .monthPicker_8e9f232b{margin-left:12px}html[dir='rtl'] .calendarsInline_8e9f232b .monthPicker_8e9f232b{margin-right:12px}html[dir='ltr'] .calendarsInline_8e9f232b .yearPicker_8e9f232b{margin-left:12px}html[dir='rtl'] .calendarsInline_8e9f232b .yearPicker_8e9f232b{margin-right:12px}.calendarsInline_8e9f232b .goToday_8e9f232b{padding:0 10px}[dir='ltr'] .calendarsInline_8e9f232b .goToday_8e9f232b{right:14px}[dir='rtl'] .calendarsInline_8e9f232b .goToday_8e9f232b{left:14px}html[dir='ltr'] .calendarsInline_8e9f232b .monthComponents_8e9f232b{margin-right:12px}html[dir='rtl'] .calendarsInline_8e9f232b .monthComponents_8e9f232b{margin-left:12px}.monthPickerOnly_8e9f232b .wrap_8e9f232b{padding:12px}.monthPickerAsOverlay_8e9f232b .wrap_8e9f232b{padding-bottom:28px;margin-bottom:6px}.monthPickerAsOverlay_8e9f232b .holder_8e9f232b{height:240px;min-height:240px}.monthPickerAsOverlay_8e9f232b .holderWithButton_8e9f232b{padding-top:6px;height:auto}}@media (max-device-width: 459px){.calendarsInline_8e9f232b .monthPicker_8e9f232b,.calendarsInline_8e9f232b .yearPicker_8e9f232b{display:none}.yearComponents_8e9f232b{margin-top:2px}}.goToday_8e9f232b{width:auto}.closeButton_8e9f232b,.nextMonth_8e9f232b,.prevMonth_8e9f232b,.nextYear_8e9f232b,.prevYear_8e9f232b,.nextDecade_8e9f232b,.prevDecade_8e9f232b{display:inline-block}.closeButton_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextDecade_8e9f232b:hover,.prevDecade_8e9f232b:hover{background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.closeButton_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextDecade_8e9f232b:hover,.prevDecade_8e9f232b:hover{outline:1px solid highlight}}.closeButton_8e9f232b:active,.nextMonth_8e9f232b:active,.prevMonth_8e9f232b:active,.nextYear_8e9f232b:active,.prevYear_8e9f232b:active,.nextDecade_8e9f232b:active,.prevDecade_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.closeButton_8e9f232b:active,.nextMonth_8e9f232b:active,.prevMonth_8e9f232b:active,.nextYear_8e9f232b:active,.prevYear_8e9f232b:active,.nextDecade_8e9f232b:active,.prevDecade_8e9f232b:active{color:highlight}}.monthIsHighlighted_8e9f232b{font-weight:600;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.monthIsHighlighted_8e9f232b.monthOption_8e9f232b:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.monthIsHighlighted_8e9f232b{color:highlight;border:2px solid highlight;border-radius:2px}.monthIsHighlighted_8e9f232b:hover{outline:0 !important}}.monthIsCurrentMonth_8e9f232b{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.monthIsCurrentMonth_8e9f232b.monthOption_8e9f232b:hover{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.monthOption_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.yearIsHighlighted_8e9f232b{font-weight:600;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.yearIsHighlighted_8e9f232b.yearOption_8e9f232b:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.yearIsCurrentYear_8e9f232b{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.yearIsCurrentYear_8e9f232b.yearOption_8e9f232b:hover{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.yearOption_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.topLeftCornerDate_8e9f232b{border-top-left-radius:2px}.topRightCornerDate_8e9f232b{border-top-right-radius:2px}.bottomLeftCornerDate_8e9f232b{border-bottom-left-radius:2px}.bottomRightCornerDate_8e9f232b{border-bottom-right-radius:2px}@media screen and (-ms-high-contrast: active){.weekBackground_8e9f232b{border-top:1px solid highlight;border-bottom:1px solid highlight}.weekBackground_8e9f232b.bottomRightCornerDate_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;border-left:none;padding-left:1px}.weekBackground_8e9f232b.bottomLeftCornerDate_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;border-right:none;padding-right:1px}.weekBackground_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}.weekSelection_8e9f232b.dayHover_8e9f232b{border-top:1px solid highlight;border-bottom:1px solid highlight}.weekSelection_8e9f232b.dayHover_8e9f232b.bottomLeftCornerDate_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.weekSelection_8e9f232b.dayHover_8e9f232b.bottomRightCornerDate_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.weekSelection_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}.monthSelection_8e9f232b.dayHover_8e9f232b.bottomLeftCornerDate_8e9f232b,.monthSelection_8e9f232b.dayHover_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.monthSelection_8e9f232b.dayHover_8e9f232b.bottomRightCornerDate_8e9f232b,.monthSelection_8e9f232b.dayHover_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.topDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.topDate_8e9f232b{border-top:1px solid highlight;padding-bottom:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.rightDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.rightDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.bottomDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.bottomDate_8e9f232b{border-bottom:1px solid highlight;padding-top:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.leftdate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.leftdate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}}\n" }]);
	exports.root = "root_8e9f232b";
	exports.picker = "picker_8e9f232b";
	exports.holder = "holder_8e9f232b";
	exports.pickerIsOpened = "pickerIsOpened_8e9f232b";
	exports.frame = "frame_8e9f232b";
	exports.wrap = "wrap_8e9f232b";
	exports.goTodaySpacing = "goTodaySpacing_8e9f232b";
	exports.dayPicker = "dayPicker_8e9f232b";
	exports.header = "header_8e9f232b";
	exports.divider = "divider_8e9f232b";
	exports.monthAndYear = "monthAndYear_8e9f232b";
	exports.year = "year_8e9f232b";
	exports.decade = "decade_8e9f232b";
	exports.currentYear = "currentYear_8e9f232b";
	exports.currentDecade = "currentDecade_8e9f232b";
	exports.table = "table_8e9f232b";
	exports.dayWrapper = "dayWrapper_8e9f232b";
	exports.weekday = "weekday_8e9f232b";
	exports.day = "day_8e9f232b";
	exports.daySelection = "daySelection_8e9f232b";
	exports.dayIsToday = "dayIsToday_8e9f232b";
	exports.dayIsDisabled = "dayIsDisabled_8e9f232b";
	exports.dayIsUnfocused = "dayIsUnfocused_8e9f232b";
	exports.dayIsFocused = "dayIsFocused_8e9f232b";
	exports.dayIsHighlighted = "dayIsHighlighted_8e9f232b";
	exports.pickerIsFocused = "pickerIsFocused_8e9f232b";
	exports.dayDisabled = "dayDisabled_8e9f232b";
	exports.dayBackground = "dayBackground_8e9f232b";
	exports.dayHover = "dayHover_8e9f232b";
	exports.dayPress = "dayPress_8e9f232b";
	exports.weekBackground = "weekBackground_8e9f232b";
	exports.showWeekNumbers = "showWeekNumbers_8e9f232b";
	exports.weekNumbers = "weekNumbers_8e9f232b";
	exports.weekIsHighlighted = "weekIsHighlighted_8e9f232b";
	exports.showWeekNumbersRTL = "showWeekNumbersRTL_8e9f232b";
	exports.monthComponents = "monthComponents_8e9f232b";
	exports.yearComponents = "yearComponents_8e9f232b";
	exports.decadeComponents = "decadeComponents_8e9f232b";
	exports.closeButton = "closeButton_8e9f232b";
	exports.prevMonth = "prevMonth_8e9f232b";
	exports.nextMonth = "nextMonth_8e9f232b";
	exports.prevYear = "prevYear_8e9f232b";
	exports.nextYear = "nextYear_8e9f232b";
	exports.prevDecade = "prevDecade_8e9f232b";
	exports.nextDecade = "nextDecade_8e9f232b";
	exports.prevMonthIsDisabled = "prevMonthIsDisabled_8e9f232b";
	exports.nextMonthIsDisabled = "nextMonthIsDisabled_8e9f232b";
	exports.prevYearIsDisabled = "prevYearIsDisabled_8e9f232b";
	exports.nextYearIsDisabled = "nextYearIsDisabled_8e9f232b";
	exports.prevDecadeIsDisabled = "prevDecadeIsDisabled_8e9f232b";
	exports.nextDecadeIsDisabled = "nextDecadeIsDisabled_8e9f232b";
	exports.headerToggleView = "headerToggleView_8e9f232b";
	exports.optionGrid = "optionGrid_8e9f232b";
	exports.monthOption = "monthOption_8e9f232b";
	exports.yearOption = "yearOption_8e9f232b";
	exports.isHighlighted = "isHighlighted_8e9f232b";
	exports.monthOptionIsDisabled = "monthOptionIsDisabled_8e9f232b";
	exports.yearOptionIsDisabled = "yearOptionIsDisabled_8e9f232b";
	exports.goToday = "goToday_8e9f232b";
	exports.goToTodayIsDisabled = "goToTodayIsDisabled_8e9f232b";
	exports.goTodayInlineMonth = "goTodayInlineMonth_8e9f232b";
	exports.isPickingYears = "isPickingYears_8e9f232b";
	exports.monthPicker = "monthPicker_8e9f232b";
	exports.yearPicker = "yearPicker_8e9f232b";
	exports.monthPickerVisible = "monthPickerVisible_8e9f232b";
	exports.toggleMonthView = "toggleMonthView_8e9f232b";
	exports.calendarsInline = "calendarsInline_8e9f232b";
	exports.monthPickerOnly = "monthPickerOnly_8e9f232b";
	exports.monthPickerAsOverlay = "monthPickerAsOverlay_8e9f232b";
	exports.holderWithButton = "holderWithButton_8e9f232b";
	exports.monthIsHighlighted = "monthIsHighlighted_8e9f232b";
	exports.monthIsCurrentMonth = "monthIsCurrentMonth_8e9f232b";
	exports.yearIsHighlighted = "yearIsHighlighted_8e9f232b";
	exports.yearIsCurrentYear = "yearIsCurrentYear_8e9f232b";
	exports.topLeftCornerDate = "topLeftCornerDate_8e9f232b";
	exports.topRightCornerDate = "topRightCornerDate_8e9f232b";
	exports.bottomLeftCornerDate = "bottomLeftCornerDate_8e9f232b";
	exports.bottomRightCornerDate = "bottomRightCornerDate_8e9f232b";
	exports.weekSelection = "weekSelection_8e9f232b";
	exports.monthSelection = "monthSelection_8e9f232b";
	exports.topDate = "topDate_8e9f232b";
	exports.rightDate = "rightDate_8e9f232b";
	exports.bottomDate = "bottomDate_8e9f232b";
	exports.leftdate = "leftdate_8e9f232b";
	//# sourceMappingURL=Calendar.scss.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var DateMath_1 = __webpack_require__(751);
	var Icon_1 = __webpack_require__(643);
	var stylesImport = __webpack_require__(753);
	var CalendarYear_1 = __webpack_require__(755);
	var styles = stylesImport;
	var MONTHS_PER_ROW = 4;
	var CalendarMonth = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarMonth, _super);
	    function CalendarMonth(props) {
	        var _this = _super.call(this, props) || this;
	        _this._navigatedMonthRef = React.createRef();
	        _this._onCalendarYearRef = function (ref) {
	            _this._calendarYearRef = ref;
	        };
	        _this._onKeyDown = function (callback, ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                callback();
	            }
	        };
	        _this._onSelectYear = function (selectedYear) {
	            _this._focusOnUpdate = true;
	            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate, maxDate = _a.maxDate, minDate = _a.minDate;
	            var navYear = navigatedDate.getFullYear();
	            if (navYear !== selectedYear) {
	                var newNavigationDate = new Date(navigatedDate.getTime());
	                newNavigationDate.setFullYear(selectedYear);
	                // for min and max dates, adjust the new navigation date - perhaps this should be
	                // checked on the master navigation date handler (i.e. in Calendar)
	                if (maxDate && newNavigationDate > maxDate) {
	                    newNavigationDate = DateMath_1.setMonth(newNavigationDate, maxDate.getMonth());
	                }
	                else if (minDate && newNavigationDate < minDate) {
	                    newNavigationDate = DateMath_1.setMonth(newNavigationDate, minDate.getMonth());
	                }
	                onNavigateDate(newNavigationDate, true);
	            }
	            _this.setState({ isYearPickerVisible: false });
	        };
	        _this._yearToString = function (year) {
	            var _a = _this.props, navigatedDate = _a.navigatedDate, dateTimeFormatter = _a.dateTimeFormatter;
	            if (dateTimeFormatter) {
	                // create a date based on the current nav date
	                var yearFormattingDate = new Date(navigatedDate.getTime());
	                yearFormattingDate.setFullYear(year);
	                return dateTimeFormatter.formatYear(yearFormattingDate);
	            }
	            return String(year);
	        };
	        _this._yearRangeToString = function (yearRange) {
	            return _this._yearToString(yearRange.fromYear) + " - " + _this._yearToString(yearRange.toYear);
	        };
	        _this._yearRangeToNextDecadeLabel = function (yearRange) {
	            var strings = _this.props.strings;
	            return strings.nextYearRangeAriaLabel ? strings.nextYearRangeAriaLabel + " " + _this._yearRangeToString(yearRange) : '';
	        };
	        _this._yearRangeToPrevDecadeLabel = function (yearRange) {
	            var strings = _this.props.strings;
	            return strings.prevYearRangeAriaLabel ? strings.prevYearRangeAriaLabel + " " + _this._yearRangeToString(yearRange) : '';
	        };
	        _this._onRenderYear = function (year) {
	            return _this._yearToString(year);
	        };
	        _this._onSelectNextYear = function () {
	            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
	            onNavigateDate(DateMath_1.addYears(navigatedDate, 1), false);
	        };
	        _this._onSelectNextYearKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onKeyDown(_this._onSelectNextYear, ev);
	            }
	        };
	        _this._onSelectPrevYear = function () {
	            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
	            onNavigateDate(DateMath_1.addYears(navigatedDate, -1), false);
	        };
	        _this._onSelectPrevYearKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onKeyDown(_this._onSelectPrevYear, ev);
	            }
	        };
	        _this._onSelectMonthKeyDown = function (index) {
	            return function (ev) { return _this._onKeyDown(function () { return _this._onSelectMonth(index); }, ev); };
	        };
	        _this._onSelectMonth = function (newMonth) {
	            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate, onHeaderSelect = _a.onHeaderSelect;
	            // If header is clickable the calendars are overlayed, switch back to day picker when month is clicked
	            if (onHeaderSelect) {
	                onHeaderSelect(true);
	            }
	            onNavigateDate(DateMath_1.setMonth(navigatedDate, newMonth), true);
	        };
	        _this._onHeaderSelect = function () {
	            var _a = _this.props, onHeaderSelect = _a.onHeaderSelect, yearPickerHidden = _a.yearPickerHidden;
	            if (!yearPickerHidden) {
	                _this._focusOnUpdate = true;
	                _this.setState({ isYearPickerVisible: true });
	            }
	            else if (onHeaderSelect) {
	                onHeaderSelect(true);
	            }
	        };
	        _this._onYearPickerHeaderSelect = function (focus) {
	            _this._focusOnUpdate = focus;
	            _this.setState({ isYearPickerVisible: false });
	        };
	        _this._onHeaderKeyDown = function (ev) {
	            if (_this._onHeaderSelect && (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space)) {
	                _this._onHeaderSelect();
	            }
	        };
	        _this._selectMonthCallbacks = [];
	        props.strings.shortMonths.map(function (month, index) {
	            _this._selectMonthCallbacks[index] = _this._onSelectMonth.bind(_this, index);
	        });
	        _this._isCurrentMonth = _this._isCurrentMonth.bind(_this);
	        _this._onSelectNextYear = _this._onSelectNextYear.bind(_this);
	        _this._onSelectPrevYear = _this._onSelectPrevYear.bind(_this);
	        _this._onSelectMonth = _this._onSelectMonth.bind(_this);
	        _this.state = { isYearPickerVisible: false };
	        return _this;
	    }
	    CalendarMonth.prototype.componentDidUpdate = function () {
	        if (this._focusOnUpdate) {
	            this.focus();
	            this._focusOnUpdate = false;
	        }
	    };
	    CalendarMonth.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, navigatedDate = _a.navigatedDate, selectedDate = _a.selectedDate, strings = _a.strings, today = _a.today, highlightCurrentMonth = _a.highlightCurrentMonth, highlightSelectedMonth = _a.highlightSelectedMonth, navigationIcons = _a.navigationIcons, dateTimeFormatter = _a.dateTimeFormatter, minDate = _a.minDate, maxDate = _a.maxDate, yearPickerHidden = _a.yearPickerHidden;
	        if (this.state.isYearPickerVisible) {
	            // default the year picker to the current navigated date
	            var currentSelectedDate = navigatedDate ? navigatedDate.getFullYear() : undefined;
	            return (React.createElement(CalendarYear_1.CalendarYear, { key: 'calendarYear_' + (currentSelectedDate && currentSelectedDate.toString()), minYear: minDate ? minDate.getFullYear() : undefined, maxYear: maxDate ? maxDate.getFullYear() : undefined, onSelectYear: this._onSelectYear, navigationIcons: navigationIcons, onHeaderSelect: this._onYearPickerHeaderSelect, selectedYear: currentSelectedDate, onRenderYear: this._onRenderYear, strings: {
	                    rangeAriaLabel: this._yearRangeToString,
	                    prevRangeAriaLabel: this._yearRangeToPrevDecadeLabel,
	                    nextRangeAriaLabel: this._yearRangeToNextDecadeLabel
	                }, ref: this._onCalendarYearRef }));
	        }
	        var rowIndexes = [];
	        for (var i = 0; i < strings.shortMonths.length / MONTHS_PER_ROW; i++) {
	            rowIndexes.push(i);
	        }
	        var leftNavigationIcon = navigationIcons.leftNavigation;
	        var rightNavigationIcon = navigationIcons.rightNavigation;
	        // determine if previous/next years are in bounds
	        var isPrevYearInBounds = minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getYearStart(navigatedDate)) < 0 : true;
	        var isNextYearInBounds = maxDate ? DateMath_1.compareDatePart(DateMath_1.getYearEnd(navigatedDate), maxDate) < 0 : true;
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-monthPicker', styles.monthPicker) },
	            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-header', styles.header) },
	                this.props.onHeaderSelect || !yearPickerHidden ? (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatYear(navigatedDate), role: "button", "aria-atomic": true, "aria-live": "polite", tabIndex: 0 }, dateTimeFormatter.formatYear(navigatedDate))) : (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear) }, dateTimeFormatter.formatYear(navigatedDate))),
	                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-yearComponents', styles.yearComponents) },
	                    React.createElement("div", { className: Utilities_1.css('ms-DatePicker-navContainer', styles.navContainer) },
	                        React.createElement("button", { className: Utilities_1.css('ms-DatePicker-prevYear js-prevYear', styles.prevYear, (_b = {},
	                                _b['ms-DatePicker-prevYear--disabled ' + styles.prevYearIsDisabled] = !isPrevYearInBounds,
	                                _b)), disabled: !isPrevYearInBounds, onClick: isPrevYearInBounds ? this._onSelectPrevYear : undefined, onKeyDown: isPrevYearInBounds ? this._onSelectPrevYearKeyDown : undefined, title: strings.prevYearAriaLabel
	                                ? strings.prevYearAriaLabel + ' ' + dateTimeFormatter.formatYear(DateMath_1.addYears(navigatedDate, -1))
	                                : undefined, role: "button", type: "button" },
	                            React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? rightNavigationIcon : leftNavigationIcon })),
	                        React.createElement("button", { className: Utilities_1.css('ms-DatePicker-nextYear js-nextYear', styles.nextYear, (_c = {},
	                                _c['ms-DatePicker-nextYear--disabled ' + styles.nextYearIsDisabled] = !isNextYearInBounds,
	                                _c)), disabled: !isNextYearInBounds, onClick: isNextYearInBounds ? this._onSelectNextYear : undefined, onKeyDown: isNextYearInBounds ? this._onSelectNextYearKeyDown : undefined, title: strings.nextYearAriaLabel
	                                ? strings.nextYearAriaLabel + ' ' + dateTimeFormatter.formatYear(DateMath_1.addYears(navigatedDate, 1))
	                                : undefined, role: "button", type: "button" },
	                            React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? leftNavigationIcon : rightNavigationIcon }))))),
	            React.createElement(FocusZone_1.FocusZone, null,
	                React.createElement("div", { className: Utilities_1.css('ms-DatePicker-optionGrid', styles.optionGrid), role: "grid", "aria-readonly": "true" }, rowIndexes.map(function (rowNum) {
	                    var monthsForRow = strings.shortMonths.slice(rowNum * MONTHS_PER_ROW, (rowNum + 1) * MONTHS_PER_ROW);
	                    return (React.createElement("div", { key: 'monthRow_' + rowNum, role: "row" }, monthsForRow.map(function (month, index) {
	                        var monthIndex = rowNum * MONTHS_PER_ROW + index;
	                        var indexedMonth = DateMath_1.setMonth(navigatedDate, monthIndex);
	                        var isCurrentMonth = _this._isCurrentMonth(monthIndex, navigatedDate.getFullYear(), today);
	                        var isNavigatedMonth = navigatedDate.getMonth() === monthIndex;
	                        var isSelectedMonth = selectedDate.getMonth() === monthIndex;
	                        var isSelectedYear = selectedDate.getFullYear() === navigatedDate.getFullYear();
	                        var isInBounds = (minDate ? DateMath_1.compareDatePart(minDate, DateMath_1.getMonthEnd(indexedMonth)) < 1 : true) &&
	                            (maxDate ? DateMath_1.compareDatePart(DateMath_1.getMonthStart(indexedMonth), maxDate) < 1 : true);
	                        return (React.createElement("button", { role: 'gridcell', className: Utilities_1.css('ms-DatePicker-monthOption', styles.monthOption, (_a = {},
	                                _a['ms-DatePicker-day--today ' + styles.monthIsCurrentMonth] = highlightCurrentMonth && isCurrentMonth,
	                                _a['ms-DatePicker-day--highlighted ' + styles.monthIsHighlighted] = (highlightCurrentMonth || highlightSelectedMonth) && isSelectedMonth && isSelectedYear,
	                                _a['ms-DatePicker-monthOption--disabled ' + styles.monthOptionIsDisabled] = !isInBounds,
	                                _a)), disabled: !isInBounds, key: monthIndex, onClick: isInBounds ? _this._selectMonthCallbacks[monthIndex] : undefined, onKeyDown: isInBounds ? _this._onSelectMonthKeyDown(monthIndex) : undefined, "aria-label": dateTimeFormatter.formatMonthYear(indexedMonth, strings), "aria-selected": isCurrentMonth || isNavigatedMonth, "data-is-focusable": isInBounds ? true : undefined, ref: isNavigatedMonth ? _this._navigatedMonthRef : undefined, type: "button" }, month));
	                        var _a;
	                    })));
	                })))));
	        var _b, _c;
	    };
	    CalendarMonth.prototype.focus = function () {
	        if (this._calendarYearRef) {
	            this._calendarYearRef.focus();
	        }
	        else if (this._navigatedMonthRef.current) {
	            this._navigatedMonthRef.current.tabIndex = 0;
	            this._navigatedMonthRef.current.focus();
	        }
	    };
	    CalendarMonth.prototype._isCurrentMonth = function (month, year, today) {
	        return today.getFullYear() === year && today.getMonth() === month;
	    };
	    return CalendarMonth;
	}(Utilities_1.BaseComponent));
	exports.CalendarMonth = CalendarMonth;
	//# sourceMappingURL=CalendarMonth.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var stylesImport = __webpack_require__(753);
	var Icon_1 = __webpack_require__(643);
	var styles = stylesImport;
	var CELL_COUNT = 12;
	var DefaultCalendarYearStrings = {
	    prevRangeAriaLabel: undefined,
	    nextRangeAriaLabel: undefined
	};
	var DefaultNavigationIcons = {
	    leftNavigation: 'Up',
	    rightNavigation: 'Down',
	    closeIcon: 'CalculatorMultiply'
	};
	var CalendarYearGridCell = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearGridCell, _super);
	    function CalendarYearGridCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._buttonRef = React.createRef();
	        _this._onRenderYear = function () {
	            var _a = _this.props, year = _a.year, onRenderYear = _a.onRenderYear;
	            if (onRenderYear) {
	                return onRenderYear(year);
	            }
	            return year;
	        };
	        _this._onClick = function () {
	            if (_this.props.onSelectYear) {
	                _this.props.onSelectYear(_this.props.year);
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            if (_this.props.onSelectYear && ev.which === Utilities_1.KeyCodes.enter) {
	                _this.props.onSelectYear(_this.props.year);
	            }
	        };
	        return _this;
	    }
	    CalendarYearGridCell.prototype.focus = function () {
	        if (this._buttonRef.current) {
	            this._buttonRef.current.focus();
	        }
	    };
	    CalendarYearGridCell.prototype.render = function () {
	        var _a = this.props, year = _a.year, selected = _a.selected, disabled = _a.disabled, onSelectYear = _a.onSelectYear;
	        return (React.createElement("button", { className: Utilities_1.css('ms-DatePicker-yearOption', styles.yearOption, (_b = {},
	                _b['ms-DatePicker-day--highlighted ' + styles.yearIsHighlighted] = selected,
	                _b['ms-DatePicker-yearOption--disabled ' + styles.yearOptionIsDisabled] = disabled,
	                _b)), type: "button", role: "gridcell", onClick: !disabled && onSelectYear ? this._onClick : undefined, onKeyDown: !disabled && onSelectYear ? this._onKeyDown : undefined, disabled: disabled, "aria-label": String(year), "aria-selected": selected, ref: this._buttonRef }, this._onRenderYear()));
	        var _b;
	    };
	    return CalendarYearGridCell;
	}(React.Component));
	var CalendarYearGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearGrid, _super);
	    function CalendarYearGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._selectedCellRef = React.createRef();
	        _this._currentCellRef = React.createRef();
	        _this._renderCell = function (year) {
	            var selected = year === _this.props.selectedYear;
	            var _a = _this.props, minYear = _a.minYear, maxYear = _a.maxYear, onSelectYear = _a.onSelectYear;
	            var disabled = (minYear !== undefined && year < minYear) || (maxYear !== undefined && year > maxYear);
	            var current = year === new Date().getFullYear();
	            return (React.createElement(CalendarYearGridCell, { key: year, year: year, selected: selected, current: current, disabled: disabled, onSelectYear: onSelectYear, ref: selected ? _this._selectedCellRef : current ? _this._currentCellRef : undefined }));
	        };
	        return _this;
	    }
	    CalendarYearGrid.prototype.focus = function () {
	        if (this._selectedCellRef.current) {
	            this._selectedCellRef.current.focus();
	        }
	        else if (this._currentCellRef.current) {
	            this._currentCellRef.current.focus();
	        }
	    };
	    CalendarYearGrid.prototype.render = function () {
	        var _a = this.props, fromYear = _a.fromYear, toYear = _a.toYear;
	        var year = fromYear;
	        var cells = [];
	        while (year <= toYear) {
	            cells.push(this._renderCell(year));
	            year++;
	        }
	        return (React.createElement(FocusZone_1.FocusZone, null,
	            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-optionGrid', styles.optionGrid), role: "grid" },
	                React.createElement("div", { role: "row" }, cells))));
	    };
	    return CalendarYearGrid;
	}(React.Component));
	var CalendarYearNavPrev = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearNavPrev, _super);
	    function CalendarYearNavPrev() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onSelectPrev = function () {
	            if (!_this.isDisabled && _this.props.onSelectPrev) {
	                _this.props.onSelectPrev();
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onSelectPrev();
	            }
	        };
	        return _this;
	    }
	    CalendarYearNavPrev.prototype.render = function () {
	        var iconStrings = this.props.navigationIcons || DefaultNavigationIcons;
	        var strings = this.props.strings || DefaultCalendarYearStrings;
	        var prevRangeAriaLabel = strings.prevRangeAriaLabel;
	        var prevRange = { fromYear: this.props.fromYear - CELL_COUNT, toYear: this.props.toYear - CELL_COUNT };
	        var prevAriaLabel = prevRangeAriaLabel
	            ? typeof prevRangeAriaLabel === 'string'
	                ? prevRangeAriaLabel
	                : prevRangeAriaLabel(prevRange)
	            : undefined;
	        var disabled = this.isDisabled;
	        var onSelectPrev = this.props.onSelectPrev;
	        return (React.createElement("button", { className: Utilities_1.css('ms-DatePicker-prevDecade', styles.prevDecade, (_a = {},
	                _a['ms-DatePicker-prevDecade--disabled ' + styles.prevDecadeIsDisabled] = disabled,
	                _a)), onClick: !disabled && onSelectPrev ? this._onSelectPrev : undefined, onKeyDown: !disabled && onSelectPrev ? this._onKeyDown : undefined, type: "button", tabIndex: 0, title: prevAriaLabel, disabled: disabled },
	            React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? iconStrings.rightNavigation : iconStrings.leftNavigation })));
	        var _a;
	    };
	    Object.defineProperty(CalendarYearNavPrev.prototype, "isDisabled", {
	        get: function () {
	            var minYear = this.props.minYear;
	            return minYear !== undefined && this.props.fromYear < minYear;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CalendarYearNavPrev;
	}(React.Component));
	var CalendarYearNavNext = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearNavNext, _super);
	    function CalendarYearNavNext() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onSelectNext = function () {
	            if (!_this.isDisabled && _this.props.onSelectNext) {
	                _this.props.onSelectNext();
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                _this._onSelectNext();
	            }
	        };
	        return _this;
	    }
	    CalendarYearNavNext.prototype.render = function () {
	        var iconStrings = this.props.navigationIcons || DefaultNavigationIcons;
	        var strings = this.props.strings || DefaultCalendarYearStrings;
	        var nextRangeAriaLabel = strings.nextRangeAriaLabel;
	        var nextRange = { fromYear: this.props.fromYear + CELL_COUNT, toYear: this.props.toYear + CELL_COUNT };
	        var nextAriaLabel = nextRangeAriaLabel
	            ? typeof nextRangeAriaLabel === 'string'
	                ? nextRangeAriaLabel
	                : nextRangeAriaLabel(nextRange)
	            : undefined;
	        var onSelectNext = this.props.onSelectNext;
	        var disabled = this.isDisabled;
	        return (React.createElement("button", { className: Utilities_1.css('ms-DatePicker-nextDecade', styles.nextDecade, (_a = {},
	                _a['ms-DatePicker-nextDecade--disabled ' + styles.nextDecadeIsDisabled] = disabled,
	                _a)), onClick: !disabled && onSelectNext ? this._onSelectNext : undefined, onKeyDown: !disabled && onSelectNext ? this._onKeyDown : undefined, type: "button", tabIndex: 0, title: nextAriaLabel, disabled: this.isDisabled },
	            React.createElement(Icon_1.Icon, { iconName: Utilities_1.getRTL() ? iconStrings.leftNavigation : iconStrings.rightNavigation })));
	        var _a;
	    };
	    Object.defineProperty(CalendarYearNavNext.prototype, "isDisabled", {
	        get: function () {
	            var maxYear = this.props.maxYear;
	            return maxYear !== undefined && this.props.fromYear + CELL_COUNT > maxYear;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CalendarYearNavNext;
	}(React.Component));
	var CalendarYearNav = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearNav, _super);
	    function CalendarYearNav() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CalendarYearNav.prototype.render = function () {
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-decadeComponents', styles.decadeComponents) },
	            React.createElement("div", { className: Utilities_1.css('ms-DatePicker-navContainer', styles.navContainer) },
	                React.createElement(CalendarYearNavPrev, tslib_1.__assign({}, this.props)),
	                React.createElement(CalendarYearNavNext, tslib_1.__assign({}, this.props)))));
	    };
	    return CalendarYearNav;
	}(React.Component));
	var CalendarYearTitle = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearTitle, _super);
	    function CalendarYearTitle() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onHeaderSelect = function () {
	            if (_this.props.onHeaderSelect) {
	                _this.props.onHeaderSelect(true);
	            }
	        };
	        _this._onHeaderKeyDown = function (ev) {
	            if (_this.props.onHeaderSelect && (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space)) {
	                _this.props.onHeaderSelect(true);
	            }
	        };
	        _this._onRenderYear = function (year) {
	            if (_this.props.onRenderYear) {
	                return _this.props.onRenderYear(year);
	            }
	            return year;
	        };
	        return _this;
	    }
	    CalendarYearTitle.prototype.render = function () {
	        var _a = this.props, fromYear = _a.fromYear, toYear = _a.toYear, onHeaderSelect = _a.onHeaderSelect;
	        if (onHeaderSelect) {
	            var strings = this.props.strings || DefaultCalendarYearStrings;
	            var rangeAriaLabel = strings.rangeAriaLabel;
	            var ariaLabel = rangeAriaLabel
	                ? typeof rangeAriaLabel === 'string'
	                    ? rangeAriaLabel
	                    : rangeAriaLabel(this.props)
	                : undefined;
	            return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentDecade js-showYearPicker', styles.currentDecade, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": ariaLabel, role: "button", "aria-atomic": true, "aria-live": "polite", tabIndex: 0 },
	                this._onRenderYear(fromYear),
	                " - ",
	                this._onRenderYear(toYear)));
	        }
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-currentDecade js-showYearPicker', styles.currentDecade) },
	            this._onRenderYear(fromYear),
	            " - ",
	            this._onRenderYear(toYear)));
	    };
	    return CalendarYearTitle;
	}(React.Component));
	var CalendarYearHeader = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYearHeader, _super);
	    function CalendarYearHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onRenderTitle = function () {
	            if (_this.props.onRenderTitle) {
	                return _this.props.onRenderTitle(_this.props);
	            }
	            return React.createElement(CalendarYearTitle, tslib_1.__assign({}, _this.props));
	        };
	        _this._onRenderNav = function () {
	            return React.createElement(CalendarYearNav, tslib_1.__assign({}, _this.props));
	        };
	        return _this;
	    }
	    CalendarYearHeader.prototype.render = function () {
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-header', styles.header) },
	            this._onRenderTitle(),
	            this._onRenderNav()));
	    };
	    return CalendarYearHeader;
	}(React.Component));
	var CalendarYear = /** @class */ (function (_super) {
	    tslib_1.__extends(CalendarYear, _super);
	    function CalendarYear(props) {
	        var _this = _super.call(this, props) || this;
	        _this._gridRef = React.createRef();
	        _this._onNavNext = function () {
	            _this.setState({ fromYear: _this.state.fromYear + CELL_COUNT });
	        };
	        _this._onNavPrev = function () {
	            _this.setState({ fromYear: _this.state.fromYear - CELL_COUNT });
	        };
	        _this._renderHeader = function () {
	            return (React.createElement(CalendarYearHeader, tslib_1.__assign({}, _this.props, { fromYear: _this.state.fromYear, toYear: _this.state.fromYear + CELL_COUNT - 1, onSelectPrev: _this._onNavPrev, onSelectNext: _this._onNavNext })));
	        };
	        _this._renderGrid = function () {
	            return (React.createElement(CalendarYearGrid, tslib_1.__assign({}, _this.props, { fromYear: _this.state.fromYear, toYear: _this.state.fromYear + CELL_COUNT - 1, ref: _this._gridRef })));
	        };
	        _this.state = _this._calculateInitialStateFromProps(props);
	        return _this;
	    }
	    CalendarYear.prototype.focus = function () {
	        if (this._gridRef.current) {
	            this._gridRef.current.focus();
	        }
	    };
	    CalendarYear.prototype.render = function () {
	        return (React.createElement("div", { className: Utilities_1.css('ms-DatePicker-yearPicker', styles.yearPicker) },
	            this._renderHeader(),
	            this._renderGrid()));
	    };
	    CalendarYear.prototype._calculateInitialStateFromProps = function (props) {
	        var selectedYear = props.selectedYear, navigatedYear = props.navigatedYear;
	        var rangeYear = selectedYear || navigatedYear || new Date().getFullYear();
	        var fromYear = Math.floor(rangeYear / 10) * 10;
	        return {
	            fromYear: fromYear,
	            navigatedYear: navigatedYear,
	            selectedYear: selectedYear
	        };
	    };
	    return CalendarYear;
	}(React.Component));
	exports.CalendarYear = CalendarYear;
	//# sourceMappingURL=CalendarYear.js.map

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DateValues_1 = __webpack_require__(749);
	exports.DayOfWeek = DateValues_1.DayOfWeek;
	exports.FirstWeekOfYear = DateValues_1.FirstWeekOfYear;
	exports.DateRangeType = DateValues_1.DateRangeType;
	//# sourceMappingURL=Calendar.types.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(758), exports);
	//# sourceMappingURL=Check.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(759), exports);
	tslib_1.__exportStar(__webpack_require__(760), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Check_base_1 = __webpack_require__(760);
	var Check_styles_1 = __webpack_require__(761);
	exports.Check = Utilities_1.styled(Check_base_1.CheckBase, Check_styles_1.getStyles, undefined, {
	    scope: 'Check'
	}, true);
	/**
	 * Memoized helper for rendering a Check. Always uses fast icons.
	 * @param theme - Theme, so the check can be re-rendered if it changes.
	 * @param checked - Whether the check is checked.
	 * @param className - Class name for styling the check.
	 */
	exports.getCheck = Utilities_1.memoizeFunction(function (theme, checked, className) {
	    return React.createElement(exports.Check, { theme: theme, checked: checked, className: className, useFastIcons: true });
	});
	//# sourceMappingURL=Check.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.CheckBase = function (props) {
	    var _a = props.checked, checked = _a === void 0 ? false : _a, className = props.className, theme = props.theme, styles = props.styles, useFastIcons = props.useFastIcons;
	    var classNames = getClassNames(styles, { theme: theme, className: className, checked: checked, useGlobalCheckHostClass: useFastIcons });
	    var IconComponent = useFastIcons ? Icon_1.FontIcon : Icon_1.Icon;
	    return (React.createElement("div", { className: classNames.root },
	        React.createElement(IconComponent, { iconName: "CircleRing", className: classNames.circle }),
	        React.createElement(IconComponent, { iconName: "StatusCircleCheckmark", className: classNames.check })));
	};
	//# sourceMappingURL=Check.base.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	exports.CheckGlobalClassNames = {
	    root: 'ms-Check',
	    circle: 'ms-Check-circle',
	    check: 'ms-Check-check',
	    /** Must be manually applied to the parent element of the check. */
	    checkHost: 'ms-Check-checkHost'
	};
	exports.getStyles = function (props) {
	    var _a = props.checkBoxHeight, checkBoxHeight = _a === void 0 ? '18px' : _a, checked = props.checked, useGlobalCheckHostClass = props.useGlobalCheckHostClass, className = props.className, theme = props.theme;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var isRTL = Utilities_1.getRTL();
	    var classNames = Styling_1.getGlobalClassNames(exports.CheckGlobalClassNames, theme);
	    var sharedCircleCheck = {
	        fontSize: checkBoxHeight,
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: checkBoxHeight,
	        height: checkBoxHeight,
	        textAlign: 'center',
	        verticalAlign: 'middle'
	    };
	    var checkHostClass = useGlobalCheckHostClass ? exports.CheckGlobalClassNames.checkHost : '$checkHost';
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                // lineHeight currently needs to be a string to output without 'px'
	                lineHeight: '1',
	                width: checkBoxHeight,
	                height: checkBoxHeight,
	                verticalAlign: 'top',
	                position: 'relative',
	                userSelect: 'none',
	                selectors: (_b = {
	                        ':before': {
	                            content: '""',
	                            position: 'absolute',
	                            top: '1px',
	                            right: '1px',
	                            bottom: '1px',
	                            left: '1px',
	                            borderRadius: '50%',
	                            opacity: 1,
	                            background: semanticColors.bodyBackground
	                        }
	                    },
	                    _b["." + checkHostClass + ":hover &, ." + checkHostClass + ":focus &, &:hover, &:focus"] = {
	                        opacity: 1
	                    },
	                    _b)
	            },
	            checked && [
	                'is-checked',
	                {
	                    selectors: {
	                        ':before': {
	                            background: palette.themePrimary,
	                            opacity: 1,
	                            selectors: (_c = {},
	                                _c[Styling_1.HighContrastSelector] = {
	                                    background: 'Window'
	                                },
	                                _c)
	                        }
	                    }
	                }
	            ],
	            className
	        ],
	        circle: [
	            classNames.circle,
	            sharedCircleCheck,
	            {
	                color: palette.neutralTertiaryAlt,
	                selectors: (_d = {},
	                    _d[Styling_1.HighContrastSelector] = {
	                        color: 'WindowText'
	                    },
	                    _d)
	            },
	            checked && {
	                color: palette.white
	            }
	        ],
	        check: [
	            classNames.check,
	            sharedCircleCheck,
	            {
	                opacity: 0,
	                color: palette.neutralTertiaryAlt,
	                fontSize: '16px',
	                left: isRTL ? '-0.5px' : '.5px',
	                selectors: (_e = {
	                        ':hover': {
	                            opacity: 1
	                        }
	                    },
	                    _e[Styling_1.HighContrastSelector] = {
	                        MsHighContrastAdjust: 'none'
	                    },
	                    _e)
	            },
	            checked && {
	                opacity: 1,
	                color: palette.white,
	                fontWeight: 900,
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        border: 'none',
	                        color: 'WindowText'
	                    },
	                    _f)
	            }
	        ],
	        checkHost: [{}]
	    };
	    var _b, _c, _d, _e, _f;
	};
	//# sourceMappingURL=Check.styles.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(763), exports);
	//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(764), exports);
	tslib_1.__exportStar(__webpack_require__(765), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Checkbox_base_1 = __webpack_require__(765);
	var Checkbox_styles_1 = __webpack_require__(766);
	exports.Checkbox = Utilities_1.styled(Checkbox_base_1.CheckboxBase, Checkbox_styles_1.getStyles, undefined, { scope: 'Checkbox' });
	//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var KeytipData_1 = __webpack_require__(684);
	var getClassNames = Utilities_1.classNamesFunction();
	var CheckboxBase = /** @class */ (function (_super) {
	    tslib_1.__extends(CheckboxBase, _super);
	    /**
	     * Initialize a new instance of the Checkbox
	     * @param props - Props for the component
	     * @param context - Context or initial state for the base component.
	     */
	    function CheckboxBase(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this._checkBox = React.createRef();
	        _this._onFocus = function (ev) {
	            var inputProps = _this.props.inputProps;
	            if (inputProps && inputProps.onFocus) {
	                inputProps.onFocus(ev);
	            }
	        };
	        _this._onBlur = function (ev) {
	            var inputProps = _this.props.inputProps;
	            if (inputProps && inputProps.onBlur) {
	                inputProps.onBlur(ev);
	            }
	        };
	        _this._onChange = function (ev) {
	            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange;
	            var isChecked = _this.state.isChecked;
	            if (!disabled) {
	                if (onChange) {
	                    onChange(ev, !isChecked);
	                }
	                if (_this.props.checked === undefined) {
	                    _this.setState({ isChecked: !isChecked });
	                }
	            }
	        };
	        _this._onRenderLabel = function (props) {
	            var label = props.label;
	            return label ? (React.createElement("span", { "aria-hidden": "true", className: _this._classNames.text }, label)) : null;
	        };
	        Utilities_1.initializeComponentRef(_this);
	        if (false) {
	            Utilities_1.warnMutuallyExclusive('Checkbox', props, {
	                checked: 'defaultChecked'
	            });
	        }
	        _this._id = _this.props.id || Utilities_1.getId('checkbox-');
	        _this.state = {
	            isChecked: !!(props.checked !== undefined ? props.checked : props.defaultChecked)
	        };
	        Utilities_1.initializeFocusRects();
	        return _this;
	    }
	    CheckboxBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.checked !== undefined) {
	            this.setState({
	                isChecked: !!newProps.checked // convert null to false
	            });
	        }
	    };
	    /**
	     * Render the Checkbox based on passed props
	     */
	    CheckboxBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, inputProps = _a.inputProps, name = _a.name, boxSide = _a.boxSide, theme = _a.theme, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, styles = _a.styles, _b = _a.onRenderLabel, onRenderLabel = _b === void 0 ? this._onRenderLabel : _b, checkmarkIconProps = _a.checkmarkIconProps, ariaPositionInSet = _a.ariaPositionInSet, ariaSetSize = _a.ariaSetSize, keytipProps = _a.keytipProps, title = _a.title, label = _a.label;
	        var isChecked = checked === undefined ? this.state.isChecked : checked;
	        var isReversed = boxSide !== 'start' ? true : false;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            disabled: disabled,
	            checked: isChecked,
	            reversed: isReversed,
	            isUsingCustomLabelRender: onRenderLabel !== this._onRenderLabel
	        });
	        return (React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (React.createElement("div", { className: _this._classNames.root },
	            React.createElement("input", tslib_1.__assign({ type: "checkbox" }, inputProps, { "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'] }, checked !== undefined && { checked: checked }, defaultChecked !== undefined && { defaultChecked: defaultChecked }, { disabled: disabled, className: _this._classNames.input, ref: _this._checkBox, name: name, id: _this._id, title: title, onChange: _this._onChange, onFocus: _this._onFocus, onBlur: _this._onBlur, "aria-disabled": disabled, "aria-label": ariaLabel || label, "aria-labelledby": ariaLabelledBy, "aria-describedby": Utilities_1.mergeAriaAttributeValues(ariaDescribedBy, keytipAttributes['aria-describedby']), "aria-posinset": ariaPositionInSet, "aria-setsize": ariaSetSize })),
	            React.createElement("label", { className: _this._classNames.label, htmlFor: _this._id },
	                React.createElement("div", { className: _this._classNames.checkbox, "data-ktp-target": keytipAttributes['data-ktp-target'] },
	                    React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: "CheckMark" }, checkmarkIconProps, { className: _this._classNames.checkmark }))),
	                onRenderLabel(_this.props, _this._onRenderLabel)))); }));
	    };
	    Object.defineProperty(CheckboxBase.prototype, "checked", {
	        get: function () {
	            return this.state.isChecked;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CheckboxBase.prototype.focus = function () {
	        if (this._checkBox.current) {
	            this._checkBox.current.focus();
	        }
	    };
	    CheckboxBase.defaultProps = {
	        boxSide: 'start'
	    };
	    return CheckboxBase;
	}(React.Component));
	exports.CheckboxBase = CheckboxBase;
	//# sourceMappingURL=Checkbox.base.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var MS_CHECKBOX_LABEL_SIZE = '20px';
	var MS_CHECKBOX_TRANSITION_DURATION = '200ms';
	var MS_CHECKBOX_TRANSITION_TIMING = 'cubic-bezier(.4, 0, .23, 1)';
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, reversed = props.reversed, checked = props.checked, disabled = props.disabled, isUsingCustomLabelRender = props.isUsingCustomLabelRender;
	    var semanticColors = theme.semanticColors;
	    var checkmarkFontColor = semanticColors.inputForegroundChecked;
	    var checkmarkFontColorCheckedDisabled = semanticColors.disabledBackground;
	    var checkmarkFontColorHovered = semanticColors.inputBorder;
	    var checkboxBorderColor = semanticColors.smallInputBorder;
	    var checkboxBorderColorChecked = semanticColors.inputBackgroundChecked;
	    var checkboxBorderColorDisabled = semanticColors.disabledBodySubtext;
	    var checkboxBorderHoveredColor = semanticColors.inputBorderHovered;
	    var checkboxBackgroundChecked = semanticColors.inputBackgroundChecked;
	    var checkboxBackgroundCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
	    var checkboxBorderColorCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
	    var checkboxHoveredTextColor = semanticColors.bodyText;
	    var checkboxBackgroundDisabledChecked = semanticColors.disabledBodySubtext;
	    var checkboxTextColor = semanticColors.bodyText;
	    var checkboxTextColorDisabled = semanticColors.disabledText;
	    return {
	        root: [
	            'ms-Checkbox',
	            {
	                position: 'relative',
	                display: 'flex'
	            },
	            reversed && 'reversed',
	            checked && 'is-checked',
	            !disabled && 'is-enabled',
	            disabled && 'is-disabled',
	            className
	        ],
	        input: [
	            {
	                position: 'absolute',
	                background: 'none',
	                opacity: 0,
	                selectors: (_a = {},
	                    _a["." + Utilities_1.IsFocusVisibleClassName + " &:focus + label"] = {
	                        outline: '1px solid ' + theme.palette.neutralSecondary,
	                        outlineOffset: '2px',
	                        selectors: (_b = {},
	                            _b[Styling_1.HighContrastSelector] = {
	                                outline: '1px solid ActiveBorder'
	                            },
	                            _b)
	                    },
	                    _a)
	            }
	        ],
	        label: [
	            'ms-Checkbox-label',
	            theme.fonts.medium,
	            {
	                display: 'flex',
	                alignItems: isUsingCustomLabelRender ? 'center' : 'flex-start',
	                cursor: disabled ? 'default' : 'pointer',
	                position: 'relative',
	                userSelect: 'none',
	                textAlign: 'left'
	            },
	            reversed && {
	                flexDirection: 'row-reverse',
	                justifyContent: 'flex-end'
	            },
	            !disabled && [
	                !checked && {
	                    selectors: {
	                        ':hover .ms-Checkbox-checkbox': {
	                            borderColor: checkboxBorderHoveredColor,
	                            selectors: (_c = {},
	                                _c[Styling_1.HighContrastSelector] = {
	                                    borderColor: 'Highlight'
	                                },
	                                _c)
	                        },
	                        ':focus .ms-Checkbox-checkbox': { borderColor: checkboxBorderHoveredColor },
	                        ':hover .ms-Checkbox-checkmark': {
	                            color: checkmarkFontColorHovered,
	                            opacity: '1',
	                            selectors: (_d = {},
	                                _d[Styling_1.HighContrastSelector] = {
	                                    color: 'Highlight'
	                                },
	                                _d)
	                        }
	                    }
	                },
	                checked && {
	                    selectors: (_e = {
	                            ':hover .ms-Checkbox-checkbox': {
	                                background: checkboxBackgroundCheckedHovered,
	                                borderColor: checkboxBorderColorCheckedHovered
	                            },
	                            ':focus .ms-Checkbox-checkbox': {
	                                background: checkboxBackgroundCheckedHovered,
	                                borderColor: checkboxBorderColorCheckedHovered
	                            }
	                        },
	                        _e[Styling_1.HighContrastSelector] = {
	                            selectors: {
	                                ':hover .ms-Checkbox-checkbox': {
	                                    background: 'Window',
	                                    borderColor: 'Highlight'
	                                },
	                                ':focus .ms-Checkbox-checkbox': {
	                                    background: 'Highlight'
	                                },
	                                ':focus:hover .ms-Checkbox-checkbox': {
	                                    background: 'Highlight'
	                                },
	                                ':focus:hover .ms-Checkbox-checkmark': {
	                                    color: 'Window'
	                                },
	                                ':hover .ms-Checkbox-checkmark': {
	                                    color: 'Highlight'
	                                }
	                            }
	                        },
	                        _e)
	                },
	                {
	                    selectors: {
	                        ':hover .ms-Checkbox-text': { color: checkboxHoveredTextColor },
	                        ':focus .ms-Checkbox-text': { color: checkboxHoveredTextColor }
	                    }
	                }
	            ]
	        ],
	        checkbox: [
	            'ms-Checkbox-checkbox',
	            {
	                display: 'flex',
	                flexShrink: 0,
	                alignItems: 'center',
	                justifyContent: 'center',
	                height: MS_CHECKBOX_LABEL_SIZE,
	                width: MS_CHECKBOX_LABEL_SIZE,
	                borderWidth: '1px',
	                borderStyle: 'solid',
	                borderColor: checkboxBorderColor,
	                boxSizing: 'border-box',
	                transitionProperty: 'background, border, border-color',
	                transitionDuration: MS_CHECKBOX_TRANSITION_DURATION,
	                transitionTimingFunction: MS_CHECKBOX_TRANSITION_TIMING,
	                /* in case the icon is bigger than the box */
	                overflow: 'hidden'
	            },
	            !reversed
	                ? // this margin on the checkbox is for backwards compat.
	                    // notably it has the effect where a customRender is used, there will be only a 4px margin from checkbox to label.
	                    // the label by default would have another 4px margin for a total of 8px margin between checkbox and label.
	                    // we don't combine the two (and move it into the text) to not incur a breaking change for everyone using custom render atm.
	                    {
	                        marginRight: 4
	                    }
	                : {
	                    marginLeft: 4
	                },
	            !disabled &&
	                checked && {
	                background: checkboxBackgroundChecked,
	                borderColor: checkboxBorderColorChecked,
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        background: 'Highlight',
	                        borderColor: 'Highlight'
	                    },
	                    _f)
	            },
	            disabled && {
	                borderColor: checkboxBorderColorDisabled,
	                selectors: (_g = {},
	                    _g[Styling_1.HighContrastSelector] = {
	                        borderColor: 'InactiveBorder'
	                    },
	                    _g)
	            },
	            checked &&
	                disabled && {
	                background: checkboxBackgroundDisabledChecked,
	                borderColor: checkboxBorderColorDisabled
	            }
	        ],
	        checkmark: [
	            'ms-Checkbox-checkmark',
	            {
	                opacity: checked ? '1' : '0',
	                color: checked && disabled ? checkmarkFontColorCheckedDisabled : checkmarkFontColor,
	                selectors: (_h = {},
	                    _h[Styling_1.HighContrastSelector] = {
	                        color: disabled ? 'InactiveBorder' : 'Window',
	                        MsHighContrastAdjust: 'none'
	                    },
	                    _h)
	            }
	        ],
	        text: [
	            'ms-Checkbox-text',
	            {
	                color: disabled ? checkboxTextColorDisabled : checkboxTextColor,
	                fontSize: Styling_1.FontSizes.medium,
	                lineHeight: '20px'
	            },
	            !reversed
	                ? {
	                    marginLeft: 4
	                }
	                : {
	                    marginRight: 4
	                },
	            disabled && {
	                selectors: (_j = {},
	                    _j[Styling_1.HighContrastSelector] = {
	                        // backwards compat for the color of the text when the checkbox was rendered
	                        // using a Button.
	                        color: 'InactiveBorder'
	                    },
	                    _j)
	            }
	        ]
	    };
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	};
	//# sourceMappingURL=Checkbox.styles.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(768), exports);
	//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(769), exports);
	tslib_1.__exportStar(__webpack_require__(770), exports);
	tslib_1.__exportStar(__webpack_require__(776), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ChoiceGroup_base_1 = __webpack_require__(770);
	var ChoiceGroup_styles_1 = __webpack_require__(780);
	exports.ChoiceGroup = Utilities_1.styled(ChoiceGroup_base_1.ChoiceGroupBase, ChoiceGroup_styles_1.getStyles, undefined, { scope: 'ChoiceGroup' });
	//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Label_1 = __webpack_require__(771);
	var Utilities_1 = __webpack_require__(592);
	var index_1 = __webpack_require__(776);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory ChoiceGroup}
	 */
	var ChoiceGroupBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ChoiceGroupBase, _super);
	    function ChoiceGroupBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._inputElement = React.createRef();
	        _this.focusedVars = {};
	        _this.changedVars = {};
	        _this._onFocus = function (key) {
	            return _this.focusedVars[key]
	                ? _this.focusedVars[key]
	                : (_this.focusedVars[key] = function (ev, option) {
	                    _this.setState({
	                        keyFocused: key,
	                        keyChecked: _this.state.keyChecked
	                    });
	                });
	        };
	        _this._onBlur = function (ev, option) {
	            _this.setState({
	                keyFocused: undefined,
	                keyChecked: _this.state.keyChecked
	            });
	        };
	        _this._onChange = function (key) {
	            return _this.changedVars[key]
	                ? _this.changedVars[key]
	                : (_this.changedVars[key] = function (evt, option) {
	                    var _a = _this.props, onChanged = _a.onChanged, onChange = _a.onChange, selectedKey = _a.selectedKey, _b = _a.options, options = _b === void 0 ? [] : _b;
	                    // Only manage state in uncontrolled scenarios.
	                    if (selectedKey === undefined) {
	                        _this.setState({
	                            keyChecked: key
	                        });
	                    }
	                    var originalOption = Utilities_1.find(options, function (value) { return value.key === key; });
	                    // TODO: onChanged deprecated, remove else if after 07/17/2017 when onChanged has been removed.
	                    if (onChange) {
	                        onChange(evt, originalOption);
	                    }
	                    else if (onChanged) {
	                        onChanged(originalOption);
	                    }
	                });
	        };
	        Utilities_1.initializeComponentRef(_this);
	        if (false) {
	            Utilities_1.warnDeprecations('ChoiceGroup', props, { onChanged: 'onChange' });
	            Utilities_1.warnMutuallyExclusive('ChoiceGroup', props, {
	                selectedKey: 'defaultSelectedKey'
	            });
	        }
	        var validDefaultSelectedKey = !!props.options && props.options.some(function (option) { return option.key === props.defaultSelectedKey; });
	        _this.state = {
	            keyChecked: props.defaultSelectedKey === undefined || !validDefaultSelectedKey ? _this._getKeyChecked(props) : props.defaultSelectedKey,
	            keyFocused: undefined
	        };
	        _this._id = Utilities_1.getId('ChoiceGroup');
	        _this._labelId = Utilities_1.getId('ChoiceGroupLabel');
	        return _this;
	    }
	    Object.defineProperty(ChoiceGroupBase.prototype, "checkedOption", {
	        /**
	         * Gets the current checked option.
	         */
	        get: function () {
	            var _a = this.props.options, options = _a === void 0 ? [] : _a;
	            var key = this.state.keyChecked;
	            return Utilities_1.find(options, function (value) { return value.key === key; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ChoiceGroupBase.prototype.componentWillReceiveProps = function (newProps) {
	        var newKeyChecked = this._getKeyChecked(newProps);
	        var oldKeyChecked = this._getKeyChecked(this.props);
	        if (newKeyChecked !== oldKeyChecked) {
	            this.setState({
	                keyChecked: newKeyChecked
	            });
	        }
	    };
	    ChoiceGroupBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, className = _a.className, theme = _a.theme, styles = _a.styles, options = _a.options, label = _a.label, required = _a.required, disabled = _a.disabled, name = _a.name, role = _a.role;
	        var _b = this.state, keyChecked = _b.keyChecked, keyFocused = _b.keyFocused;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['onChange', 'className', 'required']);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            optionsContainIconOrImage: options.some(function (option) { return Boolean(option.iconProps || option.imageSrc); })
	        });
	        var ariaLabelledBy = this.props.ariaLabelledBy
	            ? this.props.ariaLabelledBy
	            : label
	                ? this._id + '-label'
	                : this.props['aria-labelledby'];
	        return (React.createElement("div", tslib_1.__assign({ role: role, className: classNames.applicationRole }, divProps),
	            React.createElement("div", tslib_1.__assign({ className: classNames.root, role: "radiogroup" }, ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }),
	                label && (React.createElement(Label_1.Label, { className: classNames.label, required: required, id: this._id + '-label' }, label)),
	                React.createElement("div", { className: classNames.flexContainer }, options.map(function (option) {
	                    var innerOptionProps = tslib_1.__assign({}, option, { focused: option.key === keyFocused, checked: option.key === keyChecked, disabled: option.disabled || disabled, id: _this._id + "-" + option.key, labelId: _this._labelId + "-" + option.key, name: name || _this._id, required: required });
	                    return (React.createElement(index_1.ChoiceGroupOption, tslib_1.__assign({ key: option.key, onBlur: _this._onBlur, onFocus: _this._onFocus(option.key), onChange: _this._onChange(option.key) }, innerOptionProps)));
	                })))));
	    };
	    ChoiceGroupBase.prototype.focus = function () {
	        var options = this.props.options;
	        if (options) {
	            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
	                var option = options_1[_i];
	                var elementToFocus = document.getElementById(this._id + "-" + option.key);
	                if (elementToFocus && elementToFocus.getAttribute('data-is-focusable') === 'true') {
	                    elementToFocus.focus(); // focus on checked or default focusable key
	                    return;
	                }
	            }
	        }
	        if (this._inputElement.current) {
	            this._inputElement.current.focus();
	        }
	    };
	    ChoiceGroupBase.prototype._getKeyChecked = function (props) {
	        if (props.selectedKey !== undefined) {
	            return props.selectedKey;
	        }
	        var _a = props.options, options = _a === void 0 ? [] : _a;
	        var optionsChecked = options.filter(function (option) {
	            return option.checked;
	        });
	        if (optionsChecked.length === 0) {
	            return undefined;
	        }
	        else {
	            return optionsChecked[0].key;
	        }
	    };
	    ChoiceGroupBase.defaultProps = {
	        options: []
	    };
	    return ChoiceGroupBase;
	}(React.Component));
	exports.ChoiceGroupBase = ChoiceGroupBase;
	//# sourceMappingURL=ChoiceGroup.base.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(772), exports);
	//# sourceMappingURL=Label.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(773), exports);
	tslib_1.__exportStar(__webpack_require__(774), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Utilities_2 = __webpack_require__(592);
	var getClassNames = Utilities_2.classNamesFunction({
	    disableCaching: true
	});
	var LabelBase = /** @class */ (function (_super) {
	    tslib_1.__extends(LabelBase, _super);
	    function LabelBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LabelBase.prototype.render = function () {
	        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? 'label' : _b, children = _a.children, className = _a.className, disabled = _a.disabled, styles = _a.styles, required = _a.required, theme = _a.theme;
	        var classNames = getClassNames(styles, {
	            className: className,
	            disabled: disabled,
	            required: required,
	            theme: theme
	        });
	        return (React.createElement(RootType, tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { className: classNames.root }), children));
	    };
	    return LabelBase;
	}(React.Component));
	exports.LabelBase = LabelBase;
	//# sourceMappingURL=Label.base.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Label_base_1 = __webpack_require__(773);
	var Label_styles_1 = __webpack_require__(775);
	exports.Label = Utilities_1.styled(Label_base_1.LabelBase, Label_styles_1.getStyles, undefined, {
	    scope: 'Label'
	});
	//# sourceMappingURL=Label.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, disabled = props.disabled, required = props.required;
	    return {
	        root: [
	            'ms-Label',
	            theme.fonts.medium,
	            {
	                color: theme.semanticColors.bodyText,
	                boxSizing: 'border-box',
	                boxShadow: 'none',
	                margin: 0,
	                display: 'block',
	                padding: '5px 0',
	                wordWrap: 'break-word',
	                overflowWrap: 'break-word'
	            },
	            disabled && {
	                color: theme.semanticColors.disabledBodyText,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText'
	                    },
	                    _a)
	            },
	            required && {
	                selectors: {
	                    '::after': {
	                        content: "' *'",
	                        color: theme.semanticColors.errorText,
	                        paddingRight: 12
	                    }
	                }
	            },
	            className
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=Label.styles.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(777), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ChoiceGroupOption_base_1 = __webpack_require__(778);
	var ChoiceGroupOption_styles_1 = __webpack_require__(779);
	exports.ChoiceGroupOption = Utilities_1.styled(ChoiceGroupOption_base_1.ChoiceGroupOptionBase, ChoiceGroupOption_styles_1.getStyles, undefined, { scope: 'ChoiceGroupOption' });
	//# sourceMappingURL=ChoiceGroupOption.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Image_1 = __webpack_require__(658);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory ChoiceGroup}
	 */
	var ChoiceGroupOptionBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ChoiceGroupOptionBase, _super);
	    function ChoiceGroupOptionBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._inputElement = React.createRef();
	        _this._onRenderField = function (props) {
	            var _a = props.onRenderLabel, onRenderLabel = _a === void 0 ? _this._onRenderLabel : _a, id = props.id, imageSrc = props.imageSrc, imageAlt = props.imageAlt, selectedImageSrc = props.selectedImageSrc, iconProps = props.iconProps;
	            var imageSize = props.imageSize ? props.imageSize : { width: 32, height: 32 };
	            return (React.createElement("label", { htmlFor: id, className: _this._classNames.field },
	                imageSrc && (React.createElement("div", { className: _this._classNames.innerField, style: { height: imageSize.height, width: imageSize.width } },
	                    React.createElement("div", { className: _this._classNames.imageWrapper },
	                        React.createElement(Image_1.Image, { src: imageSrc, alt: imageAlt ? imageAlt : '', width: imageSize.width, height: imageSize.height })),
	                    React.createElement("div", { className: _this._classNames.selectedImageWrapper },
	                        React.createElement(Image_1.Image, { src: selectedImageSrc, alt: imageAlt ? imageAlt : '', width: imageSize.width, height: imageSize.height })))),
	                iconProps ? (React.createElement("div", { className: _this._classNames.innerField },
	                    React.createElement("div", { className: _this._classNames.iconWrapper },
	                        React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps))))) : null,
	                imageSrc || iconProps ? (React.createElement("div", { className: _this._classNames.labelWrapper, style: { maxWidth: imageSize.width * 2 } }, onRenderLabel(props))) : (onRenderLabel(props))));
	        };
	        _this._onRenderLabel = function (props) {
	            return (React.createElement("span", { id: props.labelId, className: "ms-ChoiceFieldLabel" }, props.text));
	        };
	        return _this;
	    }
	    ChoiceGroupOptionBase.prototype.render = function () {
	        var _a = this.props, ariaLabel = _a.ariaLabel, focused = _a.focused, required = _a.required, theme = _a.theme, iconProps = _a.iconProps, imageSrc = _a.imageSrc, _b = _a.imageSize, imageSize = _b === void 0 ? { width: 32, height: 32 } : _b, disabled = _a.disabled, checked = _a.checked, id = _a.id, styles = _a.styles, name = _a.name, _c = _a.onRenderField, onRenderField = _c === void 0 ? this._onRenderField : _c, rest = tslib_1.__rest(_a, ["ariaLabel", "focused", "required", "theme", "iconProps", "imageSrc", "imageSize", "disabled", "checked", "id", "styles", "name", "onRenderField"]);
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            hasIcon: !!iconProps,
	            hasImage: !!imageSrc,
	            checked: checked,
	            disabled: disabled,
	            imageIsLarge: !!imageSrc && (imageSize.width > 71 || imageSize.height > 71),
	            focused: focused
	        });
	        var _d = Utilities_1.getNativeProps(rest, Utilities_1.inputProperties), className = _d.className, nativeProps = tslib_1.__rest(_d, ["className"]);
	        return (React.createElement("div", { className: this._classNames.root },
	            React.createElement("div", { className: this._classNames.choiceFieldWrapper },
	                React.createElement("input", tslib_1.__assign({ "aria-label": ariaLabel ? ariaLabel : undefined, ref: this._inputElement, id: id, className: Utilities_1.css(this._classNames.input, className), type: "radio", name: name, disabled: disabled, checked: checked, required: required, onChange: this._onChange.bind(this, this.props), onFocus: this._onFocus.bind(this, this.props), onBlur: this._onBlur.bind(this, this.props) }, nativeProps)),
	                onRenderField(this.props, this._onRenderField))));
	    };
	    ChoiceGroupOptionBase.prototype._onChange = function (props, evt) {
	        var onChange = props.onChange;
	        if (onChange) {
	            onChange(evt, props);
	        }
	    };
	    ChoiceGroupOptionBase.prototype._onBlur = function (props, evt) {
	        var onBlur = props.onBlur;
	        if (onBlur) {
	            onBlur(evt, props);
	        }
	    };
	    ChoiceGroupOptionBase.prototype._onFocus = function (props, evt) {
	        var onFocus = props.onFocus;
	        if (onFocus) {
	            onFocus(evt, props);
	        }
	    };
	    return ChoiceGroupOptionBase;
	}(React.Component));
	exports.ChoiceGroupOptionBase = ChoiceGroupOptionBase;
	//# sourceMappingURL=ChoiceGroupOption.base.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var GlobalClassNames = {
	    root: 'ms-ChoiceField',
	    choiceFieldWrapper: 'ms-ChoiceField-wrapper',
	    input: 'ms-ChoiceField-input',
	    field: 'ms-ChoiceField-field',
	    innerField: 'ms-ChoiceField-innerField',
	    imageWrapper: 'ms-ChoiceField-imageWrapper',
	    iconWrapper: 'ms-ChoiceField-iconWrapper',
	    labelWrapper: 'ms-ChoiceField-labelWrapper',
	    checked: 'is-checked'
	};
	var labelWrapperLineHeight = 15;
	var iconSize = 32;
	var choiceFieldSize = 20;
	var choiceFieldTransitionDuration = '200ms';
	var choiceFieldTransitionTiming = 'cubic-bezier(.4, 0, .23, 1)';
	var radioButtonSpacing = 3;
	var radioButtonInnerSize = 5;
	function getChoiceGroupFocusStyle(palette, hasIconOrImage) {
	    return [
	        'is-inFocus',
	        {
	            selectors: (_a = {},
	                _a["." + Utilities_1.IsFocusVisibleClassName + " &"] = {
	                    position: 'relative',
	                    outline: 'transparent',
	                    selectors: {
	                        '::-moz-focus-inner': {
	                            border: 0
	                        },
	                        ':after': {
	                            content: '""',
	                            top: -2,
	                            right: -2,
	                            bottom: -2,
	                            left: -2,
	                            pointerEvents: 'none',
	                            border: '1px solid ' + (hasIconOrImage ? palette.neutralSecondary : palette.neutralPrimary),
	                            position: 'absolute',
	                            selectors: (_b = {},
	                                _b[Styling_1.HighContrastSelector] = {
	                                    borderColor: 'WindowText',
	                                    borderWidth: hasIconOrImage ? 1 : 2
	                                },
	                                _b)
	                        }
	                    }
	                },
	                _a)
	        }
	    ];
	    var _a, _b;
	}
	function getImageWrapperStyle(isSelectedImageWrapper, className, checked) {
	    return [
	        className,
	        {
	            paddingBottom: 2,
	            transitionProperty: 'opacity',
	            transitionDuration: choiceFieldTransitionDuration,
	            transitionTimingFunction: 'ease',
	            selectors: {
	                '.ms-Image': {
	                    display: 'inline-block',
	                    borderStyle: 'none'
	                }
	            }
	        },
	        (checked ? !isSelectedImageWrapper : isSelectedImageWrapper) && [
	            'is-hidden',
	            {
	                position: 'absolute',
	                left: 0,
	                top: 0,
	                width: '100%',
	                height: '100%',
	                overflow: 'hidden',
	                opacity: 0
	            }
	        ]
	    ];
	}
	exports.getStyles = function (props) {
	    var theme = props.theme, hasIcon = props.hasIcon, hasImage = props.hasImage, checked = props.checked, disabled = props.disabled, imageIsLarge = props.imageIsLarge, focused = props.focused;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var fieldHoverOrFocusProperties = {
	        selectors: {
	            '.ms-ChoiceFieldLabel': {
	                color: semanticColors.bodyTextChecked
	            },
	            ':before': {
	                borderColor: checked ? semanticColors.inputBackgroundCheckedHovered : semanticColors.inputBorderHovered
	            }
	        }
	    };
	    var enabledFieldWithImageHoverOrFocusProperties = {
	        borderColor: checked ? palette.themeDark : palette.neutralTertiaryAlt,
	        selectors: {
	            ':before': {
	                opacity: 1,
	                borderColor: checked ? palette.themeDark : semanticColors.inputBorderHovered
	            }
	        }
	    };
	    var circleAreaProperties = [
	        {
	            content: '""',
	            display: 'inline-block',
	            backgroundColor: semanticColors.bodyBackground,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: semanticColors.smallInputBorder,
	            width: choiceFieldSize,
	            height: choiceFieldSize,
	            fontWeight: 'normal',
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            boxSizing: 'border-box',
	            transitionProperty: 'border-color',
	            transitionDuration: choiceFieldTransitionDuration,
	            transitionTimingFunction: choiceFieldTransitionTiming,
	            borderRadius: '50%'
	        },
	        disabled && {
	            backgroundColor: checked ? semanticColors.bodyBackground : semanticColors.disabledText,
	            borderColor: semanticColors.disabledText,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText'
	                },
	                _a)
	        },
	        checked && {
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: disabled ? semanticColors.disabledText : semanticColors.inputBackgroundChecked,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight'
	                },
	                _b)
	        },
	        (hasIcon || hasImage) && {
	            top: radioButtonSpacing,
	            right: radioButtonSpacing,
	            left: 'auto',
	            opacity: !disabled && checked ? 1 : 0
	        }
	    ];
	    var dotAreaProperties = [
	        {
	            content: '""',
	            width: 0,
	            height: 0,
	            borderRadius: '50%',
	            position: 'absolute',
	            left: choiceFieldSize / 2,
	            right: 0,
	            transitionProperty: 'border-width',
	            transitionDuration: choiceFieldTransitionDuration,
	            transitionTimingFunction: choiceFieldTransitionTiming,
	            boxSizing: 'border-box'
	        },
	        checked && {
	            borderWidth: 5,
	            borderStyle: 'solid',
	            borderColor: disabled ? semanticColors.disabledText : semanticColors.inputBackgroundChecked,
	            left: 5,
	            top: 5,
	            width: 10,
	            height: 10,
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight'
	                },
	                _c)
	        },
	        checked &&
	            (hasIcon || hasImage) && {
	            top: radioButtonSpacing + radioButtonInnerSize,
	            right: radioButtonSpacing + radioButtonInnerSize,
	            left: 'auto' // To reset the value of 'left' to its default value, so that 'right' works
	        }
	    ];
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                boxSizing: 'border-box',
	                color: semanticColors.bodyText,
	                fontSize: Styling_1.FontSizes.medium,
	                fontWeight: Styling_1.FontWeights.regular,
	                minHeight: 26,
	                border: 'none',
	                position: 'relative',
	                marginTop: 8,
	                selectors: {
	                    '.ms-ChoiceFieldLabel': {
	                        fontSize: Styling_1.FontSizes.medium,
	                        display: 'inline-block'
	                    }
	                }
	            },
	            !hasIcon &&
	                !hasImage && {
	                selectors: {
	                    '.ms-ChoiceFieldLabel': {
	                        paddingLeft: '26px'
	                    }
	                }
	            },
	            hasImage && 'ms-ChoiceField--image',
	            hasIcon && 'ms-ChoiceField--icon',
	            (hasIcon || hasImage) && {
	                display: 'inline-flex',
	                fontSize: 0,
	                margin: '0 4px 4px 0',
	                paddingLeft: 0,
	                backgroundColor: palette.neutralLighter,
	                height: '100%'
	            }
	        ],
	        choiceFieldWrapper: [classNames.choiceFieldWrapper, focused && getChoiceGroupFocusStyle(palette, hasIcon || hasImage)],
	        // The hidden input
	        input: [
	            classNames.input,
	            {
	                position: 'absolute',
	                opacity: 0,
	                top: 0,
	                right: 0,
	                width: '100%',
	                height: '100%',
	                margin: 0
	            }
	        ],
	        field: [
	            classNames.field,
	            checked && classNames.checked,
	            {
	                display: 'inline-block',
	                cursor: 'pointer',
	                marginTop: 0,
	                position: 'relative',
	                verticalAlign: 'top',
	                userSelect: 'none',
	                minHeight: 20,
	                selectors: {
	                    ':hover': !disabled && fieldHoverOrFocusProperties,
	                    ':focus': !disabled && fieldHoverOrFocusProperties,
	                    // The circle
	                    ':before': circleAreaProperties,
	                    // The dot
	                    ':after': dotAreaProperties
	                }
	            },
	            hasIcon && 'ms-ChoiceField--icon',
	            hasImage && 'ms-ChoiceField-field--image',
	            (hasIcon || hasImage) && {
	                boxSizing: 'content-box',
	                cursor: 'pointer',
	                paddingTop: 22,
	                margin: 0,
	                textAlign: 'center',
	                transitionProperty: 'all',
	                transitionDuration: choiceFieldTransitionDuration,
	                transitionTimingFunction: 'ease',
	                border: '2px solid transparent',
	                justifyContent: 'center',
	                alignItems: 'center',
	                display: 'flex',
	                flexDirection: 'column'
	            },
	            checked && {
	                borderColor: palette.themePrimary
	            },
	            (hasIcon || hasImage) &&
	                !disabled && {
	                selectors: {
	                    ':hover': enabledFieldWithImageHoverOrFocusProperties,
	                    ':focus': enabledFieldWithImageHoverOrFocusProperties
	                }
	            },
	            disabled && {
	                cursor: 'default',
	                selectors: (_d = {
	                        '.ms-ChoiceFieldLabel': {
	                            color: semanticColors.disabledBodyText
	                        }
	                    },
	                    _d[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText'
	                    },
	                    _d)
	            }
	        ],
	        innerField: [
	            classNames.innerField,
	            (hasIcon || hasImage) && {
	                position: 'relative',
	                display: 'inline-block',
	                paddingLeft: 30,
	                paddingRight: 30
	            },
	            (hasIcon || hasImage) &&
	                imageIsLarge && {
	                paddingLeft: 24,
	                paddingRight: 24
	            },
	            (hasIcon || hasImage) &&
	                disabled && {
	                opacity: 0.25,
	                selectors: (_e = {},
	                    _e[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText',
	                        opacity: 1
	                    },
	                    _e)
	            }
	        ],
	        imageWrapper: getImageWrapperStyle(false, classNames.imageWrapper, checked),
	        selectedImageWrapper: getImageWrapperStyle(true, classNames.imageWrapper, checked),
	        iconWrapper: [
	            classNames.iconWrapper,
	            {
	                fontSize: iconSize,
	                lineHeight: iconSize,
	                height: iconSize
	            }
	        ],
	        labelWrapper: [
	            classNames.labelWrapper,
	            (hasIcon || hasImage) && {
	                display: 'block',
	                position: 'relative',
	                margin: '4px 8px',
	                height: labelWrapperLineHeight * 2,
	                lineHeight: labelWrapperLineHeight,
	                overflow: 'hidden',
	                whiteSpace: 'pre-wrap',
	                textOverflow: 'ellipsis',
	                fontSize: Styling_1.FontSizes.medium,
	                fontWeight: Styling_1.FontWeights.regular
	            }
	        ]
	    };
	    var _a, _b, _c, _d, _e;
	};
	//# sourceMappingURL=ChoiceGroupOption.styles.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ChoiceFieldGroup',
	    flexContainer: 'ms-ChoiceFieldGroup-flexContainer'
	};
	exports.getStyles = function (props) {
	    var className = props.className, optionsContainIconOrImage = props.optionsContainIconOrImage, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        applicationRole: className,
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                display: 'block'
	            }
	        ],
	        flexContainer: [
	            classNames.flexContainer,
	            optionsContainIconOrImage && {
	                display: 'flex',
	                flexDirection: 'row',
	                flexWrap: 'wrap'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=ChoiceGroup.styles.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(776), exports);
	//# sourceMappingURL=ChoiceGroupOption.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(783), exports);
	//# sourceMappingURL=Coachmark.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(784), exports);
	tslib_1.__exportStar(__webpack_require__(786), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Coachmark_styles_1 = __webpack_require__(785);
	var Coachmark_base_1 = __webpack_require__(786);
	exports.Coachmark = Utilities_1.styled(Coachmark_base_1.CoachmarkBase, Coachmark_styles_1.getStyles, undefined, {
	    scope: 'Coachmark'
	});
	//# sourceMappingURL=Coachmark.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	exports.COACHMARK_WIDTH = 32;
	exports.COACHMARK_HEIGHT = 32;
	exports.translateOne = Styling_1.keyframes({
	    '0%': {
	        transform: 'translate(0, 0)',
	        animationTimingFunction: 'linear'
	    },
	    '78.57%': {
	        transform: 'translate(0, 0)',
	        animationTimingFunction: 'cubic-bezier(0.62, 0, 0.56, 1)'
	    },
	    '82.14%': {
	        transform: 'translate(0, -5px)',
	        animationTimingFunction: 'cubic-bezier(0.58, 0, 0, 1)'
	    },
	    '84.88%': {
	        transform: 'translate(0, 9px)',
	        animationTimingFunction: 'cubic-bezier(1, 0, 0.56, 1)'
	    },
	    '88.1%': {
	        transform: 'translate(0, -2px)',
	        animationTimingFunction: 'cubic-bezier(0.58, 0, 0.67, 1)'
	    },
	    '90.12%': {
	        transform: 'translate(0, 0)',
	        animationTimingFunction: 'linear'
	    },
	    '100%': {
	        transform: 'translate(0, 0)'
	    }
	});
	exports.scaleOne = Styling_1.keyframes({
	    '0%': {
	        transform: ' scale(0)',
	        animationTimingFunction: 'linear'
	    },
	    '14.29%': {
	        transform: 'scale(0)',
	        animationTimingFunction: 'cubic-bezier(0.84, 0, 0.52, 0.99)'
	    },
	    '16.67%': {
	        transform: 'scale(1.15)',
	        animationTimingFunction: 'cubic-bezier(0.48, -0.01, 0.52, 1.01)'
	    },
	    '19.05%': {
	        transform: 'scale(0.95)',
	        animationTimingFunction: 'cubic-bezier(0.48, 0.02, 0.52, 0.98)'
	    },
	    '21.43%': {
	        transform: 'scale(1)',
	        animationTimingFunction: 'linear'
	    },
	    '42.86%': {
	        transform: 'scale(1)',
	        animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)'
	    },
	    '45.71%': {
	        transform: 'scale(0.8)',
	        animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)'
	    },
	    '50%': {
	        transform: 'scale(1)',
	        animationTimingFunction: 'linear'
	    },
	    '90.12%': {
	        transform: 'scale(1)',
	        animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)'
	    },
	    '92.98%': {
	        transform: 'scale(0.8)',
	        animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)'
	    },
	    '97.26%': {
	        transform: 'scale(1)',
	        animationTimingFunction: 'linear'
	    },
	    '100%': {
	        transform: 'scale(1)'
	    }
	});
	exports.rotateOne = Styling_1.keyframes({
	    '0%': {
	        transform: 'rotate(0deg)',
	        animationTimingFunction: 'linear'
	    },
	    '83.33%': {
	        transform: ' rotate(0deg)',
	        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
	    },
	    '83.93%': {
	        transform: 'rotate(15deg)',
	        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
	    },
	    '84.52%': {
	        transform: 'rotate(-15deg)',
	        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
	    },
	    '85.12%': {
	        transform: 'rotate(15deg)',
	        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
	    },
	    '85.71%': {
	        transform: 'rotate(-15deg)',
	        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
	    },
	    '86.31%': {
	        transform: 'rotate(0deg)',
	        animationTimingFunction: 'linear'
	    },
	    '100%': {
	        transform: 'rotate(0deg)'
	    }
	});
	function getStyles(props) {
	    var theme = props.theme, className = props.className, color = props.color, beaconColorOne = props.beaconColorOne, beaconColorTwo = props.beaconColorTwo, delayBeforeCoachmarkAnimation = props.delayBeforeCoachmarkAnimation, isCollapsed = props.isCollapsed, isBeaconAnimating = props.isBeaconAnimating, isMeasuring = props.isMeasuring, isMeasured = props.isMeasured, entityHostHeight = props.entityHostHeight, entityHostWidth = props.entityHostWidth, transformOrigin = props.transformOrigin;
	    if (!theme) {
	        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
	    }
	    var animationInnerDimension = '35px';
	    var animationOuterDimension = '150px';
	    var animationBorderWidth = '10px';
	    var ContinuousPulse = Styling_1.PulsingBeaconAnimationStyles.continuousPulseAnimationDouble(beaconColorOne ? beaconColorOne : theme.palette.themePrimary, beaconColorTwo ? beaconColorTwo : theme.palette.themeTertiary, animationInnerDimension, animationOuterDimension, animationBorderWidth);
	    var ContinuousPulseAnimation = Styling_1.PulsingBeaconAnimationStyles.createDefaultAnimation(ContinuousPulse, delayBeforeCoachmarkAnimation);
	    return {
	        root: [
	            theme.fonts.medium,
	            {
	                position: 'relative'
	            },
	            className
	        ],
	        pulsingBeacon: [
	            {
	                position: 'absolute',
	                top: '50%',
	                left: '50%',
	                transform: Utilities_1.getRTL() ? 'translate(50%, -50%)' : 'translate(-50%, -50%)',
	                width: '0px',
	                height: '0px',
	                borderRadius: '225px',
	                borderStyle: 'solid',
	                opacity: '0'
	            },
	            isCollapsed && isBeaconAnimating && ContinuousPulseAnimation
	        ],
	        // Translate Animation Layer
	        translateAnimationContainer: [
	            {
	                width: '100%',
	                height: '100%'
	            },
	            isCollapsed && {
	                animationDuration: '14s',
	                animationTimingFunction: 'linear',
	                animationDirection: 'normal',
	                animationIterationCount: '1',
	                animationDelay: '0s',
	                animationFillMode: 'forwards',
	                animationName: exports.translateOne,
	                transition: 'opacity 0.5s ease-in-out'
	            },
	            !isCollapsed && {
	                opacity: '1'
	            }
	        ],
	        // Scale Animation Layer
	        scaleAnimationLayer: [
	            {
	                width: '100%',
	                height: '100%'
	            },
	            isCollapsed && {
	                animationDuration: '14s',
	                animationTimingFunction: 'linear',
	                animationDirection: 'normal',
	                animationIterationCount: '1',
	                animationDelay: '0s',
	                animationFillMode: 'forwards',
	                animationName: exports.scaleOne
	            }
	        ],
	        // Rotate Animation Layer
	        rotateAnimationLayer: [
	            {
	                width: '100%',
	                height: '100%'
	            },
	            isCollapsed && {
	                animationDuration: '14s',
	                animationTimingFunction: 'linear',
	                animationDirection: 'normal',
	                animationIterationCount: '1',
	                animationDelay: '0s',
	                animationFillMode: 'forwards',
	                animationName: exports.rotateOne
	            },
	            !isCollapsed && {
	                opacity: '1'
	            }
	        ],
	        // Layer Host, defaults to collapsed
	        entityHost: [
	            {
	                position: 'relative',
	                outline: 'none',
	                overflow: 'hidden',
	                backgroundColor: color,
	                borderRadius: exports.COACHMARK_WIDTH,
	                transition: 'border-radius 250ms, width 500ms, height 500ms cubic-bezier(0.5, 0, 0, 1)',
	                visibility: 'hidden'
	            },
	            !isMeasuring && {
	                width: exports.COACHMARK_WIDTH,
	                height: exports.COACHMARK_HEIGHT,
	                visibility: 'visible'
	            },
	            !isCollapsed && {
	                borderRadius: '1px',
	                opacity: '1',
	                width: entityHostWidth,
	                height: entityHostHeight
	            }
	        ],
	        entityInnerHost: [
	            {
	                transition: 'transform 500ms cubic-bezier(0.5, 0, 0, 1)',
	                transformOrigin: transformOrigin,
	                transform: 'scale(0)'
	            },
	            !isCollapsed && {
	                width: entityHostWidth,
	                height: entityHostHeight,
	                transform: 'scale(1)'
	            },
	            !isMeasuring && {
	                visibility: 'visible'
	            }
	        ],
	        childrenContainer: [
	            {
	                display: isMeasured && isCollapsed ? 'none' : 'block'
	            }
	        ],
	        ariaContainer: {
	            position: 'fixed',
	            opacity: 0,
	            height: 0,
	            width: 0,
	            pointerEvents: 'none'
	        }
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=Coachmark.styles.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	// Utilities
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var positioning_1 = __webpack_require__(609);
	// Component Dependencies
	var index_1 = __webpack_require__(787);
	var Beak_1 = __webpack_require__(790);
	var DirectionalHint_1 = __webpack_require__(608);
	var Coachmark_styles_1 = __webpack_require__(785);
	var FocusTrapZone_1 = __webpack_require__(630);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.COACHMARK_ATTRIBUTE_NAME = 'data-coachmarkid';
	var CoachmarkBase = /** @class */ (function (_super) {
	    tslib_1.__extends(CoachmarkBase, _super);
	    function CoachmarkBase(props) {
	        var _this = _super.call(this, props) || this;
	        /**
	         * The cached HTMLElement reference to the Entity Inner Host
	         * element.
	         */
	        _this._entityHost = React.createRef();
	        _this._entityInnerHostElement = React.createRef();
	        _this._translateAnimationContainer = React.createRef();
	        _this._ariaAlertContainer = React.createRef();
	        _this._childrenContainer = React.createRef();
	        _this._positioningContainer = React.createRef();
	        _this.dismiss = function (ev) {
	            var onDismiss = _this.props.onDismiss;
	            if (onDismiss) {
	                onDismiss(ev);
	            }
	        };
	        _this._onKeyDown = function (e) {
	            // Open coachmark if user presses ALT + C (arbitrary keypress for now)
	            if ((e.altKey && e.which === Utilities_1.KeyCodes.c) ||
	                (e.which === Utilities_1.KeyCodes.enter &&
	                    _this._translateAnimationContainer.current &&
	                    _this._translateAnimationContainer.current.contains(e.target))) {
	                _this._onFocusHandler();
	            }
	        };
	        _this._onFocusHandler = function () {
	            if (_this.state.isCollapsed) {
	                _this._openCoachmark();
	            }
	        };
	        _this._onPositioned = function (positionData) {
	            _this._async.requestAnimationFrame(function () {
	                _this.setState({
	                    targetAlignment: positionData.alignmentEdge,
	                    targetPosition: positionData.targetEdge
	                });
	            });
	        };
	        _this._setBeakPosition = function () {
	            var beakLeft;
	            var beakTop;
	            var beakRight;
	            var beakBottom;
	            var transformOriginX;
	            var transformOriginY;
	            var targetAlignment = _this.state.targetAlignment;
	            var distanceAdjustment = '3px'; // Adjustment distance for Beak to shift towards Coachmark bubble.
	            switch (_this._beakDirection) {
	                // If Beak is pointing Up or Down
	                case positioning_1.RectangleEdge.top:
	                case positioning_1.RectangleEdge.bottom:
	                    // If there is no target alignment, then beak is X-axis centered in callout
	                    if (!targetAlignment) {
	                        beakLeft = "calc(50% - " + Beak_1.BEAK_WIDTH / 2 + "px)";
	                        transformOriginX = 'center';
	                    }
	                    else {
	                        // Beak is aligned to the left of target
	                        if (targetAlignment === positioning_1.RectangleEdge.left) {
	                            beakLeft = Coachmark_styles_1.COACHMARK_WIDTH / 2 - Beak_1.BEAK_WIDTH / 2 + "px";
	                            transformOriginX = 'left';
	                        }
	                        else {
	                            // Beak is aligned to the right of target
	                            beakRight = Coachmark_styles_1.COACHMARK_WIDTH / 2 - Beak_1.BEAK_WIDTH / 2 + "px";
	                            transformOriginX = 'right';
	                        }
	                    }
	                    if (_this._beakDirection === positioning_1.RectangleEdge.top) {
	                        beakTop = distanceAdjustment;
	                        transformOriginY = 'top';
	                    }
	                    else {
	                        beakBottom = distanceAdjustment;
	                        transformOriginY = 'bottom';
	                    }
	                    break;
	                // If Beak is pointing Left or Right
	                case positioning_1.RectangleEdge.left:
	                case positioning_1.RectangleEdge.right:
	                    // If there is no target alignment, then beak is Y-axis centered in callout
	                    if (!targetAlignment) {
	                        beakTop = "calc(50% - " + Beak_1.BEAK_WIDTH / 2 + "px)";
	                        transformOriginY = "center";
	                    }
	                    else {
	                        // Beak is aligned to the top of target
	                        if (targetAlignment === positioning_1.RectangleEdge.top) {
	                            beakTop = Coachmark_styles_1.COACHMARK_WIDTH / 2 - Beak_1.BEAK_WIDTH / 2 + "px";
	                            transformOriginY = "top";
	                        }
	                        else {
	                            // Beak is aligned to the bottom of target
	                            beakBottom = Coachmark_styles_1.COACHMARK_WIDTH / 2 - Beak_1.BEAK_WIDTH / 2 + "px";
	                            transformOriginY = "bottom";
	                        }
	                    }
	                    if (_this._beakDirection === positioning_1.RectangleEdge.left) {
	                        beakLeft = distanceAdjustment;
	                        if (Utilities_1.getRTL()) {
	                            beakRight = distanceAdjustment;
	                        }
	                        else {
	                            beakLeft = distanceAdjustment;
	                        }
	                        transformOriginX = 'left';
	                    }
	                    else {
	                        beakRight = distanceAdjustment;
	                        if (Utilities_1.getRTL()) {
	                            beakLeft = distanceAdjustment;
	                        }
	                        else {
	                            beakRight = distanceAdjustment;
	                        }
	                        transformOriginX = 'right';
	                    }
	                    break;
	            }
	            _this.setState({
	                beakLeft: beakLeft,
	                beakRight: beakRight,
	                beakBottom: beakBottom,
	                beakTop: beakTop,
	                transformOrigin: transformOriginX + " " + transformOriginY
	            });
	        };
	        _this._openCoachmark = function () {
	            _this.setState({
	                isCollapsed: false
	            });
	            if (_this.props.onAnimationOpenStart) {
	                _this.props.onAnimationOpenStart();
	            }
	            _this._entityInnerHostElement.current &&
	                _this._entityInnerHostElement.current.addEventListener('transitionend', function () {
	                    // Need setTimeout to trigger narrator
	                    _this._async.setTimeout(function () {
	                        if (_this._entityInnerHostElement.current) {
	                            Utilities_1.focusFirstChild(_this._entityInnerHostElement.current);
	                        }
	                    }, 1000);
	                    if (_this.props.onAnimationOpenEnd) {
	                        _this.props.onAnimationOpenEnd();
	                    }
	                });
	        };
	        _this._warnDeprecations({
	            teachingBubbleRef: undefined,
	            collapsed: 'isCollapsed',
	            beakWidth: undefined,
	            beakHeight: undefined,
	            width: undefined,
	            height: undefined
	        });
	        // Set defaults for state
	        _this.state = {
	            isCollapsed: props.isCollapsed,
	            isBeaconAnimating: true,
	            isMeasuring: true,
	            entityInnerHostRect: {
	                width: 0,
	                height: 0
	            },
	            isMouseInProximity: false,
	            isMeasured: false
	        };
	        return _this;
	    }
	    Object.defineProperty(CoachmarkBase.prototype, "_beakDirection", {
	        get: function () {
	            var targetPosition = this.state.targetPosition;
	            if (targetPosition === undefined) {
	                return positioning_1.RectangleEdge.bottom;
	            }
	            return positioning_1.getOppositeEdge(targetPosition);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CoachmarkBase.prototype.render = function () {
	        var _a = this.props, children = _a.children, target = _a.target, color = _a.color, positioningContainerProps = _a.positioningContainerProps, ariaDescribedBy = _a.ariaDescribedBy, ariaDescribedByText = _a.ariaDescribedByText, ariaLabelledBy = _a.ariaLabelledBy, ariaLabelledByText = _a.ariaLabelledByText, ariaAlertText = _a.ariaAlertText, delayBeforeCoachmarkAnimation = _a.delayBeforeCoachmarkAnimation, styles = _a.styles, theme = _a.theme, className = _a.className;
	        var _b = this.state, beakLeft = _b.beakLeft, beakTop = _b.beakTop, beakRight = _b.beakRight, beakBottom = _b.beakBottom, isCollapsed = _b.isCollapsed, isBeaconAnimating = _b.isBeaconAnimating, isMeasuring = _b.isMeasuring, entityInnerHostRect = _b.entityInnerHostRect, transformOrigin = _b.transformOrigin, alertText = _b.alertText, isMeasured = _b.isMeasured;
	        // Defaulting the main background before passing it to the styles because it is used for `Beak` too.
	        var defaultColor = color;
	        if (!defaultColor && theme) {
	            defaultColor = theme.semanticColors.primaryButtonBackground;
	        }
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            isCollapsed: isCollapsed,
	            isBeaconAnimating: isBeaconAnimating,
	            isMeasuring: isMeasuring,
	            color: defaultColor,
	            transformOrigin: transformOrigin,
	            isMeasured: isMeasured,
	            entityHostHeight: entityInnerHostRect.height + "px",
	            entityHostWidth: entityInnerHostRect.width + "px",
	            width: Coachmark_styles_1.COACHMARK_WIDTH + "px",
	            height: Coachmark_styles_1.COACHMARK_HEIGHT + "px",
	            delayBeforeCoachmarkAnimation: delayBeforeCoachmarkAnimation + "ms"
	        });
	        var finalHeight = isCollapsed ? Coachmark_styles_1.COACHMARK_HEIGHT : entityInnerHostRect.height;
	        return (React.createElement(index_1.PositioningContainer, tslib_1.__assign({ target: target, offsetFromTarget: Beak_1.BEAK_HEIGHT, componentRef: this._positioningContainer, finalHeight: finalHeight, onPositioned: this._onPositioned, bounds: this._getBounds() }, positioningContainerProps),
	            React.createElement("div", { className: classNames.root },
	                ariaAlertText && (React.createElement("div", { className: classNames.ariaContainer, role: "alert", ref: this._ariaAlertContainer, "aria-hidden": !isCollapsed }, alertText)),
	                React.createElement("div", { className: classNames.pulsingBeacon }),
	                React.createElement("div", { className: classNames.translateAnimationContainer, ref: this._translateAnimationContainer },
	                    React.createElement("div", { className: classNames.scaleAnimationLayer },
	                        React.createElement("div", { className: classNames.rotateAnimationLayer },
	                            this._positioningContainer.current && isCollapsed && (React.createElement(Beak_1.Beak, { left: beakLeft, top: beakTop, right: beakRight, bottom: beakBottom, direction: this._beakDirection, color: defaultColor })),
	                            React.createElement("div", { className: classNames.entityHost, ref: this._entityHost, tabIndex: -1, "data-is-focusable": true, role: "dialog", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
	                                isCollapsed && [
	                                    ariaLabelledBy && (React.createElement("p", { id: ariaLabelledBy, key: 0, className: classNames.ariaContainer }, ariaLabelledByText)),
	                                    ariaDescribedBy && (React.createElement("p", { id: ariaDescribedBy, key: 1, className: classNames.ariaContainer }, ariaDescribedByText))
	                                ],
	                                React.createElement(FocusTrapZone_1.FocusTrapZone, { isClickableOutsideFocusTrap: true, forceFocusInsideTrap: false },
	                                    React.createElement("div", { className: classNames.entityInnerHost, ref: this._entityInnerHostElement },
	                                        React.createElement("div", { className: classNames.childrenContainer, ref: this._childrenContainer, "aria-hidden": isCollapsed }, children))))))))));
	    };
	    CoachmarkBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (this.props.isCollapsed && !newProps.isCollapsed) {
	            // The coachmark is about to open
	            this._openCoachmark();
	        }
	    };
	    CoachmarkBase.prototype.shouldComponentUpdate = function (newProps, newState) {
	        return !Utilities_1.shallowCompare(newProps, this.props) || !Utilities_1.shallowCompare(newState, this.state);
	    };
	    CoachmarkBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (prevState.targetAlignment !== this.state.targetAlignment || prevState.targetPosition !== this.state.targetPosition) {
	            this._setBeakPosition();
	        }
	        if (prevProps.preventDismissOnLostFocus !== this.props.preventDismissOnLostFocus) {
	            this._addListeners();
	        }
	    };
	    CoachmarkBase.prototype.componentDidMount = function () {
	        var _this = this;
	        this._async.requestAnimationFrame(function () {
	            if (_this._entityInnerHostElement.current && _this.state.entityInnerHostRect.width + _this.state.entityInnerHostRect.width === 0) {
	                _this.setState({
	                    isMeasuring: false,
	                    entityInnerHostRect: {
	                        width: _this._entityInnerHostElement.current.offsetWidth,
	                        height: _this._entityInnerHostElement.current.offsetHeight
	                    },
	                    isMeasured: true
	                });
	                _this._setBeakPosition();
	                _this.forceUpdate();
	            }
	            _this._addListeners();
	            // We don't want to the user to immediately trigger the Coachmark when it's opened
	            _this._async.setTimeout(function () {
	                _this._addProximityHandler(_this.props.mouseProximityOffset);
	            }, _this.props.delayBeforeMouseOpen);
	            // Need to add setTimeout to have narrator read change in alert container
	            if (_this.props.ariaAlertText) {
	                _this._async.setTimeout(function () {
	                    if (_this.props.ariaAlertText && _this._ariaAlertContainer.current) {
	                        _this.setState({
	                            alertText: _this.props.ariaAlertText
	                        });
	                    }
	                }, 0);
	            }
	            if (!_this.props.preventFocusOnMount) {
	                _this._async.setTimeout(function () {
	                    if (_this._entityHost.current) {
	                        _this._entityHost.current.focus();
	                    }
	                }, 1000);
	            }
	        });
	    };
	    CoachmarkBase.prototype._addListeners = function () {
	        var preventDismissOnLostFocus = this.props.preventDismissOnLostFocus;
	        var currentDoc = Utilities_1.getDocument();
	        this._events.off();
	        if (currentDoc) {
	            this._events.on(currentDoc, 'keydown', this._onKeyDown, true);
	            if (!preventDismissOnLostFocus) {
	                this._events.on(currentDoc, 'click', this._dismissOnLostFocus, true);
	                this._events.on(currentDoc, 'focus', this._dismissOnLostFocus, true);
	            }
	        }
	    };
	    CoachmarkBase.prototype._dismissOnLostFocus = function (ev) {
	        var clickTarget = ev.target;
	        var clickedOutsideCallout = this._translateAnimationContainer.current && !Utilities_1.elementContains(this._translateAnimationContainer.current, clickTarget);
	        var target = this.props.target;
	        if (clickedOutsideCallout && clickTarget !== target && !Utilities_1.elementContains(target, clickTarget)) {
	            this.dismiss(ev);
	        }
	    };
	    CoachmarkBase.prototype._getBounds = function () {
	        var _a = this.props, isPositionForced = _a.isPositionForced, positioningContainerProps = _a.positioningContainerProps;
	        if (isPositionForced) {
	            // If directionalHint direction is the top or bottom auto edge, then we want to set the left/right bounds
	            // to the window x-axis to have auto positioning work correctly.
	            if (positioningContainerProps &&
	                (positioningContainerProps.directionalHint === DirectionalHint_1.DirectionalHint.topAutoEdge ||
	                    positioningContainerProps.directionalHint === DirectionalHint_1.DirectionalHint.bottomAutoEdge)) {
	                return {
	                    left: 0,
	                    top: -Infinity,
	                    bottom: Infinity,
	                    right: window.innerWidth,
	                    width: window.innerWidth,
	                    height: Infinity
	                };
	            }
	            else {
	                return {
	                    left: -Infinity,
	                    top: -Infinity,
	                    bottom: Infinity,
	                    right: Infinity,
	                    width: Infinity,
	                    height: Infinity
	                };
	            }
	        }
	        else {
	            return undefined;
	        }
	    };
	    CoachmarkBase.prototype._addProximityHandler = function (mouseProximityOffset) {
	        var _this = this;
	        if (mouseProximityOffset === void 0) { mouseProximityOffset = 0; }
	        /**
	         * An array of cached ids returned when setTimeout runs during
	         * the window resize event trigger.
	         */
	        var timeoutIds = [];
	        // Take the initial measure out of the initial render to prevent
	        // an unnecessary render.
	        this._async.setTimeout(function () {
	            _this._setTargetElementRect();
	            // When the window resizes we want to async
	            // get the bounding client rectangle.
	            // Every time the event is triggered we want to
	            // setTimeout and then clear any previous instances
	            // of setTimeout.
	            _this._events.on(window, 'resize', function () {
	                timeoutIds.forEach(function (value) {
	                    clearInterval(value);
	                });
	                timeoutIds.push(_this._async.setTimeout(function () {
	                    _this._setTargetElementRect();
	                }, 100));
	            });
	        }, 10);
	        // Every time the document's mouse move is triggered
	        // we want to check if inside of an element and
	        // set the state with the result.
	        this._events.on(document, 'mousemove', function (e) {
	            if (_this.state.isCollapsed) {
	                var mouseY = e.clientY;
	                var mouseX = e.clientX;
	                _this._setTargetElementRect();
	                var isMouseInProximity = _this._isInsideElement(mouseX, mouseY, mouseProximityOffset);
	                if (isMouseInProximity !== _this.state.isMouseInProximity) {
	                    _this._openCoachmark();
	                }
	            }
	            if (_this.props.onMouseMove) {
	                _this.props.onMouseMove(e);
	            }
	        });
	    };
	    CoachmarkBase.prototype._setTargetElementRect = function () {
	        if (this._translateAnimationContainer && this._translateAnimationContainer.current) {
	            this._targetElementRect = this._translateAnimationContainer.current.getBoundingClientRect();
	        }
	    };
	    CoachmarkBase.prototype._isInsideElement = function (mouseX, mouseY, mouseProximityOffset) {
	        if (mouseProximityOffset === void 0) { mouseProximityOffset = 0; }
	        return (mouseX > this._targetElementRect.left - mouseProximityOffset &&
	            mouseX < this._targetElementRect.left + this._targetElementRect.width + mouseProximityOffset &&
	            mouseY > this._targetElementRect.top - mouseProximityOffset &&
	            mouseY < this._targetElementRect.top + this._targetElementRect.height + mouseProximityOffset);
	    };
	    CoachmarkBase.defaultProps = {
	        isCollapsed: true,
	        mouseProximityOffset: 10,
	        delayBeforeMouseOpen: 3600,
	        delayBeforeCoachmarkAnimation: 0,
	        isPositionForced: true,
	        positioningContainerProps: {
	            directionalHint: DirectionalHint_1.DirectionalHint.bottomAutoEdge
	        }
	    };
	    return CoachmarkBase;
	}(Utilities_1.BaseComponent));
	exports.CoachmarkBase = CoachmarkBase;
	//# sourceMappingURL=Coachmark.base.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(788), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var PositioningContainer_styles_1 = __webpack_require__(789);
	var Layer_1 = __webpack_require__(617);
	// Utilites/Helpers
	var DirectionalHint_1 = __webpack_require__(608);
	var Utilities_1 = __webpack_require__(592);
	var positioning_1 = __webpack_require__(609);
	var Styling_1 = __webpack_require__(463);
	var OFF_SCREEN_STYLE = { opacity: 0 };
	// In order for some of the max height logic to work
	// properly we need to set the border.
	// The value is abitrary.
	var BORDER_WIDTH = 1;
	var SLIDE_ANIMATIONS = (_a = {},
	    _a[positioning_1.RectangleEdge.top] = 'slideUpIn20',
	    _a[positioning_1.RectangleEdge.bottom] = 'slideDownIn20',
	    _a[positioning_1.RectangleEdge.left] = 'slideLeftIn20',
	    _a[positioning_1.RectangleEdge.right] = 'slideRightIn20',
	    _a);
	var PositioningContainer = /** @class */ (function (_super) {
	    tslib_1.__extends(PositioningContainer, _super);
	    function PositioningContainer(props) {
	        var _this = _super.call(this, props) || this;
	        /**
	         * The primary positioned div.
	         */
	        _this._positionedHost = React.createRef();
	        // @TODO rename to reflect the name of this class
	        _this._contentHost = React.createRef();
	        /**
	         * Deprecated, use `onResize` instead.
	         * @deprecated Use `onResize` instead.
	         */
	        _this.dismiss = function (ev) {
	            _this.onResize(ev);
	        };
	        _this.onResize = function (ev) {
	            var onDismiss = _this.props.onDismiss;
	            if (onDismiss) {
	                onDismiss(ev);
	            }
	            else {
	                _this._updateAsyncPosition();
	            }
	        };
	        _this._setInitialFocus = function () {
	            if (_this._contentHost.current && _this.props.setInitialFocus && !_this._didSetInitialFocus && _this.state.positions) {
	                _this._didSetInitialFocus = true;
	                Utilities_1.focusFirstChild(_this._contentHost.current);
	            }
	        };
	        _this._onComponentDidMount = function () {
	            // This is added so the positioningContainer will dismiss when the window is scrolled
	            // but not when something inside the positioningContainer is scrolled. The delay seems
	            // to be required to avoid React firing an async focus event in IE from
	            // the target changing focus quickly prior to rendering the positioningContainer.
	            _this._async.setTimeout(function () {
	                _this._events.on(_this._targetWindow, 'scroll', _this._async.throttle(_this._dismissOnScroll, 10), true);
	                _this._events.on(_this._targetWindow, 'resize', _this._async.throttle(_this.onResize, 10), true);
	                _this._events.on(_this._targetWindow.document.body, 'focus', _this._dismissOnLostFocus, true);
	                _this._events.on(_this._targetWindow.document.body, 'click', _this._dismissOnLostFocus, true);
	            }, 0);
	            if (_this.props.onLayerMounted) {
	                _this.props.onLayerMounted();
	            }
	            _this._updateAsyncPosition();
	            _this._setHeightOffsetEveryFrame();
	        };
	        _this._didSetInitialFocus = false;
	        _this.state = {
	            positions: undefined,
	            heightOffset: 0
	        };
	        _this._positionAttempts = 0;
	        return _this;
	    }
	    PositioningContainer.prototype.componentWillMount = function () {
	        this._setTargetWindowAndElement(this._getTarget());
	    };
	    PositioningContainer.prototype.componentDidMount = function () {
	        this._onComponentDidMount();
	    };
	    PositioningContainer.prototype.componentDidUpdate = function () {
	        this._setInitialFocus();
	        this._updateAsyncPosition();
	    };
	    PositioningContainer.prototype.componentWillUpdate = function (newProps) {
	        // If the target element changed, find the new one. If we are tracking
	        // target with class name, always find element because we do not know if
	        // fabric has rendered a new element and disposed the old element.
	        var newTarget = this._getTarget(newProps);
	        var oldTarget = this._getTarget();
	        if (newTarget !== oldTarget || typeof newTarget === 'string' || newTarget instanceof String) {
	            this._maxHeight = undefined;
	            this._setTargetWindowAndElement(newTarget);
	        }
	        if (newProps.offsetFromTarget !== this.props.offsetFromTarget) {
	            this._maxHeight = undefined;
	        }
	        if (newProps.finalHeight !== this.props.finalHeight) {
	            this._setHeightOffsetEveryFrame();
	        }
	    };
	    PositioningContainer.prototype.render = function () {
	        // If there is no target window then we are likely in server side rendering and we should not render anything.
	        if (!this._targetWindow) {
	            return null;
	        }
	        var _a = this.props, className = _a.className, positioningContainerWidth = _a.positioningContainerWidth, positioningContainerMaxHeight = _a.positioningContainerMaxHeight, children = _a.children;
	        var positions = this.state.positions;
	        var styles = PositioningContainer_styles_1.getClassNames();
	        var directionalClassName = positions && positions.targetEdge ? Styling_1.AnimationClassNames[SLIDE_ANIMATIONS[positions.targetEdge]] : '';
	        var getContentMaxHeight = this._getMaxHeight() + this.state.heightOffset;
	        var contentMaxHeight = positioningContainerMaxHeight && positioningContainerMaxHeight > getContentMaxHeight
	            ? getContentMaxHeight
	            : positioningContainerMaxHeight;
	        var content = (React.createElement("div", { ref: this._positionedHost, className: Utilities_1.css('ms-PositioningContainer', styles.container) },
	            React.createElement("div", { className: Styling_1.mergeStyles('ms-PositioningContainer-layerHost', styles.root, className, directionalClassName, !!positioningContainerWidth && { width: positioningContainerWidth }), 
	                // tslint:disable-next-line:jsx-ban-props
	                style: positions ? positions.elementPosition : OFF_SCREEN_STYLE, tabIndex: -1, 
	                // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
	                ref: this._contentHost },
	                children,
	                // @TODO apply to the content container
	                contentMaxHeight)));
	        return this.props.doNotLayer ? content : React.createElement(Layer_1.Layer, null, content);
	    };
	    PositioningContainer.prototype._dismissOnScroll = function (ev) {
	        var preventDismissOnScroll = this.props.preventDismissOnScroll;
	        if (this.state.positions && !preventDismissOnScroll) {
	            this._dismissOnLostFocus(ev);
	        }
	    };
	    PositioningContainer.prototype._dismissOnLostFocus = function (ev) {
	        var target = ev.target;
	        var clickedOutsideCallout = this._positionedHost.current && !Utilities_1.elementContains(this._positionedHost.current, target);
	        if ((!this._target && clickedOutsideCallout) ||
	            (ev.target !== this._targetWindow &&
	                clickedOutsideCallout &&
	                (this._target.stopPropagation ||
	                    (!this._target || (target !== this._target && !Utilities_1.elementContains(this._target, target)))))) {
	            this.onResize(ev);
	        }
	    };
	    PositioningContainer.prototype._updateAsyncPosition = function () {
	        var _this = this;
	        this._async.requestAnimationFrame(function () { return _this._updatePosition(); });
	    };
	    PositioningContainer.prototype._updatePosition = function () {
	        var positions = this.state.positions;
	        var _a = this.props, offsetFromTarget = _a.offsetFromTarget, onPositioned = _a.onPositioned;
	        var hostElement = this._positionedHost.current;
	        var positioningContainerElement = this._contentHost.current;
	        if (hostElement && positioningContainerElement) {
	            var currentProps = void 0;
	            currentProps = Utilities_1.assign(currentProps, this.props);
	            currentProps.bounds = this._getBounds();
	            currentProps.target = this._target;
	            if (document.body.contains(currentProps.target)) {
	                currentProps.gapSpace = offsetFromTarget;
	                var newPositions_1 = positioning_1.positionElement(currentProps, hostElement, positioningContainerElement);
	                // Set the new position only when the positions are not exists or one of the new positioningContainer positions are different.
	                // The position should not change if the position is within 2 decimal places.
	                if ((!positions && newPositions_1) ||
	                    (positions && newPositions_1 && !this._arePositionsEqual(positions, newPositions_1) && this._positionAttempts < 5)) {
	                    // We should not reposition the positioningContainer more than a few times, if it is then the content is likely resizing
	                    // and we should stop trying to reposition to prevent a stack overflow.
	                    this._positionAttempts++;
	                    this.setState({
	                        positions: newPositions_1
	                    }, function () {
	                        if (onPositioned) {
	                            onPositioned(newPositions_1);
	                        }
	                    });
	                }
	                else {
	                    this._positionAttempts = 0;
	                    if (onPositioned) {
	                        onPositioned(newPositions_1);
	                    }
	                }
	            }
	            else if (positions !== undefined) {
	                this.setState({
	                    positions: undefined
	                });
	            }
	        }
	    };
	    PositioningContainer.prototype._getBounds = function () {
	        if (!this._positioningBounds) {
	            var currentBounds = this.props.bounds;
	            if (!currentBounds) {
	                currentBounds = {
	                    top: 0 + this.props.minPagePadding,
	                    left: 0 + this.props.minPagePadding,
	                    right: this._targetWindow.innerWidth - this.props.minPagePadding,
	                    bottom: this._targetWindow.innerHeight - this.props.minPagePadding,
	                    width: this._targetWindow.innerWidth - this.props.minPagePadding * 2,
	                    height: this._targetWindow.innerHeight - this.props.minPagePadding * 2
	                };
	            }
	            this._positioningBounds = currentBounds;
	        }
	        return this._positioningBounds;
	    };
	    /**
	     * Return the maximum height the container can grow to
	     * without going out of the specified bounds
	     */
	    PositioningContainer.prototype._getMaxHeight = function () {
	        var _a = this.props, directionalHintFixed = _a.directionalHintFixed, offsetFromTarget = _a.offsetFromTarget, directionalHint = _a.directionalHint;
	        if (!this._maxHeight) {
	            if (directionalHintFixed && this._target) {
	                var gapSpace = offsetFromTarget ? offsetFromTarget : 0;
	                this._maxHeight = positioning_1.getMaxHeight(this._target, directionalHint, gapSpace, this._getBounds());
	            }
	            else {
	                this._maxHeight = this._getBounds().height - BORDER_WIDTH * 2;
	            }
	        }
	        return this._maxHeight;
	    };
	    PositioningContainer.prototype._arePositionsEqual = function (positions, newPosition) {
	        return this._comparePositions(positions.elementPosition, newPosition.elementPosition);
	    };
	    PositioningContainer.prototype._comparePositions = function (oldPositions, newPositions) {
	        for (var key in newPositions) {
	            // This needs to be checked here and below because there is a linting error if for in does not immediately have an if statement
	            if (newPositions.hasOwnProperty(key)) {
	                var oldPositionEdge = oldPositions[key];
	                var newPositionEdge = newPositions[key];
	                if (oldPositionEdge && newPositionEdge) {
	                    if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
	                        return false;
	                    }
	                }
	            }
	        }
	        return true;
	    };
	    PositioningContainer.prototype._setTargetWindowAndElement = function (target) {
	        var currentElement = this._positionedHost.current;
	        if (target) {
	            if (typeof target === 'string') {
	                var currentDoc = Utilities_1.getDocument();
	                this._target = currentDoc ? currentDoc.querySelector(target) : null;
	                this._targetWindow = Utilities_1.getWindow(currentElement);
	            }
	            else if (target.stopPropagation) {
	                this._targetWindow = Utilities_1.getWindow(target.toElement);
	                this._target = target;
	            }
	            else if (target.x !== undefined && target.y !== undefined) {
	                this._targetWindow = Utilities_1.getWindow(currentElement);
	                this._target = target;
	            }
	            else {
	                var targetElement = target;
	                this._targetWindow = Utilities_1.getWindow(targetElement);
	                this._target = target;
	            }
	        }
	        else {
	            this._targetWindow = Utilities_1.getWindow(currentElement);
	        }
	    };
	    /**
	     * Animates the height if finalHeight was given.
	     */
	    PositioningContainer.prototype._setHeightOffsetEveryFrame = function () {
	        var _this = this;
	        if (this._contentHost && this.props.finalHeight) {
	            this._setHeightOffsetTimer = this._async.requestAnimationFrame(function () {
	                if (!_this._contentHost.current) {
	                    return;
	                }
	                var positioningContainerMainElem = _this._contentHost.current.lastChild;
	                var cardScrollHeight = positioningContainerMainElem.scrollHeight;
	                var cardCurrHeight = positioningContainerMainElem.offsetHeight;
	                var scrollDiff = cardScrollHeight - cardCurrHeight;
	                _this.setState({
	                    heightOffset: _this.state.heightOffset + scrollDiff
	                });
	                if (positioningContainerMainElem.offsetHeight < _this.props.finalHeight) {
	                    _this._setHeightOffsetEveryFrame();
	                }
	                else {
	                    _this._async.cancelAnimationFrame(_this._setHeightOffsetTimer);
	                }
	            });
	        }
	    };
	    PositioningContainer.prototype._getTarget = function (props) {
	        if (props === void 0) { props = this.props; }
	        var target = props.target;
	        return target;
	    };
	    PositioningContainer.defaultProps = {
	        preventDismissOnScroll: false,
	        offsetFromTarget: 0,
	        minPagePadding: 8,
	        directionalHint: DirectionalHint_1.DirectionalHint.bottomAutoEdge
	    };
	    return PositioningContainer;
	}(Utilities_1.BaseComponent));
	exports.PositioningContainer = PositioningContainer;
	var _a;
	//# sourceMappingURL=PositioningContainer.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	exports.getClassNames = Utilities_1.memoizeFunction(function () {
	    return Styling_1.mergeStyleSets({
	        root: [
	            {
	                position: 'absolute',
	                boxSizing: 'border-box',
	                border: '1px solid ${}',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText'
	                    },
	                    _a)
	            },
	            Styling_1.focusClear()
	        ],
	        container: {
	            position: 'relative'
	        },
	        main: {
	            backgroundColor: '#ffffff',
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            position: 'relative'
	        },
	        overFlowYHidden: {
	            overflowY: 'hidden'
	        }
	    });
	    var _a;
	});
	//# sourceMappingURL=PositioningContainer.styles.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Beak_styles_1 = __webpack_require__(791);
	var positioning_1 = __webpack_require__(609);
	exports.BEAK_HEIGHT = 10;
	exports.BEAK_WIDTH = 18;
	var Beak = /** @class */ (function (_super) {
	    tslib_1.__extends(Beak, _super);
	    function Beak(props) {
	        return _super.call(this, props) || this;
	    }
	    Beak.prototype.render = function () {
	        var _a = this.props, left = _a.left, top = _a.top, bottom = _a.bottom, right = _a.right, color = _a.color, _b = _a.direction, direction = _b === void 0 ? positioning_1.RectangleEdge.top : _b;
	        var svgHeight;
	        var svgWidth;
	        if (direction === positioning_1.RectangleEdge.top || direction === positioning_1.RectangleEdge.bottom) {
	            svgHeight = exports.BEAK_HEIGHT;
	            svgWidth = exports.BEAK_WIDTH;
	        }
	        else {
	            svgHeight = exports.BEAK_WIDTH;
	            svgWidth = exports.BEAK_HEIGHT;
	        }
	        var pointOne;
	        var pointTwo;
	        var pointThree;
	        var transform;
	        switch (direction) {
	            case positioning_1.RectangleEdge.top:
	            default:
	                pointOne = exports.BEAK_WIDTH / 2 + ", 0";
	                pointTwo = exports.BEAK_WIDTH + ", " + exports.BEAK_HEIGHT;
	                pointThree = "0, " + exports.BEAK_HEIGHT;
	                transform = 'translateY(-100%)';
	                break;
	            case positioning_1.RectangleEdge.right:
	                pointOne = "0, 0";
	                pointTwo = exports.BEAK_HEIGHT + ", " + exports.BEAK_HEIGHT;
	                pointThree = "0, " + exports.BEAK_WIDTH;
	                transform = 'translateX(100%)';
	                break;
	            case positioning_1.RectangleEdge.bottom:
	                pointOne = "0, 0";
	                pointTwo = exports.BEAK_WIDTH + ", 0";
	                pointThree = exports.BEAK_WIDTH / 2 + ", " + exports.BEAK_HEIGHT;
	                transform = 'translateY(100%)';
	                break;
	            case positioning_1.RectangleEdge.left:
	                pointOne = exports.BEAK_HEIGHT + ", 0";
	                pointTwo = "0, " + exports.BEAK_HEIGHT;
	                pointThree = exports.BEAK_HEIGHT + ", " + exports.BEAK_WIDTH;
	                transform = 'translateX(-100%)';
	                break;
	        }
	        var getClassNames = Utilities_1.classNamesFunction();
	        var classNames = getClassNames(Beak_styles_1.getStyles, {
	            left: left,
	            top: top,
	            bottom: bottom,
	            right: right,
	            height: svgHeight + "px",
	            width: svgWidth + "px",
	            transform: transform,
	            color: color
	        });
	        return (React.createElement("div", { className: classNames.root, role: "presentation" },
	            React.createElement("svg", { height: svgHeight, width: svgWidth, className: classNames.beak },
	                React.createElement("polygon", { points: pointOne + ' ' + pointTwo + ' ' + pointThree }))));
	    };
	    return Beak;
	}(Utilities_1.BaseComponent));
	exports.Beak = Beak;
	//# sourceMappingURL=Beak.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getStyles(props) {
	    return {
	        root: [
	            {
	                position: 'absolute',
	                boxShadow: 'inherit',
	                border: 'none',
	                boxSizing: 'border-box',
	                transform: props.transform,
	                width: props.width,
	                height: props.height,
	                left: props.left,
	                top: props.top,
	                right: props.right,
	                bottom: props.bottom
	            }
	        ],
	        beak: {
	            fill: props.color,
	            display: 'block'
	        }
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=Beak.styles.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(793), exports);
	//# sourceMappingURL=Color.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(794), exports);
	tslib_1.__exportStar(__webpack_require__(817), exports);
	tslib_1.__exportStar(__webpack_require__(795), exports);
	tslib_1.__exportStar(__webpack_require__(796), exports);
	tslib_1.__exportStar(__webpack_require__(800), exports);
	tslib_1.__exportStar(__webpack_require__(801), exports);
	tslib_1.__exportStar(__webpack_require__(797), exports);
	tslib_1.__exportStar(__webpack_require__(798), exports);
	tslib_1.__exportStar(__webpack_require__(799), exports);
	tslib_1.__exportStar(__webpack_require__(802), exports);
	tslib_1.__exportStar(__webpack_require__(803), exports);
	tslib_1.__exportStar(__webpack_require__(804), exports);
	tslib_1.__exportStar(__webpack_require__(805), exports);
	tslib_1.__exportStar(__webpack_require__(806), exports);
	tslib_1.__exportStar(__webpack_require__(808), exports);
	tslib_1.__exportStar(__webpack_require__(809), exports);
	tslib_1.__exportStar(__webpack_require__(810), exports);
	tslib_1.__exportStar(__webpack_require__(811), exports);
	tslib_1.__exportStar(__webpack_require__(812), exports);
	tslib_1.__exportStar(__webpack_require__(805), exports);
	tslib_1.__exportStar(__webpack_require__(813), exports);
	tslib_1.__exportStar(__webpack_require__(814), exports);
	tslib_1.__exportStar(__webpack_require__(815), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(795), exports);
	tslib_1.__exportStar(__webpack_require__(796), exports);
	tslib_1.__exportStar(__webpack_require__(800), exports);
	tslib_1.__exportStar(__webpack_require__(801), exports);
	tslib_1.__exportStar(__webpack_require__(797), exports);
	tslib_1.__exportStar(__webpack_require__(798), exports);
	tslib_1.__exportStar(__webpack_require__(799), exports);
	tslib_1.__exportStar(__webpack_require__(802), exports);
	tslib_1.__exportStar(__webpack_require__(803), exports);
	tslib_1.__exportStar(__webpack_require__(804), exports);
	tslib_1.__exportStar(__webpack_require__(805), exports);
	tslib_1.__exportStar(__webpack_require__(806), exports);
	tslib_1.__exportStar(__webpack_require__(808), exports);
	tslib_1.__exportStar(__webpack_require__(809), exports);
	tslib_1.__exportStar(__webpack_require__(810), exports);
	tslib_1.__exportStar(__webpack_require__(811), exports);
	tslib_1.__exportStar(__webpack_require__(812), exports);
	tslib_1.__exportStar(__webpack_require__(805), exports);
	tslib_1.__exportStar(__webpack_require__(813), exports);
	tslib_1.__exportStar(__webpack_require__(814), exports);
	tslib_1.__exportStar(__webpack_require__(815), exports);
	tslib_1.__exportStar(__webpack_require__(816), exports);
	//# sourceMappingURL=colors.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MAX_COLOR_SATURATION = 100;
	exports.MAX_COLOR_HUE = 359;
	exports.MAX_COLOR_VALUE = 100;
	exports.MAX_COLOR_RGB = 255;
	/** @deprecated Use MAX_COLOR_RGB (255) or MAX_COLOR_ALPHA (100) */
	exports.MAX_COLOR_RGBA = exports.MAX_COLOR_RGB;
	exports.MAX_COLOR_ALPHA = 100;
	/** Minimum length for a hexadecimal color string (not including the #) */
	exports.MIN_HEX_LENGTH = 3;
	/** Maximum length for a hexadecimal color string (not including the #) */
	exports.MAX_HEX_LENGTH = 6;
	/** Minimum length for a string of an RGBA color component */
	exports.MIN_RGBA_LENGTH = 1;
	/** Maximum length for a string of an RGBA color component */
	exports.MAX_RGBA_LENGTH = 3;
	/** Regular expression matching only valid hexadecimal chars */
	exports.HEX_REGEX = /^[\da-f]{0,6}$/i;
	/** Regular expression matching only numbers */
	exports.RGBA_REGEX = /^\d{0,3}$/;
	//# sourceMappingURL=consts.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var hsl2rgb_1 = __webpack_require__(797);
	/**
	 * Converts a valid CSS color string to an RGB color.
	 * Note that hex colors *must* be prefixed with # to be considered valid.
	 * Alpha in returned color defaults to 100.
	 * Four and eight digit hex values (with alpha) are supported if the current browser supports them.
	 */
	function cssColor(color) {
	    if (!color) {
	        return undefined;
	    }
	    // Need to check the following valid color formats: RGB(A), HSL(A), hex, named color
	    // First check for well formatted RGB(A), HSL(A), and hex formats at the start.
	    // This is for perf (no creating an element) and catches the intentional "transparent" color
	    //   case early on.
	    var easyColor = _rgba(color) || _hex6(color) || _hex3(color) || _hsla(color);
	    if (easyColor) {
	        return easyColor;
	    }
	    // if the above fails, do the more expensive catch-all
	    return _browserCompute(color);
	}
	exports.cssColor = cssColor;
	/**
	 * Uses the browser's getComputedStyle() to determine what the passed-in color is.
	 * This assumes _rgba, _hex6, _hex3, and _hsla have already been tried and all failed.
	 * This works by attaching an element to the DOM, which may fail in server-side rendering
	 *   or with headless browsers.
	 */
	function _browserCompute(str) {
	    if (typeof document === 'undefined') {
	        // don't throw an error when used server-side
	        return undefined;
	    }
	    var elem = document.createElement('div');
	    elem.style.backgroundColor = str;
	    // This element must be attached to the DOM for getComputedStyle() to have a value
	    elem.style.position = 'absolute';
	    elem.style.top = '-9999px';
	    elem.style.left = '-9999px';
	    elem.style.height = '1px';
	    elem.style.width = '1px';
	    document.body.appendChild(elem);
	    var eComputedStyle = getComputedStyle(elem);
	    var computedColor = eComputedStyle && eComputedStyle.backgroundColor;
	    document.body.removeChild(elem);
	    // computedColor is always an RGB(A) string, except for invalid colors in IE/Edge which return 'transparent'
	    // browsers return one of these if the color string is invalid,
	    // so need to differentiate between an actual error and intentionally passing in this color
	    if (computedColor === 'rgba(0, 0, 0, 0)' || computedColor === 'transparent') {
	        switch (str.trim()) {
	            // RGB and HSL were already checked at the start of the function
	            case 'transparent':
	            case '#0000':
	            case '#00000000':
	                return { r: 0, g: 0, b: 0, a: 0 };
	        }
	        return undefined;
	    }
	    return _rgba(computedColor);
	}
	/**
	 * If `str` is in valid `rgb()` or `rgba()` format, returns an RGB color (alpha defaults to 100).
	 * Otherwise returns undefined.
	 */
	function _rgba(str) {
	    if (!str) {
	        return undefined;
	    }
	    var match = str.match(/^rgb(a?)\(([\d., ]+)\)$/);
	    if (match) {
	        var hasAlpha = !!match[1];
	        var expectedPartCount = hasAlpha ? 4 : 3;
	        var parts = match[2].split(/ *, */).map(Number);
	        if (parts.length === expectedPartCount) {
	            return {
	                r: parts[0],
	                g: parts[1],
	                b: parts[2],
	                a: hasAlpha ? parts[3] * 100 : consts_1.MAX_COLOR_ALPHA
	            };
	        }
	    }
	}
	/**
	 * If `str` is in `hsl()` or `hsla()` format, returns an RGB color (alpha defaults to 100).
	 * Otherwise returns undefined.
	 */
	function _hsla(str) {
	    var match = str.match(/^hsl(a?)\(([\d., ]+)\)$/);
	    if (match) {
	        var hasAlpha = !!match[1];
	        var expectedPartCount = hasAlpha ? 4 : 3;
	        var parts = match[2].split(/ *, */).map(Number);
	        if (parts.length === expectedPartCount) {
	            var rgba = hsl2rgb_1.hsl2rgb(parts[0], parts[1], parts[2]);
	            rgba.a = hasAlpha ? parts[3] * 100 : consts_1.MAX_COLOR_ALPHA;
	            return rgba;
	        }
	    }
	}
	/**
	 * If `str` is in valid 6-digit hex format *with* # prefix, returns an RGB color (with alpha 100).
	 * Otherwise returns undefined.
	 */
	function _hex6(str) {
	    if ('#' === str[0] && 7 === str.length && /^#[\da-fA-F]{6}$/.test(str)) {
	        return {
	            r: parseInt(str.slice(1, 3), 16),
	            g: parseInt(str.slice(3, 5), 16),
	            b: parseInt(str.slice(5, 7), 16),
	            a: consts_1.MAX_COLOR_ALPHA
	        };
	    }
	}
	/**
	 * If `str` is in valid 3-digit hex format *with* # prefix, returns an RGB color (with alpha 100).
	 * Otherwise returns undefined.
	 */
	function _hex3(str) {
	    if ('#' === str[0] && 4 === str.length && /^#[\da-fA-F]{3}$/.test(str)) {
	        return {
	            r: parseInt(str[1] + str[1], 16),
	            g: parseInt(str[2] + str[2], 16),
	            b: parseInt(str[3] + str[3], 16),
	            a: consts_1.MAX_COLOR_ALPHA
	        };
	    }
	}
	//# sourceMappingURL=cssColor.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hsl2hsv_1 = __webpack_require__(798);
	var hsv2rgb_1 = __webpack_require__(799);
	/** Converts HSL components to an RGB color. Does not set the alpha value. */
	function hsl2rgb(h, s, l) {
	    var hsv = hsl2hsv_1.hsl2hsv(h, s, l);
	    return hsv2rgb_1.hsv2rgb(hsv.h, hsv.s, hsv.v);
	}
	exports.hsl2rgb = hsl2rgb;
	//# sourceMappingURL=hsl2rgb.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Converts HSL components to an HSV color. */
	function hsl2hsv(h, s, l) {
	    s *= (l < 50 ? l : 100 - l) / 100;
	    var v = l + s;
	    return {
	        h: h,
	        s: v === 0 ? 0 : ((2 * s) / v) * 100,
	        v: v
	    };
	}
	exports.hsl2hsv = hsl2hsv;
	//# sourceMappingURL=hsl2hsv.js.map

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	/** Converts HSV components to an RGB color. Does not set the alpha value. */
	function hsv2rgb(h, s, v) {
	    s = s / 100;
	    v = v / 100;
	    var rgb = [];
	    var c = v * s;
	    var hh = h / 60;
	    var x = c * (1 - Math.abs((hh % 2) - 1));
	    var m = v - c;
	    switch (Math.floor(hh)) {
	        case 0:
	            rgb = [c, x, 0];
	            break;
	        case 1:
	            rgb = [x, c, 0];
	            break;
	        case 2:
	            rgb = [0, c, x];
	            break;
	        case 3:
	            rgb = [0, x, c];
	            break;
	        case 4:
	            rgb = [x, 0, c];
	            break;
	        case 5:
	            rgb = [c, 0, x];
	            break;
	    }
	    return {
	        r: Math.round(consts_1.MAX_COLOR_RGB * (rgb[0] + m)),
	        g: Math.round(consts_1.MAX_COLOR_RGB * (rgb[1] + m)),
	        b: Math.round(consts_1.MAX_COLOR_RGB * (rgb[2] + m))
	    };
	}
	exports.hsv2rgb = hsv2rgb;
	//# sourceMappingURL=hsv2rgb.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var clamp_1 = __webpack_require__(801);
	/** Converts RGB components to a hex color string (without # prefix). */
	function rgb2hex(r, g, b) {
	    return [_rgbToPaddedHex(r), _rgbToPaddedHex(g), _rgbToPaddedHex(b)].join('');
	}
	exports.rgb2hex = rgb2hex;
	/** Converts an RGB component to a 0-padded hex component of length 2. */
	function _rgbToPaddedHex(num) {
	    num = clamp_1.clamp(num, consts_1.MAX_COLOR_RGB);
	    var hex = num.toString(16);
	    return hex.length === 1 ? '0' + hex : hex;
	}
	//# sourceMappingURL=rgb2hex.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Clamp a value to ensure it falls within a given range. */
	function clamp(value, max, min) {
	    if (min === void 0) { min = 0; }
	    return value < min ? min : value > max ? max : value;
	}
	exports.clamp = clamp;
	//# sourceMappingURL=clamp.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hsv2rgb_1 = __webpack_require__(799);
	var rgb2hex_1 = __webpack_require__(800);
	/** Converts HSV components to a hex color string (without # prefix). */
	function hsv2hex(h, s, v) {
	    var _a = hsv2rgb_1.hsv2rgb(h, s, v), r = _a.r, g = _a.g, b = _a.b;
	    return rgb2hex_1.rgb2hex(r, g, b);
	}
	exports.hsv2hex = hsv2hex;
	//# sourceMappingURL=hsv2hex.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	/** Converts RGB components to an HSV color. */
	function rgb2hsv(r, g, b) {
	    var h = NaN;
	    var s;
	    var v;
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var delta = max - min;
	    // hue
	    if (delta === 0) {
	        h = 0;
	    }
	    else if (r === max) {
	        h = ((g - b) / delta) % 6;
	    }
	    else if (g === max) {
	        h = (b - r) / delta + 2;
	    }
	    else if (b === max) {
	        h = (r - g) / delta + 4;
	    }
	    h = Math.round(h * 60);
	    if (h < 0) {
	        h += 360;
	    }
	    // saturation
	    s = Math.round((max === 0 ? 0 : delta / max) * 100);
	    // value
	    v = Math.round((max / consts_1.MAX_COLOR_RGB) * 100);
	    return { h: h, s: s, v: v };
	}
	exports.rgb2hsv = rgb2hsv;
	//# sourceMappingURL=rgb2hsv.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	/** Converts HSV components to an HSL color. */
	function hsv2hsl(h, s, v) {
	    s /= consts_1.MAX_COLOR_SATURATION;
	    v /= consts_1.MAX_COLOR_VALUE;
	    var l = (2 - s) * v;
	    var sl = s * v;
	    sl /= l <= 1 ? l : 2 - l;
	    sl = sl || 0;
	    l /= 2;
	    return { h: h, s: sl * 100, l: l * 100 };
	}
	exports.hsv2hsl = hsv2hsl;
	//# sourceMappingURL=hsv2hsl.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var cssColor_1 = __webpack_require__(796);
	var getColorFromRGBA_1 = __webpack_require__(806);
	/**
	 * Converts a CSS color string to a color object.
	 * Note that hex colors *must* be prefixed with # to be considered valid.
	 *
	 * `inputColor` will be used unmodified as the `str` property of the returned object.
	 * Alpha defaults to 100 if not specified in `inputColor`.
	 * Returns undefined if the color string is invalid/not recognized.
	 */
	function getColorFromString(inputColor) {
	    var color = cssColor_1.cssColor(inputColor);
	    if (!color) {
	        return;
	    }
	    return tslib_1.__assign({}, getColorFromRGBA_1.getColorFromRGBA(color), { str: inputColor });
	}
	exports.getColorFromString = getColorFromString;
	//# sourceMappingURL=getColorFromString.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var rgb2hsv_1 = __webpack_require__(803);
	var rgb2hex_1 = __webpack_require__(800);
	var _rgbaOrHexString_1 = __webpack_require__(807);
	/** Converts an RGBA color to a color object (alpha defaults to 100). */
	function getColorFromRGBA(rgba) {
	    var _a = rgba.a, a = _a === void 0 ? consts_1.MAX_COLOR_ALPHA : _a, b = rgba.b, g = rgba.g, r = rgba.r;
	    var _b = rgb2hsv_1.rgb2hsv(r, g, b), h = _b.h, s = _b.s, v = _b.v;
	    var hex = rgb2hex_1.rgb2hex(r, g, b);
	    var str = _rgbaOrHexString_1._rgbaOrHexString(r, g, b, a, hex);
	    return { a: a, b: b, g: g, h: h, hex: hex, r: r, s: s, str: str, v: v };
	}
	exports.getColorFromRGBA = getColorFromRGBA;
	//# sourceMappingURL=getColorFromRGBA.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	/**
	 * @internal
	 * Get a CSS color string from some color components.
	 * If `a` is specified and not 100, returns an `rgba()` string.
	 * Otherwise returns `hex` prefixed with #.
	 */
	function _rgbaOrHexString(r, g, b, a, hex) {
	    return a === consts_1.MAX_COLOR_ALPHA || typeof a !== 'number' ? "#" + hex : "rgba(" + r + ", " + g + ", " + b + ", " + a / consts_1.MAX_COLOR_ALPHA + ")";
	}
	exports._rgbaOrHexString = _rgbaOrHexString;
	//# sourceMappingURL=_rgbaOrHexString.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var hsv2rgb_1 = __webpack_require__(799);
	var hsv2hex_1 = __webpack_require__(802);
	var _rgbaOrHexString_1 = __webpack_require__(807);
	/**
	 * Converts an HSV color (and optional alpha value) to a color object.
	 * If `a` is not given, a default of 100 is used.
	 * Hex in the returned value will *not* be prefixed with #.
	 * If `a` is unspecified or 100, the result's `str` property will contain a hex value
	 * (*not* prefixed with #)
	 */
	function getColorFromHSV(hsv, a) {
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    a = typeof a === 'number' ? a : consts_1.MAX_COLOR_ALPHA;
	    var _a = hsv2rgb_1.hsv2rgb(h, s, v), r = _a.r, g = _a.g, b = _a.b;
	    var hex = hsv2hex_1.hsv2hex(h, s, v);
	    var str = _rgbaOrHexString_1._rgbaOrHexString(r, g, b, a, hex);
	    return { a: a, b: b, g: g, h: h, hex: hex, r: r, s: s, str: str, v: v };
	}
	exports.getColorFromHSV = getColorFromHSV;
	//# sourceMappingURL=getColorFromHSV.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var hsv2hex_1 = __webpack_require__(802);
	/**
	 * Converts a color hue to an HTML color string (with # prefix).
	 * This implementation ignores all components of `color` except hue.
	 */
	function getFullColorString(color) {
	    return "#" + hsv2hex_1.hsv2hex(color.h, consts_1.MAX_COLOR_SATURATION, consts_1.MAX_COLOR_VALUE);
	}
	exports.getFullColorString = getFullColorString;
	//# sourceMappingURL=getFullColorString.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hsv2rgb_1 = __webpack_require__(799);
	var rgb2hex_1 = __webpack_require__(800);
	var _rgbaOrHexString_1 = __webpack_require__(807);
	/**
	 * Gets a color with the same hue as `color` and other components updated to match the given
	 * saturation and value.
	 *
	 * Does not modify the original `color` and does not supply a default alpha value.
	 */
	function updateSV(color, s, v) {
	    var _a = hsv2rgb_1.hsv2rgb(color.h, s, v), r = _a.r, g = _a.g, b = _a.b;
	    var hex = rgb2hex_1.rgb2hex(r, g, b);
	    return {
	        a: color.a,
	        b: b,
	        g: g,
	        h: color.h,
	        hex: hex,
	        r: r,
	        s: s,
	        str: _rgbaOrHexString_1._rgbaOrHexString(r, g, b, color.a, hex),
	        v: v
	    };
	}
	exports.updateSV = updateSV;
	//# sourceMappingURL=updateSV.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hsv2rgb_1 = __webpack_require__(799);
	var rgb2hex_1 = __webpack_require__(800);
	var _rgbaOrHexString_1 = __webpack_require__(807);
	/**
	 * Gets a color with the same saturation and value as `color` and the other components updated
	 * to match the given hue.
	 *
	 * Does not modify the original `color` and does not supply a default alpha value.
	 */
	function updateH(color, h) {
	    var _a = hsv2rgb_1.hsv2rgb(h, color.s, color.v), r = _a.r, g = _a.g, b = _a.b;
	    var hex = rgb2hex_1.rgb2hex(r, g, b);
	    return {
	        a: color.a,
	        b: b,
	        g: g,
	        h: h,
	        hex: hex,
	        r: r,
	        s: color.s,
	        str: _rgbaOrHexString_1._rgbaOrHexString(r, g, b, color.a, hex),
	        v: color.v
	    };
	}
	exports.updateH = updateH;
	//# sourceMappingURL=updateH.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getColorFromRGBA_1 = __webpack_require__(806);
	/**
	 * Gets a color with a single RGBA component updated to a new value.
	 * Does not modify the original `color`. Alpha defaults to 100 if not set.
	 */
	function updateRGB(color, component, value) {
	    return getColorFromRGBA_1.getColorFromRGBA((_a = {
	            r: color.r,
	            g: color.g,
	            b: color.b,
	            a: color.a
	        },
	        _a[component] = value,
	        _a));
	    var _a;
	}
	exports.updateRGB = updateRGB;
	//# sourceMappingURL=updateRGB.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var _rgbaOrHexString_1 = __webpack_require__(807);
	/**
	 * Gets a color with the given alpha value and the same other components as `color`.
	 * Does not modify the original color.
	 */
	function updateA(color, a) {
	    return tslib_1.__assign({}, color, { a: a, str: _rgbaOrHexString_1._rgbaOrHexString(color.r, color.g, color.b, a, color.hex) });
	}
	exports.updateA = updateA;
	//# sourceMappingURL=updateA.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var clamp_1 = __webpack_require__(801);
	/** Corrects an RGB color to fall within the valid range.  */
	function correctRGB(color) {
	    return {
	        r: clamp_1.clamp(color.r, consts_1.MAX_COLOR_RGB),
	        g: clamp_1.clamp(color.g, consts_1.MAX_COLOR_RGB),
	        b: clamp_1.clamp(color.b, consts_1.MAX_COLOR_RGB),
	        a: typeof color.a === 'number' ? clamp_1.clamp(color.a, consts_1.MAX_COLOR_ALPHA) : color.a
	    };
	}
	exports.correctRGB = correctRGB;
	//# sourceMappingURL=correctRGB.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var clamp_1 = __webpack_require__(801);
	/** Corrects an HSV color to fall within the valid range. */
	function correctHSV(color) {
	    return {
	        h: clamp_1.clamp(color.h, consts_1.MAX_COLOR_HUE),
	        s: clamp_1.clamp(color.s, consts_1.MAX_COLOR_SATURATION),
	        v: clamp_1.clamp(color.v, consts_1.MAX_COLOR_VALUE)
	    };
	}
	exports.correctHSV = correctHSV;
	//# sourceMappingURL=correctHSV.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	/**
	 * Corrects a hex color to have length 3 or 6. Defaults to white if too short.
	 * Does NOT check anything besides the length (such as valid characters) and does NOT handle
	 * hex values starting with # sign.
	 */
	function correctHex(hex) {
	    if (!hex || hex.length < consts_1.MIN_HEX_LENGTH) {
	        return 'ffffff'; // not a valid color--default to white
	    }
	    if (hex.length >= consts_1.MAX_HEX_LENGTH) {
	        return hex.substring(0, consts_1.MAX_HEX_LENGTH);
	    }
	    return hex.substring(0, consts_1.MIN_HEX_LENGTH);
	}
	exports.correctHex = correctHex;
	//# sourceMappingURL=correctHex.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(795);
	var Utilities_1 = __webpack_require__(592);
	var hsv2hsl_1 = __webpack_require__(804);
	var getColorFromRGBA_1 = __webpack_require__(806);
	var hsv2rgb_1 = __webpack_require__(799);
	// Soften: to get closer to the background color's luminance
	// (softening with a white background would be lightening, with black it'd be darkening)
	// Strongen: opposite of soften
	// Luminance multiplier constants for generating shades of a given color
	var WhiteShadeTableBG = [0.027, 0.043, 0.082, 0.145, 0.184, 0.216, 0.349, 0.537]; // white bg
	var BlackTintTableBG = [0.537, 0.45, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043]; // black bg
	var WhiteShadeTable = [0.537, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043, 0.027]; // white fg
	var BlackTintTable = [0.537, 0.45, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043]; // black fg
	var LumTintTable = [0.88, 0.77, 0.66, 0.55, 0.44, 0.33, 0.22, 0.11]; // light (strongen all)
	var LumShadeTable = [0.11, 0.22, 0.33, 0.44, 0.55, 0.66, 0.77, 0.88]; // dark (soften all)
	var ColorTintTable = [0.96, 0.84, 0.7, 0.4, 0.12]; // default soften
	var ColorShadeTable = [0.1, 0.24, 0.44]; // default strongen
	// If the given shade's luminance is below/above these values, we'll swap to using the White/Black tables above
	var LowLuminanceThreshold = 0.2;
	var HighLuminanceThreshold = 0.8;
	/** Shades of a given color, from softest to strongest. */
	var Shade;
	(function (Shade) {
	    Shade[Shade["Unshaded"] = 0] = "Unshaded";
	    Shade[Shade["Shade1"] = 1] = "Shade1";
	    Shade[Shade["Shade2"] = 2] = "Shade2";
	    Shade[Shade["Shade3"] = 3] = "Shade3";
	    Shade[Shade["Shade4"] = 4] = "Shade4";
	    Shade[Shade["Shade5"] = 5] = "Shade5";
	    Shade[Shade["Shade6"] = 6] = "Shade6";
	    Shade[Shade["Shade7"] = 7] = "Shade7";
	    Shade[Shade["Shade8"] = 8] = "Shade8";
	    // remember to update isValidShade()!
	})(Shade = exports.Shade || (exports.Shade = {}));
	/**
	 * Returns true if the argument is a valid Shade value
	 * @param shade - The Shade value to validate.
	 */
	function isValidShade(shade) {
	    'use strict';
	    return typeof shade === 'number' && shade >= Shade.Unshaded && shade <= Shade.Shade8;
	}
	exports.isValidShade = isValidShade;
	function _isBlack(color) {
	    return color.r === 0 && color.g === 0 && color.b === 0;
	}
	function _isWhite(color) {
	    return color.r === consts_1.MAX_COLOR_RGBA && color.g === consts_1.MAX_COLOR_RGBA && color.b === consts_1.MAX_COLOR_RGBA;
	}
	function _darken(hsv, factor) {
	    return {
	        h: hsv.h,
	        s: hsv.s,
	        v: _clamp(hsv.v - hsv.v * factor, 0, 100)
	    };
	}
	function _lighten(hsv, factor) {
	    return {
	        h: hsv.h,
	        s: _clamp(hsv.s - hsv.s * factor, 0, 100),
	        v: _clamp(hsv.v + (100 - hsv.v) * factor, 0, 100)
	    };
	}
	function _clamp(n, min, max) {
	    return n; // Math.max(min, Math.min(n, max));
	}
	function isDark(color) {
	    return hsv2hsl_1.hsv2hsl(color.h, color.s, color.v).l < 50;
	}
	exports.isDark = isDark;
	/**
	 * Given a color and a shade specification, generates the requested shade of the color.
	 * Logic:
	 * if white
	 *  darken via tables defined above
	 * if black
	 *  lighten
	 * if light
	 *  strongen
	 * if dark
	 *  soften
	 * else default
	 *  soften or strongen depending on shade#
	 * @param color - The base color whose shade is to be computed
	 * @param shade - The shade of the base color to compute
	 * @param isInverted - Default false. Whether the given theme is inverted (reverse strongen/soften logic)
	 */
	function getShade(color, shade, isInverted) {
	    'use strict';
	    if (isInverted === void 0) { isInverted = false; }
	    if (!color) {
	        return null;
	    }
	    if (shade === Shade.Unshaded || !isValidShade(shade)) {
	        return color;
	    }
	    var hsl = hsv2hsl_1.hsv2hsl(color.h, color.s, color.v);
	    var hsv = { h: color.h, s: color.s, v: color.v };
	    var tableIndex = shade - 1;
	    var _soften = _lighten;
	    var _strongen = _darken;
	    if (isInverted) {
	        _soften = _darken;
	        _strongen = _lighten;
	    }
	    if (_isWhite(color)) {
	        // white
	        hsv = _darken(hsv, WhiteShadeTable[tableIndex]);
	    }
	    else if (_isBlack(color)) {
	        // black
	        hsv = _lighten(hsv, BlackTintTable[tableIndex]);
	    }
	    else if (hsl.l / 100 > HighLuminanceThreshold) {
	        // light
	        hsv = _strongen(hsv, LumShadeTable[tableIndex]);
	    }
	    else if (hsl.l / 100 < LowLuminanceThreshold) {
	        // dark
	        hsv = _soften(hsv, LumTintTable[tableIndex]);
	    }
	    else {
	        // default
	        if (tableIndex < ColorTintTable.length) {
	            hsv = _soften(hsv, ColorTintTable[tableIndex]);
	        }
	        else {
	            hsv = _strongen(hsv, ColorShadeTable[tableIndex - ColorTintTable.length]);
	        }
	    }
	    return getColorFromRGBA_1.getColorFromRGBA(Utilities_1.assign(hsv2rgb_1.hsv2rgb(hsv.h, hsv.s, hsv.v), { a: color.a }));
	}
	exports.getShade = getShade;
	// Background shades/tints are generated differently. The provided color will be guaranteed
	//   to be the darkest or lightest one. If it is <50% luminance, it will always be the darkest,
	//   otherwise it will always be the lightest.
	function getBackgroundShade(color, shade, isInverted) {
	    'use strict';
	    if (isInverted === void 0) { isInverted = false; }
	    if (!color) {
	        return null;
	    }
	    if (shade === Shade.Unshaded || !isValidShade(shade)) {
	        return color;
	    }
	    var hsv = { h: color.h, s: color.s, v: color.v };
	    var tableIndex = shade - 1;
	    if (!isInverted) {
	        // lightish
	        hsv = _darken(hsv, WhiteShadeTableBG[tableIndex]);
	    }
	    else {
	        // default: if (hsl.l / 100 < .5) { // darkish
	        hsv = _lighten(hsv, BlackTintTableBG[BlackTintTable.length - 1 - tableIndex]);
	    }
	    return getColorFromRGBA_1.getColorFromRGBA(Utilities_1.assign(hsv2rgb_1.hsv2rgb(hsv.h, hsv.s, hsv.v), { a: color.a }));
	}
	exports.getBackgroundShade = getBackgroundShade;
	/* Calculates the contrast ratio between two colors. Used for verifying
	 * color pairs meet minimum accessibility requirements.
	 * See: https://www.w3.org/TR/WCAG20/ section 1.4.3
	 */
	function getContrastRatio(color1, color2) {
	    // Formula defined by: http://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html#contrast-ratiodef
	    // relative luminance: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	    /* calculate the intermediate value needed to calculating relative luminance */
	    function _getThing(x) {
	        if (x <= 0.03928) {
	            return x / 12.92;
	        }
	        else {
	            return Math.pow((x + 0.055) / 1.055, 2.4);
	        }
	    }
	    var r1 = _getThing(color1.r / consts_1.MAX_COLOR_RGBA);
	    var g1 = _getThing(color1.g / consts_1.MAX_COLOR_RGBA);
	    var b1 = _getThing(color1.b / consts_1.MAX_COLOR_RGBA);
	    var L1 = 0.2126 * r1 + 0.7152 * g1 + 0.0722 * b1; // relative luminance of first color
	    L1 += 0.05;
	    var r2 = _getThing(color2.r / consts_1.MAX_COLOR_RGBA);
	    var g2 = _getThing(color2.g / consts_1.MAX_COLOR_RGBA);
	    var b2 = _getThing(color2.b / consts_1.MAX_COLOR_RGBA);
	    var L2 = 0.2126 * r2 + 0.7152 * g2 + 0.0722 * b2; // relative luminance of second color
	    L2 += 0.05;
	    // return the lighter color divided by darker
	    return L1 / L2 > 1 ? L1 / L2 : L2 / L1;
	}
	exports.getContrastRatio = getContrastRatio;
	//# sourceMappingURL=shades.js.map

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(819), exports);
	//# sourceMappingURL=ColorPicker.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(820), exports);
	tslib_1.__exportStar(__webpack_require__(821), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ColorPicker_base_1 = __webpack_require__(821);
	var ColorPicker_styles_1 = __webpack_require__(835);
	exports.ColorPicker = Utilities_1.styled(ColorPicker_base_1.ColorPickerBase, ColorPicker_styles_1.getStyles, undefined, { scope: 'ColorPicker' });
	//# sourceMappingURL=ColorPicker.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var TextField_1 = __webpack_require__(822);
	var ColorRectangle_1 = __webpack_require__(829);
	var ColorSlider_1 = __webpack_require__(832);
	// These imports are separated to help with bundling
	var consts_1 = __webpack_require__(795);
	var getColorFromString_1 = __webpack_require__(805);
	var getColorFromRGBA_1 = __webpack_require__(806);
	var updateA_1 = __webpack_require__(813);
	var updateH_1 = __webpack_require__(811);
	var correctRGB_1 = __webpack_require__(814);
	var correctHex_1 = __webpack_require__(816);
	var getClassNames = Utilities_1.classNamesFunction();
	var colorComponents = ['hex', 'r', 'g', 'b', 'a'];
	/**
	 * {@docCategory ColorPicker}
	 */
	var ColorPickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ColorPickerBase, _super);
	    function ColorPickerBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onSVChanged = function (ev, color) {
	            _this._updateColor(ev, color);
	        };
	        _this._onHChanged = function (ev, h) {
	            _this._updateColor(ev, updateH_1.updateH(_this.state.color, h));
	        };
	        _this._onAChanged = function (ev, a) {
	            _this._updateColor(ev, updateA_1.updateA(_this.state.color, Math.round(a)));
	        };
	        _this._onBlur = function (event) {
	            var _a = _this.state, color = _a.color, editingColor = _a.editingColor;
	            if (!editingColor) {
	                return;
	            }
	            // If there was an intermediate incorrect value (such as too large or empty), correct it.
	            var value = editingColor.value, component = editingColor.component;
	            var isHex = component === 'hex';
	            var minLength = isHex ? consts_1.MIN_HEX_LENGTH : consts_1.MIN_RGBA_LENGTH;
	            if (value.length >= minLength && (isHex || !isNaN(Number(value)))) {
	                // Real value. Clamp to appropriate length (hex) or range (rgba).
	                var newColor = void 0;
	                if (isHex) {
	                    newColor = getColorFromString_1.getColorFromString('#' + correctHex_1.correctHex(value));
	                }
	                else {
	                    newColor = getColorFromRGBA_1.getColorFromRGBA(correctRGB_1.correctRGB(tslib_1.__assign({}, color, (_b = {}, _b[component] = Number(value), _b))));
	                }
	                // Update state and call onChange
	                _this._updateColor(event, newColor);
	            }
	            else {
	                // Intermediate value was an empty string, too short (hex only), or just . (alpha only).
	                // Just clear the intermediate state and revert to the previous value.
	                _this.setState({ editingColor: undefined });
	            }
	            var _b;
	        };
	        Utilities_1.initializeComponentRef(_this);
	        Utilities_1.warnDeprecations('ColorPicker', props, {
	            onColorChanged: 'onChange'
	        });
	        _this.state = {
	            color: _getColorFromProps(props) || getColorFromString_1.getColorFromString('#ffffff')
	        };
	        _this._textChangeHandlers = {};
	        for (var _i = 0, colorComponents_1 = colorComponents; _i < colorComponents_1.length; _i++) {
	            var component = colorComponents_1[_i];
	            _this._textChangeHandlers[component] = _this._onTextChange.bind(_this, component);
	        }
	        _this._textLabels = {
	            r: props.redLabel,
	            g: props.greenLabel,
	            b: props.blueLabel,
	            a: props.alphaLabel,
	            hex: props.hexLabel
	        };
	        return _this;
	    }
	    Object.defineProperty(ColorPickerBase.prototype, "color", {
	        get: function () {
	            return this.state.color;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ColorPickerBase.prototype.componentWillReceiveProps = function (newProps) {
	        var color = _getColorFromProps(newProps);
	        if (color) {
	            this._updateColor(undefined, color);
	        }
	    };
	    ColorPickerBase.prototype.render = function () {
	        var _this = this;
	        var props = this.props;
	        var theme = props.theme, className = props.className, styles = props.styles;
	        var color = this.state.color;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { className: classNames.root },
	            React.createElement("div", { className: classNames.panel },
	                React.createElement(ColorRectangle_1.ColorRectangle, { color: color, onChange: this._onSVChanged }),
	                React.createElement(ColorSlider_1.ColorSlider, { className: "is-hue", minValue: 0, maxValue: consts_1.MAX_COLOR_HUE, value: color.h, onChange: this._onHChanged }),
	                !props.alphaSliderHidden && (React.createElement(ColorSlider_1.ColorSlider, { className: "is-alpha", isAlpha: true, overlayStyle: { background: "linear-gradient(to right, transparent 0, #" + color.hex + " 100%)" }, minValue: 0, maxValue: consts_1.MAX_COLOR_ALPHA, value: color.a, onChange: this._onAChanged })),
	                React.createElement("table", { className: classNames.table, cellPadding: "0", cellSpacing: "0" },
	                    React.createElement("thead", null,
	                        React.createElement("tr", { className: classNames.tableHeader },
	                            React.createElement("td", { className: classNames.tableHexCell }, props.hexLabel),
	                            React.createElement("td", null, props.redLabel),
	                            React.createElement("td", null, props.greenLabel),
	                            React.createElement("td", null, props.blueLabel),
	                            !props.alphaSliderHidden && React.createElement("td", null, props.alphaLabel))),
	                    React.createElement("tbody", null,
	                        React.createElement("tr", null, colorComponents.map(function (comp) {
	                            if (comp === 'a' && props.alphaSliderHidden) {
	                                return null;
	                            }
	                            return (React.createElement("td", { key: comp, style: comp === 'hex' ? undefined : { width: '18%' } },
	                                React.createElement(TextField_1.TextField, { className: classNames.input, onChange: _this._textChangeHandlers[comp], onBlur: _this._onBlur, value: _this._getDisplayValue(comp), spellCheck: false, ariaLabel: _this._textLabels[comp] })));
	                        })))))));
	    };
	    ColorPickerBase.prototype._getDisplayValue = function (component) {
	        var _a = this.state, color = _a.color, editingColor = _a.editingColor;
	        if (editingColor && editingColor.component === component) {
	            return editingColor.value;
	        }
	        if (color[component] === null || color[component] === undefined) {
	            return '';
	        }
	        else {
	            return String(color[component]);
	        }
	    };
	    ColorPickerBase.prototype._onTextChange = function (component, event, newValue) {
	        var color = this.state.color;
	        var isHex = component === 'hex';
	        var isAlpha = component === 'a';
	        newValue = (newValue || '').substr(0, isHex ? consts_1.MAX_HEX_LENGTH : consts_1.MAX_RGBA_LENGTH);
	        // Ignore what the user typed if it contains invalid characters
	        var validCharsRegex = isHex ? consts_1.HEX_REGEX : consts_1.RGBA_REGEX;
	        if (!validCharsRegex.test(newValue)) {
	            // Reset the value
	            // TODO: once TextField controlled mode works properly, just return without setting state
	            this.setState({ color: color });
	            return;
	        }
	        // Determine if the entry is valid (different methods for hex, alpha, and RGB)
	        var isValid;
	        if (newValue === '') {
	            // Empty string is obviously not valid
	            isValid = false;
	        }
	        else if (isHex) {
	            // Technically hex values of length 3 are also valid, but committing the value here would
	            // cause it to be automatically converted to a value of length 6, which may not be what the
	            // user wanted if they're not finished typing. (Values of length 3 will be committed on blur.)
	            isValid = newValue.length === consts_1.MAX_HEX_LENGTH;
	        }
	        else if (isAlpha) {
	            isValid = Number(newValue) <= consts_1.MAX_COLOR_ALPHA;
	        }
	        else {
	            isValid = Number(newValue) <= consts_1.MAX_COLOR_RGB;
	        }
	        if (!isValid) {
	            // If the new value is an empty string or other invalid value, save that to display.
	            // (if the user still hasn't entered anything on blur, the last value is restored)
	            this.setState({ editingColor: { component: component, value: newValue } });
	        }
	        else if (String(color[component]) === newValue) {
	            // If the new value is the same as the current value, mostly ignore it.
	            // Exception is that if the user was previously editing the value (but hadn't yet entered
	            // a new valid value), we should clear the intermediate value.
	            if (this.state.editingColor) {
	                this.setState({ editingColor: undefined });
	            }
	            else {
	                // TODO: remove once TextField is properly controlled
	                this.setState({ color: color });
	            }
	        }
	        else {
	            // Should be a valid color. Update the value.
	            var newColor = isHex
	                ? getColorFromString_1.getColorFromString('#' + newValue)
	                : getColorFromRGBA_1.getColorFromRGBA(tslib_1.__assign({}, color, (_a = {}, _a[component] = Number(newValue), _a)));
	            this._updateColor(event, newColor);
	        }
	        var _a;
	    };
	    /**
	     * Update the displayed color and call change handlers if appropriate.
	     * @param ev - Event if call was triggered by an event (undefined if triggered by props change)
	     * @param newColor - Updated color
	     */
	    ColorPickerBase.prototype._updateColor = function (ev, newColor) {
	        var _this = this;
	        if (!newColor) {
	            return;
	        }
	        var _a = this.state, color = _a.color, editingColor = _a.editingColor;
	        var isDifferentColor = newColor.h !== color.h || newColor.str !== color.str;
	        if (isDifferentColor || editingColor) {
	            this.setState({ color: newColor, editingColor: undefined }, function () {
	                if (ev && _this.props.onChange) {
	                    _this.props.onChange(ev, newColor);
	                }
	                // To preserve the existing behavior, this one is called even when the change comes from a
	                // props update (which is not very useful)
	                if (_this.props.onColorChanged) {
	                    _this.props.onColorChanged(newColor.str, newColor);
	                }
	            });
	        }
	    };
	    ColorPickerBase.defaultProps = {
	        hexLabel: 'Hex',
	        redLabel: 'Red',
	        greenLabel: 'Green',
	        blueLabel: 'Blue',
	        alphaLabel: 'Alpha'
	    };
	    return ColorPickerBase;
	}(React.Component));
	exports.ColorPickerBase = ColorPickerBase;
	function _getColorFromProps(props) {
	    var color = props.color;
	    return typeof color === 'string' ? getColorFromString_1.getColorFromString(color) : color;
	}
	//# sourceMappingURL=ColorPicker.base.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(823), exports);
	//# sourceMappingURL=TextField.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(824), exports);
	tslib_1.__exportStar(__webpack_require__(825), exports);
	tslib_1.__exportStar(__webpack_require__(827), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var TextField_base_1 = __webpack_require__(825);
	var TextField_styles_1 = __webpack_require__(826);
	exports.TextField = Utilities_1.styled(TextField_base_1.TextFieldBase, TextField_styles_1.getStyles, undefined, {
	    scope: 'TextField'
	});
	//# sourceMappingURL=TextField.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Label_1 = __webpack_require__(771);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var DEFAULT_STATE_VALUE = '';
	var TextFieldBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TextFieldBase, _super);
	    function TextFieldBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._textElement = Utilities_1.createRef();
	        _this._onFocus = function (ev) {
	            if (_this.props.onFocus) {
	                _this.props.onFocus(ev);
	            }
	            _this.setState({ isFocused: true });
	            if (_this.props.validateOnFocusIn) {
	                _this._validate(_this.state.value);
	            }
	        };
	        _this._onBlur = function (ev) {
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	            _this.setState({ isFocused: false });
	            if (_this.props.validateOnFocusOut) {
	                _this._validate(_this.state.value);
	            }
	        };
	        _this._onRenderLabel = function (props) {
	            var label = props.label, required = props.required;
	            // IProcessedStyleSet definition requires casting for what Label expects as its styles prop
	            var labelStyles = _this._classNames.subComponentStyles
	                ? _this._classNames.subComponentStyles.label
	                : undefined;
	            if (label) {
	                return (React.createElement(Label_1.Label, { required: required, htmlFor: _this._id, styles: labelStyles, disabled: props.disabled, id: _this._labelId }, props.label));
	            }
	            return null;
	        };
	        _this._onRenderDescription = function (props) {
	            if (props.description) {
	                return React.createElement("span", { className: _this._classNames.description }, props.description);
	            }
	            return null;
	        };
	        _this._onInputChange = function (event) {
	            event.persist();
	            var element = event.target;
	            var value = element.value;
	            // Avoid doing unnecessary work when the value has not changed.
	            if (value === _this._latestValue) {
	                return;
	            }
	            _this._latestValue = value;
	            _this.setState({ value: value }, function () {
	                _this._adjustInputHeight();
	                if (_this.props.onChange) {
	                    _this.props.onChange(event, value);
	                }
	                if (_this.props.onChanged) {
	                    _this.props.onChanged(value);
	                }
	            });
	            if (_shouldValidateAllChanges(_this.props)) {
	                _this._delayedValidate(value);
	            }
	            if (_this.props.onBeforeChange) {
	                _this.props.onBeforeChange(value);
	            }
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._async = new Utilities_1.Async(_this);
	        if (false) {
	            Utilities_1.warnDeprecations('TextField', props, {
	                iconClass: 'iconProps',
	                addonString: 'prefix',
	                onRenderAddon: 'onRenderPrefix',
	                onChanged: 'onChange'
	            });
	            Utilities_1.warnMutuallyExclusive('TextField', props, {
	                value: 'defaultValue'
	            });
	        }
	        _this._id = props.id || Utilities_1.getId('TextField');
	        _this._descriptionId = Utilities_1.getId('TextFieldDescription');
	        _this._labelId = Utilities_1.getId('TextFieldLabel');
	        if (props.value !== undefined) {
	            _this._latestValue = props.value;
	        }
	        else if (props.defaultValue !== undefined) {
	            _this._latestValue = props.defaultValue;
	        }
	        else {
	            _this._latestValue = DEFAULT_STATE_VALUE;
	        }
	        _this.state = {
	            value: _this._latestValue,
	            isFocused: false,
	            errorMessage: ''
	        };
	        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
	        _this._lastValidation = 0;
	        return _this;
	    }
	    Object.defineProperty(TextFieldBase.prototype, "value", {
	        /**
	         * Gets the current value of the text field.
	         */
	        get: function () {
	            return this.state.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TextFieldBase.prototype.componentDidMount = function () {
	        this._isMounted = true;
	        this._adjustInputHeight();
	        if (this.props.validateOnLoad) {
	            this._validate(this.state.value);
	        }
	    };
	    TextFieldBase.prototype.componentWillReceiveProps = function (newProps) {
	        var onBeforeChange = this.props.onBeforeChange;
	        // If old value prop was undefined, then component is controlled and we should
	        //    respect new undefined value and update state accordingly.
	        if (newProps.value !== this.state.value && (newProps.value !== undefined || this.props.value !== undefined)) {
	            if (onBeforeChange) {
	                onBeforeChange(newProps.value);
	            }
	            this._id = newProps.id || this._id;
	            this._setValue(newProps.value);
	            if (_shouldValidateAllChanges(newProps)) {
	                this._delayedValidate(newProps.value);
	            }
	        }
	        // If component is not currently controlled and defaultValue changes, set value to new defaultValue.
	        if (newProps.defaultValue !== this.props.defaultValue && newProps.value === undefined) {
	            this._setValue(newProps.defaultValue);
	        }
	        // Text field is changing between single- and multi-line. After the change is complete,
	        // we'll need to reset focus and selection/cursor.
	        if (!!newProps.multiline !== !!this.props.multiline && this.state.isFocused) {
	            this._shouldResetFocusAfterRender = true;
	            this._selectionBeforeInputTypeChange = [this.selectionStart, this.selectionEnd];
	        }
	    };
	    TextFieldBase.prototype.componentDidUpdate = function () {
	        if (this._shouldResetFocusAfterRender) {
	            // The text field has just changed between single- and multi-line, so we need to reset focus
	            // and selection/cursor.
	            this._shouldResetFocusAfterRender = false;
	            this.focus();
	            if (this._selectionBeforeInputTypeChange) {
	                var _a = this._selectionBeforeInputTypeChange, start = _a[0], end = _a[1];
	                if (start !== null && end !== null) {
	                    this.setSelectionRange(start, end);
	                }
	            }
	        }
	    };
	    TextFieldBase.prototype.componentWillUnmount = function () {
	        this._isMounted = false;
	        this._async.dispose();
	    };
	    TextFieldBase.prototype.render = function () {
	        var _a = this.props, borderless = _a.borderless, className = _a.className, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, inputClassName = _a.inputClassName, label = _a.label, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, addonString = _a.addonString, // @deprecated
	        prefix = _a.prefix, resizable = _a.resizable, suffix = _a.suffix, theme = _a.theme, styles = _a.styles, autoAdjustHeight = _a.autoAdjustHeight, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
	        _c = _a.onRenderPrefix, // @deprecated
	        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e, _f = _a.onRenderDescription, onRenderDescription = _f === void 0 ? this._onRenderDescription : _f;
	        var isFocused = this.state.isFocused;
	        var errorMessage = this._errorMessage;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            disabled: disabled,
	            focused: isFocused,
	            required: required,
	            multiline: multiline,
	            hasLabel: !!label,
	            hasErrorMessage: !!errorMessage,
	            borderless: borderless,
	            resizable: resizable,
	            hasIcon: !!iconProps,
	            underlined: underlined,
	            iconClass: iconClass,
	            inputClassName: inputClassName,
	            autoAdjustHeight: autoAdjustHeight
	        });
	        return (React.createElement("div", { className: this._classNames.root },
	            React.createElement("div", { className: this._classNames.wrapper },
	                onRenderLabel(this.props, this._onRenderLabel),
	                React.createElement("div", { className: this._classNames.fieldGroup },
	                    (addonString !== undefined || this.props.onRenderAddon) && (React.createElement("div", { className: this._classNames.prefix }, onRenderAddon(this.props, this._onRenderAddon))),
	                    (prefix !== undefined || this.props.onRenderPrefix) && (React.createElement("div", { className: this._classNames.prefix }, onRenderPrefix(this.props, this._onRenderPrefix))),
	                    multiline ? this._renderTextArea() : this._renderInput(),
	                    (iconClass || iconProps) && React.createElement(Icon_1.Icon, tslib_1.__assign({ className: this._classNames.icon }, iconProps)),
	                    (suffix !== undefined || this.props.onRenderSuffix) && (React.createElement("div", { className: this._classNames.suffix }, onRenderSuffix(this.props, this._onRenderSuffix))))),
	            this._isDescriptionAvailable && (React.createElement("span", { id: this._descriptionId },
	                onRenderDescription(this.props, this._onRenderDescription),
	                errorMessage && (React.createElement("div", { role: "alert" },
	                    React.createElement(Utilities_1.DelayedRender, null,
	                        React.createElement("p", { className: this._classNames.errorMessage },
	                            React.createElement("span", { "data-automation-id": "error-message" }, errorMessage)))))))));
	    };
	    /**
	     * Sets focus on the text field
	     */
	    TextFieldBase.prototype.focus = function () {
	        if (this._textElement.current) {
	            this._textElement.current.focus();
	        }
	    };
	    /**
	     * Blurs the text field.
	     */
	    TextFieldBase.prototype.blur = function () {
	        if (this._textElement.current) {
	            this._textElement.current.blur();
	        }
	    };
	    /**
	     * Selects the text field
	     */
	    TextFieldBase.prototype.select = function () {
	        if (this._textElement.current) {
	            this._textElement.current.select();
	        }
	    };
	    /**
	     * Sets the selection start of the text field to a specified value
	     */
	    TextFieldBase.prototype.setSelectionStart = function (value) {
	        if (this._textElement.current) {
	            this._textElement.current.selectionStart = value;
	        }
	    };
	    /**
	     * Sets the selection end of the text field to a specified value
	     */
	    TextFieldBase.prototype.setSelectionEnd = function (value) {
	        if (this._textElement.current) {
	            this._textElement.current.selectionEnd = value;
	        }
	    };
	    Object.defineProperty(TextFieldBase.prototype, "selectionStart", {
	        /**
	         * Gets the selection start of the text field
	         */
	        get: function () {
	            return this._textElement.current ? this._textElement.current.selectionStart : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TextFieldBase.prototype, "selectionEnd", {
	        /**
	         * Gets the selection end of the text field
	         */
	        get: function () {
	            return this._textElement.current ? this._textElement.current.selectionEnd : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the start and end positions of a selection in a text field.
	     * @param start - Index of the start of the selection.
	     * @param end - Index of the end of the selection.
	     */
	    TextFieldBase.prototype.setSelectionRange = function (start, end) {
	        if (this._textElement.current) {
	            this._textElement.current.setSelectionRange(start, end);
	        }
	    };
	    TextFieldBase.prototype._setValue = function (value) {
	        var _this = this;
	        this._latestValue = value;
	        this.setState({
	            value: value || DEFAULT_STATE_VALUE,
	            errorMessage: ''
	        }, function () {
	            _this._adjustInputHeight();
	        });
	    };
	    // @deprecated
	    TextFieldBase.prototype._onRenderAddon = function (props) {
	        var addonString = props.addonString;
	        return React.createElement("span", { style: { paddingBottom: '1px' } }, addonString);
	    };
	    TextFieldBase.prototype._onRenderPrefix = function (props) {
	        var prefix = props.prefix;
	        return React.createElement("span", { style: { paddingBottom: '1px' } }, prefix);
	    };
	    TextFieldBase.prototype._onRenderSuffix = function (props) {
	        var suffix = props.suffix;
	        return React.createElement("span", { style: { paddingBottom: '1px' } }, suffix);
	    };
	    Object.defineProperty(TextFieldBase.prototype, "_errorMessage", {
	        get: function () {
	            var errorMessage = this.state.errorMessage;
	            if (!errorMessage && this.props.errorMessage) {
	                errorMessage = this.props.errorMessage;
	            }
	            return errorMessage;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TextFieldBase.prototype, "_isDescriptionAvailable", {
	        /**
	         * If a custom description render function is supplied then treat description as always available.
	         * Otherwise defer to the presence of description or error message text.
	         */
	        get: function () {
	            var props = this.props;
	            return !!(props.onRenderDescription || props.description || this._errorMessage);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TextFieldBase.prototype._renderTextArea = function () {
	        var textAreaProps = Utilities_1.getNativeProps(this.props, Utilities_1.textAreaProperties, ['defaultValue']);
	        return (React.createElement("textarea", tslib_1.__assign({ id: this._id }, textAreaProps, { ref: this._textElement, value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props['aria-describedby'], "aria-invalid": !!this._errorMessage, "aria-label": this.props.ariaLabel, readOnly: this.props.readOnly, onFocus: this._onFocus, onBlur: this._onBlur })));
	    };
	    TextFieldBase.prototype._renderInput = function () {
	        var inputProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultValue']);
	        var ariaLabelledBy = this.props['aria-labelledby'] || (this.props.label ? this._labelId : undefined);
	        return (React.createElement("input", tslib_1.__assign({ type: 'text', id: this._id, "aria-labelledby": ariaLabelledBy }, inputProps, { ref: this._textElement, value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props['aria-describedby'], "aria-invalid": !!this._errorMessage, readOnly: this.props.readOnly, onFocus: this._onFocus, onBlur: this._onBlur })));
	    };
	    TextFieldBase.prototype._validate = function (value) {
	        var _this = this;
	        // In case of _validate called multi-times during executing validate logic with promise return.
	        if (this._latestValidateValue === value && _shouldValidateAllChanges(this.props)) {
	            return;
	        }
	        this._latestValidateValue = value;
	        var onGetErrorMessage = this.props.onGetErrorMessage;
	        var result = onGetErrorMessage(value || '');
	        if (result !== undefined) {
	            if (typeof result === 'string' || !('then' in result)) {
	                this.setState({ errorMessage: result });
	                this._notifyAfterValidate(value, result);
	            }
	            else {
	                var currentValidation_1 = ++this._lastValidation;
	                result.then(function (errorMessage) {
	                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
	                        _this.setState({ errorMessage: errorMessage });
	                    }
	                    _this._notifyAfterValidate(value, errorMessage);
	                });
	            }
	        }
	        else {
	            this._notifyAfterValidate(value, '');
	        }
	    };
	    TextFieldBase.prototype._notifyAfterValidate = function (value, errorMessage) {
	        if (this._isMounted && value === this.state.value && this.props.onNotifyValidationResult) {
	            this.props.onNotifyValidationResult(errorMessage, value);
	        }
	    };
	    TextFieldBase.prototype._adjustInputHeight = function () {
	        if (this._textElement.current && this.props.autoAdjustHeight && this.props.multiline) {
	            var textField = this._textElement.current;
	            textField.style.height = '';
	            textField.style.height = textField.scrollHeight + 'px';
	        }
	    };
	    TextFieldBase.defaultProps = {
	        multiline: false,
	        resizable: true,
	        autoAdjustHeight: false,
	        underlined: false,
	        borderless: false,
	        onChange: function () {
	            /* noop */
	        },
	        onBeforeChange: function () {
	            /* noop */
	        },
	        onNotifyValidationResult: function () {
	            /* noop */
	        },
	        onGetErrorMessage: function () { return undefined; },
	        deferredValidationTime: 200,
	        errorMessage: '',
	        validateOnFocusIn: false,
	        validateOnFocusOut: false,
	        validateOnLoad: true
	    };
	    return TextFieldBase;
	}(React.Component));
	exports.TextFieldBase = TextFieldBase;
	/**
	 * If `validateOnFocusIn` or `validateOnFocusOut` is true, validation should run **only** on that event.
	 * Otherwise, validation should run on every change.
	 */
	function _shouldValidateAllChanges(props) {
	    return !(props.validateOnFocusIn || props.validateOnFocusOut);
	}
	//# sourceMappingURL=TextField.base.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var globalClassNames = {
	    root: 'ms-TextField',
	    description: 'ms-TextField-description',
	    errorMessage: 'ms-TextField-errorMessage',
	    field: 'ms-TextField-field',
	    fieldGroup: 'ms-TextField-fieldGroup',
	    prefix: 'ms-TextField-prefix',
	    suffix: 'ms-TextField-suffix',
	    wrapper: 'ms-TextField-wrapper',
	    multiline: 'ms-TextField--multiline',
	    borderless: 'ms-TextField--borderless',
	    underlined: 'ms-TextField--underlined',
	    unresizable: 'ms-TextField--unresizable',
	    required: 'is-required',
	    disabled: 'is-disabled',
	    active: 'is-active'
	};
	function getLabelStyles(props) {
	    var underlined = props.underlined, disabled = props.disabled, focused = props.focused;
	    return function () {
	        return ({
	            root: [
	                underlined &&
	                    disabled && {
	                    color: props.theme.palette.neutralTertiary
	                },
	                underlined && {
	                    fontSize: Styling_1.FontSizes.medium,
	                    marginRight: 8,
	                    paddingLeft: 12,
	                    paddingRight: 0,
	                    lineHeight: '22px',
	                    height: 32
	                },
	                underlined &&
	                    focused && {
	                    selectors: (_a = {},
	                        _a[Styling_1.HighContrastSelector] = {
	                            height: 31 // -1px to prevent jumpiness in HC with the increased border-width to 2px
	                        },
	                        _a)
	                }
	            ]
	        });
	        var _a;
	    };
	}
	function getStyles(props) {
	    var theme = props.theme, className = props.className, disabled = props.disabled, focused = props.focused, required = props.required, multiline = props.multiline, hasLabel = props.hasLabel, borderless = props.borderless, underlined = props.underlined, hasIcon = props.hasIcon, resizable = props.resizable, hasErrorMessage = props.hasErrorMessage, iconClass = props.iconClass, inputClassName = props.inputClassName, autoAdjustHeight = props.autoAdjustHeight;
	    var semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(globalClassNames, theme);
	    var fieldPrefixSuffix = {
	        background: semanticColors.disabledBackground,
	        color: !disabled ? semanticColors.inputPlaceholderText : semanticColors.disabledText,
	        display: 'flex',
	        alignItems: 'center',
	        padding: '0 10px',
	        lineHeight: 1,
	        whiteSpace: 'nowrap',
	        flexShrink: 0
	    };
	    // placeholder style constants
	    var placeholderStyles = [
	        theme.fonts.medium,
	        {
	            color: semanticColors.inputPlaceholderText,
	            opacity: 1
	        }
	    ];
	    var disabledPlaceholderStyles = {
	        color: semanticColors.disabledText
	    };
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            required && classNames.required,
	            disabled && classNames.disabled,
	            focused && classNames.active,
	            multiline && classNames.multiline,
	            borderless && classNames.borderless,
	            underlined && classNames.underlined,
	            Styling_1.normalize,
	            {
	                position: 'relative'
	            },
	            className
	        ],
	        wrapper: [
	            classNames.wrapper,
	            underlined && {
	                display: 'flex',
	                borderBottomWidth: 1,
	                borderBottomStyle: 'solid',
	                borderBottomColor: semanticColors.inputBorder,
	                width: '100%'
	            },
	            hasErrorMessage &&
	                underlined &&
	                !disabled && {
	                borderBottomColor: semanticColors.errorText,
	                selectors: {
	                    ':hover': {
	                        borderBottomColor: semanticColors.errorText,
	                        selectors: (_a = {},
	                            _a[Styling_1.HighContrastSelector] = {
	                                borderBottomColor: 'Highlight'
	                            },
	                            _a)
	                    }
	                }
	            },
	            underlined &&
	                disabled && {
	                borderBottomColor: semanticColors.disabledBackground
	            },
	            underlined &&
	                !disabled &&
	                !focused &&
	                !hasErrorMessage && {
	                selectors: {
	                    ':hover': {
	                        borderBottomColor: semanticColors.inputBorderHovered,
	                        selectors: (_b = {},
	                            _b[Styling_1.HighContrastSelector] = {
	                                borderBottomColor: 'Highlight'
	                            },
	                            _b)
	                    }
	                }
	            },
	            underlined &&
	                focused && {
	                borderBottomColor: !hasErrorMessage ? semanticColors.inputFocusBorderAlt : semanticColors.errorText,
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = {
	                        borderBottomWidth: 2,
	                        borderBottomColor: 'Highlight'
	                    },
	                    _c)
	            }
	        ],
	        fieldGroup: [
	            classNames.fieldGroup,
	            Styling_1.normalize,
	            {
	                border: "1px solid " + semanticColors.inputBorder,
	                background: semanticColors.inputBackground,
	                cursor: 'text',
	                height: 32,
	                display: 'flex',
	                flexDirection: 'row',
	                alignItems: 'stretch',
	                position: 'relative',
	                selectors: {
	                    ':hover': {
	                        selectors: (_d = {},
	                            _d[Styling_1.HighContrastSelector] = {
	                                borderColor: 'Highlight'
	                            },
	                            _d)
	                    }
	                }
	            },
	            multiline && {
	                minHeight: '60px',
	                height: 'auto',
	                display: 'flex'
	            },
	            borderless && {
	                border: 'none'
	            },
	            !focused &&
	                !disabled && {
	                selectors: {
	                    ':hover': {
	                        borderColor: semanticColors.inputBorderHovered
	                    }
	                }
	            },
	            focused && {
	                borderColor: semanticColors.inputFocusBorderAlt,
	                selectors: (_e = {},
	                    _e[Styling_1.HighContrastSelector] = {
	                        borderWidth: 2,
	                        borderColor: 'Highlight'
	                    },
	                    _e)
	            },
	            disabled && {
	                backgroundColor: semanticColors.disabledBackground,
	                borderColor: semanticColors.disabledBackground,
	                cursor: 'default'
	            },
	            underlined && {
	                flex: '1 1 0px',
	                border: 'none',
	                textAlign: 'left'
	            },
	            underlined &&
	                focused && {
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        height: 31 // -1px to prevent jumpiness in HC with the increased border-width to 2px
	                    },
	                    _f)
	            },
	            underlined &&
	                disabled && {
	                backgroundColor: 'transparent'
	            },
	            hasErrorMessage && {
	                borderColor: semanticColors.errorText,
	                selectors: {
	                    '&:focus, &:hover': {
	                        borderColor: semanticColors.errorText
	                    }
	                }
	            },
	            hasErrorMessage &&
	                focused && {
	                borderColor: semanticColors.errorText
	            },
	            !hasLabel &&
	                required && {
	                selectors: (_g = {
	                        ':after': {
	                            content: "'*'",
	                            color: semanticColors.errorText,
	                            position: 'absolute',
	                            top: -5,
	                            right: -10
	                        }
	                    },
	                    _g[Styling_1.HighContrastSelector] = {
	                        selectors: {
	                            ':after': {
	                                right: -14 // moving the * 4 pixel to right to alleviate border clipping in HC mode.
	                            }
	                        }
	                    },
	                    _g)
	            }
	        ],
	        field: [
	            theme.fonts.medium,
	            classNames.field,
	            Styling_1.normalize,
	            {
	                fontSize: Styling_1.FontSizes.medium,
	                borderRadius: 0,
	                border: 'none',
	                background: 'none',
	                backgroundColor: 'transparent',
	                color: semanticColors.inputText,
	                padding: '0 12px',
	                width: '100%',
	                minWidth: 0,
	                textOverflow: 'ellipsis',
	                outline: 0,
	                selectors: {
	                    '&:active, &:focus, &:hover': { outline: 0 },
	                    '::-ms-clear': {
	                        display: 'none'
	                    }
	                }
	            },
	            Styling_1.getPlaceholderStyles(placeholderStyles),
	            multiline &&
	                !resizable && [
	                classNames.unresizable,
	                {
	                    resize: 'none'
	                }
	            ],
	            multiline && {
	                minHeight: 'inherit',
	                lineHeight: 17,
	                flexGrow: 1,
	                paddingTop: 6,
	                overflow: 'auto',
	                width: '100%'
	            },
	            multiline &&
	                autoAdjustHeight && {
	                overflow: 'hidden'
	            },
	            hasIcon && {
	                paddingRight: 24
	            },
	            multiline &&
	                hasIcon && {
	                paddingRight: 40
	            },
	            disabled && [
	                {
	                    backgroundColor: 'transparent',
	                    borderColor: 'transparent',
	                    color: semanticColors.disabledText
	                },
	                Styling_1.getPlaceholderStyles(disabledPlaceholderStyles)
	            ],
	            underlined && {
	                textAlign: 'left'
	            },
	            focused &&
	                !borderless && {
	                selectors: (_h = {},
	                    _h[Styling_1.HighContrastSelector] = {
	                        paddingLeft: 11,
	                        paddingRight: 11
	                    },
	                    _h)
	            },
	            focused &&
	                multiline &&
	                !borderless && {
	                selectors: (_j = {},
	                    _j[Styling_1.HighContrastSelector] = {
	                        paddingTop: 4 // take into consideration the 2px increased border-width (not when borderless).
	                    },
	                    _j)
	            },
	            inputClassName
	        ],
	        icon: [
	            multiline && {
	                paddingRight: 24,
	                paddingBottom: 8,
	                alignItems: 'flex-end'
	            },
	            {
	                pointerEvents: 'none',
	                position: 'absolute',
	                bottom: 5,
	                right: 8,
	                top: 'auto',
	                fontSize: 16,
	                lineHeight: 18
	            },
	            disabled && {
	                color: semanticColors.disabledText
	            },
	            iconClass
	        ],
	        description: [
	            classNames.description,
	            {
	                color: semanticColors.bodySubtext,
	                fontSize: Styling_1.FontSizes.xSmall
	            }
	        ],
	        errorMessage: [
	            classNames.errorMessage,
	            Styling_1.AnimationClassNames.slideDownIn20,
	            theme.fonts.small,
	            {
	                color: semanticColors.errorText,
	                margin: 0,
	                paddingTop: 5,
	                display: 'flex',
	                alignItems: 'center'
	            }
	        ],
	        prefix: [classNames.prefix, fieldPrefixSuffix],
	        suffix: [classNames.suffix, fieldPrefixSuffix],
	        subComponentStyles: {
	            label: getLabelStyles(props)
	        }
	    };
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=TextField.styles.js.map

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var TextField_1 = __webpack_require__(824);
	var Utilities_1 = __webpack_require__(592);
	var inputMask_1 = __webpack_require__(828);
	exports.DEFAULT_MASK_CHAR = '_';
	var MaskedTextField = /** @class */ (function (_super) {
	    tslib_1.__extends(MaskedTextField, _super);
	    function MaskedTextField(props) {
	        var _this = _super.call(this, props) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        _this._textField = React.createRef();
	        Utilities_1.initializeComponentRef(_this);
	        // Translate mask into charData
	        _this._maskCharData = inputMask_1.parseMask(props.mask, props.maskFormat);
	        // If an initial value is provided, use it to populate the format chars
	        props.value !== undefined && _this.setValue(props.value);
	        _this._isFocused = false;
	        _this._moveCursorOnMouseUp = false;
	        _this.state = {
	            displayValue: inputMask_1.getMaskDisplay(props.mask, _this._maskCharData, props.maskChar)
	        };
	        return _this;
	    }
	    MaskedTextField.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.mask !== this.props.mask || newProps.value !== this.props.value) {
	            this._maskCharData = inputMask_1.parseMask(newProps.mask, newProps.maskFormat);
	            newProps.value !== undefined && this.setValue(newProps.value);
	            this.setState({
	                displayValue: inputMask_1.getMaskDisplay(newProps.mask, this._maskCharData, newProps.maskChar)
	            });
	        }
	    };
	    MaskedTextField.prototype.componentDidUpdate = function () {
	        // Move the cursor to the start of the mask format on update
	        if (this._isFocused && this.state.maskCursorPosition !== undefined && this._textField.current) {
	            this._textField.current.setSelectionRange(this.state.maskCursorPosition, this.state.maskCursorPosition);
	        }
	    };
	    MaskedTextField.prototype.render = function () {
	        return (React.createElement(TextField_1.TextField, tslib_1.__assign({}, this.props, { onFocus: this._onFocus, onBlur: this._onBlur, onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp, onChange: this._onInputChange, onBeforeChange: this._onBeforeChange, onKeyDown: this._onKeyDown, onPaste: this._onPaste, value: this.state.displayValue, componentRef: this._textField })));
	    };
	    Object.defineProperty(MaskedTextField.prototype, "value", {
	        /**
	         * @returns The value of all filled format characters or undefined if not all format characters are filled
	         */
	        get: function () {
	            var value = '';
	            for (var i = 0; i < this._maskCharData.length; i++) {
	                if (!this._maskCharData[i].value) {
	                    return undefined;
	                }
	                value += this._maskCharData[i].value;
	            }
	            return value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     *
	     */
	    MaskedTextField.prototype.setValue = function (newValue) {
	        var valueIndex = 0, charDataIndex = 0;
	        while (valueIndex < newValue.length && charDataIndex < this._maskCharData.length) {
	            // Test if the next character in the new value fits the next format character
	            var testVal = newValue[valueIndex];
	            if (this._maskCharData[charDataIndex].format.test(testVal)) {
	                this._maskCharData[charDataIndex].value = testVal;
	                charDataIndex++;
	            }
	            valueIndex++;
	        }
	    };
	    MaskedTextField.prototype.focus = function () {
	        var current = this._textField.current;
	        current && current.focus();
	    };
	    MaskedTextField.prototype.blur = function () {
	        var current = this._textField.current;
	        current && current.blur();
	    };
	    MaskedTextField.prototype.select = function () {
	        var current = this._textField.current;
	        current && current.select();
	    };
	    MaskedTextField.prototype.setSelectionStart = function (value) {
	        var current = this._textField.current;
	        current && current.setSelectionStart(value);
	    };
	    MaskedTextField.prototype.setSelectionEnd = function (value) {
	        var current = this._textField.current;
	        current && current.setSelectionEnd(value);
	    };
	    MaskedTextField.prototype.setSelectionRange = function (start, end) {
	        var current = this._textField.current;
	        current && current.setSelectionRange(start, end);
	    };
	    Object.defineProperty(MaskedTextField.prototype, "selectionStart", {
	        get: function () {
	            var current = this._textField.current;
	            return current && current.selectionStart !== null ? current.selectionStart : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MaskedTextField.prototype, "selectionEnd", {
	        get: function () {
	            var current = this._textField.current;
	            return current && current.selectionEnd ? current.selectionEnd : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MaskedTextField.prototype._onFocus = function (event) {
	        if (this.props.onFocus) {
	            this.props.onFocus(event);
	        }
	        this._isFocused = true;
	        // Move the cursor position to the leftmost unfilled position
	        for (var i = 0; i < this._maskCharData.length; i++) {
	            if (!this._maskCharData[i].value) {
	                this.setState({
	                    maskCursorPosition: this._maskCharData[i].displayIndex
	                });
	                break;
	            }
	        }
	    };
	    MaskedTextField.prototype._onBlur = function (event) {
	        if (this.props.onBlur) {
	            this.props.onBlur(event);
	        }
	        this._isFocused = false;
	        this._moveCursorOnMouseUp = true;
	    };
	    MaskedTextField.prototype._onMouseDown = function (event) {
	        if (this.props.onMouseDown) {
	            this.props.onMouseDown(event);
	        }
	        if (!this._isFocused) {
	            this._moveCursorOnMouseUp = true;
	        }
	    };
	    MaskedTextField.prototype._onMouseUp = function (event) {
	        if (this.props.onMouseUp) {
	            this.props.onMouseUp(event);
	        }
	        // Move the cursor on mouseUp after focusing the textField
	        if (this._moveCursorOnMouseUp) {
	            this._moveCursorOnMouseUp = false;
	            // Move the cursor position to the rightmost unfilled position
	            for (var i = 0; i < this._maskCharData.length; i++) {
	                if (!this._maskCharData[i].value) {
	                    this.setState({
	                        maskCursorPosition: this._maskCharData[i].displayIndex
	                    });
	                    break;
	                }
	            }
	        }
	    };
	    MaskedTextField.prototype._onBeforeChange = function (value) {
	        var current = this._textField.current;
	        if (this.props.onBeforeChange) {
	            this.props.onBeforeChange(value);
	        }
	        if (this._changeSelectionData === null && current) {
	            this._changeSelectionData = {
	                changeType: 'default',
	                selectionStart: current.selectionStart !== null ? current.selectionStart : -1,
	                selectionEnd: current.selectionEnd !== null ? current.selectionEnd : -1
	            };
	        }
	    };
	    MaskedTextField.prototype._onInputChange = function (ev, value) {
	        if (!this._changeSelectionData) {
	            return;
	        }
	        var displayValue = this.state.displayValue;
	        // The initial value of cursorPos does not matter
	        var cursorPos = 0;
	        var _a = this._changeSelectionData, changeType = _a.changeType, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
	        if (changeType === 'textPasted') {
	            var charsSelected = selectionEnd - selectionStart, charCount = value.length + charsSelected - displayValue.length, startPos = selectionStart, pastedString = value.substr(startPos, charCount);
	            // Clear any selected characters
	            if (charsSelected) {
	                this._maskCharData = inputMask_1.clearRange(this._maskCharData, selectionStart, charsSelected);
	            }
	            cursorPos = inputMask_1.insertString(this._maskCharData, startPos, pastedString);
	        }
	        else if (changeType === 'delete' || changeType === 'backspace') {
	            // isDel is true If the characters are removed LTR, otherwise RTL
	            var isDel = changeType === 'delete', charCount = selectionEnd - selectionStart;
	            if (charCount) {
	                // charCount is > 0 if range was deleted
	                this._maskCharData = inputMask_1.clearRange(this._maskCharData, selectionStart, charCount);
	                cursorPos = inputMask_1.getRightFormatIndex(this._maskCharData, selectionStart);
	            }
	            else {
	                // If charCount === 0, there was no selection and a single character was deleted
	                if (isDel) {
	                    this._maskCharData = inputMask_1.clearNext(this._maskCharData, selectionStart);
	                    cursorPos = inputMask_1.getRightFormatIndex(this._maskCharData, selectionStart);
	                }
	                else {
	                    this._maskCharData = inputMask_1.clearPrev(this._maskCharData, selectionStart);
	                    cursorPos = inputMask_1.getLeftFormatIndex(this._maskCharData, selectionStart);
	                }
	            }
	        }
	        else if (value.length > displayValue.length) {
	            // This case is if the user added characters
	            var charCount = value.length - displayValue.length, startPos = selectionEnd - charCount, enteredString = value.substr(startPos, charCount);
	            cursorPos = inputMask_1.insertString(this._maskCharData, startPos, enteredString);
	        }
	        else if (value.length <= displayValue.length) {
	            /**
	             * This case is reached only if the user has selected a block of 1 or more
	             * characters and input a character replacing the characters they've selected.
	             */
	            var charCount = 1, selectCount = displayValue.length + charCount - value.length, startPos = selectionEnd - charCount, enteredString = value.substr(startPos, charCount);
	            // Clear the selected range
	            this._maskCharData = inputMask_1.clearRange(this._maskCharData, startPos, selectCount);
	            // Insert the printed character
	            cursorPos = inputMask_1.insertString(this._maskCharData, startPos, enteredString);
	        }
	        this._changeSelectionData = null;
	        var newValue = inputMask_1.getMaskDisplay(this.props.mask, this._maskCharData, this.props.maskChar);
	        this.setState({
	            displayValue: newValue,
	            maskCursorPosition: cursorPos
	        });
	        // Perform onChange/d after input has been processed. Return value is expected to be the displayed text
	        if (this.props.onChange) {
	            this.props.onChange(ev, newValue);
	        }
	        if (this.props.onChanged) {
	            this.props.onChanged(newValue);
	        }
	    };
	    MaskedTextField.prototype._onKeyDown = function (event) {
	        var current = this._textField.current;
	        if (this.props.onKeyDown) {
	            this.props.onKeyDown(event);
	        }
	        this._changeSelectionData = null;
	        if (current && current.value) {
	            var keyCode = event.keyCode, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
	            // Ignore ctrl and meta keydown
	            if (ctrlKey || metaKey) {
	                return;
	            }
	            // On backspace or delete, store the selection and the keyCode
	            if (keyCode === Utilities_1.KeyCodes.backspace || keyCode === Utilities_1.KeyCodes.del) {
	                var selectionStart = event.target.selectionStart, selectionEnd = event.target.selectionEnd;
	                // Check if backspace or delete press is valid.
	                if (!(keyCode === Utilities_1.KeyCodes.backspace && selectionEnd && selectionEnd > 0) &&
	                    !(keyCode === Utilities_1.KeyCodes.del && selectionStart !== null && selectionStart < current.value.length)) {
	                    return;
	                }
	                this._changeSelectionData = {
	                    changeType: keyCode === Utilities_1.KeyCodes.backspace ? 'backspace' : 'delete',
	                    selectionStart: selectionStart !== null ? selectionStart : -1,
	                    selectionEnd: selectionEnd !== null ? selectionEnd : -1
	                };
	            }
	        }
	    };
	    MaskedTextField.prototype._onPaste = function (event) {
	        if (this.props.onPaste) {
	            this.props.onPaste(event);
	        }
	        var selectionStart = event.target.selectionStart, selectionEnd = event.target.selectionEnd;
	        // Store the paste selection range
	        this._changeSelectionData = {
	            changeType: 'textPasted',
	            selectionStart: selectionStart !== null ? selectionStart : -1,
	            selectionEnd: selectionEnd !== null ? selectionEnd : -1
	        };
	    };
	    MaskedTextField.defaultProps = {
	        maskChar: exports.DEFAULT_MASK_CHAR,
	        maskFormat: inputMask_1.DEFAULT_MASK_FORMAT_CHARS
	    };
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onFocus", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onBlur", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onMouseDown", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onMouseUp", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onBeforeChange", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onInputChange", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onKeyDown", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], MaskedTextField.prototype, "_onPaste", null);
	    return MaskedTextField;
	}(React.Component));
	exports.MaskedTextField = MaskedTextField;
	//# sourceMappingURL=MaskedTextField.js.map

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DEFAULT_MASK_FORMAT_CHARS = {
	    '9': /[0-9]/,
	    a: /[a-zA-Z]/,
	    '*': /[a-zA-Z0-9]/
	};
	/**
	 * Takes in the mask string and the formatCharacters and returns an array of MaskValues
	 * Example:
	 * mask = 'Phone Number: (999) - 9999'
	 * return = [
	 *    { value: undefined, displayIndex: 16, format: /[0-9]/ },
	 *    { value: undefined, displayIndex: 17, format: /[0-9]/ },
	 *    { value: undefined, displayIndex: 18, format: /[0-9]/ },
	 *    { value: undefined, displayIndex: 22, format: /[0-9]/ },
	 * ]
	 *
	 * @param mask The string use to define the format of the displayed maskedValue.
	 * @param formatChars An object defining how certain characters in the mask should accept input.
	 */
	function parseMask(mask, formatChars) {
	    if (formatChars === void 0) { formatChars = exports.DEFAULT_MASK_FORMAT_CHARS; }
	    if (!mask) {
	        return [];
	    }
	    var maskCharData = [];
	    // Count the escape characters in the mask string.
	    var escapedChars = 0;
	    for (var i = 0; i + escapedChars < mask.length; i++) {
	        var maskChar = mask.charAt(i + escapedChars);
	        if (maskChar === '\\') {
	            escapedChars++;
	        }
	        else {
	            // Check if the maskChar is a format character.
	            var maskFormat = formatChars[maskChar];
	            if (maskFormat) {
	                maskCharData.push({
	                    /**
	                     * Do not add escapedChars to the displayIndex.
	                     * The index refers to a position in the mask's displayValue.
	                     * Since the backslashes don't appear in the displayValue,
	                     * we do not add them to the charData displayIndex.
	                     */
	                    displayIndex: i,
	                    format: maskFormat
	                });
	            }
	        }
	    }
	    return maskCharData;
	}
	exports.parseMask = parseMask;
	/**
	 * Takes in the mask string, an array of MaskValues, and the maskCharacter
	 * returns the mask string formatted with the input values and maskCharacter.
	 * If the maskChar is undefined, the maskDisplay is truncated to the last filled format character.
	 * Example:
	 * mask = 'Phone Number: (999) 999 - 9999'
	 * maskCharData = '12345'
	 * maskChar = '_'
	 * return = 'Phone Number: (123) 45_ - ___'
	 *
	 * Example:
	 * mask = 'Phone Number: (999) 999 - 9999'
	 * value = '12345'
	 * maskChar = undefined
	 * return = 'Phone Number: (123) 45'
	 *
	 * @param mask The string use to define the format of the displayed maskedValue.
	 * @param maskCharData The input values to insert into the mask string for displaying.
	 * @param maskChar? A character to display in place of unfilled mask format characters.
	 */
	function getMaskDisplay(mask, maskCharData, maskChar) {
	    var maskDisplay = mask;
	    if (!maskDisplay) {
	        return '';
	    }
	    // Remove all backslashes
	    maskDisplay = maskDisplay.replace(/\\/g, '');
	    // lastDisplayIndex is is used to truncate the string if necessary.
	    var lastDisplayIndex = 0;
	    if (maskCharData.length > 0) {
	        lastDisplayIndex = maskCharData[0].displayIndex - 1;
	    }
	    /**
	     * For each input value, replace the character in the maskDisplay with the value.
	     * If there is no value set for the format character, use the maskChar.
	     */
	    for (var _i = 0, maskCharData_1 = maskCharData; _i < maskCharData_1.length; _i++) {
	        var charData = maskCharData_1[_i];
	        var nextChar = ' ';
	        if (charData.value) {
	            nextChar = charData.value;
	            if (charData.displayIndex > lastDisplayIndex) {
	                lastDisplayIndex = charData.displayIndex;
	            }
	        }
	        else {
	            if (maskChar) {
	                nextChar = maskChar;
	            }
	        }
	        // Insert the character into the maskdisplay at its corresponding index
	        maskDisplay = maskDisplay.slice(0, charData.displayIndex) + nextChar + maskDisplay.slice(charData.displayIndex + 1);
	    }
	    // Cut off all mask characters after the last filled format value
	    if (!maskChar) {
	        maskDisplay = maskDisplay.slice(0, lastDisplayIndex + 1);
	    }
	    return maskDisplay;
	}
	exports.getMaskDisplay = getMaskDisplay;
	/**
	 * Get the next format index right of or at a specified index.
	 * If no index exists, returns the rightmost index.
	 * @param maskCharData
	 * @param index
	 */
	function getRightFormatIndex(maskCharData, index) {
	    for (var i = 0; i < maskCharData.length; i++) {
	        if (maskCharData[i].displayIndex >= index) {
	            return maskCharData[i].displayIndex;
	        }
	    }
	    return maskCharData[maskCharData.length - 1].displayIndex;
	}
	exports.getRightFormatIndex = getRightFormatIndex;
	/**
	 * Get the next format index left of a specified index.
	 * If no index exists, returns the leftmost index.
	 * @param maskCharData
	 * @param index
	 */
	function getLeftFormatIndex(maskCharData, index) {
	    for (var i = maskCharData.length - 1; i >= 0; i--) {
	        if (maskCharData[i].displayIndex < index) {
	            return maskCharData[i].displayIndex;
	        }
	    }
	    return maskCharData[0].displayIndex;
	}
	exports.getLeftFormatIndex = getLeftFormatIndex;
	/**
	 * Deletes all values in maskCharData with a displayIndex that falls inside the specified range.
	 * maskCharData is modified inline and also returned.
	 * @param maskCharData
	 * @param selectionStart
	 * @param selectionCount
	 */
	function clearRange(maskCharData, selectionStart, selectionCount) {
	    for (var i = 0; i < maskCharData.length; i++) {
	        if (maskCharData[i].displayIndex >= selectionStart) {
	            if (maskCharData[i].displayIndex >= selectionStart + selectionCount) {
	                break;
	            }
	            maskCharData[i].value = undefined;
	        }
	    }
	    return maskCharData;
	}
	exports.clearRange = clearRange;
	/**
	 * Deletes the input character at or after a specified index and returns the new array of charData
	 * maskCharData is modified inline and also returned.
	 * @param maskCharData
	 * @param selectionStart
	 */
	function clearNext(maskCharData, selectionStart) {
	    for (var i = 0; i < maskCharData.length; i++) {
	        if (maskCharData[i].displayIndex >= selectionStart) {
	            maskCharData[i].value = undefined;
	            break;
	        }
	    }
	    return maskCharData;
	}
	exports.clearNext = clearNext;
	/**
	 * Deletes the input character before a specified index and returns the new array of charData
	 * maskCharData is modified inline and also returned.
	 * @param maskCharData
	 * @param selectionStart
	 */
	function clearPrev(maskCharData, selectionStart) {
	    for (var i = maskCharData.length - 1; i >= 0; i--) {
	        if (maskCharData[i].displayIndex < selectionStart) {
	            maskCharData[i].value = undefined;
	            break;
	        }
	    }
	    return maskCharData;
	}
	exports.clearPrev = clearPrev;
	/**
	 * Deletes all values in maskCharData with a displayIndex that falls inside the specified range.
	 * Modifies the maskCharData inplace with the passed string and returns the display index of the
	 * next format character after the inserted string.
	 * @param maskCharData
	 * @param selectionStart
	 * @param selectionCount
	 * @return The displayIndex of the next format character
	 */
	function insertString(maskCharData, selectionStart, newString) {
	    var stringIndex = 0;
	    var nextIndex = 0;
	    var isStringInserted = false;
	    // Iterate through _maskCharData finding values with a displayIndex after the specified range start
	    for (var i = 0; i < maskCharData.length && stringIndex < newString.length; i++) {
	        if (maskCharData[i].displayIndex >= selectionStart) {
	            isStringInserted = true;
	            nextIndex = maskCharData[i].displayIndex;
	            // Find the next character in the newString that matches the format
	            while (stringIndex < newString.length) {
	                // If the character matches the format regexp, set the maskCharData to the new character
	                if (maskCharData[i].format.test(newString.charAt(stringIndex))) {
	                    maskCharData[i].value = newString.charAt(stringIndex++);
	                    // Set the nextIndex to the display index of the next mask format character.
	                    if (i + 1 < maskCharData.length) {
	                        nextIndex = maskCharData[i + 1].displayIndex;
	                    }
	                    else {
	                        nextIndex++;
	                    }
	                    break;
	                }
	                stringIndex++;
	            }
	        }
	    }
	    return isStringInserted ? nextIndex : selectionStart;
	}
	exports.insertString = insertString;
	//# sourceMappingURL=inputMask.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ColorRectangle_base_1 = __webpack_require__(830);
	var ColorRectangle_styles_1 = __webpack_require__(831);
	exports.ColorRectangle = Utilities_1.styled(ColorRectangle_base_1.ColorRectangleBase, ColorRectangle_styles_1.getStyles, undefined, { scope: 'ColorRectangle' });
	//# sourceMappingURL=ColorRectangle.js.map

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var consts_1 = __webpack_require__(795);
	var getFullColorString_1 = __webpack_require__(809);
	var updateSV_1 = __webpack_require__(810);
	var clamp_1 = __webpack_require__(801);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory ColorPicker}
	 */
	var ColorRectangleBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ColorRectangleBase, _super);
	    function ColorRectangleBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._onMouseDown = function (ev) {
	            _this._events.on(window, 'mousemove', _this._onMouseMove, true);
	            _this._events.on(window, 'mouseup', _this._disableEvents, true);
	            _this._onMouseMove(ev);
	        };
	        _this._onMouseMove = function (ev) {
	            var _a = _this.props, color = _a.color, onSVChanged = _a.onSVChanged, onChange = _a.onChange;
	            if (!_this._root.current) {
	                return;
	            }
	            // If the primary button (1) isn't pressed, the user is no longer dragging, so turn off the
	            // event handlers and exit. (this may only be relevant while debugging)
	            // tslint:disable-next-line:no-bitwise
	            if (!(ev.buttons & 1)) {
	                _this._disableEvents();
	                return;
	            }
	            var newColor = _getNewColor(ev, color, _this._root.current);
	            if (newColor) {
	                _this.setState({
	                    color: newColor
	                });
	                if (onChange) {
	                    onChange(ev, newColor);
	                }
	                if (onSVChanged) {
	                    onSVChanged(newColor.s, newColor.v);
	                }
	            }
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._disableEvents = function () {
	            _this._events.off();
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._events = new Utilities_1.EventGroup(_this);
	        Utilities_1.warnDeprecations('ColorRectangle', props, {
	            onSVChanged: 'onChange'
	        });
	        var color = _this.props.color;
	        _this.state = {
	            color: color
	        };
	        return _this;
	    }
	    Object.defineProperty(ColorRectangleBase.prototype, "color", {
	        get: function () {
	            return this.state.color;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ColorRectangleBase.prototype.componentWillReceiveProps = function (newProps) {
	        var color = newProps.color;
	        this.setState({
	            color: color
	        });
	    };
	    ColorRectangleBase.prototype.componentWillUnmount = function () {
	        this._events.dispose();
	    };
	    ColorRectangleBase.prototype.render = function () {
	        var _a = this.props, minSize = _a.minSize, theme = _a.theme, className = _a.className, styles = _a.styles;
	        var color = this.state.color;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { ref: this._root, className: classNames.root, style: { minWidth: minSize, minHeight: minSize, backgroundColor: getFullColorString_1.getFullColorString(color) }, onMouseDown: this._onMouseDown },
	            React.createElement("div", { className: classNames.light }),
	            React.createElement("div", { className: classNames.dark }),
	            React.createElement("div", { className: classNames.thumb, style: { left: color.s + '%', top: consts_1.MAX_COLOR_VALUE - color.v + '%', backgroundColor: color.str } })));
	    };
	    ColorRectangleBase.defaultProps = {
	        minSize: 220
	    };
	    return ColorRectangleBase;
	}(React.Component));
	exports.ColorRectangleBase = ColorRectangleBase;
	/**
	 * Exported for testing only.
	 * @internal
	 */
	function _getNewColor(ev, prevColor, root) {
	    var rectSize = root.getBoundingClientRect();
	    var sPercentage = (ev.clientX - rectSize.left) / rectSize.width;
	    var vPercentage = (ev.clientY - rectSize.top) / rectSize.height;
	    return updateSV_1.updateSV(prevColor, clamp_1.clamp(sPercentage * consts_1.MAX_COLOR_SATURATION, consts_1.MAX_COLOR_SATURATION), clamp_1.clamp(consts_1.MAX_COLOR_VALUE - vPercentage * consts_1.MAX_COLOR_VALUE, consts_1.MAX_COLOR_VALUE));
	}
	exports._getNewColor = _getNewColor;
	//# sourceMappingURL=ColorRectangle.base.js.map

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var className = props.className;
	    return {
	        root: [
	            'ms-ColorPicker-colorRect',
	            {
	                position: 'relative',
	                marginBottom: 10,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        MsHighContrastAdjust: 'none'
	                    },
	                    _a)
	            },
	            className
	        ],
	        light: [
	            'ms-ColorPicker-light',
	            {
	                position: 'absolute',
	                left: 0,
	                right: 0,
	                top: 0,
	                bottom: 0,
	                background: 'linear-gradient(to right, white 0%, transparent 100%)'
	            }
	        ],
	        dark: [
	            'ms-ColorPicker-dark',
	            {
	                position: 'absolute',
	                left: 0,
	                right: 0,
	                top: 0,
	                bottom: 0,
	                background: 'linear-gradient(to bottom, transparent 0, #000 100%)'
	            }
	        ],
	        thumb: [
	            'ms-ColorPicker-thumb',
	            {
	                position: 'absolute',
	                width: 20,
	                height: 20,
	                background: 'white',
	                border: '1px solid rgba(255,255,255,.8)',
	                borderRadius: '50%',
	                boxShadow: '0 0 15px -5px black',
	                transform: 'translate(-50%, -50%)'
	            }
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=ColorRectangle.styles.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ColorSlider_base_1 = __webpack_require__(833);
	var ColorSlider_styles_1 = __webpack_require__(834);
	exports.ColorSlider = Utilities_1.styled(ColorSlider_base_1.ColorSliderBase, ColorSlider_styles_1.getStyles, undefined, { scope: 'ColorSlider' });
	//# sourceMappingURL=ColorSlider.js.map

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory ColorPicker}
	 */
	var ColorSliderBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ColorSliderBase, _super);
	    function ColorSliderBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._onMouseDown = function (ev) {
	            _this._events.on(window, 'mousemove', _this._onMouseMove, true);
	            _this._events.on(window, 'mouseup', _this._onMouseUp, true);
	            _this._onMouseMove(ev);
	        };
	        _this._onMouseMove = function (ev) {
	            if (!_this._root.current) {
	                return;
	            }
	            var _a = _this.props, onChange = _a.onChange, onChanged = _a.onChanged, minValue = _a.minValue, maxValue = _a.maxValue;
	            var rectSize = _this._root.current.getBoundingClientRect();
	            var currentPercentage = (ev.clientX - rectSize.left) / rectSize.width;
	            var newValue = Math.min(maxValue, Math.max(minValue, currentPercentage * maxValue));
	            _this.setState({
	                currentValue: newValue
	            });
	            if (onChange) {
	                onChange(ev, newValue);
	            }
	            if (onChanged) {
	                onChanged(newValue);
	            }
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._onMouseUp = function (ev) {
	            _this._events.off();
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._events = new Utilities_1.EventGroup(_this);
	        Utilities_1.warnDeprecations('ColorSlider', props, {
	            onChanged: 'onChange'
	        });
	        var value = _this.props.value;
	        _this.state = {
	            currentValue: value
	        };
	        return _this;
	    }
	    ColorSliderBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps && newProps.value) {
	            this.setState({ currentValue: newProps.value });
	        }
	    };
	    ColorSliderBase.prototype.componentWillUnmount = function () {
	        this._events.dispose();
	    };
	    ColorSliderBase.prototype.render = function () {
	        var _a = this.props, isAlpha = _a.isAlpha, minValue = _a.minValue, maxValue = _a.maxValue, overlayStyle = _a.overlayStyle, theme = _a.theme, className = _a.className, styles = _a.styles;
	        var currentValue = this.state.currentValue;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        var currentPercentage = (100 * (currentValue - minValue)) / (maxValue - minValue);
	        var hueStyle = {
	            background: 
	            // tslint:disable-next-line:max-line-length
	            'linear-gradient(to left,red 0,#f09 10%,#cd00ff 20%,#3200ff 30%,#06f 40%,#00fffd 50%,#0f6 60%,#35ff00 70%,#cdff00 80%,#f90 90%,red 100%)'
	        };
	        var alphaStyle = {
	            backgroundImage: 
	            // tslint:disable-next-line:max-line-length
	            'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAJUlEQVQYV2N89erVfwY0ICYmxoguxjgUFKI7GsTH5m4M3w1ChQC1/Ca8i2n1WgAAAABJRU5ErkJggg==)'
	        };
	        var sliderStyle = isAlpha ? alphaStyle : hueStyle;
	        return (React.createElement("div", { ref: this._root, className: classNames.root, onMouseDown: this._onMouseDown, style: sliderStyle },
	            React.createElement("div", { className: classNames.sliderOverlay, style: overlayStyle }),
	            React.createElement("div", { className: classNames.sliderThumb, style: { left: currentPercentage + '%' } })));
	    };
	    ColorSliderBase.defaultProps = {
	        minValue: 0,
	        maxValue: 100,
	        thumbColor: 'inherit',
	        value: 0
	    };
	    return ColorSliderBase;
	}(React.Component));
	exports.ColorSliderBase = ColorSliderBase;
	//# sourceMappingURL=ColorSlider.base.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className;
	    var palette = theme.palette;
	    return {
	        root: [
	            'ms-ColorPicker-slider',
	            {
	                position: 'relative',
	                height: 20,
	                marginBottom: 5,
	                border: "1px solid " + palette.neutralLight,
	                boxSizing: 'border-box'
	            },
	            className
	        ],
	        sliderOverlay: [
	            'ms-ColorPicker-sliderOverlay',
	            {
	                content: '',
	                position: 'absolute',
	                left: 0,
	                right: 0,
	                top: 0,
	                bottom: 0
	            }
	        ],
	        sliderThumb: [
	            'ms-ColorPicker-thumb',
	            'is-slider',
	            {
	                position: 'absolute',
	                width: 20,
	                height: 20,
	                background: 'white',
	                border: '1px solid rgba(255,255,255,.8)',
	                borderRadius: '50%',
	                boxShadow: '0 0 15px -5px black',
	                transform: 'translate(-50%, -50%)',
	                top: '50%'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=ColorSlider.styles.js.map

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    return {
	        root: [
	            'ms-ColorPicker',
	            theme.fonts.medium,
	            {
	                position: 'relative',
	                maxWidth: 300
	            },
	            className
	        ],
	        panel: [
	            'ms-ColorPicker-panel',
	            {
	                padding: '16px'
	            }
	        ],
	        table: [
	            'ms-ColorPicker-table',
	            {
	                tableLayout: 'fixed',
	                width: '100%'
	            }
	        ],
	        tableHeader: [
	            tslib_1.__assign({}, theme.fonts.small)
	        ],
	        tableHexCell: [
	            {
	                width: '25%'
	            }
	        ],
	        input: [
	            'ms-ColorPicker-input',
	            {
	                width: '100%',
	                border: 'none',
	                boxSizing: 'border-box',
	                height: 30,
	                selectors: {
	                    '&.ms-TextField': {
	                        paddingRight: 2
	                    },
	                    '& .ms-TextField-field': {
	                        minWidth: 'auto',
	                        padding: 5,
	                        textOverflow: 'clip'
	                    }
	                }
	            }
	        ]
	    };
	};
	//# sourceMappingURL=ColorPicker.styles.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(837), exports);
	//# sourceMappingURL=ComboBox.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var SelectableOption_types_1 = __webpack_require__(838);
	exports.SelectableOptionMenuItemType = SelectableOption_types_1.SelectableOptionMenuItemType;
	tslib_1.__exportStar(__webpack_require__(839), exports);
	tslib_1.__exportStar(__webpack_require__(844), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SelectableOptionMenuItemType;
	(function (SelectableOptionMenuItemType) {
	    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
	    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
	    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
	})(SelectableOptionMenuItemType = exports.SelectableOptionMenuItemType || (exports.SelectableOptionMenuItemType = {}));
	//# sourceMappingURL=SelectableOption.types.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var index_1 = __webpack_require__(665);
	var Utilities_1 = __webpack_require__(592);
	var Callout_1 = __webpack_require__(603);
	var Checkbox_1 = __webpack_require__(762);
	var Button_1 = __webpack_require__(691);
	var DirectionalHint_1 = __webpack_require__(608);
	var ComboBox_styles_1 = __webpack_require__(840);
	var ComboBox_classNames_1 = __webpack_require__(841);
	var KeytipData_1 = __webpack_require__(684);
	var Label_1 = __webpack_require__(771);
	var index_2 = __webpack_require__(842);
	var SearchDirection;
	(function (SearchDirection) {
	    SearchDirection[SearchDirection["backward"] = -1] = "backward";
	    SearchDirection[SearchDirection["none"] = 0] = "none";
	    SearchDirection[SearchDirection["forward"] = 1] = "forward";
	})(SearchDirection || (SearchDirection = {}));
	var HoverStatus;
	(function (HoverStatus) {
	    /** Used when the user was hovering and has since moused out of the menu items */
	    HoverStatus[HoverStatus["clearAll"] = -2] = "clearAll";
	    /** Default "normal" state, when no hover has happened or a hover is in progress */
	    HoverStatus[HoverStatus["default"] = -1] = "default";
	})(HoverStatus || (HoverStatus = {}));
	var ScrollIdleDelay = 250 /* ms */;
	var TouchIdleDelay = 500; /* ms */
	/**
	 * This is used to clear any pending autocomplete text (used when autocomplete is true and
	 * allowFreeform is false)
	 */
	var ReadOnlyPendingAutoCompleteTimeout = 1000 /* ms */;
	/**
	 * Internal class that is used to wrap all ComboBox options.
	 * This is used to customize when we want to rerender components,
	 * so we don't rerender every option every time render is executed.
	 */
	var ComboBoxOptionWrapper = /** @class */ (function (_super) {
	    tslib_1.__extends(ComboBoxOptionWrapper, _super);
	    function ComboBoxOptionWrapper() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComboBoxOptionWrapper.prototype.render = function () {
	        return this.props.render();
	    };
	    ComboBoxOptionWrapper.prototype.shouldComponentUpdate = function (newProps) {
	        // The render function will always be different, so we ignore that prop
	        return !Utilities_1.shallowCompare(tslib_1.__assign({}, this.props, { render: undefined }), tslib_1.__assign({}, newProps, { render: undefined }));
	    };
	    return ComboBoxOptionWrapper;
	}(React.Component));
	var ComboBox = /** @class */ (function (_super) {
	    tslib_1.__extends(ComboBox, _super);
	    function ComboBox(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        /** The input aspect of the comboBox */
	        _this._autofill = React.createRef();
	        /** The wrapping div of the input and button */
	        _this._comboBoxWrapper = React.createRef();
	        /** The callout element */
	        _this._comboBoxMenu = React.createRef();
	        /** The menu item element that is currently selected */
	        _this._selectedElement = React.createRef();
	        /**
	         * {@inheritdoc}
	         */
	        _this.focus = function (shouldOpenOnFocus, useFocusAsync) {
	            if (_this._autofill.current) {
	                if (useFocusAsync) {
	                    Utilities_1.focusAsync(_this._autofill.current);
	                }
	                else {
	                    _this._autofill.current.focus();
	                }
	                if (shouldOpenOnFocus) {
	                    _this.setState({
	                        isOpen: true
	                    });
	                }
	            }
	        };
	        /**
	         * Close menu callout if it is open
	         */
	        _this.dismissMenu = function () {
	            var isOpen = _this.state.isOpen;
	            isOpen && _this.setState({ isOpen: false });
	        };
	        /**
	         * componentWillReceiveProps handler for the auto fill component
	         * Checks/updates the iput value to set, if needed
	         * @param defaultVisibleValue - the defaultVisibleValue that got passed
	         *  in to the auto fill's componentWillReceiveProps
	         * @returns - the updated value to set, if needed
	         */
	        _this._onUpdateValueInAutofillWillReceiveProps = function () {
	            var comboBox = _this._autofill.current;
	            if (!comboBox) {
	                return null;
	            }
	            if (comboBox.value === null || comboBox.value === undefined) {
	                return null;
	            }
	            var visibleValue = _this._normalizeToString(_this._currentVisibleValue);
	            if (comboBox.value !== visibleValue) {
	                // If visibleValue is empty, make it a zero width space.
	                // If we did not do that, the empty string would not get used
	                // potentially resulting in an unexpected value being used
	                return visibleValue || '​';
	            }
	            return comboBox.value;
	        };
	        /**
	         * componentDidUpdate handler for the auto fill component
	         *
	         * @param defaultVisibleValue - the current defaultVisibleValue in the auto fill's componentDidUpdate
	         * @param suggestedDisplayValue - the current suggestedDisplayValue in the auto fill's componentDidUpdate
	         * @returns - should the full value of the input be selected?
	         * True if the defaultVisibleValue equals the suggestedDisplayValue, false otherwise
	         */
	        _this._onShouldSelectFullInputValueInAutofillComponentDidUpdate = function () {
	            return _this._currentVisibleValue === _this.state.suggestedDisplayValue;
	        };
	        /**
	         * Get the correct value to pass to the input
	         * to show to the user based off of the current props and state
	         * @returns the value to pass to the input
	         */
	        _this._getVisibleValue = function () {
	            var _a = _this.props, text = _a.text, value = _a.value, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
	            var _b = _this.state, selectedIndices = _b.selectedIndices, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentOptions = _b.currentOptions, currentPendingValue = _b.currentPendingValue, suggestedDisplayValue = _b.suggestedDisplayValue, isOpen = _b.isOpen, focused = _b.focused;
	            var currentPendingIndexValid = _this._indexWithinBounds(currentOptions, currentPendingValueValidIndex);
	            // If the user passed is a value prop, use that
	            // unless we are open and have a valid current pending index
	            if (!(isOpen && currentPendingIndexValid) && (text && (currentPendingValue === null || currentPendingValue === undefined))) {
	                return text;
	            }
	            if (!(isOpen && currentPendingIndexValid) && (value && (currentPendingValue === null || currentPendingValue === undefined))) {
	                return value;
	            }
	            // Values to display in the BaseAutoFill area
	            var displayValues = [];
	            if (_this.props.multiSelect) {
	                // Multi-select
	                if (focused) {
	                    var index = -1;
	                    if (autoComplete === 'on' && currentPendingIndexValid) {
	                        index = currentPendingValueValidIndex;
	                    }
	                    displayValues.push(currentPendingValue !== null && currentPendingValue !== undefined
	                        ? currentPendingValue
	                        : _this._indexWithinBounds(currentOptions, index)
	                            ? currentOptions[index].text
	                            : '');
	                }
	                else {
	                    for (var idx = 0; selectedIndices && idx < selectedIndices.length; idx++) {
	                        var index = selectedIndices[idx];
	                        displayValues.push(_this._indexWithinBounds(currentOptions, index) ? currentOptions[index].text : _this._normalizeToString(suggestedDisplayValue));
	                    }
	                }
	            }
	            else {
	                // Single-select
	                var index = _this._getFirstSelectedIndex();
	                if (allowFreeform) {
	                    // If we are allowing freeform and autocomplete is also true
	                    // and we've got a pending value that matches an option, remember
	                    // the matched option's index
	                    if (autoComplete === 'on' && currentPendingIndexValid) {
	                        index = currentPendingValueValidIndex;
	                    }
	                    // Since we are allowing freeform, if there is currently a pending value, use that
	                    // otherwise use the index determined above (falling back to '' if we did not get a valid index)
	                    displayValues.push(currentPendingValue !== null && currentPendingValue !== undefined
	                        ? currentPendingValue
	                        : _this._indexWithinBounds(currentOptions, index)
	                            ? currentOptions[index].text
	                            : '');
	                }
	                else {
	                    // If we are not allowing freeform and have a
	                    // valid index that matches the pending value,
	                    // we know we will need some version of the pending value
	                    if (currentPendingIndexValid && autoComplete === 'on') {
	                        // If autoComplete is on, return the
	                        // raw pending value, otherwise remember
	                        // the matched option's index
	                        index = currentPendingValueValidIndex;
	                        displayValues.push(_this._normalizeToString(currentPendingValue));
	                    }
	                    else {
	                        displayValues.push(_this._indexWithinBounds(currentOptions, index) ? currentOptions[index].text : _this._normalizeToString(suggestedDisplayValue));
	                    }
	                }
	            }
	            // If we have a valid index then return the text value of that option,
	            // otherwise return the suggestedDisplayValue
	            var displayString = '';
	            for (var idx = 0; idx < displayValues.length; idx++) {
	                if (idx > 0) {
	                    displayString += ', ';
	                }
	                displayString += displayValues[idx];
	            }
	            return displayString;
	        };
	        /**
	         * Handler for typing changes on the input
	         * @param updatedValue - the newly changed value
	         */
	        _this._onInputChange = function (updatedValue) {
	            if (_this.props.disabled) {
	                _this._handleInputWhenDisabled(null /* event */);
	                return;
	            }
	            _this.props.allowFreeform ? _this._processInputChangeWithFreeform(updatedValue) : _this._processInputChangeWithoutFreeform(updatedValue);
	        };
	        /**
	         * Focus (and select) the content of the input
	         * and set the focused state
	         */
	        _this._select = function () {
	            if (_this._autofill.current && _this._autofill.current.inputElement) {
	                _this._autofill.current.inputElement.select();
	            }
	            if (!_this.state.focused) {
	                var state = { focused: true };
	                if (_this.props.openOnKeyboardFocus && !_this.state.isOpen && !_this.props.disabled) {
	                    state.isOpen = true;
	                }
	                _this.setState(state);
	            }
	        };
	        /**
	         * Callback issued when the options should be resolved, if they have been updated or
	         * if they need to be passed in the first time. This only does work if an onResolveOptions
	         * callback was passed in
	         */
	        _this._onResolveOptions = function () {
	            if (_this.props.onResolveOptions) {
	                // get the options
	                var newOptions = _this.props.onResolveOptions(_this.state.currentOptions.slice());
	                // Check to see if the returned value is an array, if it is update the state
	                // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
	                if (Array.isArray(newOptions)) {
	                    _this.setState({
	                        currentOptions: newOptions
	                    });
	                }
	                else if (newOptions && newOptions.then) {
	                    // Ensure that the promise will only use the callback if it was the most recent one
	                    // and update the state when the promise returns
	                    var promise_1 = (_this._currentPromise = newOptions);
	                    promise_1.then(function (newOptionsFromPromise) {
	                        if (promise_1 === _this._currentPromise) {
	                            _this.setState({
	                                currentOptions: newOptionsFromPromise
	                            });
	                        }
	                    });
	                }
	            }
	        };
	        /**
	         * OnBlur handler. Set the focused state to false
	         * and submit any pending value
	         */
	        _this._onBlur = function (event) {
	            // Do nothing if the blur is coming from something
	            // inside the comboBox root or the comboBox menu since
	            // it we are not really bluring from the whole comboBox
	            var relatedTarget = event.relatedTarget;
	            if (event.relatedTarget === null) {
	                // In IE11, due to lack of support, event.relatedTarget is always
	                // null making every onBlur call to be "outside" of the ComboBox
	                // even when it's not. Using document.activeElement is another way
	                // for us to be able to get what the relatedTarget without relying
	                // on the event
	                relatedTarget = document.activeElement;
	            }
	            if (relatedTarget &&
	                // when event coming from withing the comboBox title
	                ((_this._root.current && _this._root.current.contains(relatedTarget)) ||
	                    // when event coming from within the comboBox list menu
	                    (_this._comboBoxMenu.current &&
	                        (_this._comboBoxMenu.current.contains(relatedTarget) ||
	                            // when event coming from the callout containing the comboBox list menu (ex: when scrollBar of the Callout clicked)
	                            // checks if the relatedTarget is a parent of _comboBoxMenu
	                            Utilities_1.findElementRecursive(_this._comboBoxMenu.current, function (element) { return element === relatedTarget; }))))) {
	                event.preventDefault();
	                event.stopPropagation();
	                return;
	            }
	            if (_this.state.focused) {
	                _this.setState({ focused: false });
	                if (!_this.props.multiSelect || _this.props.allowFreeform) {
	                    _this._submitPendingValue(event);
	                }
	            }
	        };
	        // Render Callout container and pass in list
	        _this._onRenderContainer = function (props) {
	            var onRenderList = props.onRenderList, calloutProps = props.calloutProps, dropdownWidth = props.dropdownWidth, dropdownMaxWidth = props.dropdownMaxWidth, _a = props.onRenderLowerContent, onRenderLowerContent = _a === void 0 ? _this._onRenderLowerContent : _a, useComboBoxAsMenuWidth = props.useComboBoxAsMenuWidth, persistMenu = props.persistMenu, _b = props.shouldRestoreFocus, shouldRestoreFocus = _b === void 0 ? true : _b;
	            var isOpen = _this.state.isOpen;
	            var comboBoxMenuWidth = useComboBoxAsMenuWidth && _this._comboBoxWrapper.current ? _this._comboBoxWrapper.current.clientWidth + 2 : undefined;
	            return (React.createElement(Callout_1.Callout, tslib_1.__assign({ isBeakVisible: false, gapSpace: 0, doNotLayer: false, directionalHint: DirectionalHint_1.DirectionalHint.bottomLeftEdge, directionalHintFixed: false }, calloutProps, { onLayerMounted: _this._onLayerMounted, className: Utilities_1.css(_this._classNames.callout, calloutProps ? calloutProps.className : undefined), target: _this._comboBoxWrapper.current, onDismiss: _this._onDismiss, onScroll: _this._onScroll, setInitialFocus: false, calloutWidth: useComboBoxAsMenuWidth && _this._comboBoxWrapper.current ? comboBoxMenuWidth && comboBoxMenuWidth : dropdownWidth, calloutMaxWidth: dropdownMaxWidth ? dropdownMaxWidth : comboBoxMenuWidth, hidden: persistMenu ? !isOpen : undefined, shouldRestoreFocus: shouldRestoreFocus }),
	                React.createElement("div", { className: _this._classNames.optionsContainerWrapper, ref: _this._comboBoxMenu }, onRenderList(tslib_1.__assign({}, props), _this._onRenderList)),
	                onRenderLowerContent(_this.props, _this._onRenderLowerContent)));
	        };
	        _this._onLayerMounted = function () {
	            _this._onCalloutLayerMounted();
	            if (_this.props.calloutProps && _this.props.calloutProps.onLayerMounted) {
	                _this.props.calloutProps.onLayerMounted();
	            }
	        };
	        // Render List of items
	        _this._onRenderList = function (props) {
	            var onRenderItem = props.onRenderItem, options = props.options;
	            var id = _this._id;
	            return (React.createElement("div", { id: id + '-list', className: _this._classNames.optionsContainer, "aria-labelledby": id + '-label', role: "listbox" }, options.map(function (item) { return onRenderItem(item, _this._onRenderItem); })));
	        };
	        // Render items
	        _this._onRenderItem = function (item) {
	            switch (item.itemType) {
	                case index_2.SelectableOptionMenuItemType.Divider:
	                    return _this._renderSeparator(item);
	                case index_2.SelectableOptionMenuItemType.Header:
	                    return _this._renderHeader(item);
	                default:
	                    return _this._renderOption(item);
	            }
	        };
	        // Default _onRenderLowerContent function returns nothing
	        _this._onRenderLowerContent = function () {
	            return null;
	        };
	        _this._renderOption = function (item) {
	            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOptionContent : _a;
	            var id = _this._id;
	            var isSelected = _this._isOptionSelected(item.index);
	            var optionStyles = _this._getCurrentOptionStyles(item);
	            var optionClassNames = ComboBox_classNames_1.getComboBoxOptionClassNames(_this._getCurrentOptionStyles(item));
	            var checkboxStyles = function () {
	                return optionStyles;
	            };
	            var title = _this._getPreviewText(item);
	            var getOptionComponent = function () {
	                return !_this.props.multiSelect ? (React.createElement(Button_1.CommandButton, { id: id + '-list' + item.index, key: item.key, "data-index": item.index, styles: _this._getCurrentOptionStyles(item), checked: isSelected, className: 'ms-ComboBox-option', onClick: _this._onItemClick(item), onMouseEnter: _this._onOptionMouseEnter.bind(_this, item.index), onMouseMove: _this._onOptionMouseMove.bind(_this, item.index), onMouseLeave: _this._onOptionMouseLeave, role: "option", "aria-selected": isSelected ? 'true' : 'false', ariaLabel: _this._getPreviewText(item), disabled: item.disabled, title: title },
	                    ' ',
	                    React.createElement("span", { className: optionClassNames.optionTextWrapper, ref: isSelected ? _this._selectedElement : undefined }, onRenderOption(item, _this._onRenderOptionContent)))) : (React.createElement(Checkbox_1.Checkbox, { id: id + '-list' + item.index, ariaLabel: _this._getPreviewText(item), key: item.key, "data-index": item.index, styles: checkboxStyles, className: 'ms-ComboBox-option', "data-is-focusable": true, onChange: _this._onItemClick(item), label: item.text, role: "option", "aria-selected": isSelected ? 'true' : 'false', checked: isSelected, title: title }, onRenderOption(item, _this._onRenderOptionContent)));
	            };
	            return (React.createElement(ComboBoxOptionWrapper, { key: item.key, index: item.index, disabled: item.disabled, isSelected: isSelected, text: item.text, render: getOptionComponent, data: item.data }));
	        };
	        /**
	         * Scroll handler for the callout to make sure the mouse events
	         * for updating focus are not interacting during scroll
	         */
	        _this._onScroll = function () {
	            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
	                _this._async.clearTimeout(_this._scrollIdleTimeoutId);
	                _this._scrollIdleTimeoutId = undefined;
	            }
	            else {
	                _this._isScrollIdle = false;
	            }
	            _this._scrollIdleTimeoutId = _this._async.setTimeout(function () {
	                _this._isScrollIdle = true;
	            }, ScrollIdleDelay);
	        };
	        _this._onRenderOptionContent = function (item) {
	            var optionClassNames = ComboBox_classNames_1.getComboBoxOptionClassNames(_this._getCurrentOptionStyles(item));
	            return React.createElement("span", { className: optionClassNames.optionText }, item.text);
	        };
	        /**
	         * Handles dismissing (cancelling) the menu
	         */
	        _this._onDismiss = function () {
	            var onMenuDismiss = _this.props.onMenuDismiss;
	            if (onMenuDismiss) {
	                onMenuDismiss();
	            }
	            // In persistMode we need to simulate callout layer mount
	            // since that only happens once. We do it on dismiss since
	            // it works either way.
	            if (_this.props.persistMenu) {
	                _this._onCalloutLayerMounted();
	            }
	            // close the menu
	            _this._setOpenStateAndFocusOnClose(false /* isOpen */, false /* focusInputAfterClose */);
	            // reset the selected index
	            // to the last value state
	            _this._resetSelectedIndex();
	        };
	        _this._onAfterClearPendingInfo = function () {
	            _this._processingClearPendingInfo = false;
	        };
	        /**
	         * Handle keydown on the input
	         * @param ev - The keyboard event that was fired
	         */
	        _this._onInputKeyDown = function (ev) {
	            var _a = _this.props, disabled = _a.disabled, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
	            var _b = _this.state, isOpen = _b.isOpen, currentOptions = _b.currentOptions, currentPendingValueValidIndexOnHover = _b.currentPendingValueValidIndexOnHover;
	            // Take note if we are processing an alt (option) or meta (command) keydown.
	            // See comment in _onInputKeyUp for reasoning.
	            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
	            if (disabled) {
	                _this._handleInputWhenDisabled(ev);
	                return;
	            }
	            var index = _this._getPendingSelectedIndex(false /* includeCurrentPendingValue */);
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.enter:
	                    if (_this._autofill.current && _this._autofill.current.inputElement) {
	                        _this._autofill.current.inputElement.select();
	                    }
	                    _this._submitPendingValue(ev);
	                    if (_this.props.multiSelect && isOpen) {
	                        _this.setState({
	                            currentPendingValueValidIndex: index
	                        });
	                    }
	                    else {
	                        // On enter submit the pending value
	                        if (isOpen ||
	                            ((!allowFreeform ||
	                                _this.state.currentPendingValue === undefined ||
	                                _this.state.currentPendingValue === null ||
	                                _this.state.currentPendingValue.length <= 0) &&
	                                _this.state.currentPendingValueValidIndex < 0)) {
	                            // if we are open or
	                            // if we are not allowing freeform or
	                            // our we have no pending value
	                            // and no valid pending index
	                            // flip the open state
	                            _this.setState({
	                                isOpen: !isOpen
	                            });
	                        }
	                    }
	                    break;
	                case Utilities_1.KeyCodes.tab:
	                    // On enter submit the pending value
	                    if (!_this.props.multiSelect) {
	                        _this._submitPendingValue(ev);
	                    }
	                    // If we are not allowing freeform
	                    // or the comboBox is open, flip the open state
	                    if (isOpen) {
	                        _this._setOpenStateAndFocusOnClose(!isOpen, false /* focusInputAfterClose */);
	                    }
	                    // Allow TAB to propigate
	                    return;
	                case Utilities_1.KeyCodes.escape:
	                    // reset the selected index
	                    _this._resetSelectedIndex();
	                    // Close the menu if opened
	                    if (isOpen) {
	                        _this.setState({
	                            isOpen: false
	                        });
	                    }
	                    else {
	                        return;
	                    }
	                    break;
	                case Utilities_1.KeyCodes.up:
	                    // if we are in clearAll state (e.g. the user as hovering
	                    // and has since mousedOut of the menu items),
	                    // go to the last index
	                    if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
	                        index = _this.state.currentOptions.length;
	                    }
	                    if (ev.altKey || ev.metaKey) {
	                        // Close the menu if it is open and break so
	                        // that the event get stopPropagation and prevent default.
	                        // Otherwise, we need to let the event continue to propagate
	                        if (isOpen) {
	                            _this._setOpenStateAndFocusOnClose(!isOpen, true /* focusInputAfterClose */);
	                            break;
	                        }
	                        return;
	                    }
	                    // Go to the previous option
	                    _this._setPendingInfoFromIndexAndDirection(index, SearchDirection.backward);
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    // Expand the comboBox on ALT + DownArrow
	                    if (ev.altKey || ev.metaKey) {
	                        _this._setOpenStateAndFocusOnClose(true /* isOpen */, true /* focusInputAfterClose */);
	                    }
	                    else {
	                        // if we are in clearAll state (e.g. the user as hovering
	                        // and has since mousedOut of the menu items),
	                        // go to the first index
	                        if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
	                            index = -1;
	                        }
	                        // Got to the next option
	                        _this._setPendingInfoFromIndexAndDirection(index, SearchDirection.forward);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.home:
	                case Utilities_1.KeyCodes.end:
	                    if (allowFreeform) {
	                        return;
	                    }
	                    // Set the initial values to respond to HOME
	                    // which goes to the first selectable option
	                    index = -1;
	                    var directionToSearch = SearchDirection.forward;
	                    // If end, update the values to respond to END
	                    // which goes to the last selectable option
	                    if (ev.which === Utilities_1.KeyCodes.end) {
	                        index = currentOptions.length;
	                        directionToSearch = SearchDirection.backward;
	                    }
	                    _this._setPendingInfoFromIndexAndDirection(index, directionToSearch);
	                    break;
	                case Utilities_1.KeyCodes.space:
	                    // event handled in _onComboBoxKeyUp
	                    if (!allowFreeform && autoComplete === 'off') {
	                        break;
	                    }
	                default:
	                    // are we processing a function key? if so bail out
	                    if (ev.which >= 112 /* F1 */ && ev.which <= 123 /* F12 */) {
	                        return;
	                    }
	                    // If we get here and we got either and ALT key
	                    // or meta key, let the event propagate
	                    if (ev.keyCode === Utilities_1.KeyCodes.alt || ev.key === 'Meta' /* && isOpen */) {
	                        return;
	                    }
	                    // If we are not allowing freeform and
	                    // allowing autoComplete, handle the input here
	                    // since we have marked the input as readonly
	                    if (!allowFreeform && autoComplete === 'on') {
	                        _this._onInputChange(String.fromCharCode(ev.which));
	                        break;
	                    }
	                    // allow the key to propagate by default
	                    return;
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        /**
	         * Handle keyup on the input
	         * @param ev - the keyboard event that was fired
	         */
	        _this._onInputKeyUp = function (ev) {
	            var _a = _this.props, disabled = _a.disabled, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
	            var isOpen = _this.state.isOpen;
	            // We close the menu on key up only if ALL of the following are true:
	            // - Most recent key down was alt or meta (command)
	            // - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
	            //   expand/collapse the menu)
	            // - We're not on a Mac (or iOS)
	            // This is because on Windows, pressing alt moves focus to the application menu bar or similar,
	            // closing any open context menus. There is not a similar behavior on Macs.
	            var keyPressIsAltOrMetaAlone = _this._lastKeyDownWasAltOrMeta && _this._isAltOrMeta(ev);
	            _this._lastKeyDownWasAltOrMeta = false;
	            var shouldHandleKey = keyPressIsAltOrMetaAlone && !(Utilities_1.isMac() || Utilities_1.isIOS());
	            if (disabled) {
	                _this._handleInputWhenDisabled(ev);
	                return;
	            }
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.space:
	                    // If we are not allowing freeform and are not autoComplete
	                    // make space expand/collapse the comboBox
	                    // and allow the event to propagate
	                    if (!allowFreeform && autoComplete === 'off') {
	                        _this._setOpenStateAndFocusOnClose(!isOpen, !!isOpen);
	                        return;
	                    }
	                    break;
	                default:
	                    if (shouldHandleKey && isOpen) {
	                        _this._setOpenStateAndFocusOnClose(!isOpen, true /* focusInputAfterClose */);
	                    }
	                    return;
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        _this._onOptionMouseLeave = function () {
	            if (_this._shouldIgnoreMouseEvent()) {
	                return;
	            }
	            // Ignore the event in persistMenu mode if the callout has
	            // closed. This is to avoid clearing the visuals on item click.
	            if (_this.props.persistMenu && !_this.state.isOpen) {
	                return;
	            }
	            _this.setState({
	                currentPendingValueValidIndexOnHover: HoverStatus.clearAll
	            });
	        };
	        /**
	         * Click handler for the button of the comboBox
	         * and the input when not allowing freeform. This
	         * toggles the expand/collapse state of the comboBox (if enbled)
	         */
	        _this._onComboBoxClick = function () {
	            var disabled = _this.props.disabled;
	            var isOpen = _this.state.isOpen;
	            if (!disabled) {
	                _this._setOpenStateAndFocusOnClose(!isOpen, false /* focusInputAfterClose */);
	                _this.setState({ focused: true });
	            }
	        };
	        /**
	         * Click handler for the autofill.
	         */
	        _this._onAutofillClick = function () {
	            if (_this.props.allowFreeform) {
	                _this.focus(_this.state.isOpen || _this._processingTouch);
	            }
	            else {
	                _this._onComboBoxClick();
	            }
	        };
	        _this._onTouchStart = function () {
	            if (_this._comboBoxWrapper.current && !('onpointerdown' in _this._comboBoxWrapper)) {
	                _this._handleTouchAndPointerEvent();
	            }
	        };
	        _this._onPointerDown = function (ev) {
	            if (ev.pointerType === 'touch') {
	                _this._handleTouchAndPointerEvent();
	                ev.preventDefault();
	                ev.stopImmediatePropagation();
	            }
	        };
	        _this._warnMutuallyExclusive({
	            defaultSelectedKey: 'selectedKey',
	            text: 'defaultSelectedKey',
	            value: 'defaultSelectedKey',
	            selectedKey: 'value',
	            dropdownWidth: 'useComboBoxAsMenuWidth'
	        });
	        _this._warnDeprecations({
	            value: 'text',
	            onChanged: 'onChange'
	        });
	        _this._id = props.id || Utilities_1.getId('ComboBox');
	        var selectedKeys = _this._buildDefaultSelectedKeys(props.defaultSelectedKey, props.selectedKey);
	        _this._isScrollIdle = true;
	        _this._processingTouch = false;
	        _this._gotMouseMove = false;
	        _this._processingClearPendingInfo = false;
	        var initialSelectedIndices = _this._getSelectedIndices(props.options, selectedKeys);
	        _this.state = {
	            isOpen: false,
	            selectedIndices: initialSelectedIndices,
	            focused: false,
	            suggestedDisplayValue: undefined,
	            currentOptions: _this.props.options,
	            currentPendingValueValidIndex: -1,
	            currentPendingValue: undefined,
	            currentPendingValueValidIndexOnHover: HoverStatus.default
	        };
	        return _this;
	    }
	    Object.defineProperty(ComboBox.prototype, "selectedOptions", {
	        /**
	         * All selected options
	         */
	        get: function () {
	            var _a = this.state, currentOptions = _a.currentOptions, selectedIndices = _a.selectedIndices;
	            return index_2.getAllSelectedOptions(currentOptions, selectedIndices);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ComboBox.prototype.componentDidMount = function () {
	        if (this._comboBoxWrapper.current) {
	            // hook up resolving the options if needed on focus
	            this._events.on(this._comboBoxWrapper.current, 'focus', this._onResolveOptions, true);
	            if ('onpointerdown' in this._comboBoxWrapper.current) {
	                // For ComboBoxes, touching anywhere in the combo box should drop the dropdown, including the input element.
	                // This gives more hit target space for touch environments. We're setting the onpointerdown here, because React
	                // does not support Pointer events yet.
	                this._events.on(this._comboBoxWrapper.current, 'pointerdown', this._onPointerDown, true);
	            }
	        }
	    };
	    ComboBox.prototype.componentWillReceiveProps = function (newProps) {
	        // Update the selectedIndex and currentOptions state if
	        // the selectedKey, value, or options have changed
	        if (newProps.selectedKey !== this.props.selectedKey ||
	            newProps.text !== this.props.text ||
	            newProps.value !== this.props.value ||
	            newProps.options !== this.props.options) {
	            var selectedKeys = this._buildSelectedKeys(newProps.selectedKey);
	            var indices = this._getSelectedIndices(newProps.options, selectedKeys);
	            this.setState({
	                selectedIndices: indices,
	                currentOptions: newProps.options
	            });
	        }
	    };
	    ComboBox.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var _this = this;
	        var _a = this.props, allowFreeform = _a.allowFreeform, text = _a.text, value = _a.value, onMenuOpen = _a.onMenuOpen, onMenuDismissed = _a.onMenuDismissed;
	        var _b = this.state, isOpen = _b.isOpen, focused = _b.focused, selectedIndices = _b.selectedIndices, currentPendingValueValidIndex = _b.currentPendingValueValidIndex;
	        // If we are newly open or are open and the pending valid index changed,
	        // make sure the currently selected/pending option is scrolled into view
	        if (isOpen && (!prevState.isOpen || prevState.currentPendingValueValidIndex !== currentPendingValueValidIndex)) {
	            // Need this timeout so that the selectedElement ref is correctly updated
	            this._async.setTimeout(function () { return _this._scrollIntoView(); }, 0);
	        }
	        // if an action is taken that put focus in the ComboBox
	        // and If we are open or we are just closed, shouldFocusAfterClose is set,
	        // but we are not the activeElement set focus on the input
	        if (focused &&
	            (isOpen ||
	                (prevState.isOpen &&
	                    !isOpen &&
	                    this._focusInputAfterClose &&
	                    this._autofill.current &&
	                    document.activeElement !== this._autofill.current.inputElement))) {
	            this.focus(undefined /*shouldOpenOnFocus*/, true /*useFocusAsync*/);
	        }
	        // If we should focusAfterClose AND
	        //   just opened/closed the menu OR
	        //   are focused AND
	        //     updated the selectedIndex with the menu closed OR
	        //     are not allowing freeform OR
	        //     the value changed
	        // we need to set selection
	        if (this._focusInputAfterClose &&
	            ((prevState.isOpen && !isOpen) ||
	                (focused &&
	                    ((!isOpen &&
	                        !this.props.multiSelect &&
	                        prevState.selectedIndices &&
	                        selectedIndices &&
	                        prevState.selectedIndices[0] !== selectedIndices[0]) ||
	                        !allowFreeform ||
	                        text !== prevProps.text ||
	                        value !== prevProps.value)))) {
	            this._select();
	        }
	        this._notifyPendingValueChanged(prevState);
	        if (isOpen && !prevState.isOpen && onMenuOpen) {
	            onMenuOpen();
	        }
	        if (!isOpen && prevState.isOpen && onMenuDismissed) {
	            onMenuDismissed();
	        }
	    };
	    ComboBox.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	        // remove the eventHanlder that was added in componentDidMount
	        this._events.off(this._comboBoxWrapper.current);
	    };
	    // Primary Render
	    ComboBox.prototype.render = function () {
	        var _this = this;
	        var id = this._id;
	        var _a = this.props, className = _a.className, label = _a.label, disabled = _a.disabled, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, required = _a.required, errorMessage = _a.errorMessage, _b = _a.onRenderContainer, onRenderContainer = _b === void 0 ? this._onRenderContainer : _b, _c = _a.onRenderList, onRenderList = _c === void 0 ? this._onRenderList : _c, _d = _a.onRenderItem, onRenderItem = _d === void 0 ? this._onRenderItem : _d, _e = _a.onRenderOption, onRenderOption = _e === void 0 ? this._onRenderOptionContent : _e, allowFreeform = _a.allowFreeform, buttonIconProps = _a.buttonIconProps, _f = _a.isButtonAriaHidden, isButtonAriaHidden = _f === void 0 ? true : _f, customStyles = _a.styles, theme = _a.theme, title = _a.title, keytipProps = _a.keytipProps, placeholder = _a.placeholder, tabIndex = _a.tabIndex, autofill = _a.autofill, persistMenu = _a.persistMenu;
	        var _g = this.state, isOpen = _g.isOpen, focused = _g.focused, suggestedDisplayValue = _g.suggestedDisplayValue;
	        this._currentVisibleValue = this._getVisibleValue();
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['onChange', 'value']);
	        var hasErrorMessage = errorMessage && errorMessage.length > 0 ? true : false;
	        this._classNames = this.props.getClassNames
	            ? this.props.getClassNames(theme, !!isOpen, !!disabled, !!required, !!focused, !!allowFreeform, !!hasErrorMessage, className)
	            : ComboBox_classNames_1.getClassNames(ComboBox_styles_1.getStyles(theme, customStyles), className, !!isOpen, !!disabled, !!required, !!focused, !!allowFreeform, !!hasErrorMessage);
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { ref: this._root, className: this._classNames.container }),
	            label && (React.createElement(Label_1.Label, { id: id + '-label', disabled: disabled, required: required, htmlFor: id + '-input', className: this._classNames.label }, label)),
	            React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (React.createElement("div", { "data-ktp-target": keytipAttributes['data-ktp-target'], ref: _this._comboBoxWrapper, id: id + 'wrapper', className: _this._classNames.root },
	                React.createElement(index_1.Autofill, tslib_1.__assign({ "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'], "data-is-interactable": !disabled, componentRef: _this._autofill, id: id + '-input', className: _this._classNames.input, type: "text", onFocus: _this._select, onBlur: _this._onBlur, onKeyDown: _this._onInputKeyDown, onKeyUp: _this._onInputKeyUp, onClick: _this._onAutofillClick, onTouchStart: _this._onTouchStart, onInputValueChange: _this._onInputChange, "aria-expanded": isOpen, "aria-autocomplete": _this._getAriaAutoCompleteValue(), role: "combobox", readOnly: disabled || !allowFreeform, "aria-labelledby": label && id + '-label', "aria-label": ariaLabel && !label ? ariaLabel : undefined, "aria-describedby": Utilities_1.mergeAriaAttributeValues(ariaDescribedBy, keytipAttributes['aria-describedby']), "aria-activedescendant": _this._getAriaActiveDescentValue(), "aria-required": required, "aria-disabled": disabled, "aria-owns": isOpen ? id + '-list' : undefined, spellCheck: false, defaultVisibleValue: _this._currentVisibleValue, suggestedDisplayValue: suggestedDisplayValue, updateValueInWillReceiveProps: _this._onUpdateValueInAutofillWillReceiveProps, shouldSelectFullInputValueInComponentDidUpdate: _this._onShouldSelectFullInputValueInAutofillComponentDidUpdate, title: title, preventValueSelection: !focused, placeholder: placeholder, tabIndex: tabIndex }, autofill)),
	                React.createElement(Button_1.IconButton, { className: 'ms-ComboBox-CaretDown-button', styles: _this._getCaretButtonStyles(), role: "presentation", "aria-hidden": isButtonAriaHidden, "data-is-focusable": false, tabIndex: -1, onClick: _this._onComboBoxClick, onBlur: _this._onBlur, iconProps: buttonIconProps, disabled: disabled, checked: isOpen }))); }),
	            (persistMenu || isOpen) &&
	                onRenderContainer(tslib_1.__assign({}, this.props, { onRenderList: onRenderList,
	                    onRenderItem: onRenderItem,
	                    onRenderOption: onRenderOption, options: this.state.currentOptions.map(function (item, index) { return (tslib_1.__assign({}, item, { index: index })); }) }), this._onRenderContainer),
	            errorMessage && React.createElement("div", { className: this._classNames.errorMessage }, errorMessage)));
	    };
	    /**
	     * Is the index within the bounds of the array?
	     * @param options - options to check if the index is valid for
	     * @param index - the index to check
	     * @returns - true if the index is valid for the given options, false otherwise
	     */
	    ComboBox.prototype._indexWithinBounds = function (options, index) {
	        if (!options) {
	            return false;
	        }
	        return index >= 0 && index < options.length;
	    };
	    /**
	     * Process the new input's new value when the comboBox
	     * allows freeform entry
	     * @param updatedValue - the input's newly changed value
	     */
	    ComboBox.prototype._processInputChangeWithFreeform = function (updatedValue) {
	        var _this = this;
	        var currentOptions = this.state.currentOptions;
	        updatedValue = this._removeZeroWidthSpaces(updatedValue);
	        var newCurrentPendingValueValidIndex = -1;
	        // if the new value is empty, see if we have an exact match
	        // and then set the pending info
	        if (updatedValue === '') {
	            var items = currentOptions
	                .map(function (item, index) {
	                return tslib_1.__assign({}, item, { index: index });
	            })
	                .filter(function (option) { return option.itemType !== index_2.SelectableOptionMenuItemType.Header && option.itemType !== index_2.SelectableOptionMenuItemType.Divider; })
	                .filter(function (option) { return _this._getPreviewText(option) === updatedValue; });
	            // if we found a match remember the index
	            if (items.length === 1) {
	                newCurrentPendingValueValidIndex = items[0].index;
	            }
	            this._setPendingInfo(updatedValue, newCurrentPendingValueValidIndex, updatedValue);
	            return;
	        }
	        // Remember the original value and then,
	        // make the value lowercase for comparison
	        var originalUpdatedValue = updatedValue;
	        updatedValue = updatedValue.toLocaleLowerCase();
	        var newSuggestedDisplayValue = '';
	        // If autoComplete is on, attempt to find a match from the available options
	        if (this.props.autoComplete === 'on') {
	            // If autoComplete is on, attempt to find a match where the text of an option starts with the updated value
	            var items = currentOptions
	                .map(function (item, index) {
	                return tslib_1.__assign({}, item, { index: index });
	            })
	                .filter(function (option) { return option.itemType !== index_2.SelectableOptionMenuItemType.Header && option.itemType !== index_2.SelectableOptionMenuItemType.Divider; })
	                .filter(function (option) {
	                return _this._getPreviewText(option)
	                    .toLocaleLowerCase()
	                    .indexOf(updatedValue) === 0;
	            });
	            if (items.length > 0) {
	                // use ariaLabel as the value when the option is set
	                var text = this._getPreviewText(items[0]);
	                // If the user typed out the complete option text, we don't need any suggested display text anymore
	                newSuggestedDisplayValue = text.toLocaleLowerCase() !== updatedValue ? text : '';
	                // remember the index of the match we found
	                newCurrentPendingValueValidIndex = items[0].index;
	            }
	        }
	        else {
	            // If autoComplete is off, attempt to find a match only when the value is exactly equal to the text of an option
	            var items = currentOptions
	                .map(function (item, index) {
	                return tslib_1.__assign({}, item, { index: index });
	            })
	                .filter(function (option) { return option.itemType !== index_2.SelectableOptionMenuItemType.Header && option.itemType !== index_2.SelectableOptionMenuItemType.Divider; })
	                .filter(function (option) { return _this._getPreviewText(option).toLocaleLowerCase() === updatedValue; });
	            // if we found a match remember the index
	            if (items.length === 1) {
	                newCurrentPendingValueValidIndex = items[0].index;
	            }
	        }
	        // Set the updated state
	        this._setPendingInfo(originalUpdatedValue, newCurrentPendingValueValidIndex, newSuggestedDisplayValue);
	    };
	    /**
	     * Process the new input's new value when the comboBox
	     * does not allow freeform entry
	     * @param updatedValue - the input's newly changed value
	     */
	    ComboBox.prototype._processInputChangeWithoutFreeform = function (updatedValue) {
	        var _this = this;
	        var _a = this.state, currentPendingValue = _a.currentPendingValue, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentOptions = _a.currentOptions;
	        updatedValue = this._removeZeroWidthSpaces(updatedValue);
	        if (this.props.autoComplete === 'on') {
	            // If autoComplete is on while allow freeform is off,
	            // we will remember the keypresses and build up a string to attempt to match
	            // as long as characters are typed within a the timeout span of each other,
	            // otherwise we will clear the string and start building a new one on the next keypress.
	            // Also, only do this processing if we have a non-empty value
	            if (updatedValue !== '') {
	                // If we have a pending autocomplete clearing task,
	                // we know that the user is typing with keypresses happening
	                // within the timeout of each other so remove the clearing task
	                // and continue building the pending value with the udpated value
	                if (this._lastReadOnlyAutoCompleteChangeTimeoutId !== undefined) {
	                    this._async.clearTimeout(this._lastReadOnlyAutoCompleteChangeTimeoutId);
	                    this._lastReadOnlyAutoCompleteChangeTimeoutId = undefined;
	                    updatedValue = this._normalizeToString(currentPendingValue) + updatedValue;
	                }
	                var originalUpdatedValue = updatedValue;
	                updatedValue = updatedValue.toLocaleLowerCase();
	                // If autoComplete is on, attempt to find a match where the text of an option starts with the updated value
	                var items = currentOptions
	                    .map(function (item, i) {
	                    return tslib_1.__assign({}, item, { index: i });
	                })
	                    .filter(function (option) { return option.itemType !== index_2.SelectableOptionMenuItemType.Header && option.itemType !== index_2.SelectableOptionMenuItemType.Divider; })
	                    .filter(function (option) { return option.text.toLocaleLowerCase().indexOf(updatedValue) === 0; });
	                // If we found a match, udpdate the state
	                if (items.length > 0) {
	                    this._setPendingInfo(originalUpdatedValue, items[0].index, this._getPreviewText(items[0]));
	                }
	                // Schedule a timeout to clear the pending value after the timeout span
	                this._lastReadOnlyAutoCompleteChangeTimeoutId = this._async.setTimeout(function () {
	                    _this._lastReadOnlyAutoCompleteChangeTimeoutId = undefined;
	                }, ReadOnlyPendingAutoCompleteTimeout);
	                return;
	            }
	        }
	        // If we get here, either autoComplete is on or we did not find a match with autoComplete on.
	        // Remember we are not allowing freeform, so at this point, if we have a pending valid value index
	        // use that; otherwise use the selectedIndex
	        var index = currentPendingValueValidIndex >= 0 ? currentPendingValueValidIndex : this._getFirstSelectedIndex();
	        // Since we are not allowing freeform, we need to
	        // set both the pending and suggested values/index
	        // to allow us to select all content in the input to
	        // give the illusion that we are readonly (e.g. freeform off)
	        this._setPendingInfoFromIndex(index);
	    };
	    ComboBox.prototype._getFirstSelectedIndex = function () {
	        return this.state.selectedIndices && this.state.selectedIndices.length > 0 ? this.state.selectedIndices[0] : -1;
	    };
	    /**
	     * Walk along the options starting at the index, stepping by the delta (positive or negative)
	     * looking for the next valid selectable index (e.g. skipping headings and dividers)
	     * @param index - the index to get the next selectable index from
	     * @param delta - optional delta to step by when finding the next index, defaults to 0
	     * @returns - the next valid selectable index. If the new index is outside of the bounds,
	     * it will snap to the edge of the options array. If delta == 0 and the given index is not selectable
	     */
	    ComboBox.prototype._getNextSelectableIndex = function (index, searchDirection) {
	        var currentOptions = this.state.currentOptions;
	        var newIndex = index + searchDirection;
	        newIndex = Math.max(0, Math.min(currentOptions.length - 1, newIndex));
	        if (!this._indexWithinBounds(currentOptions, newIndex)) {
	            return -1;
	        }
	        var option = currentOptions[newIndex];
	        // attempt to skip headers and dividers
	        if (option.itemType === index_2.SelectableOptionMenuItemType.Header || option.itemType === index_2.SelectableOptionMenuItemType.Divider) {
	            // Should we continue looking for an index to select?
	            if (searchDirection !== SearchDirection.none &&
	                ((newIndex > 0 && searchDirection < SearchDirection.none) ||
	                    (newIndex >= 0 && newIndex < currentOptions.length && searchDirection > SearchDirection.none))) {
	                newIndex = this._getNextSelectableIndex(newIndex, searchDirection);
	            }
	            else {
	                // If we cannot perform a useful search just return the index we were given
	                return index;
	            }
	        }
	        // We have the next valid selectable index, return it
	        return newIndex;
	    };
	    /**
	     * Set the selected index. Note, this is
	     * the "real" selected index, not the pending selected index
	     * @param index - the index to set (or the index to set from if a search direction is provided)
	     * @param searchDirection - the direction to search along the options from the given index
	     */
	    ComboBox.prototype._setSelectedIndex = function (index, submitPendingValueEvent, searchDirection) {
	        var _this = this;
	        if (searchDirection === void 0) { searchDirection = SearchDirection.none; }
	        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged, onPendingValueChanged = _a.onPendingValueChanged;
	        var currentOptions = this.state.currentOptions;
	        var selectedIndices = this.state.selectedIndices;
	        if (!selectedIndices) {
	            selectedIndices = [];
	        }
	        // Find the next selectable index, if searchDirection is none
	        // we will get our starting index back
	        index = this._getNextSelectableIndex(index, searchDirection);
	        if (!this._indexWithinBounds(currentOptions, index)) {
	            return;
	        }
	        // Are we at a new index? If so, update the state, otherwise
	        // there is nothing to do
	        if (this.props.multiSelect || selectedIndices.length < 1 || (selectedIndices.length === 1 && selectedIndices[0] !== index)) {
	            var option_1 = currentOptions[index];
	            if (!option_1) {
	                return;
	            }
	            if (this.props.multiSelect) {
	                // Setting the initial state of option.selected in Multi-select combobox by checking the
	                // selectedIndices array and overriding the undefined issue
	                option_1.selected = option_1.selected !== undefined ? !option_1.selected : selectedIndices.indexOf(index) < 0;
	                if (option_1.selected && selectedIndices.indexOf(index) < 0) {
	                    selectedIndices.push(index);
	                }
	                else if (!option_1.selected && selectedIndices.indexOf(index) >= 0) {
	                    selectedIndices = selectedIndices.filter(function (value) { return value !== index; });
	                }
	            }
	            else {
	                selectedIndices[0] = index;
	            }
	            submitPendingValueEvent.persist();
	            // Call onChange after state is updated
	            this.setState({
	                selectedIndices: selectedIndices
	            }, function () {
	                // If ComboBox value is changed, revert preview first
	                if (_this._hasPendingValue && onPendingValueChanged) {
	                    onPendingValueChanged();
	                    _this._hasPendingValue = false;
	                }
	                if (onChange) {
	                    onChange(submitPendingValueEvent, option_1, index, undefined);
	                }
	                if (onChanged) {
	                    onChanged(option_1, index, undefined, submitPendingValueEvent);
	                }
	            });
	        }
	        // clear all of the pending info
	        this._clearPendingInfo();
	    };
	    /**
	     * Submit a pending value if there is one
	     */
	    ComboBox.prototype._submitPendingValue = function (submitPendingValueEvent) {
	        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
	        var _b = this.state, currentPendingValue = _b.currentPendingValue, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentOptions = _b.currentOptions, currentPendingValueValidIndexOnHover = _b.currentPendingValueValidIndexOnHover;
	        var selectedIndices = this.state.selectedIndices;
	        // Do not submit any pending value if we
	        // have already initiated clearing the pending info
	        if (this._processingClearPendingInfo) {
	            return;
	        }
	        // If we allow freeform we need to handle that
	        if (allowFreeform) {
	            // if currentPendingValue is null or undefined the user did not submit anything
	            // (not even empty because we would have stored that as the pending value)
	            if (currentPendingValue === null || currentPendingValue === undefined) {
	                // if a user did not type anything they may just hovered over an item
	                if (currentPendingValueValidIndexOnHover >= 0) {
	                    this._setSelectedIndex(currentPendingValueValidIndexOnHover, submitPendingValueEvent);
	                    this._clearPendingInfo();
	                }
	                return;
	            }
	            // Check to see if the user typed an exact match
	            if (this._indexWithinBounds(currentOptions, currentPendingValueValidIndex)) {
	                var pendingOptionText = this._getPreviewText(currentOptions[currentPendingValueValidIndex]).toLocaleLowerCase();
	                // By exact match, that means: our pending value is the same as the the pending option text OR
	                // the pending option starts with the pending value and we have an "autoComplete" selection
	                // where the total length is equal to pending option length OR
	                // the live value in the underlying input matches the pending option; update the state
	                if (currentPendingValue.toLocaleLowerCase() === pendingOptionText ||
	                    ((autoComplete &&
	                        pendingOptionText.indexOf(currentPendingValue.toLocaleLowerCase()) === 0 &&
	                        (this._autofill.current &&
	                            this._autofill.current.isValueSelected &&
	                            currentPendingValue.length + (this._autofill.current.selectionEnd - this._autofill.current.selectionStart) ===
	                                pendingOptionText.length)) ||
	                        (this._autofill.current &&
	                            this._autofill.current.inputElement &&
	                            this._autofill.current.inputElement.value.toLocaleLowerCase() === pendingOptionText))) {
	                    this._setSelectedIndex(currentPendingValueValidIndex, submitPendingValueEvent);
	                    this._clearPendingInfo();
	                    return;
	                }
	            }
	            if (onChange || onChanged) {
	                if (onChange) {
	                    // trigger onChange to clear value
	                    onChange(submitPendingValueEvent, undefined, undefined, currentPendingValue);
	                }
	                if (onChanged) {
	                    // trigger onChanged to clear value
	                    onChanged(undefined, undefined, currentPendingValue, submitPendingValueEvent);
	                }
	            }
	            else {
	                // If we are not controlled, create a new option
	                var newOption = {
	                    key: currentPendingValue || Utilities_1.getId(),
	                    text: this._normalizeToString(currentPendingValue)
	                };
	                var newOptions = currentOptions.concat([newOption]);
	                if (selectedIndices) {
	                    if (!this.props.multiSelect) {
	                        selectedIndices = [];
	                    }
	                    selectedIndices.push(newOptions.length - 1);
	                }
	                this.setState({
	                    currentOptions: newOptions,
	                    selectedIndices: selectedIndices
	                });
	            }
	        }
	        else if (currentPendingValueValidIndex >= 0) {
	            // Since we are not allowing freeform, we must have a matching
	            // to be able to update state
	            this._setSelectedIndex(currentPendingValueValidIndex, submitPendingValueEvent);
	        }
	        else if (currentPendingValueValidIndexOnHover >= 0) {
	            // If all else failed and we were hovering over an item, select it
	            this._setSelectedIndex(currentPendingValueValidIndexOnHover, submitPendingValueEvent);
	        }
	        // Finally, clear the pending info
	        this._clearPendingInfo();
	    };
	    ComboBox.prototype._onCalloutLayerMounted = function () {
	        // In persistMenu mode _onLayerMounted is only called once for the lifetime
	        // of the component. Any functionality required for callout "on mount" can
	        // go here so that we can also call it again during callout dismissal to reset
	        // object state.
	        this._gotMouseMove = false;
	    };
	    // Render separator
	    ComboBox.prototype._renderSeparator = function (item) {
	        var index = item.index, key = item.key;
	        if (index && index > 0) {
	            return React.createElement("div", { role: "separator", key: key, className: this._classNames.divider });
	        }
	        return null;
	    };
	    ComboBox.prototype._renderHeader = function (item) {
	        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOptionContent : _a;
	        return (React.createElement("div", { key: item.key, className: this._classNames.header }, onRenderOption(item, this._onRenderOptionContent)));
	    };
	    /**
	     * If we are coming from a mouseOut:
	     * there is no visible selected option.
	     *
	     * Else if We are hovering over an item:
	     * that gets the selected look.
	     *
	     * Else:
	     * Use the current valid pending index if it exists OR
	     * we do not have a valid index and we currently have a pending input value,
	     * otherwise use the selected index
	     * */
	    ComboBox.prototype._isOptionSelected = function (index) {
	        var currentPendingValueValidIndexOnHover = this.state.currentPendingValueValidIndexOnHover;
	        // If the hover state is set to clearAll, don't show a selected index.
	        // Note, this happens when the user moused out of the menu items
	        if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
	            return false;
	        }
	        if (!this.props.multiSelect && this._getPendingSelectedIndex(true /* includePendingValue */) === index) {
	            return true;
	        }
	        var idxOfSelectedIndex = -1;
	        if (this.props.multiSelect && index !== undefined && this.state.selectedIndices) {
	            idxOfSelectedIndex = this.state.selectedIndices.indexOf(index);
	        }
	        return idxOfSelectedIndex >= 0;
	    };
	    /**
	     * Gets the pending selected index taking into account hover, valueValidIndex, and selectedIndex
	     * @param includeCurrentPendingValue - Should we include the currentPendingValue when
	     * finding the index
	     */
	    ComboBox.prototype._getPendingSelectedIndex = function (includeCurrentPendingValue) {
	        var _a = this.state, currentPendingValueValidIndexOnHover = _a.currentPendingValueValidIndexOnHover, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentPendingValue = _a.currentPendingValue;
	        return currentPendingValueValidIndexOnHover >= 0
	            ? currentPendingValueValidIndexOnHover
	            : currentPendingValueValidIndex >= 0 ||
	                (includeCurrentPendingValue && (currentPendingValue !== null && currentPendingValue !== undefined))
	                ? currentPendingValueValidIndex
	                : this.props.multiSelect
	                    ? 0
	                    : this._getFirstSelectedIndex();
	    };
	    /**
	     * Scroll the selected element into view
	     */
	    ComboBox.prototype._scrollIntoView = function () {
	        var _a = this.props, onScrollToItem = _a.onScrollToItem, scrollSelectedToTop = _a.scrollSelectedToTop;
	        var _b = this.state, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentPendingValue = _b.currentPendingValue;
	        if (onScrollToItem) {
	            // Use the custom scroll handler
	            onScrollToItem(currentPendingValueValidIndex >= 0 || currentPendingValue !== '' ? currentPendingValueValidIndex : this._getFirstSelectedIndex());
	        }
	        else if (this._selectedElement.current && this._selectedElement.current.offsetParent) {
	            // We are using refs, scroll the ref into view
	            if (scrollSelectedToTop) {
	                this._selectedElement.current.offsetParent.scrollIntoView(true);
	            }
	            else {
	                var alignToTop = true;
	                if (this._comboBoxMenu.current && this._comboBoxMenu.current.offsetParent) {
	                    var scrollableParentRect = this._comboBoxMenu.current.offsetParent.getBoundingClientRect();
	                    var selectedElementRect = this._selectedElement.current.offsetParent.getBoundingClientRect();
	                    // If we are completely in view then we do not need to scroll
	                    if (scrollableParentRect.top <= selectedElementRect.top &&
	                        scrollableParentRect.top + scrollableParentRect.height >= selectedElementRect.top + selectedElementRect.height) {
	                        return;
	                    }
	                    // If we are lower than the scrollable parent viewport then we should align to the bottom
	                    if (scrollableParentRect.top + scrollableParentRect.height <= selectedElementRect.top + selectedElementRect.height) {
	                        alignToTop = false;
	                    }
	                }
	                this._selectedElement.current.offsetParent.scrollIntoView(alignToTop);
	            }
	        }
	    };
	    /**
	     * Click handler for the menu items
	     * to select the item and also close the menu
	     * @param index - the index of the item that was clicked
	     */
	    ComboBox.prototype._onItemClick = function (item) {
	        var _this = this;
	        var onItemClick = this.props.onItemClick;
	        var index = item.index;
	        return function (ev) {
	            onItemClick && onItemClick(ev, item, index);
	            _this._setSelectedIndex(index, ev);
	            if (!_this.props.multiSelect) {
	                // only close the callout when it's in single-select mode
	                _this.setState({
	                    isOpen: false
	                });
	            }
	        };
	    };
	    /**
	     * Get the indices of the options that are marked as selected
	     * @param options - the comboBox options
	     * @param selectedKeys - the known selected keys to find
	     * @returns - an array of the indices of the selected options, empty array if nothing is selected
	     */
	    ComboBox.prototype._getSelectedIndices = function (options, selectedKeys) {
	        if (!options || !selectedKeys) {
	            return [];
	        }
	        var selectedIndices = {};
	        options.forEach(function (option, index) {
	            if (option.selected) {
	                selectedIndices[index] = true;
	            }
	        });
	        var _loop_1 = function (selectedKey) {
	            var index = Utilities_1.findIndex(options, function (option) { return option.key === selectedKey; });
	            if (index > -1) {
	                selectedIndices[index] = true;
	            }
	        };
	        for (var _i = 0, selectedKeys_1 = selectedKeys; _i < selectedKeys_1.length; _i++) {
	            var selectedKey = selectedKeys_1[_i];
	            _loop_1(selectedKey);
	        }
	        return Object.keys(selectedIndices)
	            .map(Number)
	            .sort();
	    };
	    /**
	     * Reset the selected index by clearing the
	     * input (of any pending text), clearing the pending state,
	     * and setting the suggested display value to the last
	     * selected state text
	     */
	    ComboBox.prototype._resetSelectedIndex = function () {
	        var currentOptions = this.state.currentOptions;
	        this._clearPendingInfo();
	        var selectedIndex = this._getFirstSelectedIndex();
	        if (selectedIndex > 0 && selectedIndex < currentOptions.length) {
	            this.setState({
	                suggestedDisplayValue: currentOptions[selectedIndex].text
	            });
	        }
	        else if (this.props.text || this.props.value) {
	            // If we had a value initially, restore it
	            this.setState({
	                suggestedDisplayValue: this.props.text || this.props.value
	            });
	        }
	    };
	    /**
	     * Clears the pending info state
	     */
	    ComboBox.prototype._clearPendingInfo = function () {
	        this._processingClearPendingInfo = true;
	        this.setState({
	            currentPendingValue: undefined,
	            currentPendingValueValidIndex: -1,
	            suggestedDisplayValue: undefined,
	            currentPendingValueValidIndexOnHover: HoverStatus.default
	        }, this._onAfterClearPendingInfo);
	    };
	    /**
	     * Set the pending info
	     * @param currentPendingValue - new pending value to set
	     * @param currentPendingValueValidIndex - new pending value index to set
	     * @param suggestedDisplayValue - new suggest display value to set
	     */
	    ComboBox.prototype._setPendingInfo = function (currentPendingValue, currentPendingValueValidIndex, suggestedDisplayValue) {
	        if (currentPendingValueValidIndex === void 0) { currentPendingValueValidIndex = -1; }
	        if (this._processingClearPendingInfo) {
	            return;
	        }
	        this.setState({
	            currentPendingValue: currentPendingValue && this._removeZeroWidthSpaces(currentPendingValue),
	            currentPendingValueValidIndex: currentPendingValueValidIndex,
	            suggestedDisplayValue: suggestedDisplayValue,
	            currentPendingValueValidIndexOnHover: HoverStatus.default
	        });
	    };
	    /**
	     * Set the pending info from the given index
	     * @param index - the index to set the pending info from
	     */
	    ComboBox.prototype._setPendingInfoFromIndex = function (index) {
	        var currentOptions = this.state.currentOptions;
	        if (index >= 0 && index < currentOptions.length) {
	            var option = currentOptions[index];
	            this._setPendingInfo(this._getPreviewText(option), index, this._getPreviewText(option));
	        }
	        else {
	            this._clearPendingInfo();
	        }
	    };
	    /**
	     * Sets the pending info for the comboBox
	     * @param index - the index to search from
	     * @param searchDirection - the direction to search
	     */
	    ComboBox.prototype._setPendingInfoFromIndexAndDirection = function (index, searchDirection) {
	        var currentOptions = this.state.currentOptions;
	        // update index to allow content to wrap
	        if (searchDirection === SearchDirection.forward && index >= currentOptions.length - 1) {
	            index = -1;
	        }
	        else if (searchDirection === SearchDirection.backward && index <= 0) {
	            index = currentOptions.length;
	        }
	        // get the next "valid" index
	        var indexUpdate = this._getNextSelectableIndex(index, searchDirection);
	        // if the two indicies are equal we didn't move and
	        // we should attempt to get  get the first/last "valid" index to use
	        // (Note, this takes care of the potential cases where the first/last
	        // item is not focusable), otherwise use the updated index
	        if (index === indexUpdate) {
	            if (searchDirection === SearchDirection.forward) {
	                index = this._getNextSelectableIndex(-1, searchDirection);
	            }
	            else if (searchDirection === SearchDirection.backward) {
	                index = this._getNextSelectableIndex(currentOptions.length, searchDirection);
	            }
	        }
	        else {
	            index = indexUpdate;
	        }
	        if (this._indexWithinBounds(currentOptions, index)) {
	            this._setPendingInfoFromIndex(index);
	        }
	    };
	    ComboBox.prototype._notifyPendingValueChanged = function (prevState) {
	        var onPendingValueChanged = this.props.onPendingValueChanged;
	        if (!onPendingValueChanged) {
	            return;
	        }
	        var _a = this.state, currentPendingValue = _a.currentPendingValue, currentOptions = _a.currentOptions, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentPendingValueValidIndexOnHover = _a.currentPendingValueValidIndexOnHover;
	        var newPendingIndex = undefined;
	        var newPendingValue = undefined;
	        if (currentPendingValueValidIndexOnHover !== prevState.currentPendingValueValidIndexOnHover &&
	            this._indexWithinBounds(currentOptions, currentPendingValueValidIndexOnHover)) {
	            // Set new pending index if hover index was changed
	            newPendingIndex = currentPendingValueValidIndexOnHover;
	        }
	        else if (currentPendingValueValidIndex !== prevState.currentPendingValueValidIndex &&
	            this._indexWithinBounds(currentOptions, currentPendingValueValidIndex)) {
	            // Set new pending index if currentPendingValueValidIndex was changed
	            newPendingIndex = currentPendingValueValidIndex;
	        }
	        else if (currentPendingValue !== prevState.currentPendingValue) {
	            // Set pendingValue in the case it was changed and no index was changed
	            newPendingValue = currentPendingValue;
	        }
	        // Notify when there is a new pending index/value. Also, if there is a pending value, it needs to send undefined.
	        if (newPendingIndex !== undefined || newPendingValue !== undefined || this._hasPendingValue) {
	            onPendingValueChanged(newPendingIndex !== undefined ? currentOptions[newPendingIndex] : undefined, newPendingIndex, newPendingValue);
	            this._hasPendingValue = newPendingIndex !== undefined || newPendingValue !== undefined;
	        }
	    };
	    /**
	     * Sets the isOpen state and updates focusInputAfterClose
	     */
	    ComboBox.prototype._setOpenStateAndFocusOnClose = function (isOpen, focusInputAfterClose) {
	        this._focusInputAfterClose = focusInputAfterClose;
	        this.setState({
	            isOpen: isOpen
	        });
	    };
	    /**
	     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
	     */
	    ComboBox.prototype._isAltOrMeta = function (ev) {
	        return ev.which === Utilities_1.KeyCodes.alt || ev.key === 'Meta';
	    };
	    ComboBox.prototype._onOptionMouseEnter = function (index) {
	        if (this._shouldIgnoreMouseEvent()) {
	            return;
	        }
	        this.setState({
	            currentPendingValueValidIndexOnHover: index
	        });
	    };
	    ComboBox.prototype._onOptionMouseMove = function (index) {
	        this._gotMouseMove = true;
	        if (!this._isScrollIdle || this.state.currentPendingValueValidIndexOnHover === index) {
	            return;
	        }
	        this.setState({
	            currentPendingValueValidIndexOnHover: index
	        });
	    };
	    ComboBox.prototype._shouldIgnoreMouseEvent = function () {
	        return !this._isScrollIdle || !this._gotMouseMove;
	    };
	    /**
	     * Handle dismissing the menu and
	     * eating the required key event when disabled
	     * @param ev - the keyboard event that was fired
	     */
	    ComboBox.prototype._handleInputWhenDisabled = function (ev) {
	        // If we are disabled, close the menu (if needed)
	        // and eat all keystokes other than TAB or ESC
	        if (this.props.disabled) {
	            if (this.state.isOpen) {
	                this.setState({ isOpen: false });
	            }
	            // When disabled stop propagation and prevent default
	            // of the event unless we have a tab, escape, or function key
	            if (ev !== null &&
	                ev.which !== Utilities_1.KeyCodes.tab &&
	                ev.which !== Utilities_1.KeyCodes.escape &&
	                (ev.which < 112 /* F1 */ || ev.which > 123) /* F12 */) {
	                ev.stopPropagation();
	                ev.preventDefault();
	            }
	        }
	    };
	    ComboBox.prototype._handleTouchAndPointerEvent = function () {
	        var _this = this;
	        // If we already have an existing timeeout from a previous touch and pointer event
	        // cancel that timeout so we can set a nwe one.
	        if (this._lastTouchTimeoutId !== undefined) {
	            this._async.clearTimeout(this._lastTouchTimeoutId);
	            this._lastTouchTimeoutId = undefined;
	        }
	        this._processingTouch = true;
	        this._lastTouchTimeoutId = this._async.setTimeout(function () {
	            _this._processingTouch = false;
	            _this._lastTouchTimeoutId = undefined;
	        }, TouchIdleDelay);
	    };
	    /**
	     * Get the styles for the current option.
	     * @param item - Item props for the current option
	     */
	    ComboBox.prototype._getCaretButtonStyles = function () {
	        var customCaretDownButtonStyles = this.props.caretDownButtonStyles;
	        return ComboBox_styles_1.getCaretDownButtonStyles(this.props.theme, customCaretDownButtonStyles);
	    };
	    /**
	     * Get the styles for the current option.
	     * @param item - Item props for the current option
	     */
	    ComboBox.prototype._getCurrentOptionStyles = function (item) {
	        var customStylesForAllOptions = this.props.comboBoxOptionStyles;
	        var customStylesForCurrentOption = item.styles;
	        return ComboBox_styles_1.getOptionStyles(this.props.theme, customStylesForAllOptions, customStylesForCurrentOption, this._isPendingOption(item), item.hidden);
	    };
	    /**
	     * Get the aria-activedescendant value for the comboxbox.
	     * @returns the id of the current focused combo item, otherwise the id of the currently selected element, null otherwise
	     */
	    ComboBox.prototype._getAriaActiveDescentValue = function () {
	        var descendantText = this.state.isOpen && this.state.selectedIndices && this.state.selectedIndices.length >= 0
	            ? this._id + '-list' + this.state.selectedIndices[0]
	            : undefined;
	        if (this.state.isOpen && this.state.focused && this.state.currentPendingValueValidIndex !== -1) {
	            descendantText = this._id + '-list' + this.state.currentPendingValueValidIndex;
	        }
	        return descendantText;
	    };
	    /**
	     * Get the aria autocomplete value for the Combobox
	     * @returns 'inline' if auto-complete automatically dynamic, 'both' if we have a list of possible values to pick from and can
	     * dynamically populate input, and 'none' if auto-complete is not enabled as we can't give user inputs.
	     */
	    ComboBox.prototype._getAriaAutoCompleteValue = function () {
	        var autoComplete = !this.props.disabled && this.props.autoComplete === 'on';
	        return autoComplete ? (this.props.allowFreeform ? 'inline' : 'both') : 'none';
	    };
	    ComboBox.prototype._isPendingOption = function (item) {
	        return item && item.index === this.state.currentPendingValueValidIndex;
	    };
	    /**
	     * Given default selected key(s) and selected key(s), return the selected keys(s).
	     * When default selected key(s) are available, they take precedence and return them instead of selected key(s).
	     *
	     * @returns No matter what specific types the input parameters are, always return an array of
	     *  either strings or numbers instead of premitive type.  This normlization makes caller's logic easier.
	     */
	    ComboBox.prototype._buildDefaultSelectedKeys = function (defaultSelectedKey, selectedKey) {
	        var selectedKeys = this._buildSelectedKeys(defaultSelectedKey);
	        if (selectedKeys.length) {
	            return selectedKeys;
	        }
	        return this._buildSelectedKeys(selectedKey);
	    };
	    ComboBox.prototype._buildSelectedKeys = function (selectedKey) {
	        if (selectedKey === undefined) {
	            return [];
	        }
	        // need to cast here so typescript does not complain
	        return (selectedKey instanceof Array ? selectedKey : [selectedKey]);
	    };
	    // For scenarios where the option's text prop contains embedded styles, we use the option's
	    // ariaLabel value as the text in the input and for autocomplete matching. We know to use this
	    // when the useAriaLabelAsText prop is set to true
	    ComboBox.prototype._getPreviewText = function (item) {
	        return item.useAriaLabelAsText && item.ariaLabel ? item.ariaLabel : item.text;
	    };
	    ComboBox.prototype._normalizeToString = function (value) {
	        return value || '';
	    };
	    ComboBox.prototype._removeZeroWidthSpaces = function (value) {
	        // remove any zero width space characters
	        return value.replace(RegExp('​', 'g'), '');
	    };
	    ComboBox.defaultProps = {
	        options: [],
	        allowFreeform: false,
	        autoComplete: 'on',
	        buttonIconProps: { iconName: 'ChevronDown' }
	    };
	    ComboBox = tslib_1.__decorate([
	        Utilities_1.customizable('ComboBox', ['theme', 'styles'], true)
	    ], ComboBox);
	    return ComboBox;
	}(Utilities_1.BaseComponent));
	exports.ComboBox = ComboBox;
	//# sourceMappingURL=ComboBox.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var ComboBoxHeight = '32px';
	var ComboBoxLineHeight = '30px';
	var ComboxBoxCaretDownWidth = '32px';
	var ComboBoxOptionHeight = '32px';
	var getDisabledStyles = Utilities_1.memoizeFunction(function (theme) {
	    var semanticColors = theme.semanticColors;
	    return {
	        backgroundColor: semanticColors.disabledBackground,
	        borderColor: semanticColors.disabledBackground,
	        color: semanticColors.disabledText,
	        cursor: 'default',
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                borderColor: 'GrayText',
	                color: 'GrayText'
	            },
	            _a)
	    };
	    var _a;
	});
	var getListOptionHighContrastStyles = Utilities_1.memoizeFunction(function (theme) {
	    return {
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                backgroundColor: 'Highlight',
	                borderColor: 'Highlight',
	                color: 'HighlightText',
	                MsHighContrastAdjust: 'none'
	            },
	            _a)
	    };
	    var _a;
	});
	exports.getOptionStyles = Utilities_1.memoizeFunction(function (theme, customStylesForAllOptions, customOptionStylesForCurrentOption, isPending, isHidden) {
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var ComboBoxOptionBackgroundHovered = semanticColors.menuItemBackgroundHovered;
	    var ComboBoxOptionTextColorHovered = semanticColors.bodyText;
	    var ComboBoxOptionTextColorSelected = palette.black;
	    var ComboBoxOptionTextColorDisabled = semanticColors.disabledText;
	    var ComboBoxOptionBackgroundDisabled = semanticColors.bodyBackground;
	    var optionStyles = {
	        root: [
	            theme.fonts.medium,
	            {
	                backgroundColor: isPending ? ComboBoxOptionBackgroundHovered : 'transparent',
	                boxSizing: 'border-box',
	                cursor: 'pointer',
	                display: isHidden ? 'none' : 'block',
	                width: '100%',
	                height: 'auto',
	                minHeight: ComboBoxOptionHeight,
	                lineHeight: '20px',
	                padding: '5px 16px',
	                position: 'relative',
	                borderWidth: '1px',
	                borderStyle: 'solid',
	                borderColor: 'transparent',
	                wordWrap: 'break-word',
	                overflowWrap: 'break-word',
	                textAlign: 'left',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Background'
	                    },
	                    _a)
	            }
	        ],
	        rootHovered: {
	            backgroundColor: ComboBoxOptionBackgroundHovered,
	            color: ComboBoxOptionTextColorHovered
	        },
	        rootFocused: {
	            backgroundColor: ComboBoxOptionBackgroundHovered
	        },
	        rootChecked: [
	            {
	                backgroundColor: ComboBoxOptionBackgroundHovered,
	                color: ComboBoxOptionTextColorSelected
	            },
	            Styling_1.getFocusStyle(theme, { isFocusedOnly: false }),
	            getListOptionHighContrastStyles(theme)
	        ],
	        rootDisabled: {
	            backgroundColor: ComboBoxOptionBackgroundDisabled,
	            color: ComboBoxOptionTextColorDisabled,
	            cursor: 'default',
	            selectors: {
	                '& .ms-Button-flexContainer': {
	                    justifyContent: 'flex-start'
	                }
	            }
	        },
	        optionText: {
	            overflow: 'hidden',
	            whiteSpace: 'nowrap',
	            textOverflow: 'ellipsis',
	            minWidth: '0px',
	            maxWidth: '100%',
	            wordWrap: 'break-word',
	            overflowWrap: 'break-word',
	            margin: '1px',
	            display: 'inline-block'
	        },
	        optionTextWrapper: {
	            maxWidth: '100%'
	        }
	    };
	    return Styling_1.concatStyleSets(optionStyles, customStylesForAllOptions, customOptionStylesForCurrentOption);
	    var _a;
	});
	exports.getCaretDownButtonStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
	    var semanticColors = theme.semanticColors;
	    var caretButtonTextColor = semanticColors.bodySubtext;
	    var caretButtonTextColorHoveredChecked = semanticColors.buttonTextChecked;
	    var caretButtonBackgroundHovered = semanticColors.listItemBackgroundHovered;
	    var caretButtonBackgroundChecked = semanticColors.listItemBackgroundChecked;
	    var caretButtonBackgroundCheckedHovered = semanticColors.listItemBackgroundCheckedHovered;
	    var styles = {
	        root: {
	            color: caretButtonTextColor,
	            fontSize: Styling_1.FontSizes.small,
	            position: 'absolute',
	            // The negative positioning accounts for the 1px root border now that box-sizing is border-box
	            top: '-1px',
	            right: '-1px',
	            height: ComboBoxHeight,
	            lineHeight: ComboBoxLineHeight,
	            width: ComboxBoxCaretDownWidth,
	            textAlign: 'center',
	            cursor: 'default',
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'ButtonFace',
	                    borderColor: 'ButtonText',
	                    color: 'ButtonText',
	                    MsHighContrastAdjust: 'none'
	                },
	                _a)
	        },
	        icon: {
	            fontSize: Styling_1.FontSizes.small
	        },
	        rootHovered: {
	            backgroundColor: caretButtonBackgroundHovered,
	            color: caretButtonTextColorHoveredChecked,
	            cursor: 'pointer'
	        },
	        rootPressed: {
	            backgroundColor: caretButtonBackgroundChecked,
	            color: caretButtonTextColorHoveredChecked
	        },
	        rootChecked: {
	            backgroundColor: caretButtonBackgroundChecked,
	            color: caretButtonTextColorHoveredChecked
	        },
	        rootCheckedHovered: {
	            backgroundColor: caretButtonBackgroundCheckedHovered,
	            color: caretButtonTextColorHoveredChecked
	        },
	        rootDisabled: getDisabledStyles(theme)
	    };
	    return Styling_1.concatStyleSets(styles, customStyles);
	    var _a;
	});
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles, comboBoxOptionWidth) {
	    var semanticColors = theme.semanticColors, fonts = theme.fonts, palette = theme.palette;
	    var ComboBoxRootBackground = semanticColors.bodyBackground;
	    var ComboBoxRootTextColor = semanticColors.bodyText;
	    var ComboBoxRootBorderColor = semanticColors.inputBorder;
	    var ComboBoxRootBorderColorHovered = semanticColors.inputBorderHovered;
	    var ComboBoxRootBorderColorFocused = semanticColors.inputFocusBorderAlt;
	    var ComboBoxRootColorErrored = semanticColors.errorText;
	    var ComboBoxCalloutBorderColor = palette.neutralLight;
	    var ComboBoxOptionHeaderTextColor = semanticColors.menuHeader;
	    var ComboBoxOptionDividerBorderColor = semanticColors.bodyDivider;
	    // placeholder style variables
	    var placeholderStyles = {
	        color: semanticColors.inputPlaceholderText
	    };
	    var hoverPlaceholderStyles = {
	        color: palette.neutralPrimary
	    };
	    var disabledPlaceholderStyles = {
	        color: semanticColors.disabledText
	    };
	    var ComboBoxRootHighContrastFocused = {
	        color: 'HighlightText',
	        borderColor: 'Highlight',
	        backgroundColor: 'Window',
	        borderWidth: '2px',
	        MsHighContrastAdjust: 'none',
	        paddingLeft: '11px',
	        paddingTop: '0',
	        paddingBottom: '0',
	        selectors: {
	            '.ms-ComboBox-CaretDown-button': {
	                // Negative positioning to account for the 2px border
	                right: '-2px',
	                top: '-2px'
	            }
	        }
	    };
	    var styles = {
	        container: {},
	        label: {},
	        labelDisabled: {},
	        root: [
	            theme.fonts.medium,
	            {
	                boxShadow: 'none',
	                marginLeft: '0',
	                paddingTop: '1px',
	                paddingBottom: '1px',
	                paddingRight: ComboxBoxCaretDownWidth,
	                paddingLeft: '12px',
	                color: ComboBoxRootTextColor,
	                position: 'relative',
	                outline: '0',
	                userSelect: 'none',
	                backgroundColor: ComboBoxRootBackground,
	                borderWidth: '1px',
	                borderStyle: 'solid',
	                borderColor: ComboBoxRootBorderColor,
	                cursor: 'text',
	                display: 'block',
	                height: ComboBoxHeight,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis',
	                boxSizing: 'border-box',
	                selectors: {
	                    '.ms-Label': {
	                        display: 'inline-block',
	                        marginBottom: '8px'
	                    },
	                    '&.is-open': {
	                        borderColor: ComboBoxRootBorderColorFocused,
	                        selectors: (_a = {},
	                            _a[Styling_1.HighContrastSelector] = ComboBoxRootHighContrastFocused,
	                            _a)
	                    }
	                }
	            }
	        ],
	        rootHovered: {
	            borderColor: ComboBoxRootBorderColorHovered,
	            selectors: (_b = {
	                    '.ms-ComboBox-Input': [{ color: palette.neutralDark }, Styling_1.getPlaceholderStyles(hoverPlaceholderStyles)]
	                },
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'HighlightText',
	                    borderColor: 'Highlight',
	                    backgroundColor: 'Window',
	                    MsHighContrastAdjust: 'none'
	                },
	                _b)
	        },
	        rootPressed: {
	            borderColor: ComboBoxRootBorderColorFocused,
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = ComboBoxRootHighContrastFocused,
	                _c)
	        },
	        rootFocused: {
	            borderColor: ComboBoxRootBorderColorFocused,
	            selectors: (_d = {},
	                _d[Styling_1.HighContrastSelector] = ComboBoxRootHighContrastFocused,
	                _d)
	        },
	        rootDisabled: getDisabledStyles(theme),
	        rootError: {
	            borderColor: ComboBoxRootColorErrored,
	            marginBottom: '5px'
	        },
	        rootDisallowFreeForm: {},
	        input: [
	            Styling_1.getPlaceholderStyles(placeholderStyles),
	            {
	                backgroundColor: ComboBoxRootBackground,
	                color: ComboBoxRootTextColor,
	                boxSizing: 'border-box',
	                width: '100%',
	                height: '28px',
	                borderStyle: 'none',
	                outline: 'none',
	                font: 'inherit',
	                textOverflow: 'ellipsis',
	                padding: '0',
	                selectors: {
	                    '::-ms-clear': {
	                        display: 'none'
	                    }
	                }
	            }
	        ],
	        inputDisabled: [getDisabledStyles(theme), Styling_1.getPlaceholderStyles(disabledPlaceholderStyles)],
	        errorMessage: {
	            color: ComboBoxRootColorErrored
	        },
	        callout: {
	            boxShadow: '0 0px 5px 0px rgba(0, 0, 0, 0.4)',
	            borderWidth: '1px',
	            borderStyle: 'solid',
	            borderColor: ComboBoxCalloutBorderColor
	        },
	        optionsContainerWrapper: {
	            width: comboBoxOptionWidth
	        },
	        optionsContainer: {
	            display: 'block'
	        },
	        header: [
	            fonts.medium,
	            {
	                fontWeight: Styling_1.FontWeights.semibold,
	                color: ComboBoxOptionHeaderTextColor,
	                backgroundColor: 'none',
	                borderStyle: 'none',
	                height: ComboBoxOptionHeight,
	                lineHeight: ComboBoxOptionHeight,
	                cursor: 'default',
	                padding: '0px 16px',
	                userSelect: 'none',
	                textAlign: 'left'
	            }
	        ],
	        divider: {
	            borderWidth: '1px',
	            borderStyle: 'solid',
	            borderColor: ComboBoxOptionDividerBorderColor
	        }
	    };
	    return Styling_1.concatStyleSets(styles, customStyles);
	    var _a, _b, _c, _d;
	});
	//# sourceMappingURL=ComboBox.styles.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	exports.getClassNames = Utilities_1.memoizeFunction(function (styles, className, isOpen, disabled, required, focused, allowFreeForm, hasErrorMessage) {
	    return {
	        container: Styling_1.mergeStyles('ms-ComboBox-container', className, styles.container),
	        label: Styling_1.mergeStyles(styles.label, disabled && styles.labelDisabled),
	        root: Styling_1.mergeStyles('ms-ComboBox', hasErrorMessage ? styles.rootError : isOpen && 'is-open', required && 'is-required', styles.root, !allowFreeForm && styles.rootDisallowFreeForm, hasErrorMessage ? styles.rootError : !disabled && focused && styles.rootFocused, !disabled && {
	            selectors: {
	                ':hover': hasErrorMessage ? styles.rootError : !isOpen && !focused && styles.rootHovered,
	                ':active': hasErrorMessage ? styles.rootError : styles.rootPressed,
	                ':focus': hasErrorMessage ? styles.rootError : styles.rootFocused
	            }
	        }, disabled && ['is-disabled', styles.rootDisabled]),
	        input: Styling_1.mergeStyles('ms-ComboBox-Input', styles.input, disabled && styles.inputDisabled),
	        errorMessage: Styling_1.mergeStyles(styles.errorMessage),
	        callout: Styling_1.mergeStyles('ms-ComboBox-callout', styles.callout),
	        optionsContainerWrapper: Styling_1.mergeStyles('ms-ComboBox-optionsContainerWrapper', styles.optionsContainerWrapper),
	        optionsContainer: Styling_1.mergeStyles('ms-ComboBox-optionsContainer', styles.optionsContainer),
	        header: Styling_1.mergeStyles('ms-ComboBox-header', styles.header),
	        divider: Styling_1.mergeStyles('ms-ComboBox-divider', styles.divider)
	    };
	});
	exports.getComboBoxOptionClassNames = Utilities_1.memoizeFunction(function (styles) {
	    return {
	        optionText: Styling_1.mergeStyles('ms-ComboBox-optionText', styles.optionText),
	        root: Styling_1.mergeStyles('ms-ComboBox-option', styles.root, {
	            selectors: {
	                ':hover': styles.rootHovered,
	                ':focus': styles.rootFocused,
	                ':active': styles.rootPressed
	            }
	        }),
	        optionTextWrapper: Styling_1.mergeStyles(styles.optionTextWrapper)
	    };
	});
	//# sourceMappingURL=ComboBox.classNames.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(843), exports);
	tslib_1.__exportStar(__webpack_require__(838), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getAllSelectedOptions(options, selectedIndices) {
	    var selectedOptions = [];
	    for (var _i = 0, selectedIndices_1 = selectedIndices; _i < selectedIndices_1.length; _i++) {
	        var index = selectedIndices_1[_i];
	        var option = options[index];
	        if (option) {
	            selectedOptions.push(option);
	        }
	    }
	    return selectedOptions;
	}
	exports.getAllSelectedOptions = getAllSelectedOptions;
	//# sourceMappingURL=SelectableOption.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ComboBox_1 = __webpack_require__(839);
	var List_1 = __webpack_require__(845);
	var VirtualizedComboBox = /** @class */ (function (_super) {
	    tslib_1.__extends(VirtualizedComboBox, _super);
	    function VirtualizedComboBox() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /** The combo box element */
	        _this._comboBox = React.createRef();
	        /** The virtualized list element */
	        _this._list = React.createRef();
	        _this._onRenderList = function (props) {
	            var onRenderItem = props.onRenderItem;
	            // Render virtualized list
	            return (React.createElement(List_1.List, { componentRef: _this._list, role: "listbox", items: props.options, onRenderCell: onRenderItem ? function (item) { return onRenderItem(item); } : function () { return null; } }));
	        };
	        _this._onScrollToItem = function (itemIndex) {
	            // We are using the List component, call scrollToIndex
	            _this._list.current && _this._list.current.scrollToIndex(itemIndex);
	        };
	        return _this;
	    }
	    Object.defineProperty(VirtualizedComboBox.prototype, "selectedOptions", {
	        /**
	         * All selected options
	         */
	        get: function () {
	            if (this._comboBox.current) {
	                return this._comboBox.current.selectedOptions;
	            }
	            return [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    VirtualizedComboBox.prototype.dismissMenu = function () {
	        if (this._comboBox.current) {
	            return this._comboBox.current.dismissMenu();
	        }
	    };
	    VirtualizedComboBox.prototype.focus = function () {
	        if (this._comboBox.current) {
	            this._comboBox.current.focus();
	            return true;
	        }
	        return false;
	    };
	    VirtualizedComboBox.prototype.render = function () {
	        return (React.createElement(ComboBox_1.ComboBox, tslib_1.__assign({}, this.props, { componentRef: this._comboBox, onRenderList: this._onRenderList, onScrollToItem: this._onScrollToItem })));
	    };
	    return VirtualizedComboBox;
	}(Utilities_1.BaseComponent));
	exports.VirtualizedComboBox = VirtualizedComboBox;
	//# sourceMappingURL=VirtualizedComboBox.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(846), exports);
	//# sourceMappingURL=List.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(847), exports);
	tslib_1.__exportStar(__webpack_require__(848), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var List_types_1 = __webpack_require__(848);
	var RESIZE_DELAY = 16;
	var MIN_SCROLL_UPDATE_DELAY = 100;
	var MAX_SCROLL_UPDATE_DELAY = 500;
	var IDLE_DEBOUNCE_DELAY = 200;
	// The amount of time to wait before declaring that the list isn't scrolling
	var DONE_SCROLLING_WAIT = 500;
	var DEFAULT_ITEMS_PER_PAGE = 10;
	var DEFAULT_PAGE_HEIGHT = 30;
	var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
	var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
	var PAGE_KEY_PREFIX = 'page-';
	var SPACER_KEY_PREFIX = 'spacer-';
	var EMPTY_RECT = {
	    top: -1,
	    bottom: -1,
	    left: -1,
	    right: -1,
	    width: 0,
	    height: 0
	};
	// Naming expensive measures so that they're named in profiles.
	var _measurePageRect = function (element) { return element.getBoundingClientRect(); };
	var _measureSurfaceRect = _measurePageRect;
	var _measureScrollRect = _measurePageRect;
	/**
	 * The List renders virtualized pages of items. Each page's item count is determined by the getItemCountForPage callback if
	 * provided by the caller, or 10 as default. Each page's height is determined by the getPageHeight callback if provided by
	 * the caller, or by cached measurements if available, or by a running average, or a default fallback.
	 *
	 * The algorithm for rendering pages works like this:
	 *
	 * 1. Predict visible pages based on "current measure data" (page heights, surface position, visible window)
	 * 2. If changes are necessary, apply changes (add/remove pages)
	 * 3. For pages that are added, measure the page heights if we need to using getBoundingClientRect
	 * 4. If measurements don't match predictions, update measure data and goto step 1 asynchronously
	 *
	 * Measuring too frequently can pull performance down significantly. To compensate, we cache measured values so that
	 * we can avoid re-measuring during operations that should not alter heights, like scrolling.
	 *
	 * To optimize glass rendering performance, onShouldVirtualize can be set. When onShouldVirtualize return false,
	 * List will run in fast mode (not virtualized) to render all items without any measurements to improve page load time. And we
	 * start doing measurements and rendering in virtualized mode when items grows larger than this threshold.
	 *
	 * However, certain operations can make measure data stale. For example, resizing the list, or passing in new props,
	 * or forcing an update change cause pages to shrink/grow. When these operations occur, we increment a measureVersion
	 * number, which we associate with cached measurements and use to determine if a remeasure should occur.
	 */
	var List = /** @class */ (function (_super) {
	    tslib_1.__extends(List, _super);
	    function List(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._surface = React.createRef();
	        _this._onRenderPage = function (pageProps, defaultRender) {
	            var _a = _this.props, onRenderCell = _a.onRenderCell, role = _a.role;
	            var _b = pageProps.page, _c = _b.items, items = _c === void 0 ? [] : _c, startIndex = _b.startIndex, divProps = tslib_1.__rest(pageProps, ["page"]);
	            // only assign list item role if no role is assigned
	            var cellRole = role === undefined ? 'listitem' : 'presentation';
	            var cells = [];
	            for (var i = 0; i < items.length; i++) {
	                var index = startIndex + i;
	                var item = items[i];
	                var itemKey = _this.props.getKey ? _this.props.getKey(item, index) : item && item.key;
	                if (itemKey === null || itemKey === undefined) {
	                    itemKey = index;
	                }
	                cells.push(React.createElement("div", { role: cellRole, className: 'ms-List-cell', key: itemKey, "data-list-index": index, "data-automationid": "ListCell" }, onRenderCell && onRenderCell(item, index, _this.state.isScrolling)));
	            }
	            return React.createElement("div", tslib_1.__assign({}, divProps), cells);
	        };
	        _this.state = {
	            pages: [],
	            isScrolling: false
	        };
	        _this._estimatedPageHeight = 0;
	        _this._totalEstimates = 0;
	        _this._requiredWindowsAhead = 0;
	        _this._requiredWindowsBehind = 0;
	        // Track the measure version for everything.
	        _this._measureVersion = 0;
	        // Ensure that scrolls are lazy updated.
	        _this._onAsyncScroll = _this._async.debounce(_this._onAsyncScroll, MIN_SCROLL_UPDATE_DELAY, {
	            leading: false,
	            maxWait: MAX_SCROLL_UPDATE_DELAY
	        });
	        _this._onAsyncIdle = _this._async.debounce(_this._onAsyncIdle, IDLE_DEBOUNCE_DELAY, {
	            leading: false
	        });
	        _this._onAsyncResize = _this._async.debounce(_this._onAsyncResize, RESIZE_DELAY, {
	            leading: false
	        });
	        _this._onScrollingDone = _this._async.debounce(_this._onScrollingDone, DONE_SCROLLING_WAIT, {
	            leading: false
	        });
	        _this._cachedPageHeights = {};
	        _this._estimatedPageHeight = 0;
	        _this._focusedIndex = -1;
	        _this._pageCache = {};
	        return _this;
	    }
	    /**
	     * Scroll to the given index. By default will bring the page the specified item is on into the view. If a callback
	     * to measure the height of an individual item is specified, will only scroll to bring the specific item into view.
	     *
	     * Note: with items of variable height and no passed in `getPageHeight` method, the list might jump after scrolling
	     * when windows before/ahead are being rendered, and the estimated height is replaced using actual elements.
	     *
	     * @param index - Index of item to scroll to
	     * @param measureItem - Optional callback to measure the height of an individual item
	     * @param scrollToMode - Optional defines where in the window the item should be positioned to when scrolling
	     */
	    List.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
	        if (scrollToMode === void 0) { scrollToMode = List_types_1.ScrollToMode.auto; }
	        var startIndex = this.props.startIndex;
	        var renderCount = this._getRenderCount();
	        var endIndex = startIndex + renderCount;
	        var allowedRect = this._allowedRect;
	        var scrollTop = 0;
	        var itemsPerPage = 1;
	        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
	            var pageSpecification = this._getPageSpecification(itemIndex, allowedRect);
	            var pageHeight = pageSpecification.height;
	            itemsPerPage = pageSpecification.itemCount;
	            var requestedIndexIsInPage = itemIndex <= index && itemIndex + itemsPerPage > index;
	            if (requestedIndexIsInPage) {
	                // We have found the page. If the user provided a way to measure an individual item, we will try to scroll in just
	                // the given item, otherwise we'll only bring the page into view
	                if (measureItem && this._scrollElement) {
	                    var scrollRect = _measureScrollRect(this._scrollElement);
	                    var scrollWindow = {
	                        top: this._scrollElement.scrollTop,
	                        bottom: this._scrollElement.scrollTop + scrollRect.height
	                    };
	                    // Adjust for actual item position within page
	                    var itemPositionWithinPage = index - itemIndex;
	                    for (var itemIndexInPage = 0; itemIndexInPage < itemPositionWithinPage; ++itemIndexInPage) {
	                        scrollTop += measureItem(itemIndex + itemIndexInPage);
	                    }
	                    var scrollBottom = scrollTop + measureItem(index);
	                    // If scrollToMode is set to something other than auto, we always want to
	                    // scroll the item into a specific position on the page.
	                    switch (scrollToMode) {
	                        case List_types_1.ScrollToMode.top:
	                            this._scrollElement.scrollTop = scrollTop;
	                            return;
	                        case List_types_1.ScrollToMode.bottom:
	                            this._scrollElement.scrollTop = scrollBottom - scrollRect.height;
	                            return;
	                        case List_types_1.ScrollToMode.center:
	                            this._scrollElement.scrollTop = (scrollTop + scrollBottom - scrollRect.height) / 2;
	                            return;
	                        case List_types_1.ScrollToMode.auto:
	                        default:
	                            break;
	                    }
	                    var itemIsFullyVisible = scrollTop >= scrollWindow.top && scrollBottom <= scrollWindow.bottom;
	                    if (itemIsFullyVisible) {
	                        // Item is already visible, do nothing.
	                        return;
	                    }
	                    var itemIsPartiallyAbove = scrollTop < scrollWindow.top;
	                    var itemIsPartiallyBelow = scrollBottom > scrollWindow.bottom;
	                    if (itemIsPartiallyAbove) {
	                        //  We will just scroll to 'scrollTop'
	                        //  .------.   - scrollTop
	                        //  |Item  |
	                        //  | .----|-. - scrollWindow.top
	                        //  '------' |
	                        //    |      |
	                        //    '------'
	                    }
	                    else if (itemIsPartiallyBelow) {
	                        //  Adjust scrollTop position to just bring in the element
	                        // .------.  - scrollTop
	                        // |      |
	                        // | .------.
	                        // '-|----' | - scrollWindow.bottom
	                        //   | Item |
	                        //   '------' - scrollBottom
	                        scrollTop = scrollBottom - scrollRect.height;
	                    }
	                }
	                this._scrollElement.scrollTop = scrollTop;
	                return;
	            }
	            scrollTop += pageHeight;
	        }
	    };
	    List.prototype.getStartItemIndexInView = function (measureItem) {
	        var pages = this.state.pages || [];
	        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
	            var page = pages_1[_i];
	            var isPageVisible = !page.isSpacer && (this._scrollTop || 0) >= page.top && (this._scrollTop || 0) <= page.top + page.height;
	            if (isPageVisible) {
	                if (!measureItem) {
	                    var rowHeight = Math.floor(page.height / page.itemCount);
	                    return page.startIndex + Math.floor((this._scrollTop - page.top) / rowHeight);
	                }
	                else {
	                    var totalRowHeight = 0;
	                    for (var itemIndex = page.startIndex; itemIndex < page.startIndex + page.itemCount; itemIndex++) {
	                        var rowHeight = measureItem(itemIndex);
	                        if (page.top + totalRowHeight <= this._scrollTop && this._scrollTop < page.top + totalRowHeight + rowHeight) {
	                            return itemIndex;
	                        }
	                        else {
	                            totalRowHeight += rowHeight;
	                        }
	                    }
	                }
	            }
	        }
	        return 0;
	    };
	    List.prototype.componentDidMount = function () {
	        this._updatePages();
	        this._measureVersion++;
	        this._scrollElement = Utilities_1.findScrollableParent(this._root.current);
	        this._events.on(window, 'resize', this._onAsyncResize);
	        if (this._root.current) {
	            this._events.on(this._root.current, 'focus', this._onFocus, true);
	        }
	        if (this._scrollElement) {
	            this._events.on(this._scrollElement, 'scroll', this._onScroll);
	            this._events.on(this._scrollElement, 'scroll', this._onAsyncScroll);
	        }
	    };
	    List.prototype.componentWillUnmount = function () {
	        delete this._scrollElement;
	    };
	    List.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.items !== this.props.items ||
	            newProps.renderCount !== this.props.renderCount ||
	            newProps.startIndex !== this.props.startIndex ||
	            newProps.version !== this.props.version) {
	            // We have received new items so we want to make sure that initially we only render a single window to
	            // fill the currently visible rect, and then later render additional windows.
	            this._resetRequiredWindows();
	            this._requiredRect = null;
	            this._measureVersion++;
	            this._invalidatePageCache();
	            this._updatePages(newProps);
	        }
	    };
	    List.prototype.shouldComponentUpdate = function (newProps, newState) {
	        var oldPages = this.state.pages;
	        var newPages = newState.pages;
	        var shouldComponentUpdate = false;
	        // Update if the page stops scrolling
	        if (!newState.isScrolling && this.state.isScrolling) {
	            return true;
	        }
	        if (newProps.version !== this.props.version) {
	            return true;
	        }
	        if (newProps.items === this.props.items && oldPages.length === newPages.length) {
	            for (var i = 0; i < oldPages.length; i++) {
	                var oldPage = oldPages[i];
	                var newPage = newPages[i];
	                if (oldPage.key !== newPage.key || oldPage.itemCount !== newPage.itemCount) {
	                    shouldComponentUpdate = true;
	                    break;
	                }
	            }
	        }
	        else {
	            shouldComponentUpdate = true;
	        }
	        return shouldComponentUpdate;
	    };
	    List.prototype.forceUpdate = function () {
	        this._invalidatePageCache();
	        // Ensure that when the list is force updated we update the pages first before render.
	        this._updateRenderRects(this.props, true);
	        this._updatePages();
	        this._measureVersion++;
	        _super.prototype.forceUpdate.call(this);
	    };
	    /**
	     * Get the current height the list and it's pages.
	     */
	    List.prototype.getTotalListHeight = function () {
	        return this._surfaceRect.height;
	    };
	    List.prototype.render = function () {
	        var _a = this.props, className = _a.className, _b = _a.role, role = _b === void 0 ? 'list' : _b;
	        var _c = this.state.pages, pages = _c === void 0 ? [] : _c;
	        var pageElements = [];
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        for (var _i = 0, pages_2 = pages; _i < pages_2.length; _i++) {
	            var page = pages_2[_i];
	            pageElements.push(this._renderPage(page));
	        }
	        return (React.createElement("div", tslib_1.__assign({ ref: this._root }, divProps, { role: pageElements.length > 0 ? role : undefined, className: Utilities_1.css('ms-List', className) }),
	            React.createElement("div", { ref: this._surface, className: 'ms-List-surface', role: "presentation" }, pageElements)));
	    };
	    List.prototype._shouldVirtualize = function (props) {
	        if (props === void 0) { props = this.props; }
	        var onShouldVirtualize = props.onShouldVirtualize;
	        return !onShouldVirtualize || onShouldVirtualize(props);
	    };
	    /**
	     * when props.items change or forceUpdate called, throw away cached pages
	     */
	    List.prototype._invalidatePageCache = function () {
	        this._pageCache = {};
	    };
	    List.prototype._renderPage = function (page) {
	        var usePageCache = this.props.usePageCache;
	        var cachedPage;
	        // if usePageCache is set and cached page element can be found, just return cached page
	        if (usePageCache) {
	            cachedPage = this._pageCache[page.key];
	            if (cachedPage && cachedPage.pageElement) {
	                return cachedPage.pageElement;
	            }
	        }
	        var pageStyle = this._getPageStyle(page);
	        var _a = this.props.onRenderPage, onRenderPage = _a === void 0 ? this._onRenderPage : _a;
	        var pageElement = onRenderPage({
	            page: page,
	            className: 'ms-List-page',
	            key: page.key,
	            ref: page.key,
	            style: pageStyle,
	            role: 'presentation'
	        }, this._onRenderPage);
	        // cache the first page for now since it is re-rendered a lot times unnecessarily.
	        // todo: a more aggresive caching mechanism is to cache pages constaining the items not changed.
	        // now we re-render pages too frequently, for example, props.items increased from 30 to 60, although the
	        // first 30 items did not change, we still re-rendered all of them in this props.items change.
	        if (usePageCache && page.startIndex === 0) {
	            this._pageCache[page.key] = {
	                page: page,
	                pageElement: pageElement
	            };
	        }
	        return pageElement;
	    };
	    /** Generate the style object for the page. */
	    List.prototype._getPageStyle = function (page) {
	        var getPageStyle = this.props.getPageStyle;
	        return tslib_1.__assign({}, (getPageStyle ? getPageStyle(page) : {}), (!page.items
	            ? {
	                height: page.height
	            }
	            : {}));
	    };
	    /** Track the last item index focused so that we ensure we keep it rendered. */
	    List.prototype._onFocus = function (ev) {
	        var target = ev.target;
	        while (target !== this._surface.current) {
	            var indexString = target.getAttribute('data-list-index');
	            if (indexString) {
	                this._focusedIndex = Number(indexString);
	                break;
	            }
	            target = Utilities_1.getParent(target);
	        }
	    };
	    /**
	     * Called synchronously to reset the required render range to 0 on scrolling. After async scroll has executed,
	     * we will call onAsyncIdle which will reset it back to it's correct value.
	     */
	    List.prototype._onScroll = function () {
	        if (!this.state.isScrolling) {
	            this.setState({ isScrolling: true });
	        }
	        this._resetRequiredWindows();
	        this._onScrollingDone();
	    };
	    List.prototype._resetRequiredWindows = function () {
	        this._requiredWindowsAhead = 0;
	        this._requiredWindowsBehind = 0;
	    };
	    /**
	     * Debounced method to asynchronously update the visible region on a scroll event.
	     */
	    List.prototype._onAsyncScroll = function () {
	        this._updateRenderRects();
	        // Only update pages when the visible rect falls outside of the materialized rect.
	        if (!this._materializedRect || !_isContainedWithin(this._requiredRect, this._materializedRect)) {
	            this._updatePages();
	        }
	        else {
	            // console.log('requiredRect contained in materialized', this._requiredRect, this._materializedRect);
	        }
	    };
	    /**
	     * This is an async debounced method that will try and increment the windows we render. If we can increment
	     * either, we increase the amount we render and re-evaluate.
	     */
	    List.prototype._onAsyncIdle = function () {
	        var _a = this.props, renderedWindowsAhead = _a.renderedWindowsAhead, renderedWindowsBehind = _a.renderedWindowsBehind;
	        var _b = this, requiredWindowsAhead = _b._requiredWindowsAhead, requiredWindowsBehind = _b._requiredWindowsBehind;
	        var windowsAhead = Math.min(renderedWindowsAhead, requiredWindowsAhead + 1);
	        var windowsBehind = Math.min(renderedWindowsBehind, requiredWindowsBehind + 1);
	        if (windowsAhead !== requiredWindowsAhead || windowsBehind !== requiredWindowsBehind) {
	            // console.log('idling', windowsBehind, windowsAhead);
	            this._requiredWindowsAhead = windowsAhead;
	            this._requiredWindowsBehind = windowsBehind;
	            this._updateRenderRects();
	            this._updatePages();
	        }
	        if (renderedWindowsAhead > windowsAhead || renderedWindowsBehind > windowsBehind) {
	            // Async increment on next tick.
	            this._onAsyncIdle();
	        }
	    };
	    /**
	     * Function to call when the list is done scrolling.
	     * This function is debounced.
	     */
	    List.prototype._onScrollingDone = function () {
	        this.setState({ isScrolling: false });
	    };
	    List.prototype._onAsyncResize = function () {
	        this.forceUpdate();
	    };
	    List.prototype._updatePages = function (props) {
	        // console.log('updating pages');
	        var _this = this;
	        if (props === void 0) { props = this.props; }
	        if (!this._requiredRect) {
	            this._updateRenderRects(props);
	        }
	        var newListState = this._buildPages(props);
	        var oldListPages = this.state.pages;
	        this._notifyPageChanges(oldListPages, newListState.pages);
	        this.setState(newListState, function () {
	            // Multiple updates may have been queued, so the callback will reflect all of them.
	            // Re-fetch the current props and states to avoid using a stale props or state captured in the closure.
	            var finalProps = _this.props;
	            var finalState = _this.state;
	            // If we weren't provided with the page height, measure the pages
	            if (!finalProps.getPageHeight) {
	                // If measured version is invalid since we've updated the DOM
	                var heightsChanged = _this._updatePageMeasurements(finalState.pages);
	                // On first render, we should re-measure so that we don't get a visual glitch.
	                if (heightsChanged) {
	                    _this._materializedRect = null;
	                    if (!_this._hasCompletedFirstRender) {
	                        _this._hasCompletedFirstRender = true;
	                        _this._updatePages(finalProps);
	                    }
	                    else {
	                        _this._onAsyncScroll();
	                    }
	                }
	                else {
	                    // Enqueue an idle bump.
	                    _this._onAsyncIdle();
	                }
	            }
	            else {
	                // Enqueue an idle bump
	                _this._onAsyncIdle();
	            }
	            // Notify the caller that rendering the new pages has completed
	            if (finalProps.onPagesUpdated) {
	                finalProps.onPagesUpdated(finalState.pages);
	            }
	        });
	    };
	    /**
	     * Notify consumers that the rendered pages have changed
	     * @param oldPages - The old pages
	     * @param newPages - The new pages
	     * @param props - The props to use
	     */
	    List.prototype._notifyPageChanges = function (oldPages, newPages, props) {
	        if (props === void 0) { props = this.props; }
	        var onPageAdded = props.onPageAdded, onPageRemoved = props.onPageRemoved;
	        if (onPageAdded || onPageRemoved) {
	            var renderedIndexes = {};
	            for (var _i = 0, oldPages_1 = oldPages; _i < oldPages_1.length; _i++) {
	                var page = oldPages_1[_i];
	                if (page.items) {
	                    renderedIndexes[page.startIndex] = page;
	                }
	            }
	            for (var _a = 0, newPages_1 = newPages; _a < newPages_1.length; _a++) {
	                var page = newPages_1[_a];
	                if (page.items) {
	                    if (!renderedIndexes[page.startIndex]) {
	                        this._onPageAdded(page);
	                    }
	                    else {
	                        delete renderedIndexes[page.startIndex];
	                    }
	                }
	            }
	            for (var index in renderedIndexes) {
	                if (renderedIndexes.hasOwnProperty(index)) {
	                    this._onPageRemoved(renderedIndexes[index]);
	                }
	            }
	        }
	    };
	    List.prototype._updatePageMeasurements = function (pages) {
	        var heightChanged = false;
	        // when not in virtualize mode, we render all the items without page measurement
	        if (!this._shouldVirtualize()) {
	            return heightChanged;
	        }
	        for (var i = 0; i < pages.length; i++) {
	            var page = pages[i];
	            if (page.items) {
	                heightChanged = this._measurePage(page) || heightChanged;
	            }
	        }
	        return heightChanged;
	    };
	    /**
	     * Given a page, measure its dimensions, update cache.
	     * @returns True if the height has changed.
	     */
	    List.prototype._measurePage = function (page) {
	        var hasChangedHeight = false;
	        var pageElement = this.refs[page.key];
	        var cachedHeight = this._cachedPageHeights[page.startIndex];
	        // console.log('   * measure attempt', page.startIndex, cachedHeight);
	        if (pageElement && this._shouldVirtualize() && (!cachedHeight || cachedHeight.measureVersion !== this._measureVersion)) {
	            var newClientRect = {
	                width: pageElement.clientWidth,
	                height: pageElement.clientHeight
	            };
	            if (newClientRect.height || newClientRect.width) {
	                hasChangedHeight = page.height !== newClientRect.height;
	                // console.warn(' *** expensive page measure', page.startIndex, page.height, newClientRect.height);
	                page.height = newClientRect.height;
	                this._cachedPageHeights[page.startIndex] = {
	                    height: newClientRect.height,
	                    measureVersion: this._measureVersion
	                };
	                this._estimatedPageHeight = Math.round((this._estimatedPageHeight * this._totalEstimates + newClientRect.height) / (this._totalEstimates + 1));
	                this._totalEstimates++;
	            }
	        }
	        return hasChangedHeight;
	    };
	    /** Called when a page has been added to the DOM. */
	    List.prototype._onPageAdded = function (page) {
	        var onPageAdded = this.props.onPageAdded;
	        // console.log('page added', page.startIndex, this.state.pages.map(page => page.key).join(', '));
	        if (onPageAdded) {
	            onPageAdded(page);
	        }
	    };
	    /** Called when a page has been removed from the DOM. */
	    List.prototype._onPageRemoved = function (page) {
	        var onPageRemoved = this.props.onPageRemoved;
	        // console.log('  --- page removed', page.startIndex, this.state.pages.map(page => page.key).join(', '));
	        if (onPageRemoved) {
	            onPageRemoved(page);
	        }
	    };
	    /** Build up the pages that should be rendered. */
	    List.prototype._buildPages = function (props) {
	        var renderCount = props.renderCount;
	        var items = props.items, startIndex = props.startIndex, getPageHeight = props.getPageHeight;
	        renderCount = this._getRenderCount(props);
	        var materializedRect = tslib_1.__assign({}, EMPTY_RECT);
	        var pages = [];
	        var itemsPerPage = 1;
	        var pageTop = 0;
	        var currentSpacer = null;
	        var focusedIndex = this._focusedIndex;
	        var endIndex = startIndex + renderCount;
	        var shouldVirtualize = this._shouldVirtualize(props);
	        // First render is very important to track; when we render cells, we have no idea of estimated page height.
	        // So we should default to rendering only the first page so that we can get information.
	        // However if the user provides a measure function, let's just assume they know the right heights.
	        var isFirstRender = this._estimatedPageHeight === 0 && !getPageHeight;
	        var allowedRect = this._allowedRect;
	        var _loop_1 = function (itemIndex) {
	            var pageSpecification = this_1._getPageSpecification(itemIndex, allowedRect);
	            var pageHeight = pageSpecification.height;
	            var pageData = pageSpecification.data;
	            var key = pageSpecification.key;
	            itemsPerPage = pageSpecification.itemCount;
	            var pageBottom = pageTop + pageHeight - 1;
	            var isPageRendered = Utilities_1.findIndex(this_1.state.pages, function (page) { return !!page.items && page.startIndex === itemIndex; }) > -1;
	            var isPageInAllowedRange = !allowedRect || (pageBottom >= allowedRect.top && pageTop <= allowedRect.bottom);
	            var isPageInRequiredRange = !this_1._requiredRect || (pageBottom >= this_1._requiredRect.top && pageTop <= this_1._requiredRect.bottom);
	            var isPageVisible = (!isFirstRender && (isPageInRequiredRange || (isPageInAllowedRange && isPageRendered))) || !shouldVirtualize;
	            var isPageFocused = focusedIndex >= itemIndex && focusedIndex < itemIndex + itemsPerPage;
	            var isFirstPage = itemIndex === startIndex;
	            // console.log('building page', itemIndex, 'pageTop: ' + pageTop, 'inAllowed: ' +
	            // isPageInAllowedRange, 'inRequired: ' + isPageInRequiredRange);
	            // Only render whats visible, focused, or first page,
	            // or when running in fast rendering mode (not in virtualized mode), we render all current items in pages
	            if (isPageVisible || isPageFocused || isFirstPage) {
	                if (currentSpacer) {
	                    pages.push(currentSpacer);
	                    currentSpacer = null;
	                }
	                var itemsInPage = Math.min(itemsPerPage, endIndex - itemIndex);
	                var newPage = this_1._createPage(key, items.slice(itemIndex, itemIndex + itemsInPage), itemIndex, undefined, undefined, pageData);
	                newPage.top = pageTop;
	                newPage.height = pageHeight;
	                if (this_1._visibleRect && this_1._visibleRect.bottom) {
	                    newPage.isVisible = pageBottom >= this_1._visibleRect.top && pageTop <= this_1._visibleRect.bottom;
	                }
	                pages.push(newPage);
	                if (isPageInRequiredRange && this_1._allowedRect) {
	                    _mergeRect(materializedRect, {
	                        top: pageTop,
	                        bottom: pageBottom,
	                        height: pageHeight,
	                        left: allowedRect.left,
	                        right: allowedRect.right,
	                        width: allowedRect.width
	                    });
	                }
	            }
	            else {
	                if (!currentSpacer) {
	                    currentSpacer = this_1._createPage(SPACER_KEY_PREFIX + itemIndex, undefined, itemIndex, 0, undefined, pageData, true /*isSpacer*/);
	                }
	                currentSpacer.height = (currentSpacer.height || 0) + (pageBottom - pageTop) + 1;
	                currentSpacer.itemCount += itemsPerPage;
	            }
	            pageTop += pageBottom - pageTop + 1;
	            // in virtualized mode, we render need to render first page then break and measure,
	            // otherwise, we render all items without measurement to make rendering fast
	            if (isFirstRender && shouldVirtualize) {
	                return "break";
	            }
	        };
	        var this_1 = this;
	        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
	            var state_1 = _loop_1(itemIndex);
	            if (state_1 === "break")
	                break;
	        }
	        if (currentSpacer) {
	            currentSpacer.key = SPACER_KEY_PREFIX + 'end';
	            pages.push(currentSpacer);
	        }
	        this._materializedRect = materializedRect;
	        // console.log('materialized: ', materializedRect);
	        return {
	            pages: pages,
	            measureVersion: this._measureVersion
	        };
	    };
	    List.prototype._getPageSpecification = function (itemIndex, visibleRect) {
	        var getPageSpecification = this.props.getPageSpecification;
	        if (getPageSpecification) {
	            var pageData = getPageSpecification(itemIndex, visibleRect);
	            var _a = pageData.itemCount, itemCount = _a === void 0 ? this._getItemCountForPage(itemIndex, visibleRect) : _a;
	            var _b = pageData.height, height = _b === void 0 ? this._getPageHeight(itemIndex, visibleRect, itemCount) : _b;
	            return {
	                itemCount: itemCount,
	                height: height,
	                data: pageData.data,
	                key: pageData.key
	            };
	        }
	        else {
	            var itemCount = this._getItemCountForPage(itemIndex, visibleRect);
	            return {
	                itemCount: itemCount,
	                height: this._getPageHeight(itemIndex, visibleRect, itemCount)
	            };
	        }
	    };
	    /**
	     * Get the pixel height of a give page. Will use the props getPageHeight first, and if not provided, fallback to
	     * cached height, or estimated page height, or default page height.
	     */
	    List.prototype._getPageHeight = function (itemIndex, visibleRect, itemsPerPage) {
	        if (this.props.getPageHeight) {
	            return this.props.getPageHeight(itemIndex, visibleRect, itemsPerPage);
	        }
	        else {
	            var cachedHeight = this._cachedPageHeights[itemIndex];
	            return cachedHeight ? cachedHeight.height : this._estimatedPageHeight || DEFAULT_PAGE_HEIGHT;
	        }
	    };
	    List.prototype._getItemCountForPage = function (itemIndex, visibileRect) {
	        var itemsPerPage = this.props.getItemCountForPage ? this.props.getItemCountForPage(itemIndex, visibileRect) : DEFAULT_ITEMS_PER_PAGE;
	        return itemsPerPage ? itemsPerPage : DEFAULT_ITEMS_PER_PAGE;
	    };
	    List.prototype._createPage = function (pageKey, items, startIndex, count, style, data, isSpacer) {
	        if (startIndex === void 0) { startIndex = -1; }
	        if (count === void 0) { count = items ? items.length : 0; }
	        if (style === void 0) { style = {}; }
	        pageKey = pageKey || PAGE_KEY_PREFIX + startIndex;
	        var cachedPage = this._pageCache[pageKey];
	        if (cachedPage && cachedPage.page) {
	            return cachedPage.page;
	        }
	        return {
	            key: pageKey,
	            startIndex: startIndex,
	            itemCount: count,
	            items: items,
	            style: style,
	            top: 0,
	            height: 0,
	            data: data,
	            isSpacer: isSpacer || false
	        };
	    };
	    List.prototype._getRenderCount = function (props) {
	        var _a = props || this.props, items = _a.items, startIndex = _a.startIndex, renderCount = _a.renderCount;
	        return renderCount === undefined ? (items ? items.length - startIndex : 0) : renderCount;
	    };
	    /** Calculate the visible rect within the list where top: 0 and left: 0 is the top/left of the list. */
	    List.prototype._updateRenderRects = function (props, forceUpdate) {
	        props = props || this.props;
	        var renderedWindowsAhead = props.renderedWindowsAhead, renderedWindowsBehind = props.renderedWindowsBehind;
	        var pages = this.state.pages;
	        // when not in virtualize mode, we render all items without measurement to optimize page rendering perf
	        if (!this._shouldVirtualize(props)) {
	            return;
	        }
	        var surfaceRect = this._surfaceRect || tslib_1.__assign({}, EMPTY_RECT);
	        var scrollHeight = this._scrollElement && this._scrollElement.scrollHeight;
	        var scrollTop = this._scrollElement ? this._scrollElement.scrollTop : 0;
	        // WARNING: EXPENSIVE CALL! We need to know the surface top relative to the window.
	        // This needs to be called to recalculate when new pages should be loaded.
	        // We check to see how far we've scrolled and if it's further than a third of a page we run it again.
	        if (this._surface.current &&
	            (forceUpdate ||
	                !pages ||
	                !this._surfaceRect ||
	                !scrollHeight ||
	                scrollHeight !== this._scrollHeight ||
	                Math.abs(this._scrollTop - scrollTop) > this._estimatedPageHeight / 3)) {
	            surfaceRect = this._surfaceRect = _measureSurfaceRect(this._surface.current);
	            this._scrollTop = scrollTop;
	        }
	        // If the scroll height has changed, something in the container likely resized and
	        // we should redo the page heights incase their content resized.
	        if (forceUpdate || !scrollHeight || scrollHeight !== this._scrollHeight) {
	            this._measureVersion++;
	        }
	        this._scrollHeight = scrollHeight;
	        // If the surface is above the container top or below the container bottom, or if this is not the first
	        // render return empty rect.
	        // The first time the list gets rendered we need to calculate the rectangle. The width of the list is
	        // used to calculate the width of the list items.
	        var visibleTop = Math.max(0, -surfaceRect.top);
	        var win = Utilities_1.getWindow(this._root.current);
	        var visibleRect = {
	            top: visibleTop,
	            left: surfaceRect.left,
	            bottom: visibleTop + win.innerHeight,
	            right: surfaceRect.right,
	            width: surfaceRect.width,
	            height: win.innerHeight
	        };
	        // The required/allowed rects are adjusted versions of the visible rect.
	        this._requiredRect = _expandRect(visibleRect, this._requiredWindowsBehind, this._requiredWindowsAhead);
	        this._allowedRect = _expandRect(visibleRect, renderedWindowsBehind, renderedWindowsAhead);
	        // store the visible rect for later use.
	        this._visibleRect = visibleRect;
	    };
	    List.defaultProps = {
	        startIndex: 0,
	        onRenderCell: function (item, index, containsFocus) { return React.createElement(React.Fragment, null, (item && item.name) || ''); },
	        renderedWindowsAhead: DEFAULT_RENDERED_WINDOWS_AHEAD,
	        renderedWindowsBehind: DEFAULT_RENDERED_WINDOWS_BEHIND
	    };
	    return List;
	}(Utilities_1.BaseComponent));
	exports.List = List;
	function _expandRect(rect, pagesBefore, pagesAfter) {
	    var top = rect.top - pagesBefore * rect.height;
	    var height = rect.height + (pagesBefore + pagesAfter) * rect.height;
	    return {
	        top: top,
	        bottom: top + height,
	        height: height,
	        left: rect.left,
	        right: rect.right,
	        width: rect.width
	    };
	}
	function _isContainedWithin(innerRect, outerRect) {
	    return (innerRect.top >= outerRect.top &&
	        innerRect.left >= outerRect.left &&
	        innerRect.bottom <= outerRect.bottom &&
	        innerRect.right <= outerRect.right);
	}
	function _mergeRect(targetRect, newRect) {
	    targetRect.top = newRect.top < targetRect.top || targetRect.top === -1 ? newRect.top : targetRect.top;
	    targetRect.left = newRect.left < targetRect.left || targetRect.left === -1 ? newRect.left : targetRect.left;
	    targetRect.bottom = newRect.bottom > targetRect.bottom || targetRect.bottom === -1 ? newRect.bottom : targetRect.bottom;
	    targetRect.right = newRect.right > targetRect.right || targetRect.right === -1 ? newRect.right : targetRect.right;
	    targetRect.width = targetRect.right - targetRect.left + 1;
	    targetRect.height = targetRect.bottom - targetRect.top + 1;
	    return targetRect;
	}
	//# sourceMappingURL=List.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory List}
	 */
	exports.ScrollToMode = {
	    /**
	     * Does not make any consideration to where in the viewport the item should align to.
	     */
	    auto: 0,
	    /**
	     * Attempts to scroll the list so the top of the desired item is aligned with the top of the viewport.
	     */
	    top: 1,
	    /**
	     * Attempts to scroll the list so the bottom of the desired item is aligned with the bottom of the viewport.
	     */
	    bottom: 2,
	    /**
	     * Attempts to scroll the list so the desired item is in the exact center of the viewport.
	     */
	    center: 3
	};
	//# sourceMappingURL=List.types.js.map

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(850), exports);
	//# sourceMappingURL=CommandBar.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(851), exports);
	tslib_1.__exportStar(__webpack_require__(852), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var CommandBar_base_1 = __webpack_require__(852);
	var CommandBar_styles_1 = __webpack_require__(858);
	// Create a CommandBar variant which uses these default styles and this styled subcomponent.
	exports.CommandBar = Utilities_1.styled(CommandBar_base_1.CommandBarBase, CommandBar_styles_1.getStyles, undefined, {
	    scope: 'CommandBar'
	});
	//# sourceMappingURL=CommandBar.js.map

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var OverflowSet_1 = __webpack_require__(853);
	var ResizeGroup_1 = __webpack_require__(740);
	var FocusZone_1 = __webpack_require__(676);
	var Utilities_2 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var Tooltip_1 = __webpack_require__(598);
	var getClassNames = Utilities_2.classNamesFunction();
	var CommandBarBase = /** @class */ (function (_super) {
	    tslib_1.__extends(CommandBarBase, _super);
	    function CommandBarBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._overflowSet = React.createRef();
	        _this._resizeGroup = React.createRef();
	        _this._onRenderData = function (data) {
	            return (React.createElement(FocusZone_1.FocusZone, { className: Utilities_1.css(_this._classNames.root), direction: FocusZone_1.FocusZoneDirection.horizontal, role: 'menubar', "aria-label": _this.props.ariaLabel },
	                React.createElement(OverflowSet_1.OverflowSet, { componentRef: _this._resolveRef('_overflowSet'), className: Utilities_1.css(_this._classNames.primarySet), doNotContainWithinFocusZone: true, role: 'presentation', items: data.primaryItems, overflowItems: data.overflowItems.length ? data.overflowItems : undefined, onRenderItem: _this._onRenderItem, onRenderOverflowButton: _this._onRenderOverflowButton }),
	                data.farItems && (React.createElement(OverflowSet_1.OverflowSet, { className: Utilities_1.css(_this._classNames.secondarySet), doNotContainWithinFocusZone: true, role: 'presentation', items: data.farItems, onRenderItem: _this._onRenderItem, onRenderOverflowButton: Utilities_1.nullRender }))));
	        };
	        _this._onRenderItem = function (item) {
	            var CommandButtonType = _this.props.buttonAs || item.commandBarButtonAs || Button_1.CommandBarButton;
	            var itemText = item.text || item.name;
	            if (item.onRender) {
	                // These are the top level items, there is no relevant menu dismissing function to
	                // provide for the IContextualMenuItem onRender function. Pass in a no op function instead.
	                return item.onRender(item, function () { return undefined; });
	            }
	            var commandButtonProps = tslib_1.__assign({ allowDisabledFocus: true, role: 'menuitem' }, item, { styles: tslib_1.__assign({ root: { height: '100%' }, label: { whiteSpace: 'nowrap' } }, item.buttonStyles), className: Utilities_1.css('ms-CommandBarItem-link', item.className), text: !item.iconOnly ? itemText : undefined, menuProps: item.subMenuProps, onClick: _this._onButtonClick(item) });
	            if (item.iconOnly && itemText !== undefined) {
	                return (React.createElement(Tooltip_1.TooltipHost, tslib_1.__assign({ content: itemText }, item.tooltipHostProps),
	                    React.createElement(CommandButtonType, tslib_1.__assign({}, commandButtonProps, { defaultRender: Button_1.CommandBarButton }))));
	            }
	            return React.createElement(CommandButtonType, tslib_1.__assign({}, commandButtonProps, { defaultRender: Button_1.CommandBarButton }));
	        };
	        _this._onRenderOverflowButton = function (overflowItems) {
	            var _a = _this.props, _b = _a.overflowButtonAs, OverflowButtonType = _b === void 0 ? Button_1.CommandBarButton : _b, _c = _a.overflowButtonProps // assure that props is not empty
	            , overflowButtonProps = _c === void 0 ? {} : _c // assure that props is not empty
	            ;
	            var combinedOverflowItems = (overflowButtonProps.menuProps ? overflowButtonProps.menuProps.items : []).concat(overflowItems);
	            var overflowProps = tslib_1.__assign({}, overflowButtonProps, { styles: tslib_1.__assign({ menuIcon: { fontSize: '17px' } }, overflowButtonProps.styles), className: Utilities_1.css('ms-CommandBar-overflowButton', overflowButtonProps.className), menuProps: tslib_1.__assign({}, overflowButtonProps.menuProps, { items: combinedOverflowItems }), menuIconProps: tslib_1.__assign({ iconName: 'More' }, overflowButtonProps.menuIconProps) });
	            return React.createElement(OverflowButtonType, tslib_1.__assign({}, overflowProps));
	        };
	        _this._onReduceData = function (data) {
	            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataReduced = _a.onDataReduced;
	            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
	            // Use first item if shiftOnReduce, otherwise use last item
	            var movedItem = primaryItems[shiftOnReduce ? 0 : primaryItems.length - 1];
	            if (movedItem !== undefined) {
	                movedItem.renderedInOverflow = true;
	                overflowItems = [movedItem].concat(overflowItems);
	                primaryItems = shiftOnReduce ? primaryItems.slice(1) : primaryItems.slice(0, -1);
	                var newData = tslib_1.__assign({}, data, { primaryItems: primaryItems, overflowItems: overflowItems });
	                cacheKey = _this._computeCacheKey(newData);
	                if (onDataReduced) {
	                    onDataReduced(movedItem);
	                }
	                newData.cacheKey = cacheKey;
	                return newData;
	            }
	            return undefined;
	        };
	        _this._onGrowData = function (data) {
	            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataGrown = _a.onDataGrown;
	            var minimumOverflowItems = data.minimumOverflowItems;
	            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
	            var movedItem = overflowItems[0];
	            // Make sure that moved item exists and is not one of the original overflow items
	            if (movedItem !== undefined && overflowItems.length > minimumOverflowItems) {
	                movedItem.renderedInOverflow = false;
	                overflowItems = overflowItems.slice(1);
	                // if shiftOnReduce, movedItem goes first, otherwise, last.
	                primaryItems = shiftOnReduce ? [movedItem].concat(primaryItems) : primaryItems.concat([movedItem]);
	                var newData = tslib_1.__assign({}, data, { primaryItems: primaryItems, overflowItems: overflowItems });
	                cacheKey = _this._computeCacheKey(newData);
	                if (onDataGrown) {
	                    onDataGrown(movedItem);
	                }
	                newData.cacheKey = cacheKey;
	                return newData;
	            }
	            return undefined;
	        };
	        return _this;
	    }
	    CommandBarBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, items = _a.items, overflowItems = _a.overflowItems, farItems = _a.farItems, styles = _a.styles, theme = _a.theme, dataDidRender = _a.dataDidRender, _b = _a.onReduceData, onReduceData = _b === void 0 ? this._onReduceData : _b, _c = _a.onGrowData, onGrowData = _c === void 0 ? this._onGrowData : _c;
	        var commandBarData = {
	            primaryItems: items.slice(),
	            overflowItems: overflowItems.slice(),
	            minimumOverflowItems: overflowItems.slice().length,
	            farItems: farItems,
	            cacheKey: ''
	        };
	        this._classNames = getClassNames(styles, { theme: theme });
	        return (React.createElement(ResizeGroup_1.ResizeGroup, { componentRef: this._resizeGroup, className: className, data: commandBarData, onReduceData: onReduceData, onGrowData: onGrowData, onRenderData: this._onRenderData, dataDidRender: dataDidRender }));
	    };
	    CommandBarBase.prototype.focus = function () {
	        var overflowSet = this._overflowSet.current;
	        overflowSet && overflowSet.focus();
	    };
	    CommandBarBase.prototype.remeasure = function () {
	        this._resizeGroup.current && this._resizeGroup.current.remeasure();
	    };
	    CommandBarBase.prototype._onButtonClick = function (item) {
	        return function (ev) {
	            // inactive is deprecated. remove check in 7.0
	            if (item.inactive) {
	                return;
	            }
	            if (item.onClick) {
	                item.onClick(ev, item);
	            }
	        };
	    };
	    CommandBarBase.prototype._computeCacheKey = function (data) {
	        var primaryItems = data.primaryItems, _a = data.farItems, farItems = _a === void 0 ? [] : _a, overflowItems = data.overflowItems;
	        var returnKey = function (acc, current) {
	            var _a = current.cacheKey, cacheKey = _a === void 0 ? current.key : _a;
	            return acc + cacheKey;
	        };
	        var primaryKey = primaryItems.reduce(returnKey, '');
	        var farKey = farItems.reduce(returnKey, '');
	        var overflowKey = !!overflowItems.length ? 'overflow' : '';
	        return [primaryKey, farKey, overflowKey].join(' ');
	    };
	    CommandBarBase.defaultProps = {
	        items: [],
	        overflowItems: []
	    };
	    return CommandBarBase;
	}(Utilities_1.BaseComponent));
	exports.CommandBarBase = CommandBarBase;
	//# sourceMappingURL=CommandBar.base.js.map

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(854), exports);
	//# sourceMappingURL=OverflowSet.js.map

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(855), exports);
	tslib_1.__exportStar(__webpack_require__(856), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var OverflowSet_base_1 = __webpack_require__(856);
	var OverflowSet_styles_1 = __webpack_require__(857);
	exports.OverflowSet = Utilities_1.styled(OverflowSet_base_1.OverflowSetBase, OverflowSet_styles_1.getStyles, undefined, {
	    scope: 'OverflowSet'
	});
	//# sourceMappingURL=OverflowSet.js.map

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var FocusZone_1 = __webpack_require__(676);
	var Utilities_1 = __webpack_require__(592);
	var KeytipManager_1 = __webpack_require__(687);
	var getClassNames = Utilities_1.classNamesFunction();
	var OverflowSetBase = /** @class */ (function (_super) {
	    tslib_1.__extends(OverflowSetBase, _super);
	    function OverflowSetBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._focusZone = React.createRef();
	        _this._persistedKeytips = {};
	        _this._keytipManager = KeytipManager_1.KeytipManager.getInstance();
	        _this._divContainer = React.createRef();
	        _this._onRenderItems = function (items) {
	            return items.map(function (item, i) {
	                var wrapperDivProps = {
	                    className: _this._classNames.item
	                };
	                return (React.createElement("div", tslib_1.__assign({ key: item.key }, wrapperDivProps), _this.props.onRenderItem(item)));
	            });
	        };
	        _this._onRenderOverflowButtonWrapper = function (items) {
	            var wrapperDivProps = {
	                className: _this._classNames.overflowButton
	            };
	            var overflowKeytipSequences = _this.props.keytipSequences;
	            var newOverflowItems = [];
	            if (overflowKeytipSequences) {
	                items.forEach(function (overflowItem) {
	                    var keytip = overflowItem.keytipProps;
	                    if (keytip) {
	                        // Create persisted keytip
	                        var persistedKeytip = {
	                            content: keytip.content,
	                            keySequences: keytip.keySequences,
	                            disabled: keytip.disabled || !!(overflowItem.disabled || overflowItem.isDisabled),
	                            hasDynamicChildren: keytip.hasDynamicChildren,
	                            hasMenu: keytip.hasMenu
	                        };
	                        if (keytip.hasDynamicChildren || _this._getSubMenuForItem(overflowItem)) {
	                            // If the keytip has a submenu or children nodes, change onExecute to persistedKeytipExecute
	                            persistedKeytip.onExecute = _this._keytipManager.menuExecute.bind(_this._keytipManager, overflowKeytipSequences, overflowItem.keytipProps.keySequences);
	                        }
	                        else {
	                            // If the keytip doesn't have a submenu, just execute the original function
	                            persistedKeytip.onExecute = keytip.onExecute;
	                        }
	                        // Add this persisted keytip to our internal list, use a temporary uniqueID (its content)
	                        // uniqueID will get updated on register
	                        _this._persistedKeytips[persistedKeytip.content] = persistedKeytip;
	                        // Add the overflow sequence to this item
	                        var newOverflowItem = tslib_1.__assign({}, overflowItem, { keytipProps: tslib_1.__assign({}, keytip, { overflowSetSequence: overflowKeytipSequences }) });
	                        newOverflowItems.push(newOverflowItem);
	                    }
	                    else {
	                        // Nothing to change, add overflowItem to list
	                        newOverflowItems.push(overflowItem);
	                    }
	                });
	            }
	            else {
	                newOverflowItems = items;
	            }
	            return React.createElement("div", tslib_1.__assign({}, wrapperDivProps), _this.props.onRenderOverflowButton(newOverflowItems));
	        };
	        if (props.doNotContainWithinFocusZone) {
	            _this._warnMutuallyExclusive({
	                doNotContainWithinFocusZone: 'focusZoneProps'
	            });
	        }
	        return _this;
	    }
	    OverflowSetBase.prototype.render = function () {
	        var _a = this.props, items = _a.items, overflowItems = _a.overflowItems, className = _a.className, focusZoneProps = _a.focusZoneProps, styles = _a.styles, vertical = _a.vertical, role = _a.role, doNotContainWithinFocusZone = _a.doNotContainWithinFocusZone;
	        this._classNames = getClassNames(styles, { className: className, vertical: vertical });
	        var Tag;
	        var uniqueComponentProps;
	        if (doNotContainWithinFocusZone) {
	            Tag = 'div';
	            uniqueComponentProps = tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { ref: this._divContainer });
	        }
	        else {
	            Tag = FocusZone_1.FocusZone;
	            uniqueComponentProps = tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), focusZoneProps, { componentRef: this._focusZone, direction: vertical ? FocusZone_1.FocusZoneDirection.vertical : FocusZone_1.FocusZoneDirection.horizontal });
	        }
	        return (React.createElement(Tag, tslib_1.__assign({}, uniqueComponentProps, { className: this._classNames.root, role: role }),
	            items && this._onRenderItems(items),
	            overflowItems && overflowItems.length > 0 && this._onRenderOverflowButtonWrapper(overflowItems)));
	    };
	    /**
	     * Sets focus to the first tabbable item in the OverflowSet.
	     * @param forceIntoFirstElement - If true, focus will be forced into the first element,
	     * even if focus is already in theOverflowSet
	     * @returns True if focus could be set to an active element, false if no operation was taken.
	     */
	    OverflowSetBase.prototype.focus = function (forceIntoFirstElement) {
	        var focusSucceeded = false;
	        if (this.props.doNotContainWithinFocusZone) {
	            if (this._divContainer.current) {
	                focusSucceeded = Utilities_1.focusFirstChild(this._divContainer.current);
	            }
	        }
	        else if (this._focusZone.current) {
	            focusSucceeded = this._focusZone.current.focus(forceIntoFirstElement);
	        }
	        return focusSucceeded;
	    };
	    /**
	     * Sets focus to a specific child element within the OverflowSet.
	     * @param childElement - The child element within the zone to focus.
	     * @returns True if focus could be set to an active element, false if no operation was taken.
	     */
	    OverflowSetBase.prototype.focusElement = function (childElement) {
	        var focusSucceeded = false;
	        if (!childElement) {
	            return false;
	        }
	        if (this.props.doNotContainWithinFocusZone) {
	            if (this._divContainer.current && Utilities_1.elementContains(this._divContainer.current, childElement)) {
	                childElement.focus();
	                focusSucceeded = document.activeElement === childElement;
	            }
	        }
	        else if (this._focusZone.current) {
	            focusSucceeded = this._focusZone.current.focusElement(childElement);
	        }
	        return focusSucceeded;
	    };
	    // Add keytip register/unregister handlers to lifecycle functions to correctly manage persisted keytips
	    OverflowSetBase.prototype.componentDidMount = function () {
	        this._registerPersistedKeytips();
	    };
	    OverflowSetBase.prototype.componentWillUnmount = function () {
	        this._unregisterPersistedKeytips();
	    };
	    OverflowSetBase.prototype.componentWillUpdate = function () {
	        this._unregisterPersistedKeytips();
	    };
	    OverflowSetBase.prototype.componentDidUpdate = function () {
	        this._registerPersistedKeytips();
	    };
	    OverflowSetBase.prototype._registerPersistedKeytips = function () {
	        var _this = this;
	        Object.keys(this._persistedKeytips).forEach(function (key) {
	            var keytip = _this._persistedKeytips[key];
	            var uniqueID = _this._keytipManager.register(keytip, true);
	            // Update map
	            _this._persistedKeytips[uniqueID] = keytip;
	            delete _this._persistedKeytips[key];
	        });
	    };
	    OverflowSetBase.prototype._unregisterPersistedKeytips = function () {
	        var _this = this;
	        // Delete all persisted keytips saved
	        Object.keys(this._persistedKeytips).forEach(function (uniqueID) {
	            _this._keytipManager.unregister(_this._persistedKeytips[uniqueID], uniqueID, true);
	        });
	        this._persistedKeytips = {};
	    };
	    /**
	     * Gets the subMenu for an overflow item
	     * Checks if itemSubMenuProvider has been defined, if not defaults to subMenuProps
	     */
	    OverflowSetBase.prototype._getSubMenuForItem = function (item) {
	        if (this.props.itemSubMenuProvider) {
	            return this.props.itemSubMenuProvider(item);
	        }
	        if (item.subMenuProps) {
	            return item.subMenuProps.items;
	        }
	        return undefined;
	    };
	    OverflowSetBase.defaultProps = {
	        vertical: false,
	        role: 'menubar'
	    };
	    return OverflowSetBase;
	}(Utilities_1.BaseComponent));
	exports.OverflowSetBase = OverflowSetBase;
	//# sourceMappingURL=OverflowSet.base.js.map

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var overflowItemStyle = {
	    flexShrink: 0,
	    display: 'inherit'
	};
	exports.getStyles = function (props) {
	    var className = props.className, vertical = props.vertical;
	    return {
	        root: [
	            'ms-OverflowSet',
	            {
	                position: 'relative',
	                display: 'flex',
	                flexWrap: 'nowrap'
	            },
	            vertical && { flexDirection: 'column' },
	            className
	        ],
	        item: ['ms-OverflowSet-item', overflowItemStyle],
	        overflowButton: ['ms-OverflowSet-overflowButton', overflowItemStyle]
	    };
	};
	//# sourceMappingURL=OverflowSet.styles.js.map

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var palette = theme.palette;
	    return {
	        root: [
	            theme.fonts.medium,
	            'ms-CommandBar',
	            {
	                display: 'flex',
	                backgroundColor: palette.neutralLighter,
	                padding: '0 16px',
	                height: '40px'
	            },
	            className
	        ],
	        primarySet: [
	            'ms-CommandBar-primaryCommand',
	            {
	                flexGrow: '1',
	                display: 'flex',
	                alignItems: 'stretch'
	            }
	        ],
	        secondarySet: [
	            'ms-CommandBar-secondaryCommand',
	            {
	                flexShrink: '0',
	                display: 'flex',
	                alignItems: 'stretch'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=CommandBar.styles.js.map

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(860), exports);
	//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(861), exports);
	tslib_1.__exportStar(__webpack_require__(862), exports);
	tslib_1.__exportStar(__webpack_require__(756), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DatePicker_base_1 = __webpack_require__(862);
	var DatePicker_styles_1 = __webpack_require__(863);
	/**
	 * DatePicker description
	 */
	exports.DatePicker = Utilities_1.styled(DatePicker_base_1.DatePickerBase, DatePicker_styles_1.styles, undefined, {
	    scope: 'DatePicker'
	});
	//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Calendar_1 = __webpack_require__(746);
	var DateValues_1 = __webpack_require__(749);
	var Callout_1 = __webpack_require__(603);
	var DirectionalHint_1 = __webpack_require__(608);
	var TextField_1 = __webpack_require__(822);
	var DateMath_1 = __webpack_require__(751);
	var FocusTrapZone_1 = __webpack_require__(630);
	var getClassNames = Utilities_1.classNamesFunction();
	var DEFAULT_STRINGS = {
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	    goToToday: 'Go to today',
	    prevMonthAriaLabel: 'Go to previous month',
	    nextMonthAriaLabel: 'Go to next month',
	    prevYearAriaLabel: 'Go to previous year',
	    nextYearAriaLabel: 'Go to next year',
	    prevYearRangeAriaLabel: 'Previous year range',
	    nextYearRangeAriaLabel: 'Next year range',
	    closeButtonAriaLabel: 'Close date picker',
	    weekNumberFormatString: 'Week number {0}'
	};
	var DatePickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DatePickerBase, _super);
	    function DatePickerBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._calendar = React.createRef();
	        _this._datePickerDiv = React.createRef();
	        _this._textField = React.createRef();
	        _this._onSelectDate = function (date) {
	            var _a = _this.props, formatDate = _a.formatDate, onSelectDate = _a.onSelectDate;
	            if (_this.props.calendarProps && _this.props.calendarProps.onSelectDate) {
	                _this.props.calendarProps.onSelectDate(date);
	            }
	            _this.setState({
	                selectedDate: date,
	                formattedDate: formatDate && date ? formatDate(date) : ''
	            });
	            if (onSelectDate) {
	                onSelectDate(date);
	            }
	            _this._calendarDismissed();
	        };
	        _this._onCalloutPositioned = function () {
	            var shouldFocus = true;
	            // If the user has specified that the callout shouldn't use initial focus, then respect
	            // that and don't attempt to set focus. That will default to true within the callout
	            // so we need to check if it's undefined here.
	            if (_this.props.calloutProps && _this.props.calloutProps.setInitialFocus !== undefined) {
	                shouldFocus = _this.props.calloutProps.setInitialFocus;
	            }
	            if (_this._calendar.current && shouldFocus) {
	                _this._calendar.current.focus();
	            }
	        };
	        _this._onTextFieldFocus = function (ev) {
	            if (_this.props.disableAutoFocus) {
	                return;
	            }
	            if (!_this.props.allowTextInput) {
	                if (!_this._preventFocusOpeningPicker) {
	                    _this._showDatePickerPopup();
	                }
	                else {
	                    _this._preventFocusOpeningPicker = false;
	                }
	            }
	        };
	        _this._onTextFieldBlur = function (ev) {
	            _this._validateTextInput();
	        };
	        _this._onTextFieldChanged = function (ev, newValue) {
	            var _a = _this.props, allowTextInput = _a.allowTextInput, textField = _a.textField;
	            if (allowTextInput) {
	                if (_this.state.isDatePickerShown) {
	                    _this._dismissDatePickerPopup();
	                }
	                var _b = _this.props, isRequired = _b.isRequired, value = _b.value, strings = _b.strings;
	                _this.setState({
	                    errorMessage: isRequired && !value ? strings.isRequiredErrorMessage || ' ' : undefined,
	                    formattedDate: newValue
	                });
	            }
	            if (textField && textField.onChange) {
	                textField.onChange(ev, newValue);
	            }
	        };
	        _this._onTextFieldKeyDown = function (ev) {
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.enter:
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                    if (!_this.state.isDatePickerShown) {
	                        _this._validateTextInput();
	                        _this._showDatePickerPopup();
	                    }
	                    else {
	                        // When DatePicker allows input date string directly,
	                        // it is expected to hit another enter to close the popup
	                        if (_this.props.allowTextInput) {
	                            _this._dismissDatePickerPopup();
	                        }
	                    }
	                    break;
	                case Utilities_1.KeyCodes.escape:
	                    _this._handleEscKey(ev);
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this._onTextFieldClick = function (ev) {
	            if (!_this.state.isDatePickerShown && !_this.props.disabled) {
	                _this._showDatePickerPopup();
	            }
	            else {
	                if (_this.props.allowTextInput) {
	                    _this.setState({
	                        isDatePickerShown: false
	                    });
	                }
	            }
	        };
	        _this._onIconClick = function (ev) {
	            ev.stopPropagation();
	            _this._onTextFieldClick(ev);
	        };
	        _this._dismissDatePickerPopup = function () {
	            if (_this.state.isDatePickerShown) {
	                _this.setState({
	                    isDatePickerShown: false
	                }, function () {
	                    // setState is async, so we must call validate in a callback
	                    _this._validateTextInput();
	                });
	            }
	        };
	        /**
	         * Callback for closing the calendar callout
	         */
	        _this._calendarDismissed = function () {
	            _this._preventFocusOpeningPicker = true;
	            _this._dismissDatePickerPopup();
	            // don't need to focus the text box, if necessary the focusTrapZone will do it
	        };
	        _this._handleEscKey = function (ev) {
	            if (_this.state.isDatePickerShown) {
	                ev.stopPropagation();
	            }
	            _this._calendarDismissed();
	        };
	        _this._validateTextInput = function () {
	            var _a = _this.props, isRequired = _a.isRequired, allowTextInput = _a.allowTextInput, strings = _a.strings, parseDateFromString = _a.parseDateFromString, onSelectDate = _a.onSelectDate, formatDate = _a.formatDate, minDate = _a.minDate, maxDate = _a.maxDate;
	            var inputValue = _this.state.formattedDate;
	            // Do validation only if DatePicker's popup is dismissed
	            if (_this.state.isDatePickerShown) {
	                return;
	            }
	            if (allowTextInput) {
	                var date = null;
	                if (inputValue) {
	                    // Don't parse if the selected date has the same formatted string as what we're about to parse.
	                    // The formatted string might be ambiguous (ex: "1/2/3" or "New Year Eve") and the parser might
	                    // not be able to come up with the exact same date.
	                    if (_this.state.selectedDate && formatDate && formatDate(_this.state.selectedDate) === inputValue) {
	                        return;
	                    }
	                    else {
	                        date = parseDateFromString(inputValue);
	                        // Check if date is null, or date is Invalid Date
	                        if (!date || isNaN(date.getTime())) {
	                            // Reset invalid input field, if formatting is available
	                            if (formatDate) {
	                                date = _this.state.selectedDate;
	                                _this.setState({
	                                    formattedDate: formatDate(date).toString()
	                                });
	                            }
	                            _this.setState({
	                                errorMessage: strings.invalidInputErrorMessage || ' '
	                            });
	                        }
	                        else {
	                            // Check against optional date boundaries
	                            if (_this._isDateOutOfBounds(date, minDate, maxDate)) {
	                                _this.setState({
	                                    errorMessage: strings.isOutOfBoundsErrorMessage || ' '
	                                });
	                            }
	                            else {
	                                _this.setState({
	                                    selectedDate: date,
	                                    errorMessage: ''
	                                });
	                                // When formatting is available. If formatted date is valid, but is different from input, update with formatted date
	                                // This occurs when an invalid date is entered twice
	                                if (formatDate && formatDate(date) !== inputValue) {
	                                    _this.setState({
	                                        formattedDate: formatDate(date).toString()
	                                    });
	                                }
	                            }
	                        }
	                    }
	                }
	                else {
	                    // Only show error for empty inputValue if it is a required field
	                    _this.setState({
	                        errorMessage: isRequired ? strings.isRequiredErrorMessage || ' ' : ''
	                    });
	                }
	                // Execute onSelectDate callback
	                if (onSelectDate) {
	                    // If no input date string or input date string is invalid
	                    // date variable will be null, callback should expect null value for this case
	                    onSelectDate(date);
	                }
	            }
	            else if (isRequired && !inputValue) {
	                // Check when DatePicker is a required field but has NO input value
	                _this.setState({
	                    errorMessage: strings.isRequiredErrorMessage || ' '
	                });
	            }
	        };
	        _this.state = _this._getDefaultState();
	        _this._id = props.id || Utilities_1.getId('DatePicker');
	        _this._preventFocusOpeningPicker = false;
	        return _this;
	    }
	    DatePickerBase.prototype.componentWillReceiveProps = function (nextProps) {
	        var formatDate = nextProps.formatDate, value = nextProps.value;
	        if (DateMath_1.compareDates(this.props.minDate, nextProps.minDate) &&
	            DateMath_1.compareDates(this.props.maxDate, nextProps.maxDate) &&
	            this.props.isRequired === nextProps.isRequired &&
	            DateMath_1.compareDates(this.state.selectedDate, value) &&
	            this.props.formatDate === formatDate) {
	            // if the props we care about haven't changed, don't run validation or updates
	            return;
	        }
	        this._setErrorMessage(true, nextProps);
	        this._id = nextProps.id || this._id;
	        // Issue# 1274: Check if the date value changed from old value, i.e., if indeed a new date is being
	        // passed in or if the formatting function was modified. We only update the selected date if either of these
	        // had a legit change. Note tha the bug will still repro when only the formatDate was passed in props and this
	        // is the result of the onSelectDate callback, but this should be a rare scenario.
	        var oldValue = this.state.selectedDate;
	        if (!DateMath_1.compareDates(oldValue, value) || this.props.formatDate !== formatDate) {
	            this.setState({
	                selectedDate: value || undefined,
	                formattedDate: formatDate && value ? formatDate(value) : ''
	            });
	        }
	    };
	    DatePickerBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (prevState.isDatePickerShown && !this.state.isDatePickerShown) {
	            // If DatePicker's menu (Calendar) is closed, run onAfterMenuDismiss
	            if (this.props.onAfterMenuDismiss) {
	                this.props.onAfterMenuDismiss();
	            }
	        }
	    };
	    DatePickerBase.prototype.render = function () {
	        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, strings = _a.strings, label = _a.label, theme = _a.theme, className = _a.className, styles = _a.styles, initialPickerDate = _a.initialPickerDate, isRequired = _a.isRequired, disabled = _a.disabled, ariaLabel = _a.ariaLabel, pickerAriaLabel = _a.pickerAriaLabel, placeholder = _a.placeholder, allowTextInput = _a.allowTextInput, borderless = _a.borderless, minDate = _a.minDate, maxDate = _a.maxDate, showCloseButton = _a.showCloseButton, calendarProps = _a.calendarProps, calloutProps = _a.calloutProps, textFieldProps = _a.textField, underlined = _a.underlined, allFocusable = _a.allFocusable, _b = _a.calendarAs, CalendarType = _b === void 0 ? Calendar_1.Calendar : _b, tabIndex = _a.tabIndex;
	        var _c = this.state, isDatePickerShown = _c.isDatePickerShown, formattedDate = _c.formattedDate, selectedDate = _c.selectedDate;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            disabled: disabled,
	            label: !!label,
	            isDatePickerShown: isDatePickerShown
	        });
	        var calloutId = Utilities_1.getId('DatePicker-Callout');
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['value']);
	        var iconProps = textFieldProps && textFieldProps.iconProps;
	        return (React.createElement("div", tslib_1.__assign({}, nativeProps, { className: classNames.root }),
	            React.createElement("div", { ref: this._datePickerDiv, role: "combobox", "aria-expanded": isDatePickerShown, "aria-haspopup": "true", "aria-owns": isDatePickerShown ? calloutId : undefined },
	                React.createElement(TextField_1.TextField, tslib_1.__assign({ label: label, ariaLabel: ariaLabel, "aria-controls": isDatePickerShown ? calloutId : undefined, required: isRequired, disabled: disabled, errorMessage: this._getErrorMessage(), placeholder: placeholder, borderless: borderless, value: formattedDate, componentRef: this._textField, underlined: underlined, tabIndex: tabIndex, readOnly: !allowTextInput }, textFieldProps, { id: this._id + '-label', className: Utilities_1.css(classNames.textField, textFieldProps && textFieldProps.className), iconProps: tslib_1.__assign({ iconName: 'Calendar' }, iconProps, { className: Utilities_1.css(classNames.icon, iconProps && iconProps.className), onClick: this._onIconClick }), onKeyDown: this._onTextFieldKeyDown, onFocus: this._onTextFieldFocus, onBlur: this._onTextFieldBlur, onClick: this._onTextFieldClick, onChange: this._onTextFieldChanged }))),
	            isDatePickerShown && (React.createElement(Callout_1.Callout, tslib_1.__assign({ id: calloutId, role: "dialog", ariaLabel: pickerAriaLabel, isBeakVisible: false, gapSpace: 0, doNotLayer: false, target: this._datePickerDiv.current, directionalHint: DirectionalHint_1.DirectionalHint.bottomLeftEdge }, calloutProps, { className: Utilities_1.css(classNames.callout, calloutProps && calloutProps.className), onDismiss: this._calendarDismissed, onPositioned: this._onCalloutPositioned }),
	                React.createElement(FocusTrapZone_1.FocusTrapZone, { isClickableOutsideFocusTrap: true, disableFirstFocus: this.props.disableAutoFocus, forceFocusInsideTrap: false },
	                    React.createElement(CalendarType, tslib_1.__assign({}, calendarProps, { onSelectDate: this._onSelectDate, onDismiss: this._calendarDismissed, isMonthPickerVisible: this.props.isMonthPickerVisible, showMonthPickerAsOverlay: this.props.showMonthPickerAsOverlay, today: this.props.today, value: selectedDate || initialPickerDate, firstDayOfWeek: firstDayOfWeek, strings: strings, highlightCurrentMonth: this.props.highlightCurrentMonth, highlightSelectedMonth: this.props.highlightSelectedMonth, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, showGoToToday: this.props.showGoToToday, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, componentRef: this._calendar, showCloseButton: showCloseButton, allFocusable: allFocusable })))))));
	    };
	    DatePickerBase.prototype.focus = function () {
	        if (this._textField.current) {
	            this._textField.current.focus();
	        }
	    };
	    DatePickerBase.prototype.reset = function () {
	        this.setState(this._getDefaultState());
	    };
	    DatePickerBase.prototype._setErrorMessage = function (setState, nextProps) {
	        var _a = nextProps || this.props, isRequired = _a.isRequired, strings = _a.strings, value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, initialPickerDate = _a.initialPickerDate;
	        var errorMessage = !initialPickerDate && isRequired && !value ? strings.isRequiredErrorMessage || ' ' : undefined;
	        if (!errorMessage && value) {
	            errorMessage = this._isDateOutOfBounds(value, minDate, maxDate) ? strings.isOutOfBoundsErrorMessage || ' ' : undefined;
	        }
	        if (setState) {
	            this.setState({
	                errorMessage: errorMessage
	            });
	        }
	        return errorMessage;
	    };
	    DatePickerBase.prototype._showDatePickerPopup = function () {
	        if (!this.state.isDatePickerShown) {
	            this._preventFocusOpeningPicker = true;
	            this.setState({
	                isDatePickerShown: true
	            });
	        }
	    };
	    DatePickerBase.prototype._getDefaultState = function (props) {
	        if (props === void 0) { props = this.props; }
	        return {
	            selectedDate: props.value || undefined,
	            formattedDate: props.formatDate && props.value ? props.formatDate(props.value) : '',
	            isDatePickerShown: false,
	            errorMessage: this._setErrorMessage(false)
	        };
	    };
	    DatePickerBase.prototype._isDateOutOfBounds = function (date, minDate, maxDate) {
	        return (!!minDate && DateMath_1.compareDatePart(minDate, date) > 0) || (!!maxDate && DateMath_1.compareDatePart(maxDate, date) < 0);
	    };
	    DatePickerBase.prototype._getErrorMessage = function () {
	        if (this.state.isDatePickerShown) {
	            return undefined;
	        }
	        return this.state.errorMessage;
	    };
	    DatePickerBase.defaultProps = {
	        allowTextInput: false,
	        formatDate: function (date) {
	            if (date) {
	                return date.toDateString();
	            }
	            return '';
	        },
	        parseDateFromString: function (dateStr) {
	            var date = Date.parse(dateStr);
	            if (date) {
	                return new Date(date);
	            }
	            return null;
	        },
	        firstDayOfWeek: Calendar_1.DayOfWeek.Sunday,
	        initialPickerDate: new Date(),
	        isRequired: false,
	        isMonthPickerVisible: true,
	        showMonthPickerAsOverlay: false,
	        strings: DEFAULT_STRINGS,
	        highlightCurrentMonth: false,
	        highlightSelectedMonth: false,
	        borderless: false,
	        pickerAriaLabel: 'Calendar',
	        showWeekNumbers: false,
	        firstWeekOfYear: DateValues_1.FirstWeekOfYear.FirstDay,
	        showGoToToday: true,
	        dateTimeFormatter: undefined,
	        showCloseButton: false,
	        underlined: false,
	        allFocusable: false
	    };
	    return DatePickerBase;
	}(Utilities_1.BaseComponent));
	exports.DatePickerBase = DatePickerBase;
	//# sourceMappingURL=DatePicker.base.js.map

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DatePicker',
	    callout: 'ms-DatePicker-callout',
	    withLabel: 'ms-DatePicker-event--with-label',
	    withoutLabel: 'ms-DatePicker-event--without-label',
	    disabled: 'msDatePickerDisabled '
	};
	exports.styles = function (props) {
	    var className = props.className, theme = props.theme, disabled = props.disabled, label = props.label, isDatePickerShown = props.isDatePickerShown;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var DatePickerEvent = {
	        color: palette.neutralSecondary,
	        fontSize: Styling_1.FontSizes.icon,
	        lineHeight: '18px',
	        pointerEvents: 'none',
	        position: 'absolute',
	        right: '9px'
	    };
	    return {
	        root: [classNames.root, theme.fonts.medium, isDatePickerShown && 'is-open', Styling_1.normalize, className],
	        textField: [
	            {
	                position: 'relative',
	                selectors: {
	                    '& input[readonly]': {
	                        cursor: 'pointer'
	                    },
	                    input: {
	                        selectors: {
	                            '::-ms-clear': {
	                                display: 'none'
	                            }
	                        }
	                    }
	                }
	            },
	            disabled && {
	                selectors: {
	                    '& input[readonly]': {
	                        cursor: 'default'
	                    }
	                }
	            }
	        ],
	        callout: [classNames.callout],
	        icon: [
	            DatePickerEvent,
	            !label && [classNames.withoutLabel, { top: '7px' }],
	            label && [classNames.withLabel, { bottom: '5px' }],
	            !disabled && [
	                classNames.disabled,
	                {
	                    pointerEvents: 'initial',
	                    cursor: 'pointer'
	                }
	            ],
	            disabled && {
	                color: semanticColors.disabledText,
	                cursor: 'default'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=DatePicker.styles.js.map

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(865), exports);
	//# sourceMappingURL=DetailsList.js.map

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(866), exports);
	tslib_1.__exportStar(__webpack_require__(870), exports);
	tslib_1.__exportStar(__webpack_require__(871), exports);
	tslib_1.__exportStar(__webpack_require__(872), exports);
	tslib_1.__exportStar(__webpack_require__(905), exports);
	tslib_1.__exportStar(__webpack_require__(906), exports);
	tslib_1.__exportStar(__webpack_require__(907), exports);
	tslib_1.__exportStar(__webpack_require__(873), exports);
	tslib_1.__exportStar(__webpack_require__(908), exports);
	tslib_1.__exportStar(__webpack_require__(909), exports);
	tslib_1.__exportStar(__webpack_require__(897), exports);
	tslib_1.__exportStar(__webpack_require__(903), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(867), exports);
	tslib_1.__exportStar(__webpack_require__(868), exports);
	tslib_1.__exportStar(__webpack_require__(869), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utilities_1 = __webpack_require__(489);
	exports.SELECTION_CHANGE = utilities_1.SELECTION_CHANGE;
	exports.SelectionDirection = utilities_1.SelectionDirection;
	exports.SelectionMode = utilities_1.SelectionMode;
	//# sourceMappingURL=interfaces.js.map

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utilities_1 = __webpack_require__(489);
	exports.Selection = utilities_1.Selection;
	//# sourceMappingURL=Selection.js.map

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var interfaces_1 = __webpack_require__(867);
	// Selection definitions:
	//
	// Anchor index: the point from which a range selection starts.
	// Focus index: the point from which layout movement originates from.
	//
	// These two can differ. Tests:
	//
	// If you start at index 5
	// Shift click to index 10
	//    The focus is 10, the anchor is 5.
	// If you shift click at index 0
	//    The anchor remains at 5, the items between 0 and 5 are selected and everything else is cleared.
	// If you click index 8
	//    The anchor and focus are set to 8.
	var SELECTION_DISABLED_ATTRIBUTE_NAME = 'data-selection-disabled';
	var SELECTION_INDEX_ATTRIBUTE_NAME = 'data-selection-index';
	var SELECTION_TOGGLE_ATTRIBUTE_NAME = 'data-selection-toggle';
	var SELECTION_INVOKE_ATTRIBUTE_NAME = 'data-selection-invoke';
	var SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME = 'data-selection-all-toggle';
	var SELECTION_SELECT_ATTRIBUTE_NAME = 'data-selection-select';
	/**
	 * {@docCategory Selection}
	 */
	var SelectionZone = /** @class */ (function (_super) {
	    tslib_1.__extends(SelectionZone, _super);
	    function SelectionZone() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._root = React.createRef();
	        /**
	         * In some cases, the consuming scenario requires to set focus on a row without having SelectionZone
	         * react to the event. Note that focus events in IE \<= 11 will occur asynchronously after .focus() has
	         * been called on an element, so we need a flag to store the idea that we will bypass the "next"
	         * focus event that occurs. This method does that.
	         */
	        _this.ignoreNextFocus = function () {
	            _this._handleNextFocus(false);
	        };
	        _this._onMouseDownCapture = function (ev) {
	            if (document.activeElement !== ev.target && !Utilities_1.elementContains(document.activeElement, ev.target)) {
	                _this.ignoreNextFocus();
	                return;
	            }
	            if (!Utilities_1.elementContains(ev.target, _this._root.current)) {
	                return;
	            }
	            var target = ev.target;
	            while (target !== _this._root.current) {
	                if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
	                    _this.ignoreNextFocus();
	                    break;
	                }
	                target = Utilities_1.getParent(target);
	            }
	        };
	        /**
	         * When we focus an item, for single/multi select scenarios, we should try to select it immediately
	         * as long as the focus did not originate from a mouse down/touch event. For those cases, we handle them
	         * specially.
	         */
	        _this._onFocus = function (ev) {
	            var target = ev.target;
	            var selection = _this.props.selection;
	            var isToggleModifierPressed = _this._isCtrlPressed || _this._isMetaPressed;
	            var selectionMode = _this._getSelectionMode();
	            if (_this._shouldHandleFocus && selectionMode !== interfaces_1.SelectionMode.none) {
	                var isToggle = _this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME);
	                var itemRoot = _this._findItemRoot(target);
	                if (!isToggle && itemRoot) {
	                    var index = _this._getItemIndex(itemRoot);
	                    if (isToggleModifierPressed) {
	                        // set anchor only.
	                        selection.setIndexSelected(index, selection.isIndexSelected(index), true);
	                        if (_this.props.enterModalOnTouch && _this._isTouch && selection.setModal) {
	                            selection.setModal(true);
	                            _this._setIsTouch(false);
	                        }
	                    }
	                    else {
	                        if (_this.props.isSelectedOnFocus) {
	                            _this._onItemSurfaceClick(ev, index);
	                        }
	                    }
	                }
	            }
	            _this._handleNextFocus(false);
	        };
	        _this._onMouseDown = function (ev) {
	            _this._updateModifiers(ev);
	            var target = ev.target;
	            var itemRoot = _this._findItemRoot(target);
	            // No-op if selection is disabled
	            if (_this._isSelectionDisabled(target)) {
	                return;
	            }
	            while (target !== _this._root.current) {
	                if (_this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
	                    break;
	                }
	                else if (itemRoot) {
	                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
	                        break;
	                    }
	                    else if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
	                        break;
	                    }
	                    else if ((target === itemRoot || _this._shouldAutoSelect(target)) &&
	                        !_this._isShiftPressed &&
	                        !_this._isCtrlPressed &&
	                        !_this._isMetaPressed) {
	                        _this._onInvokeMouseDown(ev, _this._getItemIndex(itemRoot));
	                        break;
	                    }
	                    else if (_this.props.disableAutoSelectOnInputElements &&
	                        (target.tagName === 'A' || target.tagName === 'BUTTON' || target.tagName === 'INPUT')) {
	                        return;
	                    }
	                }
	                target = Utilities_1.getParent(target);
	            }
	        };
	        _this._onTouchStartCapture = function (ev) {
	            _this._setIsTouch(true);
	        };
	        _this._onClick = function (ev) {
	            _this._updateModifiers(ev);
	            var target = ev.target;
	            var itemRoot = _this._findItemRoot(target);
	            var isSelectionDisabled = _this._isSelectionDisabled(target);
	            while (target !== _this._root.current) {
	                if (_this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
	                    if (!isSelectionDisabled) {
	                        _this._onToggleAllClick(ev);
	                    }
	                    break;
	                }
	                else if (itemRoot) {
	                    var index = _this._getItemIndex(itemRoot);
	                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
	                        if (!isSelectionDisabled) {
	                            if (_this._isShiftPressed) {
	                                _this._onItemSurfaceClick(ev, index);
	                            }
	                            else {
	                                _this._onToggleClick(ev, index);
	                            }
	                        }
	                        break;
	                    }
	                    else if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
	                        // Items should be invokable even if selection is disabled.
	                        _this._onInvokeClick(ev, index);
	                        break;
	                    }
	                    else if (target === itemRoot) {
	                        if (!isSelectionDisabled) {
	                            _this._onItemSurfaceClick(ev, index);
	                        }
	                        break;
	                    }
	                    else if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
	                        return;
	                    }
	                }
	                target = Utilities_1.getParent(target);
	            }
	        };
	        _this._onContextMenu = function (ev) {
	            var target = ev.target;
	            var _a = _this.props, onItemContextMenu = _a.onItemContextMenu, selection = _a.selection;
	            if (onItemContextMenu) {
	                var itemRoot = _this._findItemRoot(target);
	                if (itemRoot) {
	                    var index = _this._getItemIndex(itemRoot);
	                    _this._onInvokeMouseDown(ev, index);
	                    var skipPreventDefault = onItemContextMenu(selection.getItems()[index], index, ev.nativeEvent);
	                    // In order to keep back compat, if the value here is undefined, then we should still
	                    // call preventDefault(). Only in the case where true is explicitly returned should
	                    // the call be skipped.
	                    if (!skipPreventDefault) {
	                        ev.preventDefault();
	                    }
	                }
	            }
	        };
	        /**
	         * In multi selection, if you double click within an item's root (but not within the invoke element or input elements),
	         * we should execute the invoke handler.
	         */
	        _this._onDoubleClick = function (ev) {
	            var target = ev.target;
	            var onItemInvoked = _this.props.onItemInvoked;
	            var itemRoot = _this._findItemRoot(target);
	            if (itemRoot && onItemInvoked && !_this._isInputElement(target)) {
	                var index = _this._getItemIndex(itemRoot);
	                while (target !== _this._root.current) {
	                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME) || _this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
	                        break;
	                    }
	                    else if (target === itemRoot) {
	                        _this._onInvokeClick(ev, index);
	                        break;
	                    }
	                    target = Utilities_1.getParent(target);
	                }
	                target = Utilities_1.getParent(target);
	            }
	        };
	        _this._onKeyDownCapture = function (ev) {
	            _this._updateModifiers(ev);
	            _this._handleNextFocus(true);
	        };
	        _this._onKeyDown = function (ev) {
	            _this._updateModifiers(ev);
	            var target = ev.target;
	            var isSelectionDisabled = _this._isSelectionDisabled(target);
	            var selection = _this.props.selection;
	            var isSelectAllKey = ev.which === Utilities_1.KeyCodes.a && (_this._isCtrlPressed || _this._isMetaPressed);
	            var isClearSelectionKey = ev.which === Utilities_1.KeyCodes.escape;
	            // Ignore key downs from input elements.
	            if (_this._isInputElement(target)) {
	                // A key was pressed while an item in this zone was focused.
	                return;
	            }
	            var selectionMode = _this._getSelectionMode();
	            // If ctrl-a is pressed, select all (if all are not already selected.)
	            if (isSelectAllKey && selectionMode === interfaces_1.SelectionMode.multiple && !selection.isAllSelected()) {
	                if (!isSelectionDisabled) {
	                    selection.setAllSelected(true);
	                }
	                ev.stopPropagation();
	                ev.preventDefault();
	                return;
	            }
	            // If escape is pressed, clear selection (if any are selected.)
	            if (isClearSelectionKey && selection.getSelectedCount() > 0) {
	                if (!isSelectionDisabled) {
	                    selection.setAllSelected(false);
	                }
	                ev.stopPropagation();
	                ev.preventDefault();
	                return;
	            }
	            var itemRoot = _this._findItemRoot(target);
	            // If a key was pressed within an item, we should treat "enters" as invokes and "space" as toggle
	            if (itemRoot) {
	                var index = _this._getItemIndex(itemRoot);
	                while (target !== _this._root.current) {
	                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
	                        // For toggle elements, assuming they are rendered as buttons, they will generate a click event,
	                        // so we can no-op for any keydowns in this case.
	                        break;
	                    }
	                    else if (_this._shouldAutoSelect(target)) {
	                        if (!isSelectionDisabled) {
	                            // If the event went to an element which should trigger auto-select, select it and then let
	                            // the default behavior kick in.
	                            _this._onInvokeMouseDown(ev, index);
	                        }
	                        break;
	                    }
	                    else if ((ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space) &&
	                        (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT')) {
	                        return false;
	                    }
	                    else if (target === itemRoot) {
	                        if (ev.which === Utilities_1.KeyCodes.enter) {
	                            // Items should be invokable even if selection is disabled.
	                            _this._onInvokeClick(ev, index);
	                            ev.preventDefault();
	                            return;
	                        }
	                        else if (ev.which === Utilities_1.KeyCodes.space) {
	                            if (!isSelectionDisabled) {
	                                _this._onToggleClick(ev, index);
	                            }
	                            ev.preventDefault();
	                            return;
	                        }
	                        break;
	                    }
	                    target = Utilities_1.getParent(target);
	                }
	            }
	        };
	        return _this;
	    }
	    SelectionZone.prototype.componentDidMount = function () {
	        var win = Utilities_1.getWindow(this._root.current);
	        // Track the latest modifier keys globally.
	        this._events.on(win, 'keydown, keyup', this._updateModifiers, true);
	        this._events.on(document, 'click', this._findScrollParentAndTryClearOnEmptyClick);
	        this._events.on(document.body, 'touchstart', this._onTouchStartCapture, true);
	        this._events.on(document.body, 'touchend', this._onTouchStartCapture, true);
	    };
	    SelectionZone.prototype.render = function () {
	        return (React.createElement("div", tslib_1.__assign({ className: "ms-SelectionZone", ref: this._root, onKeyDown: this._onKeyDown, onMouseDown: this._onMouseDown, onKeyDownCapture: this._onKeyDownCapture, onClick: this._onClick, role: "presentation", onDoubleClick: this._onDoubleClick, onContextMenu: this._onContextMenu }, {
	            onMouseDownCapture: this._onMouseDownCapture,
	            onFocusCapture: this._onFocus
	        }), this.props.children));
	    };
	    SelectionZone.prototype._isSelectionDisabled = function (target) {
	        if (this._getSelectionMode() === interfaces_1.SelectionMode.none) {
	            return true;
	        }
	        while (target !== this._root.current) {
	            if (this._hasAttribute(target, SELECTION_DISABLED_ATTRIBUTE_NAME)) {
	                return true;
	            }
	            target = Utilities_1.getParent(target);
	        }
	        return false;
	    };
	    SelectionZone.prototype._onToggleAllClick = function (ev) {
	        var selection = this.props.selection;
	        var selectionMode = this._getSelectionMode();
	        if (selectionMode === interfaces_1.SelectionMode.multiple) {
	            selection.toggleAllSelected();
	            ev.stopPropagation();
	            ev.preventDefault();
	        }
	    };
	    SelectionZone.prototype._onToggleClick = function (ev, index) {
	        var selection = this.props.selection;
	        var selectionMode = this._getSelectionMode();
	        selection.setChangeEvents(false);
	        if (this.props.enterModalOnTouch && this._isTouch && !selection.isIndexSelected(index) && selection.setModal) {
	            selection.setModal(true);
	            this._setIsTouch(false);
	        }
	        if (selectionMode === interfaces_1.SelectionMode.multiple) {
	            selection.toggleIndexSelected(index);
	        }
	        else if (selectionMode === interfaces_1.SelectionMode.single) {
	            var isSelected = selection.isIndexSelected(index);
	            var isModal = selection.isModal && selection.isModal();
	            selection.setAllSelected(false);
	            selection.setIndexSelected(index, !isSelected, true);
	            if (isModal && selection.setModal) {
	                // Since the above call to setAllSelected(false) clears modal state,
	                // restore it. This occurs because the SelectionMode of the Selection
	                // may differ from the SelectionZone.
	                selection.setModal(true);
	            }
	        }
	        else {
	            selection.setChangeEvents(true);
	            return;
	        }
	        selection.setChangeEvents(true);
	        ev.stopPropagation();
	        // NOTE: ev.preventDefault is not called for toggle clicks, because this will kill the browser behavior
	        // for checkboxes if you use a checkbox for the toggle.
	    };
	    SelectionZone.prototype._onInvokeClick = function (ev, index) {
	        var _a = this.props, selection = _a.selection, onItemInvoked = _a.onItemInvoked;
	        if (onItemInvoked) {
	            onItemInvoked(selection.getItems()[index], index, ev.nativeEvent);
	            ev.preventDefault();
	            ev.stopPropagation();
	        }
	    };
	    SelectionZone.prototype._onItemSurfaceClick = function (ev, index) {
	        var selection = this.props.selection;
	        var isToggleModifierPressed = this._isCtrlPressed || this._isMetaPressed;
	        var selectionMode = this._getSelectionMode();
	        if (selectionMode === interfaces_1.SelectionMode.multiple) {
	            if (this._isShiftPressed && !this._isTabPressed) {
	                selection.selectToIndex(index, !isToggleModifierPressed);
	            }
	            else if (isToggleModifierPressed) {
	                selection.toggleIndexSelected(index);
	            }
	            else {
	                this._clearAndSelectIndex(index);
	            }
	        }
	        else if (selectionMode === interfaces_1.SelectionMode.single) {
	            this._clearAndSelectIndex(index);
	        }
	    };
	    SelectionZone.prototype._onInvokeMouseDown = function (ev, index) {
	        var selection = this.props.selection;
	        // Only do work if item is not selected.
	        if (selection.isIndexSelected(index)) {
	            return;
	        }
	        this._clearAndSelectIndex(index);
	    };
	    /**
	     * To avoid high startup cost of traversing the DOM on component mount,
	     * defer finding the scrollable parent until a click interaction.
	     *
	     * The styles will probably already calculated since we're running in a click handler,
	     * so this is less likely to cause layout thrashing then doing it in mount.
	     */
	    SelectionZone.prototype._findScrollParentAndTryClearOnEmptyClick = function (ev) {
	        var scrollParent = Utilities_1.findScrollableParent(this._root.current);
	        // unbind this handler and replace binding with a binding on the actual scrollable parent
	        this._events.off(document, 'click', this._findScrollParentAndTryClearOnEmptyClick);
	        this._events.on(scrollParent, 'click', this._tryClearOnEmptyClick);
	        // If we clicked inside the scrollable parent, call through to the handler on this click.
	        if ((scrollParent && ev.target instanceof Node && scrollParent.contains(ev.target)) || scrollParent === ev.target) {
	            this._tryClearOnEmptyClick(ev);
	        }
	    };
	    SelectionZone.prototype._tryClearOnEmptyClick = function (ev) {
	        if (!this.props.selectionPreservedOnEmptyClick && this._isNonHandledClick(ev.target)) {
	            this.props.selection.setAllSelected(false);
	        }
	    };
	    SelectionZone.prototype._clearAndSelectIndex = function (index) {
	        var selection = this.props.selection;
	        var isAlreadySingleSelected = selection.getSelectedCount() === 1 && selection.isIndexSelected(index);
	        if (!isAlreadySingleSelected) {
	            selection.setChangeEvents(false);
	            selection.setAllSelected(false);
	            selection.setIndexSelected(index, true, true);
	            if (this.props.enterModalOnTouch && this._isTouch && selection.setModal) {
	                selection.setModal(true);
	                this._setIsTouch(false);
	            }
	            selection.setChangeEvents(true);
	        }
	    };
	    /**
	     * We need to track the modifier key states so that when focus events occur, which do not contain
	     * modifier states in the Event object, we know how to behave.
	     */
	    SelectionZone.prototype._updateModifiers = function (ev) {
	        this._isShiftPressed = ev.shiftKey;
	        this._isCtrlPressed = ev.ctrlKey;
	        this._isMetaPressed = ev.metaKey;
	        var keyCode = ev.keyCode;
	        this._isTabPressed = keyCode ? keyCode === Utilities_1.KeyCodes.tab : false;
	    };
	    SelectionZone.prototype._findItemRoot = function (target) {
	        var selection = this.props.selection;
	        while (target !== this._root.current) {
	            var indexValue = target.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME);
	            var index = Number(indexValue);
	            if (indexValue !== null && index >= 0 && index < selection.getItems().length) {
	                break;
	            }
	            target = Utilities_1.getParent(target);
	        }
	        if (target === this._root.current) {
	            return undefined;
	        }
	        return target;
	    };
	    SelectionZone.prototype._getItemIndex = function (itemRoot) {
	        return Number(itemRoot.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME));
	    };
	    SelectionZone.prototype._shouldAutoSelect = function (element) {
	        return this._hasAttribute(element, SELECTION_SELECT_ATTRIBUTE_NAME);
	    };
	    SelectionZone.prototype._hasAttribute = function (element, attributeName) {
	        var isToggle = false;
	        while (!isToggle && element !== this._root.current) {
	            isToggle = element.getAttribute(attributeName) === 'true';
	            element = Utilities_1.getParent(element);
	        }
	        return isToggle;
	    };
	    SelectionZone.prototype._isInputElement = function (element) {
	        return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
	    };
	    SelectionZone.prototype._isNonHandledClick = function (element) {
	        var doc = Utilities_1.getDocument();
	        if (doc && element) {
	            while (element && element !== doc.documentElement) {
	                if (Utilities_1.isElementTabbable(element)) {
	                    return false;
	                }
	                element = Utilities_1.getParent(element);
	            }
	        }
	        return true;
	    };
	    SelectionZone.prototype._handleNextFocus = function (handleFocus) {
	        var _this = this;
	        if (this._shouldHandleFocusTimeoutId) {
	            this._async.clearTimeout(this._shouldHandleFocusTimeoutId);
	            this._shouldHandleFocusTimeoutId = undefined;
	        }
	        this._shouldHandleFocus = handleFocus;
	        if (handleFocus) {
	            this._async.setTimeout(function () {
	                _this._shouldHandleFocus = false;
	            }, 100);
	        }
	    };
	    SelectionZone.prototype._setIsTouch = function (isTouch) {
	        var _this = this;
	        if (this._isTouchTimeoutId) {
	            this._async.clearTimeout(this._isTouchTimeoutId);
	            this._isTouchTimeoutId = undefined;
	        }
	        this._isTouch = true;
	        if (isTouch) {
	            this._async.setTimeout(function () {
	                _this._isTouch = false;
	            }, 300);
	        }
	    };
	    SelectionZone.prototype._getSelectionMode = function () {
	        var selection = this.props.selection;
	        var _a = this.props.selectionMode, selectionMode = _a === void 0 ? selection ? selection.mode : interfaces_1.SelectionMode.none : _a;
	        return selectionMode;
	    };
	    SelectionZone.defaultProps = {
	        isMultiSelectEnabled: true,
	        isSelectedOnFocus: true,
	        selectionMode: interfaces_1.SelectionMode.multiple
	    };
	    return SelectionZone;
	}(Utilities_1.BaseComponent));
	exports.SelectionZone = SelectionZone;
	//# sourceMappingURL=SelectionZone.js.map

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory GroupedList}
	 */
	var CollapseAllVisibility;
	(function (CollapseAllVisibility) {
	    CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
	    CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
	})(CollapseAllVisibility = exports.CollapseAllVisibility || (exports.CollapseAllVisibility = {}));
	//# sourceMappingURL=GroupedList.types.js.map

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DetailsHeader_base_1 = __webpack_require__(872);
	var DetailsHeader_styles_1 = __webpack_require__(899);
	exports.DetailsHeader = Utilities_1.styled(DetailsHeader_base_1.DetailsHeaderBase, DetailsHeader_styles_1.getStyles, undefined, { scope: 'DetailsHeader' });
	//# sourceMappingURL=DetailsHeader.js.map

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var react_dom_1 = __webpack_require__(41);
	var Utilities_1 = __webpack_require__(592);
	var DetailsList_types_1 = __webpack_require__(873);
	var FocusZone_1 = __webpack_require__(676);
	var Icon_1 = __webpack_require__(643);
	var Layer_1 = __webpack_require__(617);
	var GroupSpacer_1 = __webpack_require__(874);
	var GroupedList_1 = __webpack_require__(875);
	var DetailsRowCheck_1 = __webpack_require__(897);
	var interfaces_1 = __webpack_require__(867);
	var index_1 = __webpack_require__(900);
	var DetailsColumn_1 = __webpack_require__(902);
	var DetailsHeader_types_1 = __webpack_require__(905);
	var Utilities_2 = __webpack_require__(592);
	var getClassNames = Utilities_2.classNamesFunction();
	var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
	var MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
	var NO_COLUMNS = [];
	var DetailsHeaderBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetailsHeaderBase, _super);
	    function DetailsHeaderBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._rootComponent = React.createRef();
	        _this._draggedColumnIndex = -1;
	        _this._dropHintDetails = {};
	        _this._updateDroppingState = function (newValue, event) {
	            if (_this._draggedColumnIndex >= 0 && event.type !== 'drop') {
	                if (!newValue) {
	                    _this._resetDropHints();
	                }
	            }
	        };
	        _this._onDragOver = function (item, event) {
	            if (_this._draggedColumnIndex >= 0) {
	                event.stopPropagation();
	                _this._computeDropHintToBeShown(event.clientX);
	            }
	        };
	        _this._onDrop = function (item, event) {
	            var columnReorderProps = _this.state.columnReorderProps;
	            // Target index will not get changed if draggeditem is after target item.
	            if (_this._draggedColumnIndex >= 0 && event) {
	                var targetIndex = _this._draggedColumnIndex > _this._currentDropHintIndex ? _this._currentDropHintIndex : _this._currentDropHintIndex - 1;
	                var isValidDrop = _this._isValidCurrentDropHintIndex();
	                event.stopPropagation();
	                if (isValidDrop) {
	                    _this._onDropIndexInfo.sourceIndex = _this._draggedColumnIndex;
	                    _this._onDropIndexInfo.targetIndex = targetIndex;
	                    if (columnReorderProps && columnReorderProps.onColumnDrop) {
	                        var dragDropDetails = {
	                            draggedIndex: _this._draggedColumnIndex,
	                            targetIndex: targetIndex
	                        };
	                        columnReorderProps.onColumnDrop(dragDropDetails);
	                    }
	                    else if (columnReorderProps && columnReorderProps.handleColumnReorder) {
	                        columnReorderProps.handleColumnReorder(_this._draggedColumnIndex, targetIndex);
	                    }
	                }
	            }
	            _this._resetDropHints();
	            _this._dropHintDetails = {};
	            _this._draggedColumnIndex = -1;
	        };
	        _this._updateDragInfo = function (props, event) {
	            var columnReorderProps = _this.state.columnReorderProps;
	            var itemIndex = props.itemIndex;
	            if (itemIndex >= 0) {
	                // Column index is set based on the checkbox
	                _this._draggedColumnIndex = _this._isCheckboxColumnHidden() ? itemIndex - 1 : itemIndex - 2;
	                _this._getDropHintPositions();
	                if (columnReorderProps && columnReorderProps.onColumnDragStart) {
	                    columnReorderProps.onColumnDragStart(true);
	                }
	            }
	            else if (event && _this._draggedColumnIndex >= 0) {
	                _this._resetDropHints();
	                _this._draggedColumnIndex = -1;
	                _this._dropHintDetails = {};
	                if (columnReorderProps && columnReorderProps.onColumnDragEnd) {
	                    var columnDragEndLocation = _this._isEventOnHeader(event);
	                    columnReorderProps.onColumnDragEnd({ dropLocation: columnDragEndLocation }, event);
	                }
	            }
	        };
	        _this._getDropHintPositions = function () {
	            var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
	            var columnReorderProps = _this.state.columnReorderProps;
	            var prevX = 0;
	            var prevMid = 0;
	            var prevRef;
	            var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
	            var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
	            for (var i = frozenColumnCountFromStart; i < columns.length - frozenColumnCountFromEnd + 1; i++) {
	                if (_this._rootElement) {
	                    var dropHintElement = _this._rootElement.querySelectorAll('#columnDropHint_' + i)[0];
	                    if (dropHintElement) {
	                        if (i === frozenColumnCountFromStart) {
	                            prevX = dropHintElement.offsetLeft;
	                            prevMid = dropHintElement.offsetLeft;
	                            prevRef = dropHintElement;
	                        }
	                        else {
	                            var newMid = (dropHintElement.offsetLeft + prevX) / 2;
	                            _this._dropHintDetails[i - 1] = {
	                                originX: prevX,
	                                startX: prevMid,
	                                endX: newMid,
	                                dropHintElementRef: prevRef
	                            };
	                            prevMid = newMid;
	                            prevRef = dropHintElement;
	                            prevX = dropHintElement.offsetLeft;
	                            if (i === columns.length - frozenColumnCountFromEnd) {
	                                _this._dropHintDetails[i] = {
	                                    originX: prevX,
	                                    startX: prevMid,
	                                    endX: dropHintElement.offsetLeft,
	                                    dropHintElementRef: prevRef
	                                };
	                            }
	                        }
	                    }
	                }
	            }
	        };
	        /**
	         * Based on the given cursor position, finds the nearest drop hint and updates the state to make it visible
	         *
	         */
	        _this._computeDropHintToBeShown = function (clientX) {
	            if (_this._rootElement) {
	                var clientRect = _this._rootElement.getBoundingClientRect();
	                var headerOriginX = clientRect.left;
	                var eventXRelativePosition = clientX - headerOriginX;
	                var currentDropHintIndex = _this._currentDropHintIndex;
	                if (_this._isValidCurrentDropHintIndex()) {
	                    if (_this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex].startX, _this._dropHintDetails[currentDropHintIndex].endX)) {
	                        return;
	                    }
	                }
	                var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
	                var columnReorderProps = _this.state.columnReorderProps;
	                var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
	                var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
	                var currentIndex = frozenColumnCountFromStart;
	                var lastValidColumn = columns.length - frozenColumnCountFromEnd;
	                var indexToUpdate = -1;
	                if (_this._isBefore(eventXRelativePosition, _this._dropHintDetails[currentIndex].endX)) {
	                    indexToUpdate = currentIndex;
	                }
	                else if (_this._isAfter(eventXRelativePosition, _this._dropHintDetails[lastValidColumn].startX)) {
	                    indexToUpdate = lastValidColumn;
	                }
	                else if (_this._isValidCurrentDropHintIndex()) {
	                    if (_this._dropHintDetails[currentDropHintIndex + 1] &&
	                        _this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex + 1].startX, _this._dropHintDetails[currentDropHintIndex + 1].endX)) {
	                        indexToUpdate = currentDropHintIndex + 1;
	                    }
	                    else if (_this._dropHintDetails[currentDropHintIndex - 1] &&
	                        _this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex - 1].startX, _this._dropHintDetails[currentDropHintIndex - 1].endX)) {
	                        indexToUpdate = currentDropHintIndex - 1;
	                    }
	                }
	                if (indexToUpdate === -1) {
	                    var startIndex = frozenColumnCountFromStart;
	                    var endIndex = lastValidColumn;
	                    while (startIndex < endIndex) {
	                        var middleIndex = Math.ceil((endIndex + startIndex) / 2);
	                        if (_this._liesBetween(eventXRelativePosition, _this._dropHintDetails[middleIndex].startX, _this._dropHintDetails[middleIndex].endX)) {
	                            indexToUpdate = middleIndex;
	                            break;
	                        }
	                        else if (_this._isBefore(eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) {
	                            endIndex = middleIndex;
	                        }
	                        else if (_this._isAfter(eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) {
	                            startIndex = middleIndex;
	                        }
	                    }
	                }
	                if (indexToUpdate === _this._draggedColumnIndex || indexToUpdate === _this._draggedColumnIndex + 1) {
	                    if (_this._isValidCurrentDropHintIndex()) {
	                        _this._resetDropHints();
	                    }
	                }
	                else if (currentDropHintIndex !== indexToUpdate && indexToUpdate >= 0) {
	                    _this._resetDropHints();
	                    _this._updateDropHintElement(_this._dropHintDetails[indexToUpdate].dropHintElementRef, 'inline-block');
	                    _this._currentDropHintIndex = indexToUpdate;
	                }
	            }
	        };
	        _this._renderColumnSizer = function (_a) {
	            var columnIndex = _a.columnIndex;
	            var _b = _this.props.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
	            var column = columns[columnIndex];
	            var columnResizeDetails = _this.state.columnResizeDetails;
	            var classNames = _this._classNames;
	            return column.isResizable ? (React.createElement("div", { key: column.key + "_sizer", "aria-hidden": true, role: "button", "data-is-focusable": false, onClick: stopPropagation, "data-sizer-index": columnIndex, onBlur: _this._onSizerBlur, className: Utilities_1.css(classNames.cellSizer, columnIndex < columns.length - 1 ? classNames.cellSizerStart : classNames.cellSizerEnd, (_c = {},
	                    _c[classNames.cellIsResizing] = columnResizeDetails && columnResizeDetails.columnIndex === columnIndex,
	                    _c)), onDoubleClick: _this._onSizerDoubleClick.bind(_this, columnIndex) })) : null;
	            var _c;
	        };
	        _this._onRenderColumnHeaderTooltip = function (tooltipHostProps) {
	            return React.createElement("span", { className: tooltipHostProps.hostClassName }, tooltipHostProps.children);
	        };
	        /**
	         * Called when the select all toggle is clicked.
	         */
	        _this._onSelectAllClicked = function () {
	            var selection = _this.props.selection;
	            if (selection) {
	                selection.toggleAllSelected();
	            }
	        };
	        _this._onRootMouseDown = function (ev) {
	            var columnIndexAttr = ev.target.getAttribute('data-sizer-index');
	            var columnIndex = Number(columnIndexAttr);
	            var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
	            if (columnIndexAttr === null || ev.button !== MOUSEDOWN_PRIMARY_BUTTON) {
	                // Ignore anything except the primary button.
	                return;
	            }
	            _this.setState({
	                columnResizeDetails: {
	                    columnIndex: columnIndex,
	                    columnMinWidth: columns[columnIndex].calculatedWidth,
	                    originX: ev.clientX
	                }
	            });
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._onRootMouseMove = function (ev) {
	            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
	            if (columnResizeDetails && !isSizing && ev.clientX !== columnResizeDetails.originX) {
	                _this.setState({ isSizing: true });
	            }
	        };
	        _this._onRootRef = function (focusZone) {
	            if (focusZone) {
	                // Need to resolve the actual DOM node, not the component. The element itself will be used for drag/drop and focusing.
	                _this._rootElement = react_dom_1.findDOMNode(focusZone);
	            }
	            else {
	                _this._rootElement = undefined;
	            }
	        };
	        _this._onRootKeyDown = function (ev) {
	            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
	            var _b = _this.props, _c = _b.columns, columns = _c === void 0 ? NO_COLUMNS : _c, onColumnResized = _b.onColumnResized;
	            var columnIndexAttr = ev.target.getAttribute('data-sizer-index');
	            if (!columnIndexAttr || isSizing) {
	                return;
	            }
	            var columnIndex = Number(columnIndexAttr);
	            if (!columnResizeDetails) {
	                if (ev.which === Utilities_1.KeyCodes.enter) {
	                    _this.setState({
	                        columnResizeDetails: {
	                            columnIndex: columnIndex,
	                            columnMinWidth: columns[columnIndex].calculatedWidth
	                        }
	                    });
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	            else {
	                var increment = void 0;
	                if (ev.which === Utilities_1.KeyCodes.enter) {
	                    _this.setState({
	                        columnResizeDetails: undefined
	                    });
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	                else if (ev.which === Utilities_1.KeyCodes.left) {
	                    increment = Utilities_1.getRTL() ? 1 : -1;
	                }
	                else if (ev.which === Utilities_1.KeyCodes.right) {
	                    increment = Utilities_1.getRTL() ? -1 : 1;
	                }
	                if (increment) {
	                    if (!ev.shiftKey) {
	                        increment *= 10;
	                    }
	                    _this.setState({
	                        columnResizeDetails: tslib_1.__assign({}, columnResizeDetails, { columnMinWidth: columnResizeDetails.columnMinWidth + increment })
	                    });
	                    if (onColumnResized) {
	                        onColumnResized(columns[columnIndex], columnResizeDetails.columnMinWidth + increment, columnIndex);
	                    }
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        /**
	         * mouse move event handler in the header
	         * it will set isSizing state to true when user clicked on the sizer and move the mouse.
	         *
	         * @param ev - mouse move event
	         */
	        _this._onSizerMouseMove = function (ev) {
	            var 
	            // use buttons property here since ev.button in some edge case is not upding well during the move.
	            // but firefox doesn't support it, so we set the default value when it is not defined.
	            buttons = ev.buttons;
	            var _a = _this.props, onColumnIsSizingChanged = _a.onColumnIsSizingChanged, onColumnResized = _a.onColumnResized, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
	            var columnResizeDetails = _this.state.columnResizeDetails;
	            if (buttons !== undefined && buttons !== MOUSEMOVE_PRIMARY_BUTTON) {
	                // cancel mouse down event and return early when the primary button is not pressed
	                _this._onSizerMouseUp(ev);
	                return;
	            }
	            if (ev.clientX !== columnResizeDetails.originX) {
	                if (onColumnIsSizingChanged) {
	                    onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], true);
	                }
	            }
	            if (onColumnResized) {
	                var movement = ev.clientX - columnResizeDetails.originX;
	                if (Utilities_1.getRTL()) {
	                    movement = -movement;
	                }
	                onColumnResized(columns[columnResizeDetails.columnIndex], columnResizeDetails.columnMinWidth + movement, columnResizeDetails.columnIndex);
	            }
	        };
	        _this._onSizerBlur = function (ev) {
	            var columnResizeDetails = _this.state.columnResizeDetails;
	            if (columnResizeDetails) {
	                _this.setState({
	                    columnResizeDetails: undefined,
	                    isSizing: false
	                });
	            }
	        };
	        /**
	         * mouse up event handler in the header
	         * clear the resize related state.
	         * This is to ensure we can catch double click event
	         *
	         * @param ev - mouse up event
	         */
	        _this._onSizerMouseUp = function (ev) {
	            var _a = _this.props, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, onColumnIsSizingChanged = _a.onColumnIsSizingChanged;
	            var columnResizeDetails = _this.state.columnResizeDetails;
	            _this.setState({
	                columnResizeDetails: undefined,
	                isSizing: false
	            });
	            if (onColumnIsSizingChanged) {
	                onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], false);
	            }
	        };
	        _this._onToggleCollapseAll = function () {
	            var onToggleCollapseAll = _this.props.onToggleCollapseAll;
	            var newCollapsed = !_this.state.isAllCollapsed;
	            _this.setState({
	                isAllCollapsed: newCollapsed
	            });
	            if (onToggleCollapseAll) {
	                onToggleCollapseAll(newCollapsed);
	            }
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._events = new Utilities_1.EventGroup(_this);
	        var columnReorderProps = props.columnReorderProps || (props.columnReorderOptions && getLegacyColumnReorderProps(props.columnReorderOptions));
	        _this.state = {
	            columnReorderProps: columnReorderProps,
	            columnResizeDetails: undefined,
	            groupNestingDepth: _this.props.groupNestingDepth,
	            isAllCollapsed: _this.props.isAllCollapsed,
	            isAllSelected: !!_this.props.selection && _this.props.selection.isAllSelected()
	        };
	        _this._onDropIndexInfo = {
	            sourceIndex: -1,
	            targetIndex: -1
	        };
	        _this._id = Utilities_1.getId('header');
	        _this._currentDropHintIndex = -1;
	        return _this;
	    }
	    DetailsHeaderBase.getDerivedStateFromProps = function (newProps, prevState) {
	        var columnReorderProps = newProps.columnReorderProps || (newProps.columnReorderOptions && getLegacyColumnReorderProps(newProps.columnReorderOptions));
	        var groupNestingDepth = newProps.groupNestingDepth;
	        var newState = { columnReorderProps: columnReorderProps, groupNestingDepth: groupNestingDepth };
	        if (newProps.isAllCollapsed !== undefined) {
	            newState.isAllCollapsed = newProps.isAllCollapsed;
	        }
	        return newState;
	    };
	    DetailsHeaderBase.prototype.componentDidMount = function () {
	        var selection = this.props.selection;
	        var columnReorderProps = this.state.columnReorderProps;
	        this._events.on(selection, interfaces_1.SELECTION_CHANGE, this._onSelectionChanged);
	        // We need to use native on this to avoid MarqueeSelection from handling the event before us.
	        this._events.on(this._rootElement, 'mousedown', this._onRootMouseDown);
	        this._events.on(this._rootElement, 'keydown', this._onRootKeyDown);
	        if (columnReorderProps && this._dragDropHelper) {
	            this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement, this._events, this._getHeaderDragDropOptions());
	        }
	    };
	    DetailsHeaderBase.prototype.componentDidUpdate = function (prevProps) {
	        var columnReorderProps = this.state.columnReorderProps;
	        if (!columnReorderProps) {
	            if (this._subscriptionObject) {
	                this._subscriptionObject.dispose();
	                delete this._subscriptionObject;
	            }
	        }
	        else if (!this._subscriptionObject && this._dragDropHelper) {
	            this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement, this._events, this._getHeaderDragDropOptions());
	        }
	        if (this.props !== prevProps && this._onDropIndexInfo.sourceIndex >= 0 && this._onDropIndexInfo.targetIndex >= 0) {
	            var _a = prevProps.columns, previousColumns = _a === void 0 ? NO_COLUMNS : _a;
	            var _b = this.props.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
	            if (previousColumns[this._onDropIndexInfo.sourceIndex].key === columns[this._onDropIndexInfo.targetIndex].key) {
	                this._onDropIndexInfo = {
	                    sourceIndex: -1,
	                    targetIndex: -1
	                };
	            }
	        }
	    };
	    DetailsHeaderBase.prototype.componentWillUnmount = function () {
	        if (this._subscriptionObject) {
	            this._subscriptionObject.dispose();
	            delete this._subscriptionObject;
	        }
	        if (this._dragDropHelper) {
	            this._dragDropHelper.dispose();
	        }
	        this._events.dispose();
	    };
	    DetailsHeaderBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, ariaLabel = _a.ariaLabel, ariaLabelForToggleAllGroupsButton = _a.ariaLabelForToggleAllGroupsButton, ariaLabelForSelectAllCheckbox = _a.ariaLabelForSelectAllCheckbox, selectAllVisibility = _a.selectAllVisibility, ariaLabelForSelectionColumn = _a.ariaLabelForSelectionColumn, indentWidth = _a.indentWidth, _c = _a.rowWidth, rowWidth = _c === void 0 ? 0 : _c, onColumnClick = _a.onColumnClick, onColumnContextMenu = _a.onColumnContextMenu, _d = _a.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _d === void 0 ? this._onRenderColumnHeaderTooltip : _d, styles = _a.styles, theme = _a.theme, onRenderDetailsCheckbox = _a.onRenderDetailsCheckbox, useFastIcons = _a.useFastIcons;
	        var _e = this.state, isAllSelected = _e.isAllSelected, columnResizeDetails = _e.columnResizeDetails, isSizing = _e.isSizing, groupNestingDepth = _e.groupNestingDepth, isAllCollapsed = _e.isAllCollapsed, columnReorderProps = _e.columnReorderProps;
	        var showCheckbox = selectAllVisibility !== DetailsHeader_types_1.SelectAllVisibility.none;
	        var isCheckboxHidden = selectAllVisibility === DetailsHeader_types_1.SelectAllVisibility.hidden;
	        if (!this._dragDropHelper && columnReorderProps) {
	            // TODO Do not assign local fields during render.
	            // This behavior needs to be moved to the appropriate React lifecycle methods.
	            this._dragDropHelper = new index_1.DragDropHelper({
	                selection: {
	                    getSelection: function () {
	                        return;
	                    }
	                },
	                minimumPixelsForDrag: this.props.minimumPixelsForDrag
	            });
	        }
	        var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
	        var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            isAllSelected: isAllSelected,
	            isSelectAllHidden: selectAllVisibility === DetailsHeader_types_1.SelectAllVisibility.hidden,
	            isResizingColumn: !!columnResizeDetails && isSizing,
	            isSizing: isSizing,
	            isAllCollapsed: isAllCollapsed,
	            isCheckboxHidden: isCheckboxHidden
	        });
	        var classNames = this._classNames;
	        var IconComponent = useFastIcons ? Icon_1.FontIcon : Icon_1.Icon;
	        var isRTL = Utilities_1.getRTL();
	        return (React.createElement(FocusZone_1.FocusZone, { role: "row", "aria-label": ariaLabel, className: classNames.root, componentRef: this._rootComponent, ref: this._onRootRef, onMouseMove: this._onRootMouseMove, "data-automationid": "DetailsHeader", style: { minWidth: rowWidth }, direction: FocusZone_1.FocusZoneDirection.horizontal },
	            showCheckbox
	                ? [
	                    React.createElement("div", { key: "__checkbox", className: classNames.cellIsCheck, "aria-labelledby": this._id + "-check", onClick: !isCheckboxHidden ? this._onSelectAllClicked : undefined, "aria-colindex": 1, role: 'columnheader' }, onRenderColumnHeaderTooltip({
	                        hostClassName: classNames.checkTooltip,
	                        id: this._id + "-checkTooltip",
	                        setAriaDescribedBy: false,
	                        content: ariaLabelForSelectAllCheckbox,
	                        children: (React.createElement(DetailsRowCheck_1.DetailsRowCheck, { id: this._id + "-check", "aria-label": ariaLabelForSelectionColumn, "aria-describedby": !isCheckboxHidden
	                                ? ariaLabelForSelectAllCheckbox && !this.props.onRenderColumnHeaderTooltip
	                                    ? this._id + "-checkTooltip"
	                                    : undefined
	                                : ariaLabelForSelectionColumn && !this.props.onRenderColumnHeaderTooltip
	                                    ? this._id + "-checkTooltip"
	                                    : undefined, "data-is-focusable": !isCheckboxHidden || undefined, isHeader: true, selected: isAllSelected, anySelected: false, canSelect: !isCheckboxHidden, className: classNames.check, onRenderDetailsCheckbox: onRenderDetailsCheckbox, useFastIcons: useFastIcons }))
	                    }, this._onRenderColumnHeaderTooltip)),
	                    !this.props.onRenderColumnHeaderTooltip ? (ariaLabelForSelectAllCheckbox && !isCheckboxHidden ? (React.createElement("label", { key: "__checkboxLabel", id: this._id + "-checkTooltip", className: classNames.accessibleLabel, "aria-hidden": true }, ariaLabelForSelectAllCheckbox)) : ariaLabelForSelectionColumn && isCheckboxHidden ? (React.createElement("label", { key: "__checkboxLabel", id: this._id + "-checkTooltip", className: classNames.accessibleLabel, "aria-hidden": true }, ariaLabelForSelectionColumn)) : null) : null
	                ]
	                : null,
	            groupNestingDepth > 0 && this.props.collapseAllVisibility === GroupedList_1.CollapseAllVisibility.visible ? (React.createElement("div", { className: classNames.cellIsGroupExpander, onClick: this._onToggleCollapseAll, "data-is-focusable": true, "aria-label": ariaLabelForToggleAllGroupsButton, "aria-expanded": !isAllCollapsed, role: ariaLabelForToggleAllGroupsButton ? 'button' : undefined },
	                React.createElement(IconComponent, { className: classNames.collapseButton, iconName: isRTL ? 'ChevronLeftMed' : 'ChevronRightMed' }))) : null,
	            React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: groupNestingDepth - 1 }),
	            columns.map(function (column, columnIndex) {
	                var _isDraggable = columnReorderProps
	                    ? columnIndex >= frozenColumnCountFromStart && columnIndex < columns.length - frozenColumnCountFromEnd
	                    : false;
	                return [
	                    columnReorderProps &&
	                        (_isDraggable || columnIndex === columns.length - frozenColumnCountFromEnd) &&
	                        _this._renderDropHint(columnIndex),
	                    React.createElement(DetailsColumn_1.DetailsColumn, { column: column, key: column.key, columnIndex: (showCheckbox ? 2 : 1) + columnIndex, parentId: _this._id, isDraggable: _isDraggable, updateDragInfo: _this._updateDragInfo, dragDropHelper: _this._dragDropHelper, onColumnClick: onColumnClick, onColumnContextMenu: onColumnContextMenu, 
	                        // Do not render tooltips by default, but allow for override via props.
	                        onRenderColumnHeaderTooltip: _this.props.onRenderColumnHeaderTooltip, isDropped: _this._onDropIndexInfo.targetIndex === columnIndex, cellStyleProps: _this.props.cellStyleProps, useFastIcons: useFastIcons }),
	                    _this._renderColumnDivider(columnIndex)
	                ];
	            }),
	            columnReorderProps && frozenColumnCountFromEnd === 0 && this._renderDropHint(columns.length),
	            isSizing && (React.createElement(Layer_1.Layer, null,
	                React.createElement("div", { className: classNames.sizingOverlay, onMouseMove: this._onSizerMouseMove, onMouseUp: this._onSizerMouseUp })))));
	    };
	    /** Set focus to the active thing in the focus area. */
	    DetailsHeaderBase.prototype.focus = function () {
	        return Boolean(this._rootComponent.current && this._rootComponent.current.focus());
	    };
	    DetailsHeaderBase.prototype._getHeaderDragDropOptions = function () {
	        var options = {
	            selectionIndex: 1,
	            context: { data: this, index: 0 },
	            canDrag: function () { return false; },
	            canDrop: function () { return true; },
	            onDragStart: function () { return undefined; },
	            updateDropState: this._updateDroppingState,
	            onDrop: this._onDrop,
	            onDragEnd: function () { return undefined; },
	            onDragOver: this._onDragOver
	        };
	        return options;
	    };
	    DetailsHeaderBase.prototype._isValidCurrentDropHintIndex = function () {
	        return this._currentDropHintIndex >= 0;
	    };
	    /**
	     * @returns whether or not the "Select All" checkbox column is hidden.
	     */
	    DetailsHeaderBase.prototype._isCheckboxColumnHidden = function () {
	        var _a = this.props, selectionMode = _a.selectionMode, checkboxVisibility = _a.checkboxVisibility;
	        return selectionMode === interfaces_1.SelectionMode.none || checkboxVisibility === DetailsList_types_1.CheckboxVisibility.hidden;
	    };
	    DetailsHeaderBase.prototype._resetDropHints = function () {
	        if (this._currentDropHintIndex >= 0) {
	            this._updateDropHintElement(this._dropHintDetails[this._currentDropHintIndex].dropHintElementRef, 'none');
	            this._currentDropHintIndex = -1;
	        }
	    };
	    DetailsHeaderBase.prototype._updateDropHintElement = function (element, displayProperty) {
	        element.childNodes[1].style.display = displayProperty;
	        element.childNodes[0].style.display = displayProperty;
	    };
	    DetailsHeaderBase.prototype._liesBetween = function (target, left, right) {
	        return Utilities_1.getRTL() ? target <= left && target >= right : target >= left && target <= right;
	    };
	    DetailsHeaderBase.prototype._isBefore = function (a, b) {
	        return Utilities_1.getRTL() ? a >= b : a <= b;
	    };
	    DetailsHeaderBase.prototype._isAfter = function (a, b) {
	        return Utilities_1.getRTL() ? a <= b : a >= b;
	    };
	    DetailsHeaderBase.prototype._isEventOnHeader = function (event) {
	        if (this._rootElement) {
	            var clientRect = this._rootElement.getBoundingClientRect();
	            if (event.clientX > clientRect.left &&
	                event.clientX < clientRect.right &&
	                event.clientY > clientRect.top &&
	                event.clientY < clientRect.bottom) {
	                return DetailsList_types_1.ColumnDragEndLocation.header;
	            }
	        }
	    };
	    DetailsHeaderBase.prototype._renderColumnDivider = function (columnIndex) {
	        var _a = this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
	        var column = columns[columnIndex];
	        var onRenderDivider = column.onRenderDivider;
	        return onRenderDivider
	            ? onRenderDivider({ column: column, columnIndex: columnIndex }, this._renderColumnSizer)
	            : this._renderColumnSizer({ column: column, columnIndex: columnIndex });
	    };
	    DetailsHeaderBase.prototype._renderDropHint = function (dropHintIndex) {
	        var classNames = this._classNames;
	        var IconComponent = this.props.useFastIcons ? Icon_1.FontIcon : Icon_1.Icon;
	        return (React.createElement("div", { key: 'dropHintKey', className: classNames.dropHintStyle, id: "columnDropHint_" + dropHintIndex },
	            React.createElement(IconComponent, { key: "dropHintCircleKey", "aria-hidden": true, "data-is-focusable": false, "data-sizer-index": dropHintIndex, className: classNames.dropHintCaretStyle, iconName: 'CircleShapeSolid' }),
	            React.createElement("div", { key: "dropHintLineKey", "aria-hidden": true, "data-is-focusable": false, "data-sizer-index": dropHintIndex, className: classNames.dropHintLineStyle })));
	    };
	    /**
	     * double click on the column sizer will auto ajust column width
	     * to fit the longest content among current rendered rows.
	     *
	     * @param columnIndex - index of the column user double clicked
	     * @param ev - mouse double click event
	     */
	    DetailsHeaderBase.prototype._onSizerDoubleClick = function (columnIndex, ev) {
	        var _a = this.props, onColumnAutoResized = _a.onColumnAutoResized, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
	        if (onColumnAutoResized) {
	            onColumnAutoResized(columns[columnIndex], columnIndex);
	        }
	    };
	    DetailsHeaderBase.prototype._onSelectionChanged = function () {
	        var isAllSelected = !!this.props.selection && this.props.selection.isAllSelected();
	        if (this.state.isAllSelected !== isAllSelected) {
	            this.setState({
	                isAllSelected: isAllSelected
	            });
	        }
	    };
	    DetailsHeaderBase.defaultProps = {
	        selectAllVisibility: DetailsHeader_types_1.SelectAllVisibility.visible,
	        collapseAllVisibility: GroupedList_1.CollapseAllVisibility.visible
	    };
	    return DetailsHeaderBase;
	}(React.Component));
	exports.DetailsHeaderBase = DetailsHeaderBase;
	function getLegacyColumnReorderProps(columnReorderOptions) {
	    return tslib_1.__assign({}, columnReorderOptions, { onColumnDragEnd: undefined });
	}
	function stopPropagation(ev) {
	    ev.stopPropagation();
	}
	//# sourceMappingURL=DetailsHeader.base.js.map

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Enum to describe how a particular column header behaves.... This enum is used to
	 * to specify the property IColumn:columnActionsMode.
	 * If IColumn:columnActionsMode is undefined, then it's equivalent to ColumnActionsMode.clickable
	 * {@docCategory DetailsList}
	 */
	var ColumnActionsMode;
	(function (ColumnActionsMode) {
	    /**
	     * Renders the column header as disabled.
	     */
	    ColumnActionsMode[ColumnActionsMode["disabled"] = 0] = "disabled";
	    /**
	     * Renders the column header is clickable.
	     */
	    ColumnActionsMode[ColumnActionsMode["clickable"] = 1] = "clickable";
	    /**
	     * Renders the column header ias clickable and displays the dropdown cheveron.
	     */
	    ColumnActionsMode[ColumnActionsMode["hasDropdown"] = 2] = "hasDropdown";
	})(ColumnActionsMode = exports.ColumnActionsMode || (exports.ColumnActionsMode = {}));
	/**
	 * {@docCategory DetailsList}
	 */
	var ConstrainMode;
	(function (ConstrainMode) {
	    /** If specified, lets the content grow which allows the page to manage scrolling. */
	    ConstrainMode[ConstrainMode["unconstrained"] = 0] = "unconstrained";
	    /**
	     * If specified, constrains the list to the given layout space.
	     */
	    ConstrainMode[ConstrainMode["horizontalConstrained"] = 1] = "horizontalConstrained";
	})(ConstrainMode = exports.ConstrainMode || (exports.ConstrainMode = {}));
	/**
	 * Enum to describe where the column has been dropped, after starting the drag
	 * {@docCategory DetailsList}
	 */
	var ColumnDragEndLocation;
	(function (ColumnDragEndLocation) {
	    /**
	     * Drag ended outside of current list
	     */
	    ColumnDragEndLocation[ColumnDragEndLocation["outside"] = 0] = "outside";
	    /**
	     * Drag ended on current List
	     */
	    ColumnDragEndLocation[ColumnDragEndLocation["surface"] = 1] = "surface";
	    /**
	     * Drag ended on Header
	     */
	    ColumnDragEndLocation[ColumnDragEndLocation["header"] = 2] = "header";
	})(ColumnDragEndLocation = exports.ColumnDragEndLocation || (exports.ColumnDragEndLocation = {}));
	/**
	 * {@docCategory DetailsList}
	 */
	var DetailsListLayoutMode;
	(function (DetailsListLayoutMode) {
	    /**
	     * Lets the user resize columns and makes not attempt to fit them.
	     */
	    DetailsListLayoutMode[DetailsListLayoutMode["fixedColumns"] = 0] = "fixedColumns";
	    /**
	     * Manages which columns are visible, tries to size them according to their min/max rules and drops
	     * off columns that can't fit and have isCollapsible set.
	     */
	    DetailsListLayoutMode[DetailsListLayoutMode["justified"] = 1] = "justified";
	})(DetailsListLayoutMode = exports.DetailsListLayoutMode || (exports.DetailsListLayoutMode = {}));
	/**
	 * {@docCategory DetailsList}
	 */
	var CheckboxVisibility;
	(function (CheckboxVisibility) {
	    /**
	     * Visible on hover.
	     */
	    CheckboxVisibility[CheckboxVisibility["onHover"] = 0] = "onHover";
	    /**
	     * Visible always.
	     */
	    CheckboxVisibility[CheckboxVisibility["always"] = 1] = "always";
	    /**
	     * Hide checkboxes.
	     */
	    CheckboxVisibility[CheckboxVisibility["hidden"] = 2] = "hidden";
	})(CheckboxVisibility = exports.CheckboxVisibility || (exports.CheckboxVisibility = {}));
	//# sourceMappingURL=DetailsList.types.js.map

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	exports.SPACER_WIDTH = 32;
	exports.GroupSpacer = function (props) {
	    var count = props.count, _a = props.indentWidth, indentWidth = _a === void 0 ? exports.SPACER_WIDTH : _a;
	    var width = count * indentWidth;
	    return count > 0 ? React.createElement("span", { className: 'ms-GroupSpacer', style: { display: 'inline-block', width: width } }) : null;
	};
	//# sourceMappingURL=GroupSpacer.js.map

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(876), exports);
	//# sourceMappingURL=GroupedList.js.map

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(877), exports);
	tslib_1.__exportStar(__webpack_require__(879), exports);
	tslib_1.__exportStar(__webpack_require__(870), exports);
	tslib_1.__exportStar(__webpack_require__(881), exports);
	tslib_1.__exportStar(__webpack_require__(894), exports);
	tslib_1.__exportStar(__webpack_require__(891), exports);
	var GroupSpacer_1 = __webpack_require__(874);
	exports.GroupSpacer = GroupSpacer_1.GroupSpacer;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var GroupedList_styles_1 = __webpack_require__(878);
	var GroupedList_base_1 = __webpack_require__(879);
	exports.GroupedList = Utilities_1.styled(GroupedList_base_1.GroupedListBase, GroupedList_styles_1.getStyles, undefined, {
	    scope: 'GroupedList'
	});
	//# sourceMappingURL=GroupedList.js.map

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-GroupedList',
	    compact: 'ms-GroupedList--Compact',
	    group: 'ms-GroupedList-group',
	    link: 'ms-Link',
	    listCell: 'ms-List-cell'
	};
	var beziers = {
	    easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, compact = props.compact;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                position: 'relative',
	                fontSize: Styling_1.FontSizes.small,
	                selectors: (_a = {},
	                    _a["." + classNames.listCell] = {
	                        minHeight: 38 // be consistent with DetailsList styles
	                    },
	                    _a)
	            },
	            compact && [
	                classNames.compact,
	                {
	                    selectors: (_b = {},
	                        _b["." + classNames.listCell] = {
	                            minHeight: 32 // be consistent with DetailsList styles
	                        },
	                        _b)
	                }
	            ],
	            className
	        ],
	        group: [
	            classNames.group,
	            {
	                transition: "background-color " + Styling_1.AnimationVariables.durationValue2 + " " + beziers.easeInOutSine
	            }
	        ],
	        groupIsDropping: [
	            {
	                backgroundColor: palette.neutralLight
	            }
	        ]
	    };
	    var _a, _b;
	};
	//# sourceMappingURL=GroupedList.styles.js.map

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var GroupedListSection_1 = __webpack_require__(880);
	var List_1 = __webpack_require__(845);
	var index_1 = __webpack_require__(866);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var getClassNames = Utilities_1.classNamesFunction();
	var ROW_HEIGHT = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.rowHeight, COMPACT_ROW_HEIGHT = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.compactRowHeight;
	var GroupedListBase = /** @class */ (function (_super) {
	    tslib_1.__extends(GroupedListBase, _super);
	    function GroupedListBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._list = React.createRef();
	        _this._renderGroup = function (group, groupIndex) {
	            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, groupProps = _a.groupProps, items = _a.items, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selectionMode = _a.selectionMode, selection = _a.selection, viewport = _a.viewport, onShouldVirtualize = _a.onShouldVirtualize, groups = _a.groups, compact = _a.compact;
	            // override group header/footer props as needed
	            var dividerProps = {
	                onToggleSelectGroup: _this._onToggleSelectGroup,
	                onToggleCollapse: _this._onToggleCollapse,
	                onToggleSummarize: _this._onToggleSummarize
	            };
	            var headerProps = tslib_1.__assign({}, groupProps.headerProps, dividerProps);
	            var showAllProps = tslib_1.__assign({}, groupProps.showAllProps, dividerProps);
	            var footerProps = tslib_1.__assign({}, groupProps.footerProps, dividerProps);
	            var groupNestingDepth = _this._getGroupNestingDepth();
	            if (!groupProps.showEmptyGroups && group && group.count === 0) {
	                return null;
	            }
	            return (React.createElement(GroupedListSection_1.GroupedListSection, { ref: 'group_' + groupIndex, key: _this._getGroupKey(group, groupIndex), dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: eventsToRegister, footerProps: footerProps, getGroupItemLimit: groupProps && groupProps.getGroupItemLimit, group: group, groupIndex: groupIndex, groupNestingDepth: groupNestingDepth, groupProps: groupProps, headerProps: headerProps, listProps: listProps, items: items, onRenderCell: onRenderCell, onRenderGroupHeader: groupProps.onRenderHeader, onRenderGroupShowAll: groupProps.onRenderShowAll, onRenderGroupFooter: groupProps.onRenderFooter, selectionMode: selectionMode, selection: selection, showAllProps: showAllProps, viewport: viewport, onShouldVirtualize: onShouldVirtualize, groupedListClassNames: _this._classNames, groups: groups, compact: compact }));
	        };
	        _this._getDefaultGroupItemLimit = function (group) {
	            return group.count;
	        };
	        _this._getGroupItemLimit = function (group) {
	            var groupProps = _this.props.groupProps;
	            var getGroupItemLimit = groupProps && groupProps.getGroupItemLimit ? groupProps.getGroupItemLimit : _this._getDefaultGroupItemLimit;
	            return getGroupItemLimit(group);
	        };
	        _this._getGroupHeight = function (group) {
	            var rowHeight = _this.props.compact ? COMPACT_ROW_HEIGHT : ROW_HEIGHT;
	            return rowHeight + (group.isCollapsed ? 0 : rowHeight * _this._getGroupItemLimit(group));
	        };
	        _this._getPageHeight = function (itemIndex) {
	            var groups = _this.state.groups;
	            var _a = _this.props.getGroupHeight, getGroupHeight = _a === void 0 ? _this._getGroupHeight : _a;
	            var pageGroup = groups && groups[itemIndex];
	            if (pageGroup) {
	                return getGroupHeight(pageGroup, itemIndex);
	            }
	            else {
	                return 0;
	            }
	        };
	        _this._onToggleCollapse = function (group) {
	            var groupProps = _this.props.groupProps;
	            var onToggleCollapse = groupProps && groupProps.headerProps && groupProps.headerProps.onToggleCollapse;
	            if (group) {
	                if (onToggleCollapse) {
	                    onToggleCollapse(group);
	                }
	                group.isCollapsed = !group.isCollapsed;
	                _this._updateIsSomeGroupExpanded();
	                _this.forceUpdate();
	            }
	        };
	        _this._onToggleSelectGroup = function (group) {
	            if (group) {
	                _this.props.selection.toggleRangeSelected(group.startIndex, group.count);
	            }
	        };
	        _this._onToggleSummarize = function (group) {
	            var groupProps = _this.props.groupProps;
	            var onToggleSummarize = groupProps && groupProps.showAllProps && groupProps.showAllProps.onToggleSummarize;
	            if (onToggleSummarize) {
	                onToggleSummarize(group);
	            }
	            else {
	                if (group) {
	                    group.isShowingAll = !group.isShowingAll;
	                }
	                _this.forceUpdate();
	            }
	        };
	        _this._getPageSpecification = function (itemIndex) {
	            var groups = _this.state.groups;
	            var pageGroup = groups && groups[itemIndex];
	            return {
	                key: pageGroup && pageGroup.key
	            };
	        };
	        _this._isSomeGroupExpanded = _this._computeIsSomeGroupExpanded(props.groups);
	        _this.state = {
	            lastWidth: 0,
	            groups: props.groups
	        };
	        return _this;
	    }
	    GroupedListBase.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
	        if (this._list.current) {
	            this._list.current.scrollToIndex(index, measureItem, scrollToMode);
	        }
	    };
	    GroupedListBase.prototype.getStartItemIndexInView = function () {
	        return this._list.current.getStartItemIndexInView() || 0;
	    };
	    GroupedListBase.prototype.componentWillReceiveProps = function (newProps) {
	        var _a = this.props, groups = _a.groups, selectionMode = _a.selectionMode, compact = _a.compact;
	        var shouldForceUpdates = false;
	        if (newProps.groups !== groups) {
	            this.setState({ groups: newProps.groups });
	            shouldForceUpdates = true;
	        }
	        if (newProps.selectionMode !== selectionMode || newProps.compact !== compact) {
	            shouldForceUpdates = true;
	        }
	        if (shouldForceUpdates) {
	            this._forceListUpdates();
	        }
	    };
	    GroupedListBase.prototype.componentDidMount = function () {
	        var _a = this.props, groupProps = _a.groupProps, _b = _a.groups, groups = _b === void 0 ? [] : _b;
	        if (groupProps && groupProps.isAllGroupsCollapsed) {
	            this._setGroupsCollapsedState(groups, groupProps.isAllGroupsCollapsed);
	        }
	    };
	    GroupedListBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, usePageCache = _a.usePageCache, onShouldVirtualize = _a.onShouldVirtualize, theme = _a.theme, styles = _a.styles, compact = _a.compact, _b = _a.listProps, listProps = _b === void 0 ? {} : _b;
	        var groups = this.state.groups;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            compact: compact
	        });
	        var version = listProps.version;
	        return (React.createElement("div", { className: this._classNames.root, "data-automationid": "GroupedList", "data-is-scrollable": "false", role: "presentation" }, !groups ? (this._renderGroup(undefined, 0)) : (React.createElement(List_1.List, { ref: this._list, role: "presentation", items: groups, onRenderCell: this._renderGroup, getItemCountForPage: this._returnOne, getPageHeight: this._getPageHeight, getPageSpecification: this._getPageSpecification, usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize, version: version }))));
	    };
	    GroupedListBase.prototype.forceUpdate = function () {
	        _super.prototype.forceUpdate.call(this);
	        this._forceListUpdates();
	    };
	    GroupedListBase.prototype.toggleCollapseAll = function (allCollapsed) {
	        var _a = this.state.groups, groups = _a === void 0 ? [] : _a;
	        var groupProps = this.props.groupProps;
	        var onToggleCollapseAll = groupProps && groupProps.onToggleCollapseAll;
	        if (groups.length > 0) {
	            if (onToggleCollapseAll) {
	                onToggleCollapseAll(allCollapsed);
	            }
	            this._setGroupsCollapsedState(groups, allCollapsed);
	            this._updateIsSomeGroupExpanded();
	            this.forceUpdate();
	        }
	    };
	    GroupedListBase.prototype._setGroupsCollapsedState = function (groups, isCollapsed) {
	        for (var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
	            groups[groupIndex].isCollapsed = isCollapsed;
	        }
	    };
	    GroupedListBase.prototype._returnOne = function () {
	        return 1;
	    };
	    GroupedListBase.prototype._getGroupKey = function (group, index) {
	        return 'group-' + (group && group.key ? group.key : String(index));
	    };
	    GroupedListBase.prototype._getGroupNestingDepth = function () {
	        var groups = this.state.groups;
	        var level = 0;
	        var groupsInLevel = groups;
	        while (groupsInLevel && groupsInLevel.length > 0) {
	            level++;
	            groupsInLevel = groupsInLevel[0].children;
	        }
	        return level;
	    };
	    GroupedListBase.prototype._forceListUpdates = function (groups) {
	        groups = groups || this.state.groups;
	        var groupCount = groups ? groups.length : 1;
	        if (this._list.current) {
	            this._list.current.forceUpdate();
	            for (var i = 0; i < groupCount; i++) {
	                var group = this._list.current.refs['group_' + String(i)];
	                if (group) {
	                    group.forceListUpdate();
	                }
	            }
	        }
	        else {
	            var group = this.refs['group_' + String(0)];
	            if (group) {
	                group.forceListUpdate();
	            }
	        }
	    };
	    GroupedListBase.prototype._computeIsSomeGroupExpanded = function (groups) {
	        var _this = this;
	        return !!(groups && groups.some(function (group) { return (group.children ? _this._computeIsSomeGroupExpanded(group.children) : !group.isCollapsed); }));
	    };
	    GroupedListBase.prototype._updateIsSomeGroupExpanded = function () {
	        var groups = this.state.groups;
	        var onGroupExpandStateChanged = this.props.onGroupExpandStateChanged;
	        var newIsSomeGroupExpanded = this._computeIsSomeGroupExpanded(groups);
	        if (this._isSomeGroupExpanded !== newIsSomeGroupExpanded) {
	            if (onGroupExpandStateChanged) {
	                onGroupExpandStateChanged(newIsSomeGroupExpanded);
	            }
	            this._isSomeGroupExpanded = newIsSomeGroupExpanded;
	        }
	    };
	    GroupedListBase.defaultProps = {
	        selectionMode: index_1.SelectionMode.multiple,
	        isHeaderVisible: true,
	        groupProps: {},
	        compact: false
	    };
	    return GroupedListBase;
	}(Utilities_1.BaseComponent));
	exports.GroupedListBase = GroupedListBase;
	//# sourceMappingURL=GroupedList.base.js.map

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var index_1 = __webpack_require__(866);
	var GroupHeader_1 = __webpack_require__(881);
	var GroupShowAll_1 = __webpack_require__(891);
	var GroupFooter_1 = __webpack_require__(894);
	var List_1 = __webpack_require__(845);
	var Utilities_2 = __webpack_require__(592);
	var DEFAULT_DROPPING_CSS_CLASS = 'is-dropping';
	var GroupedListSection = /** @class */ (function (_super) {
	    tslib_1.__extends(GroupedListSection, _super);
	    function GroupedListSection(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._list = React.createRef();
	        _this._onRenderGroupHeader = function (props) {
	            return React.createElement(GroupHeader_1.GroupHeader, tslib_1.__assign({}, props));
	        };
	        _this._onRenderGroupShowAll = function (props) {
	            return React.createElement(GroupShowAll_1.GroupShowAll, tslib_1.__assign({}, props));
	        };
	        _this._onRenderGroupFooter = function (props) {
	            return React.createElement(GroupFooter_1.GroupFooter, tslib_1.__assign({}, props));
	        };
	        _this._renderSubGroup = function (subGroup, subGroupIndex) {
	            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, getGroupItemLimit = _a.getGroupItemLimit, groupNestingDepth = _a.groupNestingDepth, groupProps = _a.groupProps, items = _a.items, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selection = _a.selection, selectionMode = _a.selectionMode, viewport = _a.viewport, onRenderGroupHeader = _a.onRenderGroupHeader, onRenderGroupShowAll = _a.onRenderGroupShowAll, onRenderGroupFooter = _a.onRenderGroupFooter, onShouldVirtualize = _a.onShouldVirtualize, group = _a.group, compact = _a.compact;
	            return !subGroup || subGroup.count > 0 || (groupProps && groupProps.showEmptyGroups) ? (React.createElement(GroupedListSection, { ref: 'subGroup_' + subGroupIndex, key: _this._getGroupKey(subGroup, subGroupIndex), dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: eventsToRegister, footerProps: footerProps, getGroupItemLimit: getGroupItemLimit, group: subGroup, groupIndex: subGroupIndex, groupNestingDepth: groupNestingDepth, groupProps: groupProps, headerProps: headerProps, items: items, listProps: listProps, onRenderCell: onRenderCell, selection: selection, selectionMode: selectionMode, showAllProps: showAllProps, viewport: viewport, onRenderGroupHeader: onRenderGroupHeader, onRenderGroupShowAll: onRenderGroupShowAll, onRenderGroupFooter: onRenderGroupFooter, onShouldVirtualize: onShouldVirtualize, groups: group.children, compact: compact })) : null;
	        };
	        /**
	         * collect all the data we need to enable drag/drop for a group
	         */
	        _this._getGroupDragDropOptions = function () {
	            var _a = _this.props, group = _a.group, groupIndex = _a.groupIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
	            var options = {
	                eventMap: eventsToRegister,
	                selectionIndex: -1,
	                context: { data: group, index: groupIndex, isGroup: true },
	                canDrag: function () { return false; },
	                canDrop: dragDropEvents.canDrop,
	                updateDropState: _this._updateDroppingState
	            };
	            return options;
	        };
	        /**
	         * update groupIsDropping state based on the input value, which is used to change style during drag and drop
	         *
	         * @param newValue - new isDropping state value
	         * @param event - the event trigger dropping state change which can be dragenter, dragleave etc
	         */
	        _this._updateDroppingState = function (newIsDropping, event) {
	            var isDropping = _this.state.isDropping;
	            var dragDropEvents = _this.props.dragDropEvents;
	            if (!isDropping) {
	                if (dragDropEvents && dragDropEvents.onDragLeave) {
	                    dragDropEvents.onDragLeave(event, undefined);
	                }
	            }
	            else {
	                if (dragDropEvents && dragDropEvents.onDragEnter) {
	                    dragDropEvents.onDragEnter(event, undefined);
	                }
	            }
	            if (isDropping !== newIsDropping) {
	                _this.setState({ isDropping: newIsDropping });
	            }
	        };
	        var selection = props.selection, group = props.group;
	        _this._id = Utilities_2.getId('GroupedListSection');
	        _this.state = {
	            isDropping: false,
	            isSelected: selection && group ? selection.isRangeSelected(group.startIndex, group.count) : false
	        };
	        return _this;
	    }
	    GroupedListSection.prototype.componentDidMount = function () {
	        var _a = this.props, dragDropHelper = _a.dragDropHelper, selection = _a.selection;
	        if (dragDropHelper && this._root.current) {
	            this._dragDropSubscription = dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
	        }
	        if (selection) {
	            this._events.on(selection, index_1.SELECTION_CHANGE, this._onSelectionChange);
	        }
	    };
	    GroupedListSection.prototype.componentWillUnmount = function () {
	        if (this._dragDropSubscription) {
	            this._dragDropSubscription.dispose();
	        }
	    };
	    GroupedListSection.prototype.componentDidUpdate = function (previousProps) {
	        if (this.props.group !== previousProps.group ||
	            this.props.groupIndex !== previousProps.groupIndex ||
	            this.props.dragDropHelper !== previousProps.dragDropHelper) {
	            if (this._dragDropSubscription) {
	                this._dragDropSubscription.dispose();
	                delete this._dragDropSubscription;
	            }
	            if (this.props.dragDropHelper && this._root.current) {
	                this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
	            }
	        }
	    };
	    GroupedListSection.prototype.render = function () {
	        var _a = this.props, getGroupItemLimit = _a.getGroupItemLimit, group = _a.group, groupIndex = _a.groupIndex, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, viewport = _a.viewport, selectionMode = _a.selectionMode, _b = _a.onRenderGroupHeader, onRenderGroupHeader = _b === void 0 ? this._onRenderGroupHeader : _b, _c = _a.onRenderGroupShowAll, onRenderGroupShowAll = _c === void 0 ? this._onRenderGroupShowAll : _c, _d = _a.onRenderGroupFooter, onRenderGroupFooter = _d === void 0 ? this._onRenderGroupFooter : _d, onShouldVirtualize = _a.onShouldVirtualize, groupedListClassNames = _a.groupedListClassNames, groups = _a.groups, compact = _a.compact, _e = _a.listProps, listProps = _e === void 0 ? {} : _e;
	        var isSelected = this.state.isSelected;
	        var renderCount = group && getGroupItemLimit ? getGroupItemLimit(group) : Infinity;
	        var isShowAllVisible = group && !group.children && !group.isCollapsed && !group.isShowingAll && (group.count > renderCount || group.hasMoreData);
	        var hasNestedGroups = group && group.children && group.children.length > 0;
	        var version = listProps.version;
	        var dividerProps = {
	            group: group,
	            groupIndex: groupIndex,
	            groupLevel: group ? group.level : 0,
	            isSelected: isSelected,
	            viewport: viewport,
	            selectionMode: selectionMode,
	            groups: groups,
	            compact: compact
	        };
	        var ariaControlsProps = {
	            groupedListId: this._id
	        };
	        var groupHeaderProps = tslib_1.__assign({}, headerProps, dividerProps, ariaControlsProps);
	        var groupShowAllProps = tslib_1.__assign({}, showAllProps, dividerProps);
	        var groupFooterProps = tslib_1.__assign({}, footerProps, dividerProps);
	        return (React.createElement("div", { ref: this._root, className: Utilities_2.css(groupedListClassNames && groupedListClassNames.group, this._getDroppingClassName()), role: "presentation" },
	            onRenderGroupHeader(groupHeaderProps, this._onRenderGroupHeader),
	            group && group.isCollapsed ? null : hasNestedGroups ? (React.createElement(List_1.List, { role: "presentation", ref: this._list, items: group.children, onRenderCell: this._renderSubGroup, getItemCountForPage: this._returnOne, onShouldVirtualize: onShouldVirtualize, version: version, id: this._id })) : (this._onRenderGroup(renderCount)),
	            group && group.isCollapsed ? null : isShowAllVisible && onRenderGroupShowAll(groupShowAllProps, this._onRenderGroupShowAll),
	            onRenderGroupFooter(groupFooterProps, this._onRenderGroupFooter)));
	    };
	    GroupedListSection.prototype.forceUpdate = function () {
	        _super.prototype.forceUpdate.call(this);
	        this.forceListUpdate();
	    };
	    GroupedListSection.prototype.forceListUpdate = function () {
	        var group = this.props.group;
	        if (this._list.current) {
	            this._list.current.forceUpdate();
	            if (group && group.children && group.children.length > 0) {
	                var subGroupCount = group.children.length;
	                for (var i = 0; i < subGroupCount; i++) {
	                    var subGroup = this._list.current.refs['subGroup_' + String(i)];
	                    if (subGroup) {
	                        subGroup.forceListUpdate();
	                    }
	                }
	            }
	        }
	        else {
	            var subGroup = this.refs['subGroup_' + String(0)];
	            if (subGroup) {
	                subGroup.forceListUpdate();
	            }
	        }
	    };
	    GroupedListSection.prototype._onSelectionChange = function () {
	        var _a = this.props, group = _a.group, selection = _a.selection;
	        var isSelected = selection.isRangeSelected(group.startIndex, group.count);
	        if (isSelected !== this.state.isSelected) {
	            this.setState({ isSelected: isSelected });
	        }
	    };
	    GroupedListSection.prototype._onRenderGroupCell = function (onRenderCell, groupNestingDepth) {
	        return function (item, itemIndex) {
	            return onRenderCell(groupNestingDepth, item, itemIndex);
	        };
	    };
	    GroupedListSection.prototype._onRenderGroup = function (renderCount) {
	        var _a = this.props, group = _a.group, items = _a.items, onRenderCell = _a.onRenderCell, listProps = _a.listProps, groupNestingDepth = _a.groupNestingDepth, onShouldVirtualize = _a.onShouldVirtualize;
	        var count = group && !group.isShowingAll ? group.count : items.length;
	        var startIndex = group ? group.startIndex : 0;
	        return (React.createElement(List_1.List, tslib_1.__assign({ role: "grid", items: items, onRenderCell: this._onRenderGroupCell(onRenderCell, groupNestingDepth), ref: this._list, renderCount: Math.min(count, renderCount), startIndex: startIndex, onShouldVirtualize: onShouldVirtualize, id: this._id }, listProps)));
	    };
	    GroupedListSection.prototype._returnOne = function () {
	        return 1;
	    };
	    GroupedListSection.prototype._getGroupKey = function (group, index) {
	        return 'group-' + (group && group.key ? group.key : String(group.level) + String(index));
	    };
	    /**
	     * get the correct css class to reflect the dropping state for a given group
	     *
	     * If the group is the current drop target, return the default dropping class name
	     * Otherwise, return '';
	     *
	     */
	    GroupedListSection.prototype._getDroppingClassName = function () {
	        var isDropping = this.state.isDropping;
	        var _a = this.props, group = _a.group, groupedListClassNames = _a.groupedListClassNames;
	        isDropping = !!(group && isDropping);
	        return Utilities_2.css(isDropping && DEFAULT_DROPPING_CSS_CLASS, isDropping && groupedListClassNames && groupedListClassNames.groupIsDropping);
	    };
	    return GroupedListSection;
	}(Utilities_1.BaseComponent));
	exports.GroupedListSection = GroupedListSection;
	//# sourceMappingURL=GroupedListSection.js.map

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var GroupHeader_styles_1 = __webpack_require__(882);
	var GroupHeader_base_1 = __webpack_require__(884);
	exports.GroupHeader = Utilities_1.styled(GroupHeader_base_1.GroupHeaderBase, GroupHeader_styles_1.getStyles, undefined, {
	    scope: 'GroupHeader'
	});
	//# sourceMappingURL=GroupHeader.js.map

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var DetailsRow_styles_1 = __webpack_require__(883);
	// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.
	var GroupSpacer_1 = __webpack_require__(874);
	var GlobalClassNames = {
	    root: 'ms-GroupHeader',
	    compact: 'ms-GroupHeader--compact',
	    check: 'ms-GroupHeader-check',
	    dropIcon: 'ms-GroupHeader-dropIcon',
	    expand: 'ms-GroupHeader-expand',
	    isCollapsed: 'is-collapsed',
	    title: 'ms-GroupHeader-title',
	    isSelected: 'is-selected',
	    iconTag: 'ms-Icon--Tag',
	    group: 'ms-GroupedList-group',
	    isDropping: 'is-dropping'
	};
	var beziers = {
	    easeOutCirc: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
	    easeOutSine: 'cubic-bezier(0.390, 0.575, 0.565, 1.000)',
	    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, selected = props.selected, isCollapsed = props.isCollapsed, compact = props.compact;
	    var rowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.rowHeight, compactRowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.compactRowHeight;
	    var cellLeftPadding = DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS.cellLeftPadding; // padding from the source to align GroupHeader title with DetailsRow's first cell.
	    var finalRowHeight = compact ? compactRowHeight : rowHeight;
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var checkExpandResetStyles = [
	        Styling_1.getFocusStyle(theme),
	        {
	            cursor: 'default',
	            background: 'none',
	            backgroundColor: 'transparent',
	            border: 'none',
	            padding: 0 // cancel default <button> padding
	        }
	    ];
	    return {
	        root: [
	            classNames.root,
	            Styling_1.getFocusStyle(theme),
	            theme.fonts.medium,
	            {
	                borderBottom: "1px solid " + semanticColors.listBackground,
	                cursor: 'default',
	                userSelect: 'none',
	                selectors: (_a = {
	                        ':hover': {
	                            background: semanticColors.listItemBackgroundHovered
	                        },
	                        ':hover $check': {
	                            opacity: 1
	                        },
	                        ':focus $check': {
	                            opacity: 1
	                        }
	                    },
	                    _a[":global(." + classNames.group + "." + classNames.isDropping + ")"] = {
	                        selectors: {
	                            '> $root $dropIcon': {
	                                transition: "transform " + Styling_1.AnimationVariables.durationValue4 + " " + beziers.easeOutCirc + " opacity " + Styling_1.AnimationVariables.durationValue1 + " " + beziers.easeOutSine,
	                                transitionDelay: Styling_1.AnimationVariables.durationValue3,
	                                opacity: 1,
	                                transform: "rotate(0.2deg) scale(1);" // rotation prevents jittery motion in IE
	                            },
	                            $check: {
	                                opacity: 0
	                            }
	                        }
	                    },
	                    _a)
	            },
	            selected && [
	                classNames.isSelected,
	                {
	                    background: semanticColors.listItemBackgroundChecked,
	                    selectors: {
	                        ':hover': {
	                            background: semanticColors.listItemBackgroundCheckedHovered
	                        },
	                        $check: {
	                            opacity: 1
	                        }
	                    }
	                }
	            ],
	            compact && [classNames.compact, { border: 'none' }],
	            className
	        ],
	        groupHeaderContainer: [
	            {
	                display: 'flex',
	                alignItems: 'center',
	                height: finalRowHeight
	            }
	        ],
	        headerCount: [
	            {
	                padding: '0px 4px'
	            }
	        ],
	        check: [
	            classNames.check,
	            checkExpandResetStyles,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                // paddingTop and marginTop brought from the DetailsRow.styles.ts with explanation below.
	                // Ensure that the check cell covers the top border of the cell.
	                // This ensures the click target does not leave a spot which would
	                // cause other items to be deselected.
	                paddingTop: 1,
	                marginTop: -1,
	                opacity: 0,
	                width: '40px',
	                height: finalRowHeight,
	                selectors: {
	                    ':focus': {
	                        opacity: 1
	                    }
	                }
	            }
	        ],
	        expand: [
	            classNames.expand,
	            checkExpandResetStyles,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                fontSize: compact ? Styling_1.FontSizes.mediumPlus : 18,
	                width: GroupSpacer_1.SPACER_WIDTH,
	                height: finalRowHeight,
	                color: selected ? palette.neutralPrimary : palette.neutralSecondary,
	                selectors: {
	                    ':hover': {
	                        backgroundColor: selected ? palette.neutralQuaternary : palette.neutralLight
	                    },
	                    ':active': {
	                        backgroundColor: selected ? palette.neutralTertiaryAlt : palette.neutralQuaternaryAlt
	                    }
	                }
	            }
	        ],
	        expandIsCollapsed: [
	            isCollapsed
	                ? [
	                    classNames.isCollapsed,
	                    {
	                        transform: 'rotate(0deg)',
	                        transformOrigin: '50% 50%',
	                        transition: 'transform .1s linear'
	                    }
	                ]
	                : {
	                    transform: 'rotate(90deg)',
	                    transformOrigin: '50% 50%',
	                    transition: 'transform .1s linear'
	                }
	        ],
	        title: [
	            classNames.title,
	            {
	                paddingLeft: cellLeftPadding,
	                fontSize: compact ? Styling_1.FontSizes.large : Styling_1.FontSizes.xLarge,
	                fontWeight: Styling_1.FontWeights.semilight,
	                cursor: 'pointer',
	                outline: 0,
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	            }
	        ],
	        dropIcon: [
	            classNames.dropIcon,
	            {
	                position: 'absolute',
	                left: -26,
	                fontSize: Styling_1.IconFontSizes.large,
	                color: palette.neutralSecondary,
	                transition: "transform " + Styling_1.AnimationVariables.durationValue2 + " " + beziers.easeInBack + ", opacity " + Styling_1.AnimationVariables.durationValue4 + " " + beziers.easeOutSine,
	                opacity: 0,
	                transform: 'rotate(0.2deg) scale(0.65)',
	                transformOrigin: '10px 10px',
	                selectors: (_b = {},
	                    _b[":global(." + classNames.iconTag + ")"] = {
	                        position: 'absolute'
	                    },
	                    _b)
	            }
	        ]
	    };
	    var _a, _b;
	};
	//# sourceMappingURL=GroupHeader.styles.js.map

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DetailsRow',
	    compact: 'ms-DetailsList--Compact',
	    cell: 'ms-DetailsRow-cell',
	    cellAnimation: 'ms-DetailsRow-cellAnimation',
	    cellCheck: 'ms-DetailsRow-cellCheck',
	    cellMeasurer: 'ms-DetailsRow-cellMeasurer',
	    listCellFirstChild: 'ms-List-cell:first-child',
	    isContentUnselectable: 'is-contentUnselectable',
	    isSelected: 'is-selected',
	    isCheckVisible: 'is-check-visible',
	    fields: 'ms-DetailsRow-fields'
	};
	var IsFocusableSelector = "[data-is-focusable='true']";
	exports.DEFAULT_CELL_STYLE_PROPS = {
	    cellLeftPadding: 12,
	    cellRightPadding: 8,
	    cellExtraRightPadding: 24
	};
	// Source of default row heights to share.
	exports.DEFAULT_ROW_HEIGHTS = {
	    rowHeight: 42,
	    compactRowHeight: 32
	};
	// Constant values
	var values = tslib_1.__assign({}, exports.DEFAULT_ROW_HEIGHTS, { rowVerticalPadding: 11, compactRowVerticalPadding: 6, rowShimmerLineHeight: 7, rowShimmerIconPlaceholderHeight: 16, rowShimmerVerticalBorder: 0, compactRowShimmerVerticalBorder: 0 });
	// Computed Values
	values = tslib_1.__assign({}, values, {
	    rowShimmerVerticalBorder: (values.rowHeight - values.rowShimmerLineHeight) / 2,
	    compactRowShimmerVerticalBorder: (values.compactRowHeight - values.rowShimmerLineHeight) / 2
	});
	exports.getStyles = function (props) {
	    var theme = props.theme, isSelected = props.isSelected, canSelect = props.canSelect, droppingClassName = props.droppingClassName, anySelected = props.anySelected, isCheckVisible = props.isCheckVisible, checkboxCellClassName = props.checkboxCellClassName, compact = props.compact, className = props.className, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? exports.DEFAULT_CELL_STYLE_PROPS : _a, enableUpdateAnimations = props.enableUpdateAnimations;
	    var _b = theme.palette, neutralPrimary = _b.neutralPrimary, white = _b.white, neutralSecondary = _b.neutralSecondary, neutralLighter = _b.neutralLighter, neutralLight = _b.neutralLight, neutralDark = _b.neutralDark, neutralQuaternaryAlt = _b.neutralQuaternaryAlt, black = _b.black;
	    var focusBorder = theme.semanticColors.focusBorder;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var colors = {
	        // Default
	        defaultHeaderTextColor: neutralPrimary,
	        defaultMetaTextColor: neutralSecondary,
	        defaultBackgroundColor: white,
	        // Hover
	        hoverTextColor: neutralPrimary,
	        hoverColorBackground: neutralLighter,
	        // Selected
	        selectedTextColor: neutralDark,
	        selectedMetaTextColor: neutralPrimary,
	        selectedBackgroundColor: neutralLight,
	        // Selected Hover
	        selectedHoverTextColor: black,
	        selectedHoverMetaTextColor: neutralDark,
	        selectedHoverBackgroundColor: neutralQuaternaryAlt,
	        // Focus
	        focusHeaderTextColor: black,
	        focusBackgroundColor: neutralQuaternaryAlt,
	        focusMetaTextColor: neutralDark
	    };
	    var shimmerRightBorderStyle = cellStyleProps.cellRightPadding * 4 + "px solid " + colors.defaultBackgroundColor;
	    var shimmerLeftBorderStyle = cellStyleProps.cellLeftPadding + "px solid " + colors.defaultBackgroundColor;
	    var selectedStyles = [
	        Styling_1.getFocusStyle(theme, { inset: -1, borderColor: focusBorder, outlineColor: white }),
	        classNames.isSelected,
	        {
	            color: colors.selectedMetaTextColor,
	            background: colors.selectedBackgroundColor,
	            borderBottom: "1px solid " + white,
	            selectors: (_c = {
	                    '&:before': {
	                        position: 'absolute',
	                        display: 'block',
	                        top: -1,
	                        height: 1,
	                        bottom: 0,
	                        left: 0,
	                        right: 0,
	                        content: '',
	                        borderTop: "1px solid " + white
	                    },
	                    // Selected State hover
	                    '&:hover': {
	                        background: colors.selectedHoverBackgroundColor,
	                        selectors: (_d = {
	                                // Selected State hover meta cell
	                                $cell: {
	                                    color: colors.selectedHoverMetaTextColor,
	                                    selectors: (_e = {},
	                                        _e[Styling_1.HighContrastSelector] = {
	                                            color: 'HighlightText',
	                                            selectors: {
	                                                '> a': {
	                                                    color: 'HighlightText'
	                                                }
	                                            }
	                                        },
	                                        // Selected State hover Header cell
	                                        _e['&.$isRowHeader'] = {
	                                            color: colors.selectedHoverTextColor,
	                                            selectors: (_f = {},
	                                                _f[Styling_1.HighContrastSelector] = {
	                                                    color: 'HighlightText'
	                                                },
	                                                _f)
	                                        },
	                                        _e)
	                                }
	                            },
	                            // Ensure high-contrast mode overrides default hover background
	                            _d[Styling_1.HighContrastSelector] = {
	                                background: 'Highlight'
	                            },
	                            _d)
	                    },
	                    // Focus state
	                    '&:focus': {
	                        background: colors.focusBackgroundColor,
	                        selectors: (_g = {
	                                // Selected State hover meta cell
	                                $cell: {
	                                    color: colors.focusMetaTextColor,
	                                    // Row header cell
	                                    '&.$isRowHeader': {
	                                        color: colors.focusHeaderTextColor,
	                                        selectors: (_h = {},
	                                            _h[Styling_1.HighContrastSelector] = {
	                                                color: 'HighlightText'
	                                            },
	                                            _h)
	                                    }
	                                }
	                            },
	                            // Ensure high-contrast mode overrides default focus background
	                            _g[Styling_1.HighContrastSelector] = {
	                                background: 'Highlight'
	                            },
	                            _g)
	                    }
	                },
	                _c[Styling_1.HighContrastSelector] = {
	                    background: 'Highlight',
	                    color: 'HighlightText',
	                    MsHighContrastAdjust: 'none',
	                    selectors: {
	                        a: {
	                            color: 'HighlightText'
	                        }
	                    }
	                },
	                _c)
	        }
	    ];
	    var cannotSelectStyles = [
	        classNames.isContentUnselectable,
	        {
	            userSelect: 'none',
	            cursor: 'default'
	        }
	    ];
	    var rootCompactStyles = {
	        minHeight: values.compactRowHeight,
	        border: 0
	    };
	    var cellCompactStyles = {
	        minHeight: values.compactRowHeight,
	        paddingTop: values.compactRowVerticalPadding,
	        paddingBottom: values.compactRowVerticalPadding,
	        paddingLeft: cellStyleProps.cellLeftPadding + "px",
	        selectors: (_j = {},
	            // Masking the running shimmer background with borders
	            _j["&$shimmer"] = {
	                padding: 0,
	                borderLeft: shimmerLeftBorderStyle,
	                borderRight: shimmerRightBorderStyle,
	                borderTop: values.compactRowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor,
	                borderBottom: values.compactRowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor
	            },
	            // Masking the running shimmer background with borders when it's an Icon placeholder
	            _j["&$shimmerIconPlaceholder"] = {
	                borderRight: cellStyleProps.cellRightPadding + "px solid " + colors.defaultBackgroundColor,
	                borderBottom: (values.compactRowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor,
	                borderTop: (values.compactRowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor
	            },
	            _j)
	    };
	    var defaultCellStyles = [
	        Styling_1.getFocusStyle(theme, { inset: -1 }),
	        classNames.cell,
	        {
	            display: 'inline-block',
	            position: 'relative',
	            boxSizing: 'border-box',
	            minHeight: values.rowHeight,
	            verticalAlign: 'top',
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            paddingTop: values.rowVerticalPadding,
	            paddingBottom: values.rowVerticalPadding,
	            paddingLeft: cellStyleProps.cellLeftPadding + "px",
	            selectors: (_k = {
	                    '& > button': {
	                        maxWidth: '100%'
	                    }
	                },
	                _k[IsFocusableSelector] = Styling_1.getFocusStyle(theme, { inset: -1, borderColor: neutralSecondary, outlineColor: white }),
	                _k['&$shimmer'] = {
	                    padding: 0,
	                    borderLeft: shimmerLeftBorderStyle,
	                    borderRight: shimmerRightBorderStyle,
	                    borderTop: values.rowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor,
	                    borderBottom: values.rowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor
	                },
	                _k['&$shimmerIconPlaceholder'] = {
	                    borderRight: cellStyleProps.cellRightPadding + "px solid " + colors.defaultBackgroundColor,
	                    borderBottom: (values.rowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor,
	                    borderTop: (values.rowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor
	                },
	                _k)
	        },
	        compact && cellCompactStyles
	    ];
	    return {
	        root: [
	            classNames.root,
	            Styling_1.AnimationClassNames.fadeIn400,
	            droppingClassName,
	            theme.fonts.small,
	            isCheckVisible && classNames.isCheckVisible,
	            Styling_1.getFocusStyle(theme, { borderColor: focusBorder, outlineColor: white }),
	            {
	                borderBottom: "1px solid " + neutralLighter,
	                background: colors.defaultBackgroundColor,
	                color: colors.defaultMetaTextColor,
	                display: 'inline-flex',
	                minWidth: '100%',
	                minHeight: values.rowHeight,
	                whiteSpace: 'nowrap',
	                padding: 0,
	                boxSizing: 'border-box',
	                verticalAlign: 'top',
	                textAlign: 'left',
	                selectors: (_l = {},
	                    _l[classNames.listCellFirstChild + " &:before"] = {
	                        display: 'none'
	                    },
	                    _l['&:hover'] = {
	                        background: colors.hoverColorBackground
	                    },
	                    _l['&:hover $check'] = {
	                        opacity: 1
	                    },
	                    _l)
	            },
	            isSelected && selectedStyles,
	            !canSelect && cannotSelectStyles,
	            compact && rootCompactStyles,
	            className
	        ],
	        cellUnpadded: {
	            paddingRight: cellStyleProps.cellRightPadding + "px"
	        },
	        cellPadded: {
	            paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding + "px",
	            selectors: {
	                '&.$checkCell': {
	                    paddingRight: 0
	                }
	            }
	        },
	        cell: defaultCellStyles,
	        cellAnimation: enableUpdateAnimations && Styling_1.AnimationStyles.slideLeftIn40,
	        cellMeasurer: [
	            classNames.cellMeasurer,
	            {
	                overflow: 'visible',
	                whiteSpace: 'nowrap'
	            }
	        ],
	        checkCell: [
	            defaultCellStyles,
	            classNames.cellCheck,
	            checkboxCellClassName,
	            {
	                padding: 0,
	                // Ensure that the check cell covers the top border of the cell.
	                // This ensures the click target does not leave a spot which would
	                // cause other items to be deselected.
	                paddingTop: 1,
	                marginTop: -1,
	                flexShrink: 0
	            }
	        ],
	        checkCover: {
	            position: 'absolute',
	            top: -1,
	            left: 0,
	            bottom: 0,
	            right: 0,
	            display: anySelected ? 'block' : 'none'
	        },
	        fields: [
	            classNames.fields,
	            {
	                display: 'flex',
	                alignItems: 'stretch'
	            }
	        ],
	        isRowHeader: [
	            {
	                color: colors.defaultHeaderTextColor,
	                fontSize: Styling_1.FontSizes.medium
	            }
	        ],
	        isMultiline: [
	            defaultCellStyles,
	            {
	                whiteSpace: 'normal',
	                wordBreak: 'break-word',
	                textOverflow: 'clip'
	            }
	        ],
	        shimmer: [],
	        shimmerIconPlaceholder: [],
	        shimmerLeftBorder: [
	            {
	                // 40px to take into account the checkbox of items if present.
	                borderLeft: "40px solid " + colors.defaultBackgroundColor
	            }
	        ],
	        shimmerBottomBorder: [
	            {
	                // 1px to take into account the border-bottom when items replace shimmer lines and in default state.
	                borderBottom: "1px solid " + colors.defaultBackgroundColor
	            }
	        ],
	        check: []
	    };
	    var _c, _d, _e, _f, _g, _h, _j, _k, _l;
	};
	//# sourceMappingURL=DetailsRow.styles.js.map

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var index_1 = __webpack_require__(866);
	var Check_1 = __webpack_require__(757);
	var Icon_1 = __webpack_require__(643);
	var GroupSpacer_1 = __webpack_require__(874);
	var Spinner_1 = __webpack_require__(885);
	var FocusZone_1 = __webpack_require__(676);
	var getClassNames = Utilities_1.classNamesFunction();
	var GroupHeaderBase = /** @class */ (function (_super) {
	    tslib_1.__extends(GroupHeaderBase, _super);
	    function GroupHeaderBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onToggleCollapse = function (ev) {
	            var _a = _this.props, group = _a.group, onToggleCollapse = _a.onToggleCollapse, isGroupLoading = _a.isGroupLoading;
	            var isCollapsed = _this.state.isCollapsed;
	            var newCollapsed = !isCollapsed;
	            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(group);
	            _this.setState({
	                isCollapsed: newCollapsed,
	                isLoadingVisible: newLoadingVisible
	            });
	            if (onToggleCollapse) {
	                onToggleCollapse(group);
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        _this._onToggleSelectGroupClick = function (ev) {
	            var _a = _this.props, onToggleSelectGroup = _a.onToggleSelectGroup, group = _a.group;
	            if (onToggleSelectGroup) {
	                onToggleSelectGroup(group);
	            }
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._onHeaderClick = function () {
	            var _a = _this.props, group = _a.group, onGroupHeaderClick = _a.onGroupHeaderClick, onToggleSelectGroup = _a.onToggleSelectGroup;
	            if (onGroupHeaderClick) {
	                onGroupHeaderClick(group);
	            }
	            else if (onToggleSelectGroup) {
	                onToggleSelectGroup(group);
	            }
	        };
	        _this._onRenderTitle = function (props) {
	            var group = props.group;
	            if (!group) {
	                return null;
	            }
	            return (React.createElement("div", { className: _this._classNames.title },
	                React.createElement("span", null, group.name),
	                React.createElement("span", { className: _this._classNames.headerCount },
	                    "(",
	                    group.count,
	                    group.hasMoreData && '+',
	                    ")")));
	        };
	        _this.state = {
	            isCollapsed: (_this.props.group && _this.props.group.isCollapsed),
	            isLoadingVisible: false
	        };
	        return _this;
	    }
	    GroupHeaderBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.group) {
	            var newCollapsed = newProps.group.isCollapsed;
	            var isGroupLoading = newProps.isGroupLoading;
	            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(newProps.group);
	            this.setState({
	                isCollapsed: newCollapsed || false,
	                isLoadingVisible: newLoadingVisible || false
	            });
	        }
	    };
	    GroupHeaderBase.prototype.render = function () {
	        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, viewport = _a.viewport, selectionMode = _a.selectionMode, loadingText = _a.loadingText, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, indentWidth = _a.indentWidth, _d = _a.onRenderTitle, onRenderTitle = _d === void 0 ? this._onRenderTitle : _d, _e = _a.isCollapsedGroupSelectVisible, isCollapsedGroupSelectVisible = _e === void 0 ? true : _e, expandButtonProps = _a.expandButtonProps, selectAllButtonProps = _a.selectAllButtonProps, theme = _a.theme, styles = _a.styles, className = _a.className, groupedListId = _a.groupedListId, compact = _a.compact;
	        var _f = this.state, isCollapsed = _f.isCollapsed, isLoadingVisible = _f.isLoadingVisible;
	        var canSelectGroup = selectionMode === index_1.SelectionMode.multiple;
	        var isSelectionCheckVisible = canSelectGroup && (isCollapsedGroupSelectVisible || !(group && group.isCollapsed));
	        var currentlySelected = isSelected || selected;
	        var isRTL = Utilities_1.getRTL();
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            selected: currentlySelected,
	            isCollapsed: isCollapsed,
	            compact: compact
	        });
	        if (!group) {
	            return null;
	        }
	        return (React.createElement("div", { className: this._classNames.root, style: viewport ? { minWidth: viewport.width } : {}, onClick: this._onHeaderClick, "aria-label": group.ariaLabel || group.name, "data-is-focusable": true },
	            React.createElement(FocusZone_1.FocusZone, { className: this._classNames.groupHeaderContainer, direction: FocusZone_1.FocusZoneDirection.horizontal },
	                isSelectionCheckVisible ? (React.createElement("button", tslib_1.__assign({ type: "button", className: this._classNames.check, role: "checkbox", "aria-checked": currentlySelected, "data-selection-toggle": true, onClick: this._onToggleSelectGroupClick }, selectAllButtonProps),
	                    React.createElement(Check_1.Check, { checked: currentlySelected }))) : (selectionMode !== index_1.SelectionMode.none && React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: 1 })),
	                React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: groupLevel }),
	                React.createElement("div", { className: this._classNames.dropIcon },
	                    React.createElement(Icon_1.Icon, { iconName: "Tag" })),
	                React.createElement("button", tslib_1.__assign({ type: "button", className: this._classNames.expand, onClick: this._onToggleCollapse, "aria-expanded": group ? !group.isCollapsed : undefined, "aria-controls": group && !group.isCollapsed ? groupedListId : undefined }, expandButtonProps),
	                    React.createElement(Icon_1.Icon, { className: this._classNames.expandIsCollapsed, iconName: isRTL ? 'ChevronLeftMed' : 'ChevronRightMed' })),
	                onRenderTitle(this.props, this._onRenderTitle),
	                isLoadingVisible && React.createElement(Spinner_1.Spinner, { label: loadingText }))));
	    };
	    GroupHeaderBase.defaultProps = {
	        expandButtonProps: { 'aria-label': 'expand collapse group' }
	    };
	    return GroupHeaderBase;
	}(React.Component));
	exports.GroupHeaderBase = GroupHeaderBase;
	//# sourceMappingURL=GroupHeader.base.js.map

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(886), exports);
	//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(887), exports);
	tslib_1.__exportStar(__webpack_require__(888), exports);
	tslib_1.__exportStar(__webpack_require__(889), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Spinner_base_1 = __webpack_require__(888);
	var Spinner_styles_1 = __webpack_require__(890);
	exports.Spinner = Utilities_1.styled(Spinner_base_1.SpinnerBase, Spinner_styles_1.getStyles, undefined, { scope: 'Spinner' });
	//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Spinner_types_1 = __webpack_require__(889);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var SpinnerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(SpinnerBase, _super);
	    function SpinnerBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SpinnerBase.prototype.render = function () {
	        var _a = this.props, type = _a.type, size = _a.size, ariaLabel = _a.ariaLabel, ariaLive = _a.ariaLive, styles = _a.styles, label = _a.label, theme = _a.theme, className = _a.className, labelPosition = _a.labelPosition;
	        var statusMessage = ariaLabel;
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['size']);
	        // SpinnerType is deprecated. If someone is still using this property, rather than putting the SpinnerType into the ISpinnerStyleProps,
	        // we'll map SpinnerType to its equivalent SpinnerSize and pass that in. Once SpinnerType finally goes away we should delete this.
	        var styleSize = size;
	        if (styleSize === undefined && type !== undefined) {
	            styleSize = type === Spinner_types_1.SpinnerType.large ? Spinner_types_1.SpinnerSize.large : Spinner_types_1.SpinnerSize.medium;
	        }
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            size: styleSize,
	            className: className,
	            labelPosition: labelPosition
	        });
	        return (React.createElement("div", tslib_1.__assign({}, nativeProps, { className: classNames.root }),
	            React.createElement("div", { className: classNames.circle }),
	            label && React.createElement("div", { className: classNames.label }, label),
	            statusMessage && (React.createElement("div", { role: "status", "aria-live": ariaLive },
	                React.createElement(Utilities_1.DelayedRender, null,
	                    React.createElement("div", { className: classNames.screenReaderText }, statusMessage))))));
	    };
	    SpinnerBase.defaultProps = {
	        size: Spinner_types_1.SpinnerSize.medium,
	        ariaLive: 'polite',
	        labelPosition: 'bottom'
	    };
	    return SpinnerBase;
	}(Utilities_1.BaseComponent));
	exports.SpinnerBase = SpinnerBase;
	//# sourceMappingURL=Spinner.base.js.map

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Possible variations of the spinner circle size.
	 * {@docCategory Spinner}
	 */
	var SpinnerSize;
	(function (SpinnerSize) {
	    /**
	     * 12px Spinner diameter
	     */
	    SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
	    /**
	     * 16px Spinner diameter
	     */
	    SpinnerSize[SpinnerSize["small"] = 1] = "small";
	    /**
	     * 20px Spinner diameter
	     */
	    SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
	    /**
	     * 28px Spinner diameter
	     */
	    SpinnerSize[SpinnerSize["large"] = 3] = "large";
	})(SpinnerSize = exports.SpinnerSize || (exports.SpinnerSize = {}));
	/**
	 * Deprecated at v2.0.0, use `SpinnerSize` instead.
	 * @deprecated Use `SpinnerSize` instead.
	 * {@docCategory Spinner}
	 */
	var SpinnerType;
	(function (SpinnerType) {
	    /**
	     * Deprecated and will be removed at \>= 2.0.0. Use `SpinnerSize.medium` instead.
	     * @deprecated Use `SpinnerSize.medium` instead.
	     */
	    SpinnerType[SpinnerType["normal"] = 0] = "normal";
	    /**
	     * Deprecated and will be removed at \>= 2.0.0. Use `SpinnerSize.large` instead.
	     * @deprecated Use `SpinnerSize.large` instead.
	     */
	    SpinnerType[SpinnerType["large"] = 1] = "large";
	})(SpinnerType = exports.SpinnerType || (exports.SpinnerType = {}));
	//# sourceMappingURL=Spinner.types.js.map

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Spinner_types_1 = __webpack_require__(889);
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Spinner',
	    circle: 'ms-Spinner-circle',
	    label: 'ms-Spinner-label'
	};
	var spinAnimation = Styling_1.keyframes({
	    '0%': {
	        transform: 'rotate(0deg)'
	    },
	    '100%': {
	        transform: 'rotate(360deg)'
	    }
	});
	exports.getStyles = function (props) {
	    var theme = props.theme, size = props.size, className = props.className, labelPosition = props.labelPosition;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                display: 'flex',
	                flexDirection: 'column',
	                alignItems: 'center',
	                justifyContent: 'center'
	            },
	            labelPosition === 'top' && {
	                flexDirection: 'column-reverse'
	            },
	            labelPosition === 'right' && {
	                flexDirection: 'row'
	            },
	            labelPosition === 'left' && {
	                flexDirection: 'row-reverse'
	            },
	            className
	        ],
	        circle: [
	            classNames.circle,
	            {
	                boxSizing: 'border-box',
	                borderRadius: '50%',
	                border: '1.5px solid ' + palette.themeLight,
	                borderTopColor: palette.themePrimary,
	                animationName: spinAnimation,
	                animationDuration: '1.3s',
	                animationIterationCount: 'infinite',
	                animationTimingFunction: 'cubic-bezier(.53,.21,.29,.67)',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderTopColor: 'Highlight'
	                    },
	                    _a)
	            },
	            size === Spinner_types_1.SpinnerSize.xSmall && [
	                'ms-Spinner--xSmall',
	                {
	                    width: 12,
	                    height: 12
	                }
	            ],
	            size === Spinner_types_1.SpinnerSize.small && [
	                'ms-Spinner--small',
	                {
	                    width: 16,
	                    height: 16
	                }
	            ],
	            size === Spinner_types_1.SpinnerSize.medium && [
	                'ms-Spinner--medium',
	                {
	                    width: 20,
	                    height: 20
	                }
	            ],
	            size === Spinner_types_1.SpinnerSize.large && [
	                'ms-Spinner--large',
	                {
	                    width: 28,
	                    height: 28
	                }
	            ]
	        ],
	        label: [
	            classNames.label,
	            {
	                color: palette.themePrimary,
	                margin: '10px 0 0',
	                textAlign: 'center'
	            },
	            labelPosition === 'top' && {
	                margin: '0 0 10px'
	            },
	            labelPosition === 'right' && {
	                margin: '0 0 0 10px'
	            },
	            labelPosition === 'left' && {
	                margin: '0 10px 0 0'
	            }
	        ],
	        screenReaderText: Styling_1.hiddenContentStyle
	    };
	    var _a;
	};
	//# sourceMappingURL=Spinner.styles.js.map

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var GroupShowAll_styles_1 = __webpack_require__(892);
	var GroupShowAll_base_1 = __webpack_require__(893);
	exports.GroupShowAll = Utilities_1.styled(GroupShowAll_base_1.GroupShowAllBase, GroupShowAll_styles_1.getStyles, undefined, { scope: 'GroupShowAll' });
	//# sourceMappingURL=GroupShowAll.js.map

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-GroupShowAll',
	    link: 'ms-Link'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                position: 'relative',
	                padding: '10px 84px',
	                cursor: 'pointer',
	                selectors: (_a = {},
	                    _a["." + classNames.link] = {
	                        fontSize: Styling_1.FontSizes.small
	                    },
	                    _a)
	            }
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=GroupShowAll.styles.js.map

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Link_1 = __webpack_require__(680);
	var GroupSpacer_1 = __webpack_require__(874);
	var getClassNames = Utilities_1.classNamesFunction();
	var GroupShowAllBase = /** @class */ (function (_super) {
	    tslib_1.__extends(GroupShowAllBase, _super);
	    function GroupShowAllBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onSummarizeClick = function (ev) {
	            _this.props.onToggleSummarize(_this.props.group);
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        return _this;
	    }
	    GroupShowAllBase.prototype.render = function () {
	        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, showAllLinkText = _a.showAllLinkText, styles = _a.styles, theme = _a.theme;
	        var classNames = getClassNames(styles, { theme: theme });
	        if (group) {
	            return (React.createElement("div", { className: classNames.root },
	                React.createElement(GroupSpacer_1.GroupSpacer, { count: groupLevel }),
	                React.createElement(Link_1.Link, { onClick: this._onSummarizeClick }, showAllLinkText)));
	        }
	        return null;
	    };
	    GroupShowAllBase.defaultProps = {
	        showAllLinkText: 'Show All'
	    };
	    return GroupShowAllBase;
	}(Utilities_1.BaseComponent));
	exports.GroupShowAllBase = GroupShowAllBase;
	//# sourceMappingURL=GroupShowAll.base.js.map

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var GroupFooter_styles_1 = __webpack_require__(895);
	var GroupFooter_base_1 = __webpack_require__(896);
	exports.GroupFooter = Utilities_1.styled(GroupFooter_base_1.GroupFooterBase, GroupFooter_styles_1.getStyles, undefined, {
	    scope: 'GroupFooter'
	});
	//# sourceMappingURL=GroupFooter.js.map

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-groupFooter'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            theme.fonts.medium,
	            classNames.root,
	            {
	                position: 'relative',
	                padding: '5px 38px'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=GroupFooter.styles.js.map

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var GroupSpacer_1 = __webpack_require__(874);
	var getClassNames = Utilities_1.classNamesFunction();
	var GroupFooterBase = /** @class */ (function (_super) {
	    tslib_1.__extends(GroupFooterBase, _super);
	    function GroupFooterBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GroupFooterBase.prototype.render = function () {
	        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, footerText = _a.footerText, indentWidth = _a.indentWidth, styles = _a.styles, theme = _a.theme;
	        var classNames = getClassNames(styles, { theme: theme });
	        if (group && footerText) {
	            return (React.createElement("div", { className: classNames.root },
	                React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: groupLevel }),
	                footerText));
	        }
	        return null;
	    };
	    return GroupFooterBase;
	}(React.Component));
	exports.GroupFooterBase = GroupFooterBase;
	//# sourceMappingURL=GroupFooter.base.js.map

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Check_1 = __webpack_require__(757);
	var Check_styles_1 = __webpack_require__(761);
	var DetailsRowCheck_styles_1 = __webpack_require__(898);
	var getCheckClassNames = Utilities_1.classNamesFunction({
	    disableCaching: true
	});
	var getClassNames = Utilities_1.classNamesFunction({
	    disableCaching: true
	});
	var DetailsRowCheckBase = function (props) {
	    var _a = props.isVisible, isVisible = _a === void 0 ? false : _a, _b = props.canSelect, canSelect = _b === void 0 ? false : _b, _c = props.isSelected, isSelected = _c === void 0 ? false : _c, _d = props.anySelected, anySelected = _d === void 0 ? false : _d, _e = props.selected, selected = _e === void 0 ? false : _e, _f = props.isHeader, isHeader = _f === void 0 ? false : _f, className = props.className, checkClassName = props.checkClassName, styles = props.styles, theme = props.theme, compact = props.compact, onRenderDetailsCheckbox = props.onRenderDetailsCheckbox, useFastIcons = props.useFastIcons, // must be removed from buttonProps
	    buttonProps = tslib_1.__rest(props, ["isVisible", "canSelect", "isSelected", "anySelected", "selected", "isHeader", "className", "checkClassName", "styles", "theme", "compact", "onRenderDetailsCheckbox", "useFastIcons"]);
	    var defaultCheckboxRender = useFastIcons ? _fastDefaultCheckboxRender : _defaultCheckboxRender;
	    var onRenderCheckbox = onRenderDetailsCheckbox || defaultCheckboxRender;
	    var isPressed = isSelected || selected;
	    var checkStyles = useFastIcons ? undefined : Check_styles_1.getStyles({ theme: theme });
	    var checkClassNames = useFastIcons
	        ? undefined
	        : getCheckClassNames(checkStyles, {
	            theme: theme
	        });
	    var classNames = getClassNames(styles, {
	        theme: theme,
	        canSelect: canSelect,
	        selected: isPressed,
	        anySelected: anySelected,
	        className: className,
	        isHeader: isHeader,
	        isVisible: isVisible,
	        compact: compact,
	        useGlobalCheckHostClass: useFastIcons
	    });
	    var detailsCheckboxProps = {
	        checked: isPressed,
	        theme: theme
	    };
	    return canSelect ? (React.createElement("div", tslib_1.__assign({}, buttonProps, { role: "checkbox", className: Utilities_1.css(classNames.root, classNames.check, checkClassNames && checkClassNames.checkHost), "aria-checked": isPressed, "data-selection-toggle": true, "data-automationid": "DetailsRowCheck" }), onRenderCheckbox(detailsCheckboxProps, defaultCheckboxRender))) : (React.createElement("div", tslib_1.__assign({}, buttonProps, { className: Utilities_1.css(classNames.root, classNames.check) })));
	};
	function _defaultCheckboxRender(checkboxProps) {
	    return React.createElement(Check_1.Check, { checked: checkboxProps.checked });
	}
	function _fastDefaultCheckboxRender(checkboxProps) {
	    return Check_1.getCheck(checkboxProps.theme, checkboxProps.checked);
	}
	exports.DetailsRowCheck = Utilities_1.styled(DetailsRowCheckBase, DetailsRowCheck_styles_1.getStyles, undefined, { scope: 'DetailsRowCheck' }, true);
	//# sourceMappingURL=DetailsRowCheck.js.map

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var DetailsHeader_styles_1 = __webpack_require__(899);
	var Check_styles_1 = __webpack_require__(761);
	var GlobalClassNames = {
	    root: 'ms-DetailsRow-check',
	    isDisabled: 'ms-DetailsRow-check--isDisabled',
	    isHeader: 'ms-DetailsRow-check--isHeader'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, isHeader = props.isHeader, selected = props.selected, anySelected = props.anySelected, canSelect = props.canSelect, compact = props.compact, isVisible = props.isVisible, useGlobalCheckHostClass = props.useGlobalCheckHostClass;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var rowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.rowHeight, compactRowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.compactRowHeight;
	    var height = isHeader ? DetailsHeader_styles_1.HEADER_HEIGHT : compact ? compactRowHeight : rowHeight;
	    var isCheckVisible = isVisible || selected || anySelected;
	    return {
	        root: [classNames.root, className],
	        check: [
	            !canSelect && classNames.isDisabled,
	            isHeader && classNames.isHeader,
	            Styling_1.getFocusStyle(theme),
	            theme.fonts.small,
	            useGlobalCheckHostClass && Check_styles_1.CheckGlobalClassNames.checkHost,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                cursor: 'default',
	                boxSizing: 'border-box',
	                verticalAlign: 'top',
	                background: 'none',
	                backgroundColor: 'transparent',
	                border: 'none',
	                opacity: isCheckVisible ? 1 : 0,
	                height: height,
	                width: 40,
	                padding: 0,
	                margin: 0
	            },
	            useGlobalCheckHostClass && {
	                selectors: {
	                    '&:hover': {
	                        opacity: 1
	                    }
	                }
	            }
	        ],
	        isDisabled: []
	    };
	};
	//# sourceMappingURL=DetailsRowCheck.styles.js.map

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var DetailsRow_styles_1 = __webpack_require__(883);
	// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.
	var GroupSpacer_1 = __webpack_require__(874);
	var GlobalClassNames = {
	    tooltipHost: 'ms-TooltipHost',
	    root: 'ms-DetailsHeader',
	    cell: 'ms-DetailsHeader-cell',
	    cellIsCheck: 'ms-DetailsHeader-cellIsCheck',
	    collapseButton: 'ms-DetailsHeader-collapseButton',
	    isCollapsed: 'is-collapsed',
	    isAllSelected: 'is-allSelected',
	    isSelectAllHidden: 'is-selectAllHidden',
	    isResizingColumn: 'is-resizingColumn',
	    cellSizer: 'ms-DetailsHeader-cellSizer',
	    isResizing: 'is-resizing',
	    dropHintCircleStyle: 'ms-DetailsHeader-dropHintCircleStyle',
	    dropHintCaretStyle: 'ms-DetailsHeader-dropHintCaretStyle',
	    dropHintLineStyle: 'ms-DetailsHeader-dropHintLineStyle',
	    cellTitle: 'ms-DetailsHeader-cellTitle',
	    cellName: 'ms-DetailsHeader-cellName',
	    filterChevron: 'ms-DetailsHeader-filterChevron',
	    gripperBarVertical: 'ms-DetailsColumn-gripperBarVertical'
	};
	exports.HEADER_HEIGHT = 32;
	exports.getCellStyles = function (props) {
	    var theme = props.theme, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _a;
	    var semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return [
	        classNames.cell,
	        Styling_1.getFocusStyle(theme),
	        {
	            color: semanticColors.bodyText,
	            position: 'relative',
	            display: 'inline-block',
	            boxSizing: 'border-box',
	            padding: "0 " + cellStyleProps.cellRightPadding + "px 0 " + cellStyleProps.cellLeftPadding + "px",
	            lineHeight: 'inherit',
	            margin: '0',
	            height: exports.HEADER_HEIGHT,
	            verticalAlign: 'top',
	            whiteSpace: 'nowrap',
	            textOverflow: 'ellipsis',
	            textAlign: 'left'
	        }
	    ];
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, isSelectAllHidden = props.isSelectAllHidden, isAllSelected = props.isAllSelected, isResizingColumn = props.isResizingColumn, isSizing = props.isSizing, isAllCollapsed = props.isAllCollapsed, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _a;
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var colors = {
	        iconForegroundColor: semanticColors.bodySubtext,
	        headerForegroundColor: semanticColors.bodyText,
	        headerBackgroundColor: semanticColors.bodyBackground,
	        dropdownChevronForegroundColor: palette.neutralTertiary,
	        resizerColor: palette.neutralTertiaryAlt
	    };
	    var cellSizerFadeInStyles = {
	        opacity: 1,
	        transition: 'opacity 0.3s linear'
	    };
	    var cellStyles = exports.getCellStyles(props);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.small,
	            {
	                display: 'inline-block',
	                background: colors.headerBackgroundColor,
	                position: 'relative',
	                minWidth: '100%',
	                verticalAlign: 'top',
	                height: exports.HEADER_HEIGHT,
	                lineHeight: exports.HEADER_HEIGHT,
	                whiteSpace: 'nowrap',
	                boxSizing: 'content-box',
	                paddingBottom: '1px',
	                paddingTop: '16px',
	                borderBottom: "1px solid " + semanticColors.bodyDivider,
	                cursor: 'default',
	                userSelect: 'none',
	                selectors: (_b = {
	                        '&:hover $check': {
	                            opacity: 1
	                        }
	                    },
	                    _b[classNames.tooltipHost + " $checkTooltip"] = {
	                        display: 'block'
	                    },
	                    _b)
	            },
	            isAllSelected && classNames.isAllSelected,
	            isSelectAllHidden && {
	                selectors: {
	                    $cell$cellIsCheck: {
	                        visibility: 'hidden'
	                    }
	                }
	            },
	            isResizingColumn && classNames.isResizingColumn,
	            className
	        ],
	        check: {
	            height: exports.HEADER_HEIGHT,
	            selectors: (_c = {},
	                _c["." + Utilities_1.IsFocusVisibleClassName + " &:focus"] = {
	                    opacity: 1
	                },
	                _c)
	        },
	        cellWrapperPadded: {
	            paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
	        },
	        cellIsCheck: [
	            cellStyles,
	            classNames.cellIsCheck,
	            {
	                position: 'relative',
	                padding: 0,
	                margin: 0,
	                display: 'inline-flex',
	                alignItems: 'center',
	                border: 'none'
	            },
	            isAllSelected && {
	                opacity: 1
	            }
	        ],
	        cellIsGroupExpander: [
	            cellStyles,
	            {
	                display: 'inline-flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                fontSize: Styling_1.FontSizes.small,
	                padding: 0,
	                border: 'none',
	                width: GroupSpacer_1.SPACER_WIDTH,
	                color: palette.neutralSecondary,
	                selectors: {
	                    ':hover': {
	                        backgroundColor: palette.neutralLighter
	                    },
	                    ':active': {
	                        backgroundColor: palette.neutralLight
	                    }
	                }
	            }
	        ],
	        cellIsActionable: {
	            selectors: {
	                ':hover': {
	                    color: semanticColors.bodyText,
	                    background: semanticColors.listHeaderBackgroundHovered
	                },
	                ':active': {
	                    background: semanticColors.listHeaderBackgroundPressed
	                }
	            }
	        },
	        cellIsEmpty: {
	            textOverflow: 'clip'
	        },
	        cellSizer: [
	            classNames.cellSizer,
	            Styling_1.focusClear(),
	            {
	                display: 'inline-block',
	                position: 'relative',
	                cursor: 'ew-resize',
	                bottom: 0,
	                top: 0,
	                overflow: 'hidden',
	                height: 'inherit',
	                background: 'transparent',
	                zIndex: 1,
	                width: 16,
	                selectors: {
	                    ':after': {
	                        content: '""',
	                        position: 'absolute',
	                        top: 0,
	                        bottom: 0,
	                        width: 1,
	                        background: colors.resizerColor,
	                        opacity: 0,
	                        left: '50%'
	                    },
	                    ':focus:after': cellSizerFadeInStyles,
	                    ':hover:after': cellSizerFadeInStyles,
	                    '&$cellIsResizing:after': [
	                        cellSizerFadeInStyles,
	                        {
	                            boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.4)'
	                        }
	                    ]
	                }
	            }
	        ],
	        cellIsResizing: classNames.isResizing,
	        cellSizerStart: {
	            margin: '0 -8px'
	        },
	        cellSizerEnd: {
	            margin: 0,
	            marginLeft: -16
	        },
	        collapseButton: [
	            classNames.collapseButton,
	            {
	                transformOrigin: '50% 50%',
	                transition: 'transform .1s linear'
	            },
	            isAllCollapsed
	                ? [
	                    classNames.isCollapsed,
	                    {
	                        transform: 'rotate(0deg)'
	                    }
	                ]
	                : {
	                    transform: 'rotate(90deg)'
	                }
	        ],
	        checkTooltip: [],
	        sizingOverlay: isSizing && {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            right: 0,
	            bottom: 0,
	            cursor: 'ew-resize',
	            background: 'rgba(255, 255, 255, 0)',
	            selectors: (_d = {},
	                _d[Styling_1.HighContrastSelector] = {
	                    background: 'transparent',
	                    MsHighContrastAdjust: 'none'
	                },
	                _d)
	        },
	        accessibleLabel: Styling_1.hiddenContentStyle,
	        dropHintCircleStyle: [
	            classNames.dropHintCircleStyle,
	            {
	                display: 'inline-block',
	                visibility: 'hidden',
	                position: 'absolute',
	                bottom: 0,
	                height: 9,
	                width: 9,
	                borderRadius: '50%',
	                marginLeft: -5,
	                top: 34,
	                overflow: 'visible',
	                zIndex: 10,
	                border: "1px solid " + palette.themePrimary,
	                background: palette.white
	            }
	        ],
	        dropHintCaretStyle: [
	            classNames.dropHintCaretStyle,
	            {
	                display: 'none',
	                position: 'absolute',
	                top: -23,
	                left: -6.5,
	                fontSize: 14,
	                color: palette.themePrimary,
	                overflow: 'visible',
	                zIndex: 10
	            }
	        ],
	        dropHintLineStyle: [
	            classNames.dropHintLineStyle,
	            {
	                display: 'none',
	                position: 'absolute',
	                bottom: 0,
	                top: 0,
	                overflow: 'hidden',
	                height: 33,
	                width: 1,
	                background: palette.themePrimary,
	                zIndex: 10
	            }
	        ],
	        dropHintStyle: {
	            display: 'inline-block',
	            position: 'absolute'
	        }
	    };
	    var _b, _c, _d;
	};
	//# sourceMappingURL=DetailsHeader.styles.js.map

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(901), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactDOM = __webpack_require__(41);
	var Utilities_1 = __webpack_require__(592);
	var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
	var MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
	var DragDropHelper = /** @class */ (function () {
	    function DragDropHelper(params) {
	        this._selection = params.selection;
	        this._dragEnterCounts = {};
	        this._activeTargets = {};
	        this._lastId = 0;
	        this._events = new Utilities_1.EventGroup(this);
	        var doc = Utilities_1.getDocument();
	        // clear drag data when mouse up, use capture event to ensure it will be run
	        if (doc) {
	            this._events.on(doc.body, 'mouseup', this._onMouseUp.bind(this), true);
	            this._events.on(doc, 'mouseup', this._onDocumentMouseUp.bind(this), true);
	        }
	    }
	    DragDropHelper.prototype.dispose = function () {
	        this._events.dispose();
	    };
	    DragDropHelper.prototype.subscribe = function (root, events, dragDropOptions) {
	        var _this = this;
	        var _a = dragDropOptions.key, key = _a === void 0 ? "" + ++this._lastId : _a;
	        var handlers = [];
	        var onDragStart;
	        var onDragLeave;
	        var onDragEnter;
	        var onDragEnd;
	        var onDrop;
	        var onDragOver;
	        var onMouseDown;
	        var isDraggable;
	        var isDroppable;
	        var activeTarget;
	        if (dragDropOptions && root) {
	            var eventMap = dragDropOptions.eventMap, context = dragDropOptions.context, updateDropState_1 = dragDropOptions.updateDropState;
	            var dragDropTarget = {
	                root: root,
	                options: dragDropOptions,
	                key: key
	            };
	            isDraggable = this._isDraggable(dragDropTarget);
	            isDroppable = this._isDroppable(dragDropTarget);
	            if (isDraggable || isDroppable) {
	                if (eventMap) {
	                    for (var _i = 0, eventMap_1 = eventMap; _i < eventMap_1.length; _i++) {
	                        var event_1 = eventMap_1[_i];
	                        var handler = {
	                            callback: event_1.callback.bind(null, context),
	                            eventName: event_1.eventName
	                        };
	                        handlers.push(handler);
	                        this._events.on(root, handler.eventName, handler.callback);
	                    }
	                }
	            }
	            if (isDroppable) {
	                // If the target is droppable, wire up global event listeners to track drop-related events.
	                onDragLeave = function (event) {
	                    if (!event.isHandled) {
	                        event.isHandled = true;
	                        _this._dragEnterCounts[key]--;
	                        if (_this._dragEnterCounts[key] === 0) {
	                            updateDropState_1(false /* isDropping */, event);
	                        }
	                    }
	                };
	                onDragEnter = function (event) {
	                    event.preventDefault(); // needed for IE
	                    if (!event.isHandled) {
	                        event.isHandled = true;
	                        _this._dragEnterCounts[key]++;
	                        if (_this._dragEnterCounts[key] === 1) {
	                            updateDropState_1(true /* isDropping */, event);
	                        }
	                    }
	                };
	                onDragEnd = function (event) {
	                    _this._dragEnterCounts[key] = 0;
	                    updateDropState_1(false /* isDropping */, event);
	                };
	                onDrop = function (event) {
	                    _this._dragEnterCounts[key] = 0;
	                    updateDropState_1(false /* isDropping */, event);
	                    if (dragDropOptions.onDrop) {
	                        dragDropOptions.onDrop(dragDropOptions.context.data, event);
	                    }
	                };
	                onDragOver = function (event) {
	                    event.preventDefault();
	                    if (dragDropOptions.onDragOver) {
	                        dragDropOptions.onDragOver(dragDropOptions.context.data, event);
	                    }
	                };
	                this._dragEnterCounts[key] = 0;
	                // dragenter and dragleave will be fired when hover to the child element
	                // but we only want to change state when enter or leave the current element
	                // use the count to ensure it.
	                events.on(root, 'dragenter', onDragEnter);
	                events.on(root, 'dragleave', onDragLeave);
	                events.on(root, 'dragend', onDragEnd);
	                events.on(root, 'drop', onDrop);
	                events.on(root, 'dragover', onDragOver);
	            }
	            if (isDraggable) {
	                // If the target is draggable, wire up local event listeners for mouse events.
	                onMouseDown = this._onMouseDown.bind(this, dragDropTarget);
	                onDragEnd = this._onDragEnd.bind(this, dragDropTarget);
	                // We need to add in data so that on Firefox we show the ghost element when dragging
	                onDragStart = function (event) {
	                    var options = _this._dragData.dragTarget.options;
	                    if (options && options.onDragStart) {
	                        options.onDragStart(options.context.data, options.context.index, _this._selection.getSelection(), event);
	                    }
	                    _this._isDragging = true;
	                    if (event.dataTransfer) {
	                        event.dataTransfer.setData('id', root.id);
	                    }
	                };
	                events.on(root, 'dragstart', onDragStart);
	                events.on(root, 'mousedown', onMouseDown);
	                events.on(root, 'dragend', onDragEnd);
	            }
	            activeTarget = {
	                target: dragDropTarget,
	                dispose: function () {
	                    if (_this._activeTargets[key] === activeTarget) {
	                        delete _this._activeTargets[key];
	                    }
	                    if (root) {
	                        for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
	                            var handler = handlers_1[_i];
	                            _this._events.off(root, handler.eventName, handler.callback);
	                        }
	                        if (isDroppable) {
	                            events.off(root, 'dragenter', onDragEnter);
	                            events.off(root, 'dragleave', onDragLeave);
	                            events.off(root, 'dragend', onDragEnd);
	                            events.off(root, 'dragover', onDragOver);
	                            events.off(root, 'drop', onDrop);
	                        }
	                        if (isDraggable) {
	                            events.off(root, 'dragstart', onDragStart);
	                            events.off(root, 'mousedown', onMouseDown);
	                            events.off(root, 'dragend', onDragEnd);
	                        }
	                    }
	                }
	            };
	            this._activeTargets[key] = activeTarget;
	        }
	        return {
	            key: key,
	            dispose: function () {
	                if (activeTarget) {
	                    activeTarget.dispose();
	                }
	            }
	        };
	    };
	    DragDropHelper.prototype.unsubscribe = function (root, key) {
	        var activeTarget = this._activeTargets[key];
	        if (activeTarget) {
	            activeTarget.dispose();
	        }
	    };
	    DragDropHelper.prototype._onDragEnd = function (target, event) {
	        var options = target.options;
	        if (options.onDragEnd) {
	            options.onDragEnd(options.context.data, event);
	        }
	    };
	    /**
	     * clear drag data when mouse up on body
	     */
	    DragDropHelper.prototype._onMouseUp = function (event) {
	        this._isDragging = false;
	        if (this._dragData) {
	            for (var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++) {
	                var key = _a[_i];
	                var activeTarget = this._activeTargets[key];
	                if (activeTarget.target.root) {
	                    this._events.off(activeTarget.target.root, 'mousemove');
	                    this._events.off(activeTarget.target.root, 'mouseleave');
	                }
	            }
	            if (this._dragData.dropTarget) {
	                // raise dragleave event to let dropTarget know it need to remove dropping style
	                Utilities_1.EventGroup.raise(this._dragData.dropTarget.root, 'dragleave');
	                Utilities_1.EventGroup.raise(this._dragData.dropTarget.root, 'drop');
	            }
	        }
	        this._dragData = null;
	    };
	    /**
	     * clear drag data when mouse up outside of the document
	     */
	    DragDropHelper.prototype._onDocumentMouseUp = function (event) {
	        var doc = Utilities_1.getDocument();
	        if (doc && event.target === doc.documentElement) {
	            this._onMouseUp(event);
	        }
	    };
	    /**
	     * when mouse move over a new drop target while dragging some items,
	     * fire dragleave on the old target and fire dragenter to the new target
	     * The target will handle style change on dragenter and dragleave events.
	     */
	    DragDropHelper.prototype._onMouseMove = function (target, event) {
	        var 
	        // use buttons property here since ev.button in some edge case is not updating well during the move.
	        // but firefox doesn't support it, so we set the default value when it is not defined.
	        _a = event.buttons, 
	        // use buttons property here since ev.button in some edge case is not updating well during the move.
	        // but firefox doesn't support it, so we set the default value when it is not defined.
	        buttons = _a === void 0 ? MOUSEMOVE_PRIMARY_BUTTON : _a;
	        if (this._dragData && buttons !== MOUSEMOVE_PRIMARY_BUTTON) {
	            // cancel mouse down event and return early when the primary button is not pressed
	            this._onMouseUp(event);
	            return;
	        }
	        var root = target.root, key = target.key;
	        if (this._isDragging) {
	            if (this._isDroppable(target)) {
	                // we can have nested drop targets in the DOM, like a folder inside a group. In that case, when we drag into
	                // the inner target (folder), we first set dropTarget to the inner element. But the same event is bubbled to the
	                // outer target too, and we need to prevent the outer one from taking over.
	                // So, check if the last dropTarget is not a child of the current.
	                if (this._dragData) {
	                    if (this._dragData.dropTarget && this._dragData.dropTarget.key !== key && !this._isChild(root, this._dragData.dropTarget.root)) {
	                        if (this._dragEnterCounts[this._dragData.dropTarget.key] > 0) {
	                            Utilities_1.EventGroup.raise(this._dragData.dropTarget.root, 'dragleave');
	                            Utilities_1.EventGroup.raise(root, 'dragenter');
	                            this._dragData.dropTarget = target;
	                        }
	                    }
	                }
	            }
	        }
	    };
	    /**
	     * when mouse leave a target while dragging some items, fire dragleave to the target
	     */
	    DragDropHelper.prototype._onMouseLeave = function (target, event) {
	        if (this._isDragging) {
	            if (this._dragData && this._dragData.dropTarget && this._dragData.dropTarget.key === target.key) {
	                Utilities_1.EventGroup.raise(target.root, 'dragleave');
	                this._dragData.dropTarget = undefined;
	            }
	        }
	    };
	    /**
	     * when mouse down on a draggable item, we start to track dragdata.
	     */
	    DragDropHelper.prototype._onMouseDown = function (target, event) {
	        if (event.button !== MOUSEDOWN_PRIMARY_BUTTON) {
	            // Ignore anything except the primary button.
	            return;
	        }
	        if (this._isDraggable(target)) {
	            this._dragData = {
	                clientX: event.clientX,
	                clientY: event.clientY,
	                eventTarget: event.target,
	                dragTarget: target
	            };
	            for (var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++) {
	                var key = _a[_i];
	                var activeTarget = this._activeTargets[key];
	                if (activeTarget.target.root) {
	                    this._events.on(activeTarget.target.root, 'mousemove', this._onMouseMove.bind(this, activeTarget.target));
	                    this._events.on(activeTarget.target.root, 'mouseleave', this._onMouseLeave.bind(this, activeTarget.target));
	                }
	            }
	        }
	        else {
	            this._dragData = null;
	        }
	    };
	    /**
	     * determine whether the child target is a descendant of the parent
	     */
	    DragDropHelper.prototype._isChild = function (parent, child) {
	        var parentElement = ReactDOM.findDOMNode(parent);
	        var childElement = ReactDOM.findDOMNode(child);
	        while (childElement && childElement.parentElement) {
	            if (childElement.parentElement === parentElement) {
	                return true;
	            }
	            childElement = childElement.parentElement;
	        }
	        return false;
	    };
	    DragDropHelper.prototype._isDraggable = function (target) {
	        var options = target.options;
	        return !!(options.canDrag && options.canDrag(options.context.data));
	    };
	    DragDropHelper.prototype._isDroppable = function (target) {
	        // TODO: take the drag item into consideration to prevent dragging an item into the same group
	        var options = target.options;
	        var dragContext = this._dragData && this._dragData.dragTarget ? this._dragData.dragTarget.options.context : undefined;
	        return !!(options.canDrop && options.canDrop(options.context, dragContext));
	    };
	    return DragDropHelper;
	}());
	exports.DragDropHelper = DragDropHelper;
	//# sourceMappingURL=DragDropHelper.js.map

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DetailsColumn_base_1 = __webpack_require__(903);
	var DetailsColumn_styles_1 = __webpack_require__(904);
	exports.DetailsColumn = Utilities_1.styled(DetailsColumn_base_1.DetailsColumnBase, DetailsColumn_styles_1.getStyles, undefined, { scope: 'DetailsColumn' });
	//# sourceMappingURL=DetailsColumn.js.map

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var DetailsList_types_1 = __webpack_require__(873);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
	var getClassNames = Utilities_1.classNamesFunction();
	var TRANSITION_DURATION_DRAG = 200; // ms
	var TRANSITION_DURATION_DROP = 1500; // ms
	var CLASSNAME_ADD_INTERVAL = 20; // ms
	/**
	 * Component for rendering columns in a `DetailsList`.
	 *
	 * {@docCategory DetailsList}
	 */
	var DetailsColumnBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetailsColumnBase, _super);
	    function DetailsColumnBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._onRenderColumnHeaderTooltip = function (tooltipHostProps, defaultRender) {
	            return React.createElement("span", { className: tooltipHostProps.hostClassName }, tooltipHostProps.children);
	        };
	        _this._onDragStart = function (item, itemIndex, selectedItems, event) {
	            var classNames = _this._classNames;
	            if (itemIndex) {
	                _this._updateHeaderDragInfo(itemIndex);
	                _this._root.current.classList.add(classNames.borderWhileDragging);
	                _this._async.setTimeout(function () {
	                    if (_this._root.current) {
	                        _this._root.current.classList.add(classNames.noBorderWhileDragging);
	                    }
	                }, CLASSNAME_ADD_INTERVAL);
	            }
	        };
	        _this._onDragEnd = function (item, event) {
	            var classNames = _this._classNames;
	            if (event) {
	                _this._updateHeaderDragInfo(-1, event);
	            }
	            _this._root.current.classList.remove(classNames.borderWhileDragging);
	            _this._root.current.classList.remove(classNames.noBorderWhileDragging);
	        };
	        _this._updateHeaderDragInfo = function (itemIndex, event) {
	            if (_this.props.setDraggedItemIndex) {
	                _this.props.setDraggedItemIndex(itemIndex);
	            }
	            if (_this.props.updateDragInfo) {
	                _this.props.updateDragInfo({ itemIndex: itemIndex }, event);
	            }
	        };
	        _this._onRootMouseDown = function (ev) {
	            var isDraggable = _this.props.isDraggable;
	            // Ignore anything except the primary button.
	            if (isDraggable && ev.button === MOUSEDOWN_PRIMARY_BUTTON) {
	                ev.stopPropagation();
	            }
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._async = new Utilities_1.Async(_this);
	        _this._events = new Utilities_1.EventGroup(_this);
	        return _this;
	    }
	    DetailsColumnBase.prototype.render = function () {
	        var _a = this.props, column = _a.column, columnIndex = _a.columnIndex, parentId = _a.parentId, isDraggable = _a.isDraggable, styles = _a.styles, theme = _a.theme, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _b, useFastIcons = _a.useFastIcons;
	        var _c = this.props.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _c === void 0 ? this._onRenderColumnHeaderTooltip : _c;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            headerClassName: column.headerClassName,
	            iconClassName: column.iconClassName,
	            isActionable: column.columnActionsMode !== DetailsList_types_1.ColumnActionsMode.disabled,
	            isEmpty: !column.name,
	            isIconVisible: column.isSorted || column.isGrouped || column.isFiltered,
	            isPadded: column.isPadded,
	            isIconOnly: column.isIconOnly,
	            cellStyleProps: cellStyleProps,
	            transitionDurationDrag: TRANSITION_DURATION_DRAG,
	            transitionDurationDrop: TRANSITION_DURATION_DROP
	        });
	        var classNames = this._classNames;
	        var IconComponent = useFastIcons ? Icon_1.FontIcon : Icon_1.Icon;
	        return (React.createElement(React.Fragment, null,
	            React.createElement("div", { key: column.key, ref: this._root, role: 'columnheader', "aria-sort": column.isSorted ? (column.isSortedDescending ? 'descending' : 'ascending') : 'none', "aria-colindex": columnIndex, className: classNames.root, "data-is-draggable": isDraggable, draggable: isDraggable, style: {
	                    width: column.calculatedWidth +
	                        cellStyleProps.cellLeftPadding +
	                        cellStyleProps.cellRightPadding +
	                        (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0)
	                }, "data-automationid": 'ColumnsHeaderColumn', "data-item-key": column.key },
	                isDraggable && React.createElement(IconComponent, { iconName: "GripperBarVertical", className: classNames.gripperBarVerticalStyle }),
	                onRenderColumnHeaderTooltip({
	                    hostClassName: classNames.cellTooltip,
	                    id: parentId + "-" + column.key + "-tooltip",
	                    setAriaDescribedBy: false,
	                    content: column.columnActionsMode !== DetailsList_types_1.ColumnActionsMode.disabled ? column.ariaLabel : '',
	                    children: (React.createElement("span", { id: parentId + "-" + column.key, "aria-label": column.isIconOnly ? column.name : undefined, "aria-labelledby": column.isIconOnly ? undefined : parentId + "-" + column.key + "-name", className: classNames.cellTitle, "data-is-focusable": column.columnActionsMode !== DetailsList_types_1.ColumnActionsMode.disabled, role: column.columnActionsMode !== DetailsList_types_1.ColumnActionsMode.disabled &&
	                            (column.onColumnClick !== undefined || this.props.onColumnClick !== undefined)
	                            ? 'button'
	                            : undefined, "aria-describedby": !this.props.onRenderColumnHeaderTooltip && this._hasAccessibleLabel() ? parentId + "-" + column.key + "-tooltip" : undefined, onContextMenu: this._onColumnContextMenu.bind(this, column), onClick: this._onColumnClick.bind(this, column), "aria-haspopup": column.columnActionsMode === DetailsList_types_1.ColumnActionsMode.hasDropdown, "aria-expanded": column.columnActionsMode === DetailsList_types_1.ColumnActionsMode.hasDropdown ? (column.isMenuOpen ? true : false) : undefined },
	                        React.createElement("span", { id: parentId + "-" + column.key + "-name", className: classNames.cellName },
	                            (column.iconName || column.iconClassName) && (React.createElement(IconComponent, { className: classNames.iconClassName, iconName: column.iconName })),
	                            column.isIconOnly ? React.createElement("span", { className: classNames.accessibleLabel }, column.name) : column.name),
	                        column.isFiltered && React.createElement(IconComponent, { className: classNames.nearIcon, iconName: "Filter" }),
	                        column.isSorted && (React.createElement(IconComponent, { className: classNames.sortIcon, iconName: column.isSortedDescending ? 'SortDown' : 'SortUp' })),
	                        column.isGrouped && React.createElement(IconComponent, { className: classNames.nearIcon, iconName: "GroupedDescending" }),
	                        column.columnActionsMode === DetailsList_types_1.ColumnActionsMode.hasDropdown && !column.isIconOnly && (React.createElement(IconComponent, { "aria-hidden": true, className: classNames.filterChevron, iconName: "ChevronDown" }))))
	                }, this._onRenderColumnHeaderTooltip)),
	            !this.props.onRenderColumnHeaderTooltip ? this._renderAccessibleLabel() : null));
	    };
	    DetailsColumnBase.prototype.componentDidMount = function () {
	        var _this = this;
	        if (this._dragDropSubscription) {
	            this._dragDropSubscription.dispose();
	            delete this._dragDropSubscription;
	        }
	        if (this.props.dragDropHelper && this.props.isDraggable) {
	            this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getColumnDragDropOptions());
	            // We need to use native on this to avoid MarqueeSelection from handling the event before us.
	            this._events.on(this._root.current, 'mousedown', this._onRootMouseDown);
	        }
	        var classNames = this._classNames;
	        if (this.props.isDropped) {
	            if (this._root.current) {
	                this._root.current.classList.add(classNames.borderAfterDropping);
	                this._async.setTimeout(function () {
	                    if (_this._root.current) {
	                        _this._root.current.classList.add(classNames.noBorderAfterDropping);
	                    }
	                }, CLASSNAME_ADD_INTERVAL);
	            }
	            this._async.setTimeout(function () {
	                if (_this._root.current) {
	                    _this._root.current.classList.remove(classNames.borderAfterDropping);
	                    _this._root.current.classList.remove(classNames.noBorderAfterDropping);
	                }
	            }, TRANSITION_DURATION_DROP + CLASSNAME_ADD_INTERVAL);
	        }
	    };
	    DetailsColumnBase.prototype.componentWillUnmount = function () {
	        if (this._dragDropSubscription) {
	            this._dragDropSubscription.dispose();
	            delete this._dragDropSubscription;
	        }
	        this._async.dispose();
	        this._events.dispose();
	    };
	    DetailsColumnBase.prototype.componentDidUpdate = function () {
	        if (!this._dragDropSubscription && this.props.dragDropHelper && this.props.isDraggable) {
	            this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getColumnDragDropOptions());
	            // We need to use native on this to avoid MarqueeSelection from handling the event before us.
	            this._events.on(this._root.current, 'mousedown', this._onRootMouseDown);
	        }
	        if (this._dragDropSubscription && !this.props.isDraggable) {
	            this._dragDropSubscription.dispose();
	            this._events.off(this._root.current, 'mousedown');
	            delete this._dragDropSubscription;
	        }
	    };
	    DetailsColumnBase.prototype._onColumnClick = function (column, ev) {
	        if (column.columnActionsMode === DetailsList_types_1.ColumnActionsMode.disabled) {
	            return;
	        }
	        var onColumnClick = this.props.onColumnClick;
	        if (column.onColumnClick) {
	            column.onColumnClick(ev, column);
	        }
	        if (onColumnClick) {
	            onColumnClick(ev, column);
	        }
	    };
	    DetailsColumnBase.prototype._getColumnDragDropOptions = function () {
	        var _this = this;
	        var columnIndex = this.props.columnIndex;
	        var options = {
	            selectionIndex: columnIndex,
	            context: { data: columnIndex, index: columnIndex },
	            canDrag: function () { return _this.props.isDraggable; },
	            canDrop: function () { return false; },
	            onDragStart: this._onDragStart,
	            updateDropState: function () { return undefined; },
	            onDrop: function () { return undefined; },
	            onDragEnd: this._onDragEnd
	        };
	        return options;
	    };
	    DetailsColumnBase.prototype._hasAccessibleLabel = function () {
	        var column = this.props.column;
	        return !!(column.ariaLabel ||
	            column.filterAriaLabel ||
	            column.sortAscendingAriaLabel ||
	            column.sortDescendingAriaLabel ||
	            column.groupAriaLabel);
	    };
	    DetailsColumnBase.prototype._renderAccessibleLabel = function () {
	        var _a = this.props, column = _a.column, parentId = _a.parentId;
	        var classNames = this._classNames;
	        return this._hasAccessibleLabel() && !this.props.onRenderColumnHeaderTooltip ? (React.createElement("label", { key: column.key + "_label", id: parentId + "-" + column.key + "-tooltip", className: classNames.accessibleLabel },
	            column.ariaLabel,
	            (column.isFiltered && column.filterAriaLabel) || null,
	            (column.isSorted && (column.isSortedDescending ? column.sortDescendingAriaLabel : column.sortAscendingAriaLabel)) || null,
	            (column.isGrouped && column.groupAriaLabel) || null)) : null;
	    };
	    DetailsColumnBase.prototype._onColumnContextMenu = function (column, ev) {
	        var onColumnContextMenu = this.props.onColumnContextMenu;
	        if (column.onColumnContextMenu) {
	            column.onColumnContextMenu(column, ev);
	            ev.preventDefault();
	        }
	        if (onColumnContextMenu) {
	            onColumnContextMenu(column, ev);
	            ev.preventDefault();
	        }
	    };
	    return DetailsColumnBase;
	}(React.Component));
	exports.DetailsColumnBase = DetailsColumnBase;
	//# sourceMappingURL=DetailsColumn.base.js.map

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var DetailsHeader_styles_1 = __webpack_require__(899);
	var GlobalClassNames = {
	    isActionable: 'is-actionable',
	    cellIsCheck: 'ms-DetailsHeader-cellIsCheck',
	    collapseButton: 'ms-DetailsHeader-collapseButton',
	    isCollapsed: 'is-collapsed',
	    isAllSelected: 'is-allSelected',
	    isSelectAllHidden: 'is-selectAllHidden',
	    isResizingColumn: 'is-resizingColumn',
	    isEmpty: 'is-empty',
	    isIconVisible: 'is-icon-visible',
	    cellSizer: 'ms-DetailsHeader-cellSizer',
	    isResizing: 'is-resizing',
	    dropHintCircleStyle: 'ms-DetailsHeader-dropHintCircleStyle',
	    dropHintLineStyle: 'ms-DetailsHeader-dropHintLineStyle',
	    cellTitle: 'ms-DetailsHeader-cellTitle',
	    cellName: 'ms-DetailsHeader-cellName',
	    filterChevron: 'ms-DetailsHeader-filterChevron',
	    gripperBarVerticalStyle: 'ms-DetailsColumn-gripperBar'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, headerClassName = props.headerClassName, iconClassName = props.iconClassName, isActionable = props.isActionable, isEmpty = props.isEmpty, isIconVisible = props.isIconVisible, isPadded = props.isPadded, isIconOnly = props.isIconOnly, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _a, transitionDurationDrag = props.transitionDurationDrag, transitionDurationDrop = props.transitionDurationDrop;
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var colors = {
	        iconForegroundColor: semanticColors.bodySubtext,
	        headerForegroundColor: semanticColors.bodyText,
	        headerBackgroundColor: semanticColors.bodyBackground,
	        dropdownChevronForegroundColor: palette.neutralTertiary,
	        resizerColor: palette.neutralTertiaryAlt
	    };
	    var nearIconStyle = {
	        color: colors.iconForegroundColor,
	        opacity: 1,
	        paddingLeft: 8
	    };
	    var borderWhileDragging = {
	        outline: "1px solid " + palette.themePrimary
	    };
	    var borderAfterDragOrDrop = {
	        outlineColor: 'transparent'
	    };
	    return {
	        root: [
	            DetailsHeader_styles_1.getCellStyles(props),
	            theme.fonts.small,
	            isActionable && [
	                classNames.isActionable,
	                {
	                    selectors: {
	                        ':hover': {
	                            color: semanticColors.bodyText,
	                            background: semanticColors.listHeaderBackgroundHovered
	                        },
	                        ':active': {
	                            background: semanticColors.listHeaderBackgroundPressed
	                        }
	                    }
	                }
	            ],
	            isEmpty && [
	                classNames.isEmpty,
	                {
	                    textOverflow: 'clip'
	                }
	            ],
	            isIconVisible && classNames.isIconVisible,
	            isPadded && {
	                paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
	            },
	            {
	                selectors: {
	                    ':hover i[data-icon-name="GripperBarVertical"]': {
	                        display: 'block'
	                    }
	                }
	            },
	            headerClassName
	        ],
	        gripperBarVerticalStyle: {
	            display: 'none',
	            position: 'absolute',
	            textAlign: 'left',
	            color: palette.neutralTertiary,
	            left: 1
	        },
	        nearIcon: nearIconStyle,
	        sortIcon: [
	            nearIconStyle,
	            {
	                paddingLeft: 4,
	                position: 'relative',
	                top: 1
	            }
	        ],
	        iconClassName: [
	            {
	                color: colors.iconForegroundColor,
	                opacity: 1
	            },
	            iconClassName
	        ],
	        filterChevron: [
	            classNames.filterChevron,
	            {
	                color: colors.dropdownChevronForegroundColor,
	                paddingLeft: 4,
	                verticalAlign: 'middle'
	            }
	        ],
	        cellTitle: [
	            classNames.cellTitle,
	            Styling_1.getFocusStyle(theme),
	            tslib_1.__assign({ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'stretch', boxSizing: 'border-box', overflow: 'hidden', padding: "0 " + cellStyleProps.cellRightPadding + "px 0 " + cellStyleProps.cellLeftPadding + "px" }, (isIconOnly
	                ? {
	                    alignContent: 'flex-end',
	                    maxHeight: '100%',
	                    flexWrap: 'wrap-reverse'
	                }
	                : {}))
	        ],
	        cellName: [
	            classNames.cellName,
	            {
	                flex: '0 1 auto',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis'
	            },
	            isIconOnly && {
	                selectors: {
	                    $nearIcon: {
	                        paddingLeft: 0
	                    }
	                }
	            }
	        ],
	        cellTooltip: {
	            display: 'block',
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            bottom: 0,
	            right: 0
	        },
	        accessibleLabel: Styling_1.hiddenContentStyle,
	        borderWhileDragging: borderWhileDragging,
	        noBorderWhileDragging: [borderAfterDragOrDrop, { transition: "outline " + transitionDurationDrag + "ms ease" }],
	        borderAfterDropping: borderWhileDragging,
	        noBorderAfterDropping: [borderAfterDragOrDrop, { transition: "outline  " + transitionDurationDrop + "ms ease" }]
	    };
	};
	//# sourceMappingURL=DetailsColumn.styles.js.map

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory DetailsList}
	 */
	var SelectAllVisibility;
	(function (SelectAllVisibility) {
	    SelectAllVisibility[SelectAllVisibility["none"] = 0] = "none";
	    SelectAllVisibility[SelectAllVisibility["hidden"] = 1] = "hidden";
	    SelectAllVisibility[SelectAllVisibility["visible"] = 2] = "visible";
	})(SelectAllVisibility = exports.SelectAllVisibility || (exports.SelectAllVisibility = {}));
	//# sourceMappingURL=DetailsHeader.types.js.map

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DetailsList_base_1 = __webpack_require__(907);
	var DetailsList_styles_1 = __webpack_require__(913);
	exports.DetailsList = Utilities_1.styled(DetailsList_base_1.DetailsListBase, DetailsList_styles_1.getStyles, undefined, {
	    scope: 'DetailsList'
	});
	//# sourceMappingURL=DetailsList.js.map

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DetailsList_types_1 = __webpack_require__(873);
	var DetailsHeader_1 = __webpack_require__(871);
	var DetailsHeader_types_1 = __webpack_require__(905);
	var DetailsRow_1 = __webpack_require__(908);
	var FocusZone_1 = __webpack_require__(676);
	var index_1 = __webpack_require__(866);
	var DragDropHelper_1 = __webpack_require__(901);
	var GroupedList_1 = __webpack_require__(875);
	var List_1 = __webpack_require__(845);
	var withViewport_1 = __webpack_require__(911);
	var GroupedListUtility_1 = __webpack_require__(912);
	var DetailsRow_styles_1 = __webpack_require__(883);
	// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.
	var GroupSpacer_1 = __webpack_require__(874);
	var getClassNames = Utilities_1.classNamesFunction();
	var MIN_COLUMN_WIDTH = 100; // this is the global min width
	var CHECKBOX_WIDTH = 40;
	var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
	var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
	var SHIMMER_INITIAL_ITEMS = 10;
	var SHIMMER_ITEMS = new Array(SHIMMER_INITIAL_ITEMS);
	var DetailsListBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetailsListBase, _super);
	    function DetailsListBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._header = React.createRef();
	        _this._groupedList = React.createRef();
	        _this._list = React.createRef();
	        _this._focusZone = React.createRef();
	        _this._selectionZone = React.createRef();
	        _this._sumColumnWidths = Utilities_1.memoizeFunction(function (columns) {
	            var totalWidth = 0;
	            columns.forEach(function (column) { return (totalWidth += column.calculatedWidth || column.minWidth); });
	            return totalWidth;
	        });
	        _this._onRenderRow = function (props, defaultRender) {
	            return React.createElement(DetailsRow_1.DetailsRow, tslib_1.__assign({}, props));
	        };
	        _this._onRenderDetailsHeader = function (detailsHeaderProps, defaultRender) {
	            return React.createElement(DetailsHeader_1.DetailsHeader, tslib_1.__assign({}, detailsHeaderProps));
	        };
	        _this._onRenderDetailsFooter = function (detailsFooterProps, defaultRender) {
	            return null;
	        };
	        _this._onRenderListCell = function (nestingDepth) {
	            return function (item, itemIndex) {
	                return _this._onRenderCell(nestingDepth, item, itemIndex);
	            };
	        };
	        _this._onRenderCell = function (nestingDepth, item, index) {
	            var _a = _this.props, compact = _a.compact, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.rowElementEventMap, onRenderMissingItem = _a.onRenderMissingItem, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, _b = _a.onRenderRow, onRenderRow = _b === void 0 ? _this._onRenderRow : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? _this._selection.mode : _c, viewport = _a.viewport, checkboxVisibility = _a.checkboxVisibility, getRowAriaLabel = _a.getRowAriaLabel, getRowAriaDescribedBy = _a.getRowAriaDescribedBy, checkButtonAriaLabel = _a.checkButtonAriaLabel, checkboxCellClassName = _a.checkboxCellClassName, groupProps = _a.groupProps, useReducedRowRenderer = _a.useReducedRowRenderer, indentWidth = _a.indentWidth, _d = _a.cellStyleProps, cellStyleProps = _d === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _d, onRenderCheckbox = _a.onRenderCheckbox, enableUpdateAnimations = _a.enableUpdateAnimations, useFastIcons = _a.useFastIcons;
	            var collapseAllVisibility = groupProps && groupProps.collapseAllVisibility;
	            var selection = _this._selection;
	            var dragDropHelper = _this._dragDropHelper;
	            var columns = _this.state.adjustedColumns;
	            var rowProps = {
	                item: item,
	                itemIndex: index,
	                compact: compact,
	                columns: columns,
	                groupNestingDepth: nestingDepth,
	                selectionMode: selectionMode,
	                selection: selection,
	                onDidMount: _this._onRowDidMount,
	                onWillUnmount: _this._onRowWillUnmount,
	                onRenderItemColumn: onRenderItemColumn,
	                getCellValueKey: getCellValueKey,
	                eventsToRegister: eventsToRegister,
	                dragDropEvents: dragDropEvents,
	                dragDropHelper: dragDropHelper,
	                viewport: viewport,
	                checkboxVisibility: checkboxVisibility,
	                collapseAllVisibility: collapseAllVisibility,
	                getRowAriaLabel: getRowAriaLabel,
	                getRowAriaDescribedBy: getRowAriaDescribedBy,
	                checkButtonAriaLabel: checkButtonAriaLabel,
	                checkboxCellClassName: checkboxCellClassName,
	                useReducedRowRenderer: useReducedRowRenderer,
	                indentWidth: indentWidth,
	                cellStyleProps: cellStyleProps,
	                onRenderDetailsCheckbox: onRenderCheckbox,
	                enableUpdateAnimations: enableUpdateAnimations,
	                rowWidth: _this._sumColumnWidths(columns),
	                useFastIcons: useFastIcons
	            };
	            if (!item) {
	                if (onRenderMissingItem) {
	                    return onRenderMissingItem(index, rowProps);
	                }
	                return null;
	            }
	            return onRenderRow(rowProps, _this._onRenderRow);
	        };
	        _this._onGroupExpandStateChanged = function (isSomeGroupExpanded) {
	            _this.setState({ isSomeGroupExpanded: isSomeGroupExpanded });
	        };
	        _this._onColumnIsSizingChanged = function (column, isSizing) {
	            _this.setState({ isSizing: isSizing });
	        };
	        _this._onHeaderKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.down) {
	                if (_this._focusZone.current && _this._focusZone.current.focus()) {
	                    // select the first item in list after down arrow key event
	                    // only if nothing was selected; otherwise start with the already-selected item
	                    if (_this._selection.getSelectedIndices().length === 0) {
	                        _this._selection.setIndexSelected(0, true, false);
	                    }
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        _this._onContentKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.up && !ev.altKey) {
	                if (_this._header.current && _this._header.current.focus()) {
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                }
	            }
	        };
	        _this._onRowDidMount = function (row) {
	            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
	            var itemKey = _this._getItemKey(item, itemIndex);
	            _this._activeRows[itemKey] = row; // this is used for column auto resize
	            _this._setFocusToRowIfPending(row);
	            var onRowDidMount = _this.props.onRowDidMount;
	            if (onRowDidMount) {
	                onRowDidMount(item, itemIndex);
	            }
	        };
	        _this._onRowWillUnmount = function (row) {
	            var onRowWillUnmount = _this.props.onRowWillUnmount;
	            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
	            var itemKey = _this._getItemKey(item, itemIndex);
	            delete _this._activeRows[itemKey];
	            if (onRowWillUnmount) {
	                onRowWillUnmount(item, itemIndex);
	            }
	        };
	        _this._onToggleCollapse = function (collapsed) {
	            _this.setState({
	                isCollapsed: collapsed
	            });
	            if (_this._groupedList.current) {
	                _this._groupedList.current.toggleCollapseAll(collapsed);
	            }
	        };
	        _this._onColumnDragEnd = function (props, event) {
	            var columnReorderOptions = _this.props.columnReorderOptions;
	            var finalDropLocation = DetailsList_types_1.ColumnDragEndLocation.outside;
	            if (columnReorderOptions && columnReorderOptions.onDragEnd) {
	                if (props.dropLocation && props.dropLocation !== DetailsList_types_1.ColumnDragEndLocation.header) {
	                    finalDropLocation = props.dropLocation;
	                }
	                else if (_this._root.current) {
	                    var clientRect = _this._root.current.getBoundingClientRect();
	                    if (event.clientX > clientRect.left &&
	                        event.clientX < clientRect.right &&
	                        event.clientY > clientRect.top &&
	                        event.clientY < clientRect.bottom) {
	                        finalDropLocation = DetailsList_types_1.ColumnDragEndLocation.surface;
	                    }
	                }
	                columnReorderOptions.onDragEnd(finalDropLocation);
	            }
	        };
	        _this._onColumnResized = function (resizingColumn, newWidth, resizingColumnIndex) {
	            var newCalculatedWidth = Math.max(resizingColumn.minWidth || MIN_COLUMN_WIDTH, newWidth);
	            if (_this.props.onColumnResize) {
	                _this.props.onColumnResize(resizingColumn, newCalculatedWidth, resizingColumnIndex);
	            }
	            _this._rememberCalculatedWidth(resizingColumn, newCalculatedWidth);
	            _this._adjustColumns(_this.props, true, resizingColumnIndex);
	            _this.setState({
	                version: {}
	            });
	        };
	        /**
	         * Callback function when double clicked on the details header column resizer
	         * which will measure the column cells of all the active rows and resize the
	         * column to the max cell width.
	         *
	         * @param column - double clicked column definition
	         * @param columnIndex - double clicked column index
	         * TODO: min width 100 should be changed to const value and should be consistent with the
	         * value used on _onSizerMove method in DetailsHeader
	         */
	        _this._onColumnAutoResized = function (column, columnIndex) {
	            var max = 0;
	            var count = 0;
	            var totalCount = Object.keys(_this._activeRows).length;
	            for (var key in _this._activeRows) {
	                if (_this._activeRows.hasOwnProperty(key)) {
	                    var currentRow = _this._activeRows[key];
	                    currentRow.measureCell(columnIndex, function (width) {
	                        max = Math.max(max, width);
	                        count++;
	                        if (count === totalCount) {
	                            _this._onColumnResized(column, max, columnIndex);
	                        }
	                    });
	                }
	            }
	        };
	        /**
	         * Call back function when an element in FocusZone becomes active. It will translate it into item
	         * and call onActiveItemChanged callback if specified.
	         *
	         * @param row - element that became active in Focus Zone
	         * @param focus - event from Focus Zone
	         */
	        _this._onActiveRowChanged = function (el, ev) {
	            var _a = _this.props, items = _a.items, onActiveItemChanged = _a.onActiveItemChanged;
	            if (!el) {
	                return;
	            }
	            // Check and assign index only if the event was raised from any DetailsRow element
	            if (el.getAttribute('data-item-index')) {
	                var index = Number(el.getAttribute('data-item-index'));
	                if (index >= 0) {
	                    if (onActiveItemChanged) {
	                        onActiveItemChanged(items[index], index, ev);
	                    }
	                    _this.setState({
	                        focusedItemIndex: index
	                    });
	                }
	            }
	        };
	        _this._onBlur = function (event) {
	            _this.setState({
	                focusedItemIndex: -1
	            });
	        };
	        Utilities_1.initializeComponentRef(_this);
	        Utilities_1.initializeFocusRects();
	        _this._async = new Utilities_1.Async(_this);
	        _this._activeRows = {};
	        _this._columnOverrides = {};
	        _this.state = {
	            focusedItemIndex: -1,
	            lastWidth: 0,
	            adjustedColumns: _this._getAdjustedColumns(props),
	            isSizing: false,
	            isDropping: false,
	            isCollapsed: props.groupProps && props.groupProps.isAllGroupsCollapsed,
	            isSomeGroupExpanded: props.groupProps && !props.groupProps.isAllGroupsCollapsed,
	            version: {}
	        };
	        _this._selection = props.selection || new index_1.Selection({ onSelectionChanged: undefined, getKey: props.getKey });
	        if (!_this.props.disableSelectionZone) {
	            _this._selection.setItems(props.items, false);
	        }
	        _this._dragDropHelper = props.dragDropEvents
	            ? new DragDropHelper_1.DragDropHelper({
	                selection: _this._selection,
	                minimumPixelsForDrag: props.minimumPixelsForDrag
	            })
	            : undefined;
	        _this._initialFocusedIndex = props.initialFocusedIndex;
	        return _this;
	    }
	    DetailsListBase.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
	        this._list.current && this._list.current.scrollToIndex(index, measureItem, scrollToMode);
	        this._groupedList.current && this._groupedList.current.scrollToIndex(index, measureItem, scrollToMode);
	    };
	    DetailsListBase.prototype.focusIndex = function (index, forceIntoFirstElement, measureItem, scrollToMode) {
	        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
	        var item = this.props.items[index];
	        if (item) {
	            this.scrollToIndex(index, measureItem, scrollToMode);
	            var itemKey = this._getItemKey(item, index);
	            var row = this._activeRows[itemKey];
	            if (row) {
	                this._setFocusToRow(row, forceIntoFirstElement);
	            }
	        }
	    };
	    DetailsListBase.prototype.getStartItemIndexInView = function () {
	        if (this._list && this._list.current) {
	            return this._list.current.getStartItemIndexInView();
	        }
	        else if (this._groupedList && this._groupedList.current) {
	            return this._groupedList.current.getStartItemIndexInView();
	        }
	        return 0;
	    };
	    DetailsListBase.prototype.componentWillUnmount = function () {
	        if (this._dragDropHelper) {
	            // TODO If the DragDropHelper was passed via props, this will dispose it, which is incorrect behavior.
	            this._dragDropHelper.dispose();
	        }
	        this._async.dispose();
	    };
	    DetailsListBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (this._initialFocusedIndex !== undefined) {
	            var item = this.props.items[this._initialFocusedIndex];
	            if (item) {
	                var itemKey = this._getItemKey(item, this._initialFocusedIndex);
	                var row = this._activeRows[itemKey];
	                if (row) {
	                    this._setFocusToRowIfPending(row);
	                }
	            }
	        }
	        if (this.props.items !== prevProps.items &&
	            this.props.items.length > 0 &&
	            this.state.focusedItemIndex !== -1 &&
	            !Utilities_1.elementContains(this._root.current, document.activeElement, false)) {
	            // Item set has changed and previously-focused item is gone.
	            // Set focus to item at index of previously-focused item if it is in range,
	            // else set focus to the last item.
	            var index = this.state.focusedItemIndex < this.props.items.length ? this.state.focusedItemIndex : this.props.items.length - 1;
	            var item = this.props.items[index];
	            var itemKey = this._getItemKey(item, this.state.focusedItemIndex);
	            var row = this._activeRows[itemKey];
	            if (row) {
	                this._setFocusToRow(row);
	            }
	            else {
	                this._initialFocusedIndex = index;
	            }
	        }
	        if (this.props.onDidUpdate) {
	            this.props.onDidUpdate(this);
	        }
	    };
	    DetailsListBase.prototype.componentWillReceiveProps = function (newProps) {
	        var _a = this.props, checkboxVisibility = _a.checkboxVisibility, items = _a.items, setKey = _a.setKey, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, columns = _a.columns, viewport = _a.viewport, compact = _a.compact, dragDropEvents = _a.dragDropEvents;
	        var _c = (this.props.groupProps || {}).isAllGroupsCollapsed, isAllGroupsCollapsed = _c === void 0 ? undefined : _c;
	        var newViewportWidth = (newProps.viewport && newProps.viewport.width) || 0;
	        var oldViewportWidth = (viewport && viewport.width) || 0;
	        var shouldResetSelection = newProps.setKey !== setKey || newProps.setKey === undefined;
	        var shouldForceUpdates = false;
	        if (newProps.layoutMode !== this.props.layoutMode) {
	            shouldForceUpdates = true;
	        }
	        if (shouldResetSelection) {
	            this._initialFocusedIndex = newProps.initialFocusedIndex;
	            // reset focusedItemIndex when setKey changes
	            this.setState({
	                focusedItemIndex: this._initialFocusedIndex !== undefined ? this._initialFocusedIndex : -1
	            });
	        }
	        if (!this.props.disableSelectionZone && newProps.items !== items) {
	            this._selection.setItems(newProps.items, shouldResetSelection);
	        }
	        if (newProps.checkboxVisibility !== checkboxVisibility ||
	            newProps.columns !== columns ||
	            newViewportWidth !== oldViewportWidth ||
	            newProps.compact !== compact) {
	            shouldForceUpdates = true;
	        }
	        this._adjustColumns(newProps, true);
	        if (newProps.selectionMode !== selectionMode) {
	            shouldForceUpdates = true;
	        }
	        if (isAllGroupsCollapsed === undefined && (newProps.groupProps && newProps.groupProps.isAllGroupsCollapsed !== undefined)) {
	            this.setState({
	                isCollapsed: newProps.groupProps.isAllGroupsCollapsed,
	                isSomeGroupExpanded: !newProps.groupProps.isAllGroupsCollapsed
	            });
	        }
	        if (newProps.dragDropEvents !== dragDropEvents) {
	            this._dragDropHelper && this._dragDropHelper.dispose();
	            this._dragDropHelper = newProps.dragDropEvents
	                ? new DragDropHelper_1.DragDropHelper({
	                    selection: this._selection,
	                    minimumPixelsForDrag: newProps.minimumPixelsForDrag
	                })
	                : undefined;
	            shouldForceUpdates = true;
	        }
	        if (shouldForceUpdates) {
	            this.setState({
	                version: {}
	            });
	        }
	    };
	    DetailsListBase.prototype.render = function () {
	        var _a = this.props, ariaLabelForListHeader = _a.ariaLabelForListHeader, ariaLabelForSelectAllCheckbox = _a.ariaLabelForSelectAllCheckbox, ariaLabelForSelectionColumn = _a.ariaLabelForSelectionColumn, className = _a.className, checkboxVisibility = _a.checkboxVisibility, compact = _a.compact, constrainMode = _a.constrainMode, dragDropEvents = _a.dragDropEvents, groups = _a.groups, groupProps = _a.groupProps, indentWidth = _a.indentWidth, items = _a.items, isHeaderVisible = _a.isHeaderVisible, layoutMode = _a.layoutMode, onItemInvoked = _a.onItemInvoked, onItemContextMenu = _a.onItemContextMenu, onColumnHeaderClick = _a.onColumnHeaderClick, onColumnHeaderContextMenu = _a.onColumnHeaderContextMenu, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, selectionPreservedOnEmptyClick = _a.selectionPreservedOnEmptyClick, selectionZoneProps = _a.selectionZoneProps, ariaLabel = _a.ariaLabel, ariaLabelForGrid = _a.ariaLabelForGrid, rowElementEventMap = _a.rowElementEventMap, _c = _a.shouldApplyApplicationRole, shouldApplyApplicationRole = _c === void 0 ? false : _c, getKey = _a.getKey, listProps = _a.listProps, usePageCache = _a.usePageCache, onShouldVirtualize = _a.onShouldVirtualize, enableShimmer = _a.enableShimmer, viewport = _a.viewport, minimumPixelsForDrag = _a.minimumPixelsForDrag, getGroupHeight = _a.getGroupHeight, styles = _a.styles, theme = _a.theme, _d = _a.cellStyleProps, cellStyleProps = _d === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _d, onRenderCheckbox = _a.onRenderCheckbox, useFastIcons = _a.useFastIcons;
	        var _e = this.state, adjustedColumns = _e.adjustedColumns, isCollapsed = _e.isCollapsed, isSizing = _e.isSizing, isSomeGroupExpanded = _e.isSomeGroupExpanded;
	        var _f = this, selection = _f._selection, dragDropHelper = _f._dragDropHelper;
	        var groupNestingDepth = this._getGroupNestingDepth();
	        var additionalListProps = tslib_1.__assign({ renderedWindowsAhead: isSizing ? 0 : DEFAULT_RENDERED_WINDOWS_AHEAD, renderedWindowsBehind: isSizing ? 0 : DEFAULT_RENDERED_WINDOWS_BEHIND, getKey: getKey, version: this.state.version }, listProps);
	        var selectAllVisibility = DetailsHeader_types_1.SelectAllVisibility.none; // for SelectionMode.none
	        if (selectionMode === index_1.SelectionMode.single) {
	            selectAllVisibility = DetailsHeader_types_1.SelectAllVisibility.hidden;
	        }
	        if (selectionMode === index_1.SelectionMode.multiple) {
	            // if isCollapsedGroupSelectVisible is false, disable select all when the list has all collapsed groups
	            var isCollapsedGroupSelectVisible = groupProps && groupProps.headerProps && groupProps.headerProps.isCollapsedGroupSelectVisible;
	            if (isCollapsedGroupSelectVisible === undefined) {
	                isCollapsedGroupSelectVisible = true;
	            }
	            var isSelectAllVisible = isCollapsedGroupSelectVisible || !groups || isSomeGroupExpanded;
	            selectAllVisibility = isSelectAllVisible ? DetailsHeader_types_1.SelectAllVisibility.visible : DetailsHeader_types_1.SelectAllVisibility.hidden;
	        }
	        if (checkboxVisibility === DetailsList_types_1.CheckboxVisibility.hidden) {
	            selectAllVisibility = DetailsHeader_types_1.SelectAllVisibility.none;
	        }
	        var _g = this.props, _h = _g.onRenderDetailsHeader, onRenderDetailsHeader = _h === void 0 ? this._onRenderDetailsHeader : _h, _j = _g.onRenderDetailsFooter, onRenderDetailsFooter = _j === void 0 ? this._onRenderDetailsFooter : _j;
	        var detailsFooterProps = this._getDetailsFooterProps();
	        var columnReorderProps = this._getColumnReorderProps();
	        var rowCount = (isHeaderVisible ? 1 : 0) + GroupedListUtility_1.GetGroupCount(groups) + (items ? items.length : 0);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            compact: compact,
	            isFixed: layoutMode === DetailsList_types_1.DetailsListLayoutMode.fixedColumns,
	            isHorizontalConstrained: constrainMode === DetailsList_types_1.ConstrainMode.horizontalConstrained,
	            className: className
	        });
	        var list = groups ? (React.createElement(GroupedList_1.GroupedList, { componentRef: this._groupedList, groups: groups, groupProps: groupProps ? this._getGroupProps(groupProps) : undefined, items: items, onRenderCell: this._onRenderCell, selection: selection, selectionMode: checkboxVisibility !== DetailsList_types_1.CheckboxVisibility.hidden ? selectionMode : index_1.SelectionMode.none, dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: rowElementEventMap, listProps: additionalListProps, onGroupExpandStateChanged: this._onGroupExpandStateChanged, usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize, getGroupHeight: getGroupHeight, compact: compact })) : (React.createElement(List_1.List, tslib_1.__assign({ ref: this._list, role: "presentation", items: enableShimmer && !items.length ? SHIMMER_ITEMS : items, onRenderCell: this._onRenderListCell(0), usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize }, additionalListProps)));
	        return (
	        // If shouldApplyApplicationRole is true, role application will be applied to make arrow keys work
	        // with JAWS.
	        React.createElement("div", tslib_1.__assign({ ref: this._root, className: classNames.root, "data-automationid": "DetailsList", "data-is-scrollable": "false", "aria-label": ariaLabel }, (shouldApplyApplicationRole ? { role: 'application' } : {})),
	            React.createElement("div", { role: "grid", "aria-label": ariaLabelForGrid, "aria-rowcount": rowCount, "aria-colcount": (selectAllVisibility !== DetailsHeader_types_1.SelectAllVisibility.none ? 1 : 0) + (adjustedColumns ? adjustedColumns.length : 0), "aria-readonly": "true" },
	                React.createElement("div", { onKeyDown: this._onHeaderKeyDown, role: "presentation", className: classNames.headerWrapper }, isHeaderVisible &&
	                    onRenderDetailsHeader({
	                        componentRef: this._header,
	                        selectionMode: selectionMode,
	                        layoutMode: layoutMode,
	                        selection: selection,
	                        columns: adjustedColumns,
	                        onColumnClick: onColumnHeaderClick,
	                        onColumnContextMenu: onColumnHeaderContextMenu,
	                        onColumnResized: this._onColumnResized,
	                        onColumnIsSizingChanged: this._onColumnIsSizingChanged,
	                        onColumnAutoResized: this._onColumnAutoResized,
	                        groupNestingDepth: groupNestingDepth,
	                        isAllCollapsed: isCollapsed,
	                        onToggleCollapseAll: this._onToggleCollapse,
	                        ariaLabel: ariaLabelForListHeader,
	                        ariaLabelForSelectAllCheckbox: ariaLabelForSelectAllCheckbox,
	                        ariaLabelForSelectionColumn: ariaLabelForSelectionColumn,
	                        selectAllVisibility: selectAllVisibility,
	                        collapseAllVisibility: groupProps && groupProps.collapseAllVisibility,
	                        viewport: viewport,
	                        columnReorderProps: columnReorderProps,
	                        minimumPixelsForDrag: minimumPixelsForDrag,
	                        cellStyleProps: cellStyleProps,
	                        checkboxVisibility: checkboxVisibility,
	                        indentWidth: indentWidth,
	                        onRenderDetailsCheckbox: onRenderCheckbox,
	                        rowWidth: this._sumColumnWidths(this.state.adjustedColumns),
	                        useFastIcons: useFastIcons
	                    }, this._onRenderDetailsHeader)),
	                React.createElement("div", { onKeyDown: this._onContentKeyDown, role: "presentation", className: classNames.contentWrapper },
	                    React.createElement(FocusZone_1.FocusZone, { componentRef: this._focusZone, className: classNames.focusZone, direction: FocusZone_1.FocusZoneDirection.vertical, isInnerZoneKeystroke: isRightArrow, onActiveElementChanged: this._onActiveRowChanged, onBlur: this._onBlur }, !this.props.disableSelectionZone ? (React.createElement(index_1.SelectionZone, tslib_1.__assign({ ref: this._selectionZone, selection: selection, selectionPreservedOnEmptyClick: selectionPreservedOnEmptyClick, selectionMode: selectionMode, onItemInvoked: onItemInvoked, onItemContextMenu: onItemContextMenu, enterModalOnTouch: this.props.enterModalSelectionOnTouch }, selectionZoneProps || {}), list)) : (list))),
	                onRenderDetailsFooter(tslib_1.__assign({}, detailsFooterProps), this._onRenderDetailsFooter))));
	    };
	    DetailsListBase.prototype.forceUpdate = function () {
	        _super.prototype.forceUpdate.call(this);
	        this._forceListUpdates();
	    };
	    DetailsListBase.prototype._getGroupNestingDepth = function () {
	        var groups = this.props.groups;
	        var level = 0;
	        var groupsInLevel = groups;
	        while (groupsInLevel && groupsInLevel.length > 0) {
	            level++;
	            groupsInLevel = groupsInLevel[0].children;
	        }
	        return level;
	    };
	    DetailsListBase.prototype._setFocusToRowIfPending = function (row) {
	        var itemIndex = row.props.itemIndex;
	        if (this._initialFocusedIndex !== undefined && itemIndex === this._initialFocusedIndex) {
	            this._setFocusToRow(row);
	            delete this._initialFocusedIndex;
	        }
	    };
	    DetailsListBase.prototype._setFocusToRow = function (row, forceIntoFirstElement) {
	        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
	        if (this._selectionZone.current) {
	            this._selectionZone.current.ignoreNextFocus();
	        }
	        this._async.setTimeout(function () {
	            row.focus(forceIntoFirstElement);
	        }, 0);
	    };
	    DetailsListBase.prototype._forceListUpdates = function () {
	        if (this._groupedList.current) {
	            this._groupedList.current.forceUpdate();
	        }
	        if (this._list.current) {
	            this._list.current.forceUpdate();
	        }
	    };
	    DetailsListBase.prototype._notifyColumnsResized = function () {
	        this.state.adjustedColumns.forEach(function (column) {
	            if (column.onColumnResize) {
	                column.onColumnResize(column.currentWidth);
	            }
	        });
	    };
	    DetailsListBase.prototype._adjustColumns = function (newProps, forceUpdate, resizingColumnIndex) {
	        var adjustedColumns = this._getAdjustedColumns(newProps, forceUpdate, resizingColumnIndex);
	        var viewport = this.props.viewport;
	        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
	        if (adjustedColumns) {
	            this.setState({
	                adjustedColumns: adjustedColumns,
	                lastWidth: viewportWidth
	            }, this._notifyColumnsResized);
	        }
	    };
	    /** Returns adjusted columns, given the viewport size and layout mode. */
	    DetailsListBase.prototype._getAdjustedColumns = function (newProps, forceUpdate, resizingColumnIndex) {
	        var _this = this;
	        var newItems = newProps.items, layoutMode = newProps.layoutMode, selectionMode = newProps.selectionMode, viewport = newProps.viewport;
	        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
	        var newColumns = newProps.columns;
	        var columns = this.props ? this.props.columns : [];
	        var lastWidth = this.state ? this.state.lastWidth : -1;
	        var lastSelectionMode = this.state ? this.state.lastSelectionMode : undefined;
	        if (!forceUpdate && lastWidth === viewportWidth && lastSelectionMode === selectionMode && (!columns || newColumns === columns)) {
	            return [];
	        }
	        newColumns = newColumns || buildColumns(newItems, true);
	        var adjustedColumns;
	        if (layoutMode === DetailsList_types_1.DetailsListLayoutMode.fixedColumns) {
	            adjustedColumns = this._getFixedColumns(newColumns);
	            // Preserve adjusted column calculated widths.
	            adjustedColumns.forEach(function (column) {
	                _this._rememberCalculatedWidth(column, column.calculatedWidth);
	            });
	        }
	        else {
	            if (resizingColumnIndex !== undefined) {
	                adjustedColumns = this._getJustifiedColumnsAfterResize(newColumns, viewportWidth, newProps, resizingColumnIndex);
	            }
	            else {
	                adjustedColumns = this._getJustifiedColumns(newColumns, viewportWidth, newProps, 0);
	            }
	            adjustedColumns.forEach(function (column) {
	                _this._getColumnOverride(column.key).currentWidth = column.calculatedWidth;
	            });
	        }
	        return adjustedColumns;
	    };
	    /** Builds a set of columns based on the given columns mixed with the current overrides. */
	    DetailsListBase.prototype._getFixedColumns = function (newColumns) {
	        var _this = this;
	        return newColumns.map(function (column) {
	            var newColumn = tslib_1.__assign({}, column, _this._columnOverrides[column.key]);
	            if (!newColumn.calculatedWidth) {
	                newColumn.calculatedWidth = newColumn.maxWidth || newColumn.minWidth || MIN_COLUMN_WIDTH;
	            }
	            return newColumn;
	        });
	    };
	    DetailsListBase.prototype._getJustifiedColumnsAfterResize = function (newColumns, viewportWidth, props, resizingColumnIndex) {
	        var _this = this;
	        var fixedColumns = newColumns.slice(0, resizingColumnIndex);
	        fixedColumns.forEach(function (column) { return (column.calculatedWidth = _this._getColumnOverride(column.key).currentWidth); });
	        var fixedWidth = fixedColumns.reduce(function (total, column, i) { return total + getPaddedWidth(column, i === 0, props); }, 0);
	        var remainingColumns = newColumns.slice(resizingColumnIndex);
	        var remainingWidth = viewportWidth - fixedWidth;
	        return fixedColumns.concat(this._getJustifiedColumns(remainingColumns, remainingWidth, props, resizingColumnIndex));
	    };
	    /** Builds a set of columns to fix within the viewport width. */
	    DetailsListBase.prototype._getJustifiedColumns = function (newColumns, viewportWidth, props, firstIndex) {
	        var _this = this;
	        var _a = props.selectionMode, selectionMode = _a === void 0 ? this._selection.mode : _a, checkboxVisibility = props.checkboxVisibility;
	        var rowCheckWidth = selectionMode !== index_1.SelectionMode.none && checkboxVisibility !== DetailsList_types_1.CheckboxVisibility.hidden ? CHECKBOX_WIDTH : 0;
	        var groupExpandWidth = this._getGroupNestingDepth() * GroupSpacer_1.SPACER_WIDTH;
	        var totalWidth = 0; // offset because we have one less inner padding.
	        var availableWidth = viewportWidth - (rowCheckWidth + groupExpandWidth);
	        var adjustedColumns = newColumns.map(function (column, i) {
	            var newColumn = tslib_1.__assign({}, column, { calculatedWidth: column.minWidth || MIN_COLUMN_WIDTH }, _this._columnOverrides[column.key]);
	            var isFirst = i + firstIndex === 0;
	            totalWidth += getPaddedWidth(newColumn, isFirst, props);
	            return newColumn;
	        });
	        var lastIndex = adjustedColumns.length - 1;
	        // Shrink or remove collapsable columns.
	        while (lastIndex > 0 && totalWidth > availableWidth) {
	            var column = adjustedColumns[lastIndex];
	            var minWidth = column.minWidth || MIN_COLUMN_WIDTH;
	            var overflowWidth = totalWidth - availableWidth;
	            if (column.calculatedWidth - minWidth >= overflowWidth || !(column.isCollapsable || column.isCollapsible)) {
	                var originalWidth = column.calculatedWidth;
	                column.calculatedWidth = Math.max(column.calculatedWidth - overflowWidth, minWidth);
	                totalWidth -= originalWidth - column.calculatedWidth;
	            }
	            else {
	                totalWidth -= getPaddedWidth(column, false, props);
	                adjustedColumns.splice(lastIndex, 1);
	            }
	            lastIndex--;
	        }
	        // Then expand columns starting at the beginning, until we've filled the width.
	        for (var i = 0; i < adjustedColumns.length && totalWidth < availableWidth; i++) {
	            var column = adjustedColumns[i];
	            var isLast = i === adjustedColumns.length - 1;
	            var overrides = this._columnOverrides[column.key];
	            if (overrides && overrides.calculatedWidth && !isLast) {
	                continue;
	            }
	            var spaceLeft = availableWidth - totalWidth;
	            var increment = void 0;
	            if (isLast) {
	                increment = spaceLeft;
	            }
	            else {
	                var maxWidth = column.maxWidth;
	                var minWidth = column.minWidth || maxWidth || MIN_COLUMN_WIDTH;
	                increment = maxWidth ? Math.min(spaceLeft, maxWidth - minWidth) : spaceLeft;
	            }
	            column.calculatedWidth = column.calculatedWidth + increment;
	            totalWidth += increment;
	        }
	        return adjustedColumns;
	    };
	    DetailsListBase.prototype._rememberCalculatedWidth = function (column, newCalculatedWidth) {
	        var overrides = this._getColumnOverride(column.key);
	        overrides.calculatedWidth = newCalculatedWidth;
	        overrides.currentWidth = newCalculatedWidth;
	    };
	    DetailsListBase.prototype._getColumnOverride = function (key) {
	        return (this._columnOverrides[key] = this._columnOverrides[key] || {});
	    };
	    DetailsListBase.prototype._getItemKey = function (item, itemIndex) {
	        var getKey = this.props.getKey;
	        var itemKey = undefined;
	        if (item) {
	            itemKey = item.key;
	        }
	        if (getKey) {
	            itemKey = getKey(item, itemIndex);
	        }
	        if (!itemKey) {
	            itemKey = itemIndex;
	        }
	        return itemKey;
	    };
	    DetailsListBase.prototype._getDetailsFooterProps = function () {
	        var columns = this.state.adjustedColumns;
	        var _a = this.props, viewport = _a.viewport, checkboxVisibility = _a.checkboxVisibility, indentWidth = _a.indentWidth, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? this._selection.mode : _c;
	        return {
	            columns: columns,
	            groupNestingDepth: this._getGroupNestingDepth(),
	            selection: this._selection,
	            selectionMode: selectionMode,
	            viewport: viewport,
	            checkboxVisibility: checkboxVisibility,
	            indentWidth: indentWidth,
	            cellStyleProps: cellStyleProps
	        };
	    };
	    DetailsListBase.prototype._getColumnReorderProps = function () {
	        var columnReorderOptions = this.props.columnReorderOptions;
	        if (columnReorderOptions) {
	            return tslib_1.__assign({}, columnReorderOptions, { onColumnDragEnd: this._onColumnDragEnd });
	        }
	    };
	    DetailsListBase.prototype._getGroupProps = function (detailsGroupProps) {
	        var _this = this;
	        var onRenderDetailsGroupFooter = detailsGroupProps.onRenderFooter, onRenderDetailsGroupHeader = detailsGroupProps.onRenderHeader;
	        var columns = this.state.adjustedColumns;
	        var _a = this.props, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, viewport = _a.viewport, _c = _a.cellStyleProps, cellStyleProps = _c === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _c, checkboxVisibility = _a.checkboxVisibility, indentWidth = _a.indentWidth;
	        var groupNestingDepth = this._getGroupNestingDepth();
	        var onRenderFooter = onRenderDetailsGroupFooter
	            ? function (props, defaultRender) {
	                return onRenderDetailsGroupFooter(tslib_1.__assign({}, props, { columns: columns, groupNestingDepth: groupNestingDepth, indentWidth: indentWidth, selection: _this._selection, selectionMode: selectionMode, viewport: viewport, checkboxVisibility: checkboxVisibility,
	                    cellStyleProps: cellStyleProps }), defaultRender);
	            }
	            : undefined;
	        var onRenderHeader = onRenderDetailsGroupHeader
	            ? function (props, defaultRender) {
	                return onRenderDetailsGroupHeader(tslib_1.__assign({}, props, { columns: columns, groupNestingDepth: groupNestingDepth, indentWidth: indentWidth, selection: _this._selection, selectionMode: selectionMode, viewport: viewport, checkboxVisibility: checkboxVisibility,
	                    cellStyleProps: cellStyleProps }), defaultRender);
	            }
	            : undefined;
	        return tslib_1.__assign({}, detailsGroupProps, { onRenderFooter: onRenderFooter,
	            onRenderHeader: onRenderHeader });
	    };
	    DetailsListBase.defaultProps = {
	        layoutMode: DetailsList_types_1.DetailsListLayoutMode.justified,
	        selectionMode: index_1.SelectionMode.multiple,
	        constrainMode: DetailsList_types_1.ConstrainMode.horizontalConstrained,
	        checkboxVisibility: DetailsList_types_1.CheckboxVisibility.onHover,
	        isHeaderVisible: true,
	        enableShimmer: false,
	        compact: false
	    };
	    DetailsListBase = tslib_1.__decorate([
	        withViewport_1.withViewport
	    ], DetailsListBase);
	    return DetailsListBase;
	}(React.Component));
	exports.DetailsListBase = DetailsListBase;
	function buildColumns(items, canResizeColumns, onColumnClick, sortedColumnKey, isSortedDescending, groupedColumnKey, isMultiline) {
	    var columns = [];
	    if (items && items.length) {
	        var firstItem = items[0];
	        for (var propName in firstItem) {
	            if (firstItem.hasOwnProperty(propName)) {
	                columns.push({
	                    key: propName,
	                    name: propName,
	                    fieldName: propName,
	                    minWidth: MIN_COLUMN_WIDTH,
	                    maxWidth: 300,
	                    isCollapsable: !!columns.length,
	                    isCollapsible: !!columns.length,
	                    isMultiline: isMultiline === undefined ? false : isMultiline,
	                    isSorted: sortedColumnKey === propName,
	                    isSortedDescending: !!isSortedDescending,
	                    isRowHeader: false,
	                    columnActionsMode: DetailsList_types_1.ColumnActionsMode.clickable,
	                    isResizable: canResizeColumns,
	                    onColumnClick: onColumnClick,
	                    isGrouped: groupedColumnKey === propName
	                });
	            }
	        }
	    }
	    return columns;
	}
	exports.buildColumns = buildColumns;
	function isRightArrow(event) {
	    return event.which === Utilities_1.getRTLSafeKeyCode(Utilities_1.KeyCodes.right);
	}
	function getPaddedWidth(column, isFirst, props) {
	    var _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _a;
	    return (column.calculatedWidth +
	        cellStyleProps.cellLeftPadding +
	        cellStyleProps.cellRightPadding +
	        (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0));
	}
	//# sourceMappingURL=DetailsList.base.js.map

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DetailsRow_base_1 = __webpack_require__(909);
	var DetailsRow_styles_1 = __webpack_require__(883);
	exports.DetailsRow = Utilities_1.styled(DetailsRow_base_1.DetailsRowBase, DetailsRow_styles_1.getStyles, undefined, {
	    scope: 'DetailsRow'
	});
	//# sourceMappingURL=DetailsRow.js.map

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var ReactDOM = __webpack_require__(41);
	var Utilities_1 = __webpack_require__(592);
	var DetailsList_types_1 = __webpack_require__(873);
	var DetailsRowCheck_1 = __webpack_require__(897);
	var GroupSpacer_1 = __webpack_require__(874);
	var DetailsRowFields_1 = __webpack_require__(910);
	var FocusZone_1 = __webpack_require__(676);
	var interfaces_1 = __webpack_require__(867);
	var GroupedList_1 = __webpack_require__(875);
	var Utilities_2 = __webpack_require__(592);
	var getClassNames = Utilities_2.classNamesFunction();
	var DEFAULT_DROPPING_CSS_CLASS = 'is-dropping';
	var NO_COLUMNS = [];
	var DetailsRowBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetailsRowBase, _super);
	    function DetailsRowBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._cellMeasurer = React.createRef();
	        _this._focusZone = React.createRef();
	        _this._onSelectionChanged = function () {
	            var selectionState = _this._getSelectionState(_this.props);
	            if (!Utilities_1.shallowCompare(selectionState, _this.state.selectionState)) {
	                _this.setState({
	                    selectionState: selectionState
	                });
	            }
	        };
	        _this._onRootRef = function (focusZone) {
	            if (focusZone) {
	                // Need to resolve the actual DOM node, not the component. The element itself will be used for drag/drop and focusing.
	                _this._root = ReactDOM.findDOMNode(focusZone);
	            }
	            else {
	                _this._root = undefined;
	            }
	        };
	        /**
	         * update isDropping state based on the input value, which is used to change style during drag and drop
	         *
	         * when change to true, that means drag enter. we will add default dropping class name
	         * or the custom dropping class name (return result from onDragEnter) to the root elemet.
	         *
	         * when change to false, that means drag leave. we will remove the dropping class name from root element.
	         *
	         * @param newValue - New isDropping state value
	         * @param event - The event trigger dropping state change which can be dragenter, dragleave etc
	         */
	        _this._updateDroppingState = function (newValue, event) {
	            var _a = _this.state, selectionState = _a.selectionState, isDropping = _a.isDropping;
	            var _b = _this.props, dragDropEvents = _b.dragDropEvents, item = _b.item;
	            if (!newValue) {
	                if (dragDropEvents.onDragLeave) {
	                    dragDropEvents.onDragLeave(item, event);
	                }
	            }
	            else {
	                if (dragDropEvents.onDragEnter) {
	                    _this._droppingClassNames = dragDropEvents.onDragEnter(item, event);
	                }
	            }
	            if (isDropping !== newValue) {
	                _this.setState({ selectionState: selectionState, isDropping: newValue });
	            }
	        };
	        Utilities_1.initializeComponentRef(_this);
	        _this._events = new Utilities_1.EventGroup(_this);
	        _this.state = {
	            selectionState: _this._getSelectionState(props),
	            columnMeasureInfo: undefined,
	            isDropping: false,
	            groupNestingDepth: props.groupNestingDepth
	        };
	        _this._droppingClassNames = '';
	        return _this;
	    }
	    DetailsRowBase.prototype.componentDidMount = function () {
	        var dragDropHelper = this.props.dragDropHelper;
	        if (dragDropHelper) {
	            this._dragDropSubscription = dragDropHelper.subscribe(this._root, this._events, this._getRowDragDropOptions());
	        }
	        this._events.on(this.props.selection, interfaces_1.SELECTION_CHANGE, this._onSelectionChanged);
	        if (this.props.onDidMount && this.props.item) {
	            // If the item appears later, we should wait for it before calling this method.
	            this._hasMounted = true;
	            this.props.onDidMount(this);
	        }
	    };
	    DetailsRowBase.prototype.componentDidUpdate = function (previousProps) {
	        var state = this.state;
	        var _a = this.props, item = _a.item, onDidMount = _a.onDidMount;
	        var columnMeasureInfo = state.columnMeasureInfo;
	        if (this.props.itemIndex !== previousProps.itemIndex ||
	            this.props.item !== previousProps.item ||
	            this.props.dragDropHelper !== previousProps.dragDropHelper) {
	            if (this._dragDropSubscription) {
	                this._dragDropSubscription.dispose();
	                delete this._dragDropSubscription;
	            }
	            if (this.props.dragDropHelper) {
	                this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root, this._events, this._getRowDragDropOptions());
	            }
	        }
	        if (columnMeasureInfo && columnMeasureInfo.index >= 0 && this._cellMeasurer.current) {
	            var newWidth = this._cellMeasurer.current.getBoundingClientRect().width;
	            columnMeasureInfo.onMeasureDone(newWidth);
	            this.setState({
	                columnMeasureInfo: undefined
	            });
	        }
	        if (item && onDidMount && !this._hasMounted) {
	            this._hasMounted = true;
	            onDidMount(this);
	        }
	    };
	    DetailsRowBase.prototype.componentWillUnmount = function () {
	        var _a = this.props, item = _a.item, onWillUnmount = _a.onWillUnmount;
	        // Only call the onWillUnmount callback if we have an item.
	        if (onWillUnmount && item) {
	            onWillUnmount(this);
	        }
	        if (this._dragDropSubscription) {
	            this._dragDropSubscription.dispose();
	            delete this._dragDropSubscription;
	        }
	        this._events.dispose();
	    };
	    DetailsRowBase.prototype.componentWillReceiveProps = function (newProps) {
	        this.setState({
	            selectionState: this._getSelectionState(newProps),
	            groupNestingDepth: newProps.groupNestingDepth
	        });
	    };
	    DetailsRowBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        if (this.props.useReducedRowRenderer) {
	            if (this.state.selectionState) {
	                var newSelectionState = this._getSelectionState(nextProps);
	                if (this.state.selectionState.isSelected !== newSelectionState.isSelected) {
	                    return true;
	                }
	            }
	            return !Utilities_1.shallowCompare(this.props, nextProps);
	        }
	        else {
	            return true;
	        }
	    };
	    DetailsRowBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, dragDropEvents = _a.dragDropEvents, item = _a.item, itemIndex = _a.itemIndex, _c = _a.onRenderCheck, onRenderCheck = _c === void 0 ? this._onRenderCheck : _c, onRenderDetailsCheckbox = _a.onRenderDetailsCheckbox, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, selectionMode = _a.selectionMode, _d = _a.rowWidth, rowWidth = _d === void 0 ? 0 : _d, checkboxVisibility = _a.checkboxVisibility, getRowAriaLabel = _a.getRowAriaLabel, getRowAriaDescribedBy = _a.getRowAriaDescribedBy, checkButtonAriaLabel = _a.checkButtonAriaLabel, checkboxCellClassName = _a.checkboxCellClassName, 
	        /** Alias rowFieldsAs as RowFields and default to DetailsRowFields if rowFieldsAs does not exist */
	        _e = _a.rowFieldsAs, 
	        /** Alias rowFieldsAs as RowFields and default to DetailsRowFields if rowFieldsAs does not exist */
	        RowFields = _e === void 0 ? DetailsRowFields_1.DetailsRowFields : _e, selection = _a.selection, indentWidth = _a.indentWidth, shimmer = _a.shimmer, enableUpdateAnimations = _a.enableUpdateAnimations, compact = _a.compact, theme = _a.theme, styles = _a.styles, cellsByColumn = _a.cellsByColumn, useFastIcons = _a.useFastIcons;
	        var _f = this.state, columnMeasureInfo = _f.columnMeasureInfo, isDropping = _f.isDropping, groupNestingDepth = _f.groupNestingDepth;
	        var _g = this.state.selectionState, _h = _g.isSelected, isSelected = _h === void 0 ? false : _h, _j = _g.isSelectionModal, isSelectionModal = _j === void 0 ? false : _j;
	        var isDraggable = dragDropEvents ? !!(dragDropEvents.canDrag && dragDropEvents.canDrag(item)) : undefined;
	        var droppingClassName = isDropping ? (this._droppingClassNames ? this._droppingClassNames : DEFAULT_DROPPING_CSS_CLASS) : '';
	        var ariaLabel = getRowAriaLabel ? getRowAriaLabel(item) : undefined;
	        var ariaDescribedBy = getRowAriaDescribedBy ? getRowAriaDescribedBy(item) : undefined;
	        var canSelect = !!selection && selection.canSelectItem(item, itemIndex);
	        var isContentUnselectable = selectionMode === interfaces_1.SelectionMode.multiple;
	        var showCheckbox = selectionMode !== interfaces_1.SelectionMode.none && checkboxVisibility !== DetailsList_types_1.CheckboxVisibility.hidden;
	        var ariaSelected = selectionMode === interfaces_1.SelectionMode.none ? undefined : isSelected;
	        this._classNames = tslib_1.__assign({}, this._classNames, getClassNames(styles, {
	            theme: theme,
	            isSelected: isSelected,
	            canSelect: !isContentUnselectable,
	            anySelected: isSelectionModal,
	            checkboxCellClassName: checkboxCellClassName,
	            droppingClassName: droppingClassName,
	            className: className,
	            compact: compact,
	            enableUpdateAnimations: enableUpdateAnimations
	        }));
	        var rowClassNames = {
	            isMultiline: this._classNames.isMultiline,
	            isRowHeader: this._classNames.isRowHeader,
	            shimmerIconPlaceholder: this._classNames.shimmerIconPlaceholder,
	            shimmer: this._classNames.shimmer,
	            cell: this._classNames.cell,
	            cellAnimation: this._classNames.cellAnimation,
	            cellPadded: this._classNames.cellPadded,
	            cellUnpadded: this._classNames.cellUnpadded,
	            fields: this._classNames.fields
	        };
	        // Only re-assign rowClassNames when classNames have changed.
	        // Otherwise, they will cause DetailsRowFields to unnecessarily
	        // re-render, see https://github.com/OfficeDev/office-ui-fabric-react/pull/8799.
	        // Refactor DetailsRowFields to generate own styles to remove need for this.
	        if (!Utilities_1.shallowCompare(this._rowClassNames || {}, rowClassNames)) {
	            this._rowClassNames = rowClassNames;
	        }
	        var rowFields = (React.createElement(RowFields, { rowClassNames: this._rowClassNames, cellsByColumn: cellsByColumn, columns: columns, item: item, itemIndex: itemIndex, columnStartIndex: showCheckbox ? 1 : 0, onRenderItemColumn: onRenderItemColumn, shimmer: shimmer, getCellValueKey: getCellValueKey, enableUpdateAnimations: enableUpdateAnimations }));
	        // Rendering Shimmer Animation outside the focus zone
	        if (shimmer) {
	            return (React.createElement("div", { className: Utilities_1.css(showCheckbox && this._classNames.shimmerLeftBorder, !compact && this._classNames.shimmerBottomBorder) }, rowFields));
	        }
	        return (React.createElement(FocusZone_1.FocusZone, tslib_1.__assign({ "data-is-focusable": true }, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), (typeof isDraggable === 'boolean'
	            ? {
	                'data-is-draggable': isDraggable,
	                draggable: isDraggable
	            }
	            : {}), { direction: FocusZone_1.FocusZoneDirection.horizontal, ref: this._onRootRef, componentRef: this._focusZone, role: "row", "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, className: this._classNames.root, "data-selection-index": itemIndex, "data-item-index": itemIndex, "aria-rowindex": itemIndex + 1, "data-automationid": "DetailsRow", style: { minWidth: rowWidth }, "aria-selected": ariaSelected, allowFocusRoot: true }),
	            showCheckbox && (React.createElement("div", { role: "gridcell", "aria-colindex": 1, "data-selection-toggle": true, className: this._classNames.checkCell }, onRenderCheck({
	                selected: isSelected,
	                anySelected: isSelectionModal,
	                'aria-label': checkButtonAriaLabel,
	                canSelect: canSelect,
	                compact: compact,
	                className: this._classNames.check,
	                theme: theme,
	                isVisible: checkboxVisibility === DetailsList_types_1.CheckboxVisibility.always,
	                onRenderDetailsCheckbox: onRenderDetailsCheckbox,
	                useFastIcons: useFastIcons
	            }))),
	            React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: groupNestingDepth - (this.props.collapseAllVisibility === GroupedList_1.CollapseAllVisibility.hidden ? 1 : 0) }),
	            item && rowFields,
	            columnMeasureInfo && (React.createElement("span", { role: "presentation", className: Utilities_1.css(this._classNames.cellMeasurer, this._classNames.cell), ref: this._cellMeasurer },
	                React.createElement(RowFields, { rowClassNames: this._rowClassNames, columns: [columnMeasureInfo.column], item: item, itemIndex: itemIndex, columnStartIndex: (showCheckbox ? 1 : 0) + columns.length, onRenderItemColumn: onRenderItemColumn, getCellValueKey: getCellValueKey }))),
	            React.createElement("span", { role: "checkbox", className: this._classNames.checkCover, "aria-checked": isSelected, "data-selection-toggle": true })));
	    };
	    /**
	     * measure cell at index. and call the call back with the measured cell width when finish measure
	     *
	     * @param index - The cell index
	     * @param onMeasureDone - The call back function when finish measure
	     */
	    DetailsRowBase.prototype.measureCell = function (index, onMeasureDone) {
	        var _a = this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
	        var column = tslib_1.__assign({}, columns[index]);
	        column.minWidth = 0;
	        column.maxWidth = 999999;
	        delete column.calculatedWidth;
	        this.setState({
	            columnMeasureInfo: {
	                index: index,
	                column: column,
	                onMeasureDone: onMeasureDone
	            }
	        });
	    };
	    DetailsRowBase.prototype.focus = function (forceIntoFirstElement) {
	        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
	        return !!this._focusZone.current && this._focusZone.current.focus(forceIntoFirstElement);
	    };
	    DetailsRowBase.prototype._onRenderCheck = function (props) {
	        return React.createElement(DetailsRowCheck_1.DetailsRowCheck, tslib_1.__assign({}, props));
	    };
	    DetailsRowBase.prototype._getSelectionState = function (props) {
	        var itemIndex = props.itemIndex, selection = props.selection;
	        return {
	            isSelected: !!selection && selection.isIndexSelected(itemIndex),
	            isSelectionModal: !!selection && !!selection.isModal && selection.isModal()
	        };
	    };
	    DetailsRowBase.prototype._getRowDragDropOptions = function () {
	        var _a = this.props, item = _a.item, itemIndex = _a.itemIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
	        var options = {
	            eventMap: eventsToRegister,
	            selectionIndex: itemIndex,
	            context: { data: item, index: itemIndex },
	            canDrag: dragDropEvents.canDrag,
	            canDrop: dragDropEvents.canDrop,
	            onDragStart: dragDropEvents.onDragStart,
	            updateDropState: this._updateDroppingState,
	            onDrop: dragDropEvents.onDrop,
	            onDragEnd: dragDropEvents.onDragEnd
	        };
	        return options;
	    };
	    return DetailsRowBase;
	}(React.Component));
	exports.DetailsRowBase = DetailsRowBase;
	//# sourceMappingURL=DetailsRow.base.js.map

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var getCellText = function (item, column) {
	    var value = item && column && column.fieldName ? item[column.fieldName] : '';
	    if (value === null || value === undefined) {
	        value = '';
	    }
	    return value;
	};
	/**
	 * Component for rendering a row's cells in a `DetailsList`.
	 *
	 * {@docCategory DetailsList}
	 */
	var DetailsRowFields = /** @class */ (function (_super) {
	    tslib_1.__extends(DetailsRowFields, _super);
	    function DetailsRowFields(props) {
	        var _this = _super.call(this, props) || this;
	        _this._cellValueKeys = {};
	        return _this;
	    }
	    DetailsRowFields.prototype.render = function () {
	        var _a = this.props, columns = _a.columns, columnStartIndex = _a.columnStartIndex, shimmer = _a.shimmer, rowClassNames = _a.rowClassNames, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _b, item = _a.item, itemIndex = _a.itemIndex, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, cellsByColumn = _a.cellsByColumn, enableUpdateAnimations = _a.enableUpdateAnimations;
	        var cellValueKeys = this._cellValueKeys;
	        return (React.createElement("div", { className: rowClassNames.fields, "data-automationid": "DetailsRowFields", role: "presentation" }, columns.map(function (column, columnIndex) {
	            var width = typeof column.calculatedWidth === 'undefined'
	                ? 'auto'
	                : column.calculatedWidth +
	                    cellStyleProps.cellLeftPadding +
	                    cellStyleProps.cellRightPadding +
	                    (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
	            var _a = column.onRender, onRender = _a === void 0 ? onRenderItemColumn : _a, _b = column.getValueKey, getValueKey = _b === void 0 ? getCellValueKey : _b;
	            var cellContentsRender = cellsByColumn && column.key in cellsByColumn
	                ? cellsByColumn[column.key]
	                : onRender && !shimmer
	                    ? onRender(item, itemIndex, column)
	                    : getCellText(item, column);
	            var previousValueKey = cellValueKeys[column.key];
	            var cellValueKey = enableUpdateAnimations && getValueKey ? getValueKey(item, itemIndex, column) : undefined;
	            var showAnimation = false;
	            if (cellValueKey !== undefined && previousValueKey !== undefined && cellValueKey !== previousValueKey) {
	                showAnimation = true;
	            }
	            cellValueKeys[column.key] = cellValueKey;
	            // generate a key that auto-dirties when content changes, to force the container to re-render, to trigger animation
	            var key = "" + column.key + (cellValueKey !== undefined ? "-" + cellValueKey : '');
	            return (React.createElement("div", { key: key, role: column.isRowHeader ? 'rowheader' : 'gridcell', "aria-colindex": columnIndex + columnStartIndex + 1, className: Utilities_1.css(column.className, column.isMultiline && rowClassNames.isMultiline, column.isRowHeader && rowClassNames.isRowHeader, column.isIconOnly && shimmer && rowClassNames.shimmerIconPlaceholder, shimmer && rowClassNames.shimmer, rowClassNames.cell, column.isPadded ? rowClassNames.cellPadded : rowClassNames.cellUnpadded, showAnimation && rowClassNames.cellAnimation), style: { width: width }, "data-automationid": "DetailsRowCell", "data-automation-key": column.key }, cellContentsRender));
	        })));
	    };
	    return DetailsRowFields;
	}(React.PureComponent));
	exports.DetailsRowFields = DetailsRowFields;
	//# sourceMappingURL=DetailsRowFields.js.map

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var BaseDecorator_1 = __webpack_require__(702);
	var Utilities_1 = __webpack_require__(592);
	var RESIZE_DELAY = 500;
	var MAX_RESIZE_ATTEMPTS = 3;
	/**
	 * A decorator to update decorated component on viewport or window resize events.
	 *
	 * @param ComposedComponent decorated React component reference.
	 */
	function withViewport(ComposedComponent) {
	    return /** @class */ (function (_super) {
	        tslib_1.__extends(WithViewportComponent, _super);
	        function WithViewportComponent(props) {
	            var _this = _super.call(this, props) || this;
	            _this._root = React.createRef();
	            _this._registerResizeObserver = function () {
	                var win = Utilities_1.getWindow(_this._root.current);
	                _this._viewportResizeObserver = new win.ResizeObserver(_this._onAsyncResize);
	                _this._viewportResizeObserver.observe(_this._root.current);
	            };
	            _this._unregisterResizeObserver = function () {
	                if (_this._viewportResizeObserver) {
	                    _this._viewportResizeObserver.disconnect();
	                    _this._viewportResizeObserver = null;
	                }
	            };
	            /* Note: using lambda here because decorators don't seem to work in decorators. */
	            _this._updateViewport = function (withForceUpdate) {
	                var viewport = _this.state.viewport;
	                var viewportElement = _this._root.current;
	                var scrollElement = Utilities_1.findScrollableParent(viewportElement);
	                var scrollRect = Utilities_1.getRect(scrollElement);
	                var clientRect = Utilities_1.getRect(viewportElement);
	                var updateComponent = function () {
	                    if (withForceUpdate && _this._composedComponentInstance) {
	                        _this._composedComponentInstance.forceUpdate();
	                    }
	                };
	                var isSizeChanged = (clientRect && clientRect.width) !== viewport.width || (scrollRect && scrollRect.height) !== viewport.height;
	                if (isSizeChanged && _this._resizeAttempts < MAX_RESIZE_ATTEMPTS && clientRect && scrollRect) {
	                    _this._resizeAttempts++;
	                    _this.setState({
	                        viewport: {
	                            width: clientRect.width,
	                            height: scrollRect.height
	                        }
	                    }, function () {
	                        _this._updateViewport(withForceUpdate);
	                    });
	                }
	                else {
	                    _this._resizeAttempts = 0;
	                    updateComponent();
	                }
	            };
	            _this._resizeAttempts = 0;
	            _this.state = {
	                viewport: {
	                    width: 0,
	                    height: 0
	                }
	            };
	            return _this;
	        }
	        WithViewportComponent.prototype.componentDidMount = function () {
	            var skipViewportMeasures = this.props.skipViewportMeasures;
	            var win = Utilities_1.getWindow(this._root.current);
	            this._onAsyncResize = this._async.debounce(this._onAsyncResize, RESIZE_DELAY, {
	                leading: false
	            });
	            // ResizeObserver seems always fire even window is not resized. This is
	            // particularly bad when skipViewportMeasures is set when optimizing fixed layout lists.
	            // It will measure and update and re-render the entire list after list is fully rendered.
	            // So fallback to listen to resize event when skipViewportMeasures is set.
	            if (!skipViewportMeasures && this._isResizeObserverAvailable()) {
	                this._registerResizeObserver();
	            }
	            else {
	                this._events.on(win, 'resize', this._onAsyncResize);
	            }
	            if (!skipViewportMeasures) {
	                this._updateViewport();
	            }
	        };
	        WithViewportComponent.prototype.componentDidUpdate = function (newProps) {
	            var oldSkipViewportMeasures = this.props.skipViewportMeasures;
	            var newSkipViewportMeasures = newProps.skipViewportMeasures;
	            var win = Utilities_1.getWindow(this._root.current);
	            if (oldSkipViewportMeasures !== newSkipViewportMeasures) {
	                if (newSkipViewportMeasures) {
	                    this._unregisterResizeObserver();
	                    this._events.on(win, 'resize', this._onAsyncResize);
	                }
	                else if (!newSkipViewportMeasures && this._isResizeObserverAvailable()) {
	                    this._events.off(win, 'resize', this._onAsyncResize);
	                    this._registerResizeObserver();
	                }
	            }
	            if (!!newSkipViewportMeasures) {
	                this._updateViewport();
	            }
	        };
	        WithViewportComponent.prototype.componentWillUnmount = function () {
	            this._events.dispose();
	            if (this._viewportResizeObserver) {
	                this._viewportResizeObserver.disconnect();
	            }
	        };
	        WithViewportComponent.prototype.render = function () {
	            var viewport = this.state.viewport;
	            var newViewport = viewport.width > 0 && viewport.height > 0 ? viewport : undefined;
	            return (React.createElement("div", { className: "ms-Viewport", ref: this._root, style: { minWidth: 1, minHeight: 1 } },
	                React.createElement(ComposedComponent, tslib_1.__assign({ ref: this._updateComposedComponentRef, viewport: newViewport }, this.props))));
	        };
	        WithViewportComponent.prototype.forceUpdate = function () {
	            this._updateViewport(true);
	        };
	        WithViewportComponent.prototype._onAsyncResize = function () {
	            this._updateViewport();
	        };
	        WithViewportComponent.prototype._isResizeObserverAvailable = function () {
	            var win = Utilities_1.getWindow(this._root.current);
	            return win && win.ResizeObserver;
	        };
	        return WithViewportComponent;
	    }(BaseDecorator_1.BaseDecorator));
	}
	exports.withViewport = withViewport;
	//# sourceMappingURL=withViewport.js.map

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes an array of groups and returns a count of the groups and all descendant groups.
	 * @param groups - The array of groups to count.
	 */
	exports.GetGroupCount = function (groups) {
	    var total = 0;
	    if (groups) {
	        var remainingGroups = groups.slice();
	        var currentGroup = void 0;
	        while (remainingGroups && remainingGroups.length > 0) {
	            ++total;
	            currentGroup = remainingGroups.pop();
	            if (currentGroup && currentGroup.children) {
	                remainingGroups.push.apply(remainingGroups, currentGroup.children);
	            }
	        }
	    }
	    return total;
	};
	//# sourceMappingURL=GroupedListUtility.js.map

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DetailsList',
	    compact: 'ms-DetailsList--Compact',
	    contentWrapper: 'ms-DetailsList-contentWrapper',
	    headerWrapper: 'ms-DetailsList-headerWrapper',
	    isFixed: 'is-fixed',
	    isHorizontalConstrained: 'is-horizontalConstrained',
	    listCell: 'ms-List-cell'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, isHorizontalConstrained = props.isHorizontalConstrained, compact = props.compact, isFixed = props.isFixed;
	    var semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.small,
	            {
	                position: 'relative',
	                fontSize: Styling_1.FontSizes.small,
	                background: semanticColors.listBackground,
	                color: semanticColors.listText,
	                selectors: (_a = {},
	                    _a["& ." + classNames.listCell] = {
	                        minHeight: 38,
	                        wordBreak: 'break-word'
	                    },
	                    _a)
	            },
	            isFixed && classNames.isFixed,
	            compact && [
	                classNames.compact,
	                {
	                    selectors: (_b = {},
	                        _b["." + classNames.listCell] = {
	                            minHeight: 32
	                        },
	                        _b)
	                }
	            ],
	            isHorizontalConstrained && [
	                classNames.isHorizontalConstrained,
	                {
	                    overflowX: 'auto',
	                    overflowY: 'visible',
	                    WebkitOverflowScrolling: 'touch'
	                }
	            ],
	            className
	        ],
	        focusZone: [
	            {
	                display: 'inline-block',
	                minWidth: '100%',
	                minHeight: 1
	            }
	        ],
	        headerWrapper: classNames.headerWrapper,
	        contentWrapper: classNames.contentWrapper
	    };
	    var _a, _b;
	};
	//# sourceMappingURL=DetailsList.styles.js.map

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(915), exports);
	var index_1 = __webpack_require__(915);
	exports.default = index_1.Dialog;
	//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(916), exports);
	tslib_1.__exportStar(__webpack_require__(917), exports);
	tslib_1.__exportStar(__webpack_require__(932), exports);
	tslib_1.__exportStar(__webpack_require__(933), exports);
	tslib_1.__exportStar(__webpack_require__(934), exports);
	tslib_1.__exportStar(__webpack_require__(935), exports);
	tslib_1.__exportStar(__webpack_require__(918), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Dialog_base_1 = __webpack_require__(917);
	var Dialog_styles_1 = __webpack_require__(938);
	exports.Dialog = Utilities_1.styled(Dialog_base_1.DialogBase, Dialog_styles_1.getStyles, undefined, { scope: 'Dialog' });
	//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DialogContent_types_1 = __webpack_require__(918);
	var Modal_1 = __webpack_require__(919);
	var withResponsiveMode_1 = __webpack_require__(701);
	var getClassNames = Utilities_1.classNamesFunction();
	var DialogContent_1 = __webpack_require__(932);
	var DefaultModalProps = {
	    isDarkOverlay: false,
	    isBlocking: false,
	    className: '',
	    containerClassName: '',
	    topOffsetFixed: false
	};
	var DefaultDialogContentProps = {
	    type: DialogContent_types_1.DialogType.normal,
	    className: '',
	    topButtonsProps: []
	};
	var DialogBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DialogBase, _super);
	    function DialogBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._getSubTextId = function () {
	            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
	            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
	            if (!id) {
	                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
	            }
	            return id;
	        };
	        _this._getTitleTextId = function () {
	            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
	            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
	            if (!id) {
	                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
	            }
	            return id;
	        };
	        _this._id = Utilities_1.getId('Dialog');
	        _this._defaultTitleTextId = _this._id + '-title';
	        _this._defaultSubTextId = _this._id + '-subText';
	        if (false) {
	            Utilities_1.warnDeprecations('Dialog', props, {
	                isOpen: 'hidden',
	                type: 'dialogContentProps.type',
	                subText: 'dialogContentProps.subText',
	                contentClassName: 'dialogContentProps.className',
	                topButtonsProps: 'dialogContentProps.topButtonsProps',
	                className: 'modalProps.className',
	                isDarkOverlay: 'modalProps.isDarkOverlay',
	                isBlocking: 'modalProps.isBlocking',
	                containerClassName: 'modalProps.containerClassName',
	                onDismissed: 'modalProps.onDismissed',
	                onLayerDidMount: 'modalProps.layerProps.onLayerDidMount',
	                ariaDescribedById: 'modalProps.subtitleAriaId',
	                ariaLabelledById: 'modalProps.titleAriaId'
	            });
	        }
	        return _this;
	    }
	    DialogBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, containerClassName = _a.containerClassName, contentClassName = _a.contentClassName, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, styles = _a.styles, hidden = _a.hidden, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, theme = _a.theme, title = _a.title, topButtonsProps = _a.topButtonsProps, type = _a.type, minWidth = _a.minWidth, maxWidth = _a.maxWidth, modalProps = _a.modalProps;
	        var mergedLayerProps = tslib_1.__assign({}, (modalProps ? modalProps.layerProps : { onLayerDidMount: onLayerDidMount }));
	        if (onLayerDidMount && !mergedLayerProps.onLayerDidMount) {
	            mergedLayerProps.onLayerDidMount = onLayerDidMount;
	        }
	        var dialogDraggableClassName;
	        var dragOptions;
	        // if we are draggable, make sure we are using the correct
	        // draggable classname and selectors
	        if (modalProps && modalProps.dragOptions && !modalProps.dragOptions.dragHandleSelector) {
	            dialogDraggableClassName = 'ms-Dialog-draggable-header';
	            dragOptions = tslib_1.__assign({}, modalProps.dragOptions, { dragHandleSelector: "." + dialogDraggableClassName });
	        }
	        else {
	            dragOptions = modalProps && modalProps.dragOptions;
	        }
	        var mergedModalProps = tslib_1.__assign({}, DefaultModalProps, modalProps, { layerProps: mergedLayerProps, dragOptions: dragOptions });
	        var dialogContentProps = tslib_1.__assign({}, DefaultDialogContentProps, this.props.dialogContentProps, { draggableHeaderClassName: dialogDraggableClassName });
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className || mergedModalProps.className,
	            containerClassName: containerClassName || mergedModalProps.containerClassName,
	            hidden: hidden,
	            dialogDefaultMinWidth: minWidth,
	            dialogDefaultMaxWidth: maxWidth
	        });
	        return (React.createElement(Modal_1.Modal, tslib_1.__assign({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, responsiveMode: responsiveMode }, mergedModalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : mergedModalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : mergedModalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: classNames.root, containerClassName: classNames.main, onDismiss: onDismiss ? onDismiss : mergedModalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
	            React.createElement(DialogContent_1.DialogContent, tslib_1.__assign({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !mergedModalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: contentClassName || dialogContentProps.className }, dialogContentProps), this.props.children)));
	    };
	    DialogBase.defaultProps = {
	        hidden: true
	    };
	    DialogBase = tslib_1.__decorate([
	        withResponsiveMode_1.withResponsiveMode
	    ], DialogBase);
	    return DialogBase;
	}(React.Component));
	exports.DialogBase = DialogBase;
	//# sourceMappingURL=Dialog.base.js.map

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var withResponsiveMode_1 = __webpack_require__(701);
	exports.ResponsiveMode = withResponsiveMode_1.ResponsiveMode;
	/**
	 * {@docCategory Dialog}
	 */
	var DialogType;
	(function (DialogType) {
	    /** Standard dialog */
	    DialogType[DialogType["normal"] = 0] = "normal";
	    /** Dialog with large header banner */
	    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
	    /** Dialog with an 'x' close button in the upper-right corner */
	    DialogType[DialogType["close"] = 2] = "close";
	})(DialogType = exports.DialogType || (exports.DialogType = {}));
	//# sourceMappingURL=DialogContent.types.js.map

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(920), exports);
	var index_1 = __webpack_require__(920);
	exports.default = index_1.Modal;
	//# sourceMappingURL=Modal.js.map

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(921), exports);
	tslib_1.__exportStar(__webpack_require__(922), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Modal_base_1 = __webpack_require__(922);
	var Modal_styles_1 = __webpack_require__(923);
	exports.Modal = Utilities_1.styled(Modal_base_1.ModalBase, Modal_styles_1.getStyles, undefined, {
	    scope: 'Modal'
	});
	//# sourceMappingURL=Modal.js.map

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var index_1 = __webpack_require__(631);
	var Modal_styles_1 = __webpack_require__(923);
	var Overlay_1 = __webpack_require__(924);
	var Layer_1 = __webpack_require__(617);
	var index_2 = __webpack_require__(614);
	var withResponsiveMode_1 = __webpack_require__(701);
	var index_3 = __webpack_require__(604);
	var index_4 = __webpack_require__(644);
	var index_5 = __webpack_require__(929);
	// @TODO - need to change this to a panel whenever the breakpoint is under medium (verify the spec)
	var DefaultLayerProps = {
	    eventBubblingEnabled: false
	};
	var getClassNames = Utilities_1.classNamesFunction();
	var ModalBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ModalBase, _super);
	    function ModalBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._focusTrapZone = React.createRef();
	        // Allow the user to scroll within the modal but not on the body
	        _this._allowScrollOnModal = function (elt) {
	            if (elt) {
	                Utilities_1.allowScrollOnElement(elt, _this._events);
	            }
	            else {
	                _this._events.off(_this._scrollableContent);
	            }
	            _this._scrollableContent = elt;
	        };
	        _this._onModalContextMenuClose = function () {
	            _this.setState({ isModalMenuOpen: false });
	        };
	        _this._onModalClose = function () {
	            _this._lastSetX = 0;
	            _this._lastSetY = 0;
	            _this.setState({
	                isModalMenuOpen: false,
	                isInKeyboardMoveMode: false,
	                isOpen: false,
	                x: 0,
	                y: 0
	            });
	            // Call the onDismiss callback
	            if (_this.props.onDismissed) {
	                _this.props.onDismissed();
	            }
	        };
	        _this._onDragStart = function () {
	            _this.setState({ isModalMenuOpen: false, isInKeyboardMoveMode: false });
	        };
	        _this._onDrag = function (_, ui) {
	            var _a = _this.state, x = _a.x, y = _a.y;
	            _this.setState({ x: x + ui.delta.x, y: y + ui.delta.y });
	        };
	        _this._onDragStop = function () {
	            _this.focus();
	        };
	        _this._onDialogKeyUp = function (event) {
	            // Need to handle the CTRL + ALT + SPACE key during keyup due to FireFox bug:
	            // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
	            // Otherwise it would continue to fire a click even if the event was cancelled
	            // during mouseDown.
	            if (event.altKey && event.ctrlKey && event.keyCode === Utilities_1.KeyCodes.space) {
	                _this.setState({ isModalMenuOpen: !_this.state.isModalMenuOpen });
	                event.preventDefault();
	                event.stopPropagation();
	            }
	        };
	        _this._onDialogKeyDown = function (event) {
	            if (event.altKey && event.ctrlKey && event.keyCode === Utilities_1.KeyCodes.space) {
	                // CTRL + ALT + SPACE is handled during keyUp
	                event.preventDefault();
	                event.stopPropagation();
	                return;
	            }
	            if (_this.state.isModalMenuOpen && (event.altKey || event.keyCode === Utilities_1.KeyCodes.escape)) {
	                _this.setState({ isModalMenuOpen: false });
	            }
	            if (_this.state.isInKeyboardMoveMode && (event.keyCode === Utilities_1.KeyCodes.escape || event.keyCode === Utilities_1.KeyCodes.enter)) {
	                _this.setState({ isInKeyboardMoveMode: false });
	                event.preventDefault();
	                event.stopPropagation();
	            }
	            if (_this.state.isInKeyboardMoveMode) {
	                var handledEvent = true;
	                var delta = _this._getMoveDelta(event);
	                switch (event.keyCode) {
	                    case Utilities_1.KeyCodes.escape:
	                        _this.setState({ x: _this._lastSetX, y: _this._lastSetY });
	                    case Utilities_1.KeyCodes.enter: {
	                        _this._lastSetX = 0;
	                        _this._lastSetY = 0;
	                        _this.setState({ isInKeyboardMoveMode: false });
	                        break;
	                    }
	                    case Utilities_1.KeyCodes.up: {
	                        _this.setState({
	                            y: _this.state.y - delta
	                        });
	                        break;
	                    }
	                    case Utilities_1.KeyCodes.down: {
	                        _this.setState({
	                            y: _this.state.y + delta
	                        });
	                        break;
	                    }
	                    case Utilities_1.KeyCodes.left: {
	                        _this.setState({
	                            x: _this.state.x - delta
	                        });
	                        break;
	                    }
	                    case Utilities_1.KeyCodes.right: {
	                        _this.setState({
	                            x: _this.state.x + delta
	                        });
	                        break;
	                    }
	                    default: {
	                        handledEvent = false;
	                    }
	                }
	                if (handledEvent) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                }
	            }
	        };
	        _this._onEnterKeyboardMoveMode = function () {
	            _this._lastSetX = _this.state.x;
	            _this._lastSetY = _this.state.y;
	            _this.setState({ isInKeyboardMoveMode: true, isModalMenuOpen: false });
	        };
	        _this._onExitKeyboardMoveMode = function () {
	            _this._lastSetX = 0;
	            _this._lastSetY = 0;
	            _this.setState({ isInKeyboardMoveMode: false });
	        };
	        _this.state = {
	            id: Utilities_1.getId('Modal'),
	            isOpen: props.isOpen,
	            isVisible: props.isOpen,
	            hasBeenOpened: props.isOpen,
	            x: 0,
	            y: 0
	        };
	        _this._lastSetX = 0;
	        _this._lastSetY = 0;
	        _this._warnDeprecations({
	            onLayerDidMount: 'layerProps.onLayerDidMount'
	        });
	        return _this;
	    }
	    ModalBase.prototype.componentWillReceiveProps = function (newProps) {
	        clearTimeout(this._onModalCloseTimer);
	        // Opening the dialog
	        if (newProps.isOpen) {
	            if (!this.state.isOpen) {
	                // First Open
	                this.setState({
	                    isOpen: true
	                });
	            }
	            else {
	                // Modal has been opened
	                // Reopen during closing
	                this.setState({
	                    hasBeenOpened: true,
	                    isVisible: true
	                });
	                if (newProps.topOffsetFixed) {
	                    var dialogMain = document.getElementsByClassName('ms-Dialog-main');
	                    var modalRectangle = void 0;
	                    if (dialogMain.length > 0) {
	                        modalRectangle = dialogMain[0].getBoundingClientRect();
	                        this.setState({
	                            modalRectangleTop: modalRectangle.top
	                        });
	                    }
	                }
	            }
	        }
	        // Closing the dialog
	        if (!newProps.isOpen && this.state.isOpen) {
	            this._onModalCloseTimer = this._async.setTimeout(this._onModalClose, parseFloat(Modal_styles_1.animationDuration) * 1000);
	            this.setState({
	                isVisible: false
	            });
	        }
	    };
	    ModalBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (!prevProps.isOpen && !prevState.isVisible) {
	            this.setState({
	                isVisible: true
	            });
	        }
	    };
	    ModalBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, containerClassName = _a.containerClassName, scrollableContentClassName = _a.scrollableContentClassName, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, onDismiss = _a.onDismiss, layerProps = _a.layerProps, responsiveMode = _a.responsiveMode, titleAriaId = _a.titleAriaId, styles = _a.styles, subtitleAriaId = _a.subtitleAriaId, theme = _a.theme, topOffsetFixed = _a.topOffsetFixed, onLayerDidMount = _a.onLayerDidMount, isModeless = _a.isModeless, dragOptions = _a.dragOptions;
	        var _b = this.state, isOpen = _b.isOpen, isVisible = _b.isVisible, hasBeenOpened = _b.hasBeenOpened, modalRectangleTop = _b.modalRectangleTop, x = _b.x, y = _b.y, isInKeyboardMoveMode = _b.isInKeyboardMoveMode;
	        if (!isOpen) {
	            return null;
	        }
	        var layerClassName = layerProps === undefined ? '' : layerProps.className;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            containerClassName: containerClassName,
	            scrollableContentClassName: scrollableContentClassName,
	            isOpen: isOpen,
	            isVisible: isVisible,
	            hasBeenOpened: hasBeenOpened,
	            modalRectangleTop: modalRectangleTop,
	            topOffsetFixed: topOffsetFixed,
	            isModeless: isModeless,
	            layerClassName: layerClassName,
	            isDefaultDragHandle: dragOptions && !dragOptions.dragHandleSelector
	        });
	        var mergedLayerProps = tslib_1.__assign({}, DefaultLayerProps, this.props.layerProps, { onLayerDidMount: layerProps && layerProps.onLayerDidMount ? layerProps.onLayerDidMount : onLayerDidMount, insertFirst: isModeless, className: classNames.layer });
	        var modalContent = (React.createElement(index_1.FocusTrapZone, { componentRef: this._focusTrapZone, className: classNames.main, elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isModeless || isClickableOutsideFocusTrap || !isBlocking, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: isModeless ? !isModeless : forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector, focusPreviouslyFocusedInnerElement: true, onKeyDown: dragOptions ? this._onDialogKeyDown : undefined, onKeyUp: dragOptions ? this._onDialogKeyUp : undefined, onBlur: isInKeyboardMoveMode ? this._onExitKeyboardMoveMode : undefined },
	            dragOptions && isInKeyboardMoveMode && (React.createElement("div", { className: classNames.keyboardMoveIconContainer }, dragOptions.keyboardMoveIconProps ? (React.createElement(index_4.Icon, tslib_1.__assign({}, dragOptions.keyboardMoveIconProps))) : (React.createElement(index_4.Icon, { iconName: "move", className: classNames.keyboardMoveIcon })))),
	            React.createElement("div", { ref: this._allowScrollOnModal, className: classNames.scrollableContent, "data-is-scrollable": true },
	                dragOptions && this.state.isModalMenuOpen && (React.createElement(dragOptions.menu, { items: [
	                        { key: 'move', text: dragOptions.moveMenuItemText, onClick: this._onEnterKeyboardMoveMode },
	                        { key: 'close', text: dragOptions.closeMenuItemText, onClick: this._onModalClose }
	                    ], onDismiss: this._onModalContextMenuClose, alignTargetEdge: true, coverTarget: true, directionalHint: index_3.DirectionalHint.topLeftEdge, directionalHintFixed: true, shouldFocusOnMount: true, target: this._scrollableContent })),
	                this.props.children)));
	        // @temp tuatology - Will adjust this to be a panel at certain breakpoints
	        if (responsiveMode >= withResponsiveMode_1.ResponsiveMode.small) {
	            return (React.createElement(Layer_1.Layer, tslib_1.__assign({}, mergedLayerProps),
	                React.createElement(index_2.Popup, { role: isModeless || !isBlocking ? 'dialog' : 'alertdialog', "aria-modal": !isModeless, ariaLabelledBy: titleAriaId, ariaDescribedBy: subtitleAriaId, onDismiss: onDismiss },
	                    React.createElement("div", { className: classNames.root },
	                        !isModeless && React.createElement(Overlay_1.Overlay, { isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss }),
	                        dragOptions ? (React.createElement(index_5.DraggableZone, { handleSelector: dragOptions.dragHandleSelector || "." + classNames.main.split(' ')[0], preventDragSelector: "button", onStart: this._onDragStart, onDragChange: this._onDrag, onStop: this._onDragStop, position: { x: x, y: y } }, modalContent)) : (modalContent)))));
	        }
	        return null;
	    };
	    ModalBase.prototype.focus = function () {
	        if (this._focusTrapZone.current) {
	            this._focusTrapZone.current.focus();
	        }
	    };
	    ModalBase.prototype._getMoveDelta = function (event) {
	        var delta = 10;
	        if (event.shiftKey) {
	            if (!event.ctrlKey) {
	                delta = 50;
	            }
	        }
	        else if (event.ctrlKey) {
	            delta = 1;
	        }
	        return delta;
	    };
	    ModalBase.defaultProps = {
	        isOpen: false,
	        isDarkOverlay: true,
	        isBlocking: false,
	        className: '',
	        containerClassName: ''
	    };
	    ModalBase = tslib_1.__decorate([
	        withResponsiveMode_1.withResponsiveMode
	    ], ModalBase);
	    return ModalBase;
	}(Utilities_1.BaseComponent));
	exports.ModalBase = ModalBase;
	//# sourceMappingURL=Modal.base.js.map

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.animationDuration = Styling_1.AnimationVariables.durationValue2;
	var globalClassNames = {
	    root: 'ms-Modal',
	    main: 'ms-Dialog-main',
	    scrollableContent: 'ms-Modal-scrollableContent',
	    isOpen: 'is-open',
	    layer: 'ms-Modal-Layer'
	};
	exports.getStyles = function (props) {
	    var className = props.className, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, isOpen = props.isOpen, isVisible = props.isVisible, hasBeenOpened = props.hasBeenOpened, modalRectangleTop = props.modalRectangleTop, theme = props.theme, topOffsetFixed = props.topOffsetFixed, isModeless = props.isModeless, layerClassName = props.layerClassName, isDefaultDragHandle = props.isDefaultDragHandle;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(globalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                backgroundColor: 'transparent',
	                position: isModeless ? 'absolute' : 'fixed',
	                height: '100%',
	                width: '100%',
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                opacity: 0,
	                pointerEvents: 'none',
	                transition: "opacity " + exports.animationDuration
	            },
	            topOffsetFixed &&
	                hasBeenOpened && {
	                alignItems: 'flex-start'
	            },
	            isOpen && classNames.isOpen,
	            isVisible && {
	                opacity: 1,
	                pointerEvents: 'auto'
	            },
	            className
	        ],
	        main: [
	            classNames.main,
	            {
	                boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.4)',
	                backgroundColor: palette.white,
	                boxSizing: 'border-box',
	                position: 'relative',
	                textAlign: 'left',
	                outline: '3px solid transparent',
	                maxHeight: '100%',
	                overflowY: 'auto',
	                zIndex: isModeless ? Styling_1.ZIndexes.Layer : undefined
	            },
	            topOffsetFixed &&
	                hasBeenOpened && {
	                top: modalRectangleTop
	            },
	            isDefaultDragHandle && {
	                cursor: 'move'
	            },
	            containerClassName
	        ],
	        scrollableContent: [
	            classNames.scrollableContent,
	            {
	                overflowY: 'auto',
	                flexGrow: 1,
	                maxHeight: '100vh',
	                selectors: (_a = {},
	                    _a['@supports (-webkit-overflow-scrolling: touch)'] = {
	                        maxHeight: window.innerHeight
	                    },
	                    _a)
	            },
	            scrollableContentClassName
	        ],
	        layer: isModeless && [
	            layerClassName,
	            classNames.layer,
	            {
	                position: 'static',
	                width: 'unset',
	                height: 'unset'
	            }
	        ],
	        keyboardMoveIconContainer: {
	            position: 'absolute',
	            display: 'flex',
	            justifyContent: 'center',
	            width: '100%',
	            padding: '3px 0px'
	        },
	        keyboardMoveIcon: {
	            fontSize: '24px',
	            width: '24px'
	        }
	    };
	    var _a;
	};
	//# sourceMappingURL=Modal.styles.js.map

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(925), exports);
	//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(926), exports);
	tslib_1.__exportStar(__webpack_require__(927), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Overlay_base_1 = __webpack_require__(927);
	var Overlay_styles_1 = __webpack_require__(928);
	exports.Overlay = Utilities_1.styled(Overlay_base_1.OverlayBase, Overlay_styles_1.getStyles, undefined, {
	    scope: 'Overlay'
	});
	//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var OverlayBase = /** @class */ (function (_super) {
	    tslib_1.__extends(OverlayBase, _super);
	    function OverlayBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    OverlayBase.prototype.componentDidMount = function () {
	        Utilities_1.disableBodyScroll();
	    };
	    OverlayBase.prototype.componentWillUnmount = function () {
	        Utilities_1.enableBodyScroll();
	    };
	    OverlayBase.prototype.render = function () {
	        var _a = this.props, isDark = _a.isDarkThemed, className = _a.className, theme = _a.theme, styles = _a.styles;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            isDark: isDark
	        });
	        return React.createElement("div", tslib_1.__assign({}, divProps, { className: classNames.root }));
	    };
	    return OverlayBase;
	}(Utilities_1.BaseComponent));
	exports.OverlayBase = OverlayBase;
	//# sourceMappingURL=Overlay.base.js.map

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Overlay',
	    rootDark: 'ms-Overlay--dark'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, isNone = props.isNone, isDark = props.isDark;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                backgroundColor: palette.whiteTranslucent40,
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0,
	                position: 'absolute',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText',
	                        opacity: 0
	                    },
	                    _a)
	            },
	            isNone && {
	                visibility: 'hidden'
	            },
	            isDark && [
	                classNames.rootDark,
	                {
	                    backgroundColor: palette.blackTranslucent40
	                }
	            ],
	            className
	        ]
	    };
	    var _a;
	};
	//# sourceMappingURL=Overlay.styles.js.map

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(930), exports);
	tslib_1.__exportStar(__webpack_require__(931), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var DraggableZone_styles_1 = __webpack_require__(931);
	var Utilities_1 = __webpack_require__(592);
	var eventMapping = {
	    touch: {
	        start: 'touchstart',
	        move: 'touchmove',
	        stop: 'touchend'
	    },
	    mouse: {
	        start: 'mousedown',
	        move: 'mousemove',
	        stop: 'mouseup'
	    }
	};
	var DraggableZone = /** @class */ (function (_super) {
	    tslib_1.__extends(DraggableZone, _super);
	    function DraggableZone(props) {
	        var _this = _super.call(this, props) || this;
	        _this._currentEventType = eventMapping.mouse;
	        _this._events = [];
	        _this._onMouseDown = function (event) {
	            var onMouseDown = React.Children.only(_this.props.children).props.onMouseDown;
	            if (onMouseDown) {
	                onMouseDown(event);
	            }
	            _this._currentEventType = eventMapping.mouse;
	            return _this._onDragStart(event);
	        };
	        _this._onMouseUp = function (event) {
	            var onMouseUp = React.Children.only(_this.props.children).props.onMouseUp;
	            if (onMouseUp) {
	                onMouseUp(event);
	            }
	            _this._currentEventType = eventMapping.mouse;
	            return _this._onDragStop(event);
	        };
	        _this._onTouchStart = function (event) {
	            var onTouchStart = React.Children.only(_this.props.children).props.onTouchStart;
	            if (onTouchStart) {
	                onTouchStart(event);
	            }
	            _this._currentEventType = eventMapping.touch;
	            return _this._onDragStart(event);
	        };
	        _this._onTouchEnd = function (event) {
	            var onTouchEnd = React.Children.only(_this.props.children).props.onTouchEnd;
	            if (onTouchEnd) {
	                onTouchEnd(event);
	            }
	            _this._currentEventType = eventMapping.touch;
	            _this._onDragStop(event);
	        };
	        _this._onDragStart = function (event) {
	            // Only handle left click for dragging
	            if (typeof event.button === 'number' && event.button !== 0) {
	                return false;
	            }
	            // If the target doesn't match the handleSelector OR
	            // if the target does match the preventDragSelector, bail out
	            if ((_this.props.handleSelector && !_this._matchesSelector(event.target, _this.props.handleSelector)) ||
	                (_this.props.preventDragSelector && _this._matchesSelector(event.target, _this.props.preventDragSelector))) {
	                return;
	            }
	            // Remember the touch identifier if this is a touch event so we can
	            // distinguish between individual touches in multitouch scenarios
	            // by remembering which touch point we were given
	            _this._touchId = _this._getTouchId(event);
	            var position = _this._getControlPosition(event);
	            if (position === undefined) {
	                return;
	            }
	            var dragData = _this._createDragDataFromPosition(position);
	            _this.props.onStart && _this.props.onStart(event, dragData);
	            _this.setState({
	                isDragging: true,
	                lastPosition: position
	            });
	            // hook up the appropriate mouse/touch events to the body to ensure
	            // smooth dragging
	            _this._events = [
	                Utilities_1.on(document.body, _this._currentEventType.move, _this._onDrag),
	                Utilities_1.on(document.body, _this._currentEventType.stop, _this._onDragStop)
	            ];
	        };
	        _this._onDrag = function (event) {
	            // Prevent scrolling on mobile devices
	            if (event.type === 'touchmove') {
	                event.preventDefault();
	            }
	            var position = _this._getControlPosition(event);
	            if (!position) {
	                return;
	            }
	            // create the updated drag data from the position data
	            var updatedData = _this._createUpdatedDragData(_this._createDragDataFromPosition(position));
	            var updatedPosition = updatedData.position;
	            _this.props.onDragChange && _this.props.onDragChange(event, updatedData);
	            _this.setState({
	                position: updatedPosition,
	                lastPosition: position
	            });
	        };
	        _this._onDragStop = function (event) {
	            if (!_this.state.isDragging) {
	                return;
	            }
	            var position = _this._getControlPosition(event);
	            if (!position) {
	                return;
	            }
	            var baseDragData = _this._createDragDataFromPosition(position);
	            // Set dragging to false and reset the lastPosition
	            _this.setState({
	                isDragging: false,
	                lastPosition: undefined
	            });
	            _this.props.onStop && _this.props.onStop(event, baseDragData);
	            if (_this.props.position) {
	                _this.setState({
	                    position: _this.props.position
	                });
	            }
	            // Remove event handlers
	            _this._events.forEach(function (dispose) { return dispose(); });
	        };
	        _this.state = {
	            isDragging: false,
	            position: _this.props.position || { x: 0, y: 0 },
	            lastPosition: undefined
	        };
	        return _this;
	    }
	    DraggableZone.prototype.componentDidUpdate = function (prevProps) {
	        if (this.props.position && (!prevProps.position || this.props.position !== prevProps.position)) {
	            this.setState({ position: this.props.position });
	        }
	    };
	    DraggableZone.prototype.componentWillUnmount = function () {
	        this._events.forEach(function (dispose) { return dispose(); });
	    };
	    DraggableZone.prototype.render = function () {
	        var child = React.Children.only(this.props.children);
	        var props = child.props;
	        var position = this.props.position;
	        var _a = this.state, statePosition = _a.position, isDragging = _a.isDragging;
	        var x = statePosition.x;
	        var y = statePosition.y;
	        if (position && !isDragging) {
	            x = position.x;
	            y = position.y;
	        }
	        return React.cloneElement(child, {
	            style: tslib_1.__assign({}, props.style, { transform: "translate(" + x + "px, " + y + "px)" }),
	            className: DraggableZone_styles_1.getClassNames(props.className, this.state.isDragging).root,
	            onMouseDown: this._onMouseDown,
	            onMouseUp: this._onMouseUp,
	            onTouchStart: this._onTouchStart,
	            onTouchEnd: this._onTouchEnd
	        });
	    };
	    /**
	     * Get the control position based off the event that fired
	     * @param event - The event to get offsets from
	     */
	    DraggableZone.prototype._getControlPosition = function (event) {
	        var touchObj = this._getActiveTouch(event);
	        // did we get the right touch?
	        if (this._touchId !== undefined && !touchObj) {
	            return undefined;
	        }
	        var eventToGetOffset = touchObj || event;
	        return {
	            x: eventToGetOffset.clientX,
	            y: eventToGetOffset.clientY
	        };
	    };
	    /**
	     * Get the active touch point that we have saved from the event's TouchList
	     * @param event - The event used to get the TouchList for the active touch point
	     */
	    DraggableZone.prototype._getActiveTouch = function (event) {
	        return ((event.targetTouches && this._findTouchInTouchList(event.targetTouches)) ||
	            (event.changedTouches && this._findTouchInTouchList(event.changedTouches)));
	    };
	    /**
	     * Get the initial touch identifier associated with the given event
	     * @param event - The event that contains the TouchList
	     */
	    DraggableZone.prototype._getTouchId = function (event) {
	        var touch = (event.targetTouches && event.targetTouches[0]) || (event.changedTouches && event.changedTouches[0]);
	        if (touch) {
	            return touch.identifier;
	        }
	    };
	    /**
	     * Returns if an element (or any of the element's parents) match the given selector
	     */
	    DraggableZone.prototype._matchesSelector = function (element, selector) {
	        if (!element || element === document.body) {
	            return false;
	        }
	        /* tslint:disable-next-line:no-string-literal */
	        var matchesSelectorFn = element.matches || element.webkitMatchesSelector || element['msMatchesSelector'] /* for IE */;
	        if (!matchesSelectorFn) {
	            return false;
	        }
	        return matchesSelectorFn.call(element, selector) || this._matchesSelector(element.parentElement, selector);
	    };
	    /**
	     * Attempts to find the Touch that matches the identifier  we stored in dragStart
	     * @param touchList The TouchList to look for the stored identifier from dragStart
	     */
	    DraggableZone.prototype._findTouchInTouchList = function (touchList) {
	        if (this._touchId === undefined) {
	            return;
	        }
	        for (var i = 0; i < touchList.length; i++) {
	            if (touchList[i].identifier === this._touchId) {
	                return touchList[i];
	            }
	        }
	        return undefined;
	    };
	    /**
	     * Create DragData based off of the last known position and the new position passed in
	     * @param position The new position as part of the drag
	     */
	    DraggableZone.prototype._createDragDataFromPosition = function (position) {
	        var lastPosition = this.state.lastPosition;
	        // If we have no lastPosition, use the given position
	        // for last position
	        if (lastPosition === undefined) {
	            return {
	                delta: { x: 0, y: 0 },
	                lastPosition: position,
	                position: position
	            };
	        }
	        return {
	            delta: {
	                x: position.x - lastPosition.x,
	                y: position.y - lastPosition.y
	            },
	            lastPosition: lastPosition,
	            position: position
	        };
	    };
	    /**
	     * Creates an updated DragData based off the current position and given baseDragData
	     * @param baseDragData The base DragData (gotten from _createDragDataFromPosition) used to calculate the updated positions
	     */
	    DraggableZone.prototype._createUpdatedDragData = function (baseDragData) {
	        var position = this.state.position;
	        return {
	            position: {
	                x: position.x + baseDragData.delta.x,
	                y: position.y + baseDragData.delta.y
	            },
	            delta: baseDragData.delta,
	            lastPosition: position
	        };
	    };
	    return DraggableZone;
	}(React.Component));
	exports.DraggableZone = DraggableZone;
	//# sourceMappingURL=DraggableZone.js.map

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	exports.getClassNames = Utilities_1.memoizeFunction(function (className, isDragging) {
	    return {
	        root: Styling_1.mergeStyles(className, isDragging && {
	            touchAction: 'none',
	            selectors: {
	                '& *': {
	                    userSelect: 'none'
	                }
	            }
	        })
	    };
	});
	//# sourceMappingURL=DraggableZone.styles.js.map

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DialogContent_base_1 = __webpack_require__(933);
	var DialogContent_styles_1 = __webpack_require__(937);
	exports.DialogContent = Utilities_1.styled(DialogContent_base_1.DialogContentBase, DialogContent_styles_1.getStyles, undefined, { scope: 'DialogContent' });
	//# sourceMappingURL=DialogContent.js.map

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DialogContent_types_1 = __webpack_require__(918);
	var Button_1 = __webpack_require__(691);
	var DialogFooter_1 = __webpack_require__(934);
	var withResponsiveMode_1 = __webpack_require__(701);
	var getClassNames = Utilities_1.classNamesFunction();
	var DialogFooterType = React.createElement(DialogFooter_1.DialogFooter, null).type;
	var DialogContentBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DialogContentBase, _super);
	    function DialogContentBase(props) {
	        return _super.call(this, props) || this;
	    }
	    DialogContentBase.prototype.render = function () {
	        var _a = this.props, showCloseButton = _a.showCloseButton, className = _a.className, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, titleId = _a.titleId, title = _a.title, type = _a.type, styles = _a.styles, theme = _a.theme, draggableHeaderClassName = _a.draggableHeaderClassName;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            isLargeHeader: type === DialogContent_types_1.DialogType.largeHeader,
	            isClose: type === DialogContent_types_1.DialogType.close,
	            draggableHeaderClassName: draggableHeaderClassName
	        });
	        var groupings = this._groupChildren();
	        var subTextContent;
	        if (subText) {
	            subTextContent = (React.createElement("p", { className: classNames.subText, id: subTextId }, subText));
	        }
	        return (React.createElement("div", { className: classNames.content },
	            React.createElement("div", { className: classNames.header },
	                React.createElement("p", { className: classNames.title, id: titleId, role: "heading", "aria-level": 2 }, title),
	                React.createElement("div", { className: classNames.topButton },
	                    this.props.topButtonsProps.map(function (props, index) { return (React.createElement(Button_1.IconButton, tslib_1.__assign({ key: props.uniqueId || index }, props))); }),
	                    (type === DialogContent_types_1.DialogType.close || (showCloseButton && type !== DialogContent_types_1.DialogType.largeHeader)) && (React.createElement(Button_1.IconButton, { className: classNames.button, iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss })))),
	            React.createElement("div", { className: classNames.inner },
	                React.createElement("div", { className: classNames.innerContent },
	                    subTextContent,
	                    groupings.contents),
	                groupings.footers)));
	    };
	    // @TODO - typing the footers as an array of DialogFooter is difficult because
	    // casing "child as DialogFooter" causes a problem because
	    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
	    DialogContentBase.prototype._groupChildren = function () {
	        var groupings = {
	            footers: [],
	            contents: []
	        };
	        React.Children.map(this.props.children, function (child) {
	            if (typeof child === 'object' && child !== null && child.type === DialogFooterType) {
	                groupings.footers.push(child);
	            }
	            else {
	                groupings.contents.push(child);
	            }
	        });
	        return groupings;
	    };
	    DialogContentBase.defaultProps = {
	        showCloseButton: false,
	        className: '',
	        topButtonsProps: [],
	        closeButtonAriaLabel: 'Close'
	    };
	    DialogContentBase = tslib_1.__decorate([
	        withResponsiveMode_1.withResponsiveMode
	    ], DialogContentBase);
	    return DialogContentBase;
	}(Utilities_1.BaseComponent));
	exports.DialogContentBase = DialogContentBase;
	//# sourceMappingURL=DialogContent.base.js.map

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DialogFooter_base_1 = __webpack_require__(935);
	var DialogFooter_styles_1 = __webpack_require__(936);
	exports.DialogFooter = Utilities_1.styled(DialogFooter_base_1.DialogFooterBase, DialogFooter_styles_1.getStyles, undefined, { scope: 'DialogFooter' });
	//# sourceMappingURL=DialogFooter.js.map

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var DialogFooterBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DialogFooterBase, _super);
	    function DialogFooterBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DialogFooterBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { className: this._classNames.actions },
	            React.createElement("div", { className: this._classNames.actionsRight }, this._renderChildrenAsActions())));
	    };
	    DialogFooterBase.prototype._renderChildrenAsActions = function () {
	        var _this = this;
	        return React.Children.map(this.props.children, function (child) { return (child ? React.createElement("span", { className: _this._classNames.action }, child) : null); });
	    };
	    return DialogFooterBase;
	}(Utilities_1.BaseComponent));
	exports.DialogFooterBase = DialogFooterBase;
	//# sourceMappingURL=DialogFooter.base.js.map

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    actions: 'ms-Dialog-actions',
	    action: 'ms-Dialog-action',
	    actionsRight: 'ms-Dialog-actionsRight'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        actions: [
	            classNames.actions,
	            {
	                position: 'relative',
	                width: '100%',
	                minHeight: '24px',
	                lineHeight: '24px',
	                margin: '20px 0 0',
	                fontSize: '0',
	                selectors: {
	                    '.ms-Button': {
	                        lineHeight: 'normal'
	                    }
	                }
	            },
	            className
	        ],
	        action: [classNames.action],
	        actionsRight: [
	            classNames.actionsRight,
	            {
	                textAlign: 'right',
	                marginRight: '-4px',
	                fontSize: '0',
	                selectors: {
	                    $action: {
	                        margin: '0 4px'
	                    }
	                }
	            }
	        ]
	    };
	};
	//# sourceMappingURL=DialogFooter.styles.js.map

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    contentLgHeader: 'ms-Dialog-lgHeader',
	    close: 'ms-Dialog--close',
	    subText: 'ms-Dialog-subText',
	    header: 'ms-Dialog-header',
	    headerLg: 'ms-Dialog--lgHeader',
	    button: 'ms-Dialog-button ms-Dialog-button--close',
	    inner: 'ms-Dialog-inner',
	    content: 'ms-Dialog-content',
	    title: 'ms-Dialog-title'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, isLargeHeader = props.isLargeHeader, isClose = props.isClose, hidden = props.hidden, isMultiline = props.isMultiline, draggableHeaderClassName = props.draggableHeaderClassName;
	    var palette = theme.palette, fonts = theme.fonts;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        content: [
	            isLargeHeader && classNames.contentLgHeader,
	            isClose && classNames.close,
	            {
	                flexGrow: 1,
	                overflowY: 'hidden' // required for allowScrollOnElement
	            },
	            className
	        ],
	        subText: [
	            classNames.subText,
	            isLargeHeader ? fonts.medium : fonts.small,
	            {
	                margin: '0 0 20px 0',
	                paddingTop: '8px',
	                color: palette.neutralPrimary,
	                lineHeight: '1.5',
	                wordWrap: 'break-word',
	                fontWeight: Styling_1.FontWeights.semilight
	            }
	        ],
	        header: [
	            classNames.header,
	            {
	                position: 'relative',
	                width: '100%',
	                boxSizing: 'border-box'
	            },
	            isLargeHeader && [
	                classNames.headerLg,
	                {
	                    backgroundColor: palette.themePrimary
	                }
	            ],
	            isClose && classNames.close,
	            draggableHeaderClassName && [
	                draggableHeaderClassName,
	                {
	                    cursor: 'move'
	                }
	            ]
	        ],
	        button: [
	            classNames.button,
	            hidden && {
	                selectors: {
	                    '.ms-Icon.ms-Icon--Cancel': {
	                        color: palette.neutralSecondary,
	                        fontSize: '16px'
	                    }
	                }
	            }
	        ],
	        inner: [
	            classNames.inner,
	            {
	                padding: isMultiline ? '0 20px 20px' : '0 28px 20px'
	            }
	        ],
	        innerContent: [
	            classNames.content,
	            {
	                position: 'relative',
	                width: '100%',
	                selectors: {
	                    '.ms-Button.ms-Button--compount': {
	                        marginBottom: '20px',
	                        selectors: {
	                            '&:last-child': {
	                                marginBottom: '0'
	                            }
	                        }
	                    }
	                }
	            },
	            className
	        ],
	        title: [
	            classNames.title,
	            {
	                color: palette.neutralPrimary,
	                margin: '0',
	                padding: '20px 36px 20px 28px'
	            },
	            fonts.xLarge,
	            isLargeHeader && [
	                {
	                    color: palette.white,
	                    marginBottom: '8px',
	                    padding: '26px 28px 28px'
	                },
	                fonts.xxLarge
	            ],
	            isMultiline && fonts.xxLarge
	        ],
	        topButton: [
	            {
	                display: 'flex',
	                flexDirection: 'row',
	                flexWrap: 'nowrap',
	                position: 'absolute',
	                top: '0',
	                right: '0',
	                padding: '12px 12px 0 0',
	                selectors: {
	                    '> *': {
	                        flex: '0 0 auto'
	                    }
	                }
	            }
	        ]
	    };
	};
	//# sourceMappingURL=DialogContent.styles.js.map

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Dialog'
	};
	exports.getStyles = function (props) {
	    var className = props.className, containerClassName = props.containerClassName, _a = props.dialogDefaultMinWidth, dialogDefaultMinWidth = _a === void 0 ? '288px' : _a, _b = props.dialogDefaultMaxWidth, dialogDefaultMaxWidth = _b === void 0 ? '340px' : _b, hidden = props.hidden, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [classNames.root, theme.fonts.medium, className],
	        main: [
	            {
	                width: dialogDefaultMinWidth,
	                outline: '3px solid transparent',
	                selectors: (_c = {},
	                    _c["@media (min-width: " + Styling_1.ScreenWidthMinMedium + "px)"] = {
	                        width: 'auto',
	                        maxWidth: dialogDefaultMaxWidth,
	                        minWidth: dialogDefaultMinWidth
	                    },
	                    _c)
	            },
	            !hidden && { display: 'flex' },
	            containerClassName
	        ]
	    };
	    var _c;
	};
	//# sourceMappingURL=Dialog.styles.js.map

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(940), exports);
	//# sourceMappingURL=DocumentCard.js.map

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(941), exports);
	tslib_1.__exportStar(__webpack_require__(943), exports);
	tslib_1.__exportStar(__webpack_require__(949), exports);
	tslib_1.__exportStar(__webpack_require__(952), exports);
	tslib_1.__exportStar(__webpack_require__(955), exports);
	tslib_1.__exportStar(__webpack_require__(958), exports);
	tslib_1.__exportStar(__webpack_require__(960), exports);
	tslib_1.__exportStar(__webpack_require__(962), exports);
	tslib_1.__exportStar(__webpack_require__(965), exports);
	tslib_1.__exportStar(__webpack_require__(967), exports);
	tslib_1.__exportStar(__webpack_require__(970), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCard_base_1 = __webpack_require__(942);
	var DocumentCard_styles_1 = __webpack_require__(944);
	exports.DocumentCard = Utilities_1.styled(DocumentCard_base_1.DocumentCardBase, DocumentCard_styles_1.getStyles, undefined, { scope: 'DocumentCard' });
	//# sourceMappingURL=DocumentCard.js.map

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var DocumentCard_types_1 = __webpack_require__(943);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardBase, _super);
	    function DocumentCardBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._rootElement = React.createRef();
	        _this._onClick = function (ev) {
	            _this._onAction(ev);
	        };
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.enter || ev.which === Utilities_1.KeyCodes.space) {
	                _this._onAction(ev);
	            }
	        };
	        _this._onAction = function (ev) {
	            var _a = _this.props, onClick = _a.onClick, onClickHref = _a.onClickHref;
	            if (onClick) {
	                onClick(ev);
	            }
	            else if (!onClick && onClickHref) {
	                // If no onClick Function was provided and we do have an onClickHref, redirect to the onClickHref
	                window.location.href = onClickHref;
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	        };
	        _this._warnDeprecations({
	            accentColor: undefined
	        });
	        return _this;
	    }
	    DocumentCardBase.prototype.render = function () {
	        var _a = this.props, onClick = _a.onClick, onClickHref = _a.onClickHref, children = _a.children, type = _a.type, accentColor = _a.accentColor, styles = _a.styles, theme = _a.theme, className = _a.className;
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties, ['className', 'onClick', 'type', 'role']);
	        var actionable = onClick || onClickHref ? true : false;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            actionable: actionable,
	            compact: type === DocumentCard_types_1.DocumentCardType.compact ? true : false
	        });
	        // Override the border color if an accent color was provided (compact card only)
	        var style;
	        if (type === DocumentCard_types_1.DocumentCardType.compact && accentColor) {
	            style = {
	                borderBottomColor: accentColor
	            };
	        }
	        // if this element is actionable it should have an aria role
	        var role = this.props.role || (actionable ? (onClick ? 'button' : 'link') : undefined);
	        var tabIndex = actionable ? 0 : undefined;
	        return (React.createElement("div", tslib_1.__assign({ ref: this._rootElement, tabIndex: tabIndex, "data-is-focusable": actionable, role: role, className: this._classNames.root, onKeyDown: actionable ? this._onKeyDown : undefined, onClick: actionable ? this._onClick : undefined, style: style }, nativeProps), children));
	    };
	    DocumentCardBase.prototype.focus = function () {
	        if (this._rootElement.current) {
	            this._rootElement.current.focus();
	        }
	    };
	    DocumentCardBase.defaultProps = {
	        type: DocumentCard_types_1.DocumentCardType.normal
	    };
	    return DocumentCardBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardBase = DocumentCardBase;
	//# sourceMappingURL=DocumentCard.base.js.map

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardType;
	(function (DocumentCardType) {
	    /**
	     * Standard DocumentCard.
	     */
	    DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
	    /**
	     * Compact layout. Displays the preview beside the details, rather than above.
	     */
	    DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
	})(DocumentCardType = exports.DocumentCardType || (exports.DocumentCardType = {}));
	//# sourceMappingURL=DocumentCard.types.js.map

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var DocumentCardPreview_styles_1 = __webpack_require__(945);
	var DocumentCardActivity_styles_1 = __webpack_require__(946);
	var DocumentCardTitle_styles_1 = __webpack_require__(947);
	var DocumentCardLocation_styles_1 = __webpack_require__(948);
	var GlobalClassNames = {
	    root: 'ms-DocumentCard',
	    rootActionable: 'ms-DocumentCard--actionable',
	    rootCompact: 'ms-DocumentCard--compact'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, actionable = props.actionable, compact = props.compact;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                WebkitFontSmoothing: 'antialiased',
	                backgroundColor: palette.white,
	                border: "1px solid " + palette.neutralLight,
	                boxSizing: 'border-box',
	                maxWidth: '320px',
	                minWidth: '206px',
	                userSelect: 'none',
	                position: 'relative',
	                selectors: (_a = {},
	                    _a["." + DocumentCardLocation_styles_1.DocumentCardLocationGlobalClassNames.root + " + ." + DocumentCardTitle_styles_1.DocumentCardTitleGlobalClassNames.root] = {
	                        paddingTop: '4px'
	                    },
	                    _a)
	            },
	            actionable && [
	                classNames.rootActionable,
	                {
	                    selectors: {
	                        ':hover': {
	                            cursor: 'pointer',
	                            borderColor: palette.neutralTertiaryAlt
	                        },
	                        ':hover:after': {
	                            content: '" "',
	                            position: 'absolute',
	                            top: 0,
	                            right: 0,
	                            bottom: 0,
	                            left: 0,
	                            border: "1px solid " + palette.neutralTertiaryAlt,
	                            pointerEvents: 'none'
	                        }
	                    }
	                }
	            ],
	            compact && [
	                classNames.rootCompact,
	                {
	                    display: 'flex',
	                    maxWidth: '480px',
	                    height: '108px',
	                    selectors: (_b = {},
	                        _b["." + DocumentCardPreview_styles_1.DocumentCardPreviewGlobalClassNames.root] = {
	                            borderRight: "1px solid " + palette.neutralLight,
	                            borderBottom: 0,
	                            maxHeight: '106px',
	                            maxWidth: '144px'
	                        },
	                        _b["." + DocumentCardPreview_styles_1.DocumentCardPreviewGlobalClassNames.icon] = {
	                            maxHeight: '32px',
	                            maxWidth: '32px'
	                        },
	                        _b["." + DocumentCardActivity_styles_1.DocumentCardActivityGlobalClassNames.root] = {
	                            paddingBottom: '12px'
	                        },
	                        _b["." + DocumentCardTitle_styles_1.DocumentCardTitleGlobalClassNames.root] = {
	                            paddingBottom: '12px 16px 8px 16px',
	                            fontSize: Styling_1.FontSizes.mediumPlus,
	                            lineHeight: '16px'
	                        },
	                        _b)
	                }
	            ],
	            className
	        ]
	    };
	    var _a, _b;
	};
	//# sourceMappingURL=DocumentCard.styles.js.map

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.DocumentCardPreviewGlobalClassNames = {
	    root: 'ms-DocumentCardPreview',
	    icon: 'ms-DocumentCardPreview-icon',
	    iconContainer: 'ms-DocumentCardPreview-iconContainer'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, isFileList = props.isFileList;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardPreviewGlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                borderBottom: "1px solid " + palette.neutralLight,
	                position: 'relative',
	                backgroundColor: isFileList ? palette.white : palette.neutralLighterAlt,
	                overflow: "hidden"
	            },
	            className
	        ],
	        previewIcon: [
	            classNames.iconContainer,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                height: '100%'
	            }
	        ],
	        icon: [
	            classNames.icon,
	            {
	                left: '10px',
	                bottom: '10px',
	                position: 'absolute'
	            }
	        ],
	        fileList: {
	            padding: '16px 16px 0 16px',
	            listStyleType: 'none',
	            margin: 0,
	            selectors: {
	                li: {
	                    height: '16px',
	                    lineHeight: '16px',
	                    marginBottom: '8px',
	                    overflow: 'hidden',
	                    paddingLeft: '24px',
	                    position: 'relative',
	                    textOverflow: 'ellipsis',
	                    whiteSpace: 'nowrap'
	                },
	                a: {
	                    fontSize: Styling_1.FontSizes.small,
	                    textDecoration: 'none',
	                    color: palette.neutralDark,
	                    selectors: {
	                        ':hover': {
	                            color: palette.themePrimary
	                        }
	                    }
	                }
	            }
	        },
	        fileListIcon: {
	            left: 0,
	            position: 'absolute',
	            top: 0
	        },
	        fileListOverflowText: {
	            padding: '0px 16px 8px 16px',
	            display: 'block',
	            fontSize: Styling_1.FontSizes.small
	        }
	    };
	};
	//# sourceMappingURL=DocumentCardPreview.styles.js.map

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var VERTICAL_PADDING = 8;
	var HORIZONTAL_PADDING = 16;
	var IMAGE_SIZE = 32;
	var PERSONA_TEXT_GUTTER = 8;
	exports.DocumentCardActivityGlobalClassNames = {
	    root: 'ms-DocumentCardActivity',
	    multiplePeople: 'ms-DocumentCardActivity--multiplePeople',
	    details: 'ms-DocumentCardActivity-details',
	    name: 'ms-DocumentCardActivity-name',
	    activity: 'ms-DocumentCardActivity-activity',
	    avatars: 'ms-DocumentCardActivity-avatars',
	    avatar: 'ms-DocumentCardActivity-avatar'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, multiplePeople = props.multiplePeople;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardActivityGlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            multiplePeople && classNames.multiplePeople,
	            {
	                padding: VERTICAL_PADDING + "px " + HORIZONTAL_PADDING + "px",
	                position: 'relative'
	            },
	            className
	        ],
	        avatars: [
	            classNames.avatars,
	            {
	                marginLeft: '-2px',
	                height: '32px'
	            }
	        ],
	        avatar: [
	            classNames.avatar,
	            {
	                display: 'inline-block',
	                verticalAlign: 'top',
	                position: 'relative',
	                textAlign: 'center',
	                width: IMAGE_SIZE,
	                height: IMAGE_SIZE,
	                selectors: {
	                    '&:after': {
	                        content: '" "',
	                        position: 'absolute',
	                        left: '-1px',
	                        top: '-1px',
	                        right: '-1px',
	                        bottom: '-1px',
	                        border: "2px solid " + palette.white,
	                        borderRadius: '50%'
	                    },
	                    ':nth-of-type(2)': multiplePeople && {
	                        marginLeft: '-16px'
	                    }
	                }
	            }
	        ],
	        details: [
	            classNames.details,
	            {
	                left: multiplePeople
	                    ? HORIZONTAL_PADDING + IMAGE_SIZE * 1.5 + PERSONA_TEXT_GUTTER + "px"
	                    : HORIZONTAL_PADDING + IMAGE_SIZE + PERSONA_TEXT_GUTTER + "px",
	                height: IMAGE_SIZE,
	                position: 'absolute',
	                top: VERTICAL_PADDING,
	                width: "calc(100% - " + (HORIZONTAL_PADDING + IMAGE_SIZE + PERSONA_TEXT_GUTTER + HORIZONTAL_PADDING) + "px)"
	            }
	        ],
	        name: [
	            classNames.name,
	            {
	                display: 'block',
	                fontSize: Styling_1.FontSizes.small,
	                lineHeight: '15px',
	                height: '15px',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                color: palette.neutralPrimary,
	                fontWeight: Styling_1.FontWeights.semibold
	            }
	        ],
	        activity: [
	            classNames.activity,
	            {
	                display: 'block',
	                fontSize: Styling_1.FontSizes.small,
	                lineHeight: '15px',
	                height: '15px',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                color: palette.neutralSecondary
	            }
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardActivity.styles.js.map

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.DocumentCardTitleGlobalClassNames = {
	    root: 'ms-DocumentCardTitle'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, showAsSecondaryTitle = props.showAsSecondaryTitle;
	    var palette = theme.palette, fonts = theme.fonts;
	    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardTitleGlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            showAsSecondaryTitle ? fonts.medium : fonts.large,
	            {
	                padding: '8px 16px',
	                display: 'block',
	                overflow: 'hidden',
	                wordWrap: 'break-word',
	                height: showAsSecondaryTitle ? '45px' : '38px',
	                lineHeight: showAsSecondaryTitle ? '18px' : '21px',
	                color: showAsSecondaryTitle ? palette.neutralSecondary : palette.neutralPrimary
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardTitle.styles.js.map

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.DocumentCardLocationGlobalClassNames = {
	    root: 'ms-DocumentCardLocation'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardLocationGlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                fontSize: Styling_1.FontSizes.small,
	                color: palette.neutralPrimary,
	                display: 'block',
	                padding: '8px 16px',
	                position: 'relative',
	                textDecoration: 'none',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                selectors: {
	                    ':hover': {
	                        color: palette.themePrimary,
	                        cursor: 'pointer'
	                    }
	                }
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardLocation.styles.js.map

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardActions_base_1 = __webpack_require__(950);
	var DocumentCardActions_styles_1 = __webpack_require__(951);
	exports.DocumentCardActions = Utilities_1.styled(DocumentCardActions_base_1.DocumentCardActionsBase, DocumentCardActions_styles_1.getStyles, undefined, { scope: 'DocumentCardActions' });
	//# sourceMappingURL=DocumentCardActions.js.map

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var Button_1 = __webpack_require__(691);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardActionsBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardActionsBase, _super);
	    function DocumentCardActionsBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardActionsBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, actions = _a.actions, views = _a.views, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { className: this._classNames.root },
	            actions &&
	                actions.map(function (action, index) {
	                    return (React.createElement("div", { className: _this._classNames.action, key: index },
	                        React.createElement(Button_1.IconButton, tslib_1.__assign({}, action))));
	                }),
	            views > 0 && (React.createElement("div", { className: this._classNames.views },
	                React.createElement(Icon_1.Icon, { iconName: "View", className: this._classNames.viewsIcon }),
	                views))));
	    };
	    return DocumentCardActionsBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardActionsBase = DocumentCardActionsBase;
	//# sourceMappingURL=DocumentCardActions.base.js.map

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var ACTION_SIZE = 34;
	var HORIZONTAL_PADDING = 12;
	var VERTICAL_PADDING = 4;
	var GlobalClassNames = {
	    root: 'ms-DocumentCardActions',
	    action: 'ms-DocumentCardActions-action',
	    views: 'ms-DocumentCardActions-views'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                height: ACTION_SIZE + "px",
	                padding: VERTICAL_PADDING + "px " + HORIZONTAL_PADDING + "px",
	                position: 'relative'
	            },
	            className
	        ],
	        action: [
	            classNames.action,
	            {
	                float: 'left',
	                marginRight: '4px',
	                color: palette.neutralSecondary,
	                cursor: 'pointer',
	                selectors: {
	                    '.ms-Button': {
	                        fontSize: '16px',
	                        height: ACTION_SIZE,
	                        width: ACTION_SIZE
	                    },
	                    '.ms-Button:hover .ms-Button-icon': {
	                        color: theme.semanticColors.buttonText,
	                        cursor: 'pointer'
	                    }
	                }
	            }
	        ],
	        views: [
	            classNames.views,
	            {
	                textAlign: 'right',
	                lineHeight: ACTION_SIZE
	            }
	        ],
	        viewsIcon: {
	            marginRight: '8px',
	            fontSize: Styling_1.FontSizes.medium,
	            verticalAlign: 'top'
	        }
	    };
	};
	//# sourceMappingURL=DocumentCardActions.styles.js.map

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardActivity_base_1 = __webpack_require__(953);
	var DocumentCardActivity_styles_1 = __webpack_require__(946);
	exports.DocumentCardActivity = Utilities_1.styled(DocumentCardActivity_base_1.DocumentCardActivityBase, DocumentCardActivity_styles_1.getStyles, undefined, { scope: 'DocumentCardActivity' });
	//# sourceMappingURL=DocumentCardActivity.js.map

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Persona_1 = __webpack_require__(594);
	var PersonaCoin_1 = __webpack_require__(954);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardActivityBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardActivityBase, _super);
	    function DocumentCardActivityBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardActivityBase.prototype.render = function () {
	        var _a = this.props, activity = _a.activity, people = _a.people, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            multiplePeople: people.length > 1
	        });
	        if (!people || people.length === 0) {
	            return null;
	        }
	        return (React.createElement("div", { className: this._classNames.root },
	            this._renderAvatars(people),
	            React.createElement("div", { className: this._classNames.details },
	                React.createElement("span", { className: this._classNames.name }, this._getNameString(people)),
	                React.createElement("span", { className: this._classNames.activity }, activity))));
	    };
	    DocumentCardActivityBase.prototype._renderAvatars = function (people) {
	        return (React.createElement("div", { className: this._classNames.avatars },
	            people.length > 1 ? this._renderAvatar(people[1]) : null,
	            this._renderAvatar(people[0])));
	    };
	    DocumentCardActivityBase.prototype._renderAvatar = function (person) {
	        return (React.createElement("div", { className: this._classNames.avatar },
	            React.createElement(PersonaCoin_1.PersonaCoin, { imageInitials: person.initials, text: person.name, imageUrl: person.profileImageSrc, initialsColor: person.initialsColor, allowPhoneInitials: person.allowPhoneInitials, role: "presentation", size: Persona_1.PersonaSize.size32 })));
	    };
	    DocumentCardActivityBase.prototype._getNameString = function (people) {
	        var nameString = people[0].name;
	        if (people.length >= 2) {
	            nameString += ' +' + (people.length - 1);
	        }
	        return nameString;
	    };
	    return DocumentCardActivityBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardActivityBase = DocumentCardActivityBase;
	//# sourceMappingURL=DocumentCardActivity.base.js.map

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(595), exports);
	//# sourceMappingURL=PersonaCoin.js.map

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardDetails_base_1 = __webpack_require__(956);
	var DocumentCardDetails_styles_1 = __webpack_require__(957);
	exports.DocumentCardDetails = Utilities_1.styled(DocumentCardDetails_base_1.DocumentCardDetailsBase, DocumentCardDetails_styles_1.getStyles, undefined, { scope: 'DocumentCardDetails' });
	//# sourceMappingURL=DocumentCardDetails.js.map

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardDetailsBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardDetailsBase, _super);
	    function DocumentCardDetailsBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardDetailsBase.prototype.render = function () {
	        var _a = this.props, children = _a.children, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return React.createElement("div", { className: this._classNames.root }, children);
	    };
	    return DocumentCardDetailsBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardDetailsBase = DocumentCardDetailsBase;
	//# sourceMappingURL=DocumentCardDetails.base.js.map

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DocumentCardDetails'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                display: 'flex',
	                flexDirection: 'column',
	                flex: 1,
	                justifyContent: 'space-between',
	                overflow: 'hidden'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardDetails.styles.js.map

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardLocation_base_1 = __webpack_require__(959);
	var DocumentCardLocation_styles_1 = __webpack_require__(948);
	exports.DocumentCardLocation = Utilities_1.styled(DocumentCardLocation_base_1.DocumentCardLocationBase, DocumentCardLocation_styles_1.getStyles, undefined, { scope: 'DocumentCardLocation' });
	//# sourceMappingURL=DocumentCardLocation.js.map

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardLocationBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardLocationBase, _super);
	    function DocumentCardLocationBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardLocationBase.prototype.render = function () {
	        var _a = this.props, location = _a.location, locationHref = _a.locationHref, ariaLabel = _a.ariaLabel, onClick = _a.onClick, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("a", { className: this._classNames.root, href: locationHref, onClick: onClick, "aria-label": ariaLabel }, location));
	    };
	    return DocumentCardLocationBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardLocationBase = DocumentCardLocationBase;
	//# sourceMappingURL=DocumentCardLocation.base.js.map

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardPreview_base_1 = __webpack_require__(961);
	var DocumentCardPreview_styles_1 = __webpack_require__(945);
	exports.DocumentCardPreview = Utilities_1.styled(DocumentCardPreview_base_1.DocumentCardPreviewBase, DocumentCardPreview_styles_1.getStyles, undefined, { scope: 'DocumentCardPreview' });
	//# sourceMappingURL=DocumentCardPreview.js.map

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_1 = __webpack_require__(643);
	var Image_1 = __webpack_require__(658);
	var Link_1 = __webpack_require__(680);
	var Utilities_1 = __webpack_require__(592);
	var LIST_ITEM_COUNT = 3;
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardPreviewBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardPreviewBase, _super);
	    function DocumentCardPreviewBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._renderPreviewList = function (previewImages) {
	            var getOverflowDocumentCountText = _this.props.getOverflowDocumentCountText;
	            // Determine how many documents we won't be showing
	            var overflowDocumentCount = previewImages.length - LIST_ITEM_COUNT;
	            // Determine the overflow text that will be rendered after the preview list.
	            var overflowText = overflowDocumentCount
	                ? getOverflowDocumentCountText
	                    ? getOverflowDocumentCountText(overflowDocumentCount)
	                    : '+' + overflowDocumentCount
	                : null;
	            // Create list items for the documents to be shown
	            var fileListItems = previewImages.slice(0, LIST_ITEM_COUNT).map(function (file, fileIndex) { return (React.createElement("li", { key: fileIndex },
	                React.createElement(Image_1.Image, { className: _this._classNames.fileListIcon, src: file.iconSrc, role: "presentation", alt: "", width: "16px", height: "16px" }),
	                React.createElement(Link_1.Link, tslib_1.__assign({}, (file.linkProps, { href: file.url || (file.linkProps && file.linkProps.href) })), file.name))); });
	            return (React.createElement("div", null,
	                React.createElement("ul", { className: _this._classNames.fileList }, fileListItems),
	                overflowText && React.createElement("span", { className: _this._classNames.fileListOverflowText }, overflowText)));
	        };
	        return _this;
	    }
	    DocumentCardPreviewBase.prototype.render = function () {
	        var _a = this.props, previewImages = _a.previewImages, styles = _a.styles, theme = _a.theme, className = _a.className;
	        var style, preview;
	        var isFileList = previewImages.length > 1;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            isFileList: isFileList
	        });
	        if (previewImages.length > 1) {
	            // Render a list of files
	            preview = this._renderPreviewList(previewImages);
	        }
	        else if (previewImages.length === 1) {
	            // Render a single preview
	            preview = this._renderPreviewImage(previewImages[0]);
	            // Override the border color if an accent color was provided
	            if (previewImages[0].accentColor) {
	                style = {
	                    borderBottomColor: previewImages[0].accentColor
	                };
	            }
	        }
	        return (React.createElement("div", { className: this._classNames.root, style: style }, preview));
	    };
	    DocumentCardPreviewBase.prototype._renderPreviewImage = function (previewImage) {
	        var width = previewImage.width, height = previewImage.height, imageFit = previewImage.imageFit, previewIconProps = previewImage.previewIconProps, previewIconContainerClass = previewImage.previewIconContainerClass;
	        if (previewIconProps) {
	            return (React.createElement("div", { className: Utilities_1.css(this._classNames.previewIcon, previewIconContainerClass), style: { width: width, height: height } },
	                React.createElement(Icon_1.Icon, tslib_1.__assign({}, previewIconProps))));
	        }
	        var image = React.createElement(Image_1.Image, { width: width, height: height, imageFit: imageFit, src: previewImage.previewImageSrc, role: "presentation", alt: "" });
	        var icon;
	        if (previewImage.iconSrc) {
	            icon = React.createElement(Image_1.Image, { className: this._classNames.icon, src: previewImage.iconSrc, role: "presentation", alt: "" });
	        }
	        return (React.createElement("div", null,
	            image,
	            icon));
	    };
	    return DocumentCardPreviewBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardPreviewBase = DocumentCardPreviewBase;
	//# sourceMappingURL=DocumentCardPreview.base.js.map

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardImage_base_1 = __webpack_require__(963);
	var DocumentCardImage_styles_1 = __webpack_require__(964);
	exports.DocumentCardImage = Utilities_1.styled(DocumentCardImage_base_1.DocumentCardImageBase, DocumentCardImage_styles_1.getStyles, undefined, { scope: 'DocumentCardImage' });
	//# sourceMappingURL=DocumentCardImage.js.map

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_1 = __webpack_require__(643);
	var Image_1 = __webpack_require__(658);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardImageBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardImageBase, _super);
	    function DocumentCardImageBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onImageLoad = function () {
	            _this.setState({ imageHasLoaded: true });
	        };
	        _this.state = { imageHasLoaded: false };
	        return _this;
	    }
	    DocumentCardImageBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, width = _a.width, height = _a.height, imageFit = _a.imageFit, imageSrc = _a.imageSrc;
	        this._classNames = getClassNames(styles, this.props);
	        return (React.createElement("div", { className: this._classNames.root },
	            imageSrc && (React.createElement(Image_1.Image, { width: width, height: height, imageFit: imageFit, src: imageSrc, role: "presentation", alt: "", onLoad: this._onImageLoad })),
	            this.state.imageHasLoaded ? this._renderCornerIcon() : this._renderCenterIcon()));
	    };
	    DocumentCardImageBase.prototype._renderCenterIcon = function () {
	        var iconProps = this.props.iconProps;
	        return (React.createElement("div", { className: this._classNames.centeredIconWrapper },
	            React.createElement(Icon_1.Icon, tslib_1.__assign({ className: this._classNames.centeredIcon }, iconProps))));
	    };
	    DocumentCardImageBase.prototype._renderCornerIcon = function () {
	        var iconProps = this.props.iconProps;
	        return React.createElement(Icon_1.Icon, tslib_1.__assign({ className: this._classNames.cornerIcon }, iconProps));
	    };
	    return DocumentCardImageBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardImageBase = DocumentCardImageBase;
	//# sourceMappingURL=DocumentCardImage.base.js.map

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var centeredIconSize = '42px';
	var cornerIconSize = '32px';
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, height = props.height, width = props.width;
	    var palette = theme.palette;
	    return {
	        root: [
	            {
	                borderBottom: "1px solid " + palette.neutralLight,
	                position: 'relative',
	                backgroundColor: palette.neutralLighterAlt,
	                overflow: "hidden",
	                height: height && height + "px",
	                width: width && width + "px"
	            },
	            className
	        ],
	        centeredIcon: [
	            {
	                height: centeredIconSize,
	                width: centeredIconSize,
	                fontSize: centeredIconSize
	            }
	        ],
	        centeredIconWrapper: [
	            {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                height: '100%',
	                width: '100%',
	                position: 'absolute',
	                top: 0,
	                left: 0
	            }
	        ],
	        cornerIcon: [
	            {
	                left: '10px',
	                bottom: '10px',
	                height: cornerIconSize,
	                width: cornerIconSize,
	                fontSize: cornerIconSize,
	                position: 'absolute',
	                overflow: 'visible'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardImage.styles.js.map

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardTitle_base_1 = __webpack_require__(966);
	var DocumentCardTitle_styles_1 = __webpack_require__(947);
	exports.DocumentCardTitle = Utilities_1.styled(DocumentCardTitle_base_1.DocumentCardTitleBase, DocumentCardTitle_styles_1.getStyles, undefined, { scope: 'DocumentCardTitle' });
	//# sourceMappingURL=DocumentCardTitle.js.map

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD = 5;
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardTitleBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardTitleBase, _super);
	    function DocumentCardTitleBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._titleElement = React.createRef();
	        _this._measureTitleElement = React.createRef();
	        // Truncate logic here way can't handle the case that chars with different widths are mixed very well, let _shrinkTitle take care of that.
	        _this._truncateTitle = function () {
	            if (!_this.state.needMeasurement) {
	                return;
	            }
	            _this._async.requestAnimationFrame(_this._truncateWhenInAnimation);
	        };
	        _this._truncateWhenInAnimation = function () {
	            var originalTitle = _this.props.title;
	            var element = _this._measureTitleElement.current;
	            if (element) {
	                var style = getComputedStyle(element);
	                if (style.width && style.lineHeight && style.height) {
	                    var clientWidth = element.clientWidth, scrollWidth = element.scrollWidth;
	                    var lines = Math.floor((parseInt(style.height, 10) + TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD) / parseInt(style.lineHeight, 10));
	                    // Use overflow to predict truncated length.
	                    // Take an example.The text is: A text with A very long text that need to be truncated.ppt
	                    // if container is like
	                    // |A text with A very| long text that need to be truncated.ppt
	                    // The scroll width is 58, (take two | out of length)
	                    // The client width is 18
	                    // the overflow rate is scrollWidth/clientWidth which should be close to length(overflowText)/length(visualText)
	                    // And the length of remaining text should be truncated is (original Length)/(58/18) -3 = 15.
	                    // So that the logic can predict truncated text well.
	                    // first piece will be `A text `, * second piece will be `ated.ppt`
	                    // |A text ...ated.ppt|
	                    var overFlowRate = scrollWidth / (parseInt(style.width, 10) * lines);
	                    if (overFlowRate > 1) {
	                        var truncatedLength = originalTitle.length / overFlowRate - 3 /** Saved for separator */;
	                        return _this.setState({
	                            truncatedTitleFirstPiece: originalTitle.slice(0, truncatedLength / 2),
	                            truncatedTitleSecondPiece: originalTitle.slice(originalTitle.length - truncatedLength / 2),
	                            clientWidth: clientWidth,
	                            needMeasurement: false
	                        });
	                    }
	                }
	            }
	            return _this.setState({ needMeasurement: false });
	        };
	        _this._shrinkTitle = function () {
	            var _a = _this.state, truncatedTitleFirstPiece = _a.truncatedTitleFirstPiece, truncatedTitleSecondPiece = _a.truncatedTitleSecondPiece;
	            if (truncatedTitleFirstPiece && truncatedTitleSecondPiece) {
	                var titleElement = _this._titleElement.current;
	                if (!titleElement) {
	                    return;
	                }
	                if (titleElement.scrollHeight > titleElement.clientHeight + TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD ||
	                    titleElement.scrollWidth > titleElement.clientWidth) {
	                    _this.setState({
	                        truncatedTitleFirstPiece: truncatedTitleFirstPiece.slice(0, truncatedTitleFirstPiece.length - 1),
	                        truncatedTitleSecondPiece: truncatedTitleSecondPiece.slice(1)
	                    });
	                }
	            }
	        };
	        _this.state = {
	            truncatedTitleFirstPiece: '',
	            truncatedTitleSecondPiece: '',
	            previousTitle: props.title,
	            needMeasurement: !!props.shouldTruncate
	        };
	        return _this;
	    }
	    DocumentCardTitleBase.prototype.componentDidUpdate = function () {
	        if (this.props.title !== this.state.previousTitle) {
	            this.setState({
	                truncatedTitleFirstPiece: undefined,
	                truncatedTitleSecondPiece: undefined,
	                clientWidth: undefined,
	                previousTitle: this.props.title,
	                needMeasurement: !!this.props.shouldTruncate
	            });
	        }
	        this._events.off(window, 'resize', this._updateTruncation);
	        if (this.props.shouldTruncate) {
	            this._truncateTitle();
	            requestAnimationFrame(this._shrinkTitle);
	            this._events.on(window, 'resize', this._updateTruncation);
	        }
	    };
	    DocumentCardTitleBase.prototype.componentDidMount = function () {
	        if (this.props.shouldTruncate) {
	            this._truncateTitle();
	            this._events.on(window, 'resize', this._updateTruncation);
	        }
	    };
	    DocumentCardTitleBase.prototype.componentWillUnmount = function () {
	        this._events.off(window, 'resize', this._updateTruncation);
	    };
	    DocumentCardTitleBase.prototype.render = function () {
	        var _a = this.props, title = _a.title, shouldTruncate = _a.shouldTruncate, showAsSecondaryTitle = _a.showAsSecondaryTitle, styles = _a.styles, theme = _a.theme, className = _a.className;
	        var _b = this.state, truncatedTitleFirstPiece = _b.truncatedTitleFirstPiece, truncatedTitleSecondPiece = _b.truncatedTitleSecondPiece, needMeasurement = _b.needMeasurement;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            showAsSecondaryTitle: showAsSecondaryTitle
	        });
	        var documentCardTitle;
	        if (needMeasurement) {
	            documentCardTitle = (React.createElement("div", { className: this._classNames.root, ref: this._measureTitleElement, title: title, style: { whiteSpace: 'nowrap' } }, title));
	        }
	        else if (shouldTruncate && truncatedTitleFirstPiece && truncatedTitleSecondPiece) {
	            documentCardTitle = (React.createElement("div", { className: this._classNames.root, ref: this._titleElement, title: title },
	                truncatedTitleFirstPiece,
	                "\u2026",
	                truncatedTitleSecondPiece));
	        }
	        else {
	            documentCardTitle = (React.createElement("div", { className: this._classNames.root, ref: this._titleElement, title: title }, title));
	        }
	        return documentCardTitle;
	    };
	    DocumentCardTitleBase.prototype._updateTruncation = function () {
	        var _this = this;
	        this._async.requestAnimationFrame(function () {
	            // Only update truncation if the title's size has changed since the last time we truncated
	            if (_this._titleElement.current) {
	                var clientWidth = _this._titleElement.current.clientWidth;
	                // Throttle truncation so that it doesn't happen during a window resize
	                clearTimeout(_this._titleTruncationTimer);
	                if (_this.state.clientWidth !== clientWidth) {
	                    _this._titleTruncationTimer = _this._async.setTimeout(function () {
	                        return _this.setState({
	                            truncatedTitleFirstPiece: undefined,
	                            truncatedTitleSecondPiece: undefined,
	                            needMeasurement: true
	                        });
	                    }, 250);
	                }
	            }
	        });
	    };
	    return DocumentCardTitleBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardTitleBase = DocumentCardTitleBase;
	//# sourceMappingURL=DocumentCardTitle.base.js.map

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardLogo_base_1 = __webpack_require__(968);
	var DocumentCardLogo_styles_1 = __webpack_require__(969);
	exports.DocumentCardLogo = Utilities_1.styled(DocumentCardLogo_base_1.DocumentCardLogoBase, DocumentCardLogo_styles_1.getStyles, undefined, { scope: 'DocumentCardLogo' });
	//# sourceMappingURL=DocumentCardLogo.js.map

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardLogoBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardLogoBase, _super);
	    function DocumentCardLogoBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardLogoBase.prototype.render = function () {
	        var _a = this.props, logoIcon = _a.logoIcon, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { className: this._classNames.root },
	            React.createElement(Icon_1.Icon, { iconName: logoIcon })));
	    };
	    return DocumentCardLogoBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardLogoBase = DocumentCardLogoBase;
	//# sourceMappingURL=DocumentCardLogo.base.js.map

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DocumentCardLogo'
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                fontSize: '32px',
	                color: palette.themePrimary,
	                display: 'block',
	                padding: '16px 16px 0 16px'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardLogo.styles.js.map

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var DocumentCardStatus_base_1 = __webpack_require__(971);
	var DocumentCardStatus_styles_1 = __webpack_require__(972);
	exports.DocumentCardStatus = Utilities_1.styled(DocumentCardStatus_base_1.DocumentCardStatusBase, DocumentCardStatus_styles_1.getStyles, undefined, { scope: 'DocumentCardStatus' });
	//# sourceMappingURL=DocumentCardStatus.js.map

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory DocumentCard}
	 */
	var DocumentCardStatusBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DocumentCardStatusBase, _super);
	    function DocumentCardStatusBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentCardStatusBase.prototype.render = function () {
	        var _a = this.props, statusIcon = _a.statusIcon, status = _a.status, styles = _a.styles, theme = _a.theme, className = _a.className;
	        var iconProps = {
	            iconName: statusIcon,
	            styles: {
	                root: { padding: '8px' }
	            }
	        };
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", { className: this._classNames.root },
	            statusIcon && React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps)),
	            status));
	    };
	    return DocumentCardStatusBase;
	}(Utilities_1.BaseComponent));
	exports.DocumentCardStatusBase = DocumentCardStatusBase;
	//# sourceMappingURL=DocumentCardStatus.base.js.map

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-DocumentCardStatus'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var palette = theme.palette, fonts = theme.fonts;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            fonts.medium,
	            {
	                margin: '8px 16px',
	                color: palette.neutralPrimary,
	                backgroundColor: palette.neutralLighter,
	                height: '32px'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=DocumentCardStatus.styles.js.map

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(974), exports);
	//# sourceMappingURL=Dropdown.js.map

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(975), exports);
	tslib_1.__exportStar(__webpack_require__(976), exports);
	tslib_1.__exportStar(__webpack_require__(977), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Dropdown_base_1 = __webpack_require__(976);
	var Dropdown_styles_1 = __webpack_require__(985);
	exports.Dropdown = Utilities_1.styled(Dropdown_base_1.DropdownBase, Dropdown_styles_1.getStyles, undefined, {
	    scope: 'Dropdown'
	});
	//# sourceMappingURL=Dropdown.js.map

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Callout_1 = __webpack_require__(603);
	var Checkbox_1 = __webpack_require__(762);
	var Button_1 = __webpack_require__(691);
	var DirectionalHint_1 = __webpack_require__(608);
	var Dropdown_types_1 = __webpack_require__(977);
	var DropdownSizePosCache_1 = __webpack_require__(978);
	var FocusZone_1 = __webpack_require__(676);
	var Icon_1 = __webpack_require__(643);
	var Label_1 = __webpack_require__(771);
	var KeytipData_1 = __webpack_require__(684);
	var Panel_1 = __webpack_require__(979);
	var withResponsiveMode_1 = __webpack_require__(701);
	var index_1 = __webpack_require__(842);
	var getClassNames = Utilities_1.classNamesFunction();
	var DropdownBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DropdownBase, _super);
	    function DropdownBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._host = React.createRef();
	        _this._focusZone = React.createRef();
	        _this._dropDown = React.createRef();
	        _this._scrollIdleDelay = 250 /* ms */;
	        _this._sizePosCache = new DropdownSizePosCache_1.DropdownSizePosCache();
	        _this._requestAnimationFrame = Utilities_1.safeRequestAnimationFrame(_this);
	        _this._onChange = function (event, options, index, checked, multiSelect) {
	            var _a = _this.props, onChange = _a.onChange, onChanged = _a.onChanged;
	            if (onChange) {
	                // for single-select, option passed in will always be selected.
	                // for multi-select, flip the checked value
	                var changedOpt = multiSelect ? tslib_1.__assign({}, options[index], { selected: !checked }) : options[index];
	                onChange(tslib_1.__assign({}, event, { target: _this._dropDown.current }), changedOpt, index);
	            }
	            if (onChanged) {
	                // for single-select, option passed in will always be selected.
	                // for multi-select, flip the checked value
	                var changedOpt = multiSelect ? tslib_1.__assign({}, options[index], { selected: !checked }) : options[index];
	                onChanged(changedOpt, index);
	            }
	        };
	        /** Render text in dropdown input */
	        _this._onRenderTitle = function (items) {
	            var _a = _this.props.multiSelectDelimiter, multiSelectDelimiter = _a === void 0 ? ', ' : _a;
	            var displayTxt = items.map(function (i) { return i.text; }).join(multiSelectDelimiter);
	            return React.createElement("span", null, displayTxt);
	        };
	        /** Render placeholder text in dropdown input */
	        _this._onRenderPlaceholder = function (props) {
	            if (!_this._placeholder) {
	                return null;
	            }
	            return React.createElement("span", null, _this._placeholder);
	        };
	        /** Render Callout or Panel container and pass in list */
	        _this._onRenderContainer = function (props) {
	            var calloutProps = props.calloutProps, panelProps = props.panelProps;
	            var _a = _this.props, responsiveMode = _a.responsiveMode, dropdownWidth = _a.dropdownWidth;
	            var isSmall = responsiveMode <= withResponsiveMode_1.ResponsiveMode.medium;
	            var panelStyles = _this._classNames.subComponentStyles
	                ? _this._classNames.subComponentStyles.panel
	                : undefined;
	            return isSmall ? (React.createElement(Panel_1.Panel, tslib_1.__assign({ isOpen: true, isLightDismiss: true, onDismissed: _this._onDismiss, hasCloseButton: false, styles: panelStyles }, panelProps), _this._renderFocusableList(props))) : (React.createElement(Callout_1.Callout, tslib_1.__assign({ isBeakVisible: false, gapSpace: 0, doNotLayer: false, directionalHintFixed: false, directionalHint: DirectionalHint_1.DirectionalHint.bottomLeftEdge }, calloutProps, { className: _this._classNames.callout, target: _this._dropDown.current, onDismiss: _this._onDismiss, onScroll: _this._onScroll, onPositioned: _this._onPositioned, calloutWidth: dropdownWidth || (_this._dropDown.current ? _this._dropDown.current.clientWidth : 0) }), _this._renderFocusableList(props)));
	        };
	        /** Render Caret Down Icon */
	        _this._onRenderCaretDown = function (props) {
	            return React.createElement(Icon_1.Icon, { className: _this._classNames.caretDown, iconName: "ChevronDown", "aria-hidden": true });
	        };
	        /** Render List of items */
	        _this._onRenderList = function (props) {
	            var _a = props.onRenderItem, onRenderItem = _a === void 0 ? _this._onRenderItem : _a;
	            return React.createElement(React.Fragment, null, props.options.map(function (item, index) { return onRenderItem(tslib_1.__assign({}, item, { index: index }), _this._onRenderItem); }));
	        };
	        _this._onRenderItem = function (item) {
	            switch (item.itemType) {
	                case index_1.SelectableOptionMenuItemType.Divider:
	                    return _this._renderSeparator(item);
	                case index_1.SelectableOptionMenuItemType.Header:
	                    return _this._renderHeader(item);
	                default:
	                    return _this._renderOption(item);
	            }
	        };
	        _this._renderOption = function (item) {
	            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOption : _a;
	            var _b = _this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
	            var id = _this._id;
	            var isItemSelected = item.index !== undefined && selectedIndices ? selectedIndices.indexOf(item.index) > -1 : false;
	            // select the right className based on the combination of selected/disabled
	            var itemClassName = item.hidden // predicate: item hidden
	                ? _this._classNames.dropdownItemHidden
	                : isItemSelected && item.disabled === true // predicate: both selected and disabled
	                    ? _this._classNames.dropdownItemSelectedAndDisabled
	                    : isItemSelected // predicate: selected only
	                        ? _this._classNames.dropdownItemSelected
	                        : item.disabled === true // predicate: disabled only
	                            ? _this._classNames.dropdownItemDisabled
	                            : _this._classNames.dropdownItem;
	            return !_this.props.multiSelect ? (React.createElement(Button_1.CommandButton, { id: id + '-list' + item.index, key: item.key, "data-index": item.index, "data-is-focusable": !item.disabled, disabled: item.disabled, className: itemClassName, onClick: _this._onItemClick(item), onMouseEnter: _this._onItemMouseEnter.bind(_this, item), onMouseLeave: _this._onMouseItemLeave.bind(_this, item), onMouseMove: _this._onItemMouseMove.bind(_this, item), role: "option", "aria-selected": isItemSelected ? 'true' : 'false', ariaLabel: item.ariaLabel, title: item.title ? item.title : item.text }, onRenderOption(item, _this._onRenderOption))) : (React.createElement(Checkbox_1.Checkbox, { id: id + '-list' + item.index, key: item.key, "data-index": item.index, "data-is-focusable": !item.disabled, disabled: item.disabled, onChange: _this._onItemClick(item), inputProps: {
	                    onMouseEnter: _this._onItemMouseEnter.bind(_this, item),
	                    onMouseLeave: _this._onMouseItemLeave.bind(_this, item),
	                    onMouseMove: _this._onItemMouseMove.bind(_this, item)
	                }, label: item.text, title: item.title ? item.title : item.text, onRenderLabel: _this._onRenderLabel.bind(_this, item), className: itemClassName, role: "option", "aria-selected": isItemSelected ? 'true' : 'false', checked: isItemSelected }));
	        };
	        /** Render content of item (i.e. text/icon inside of button) */
	        _this._onRenderOption = function (item) {
	            return React.createElement("span", { className: _this._classNames.dropdownOptionText }, item.text);
	        };
	        /** Render custom label for drop down item */
	        _this._onRenderLabel = function (item) {
	            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOption : _a;
	            return onRenderOption(item, _this._onRenderOption);
	        };
	        _this._onPositioned = function (positions) {
	            if (_this._focusZone.current) {
	                // Focusing an element can trigger a reflow. Making this wait until there is an animation
	                // frame can improve perf significantly.
	                _this._requestAnimationFrame(function () {
	                    var selectedIndices = _this.state.selectedIndices;
	                    if (selectedIndices && selectedIndices[0] && !_this.props.options[selectedIndices[0]].disabled) {
	                        var element = Utilities_1.getDocument().querySelector("#" + _this._id + "-list" + selectedIndices[0]);
	                        _this._focusZone.current.focusElement(element);
	                    }
	                    else {
	                        _this._focusZone.current.focus();
	                    }
	                });
	            }
	            if (!_this.state.calloutRenderEdge || _this.state.calloutRenderEdge !== positions.targetEdge) {
	                _this.setState({
	                    calloutRenderEdge: positions.targetEdge
	                });
	            }
	        };
	        _this._onItemClick = function (item) {
	            return function (event) {
	                if (!item.disabled) {
	                    _this.setSelectedIndex(event, item.index);
	                    if (!_this.props.multiSelect) {
	                        // only close the callout when it's in single-select mode
	                        _this.setState({
	                            isOpen: false
	                        });
	                    }
	                }
	            };
	        };
	        /**
	         * Scroll handler for the callout to make sure the mouse events
	         * for updating focus are not interacting during scroll
	         */
	        _this._onScroll = function () {
	            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
	                clearTimeout(_this._scrollIdleTimeoutId);
	                _this._scrollIdleTimeoutId = undefined;
	            }
	            else {
	                _this._isScrollIdle = false;
	            }
	            _this._scrollIdleTimeoutId = setTimeout(function () {
	                _this._isScrollIdle = true;
	            }, _this._scrollIdleDelay);
	        };
	        _this._onMouseItemLeave = function (item, ev) {
	            if (_this._shouldIgnoreMouseEvent()) {
	                return;
	            }
	            /**
	             * IE11 focus() method forces parents to scroll to top of element.
	             * Edge and IE expose a setActive() function for focusable divs that
	             * sets the page focus but does not scroll the parent element.
	             */
	            if (_this._host.current) {
	                if (_this._host.current.setActive) {
	                    try {
	                        _this._host.current.setActive();
	                    }
	                    catch (e) {
	                        /* no-op */
	                    }
	                }
	                else {
	                    _this._host.current.focus();
	                }
	            }
	        };
	        _this._onDismiss = function () {
	            _this.setState({ isOpen: false });
	            if (_this._dropDown.current) {
	                _this._dropDown.current.focus();
	            }
	        };
	        _this._onDropdownBlur = function (ev) {
	            // If Dropdown disabled do not proceed with this logic.
	            var disabled = _this._isDisabled();
	            if (disabled) {
	                return;
	            }
	            // hasFocus tracks whether the root element has focus so always update the state.
	            _this.setState({ hasFocus: false });
	            if (_this.state.isOpen) {
	                // Do not onBlur when the callout is opened
	                return;
	            }
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	        };
	        _this._onDropdownKeyDown = function (ev) {
	            // If Dropdown disabled do not process any keyboard events.
	            var disabled = _this._isDisabled();
	            if (disabled) {
	                return;
	            }
	            // Take note if we are processing an alt (option) or meta (command) keydown.
	            // See comment in _shouldHandleKeyUp for reasoning.
	            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
	            if (_this.props.onKeyDown) {
	                _this.props.onKeyDown(ev);
	                if (ev.defaultPrevented) {
	                    return;
	                }
	            }
	            var newIndex;
	            var selectedIndex = _this.state.selectedIndices.length ? _this.state.selectedIndices[0] : -1;
	            var containsExpandCollapseModifier = ev.altKey || ev.metaKey;
	            var isOpen = _this.state.isOpen;
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.enter:
	                    _this.setState({
	                        isOpen: !isOpen
	                    });
	                    break;
	                case Utilities_1.KeyCodes.escape:
	                    if (!isOpen) {
	                        return;
	                    }
	                    _this.setState({
	                        isOpen: false
	                    });
	                    break;
	                case Utilities_1.KeyCodes.up:
	                    if (containsExpandCollapseModifier) {
	                        if (isOpen) {
	                            _this.setState({ isOpen: false });
	                            break;
	                        }
	                        return;
	                    }
	                    if (_this.props.multiSelect) {
	                        _this.setState({ isOpen: true });
	                    }
	                    else if (!_this._isDisabled()) {
	                        newIndex = _this._moveIndex(ev, -1, selectedIndex - 1, selectedIndex);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    if (containsExpandCollapseModifier) {
	                        ev.stopPropagation();
	                        ev.preventDefault();
	                    }
	                    if ((containsExpandCollapseModifier && !isOpen) || _this.props.multiSelect) {
	                        _this.setState({ isOpen: true });
	                    }
	                    else if (!_this._isDisabled()) {
	                        newIndex = _this._moveIndex(ev, 1, selectedIndex + 1, selectedIndex);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.home:
	                    if (!_this.props.multiSelect) {
	                        newIndex = _this._moveIndex(ev, 1, 0, selectedIndex);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.end:
	                    if (!_this.props.multiSelect) {
	                        newIndex = _this._moveIndex(ev, -1, _this.props.options.length - 1, selectedIndex);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.space:
	                    // event handled in _onDropdownKeyUp
	                    break;
	                default:
	                    return;
	            }
	            if (newIndex !== selectedIndex) {
	                ev.stopPropagation();
	                ev.preventDefault();
	            }
	        };
	        _this._onDropdownKeyUp = function (ev) {
	            // If Dropdown disabled do not process any keyboard events.
	            var disabled = _this._isDisabled();
	            if (disabled) {
	                return;
	            }
	            var shouldHandleKey = _this._shouldHandleKeyUp(ev);
	            var isOpen = _this.state.isOpen;
	            if (_this.props.onKeyUp) {
	                _this.props.onKeyUp(ev);
	                if (ev.preventDefault) {
	                    return;
	                }
	            }
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.space:
	                    _this.setState({
	                        isOpen: !isOpen
	                    });
	                    break;
	                default:
	                    if (shouldHandleKey && isOpen) {
	                        _this.setState({ isOpen: false });
	                    }
	                    return;
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        _this._onZoneKeyDown = function (ev) {
	            var elementToFocus;
	            // Take note if we are processing an alt (option) or meta (command) keydown.
	            // See comment in _shouldHandleKeyUp for reasoning.
	            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
	            var containsExpandCollapseModifier = ev.altKey || ev.metaKey;
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.up:
	                    if (containsExpandCollapseModifier) {
	                        _this.setState({ isOpen: false });
	                    }
	                    else {
	                        if (_this._host.current) {
	                            elementToFocus = Utilities_1.getLastFocusable(_this._host.current, _this._host.current.lastChild, true);
	                        }
	                    }
	                    break;
	                // All directional keystrokes should be canceled when the zone is rendered.
	                // This avoids the body scroll from reacting and thus dismissing the dropdown.
	                case Utilities_1.KeyCodes.home:
	                case Utilities_1.KeyCodes.end:
	                case Utilities_1.KeyCodes.pageUp:
	                case Utilities_1.KeyCodes.pageDown:
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    if (!containsExpandCollapseModifier && _this._host.current) {
	                        elementToFocus = Utilities_1.getFirstFocusable(_this._host.current, _this._host.current.firstChild, true);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.escape:
	                    _this.setState({ isOpen: false });
	                    break;
	                case Utilities_1.KeyCodes.tab:
	                    _this.setState({ isOpen: false });
	                    return;
	                default:
	                    return;
	            }
	            if (elementToFocus) {
	                elementToFocus.focus();
	            }
	            ev.stopPropagation();
	            ev.preventDefault();
	        };
	        _this._onZoneKeyUp = function (ev) {
	            var shouldHandleKey = _this._shouldHandleKeyUp(ev);
	            if (shouldHandleKey && _this.state.isOpen) {
	                _this.setState({ isOpen: false });
	                ev.preventDefault();
	            }
	        };
	        _this._onDropdownClick = function (ev) {
	            if (_this.props.onClick) {
	                _this.props.onClick(ev);
	                if (ev.preventDefault) {
	                    return;
	                }
	            }
	            var isOpen = _this.state.isOpen;
	            var disabled = _this._isDisabled();
	            if (!disabled && !_this._shouldOpenOnFocus()) {
	                _this.setState({
	                    isOpen: !isOpen
	                });
	            }
	            _this._isFocusedByClick = false; // reset
	        };
	        _this._onDropdownMouseDown = function () {
	            _this._isFocusedByClick = true;
	        };
	        _this._onFocus = function (ev) {
	            var _a = _this.state, isOpen = _a.isOpen, selectedIndices = _a.selectedIndices;
	            var multiSelect = _this.props.multiSelect;
	            var disabled = _this._isDisabled();
	            if (!disabled) {
	                if (!_this._isFocusedByClick && !isOpen && selectedIndices.length === 0 && !multiSelect) {
	                    // Per aria: https://www.w3.org/TR/wai-aria-practices-1.1/#listbox_kbd_interaction
	                    _this._moveIndex(ev, 1, 0, -1);
	                }
	                if (_this.props.onFocus) {
	                    _this.props.onFocus(ev);
	                }
	                var state = { hasFocus: true };
	                if (_this._shouldOpenOnFocus()) {
	                    state.isOpen = true;
	                }
	                _this.setState(state);
	            }
	        };
	        /**
	         * Because the isDisabled prop is deprecated, we have had to repeat this logic all over the place.
	         * This helper method avoids all the repetition.
	         */
	        _this._isDisabled = function () {
	            var disabled = _this.props.disabled;
	            var isDisabled = _this.props.isDisabled;
	            // Remove this deprecation workaround at 1.0.0
	            if (isDisabled !== undefined) {
	                disabled = isDisabled;
	            }
	            return disabled;
	        };
	        Utilities_1.initializeComponentRef(_this);
	        if (false) {
	            Utilities_1.warnDeprecations('Dropdown', props, {
	                isDisabled: 'disabled',
	                onChanged: 'onChange',
	                placeHolder: 'placeholder',
	                onRenderPlaceHolder: 'onRenderPlaceholder'
	            });
	            Utilities_1.warnMutuallyExclusive('Dropdown', props, {
	                defaultSelectedKey: 'selectedKey',
	                defaultSelectedKeys: 'selectedKeys',
	                selectedKeys: 'selectedKey',
	                multiSelect: 'defaultSelectedKey',
	                selectedKey: 'multiSelect'
	            });
	        }
	        _this._id = props.id || Utilities_1.getId('Dropdown');
	        _this._isScrollIdle = true;
	        var selectedIndices;
	        if (_this.props.multiSelect) {
	            var selectedKeys = props.defaultSelectedKeys !== undefined ? props.defaultSelectedKeys : props.selectedKeys;
	            selectedIndices = _this._getSelectedIndexes(props.options, selectedKeys);
	        }
	        else {
	            var selectedKey = props.defaultSelectedKey !== undefined ? props.defaultSelectedKey : props.selectedKey;
	            selectedIndices = _this._getSelectedIndexes(props.options, selectedKey);
	            _this._sizePosCache.updateOptions(props.options);
	        }
	        _this.state = {
	            isOpen: false,
	            selectedIndices: selectedIndices,
	            hasFocus: false,
	            calloutRenderEdge: undefined
	        };
	        return _this;
	    }
	    Object.defineProperty(DropdownBase.prototype, "selectedOptions", {
	        /**
	         * All selected options
	         */
	        get: function () {
	            var options = this.props.options;
	            var selectedIndices = this.state.selectedIndices;
	            return index_1.getAllSelectedOptions(options, selectedIndices);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownBase.prototype.componentWillUnmount = function () {
	        clearTimeout(this._scrollIdleTimeoutId);
	    };
	    DropdownBase.prototype.componentWillReceiveProps = function (newProps) {
	        // In controlled component usage where selectedKey is provided, update the selectedIndex
	        // state if the key or options change.
	        var selectedKeyProp;
	        // this does a shallow compare (assumes options are pure), for the purposes of determining whether
	        // defaultSelectedKey/defaultSelectedKeys are respected.
	        var didOptionsChange = newProps.options !== this.props.options;
	        if (newProps.multiSelect) {
	            if (didOptionsChange && newProps.defaultSelectedKeys !== undefined) {
	                selectedKeyProp = 'defaultSelectedKeys';
	            }
	            else {
	                selectedKeyProp = 'selectedKeys';
	            }
	        }
	        else {
	            if (didOptionsChange && newProps.defaultSelectedKey !== undefined) {
	                selectedKeyProp = 'defaultSelectedKey';
	            }
	            else {
	                selectedKeyProp = 'selectedKey';
	            }
	        }
	        if (newProps[selectedKeyProp] !== undefined && (newProps[selectedKeyProp] !== this.props[selectedKeyProp] || didOptionsChange)) {
	            this.setState({
	                selectedIndices: this._getSelectedIndexes(newProps.options, newProps[selectedKeyProp])
	            });
	        }
	        if (newProps.options !== this.props.options && // preexisting code assumes purity of the options...
	            !newProps.multiSelect // only relevant in single selection
	        ) {
	            this._sizePosCache.updateOptions(newProps.options);
	        }
	    };
	    DropdownBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (prevState.isOpen === true && this.state.isOpen === false) {
	            this._gotMouseMove = false;
	            if (this._dropDown.current) {
	                this._dropDown.current.focus();
	            }
	            if (this.props.onDismiss) {
	                this.props.onDismiss();
	            }
	        }
	    };
	    DropdownBase.prototype.render = function () {
	        var _this = this;
	        var id = this._id;
	        var props = this.props;
	        var className = props.className, label = props.label, options = props.options, ariaLabel = props.ariaLabel, required = props.required, errorMessage = props.errorMessage, multiSelect = props.multiSelect, keytipProps = props.keytipProps, propStyles = props.styles, theme = props.theme, panelProps = props.panelProps, calloutProps = props.calloutProps, _a = props.onRenderTitle, onRenderTitle = _a === void 0 ? this._onRenderTitle : _a, _b = props.onRenderContainer, onRenderContainer = _b === void 0 ? this._onRenderContainer : _b, _c = props.onRenderCaretDown, onRenderCaretDown = _c === void 0 ? this._onRenderCaretDown : _c;
	        var _d = this.state, isOpen = _d.isOpen, selectedIndices = _d.selectedIndices, hasFocus = _d.hasFocus, calloutRenderEdge = _d.calloutRenderEdge;
	        var onRenderPlaceholder = props.onRenderPlaceholder || props.onRenderPlaceHolder || this._onRenderPlaceholder;
	        var selectedOptions = index_1.getAllSelectedOptions(options, selectedIndices);
	        var divProps = Utilities_1.getNativeProps(props, Utilities_1.divProperties);
	        var disabled = this._isDisabled();
	        var optionId = id + '-option';
	        var ariaAttrs = multiSelect || disabled
	            ? {
	                role: undefined,
	                ariaActiveDescendant: undefined,
	                childRole: undefined,
	                ariaSetSize: undefined,
	                ariaPosInSet: undefined,
	                ariaSelected: undefined
	            }
	            : // single select
	                {
	                    role: 'listbox',
	                    ariaActiveDescendant: isOpen && selectedIndices.length === 1 && selectedIndices[0] >= 0 ? this._id + '-list' + selectedIndices[0] : optionId,
	                    childRole: 'option',
	                    ariaSetSize: this._sizePosCache.optionSetSize,
	                    ariaPosInSet: this._sizePosCache.positionInSet(selectedIndices[0]),
	                    ariaSelected: selectedIndices[0] === undefined ? undefined : true
	                };
	        this._classNames = getClassNames(propStyles, {
	            theme: theme,
	            className: className,
	            hasError: !!(errorMessage && errorMessage.length > 0),
	            hasLabel: !!label,
	            isOpen: isOpen,
	            required: required,
	            disabled: disabled,
	            isRenderingPlaceholder: !selectedOptions.length,
	            panelClassName: !!panelProps ? panelProps.className : undefined,
	            calloutClassName: !!calloutProps ? calloutProps.className : undefined,
	            calloutRenderEdge: calloutRenderEdge
	        });
	        var labelStyles = this._classNames.subComponentStyles
	            ? this._classNames.subComponentStyles.label
	            : undefined;
	        var hasErrorMessage = !!errorMessage && errorMessage.length > 0;
	        return (React.createElement("div", { className: this._classNames.root },
	            label && (React.createElement(Label_1.Label, { className: this._classNames.label, id: id + '-label', htmlFor: id, required: required, styles: labelStyles }, label)),
	            React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (React.createElement("div", tslib_1.__assign({}, keytipAttributes, { "data-is-focusable": !disabled, ref: _this._dropDown, id: id, tabIndex: disabled ? -1 : 0, "aria-expanded": isOpen ? 'true' : 'false', role: ariaAttrs.role, "aria-label": ariaLabel, "aria-labelledby": label && !ariaLabel ? id + '-label' : undefined, "aria-describedby": Utilities_1.mergeAriaAttributeValues(optionId, keytipAttributes['aria-describedby']), "aria-activedescendant": isOpen ? ariaAttrs.ariaActiveDescendant : undefined, "aria-required": required, "aria-disabled": disabled, "aria-owns": isOpen ? id + '-list' : undefined }, divProps, { className: _this._classNames.dropdown, onBlur: _this._onDropdownBlur, onKeyDown: _this._onDropdownKeyDown, onKeyUp: _this._onDropdownKeyUp, onClick: _this._onDropdownClick, onFocus: _this._onFocus, onMouseDown: _this._onDropdownMouseDown }),
	                React.createElement("span", { id: optionId, className: _this._classNames.title, "aria-atomic": true, role: ariaAttrs.childRole, "aria-live": !hasFocus || disabled || multiSelect || isOpen ? 'off' : 'assertive', "aria-label": selectedOptions.length ? selectedOptions[0].text : _this._placeholder, "aria-invalid": hasErrorMessage, "aria-setsize": ariaAttrs.ariaSetSize, "aria-posinset": ariaAttrs.ariaPosInSet, "aria-selected": ariaAttrs.ariaSelected, "aria-describedby": Utilities_1.mergeAriaAttributeValues(hasErrorMessage && id + '-errorMessage') }, // If option is selected render title, otherwise render the placeholder text
	                selectedOptions.length
	                    ? onRenderTitle(selectedOptions, _this._onRenderTitle)
	                    : onRenderPlaceholder(props, _this._onRenderPlaceholder)),
	                React.createElement("span", { className: _this._classNames.caretDownWrapper }, onRenderCaretDown(props, _this._onRenderCaretDown)))); }),
	            isOpen && onRenderContainer(props, this._onRenderContainer),
	            hasErrorMessage && (React.createElement("div", { id: id + '-errorMessage', className: this._classNames.errorMessage }, errorMessage))));
	    };
	    DropdownBase.prototype.focus = function (shouldOpenOnFocus) {
	        if (this._dropDown.current && this._dropDown.current.tabIndex !== -1) {
	            this._dropDown.current.focus();
	            if (shouldOpenOnFocus) {
	                this.setState({
	                    isOpen: true
	                });
	            }
	        }
	    };
	    DropdownBase.prototype.setSelectedIndex = function (event, index) {
	        var _this = this;
	        var _a = this.props, options = _a.options, selectedKey = _a.selectedKey, selectedKeys = _a.selectedKeys, multiSelect = _a.multiSelect, notifyOnReselect = _a.notifyOnReselect;
	        var _b = this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
	        var checked = selectedIndices ? selectedIndices.indexOf(index) > -1 : false;
	        var newIndexes = [];
	        index = Math.max(0, Math.min(options.length - 1, index));
	        // If this is a controlled component then no state change should take place.
	        if (selectedKey !== undefined || selectedKeys !== undefined) {
	            this._onChange(event, options, index, checked, multiSelect);
	            return;
	        }
	        if (!multiSelect && !notifyOnReselect && index === selectedIndices[0]) {
	            return;
	        }
	        else if (multiSelect) {
	            newIndexes = selectedIndices ? this._copyArray(selectedIndices) : [];
	            if (checked) {
	                var position = newIndexes.indexOf(index);
	                if (position > -1) {
	                    // unchecked the current one
	                    newIndexes.splice(position, 1);
	                }
	            }
	            else {
	                // add the new selected index into the existing one
	                newIndexes.push(index);
	            }
	        }
	        else {
	            // Set the selected option if this is an uncontrolled component
	            newIndexes = [index];
	        }
	        event.persist();
	        // Call onChange after state is updated
	        this.setState({
	            selectedIndices: newIndexes
	        }, function () {
	            _this._onChange(event, options, index, checked, multiSelect);
	        });
	    };
	    Object.defineProperty(DropdownBase.prototype, "_placeholder", {
	        /** Get either props.placeholder (new name) or props.placeHolder (old name) */
	        get: function () {
	            return this.props.placeholder || this.props.placeHolder;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownBase.prototype._copyArray = function (array) {
	        var newArray = [];
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var element = array_1[_i];
	            newArray.push(element);
	        }
	        return newArray;
	    };
	    /**
	     * Finds the next valid Dropdown option and sets the selected index to it.
	     * @param stepValue - Value of how many items the function should traverse.  Should be -1 or 1.
	     * @param index - Index of where the search should start
	     * @param selectedIndex - The selectedIndex Dropdown's state
	     * @returns The next valid dropdown option's index
	     */
	    DropdownBase.prototype._moveIndex = function (event, stepValue, index, selectedIndex) {
	        var options = this.props.options;
	        // Return selectedIndex if nothing has changed or options is empty
	        if (selectedIndex === index || options.length === 0) {
	            return selectedIndex;
	        }
	        // Set starting index to 0 if index is < 0
	        if (index < 0) {
	            index = 0;
	        }
	        // Set starting index to last option index if greater than options.length
	        if (index >= options.length) {
	            index = options.length - 1;
	        }
	        var stepCounter = 0;
	        // If current index is a header or divider, or disabled, increment by step
	        while (options[index].itemType === Dropdown_types_1.DropdownMenuItemType.Header ||
	            options[index].itemType === Dropdown_types_1.DropdownMenuItemType.Divider ||
	            options[index].disabled) {
	            // If stepCounter exceeds length of options, then return selectedIndex (-1)
	            if (stepCounter >= options.length) {
	                return selectedIndex;
	            }
	            // If index + stepValue is out of bounds, wrap around
	            if (index + stepValue < 0) {
	                index = options.length;
	            }
	            else if (index + stepValue >= options.length) {
	                index = -1;
	            }
	            index = index + stepValue;
	            stepCounter++;
	        }
	        this.setSelectedIndex(event, index);
	        return index;
	    };
	    /** Wrap item list in a FocusZone */
	    DropdownBase.prototype._renderFocusableList = function (props) {
	        var _a = props.onRenderList, onRenderList = _a === void 0 ? this._onRenderList : _a, label = props.label, ariaLabel = props.ariaLabel;
	        var id = this._id;
	        return (React.createElement("div", { className: this._classNames.dropdownItemsWrapper, onKeyDown: this._onZoneKeyDown, onKeyUp: this._onZoneKeyUp, ref: this._host, tabIndex: 0 },
	            React.createElement(FocusZone_1.FocusZone, { ref: this._focusZone, direction: FocusZone_1.FocusZoneDirection.vertical, id: id + '-list', className: this._classNames.dropdownItems, "aria-label": ariaLabel, "aria-labelledby": label && !ariaLabel ? id + '-label' : undefined, role: "listbox" }, onRenderList(props, this._onRenderList))));
	    };
	    DropdownBase.prototype._renderSeparator = function (item) {
	        var index = item.index, key = item.key;
	        if (index > 0) {
	            return React.createElement("div", { role: "separator", key: key, className: this._classNames.dropdownDivider });
	        }
	        return null;
	    };
	    DropdownBase.prototype._renderHeader = function (item) {
	        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOption : _a;
	        var key = item.key;
	        return (React.createElement("div", { key: key, className: this._classNames.dropdownItemHeader }, onRenderOption(item, this._onRenderOption)));
	    };
	    DropdownBase.prototype._onItemMouseEnter = function (item, ev) {
	        if (this._shouldIgnoreMouseEvent()) {
	            return;
	        }
	        var targetElement = ev.currentTarget;
	        targetElement.focus();
	    };
	    DropdownBase.prototype._onItemMouseMove = function (item, ev) {
	        var targetElement = ev.currentTarget;
	        this._gotMouseMove = true;
	        if (!this._isScrollIdle || document.activeElement === targetElement) {
	            return;
	        }
	        targetElement.focus();
	    };
	    DropdownBase.prototype._shouldIgnoreMouseEvent = function () {
	        return !this._isScrollIdle || !this._gotMouseMove;
	    };
	    /** Get all selected indexes for multi-select mode */
	    DropdownBase.prototype._getSelectedIndexes = function (options, selectedKey) {
	        if (selectedKey === undefined) {
	            if (this.props.multiSelect) {
	                return this._getAllSelectedIndices(options);
	            }
	            var selectedIndex = this._getSelectedIndex(options, null);
	            return selectedIndex !== -1 ? [selectedIndex] : [];
	        }
	        else if (!Array.isArray(selectedKey)) {
	            var selectedIndex = this._getSelectedIndex(options, selectedKey);
	            return selectedIndex !== -1 ? [selectedIndex] : [];
	        }
	        var selectedIndices = [];
	        for (var _i = 0, selectedKey_1 = selectedKey; _i < selectedKey_1.length; _i++) {
	            var key = selectedKey_1[_i];
	            var selectedIndex = this._getSelectedIndex(options, key);
	            selectedIndex !== -1 && selectedIndices.push(selectedIndex);
	        }
	        return selectedIndices;
	    };
	    DropdownBase.prototype._getAllSelectedIndices = function (options) {
	        return options.map(function (option, index) { return (option.selected ? index : -1); }).filter(function (index) { return index !== -1; });
	    };
	    DropdownBase.prototype._getSelectedIndex = function (options, selectedKey) {
	        return Utilities_1.findIndex(options, function (option) {
	            // tslint:disable-next-line:triple-equals
	            if (selectedKey != null) {
	                return option.key === selectedKey;
	            }
	            else {
	                return !!option.isSelected || !!option.selected;
	            }
	        });
	    };
	    /**
	     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
	     */
	    DropdownBase.prototype._isAltOrMeta = function (ev) {
	        return ev.which === Utilities_1.KeyCodes.alt || ev.key === 'Meta';
	    };
	    /**
	     * We close the menu on key up only if ALL of the following are true:
	     * - Most recent key down was alt or meta (command)
	     * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
	     *   expand/collapse the menu)
	     * - We're not on a Mac (or iOS)
	     *
	     * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
	     * closing any open context menus. There is not a similar behavior on Macs.
	     */
	    DropdownBase.prototype._shouldHandleKeyUp = function (ev) {
	        var keyPressIsAltOrMetaAlone = this._lastKeyDownWasAltOrMeta && this._isAltOrMeta(ev);
	        this._lastKeyDownWasAltOrMeta = false;
	        return !!keyPressIsAltOrMetaAlone && !(Utilities_1.isMac() || Utilities_1.isIOS());
	    };
	    /**
	     * Returns true if dropdown should set to open on focus.
	     * Otherwise, isOpen state should be toggled on click
	     */
	    DropdownBase.prototype._shouldOpenOnFocus = function () {
	        var hasFocus = this.state.hasFocus;
	        var openOnKeyboardFocus = this.props.openOnKeyboardFocus;
	        return !this._isFocusedByClick && openOnKeyboardFocus === true && !hasFocus;
	    };
	    DropdownBase.defaultProps = {
	        options: []
	    };
	    DropdownBase = tslib_1.__decorate([
	        withResponsiveMode_1.withResponsiveMode
	    ], DropdownBase);
	    return DropdownBase;
	}(React.Component));
	exports.DropdownBase = DropdownBase;
	//# sourceMappingURL=Dropdown.base.js.map

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var withResponsiveMode_1 = __webpack_require__(701);
	exports.ResponsiveMode = withResponsiveMode_1.ResponsiveMode;
	var SelectableOption_types_1 = __webpack_require__(838);
	exports.DropdownMenuItemType = SelectableOption_types_1.SelectableOptionMenuItemType;
	//# sourceMappingURL=Dropdown.types.js.map

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Dropdown_types_1 = __webpack_require__(977);
	/**
	 * A utility class to cache size and position in cache.
	 *
	 * Dropdown options has non-selectable display types. It is therefore not cheap to determine
	 * the total number of actual selectable options as well as the position an option is in the
	 * list of options - O(n) cost for each lookup.
	 *
	 * Given that we potentially have to make this determination on every single render pass, this
	 * cache should provide a little bit of relief.
	 */
	var DropdownSizePosCache = /** @class */ (function () {
	    function DropdownSizePosCache() {
	        this._size = 0;
	    }
	    /**
	     * Invalidates the cache and recalculate the size of selectable options.
	     */
	    DropdownSizePosCache.prototype.updateOptions = function (options) {
	        var displayOnlyOptionsCache = [];
	        var size = 0;
	        for (var i = 0; i < options.length; i++) {
	            if (options[i].itemType === Dropdown_types_1.DropdownMenuItemType.Divider || options[i].itemType === Dropdown_types_1.DropdownMenuItemType.Header) {
	                displayOnlyOptionsCache.push(i);
	            }
	            else {
	                size++;
	            }
	        }
	        this._size = size;
	        this._displayOnlyOptionsCache = displayOnlyOptionsCache;
	    };
	    Object.defineProperty(DropdownSizePosCache.prototype, "optionSetSize", {
	        /**
	         * The size of all the selectable options.
	         */
	        get: function () {
	            return this._size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the position of this option element relative to the full set of selectable option elements.
	     * Note: the first selectable element is position 1 in the set.
	     * @param index The raw index of the option element.
	     */
	    DropdownSizePosCache.prototype.positionInSet = function (index) {
	        if (index === undefined) {
	            return undefined;
	        }
	        // we could possibly memoize this too but this should be good enough, most of the time (the expectation is that
	        // when you have a lot of options, the selectable options will heavily dominate over the non-selectable options.
	        var offset = 0;
	        while (index > this._displayOnlyOptionsCache[offset]) {
	            offset++;
	        }
	        if (this._displayOnlyOptionsCache[offset] === index) {
	            throw new Error("Unexpected: Option at index " + index + " is not a selectable element.");
	        }
	        return index - offset + 1;
	    };
	    return DropdownSizePosCache;
	}());
	exports.DropdownSizePosCache = DropdownSizePosCache;
	//# sourceMappingURL=DropdownSizePosCache.js.map

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(980), exports);
	//# sourceMappingURL=Panel.js.map

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(981), exports);
	tslib_1.__exportStar(__webpack_require__(983), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Panel_base_1 = __webpack_require__(982);
	var Panel_styles_1 = __webpack_require__(984);
	/**
	 * Panel description
	 */
	exports.Panel = Utilities_1.styled(Panel_base_1.PanelBase, Panel_styles_1.getStyles, undefined, {
	    scope: 'Panel'
	});
	//# sourceMappingURL=Panel.js.map

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Button_1 = __webpack_require__(691);
	var Layer_1 = __webpack_require__(617);
	var Overlay_1 = __webpack_require__(924);
	var Popup_1 = __webpack_require__(613);
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var index_1 = __webpack_require__(631);
	var Panel_types_1 = __webpack_require__(983);
	var getClassNames = Utilities_1.classNamesFunction();
	var PanelBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PanelBase, _super);
	    function PanelBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._panel = React.createRef();
	        _this.dismiss = function (ev) {
	            if (_this._isOpen) {
	                _this._isOpen = false;
	                if (_this.props.onDismiss) {
	                    _this.props.onDismiss(ev);
	                }
	                if (!ev || (ev && !ev.defaultPrevented)) {
	                    _this.setState({
	                        isAnimating: true
	                    }, function () {
	                        _this._async.setTimeout(_this._onTransitionComplete, 200);
	                    });
	                }
	            }
	        };
	        // Allow the user to scroll within the panel but not on the body
	        _this._allowScrollOnPanel = function (elt) {
	            if (elt) {
	                Utilities_1.allowScrollOnElement(elt, _this._events);
	            }
	            else {
	                _this._events.off(_this._scrollableContent);
	            }
	            _this._scrollableContent = elt;
	        };
	        _this._onRenderNavigation = function (props) {
	            if (!_this.props.onRenderNavigationContent && !_this.props.onRenderNavigation && !_this.props.hasCloseButton) {
	                return null;
	            }
	            var _a = _this.props.onRenderNavigationContent, onRenderNavigationContent = _a === void 0 ? _this._onRenderNavigationContent : _a;
	            return React.createElement("div", { className: _this._classNames.navigation }, onRenderNavigationContent(props, _this._onRenderNavigationContent));
	        };
	        _this._onRenderNavigationContent = function (props) {
	            var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton;
	            var theme = Styling_1.getTheme();
	            if (hasCloseButton) {
	                // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
	                // const iconButtonStyles = this._classNames.subComponentStyles
	                // ? (this._classNames.subComponentStyles.iconButton as IStyleFunctionOrObject<IButtonStyleProps, IButtonStyles>)
	                // : undefined;
	                return (React.createElement(Button_1.IconButton
	                // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
	                // className={iconButtonStyles}
	                , { 
	                    // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
	                    // className={iconButtonStyles}
	                    styles: {
	                        root: {
	                            height: 'auto',
	                            width: '44px',
	                            color: theme.palette.neutralSecondary,
	                            fontSize: Styling_1.IconFontSizes.large
	                        },
	                        rootHovered: {
	                            color: theme.palette.neutralPrimary
	                        }
	                    }, className: _this._classNames.closeButton, onClick: _this._onPanelClick, ariaLabel: closeButtonAriaLabel, title: closeButtonAriaLabel, "data-is-visible": true, iconProps: { iconName: 'Cancel' } }));
	            }
	            return null;
	        };
	        _this._onRenderHeader = function (props, defaultRender, headerTextId) {
	            var headerText = props.headerText;
	            if (headerText) {
	                return (React.createElement("div", { className: _this._classNames.header },
	                    React.createElement("p", { className: _this._classNames.headerText, id: headerTextId, role: "heading", "aria-level": 2 }, headerText)));
	            }
	            return null;
	        };
	        _this._onRenderBody = function (props) {
	            return React.createElement("div", { className: _this._classNames.content }, props.children);
	        };
	        _this._onRenderFooter = function (props) {
	            var _a = _this.props.onRenderFooterContent, onRenderFooterContent = _a === void 0 ? null : _a;
	            if (onRenderFooterContent) {
	                return (React.createElement("div", { className: _this._classNames.footer },
	                    React.createElement("div", { className: _this._classNames.footerInner }, onRenderFooterContent())));
	            }
	            return null;
	        };
	        _this._onPanelClick = function (ev) {
	            _this.dismiss(ev);
	        };
	        _this._onTransitionComplete = function () {
	            _this._updateFooterPosition();
	            _this.setState({
	                isAnimating: false
	            });
	            if (_this._isOpen && _this.props.onOpened) {
	                _this.props.onOpened();
	            }
	            if (!_this._isOpen && _this.props.onDismissed) {
	                _this.props.onDismissed();
	            }
	        };
	        _this._warnDeprecations({
	            ignoreExternalFocusing: 'focusTrapZoneProps',
	            forceFocusInsideTrap: 'focusTrapZoneProps',
	            firstFocusableSelector: 'focusTrapZoneProps'
	        });
	        _this._isOpen = !!props.isOpen;
	        _this.state = {
	            isFooterSticky: false,
	            isAnimating: false,
	            id: Utilities_1.getId('Panel')
	        };
	        return _this;
	    }
	    PanelBase.prototype.componentDidMount = function () {
	        this._events.on(window, 'resize', this._updateFooterPosition);
	        if (this._shouldListenForOuterClick(this.props)) {
	            this._events.on(document.body, 'mousedown', this._dismissOnOuterClick, true);
	        }
	        if (this.props.isOpen) {
	            this.open();
	        }
	    };
	    PanelBase.prototype.componentDidUpdate = function (previousProps) {
	        var shouldListenOnOuterClick = this._shouldListenForOuterClick(this.props);
	        var previousShouldListenOnOuterClick = this._shouldListenForOuterClick(previousProps);
	        if (shouldListenOnOuterClick && !previousShouldListenOnOuterClick) {
	            this._events.on(document.body, 'mousedown', this._dismissOnOuterClick, true);
	        }
	        else if (!shouldListenOnOuterClick && previousShouldListenOnOuterClick) {
	            this._events.off(document.body, 'mousedown', this._dismissOnOuterClick, true);
	        }
	    };
	    PanelBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.isOpen !== this._isOpen) {
	            if (newProps.isOpen) {
	                this.open();
	            }
	            else {
	                this.dismiss();
	            }
	        }
	    };
	    PanelBase.prototype.render = function () {
	        var _a = this.props, _b = _a.className, className = _b === void 0 ? '' : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, focusTrapZoneProps = _a.focusTrapZoneProps, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, _c = _a.headerClassName, headerClassName = _c === void 0 ? '' : _c, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isFooterAtBottom = _a.isFooterAtBottom, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, type = _a.type, styles = _a.styles, theme = _a.theme, customWidth = _a.customWidth, _d = _a.onLightDismissClick, onLightDismissClick = _d === void 0 ? this._onPanelClick : _d, _e = _a.onRenderNavigation, onRenderNavigation = _e === void 0 ? this._onRenderNavigation : _e, _f = _a.onRenderHeader, onRenderHeader = _f === void 0 ? this._onRenderHeader : _f, _g = _a.onRenderBody, onRenderBody = _g === void 0 ? this._onRenderBody : _g, _h = _a.onRenderFooter, onRenderFooter = _h === void 0 ? this._onRenderFooter : _h;
	        var _j = this.state, isFooterSticky = _j.isFooterSticky, isAnimating = _j.isAnimating, id = _j.id;
	        var isLeft = type === Panel_types_1.PanelType.smallFixedNear || type === Panel_types_1.PanelType.customNear ? true : false;
	        var isRTL = Utilities_1.getRTL();
	        var isOnRightSide = isRTL ? isLeft : !isLeft;
	        var headerTextId = headerText && id + '-headerText';
	        var customWidthStyles = type === Panel_types_1.PanelType.custom || type === Panel_types_1.PanelType.customNear ? { width: customWidth } : {};
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        var isOpen = this._isOpen;
	        if (!isOpen && !isAnimating && !isHiddenOnDismiss) {
	            return null;
	        }
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            focusTrapZoneClassName: focusTrapZoneProps ? focusTrapZoneProps.className : undefined,
	            hasCloseButton: hasCloseButton,
	            headerClassName: headerClassName,
	            isAnimating: isAnimating,
	            isFooterSticky: isFooterSticky,
	            isFooterAtBottom: isFooterAtBottom,
	            isOnRightSide: isOnRightSide,
	            isOpen: isOpen,
	            isHiddenOnDismiss: isHiddenOnDismiss,
	            type: type
	        });
	        var _classNames = this._classNames;
	        var overlay;
	        if (isBlocking && isOpen) {
	            overlay = React.createElement(Overlay_1.Overlay, { className: _classNames.overlay, isDarkThemed: false, onClick: isLightDismiss ? onLightDismissClick : undefined });
	        }
	        var header = onRenderHeader(this.props, this._onRenderHeader, headerTextId);
	        return (React.createElement(Layer_1.Layer, tslib_1.__assign({}, layerProps),
	            React.createElement(Popup_1.Popup, { role: "dialog", "aria-modal": "true", ariaLabelledBy: header ? headerTextId : undefined, onDismiss: this.dismiss, className: _classNames.hiddenPanel },
	                React.createElement("div", tslib_1.__assign({ "aria-hidden": !isOpen && isAnimating }, nativeProps, { ref: this._panel, className: _classNames.root }),
	                    overlay,
	                    React.createElement(index_1.FocusTrapZone, tslib_1.__assign({ ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: !isBlocking || (isHiddenOnDismiss && !isOpen) ? false : forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector, isClickableOutsideFocusTrap: true }, focusTrapZoneProps, { className: _classNames.main, style: customWidthStyles, elementToFocusOnDismiss: elementToFocusOnDismiss }),
	                        React.createElement("div", { className: _classNames.commands, "data-is-visible": true }, onRenderNavigation(this.props, this._onRenderNavigation)),
	                        React.createElement("div", { className: _classNames.contentInner },
	                            header,
	                            React.createElement("div", { ref: this._allowScrollOnPanel, className: _classNames.scrollableContent, "data-is-scrollable": true }, onRenderBody(this.props, this._onRenderBody)),
	                            onRenderFooter(this.props, this._onRenderFooter)))))));
	    };
	    PanelBase.prototype.open = function () {
	        var _this = this;
	        if (!this._isOpen) {
	            this._isOpen = true;
	            this.setState({
	                isAnimating: true
	            }, function () {
	                _this._async.setTimeout(_this._onTransitionComplete, 200);
	            });
	            if (this.props.onOpen) {
	                this.props.onOpen();
	            }
	        }
	    };
	    PanelBase.prototype._shouldListenForOuterClick = function (props) {
	        return !!props.isBlocking && !!props.isOpen;
	    };
	    PanelBase.prototype._updateFooterPosition = function () {
	        var scrollableContent = this._scrollableContent;
	        if (scrollableContent) {
	            var height = scrollableContent.clientHeight;
	            var innerHeight_1 = scrollableContent.scrollHeight;
	            this.setState({
	                isFooterSticky: height < innerHeight_1 ? true : false
	            });
	        }
	    };
	    PanelBase.prototype._dismissOnOuterClick = function (ev) {
	        var panel = this._panel.current;
	        if (this._isOpen && panel) {
	            if (!Utilities_1.elementContains(panel, ev.target)) {
	                if (this.props.onOuterClick) {
	                    this.props.onOuterClick();
	                    ev.preventDefault();
	                }
	                else {
	                    this.dismiss();
	                }
	            }
	        }
	    };
	    PanelBase.defaultProps = {
	        isHiddenOnDismiss: false,
	        isOpen: false,
	        isBlocking: true,
	        hasCloseButton: true,
	        type: Panel_types_1.PanelType.smallFixedFar
	    };
	    return PanelBase;
	}(Utilities_1.BaseComponent));
	exports.PanelBase = PanelBase;
	//# sourceMappingURL=Panel.base.js.map

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Panel}
	 */
	var PanelType;
	(function (PanelType) {
	    /**
	     * Renders the Panel with a `fluid` (full screen) width.
	     * Recommended for use on small screen breakpoints.
	     * - Small (320-479): full screen width, 16px left/right padding
	     * - Medium (480-639): full screen width, 16px left/right padding
	     * - Large (640-1023): full screen width, 32px left/right padding
	     * - XLarge (1024-1365): full screen width, 32px left/right padding
	     * - XXLarge (1366-up): full screen width, 40px left/right padding
	     */
	    PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
	    /**
	     * Renders the Panel in fixed-width `small` size, anchored to the far side (right in LTR mode).
	     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
	     * - Medium (480-639): 340px width, 16px left/right padding
	     * - Large (640-1023): 340px width, 32px left/right padding
	     * - XLarge (1024-1365): 340px width, 32px left/right padding
	     * - XXLarge (1366-up): 340px width, 40px left/right padding
	     */
	    PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
	    /**
	     * Renders the Panel in fixed-width `small` size, anchored to the near side (left in LTR mode).
	     * - Small (320-479): 272px width, 16px left/right padding
	     * - Medium (480-639): 272px width, 16px left/right padding
	     * - Large (640-1023): 272px width, 32px left/right padding
	     * - XLarge (1024-1365): 272px width, 32px left/right padding
	     * - XXLarge (1366-up): 272px width, 40px left/right padding
	     */
	    PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
	    /**
	     * Renders the Panel in `medium` size, anchored to the far side (right in LTR mode).
	     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
	     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
	     * - Large (640-1023): 592px width, 32px left/right padding
	     * - XLarge (1024-1365): 644px width, 32px left/right padding
	     * - XXLarge (1366-up): 644px width, 40px left/right padding
	     */
	    PanelType[PanelType["medium"] = 3] = "medium";
	    /**
	     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode).
	     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
	     * - Medium (480-639):  adapts to `PanelType.smallFixedFar` at this breakpoint
	     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
	     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
	     * - XXLarge (1366-up): 428px fixed left margin, fluid width, 40px left/right padding
	     */
	    PanelType[PanelType["large"] = 4] = "large";
	    /**
	     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode), with a fixed width at XX-Large breakpoint.
	     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
	     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
	     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
	     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
	     * - XXLarge (1366-up): 940px width, 40px left/right padding
	     */
	    PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
	    /**
	     * Renders the Panel in `extra large` size, anchored to the far side (right in LTR mode).
	     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
	     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
	     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
	     * - XLarge (1024-1365): adapts to `PanelType.large` at this breakpoint
	     * - XXLarge (1366-1919): 176px fixed left margin, fluid width, 40px left/right padding
	     * - XXXLarge (1920-up): 176px fixed left margin, fluid width, 40px left/right padding
	     */
	    PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
	    /**
	     * Renders the Panel in `custom` size using `customWidth`, anchored to the far side (right in LTR mode).
	     * - Has a fixed width provided by the `customWidth` prop
	     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
	     * taking up 100% of the viewport width
	     */
	    PanelType[PanelType["custom"] = 7] = "custom";
	    /**
	     * Renders the Panel in `custom` size using `customWidth`, anchored to the near side (left in LTR mode).
	     * - Has a fixed width provided by the `customWidth` prop
	     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
	     * taking up 100% of the viewport width
	     */
	    PanelType[PanelType["customNear"] = 8] = "customNear";
	})(PanelType = exports.PanelType || (exports.PanelType = {}));
	//# sourceMappingURL=Panel.types.js.map

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Panel_types_1 = __webpack_require__(983);
	var Styling_1 = __webpack_require__(463);
	// TODO -Issue #5689: Comment in once Button is converted to mergeStyles
	// import { IStyleFunctionOrObject } from '../../Utilities';
	// import { IButtonStyles, IButtonStyleProps } from '../../Button';
	var GlobalClassNames = {
	    root: 'ms-Panel',
	    main: 'ms-Panel-main',
	    commands: 'ms-Panel-commands',
	    contentInner: 'ms-Panel-contentInner',
	    scrollableContent: 'ms-Panel-scrollableContent',
	    navigation: 'ms-Panel-navigation',
	    closeButton: 'ms-Panel-closeButton ms-PanelAction-close',
	    header: 'ms-Panel-header',
	    headerText: 'ms-Panel-headerText',
	    content: 'ms-Panel-content',
	    footer: 'ms-Panel-footer',
	    footerInner: 'ms-Panel-footerInner',
	    isOpen: 'is-open',
	    hasCloseButton: 'ms-Panel--hasCloseButton',
	    smallFluid: 'ms-Panel--smFluid',
	    smallFixedNear: 'ms-Panel--smLeft',
	    smallFixedFar: 'ms-Panel--sm',
	    medium: 'ms-Panel--md',
	    large: 'ms-Panel--lg',
	    largeFixed: 'ms-Panel--fixed',
	    extraLarge: 'ms-Panel--xl',
	    custom: 'ms-Panel--custom',
	    customNear: 'ms-Panel--customLeft'
	};
	var panelWidth = {
	    full: '100%',
	    auto: 'auto',
	    xs: 272,
	    sm: 340,
	    md1: 592,
	    md2: 644,
	    lg: 940
	};
	var panelMargin = {
	    auto: 'auto',
	    none: 0,
	    md: 48,
	    lg: 428,
	    xl: 176
	};
	// Following consts are used below in `getPanelBreakpoints()` function to provide
	// necessary fallbacks for different types of Panel in different breakpoints.
	var smallPanelSelectors = (_a = {},
	    _a["@media (min-width: " + Styling_1.ScreenWidthMinMedium + "px)"] = {
	        width: panelWidth.sm
	    },
	    _a);
	var mediumPanelSelectors = (_b = {},
	    _b["@media (min-width: " + Styling_1.ScreenWidthMinLarge + "px)"] = {
	        width: panelWidth.md1
	    },
	    _b["@media (min-width: " + Styling_1.ScreenWidthMinXLarge + "px)"] = {
	        width: panelWidth.md2
	    },
	    _b);
	var largePanelSelectors = (_c = {},
	    _c["@media (min-width: " + Styling_1.ScreenWidthMinUhfMobile + "px)"] = {
	        left: panelMargin.md,
	        width: panelWidth.auto
	    },
	    _c["@media (min-width: " + Styling_1.ScreenWidthMinXXLarge + "px)"] = {
	        left: panelMargin.lg
	    },
	    _c);
	var largeFixedPanelSelectors = (_d = {},
	    _d["@media (min-width: " + Styling_1.ScreenWidthMinXXLarge + "px)"] = {
	        left: panelMargin.auto,
	        width: panelWidth.lg
	    },
	    _d);
	var extraLargePanelSelectors = (_e = {},
	    _e["@media (min-width: " + Styling_1.ScreenWidthMinXXLarge + "px)"] = {
	        left: panelMargin.xl
	    },
	    _e);
	// Make sure Panels have fallbacks to different breakpoints by reusing same selectors.
	// This is done in the effort to follow design redlines.
	var getPanelBreakpoints = function (type) {
	    var selectors;
	    // Panel types `smallFluid`, `smallFixedNear`, `custom` and `customNear`
	    // are not checked in here because they render the same in all the breakpoints
	    // and have the checks done separately in the `getStyles` function below.
	    switch (type) {
	        case Panel_types_1.PanelType.smallFixedFar:
	            selectors = tslib_1.__assign({}, smallPanelSelectors);
	            break;
	        case Panel_types_1.PanelType.medium:
	            selectors = tslib_1.__assign({}, smallPanelSelectors, mediumPanelSelectors);
	            break;
	        case Panel_types_1.PanelType.large:
	            selectors = tslib_1.__assign({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors);
	            break;
	        case Panel_types_1.PanelType.largeFixed:
	            selectors = tslib_1.__assign({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors, largeFixedPanelSelectors);
	            break;
	        case Panel_types_1.PanelType.extraLarge:
	            selectors = tslib_1.__assign({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors, extraLargePanelSelectors);
	            break;
	        default:
	            break;
	    }
	    return selectors;
	};
	var commandBarHeight = '44px';
	var sharedPaddingStyles = {
	    paddingLeft: '16px',
	    paddingRight: '16px',
	    selectors: (_f = {},
	        _f["@media screen and (min-width: " + Styling_1.ScreenWidthMinLarge + "px)"] = {
	            paddingLeft: '32px',
	            paddingRight: '32px'
	        },
	        _f["@media screen and (min-width: " + Styling_1.ScreenWidthMinXXLarge + "px)"] = {
	            paddingLeft: '40px',
	            paddingRight: '40px'
	        },
	        _f)
	};
	// // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
	// function getIconButtonStyles(props: IPanelStyleProps): IStyleFunctionOrObject<IButtonStyleProps, IButtonStyles> {
	//   const { theme } = props;
	//   return () => ({
	//     root: {
	//       height: 'auto',
	//       width: '44px',
	//       color: theme.palette.neutralSecondary,
	//       fontSize: IconFontSizes.large
	//     },
	//     rootHovered: {
	//       color: theme.palette.neutralPrimary
	//     }
	//   });
	// }
	exports.getStyles = function (props) {
	    var className = props.className, focusTrapZoneClassName = props.focusTrapZoneClassName, hasCloseButton = props.hasCloseButton, headerClassName = props.headerClassName, isAnimating = props.isAnimating, isFooterSticky = props.isFooterSticky, isFooterAtBottom = props.isFooterAtBottom, isOnRightSide = props.isOnRightSide, isOpen = props.isOpen, isHiddenOnDismiss = props.isHiddenOnDismiss, theme = props.theme, _a = props.type, type = _a === void 0 ? Panel_types_1.PanelType.smallFixedFar : _a;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var isCustomPanel = type === Panel_types_1.PanelType.custom || type === Panel_types_1.PanelType.customNear;
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            isOpen && classNames.isOpen,
	            hasCloseButton && classNames.hasCloseButton,
	            {
	                pointerEvents: 'none',
	                position: 'absolute',
	                top: 0,
	                left: 0,
	                right: 0,
	                bottom: 0
	            },
	            isCustomPanel && isOnRightSide && classNames.custom,
	            isCustomPanel && !isOnRightSide && classNames.customNear,
	            className
	        ],
	        overlay: [
	            {
	                pointerEvents: 'auto',
	                cursor: 'pointer'
	            },
	            isOpen && isAnimating && Styling_1.AnimationClassNames.fadeIn100,
	            !isOpen && isAnimating && Styling_1.AnimationClassNames.fadeOut100
	        ],
	        hiddenPanel: [
	            !isOpen &&
	                !isAnimating &&
	                isHiddenOnDismiss && {
	                visibility: 'hidden'
	            }
	        ],
	        main: [
	            classNames.main,
	            {
	                backgroundColor: palette.white,
	                boxShadow: '0px 0px 30px 0px rgba(0,0,0,0.2)',
	                pointerEvents: 'auto',
	                position: 'absolute',
	                display: 'flex',
	                flexDirection: 'column',
	                overflowX: 'hidden',
	                overflowY: 'auto',
	                WebkitOverflowScrolling: 'touch',
	                bottom: 0,
	                top: 0,
	                // (left, right, width) - Properties to be overridden depending on the type of the Panel and the screen breakpoint.
	                left: panelMargin.auto,
	                right: panelMargin.none,
	                width: panelWidth.full,
	                selectors: tslib_1.__assign((_b = {}, _b[Styling_1.HighContrastSelector] = {
	                    borderLeft: "3px solid " + palette.neutralLight,
	                    borderRight: "3px solid " + palette.neutralLight
	                }, _b), getPanelBreakpoints(type))
	            },
	            type === Panel_types_1.PanelType.smallFluid && {
	                left: panelMargin.none
	            },
	            type === Panel_types_1.PanelType.smallFixedNear && {
	                left: panelMargin.none,
	                right: panelMargin.auto,
	                width: panelWidth.xs
	            },
	            type === Panel_types_1.PanelType.customNear && {
	                right: 'auto',
	                left: 0
	            },
	            isCustomPanel && {
	                maxWidth: '100vw'
	            },
	            isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideRightIn40,
	            isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideLeftIn40,
	            !isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideLeftOut40,
	            !isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideRightOut40,
	            focusTrapZoneClassName
	        ],
	        commands: [classNames.commands],
	        navigation: [
	            classNames.navigation,
	            {
	                padding: '0 5px',
	                height: commandBarHeight,
	                display: 'flex',
	                justifyContent: 'flex-end'
	            }
	        ],
	        closeButton: [classNames.closeButton],
	        contentInner: [
	            classNames.contentInner,
	            {
	                display: 'flex',
	                flexDirection: 'column',
	                flexGrow: 1,
	                overflowY: 'hidden'
	            }
	        ],
	        header: [
	            classNames.header,
	            sharedPaddingStyles,
	            {
	                margin: '14px 0',
	                // Ensure that title doesn't shrink if screen is too small
	                flexGrow: 0,
	                selectors: (_c = {},
	                    _c["@media (min-width: " + Styling_1.ScreenWidthMinXLarge + "px)"] = {
	                        marginTop: '30px'
	                    },
	                    _c)
	            }
	        ],
	        headerText: [
	            classNames.headerText,
	            Styling_1.DefaultFontStyles.xLarge,
	            {
	                color: palette.neutralPrimary,
	                lineHeight: '32px',
	                margin: 0
	            },
	            headerClassName
	        ],
	        scrollableContent: [
	            classNames.scrollableContent,
	            {
	                overflowY: 'auto'
	            },
	            isFooterAtBottom && {
	                flexGrow: 1
	            }
	        ],
	        content: [
	            classNames.content,
	            sharedPaddingStyles,
	            {
	                marginBottom: 0,
	                paddingBottom: 20
	            }
	        ],
	        footer: [
	            classNames.footer,
	            {
	                // Ensure that footer doesn't shrink if screen is too small
	                flexGrow: 0,
	                borderTop: '1px solid transparent',
	                transition: "opacity " + Styling_1.AnimationVariables.durationValue3 + " " + Styling_1.AnimationVariables.easeFunction2
	            },
	            isFooterSticky && {
	                background: palette.white,
	                borderTopColor: palette.neutralLight
	            }
	        ],
	        footerInner: [
	            classNames.footerInner,
	            sharedPaddingStyles,
	            {
	                paddingBottom: '20px',
	                paddingTop: '20px'
	            }
	        ]
	        // subComponentStyles: {
	        //   iconButton: getIconButtonStyles(props)
	        // }
	    };
	    var _b, _c;
	};
	var _a, _b, _c, _d, _e, _f;
	//# sourceMappingURL=Panel.styles.js.map

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Dropdown-container',
	    label: 'ms-Dropdown-label',
	    dropdown: 'ms-Dropdown',
	    title: 'ms-Dropdown-title',
	    caretDownWrapper: 'ms-Dropdown-caretDownWrapper',
	    caretDown: 'ms-Dropdown-caretDown',
	    callout: 'ms-Dropdown-callout',
	    panel: 'ms-Dropdown-panel',
	    dropdownItems: 'ms-Dropdown-items',
	    dropdownItem: 'ms-Dropdown-item',
	    dropdownDivider: 'ms-Dropdown-divider',
	    dropdownOptionText: 'ms-Dropdown-optionText',
	    dropdownItemHeader: 'ms-Dropdown-header',
	    titleIsPlaceHolder: 'ms-Dropdown-titleIsPlaceHolder',
	    titleHasError: 'ms-Dropdown-title--hasError'
	};
	var DROPDOWN_HEIGHT = 32;
	var DROPDOWN_ITEM_HEIGHT = 32;
	var highContrastAdjustMixin = (_a = {},
	    _a[Styling_1.HighContrastSelector + ", " + Styling_1.HighContrastSelectorWhite.replace('@media ', '')] = {
	        MsHighContrastAdjust: 'none'
	    },
	    _a);
	var highContrastItemAndTitleStateMixin = {
	    selectors: tslib_1.__assign((_b = {}, _b[Styling_1.HighContrastSelector] = {
	        backgroundColor: 'Highlight',
	        borderColor: 'Highlight',
	        color: 'HighlightText',
	        selectors: {
	            ':hover': {
	                color: 'HighlightText' // overrides the hover styling for buttons that are also selected
	            }
	        }
	    }, _b), highContrastAdjustMixin)
	};
	var highContrastBorderState = {
	    selectors: (_c = {},
	        _c[Styling_1.HighContrastSelector] = {
	            borderColor: 'Highlight'
	        },
	        _c)
	};
	var MinimumScreenSelector = Styling_1.getScreenSelector(0, Styling_1.ScreenWidthMinMedium);
	exports.getStyles = function (props) {
	    var theme = props.theme, hasError = props.hasError, hasLabel = props.hasLabel, className = props.className, isOpen = props.isOpen, disabled = props.disabled, required = props.required, isRenderingPlaceholder = props.isRenderingPlaceholder, panelClassName = props.panelClassName, calloutClassName = props.calloutClassName;
	    if (!theme) {
	        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
	    }
	    var globalClassnames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var rootHoverFocusActiveSelectorNeutralDarkMixin = {
	        color: semanticColors.menuItemTextHovered
	    };
	    var rootHoverFocusActiveSelectorBodySubtextMixin = {
	        color: semanticColors.bodySubtext
	    };
	    var borderColorError = {
	        borderColor: semanticColors.errorText
	    };
	    var dropdownItemStyle = [
	        globalClassnames.dropdownItem,
	        {
	            backgroundColor: 'transparent',
	            boxSizing: 'border-box',
	            cursor: 'pointer',
	            display: 'block',
	            padding: '4px 16px',
	            width: '100%',
	            minHeight: DROPDOWN_ITEM_HEIGHT,
	            lineHeight: 20,
	            height: 'auto',
	            position: 'relative',
	            border: '1px solid transparent',
	            wordWrap: 'break-word',
	            overflowWrap: 'break-word',
	            textAlign: 'left'
	        }
	    ];
	    var dropdownItemSelected = dropdownItemStyle.concat([
	        {
	            backgroundColor: palette.neutralQuaternaryAlt,
	            color: palette.black
	        },
	        highContrastItemAndTitleStateMixin
	    ]);
	    var dropdownItemDisabled = dropdownItemStyle.concat([
	        {
	            color: semanticColors.disabledText,
	            cursor: 'default'
	        }
	    ]);
	    return {
	        root: globalClassnames.root,
	        label: globalClassnames.label,
	        dropdown: [
	            globalClassnames.dropdown,
	            Styling_1.normalize,
	            tslib_1.__assign({}, theme.fonts.medium, { color: semanticColors.menuItemText, position: 'relative', outline: 0, userSelect: 'none', selectors: (_a = {},
	                    _a['&:hover .' + globalClassnames.title] = [
	                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                        { borderColor: palette.neutralDark },
	                        highContrastBorderState
	                    ],
	                    _a['&:focus .' + globalClassnames.title] = [
	                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                        {
	                            borderColor: palette.themePrimary /* see https://github.com/OfficeDev/office-ui-fabric-react/pull/9182 for semantic color disc */
	                        },
	                        highContrastItemAndTitleStateMixin
	                    ],
	                    _a['&:active .' + globalClassnames.title] = [
	                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                        { borderColor: palette.themeDark },
	                        highContrastBorderState
	                    ],
	                    _a['&:hover .' + globalClassnames.caretDown] = !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                    _a['&:focus .' + globalClassnames.caretDown] = [
	                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                        { selectors: tslib_1.__assign((_b = {}, _b[Styling_1.HighContrastSelector] = { color: 'HighlightText' }, _b), highContrastAdjustMixin) }
	                    ],
	                    _a['&:active .' + globalClassnames.caretDown] = !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
	                    _a['&:hover .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
	                    _a['&:focus .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
	                    _a['&:active .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
	                    _a['&:hover .' + globalClassnames.titleHasError] = borderColorError,
	                    _a['&:active .' + globalClassnames.titleHasError] = borderColorError,
	                    _a['&:focus .' + globalClassnames.titleHasError] = borderColorError,
	                    _a) }),
	            className,
	            isOpen && 'is-open',
	            disabled && 'is-disabled',
	            required && 'is-required',
	            required &&
	                !hasLabel && {
	                selectors: (_c = {
	                        ':after': {
	                            content: "'*'",
	                            color: semanticColors.errorText,
	                            position: 'absolute',
	                            top: -5,
	                            right: -10
	                        }
	                    },
	                    _c[Styling_1.HighContrastSelector] = {
	                        selectors: {
	                            ':after': {
	                                right: -14 // moving the * 4 pixel to right to alleviate border clipping in HC mode.
	                            }
	                        }
	                    },
	                    _c)
	            }
	        ],
	        title: [
	            globalClassnames.title,
	            Styling_1.normalize,
	            {
	                backgroundColor: semanticColors.inputBackground,
	                borderWidth: 1,
	                borderStyle: 'solid',
	                borderColor: semanticColors.inputBorder,
	                cursor: 'pointer',
	                display: 'block',
	                height: DROPDOWN_HEIGHT,
	                lineHeight: DROPDOWN_HEIGHT - 2,
	                padding: "0 " + DROPDOWN_HEIGHT + "px 0 12px",
	                position: 'relative',
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	            },
	            isRenderingPlaceholder && [globalClassnames.titleIsPlaceHolder, { color: semanticColors.inputPlaceholderText }],
	            hasError && [globalClassnames.titleHasError, borderColorError],
	            disabled && {
	                backgroundColor: semanticColors.disabledBackground,
	                border: 'none',
	                color: semanticColors.disabledText,
	                cursor: 'default',
	                selectors: (_d = {}, _d[Styling_1.HighContrastSelector] = { border: '1px solid GrayText', color: 'GrayText' }, _d)
	            }
	        ],
	        caretDownWrapper: [
	            globalClassnames.caretDownWrapper,
	            {
	                position: 'absolute',
	                top: 1,
	                right: 12,
	                height: DROPDOWN_HEIGHT,
	                lineHeight: DROPDOWN_HEIGHT - 2 // height minus the border
	            },
	            !disabled && {
	                cursor: 'pointer'
	            }
	        ],
	        caretDown: [
	            globalClassnames.caretDown,
	            { color: semanticColors.bodySubtext, fontSize: Styling_1.FontSizes.small, pointerEvents: 'none' },
	            disabled && { color: semanticColors.disabledText, selectors: (_e = {}, _e[Styling_1.HighContrastSelector] = { color: 'GrayText' }, _e) }
	        ],
	        errorMessage: tslib_1.__assign({ color: semanticColors.errorText }, theme.fonts.small, { paddingTop: 5 }),
	        callout: [
	            globalClassnames.callout,
	            {
	                boxShadow: '0 0 2px 0 rgba(0,0,0,0.2)',
	                border: "1px solid " + semanticColors.variantBorder
	            },
	            calloutClassName
	        ],
	        dropdownItemsWrapper: { selectors: { '&:focus': { outline: 0 } } },
	        dropdownItems: [globalClassnames.dropdownItems, { display: 'block' }],
	        dropdownItem: dropdownItemStyle.concat([
	            {
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Window'
	                    },
	                    _f['&:hover'] = {
	                        color: 'inherit'
	                    },
	                    _f['&:focus'] = {
	                        backgroundColor: semanticColors.listItemBackgroundHovered
	                    },
	                    _f['&:active'] = {
	                        backgroundColor: semanticColors.listHeaderBackgroundHovered,
	                        color: palette.black
	                    },
	                    _f)
	            }
	        ]),
	        dropdownItemSelected: dropdownItemSelected,
	        dropdownItemDisabled: dropdownItemDisabled,
	        dropdownItemSelectedAndDisabled: [dropdownItemSelected, dropdownItemDisabled, { backgroundColor: 'transparent' }],
	        dropdownItemHidden: dropdownItemStyle.concat([{ display: 'none' }]),
	        dropdownDivider: [globalClassnames.dropdownDivider, { height: 1, backgroundColor: semanticColors.bodyDivider }],
	        dropdownOptionText: [
	            globalClassnames.dropdownOptionText,
	            {
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis',
	                minWidth: 0,
	                maxWidth: '100%',
	                wordWrap: 'break-word',
	                overflowWrap: 'break-word',
	                margin: '1px'
	            }
	        ],
	        dropdownItemHeader: [
	            globalClassnames.dropdownItemHeader,
	            tslib_1.__assign({}, theme.fonts.medium, { fontWeight: Styling_1.FontWeights.semibold, color: semanticColors.menuHeader, background: 'none', backgroundColor: 'transparent', border: 'none', height: DROPDOWN_ITEM_HEIGHT, lineHeight: DROPDOWN_ITEM_HEIGHT, cursor: 'default', padding: '0px 16px', userSelect: 'none', textAlign: 'left' })
	        ],
	        subComponentStyles: {
	            label: { root: { display: 'inline-block' } },
	            panel: {
	                root: [panelClassName],
	                main: {
	                    // Force drop shadow even under medium breakpoint
	                    boxShadow: '-30px 0px 30px -30px rgba(0,0,0,0.2)',
	                    selectors: (_g = {},
	                        // In case of extra small screen sizes
	                        _g[MinimumScreenSelector] = {
	                            // panelWidth xs
	                            width: 272
	                        },
	                        _g)
	                },
	                contentInner: { padding: '0 0 20px' }
	            }
	        }
	    };
	    var _a, _b, _c, _d, _e, _f, _g;
	};
	var _a, _b, _c;
	//# sourceMappingURL=Dropdown.styles.js.map

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(987), exports);
	//# sourceMappingURL=ExtendedPicker.js.map

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(988), exports);
	tslib_1.__exportStar(__webpack_require__(991), exports);
	tslib_1.__exportStar(__webpack_require__(993), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Autofill_1 = __webpack_require__(664);
	var stylesImport = __webpack_require__(989);
	var FocusZone_1 = __webpack_require__(676);
	var Selection_1 = __webpack_require__(990);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	var BaseExtendedPicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseExtendedPicker, _super);
	    function BaseExtendedPicker(basePickerProps) {
	        var _this = _super.call(this, basePickerProps) || this;
	        _this.floatingPicker = React.createRef();
	        _this.selectedItemsList = React.createRef();
	        _this.root = React.createRef();
	        _this.input = React.createRef();
	        _this.onSelectionChange = function () {
	            _this.forceUpdate();
	        };
	        _this.onInputChange = function (value) {
	            _this.setState({ queryString: value });
	            if (_this.floatingPicker.current) {
	                _this.floatingPicker.current.onQueryStringChanged(value);
	            }
	        };
	        _this.onInputFocus = function (ev) {
	            if (_this.selectedItemsList.current) {
	                _this.selectedItemsList.current.unselectAll();
	            }
	            if (_this.props.inputProps && _this.props.inputProps.onFocus) {
	                _this.props.inputProps.onFocus(ev);
	            }
	        };
	        _this.onInputClick = function (ev) {
	            if (_this.selectedItemsList.current) {
	                _this.selectedItemsList.current.unselectAll();
	            }
	            if (_this.floatingPicker.current && _this.inputElement) {
	                // Update the value if the input value is empty or it is different than the current inputText from the floatingPicker
	                var shoudUpdateValue = _this.inputElement.value === '' || _this.inputElement.value !== _this.floatingPicker.current.inputText;
	                _this.floatingPicker.current.showPicker(shoudUpdateValue);
	            }
	        };
	        // This is protected because we may expect the backspace key to work differently in a different kind of picker.
	        // This lets the subclass override it and provide it's own onBackspace. For an example see the BasePickerListBelow
	        _this.onBackspace = function (ev) {
	            if (ev.which !== Utilities_1.KeyCodes.backspace) {
	                return;
	            }
	            if (_this.selectedItemsList.current && _this.items.length) {
	                if (_this.input.current &&
	                    !_this.input.current.isValueSelected &&
	                    _this.input.current.inputElement === document.activeElement &&
	                    _this.input.current.cursorLocation === 0) {
	                    if (_this.floatingPicker.current) {
	                        _this.floatingPicker.current.hidePicker();
	                    }
	                    ev.preventDefault();
	                    _this.selectedItemsList.current.removeItemAt(_this.items.length - 1);
	                    _this._onSelectedItemsChanged();
	                }
	                else if (_this.selectedItemsList.current.hasSelectedItems()) {
	                    if (_this.floatingPicker.current) {
	                        _this.floatingPicker.current.hidePicker();
	                    }
	                    ev.preventDefault();
	                    _this.selectedItemsList.current.removeSelectedItems();
	                    _this._onSelectedItemsChanged();
	                }
	            }
	        };
	        _this.onCopy = function (ev) {
	            if (_this.selectedItemsList.current) {
	                // Pass it down into the selected items list
	                _this.selectedItemsList.current.onCopy(ev);
	            }
	        };
	        _this.onPaste = function (ev) {
	            if (_this.props.onPaste) {
	                var inputText = ev.clipboardData.getData('Text');
	                ev.preventDefault();
	                _this.props.onPaste(inputText);
	            }
	        };
	        _this._onSuggestionSelected = function (item) {
	            var currentRenderedQueryString = _this.props.currentRenderedQueryString;
	            var queryString = _this.state.queryString;
	            if (currentRenderedQueryString === undefined || currentRenderedQueryString === queryString) {
	                var processedItem = _this.props.onItemSelected ? _this.props.onItemSelected(item) : item;
	                if (processedItem === null) {
	                    return;
	                }
	                var processedItemObject = processedItem;
	                var processedItemPromiseLike = processedItem;
	                var newItem_1;
	                if (processedItemPromiseLike && processedItemPromiseLike.then) {
	                    processedItemPromiseLike.then(function (resolvedProcessedItem) {
	                        newItem_1 = resolvedProcessedItem;
	                        _this._addProcessedItem(newItem_1);
	                    });
	                }
	                else {
	                    newItem_1 = processedItemObject;
	                    _this._addProcessedItem(newItem_1);
	                }
	            }
	        };
	        _this._onSelectedItemsChanged = function () {
	            _this.focus();
	        };
	        _this.selection = new Selection_1.Selection({ onSelectionChanged: function () { return _this.onSelectionChange(); } });
	        _this.state = {
	            queryString: '',
	            suggestionItems: _this.props.suggestionItems ? _this.props.suggestionItems : null,
	            selectedItems: _this.props.defaultSelectedItems
	                ? _this.props.defaultSelectedItems
	                : _this.props.selectedItems
	                    ? _this.props.selectedItems
	                    : null
	        };
	        _this.floatingPickerProps = _this.props.floatingPickerProps;
	        _this.selectedItemsListProps = _this.props.selectedItemsListProps;
	        return _this;
	    }
	    Object.defineProperty(BaseExtendedPicker.prototype, "items", {
	        // tslint:disable-next-line:no-any
	        get: function () {
	            return this.state.selectedItems
	                ? this.state.selectedItems
	                : this.selectedItemsList.current
	                    ? this.selectedItemsList.current.items
	                    : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseExtendedPicker.prototype.componentDidMount = function () {
	        this.forceUpdate();
	    };
	    BaseExtendedPicker.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.floatingPickerProps) {
	            this.floatingPickerProps = newProps.floatingPickerProps;
	        }
	        if (newProps.selectedItemsListProps) {
	            this.selectedItemsListProps = newProps.selectedItemsListProps;
	        }
	        if (newProps.selectedItems) {
	            this.setState({ selectedItems: newProps.selectedItems });
	        }
	    };
	    BaseExtendedPicker.prototype.focus = function () {
	        if (this.input.current) {
	            this.input.current.focus();
	        }
	    };
	    BaseExtendedPicker.prototype.clearInput = function () {
	        if (this.input.current) {
	            this.input.current.clear();
	        }
	    };
	    Object.defineProperty(BaseExtendedPicker.prototype, "inputElement", {
	        get: function () {
	            return this.input.current && this.input.current.inputElement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseExtendedPicker.prototype, "highlightedItems", {
	        get: function () {
	            return this.selectedItemsList.current ? this.selectedItemsList.current.highlightedItems() : [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseExtendedPicker.prototype.render = function () {
	        var _a = this.props, className = _a.className, inputProps = _a.inputProps, disabled = _a.disabled, focusZoneProps = _a.focusZoneProps;
	        var activeDescendant = this.floatingPicker.current && this.floatingPicker.current.currentSelectedSuggestionIndex !== -1
	            ? 'sug-' + this.floatingPicker.current.currentSelectedSuggestionIndex
	            : undefined;
	        return (React.createElement("div", { ref: this.root, className: Utilities_1.css('ms-BasePicker ms-BaseExtendedPicker', className ? className : ''), onKeyDown: this.onBackspace, onCopy: this.onCopy },
	            React.createElement(FocusZone_1.FocusZone, tslib_1.__assign({ direction: FocusZone_1.FocusZoneDirection.bidirectional }, focusZoneProps),
	                React.createElement(Selection_1.SelectionZone, { selection: this.selection, selectionMode: Selection_1.SelectionMode.multiple },
	                    React.createElement("div", { className: Utilities_1.css('ms-BasePicker-text', styles.pickerText), role: 'list' },
	                        this.props.headerComponent,
	                        this.renderSelectedItemsList(),
	                        this.canAddItems() && (React.createElement(Autofill_1.Autofill, tslib_1.__assign({}, inputProps, { className: Utilities_1.css('ms-BasePicker-input', styles.pickerInput), ref: this.input, onFocus: this.onInputFocus, onClick: this.onInputClick, onInputValueChange: this.onInputChange, "aria-activedescendant": activeDescendant, "aria-owns": "suggestion-list", "aria-expanded": this.floatingPicker.current ? this.floatingPicker.current.isSuggestionsShown : false, "aria-haspopup": "true", role: "combobox", disabled: disabled, onPaste: this.onPaste })))))),
	            this.renderFloatingPicker()));
	    };
	    BaseExtendedPicker.prototype.canAddItems = function () {
	        var itemLimit = this.props.itemLimit;
	        return itemLimit === undefined || this.items.length < itemLimit;
	    };
	    BaseExtendedPicker.prototype.renderFloatingPicker = function () {
	        var FloatingPicker = this.props.onRenderFloatingPicker;
	        return (React.createElement(FloatingPicker, tslib_1.__assign({ componentRef: this.floatingPicker, onChange: this._onSuggestionSelected, inputElement: this.input.current ? this.input.current.inputElement : undefined, selectedItems: this.items, suggestionItems: this.props.suggestionItems ? this.props.suggestionItems : undefined }, this.floatingPickerProps)));
	    };
	    BaseExtendedPicker.prototype.renderSelectedItemsList = function () {
	        var SelectedItems = this.props.onRenderSelectedItems;
	        return (React.createElement(SelectedItems, tslib_1.__assign({ componentRef: this.selectedItemsList, selection: this.selection, selectedItems: this.props.selectedItems ? this.props.selectedItems : undefined, onItemsDeleted: this.props.selectedItems ? this.props.onItemsRemoved : undefined }, this.selectedItemsListProps)));
	    };
	    BaseExtendedPicker.prototype._addProcessedItem = function (newItem) {
	        // If this is a controlled component, call the on item selected callback
	        // Otherwise add it to the selectedItemsList
	        if (this.props.onItemAdded) {
	            this.props.onItemAdded(newItem);
	        }
	        if (this.selectedItemsList.current) {
	            this.selectedItemsList.current.addItems([newItem]);
	        }
	        if (this.input.current) {
	            this.input.current.clear();
	        }
	        if (this.floatingPicker.current) {
	            this.floatingPicker.current.hidePicker();
	        }
	        this.focus();
	    };
	    return BaseExtendedPicker;
	}(Utilities_1.BaseComponent));
	exports.BaseExtendedPicker = BaseExtendedPicker;
	//# sourceMappingURL=BaseExtendedPicker.js.map

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".pickerText_55459320{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";min-width:180px;padding:1px;min-height:32px}.pickerText_55459320:hover{border-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.pickerInput_55459320{height:34px;border:none;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;outline:none;padding:0 6px 0px;margin:1px}.pickerInput_55459320::-ms-clear{display:none}\n" }]);
	exports.pickerText = "pickerText_55459320";
	exports.pickerInput = "pickerInput_55459320";
	//# sourceMappingURL=BaseExtendedPicker.scss.js.map

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(866), exports);
	//# sourceMappingURL=Selection.js.map

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	__webpack_require__(992);
	var BaseExtendedPicker_1 = __webpack_require__(988);
	/**
	 * {@docCategory ExtendedPeoplePicker}
	 */
	var BaseExtendedPeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseExtendedPeoplePicker, _super);
	    function BaseExtendedPeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BaseExtendedPeoplePicker;
	}(BaseExtendedPicker_1.BaseExtendedPicker));
	exports.BaseExtendedPeoplePicker = BaseExtendedPeoplePicker;
	/**
	 * {@docCategory ExtendedPeoplePicker}
	 */
	var ExtendedPeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(ExtendedPeoplePicker, _super);
	    function ExtendedPeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ExtendedPeoplePicker;
	}(BaseExtendedPeoplePicker));
	exports.ExtendedPeoplePicker = ExtendedPeoplePicker;
	//# sourceMappingURL=ExtendedPeoplePicker.js.map

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_8d238594{display:table-row}.resultContent_8d238594 .resultItem_8d238594{display:table-cell;vertical-align:bottom}.peoplePickerPersona_8d238594{width:180px}.peoplePickerPersona_8d238594 .ms-Persona-details{width:100%}.peoplePicker_8d238594 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_8d238594{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
	exports.resultContent = "resultContent_8d238594";
	exports.resultItem = "resultItem_8d238594";
	exports.peoplePickerPersona = "peoplePickerPersona_8d238594";
	exports.peoplePicker = "peoplePicker_8d238594";
	exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_8d238594";
	//# sourceMappingURL=ExtendedPeoplePicker.scss.js.map

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// If this file is moved or split, the scripts for building codepen examples will likely need to be updated.
	Object.defineProperty(exports, "__esModule", { value: true });
	var Persona_1 = __webpack_require__(594);
	var TestImages_1 = __webpack_require__(994);
	exports.people = [
	    {
	        key: 1,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'PV',
	        text: 'Annie Lindqvist',
	        secondaryText: 'Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 2,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'AR',
	        text: 'Aaron Reid',
	        secondaryText: 'Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 3,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'AL',
	        text: 'Alex Lundberg',
	        secondaryText: 'Software Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.dnd
	    },
	    {
	        key: 4,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'RK',
	        text: 'Roko Kolar',
	        secondaryText: 'Financial Analyst',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 5,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'CB',
	        text: 'Christian Bergqvist',
	        secondaryText: 'Sr. Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 6,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Valentina Lovric',
	        secondaryText: 'Design Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 7,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Maor Sharett',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.away
	    },
	    {
	        key: 8,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'PV',
	        text: 'Anny Lindqvist',
	        secondaryText: 'Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 9,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'AR',
	        text: 'Aron Reid',
	        secondaryText: 'Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.dnd
	    },
	    {
	        key: 10,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'AL',
	        text: 'Alix Lundberg',
	        secondaryText: 'Software Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 11,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'RK',
	        text: 'Roko Kular',
	        secondaryText: 'Financial Analyst',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.none
	    },
	    {
	        key: 12,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'CB',
	        text: 'Christian Bergqvest',
	        secondaryText: 'Sr. Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 13,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Valintina Lovric',
	        secondaryText: 'Design Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 14,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Maor Sharet',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.blocked
	    },
	    {
	        key: 15,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Anny Lindqvest',
	        secondaryText: 'SDE',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.blocked
	    },
	    {
	        key: 16,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Alix Lunberg',
	        secondaryText: 'SE',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.away
	    },
	    {
	        key: 17,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Annie Lindqvest',
	        secondaryText: 'SDET',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 18,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Alixander Lundberg',
	        secondaryText: 'Senior Manager of SDET',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 19,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Anny Lundqvist',
	        secondaryText: 'Junior Manager of Software',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.away
	    },
	    {
	        key: 20,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Maor Shorett',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.blocked
	    },
	    {
	        key: 21,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Valentina Lovrics',
	        secondaryText: 'Design Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 22,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Maor Sharet',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 23,
	        imageUrl: TestImages_1.TestImages.personaFemale,
	        imageInitials: 'VL',
	        text: 'Valentina Lovrecs',
	        secondaryText: 'Design Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.blocked
	    },
	    {
	        key: 24,
	        imageUrl: TestImages_1.TestImages.personaMale,
	        imageInitials: 'MS',
	        text: 'Maor Sharitt',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 25,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'MS',
	        text: 'Maor Shariett',
	        secondaryText: 'Design Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 3:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 26,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'AL',
	        text: 'Alix Lundburg',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 3:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.away
	    },
	    {
	        key: 27,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'VL',
	        text: 'Valantena Lovric',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 28,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'VL',
	        text: 'Velatine Lourvric',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 29,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'VL',
	        text: 'Valentyna Lovrique',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 30,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'AL',
	        text: 'Annie Lindquest',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.dnd
	    },
	    {
	        key: 31,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'AL',
	        text: 'Anne Lindquist',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.blocked
	    },
	    {
	        key: 32,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'AL',
	        text: 'Ann Lindqiest',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 33,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'AR',
	        text: 'Aron Reid',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.away
	    },
	    {
	        key: 34,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'AR',
	        text: 'Aaron Reed',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 35,
	        imageUrl: './images/persona-female.png',
	        imageInitials: 'AL',
	        text: 'Alix Lindberg',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 36,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'AL',
	        text: 'Alan Lindberg',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.busy
	    },
	    {
	        key: 37,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'MS',
	        text: 'Maor Sharit',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.offline
	    },
	    {
	        key: 38,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'MS',
	        text: 'Maorr Sherit',
	        secondaryText: 'UX Designer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 39,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'AL',
	        text: 'Alex Lindbirg',
	        secondaryText: 'Software Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.dnd
	    },
	    {
	        key: 40,
	        imageUrl: './images/persona-male.png',
	        imageInitials: 'AL',
	        text: 'Alex Lindbarg',
	        secondaryText: 'Software Developer',
	        tertiaryText: 'In a meeting',
	        optionalText: 'Available at 4:00pm',
	        isValid: true,
	        presence: Persona_1.PersonaPresence.online
	    },
	    {
	        key: 41,
	        imageInitials: 'GO',
	        text: 'Group One',
	        canExpand: true,
	        isValid: true
	    },
	    {
	        key: 42,
	        imageInitials: 'GT',
	        text: 'Group Two',
	        canExpand: true,
	        isValid: true
	    }
	];
	exports.mru = exports.people.slice(0, 5);
	exports.groupOne = exports.people.slice(6, 10);
	exports.groupTwo = exports.people.slice(11, 16);
	//# sourceMappingURL=PeopleExampleData.js.map

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	"use strict";
	// If this file is moved or split, the scripts for building codepen examples will likely need to be updated.
	Object.defineProperty(exports, "__esModule", { value: true });
	var baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';
	exports.TestImages = {
	    choiceGroupBarUnselected: baseProductionCdnUrl + 'choicegroup-bar-unselected.png',
	    choiceGroupBarSelected: baseProductionCdnUrl + 'choicegroup-bar-selected.png',
	    choiceGroupPieUnselected: baseProductionCdnUrl + 'choicegroup-pie-unselected.png',
	    choiceGroupPieSelected: baseProductionCdnUrl + 'choicegroup-pie-selected.png',
	    documentPreview: baseProductionCdnUrl + 'document-preview.png',
	    documentPreviewTwo: baseProductionCdnUrl + 'document-preview2.png',
	    documentPreviewThree: baseProductionCdnUrl + 'document-preview3.png',
	    iconOne: baseProductionCdnUrl + 'icon-one.png',
	    iconPpt: baseProductionCdnUrl + 'icon-ppt.png',
	    personaFemale: baseProductionCdnUrl + 'persona-female.png',
	    personaMale: baseProductionCdnUrl + 'persona-male.png'
	};
	//# sourceMappingURL=TestImages.js.map

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(996), exports);
	//# sourceMappingURL=Facepile.js.map

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(997), exports);
	tslib_1.__exportStar(__webpack_require__(998), exports);
	tslib_1.__exportStar(__webpack_require__(1001), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Facepile}
	 */
	var OverflowButtonType;
	(function (OverflowButtonType) {
	    /** No overflow */
	    OverflowButtonType[OverflowButtonType["none"] = 0] = "none";
	    /** +1 overflow icon */
	    OverflowButtonType[OverflowButtonType["descriptive"] = 1] = "descriptive";
	    /** More overflow icon */
	    OverflowButtonType[OverflowButtonType["more"] = 2] = "more";
	    /** Chevron overflow icon */
	    OverflowButtonType[OverflowButtonType["downArrow"] = 3] = "downArrow";
	})(OverflowButtonType = exports.OverflowButtonType || (exports.OverflowButtonType = {}));
	//# sourceMappingURL=Facepile.types.js.map

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Facepile_types_1 = __webpack_require__(997);
	var FacepileButton_1 = __webpack_require__(999);
	var Icon_1 = __webpack_require__(643);
	var Persona_1 = __webpack_require__(594);
	var PersonaCoin_1 = __webpack_require__(954);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * FacePile with no default styles.
	 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Component-Styling)
	 */
	var FacepileBase = /** @class */ (function (_super) {
	    tslib_1.__extends(FacepileBase, _super);
	    function FacepileBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._classNames = getClassNames(_this.props.styles, {
	            theme: _this.props.theme,
	            className: _this.props.className
	        });
	        _this._getPersonaControl = function (persona) {
	            var _a = _this.props, getPersonaProps = _a.getPersonaProps, personaSize = _a.personaSize;
	            var personaStyles = {
	                details: {
	                    flex: '1 0 auto'
	                }
	            };
	            return (React.createElement(Persona_1.Persona, tslib_1.__assign({ imageInitials: persona.imageInitials, imageUrl: persona.imageUrl, initialsColor: persona.initialsColor, allowPhoneInitials: persona.allowPhoneInitials, text: persona.personaName, size: personaSize }, (getPersonaProps ? getPersonaProps(persona) : null), { styles: personaStyles })));
	        };
	        _this._getPersonaCoinControl = function (persona) {
	            var _a = _this.props, getPersonaProps = _a.getPersonaProps, personaSize = _a.personaSize;
	            return (React.createElement(PersonaCoin_1.PersonaCoin, tslib_1.__assign({ imageInitials: persona.imageInitials, imageUrl: persona.imageUrl, initialsColor: persona.initialsColor, allowPhoneInitials: persona.allowPhoneInitials, text: persona.personaName, size: personaSize }, (getPersonaProps ? getPersonaProps(persona) : null))));
	        };
	        _this._ariaDescriptionId = Utilities_1.getId();
	        return _this;
	    }
	    FacepileBase.prototype.render = function () {
	        var overflowButtonProps = this.props.overflowButtonProps;
	        var _a = this.props, chevronButtonProps = _a.chevronButtonProps, maxDisplayablePersonas = _a.maxDisplayablePersonas, personas = _a.personas, overflowPersonas = _a.overflowPersonas, showAddButton = _a.showAddButton, ariaLabel = _a.ariaLabel;
	        var _classNames = this._classNames;
	        // Add a check to make sure maxDisplayalePersonas is defined to cover the edge case of it being 0.
	        var numPersonasToShow = typeof maxDisplayablePersonas === 'number' ? Math.min(personas.length, maxDisplayablePersonas) : personas.length;
	        // Added for deprecating chevronButtonProps.  Can remove after v1.0
	        if (chevronButtonProps && !overflowButtonProps) {
	            overflowButtonProps = chevronButtonProps;
	        }
	        var hasOverflowPersonas = overflowPersonas && overflowPersonas.length > 0;
	        var personasPrimary = hasOverflowPersonas ? personas : personas.slice(0, numPersonasToShow);
	        var personasOverflow = (hasOverflowPersonas ? overflowPersonas : personas.slice(numPersonasToShow)) || [];
	        return (React.createElement("div", { className: _classNames.root },
	            this.onRenderAriaDescription(),
	            React.createElement("div", { className: _classNames.itemContainer },
	                showAddButton ? this._getAddNewElement() : null,
	                React.createElement("ul", { className: _classNames.members, role: "listbox", "aria-label": ariaLabel }, this._onRenderVisiblePersonas(personasPrimary, personasOverflow.length === 0 && personas.length === 1)),
	                overflowButtonProps ? this._getOverflowElement(personasOverflow) : null)));
	    };
	    FacepileBase.prototype.onRenderAriaDescription = function () {
	        var ariaDescription = this.props.ariaDescription;
	        var _classNames = this._classNames;
	        // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
	        // otherwise it will be assigned to descriptionSpan.
	        return (ariaDescription && (React.createElement("span", { className: _classNames.screenReaderOnly, id: this._ariaDescriptionId }, ariaDescription)));
	    };
	    FacepileBase.prototype._onRenderVisiblePersonas = function (personas, singlePersona) {
	        var _this = this;
	        var _a = this.props, _b = _a.onRenderPersona, onRenderPersona = _b === void 0 ? this._getPersonaControl : _b, _c = _a.onRenderPersonaCoin, onRenderPersonaCoin = _c === void 0 ? this._getPersonaCoinControl : _c;
	        return personas.map(function (persona, index) {
	            var personaControl = singlePersona
	                ? onRenderPersona(persona, _this._getPersonaControl)
	                : onRenderPersonaCoin(persona, _this._getPersonaCoinControl);
	            return (React.createElement("li", { role: "option", key: (singlePersona ? 'persona' : 'personaCoin') + "-" + index, className: _this._classNames.member }, persona.onClick
	                ? _this._getElementWithOnClickEvent(personaControl, persona, index)
	                : _this._getElementWithoutOnClickEvent(personaControl, persona, index)));
	        });
	    };
	    FacepileBase.prototype._getElementWithOnClickEvent = function (personaControl, persona, index) {
	        var keytipProps = persona.keytipProps;
	        return (React.createElement(FacepileButton_1.FacepileButton, tslib_1.__assign({}, Utilities_1.getNativeProps(persona, Utilities_1.buttonProperties), this._getElementProps(persona, index), { keytipProps: keytipProps, onClick: this._onPersonaClick.bind(this, persona) }), personaControl));
	    };
	    FacepileBase.prototype._getElementWithoutOnClickEvent = function (personaControl, persona, index) {
	        return (React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(persona, Utilities_1.buttonProperties), this._getElementProps(persona, index)), personaControl));
	    };
	    FacepileBase.prototype._getElementProps = function (persona, index) {
	        var _classNames = this._classNames;
	        return {
	            key: (!!persona.imageUrl ? 'i' : '') + index,
	            'data-is-focusable': true,
	            role: 'option',
	            className: _classNames.itemButton,
	            title: persona.personaName,
	            onMouseMove: this._onPersonaMouseMove.bind(this, persona),
	            onMouseOut: this._onPersonaMouseOut.bind(this, persona)
	        };
	    };
	    FacepileBase.prototype._getOverflowElement = function (personasOverflow) {
	        switch (this.props.overflowButtonType) {
	            case Facepile_types_1.OverflowButtonType.descriptive:
	                return this._getDescriptiveOverflowElement(personasOverflow);
	            case Facepile_types_1.OverflowButtonType.downArrow:
	                return this._getIconElement('ChevronDown');
	            case Facepile_types_1.OverflowButtonType.more:
	                return this._getIconElement('More');
	            default:
	                return null;
	        }
	    };
	    FacepileBase.prototype._getDescriptiveOverflowElement = function (personasOverflow) {
	        var personaSize = this.props.personaSize;
	        if (!personasOverflow || personasOverflow.length < 1) {
	            return null;
	        }
	        var personaNames = personasOverflow.map(function (p) { return p.personaName; }).join(', ');
	        var overflowButtonProps = tslib_1.__assign({ title: personaNames }, this.props.overflowButtonProps);
	        var numPersonasNotPictured = Math.max(personasOverflow.length, 0);
	        var _classNames = this._classNames;
	        return (React.createElement(FacepileButton_1.FacepileButton, tslib_1.__assign({}, overflowButtonProps, { ariaDescription: overflowButtonProps.title, className: _classNames.descriptiveOverflowButton }),
	            React.createElement(PersonaCoin_1.PersonaCoin, { size: personaSize, onRenderInitials: this._renderInitialsNotPictured(numPersonasNotPictured), initialsColor: PersonaCoin_1.PersonaInitialsColor.transparent })));
	    };
	    FacepileBase.prototype._getIconElement = function (icon) {
	        var _a = this.props, overflowButtonProps = _a.overflowButtonProps, personaSize = _a.personaSize;
	        var overflowInitialsIcon = true;
	        var _classNames = this._classNames;
	        return (React.createElement(FacepileButton_1.FacepileButton, tslib_1.__assign({}, overflowButtonProps, { className: _classNames.overflowButton }),
	            React.createElement(PersonaCoin_1.PersonaCoin, { size: personaSize, onRenderInitials: this._renderInitials(icon, overflowInitialsIcon), initialsColor: PersonaCoin_1.PersonaInitialsColor.transparent })));
	    };
	    FacepileBase.prototype._getAddNewElement = function () {
	        var _a = this.props, addButtonProps = _a.addButtonProps, personaSize = _a.personaSize;
	        var _classNames = this._classNames;
	        return (React.createElement(FacepileButton_1.FacepileButton, tslib_1.__assign({}, addButtonProps, { className: _classNames.addButton }),
	            React.createElement(PersonaCoin_1.PersonaCoin, { size: personaSize, onRenderInitials: this._renderInitials('AddFriend') })));
	    };
	    FacepileBase.prototype._onPersonaClick = function (persona, ev) {
	        persona.onClick(ev, persona);
	        ev.preventDefault();
	        ev.stopPropagation();
	    };
	    FacepileBase.prototype._onPersonaMouseMove = function (persona, ev) {
	        if (!!persona.onMouseMove) {
	            persona.onMouseMove(ev, persona);
	        }
	    };
	    FacepileBase.prototype._onPersonaMouseOut = function (persona, ev) {
	        if (!!persona.onMouseOut) {
	            persona.onMouseOut(ev, persona);
	        }
	    };
	    FacepileBase.prototype._renderInitials = function (iconName, overflowButton) {
	        var _classNames = this._classNames;
	        return function () {
	            return React.createElement(Icon_1.Icon, { iconName: iconName, className: overflowButton ? _classNames.overflowInitialsIcon : '' });
	        };
	    };
	    FacepileBase.prototype._renderInitialsNotPictured = function (numPersonasNotPictured) {
	        var _classNames = this._classNames;
	        return function () {
	            return React.createElement("span", { className: _classNames.overflowInitialsIcon }, '+' + numPersonasNotPictured);
	        };
	    };
	    FacepileBase.defaultProps = {
	        maxDisplayablePersonas: 5,
	        personas: [],
	        overflowPersonas: [],
	        personaSize: PersonaCoin_1.PersonaSize.size32
	    };
	    return FacepileBase;
	}(Utilities_1.BaseComponent));
	exports.FacepileBase = FacepileBase;
	//# sourceMappingURL=Facepile.base.js.map

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Button_1 = __webpack_require__(691);
	var Utilities_1 = __webpack_require__(592);
	var FacepileButton_styles_1 = __webpack_require__(1000);
	var FacepileButton = /** @class */ (function (_super) {
	    tslib_1.__extends(FacepileButton, _super);
	    function FacepileButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Tell BaseComponent to bypass resolution of componentRef.
	         */
	        _this._skipComponentRefResolution = true;
	        return _this;
	    }
	    FacepileButton.prototype.render = function () {
	        var _a = this.props, className = _a.className, styles = _a.styles, rest = tslib_1.__rest(_a, ["className", "styles"]);
	        var customStyles = FacepileButton_styles_1.getStyles(this.props.theme, className, styles);
	        return React.createElement(Button_1.BaseButton, tslib_1.__assign({}, rest, { variantClassName: "ms-Button--facepile", styles: customStyles, onRenderDescription: Utilities_1.nullRender }));
	    };
	    FacepileButton = tslib_1.__decorate([
	        Utilities_1.customizable('FacepileButton', ['theme', 'styles'], true)
	    ], FacepileButton);
	    return FacepileButton;
	}(Utilities_1.BaseComponent));
	exports.FacepileButton = FacepileButton;
	//# sourceMappingURL=FacepileButton.js.map

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var BaseButton_styles_1 = __webpack_require__(725);
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, className, customStyles) {
	    var baseButtonStyles = BaseButton_styles_1.getStyles(theme);
	    var customButtonStyles = Styling_1.concatStyleSets(baseButtonStyles, customStyles);
	    return tslib_1.__assign({}, customButtonStyles, { root: [baseButtonStyles.root, className, theme.fonts.medium, customStyles && customStyles.root] });
	});
	//# sourceMappingURL=FacepileButton.styles.js.map

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Facepile_base_1 = __webpack_require__(998);
	var Facepile_styles_1 = __webpack_require__(1002);
	/**
	 * The Facepile shows a list of faces or initials in a horizontal lockup. Each circle represents a person.
	 */
	exports.Facepile = Utilities_1.styled(Facepile_base_1.FacepileBase, Facepile_styles_1.styles, undefined, {
	    scope: 'Facepile'
	});
	//# sourceMappingURL=Facepile.js.map

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Facepile',
	    addButton: 'ms-Facepile-addButton ms-Facepile-itemButton',
	    descriptiveOverflowButton: 'ms-Facepile-descriptiveOverflowButton ms-Facepile-itemButton',
	    itemButton: 'ms-Facepile-itemButton ms-Facepile-person',
	    itemContainer: 'ms-Facepile-itemContainer',
	    members: 'ms-Facepile-members',
	    member: 'ms-Facepile-member',
	    overflowButton: 'ms-Facepile-overflowButton ms-Facepile-itemButton'
	};
	exports.styles = function (props) {
	    var className = props.className, theme = props.theme, _a = props.spacingAroundItemButton, spacingAroundItemButton = _a === void 0 ? 2 : _a;
	    var palette = theme.palette, fonts = theme.fonts;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var ItemButtonStyles = {
	        textAlign: 'center',
	        padding: 0,
	        borderRadius: '50%',
	        verticalAlign: 'top',
	        display: 'inline',
	        backgroundColor: 'transparent',
	        cursor: 'pointer',
	        border: 'none',
	        selectors: {
	            '&::-moz-focus-inner': {
	                padding: 0,
	                border: 0
	            }
	        }
	    };
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                width: 'auto'
	            },
	            className
	        ],
	        addButton: [
	            classNames.addButton,
	            Styling_1.getFocusStyle(theme, { inset: -1 }),
	            ItemButtonStyles,
	            {
	                fontSize: fonts.medium.fontSize,
	                color: palette.white,
	                backgroundColor: palette.themePrimary,
	                marginRight: spacingAroundItemButton * 2 + 'px',
	                selectors: {
	                    '&:hover': {
	                        backgroundColor: palette.themeDark
	                    },
	                    '&:focus': {
	                        backgroundColor: palette.themeDark
	                    },
	                    '&:active': {
	                        backgroundColor: palette.themeDarker
	                    },
	                    '&:disabled': {
	                        backgroundColor: palette.neutralTertiaryAlt
	                    }
	                }
	            }
	        ],
	        descriptiveOverflowButton: [
	            classNames.descriptiveOverflowButton,
	            Styling_1.getFocusStyle(theme, { inset: -1 }),
	            ItemButtonStyles,
	            {
	                fontSize: fonts.small.fontSize,
	                color: palette.neutralSecondary,
	                backgroundColor: palette.neutralLight,
	                marginLeft: spacingAroundItemButton * 2 + "px"
	            }
	        ],
	        itemButton: [classNames.itemButton, ItemButtonStyles],
	        itemContainer: [
	            classNames.itemContainer,
	            {
	                display: 'flex'
	            }
	        ],
	        members: [
	            classNames.members,
	            {
	                display: 'flex',
	                overflow: 'hidden',
	                listStyleType: 'none',
	                padding: 0,
	                margin: "-" + spacingAroundItemButton + "px"
	            }
	        ],
	        member: [
	            classNames.member,
	            {
	                display: 'inline-flex',
	                flex: '0 0 auto',
	                margin: spacingAroundItemButton + "px"
	            }
	        ],
	        overflowButton: [
	            classNames.overflowButton,
	            Styling_1.getFocusStyle(theme, { inset: -1 }),
	            ItemButtonStyles,
	            {
	                fontSize: fonts.medium.fontSize,
	                color: palette.neutralSecondary,
	                backgroundColor: palette.neutralLight,
	                marginLeft: spacingAroundItemButton * 2 + "px"
	            }
	        ],
	        overflowInitialsIcon: [
	            {
	                color: palette.neutralPrimary
	            }
	        ],
	        screenReaderOnly: Styling_1.hiddenContentStyle
	    };
	};
	//# sourceMappingURL=Facepile.styles.js.map

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1004), exports);
	//# sourceMappingURL=FloatingPicker.js.map

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1005), exports);
	tslib_1.__exportStar(__webpack_require__(1035), exports);
	tslib_1.__exportStar(__webpack_require__(1038), exports);
	tslib_1.__exportStar(__webpack_require__(1007), exports);
	tslib_1.__exportStar(__webpack_require__(1008), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var stylesImport = __webpack_require__(1006);
	var Utilities_1 = __webpack_require__(592);
	var Callout_1 = __webpack_require__(603);
	var SuggestionsControl_1 = __webpack_require__(1007);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	var BaseFloatingPicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseFloatingPicker, _super);
	    function BaseFloatingPicker(basePickerProps) {
	        var _this = _super.call(this, basePickerProps) || this;
	        _this.root = React.createRef();
	        _this.suggestionsControl = React.createRef();
	        _this.SuggestionsControlOfProperType = SuggestionsControl_1.SuggestionsControl;
	        _this.isComponentMounted = false;
	        _this.onQueryStringChanged = function (queryString) {
	            if (queryString !== _this.state.queryString) {
	                _this.setState({
	                    queryString: queryString
	                });
	                if (_this.props.onInputChanged) {
	                    _this.props.onInputChanged(queryString);
	                }
	                _this.updateValue(queryString);
	            }
	        };
	        _this.hidePicker = function () {
	            if (_this.props.onSuggestionsHidden && _this.isSuggestionsShown) {
	                _this.props.onSuggestionsHidden();
	            }
	            _this.setState({
	                suggestionsVisible: false
	            });
	        };
	        _this.showPicker = function (updateValue) {
	            if (updateValue === void 0) { updateValue = false; }
	            if (_this.props.onSuggestionsShown && !_this.isSuggestionsShown) {
	                _this.props.onSuggestionsShown();
	            }
	            _this.setState({
	                suggestionsVisible: true
	            });
	            // Update the suggestions if updateValue == true
	            var value = _this.props.inputElement ? _this.props.inputElement.value : '';
	            if (updateValue) {
	                _this.updateValue(value);
	            }
	        };
	        _this.completeSuggestion = function () {
	            if (_this.suggestionsControl.current && _this.suggestionsControl.current.hasSuggestionSelected()) {
	                _this.onChange(_this.suggestionsControl.current.currentSuggestion.item);
	            }
	        };
	        _this.onSuggestionClick = function (ev, item, index) {
	            _this.onChange(item);
	            _this._updateSuggestionsVisible(false /*shouldShow*/);
	        };
	        _this.onSuggestionRemove = function (ev, item, index) {
	            if (_this.props.onRemoveSuggestion) {
	                _this.props.onRemoveSuggestion(item);
	            }
	            if (_this.suggestionsControl.current) {
	                _this.suggestionsControl.current.removeSuggestion(index);
	            }
	        };
	        _this.onKeyDown = function (ev) {
	            if (!_this.state.suggestionsVisible ||
	                (_this.props.inputElement && !_this.props.inputElement.contains(ev.target))) {
	                return;
	            }
	            var keyCode = ev.which;
	            switch (keyCode) {
	                case Utilities_1.KeyCodes.escape:
	                    _this.hidePicker();
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                    break;
	                case Utilities_1.KeyCodes.tab:
	                case Utilities_1.KeyCodes.enter:
	                    if (!ev.shiftKey && !ev.ctrlKey && _this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                    }
	                    else {
	                        _this._onValidateInput();
	                    }
	                    break;
	                case Utilities_1.KeyCodes.del:
	                    if (_this.props.onRemoveSuggestion &&
	                        _this.suggestionsControl.current &&
	                        _this.suggestionsControl.current.hasSuggestionSelected &&
	                        _this.suggestionsControl.current.currentSuggestion &&
	                        ev.shiftKey) {
	                        _this.props.onRemoveSuggestion(_this.suggestionsControl.current.currentSuggestion.item);
	                        _this.suggestionsControl.current.removeSuggestion();
	                        _this.forceUpdate();
	                        ev.stopPropagation();
	                    }
	                    break;
	                case Utilities_1.KeyCodes.up:
	                    if (_this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                        _this._updateActiveDescendant();
	                    }
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    if (_this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                        _this._updateActiveDescendant();
	                    }
	                    break;
	            }
	        };
	        _this._onValidateInput = function () {
	            if (_this.state.queryString && _this.props.onValidateInput && _this.props.createGenericItem) {
	                var itemToConvert = _this.props.createGenericItem(_this.state.queryString, _this.props.onValidateInput(_this.state.queryString));
	                var convertedItems = _this.suggestionStore.convertSuggestionsToSuggestionItems([itemToConvert]);
	                _this.onChange(convertedItems[0].item);
	            }
	        };
	        _this.suggestionStore = basePickerProps.suggestionsStore;
	        _this.state = {
	            queryString: '',
	            didBind: false
	        };
	        return _this;
	    }
	    Object.defineProperty(BaseFloatingPicker.prototype, "inputText", {
	        get: function () {
	            return this.state.queryString;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseFloatingPicker.prototype, "suggestions", {
	        // tslint:disable-next-line:no-any
	        get: function () {
	            return this.suggestionStore.suggestions;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseFloatingPicker.prototype.forceResolveSuggestion = function () {
	        if (this.suggestionsControl.current && this.suggestionsControl.current.hasSuggestionSelected()) {
	            this.completeSuggestion();
	        }
	        else {
	            this._onValidateInput();
	        }
	    };
	    Object.defineProperty(BaseFloatingPicker.prototype, "currentSelectedSuggestionIndex", {
	        get: function () {
	            return this.suggestionsControl.current ? this.suggestionsControl.current.currentSuggestionIndex : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseFloatingPicker.prototype, "isSuggestionsShown", {
	        get: function () {
	            return this.state.suggestionsVisible === undefined ? false : this.state.suggestionsVisible;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseFloatingPicker.prototype.componentDidMount = function () {
	        this._bindToInputElement();
	        this.isComponentMounted = true;
	        this._onResolveSuggestions = this._async.debounce(this._onResolveSuggestions, this.props.resolveDelay);
	    };
	    BaseFloatingPicker.prototype.componentDidUpdate = function () {
	        this._bindToInputElement();
	    };
	    BaseFloatingPicker.prototype.componentWillUnmount = function () {
	        this._unbindFromInputElement();
	        this.isComponentMounted = false;
	    };
	    BaseFloatingPicker.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.suggestionItems) {
	            this.updateSuggestions(newProps.suggestionItems);
	        }
	    };
	    BaseFloatingPicker.prototype.updateSuggestions = function (suggestions, forceUpdate) {
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        this.suggestionStore.updateSuggestions(suggestions);
	        if (forceUpdate) {
	            this.forceUpdate();
	        }
	    };
	    BaseFloatingPicker.prototype.render = function () {
	        var className = this.props.className;
	        return (React.createElement("div", { ref: this.root, className: Utilities_1.css('ms-BasePicker ms-BaseFloatingPicker', className ? className : '') }, this.renderSuggestions()));
	    };
	    BaseFloatingPicker.prototype.renderSuggestions = function () {
	        var TypedSuggestionsControl = this.SuggestionsControlOfProperType;
	        return this.state.suggestionsVisible ? (React.createElement(Callout_1.Callout, { className: styles.callout, isBeakVisible: false, gapSpace: 5, target: this.props.inputElement, onDismiss: this.hidePicker, directionalHint: Callout_1.DirectionalHint.bottomLeftEdge, directionalHintForRTL: Callout_1.DirectionalHint.bottomRightEdge, calloutWidth: this.props.calloutWidth ? this.props.calloutWidth : 0 },
	            React.createElement(TypedSuggestionsControl, tslib_1.__assign({ onRenderSuggestion: this.props.onRenderSuggestionsItem, onSuggestionClick: this.onSuggestionClick, onSuggestionRemove: this.onSuggestionRemove, suggestions: this.suggestionStore.getSuggestions(), componentRef: this.suggestionsControl, completeSuggestion: this.completeSuggestion, shouldLoopSelection: false }, this.props.pickerSuggestionsProps)))) : null;
	    };
	    BaseFloatingPicker.prototype.onSelectionChange = function () {
	        this.forceUpdate();
	    };
	    BaseFloatingPicker.prototype.updateValue = function (updatedValue) {
	        if (updatedValue === '') {
	            this.updateSuggestionWithZeroState();
	        }
	        else {
	            this._onResolveSuggestions(updatedValue);
	        }
	    };
	    BaseFloatingPicker.prototype.updateSuggestionWithZeroState = function () {
	        if (this.props.onZeroQuerySuggestion) {
	            var onEmptyInputFocus = this.props.onZeroQuerySuggestion;
	            var suggestions = onEmptyInputFocus(this.props.selectedItems);
	            this.updateSuggestionsList(suggestions);
	        }
	        else {
	            this.hidePicker();
	        }
	    };
	    BaseFloatingPicker.prototype.updateSuggestionsList = function (suggestions) {
	        var _this = this;
	        var suggestionsArray = suggestions;
	        var suggestionsPromiseLike = suggestions;
	        // Check to see if the returned value is an array, if it is then just pass it into the next function.
	        // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
	        if (Array.isArray(suggestionsArray)) {
	            this.updateSuggestions(suggestionsArray, true /*forceUpdate*/);
	        }
	        else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
	            // Ensure that the promise will only use the callback if it was the most recent one.
	            var promise_1 = (this.currentPromise = suggestionsPromiseLike);
	            promise_1.then(function (newSuggestions) {
	                // Only update if the next promise has not yet resolved and
	                // the floating picker is still mounted.
	                if (promise_1 === _this.currentPromise && _this.isComponentMounted) {
	                    _this.updateSuggestions(newSuggestions, true /*forceUpdate*/);
	                }
	            });
	        }
	    };
	    BaseFloatingPicker.prototype.onChange = function (item) {
	        if (this.props.onChange) {
	            this.props.onChange(item);
	        }
	    };
	    BaseFloatingPicker.prototype._updateActiveDescendant = function () {
	        if (this.props.inputElement && this.suggestionsControl.current && this.suggestionsControl.current.selectedElement) {
	            var selectedElId = this.suggestionsControl.current.selectedElement.getAttribute('id');
	            if (selectedElId) {
	                this.props.inputElement.setAttribute('aria-activedescendant', selectedElId);
	            }
	        }
	    };
	    BaseFloatingPicker.prototype._onResolveSuggestions = function (updatedValue) {
	        var suggestions = this.props.onResolveSuggestions(updatedValue, this.props.selectedItems);
	        this._updateSuggestionsVisible(true /*shouldShow*/);
	        if (suggestions !== null) {
	            this.updateSuggestionsList(suggestions);
	        }
	    };
	    BaseFloatingPicker.prototype._updateSuggestionsVisible = function (shouldShow) {
	        if (shouldShow) {
	            this.showPicker();
	        }
	        else {
	            this.hidePicker();
	        }
	    };
	    BaseFloatingPicker.prototype._bindToInputElement = function () {
	        if (this.props.inputElement && !this.state.didBind) {
	            this.props.inputElement.addEventListener('keydown', this.onKeyDown);
	            this.setState({ didBind: true });
	        }
	    };
	    BaseFloatingPicker.prototype._unbindFromInputElement = function () {
	        if (this.props.inputElement && this.state.didBind) {
	            this.props.inputElement.removeEventListener('keydown', this.onKeyDown);
	            this.setState({ didBind: false });
	        }
	    };
	    return BaseFloatingPicker;
	}(Utilities_1.BaseComponent));
	exports.BaseFloatingPicker = BaseFloatingPicker;
	//# sourceMappingURL=BaseFloatingPicker.js.map

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".callout_e8e64567 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_e8e64567 .ms-Suggestions{min-width:300px}\n" }]);
	exports.callout = "callout_e8e64567";
	//# sourceMappingURL=BaseFloatingPicker.scss.js.map

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var SuggestionsCore_1 = __webpack_require__(1008);
	var stylesImport = __webpack_require__(1034);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	var SuggestionItemType;
	(function (SuggestionItemType) {
	    SuggestionItemType[SuggestionItemType["header"] = 0] = "header";
	    SuggestionItemType[SuggestionItemType["suggestion"] = 1] = "suggestion";
	    SuggestionItemType[SuggestionItemType["footer"] = 2] = "footer";
	})(SuggestionItemType = exports.SuggestionItemType || (exports.SuggestionItemType = {}));
	var SuggestionsHeaderFooterItem = /** @class */ (function (_super) {
	    tslib_1.__extends(SuggestionsHeaderFooterItem, _super);
	    function SuggestionsHeaderFooterItem() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SuggestionsHeaderFooterItem.prototype.render = function () {
	        var _a = this.props, renderItem = _a.renderItem, onExecute = _a.onExecute, isSelected = _a.isSelected, id = _a.id, className = _a.className;
	        return onExecute ? (React.createElement("div", { id: id, onClick: onExecute, className: Utilities_1.css('ms-Suggestions-sectionButton', className, styles.actionButton, (_b = {},
	                _b['is-selected ' + styles.buttonSelected] = isSelected,
	                _b)) }, renderItem())) : (React.createElement("div", { id: id, className: Utilities_1.css('ms-Suggestions-section', className, styles.suggestionsTitle) }, renderItem()));
	        var _b;
	    };
	    return SuggestionsHeaderFooterItem;
	}(Utilities_1.BaseComponent));
	exports.SuggestionsHeaderFooterItem = SuggestionsHeaderFooterItem;
	/**
	 * Class when used with SuggestionsStore, renders a suggestions control with customizable headers and footers
	 */
	var SuggestionsControl = /** @class */ (function (_super) {
	    tslib_1.__extends(SuggestionsControl, _super);
	    function SuggestionsControl(suggestionsProps) {
	        var _this = _super.call(this, suggestionsProps) || this;
	        _this.SuggestionsOfProperType = SuggestionsCore_1.SuggestionsCore;
	        _this.state = {
	            selectedHeaderIndex: -1,
	            selectedFooterIndex: -1,
	            suggestions: suggestionsProps.suggestions
	        };
	        return _this;
	    }
	    SuggestionsControl.prototype.componentDidMount = function () {
	        this.resetSelectedItem();
	    };
	    SuggestionsControl.prototype.componentDidUpdate = function () {
	        this.scrollSelected();
	    };
	    SuggestionsControl.prototype.componentWillReceiveProps = function (newProps) {
	        var _this = this;
	        if (newProps.suggestions) {
	            this.setState({ suggestions: newProps.suggestions }, function () {
	                _this.resetSelectedItem();
	            });
	        }
	    };
	    SuggestionsControl.prototype.componentWillUnmount = function () {
	        this._suggestions.deselectAllSuggestions();
	    };
	    SuggestionsControl.prototype.render = function () {
	        var _a = this.props, className = _a.className, headerItemsProps = _a.headerItemsProps, footerItemsProps = _a.footerItemsProps;
	        return (React.createElement("div", { className: Utilities_1.css('ms-Suggestions', className ? className : '', styles.root) },
	            headerItemsProps && this.renderHeaderItems(),
	            this._renderSuggestions(),
	            footerItemsProps && this.renderFooterItems()));
	    };
	    Object.defineProperty(SuggestionsControl.prototype, "currentSuggestion", {
	        get: function () {
	            return this._suggestions && this._suggestions.getCurrentItem();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SuggestionsControl.prototype, "currentSuggestionIndex", {
	        get: function () {
	            return this._suggestions ? this._suggestions.currentIndex : -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SuggestionsControl.prototype, "selectedElement", {
	        get: function () {
	            return this._selectedElement ? this._selectedElement : this._suggestions.selectedElement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SuggestionsControl.prototype.hasSuggestionSelected = function () {
	        return this._suggestions && this._suggestions.hasSuggestionSelected();
	    };
	    SuggestionsControl.prototype.hasSelection = function () {
	        var _a = this.state, selectedHeaderIndex = _a.selectedHeaderIndex, selectedFooterIndex = _a.selectedFooterIndex;
	        return selectedHeaderIndex !== -1 || this.hasSuggestionSelected() || selectedFooterIndex !== -1;
	    };
	    SuggestionsControl.prototype.executeSelectedAction = function () {
	        var _a = this.props, headerItemsProps = _a.headerItemsProps, footerItemsProps = _a.footerItemsProps;
	        var _b = this.state, selectedHeaderIndex = _b.selectedHeaderIndex, selectedFooterIndex = _b.selectedFooterIndex;
	        if (headerItemsProps && selectedHeaderIndex !== -1 && selectedHeaderIndex < headerItemsProps.length) {
	            var selectedHeaderItem = headerItemsProps[selectedHeaderIndex];
	            if (selectedHeaderItem.onExecute) {
	                selectedHeaderItem.onExecute();
	            }
	        }
	        else if (this._suggestions.hasSuggestionSelected()) {
	            this.props.completeSuggestion();
	        }
	        else if (footerItemsProps && selectedFooterIndex !== -1 && selectedFooterIndex < footerItemsProps.length) {
	            var selectedFooterItem = footerItemsProps[selectedFooterIndex];
	            if (selectedFooterItem.onExecute) {
	                selectedFooterItem.onExecute();
	            }
	        }
	    };
	    SuggestionsControl.prototype.removeSuggestion = function (index) {
	        this._suggestions.removeSuggestion(index ? index : this._suggestions.currentIndex);
	    };
	    /**
	     * Handles the key down, returns true, if the event was handled, false otherwise
	     * @param keyCode - The keyCode to handle
	     */
	    SuggestionsControl.prototype.handleKeyDown = function (keyCode) {
	        var _a = this.state, selectedHeaderIndex = _a.selectedHeaderIndex, selectedFooterIndex = _a.selectedFooterIndex;
	        var isKeyDownHandled = false;
	        if (keyCode === Utilities_1.KeyCodes.down) {
	            if (selectedHeaderIndex === -1 && !this._suggestions.hasSuggestionSelected() && selectedFooterIndex === -1) {
	                this.selectFirstItem();
	            }
	            else if (selectedHeaderIndex !== -1) {
	                this.selectNextItem(SuggestionItemType.header);
	                isKeyDownHandled = true;
	            }
	            else if (this._suggestions.hasSuggestionSelected()) {
	                this.selectNextItem(SuggestionItemType.suggestion);
	                isKeyDownHandled = true;
	            }
	            else if (selectedFooterIndex !== -1) {
	                this.selectNextItem(SuggestionItemType.footer);
	                isKeyDownHandled = true;
	            }
	        }
	        else if (keyCode === Utilities_1.KeyCodes.up) {
	            if (selectedHeaderIndex === -1 && !this._suggestions.hasSuggestionSelected() && selectedFooterIndex === -1) {
	                this.selectLastItem();
	            }
	            else if (selectedHeaderIndex !== -1) {
	                this.selectPreviousItem(SuggestionItemType.header);
	                isKeyDownHandled = true;
	            }
	            else if (this._suggestions.hasSuggestionSelected()) {
	                this.selectPreviousItem(SuggestionItemType.suggestion);
	                isKeyDownHandled = true;
	            }
	            else if (selectedFooterIndex !== -1) {
	                this.selectPreviousItem(SuggestionItemType.footer);
	                isKeyDownHandled = true;
	            }
	        }
	        else if (keyCode === Utilities_1.KeyCodes.enter || keyCode === Utilities_1.KeyCodes.tab) {
	            if (this.hasSelection()) {
	                this.executeSelectedAction();
	                isKeyDownHandled = true;
	            }
	        }
	        return isKeyDownHandled;
	    };
	    // TODO get the element to scroll into view properly regardless of direction.
	    SuggestionsControl.prototype.scrollSelected = function () {
	        if (this._selectedElement) {
	            this._selectedElement.scrollIntoView(false);
	        }
	    };
	    SuggestionsControl.prototype.renderHeaderItems = function () {
	        var _this = this;
	        var _a = this.props, headerItemsProps = _a.headerItemsProps, suggestionsHeaderContainerAriaLabel = _a.suggestionsHeaderContainerAriaLabel;
	        var selectedHeaderIndex = this.state.selectedHeaderIndex;
	        return headerItemsProps ? (React.createElement("div", { className: Utilities_1.css('ms-Suggestions-headerContainer', styles.suggestionsContainer), id: "suggestionHeader-list", role: "list", "aria-label": suggestionsHeaderContainerAriaLabel }, headerItemsProps.map(function (headerItemProps, index) {
	            var isSelected = selectedHeaderIndex !== -1 && selectedHeaderIndex === index;
	            return headerItemProps.shouldShow() ? (React.createElement("div", { ref: _this._resolveRef(isSelected ? '_selectedElement' : ''), id: 'sug-header' + index, key: 'sug-header' + index, role: "listitem", "aria-label": headerItemProps.ariaLabel },
	                React.createElement(SuggestionsHeaderFooterItem, { id: 'sug-header-item' + index, isSelected: isSelected, renderItem: headerItemProps.renderItem, onExecute: headerItemProps.onExecute, className: headerItemProps.className }))) : null;
	        }))) : null;
	    };
	    SuggestionsControl.prototype.renderFooterItems = function () {
	        var _this = this;
	        var _a = this.props, footerItemsProps = _a.footerItemsProps, suggestionsFooterContainerAriaLabel = _a.suggestionsFooterContainerAriaLabel;
	        var selectedFooterIndex = this.state.selectedFooterIndex;
	        return footerItemsProps ? (React.createElement("div", { className: Utilities_1.css('ms-Suggestions-footerContainer', styles.suggestionsContainer), id: "suggestionFooter-list", role: "list", "aria-label": suggestionsFooterContainerAriaLabel }, footerItemsProps.map(function (footerItemProps, index) {
	            var isSelected = selectedFooterIndex !== -1 && selectedFooterIndex === index;
	            return footerItemProps.shouldShow() ? (React.createElement("div", { ref: _this._resolveRef(isSelected ? '_selectedElement' : ''), id: 'sug-footer' + index, key: 'sug-footer' + index, role: "listitem", "aria-label": footerItemProps.ariaLabel },
	                React.createElement(SuggestionsHeaderFooterItem, { id: 'sug-footer-item' + index, isSelected: isSelected, renderItem: footerItemProps.renderItem, onExecute: footerItemProps.onExecute, className: footerItemProps.className }))) : null;
	        }))) : null;
	    };
	    SuggestionsControl.prototype._renderSuggestions = function () {
	        var TypedSuggestions = this.SuggestionsOfProperType;
	        return React.createElement(TypedSuggestions, tslib_1.__assign({ ref: this._resolveRef('_suggestions') }, this.props, { suggestions: this.state.suggestions }));
	    };
	    /**
	     * Selects the next selectable item
	     */
	    SuggestionsControl.prototype.selectNextItem = function (itemType, originalItemType) {
	        // If the recursive calling has not found a selectable item in the other suggestion item type groups
	        // And the method is being called again with the original item type,
	        // Select the first selectable item of this suggestion item type group (could be the currently selected item)
	        if (itemType === originalItemType) {
	            this._selectNextItemOfItemType(itemType);
	            return;
	        }
	        var startedItemType = originalItemType !== undefined ? originalItemType : itemType;
	        // Try to set the selection to the next selectable item, of the same suggestion item type group
	        // If this is the original item type, use the current index
	        var selectionChanged = this._selectNextItemOfItemType(itemType, startedItemType === itemType ? this._getCurrentIndexForType(itemType) : undefined);
	        // If the selection did not change, try to select from the next suggestion type group
	        if (!selectionChanged) {
	            this.selectNextItem(this._getNextItemSectionType(itemType), startedItemType);
	        }
	    };
	    /**
	     * Selects the previous selectable item
	     */
	    SuggestionsControl.prototype.selectPreviousItem = function (itemType, originalItemType) {
	        // If the recursive calling has not found a selectable item in the other suggestion item type groups
	        // And the method is being called again with the original item type,
	        // Select the last selectable item of this suggestion item type group (could be the currently selected item)
	        if (itemType === originalItemType) {
	            this._selectPreviousItemOfItemType(itemType);
	            return;
	        }
	        var startedItemType = originalItemType !== undefined ? originalItemType : itemType;
	        // Try to set the selection to the previous selectable item, of the same suggestion item type group
	        var selectionChanged = this._selectPreviousItemOfItemType(itemType, startedItemType === itemType ? this._getCurrentIndexForType(itemType) : undefined);
	        // If the selection did not change, try to select from the previous suggestion type group
	        if (!selectionChanged) {
	            this.selectPreviousItem(this._getPreviousItemSectionType(itemType), startedItemType);
	        }
	    };
	    /**
	     * Resets the selected state and selects the first selectable item
	     */
	    SuggestionsControl.prototype.resetSelectedItem = function () {
	        this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
	        this._suggestions.deselectAllSuggestions();
	        // Select the first item if the shouldSelectFirstItem prop is not set or it is set and it returns true
	        if (this.props.shouldSelectFirstItem === undefined || this.props.shouldSelectFirstItem()) {
	            this.selectFirstItem();
	        }
	    };
	    /**
	     * Selects the first item
	     */
	    SuggestionsControl.prototype.selectFirstItem = function () {
	        if (this._selectNextItemOfItemType(SuggestionItemType.header)) {
	            return;
	        }
	        if (this._selectNextItemOfItemType(SuggestionItemType.suggestion)) {
	            return;
	        }
	        this._selectNextItemOfItemType(SuggestionItemType.footer);
	    };
	    /**
	     * Selects the last item
	     */
	    SuggestionsControl.prototype.selectLastItem = function () {
	        if (this._selectPreviousItemOfItemType(SuggestionItemType.footer)) {
	            return;
	        }
	        if (this._selectPreviousItemOfItemType(SuggestionItemType.suggestion)) {
	            return;
	        }
	        this._selectPreviousItemOfItemType(SuggestionItemType.header);
	    };
	    /**
	     * Selects the next item in the suggestion item type group, given the current index
	     * If none is able to be selected, returns false, otherwise returns true
	     * @param itemType - The suggestion item type
	     * @param currentIndex - The current index, default is -1
	     */
	    SuggestionsControl.prototype._selectNextItemOfItemType = function (itemType, currentIndex) {
	        if (currentIndex === void 0) { currentIndex = -1; }
	        if (itemType === SuggestionItemType.suggestion) {
	            if (this.state.suggestions.length > currentIndex + 1) {
	                this._suggestions.setSelectedSuggestion(currentIndex + 1);
	                this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
	                return true;
	            }
	        }
	        else {
	            var isHeader = itemType === SuggestionItemType.header;
	            var itemProps = isHeader ? this.props.headerItemsProps : this.props.footerItemsProps;
	            if (itemProps && itemProps.length > currentIndex + 1) {
	                for (var i = currentIndex + 1; i < itemProps.length; i++) {
	                    var item = itemProps[i];
	                    if (item.onExecute && item.shouldShow()) {
	                        this.setState({ selectedHeaderIndex: isHeader ? i : -1 });
	                        this.setState({ selectedFooterIndex: isHeader ? -1 : i });
	                        this._suggestions.deselectAllSuggestions();
	                        return true;
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * Selects the previous item in the suggestion item type group, given the current index
	     * If none is able to be selected, returns false, otherwise returns true
	     * @param itemType - The suggestion item type
	     * @param currentIndex - The current index. If none is provided, the default is the items length of specified type
	     */
	    SuggestionsControl.prototype._selectPreviousItemOfItemType = function (itemType, currentIndex) {
	        if (itemType === SuggestionItemType.suggestion) {
	            var index = currentIndex !== undefined ? currentIndex : this.state.suggestions.length;
	            if (index > 0) {
	                this._suggestions.setSelectedSuggestion(index - 1);
	                this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
	                return true;
	            }
	        }
	        else {
	            var isHeader = itemType === SuggestionItemType.header;
	            var itemProps = isHeader ? this.props.headerItemsProps : this.props.footerItemsProps;
	            if (itemProps) {
	                var index = currentIndex !== undefined ? currentIndex : itemProps.length;
	                if (index > 0) {
	                    for (var i = index - 1; i >= 0; i--) {
	                        var item = itemProps[i];
	                        if (item.onExecute && item.shouldShow()) {
	                            this.setState({ selectedHeaderIndex: isHeader ? i : -1 });
	                            this.setState({ selectedFooterIndex: isHeader ? -1 : i });
	                            this._suggestions.deselectAllSuggestions();
	                            return true;
	                        }
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    SuggestionsControl.prototype._getCurrentIndexForType = function (itemType) {
	        switch (itemType) {
	            case SuggestionItemType.header:
	                return this.state.selectedHeaderIndex;
	            case SuggestionItemType.suggestion:
	                return this._suggestions.currentIndex;
	            case SuggestionItemType.footer:
	                return this.state.selectedFooterIndex;
	        }
	    };
	    SuggestionsControl.prototype._getNextItemSectionType = function (itemType) {
	        switch (itemType) {
	            case SuggestionItemType.header:
	                return SuggestionItemType.suggestion;
	            case SuggestionItemType.suggestion:
	                return SuggestionItemType.footer;
	            case SuggestionItemType.footer:
	                return SuggestionItemType.header;
	        }
	    };
	    SuggestionsControl.prototype._getPreviousItemSectionType = function (itemType) {
	        switch (itemType) {
	            case SuggestionItemType.header:
	                return SuggestionItemType.footer;
	            case SuggestionItemType.suggestion:
	                return SuggestionItemType.header;
	            case SuggestionItemType.footer:
	                return SuggestionItemType.suggestion;
	        }
	    };
	    return SuggestionsControl;
	}(Utilities_1.BaseComponent));
	exports.SuggestionsControl = SuggestionsControl;
	//# sourceMappingURL=SuggestionsControl.js.map

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Pickers_1 = __webpack_require__(1009);
	var stylesImport = __webpack_require__(1033);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	/**
	 * Class when used with SuggestionsStore, renders a basic suggestions control
	 */
	var SuggestionsCore = /** @class */ (function (_super) {
	    tslib_1.__extends(SuggestionsCore, _super);
	    function SuggestionsCore(suggestionsProps) {
	        var _this = _super.call(this, suggestionsProps) || this;
	        _this.SuggestionsItemOfProperType = Pickers_1.SuggestionsItem;
	        _this.currentIndex = -1;
	        return _this;
	    }
	    /**
	     * Increments the selected suggestion index
	     */
	    SuggestionsCore.prototype.nextSuggestion = function () {
	        var suggestions = this.props.suggestions;
	        if (suggestions && suggestions.length > 0) {
	            if (this.currentIndex === -1) {
	                this.setSelectedSuggestion(0);
	                return true;
	            }
	            else if (this.currentIndex < suggestions.length - 1) {
	                this.setSelectedSuggestion(this.currentIndex + 1);
	                return true;
	            }
	            else if (this.props.shouldLoopSelection && this.currentIndex === suggestions.length - 1) {
	                this.setSelectedSuggestion(0);
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Decrements the selected suggestion index
	     */
	    SuggestionsCore.prototype.previousSuggestion = function () {
	        var suggestions = this.props.suggestions;
	        if (suggestions && suggestions.length > 0) {
	            if (this.currentIndex === -1) {
	                this.setSelectedSuggestion(suggestions.length - 1);
	                return true;
	            }
	            else if (this.currentIndex > 0) {
	                this.setSelectedSuggestion(this.currentIndex - 1);
	                return true;
	            }
	            else if (this.props.shouldLoopSelection && this.currentIndex === 0) {
	                this.setSelectedSuggestion(suggestions.length - 1);
	                return true;
	            }
	        }
	        return false;
	    };
	    Object.defineProperty(SuggestionsCore.prototype, "selectedElement", {
	        get: function () {
	            return this._selectedElement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SuggestionsCore.prototype.getCurrentItem = function () {
	        return this.props.suggestions[this.currentIndex];
	    };
	    SuggestionsCore.prototype.getSuggestionAtIndex = function (index) {
	        return this.props.suggestions[index];
	    };
	    SuggestionsCore.prototype.hasSuggestionSelected = function () {
	        return this.currentIndex !== -1 && this.currentIndex < this.props.suggestions.length;
	    };
	    SuggestionsCore.prototype.removeSuggestion = function (index) {
	        this.props.suggestions.splice(index, 1);
	    };
	    SuggestionsCore.prototype.deselectAllSuggestions = function () {
	        if (this.currentIndex > -1 && this.props.suggestions[this.currentIndex]) {
	            this.props.suggestions[this.currentIndex].selected = false;
	            this.currentIndex = -1;
	            this.forceUpdate();
	        }
	    };
	    SuggestionsCore.prototype.setSelectedSuggestion = function (index) {
	        var suggestions = this.props.suggestions;
	        if (index > suggestions.length - 1 || index < 0) {
	            this.currentIndex = 0;
	            this.currentSuggestion.selected = false;
	            this.currentSuggestion = suggestions[0];
	            this.currentSuggestion.selected = true;
	        }
	        else {
	            if (this.currentIndex > -1 && suggestions[this.currentIndex]) {
	                suggestions[this.currentIndex].selected = false;
	            }
	            suggestions[index].selected = true;
	            this.currentIndex = index;
	            this.currentSuggestion = suggestions[index];
	        }
	        this.forceUpdate();
	    };
	    SuggestionsCore.prototype.componentDidUpdate = function () {
	        this.scrollSelected();
	    };
	    SuggestionsCore.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, onRenderSuggestion = _a.onRenderSuggestion, suggestionsItemClassName = _a.suggestionsItemClassName, resultsMaximumNumber = _a.resultsMaximumNumber, showRemoveButtons = _a.showRemoveButtons, suggestionsContainerAriaLabel = _a.suggestionsContainerAriaLabel;
	        var TypedSuggestionsItem = this.SuggestionsItemOfProperType;
	        var suggestions = this.props.suggestions;
	        if (resultsMaximumNumber) {
	            suggestions = suggestions.slice(0, resultsMaximumNumber);
	        }
	        return (React.createElement("div", { className: Utilities_1.css('ms-Suggestions-container', styles.suggestionsContainer), id: "suggestion-list", role: "list", "aria-label": suggestionsContainerAriaLabel }, suggestions.map(function (suggestion, index) { return (React.createElement("div", { ref: _this._resolveRef(suggestion.selected || index === _this.currentIndex ? '_selectedElement' : ''), 
	            // tslint:disable
	            key: suggestion.item['key'] ? suggestion.item['key'] : index, 
	            // tslint:enable
	            id: 'sug-' + index, role: "listitem", "aria-label": suggestion.ariaLabel },
	            React.createElement(TypedSuggestionsItem, { id: 'sug-item' + index, suggestionModel: suggestion, 
	                // tslint:disable-next-line:no-any
	                RenderSuggestion: onRenderSuggestion, onClick: _this._onClickTypedSuggestionsItem(suggestion.item, index), className: suggestionsItemClassName, showRemoveButton: showRemoveButtons, onRemoveItem: _this._onRemoveTypedSuggestionsItem(suggestion.item, index), isSelectedOverride: index === _this.currentIndex }))); })));
	    };
	    // TODO get the element to scroll into view properly regardless of direction.
	    SuggestionsCore.prototype.scrollSelected = function () {
	        if (this._selectedElement && this._selectedElement.scrollIntoView !== undefined) {
	            this._selectedElement.scrollIntoView(false);
	        }
	    };
	    SuggestionsCore.prototype._onClickTypedSuggestionsItem = function (item, index) {
	        var _this = this;
	        return function (ev) {
	            _this.props.onSuggestionClick(ev, item, index);
	        };
	    };
	    SuggestionsCore.prototype._onRemoveTypedSuggestionsItem = function (item, index) {
	        var _this = this;
	        return function (ev) {
	            var onSuggestionRemove = _this.props.onSuggestionRemove;
	            onSuggestionRemove(ev, item, index);
	            ev.stopPropagation();
	        };
	    };
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], SuggestionsCore.prototype, "_onClickTypedSuggestionsItem", null);
	    tslib_1.__decorate([
	        Utilities_1.autobind
	    ], SuggestionsCore.prototype, "_onRemoveTypedSuggestionsItem", null);
	    return SuggestionsCore;
	}(Utilities_1.BaseComponent));
	exports.SuggestionsCore = SuggestionsCore;
	//# sourceMappingURL=SuggestionsCore.js.map

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1010), exports);
	//# sourceMappingURL=Pickers.js.map

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1011), exports);
	tslib_1.__exportStar(__webpack_require__(1012), exports);
	tslib_1.__exportStar(__webpack_require__(1013), exports);
	tslib_1.__exportStar(__webpack_require__(1016), exports);
	tslib_1.__exportStar(__webpack_require__(1017), exports);
	tslib_1.__exportStar(__webpack_require__(1018), exports);
	tslib_1.__exportStar(__webpack_require__(1020), exports);
	tslib_1.__exportStar(__webpack_require__(1022), exports);
	tslib_1.__exportStar(__webpack_require__(1023), exports);
	tslib_1.__exportStar(__webpack_require__(1025), exports);
	tslib_1.__exportStar(__webpack_require__(1028), exports);
	tslib_1.__exportStar(__webpack_require__(1029), exports);
	tslib_1.__exportStar(__webpack_require__(1031), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var Spinner_1 = __webpack_require__(885);
	var Suggestions_types_1 = __webpack_require__(1012);
	var SuggestionsItem_1 = __webpack_require__(1013);
	var SuggestionsItem_styles_1 = __webpack_require__(1015);
	var stylesImport = __webpack_require__(1014);
	var legacyStyles = stylesImport;
	var getClassNames = Utilities_1.classNamesFunction();
	var StyledSuggestionsItem = Utilities_1.styled(SuggestionsItem_1.SuggestionsItem, SuggestionsItem_styles_1.getStyles, undefined, { scope: 'SuggestionItem' });
	/**
	 * {@docCategory Pickers}
	 */
	var Suggestions = /** @class */ (function (_super) {
	    tslib_1.__extends(Suggestions, _super);
	    function Suggestions(suggestionsProps) {
	        var _this = _super.call(this, suggestionsProps) || this;
	        _this._forceResolveButton = React.createRef();
	        _this._searchForMoreButton = React.createRef();
	        _this._selectedElement = React.createRef();
	        /**
	         * Returns true if the event was handled, false otherwise
	         */
	        _this.tryHandleKeyDown = function (keyCode, currentSuggestionIndex) {
	            var isEventHandled = false;
	            var newSelectedActionType = null;
	            var currentSelectedAction = _this.state.selectedActionType;
	            var suggestionLength = _this.props.suggestions.length;
	            if (keyCode === Utilities_1.KeyCodes.down) {
	                switch (currentSelectedAction) {
	                    case Suggestions_types_1.SuggestionActionType.forceResolve:
	                        if (suggestionLength > 0) {
	                            _this._refocusOnSuggestions(keyCode);
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.none;
	                        }
	                        else if (_this._searchForMoreButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.searchMore;
	                        }
	                        else {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.forceResolve;
	                        }
	                        break;
	                    case Suggestions_types_1.SuggestionActionType.searchMore:
	                        if (_this._forceResolveButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.forceResolve;
	                        }
	                        else if (suggestionLength > 0) {
	                            _this._refocusOnSuggestions(keyCode);
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.none;
	                        }
	                        else {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.searchMore;
	                        }
	                        break;
	                    case Suggestions_types_1.SuggestionActionType.none:
	                        if (currentSuggestionIndex === -1 && _this._forceResolveButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.forceResolve;
	                        }
	                        break;
	                }
	            }
	            else if (keyCode === Utilities_1.KeyCodes.up) {
	                switch (currentSelectedAction) {
	                    case Suggestions_types_1.SuggestionActionType.forceResolve:
	                        if (_this._searchForMoreButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.searchMore;
	                        }
	                        else if (suggestionLength > 0) {
	                            _this._refocusOnSuggestions(keyCode);
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.none;
	                        }
	                        break;
	                    case Suggestions_types_1.SuggestionActionType.searchMore:
	                        if (suggestionLength > 0) {
	                            _this._refocusOnSuggestions(keyCode);
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.none;
	                        }
	                        else if (_this._forceResolveButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.forceResolve;
	                        }
	                        break;
	                    case Suggestions_types_1.SuggestionActionType.none:
	                        if (currentSuggestionIndex === -1 && _this._searchForMoreButton.current) {
	                            newSelectedActionType = Suggestions_types_1.SuggestionActionType.searchMore;
	                        }
	                        break;
	                }
	            }
	            if (newSelectedActionType !== null) {
	                _this.setState({ selectedActionType: newSelectedActionType });
	                isEventHandled = true;
	            }
	            return isEventHandled;
	        };
	        _this._getMoreResults = function () {
	            if (_this.props.onGetMoreResults) {
	                _this.props.onGetMoreResults();
	            }
	        };
	        _this._forceResolve = function () {
	            if (_this.props.createGenericItem) {
	                _this.props.createGenericItem();
	            }
	        };
	        _this._shouldShowForceResolve = function () {
	            return _this.props.showForceResolve ? _this.props.showForceResolve() : false;
	        };
	        _this._onClickTypedSuggestionsItem = function (item, index) {
	            return function (ev) {
	                _this.props.onSuggestionClick(ev, item, index);
	            };
	        };
	        _this._refocusOnSuggestions = function (keyCode) {
	            if (typeof _this.props.refocusSuggestions === 'function') {
	                _this.props.refocusSuggestions(keyCode);
	            }
	        };
	        _this._onRemoveTypedSuggestionsItem = function (item, index) {
	            return function (ev) {
	                var onSuggestionRemove = _this.props.onSuggestionRemove;
	                onSuggestionRemove(ev, item, index);
	                ev.stopPropagation();
	            };
	        };
	        _this.state = {
	            selectedActionType: Suggestions_types_1.SuggestionActionType.none
	        };
	        return _this;
	    }
	    Suggestions.prototype.componentDidMount = function () {
	        this.scrollSelected();
	        this.activeSelectedElement = this._selectedElement ? this._selectedElement.current : null;
	    };
	    Suggestions.prototype.componentDidUpdate = function () {
	        // Only scroll to selected element if the selected element has changed. Otherwise do nothing.
	        // This prevents some odd behavior where scrolling the active element out of view and clicking on a selected element
	        // will trigger a focus event and not give the clicked element the click.
	        if (this._selectedElement.current && this.activeSelectedElement !== this._selectedElement.current) {
	            this.scrollSelected();
	            this.activeSelectedElement = this._selectedElement.current;
	        }
	    };
	    Suggestions.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, forceResolveText = _a.forceResolveText, mostRecentlyUsedHeaderText = _a.mostRecentlyUsedHeaderText, searchForMoreText = _a.searchForMoreText, className = _a.className, moreSuggestionsAvailable = _a.moreSuggestionsAvailable, noResultsFoundText = _a.noResultsFoundText, suggestions = _a.suggestions, isLoading = _a.isLoading, isSearching = _a.isSearching, loadingText = _a.loadingText, onRenderNoResultFound = _a.onRenderNoResultFound, searchingText = _a.searchingText, isMostRecentlyUsedVisible = _a.isMostRecentlyUsedVisible, resultsMaximumNumber = _a.resultsMaximumNumber, resultsFooterFull = _a.resultsFooterFull, resultsFooter = _a.resultsFooter, _b = _a.isResultsFooterVisible, isResultsFooterVisible = _b === void 0 ? true : _b, suggestionsAvailableAlertText = _a.suggestionsAvailableAlertText, suggestionsHeaderText = _a.suggestionsHeaderText, suggestionsClassName = _a.suggestionsClassName, theme = _a.theme, styles = _a.styles;
	        // TODO
	        // Clean this up by leaving only the first part after removing support for SASS.
	        // Currently we can not remove the SASS styles from Suggestions class because it
	        // might be used by consumers separately from pickers extending from BasePicker
	        // and have not used the new 'styles' prop. Because it's expecting a type parameter,
	        // we can not use the 'styled' function without adding some helpers which can break
	        // downstream consumers who did not use the new helpers.
	        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
	        // in BasePicker when the typed Suggestions class is ready to be rendered. If the check
	        // passes we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
	        // then we just use the old SASS styles instead.
	        this._classNames = styles
	            ? getClassNames(styles, {
	                theme: theme,
	                className: className,
	                suggestionsClassName: suggestionsClassName,
	                forceResolveButtonSelected: this.state.selectedActionType === Suggestions_types_1.SuggestionActionType.forceResolve,
	                searchForMoreButtonSelected: this.state.selectedActionType === Suggestions_types_1.SuggestionActionType.searchMore
	            })
	            : {
	                root: Utilities_1.css('ms-Suggestions', className, legacyStyles.root),
	                title: Utilities_1.css('ms-Suggestions-title', legacyStyles.suggestionsTitle),
	                searchForMoreButton: Utilities_1.css('ms-SearchMore-button', legacyStyles.actionButton, (_c = {},
	                    _c['is-selected ' + legacyStyles.buttonSelected] = this.state.selectedActionType === Suggestions_types_1.SuggestionActionType.searchMore,
	                    _c)),
	                forceResolveButton: Utilities_1.css('ms-forceResolve-button', legacyStyles.actionButton, (_d = {},
	                    _d['is-selected ' + legacyStyles.buttonSelected] = this.state.selectedActionType === Suggestions_types_1.SuggestionActionType.forceResolve,
	                    _d)),
	                suggestionsAvailable: Utilities_1.css('ms-Suggestions-suggestionsAvailable', legacyStyles.suggestionsAvailable),
	                suggestionsContainer: Utilities_1.css('ms-Suggestions-container', legacyStyles.suggestionsContainer, suggestionsClassName),
	                noSuggestions: Utilities_1.css('ms-Suggestions-none', legacyStyles.suggestionsNone)
	            };
	        var spinnerStyles = this._classNames.subComponentStyles
	            ? this._classNames.subComponentStyles.spinner
	            : undefined;
	        // TODO: cleanup after refactor of pickers to composition pattern and remove SASS support.
	        var spinnerClassNameOrStyles = styles
	            ? { styles: spinnerStyles }
	            : { className: Utilities_1.css('ms-Suggestions-spinner', legacyStyles.suggestionsSpinner) };
	        var noResults = function () {
	            return noResultsFoundText ? (React.createElement("div", { role: "alert", className: _this._classNames.noSuggestions }, noResultsFoundText)) : null;
	        };
	        // MostRecently Used text should supercede the header text if it's there and available.
	        var headerText = suggestionsHeaderText;
	        if (isMostRecentlyUsedVisible && mostRecentlyUsedHeaderText) {
	            headerText = mostRecentlyUsedHeaderText;
	        }
	        var footerTitle = undefined;
	        if (isResultsFooterVisible) {
	            footerTitle = suggestions.length >= resultsMaximumNumber ? resultsFooterFull : resultsFooter;
	        }
	        var hasNoSuggestions = (!suggestions || !suggestions.length) && !isLoading;
	        return (React.createElement("div", { className: this._classNames.root },
	            headerText ? React.createElement("div", { className: this._classNames.title }, headerText) : null,
	            forceResolveText && this._shouldShowForceResolve() && (React.createElement(Button_1.CommandButton, { componentRef: this._forceResolveButton, className: this._classNames.forceResolveButton, onClick: this._forceResolve, "data-automationid": 'sug-forceResolve' }, forceResolveText)),
	            isLoading && React.createElement(Spinner_1.Spinner, tslib_1.__assign({}, spinnerClassNameOrStyles, { label: loadingText })),
	            hasNoSuggestions ? (onRenderNoResultFound ? onRenderNoResultFound(undefined, noResults) : noResults()) : this._renderSuggestions(),
	            searchForMoreText && moreSuggestionsAvailable && (React.createElement(Button_1.CommandButton, { componentRef: this._searchForMoreButton, className: this._classNames.searchForMoreButton, iconProps: { iconName: 'Search' }, onClick: this._getMoreResults }, searchForMoreText)),
	            isSearching ? React.createElement(Spinner_1.Spinner, tslib_1.__assign({}, spinnerClassNameOrStyles, { label: searchingText })) : null,
	            footerTitle && !moreSuggestionsAvailable && !isMostRecentlyUsedVisible && !isSearching ? (React.createElement("div", { className: this._classNames.title }, footerTitle(this.props))) : null,
	            React.createElement("span", { role: "alert", "aria-live": "polite", className: this._classNames.suggestionsAvailable }, !isLoading && !isSearching && suggestions && suggestions.length > 0 && suggestionsAvailableAlertText
	                ? suggestionsAvailableAlertText
	                : null)));
	        var _c, _d;
	    };
	    Suggestions.prototype.hasSuggestedAction = function () {
	        return this._searchForMoreButton.current !== undefined || this._forceResolveButton.current !== undefined;
	    };
	    Suggestions.prototype.hasSuggestedActionSelected = function () {
	        return this.state.selectedActionType !== Suggestions_types_1.SuggestionActionType.none;
	    };
	    Suggestions.prototype.executeSelectedAction = function () {
	        switch (this.state.selectedActionType) {
	            case Suggestions_types_1.SuggestionActionType.forceResolve:
	                this._forceResolve();
	                break;
	            case Suggestions_types_1.SuggestionActionType.searchMore:
	                this._getMoreResults();
	                break;
	        }
	    };
	    Suggestions.prototype.focusAboveSuggestions = function () {
	        if (this._forceResolveButton.current) {
	            this.setState({ selectedActionType: Suggestions_types_1.SuggestionActionType.forceResolve });
	        }
	        else if (this._searchForMoreButton.current) {
	            this.setState({ selectedActionType: Suggestions_types_1.SuggestionActionType.searchMore });
	        }
	    };
	    Suggestions.prototype.focusBelowSuggestions = function () {
	        if (this._searchForMoreButton.current) {
	            this.setState({ selectedActionType: Suggestions_types_1.SuggestionActionType.searchMore });
	        }
	        else if (this._forceResolveButton.current) {
	            this.setState({ selectedActionType: Suggestions_types_1.SuggestionActionType.forceResolve });
	        }
	    };
	    Suggestions.prototype.focusSearchForMoreButton = function () {
	        if (this._searchForMoreButton.current) {
	            this._searchForMoreButton.current.focus();
	        }
	    };
	    // TODO get the element to scroll into view properly regardless of direction.
	    Suggestions.prototype.scrollSelected = function () {
	        if (this._selectedElement.current && this._selectedElement.current.scrollIntoView !== undefined) {
	            this._selectedElement.current.scrollIntoView(false);
	        }
	    };
	    Suggestions.prototype._renderSuggestions = function () {
	        var _this = this;
	        var _a = this.props, onRenderSuggestion = _a.onRenderSuggestion, removeSuggestionAriaLabel = _a.removeSuggestionAriaLabel, suggestionsItemClassName = _a.suggestionsItemClassName, resultsMaximumNumber = _a.resultsMaximumNumber, showRemoveButtons = _a.showRemoveButtons, suggestionsContainerAriaLabel = _a.suggestionsContainerAriaLabel, suggestionsListId = _a.suggestionsListId;
	        var suggestions = this.props.suggestions;
	        var StyledTypedSuggestionsItem = StyledSuggestionsItem;
	        var selectedIndex = -1;
	        suggestions.some(function (element, index) {
	            if (element.selected) {
	                selectedIndex = index;
	                return true;
	            }
	            return false;
	        });
	        if (resultsMaximumNumber) {
	            suggestions =
	                selectedIndex >= resultsMaximumNumber
	                    ? suggestions.slice(selectedIndex - resultsMaximumNumber + 1, selectedIndex + 1)
	                    : suggestions.slice(0, resultsMaximumNumber);
	        }
	        if (suggestions.length === 0) {
	            return null;
	        }
	        return (React.createElement("div", { className: this._classNames.suggestionsContainer, id: suggestionsListId, role: "listbox", "aria-label": suggestionsContainerAriaLabel }, suggestions.map(function (suggestion, index) { return (React.createElement("div", { ref: suggestion.selected ? _this._selectedElement : undefined, 
	            // tslint:disable-next-line:no-string-literal
	            key: suggestion.item['key'] ? suggestion.item['key'] : index, id: 'sug-' + index, "aria-selected": suggestion.selected, role: "option", "aria-label": suggestion.ariaLabel },
	            React.createElement(StyledTypedSuggestionsItem, { suggestionModel: suggestion, RenderSuggestion: onRenderSuggestion, onClick: _this._onClickTypedSuggestionsItem(suggestion.item, index), className: suggestionsItemClassName, showRemoveButton: showRemoveButtons, removeButtonAriaLabel: removeSuggestionAriaLabel, onRemoveItem: _this._onRemoveTypedSuggestionsItem(suggestion.item, index) }))); })));
	    };
	    return Suggestions;
	}(Utilities_1.BaseComponent));
	exports.Suggestions = Suggestions;
	//# sourceMappingURL=Suggestions.js.map

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Enum to help identify which suggestions action button is selected.
	 * {@docCategory Pickers}
	 */
	var SuggestionActionType;
	(function (SuggestionActionType) {
	    /** None of the actions is selected. */
	    SuggestionActionType[SuggestionActionType["none"] = 0] = "none";
	    /** ForceResolve action is selected. */
	    SuggestionActionType[SuggestionActionType["forceResolve"] = 1] = "forceResolve";
	    /** SearchMore action is selected. */
	    SuggestionActionType[SuggestionActionType["searchMore"] = 2] = "searchMore";
	})(SuggestionActionType = exports.SuggestionActionType || (exports.SuggestionActionType = {}));
	//# sourceMappingURL=Suggestions.types.js.map

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var stylesImport = __webpack_require__(1014);
	var legacyStyles = stylesImport;
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Pickers}
	 */
	var SuggestionsItem = /** @class */ (function (_super) {
	    tslib_1.__extends(SuggestionsItem, _super);
	    function SuggestionsItem() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SuggestionsItem.prototype.render = function () {
	        var _a = this.props, suggestionModel = _a.suggestionModel, RenderSuggestion = _a.RenderSuggestion, onClick = _a.onClick, className = _a.className, onRemoveItem = _a.onRemoveItem, isSelectedOverride = _a.isSelectedOverride, removeButtonAriaLabel = _a.removeButtonAriaLabel, styles = _a.styles, theme = _a.theme;
	        // TODO
	        // Clean this up by leaving only the first part after removing support for SASS.
	        // Currently we can not remove the SASS styles from SuggestionsItem class because it
	        // might be used by consumers separately from pickers extending from BasePicker
	        // and have not used the new 'styles' prop. Because it's expecting a type parameter,
	        // we can not use the 'styled' function without adding some helpers which can break
	        // downstream consumers who did not use the new helpers.
	        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
	        // in Suggestions when the typed SuggestionsItem class is ready to be rendered. If the
	        // check passes we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
	        // then we just use the old SASS styles instead.
	        var classNames = styles
	            ? getClassNames(styles, {
	                theme: theme,
	                className: className,
	                suggested: suggestionModel.selected || isSelectedOverride
	            })
	            : {
	                root: Utilities_1.css('ms-Suggestions-item', legacyStyles.suggestionsItem, (_b = {},
	                    _b['is-suggested ' + legacyStyles.suggestionsItemIsSuggested] = suggestionModel.selected || isSelectedOverride,
	                    _b), className),
	                itemButton: Utilities_1.css('ms-Suggestions-itemButton', legacyStyles.itemButton),
	                closeButton: Utilities_1.css('ms-Suggestions-closeButton', legacyStyles.closeButton)
	            };
	        return (React.createElement("div", { className: classNames.root },
	            React.createElement(Button_1.CommandButton, { onClick: onClick, className: classNames.itemButton }, RenderSuggestion(suggestionModel.item, this.props)),
	            this.props.showRemoveButton ? (React.createElement(Button_1.IconButton, { iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, title: removeButtonAriaLabel, ariaLabel: removeButtonAriaLabel, onClick: onRemoveItem, className: classNames.closeButton })) : null));
	        var _b;
	    };
	    return SuggestionsItem;
	}(Utilities_1.BaseComponent));
	exports.SuggestionsItem = SuggestionsItem;
	//# sourceMappingURL=SuggestionsItem.js.map

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".root_18d80577{min-width:260px}.suggestionsItem_18d80577{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;position:relative;overflow:hidden}.suggestionsItem_18d80577:hover{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": "}.suggestionsItem_18d80577:hover .closeButton_18d80577{display:block}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577{background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577:hover{background:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577:hover{background:Highlight;color:HighlightText}}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577{background:Highlight;color:HighlightText;-ms-high-contrast-adjust:none}}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577 .closeButton_18d80577:hover{background:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577 .itemButton_18d80577{color:HighlightText}}.suggestionsItem_18d80577 .closeButton_18d80577{display:none;color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.suggestionsItem_18d80577 .closeButton_18d80577:hover{background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.actionButton_18d80577{background:none;background-color:transparent;border:0;cursor:pointer;margin:0;position:relative;border-top:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";height:40px;width:100%;font-size:12px}[dir='ltr'] .actionButton_18d80577{padding-left:8px}[dir='rtl'] .actionButton_18d80577{padding-right:8px}html[dir='ltr'] .actionButton_18d80577{text-align:left}html[dir='rtl'] .actionButton_18d80577{text-align:right}.actionButton_18d80577:hover{background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";cursor:pointer}.actionButton_18d80577:focus,.actionButton_18d80577:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.actionButton_18d80577 .ms-Button-icon{font-size:16px;width:25px}.actionButton_18d80577 .ms-Button-label{margin:0 4px 0 9px}html[dir='rtl'] .actionButton_18d80577 .ms-Button-label{margin:0 9px 0 4px}.buttonSelected_18d80577{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.suggestionsTitle_18d80577{padding:0 12px;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";font-size:12px;line-height:40px;border-bottom:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsContainer_18d80577{overflow-y:auto;overflow-x:hidden;max-height:300px;border-bottom:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsNone_18d80577{text-align:center;color:#767676;font-size:12px;line-height:30px}.suggestionsSpinner_18d80577{margin:5px 0;white-space:nowrap;line-height:20px;font-size:12px}html[dir='ltr'] .suggestionsSpinner_18d80577{padding-left:14px}html[dir='rtl'] .suggestionsSpinner_18d80577{padding-right:14px}html[dir='ltr'] .suggestionsSpinner_18d80577{text-align:left}html[dir='rtl'] .suggestionsSpinner_18d80577{text-align:right}.suggestionsSpinner_18d80577 .ms-Spinner-circle{display:inline-block;vertical-align:middle}.suggestionsSpinner_18d80577 .ms-Spinner-label{display:inline-block;margin:0px 10px 0 16px;vertical-align:middle}html[dir='rtl'] .suggestionsSpinner_18d80577 .ms-Spinner-label{margin:0px 16px 0 10px}.itemButton_18d80577.itemButton_18d80577{width:100%;padding:0px;min-width:0;height:100%}@media screen and (-ms-high-contrast: active){.itemButton_18d80577.itemButton_18d80577{color:WindowText}}.itemButton_18d80577.itemButton_18d80577:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.closeButton_18d80577.closeButton_18d80577{padding:0 4px;height:auto;width:32px}@media screen and (-ms-high-contrast: active){.closeButton_18d80577.closeButton_18d80577{color:WindowText}}.closeButton_18d80577.closeButton_18d80577:hover{background:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.suggestionsAvailable_18d80577{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
	exports.root = "root_18d80577";
	exports.suggestionsItem = "suggestionsItem_18d80577";
	exports.closeButton = "closeButton_18d80577";
	exports.suggestionsItemIsSuggested = "suggestionsItemIsSuggested_18d80577";
	exports.itemButton = "itemButton_18d80577";
	exports.actionButton = "actionButton_18d80577";
	exports.buttonSelected = "buttonSelected_18d80577";
	exports.suggestionsTitle = "suggestionsTitle_18d80577";
	exports.suggestionsContainer = "suggestionsContainer_18d80577";
	exports.suggestionsNone = "suggestionsNone_18d80577";
	exports.suggestionsSpinner = "suggestionsSpinner_18d80577";
	exports.suggestionsAvailable = "suggestionsAvailable_18d80577";
	//# sourceMappingURL=Suggestions.scss.js.map

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.SuggestionsItemGlobalClassNames = {
	    root: 'ms-Suggestions-item',
	    itemButton: 'ms-Suggestions-itemButton',
	    closeButton: 'ms-Suggestions-closeButton',
	    isSuggested: 'is-suggested'
	};
	function getStyles(props) {
	    var className = props.className, theme = props.theme, suggested = props.suggested;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(exports.SuggestionsItemGlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                display: 'flex',
	                alignItems: 'stretch',
	                boxSizing: 'border-box',
	                width: '100%',
	                position: 'relative',
	                selectors: {
	                    '&:hover': {
	                        background: palette.neutralLighter
	                    },
	                    '&:hover .ms-Suggestions-closeButton': {
	                        display: 'block'
	                    }
	                }
	            },
	            className
	        ],
	        itemButton: [
	            classNames.itemButton,
	            {
	                width: '100%',
	                padding: 0,
	                border: 'none',
	                height: '100%',
	                // Force the item button to be collapsible so it can always shrink
	                // to accommodate the close button as a peer in its flex container.
	                minWidth: 0,
	                // Require for IE11 to truncate the component.
	                overflow: 'hidden',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'WindowText',
	                        selectors: {
	                            ':hover': {
	                                background: 'Highlight',
	                                color: 'HighlightText',
	                                MsHighContrastAdjust: 'none'
	                            }
	                        }
	                    },
	                    _a[':hover'] = {
	                        color: palette.neutralDark
	                    },
	                    _a)
	            },
	            suggested && [
	                classNames.isSuggested,
	                {
	                    background: palette.neutralLight,
	                    selectors: (_b = {
	                            ':hover': {
	                                background: palette.neutralTertiaryAlt
	                            }
	                        },
	                        _b[Styling_1.HighContrastSelector] = {
	                            background: 'Highlight',
	                            color: 'HighlightText',
	                            MsHighContrastAdjust: 'none'
	                        },
	                        _b)
	                }
	            ]
	        ],
	        closeButton: [
	            classNames.closeButton,
	            {
	                display: 'none',
	                color: palette.neutralSecondary,
	                padding: '0 4px',
	                height: 'auto',
	                width: 32,
	                selectors: (_c = {
	                        ':hover, :active': {
	                            background: palette.neutralTertiaryAlt,
	                            color: palette.neutralDark
	                        }
	                    },
	                    _c[Styling_1.HighContrastSelector] = {
	                        color: 'WindowText'
	                    },
	                    _c)
	            },
	            suggested && {
	                selectors: {
	                    ':hover, :active': {
	                        background: palette.neutralTertiary,
	                        color: palette.neutralPrimary
	                    }
	                }
	            }
	        ]
	    };
	    var _a, _b, _c;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=SuggestionsItem.styles.js.map

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Pickers}
	 */
	var SuggestionsController = /** @class */ (function () {
	    function SuggestionsController() {
	        var _this = this;
	        this._isSuggestionModel = function (value) {
	            return value.item !== undefined;
	        };
	        this._ensureSuggestionModel = function (suggestion) {
	            if (_this._isSuggestionModel(suggestion)) {
	                return suggestion;
	            }
	            else {
	                return {
	                    item: suggestion,
	                    selected: false,
	                    ariaLabel: suggestion.name || suggestion.primaryText
	                };
	            }
	        };
	        this.suggestions = [];
	        this.currentIndex = -1;
	    }
	    SuggestionsController.prototype.updateSuggestions = function (newSuggestions, selectedIndex) {
	        if (newSuggestions && newSuggestions.length > 0) {
	            this.suggestions = this.convertSuggestionsToSuggestionItems(newSuggestions);
	            this.currentIndex = selectedIndex ? selectedIndex : 0;
	            if (selectedIndex === -1) {
	                this.currentSuggestion = undefined;
	            }
	            else if (selectedIndex !== undefined) {
	                this.suggestions[selectedIndex].selected = true;
	                this.currentSuggestion = this.suggestions[selectedIndex];
	            }
	        }
	        else {
	            this.suggestions = [];
	            this.currentIndex = -1;
	            this.currentSuggestion = undefined;
	        }
	    };
	    /**
	     * Increments the suggestion index and gets the next suggestion in the list.
	     */
	    SuggestionsController.prototype.nextSuggestion = function () {
	        if (this.suggestions && this.suggestions.length) {
	            if (this.currentIndex < this.suggestions.length - 1) {
	                this.setSelectedSuggestion(this.currentIndex + 1);
	                return true;
	            }
	            else if (this.currentIndex === this.suggestions.length - 1) {
	                this.setSelectedSuggestion(0);
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Decrements the suggestion index and gets the previous suggestion in the list.
	     */
	    SuggestionsController.prototype.previousSuggestion = function () {
	        if (this.suggestions && this.suggestions.length) {
	            if (this.currentIndex > 0) {
	                this.setSelectedSuggestion(this.currentIndex - 1);
	                return true;
	            }
	            else if (this.currentIndex === 0) {
	                this.setSelectedSuggestion(this.suggestions.length - 1);
	                return true;
	            }
	        }
	        return false;
	    };
	    SuggestionsController.prototype.getSuggestions = function () {
	        return this.suggestions;
	    };
	    SuggestionsController.prototype.getCurrentItem = function () {
	        return this.currentSuggestion;
	    };
	    SuggestionsController.prototype.getSuggestionAtIndex = function (index) {
	        return this.suggestions[index];
	    };
	    SuggestionsController.prototype.hasSelectedSuggestion = function () {
	        return this.currentSuggestion ? true : false;
	    };
	    SuggestionsController.prototype.removeSuggestion = function (index) {
	        this.suggestions.splice(index, 1);
	    };
	    SuggestionsController.prototype.createGenericSuggestion = function (itemToConvert) {
	        var itemToAdd = this.convertSuggestionsToSuggestionItems([itemToConvert])[0];
	        this.currentSuggestion = itemToAdd;
	    };
	    SuggestionsController.prototype.convertSuggestionsToSuggestionItems = function (suggestions) {
	        return Array.isArray(suggestions) ? suggestions.map(this._ensureSuggestionModel) : [];
	    };
	    SuggestionsController.prototype.deselectAllSuggestions = function () {
	        if (this.currentIndex > -1) {
	            this.suggestions[this.currentIndex].selected = false;
	            this.currentIndex = -1;
	        }
	    };
	    SuggestionsController.prototype.setSelectedSuggestion = function (index) {
	        if (index > this.suggestions.length - 1 || index < 0) {
	            this.currentIndex = 0;
	            this.currentSuggestion.selected = false;
	            this.currentSuggestion = this.suggestions[0];
	            this.currentSuggestion.selected = true;
	        }
	        else {
	            if (this.currentIndex > -1) {
	                this.suggestions[this.currentIndex].selected = false;
	            }
	            this.suggestions[index].selected = true;
	            this.currentIndex = index;
	            this.currentSuggestion = this.suggestions[index];
	        }
	    };
	    return SuggestionsController;
	}());
	exports.SuggestionsController = SuggestionsController;
	//# sourceMappingURL=SuggestionsController.js.map

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	// Deprecated, import directly from the component folder now.
	tslib_1.__exportStar(__webpack_require__(666), exports);
	//# sourceMappingURL=BaseAutoFill.js.map

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var Callout_1 = __webpack_require__(603);
	var index_1 = __webpack_require__(866);
	var Suggestions_1 = __webpack_require__(1011);
	var Suggestions_styles_1 = __webpack_require__(1019);
	var SuggestionsController_1 = __webpack_require__(1016);
	var BasePicker_types_1 = __webpack_require__(1020);
	var index_2 = __webpack_require__(665);
	var stylesImport = __webpack_require__(1021);
	var legacyStyles = stylesImport;
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * Should be removed once new picker without inheritance is created
	 */
	function getStyledSuggestions(suggestionsType) {
	    return Utilities_1.styled(suggestionsType, Suggestions_styles_1.getStyles, undefined, {
	        scope: 'Suggestions'
	    });
	}
	/**
	 * {@docCategory Pickers}
	 */
	var BasePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BasePicker, _super);
	    function BasePicker(basePickerProps) {
	        var _this = _super.call(this, basePickerProps) || this;
	        // Refs
	        _this.root = React.createRef();
	        _this.input = React.createRef();
	        _this.focusZone = React.createRef();
	        _this.suggestionElement = React.createRef();
	        /**
	         * @deprecated this is no longer necessary as typescript now supports generic elements
	         */
	        _this.SuggestionOfProperType = Suggestions_1.Suggestions;
	        _this._styledSuggestions = getStyledSuggestions(_this.SuggestionOfProperType);
	        _this.dismissSuggestions = function (ev) {
	            var selectItemFunction = function () {
	                if (_this.props.onDismiss) {
	                    _this.props.onDismiss(ev, _this.suggestionStore.currentSuggestion ? _this.suggestionStore.currentSuggestion.item : undefined);
	                }
	                if (!ev || (ev && !ev.defaultPrevented)) {
	                    // Select the first suggestion if one is available when user leaves.
	                    if (_this.canAddItems() && _this.suggestionStore.hasSelectedSuggestion() && _this.state.suggestedDisplayValue) {
	                        _this.addItemByIndex(0);
	                    }
	                }
	            };
	            if (_this.currentPromise) {
	                _this.currentPromise.then(function () { return selectItemFunction(); });
	            }
	            else {
	                selectItemFunction();
	            }
	            _this.setState({ suggestionsVisible: false });
	        };
	        _this.refocusSuggestions = function (keyCode) {
	            _this.resetFocus();
	            if (_this.suggestionStore.suggestions && _this.suggestionStore.suggestions.length > 0) {
	                if (keyCode === Utilities_1.KeyCodes.up) {
	                    _this.suggestionStore.setSelectedSuggestion(_this.suggestionStore.suggestions.length - 1);
	                }
	                else if (keyCode === Utilities_1.KeyCodes.down) {
	                    _this.suggestionStore.setSelectedSuggestion(0);
	                }
	            }
	        };
	        _this.onInputChange = function (value) {
	            _this.updateValue(value);
	            _this.setState({
	                moreSuggestionsAvailable: true,
	                isMostRecentlyUsedVisible: false
	            });
	        };
	        _this.onSuggestionClick = function (ev, item, index) {
	            _this.addItemByIndex(index);
	            _this.setState({ suggestionsVisible: false });
	        };
	        _this.onSuggestionRemove = function (ev, item, index) {
	            if (_this.props.onRemoveSuggestion) {
	                _this.props.onRemoveSuggestion(item);
	            }
	            _this.suggestionStore.removeSuggestion(index);
	        };
	        _this.onInputFocus = function (ev) {
	            // Only trigger all of the focus if this component isn't already focused.
	            // For example when an item is selected or removed from the selected list it should be treated
	            // as though the input is still focused.
	            if (!_this.state.isFocused) {
	                _this.setState({ isFocused: true });
	                _this.selection.setAllSelected(false);
	                if (_this.input.current && _this.input.current.value === '' && _this.props.onEmptyInputFocus) {
	                    _this.onEmptyInputFocus();
	                    _this.setState({
	                        isMostRecentlyUsedVisible: true,
	                        moreSuggestionsAvailable: false,
	                        suggestionsVisible: true
	                    });
	                }
	                else if (_this.input.current && _this.input.current.value) {
	                    _this.setState({
	                        isMostRecentlyUsedVisible: false,
	                        suggestionsVisible: true
	                    });
	                }
	                if (_this.props.inputProps && _this.props.inputProps.onFocus) {
	                    _this.props.inputProps.onFocus(ev);
	                }
	            }
	        };
	        _this.onInputBlur = function (ev) {
	            if (_this.props.inputProps && _this.props.inputProps.onBlur) {
	                _this.props.inputProps.onBlur(ev);
	            }
	        };
	        _this.onBlur = function (ev) {
	            if (_this.state.isFocused) {
	                // Only blur the entire component if an unrelated element gets focus. Otherwise treat it as though it still has focus.
	                // Do nothing if the blur is coming from something
	                // inside the comboBox root or the comboBox menu since
	                // it we are not really bluring from the whole comboBox
	                var relatedTarget = ev.relatedTarget;
	                if (ev.relatedTarget === null) {
	                    // In IE11, due to lack of support, event.relatedTarget is always
	                    // null making every onBlur call to be "outside" of the ComboBox
	                    // even when it's not. Using document.activeElement is another way
	                    // for us to be able to get what the relatedTarget without relying
	                    // on the event
	                    relatedTarget = document.activeElement;
	                }
	                if (relatedTarget && !Utilities_1.elementContains(_this.root.current, relatedTarget)) {
	                    _this.setState({ isFocused: false });
	                    if (_this.props.onBlur) {
	                        _this.props.onBlur(ev);
	                    }
	                }
	            }
	        };
	        _this.onKeyDown = function (ev) {
	            var keyCode = ev.which;
	            switch (keyCode) {
	                case Utilities_1.KeyCodes.escape:
	                    if (_this.state.suggestionsVisible) {
	                        _this.setState({ suggestionsVisible: false });
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                    }
	                    break;
	                case Utilities_1.KeyCodes.tab:
	                case Utilities_1.KeyCodes.enter:
	                    if (_this.suggestionElement.current && _this.suggestionElement.current.hasSuggestedActionSelected()) {
	                        _this.suggestionElement.current.executeSelectedAction();
	                    }
	                    else if (!ev.shiftKey && _this.suggestionStore.hasSelectedSuggestion() && _this.state.suggestionsVisible) {
	                        _this.completeSuggestion();
	                        ev.preventDefault();
	                        ev.stopPropagation();
	                    }
	                    else {
	                        _this._completeGenericSuggestion();
	                    }
	                    break;
	                case Utilities_1.KeyCodes.backspace:
	                    if (!_this.props.disabled) {
	                        _this.onBackspace(ev);
	                    }
	                    ev.stopPropagation();
	                    break;
	                case Utilities_1.KeyCodes.del:
	                    if (!_this.props.disabled) {
	                        if (_this.input.current &&
	                            ev.target === _this.input.current.inputElement &&
	                            _this.state.suggestionsVisible &&
	                            _this.suggestionStore.currentIndex !== -1) {
	                            if (_this.props.onRemoveSuggestion) {
	                                _this.props.onRemoveSuggestion(_this.suggestionStore.currentSuggestion.item);
	                            }
	                            _this.suggestionStore.removeSuggestion(_this.suggestionStore.currentIndex);
	                            _this.forceUpdate();
	                        }
	                        else {
	                            _this.onBackspace(ev);
	                        }
	                    }
	                    ev.stopPropagation();
	                    break;
	                case Utilities_1.KeyCodes.up:
	                    if (_this.input.current && ev.target === _this.input.current.inputElement && _this.state.suggestionsVisible) {
	                        if (_this.suggestionElement.current &&
	                            _this.suggestionElement.current.tryHandleKeyDown(keyCode, _this.suggestionStore.currentIndex)) {
	                            ev.preventDefault();
	                            ev.stopPropagation();
	                        }
	                        else {
	                            if (_this.suggestionElement.current &&
	                                _this.suggestionElement.current.hasSuggestedAction() &&
	                                _this.suggestionStore.currentIndex === 0) {
	                                ev.preventDefault();
	                                ev.stopPropagation();
	                                _this.suggestionElement.current.focusAboveSuggestions();
	                                _this.suggestionStore.deselectAllSuggestions();
	                                _this.forceUpdate();
	                            }
	                            else {
	                                if (_this.suggestionStore.previousSuggestion()) {
	                                    ev.preventDefault();
	                                    ev.stopPropagation();
	                                    _this.onSuggestionSelect();
	                                }
	                            }
	                        }
	                    }
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    if (_this.input.current && ev.target === _this.input.current.inputElement && _this.state.suggestionsVisible) {
	                        if (_this.suggestionElement.current &&
	                            _this.suggestionElement.current.tryHandleKeyDown(keyCode, _this.suggestionStore.currentIndex)) {
	                            ev.preventDefault();
	                            ev.stopPropagation();
	                        }
	                        else {
	                            if (_this.suggestionElement.current &&
	                                _this.suggestionElement.current.hasSuggestedAction() &&
	                                _this.suggestionStore.currentIndex + 1 === _this.suggestionStore.suggestions.length) {
	                                ev.preventDefault();
	                                ev.stopPropagation();
	                                _this.suggestionElement.current.focusBelowSuggestions();
	                                _this.suggestionStore.deselectAllSuggestions();
	                                _this.forceUpdate();
	                            }
	                            else {
	                                if (_this.suggestionStore.nextSuggestion()) {
	                                    ev.preventDefault();
	                                    ev.stopPropagation();
	                                    _this.onSuggestionSelect();
	                                }
	                            }
	                        }
	                    }
	                    break;
	            }
	        };
	        _this.onItemChange = function (changedItem, index) {
	            var items = _this.state.items;
	            if (index >= 0) {
	                var newItems = items;
	                newItems[index] = changedItem;
	                _this._updateSelectedItems(newItems);
	            }
	        };
	        _this.onGetMoreResults = function () {
	            _this.setState({
	                isSearching: true
	            }, function () {
	                if (_this.props.onGetMoreResults && _this.input.current) {
	                    var suggestions = _this.props.onGetMoreResults(_this.input.current.value, _this.state.items);
	                    var suggestionsArray = suggestions;
	                    var suggestionsPromiseLike = suggestions;
	                    if (Array.isArray(suggestionsArray)) {
	                        _this.updateSuggestions(suggestionsArray);
	                        _this.setState({ isSearching: false });
	                    }
	                    else if (suggestionsPromiseLike.then) {
	                        suggestionsPromiseLike.then(function (newSuggestions) {
	                            _this.updateSuggestions(newSuggestions);
	                            _this.setState({ isSearching: false });
	                        });
	                    }
	                }
	                else {
	                    _this.setState({ isSearching: false });
	                }
	                if (_this.input.current) {
	                    _this.input.current.focus();
	                }
	                _this.setState({
	                    moreSuggestionsAvailable: false,
	                    isResultsFooterVisible: true
	                });
	            });
	        };
	        _this.addItemByIndex = function (index) {
	            _this.addItem(_this.suggestionStore.getSuggestionAtIndex(index).item);
	            if (_this.input.current) {
	                _this.input.current.clear();
	            }
	            _this.updateValue('');
	        };
	        _this.addItem = function (item) {
	            var processedItem = _this.props.onItemSelected ? _this.props.onItemSelected(item) : item;
	            if (processedItem === null) {
	                return;
	            }
	            var processedItemObject = processedItem;
	            var processedItemPromiseLike = processedItem;
	            if (processedItemPromiseLike && processedItemPromiseLike.then) {
	                processedItemPromiseLike.then(function (resolvedProcessedItem) {
	                    var newItems = _this.state.items.concat([resolvedProcessedItem]);
	                    _this._updateSelectedItems(newItems);
	                });
	            }
	            else {
	                var newItems = _this.state.items.concat([processedItemObject]);
	                _this._updateSelectedItems(newItems);
	            }
	            _this.setState({ suggestedDisplayValue: '' });
	        };
	        _this.removeItem = function (item, focusNextItem) {
	            var items = _this.state.items;
	            var index = items.indexOf(item);
	            if (index >= 0) {
	                var newItems = items.slice(0, index).concat(items.slice(index + 1));
	                _this._updateSelectedItems(newItems, focusNextItem ? index : undefined);
	            }
	        };
	        _this.removeItems = function (itemsToRemove) {
	            var items = _this.state.items;
	            var newItems = items.filter(function (item) { return itemsToRemove.indexOf(item) === -1; });
	            var firstItemToRemove = itemsToRemove[0];
	            var index = items.indexOf(firstItemToRemove);
	            _this._updateSelectedItems(newItems, index);
	        };
	        _this._isFocusZoneInnerKeystroke = function (ev) {
	            // If suggestions are shown const up/down keys control them, otherwise allow them through to control the focusZone.
	            if (_this.state.suggestionsVisible) {
	                switch (ev.which) {
	                    case Utilities_1.KeyCodes.up:
	                    case Utilities_1.KeyCodes.down:
	                        return true;
	                }
	            }
	            if (ev.which === Utilities_1.KeyCodes.enter) {
	                return true;
	            }
	            return false;
	        };
	        _this._completeGenericSuggestion = function () {
	            if (_this.props.onValidateInput &&
	                _this.input.current &&
	                _this.props.onValidateInput(_this.input.current.value) !== BasePicker_types_1.ValidationState.invalid &&
	                _this.props.createGenericItem) {
	                var itemToConvert = _this.props.createGenericItem(_this.input.current.value, _this.props.onValidateInput(_this.input.current.value));
	                _this.suggestionStore.createGenericSuggestion(itemToConvert);
	                _this.completeSuggestion();
	            }
	        };
	        var items = basePickerProps.selectedItems || basePickerProps.defaultSelectedItems || [];
	        _this._id = Utilities_1.getId();
	        _this._ariaMap = {
	            selectedItems: "selected-items-" + _this._id,
	            selectedSuggestionAlert: "selected-suggestion-alert-" + _this._id,
	            suggestionList: "suggestion-list-" + _this._id
	        };
	        _this.suggestionStore = new SuggestionsController_1.SuggestionsController();
	        _this.selection = new index_1.Selection({ onSelectionChanged: function () { return _this.onSelectionChange(); } });
	        _this.selection.setItems(items);
	        _this.state = {
	            items: items,
	            suggestedDisplayValue: '',
	            isMostRecentlyUsedVisible: false,
	            moreSuggestionsAvailable: false,
	            isFocused: false,
	            isSearching: false,
	            selectedIndices: []
	        };
	        return _this;
	    }
	    Object.defineProperty(BasePicker.prototype, "items", {
	        get: function () {
	            return this.state.items;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BasePicker.prototype.componentWillUpdate = function (newProps, newState) {
	        if (newState.items && newState.items !== this.state.items) {
	            this.selection.setItems(newState.items);
	        }
	    };
	    BasePicker.prototype.componentDidMount = function () {
	        this.selection.setItems(this.state.items);
	        this._onResolveSuggestions = this._async.debounce(this._onResolveSuggestions, this.props.resolveDelay);
	    };
	    BasePicker.prototype.componentWillReceiveProps = function (newProps) {
	        var _this = this;
	        var newItems = newProps.selectedItems;
	        if (newItems) {
	            var focusIndex_1;
	            // If there are less new items than old items then something was removed and we
	            // should try to keep focus consistent
	            if (newItems.length < this.state.items.length) {
	                focusIndex_1 = this.state.items.indexOf(this.selection.getSelection()[0]);
	            }
	            this.setState({
	                items: newProps.selectedItems
	            }, function () {
	                // Only update the focus if this component is currently focused to ensure that the basepicker
	                // doesn't steal focus from something else.
	                if (_this.state.isFocused) {
	                    // Need to reset focus in the same that way that we do if an item is selected by a non-controlled component
	                    // See _onSelectedItemsUpdated.
	                    _this.resetFocus(focusIndex_1);
	                }
	            });
	        }
	    };
	    BasePicker.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	        if (this.currentPromise) {
	            this.currentPromise = undefined;
	        }
	    };
	    BasePicker.prototype.focus = function () {
	        if (this.focusZone.current) {
	            this.focusZone.current.focus();
	        }
	    };
	    BasePicker.prototype.focusInput = function () {
	        if (this.input.current) {
	            this.input.current.focus();
	        }
	    };
	    BasePicker.prototype.completeSuggestion = function (forceComplete) {
	        if (this.suggestionStore.hasSelectedSuggestion() && this.input.current) {
	            this.addItem(this.suggestionStore.currentSuggestion.item);
	            this.updateValue('');
	            this.input.current.clear();
	        }
	        else if (forceComplete) {
	            this._completeGenericSuggestion();
	        }
	    };
	    BasePicker.prototype.render = function () {
	        var _a = this.state, suggestedDisplayValue = _a.suggestedDisplayValue, isFocused = _a.isFocused, items = _a.items;
	        var _b = this.props, className = _b.className, inputProps = _b.inputProps, disabled = _b.disabled, theme = _b.theme, styles = _b.styles;
	        var selectedSuggestionAlertId = this.props.enableSelectedSuggestionAlert ? this._ariaMap.selectedSuggestionAlert : '';
	        var suggestionsAvailable = this.state.suggestionsVisible ? this._ariaMap.suggestionList : '';
	        // TODO
	        // Clean this up by leaving only the first part after removing support for SASS.
	        // Currently we can not remove the SASS styles from BasePicker class because it
	        // might be used by consumers who created custom pickers from extending from
	        // this base class and have not used the new 'styles' prop.
	        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
	        // for every other already existing picker variant (PeoplePicker, TagPicker)
	        // so that we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
	        // then we just use the old SASS styles instead.
	        var classNames = styles
	            ? getClassNames(styles, {
	                theme: theme,
	                className: className,
	                isFocused: isFocused,
	                disabled: disabled,
	                inputClassName: inputProps && inputProps.className
	            })
	            : {
	                root: Utilities_1.css('ms-BasePicker', className ? className : ''),
	                text: Utilities_1.css('ms-BasePicker-text', legacyStyles.pickerText, this.state.isFocused && legacyStyles.inputFocused),
	                itemsWrapper: legacyStyles.pickerItems,
	                input: Utilities_1.css('ms-BasePicker-input', legacyStyles.pickerInput, inputProps && inputProps.className),
	                screenReaderText: legacyStyles.screenReaderOnly
	            };
	        return (React.createElement("div", { ref: this.root, className: classNames.root, onKeyDown: this.onKeyDown, onBlur: this.onBlur },
	            React.createElement(FocusZone_1.FocusZone, { componentRef: this.focusZone, direction: FocusZone_1.FocusZoneDirection.bidirectional, isInnerZoneKeystroke: this._isFocusZoneInnerKeystroke },
	                this.getSuggestionsAlert(classNames.screenReaderText),
	                React.createElement(index_1.SelectionZone, { selection: this.selection, selectionMode: index_1.SelectionMode.multiple },
	                    React.createElement("div", { className: classNames.text },
	                        items.length > 0 && (React.createElement("span", { id: this._ariaMap.selectedItems, className: classNames.itemsWrapper, role: 'list' }, this.renderItems())),
	                        this.canAddItems() && (React.createElement(index_2.Autofill, tslib_1.__assign({ spellCheck: false }, inputProps, { className: classNames.input, componentRef: this.input, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onInputValueChange: this.onInputChange, suggestedDisplayValue: suggestedDisplayValue, "aria-activedescendant": this.getActiveDescendant(), "aria-expanded": !!this.state.suggestionsVisible, "aria-haspopup": "true", "aria-describedby": items.length > 0 ? this._ariaMap.selectedItems : undefined, role: 'combobox', disabled: disabled, "aria-controls": suggestionsAvailable + " " + selectedSuggestionAlertId || undefined, "aria-owns": suggestionsAvailable || undefined, onInputChange: this.props.onInputChange })))))),
	            this.renderSuggestions()));
	    };
	    BasePicker.prototype.canAddItems = function () {
	        var items = this.state.items;
	        var itemLimit = this.props.itemLimit;
	        return itemLimit === undefined || items.length < itemLimit;
	    };
	    BasePicker.prototype.renderSuggestions = function () {
	        var StyledTypedSuggestions = this._styledSuggestions;
	        return this.state.suggestionsVisible && this.input ? (React.createElement(Callout_1.Callout, tslib_1.__assign({ isBeakVisible: false, gapSpace: 5, target: this.input.current ? this.input.current.inputElement : undefined, onDismiss: this.dismissSuggestions, directionalHint: Callout_1.DirectionalHint.bottomLeftEdge, directionalHintForRTL: Callout_1.DirectionalHint.bottomRightEdge }, this.props.pickerCalloutProps),
	            React.createElement(StyledTypedSuggestions, tslib_1.__assign({ onRenderSuggestion: this.props.onRenderSuggestionsItem, onSuggestionClick: this.onSuggestionClick, onSuggestionRemove: this.onSuggestionRemove, suggestions: this.suggestionStore.getSuggestions(), componentRef: this.suggestionElement, onGetMoreResults: this.onGetMoreResults, moreSuggestionsAvailable: this.state.moreSuggestionsAvailable, isLoading: this.state.suggestionsLoading, isSearching: this.state.isSearching, isMostRecentlyUsedVisible: this.state.isMostRecentlyUsedVisible, isResultsFooterVisible: this.state.isResultsFooterVisible, refocusSuggestions: this.refocusSuggestions, removeSuggestionAriaLabel: this.props.removeButtonAriaLabel, suggestionsListId: this._ariaMap.suggestionList, createGenericItem: this._completeGenericSuggestion }, this.props.pickerSuggestionsProps)))) : null;
	    };
	    BasePicker.prototype.renderItems = function () {
	        var _this = this;
	        var _a = this.props, disabled = _a.disabled, removeButtonAriaLabel = _a.removeButtonAriaLabel;
	        var onRenderItem = this.props.onRenderItem;
	        var _b = this.state, items = _b.items, selectedIndices = _b.selectedIndices;
	        return items.map(function (item, index) {
	            return onRenderItem({
	                item: item,
	                index: index,
	                key: item.key ? item.key : index,
	                selected: selectedIndices.indexOf(index) !== -1,
	                onRemoveItem: function () { return _this.removeItem(item, true); },
	                disabled: disabled,
	                onItemChange: _this.onItemChange,
	                removeButtonAriaLabel: removeButtonAriaLabel
	            });
	        });
	    };
	    BasePicker.prototype.resetFocus = function (index) {
	        var items = this.state.items;
	        if (items.length && index >= 0) {
	            var newEl = this.root.current &&
	                this.root.current.querySelectorAll('[data-selection-index]')[Math.min(index, items.length - 1)];
	            if (newEl && this.focusZone.current) {
	                this.focusZone.current.focusElement(newEl);
	            }
	        }
	        else if (!this.canAddItems()) {
	            this.resetFocus(items.length - 1);
	        }
	        else {
	            if (this.input.current) {
	                this.input.current.focus();
	            }
	        }
	    };
	    BasePicker.prototype.onSuggestionSelect = function () {
	        if (this.suggestionStore.currentSuggestion) {
	            var currentValue = this.input.current ? this.input.current.value : '';
	            var itemValue = this._getTextFromItem(this.suggestionStore.currentSuggestion.item, currentValue);
	            this.setState({ suggestedDisplayValue: itemValue });
	        }
	    };
	    BasePicker.prototype.onSelectionChange = function () {
	        this.setState({
	            selectedIndices: this.selection.getSelectedIndices()
	        });
	    };
	    BasePicker.prototype.updateSuggestions = function (suggestions) {
	        this.suggestionStore.updateSuggestions(suggestions, 0);
	        this.forceUpdate();
	    };
	    BasePicker.prototype.onEmptyInputFocus = function () {
	        var onEmptyInputFocus = this.props.onEmptyInputFocus;
	        var suggestions = onEmptyInputFocus(this.state.items);
	        this.updateSuggestionsList(suggestions);
	    };
	    BasePicker.prototype.updateValue = function (updatedValue) {
	        this._onResolveSuggestions(updatedValue);
	    };
	    BasePicker.prototype.updateSuggestionsList = function (suggestions, updatedValue) {
	        var _this = this;
	        var suggestionsArray = suggestions;
	        var suggestionsPromiseLike = suggestions;
	        // Check to see if the returned value is an array, if it is then just pass it into the next function .
	        // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
	        if (Array.isArray(suggestionsArray)) {
	            this._updateAndResolveValue(updatedValue, suggestionsArray);
	        }
	        else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
	            this.setState({
	                suggestionsLoading: true
	            });
	            // Clear suggestions
	            this.suggestionStore.updateSuggestions([]);
	            if (updatedValue !== undefined) {
	                this.setState({
	                    suggestionsVisible: this.input.current
	                        ? this.input.current.value !== '' && this.input.current.inputElement === document.activeElement
	                        : false
	                });
	            }
	            else {
	                this.setState({
	                    suggestionsVisible: this.input.current ? this.input.current.inputElement === document.activeElement : false
	                });
	            }
	            // Ensure that the promise will only use the callback if it was the most recent one.
	            var promise_1 = (this.currentPromise = suggestionsPromiseLike);
	            promise_1.then(function (newSuggestions) {
	                if (promise_1 === _this.currentPromise) {
	                    _this._updateAndResolveValue(updatedValue, newSuggestions);
	                }
	            });
	        }
	    };
	    BasePicker.prototype.resolveNewValue = function (updatedValue, suggestions) {
	        var _this = this;
	        this.updateSuggestions(suggestions);
	        var itemValue = undefined;
	        if (this.suggestionStore.currentSuggestion) {
	            itemValue = this._getTextFromItem(this.suggestionStore.currentSuggestion.item, updatedValue);
	        }
	        // Only set suggestionloading to false after there has been time for the new suggestions to flow
	        // to the suggestions list. This is to ensure that the suggestions are available before aria-activedescendant
	        // is set so that screen readers will read out the first selected option.
	        this.setState({
	            suggestedDisplayValue: itemValue,
	            suggestionsVisible: this.input.current
	                ? this.input.current.value !== '' && this.input.current.inputElement === document.activeElement
	                : false
	        }, function () { return _this.setState({ suggestionsLoading: false }); });
	    };
	    BasePicker.prototype.onChange = function (items) {
	        if (this.props.onChange) {
	            this.props.onChange(items);
	        }
	    };
	    // This is protected because we may expect the backspace key to work differently in a different kind of picker.
	    // This lets the subclass override it and provide it's own onBackspace. For an example see the BasePickerListBelow
	    BasePicker.prototype.onBackspace = function (ev) {
	        if ((this.state.items.length && !this.input.current) ||
	            (this.input.current && !this.input.current.isValueSelected && this.input.current.cursorLocation === 0)) {
	            if (this.selection.getSelectedCount() > 0) {
	                this.removeItems(this.selection.getSelection());
	            }
	            else {
	                this.removeItem(this.state.items[this.state.items.length - 1]);
	            }
	        }
	    };
	    BasePicker.prototype.getActiveDescendant = function () {
	        var currentIndex = this.suggestionStore.currentIndex;
	        return currentIndex > -1 && !this.state.suggestionsLoading ? 'sug-' + currentIndex : undefined;
	    };
	    BasePicker.prototype.getSuggestionsAlert = function (suggestionAlertClassName) {
	        if (suggestionAlertClassName === void 0) { suggestionAlertClassName = legacyStyles.screenReaderOnly; }
	        var currentIndex = this.suggestionStore.currentIndex;
	        if (this.props.enableSelectedSuggestionAlert) {
	            var selectedSuggestion = currentIndex > -1 ? this.suggestionStore.getSuggestionAtIndex(this.suggestionStore.currentIndex) : undefined;
	            var selectedSuggestionAlertText = selectedSuggestion ? selectedSuggestion.ariaLabel : undefined;
	            return (React.createElement("div", { className: suggestionAlertClassName, role: "alert", id: this._ariaMap.selectedSuggestionAlert, "aria-live": "assertive" },
	                selectedSuggestionAlertText,
	                ' '));
	        }
	    };
	    /**
	     * Takes in the current updated value and either resolves it with the new suggestions
	     * or if updated value is undefined then it clears out currently suggested items
	     */
	    BasePicker.prototype._updateAndResolveValue = function (updatedValue, newSuggestions) {
	        if (updatedValue !== undefined) {
	            this.resolveNewValue(updatedValue, newSuggestions);
	        }
	        else {
	            this.suggestionStore.updateSuggestions(newSuggestions, -1);
	            if (this.state.suggestionsLoading) {
	                this.setState({
	                    suggestionsLoading: false
	                });
	            }
	        }
	    };
	    /**
	     * Controls what happens whenever there is an action that impacts the selected items.
	     * If selectedItems is provided as a property then this will act as a controlled component and it will not update it's own state.
	     */
	    BasePicker.prototype._updateSelectedItems = function (items, focusIndex) {
	        var _this = this;
	        if (this.props.selectedItems) {
	            // If the component is a controlled component then the controlling component will need to add or remove the items.
	            this.onChange(items);
	        }
	        else {
	            this.setState({ items: items }, function () {
	                _this._onSelectedItemsUpdated(items, focusIndex);
	            });
	        }
	    };
	    BasePicker.prototype._onSelectedItemsUpdated = function (items, focusIndex) {
	        this.resetFocus(focusIndex);
	        this.onChange(items);
	    };
	    BasePicker.prototype._onResolveSuggestions = function (updatedValue) {
	        var suggestions = this.props.onResolveSuggestions(updatedValue, this.state.items);
	        if (suggestions !== null) {
	            this.updateSuggestionsList(suggestions, updatedValue);
	        }
	    };
	    BasePicker.prototype._getTextFromItem = function (item, currentValue) {
	        if (this.props.getTextFromItem) {
	            return this.props.getTextFromItem(item, currentValue);
	        }
	        else {
	            return '';
	        }
	    };
	    return BasePicker;
	}(Utilities_1.BaseComponent));
	exports.BasePicker = BasePicker;
	var BasePickerListBelow = /** @class */ (function (_super) {
	    tslib_1.__extends(BasePickerListBelow, _super);
	    function BasePickerListBelow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BasePickerListBelow.prototype.render = function () {
	        var _a = this.state, suggestedDisplayValue = _a.suggestedDisplayValue, isFocused = _a.isFocused;
	        var _b = this.props, className = _b.className, inputProps = _b.inputProps, disabled = _b.disabled, theme = _b.theme, styles = _b.styles;
	        var selectedSuggestionAlertId = this.props.enableSelectedSuggestionAlert
	            ? this._ariaMap.selectedSuggestionAlert
	            : '';
	        var suggestionsAvailable = this.state.suggestionsVisible ? this._ariaMap.suggestionList : '';
	        // TODO
	        // Clean this up by leaving only the first part after removing support for SASS.
	        // Currently we can not remove the SASS styles from BasePicker class because it
	        // might be used by consumers who created custom pickers from extending from
	        // this base class and have not used the new 'styles' prop.
	        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
	        // for every other already existing picker variant (PeoplePicker, TagPicker)
	        // so that we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
	        // then we just use the old SASS styles instead.
	        var classNames = styles
	            ? getClassNames(styles, {
	                theme: theme,
	                className: className,
	                isFocused: isFocused,
	                inputClassName: inputProps && inputProps.className
	            })
	            : {
	                root: Utilities_1.css('ms-BasePicker', className ? className : ''),
	                text: Utilities_1.css('ms-BasePicker-text', legacyStyles.pickerText, this.state.isFocused && legacyStyles.inputFocused),
	                input: Utilities_1.css('ms-BasePicker-input', legacyStyles.pickerInput, inputProps && inputProps.className),
	                screenReaderText: legacyStyles.screenReaderOnly
	            };
	        return (React.createElement("div", { ref: this.root, onBlur: this.onBlur },
	            React.createElement("div", { className: classNames.root, onKeyDown: this.onKeyDown },
	                this.getSuggestionsAlert(classNames.screenReaderText),
	                React.createElement("div", { className: classNames.text },
	                    React.createElement(index_2.Autofill, tslib_1.__assign({}, inputProps, { className: classNames.input, componentRef: this.input, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onInputValueChange: this.onInputChange, suggestedDisplayValue: suggestedDisplayValue, "aria-activedescendant": this.getActiveDescendant(), "aria-expanded": !!this.state.suggestionsVisible, role: "combobox", disabled: disabled, "aria-controls": suggestionsAvailable + " " + selectedSuggestionAlertId || undefined, "aria-owns": suggestionsAvailable || undefined, onInputChange: this.props.onInputChange })))),
	            this.renderSuggestions(),
	            React.createElement(index_1.SelectionZone, { selection: this.selection, selectionMode: index_1.SelectionMode.single },
	                React.createElement(FocusZone_1.FocusZone, { componentRef: this.focusZone, className: "ms-BasePicker-selectedItems" // just a className hook without any styles applied to it.
	                    , isCircularNavigation: true, direction: FocusZone_1.FocusZoneDirection.bidirectional, isInnerZoneKeystroke: this._isFocusZoneInnerKeystroke, id: this._ariaMap.selectedItems, role: 'list' }, this.renderItems()))));
	    };
	    BasePickerListBelow.prototype.onBackspace = function (ev) {
	        // override the existing backspace method to not do anything because the list items appear below.
	    };
	    return BasePickerListBelow;
	}(BasePicker));
	exports.BasePickerListBelow = BasePickerListBelow;
	//# sourceMappingURL=BasePicker.js.map

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Suggestions',
	    suggestionsContainer: 'ms-Suggestions-container',
	    title: 'ms-Suggestions-title',
	    forceResolveButton: 'ms-forceResolve-button',
	    searchForMoreButton: 'ms-SearchMore-button',
	    spinner: 'ms-Suggestions-spinner',
	    noSuggestions: 'ms-Suggestions-none',
	    suggestionsAvailable: 'ms-Suggestions-suggestionsAvailable',
	    isSelected: 'is-selected'
	};
	function getStyles(props) {
	    var className = props.className, suggestionsClassName = props.suggestionsClassName, theme = props.theme, forceResolveButtonSelected = props.forceResolveButtonSelected, searchForMoreButtonSelected = props.searchForMoreButtonSelected;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var actionButtonStyles = {
	        background: 'none',
	        backgroundColor: 'transparent',
	        border: 0,
	        cursor: 'pointer',
	        margin: 0,
	        paddingLeft: 8,
	        position: 'relative',
	        borderTop: "1px solid " + palette.neutralLight,
	        height: 40,
	        textAlign: 'left',
	        width: '100%',
	        fontSize: Styling_1.FontSizes.small,
	        selectors: {
	            ':hover': {
	                backgroundColor: palette.neutralLight,
	                cursor: 'pointer'
	            },
	            ':focus, :active': {
	                backgroundColor: palette.themeLight
	            },
	            '.ms-Button-icon': {
	                fontSize: Styling_1.FontSizes.icon,
	                width: 25
	            },
	            '.ms-Button-label': {
	                margin: '0 4px 0 9px'
	            }
	        }
	    };
	    var actionButtonSelectedStyles = {
	        backgroundColor: palette.themeLight
	    };
	    return {
	        root: [
	            classNames.root,
	            {
	                minWidth: 260
	            },
	            className
	        ],
	        suggestionsContainer: [
	            classNames.suggestionsContainer,
	            {
	                overflowY: 'auto',
	                overflowX: 'hidden',
	                maxHeight: 300,
	                borderBottom: "1px solid " + palette.neutralLight
	            },
	            suggestionsClassName
	        ],
	        title: [
	            classNames.title,
	            {
	                padding: '0 12px',
	                fontSize: Styling_1.FontSizes.small,
	                color: palette.themePrimary,
	                lineHeight: 40,
	                borderBottom: "1px solid " + palette.neutralLight
	            }
	        ],
	        forceResolveButton: [
	            classNames.forceResolveButton,
	            actionButtonStyles,
	            forceResolveButtonSelected && [classNames.isSelected, actionButtonSelectedStyles]
	        ],
	        searchForMoreButton: [
	            classNames.searchForMoreButton,
	            actionButtonStyles,
	            searchForMoreButtonSelected && [classNames.isSelected, actionButtonSelectedStyles]
	        ],
	        noSuggestions: [
	            classNames.noSuggestions,
	            {
	                textAlign: 'center',
	                color: palette.neutralSecondary,
	                fontSize: Styling_1.FontSizes.small,
	                lineHeight: 30
	            }
	        ],
	        suggestionsAvailable: [classNames.suggestionsAvailable, Styling_1.hiddenContentStyle],
	        subComponentStyles: {
	            spinner: {
	                root: [
	                    classNames.spinner,
	                    {
	                        margin: '5px 0',
	                        paddingLeft: 14,
	                        textAlign: 'left',
	                        whiteSpace: 'nowrap',
	                        lineHeight: 20,
	                        fontSize: Styling_1.FontSizes.small
	                    }
	                ],
	                circle: {
	                    display: 'inline-block',
	                    verticalAlign: 'middle'
	                },
	                label: {
	                    display: 'inline-block',
	                    verticalAlign: 'middle',
	                    margin: '0 10px 0 16px'
	                }
	            }
	        }
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=Suggestions.styles.js.map

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Validation state of the user's input.
	 * {@docCategory Pickers}
	 */
	var ValidationState;
	(function (ValidationState) {
	    /** User input is valid. */
	    ValidationState[ValidationState["valid"] = 0] = "valid";
	    /** User input could be valid or invalid, its state is not known yet. */
	    ValidationState[ValidationState["warning"] = 1] = "warning";
	    /** User input is invalid. */
	    ValidationState[ValidationState["invalid"] = 2] = "invalid";
	})(ValidationState = exports.ValidationState || (exports.ValidationState = {}));
	//# sourceMappingURL=BasePicker.types.js.map

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".pickerText_de6ce0eb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";min-width:180px;min-height:30px}.pickerText_de6ce0eb:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#333333" }, { "rawString": "}.pickerText_de6ce0eb.inputFocused_de6ce0eb{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d4" }, { "rawString": "}.pickerInput_de6ce0eb{height:34px;border:none;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;outline:none;padding:0 6px 0px;-ms-flex-item-align:end;align-self:flex-end}.pickerItems_de6ce0eb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.screenReaderOnly_de6ce0eb{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
	exports.pickerText = "pickerText_de6ce0eb";
	exports.inputFocused = "inputFocused_de6ce0eb";
	exports.pickerInput = "pickerInput_de6ce0eb";
	exports.pickerItems = "pickerItems_de6ce0eb";
	exports.screenReaderOnly = "screenReaderOnly_de6ce0eb";
	//# sourceMappingURL=BasePicker.scss.js.map

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var BasePicker_1 = __webpack_require__(1018);
	var BasePicker_types_1 = __webpack_require__(1020);
	var PeoplePickerItem_1 = __webpack_require__(1023);
	var PeoplePickerItemSuggestion_1 = __webpack_require__(1025);
	var BasePicker_styles_1 = __webpack_require__(1027);
	/**
	 * {@docCategory PeoplePicker}
	 */
	var BasePeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BasePeoplePicker, _super);
	    function BasePeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BasePeoplePicker;
	}(BasePicker_1.BasePicker));
	exports.BasePeoplePicker = BasePeoplePicker;
	/**
	 * {@docCategory PeoplePicker}
	 */
	var MemberListPeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(MemberListPeoplePicker, _super);
	    function MemberListPeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return MemberListPeoplePicker;
	}(BasePicker_1.BasePickerListBelow));
	exports.MemberListPeoplePicker = MemberListPeoplePicker;
	/**
	 * Standard People Picker.
	 * {@docCategory PeoplePicker}
	 */
	var NormalPeoplePickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(NormalPeoplePickerBase, _super);
	    function NormalPeoplePickerBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** Default props for NormalPeoplePicker. */
	    NormalPeoplePickerBase.defaultProps = {
	        onRenderItem: function (props) { return React.createElement(PeoplePickerItem_1.PeoplePickerItem, tslib_1.__assign({}, props)); },
	        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (React.createElement(PeoplePickerItemSuggestion_1.PeoplePickerItemSuggestion, { personaProps: personaProps, suggestionsProps: suggestionsProps })); },
	        createGenericItem: createGenericItem
	    };
	    return NormalPeoplePickerBase;
	}(BasePeoplePicker));
	exports.NormalPeoplePickerBase = NormalPeoplePickerBase;
	/**
	 * Compact layout. It uses personas without secondary text when displaying search results.
	 * {@docCategory PeoplePicker}
	 */
	var CompactPeoplePickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(CompactPeoplePickerBase, _super);
	    function CompactPeoplePickerBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** Default props for CompactPeoplePicker. */
	    CompactPeoplePickerBase.defaultProps = {
	        onRenderItem: function (props) { return React.createElement(PeoplePickerItem_1.PeoplePickerItem, tslib_1.__assign({}, props)); },
	        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (React.createElement(PeoplePickerItemSuggestion_1.PeoplePickerItemSuggestion, { personaProps: personaProps, suggestionsProps: suggestionsProps, compact: true })); },
	        createGenericItem: createGenericItem
	    };
	    return CompactPeoplePickerBase;
	}(BasePeoplePicker));
	exports.CompactPeoplePickerBase = CompactPeoplePickerBase;
	/**
	 * MemberList layout. The selected people show up below the search box.
	 * {@docCategory PeoplePicker}
	 */
	var ListPeoplePickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ListPeoplePickerBase, _super);
	    function ListPeoplePickerBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** Default props for ListPeoplePicker. */
	    ListPeoplePickerBase.defaultProps = {
	        onRenderItem: function (props) { return React.createElement(PeoplePickerItem_1.PeoplePickerItem, tslib_1.__assign({}, props)); },
	        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (React.createElement(PeoplePickerItemSuggestion_1.PeoplePickerItemSuggestion, { personaProps: personaProps, suggestionsProps: suggestionsProps })); },
	        createGenericItem: createGenericItem
	    };
	    return ListPeoplePickerBase;
	}(MemberListPeoplePicker));
	exports.ListPeoplePickerBase = ListPeoplePickerBase;
	/**
	 * {@docCategory PeoplePicker}
	 */
	function createGenericItem(name, currentValidationState) {
	    var personaToConvert = {
	        key: name,
	        primaryText: name,
	        imageInitials: '!',
	        ValidationState: currentValidationState
	    };
	    if (currentValidationState !== BasePicker_types_1.ValidationState.warning) {
	        personaToConvert.imageInitials = Utilities_1.getInitials(name, Utilities_1.getRTL());
	    }
	    return personaToConvert;
	}
	exports.createGenericItem = createGenericItem;
	exports.NormalPeoplePicker = Utilities_1.styled(NormalPeoplePickerBase, BasePicker_styles_1.getStyles, undefined, {
	    scope: 'NormalPeoplePicker'
	});
	exports.CompactPeoplePicker = Utilities_1.styled(CompactPeoplePickerBase, BasePicker_styles_1.getStyles, undefined, {
	    scope: 'CompactPeoplePicker'
	});
	exports.ListPeoplePicker = Utilities_1.styled(ListPeoplePickerBase, BasePicker_styles_1.getStyles, undefined, {
	    scope: 'ListPeoplePickerBase'
	});
	//# sourceMappingURL=PeoplePicker.js.map

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Persona_1 = __webpack_require__(594);
	var Button_1 = __webpack_require__(691);
	var BasePicker_types_1 = __webpack_require__(1020);
	var PeoplePickerItem_styles_1 = __webpack_require__(1024);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.PeoplePickerItemBase = function (props) {
	    var item = props.item, onRemoveItem = props.onRemoveItem, index = props.index, selected = props.selected, removeButtonAriaLabel = props.removeButtonAriaLabel, styles = props.styles, theme = props.theme, className = props.className, disabled = props.disabled;
	    var itemId = Utilities_1.getId();
	    var classNames = getClassNames(styles, {
	        theme: theme,
	        className: className,
	        selected: selected,
	        disabled: disabled,
	        invalid: item.ValidationState === BasePicker_types_1.ValidationState.warning
	    });
	    var personaStyles = classNames.subComponentStyles
	        ? classNames.subComponentStyles.persona
	        : undefined;
	    var personaCoinStyles = classNames.subComponentStyles
	        ? classNames.subComponentStyles.personaCoin
	        : undefined;
	    return (React.createElement("div", { className: classNames.root, "data-is-focusable": !disabled, "data-is-sub-focuszone": true, "data-selection-index": index, role: 'listitem', "aria-labelledby": 'selectedItemPersona-' + itemId },
	        React.createElement("div", { className: classNames.itemContent, id: 'selectedItemPersona-' + itemId },
	            React.createElement(Persona_1.Persona, tslib_1.__assign({ size: Persona_1.PersonaSize.size24, styles: personaStyles, coinProps: { styles: personaCoinStyles } }, item))),
	        React.createElement(Button_1.IconButton, { onClick: onRemoveItem, disabled: disabled, iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, className: classNames.removeButton, ariaLabel: removeButtonAriaLabel })));
	};
	exports.PeoplePickerItem = Utilities_1.styled(exports.PeoplePickerItemBase, PeoplePickerItem_styles_1.getStyles, undefined, { scope: 'PeoplePickerItem' });
	//# sourceMappingURL=PeoplePickerItem.js.map

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var BaseButton_classNames_1 = __webpack_require__(719);
	var GlobalClassNames = {
	    root: 'ms-PickerPersona-container',
	    itemContent: 'ms-PickerItem-content',
	    removeButton: 'ms-PickerItem-removeButton',
	    isSelected: 'is-selected',
	    isInvalid: 'is-invalid'
	};
	var REMOVE_BUTTON_SIZE = 24;
	function getStyles(props) {
	    var className = props.className, theme = props.theme, selected = props.selected, invalid = props.invalid, disabled = props.disabled;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var personaPrimaryTextStyles = [
	        selected &&
	            !invalid &&
	            !disabled && {
	            color: palette.white,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'HighlightText'
	                },
	                _a)
	        },
	        ((invalid && !selected) || (invalid && selected && disabled)) && {
	            color: palette.redDark,
	            borderBottom: "2px dotted " + palette.redDark,
	            selectors: {
	                '$root:hover &': {
	                    // override Persona root:hover selector
	                    color: palette.redDark
	                }
	            }
	        },
	        invalid &&
	            selected &&
	            !disabled && {
	            color: palette.white,
	            borderBottom: "2px dotted " + palette.white
	        },
	        disabled && {
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText'
	                },
	                _b)
	        }
	    ];
	    var personaCoinInitialsStyles = [
	        invalid && {
	            fontSize: 20 // does not exist on the FontSizes type ramp.
	        }
	    ];
	    return {
	        root: [
	            classNames.root,
	            Styling_1.getFocusStyle(theme, { inset: -2 }),
	            {
	                borderRadius: 15,
	                display: 'inline-flex',
	                alignItems: 'center',
	                background: palette.neutralLighter,
	                margin: '1px 2px',
	                cursor: 'default',
	                userSelect: 'none',
	                maxWidth: 300,
	                verticalAlign: 'middle',
	                minWidth: 0,
	                selectors: (_c = {
	                        ':hover': {
	                            background: !selected && !disabled ? palette.neutralLight : ''
	                        }
	                    },
	                    _c[Styling_1.HighContrastSelector] = [{ border: '1px solid WindowText' }, disabled && { borderColor: 'GrayText' }],
	                    _c)
	            },
	            selected &&
	                !disabled && [
	                classNames.isSelected,
	                {
	                    background: palette.themePrimary,
	                    selectors: (_d = {},
	                        _d[Styling_1.HighContrastSelector] = {
	                            borderColor: 'HighLight',
	                            background: 'Highlight',
	                            MsHighContrastAdjust: 'none'
	                        },
	                        _d)
	                }
	            ],
	            invalid && [classNames.isInvalid],
	            invalid &&
	                selected &&
	                !disabled && {
	                background: palette.redDark
	            },
	            className
	        ],
	        itemContent: [
	            classNames.itemContent,
	            {
	                flex: '0 1 auto',
	                minWidth: 0,
	                // CSS below is needed for IE 11 to properly truncate long persona names in the picker
	                // and to clip the presence indicator (in all browsers)
	                maxWidth: '100%',
	                overflow: 'hidden'
	            }
	        ],
	        removeButton: [
	            classNames.removeButton,
	            {
	                borderRadius: 15,
	                flex: '0 0 auto',
	                width: REMOVE_BUTTON_SIZE,
	                height: REMOVE_BUTTON_SIZE,
	                flexBasis: REMOVE_BUTTON_SIZE,
	                selectors: {
	                    ':hover': {
	                        background: palette.neutralTertiaryAlt,
	                        color: palette.neutralDark
	                    }
	                }
	            },
	            selected && [
	                {
	                    color: palette.white,
	                    selectors: (_e = {
	                            ':hover': {
	                                color: palette.white,
	                                background: palette.themeDark
	                            }
	                        },
	                        _e[Styling_1.HighContrastSelector] = {
	                            color: 'HighlightText'
	                        },
	                        _e)
	                },
	                invalid && {
	                    selectors: {
	                        ':hover': {
	                            background: palette.red
	                        }
	                    }
	                }
	            ],
	            disabled && {
	                selectors: (_f = {},
	                    _f["." + BaseButton_classNames_1.ButtonGlobalClassNames.msButtonIcon] = {
	                        color: semanticColors.buttonText
	                    },
	                    _f)
	            }
	        ],
	        subComponentStyles: {
	            persona: {
	                primaryText: personaPrimaryTextStyles
	            },
	            personaCoin: {
	                initials: personaCoinInitialsStyles
	            }
	        }
	    };
	    var _a, _b, _c, _d, _e, _f;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=PeoplePickerItem.styles.js.map

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Persona_1 = __webpack_require__(594);
	var PeoplePickerItemSuggestion_styles_1 = __webpack_require__(1026);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.PeoplePickerItemSuggestionBase = function (props) {
	    var personaProps = props.personaProps, suggestionsProps = props.suggestionsProps, compact = props.compact, styles = props.styles, theme = props.theme, className = props.className;
	    var classNames = getClassNames(styles, {
	        theme: theme,
	        className: (suggestionsProps && suggestionsProps.suggestionsItemClassName) || className
	    });
	    var personaStyles = classNames.subComponentStyles && classNames.subComponentStyles.persona
	        ? classNames.subComponentStyles.persona
	        : undefined;
	    return (React.createElement("div", { className: classNames.root },
	        React.createElement(Persona_1.Persona, tslib_1.__assign({ size: Persona_1.PersonaSize.size24, styles: personaStyles, className: classNames.personaWrapper, showSecondaryText: !compact }, personaProps))));
	};
	exports.PeoplePickerItemSuggestion = Utilities_1.styled(exports.PeoplePickerItemSuggestionBase, PeoplePickerItemSuggestion_styles_1.getStyles, undefined, { scope: 'PeoplePickerItemSuggestion' });
	//# sourceMappingURL=PeoplePickerItemSuggestion.js.map

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var SuggestionsItem_styles_1 = __webpack_require__(1015);
	var GlobalClassNames = {
	    root: 'ms-PeoplePicker-personaContent',
	    personaWrapper: 'ms-PeoplePicker-Persona'
	};
	function getStyles(props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var textSelectorsStyles = {
	        selectors: (_a = {},
	            _a["." + SuggestionsItem_styles_1.SuggestionsItemGlobalClassNames.isSuggested + " &"] = {
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        color: 'HighlightText'
	                    },
	                    _b)
	            },
	            _a["." + classNames.root + ":hover &"] = {
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = {
	                        color: 'HighlightText'
	                    },
	                    _c)
	            },
	            _a)
	    };
	    return {
	        root: [
	            classNames.root,
	            {
	                width: '100%',
	                padding: '4px 12px'
	            },
	            className
	        ],
	        personaWrapper: [
	            classNames.personaWrapper,
	            {
	                width: 180
	            }
	        ],
	        subComponentStyles: {
	            persona: {
	                primaryText: textSelectorsStyles,
	                secondaryText: textSelectorsStyles
	            }
	        }
	    };
	    var _a, _b, _c;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=PeoplePickerItemSuggestion.styles.js.map

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-BasePicker',
	    text: 'ms-BasePicker-text',
	    itemsWrapper: 'ms-BasePicker-itemsWrapper',
	    input: 'ms-BasePicker-input'
	};
	function getStyles(props) {
	    var className = props.className, theme = props.theme, isFocused = props.isFocused, inputClassName = props.inputClassName, disabled = props.disabled;
	    if (!theme) {
	        throw new Error('theme is undefined or null in base BasePicker getStyles function.');
	    }
	    var semanticColors = theme.semanticColors;
	    var inputBorder = semanticColors.inputBorder, inputBorderHovered = semanticColors.inputBorderHovered, inputFocusBorderAlt = semanticColors.inputFocusBorderAlt;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    // The following lines are to create a semi-transparent color overlay for the disabled state with designer's approval.
	    // @todo: investigate the performance cost of the calculation below and apply if negligible. Replacing with a static color for now.
	    // const rgbColor: IRGB | undefined = cssColor(palette.neutralQuaternaryAlt);
	    // const disabledOverlayColor = rgbColor ? `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.29)` : 'transparent';
	    var disabledOverlayColor = 'rgba(218, 218, 218, 0.29)';
	    return {
	        root: [classNames.root, className],
	        text: [
	            classNames.text,
	            {
	                display: 'flex',
	                position: 'relative',
	                flexWrap: 'wrap',
	                alignItems: 'center',
	                boxSizing: 'border-box',
	                minWidth: 180,
	                minHeight: 30,
	                border: "1px solid " + inputBorder
	            },
	            !isFocused &&
	                !disabled && {
	                selectors: {
	                    ':hover': {
	                        borderColor: inputBorderHovered
	                    }
	                }
	            },
	            isFocused &&
	                !disabled && {
	                borderColor: inputFocusBorderAlt
	            },
	            disabled && {
	                borderColor: 'transparent',
	                selectors: (_a = {
	                        ':after': {
	                            content: '""',
	                            position: 'absolute',
	                            top: 0,
	                            right: 0,
	                            bottom: 0,
	                            left: 0,
	                            background: disabledOverlayColor
	                        }
	                    },
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderColor: 'GrayText',
	                        selectors: {
	                            ':after': {
	                                background: 'none'
	                            }
	                        }
	                    },
	                    _a)
	            }
	        ],
	        itemsWrapper: [
	            classNames.itemsWrapper,
	            {
	                display: 'flex',
	                flexWrap: 'wrap',
	                maxWidth: '100%'
	            }
	        ],
	        input: [
	            classNames.input,
	            {
	                height: 30,
	                border: 'none',
	                flexGrow: 1,
	                outline: 'none',
	                padding: '0 6px 0',
	                alignSelf: 'flex-end',
	                selectors: {
	                    '::-ms-clear': {
	                        display: 'none'
	                    }
	                }
	            },
	            inputClassName
	        ],
	        screenReaderText: Styling_1.hiddenContentStyle
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=BasePicker.styles.js.map

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var Utilities_1 = __webpack_require__(592);
	var BasePicker_1 = __webpack_require__(1018);
	var BasePicker_styles_1 = __webpack_require__(1027);
	var TagItem_1 = __webpack_require__(1029);
	var TagItemSuggestion_1 = __webpack_require__(1031);
	/**
	 * {@docCategory TagPicker}
	 */
	var TagPickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TagPickerBase, _super);
	    function TagPickerBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TagPickerBase.defaultProps = {
	        onRenderItem: function (props) { return React.createElement(TagItem_1.TagItem, tslib_1.__assign({}, props), props.item.name); },
	        onRenderSuggestionsItem: function (props) { return React.createElement(TagItemSuggestion_1.TagItemSuggestion, null, props.name); }
	    };
	    return TagPickerBase;
	}(BasePicker_1.BasePicker));
	exports.TagPickerBase = TagPickerBase;
	exports.TagPicker = Utilities_1.styled(TagPickerBase, BasePicker_styles_1.getStyles, undefined, {
	    scope: 'TagPicker'
	});
	//# sourceMappingURL=TagPicker.js.map

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var TagItem_styles_1 = __webpack_require__(1030);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory TagPicker}
	 */
	exports.TagItemBase = function (props) {
	    var theme = props.theme, styles = props.styles, selected = props.selected, disabled = props.disabled, enableTagFocusInDisabledPicker = props.enableTagFocusInDisabledPicker, children = props.children, className = props.className, index = props.index, onRemoveItem = props.onRemoveItem, removeButtonAriaLabel = props.removeButtonAriaLabel;
	    var classNames = getClassNames(styles, {
	        theme: theme,
	        className: className,
	        selected: selected,
	        disabled: disabled
	    });
	    return (React.createElement("div", { className: classNames.root, role: 'listitem', key: index, "data-selection-index": index, "data-is-focusable": (enableTagFocusInDisabledPicker || !disabled) && true },
	        React.createElement("span", { className: classNames.text, "aria-label": children }, children),
	        React.createElement(Button_1.IconButton, { onClick: onRemoveItem, disabled: disabled, iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, className: classNames.close, ariaLabel: removeButtonAriaLabel })));
	};
	exports.TagItem = Utilities_1.styled(exports.TagItemBase, TagItem_styles_1.getStyles, undefined, { scope: 'TagItem' });
	//# sourceMappingURL=TagItem.js.map

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var BaseButton_classNames_1 = __webpack_require__(719);
	var GlobalClassNames = {
	    root: 'ms-TagItem',
	    text: 'ms-TagItem-text',
	    close: 'ms-TagItem-close',
	    isSelected: 'is-selected'
	};
	var TAG_HEIGHT = 26;
	function getStyles(props) {
	    var className = props.className, theme = props.theme, selected = props.selected, disabled = props.disabled;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            Styling_1.getFocusStyle(theme),
	            {
	                boxSizing: 'content-box',
	                flexShrink: '1',
	                margin: 2,
	                height: TAG_HEIGHT,
	                lineHeight: TAG_HEIGHT,
	                cursor: 'default',
	                userSelect: 'none',
	                display: 'flex',
	                flexWrap: 'nowrap',
	                maxWidth: 300,
	                background: !selected || disabled ? palette.neutralLighter : palette.themePrimary,
	                selectors: (_a = {
	                        ':hover': [
	                            !disabled &&
	                                !selected && {
	                                background: palette.neutralLight,
	                                selectors: {
	                                    '.ms-TagItem-close': {
	                                        color: palette.neutralPrimary
	                                    }
	                                }
	                            },
	                            disabled && { background: palette.neutralLighter },
	                            selected && !disabled && { background: palette.themePrimary }
	                        ]
	                    },
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: "1px solid " + (!selected ? 'WindowText' : 'WindowFrame')
	                    },
	                    _a)
	            },
	            disabled && {
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        borderColor: 'GrayText'
	                    },
	                    _b)
	            },
	            selected &&
	                !disabled && [
	                classNames.isSelected,
	                {
	                    color: palette.white
	                }
	            ],
	            className
	        ],
	        text: [
	            classNames.text,
	            {
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                minWidth: 30,
	                margin: '0 8px'
	            },
	            disabled && {
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText'
	                    },
	                    _c)
	            }
	        ],
	        close: [
	            classNames.close,
	            {
	                color: palette.neutralSecondary,
	                width: 30,
	                height: '100%',
	                flex: '0 0 auto',
	                selectors: {
	                    ':hover': {
	                        background: palette.neutralQuaternaryAlt,
	                        color: palette.neutralPrimary
	                    }
	                }
	            },
	            selected && {
	                color: palette.white,
	                selectors: (_d = {
	                        ':hover': {
	                            color: palette.white,
	                            background: palette.themeDark
	                        }
	                    },
	                    _d[Styling_1.HighContrastSelector] = {
	                        color: 'HighlightText'
	                    },
	                    _d)
	            },
	            disabled && {
	                selectors: (_e = {},
	                    _e["." + BaseButton_classNames_1.ButtonGlobalClassNames.msButtonIcon] = {
	                        color: palette.neutralSecondary
	                    },
	                    _e)
	            }
	        ]
	    };
	    var _a, _b, _c, _d, _e;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=TagItem.styles.js.map

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var TagItemSuggestion_styles_1 = __webpack_require__(1032);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory TagPicker}
	 */
	exports.TagItemSuggestionBase = function (props) {
	    var styles = props.styles, theme = props.theme, children = props.children;
	    var classNames = getClassNames(styles, {
	        theme: theme
	    });
	    return React.createElement("div", { className: classNames.suggestionTextOverflow },
	        " ",
	        children,
	        " ");
	};
	exports.TagItemSuggestion = Utilities_1.styled(exports.TagItemSuggestionBase, TagItemSuggestion_styles_1.getStyles, undefined, { scope: 'TagItemSuggestion' });
	//# sourceMappingURL=TagItemSuggestion.js.map

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    suggestionTextOverflow: 'ms-TagItem-TextOverflow'
	};
	function getStyles(props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        suggestionTextOverflow: [
	            classNames.suggestionTextOverflow,
	            {
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                maxWidth: '60vw',
	                padding: '6px 12px 7px',
	                whiteSpace: 'nowrap'
	            },
	            className
	        ]
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=TagItemSuggestion.styles.js.map

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".suggestionsContainer_54c57b9b{overflow-y:auto;overflow-x:hidden;max-height:300px}.suggestionsContainer_54c57b9b .ms-Suggestion-item:hover{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";cursor:pointer}.suggestionsContainer_54c57b9b .is-suggested{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.suggestionsContainer_54c57b9b .is-suggested:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";cursor:pointer}\n" }]);
	exports.suggestionsContainer = "suggestionsContainer_54c57b9b";
	//# sourceMappingURL=SuggestionsCore.scss.js.map

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".root_084d4d9e{min-width:260px}.actionButton_084d4d9e{background:none;background-color:transparent;border:0;cursor:pointer;margin:0;padding:0px;position:relative;width:100%;font-size:12px}html[dir='ltr'] .actionButton_084d4d9e{text-align:left}html[dir='rtl'] .actionButton_084d4d9e{text-align:right}.actionButton_084d4d9e:hover{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";cursor:pointer}.actionButton_084d4d9e:focus,.actionButton_084d4d9e:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.actionButton_084d4d9e .ms-Button-icon{font-size:16px;width:25px}.actionButton_084d4d9e .ms-Button-label{margin:0 4px 0 9px}html[dir='rtl'] .actionButton_084d4d9e .ms-Button-label{margin:0 9px 0 4px}.buttonSelected_084d4d9e{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.buttonSelected_084d4d9e:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";cursor:pointer}.suggestionsTitle_084d4d9e{font-size:12px}.suggestionsSpinner_084d4d9e{margin:5px 0;white-space:nowrap;line-height:20px;font-size:12px}html[dir='ltr'] .suggestionsSpinner_084d4d9e{padding-left:14px}html[dir='rtl'] .suggestionsSpinner_084d4d9e{padding-right:14px}html[dir='ltr'] .suggestionsSpinner_084d4d9e{text-align:left}html[dir='rtl'] .suggestionsSpinner_084d4d9e{text-align:right}.suggestionsSpinner_084d4d9e .ms-Spinner-circle{display:inline-block;vertical-align:middle}.suggestionsSpinner_084d4d9e .ms-Spinner-label{display:inline-block;margin:0px 10px 0 16px;vertical-align:middle}html[dir='rtl'] .suggestionsSpinner_084d4d9e .ms-Spinner-label{margin:0px 16px 0 10px}.itemButton_084d4d9e{height:100%;width:100%;padding:7px 12px}@media screen and (-ms-high-contrast: active){.itemButton_084d4d9e{color:WindowText}}.screenReaderOnly_084d4d9e{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
	exports.root = "root_084d4d9e";
	exports.actionButton = "actionButton_084d4d9e";
	exports.buttonSelected = "buttonSelected_084d4d9e";
	exports.suggestionsTitle = "suggestionsTitle_084d4d9e";
	exports.suggestionsSpinner = "suggestionsSpinner_084d4d9e";
	exports.itemButton = "itemButton_084d4d9e";
	exports.screenReaderOnly = "screenReaderOnly_084d4d9e";
	//# sourceMappingURL=SuggestionsControl.scss.js.map

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Utilities_1 = __webpack_require__(592);
	var BaseFloatingPicker_1 = __webpack_require__(1005);
	var SuggestionItemDefault_1 = __webpack_require__(1036);
	__webpack_require__(1037);
	/**
	 * {@docCategory FloatingPeoplePicker}
	 */
	var BaseFloatingPeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseFloatingPeoplePicker, _super);
	    function BaseFloatingPeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BaseFloatingPeoplePicker;
	}(BaseFloatingPicker_1.BaseFloatingPicker));
	exports.BaseFloatingPeoplePicker = BaseFloatingPeoplePicker;
	var FloatingPeoplePicker = /** @class */ (function (_super) {
	    tslib_1.__extends(FloatingPeoplePicker, _super);
	    function FloatingPeoplePicker() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // tslint:disable-next-line:no-any
	    FloatingPeoplePicker.defaultProps = {
	        onRenderSuggestionsItem: function (props, itemProps) {
	            return SuggestionItemDefault_1.SuggestionItemNormal(tslib_1.__assign({}, props), tslib_1.__assign({}, itemProps));
	        },
	        createGenericItem: createItem
	    };
	    return FloatingPeoplePicker;
	}(BaseFloatingPeoplePicker));
	exports.FloatingPeoplePicker = FloatingPeoplePicker;
	function createItem(name, isValid) {
	    // tslint:disable-next-line:no-any
	    var personaToConvert = {
	        key: name,
	        primaryText: name,
	        imageInitials: '!',
	        isValid: isValid
	    };
	    if (!isValid) {
	        personaToConvert.imageInitials = Utilities_1.getInitials(name, Utilities_1.getRTL());
	    }
	    return personaToConvert;
	}
	exports.createItem = createItem;
	//# sourceMappingURL=FloatingPeoplePicker.js.map

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var Utilities_1 = __webpack_require__(592);
	var Persona_1 = __webpack_require__(594);
	var stylesImport = __webpack_require__(1037);
	exports.SuggestionItemNormal = function (personaProps, suggestionItemProps) {
	    return (React.createElement("div", { className: Utilities_1.css('ms-PeoplePicker-personaContent', stylesImport.peoplePickerPersonaContent) },
	        React.createElement(Persona_1.Persona, tslib_1.__assign({ presence: personaProps.presence !== undefined ? personaProps.presence : Persona_1.PersonaPresence.none, size: Persona_1.PersonaSize.size40, className: Utilities_1.css('ms-PeoplePicker-Persona', stylesImport.peoplePickerPersona), showSecondaryText: true }, personaProps))));
	};
	//# sourceMappingURL=SuggestionItemDefault.js.map

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_77ff388a{display:table-row}.resultContent_77ff388a .resultItem_77ff388a{display:table-cell;vertical-align:bottom}.peoplePickerPersona_77ff388a{width:180px}.peoplePickerPersona_77ff388a .ms-Persona-details{width:100%}.peoplePicker_77ff388a .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_77ff388a{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:7px 12px}\n" }]);
	exports.resultContent = "resultContent_77ff388a";
	exports.resultItem = "resultItem_77ff388a";
	exports.peoplePickerPersona = "peoplePickerPersona_77ff388a";
	exports.peoplePicker = "peoplePicker_77ff388a";
	exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_77ff388a";
	//# sourceMappingURL=PeoplePicker.scss.js.map

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SuggestionsStore = /** @class */ (function () {
	    function SuggestionsStore(options) {
	        var _this = this;
	        this._isSuggestionModel = function (value) {
	            return value.item !== undefined;
	        };
	        this._ensureSuggestionModel = function (suggestion) {
	            if (_this._isSuggestionModel(suggestion)) {
	                return suggestion;
	            }
	            else {
	                return {
	                    item: suggestion,
	                    selected: false,
	                    ariaLabel: _this.getAriaLabel !== undefined
	                        ? _this.getAriaLabel(suggestion)
	                        : // tslint:disable-next-line:no-any
	                            suggestion.name || suggestion.primaryText
	                };
	            }
	        };
	        this.suggestions = [];
	        this.getAriaLabel = options && options.getAriaLabel;
	    }
	    SuggestionsStore.prototype.updateSuggestions = function (newSuggestions) {
	        if (newSuggestions && newSuggestions.length > 0) {
	            this.suggestions = this.convertSuggestionsToSuggestionItems(newSuggestions);
	        }
	        else {
	            this.suggestions = [];
	        }
	    };
	    SuggestionsStore.prototype.getSuggestions = function () {
	        return this.suggestions;
	    };
	    SuggestionsStore.prototype.getSuggestionAtIndex = function (index) {
	        return this.suggestions[index];
	    };
	    SuggestionsStore.prototype.removeSuggestion = function (index) {
	        this.suggestions.splice(index, 1);
	    };
	    SuggestionsStore.prototype.convertSuggestionsToSuggestionItems = function (suggestions) {
	        return Array.isArray(suggestions) ? suggestions.map(this._ensureSuggestionModel) : [];
	    };
	    return SuggestionsStore;
	}());
	exports.SuggestionsStore = SuggestionsStore;
	//# sourceMappingURL=SuggestionsStore.js.map

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1040), exports);
	//# sourceMappingURL=Foundation.js.map

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1041), exports);
	tslib_1.__exportStar(__webpack_require__(1042), exports);
	tslib_1.__exportStar(__webpack_require__(1044), exports);
	__webpack_require__(1045);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var styling_1 = __webpack_require__(467);
	var utilities_1 = __webpack_require__(489);
	var slots_1 = __webpack_require__(1042);
	var utilities_2 = __webpack_require__(1043);
	/**
	 * Assembles a higher order component based on the following: styles, theme, view, and state.
	 * Imposes a separation of concern and centralizes styling processing to increase ease of use and robustness
	 * in how components use and apply styling and theming.
	 *
	 * Automatically merges and applies themes and styles with theme / styleprops having the highest priority.
	 * State component, if provided, is passed in props for processing. Props from state / user are automatically processed
	 * and styled before finally being passed to view.
	 *
	 * State components should contain all stateful behavior and should not generate any JSX, but rather simply call the view prop.
	 * Views should simply be stateless pure functions that receive all props needed for rendering their output.
	 * State component is optional. If state is not provided, created component is essentially a functional stateless component.
	 *
	 * @param component - component Component options. See IComponent for more detail.
	 */
	function createComponent(component) {
	    var _a = component.factoryOptions, factoryOptions = _a === void 0 ? {} : _a;
	    var defaultProp = factoryOptions.defaultProp;
	    var result = function (componentProps) {
	        return (
	        // TODO: createComponent is also affected by https://github.com/OfficeDev/office-ui-fabric-react/issues/6603
	        React.createElement(utilities_1.CustomizerContext.Consumer, null, function (context) {
	            // TODO: this next line is basically saying 'theme' prop will ALWAYS be available from getCustomizations
	            //        via ICustomizationProps cast. Is there mechanism that guarantees theme and other request fields will be defined?
	            //        is there a static init that guarantees theme will be provided?
	            //        what happens if createTheme/loadTheme is not called?
	            //        if so, convey through getCustomizations typing keying off fields. can we convey this
	            //          all the way from Customizations with something like { { K in fields }: object}? hmm
	            //        if not, how does existing "theme!" styles code work without risk of failing (assuming it doesn't fail)?
	            // For now cast return value as if theme is always available.
	            var settings = _getCustomizations(component.displayName, context, component.fields);
	            var renderView = function (viewProps) {
	                // The approach here is to allow state components to provide only the props they care about, automatically
	                //    merging user props and state props together. This ensures all props are passed properly to view,
	                //    including children and styles.
	                // TODO: for full 'fields' support, 'rest' props from customizations need to pass onto view.
	                //        however, customized props like theme will break snapshots. how is styled not showing theme output in snapshots?
	                var mergedProps = viewProps
	                    ? tslib_1.__assign({}, componentProps, viewProps) : componentProps;
	                var theme = mergedProps.theme || settings.theme;
	                var tokens = _resolveTokens(mergedProps, theme, component.tokens, settings.tokens, mergedProps.tokens);
	                var styles = _resolveStyles(mergedProps, theme, tokens, component.styles, settings.styles, mergedProps.styles);
	                var viewComponentProps = tslib_1.__assign({}, mergedProps, { styles: styles,
	                    tokens: tokens, _defaultStyles: styles });
	                return component.view(viewComponentProps);
	            };
	            return component.state ? React.createElement(component.state, tslib_1.__assign({}, componentProps, { renderView: renderView })) : renderView();
	        }));
	    };
	    result.displayName = component.displayName;
	    // If a shorthand prop is defined, create a factory for the component.
	    // TODO: This shouldn't be a concern of createComponent.. factoryOptions should just be forwarded.
	    //       Need to weigh creating default factories on component creation vs. memozing them on use in slots.tsx.
	    if (defaultProp) {
	        result.create = slots_1.createFactory(result, { defaultProp: defaultProp });
	    }
	    utilities_2.assign(result, component.statics);
	    // Later versions of TypeSript should allow us to merge objects in a type safe way and avoid this cast.
	    return result;
	}
	exports.createComponent = createComponent;
	/**
	 * Resolve all styles functions with both props and tokens and flatten results along with all styles objects.
	 */
	function _resolveStyles(props, theme, tokens) {
	    var allStyles = [];
	    for (var _i = 3; _i < arguments.length; _i++) {
	        allStyles[_i - 3] = arguments[_i];
	    }
	    return styling_1.concatStyleSets.apply(void 0, allStyles.map(function (styles) {
	        return typeof styles === 'function' ? styles(props, theme, tokens) : styles;
	    }));
	}
	/**
	 * Resolve all tokens functions with props flatten results along with all tokens objects.
	 */
	function _resolveTokens(props, theme) {
	    var allTokens = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        allTokens[_i - 2] = arguments[_i];
	    }
	    var tokens = {};
	    for (var _a = 0, allTokens_1 = allTokens; _a < allTokens_1.length; _a++) {
	        var currentTokens = allTokens_1[_a];
	        if (currentTokens) {
	            currentTokens = typeof currentTokens === 'function' ? currentTokens(props, theme) : currentTokens;
	            if (Array.isArray(currentTokens)) {
	                currentTokens = _resolveTokens.apply(void 0, [props, theme].concat(currentTokens));
	            }
	            utilities_2.assign.apply(void 0, [tokens].concat(currentTokens));
	        }
	    }
	    return tokens;
	}
	/**
	 * Helper function for calling Customizations.getSettings falling back to default fields.
	 *
	 * @param displayName Displayable name for component.
	 * @param context React context passed to component containing contextual settings.
	 * @param fields Optional list of properties to grab from global store and context.
	 */
	function _getCustomizations(displayName, context, fields) {
	    // TODO: do we want field props? should fields be part of IComponent and used here?
	    // TODO: should we centrally define DefaultFields? (not exported from styling)
	    // TOOD: tie this array to ICustomizationProps, such that each array element is keyof ICustomizationProps
	    var DefaultFields = ['theme', 'styles', 'tokens'];
	    return utilities_1.Customizations.getSettings(fields || DefaultFields, displayName, context.customizations);
	}
	//# sourceMappingURL=createComponent.js.map

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var styling_1 = __webpack_require__(467);
	var utilities_1 = __webpack_require__(489);
	var utilities_2 = __webpack_require__(1043);
	// TODO: Is getting only div props for 'root' slots is pretty limiting? Or is it exactly as it needs to be?
	//        Another example is getting Toggle state for `label` slot render functions. Should it get Toggle props instead?
	//        Needs more usage to rationalize the best approach. If we want component props, component props are passed
	//        as each slot as rendered and aren't available when getSlots is called. This would substantially change this approach.
	/**
	 * This function is required for any module that uses slots.
	 *
	 * This function is a slot resolver that automatically evaluates slot functions to generate React elements.
	 * A byproduct of this resolver is that it removes slots from the React hierarchy by bypassing React.createElement.
	 *
	 * To use this function on a per-file basis, use the jsx directive targeting withSlots.
	 * This directive must be the FIRST LINE in the file to work correctly.
	 * Usage of this pragma also requires withSlots import statement.
	 *
	 * See React.createElement
	 */
	// Can't use typeof on React.createElement since it's overloaded. Approximate createElement's signature for now and widen as needed.
	function withSlots(type, props) {
	    // tslint:disable-next-line:missing-optional-annotation
	    var children = [];
	    for (
	    // tslint:disable-next-line:missing-optional-annotation
	    var _i = 2; 
	    // tslint:disable-next-line:missing-optional-annotation
	    _i < arguments.length; 
	    // tslint:disable-next-line:missing-optional-annotation
	    _i++) {
	        // tslint:disable-next-line:missing-optional-annotation
	        children[_i - 2] = arguments[_i];
	    }
	    var slotType = type;
	    if (slotType.isSlot) {
	        // TODO: There is something weird going on here with children embedded in props vs. rest args.
	        // Comment out these lines to see. Make sure this function is doing the right things.
	        var numChildren = React.Children.count(children);
	        if (numChildren === 0) {
	            return slotType(props);
	        }
	        // Since we are bypassing createElement, use React.Children.toArray to make sure children are properly assigned keys.
	        // TODO: should this be mutating? does React mutate children subprop with createElement?
	        // TODO: will toArray clobber existing keys?
	        // TODO: React generates warnings because it doesn't detect hidden member _store that is set in createElement.
	        //        Even children passed to createElement without keys don't generate this warning.
	        //        Is there a better way to prevent slots from appearing in hierarchy? toArray doesn't address root issue.
	        children = React.Children.toArray(children);
	        return slotType(tslib_1.__assign({}, props, { children: children }));
	    }
	    else {
	        // TODO: Are there some cases where children should NOT be spread? Also, spreading reraises perf question.
	        //        Children had to be spread to avoid breaking KeytipData in Toggle.view:
	        //        react-dom.development.js:18931 Uncaught TypeError: children is not a function
	        //        Without spread, function child is a child array of one element
	        // TODO: is there a reason this can't be:
	        // return React.createElement.apply(this, arguments);
	        return React.createElement.apply(React, [type, props].concat(children));
	    }
	}
	exports.withSlots = withSlots;
	/**
	 * This function creates factories that render ouput depending on the user ISlotProp props passed in.
	 * @param ComponentType - Base component to render when not overridden by user props.
	 * @param options - Factory options, including defaultProp value for shorthand prop mapping.
	 * @returns ISlotFactory function used for rendering slots.
	 */
	function createFactory(ComponentType, options) {
	    if (options === void 0) { options = {}; }
	    var _a = options.defaultProp, defaultProp = _a === void 0 ? 'children' : _a;
	    var result = function (componentProps, userProps, defaultStyles) {
	        // If they passed in raw JSX, just return that.
	        if (React.isValidElement(userProps)) {
	            return userProps;
	        }
	        // If we're rendering a function, let the user resolve how to render given the original component and final args.
	        if (typeof userProps === 'function') {
	            var render = function (slotRenderFunction, renderProps) {
	                // TODO: _translateShorthand is returning TProps, so why is the finalProps cast required?
	                // TS isn't respecting the difference between props arg type and return type and instead treating both as ISlotPropValue.
	                var finalRenderProps = _translateShorthand(defaultProp, renderProps);
	                finalRenderProps = _constructFinalProps(defaultStyles, componentProps, finalRenderProps);
	                return slotRenderFunction(ComponentType, finalRenderProps);
	            };
	            return userProps(render);
	        }
	        userProps = _translateShorthand(defaultProp, userProps);
	        // TODO: _translateShorthand is returning TProps, so why is the finalProps cast required?
	        // TS isn't respecting the difference between props arg type and return type and instead treating both as ISlotPropValue.
	        var finalProps = _constructFinalProps(defaultStyles, componentProps, userProps);
	        return React.createElement(ComponentType, tslib_1.__assign({}, finalProps));
	    };
	    return result;
	}
	exports.createFactory = createFactory;
	/**
	 * Default factory for components without explicit factories.
	 */
	var defaultFactory = utilities_1.memoizeFunction(function (type) { return createFactory(type); });
	/**
	 * This function generates slots that can be used in JSX given a definition of slots and their corresponding types.
	 * @param userProps - Props as pass to component.
	 * @param slots - Slot definition object defining the default slot component for each slot.
	 * @returns A set of created slots that components can render in JSX.
	 */
	function getSlots(userProps, slots) {
	    var result = {};
	    // userProps already has default props mixed in by createComponent. Recast here to gain typing for this function.
	    var mixedProps = userProps;
	    var _loop_1 = function (name_1) {
	        if (slots.hasOwnProperty(name_1)) {
	            // This closure method requires the use of withSlots to prevent unnecessary rerenders. This is because React detects
	            //  each closure as a different component (since it is a new instance) from the previous one and then forces a rerender of the entire
	            //  slot subtree. For now, the only way to avoid this is to use withSlots, which bypasses the call to React.createElement.
	            var slot = function (componentProps) {
	                var args = [];
	                for (var _i = 1; _i < arguments.length; _i++) {
	                    args[_i - 1] = arguments[_i];
	                }
	                if (args.length > 0) {
	                    // If React.createElement is being incorrectly used with slots, there will be additional arguments.
	                    // We can detect these additional arguments and error on their presence.
	                    throw new Error('Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.');
	                }
	                return _renderSlot(slots[name_1], 
	                // TODO: this cast to any is hiding a relationship issue between the first two args
	                componentProps, mixedProps[name_1], 
	                // _defaultStyles should always be present, but a check for existence is added to make view tests easier to use.
	                mixedProps._defaultStyles && mixedProps._defaultStyles[name_1]);
	            };
	            slot.isSlot = true;
	            result[name_1] = slot;
	        }
	    };
	    for (var name_1 in slots) {
	        _loop_1(name_1);
	    }
	    return result;
	}
	exports.getSlots = getSlots;
	/**
	 * Helper function that constructs a props object when given shorthand props.
	 */
	function _translateShorthand(defaultProp, props) {
	    if (typeof props === 'string' || typeof props === 'number' || typeof props === 'boolean') {
	        props = (_a = {},
	            _a[defaultProp] = props,
	            _a);
	    }
	    return props;
	    var _a;
	}
	/**
	 * Helper function that constructs final styles and props given a series of props ordered by increasing priority.
	 */
	function _constructFinalProps(defaultStyles) {
	    var allProps = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        allProps[_i - 1] = arguments[_i];
	    }
	    var finalProps = {};
	    var classNames = [];
	    for (var _a = 0, allProps_1 = allProps; _a < allProps_1.length; _a++) {
	        var props = allProps_1[_a];
	        classNames.push(props && props.className);
	        utilities_2.assign.apply(void 0, [finalProps].concat(props));
	    }
	    finalProps.className = styling_1.mergeStyles(defaultStyles, classNames);
	    return finalProps;
	}
	/**
	 * Render a slot given component and user props. Uses component factory if available, otherwise falls back
	 * to default factory.
	 * @param ComponentType Factory component type.
	 * @param componentProps The properties passed into slot from within the component.
	 * @param userProps The user properties passed in from outside of the component.
	 */
	function _renderSlot(ComponentType, componentProps, userProps, defaultStyles) {
	    if (ComponentType.create !== undefined) {
	        return ComponentType.create(componentProps, userProps, defaultStyles);
	    }
	    else {
	        return defaultFactory(ComponentType)(componentProps, userProps, defaultStyles);
	    }
	}
	//# sourceMappingURL=slots.js.map

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	exports.assign = tslib_1.__assign;
	//# sourceMappingURL=utilities.js.map

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var styling_1 = __webpack_require__(467);
	var utilities_1 = __webpack_require__(489);
	/**
	 * Theme provider is a simplified version of Customizer that activates the appropriate theme data
	 * for a given scheme name.
	 *
	 * @param providers - Injected providers for accessing theme data and providing it via a Customizer component.
	 */
	exports.ThemeProvider = function (props) {
	    var scheme = props.scheme, theme = props.theme, rest = tslib_1.__rest(props, ["scheme", "theme"]);
	    // TODO: consider merging implementation with theme-proto, which only stores a reference / scheme name to theme in context
	    //        and uses quick global store accessor to trigger change by passing in theme object as child and triggering re-render.
	    //        (perf benefits need verification)
	    // tslint:disable-next-line:typedef
	    var contextTransform = function (context) {
	        return styling_1.getThemedContext(context, scheme, theme);
	    };
	    return React.createElement(utilities_1.Customizer, tslib_1.__assign({}, rest, { contextTransform: contextTransform }));
	};
	//# sourceMappingURL=ThemeProvider.js.map

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// @uifabric/foundation@0.8.2
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('@uifabric/foundation', '0.8.2');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1047), exports);
	//# sourceMappingURL=Grid.js.map

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1048), exports);
	tslib_1.__exportStar(__webpack_require__(1051), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Grid_base_1 = __webpack_require__(1049);
	var Grid_styles_1 = __webpack_require__(1050);
	exports.Grid = Utilities_1.styled(Grid_base_1.GridBase, Grid_styles_1.getStyles);
	//# sourceMappingURL=Grid.js.map

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var getClassNames = Utilities_1.classNamesFunction();
	var GridBase = /** @class */ (function (_super) {
	    tslib_1.__extends(GridBase, _super);
	    function GridBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._id = Utilities_1.getId();
	        return _this;
	    }
	    GridBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, items = _a.items, columnCount = _a.columnCount, onRenderItem = _a.onRenderItem, positionInSet = _a.positionInSet, setSize = _a.setSize, styles = _a.styles;
	        var htmlProps = Utilities_1.getNativeProps(this.props, Utilities_1.htmlElementProperties, ['onBlur, aria-posinset, aria-setsize']);
	        var classNames = getClassNames(styles, { theme: this.props.theme });
	        // Array to store the cells in the correct row index
	        var rowsOfItems = Utilities_1.toMatrix(items, columnCount);
	        var content = (React.createElement("table", tslib_1.__assign({}, htmlProps, { "aria-posinset": positionInSet, "aria-setsize": setSize, id: this._id, role: 'grid', className: classNames.root }),
	            React.createElement("tbody", null, rowsOfItems.map(function (rows, rowIndex) {
	                return (React.createElement("tr", { role: 'row', key: _this._id + '-' + rowIndex + '-row' }, rows.map(function (cell, cellIndex) {
	                    return (React.createElement("td", { role: 'presentation', key: _this._id + '-' + cellIndex + '-cell', className: classNames.tableCell }, onRenderItem(cell, cellIndex)));
	                })));
	            }))));
	        // Create the table/grid
	        return this.props.doNotContainWithinFocusZone ? (content) : (React.createElement(FocusZone_1.FocusZone, { isCircularNavigation: this.props.shouldFocusCircularNavigate, className: classNames.focusedContainer, onBlur: this.props.onBlur }, content));
	    };
	    return GridBase;
	}(Utilities_1.BaseComponent));
	exports.GridBase = GridBase;
	//# sourceMappingURL=Grid.base.js.map

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    return {
	        root: {
	            padding: 2,
	            outline: 'none'
	        },
	        tableCell: {
	            padding: 0
	        }
	    };
	};
	//# sourceMappingURL=Grid.styles.js.map

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var GridCell = /** @class */ (function (_super) {
	    tslib_1.__extends(GridCell, _super);
	    function GridCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onClick = function () {
	            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled, item = _a.item;
	            if (onClick && !disabled) {
	                onClick(item);
	            }
	        };
	        _this._onMouseEnter = function (ev) {
	            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, item = _a.item, onMouseEnter = _a.onMouseEnter;
	            var didUpdateOnEnter = onMouseEnter && onMouseEnter(ev);
	            if (!didUpdateOnEnter && onHover && !disabled) {
	                onHover(item);
	            }
	        };
	        _this._onMouseMove = function (ev) {
	            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, item = _a.item, onMouseMove = _a.onMouseMove;
	            var didUpdateOnMove = onMouseMove && onMouseMove(ev);
	            if (!didUpdateOnMove && onHover && !disabled) {
	                onHover(item);
	            }
	        };
	        _this._onMouseLeave = function (ev) {
	            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, onMouseLeave = _a.onMouseLeave;
	            var didUpdateOnLeave = onMouseLeave && onMouseLeave(ev);
	            if (!didUpdateOnLeave && onHover && !disabled) {
	                onHover();
	            }
	        };
	        _this._onFocus = function () {
	            var _a = _this.props, onFocus = _a.onFocus, disabled = _a.disabled, item = _a.item;
	            if (onFocus && !disabled) {
	                onFocus(item);
	            }
	        };
	        return _this;
	    }
	    GridCell.prototype.render = function () {
	        var _a = this.props, item = _a.item, id = _a.id, className = _a.className, role = _a.role, selected = _a.selected, disabled = _a.disabled, onRenderItem = _a.onRenderItem, cellDisabledStyle = _a.cellDisabledStyle, cellIsSelectedStyle = _a.cellIsSelectedStyle, index = _a.index, label = _a.label, getClassNames = _a.getClassNames;
	        return (React.createElement(Button_1.CommandButton, { id: id, "data-index": index, "data-is-focusable": true, disabled: disabled, className: Utilities_1.css(className, (_b = {},
	                _b['' + cellIsSelectedStyle] = selected,
	                _b['' + cellDisabledStyle] = disabled,
	                _b)), onClick: this._onClick, onMouseEnter: this._onMouseEnter, onMouseMove: this._onMouseMove, onMouseLeave: this._onMouseLeave, onFocus: this._onFocus, role: role, "aria-selected": selected, ariaLabel: label, title: label, getClassNames: getClassNames }, onRenderItem(item)));
	        var _b;
	    };
	    GridCell.defaultProps = {
	        disabled: false,
	        id: Utilities_1.getId('gridCell')
	    };
	    return GridCell;
	}(React.Component));
	exports.GridCell = GridCell;
	//# sourceMappingURL=GridCell.js.map

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1053), exports);
	//# sourceMappingURL=HoverCard.js.map

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1054), exports);
	tslib_1.__exportStar(__webpack_require__(1056), exports);
	tslib_1.__exportStar(__webpack_require__(1057), exports);
	tslib_1.__exportStar(__webpack_require__(1058), exports);
	tslib_1.__exportStar(__webpack_require__(1060), exports);
	tslib_1.__exportStar(__webpack_require__(1061), exports);
	tslib_1.__exportStar(__webpack_require__(1063), exports);
	tslib_1.__exportStar(__webpack_require__(1065), exports);
	tslib_1.__exportStar(__webpack_require__(608), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var HoverCard_styles_1 = __webpack_require__(1055);
	var HoverCard_base_1 = __webpack_require__(1056);
	exports.HoverCard = Utilities_1.styled(HoverCard_base_1.HoverCardBase, HoverCard_styles_1.getStyles, undefined, {
	    scope: 'HoverCard'
	});
	//# sourceMappingURL=HoverCard.js.map

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    host: 'ms-HoverCard-host'
	};
	function getStyles(props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        host: [classNames.host, className]
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=HoverCard.styles.js.map

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var HoverCard_types_1 = __webpack_require__(1057);
	var ExpandingCard_1 = __webpack_require__(1058);
	var ExpandingCard_types_1 = __webpack_require__(1061);
	var PlainCard_1 = __webpack_require__(1063);
	var getClassNames = Utilities_1.classNamesFunction();
	var HoverCardBase = /** @class */ (function (_super) {
	    tslib_1.__extends(HoverCardBase, _super);
	    // Constructor
	    function HoverCardBase(props) {
	        var _this = _super.call(this, props) || this;
	        // The wrapping div that gets the hover events
	        _this._hoverCard = Utilities_1.createRef();
	        _this.dismiss = function (withTimeOut) {
	            _this._async.clearTimeout(_this._openTimerId);
	            _this._async.clearTimeout(_this._dismissTimerId);
	            if (!withTimeOut) {
	                _this._setDismissedState();
	            }
	            else {
	                _this._dismissTimerId = _this._async.setTimeout(function () {
	                    _this._setDismissedState();
	                }, _this.props.cardDismissDelay);
	            }
	        };
	        // Show HoverCard
	        _this._cardOpen = function (ev) {
	            if (_this._shouldBlockHoverCard() || (ev.type === 'keydown' && !(ev.which === _this.props.openHotKey))) {
	                return;
	            }
	            _this._async.clearTimeout(_this._dismissTimerId);
	            if (ev.type === 'mouseenter') {
	                _this._currentMouseTarget = ev.currentTarget;
	            }
	            _this._executeCardOpen(ev);
	        };
	        _this._executeCardOpen = function (ev) {
	            _this._async.clearTimeout(_this._openTimerId);
	            _this._openTimerId = _this._async.setTimeout(function () {
	                _this.setState(function (prevState) {
	                    if (!prevState.isHoverCardVisible) {
	                        return {
	                            isHoverCardVisible: true,
	                            mode: ExpandingCard_types_1.ExpandingCardMode.compact,
	                            openMode: ev.type === 'keydown' ? HoverCard_types_1.OpenCardMode.hotKey : HoverCard_types_1.OpenCardMode.hover
	                        };
	                    }
	                    return prevState;
	                });
	            }, _this.props.cardOpenDelay);
	        };
	        /**
	         * Hide HoverCard
	         * How we dismiss the card depends on where the callback is coming from.
	         * This is provided by the `isNativeEvent` argument.
	         *  true: Event is coming from event listeners set up in componentDidMount.
	         *  false: Event is coming from the `onLeave` prop from the HoverCard component.
	         */
	        _this._cardDismiss = function (isNativeEvent, ev) {
	            if (isNativeEvent) {
	                // We expect these to be MouseEvents, If not, return.
	                if (!(ev instanceof MouseEvent)) {
	                    return;
	                }
	                if (ev.type === 'keydown' && ev.which !== Utilities_1.KeyCodes.escape) {
	                    return;
	                }
	                // Dismiss if not sticky and currentTarget is the same element that mouse last entered
	                if (!_this.props.sticky && (_this._currentMouseTarget === ev.currentTarget || ev.which === Utilities_1.KeyCodes.escape)) {
	                    _this.dismiss(true);
	                }
	            }
	            else {
	                // If this is a mouseleave event and the component is sticky, do not dismiss.
	                if (_this.props.sticky && !(ev instanceof MouseEvent) && ev.nativeEvent instanceof MouseEvent && ev.type === 'mouseleave') {
	                    return;
	                }
	                _this.dismiss(true);
	            }
	        };
	        _this._setDismissedState = function () {
	            _this.setState({
	                isHoverCardVisible: false,
	                mode: ExpandingCard_types_1.ExpandingCardMode.compact,
	                openMode: HoverCard_types_1.OpenCardMode.hover
	            });
	        };
	        _this._instantOpenAsExpanded = function (ev) {
	            _this._async.clearTimeout(_this._dismissTimerId);
	            _this.setState(function (prevState) {
	                if (!prevState.isHoverCardVisible) {
	                    return {
	                        isHoverCardVisible: true,
	                        mode: ExpandingCard_types_1.ExpandingCardMode.expanded
	                    };
	                }
	                return prevState;
	            });
	        };
	        _this._setEventListeners = function () {
	            var _a = _this.props, trapFocus = _a.trapFocus, instantOpenOnClick = _a.instantOpenOnClick, eventListenerTarget = _a.eventListenerTarget;
	            var target = eventListenerTarget ? _this._getTargetElement(eventListenerTarget) : _this._getTargetElement(_this.props.target);
	            var nativeEventDismiss = _this._nativeDismissEvent;
	            // target can be undefined if ref isn't available, only assign
	            // events when defined to avoid throwing exception.
	            if (target) {
	                _this._events.on(target, 'mouseenter', _this._cardOpen);
	                _this._events.on(target, 'mouseleave', nativeEventDismiss);
	                if (trapFocus) {
	                    _this._events.on(target, 'keydown', _this._cardOpen);
	                }
	                else {
	                    _this._events.on(target, 'focus', _this._cardOpen);
	                    _this._events.on(target, 'blur', nativeEventDismiss);
	                }
	                if (instantOpenOnClick) {
	                    _this._events.on(target, 'click', _this._instantOpenAsExpanded);
	                }
	                else {
	                    _this._events.on(target, 'mousedown', nativeEventDismiss);
	                    _this._events.on(target, 'keydown', nativeEventDismiss);
	                }
	            }
	        };
	        _this._nativeDismissEvent = _this._cardDismiss.bind(_this, true);
	        _this._childDismissEvent = _this._cardDismiss.bind(_this, false);
	        _this.state = {
	            isHoverCardVisible: false,
	            mode: ExpandingCard_types_1.ExpandingCardMode.compact,
	            openMode: HoverCard_types_1.OpenCardMode.hover
	        };
	        return _this;
	    }
	    HoverCardBase.prototype.componentDidMount = function () {
	        this._setEventListeners();
	    };
	    HoverCardBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var _this = this;
	        if (prevProps.target !== this.props.target) {
	            this._events.off();
	            this._setEventListeners();
	        }
	        if (prevState.isHoverCardVisible !== this.state.isHoverCardVisible) {
	            if (this.state.isHoverCardVisible) {
	                this._async.setTimeout(function () {
	                    _this.setState({
	                        mode: ExpandingCard_types_1.ExpandingCardMode.expanded
	                    }, function () {
	                        _this.props.onCardExpand && _this.props.onCardExpand();
	                    });
	                }, this.props.expandedCardOpenDelay);
	                this.props.onCardVisible && this.props.onCardVisible();
	            }
	            else {
	                this.setState({
	                    mode: ExpandingCard_types_1.ExpandingCardMode.compact
	                });
	                this.props.onCardHide && this.props.onCardHide();
	            }
	        }
	    };
	    // Render
	    HoverCardBase.prototype.render = function () {
	        var _a = this.props, expandingCardProps = _a.expandingCardProps, children = _a.children, id = _a.id, _b = _a.setAriaDescribedBy, setAriaDescribedBy = _b === void 0 ? true : _b, customStyles = _a.styles, theme = _a.theme, className = _a.className, type = _a.type, plainCardProps = _a.plainCardProps, trapFocus = _a.trapFocus, setInitialFocus = _a.setInitialFocus;
	        var _c = this.state, isHoverCardVisible = _c.isHoverCardVisible, mode = _c.mode, openMode = _c.openMode;
	        var hoverCardId = id || Utilities_1.getId('hoverCard');
	        this._classNames = getClassNames(customStyles, {
	            theme: theme,
	            className: className
	        });
	        // Common props for both card types.
	        var commonCardProps = tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { id: hoverCardId, trapFocus: !!trapFocus, firstFocus: setInitialFocus || openMode === HoverCard_types_1.OpenCardMode.hotKey, targetElement: this._getTargetElement(this.props.target), onEnter: this._cardOpen, onLeave: this._childDismissEvent });
	        var finalExpandedCardProps = tslib_1.__assign({}, expandingCardProps, commonCardProps, { mode: mode });
	        var finalPlainCardProps = tslib_1.__assign({}, plainCardProps, commonCardProps);
	        return (React.createElement("div", { className: this._classNames.host, ref: this._hoverCard, "aria-describedby": setAriaDescribedBy && isHoverCardVisible ? hoverCardId : undefined, "data-is-focusable": !Boolean(this.props.target) },
	            children,
	            isHoverCardVisible &&
	                (type === HoverCard_types_1.HoverCardType.expanding ? React.createElement(ExpandingCard_1.ExpandingCard, tslib_1.__assign({}, finalExpandedCardProps)) : React.createElement(PlainCard_1.PlainCard, tslib_1.__assign({}, finalPlainCardProps)))));
	    };
	    HoverCardBase.prototype._getTargetElement = function (target) {
	        switch (typeof target) {
	            case 'string':
	                return Utilities_1.getDocument().querySelector(target);
	            case 'object':
	                return target;
	            default:
	                return this._hoverCard.current || undefined;
	        }
	    };
	    HoverCardBase.prototype._shouldBlockHoverCard = function () {
	        return !!(this.props.shouldBlockHoverCard && this.props.shouldBlockHoverCard());
	    };
	    HoverCardBase.defaultProps = {
	        cardOpenDelay: 500,
	        cardDismissDelay: 100,
	        expandedCardOpenDelay: 1500,
	        instantOpenOnClick: false,
	        setInitialFocus: false,
	        openHotKey: Utilities_1.KeyCodes.c,
	        type: HoverCard_types_1.HoverCardType.expanding
	    };
	    return HoverCardBase;
	}(Utilities_1.BaseComponent));
	exports.HoverCardBase = HoverCardBase;
	//# sourceMappingURL=HoverCard.base.js.map

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory HoverCard}
	 */
	var OpenCardMode;
	(function (OpenCardMode) {
	    /**
	     * Open card by hover
	     */
	    OpenCardMode[OpenCardMode["hover"] = 0] = "hover";
	    /**
	     * Open card by hot key
	     */
	    OpenCardMode[OpenCardMode["hotKey"] = 1] = "hotKey";
	})(OpenCardMode = exports.OpenCardMode || (exports.OpenCardMode = {}));
	/**
	 * {@docCategory HoverCard}
	 */
	var HoverCardType;
	(function (HoverCardType) {
	    /**
	     * Plain card consisting of one part responsive to the size of content.
	     */
	    HoverCardType["plain"] = "PlainCard";
	    /**
	     * File card consisting of two parts: compact and expanded. Has some default sizes if not specified.
	     */
	    HoverCardType["expanding"] = "ExpandingCard";
	})(HoverCardType = exports.HoverCardType || (exports.HoverCardType = {}));
	//# sourceMappingURL=HoverCard.types.js.map

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ExpandingCard_styles_1 = __webpack_require__(1059);
	var ExpandingCard_base_1 = __webpack_require__(1060);
	exports.ExpandingCard = Utilities_1.styled(ExpandingCard_base_1.ExpandingCardBase, ExpandingCard_styles_1.getStyles, undefined, {
	    scope: 'ExpandingCard'
	});
	//# sourceMappingURL=ExpandingCard.js.map

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ExpandingCard-root',
	    compactCard: 'ms-ExpandingCard-compactCard',
	    expandedCard: 'ms-ExpandingCard-expandedCard',
	    expandedCardScroll: 'ms-ExpandingCard-expandedCardScrollRegion'
	};
	function getStyles(props) {
	    var theme = props.theme, needsScroll = props.needsScroll, expandedCardFirstFrameRendered = props.expandedCardFirstFrameRendered, compactCardHeight = props.compactCardHeight, expandedCardHeight = props.expandedCardHeight, className = props.className;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                width: '340px',
	                pointerEvents: 'none',
	                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
	                border: 'none',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText'
	                    },
	                    _a)
	            },
	            className
	        ],
	        compactCard: [
	            classNames.compactCard,
	            {
	                pointerEvents: 'auto',
	                position: 'relative',
	                height: compactCardHeight
	            }
	        ],
	        expandedCard: [
	            classNames.expandedCard,
	            {
	                height: '1px',
	                overflowY: 'hidden',
	                pointerEvents: 'auto',
	                transition: 'height 0.467s cubic-bezier(0.5, 0, 0, 1)',
	                selectors: {
	                    ':before': {
	                        content: '""',
	                        position: 'relative',
	                        display: 'block',
	                        top: '0',
	                        left: '24px',
	                        width: '292px',
	                        height: '1px',
	                        backgroundColor: palette.neutralLighter
	                    }
	                }
	            },
	            expandedCardFirstFrameRendered && {
	                height: expandedCardHeight
	            }
	        ],
	        expandedCardScroll: [
	            classNames.expandedCardScroll,
	            needsScroll && {
	                height: '100%',
	                boxSizing: 'border-box',
	                overflowY: 'auto'
	            }
	        ]
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=ExpandingCard.styles.js.map

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ExpandingCard_types_1 = __webpack_require__(1061);
	var CardCallout_1 = __webpack_require__(1062);
	var getClassNames = Utilities_1.classNamesFunction();
	var ExpandingCardBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ExpandingCardBase, _super);
	    function ExpandingCardBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._expandedElem = React.createRef();
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.escape) {
	                _this.props.onLeave && _this.props.onLeave(ev);
	            }
	        };
	        _this._onRenderCompactCard = function () {
	            return React.createElement("div", { className: _this._classNames.compactCard }, _this.props.onRenderCompactCard(_this.props.renderData));
	        };
	        _this._onRenderExpandedCard = function () {
	            // firstFrameRendered helps in initially setting height of expanded card to 1px, even if
	            // mode prop is set to ExpandingCardMode.expanded on first render. This is to make sure transition animation takes place.
	            !_this.state.firstFrameRendered &&
	                _this._async.requestAnimationFrame(function () {
	                    _this.setState({
	                        firstFrameRendered: true
	                    });
	                });
	            return (React.createElement("div", { className: _this._classNames.expandedCard, ref: _this._expandedElem },
	                React.createElement("div", { className: _this._classNames.expandedCardScroll }, _this.props.onRenderExpandedCard && _this.props.onRenderExpandedCard(_this.props.renderData))));
	        };
	        _this._checkNeedsScroll = function () {
	            var expandedCardHeight = _this.props.expandedCardHeight;
	            _this._async.requestAnimationFrame(function () {
	                if (_this._expandedElem.current && _this._expandedElem.current.scrollHeight >= expandedCardHeight) {
	                    _this.setState({
	                        needsScroll: true
	                    });
	                }
	            });
	        };
	        _this.state = {
	            firstFrameRendered: false,
	            needsScroll: false
	        };
	        return _this;
	    }
	    ExpandingCardBase.prototype.componentDidMount = function () {
	        this._checkNeedsScroll();
	    };
	    ExpandingCardBase.prototype.componentWillUnmount = function () {
	        this._async.dispose();
	    };
	    ExpandingCardBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, compactCardHeight = _a.compactCardHeight, expandedCardHeight = _a.expandedCardHeight, theme = _a.theme, mode = _a.mode, className = _a.className;
	        var _b = this.state, needsScroll = _b.needsScroll, firstFrameRendered = _b.firstFrameRendered;
	        var finalHeight = compactCardHeight + expandedCardHeight;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            compactCardHeight: compactCardHeight,
	            className: className,
	            expandedCardHeight: expandedCardHeight,
	            needsScroll: needsScroll,
	            expandedCardFirstFrameRendered: mode === ExpandingCard_types_1.ExpandingCardMode.expanded && firstFrameRendered
	        });
	        var content = (React.createElement("div", { onMouseEnter: this.props.onEnter, onMouseLeave: this.props.onLeave, onKeyDown: this._onKeyDown },
	            this._onRenderCompactCard(),
	            this._onRenderExpandedCard()));
	        return React.createElement(CardCallout_1.CardCallout, tslib_1.__assign({}, this.props, { content: content, finalHeight: finalHeight, className: this._classNames.root }));
	    };
	    ExpandingCardBase.defaultProps = {
	        compactCardHeight: 156,
	        expandedCardHeight: 384,
	        directionalHintFixed: true
	    };
	    return ExpandingCardBase;
	}(Utilities_1.BaseComponent));
	exports.ExpandingCardBase = ExpandingCardBase;
	//# sourceMappingURL=ExpandingCard.base.js.map

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory HoverCard}
	 */
	var ExpandingCardMode;
	(function (ExpandingCardMode) {
	    /**
	     * To have top compact card only
	     */
	    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
	    /**
	     * To have both top compact and bottom expanded card
	     */
	    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
	})(ExpandingCardMode = exports.ExpandingCardMode || (exports.ExpandingCardMode = {}));
	//# sourceMappingURL=ExpandingCard.types.js.map

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Callout_1 = __webpack_require__(603);
	var DirectionalHint_1 = __webpack_require__(608);
	var Callout_2 = __webpack_require__(603);
	exports.CardCallout = function (props) {
	    var _a = props.gapSpace, gapSpace = _a === void 0 ? 0 : _a, _b = props.directionalHint, directionalHint = _b === void 0 ? DirectionalHint_1.DirectionalHint.bottomLeftEdge : _b, directionalHintFixed = props.directionalHintFixed, targetElement = props.targetElement, firstFocus = props.firstFocus, trapFocus = props.trapFocus, onLeave = props.onLeave, className = props.className, finalHeight = props.finalHeight, content = props.content;
	    var calloutProps = tslib_1.__assign({}, Utilities_1.getNativeProps(props, Utilities_1.divProperties), { className: className, target: targetElement, isBeakVisible: false, directionalHint: directionalHint, directionalHintFixed: directionalHintFixed, finalHeight: finalHeight, minPagePadding: 24, onDismiss: onLeave, gapSpace: gapSpace });
	    return (React.createElement(React.Fragment, null, trapFocus ? (React.createElement(Callout_2.FocusTrapCallout, tslib_1.__assign({}, calloutProps, { focusTrapProps: {
	            forceFocusInsideTrap: false,
	            isClickableOutsideFocusTrap: true,
	            disableFirstFocus: !firstFocus
	        } }), content)) : (React.createElement(Callout_1.Callout, tslib_1.__assign({}, calloutProps), content))));
	};
	//# sourceMappingURL=CardCallout.js.map

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var PlainCard_styles_1 = __webpack_require__(1064);
	var PlainCard_base_1 = __webpack_require__(1065);
	exports.PlainCard = Utilities_1.styled(PlainCard_base_1.PlainCardBase, PlainCard_styles_1.getStyles, undefined, {
	    scope: 'PlainCard'
	});
	//# sourceMappingURL=PlainCard.js.map

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-PlainCard-root'
	};
	function getStyles(props) {
	    var theme = props.theme, className = props.className;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            {
	                pointerEvents: 'auto',
	                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
	                border: 'none',
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText'
	                    },
	                    _a)
	            },
	            className
	        ]
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=PlainCard.styles.js.map

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var CardCallout_1 = __webpack_require__(1062);
	var getClassNames = Utilities_1.classNamesFunction();
	var PlainCardBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PlainCardBase, _super);
	    function PlainCardBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.escape) {
	                _this.props.onLeave && _this.props.onLeave(ev);
	            }
	        };
	        return _this;
	    }
	    PlainCardBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, theme = _a.theme, className = _a.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        var content = (React.createElement("div", { onMouseEnter: this.props.onEnter, onMouseLeave: this.props.onLeave, onKeyDown: this._onKeyDown }, this.props.onRenderPlainCard(this.props.renderData)));
	        return React.createElement(CardCallout_1.CardCallout, tslib_1.__assign({}, this.props, { content: content, className: this._classNames.root }));
	    };
	    return PlainCardBase;
	}(Utilities_1.BaseComponent));
	exports.PlainCardBase = PlainCardBase;
	//# sourceMappingURL=PlainCard.base.js.map

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1067), exports);
	//# sourceMappingURL=Icons.js.map

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var fabric_icons_1 = __webpack_require__(1068);
	var fabric_icons_0_1 = __webpack_require__(1069);
	var fabric_icons_1_1 = __webpack_require__(1070);
	var fabric_icons_2_1 = __webpack_require__(1071);
	var fabric_icons_3_1 = __webpack_require__(1072);
	var fabric_icons_4_1 = __webpack_require__(1073);
	var fabric_icons_5_1 = __webpack_require__(1074);
	var fabric_icons_6_1 = __webpack_require__(1075);
	var fabric_icons_7_1 = __webpack_require__(1076);
	var fabric_icons_8_1 = __webpack_require__(1077);
	var fabric_icons_9_1 = __webpack_require__(1078);
	var fabric_icons_10_1 = __webpack_require__(1079);
	var fabric_icons_11_1 = __webpack_require__(1080);
	var fabric_icons_12_1 = __webpack_require__(1081);
	var fabric_icons_13_1 = __webpack_require__(1082);
	var fabric_icons_14_1 = __webpack_require__(1083);
	var fabric_icons_15_1 = __webpack_require__(1084);
	var fabric_icons_16_1 = __webpack_require__(1085);
	var iconAliases_1 = __webpack_require__(1086);
	var DEFAULT_BASE_URL = 'https://spoprod-a.akamaihd.net/files/fabric/assets/icons/';
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = DEFAULT_BASE_URL; }
	    [fabric_icons_1.initializeIcons, fabric_icons_0_1.initializeIcons, fabric_icons_1_1.initializeIcons, fabric_icons_2_1.initializeIcons, fabric_icons_3_1.initializeIcons, fabric_icons_4_1.initializeIcons, fabric_icons_5_1.initializeIcons, fabric_icons_6_1.initializeIcons, fabric_icons_7_1.initializeIcons, fabric_icons_8_1.initializeIcons, fabric_icons_9_1.initializeIcons, fabric_icons_10_1.initializeIcons, fabric_icons_11_1.initializeIcons, fabric_icons_12_1.initializeIcons, fabric_icons_13_1.initializeIcons, fabric_icons_14_1.initializeIcons, fabric_icons_15_1.initializeIcons, fabric_icons_16_1.initializeIcons].forEach(function (initialize) { return initialize(baseUrl, options); });
	    iconAliases_1.registerIconAliases();
	}
	exports.initializeIcons = initializeIcons;
	__webpack_require__(1087);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons\"",
	            src: "url('" + baseUrl + "fabric-icons-a13498cf.woff') format('woff')"
	        },
	        icons: {
	            GlobalNavButton: '\uE700',
	            ChevronDown: '\uE70D',
	            ChevronUp: '\uE70E',
	            Edit: '\uE70F',
	            Add: '\uE710',
	            Cancel: '\uE711',
	            More: '\uE712',
	            Settings: '\uE713',
	            Mail: '\uE715',
	            Filter: '\uE71C',
	            Search: '\uE721',
	            Share: '\uE72D',
	            BlockedSite: '\uE72F',
	            FavoriteStar: '\uE734',
	            FavoriteStarFill: '\uE735',
	            CheckMark: '\uE73E',
	            Delete: '\uE74D',
	            ChevronLeft: '\uE76B',
	            ChevronRight: '\uE76C',
	            Calendar: '\uE787',
	            Megaphone: '\uE789',
	            Undo: '\uE7A7',
	            Flag: '\uE7C1',
	            Page: '\uE7C3',
	            Pinned: '\uE840',
	            View: '\uE890',
	            Clear: '\uE894',
	            Download: '\uE896',
	            Upload: '\uE898',
	            Folder: '\uE8B7',
	            Sort: '\uE8CB',
	            AlignRight: '\uE8E2',
	            AlignLeft: '\uE8E4',
	            Tag: '\uE8EC',
	            AddFriend: '\uE8FA',
	            Info: '\uE946',
	            SortLines: '\uE9D0',
	            List: '\uEA37',
	            CircleRing: '\uEA3A',
	            Heart: '\uEB51',
	            HeartFill: '\uEB52',
	            Tiles: '\uECA5',
	            Embed: '\uECCE',
	            Glimmer: '\uECF4',
	            Ascending: '\uEDC0',
	            Descending: '\uEDC1',
	            SortUp: '\uEE68',
	            SortDown: '\uEE69',
	            SyncToPC: '\uEE6E',
	            LargeGrid: '\uEECB',
	            SkypeCheck: '\uEF80',
	            SkypeClock: '\uEF81',
	            SkypeMinus: '\uEF82',
	            ClearFilter: '\uEF8F',
	            Flow: '\uEF90',
	            StatusCircleCheckmark: '\uF13E',
	            MoreVertical: '\uF2BC'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons.js.map

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-0\"",
	            src: "url('" + baseUrl + "fabric-icons-0-2a8db1f5.woff') format('woff')"
	        },
	        icons: {
	            InternetSharing: '\uE704',
	            Brightness: '\uE706',
	            MapPin: '\uE707',
	            Airplane: '\uE709',
	            Tablet: '\uE70A',
	            QuickNote: '\uE70B',
	            Video: '\uE714',
	            People: '\uE716',
	            Phone: '\uE717',
	            Pin: '\uE718',
	            Shop: '\uE719',
	            Stop: '\uE71A',
	            Link: '\uE71B',
	            AllApps: '\uE71D',
	            Zoom: '\uE71E',
	            ZoomOut: '\uE71F',
	            Microphone: '\uE720',
	            Camera: '\uE722',
	            Attach: '\uE723',
	            Send: '\uE724',
	            FavoriteList: '\uE728',
	            PageSolid: '\uE729',
	            Forward: '\uE72A',
	            Back: '\uE72B',
	            Refresh: '\uE72C',
	            Lock: '\uE72E',
	            ReportHacked: '\uE730',
	            EMI: '\uE731',
	            MiniLink: '\uE732',
	            Blocked: '\uE733',
	            ReadingMode: '\uE736',
	            Favicon: '\uE737',
	            Remove: '\uE738',
	            Checkbox: '\uE739',
	            CheckboxComposite: '\uE73A',
	            CheckboxFill: '\uE73B',
	            CheckboxIndeterminate: '\uE73C',
	            CheckboxCompositeReversed: '\uE73D',
	            BackToWindow: '\uE73F',
	            FullScreen: '\uE740',
	            Print: '\uE749',
	            Up: '\uE74A',
	            Down: '\uE74B',
	            OEM: '\uE74C',
	            Save: '\uE74E',
	            ReturnKey: '\uE751',
	            Cloud: '\uE753',
	            Flashlight: '\uE754',
	            CommandPrompt: '\uE756',
	            Sad: '\uE757',
	            RealEstate: '\uE758',
	            SIPMove: '\uE759',
	            EraseTool: '\uE75C',
	            GripperTool: '\uE75E',
	            Dialpad: '\uE75F',
	            PageLeft: '\uE760',
	            PageRight: '\uE761',
	            MultiSelect: '\uE762',
	            KeyboardClassic: '\uE765',
	            Play: '\uE768',
	            Pause: '\uE769',
	            InkingTool: '\uE76D',
	            Emoji2: '\uE76E',
	            GripperBarHorizontal: '\uE76F',
	            System: '\uE770',
	            Personalize: '\uE771',
	            SearchAndApps: '\uE773',
	            Globe: '\uE774',
	            EaseOfAccess: '\uE776',
	            ContactInfo: '\uE779',
	            Unpin: '\uE77A',
	            Contact: '\uE77B',
	            Memo: '\uE77C',
	            IncomingCall: '\uE77E',
	            Paste: '\uE77F',
	            WindowsLogo: '\uE782',
	            Error: '\uE783',
	            GripperBarVertical: '\uE784',
	            Unlock: '\uE785',
	            Slideshow: '\uE786',
	            AutoEnhanceOn: '\uE78D',
	            AutoEnhanceOff: '\uE78E',
	            Color: '\uE790',
	            SaveAs: '\uE792',
	            Light: '\uE793',
	            Filters: '\uE795',
	            AspectRatio: '\uE799',
	            Contrast: '\uE7A1',
	            Redo: '\uE7A6',
	            Crop: '\uE7A8',
	            PhotoCollection: '\uE7AA',
	            Album: '\uE7AB',
	            Rotate: '\uE7AD',
	            PanoIndicator: '\uE7B0',
	            Translate: '\uE7B2',
	            RedEye: '\uE7B3',
	            ThumbnailView: '\uE7B6',
	            Package: '\uE7B8',
	            Telemarketer: '\uE7B9',
	            Warning: '\uE7BA'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-0.js.map

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-1\"",
	            src: "url('" + baseUrl + "fabric-icons-1-360e3054.woff') format('woff')"
	        },
	        icons: {
	            Financial: '\uE7BB',
	            Education: '\uE7BE',
	            ShoppingCart: '\uE7BF',
	            Train: '\uE7C0',
	            Move: '\uE7C2',
	            TouchPointer: '\uE7C9',
	            Merge: '\uE7D5',
	            TurnRight: '\uE7DB',
	            Ferry: '\uE7E3',
	            Highlight: '\uE7E6',
	            PowerButton: '\uE7E8',
	            Tab: '\uE7E9',
	            Admin: '\uE7EF',
	            TVMonitor: '\uE7F4',
	            Speakers: '\uE7F5',
	            Game: '\uE7FC',
	            UnstackSelected: '\uE7FE',
	            StackIndicator: '\uE7FF',
	            Nav2DMapView: '\uE800',
	            StreetsideSplitMinimize: '\uE802',
	            Car: '\uE804',
	            Bus: '\uE806',
	            EatDrink: '\uE807',
	            SeeDo: '\uE808',
	            LocationCircle: '\uE80E',
	            Home: '\uE80F',
	            SwitcherStartEnd: '\uE810',
	            ParkingLocation: '\uE811',
	            IncidentTriangle: '\uE814',
	            Touch: '\uE815',
	            MapDirections: '\uE816',
	            CaretHollow: '\uE817',
	            CaretSolid: '\uE818',
	            History: '\uE81C',
	            Location: '\uE81D',
	            MapLayers: '\uE81E',
	            SearchNearby: '\uE820',
	            Work: '\uE821',
	            Recent: '\uE823',
	            Hotel: '\uE824',
	            Bank: '\uE825',
	            LocationDot: '\uE827',
	            Dictionary: '\uE82D',
	            ChromeBack: '\uE830',
	            FolderOpen: '\uE838',
	            PinnedFill: '\uE842',
	            RevToggleKey: '\uE845',
	            USB: '\uE88E',
	            Previous: '\uE892',
	            Next: '\uE893',
	            Sync: '\uE895',
	            Help: '\uE897',
	            Emoji: '\uE899',
	            MailForward: '\uE89C',
	            ClosePane: '\uE89F',
	            OpenPane: '\uE8A0',
	            PreviewLink: '\uE8A1',
	            ZoomIn: '\uE8A3',
	            Bookmarks: '\uE8A4',
	            Document: '\uE8A5',
	            ProtectedDocument: '\uE8A6',
	            OpenInNewWindow: '\uE8A7',
	            MailFill: '\uE8A8',
	            ViewAll: '\uE8A9',
	            Switch: '\uE8AB',
	            Rename: '\uE8AC',
	            Go: '\uE8AD',
	            Remote: '\uE8AF',
	            SelectAll: '\uE8B3',
	            Orientation: '\uE8B4',
	            Import: '\uE8B5',
	            Picture: '\uE8B9',
	            ChromeClose: '\uE8BB',
	            ShowResults: '\uE8BC',
	            Message: '\uE8BD',
	            CalendarDay: '\uE8BF',
	            CalendarWeek: '\uE8C0',
	            MailReplyAll: '\uE8C2',
	            Read: '\uE8C3',
	            Cut: '\uE8C6',
	            PaymentCard: '\uE8C7',
	            Copy: '\uE8C8',
	            Important: '\uE8C9',
	            MailReply: '\uE8CA',
	            GotoToday: '\uE8D1',
	            Font: '\uE8D2',
	            FontColor: '\uE8D3',
	            FolderFill: '\uE8D5',
	            Permissions: '\uE8D7',
	            DisableUpdates: '\uE8D8',
	            Unfavorite: '\uE8D9',
	            Italic: '\uE8DB',
	            Underline: '\uE8DC',
	            Bold: '\uE8DD',
	            MoveToFolder: '\uE8DE',
	            Dislike: '\uE8E0',
	            Like: '\uE8E1',
	            AlignCenter: '\uE8E3',
	            OpenFile: '\uE8E5',
	            FontDecrease: '\uE8E7'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-1.js.map

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-2\"",
	            src: "url('" + baseUrl + "fabric-icons-2-8820ef0b.woff') format('woff')"
	        },
	        icons: {
	            FontIncrease: '\uE8E8',
	            FontSize: '\uE8E9',
	            CellPhone: '\uE8EA',
	            RepeatOne: '\uE8ED',
	            RepeatAll: '\uE8EE',
	            Calculator: '\uE8EF',
	            Library: '\uE8F1',
	            PostUpdate: '\uE8F3',
	            NewFolder: '\uE8F4',
	            CalendarReply: '\uE8F5',
	            UnsyncFolder: '\uE8F6',
	            SyncFolder: '\uE8F7',
	            BlockContact: '\uE8F8',
	            Accept: '\uE8FB',
	            BulletedList: '\uE8FD',
	            Preview: '\uE8FF',
	            News: '\uE900',
	            Chat: '\uE901',
	            Group: '\uE902',
	            World: '\uE909',
	            Comment: '\uE90A',
	            DockLeft: '\uE90C',
	            DockRight: '\uE90D',
	            Repair: '\uE90F',
	            Accounts: '\uE910',
	            Street: '\uE913',
	            RadioBullet: '\uE915',
	            Stopwatch: '\uE916',
	            Clock: '\uE917',
	            WorldClock: '\uE918',
	            AlarmClock: '\uE919',
	            Photo: '\uE91B',
	            ActionCenter: '\uE91C',
	            Hospital: '\uE91D',
	            Timer: '\uE91E',
	            FullCircleMask: '\uE91F',
	            LocationFill: '\uE920',
	            ChromeMinimize: '\uE921',
	            ChromeRestore: '\uE923',
	            Annotation: '\uE924',
	            Fingerprint: '\uE928',
	            Handwriting: '\uE929',
	            ChromeFullScreen: '\uE92D',
	            Completed: '\uE930',
	            Label: '\uE932',
	            FlickDown: '\uE935',
	            FlickUp: '\uE936',
	            FlickLeft: '\uE937',
	            FlickRight: '\uE938',
	            MiniExpand: '\uE93A',
	            MiniContract: '\uE93B',
	            Streaming: '\uE93E',
	            MusicInCollection: '\uE940',
	            OneDriveLogo: '\uE941',
	            CompassNW: '\uE942',
	            Code: '\uE943',
	            LightningBolt: '\uE945',
	            CalculatorMultiply: '\uE947',
	            CalculatorAddition: '\uE948',
	            CalculatorSubtract: '\uE949',
	            CalculatorPercentage: '\uE94C',
	            CalculatorEqualTo: '\uE94E',
	            PrintfaxPrinterFile: '\uE956',
	            StorageOptical: '\uE958',
	            Communications: '\uE95A',
	            Headset: '\uE95B',
	            Health: '\uE95E',
	            FrontCamera: '\uE96B',
	            ChevronUpSmall: '\uE96D',
	            ChevronDownSmall: '\uE96E',
	            ChevronLeftSmall: '\uE96F',
	            ChevronRightSmall: '\uE970',
	            ChevronUpMed: '\uE971',
	            ChevronDownMed: '\uE972',
	            ChevronLeftMed: '\uE973',
	            ChevronRightMed: '\uE974',
	            Devices2: '\uE975',
	            PC1: '\uE977',
	            PresenceChickletVideo: '\uE979',
	            Reply: '\uE97A',
	            HalfAlpha: '\uE97E',
	            ConstructionCone: '\uE98F',
	            DoubleChevronLeftMed: '\uE991',
	            Volume0: '\uE992',
	            Volume1: '\uE993',
	            Volume2: '\uE994',
	            Volume3: '\uE995',
	            Chart: '\uE999',
	            Robot: '\uE99A',
	            Manufacturing: '\uE99C',
	            LockSolid: '\uE9A2',
	            FitPage: '\uE9A6',
	            FitWidth: '\uE9A7',
	            BidiLtr: '\uE9AA',
	            BidiRtl: '\uE9AB',
	            RightDoubleQuote: '\uE9B1',
	            Sunny: '\uE9BD',
	            CloudWeather: '\uE9BE',
	            Cloudy: '\uE9BF',
	            PartlyCloudyDay: '\uE9C0'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-2.js.map

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-3\"",
	            src: "url('" + baseUrl + "fabric-icons-3-7c253e01.woff') format('woff')"
	        },
	        icons: {
	            PartlyCloudyNight: '\uE9C1',
	            ClearNight: '\uE9C2',
	            RainShowersDay: '\uE9C3',
	            Rain: '\uE9C4',
	            Thunderstorms: '\uE9C6',
	            RainSnow: '\uE9C7',
	            Snow: '\uE9C8',
	            BlowingSnow: '\uE9C9',
	            Frigid: '\uE9CA',
	            Fog: '\uE9CB',
	            Squalls: '\uE9CC',
	            Duststorm: '\uE9CD',
	            Unknown: '\uE9CE',
	            Precipitation: '\uE9CF',
	            Ribbon: '\uE9D1',
	            AreaChart: '\uE9D2',
	            Assign: '\uE9D3',
	            FlowChart: '\uE9D4',
	            CheckList: '\uE9D5',
	            Diagnostic: '\uE9D9',
	            Generate: '\uE9DA',
	            LineChart: '\uE9E6',
	            Equalizer: '\uE9E9',
	            BarChartHorizontal: '\uE9EB',
	            BarChartVertical: '\uE9EC',
	            Freezing: '\uE9EF',
	            FunnelChart: '\uE9F1',
	            Processing: '\uE9F5',
	            Quantity: '\uE9F8',
	            ReportDocument: '\uE9F9',
	            StackColumnChart: '\uE9FC',
	            SnowShowerDay: '\uE9FD',
	            HailDay: '\uEA00',
	            WorkFlow: '\uEA01',
	            HourGlass: '\uEA03',
	            StoreLogoMed20: '\uEA04',
	            TimeSheet: '\uEA05',
	            TriangleSolid: '\uEA08',
	            UpgradeAnalysis: '\uEA0B',
	            VideoSolid: '\uEA0C',
	            RainShowersNight: '\uEA0F',
	            SnowShowerNight: '\uEA11',
	            Teamwork: '\uEA12',
	            HailNight: '\uEA13',
	            PeopleAdd: '\uEA15',
	            Glasses: '\uEA16',
	            DateTime2: '\uEA17',
	            Shield: '\uEA18',
	            Header1: '\uEA19',
	            PageAdd: '\uEA1A',
	            NumberedList: '\uEA1C',
	            PowerBILogo: '\uEA1E',
	            Info2: '\uEA1F',
	            MusicInCollectionFill: '\uEA36',
	            Asterisk: '\uEA38',
	            ErrorBadge: '\uEA39',
	            CircleFill: '\uEA3B',
	            Record2: '\uEA3F',
	            AllAppsMirrored: '\uEA40',
	            BookmarksMirrored: '\uEA41',
	            BulletedListMirrored: '\uEA42',
	            CaretHollowMirrored: '\uEA45',
	            CaretSolidMirrored: '\uEA46',
	            ChromeBackMirrored: '\uEA47',
	            ClosePaneMirrored: '\uEA49',
	            DockLeftMirrored: '\uEA4C',
	            DoubleChevronLeftMedMirrored: '\uEA4D',
	            GoMirrored: '\uEA4F',
	            HelpMirrored: '\uEA51',
	            ImportMirrored: '\uEA52',
	            ImportAllMirrored: '\uEA53',
	            ListMirrored: '\uEA55',
	            MailForwardMirrored: '\uEA56',
	            MailReplyMirrored: '\uEA57',
	            MailReplyAllMirrored: '\uEA58',
	            MiniContractMirrored: '\uEA59',
	            MiniExpandMirrored: '\uEA5A',
	            OpenPaneMirrored: '\uEA5B',
	            ParkingLocationMirrored: '\uEA5E',
	            SendMirrored: '\uEA63',
	            ShowResultsMirrored: '\uEA65',
	            ThumbnailViewMirrored: '\uEA67',
	            Media: '\uEA69',
	            Devices3: '\uEA6C',
	            Focus: '\uEA6F',
	            VideoLightOff: '\uEA74',
	            Lightbulb: '\uEA80',
	            StatusTriangle: '\uEA82',
	            VolumeDisabled: '\uEA85',
	            Puzzle: '\uEA86',
	            EmojiNeutral: '\uEA87',
	            EmojiDisappointed: '\uEA88',
	            HomeSolid: '\uEA8A',
	            Ringer: '\uEA8F',
	            PDF: '\uEA90',
	            HeartBroken: '\uEA92',
	            StoreLogo16: '\uEA96',
	            MultiSelectMirrored: '\uEA98',
	            Broom: '\uEA99',
	            Cocktails: '\uEA9D'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-3.js.map

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-4\"",
	            src: "url('" + baseUrl + "fabric-icons-4-15a649f8.woff') format('woff')"
	        },
	        icons: {
	            Wines: '\uEABF',
	            Articles: '\uEAC1',
	            Cycling: '\uEAC7',
	            DietPlanNotebook: '\uEAC8',
	            Pill: '\uEACB',
	            ExerciseTracker: '\uEACC',
	            HandsFree: '\uEAD0',
	            Medical: '\uEAD4',
	            Running: '\uEADA',
	            Weights: '\uEADB',
	            Trackers: '\uEADF',
	            AddNotes: '\uEAE3',
	            AllCurrency: '\uEAE4',
	            BarChart4: '\uEAE7',
	            CirclePlus: '\uEAEE',
	            Coffee: '\uEAEF',
	            Cotton: '\uEAF3',
	            Market: '\uEAFC',
	            Money: '\uEAFD',
	            PieDouble: '\uEB04',
	            PieSingle: '\uEB05',
	            RemoveFilter: '\uEB08',
	            Savings: '\uEB0B',
	            Sell: '\uEB0C',
	            StockDown: '\uEB0F',
	            StockUp: '\uEB11',
	            Lamp: '\uEB19',
	            Source: '\uEB1B',
	            MSNVideos: '\uEB1C',
	            Cricket: '\uEB1E',
	            Golf: '\uEB1F',
	            Baseball: '\uEB20',
	            Soccer: '\uEB21',
	            MoreSports: '\uEB22',
	            AutoRacing: '\uEB24',
	            CollegeHoops: '\uEB25',
	            CollegeFootball: '\uEB26',
	            ProFootball: '\uEB27',
	            ProHockey: '\uEB28',
	            Rugby: '\uEB2D',
	            SubstitutionsIn: '\uEB31',
	            Tennis: '\uEB33',
	            Arrivals: '\uEB34',
	            Design: '\uEB3C',
	            Website: '\uEB41',
	            Drop: '\uEB42',
	            HistoricalWeather: '\uEB43',
	            SkiResorts: '\uEB45',
	            Snowflake: '\uEB46',
	            BusSolid: '\uEB47',
	            FerrySolid: '\uEB48',
	            AirplaneSolid: '\uEB4C',
	            TrainSolid: '\uEB4D',
	            Ticket: '\uEB54',
	            WifiWarning4: '\uEB63',
	            Devices4: '\uEB66',
	            AzureLogo: '\uEB6A',
	            BingLogo: '\uEB6B',
	            MSNLogo: '\uEB6C',
	            OutlookLogoInverse: '\uEB6D',
	            OfficeLogo: '\uEB6E',
	            SkypeLogo: '\uEB6F',
	            Door: '\uEB75',
	            EditMirrored: '\uEB7E',
	            GiftCard: '\uEB8E',
	            DoubleBookmark: '\uEB8F',
	            StatusErrorFull: '\uEB90',
	            Certificate: '\uEB95',
	            FastForward: '\uEB9D',
	            Rewind: '\uEB9E',
	            Photo2: '\uEB9F',
	            OpenSource: '\uEBC2',
	            Movers: '\uEBCD',
	            CloudDownload: '\uEBD3',
	            Family: '\uEBDA',
	            WindDirection: '\uEBE6',
	            Bug: '\uEBE8',
	            SiteScan: '\uEBEC',
	            BrowserScreenShot: '\uEBED',
	            F12DevTools: '\uEBEE',
	            CSS: '\uEBEF',
	            JS: '\uEBF0',
	            DeliveryTruck: '\uEBF4',
	            ReminderPerson: '\uEBF7',
	            ReminderGroup: '\uEBF8',
	            TabletMode: '\uEBFC',
	            Umbrella: '\uEC04',
	            NetworkTower: '\uEC05',
	            CityNext: '\uEC06',
	            CityNext2: '\uEC07',
	            Section: '\uEC0C',
	            OneNoteLogoInverse: '\uEC0D',
	            ToggleFilled: '\uEC11',
	            ToggleBorder: '\uEC12',
	            SliderThumb: '\uEC13',
	            ToggleThumb: '\uEC14',
	            Documentation: '\uEC17',
	            Badge: '\uEC1B',
	            Giftbox: '\uEC1F',
	            VisualStudioLogo: '\uEC22'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-4.js.map

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-5\"",
	            src: "url('" + baseUrl + "fabric-icons-5-f6de453a.woff') format('woff')"
	        },
	        icons: {
	            HomeGroup: '\uEC26',
	            ExcelLogoInverse: '\uEC28',
	            WordLogoInverse: '\uEC29',
	            PowerPointLogoInverse: '\uEC2A',
	            Cafe: '\uEC32',
	            SpeedHigh: '\uEC4A',
	            Commitments: '\uEC4D',
	            ThisPC: '\uEC4E',
	            MusicNote: '\uEC4F',
	            MicOff: '\uEC54',
	            EdgeLogo: '\uEC60',
	            CompletedSolid: '\uEC61',
	            AlbumRemove: '\uEC62',
	            MessageFill: '\uEC70',
	            TabletSelected: '\uEC74',
	            MobileSelected: '\uEC75',
	            LaptopSelected: '\uEC76',
	            TVMonitorSelected: '\uEC77',
	            DeveloperTools: '\uEC7A',
	            Shapes: '\uEC7C',
	            InsertTextBox: '\uEC7D',
	            LowerBrightness: '\uEC8A',
	            WebComponents: '\uEC8B',
	            OfflineStorage: '\uEC8C',
	            DOM: '\uEC8D',
	            CloudUpload: '\uEC8E',
	            ScrollUpDown: '\uEC8F',
	            DateTime: '\uEC92',
	            Event: '\uECA3',
	            Cake: '\uECA4',
	            Org: '\uECA6',
	            PartyLeader: '\uECA7',
	            DRM: '\uECA8',
	            CloudAdd: '\uECA9',
	            AppIconDefault: '\uECAA',
	            Photo2Add: '\uECAB',
	            Photo2Remove: '\uECAC',
	            POI: '\uECAF',
	            AddTo: '\uECC8',
	            RadioBtnOff: '\uECCA',
	            RadioBtnOn: '\uECCB',
	            ExploreContent: '\uECCD',
	            Product: '\uECDC',
	            ProgressLoopInner: '\uECDE',
	            ProgressLoopOuter: '\uECDF',
	            Blocked2: '\uECE4',
	            FangBody: '\uECEB',
	            PageHeader: '\uECEE',
	            ChatInviteFriend: '\uECFE',
	            Brush: '\uECFF',
	            Shirt: '\uED00',
	            Crown: '\uED01',
	            Diamond: '\uED02',
	            ScaleUp: '\uED09',
	            QRCode: '\uED14',
	            Feedback: '\uED15',
	            SharepointLogoInverse: '\uED18',
	            YammerLogo: '\uED19',
	            Hide: '\uED1A',
	            Uneditable: '\uED1D',
	            ReturnToSession: '\uED24',
	            OpenFolderHorizontal: '\uED25',
	            CalendarMirrored: '\uED28',
	            SwayLogoInverse: '\uED29',
	            OutOfOffice: '\uED34',
	            Trophy: '\uED3F',
	            ReopenPages: '\uED50',
	            EmojiTabSymbols: '\uED58',
	            AADLogo: '\uED68',
	            AccessLogo: '\uED69',
	            AdminALogoInverse32: '\uED6A',
	            AdminCLogoInverse32: '\uED6B',
	            AdminDLogoInverse32: '\uED6C',
	            AdminELogoInverse32: '\uED6D',
	            AdminLLogoInverse32: '\uED6E',
	            AdminMLogoInverse32: '\uED6F',
	            AdminOLogoInverse32: '\uED70',
	            AdminPLogoInverse32: '\uED71',
	            AdminSLogoInverse32: '\uED72',
	            AdminYLogoInverse32: '\uED73',
	            DelveLogoInverse: '\uED76',
	            ExchangeLogoInverse: '\uED78',
	            LyncLogo: '\uED79',
	            OfficeVideoLogoInverse: '\uED7A',
	            SocialListeningLogo: '\uED7C',
	            VisioLogoInverse: '\uED7D',
	            Balloons: '\uED7E',
	            Cat: '\uED7F',
	            MailAlert: '\uED80',
	            MailCheck: '\uED81',
	            MailLowImportance: '\uED82',
	            MailPause: '\uED83',
	            MailRepeat: '\uED84',
	            SecurityGroup: '\uED85',
	            Table: '\uED86',
	            VoicemailForward: '\uED87',
	            VoicemailReply: '\uED88',
	            Waffle: '\uED89',
	            RemoveEvent: '\uED8A',
	            EventInfo: '\uED8B'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-5.js.map

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-6\"",
	            src: "url('" + baseUrl + "fabric-icons-6-32b702b9.woff') format('woff')"
	        },
	        icons: {
	            ForwardEvent: '\uED8C',
	            WipePhone: '\uED8D',
	            AddOnlineMeeting: '\uED8E',
	            JoinOnlineMeeting: '\uED8F',
	            RemoveLink: '\uED90',
	            PeopleBlock: '\uED91',
	            PeopleRepeat: '\uED92',
	            PeopleAlert: '\uED93',
	            PeoplePause: '\uED94',
	            TransferCall: '\uED95',
	            AddPhone: '\uED96',
	            UnknownCall: '\uED97',
	            NoteReply: '\uED98',
	            NoteForward: '\uED99',
	            NotePinned: '\uED9A',
	            RemoveOccurrence: '\uED9B',
	            Timeline: '\uED9C',
	            EditNote: '\uED9D',
	            CircleHalfFull: '\uED9E',
	            Room: '\uED9F',
	            Unsubscribe: '\uEDA0',
	            Subscribe: '\uEDA1',
	            HardDrive: '\uEDA2',
	            RecurringTask: '\uEDB2',
	            TaskManager: '\uEDB7',
	            TaskManagerMirrored: '\uEDB8',
	            Combine: '\uEDBB',
	            Split: '\uEDBC',
	            DoubleChevronUp: '\uEDBD',
	            DoubleChevronLeft: '\uEDBE',
	            DoubleChevronRight: '\uEDBF',
	            TextBox: '\uEDC2',
	            TextField: '\uEDC3',
	            NumberField: '\uEDC4',
	            Dropdown: '\uEDC5',
	            PenWorkspace: '\uEDC6',
	            BookingsLogo: '\uEDC7',
	            ClassNotebookLogoInverse: '\uEDC8',
	            DelveAnalyticsLogo: '\uEDCA',
	            DocsLogoInverse: '\uEDCB',
	            Dynamics365Logo: '\uEDCC',
	            DynamicSMBLogo: '\uEDCD',
	            OfficeAssistantLogo: '\uEDCE',
	            OfficeStoreLogo: '\uEDCF',
	            OneNoteEduLogoInverse: '\uEDD0',
	            PlannerLogo: '\uEDD1',
	            PowerApps: '\uEDD2',
	            Suitcase: '\uEDD3',
	            ProjectLogoInverse: '\uEDD4',
	            CaretLeft8: '\uEDD5',
	            CaretRight8: '\uEDD6',
	            CaretUp8: '\uEDD7',
	            CaretDown8: '\uEDD8',
	            CaretLeftSolid8: '\uEDD9',
	            CaretRightSolid8: '\uEDDA',
	            CaretUpSolid8: '\uEDDB',
	            CaretDownSolid8: '\uEDDC',
	            ClearFormatting: '\uEDDD',
	            Superscript: '\uEDDE',
	            Subscript: '\uEDDF',
	            Strikethrough: '\uEDE0',
	            Export: '\uEDE1',
	            ExportMirrored: '\uEDE2',
	            SingleBookmark: '\uEDFF',
	            SingleBookmarkSolid: '\uEE00',
	            DoubleChevronDown: '\uEE04',
	            FollowUser: '\uEE05',
	            ReplyAll: '\uEE0A',
	            WorkforceManagement: '\uEE0F',
	            RecruitmentManagement: '\uEE12',
	            Questionnaire: '\uEE19',
	            ManagerSelfService: '\uEE23',
	            ProductRelease: '\uEE2E',
	            ReplyMirrored: '\uEE35',
	            ReplyAllMirrored: '\uEE36',
	            Medal: '\uEE38',
	            AddGroup: '\uEE3D',
	            QuestionnaireMirrored: '\uEE4B',
	            TemporaryUser: '\uEE58',
	            CaretSolid16: '\uEE62',
	            GroupedDescending: '\uEE66',
	            GroupedAscending: '\uEE67',
	            AwayStatus: '\uEE6A',
	            MyMoviesTV: '\uEE6C',
	            GenericScan: '\uEE6F',
	            AustralianRules: '\uEE70',
	            WifiEthernet: '\uEE77',
	            TrackersMirrored: '\uEE92',
	            DateTimeMirrored: '\uEE93',
	            StopSolid: '\uEE95',
	            DoubleChevronUp12: '\uEE96',
	            DoubleChevronDown12: '\uEE97',
	            DoubleChevronLeft12: '\uEE98',
	            DoubleChevronRight12: '\uEE99',
	            CalendarAgenda: '\uEE9A',
	            AddEvent: '\uEEB5',
	            AssetLibrary: '\uEEB6',
	            DataConnectionLibrary: '\uEEB7',
	            DocLibrary: '\uEEB8',
	            FormLibrary: '\uEEB9'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-6.js.map

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-7\"",
	            src: "url('" + baseUrl + "fabric-icons-7-bbebf62d.woff') format('woff')"
	        },
	        icons: {
	            FormLibraryMirrored: '\uEEBA',
	            ReportLibrary: '\uEEBB',
	            ReportLibraryMirrored: '\uEEBC',
	            ContactCard: '\uEEBD',
	            CustomList: '\uEEBE',
	            CustomListMirrored: '\uEEBF',
	            IssueTracking: '\uEEC0',
	            IssueTrackingMirrored: '\uEEC1',
	            PictureLibrary: '\uEEC2',
	            OfficeAddinsLogo: '\uEEC7',
	            OfflineOneDriveParachute: '\uEEC8',
	            OfflineOneDriveParachuteDisabled: '\uEEC9',
	            TriangleSolidUp12: '\uEECC',
	            TriangleSolidDown12: '\uEECD',
	            TriangleSolidLeft12: '\uEECE',
	            TriangleSolidRight12: '\uEECF',
	            TriangleUp12: '\uEED0',
	            TriangleDown12: '\uEED1',
	            TriangleLeft12: '\uEED2',
	            TriangleRight12: '\uEED3',
	            ArrowUpRight8: '\uEED4',
	            ArrowDownRight8: '\uEED5',
	            DocumentSet: '\uEED6',
	            DelveAnalytics: '\uEEEE',
	            ArrowUpRightMirrored8: '\uEEEF',
	            ArrowDownRightMirrored8: '\uEEF0',
	            CompanyDirectory: '\uEF0D',
	            OpenEnrollment: '\uEF1C',
	            CompanyDirectoryMirrored: '\uEF2B',
	            OneDriveAdd: '\uEF32',
	            ProfileSearch: '\uEF35',
	            Header2: '\uEF36',
	            Header3: '\uEF37',
	            Header4: '\uEF38',
	            RingerSolid: '\uEF3A',
	            Eyedropper: '\uEF3C',
	            MarketDown: '\uEF42',
	            CalendarWorkWeek: '\uEF51',
	            SidePanel: '\uEF52',
	            GlobeFavorite: '\uEF53',
	            CaretTopLeftSolid8: '\uEF54',
	            CaretTopRightSolid8: '\uEF55',
	            ViewAll2: '\uEF56',
	            DocumentReply: '\uEF57',
	            PlayerSettings: '\uEF58',
	            ReceiptForward: '\uEF59',
	            ReceiptReply: '\uEF5A',
	            ReceiptCheck: '\uEF5B',
	            Fax: '\uEF5C',
	            RecurringEvent: '\uEF5D',
	            ReplyAlt: '\uEF5E',
	            ReplyAllAlt: '\uEF5F',
	            EditStyle: '\uEF60',
	            EditMail: '\uEF61',
	            Lifesaver: '\uEF62',
	            LifesaverLock: '\uEF63',
	            InboxCheck: '\uEF64',
	            FolderSearch: '\uEF65',
	            CollapseMenu: '\uEF66',
	            ExpandMenu: '\uEF67',
	            Boards: '\uEF68',
	            SunAdd: '\uEF69',
	            SunQuestionMark: '\uEF6A',
	            LandscapeOrientation: '\uEF6B',
	            DocumentSearch: '\uEF6C',
	            PublicCalendar: '\uEF6D',
	            PublicContactCard: '\uEF6E',
	            PublicEmail: '\uEF6F',
	            PublicFolder: '\uEF70',
	            WordDocument: '\uEF71',
	            PowerPointDocument: '\uEF72',
	            ExcelDocument: '\uEF73',
	            GroupedList: '\uEF74',
	            ClassroomLogo: '\uEF75',
	            Sections: '\uEF76',
	            EditPhoto: '\uEF77',
	            Starburst: '\uEF78',
	            ShareiOS: '\uEF79',
	            AirTickets: '\uEF7A',
	            PencilReply: '\uEF7B',
	            Tiles2: '\uEF7C',
	            SkypeCircleCheck: '\uEF7D',
	            SkypeCircleClock: '\uEF7E',
	            SkypeCircleMinus: '\uEF7F',
	            SkypeMessage: '\uEF83',
	            ClosedCaption: '\uEF84',
	            ATPLogo: '\uEF85',
	            OfficeFormsLogoInverse: '\uEF86',
	            RecycleBin: '\uEF87',
	            EmptyRecycleBin: '\uEF88',
	            Hide2: '\uEF89',
	            Breadcrumb: '\uEF8C',
	            BirthdayCake: '\uEF8D',
	            TimeEntry: '\uEF95',
	            CRMProcesses: '\uEFB1',
	            PageEdit: '\uEFB6',
	            PageArrowRight: '\uEFB8',
	            PageRemove: '\uEFBA',
	            Database: '\uEFC7',
	            DataManagementSettings: '\uEFC8'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-7.js.map

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-8\"",
	            src: "url('" + baseUrl + "fabric-icons-8-50fd817c.woff') format('woff')"
	        },
	        icons: {
	            CRMServices: '\uEFD2',
	            EditContact: '\uEFD3',
	            ConnectContacts: '\uEFD4',
	            AppIconDefaultAdd: '\uEFDA',
	            AppIconDefaultList: '\uEFDE',
	            ActivateOrders: '\uEFE0',
	            DeactivateOrders: '\uEFE1',
	            DocumentManagement: '\uEFFC',
	            CRMReport: '\uEFFE',
	            KnowledgeArticle: '\uF000',
	            Relationship: '\uF003',
	            HomeVerify: '\uF00E',
	            ZipFolder: '\uF012',
	            SurveyQuestions: '\uF01B',
	            TextDocument: '\uF029',
	            TextDocumentShared: '\uF02B',
	            PageCheckedOut: '\uF02C',
	            SaveAndClose: '\uF038',
	            Script: '\uF03A',
	            Archive: '\uF03F',
	            ActivityFeed: '\uF056',
	            Compare: '\uF057',
	            EventDate: '\uF059',
	            ArrowUpRight: '\uF069',
	            CaretRight: '\uF06B',
	            SetAction: '\uF071',
	            CaretSolidLeft: '\uF08D',
	            CaretSolidDown: '\uF08E',
	            CaretSolidRight: '\uF08F',
	            CaretSolidUp: '\uF090',
	            PowerAppsLogo: '\uF091',
	            PowerApps2Logo: '\uF092',
	            SearchIssue: '\uF09A',
	            SearchIssueMirrored: '\uF09B',
	            FabricAssetLibrary: '\uF09C',
	            FabricDataConnectionLibrary: '\uF09D',
	            FabricDocLibrary: '\uF09E',
	            FabricFormLibrary: '\uF09F',
	            FabricFormLibraryMirrored: '\uF0A0',
	            FabricReportLibrary: '\uF0A1',
	            FabricReportLibraryMirrored: '\uF0A2',
	            FabricPublicFolder: '\uF0A3',
	            FabricFolderSearch: '\uF0A4',
	            FabricMovetoFolder: '\uF0A5',
	            FabricUnsyncFolder: '\uF0A6',
	            FabricSyncFolder: '\uF0A7',
	            FabricOpenFolderHorizontal: '\uF0A8',
	            FabricFolder: '\uF0A9',
	            FabricFolderFill: '\uF0AA',
	            FabricNewFolder: '\uF0AB',
	            FabricPictureLibrary: '\uF0AC',
	            AddFavorite: '\uF0C8',
	            AddFavoriteFill: '\uF0C9',
	            BufferTimeBefore: '\uF0CF',
	            BufferTimeAfter: '\uF0D0',
	            BufferTimeBoth: '\uF0D1',
	            PublishContent: '\uF0D4',
	            ClipboardList: '\uF0E3',
	            ClipboardListMirrored: '\uF0E4',
	            CannedChat: '\uF0F2',
	            SkypeForBusinessLogo: '\uF0FC',
	            TabCenter: '\uF100',
	            PageCheckedin: '\uF104',
	            PageList: '\uF106',
	            ReadOutLoud: '\uF112',
	            CaretBottomLeftSolid8: '\uF121',
	            CaretBottomRightSolid8: '\uF122',
	            FolderHorizontal: '\uF12B',
	            MicrosoftStaffhubLogo: '\uF130',
	            GiftboxOpen: '\uF133',
	            StatusCircleOuter: '\uF136',
	            StatusCircleInner: '\uF137',
	            StatusCircleRing: '\uF138',
	            StatusTriangleOuter: '\uF139',
	            StatusTriangleInner: '\uF13A',
	            StatusTriangleExclamation: '\uF13B',
	            StatusCircleExclamation: '\uF13C',
	            StatusCircleErrorX: '\uF13D',
	            StatusCircleInfo: '\uF13F',
	            StatusCircleBlock: '\uF140',
	            StatusCircleBlock2: '\uF141',
	            StatusCircleQuestionMark: '\uF142',
	            StatusCircleSync: '\uF143',
	            Toll: '\uF160',
	            ExploreContentSingle: '\uF164',
	            CollapseContent: '\uF165',
	            CollapseContentSingle: '\uF166',
	            InfoSolid: '\uF167',
	            ProgressRingDots: '\uF16A',
	            CaloriesAdd: '\uF172',
	            BranchFork: '\uF173',
	            AddHome: '\uF17B',
	            MobileReport: '\uF18A',
	            ScaleVolume: '\uF18C',
	            HardDriveGroup: '\uF18F',
	            FastMode: '\uF19A',
	            ToggleLeft: '\uF19E',
	            ToggleRight: '\uF19F',
	            TriangleShape: '\uF1A7',
	            RectangleShape: '\uF1A9'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-8.js.map

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-9\"",
	            src: "url('" + baseUrl + "fabric-icons-9-88060b8a.woff') format('woff')"
	        },
	        icons: {
	            Trophy2: '\uF1AE',
	            BucketColor: '\uF1B6',
	            BucketColorFill: '\uF1B7',
	            Taskboard: '\uF1C2',
	            SingleColumn: '\uF1D3',
	            DoubleColumn: '\uF1D4',
	            TripleColumn: '\uF1D5',
	            ColumnLeftTwoThirds: '\uF1D6',
	            ColumnRightTwoThirds: '\uF1D7',
	            AccessLogoFill: '\uF1DB',
	            AnalyticsLogo: '\uF1DE',
	            AnalyticsQuery: '\uF1DF',
	            NewAnalyticsQuery: '\uF1E0',
	            AnalyticsReport: '\uF1E1',
	            WordLogo: '\uF1E3',
	            WordLogoFill: '\uF1E4',
	            ExcelLogo: '\uF1E5',
	            ExcelLogoFill: '\uF1E6',
	            OneNoteLogo: '\uF1E7',
	            OneNoteLogoFill: '\uF1E8',
	            OutlookLogo: '\uF1E9',
	            OutlookLogoFill: '\uF1EA',
	            PowerPointLogo: '\uF1EB',
	            PowerPointLogoFill: '\uF1EC',
	            PublisherLogo: '\uF1ED',
	            PublisherLogoFill: '\uF1EE',
	            ScheduleEventAction: '\uF1EF',
	            FlameSolid: '\uF1F3',
	            ServerProcesses: '\uF1FE',
	            Server: '\uF201',
	            SaveAll: '\uF203',
	            LinkedInLogo: '\uF20A',
	            Decimals: '\uF218',
	            SidePanelMirrored: '\uF221',
	            ProtectRestrict: '\uF22A',
	            Blog: '\uF22B',
	            UnknownMirrored: '\uF22E',
	            PublicContactCardMirrored: '\uF230',
	            GridViewSmall: '\uF232',
	            GridViewMedium: '\uF233',
	            GridViewLarge: '\uF234',
	            Step: '\uF241',
	            StepInsert: '\uF242',
	            StepShared: '\uF243',
	            StepSharedAdd: '\uF244',
	            StepSharedInsert: '\uF245',
	            ViewDashboard: '\uF246',
	            ViewList: '\uF247',
	            ViewListGroup: '\uF248',
	            ViewListTree: '\uF249',
	            TriggerAuto: '\uF24A',
	            TriggerUser: '\uF24B',
	            PivotChart: '\uF24C',
	            StackedBarChart: '\uF24D',
	            StackedLineChart: '\uF24E',
	            BuildQueue: '\uF24F',
	            BuildQueueNew: '\uF250',
	            UserFollowed: '\uF25C',
	            ContactLink: '\uF25F',
	            Stack: '\uF26F',
	            Bullseye: '\uF272',
	            VennDiagram: '\uF273',
	            FiveTileGrid: '\uF274',
	            FocalPoint: '\uF277',
	            RingerRemove: '\uF279',
	            TeamsLogoInverse: '\uF27A',
	            TeamsLogo: '\uF27B',
	            TeamsLogoFill: '\uF27C',
	            SkypeForBusinessLogoFill: '\uF27D',
	            SharepointLogo: '\uF27E',
	            SharepointLogoFill: '\uF27F',
	            DelveLogo: '\uF280',
	            DelveLogoFill: '\uF281',
	            OfficeVideoLogo: '\uF282',
	            OfficeVideoLogoFill: '\uF283',
	            ExchangeLogo: '\uF284',
	            ExchangeLogoFill: '\uF285',
	            Signin: '\uF286',
	            DocumentApproval: '\uF28B',
	            CloneToDesktop: '\uF28C',
	            InstallToDrive: '\uF28D',
	            Blur: '\uF28E',
	            Build: '\uF28F',
	            ProcessMetaTask: '\uF290',
	            BranchFork2: '\uF291',
	            BranchLocked: '\uF292',
	            BranchCommit: '\uF293',
	            BranchCompare: '\uF294',
	            BranchMerge: '\uF295',
	            BranchPullRequest: '\uF296',
	            BranchSearch: '\uF297',
	            BranchShelveset: '\uF298',
	            RawSource: '\uF299',
	            MergeDuplicate: '\uF29A',
	            RowsGroup: '\uF29B',
	            RowsChild: '\uF29C',
	            Deploy: '\uF29D',
	            Redeploy: '\uF29E',
	            ServerEnviroment: '\uF29F',
	            VisioDiagram: '\uF2A0'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-9.js.map

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-10\"",
	            src: "url('" + baseUrl + "fabric-icons-10-1ca3e4a1.woff') format('woff')"
	        },
	        icons: {
	            HighlightMappedShapes: '\uF2A1',
	            TextCallout: '\uF2A2',
	            IconSetsFlag: '\uF2A4',
	            VisioLogo: '\uF2A7',
	            VisioLogoFill: '\uF2A8',
	            VisioDocument: '\uF2A9',
	            TimelineProgress: '\uF2AA',
	            TimelineDelivery: '\uF2AB',
	            Backlog: '\uF2AC',
	            TeamFavorite: '\uF2AD',
	            TaskGroup: '\uF2AE',
	            TaskGroupMirrored: '\uF2AF',
	            ScopeTemplate: '\uF2B0',
	            AssessmentGroupTemplate: '\uF2B1',
	            NewTeamProject: '\uF2B2',
	            CommentAdd: '\uF2B3',
	            CommentNext: '\uF2B4',
	            CommentPrevious: '\uF2B5',
	            ShopServer: '\uF2B6',
	            LocaleLanguage: '\uF2B7',
	            QueryList: '\uF2B8',
	            UserSync: '\uF2B9',
	            UserPause: '\uF2BA',
	            StreamingOff: '\uF2BB',
	            ArrowTallUpLeft: '\uF2BD',
	            ArrowTallUpRight: '\uF2BE',
	            ArrowTallDownLeft: '\uF2BF',
	            ArrowTallDownRight: '\uF2C0',
	            FieldEmpty: '\uF2C1',
	            FieldFilled: '\uF2C2',
	            FieldChanged: '\uF2C3',
	            FieldNotChanged: '\uF2C4',
	            RingerOff: '\uF2C5',
	            PlayResume: '\uF2C6',
	            BulletedList2: '\uF2C7',
	            BulletedList2Mirrored: '\uF2C8',
	            ImageCrosshair: '\uF2C9',
	            GitGraph: '\uF2CA',
	            Repo: '\uF2CB',
	            RepoSolid: '\uF2CC',
	            FolderQuery: '\uF2CD',
	            FolderList: '\uF2CE',
	            FolderListMirrored: '\uF2CF',
	            LocationOutline: '\uF2D0',
	            POISolid: '\uF2D1',
	            CalculatorNotEqualTo: '\uF2D2',
	            BoxSubtractSolid: '\uF2D3',
	            BoxAdditionSolid: '\uF2D4',
	            BoxMultiplySolid: '\uF2D5',
	            BoxPlaySolid: '\uF2D6',
	            BoxCheckmarkSolid: '\uF2D7',
	            CirclePauseSolid: '\uF2D8',
	            CirclePause: '\uF2D9',
	            MSNVideosSolid: '\uF2DA',
	            CircleStopSolid: '\uF2DB',
	            CircleStop: '\uF2DC',
	            NavigateBack: '\uF2DD',
	            NavigateBackMirrored: '\uF2DE',
	            NavigateForward: '\uF2DF',
	            NavigateForwardMirrored: '\uF2E0',
	            UnknownSolid: '\uF2E1',
	            UnknownMirroredSolid: '\uF2E2',
	            CircleAddition: '\uF2E3',
	            CircleAdditionSolid: '\uF2E4',
	            FilePDB: '\uF2E5',
	            FileTemplate: '\uF2E6',
	            FileSQL: '\uF2E7',
	            FileJAVA: '\uF2E8',
	            FileASPX: '\uF2E9',
	            FileCSS: '\uF2EA',
	            FileSass: '\uF2EB',
	            FileLess: '\uF2EC',
	            FileHTML: '\uF2ED',
	            JavaScriptLanguage: '\uF2EE',
	            CSharpLanguage: '\uF2EF',
	            CSharp: '\uF2F0',
	            VisualBasicLanguage: '\uF2F1',
	            VB: '\uF2F2',
	            CPlusPlusLanguage: '\uF2F3',
	            CPlusPlus: '\uF2F4',
	            FSharpLanguage: '\uF2F5',
	            FSharp: '\uF2F6',
	            TypeScriptLanguage: '\uF2F7',
	            PythonLanguage: '\uF2F8',
	            PY: '\uF2F9',
	            CoffeeScript: '\uF2FA',
	            MarkDownLanguage: '\uF2FB',
	            FullWidth: '\uF2FE',
	            FullWidthEdit: '\uF2FF',
	            Plug: '\uF300',
	            PlugSolid: '\uF301',
	            PlugConnected: '\uF302',
	            PlugDisconnected: '\uF303',
	            UnlockSolid: '\uF304',
	            Variable: '\uF305',
	            Parameter: '\uF306',
	            CommentUrgent: '\uF307',
	            Storyboard: '\uF308',
	            DiffInline: '\uF309',
	            DiffSideBySide: '\uF30A'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-10.js.map

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-11\"",
	            src: "url('" + baseUrl + "fabric-icons-11-93bad8ee.woff') format('woff')"
	        },
	        icons: {
	            ImageDiff: '\uF30B',
	            ImagePixel: '\uF30C',
	            FileBug: '\uF30D',
	            FileCode: '\uF30E',
	            FileComment: '\uF30F',
	            BusinessHoursSign: '\uF310',
	            FileImage: '\uF311',
	            FileSymlink: '\uF312',
	            AutoFillTemplate: '\uF313',
	            WorkItem: '\uF314',
	            WorkItemBug: '\uF315',
	            LogRemove: '\uF316',
	            ColumnOptions: '\uF317',
	            Packages: '\uF318',
	            BuildIssue: '\uF319',
	            AssessmentGroup: '\uF31A',
	            VariableGroup: '\uF31B',
	            FullHistory: '\uF31C',
	            SingleColumnEdit: '\uF321',
	            DoubleColumnEdit: '\uF322',
	            TripleColumnEdit: '\uF323',
	            ColumnLeftTwoThirdsEdit: '\uF324',
	            ColumnRightTwoThirdsEdit: '\uF325',
	            StreamLogo: '\uF329',
	            PassiveAuthentication: '\uF32A',
	            AlertSolid: '\uF331',
	            MegaphoneSolid: '\uF332',
	            TaskSolid: '\uF333',
	            ConfigurationSolid: '\uF334',
	            BugSolid: '\uF335',
	            CrownSolid: '\uF336',
	            Trophy2Solid: '\uF337',
	            QuickNoteSolid: '\uF338',
	            ConstructionConeSolid: '\uF339',
	            PageListSolid: '\uF33A',
	            PageListMirroredSolid: '\uF33B',
	            StarburstSolid: '\uF33C',
	            ReadingModeSolid: '\uF33D',
	            SadSolid: '\uF33E',
	            HealthSolid: '\uF33F',
	            ShieldSolid: '\uF340',
	            GiftBoxSolid: '\uF341',
	            ShoppingCartSolid: '\uF342',
	            MailSolid: '\uF343',
	            ChatSolid: '\uF344',
	            RibbonSolid: '\uF345',
	            FinancialSolid: '\uF346',
	            FinancialMirroredSolid: '\uF347',
	            HeadsetSolid: '\uF348',
	            PermissionsSolid: '\uF349',
	            ParkingSolid: '\uF34A',
	            ParkingMirroredSolid: '\uF34B',
	            DiamondSolid: '\uF34C',
	            AsteriskSolid: '\uF34D',
	            OfflineStorageSolid: '\uF34E',
	            BankSolid: '\uF34F',
	            DecisionSolid: '\uF350',
	            Parachute: '\uF351',
	            ParachuteSolid: '\uF352',
	            FiltersSolid: '\uF353',
	            ColorSolid: '\uF354',
	            ReviewSolid: '\uF355',
	            ReviewRequestSolid: '\uF356',
	            ReviewRequestMirroredSolid: '\uF357',
	            ReviewResponseSolid: '\uF358',
	            FeedbackRequestSolid: '\uF359',
	            FeedbackRequestMirroredSolid: '\uF35A',
	            FeedbackResponseSolid: '\uF35B',
	            WorkItemBar: '\uF35C',
	            WorkItemBarSolid: '\uF35D',
	            Separator: '\uF35E',
	            NavigateExternalInline: '\uF35F',
	            PlanView: '\uF360',
	            TimelineMatrixView: '\uF361',
	            EngineeringGroup: '\uF362',
	            ProjectCollection: '\uF363',
	            CaretBottomRightCenter8: '\uF364',
	            CaretBottomLeftCenter8: '\uF365',
	            CaretTopRightCenter8: '\uF366',
	            CaretTopLeftCenter8: '\uF367',
	            DonutChart: '\uF368',
	            ChevronUnfold10: '\uF369',
	            ChevronFold10: '\uF36A',
	            DoubleChevronDown8: '\uF36B',
	            DoubleChevronUp8: '\uF36C',
	            DoubleChevronLeft8: '\uF36D',
	            DoubleChevronRight8: '\uF36E',
	            ChevronDownEnd6: '\uF36F',
	            ChevronUpEnd6: '\uF370',
	            ChevronLeftEnd6: '\uF371',
	            ChevronRightEnd6: '\uF372',
	            ContextMenu: '\uF37C',
	            AzureAPIManagement: '\uF37F',
	            AzureServiceEndpoint: '\uF380',
	            VSTSLogo: '\uF381',
	            VSTSAltLogo1: '\uF382',
	            VSTSAltLogo2: '\uF383',
	            FileTypeSolution: '\uF387',
	            WordLogoInverse16: '\uF390',
	            WordLogo16: '\uF391'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-11.js.map

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-12\"",
	            src: "url('" + baseUrl + "fabric-icons-12-d9534567.woff') format('woff')"
	        },
	        icons: {
	            WordLogoFill16: '\uF392',
	            PowerPointLogoInverse16: '\uF393',
	            PowerPointLogo16: '\uF394',
	            PowerPointLogoFill16: '\uF395',
	            ExcelLogoInverse16: '\uF396',
	            ExcelLogo16: '\uF397',
	            ExcelLogoFill16: '\uF398',
	            OneNoteLogoInverse16: '\uF399',
	            OneNoteLogo16: '\uF39A',
	            OneNoteLogoFill16: '\uF39B',
	            OutlookLogoInverse16: '\uF39C',
	            OutlookLogo16: '\uF39D',
	            OutlookLogoFill16: '\uF39E',
	            PublisherLogoInverse16: '\uF39F',
	            PublisherLogo16: '\uF3A0',
	            PublisherLogoFill16: '\uF3A1',
	            VisioLogoInverse16: '\uF3A2',
	            VisioLogo16: '\uF3A3',
	            VisioLogoFill16: '\uF3A4',
	            TestBeaker: '\uF3A5',
	            TestBeakerSolid: '\uF3A6',
	            TestExploreSolid: '\uF3A7',
	            TestAutoSolid: '\uF3A8',
	            TestUserSolid: '\uF3A9',
	            TestImpactSolid: '\uF3AA',
	            TestPlan: '\uF3AB',
	            TestStep: '\uF3AC',
	            TestParameter: '\uF3AD',
	            TestSuite: '\uF3AE',
	            TestCase: '\uF3AF',
	            Sprint: '\uF3B0',
	            SignOut: '\uF3B1',
	            TriggerApproval: '\uF3B2',
	            Rocket: '\uF3B3',
	            AzureKeyVault: '\uF3B4',
	            Onboarding: '\uF3BA',
	            Transition: '\uF3BC',
	            LikeSolid: '\uF3BF',
	            DislikeSolid: '\uF3C0',
	            CRMCustomerInsightsApp: '\uF3C8',
	            EditCreate: '\uF3C9',
	            UnSetColor: '\uF3F9',
	            DeclineCall: '\uF405',
	            RectangularClipping: '\uF407',
	            TeamsLogo16: '\uF40A',
	            TeamsLogoFill16: '\uF40B',
	            Spacer: '\uF40D',
	            SkypeLogo16: '\uF40E',
	            SkypeForBusinessLogo16: '\uF40F',
	            SkypeForBusinessLogoFill16: '\uF410',
	            FilterSolid: '\uF412',
	            MailUndelivered: '\uF415',
	            MailTentative: '\uF416',
	            MailTentativeMirrored: '\uF417',
	            MailReminder: '\uF418',
	            ReceiptUndelivered: '\uF419',
	            ReceiptTentative: '\uF41A',
	            ReceiptTentativeMirrored: '\uF41B',
	            Inbox: '\uF41C',
	            IRMReply: '\uF41D',
	            IRMReplyMirrored: '\uF41E',
	            IRMForward: '\uF41F',
	            IRMForwardMirrored: '\uF420',
	            VoicemailIRM: '\uF421',
	            EventAccepted: '\uF422',
	            EventTentative: '\uF423',
	            EventTentativeMirrored: '\uF424',
	            EventDeclined: '\uF425',
	            IDBadge: '\uF427',
	            BackgroundColor: '\uF42B',
	            OfficeFormsLogoInverse16: '\uF433',
	            OfficeFormsLogo: '\uF434',
	            OfficeFormsLogoFill: '\uF435',
	            OfficeFormsLogo16: '\uF436',
	            OfficeFormsLogoFill16: '\uF437',
	            OfficeFormsLogoInverse24: '\uF43A',
	            OfficeFormsLogo24: '\uF43B',
	            OfficeFormsLogoFill24: '\uF43C',
	            PageLock: '\uF43F',
	            NotExecuted: '\uF440',
	            NotImpactedSolid: '\uF441',
	            FieldReadOnly: '\uF442',
	            FieldRequired: '\uF443',
	            BacklogBoard: '\uF444',
	            ExternalBuild: '\uF445',
	            ExternalTFVC: '\uF446',
	            ExternalXAML: '\uF447',
	            IssueSolid: '\uF448',
	            DefectSolid: '\uF449',
	            LadybugSolid: '\uF44A',
	            NugetLogo: '\uF44C',
	            TFVCLogo: '\uF44D',
	            ProjectLogo32: '\uF47E',
	            ProjectLogoFill32: '\uF47F',
	            ProjectLogo16: '\uF480',
	            ProjectLogoFill16: '\uF481',
	            SwayLogo32: '\uF482',
	            SwayLogoFill32: '\uF483',
	            SwayLogo16: '\uF484',
	            SwayLogoFill16: '\uF485'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-12.js.map

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-13\"",
	            src: "url('" + baseUrl + "fabric-icons-13-0b48c801.woff') format('woff')"
	        },
	        icons: {
	            ClassNotebookLogo32: '\uF486',
	            ClassNotebookLogoFill32: '\uF487',
	            ClassNotebookLogo16: '\uF488',
	            ClassNotebookLogoFill16: '\uF489',
	            ClassNotebookLogoInverse32: '\uF48A',
	            ClassNotebookLogoInverse16: '\uF48B',
	            StaffNotebookLogo32: '\uF48C',
	            StaffNotebookLogoFill32: '\uF48D',
	            StaffNotebookLogo16: '\uF48E',
	            StaffNotebookLogoFill16: '\uF48F',
	            StaffNotebookLogoInverted32: '\uF490',
	            StaffNotebookLogoInverted16: '\uF491',
	            KaizalaLogo: '\uF492',
	            TaskLogo: '\uF493',
	            ProtectionCenterLogo32: '\uF494',
	            GallatinLogo: '\uF496',
	            Globe2: '\uF49A',
	            Guitar: '\uF49B',
	            Breakfast: '\uF49C',
	            Brunch: '\uF49D',
	            BeerMug: '\uF49E',
	            Vacation: '\uF49F',
	            Teeth: '\uF4A0',
	            Taxi: '\uF4A1',
	            Chopsticks: '\uF4A2',
	            SyncOccurence: '\uF4A3',
	            UnsyncOccurence: '\uF4A4',
	            GIF: '\uF4A9',
	            PrimaryCalendar: '\uF4AE',
	            SearchCalendar: '\uF4AF',
	            VideoOff: '\uF4B0',
	            MicrosoftFlowLogo: '\uF4B1',
	            BusinessCenterLogo: '\uF4B2',
	            ToDoLogoBottom: '\uF4B3',
	            ToDoLogoTop: '\uF4B4',
	            EditSolid12: '\uF4B5',
	            EditSolidMirrored12: '\uF4B6',
	            UneditableSolid12: '\uF4B7',
	            UneditableSolidMirrored12: '\uF4B8',
	            UneditableMirrored: '\uF4B9',
	            AdminALogo32: '\uF4BA',
	            AdminALogoFill32: '\uF4BB',
	            ToDoLogoInverse: '\uF4BC',
	            Snooze: '\uF4BD',
	            WaffleOffice365: '\uF4E0',
	            ImageSearch: '\uF4E8',
	            NewsSearch: '\uF4E9',
	            VideoSearch: '\uF4EA',
	            R: '\uF4EB',
	            FontColorA: '\uF4EC',
	            FontColorSwatch: '\uF4ED',
	            LightWeight: '\uF4EE',
	            NormalWeight: '\uF4EF',
	            SemiboldWeight: '\uF4F0',
	            GroupObject: '\uF4F1',
	            UngroupObject: '\uF4F2',
	            AlignHorizontalLeft: '\uF4F3',
	            AlignHorizontalCenter: '\uF4F4',
	            AlignHorizontalRight: '\uF4F5',
	            AlignVerticalTop: '\uF4F6',
	            AlignVerticalCenter: '\uF4F7',
	            AlignVerticalBottom: '\uF4F8',
	            HorizontalDistributeCenter: '\uF4F9',
	            VerticalDistributeCenter: '\uF4FA',
	            Ellipse: '\uF4FB',
	            Line: '\uF4FC',
	            Octagon: '\uF4FD',
	            Hexagon: '\uF4FE',
	            Pentagon: '\uF4FF',
	            RightTriangle: '\uF500',
	            HalfCircle: '\uF501',
	            QuarterCircle: '\uF502',
	            ThreeQuarterCircle: '\uF503',
	            '6PointStar': '\uF504',
	            '12PointStar': '\uF505',
	            ArrangeBringToFront: '\uF506',
	            ArrangeSendToBack: '\uF507',
	            ArrangeSendBackward: '\uF508',
	            ArrangeBringForward: '\uF509',
	            BorderDash: '\uF50A',
	            BorderDot: '\uF50B',
	            LineStyle: '\uF50C',
	            LineThickness: '\uF50D',
	            WindowEdit: '\uF50E',
	            HintText: '\uF50F',
	            MediaAdd: '\uF510',
	            AnchorLock: '\uF511',
	            AutoHeight: '\uF512',
	            ChartSeries: '\uF513',
	            ChartXAngle: '\uF514',
	            ChartYAngle: '\uF515',
	            Combobox: '\uF516',
	            LineSpacing: '\uF517',
	            Padding: '\uF518',
	            PaddingTop: '\uF519',
	            PaddingBottom: '\uF51A',
	            PaddingLeft: '\uF51B',
	            PaddingRight: '\uF51C',
	            NavigationFlipper: '\uF51D',
	            AlignJustify: '\uF51E'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-13.js.map

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-14\"",
	            src: "url('" + baseUrl + "fabric-icons-14-9a8324a9.woff') format('woff')"
	        },
	        icons: {
	            TextOverflow: '\uF51F',
	            VisualsFolder: '\uF520',
	            VisualsStore: '\uF521',
	            PictureCenter: '\uF522',
	            PictureFill: '\uF523',
	            PicturePosition: '\uF524',
	            PictureStretch: '\uF525',
	            PictureTile: '\uF526',
	            Slider: '\uF527',
	            SliderHandleSize: '\uF528',
	            DefaultRatio: '\uF529',
	            NumberSequence: '\uF52A',
	            GUID: '\uF52B',
	            ReportAdd: '\uF52C',
	            DashboardAdd: '\uF52D',
	            MapPinSolid: '\uF52E',
	            WebPublish: '\uF52F',
	            PieSingleSolid: '\uF530',
	            BlockedSolid: '\uF531',
	            DrillDown: '\uF532',
	            DrillDownSolid: '\uF533',
	            DrillExpand: '\uF534',
	            DrillShow: '\uF535',
	            SpecialEvent: '\uF536',
	            OneDriveFolder16: '\uF53B',
	            FunctionalManagerDashboard: '\uF542',
	            BIDashboard: '\uF543',
	            CodeEdit: '\uF544',
	            RenewalCurrent: '\uF545',
	            RenewalFuture: '\uF546',
	            SplitObject: '\uF547',
	            BulkUpload: '\uF548',
	            DownloadDocument: '\uF549',
	            Flower: '\uF54E',
	            WaitlistConfirm: '\uF550',
	            WaitlistConfirmMirrored: '\uF551',
	            LaptopSecure: '\uF552',
	            DragObject: '\uF553',
	            EntryView: '\uF554',
	            EntryDecline: '\uF555',
	            ContactCardSettings: '\uF556',
	            ContactCardSettingsMirrored: '\uF557',
	            CalendarSettings: '\uF558',
	            CalendarSettingsMirrored: '\uF559',
	            HardDriveLock: '\uF55A',
	            HardDriveUnlock: '\uF55B',
	            AccountManagement: '\uF55C',
	            TransitionPop: '\uF5B2',
	            TransitionPush: '\uF5B3',
	            TransitionEffect: '\uF5B4',
	            LookupEntities: '\uF5B5',
	            ExploreData: '\uF5B6',
	            AddBookmark: '\uF5B7',
	            SearchBookmark: '\uF5B8',
	            DrillThrough: '\uF5B9',
	            MasterDatabase: '\uF5BA',
	            CertifiedDatabase: '\uF5BB',
	            MaximumValue: '\uF5BC',
	            MinimumValue: '\uF5BD',
	            VisualStudioIDELogo32: '\uF5D0',
	            PasteAsText: '\uF5D5',
	            PasteAsCode: '\uF5D6',
	            BrowserTab: '\uF5D7',
	            BrowserTabScreenshot: '\uF5D8',
	            DesktopScreenshot: '\uF5D9',
	            FileYML: '\uF5DA',
	            ClipboardSolid: '\uF5DC',
	            FabricUserFolder: '\uF5E5',
	            FabricNetworkFolder: '\uF5E6',
	            AnalyticsView: '\uF5F1',
	            Video360Generic: '\uF609',
	            Leave: '\uF627',
	            Trending12: '\uF62D',
	            Blocked12: '\uF62E',
	            Warning12: '\uF62F',
	            CheckedOutByOther12: '\uF630',
	            CheckedOutByYou12: '\uF631',
	            CircleShapeSolid: '\uF63C',
	            SquareShapeSolid: '\uF63D',
	            TriangleShapeSolid: '\uF63E',
	            DropShapeSolid: '\uF63F',
	            RectangleShapeSolid: '\uF640',
	            ZoomToFit: '\uF649',
	            InsertColumnsLeft: '\uF64A',
	            InsertColumnsRight: '\uF64B',
	            InsertRowsAbove: '\uF64C',
	            InsertRowsBelow: '\uF64D',
	            DeleteColumns: '\uF64E',
	            DeleteRows: '\uF64F',
	            DeleteRowsMirrored: '\uF650',
	            DeleteTable: '\uF651',
	            AccountBrowser: '\uF652',
	            VersionControlPush: '\uF664',
	            StackedColumnChart2: '\uF666',
	            TripleColumnWide: '\uF66E',
	            QuadColumn: '\uF66F',
	            WhiteBoardApp16: '\uF673',
	            WhiteBoardApp32: '\uF674',
	            InsertSignatureLine: '\uF677',
	            ArrangeByFrom: '\uF678'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-14.js.map

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-15\"",
	            src: "url('" + baseUrl + "fabric-icons-15-65272067.woff') format('woff')"
	        },
	        icons: {
	            Phishing: '\uF679',
	            CreateMailRule: '\uF67A',
	            PublishCourse: '\uF699',
	            DictionaryRemove: '\uF69A',
	            UserRemove: '\uF69B',
	            UserEvent: '\uF69C',
	            Encryption: '\uF69D',
	            PasswordField: '\uF6AA',
	            OpenInNewTab: '\uF6AB',
	            Hide3: '\uF6AC',
	            VerifiedBrandSolid: '\uF6AD',
	            MarkAsProtected: '\uF6AE',
	            AuthenticatorApp: '\uF6B1',
	            WebTemplate: '\uF6B2',
	            DefenderTVM: '\uF6B3',
	            MedalSolid: '\uF6B9',
	            D365TalentLearn: '\uF6BB',
	            D365TalentInsight: '\uF6BC',
	            D365TalentHRCore: '\uF6BD',
	            BacklogList: '\uF6BF',
	            ButtonControl: '\uF6C0',
	            TableGroup: '\uF6D9',
	            MountainClimbing: '\uF6DB',
	            TagUnknown: '\uF6DF',
	            TagUnknownMirror: '\uF6E0',
	            TagUnknown12: '\uF6E1',
	            TagUnknown12Mirror: '\uF6E2',
	            Link12: '\uF6E3',
	            Presentation: '\uF6E4',
	            Presentation12: '\uF6E5',
	            Lock12: '\uF6E6',
	            BuildDefinition: '\uF6E9',
	            ReleaseDefinition: '\uF6EA',
	            SaveTemplate: '\uF6EC',
	            UserGauge: '\uF6ED',
	            BlockedSiteSolid12: '\uF70A',
	            TagSolid: '\uF70E',
	            OfficeChat: '\uF70F',
	            OfficeChatSolid: '\uF710',
	            MailSchedule: '\uF72E',
	            WarningSolid: '\uF736',
	            Blocked2Solid: '\uF737',
	            SkypeCircleArrow: '\uF747',
	            SkypeArrow: '\uF748',
	            SyncStatus: '\uF751',
	            SyncStatusSolid: '\uF752',
	            ProjectDocument: '\uF759',
	            ToDoLogoOutline: '\uF75B',
	            VisioOnlineLogoFill32: '\uF75F',
	            VisioOnlineLogo32: '\uF760',
	            VisioOnlineLogoCloud32: '\uF761',
	            VisioDiagramSync: '\uF762',
	            Event12: '\uF763',
	            EventDateMissed12: '\uF764',
	            UserOptional: '\uF767',
	            ResponsesMenu: '\uF768',
	            DoubleDownArrow: '\uF769',
	            DistributeDown: '\uF76A',
	            BookmarkReport: '\uF76B',
	            FilterSettings: '\uF76C',
	            GripperDotsVertical: '\uF772',
	            MailAttached: '\uF774',
	            AddIn: '\uF775',
	            LinkedDatabase: '\uF779',
	            PromotedDatabase: '\uF77D',
	            BarChartVerticalFilter: '\uF77E',
	            BarChartVerticalFilterSolid: '\uF77F',
	            MicrosoftTranslatorLogo: '\uF782',
	            ShowTimeAs: '\uF787',
	            FileRequest: '\uF789',
	            WorkItemAlert: '\uF78F',
	            PowerBILogo16: '\uF790',
	            PowerBILogoBackplate16: '\uF791',
	            BulletedListText: '\uF792',
	            BulletedListBullet: '\uF793',
	            BulletedListTextMirrored: '\uF794',
	            BulletedListBulletMirrored: '\uF795',
	            NumberedListText: '\uF796',
	            NumberedListNumber: '\uF797',
	            NumberedListTextMirrored: '\uF798',
	            NumberedListNumberMirrored: '\uF799',
	            RemoveLinkChain: '\uF79A',
	            RemoveLinkX: '\uF79B',
	            FabricTextHighlight: '\uF79C',
	            ClearFormattingA: '\uF79D',
	            ClearFormattingEraser: '\uF79E',
	            Photo2Fill: '\uF79F',
	            IncreaseIndentText: '\uF7A0',
	            IncreaseIndentArrow: '\uF7A1',
	            DecreaseIndentText: '\uF7A2',
	            DecreaseIndentArrow: '\uF7A3',
	            IncreaseIndentTextMirrored: '\uF7A4',
	            IncreaseIndentArrowMirrored: '\uF7A5',
	            DecreaseIndentTextMirrored: '\uF7A6',
	            DecreaseIndentArrowMirrored: '\uF7A7',
	            CheckListText: '\uF7A8',
	            CheckListCheck: '\uF7A9',
	            CheckListTextMirrored: '\uF7AA',
	            CheckListCheckMirrored: '\uF7AB',
	            NumberSymbol: '\uF7AC'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-15.js.map

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var styling_1 = __webpack_require__(467);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-16\"",
	            src: "url('" + baseUrl + "fabric-icons-16-dff5b9a6.woff') format('woff')"
	        },
	        icons: {
	            Coupon: '\uF7BC',
	            VerifiedBrand: '\uF7BD',
	            ReleaseGate: '\uF7BE',
	            ReleaseGateCheck: '\uF7BF',
	            ReleaseGateError: '\uF7C0',
	            M365InvoicingLogo: '\uF7C1',
	            FabricTextHighlightComposite: '\uF7DA',
	            Dataflows: '\uF7DD',
	            GenericScanFilled: '\uF7DE',
	            DiagnosticDataBarTooltip: '\uF7DF',
	            SaveToMobile: '\uF7E0',
	            Orientation2: '\uF7E1',
	            ScreenCast: '\uF7E2',
	            ShowGrid: '\uF7E3',
	            SnapToGrid: '\uF7E4',
	            ContactList: '\uF7E5',
	            NewMail: '\uF7EA',
	            EyeShadow: '\uF7EB',
	            FabricFolderConfirm: '\uF7FF',
	            InformationBarriers: '\uF803',
	            CommentActive: '\uF804',
	            ColumnVerticalSectionEdit: '\uF806',
	            WavingHand: '\uF807',
	            ShakeDevice: '\uF80A',
	            SmartGlassRemote: '\uF80B',
	            Rotate90Clockwise: '\uF80D',
	            Rotate90CounterClockwise: '\uF80E',
	            CampaignTemplate: '\uF811',
	            ChartTemplate: '\uF812',
	            PageListFilter: '\uF813',
	            SecondaryNav: '\uF814',
	            ColumnVerticalSection: '\uF81E',
	            SkypeCircleSlash: '\uF825',
	            SkypeSlash: '\uF826',
	            CustomizeToolbar: '\uF828',
	            DuplicateRow: '\uF82A',
	            RemoveFromTrash: '\uF82B',
	            MailOptions: '\uF82C',
	            Childof: '\uF82D',
	            Footer: '\uF82E',
	            Header: '\uF82F',
	            BarChartVerticalFill: '\uF830',
	            StackedColumnChart2Fill: '\uF831',
	            PlainText: '\uF834',
	            AccessibiltyChecker: '\uF835',
	            DatabaseSync: '\uF842',
	            ReservationOrders: '\uF845',
	            TabOneColumn: '\uF849',
	            TabTwoColumn: '\uF84A',
	            TabThreeColumn: '\uF84B',
	            MicrosoftTranslatorLogoGreen: '\uF852',
	            MicrosoftTranslatorLogoBlue: '\uF853',
	            InternalInvestigation: '\uF854',
	            AppleTVPlay: '\uF859',
	            AppleTVMonitor: '\uF85A',
	            AppleTVMicrophone: '\uF85B',
	            AppleTVMenu: '\uF85C',
	            AddReaction: '\uF85D',
	            DecreaseIndentLegacy: '\uE290',
	            IncreaseIndentLegacy: '\uE291',
	            SizeLegacy: '\uE2B2'
	        }
	    };
	    styling_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-16.js.map

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var styling_1 = __webpack_require__(467);
	exports.registerIconAliases = function () {
	    styling_1.registerIconAlias('trash', 'delete');
	    styling_1.registerIconAlias('onedrive', 'onedrivelogo');
	    styling_1.registerIconAlias('alertsolid12', 'eventdatemissed12');
	    styling_1.registerIconAlias('sixpointstar', '6pointstar');
	    styling_1.registerIconAlias('twelvepointstar', '12pointstar');
	    styling_1.registerIconAlias('toggleon', 'toggleleft');
	    styling_1.registerIconAlias('toggleoff', 'toggleright');
	};
	exports.default = exports.registerIconAliases;
	//# sourceMappingURL=iconAliases.js.map

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// @uifabric/icons@6.5.4
	// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
	var set_version_1 = __webpack_require__(465);
	set_version_1.setVersion('@uifabric/icons', '6.5.4');
	//# sourceMappingURL=version.js.map

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1089), exports);
	//# sourceMappingURL=Keytip.js.map

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1090), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var KeytipUtils_1 = __webpack_require__(689);
	var Callout_1 = __webpack_require__(603);
	var ContextualMenu_1 = __webpack_require__(694);
	var KeytipContent_1 = __webpack_require__(1091);
	var Keytip_styles_1 = __webpack_require__(1093);
	/**
	 * A callout corresponding to another Fabric component to describe a key sequence that will activate that component
	 */
	var Keytip = /** @class */ (function (_super) {
	    tslib_1.__extends(Keytip, _super);
	    function Keytip() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Keytip.prototype.render = function () {
	        var _a = this.props, keySequences = _a.keySequences, offset = _a.offset, overflowSetSequence = _a.overflowSetSequence;
	        var calloutProps = this.props.calloutProps;
	        var keytipTarget;
	        // Take into consideration the overflow sequence
	        if (overflowSetSequence) {
	            keytipTarget = KeytipUtils_1.ktpTargetFromSequences(KeytipUtils_1.mergeOverflows(keySequences, overflowSetSequence));
	        }
	        else {
	            keytipTarget = KeytipUtils_1.ktpTargetFromSequences(keySequences);
	        }
	        if (offset) {
	            // Set callout to top-left corner, will be further positioned in
	            // getCalloutOffsetStyles
	            calloutProps = tslib_1.__assign({}, calloutProps, { coverTarget: true, directionalHint: ContextualMenu_1.DirectionalHint.topLeftEdge });
	        }
	        if (!calloutProps || calloutProps.directionalHint === undefined) {
	            // Default callout directional hint to BottomCenter
	            calloutProps = tslib_1.__assign({}, calloutProps, { directionalHint: ContextualMenu_1.DirectionalHint.bottomCenter });
	        }
	        return (React.createElement(Callout_1.Callout, tslib_1.__assign({}, calloutProps, { isBeakVisible: false, doNotLayer: true, minPagePadding: 0, styles: offset ? Keytip_styles_1.getCalloutOffsetStyles(offset) : Keytip_styles_1.getCalloutStyles, preventDismissOnScroll: true, target: keytipTarget }),
	            React.createElement(KeytipContent_1.KeytipContent, tslib_1.__assign({}, this.props))));
	    };
	    return Keytip;
	}(React.Component));
	exports.Keytip = Keytip;
	//# sourceMappingURL=Keytip.js.map

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var KeytipContent_base_1 = __webpack_require__(1092);
	var Keytip_styles_1 = __webpack_require__(1093);
	exports.KeytipContent = Utilities_1.styled(KeytipContent_base_1.KeytipContentBase, Keytip_styles_1.getStyles, undefined, {
	    scope: 'KeytipContent'
	});
	//# sourceMappingURL=KeytipContent.js.map

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	/**
	 * A component corresponding the the content rendered inside the callout of the keytip component.
	 * {@docCategory Keytips}
	 */
	var KeytipContentBase = /** @class */ (function (_super) {
	    tslib_1.__extends(KeytipContentBase, _super);
	    function KeytipContentBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    KeytipContentBase.prototype.render = function () {
	        var _a = this.props, content = _a.content, styles = _a.styles, theme = _a.theme, disabled = _a.disabled, visible = _a.visible;
	        var getClassNames = Utilities_1.classNamesFunction();
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            disabled: disabled,
	            visible: visible
	        });
	        return (React.createElement("div", { className: classNames.container },
	            React.createElement("span", { className: classNames.root }, content)));
	    };
	    return KeytipContentBase;
	}(React.Component));
	exports.KeytipContentBase = KeytipContentBase;
	//# sourceMappingURL=KeytipContent.base.js.map

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var theme = props.theme, disabled = props.disabled, visible = props.visible;
	    return {
	        container: [
	            {
	                backgroundColor: theme.palette.neutralDark
	            },
	            disabled && {
	                opacity: 0.5,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText',
	                        opacity: 1
	                    },
	                    _a)
	            },
	            !visible && {
	                visibility: 'hidden'
	            }
	        ],
	        root: [
	            theme.fonts.medium,
	            {
	                textAlign: 'center',
	                paddingLeft: '3px',
	                paddingRight: '3px',
	                backgroundColor: theme.palette.neutralDark,
	                color: theme.palette.neutralLight,
	                minWidth: '11px',
	                lineHeight: '17px',
	                height: '17px',
	                display: 'inline-block'
	            },
	            disabled && {
	                color: theme.palette.neutralTertiaryAlt
	            }
	        ]
	    };
	    var _a;
	};
	exports.getCalloutStyles = function (props) {
	    return {
	        container: [],
	        root: [
	            {
	                border: 'none',
	                boxShadow: 'none'
	            }
	        ],
	        beak: [],
	        beakCurtain: [],
	        calloutMain: [
	            {
	                backgroundColor: 'transparent'
	            }
	        ]
	    };
	};
	exports.getCalloutOffsetStyles = function (offset) {
	    return function (props) {
	        return Styling_1.mergeStyleSets(exports.getCalloutStyles(props), {
	            root: [
	                {
	                    marginLeft: offset.x,
	                    marginTop: offset.y
	                }
	            ]
	        });
	    };
	};
	//# sourceMappingURL=Keytip.styles.js.map

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1095), exports);
	//# sourceMappingURL=KeytipLayer.js.map

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1096), exports);
	tslib_1.__exportStar(__webpack_require__(1097), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var KeytipLayer_base_1 = __webpack_require__(1097);
	var KeytipLayer_styles_1 = __webpack_require__(1098);
	exports.KeytipLayer = Utilities_1.styled(KeytipLayer_base_1.KeytipLayerBase, KeytipLayer_styles_1.getStyles, undefined, {
	    scope: 'KeytipLayer'
	});
	//# sourceMappingURL=KeytipLayer.js.map

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var KeytipLayer_styles_1 = __webpack_require__(1098);
	var Keytip_1 = __webpack_require__(1088);
	var Layer_1 = __webpack_require__(617);
	var Utilities_1 = __webpack_require__(592);
	var KeytipManager_1 = __webpack_require__(687);
	var KeytipTree_1 = __webpack_require__(1099);
	var KeytipUtils_1 = __webpack_require__(689);
	var IKeytipTransitionKey_1 = __webpack_require__(1100);
	var KeytipConstants_1 = __webpack_require__(688);
	// Default sequence is Alt-Windows (Alt-Meta) in Windows, Option-Control (Alt-Control) in Mac
	var defaultStartSequence = {
	    key: Utilities_1.isMac() ? 'Control' : 'Meta',
	    modifierKeys: [IKeytipTransitionKey_1.KeytipTransitionModifier.alt]
	};
	// Default exit sequence is the same as the start sequence
	var defaultExitSequence = defaultStartSequence;
	// Default return sequence is Escape
	var defaultReturnSequence = {
	    key: 'Escape'
	};
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * A layer that holds all keytip items
	 * {@docCategory Keytips}
	 */
	var KeytipLayerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(KeytipLayerBase, _super);
	    // tslint:disable-next-line:no-any
	    function KeytipLayerBase(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this._keytipManager = KeytipManager_1.KeytipManager.getInstance();
	        _this._delayedKeytipQueue = [];
	        _this._keyHandled = false;
	        _this._onDismiss = function (ev) {
	            // if we are in keytip mode, then exit keytip mode
	            if (_this.state.inKeytipMode) {
	                _this._exitKeytipMode(ev);
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            _this._keyHandled = false;
	            // using key since which has been deprecated and key is now widely suporrted.
	            // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which
	            var key = ev.key;
	            switch (key) {
	                case 'Alt':
	                    // ALT puts focus in the browser bar, so it should not be used as a key for keytips.
	                    // It can be used as a modifier
	                    break;
	                case 'Tab':
	                case 'Enter':
	                case 'Spacebar':
	                case ' ':
	                case 'ArrowUp':
	                case 'Up':
	                case 'ArrowDown':
	                case 'Down':
	                case 'ArrowLeft':
	                case 'Left':
	                case 'ArrowRight':
	                case 'Right':
	                    if (_this.state.inKeytipMode) {
	                        _this._keyHandled = true;
	                        _this._exitKeytipMode(ev);
	                    }
	                    break;
	                default:
	                    // Special cases for browser-specific keys that are not at standard
	                    // (according to http://www.w3.org/TR/uievents-key/#keys-navigation)
	                    if (key === 'Esc') {
	                        // Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/5290772/
	                        key = 'Escape';
	                    }
	                    else if (key === 'OS' || key === 'Win') {
	                        // Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1232918
	                        // Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
	                        // and https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16424492/
	                        key = 'Meta';
	                    }
	                    var transitionKey = { key: key };
	                    transitionKey.modifierKeys = _this._getModifierKey(key, ev);
	                    _this.processTransitionInput(transitionKey, ev);
	                    break;
	            }
	        };
	        _this._onKeyPress = function (ev) {
	            if (_this.state.inKeytipMode && !_this._keyHandled) {
	                // Call processInput
	                _this.processInput(ev.key.toLocaleLowerCase(), ev);
	                ev.preventDefault();
	                ev.stopPropagation();
	            }
	        };
	        _this._onKeytipAdded = function (eventArgs) {
	            var keytipProps = eventArgs.keytip;
	            var uniqueID = eventArgs.uniqueID;
	            _this._keytipTree.addNode(keytipProps, uniqueID);
	            _this._setKeytips();
	            // Add the keytip to the queue to show later
	            if (_this._keytipTree.isCurrentKeytipParent(keytipProps)) {
	                _this._addKeytipToQueue(KeytipUtils_1.sequencesToID(keytipProps.keySequences));
	                // Check to make sure that child of currentKeytip is successfully added to currentKeytip's children and update it if not
	                // Note: Added this condition because KeytipTree.addNode was not always reflecting updates made to a parent node in currentKeytip
	                // when that parent is the currentKeytip
	                if (_this._keytipTree.currentKeytip &&
	                    _this._keytipTree.currentKeytip.hasDynamicChildren &&
	                    _this._keytipTree.currentKeytip.children.indexOf(keytipProps.id) < 0) {
	                    _this._keytipTree.currentKeytip = _this._keytipTree.getNode(_this._keytipTree.currentKeytip.id);
	                }
	            }
	            if (_this._newCurrentKeytipSequences && Utilities_1.arraysEqual(keytipProps.keySequences, _this._newCurrentKeytipSequences)) {
	                _this._triggerKeytipImmediately(keytipProps);
	            }
	            if (_this._isCurrentKeytipAnAlias(keytipProps)) {
	                var keytipSequence = keytipProps.keySequences;
	                if (keytipProps.overflowSetSequence) {
	                    keytipSequence = KeytipUtils_1.mergeOverflows(keytipSequence, keytipProps.overflowSetSequence);
	                }
	                _this._keytipTree.currentKeytip = _this._keytipTree.getNode(KeytipUtils_1.sequencesToID(keytipSequence));
	            }
	        };
	        _this._onKeytipUpdated = function (eventArgs) {
	            var keytipProps = eventArgs.keytip;
	            var uniqueID = eventArgs.uniqueID;
	            _this._keytipTree.updateNode(keytipProps, uniqueID);
	            _this._setKeytips();
	        };
	        _this._onKeytipRemoved = function (eventArgs) {
	            var keytipProps = eventArgs.keytip;
	            var uniqueID = eventArgs.uniqueID;
	            // Remove keytip from the delayed queue
	            _this._removeKeytipFromQueue(KeytipUtils_1.sequencesToID(keytipProps.keySequences));
	            // Remove the node from the Tree
	            _this._keytipTree.removeNode(keytipProps, uniqueID);
	            _this._setKeytips();
	        };
	        _this._onPersistedKeytipAdded = function (eventArgs) {
	            var keytipProps = eventArgs.keytip;
	            var uniqueID = eventArgs.uniqueID;
	            _this._keytipTree.addNode(keytipProps, uniqueID, true);
	        };
	        _this._onPersistedKeytipRemoved = function (eventArgs) {
	            var keytipProps = eventArgs.keytip;
	            var uniqueID = eventArgs.uniqueID;
	            _this._keytipTree.removeNode(keytipProps, uniqueID);
	        };
	        _this._onPersistedKeytipExecute = function (eventArgs) {
	            _this._persistedKeytipExecute(eventArgs.overflowButtonSequences, eventArgs.keytipSequences);
	        };
	        /**
	         * Sets if we are in keytip mode.
	         * Note, this sets both the state for the layer as well as
	         * the value that the manager will expose externally.
	         * @param inKeytipMode - Boolean so set whether we are in keytip mode or not
	         */
	        _this._setInKeytipMode = function (inKeytipMode) {
	            _this.setState({ inKeytipMode: inKeytipMode });
	            _this._keytipManager.inKeytipMode = inKeytipMode;
	        };
	        /**
	         * Emits a warning if duplicate keytips are found for the children of the current keytip
	         */
	        _this._warnIfDuplicateKeytips = function () {
	            var duplicateKeytips = _this._getDuplicateIds(_this._keytipTree.getChildren());
	            if (duplicateKeytips.length) {
	                Utilities_1.warn('Duplicate keytips found for ' + duplicateKeytips.join(', '));
	            }
	        };
	        /**
	         * Returns duplicates among keytip IDs
	         * If the returned array is empty, no duplicates were found
	         *
	         * @param keytipIds - Array of keytip IDs to find duplicates for
	         * @returns - Array of duplicates that were found. If multiple duplicates were found it will only be added once to this array
	         */
	        _this._getDuplicateIds = function (keytipIds) {
	            var seenIds = {};
	            return keytipIds.filter(function (keytipId) {
	                seenIds[keytipId] = seenIds[keytipId] ? seenIds[keytipId] + 1 : 1;
	                // Only add the first duplicate keytip seen
	                return seenIds[keytipId] === 2;
	            });
	        };
	        var managerKeytips = _this._keytipManager.getKeytips().slice();
	        _this.state = {
	            inKeytipMode: false,
	            // Get the initial set of keytips
	            keytips: managerKeytips,
	            visibleKeytips: _this._getVisibleKeytips(managerKeytips)
	        };
	        _this._keytipTree = new KeytipTree_1.KeytipTree();
	        // Add regular and persisted keytips to the tree
	        for (var _i = 0, _a = _this._keytipManager.keytips.concat(_this._keytipManager.persistedKeytips); _i < _a.length; _i++) {
	            var uniqueKeytip = _a[_i];
	            _this._keytipTree.addNode(uniqueKeytip.keytip, uniqueKeytip.uniqueID);
	        }
	        _this._currentSequence = '';
	        // Add keytip listeners
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_ADDED, _this._onKeytipAdded);
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_UPDATED, _this._onKeytipUpdated);
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_REMOVED, _this._onKeytipRemoved);
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_ADDED, _this._onPersistedKeytipAdded);
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_REMOVED, _this._onPersistedKeytipRemoved);
	        _this._events.on(_this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_EXECUTE, _this._onPersistedKeytipExecute);
	        return _this;
	    }
	    KeytipLayerBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, content = _a.content, styles = _a.styles;
	        var _b = this.state, keytips = _b.keytips, visibleKeytips = _b.visibleKeytips;
	        this._classNames = getClassNames(styles, {});
	        return (React.createElement(Layer_1.Layer, { styles: KeytipLayer_styles_1.getLayerStyles },
	            React.createElement("span", { id: KeytipConstants_1.KTP_LAYER_ID, className: this._classNames.innerContent }, "" + content + KeytipConstants_1.KTP_ARIA_SEPARATOR),
	            keytips &&
	                keytips.map(function (keytipProps, index) {
	                    return (React.createElement("span", { key: index, id: KeytipUtils_1.sequencesToID(keytipProps.keySequences), className: _this._classNames.innerContent }, keytipProps.keySequences.join(KeytipConstants_1.KTP_ARIA_SEPARATOR)));
	                }),
	            visibleKeytips &&
	                visibleKeytips.map(function (visibleKeytipProps) {
	                    return React.createElement(Keytip_1.Keytip, tslib_1.__assign({ key: KeytipUtils_1.sequencesToID(visibleKeytipProps.keySequences) }, visibleKeytipProps));
	                })));
	    };
	    KeytipLayerBase.prototype.componentDidMount = function () {
	        // Add window listeners
	        this._events.on(window, 'mouseup', this._onDismiss, true /* useCapture */);
	        this._events.on(window, 'pointerup', this._onDismiss, true /* useCapture */);
	        this._events.on(window, 'resize', this._onDismiss);
	        this._events.on(window, 'keydown', this._onKeyDown, true /* useCapture */);
	        this._events.on(window, 'keypress', this._onKeyPress, true /* useCapture */);
	        this._events.on(window, 'scroll', this._onDismiss, true /* useCapture */);
	        // Add keytip listeners
	        this._events.on(this._keytipManager, KeytipConstants_1.KeytipEvents.ENTER_KEYTIP_MODE, this._enterKeytipMode);
	        this._events.on(this._keytipManager, KeytipConstants_1.KeytipEvents.EXIT_KEYTIP_MODE, this._exitKeytipMode);
	    };
	    KeytipLayerBase.prototype.componentWillUnmount = function () {
	        // Remove window listeners
	        this._events.off(window, 'mouseup', this._onDismiss, true /* useCapture */);
	        this._events.off(window, 'pointerup', this._onDismiss, true /* useCapture */);
	        this._events.off(window, 'resize', this._onDismiss);
	        this._events.off(window, 'keydown', this._onKeyDown, true /* useCapture */);
	        this._events.off(window, 'keypress', this._onKeyPress, true /* useCapture */);
	        this._events.off(window, 'scroll', this._onDismiss, true /* useCapture */);
	        // Remove keytip listeners
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_ADDED, this._onKeytipAdded);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_UPDATED, this._onKeytipUpdated);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.KEYTIP_REMOVED, this._onKeytipRemoved);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_ADDED, this._onPersistedKeytipAdded);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_REMOVED, this._onPersistedKeytipRemoved);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.PERSISTED_KEYTIP_EXECUTE, this._onPersistedKeytipExecute);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.ENTER_KEYTIP_MODE, this._enterKeytipMode);
	        this._events.off(this._keytipManager, KeytipConstants_1.KeytipEvents.EXIT_KEYTIP_MODE, this._exitKeytipMode);
	    };
	    // The below public functions are only public for testing purposes
	    // They are not intended to be used in app code by using a KeytipLayer reference
	    KeytipLayerBase.prototype.getCurrentSequence = function () {
	        return this._currentSequence;
	    };
	    KeytipLayerBase.prototype.getKeytipTree = function () {
	        return this._keytipTree;
	    };
	    /**
	     * Processes an IKeytipTransitionKey entered by the user
	     *
	     * @param transitionKey - IKeytipTransitionKey received by the layer to process
	     */
	    KeytipLayerBase.prototype.processTransitionInput = function (transitionKey, ev) {
	        var currKtp = this._keytipTree.currentKeytip;
	        if (IKeytipTransitionKey_1.transitionKeysContain(this.props.keytipExitSequences, transitionKey) && currKtp) {
	            // If key sequence is in 'exit sequences', exit keytip mode
	            this._keyHandled = true;
	            this._exitKeytipMode(ev);
	        }
	        else if (IKeytipTransitionKey_1.transitionKeysContain(this.props.keytipReturnSequences, transitionKey)) {
	            // If key sequence is in return sequences, move currentKeytip to parent (or if currentKeytip is the root, exit)
	            if (currKtp) {
	                this._keyHandled = true;
	                if (currKtp.id === this._keytipTree.root.id) {
	                    // We are at the root, exit keytip mode
	                    this._exitKeytipMode(ev);
	                }
	                else {
	                    // If this keytip has a onReturn prop, we execute the func.
	                    if (currKtp.onReturn) {
	                        currKtp.onReturn(this._getKtpExecuteTarget(currKtp), this._getKtpTarget(currKtp));
	                    }
	                    // Reset currentSequence
	                    this._currentSequence = '';
	                    // Return pointer to its parent
	                    this._keytipTree.currentKeytip = this._keytipTree.getNode(currKtp.parent);
	                    // Show children keytips of the new currentKeytip
	                    this.showKeytips(this._keytipTree.getChildren());
	                    this._warnIfDuplicateKeytips();
	                }
	            }
	        }
	        else if (IKeytipTransitionKey_1.transitionKeysContain(this.props.keytipStartSequences, transitionKey) && !currKtp) {
	            // If key sequence is in 'entry sequences' and currentKeytip is null, we enter keytip mode
	            this._keyHandled = true;
	            this._enterKeytipMode();
	            this._warnIfDuplicateKeytips();
	        }
	    };
	    /**
	     * Processes inputs from the document listener and traverse the keytip tree
	     *
	     * @param key - Key pressed by the user
	     */
	    KeytipLayerBase.prototype.processInput = function (key, ev) {
	        // Concat the input key with the current sequence
	        var currSequence = this._currentSequence + key;
	        var currKtp = this._keytipTree.currentKeytip;
	        // currentKeytip must be defined, otherwise we haven't entered keytip mode yet
	        if (currKtp) {
	            var node = this._keytipTree.getExactMatchedNode(currSequence, currKtp);
	            if (node) {
	                this._keytipTree.currentKeytip = currKtp = node;
	                var currKtpChildren = this._keytipTree.getChildren();
	                // Execute this node's onExecute if defined
	                if (currKtp.onExecute) {
	                    currKtp.onExecute(this._getKtpExecuteTarget(currKtp), this._getKtpTarget(currKtp));
	                    // Reset currKtp, this might have changed from the onExecute
	                    currKtp = this._keytipTree.currentKeytip;
	                }
	                // To exit keytipMode after executing the keytip it must not have a menu or have dynamic children
	                if (currKtpChildren.length === 0 && !(currKtp.hasDynamicChildren || currKtp.hasMenu)) {
	                    this._exitKeytipMode(ev);
	                }
	                else {
	                    // Show all children keytips
	                    this.showKeytips(currKtpChildren);
	                    this._warnIfDuplicateKeytips();
	                }
	                // Clear currentSequence
	                this._currentSequence = '';
	                return;
	            }
	            var partialNodes = this._keytipTree.getPartiallyMatchedNodes(currSequence, currKtp);
	            if (partialNodes.length > 0) {
	                // We found nodes that partially match the sequence, so we show only those
	                // Omit showing persisted nodes here
	                var ids = partialNodes
	                    .filter(function (partialNode) {
	                    return !partialNode.persisted;
	                })
	                    .map(function (partialNode) {
	                    return partialNode.id;
	                });
	                this.showKeytips(ids);
	                // Save currentSequence
	                this._currentSequence = currSequence;
	            }
	        }
	    };
	    /**
	     * Show the given keytips and hide all others
	     *
	     * @param ids - Keytip IDs to show
	     */
	    KeytipLayerBase.prototype.showKeytips = function (ids) {
	        // Update the visible prop in the manager
	        for (var _i = 0, _a = this._keytipManager.getKeytips(); _i < _a.length; _i++) {
	            var keytip = _a[_i];
	            var keytipId = KeytipUtils_1.sequencesToID(keytip.keySequences);
	            if (ids.indexOf(keytipId) >= 0) {
	                keytip.visible = true;
	            }
	            else if (keytip.overflowSetSequence &&
	                ids.indexOf(KeytipUtils_1.sequencesToID(KeytipUtils_1.mergeOverflows(keytip.keySequences, keytip.overflowSetSequence))) >= 0) {
	                // Check if the ID with the overflow is the keytip we're looking for
	                keytip.visible = true;
	            }
	            else {
	                keytip.visible = false;
	            }
	        }
	        // Apply the manager changes to the Layer state
	        this._setKeytips();
	    };
	    /**
	     * Enters keytip mode for this layer
	     */
	    KeytipLayerBase.prototype._enterKeytipMode = function () {
	        if (this._keytipManager.shouldEnterKeytipMode) {
	            this._keytipTree.currentKeytip = this._keytipTree.root;
	            // Show children of root
	            this.showKeytips(this._keytipTree.getChildren());
	            this._setInKeytipMode(true /* inKeytipMode */);
	            if (this.props.onEnterKeytipMode) {
	                this.props.onEnterKeytipMode();
	            }
	        }
	    };
	    /**
	     * Exits keytip mode for this layer
	     */
	    KeytipLayerBase.prototype._exitKeytipMode = function (ev) {
	        this._keytipTree.currentKeytip = undefined;
	        this._currentSequence = '';
	        // Hide all keytips
	        this.showKeytips([]);
	        // Reset the delayed keytips if any
	        this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
	        this._delayedKeytipQueue = [];
	        this._setInKeytipMode(false /* inKeytipMode */);
	        if (this.props.onExitKeytipMode) {
	            this.props.onExitKeytipMode(ev);
	        }
	    };
	    /**
	     * Sets the keytips state property
	     *
	     * @param keytipProps - Keytips to set in this layer
	     */
	    KeytipLayerBase.prototype._setKeytips = function (keytipProps) {
	        if (keytipProps === void 0) { keytipProps = this._keytipManager.getKeytips(); }
	        this.setState({ keytips: keytipProps, visibleKeytips: this._getVisibleKeytips(keytipProps) });
	    };
	    /**
	     * Callback function to use for persisted keytips
	     *
	     * @param overflowButtonSequences - The overflow button sequence to execute
	     * @param keytipSequences - The keytip that should become the 'currentKeytip' when it is registered
	     */
	    KeytipLayerBase.prototype._persistedKeytipExecute = function (overflowButtonSequences, keytipSequences) {
	        // Save newCurrentKeytip for later
	        this._newCurrentKeytipSequences = keytipSequences;
	        // Execute the overflow button's onExecute
	        var overflowKeytipNode = this._keytipTree.getNode(KeytipUtils_1.sequencesToID(overflowButtonSequences));
	        if (overflowKeytipNode && overflowKeytipNode.onExecute) {
	            overflowKeytipNode.onExecute(this._getKtpExecuteTarget(overflowKeytipNode), this._getKtpTarget(overflowKeytipNode));
	        }
	    };
	    KeytipLayerBase.prototype._getVisibleKeytips = function (keytips) {
	        // Filter out non-visible keytips and duplicates
	        var seenIds = {};
	        return keytips.filter(function (keytip) {
	            var keytipId = KeytipUtils_1.sequencesToID(keytip.keySequences);
	            seenIds[keytipId] = seenIds[keytipId] ? seenIds[keytipId] + 1 : 1;
	            return keytip.visible && seenIds[keytipId] === 1;
	        });
	    };
	    /**
	     * Gets the ModifierKeyCodes based on the keyboard event
	     *
	     * @param ev - React.KeyboardEvent
	     * @returns List of ModifierKeyCodes that were pressed
	     */
	    KeytipLayerBase.prototype._getModifierKey = function (key, ev) {
	        var modifierKeys = [];
	        if (ev.altKey && key !== 'Alt') {
	            modifierKeys.push(IKeytipTransitionKey_1.KeytipTransitionModifier.alt);
	        }
	        if (ev.ctrlKey && key !== 'Control') {
	            modifierKeys.push(IKeytipTransitionKey_1.KeytipTransitionModifier.ctrl);
	        }
	        if (ev.shiftKey && key !== 'Shift') {
	            modifierKeys.push(IKeytipTransitionKey_1.KeytipTransitionModifier.shift);
	        }
	        if (ev.metaKey && key !== 'Meta') {
	            modifierKeys.push(IKeytipTransitionKey_1.KeytipTransitionModifier.meta);
	        }
	        return modifierKeys.length ? modifierKeys : undefined;
	    };
	    /**
	     * Trigger a keytip immediately and set it as the current keytip
	     *
	     * @param keytipProps - Keytip to trigger immediately
	     */
	    KeytipLayerBase.prototype._triggerKeytipImmediately = function (keytipProps) {
	        // This keytip should become the currentKeytip and should execute right away
	        var keytipSequence = keytipProps.keySequences.slice();
	        if (keytipProps.overflowSetSequence) {
	            keytipSequence = KeytipUtils_1.mergeOverflows(keytipSequence, keytipProps.overflowSetSequence);
	        }
	        // Set currentKeytip
	        this._keytipTree.currentKeytip = this._keytipTree.getNode(KeytipUtils_1.sequencesToID(keytipSequence));
	        if (this._keytipTree.currentKeytip) {
	            // Show all children keytips if any
	            var children = this._keytipTree.getChildren();
	            if (children.length) {
	                this.showKeytips(children);
	            }
	            if (this._keytipTree.currentKeytip.onExecute) {
	                this._keytipTree.currentKeytip.onExecute(this._getKtpExecuteTarget(this._keytipTree.currentKeytip), this._getKtpTarget(this._keytipTree.currentKeytip));
	            }
	        }
	        // Unset _newCurrKtpSequences
	        this._newCurrentKeytipSequences = undefined;
	    };
	    KeytipLayerBase.prototype._addKeytipToQueue = function (keytipID) {
	        var _this = this;
	        // Add keytip
	        this._delayedKeytipQueue.push(keytipID);
	        // Clear timeout
	        this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
	        // Reset timeout
	        this._delayedQueueTimeout = this._async.setTimeout(function () {
	            if (_this._delayedKeytipQueue.length) {
	                _this.showKeytips(_this._delayedKeytipQueue);
	                _this._delayedKeytipQueue = [];
	            }
	        }, 300);
	    };
	    KeytipLayerBase.prototype._removeKeytipFromQueue = function (keytipID) {
	        var _this = this;
	        var index = this._delayedKeytipQueue.indexOf(keytipID);
	        if (index >= 0) {
	            // Remove keytip
	            this._delayedKeytipQueue.splice(index, 1);
	            // Clear timeout
	            this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
	            // Reset timeout
	            this._delayedQueueTimeout = this._async.setTimeout(function () {
	                if (_this._delayedKeytipQueue.length) {
	                    _this.showKeytips(_this._delayedKeytipQueue);
	                    _this._delayedKeytipQueue = [];
	                }
	            }, 300);
	        }
	    };
	    KeytipLayerBase.prototype._getKtpExecuteTarget = function (currKtp) {
	        return Utilities_1.getDocument().querySelector(KeytipUtils_1.ktpTargetFromId(currKtp.id));
	    };
	    KeytipLayerBase.prototype._getKtpTarget = function (currKtp) {
	        return Utilities_1.getDocument().querySelector(KeytipUtils_1.ktpTargetFromSequences(currKtp.keySequences));
	    };
	    /**
	     * Returns T/F if the keytipProps keySequences match the currentKeytip, and the currentKeytip is in an overflow well
	     * This will make 'keytipProps' the new currentKeytip
	     *
	     * @param keytipProps - Keytip props to check
	     * @returns - T/F if this keytip should become the currentKeytip
	     */
	    KeytipLayerBase.prototype._isCurrentKeytipAnAlias = function (keytipProps) {
	        var currKtp = this._keytipTree.currentKeytip;
	        if (currKtp && (currKtp.overflowSetSequence || currKtp.persisted) && Utilities_1.arraysEqual(keytipProps.keySequences, currKtp.keySequences)) {
	            return true;
	        }
	        return false;
	    };
	    KeytipLayerBase.defaultProps = {
	        keytipStartSequences: [defaultStartSequence],
	        keytipExitSequences: [defaultExitSequence],
	        keytipReturnSequences: [defaultReturnSequence],
	        content: ''
	    };
	    return KeytipLayerBase;
	}(Utilities_1.BaseComponent));
	exports.KeytipLayerBase = KeytipLayerBase;
	//# sourceMappingURL=KeytipLayer.base.js.map

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getLayerStyles = function (props) {
	    return {
	        root: [
	            {
	                // Prioritize the Keytips above all other Layers
	                zIndex: Styling_1.ZIndexes.KeytipLayer
	            }
	        ]
	    };
	};
	exports.getStyles = function (props) {
	    return {
	        innerContent: [
	            {
	                position: 'absolute',
	                width: 0,
	                height: 0,
	                margin: 0,
	                padding: 0,
	                border: 0,
	                overflow: 'hidden',
	                visibility: 'hidden'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=KeytipLayer.styles.js.map

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var KeytipUtils_1 = __webpack_require__(689);
	var KeytipConstants_1 = __webpack_require__(688);
	/**
	 * This class is responsible for handling the parent/child relationships between keytips
	 */
	var KeytipTree = /** @class */ (function () {
	    /**
	     * KeytipTree constructor
	     */
	    function KeytipTree() {
	        this.nodeMap = {};
	        // Root has no keytipSequence
	        this.root = {
	            id: KeytipConstants_1.KTP_LAYER_ID,
	            children: [],
	            parent: '',
	            keySequences: []
	        };
	        this.nodeMap[this.root.id] = this.root;
	    }
	    /**
	     * Add a keytip node to this KeytipTree
	     *
	     * @param keytipProps - Keytip to add to the Tree
	     * @param uniqueID - Unique ID for this keytip
	     * @param persisted - T/F if this keytip should be marked as persisted
	     */
	    KeytipTree.prototype.addNode = function (keytipProps, uniqueID, persisted) {
	        var fullSequence = this._getFullSequence(keytipProps);
	        var nodeID = KeytipUtils_1.sequencesToID(fullSequence);
	        // Take off the last item to calculate the parent sequence
	        fullSequence.pop();
	        // Parent ID is the root if there aren't any more sequences
	        var parentID = this._getParentID(fullSequence);
	        // Create node and add to map
	        var node = this._createNode(nodeID, parentID, [], keytipProps, persisted);
	        this.nodeMap[uniqueID] = node;
	        // Try to add self to parents children, if they exist
	        var parent = this.getNode(parentID);
	        if (parent) {
	            parent.children.push(nodeID);
	        }
	    };
	    /**
	     * Updates a node in the tree
	     *
	     * @param keytipProps - Keytip props to update
	     * @param uniqueID - Unique ID for this keytip
	     */
	    KeytipTree.prototype.updateNode = function (keytipProps, uniqueID) {
	        var fullSequence = this._getFullSequence(keytipProps);
	        var nodeID = KeytipUtils_1.sequencesToID(fullSequence);
	        // Take off the last item to calculate the parent sequence
	        fullSequence.pop();
	        // Parent ID is the root if there aren't any more sequences
	        var parentID = this._getParentID(fullSequence);
	        var node = this.nodeMap[uniqueID];
	        var parent = this.getNode(parentID);
	        if (node) {
	            // If the ID of the node has changed, update node's parent's array of children with new ID
	            if (parent && node.id !== nodeID) {
	                var index = parent.children.indexOf(node.id);
	                index >= 0 && (parent.children[index] = nodeID);
	            }
	            // Update values
	            node.id = nodeID;
	            node.keySequences = keytipProps.keySequences;
	            node.overflowSetSequence = keytipProps.overflowSetSequence;
	            node.onExecute = keytipProps.onExecute;
	            node.onReturn = keytipProps.onReturn;
	            node.hasDynamicChildren = keytipProps.hasDynamicChildren;
	            node.hasMenu = keytipProps.hasMenu;
	            node.parent = parentID;
	            node.disabled = keytipProps.disabled;
	        }
	    };
	    /**
	     * Removes a node from the KeytipTree
	     *
	     * @param sequence - full string of the node to remove
	     */
	    KeytipTree.prototype.removeNode = function (keytipProps, uniqueID) {
	        var fullSequence = this._getFullSequence(keytipProps);
	        var nodeID = KeytipUtils_1.sequencesToID(fullSequence);
	        // Take off the last sequence to calculate the parent ID
	        fullSequence.pop();
	        // Parent ID is the root if there aren't any more sequences
	        var parentID = this._getParentID(fullSequence);
	        var parent = this.getNode(parentID);
	        if (parent) {
	            // Remove node from its parent's children
	            parent.children.splice(parent.children.indexOf(nodeID), 1);
	        }
	        if (this.nodeMap[uniqueID]) {
	            // Remove the node from the nodeMap
	            delete this.nodeMap[uniqueID];
	        }
	    };
	    /**
	     * Searches the currentKeytip's children to exactly match a sequence. Will not match disabled nodes but
	     * will match persisted nodes
	     *
	     * @param keySequence - string to match
	     * @param currentKeytip - The keytip whose children will try to match
	     * @returns The node that exactly matched the keySequence, or undefined if none matched
	     */
	    KeytipTree.prototype.getExactMatchedNode = function (keySequence, currentKeytip) {
	        var _this = this;
	        var possibleNodes = this.getNodes(currentKeytip.children);
	        return Utilities_1.find(possibleNodes, function (node) {
	            return _this._getNodeSequence(node) === keySequence && !node.disabled;
	        });
	    };
	    /**
	     * Searches the currentKeytip's children to find nodes that start with the given sequence. Will not match
	     * disabled nodes but will match persisted nodes
	     *
	     * @param keySequence - string to partially match
	     * @param currentKeytip - The keytip whose children will try to partially match
	     * @returns List of tree nodes that partially match the given sequence
	     */
	    KeytipTree.prototype.getPartiallyMatchedNodes = function (keySequence, currentKeytip) {
	        var _this = this;
	        // Get children that are persisted
	        var possibleNodes = this.getNodes(currentKeytip.children);
	        return possibleNodes.filter(function (node) {
	            return _this._getNodeSequence(node).indexOf(keySequence) === 0 && !node.disabled;
	        });
	    };
	    /**
	     * Get the non-persisted children of the give node
	     * If no node is given, will use the 'currentKeytip'
	     *
	     * @param node - Node to get the children for
	     * @returns List of node IDs that are the children of the node
	     */
	    KeytipTree.prototype.getChildren = function (node) {
	        var _this = this;
	        if (!node) {
	            node = this.currentKeytip;
	            if (!node) {
	                return [];
	            }
	        }
	        var children = node.children;
	        return Object.keys(this.nodeMap).reduce(function (nodes, key) {
	            if (children.indexOf(_this.nodeMap[key].id) >= 0 && !_this.nodeMap[key].persisted) {
	                nodes.push(_this.nodeMap[key].id);
	            }
	            return nodes;
	        }, []);
	    };
	    /**
	     * Gets all nodes from their IDs
	     *
	     * @param ids - List of keytip IDs
	     * @returns Array of nodes that match the given IDs, can be empty
	     */
	    KeytipTree.prototype.getNodes = function (ids) {
	        var _this = this;
	        return Object.keys(this.nodeMap).reduce(function (nodes, key) {
	            if (ids.indexOf(_this.nodeMap[key].id) >= 0) {
	                nodes.push(_this.nodeMap[key]);
	            }
	            return nodes;
	        }, []);
	    };
	    /**
	     * Gets a single node from its ID
	     *
	     * @param id - ID of the node to get
	     * @returns Node with the given ID, if found
	     */
	    KeytipTree.prototype.getNode = function (id) {
	        var nodeMapValues = Utilities_1.values(this.nodeMap);
	        return Utilities_1.find(nodeMapValues, function (node) {
	            return node.id === id;
	        });
	    };
	    /**
	     * Tests if the currentKeytip in this.keytipTree is the parent of 'keytipProps'
	     *
	     * @param keytipProps - Keytip to test the parent for
	     * @returns T/F if the currentKeytip is this keytipProps' parent
	     */
	    KeytipTree.prototype.isCurrentKeytipParent = function (keytipProps) {
	        if (this.currentKeytip) {
	            var fullSequence = keytipProps.keySequences.slice();
	            if (keytipProps.overflowSetSequence) {
	                fullSequence = KeytipUtils_1.mergeOverflows(fullSequence, keytipProps.overflowSetSequence);
	            }
	            // Take off the last sequence to calculate the parent ID
	            fullSequence.pop();
	            // Parent ID is the root if there aren't any more sequences
	            var parentID = fullSequence.length === 0 ? this.root.id : KeytipUtils_1.sequencesToID(fullSequence);
	            var matchesCurrWithoutOverflow = false;
	            if (this.currentKeytip.overflowSetSequence) {
	                var currKeytipIdWithoutOverflow = KeytipUtils_1.sequencesToID(this.currentKeytip.keySequences);
	                matchesCurrWithoutOverflow = currKeytipIdWithoutOverflow === parentID;
	            }
	            return matchesCurrWithoutOverflow || this.currentKeytip.id === parentID;
	        }
	        return false;
	    };
	    KeytipTree.prototype._getParentID = function (fullSequence) {
	        return fullSequence.length === 0 ? this.root.id : KeytipUtils_1.sequencesToID(fullSequence);
	    };
	    KeytipTree.prototype._getFullSequence = function (keytipProps) {
	        var fullSequence = keytipProps.keySequences.slice();
	        if (keytipProps.overflowSetSequence) {
	            fullSequence = KeytipUtils_1.mergeOverflows(fullSequence, keytipProps.overflowSetSequence);
	        }
	        return fullSequence;
	    };
	    KeytipTree.prototype._getNodeSequence = function (node) {
	        var fullSequence = node.keySequences.slice();
	        if (node.overflowSetSequence) {
	            fullSequence = KeytipUtils_1.mergeOverflows(fullSequence, node.overflowSetSequence);
	        }
	        return fullSequence[fullSequence.length - 1];
	    };
	    KeytipTree.prototype._createNode = function (id, parentId, children, keytipProps, persisted) {
	        var _this = this;
	        var keySequences = keytipProps.keySequences, hasDynamicChildren = keytipProps.hasDynamicChildren, overflowSetSequence = keytipProps.overflowSetSequence, hasMenu = keytipProps.hasMenu, onExecute = keytipProps.onExecute, onReturn = keytipProps.onReturn, disabled = keytipProps.disabled;
	        var node = {
	            id: id,
	            keySequences: keySequences,
	            overflowSetSequence: overflowSetSequence,
	            parent: parentId,
	            children: children,
	            onExecute: onExecute,
	            onReturn: onReturn,
	            hasDynamicChildren: hasDynamicChildren,
	            hasMenu: hasMenu,
	            disabled: disabled,
	            persisted: persisted
	        };
	        node.children = Object.keys(this.nodeMap).reduce(function (array, nodeMapKey) {
	            if (_this.nodeMap[nodeMapKey].parent === id) {
	                array.push(_this.nodeMap[nodeMapKey].id);
	            }
	            return array;
	        }, []);
	        return node;
	    };
	    return KeytipTree;
	}());
	exports.KeytipTree = KeytipTree;
	//# sourceMappingURL=KeytipTree.js.map

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var KeytipTransitionModifier;
	(function (KeytipTransitionModifier) {
	    KeytipTransitionModifier[KeytipTransitionModifier["shift"] = Utilities_1.KeyCodes.shift] = "shift";
	    KeytipTransitionModifier[KeytipTransitionModifier["ctrl"] = Utilities_1.KeyCodes.ctrl] = "ctrl";
	    KeytipTransitionModifier[KeytipTransitionModifier["alt"] = Utilities_1.KeyCodes.alt] = "alt";
	    KeytipTransitionModifier[KeytipTransitionModifier["meta"] = Utilities_1.KeyCodes.leftWindow] = "meta";
	})(KeytipTransitionModifier = exports.KeytipTransitionModifier || (exports.KeytipTransitionModifier = {}));
	/**
	 * Tests for equality between two IKeytipTransitionKeys.
	 *
	 * @param key1 - First IKeytipTransitionKey.
	 * @param key2 - Second IKeytipTransitionKey.
	 * @returns {boolean} T/F if the transition keys are equal.
	 */
	function transitionKeysAreEqual(key1, key2) {
	    if (key1.key !== key2.key) {
	        return false;
	    }
	    var mod1 = key1.modifierKeys;
	    var mod2 = key2.modifierKeys;
	    if ((!mod1 && mod2) || (mod1 && !mod2)) {
	        // Not equal if one modifier is defined and the other isn't
	        return false;
	    }
	    if (mod1 && mod2) {
	        if (mod1.length !== mod2.length) {
	            return false;
	        }
	        // Sort both arrays
	        mod1 = mod1.sort();
	        mod2 = mod2.sort();
	        for (var i = 0; i < mod1.length; i++) {
	            if (mod1[i] !== mod2[i]) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	exports.transitionKeysAreEqual = transitionKeysAreEqual;
	/**
	 * Tests if 'key' is present in 'keys'.
	 *
	 * @param keys - Array of IKeytipTransitionKey.
	 * @param key - IKeytipTransitionKey to find in 'keys'.
	 * @returns {boolean} T/F if 'keys' contains 'key'.
	 */
	function transitionKeysContain(keys, key) {
	    return !!Utilities_1.find(keys, function (transitionKey) {
	        return transitionKeysAreEqual(transitionKey, key);
	    });
	}
	exports.transitionKeysContain = transitionKeysContain;
	//# sourceMappingURL=IKeytipTransitionKey.js.map

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1102), exports);
	tslib_1.__exportStar(__webpack_require__(866), exports);
	//# sourceMappingURL=MarqueeSelection.js.map

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var MarqueeSelection_base_1 = __webpack_require__(1103);
	var MarqueeSelection_styles_1 = __webpack_require__(1104);
	exports.MarqueeSelection = Utilities_1.styled(MarqueeSelection_base_1.MarqueeSelectionBase, MarqueeSelection_styles_1.getStyles, undefined, {
	    scope: 'MarqueeSelection'
	});
	//# sourceMappingURL=MarqueeSelection.js.map

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	// We want to make the marquee selection start when the user drags a minimum distance. Otherwise we'd start
	// the drag even if they just click an item without moving.
	var MIN_DRAG_DISTANCE = 5;
	/**
	 * MarqueeSelection component abstracts managing a draggable rectangle which sets items selected/not selected.
	 * Elements which have data-selectable-index attributes are queried and measured once to determine if they
	 * fall within the bounds of the rectangle. The measure is memoized during the drag as a performance optimization
	 * so if the items change sizes while dragging, that could cause incorrect results.
	 */
	var MarqueeSelectionBase = /** @class */ (function (_super) {
	    tslib_1.__extends(MarqueeSelectionBase, _super);
	    function MarqueeSelectionBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._onMouseDown = function (ev) {
	            var _a = _this.props, isEnabled = _a.isEnabled, onShouldStartSelection = _a.onShouldStartSelection;
	            // Ensure the mousedown is within the boundaries of the target. If not, it may have been a click on a scrollbar.
	            if (_this._isMouseEventOnScrollbar(ev)) {
	                return;
	            }
	            if (_this._isInSelectionToggle(ev)) {
	                return;
	            }
	            if (!_this._isTouch && isEnabled && !_this._isDragStartInSelection(ev) && (!onShouldStartSelection || onShouldStartSelection(ev))) {
	                if (_this._scrollableSurface && ev.button === 0 && _this._root.current) {
	                    _this._selectedIndicies = {};
	                    _this._preservedIndicies = undefined;
	                    _this._events.on(window, 'mousemove', _this._onAsyncMouseMove);
	                    _this._events.on(_this._scrollableParent, 'scroll', _this._onAsyncMouseMove);
	                    _this._events.on(window, 'click', _this._onMouseUp, true);
	                    _this._autoScroll = new Utilities_1.AutoScroll(_this._root.current);
	                    _this._scrollTop = _this._scrollableSurface.scrollTop;
	                    _this._rootRect = _this._root.current.getBoundingClientRect();
	                    _this._onMouseMove(ev);
	                }
	            }
	        };
	        _this._onTouchStart = function (ev) {
	            _this._isTouch = true;
	            _this._async.setTimeout(function () {
	                _this._isTouch = false;
	            }, 0);
	        };
	        _this._onPointerDown = function (ev) {
	            if (ev.pointerType === 'touch') {
	                _this._isTouch = true;
	                _this._async.setTimeout(function () {
	                    _this._isTouch = false;
	                }, 0);
	            }
	        };
	        _this.state = {
	            dragRect: undefined
	        };
	        return _this;
	    }
	    MarqueeSelectionBase.prototype.componentDidMount = function () {
	        this._scrollableParent = Utilities_1.findScrollableParent(this._root.current);
	        this._scrollableSurface = this._scrollableParent === window ? document.body : this._scrollableParent;
	        // When scroll events come from window, we need to read scrollTop values from the body.
	        var hitTarget = this.props.isDraggingConstrainedToRoot ? this._root.current : this._scrollableSurface;
	        this._events.on(hitTarget, 'mousedown', this._onMouseDown);
	        this._events.on(hitTarget, 'touchstart', this._onTouchStart, true);
	        this._events.on(hitTarget, 'pointerdown', this._onPointerDown, true);
	    };
	    MarqueeSelectionBase.prototype.componentWillUnmount = function () {
	        if (this._autoScroll) {
	            this._autoScroll.dispose();
	        }
	        delete this._scrollableParent;
	        delete this._scrollableSurface;
	    };
	    MarqueeSelectionBase.prototype.render = function () {
	        var _a = this.props, rootProps = _a.rootProps, children = _a.children, theme = _a.theme, className = _a.className, styles = _a.styles;
	        var dragRect = this.state.dragRect;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className
	        });
	        return (React.createElement("div", tslib_1.__assign({}, rootProps, { className: classNames.root, ref: this._root }),
	            children,
	            dragRect && React.createElement("div", { className: classNames.dragMask }),
	            dragRect && (React.createElement("div", { className: classNames.box, style: dragRect },
	                React.createElement("div", { className: classNames.boxFill })))));
	    };
	    /** Determine if the mouse event occured on a scrollbar of the target element. */
	    MarqueeSelectionBase.prototype._isMouseEventOnScrollbar = function (ev) {
	        var targetElement = ev.target;
	        var targetScrollbarWidth = targetElement.offsetWidth - targetElement.clientWidth;
	        if (targetScrollbarWidth) {
	            var targetRect = targetElement.getBoundingClientRect();
	            // Check vertical scroll
	            if (Utilities_1.getRTL()) {
	                if (ev.clientX < targetRect.left + targetScrollbarWidth) {
	                    return true;
	                }
	            }
	            else {
	                if (ev.clientX > targetRect.left + targetElement.clientWidth) {
	                    return true;
	                }
	            }
	            // Check horizontal scroll
	            if (ev.clientY > targetRect.top + targetElement.clientHeight) {
	                return true;
	            }
	        }
	        return false;
	    };
	    MarqueeSelectionBase.prototype._getRootRect = function () {
	        return {
	            left: this._rootRect.left,
	            top: this._rootRect.top + (this._scrollTop - this._scrollableSurface.scrollTop),
	            width: this._rootRect.width,
	            height: this._rootRect.height
	        };
	    };
	    MarqueeSelectionBase.prototype._onAsyncMouseMove = function (ev) {
	        var _this = this;
	        this._async.requestAnimationFrame(function () {
	            _this._onMouseMove(ev);
	        });
	        ev.stopPropagation();
	        ev.preventDefault();
	    };
	    MarqueeSelectionBase.prototype._onMouseMove = function (ev) {
	        if (!this._autoScroll) {
	            return;
	        }
	        if (ev.clientX !== undefined) {
	            this._lastMouseEvent = ev;
	        }
	        var rootRect = this._getRootRect();
	        var currentPoint = { x: ev.clientX - rootRect.left, y: ev.clientY - rootRect.top };
	        if (!this._dragOrigin) {
	            this._dragOrigin = currentPoint;
	        }
	        if (ev.buttons !== undefined && ev.buttons === 0) {
	            this._onMouseUp(ev);
	        }
	        else {
	            if (this.state.dragRect || Utilities_1.getDistanceBetweenPoints(this._dragOrigin, currentPoint) > MIN_DRAG_DISTANCE) {
	                if (!this.state.dragRect) {
	                    var selection = this.props.selection;
	                    if (!ev.shiftKey) {
	                        selection.setAllSelected(false);
	                    }
	                    this._preservedIndicies = selection && selection.getSelectedIndices && selection.getSelectedIndices();
	                }
	                // We need to constrain the current point to the rootRect boundaries.
	                var constrainedPoint = this.props.isDraggingConstrainedToRoot
	                    ? {
	                        x: Math.max(0, Math.min(rootRect.width, this._lastMouseEvent.clientX - rootRect.left)),
	                        y: Math.max(0, Math.min(rootRect.height, this._lastMouseEvent.clientY - rootRect.top))
	                    }
	                    : {
	                        x: this._lastMouseEvent.clientX - rootRect.left,
	                        y: this._lastMouseEvent.clientY - rootRect.top
	                    };
	                var dragRect = {
	                    left: Math.min(this._dragOrigin.x, constrainedPoint.x),
	                    top: Math.min(this._dragOrigin.y, constrainedPoint.y),
	                    width: Math.abs(constrainedPoint.x - this._dragOrigin.x),
	                    height: Math.abs(constrainedPoint.y - this._dragOrigin.y)
	                };
	                this._evaluateSelection(dragRect, rootRect);
	                this.setState({ dragRect: dragRect });
	            }
	        }
	        return false;
	    };
	    MarqueeSelectionBase.prototype._onMouseUp = function (ev) {
	        this._events.off(window);
	        this._events.off(this._scrollableParent, 'scroll');
	        if (this._autoScroll) {
	            this._autoScroll.dispose();
	        }
	        this._autoScroll = this._dragOrigin = this._lastMouseEvent = this._selectedIndicies = this._itemRectCache = undefined;
	        if (this.state.dragRect) {
	            this.setState({
	                dragRect: undefined
	            });
	            ev.preventDefault();
	            ev.stopPropagation();
	        }
	    };
	    MarqueeSelectionBase.prototype._isPointInRectangle = function (rectangle, point) {
	        return rectangle.top < point.y && rectangle.bottom > point.y && rectangle.left < point.x && rectangle.right > point.x;
	    };
	    /**
	     * We do not want to start the marquee if we're trying to marquee
	     * from within an existing marquee selection.
	     */
	    MarqueeSelectionBase.prototype._isDragStartInSelection = function (ev) {
	        var selection = this.props.selection;
	        if (!this._root.current || (selection && selection.getSelectedCount() === 0)) {
	            return false;
	        }
	        var allElements = this._root.current.querySelectorAll('[data-selection-index]');
	        for (var i = 0; i < allElements.length; i++) {
	            var element = allElements[i];
	            var index = Number(element.getAttribute('data-selection-index'));
	            if (selection.isIndexSelected(index)) {
	                var itemRect = element.getBoundingClientRect();
	                if (this._isPointInRectangle(itemRect, { x: ev.clientX, y: ev.clientY })) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    MarqueeSelectionBase.prototype._isInSelectionToggle = function (ev) {
	        var element = ev.target;
	        while (element && element !== this._root.current) {
	            if (element.getAttribute('data-selection-toggle') === 'true') {
	                return true;
	            }
	            element = element.parentElement;
	        }
	        return false;
	    };
	    MarqueeSelectionBase.prototype._evaluateSelection = function (dragRect, rootRect) {
	        // Break early if we don't need to evaluate.
	        if (!dragRect || !this._root.current) {
	            return;
	        }
	        var selection = this.props.selection;
	        var allElements = this._root.current.querySelectorAll('[data-selection-index]');
	        if (!this._itemRectCache) {
	            this._itemRectCache = {};
	        }
	        for (var i = 0; i < allElements.length; i++) {
	            var element = allElements[i];
	            var index = element.getAttribute('data-selection-index');
	            // Pull the memoized rectangle for the item, or the get the rect and memoize.
	            var itemRect = this._itemRectCache[index];
	            if (!itemRect) {
	                itemRect = element.getBoundingClientRect();
	                // Normalize the item rect to the dragRect coordinates.
	                itemRect = {
	                    left: itemRect.left - rootRect.left,
	                    top: itemRect.top - rootRect.top,
	                    width: itemRect.width,
	                    height: itemRect.height,
	                    right: itemRect.left - rootRect.left + itemRect.width,
	                    bottom: itemRect.top - rootRect.top + itemRect.height
	                };
	                if (itemRect.width > 0 && itemRect.height > 0) {
	                    this._itemRectCache[index] = itemRect;
	                }
	            }
	            if (itemRect.top < dragRect.top + dragRect.height &&
	                itemRect.bottom > dragRect.top &&
	                itemRect.left < dragRect.left + dragRect.width &&
	                itemRect.right > dragRect.left) {
	                this._selectedIndicies[index] = true;
	            }
	            else {
	                delete this._selectedIndicies[index];
	            }
	        }
	        // set previousSelectedIndices to be all of the selected indices from last time
	        var previousSelectedIndices = this._allSelectedIndices || {};
	        this._allSelectedIndices = {};
	        // set all indices that are supposed to be selected in _allSelectedIndices
	        for (var index in this._selectedIndicies) {
	            if (this._selectedIndicies.hasOwnProperty(index)) {
	                this._allSelectedIndices[index] = true;
	            }
	        }
	        if (this._preservedIndicies) {
	            for (var _i = 0, _a = this._preservedIndicies; _i < _a.length; _i++) {
	                var index = _a[_i];
	                this._allSelectedIndices[index] = true;
	            }
	        }
	        // check if needs to update selection, only when current _allSelectedIndices
	        // is different than previousSelectedIndices
	        var needToUpdate = false;
	        for (var index in this._allSelectedIndices) {
	            if (this._allSelectedIndices[index] !== previousSelectedIndices[index]) {
	                needToUpdate = true;
	                break;
	            }
	        }
	        if (!needToUpdate) {
	            for (var index in previousSelectedIndices) {
	                if (this._allSelectedIndices[index] !== previousSelectedIndices[index]) {
	                    needToUpdate = true;
	                    break;
	                }
	            }
	        }
	        // only update selection when needed
	        if (needToUpdate) {
	            // Stop change events, clear selection to re-populate.
	            selection.setChangeEvents(false);
	            selection.setAllSelected(false);
	            for (var _b = 0, _c = Object.keys(this._allSelectedIndices); _b < _c.length; _b++) {
	                var index = _c[_b];
	                selection.setIndexSelected(Number(index), true, false);
	            }
	            selection.setChangeEvents(true);
	        }
	    };
	    MarqueeSelectionBase.defaultProps = {
	        rootTagName: 'div',
	        rootProps: {},
	        isEnabled: true
	    };
	    return MarqueeSelectionBase;
	}(Utilities_1.BaseComponent));
	exports.MarqueeSelectionBase = MarqueeSelectionBase;
	//# sourceMappingURL=MarqueeSelection.base.js.map

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className;
	    var palette = theme.palette;
	    return {
	        root: [
	            className,
	            {
	                position: 'relative',
	                cursor: 'default'
	            }
	        ],
	        dragMask: [
	            {
	                position: 'absolute',
	                background: 'rgba(255, 0, 0, 0)',
	                left: 0,
	                top: 0,
	                right: 0,
	                bottom: 0,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        background: 'none',
	                        backgroundColor: 'transparent'
	                    },
	                    _a)
	            }
	        ],
	        box: [
	            {
	                position: 'absolute',
	                boxSizing: 'border-box',
	                border: "1px solid " + palette.themePrimary,
	                pointerEvents: 'none',
	                zIndex: 10,
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Highlight'
	                    },
	                    _b)
	            }
	        ],
	        boxFill: [
	            {
	                position: 'absolute',
	                boxSizing: 'border-box',
	                backgroundColor: palette.themePrimary,
	                opacity: 0.1,
	                left: 0,
	                top: 0,
	                right: 0,
	                bottom: 0,
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = {
	                        background: 'none',
	                        backgroundColor: 'transparent'
	                    },
	                    _c)
	            }
	        ]
	    };
	    var _a, _b, _c;
	};
	//# sourceMappingURL=MarqueeSelection.styles.js.map

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1106), exports);
	//# sourceMappingURL=MessageBar.js.map

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1107), exports);
	tslib_1.__exportStar(__webpack_require__(1108), exports);
	tslib_1.__exportStar(__webpack_require__(1109), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var MessageBar_base_1 = __webpack_require__(1108);
	var MessageBar_styles_1 = __webpack_require__(1110);
	exports.MessageBar = Utilities_1.styled(MessageBar_base_1.MessageBarBase, MessageBar_styles_1.getStyles, undefined, {
	    scope: 'MessageBar'
	});
	//# sourceMappingURL=MessageBar.js.map

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var Icon_1 = __webpack_require__(643);
	var MessageBar_types_1 = __webpack_require__(1109);
	var getClassNames = Utilities_1.classNamesFunction();
	var MessageBarBase = /** @class */ (function (_super) {
	    tslib_1.__extends(MessageBarBase, _super);
	    function MessageBarBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.ICON_MAP = (_a = {},
	            _a[MessageBar_types_1.MessageBarType.info] = 'Info',
	            _a[MessageBar_types_1.MessageBarType.warning] = 'Info',
	            _a[MessageBar_types_1.MessageBarType.error] = 'ErrorBadge',
	            _a[MessageBar_types_1.MessageBarType.blocked] = 'Blocked2',
	            _a[MessageBar_types_1.MessageBarType.remove] = 'Blocked',
	            _a[MessageBar_types_1.MessageBarType.severeWarning] = 'Warning',
	            _a[MessageBar_types_1.MessageBarType.success] = 'Completed',
	            _a);
	        _this._onClick = function (ev) {
	            _this.setState({ expandSingleLine: !_this.state.expandSingleLine });
	        };
	        _this.state = {
	            labelId: Utilities_1.getId('MessageBar'),
	            showContent: false,
	            expandSingleLine: false
	        };
	        return _this;
	        var _a;
	    }
	    MessageBarBase.prototype.render = function () {
	        var isMultiline = this.props.isMultiline;
	        this._classNames = this._getClassNames();
	        return isMultiline ? this._renderMultiLine() : this._renderSingleLine();
	    };
	    MessageBarBase.prototype._getActionsDiv = function () {
	        if (this.props.actions) {
	            return React.createElement("div", { className: this._classNames.actions }, this.props.actions);
	        }
	        return null;
	    };
	    MessageBarBase.prototype._getDismissDiv = function () {
	        if (this.props.onDismiss) {
	            return (React.createElement(Button_1.IconButton, { disabled: false, className: this._classNames.dismissal, onClick: this.props.onDismiss, iconProps: { iconName: 'Clear' }, ariaLabel: this.props.dismissButtonAriaLabel }));
	        }
	        return null;
	    };
	    MessageBarBase.prototype._getDismissSingleLine = function () {
	        if (this.props.onDismiss) {
	            return React.createElement("div", { className: this._classNames.dismissSingleLine }, this._getDismissDiv());
	        }
	        return null;
	    };
	    MessageBarBase.prototype._getExpandSingleLine = function () {
	        if (!this.props.actions && this.props.truncated) {
	            return (React.createElement("div", { className: this._classNames.expandSingleLine },
	                React.createElement(Button_1.IconButton, { disabled: false, className: this._classNames.expand, onClick: this._onClick, iconProps: { iconName: this.state.expandSingleLine ? 'DoubleChevronUp' : 'DoubleChevronDown' }, ariaLabel: this.props.overflowButtonAriaLabel, "aria-expanded": this.state.expandSingleLine, "aria-controls": this.state.labelId })));
	        }
	        return null;
	    };
	    MessageBarBase.prototype._getIconSpan = function () {
	        return (React.createElement("div", { className: this._classNames.iconContainer, "aria-hidden": true },
	            React.createElement(Icon_1.Icon, { iconName: this.ICON_MAP[this.props.messageBarType], className: this._classNames.icon })));
	    };
	    MessageBarBase.prototype._renderMultiLine = function () {
	        var theme = this.props.theme;
	        return (React.createElement("div", { style: { background: theme.semanticColors.bodyBackground } },
	            React.createElement("div", { className: this._classNames.root },
	                React.createElement("div", { className: this._classNames.content },
	                    this._getIconSpan(),
	                    this._renderInnerText(),
	                    this._getDismissDiv()),
	                this._getActionsDiv())));
	    };
	    MessageBarBase.prototype._renderSingleLine = function () {
	        var theme = this.props.theme;
	        return (React.createElement("div", { style: { background: theme.semanticColors.bodyBackground } },
	            React.createElement("div", { className: this._classNames.root },
	                React.createElement("div", { className: this._classNames.content },
	                    this._getIconSpan(),
	                    this._renderInnerText(),
	                    this._getExpandSingleLine(),
	                    this._getActionsDiv(),
	                    this._getDismissSingleLine()))));
	    };
	    MessageBarBase.prototype._renderInnerText = function () {
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.htmlElementProperties, ['className']);
	        return (React.createElement("div", { className: this._classNames.text, id: this.state.labelId },
	            React.createElement("span", tslib_1.__assign({ className: this._classNames.innerText, role: "status", "aria-live": this._getAnnouncementPriority() }, nativeProps),
	                React.createElement(Utilities_1.DelayedRender, null,
	                    React.createElement("span", null, this.props.children)))));
	    };
	    MessageBarBase.prototype._getClassNames = function () {
	        var _a = this.props, theme = _a.theme, className = _a.className, messageBarType = _a.messageBarType, onDismiss = _a.onDismiss, actions = _a.actions, truncated = _a.truncated, isMultiline = _a.isMultiline;
	        var expandSingleLine = this.state.expandSingleLine;
	        return getClassNames(this.props.styles, {
	            theme: theme,
	            messageBarType: messageBarType || MessageBar_types_1.MessageBarType.info,
	            onDismiss: onDismiss !== undefined,
	            actions: actions !== undefined,
	            truncated: truncated,
	            isMultiline: isMultiline,
	            expandSingleLine: expandSingleLine,
	            className: className
	        });
	    };
	    MessageBarBase.prototype._getAnnouncementPriority = function () {
	        switch (this.props.messageBarType) {
	            case MessageBar_types_1.MessageBarType.blocked:
	            case MessageBar_types_1.MessageBarType.error:
	            case MessageBar_types_1.MessageBarType.severeWarning:
	                return 'assertive';
	        }
	        return 'polite';
	    };
	    MessageBarBase.defaultProps = {
	        messageBarType: MessageBar_types_1.MessageBarType.info,
	        onDismiss: undefined,
	        isMultiline: true
	    };
	    return MessageBarBase;
	}(Utilities_1.BaseComponent));
	exports.MessageBarBase = MessageBarBase;
	//# sourceMappingURL=MessageBar.base.js.map

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory MessageBar}
	 */
	var MessageBarType;
	(function (MessageBarType) {
	    /** Info styled MessageBar */
	    MessageBarType[MessageBarType["info"] = 0] = "info";
	    /** Error styled MessageBar */
	    MessageBarType[MessageBarType["error"] = 1] = "error";
	    /** Blocked styled MessageBar */
	    MessageBarType[MessageBarType["blocked"] = 2] = "blocked";
	    /** SevereWarning styled MessageBar */
	    MessageBarType[MessageBarType["severeWarning"] = 3] = "severeWarning";
	    /** Success styled MessageBar */
	    MessageBarType[MessageBarType["success"] = 4] = "success";
	    /** Warning styled MessageBar */
	    MessageBarType[MessageBarType["warning"] = 5] = "warning";
	    /**
	     * Deprecated at v0.48.0, to be removed at \>= v1.0.0. Use `blocked` instead.
	     * @deprecated Use `blocked` instead.
	     */
	    MessageBarType[MessageBarType["remove"] = 90000] = "remove";
	})(MessageBarType = exports.MessageBarType || (exports.MessageBarType = {}));
	//# sourceMappingURL=MessageBar.types.js.map

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Styling_1 = __webpack_require__(463);
	var MessageBar_types_1 = __webpack_require__(1109);
	var GlobalClassNames = {
	    root: 'ms-MessageBar',
	    error: 'ms-MessageBar--error',
	    blocked: 'ms-MessageBar--blocked',
	    severeWarning: 'ms-MessageBar--severeWarning',
	    success: 'ms-MessageBar--success',
	    warning: 'ms-MessageBar--warning',
	    multiline: 'ms-MessageBar-multiline',
	    singleline: 'ms-MessageBar-singleline',
	    dismissalSingleLine: 'ms-MessageBar-dismissalSingleLine',
	    expandingSingleLine: 'ms-MessageBar-expandingSingleLine',
	    content: 'ms-MessageBar-content',
	    iconContainer: 'ms-MessageBar-icon',
	    text: 'ms-MessageBar-text',
	    innerText: 'ms-MessageBar-innerText',
	    dismissSingleLine: 'ms-MessageBar-dismissSingleLine',
	    expandSingleLine: 'ms-MessageBar-expandSingleLine',
	    dismissal: 'ms-MessageBar-dismissal',
	    expand: 'ms-MessageBar-expand',
	    actions: 'ms-MessageBar-actions',
	    actionsSingleline: 'ms-MessageBar-actionsSingleLine'
	};
	// Returns the background color of the MessageBar root element based on the type of MessageBar.
	var getRootBackground = function (messageBarType, palette, semanticColors) {
	    switch (messageBarType) {
	        case MessageBar_types_1.MessageBarType.error:
	        case MessageBar_types_1.MessageBarType.blocked:
	            return semanticColors.errorBackground;
	        case MessageBar_types_1.MessageBarType.severeWarning:
	            return semanticColors.blockingBackground;
	        case MessageBar_types_1.MessageBarType.success:
	            return semanticColors.successBackground;
	        case MessageBar_types_1.MessageBarType.warning:
	            return semanticColors.warningBackground;
	    }
	    return palette.neutralLighter;
	};
	// Returns the icon color based on the type of MessageBar.
	var getIconColor = function (messageBarType, palette, semanticColors) {
	    switch (messageBarType) {
	        case MessageBar_types_1.MessageBarType.error:
	        case MessageBar_types_1.MessageBarType.blocked:
	        case MessageBar_types_1.MessageBarType.severeWarning:
	            return semanticColors.errorText;
	        case MessageBar_types_1.MessageBarType.success:
	            return palette.green;
	        case MessageBar_types_1.MessageBarType.warning:
	            return semanticColors.warningText;
	    }
	    return palette.neutralSecondary;
	};
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, messageBarType = props.messageBarType, onDismiss = props.onDismiss, actions = props.actions, truncated = props.truncated, isMultiline = props.isMultiline, expandSingleLine = props.expandSingleLine;
	    var semanticColors = theme.semanticColors, palette = theme.palette, fonts = theme.fonts;
	    var SmallScreenSelector = Styling_1.getScreenSelector(0, Styling_1.ScreenWidthMaxSmall);
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var dismissalAndExpandIconStyle = {
	        fontSize: 12,
	        height: 12,
	        lineHeight: '12px',
	        color: palette.neutralPrimary,
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                MsHighContrastAdjust: 'none',
	                color: 'window'
	            },
	            _a)
	    };
	    var dismissalAndExpandSingleLineStyle = {
	        display: 'flex',
	        selectors: {
	            '& .ms-Button-icon': dismissalAndExpandIconStyle
	        }
	    };
	    var dismissalAndExpandStyle = [
	        Styling_1.getFocusStyle(theme, {
	            inset: 1,
	            highContrastStyle: {
	                outlineOffset: '-4px',
	                outlineColor: 'Window'
	            },
	            borderColor: 'transparent'
	        }),
	        {
	            flexShrink: 0,
	            margin: 8,
	            marginLeft: 0,
	            selectors: (_b = {
	                    '& .ms-Button-icon': dismissalAndExpandIconStyle
	                },
	                _b[SmallScreenSelector] = {
	                    margin: '0px 0px 0px 8px'
	                },
	                _b)
	        }
	    ];
	    var focusStyle = Styling_1.getFocusStyle(theme, { borderColor: palette.black });
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            messageBarType === MessageBar_types_1.MessageBarType.error && classNames.error,
	            messageBarType === MessageBar_types_1.MessageBarType.blocked && classNames.blocked,
	            messageBarType === MessageBar_types_1.MessageBarType.severeWarning && classNames.severeWarning,
	            messageBarType === MessageBar_types_1.MessageBarType.success && classNames.success,
	            messageBarType === MessageBar_types_1.MessageBarType.warning && classNames.warning,
	            isMultiline ? classNames.multiline : classNames.singleline,
	            !isMultiline && onDismiss && classNames.dismissalSingleLine,
	            !isMultiline && truncated && classNames.expandingSingleLine,
	            {
	                background: getRootBackground(messageBarType, palette, semanticColors),
	                color: palette.neutralPrimary,
	                minHeight: 32,
	                width: '100%',
	                boxSizing: 'border-box',
	                display: 'flex',
	                wordBreak: 'break-word',
	                selectors: (_c = {
	                        '& .ms-Link': tslib_1.__assign({ color: palette.themeDark }, fonts.small)
	                    },
	                    _c[Styling_1.HighContrastSelector] = {
	                        background: 'windowText',
	                        color: 'Window'
	                    },
	                    _c)
	            },
	            isMultiline && {
	                flexDirection: 'column'
	            },
	            !isMultiline && {
	                selectors: (_d = {},
	                    _d[SmallScreenSelector] = {
	                        flexDirection: 'column'
	                    },
	                    _d)
	            },
	            truncated && {
	                flexDirection: 'column',
	                selectors: {
	                    '& .ms-Button-icon': dismissalAndExpandIconStyle
	                }
	            },
	            className
	        ],
	        content: [
	            classNames.content,
	            {
	                display: 'flex',
	                lineHeight: 'normal',
	                width: '100%',
	                boxSizing: 'border-box'
	            },
	            !isMultiline && {
	                selectors: (_e = {},
	                    _e[SmallScreenSelector] = {
	                        flexDirection: 'row'
	                    },
	                    _e)
	            },
	            (truncated || isMultiline) && {
	                flexDirection: 'row'
	            }
	        ],
	        iconContainer: [
	            classNames.iconContainer,
	            {
	                fontSize: 16,
	                minWidth: 16,
	                minHeight: 16,
	                display: 'flex',
	                color: palette.neutralSecondary,
	                flexShrink: 0,
	                margin: 16,
	                marginRight: 0,
	                selectors: (_f = {},
	                    _f[SmallScreenSelector] = {
	                        margin: '8px 0px 8px 8px'
	                    },
	                    _f)
	            }
	        ],
	        icon: {
	            color: getIconColor(messageBarType, palette, semanticColors),
	            selectors: (_g = {},
	                _g[Styling_1.HighContrastSelector] = {
	                    MsHighContrastAdjust: 'none',
	                    color: 'window'
	                },
	                _g)
	        },
	        text: [
	            classNames.text,
	            tslib_1.__assign({ minWidth: 0, display: 'flex', flexGrow: 1, margin: '16px 8px' }, fonts.small, { selectors: (_h = {},
	                    _h[SmallScreenSelector] = {
	                        margin: '8px 0px 8px 8px'
	                    },
	                    _h[Styling_1.HighContrastSelector] = {
	                        MsHighContrastAdjust: 'none',
	                        color: 'window'
	                    },
	                    _h) }),
	            !onDismiss && {
	                marginRight: 16,
	                selectors: (_j = {},
	                    _j[SmallScreenSelector] = {
	                        marginRight: 8
	                    },
	                    _j)
	            },
	            isMultiline &&
	                actions && {
	                marginBottom: 8,
	                selectors: (_k = {},
	                    _k[SmallScreenSelector] = {
	                        marginBottom: 0
	                    },
	                    _k)
	            },
	            !isMultiline &&
	                actions && {
	                selectors: (_l = {},
	                    _l[SmallScreenSelector] = {
	                        marginBottom: 0
	                    },
	                    _l)
	            }
	        ],
	        innerText: [
	            classNames.innerText,
	            {
	                lineHeight: 16,
	                selectors: {
	                    '& span': {
	                        selectors: {
	                            '& a': {
	                                paddingLeft: 4
	                            }
	                        }
	                    }
	                }
	            },
	            truncated && {
	                overflow: 'visible',
	                whiteSpace: 'pre-wrap'
	            },
	            !isMultiline && {
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap'
	            },
	            !isMultiline &&
	                !truncated && {
	                selectors: (_m = {},
	                    _m[SmallScreenSelector] = {
	                        overflow: 'visible',
	                        whiteSpace: 'pre-wrap'
	                    },
	                    _m)
	            },
	            expandSingleLine && {
	                overflow: 'visible',
	                whiteSpace: 'pre-wrap'
	            }
	        ],
	        dismissSingleLine: [classNames.dismissSingleLine, dismissalAndExpandSingleLineStyle],
	        expandSingleLine: [classNames.expandSingleLine, dismissalAndExpandSingleLineStyle],
	        dismissal: [classNames.dismissal, dismissalAndExpandStyle, focusStyle],
	        expand: [classNames.expand, dismissalAndExpandStyle, focusStyle],
	        actions: [
	            isMultiline ? classNames.actions : classNames.actionsSingleline,
	            {
	                display: 'flex',
	                flexGrow: 0,
	                flexShrink: 0,
	                flexBasis: 'auto',
	                flexDirection: 'row-reverse',
	                alignItems: 'center',
	                margin: '8px 8px 8px 0',
	                selectors: {
	                    '& button:nth-child(n+2)': {
	                        marginLeft: 8
	                    }
	                }
	            },
	            isMultiline && {
	                margin: '0px 12px 12px 0',
	                selectors: {
	                    '& button:nth-child(n+2)': {
	                        marginLeft: 12
	                    }
	                }
	            }
	        ]
	    };
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	};
	//# sourceMappingURL=MessageBar.styles.js.map

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1112), exports);
	//# sourceMappingURL=Nav.js.map

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1113), exports);
	tslib_1.__exportStar(__webpack_require__(1114), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Nav_base_1 = __webpack_require__(1114);
	var Nav_styles_1 = __webpack_require__(1115);
	exports.Nav = Utilities_1.styled(Nav_base_1.NavBase, Nav_styles_1.getStyles, undefined, {
	    scope: 'Nav'
	});
	//# sourceMappingURL=Nav.js.map

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var FocusZone_1 = __webpack_require__(676);
	var Button_1 = __webpack_require__(691);
	var Icon_1 = __webpack_require__(643);
	var Nav_styles_1 = __webpack_require__(1115);
	// The number pixels per indentation level for Nav links.
	var _indentationSize = 14;
	// The number of pixels of left margin
	var _baseIndent = 3;
	// global var used in _isLinkSelectedKey
	var _urlResolver;
	function isRelativeUrl(url) {
	    // A URL is relative if it has no protocol.
	    return !!url && !/^[a-z0-9+-.]:\/\//i.test(url);
	}
	exports.isRelativeUrl = isRelativeUrl;
	var getClassNames = Utilities_1.classNamesFunction();
	var NavBase = /** @class */ (function (_super) {
	    tslib_1.__extends(NavBase, _super);
	    function NavBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onRenderLink = function (link) {
	            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
	            var classNames = getClassNames(styles, { theme: theme, groups: groups });
	            return React.createElement("div", { className: classNames.linkText }, link.name);
	        };
	        _this._renderGroup = function (group, groupIndex) {
	            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, _b = _a.onRenderGroupHeader, onRenderGroupHeader = _b === void 0 ? _this._renderGroupHeader : _b;
	            var classNames = getClassNames(styles, {
	                theme: theme,
	                isGroup: true,
	                isExpanded: _this._isGroupExpanded(group),
	                groups: groups
	            });
	            return (React.createElement("div", { key: groupIndex, className: classNames.group },
	                group.name ? onRenderGroupHeader(group, _this._renderGroupHeader) : null,
	                React.createElement("div", { className: classNames.groupContent }, _this._renderLinks(group.links, 0 /* nestingLevel */))));
	        };
	        _this._renderGroupHeader = function (group) {
	            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, expandButtonAriaLabel = _a.expandButtonAriaLabel;
	            var classNames = getClassNames(styles, {
	                theme: theme,
	                isGroup: true,
	                isExpanded: _this._isGroupExpanded(group),
	                groups: groups
	            });
	            return (React.createElement("button", { className: classNames.chevronButton, onClick: _this._onGroupHeaderClicked.bind(_this, group), "aria-label": expandButtonAriaLabel, "aria-expanded": _this._isGroupExpanded(group) },
	                React.createElement(Icon_1.Icon, { className: classNames.chevronIcon, iconName: "ChevronDown" }),
	                group.name));
	        };
	        _this.state = {
	            isGroupCollapsed: {},
	            isLinkExpandStateChanged: false,
	            selectedKey: props.initialSelectedKey || props.selectedKey
	        };
	        return _this;
	    }
	    NavBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, groups = _a.groups, className = _a.className, isOnTop = _a.isOnTop, theme = _a.theme;
	        if (!groups) {
	            return null;
	        }
	        var groupElements = groups.map(this._renderGroup);
	        var classNames = getClassNames(styles, { theme: theme, className: className, isOnTop: isOnTop, groups: groups });
	        return (React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical },
	            React.createElement("nav", { role: "navigation", className: classNames.root, "aria-label": this.props.ariaLabel }, groupElements)));
	    };
	    Object.defineProperty(NavBase.prototype, "selectedKey", {
	        get: function () {
	            return this.state.selectedKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NavBase.prototype._renderNavLink = function (link, linkIndex, nestingLevel) {
	        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, _b = _a.onRenderLink, onRenderLink = _b === void 0 ? this._onRenderLink : _b, _c = _a.linkAs, LinkAs = _c === void 0 ? Button_1.ActionButton : _c, selectedAriaLabel = _a.selectedAriaLabel;
	        var isLinkWithIcon = link.icon || link.iconProps;
	        var isSelectedLink = this._isLinkSelected(link);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            isSelected: isSelectedLink,
	            isDisabled: link.disabled,
	            isButtonEntry: link.onClick && !link.forceAnchor,
	            leftPadding: _indentationSize * nestingLevel + _baseIndent + (isLinkWithIcon ? 0 : 24),
	            groups: groups
	        });
	        // Prevent hijacking of the parent window if link.target is defined
	        var rel = link.url && link.target && !isRelativeUrl(link.url) ? 'noopener noreferrer' : undefined;
	        var selectedStateAriaLabel = isSelectedLink && selectedAriaLabel ? selectedAriaLabel : undefined;
	        return (React.createElement(LinkAs, { className: classNames.link, styles: Nav_styles_1.buttonStyles, href: link.url || (link.forceAnchor ? 'javascript:' : undefined), iconProps: link.iconProps || { iconName: link.icon }, onClick: link.onClick ? this._onNavButtonLinkClicked.bind(this, link) : this._onNavAnchorLinkClicked.bind(this, link), title: link.title || link.name, target: link.target, rel: rel, disabled: link.disabled, "aria-label": link.ariaLabel && selectedStateAriaLabel
	                ? link.ariaLabel + " " + selectedStateAriaLabel
	                : selectedStateAriaLabel
	                    ? selectedStateAriaLabel
	                    : link.ariaLabel
	                        ? link.ariaLabel
	                        : undefined }, onRenderLink(link, this._onRenderLink)));
	    };
	    NavBase.prototype._renderCompositeLink = function (link, linkIndex, nestingLevel) {
	        var divProps = tslib_1.__assign({}, Utilities_1.getNativeProps(link, Utilities_1.divProperties, ['onClick']));
	        var _a = this.props, expandButtonAriaLabel = _a.expandButtonAriaLabel, styles = _a.styles, groups = _a.groups, theme = _a.theme;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            isExpanded: !!link.isExpanded,
	            isSelected: this._isLinkSelected(link),
	            isLink: true,
	            isDisabled: link.disabled,
	            position: _indentationSize * nestingLevel + 1,
	            groups: groups
	        });
	        var finalExpandBtnAriaLabel = expandButtonAriaLabel ? link.name + " " + expandButtonAriaLabel : link.name;
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { key: link.key || linkIndex, className: classNames.compositeLink }),
	            link.links && link.links.length > 0 ? (React.createElement("button", { className: classNames.chevronButton, onClick: this._onLinkExpandClicked.bind(this, link), "aria-label": finalExpandBtnAriaLabel, "aria-expanded": link.isExpanded ? 'true' : 'false' },
	                React.createElement(Icon_1.Icon, { className: classNames.chevronIcon, iconName: "ChevronDown" }))) : null,
	            this._renderNavLink(link, linkIndex, nestingLevel)));
	    };
	    NavBase.prototype._renderLink = function (link, linkIndex, nestingLevel) {
	        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
	        var classNames = getClassNames(styles, { theme: theme, groups: groups });
	        return (React.createElement("li", { key: link.key || linkIndex, role: "listitem", className: classNames.navItem },
	            this._renderCompositeLink(link, linkIndex, nestingLevel),
	            link.isExpanded ? this._renderLinks(link.links, ++nestingLevel) : null));
	    };
	    NavBase.prototype._renderLinks = function (links, nestingLevel) {
	        var _this = this;
	        if (!links || !links.length) {
	            return null;
	        }
	        var linkElements = links.map(function (link, linkIndex) {
	            return _this._renderLink(link, linkIndex, nestingLevel);
	        });
	        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
	        var classNames = getClassNames(styles, { theme: theme, groups: groups });
	        return (React.createElement("ul", { role: "list", className: classNames.navItems }, linkElements));
	    };
	    NavBase.prototype._onGroupHeaderClicked = function (group, ev) {
	        if (group.onHeaderClick) {
	            group.onHeaderClick(ev, this._isGroupExpanded(group));
	        }
	        this._toggleCollapsed(group);
	        ev.preventDefault();
	        ev.stopPropagation();
	    };
	    NavBase.prototype._onLinkExpandClicked = function (link, ev) {
	        var onLinkExpandClick = this.props.onLinkExpandClick;
	        if (onLinkExpandClick) {
	            onLinkExpandClick(ev, link);
	        }
	        if (!ev.defaultPrevented) {
	            link.isExpanded = !link.isExpanded;
	            this.setState({ isLinkExpandStateChanged: true });
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	    };
	    NavBase.prototype._onNavAnchorLinkClicked = function (link, ev) {
	        if (this.props.onLinkClick) {
	            this.props.onLinkClick(ev, link);
	        }
	        if (!link.url && link.links && link.links.length > 0) {
	            this._onLinkExpandClicked(link, ev);
	        }
	        this.setState({ selectedKey: link.key });
	    };
	    NavBase.prototype._onNavButtonLinkClicked = function (link, ev) {
	        if (link.onClick) {
	            link.onClick(ev, link);
	        }
	        if (!link.url && link.links && link.links.length > 0) {
	            this._onLinkExpandClicked(link, ev);
	        }
	        this.setState({ selectedKey: link.key });
	    };
	    NavBase.prototype._isLinkSelected = function (link) {
	        // if caller passes in selectedKey, use it as first choice or
	        // if current state.selectedKey (from addressbar) is match to the link or
	        // check if URL is matching location.href (if link.url exists)
	        if (this.props.selectedKey !== undefined) {
	            return link.key === this.props.selectedKey;
	        }
	        else if (this.state.selectedKey !== undefined) {
	            return link.key === this.state.selectedKey;
	        }
	        else if (typeof Utilities_1.getWindow() === 'undefined' || !link.url) {
	            // resolve is not supported for ssr
	            return false;
	        }
	        else {
	            // If selectedKey is undefined in props and state, then check URL
	            _urlResolver = _urlResolver || document.createElement('a');
	            _urlResolver.href = link.url || '';
	            var target = _urlResolver.href;
	            if (location.href === target) {
	                return true;
	            }
	            // If selectedKey is not defined in state, then check URL to determine link selected status
	            if (location.protocol + '//' + location.host + location.pathname === target) {
	                return true;
	            }
	            if (location.hash) {
	                // Match the hash to the url.
	                if (location.hash === link.url) {
	                    return true;
	                }
	                // Match a rebased url. (e.g. #foo becomes http://hostname/foo)
	                _urlResolver.href = location.hash.substring(1);
	                return _urlResolver.href === target;
	            }
	        }
	        return false;
	    };
	    NavBase.prototype._isGroupExpanded = function (group) {
	        if (group.name && this.state.isGroupCollapsed.hasOwnProperty(group.name)) {
	            return !this.state.isGroupCollapsed[group.name];
	        }
	        if (group.collapseByDefault !== undefined) {
	            return !group.collapseByDefault;
	        }
	        return true;
	    };
	    NavBase.prototype._toggleCollapsed = function (group) {
	        if (group.name) {
	            var newGroupCollapsed = tslib_1.__assign({}, this.state.isGroupCollapsed, (_a = {}, _a[group.name] = this._isGroupExpanded(group) // sic - presently open will be collapsed after setState
	            , _a));
	            this.setState({ isGroupCollapsed: newGroupCollapsed });
	        }
	        var _a;
	    };
	    NavBase.defaultProps = {
	        groups: null
	    };
	    return NavBase;
	}(React.Component));
	exports.NavBase = NavBase;
	//# sourceMappingURL=Nav.base.js.map

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-Nav',
	    linkText: 'ms-Nav-linkText',
	    compositeLink: 'ms-Nav-compositeLink',
	    link: 'ms-Nav-link',
	    chevronButton: 'ms-Nav-chevronButton',
	    chevronIcon: 'ms-Nav-chevron',
	    navItem: 'ms-Nav-navItem',
	    navItems: 'ms-Nav-navItems',
	    group: 'ms-Nav-group',
	    groupContent: 'ms-Nav-groupContent'
	};
	exports.buttonStyles = {
	    textContainer: {
	        overflow: 'hidden'
	    },
	    label: {
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis',
	        overflow: 'hidden',
	        lineHeight: '36px'
	    }
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, isOnTop = props.isOnTop, isExpanded = props.isExpanded, isGroup = props.isGroup, isLink = props.isLink, isSelected = props.isSelected, isDisabled = props.isDisabled, isButtonEntry = props.isButtonEntry, _a = props.navHeight, navHeight = _a === void 0 ? 36 : _a, position = props.position, _b = props.leftPadding, leftPadding = _b === void 0 ? 20 : _b, _c = props.leftPaddingExpanded, leftPaddingExpanded = _c === void 0 ? 28 : _c, _d = props.rightPadding, rightPadding = _d === void 0 ? 20 : _d;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            className,
	            theme.fonts.medium,
	            {
	                overflowY: 'auto',
	                userSelect: 'none',
	                WebkitOverflowScrolling: 'touch'
	            },
	            isOnTop && [
	                {
	                    position: 'absolute'
	                },
	                Styling_1.AnimationClassNames.slideRightIn40
	            ]
	        ],
	        linkText: [
	            classNames.linkText,
	            {
	                margin: '0 4px',
	                overflow: 'hidden',
	                verticalAlign: 'middle',
	                textAlign: 'left',
	                textOverflow: 'ellipsis'
	            }
	        ],
	        compositeLink: [
	            classNames.compositeLink,
	            {
	                display: 'block',
	                position: 'relative',
	                color: semanticColors.bodyText,
	                backgroundColor: semanticColors.bodyBackground
	            },
	            isExpanded && 'is-expanded',
	            isSelected && 'is-selected',
	            isDisabled && 'is-disabled',
	            isDisabled && {
	                color: semanticColors.disabledText
	            }
	        ],
	        link: [
	            classNames.link,
	            Styling_1.getFocusStyle(theme),
	            {
	                display: 'block',
	                position: 'relative',
	                height: navHeight + "px",
	                width: '100%',
	                lineHeight: navHeight + "px",
	                textDecoration: 'none',
	                cursor: 'pointer',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                overflow: 'hidden',
	                paddingLeft: leftPadding,
	                paddingRight: rightPadding,
	                color: semanticColors.bodyText,
	                selectors: !isDisabled
	                    ? {
	                        '.ms-Nav-compositeLink:hover &': {
	                            backgroundColor: palette.neutralLighterAlt,
	                            color: semanticColors.bodyText
	                        }
	                    }
	                    : {}
	            },
	            isSelected && {
	                color: palette.themePrimary,
	                backgroundColor: palette.neutralLighter,
	                selectors: {
	                    '&:after': {
	                        borderLeft: "2px solid " + palette.themePrimary,
	                        content: '""',
	                        position: 'absolute',
	                        top: 0,
	                        right: 0,
	                        bottom: 0,
	                        left: 0,
	                        pointerEvents: 'none'
	                    }
	                }
	            },
	            isDisabled && {
	                color: semanticColors.disabledText
	            },
	            isButtonEntry && {
	                color: palette.themePrimary
	            }
	        ],
	        chevronButton: [
	            classNames.chevronButton,
	            Styling_1.getFocusStyle(theme),
	            {
	                display: 'block',
	                fontWeight: Styling_1.FontWeights.regular,
	                fontSize: Styling_1.FontSizes.small,
	                textAlign: 'left',
	                lineHeight: navHeight + "px",
	                margin: '5px 0',
	                padding: "0px, " + rightPadding + "px, 0px, " + leftPaddingExpanded + "px",
	                border: 'none',
	                textOverflow: 'ellipsis',
	                whiteSpace: 'nowrap',
	                overflow: 'hidden',
	                cursor: 'pointer',
	                color: semanticColors.bodyText,
	                backgroundColor: 'transparent',
	                selectors: {
	                    '&:visited': {
	                        color: 'inherit'
	                    },
	                    '&:hover': {
	                        color: semanticColors.bodyText,
	                        backgroundColor: palette.neutralLighterAlt
	                    },
	                    '$compositeLink:hover &': {
	                        color: semanticColors.bodyText,
	                        backgroundColor: palette.neutralLighterAlt
	                    }
	                }
	            },
	            isGroup && [
	                {
	                    width: '100%',
	                    height: navHeight + "px",
	                    borderBottom: "1px solid " + semanticColors.bodyDivider
	                },
	                Styling_1.DefaultFontStyles.large
	            ],
	            isLink && [
	                {
	                    display: 'block',
	                    width: leftPaddingExpanded - 2 + "px",
	                    height: navHeight - 2 + "px",
	                    position: 'absolute',
	                    top: '1px',
	                    left: position + "px",
	                    zIndex: Styling_1.ZIndexes.Nav,
	                    padding: 0,
	                    margin: 0
	                }
	            ],
	            isSelected && {
	                color: palette.themePrimary,
	                backgroundColor: palette.neutralLighterAlt,
	                selectors: {
	                    '&:after': {
	                        borderLeft: "2px solid " + palette.themePrimary,
	                        content: '""',
	                        position: 'absolute',
	                        top: 0,
	                        right: 0,
	                        bottom: 0,
	                        left: 0,
	                        pointerEvents: 'none'
	                    }
	                }
	            }
	        ],
	        chevronIcon: [
	            classNames.chevronIcon,
	            {
	                position: 'absolute',
	                left: '8px',
	                height: navHeight + "px",
	                lineHeight: navHeight + "px",
	                fontSize: '12px',
	                transition: 'transform .1s linear'
	            },
	            isExpanded && {
	                transform: 'rotate(-180deg)'
	            },
	            isLink && {
	                top: 0
	            }
	        ],
	        navItem: [
	            classNames.navItem,
	            {
	                padding: 0
	            }
	        ],
	        navItems: [
	            classNames.navItems,
	            {
	                listStyleType: 'none',
	                padding: 0
	            }
	        ],
	        group: [classNames.group, isExpanded && 'is-expanded'],
	        groupContent: [
	            classNames.groupContent,
	            {
	                display: 'none',
	                marginBottom: '40px'
	            },
	            Styling_1.AnimationClassNames.slideDownIn20,
	            isExpanded && {
	                display: 'block'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=Nav.styles.js.map

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1117), exports);
	//# sourceMappingURL=Pivot.js.map

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1118), exports);
	tslib_1.__exportStar(__webpack_require__(1119), exports);
	var PivotItem_1 = __webpack_require__(1120);
	exports.PivotItem = PivotItem_1.PivotItem;
	tslib_1.__exportStar(__webpack_require__(1121), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Pivot_base_1 = __webpack_require__(1119);
	var Pivot_styles_1 = __webpack_require__(1122);
	/**
	 * The Pivot control and related tabs pattern are used for navigating frequently accessed,
	 * distinct content categories. Pivots allow for navigation between two or more content
	 * views and relies on text headers to articulate the different sections of content.
	 */
	exports.Pivot = Utilities_1.styled(Pivot_base_1.PivotBase, Pivot_styles_1.getStyles, undefined, {
	    scope: 'Pivot'
	});
	//# sourceMappingURL=Pivot.js.map

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var FocusZone_1 = __webpack_require__(676);
	var PivotItem_1 = __webpack_require__(1120);
	var Pivot_types_1 = __webpack_require__(1121);
	var Pivot_types_2 = __webpack_require__(1121);
	var Icon_1 = __webpack_require__(643);
	var getClassNames = Utilities_1.classNamesFunction();
	var PivotItemType = React.createElement(PivotItem_1.PivotItem, null).type;
	/**
	 *  Usage:
	 *
	 *     <Pivot>
	 *       <PivotItem headerText="Foo">
	 *         <Label>Pivot #1</Label>
	 *       </PivotItem>
	 *       <PivotItem headerText="Bar">
	 *         <Label>Pivot #2</Label>
	 *       </PivotItem>
	 *       <PivotItem headerText="Bas">
	 *         <Label>Pivot #3</Label>
	 *       </PivotItem>
	 *     </Pivot>
	 */
	var PivotBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PivotBase, _super);
	    function PivotBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._focusZone = React.createRef();
	        _this._renderPivotLink = function (linkCollection, link, selectedKey) {
	            var itemKey = link.itemKey, headerButtonProps = link.headerButtonProps;
	            var tabId = linkCollection.keyToTabIdMapping[itemKey];
	            var onRenderItemLink = link.onRenderItemLink;
	            var linkContent;
	            var isSelected = selectedKey === itemKey;
	            if (onRenderItemLink) {
	                linkContent = onRenderItemLink(link, _this._renderLinkContent);
	            }
	            else {
	                linkContent = _this._renderLinkContent(link);
	            }
	            var contentString = link.headerText || '';
	            contentString += link.itemCount ? ' (' + link.itemCount + ')' : '';
	            // Adding space supplementary for icon
	            contentString += link.itemIcon ? ' xx' : '';
	            return (React.createElement(Button_1.CommandButton, tslib_1.__assign({}, headerButtonProps, { id: tabId, key: itemKey, className: isSelected ? _this._classNames.linkIsSelected : _this._classNames.link, onClick: _this._onLinkClick.bind(_this, itemKey), onKeyPress: _this._onKeyPress.bind(_this, itemKey), ariaLabel: link.ariaLabel, role: "tab", "aria-selected": isSelected, name: link.headerText, keytipProps: link.keytipProps, "data-content": contentString }), linkContent));
	        };
	        _this._renderLinkContent = function (link) {
	            var itemCount = link.itemCount, itemIcon = link.itemIcon, headerText = link.headerText;
	            var classNames = _this._classNames;
	            return (React.createElement("span", { className: classNames.linkContent },
	                itemIcon !== undefined && (React.createElement("span", { className: classNames.icon },
	                    React.createElement(Icon_1.Icon, { iconName: itemIcon }))),
	                headerText !== undefined && React.createElement("span", { className: classNames.text },
	                    " ",
	                    link.headerText),
	                itemCount !== undefined && React.createElement("span", { className: classNames.count },
	                    " (",
	                    itemCount,
	                    ")")));
	        };
	        _this._warnDeprecations({
	            initialSelectedKey: 'defaultSelectedKey',
	            initialSelectedIndex: 'defaultSelectedIndex'
	        });
	        _this._pivotId = Utilities_1.getId('Pivot');
	        var links = _this._getPivotLinks(props).links;
	        var _a = props.defaultSelectedKey, defaultSelectedKey = _a === void 0 ? props.initialSelectedKey : _a, _b = props.defaultSelectedIndex, defaultSelectedIndex = _b === void 0 ? props.initialSelectedIndex : _b;
	        var selectedKey;
	        if (defaultSelectedKey) {
	            selectedKey = defaultSelectedKey;
	        }
	        else if (typeof defaultSelectedIndex === 'number') {
	            selectedKey = links[defaultSelectedIndex].itemKey;
	        }
	        else if (links.length) {
	            selectedKey = links[0].itemKey;
	        }
	        _this.state = {
	            selectedKey: selectedKey
	        };
	        return _this;
	    }
	    /**
	     * Sets focus to the first pivot tab.
	     */
	    PivotBase.prototype.focus = function () {
	        if (this._focusZone.current) {
	            this._focusZone.current.focus();
	        }
	    };
	    PivotBase.prototype.render = function () {
	        var linkCollection = this._getPivotLinks(this.props);
	        var selectedKey = this._getSelectedKey(linkCollection);
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        this._classNames = this._getClassNames(this.props);
	        return (React.createElement("div", tslib_1.__assign({}, divProps),
	            this._renderPivotLinks(linkCollection, selectedKey),
	            selectedKey && this._renderPivotItem(linkCollection, selectedKey)));
	    };
	    PivotBase.prototype._getSelectedKey = function (linkCollection) {
	        var propsSelectedKey = this.props.selectedKey;
	        if (this._isKeyValid(linkCollection, propsSelectedKey) || propsSelectedKey === null) {
	            return propsSelectedKey;
	        }
	        var stateSelectedKey = this.state.selectedKey;
	        if (this._isKeyValid(linkCollection, stateSelectedKey)) {
	            return stateSelectedKey;
	        }
	        if (linkCollection.links.length) {
	            return linkCollection.links[0].itemKey;
	        }
	        return undefined;
	    };
	    /**
	     * Renders the set of links to route between pivots
	     */
	    PivotBase.prototype._renderPivotLinks = function (linkCollection, selectedKey) {
	        var _this = this;
	        var items = linkCollection.links.map(function (l) { return _this._renderPivotLink(linkCollection, l, selectedKey); });
	        return (React.createElement(FocusZone_1.FocusZone, { componentRef: this._focusZone, direction: FocusZone_1.FocusZoneDirection.horizontal },
	            React.createElement("div", { className: this._classNames.root, role: "tablist" }, items)));
	    };
	    /**
	     * Renders the current Pivot Item
	     */
	    PivotBase.prototype._renderPivotItem = function (linkCollection, itemKey) {
	        if (this.props.headersOnly || !itemKey) {
	            return null;
	        }
	        var index = linkCollection.keyToIndexMapping[itemKey];
	        var selectedTabId = linkCollection.keyToTabIdMapping[itemKey];
	        return (React.createElement("div", { role: "tabpanel", "aria-labelledby": selectedTabId, className: this._classNames.itemContainer }, React.Children.toArray(this.props.children)[index]));
	    };
	    /**
	     * Gets the set of PivotLinks as array of IPivotItemProps
	     * The set of Links is determined by child components of type PivotItem
	     */
	    PivotBase.prototype._getPivotLinks = function (props) {
	        var _this = this;
	        var result = {
	            links: [],
	            keyToIndexMapping: {},
	            keyToTabIdMapping: {}
	        };
	        React.Children.map(React.Children.toArray(props.children), function (child, index) {
	            if (typeof child === 'object' && child.type === PivotItemType) {
	                var pivotItem = child;
	                var _a = pivotItem.props, linkText = _a.linkText, pivotItemProps = tslib_1.__rest(_a, ["linkText"]);
	                var itemKey = pivotItem.props.itemKey || index.toString();
	                result.links.push(tslib_1.__assign({ 
	                    // Use linkText (deprecated) if headerText is not provided
	                    headerText: linkText }, pivotItemProps, { itemKey: itemKey }));
	                result.keyToIndexMapping[itemKey] = index;
	                result.keyToTabIdMapping[itemKey] = _this._getTabId(itemKey, index);
	            }
	            else {
	                Utilities_1.warn('The children of a Pivot component must be of type PivotItem to be rendered.');
	            }
	        });
	        return result;
	    };
	    /**
	     * Generates the Id for the tab button.
	     */
	    PivotBase.prototype._getTabId = function (itemKey, index) {
	        if (this.props.getTabId) {
	            return this.props.getTabId(itemKey, index);
	        }
	        return this._pivotId + ("-Tab" + index);
	    };
	    /**
	     * whether the key exists in the pivot items.
	     */
	    PivotBase.prototype._isKeyValid = function (linkCollection, itemKey) {
	        return itemKey !== undefined && itemKey !== null && linkCollection.keyToIndexMapping[itemKey] !== undefined;
	    };
	    /**
	     * Handles the onClick event on PivotLinks
	     */
	    PivotBase.prototype._onLinkClick = function (itemKey, ev) {
	        ev.preventDefault();
	        this._updateSelectedItem(itemKey, ev);
	    };
	    /**
	     * Handle the onKeyPress eventon the PivotLinks
	     */
	    PivotBase.prototype._onKeyPress = function (itemKey, ev) {
	        if (ev.which === Utilities_1.KeyCodes.enter) {
	            ev.preventDefault();
	            this._updateSelectedItem(itemKey);
	        }
	    };
	    /**
	     * Updates the state with the new selected index
	     */
	    PivotBase.prototype._updateSelectedItem = function (itemKey, ev) {
	        this.setState({
	            selectedKey: itemKey
	        });
	        var linkCollection = this._getPivotLinks(this.props);
	        if (this.props.onLinkClick && linkCollection.keyToIndexMapping[itemKey] >= 0) {
	            var index = linkCollection.keyToIndexMapping[itemKey];
	            // React.Element<any> cannot directly convert to PivotItem.
	            var item = React.Children.toArray(this.props.children)[index];
	            if (typeof item === 'object' && item.type === PivotItemType) {
	                this.props.onLinkClick(item, ev);
	            }
	        }
	    };
	    PivotBase.prototype._getClassNames = function (props) {
	        var theme = props.theme;
	        var rootIsLarge = props.linkSize === Pivot_types_2.PivotLinkSize.large;
	        var rootIsTabs = props.linkFormat === Pivot_types_1.PivotLinkFormat.tabs;
	        return getClassNames(props.styles, {
	            theme: theme,
	            rootIsLarge: rootIsLarge,
	            rootIsTabs: rootIsTabs
	        });
	    };
	    return PivotBase;
	}(Utilities_1.BaseComponent));
	exports.PivotBase = PivotBase;
	//# sourceMappingURL=Pivot.base.js.map

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var PivotItem = /** @class */ (function (_super) {
	    tslib_1.__extends(PivotItem, _super);
	    function PivotItem(props) {
	        var _this = _super.call(this, props) || this;
	        _this._warnDeprecations({
	            linkText: 'headerText'
	        });
	        return _this;
	    }
	    PivotItem.prototype.render = function () {
	        return React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties)), this.props.children);
	    };
	    return PivotItem;
	}(Utilities_1.BaseComponent));
	exports.PivotItem = PivotItem;
	//# sourceMappingURL=PivotItem.js.map

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Pivot}
	 */
	var PivotLinkFormat;
	(function (PivotLinkFormat) {
	    /**
	     * Display Pivot Links as links
	     */
	    PivotLinkFormat[PivotLinkFormat["links"] = 0] = "links";
	    /**
	     * Display Pivot Links as Tabs
	     */
	    PivotLinkFormat[PivotLinkFormat["tabs"] = 1] = "tabs";
	})(PivotLinkFormat = exports.PivotLinkFormat || (exports.PivotLinkFormat = {}));
	/**
	 * {@docCategory Pivot}
	 */
	var PivotLinkSize;
	(function (PivotLinkSize) {
	    /**
	     * Display Link using normal font size
	     */
	    PivotLinkSize[PivotLinkSize["normal"] = 0] = "normal";
	    /**
	     * Display links using large font size
	     */
	    PivotLinkSize[PivotLinkSize["large"] = 1] = "large";
	})(PivotLinkSize = exports.PivotLinkSize || (exports.PivotLinkSize = {}));
	//# sourceMappingURL=Pivot.types.js.map

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var globalClassNames = {
	    count: 'ms-Pivot-count',
	    icon: 'ms-Pivot-icon',
	    linkIsSelected: 'is-selected',
	    link: 'ms-Pivot-link',
	    linkContent: 'ms-Pivot-linkContent',
	    root: 'ms-Pivot',
	    rootIsLarge: 'ms-Pivot--large',
	    rootIsTabs: 'ms-Pivot--tabs',
	    text: 'ms-Pivot-text'
	};
	var linkStyles = function (props) {
	    var rootIsLarge = props.rootIsLarge, rootIsTabs = props.rootIsTabs;
	    var _a = props.theme, palette = _a.palette, semanticColors = _a.semanticColors;
	    return [
	        {
	            color: semanticColors.actionLink,
	            display: 'inline-block',
	            fontSize: Styling_1.FontSizes.medium,
	            fontWeight: Styling_1.FontWeights.regular,
	            lineHeight: '40px',
	            marginRight: '8px',
	            padding: '0 8px',
	            textAlign: 'center',
	            position: 'relative',
	            backgroundColor: 'transparent',
	            border: 0,
	            selectors: (_b = {
	                    ':before': {
	                        backgroundColor: 'transparent',
	                        bottom: 0,
	                        content: '""',
	                        height: '2px',
	                        left: '8px',
	                        position: 'absolute',
	                        right: '8px',
	                        transition: "background-color " + Styling_1.AnimationVariables.durationValue2 + " " + Styling_1.AnimationVariables.easeFunction2
	                    },
	                    ':after': {
	                        color: 'transparent',
	                        content: 'attr(data-content)',
	                        display: 'block',
	                        fontWeight: Styling_1.FontWeights.bold,
	                        height: '1px',
	                        overflow: 'hidden',
	                        visibility: 'hidden'
	                    },
	                    ':hover': {
	                        color: semanticColors.actionLinkHovered,
	                        cursor: 'pointer'
	                    },
	                    ':focus': {
	                        outline: 'none'
	                    }
	                },
	                _b["." + Utilities_1.IsFocusVisibleClassName + " &:focus"] = {
	                    outline: "1px solid " + semanticColors.focusBorder
	                },
	                _b["." + Utilities_1.IsFocusVisibleClassName + " &:focus:after"] = {
	                    content: 'attr(data-content)',
	                    position: 'relative',
	                    border: 0
	                },
	                _b)
	        },
	        rootIsLarge && {
	            fontSize: Styling_1.FontSizes.large
	        },
	        rootIsTabs && [
	            {
	                marginRight: 0,
	                height: '40px',
	                lineHeight: '40px',
	                backgroundColor: palette.neutralLighter,
	                padding: '0 10px',
	                verticalAlign: 'top',
	                selectors: (_c = {
	                        ':focus': {
	                            outlineOffset: '-1px'
	                        }
	                    },
	                    _c["." + Utilities_1.IsFocusVisibleClassName + " &:focus::before"] = {
	                        height: 'auto',
	                        background: 'transparent',
	                        transition: 'none'
	                    },
	                    _c)
	            }
	        ]
	    ];
	    var _b, _c;
	};
	exports.getStyles = function (props) {
	    var className = props.className, rootIsLarge = props.rootIsLarge, rootIsTabs = props.rootIsTabs, theme = props.theme;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(globalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            Styling_1.normalize,
	            {
	                fontSize: Styling_1.FontSizes.medium,
	                fontWeight: Styling_1.FontWeights.regular,
	                position: 'relative',
	                color: palette.themePrimary,
	                whiteSpace: 'nowrap'
	            },
	            rootIsLarge && classNames.rootIsLarge,
	            rootIsTabs && classNames.rootIsTabs,
	            className
	        ],
	        link: [
	            classNames.link
	        ].concat(linkStyles(props), [
	            {
	                selectors: {
	                    ':hover::before': {
	                        boxSizing: 'border-box',
	                        borderBottom: '2px solid transparent'
	                    }
	                }
	            },
	            rootIsTabs && {
	                selectors: {
	                    '&:hover, &:focus': {
	                        color: palette.black
	                    },
	                    ':active': {
	                        backgroundColor: palette.themePrimary
	                    }
	                }
	            }
	        ]),
	        linkIsSelected: [
	            classNames.link,
	            classNames.linkIsSelected
	        ].concat(linkStyles(props), [
	            {
	                fontWeight: Styling_1.FontWeights.semibold,
	                selectors: (_a = {
	                        ':before': {
	                            boxSizing: 'border-box',
	                            borderBottom: "2px solid " + semanticColors.inputBackgroundChecked,
	                            selectors: (_b = {},
	                                _b[Styling_1.HighContrastSelector] = {
	                                    borderBottomColor: 'Highlight'
	                                },
	                                _b)
	                        }
	                    },
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'Highlight'
	                    },
	                    _a)
	            },
	            rootIsTabs && {
	                backgroundColor: palette.themePrimary,
	                color: palette.white,
	                fontWeight: Styling_1.FontWeights.semilight,
	                selectors: (_c = {
	                        ':before': {
	                            backgroundColor: 'transparent',
	                            transition: 'none',
	                            position: 'absolute',
	                            top: 0,
	                            left: 0,
	                            right: 0,
	                            bottom: 0,
	                            content: '""',
	                            height: 'auto'
	                        },
	                        '&:active, &:hover': {
	                            color: palette.white
	                        }
	                    },
	                    _c[Styling_1.HighContrastSelector] = {
	                        fontWeight: Styling_1.FontWeights.semibold,
	                        color: 'HighlightText',
	                        background: 'Highlight',
	                        MsHighContrastAdjust: 'none'
	                    },
	                    _c)
	            }
	        ]),
	        linkContent: [classNames.linkContent],
	        text: [
	            classNames.text,
	            {
	                display: 'inline-block',
	                verticalAlign: 'top'
	            }
	        ],
	        count: [
	            classNames.count,
	            {
	                marginLeft: '4px',
	                display: 'inline-block',
	                verticalAlign: 'top'
	            }
	        ],
	        icon: [
	            classNames.icon,
	            {
	                selectors: {
	                    '& + $text': {
	                        marginLeft: '4px'
	                    }
	                }
	            }
	        ]
	    };
	    var _a, _b, _c;
	};
	//# sourceMappingURL=Pivot.styles.js.map

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(787), exports);
	//# sourceMappingURL=PositioningContainer.js.map

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1125), exports);
	//# sourceMappingURL=ProgressIndicator.js.map

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1126), exports);
	tslib_1.__exportStar(__webpack_require__(1127), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ProgressIndicator_base_1 = __webpack_require__(1127);
	var ProgressIndicator_styles_1 = __webpack_require__(1128);
	/**
	 * ProgressIndicator description
	 */
	exports.ProgressIndicator = Utilities_1.styled(ProgressIndicator_base_1.ProgressIndicatorBase, ProgressIndicator_styles_1.getStyles, undefined, { scope: 'ProgressIndicator' });
	//# sourceMappingURL=ProgressIndicator.js.map

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	// if the percentComplete is near 0, don't animate it.
	// This prevents animations on reset to 0 scenarios
	var ZERO_THRESHOLD = 0.01;
	/**
	 * ProgressIndicator with no default styles.
	 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
	 */
	var ProgressIndicatorBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ProgressIndicatorBase, _super);
	    function ProgressIndicatorBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._onRenderProgress = function (props) {
	            var _a = _this.props, ariaValueText = _a.ariaValueText, barHeight = _a.barHeight, className = _a.className, styles = _a.styles, theme = _a.theme;
	            var percentComplete = typeof _this.props.percentComplete === 'number' ? Math.min(100, Math.max(0, _this.props.percentComplete * 100)) : undefined;
	            var classNames = getClassNames(styles, {
	                theme: theme,
	                className: className,
	                barHeight: barHeight,
	                indeterminate: percentComplete === undefined ? true : false
	            });
	            var progressBarStyles = {
	                width: percentComplete !== undefined ? percentComplete + '%' : undefined,
	                transition: percentComplete !== undefined && percentComplete < ZERO_THRESHOLD ? 'none' : undefined
	            };
	            var ariaValueMin = percentComplete !== undefined ? 0 : undefined;
	            var ariaValueMax = percentComplete !== undefined ? 100 : undefined;
	            var ariaValueNow = percentComplete !== undefined ? Math.floor(percentComplete) : undefined;
	            return (React.createElement("div", { className: classNames.itemProgress },
	                React.createElement("div", { className: classNames.progressTrack }),
	                React.createElement("div", { className: classNames.progressBar, style: progressBarStyles, role: "progressbar", "aria-valuemin": ariaValueMin, "aria-valuemax": ariaValueMax, "aria-valuenow": ariaValueNow, "aria-valuetext": ariaValueText })));
	        };
	        return _this;
	    }
	    ProgressIndicatorBase.prototype.render = function () {
	        var _a = this.props, barHeight = _a.barHeight, className = _a.className, _b = _a.label, label = _b === void 0 ? this.props.title : _b, // Fall back to deprecated value.
	        description = _a.description, styles = _a.styles, theme = _a.theme, progressHidden = _a.progressHidden, _c = _a.onRenderProgress, onRenderProgress = _c === void 0 ? this._onRenderProgress : _c;
	        var percentComplete = typeof this.props.percentComplete === 'number' ? Math.min(100, Math.max(0, this.props.percentComplete * 100)) : undefined;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            barHeight: barHeight,
	            indeterminate: percentComplete === undefined ? true : false
	        });
	        return (React.createElement("div", { className: classNames.root },
	            label ? React.createElement("div", { className: classNames.itemName }, label) : null,
	            !progressHidden
	                ? onRenderProgress(tslib_1.__assign({}, this.props, { percentComplete: percentComplete }), this._onRenderProgress)
	                : null,
	            description ? React.createElement("div", { className: classNames.itemDescription }, description) : null));
	    };
	    ProgressIndicatorBase.defaultProps = {
	        label: '',
	        description: '',
	        width: 180
	    };
	    return ProgressIndicatorBase;
	}(React.Component));
	exports.ProgressIndicatorBase = ProgressIndicatorBase;
	//# sourceMappingURL=ProgressIndicator.base.js.map

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var GlobalClassNames = {
	    root: 'ms-ProgressIndicator',
	    itemName: 'ms-ProgressIndicator-itemName',
	    itemDescription: 'ms-ProgressIndicator-itemDescription',
	    itemProgress: 'ms-ProgressIndicator-itemProgress',
	    progressTrack: 'ms-ProgressIndicator-progressTrack',
	    progressBar: 'ms-ProgressIndicator-progressBar'
	};
	var IndeterminateProgress = Styling_1.keyframes({
	    '0%': {
	        left: '-30%'
	    },
	    '100%': {
	        left: '100%'
	    }
	});
	var IndeterminateProgressRTL = Styling_1.keyframes({
	    '100%': {
	        right: '-30%'
	    },
	    '0%': {
	        right: '100%'
	    }
	});
	exports.getStyles = function (props) {
	    var isRTL = Utilities_1.getRTL();
	    var className = props.className, indeterminate = props.indeterminate, theme = props.theme, _a = props.barHeight, barHeight = _a === void 0 ? 2 : _a;
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var marginBetweenText = 8;
	    var textHeight = 18;
	    var progressTrackColor = palette.neutralLight;
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                fontWeight: Styling_1.FontWeights.regular
	            },
	            className
	        ],
	        itemName: [
	            classNames.itemName,
	            Styling_1.noWrap,
	            {
	                color: semanticColors.bodyText,
	                fontSize: Styling_1.FontSizes.medium,
	                paddingTop: marginBetweenText / 2,
	                lineHeight: textHeight + 2
	            }
	        ],
	        itemDescription: [
	            classNames.itemDescription,
	            {
	                color: semanticColors.bodySubtext,
	                fontSize: Styling_1.FontSizes.xSmall,
	                lineHeight: textHeight
	            }
	        ],
	        itemProgress: [
	            classNames.itemProgress,
	            {
	                position: 'relative',
	                overflow: 'hidden',
	                height: barHeight,
	                padding: marginBetweenText + "px 0"
	            }
	        ],
	        progressTrack: [
	            classNames.progressTrack,
	            {
	                position: 'absolute',
	                width: '100%',
	                height: barHeight,
	                backgroundColor: progressTrackColor,
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        borderBottom: '1px solid WindowText'
	                    },
	                    _b)
	            }
	        ],
	        progressBar: [
	            {
	                backgroundColor: palette.themePrimary,
	                height: barHeight,
	                position: 'absolute',
	                transition: 'width .3s ease',
	                width: 0,
	                selectors: (_c = {},
	                    _c[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'WindowText'
	                    },
	                    _c)
	            },
	            indeterminate
	                ? {
	                    position: 'absolute',
	                    minWidth: '33%',
	                    background: "linear-gradient(to right, " + progressTrackColor + " 0%, " + palette.themePrimary + " 50%, " + progressTrackColor + " 100%)",
	                    animation: (isRTL ? IndeterminateProgressRTL : IndeterminateProgress) + " 3s infinite"
	                }
	                : {
	                    transition: 'width .15s linear'
	                },
	            classNames.progressBar
	        ]
	    };
	    var _b, _c;
	};
	//# sourceMappingURL=ProgressIndicator.styles.js.map

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1130), exports);
	//# sourceMappingURL=Rating.js.map

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1131), exports);
	tslib_1.__exportStar(__webpack_require__(1133), exports);
	tslib_1.__exportStar(__webpack_require__(1134), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Rating_styles_1 = __webpack_require__(1132);
	var Rating_base_1 = __webpack_require__(1133);
	exports.Rating = Utilities_1.styled(Rating_base_1.RatingBase, Rating_styles_1.getStyles, undefined, { scope: 'Rating' });
	//# sourceMappingURL=Rating.js.map

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-RatingStar-root',
	    rootIsSmall: 'ms-RatingStar-root--small',
	    rootIsLarge: 'ms-RatingStar-root--large',
	    ratingStar: 'ms-RatingStar-container',
	    ratingStarBack: 'ms-RatingStar-back',
	    ratingStarFront: 'ms-RatingStar-front',
	    ratingButton: 'ms-Rating-button',
	    ratingStarIsSmall: 'ms-Rating--small',
	    ratingStartIsLarge: 'ms-Rating--large',
	    labelText: 'ms-Rating-labelText',
	    ratingFocusZone: 'ms-Rating-focuszone'
	};
	function _getColorWithHighContrast(color, highContrastColor) {
	    return {
	        color: color,
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                color: highContrastColor
	            },
	            _a)
	    };
	    var _a;
	}
	function getStyles(props) {
	    var disabled = props.disabled, readOnly = props.readOnly, theme = props.theme;
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var ratingSmallIconSize = 16;
	    var ratingLargeIconSize = 20;
	    var ratingVerticalPadding = 8;
	    var ratingHorizontalPadding = 2;
	    var ratingStarUncheckedColor = palette.neutralTertiary;
	    var ratingStarUncheckedHoverColor = palette.themePrimary;
	    var ratingStarUncheckedHoverSelectedColor = palette.themeDark;
	    var ratingStarCheckedColor = semanticColors.bodyTextChecked;
	    var ratingStarDisabledColor = semanticColors.disabledBodySubtext;
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            !disabled &&
	                !readOnly && {
	                selectors: {
	                    // This is part 1 of highlighting all stars up to the one the user is hovering over
	                    '&:hover': {
	                        selectors: {
	                            '.ms-RatingStar-back': _getColorWithHighContrast(ratingStarCheckedColor, 'Highlight')
	                        }
	                    }
	                }
	            }
	        ],
	        rootIsSmall: [
	            classNames.rootIsSmall,
	            {
	                height: ratingSmallIconSize + ratingVerticalPadding * 2 + 'px'
	            }
	        ],
	        rootIsLarge: [
	            classNames.rootIsLarge,
	            {
	                height: ratingLargeIconSize + ratingVerticalPadding * 2 + 'px'
	            }
	        ],
	        ratingStar: [
	            classNames.ratingStar,
	            {
	                display: 'inline-block',
	                position: 'relative',
	                height: 'inherit'
	            }
	        ],
	        ratingStarBack: [
	            classNames.ratingStarBack,
	            {
	                // TODO: Use a proper semantic color for this
	                color: ratingStarUncheckedColor,
	                width: '100%'
	            },
	            disabled && _getColorWithHighContrast(ratingStarDisabledColor, 'GrayText')
	        ],
	        ratingStarFront: [
	            classNames.ratingStarFront,
	            {
	                position: 'absolute',
	                height: '100 %',
	                left: '0',
	                top: '0',
	                textAlign: 'center',
	                verticalAlign: 'middle',
	                overflow: 'hidden'
	            },
	            _getColorWithHighContrast(ratingStarCheckedColor, 'Highlight')
	        ],
	        ratingButton: [
	            Styling_1.getFocusStyle(theme),
	            classNames.ratingButton,
	            {
	                backgroundColor: 'transparent',
	                padding: ratingVerticalPadding + "px " + ratingHorizontalPadding + "px",
	                boxSizing: 'content-box',
	                margin: '0px',
	                border: 'none',
	                cursor: 'pointer',
	                selectors: {
	                    '&:disabled': {
	                        cursor: 'default'
	                    },
	                    '&[disabled]': {
	                        cursor: 'default'
	                    }
	                }
	            },
	            !disabled &&
	                !readOnly && {
	                selectors: {
	                    // This is part 2 of highlighting all stars up to the one the user is hovering over
	                    '&:hover ~ .ms-Rating-button': {
	                        selectors: {
	                            '.ms-RatingStar-back': _getColorWithHighContrast(ratingStarUncheckedColor, 'WindowText'),
	                            '.ms-RatingStar-front': _getColorWithHighContrast(ratingStarUncheckedColor, 'WindowText')
	                        }
	                    },
	                    '&:hover': {
	                        selectors: {
	                            '.ms-RatingStar-back': {
	                                color: ratingStarUncheckedHoverColor
	                            },
	                            '.ms-RatingStar-front': {
	                                color: ratingStarUncheckedHoverSelectedColor
	                            }
	                        }
	                    }
	                }
	            },
	            disabled && {
	                cursor: 'default'
	            }
	        ],
	        ratingStarIsSmall: [
	            classNames.ratingStarIsSmall,
	            {
	                fontSize: ratingSmallIconSize + 'px',
	                lineHeight: ratingSmallIconSize + 'px',
	                height: ratingSmallIconSize + 'px'
	            }
	        ],
	        ratingStarIsLarge: [
	            classNames.ratingStartIsLarge,
	            {
	                fontSize: ratingLargeIconSize + 'px',
	                lineHeight: ratingLargeIconSize + 'px',
	                height: ratingLargeIconSize + 'px'
	            }
	        ],
	        labelText: [classNames.labelText, Styling_1.hiddenContentStyle],
	        ratingFocusZone: [
	            classNames.ratingFocusZone,
	            {
	                display: 'inline-block'
	            }
	        ]
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=Rating.styles.js.map

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Icon_1 = __webpack_require__(643);
	var FocusZone_1 = __webpack_require__(676);
	var Rating_types_1 = __webpack_require__(1134);
	var getClassNames = Utilities_1.classNamesFunction();
	var RatingStar = function (props) {
	    var icon = props.icon || 'FavoriteStarFill';
	    return (React.createElement("div", { className: props.classNames.ratingStar, key: props.id },
	        React.createElement(Icon_1.Icon, { className: props.classNames.ratingStarBack, iconName: icon }),
	        !props.disabled && (React.createElement(Icon_1.Icon, { className: props.classNames.ratingStarFront, iconName: icon, style: { width: props.fillPercentage + '%' } }))));
	};
	var RatingBase = /** @class */ (function (_super) {
	    tslib_1.__extends(RatingBase, _super);
	    function RatingBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._warnDeprecations({
	            onChanged: 'onChange'
	        });
	        _this._id = Utilities_1.getId('Rating');
	        _this._min = _this.props.allowZeroStars ? 0 : 1;
	        if (_this.props.min !== undefined && _this.props.min !== 1) {
	            _this._min = _this.props.min;
	        }
	        _this._labelId = Utilities_1.getId('RatingLabel');
	        _this.state = {
	            rating: _this._getInitialValue(props)
	        };
	        return _this;
	    }
	    RatingBase.prototype.componentWillReceiveProps = function (nextProps) {
	        if (typeof nextProps.rating !== 'undefined' && nextProps.rating !== this.state.rating) {
	            this.setState({
	                rating: this._getClampedRating(nextProps.rating)
	            });
	        }
	    };
	    RatingBase.prototype.render = function () {
	        var id = this._id;
	        var stars = [];
	        var starIds = [];
	        var _a = this.props, disabled = _a.disabled, getAriaLabel = _a.getAriaLabel, styles = _a.styles, max = _a.max, rating = _a.rating, readOnly = _a.readOnly, size = _a.size, theme = _a.theme, _b = _a.icon, icon = _b === void 0 ? 'FavoriteStarFill' : _b, _c = _a.unselectedIcon, unselectedIcon = _c === void 0 ? 'FavoriteStar' : _c;
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        this._classNames = getClassNames(styles, {
	            disabled: disabled,
	            readOnly: readOnly,
	            theme: theme
	        });
	        for (var i = this._min; i <= max; i++) {
	            if (i !== 0) {
	                var fillPercentage = this._getFillingPercentage(i);
	                var ratingStarProps = {
	                    fillPercentage: fillPercentage,
	                    disabled: disabled ? true : false,
	                    readOnly: readOnly ? true : false,
	                    classNames: this._classNames,
	                    icon: fillPercentage > 0 ? icon : unselectedIcon
	                };
	                starIds.push(this._getStarId(i - 1));
	                stars.push(React.createElement("button", tslib_1.__assign({ className: Utilities_1.css(this._classNames.ratingButton, (_d = {},
	                        _d[this._classNames.ratingStarIsLarge] = size === Rating_types_1.RatingSize.Large,
	                        _d[this._classNames.ratingStarIsSmall] = size !== Rating_types_1.RatingSize.Large,
	                        _d)), id: starIds[i - 1], key: i }, (i === Math.ceil(this.state.rating) ? { 'data-is-current': true } : {}), { onFocus: this._onFocus.bind(this, i), onClick: this._onFocus.bind(this, i), disabled: disabled || readOnly ? true : false, role: "presentation", type: "button" }),
	                    this._getLabel(i),
	                    React.createElement(RatingStar, tslib_1.__assign({ key: i + 'rating' }, ratingStarProps))));
	            }
	        }
	        return (React.createElement("div", tslib_1.__assign({ className: Utilities_1.css('ms-Rating-star', this._classNames.root, (_e = {},
	                _e[this._classNames.rootIsLarge] = size === Rating_types_1.RatingSize.Large,
	                _e[this._classNames.rootIsSmall] = size !== Rating_types_1.RatingSize.Large,
	                _e)), "aria-label": getAriaLabel ? getAriaLabel(this.state.rating ? this.state.rating : 0, this.props.max) : '', id: id }, divProps),
	            React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.horizontal, tabIndex: readOnly ? 0 : -1, className: Utilities_1.css(this._classNames.ratingFocusZone, (_f = {},
	                    _f[this._classNames.rootIsLarge] = size === Rating_types_1.RatingSize.Large,
	                    _f[this._classNames.rootIsSmall] = size !== Rating_types_1.RatingSize.Large,
	                    _f)), "data-is-focusable": readOnly ? true : false, defaultActiveElement: rating ? starIds[rating - 1] && '#' + starIds[rating - 1] : undefined }, stars)));
	        var _d, _e, _f;
	    };
	    RatingBase.prototype._getStarId = function (index) {
	        return this._id + '-star-' + index;
	    };
	    RatingBase.prototype._onFocus = function (value, ev) {
	        if (this.state.rating !== value) {
	            this.setState({
	                rating: value
	            });
	            var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged;
	            if (onChange) {
	                onChange(ev, value);
	            }
	            if (onChanged) {
	                onChanged(value);
	            }
	        }
	    };
	    RatingBase.prototype._getLabel = function (rating) {
	        var text = this.props.ariaLabelFormat || '';
	        return (React.createElement("span", { id: this._labelId + "-" + rating, className: this._classNames.labelText }, Utilities_1.format(text, rating, this.props.max)));
	    };
	    RatingBase.prototype._getInitialValue = function (props) {
	        if (typeof props.rating === 'undefined') {
	            return this._min;
	        }
	        if (props.rating === null) {
	            return undefined;
	        }
	        return this._getClampedRating(props.rating);
	    };
	    RatingBase.prototype._getClampedRating = function (rating) {
	        return Math.min(Math.max(rating, this._min), this.props.max);
	    };
	    RatingBase.prototype._getFillingPercentage = function (starPosition) {
	        var ceilValue = Math.ceil(this.state.rating);
	        var fillPercentage = 100;
	        if (starPosition === this.state.rating) {
	            fillPercentage = 100;
	        }
	        else if (starPosition === ceilValue) {
	            fillPercentage = 100 * (this.state.rating % 1);
	        }
	        else if (starPosition > ceilValue) {
	            fillPercentage = 0;
	        }
	        return fillPercentage;
	    };
	    RatingBase.defaultProps = {
	        min: 1,
	        max: 5
	    };
	    return RatingBase;
	}(Utilities_1.BaseComponent));
	exports.RatingBase = RatingBase;
	//# sourceMappingURL=Rating.base.js.map

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory Rating}
	 */
	var RatingSize;
	(function (RatingSize) {
	    RatingSize[RatingSize["Small"] = 0] = "Small";
	    RatingSize[RatingSize["Large"] = 1] = "Large";
	})(RatingSize = exports.RatingSize || (exports.RatingSize = {}));
	//# sourceMappingURL=Rating.types.js.map

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1136), exports);
	//# sourceMappingURL=ScrollablePane.js.map

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1137), exports);
	tslib_1.__exportStar(__webpack_require__(1138), exports);
	tslib_1.__exportStar(__webpack_require__(1140), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ScrollablePane_base_1 = __webpack_require__(1138);
	var ScrollablePane_styles_1 = __webpack_require__(1139);
	exports.ScrollablePane = Utilities_1.styled(ScrollablePane_base_1.ScrollablePaneBase, ScrollablePane_styles_1.getStyles, undefined, { scope: 'ScrollablePane' });
	//# sourceMappingURL=ScrollablePane.js.map

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var PropTypes = __webpack_require__(53);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var ScrollablePaneBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ScrollablePaneBase, _super);
	    function ScrollablePaneBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._stickyAboveRef = React.createRef();
	        _this._stickyBelowRef = React.createRef();
	        _this._contentContainer = React.createRef();
	        _this.subscribe = function (handler) {
	            _this._subscribers.add(handler);
	        };
	        _this.unsubscribe = function (handler) {
	            _this._subscribers.delete(handler);
	        };
	        _this.addSticky = function (sticky) {
	            _this._stickies.add(sticky);
	            // If ScrollablePane is mounted, then sort sticky in correct place
	            if (_this.contentContainer) {
	                sticky.setDistanceFromTop(_this.contentContainer);
	                _this.sortSticky(sticky);
	            }
	        };
	        _this.removeSticky = function (sticky) {
	            _this._stickies.delete(sticky);
	            _this._removeStickyFromContainers(sticky);
	            _this.notifySubscribers();
	        };
	        _this.sortSticky = function (sticky, sortAgain) {
	            if (_this.stickyAbove && _this.stickyBelow) {
	                if (sortAgain) {
	                    _this._removeStickyFromContainers(sticky);
	                }
	                if (sticky.canStickyTop && sticky.stickyContentTop) {
	                    _this._addToStickyContainer(sticky, _this.stickyAbove, sticky.stickyContentTop);
	                }
	                if (sticky.canStickyBottom && sticky.stickyContentBottom) {
	                    _this._addToStickyContainer(sticky, _this.stickyBelow, sticky.stickyContentBottom);
	                }
	            }
	        };
	        _this.updateStickyRefHeights = function () {
	            var stickyItems = _this._stickies;
	            var stickyTopHeight = 0;
	            var stickyBottomHeight = 0;
	            stickyItems.forEach(function (sticky) {
	                var _a = sticky.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
	                if (sticky.nonStickyContent) {
	                    if (isStickyTop) {
	                        stickyTopHeight += sticky.nonStickyContent.offsetHeight;
	                    }
	                    if (isStickyBottom) {
	                        stickyBottomHeight += sticky.nonStickyContent.offsetHeight;
	                    }
	                    _this._checkStickyStatus(sticky);
	                }
	            });
	            _this.setState({
	                stickyTopHeight: stickyTopHeight,
	                stickyBottomHeight: stickyBottomHeight
	            });
	        };
	        _this.notifySubscribers = function () {
	            if (_this.contentContainer) {
	                _this._subscribers.forEach(function (handle) {
	                    // this.stickyBelow is passed in for calculating distance to determine Sticky status
	                    handle(_this.contentContainer, _this.stickyBelow);
	                });
	            }
	        };
	        _this.getScrollPosition = function () {
	            if (_this.contentContainer) {
	                return _this.contentContainer.scrollTop;
	            }
	            return 0;
	        };
	        _this.syncScrollSticky = function (sticky) {
	            if (sticky && _this.contentContainer) {
	                sticky.syncScroll(_this.contentContainer);
	            }
	        };
	        _this._addToStickyContainer = function (sticky, stickyContainer, stickyContentToAdd) {
	            // If there's no children, append child to list, otherwise, sort though array and append at correct position
	            if (!stickyContainer.children.length) {
	                stickyContainer.appendChild(stickyContentToAdd);
	            }
	            else {
	                // If stickyContentToAdd isn't a child element of target container, then append
	                if (!stickyContainer.contains(stickyContentToAdd)) {
	                    var stickyChildrenElements_1 = [].slice.call(stickyContainer.children);
	                    var stickyList_1 = [];
	                    // Get stickies.  Filter by canStickyTop/Bottom, then sort by distance from top, and then
	                    // filter by elements that are in the stickyContainer already.
	                    _this._stickies.forEach(function (stickyItem) {
	                        if (stickyContainer === _this.stickyAbove && sticky.canStickyTop) {
	                            stickyList_1.push(stickyItem);
	                        }
	                        else if (sticky.canStickyBottom) {
	                            stickyList_1.push(stickyItem);
	                        }
	                    });
	                    var stickyListSorted = stickyList_1
	                        .sort(function (a, b) {
	                        return (a.state.distanceFromTop || 0) - (b.state.distanceFromTop || 0);
	                    })
	                        .filter(function (item) {
	                        var stickyContent = stickyContainer === _this.stickyAbove ? item.stickyContentTop : item.stickyContentBottom;
	                        if (stickyContent) {
	                            return stickyChildrenElements_1.indexOf(stickyContent) > -1;
	                        }
	                    });
	                    // Get first element that has a distance from top that is further than our sticky that is being added
	                    var targetStickyToAppendBefore = undefined;
	                    for (var i in stickyListSorted) {
	                        if ((stickyListSorted[i].state.distanceFromTop || 0) >= (sticky.state.distanceFromTop || 0)) {
	                            targetStickyToAppendBefore = stickyListSorted[i];
	                            break;
	                        }
	                    }
	                    // If target element to append before is known, then grab respective stickyContentTop/Bottom element and insert before
	                    var targetContainer = null;
	                    if (targetStickyToAppendBefore) {
	                        targetContainer =
	                            stickyContainer === _this.stickyAbove
	                                ? targetStickyToAppendBefore.stickyContentTop
	                                : targetStickyToAppendBefore.stickyContentBottom;
	                    }
	                    stickyContainer.insertBefore(stickyContentToAdd, targetContainer);
	                }
	            }
	        };
	        _this._removeStickyFromContainers = function (sticky) {
	            if (_this.stickyAbove && sticky.stickyContentTop && _this.stickyAbove.contains(sticky.stickyContentTop)) {
	                _this.stickyAbove.removeChild(sticky.stickyContentTop);
	            }
	            if (_this.stickyBelow && sticky.stickyContentBottom && _this.stickyBelow.contains(sticky.stickyContentBottom)) {
	                _this.stickyBelow.removeChild(sticky.stickyContentBottom);
	            }
	        };
	        _this._onWindowResize = function () {
	            var scrollbarWidth = _this._getScrollbarWidth();
	            var scrollbarHeight = _this._getScrollbarHeight();
	            _this.setState({
	                scrollbarWidth: scrollbarWidth,
	                scrollbarHeight: scrollbarHeight
	            });
	            _this.notifySubscribers();
	        };
	        _this._getStickyContainerStyle = function (height, isTop) {
	            return tslib_1.__assign({ height: height }, (Utilities_1.getRTL()
	                ? {
	                    right: '0',
	                    left: (_this.state.scrollbarWidth || _this._getScrollbarWidth() || 0) + "px"
	                }
	                : {
	                    left: '0',
	                    right: (_this.state.scrollbarWidth || _this._getScrollbarWidth() || 0) + "px"
	                }), (isTop
	                ? {
	                    top: '0'
	                }
	                : {
	                    bottom: (_this.state.scrollbarHeight || _this._getScrollbarHeight() || 0) + "px"
	                }));
	        };
	        _this._onScroll = function () {
	            var contentContainer = _this.contentContainer;
	            if (contentContainer) {
	                _this._stickies.forEach(function (sticky) {
	                    sticky.syncScroll(contentContainer);
	                });
	            }
	            _this._notifyThrottled();
	        };
	        _this._subscribers = new Set();
	        _this._stickies = new Set();
	        _this.state = {
	            stickyTopHeight: 0,
	            stickyBottomHeight: 0,
	            scrollbarWidth: 0,
	            scrollbarHeight: 0
	        };
	        _this._notifyThrottled = _this._async.throttle(_this.notifySubscribers, 50);
	        return _this;
	    }
	    Object.defineProperty(ScrollablePaneBase.prototype, "root", {
	        get: function () {
	            return this._root.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScrollablePaneBase.prototype, "stickyAbove", {
	        get: function () {
	            return this._stickyAboveRef.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScrollablePaneBase.prototype, "stickyBelow", {
	        get: function () {
	            return this._stickyBelowRef.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScrollablePaneBase.prototype, "contentContainer", {
	        get: function () {
	            return this._contentContainer.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScrollablePaneBase.prototype.getChildContext = function () {
	        return {
	            scrollablePane: {
	                subscribe: this.subscribe,
	                unsubscribe: this.unsubscribe,
	                addSticky: this.addSticky,
	                removeSticky: this.removeSticky,
	                updateStickyRefHeights: this.updateStickyRefHeights,
	                sortSticky: this.sortSticky,
	                notifySubscribers: this.notifySubscribers,
	                syncScrollSticky: this.syncScrollSticky
	            }
	        };
	    };
	    ScrollablePaneBase.prototype.componentDidMount = function () {
	        var _this = this;
	        var initialScrollPosition = this.props.initialScrollPosition;
	        this._events.on(this.contentContainer, 'scroll', this._onScroll);
	        this._events.on(window, 'resize', this._onWindowResize);
	        if (this.contentContainer && initialScrollPosition) {
	            this.contentContainer.scrollTop = initialScrollPosition;
	        }
	        // Set sticky distances from top property, then sort in correct order and notify subscribers
	        this.setStickiesDistanceFromTop();
	        this._stickies.forEach(function (sticky) {
	            _this.sortSticky(sticky);
	        });
	        this.notifySubscribers();
	        if ('MutationObserver' in window) {
	            this._mutationObserver = new MutationObserver(function (mutation) {
	                // Function to check if mutation is occuring in stickyAbove or stickyBelow
	                function checkIfMutationIsSticky(mutationRecord) {
	                    if (this.stickyAbove !== null && this.stickyBelow !== null) {
	                        return this.stickyAbove.contains(mutationRecord.target) || this.stickyBelow.contains(mutationRecord.target);
	                    }
	                    return false;
	                }
	                // Compute the scrollbar height which might have changed due to change in width of the content which might cause overflow
	                var scrollbarHeight = _this._getScrollbarHeight();
	                // check if the scroll bar height has changed and update the state so that it's postioned correctly below sticky footer
	                if (scrollbarHeight !== _this.state.scrollbarHeight) {
	                    _this.setState({
	                        scrollbarHeight: scrollbarHeight
	                    });
	                }
	                // Notify subscribers again to re-check whether Sticky should be Sticky'd or not
	                _this.notifySubscribers();
	                // If mutation occurs in sticky header or footer, then update sticky top/bottom heights
	                if (mutation.some(checkIfMutationIsSticky.bind(_this))) {
	                    _this.updateStickyRefHeights();
	                }
	                else {
	                    // If mutation occurs in scrollable region, then find Sticky it belongs to and force update
	                    var stickyList_2 = [];
	                    _this._stickies.forEach(function (sticky) {
	                        if (sticky.root && sticky.root.contains(mutation[0].target)) {
	                            stickyList_2.push(sticky);
	                        }
	                    });
	                    if (stickyList_2.length) {
	                        stickyList_2.forEach(function (sticky) {
	                            sticky.forceUpdate();
	                        });
	                    }
	                }
	            });
	            if (this.root) {
	                this._mutationObserver.observe(this.root, {
	                    childList: true,
	                    attributes: true,
	                    subtree: true,
	                    characterData: true
	                });
	            }
	        }
	    };
	    ScrollablePaneBase.prototype.componentWillUnmount = function () {
	        this._events.off(this.contentContainer);
	        this._events.off(window);
	        if (this._mutationObserver) {
	            this._mutationObserver.disconnect();
	        }
	    };
	    // Only updates if props/state change, just to prevent excessive setState with updateStickyRefHeights
	    ScrollablePaneBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        return (this.props.children !== nextProps.children ||
	            this.props.initialScrollPosition !== nextProps.initialScrollPosition ||
	            this.props.className !== nextProps.className ||
	            this.state.stickyTopHeight !== nextState.stickyTopHeight ||
	            this.state.stickyBottomHeight !== nextState.stickyBottomHeight ||
	            this.state.scrollbarWidth !== nextState.scrollbarWidth ||
	            this.state.scrollbarHeight !== nextState.scrollbarHeight);
	    };
	    ScrollablePaneBase.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var initialScrollPosition = this.props.initialScrollPosition;
	        if (this.contentContainer && typeof initialScrollPosition === 'number' && prevProps.initialScrollPosition !== initialScrollPosition) {
	            this.contentContainer.scrollTop = initialScrollPosition;
	        }
	        // Update subscribers when stickyTopHeight/stickyBottomHeight changes
	        if (prevState.stickyTopHeight !== this.state.stickyTopHeight || prevState.stickyBottomHeight !== this.state.stickyBottomHeight) {
	            this.notifySubscribers();
	        }
	        this._async.setTimeout(this._onWindowResize, 0);
	    };
	    ScrollablePaneBase.prototype.render = function () {
	        var _a = this.props, className = _a.className, theme = _a.theme, styles = _a.styles;
	        var _b = this.state, stickyTopHeight = _b.stickyTopHeight, stickyBottomHeight = _b.stickyBottomHeight;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            scrollbarVisibility: this.props.scrollbarVisibility
	        });
	        return (React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { ref: this._root, className: classNames.root }),
	            React.createElement("div", { ref: this._contentContainer, className: classNames.contentContainer, "data-is-scrollable": true }, this.props.children),
	            React.createElement("div", { ref: this._stickyAboveRef, className: classNames.stickyAbove, style: this._getStickyContainerStyle(stickyTopHeight, true) }),
	            React.createElement("div", { className: classNames.stickyBelow, style: this._getStickyContainerStyle(stickyBottomHeight, false) },
	                React.createElement("div", { ref: this._stickyBelowRef, className: classNames.stickyBelowItems }))));
	    };
	    ScrollablePaneBase.prototype.setStickiesDistanceFromTop = function () {
	        var _this = this;
	        if (this.contentContainer) {
	            this._stickies.forEach(function (sticky) {
	                sticky.setDistanceFromTop(_this.contentContainer);
	            });
	        }
	    };
	    ScrollablePaneBase.prototype.forceLayoutUpdate = function () {
	        this._onWindowResize();
	    };
	    ScrollablePaneBase.prototype._checkStickyStatus = function (sticky) {
	        if (this.stickyAbove && this.stickyBelow && this.contentContainer && sticky.nonStickyContent) {
	            // If sticky is sticky, then append content to appropriate container
	            if (sticky.state.isStickyTop || sticky.state.isStickyBottom) {
	                if (sticky.state.isStickyTop && !this.stickyAbove.contains(sticky.nonStickyContent) && sticky.stickyContentTop) {
	                    sticky.addSticky(sticky.stickyContentTop);
	                }
	                if (sticky.state.isStickyBottom && !this.stickyBelow.contains(sticky.nonStickyContent) && sticky.stickyContentBottom) {
	                    sticky.addSticky(sticky.stickyContentBottom);
	                }
	            }
	            else if (!this.contentContainer.contains(sticky.nonStickyContent)) {
	                // Reset sticky if it's not sticky and not in the contentContainer element
	                sticky.resetSticky();
	            }
	        }
	    };
	    ScrollablePaneBase.prototype._getScrollbarWidth = function () {
	        var contentContainer = this.contentContainer;
	        return contentContainer ? contentContainer.offsetWidth - contentContainer.clientWidth : 0;
	    };
	    ScrollablePaneBase.prototype._getScrollbarHeight = function () {
	        var contentContainer = this.contentContainer;
	        return contentContainer ? contentContainer.offsetHeight - contentContainer.clientHeight : 0;
	    };
	    ScrollablePaneBase.childContextTypes = {
	        scrollablePane: PropTypes.object
	    };
	    return ScrollablePaneBase;
	}(Utilities_1.BaseComponent));
	exports.ScrollablePaneBase = ScrollablePaneBase;
	//# sourceMappingURL=ScrollablePane.base.js.map

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ScrollablePane',
	    contentContainer: 'ms-ScrollablePane--contentContainer'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var AboveAndBelowStyles = {
	        position: 'absolute',
	        pointerEvents: 'auto'
	    };
	    var positioningStyle = {
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0,
	        WebkitOverflowScrolling: 'touch'
	    };
	    return {
	        root: [classNames.root, theme.fonts.medium, positioningStyle, className],
	        contentContainer: [
	            classNames.contentContainer,
	            {
	                overflowY: props.scrollbarVisibility === 'always' ? 'scroll' : 'auto'
	            },
	            positioningStyle
	        ],
	        stickyAbove: [
	            {
	                top: 0,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderBottom: '1px solid WindowText'
	                    },
	                    _a)
	            },
	            AboveAndBelowStyles
	        ],
	        stickyBelow: [
	            {
	                bottom: 0,
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        borderTop: '1px solid WindowText'
	                    },
	                    _b)
	            },
	            AboveAndBelowStyles
	        ],
	        stickyBelowItems: [
	            {
	                bottom: 0
	            },
	            AboveAndBelowStyles,
	            {
	                width: '100%'
	            }
	        ]
	    };
	    var _a, _b;
	};
	//# sourceMappingURL=ScrollablePane.styles.js.map

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * {@docCategory ScrollablePane}
	 */
	exports.ScrollbarVisibility = {
	    auto: 'auto',
	    always: 'always'
	};
	//# sourceMappingURL=ScrollablePane.types.js.map

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1142), exports);
	//# sourceMappingURL=SearchBox.js.map

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1143), exports);
	tslib_1.__exportStar(__webpack_require__(1144), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var SearchBox_base_1 = __webpack_require__(1144);
	var SearchBox_styles_1 = __webpack_require__(1145);
	exports.SearchBox = Utilities_1.styled(SearchBox_base_1.SearchBoxBase, SearchBox_styles_1.getStyles, undefined, { scope: 'SearchBox' });
	//# sourceMappingURL=SearchBox.js.map

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var Icon_1 = __webpack_require__(643);
	var getClassNames = Utilities_1.classNamesFunction();
	var SearchBoxBase = /** @class */ (function (_super) {
	    tslib_1.__extends(SearchBoxBase, _super);
	    function SearchBoxBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._rootElement = React.createRef();
	        _this._inputElement = React.createRef();
	        _this._onClickFocus = function () {
	            var inputElement = _this._inputElement.current;
	            if (inputElement) {
	                _this.focus();
	                inputElement.selectionStart = inputElement.selectionEnd = 0;
	            }
	        };
	        _this._onFocusCapture = function (ev) {
	            _this.setState({
	                hasFocus: true
	            });
	            _this._events.on(ev.currentTarget, 'blur', _this._onBlur, true);
	            if (_this.props.onFocus) {
	                _this.props.onFocus(ev);
	            }
	        };
	        _this._onClearClick = function (ev) {
	            var clearButtonProps = _this.props.clearButtonProps;
	            if (clearButtonProps && clearButtonProps.onClick) {
	                clearButtonProps.onClick(ev);
	            }
	            if (!ev.defaultPrevented) {
	                _this._onClear(ev);
	            }
	        };
	        _this._onKeyDown = function (ev) {
	            switch (ev.which) {
	                case Utilities_1.KeyCodes.escape:
	                    _this.props.onEscape && _this.props.onEscape(ev);
	                    if (!ev.defaultPrevented) {
	                        _this._onClear(ev);
	                    }
	                    break;
	                case Utilities_1.KeyCodes.enter:
	                    if (_this.props.onSearch) {
	                        _this.props.onSearch(_this.state.value);
	                        break;
	                    }
	                    // if we don't handle the enter press then we shouldn't prevent default
	                    return;
	                default:
	                    _this.props.onKeyDown && _this.props.onKeyDown(ev);
	                    if (!ev.defaultPrevented) {
	                        return;
	                    }
	            }
	            // We only get here if the keypress has been handled,
	            // or preventDefault was called in case of default keyDown handler
	            ev.preventDefault();
	            ev.stopPropagation();
	        };
	        _this._onBlur = function (ev) {
	            _this._events.off(_this._rootElement.current, 'blur');
	            _this.setState({
	                hasFocus: false
	            });
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	        };
	        _this._onInputChange = function (ev) {
	            var value = ev.target.value;
	            if (value === _this._latestValue) {
	                return;
	            }
	            _this._latestValue = value;
	            _this.setState({ value: value });
	            _this._callOnChange(value);
	        };
	        _this._warnDeprecations({
	            labelText: 'placeholder',
	            defaultValue: 'value'
	        });
	        _this._latestValue = props.value || '';
	        _this.state = {
	            value: _this._latestValue,
	            hasFocus: false,
	            id: Utilities_1.getId('SearchBox')
	        };
	        return _this;
	    }
	    SearchBoxBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.value !== undefined) {
	            this._latestValue = newProps.value;
	            // If the user passes in null, substitute an empty string
	            // (passing null is not allowed per typings, but users might do it anyway)
	            this.setState({
	                value: newProps.value || ''
	            });
	        }
	    };
	    SearchBoxBase.prototype.render = function () {
	        var _a = this.props, ariaLabel = _a.ariaLabel, placeholder = _a.placeholder, className = _a.className, disabled = _a.disabled, underlined = _a.underlined, styles = _a.styles, labelText = _a.labelText, theme = _a.theme, clearButtonProps = _a.clearButtonProps, disableAnimation = _a.disableAnimation, iconProps = _a.iconProps;
	        var _b = this.state, value = _b.value, hasFocus = _b.hasFocus, id = _b.id;
	        var placeholderValue = labelText === undefined ? placeholder : labelText;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            underlined: underlined,
	            hasFocus: hasFocus,
	            disabled: disabled,
	            hasInput: value.length > 0,
	            disableAnimation: disableAnimation
	        });
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['id', 'className', 'placeholder', 'onFocus', 'onBlur', 'value']);
	        return (React.createElement("div", { ref: this._rootElement, className: classNames.root, onFocusCapture: this._onFocusCapture },
	            React.createElement("div", { className: classNames.iconContainer, onClick: this._onClickFocus, "aria-hidden": true },
	                React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: "Search" }, iconProps, { className: classNames.icon }))),
	            React.createElement("input", tslib_1.__assign({}, nativeProps, { id: id, className: classNames.field, placeholder: placeholderValue, onChange: this._onInputChange, onInput: this._onInputChange, onKeyDown: this._onKeyDown, value: value, disabled: disabled, "aria-label": ariaLabel ? ariaLabel : placeholder, ref: this._inputElement })),
	            value.length > 0 && (React.createElement("div", { className: classNames.clearButton },
	                React.createElement(Button_1.IconButton, tslib_1.__assign({ styles: { root: { height: 'auto' }, icon: { fontSize: '12px' } }, iconProps: { iconName: 'Clear' } }, clearButtonProps, { onClick: this._onClearClick }))))));
	    };
	    /**
	     * Sets focus to the search box input field
	     */
	    SearchBoxBase.prototype.focus = function () {
	        if (this._inputElement.current) {
	            this._inputElement.current.focus();
	        }
	    };
	    /**
	     * Returns whether or not the SearchBox has focus
	     */
	    SearchBoxBase.prototype.hasFocus = function () {
	        return !!this.state.hasFocus;
	    };
	    SearchBoxBase.prototype._onClear = function (ev) {
	        this.props.onClear && this.props.onClear(ev);
	        if (!ev.defaultPrevented) {
	            this._latestValue = '';
	            this.setState({
	                value: ''
	            });
	            this._callOnChange('');
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.focus();
	        }
	    };
	    SearchBoxBase.prototype._callOnChange = function (newValue) {
	        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged;
	        // Call @deprecated method.
	        if (onChanged) {
	            onChanged(newValue);
	        }
	        if (onChange) {
	            onChange(newValue);
	        }
	    };
	    SearchBoxBase.defaultProps = {
	        disableAnimation: false,
	        clearButtonProps: { ariaLabel: 'Clear text' }
	    };
	    return SearchBoxBase;
	}(Utilities_1.BaseComponent));
	exports.SearchBoxBase = SearchBoxBase;
	//# sourceMappingURL=SearchBox.base.js.map

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var styling_1 = __webpack_require__(467);
	function getStyles(props) {
	    var theme = props.theme, underlined = props.underlined, disabled = props.disabled, hasFocus = props.hasFocus, className = props.className, hasInput = props.hasInput, disableAnimation = props.disableAnimation;
	    var palette = theme.palette, fonts = theme.fonts, semanticColors = theme.semanticColors;
	    // placeholder style constants
	    var placeholderStyles = {
	        color: semanticColors.inputPlaceholderText,
	        opacity: 1
	    };
	    return {
	        root: [
	            'ms-SearchBox',
	            fonts.medium,
	            Styling_1.normalize,
	            {
	                color: palette.neutralPrimary,
	                backgroundColor: semanticColors.inputBackground,
	                display: 'flex',
	                flexDirection: 'row',
	                flexWrap: 'nowrap',
	                alignItems: 'stretch',
	                // The 1px top and bottom padding ensure the input field does not overlap the border
	                padding: '1px 0 1px 4px',
	                border: "1px solid " + palette.neutralTertiary,
	                height: 32,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText'
	                    },
	                    _a[':hover'] = {
	                        borderColor: palette.neutralDark,
	                        selectors: (_b = {},
	                            _b[Styling_1.HighContrastSelector] = {
	                                borderColor: 'Highlight'
	                            },
	                            _b)
	                    },
	                    _a[':hover $iconContainer'] = {
	                        color: palette.themeDark
	                    },
	                    _a)
	            },
	            hasFocus && [
	                'is-active',
	                {
	                    borderColor: palette.themePrimary,
	                    selectors: (_c = {
	                            ':hover': {
	                                borderColor: palette.themePrimary
	                            }
	                        },
	                        _c[Styling_1.HighContrastSelector] = {
	                            borderColor: 'Highlight'
	                        },
	                        _c)
	                }
	            ],
	            disabled && [
	                'is-disabled',
	                {
	                    borderColor: palette.neutralLighter,
	                    backgroundColor: palette.neutralLighter,
	                    pointerEvents: 'none',
	                    cursor: 'default'
	                }
	            ],
	            underlined && [
	                'is-underlined',
	                {
	                    borderWidth: '0 0 1px 0',
	                    // Underlined SearchBox has a larger padding left to vertically align with the waffle in product
	                    padding: '1px 0 1px 8px'
	                }
	            ],
	            underlined &&
	                disabled && {
	                backgroundColor: 'transparent'
	            },
	            hasInput && 'can-clear',
	            className
	        ],
	        iconContainer: [
	            'ms-SearchBox-iconContainer',
	            {
	                display: 'flex',
	                flexDirection: 'column',
	                justifyContent: 'center',
	                flexShrink: 0,
	                fontSize: 16,
	                width: 32,
	                textAlign: 'center',
	                color: palette.themePrimary,
	                cursor: 'text'
	            },
	            hasFocus && {
	                width: 4
	            },
	            disabled && {
	                color: palette.neutralTertiary
	            },
	            !disableAnimation && {
	                transition: "width " + Styling_1.AnimationVariables.durationValue1
	            }
	        ],
	        icon: [
	            'ms-SearchBox-icon',
	            {
	                opacity: 1
	            },
	            hasFocus && {
	                opacity: 0
	            },
	            !disableAnimation && {
	                transition: "opacity " + Styling_1.AnimationVariables.durationValue1 + " 0s"
	            }
	        ],
	        clearButton: [
	            'ms-SearchBox-clearButton',
	            {
	                display: 'flex',
	                flexDirection: 'row',
	                alignItems: 'stretch',
	                cursor: 'pointer',
	                flexBasis: '32px',
	                flexShrink: 0,
	                padding: 1,
	                color: palette.themePrimary
	            }
	        ],
	        field: [
	            'ms-SearchBox-field',
	            Styling_1.normalize,
	            styling_1.getPlaceholderStyles(placeholderStyles),
	            {
	                backgroundColor: 'transparent',
	                border: 'none',
	                outline: 'none',
	                fontWeight: 'inherit',
	                fontFamily: 'inherit',
	                fontSize: 'inherit',
	                color: palette.neutralPrimary,
	                flex: '1 1 0px',
	                // The default implicit value of 'auto' prevents the input from shrinking. Setting min-width to
	                // 0px allows the input element to shrink to fit the container.
	                minWidth: '0px',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis',
	                // This padding forces the text placement to round up.
	                paddingBottom: 0.5,
	                // This removes the IE specific clear button in the input since we implimented our own
	                selectors: {
	                    '::-ms-clear': {
	                        display: 'none'
	                    }
	                }
	            },
	            disabled && {
	                color: palette.neutralTertiary
	            }
	        ]
	    };
	    var _a, _b, _c;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=SearchBox.styles.js.map

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(842), exports);
	//# sourceMappingURL=SelectableOption.js.map

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1148), exports);
	//# sourceMappingURL=SelectedItemsList.js.map

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1149), exports);
	tslib_1.__exportStar(__webpack_require__(1150), exports);
	tslib_1.__exportStar(__webpack_require__(1151), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Utilities_1 = __webpack_require__(592);
	var Selection_1 = __webpack_require__(990);
	var BaseSelectedItemsList = /** @class */ (function (_super) {
	    tslib_1.__extends(BaseSelectedItemsList, _super);
	    function BaseSelectedItemsList(basePickerProps) {
	        var _this = _super.call(this, basePickerProps) || this;
	        _this.addItems = function (items) {
	            // tslint:disable-next-line:no-any
	            var processedItems = _this.props.onItemSelected ? _this.props.onItemSelected(items) : items;
	            var processedItemObjects = processedItems;
	            var processedItemPromiseLikes = processedItems;
	            if (processedItemPromiseLikes && processedItemPromiseLikes.then) {
	                processedItemPromiseLikes.then(function (resolvedProcessedItems) {
	                    var newItems = _this.state.items.concat(resolvedProcessedItems);
	                    _this.updateItems(newItems);
	                });
	            }
	            else {
	                var newItems = _this.state.items.concat(processedItemObjects);
	                _this.updateItems(newItems);
	            }
	        };
	        _this.removeItemAt = function (index) {
	            var items = _this.state.items;
	            if (_this._canRemoveItem(items[index])) {
	                if (index > -1) {
	                    if (_this.props.onItemsDeleted) {
	                        _this.props.onItemsDeleted([items[index]]);
	                    }
	                    var newItems = items.slice(0, index).concat(items.slice(index + 1));
	                    _this.updateItems(newItems);
	                }
	            }
	        };
	        _this.removeItem = function (item) {
	            var items = _this.state.items;
	            var index = items.indexOf(item);
	            _this.removeItemAt(index);
	        };
	        _this.replaceItem = function (itemToReplace, itemsToReplaceWith) {
	            var items = _this.state.items;
	            var index = items.indexOf(itemToReplace);
	            if (index > -1) {
	                var newItems = items
	                    .slice(0, index)
	                    .concat(itemsToReplaceWith)
	                    .concat(items.slice(index + 1));
	                _this.updateItems(newItems);
	            }
	        };
	        // tslint:disable-next-line:no-any
	        _this.removeItems = function (itemsToRemove) {
	            var items = _this.state.items;
	            var itemsCanRemove = itemsToRemove.filter(function (item) { return _this._canRemoveItem(item); });
	            // tslint:disable-next-line:no-any
	            var newItems = items.filter(function (item) { return itemsCanRemove.indexOf(item) === -1; });
	            var firstItemToRemove = itemsCanRemove[0];
	            var index = items.indexOf(firstItemToRemove);
	            if (_this.props.onItemsDeleted) {
	                _this.props.onItemsDeleted(itemsCanRemove);
	            }
	            _this.updateItems(newItems, index);
	        };
	        _this.onCopy = function (ev) {
	            if (_this.props.onCopyItems && _this.selection.getSelectedCount() > 0) {
	                var selectedItems = _this.selection.getSelection();
	                _this.copyItems(selectedItems);
	            }
	        };
	        _this.renderItems = function () {
	            var removeButtonAriaLabel = _this.props.removeButtonAriaLabel;
	            var onRenderItem = _this.props.onRenderItem;
	            var items = _this.state.items;
	            // tslint:disable-next-line:no-any
	            return items.map(function (item, index) {
	                return onRenderItem({
	                    item: item,
	                    index: index,
	                    key: item.key ? item.key : index,
	                    selected: _this.selection.isIndexSelected(index),
	                    onRemoveItem: function () { return _this.removeItem(item); },
	                    onItemChange: _this.onItemChange,
	                    removeButtonAriaLabel: removeButtonAriaLabel,
	                    onCopyItem: function (itemToCopy) { return _this.copyItems([itemToCopy]); }
	                });
	            });
	        };
	        _this.onSelectionChanged = function () {
	            _this.forceUpdate();
	        };
	        _this.onItemChange = function (changedItem, index) {
	            var items = _this.state.items;
	            if (index >= 0) {
	                var newItems = items;
	                newItems[index] = changedItem;
	                _this.updateItems(newItems);
	            }
	        };
	        var items = basePickerProps.selectedItems || basePickerProps.defaultSelectedItems || [];
	        _this.state = {
	            items: items
	        };
	        // Create a new selection if one is not specified
	        _this.selection = _this.props.selection
	            ? _this.props.selection
	            : new Selection_1.Selection({ onSelectionChanged: _this.onSelectionChanged });
	        return _this;
	    }
	    Object.defineProperty(BaseSelectedItemsList.prototype, "items", {
	        get: function () {
	            return this.state.items;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseSelectedItemsList.prototype.removeSelectedItems = function () {
	        if (this.state.items.length && this.selection.getSelectedCount() > 0) {
	            this.removeItems(this.selection.getSelection());
	        }
	    };
	    /**
	     * Controls what happens whenever there is an action that impacts the selected items.
	     * If selectedItems is provided as a property then this will act as a controlled component and it will not update it's own state.
	     */
	    BaseSelectedItemsList.prototype.updateItems = function (items, focusIndex) {
	        var _this = this;
	        if (this.props.selectedItems) {
	            // If the component is a controlled component then the controlling component will need to pass the new props
	            this.onChange(items);
	        }
	        else {
	            this.setState({ items: items }, function () {
	                _this._onSelectedItemsUpdated(items, focusIndex);
	            });
	        }
	    };
	    BaseSelectedItemsList.prototype.hasSelectedItems = function () {
	        return this.selection.getSelectedCount() > 0;
	    };
	    BaseSelectedItemsList.prototype.unselectAll = function () {
	        this.selection.setAllSelected(false);
	    };
	    BaseSelectedItemsList.prototype.highlightedItems = function () {
	        return this.selection.getSelection();
	    };
	    BaseSelectedItemsList.prototype.componentWillUpdate = function (newProps, newState) {
	        if (newState.items && newState.items !== this.state.items) {
	            this.selection.setItems(newState.items);
	        }
	    };
	    BaseSelectedItemsList.prototype.componentDidMount = function () {
	        this.selection.setItems(this.state.items);
	    };
	    BaseSelectedItemsList.prototype.componentWillReceiveProps = function (newProps) {
	        var newItems = newProps.selectedItems;
	        if (newItems) {
	            this.setState({ items: newItems });
	        }
	        if (newProps.selection) {
	            this.selection = newProps.selection;
	        }
	    };
	    // tslint:disable-next-line:no-any
	    BaseSelectedItemsList.prototype.render = function () {
	        return this.renderItems();
	    };
	    BaseSelectedItemsList.prototype.onChange = function (items) {
	        if (this.props.onChange) {
	            this.props.onChange(items);
	        }
	    };
	    BaseSelectedItemsList.prototype.copyItems = function (items) {
	        if (this.props.onCopyItems) {
	            // tslint:disable-next-line:no-any
	            var copyText = this.props.onCopyItems(items);
	            var copyInput = document.createElement('input');
	            document.body.appendChild(copyInput);
	            try {
	                // Try to copy the text directly to the clipboard
	                copyInput.value = copyText;
	                copyInput.select();
	                if (!document.execCommand('copy')) {
	                    // The command failed. Fallback to the method below.
	                    throw new Error();
	                }
	            }
	            catch (err) {
	                // no op
	            }
	            finally {
	                document.body.removeChild(copyInput);
	            }
	        }
	    };
	    BaseSelectedItemsList.prototype._onSelectedItemsUpdated = function (items, focusIndex) {
	        this.onChange(items);
	    };
	    BaseSelectedItemsList.prototype._canRemoveItem = function (item) {
	        return !this.props.canRemoveItem || this.props.canRemoveItem(item);
	    };
	    return BaseSelectedItemsList;
	}(Utilities_1.BaseComponent));
	exports.BaseSelectedItemsList = BaseSelectedItemsList;
	//# sourceMappingURL=BaseSelectedItemsList.js.map

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var BaseSelectedItemsList_1 = __webpack_require__(1149);
	var ExtendedSelectedItem_1 = __webpack_require__(1151);
	var SelectedItemWithContextMenu_1 = __webpack_require__(1153);
	var EditingItem_1 = __webpack_require__(1154);
	/**
	 * {@docCategory SelectedPeopleList}
	 */
	var BasePeopleSelectedItemsList = /** @class */ (function (_super) {
	    tslib_1.__extends(BasePeopleSelectedItemsList, _super);
	    function BasePeopleSelectedItemsList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return BasePeopleSelectedItemsList;
	}(BaseSelectedItemsList_1.BaseSelectedItemsList));
	exports.BasePeopleSelectedItemsList = BasePeopleSelectedItemsList;
	/**
	 * Standard People Picker.
	 */
	var SelectedPeopleList = /** @class */ (function (_super) {
	    tslib_1.__extends(SelectedPeopleList, _super);
	    function SelectedPeopleList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.renderItems = function () {
	            var items = _this.state.items;
	            // tslint:disable-next-line:no-any
	            return items.map(function (item, index) { return _this._renderItem(item, index); });
	        };
	        _this._beginEditing = function (item) {
	            item.isEditing = true;
	            _this.forceUpdate();
	        };
	        // tslint:disable-next-line:no-any
	        _this._completeEditing = function (oldItem, newItem) {
	            oldItem.isEditing = false;
	            _this.replaceItem(oldItem, newItem);
	        };
	        return _this;
	    }
	    // tslint:disable-next-line:no-any
	    SelectedPeopleList.prototype._renderItem = function (item, index) {
	        var _this = this;
	        var removeButtonAriaLabel = this.props.removeButtonAriaLabel;
	        var expandGroup = this.props.onExpandGroup;
	        var props = {
	            item: item,
	            index: index,
	            key: item.key ? item.key : index,
	            selected: this.selection.isIndexSelected(index),
	            onRemoveItem: function () { return _this.removeItem(item); },
	            onItemChange: this.onItemChange,
	            removeButtonAriaLabel: removeButtonAriaLabel,
	            onCopyItem: function (itemToCopy) { return _this.copyItems([itemToCopy]); },
	            onExpandItem: expandGroup ? function () { return expandGroup(item); } : undefined,
	            menuItems: this._createMenuItems(item)
	        };
	        var hasContextMenu = props.menuItems.length > 0;
	        if (item.isEditing && hasContextMenu) {
	            return (React.createElement(EditingItem_1.EditingItem, tslib_1.__assign({}, props, { onRenderFloatingPicker: this.props.onRenderFloatingPicker, floatingPickerProps: this.props.floatingPickerProps, onEditingComplete: this._completeEditing, getEditingItemText: this.props.getEditingItemText })));
	        }
	        else {
	            // This cast is here because we are guaranteed that onRenderItem is set
	            // from static defaultProps
	            // TODO: Move this component to composition with required onRenderItem to remove
	            // this cast.
	            var onRenderItem = this.props.onRenderItem;
	            var renderedItem = onRenderItem(props);
	            return hasContextMenu ? (React.createElement(SelectedItemWithContextMenu_1.SelectedItemWithContextMenu, { key: props.key, renderedItem: renderedItem, beginEditing: this._beginEditing, menuItems: this._createMenuItems(props.item), item: props.item })) : (renderedItem);
	        }
	    };
	    // tslint:disable-next-line:no-any
	    SelectedPeopleList.prototype._createMenuItems = function (item) {
	        var _this = this;
	        var menuItems = [];
	        if (this.props.editMenuItemText && this.props.getEditingItemText) {
	            menuItems.push({
	                key: 'Edit',
	                text: this.props.editMenuItemText,
	                onClick: function (ev, menuItem) {
	                    _this._beginEditing(menuItem.data);
	                },
	                data: item
	            });
	        }
	        if (this.props.removeMenuItemText) {
	            menuItems.push({
	                key: 'Remove',
	                text: this.props.removeMenuItemText,
	                onClick: function (ev, menuItem) {
	                    _this.removeItem(menuItem.data);
	                },
	                data: item
	            });
	        }
	        if (this.props.copyMenuItemText) {
	            menuItems.push({
	                key: 'Copy',
	                text: this.props.copyMenuItemText,
	                onClick: function (ev, menuItem) {
	                    if (_this.props.onCopyItems) {
	                        _this.copyItems([menuItem.data]);
	                    }
	                },
	                data: item
	            });
	        }
	        return menuItems;
	    };
	    // tslint:disable-next-line:no-any
	    SelectedPeopleList.defaultProps = {
	        onRenderItem: function (props) { return React.createElement(ExtendedSelectedItem_1.ExtendedSelectedItem, tslib_1.__assign({}, props)); }
	    };
	    return SelectedPeopleList;
	}(BasePeopleSelectedItemsList));
	exports.SelectedPeopleList = SelectedPeopleList;
	//# sourceMappingURL=SelectedPeopleList.js.map

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var Utilities_1 = __webpack_require__(592);
	var Persona_1 = __webpack_require__(594);
	var Button_1 = __webpack_require__(691);
	var stylesImport = __webpack_require__(1152);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	var ExtendedSelectedItem = /** @class */ (function (_super) {
	    tslib_1.__extends(ExtendedSelectedItem, _super);
	    function ExtendedSelectedItem(props) {
	        var _this = _super.call(this, props) || this;
	        _this.persona = React.createRef();
	        _this.state = { contextualMenuVisible: false };
	        return _this;
	    }
	    ExtendedSelectedItem.prototype.render = function () {
	        var _a = this.props, item = _a.item, onExpandItem = _a.onExpandItem, onRemoveItem = _a.onRemoveItem, removeButtonAriaLabel = _a.removeButtonAriaLabel, index = _a.index, selected = _a.selected;
	        var itemId = Utilities_1.getId();
	        return (React.createElement("div", { ref: this.persona, className: Utilities_1.css('ms-PickerPersona-container', styles.personaContainer, (_b = {}, _b['is-selected ' + styles.personaContainerIsSelected] = selected, _b), (_c = {}, _c['is-invalid ' + styles.validationError] = !item.isValid, _c)), "data-is-focusable": true, "data-is-sub-focuszone": true, "data-selection-index": index, role: 'listitem', "aria-labelledby": 'selectedItemPersona-' + itemId },
	            React.createElement("div", { hidden: !item.canExpand || onExpandItem === undefined },
	                React.createElement(Button_1.IconButton, { onClick: this._onClickIconButton(onExpandItem), iconProps: { iconName: 'Add', style: { fontSize: '14px' } }, className: Utilities_1.css('ms-PickerItem-removeButton', styles.expandButton, styles.actionButton), ariaLabel: removeButtonAriaLabel })),
	            React.createElement("div", { className: Utilities_1.css(styles.personaWrapper) },
	                React.createElement("div", { className: Utilities_1.css('ms-PickerItem-content', styles.itemContent), id: 'selectedItemPersona-' + itemId },
	                    React.createElement(Persona_1.Persona, tslib_1.__assign({}, item, { onRenderCoin: this.props.renderPersonaCoin, onRenderPrimaryText: this.props.renderPrimaryText, size: Persona_1.PersonaSize.size32 }))),
	                React.createElement(Button_1.IconButton, { onClick: this._onClickIconButton(onRemoveItem), iconProps: { iconName: 'Cancel', style: { fontSize: '14px' } }, className: Utilities_1.css('ms-PickerItem-removeButton', styles.removeButton, styles.actionButton), ariaLabel: removeButtonAriaLabel }))));
	        var _b, _c;
	    };
	    ExtendedSelectedItem.prototype._onClickIconButton = function (action) {
	        return function (ev) {
	            ev.stopPropagation();
	            ev.preventDefault();
	            if (action) {
	                action();
	            }
	        };
	    };
	    return ExtendedSelectedItem;
	}(Utilities_1.BaseComponent));
	exports.ExtendedSelectedItem = ExtendedSelectedItem;
	//# sourceMappingURL=ExtendedSelectedItem.js.map

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".personaContainer_59642838{border-radius:15px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:" }, { "theme": "themeLighterAlt", "defaultValue": "#eff6fc" }, { "rawString": ";margin:4px;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;position:relative}.personaContainer_59642838::-moz-focus-inner{border:0}.personaContainer_59642838{outline:transparent}.personaContainer_59642838{position:relative}.ms-Fabric--isFocusVisible .personaContainer_59642838:focus:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:1px solid " }, { "theme": "focusBorder", "defaultValue": "#666666" }, { "rawString": "}.personaContainer_59642838 .ms-Persona-primaryText{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": ";font-size:14px;font-weight:400}.personaContainer_59642838 .ms-Persona-primaryText.hover_59642838{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838 .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838 .actionButton_59642838:hover{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.personaContainer_59642838 .actionButton_59642838 .ms-Button-icon{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838 .actionButton_59642838 .ms-Button-icon{color:HighlightText}}.personaContainer_59642838:hover{background:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.personaContainer_59642838:hover .ms-Persona-primaryText{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": ";font-size:14px;font-weight:400}@media screen and (-ms-high-contrast: active){.personaContainer_59642838:hover .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838.personaContainerIsSelected_59642838{background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .ms-Persona-primaryText{color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838 .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838{color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon:hover{background:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon{color:HighlightText}}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838{border-color:Highlight;background:Highlight;-ms-high-contrast-adjust:none}}.personaContainer_59642838.validationError_59642838 .ms-Persona-primaryText{color:" }, { "theme": "red", "defaultValue": "#e81123" }, { "rawString": "}.personaContainer_59642838.validationError_59642838 .ms-Persona-initials{font-size:20px}@media screen and (-ms-high-contrast: active){.personaContainer_59642838{border:1px solid WindowText}}.personaContainer_59642838 .itemContent_59642838{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;min-width:0px;max-width:100%}.personaContainer_59642838 .removeButton_59642838{border-radius:15px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:33px;height:33px;-ms-flex-preferred-size:32px;flex-basis:32px}.personaContainer_59642838 .expandButton_59642838{border-radius:15px 0px 0px 15px;height:33px;width:44px;padding-right:16px;position:inherit;display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:-17px}.personaContainer_59642838 .personaWrapper_59642838{position:relative;display:inherit}.personaContainer_59642838 .personaWrapper_59642838 .ms-Persona-details{padding:0px 8px}.personaContainer_59642838 .personaDetails_59642838{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.itemContainer_59642838{display:inline-block;vertical-align:top}\n" }]);
	exports.personaContainer = "personaContainer_59642838";
	exports.hover = "hover_59642838";
	exports.actionButton = "actionButton_59642838";
	exports.personaContainerIsSelected = "personaContainerIsSelected_59642838";
	exports.validationError = "validationError_59642838";
	exports.itemContent = "itemContent_59642838";
	exports.removeButton = "removeButton_59642838";
	exports.expandButton = "expandButton_59642838";
	exports.personaWrapper = "personaWrapper_59642838";
	exports.personaDetails = "personaDetails_59642838";
	exports.itemContainer = "itemContainer_59642838";
	//# sourceMappingURL=ExtendedSelectedItem.scss.js.map

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var Utilities_1 = __webpack_require__(592);
	var ContextualMenu_1 = __webpack_require__(694);
	var SelectedItemWithContextMenu = /** @class */ (function (_super) {
	    tslib_1.__extends(SelectedItemWithContextMenu, _super);
	    function SelectedItemWithContextMenu(props) {
	        var _this = _super.call(this, props) || this;
	        _this.itemElement = React.createRef();
	        _this._onClick = function (ev) {
	            ev.preventDefault();
	            if (_this.props.beginEditing && !_this.props.item.isValid) {
	                _this.props.beginEditing(_this.props.item);
	            }
	            else {
	                _this.setState({ contextualMenuVisible: true });
	            }
	        };
	        _this._onCloseContextualMenu = function (ev) {
	            _this.setState({ contextualMenuVisible: false });
	        };
	        _this.state = { contextualMenuVisible: false };
	        return _this;
	    }
	    SelectedItemWithContextMenu.prototype.render = function () {
	        return (React.createElement("div", { ref: this.itemElement, onContextMenu: this._onClick },
	            this.props.renderedItem,
	            this.state.contextualMenuVisible ? (React.createElement(ContextualMenu_1.ContextualMenu, { items: this.props.menuItems, shouldFocusOnMount: true, target: this.itemElement.current, onDismiss: this._onCloseContextualMenu, directionalHint: ContextualMenu_1.DirectionalHint.bottomLeftEdge })) : null));
	    };
	    return SelectedItemWithContextMenu;
	}(Utilities_1.BaseComponent));
	exports.SelectedItemWithContextMenu = SelectedItemWithContextMenu;
	//# sourceMappingURL=SelectedItemWithContextMenu.js.map

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/* tslint:disable */
	var React = __webpack_require__(38);
	/* tslint:enable */
	var Utilities_1 = __webpack_require__(592);
	var stylesImport = __webpack_require__(1155);
	// tslint:disable-next-line:no-any
	var styles = stylesImport;
	var EditingItem = /** @class */ (function (_super) {
	    tslib_1.__extends(EditingItem, _super);
	    function EditingItem(props) {
	        var _this = _super.call(this, props) || this;
	        _this._editingFloatingPicker = React.createRef();
	        _this._renderEditingSuggestions = function () {
	            var FloatingPicker = _this.props.onRenderFloatingPicker;
	            var floatingPickerProps = _this.props.floatingPickerProps;
	            if (!FloatingPicker || !floatingPickerProps) {
	                return React.createElement(React.Fragment, null);
	            }
	            return (React.createElement(FloatingPicker, tslib_1.__assign({ componentRef: _this._editingFloatingPicker, onChange: _this._onSuggestionSelected, inputElement: _this._editingInput, selectedItems: [] }, floatingPickerProps)));
	        };
	        _this._resolveInputRef = function (ref) {
	            _this._editingInput = ref;
	            _this.forceUpdate(function () {
	                _this._editingInput.focus();
	            });
	        };
	        _this._onInputClick = function () {
	            _this._editingFloatingPicker.current && _this._editingFloatingPicker.current.showPicker(true /*updatevalue*/);
	        };
	        _this._onInputBlur = function (ev) {
	            if (_this._editingFloatingPicker.current && ev.relatedTarget !== null) {
	                var target = ev.relatedTarget;
	                if (target.className.indexOf('ms-Suggestions-itemButton') === -1 && target.className.indexOf('ms-Suggestions-sectionButton') === -1) {
	                    _this._editingFloatingPicker.current.forceResolveSuggestion();
	                }
	            }
	        };
	        _this._onInputChange = function (ev) {
	            var value = ev.target.value;
	            if (value === '') {
	                if (_this.props.onRemoveItem) {
	                    _this.props.onRemoveItem();
	                }
	            }
	            else {
	                _this._editingFloatingPicker.current && _this._editingFloatingPicker.current.onQueryStringChanged(value);
	            }
	        };
	        _this._onSuggestionSelected = function (item) {
	            _this.props.onEditingComplete(_this.props.item, item);
	        };
	        _this.state = { contextualMenuVisible: false };
	        return _this;
	    }
	    EditingItem.prototype.componentDidMount = function () {
	        var getEditingItemText = this.props.getEditingItemText;
	        var itemText = getEditingItemText(this.props.item);
	        this._editingFloatingPicker.current && this._editingFloatingPicker.current.onQueryStringChanged(itemText);
	        this._editingInput.value = itemText;
	        this._editingInput.focus();
	    };
	    EditingItem.prototype.render = function () {
	        var itemId = Utilities_1.getId();
	        var nativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties);
	        return (React.createElement("div", { "aria-labelledby": 'editingItemPersona-' + itemId, className: Utilities_1.css('ms-EditingItem', styles.editingContainer) },
	            React.createElement("input", tslib_1.__assign({ autoCapitalize: 'off', autoComplete: 'off' }, nativeProps, { ref: this._resolveInputRef, onChange: this._onInputChange, onKeyDown: this._onInputKeyDown, onBlur: this._onInputBlur, onClick: this._onInputClick, "data-lpignore": true, className: styles.editingInput, id: itemId })),
	            this._renderEditingSuggestions()));
	    };
	    EditingItem.prototype._onInputKeyDown = function (ev) {
	        if (ev.which === Utilities_1.KeyCodes.backspace || ev.which === Utilities_1.KeyCodes.del) {
	            ev.stopPropagation();
	        }
	    };
	    return EditingItem;
	}(Utilities_1.BaseComponent));
	exports.EditingItem = EditingItem;
	//# sourceMappingURL=EditingItem.js.map

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable */
	var load_themed_styles_1 = __webpack_require__(584);
	load_themed_styles_1.loadStyles([{ "rawString": ".editingInput_aec7d74f{border:0px;outline:none;width:100%}.editingInput_aec7d74f::-ms-clear{display:none}.editingContainer_aec7d74f{margin:4px}\n" }]);
	exports.editingInput = "editingInput_aec7d74f";
	exports.editingContainer = "editingContainer_aec7d74f";
	//# sourceMappingURL=EditingItem.scss.js.map

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1157), exports);
	//# sourceMappingURL=Separator.js.map

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1158), exports);
	tslib_1.__exportStar(__webpack_require__(1159), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	exports.SeparatorBase = function (props) {
	    var styles = props.styles, theme = props.theme, className = props.className, vertical = props.vertical, alignContent = props.alignContent;
	    var _classNames = getClassNames(styles, {
	        theme: theme,
	        className: className,
	        alignContent: alignContent,
	        vertical: vertical
	    });
	    return (React.createElement("div", { className: _classNames.root },
	        React.createElement("div", { className: _classNames.content, role: "separator", "aria-orientation": vertical ? 'vertical' : 'horizontal' }, props.children)));
	};
	//# sourceMappingURL=Separator.base.js.map

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Separator_styles_1 = __webpack_require__(1160);
	var Separator_base_1 = __webpack_require__(1158);
	exports.Separator = Utilities_1.styled(Separator_base_1.SeparatorBase, Separator_styles_1.getStyles, undefined, {
	    scope: 'Separator'
	});
	//# sourceMappingURL=Separator.js.map

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    var theme = props.theme, alignContent = props.alignContent, vertical = props.vertical, className = props.className;
	    var alignStart = alignContent === 'start';
	    var alignCenter = alignContent === 'center';
	    var alignEnd = alignContent === 'end';
	    return {
	        root: [
	            theme.fonts.medium,
	            {
	                position: 'relative'
	            },
	            alignContent && {
	                textAlign: alignContent
	            },
	            !alignContent && {
	                textAlign: 'center'
	            },
	            vertical &&
	                (alignCenter || !alignContent) && {
	                verticalAlign: 'middle'
	            },
	            vertical &&
	                alignStart && {
	                verticalAlign: 'top'
	            },
	            vertical &&
	                alignEnd && {
	                verticalAlign: 'bottom'
	            },
	            vertical && {
	                padding: '0 4px',
	                height: 'inherit',
	                display: 'table-cell',
	                zIndex: 1,
	                selectors: {
	                    ':after': {
	                        backgroundColor: theme.palette.neutralLighter,
	                        width: '1px',
	                        content: '""',
	                        position: 'absolute',
	                        top: '0',
	                        bottom: '0',
	                        left: '50%',
	                        right: '0',
	                        zIndex: -1
	                    }
	                }
	            },
	            !vertical && {
	                padding: '4px 0',
	                selectors: {
	                    ':before': {
	                        backgroundColor: theme.palette.neutralLighter,
	                        height: '1px',
	                        content: '""',
	                        display: 'block',
	                        position: 'absolute',
	                        top: '50%',
	                        bottom: '0',
	                        left: '0',
	                        right: '0'
	                    }
	                }
	            },
	            className
	        ],
	        content: [
	            {
	                position: 'relative',
	                display: 'inline-block',
	                padding: '0 12px',
	                color: theme.semanticColors.bodyText,
	                background: theme.semanticColors.bodyBackground
	            },
	            vertical && {
	                padding: '12px 0'
	            }
	        ]
	    };
	};
	//# sourceMappingURL=Separator.styles.js.map

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1162), exports);
	//# sourceMappingURL=Shimmer.js.map

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1163), exports);
	tslib_1.__exportStar(__webpack_require__(1165), exports);
	tslib_1.__exportStar(__webpack_require__(1168), exports);
	tslib_1.__exportStar(__webpack_require__(1169), exports);
	tslib_1.__exportStar(__webpack_require__(1170), exports);
	tslib_1.__exportStar(__webpack_require__(1175), exports);
	tslib_1.__exportStar(__webpack_require__(1177), exports);
	tslib_1.__exportStar(__webpack_require__(1172), exports);
	tslib_1.__exportStar(__webpack_require__(1173), exports);
	tslib_1.__exportStar(__webpack_require__(1166), exports);
	tslib_1.__exportStar(__webpack_require__(1167), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Shimmer_styles_1 = __webpack_require__(1164);
	var Shimmer_base_1 = __webpack_require__(1165);
	exports.Shimmer = Utilities_1.styled(Shimmer_base_1.ShimmerBase, Shimmer_styles_1.getStyles, undefined, {
	    scope: 'Shimmer'
	});
	//# sourceMappingURL=Shimmer.js.map

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var GlobalClassNames = {
	    root: 'ms-Shimmer-container',
	    shimmerWrapper: 'ms-Shimmer-shimmerWrapper',
	    dataWrapper: 'ms-Shimmer-dataWrapper'
	};
	var BACKGROUND_OFF_SCREEN_POSITION = '1000%';
	var shimmerAnimation = Styling_1.keyframes({
	    '0%': {
	        backgroundPosition: "-" + BACKGROUND_OFF_SCREEN_POSITION
	    },
	    '100%': {
	        backgroundPosition: BACKGROUND_OFF_SCREEN_POSITION
	    }
	});
	var shimmerAnimationRTL = Styling_1.keyframes({
	    '100%': {
	        backgroundPosition: "-" + BACKGROUND_OFF_SCREEN_POSITION
	    },
	    '0%': {
	        backgroundPosition: BACKGROUND_OFF_SCREEN_POSITION
	    }
	});
	function getStyles(props) {
	    var isDataLoaded = props.isDataLoaded, className = props.className, theme = props.theme, transitionAnimationInterval = props.transitionAnimationInterval, shimmerColor = props.shimmerColor, shimmerWaveColor = props.shimmerWaveColor;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var isRTL = Utilities_1.getRTL();
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                position: 'relative',
	                height: 'auto'
	            },
	            className
	        ],
	        shimmerWrapper: [
	            classNames.shimmerWrapper,
	            {
	                background: (shimmerColor || palette.neutralLighter) + "\n                    linear-gradient(\n                      to right,\n                      " + (shimmerColor || palette.neutralLighter) + " 0%,\n                      " + (shimmerWaveColor || palette.neutralLight) + " 50%,\n                      " + (shimmerColor || palette.neutralLighter) + " 100%)\n                    0 0 / 90% 100%\n                    no-repeat",
	                animationDuration: '2s',
	                animationTimingFunction: 'ease-in-out',
	                animationDirection: 'normal',
	                animationIterationCount: 'infinite',
	                animationName: isRTL ? shimmerAnimationRTL : shimmerAnimation,
	                transition: "opacity " + transitionAnimationInterval + "ms",
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        background: "WindowText\n                        linear-gradient(\n                          to right,\n                          transparent 0%,\n                          Window 50%,\n                          transparent 100%)\n                        0 0 / 90% 100%\n                        no-repeat"
	                    },
	                    _a)
	            },
	            isDataLoaded && {
	                opacity: '0',
	                position: 'absolute',
	                top: '0',
	                bottom: '0',
	                left: '0',
	                right: '0'
	            }
	        ],
	        dataWrapper: [
	            classNames.dataWrapper,
	            {
	                position: 'absolute',
	                top: '0',
	                bottom: '0',
	                left: '0',
	                right: '0',
	                opacity: '0',
	                background: 'none',
	                backgroundColor: 'transparent',
	                border: 'none',
	                transition: "opacity " + transitionAnimationInterval + "ms"
	            },
	            isDataLoaded && {
	                opacity: '1',
	                position: 'static'
	            }
	        ],
	        screenReaderText: Styling_1.hiddenContentStyle
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=Shimmer.styles.js.map

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var ShimmerElementsGroup_1 = __webpack_require__(1166);
	var TRANSITION_ANIMATION_INTERVAL = 200; /* ms */
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Shimmer}
	 */
	var ShimmerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmerBase, _super);
	    function ShimmerBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            contentLoaded: props.isDataLoaded
	        };
	        return _this;
	    }
	    ShimmerBase.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        var isDataLoaded = nextProps.isDataLoaded;
	        if (this._lastTimeoutId !== undefined) {
	            this._async.clearTimeout(this._lastTimeoutId);
	            this._lastTimeoutId = undefined;
	        }
	        if (isDataLoaded) {
	            this._lastTimeoutId = this._async.setTimeout(function () {
	                _this.setState({
	                    contentLoaded: isDataLoaded
	                });
	                _this._lastTimeoutId = undefined;
	            }, TRANSITION_ANIMATION_INTERVAL);
	        }
	        else {
	            this.setState({
	                contentLoaded: isDataLoaded
	            });
	        }
	    };
	    ShimmerBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, shimmerElements = _a.shimmerElements, children = _a.children, isDataLoaded = _a.isDataLoaded, width = _a.width, className = _a.className, customElementsGroup = _a.customElementsGroup, theme = _a.theme, ariaLabel = _a.ariaLabel, shimmerColors = _a.shimmerColors;
	        var contentLoaded = this.state.contentLoaded;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            isDataLoaded: isDataLoaded,
	            className: className,
	            transitionAnimationInterval: TRANSITION_ANIMATION_INTERVAL,
	            shimmerColor: shimmerColors && shimmerColors.shimmer,
	            shimmerWaveColor: shimmerColors && shimmerColors.shimmerWave
	        });
	        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
	        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: this._classNames.root }),
	            !contentLoaded && (React.createElement("div", { style: { width: width ? width : '100%' }, className: this._classNames.shimmerWrapper }, customElementsGroup ? (customElementsGroup) : (React.createElement(ShimmerElementsGroup_1.ShimmerElementsGroup, { shimmerElements: shimmerElements, backgroundColor: shimmerColors && shimmerColors.background })))),
	            children && React.createElement("div", { className: this._classNames.dataWrapper }, children),
	            ariaLabel && !isDataLoaded && (React.createElement("div", { role: "status", "aria-live": "polite" },
	                React.createElement(Utilities_1.DelayedRender, null,
	                    React.createElement("div", { className: this._classNames.screenReaderText }, ariaLabel))))));
	    };
	    ShimmerBase.defaultProps = {
	        isDataLoaded: false
	    };
	    return ShimmerBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmerBase = ShimmerBase;
	//# sourceMappingURL=Shimmer.base.js.map

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ShimmerElementsGroup_base_1 = __webpack_require__(1167);
	var ShimmerElementsGroup_styles_1 = __webpack_require__(1178);
	exports.ShimmerElementsGroup = Utilities_1.styled(ShimmerElementsGroup_base_1.ShimmerElementsGroupBase, ShimmerElementsGroup_styles_1.getStyles, undefined, { scope: 'ShimmerElementsGroup' });
	//# sourceMappingURL=ShimmerElementsGroup.js.map

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Shimmer_types_1 = __webpack_require__(1168);
	var ShimmerLine_1 = __webpack_require__(1169);
	var ShimmerGap_1 = __webpack_require__(1172);
	var ShimmerCircle_1 = __webpack_require__(1175);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Shimmer}
	 */
	var ShimmerElementsGroupBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmerElementsGroupBase, _super);
	    function ShimmerElementsGroupBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._getRenderedElements = function (shimmerElements, rowHeight) {
	            var renderedElements = shimmerElements ? (shimmerElements.map(function (elem, index) {
	                var type = elem.type, filteredElem = tslib_1.__rest(elem, ["type"]);
	                switch (elem.type) {
	                    case Shimmer_types_1.ShimmerElementType.circle:
	                        return React.createElement(ShimmerCircle_1.ShimmerCircle, tslib_1.__assign({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
	                    case Shimmer_types_1.ShimmerElementType.gap:
	                        return React.createElement(ShimmerGap_1.ShimmerGap, tslib_1.__assign({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
	                    case Shimmer_types_1.ShimmerElementType.line:
	                        return React.createElement(ShimmerLine_1.ShimmerLine, tslib_1.__assign({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
	                }
	            })) : (React.createElement(ShimmerLine_1.ShimmerLine, { height: Shimmer_types_1.ShimmerElementsDefaultHeights.line, styles: { root: [{ borderWidth: '0px' }] } }));
	            return renderedElements;
	        };
	        _this._getStyles = function (elem, rowHeight) {
	            var backgroundColor = _this.props.backgroundColor;
	            var verticalAlign = elem.verticalAlign, type = elem.type;
	            var elemHeight = elem.height;
	            var dif = rowHeight && elemHeight ? rowHeight - elemHeight : 0;
	            var borderStyle;
	            if (!verticalAlign || verticalAlign === 'center') {
	                borderStyle = {
	                    borderBottomWidth: (dif ? Math.floor(dif / 2) : 0) + "px",
	                    borderTopWidth: (dif ? Math.ceil(dif / 2) : 0) + "px"
	                };
	            }
	            else if (verticalAlign && verticalAlign === 'top') {
	                borderStyle = {
	                    borderBottomWidth: (dif ? dif : 0) + "px",
	                    borderTopWidth: "0px"
	                };
	            }
	            else if (verticalAlign && verticalAlign === 'bottom') {
	                borderStyle = {
	                    borderBottomWidth: "0px",
	                    borderTopWidth: (dif ? dif : 0) + "px"
	                };
	            }
	            if (backgroundColor) {
	                switch (type) {
	                    case Shimmer_types_1.ShimmerElementType.circle:
	                        return {
	                            root: tslib_1.__assign({}, borderStyle, { borderColor: backgroundColor }),
	                            svg: { fill: backgroundColor }
	                        };
	                    case Shimmer_types_1.ShimmerElementType.gap:
	                        return {
	                            root: tslib_1.__assign({}, borderStyle, { borderColor: backgroundColor, backgroundColor: backgroundColor })
	                        };
	                    case Shimmer_types_1.ShimmerElementType.line:
	                        return {
	                            root: tslib_1.__assign({}, borderStyle, { borderColor: backgroundColor }),
	                            topLeftCorner: { fill: backgroundColor },
	                            topRightCorner: { fill: backgroundColor },
	                            bottomLeftCorner: { fill: backgroundColor },
	                            bottomRightCorner: { fill: backgroundColor }
	                        };
	                }
	            }
	            return {
	                root: tslib_1.__assign({}, borderStyle)
	            };
	        };
	        /**
	         * User should not worry to provide which of the elements is the highest, we do the calculation for him.
	         * Plus if user forgot to specify the height we assign their defaults.
	         */
	        _this._findMaxElementHeight = function (elements) {
	            var itemsDefaulted = elements.map(function (elem) {
	                switch (elem.type) {
	                    case Shimmer_types_1.ShimmerElementType.circle:
	                        if (!elem.height) {
	                            elem.height = Shimmer_types_1.ShimmerElementsDefaultHeights.circle;
	                        }
	                    case Shimmer_types_1.ShimmerElementType.line:
	                        if (!elem.height) {
	                            elem.height = Shimmer_types_1.ShimmerElementsDefaultHeights.line;
	                        }
	                    case Shimmer_types_1.ShimmerElementType.gap:
	                        if (!elem.height) {
	                            elem.height = Shimmer_types_1.ShimmerElementsDefaultHeights.gap;
	                        }
	                }
	                return elem;
	            });
	            var rowHeight = itemsDefaulted.reduce(function (acc, next) {
	                return next.height ? (next.height > acc ? next.height : acc) : acc;
	            }, 0);
	            return rowHeight;
	        };
	        return _this;
	    }
	    ShimmerElementsGroupBase.prototype.render = function () {
	        var _a = this.props, styles = _a.styles, width = _a.width, shimmerElements = _a.shimmerElements, rowHeight = _a.rowHeight, flexWrap = _a.flexWrap, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            flexWrap: flexWrap
	        });
	        var height = rowHeight ? rowHeight : this._findMaxElementHeight(shimmerElements ? shimmerElements : []);
	        return (
	        // tslint:disable-next-line:jsx-ban-props
	        React.createElement("div", { style: { width: width ? width : 'auto' }, className: this._classNames.root }, this._getRenderedElements(shimmerElements, height)));
	    };
	    ShimmerElementsGroupBase.defaultProps = {
	        flexWrap: false
	    };
	    return ShimmerElementsGroupBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmerElementsGroupBase = ShimmerElementsGroupBase;
	//# sourceMappingURL=ShimmerElementsGroup.base.js.map

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Describes the possible types for shimmer elements used.
	 * {@docCategory Shimmer}
	 */
	var ShimmerElementType;
	(function (ShimmerElementType) {
	    /**
	     * Line element type
	     */
	    ShimmerElementType[ShimmerElementType["line"] = 1] = "line";
	    /**
	     * Circle element type
	     */
	    ShimmerElementType[ShimmerElementType["circle"] = 2] = "circle";
	    /**
	     * Gap element type
	     */
	    ShimmerElementType[ShimmerElementType["gap"] = 3] = "gap";
	})(ShimmerElementType = exports.ShimmerElementType || (exports.ShimmerElementType = {}));
	/**
	 * Describes the default heights for shimmer elements when omitted in implementation.
	 * {@docCategory Shimmer}
	 */
	var ShimmerElementsDefaultHeights;
	(function (ShimmerElementsDefaultHeights) {
	    /**
	     * Default height of the line element when not provided by user: 16px
	     */
	    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["line"] = 16] = "line";
	    /**
	     * Default height of the gap element when not provided by user: 16px
	     */
	    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["gap"] = 16] = "gap";
	    /**
	     * Default height of the circle element when not provided by user: 24px
	     */
	    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["circle"] = 24] = "circle";
	})(ShimmerElementsDefaultHeights = exports.ShimmerElementsDefaultHeights || (exports.ShimmerElementsDefaultHeights = {}));
	//# sourceMappingURL=Shimmer.types.js.map

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ShimmerLine_base_1 = __webpack_require__(1170);
	var ShimmerLine_styles_1 = __webpack_require__(1171);
	exports.ShimmerLine = Utilities_1.styled(ShimmerLine_base_1.ShimmerLineBase, ShimmerLine_styles_1.getStyles, undefined, {
	    scope: 'ShimmerLine'
	});
	//# sourceMappingURL=ShimmerLine.js.map

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Shimmer}
	 */
	var ShimmerLineBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmerLineBase, _super);
	    function ShimmerLineBase(props) {
	        return _super.call(this, props) || this;
	    }
	    ShimmerLineBase.prototype.render = function () {
	        var _a = this.props, height = _a.height, styles = _a.styles, width = _a.width, borderStyle = _a.borderStyle, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            height: height,
	            borderStyle: borderStyle
	        });
	        return (React.createElement("div", { style: { width: width ? width : '100%', minWidth: typeof width === 'number' ? width + "px" : 'auto' }, className: this._classNames.root },
	            React.createElement("svg", { width: "2", height: "2", className: this._classNames.topLeftCorner },
	                React.createElement("path", { d: "M0 2 A 2 2, 0, 0, 1, 2 0 L 0 0 Z" })),
	            React.createElement("svg", { width: "2", height: "2", className: this._classNames.topRightCorner },
	                React.createElement("path", { d: "M0 0 A 2 2, 0, 0, 1, 2 2 L 2 0 Z" })),
	            React.createElement("svg", { width: "2", height: "2", className: this._classNames.bottomRightCorner },
	                React.createElement("path", { d: "M2 0 A 2 2, 0, 0, 1, 0 2 L 2 2 Z" })),
	            React.createElement("svg", { width: "2", height: "2", className: this._classNames.bottomLeftCorner },
	                React.createElement("path", { d: "M2 2 A 2 2, 0, 0, 1, 0 0 L 0 2 Z" }))));
	    };
	    return ShimmerLineBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmerLineBase = ShimmerLineBase;
	//# sourceMappingURL=ShimmerLine.base.js.map

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ShimmerLine-root',
	    topLeftCorner: 'ms-ShimmerLine-topLeftCorner',
	    topRightCorner: 'ms-ShimmerLine-topRightCorner',
	    bottomLeftCorner: 'ms-ShimmerLine-bottomLeftCorner',
	    bottomRightCorner: 'ms-ShimmerLine-bottomRightCorner'
	};
	function getStyles(props) {
	    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
	    var palette = theme.palette;
	    var globalClassNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var borderStyles = !!borderStyle ? borderStyle : {};
	    var sharedCornerStyles = {
	        position: 'absolute',
	        fill: palette.white
	    };
	    return {
	        root: [
	            globalClassNames.root,
	            theme.fonts.medium,
	            {
	                height: height + "px",
	                boxSizing: 'content-box',
	                position: 'relative',
	                borderTopStyle: 'solid',
	                borderBottomStyle: 'solid',
	                borderColor: palette.white,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Window',
	                        selectors: {
	                            '> *': {
	                                fill: 'Window'
	                            }
	                        }
	                    },
	                    _a)
	            },
	            borderStyles
	        ],
	        topLeftCorner: [
	            globalClassNames.topLeftCorner,
	            {
	                top: '0',
	                left: '0'
	            },
	            sharedCornerStyles
	        ],
	        topRightCorner: [
	            globalClassNames.topRightCorner,
	            {
	                top: '0',
	                right: '0'
	            },
	            sharedCornerStyles
	        ],
	        bottomRightCorner: [
	            globalClassNames.bottomRightCorner,
	            {
	                bottom: '0',
	                right: '0'
	            },
	            sharedCornerStyles
	        ],
	        bottomLeftCorner: [
	            globalClassNames.bottomLeftCorner,
	            {
	                bottom: '0',
	                left: '0'
	            },
	            sharedCornerStyles
	        ]
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=ShimmerLine.styles.js.map

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ShimmerGap_base_1 = __webpack_require__(1173);
	var ShimmerGap_styles_1 = __webpack_require__(1174);
	exports.ShimmerGap = Utilities_1.styled(ShimmerGap_base_1.ShimmerGapBase, ShimmerGap_styles_1.getStyles, undefined, {
	    scope: 'ShimmerGap'
	});
	//# sourceMappingURL=ShimmerGap.js.map

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	/**
	 * {@docCategory Shimmer}
	 */
	var ShimmerGapBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmerGapBase, _super);
	    function ShimmerGapBase(props) {
	        return _super.call(this, props) || this;
	    }
	    ShimmerGapBase.prototype.render = function () {
	        var _a = this.props, height = _a.height, styles = _a.styles, width = _a.width, borderStyle = _a.borderStyle, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            height: height,
	            borderStyle: borderStyle
	        });
	        return (React.createElement("div", { style: { width: width ? width : '10px', minWidth: typeof width === 'number' ? width + "px" : 'auto' }, className: this._classNames.root }));
	    };
	    return ShimmerGapBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmerGapBase = ShimmerGapBase;
	//# sourceMappingURL=ShimmerGap.base.js.map

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ShimmerGap-root'
	};
	function getStyles(props) {
	    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
	    var palette = theme.palette;
	    var globalClassNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var borderStyles = !!borderStyle ? borderStyle : {};
	    return {
	        root: [
	            globalClassNames.root,
	            theme.fonts.medium,
	            {
	                backgroundColor: palette.white,
	                height: height + "px",
	                boxSizing: 'content-box',
	                borderTopStyle: 'solid',
	                borderBottomStyle: 'solid',
	                borderColor: palette.white,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'Window',
	                        borderColor: 'Window'
	                    },
	                    _a)
	            },
	            borderStyles
	        ]
	    };
	    var _a;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=ShimmerGap.styles.js.map

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ShimmerCircle_styles_1 = __webpack_require__(1176);
	var ShimmerCircle_base_1 = __webpack_require__(1177);
	exports.ShimmerCircle = Utilities_1.styled(ShimmerCircle_base_1.ShimmerCircleBase, ShimmerCircle_styles_1.getStyles, undefined, { scope: 'ShimmerCircle' });
	//# sourceMappingURL=ShimmerCircle.js.map

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ShimmerCircle-root',
	    svg: 'ms-ShimmerCircle-svg'
	};
	function getStyles(props) {
	    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
	    var palette = theme.palette;
	    var globalClassNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var borderStyles = !!borderStyle ? borderStyle : {};
	    return {
	        root: [
	            globalClassNames.root,
	            theme.fonts.medium,
	            {
	                width: height + "px",
	                height: height + "px",
	                minWidth: height + "px",
	                boxSizing: 'content-box',
	                borderTopStyle: 'solid',
	                borderBottomStyle: 'solid',
	                borderColor: palette.white,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        borderColor: 'Window'
	                    },
	                    _a)
	            },
	            borderStyles
	        ],
	        svg: [
	            globalClassNames.svg,
	            {
	                display: 'block',
	                fill: palette.white,
	                selectors: (_b = {},
	                    _b[Styling_1.HighContrastSelector] = {
	                        fill: 'Window'
	                    },
	                    _b)
	            }
	        ]
	    };
	    var _a, _b;
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=ShimmerCircle.styles.js.map

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var ShimmerCircleBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmerCircleBase, _super);
	    function ShimmerCircleBase(props) {
	        return _super.call(this, props) || this;
	    }
	    ShimmerCircleBase.prototype.render = function () {
	        var _a = this.props, height = _a.height, styles = _a.styles, borderStyle = _a.borderStyle, theme = _a.theme;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            height: height,
	            borderStyle: borderStyle
	        });
	        return (React.createElement("div", { className: this._classNames.root },
	            React.createElement("svg", { viewBox: "0 0 10 10", width: height, height: height, className: this._classNames.svg },
	                React.createElement("path", { 
	                    // tslint:disable-next-line:max-line-length
	                    d: "M0,0 L10,0 L10,10 L0,10 L0,0 Z M0,5 C0,7.76142375 2.23857625,10 5,10 C7.76142375,10 10,7.76142375 10,5 C10,2.23857625 7.76142375,2.22044605e-16 5,0 C2.23857625,-2.22044605e-16 0,2.23857625 0,5 L0,5 Z" }))));
	    };
	    return ShimmerCircleBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmerCircleBase = ShimmerCircleBase;
	//# sourceMappingURL=ShimmerCircle.base.js.map

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-ShimmerElementsGroup-root'
	};
	function getStyles(props) {
	    var flexWrap = props.flexWrap, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                display: 'flex',
	                alignItems: 'center',
	                flexWrap: flexWrap ? 'wrap' : 'nowrap'
	            }
	        ]
	    };
	}
	exports.getStyles = getStyles;
	//# sourceMappingURL=ShimmerElementsGroup.styles.js.map

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1180), exports);
	tslib_1.__exportStar(__webpack_require__(1181), exports);
	//# sourceMappingURL=ShimmeredDetailsList.js.map

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ShimmeredDetailsList_base_1 = __webpack_require__(1181);
	var ShimmeredDetailsList_styles_1 = __webpack_require__(1182);
	exports.ShimmeredDetailsList = Utilities_1.styled(ShimmeredDetailsList_base_1.ShimmeredDetailsListBase, ShimmeredDetailsList_styles_1.getStyles, undefined, { scope: 'ShimmeredDetailsList' });
	//# sourceMappingURL=ShimmeredDetailsList.js.map

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var interfaces_1 = __webpack_require__(867);
	var DetailsList_1 = __webpack_require__(906);
	var Shimmer_1 = __webpack_require__(1161);
	var DetailsList_types_1 = __webpack_require__(873);
	var DetailsRow_styles_1 = __webpack_require__(883);
	var getClassNames = Utilities_1.classNamesFunction();
	var SHIMMER_INITIAL_ITEMS = 10;
	var DEFAULT_SHIMMER_HEIGHT = 7;
	var SHIMMER_LINE_VS_CELL_WIDTH_RATIO = 0.95;
	var ShimmeredDetailsListBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ShimmeredDetailsListBase, _super);
	    function ShimmeredDetailsListBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._onRenderShimmerPlaceholder = function (index, rowProps) {
	            var onRenderCustomPlaceholder = _this.props.onRenderCustomPlaceholder;
	            var placeholderElements = onRenderCustomPlaceholder
	                ? onRenderCustomPlaceholder(rowProps)
	                : _this._renderDefaultShimmerPlaceholder(rowProps);
	            return React.createElement(Shimmer_1.Shimmer, { customElementsGroup: placeholderElements });
	        };
	        _this._renderDefaultShimmerPlaceholder = function (rowProps) {
	            var columns = rowProps.columns, compact = rowProps.compact, selectionMode = rowProps.selectionMode, checkboxVisibility = rowProps.checkboxVisibility, _a = rowProps.cellStyleProps, cellStyleProps = _a === void 0 ? DetailsRow_styles_1.DEFAULT_CELL_STYLE_PROPS : _a;
	            var rowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.rowHeight, compactRowHeight = DetailsRow_styles_1.DEFAULT_ROW_HEIGHTS.compactRowHeight;
	            var gapHeight = compact ? compactRowHeight : rowHeight + 1; // 1px to take into account the border-bottom of DetailsRow.
	            var shimmerElementsRow = [];
	            var showCheckbox = selectionMode !== interfaces_1.SelectionMode.none && checkboxVisibility !== DetailsList_types_1.CheckboxVisibility.hidden;
	            if (showCheckbox) {
	                shimmerElementsRow.push(React.createElement(Shimmer_1.ShimmerElementsGroup, { key: 'checkboxGap', shimmerElements: [{ type: Shimmer_1.ShimmerElementType.gap, width: '40px', height: gapHeight }] }));
	            }
	            columns.map(function (column, columnIdx) {
	                var shimmerElements = [];
	                var groupWidth = cellStyleProps.cellLeftPadding +
	                    cellStyleProps.cellRightPadding +
	                    column.calculatedWidth +
	                    (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
	                shimmerElements.push({
	                    type: Shimmer_1.ShimmerElementType.gap,
	                    width: cellStyleProps.cellLeftPadding,
	                    height: gapHeight
	                });
	                if (column.isIconOnly) {
	                    shimmerElements.push({
	                        type: Shimmer_1.ShimmerElementType.line,
	                        width: column.calculatedWidth,
	                        height: column.calculatedWidth
	                    });
	                    shimmerElements.push({
	                        type: Shimmer_1.ShimmerElementType.gap,
	                        width: cellStyleProps.cellRightPadding,
	                        height: gapHeight
	                    });
	                }
	                else {
	                    shimmerElements.push({
	                        type: Shimmer_1.ShimmerElementType.line,
	                        width: column.calculatedWidth * SHIMMER_LINE_VS_CELL_WIDTH_RATIO,
	                        height: DEFAULT_SHIMMER_HEIGHT
	                    });
	                    shimmerElements.push({
	                        type: Shimmer_1.ShimmerElementType.gap,
	                        width: cellStyleProps.cellRightPadding +
	                            (column.calculatedWidth - column.calculatedWidth * SHIMMER_LINE_VS_CELL_WIDTH_RATIO) +
	                            (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0),
	                        height: gapHeight
	                    });
	                }
	                shimmerElementsRow.push(React.createElement(Shimmer_1.ShimmerElementsGroup, { key: columnIdx, width: groupWidth + "px", shimmerElements: shimmerElements }));
	            });
	            // When resizing the window from narrow to wider, we need to cover the exposed Shimmer wave until the column resizing logic is done.
	            shimmerElementsRow.push(React.createElement(Shimmer_1.ShimmerElementsGroup, { key: 'endGap', width: '100%', shimmerElements: [{ type: Shimmer_1.ShimmerElementType.gap, width: '100%', height: gapHeight }] }));
	            return React.createElement("div", { style: { display: 'flex' } }, shimmerElementsRow);
	        };
	        _this._shimmerItems = props.shimmerLines ? new Array(props.shimmerLines) : new Array(SHIMMER_INITIAL_ITEMS);
	        return _this;
	    }
	    ShimmeredDetailsListBase.prototype.render = function () {
	        var _a = this.props, detailsListStyles = _a.detailsListStyles, enableShimmer = _a.enableShimmer, items = _a.items, listProps = _a.listProps, onRenderCustomPlaceholder = _a.onRenderCustomPlaceholder, removeFadingOverlay = _a.removeFadingOverlay, shimmerLines = _a.shimmerLines, styles = _a.styles, theme = _a.theme, restProps = tslib_1.__rest(_a, ["detailsListStyles", "enableShimmer", "items", "listProps", "onRenderCustomPlaceholder", "removeFadingOverlay", "shimmerLines", "styles", "theme"]);
	        var listClassName = listProps && listProps.className;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            className: listClassName,
	            enableShimmer: enableShimmer
	        });
	        var newListProps = tslib_1.__assign({}, listProps, { 
	            // Adds to the optional listProp className a fading out overlay className only when shimmer enabled.
	            className: enableShimmer && !removeFadingOverlay ? this._classNames.root : listClassName });
	        return (React.createElement(DetailsList_1.DetailsList, tslib_1.__assign({}, restProps, { items: enableShimmer ? this._shimmerItems : items, onRenderMissingItem: this._onRenderShimmerPlaceholder, listProps: newListProps, styles: detailsListStyles })));
	    };
	    return ShimmeredDetailsListBase;
	}(Utilities_1.BaseComponent));
	exports.ShimmeredDetailsListBase = ShimmeredDetailsListBase;
	//# sourceMappingURL=ShimmeredDetailsList.base.js.map

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, enableShimmer = props.enableShimmer;
	    var semanticColors = theme.semanticColors, palette = theme.palette;
	    var overlayStyles = {
	        // set `position: relative` to stop the fading overlay cover the DetailsList header.
	        position: 'relative',
	        selectors: {
	            ':after': {
	                content: '""',
	                position: 'absolute',
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0,
	                backgroundImage: "linear-gradient(to bottom,\n                          transparent 30%,\n                          " + palette.whiteTranslucent40 + " 65%,\n                          " + semanticColors.listBackground + " 100%)"
	            }
	        }
	    };
	    return {
	        root: [enableShimmer && overlayStyles, className]
	    };
	};
	//# sourceMappingURL=ShimmeredDetailsList.styles.js.map

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1184), exports);
	//# sourceMappingURL=Slider.js.map

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1185), exports);
	tslib_1.__exportStar(__webpack_require__(1186), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Slider_base_1 = __webpack_require__(1186);
	var Slider_styles_1 = __webpack_require__(1187);
	exports.Slider = Utilities_1.styled(Slider_base_1.SliderBase, Slider_styles_1.getStyles, undefined, {
	    scope: 'Slider'
	});
	//# sourceMappingURL=Slider.js.map

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Utilities_2 = __webpack_require__(592);
	var Label_1 = __webpack_require__(771);
	/**
	 * @deprecated Unused.
	 */
	var ValuePosition;
	(function (ValuePosition) {
	    ValuePosition[ValuePosition["Previous"] = 0] = "Previous";
	    ValuePosition[ValuePosition["Next"] = 1] = "Next";
	})(ValuePosition = exports.ValuePosition || (exports.ValuePosition = {}));
	var getClassNames = Utilities_2.classNamesFunction();
	exports.ONKEYDOWN_TIMEOUT_DURATION = 1000;
	var SliderBase = /** @class */ (function (_super) {
	    tslib_1.__extends(SliderBase, _super);
	    function SliderBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._sliderLine = React.createRef();
	        _this._thumb = React.createRef();
	        _this._onKeyDownTimer = -1;
	        _this._getAriaValueText = function (value) {
	            if (_this.props.ariaValueText && value !== undefined) {
	                return _this.props.ariaValueText(value);
	            }
	        };
	        _this._onMouseDownOrTouchStart = function (event) {
	            if (event.type === 'mousedown') {
	                _this._events.on(window, 'mousemove', _this._onMouseMoveOrTouchMove, true);
	                _this._events.on(window, 'mouseup', _this._onMouseUpOrTouchEnd, true);
	            }
	            else if (event.type === 'touchstart') {
	                _this._events.on(window, 'touchmove', _this._onMouseMoveOrTouchMove, true);
	                _this._events.on(window, 'touchend', _this._onMouseUpOrTouchEnd, true);
	            }
	            _this._onMouseMoveOrTouchMove(event, true);
	        };
	        _this._onMouseMoveOrTouchMove = function (event, suppressEventCancelation) {
	            if (!_this._sliderLine.current) {
	                return;
	            }
	            var _a = _this.props, max = _a.max, min = _a.min, step = _a.step;
	            var steps = (max - min) / step;
	            var sliderPositionRect = _this._sliderLine.current.getBoundingClientRect();
	            var sliderLength = !_this.props.vertical ? sliderPositionRect.width : sliderPositionRect.height;
	            var stepLength = sliderLength / steps;
	            var currentSteps;
	            var distance;
	            if (!_this.props.vertical) {
	                var left = _this._getPosition(event, _this.props.vertical);
	                distance = Utilities_1.getRTL() ? sliderPositionRect.right - left : left - sliderPositionRect.left;
	                currentSteps = distance / stepLength;
	            }
	            else {
	                var bottom = _this._getPosition(event, _this.props.vertical);
	                distance = sliderPositionRect.bottom - bottom;
	                currentSteps = distance / stepLength;
	            }
	            var currentValue;
	            var renderedValue;
	            // The value shouldn't be bigger than max or be smaller than min.
	            if (currentSteps > Math.floor(steps)) {
	                renderedValue = currentValue = max;
	            }
	            else if (currentSteps < 0) {
	                renderedValue = currentValue = min;
	            }
	            else {
	                renderedValue = min + step * currentSteps;
	                currentValue = min + step * Math.round(currentSteps);
	            }
	            _this._updateValue(currentValue, renderedValue);
	            if (!suppressEventCancelation) {
	                event.preventDefault();
	                event.stopPropagation();
	            }
	        };
	        _this._onMouseUpOrTouchEnd = function (event) {
	            // Synchronize the renderedValue to the actual value.
	            _this.setState({
	                renderedValue: _this.state.value
	            });
	            if (_this.props.onChanged) {
	                _this.props.onChanged(event, _this.state.value);
	            }
	            _this._events.off();
	        };
	        _this._onKeyDown = function (event) {
	            var value = _this.state.value;
	            var _a = _this.props, max = _a.max, min = _a.min, step = _a.step;
	            var diff = 0;
	            switch (event.which) {
	                case Utilities_1.getRTLSafeKeyCode(Utilities_1.KeyCodes.left):
	                case Utilities_1.KeyCodes.down:
	                    diff = -step;
	                    _this._clearOnKeyDownTimer();
	                    _this._setOnKeyDownTimer(event);
	                    break;
	                case Utilities_1.getRTLSafeKeyCode(Utilities_1.KeyCodes.right):
	                case Utilities_1.KeyCodes.up:
	                    diff = step;
	                    _this._clearOnKeyDownTimer();
	                    _this._setOnKeyDownTimer(event);
	                    break;
	                case Utilities_1.KeyCodes.home:
	                    value = min;
	                    break;
	                case Utilities_1.KeyCodes.end:
	                    value = max;
	                    break;
	                default:
	                    return;
	            }
	            var newValue = Math.min(max, Math.max(min, value + diff));
	            _this._updateValue(newValue, newValue);
	            event.preventDefault();
	            event.stopPropagation();
	        };
	        _this._clearOnKeyDownTimer = function () {
	            _this._async.clearTimeout(_this._onKeyDownTimer);
	        };
	        _this._setOnKeyDownTimer = function (event) {
	            // what is this for?
	            _this._onKeyDownTimer = _this._async.setTimeout(function () {
	                if (_this.props.onChanged) {
	                    _this.props.onChanged(event, _this.state.value);
	                }
	            }, exports.ONKEYDOWN_TIMEOUT_DURATION);
	        };
	        _this._warnMutuallyExclusive({
	            value: 'defaultValue'
	        });
	        _this._id = Utilities_1.getId('Slider');
	        var value = props.value !== undefined ? props.value : props.defaultValue !== undefined ? props.defaultValue : props.min;
	        _this.state = {
	            value: value,
	            renderedValue: value
	        };
	        return _this;
	    }
	    /**
	     * Invoked when a component is receiving new props. This method is not called for the initial render.
	     */
	    SliderBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.value !== undefined) {
	            var value = Math.max(newProps.min, Math.min(newProps.max, newProps.value));
	            this.setState({
	                value: value,
	                renderedValue: value
	            });
	        }
	    };
	    SliderBase.prototype.render = function () {
	        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, disabled = _a.disabled, label = _a.label, max = _a.max, min = _a.min, showValue = _a.showValue, buttonProps = _a.buttonProps, vertical = _a.vertical, valueFormat = _a.valueFormat, styles = _a.styles, theme = _a.theme, originFromZero = _a.originFromZero;
	        var _b = this.state, value = _b.value, renderedValue = _b.renderedValue;
	        var thumbOffsetPercent = min === max ? 0 : ((renderedValue - min) / (max - min)) * 100;
	        var zeroOffsetPercent = min >= 0 ? 0 : (-min / (max - min)) * 100;
	        var lengthString = vertical ? 'height' : 'width';
	        var onMouseDownProp = disabled ? {} : { onMouseDown: this._onMouseDownOrTouchStart };
	        var onTouchStartProp = disabled ? {} : { onTouchStart: this._onMouseDownOrTouchStart };
	        var onKeyDownProp = disabled ? {} : { onKeyDown: this._onKeyDown };
	        var classNames = getClassNames(styles, {
	            className: className,
	            disabled: disabled,
	            vertical: vertical,
	            showTransitions: renderedValue === value,
	            showValue: showValue,
	            theme: theme
	        });
	        var divButtonProps = buttonProps ? Utilities_2.getNativeProps(buttonProps, Utilities_2.divProperties) : undefined;
	        return (React.createElement("div", { className: classNames.root },
	            label && (React.createElement(Label_1.Label, tslib_1.__assign({ className: classNames.titleLabel }, (ariaLabel ? {} : { htmlFor: this._id })), label)),
	            React.createElement("div", { className: classNames.container },
	                React.createElement("div", tslib_1.__assign({ "aria-valuenow": value, "aria-valuemin": min, "aria-valuemax": max, "aria-valuetext": this._getAriaValueText(value), "aria-label": ariaLabel || label, "aria-disabled": disabled }, onMouseDownProp, onTouchStartProp, onKeyDownProp, divButtonProps, { className: Utilities_1.css(classNames.slideBox, buttonProps.className), id: this._id, role: "slider", tabIndex: disabled ? undefined : 0, "data-is-focusable": !disabled }),
	                    React.createElement("div", { ref: this._sliderLine, className: classNames.line },
	                        originFromZero && (React.createElement("span", { className: Utilities_1.css(classNames.zeroTick), style: this._getStyleUsingOffsetPercent(vertical, zeroOffsetPercent) })),
	                        React.createElement("span", { ref: this._thumb, className: classNames.thumb, style: this._getStyleUsingOffsetPercent(vertical, thumbOffsetPercent) }),
	                        originFromZero ? (React.createElement(React.Fragment, null,
	                            React.createElement("span", { className: Utilities_1.css(classNames.lineContainer, classNames.inactiveSection), style: (_c = {}, _c[lengthString] = Math.min(thumbOffsetPercent, zeroOffsetPercent) + '%', _c) }),
	                            React.createElement("span", { className: Utilities_1.css(classNames.lineContainer, classNames.activeSection), style: (_d = {}, _d[lengthString] = Math.abs(zeroOffsetPercent - thumbOffsetPercent) + '%', _d) }),
	                            React.createElement("span", { className: Utilities_1.css(classNames.lineContainer, classNames.inactiveSection), style: (_e = {}, _e[lengthString] = Math.min(100 - thumbOffsetPercent, 100 - zeroOffsetPercent) + '%', _e) }))) : (React.createElement(React.Fragment, null,
	                            React.createElement("span", { className: Utilities_1.css(classNames.lineContainer, classNames.activeSection), style: (_f = {}, _f[lengthString] = thumbOffsetPercent + '%', _f) }),
	                            React.createElement("span", { className: Utilities_1.css(classNames.lineContainer, classNames.inactiveSection), style: (_g = {}, _g[lengthString] = 100 - thumbOffsetPercent + '%', _g) }))))),
	                showValue && React.createElement(Label_1.Label, { className: classNames.valueLabel }, valueFormat ? valueFormat(value) : value))));
	        var _c, _d, _e, _f, _g;
	    };
	    SliderBase.prototype.focus = function () {
	        if (this._thumb.current) {
	            this._thumb.current.focus();
	        }
	    };
	    Object.defineProperty(SliderBase.prototype, "value", {
	        get: function () {
	            return this.state.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SliderBase.prototype._getStyleUsingOffsetPercent = function (vertical, thumbOffsetPercent) {
	        var direction = vertical ? 'bottom' : Utilities_1.getRTL() ? 'right' : 'left';
	        return _a = {},
	            _a[direction] = thumbOffsetPercent + '%',
	            _a;
	        var _a;
	    };
	    SliderBase.prototype._getPosition = function (event, vertical) {
	        var currentPosition;
	        switch (event.type) {
	            case 'mousedown':
	            case 'mousemove':
	                currentPosition = !vertical ? event.clientX : event.clientY;
	                break;
	            case 'touchstart':
	            case 'touchmove':
	                currentPosition = !vertical ? event.touches[0].clientX : event.touches[0].clientY;
	                break;
	        }
	        return currentPosition;
	    };
	    SliderBase.prototype._updateValue = function (value, renderedValue) {
	        var _this = this;
	        var step = this.props.step;
	        var numDec = 0;
	        if (isFinite(step)) {
	            while (Math.round(step * Math.pow(10, numDec)) / Math.pow(10, numDec) !== step) {
	                numDec++;
	            }
	        }
	        // Make sure value has correct number of decimal places based on number of decimals in step
	        var roundedValue = parseFloat(value.toFixed(numDec));
	        var valueChanged = roundedValue !== this.state.value;
	        this.setState({
	            value: roundedValue,
	            renderedValue: renderedValue
	        }, function () {
	            if (valueChanged && _this.props.onChange) {
	                _this.props.onChange(_this.state.value);
	            }
	        });
	    };
	    SliderBase.defaultProps = {
	        step: 1,
	        min: 0,
	        max: 10,
	        showValue: true,
	        disabled: false,
	        vertical: false,
	        buttonProps: {},
	        originFromZero: false
	    };
	    return SliderBase;
	}(Utilities_1.BaseComponent));
	exports.SliderBase = SliderBase;
	//# sourceMappingURL=Slider.base.js.map

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var utilities_1 = __webpack_require__(489);
	var GlobalClassNames = {
	    root: 'ms-Slider',
	    enabled: 'ms-Slider-enabled',
	    disabled: 'ms-Slider-disabled',
	    row: 'ms-Slider-row',
	    column: 'ms-Slider-column',
	    container: 'ms-Slider-container',
	    slideBox: 'ms-Slider-slideBox',
	    line: 'ms-Slider-line',
	    thumb: 'ms-Slider-thumb',
	    activeSection: 'ms-Slider-active',
	    inactiveSection: 'ms-Slider-inactive',
	    valueLabel: 'ms-Slider-value',
	    showValue: 'ms-Slider-showValue',
	    showTransitions: 'ms-Slider-showTransitions',
	    zeroTick: 'ms-Slider-zeroTick'
	};
	exports.getStyles = function (props) {
	    var className = props.className, titleLabelClassName = props.titleLabelClassName, theme = props.theme;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var slideBoxActiveSectionStyles = !props.disabled && {
	        backgroundColor: theme.palette.themePrimary,
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                backgroundColor: 'Highlight'
	            },
	            _a)
	    };
	    var slideBoxInactiveSectionStyles = !props.disabled && {
	        backgroundColor: theme.palette.themeLight,
	        selectors: (_b = {},
	            _b[Styling_1.HighContrastSelector] = {
	                borderColor: 'Highlight'
	            },
	            _b)
	    };
	    var slideBoxActiveThumbStyles = !props.disabled && {
	        border: "2px solid " + theme.palette.themePrimary,
	        selectors: (_c = {},
	            _c[Styling_1.HighContrastSelector] = {
	                borderColor: 'Highlight'
	            },
	            _c)
	    };
	    var slideBoxActiveZeroTickStyles = !props.disabled && {
	        backgroundColor: theme.palette.themeLight,
	        selectors: (_d = {},
	            _d[Styling_1.HighContrastSelector] = {
	                backgroundColor: 'Highlight'
	            },
	            _d)
	    };
	    return {
	        root: [
	            classNames.root,
	            theme.fonts.medium,
	            {
	                userSelect: 'none'
	            },
	            props.vertical && {
	                marginRight: 8
	            }
	        ].concat([!props.disabled ? classNames.enabled : undefined], [props.disabled ? classNames.disabled : undefined], [!props.vertical ? classNames.row : undefined], [props.vertical ? classNames.column : undefined], [
	            className
	        ]),
	        titleLabel: [
	            {
	                padding: 0
	            },
	            titleLabelClassName
	        ],
	        container: [
	            classNames.container,
	            {
	                display: 'flex',
	                flexWrap: 'nowrap',
	                alignItems: 'center'
	            },
	            props.vertical && {
	                flexDirection: 'column',
	                height: '100%',
	                textAlign: 'center',
	                margin: '8px 0'
	            }
	        ],
	        slideBox: [
	            classNames.slideBox,
	            Styling_1.getFocusStyle(theme),
	            {
	                background: 'transparent',
	                border: 'none',
	                flexGrow: 1,
	                lineHeight: 28,
	                display: 'flex',
	                alignItems: 'center',
	                selectors: {
	                    ':active $activeSection': slideBoxActiveSectionStyles,
	                    ':hover $activeSection': slideBoxActiveSectionStyles,
	                    ':active $inactiveSection': slideBoxInactiveSectionStyles,
	                    ':hover $inactiveSection': slideBoxInactiveSectionStyles,
	                    ':active $thumb': slideBoxActiveThumbStyles,
	                    ':hover $thumb': slideBoxActiveThumbStyles,
	                    ':active $zeroTick': slideBoxActiveZeroTickStyles,
	                    ':hover $zeroTick': slideBoxActiveZeroTickStyles,
	                    $thumb: [
	                        {
	                            borderWidth: 2,
	                            borderStyle: 'solid',
	                            borderColor: theme.palette.neutralSecondary,
	                            borderRadius: 10,
	                            boxSizing: 'border-box',
	                            background: theme.palette.white,
	                            display: 'block',
	                            width: 16,
	                            height: 16,
	                            position: 'absolute'
	                        },
	                        props.vertical
	                            ? {
	                                left: -6,
	                                margin: '0 auto',
	                                transform: 'translateY(8px)'
	                            }
	                            : {
	                                top: -6,
	                                transform: utilities_1.getRTL() ? 'translateX(50%)' : 'translateX(-50%)'
	                            },
	                        props.showTransitions && {
	                            transition: "left " + Styling_1.AnimationVariables.durationValue3 + " " + Styling_1.AnimationVariables.easeFunction1
	                        },
	                        props.disabled && {
	                            borderColor: theme.palette.neutralTertiaryAlt,
	                            selectors: (_e = {},
	                                _e[Styling_1.HighContrastSelector] = {
	                                    borderColor: 'GrayText'
	                                },
	                                _e)
	                        }
	                    ]
	                }
	            },
	            props.vertical
	                ? {
	                    height: '100%',
	                    width: 28,
	                    padding: '8px 0' // Make room for thumb at bottom of line
	                }
	                : {
	                    height: 28,
	                    width: 'auto',
	                    padding: '0 8px' // Make room for thumb at ends of line
	                }
	        ].concat([props.showValue ? classNames.showValue : undefined], [props.showTransitions ? classNames.showTransitions : undefined]),
	        thumb: [classNames.thumb],
	        line: [
	            classNames.line,
	            {
	                display: 'flex',
	                position: 'relative',
	                selectors: {
	                    $lineContainer: [
	                        {
	                            borderRadius: 4,
	                            boxSizing: 'border-box'
	                        },
	                        props.vertical
	                            ? {
	                                width: 4,
	                                height: '100%'
	                            }
	                            : {
	                                height: 4,
	                                width: '100%'
	                            }
	                    ]
	                }
	            },
	            props.vertical
	                ? {
	                    height: '100%',
	                    width: 4,
	                    margin: '0 auto',
	                    flexDirection: 'column-reverse'
	                }
	                : {
	                    width: '100%'
	                }
	        ],
	        lineContainer: [{}],
	        activeSection: [
	            classNames.activeSection,
	            {
	                background: theme.palette.neutralSecondary,
	                selectors: (_f = {},
	                    _f[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'WindowText'
	                    },
	                    _f)
	            },
	            props.showTransitions && {
	                transition: "width " + Styling_1.AnimationVariables.durationValue3 + " " + Styling_1.AnimationVariables.easeFunction1
	            },
	            props.disabled && {
	                background: theme.palette.neutralTertiaryAlt,
	                selectors: (_g = {},
	                    _g[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'GrayText',
	                        borderColor: 'GrayText'
	                    },
	                    _g)
	            }
	        ],
	        inactiveSection: [
	            classNames.inactiveSection,
	            {
	                background: theme.palette.neutralTertiaryAlt,
	                selectors: (_h = {},
	                    _h[Styling_1.HighContrastSelector] = {
	                        border: '1px solid WindowText'
	                    },
	                    _h)
	            },
	            props.showTransitions && {
	                transition: "width " + Styling_1.AnimationVariables.durationValue3 + " " + Styling_1.AnimationVariables.easeFunction1
	            },
	            props.disabled && {
	                background: theme.palette.neutralLight,
	                selectors: (_j = {},
	                    _j[Styling_1.HighContrastSelector] = {
	                        borderColor: 'GrayText'
	                    },
	                    _j)
	            }
	        ],
	        zeroTick: [
	            classNames.zeroTick,
	            {
	                position: 'absolute',
	                background: theme.palette.neutralTertiaryAlt,
	                selectors: (_k = {},
	                    _k[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'WindowText'
	                    },
	                    _k)
	            },
	            props.disabled && {
	                background: theme.palette.neutralLight,
	                selectors: (_l = {},
	                    _l[Styling_1.HighContrastSelector] = {
	                        backgroundColor: 'GrayText'
	                    },
	                    _l)
	            },
	            props.vertical
	                ? {
	                    width: '16px',
	                    height: '1px',
	                    transform: utilities_1.getRTL() ? 'translateX(6px)' : 'translateX(-6px)'
	                }
	                : {
	                    width: '1px',
	                    height: '16px',
	                    transform: 'translateY(-6px)'
	                }
	        ],
	        valueLabel: [
	            classNames.valueLabel,
	            {
	                flexShrink: 1,
	                width: 30,
	                lineHeight: '1' // using a string here meaning it's relative to the size of the font
	            },
	            props.vertical
	                ? {
	                    margin: '0 auto',
	                    whiteSpace: 'nowrap',
	                    width: 40
	                }
	                : {
	                    margin: '0 8px',
	                    whiteSpace: 'nowrap',
	                    width: 40
	                }
	        ]
	    };
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	};
	//# sourceMappingURL=Slider.styles.js.map

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1189), exports);
	//# sourceMappingURL=SpinButton.js.map

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1190), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Button_1 = __webpack_require__(691);
	var Label_1 = __webpack_require__(771);
	var Icon_1 = __webpack_require__(643);
	var Utilities_1 = __webpack_require__(592);
	var positioning_1 = __webpack_require__(609);
	var SpinButton_styles_1 = __webpack_require__(1191);
	var SpinButton_classNames_1 = __webpack_require__(1192);
	var KeytipData_1 = __webpack_require__(684);
	var KeyboardSpinDirection;
	(function (KeyboardSpinDirection) {
	    KeyboardSpinDirection[KeyboardSpinDirection["down"] = -1] = "down";
	    KeyboardSpinDirection[KeyboardSpinDirection["notSpinning"] = 0] = "notSpinning";
	    KeyboardSpinDirection[KeyboardSpinDirection["up"] = 1] = "up";
	})(KeyboardSpinDirection = exports.KeyboardSpinDirection || (exports.KeyboardSpinDirection = {}));
	var SpinButton = /** @class */ (function (_super) {
	    tslib_1.__extends(SpinButton, _super);
	    function SpinButton(props) {
	        var _this = _super.call(this, props) || this;
	        _this._input = React.createRef();
	        _this._initialStepDelay = 400;
	        _this._stepDelay = 75;
	        _this._onFocus = function (ev) {
	            // We can't set focus on a non-existing element
	            if (!_this._input.current) {
	                return;
	            }
	            if (_this._spinningByMouse || _this.state.keyboardSpinDirection !== KeyboardSpinDirection.notSpinning) {
	                _this._stop();
	            }
	            _this._input.current.select();
	            _this.setState({ isFocused: true });
	            if (_this.props.onFocus) {
	                _this.props.onFocus(ev);
	            }
	        };
	        _this._onBlur = function (ev) {
	            _this._validate(ev);
	            _this.setState({ isFocused: false });
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	        };
	        _this._onValidate = function (value, event) {
	            if (_this.props.onValidate) {
	                return _this.props.onValidate(value, event);
	            }
	            else {
	                return _this._defaultOnValidate(value);
	            }
	        };
	        _this._calculatePrecision = function (props) {
	            var _a = props.precision, precision = _a === void 0 ? Math.max(Utilities_1.calculatePrecision(props.step), 0) : _a;
	            return precision;
	        };
	        /**
	         * Validate function to use if one is not passed in
	         */
	        _this._defaultOnValidate = function (value) {
	            if (value === null || value.trim().length === 0 || isNaN(Number(value))) {
	                return _this._lastValidValue;
	            }
	            var newValue = Math.min(_this.props.max, Math.max(_this.props.min, Number(value)));
	            return String(newValue);
	        };
	        _this._onIncrement = function (value) {
	            if (_this.props.onIncrement) {
	                return _this.props.onIncrement(value);
	            }
	            else {
	                return _this._defaultOnIncrement(value);
	            }
	        };
	        /**
	         * Increment function to use if one is not passed in
	         */
	        _this._defaultOnIncrement = function (value) {
	            var _a = _this.props, max = _a.max, step = _a.step;
	            var newValue = Math.min(Number(value) + Number(step), max);
	            newValue = Utilities_1.precisionRound(newValue, _this._precision);
	            return String(newValue);
	        };
	        _this._onDecrement = function (value) {
	            if (_this.props.onDecrement) {
	                return _this.props.onDecrement(value);
	            }
	            else {
	                return _this._defaultOnDecrement(value);
	            }
	        };
	        /**
	         * Increment function to use if one is not passed in
	         */
	        _this._defaultOnDecrement = function (value) {
	            var _a = _this.props, min = _a.min, step = _a.step;
	            var newValue = Math.max(Number(value) - Number(step), min);
	            newValue = Utilities_1.precisionRound(newValue, _this._precision);
	            return String(newValue);
	        };
	        /**
	         * This is used when validating text entry
	         * in the input (not when changed via the buttons)
	         * @param event - the event that fired
	         */
	        _this._validate = function (event) {
	            if (_this.state.value !== undefined && _this._valueToValidate !== undefined && _this._valueToValidate !== _this._lastValidValue) {
	                var newValue = _this._onValidate(_this._valueToValidate, event);
	                if (newValue) {
	                    _this._lastValidValue = newValue;
	                    _this._valueToValidate = undefined;
	                    _this.setState({ value: newValue });
	                }
	            }
	        };
	        /**
	         * The method is needed to ensure we are updating the actual input value.
	         * without this our value will never change (and validation will not have the correct number)
	         * @param event - the event that was fired
	         */
	        _this._onInputChange = function (event) {
	            var element = event.target;
	            var value = element.value;
	            _this._valueToValidate = value;
	            _this.setState({
	                value: value
	            });
	        };
	        /**
	         * Update the value with the given stepFunction
	         * @param shouldSpin - should we fire off another updateValue when we are done here? This should be true
	         * when spinning in response to a mouseDown
	         * @param stepFunction - function to use to step by
	         */
	        _this._updateValue = function (shouldSpin, stepDelay, stepFunction) {
	            var newValue = stepFunction(_this.state.value);
	            if (newValue) {
	                _this._lastValidValue = newValue;
	                _this.setState({ value: newValue });
	            }
	            if (_this._spinningByMouse !== shouldSpin) {
	                _this._spinningByMouse = shouldSpin;
	            }
	            if (shouldSpin) {
	                _this._currentStepFunctionHandle = _this._async.setTimeout(function () {
	                    _this._updateValue(shouldSpin, _this._stepDelay, stepFunction);
	                }, stepDelay);
	            }
	        };
	        /**
	         * Stop spinning (clear any currently pending update and set spinning to false)
	         */
	        _this._stop = function () {
	            if (_this._currentStepFunctionHandle >= 0) {
	                _this._async.clearTimeout(_this._currentStepFunctionHandle);
	                _this._currentStepFunctionHandle = -1;
	            }
	            if (_this._spinningByMouse || _this.state.keyboardSpinDirection !== KeyboardSpinDirection.notSpinning) {
	                _this._spinningByMouse = false;
	                _this.setState({ keyboardSpinDirection: KeyboardSpinDirection.notSpinning });
	            }
	        };
	        /**
	         * Handle keydown on the text field. We need to update
	         * the value when up or down arrow are depressed
	         * @param event - the keyboardEvent that was fired
	         */
	        _this._handleKeyDown = function (event) {
	            // eat the up and down arrow keys to keep focus in the spinButton
	            // (especially when a spinButton is inside of a FocusZone)
	            if (event.which === Utilities_1.KeyCodes.up || event.which === Utilities_1.KeyCodes.down || event.which === Utilities_1.KeyCodes.enter) {
	                event.preventDefault();
	                event.stopPropagation();
	            }
	            if (_this.props.disabled) {
	                _this._stop();
	                return;
	            }
	            var spinDirection = KeyboardSpinDirection.notSpinning;
	            switch (event.which) {
	                case Utilities_1.KeyCodes.up:
	                    spinDirection = KeyboardSpinDirection.up;
	                    _this._updateValue(false /* shouldSpin */, _this._initialStepDelay, _this._onIncrement);
	                    break;
	                case Utilities_1.KeyCodes.down:
	                    spinDirection = KeyboardSpinDirection.down;
	                    _this._updateValue(false /* shouldSpin */, _this._initialStepDelay, _this._onDecrement);
	                    break;
	                case Utilities_1.KeyCodes.enter:
	                case Utilities_1.KeyCodes.tab:
	                    _this._validate(event);
	                    break;
	                case Utilities_1.KeyCodes.escape:
	                    if (_this.state.value !== _this._lastValidValue) {
	                        _this.setState({ value: _this._lastValidValue });
	                    }
	                    break;
	                default:
	                    break;
	            }
	            // style the increment/decrement button to look active
	            // when the corresponding up/down arrow keys trigger a step
	            if (_this.state.keyboardSpinDirection !== spinDirection) {
	                _this.setState({ keyboardSpinDirection: spinDirection });
	            }
	        };
	        /**
	         * Make sure that we have stopped spinning on keyUp
	         * if the up or down arrow fired this event
	         * @param event - keyboard event
	         */
	        _this._handleKeyUp = function (event) {
	            if (_this.props.disabled || event.which === Utilities_1.KeyCodes.up || event.which === Utilities_1.KeyCodes.down) {
	                _this._stop();
	                return;
	            }
	        };
	        _this._onIncrementMouseDown = function () {
	            _this._updateValue(true /* shouldSpin */, _this._initialStepDelay, _this._onIncrement);
	        };
	        _this._onDecrementMouseDown = function () {
	            _this._updateValue(true /* shouldSpin */, _this._initialStepDelay, _this._onDecrement);
	        };
	        _this._warnMutuallyExclusive({
	            value: 'defaultValue'
	        });
	        var value = props.value || props.defaultValue || String(props.min) || '0';
	        _this._lastValidValue = value;
	        // Ensure that the autocalculated precision is not negative.
	        _this._precision = _this._calculatePrecision(_this.props);
	        _this.state = {
	            isFocused: false,
	            value: value,
	            keyboardSpinDirection: KeyboardSpinDirection.notSpinning
	        };
	        _this._currentStepFunctionHandle = -1;
	        _this._labelId = Utilities_1.getId('Label');
	        _this._inputId = Utilities_1.getId('input');
	        _this._spinningByMouse = false;
	        _this._valueToValidate = undefined;
	        return _this;
	    }
	    /**
	     * Invoked when a component is receiving new props. This method is not called for the initial render.
	     */
	    SpinButton.prototype.componentWillReceiveProps = function (newProps) {
	        this._lastValidValue = this.state.value;
	        var value = newProps.value ? newProps.value : String(newProps.min);
	        if (newProps.defaultValue) {
	            value = String(Math.max(newProps.min, Math.min(newProps.max, Number(newProps.defaultValue))));
	        }
	        if (newProps.value !== undefined) {
	            this.setState({
	                value: value
	            });
	        }
	        this._precision = this._calculatePrecision(newProps);
	    };
	    SpinButton.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, disabled = _a.disabled, label = _a.label, min = _a.min, max = _a.max, labelPosition = _a.labelPosition, iconProps = _a.iconProps, incrementButtonIcon = _a.incrementButtonIcon, incrementButtonAriaLabel = _a.incrementButtonAriaLabel, decrementButtonIcon = _a.decrementButtonIcon, decrementButtonAriaLabel = _a.decrementButtonAriaLabel, title = _a.title, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, customStyles = _a.styles, customUpArrowButtonStyles = _a.upArrowButtonStyles, customDownArrowButtonStyles = _a.downArrowButtonStyles, theme = _a.theme, ariaPositionInSet = _a.ariaPositionInSet, ariaSetSize = _a.ariaSetSize, ariaValueNow = _a.ariaValueNow, ariaValueText = _a.ariaValueText, keytipProps = _a.keytipProps, className = _a.className;
	        var _b = this.state, isFocused = _b.isFocused, value = _b.value, keyboardSpinDirection = _b.keyboardSpinDirection;
	        var classNames = this.props.getClassNames
	            ? this.props.getClassNames(theme, !!disabled, !!isFocused, keyboardSpinDirection, labelPosition, className)
	            : SpinButton_classNames_1.getClassNames(SpinButton_styles_1.getStyles(theme, customStyles), !!disabled, !!isFocused, keyboardSpinDirection, labelPosition, className);
	        return (React.createElement("div", { className: classNames.root },
	            labelPosition !== positioning_1.Position.bottom && (React.createElement("div", { className: classNames.labelWrapper },
	                iconProps && React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps, { className: classNames.icon, "aria-hidden": "true" })),
	                label && (React.createElement(Label_1.Label, { id: this._labelId, htmlFor: this._inputId, className: classNames.label }, label)))),
	            React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (React.createElement("div", { className: classNames.spinButtonWrapper, title: title && title, "aria-label": ariaLabel && ariaLabel, "aria-posinset": ariaPositionInSet, "aria-setsize": ariaSetSize, "data-ktp-target": keytipAttributes['data-ktp-target'] },
	                React.createElement("input", { value: value, id: _this._inputId, onChange: _this._onChange, onInput: _this._onInputChange, className: classNames.input, type: "text", autoComplete: "off", role: "spinbutton", "aria-labelledby": label && _this._labelId, "aria-valuenow": !isNaN(Number(ariaValueNow)) ? ariaValueNow : !isNaN(Number(value)) ? Number(value) : undefined, "aria-valuetext": ariaValueText ? ariaValueText : isNaN(Number(value)) ? value : undefined, "aria-valuemin": min, "aria-valuemax": max, "aria-describedby": Utilities_1.mergeAriaAttributeValues(ariaDescribedBy, keytipAttributes['aria-describedby']), onBlur: _this._onBlur, ref: _this._input, onFocus: _this._onFocus, onKeyDown: _this._handleKeyDown, onKeyUp: _this._handleKeyUp, readOnly: disabled, "aria-disabled": disabled, "data-lpignore": true, "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'] }),
	                React.createElement("span", { className: classNames.arrowBox },
	                    React.createElement(Button_1.IconButton, { styles: SpinButton_styles_1.getArrowButtonStyles(theme, true, customUpArrowButtonStyles), className: 'ms-UpButton', checked: keyboardSpinDirection === KeyboardSpinDirection.up, disabled: disabled, iconProps: incrementButtonIcon, onMouseDown: _this._onIncrementMouseDown, onMouseLeave: _this._stop, onMouseUp: _this._stop, tabIndex: -1, ariaLabel: incrementButtonAriaLabel, "data-is-focusable": false }),
	                    React.createElement(Button_1.IconButton, { styles: SpinButton_styles_1.getArrowButtonStyles(theme, false, customDownArrowButtonStyles), className: 'ms-DownButton', checked: keyboardSpinDirection === KeyboardSpinDirection.down, disabled: disabled, iconProps: decrementButtonIcon, onMouseDown: _this._onDecrementMouseDown, onMouseLeave: _this._stop, onMouseUp: _this._stop, tabIndex: -1, ariaLabel: decrementButtonAriaLabel, "data-is-focusable": false })))); }),
	            labelPosition === positioning_1.Position.bottom && (React.createElement("div", { className: classNames.labelWrapper },
	                iconProps && React.createElement(Icon_1.Icon, { iconName: iconProps.iconName, className: classNames.icon, "aria-hidden": "true" }),
	                label && (React.createElement(Label_1.Label, { id: this._labelId, htmlFor: this._inputId, className: classNames.label }, label))))));
	    };
	    SpinButton.prototype.focus = function () {
	        if (this._input.current) {
	            this._input.current.focus();
	        }
	    };
	    Object.defineProperty(SpinButton.prototype, "value", {
	        /**
	         * Gets the value of the spin button.
	         */
	        get: function () {
	            return this.props.value === undefined ? this.state.value : this.props.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SpinButton.prototype._onChange = function () {
	        /**
	         * A noop input change handler.
	         * https://github.com/facebook/react/issues/7027.
	         * Using the native onInput handler fixes the issue but onChange
	         * still need to be wired to avoid React console errors
	         * TODO: Check if issue is resolved when React 16 is available.
	         */
	    };
	    SpinButton.defaultProps = {
	        step: 1,
	        min: 0,
	        max: 100,
	        disabled: false,
	        labelPosition: positioning_1.Position.start,
	        label: '',
	        incrementButtonIcon: { iconName: 'ChevronUpSmall' },
	        decrementButtonIcon: { iconName: 'ChevronDownSmall' }
	    };
	    SpinButton = tslib_1.__decorate([
	        Utilities_1.customizable('SpinButton', ['theme', 'styles'], true)
	    ], SpinButton);
	    return SpinButton;
	}(Utilities_1.BaseComponent));
	exports.SpinButton = SpinButton;
	//# sourceMappingURL=SpinButton.js.map

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var _getDisabledStyles = Utilities_1.memoizeFunction(function (theme) {
	    var semanticColors = theme.semanticColors;
	    var SpinButtonTextColorDisabled = semanticColors.disabledText;
	    var SpinButtonBackgroundColorDisabled = semanticColors.disabledBackground;
	    return {
	        backgroundColor: SpinButtonBackgroundColorDisabled,
	        borderColor: 'transparent',
	        pointerEvents: 'none',
	        cursor: 'default',
	        color: SpinButtonTextColorDisabled,
	        selectors: (_a = {},
	            _a[Styling_1.HighContrastSelector] = {
	                color: 'GrayText'
	            },
	            _a)
	    };
	    var _a;
	});
	exports.getArrowButtonStyles = Utilities_1.memoizeFunction(function (theme, isUpArrow, customSpecificArrowStyles) {
	    var semanticColors = theme.semanticColors;
	    var ArrowButtonTextColor = semanticColors.buttonText;
	    var ArrowButtonTextColorHovered = semanticColors.buttonTextHovered;
	    var ArrowButtonTextColorPressed = semanticColors.buttonTextChecked;
	    var ArrowButtonBackgroundHovered = semanticColors.buttonBackgroundHovered;
	    var ArrowButtonBackgroundPressed = semanticColors.buttonBackgroundChecked;
	    var defaultArrowButtonStyles = {
	        root: {
	            outline: 'none',
	            display: 'block',
	            height: '50%',
	            width: '14px',
	            padding: '0',
	            backgroundColor: 'transparent',
	            textAlign: 'center',
	            cursor: 'default',
	            color: ArrowButtonTextColor
	        },
	        rootHovered: {
	            backgroundColor: ArrowButtonBackgroundHovered,
	            color: ArrowButtonTextColorHovered
	        },
	        rootChecked: {
	            backgroundColor: ArrowButtonBackgroundPressed,
	            color: ArrowButtonTextColorPressed,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'Highlight',
	                    color: 'HighlightText'
	                },
	                _a)
	        },
	        rootPressed: {
	            backgroundColor: ArrowButtonBackgroundPressed,
	            color: ArrowButtonTextColorPressed,
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'Highlight',
	                    color: 'HighlightText'
	                },
	                _b)
	        },
	        rootDisabled: {
	            opacity: 0.5,
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText',
	                    opacity: 1
	                },
	                _c)
	        },
	        icon: {
	            fontSize: '6px',
	            marginTop: '0',
	            marginRight: '0',
	            marginBottom: '0',
	            marginLeft: '0'
	        }
	    };
	    // No specific styles needed as of now.
	    var defaultUpArrowButtonStyles = {};
	    var defaultDownArrowButtonStyles = {};
	    return Styling_1.concatStyleSets(defaultArrowButtonStyles, isUpArrow ? defaultUpArrowButtonStyles : defaultDownArrowButtonStyles, customSpecificArrowStyles);
	    var _a, _b, _c;
	});
	exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
	    var palette = theme.palette, semanticColors = theme.semanticColors;
	    var SpinButtonRootBorderColor = semanticColors.inputBorder;
	    var SpinButtonRootBorderColorHovered = semanticColors.inputBorderHovered;
	    var SpinButtonRootBorderColorFocused = semanticColors.inputFocusBorderAlt;
	    var SpinButtonTextColorDisabled = semanticColors.disabledText;
	    var SpinButtonInputTextColor = semanticColors.bodyText;
	    var SpinButtonInputTextColorSelected = palette.white;
	    var SpinButtonInputBackgroundColorSelected = palette.themePrimary;
	    var SpinButtonIconDisabledColor = semanticColors.disabledText;
	    var defaultStyles = {
	        root: {
	            outline: 'none',
	            fontSize: Styling_1.FontSizes.medium,
	            width: '100%',
	            minWidth: '86px'
	        },
	        labelWrapper: {
	            display: 'inline-flex'
	        },
	        labelWrapperStart: {
	            float: 'left',
	            marginRight: '10px'
	        },
	        labelWrapperEnd: {
	            float: 'right',
	            marginLeft: '10px'
	        },
	        labelWrapperTop: {
	            marginBottom: '10px'
	        },
	        labelWrapperBottom: {
	            marginTop: '10px'
	        },
	        icon: {
	            padding: '2px 5px',
	            fontSize: '20px'
	        },
	        iconDisabled: {
	            color: SpinButtonIconDisabledColor
	        },
	        label: {
	            pointerEvents: 'none',
	            padding: '2px 0'
	        },
	        labelDisabled: {
	            cursor: 'default',
	            color: SpinButtonTextColorDisabled,
	            selectors: (_a = {},
	                _a[Styling_1.HighContrastSelector] = {
	                    color: 'GrayText'
	                },
	                _a)
	        },
	        spinButtonWrapper: {
	            display: 'flex',
	            boxSizing: 'border-box',
	            height: '32px',
	            minWidth: '86px',
	            borderWidth: '1px',
	            borderStyle: 'solid',
	            borderColor: SpinButtonRootBorderColor
	        },
	        spinButtonWrapperTopBottom: {
	            width: '100%'
	        },
	        spinButtonWrapperHovered: {
	            borderColor: SpinButtonRootBorderColorHovered,
	            outline: '2px dashed transparent',
	            selectors: (_b = {},
	                _b[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight',
	                    outline: 'none'
	                },
	                _b)
	        },
	        spinButtonWrapperFocused: {
	            borderColor: SpinButtonRootBorderColorFocused,
	            outline: '2px dashed transparent',
	            selectors: (_c = {},
	                _c[Styling_1.HighContrastSelector] = {
	                    borderColor: 'Highlight',
	                    outline: 'none'
	                },
	                _c)
	        },
	        spinButtonWrapperDisabled: _getDisabledStyles(theme),
	        input: {
	            boxSizing: 'border-box',
	            boxShadow: 'none',
	            borderStyle: 'none',
	            marginTop: '0',
	            marginRight: '0',
	            marginBottom: '0',
	            marginLeft: '0',
	            fontSize: Styling_1.FontSizes.medium,
	            color: SpinButtonInputTextColor,
	            height: '100%',
	            padding: '0 12px',
	            outline: '0',
	            textOverflow: 'ellipsis',
	            display: 'block',
	            float: 'left',
	            width: 'calc(100% - 14px)',
	            minWidth: '72px',
	            overflow: 'hidden',
	            cursor: 'text',
	            userSelect: 'text'
	        },
	        inputTextSelected: {
	            backgroundColor: SpinButtonInputBackgroundColorSelected,
	            color: SpinButtonInputTextColorSelected,
	            selectors: (_d = {},
	                _d[Styling_1.HighContrastSelector] = {
	                    backgroundColor: 'Highlight',
	                    borderColor: 'Highlight',
	                    color: 'HighlightText'
	                },
	                _d)
	        },
	        inputDisabled: _getDisabledStyles(theme),
	        arrowButtonsContainer: {
	            outline: 'none',
	            fontSize: '12px',
	            display: 'block',
	            float: 'left',
	            height: '100%',
	            cursor: 'default',
	            padding: '0',
	            boxSizing: 'border-box'
	        },
	        arrowButtonsContainerDisabled: _getDisabledStyles(theme)
	    };
	    return Styling_1.concatStyleSets(defaultStyles, customStyles);
	    var _a, _b, _c, _d;
	});
	//# sourceMappingURL=SpinButton.styles.js.map

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	var positioning_1 = __webpack_require__(609);
	exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, isFocused, keyboardSpinDirection, labelPosition, className) {
	    if (labelPosition === void 0) { labelPosition = positioning_1.Position.start; }
	    if (className === void 0) { className = undefined; }
	    return {
	        root: Styling_1.mergeStyles(styles.root, className),
	        labelWrapper: Styling_1.mergeStyles(styles.labelWrapper, _getStyleForLabelBasedOnPosition(labelPosition, styles)),
	        icon: Styling_1.mergeStyles(styles.icon, disabled && styles.iconDisabled),
	        label: Styling_1.mergeStyles(styles.label, disabled && styles.labelDisabled),
	        spinButtonWrapper: Styling_1.mergeStyles(styles.spinButtonWrapper, _getStyleForRootBasedOnPosition(labelPosition, styles), !disabled && [
	            {
	                selectors: {
	                    ':hover': styles.spinButtonWrapperHovered
	                }
	            },
	            isFocused && {
	                // This is to increase the specifity of the focus styles
	                // and make it equal to that of the hover styles.
	                selectors: {
	                    '&&': styles.spinButtonWrapperFocused
	                }
	            }
	        ], disabled && styles.spinButtonWrapperDisabled),
	        input: Styling_1.mergeStyles('ms-spinButton-input', styles.input, !disabled && {
	            selectors: {
	                '::selection': styles.inputTextSelected
	            }
	        }, disabled && styles.inputDisabled),
	        arrowBox: Styling_1.mergeStyles(styles.arrowButtonsContainer, disabled && styles.arrowButtonsContainerDisabled)
	    };
	});
	/**
	 * Returns the Style corresponding to the label position
	 */
	function _getStyleForLabelBasedOnPosition(labelPosition, styles) {
	    switch (labelPosition) {
	        case positioning_1.Position.start:
	            return styles.labelWrapperStart;
	        case positioning_1.Position.end:
	            return styles.labelWrapperEnd;
	        case positioning_1.Position.top:
	            return styles.labelWrapperTop;
	        case positioning_1.Position.bottom:
	            return styles.labelWrapperBottom;
	    }
	}
	/**
	 * Returns the Style corresponding to the label position
	 */
	function _getStyleForRootBasedOnPosition(labelPosition, styles) {
	    switch (labelPosition) {
	        case positioning_1.Position.top:
	        case positioning_1.Position.bottom:
	            return styles.spinButtonWrapperTopBottom;
	        default:
	            return {};
	    }
	}
	//# sourceMappingURL=SpinButton.classNames.js.map

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1194), exports);
	//# sourceMappingURL=Stack.js.map

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1195), exports);
	tslib_1.__exportStar(__webpack_require__(1197), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @jsx withSlots */
	var React = __webpack_require__(38);
	var Foundation_1 = __webpack_require__(1039);
	var StackItem_styles_1 = __webpack_require__(1196);
	var view = function (props) {
	    var children = props.children;
	    if (React.Children.count(children) < 1) {
	        return null;
	    }
	    var Slots = Foundation_1.getSlots(props, {
	        root: 'div'
	    });
	    return Foundation_1.withSlots(Slots.root, null, children);
	};
	exports.StackItem = Foundation_1.createComponent({
	    displayName: 'StackItem',
	    styles: StackItem_styles_1.StackItemStyles,
	    view: view
	});
	exports.default = exports.StackItem;
	//# sourceMappingURL=StackItem.js.map

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    root: 'ms-StackItem'
	};
	var alignMap = {
	    start: 'flex-start',
	    end: 'flex-end'
	};
	exports.StackItemStyles = function (props, theme, tokens) {
	    var grow = props.grow, shrink = props.shrink, disableShrink = props.disableShrink, align = props.align, verticalFill = props.verticalFill, order = props.order, className = props.className;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: [
	            theme.fonts.medium,
	            classNames.root,
	            {
	                margin: tokens.margin,
	                height: verticalFill ? '100%' : 'auto',
	                width: 'auto'
	            },
	            grow && { flexGrow: grow === true ? 1 : grow },
	            (disableShrink || (!grow && !shrink)) && {
	                flexShrink: 0
	            },
	            shrink &&
	                !disableShrink && {
	                flexShrink: 1
	            },
	            align && {
	                alignSelf: alignMap[align] || align
	            },
	            order && {
	                order: order
	            },
	            className
	        ]
	        // TODO: this cast may be hiding some potential issues with styling and name
	        //        lookups and should be removed
	    };
	};
	//# sourceMappingURL=StackItem.styles.js.map

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/** @jsx withSlots */
	var React = __webpack_require__(38);
	var Foundation_1 = __webpack_require__(1039);
	var StackItem_1 = __webpack_require__(1195);
	var Stack_styles_1 = __webpack_require__(1198);
	var Utilities_1 = __webpack_require__(592);
	var StackItemType = Foundation_1.withSlots(StackItem_1.default, null).type;
	var view = function (props) {
	    var _a = props.as, RootType = _a === void 0 ? 'div' : _a, disableShrink = props.disableShrink, wrap = props.wrap, rest = tslib_1.__rest(props, ["as", "disableShrink", "wrap"]);
	    var stackChildren = React.Children.map(props.children, function (child, index) {
	        if (!child) {
	            return null;
	        }
	        if (child.type === StackItemType) {
	            var defaultItemProps = {
	                shrink: !disableShrink
	            };
	            return React.cloneElement(child, tslib_1.__assign({}, defaultItemProps, child.props));
	        }
	        return child;
	    });
	    var nativeProps = Utilities_1.getNativeProps(rest, Utilities_1.htmlElementProperties);
	    var Slots = Foundation_1.getSlots(props, {
	        root: RootType,
	        inner: 'div'
	    });
	    if (wrap) {
	        return (Foundation_1.withSlots(Slots.root, tslib_1.__assign({}, nativeProps),
	            Foundation_1.withSlots(Slots.inner, null, stackChildren)));
	    }
	    return Foundation_1.withSlots(Slots.root, tslib_1.__assign({}, nativeProps), stackChildren);
	};
	var StackStatics = {
	    Item: StackItem_1.default
	};
	exports.Stack = Foundation_1.createComponent({
	    displayName: 'Stack',
	    styles: Stack_styles_1.styles,
	    view: view,
	    statics: StackStatics
	});
	exports.default = exports.Stack;
	//# sourceMappingURL=Stack.js.map

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var StackUtils_1 = __webpack_require__(1199);
	var Styling_1 = __webpack_require__(463);
	var nameMap = {
	    start: 'flex-start',
	    end: 'flex-end'
	};
	var GlobalClassNames = {
	    root: 'ms-Stack',
	    inner: 'ms-Stack-inner'
	};
	exports.styles = function (props, theme, tokens) {
	    var verticalFill = props.verticalFill, maxWidth = props.maxWidth, maxHeight = props.maxHeight, horizontal = props.horizontal, reversed = props.reversed, gap = props.gap, grow = props.grow, wrap = props.wrap, padding = props.padding, horizontalAlign = props.horizontalAlign, verticalAlign = props.verticalAlign, disableShrink = props.disableShrink, className = props.className;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    var childrenGap = tokens && tokens.childrenGap ? tokens.childrenGap : gap;
	    var _a = StackUtils_1.parseGap(childrenGap, theme), rowGap = _a.rowGap, columnGap = _a.columnGap;
	    var horizontalMargin = "" + -0.5 * columnGap.value + columnGap.unit;
	    var verticalMargin = "" + -0.5 * rowGap.value + rowGap.unit;
	    // styles to be applied to all direct children regardless of wrap or direction
	    var childStyles = {
	        textOverflow: 'ellipsis'
	    };
	    // selectors to be applied regardless of wrap or direction
	    var commonSelectors = {
	        // flexShrink styles are applied by the StackItem
	        '> *:not(.ms-StackItem)': {
	            flexShrink: disableShrink ? 0 : 1
	        }
	    };
	    if (wrap) {
	        return {
	            root: [
	                classNames.root,
	                {
	                    flexWrap: 'wrap',
	                    maxWidth: maxWidth,
	                    maxHeight: maxHeight,
	                    width: 'auto',
	                    overflow: 'visible',
	                    height: '100%'
	                },
	                horizontalAlign && (_b = {},
	                    _b[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
	                    _b),
	                verticalAlign && (_c = {},
	                    _c[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
	                    _c),
	                className,
	                {
	                    // not allowed to be overridden by className
	                    // since this is necessary in order to prevent collapsing margins
	                    display: 'flex'
	                },
	                horizontal && {
	                    height: verticalFill ? '100%' : 'auto'
	                }
	            ],
	            inner: [
	                classNames.inner,
	                {
	                    display: 'flex',
	                    flexWrap: 'wrap',
	                    marginLeft: horizontalMargin,
	                    marginRight: horizontalMargin,
	                    marginTop: verticalMargin,
	                    marginBottom: verticalMargin,
	                    overflow: 'visible',
	                    boxSizing: 'border-box',
	                    padding: StackUtils_1.parsePadding(padding, theme),
	                    // avoid unnecessary calc() calls if horizontal gap is 0
	                    width: columnGap.value === 0 ? '100%' : "calc(100% + " + columnGap.value + columnGap.unit + ")",
	                    maxWidth: '100vw',
	                    selectors: tslib_1.__assign({ '> *': tslib_1.__assign({ margin: "" + 0.5 * rowGap.value + rowGap.unit + " " + 0.5 * columnGap.value + columnGap.unit }, childStyles) }, commonSelectors)
	                },
	                horizontalAlign && (_d = {},
	                    _d[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
	                    _d),
	                verticalAlign && (_e = {},
	                    _e[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
	                    _e),
	                horizontal && {
	                    flexDirection: reversed ? 'row-reverse' : 'row',
	                    // avoid unnecessary calc() calls if vertical gap is 0
	                    height: rowGap.value === 0 ? '100%' : "calc(100% + " + rowGap.value + rowGap.unit + ")",
	                    selectors: {
	                        '> *': {
	                            maxWidth: columnGap.value === 0 ? '100%' : "calc(100% - " + columnGap.value + columnGap.unit + ")"
	                        }
	                    }
	                },
	                !horizontal && {
	                    flexDirection: reversed ? 'column-reverse' : 'column',
	                    height: "calc(100% + " + rowGap.value + rowGap.unit + ")",
	                    selectors: {
	                        '> *': {
	                            maxHeight: rowGap.value === 0 ? '100%' : "calc(100% - " + rowGap.value + rowGap.unit + ")"
	                        }
	                    }
	                }
	            ]
	        };
	    }
	    return {
	        root: [
	            classNames.root,
	            {
	                display: 'flex',
	                flexDirection: horizontal ? (reversed ? 'row-reverse' : 'row') : reversed ? 'column-reverse' : 'column',
	                flexWrap: 'nowrap',
	                width: 'auto',
	                height: verticalFill ? '100%' : 'auto',
	                maxWidth: maxWidth,
	                maxHeight: maxHeight,
	                padding: StackUtils_1.parsePadding(padding, theme),
	                boxSizing: 'border-box',
	                selectors: tslib_1.__assign((_f = { '> *': childStyles }, _f[reversed ? '> *:not(:last-child)' : '> *:not(:first-child)'] = [
	                    horizontal && {
	                        marginLeft: "" + columnGap.value + columnGap.unit
	                    },
	                    !horizontal && {
	                        marginTop: "" + rowGap.value + rowGap.unit
	                    }
	                ], _f), commonSelectors)
	            },
	            grow && {
	                flexGrow: grow === true ? 1 : grow,
	                overflow: 'hidden'
	            },
	            horizontalAlign && (_g = {},
	                _g[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
	                _g),
	            verticalAlign && (_h = {},
	                _h[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
	                _h),
	            className
	        ]
	        // TODO: this cast may be hiding some potential issues with styling and name
	        //        lookups and should be removed
	    };
	    var _b, _c, _d, _e, _f, _g, _h;
	};
	//# sourceMappingURL=Stack.styles.js.map

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Functions used by Stack components to simplify style-related computations
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Helper function that converts a themed spacing key (if given) to the corresponding themed spacing value.
	var _getThemedSpacing = function (space, theme) {
	    if (theme.spacing.hasOwnProperty(space)) {
	        return theme.spacing[space];
	    }
	    return space;
	};
	// Helper function that takes a gap as a string and converts it into a { value, unit } representation.
	var _getValueUnitGap = function (gap) {
	    var numericalPart = parseFloat(gap);
	    var numericalValue = isNaN(numericalPart) ? 0 : numericalPart;
	    var numericalString = isNaN(numericalPart) ? '' : numericalPart.toString();
	    var unitPart = gap.substring(numericalString.toString().length);
	    return {
	        value: numericalValue,
	        unit: unitPart || 'px'
	    };
	};
	/**
	 * Takes in a gap size in either a CSS-style format (e.g. 10 or "10px")
	 *  or a key of a themed spacing value (e.g. "s1").
	 * Returns the separate numerical value of the padding (e.g. 10)
	 *  and the CSS unit (e.g. "px").
	 */
	exports.parseGap = function (gap, theme) {
	    if (gap === undefined || gap === '') {
	        return {
	            rowGap: {
	                value: 0,
	                unit: 'px'
	            },
	            columnGap: {
	                value: 0,
	                unit: 'px'
	            }
	        };
	    }
	    if (typeof gap === 'number') {
	        return {
	            rowGap: {
	                value: gap,
	                unit: 'px'
	            },
	            columnGap: {
	                value: gap,
	                unit: 'px'
	            }
	        };
	    }
	    var splitGap = gap.split(' ');
	    // If the array has more than two values, then return 0px.
	    if (splitGap.length > 2) {
	        return {
	            rowGap: {
	                value: 0,
	                unit: 'px'
	            },
	            columnGap: {
	                value: 0,
	                unit: 'px'
	            }
	        };
	    }
	    // If the array has two values, then parse each one.
	    if (splitGap.length === 2) {
	        return {
	            rowGap: _getValueUnitGap(_getThemedSpacing(splitGap[0], theme)),
	            columnGap: _getValueUnitGap(_getThemedSpacing(splitGap[1], theme))
	        };
	    }
	    // Else, parse the numerical value and pass it as both the vertical and horizontal gap.
	    var calculatedGap = _getValueUnitGap(_getThemedSpacing(gap, theme));
	    return {
	        rowGap: calculatedGap,
	        columnGap: calculatedGap
	    };
	};
	/**
	 * Takes in a padding in a CSS-style format (e.g. 10, "10px", "10px 10px", etc.)
	 *  where the separate padding values can also be the key of a themed spacing value
	 *  (e.g. "s1 m", "10px l1 20px l2", etc.).
	 * Returns a CSS-style padding.
	 */
	exports.parsePadding = function (padding, theme) {
	    if (padding === undefined || typeof padding === 'number' || padding === '') {
	        return padding;
	    }
	    var paddingValues = padding.split(' ');
	    if (paddingValues.length < 2) {
	        return _getThemedSpacing(padding, theme);
	    }
	    return paddingValues.reduce(function (padding1, padding2) {
	        return _getThemedSpacing(padding1, theme) + ' ' + _getThemedSpacing(padding2, theme);
	    });
	};
	//# sourceMappingURL=StackUtils.js.map

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1201), exports);
	//# sourceMappingURL=Sticky.js.map

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1202), exports);
	tslib_1.__exportStar(__webpack_require__(1203), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var PropTypes = __webpack_require__(53);
	var Utilities_1 = __webpack_require__(592);
	var Sticky_types_1 = __webpack_require__(1203);
	var Sticky = /** @class */ (function (_super) {
	    tslib_1.__extends(Sticky, _super);
	    function Sticky(props) {
	        var _this = _super.call(this, props) || this;
	        _this._root = React.createRef();
	        _this._stickyContentTop = React.createRef();
	        _this._stickyContentBottom = React.createRef();
	        _this._nonStickyContent = React.createRef();
	        _this._placeHolder = React.createRef();
	        _this.syncScroll = function (container) {
	            var nonStickyContent = _this.nonStickyContent;
	            if (nonStickyContent && _this.props.isScrollSynced) {
	                nonStickyContent.scrollLeft = container.scrollLeft;
	            }
	        };
	        _this._onScrollEvent = function (container, footerStickyContainer) {
	            if (_this.root && _this.nonStickyContent) {
	                var distanceFromTop = _this._getNonStickyDistanceFromTop(container);
	                var isStickyTop = false;
	                var isStickyBottom = false;
	                if (_this.canStickyTop) {
	                    var distanceToStickTop = distanceFromTop - _this._getStickyDistanceFromTop();
	                    isStickyTop = distanceToStickTop < container.scrollTop;
	                }
	                // Can sticky bottom if the scrollablePane - total sticky footer height is smaller than the sticky's distance from the top of the pane
	                if (_this.canStickyBottom && container.clientHeight - footerStickyContainer.offsetHeight <= distanceFromTop) {
	                    isStickyBottom =
	                        distanceFromTop - Math.floor(container.scrollTop) >= _this._getStickyDistanceFromTopForFooter(container, footerStickyContainer);
	                }
	                if (document.activeElement &&
	                    _this.nonStickyContent.contains(document.activeElement) &&
	                    (_this.state.isStickyTop !== isStickyTop || _this.state.isStickyBottom !== isStickyBottom)) {
	                    _this._activeElement = document.activeElement;
	                }
	                else {
	                    _this._activeElement = undefined;
	                }
	                _this.setState({
	                    isStickyTop: _this.canStickyTop && isStickyTop,
	                    isStickyBottom: isStickyBottom,
	                    distanceFromTop: distanceFromTop
	                });
	            }
	        };
	        _this._getStickyDistanceFromTop = function () {
	            var distance = 0;
	            if (_this.stickyContentTop) {
	                distance = _this.stickyContentTop.offsetTop;
	            }
	            return distance;
	        };
	        _this._getStickyDistanceFromTopForFooter = function (container, footerStickyVisibleContainer) {
	            var distance = 0;
	            if (_this.stickyContentBottom) {
	                distance = container.clientHeight - footerStickyVisibleContainer.offsetHeight + _this.stickyContentBottom.offsetTop;
	            }
	            return distance;
	        };
	        _this._getNonStickyDistanceFromTop = function (container) {
	            var distance = 0;
	            var currElem = _this.root;
	            if (currElem) {
	                while (currElem && currElem.offsetParent !== container) {
	                    distance += currElem.offsetTop;
	                    currElem = currElem.offsetParent;
	                }
	                if (currElem && currElem.offsetParent === container) {
	                    distance += currElem.offsetTop;
	                }
	            }
	            return distance;
	        };
	        _this.state = {
	            isStickyTop: false,
	            isStickyBottom: false,
	            distanceFromTop: undefined
	        };
	        _this._activeElement = undefined;
	        return _this;
	    }
	    Object.defineProperty(Sticky.prototype, "root", {
	        get: function () {
	            return this._root.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "placeholder", {
	        get: function () {
	            return this._placeHolder.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "stickyContentTop", {
	        get: function () {
	            return this._stickyContentTop.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "stickyContentBottom", {
	        get: function () {
	            return this._stickyContentBottom.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "nonStickyContent", {
	        get: function () {
	            return this._nonStickyContent.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "canStickyTop", {
	        get: function () {
	            return this.props.stickyPosition === Sticky_types_1.StickyPositionType.Both || this.props.stickyPosition === Sticky_types_1.StickyPositionType.Header;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Sticky.prototype, "canStickyBottom", {
	        get: function () {
	            return this.props.stickyPosition === Sticky_types_1.StickyPositionType.Both || this.props.stickyPosition === Sticky_types_1.StickyPositionType.Footer;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Sticky.prototype.componentDidMount = function () {
	        var scrollablePane = this.context.scrollablePane;
	        if (!scrollablePane) {
	            return;
	        }
	        scrollablePane.subscribe(this._onScrollEvent);
	        scrollablePane.addSticky(this);
	    };
	    Sticky.prototype.componentWillUnmount = function () {
	        var scrollablePane = this.context.scrollablePane;
	        if (!scrollablePane) {
	            return;
	        }
	        scrollablePane.unsubscribe(this._onScrollEvent);
	        scrollablePane.removeSticky(this);
	    };
	    Sticky.prototype.componentDidUpdate = function (prevProps, prevState) {
	        var scrollablePane = this.context.scrollablePane;
	        if (!scrollablePane) {
	            return;
	        }
	        var _a = this.state, isStickyBottom = _a.isStickyBottom, isStickyTop = _a.isStickyTop, distanceFromTop = _a.distanceFromTop;
	        var syncScroll = false;
	        if (prevState.distanceFromTop !== distanceFromTop) {
	            scrollablePane.sortSticky(this, true /*sortAgain*/);
	            syncScroll = true;
	        }
	        if (prevState.isStickyTop !== isStickyTop || prevState.isStickyBottom !== isStickyBottom) {
	            if (this._activeElement) {
	                this._activeElement.focus();
	            }
	            scrollablePane.updateStickyRefHeights();
	            syncScroll = true;
	        }
	        if (syncScroll) {
	            // Sync Sticky scroll position with content container on each update
	            scrollablePane.syncScrollSticky(this);
	        }
	    };
	    Sticky.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        if (!this.context.scrollablePane) {
	            return true;
	        }
	        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom, distanceFromTop = _a.distanceFromTop;
	        return (isStickyTop !== nextState.isStickyTop ||
	            isStickyBottom !== nextState.isStickyBottom ||
	            this.props.stickyPosition !== nextProps.stickyPosition ||
	            this.props.children !== nextProps.children ||
	            distanceFromTop !== nextState.distanceFromTop ||
	            _isOffsetHeightDifferent(this._nonStickyContent, this._stickyContentTop) ||
	            _isOffsetHeightDifferent(this._nonStickyContent, this._stickyContentBottom) ||
	            _isOffsetHeightDifferent(this._nonStickyContent, this._placeHolder));
	    };
	    Sticky.prototype.render = function () {
	        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
	        var _b = this.props, stickyClassName = _b.stickyClassName, children = _b.children;
	        if (!this.context.scrollablePane) {
	            return React.createElement("div", null, this.props.children);
	        }
	        return (React.createElement("div", { ref: this._root },
	            this.canStickyTop && (React.createElement("div", { ref: this._stickyContentTop, "aria-hidden": !isStickyTop, style: { pointerEvents: isStickyTop ? 'auto' : 'none' } },
	                React.createElement("div", { style: this._getStickyPlaceholderHeight(isStickyTop) }))),
	            this.canStickyBottom && (React.createElement("div", { ref: this._stickyContentBottom, "aria-hidden": !isStickyBottom, style: { pointerEvents: isStickyBottom ? 'auto' : 'none' } },
	                React.createElement("div", { style: this._getStickyPlaceholderHeight(isStickyBottom) }))),
	            React.createElement("div", { style: this._getNonStickyPlaceholderHeightAndWidth(), ref: this._placeHolder },
	                React.createElement("div", { ref: this._nonStickyContent, className: isStickyTop || isStickyBottom ? stickyClassName : undefined, style: this._getContentStyles(isStickyTop || isStickyBottom) }, children))));
	    };
	    Sticky.prototype.addSticky = function (stickyContent) {
	        if (this.nonStickyContent) {
	            stickyContent.appendChild(this.nonStickyContent);
	        }
	    };
	    Sticky.prototype.resetSticky = function () {
	        if (this.nonStickyContent && this.placeholder) {
	            this.placeholder.appendChild(this.nonStickyContent);
	        }
	    };
	    Sticky.prototype.setDistanceFromTop = function (container) {
	        var distanceFromTop = this._getNonStickyDistanceFromTop(container);
	        this.setState({ distanceFromTop: distanceFromTop });
	    };
	    Sticky.prototype._getContentStyles = function (isSticky) {
	        return {
	            backgroundColor: this.props.stickyBackgroundColor || this._getBackground(),
	            overflow: isSticky ? 'hidden' : ''
	        };
	    };
	    Sticky.prototype._getStickyPlaceholderHeight = function (isSticky) {
	        var height = this.nonStickyContent ? this.nonStickyContent.offsetHeight : 0;
	        return {
	            visibility: isSticky ? 'hidden' : 'visible',
	            height: isSticky ? 0 : height
	        };
	    };
	    Sticky.prototype._getNonStickyPlaceholderHeightAndWidth = function () {
	        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
	        if (isStickyTop || isStickyBottom) {
	            var height = 0, width = 0;
	            // Why is placeHolder width needed?
	            // ScrollablePane content--container is reponsible for providing scrollbars depending on content overflow.
	            // If the overflow is caused by content of sticky component when it is in non-sticky state,
	            // ScrollablePane content--conatiner will provide horizontal scrollbar.
	            // If the component becomes sticky, i.e., when state.isStickyTop || state.isStickyBottom becomes true,
	            // it's actual content is no more inside ScrollablePane content--container.
	            // ScrollablePane content--conatiner will see no need for horizontal scrollbar. (Assuming no other content is causing overflow)
	            // The complete content of sticky component will not be viewable.
	            // It is necessary to provide a placeHolder of a certain width (height is already being set) in the content--container,
	            // to get a horizontal scrollbar & be able to view the complete content of sticky component.
	            if (this.nonStickyContent && this.nonStickyContent.firstElementChild) {
	                height = this.nonStickyContent.offsetHeight;
	                // What value should be substituted for placeHolder width?
	                // Assumption:
	                //    1. Content inside <Sticky> should always be wrapped in a single div.
	                //        <Sticky><div id={'firstElementChild'}>{intended_content}</div><Sticky/>
	                //    2. -ve padding, margin, etc. are not be used.
	                //    3. scrollWidth of a parent is greater than or equal to max of scrollWidths of it's children and same holds for children.
	                // placeHolder width should be computed in the best possible way to prevent overscroll/underscroll.
	                width =
	                    this.nonStickyContent.firstElementChild.scrollWidth +
	                        (this.nonStickyContent.firstElementChild.offsetWidth - this.nonStickyContent.firstElementChild.clientWidth);
	            }
	            return {
	                height: height,
	                width: width
	            };
	        }
	        else {
	            return {};
	        }
	    };
	    // Gets background of nearest parent element that has a declared background-color attribute
	    Sticky.prototype._getBackground = function () {
	        if (!this.root) {
	            return undefined;
	        }
	        var curr = this.root;
	        while (window.getComputedStyle(curr).getPropertyValue('background-color') === 'rgba(0, 0, 0, 0)' ||
	            window.getComputedStyle(curr).getPropertyValue('background-color') === 'transparent') {
	            if (curr.tagName === 'HTML') {
	                // Fallback color if no element has a declared background-color attribute
	                return undefined;
	            }
	            if (curr.parentElement) {
	                curr = curr.parentElement;
	            }
	        }
	        return window.getComputedStyle(curr).getPropertyValue('background-color');
	    };
	    Sticky.defaultProps = {
	        stickyPosition: Sticky_types_1.StickyPositionType.Both,
	        isScrollSynced: true
	    };
	    Sticky.contextTypes = {
	        scrollablePane: PropTypes.object
	    };
	    return Sticky;
	}(Utilities_1.BaseComponent));
	exports.Sticky = Sticky;
	function _isOffsetHeightDifferent(a, b) {
	    return (a && b && a.current && b.current && a.current.offsetHeight !== b.current.offsetHeight);
	}
	//# sourceMappingURL=Sticky.js.map

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StickyPositionType;
	(function (StickyPositionType) {
	    StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
	    StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
	    StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
	})(StickyPositionType = exports.StickyPositionType || (exports.StickyPositionType = {}));
	//# sourceMappingURL=Sticky.types.js.map

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1205), exports);
	//# sourceMappingURL=SwatchColorPicker.js.map

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1206), exports);
	tslib_1.__exportStar(__webpack_require__(1207), exports);
	tslib_1.__exportStar(__webpack_require__(1208), exports);
	tslib_1.__exportStar(__webpack_require__(1209), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var SwatchColorPicker_base_1 = __webpack_require__(1207);
	var SwatchColorPicker_styles_1 = __webpack_require__(1211);
	exports.SwatchColorPicker = Utilities_1.styled(SwatchColorPicker_base_1.SwatchColorPickerBase, SwatchColorPicker_styles_1.getStyles, undefined, { scope: 'SwatchColorPicker' });
	//# sourceMappingURL=SwatchColorPicker.js.map

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Grid_1 = __webpack_require__(1048);
	var ColorPickerGridCell_1 = __webpack_require__(1208);
	var getClassNames = Utilities_1.classNamesFunction();
	var SwatchColorPickerBase = /** @class */ (function (_super) {
	    tslib_1.__extends(SwatchColorPickerBase, _super);
	    function SwatchColorPickerBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.navigationIdleDelay = 250 /* ms */;
	        /**
	         * When the whole swatchColorPicker is blurred,
	         * make sure to clear the pending focused stated
	         */
	        _this._onSwatchColorPickerBlur = function () {
	            if (_this.props.onCellFocused) {
	                _this._cellFocused = false;
	                _this.props.onCellFocused();
	            }
	        };
	        /**
	         * Render a color cell
	         * @param item - The item to render
	         * @returns - Element representing the item
	         */
	        _this._renderOption = function (item) {
	            var id = _this._id;
	            return (React.createElement(ColorPickerGridCell_1.ColorPickerGridCell, { item: item, id: id, color: item.color, styles: _this.props.getColorGridCellStyles, disabled: _this.props.disabled, onClick: _this._onCellClick, onHover: _this._onGridCellHovered, onFocus: _this._onGridCellFocused, selected: _this.state.selectedIndex !== undefined && _this.state.selectedIndex === item.index, circle: _this.props.cellShape === 'circle', label: item.label, onMouseEnter: _this._onMouseEnter, onMouseMove: _this._onMouseMove, onMouseLeave: _this._onMouseLeave, onWheel: _this._onWheel, onKeyDown: _this._onKeyDown, height: _this.props.cellHeight, width: _this.props.cellWidth, borderWidth: _this.props.cellBorderWidth }));
	        };
	        /**
	         * Callback passed to the GridCell that will manage triggering the onCellHovered callback for mouseEnter
	         */
	        _this._onMouseEnter = function (ev) {
	            if (!_this.props.focusOnHover) {
	                if (!_this.isNavigationIdle || _this.props.disabled) {
	                    return true;
	                }
	                return false;
	            }
	            if (_this.isNavigationIdle && !_this.props.disabled) {
	                ev.currentTarget.focus();
	            }
	            return true;
	        };
	        /**
	         * Callback passed to the GridCell that will manage Hover/Focus updates
	         */
	        _this._onMouseMove = function (ev) {
	            if (!_this.props.focusOnHover) {
	                if (!_this.isNavigationIdle || _this.props.disabled) {
	                    return true;
	                }
	                return false;
	            }
	            var targetElement = ev.currentTarget;
	            // If navigation is idle and the targetElement is the focused element bail out
	            // if (!this.isNavigationIdle || (document && targetElement === (document.activeElement as HTMLElement))) {
	            if (_this.isNavigationIdle && !(document && targetElement === document.activeElement)) {
	                targetElement.focus();
	            }
	            return true;
	        };
	        /**
	         * Callback passed to the GridCell that will manage Hover/Focus updates
	         */
	        _this._onMouseLeave = function (ev) {
	            var parentSelector = _this.props.mouseLeaveParentSelector;
	            if (!_this.props.focusOnHover || !parentSelector || !_this.isNavigationIdle || _this.props.disabled) {
	                return;
	            }
	            // Get the the elements that math the given selector
	            var elements = document.querySelectorAll(parentSelector);
	            // iterate over the elements return to make sure it is a parent of the target and focus it
	            for (var index = 0; index < elements.length; index += 1) {
	                if (elements[index].contains(ev.currentTarget)) {
	                    /**
	                     * IE11 focus() method forces parents to scroll to top of element.
	                     * Edge and IE expose a setActive() function for focusable divs that
	                     * sets the page focus but does not scroll the parent element.
	                     */
	                    if (elements[index].setActive) {
	                        try {
	                            elements[index].setActive();
	                        }
	                        catch (e) {
	                            /* no-op */
	                        }
	                    }
	                    else {
	                        elements[index].focus();
	                    }
	                    break;
	                }
	            }
	        };
	        /**
	         * Callback to make sure we don't update the hovered element during mouse wheel
	         */
	        _this._onWheel = function () {
	            _this.setNavigationTimeout();
	        };
	        /**
	         * Callback that
	         */
	        _this._onKeyDown = function (ev) {
	            if (ev.which === Utilities_1.KeyCodes.up || ev.which === Utilities_1.KeyCodes.down || ev.which === Utilities_1.KeyCodes.left || ev.which === Utilities_1.KeyCodes.right) {
	                _this.setNavigationTimeout();
	            }
	        };
	        /**
	         * Sets a timeout so we won't process any mouse "hover" events
	         * while navigating (via mouseWheel or arrowKeys)
	         */
	        _this.setNavigationTimeout = function () {
	            if (!_this.isNavigationIdle && _this.navigationIdleTimeoutId !== undefined) {
	                _this.async.clearTimeout(_this.navigationIdleTimeoutId);
	                _this.navigationIdleTimeoutId = undefined;
	            }
	            else {
	                _this.isNavigationIdle = false;
	            }
	            _this.navigationIdleTimeoutId = _this.async.setTimeout(function () {
	                _this.isNavigationIdle = true;
	            }, _this.navigationIdleDelay);
	        };
	        /**
	         * Callback passed to the GridCell class that will trigger the onCellHovered callback of the SwatchColorPicker
	         * NOTE: This will not be triggered if shouldFocusOnHover === true
	         */
	        _this._onGridCellHovered = function (item) {
	            var onCellHovered = _this.props.onCellHovered;
	            if (onCellHovered) {
	                return item ? onCellHovered(item.id, item.color) : onCellHovered();
	            }
	        };
	        /**
	         * Callback passed to the GridCell class that will trigger the onCellFocus callback of the SwatchColorPicker
	         */
	        _this._onGridCellFocused = function (item) {
	            var onCellFocused = _this.props.onCellFocused;
	            if (onCellFocused) {
	                if (item) {
	                    _this._cellFocused = true;
	                    return onCellFocused(item.id, item.color);
	                }
	                else {
	                    _this._cellFocused = false;
	                    return onCellFocused();
	                }
	            }
	        };
	        /**
	         * Handle the click on a cell
	         * @param item - The cell that the click was fired against
	         */
	        _this._onCellClick = function (item) {
	            if (_this.props.disabled) {
	                return;
	            }
	            var index = item.index;
	            // If we have a valid index and it is not already
	            // selected, select it
	            if (index >= 0 && index !== _this.state.selectedIndex) {
	                if (_this.props.onCellFocused && _this._cellFocused) {
	                    _this._cellFocused = false;
	                    _this.props.onCellFocused();
	                }
	                if (_this.props.onColorChanged) {
	                    _this.props.onColorChanged(item.id, item.color);
	                }
	                // Update internal state only if the component is uncontrolled
	                if (_this.props.isControlled !== true) {
	                    _this.setState({
	                        selectedIndex: index
	                    });
	                }
	            }
	        };
	        _this._id = props.id || Utilities_1.getId('swatchColorPicker');
	        if (false) {
	            Utilities_1.warnMutuallyExclusive('SwatchColorPicker', _this.props, {
	                focusOnHover: 'onHover'
	            });
	            Utilities_1.warnConditionallyRequiredProps('SwatchColorPicker', _this.props, ['focusOnHover'], 'mouseLeaveParentSelector', !!_this.props.mouseLeaveParentSelector);
	        }
	        _this.isNavigationIdle = true;
	        _this.async = new Utilities_1.Async(_this);
	        var selectedIndex;
	        if (props.selectedId) {
	            selectedIndex = _this._getSelectedIndex(props.colorCells, props.selectedId);
	        }
	        _this.state = {
	            selectedIndex: selectedIndex
	        };
	        return _this;
	    }
	    SwatchColorPickerBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.selectedId !== undefined) {
	            this.setState({
	                selectedIndex: this._getSelectedIndex(newProps.colorCells, newProps.selectedId)
	            });
	        }
	    };
	    SwatchColorPickerBase.prototype.componentWillUnmount = function () {
	        if (this.props.onCellFocused && this._cellFocused) {
	            this._cellFocused = false;
	            this.props.onCellFocused();
	        }
	    };
	    SwatchColorPickerBase.prototype.render = function () {
	        var _a = this.props, colorCells = _a.colorCells, columnCount = _a.columnCount, positionInSet = _a.positionInSet, setSize = _a.setSize, shouldFocusCircularNavigate = _a.shouldFocusCircularNavigate, className = _a.className, doNotContainWithinFocusZone = _a.doNotContainWithinFocusZone, styles = _a.styles, cellMargin = _a.cellMargin;
	        var classNames = getClassNames(styles, {
	            theme: this.props.theme,
	            className: className,
	            cellMargin: cellMargin
	        });
	        if (colorCells.length < 1 || columnCount < 1) {
	            return null;
	        }
	        return (React.createElement(Grid_1.Grid, tslib_1.__assign({}, this.props, { items: colorCells.map(function (item, index) {
	                return tslib_1.__assign({}, item, { index: index });
	            }), columnCount: columnCount, onRenderItem: this._renderOption, positionInSet: positionInSet && positionInSet, setSize: setSize && setSize, shouldFocusCircularNavigate: shouldFocusCircularNavigate, doNotContainWithinFocusZone: doNotContainWithinFocusZone, onBlur: this._onSwatchColorPickerBlur, theme: this.props.theme, 
	            // tslint:disable-next-line:jsx-no-lambda
	            styles: function (props) { return ({
	                root: classNames.root,
	                tableCell: classNames.tableCell,
	                focusedContainer: classNames.focusedContainer
	            }); } })));
	    };
	    /**
	     * Get the selected item's index
	     * @param items - The items to search
	     * @param selectedId - The selected item's id to find
	     * @returns - The index of the selected item's id, -1 if there was no match
	     */
	    SwatchColorPickerBase.prototype._getSelectedIndex = function (items, selectedId) {
	        var selectedIndex = Utilities_1.findIndex(items, function (item) { return item.id === selectedId; });
	        return selectedIndex >= 0 ? selectedIndex : undefined;
	    };
	    SwatchColorPickerBase.defaultProps = {
	        cellShape: 'circle',
	        disabled: false,
	        shouldFocusCircularNavigate: true,
	        cellMargin: 10
	    };
	    return SwatchColorPickerBase;
	}(React.Component));
	exports.SwatchColorPickerBase = SwatchColorPickerBase;
	//# sourceMappingURL=SwatchColorPicker.base.js.map

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var ColorPickerGridCell_base_1 = __webpack_require__(1209);
	var ColorPickerGridCell_styles_1 = __webpack_require__(1210);
	exports.ColorPickerGridCell = Utilities_1.styled(ColorPickerGridCell_base_1.ColorPickerGridCellBase, ColorPickerGridCell_styles_1.getStyles, undefined, { scope: 'ColorPickerGridCell' });
	//# sourceMappingURL=ColorPickerGridCell.js.map

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var getColorFromString_1 = __webpack_require__(805);
	var GridCell_1 = __webpack_require__(1051);
	var ActionButton_styles_1 = __webpack_require__(729);
	var Styling_1 = __webpack_require__(463);
	var Utilities_1 = __webpack_require__(592);
	var getClassNames = Utilities_1.classNamesFunction();
	var ColorCell = /** @class */ (function (_super) {
	    tslib_1.__extends(ColorCell, _super);
	    function ColorCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ColorCell;
	}(GridCell_1.GridCell));
	var ColorPickerGridCellBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ColorPickerGridCellBase, _super);
	    function ColorPickerGridCellBase() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Render the core of a color cell
	         * @returns - Element representing the core of the item
	         */
	        _this._onRenderColorOption = function (colorOption) {
	            // Build an SVG for the cell with the given shape and color properties
	            return (React.createElement("svg", { className: _this._classNames.svg, viewBox: "0 0 20 20", fill: getColorFromString_1.getColorFromString(colorOption.color).str }, _this.props.circle ? React.createElement("circle", { cx: "50%", cy: "50%", r: "50%" }) : React.createElement("rect", { width: "100%", height: "100%" })));
	        };
	        /**
	         * Method to override the getClassNames func in a button.
	         */
	        _this._getClassNames = function (theme, className, variantClassName, iconClassName, menuIconClassName, disabled, checked, expanded, isSplit) {
	            var styles = ActionButton_styles_1.getStyles(theme);
	            return Styling_1.mergeStyleSets(_this._classNames, {
	                root: [
	                    'ms-Button',
	                    styles.root,
	                    variantClassName,
	                    className,
	                    checked && ['is-checked', styles.rootChecked],
	                    disabled && ['is-disabled', styles.rootDisabled],
	                    !disabled &&
	                        !checked && {
	                        selectors: {
	                            ':hover': styles.rootHovered,
	                            ':focus': styles.rootFocused,
	                            ':active': styles.rootPressed
	                        }
	                    },
	                    disabled && checked && [styles.rootCheckedDisabled],
	                    !disabled &&
	                        checked && {
	                        selectors: {
	                            ':hover': styles.rootCheckedHovered,
	                            ':active': styles.rootCheckedPressed
	                        }
	                    }
	                ],
	                flexContainer: ['ms-Button-flexContainer', styles.flexContainer]
	            });
	        };
	        return _this;
	    }
	    ColorPickerGridCellBase.prototype.render = function () {
	        var _a = this.props, item = _a.item, id = _a.id, selected = _a.selected, disabled = _a.disabled, styles = _a.styles, theme = _a.theme, circle = _a.circle, color = _a.color, onClick = _a.onClick, onHover = _a.onHover, onFocus = _a.onFocus, onMouseEnter = _a.onMouseEnter, onMouseMove = _a.onMouseMove, onMouseLeave = _a.onMouseLeave, onWheel = _a.onWheel, onKeyDown = _a.onKeyDown, height = _a.height, width = _a.width, borderWidth = _a.borderWidth;
	        this._classNames = getClassNames(styles, {
	            theme: theme,
	            disabled: disabled,
	            selected: selected,
	            circle: circle,
	            isWhite: this._isWhiteCell(color),
	            height: height,
	            width: width,
	            borderWidth: borderWidth
	        });
	        return (React.createElement(ColorCell, { item: item, id: id + "-" + item.id + "-" + item.index, key: item.id, disabled: disabled, role: 'gridcell', onRenderItem: this._onRenderColorOption, selected: selected, onClick: onClick, onHover: onHover, onFocus: onFocus, label: item.label, className: this._classNames.colorCell, getClassNames: this._getClassNames, index: item.index, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onWheel: onWheel, onKeyDown: onKeyDown }));
	    };
	    /**
	     * Validate if the cell's color is white or not to apply whiteCell style
	     * @param inputColor - The color of the current cell
	     * @returns - Whether the cell's color is white or not.
	     */
	    ColorPickerGridCellBase.prototype._isWhiteCell = function (inputColor) {
	        var color = getColorFromString_1.getColorFromString(inputColor);
	        return color.hex === 'ffffff';
	    };
	    ColorPickerGridCellBase.defaultProps = {
	        circle: true,
	        disabled: false,
	        selected: false
	    };
	    return ColorPickerGridCellBase;
	}(React.Component));
	exports.ColorPickerGridCellBase = ColorPickerGridCellBase;
	//# sourceMappingURL=ColorPickerGridCell.base.js.map

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Styling_1 = __webpack_require__(463);
	// Size breakpoint when the default border width changes from 2px to 4px.
	var CELL_BORDER_BREAKPOINT = 24;
	var LARGE_BORDER = 4;
	var SMALL_BORDER = 2;
	var DIVIDING_PADDING = 2;
	var DEFAULT_CELL_SIZE = 20;
	exports.getStyles = function (props) {
	    var theme = props.theme, disabled = props.disabled, selected = props.selected, circle = props.circle, isWhite = props.isWhite, _a = props.height, height = _a === void 0 ? DEFAULT_CELL_SIZE : _a, _b = props.width, width = _b === void 0 ? DEFAULT_CELL_SIZE : _b, borderWidth = props.borderWidth;
	    var semanticColors = theme.semanticColors;
	    // If user provided a value, use it. If not, then we decide depending on the 24px size breakpoint.
	    var calculatedBorderWidth = borderWidth ? borderWidth : width < CELL_BORDER_BREAKPOINT ? SMALL_BORDER : LARGE_BORDER;
	    return {
	        // this is a button that wraps the color
	        colorCell: [
	            {
	                backgroundColor: semanticColors.bodyBackground,
	                padding: 0,
	                position: 'relative',
	                boxSizing: 'border-box',
	                display: 'inline-block',
	                cursor: 'pointer',
	                userSelect: 'none',
	                border: 'none',
	                height: height,
	                width: width
	            },
	            !circle && {
	                selectors: (_c = {},
	                    _c["." + Utilities_1.IsFocusVisibleClassName + " &:focus::after"] = {
	                        // -1px so that we don't increase visually the size of the cell.
	                        outlineOffset: calculatedBorderWidth - 1 + "px"
	                    },
	                    _c)
	            },
	            // In focus state for circle we want a round border which is not possible with outline.
	            circle && {
	                borderRadius: '50%',
	                selectors: (_d = {},
	                    _d["." + Utilities_1.IsFocusVisibleClassName + " &:focus::after"] = {
	                        outline: 'none',
	                        borderColor: semanticColors.focusBorder,
	                        borderRadius: '50%',
	                        left: -calculatedBorderWidth,
	                        right: -calculatedBorderWidth,
	                        top: -calculatedBorderWidth,
	                        bottom: -calculatedBorderWidth,
	                        selectors: (_e = {},
	                            _e[Styling_1.HighContrastSelector] = {
	                                outline: "1px solid ButtonText"
	                            },
	                            _e)
	                    },
	                    _d)
	            },
	            selected && {
	                padding: DIVIDING_PADDING,
	                border: calculatedBorderWidth + "px solid " + theme.palette.neutralTertiaryAlt,
	                selectors: (_f = {},
	                    _f['&:hover::before'] = {
	                        content: '""',
	                        height: height,
	                        width: width,
	                        position: 'absolute',
	                        top: -calculatedBorderWidth,
	                        left: -calculatedBorderWidth,
	                        borderRadius: circle ? '50%' : 'default',
	                        boxShadow: "inset 0 0 0 1px " + theme.palette.neutralSecondary
	                    },
	                    _f)
	            },
	            !selected && {
	                selectors: (_g = {},
	                    _g['&:hover, &:active, &:focus'] = {
	                        backgroundColor: semanticColors.bodyBackground,
	                        padding: DIVIDING_PADDING,
	                        border: calculatedBorderWidth + "px solid " + theme.palette.neutralLight
	                    },
	                    _g['&:focus'] = {
	                        borderColor: semanticColors.bodyBackground,
	                        padding: 0,
	                        selectors: {
	                            ':hover': {
	                                borderColor: theme.palette.neutralLight,
	                                padding: DIVIDING_PADDING
	                            }
	                        }
	                    },
	                    _g)
	            },
	            disabled && {
	                color: semanticColors.disabledBodyText,
	                pointerEvents: 'none',
	                opacity: 0.3
	            },
	            isWhite &&
	                !selected && {
	                // fake a border for white
	                backgroundColor: semanticColors.bodyDivider,
	                padding: 1
	            }
	        ],
	        // the <svg> that holds the color
	        svg: [
	            {
	                width: '100%',
	                height: '100%'
	            },
	            circle && {
	                borderRadius: '50%'
	            }
	        ]
	    };
	    var _c, _d, _e, _f, _g;
	};
	//# sourceMappingURL=ColorPickerGridCell.styles.js.map

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var GlobalClassNames = {
	    focusedContainer: 'ms-swatchColorPickerBodyContainer'
	};
	exports.getStyles = function (props) {
	    var className = props.className, theme = props.theme, cellMargin = props.cellMargin;
	    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
	    return {
	        root: {
	            margin: '8px 0',
	            borderCollapse: 'collapse'
	        },
	        tableCell: {
	            padding: cellMargin / 2
	        },
	        focusedContainer: [
	            classNames.focusedContainer,
	            {
	                clear: 'both',
	                display: 'block',
	                minWidth: '180px'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=SwatchColorPicker.styles.js.map

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1213), exports);
	//# sourceMappingURL=TeachingBubble.js.map

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1214), exports);
	tslib_1.__exportStar(__webpack_require__(1215), exports);
	tslib_1.__exportStar(__webpack_require__(1216), exports);
	tslib_1.__exportStar(__webpack_require__(1217), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var TeachingBubble_base_1 = __webpack_require__(1215);
	var TeachingBubble_styles_1 = __webpack_require__(1218);
	exports.TeachingBubble = Utilities_1.styled(TeachingBubble_base_1.TeachingBubbleBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubble' });
	//# sourceMappingURL=TeachingBubble.js.map

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var TeachingBubbleContent_1 = __webpack_require__(1216);
	var Callout_1 = __webpack_require__(603);
	var DirectionalHint_1 = __webpack_require__(608);
	var getClassNames = Utilities_1.classNamesFunction();
	var TeachingBubbleBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TeachingBubbleBase, _super);
	    // Constructor
	    function TeachingBubbleBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.rootElement = React.createRef();
	        _this.state = {};
	        _this._defaultCalloutProps = {
	            beakWidth: 16,
	            gapSpace: 0,
	            setInitialFocus: true,
	            doNotLayer: false,
	            directionalHint: DirectionalHint_1.DirectionalHint.rightCenter
	        };
	        return _this;
	    }
	    TeachingBubbleBase.prototype.focus = function () {
	        if (this.rootElement.current) {
	            this.rootElement.current.focus();
	        }
	    };
	    TeachingBubbleBase.prototype.render = function () {
	        var _a = this.props, setCalloutProps = _a.calloutProps, targetElement = _a.targetElement, onDismiss = _a.onDismiss, isWide = _a.isWide, styles = _a.styles, theme = _a.theme, target = _a.target;
	        var calloutProps = tslib_1.__assign({}, this._defaultCalloutProps, setCalloutProps);
	        var stylesProps = {
	            theme: theme,
	            isWide: isWide,
	            calloutClassName: calloutProps ? calloutProps.className : undefined
	        };
	        var classNames = getClassNames(styles, stylesProps);
	        var calloutStyles = classNames.subComponentStyles
	            ? classNames.subComponentStyles.callout
	            : undefined;
	        return (React.createElement(Callout_1.Callout, tslib_1.__assign({ target: target || targetElement, onDismiss: onDismiss }, calloutProps, { className: classNames.root, styles: calloutStyles, hideOverflow: true }),
	            React.createElement("div", { ref: this.rootElement },
	                React.createElement(TeachingBubbleContent_1.TeachingBubbleContent, tslib_1.__assign({}, this.props)))));
	    };
	    TeachingBubbleBase.defaultProps = {
	        /**
	         * Default calloutProps is deprecated in favor of private `_defaultCalloutProps`.
	         * Remove in next release.
	         * @deprecated In favor of private `_defaultCalloutProps`.
	         */
	        calloutProps: {
	            beakWidth: 16,
	            gapSpace: 0,
	            setInitialFocus: true,
	            doNotLayer: false,
	            directionalHint: DirectionalHint_1.DirectionalHint.rightCenter
	        }
	    };
	    return TeachingBubbleBase;
	}(Utilities_1.BaseComponent));
	exports.TeachingBubbleBase = TeachingBubbleBase;
	//# sourceMappingURL=TeachingBubble.base.js.map

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var TeachingBubbleContent_base_1 = __webpack_require__(1217);
	var TeachingBubble_styles_1 = __webpack_require__(1218);
	exports.TeachingBubbleContent = Utilities_1.styled(TeachingBubbleContent_base_1.TeachingBubbleContentBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubbleContent' });
	//# sourceMappingURL=TeachingBubbleContent.js.map

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Button_1 = __webpack_require__(691);
	var Image_1 = __webpack_require__(658);
	var Stack_1 = __webpack_require__(1193);
	var getClassNames = Utilities_1.classNamesFunction();
	var TeachingBubbleContentBase = /** @class */ (function (_super) {
	    tslib_1.__extends(TeachingBubbleContentBase, _super);
	    function TeachingBubbleContentBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this.rootElement = React.createRef();
	        _this._onKeyDown = function (e) {
	            if (_this.props.onDismiss) {
	                if (e.which === Utilities_1.KeyCodes.escape) {
	                    _this.props.onDismiss();
	                }
	            }
	        };
	        _this.state = {};
	        return _this;
	    }
	    TeachingBubbleContentBase.prototype.componentDidMount = function () {
	        if (this.props.onDismiss) {
	            document.addEventListener('keydown', this._onKeyDown, false);
	        }
	    };
	    TeachingBubbleContentBase.prototype.componentWillUnmount = function () {
	        if (this.props.onDismiss) {
	            document.removeEventListener('keydown', this._onKeyDown);
	        }
	    };
	    TeachingBubbleContentBase.prototype.focus = function () {
	        if (this.rootElement.current) {
	            this.rootElement.current.focus();
	        }
	    };
	    TeachingBubbleContentBase.prototype.render = function () {
	        var _a = this.props, children = _a.children, illustrationImage = _a.illustrationImage, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, headline = _a.headline, hasCondensedHeadline = _a.hasCondensedHeadline, hasCloseIcon = _a.hasCloseIcon, onDismiss = _a.onDismiss, closeButtonAriaLabel = _a.closeButtonAriaLabel, hasSmallHeadline = _a.hasSmallHeadline, isWide = _a.isWide, styles = _a.styles, theme = _a.theme, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, customFooterContent = _a.footerContent;
	        var imageContent;
	        var headerContent;
	        var bodyContent;
	        var footerContent;
	        var closeButton;
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            hasCondensedHeadline: hasCondensedHeadline,
	            hasSmallHeadline: hasSmallHeadline,
	            isWide: isWide,
	            primaryButtonClassName: primaryButtonProps ? primaryButtonProps.className : undefined,
	            secondaryButtonClassName: secondaryButtonProps ? secondaryButtonProps.className : undefined
	        });
	        if (illustrationImage && illustrationImage.src) {
	            imageContent = (React.createElement("div", { className: classNames.imageContent },
	                React.createElement(Image_1.Image, tslib_1.__assign({}, illustrationImage))));
	        }
	        if (headline) {
	            var HeaderWrapperAs = typeof headline === 'string' ? 'p' : 'div';
	            headerContent = (React.createElement("div", { className: classNames.header },
	                React.createElement(HeaderWrapperAs, { className: classNames.headline, id: ariaLabelledBy }, headline)));
	        }
	        if (children) {
	            var BodyContentWrapperAs = typeof children === 'string' ? 'p' : 'div';
	            bodyContent = (React.createElement("div", { className: classNames.body },
	                React.createElement(BodyContentWrapperAs, { className: classNames.subText, id: ariaDescribedBy }, children)));
	        }
	        if (primaryButtonProps || secondaryButtonProps || customFooterContent) {
	            footerContent = (React.createElement(Stack_1.Stack, { className: classNames.footer, horizontal: true, horizontalAlign: customFooterContent ? 'space-between' : 'end' },
	                React.createElement(Stack_1.Stack.Item, { align: "center" }, React.createElement("span", null, customFooterContent)),
	                React.createElement(Stack_1.Stack.Item, null,
	                    secondaryButtonProps && React.createElement(Button_1.DefaultButton, tslib_1.__assign({}, secondaryButtonProps, { className: classNames.secondaryButton })),
	                    primaryButtonProps && React.createElement(Button_1.PrimaryButton, tslib_1.__assign({}, primaryButtonProps, { className: classNames.primaryButton })))));
	        }
	        if (hasCloseIcon) {
	            closeButton = (React.createElement(Button_1.IconButton, { className: classNames.closeButton, iconProps: { iconName: 'Cancel' }, title: closeButtonAriaLabel, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }));
	        }
	        return (React.createElement("div", { className: classNames.content, ref: this.rootElement, role: 'dialog', tabIndex: -1, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "data-is-focusable": true },
	            imageContent,
	            React.createElement("div", { className: classNames.bodyContent },
	                headerContent,
	                bodyContent,
	                footerContent,
	                closeButton)));
	    };
	    // Specify default props values
	    TeachingBubbleContentBase.defaultProps = {
	        hasCondensedHeadline: false,
	        imageProps: {
	            imageFit: Image_1.ImageFit.cover,
	            width: 364,
	            height: 130
	        }
	    };
	    return TeachingBubbleContentBase;
	}(Utilities_1.BaseComponent));
	exports.TeachingBubbleContentBase = TeachingBubbleContentBase;
	//# sourceMappingURL=TeachingBubbleContent.base.js.map

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	var globalClassNames = {
	    root: 'ms-TeachingBubble',
	    body: 'ms-TeachingBubble-body',
	    bodyContent: 'ms-TeachingBubble-bodycontent',
	    closeButton: 'ms-TeachingBubble-closebutton',
	    content: 'ms-TeachingBubble-content',
	    footer: 'ms-TeachingBubble-footer',
	    header: 'ms-TeachingBubble-header',
	    headerIsCondensed: 'ms-TeachingBubble-header--condensed',
	    headerIsSmall: 'ms-TeachingBubble-header--small',
	    headerIsLarge: 'ms-TeachingBubble-header--large',
	    headline: 'ms-TeachingBubble-headline',
	    image: 'ms-TeachingBubble-image',
	    primaryButton: 'ms-TeachingBubble-primaryButton',
	    secondaryButton: 'ms-TeachingBubble-secondaryButton',
	    subText: 'ms-TeachingBubble-subText',
	    // TODO: Button global class name usage should be converted to a styles function once
	    //        Button supports JS styling, which means these button names can be removed.
	    button: 'ms-Button',
	    buttonLabel: 'ms-Button-label'
	};
	var opacityFadeIn = Styling_1.keyframes({
	    '0%': {
	        opacity: 0,
	        animationTimingFunction: Styling_1.AnimationVariables.easeFunction1,
	        transform: 'scale3d(.90,.90,.90)'
	    },
	    '100%': {
	        opacity: 1,
	        transform: 'scale3d(1,1,1)'
	    }
	});
	var rootStyle = function (isWide) {
	    return [
	        {
	            display: 'block',
	            maxWidth: 364,
	            border: 0,
	            outline: 'transparent',
	            boxShadow: 'none !important',
	            width: 'calc(100% + 1px)',
	            animationName: "" + opacityFadeIn,
	            animationDuration: '300ms',
	            animationTimingFunction: 'linear',
	            animationFillMode: 'both'
	        },
	        isWide && {
	            maxWidth: '456px'
	        }
	    ];
	};
	var headerStyle = function (classNames, hasCondensedHeadline, hasSmallHeadline) {
	    if (hasCondensedHeadline) {
	        return [
	            classNames.headerIsCondensed,
	            {
	                marginBottom: 14
	            }
	        ];
	    }
	    if (hasSmallHeadline) {
	        return [
	            classNames.headerIsSmall,
	            {
	                selectors: {
	                    ':not(:last-child)': {
	                        marginBottom: '14px'
	                    }
	                }
	            }
	        ];
	    }
	    // Large headline is default
	    return [
	        classNames.headerIsLarge,
	        {
	            selectors: {
	                ':not(:last-child)': {
	                    marginBottom: '14px'
	                }
	            }
	        }
	    ];
	};
	exports.getStyles = function (props) {
	    var calloutClassName = props.calloutClassName, hasCondensedHeadline = props.hasCondensedHeadline, hasSmallHeadline = props.hasSmallHeadline, isWide = props.isWide, primaryButtonClassName = props.primaryButtonClassName, secondaryButtonClassName = props.secondaryButtonClassName, theme = props.theme;
	    var hasLargeHeadline = !hasCondensedHeadline && !hasSmallHeadline;
	    var palette = theme.palette;
	    var classNames = Styling_1.getGlobalClassNames(globalClassNames, theme);
	    return {
	        root: [classNames.root, theme.fonts.medium, calloutClassName],
	        body: [
	            classNames.body,
	            {
	                selectors: {
	                    ':not(:last-child)': {
	                        marginBottom: '20px'
	                    }
	                }
	            }
	        ],
	        bodyContent: [
	            classNames.bodyContent,
	            {
	                padding: '20px 24px 20px 24px'
	            }
	        ],
	        closeButton: [
	            classNames.closeButton,
	            {
	                position: 'absolute',
	                right: 0,
	                top: 0,
	                margin: '15px 15px 0 0',
	                borderRadius: 0,
	                color: palette.white,
	                fontSize: Styling_1.FontSizes.small,
	                selectors: {
	                    ':hover': {
	                        background: 'transparent'
	                    }
	                }
	            }
	        ],
	        content: [
	            classNames.content
	        ].concat(rootStyle(isWide), [
	            isWide && {
	                display: 'flex'
	            }
	        ]),
	        footer: [
	            classNames.footer,
	            {
	                display: 'flex',
	                flex: 'auto',
	                alignItems: 'center',
	                color: palette.white,
	                selectors: (_a = {},
	                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
	                    _a["." + classNames.button + ":not(:first-child)"] = {
	                        marginLeft: 10
	                    },
	                    _a)
	            }
	        ],
	        header: [
	            classNames.header
	        ].concat(headerStyle(classNames, hasCondensedHeadline, hasSmallHeadline), [
	            (hasCondensedHeadline || hasSmallHeadline) && [
	                Styling_1.DefaultFontStyles.medium,
	                {
	                    marginRight: 24,
	                    fontWeight: Styling_1.FontWeights.semibold
	                }
	            ]
	        ]),
	        headline: [
	            classNames.headline,
	            {
	                margin: 0,
	                color: palette.white
	            },
	            hasLargeHeadline && [
	                Styling_1.DefaultFontStyles.xxLarge,
	                {
	                    fontWeight: Styling_1.FontWeights.light
	                }
	            ]
	        ],
	        imageContent: [
	            classNames.header,
	            classNames.image,
	            isWide && {
	                display: 'flex',
	                alignItems: 'center',
	                maxWidth: 154
	            }
	        ],
	        primaryButton: [
	            classNames.primaryButton,
	            primaryButtonClassName,
	            {
	                backgroundColor: palette.white,
	                borderColor: palette.white,
	                whiteSpace: 'nowrap',
	                selectors: (_b = {},
	                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
	                    _b["." + classNames.buttonLabel] = [
	                        Styling_1.DefaultFontStyles.medium,
	                        {
	                            color: palette.themePrimary
	                        }
	                    ],
	                    _b[':hover'] = {
	                        backgroundColor: palette.themeLighter,
	                        borderColor: palette.themeLighter
	                    },
	                    _b[':focus'] = {
	                        backgroundColor: palette.themeLighter,
	                        borderColor: palette.white
	                    },
	                    _b[':active'] = {
	                        backgroundColor: palette.white,
	                        borderColor: palette.white
	                    },
	                    _b)
	            }
	        ],
	        secondaryButton: [
	            classNames.secondaryButton,
	            secondaryButtonClassName,
	            {
	                backgroundColor: palette.themePrimary,
	                borderColor: palette.white,
	                whiteSpace: 'nowrap',
	                selectors: (_c = {},
	                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
	                    _c["." + classNames.buttonLabel] = [
	                        Styling_1.DefaultFontStyles.medium,
	                        {
	                            color: palette.white
	                        }
	                    ],
	                    _c['&:hover, &:focus'] = {
	                        backgroundColor: palette.themeDarkAlt,
	                        borderColor: palette.white
	                    },
	                    _c[':active'] = {
	                        backgroundColor: palette.themePrimary,
	                        borderColor: palette.white
	                    },
	                    _c)
	            }
	        ],
	        subText: [
	            classNames.subText,
	            {
	                margin: 0,
	                fontSize: Styling_1.FontSizes.medium,
	                color: palette.white,
	                fontWeight: Styling_1.FontWeights.regular
	            }
	        ],
	        subComponentStyles: {
	            callout: {
	                root: rootStyle(isWide).concat([theme.fonts.medium]),
	                beak: [
	                    {
	                        background: palette.themePrimary
	                    }
	                ],
	                calloutMain: [
	                    {
	                        background: palette.themePrimary
	                    }
	                ]
	            }
	        }
	    };
	    var _a, _b, _c;
	};
	//# sourceMappingURL=TeachingBubble.styles.js.map

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1220), exports);
	//# sourceMappingURL=Text.js.map

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1221), exports);
	tslib_1.__exportStar(__webpack_require__(1222), exports);
	tslib_1.__exportStar(__webpack_require__(1223), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Foundation_1 = __webpack_require__(1039);
	var Text_view_1 = __webpack_require__(1222);
	var Text_styles_1 = __webpack_require__(1223);
	exports.Text = Foundation_1.createComponent({
	    displayName: 'Text',
	    styles: Text_styles_1.TextStyles,
	    view: Text_view_1.TextView
	});
	exports.default = exports.Text;
	//# sourceMappingURL=Text.js.map

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/** @jsx withSlots */
	var Foundation_1 = __webpack_require__(1039);
	var Utilities_1 = __webpack_require__(592);
	exports.TextView = function (props) {
	    if (!props.children) {
	        return null;
	    }
	    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = tslib_1.__rest(props, ["block", "className", "as", "variant", "nowrap"]);
	    var Slots = Foundation_1.getSlots(props, {
	        root: RootType
	    });
	    return Foundation_1.withSlots(Slots.root, tslib_1.__assign({}, Utilities_1.getNativeProps(rest, Utilities_1.htmlElementProperties)));
	};
	//# sourceMappingURL=Text.view.js.map

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TextStyles = function (props, theme) {
	    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
	    var fonts = theme.fonts;
	    var variantObject = fonts[variant || 'medium'];
	    return {
	        root: [
	            theme.fonts.medium,
	            {
	                display: block ? (as === 'td' ? 'table-cell' : 'block') : 'inline',
	                fontFamily: (variantObject && variantObject.fontFamily) || 'inherit',
	                fontSize: (variantObject && variantObject.fontSize) || 'inherit',
	                fontWeight: (variantObject && variantObject.fontWeight) || 'inherit',
	                color: (variantObject && variantObject.color) || 'inherit',
	                mozOsxFontSmoothing: variantObject && variantObject.MozOsxFontSmoothing,
	                webkitFontSmoothing: variantObject && variantObject.WebkitFontSmoothing
	            },
	            nowrap && {
	                whiteSpace: 'nowrap',
	                overflow: 'hidden',
	                textOverflow: 'ellipsis'
	            },
	            className
	        ]
	    };
	};
	//# sourceMappingURL=Text.styles.js.map

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1225), exports);
	//# sourceMappingURL=ThemeGenerator.js.map

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1226), exports);
	tslib_1.__exportStar(__webpack_require__(1227), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getColorFromString_1 = __webpack_require__(805);
	var shades_1 = __webpack_require__(817);
	var Utilities_1 = __webpack_require__(592);
	var ThemeGenerator = /** @class */ (function () {
	    function ThemeGenerator() {
	    }
	    /* Sets an IThemeSlotRule to the given color and cascades it to the rest of the theme, updating other IThemeSlotRules in the theme that
	     *   inherit from that color.
	     * isInverted: whether it's a dark theme or not, which affects the algorithm used to generate shades
	     * isCustomization should be true only if it's a user action, and indicates overwriting the slot's inheritance (if any)
	     * overwriteCustomColor: a slot could have a generated color based on its inheritance rules (isCustomized is false), or a custom color
	                              based on user input (isCustomized is true), this bool tells us whether to override existing customized colors */
	    ThemeGenerator.setSlot = function (rule, color, isInverted, isCustomization, overwriteCustomColor) {
	        if (isInverted === void 0) { isInverted = false; }
	        if (isCustomization === void 0) { isCustomization = false; }
	        if (overwriteCustomColor === void 0) { overwriteCustomColor = true; }
	        if (!rule.color && rule.value) {
	            // not a color rule
	            return;
	        }
	        if (overwriteCustomColor) {
	            var colorAsIColor = void 0;
	            if (typeof color === 'string') {
	                colorAsIColor = getColorFromString_1.getColorFromString(color); // the ! is a lie here but we'll verify it in the next line
	                if (!colorAsIColor) {
	                    throw 'color is invalid in setSlot(): ' + color;
	                }
	            }
	            else {
	                colorAsIColor = color;
	            }
	            ThemeGenerator._setSlot(rule, colorAsIColor, isInverted, isCustomization, overwriteCustomColor);
	        }
	        else if (rule.color) {
	            ThemeGenerator._setSlot(rule, rule.color, isInverted, isCustomization, overwriteCustomColor);
	        }
	    };
	    /* Sets the color of each slot based on its rule. Slots that don't inherit must have a color already.
	     * If this completes without error, then the theme is ready to use. (All slots will have a color.)
	     * setSlot() can be called before this, but this must be called before getThemeAs*().
	     * Does not override colors of rules where isCustomized is true (i.e. doesn't override existing customizations).
	     */
	    ThemeGenerator.insureSlots = function (slotRules, isInverted) {
	        // Get all the "root" rules, the ones which don't inherit. Then "set" them to trigger updating dependent slots.
	        for (var ruleName in slotRules) {
	            if (slotRules.hasOwnProperty(ruleName)) {
	                var rule = slotRules[ruleName];
	                if (!rule.inherits && !rule.value) {
	                    if (!rule.color) {
	                        throw 'A color slot rule that does not inherit must provide its own color.';
	                    }
	                    ThemeGenerator._setSlot(rule, rule.color, isInverted, false, false);
	                }
	            }
	        }
	    };
	    /* Gets the JSON-formatted blob that describes the theme, usable with the REST request endpoints
	     * { [theme slot name as string] : [color as string],
	     *  "tokenName": "#f00f00",
	     *  "tokenName2": "#ba2ba2",
	     *   ... }
	     */
	    ThemeGenerator.getThemeAsJson = function (slotRules) {
	        var theme = {};
	        for (var ruleName in slotRules) {
	            if (slotRules.hasOwnProperty(ruleName)) {
	                var rule = slotRules[ruleName];
	                theme[rule.name] = rule.color ? rule.color.str : rule.value || '';
	            }
	        }
	        return theme;
	    };
	    /*
	     * Gets code-formatted load theme blob that can be copy and pasted.
	     */
	    ThemeGenerator.getThemeAsCode = function (slotRules) {
	        var attributeTemplate = "    {0}: '{1}',\n";
	        var output = '';
	        output += 'loadTheme({\n  palette: {\n';
	        for (var ruleName in slotRules) {
	            if (slotRules.hasOwnProperty(ruleName)) {
	                var rule = slotRules[ruleName];
	                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
	                var outputColor = rule.color ? '#' + rule.color.hex : rule.value || '';
	                output += Utilities_1.format(attributeTemplate, camelCasedName, outputColor);
	            }
	        }
	        output += '  }\n});';
	        return output;
	    };
	    /* Gets the theme as a list of SASS variables that can be used in code
	     * $tokenName: "[theme:tokenName, default:#f00f00]";
	     * $tokenName2: "[theme:tokenName2, default:#ba2ba2]";
	     * ...
	     */
	    ThemeGenerator.getThemeAsSass = function (slotRules) {
	        var sassVarTemplate = '${0}Color: "[theme: {1}, default: {2}]";\n';
	        var output = '';
	        for (var ruleName in slotRules) {
	            if (slotRules.hasOwnProperty(ruleName)) {
	                var rule = slotRules[ruleName];
	                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
	                output += Utilities_1.format(sassVarTemplate, camelCasedName, camelCasedName, rule.color ? rule.color.str : rule.value || '');
	            }
	        }
	        return output;
	    };
	    /* Gets the theme formatted for PowerShell scripts
	     * @{
	     * "tokenName" = "#f00f00";
	     * "tokenName2" = "#ba2ba2";
	     * ...
	     * }
	     */
	    ThemeGenerator.getThemeForPowerShell = function (slotRules) {
	        var psVarTemplate = '"{0}" = "{1}";\n';
	        var output = '';
	        for (var ruleName in slotRules) {
	            if (slotRules.hasOwnProperty(ruleName)) {
	                var rule = slotRules[ruleName];
	                if (rule.value) {
	                    // skip this one, it's not a color
	                    continue;
	                }
	                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
	                var outputColor = rule.color ? '#' + rule.color.hex : rule.value || '';
	                // powershell endpoint uses the RGBA format
	                if (rule.color && rule.color.a && rule.color.a !== 100) {
	                    outputColor += String(rule.color.a.toString(16));
	                }
	                output += Utilities_1.format(psVarTemplate, camelCasedName, outputColor);
	            }
	        }
	        return '@{\n' + output + '}';
	    };
	    /* Sets the given slot's color to the appropriate color, shading it if necessary.
	       Then, iterates through all other rules (that are this rule's dependents) to update them accordingly.
	       isCustomization=true means it's a user provided color, set it to that raw color
	       isCustomization=false means the rule it's inheriting from changed, so updated using asShade */
	    ThemeGenerator._setSlot = function (rule, color, isInverted, isCustomization, overwriteCustomColor) {
	        if (overwriteCustomColor === void 0) { overwriteCustomColor = true; }
	        if (!rule.color && rule.value) {
	            // not a color rule
	            return;
	        }
	        if (overwriteCustomColor || !rule.color || !rule.isCustomized || !rule.inherits) {
	            // set the rule's color under these conditions
	            if ((overwriteCustomColor || !rule.isCustomized) && !isCustomization && rule.inherits && shades_1.isValidShade(rule.asShade)) {
	                // it's inheriting by shade
	                if (rule.isBackgroundShade) {
	                    rule.color = shades_1.getBackgroundShade(color, rule.asShade, isInverted);
	                }
	                else {
	                    rule.color = shades_1.getShade(color, rule.asShade, isInverted);
	                }
	                rule.isCustomized = false;
	            }
	            else {
	                rule.color = color;
	                rule.isCustomized = true;
	            }
	            // then update dependent colors
	            for (var _i = 0, _a = rule.dependentRules; _i < _a.length; _i++) {
	                var ruleToUpdate = _a[_i];
	                ThemeGenerator._setSlot(ruleToUpdate, rule.color, isInverted, false, overwriteCustomColor);
	            }
	        }
	    };
	    return ThemeGenerator;
	}());
	exports.ThemeGenerator = ThemeGenerator;
	//# sourceMappingURL=ThemeGenerator.js.map

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var shades_1 = __webpack_require__(817);
	var getColorFromString_1 = __webpack_require__(805);
	var Utilities_1 = __webpack_require__(592);
	/* This is the set of rules for our default theme.
	   We start with three base slots, defining the background, foreground (text), and
	   primary color (sometimes called theme color). Each Fabric slot is generated from
	   shades (or tints) of one of those three, creating the Fabric palette.
	   Then, we have semantic slots, the new thing intended to eventually replace the
	   Fabric palette. The semantic slots inherit from the Fabric palette. */
	/* The most minimal set of slots we start with. All other ones can be generated based on rules.
	 * This is not so much an enum as it is a list. The enum is used to insure "type"-safety.
	 * For now, we are only dealing with color. */
	var BaseSlots;
	(function (BaseSlots) {
	    BaseSlots[BaseSlots["primaryColor"] = 0] = "primaryColor";
	    BaseSlots[BaseSlots["backgroundColor"] = 1] = "backgroundColor";
	    BaseSlots[BaseSlots["foregroundColor"] = 2] = "foregroundColor";
	})(BaseSlots = exports.BaseSlots || (exports.BaseSlots = {}));
	/* The original Fabric palette, only for back-compat. */
	var FabricSlots;
	(function (FabricSlots) {
	    FabricSlots[FabricSlots["themePrimary"] = 0] = "themePrimary";
	    FabricSlots[FabricSlots["themeLighterAlt"] = 1] = "themeLighterAlt";
	    FabricSlots[FabricSlots["themeLighter"] = 2] = "themeLighter";
	    FabricSlots[FabricSlots["themeLight"] = 3] = "themeLight";
	    FabricSlots[FabricSlots["themeTertiary"] = 4] = "themeTertiary";
	    FabricSlots[FabricSlots["themeSecondary"] = 5] = "themeSecondary";
	    FabricSlots[FabricSlots["themeDarkAlt"] = 6] = "themeDarkAlt";
	    FabricSlots[FabricSlots["themeDark"] = 7] = "themeDark";
	    FabricSlots[FabricSlots["themeDarker"] = 8] = "themeDarker";
	    FabricSlots[FabricSlots["neutralLighterAlt"] = 9] = "neutralLighterAlt";
	    FabricSlots[FabricSlots["neutralLighter"] = 10] = "neutralLighter";
	    FabricSlots[FabricSlots["neutralLight"] = 11] = "neutralLight";
	    FabricSlots[FabricSlots["neutralQuaternaryAlt"] = 12] = "neutralQuaternaryAlt";
	    FabricSlots[FabricSlots["neutralQuaternary"] = 13] = "neutralQuaternary";
	    FabricSlots[FabricSlots["neutralTertiaryAlt"] = 14] = "neutralTertiaryAlt";
	    FabricSlots[FabricSlots["neutralTertiary"] = 15] = "neutralTertiary";
	    // deprecated: neutralSecondaryAlt, // BaseSlots.foregroundColor, Shade[Shade.Shade4]);
	    FabricSlots[FabricSlots["neutralSecondary"] = 16] = "neutralSecondary";
	    FabricSlots[FabricSlots["neutralPrimaryAlt"] = 17] = "neutralPrimaryAlt";
	    FabricSlots[FabricSlots["neutralPrimary"] = 18] = "neutralPrimary";
	    FabricSlots[FabricSlots["neutralDark"] = 19] = "neutralDark";
	    FabricSlots[FabricSlots["black"] = 20] = "black";
	    FabricSlots[FabricSlots["white"] = 21] = "white"; // BaseSlots.backgroundColor, Shade[Shade.Unshaded]);
	})(FabricSlots = exports.FabricSlots || (exports.FabricSlots = {}));
	/* List of all the semantic color slots for this theme.
	 * This is not so much an enum as it is a list. The enum is used to insure "type"-safety. */
	var SemanticColorSlots;
	(function (SemanticColorSlots) {
	    SemanticColorSlots[SemanticColorSlots["bodyBackground"] = 0] = "bodyBackground";
	    SemanticColorSlots[SemanticColorSlots["bodyText"] = 1] = "bodyText";
	    SemanticColorSlots[SemanticColorSlots["disabledBackground"] = 2] = "disabledBackground";
	    SemanticColorSlots[SemanticColorSlots["disabledText"] = 3] = "disabledText";
	})(SemanticColorSlots = exports.SemanticColorSlots || (exports.SemanticColorSlots = {}));
	function themeRulesStandardCreator() {
	    var slotRules = {};
	    /*** BASE COLORS and their SHADES */
	    // iterate through each base slot and make the SlotRules for those
	    Utilities_1.mapEnumByName(BaseSlots, function (baseSlot) {
	        // first make the SlotRule for the unshaded base Color
	        slotRules[baseSlot] = {
	            name: baseSlot,
	            isCustomized: true,
	            dependentRules: []
	        };
	        // then make a rule for each shade of this base color, but skip unshaded
	        Utilities_1.mapEnumByName(shades_1.Shade, function (shadeName, shadeValue) {
	            if (shadeName === shades_1.Shade[shades_1.Shade.Unshaded]) {
	                return;
	            }
	            var inherits = slotRules[baseSlot];
	            var thisSlotRule = {
	                name: baseSlot + shadeName,
	                inherits: slotRules[baseSlot],
	                asShade: shadeValue,
	                isCustomized: false,
	                isBackgroundShade: baseSlot === BaseSlots[BaseSlots.backgroundColor] ? true : false,
	                dependentRules: []
	            };
	            slotRules[baseSlot + shadeName] = thisSlotRule;
	            inherits.dependentRules.push(thisSlotRule);
	            return void 0;
	        });
	        return void 0;
	    });
	    // set default colors for the base colors
	    slotRules[BaseSlots[BaseSlots.primaryColor]].color = getColorFromString_1.getColorFromString('#0078d4');
	    slotRules[BaseSlots[BaseSlots.backgroundColor]].color = getColorFromString_1.getColorFromString('#fff');
	    slotRules[BaseSlots[BaseSlots.foregroundColor]].color = getColorFromString_1.getColorFromString('#333');
	    // set default colors for shades (the slot rules were already created above and will be used if the base colors ever change)
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade1]].color = getColorFromString_1.getColorFromString('#eff6fc');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade2]].color = getColorFromString_1.getColorFromString('#deecf9');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade3]].color = getColorFromString_1.getColorFromString('#c7e0f4');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade4]].color = getColorFromString_1.getColorFromString('#71afe5');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade5]].color = getColorFromString_1.getColorFromString('#2b88d8');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade6]].color = getColorFromString_1.getColorFromString('#106ebe');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade7]].color = getColorFromString_1.getColorFromString('#005a9e');
	    slotRules[BaseSlots[BaseSlots.primaryColor] + shades_1.Shade[shades_1.Shade.Shade8]].color = getColorFromString_1.getColorFromString('#004578');
	    // set default colors for shades (the slot rules were already created above and will be used if the base colors ever change)
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade1]].color = getColorFromString_1.getColorFromString('#eaeaea');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade2]].color = getColorFromString_1.getColorFromString('#c8c8c8');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade3]].color = getColorFromString_1.getColorFromString('#a6a6a6');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade4]].color = getColorFromString_1.getColorFromString('#767676');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade5]].color = getColorFromString_1.getColorFromString('#666666');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade6]].color = getColorFromString_1.getColorFromString('#3c3c3c');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade7]].color = getColorFromString_1.getColorFromString('#212121');
	    slotRules[BaseSlots[BaseSlots.foregroundColor] + shades_1.Shade[shades_1.Shade.Shade8]].color = getColorFromString_1.getColorFromString('#000000');
	    function _makeFabricSlotRule(slotName, inheritedBase, inheritedShade, isBackgroundShade) {
	        if (isBackgroundShade === void 0) { isBackgroundShade = false; }
	        var inherits = slotRules[BaseSlots[inheritedBase]];
	        var thisSlotRule = {
	            name: slotName,
	            inherits: inherits,
	            asShade: inheritedShade,
	            isCustomized: false,
	            isBackgroundShade: isBackgroundShade,
	            dependentRules: []
	        };
	        slotRules[slotName] = thisSlotRule;
	        inherits.dependentRules.push(thisSlotRule);
	    }
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themePrimary], BaseSlots.primaryColor, shades_1.Shade.Unshaded);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLighterAlt], BaseSlots.primaryColor, shades_1.Shade.Shade1);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLighter], BaseSlots.primaryColor, shades_1.Shade.Shade2);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLight], BaseSlots.primaryColor, shades_1.Shade.Shade3);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeTertiary], BaseSlots.primaryColor, shades_1.Shade.Shade4);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeSecondary], BaseSlots.primaryColor, shades_1.Shade.Shade5);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDarkAlt], BaseSlots.primaryColor, shades_1.Shade.Shade6);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDark], BaseSlots.primaryColor, shades_1.Shade.Shade7);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDarker], BaseSlots.primaryColor, shades_1.Shade.Shade8);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLighterAlt], BaseSlots.backgroundColor, shades_1.Shade.Shade1, true);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLighter], BaseSlots.backgroundColor, shades_1.Shade.Shade2, true);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLight], BaseSlots.backgroundColor, shades_1.Shade.Shade3, true);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralQuaternaryAlt], BaseSlots.backgroundColor, shades_1.Shade.Shade4, true);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralQuaternary], BaseSlots.backgroundColor, shades_1.Shade.Shade5, true);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralTertiaryAlt], BaseSlots.backgroundColor, shades_1.Shade.Shade6, true); // bg6 or fg2
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralTertiary], BaseSlots.foregroundColor, shades_1.Shade.Shade3);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralSecondary], BaseSlots.foregroundColor, shades_1.Shade.Shade4);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralPrimaryAlt], BaseSlots.foregroundColor, shades_1.Shade.Shade5);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralPrimary], BaseSlots.foregroundColor, shades_1.Shade.Unshaded);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralDark], BaseSlots.foregroundColor, shades_1.Shade.Shade7);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.black], BaseSlots.foregroundColor, shades_1.Shade.Shade8);
	    _makeFabricSlotRule(FabricSlots[FabricSlots.white], BaseSlots.backgroundColor, shades_1.Shade.Unshaded, true);
	    // manually set initial colors for the primary-based Fabric slots to match the default theme
	    slotRules[FabricSlots[FabricSlots.themeLighterAlt]].color = getColorFromString_1.getColorFromString('#eff6fc');
	    slotRules[FabricSlots[FabricSlots.themeLighter]].color = getColorFromString_1.getColorFromString('#deecf9');
	    slotRules[FabricSlots[FabricSlots.themeLight]].color = getColorFromString_1.getColorFromString('#c7e0f4');
	    slotRules[FabricSlots[FabricSlots.themeTertiary]].color = getColorFromString_1.getColorFromString('#71afe5');
	    slotRules[FabricSlots[FabricSlots.themeSecondary]].color = getColorFromString_1.getColorFromString('#2b88d8');
	    slotRules[FabricSlots[FabricSlots.themeDarkAlt]].color = getColorFromString_1.getColorFromString('#106ebe');
	    slotRules[FabricSlots[FabricSlots.themeDark]].color = getColorFromString_1.getColorFromString('#005a9e');
	    slotRules[FabricSlots[FabricSlots.themeDarker]].color = getColorFromString_1.getColorFromString('#004578');
	    slotRules[FabricSlots[FabricSlots.themeLighterAlt]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeLighter]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeLight]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeTertiary]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeSecondary]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeDarkAlt]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeDark]].isCustomized = true;
	    slotRules[FabricSlots[FabricSlots.themeDarker]].isCustomized = true;
	    /*** SEMANTIC SLOTS */
	    // This code is commented out for now but left for future semantic color customization.
	    // create the SlotRule for a semantic slot
	    // function _makeSemanticSlotRule(semanticSlot: SemanticColorSlots, inheritedFabricSlot: FabricSlots): void {
	    //   const inherits = slotRules[FabricSlots[inheritedFabricSlot]];
	    //   const thisSlotRule = {
	    //     name: SemanticColorSlots[semanticSlot],
	    //     inherits: slotRules[FabricSlots[inheritedFabricSlot]],
	    //     isCustomized: false,
	    //     dependentRules: []
	    //   };
	    //   slotRules[SemanticColorSlots[semanticSlot]] = thisSlotRule;
	    //   inherits.dependentRules.push(thisSlotRule);
	    // }
	    // Basic simple slots
	    // _makeSemanticSlotRule(SemanticColorSlots.bodyBackground, FabricSlots.white);
	    // _makeSemanticSlotRule(SemanticColorSlots.bodyText, FabricSlots.neutralPrimary);
	    return slotRules;
	}
	exports.themeRulesStandardCreator = themeRulesStandardCreator;
	//# sourceMappingURL=ThemeRulesStandard.js.map

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1229), exports);
	//# sourceMappingURL=Toggle.js.map

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(1230), exports);
	tslib_1.__exportStar(__webpack_require__(1231), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Utilities_1 = __webpack_require__(592);
	var Toggle_base_1 = __webpack_require__(1231);
	var Toggle_styles_1 = __webpack_require__(1232);
	exports.Toggle = Utilities_1.styled(Toggle_base_1.ToggleBase, Toggle_styles_1.getStyles, undefined, { scope: 'Toggle' });
	//# sourceMappingURL=Toggle.js.map

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var React = __webpack_require__(38);
	var Utilities_1 = __webpack_require__(592);
	var Label_1 = __webpack_require__(771);
	var KeytipData_1 = __webpack_require__(684);
	var getClassNames = Utilities_1.classNamesFunction();
	var ToggleBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ToggleBase, _super);
	    function ToggleBase(props) {
	        var _this = _super.call(this, props) || this;
	        _this._toggleButton = React.createRef();
	        _this._onClick = function (ev) {
	            var _a = _this.props, disabled = _a.disabled, checkedProp = _a.checked, onChange = _a.onChange, onChanged = _a.onChanged, onClick = _a.onClick;
	            var checked = _this.state.checked;
	            if (!disabled) {
	                // Only update the state if the user hasn't provided it.
	                if (checkedProp === undefined) {
	                    _this.setState({
	                        checked: !checked
	                    });
	                }
	                if (onChange) {
	                    onChange(ev, !checked);
	                }
	                if (onChanged) {
	                    onChanged(!checked);
	                }
	                if (onClick) {
	                    onClick(ev);
	                }
	            }
	        };
	        _this._warnMutuallyExclusive({
	            checked: 'defaultChecked'
	        });
	        _this._warnDeprecations({
	            onAriaLabel: 'ariaLabel',
	            offAriaLabel: undefined,
	            onChanged: 'onChange'
	        });
	        _this.state = {
	            checked: !!(props.checked || props.defaultChecked)
	        };
	        _this._id = props.id || Utilities_1.getId('Toggle');
	        return _this;
	    }
	    Object.defineProperty(ToggleBase.prototype, "checked", {
	        /**
	         * Gets the current checked state of the toggle.
	         */
	        get: function () {
	            return this.state.checked;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ToggleBase.prototype.componentWillReceiveProps = function (newProps) {
	        if (newProps.checked !== undefined) {
	            this.setState({
	                checked: !!newProps.checked // convert null to false
	            });
	        }
	    };
	    ToggleBase.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? 'div' : _b, className = _a.className, theme = _a.theme, disabled = _a.disabled, keytipProps = _a.keytipProps, label = _a.label, ariaLabel = _a.ariaLabel, onAriaLabel = _a.onAriaLabel, offAriaLabel = _a.offAriaLabel, offText = _a.offText, onText = _a.onText, styles = _a.styles, inlineLabel = _a.inlineLabel;
	        var checked = this.state.checked;
	        var stateText = checked ? onText : offText;
	        var badAriaLabel = checked ? onAriaLabel : offAriaLabel;
	        var toggleNativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultChecked']);
	        var classNames = getClassNames(styles, {
	            theme: theme,
	            className: className,
	            disabled: disabled,
	            checked: checked,
	            inlineLabel: inlineLabel,
	            onOffMissing: !onText && !offText
	        });
	        var labelId = this._id + "-label";
	        var stateTextId = this._id + "-stateText";
	        // The following properties take priority for what Narrator should read:
	        // 1. ariaLabel
	        // 2. onAriaLabel (if checked) or offAriaLabel (if not checked)
	        // 3. label
	        // 4. onText (if checked) or offText (if not checked)
	        var labelledById = undefined;
	        if (!ariaLabel && !badAriaLabel) {
	            if (label) {
	                labelledById = labelId;
	            }
	            else if (stateText) {
	                labelledById = stateTextId;
	            }
	        }
	        var ariaRole = this.props.role ? this.props.role : 'switch';
	        return (React.createElement(RootType, { className: classNames.root, hidden: toggleNativeProps.hidden },
	            label && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.label, id: labelId }, label)),
	            React.createElement("div", { className: classNames.container },
	                React.createElement(KeytipData_1.KeytipData, { keytipProps: keytipProps, ariaDescribedBy: toggleNativeProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (React.createElement("button", tslib_1.__assign({}, toggleNativeProps, keytipAttributes, { className: classNames.pill, disabled: disabled, id: _this._id, type: "button", role: ariaRole, ref: _this._toggleButton, "aria-disabled": disabled, "aria-checked": checked, "aria-label": ariaLabel ? ariaLabel : badAriaLabel, "data-is-focusable": true, onChange: _this._noop, onClick: _this._onClick, "aria-labelledby": labelledById }),
	                    React.createElement("div", { className: classNames.thumb }))); }),
	                stateText && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.text, id: stateTextId }, stateText)))));
	    };
	    ToggleBase.prototype.focus = function () {
	        if (this._toggleButton.current) {
	            this._toggleButton.current.focus();
	        }
	    };
	    ToggleBase.prototype._noop = function () {
	        /* no-op */
	    };
	    return ToggleBase;
	}(Utilities_1.BaseComponent));
	exports.ToggleBase = ToggleBase;
	//# sourceMappingURL=Toggle.base.js.map

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Styling_1 = __webpack_require__(463);
	exports.getStyles = function (props) {
	    var theme = props.theme, className = props.className, disabled = props.disabled, checked = props.checked, inlineLabel = props.inlineLabel, onOffMissing = props.onOffMissing;
	    var semanticColors = theme.semanticColors;
	    var pillUncheckedBackground = semanticColors.bodyBackground;
	    var pillCheckedBackground = semanticColors.inputBackgroundChecked;
	    var pillCheckedHoveredBackground = semanticColors.inputBackgroundCheckedHovered;
	    var pillCheckedDisabledBackground = semanticColors.disabledBodySubtext;
	    var thumbBackground = semanticColors.inputBorderHovered;
	    var thumbCheckedBackground = semanticColors.inputForegroundChecked;
	    var thumbDisabledBackground = semanticColors.disabledBodySubtext;
	    var thumbCheckedDisabledBackground = semanticColors.disabledBackground;
	    var pillBorderColor = semanticColors.smallInputBorder;
	    var pillBorderHoveredColor = semanticColors.inputBorderHovered;
	    var pillBorderDisabledColor = semanticColors.disabledBodySubtext;
	    var textDisabledColor = semanticColors.disabledText;
	    return {
	        root: [
	            'ms-Toggle',
	            checked && 'is-checked',
	            !disabled && 'is-enabled',
	            disabled && 'is-disabled',
	            theme.fonts.medium,
	            {
	                marginBottom: '8px'
	            },
	            inlineLabel && {
	                display: 'flex',
	                alignItems: 'center'
	            },
	            className
	        ],
	        label: [
	            'ms-Toggle-label',
	            disabled && {
	                color: textDisabledColor,
	                selectors: (_a = {},
	                    _a[Styling_1.HighContrastSelector] = {
	                        color: 'GrayText'
	                    },
	                    _a)
	            },
	            inlineLabel &&
	                !onOffMissing && {
	                marginRight: 16
	            },
	            onOffMissing &&
	                inlineLabel && {
	                order: 1,
	                marginLeft: 16
	            }
	        ],
	        container: [
	            'ms-Toggle-innerContainer',
	            {
	                display: 'inline-flex',
	                position: 'relative'
	            }
	        ],
	        pill: [
	            'ms-Toggle-background',
	            Styling_1.getFocusStyle(theme, { inset: -3 }),
	            {
	                fontSize: '20px',
	                boxSizing: 'border-box',
	                width: '2.2em',
	                height: '1em',
	                borderRadius: '1em',
	                transition: 'all 0.1s ease',
	                borderWidth: '1px',
	                borderStyle: 'solid',
	                background: pillUncheckedBackground,
	                borderColor: pillBorderColor,
	                cursor: 'pointer',
	                display: 'flex',
	                alignItems: 'center',
	                padding: '0 .2em'
	            },
	            !disabled && [
	                !checked && {
	                    selectors: {
	                        ':hover': [
	                            {
	                                borderColor: pillBorderHoveredColor
	                            }
	                        ],
	                        ':hover .ms-Toggle-thumb': [
	                            {
	                                selectors: (_b = {},
	                                    _b[Styling_1.HighContrastSelector] = {
	                                        borderColor: 'Highlight'
	                                    },
	                                    _b)
	                            }
	                        ]
	                    }
	                },
	                checked && [
	                    {
	                        background: pillCheckedBackground,
	                        borderColor: 'transparent',
	                        justifyContent: 'flex-end'
	                    },
	                    {
	                        selectors: (_c = {
	                                ':hover': [
	                                    {
	                                        backgroundColor: pillCheckedHoveredBackground,
	                                        borderColor: 'transparent',
	                                        selectors: (_d = {},
	                                            _d[Styling_1.HighContrastSelector] = {
	                                                backgroundColor: 'Highlight'
	                                            },
	                                            _d)
	                                    }
	                                ]
	                            },
	                            _c[Styling_1.HighContrastSelector] = {
	                                backgroundColor: 'WindowText'
	                            },
	                            _c)
	                    }
	                ]
	            ],
	            disabled && [
	                {
	                    cursor: 'default'
	                },
	                !checked && [
	                    {
	                        borderColor: pillBorderDisabledColor
	                    }
	                ],
	                checked && [
	                    {
	                        backgroundColor: pillCheckedDisabledBackground,
	                        borderColor: 'transparent',
	                        justifyContent: 'flex-end'
	                    }
	                ]
	            ],
	            !disabled && {
	                selectors: {
	                    '&:hover': {
	                        selectors: (_e = {},
	                            _e[Styling_1.HighContrastSelector] = {
	                                borderColor: 'Highlight'
	                            },
	                            _e)
	                    }
	                }
	            }
	        ],
	        thumb: [
	            'ms-Toggle-thumb',
	            {
	                width: '.5em',
	                height: '.5em',
	                borderRadius: '.5em',
	                transition: 'all 0.1s ease',
	                backgroundColor: thumbBackground,
	                /* Border is added to handle high contrast mode for Firefox */
	                borderColor: 'transparent',
	                borderWidth: '.28em',
	                borderStyle: 'solid',
	                boxSizing: 'border-box'
	            },
	            !disabled &&
	                checked && [
	                {
	                    backgroundColor: thumbCheckedBackground,
	                    selectors: (_f = {},
	                        _f[Styling_1.HighContrastSelector] = {
	                            backgroundColor: 'Window',
	                            borderColor: 'Window'
	                        },
	                        _f)
	                }
	            ],
	            disabled && [
	                !checked && [
	                    {
	                        backgroundColor: thumbDisabledBackground
	                    }
	                ],
	                checked && [
	                    {
	                        backgroundColor: thumbCheckedDisabledBackground
	                    }
	                ]
	            ]
	        ],
	        text: [
	            'ms-Toggle-stateText',
	            {
	                selectors: {
	                    // Workaround: make rules more specific than Label rules.
	                    '&&': {
	                        padding: '0',
	                        margin: '0 8px',
	                        userSelect: 'none'
	                    }
	                }
	            },
	            disabled && {
	                selectors: {
	                    '&&': {
	                        color: textDisabledColor,
	                        selectors: (_g = {},
	                            _g[Styling_1.HighContrastSelector] = {
	                                color: 'GrayText'
	                            },
	                            _g)
	                    }
	                }
	            }
	        ]
	    };
	    var _a, _b, _c, _d, _e, _f, _g;
	};
	//# sourceMappingURL=Toggle.styles.js.map

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	// This component is used in components/common/dateselector.jsx
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Strings = {
	    /**
	     * Month Information
	     */
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	
	    /**
	     * Day Information
	     */
	    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	
	    /**
	     * Properties
	     */
	    goToToday: 'Go to today',
	    isRequiredErrorMessage: 'This field is required.',
	    invalidInputErrorMessage: 'Invalid date format.'
	};
	
	exports['default'] = Strings;
	module.exports = exports['default'];

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	/* This component is used in
	components/common/dateselector.jsx
	components/pages/defaultsettings/card.jsx
	 */
	
	var TimePicker = (function (_React$Component) {
		_inherits(TimePicker, _React$Component);
	
		function TimePicker(props, context) {
			_classCallCheck(this, TimePicker);
	
			_get(Object.getPrototypeOf(TimePicker.prototype), "constructor", this).call(this, props, context);
			this.state = {
				indices: this.props.values,
				attached: -1 // -1 : none, 0 : left dot, 1 : right dot
			};
			this.mouseUp = this.mouseUp.bind(this);
			this.mouseMove = this.mouseMove.bind(this);
		}
	
		_createClass(TimePicker, [{
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps) {
				if (this.state.attached == -1) {
					this.setState({ indices: nextProps.values });
				}
			}
		}, {
			key: "mouseDown",
			value: function mouseDown(e, idx) {
				e.preventDefault();
				if (this.props.disabled) {
					return;
				}
				this.setState({ "attached": idx });
				window.addEventListener("mouseup", this.mouseUp);
				window.addEventListener("mousemove", this.mouseMove);
			}
		}, {
			key: "mouseMove",
			value: function mouseMove(e) {
				var mousePos = this.getMousePos(e);
				var imageElement = this.refs['body'];
				var containerX = imageElement.offsetWidth;
				var containerY = imageElement.offsetHeight;
				var xpercent = Math.max(0, Math.min(100, mousePos.x / containerX * 100));
				var ypercent = Math.max(0, Math.min(100, mousePos.y / containerY * 100));
	
				var x = this.state.attached;
				var newIndices = this.state.indices.splice(0);
				var newIndex = this.getIndex(xpercent);
	
				for (var i = 0; i < x; i++) {
					newIndex = Math.max(newIndex, newIndices[i] + 1);
				}
				for (i = x + 1; i < newIndices.length; i++) {
					newIndex = Math.min(newIndex, newIndices[i] - 1);
				}
	
				newIndices[x] = newIndex;
				this.setState({ indices: newIndices });
			}
		}, {
			key: "getMousePos",
			value: function getMousePos(evt) {
				var imageElement = this.refs['body'].getBoundingClientRect();
				var mouseX = evt.clientX - imageElement.left;
				var mouseY = evt.clientY - imageElement.top;
				return {
					x: mouseX,
					y: mouseY
				};
			}
		}, {
			key: "mouseUp",
			value: function mouseUp(e) {
				e.stopPropagation();
				e.preventDefault();
				if (this.state.attached != -1) {
					this.setState({ "attached": -1 });
					window.removeEventListener("mouseup", this.mouseUp);
					window.removeEventListener("mousemove", this.mouseMove);
				}
				if (typeof this.props.onChange === 'function') {
					this.props.onChange(this.state.indices.splice(0));
				}
			}
		}, {
			key: "getLabel",
			value: function getLabel(idx) {
				return this.state.indices[idx] + ":00";
			}
		}, {
			key: "getPercent",
			value: function getPercent(idx) {
				return idx / this.props.nSegments * 100;
			}
		}, {
			key: "getIndex",
			value: function getIndex(percent) {
				// inverse function of this.getPercent(idx) (percent is rounded)
				return Math.round(percent * this.props.nSegments / 100);
			}
		}, {
			key: "render",
			value: function render() {
				var _this = this;
	
				return _react2["default"].createElement(
					"div",
					{ className: "timepicker", ref: "body" },
					_react2["default"].createElement(
						"div",
						{ className: "timepicker-body" },
						Array.apply(null, { length: this.props.nSegments - 1 }).map(function (x, idx) {
							return _react2["default"].createElement("div", { className: "timepicker-mark",
								style: { left: _this.getPercent(idx + 1) + "%" },
								key: idx
							});
						}),
						_react2["default"].createElement("div", { className: "timepicker-range",
							style: {
								left: this.getPercent(this.state.indices[0]) + "%",
								width: this.getPercent(this.state.indices[1]) - this.getPercent(this.state.indices[0]) + "%"
							}
						}),
						_react2["default"].createElement(
							"div",
							{
								className: "range-dot",
								onContextMenu: function (e) {
									return e.preventDefault();
								},
								onMouseDown: function (e) {
									return _this.mouseDown(e, 0);
								},
								style: { left: this.getPercent(this.state.indices[0]) + "%" } },
							_react2["default"].createElement(
								"span",
								{ className: "range-value" },
								this.getLabel(0)
							)
						),
						_react2["default"].createElement(
							"div",
							{
								className: "range-dot",
								onMouseDown: function (e) {
									return _this.mouseDown(e, 1);
								},
								style: { left: this.getPercent(this.state.indices[1]) + "%" } },
							_react2["default"].createElement(
								"span",
								{ className: "range-value" },
								this.getLabel(1)
							)
						)
					)
				);
			}
		}]);
	
		return TimePicker;
	})(_react2["default"].Component);
	
	exports["default"] = TimePicker;
	module.exports = exports["default"];

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	// This component is used in components/common/dateselector.jsx
	var PeriodButton = function PeriodButton(props) {
	
	    var active = props.active == props.value ? 'active' : '';
	    var className = "font--bold main-menu__times__item " + active;
	    return _react2['default'].createElement(
	        'span',
	        { onClick: function () {
	                return props.handleClick(props.value);
	            }, className: className },
	        props.value
	    );
	};
	exports['default'] = PeriodButton;
	module.exports = exports['default'];

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _componentsPagesOverviewWidgetsWidgetcontainer = __webpack_require__(1237);
	
	var _componentsPagesOverviewWidgetsWidgetcontainer2 = _interopRequireDefault(_componentsPagesOverviewWidgetsWidgetcontainer);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var Widgets = (function (_React$Component) {
	    _inherits(Widgets, _React$Component);
	
	    function Widgets(props, context) {
	        _classCallCheck(this, Widgets);
	
	        _get(Object.getPrototypeOf(Widgets.prototype), 'constructor', this).call(this, props, context);
	        this.state = {};
	    }
	
	    _createClass(Widgets, [{
	        key: 'deleteWidget',
	        value: function deleteWidget(nodeId) {
	            var user = this.props.user;
	            var index = user.details.location.indexOf(nodeId);
	            user.details.location.splice(index, 1);
	            this.props.dispatch((0, _actionsMyaccount.updateUser)(user.username, user));
	        }
	    }, {
	        key: 'editWidget',
	        value: function editWidget(nodeId1, nodeId2) {
	            var user = this.props.user;
	            if (user.details.location.indexOf(nodeId2) > -1) {
	                _toastr2['default'].error("This location's widget has already existed");
	            } else {
	                var index = user.details.location.indexOf(nodeId1);
	                user.details.location[index] = nodeId2;
	                this.props.dispatch((0, _actionsMyaccount.updateUser)(user.username, user));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var ids = [];
	            if (this.props.user.details && this.props.user.details.location && this.props.user.details.location.constructor === Array) {
	                ids = this.props.user.details.location;
	            }
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                ids.map(function (id, index) {
	                    var node = _this.props.nodeMap[id];
	                    if (node) {
	                        return _react2['default'].createElement(_componentsPagesOverviewWidgetsWidgetcontainer2['default'], {
	                            isComparisonWidget: false,
	                            id: id, key: index, node: node,
	                            deleteWidget: _this.deleteWidget.bind(_this),
	                            allSensors: _this.props.allSensors,
	                            querySettings: _this.props.querySettings,
	                            tree: _this.props.tree, editWidget: _this.editWidget.bind(_this) });
	                    }
	                    return null;
	                })
	            );
	        }
	    }]);
	
	    return Widgets;
	})(_react2['default'].Component);
	
	exports.Widgets = Widgets;
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        nodeMap: state.overviewReducer.nodeMap,
	        overviewMap: state.statsReducer.overviewMap
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Widgets);

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsPagesOverviewWidgetsWidget = __webpack_require__(1238);
	
	var _componentsPagesOverviewWidgetsWidget2 = _interopRequireDefault(_componentsPagesOverviewWidgetsWidget);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var WidgetContainer = (function (_React$Component) {
		_inherits(WidgetContainer, _React$Component);
	
		function WidgetContainer(props, context) {
			_classCallCheck(this, WidgetContainer);
	
			_get(Object.getPrototypeOf(WidgetContainer.prototype), 'constructor', this).call(this, props, context);
			var area = {};
			var type = this.props.node.type;
			switch (type) {
				case "open_area":
					area = _config2['default'].room.OPENAREA;
					break;
				case "meeting_room":
					area = _config2['default'].room.MEETINGROOM;
					break;
				default:
					area = _config2['default'].room.ALLAREA;
			}
	
			this.state = {
				area: area,
				data: {}
			};
		}
	
		_createClass(WidgetContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ data: this.getOverview(this.props) });
			}
		}, {
			key: 'querySettingsChanged',
			value: function querySettingsChanged(node, querrySettings, rawParams) {
				var params = (0, _actionsStats.getParams)({ querySettings: querrySettings, currentNode: node });
				params.tag = (0, _actionsStats.findOccupancyTag)({ type: this.state.area.code });
				return params.startdate !== rawParams.startdate || params.enddate !== rawParams.enddate || params.starthour !== rawParams.starthour || params.endhour !== rawParams.endhour || params.weekdaymask !== rawParams.weekdaymask || params.tag !== rawParams.tag || params.room !== rawParams.room;
			}
		}, {
			key: 'getOverview',
			value: function getOverview(props) {
				var node = props.node;
				var data = this.state.data;
				if (node) {
					var id = node.id;
					var overview = props.overviewMap[id];
					if (overview && !overview.loading && !this.querySettingsChanged(node, props.querySettings, overview.params)) {
						data = overview.data;
					} else if (overview && overview.loading) {
						// just wait
					} else {
							var params = (0, _actionsStats.getParams)({ querySettings: props.querySettings, currentNode: node });
							params.tag = (0, _actionsStats.findOccupancyTag)({ type: this.state.area.code });
							props.dispatch((0, _actionsStats.getOccupancyOverview)(params, node));
						}
				}
				return data;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var type = nextProps.node.type;
				if (this.props.node.type != type) {
					var area = {};
					switch (type) {
						case "open_area":
							area = _config2['default'].room.OPENAREA;
							break;
						case "meeting_room":
							area = _config2['default'].room.MEETINGROOM;
							break;
						default:
							area = _config2['default'].room.ALLAREA;
					}
					this.selectAreaFilter(area);
				} else {
					this.setState({ data: this.getOverview(nextProps) });
				}
			}
		}, {
			key: 'selectAreaFilter',
			value: function selectAreaFilter(area) {
				var _this = this;
	
				this.setState({ area: area }, function () {
					return _this.setState({ data: _this.getOverview(_this.props) });
				});
			}
		}, {
			key: 'countTreeStatistic',
			value: function countTreeStatistic(root, map) {
				var statistic = {
					allRooms: 0,
					allSensors: 0,
					roomsInUse: 0,
					desksInUse: 0,
					faulties: 0
				};
				this.count(root, statistic, map);
				return statistic;
			}
		}, {
			key: 'count',
			value: function count(root, statistic, map) {
				var self = this;
				if (root != null && root.children != null && root.children.length > 0) {
					if ((root.type == 'meeting_room' || root.type == 'open_area') && this.state.area.code == 'all_areas' || root.type == this.state.area.code) {
						statistic.allRooms++;
						var occupied = false;
						root.children.forEach(function (sensor) {
							var status = map.get(sensor.id);
							if (status) {
								if (status.inuse) {
									occupied = true;
									statistic.desksInUse++;
								} else if (!status.registered || status.faulty && status.lastonl + 24 * 60 * 60 < (0, _moment2['default'])().unix()) {
									// (map.get(sensor.id).faulty) {
									statistic.faulties++;
								}
							}
						});
						statistic.allSensors += root.children.length;
						if (occupied) {
							statistic.roomsInUse++;
						}
					} else {
						root.children.forEach(function (node) {
							self.count(node, statistic, map);
						});
					}
				}
			}
		}, {
			key: 'redirectMaintenanceView',
			value: function redirectMaintenanceView(node) {
				if (node.info.hasfloorplan) {
					this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(_config2['default'].viewFilter[2]));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var stats = this.countTreeStatistic(this.props.node, this.props.allSensors);
				var gauge = [this.state.data.average || 0, this.state.data.peak || 0];
				var bar = this.state.data.marks || [1, 0, 0];
				return _react2['default'].createElement(_componentsPagesOverviewWidgetsWidget2['default'], {
					id: this.props.id,
					isComparisonWidget: this.props.isComparisonWidget,
					bar: bar,
					gauge: gauge,
					type: this.state.area.type,
					node: this.props.node,
					stats: stats,
					getOverview: this.selectAreaFilter.bind(this), action: this.props.action,
					redirectMaintenanceView: this.redirectMaintenanceView.bind(this),
					deleteWidget: this.props.deleteWidget.bind(this),
					tree: this.props.tree,
					editWidget: this.props.editWidget });
			}
		}]);
	
		return WidgetContainer;
	})(_react2['default'].Component);
	
	exports.WidgetContainer = WidgetContainer;
	
	function mapStateToProps(state) {
		return {
			user: state.myAccountReducer.user,
			overviewMap: state.statsReducer.overviewMap
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	//import Modal from "components/common/modal";
	
	var _componentsCommonDropdowncomponentsRoomtypeselector = __webpack_require__(1239);
	
	var _componentsCommonDropdowncomponentsRoomtypeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsRoomtypeselector);
	
	var _componentsCommonWidgetsGauge = __webpack_require__(1243);
	
	var _componentsCommonWidgetsGauge2 = _interopRequireDefault(_componentsCommonWidgetsGauge);
	
	var _componentsCommonWidgetsBar = __webpack_require__(1244);
	
	var _componentsCommonWidgetsBar2 = _interopRequireDefault(_componentsCommonWidgetsBar);
	
	var _componentsCommonWidgetsLocationstats = __webpack_require__(1246);
	
	var _componentsCommonWidgetsLocationstats2 = _interopRequireDefault(_componentsCommonWidgetsLocationstats);
	
	var _componentsCommonWidgetsLocationbottommenu = __webpack_require__(1247);
	
	var _componentsCommonWidgetsLocationbottommenu2 = _interopRequireDefault(_componentsCommonWidgetsLocationbottommenu);
	
	var Widget = (function (_React$Component) {
	    _inherits(Widget, _React$Component);
	
	    function Widget() {
	        _classCallCheck(this, Widget);
	
	        _get(Object.getPrototypeOf(Widget.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Widget, [{
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'grid-widget-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'widget-card  box--shadow bg--white', ref: function (e) {
	                            _this.widget = e;
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'widget-card__header' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'cursor--pointer ', 'data-tooltip': this.props.node.info.name },
	                            _react2['default'].createElement(
	                                'h3',
	                                null,
	                                this.props.node.info.name
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'widget-card__buttons' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'widget-card__buttons__location-select' },
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsRoomtypeselector2['default'], { roomType: this.props.node.type, type: this.props.type, chooseType: this.props.getOverview })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'widget-card__buttons__quickaccess' },
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { className: 'widget-btn', 'data-tooltip': 'Stats',
	                                    to: '/statistic/' + this.props.node.id },
	                                _react2['default'].createElement('span', { className: 'font-icon icon-stats' })
	                            ),
	                            this.props.node.info.hasfloorplan ? _react2['default'].createElement(
	                                _react2['default'].Fragment,
	                                null,
	                                _react2['default'].createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        className: 'widget-btn',
	                                        'data-tooltip': 'Heatmap',
	                                        to: '/heatmap/' + this.props.node.id },
	                                    _react2['default'].createElement('span', { className: 'font-icon icon-heatmap' })
	                                ),
	                                _react2['default'].createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        className: 'widget-btn',
	                                        'data-tooltip': 'Live',
	                                        to: 'live/' + this.props.node.id },
	                                    _react2['default'].createElement('span', { className: 'font-icon icon-live' })
	                                )
	                            ) : _react2['default'].createElement(
	                                _react2['default'].Fragment,
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'widget-btn widget-btn_disabled', 'data-tooltip': 'Heatmap not available' },
	                                    _react2['default'].createElement('span', { className: 'font-icon icon-heatmap' })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'widget-btn widget-btn_disabled', 'data-tooltip': 'Live not available' },
	                                    _react2['default'].createElement('span', { className: 'font-icon icon-live' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(_componentsCommonWidgetsGauge2['default'], {
	                        label: 'Occupancy',
	                        arcParams: [85, 110],
	                        values: this.props.gauge
	                    }),
	                    _react2['default'].createElement(_componentsCommonWidgetsBar2['default'], { id: this.props.id, values: this.props.bar }),
	                    _react2['default'].createElement(_componentsCommonWidgetsLocationstats2['default'], { stats: this.props.stats }),
	                    _react2['default'].createElement(_componentsCommonWidgetsLocationbottommenu2['default'], {
	                        isComparisonWidget: this.props.isComparisonWidget,
	                        faulty: this.props.stats.faulties, node: this.props.node,
	                        redirectMaintenanceView: this.props.redirectMaintenanceView,
	                        deleteWidget: this.props.deleteWidget,
	                        tree: this.props.tree, editWidget: this.props.editWidget,
	                        widget: this.widget
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Widget;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        nodeMap: state.overviewReducer.nodeMap,
	        overviewMap: state.statsReducer.overviewMap
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Widget);
	module.exports = exports['default'];
	/*
	<Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openInfoModal = elem }}
	   clickButton={() => { this.openInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	       <div onClick={() => { this.openInfoModal.open() }} className="widget-card__header-info cursor--pointer">
	           <img src="src/assets/icons/info.svg" alt="info-icon" />
	       </div>
	   }
	>
	   <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>
	*/ /*
	      arcParams={[x, y]}
	      x: radius
	      y: arcAngle
	   */

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	/* This component is used in
	components/common/statsmenu.jsx
	components/pages/overview/widgets/widget.jsx
	*/
	var optionClicked = function optionClicked(props, room) {
		props.chooseType(room);
	};
	var RoomTypeSelector = function RoomTypeSelector(props) {
		var singleMode = (props.roomType == 'open_area' || props.roomType == 'meeting_room') && (props.type == 'Meeting rooms' || props.type == 'Open areas');
	
		return !singleMode ? _react2['default'].createElement(
			_componentsCommonDropdowncomponentsDropdown2['default'],
			{ className: props.className, header: props.type, toggleable: true },
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdownitem2['default'],
				null,
				_react2['default'].createElement(
					'div',
					{ onClick: optionClicked.bind(undefined, props, _config2['default'].room.MEETINGROOM) },
					_config2['default'].room.MEETINGROOM.type
				)
			),
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdownitem2['default'],
				null,
				_react2['default'].createElement(
					'div',
					{ onClick: optionClicked.bind(undefined, props, _config2['default'].room.OPENAREA) },
					_config2['default'].room.OPENAREA.type
				)
			),
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdownitem2['default'],
				null,
				_react2['default'].createElement(
					'div',
					{ onClick: optionClicked.bind(undefined, props, _config2['default'].room.ALLAREA) },
					_config2['default'].room.ALLAREA.type
				)
			)
		) : _react2['default'].createElement(
			'div',
			{ className: 'dropdown-default-text ' + props.className },
			props.type
		);
	};
	exports['default'] = RoomTypeSelector;
	module.exports = exports['default'];

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var DropDown = _react2['default'].forwardRef(function (props, ref) {
	    var toggleable = props.toggleable;
	    var className = props.className;
	    var header = props.header;
	    var noArrow = props.noArrow;
	    var frozenItems = props.frozenItems;
	    var children = props.children;
	    var dropdownItemsWrapperStyle = props.dropdownItemsWrapperStyle;
	
	    var _React$useState = _react2['default'].useState(false);
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var opened = _React$useState2[0];
	    var setOpen = _React$useState2[1];
	
	    var dropdownRef = _react2['default'].useRef(null);
	    _react2['default'].useImperativeHandle(ref, function () {
	        return {
	            handleClick: function handleClick() {
	                _handleClick();
	            }
	        };
	    });
	    function _handleClick() {
	        toggleable && setOpen(!opened);
	    }
	
	    function close() {
	        setOpen(false);
	    }
	
	    (0, _componentsCommonHooks.useOnClickOutside)(dropdownRef, function () {
	        opened && close();
	    });
	
	    return _react2['default'].createElement(
	        'div',
	        { ref: dropdownRef, className: (opened ? "dropdown open" : "dropdown") + ' ' + (className ? className : '') },
	        _react2['default'].createElement(
	            'div',
	            { className: 'dropdown__toggle', onClick: function () {
	                    return _handleClick();
	                } },
	            header,
	            !noArrow && _react2['default'].createElement('img', { className: 'dropdown__toggle__arrow', src: "src/assets/icons/" + (opened ? "arrow-up.svg" : "arrow-down.svg") })
	        ),
	        toggleable && _react2['default'].createElement(
	            'div',
	            { onClick: function () {
	                    return frozenItems ? null : close();
	                }, className: 'dropdown__items', style: dropdownItemsWrapperStyle },
	            children
	        )
	    );
	});
	
	exports['default'] = DropDown;
	module.exports = exports['default'];

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports.useInterval = useInterval;
	exports.useHover = useHover;
	exports.useOnClickOutside = useOnClickOutside;
	exports.usePrevious = usePrevious;
	exports.useAnimationTimer = useAnimationTimer;
	exports.useAnimation = useAnimation;
	
	var _react = __webpack_require__(38);
	
	// Hook
	
	function useInterval(callback, delay) {
	    var savedCallback = (0, _react.useRef)();
	
	    // Remember the latest callback.
	    (0, _react.useEffect)(function () {
	        savedCallback.current = callback;
	    }, [callback]);
	
	    // Set up the interval.
	    (0, _react.useEffect)(function () {
	        function tick() {
	            savedCallback.current();
	        }
	        if (delay !== null) {
	            var _ret = (function () {
	                var id = setInterval(tick, delay);
	                return {
	                    v: function () {
	                        return clearInterval(id);
	                    }
	                };
	            })();
	
	            if (typeof _ret === 'object') return _ret.v;
	        }
	    }, [delay]);
	}
	
	function useHover() {
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var value = _useState2[0];
	    var setValue = _useState2[1];
	
	    var ref = (0, _react.useRef)(null);
	
	    var handleMouseOver = function handleMouseOver() {
	        return setValue(true);
	    };
	    var handleMouseOut = function handleMouseOut() {
	        return setValue(false);
	    };
	
	    (0, _react.useEffect)(function () {
	        var node = ref.current;
	        if (node) {
	            node.addEventListener('mouseover', handleMouseOver);
	            node.addEventListener('mouseout', handleMouseOut);
	
	            return function () {
	                node.removeEventListener('mouseover', handleMouseOver);
	                node.removeEventListener('mouseout', handleMouseOut);
	            };
	        }
	    }, []);
	
	    return [ref, value];
	}
	
	// Hook
	
	function useOnClickOutside(ref, handler) {
	    (0, _react.useEffect)(function () {
	        var listener = function listener(event) {
	            // Do nothing if clicking ref's element or descendent elements
	            if (!ref.current || ref.current.contains(event.target)) {
	                return;
	            }
	
	            handler(event);
	        };
	
	        document.addEventListener('mousedown', listener);
	        document.addEventListener('touchstart', listener);
	
	        return function () {
	            document.removeEventListener('mousedown', listener);
	            document.removeEventListener('touchstart', listener);
	        };
	    },
	    // Add ref and handler to effect dependencies
	    // It's worth noting that because passed in handler is a new ...
	    // ... function on every render that will cause this effect ...
	    // ... callback/cleanup to run every render. It's not a big deal ...
	    // ... but to optimize you can wrap handler in useCallback before ...
	    // ... passing it into this hook.
	    [ref, handler]);
	}
	
	function usePrevious(value) {
	    // The ref object is a generic container whose current property is mutable ...
	    // ... and can hold any value, similar to an instance property on a class
	    var ref = (0, _react.useRef)();
	
	    // Store current value in ref
	    (0, _react.useEffect)(function () {
	        ref.current = value;
	    }, [value]); // Only re-run if value changes
	
	    // Return previous value (happens before update in useEffect above)
	    return ref.current;
	}
	
	function useAnimationTimer() {
	    var duration = arguments.length <= 0 || arguments[0] === undefined ? 1000 : arguments[0];
	    var delay = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	    var _useState3 = (0, _react.useState)(0);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var elapsed = _useState32[0];
	    var setTime = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(animationStates.idle);
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var animationState = _useState42[0];
	    var setAnimationState = _useState42[1];
	
	    (0, _react.useEffect)(function () {
	        var animationFrame = undefined,
	            timerStop = undefined,
	            start = undefined;
	        // Function to be executed on each animation frame
	        function onFrame() {
	            setTime(Date.now() - start);
	            loop();
	        }
	
	        // Call onFrame() on next animation frame
	        function loop() {
	            animationFrame = requestAnimationFrame(onFrame);
	        }
	
	        function onStart() {
	            setAnimationState(animationStates.started);
	            // Set a timeout to stop things when duration time elapses
	            timerStop = setTimeout(function () {
	                setAnimationState(animationStates.finished);
	                cancelAnimationFrame(animationFrame);
	                setTime(Date.now() - start);
	            }, duration);
	
	            // Start the loop
	            start = Date.now();
	            loop();
	        }
	
	        // Reset animation state
	        setAnimationState(animationStates.idle);
	
	        // Start after specified delay (defaults to 0)
	        var timerDelay = setTimeout(onStart, delay);
	
	        // Clean things up
	        return function () {
	            setTime(0);
	            clearTimeout(timerStop);
	            clearTimeout(timerDelay);
	            cancelAnimationFrame(animationFrame);
	        };
	    }, [duration, delay] // Only re-run effect if duration or delay changes
	    );
	
	    return { elapsed: elapsed, animationState: animationState };
	}
	
	function useAnimation() {
	    var easingName = arguments.length <= 0 || arguments[0] === undefined ? "linear" : arguments[0];
	    var duration = arguments.length <= 1 || arguments[1] === undefined ? 500 : arguments[1];
	    var delay = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
	    // The useAnimationTimer hook calls useState every animation frame ...
	    // ... giving us elapsed time and causing a rerender as frequently ...
	    // ... as possible for a smooth animation.
	
	    var _useAnimationTimer = useAnimationTimer(duration, delay);
	
	    var elapsed = _useAnimationTimer.elapsed;
	    var animationState = _useAnimationTimer.animationState;
	
	    // Amount of specified duration elapsed on a scale from 0 - 1
	    var n = Math.min(1, elapsed / duration);
	    // Return altered value based on our specified easing function
	    var value = easing[easingName](n);
	
	    return {
	        value: value,
	        animationState: animationState
	    };
	}
	
	// Some easing functions copied from:
	// https://github.com/streamich/ts-easing/blob/master/src/index.ts
	// Hardcode here or pull in a dependency
	var easing = {
	    linear: function linear(n) {
	        return n;
	    },
	    elastic: function elastic(n) {
	        return n * (33 * n * n * n * n - 106 * n * n * n + 126 * n * n - 67 * n + 15);
	    },
	    inExpo: function inExpo(n) {
	        return Math.pow(2, 10 * (n - 1));
	    }
	};
	
	var animationStates = {
	    idle: "idle", // represents "delayed" state
	    started: "started",
	    finished: "finished"
	};

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	/*
	This component is used in
	components/common/dropdowncomponents/dataexportdropdown/heatmapexport.jsx
	components/common/dropdowncomponents/dataexportdropdown/statsexport.jsx
	components/common/dropdowncomponents/dataexportdropdown/widgetexport.jsx
	components/common/dayselector.jsx
	components/common/dropdowncomponents/listdropdown.jsx
	components/common/modeselector.jsx
	components/common/dropdowncomponents/nodedropdown.jsx
	components/common/dropdowncomponents/roomtypeselector.jsx
	components/common/tagselector.jsx
	*/
	var DropdownItem = function DropdownItem(props) {
	  return _react2['default'].createElement(
	    'div',
	    { style: props.style ? props.style : {}, className: 'dropdown__item ' + (props.className ? props.className : '') },
	    props.children
	  );
	};
	
	exports['default'] = DropdownItem;
	module.exports = exports['default'];

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; })();
	
	exports["default"] = Gauge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var squareViewBox = 245;
	var Arc = function Arc(props) {
	    return _react2["default"].createElement(
	        "svg",
	        { className: "clock__arc-svg", width: squareViewBox, height: squareViewBox, viewBox: "0 0 " + squareViewBox + " " + squareViewBox, xmlns: "http://www.w3.org/2000/svg" },
	        _react2["default"].createElement(
	            "g",
	            { transform: "rotate(" + props.rotAngle + "," + squareViewBox / 2 + "," + squareViewBox / 2 + ")" },
	            _react2["default"].createElement("circle", { className: "arc-base", cx: "50%", cy: "50%", r: props.r, strokeDasharray: props.strokeDasharrayBase, stroke: "#EEE", strokeWidth: "7px" }),
	            _react2["default"].createElement("circle", { className: "arc-peak", cx: "50%", cy: "50%", r: props.r, strokeDasharray: props.strokeDasharrayArc, stroke: "#3cb449", strokeWidth: "7px" })
	        ),
	        _react2["default"].createElement(
	            "text",
	            { className: "clock__arc-svg-label", x: "50%", y: "67%", dominantBaseline: "middle", textAnchor: "middle" },
	            "Occupancy"
	        )
	    );
	};
	
	var Needle = function Needle(props) {
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var haveTrans = _useState2[0];
	    var setHaveTrans = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        window.addEventListener("resize", setHaveTrans(false));
	        return function () {
	            window.removeEventListener("resize", setHaveTrans(false));
	        };
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (!haveTrans) {
	            setHaveTrans(true);
	        }
	    }, [haveTrans, props.rotate]);
	
	    return _react2["default"].createElement(
	        "svg",
	        { className: "clock__arc-needle", width: squareViewBox, height: squareViewBox, viewBox: "0 0 " + squareViewBox + " " + squareViewBox },
	        _react2["default"].createElement(
	            "defs",
	            null,
	            _react2["default"].createElement(
	                "filter",
	                { id: "glow-gray" },
	                _react2["default"].createElement("feOffset", { "in": "SourceAlpha", dx: "-0.1", dy: "0.1", result: "offOut" }),
	                _react2["default"].createElement("feGaussianBlur", { "in": "offOut", stdDeviation: "1", result: "blurOut" }),
	                _react2["default"].createElement(
	                    "feComponentTransfer",
	                    null,
	                    _react2["default"].createElement("feFuncA", { type: "linear", slope: "0.5" })
	                ),
	                _react2["default"].createElement(
	                    "feMerge",
	                    null,
	                    _react2["default"].createElement("feMergeNode", null),
	                    _react2["default"].createElement("feMergeNode", { "in": "SourceGraphic" })
	                )
	            )
	        ),
	        _react2["default"].createElement(
	            "g",
	            { transform: props.rotate, className: haveTrans ? "have-trans" : "" },
	            _react2["default"].createElement(
	                "g",
	                { filter: "url(#glow-gray)" },
	                _react2["default"].createElement("line", { stroke: "#3f5043", strokeWidth: "2", x1: squareViewBox / 2, y1: squareViewBox / 2, x2: squareViewBox / 1.32, y2: squareViewBox / 2 }),
	                _react2["default"].createElement("circle", { cx: squareViewBox / 2, cy: squareViewBox / 2, r: "9.360000000000001", fill: "#3f5043" })
	            )
	        )
	    );
	};
	
	var Info = function Info(props) {
	    return _react2["default"].createElement(
	        _react2["default"].Fragment,
	        null,
	        _react2["default"].createElement(
	            "p",
	            { className: "clock__info-label clock__info-label_left" },
	            _react2["default"].createElement(
	                "b",
	                { className: "font--proLight" },
	                props.avgPercent
	            ),
	            _react2["default"].createElement(
	                "span",
	                { className: "small-label" },
	                "% Avg"
	            )
	        ),
	        _react2["default"].createElement(
	            "p",
	            { className: "clock__info-label clock__info-label_right clock__info-label_text_green" },
	            _react2["default"].createElement(
	                "span",
	                { className: "small-label" },
	                "Peak "
	            ),
	            _react2["default"].createElement(
	                "b",
	                { className: "font--proLight" },
	                props.peakPercent
	            ),
	            _react2["default"].createElement(
	                "span",
	                { className: "small-label" },
	                "%"
	            )
	        )
	    );
	};
	
	var Marker = function Marker(props) {
	    return _react2["default"].createElement(
	        "p",
	        { style: props.css },
	        _react2["default"].createElement(
	            "span",
	            { className: "ticks bold" },
	            "|"
	        )
	    );
	};
	
	function Gauge(props) {
	    var _useState3 = (0, _react.useState)({});
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var clockCss = _useState32[0];
	    var setCss = _useState32[1];
	
	    var myClockRef = (0, _react.useRef)(null);
	    (0, _react.useEffect)(function () {
	        window.addEventListener("resize", updateWidth());
	        return function () {
	
	            window.removeEventListener("resize", updateWidth());
	        };
	    }, []);
	
	    function updateWidth() {
	        var width = myClockRef.current.offsetWidth;
	        var scaleNum = width / squareViewBox;
	        var scale = "scale(" + scaleNum + ")";
	        var height = 200 * scaleNum;
	        var clockCss = {
	            transformOrigin: 'left top',
	            WebkitTransformOrigin: 'left top',
	            transform: scale,
	            WebkitTransform: scale,
	            fontSize: "14px",
	            height: height + "px"
	        };
	        setCss(clockCss);
	    }
	
	    function renderArc() {
	        var cf, fullDashLen, arcDashLen, r, arcAngle, rotAngle, peakValue;
	        peakValue = props.values[1]; //peak
	        r = props.arcParams[0];
	        arcAngle = props.arcParams[1];
	        cf = 2 * r * Math.PI;
	        fullDashLen = cf * ((360 - arcAngle) / 360);
	        arcDashLen = fullDashLen * peakValue;
	        rotAngle = (180 - arcAngle) / 2 + arcAngle;
	        var strokeDasharrayArc = [arcDashLen, cf];
	        var strokeDasharrayBase = [fullDashLen, cf];
	        return _react2["default"].createElement(Arc, {
	            r: r,
	            strokeDasharrayArc: strokeDasharrayArc,
	            strokeDasharrayBase: strokeDasharrayBase,
	            rotAngle: rotAngle
	        });
	    }
	
	    function renderNeedle() {
	        var arcAngle, avgValue;
	        avgValue = props.values[0];
	        arcAngle = props.arcParams[1];
	        var offset = (180 - arcAngle) / 2 + arcAngle;
	        var needleAngle = offset + (360 - arcAngle) * avgValue;
	        var rotate = "rotate( " + needleAngle + "," + squareViewBox / 2 + "," + squareViewBox / 2 + ")";
	        return _react2["default"].createElement(Needle, {
	            rotate: rotate
	        });
	    }
	
	    function renderInfo() {
	        var avgPercent = Math.round(props.values[0] * 100);
	        var peakPercent = Math.round(props.values[1] * 100);
	        return _react2["default"].createElement(Info, {
	            avgPercent: avgPercent,
	            peakPercent: peakPercent
	        });
	    }
	
	    function renderMarkers() {
	        var markerValue, markerAngle, arcAngle, count;
	        var returnArray = [];
	        var css = {};
	        var rotate = "";
	        var offset = 2;
	        arcAngle = props.arcParams[1];
	        count = 5;
	        for (var i = 0; i < count; i++) {
	            markerValue = 0 + i * 100 / (count - 1);
	            markerAngle = -(362 - arcAngle - offset) / 2 + i * (362 - arcAngle - offset) / (count - 1);
	            rotate = "rotate(" + markerAngle + "deg)";
	            css = {
	                WebkitTransform: rotate,
	                transform: rotate
	            };
	            returnArray[i] = _react2["default"].createElement(Marker, { key: i, markerValue: markerValue, css: css });
	        }
	        return returnArray;
	    }
	
	    return _react2["default"].createElement(
	        "div",
	        { className: "clock", ref: myClockRef, style: clockCss },
	        _react2["default"].createElement(
	            "div",
	            { className: "clock__markers", style: { width: squareViewBox + "px", height: squareViewBox + "px" } },
	            renderMarkers()
	        ),
	        _react2["default"].createElement(
	            "div",
	            { className: "clock__info" },
	            renderInfo()
	        ),
	        _react2["default"].createElement(
	            "div",
	            { className: "clock__arc" },
	            renderArc(),
	            renderNeedle()
	        )
	    );
	}
	
	module.exports = exports["default"];
	/* <span style={{ display: "none" }} className="percent">{props.markerValue}</span><br></br>
	   */

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = Bar;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var Segment = function Segment(props) {
	    return _react2['default'].createElement('line', {
	        x1: '0', x2: props.maxLength,
	        y1: '30', y2: '30',
	        stroke: props.color, strokeWidth: '20', strokeOpacity: '1',
	        strokeDasharray: props.strokeDasharray, transform: props.x1, style: props.css
	    });
	};
	
	function Bar(props) {
	    var _useState = (0, _react.useState)({});
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var containerCss = _useState2[0];
	    var setContainerCss = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([0, 0, 0]);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var lengths = _useState32[0];
	    var setLengths = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(false);
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var haveTrans = _useState42[0];
	    var setHaveTrans = _useState42[1];
	
	    var myBarRef = (0, _react.useRef)(null);
	
	    var _useHover = (0, _componentsCommonHooks.useHover)();
	
	    var _useHover2 = _slicedToArray(_useHover, 2);
	
	    var hoverRef = _useHover2[0];
	    var isHovered = _useHover2[1];
	
	    var maxLength = 245;
	    var colors = ["rgb(235,241,222)", "rgb(196,215,155)", "rgb(79, 98, 41)"];
	    (0, _react.useEffect)(function () {
	        window.addEventListener("resize", updateWidth());
	        window.addEventListener("resize", setHaveTrans(false));
	
	        // Verify values
	        var values = props.values.slice();
	        // values[0] = Math.max(0, Math.min( values[0], 1 ));
	        // values[1] = Math.max(0, Math.min( values[1], 1-values[0] ));
	        // values[2] = Math.round(Math.max(0, Math.min( 1 - (values[0] + values[1]), 1 )) * 10000) / 10000;
	        //  const test = [0.553, 0.179, 0.267]
	        setLengths(values);
	        return function () {
	            window.removeEventListener("resize", setHaveTrans(false));
	            window.removeEventListener("resize", updateWidth());
	        };
	    }, [props.values]);
	    (0, _react.useEffect)(function () {
	        if (!haveTrans) {
	            setHaveTrans(true);
	        }
	        var values = props.values.slice();
	        // const test = [0.993, 0.005, 0.002]
	        setLengths(values);
	    }, [haveTrans, props.values]);
	
	    function updateWidth() {
	        var width = myBarRef.current.offsetWidth;
	        var scaleNum = width / maxLength * 1;
	        var scale = "scale(" + scaleNum + ")";
	        var height = scaleNum * 70;
	        var css = {
	            transformOrigin: 'left top',
	            WebkitTransformOrigin: 'left top',
	            transform: scale,
	            WebkitTransform: scale,
	            height: height + 'px'
	        };
	        setContainerCss(css);
	    }
	
	    function renderInfo(i) {
	        // Show in middle of Segment
	        var offset = -8;
	        var left = 0;
	        for (var n = 0; n < i; n++) {
	            left += lengths[n];
	            // offsetLeft -= offset;
	            // offsetRight += offset;
	        }
	        left = offset + (left + lengths[i] / 2) * maxLength;
	
	        var css = {
	            left: left
	        };
	        // Convert values to percent first
	        var percent = Math.round(lengths[i] * 1000) / 10;
	        // General display condition don't show if length is zero
	        var generalDisplayCondition = '' + (lengths[i] < 0.001 ? "hide " : "");
	
	        var labelClassName = 'bar-info__label ' + (haveTrans ? "bar-info_have_trans" : "bar-info_no_trans") + ' ' + (Number(i) !== 1 ? "bar-info_top" : "") + ' ';
	        var marker = percent + "%";
	        return _react2['default'].createElement(
	            _react2['default'].Fragment,
	            null,
	            _react2['default'].createElement(
	                'span',
	                { className: labelClassName + ' ' + generalDisplayCondition + ' ',
	                    style: css },
	                marker
	            )
	        );
	    }
	
	    function renderSegment(i) {
	        // Set x origin of segment
	        var x1 = 0;
	        for (var n = 0; n < i; n++) {
	            x1 += lengths[n];
	        }
	        // Don't draw if length is zero
	        var strokeColors = colors.slice();
	        if (Number(lengths[i]) <= 0.001) {
	            strokeColors[i] = "none";
	        }
	        x1 = Math.max(0, x1 * maxLength);
	        var translateX = "translate(" + x1 + ")";
	        // Set strokeDasharray
	        var strokeDasharray = [0, maxLength];
	        strokeDasharray[0] = lengths[i] * maxLength;
	        strokeDasharray[1] = (1 - lengths[i]) * maxLength;
	        var haveTransCss = {
	            transitionProperty: "all",
	            transitionDuration: "1s",
	            transitionTimingFunction: "easeInOut"
	        };
	        return _react2['default'].createElement(Segment, {
	            x1: translateX,
	            strokeDasharray: strokeDasharray,
	            maxLength: maxLength,
	            color: strokeColors[i],
	            css: haveTrans ? haveTransCss : {}
	        });
	    }
	    return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'widget-card__stacked-bar', style: containerCss, ref: myBarRef },
	            _react2['default'].createElement(
	                'svg',
	                { className: 'bar-svg' },
	                renderSegment(0),
	                renderSegment(2),
	                renderSegment(1),
	                ' '
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'bar-info', id: "legend-tooltip" + props.id, ref: hoverRef },
	                renderInfo(0),
	                renderInfo(1),
	                renderInfo(2)
	            ),
	            _react2['default'].createElement(
	                _reactPortalTooltip2['default'],
	                { active: isHovered, position: 'top', arrow: 'center',
	                    parent: "#legend-tooltip" + props.id,
	                    style: {
	                        style: {
	                            background: "rgba(0,0,0,1)",
	                            padding: 10,
	                            color: "#EEE",
	                            boxShadow: "5px 5px 3px rgba(0,0,0,.8)",
	                            borderRadius: 0,
	                            transition: 'all .2s ease-in-out',
	                            zIndex: 7089
	                        },
	                        arrowStyle: {
	                            display: "none"
	                        }
	                    },
	                    tooltipTimeout: 200
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'stacked-bar-legends' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'stacked-bar-legends__header' },
	                        'Occupancy Breakdown'
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'stacked-bar-legends__info' },
	                        'How many percent of total working time the occupancy percentage has been within the following ranges:'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'stacked-bar-legends__wrapper' },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            '<25%'
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            '25-75%'
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            ' >75%'
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	module.exports = exports['default'];
	/*Draw middle segment last*/

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(40);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var Card = (function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  function Card() {
	    _classCallCheck(this, Card);
	
	    _get(Object.getPrototypeOf(Card.prototype), 'constructor', this).apply(this, arguments);
	
	    this.state = {
	      hover: false,
	      transition: 'opacity',
	      width: 0,
	      height: 0
	    };
	    this.margin = 15;
	    this.defaultArrowStyle = {
	      color: '#fff',
	      borderColor: 'rgba(0,0,0,.4)'
	    };
	  }
	
	  _createClass(Card, [{
	    key: 'getGlobalStyle',
	    value: function getGlobalStyle() {
	      if (!this.props.parentEl) {
	        return { display: 'none' };
	      }
	
	      var style = {
	        position: 'absolute',
	        padding: '5px',
	        background: '#fff',
	        boxShadow: '0 0 8px rgba(0,0,0,.3)',
	        borderRadius: '3px',
	        transition: this.state.transition + ' .3s ease-in-out, visibility .3s ease-in-out',
	        opacity: this.state.hover || this.props.active ? 1 : 0,
	        visibility: this.state.hover || this.props.active ? 'visible' : 'hidden',
	        zIndex: 50
	      };
	
	      (0, _objectAssign2['default'])(style, this.getStyle(this.props.position, this.props.arrow));
	
	      return this.mergeStyle(style, this.props.style.style);
	    }
	  }, {
	    key: 'getBaseArrowStyle',
	    value: function getBaseArrowStyle() {
	      return {
	        position: 'absolute',
	        content: '""',
	        transition: 'all .3s ease-in-out'
	      };
	    }
	  }, {
	    key: 'getArrowStyle',
	    value: function getArrowStyle() {
	      var fgStyle = this.getBaseArrowStyle();
	      var bgStyle = this.getBaseArrowStyle();
	      fgStyle.zIndex = 60;
	      bgStyle.zIndex = 55;
	
	      var arrowStyle = (0, _objectAssign2['default'])(this.defaultArrowStyle, this.props.style.arrowStyle);
	      var bgBorderColor = arrowStyle.borderColor ? arrowStyle.borderColor : 'transparent';
	
	      var fgSize = 8;
	      var bgSize = 9;
	      var fgColorBorder = '10px solid ' + arrowStyle.color;
	      var fgTransBorder = fgSize + 'px solid transparent';
	      var bgColorBorder = '11px solid ' + bgBorderColor;
	      var bgTransBorder = bgSize + 'px solid transparent';
	
	      var _props = this.props;
	      var position = _props.position;
	      var arrow = _props.arrow;
	
	      if (position === 'left' || position === 'right') {
	        fgStyle.top = '50%';
	        fgStyle.borderTop = fgTransBorder;
	        fgStyle.borderBottom = fgTransBorder;
	        fgStyle.marginTop = -7;
	
	        bgStyle.borderTop = bgTransBorder;
	        bgStyle.borderBottom = bgTransBorder;
	        bgStyle.top = '50%';
	        bgStyle.marginTop = -8;
	
	        if (position === 'left') {
	          fgStyle.right = -10;
	          fgStyle.borderLeft = fgColorBorder;
	          bgStyle.right = -11;
	          bgStyle.borderLeft = bgColorBorder;
	        } else {
	          fgStyle.left = -10;
	          fgStyle.borderRight = fgColorBorder;
	          bgStyle.left = -11;
	          bgStyle.borderRight = bgColorBorder;
	        }
	
	        if (arrow === 'top') {
	          fgStyle.top = this.margin;
	          bgStyle.top = this.margin;
	        }
	        if (arrow === 'bottom') {
	          fgStyle.top = null;
	          fgStyle.bottom = this.margin - 7;
	          bgStyle.top = null;
	          bgStyle.bottom = this.margin - 8;
	        }
	      } else {
	        fgStyle.left = '50%';
	        fgStyle.marginLeft = -10;
	        fgStyle.borderLeft = fgTransBorder;
	        fgStyle.borderRight = fgTransBorder;
	        bgStyle.left = '50%';
	        bgStyle.marginLeft = -11;
	        bgStyle.borderLeft = bgTransBorder;
	        bgStyle.borderRight = bgTransBorder;
	
	        if (position === 'top') {
	          fgStyle.bottom = -10;
	          fgStyle.borderTop = fgColorBorder;
	          bgStyle.bottom = -11;
	          bgStyle.borderTop = bgColorBorder;
	        } else {
	          fgStyle.top = -10;
	          fgStyle.borderBottom = fgColorBorder;
	          bgStyle.top = -11;
	          bgStyle.borderBottom = bgColorBorder;
	        }
	
	        if (arrow === 'right') {
	          fgStyle.left = null;
	          fgStyle.right = this.margin + 1 - fgSize;
	          fgStyle.marginLeft = 0;
	          bgStyle.left = null;
	          bgStyle.right = this.margin - fgSize;
	          bgStyle.marginLeft = 0;
	        }
	        if (arrow === 'left') {
	          fgStyle.left = this.margin + 1 - fgSize;
	          fgStyle.marginLeft = 0;
	          bgStyle.left = this.margin - fgSize;
	          bgStyle.marginLeft = 0;
	        }
	      }
	
	      var _props$style$arrowStyle = this.props.style.arrowStyle;
	      var color = _props$style$arrowStyle.color;
	      var borderColor = _props$style$arrowStyle.borderColor;
	
	      var propsArrowStyle = _objectWithoutProperties(_props$style$arrowStyle, ['color', 'borderColor']);
	
	      return {
	        fgStyle: this.mergeStyle(fgStyle, propsArrowStyle),
	        bgStyle: this.mergeStyle(bgStyle, propsArrowStyle)
	      };
	    }
	  }, {
	    key: 'mergeStyle',
	    value: function mergeStyle(style, theme) {
	      if (theme) {
	        var position = theme.position;
	        var _top2 = theme.top;
	        var left = theme.left;
	        var right = theme.right;
	        var bottom = theme.bottom;
	        var marginLeft = theme.marginLeft;
	        var marginRight = theme.marginRight;
	
	        var validTheme = _objectWithoutProperties(theme, ['position', 'top', 'left', 'right', 'bottom', 'marginLeft', 'marginRight']);
	
	        return (0, _objectAssign2['default'])(style, validTheme);
	      }
	
	      return style;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle(position, arrow) {
	      var _this = this;
	
	      var parent = this.props.parentEl;
	      var tooltipPosition = parent.getBoundingClientRect();
	      var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
	      var scrollX = window.scrollX !== undefined ? window.scrollX : window.pageXOffset;
	      var _top = scrollY + tooltipPosition.top;
	      var _left = scrollX + tooltipPosition.left;
	      var style = {};
	
	      var stylesFromPosition = {
	        left: function left() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height / 2;
	          style.left = _left - _this.state.width - _this.margin;
	        },
	        right: function right() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height / 2;
	          style.left = _left + parent.offsetWidth + _this.margin;
	        },
	        top: function top() {
	          style.left = _left - _this.state.width / 2 + parent.offsetWidth / 2;
	          style.top = _top - _this.state.height - _this.margin;
	        },
	        bottom: function bottom() {
	          style.left = _left - _this.state.width / 2 + parent.offsetWidth / 2;
	          style.top = _top + parent.offsetHeight + _this.margin;
	        }
	      };
	
	      var stylesFromArrow = {
	        left: function left() {
	          style.left = _left + parent.offsetWidth / 2 - _this.margin;
	        },
	        right: function right() {
	          style.left = _left - _this.state.width + parent.offsetWidth / 2 + _this.margin;
	        },
	        top: function top() {
	          style.top = _top + parent.offsetHeight / 2 - _this.margin;
	        },
	        bottom: function bottom() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height + _this.margin;
	        }
	      };
	
	      executeFunctionIfExist(stylesFromPosition, position);
	      executeFunctionIfExist(stylesFromArrow, arrow);
	
	      return style;
	    }
	  }, {
	    key: 'checkWindowPosition',
	    value: function checkWindowPosition(style, arrowStyle) {
	      if (this.props.position === 'top' || this.props.position === 'bottom') {
	        if (style.left < 0) {
	          var offset = style.left;
	          style.left = this.margin;
	          arrowStyle.fgStyle.marginLeft += offset;
	          arrowStyle.bgStyle.marginLeft += offset;
	        } else {
	          var rightOffset = style.left + this.state.width - window.innerWidth;
	          if (rightOffset > 0) {
	            var originalLeft = style.left;
	            style.left = window.innerWidth - this.state.width - this.margin;
	            arrowStyle.fgStyle.marginLeft += originalLeft - style.left;
	            arrowStyle.bgStyle.marginLeft += originalLeft - style.left;
	          }
	        }
	      }
	
	      return { style: style, arrowStyle: arrowStyle };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter() {
	      this.props.active && this.setState({ hover: true });
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave() {
	      this.setState({ hover: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateSize();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var _this2 = this;
	
	      this.setState({ transition: this.state.hover || this.props.active ? 'all' : 'opacity' }, function () {
	        _this2.updateSize();
	      });
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize() {
	      var self = _reactDom2['default'].findDOMNode(this);
	      this.setState({
	        width: self.offsetWidth,
	        height: self.offsetHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _checkWindowPosition = this.checkWindowPosition(this.getGlobalStyle(), this.getArrowStyle());
	
	      var style = _checkWindowPosition.style;
	      var arrowStyle = _checkWindowPosition.arrowStyle;
	
	      return _react2['default'].createElement(
	        'div',
	        { style: style, onMouseEnter: this.handleMouseEnter.bind(this), onMouseLeave: this.handleMouseLeave.bind(this) },
	        this.props.arrow ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('span', { style: arrowStyle.fgStyle }),
	          _react2['default'].createElement('span', { style: arrowStyle.bgStyle })
	        ) : null,
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      active: _propTypes2['default'].bool,
	      position: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	      arrow: _propTypes2['default'].oneOf([null, 'center', 'top', 'right', 'bottom', 'left']),
	      style: _propTypes2['default'].object
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      active: false,
	      position: 'right',
	      arrow: null,
	      style: { style: {}, arrowStyle: {} }
	    },
	    enumerable: true
	  }]);
	
	  return Card;
	})(_react2['default'].Component);
	
	var portalNodes = {};
	
	var ToolTip = (function (_React$Component2) {
	  _inherits(ToolTip, _React$Component2);
	
	  function ToolTip() {
	    _classCallCheck(this, ToolTip);
	
	    _get(Object.getPrototypeOf(ToolTip.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ToolTip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.active) {
	        return;
	      }
	
	      this.renderPortal(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (!portalNodes[this.props.group] && !nextProps.active || !this.props.active && !nextProps.active) {
	        return;
	      }
	
	      var props = (0, _objectAssign2['default'])({}, nextProps);
	      var newProps = (0, _objectAssign2['default'])({}, nextProps);
	
	      if (portalNodes[this.props.group] && portalNodes[this.props.group].timeout) {
	        clearTimeout(portalNodes[this.props.group].timeout);
	      }
	
	      if (this.props.active && !props.active) {
	        newProps.active = true;
	        portalNodes[this.props.group].timeout = setTimeout(function () {
	          props.active = false;
	          _this3.renderPortal(props);
	        }, this.props.tooltipTimeout);
	      }
	
	      this.renderPortal(newProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (portalNodes[this.props.group]) {
	        _reactDom2['default'].unmountComponentAtNode(portalNodes[this.props.group].node);
	        clearTimeout(portalNodes[this.props.group].timeout);
	      }
	    }
	  }, {
	    key: 'createPortal',
	    value: function createPortal() {
	      portalNodes[this.props.group] = {
	        node: document.createElement('div'),
	        timeout: false
	      };
	      portalNodes[this.props.group].node.className = 'ToolTipPortal';
	      document.body.appendChild(portalNodes[this.props.group].node);
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!portalNodes[this.props.group]) {
	        this.createPortal();
	      }
	      var parent = props.parent;
	
	      var other = _objectWithoutProperties(props, ['parent']);
	
	      var parentEl = document.querySelector(parent);
	      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, _react2['default'].createElement(Card, _extends({ parentEl: parentEl }, other)), portalNodes[this.props.group].node);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      parent: _propTypes2['default'].string.isRequired,
	      active: _propTypes2['default'].bool,
	      group: _propTypes2['default'].string,
	      tooltipTimeout: _propTypes2['default'].number
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      active: false,
	      group: 'main',
	      tooltipTimeout: 500
	    },
	    enumerable: true
	  }]);
	
	  return ToolTip;
	})(_react2['default'].Component);
	
	exports['default'] = ToolTip;
	
	var executeFunctionIfExist = function executeFunctionIfExist(object, key) {
	  if (Object.prototype.hasOwnProperty.call(object, key)) {
	    object[key]();
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	// This component is used in components/pages/overview/widgets/widget.jsx
	var LocationStats = function LocationStats(props) {
	    return _react2["default"].createElement(
	        "div",
	        { className: "widget-card__stats-block " },
	        _react2["default"].createElement(
	            "div",
	            { className: "stats-block__total-rooms" },
	            _react2["default"].createElement(
	                "div",
	                { className: "total-rooms__title" },
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    "Total Rooms"
	                )
	            ),
	            _react2["default"].createElement(
	                "div",
	                { className: "total-rooms__number font--proLight" },
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    props.stats.allRooms
	                )
	            ),
	            _react2["default"].createElement(
	                "div",
	                { className: "total-rooms__rooms-inuse" },
	                _react2["default"].createElement(
	                    "span",
	                    { id: "rooms-inuse" },
	                    props.stats.roomsInUse
	                ),
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    " in use   "
	                )
	            )
	        ),
	        _react2["default"].createElement(
	            "div",
	            { className: "stats-block__total-desks" },
	            _react2["default"].createElement(
	                "div",
	                { className: "total-desks__title" },
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    "Total Desks"
	                )
	            ),
	            _react2["default"].createElement(
	                "div",
	                { className: "total-desks__number font--proLight" },
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    props.stats.allSensors
	                )
	            ),
	            _react2["default"].createElement(
	                "div",
	                { className: "total-desks__desks-inuse" },
	                _react2["default"].createElement(
	                    "span",
	                    { id: "desks-inuse" },
	                    props.stats.desksInUse
	                ),
	                _react2["default"].createElement(
	                    "span",
	                    null,
	                    " in use   "
	                )
	            )
	        )
	    );
	};
	exports["default"] = LocationStats;
	module.exports = exports["default"];

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsSensorsettings = __webpack_require__(360);
	
	var _actionsStats = __webpack_require__(207);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownWidgetexport = __webpack_require__(1248);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownWidgetexport2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDataexportdropdownWidgetexport);
	
	// This component is used in components/pages/overview/widgets/widget.jsx
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsCommonWidgetsLocationbottommenuEditwidgetmodalcontent = __webpack_require__(1253);
	
	var _componentsCommonWidgetsLocationbottommenuEditwidgetmodalcontent2 = _interopRequireDefault(_componentsCommonWidgetsLocationbottommenuEditwidgetmodalcontent);
	
	var LocationBottomMenu = (function (_React$Component) {
	    _inherits(LocationBottomMenu, _React$Component);
	
	    function LocationBottomMenu(props, context) {
	        _classCallCheck(this, LocationBottomMenu);
	
	        _get(Object.getPrototypeOf(LocationBottomMenu.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            isShowingSetting: false
	        };
	    }
	
	    _createClass(LocationBottomMenu, [{
	        key: 'openSettingDropdown',
	        value: function openSettingDropdown() {
	            this.setState({ isShowingSetting: true });
	        }
	    }, {
	        key: 'closeSettingDropdown',
	        value: function closeSettingDropdown() {
	            this.setState({ isShowingSetting: false });
	        }
	    }, {
	        key: 'deleteWidget',
	        value: function deleteWidget(node) {
	            this.props.deleteWidget(node.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'row widget-card__bottom-menu' },
	                this.props.isComparisonWidget ? _react2['default'].createElement('div', { className: 'col-xs-2' }) : _react2['default'].createElement(
	                    'div',
	                    { className: 'col-xs-4' },
	                    _react2['default'].createElement(
	                        'div',
	                        { 'data-tooltip': "Widget settings", onClick: this.openSettingDropdown.bind(this), className: 'cursor--pointer widget-setting' },
	                        _react2['default'].createElement('span', { className: 'font-icon icon-widgetsetting' })
	                    ),
	                    this.state.isShowingSetting && _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement('div', { style: { backgroundColor: 'transparent' }, className: "modals__overlay" + (this.state.isShowingSetting ? "" : " closed"), onClick: this.closeSettingDropdown.bind(this) }),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: "edit-widget-dropdown " + (this.state.isShowingSetting ? "" : " closed") },
	                            _react2['default'].createElement(
	                                'ul',
	                                null,
	                                _react2['default'].createElement(
	                                    'li',
	                                    { onClick: function () {
	                                            _this.closeSettingDropdown();
	                                            _this.delWidgetModal.open();
	                                        }, className: 'edit-widget-dropdown--item cursor--pointer' },
	                                    'Delete'
	                                ),
	                                _react2['default'].createElement(
	                                    'li',
	                                    { onClick: function () {
	                                            _this.closeSettingDropdown();
	                                            _this.editWidgetModal.open();
	                                        }, className: 'edit-widget-dropdown--item cursor--pointer' },
	                                    'Edit'
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonModal2['default'],
	                        {
	                            ref: function (elem) {
	                                _this.delWidgetModal = elem;
	                            },
	                            clickButton: function () {
	                                _this.deleteWidget(_this.props.node);_this.delWidgetModal.close();
	                            },
	                            header: 'Delete Widget',
	                            buttonText: 'Delete',
	                            buttonClass: 'btn-danger'
	                        },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Are you sure you want to delete ',
	                            this.props.node.info.name,
	                            ' ?'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonModal2['default'],
	                        {
	                            ref: function (elem) {
	                                _this.editWidgetModal = elem;
	                            },
	                            clickButton: function () {
	                                _this.editWidgetModalContent.submit() && _this.editWidgetModal.close();
	                            },
	                            header: 'Edit Widget',
	                            buttonText: 'Confirm',
	                            buttonClass: 'btn-success'
	                        },
	                        _react2['default'].createElement(_componentsCommonWidgetsLocationbottommenuEditwidgetmodalcontent2['default'], {
	                            onRef: function (ref) {
	                                return _this.editWidgetModalContent = ref;
	                            },
	                            tree: this.props.tree,
	                            widgetLocations: this.props.user.details.location,
	                            nodeId: this.props.node.id,
	                            editWidget: this.props.editWidget
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'col-xs-4' },
	                    _react2['default'].createElement(_componentsCommonDropdowncomponentsDataexportdropdownWidgetexport2['default'], { node: this.props.node, widget: this.props.widget, downloadCSV: function () {
	                            return (0, _actionsStats.downloadCSV)(_this.props.node, _this.props.querySettings);
	                        } })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'col-xs-4' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        {
	                            'data-tooltip': "Maintenance settings",
	                            to: this.props.node.info.hasfloorplan && this.props.faulty ? '/live/' + this.props.node.id : "/settings/sensor",
	                            className: 'widget-setting',
	                            onClick: function () {
	                                if (_this.props.node.info.hasfloorplan && _this.props.faulty) {
	                                    // live view
	                                    _this.props.redirectMaintenanceView(_this.props.node);
	                                } else {
	                                    // sensor settings
	                                    _this.props.dispatch((0, _actionsSensorsettings.selectNodeFilter)(_this.props.node));
	                                    // Filter : No fault sensor => all sensors, else offline sensor
	                                    var statusFilter = _config2['default'].sensorStatusFilter[_this.props.faulty == 0 ? 0 : 2];
	                                    _this.props.dispatch((0, _actionsSensorsettings.selectSensorStatusFilter)(statusFilter));
	                                }
	                            }
	                        },
	                        this.props.faulty > 0 && _react2['default'].createElement(
	                            'div',
	                            { className: "widget-setting__faulty-number " + (this.props.node.info.hasfloorplan ? "background--red" : "background--brown") },
	                            this.props.faulty
	                        ),
	                        _react2['default'].createElement('span', { className: 'font-icon icon-maintenance' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LocationBottomMenu;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        querySettings: state.querySettingsReducer,
	        token: state.authReducer.token,
	        cards: state.defaultSettingsReducer.card,
	        user: state.myAccountReducer.user
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocationBottomMenu);
	module.exports = exports['default'];

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _actionsStats = __webpack_require__(207);
	
	var _functions = __webpack_require__(1249);
	
	var NewWidgetExport = (function (_React$Component) {
	    _inherits(NewWidgetExport, _React$Component);
	
	    function NewWidgetExport(props, context) {
	        _classCallCheck(this, NewWidgetExport);
	
	        _get(Object.getPrototypeOf(NewWidgetExport.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loading: false
	        };
	    }
	
	    _createClass(NewWidgetExport, [{
	        key: 'downloadCSV',
	        value: function downloadCSV() {
	            var _this = this;
	
	            this.setState({ loading: true }, function () {
	                (0, _actionsStats.downloadCSV)(_this.props.node, _this.props.querySettings, function () {
	                    _this.setState({ loading: false });
	                });
	            });
	        }
	    }, {
	        key: 'downloadPDF',
	        value: function downloadPDF() {
	            var _this2 = this;
	
	            this.setState({ loading: true }, function () {
	                var images = [];
	                (0, _functions.chainGetPNG)([_this2.props.widget], images, function () {
	                    _this2.setState({ loading: false });
	                    (0, _functions.dumpAllToPDF)(images, _this2.getPDFName());
	                });
	            });
	        }
	    }, {
	        key: 'getPDFName',
	        value: function getPDFName() {
	            var settings = (0, _actionsStats.getParams)({
	                querySettings: this.props.querySettings,
	                currentNode: this.props.node
	            });
	            var locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
	            return 'WIDGET_' + locationName + '_' + settings.startdate + '_' + settings.enddate + '_' + settings.starthour + ':00_' + settings.endhour + ':59.pdf';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdown2['default'],
	                    { className: this.props.className, header: _react2['default'].createElement(
	                            'div',
	                            { style: { display: "block" }, 'data-tooltip': "Export data" },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: "text-center widget-export display--flex__flex--center " + (this.state.loading ? "loading" : "") },
	                                this.state.loading ? _react2['default'].createElement('img', { src: 'src/assets/icons/loading.gif' }) : _react2['default'].createElement('span', { className: 'font-icon icon-export' })
	                            )
	                        ), toggleable: !this.state.loading, noArrow: true },
	                    _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return _this3.downloadCSV();
	                                } },
	                            'CSV : Data of sensors'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return _this3.downloadPDF();
	                                } },
	                            'PDF : Picture of widget'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewWidgetExport;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        tree: state.overviewReducer.customerOverview,
	        nodeMap: state.overviewReducer.nodeMap,
	        querySettings: state.querySettingsReducer,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewWidgetExport);
	module.exports = exports['default'];

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPNG = getPNG;
	exports.chainGetPNG = chainGetPNG;
	exports.dumpAllToPDF = dumpAllToPDF;
	exports.getPngDimensions = getPngDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentsCustomLibDomToImage = __webpack_require__(1250);
	
	var _componentsCustomLibDomToImage2 = _interopRequireDefault(_componentsCustomLibDomToImage);
	
	var _componentsCustomLibJspdf = __webpack_require__(1251);
	
	var _componentsCustomLibJspdf2 = _interopRequireDefault(_componentsCustomLibJspdf);
	
	function getPNG(DOMnode, resultHolder, callbacks) {
	    if (!DOMnode) {
	        callbacks();
	    } else {
	        return _componentsCustomLibDomToImage2["default"].toPng(_reactDom2["default"].findDOMNode(DOMnode)).then(function (imgdata) {
	            resultHolder.push(imgdata);
	            callbacks();
	        });
	    }
	}
	
	function chainGetPNG(targets, images, callbacks) {
	    var chain = callbacks;
	
	    var _loop = function () {
	        var t = targets[i];
	        var c = chain;
	        chain = function () {
	            return getPNG(t, images, c);
	        };
	    };
	
	    for (var i = targets.length - 1; i >= 0; i--) {
	        _loop();
	    }
	    chain();
	}
	
	function dumpAllToPDF(images, name) {
	    var doc = new _componentsCustomLibJspdf2["default"]();
	    doc.deletePage(1);
	
	    for (var i in images) {
	        var imgContent = images[i].split(",")[1];
	        var imgSize = getPngDimensions(imgContent);
	        //  let magic = 0; // this should be 0. But there're some bug that jsPDF add extra padding to the right of the page. I have no idea why...
	        /*No need magic anymore I fixed it now, and it's not a bug from jsPDF, it's bug from styling the widget. */
	        doc.addPage(imgSize.width, /*- magic*/imgSize.height);
	        doc.addImage(images[i], 0, 0, imgSize.width, imgSize.height);
	    }
	    // save all images in one pdf only
	    doc.save(name);
	}
	
	function getPngDimensions(base64) {
	    // https://stackoverflow.com/questions/15327959/get-height-and-width-dimensions-from-base64-png/15327984
	    var header = atob(base64.slice(0, 50)).slice(16, 24);
	    var uint8 = Uint8Array.from(header, function (c) {
	        return c.charCodeAt(0);
	    });
	    var dataView = new DataView(uint8.buffer);
	
	    return {
	        width: dataView.getInt32(0),
	        height: dataView.getInt32(4)
	    };
	}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	// The MIT License (MIT)
	
	// Copyright 2015 Anatolii Saienko
	// https://github.com/tsayen
	
	// Copyright 2012 Paul Bakaus
	// http://paulbakaus.com/
	
	// Permission is hereby granted, free of charge, to any person obtaining
	// a copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to
	// permit persons to whom the Software is furnished to do so, subject to
	// the following conditions:
	
	// The above copyright notice and this permission notice shall be
	// included in all copies or substantial portions of the Software.
	
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	(function (global) {
	    'use strict';
	
	    var util = newUtil();
	    var inliner = newInliner();
	    var fontFaces = newFontFaces();
	    var images = newImages();
	
	    // Default impl options
	    var defaultOptions = {
	        // Default is to fail on error, no placeholder
	        imagePlaceholder: undefined,
	        // Default cache bust is false, it will use the cache
	        cacheBust: false
	    };
	
	    var domtoimage = {
	        toSvg: toSvg,
	        toPng: toPng,
	        toJpeg: toJpeg,
	        toBlob: toBlob,
	        toPixelData: toPixelData,
	        impl: {
	            fontFaces: fontFaces,
	            images: images,
	            util: util,
	            inliner: inliner,
	            options: {}
	        }
	    };
	
	    if (true) module.exports = domtoimage;else global.domtoimage = domtoimage;
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options
	     * @param {Function} options.filter - Should return true if passed node should be included in the output
	     *          (excluding node means excluding it's children as well). Not called on the root node.
	     * @param {String} options.bgcolor - color for the background, any valid CSS color value.
	     * @param {Number} options.width - width to be applied to node before rendering.
	     * @param {Number} options.height - height to be applied to node before rendering.
	     * @param {Object} options.style - an object whose properties to be copied to node's style before rendering.
	     * @param {Number} options.quality - a Number between 0 and 1 indicating image quality (applicable to JPEG only),
	                defaults to 1.0.
	     * @param {String} options.imagePlaceholder - dataURL to use as a placeholder for failed images, default behaviour is to fail fast on images we can't fetch
	     * @param {Boolean} options.cacheBust - set to true to cache bust by appending the time to the request url
	     * @return {Promise} - A promise that is fulfilled with a SVG image data URL
	     * */
	    function toSvg(node, options) {
	        options = options || {};
	        copyOptions(options);
	        return Promise.resolve(node).then(function (node) {
	            return cloneNode(node, options.filter, true);
	        })
	        // .then(embedFonts)
	        .then(inlineImages).then(applyOptions).then(function (clone) {
	            return makeSvgDataUri(clone, options.width || util.width(node), options.height || util.height(node));
	        });
	
	        function applyOptions(clone) {
	            if (options.bgcolor) clone.style.backgroundColor = options.bgcolor;
	
	            if (options.width) clone.style.width = options.width + 'px';
	            if (options.height) clone.style.height = options.height + 'px';
	
	            if (options.style) Object.keys(options.style).forEach(function (property) {
	                clone.style[property] = options.style[property];
	            });
	
	            return clone;
	        }
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a Uint8Array containing RGBA pixel data.
	     * */
	    function toPixelData(node, options) {
	        return draw(node, options || {}).then(function (canvas) {
	            return canvas.getContext('2d').getImageData(0, 0, util.width(node), util.height(node)).data;
	        });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image data URL
	     * */
	    function toPng(node, options) {
	        return draw(node, options || {}).then(function (canvas) {
	            return canvas.toDataURL();
	        });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a JPEG image data URL
	     * */
	    function toJpeg(node, options) {
	        options = options || {};
	        return draw(node, options).then(function (canvas) {
	            return canvas.toDataURL('image/jpeg', options.quality || 1.0);
	        });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image blob
	     * */
	    function toBlob(node, options) {
	        return draw(node, options || {}).then(util.canvasToBlob);
	    }
	
	    function copyOptions(options) {
	        // Copy options to impl options for use in impl
	        if (typeof options.imagePlaceholder === 'undefined') {
	            domtoimage.impl.options.imagePlaceholder = defaultOptions.imagePlaceholder;
	        } else {
	            domtoimage.impl.options.imagePlaceholder = options.imagePlaceholder;
	        }
	
	        if (typeof options.cacheBust === 'undefined') {
	            domtoimage.impl.options.cacheBust = defaultOptions.cacheBust;
	        } else {
	            domtoimage.impl.options.cacheBust = options.cacheBust;
	        }
	    }
	
	    function draw(domNode, options) {
	        return toSvg(domNode, options).then(util.makeImage).then(util.delay(100)).then(function (image) {
	            var canvas = newCanvas(domNode);
	            canvas.getContext('2d').drawImage(image, 0, 0);
	            return canvas;
	        });
	
	        function newCanvas(domNode) {
	            var canvas = document.createElement('canvas');
	            canvas.width = options.width || util.width(domNode);
	            canvas.height = options.height || util.height(domNode);
	
	            if (options.bgcolor) {
	                var ctx = canvas.getContext('2d');
	                ctx.fillStyle = options.bgcolor;
	                ctx.fillRect(0, 0, canvas.width, canvas.height);
	            }
	
	            return canvas;
	        }
	    }
	
	    function cloneNode(node, filter, root) {
	        if (!root && filter && !filter(node)) return Promise.resolve();
	
	        return Promise.resolve(node).then(makeNodeCopy).then(function (clone) {
	            return cloneChildren(node, clone, filter);
	        }).then(function (clone) {
	            return processClone(node, clone);
	        });
	
	        function makeNodeCopy(node) {
	            if (node instanceof HTMLCanvasElement) return util.makeImage(node.toDataURL());
	            return node.cloneNode(false);
	        }
	
	        function cloneChildren(original, clone, filter) {
	            var children = original.childNodes;
	            if (children.length === 0) return Promise.resolve(clone);
	
	            return cloneChildrenInOrder(clone, util.asArray(children), filter).then(function () {
	                return clone;
	            });
	
	            function cloneChildrenInOrder(parent, children, filter) {
	                var done = Promise.resolve();
	                children.forEach(function (child) {
	                    done = done.then(function () {
	                        return cloneNode(child, filter);
	                    }).then(function (childClone) {
	                        if (childClone) parent.appendChild(childClone);
	                    });
	                });
	                return done;
	            }
	        }
	
	        function processClone(original, clone) {
	            if (!(clone instanceof Element)) return clone;
	
	            return Promise.resolve().then(cloneStyle).then(clonePseudoElements).then(copyUserInput).then(fixSvg).then(function () {
	                return clone;
	            });
	
	            function cloneStyle() {
	                copyStyle(window.getComputedStyle(original), clone.style);
	
	                function copyStyle(source, target) {
	                    if (source.cssText) target.cssText = source.cssText;else copyProperties(source, target);
	
	                    function copyProperties(source, target) {
	                        util.asArray(source).forEach(function (name) {
	                            target.setProperty(name, source.getPropertyValue(name), source.getPropertyPriority(name));
	                        });
	                    }
	                }
	            }
	
	            function clonePseudoElements() {
	                [':before', ':after'].forEach(function (element) {
	                    clonePseudoElement(element);
	                });
	
	                function clonePseudoElement(element) {
	                    var style = window.getComputedStyle(original, element);
	                    var content = style.getPropertyValue('content');
	
	                    if (content === '' || content === 'none') return;
	
	                    var className = util.uid();
	                    clone.className = clone.className + ' ' + className;
	                    var styleElement = document.createElement('style');
	                    styleElement.appendChild(formatPseudoElementStyle(className, element, style));
	                    clone.appendChild(styleElement);
	
	                    function formatPseudoElementStyle(className, element, style) {
	                        var selector = '.' + className + ':' + element;
	                        var cssText = style.cssText ? formatCssText(style) : formatCssProperties(style);
	                        return document.createTextNode(selector + '{' + cssText + '}');
	
	                        function formatCssText(style) {
	                            var content = style.getPropertyValue('content');
	                            return style.cssText + ' content: ' + content + ';';
	                        }
	
	                        function formatCssProperties(style) {
	
	                            return util.asArray(style).map(formatProperty).join('; ') + ';';
	
	                            function formatProperty(name) {
	                                return name + ': ' + style.getPropertyValue(name) + (style.getPropertyPriority(name) ? ' !important' : '');
	                            }
	                        }
	                    }
	                }
	            }
	
	            function copyUserInput() {
	                if (original instanceof HTMLTextAreaElement) clone.innerHTML = original.value;
	                if (original instanceof HTMLInputElement) clone.setAttribute("value", original.value);
	            }
	
	            function fixSvg() {
	                if (!(clone instanceof SVGElement)) return;
	                clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	
	                if (!(clone instanceof SVGRectElement)) return;
	                ['width', 'height'].forEach(function (attribute) {
	                    var value = clone.getAttribute(attribute);
	                    if (!value) return;
	
	                    clone.style.setProperty(attribute, value);
	                });
	            }
	        }
	    }
	
	    // eslint-disable-next-line no-unused-vars
	    function embedFonts(node) {
	        return fontFaces.resolveAll().then(function (cssText) {
	            var styleNode = document.createElement('style');
	            node.appendChild(styleNode);
	            styleNode.appendChild(document.createTextNode(cssText));
	            return node;
	        });
	    }
	
	    function inlineImages(node) {
	        return images.inlineAll(node).then(function () {
	            return node;
	        });
	    }
	
	    function makeSvgDataUri(node, width, height) {
	        return Promise.resolve(node).then(function (node) {
	            node.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
	            return new XMLSerializer().serializeToString(node);
	        }).then(util.escapeXhtml).then(function (xhtml) {
	            return '<foreignObject x="0" y="0" width="100%" height="100%">' + xhtml + '</foreignObject>';
	        }).then(function (foreignObject) {
	            return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' + foreignObject + '</svg>';
	        }).then(function (svg) {
	            return 'data:image/svg+xml;charset=utf-8,' + svg;
	        });
	    }
	
	    function newUtil() {
	        return {
	            escape: escape,
	            parseExtension: parseExtension,
	            mimeType: mimeType,
	            dataAsUrl: dataAsUrl,
	            isDataUrl: isDataUrl,
	            canvasToBlob: canvasToBlob,
	            resolveUrl: resolveUrl,
	            getAndEncode: getAndEncode,
	            uid: uid(),
	            delay: delay,
	            asArray: asArray,
	            escapeXhtml: escapeXhtml,
	            makeImage: makeImage,
	            width: width,
	            height: height
	        };
	
	        function mimes() {
	            /*
	             * Only WOFF and EOT mime types for fonts are 'real'
	             * see http://www.iana.org/assignments/media-types/media-types.xhtml
	             */
	            var WOFF = 'application/font-woff';
	            var JPEG = 'image/jpeg';
	
	            return {
	                'woff': WOFF,
	                'woff2': WOFF,
	                'ttf': 'application/font-truetype',
	                'eot': 'application/vnd.ms-fontobject',
	                'png': 'image/png',
	                'jpg': JPEG,
	                'jpeg': JPEG,
	                'gif': 'image/gif',
	                'tiff': 'image/tiff',
	                'svg': 'image/svg+xml'
	            };
	        }
	
	        function parseExtension(url) {
	            // eslint-disable-next-line no-useless-escape
	            var match = /\.([^\.\/]*?)$/g.exec(url);
	            if (match) return match[1];else return '';
	        }
	
	        function mimeType(url) {
	            var extension = parseExtension(url).toLowerCase();
	            return mimes()[extension] || '';
	        }
	
	        function isDataUrl(url) {
	            return url.search(/^(data:)/) !== -1;
	        }
	
	        function toBlob(canvas) {
	            return new Promise(function (resolve) {
	                var binaryString = window.atob(canvas.toDataURL().split(',')[1]);
	                var length = binaryString.length;
	                var binaryArray = new Uint8Array(length);
	
	                for (var i = 0; i < length; i++) binaryArray[i] = binaryString.charCodeAt(i);
	
	                resolve(new Blob([binaryArray], {
	                    type: 'image/png'
	                }));
	            });
	        }
	
	        function canvasToBlob(canvas) {
	            if (canvas.toBlob) return new Promise(function (resolve) {
	                canvas.toBlob(resolve);
	            });
	
	            return toBlob(canvas);
	        }
	
	        function resolveUrl(url, baseUrl) {
	            var doc = document.implementation.createHTMLDocument();
	            var base = doc.createElement('base');
	            doc.head.appendChild(base);
	            var a = doc.createElement('a');
	            doc.body.appendChild(a);
	            base.href = baseUrl;
	            a.href = url;
	            return a.href;
	        }
	
	        function uid() {
	            var index = 0;
	
	            return function () {
	                return 'u' + fourRandomChars() + index++;
	
	                function fourRandomChars() {
	                    /* see http://stackoverflow.com/a/6248722/2519373 */
	                    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	                }
	            };
	        }
	
	        function makeImage(uri) {
	            return new Promise(function (resolve, reject) {
	                var image = new Image();
	                image.onload = function () {
	                    resolve(image);
	                };
	                image.onerror = reject;
	                image.src = uri;
	            });
	        }
	
	        function getAndEncode(url) {
	            var TIMEOUT = 30000;
	            if (domtoimage.impl.options.cacheBust) {
	                // Cache bypass so we dont have CORS issues with cached images
	                // Source: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
	                url += (/\?/.test(url) ? "&" : "?") + new Date().getTime();
	            }
	
	            return new Promise(function (resolve) {
	                var request = new XMLHttpRequest();
	
	                request.onreadystatechange = done;
	                request.ontimeout = timeout;
	                request.responseType = 'blob';
	                request.timeout = TIMEOUT;
	                request.open('GET', url, true);
	                request.send();
	
	                var placeholder;
	                if (domtoimage.impl.options.imagePlaceholder) {
	                    var split = domtoimage.impl.options.imagePlaceholder.split(/,/);
	                    if (split && split[1]) {
	                        placeholder = split[1];
	                    }
	                }
	
	                function done() {
	                    if (request.readyState !== 4) return;
	
	                    if (request.status !== 200) {
	                        if (placeholder) {
	                            resolve(placeholder);
	                        } else {
	                            fail('cannot fetch resource: ' + url + ', status: ' + request.status);
	                        }
	
	                        return;
	                    }
	
	                    var encoder = new FileReader();
	                    encoder.onloadend = function () {
	                        var content = encoder.result.split(/,/)[1];
	                        resolve(content);
	                    };
	                    encoder.readAsDataURL(request.response);
	                }
	
	                function timeout() {
	                    if (placeholder) {
	                        resolve(placeholder);
	                    } else {
	                        fail('timeout of ' + TIMEOUT + 'ms occured while fetching resource: ' + url);
	                    }
	                }
	
	                function fail(message) {
	                    console.error(message);
	                    resolve('');
	                }
	            });
	        }
	
	        function dataAsUrl(content, type) {
	            return 'data:' + type + ';base64,' + content;
	        }
	
	        function escape(string) {
	            // eslint-disable-next-line no-useless-escape
	            return string.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
	        }
	
	        function delay(ms) {
	            return function (arg) {
	                return new Promise(function (resolve) {
	                    setTimeout(function () {
	                        resolve(arg);
	                    }, ms);
	                });
	            };
	        }
	
	        function asArray(arrayLike) {
	            var array = [];
	            var length = arrayLike.length;
	            for (var i = 0; i < length; i++) array.push(arrayLike[i]);
	            return array;
	        }
	
	        function escapeXhtml(string) {
	            return string.replace(/#/g, '%23').replace(/\n/g, '%0A');
	        }
	
	        function width(node) {
	            var leftBorder = px(node, 'border-left-width');
	            var rightBorder = px(node, 'border-right-width');
	            return node.scrollWidth + leftBorder + rightBorder;
	        }
	
	        function height(node) {
	            var topBorder = px(node, 'border-top-width');
	            var bottomBorder = px(node, 'border-bottom-width');
	            return node.scrollHeight + topBorder + bottomBorder;
	        }
	
	        function px(node, styleProperty) {
	            var value = window.getComputedStyle(node).getPropertyValue(styleProperty);
	            return parseFloat(value.replace('px', ''));
	        }
	    }
	
	    function newInliner() {
	        var URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
	
	        return {
	            inlineAll: inlineAll,
	            shouldProcess: shouldProcess,
	            impl: {
	                readUrls: readUrls,
	                inline: inline
	            }
	        };
	
	        function shouldProcess(string) {
	            return string.search(URL_REGEX) !== -1;
	        }
	
	        function readUrls(string) {
	            var result = [];
	            var match;
	            while ((match = URL_REGEX.exec(string)) !== null) {
	                result.push(match[1]);
	            }
	            return result.filter(function (url) {
	                return !util.isDataUrl(url);
	            });
	        }
	
	        function inline(string, url, baseUrl, get) {
	            return Promise.resolve(url).then(function (url) {
	                return baseUrl ? util.resolveUrl(url, baseUrl) : url;
	            }).then(get || util.getAndEncode).then(function (data) {
	                return util.dataAsUrl(data, util.mimeType(url));
	            }).then(function (dataUrl) {
	                return string.replace(urlAsRegex(url), '$1' + dataUrl + '$3');
	            });
	
	            function urlAsRegex(url) {
	                return new RegExp('(url\\([\'"]?)(' + util.escape(url) + ')([\'"]?\\))', 'g');
	            }
	        }
	
	        function inlineAll(string, baseUrl, get) {
	            if (nothingToInline()) return Promise.resolve(string);
	
	            return Promise.resolve(string).then(readUrls).then(function (urls) {
	                var done = Promise.resolve(string);
	                urls.forEach(function (url) {
	                    done = done.then(function (string) {
	                        return inline(string, url, baseUrl, get);
	                    });
	                });
	                return done;
	            });
	
	            function nothingToInline() {
	                return !shouldProcess(string);
	            }
	        }
	    }
	
	    function newFontFaces() {
	        return {
	            resolveAll: resolveAll,
	            impl: {
	                readAll: readAll
	            }
	        };
	
	        function resolveAll() {
	            return readAll(document).then(function (webFonts) {
	                return Promise.all(webFonts.map(function (webFont) {
	                    return webFont.resolve();
	                }));
	            }).then(function (cssStrings) {
	                return cssStrings.join('\n');
	            });
	        }
	
	        function readAll() {
	            return Promise.resolve(util.asArray(document.styleSheets)).then(getCssRules).then(selectWebFontRules).then(function (rules) {
	                return rules.map(newWebFont);
	            });
	
	            function selectWebFontRules(cssRules) {
	                return cssRules.filter(function (rule) {
	                    return rule.type === CSSRule.FONT_FACE_RULE;
	                }).filter(function (rule) {
	                    return inliner.shouldProcess(rule.style.getPropertyValue('src'));
	                });
	            }
	
	            function getCssRules(styleSheets) {
	                var cssRules = [];
	                styleSheets.forEach(function (sheet) {
	                    try {
	                        util.asArray(sheet.cssRules || []).forEach(cssRules.push.bind(cssRules));
	                    } catch (e) {
	                        console.log('Error while reading CSS rules from ' + sheet.href, e.toString());
	                    }
	                });
	                return cssRules;
	            }
	
	            function newWebFont(webFontRule) {
	                return {
	                    resolve: function resolve() {
	                        var baseUrl = (webFontRule.parentStyleSheet || {}).href;
	                        return inliner.inlineAll(webFontRule.cssText, baseUrl);
	                    },
	                    src: function src() {
	                        return webFontRule.style.getPropertyValue('src');
	                    }
	                };
	            }
	        }
	    }
	
	    function newImages() {
	        return {
	            inlineAll: inlineAll,
	            impl: {
	                newImage: newImage
	            }
	        };
	
	        function newImage(element) {
	            return {
	                inline: inline
	            };
	
	            function inline(get) {
	                if (util.isDataUrl(element.src)) return Promise.resolve();
	
	                return Promise.resolve(element.src).then(get || util.getAndEncode).then(function (data) {
	                    return util.dataAsUrl(data, util.mimeType(element.src));
	                }).then(function (dataUrl) {
	                    return new Promise(function (resolve, reject) {
	                        element.onload = resolve;
	                        element.onerror = reject;
	                        element.src = dataUrl;
	                    });
	                });
	            }
	        }
	
	        function inlineAll(node) {
	            if (!(node instanceof Element)) return Promise.resolve(node);
	
	            return inlineBackground(node).then(function () {
	                if (node instanceof HTMLImageElement) return newImage(node).inline();else return Promise.all(util.asArray(node.childNodes).map(function (child) {
	                    return inlineAll(child);
	                }));
	            });
	
	            function inlineBackground(node) {
	                var background = node.style.getPropertyValue('background');
	
	                if (!background) return Promise.resolve(node);
	
	                return inliner.inlineAll(background).then(function (inlined) {
	                    node.style.setProperty('background', inlined, node.style.getPropertyPriority('background'));
	                }).then(function () {
	                    return node;
	                });
	            }
	        }
	    }
	})(undefined);
	/*
	    Modification : line 92 commented out.
	*/

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {// Copyright (c) 2010-2017 James Hall, https://github.com/MrRio/jsPDF
	// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
	'use strict';(function(global,factory){ true?module.exports = factory():typeof define === 'function' && define.amd?define(factory):global.jspdf = factory();})(undefined,function(){'use strict';var _typeof=typeof Symbol === "function" && typeof Symbol.iterator === "symbol"?function(obj){return typeof obj;}:function(obj){return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype?"symbol":typeof obj;};var asyncGenerator=(function(){function AwaitValue(value){this.value = value;}function AsyncGenerator(gen){var front,back;function send(key,arg){return new Promise(function(resolve,reject){var request={key:key,arg:arg,resolve:resolve,reject:reject,next:null};if(back){back = back.next = request;}else {front = back = request;resume(key,arg);}});}function resume(key,arg){try{var result=gen[key](arg);var value=result.value;if(value instanceof AwaitValue){Promise.resolve(value.value).then(function(arg){resume("next",arg);},function(arg){resume("throw",arg);});}else {settle(result.done?"return":"normal",result.value);}}catch(err) {settle("throw",err);}}function settle(type,value){switch(type){case "return":front.resolve({value:value,done:true});break;case "throw":front.reject(value);break;default:front.resolve({value:value,done:false});break;}front = front.next;if(front){resume(front.key,front.arg);}else {back = null;}}this._invoke = send;if(typeof gen['return'] !== "function"){this['return'] = undefined;}}if(typeof Symbol === "function" && Symbol.asyncIterator){AsyncGenerator.prototype[Symbol.asyncIterator] = function(){return this;};}AsyncGenerator.prototype.next = function(arg){return this._invoke("next",arg);};AsyncGenerator.prototype['throw'] = function(arg){return this._invoke("throw",arg);};AsyncGenerator.prototype['return'] = function(arg){return this._invoke("return",arg);};return {wrap:function wrap(fn){return function(){return new AsyncGenerator(fn.apply(this,arguments));};},await:function await(value){return new AwaitValue(value);}};})(); /** @preserve
	 * jsPDF - PDF Document creation from JavaScript
	 * Version 1.3.5 Built on 2017-09-14T15:10:09.569Z
	 *                           CommitID 05dc915baf
	 *
	 * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
	 *               2010 Aaron Spike, https://github.com/acspike
	 *               2012 Willow Systems Corporation, willow-systems.com
	 *               2012 Pablo Hess, https://github.com/pablohess
	 *               2012 Florian Jenett, https://github.com/fjenett
	 *               2013 Warren Weckesser, https://github.com/warrenweckesser
	 *               2013 Youssef Beddad, https://github.com/lifof
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2013 Stefan Slonevskiy, https://github.com/stefslon
	 *               2013 Jeremy Morel, https://github.com/jmorel
	 *               2013 Christoph Hartmann, https://github.com/chris-rock
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Makes, https://github.com/dollaruw
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Steven Spungin, https://github.com/Flamenco
	 *               2014 Kenneth Glassey, https://github.com/Gavvers
	 *
	 * Licensed under the MIT License
	 *
	 * Contributor(s):
	 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	 *    kim3er, mfo, alnorth, Flamenco
	 */ /**
	 * Creates new jsPDF document object instance.
	 * @name jsPDF
	 * @class
	 * @param orientation One of "portrait" or "landscape" (or shortcuts "p" (Default), "l") <br />
	 * Can also be an options object.
	 * @param unit        Measurement unit to be used when coordinates are specified.
	 *                    One of "pt" (points), "mm" (Default), "cm", "in"
	 * @param format      One of 'pageFormats' as shown below, default: a4
	 * @returns {jsPDF}
	 * @description
	 * If the first parameter (orientation) is an object, it will be interpreted as an object of named parameters
	 * ```
	 * {
	 *  orientation: 'p',
	 *  unit: 'mm',
	 *  format: 'a4',
	 *  hotfixes: [] // an array of hotfix strings to enable
	 * }
	 * ```
	 */var jsPDF=(function(global){'use strict';var pdfVersion='1.3',pageFormats={ // Size in pt of various paper formats
	'a0':[2383.94,3370.39],'a1':[1683.78,2383.94],'a2':[1190.55,1683.78],'a3':[841.89,1190.55],'a4':[595.28,841.89],'a5':[419.53,595.28],'a6':[297.64,419.53],'a7':[209.76,297.64],'a8':[147.40,209.76],'a9':[104.88,147.40],'a10':[73.70,104.88],'b0':[2834.65,4008.19],'b1':[2004.09,2834.65],'b2':[1417.32,2004.09],'b3':[1000.63,1417.32],'b4':[708.66,1000.63],'b5':[498.90,708.66],'b6':[354.33,498.90],'b7':[249.45,354.33],'b8':[175.75,249.45],'b9':[124.72,175.75],'b10':[87.87,124.72],'c0':[2599.37,3676.54],'c1':[1836.85,2599.37],'c2':[1298.27,1836.85],'c3':[918.43,1298.27],'c4':[649.13,918.43],'c5':[459.21,649.13],'c6':[323.15,459.21],'c7':[229.61,323.15],'c8':[161.57,229.61],'c9':[113.39,161.57],'c10':[79.37,113.39],'dl':[311.81,623.62],'letter':[612,792],'government-letter':[576,756],'legal':[612,1008],'junior-legal':[576,360],'ledger':[1224,792],'tabloid':[792,1224],'credit-card':[153,243]}; /**
	   * jsPDF's Internal PubSub Implementation.
	   * See mrrio.github.io/jsPDF/doc/symbols/PubSub.html
	   * Backward compatible rewritten on 2014 by
	   * Diego Casorran, https://github.com/diegocr
	   *
	   * @class
	   * @name PubSub
	   * @ignore This should not be in the public docs.
	   */function PubSub(context){var topics={};this.subscribe = function(topic,callback,once){if(typeof callback !== 'function'){return false;}if(!topics.hasOwnProperty(topic)){topics[topic] = {};}var id=Math.random().toString(35);topics[topic][id] = [callback,!!once];return id;};this.unsubscribe = function(token){for(var topic in topics) {if(topics[topic][token]){delete topics[topic][token];return true;}}return false;};this.publish = function(topic){if(topics.hasOwnProperty(topic)){var args=Array.prototype.slice.call(arguments,1),idr=[];for(var id in topics[topic]) {var sub=topics[topic][id];try{sub[0].apply(context,args);}catch(ex) {if(global.console){console.error('jsPDF PubSub Error',ex.message,ex);}}if(sub[1])idr.push(id);}if(idr.length)idr.forEach(this.unsubscribe);}};} /**
	   * @constructor
	   * @private
	   */function jsPDF(orientation,unit,format,compressPdf){var options={};if((typeof orientation === 'undefined'?'undefined':_typeof(orientation)) === 'object'){options = orientation;orientation = options.orientation;unit = options.unit || unit;format = options.format || format;compressPdf = options.compress || options.compressPdf || compressPdf;} // Default options
	unit = unit || 'mm';format = format || 'a4';orientation = ('' + (orientation || 'P')).toLowerCase();var format_as_string=('' + format).toLowerCase(),compress=!!compressPdf && typeof Uint8Array === 'function',textColor=options.textColor || '0 g',drawColor=options.drawColor || '0 G',activeFontSize=options.fontSize || 16,lineHeightProportion=options.lineHeight || 1.15,lineWidth=options.lineWidth || 0.200025, // 2mm
	objectNumber=2, // 'n' Current object number
	outToPages=!1, // switches where out() prints. outToPages true = push to pages obj. outToPages false = doc builder content
	offsets=[], // List of offsets. Activated and reset by buildDocument(). Pupulated by various calls buildDocument makes.
	fonts={}, // collection of font objects, where key is fontKey - a dynamically created label for a given font.
	fontmap={}, // mapping structure fontName > fontStyle > font key - performance layer. See addFont()
	activeFontKey, // will be string representing the KEY of the font as combination of fontName + fontStyle
	k, // Scale factor
	tmp,page=0,currentPage,pages=[],pagesContext=[], // same index as pages and pagedim
	pagedim=[],content=[],additionalObjects=[],lineCapID=0,lineJoinID=0,content_length=0,pageWidth,pageHeight,pageMode,zoomMode,layoutMode,documentProperties={'title':'','subject':'','author':'','keywords':'','creator':''},API={},events=new PubSub(API),hotfixes=options.hotfixes || [], /////////////////////
	// Private functions
	/////////////////////
	f2=function f2(number){return number.toFixed(2); // Ie, %.2f
	},f3=function f3(number){return number.toFixed(3); // Ie, %.3f
	},padd2=function padd2(number){return ('0' + parseInt(number)).slice(-2);},out=function out(string){if(outToPages){ /* set by beginPage */pages[currentPage].push(string);}else { // +1 for '\n' that will be used to join 'content'
	content_length += string.length + 1;content.push(string);}},newObject=function newObject(){ // Begin a new object
	objectNumber++;offsets[objectNumber] = content_length;out(objectNumber + ' 0 obj');return objectNumber;}, // Does not output the object until after the pages have been output.
	// Returns an object containing the objectId and content.
	// All pages have been added so the object ID can be estimated to start right after.
	// This does not modify the current objectNumber;  It must be updated after the newObjects are output.
	newAdditionalObject=function newAdditionalObject(){var objId=pages.length * 2 + 1;objId += additionalObjects.length;var obj={objId:objId,content:''};additionalObjects.push(obj);return obj;}, // Does not output the object.  The caller must call newObjectDeferredBegin(oid) before outputing any data
	newObjectDeferred=function newObjectDeferred(){objectNumber++;offsets[objectNumber] = function(){return content_length;};return objectNumber;},newObjectDeferredBegin=function newObjectDeferredBegin(oid){offsets[oid] = content_length;},putStream=function putStream(str){out('stream');out(str);out('endstream');},putPages=function putPages(){var n,p,arr,i,deflater,adler32,adler32cs,wPt,hPt,pageObjectNumbers=[];adler32cs = global.adler32cs || jsPDF.adler32cs;if(compress && typeof adler32cs === 'undefined'){compress = false;} // outToPages = false as set in endDocument(). out() writes to content.
	for(n = 1;n <= page;n++) {pageObjectNumbers.push(newObject());wPt = (pageWidth = pagedim[n].width) * k;hPt = (pageHeight = pagedim[n].height) * k;out('<</Type /Page');out('/Parent 1 0 R');out('/Resources 2 0 R');out('/MediaBox [0 0 ' + f2(wPt) + ' ' + f2(hPt) + ']'); // Added for annotation plugin
	events.publish('putPage',{pageNumber:n,page:pages[n]});out('/Contents ' + (objectNumber + 1) + ' 0 R');out('>>');out('endobj'); // Page content
	p = pages[n].join('\n');newObject();if(compress){arr = [];i = p.length;while(i--) {arr[i] = p.charCodeAt(i);}adler32 = adler32cs.from(p);deflater = new Deflater(6);deflater.append(new Uint8Array(arr));p = deflater.flush();arr = new Uint8Array(p.length + 6);arr.set(new Uint8Array([120,156])),arr.set(p,2);arr.set(new Uint8Array([adler32 & 0xFF,adler32 >> 8 & 0xFF,adler32 >> 16 & 0xFF,adler32 >> 24 & 0xFF]),p.length + 2);p = String.fromCharCode.apply(null,arr);out('<</Length ' + p.length + ' /Filter [/FlateDecode]>>');}else {out('<</Length ' + p.length + '>>');}putStream(p);out('endobj');}offsets[1] = content_length;out('1 0 obj');out('<</Type /Pages');var kids='/Kids [';for(i = 0;i < page;i++) {kids += pageObjectNumbers[i] + ' 0 R ';}out(kids + ']');out('/Count ' + page);out('>>');out('endobj');events.publish('postPutPages');},putFont=function putFont(font){font.objectNumber = newObject();out('<</BaseFont/' + font.PostScriptName + '/Type/Font');if(typeof font.encoding === 'string'){out('/Encoding/' + font.encoding);}out('/Subtype/Type1>>');out('endobj');},putFonts=function putFonts(){for(var fontKey in fonts) {if(fonts.hasOwnProperty(fontKey)){putFont(fonts[fontKey]);}}},putXobjectDict=function putXobjectDict(){ // Loop through images, or other data objects
	events.publish('putXobjectDict');},putResourceDictionary=function putResourceDictionary(){out('/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]');out('/Font <<'); // Do this for each font, the '1' bit is the index of the font
	for(var fontKey in fonts) {if(fonts.hasOwnProperty(fontKey)){out('/' + fontKey + ' ' + fonts[fontKey].objectNumber + ' 0 R');}}out('>>');out('/XObject <<');putXobjectDict();out('>>');},putResources=function putResources(){putFonts();events.publish('putResources'); // Resource dictionary
	offsets[2] = content_length;out('2 0 obj');out('<<');putResourceDictionary();out('>>');out('endobj');events.publish('postPutResources');},putAdditionalObjects=function putAdditionalObjects(){events.publish('putAdditionalObjects');for(var i=0;i < additionalObjects.length;i++) {var obj=additionalObjects[i];offsets[obj.objId] = content_length;out(obj.objId + ' 0 obj');out(obj.content);out('endobj');}objectNumber += additionalObjects.length;events.publish('postPutAdditionalObjects');},addToFontDictionary=function addToFontDictionary(fontKey,fontName,fontStyle){ // this is mapping structure for quick font key lookup.
	// returns the KEY of the font (ex: "F1") for a given
	// pair of font name and type (ex: "Arial". "Italic")
	if(!fontmap.hasOwnProperty(fontName)){fontmap[fontName] = {};}fontmap[fontName][fontStyle] = fontKey;}, /**
	     * FontObject describes a particular font as member of an instnace of jsPDF
	     *
	     * It's a collection of properties like 'id' (to be used in PDF stream),
	     * 'fontName' (font's family name), 'fontStyle' (font's style variant label)
	     *
	     * @class
	     * @public
	     * @property id {String} PDF-document-instance-specific label assinged to the font.
	     * @property PostScriptName {String} PDF specification full name for the font
	     * @property encoding {Object} Encoding_name-to-Font_metrics_object mapping.
	     * @name FontObject
	     * @ignore This should not be in the public docs.
	     */addFont=function addFont(PostScriptName,fontName,fontStyle,encoding){var fontKey='F' + (Object.keys(fonts).length + 1).toString(10), // This is FontObject
	font=fonts[fontKey] = {'id':fontKey,'PostScriptName':PostScriptName,'fontName':fontName,'fontStyle':fontStyle,'encoding':encoding,'metadata':{}};addToFontDictionary(fontKey,fontName,fontStyle);events.publish('addFont',font);return fontKey;},addFonts=function addFonts(){var HELVETICA="helvetica",TIMES="times",COURIER="courier",NORMAL="normal",BOLD="bold",ITALIC="italic",BOLD_ITALIC="bolditalic",encoding='StandardEncoding',ZAPF="zapfdingbats",standardFonts=[['Helvetica',HELVETICA,NORMAL],['Helvetica-Bold',HELVETICA,BOLD],['Helvetica-Oblique',HELVETICA,ITALIC],['Helvetica-BoldOblique',HELVETICA,BOLD_ITALIC],['Courier',COURIER,NORMAL],['Courier-Bold',COURIER,BOLD],['Courier-Oblique',COURIER,ITALIC],['Courier-BoldOblique',COURIER,BOLD_ITALIC],['Times-Roman',TIMES,NORMAL],['Times-Bold',TIMES,BOLD],['Times-Italic',TIMES,ITALIC],['Times-BoldItalic',TIMES,BOLD_ITALIC],['ZapfDingbats',ZAPF]];for(var i=0,l=standardFonts.length;i < l;i++) {var fontKey=addFont(standardFonts[i][0],standardFonts[i][1],standardFonts[i][2],encoding); // adding aliases for standard fonts, this time matching the capitalization
	var parts=standardFonts[i][0].split('-');addToFontDictionary(fontKey,parts[0],parts[1] || '');}events.publish('addFonts',{fonts:fonts,dictionary:fontmap});},SAFE=function __safeCall(fn){fn.foo = function __safeCallWrapper(){try{return fn.apply(this,arguments);}catch(e) {var stack=e.stack || '';if(~stack.indexOf(' at '))stack = stack.split(" at ")[1];var m="Error in function " + stack.split("\n")[0].split('<')[0] + ": " + e.message;if(global.console){global.console.error(m,e);if(global.alert)alert(m);}else {throw new Error(m);}}};fn.foo.bar = fn;return fn.foo;},to8bitStream=function to8bitStream(text,flags){ /**
	       * PDF 1.3 spec:
	       * "For text strings encoded in Unicode, the first two bytes must be 254 followed by
	       * 255, representing the Unicode byte order marker, U+FEFF. (This sequence conflicts
	       * with the PDFDocEncoding character sequence thorn ydieresis, which is unlikely
	       * to be a meaningful beginning of a word or phrase.) The remainder of the
	       * string consists of Unicode character codes, according to the UTF-16 encoding
	       * specified in the Unicode standard, version 2.0. Commonly used Unicode values
	       * are represented as 2 bytes per character, with the high-order byte appearing first
	       * in the string."
	       *
	       * In other words, if there are chars in a string with char code above 255, we
	       * recode the string to UCS2 BE - string doubles in length and BOM is prepended.
	       *
	       * HOWEVER!
	       * Actual *content* (body) text (as opposed to strings used in document properties etc)
	       * does NOT expect BOM. There, it is treated as a literal GID (Glyph ID)
	       *
	       * Because of Adobe's focus on "you subset your fonts!" you are not supposed to have
	       * a font that maps directly Unicode (UCS2 / UTF16BE) code to font GID, but you could
	       * fudge it with "Identity-H" encoding and custom CIDtoGID map that mimics Unicode
	       * code page. There, however, all characters in the stream are treated as GIDs,
	       * including BOM, which is the reason we need to skip BOM in content text (i.e. that
	       * that is tied to a font).
	       *
	       * To signal this "special" PDFEscape / to8bitStream handling mode,
	       * API.text() function sets (unless you overwrite it with manual values
	       * given to API.text(.., flags) )
	       * flags.autoencode = true
	       * flags.noBOM = true
	       *
	       * ===================================================================================
	       * `flags` properties relied upon:
	       *   .sourceEncoding = string with encoding label.
	       *                     "Unicode" by default. = encoding of the incoming text.
	       *                     pass some non-existing encoding name
	       *                     (ex: 'Do not touch my strings! I know what I am doing.')
	       *                     to make encoding code skip the encoding step.
	       *   .outputEncoding = Either valid PDF encoding name
	       *                     (must be supported by jsPDF font metrics, otherwise no encoding)
	       *                     or a JS object, where key = sourceCharCode, value = outputCharCode
	       *                     missing keys will be treated as: sourceCharCode === outputCharCode
	       *   .noBOM
	       *       See comment higher above for explanation for why this is important
	       *   .autoencode
	       *       See comment higher above for explanation for why this is important
	       */var i,l,sourceEncoding,encodingBlock,outputEncoding,newtext,isUnicode,ch,bch;flags = flags || {};sourceEncoding = flags.sourceEncoding || 'Unicode';outputEncoding = flags.outputEncoding; // This 'encoding' section relies on font metrics format
	// attached to font objects by, among others,
	// "Willow Systems' standard_font_metrics plugin"
	// see jspdf.plugin.standard_font_metrics.js for format
	// of the font.metadata.encoding Object.
	// It should be something like
	//   .encoding = {'codePages':['WinANSI....'], 'WinANSI...':{code:code, ...}}
	//   .widths = {0:width, code:width, ..., 'fof':divisor}
	//   .kerning = {code:{previous_char_code:shift, ..., 'fof':-divisor},...}
	if((flags.autoencode || outputEncoding) && fonts[activeFontKey].metadata && fonts[activeFontKey].metadata[sourceEncoding] && fonts[activeFontKey].metadata[sourceEncoding].encoding){encodingBlock = fonts[activeFontKey].metadata[sourceEncoding].encoding; // each font has default encoding. Some have it clearly defined.
	if(!outputEncoding && fonts[activeFontKey].encoding){outputEncoding = fonts[activeFontKey].encoding;} // Hmmm, the above did not work? Let's try again, in different place.
	if(!outputEncoding && encodingBlock.codePages){outputEncoding = encodingBlock.codePages[0]; // let's say, first one is the default
	}if(typeof outputEncoding === 'string'){outputEncoding = encodingBlock[outputEncoding];} // we want output encoding to be a JS Object, where
	// key = sourceEncoding's character code and
	// value = outputEncoding's character code.
	if(outputEncoding){isUnicode = false;newtext = [];for(i = 0,l = text.length;i < l;i++) {ch = outputEncoding[text.charCodeAt(i)];if(ch){newtext.push(String.fromCharCode(ch));}else {newtext.push(text[i]);} // since we are looping over chars anyway, might as well
	// check for residual unicodeness
	if(newtext[i].charCodeAt(0) >> 8){ /* more than 255 */isUnicode = true;}}text = newtext.join('');}}i = text.length; // isUnicode may be set to false above. Hence the triple-equal to undefined
	while(isUnicode === undefined && i !== 0) {if(text.charCodeAt(i - 1) >> 8){ /* more than 255 */isUnicode = true;}i--;}if(!isUnicode){return text;}newtext = flags.noBOM?[]:[254,255];for(i = 0,l = text.length;i < l;i++) {ch = text.charCodeAt(i);bch = ch >> 8; // divide by 256
	if(bch >> 8){ /* something left after dividing by 256 second time */throw new Error("Character at position " + i + " of string '" + text + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");}newtext.push(bch);newtext.push(ch - (bch << 8));}return String.fromCharCode.apply(undefined,newtext);},pdfEscape=function pdfEscape(text,flags){ /**
	       * Replace '/', '(', and ')' with pdf-safe versions
	       *
	       * Doing to8bitStream does NOT make this PDF display unicode text. For that
	       * we also need to reference a unicode font and embed it - royal pain in the rear.
	       *
	       * There is still a benefit to to8bitStream - PDF simply cannot handle 16bit chars,
	       * which JavaScript Strings are happy to provide. So, while we still cannot display
	       * 2-byte characters property, at least CONDITIONALLY converting (entire string containing)
	       * 16bit chars to (USC-2-BE) 2-bytes per char + BOM streams we ensure that entire PDF
	       * is still parseable.
	       * This will allow immediate support for unicode in document properties strings.
	       */return to8bitStream(text,flags).replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)');},putInfo=function putInfo(){out('/Producer (jsPDF ' + jsPDF.version + ')');for(var key in documentProperties) {if(documentProperties.hasOwnProperty(key) && documentProperties[key]){out('/' + key.substr(0,1).toUpperCase() + key.substr(1) + ' (' + pdfEscape(documentProperties[key]) + ')');}}var created=new Date(),tzoffset=created.getTimezoneOffset(),tzsign=tzoffset < 0?'+':'-',tzhour=Math.floor(Math.abs(tzoffset / 60)),tzmin=Math.abs(tzoffset % 60),tzstr=[tzsign,padd2(tzhour),"'",padd2(tzmin),"'"].join('');out(['/CreationDate (D:',created.getFullYear(),padd2(created.getMonth() + 1),padd2(created.getDate()),padd2(created.getHours()),padd2(created.getMinutes()),padd2(created.getSeconds()),tzstr,')'].join(''));},putCatalog=function putCatalog(){out('/Type /Catalog');out('/Pages 1 0 R'); // PDF13ref Section 7.2.1
	if(!zoomMode)zoomMode = 'fullwidth';switch(zoomMode){case 'fullwidth':out('/OpenAction [3 0 R /FitH null]');break;case 'fullheight':out('/OpenAction [3 0 R /FitV null]');break;case 'fullpage':out('/OpenAction [3 0 R /Fit]');break;case 'original':out('/OpenAction [3 0 R /XYZ null null 1]');break;default:var pcn='' + zoomMode;if(pcn.substr(pcn.length - 1) === '%')zoomMode = parseInt(zoomMode) / 100;if(typeof zoomMode === 'number'){out('/OpenAction [3 0 R /XYZ null null ' + f2(zoomMode) + ']');}}if(!layoutMode)layoutMode = 'continuous';switch(layoutMode){case 'continuous':out('/PageLayout /OneColumn');break;case 'single':out('/PageLayout /SinglePage');break;case 'two':case 'twoleft':out('/PageLayout /TwoColumnLeft');break;case 'tworight':out('/PageLayout /TwoColumnRight');break;}if(pageMode){ /**
	         * A name object specifying how the document should be displayed when opened:
	         * UseNone      : Neither document outline nor thumbnail images visible -- DEFAULT
	         * UseOutlines  : Document outline visible
	         * UseThumbs    : Thumbnail images visible
	         * FullScreen   : Full-screen mode, with no menu bar, window controls, or any other window visible
	         */out('/PageMode /' + pageMode);}events.publish('putCatalog');},putTrailer=function putTrailer(){out('/Size ' + (objectNumber + 1));out('/Root ' + objectNumber + ' 0 R');out('/Info ' + (objectNumber - 1) + ' 0 R');},beginPage=function beginPage(width,height){ // Dimensions are stored as user units and converted to points on output
	var orientation=typeof height === 'string' && height.toLowerCase();if(typeof width === 'string'){var format=width.toLowerCase();if(pageFormats.hasOwnProperty(format)){width = pageFormats[format][0] / k;height = pageFormats[format][1] / k;}}if(Array.isArray(width)){height = width[1];width = width[0];}if(orientation){switch(orientation.substr(0,1)){case 'l':if(height > width)orientation = 's';break;case 'p':if(width > height)orientation = 's';break;}if(orientation === 's'){tmp = width;width = height;height = tmp;}}outToPages = true;pages[++page] = [];pagedim[page] = {width:Number(width) || pageWidth,height:Number(height) || pageHeight};pagesContext[page] = {};_setPage(page);},_addPage=function _addPage(){beginPage.apply(this,arguments); // Set line width
	out(f2(lineWidth * k) + ' w'); // Set draw color
	out(drawColor); // resurrecting non-default line caps, joins
	if(lineCapID !== 0){out(lineCapID + ' J');}if(lineJoinID !== 0){out(lineJoinID + ' j');}events.publish('addPage',{pageNumber:page});},_deletePage=function _deletePage(n){if(n > 0 && n <= page){pages.splice(n,1);pagedim.splice(n,1);page--;if(currentPage > page){currentPage = page;}this.setPage(currentPage);}},_setPage=function _setPage(n){if(n > 0 && n <= page){currentPage = n;pageWidth = pagedim[n].width;pageHeight = pagedim[n].height;}}, /**
	     * Returns a document-specific font key - a label assigned to a
	     * font name + font type combination at the time the font was added
	     * to the font inventory.
	     *
	     * Font key is used as label for the desired font for a block of text
	     * to be added to the PDF document stream.
	     * @private
	     * @function
	     * @param fontName {String} can be undefined on "falthy" to indicate "use current"
	     * @param fontStyle {String} can be undefined on "falthy" to indicate "use current"
	     * @returns {String} Font key.
	     */_getFont=function _getFont(fontName,fontStyle){var key;fontName = fontName !== undefined?fontName:fonts[activeFontKey].fontName;fontStyle = fontStyle !== undefined?fontStyle:fonts[activeFontKey].fontStyle;if(fontName !== undefined){fontName = fontName.toLowerCase();}switch(fontName){case 'sans-serif':case 'verdana':case 'arial':case 'helvetica':fontName = 'helvetica';break;case 'fixed':case 'monospace':case 'terminal':case 'courier':fontName = 'courier';break;case 'serif':case 'cursive':case 'fantasy':default:fontName = 'times';break;}try{ // get a string like 'F3' - the KEY corresponding tot he font + type combination.
	key = fontmap[fontName][fontStyle];}catch(e) {}if(!key){ //throw new Error("Unable to look up font label for font '" + fontName + "', '"
	//+ fontStyle + "'. Refer to getFontList() for available fonts.");
	key = fontmap['times'][fontStyle];if(key == null){key = fontmap['times']['normal'];}}return key;},buildDocument=function buildDocument(){outToPages = false; // switches out() to content
	objectNumber = 2;content_length = 0;content = [];offsets = [];additionalObjects = []; // Added for AcroForm
	events.publish('buildDocument'); // putHeader()
	out('%PDF-' + pdfVersion);putPages(); // Must happen after putPages
	// Modifies current object Id
	putAdditionalObjects();putResources(); // Info
	newObject();out('<<');putInfo();out('>>');out('endobj'); // Catalog
	newObject();out('<<');putCatalog();out('>>');out('endobj'); // Cross-ref
	var o=content_length,i,p="0000000000";out('xref');out('0 ' + (objectNumber + 1));out(p + ' 65535 f ');for(i = 1;i <= objectNumber;i++) {var offset=offsets[i];if(typeof offset === 'function'){out((p + offsets[i]()).slice(-10) + ' 00000 n ');}else {out((p + offsets[i]).slice(-10) + ' 00000 n ');}} // Trailer
	out('trailer');out('<<');putTrailer();out('>>');out('startxref');out('' + o);out('%%EOF');outToPages = true;return content.join('\n');},getStyle=function getStyle(style){ // see path-painting operators in PDF spec
	var op='S'; // stroke
	if(style === 'F'){op = 'f'; // fill
	}else if(style === 'FD' || style === 'DF'){op = 'B'; // both
	}else if(style === 'f' || style === 'f*' || style === 'B' || style === 'B*'){ /*
	         Allow direct use of these PDF path-painting operators:
	         - f	fill using nonzero winding number rule
	         - f*	fill using even-odd rule
	         - B	fill then stroke with fill using non-zero winding number rule
	         - B*	fill then stroke with fill using even-odd rule
	         */op = style;}return op;},getArrayBuffer=function getArrayBuffer(){var data=buildDocument(),len=data.length,ab=new ArrayBuffer(len),u8=new Uint8Array(ab);while(len--) {u8[len] = data.charCodeAt(len);}return ab;},getBlob=function getBlob(){return new Blob([getArrayBuffer()],{type:"application/pdf"});}, /**
	     * Generates the PDF document.
	     *
	     * If `type` argument is undefined, output is raw body of resulting PDF returned as a string.
	     *
	     * @param {String} type A string identifying one of the possible output types.
	     * @param {Object} options An object providing some additional signalling to PDF generator.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name output
	     */_output=SAFE(function(type,options){var datauri=('' + type).substr(0,6) === 'dataur'?'data:application/pdf;base64,' + btoa(buildDocument()):0;switch(type){case undefined:return buildDocument();case 'save':if(navigator.getUserMedia){if(global.URL === undefined || global.URL.createObjectURL === undefined){return API.output('dataurlnewwindow');}}saveAs(getBlob(),options);if(typeof saveAs.unload === 'function'){if(global.setTimeout){setTimeout(saveAs.unload,911);}}break;case 'arraybuffer':return getArrayBuffer();case 'blob':return getBlob();case 'bloburi':case 'bloburl': // User is responsible of calling revokeObjectURL
	return global.URL && global.URL.createObjectURL(getBlob()) || void 0;case 'datauristring':case 'dataurlstring':return datauri;case 'dataurlnewwindow':var nW=global.open(datauri);if(nW || typeof safari === "undefined")return nW; /* pass through */case 'datauri':case 'dataurl':return global.document.location.href = datauri;default:throw new Error('Output type "' + type + '" is not supported.');} // @TODO: Add different output options
	}), /**
	     * Used to see if a supplied hotfix was requested when the pdf instance was created.
	     * @param {String} hotfixName - The name of the hotfix to check.
	     * @returns {boolean}
	    */hasHotfix=function hasHotfix(hotfixName){return Array.isArray(hotfixes) === true && hotfixes.indexOf(hotfixName) > -1;};switch(unit){case 'pt':k = 1;break;case 'mm':k = 72 / 25.4000508;break;case 'cm':k = 72 / 2.54000508;break;case 'in':k = 72;break;case 'px':if(hasHotfix('px_scaling') == true){k = 72 / 96;}else {k = 96 / 72;}break;case 'pc':k = 12;break;case 'em':k = 12;break;case 'ex':k = 6;break;default:throw 'Invalid unit: ' + unit;} //---------------------------------------
	// Public API
	/**
	     * Object exposing internal API to plugins
	     * @public
	     */API.internal = {'pdfEscape':pdfEscape,'getStyle':getStyle, /**
	       * Returns {FontObject} describing a particular font.
	       * @public
	       * @function
	       * @param fontName {String} (Optional) Font's family name
	       * @param fontStyle {String} (Optional) Font's style variation name (Example:"Italic")
	       * @returns {FontObject}
	       */'getFont':function getFont(){return fonts[_getFont.apply(API,arguments)];},'getFontSize':function getFontSize(){return activeFontSize;},'getLineHeight':function getLineHeight(){return activeFontSize * lineHeightProportion;},'write':function write(string1 /*, string2, string3, etc */){out(arguments.length === 1?string1:Array.prototype.join.call(arguments,' '));},'getCoordinateString':function getCoordinateString(value){return f2(value * k);},'getVerticalCoordinateString':function getVerticalCoordinateString(value){return f2((pageHeight - value) * k);},'collections':{},'newObject':newObject,'newAdditionalObject':newAdditionalObject,'newObjectDeferred':newObjectDeferred,'newObjectDeferredBegin':newObjectDeferredBegin,'putStream':putStream,'events':events, // ratio that you use in multiplication of a given "size" number to arrive to 'point'
	// units of measurement.
	// scaleFactor is set at initialization of the document and calculated against the stated
	// default measurement units for the document.
	// If default is "mm", k is the number that will turn number in 'mm' into 'points' number.
	// through multiplication.
	'scaleFactor':k,'pageSize':Object.defineProperties({},{width:{get:function get(){return pageWidth;},configurable:true,enumerable:true},height:{get:function get(){return pageHeight;},configurable:true,enumerable:true}}),'output':function output(type,options){return _output(type,options);},'getNumberOfPages':function getNumberOfPages(){return pages.length - 1;},'pages':pages,'out':out,'f2':f2,'getPageInfo':function getPageInfo(pageNumberOneBased){var objId=(pageNumberOneBased - 1) * 2 + 3;return {objId:objId,pageNumber:pageNumberOneBased,pageContext:pagesContext[pageNumberOneBased]};},'getCurrentPageInfo':function getCurrentPageInfo(){var objId=(currentPage - 1) * 2 + 3;return {objId:objId,pageNumber:currentPage,pageContext:pagesContext[currentPage]};},'getPDFVersion':function getPDFVersion(){return pdfVersion;},'hasHotfix':hasHotfix //Expose the hasHotfix check so plugins can also check them.
	}; /**
	     * Adds (and transfers the focus to) new page to the PDF document.
	     * @function
	     * @returns {jsPDF}
	     *
	     * @methodOf jsPDF#
	     * @name addPage
	     */API.addPage = function(){_addPage.apply(this,arguments);return this;}; /**
	     * Adds (and transfers the focus to) new page to the PDF document.
	     * @function
	     * @returns {jsPDF}
	     *
	     * @methodOf jsPDF#
	     * @name setPage
	     * @param {Number} page Switch the active page to the page number specified
	     * @example
	     * doc = jsPDF()
	     * doc.addPage()
	     * doc.addPage()
	     * doc.text('I am on page 3', 10, 10)
	     * doc.setPage(1)
	     * doc.text('I am on page 1', 10, 10)
	     */API.setPage = function(){_setPage.apply(this,arguments);return this;};API.insertPage = function(beforePage){this.addPage();this.movePage(currentPage,beforePage);return this;};API.movePage = function(targetPage,beforePage){if(targetPage > beforePage){var tmpPages=pages[targetPage];var tmpPagedim=pagedim[targetPage];var tmpPagesContext=pagesContext[targetPage];for(var i=targetPage;i > beforePage;i--) {pages[i] = pages[i - 1];pagedim[i] = pagedim[i - 1];pagesContext[i] = pagesContext[i - 1];}pages[beforePage] = tmpPages;pagedim[beforePage] = tmpPagedim;pagesContext[beforePage] = tmpPagesContext;this.setPage(beforePage);}else if(targetPage < beforePage){var tmpPages=pages[targetPage];var tmpPagedim=pagedim[targetPage];var tmpPagesContext=pagesContext[targetPage];for(var i=targetPage;i < beforePage;i++) {pages[i] = pages[i + 1];pagedim[i] = pagedim[i + 1];pagesContext[i] = pagesContext[i + 1];}pages[beforePage] = tmpPages;pagedim[beforePage] = tmpPagedim;pagesContext[beforePage] = tmpPagesContext;this.setPage(beforePage);}return this;};API.deletePage = function(){_deletePage.apply(this,arguments);return this;}; /**
	     * Set the display mode options of the page like zoom and layout.
	     *
	     * @param {integer|String} zoom   You can pass an integer or percentage as
	     * a string. 2 will scale the document up 2x, '200%' will scale up by the
	     * same amount. You can also set it to 'fullwidth', 'fullheight',
	     * 'fullpage', or 'original'.
	     *
	     * Only certain PDF readers support this, such as Adobe Acrobat
	     *
	     * @param {String} layout Layout mode can be: 'continuous' - this is the
	     * default continuous scroll. 'single' - the single page mode only shows one
	     * page at a time. 'twoleft' - two column left mode, first page starts on
	     * the left, and 'tworight' - pages are laid out in two columns, with the
	     * first page on the right. This would be used for books.
	     * @param {String} pmode 'UseOutlines' - it shows the
	     * outline of the document on the left. 'UseThumbs' - shows thumbnails along
	     * the left. 'FullScreen' - prompts the user to enter fullscreen mode.
	     *
	     * @function
	     * @returns {jsPDF}
	     * @name setDisplayMode
	     */API.setDisplayMode = function(zoom,layout,pmode){zoomMode = zoom;layoutMode = layout;pageMode = pmode;var validPageModes=[undefined,null,'UseNone','UseOutlines','UseThumbs','FullScreen'];if(validPageModes.indexOf(pmode) == -1){throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + pmode + '" is not recognized.');}return this;}, /**
	     * Adds text to page. Supports adding multiline text when 'text' argument is an Array of Strings.
	     *
	     * @function
	     * @param {String|Array} text String or array of strings to be added to the page. Each line is shifted one line down per font, spacing settings declared before this call.
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Object} flags Collection of settings signalling how the text must be encoded. Defaults are sane. If you think you want to pass some flags, you likely can read the source.
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name text
	     */API.text = function(text,x,y,flags,angle,align){ /**
	       * Inserts something like this into PDF
	       *   BT
	       *    /F1 16 Tf  % Font name + size
	       *    16 TL % How many units down for next line in multiline text
	       *    0 g % color
	       *    28.35 813.54 Td % position
	       *    (line one) Tj
	       *    T* (line two) Tj
	       *    T* (line three) Tj
	       *   ET
	       */function ESC(s){s = s.split("\t").join(Array(options.TabLen || 9).join(" "));return pdfEscape(s,flags);} // Pre-August-2012 the order of arguments was function(x, y, text, flags)
	// in effort to make all calls have similar signature like
	//   function(data, coordinates... , miscellaneous)
	// this method had its args flipped.
	// code below allows backward compatibility with old arg order.
	if(typeof text === 'number'){tmp = y;y = x;x = text;text = tmp;} // If there are any newlines in text, we assume
	// the user wanted to print multiple lines, so break the
	// text up into an array.  If the text is already an array,
	// we assume the user knows what they are doing.
	// Convert text into an array anyway to simplify
	// later code.
	if(typeof text === 'string'){if(text.match(/[\n\r]/)){text = text.split(/\r\n|\r|\n/g);}else {text = [text];}}if(typeof angle === 'string'){align = angle;angle = null;}if(typeof flags === 'string'){align = flags;flags = null;}if(typeof flags === 'number'){angle = flags;flags = null;}var xtra='',mode='Td',todo;if(angle){angle *= Math.PI / 180;var c=Math.cos(angle),s=Math.sin(angle);xtra = [f2(c),f2(s),f2(s * -1),f2(c),''].join(" ");mode = 'Tm';}flags = flags || {};if(!('noBOM' in flags))flags.noBOM = true;if(!('autoencode' in flags))flags.autoencode = true;var strokeOption='';var pageContext=this.internal.getCurrentPageInfo().pageContext;if(true === flags.stroke){if(pageContext.lastTextWasStroke !== true){strokeOption = '1 Tr\n';pageContext.lastTextWasStroke = true;}}else {if(pageContext.lastTextWasStroke){strokeOption = '0 Tr\n';}pageContext.lastTextWasStroke = false;}if(typeof this._runningPageHeight === 'undefined'){this._runningPageHeight = 0;}if(typeof text === 'string'){text = ESC(text);}else if(Object.prototype.toString.call(text) === '[object Array]'){ // we don't want to destroy  original text array, so cloning it
	var sa=text.concat(),da=[],len=sa.length; // we do array.join('text that must not be PDFescaped")
	// thus, pdfEscape each component separately
	while(len--) {da.push(ESC(sa.shift()));}if(align){var left,prevX,maxLineLength,leading=activeFontSize * lineHeightProportion,lineWidths=text.map(function(v){return this.getStringUnitWidth(v) * activeFontSize / k;},this);maxLineLength = Math.max.apply(Math,lineWidths); // The first line uses the "main" Td setting,
	// and the subsequent lines are offset by the
	// previous line's x coordinate.
	if(align === "center"){ // The passed in x coordinate defines
	// the center point.
	left = x - maxLineLength / 2;x -= lineWidths[0] / 2;}else if(align === "right"){ // The passed in x coordinate defines the
	// rightmost point of the text.
	left = x - maxLineLength;x -= lineWidths[0];}else {throw new Error('Unrecognized alignment option, use "center" or "right".');}prevX = x;text = da[0];for(var i=1,len=da.length;i < len;i++) {var delta=maxLineLength - lineWidths[i];if(align === "center")delta /= 2; // T* = x-offset leading Td ( text )
	text += ") Tj\n" + (left - prevX + delta) + " -" + leading + " Td (" + da[i];prevX = left + delta;}}else {text = da.join(") Tj\nT* (");}}else {throw new Error('Type of text must be string or Array. "' + text + '" is not recognized.');} // Using "'" ("go next line and render text" mark) would save space but would complicate our rendering code, templates
	// BT .. ET does NOT have default settings for Tf. You must state that explicitely every time for BT .. ET
	// if you want text transformation matrix (+ multiline) to work reliably (which reads sizes of things from font declarations)
	// Thus, there is NO useful, *reliable* concept of "default" font for a page.
	// The fact that "default" (reuse font used before) font worked before in basic cases is an accident
	// - readers dealing smartly with brokenness of jsPDF's markup.
	var curY;if(todo){ //this.addPage();
	//this._runningPageHeight += y -  (activeFontSize * 1.7 / k);
	//curY = f2(pageHeight - activeFontSize * 1.7 /k);
	}else {curY = f2((pageHeight - y) * k);} //curY = f2((pageHeight - (y - this._runningPageHeight)) * k);
	//			if (curY < 0){
	//				console.log('auto page break');
	//				this.addPage();
	//				this._runningPageHeight = y -  (activeFontSize * 1.7 / k);
	//				curY = f2(pageHeight - activeFontSize * 1.7 /k);
	//			}
	out('BT\n/' + activeFontKey + ' ' + activeFontSize + ' Tf\n' +  // font face, style, size
	activeFontSize * lineHeightProportion + ' TL\n' +  // line spacing
	strokeOption +  // stroke option
	textColor + '\n' + xtra + f2(x * k) + ' ' + curY + ' ' + mode + '\n(' + text + ') Tj\nET');if(todo){ //this.text( todo, x, activeFontSize * 1.7 / k);
	//this.text( todo, x, this._runningPageHeight + (activeFontSize * 1.7 / k));
	this.text(todo,x,y); // + (activeFontSize * 1.7 / k));
	}return this;}; /**
	     * Letter spacing method to print text with gaps
	     *
	     * @function
	     * @param {String|Array} text String to be added to the page.
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} spacing Spacing (in units declared at inception)
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name lstext
	     * @deprecated We'll be removing this function. It doesn't take character width into account.
	     */API.lstext = function(text,x,y,spacing){console.warn('jsPDF.lstext is deprecated');for(var i=0,len=text.length;i < len;i++,x += spacing) {this.text(text[i],x,y);}return this;};API.line = function(x1,y1,x2,y2){return this.lines([[x2 - x1,y2 - y1]],x1,y1);};API.clip = function(){ // By patrick-roberts, github.com/MrRio/jsPDF/issues/328
	// Call .clip() after calling .rect() with a style argument of null
	out('W'); // clip
	out('S'); // stroke path; necessary for clip to work
	}; /**
	     * This fixes the previous function clip(). Perhaps the 'stroke path' hack was due to the missing 'n' instruction?
	     * We introduce the fixed version so as to not break API.
	     * @param fillRule
	     */API.clip_fixed = function(fillRule){ // Call .clip() after calling drawing ops with a style argument of null
	// W is the PDF clipping op
	if('evenodd' === fillRule){out('W*');}else {out('W');} // End the path object without filling or stroking it.
	// This operator is a path-painting no-op, used primarily for the side effect of changing the current clipping path
	// (see Section 4.4.3, “Clipping Path Operators”)
	out('n');}; /**
	     * Adds series of curves (straight lines or cubic bezier curves) to canvas, starting at `x`, `y` coordinates.
	     * All data points in `lines` are relative to last line origin.
	     * `x`, `y` become x1,y1 for first line / curve in the set.
	     * For lines you only need to specify [x2, y2] - (ending point) vector against x1, y1 starting point.
	     * For bezier curves you need to specify [x2,y2,x3,y3,x4,y4] - vectors to control points 1, 2, ending point. All vectors are against the start of the curve - x1,y1.
	     *
	     * @example .lines([[2,2],[-2,2],[1,1,2,2,3,3],[2,1]], 212,110, 10) // line, line, bezier curve, line
	     * @param {Array} lines Array of *vector* shifts as pairs (lines) or sextets (cubic bezier curves).
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} scale (Defaults to [1.0,1.0]) x,y Scaling factor for all vectors. Elements can be any floating number Sub-one makes drawing smaller. Over-one grows the drawing. Negative flips the direction.
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @param {Boolean} closed If true, the path is closed with a straight line from the end of the last curve to the starting point.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name lines
	     */API.lines = function(lines,x,y,scale,style,closed){var scalex,scaley,i,l,leg,x2,y2,x3,y3,x4,y4; // Pre-August-2012 the order of arguments was function(x, y, lines, scale, style)
	// in effort to make all calls have similar signature like
	//   function(content, coordinateX, coordinateY , miscellaneous)
	// this method had its args flipped.
	// code below allows backward compatibility with old arg order.
	if(typeof lines === 'number'){tmp = y;y = x;x = lines;lines = tmp;}scale = scale || [1,1]; // starting point
	out(f3(x * k) + ' ' + f3((pageHeight - y) * k) + ' m ');scalex = scale[0];scaley = scale[1];l = lines.length; //, x2, y2 // bezier only. In page default measurement "units", *after* scaling
	//, x3, y3 // bezier only. In page default measurement "units", *after* scaling
	// ending point for all, lines and bezier. . In page default measurement "units", *after* scaling
	x4 = x; // last / ending point = starting point for first item.
	y4 = y; // last / ending point = starting point for first item.
	for(i = 0;i < l;i++) {leg = lines[i];if(leg.length === 2){ // simple line
	x4 = leg[0] * scalex + x4; // here last x4 was prior ending point
	y4 = leg[1] * scaley + y4; // here last y4 was prior ending point
	out(f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' l');}else { // bezier curve
	x2 = leg[0] * scalex + x4; // here last x4 is prior ending point
	y2 = leg[1] * scaley + y4; // here last y4 is prior ending point
	x3 = leg[2] * scalex + x4; // here last x4 is prior ending point
	y3 = leg[3] * scaley + y4; // here last y4 is prior ending point
	x4 = leg[4] * scalex + x4; // here last x4 was prior ending point
	y4 = leg[5] * scaley + y4; // here last y4 was prior ending point
	out(f3(x2 * k) + ' ' + f3((pageHeight - y2) * k) + ' ' + f3(x3 * k) + ' ' + f3((pageHeight - y3) * k) + ' ' + f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' c');}}if(closed){out(' h');} // stroking / filling / both the path
	if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds a rectangle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name rect
	     */API.rect = function(x,y,w,h,style){var op=getStyle(style);out([f2(x * k),f2((pageHeight - y) * k),f2(w * k),f2(-h * k),'re'].join(' '));if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds a triangle to PDF
	     *
	     * @param {Number} x1 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y1 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x2 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y2 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x3 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y3 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name triangle
	     */API.triangle = function(x1,y1,x2,y2,x3,y3,style){this.lines([[x2 - x1,y2 - y1], // vector to point 2
	[x3 - x2,y3 - y2], // vector to point 3
	[x1 - x3,y1 - y3] // closing vector back to point 1
	],x1,y1, // start of path
	[1,1],style,true);return this;}; /**
	     * Adds a rectangle with rounded corners to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name roundedRect
	     */API.roundedRect = function(x,y,w,h,rx,ry,style){var MyArc=4 / 3 * (Math.SQRT2 - 1);this.lines([[w - 2 * rx,0],[rx * MyArc,0,rx,ry - ry * MyArc,rx,ry],[0,h - 2 * ry],[0,ry * MyArc,-(rx * MyArc),ry,-rx,ry],[-w + 2 * rx,0],[-(rx * MyArc),0,-rx,-(ry * MyArc),-rx,-ry],[0,-h + 2 * ry],[0,-(ry * MyArc),rx * MyArc,-ry,rx,-ry]],x + rx,y, // start of path
	[1,1],style);return this;}; /**
	     * Adds an ellipse to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name ellipse
	     */API.ellipse = function(x,y,rx,ry,style){var lx=4 / 3 * (Math.SQRT2 - 1) * rx,ly=4 / 3 * (Math.SQRT2 - 1) * ry;out([f2((x + rx) * k),f2((pageHeight - y) * k),'m',f2((x + rx) * k),f2((pageHeight - (y - ly)) * k),f2((x + lx) * k),f2((pageHeight - (y - ry)) * k),f2(x * k),f2((pageHeight - (y - ry)) * k),'c'].join(' '));out([f2((x - lx) * k),f2((pageHeight - (y - ry)) * k),f2((x - rx) * k),f2((pageHeight - (y - ly)) * k),f2((x - rx) * k),f2((pageHeight - y) * k),'c'].join(' '));out([f2((x - rx) * k),f2((pageHeight - (y + ly)) * k),f2((x - lx) * k),f2((pageHeight - (y + ry)) * k),f2(x * k),f2((pageHeight - (y + ry)) * k),'c'].join(' '));out([f2((x + lx) * k),f2((pageHeight - (y + ry)) * k),f2((x + rx) * k),f2((pageHeight - (y + ly)) * k),f2((x + rx) * k),f2((pageHeight - y) * k),'c'].join(' '));if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds an circle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} r Radius (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name circle
	     */API.circle = function(x,y,r,style){return this.ellipse(x,y,r,r,style);}; /**
	     * Adds a properties to the PDF document
	     *
	     * @param {Object} A property_name-to-property_value object structure.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setProperties
	     */API.setProperties = function(properties){ // copying only those properties we can render.
	for(var property in documentProperties) {if(documentProperties.hasOwnProperty(property) && properties[property]){documentProperties[property] = properties[property];}}return this;}; /**
	     * Sets font size for upcoming text elements.
	     *
	     * @param {Number} size Font size in points.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontSize
	     */API.setFontSize = function(size){activeFontSize = size;return this;}; /**
	     * Sets text font face, variant for upcoming text elements.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} fontName Font name or family. Example: "times"
	     * @param {String} fontStyle Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFont
	     */API.setFont = function(fontName,fontStyle){activeFontKey = _getFont(fontName,fontStyle); // if font is not found, the above line blows up and we never go further
	return this;}; /**
	     * Switches font style or variant for upcoming text elements,
	     * while keeping the font face or family same.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} style Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontStyle
	     */API.setFontStyle = API.setFontType = function(style){activeFontKey = _getFont(undefined,style); // if font is not found, the above line blows up and we never go further
	return this;}; /**
	     * Returns an object - a tree of fontName to fontStyle relationships available to
	     * active PDF document.
	     *
	     * @public
	     * @function
	     * @returns {Object} Like {'times':['normal', 'italic', ... ], 'arial':['normal', 'bold', ... ], ... }
	     * @methodOf jsPDF#
	     * @name getFontList
	     */API.getFontList = function(){ // TODO: iterate over fonts array or return copy of fontmap instead in case more are ever added.
	var list={},fontName,fontStyle,tmp;for(fontName in fontmap) {if(fontmap.hasOwnProperty(fontName)){list[fontName] = tmp = [];for(fontStyle in fontmap[fontName]) {if(fontmap[fontName].hasOwnProperty(fontStyle)){tmp.push(fontStyle);}}}}return list;}; /**
	     * Add a custom font.
	     *
	     * @param {String} Postscript name of the Font.  Example: "Menlo-Regular"
	     * @param {String} Name of font-family from @font-face definition.  Example: "Menlo Regular"
	     * @param {String} Font style.  Example: "normal"
	     * @function
	     * @returns the {fontKey} (same as the internal method)
	     * @methodOf jsPDF#
	     * @name addFont
	     */API.addFont = function(postScriptName,fontName,fontStyle){addFont(postScriptName,fontName,fontStyle,'StandardEncoding');}; /**
	     * Sets line width for upcoming lines.
	     *
	     * @param {Number} width Line width (in units declared at inception of PDF document)
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineWidth
	     */API.setLineWidth = function(width){out((width * k).toFixed(2) + ' w');return this;}; /**
	     * Sets the stroke color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setDrawColor
	     */API.setDrawColor = function(ch1,ch2,ch3,ch4){var color;if(ch2 === undefined || ch4 === undefined && ch1 === ch2 === ch3){ // Gray color space.
	if(typeof ch1 === 'string'){color = ch1 + ' G';}else {color = f2(ch1 / 255) + ' G';}}else if(ch4 === undefined){ // RGB
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,'RG'].join(' ');}else {color = [f2(ch1 / 255),f2(ch2 / 255),f2(ch3 / 255),'RG'].join(' ');}}else { // CMYK
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,ch4,'K'].join(' ');}else {color = [f2(ch1),f2(ch2),f2(ch3),f2(ch4),'K'].join(' ');}}out(color);return this;}; /**
	     * Sets the fill color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFillColor
	     */API.setFillColor = function(ch1,ch2,ch3,ch4){var color;if(ch2 === undefined || ch4 === undefined && ch1 === ch2 === ch3){ // Gray color space.
	if(typeof ch1 === 'string'){color = ch1 + ' g';}else {color = f2(ch1 / 255) + ' g';}}else if(ch4 === undefined || (typeof ch4 === 'undefined'?'undefined':_typeof(ch4)) === 'object'){ // RGB
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,'rg'].join(' ');}else {color = [f2(ch1 / 255),f2(ch2 / 255),f2(ch3 / 255),'rg'].join(' ');}if(ch4 && ch4.a === 0){ //TODO Implement transparency.
	//WORKAROUND use white for now
	color = ['255','255','255','rg'].join(' ');}}else { // CMYK
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,ch4,'k'].join(' ');}else {color = [f2(ch1),f2(ch2),f2(ch3),f2(ch4),'k'].join(' ');}}out(color);return this;}; /**
	     * Sets the text color for upcoming elements.
	     * If only one, first argument is given,
	     * treats the value as gray-scale color value.
	     *
	     * @param {Number} r Red channel color value in range 0-255 or {String} r color value in hexadecimal, example: '#FFFFFF'
	     * @param {Number} g Green channel color value in range 0-255
	     * @param {Number} b Blue channel color value in range 0-255
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setTextColor
	     */API.setTextColor = function(r,g,b){if(typeof r === 'string' && /^#[0-9A-Fa-f]{6}$/.test(r)){var hex=parseInt(r.substr(1),16);r = hex >> 16 & 255;g = hex >> 8 & 255;b = hex & 255;}if(r === 0 && g === 0 && b === 0 || typeof g === 'undefined'){textColor = f3(r / 255) + ' g';}else {textColor = [f3(r / 255),f3(g / 255),f3(b / 255),'rg'].join(' ');}return this;}; /**
	     * Is an Object providing a mapping from human-readable to
	     * integer flag values designating the varieties of line cap
	     * and join styles.
	     *
	     * @returns {Object}
	     * @fieldOf jsPDF#
	     * @name CapJoinStyles
	     */API.CapJoinStyles = {0:0,'butt':0,'but':0,'miter':0,1:1,'round':1,'rounded':1,'circle':1,2:2,'projecting':2,'project':2,'square':2,'bevel':2}; /**
	     * Sets the line cap styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line cap
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineCap
	     */API.setLineCap = function(style){var id=this.CapJoinStyles[style];if(id === undefined){throw new Error("Line cap style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");}lineCapID = id;out(id + ' J');return this;}; /**
	     * Sets the line join styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line join
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineJoin
	     */API.setLineJoin = function(style){var id=this.CapJoinStyles[style];if(id === undefined){throw new Error("Line join style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");}lineJoinID = id;out(id + ' j');return this;}; // Output is both an internal (for plugins) and external function
	API.output = _output; /**
	     * Saves as PDF document. An alias of jsPDF.output('save', 'filename.pdf')
	     * @param  {String} filename The filename including extension.
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name save
	     */API.save = function(filename){API.output('save',filename);}; // applying plugins (more methods) ON TOP of built-in API.
	// this is intentional as we allow plugins to override
	// built-ins
	for(var plugin in jsPDF.API) {if(jsPDF.API.hasOwnProperty(plugin)){if(plugin === 'events' && jsPDF.API.events.length){(function(events,newEvents){ // jsPDF.API.events is a JS Array of Arrays
	// where each Array is a pair of event name, handler
	// Events were added by plugins to the jsPDF instantiator.
	// These are always added to the new instance and some ran
	// during instantiation.
	var eventname,handler_and_args,i;for(i = newEvents.length - 1;i !== -1;i--) { // subscribe takes 3 args: 'topic', function, runonce_flag
	// if undefined, runonce is false.
	// users can attach callback directly,
	// or they can attach an array with [callback, runonce_flag]
	// that's what the "apply" magic is for below.
	eventname = newEvents[i][0];handler_and_args = newEvents[i][1];events.subscribe.apply(events,[eventname].concat(typeof handler_and_args === 'function'?[handler_and_args]:handler_and_args));}})(events,jsPDF.API.events);}else {API[plugin] = jsPDF.API[plugin];}}} //////////////////////////////////////////////////////
	// continuing initialization of jsPDF Document object
	//////////////////////////////////////////////////////
	// Add the first page automatically
	addFonts();activeFontKey = 'F1';_addPage(format,orientation);events.publish('initialized');return API;} /**
	   * jsPDF.API is a STATIC property of jsPDF class.
	   * jsPDF.API is an object you can add methods and properties to.
	   * The methods / properties you add will show up in new jsPDF objects.
	   *
	   * One property is prepopulated. It is the 'events' Object. Plugin authors can add topics,
	   * callbacks to this object. These will be reassigned to all new instances of jsPDF.
	   * Examples:
	   * jsPDF.API.events['initialized'] = function(){ 'this' is API object }
	   * jsPDF.API.events['addFont'] = function(added_font_object){ 'this' is API object }
	   *
	   * @static
	   * @public
	   * @memberOf jsPDF
	   * @name API
	   *
	   * @example
	   * jsPDF.API.mymethod = function(){
	   *   // 'this' will be ref to internal API object. see jsPDF source
	   *   // , so you can refer to built-in methods like so:
	   *   //     this.line(....)
	   *   //     this.text(....)
	   * }
	   * var pdfdoc = new jsPDF()
	   * pdfdoc.mymethod() // <- !!!!!!
	   */jsPDF.API = {events:[]};jsPDF.version = "1.x-master";if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return jsPDF;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof module !== 'undefined' && module.exports){module.exports = jsPDF;}else {global.jsPDF = jsPDF;}return jsPDF;})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined); /**
	 * jsPDF AcroForm Plugin
	 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(window.AcroForm = function(jsPDFAPI){'use strict';var AcroForm=window.AcroForm;AcroForm.scale = function(x){return x * (acroformPlugin.internal.scaleFactor / 1); // 1 = (96 / 72)
	};AcroForm.antiScale = function(x){return 1 / acroformPlugin.internal.scaleFactor * x;};var acroformPlugin={fields:[],xForms:[], /**
	         * acroFormDictionaryRoot contains information about the AcroForm Dictionary
	         * 0: The Event-Token, the AcroFormDictionaryCallback has
	         * 1: The Object ID of the Root
	         */acroFormDictionaryRoot:null, /**
	         * After the PDF gets evaluated, the reference to the root has to be reset,
	         * this indicates, whether the root has already been printed out
	         */printedOut:false,internal:null};jsPDF.API.acroformPlugin = acroformPlugin;var annotReferenceCallback=function annotReferenceCallback(){for(var i in this.acroformPlugin.acroFormDictionaryRoot.Fields) {var formObject=this.acroformPlugin.acroFormDictionaryRoot.Fields[i]; // add Annot Reference!
	if(formObject.hasAnnotation){ // If theres an Annotation Widget in the Form Object, put the Reference in the /Annot array
	createAnnotationReference.call(this,formObject);}}};var createAcroForm=function createAcroForm(){if(this.acroformPlugin.acroFormDictionaryRoot){ //return;
	throw new Error("Exception while creating AcroformDictionary");} // The Object Number of the AcroForm Dictionary
	this.acroformPlugin.acroFormDictionaryRoot = new AcroForm.AcroFormDictionary();this.acroformPlugin.internal = this.internal; // add Callback for creating the AcroForm Dictionary
	this.acroformPlugin.acroFormDictionaryRoot._eventID = this.internal.events.subscribe('postPutResources',AcroFormDictionaryCallback);this.internal.events.subscribe('buildDocument',annotReferenceCallback); //buildDocument
	// Register event, that is triggered when the DocumentCatalog is written, in order to add /AcroForm
	this.internal.events.subscribe('putCatalog',putCatalogCallback); // Register event, that creates all Fields
	this.internal.events.subscribe('postPutPages',createFieldCallback);}; /**
	     * Create the Reference to the widgetAnnotation, so that it gets referenced in the Annot[] int the+
	     * (Requires the Annotation Plugin)
	     */var createAnnotationReference=function createAnnotationReference(object){var options={type:'reference',object:object};jsPDF.API.annotationPlugin.annotations[this.internal.getPageInfo(object.page).pageNumber].push(options);};var putForm=function putForm(formObject){if(this.acroformPlugin.printedOut){this.acroformPlugin.printedOut = false;this.acroformPlugin.acroFormDictionaryRoot = null;}if(!this.acroformPlugin.acroFormDictionaryRoot){createAcroForm.call(this);}this.acroformPlugin.acroFormDictionaryRoot.Fields.push(formObject);}; // Callbacks
	var putCatalogCallback=function putCatalogCallback(){ //Put reference to AcroForm to DocumentCatalog
	if(typeof this.acroformPlugin.acroFormDictionaryRoot != 'undefined'){ // for safety, shouldn't normally be the case
	this.internal.write('/AcroForm ' + this.acroformPlugin.acroFormDictionaryRoot.objId + ' ' + 0 + ' R');}else {console.log('Root missing...');}}; /**
	     * Adds /Acroform X 0 R to Document Catalog,
	     * and creates the AcroForm Dictionary
	     */var AcroFormDictionaryCallback=function AcroFormDictionaryCallback(){ // Remove event
	this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID);delete this.acroformPlugin.acroFormDictionaryRoot._eventID;this.acroformPlugin.printedOut = true;}; /**
	     * Creates the single Fields and writes them into the Document
	     *
	     * If fieldArray is set, use the fields that are inside it instead of the fields from the AcroRoot
	     * (for the FormXObjects...)
	     */var createFieldCallback=function createFieldCallback(fieldArray){var standardFields=!fieldArray;if(!fieldArray){ // in case there is no fieldArray specified, we want to print out the Fields of the AcroForm
	// Print out Root
	this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId);this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString());}var fieldArray=fieldArray || this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var i in fieldArray) {var form=fieldArray[i];var oldRect=form.Rect;if(form.Rect){form.Rect = AcroForm.internal.calculateCoordinates.call(this,form.Rect);} // Start Writing the Object
	this.internal.newObjectDeferredBegin(form.objId);var content="";content += form.objId + " 0 obj\n";content += "<<\n" + form.getContent();form.Rect = oldRect;if(form.hasAppearanceStream && !form.appearanceStreamContent){ // Calculate Appearance
	var appearance=AcroForm.internal.calculateAppearanceStream.call(this,form);content += "/AP << /N " + appearance + " >>\n";this.acroformPlugin.xForms.push(appearance);} // Assume AppearanceStreamContent is a Array with N,R,D (at least one of them!)
	if(form.appearanceStreamContent){content += "/AP << "; // Iterate over N,R and D
	for(var k in form.appearanceStreamContent) {var value=form.appearanceStreamContent[k];content += "/" + k + " ";content += "<< ";if(Object.keys(value).length >= 1 || Array.isArray(value)){ // appearanceStream is an Array or Object!
	for(var i in value) {var obj=value[i];if(typeof obj === 'function'){ // if Function is referenced, call it in order to get the FormXObject
	obj = obj.call(this,form);}content += "/" + i + " " + obj + " "; // In case the XForm is already used, e.g. OffState of CheckBoxes, don't add it
	if(!(this.acroformPlugin.xForms.indexOf(obj) >= 0))this.acroformPlugin.xForms.push(obj);}}else {var obj=value;if(typeof obj === 'function'){ // if Function is referenced, call it in order to get the FormXObject
	obj = obj.call(this,form);}content += "/" + i + " " + obj + " \n";if(!(this.acroformPlugin.xForms.indexOf(obj) >= 0))this.acroformPlugin.xForms.push(obj);}content += " >>\n";} // appearance stream is a normal Object..
	content += ">>\n";}content += ">>\nendobj\n";this.internal.out(content);}if(standardFields){createXFormObjectCallback.call(this,this.acroformPlugin.xForms);}};var createXFormObjectCallback=function createXFormObjectCallback(fieldArray){for(var i in fieldArray) {var key=i;var form=fieldArray[i]; // Start Writing the Object
	this.internal.newObjectDeferredBegin(form && form.objId);var content="";content += form?form.getString():'';this.internal.out(content);delete fieldArray[key];}}; // Public:
	jsPDFAPI.addField = function(fieldObject){ //var opt = parseOptions(fieldObject);
	if(fieldObject instanceof AcroForm.TextField){addTextField.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.ChoiceField){addChoiceField.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.Button){addButton.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.ChildClass){putForm.call(this,fieldObject);}else if(fieldObject){ // try to put..
	putForm.call(this,fieldObject);}fieldObject.page = this.acroformPlugin.internal.getCurrentPageInfo().pageNumber;return this;}; // ############### sort in:
	/**
	     * Button
	     * FT = Btn
	     */var addButton=function addButton(options){var options=options || new AcroForm.Field();options.FT = '/Btn'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 17, Pushbutton
	if(options.pushbutton){ // Options.pushbutton should be 1 or 0
	flags = AcroForm.internal.setBitPosition(flags,17);delete options.pushbutton;} //16, Radio
	if(options.radio){ //flags = options.Ff | options.radio << 15;
	flags = AcroForm.internal.setBitPosition(flags,16);delete options.radio;} // 15, NoToggleToOff (Radio buttons only
	if(options.noToggleToOff){ //flags = options.Ff | options.noToggleToOff << 14;
	flags = AcroForm.internal.setBitPosition(flags,15); //delete options.noToggleToOff;
	} // In case, there is no Flag set, it is a check-box
	options.Ff = flags;putForm.call(this,options);};var addTextField=function addTextField(options){var options=options || new AcroForm.Field();options.FT = '/Tx'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 13, multiline
	if(options.multiline){ // Set Flag
	flags = flags | 1 << 12; // Remove multiline from FieldObject
	//delete options.multiline;
	} // 14, Password
	if(options.password){flags = flags | 1 << 13; //delete options.password;
	} // 21, FileSelect, PDF 1.4...
	if(options.fileSelect){flags = flags | 1 << 20; //delete options.fileSelect;
	} // 23, DoNotSpellCheck, PDF 1.4...
	if(options.doNotSpellCheck){flags = flags | 1 << 22; //delete options.doNotSpellCheck;
	} // 24, DoNotScroll, PDF 1.4...
	if(options.doNotScroll){flags = flags | 1 << 23; //delete options.doNotScroll;
	}options.Ff = options.Ff || flags; // Add field
	putForm.call(this,options);};var addChoiceField=function addChoiceField(opt){var options=opt || new AcroForm.Field();options.FT = '/Ch'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 18, Combo (If not set, the choiceField is a listBox!!)
	if(options.combo){ // Set Flag
	flags = AcroForm.internal.setBitPosition(flags,18); // Remove combo from FieldObject
	delete options.combo;} // 19, Edit
	if(options.edit){flags = AcroForm.internal.setBitPosition(flags,19);delete options.edit;} // 20, Sort
	if(options.sort){flags = AcroForm.internal.setBitPosition(flags,20);delete options.sort;} // 22, MultiSelect (PDF 1.4)
	if(options.multiSelect && this.internal.getPDFVersion() >= 1.4){flags = AcroForm.internal.setBitPosition(flags,22);delete options.multiSelect;} // 23, DoNotSpellCheck (PDF 1.4)
	if(options.doNotSpellCheck && this.internal.getPDFVersion() >= 1.4){flags = AcroForm.internal.setBitPosition(flags,23);delete options.doNotSpellCheck;}options.Ff = flags; //options.hasAnnotation = true;
	// Add field
	putForm.call(this,options);};})(jsPDF.API);var AcroForm=window.AcroForm;AcroForm.internal = {};AcroForm.createFormXObject = function(formObject){var xobj=new AcroForm.FormXObject();var height=AcroForm.Appearance.internal.getHeight(formObject) || 0;var width=AcroForm.Appearance.internal.getWidth(formObject) || 0;xobj.BBox = [0,0,width,height];return xobj;}; // Contains Methods for creating standard appearances
	AcroForm.Appearance = {CheckBox:{createAppearanceStream:function createAppearanceStream(){var appearance={N:{On:AcroForm.Appearance.CheckBox.YesNormal},D:{On:AcroForm.Appearance.CheckBox.YesPushDown,Off:AcroForm.Appearance.CheckBox.OffPushDown}};return appearance;}, /**
	         * If any other icons are needed, the number between the brackets can be changed
	         * @returns {string}
	         */createMK:function createMK(){ // 3-> Hook
	return "<< /CA (3)>>";}, /**
	         * Returns the standard On Appearance for a CheckBox
	         * @returns {AcroForm.FormXObject}
	         */YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream=""; // F13 is ZapfDingbats (Symbolic)
	formObject.Q = 1; // set text-alignment as centered
	var calcRes=AcroForm.internal.calculateX(formObject,"3","ZapfDingbats",50);stream += "0.749023 g\n\
	             0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	             f\n\
	             BMC\n\
	             q\n\
	             0 0 1 rg\n\
	             /F13 " + calcRes.fontSize + " Tf 0 g\n\
	             BT\n";stream += calcRes.text;stream += "ET\n\
	             Q\n\
	             EMC\n";xobj.stream = stream;return xobj;},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";formObject.Q = 1; // set text-alignment as centered
	var calcRes=AcroForm.internal.calculateX(formObject,"3","ZapfDingbats",AcroForm.Appearance.internal.getHeight(formObject) * 0.9);stream += "1 g\n\
	0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	f\n\
	q\n\
	0 0 1 rg\n\
	0 0 " + (AcroForm.Appearance.internal.getWidth(formObject) - 1) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 1) + " re\n\
	W\n\
	n\n\
	0 g\n\
	BT\n\
	/F13 " + calcRes.fontSize + " Tf 0 g\n";stream += calcRes.text;stream += "ET\n\
	             Q\n";xobj.stream = stream;return xobj;}, /**
	         * Returns the standard Off Appearance for a CheckBox
	         * @returns {AcroForm.FormXObject}
	         */OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n";xobj.stream = stream;return xobj;}},RadioButton:{Circle:{createAppearanceStream:function createAppearanceStream(name){var appearanceStreamContent={D:{'Off':AcroForm.Appearance.RadioButton.Circle.OffPushDown},N:{}};appearanceStreamContent.N[name] = AcroForm.Appearance.RadioButton.Circle.YesNormal;appearanceStreamContent.D[name] = AcroForm.Appearance.RadioButton.Circle.YesPushDown;return appearanceStreamContent;},createMK:function createMK(){return "<< /CA (l)>>";},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream=""; // Make the Radius of the Circle relative to min(height, width) of formObject
	var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9;var c=AcroForm.Appearance.internal.Bezier_C; /*
	                 The Following is a Circle created with Bezier-Curves.
	                 */stream += "q\n\
	1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + DotRadius + " 0 m\n\
	" + DotRadius + " " + DotRadius * c + " " + DotRadius * c + " " + DotRadius + " 0 " + DotRadius + " c\n\
	-" + DotRadius * c + " " + DotRadius + " -" + DotRadius + " " + DotRadius * c + " -" + DotRadius + " 0 c\n\
	-" + DotRadius + " -" + DotRadius * c + " -" + DotRadius * c + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	" + DotRadius * c + " -" + DotRadius + " " + DotRadius + " -" + DotRadius * c + " " + DotRadius + " 0 c\n\
	f\n\
	Q\n";xobj.stream = stream;return xobj;},YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9; // Save results for later use; no need to waste processor ticks on doing math
	var k=DotRadius * 2; // var c = AcroForm.Appearance.internal.Bezier_C;
	var kc=k * AcroForm.Appearance.internal.Bezier_C;var dc=DotRadius * AcroForm.Appearance.internal.Bezier_C; //                 stream += "0.749023 g\n\
	//             q\n\
	//           1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius * 2 + " 0 m\n\
	// " + DotRadius * 2 + " " + DotRadius * 2 * c + " " + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 " + DotRadius * 2 + " c\n\
	// -" + DotRadius * 2 * c + " " + DotRadius * 2 + " -" + DotRadius * 2 + " " + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 c\n\
	// -" + DotRadius * 2 + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 -" + DotRadius * 2 + " c\n\
	// " + DotRadius * 2 * c + " -" + DotRadius * 2 + " " + DotRadius * 2 + " -" + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 c\n\
	//             f\n\
	//             Q\n\
	//             0 g\n\
	//             q\n\
	//             1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius + " 0 m\n\
	// " + DotRadius + " " + DotRadius * c + " " + DotRadius * c + " " + DotRadius + " 0 " + DotRadius + " c\n\
	// -" + DotRadius * c + " " + DotRadius + " -" + DotRadius + " " + DotRadius * c + " -" + DotRadius + " 0 c\n\
	// -" + DotRadius + " -" + DotRadius * c + " -" + DotRadius * c + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	// " + DotRadius * c + " -" + DotRadius + " " + DotRadius + " -" + DotRadius * c + " " + DotRadius + " 0 c\n\
	//             f\n\
	//             Q\n";
	//  FASTER VERSION with less processor ticks spent on math operations
	stream += "0.749023 g\n\
	            q\n\
	           1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + k + " 0 m\n\
	" + k + " " + kc + " " + kc + " " + k + " 0 " + k + " c\n\
	-" + kc + " " + k + " -" + k + " " + kc + " -" + k + " 0 c\n\
	-" + k + " -" + kc + " -" + kc + " -" + k + " 0 -" + k + " c\n\
	" + kc + " -" + k + " " + k + " -" + kc + " " + k + " 0 c\n\
	            f\n\
	            Q\n\
	            0 g\n\
	            q\n\
	            1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + DotRadius + " 0 m\n\
	" + DotRadius + " " + dc + " " + dc + " " + DotRadius + " 0 " + DotRadius + " c\n\
	-" + dc + " " + DotRadius + " -" + DotRadius + " " + dc + " -" + DotRadius + " 0 c\n\
	-" + DotRadius + " -" + dc + " -" + dc + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	" + dc + " -" + DotRadius + " " + DotRadius + " -" + dc + " " + DotRadius + " 0 c\n\
	            f\n\
	            Q\n";xobj.stream = stream;return xobj;},OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9; // Save results for later use; no need to waste processor ticks on doing math
	var k=DotRadius * 2; // var c = AcroForm.Appearance.internal.Bezier_C;
	var kc=k * AcroForm.Appearance.internal.Bezier_C; //                 stream += "0.749023 g\n\
	//             q\n\
	//  1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius * 2 + " 0 m\n\
	// " + DotRadius * 2 + " " + DotRadius * 2 * c + " " + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 " + DotRadius * 2 + " c\n\
	// -" + DotRadius * 2 * c + " " + DotRadius * 2 + " -" + DotRadius * 2 + " " + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 c\n\
	// -" + DotRadius * 2 + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 -" + DotRadius * 2 + " c\n\
	// " + DotRadius * 2 * c + " -" + DotRadius * 2 + " " + DotRadius * 2 + " -" + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 c\n\
	//             f\n\
	//             Q\n";
	//  FASTER VERSION with less processor ticks spent on math operations
	stream += "0.749023 g\n\
	            q\n\
	 1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + k + " 0 m\n\
	" + k + " " + kc + " " + kc + " " + k + " 0 " + k + " c\n\
	-" + kc + " " + k + " -" + k + " " + kc + " -" + k + " 0 c\n\
	-" + k + " -" + kc + " -" + kc + " -" + k + " 0 -" + k + " c\n\
	" + kc + " -" + k + " " + k + " -" + kc + " " + k + " 0 c\n\
	            f\n\
	            Q\n";xobj.stream = stream;return xobj;}},Cross:{ /**
	             * Creates the Actual AppearanceDictionary-References
	             * @param name
	             * @returns
	             */createAppearanceStream:function createAppearanceStream(name){var appearanceStreamContent={D:{'Off':AcroForm.Appearance.RadioButton.Cross.OffPushDown},N:{}};appearanceStreamContent.N[name] = AcroForm.Appearance.RadioButton.Cross.YesNormal;appearanceStreamContent.D[name] = AcroForm.Appearance.RadioButton.Cross.YesPushDown;return appearanceStreamContent;},createMK:function createMK(){return "<< /CA (8)>>";},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var cross=AcroForm.Appearance.internal.calculateCross(formObject);stream += "q\n\
	            1 1 " + (AcroForm.Appearance.internal.getWidth(formObject) - 2) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 2) + " re\n\
	            W\n\
	            n\n\
	            " + cross.x1.x + " " + cross.x1.y + " m\n\
	            " + cross.x2.x + " " + cross.x2.y + " l\n\
	            " + cross.x4.x + " " + cross.x4.y + " m\n\
	            " + cross.x3.x + " " + cross.x3.y + " l\n\
	            s\n\
	            Q\n";xobj.stream = stream;return xobj;},YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var cross=AcroForm.Appearance.internal.calculateCross(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n\
	            q\n\
	            1 1 " + (AcroForm.Appearance.internal.getWidth(formObject) - 2) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 2) + " re\n\
	            W\n\
	            n\n\
	            " + cross.x1.x + " " + cross.x1.y + " m\n\
	            " + cross.x2.x + " " + cross.x2.y + " l\n\
	            " + cross.x4.x + " " + cross.x4.y + " m\n\
	            " + cross.x3.x + " " + cross.x3.y + " l\n\
	            s\n\
	            Q\n";xobj.stream = stream;return xobj;},OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n";xobj.stream = stream;return xobj;}}}, /**
	     * Returns the standard Appearance
	     * @returns {AcroForm.FormXObject}
	     */createDefaultAppearanceStream:function createDefaultAppearanceStream(formObject){var stream=""; // Set Helvetica to Standard Font (size: auto)
	// Color: Black
	stream += "/Helv 0 Tf 0 g";return stream;}};AcroForm.Appearance.internal = {Bezier_C:0.551915024494,calculateCross:function calculateCross(formObject){var min=function min(x,y){return x > y?y:x;};var width=AcroForm.Appearance.internal.getWidth(formObject);var height=AcroForm.Appearance.internal.getHeight(formObject);var a=min(width,height);var cross={x1:{ // upperLeft
	x:(width - a) / 2,y:(height - a) / 2 + a //height - borderPadding
	},x2:{ // lowerRight
	x:(width - a) / 2 + a,y:(height - a) / 2 //borderPadding
	},x3:{ // lowerLeft
	x:(width - a) / 2,y:(height - a) / 2 //borderPadding
	},x4:{ // upperRight
	x:(width - a) / 2 + a,y:(height - a) / 2 + a //height - borderPadding
	}};return cross;}};AcroForm.Appearance.internal.getWidth = function(formObject){return formObject.Rect[2]; //(formObject.Rect[2] - formObject.Rect[0]) || 0;
	};AcroForm.Appearance.internal.getHeight = function(formObject){return formObject.Rect[3]; //(formObject.Rect[1] - formObject.Rect[3]) || 0;
	}; // ##########################
	//### For inheritance:
	AcroForm.internal.inherit = function(child,parent){child.prototype = Object.create(parent.prototype);child.prototype.constructor = child;}; // ### Handy Functions:
	AcroForm.internal.arrayToPdfArray = function(array){if(Array.isArray(array)){var content=' [';for(var i in array) {var element=array[i].toString();content += element;content += i < array.length - 1?' ':'';}content += ']';return content;}};AcroForm.internal.toPdfString = function(string){string = string || ""; // put Bracket at the Beginning of the String
	if(string.indexOf('(') !== 0){string = '(' + string;}if(string.substring(string.length - 1) != ')'){string += '(';}return string;}; // ##########################
	//          Classes
	// ##########################
	AcroForm.PDFObject = function(){ // The Object ID in the PDF Object Model
	// todo
	var _objId;Object.defineProperty(this,'objId',{get:function get(){if(!_objId){if(this.internal){_objId = this.internal.newObjectDeferred();}else if(jsPDF.API.acroformPlugin.internal){ // todo - find better option, that doesn't rely on a Global Static var
	_objId = jsPDF.API.acroformPlugin.internal.newObjectDeferred();}}if(!_objId){console.log("Couldn't create Object ID");}return _objId;},configurable:false});};AcroForm.PDFObject.prototype.toString = function(){return this.objId + " 0 R";};AcroForm.PDFObject.prototype.getString = function(){var res=this.objId + " 0 obj\n<<";var content=this.getContent();res += content + ">>\n";if(this.stream){res += "stream\n";res += this.stream;res += "endstream\n";}res += "endobj\n";return res;};AcroForm.PDFObject.prototype.getContent = function(){ /**
	     * Prints out all enumerable Variables from the Object
	     * @param fieldObject
	     * @returns {string}
	     */var createContentFromFieldObject=function createContentFromFieldObject(fieldObject){var content='';var keys=Object.keys(fieldObject).filter(function(key){return key != 'content' && key != 'appearanceStreamContent' && key.substring(0,1) != "_";});for(var i in keys) {var key=keys[i];var value=fieldObject[key]; /*if (key == 'Rect' && value) {
	             value = AcroForm.internal.calculateCoordinates.call(jsPDF.API.acroformPlugin.internal, value);
	             }*/if(value){if(Array.isArray(value)){content += '/' + key + ' ' + AcroForm.internal.arrayToPdfArray(value) + "\n";}else if(value instanceof AcroForm.PDFObject){ // In case it is a reference to another PDFObject, take the referennce number
	content += '/' + key + ' ' + value.objId + " 0 R" + "\n";}else {content += '/' + key + ' ' + value + '\n';}}}return content;};var object="";object += createContentFromFieldObject(this);return object;};AcroForm.FormXObject = function(){AcroForm.PDFObject.call(this);this.Type = "/XObject";this.Subtype = "/Form";this.FormType = 1;this.BBox;this.Matrix;this.Resources = "2 0 R";this.PieceInfo;var _stream;Object.defineProperty(this,'Length',{enumerable:true,get:function get(){return _stream !== undefined?_stream.length:0;}});Object.defineProperty(this,'stream',{enumerable:false,set:function set(val){_stream = val;},get:function get(){if(_stream){return _stream;}else {return null;}}});};AcroForm.internal.inherit(AcroForm.FormXObject,AcroForm.PDFObject);AcroForm.AcroFormDictionary = function(){AcroForm.PDFObject.call(this);var _Kids=[];Object.defineProperty(this,'Kids',{enumerable:false,configurable:true,get:function get(){if(_Kids.length > 0){return _Kids;}else {return;}}});Object.defineProperty(this,'Fields',{enumerable:true,configurable:true,get:function get(){return _Kids;}}); // Default Appearance
	this.DA;};AcroForm.internal.inherit(AcroForm.AcroFormDictionary,AcroForm.PDFObject); // ##### The Objects, the User can Create:
	// The Field Object contains the Variables, that every Field needs
	// Rectangle for Appearance: lower_left_X, lower_left_Y, width, height
	AcroForm.Field = function(){'use strict';AcroForm.PDFObject.call(this);var _Rect;Object.defineProperty(this,'Rect',{enumerable:true,configurable:false,get:function get(){if(!_Rect){return;}var tmp=_Rect; //var calculatedRes = AcroForm.internal.calculateCoordinates(_Rect); // do later!
	return tmp;},set:function set(val){_Rect = val;}});var _FT="";Object.defineProperty(this,'FT',{enumerable:true,set:function set(val){_FT = val;},get:function get(){return _FT;}}); /**
	     * The Partial name of the Field Object.
	     * It has to be unique.
	     */var _T;Object.defineProperty(this,'T',{enumerable:true,configurable:false,set:function set(val){_T = val;},get:function get(){if(!_T || _T.length < 1){if(this instanceof AcroForm.ChildClass){ // In case of a Child from a Radio´Group, you don't need a FieldName!!!
	return;}return "(FieldObject" + AcroForm.Field.FieldNum++ + ")";}if(_T.substring(0,1) == "(" && _T.substring(_T.length - 1)){return _T;}return "(" + _T + ")";}});var _DA; // Defines the default appearance (Needed for variable Text)
	Object.defineProperty(this,'DA',{enumerable:true,get:function get(){if(!_DA){return;}return '(' + _DA + ')';},set:function set(val){_DA = val;}});var _DV; // Defines the default value
	Object.defineProperty(this,'DV',{enumerable:true,configurable:true,get:function get(){if(!_DV){return;}return _DV;},set:function set(val){_DV = val;}}); //this.Type = "/Annot";
	//this.Subtype = "/Widget";
	Object.defineProperty(this,'Type',{enumerable:true,get:function get(){return this.hasAnnotation?"/Annot":null;}});Object.defineProperty(this,'Subtype',{enumerable:true,get:function get(){return this.hasAnnotation?"/Widget":null;}}); /**
	     *
	     * @type {Array}
	     */this.BG;Object.defineProperty(this,'hasAnnotation',{enumerable:false,get:function get(){if(this.Rect || this.BC || this.BG){return true;}return false;}});Object.defineProperty(this,'hasAppearanceStream',{enumerable:false,configurable:true,writable:true});Object.defineProperty(this,'page',{enumerable:false,configurable:true,writable:true});};AcroForm.Field.FieldNum = 0;AcroForm.internal.inherit(AcroForm.Field,AcroForm.PDFObject);AcroForm.ChoiceField = function(){AcroForm.Field.call(this); // Field Type = Choice Field
	this.FT = "/Ch"; // options
	this.Opt = [];this.V = '()'; // Top Index
	this.TI = 0; /**
	     * Defines, whether the
	     * @type {boolean}
	     */this.combo = false; /**
	     * Defines, whether the Choice Field is an Edit Field.
	     * An Edit Field is automatically an Combo Field.
	     */Object.defineProperty(this,'edit',{enumerable:true,set:function set(val){if(val == true){this._edit = true; // ComboBox has to be true
	this.combo = true;}else {this._edit = false;}},get:function get(){if(!this._edit){return false;}return this._edit;},configurable:false});this.hasAppearanceStream = true;Object.defineProperty(this,'V',{get:function get(){AcroForm.internal.toPdfString();}});};AcroForm.internal.inherit(AcroForm.ChoiceField,AcroForm.Field);window["ChoiceField"] = AcroForm.ChoiceField;AcroForm.ListBox = function(){AcroForm.ChoiceField.call(this); //var combo = true;
	};AcroForm.internal.inherit(AcroForm.ListBox,AcroForm.ChoiceField);window["ListBox"] = AcroForm.ListBox;AcroForm.ComboBox = function(){AcroForm.ListBox.call(this);this.combo = true;};AcroForm.internal.inherit(AcroForm.ComboBox,AcroForm.ListBox);window["ComboBox"] = AcroForm.ComboBox;AcroForm.EditBox = function(){AcroForm.ComboBox.call(this);this.edit = true;};AcroForm.internal.inherit(AcroForm.EditBox,AcroForm.ComboBox);window["EditBox"] = AcroForm.EditBox;AcroForm.Button = function(){AcroForm.Field.call(this);this.FT = "/Btn"; //this.hasAnnotation = true;
	};AcroForm.internal.inherit(AcroForm.Button,AcroForm.Field);window["Button"] = AcroForm.Button;AcroForm.PushButton = function(){AcroForm.Button.call(this);this.pushbutton = true;};AcroForm.internal.inherit(AcroForm.PushButton,AcroForm.Button);window["PushButton"] = AcroForm.PushButton;AcroForm.RadioButton = function(){AcroForm.Button.call(this);this.radio = true;var _Kids=[];Object.defineProperty(this,'Kids',{enumerable:true,get:function get(){if(_Kids.length > 0){return _Kids;}}});Object.defineProperty(this,'__Kids',{get:function get(){return _Kids;}});var _noToggleToOff;Object.defineProperty(this,'noToggleToOff',{enumerable:false,get:function get(){return _noToggleToOff;},set:function set(val){_noToggleToOff = val;}}); //this.hasAnnotation = false;
	};AcroForm.internal.inherit(AcroForm.RadioButton,AcroForm.Button);window["RadioButton"] = AcroForm.RadioButton; /*
	 * The Child classs of a RadioButton (the radioGroup)
	 * -> The single Buttons
	 */AcroForm.ChildClass = function(parent,name){AcroForm.Field.call(this);this.Parent = parent; // todo: set AppearanceType as variable that can be set from the outside...
	this._AppearanceType = AcroForm.Appearance.RadioButton.Circle; // The Default appearanceType is the Circle
	this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(name); // Set Print in the Annot Flag
	this.F = AcroForm.internal.setBitPosition(this.F,3,1); // Set AppearanceCharacteristicsDictionary with default appearance if field is not interacting with user
	this.MK = this._AppearanceType.createMK(); // (8) -> Cross, (1)-> Circle, ()-> nothing
	// Default Appearance is Off
	this.AS = "/Off"; // + name;
	this._Name = name;};AcroForm.internal.inherit(AcroForm.ChildClass,AcroForm.Field);AcroForm.RadioButton.prototype.setAppearance = function(appearance){if(!('createAppearanceStream' in appearance && 'createMK' in appearance)){console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");return;}for(var i in this.__Kids) {var child=this.__Kids[i];child.appearanceStreamContent = appearance.createAppearanceStream(child._Name);child.MK = appearance.createMK();}};AcroForm.RadioButton.prototype.createOption = function(name){var parent=this;var child=new AcroForm.ChildClass(parent,name); // Add to Parent
	this.__Kids.push(child);jsPDF.API.addField(child);return child;};AcroForm.CheckBox = function(){Button.call(this);this.appearanceStreamContent = AcroForm.Appearance.CheckBox.createAppearanceStream();this.MK = AcroForm.Appearance.CheckBox.createMK();this.AS = "/On";this.V = "/On";};AcroForm.internal.inherit(AcroForm.CheckBox,AcroForm.Button);window["CheckBox"] = AcroForm.CheckBox;AcroForm.TextField = function(){AcroForm.Field.call(this);this.DA = AcroForm.Appearance.createDefaultAppearanceStream();this.F = 4;var _V;Object.defineProperty(this,'V',{get:function get(){if(_V){return "(" + _V + ")";}else {return _V;}},enumerable:true,set:function set(val){_V = val;}});var _DV;Object.defineProperty(this,'DV',{get:function get(){if(_DV){return "(" + _DV + ")";}else {return _DV;}},enumerable:true,set:function set(val){_DV = val;}});var _multiline=false;Object.defineProperty(this,'multiline',{enumerable:false,get:function get(){return _multiline;},set:function set(val){_multiline = val;}}); //this.multiline = false;
	//this.password = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.fileSelect = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.doNotSpellCheck = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.doNotScroll = false;
	var _MaxLen=false;Object.defineProperty(this,'MaxLen',{enumerable:true,get:function get(){return _MaxLen;},set:function set(val){_MaxLen = val;}});Object.defineProperty(this,'hasAppearanceStream',{enumerable:false,get:function get(){return this.V || this.DV;}});};AcroForm.internal.inherit(AcroForm.TextField,AcroForm.Field);window["TextField"] = AcroForm.TextField;AcroForm.PasswordField = function(){TextField.call(this);Object.defineProperty(this,'password',{value:true,enumerable:false,configurable:false,writable:false});};AcroForm.internal.inherit(AcroForm.PasswordField,AcroForm.TextField);window["PasswordField"] = AcroForm.PasswordField; // ############ internal functions
	/*
	 * small workaround for calculating the TextMetric approximately
	 * @param text
	 * @param fontsize
	 * @returns {TextMetrics} (Has Height and Width)
	 */AcroForm.internal.calculateFontSpace = function(text,fontsize,fonttype){var fonttype=fonttype || "helvetica"; //re-use canvas object for speed improvements
	var canvas=AcroForm.internal.calculateFontSpace.canvas || (AcroForm.internal.calculateFontSpace.canvas = document.createElement('canvas'));var context=canvas.getContext('2d');context.save();var newFont=fontsize + " " + fonttype;context.font = newFont;var res=context.measureText(text);context.fontcolor = 'black'; // Calculate height:
	var context=canvas.getContext('2d');res.height = context.measureText("3").width * 1.5; // 3 because in ZapfDingbats its a Hook and a 3 in normal fonts
	context.restore();return res;};AcroForm.internal.calculateX = function(formObject,text,font,maxFontSize){var maxFontSize=maxFontSize || 12;var font=font || "helvetica";var returnValue={text:"",fontSize:""}; // Remove Brackets
	text = text.substr(0,1) == '('?text.substr(1):text;text = text.substr(text.length - 1) == ')'?text.substr(0,text.length - 1):text; // split into array of words
	var textSplit=text.split(' '); /**
	     * the color could be ((alpha)||(r,g,b)||(c,m,y,k))
	     * @type {string}
	     */var fontSize=maxFontSize; // The Starting fontSize (The Maximum)
	var lineSpacing=2;var borderPadding=2;var height=AcroForm.Appearance.internal.getHeight(formObject) || 0;height = height < 0?-height:height;var width=AcroForm.Appearance.internal.getWidth(formObject) || 0;width = width < 0?-width:width;var isSmallerThanWidth=function isSmallerThanWidth(i,lastLine,fontSize){if(i + 1 < textSplit.length){var tmp=lastLine + " " + textSplit[i + 1];var TextWidth=AcroForm.internal.calculateFontSpace(tmp,fontSize + "px",font).width;var FieldWidth=width - 2 * borderPadding;return TextWidth <= FieldWidth;}else {return false;}};fontSize++;FontSize: while(true) {var text="";fontSize--;var textHeight=AcroForm.internal.calculateFontSpace("3",fontSize + "px",font).height;var startY=formObject.multiline?height - fontSize:(height - textHeight) / 2;startY += lineSpacing;var startX=-borderPadding;var lastX=startX,lastY=startY;var firstWordInLine=0,lastWordInLine=0;var lastLength=0;if(fontSize == 0){ // In case, the Text doesn't fit at all
	fontSize = 12;text = "(...) Tj\n";text += "% Width of Text: " + AcroForm.internal.calculateFontSpace(text,"1px").width + ", FieldWidth:" + width + "\n";break;}lastLength = AcroForm.internal.calculateFontSpace(textSplit[0] + " ",fontSize + "px",font).width;var lastLine="";var lineCount=0;Line: for(var i in textSplit) {lastLine += textSplit[i] + " "; // Remove last blank
	lastLine = lastLine.substr(lastLine.length - 1) == " "?lastLine.substr(0,lastLine.length - 1):lastLine;var key=parseInt(i);lastLength = AcroForm.internal.calculateFontSpace(lastLine + " ",fontSize + "px",font).width;var nextLineIsSmaller=isSmallerThanWidth(key,lastLine,fontSize);var isLastWord=i >= textSplit.length - 1;if(nextLineIsSmaller && !isLastWord){lastLine += " ";continue; // Line
	}else if(!nextLineIsSmaller && !isLastWord){if(!formObject.multiline){continue FontSize;}else {if((textHeight + lineSpacing) * (lineCount + 2) + lineSpacing > height){ // If the Text is higher than the FieldObject
	continue FontSize;}lastWordInLine = key; // go on
	}}else if(isLastWord){lastWordInLine = key;}else {if(formObject.multiline && (textHeight + lineSpacing) * (lineCount + 2) + lineSpacing > height){ // If the Text is higher than the FieldObject
	continue FontSize;}}var line='';for(var x=firstWordInLine;x <= lastWordInLine;x++) {line += textSplit[x] + ' ';} // Remove last blank
	line = line.substr(line.length - 1) == " "?line.substr(0,line.length - 1):line; //lastLength -= blankSpace.width;
	lastLength = AcroForm.internal.calculateFontSpace(line,fontSize + "px",font).width; // Calculate startX
	switch(formObject.Q){case 2: // Right justified
	startX = width - lastLength - borderPadding;break;case 1: // Q = 1 := Text-Alignment: Center
	startX = (width - lastLength) / 2;break;case 0:default:startX = borderPadding;break;}text += startX + ' ' + lastY + ' Td\n';text += '(' + line + ') Tj\n'; // reset X in PDF
	text += -startX + ' 0 Td\n'; // After a Line, adjust y position
	lastY = -(fontSize + lineSpacing);lastLength = 0;firstWordInLine = lastWordInLine + 1;lineCount++;lastLine = "";continue Line;}break;}returnValue.text = text;returnValue.fontSize = fontSize;return returnValue;};AcroForm.internal.calculateAppearanceStream = function(formObject){if(formObject.appearanceStreamContent){ // If appearanceStream is already set, use it
	return formObject.appearanceStreamContent;}if(!formObject.V && !formObject.DV){return;} // else calculate it
	var stream='';var text=formObject.V || formObject.DV;var calcRes=AcroForm.internal.calculateX(formObject,text);stream += '/Tx BMC\n' + 'q\n' +  //color + '\n' +
	'/F1 ' + calcRes.fontSize + ' Tf\n' +  // Text Matrix
	'1 0 0 1 0 0 Tm\n'; // Begin Text
	stream += 'BT\n';stream += calcRes.text; // End Text
	stream += 'ET\n';stream += 'Q\n' + 'EMC\n';var appearanceStreamContent=new AcroForm.createFormXObject(formObject);appearanceStreamContent.stream = stream;return appearanceStreamContent;}; /*
	 * Converts the Parameters from x,y,w,h to lowerLeftX, lowerLeftY, upperRightX, upperRightY
	 * @param x
	 * @param y
	 * @param w
	 * @param h
	 * @returns {*[]}
	 */AcroForm.internal.calculateCoordinates = function(x,y,w,h){var coordinates={};if(this.internal){var mmtopx=function mmtopx(x){return x * this.internal.scaleFactor;};if(Array.isArray(x)){x[0] = AcroForm.scale(x[0]);x[1] = AcroForm.scale(x[1]);x[2] = AcroForm.scale(x[2]);x[3] = AcroForm.scale(x[3]);coordinates.lowerLeft_X = x[0] || 0;coordinates.lowerLeft_Y = mmtopx.call(this,this.internal.pageSize.height) - x[3] - x[1] || 0;coordinates.upperRight_X = x[0] + x[2] || 0;coordinates.upperRight_Y = mmtopx.call(this,this.internal.pageSize.height) - x[1] || 0;}else {x = AcroForm.scale(x);y = AcroForm.scale(y);w = AcroForm.scale(w);h = AcroForm.scale(h);coordinates.lowerLeft_X = x || 0;coordinates.lowerLeft_Y = this.internal.pageSize.height - y || 0;coordinates.upperRight_X = x + w || 0;coordinates.upperRight_Y = this.internal.pageSize.height - y + h || 0;}}else { // old method, that is fallback, if we can't get the pageheight, the coordinate-system starts from lower left
	if(Array.isArray(x)){coordinates.lowerLeft_X = x[0] || 0;coordinates.lowerLeft_Y = x[1] || 0;coordinates.upperRight_X = x[0] + x[2] || 0;coordinates.upperRight_Y = x[1] + x[3] || 0;}else {coordinates.lowerLeft_X = x || 0;coordinates.lowerLeft_Y = y || 0;coordinates.upperRight_X = x + w || 0;coordinates.upperRight_Y = y + h || 0;}}return [coordinates.lowerLeft_X,coordinates.lowerLeft_Y,coordinates.upperRight_X,coordinates.upperRight_Y];};AcroForm.internal.calculateColor = function(r,g,b){var color=new Array(3);color.r = r | 0;color.g = g | 0;color.b = b | 0;return color;};AcroForm.internal.getBitPosition = function(variable,position){variable = variable || 0;var bitMask=1;bitMask = bitMask << position - 1;return variable | bitMask;};AcroForm.internal.setBitPosition = function(variable,position,value){variable = variable || 0;value = value || 1;var bitMask=1;bitMask = bitMask << position - 1;if(value == 1){ // Set the Bit to 1
	var variable=variable | bitMask;}else { // Set the Bit to 0
	var variable=variable & ~bitMask;}return variable;}; /**
	 * jsPDF addHTML PlugIn
	 * Copyright (c) 2014 Diego Casorran
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(function(jsPDFAPI){'use strict'; /**
	  * Renders an HTML element to canvas object which added to the PDF
	  *
	  * This feature requires [html2canvas](https://github.com/niklasvh/html2canvas)
	  * or [rasterizeHTML](https://github.com/cburgmer/rasterizeHTML.js)
	  *
	  * @returns {jsPDF}
	  * @name addHTML
	  * @param element {Mixed} HTML Element, or anything supported by html2canvas.
	  * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	  * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	  * @param options {Object} Additional options, check the code below.
	  * @param callback {Function} to call when the rendering has finished.
	  * NOTE: Every parameter is optional except 'element' and 'callback', in such
	  *       case the image is positioned at 0x0 covering the whole PDF document
	  *       size. Ie, to easily take screenshots of webpages saving them to PDF.
	  * @deprecated This is being replace with a vector-supporting API. See
	  * [this link](https://cdn.rawgit.com/MrRio/jsPDF/master/examples/html2pdf/showcase_supported_html.html)
	  */jsPDFAPI.addHTML = function(element,x,y,options,callback){'use strict';if(typeof html2canvas === 'undefined' && typeof rasterizeHTML === 'undefined')throw new Error('You need either ' + 'https://github.com/niklasvh/html2canvas' + ' or https://github.com/cburgmer/rasterizeHTML.js');if(typeof x !== 'number'){options = x;callback = y;}if(typeof options === 'function'){callback = options;options = null;}var I=this.internal,K=I.scaleFactor,W=I.pageSize.width,H=I.pageSize.height;options = options || {};options.onrendered = (function(obj){x = parseInt(x) || 0;y = parseInt(y) || 0;var dim=options.dim || {};var h=dim.h || 0;var w=dim.w || Math.min(W,obj.width / K) - x;var format='JPEG';if(options.format)format = options.format;if(obj.height > H && options.pagesplit){var crop=(function(){var cy=0;while(1) {var canvas=document.createElement('canvas');canvas.width = Math.min(W * K,obj.width);canvas.height = Math.min(H * K,obj.height - cy);var ctx=canvas.getContext('2d');ctx.drawImage(obj,0,cy,obj.width,canvas.height,0,0,canvas.width,canvas.height);var args=[canvas,x,cy?0:y,canvas.width / K,canvas.height / K,format,null,'SLOW'];this.addImage.apply(this,args);cy += canvas.height;if(cy >= obj.height)break;this.addPage();}callback(w,cy,null,args);}).bind(this);if(obj.nodeName === 'CANVAS'){var img=new Image();img.onload = crop;img.src = obj.toDataURL("image/png");obj = img;}else {crop();}}else {var alias=Math.random().toString(35);var args=[obj,x,y,w,h,format,alias,'SLOW'];this.addImage.apply(this,args);callback(w,h,alias,args);}}).bind(this);if(typeof html2canvas !== 'undefined' && !options.rstz){return html2canvas(element,options);}if(typeof rasterizeHTML !== 'undefined'){var meth='drawDocument';if(typeof element === 'string'){meth = /^http/.test(element)?'drawURL':'drawHTML';}options.width = options.width || W * K;return rasterizeHTML[meth](element,void 0,options).then(function(r){options.onrendered(r.image);},function(e){callback(null,e);});}return null;};})(jsPDF.API); /** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 */(function(jsPDFAPI){'use strict';var namespace='addImage_',supported_image_types=['jpeg','jpg','png']; // Image functionality ported from pdf.js
	var putImage=function putImage(img){var objectNumber=this.internal.newObject(),out=this.internal.write,putStream=this.internal.putStream;img['n'] = objectNumber;out('<</Type /XObject');out('/Subtype /Image');out('/Width ' + img['w']);out('/Height ' + img['h']);if(img['cs'] === this.color_spaces.INDEXED){out('/ColorSpace [/Indexed /DeviceRGB ' // if an indexed png defines more than one colour with transparency, we've created a smask
	 + (img['pal'].length / 3 - 1) + ' ' + ('smask' in img?objectNumber + 2:objectNumber + 1) + ' 0 R]');}else {out('/ColorSpace /' + img['cs']);if(img['cs'] === this.color_spaces.DEVICE_CMYK){out('/Decode [1 0 1 0 1 0 1 0]');}}out('/BitsPerComponent ' + img['bpc']);if('f' in img){out('/Filter /' + img['f']);}if('dp' in img){out('/DecodeParms <<' + img['dp'] + '>>');}if('trns' in img && img['trns'].constructor == Array){var trns='',i=0,len=img['trns'].length;for(;i < len;i++) {trns += img['trns'][i] + ' ' + img['trns'][i] + ' ';}out('/Mask [' + trns + ']');}if('smask' in img){out('/SMask ' + (objectNumber + 1) + ' 0 R');}out('/Length ' + img['data'].length + '>>');putStream(img['data']);out('endobj'); // Soft mask
	if('smask' in img){var dp='/Predictor ' + img['p'] + ' /Colors 1 /BitsPerComponent ' + img['bpc'] + ' /Columns ' + img['w'];var smask={'w':img['w'],'h':img['h'],'cs':'DeviceGray','bpc':img['bpc'],'dp':dp,'data':img['smask']};if('f' in img)smask.f = img['f'];putImage.call(this,smask);} //Palette
	if(img['cs'] === this.color_spaces.INDEXED){this.internal.newObject(); //out('<< /Filter / ' + img['f'] +' /Length ' + img['pal'].length + '>>');
	//putStream(zlib.compress(img['pal']));
	out('<< /Length ' + img['pal'].length + '>>');putStream(this.arrayBufferToBinaryString(new Uint8Array(img['pal'])));out('endobj');}},putResourcesCallback=function putResourcesCallback(){var images=this.internal.collections[namespace + 'images'];for(var i in images) {putImage.call(this,images[i]);}},putXObjectsDictCallback=function putXObjectsDictCallback(){var images=this.internal.collections[namespace + 'images'],out=this.internal.write,image;for(var i in images) {image = images[i];out('/I' + image['i'],image['n'],'0','R');}},checkCompressValue=function checkCompressValue(value){if(value && typeof value === 'string')value = value.toUpperCase();return value in jsPDFAPI.image_compression?value:jsPDFAPI.image_compression.NONE;},getImages=function getImages(){var images=this.internal.collections[namespace + 'images']; //first run, so initialise stuff
	if(!images){this.internal.collections[namespace + 'images'] = images = {};this.internal.events.subscribe('putResources',putResourcesCallback);this.internal.events.subscribe('putXobjectDict',putXObjectsDictCallback);}return images;},getImageIndex=function getImageIndex(images){var imageIndex=0;if(images){ // this is NOT the first time this method is ran on this instance of jsPDF object.
	imageIndex = Object.keys?Object.keys(images).length:(function(o){var i=0;for(var e in o) {if(o.hasOwnProperty(e)){i++;}}return i;})(images);}return imageIndex;},notDefined=function notDefined(value){return typeof value === 'undefined' || value === null;},generateAliasFromData=function generateAliasFromData(data){return typeof data === 'string' && jsPDFAPI.sHashCode(data);},doesNotSupportImageType=function doesNotSupportImageType(type){return supported_image_types.indexOf(type) === -1;},processMethodNotEnabled=function processMethodNotEnabled(type){return typeof jsPDFAPI['process' + type.toUpperCase()] !== 'function';},isDOMElement=function isDOMElement(object){return (typeof object === 'undefined'?'undefined':_typeof(object)) === 'object' && object.nodeType === 1;},createDataURIFromElement=function createDataURIFromElement(element,format,angle){ //if element is an image which uses data url definition, just return the dataurl
	if(element.nodeName === 'IMG' && element.hasAttribute('src')){var src='' + element.getAttribute('src');if(!angle && src.indexOf('data:image/') === 0)return src; // only if the user doesn't care about a format
	if(!format && /\.png(?:[?#].*)?$/i.test(src))format = 'png';}if(element.nodeName === 'CANVAS'){var canvas=element;}else {var canvas=document.createElement('canvas');canvas.width = element.clientWidth || element.width;canvas.height = element.clientHeight || element.height;var ctx=canvas.getContext('2d');if(!ctx){throw 'addImage requires canvas to be supported by browser.';}if(angle){var x,y,b,c,s,w,h,to_radians=Math.PI / 180,angleInRadians;if((typeof angle === 'undefined'?'undefined':_typeof(angle)) === 'object'){x = angle.x;y = angle.y;b = angle.bg;angle = angle.angle;}angleInRadians = angle * to_radians;c = Math.abs(Math.cos(angleInRadians));s = Math.abs(Math.sin(angleInRadians));w = canvas.width;h = canvas.height;canvas.width = h * s + w * c;canvas.height = h * c + w * s;if(isNaN(x))x = canvas.width / 2;if(isNaN(y))y = canvas.height / 2;ctx.clearRect(0,0,canvas.width,canvas.height);ctx.fillStyle = b || 'white';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.save();ctx.translate(x,y);ctx.rotate(angleInRadians);ctx.drawImage(element,-(w / 2),-(h / 2));ctx.rotate(-angleInRadians);ctx.translate(-x,-y);ctx.restore();}else {ctx.drawImage(element,0,0,canvas.width,canvas.height);}}return canvas.toDataURL(('' + format).toLowerCase() == 'png'?'image/png':'image/jpeg');},checkImagesForAlias=function checkImagesForAlias(alias,images){var cached_info;if(images){for(var e in images) {if(alias === images[e].alias){cached_info = images[e];break;}}}return cached_info;},determineWidthAndHeight=function determineWidthAndHeight(w,h,info){if(!w && !h){w = -96;h = -96;}if(w < 0){w = -1 * info['w'] * 72 / w / this.internal.scaleFactor;}if(h < 0){h = -1 * info['h'] * 72 / h / this.internal.scaleFactor;}if(w === 0){w = h * info['w'] / info['h'];}if(h === 0){h = w * info['h'] / info['w'];}return [w,h];},writeImageToPDF=function writeImageToPDF(x,y,w,h,info,index,images){var dims=determineWidthAndHeight.call(this,w,h,info),coord=this.internal.getCoordinateString,vcoord=this.internal.getVerticalCoordinateString;w = dims[0];h = dims[1];images[index] = info;this.internal.write('q',coord(w),'0 0',coord(h), // TODO: check if this should be shifted by vcoord
	coord(x),vcoord(y + h),'cm /I' + info['i'],'Do Q');}; /**
	  * COLOR SPACES
	  */jsPDFAPI.color_spaces = {DEVICE_RGB:'DeviceRGB',DEVICE_GRAY:'DeviceGray',DEVICE_CMYK:'DeviceCMYK',CAL_GREY:'CalGray',CAL_RGB:'CalRGB',LAB:'Lab',ICC_BASED:'ICCBased',INDEXED:'Indexed',PATTERN:'Pattern',SEPARATION:'Separation',DEVICE_N:'DeviceN'}; /**
	  * DECODE METHODS
	  */jsPDFAPI.decode = {DCT_DECODE:'DCTDecode',FLATE_DECODE:'FlateDecode',LZW_DECODE:'LZWDecode',JPX_DECODE:'JPXDecode',JBIG2_DECODE:'JBIG2Decode',ASCII85_DECODE:'ASCII85Decode',ASCII_HEX_DECODE:'ASCIIHexDecode',RUN_LENGTH_DECODE:'RunLengthDecode',CCITT_FAX_DECODE:'CCITTFaxDecode'}; /**
	  * IMAGE COMPRESSION TYPES
	  */jsPDFAPI.image_compression = {NONE:'NONE',FAST:'FAST',MEDIUM:'MEDIUM',SLOW:'SLOW'};jsPDFAPI.sHashCode = function(str){return Array.prototype.reduce && str.split("").reduce(function(a,b){a = (a << 5) - a + b.charCodeAt(0);return a & a;},0);};jsPDFAPI.isString = function(object){return typeof object === 'string';}; /**
	  * Strips out and returns info from a valid base64 data URI
	  * @param {String[dataURI]} a valid data URI of format 'data:[<MIME-type>][;base64],<data>'
	  * @returns an Array containing the following
	  * [0] the complete data URI
	  * [1] <MIME-type>
	  * [2] format - the second part of the mime-type i.e 'png' in 'image/png'
	  * [4] <data>
	  */jsPDFAPI.extractInfoFromBase64DataURI = function(dataURI){return (/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(dataURI));}; /**
	  * Check to see if ArrayBuffer is supported
	  */jsPDFAPI.supportsArrayBuffer = function(){return typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';}; /**
	  * Tests supplied object to determine if ArrayBuffer
	  * @param {Object[object]}
	  */jsPDFAPI.isArrayBuffer = function(object){if(!this.supportsArrayBuffer())return false;return object instanceof ArrayBuffer;}; /**
	  * Tests supplied object to determine if it implements the ArrayBufferView (TypedArray) interface
	  * @param {Object[object]}
	  */jsPDFAPI.isArrayBufferView = function(object){if(!this.supportsArrayBuffer())return false;if(typeof Uint32Array === 'undefined')return false;return object instanceof Int8Array || object instanceof Uint8Array || typeof Uint8ClampedArray !== 'undefined' && object instanceof Uint8ClampedArray || object instanceof Int16Array || object instanceof Uint16Array || object instanceof Int32Array || object instanceof Uint32Array || object instanceof Float32Array || object instanceof Float64Array;}; /**
	  * Exactly what it says on the tin
	  */jsPDFAPI.binaryStringToUint8Array = function(binary_string){ /*
	   * not sure how efficient this will be will bigger files. Is there a native method?
	   */var len=binary_string.length;var bytes=new Uint8Array(len);for(var i=0;i < len;i++) {bytes[i] = binary_string.charCodeAt(i);}return bytes;}; /**
	  * Convert the Buffer to a Binary String
	  */jsPDFAPI.arrayBufferToBinaryString = function(buffer){if(typeof window.atob === "function"){return atob(this.arrayBufferToBase64(buffer));}else {var data=this.isArrayBuffer(buffer)?buffer:new Uint8Array(buffer);var chunkSizeForSlice=0x5000;var binary_string='';var slicesCount=Math.round(data.byteLength / chunkSizeForSlice);for(var i=0;i < slicesCount;i++) {binary_string += String.fromCharCode.apply(null,data.slice(i * chunkSizeForSlice,i * chunkSizeForSlice + chunkSizeForSlice));}return binary_string;}}; /**
	  * Converts an ArrayBuffer directly to base64
	  *
	  * Taken from here
	  *
	  * http://jsperf.com/encoding-xhr-image-data/31
	  *
	  * Need to test if this is a better solution for larger files
	  *
	  */jsPDFAPI.arrayBufferToBase64 = function(arrayBuffer){var base64='';var encodings='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';var bytes=new Uint8Array(arrayBuffer);var byteLength=bytes.byteLength;var byteRemainder=byteLength % 3;var mainLength=byteLength - byteRemainder;var a,b,c,d;var chunk; // Main loop deals with bytes in chunks of 3
	for(var i=0;i < mainLength;i = i + 3) { // Combine the three bytes into a single integer
	chunk = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2]; // Use bitmasks to extract 6-bit segments from the triplet
	a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
	b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
	c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
	d = chunk & 63; // 63       = 2^6 - 1
	// Convert the raw binary segments to the appropriate ASCII encoding
	base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];} // Deal with the remaining bytes and padding
	if(byteRemainder == 1){chunk = bytes[mainLength];a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
	// Set the 4 least significant bits to zero
	b = (chunk & 3) << 4; // 3   = 2^2 - 1
	base64 += encodings[a] + encodings[b] + '==';}else if(byteRemainder == 2){chunk = bytes[mainLength] << 8 | bytes[mainLength + 1];a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
	b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
	// Set the 2 least significant bits to zero
	c = (chunk & 15) << 2; // 15    = 2^4 - 1
	base64 += encodings[a] + encodings[b] + encodings[c] + '=';}return base64;};jsPDFAPI.createImageInfo = function(data,wd,ht,cs,bpc,f,imageIndex,alias,dp,trns,pal,smask,p){var info={alias:alias,w:wd,h:ht,cs:cs,bpc:bpc,i:imageIndex,data:data // n: objectNumber will be added by putImage code
	};if(f)info.f = f;if(dp)info.dp = dp;if(trns)info.trns = trns;if(pal)info.pal = pal;if(smask)info.smask = smask;if(p)info.p = p; // predictor parameter for PNG compression
	return info;};jsPDFAPI.addImage = function(imageData,format,x,y,w,h,alias,compression,rotation){'use strict';if(typeof format !== 'string'){var tmp=h;h = w;w = y;y = x;x = format;format = tmp;}if((typeof imageData === 'undefined'?'undefined':_typeof(imageData)) === 'object' && !isDOMElement(imageData) && "imageData" in imageData){var options=imageData;imageData = options.imageData;format = options.format || format;x = options.x || x || 0;y = options.y || y || 0;w = options.w || w;h = options.h || h;alias = options.alias || alias;compression = options.compression || compression;rotation = options.rotation || options.angle || rotation;}if(isNaN(x) || isNaN(y)){console.error('jsPDF.addImage: Invalid coordinates',arguments);throw new Error('Invalid coordinates passed to jsPDF.addImage');}var images=getImages.call(this),info;if(!(info = checkImagesForAlias(imageData,images))){var dataAsBinaryString;if(isDOMElement(imageData))imageData = createDataURIFromElement(imageData,format,rotation);if(notDefined(alias))alias = generateAliasFromData(imageData);if(!(info = checkImagesForAlias(alias,images))){if(this.isString(imageData)){var base64Info=this.extractInfoFromBase64DataURI(imageData);if(base64Info){format = base64Info[2];imageData = atob(base64Info[3]); //convert to binary string
	}else {if(imageData.charCodeAt(0) === 0x89 && imageData.charCodeAt(1) === 0x50 && imageData.charCodeAt(2) === 0x4e && imageData.charCodeAt(3) === 0x47)format = 'png';}}format = (format || 'JPEG').toLowerCase();if(doesNotSupportImageType(format))throw new Error('addImage currently only supports formats ' + supported_image_types + ', not \'' + format + '\'');if(processMethodNotEnabled(format))throw new Error('please ensure that the plugin for \'' + format + '\' support is added'); /**
	     * need to test if it's more efficient to convert all binary strings
	     * to TypedArray - or should we just leave and process as string?
	     */if(this.supportsArrayBuffer()){ // no need to convert if imageData is already uint8array
	if(!(imageData instanceof Uint8Array)){dataAsBinaryString = imageData;imageData = this.binaryStringToUint8Array(imageData);}}info = this['process' + format.toUpperCase()](imageData,getImageIndex(images),alias,checkCompressValue(compression),dataAsBinaryString);if(!info)throw new Error('An unkwown error occurred whilst processing the image');}}writeImageToPDF.call(this,x,y,w,h,info,info.i,images);return this;}; /**
	  * JPEG SUPPORT
	  **/ //takes a string imgData containing the raw bytes of
	//a jpeg image and returns [width, height]
	//Algorithm from: http://www.64lines.com/jpeg-width-height
	var getJpegSize=function getJpegSize(imgData){'use strict';var width,height,numcomponents; // Verify we have a valid jpeg header 0xff,0xd8,0xff,0xe0,?,?,'J','F','I','F',0x00
	if(!imgData.charCodeAt(0) === 0xff || !imgData.charCodeAt(1) === 0xd8 || !imgData.charCodeAt(2) === 0xff || !imgData.charCodeAt(3) === 0xe0 || !imgData.charCodeAt(6) === 'J'.charCodeAt(0) || !imgData.charCodeAt(7) === 'F'.charCodeAt(0) || !imgData.charCodeAt(8) === 'I'.charCodeAt(0) || !imgData.charCodeAt(9) === 'F'.charCodeAt(0) || !imgData.charCodeAt(10) === 0x00){throw new Error('getJpegSize requires a binary string jpeg file');}var blockLength=imgData.charCodeAt(4) * 256 + imgData.charCodeAt(5);var i=4,len=imgData.length;while(i < len) {i += blockLength;if(imgData.charCodeAt(i) !== 0xff){throw new Error('getJpegSize could not find the size of the image');}if(imgData.charCodeAt(i + 1) === 0xc0 ||  //(SOF) Huffman  - Baseline DCT
	imgData.charCodeAt(i + 1) === 0xc1 ||  //(SOF) Huffman  - Extended sequential DCT
	imgData.charCodeAt(i + 1) === 0xc2 ||  // Progressive DCT (SOF2)
	imgData.charCodeAt(i + 1) === 0xc3 ||  // Spatial (sequential) lossless (SOF3)
	imgData.charCodeAt(i + 1) === 0xc4 ||  // Differential sequential DCT (SOF5)
	imgData.charCodeAt(i + 1) === 0xc5 ||  // Differential progressive DCT (SOF6)
	imgData.charCodeAt(i + 1) === 0xc6 ||  // Differential spatial (SOF7)
	imgData.charCodeAt(i + 1) === 0xc7){height = imgData.charCodeAt(i + 5) * 256 + imgData.charCodeAt(i + 6);width = imgData.charCodeAt(i + 7) * 256 + imgData.charCodeAt(i + 8);numcomponents = imgData.charCodeAt(i + 9);return [width,height,numcomponents];}else {i += 2;blockLength = imgData.charCodeAt(i) * 256 + imgData.charCodeAt(i + 1);}}},getJpegSizeFromBytes=function getJpegSizeFromBytes(data){var hdr=data[0] << 8 | data[1];if(hdr !== 0xFFD8)throw new Error('Supplied data is not a JPEG');var len=data.length,block=(data[4] << 8) + data[5],pos=4,bytes,width,height,numcomponents;while(pos < len) {pos += block;bytes = readBytes(data,pos);block = (bytes[2] << 8) + bytes[3];if((bytes[1] === 0xC0 || bytes[1] === 0xC2) && bytes[0] === 0xFF && block > 7){bytes = readBytes(data,pos + 5);width = (bytes[2] << 8) + bytes[3];height = (bytes[0] << 8) + bytes[1];numcomponents = bytes[4];return {width:width,height:height,numcomponents:numcomponents};}pos += 2;}throw new Error('getJpegSizeFromBytes could not find the size of the image');},readBytes=function readBytes(data,offset){return data.subarray(offset,offset + 5);};jsPDFAPI.processJPEG = function(data,index,alias,compression,dataAsBinaryString){'use strict';var colorSpace=this.color_spaces.DEVICE_RGB,filter=this.decode.DCT_DECODE,bpc=8,dims;if(this.isString(data)){dims = getJpegSize(data);return this.createImageInfo(data,dims[0],dims[1],dims[3] == 1?this.color_spaces.DEVICE_GRAY:colorSpace,bpc,filter,index,alias);}if(this.isArrayBuffer(data))data = new Uint8Array(data);if(this.isArrayBufferView(data)){dims = getJpegSizeFromBytes(data); // if we already have a stored binary string rep use that
	data = dataAsBinaryString || this.arrayBufferToBinaryString(data);return this.createImageInfo(data,dims.width,dims.height,dims.numcomponents == 1?this.color_spaces.DEVICE_GRAY:colorSpace,bpc,filter,index,alias);}return null;};jsPDFAPI.processJPG = function() /*data, index, alias, compression, dataAsBinaryString*/{return this.processJPEG.apply(this,arguments);};})(jsPDF.API); /**
	 * jsPDF Annotations PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * There are many types of annotations in a PDF document. Annotations are placed
	 * on a page at a particular location. They are not 'attached' to an object.
	 * <br />
	 * This plugin current supports <br />
	 * <li> Goto Page (set pageNumber and top in options)
	 * <li> Goto Name (set name and top in options)
	 * <li> Goto URL (set url in options)
	 * <p>
	 * 	The destination magnification factor can also be specified when goto is a page number or a named destination. (see documentation below)
	 *  (set magFactor in options).  XYZ is the default.
	 * </p>
	 * <p>
	 *  Links, Text, Popup, and FreeText are supported.
	 * </p>
	 * <p>
	 * Options In PDF spec Not Implemented Yet
	 * <li> link border
	 * <li> named target
	 * <li> page coordinates
	 * <li> destination page scaling and layout
	 * <li> actions other than URL and GotoPage
	 * <li> background / hover actions
	 * </p>
	 */ /*
	    Destination Magnification Factors
	    See PDF 1.3 Page 386 for meanings and options
	
	    [supported]
		XYZ (options; left top zoom)
		Fit (no options)
		FitH (options: top)
		FitV (options: left)
	
		[not supported]
		FitR
		FitB
		FitBH
		FitBV
	 */(function(jsPDFAPI){'use strict';var annotationPlugin={ /**
	   * An array of arrays, indexed by <em>pageNumber</em>.
	   */annotations:[],f2:function f2(number){return number.toFixed(2);},notEmpty:function notEmpty(obj){if(typeof obj != 'undefined'){if(obj != ''){return true;}}}};jsPDF.API.annotationPlugin = annotationPlugin;jsPDF.API.events.push(['addPage',function(info){this.annotationPlugin.annotations[info.pageNumber] = [];}]);jsPDFAPI.events.push(['putPage',function(info){ //TODO store annotations in pageContext so reorder/remove will not affect them.
	var pageAnnos=this.annotationPlugin.annotations[info.pageNumber];var found=false;for(var a=0;a < pageAnnos.length && !found;a++) {var anno=pageAnnos[a];switch(anno.type){case 'link':if(annotationPlugin.notEmpty(anno.options.url) || annotationPlugin.notEmpty(anno.options.pageNumber)){found = true;break;}case 'reference':case 'text':case 'freetext':found = true;break;}}if(found == false){return;}this.internal.write("/Annots [");var f2=this.annotationPlugin.f2;var k=this.internal.scaleFactor;var pageHeight=this.internal.pageSize.height;var pageInfo=this.internal.getPageInfo(info.pageNumber);for(var a=0;a < pageAnnos.length;a++) {var anno=pageAnnos[a];switch(anno.type){case 'reference': // References to Widget Anotations (for AcroForm Fields)
	this.internal.write(' ' + anno.object.objId + ' 0 R ');break;case 'text': // Create a an object for both the text and the popup
	var objText=this.internal.newAdditionalObject();var objPopup=this.internal.newAdditionalObject();var title=anno.title || 'Note';var rect="/Rect [" + f2(anno.bounds.x * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + " " + f2((anno.bounds.x + anno.bounds.w) * k) + " " + f2((pageHeight - anno.bounds.y) * k) + "] ";line = '<</Type /Annot /Subtype /' + 'Text' + ' ' + rect + '/Contents (' + anno.contents + ')';line += ' /Popup ' + objPopup.objId + " 0 R";line += ' /P ' + pageInfo.objId + " 0 R";line += ' /T (' + title + ') >>';objText.content = line;var parent=objText.objId + ' 0 R';var popoff=30;var rect="/Rect [" + f2((anno.bounds.x + popoff) * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + " " + f2((anno.bounds.x + anno.bounds.w + popoff) * k) + " " + f2((pageHeight - anno.bounds.y) * k) + "] "; //var rect2 = "/Rect [" + f2(anno.bounds.x * k) + " " + f2((pageHeight - anno.bounds.y) * k) + " " + f2(anno.bounds.x + anno.bounds.w * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + "] ";
	line = '<</Type /Annot /Subtype /' + 'Popup' + ' ' + rect + ' /Parent ' + parent;if(anno.open){line += ' /Open true';}line += ' >>';objPopup.content = line;this.internal.write(objText.objId,'0 R',objPopup.objId,'0 R');break;case 'freetext':var rect="/Rect [" + f2(anno.bounds.x * k) + " " + f2((pageHeight - anno.bounds.y) * k) + " " + f2(anno.bounds.x + anno.bounds.w * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + "] ";var color=anno.color || '#000000';line = '<</Type /Annot /Subtype /' + 'FreeText' + ' ' + rect + '/Contents (' + anno.contents + ')';line += ' /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#' + color + ')';line += ' /Border [0 0 0]';line += ' >>';this.internal.write(line);break;case 'link':if(anno.options.name){var loc=this.annotations._nameMap[anno.options.name];anno.options.pageNumber = loc.page;anno.options.top = loc.y;}else {if(!anno.options.top){anno.options.top = 0;}}var rect="/Rect [" + f2(anno.x * k) + " " + f2((pageHeight - anno.y) * k) + " " + f2((anno.x + anno.w) * k) + " " + f2((pageHeight - (anno.y + anno.h)) * k) + "] ";var line='';if(anno.options.url){line = '<</Type /Annot /Subtype /Link ' + rect + '/Border [0 0 0] /A <</S /URI /URI (' + anno.options.url + ') >>';}else if(anno.options.pageNumber){ // first page is 0
	var info=this.internal.getPageInfo(anno.options.pageNumber);line = '<</Type /Annot /Subtype /Link ' + rect + '/Border [0 0 0] /Dest [' + info.objId + " 0 R";anno.options.magFactor = anno.options.magFactor || "XYZ";switch(anno.options.magFactor){case 'Fit':line += ' /Fit]';break;case 'FitH': //anno.options.top = anno.options.top || f2(pageHeight * k);
	line += ' /FitH ' + anno.options.top + ']';break;case 'FitV':anno.options.left = anno.options.left || 0;line += ' /FitV ' + anno.options.left + ']';break;case 'XYZ':default:var top=f2((pageHeight - anno.options.top) * k); // || f2(pageHeight * k);
	anno.options.left = anno.options.left || 0; // 0 or null zoom will not change zoom factor
	if(typeof anno.options.zoom === 'undefined'){anno.options.zoom = 0;}line += ' /XYZ ' + anno.options.left + ' ' + top + ' ' + anno.options.zoom + ']';break;}}else { // TODO error - should not be here
	}if(line != ''){line += " >>";this.internal.write(line);}break;}}this.internal.write("]");}]);jsPDFAPI.createAnnotation = function(options){switch(options.type){case 'link':this.link(options.bounds.x,options.bounds.y,options.bounds.w,options.bounds.h,options);break;case 'text':case 'freetext':this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(options);break;}}; /**
	  * valid options
	  * <li> pageNumber or url [required]
	  * <p>If pageNumber is specified, top and zoom may also be specified</p>
	  */jsPDFAPI.link = function(x,y,w,h,options){'use strict';this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:x,y:y,w:w,h:h,options:options,type:'link'});}; /**
	  * Currently only supports single line text.
	  * Returns the width of the text/link
	  */jsPDFAPI.textWithLink = function(text,x,y,options){'use strict';var width=this.getTextWidth(text);var height=this.internal.getLineHeight() / this.internal.scaleFactor;this.text(text,x,y); //TODO We really need the text baseline height to do this correctly.
	// Or ability to draw text on top, bottom, center, or baseline.
	y += height * .2;this.link(x,y - height,width,height,options);return width;}; //TODO move into external library
	jsPDFAPI.getTextWidth = function(text){'use strict';var fontSize=this.internal.getFontSize();var txtWidth=this.getStringUnitWidth(text) * fontSize / this.internal.scaleFactor;return txtWidth;}; //TODO move into external library
	jsPDFAPI.getLineHeight = function(){return this.internal.getLineHeight();};return this;})(jsPDF.API); /**
	 * jsPDF Autoprint Plugin
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	* Makes the PDF automatically print. This works in Chrome, Firefox, Acrobat
	* Reader.
	*
	* @returns {jsPDF}
	* @name autoPrint
	* @example
	* var doc = new jsPDF()
	* doc.text(10, 10, 'This is a test')
	* doc.autoPrint()
	* doc.save('autoprint.pdf')
	*/(function(jsPDFAPI){'use strict';jsPDFAPI.autoPrint = function(){'use strict';var refAutoPrintTag;this.internal.events.subscribe('postPutResources',function(){refAutoPrintTag = this.internal.newObject();this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj");});this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");});return this;};})(jsPDF.API); /**
	 * jsPDF Canvas PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * This plugin mimics the HTML5 Canvas
	 * 
	 * The goal is to provide a way for current canvas users to print directly to a PDF.
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['initialized',function(){this.canvas.pdf = this;}]);jsPDFAPI.canvas = {getContext:function getContext(name){this.pdf.context2d._canvas = this;return this.pdf.context2d;},style:{}};Object.defineProperty(jsPDFAPI.canvas,'width',{get:function get(){return this._width;},set:function set(value){this._width = value;this.getContext('2d').pageWrapX = value + 1;}});Object.defineProperty(jsPDFAPI.canvas,'height',{get:function get(){return this._height;},set:function set(value){this._height = value;this.getContext('2d').pageWrapY = value + 1;}});return this;})(jsPDF.API); /** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /*jslint browser:true */ /*global document: false, jsPDF */var fontName,fontSize,fontStyle,padding=3,margin=13,headerFunction,lastCellPos={x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined},pages=1,setLastCellPosition=function setLastCellPosition(x,y,w,h,ln){lastCellPos = {'x':x,'y':y,'w':w,'h':h,'ln':ln};},getLastCellPosition=function getLastCellPosition(){return lastCellPos;},NO_MARGINS={left:0,top:0,bottom:0};jsPDFAPI.setHeaderFunction = function(func){headerFunction = func;};jsPDFAPI.getTextDimensions = function(txt){fontName = this.internal.getFont().fontName;fontSize = this.table_font_size || this.internal.getFontSize();fontStyle = this.internal.getFont().fontStyle; // 1 pixel = 0.264583 mm and 1 mm = 72/25.4 point
	var px2pt=0.264583 * 72 / 25.4,dimensions,text;text = document.createElement('font');text.id = "jsPDFCell";try{text.style.fontStyle = fontStyle;}catch(e) {text.style.fontWeight = fontStyle;}text.style.fontName = fontName;text.style.fontSize = fontSize + 'pt';try{text.textContent = txt;}catch(e) {text.innerText = txt;}document.body.appendChild(text);dimensions = {w:(text.offsetWidth + 1) * px2pt,h:(text.offsetHeight + 1) * px2pt};document.body.removeChild(text);return dimensions;};jsPDFAPI.cellAddPage = function(){var margins=this.margins || NO_MARGINS;this.addPage();setLastCellPosition(margins.left,margins.top,undefined,undefined); //setLastCellPosition(undefined, undefined, undefined, undefined, undefined);
	pages += 1;};jsPDFAPI.cellInitialize = function(){lastCellPos = {x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined};pages = 1;};jsPDFAPI.cell = function(x,y,w,h,txt,ln,align){var curCell=getLastCellPosition();var pgAdded=false; // If this is not the first cell, we must change its position
	if(curCell.ln !== undefined){if(curCell.ln === ln){ //Same line
	x = curCell.x + curCell.w;y = curCell.y;}else { //New line
	var margins=this.margins || NO_MARGINS;if(curCell.y + curCell.h + h + margin >= this.internal.pageSize.height - margins.bottom){this.cellAddPage();pgAdded = true;if(this.printHeaders && this.tableHeaderRow){this.printHeaderRow(ln,true);}} //We ignore the passed y: the lines may have different heights
	y = getLastCellPosition().y + getLastCellPosition().h;if(pgAdded)y = margin + 10;}}if(txt[0] !== undefined){if(this.printingHeaderRow){this.rect(x,y,w,h,'FD');}else {this.rect(x,y,w,h);}if(align === 'right'){if(!(txt instanceof Array)){txt = [txt];}for(var i=0;i < txt.length;i++) {var currentLine=txt[i];var textSize=this.getStringUnitWidth(currentLine) * this.internal.getFontSize();this.text(currentLine,x + w - textSize - padding,y + this.internal.getLineHeight() * (i + 1));}}else {this.text(txt,x + padding,y + this.internal.getLineHeight());}}setLastCellPosition(x,y,w,h,ln);return this;}; /**
	     * Return the maximum value from an array
	     * @param array
	     * @param comparisonFn
	     * @returns {*}
	     */jsPDFAPI.arrayMax = function(array,comparisonFn){var max=array[0],i,ln,item;for(i = 0,ln = array.length;i < ln;i += 1) {item = array[i];if(comparisonFn){if(comparisonFn(max,item) === -1){max = item;}}else {if(item > max){max = item;}}}return max;}; /**
	     * Create a table from a set of data.
	     * @param {Integer} [x] : left-position for top-left corner of table
	     * @param {Integer} [y] top-position for top-left corner of table
	     * @param {Object[]} [data] As array of objects containing key-value pairs corresponding to a row of data.
	     * @param {String[]} [headers] Omit or null to auto-generate headers at a performance cost
	      * @param {Object} [config.printHeaders] True to print column headers at the top of every page
	     * @param {Object} [config.autoSize] True to dynamically set the column widths to match the widest cell value
	     * @param {Object} [config.margins] margin values for left, top, bottom, and width
	     * @param {Object} [config.fontSize] Integer fontSize to use (optional)
	     */jsPDFAPI.table = function(x,y,data,headers,config){if(!data){throw 'No data for PDF table';}var headerNames=[],headerPrompts=[],header,i,ln,cln,columnMatrix={},columnWidths={},columnData,column,columnMinWidths=[],j,tableHeaderConfigs=[],model,jln,func, //set up defaults. If a value is provided in config, defaults will be overwritten:
	autoSize=false,printHeaders=true,fontSize=12,margins=NO_MARGINS;margins.width = this.internal.pageSize.width;if(config){ //override config defaults if the user has specified non-default behavior:
	if(config.autoSize === true){autoSize = true;}if(config.printHeaders === false){printHeaders = false;}if(config.fontSize){fontSize = config.fontSize;}if(config.css && typeof config.css['font-size'] !== "undefined"){fontSize = config.css['font-size'] * 16;}if(config.margins){margins = config.margins;}} /**
	         * @property {Number} lnMod
	         * Keep track of the current line number modifier used when creating cells
	         */this.lnMod = 0;lastCellPos = {x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined},pages = 1;this.printHeaders = printHeaders;this.margins = margins;this.setFontSize(fontSize);this.table_font_size = fontSize; // Set header values
	if(headers === undefined || headers === null){ // No headers defined so we derive from data
	headerNames = Object.keys(data[0]);}else if(headers[0] && typeof headers[0] !== 'string'){var px2pt=0.264583 * 72 / 25.4; // Split header configs into names and prompts
	for(i = 0,ln = headers.length;i < ln;i += 1) {header = headers[i];headerNames.push(header.name);headerPrompts.push(header.prompt);columnWidths[header.name] = header.width * px2pt;}}else {headerNames = headers;}if(autoSize){ // Create a matrix of columns e.g., {column_title: [row1_Record, row2_Record]}
	func = function func(rec){return rec[header];};for(i = 0,ln = headerNames.length;i < ln;i += 1) {header = headerNames[i];columnMatrix[header] = data.map(func); // get header width
	columnMinWidths.push(this.getTextDimensions(headerPrompts[i] || header).w);column = columnMatrix[header]; // get cell widths
	for(j = 0,cln = column.length;j < cln;j += 1) {columnData = column[j];columnMinWidths.push(this.getTextDimensions(columnData).w);} // get final column width
	columnWidths[header] = jsPDFAPI.arrayMax(columnMinWidths); //have to reset
	columnMinWidths = [];}} // -- Construct the table
	if(printHeaders){var lineHeight=this.calculateLineHeight(headerNames,columnWidths,headerPrompts.length?headerPrompts:headerNames); // Construct the header row
	for(i = 0,ln = headerNames.length;i < ln;i += 1) {header = headerNames[i];tableHeaderConfigs.push([x,y,columnWidths[header],lineHeight,String(headerPrompts.length?headerPrompts[i]:header)]);} // Store the table header config
	this.setTableHeaderRow(tableHeaderConfigs); // Print the header for the start of the table
	this.printHeaderRow(1,false);} // Construct the data rows
	for(i = 0,ln = data.length;i < ln;i += 1) {var lineHeight;model = data[i];lineHeight = this.calculateLineHeight(headerNames,columnWidths,model);for(j = 0,jln = headerNames.length;j < jln;j += 1) {header = headerNames[j];this.cell(x,y,columnWidths[header],lineHeight,model[header],i + 2,header.align);}}this.lastCellPos = lastCellPos;this.table_x = x;this.table_y = y;return this;}; /**
	     * Calculate the height for containing the highest column
	     * @param {String[]} headerNames is the header, used as keys to the data
	     * @param {Integer[]} columnWidths is size of each column
	     * @param {Object[]} model is the line of data we want to calculate the height of
	     */jsPDFAPI.calculateLineHeight = function(headerNames,columnWidths,model){var header,lineHeight=0;for(var j=0;j < headerNames.length;j++) {header = headerNames[j];model[header] = this.splitTextToSize(String(model[header]),columnWidths[header] - padding);var h=this.internal.getLineHeight() * model[header].length + padding;if(h > lineHeight)lineHeight = h;}return lineHeight;}; /**
	     * Store the config for outputting a table header
	     * @param {Object[]} config
	     * An array of cell configs that would define a header row: Each config matches the config used by jsPDFAPI.cell
	     * except the ln parameter is excluded
	     */jsPDFAPI.setTableHeaderRow = function(config){this.tableHeaderRow = config;}; /**
	     * Output the store header row
	     * @param lineNumber The line number to output the header at
	     */jsPDFAPI.printHeaderRow = function(lineNumber,new_page){if(!this.tableHeaderRow){throw 'Property tableHeaderRow does not exist.';}var tableHeaderCell,tmpArray,i,ln;this.printingHeaderRow = true;if(headerFunction !== undefined){var position=headerFunction(this,pages);setLastCellPosition(position[0],position[1],position[2],position[3],-1);}this.setFontStyle('bold');var tempHeaderConf=[];for(i = 0,ln = this.tableHeaderRow.length;i < ln;i += 1) {this.setFillColor(200,200,200);tableHeaderCell = this.tableHeaderRow[i];if(new_page){this.margins.top = margin;tableHeaderCell[1] = this.margins && this.margins.top || 0;tempHeaderConf.push(tableHeaderCell);}tmpArray = [].concat(tableHeaderCell);this.cell.apply(this,tmpArray.concat(lineNumber));}if(tempHeaderConf.length > 0){this.setTableHeaderRow(tempHeaderConf);}this.setFontStyle('normal');this.printingHeaderRow = false;};})(jsPDF.API); /**
	 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	 *
	 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	 */ /**
	 * This plugin mimics the HTML5 Canvas's context2d.
	 *
	 * The goal is to provide a way for current canvas implementations to print directly to a PDF.
	 */ /**
	 * TODO implement stroke opacity (refactor from fill() method )
	 * TODO transform angle and radii parameters
	 */ /**
	 * require('jspdf.js'); require('lib/css_colors.js');
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['initialized',function(){this.context2d.pdf = this;this.context2d.internal.pdf = this;this.context2d.ctx = new context();this.context2d.ctxStack = [];this.context2d.path = [];}]);jsPDFAPI.context2d = {pageWrapXEnabled:false,pageWrapYEnabled:false,pageWrapX:9999999,pageWrapY:9999999,ctx:new context(),f2:function f2(number){return number.toFixed(2);},fillRect:function fillRect(x,y,w,h){if(this._isFillTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"f");},strokeRect:function strokeRect(x,y,w,h){if(this._isStrokeTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"s");}, /**
	         * We cannot clear PDF commands that were already written to PDF, so we use white instead. <br />
	         * As a special case, read a special flag (ignoreClearRect) and do nothing if it is set.
	         * This results in all calls to clearRect() to do nothing, and keep the canvas transparent.
	         * This flag is stored in the save/restore context and is managed the same way as other drawing states.
	         * @param x
	         * @param y
	         * @param w
	         * @param h
	         */clearRect:function clearRect(x,y,w,h){if(this.ctx.ignoreClearRect){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.save();this.setFillStyle('#ffffff'); //TODO This is hack to fill with white.
	this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"f");this.restore();},save:function save(){this.ctx._fontSize = this.pdf.internal.getFontSize();var ctx=new context();ctx.copy(this.ctx);this.ctxStack.push(this.ctx);this.ctx = ctx;},restore:function restore(){this.ctx = this.ctxStack.pop();this.setFillStyle(this.ctx.fillStyle);this.setStrokeStyle(this.ctx.strokeStyle);this.setFont(this.ctx.font);this.pdf.setFontSize(this.ctx._fontSize);this.setLineCap(this.ctx.lineCap);this.setLineWidth(this.ctx.lineWidth);this.setLineJoin(this.ctx.lineJoin);},rect:function rect(x,y,w,h){this.moveTo(x,y);this.lineTo(x + w,y);this.lineTo(x + w,y + h);this.lineTo(x,y + h);this.lineTo(x,y); //TODO not needed
	this.closePath();},beginPath:function beginPath(){this.path = [];},closePath:function closePath(){this.path.push({type:'close'});},_getRGBA:function _getRGBA(style){ // get the decimal values of r, g, and b;
	var r,g,b,a;if(!style){return {r:0,g:0,b:0,a:0,style:style};}if(this.internal.rxTransparent.test(style)){r = 0;g = 0;b = 0;a = 0;}else {var m=this.internal.rxRgb.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);a = 1;}else {m = this.internal.rxRgba.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);a = parseFloat(m[4]);}else {a = 1;if(style.charAt(0) != '#'){style = CssColors.colorNameToHex(style);if(!style){style = '#000000';}}else {}if(style.length === 4){r = style.substring(1,2);r += r;g = style.substring(2,3);g += g;b = style.substring(3,4);b += b;}else {r = style.substring(1,3);g = style.substring(3,5);b = style.substring(5,7);}r = parseInt(r,16);g = parseInt(g,16);b = parseInt(b,16);}}}return {r:r,g:g,b:b,a:a,style:style};},setFillStyle:function setFillStyle(style){var rgba=this._getRGBA(style);this.ctx.fillStyle = style;this.ctx._isFillTransparent = rgba.a === 0;this.ctx._fillOpacity = rgba.a;this.pdf.setFillColor(rgba.r,rgba.g,rgba.b,{a:rgba.a});this.pdf.setTextColor(rgba.r,rgba.g,rgba.b,{a:rgba.a});},setStrokeStyle:function setStrokeStyle(style){var rgba=this._getRGBA(style);this.ctx.strokeStyle = rgba.style;this.ctx._isStrokeTransparent = rgba.a === 0;this.ctx._strokeOpacity = rgba.a; //TODO jsPDF to handle rgba
	if(rgba.a === 0){this.pdf.setDrawColor(255,255,255);}else if(rgba.a === 1){this.pdf.setDrawColor(rgba.r,rgba.g,rgba.b);}else { //this.pdf.setDrawColor(rgba.r, rgba.g, rgba.b, {a: rgba.a});
	this.pdf.setDrawColor(rgba.r,rgba.g,rgba.b);}},fillText:function fillText(text,x,y,maxWidth){if(this._isFillTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var rads=this._matrix_rotation(this.ctx._transform);var degs=rads * 57.2958; //TODO only push the clip if it has not been applied to the current PDF context
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.internal.getCurrentPage();}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(null,true);this.ctx._clip_path = this.path;this.path = origPath;} // We only use X axis as scale hint 
	var scale=1;try{scale = this._matrix_decompose(this._getTransform()).scale[0];}catch(e) {console.warn(e);} // In some cases the transform was very small (5.715760606202283e-17).  Most likely a canvg rounding error.
	if(scale < .01){this.pdf.text(text,x,this._getBaseline(y),null,degs);}else {var oldSize=this.pdf.internal.getFontSize();this.pdf.setFontSize(oldSize * scale);this.pdf.text(text,x,this._getBaseline(y),null,degs);this.pdf.setFontSize(oldSize);}if(this.ctx._clip_path.length > 0){lines.push('Q');}},strokeText:function strokeText(text,x,y,maxWidth){if(this._isStrokeTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var rads=this._matrix_rotation(this.ctx._transform);var degs=rads * 57.2958; //TODO only push the clip if it has not been applied to the current PDF context
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.internal.getCurrentPage();}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(null,true);this.ctx._clip_path = this.path;this.path = origPath;}var scale=1; // We only use the X axis as scale hint 
	try{scale = this._matrix_decompose(this._getTransform()).scale[0];}catch(e) {console.warn(e);}if(scale === 1){this.pdf.text(text,x,this._getBaseline(y),{stroke:true},degs);}else {var oldSize=this.pdf.internal.getFontSize();this.pdf.setFontSize(oldSize * scale);this.pdf.text(text,x,this._getBaseline(y),{stroke:true},degs);this.pdf.setFontSize(oldSize);}if(this.ctx._clip_path.length > 0){lines.push('Q');}},setFont:function setFont(font){this.ctx.font = font; //var rx = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+["']?(\w+)['"]?/;
	var rx=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;m = rx.exec(font);if(m != null){var fontStyle=m[1];var fontWeight=m[3];var fontSize=m[4];var fontSizeUnit=m[5];var fontFamily=m[6];if('px' === fontSizeUnit){fontSize = Math.floor(parseFloat(fontSize)); // fontSize = fontSize * 1.25;
	}else if('em' === fontSizeUnit){fontSize = Math.floor(parseFloat(fontSize) * this.pdf.getFontSize());}else {fontSize = Math.floor(parseFloat(fontSize));}this.pdf.setFontSize(fontSize);if(fontWeight === 'bold' || fontWeight === '700'){this.pdf.setFontStyle('bold');}else {if(fontStyle === 'italic'){this.pdf.setFontStyle('italic');}else {this.pdf.setFontStyle('normal');}}var name=fontFamily;var parts=name.toLowerCase().split(/\s*,\s*/);var jsPdfFontName;if(parts.indexOf('arial') != -1){jsPdfFontName = 'Arial';}else if(parts.indexOf('verdana') != -1){jsPdfFontName = 'Verdana';}else if(parts.indexOf('helvetica') != -1){jsPdfFontName = 'Helvetica';}else if(parts.indexOf('sans-serif') != -1){jsPdfFontName = 'sans-serif';}else if(parts.indexOf('fixed') != -1){jsPdfFontName = 'Fixed';}else if(parts.indexOf('monospace') != -1){jsPdfFontName = 'Monospace';}else if(parts.indexOf('terminal') != -1){jsPdfFontName = 'Terminal';}else if(parts.indexOf('courier') != -1){jsPdfFontName = 'Courier';}else if(parts.indexOf('times') != -1){jsPdfFontName = 'Times';}else if(parts.indexOf('cursive') != -1){jsPdfFontName = 'Cursive';}else if(parts.indexOf('fantasy') != -1){jsPdfFontName = 'Fantasy';}else if(parts.indexOf('serif') != -1){jsPdfFontName = 'Serif';}else {jsPdfFontName = 'Serif';} //TODO check more cases
	var style;if('bold' === fontWeight){style = 'bold';}else {style = 'normal';}this.pdf.setFont(jsPdfFontName,style);}else {var rx=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/;var m=rx.exec(font);if(m != null){var size=m[1];var name=m[3];var style=m[4];if(!style){style = 'normal';}if('em' === fontSizeUnit){size = Math.floor(parseFloat(fontSize) * this.pdf.getFontSize());}else {size = Math.floor(parseFloat(size));}this.pdf.setFontSize(size);this.pdf.setFont(name,style);}}},setTextBaseline:function setTextBaseline(baseline){this.ctx.textBaseline = baseline;},getTextBaseline:function getTextBaseline(){return this.ctx.textBaseline;}, //TODO implement textAlign
	setTextAlign:function setTextAlign(align){this.ctx.textAlign = align;},getTextAlign:function getTextAlign(){return this.ctx.textAlign;},setLineWidth:function setLineWidth(width){this.ctx.lineWidth = width;this.pdf.setLineWidth(width);},setLineCap:function setLineCap(style){this.ctx.lineCap = style;this.pdf.setLineCap(style);},setLineJoin:function setLineJoin(style){this.ctx.lineJoin = style;this.pdf.setLineJoin(style);},moveTo:function moveTo(x,y){x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var obj={type:'mt',x:x,y:y};this.path.push(obj);},_wrapX:function _wrapX(x){if(this.pageWrapXEnabled){return x % this.pageWrapX;}else {return x;}},_wrapY:function _wrapY(y){if(this.pageWrapYEnabled){this._gotoPage(this._page(y));return (y - this.lastBreak) % this.pageWrapY;}else {return y;}},transform:function transform(a,b,c,d,e,f){ //TODO apply to current transformation instead of replacing
	this.ctx._transform = [a,b,c,d,e,f];},setTransform:function setTransform(a,b,c,d,e,f){this.ctx._transform = [a,b,c,d,e,f];},_getTransform:function _getTransform(){return this.ctx._transform;},lastBreak:0, // Y Position of page breaks.
	pageBreaks:[], // returns: One-based Page Number
	// Should only be used if pageWrapYEnabled is true
	_page:function _page(y){if(this.pageWrapYEnabled){this.lastBreak = 0;var manualBreaks=0;var autoBreaks=0;for(var i=0;i < this.pageBreaks.length;i++) {if(y >= this.pageBreaks[i]){manualBreaks++;if(this.lastBreak === 0){autoBreaks++;}var spaceBetweenLastBreak=this.pageBreaks[i] - this.lastBreak;this.lastBreak = this.pageBreaks[i];var pagesSinceLastBreak=Math.floor(spaceBetweenLastBreak / this.pageWrapY);autoBreaks += pagesSinceLastBreak;}}if(this.lastBreak === 0){var pagesSinceLastBreak=Math.floor(y / this.pageWrapY) + 1;autoBreaks += pagesSinceLastBreak;}return autoBreaks + manualBreaks;}else {return this.pdf.internal.getCurrentPageInfo().pageNumber;}},_gotoPage:function _gotoPage(pageOneBased){ // This is a stub to be overriden if needed
	},lineTo:function lineTo(x,y){x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var obj={type:'lt',x:x,y:y};this.path.push(obj);},bezierCurveTo:function bezierCurveTo(x1,y1,x2,y2,x,y){x1 = this._wrapX(x1);y1 = this._wrapY(y1);x2 = this._wrapX(x2);y2 = this._wrapY(y2);x = this._wrapX(x);y = this._wrapY(y);var xpt;xpt = this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x1,y1]);x1 = xpt[0];y1 = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x2,y2]);x2 = xpt[0];y2 = xpt[1];var obj={type:'bct',x1:x1,y1:y1,x2:x2,y2:y2,x:x,y:y};this.path.push(obj);},quadraticCurveTo:function quadraticCurveTo(x1,y1,x,y){x1 = this._wrapX(x1);y1 = this._wrapY(y1);x = this._wrapX(x);y = this._wrapY(y);var xpt;xpt = this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x1,y1]);x1 = xpt[0];y1 = xpt[1];var obj={type:'qct',x1:x1,y1:y1,x:x,y:y};this.path.push(obj);},arc:function arc(x,y,radius,startAngle,endAngle,anticlockwise){x = this._wrapX(x);y = this._wrapY(y);if(!this._matrix_is_identity(this.ctx._transform)){var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var x_radPt0=this._matrix_map_point(this.ctx._transform,[0,0]);var x_radPt=this._matrix_map_point(this.ctx._transform,[0,radius]);radius = Math.sqrt(Math.pow(x_radPt[0] - x_radPt0[0],2) + Math.pow(x_radPt[1] - x_radPt0[1],2)); //TODO angles need to be transformed
	}var obj={type:'arc',x:x,y:y,radius:radius,startAngle:startAngle,endAngle:endAngle,anticlockwise:anticlockwise};this.path.push(obj);},drawImage:function drawImage(img,x,y,w,h,x2,y2,w2,h2){if(x2 !== undefined){x = x2;y = y2;w = w2;h = h2;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});var xRect2=this._matrix_map_rect(this.ctx._transform,{x:x2,y:y2,w:w2,h:h2}); // TODO implement source clipping and image scaling
	var format;var rx=/data:image\/(\w+).*/i;var m=rx.exec(img);if(m != null){format = m[1];}else { // format = "jpeg";
	format = "png";}this.pdf.addImage(img,format,xRect.x,xRect.y,xRect.w,xRect.h);}, /**
	         * Multiply the first matrix by the second
	         * @param m1
	         * @param m2
	         * @returns {*[]}
	         * @private
	         */_matrix_multiply:function _matrix_multiply(m2,m1){var sx=m1[0];var shy=m1[1];var shx=m1[2];var sy=m1[3];var tx=m1[4];var ty=m1[5];var t0=sx * m2[0] + shy * m2[2];var t2=shx * m2[0] + sy * m2[2];var t4=tx * m2[0] + ty * m2[2] + m2[4];shy = sx * m2[1] + shy * m2[3];sy = shx * m2[1] + sy * m2[3];ty = tx * m2[1] + ty * m2[3] + m2[5];sx = t0;shx = t2;tx = t4;return [sx,shy,shx,sy,tx,ty];},_matrix_rotation:function _matrix_rotation(m){return Math.atan2(m[2],m[0]);},_matrix_decompose:function _matrix_decompose(matrix){var a=matrix[0];var b=matrix[1];var c=matrix[2];var d=matrix[3];var scaleX=Math.sqrt(a * a + b * b);a /= scaleX;b /= scaleX;var shear=a * c + b * d;c -= a * shear;d -= b * shear;var scaleY=Math.sqrt(c * c + d * d);c /= scaleY;d /= scaleY;shear /= scaleY;if(a * d < b * c){a = -a;b = -b;shear = -shear;scaleX = -scaleX;}return {scale:[scaleX,0,0,scaleY,0,0],translate:[1,0,0,1,matrix[4],matrix[5]],rotate:[a,b,-b,a,0,0],skew:[1,0,shear,1,0,0]};},_matrix_map_point:function _matrix_map_point(m1,pt){var sx=m1[0];var shy=m1[1];var shx=m1[2];var sy=m1[3];var tx=m1[4];var ty=m1[5];var px=pt[0];var py=pt[1];var x=px * sx + py * shx + tx;var y=px * shy + py * sy + ty;return [x,y];},_matrix_map_point_obj:function _matrix_map_point_obj(m1,pt){var xpt=this._matrix_map_point(m1,[pt.x,pt.y]);return {x:xpt[0],y:xpt[1]};},_matrix_map_rect:function _matrix_map_rect(m1,rect){var p1=this._matrix_map_point(m1,[rect.x,rect.y]);var p2=this._matrix_map_point(m1,[rect.x + rect.w,rect.y + rect.h]);return {x:p1[0],y:p1[1],w:p2[0] - p1[0],h:p2[1] - p1[1]};},_matrix_is_identity:function _matrix_is_identity(m1){if(m1[0] != 1){return false;}if(m1[1] != 0){return false;}if(m1[2] != 0){return false;}if(m1[3] != 1){return false;}if(m1[4] != 0){return false;}if(m1[5] != 0){return false;}return true;},rotate:function rotate(angle){var matrix=[Math.cos(angle),Math.sin(angle),-Math.sin(angle),Math.cos(angle),0.0,0.0];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},scale:function scale(sx,sy){var matrix=[sx,0.0,0.0,sy,0.0,0.0];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},translate:function translate(x,y){var matrix=[1.0,0.0,0.0,1.0,x,y];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},stroke:function stroke(){if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.internal.getCurrentPage();}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._stroke(true);this.ctx._clip_path = this.path;this.path = origPath;this._stroke(false);lines.push("Q");}else {this._stroke(false);}},_stroke:function _stroke(isClip){if(!isClip && this._isStrokeTransparent()){return;} //TODO opacity
	var moves=[];var xPath=this.path;for(var i=0;i < xPath.length;i++) {var pt=xPath[i];switch(pt.type){case 'mt':moves.push({start:pt,deltas:[],abs:[]});break;case 'lt':var delta=[pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);moves[moves.length - 1].abs.push(pt);break;case 'bct':var delta=[pt.x1 - xPath[i - 1].x,pt.y1 - xPath[i - 1].y,pt.x2 - xPath[i - 1].x,pt.y2 - xPath[i - 1].y,pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'qct': // convert to bezier
	var x1=xPath[i - 1].x + 2.0 / 3.0 * (pt.x1 - xPath[i - 1].x);var y1=xPath[i - 1].y + 2.0 / 3.0 * (pt.y1 - xPath[i - 1].y);var x2=pt.x + 2.0 / 3.0 * (pt.x1 - pt.x);var y2=pt.y + 2.0 / 3.0 * (pt.y1 - pt.y);var x3=pt.x;var y3=pt.y;var delta=[x1 - xPath[i - 1].x,y1 - xPath[i - 1].y,x2 - xPath[i - 1].x,y2 - xPath[i - 1].y,x3 - xPath[i - 1].x,y3 - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'arc': //TODO this was hack to avoid out-of-bounds issue
	// No move-to before drawing the arc
	if(moves.length == 0){moves.push({start:{x:0,y:0},deltas:[],abs:[]});}moves[moves.length - 1].arc = true;moves[moves.length - 1].abs.push(pt);break;case 'close':break;}}for(var i=0;i < moves.length;i++) {var style;if(i == moves.length - 1){style = 's';}else {style = null;}if(moves[i].arc){var arcs=moves[i].abs;for(var ii=0;ii < arcs.length;ii++) {var arc=arcs[ii];var start=arc.startAngle * 360 / (2 * Math.PI);var end=arc.endAngle * 360 / (2 * Math.PI);var x=arc.x;var y=arc.y;this.internal.arc2(this,x,y,arc.radius,start,end,arc.anticlockwise,style,isClip);}}else {var x=moves[i].start.x;var y=moves[i].start.y;if(!isClip){this.pdf.lines(moves[i].deltas,x,y,null,style);}else {this.pdf.lines(moves[i].deltas,x,y,null,null);this.pdf.clip_fixed();}}}},_isFillTransparent:function _isFillTransparent(){return this.ctx._isFillTransparent || this.globalAlpha == 0;},_isStrokeTransparent:function _isStrokeTransparent(){return this.ctx._isStrokeTransparent || this.globalAlpha == 0;},fill:function fill(fillRule){ //evenodd or nonzero (default)
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.internal.getCurrentPage();}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(fillRule,true);this.ctx._clip_path = this.path;this.path = origPath;this._fill(fillRule,false);lines.push('Q');}else {this._fill(fillRule,false);}},_fill:function _fill(fillRule,isClip){if(this._isFillTransparent()){return;}var v2Support=typeof this.pdf.internal.newObject2 === 'function';var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.internal.getCurrentPage();} // if (this.ctx._clip_path.length > 0) {
	//     lines.push('q');
	//     var oldPath = this.path;
	//     this.path = this.ctx._clip_path;
	//     this.ctx._clip_path = [];
	//     this._fill(fillRule, true);
	//     this.ctx._clip_path = this.path;
	//     this.path = oldPath;
	// }
	var moves=[];var outInterceptOld=window.outIntercept;if(v2Support){ // Blend and Mask
	switch(this.ctx.globalCompositeOperation){case 'normal':case 'source-over':break;case 'destination-in':case 'destination-out': //TODO this need to be added to the current group or page
	// define a mask stream
	var obj=this.pdf.internal.newStreamObject(); // define a mask state
	var obj2=this.pdf.internal.newObject2();obj2.push('<</Type /ExtGState');obj2.push('/SMask <</S /Alpha /G ' + obj.objId + ' 0 R>>'); // /S /Luminosity will need to define color space
	obj2.push('>>'); // add mask to page resources
	var gsName='MASK' + obj2.objId;this.pdf.internal.addGraphicsState(gsName,obj2.objId);var instruction='/' + gsName + ' gs'; // add mask to page, group, or stream
	lines.splice(0,0,'q');lines.splice(1,0,instruction);lines.push('Q');window.outIntercept = obj;break;default:var dictionaryEntry='/' + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];if(dictionaryEntry){this.pdf.internal.out(dictionaryEntry + ' gs');}break;}}var alpha=this.ctx.globalAlpha;if(this.ctx._fillOpacity < 1){ // TODO combine this with global opacity
	alpha = this.ctx._fillOpacity;} //TODO check for an opacity graphics state that was already created
	//TODO do not set opacity if current value is already active
	if(v2Support){var objOpac=this.pdf.internal.newObject2();objOpac.push('<</Type /ExtGState'); //objOpac.push(this.ctx.globalAlpha + " CA"); // Stroke
	//objOpac.push(this.ctx.globalAlpha + " ca"); // Not Stroke
	objOpac.push('/CA ' + alpha); // Stroke
	objOpac.push('/ca ' + alpha); // Not Stroke
	objOpac.push('>>');var gsName='GS_O_' + objOpac.objId;this.pdf.internal.addGraphicsState(gsName,objOpac.objId);this.pdf.internal.out('/' + gsName + ' gs');}var xPath=this.path;for(var i=0;i < xPath.length;i++) {var pt=xPath[i];switch(pt.type){case 'mt':moves.push({start:pt,deltas:[],abs:[]});break;case 'lt':var delta=[pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);moves[moves.length - 1].abs.push(pt);break;case 'bct':var delta=[pt.x1 - xPath[i - 1].x,pt.y1 - xPath[i - 1].y,pt.x2 - xPath[i - 1].x,pt.y2 - xPath[i - 1].y,pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'qct': // convert to bezier
	var x1=xPath[i - 1].x + 2.0 / 3.0 * (pt.x1 - xPath[i - 1].x);var y1=xPath[i - 1].y + 2.0 / 3.0 * (pt.y1 - xPath[i - 1].y);var x2=pt.x + 2.0 / 3.0 * (pt.x1 - pt.x);var y2=pt.y + 2.0 / 3.0 * (pt.y1 - pt.y);var x3=pt.x;var y3=pt.y;var delta=[x1 - xPath[i - 1].x,y1 - xPath[i - 1].y,x2 - xPath[i - 1].x,y2 - xPath[i - 1].y,x3 - xPath[i - 1].x,y3 - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'arc': //TODO this was hack to avoid out-of-bounds issue when drawing circle
	// No move-to before drawing the arc
	if(moves.length === 0){moves.push({deltas:[],abs:[]});}moves[moves.length - 1].arc = true;moves[moves.length - 1].abs.push(pt);break;case 'close':moves.push({close:true});break;}}for(var i=0;i < moves.length;i++) {var style;if(i == moves.length - 1){style = 'f';if(fillRule === 'evenodd'){style += '*';}}else {style = null;}if(moves[i].close){this.pdf.internal.out('h');this.pdf.internal.out('f');}else if(moves[i].arc){if(moves[i].start){this.internal.move2(this,moves[i].start.x,moves[i].start.y);}var arcs=moves[i].abs;for(var ii=0;ii < arcs.length;ii++) {var arc=arcs[ii]; //TODO lines deltas were getting in here
	if(typeof arc.startAngle !== 'undefined'){var start=arc.startAngle * 360 / (2 * Math.PI);var end=arc.endAngle * 360 / (2 * Math.PI);var x=arc.x;var y=arc.y;if(ii === 0){this.internal.move2(this,x,y);}this.internal.arc2(this,x,y,arc.radius,start,end,arc.anticlockwise,null,isClip);if(ii === arcs.length - 1){ // The original arc move did not occur because of the algorithm
	if(moves[i].start){var x=moves[i].start.x;var y=moves[i].start.y;this.internal.line2(c2d,x,y);}}}else {this.internal.line2(c2d,arc.x,arc.y);}}}else {var x=moves[i].start.x;var y=moves[i].start.y;if(!isClip){this.pdf.lines(moves[i].deltas,x,y,null,style);}else {this.pdf.lines(moves[i].deltas,x,y,null,null);this.pdf.clip_fixed();}}}window.outIntercept = outInterceptOld; // if (this.ctx._clip_path.length > 0) {
	//     lines.push('Q');
	// }
	},pushMask:function pushMask(){var v2Support=typeof this.pdf.internal.newObject2 === 'function';if(!v2Support){console.log('jsPDF v2 not enabled');return;} // define a mask stream
	var obj=this.pdf.internal.newStreamObject(); // define a mask state
	var obj2=this.pdf.internal.newObject2();obj2.push('<</Type /ExtGState');obj2.push('/SMask <</S /Alpha /G ' + obj.objId + ' 0 R>>'); // /S /Luminosity will need to define color space
	obj2.push('>>'); // add mask to page resources
	var gsName='MASK' + obj2.objId;this.pdf.internal.addGraphicsState(gsName,obj2.objId);var instruction='/' + gsName + ' gs';this.pdf.internal.out(instruction);},clip:function clip(){ //TODO do we reset the path, or just copy it?
	if(this.ctx._clip_path.length > 0){for(var i=0;i < this.path.length;i++) {this.ctx._clip_path.push(this.path[i]);}}else {this.ctx._clip_path = this.path;}this.path = [];},measureText:function measureText(text){var pdf=this.pdf;return Object.defineProperties({getWidth:function getWidth(){var fontSize=pdf.internal.getFontSize();var txtWidth=pdf.getStringUnitWidth(text) * fontSize / pdf.internal.scaleFactor; // Convert points to pixels
	txtWidth *= 1.3333;return txtWidth;}},{width:{get:function get(){return this.getWidth(text);},configurable:true,enumerable:true}});},_getBaseline:function _getBaseline(y){var height=parseInt(this.pdf.internal.getFontSize()); // TODO Get descent from font descriptor
	var descent=height * .25;switch(this.ctx.textBaseline){case 'bottom':return y - descent;case 'top':return y + height;case 'hanging':return y + height - descent;case 'middle':return y + height / 2 - descent;case 'ideographic': // TODO not implemented
	return y;case 'alphabetic':default:return y;}}};var c2d=jsPDFAPI.context2d; // accessor methods
	Object.defineProperty(c2d,'fillStyle',{set:function set(value){this.setFillStyle(value);},get:function get(){return this.ctx.fillStyle;}});Object.defineProperty(c2d,'strokeStyle',{set:function set(value){this.setStrokeStyle(value);},get:function get(){return this.ctx.strokeStyle;}});Object.defineProperty(c2d,'lineWidth',{set:function set(value){this.setLineWidth(value);},get:function get(){return this.ctx.lineWidth;}});Object.defineProperty(c2d,'lineCap',{set:function set(val){this.setLineCap(val);},get:function get(){return this.ctx.lineCap;}});Object.defineProperty(c2d,'lineJoin',{set:function set(val){this.setLineJoin(val);},get:function get(){return this.ctx.lineJoin;}});Object.defineProperty(c2d,'miterLimit',{set:function set(val){this.ctx.miterLimit = val;},get:function get(){return this.ctx.miterLimit;}});Object.defineProperty(c2d,'textBaseline',{set:function set(value){this.setTextBaseline(value);},get:function get(){return this.getTextBaseline();}});Object.defineProperty(c2d,'textAlign',{set:function set(value){this.setTextAlign(value);},get:function get(){return this.getTextAlign();}});Object.defineProperty(c2d,'font',{set:function set(value){this.setFont(value);},get:function get(){return this.ctx.font;}});Object.defineProperty(c2d,'globalCompositeOperation',{set:function set(value){this.ctx.globalCompositeOperation = value;},get:function get(){return this.ctx.globalCompositeOperation;}});Object.defineProperty(c2d,'globalAlpha',{set:function set(value){this.ctx.globalAlpha = value;},get:function get(){return this.ctx.globalAlpha;}}); // Not HTML API
	Object.defineProperty(c2d,'ignoreClearRect',{set:function set(value){this.ctx.ignoreClearRect = value;},get:function get(){return this.ctx.ignoreClearRect;}}); // End Not HTML API
	c2d.internal = {};c2d.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/;c2d.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/;c2d.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/; // http://hansmuller-flex.blogspot.com/2011/10/more-about-approximating-circular-arcs.html
	c2d.internal.arc = function(c2d,xc,yc,r,a1,a2,anticlockwise,style){var includeMove=true;var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2;var a1r=a1 * (Math.PI / 180);var a2r=a2 * (Math.PI / 180);var curves=this.createArc(r,a1r,a2r,anticlockwise);for(var i=0;i < curves.length;i++) {var curve=curves[i];if(includeMove && i === 0){this.pdf.internal.out([f2((curve.x1 + xc) * k),f2((pageHeight - (curve.y1 + yc)) * k),'m',f2((curve.x2 + xc) * k),f2((pageHeight - (curve.y2 + yc)) * k),f2((curve.x3 + xc) * k),f2((pageHeight - (curve.y3 + yc)) * k),f2((curve.x4 + xc) * k),f2((pageHeight - (curve.y4 + yc)) * k),'c'].join(' '));}else {this.pdf.internal.out([f2((curve.x2 + xc) * k),f2((pageHeight - (curve.y2 + yc)) * k),f2((curve.x3 + xc) * k),f2((pageHeight - (curve.y3 + yc)) * k),f2((curve.x4 + xc) * k),f2((pageHeight - (curve.y4 + yc)) * k),'c'].join(' '));} //c2d._lastPoint = {x: curve.x1 + xc, y: curve.y1 + yc};
	c2d._lastPoint = {x:xc,y:yc}; // f2((curve.x1 + xc) * k), f2((pageHeight - (curve.y1 + yc)) * k), 'm', f2((curve.x2 + xc) * k), f2((pageHeight - (curve.y2 + yc)) * k), f2((curve.x3 + xc) * k), f2((pageHeight - (curve.y3 + yc)) * k), f2((curve.x4 + xc) * k), f2((pageHeight - (curve.y4 + yc)) * k), 'c'
	}if(style !== null){this.pdf.internal.out(this.pdf.internal.getStyle(style));}}; /**
	     *
	     * @param x Edge point X
	     * @param y Edge point Y
	     * @param r Radius
	     * @param a1 start angle
	     * @param a2 end angle
	     * @param anticlockwise
	     * @param style
	     * @param isClip
	     */c2d.internal.arc2 = function(c2d,x,y,r,a1,a2,anticlockwise,style,isClip){ // we need to convert from cartesian to polar here methinks.
	var centerX=x; // + r;
	var centerY=y;if(!isClip){this.arc(c2d,centerX,centerY,r,a1,a2,anticlockwise,style);}else {this.arc(c2d,centerX,centerY,r,a1,a2,anticlockwise,null);this.pdf.clip_fixed();}};c2d.internal.move2 = function(c2d,x,y){var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2;this.pdf.internal.out([f2(x * k),f2((pageHeight - y) * k),'m'].join(' '));c2d._lastPoint = {x:x,y:y};};c2d.internal.line2 = function(c2d,dx,dy){var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2; //var pt = {x: c2d._lastPoint.x + dx, y: c2d._lastPoint.y + dy};
	var pt={x:dx,y:dy};this.pdf.internal.out([f2(pt.x * k),f2((pageHeight - pt.y) * k),'l'].join(' ')); //this.pdf.internal.out('f');
	c2d._lastPoint = pt;}; /**
	     * Return a array of objects that represent bezier curves which approximate the circular arc centered at the origin, from startAngle to endAngle (radians) with the specified radius.
	     *
	     * Each bezier curve is an object with four points, where x1,y1 and x4,y4 are the arc's end points and x2,y2 and x3,y3 are the cubic bezier's control points.
	     */c2d.internal.createArc = function(radius,startAngle,endAngle,anticlockwise){var EPSILON=0.00001; // Roughly 1/1000th of a degree, see below
	var twoPI=Math.PI * 2;var piOverTwo=Math.PI / 2.0; // normalize startAngle, endAngle to [0, 2PI]
	var startAngleN=startAngle;if(startAngleN < twoPI || startAngleN > twoPI){startAngleN = startAngleN % twoPI;}if(startAngleN < 0){startAngleN = twoPI + startAngleN;}while(startAngle > endAngle) {startAngle = startAngle - twoPI;}var totalAngle=Math.abs(endAngle - startAngle);if(totalAngle < twoPI){if(anticlockwise){totalAngle = twoPI - totalAngle;}} // Compute the sequence of arc curves, up to PI/2 at a time.
	var curves=[];var sgn=anticlockwise?-1:+1;var a1=startAngleN;for(;totalAngle > EPSILON;) {var remain=sgn * Math.min(totalAngle,piOverTwo);var a2=a1 + remain;curves.push(this.createSmallArc(radius,a1,a2));totalAngle -= Math.abs(a2 - a1);a1 = a2;}return curves;};c2d.internal.getCurrentPage = function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber];}; /**
	     * Cubic bezier approximation of a circular arc centered at the origin, from (radians) a1 to a2, where a2-a1 < pi/2. The arc's radius is r.
	     *
	     * Returns an object with four points, where x1,y1 and x4,y4 are the arc's end points and x2,y2 and x3,y3 are the cubic bezier's control points.
	     *
	     * This algorithm is based on the approach described in: A. Riškus, "Approximation of a Cubic Bezier Curve by Circular Arcs and Vice Versa," Information Technology and Control, 35(4), 2006 pp. 371-378.
	     */c2d.internal.createSmallArc = function(r,a1,a2){ // Compute all four points for an arc that subtends the same total angle
	// but is centered on the X-axis
	var a=(a2 - a1) / 2.0;var x4=r * Math.cos(a);var y4=r * Math.sin(a);var x1=x4;var y1=-y4;var q1=x1 * x1 + y1 * y1;var q2=q1 + x1 * x4 + y1 * y4;var k2=4 / 3 * (Math.sqrt(2 * q1 * q2) - q2) / (x1 * y4 - y1 * x4);var x2=x1 - k2 * y1;var y2=y1 + k2 * x1;var x3=x2;var y3=-y2; // Find the arc points' actual locations by computing x1,y1 and x4,y4
	// and rotating the control points by a + a1
	var ar=a + a1;var cos_ar=Math.cos(ar);var sin_ar=Math.sin(ar);return {x1:r * Math.cos(a1),y1:r * Math.sin(a1),x2:x2 * cos_ar - y2 * sin_ar,y2:x2 * sin_ar + y2 * cos_ar,x3:x3 * cos_ar - y3 * sin_ar,y3:x3 * sin_ar + y3 * cos_ar,x4:r * Math.cos(a2),y4:r * Math.sin(a2)};};function context(){this._isStrokeTransparent = false;this._strokeOpacity = 1;this.strokeStyle = '#000000';this.fillStyle = '#000000';this._isFillTransparent = false;this._fillOpacity = 1;this.font = "12pt times";this.textBaseline = 'alphabetic'; // top,bottom,middle,ideographic,alphabetic,hanging
	this.textAlign = 'start';this.lineWidth = 1;this.lineJoin = 'miter'; // round, bevel, miter
	this.lineCap = 'butt'; // butt, round, square
	this._transform = [1,0,0,1,0,0]; // sx, shy, shx, sy, tx, ty
	this.globalCompositeOperation = 'normal';this.globalAlpha = 1.0;this._clip_path = []; // TODO miter limit //default 10
	// Not HTML API
	this.ignoreClearRect = false;this.copy = function(ctx){this._isStrokeTransparent = ctx._isStrokeTransparent;this._strokeOpacity = ctx._strokeOpacity;this.strokeStyle = ctx.strokeStyle;this._isFillTransparent = ctx._isFillTransparent;this._fillOpacity = ctx._fillOpacity;this.fillStyle = ctx.fillStyle;this.font = ctx.font;this.lineWidth = ctx.lineWidth;this.lineJoin = ctx.lineJoin;this.lineCap = ctx.lineCap;this.textBaseline = ctx.textBaseline;this.textAlign = ctx.textAlign;this._fontSize = ctx._fontSize;this._transform = ctx._transform.slice(0);this.globalCompositeOperation = ctx.globalCompositeOperation;this.globalAlpha = ctx.globalAlpha;this._clip_path = ctx._clip_path.slice(0); //TODO deep copy?
	// Not HTML API
	this.ignoreClearRect = ctx.ignoreClearRect;};}return this;})(jsPDF.API); /** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *               2014 Steven Spungin, https://github.com/flamenco
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){var clone,_DrillForContent,FontNameDB,FontStyleMap,TextAlignMap,FontWeightMap,FloatMap,ClearMap,GetCSS,PurgeWhiteSpace,Renderer,ResolveFont,ResolveUnitedNumber,UnitedNumberMap,elementHandledElsewhere,images,loadImgs,checkForFooter,process,tableToJson;clone = (function(){return function(obj){Clone.prototype = obj;return new Clone();};function Clone(){}})();PurgeWhiteSpace = function PurgeWhiteSpace(array){var fragment,i,l,lTrimmed,r,rTrimmed,trailingSpace;i = 0;l = array.length;fragment = void 0;lTrimmed = false;rTrimmed = false;while(!lTrimmed && i !== l) {fragment = array[i] = array[i].trimLeft();if(fragment){lTrimmed = true;}i++;}i = l - 1;while(l && !rTrimmed && i !== -1) {fragment = array[i] = array[i].trimRight();if(fragment){rTrimmed = true;}i--;}r = /\s+$/g;trailingSpace = true;i = 0;while(i !== l) { // Leave the line breaks intact
	if(array[i] != '\u2028'){fragment = array[i].replace(/\s+/g," ");if(trailingSpace){fragment = fragment.trimLeft();}if(fragment){trailingSpace = r.test(fragment);}array[i] = fragment;}i++;}return array;};Renderer = function Renderer(pdf,x,y,settings){this.pdf = pdf;this.x = x;this.y = y;this.settings = settings; //list of functions which are called after each element-rendering process
	this.watchFunctions = [];this.init();return this;};ResolveFont = function ResolveFont(css_font_family_string){var name,part,parts;name = void 0;parts = css_font_family_string.split(",");part = parts.shift();while(!name && part) {name = FontNameDB[part.trim().toLowerCase()];part = parts.shift();}return name;};ResolveUnitedNumber = function ResolveUnitedNumber(css_line_height_string){ //IE8 issues
	css_line_height_string = css_line_height_string === "auto"?"0px":css_line_height_string;if(css_line_height_string.indexOf("em") > -1 && !isNaN(Number(css_line_height_string.replace("em","")))){css_line_height_string = Number(css_line_height_string.replace("em","")) * 18.719 + "px";}if(css_line_height_string.indexOf("pt") > -1 && !isNaN(Number(css_line_height_string.replace("pt","")))){css_line_height_string = Number(css_line_height_string.replace("pt","")) * 1.333 + "px";}var normal,undef,value;undef = void 0;normal = 16.00;value = UnitedNumberMap[css_line_height_string];if(value){return value;}value = ({"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0})[{css_line_height_string:css_line_height_string}];if(value !== undef){return UnitedNumberMap[css_line_height_string] = value / normal;}if(value = parseFloat(css_line_height_string)){return UnitedNumberMap[css_line_height_string] = value / normal;}value = css_line_height_string.match(/([\d\.]+)(px)/);if(value.length === 3){return UnitedNumberMap[css_line_height_string] = parseFloat(value[1]) / normal;}return UnitedNumberMap[css_line_height_string] = 1;};GetCSS = function GetCSS(element){var css,tmp,computedCSSElement;computedCSSElement = (function(el){var compCSS;compCSS = (function(el){if(document.defaultView && document.defaultView.getComputedStyle){return document.defaultView.getComputedStyle(el,null);}else if(el.currentStyle){return el.currentStyle;}else {return el.style;}})(el);return function(prop){prop = prop.replace(/-\D/g,function(match){return match.charAt(1).toUpperCase();});return compCSS[prop];};})(element);css = {};tmp = void 0;css["font-family"] = ResolveFont(computedCSSElement("font-family")) || "times";css["font-style"] = FontStyleMap[computedCSSElement("font-style")] || "normal";css["text-align"] = TextAlignMap[computedCSSElement("text-align")] || "left";tmp = FontWeightMap[computedCSSElement("font-weight")] || "normal";if(tmp === "bold"){if(css["font-style"] === "normal"){css["font-style"] = tmp;}else {css["font-style"] = tmp + css["font-style"];}}css["font-size"] = ResolveUnitedNumber(computedCSSElement("font-size")) || 1;css["line-height"] = ResolveUnitedNumber(computedCSSElement("line-height")) || 1;css["display"] = computedCSSElement("display") === "inline"?"inline":"block";tmp = css["display"] === "block";css["margin-top"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-top")) || 0;css["margin-bottom"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-bottom")) || 0;css["padding-top"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-top")) || 0;css["padding-bottom"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-bottom")) || 0;css["margin-left"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-left")) || 0;css["margin-right"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-right")) || 0;css["padding-left"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-left")) || 0;css["padding-right"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-right")) || 0;css["page-break-before"] = computedCSSElement("page-break-before") || "auto"; //float and clearing of floats
	css["float"] = FloatMap[computedCSSElement("cssFloat")] || "none";css["clear"] = ClearMap[computedCSSElement("clear")] || "none";css["color"] = computedCSSElement("color");return css;};elementHandledElsewhere = function elementHandledElsewhere(element,renderer,elementHandlers){var handlers,i,isHandledElsewhere,l,classNames;isHandledElsewhere = false;i = void 0;l = void 0;handlers = elementHandlers["#" + element.id];if(handlers){if(typeof handlers === "function"){isHandledElsewhere = handlers(element,renderer);}else {i = 0;l = handlers.length;while(!isHandledElsewhere && i !== l) {isHandledElsewhere = handlers[i](element,renderer);i++;}}}handlers = elementHandlers[element.nodeName];if(!isHandledElsewhere && handlers){if(typeof handlers === "function"){isHandledElsewhere = handlers(element,renderer);}else {i = 0;l = handlers.length;while(!isHandledElsewhere && i !== l) {isHandledElsewhere = handlers[i](element,renderer);i++;}}} // Try class names
	classNames = element.className?element.className.split(' '):[];for(i = 0;i < classNames.length;i++) {handlers = elementHandlers['.' + classNames[i]];if(!isHandledElsewhere && handlers){if(typeof handlers === "function"){isHandledElsewhere = handlers(element,renderer);}else {i = 0;l = handlers.length;while(!isHandledElsewhere && i !== l) {isHandledElsewhere = handlers[i](element,renderer);i++;}}}}return isHandledElsewhere;};tableToJson = function tableToJson(table,renderer){var data,headers,i,j,rowData,tableRow,table_obj,table_with,cell,l;data = [];headers = [];i = 0;l = table.rows[0].cells.length;table_with = table.clientWidth;while(i < l) {cell = table.rows[0].cells[i];headers[i] = {name:cell.textContent.toLowerCase().replace(/\s+/g,''),prompt:cell.textContent.replace(/\r?\n/g,''),width:cell.clientWidth / table_with * renderer.pdf.internal.pageSize.width};i++;}i = 1;while(i < table.rows.length) {tableRow = table.rows[i];rowData = {};j = 0;while(j < tableRow.cells.length) {rowData[headers[j].name] = tableRow.cells[j].textContent.replace(/\r?\n/g,'');j++;}data.push(rowData);i++;}return table_obj = {rows:data,headers:headers};};var SkipNode={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1};var listCount=1;_DrillForContent = function DrillForContent(element,renderer,elementHandlers){var cn,cns,fragmentCSS,i,isBlock,l,px2pt,table2json,cb;cns = element.childNodes;cn = void 0;fragmentCSS = GetCSS(element);isBlock = fragmentCSS.display === "block";if(isBlock){renderer.setBlockBoundary();renderer.setBlockStyle(fragmentCSS);}i = 0;l = cns.length;while(i < l) {cn = cns[i];if((typeof cn === "undefined"?"undefined":_typeof(cn)) === "object"){ //execute all watcher functions to e.g. reset floating
	renderer.executeWatchFunctions(cn); /*** HEADER rendering **/if(cn.nodeType === 1 && cn.nodeName === 'HEADER'){var header=cn; //store old top margin
	var oldMarginTop=renderer.pdf.margins_doc.top; //subscribe for new page event and render header first on every page
	renderer.pdf.internal.events.subscribe('addPage',function(pageInfo){ //set current y position to old margin
	renderer.y = oldMarginTop; //render all child nodes of the header element
	_DrillForContent(header,renderer,elementHandlers); //set margin to old margin + rendered header + 10 space to prevent overlapping
	//important for other plugins (e.g. table) to start rendering at correct position after header
	renderer.pdf.margins_doc.top = renderer.y + 10;renderer.y += 10;},false);}if(cn.nodeType === 8 && cn.nodeName === "#comment"){if(~cn.textContent.indexOf("ADD_PAGE")){renderer.pdf.addPage();renderer.y = renderer.pdf.margins_doc.top;}}else if(cn.nodeType === 1 && !SkipNode[cn.nodeName]){ /*** IMAGE RENDERING ***/var cached_image;if(cn.nodeName === "IMG"){var url=cn.getAttribute("src");cached_image = images[renderer.pdf.sHashCode(url) || url];}if(cached_image){if(renderer.pdf.internal.pageSize.height - renderer.pdf.margins_doc.bottom < renderer.y + cn.height && renderer.y > renderer.pdf.margins_doc.top){renderer.pdf.addPage();renderer.y = renderer.pdf.margins_doc.top; //check if we have to set back some values due to e.g. header rendering for new page
	renderer.executeWatchFunctions(cn);}var imagesCSS=GetCSS(cn);var imageX=renderer.x;var fontToUnitRatio=12 / renderer.pdf.internal.scaleFactor; //define additional paddings, margins which have to be taken into account for margin calculations
	var additionalSpaceLeft=(imagesCSS["margin-left"] + imagesCSS["padding-left"]) * fontToUnitRatio;var additionalSpaceRight=(imagesCSS["margin-right"] + imagesCSS["padding-right"]) * fontToUnitRatio;var additionalSpaceTop=(imagesCSS["margin-top"] + imagesCSS["padding-top"]) * fontToUnitRatio;var additionalSpaceBottom=(imagesCSS["margin-bottom"] + imagesCSS["padding-bottom"]) * fontToUnitRatio; //if float is set to right, move the image to the right border
	//add space if margin is set
	if(imagesCSS['float'] !== undefined && imagesCSS['float'] === 'right'){imageX += renderer.settings.width - cn.width - additionalSpaceRight;}else {imageX += additionalSpaceLeft;}renderer.pdf.addImage(cached_image,imageX,renderer.y + additionalSpaceTop,cn.width,cn.height);cached_image = undefined; //if the float prop is specified we have to float the text around the image
	if(imagesCSS['float'] === 'right' || imagesCSS['float'] === 'left'){ //add functiont to set back coordinates after image rendering
	renderer.watchFunctions.push((function(diffX,thresholdY,diffWidth,el){ //undo drawing box adaptions which were set by floating
	if(renderer.y >= thresholdY){renderer.x += diffX;renderer.settings.width += diffWidth;return true;}else if(el && el.nodeType === 1 && !SkipNode[el.nodeName] && renderer.x + el.width > renderer.pdf.margins_doc.left + renderer.pdf.margins_doc.width){renderer.x += diffX;renderer.y = thresholdY;renderer.settings.width += diffWidth;return true;}else {return false;}}).bind(this,imagesCSS['float'] === 'left'?-cn.width - additionalSpaceLeft - additionalSpaceRight:0,renderer.y + cn.height + additionalSpaceTop + additionalSpaceBottom,cn.width)); //reset floating by clear:both divs
	//just set cursorY after the floating element
	renderer.watchFunctions.push((function(yPositionAfterFloating,pages,el){if(renderer.y < yPositionAfterFloating && pages === renderer.pdf.internal.getNumberOfPages()){if(el.nodeType === 1 && GetCSS(el).clear === 'both'){renderer.y = yPositionAfterFloating;return true;}else {return false;}}else {return true;}}).bind(this,renderer.y + cn.height,renderer.pdf.internal.getNumberOfPages())); //if floating is set we decrease the available width by the image width
	renderer.settings.width -= cn.width + additionalSpaceLeft + additionalSpaceRight; //if left just add the image width to the X coordinate
	if(imagesCSS['float'] === 'left'){renderer.x += cn.width + additionalSpaceLeft + additionalSpaceRight;}}else { //if no floating is set, move the rendering cursor after the image height
	renderer.y += cn.height + additionalSpaceTop + additionalSpaceBottom;} /*** TABLE RENDERING ***/}else if(cn.nodeName === "TABLE"){table2json = tableToJson(cn,renderer);renderer.y += 10;renderer.pdf.table(renderer.x,renderer.y,table2json.rows,table2json.headers,{autoSize:false,printHeaders:elementHandlers.printHeaders,margins:renderer.pdf.margins_doc,css:GetCSS(cn)});renderer.y = renderer.pdf.lastCellPos.y + renderer.pdf.lastCellPos.h + 20;}else if(cn.nodeName === "OL" || cn.nodeName === "UL"){listCount = 1;if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}renderer.y += 10;}else if(cn.nodeName === "LI"){var temp=renderer.x;renderer.x += 20 / renderer.pdf.internal.scaleFactor;renderer.y += 3;if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}renderer.x = temp;}else if(cn.nodeName === "BR"){renderer.y += fragmentCSS["font-size"] * renderer.pdf.internal.scaleFactor;renderer.addText('\u2028',clone(fragmentCSS));}else {if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}}}else if(cn.nodeType === 3){var value=cn.nodeValue;if(cn.nodeValue && cn.parentNode.nodeName === "LI"){if(cn.parentNode.parentNode.nodeName === "OL"){value = listCount++ + '. ' + value;}else {var fontSize=fragmentCSS["font-size"];var offsetX=(3 - fontSize * 0.75) * renderer.pdf.internal.scaleFactor;var offsetY=fontSize * 0.75 * renderer.pdf.internal.scaleFactor;var radius=fontSize * 1.74 / renderer.pdf.internal.scaleFactor;cb = function cb(x,y){this.pdf.circle(x + offsetX,y + offsetY,radius,'FD');};}} // Only add the text if the text node is in the body element
	// Add compatibility with IE11
	if(!!(cn.ownerDocument.body.compareDocumentPosition(cn) & 16)){renderer.addText(value,fragmentCSS);}}else if(typeof cn === "string"){renderer.addText(cn,fragmentCSS);}}i++;}elementHandlers.outY = renderer.y;if(isBlock){return renderer.setBlockBoundary(cb);}};images = {};loadImgs = function loadImgs(element,renderer,elementHandlers,cb){var imgs=element.getElementsByTagName('img'),l=imgs.length,found_images,x=0;function done(){renderer.pdf.internal.events.publish('imagesLoaded');cb(found_images);}function loadImage(url,width,height){if(!url)return;var img=new Image();found_images = ++x;img.crossOrigin = '';img.onerror = img.onload = function(){if(img.complete){ //to support data urls in images, set width and height
	//as those values are not recognized automatically
	if(img.src.indexOf('data:image/') === 0){img.width = width || img.width || 0;img.height = height || img.height || 0;} //if valid image add to known images array
	if(img.width + img.height){var hash=renderer.pdf.sHashCode(url) || url;images[hash] = images[hash] || img;}}if(! --x){done();}};img.src = url;}while(l--) {loadImage(imgs[l].getAttribute("src"),imgs[l].width,imgs[l].height);}return x || done();};checkForFooter = function checkForFooter(elem,renderer,elementHandlers){ //check if we can found a <footer> element
	var footer=elem.getElementsByTagName("footer");if(footer.length > 0){footer = footer[0]; //bad hack to get height of footer
	//creat dummy out and check new y after fake rendering
	var oldOut=renderer.pdf.internal.write;var oldY=renderer.y;renderer.pdf.internal.write = function(){};_DrillForContent(footer,renderer,elementHandlers);var footerHeight=Math.ceil(renderer.y - oldY) + 5;renderer.y = oldY;renderer.pdf.internal.write = oldOut; //add 20% to prevent overlapping
	renderer.pdf.margins_doc.bottom += footerHeight; //Create function render header on every page
	var renderFooter=function renderFooter(pageInfo){var pageNumber=pageInfo !== undefined?pageInfo.pageNumber:1; //set current y position to old margin
	var oldPosition=renderer.y; //render all child nodes of the header element
	renderer.y = renderer.pdf.internal.pageSize.height - renderer.pdf.margins_doc.bottom;renderer.pdf.margins_doc.bottom -= footerHeight; //check if we have to add page numbers
	var spans=footer.getElementsByTagName('span');for(var i=0;i < spans.length;++i) { //if we find some span element with class pageCounter, set the page
	if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" pageCounter ") > -1){spans[i].innerHTML = pageNumber;} //if we find some span element with class totalPages, set a variable which is replaced after rendering of all pages
	if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" totalPages ") > -1){spans[i].innerHTML = '###jsPDFVarTotalPages###';}} //render footer content
	_DrillForContent(footer,renderer,elementHandlers); //set bottom margin to previous height including the footer height
	renderer.pdf.margins_doc.bottom += footerHeight; //important for other plugins (e.g. table) to start rendering at correct position after header
	renderer.y = oldPosition;}; //check if footer contains totalPages which should be replace at the disoposal of the document
	var spans=footer.getElementsByTagName('span');for(var i=0;i < spans.length;++i) {if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" totalPages ") > -1){renderer.pdf.internal.events.subscribe('htmlRenderingFinished',renderer.pdf.putTotalPages.bind(renderer.pdf,'###jsPDFVarTotalPages###'),true);}} //register event to render footer on every new page
	renderer.pdf.internal.events.subscribe('addPage',renderFooter,false); //render footer on first page
	renderFooter(); //prevent footer rendering
	SkipNode['FOOTER'] = 1;}};process = function process(pdf,element,x,y,settings,callback){if(!element)return false;if(typeof element !== "string" && !element.parentNode)element = '' + element.innerHTML;if(typeof element === "string"){element = (function(element){var $frame,$hiddendiv,framename,visuallyhidden;framename = "jsPDFhtmlText" + Date.now().toString() + (Math.random() * 1000).toFixed(0);visuallyhidden = "position: absolute !important;" + "clip: rect(1px 1px 1px 1px); /* IE6, IE7 */" + "clip: rect(1px, 1px, 1px, 1px);" + "padding:0 !important;" + "border:0 !important;" + "height: 1px !important;" + "width: 1px !important; " + "top:auto;" + "left:-100px;" + "overflow: hidden;";$hiddendiv = document.createElement('div');$hiddendiv.style.cssText = visuallyhidden;$hiddendiv.innerHTML = "<iframe style=\"height:1px;width:1px\" name=\"" + framename + "\" />";document.body.appendChild($hiddendiv);$frame = window.frames[framename];$frame.document.open();$frame.document.writeln(element);$frame.document.close();return $frame.document.body;})(element.replace(/<\/?script[^>]*?>/gi,''));}var r=new Renderer(pdf,x,y,settings),out; // 1. load images
	// 2. prepare optional footer elements
	// 3. render content
	loadImgs.call(this,element,r,settings.elementHandlers,function(found_images){checkForFooter(element,r,settings.elementHandlers);_DrillForContent(element,r,settings.elementHandlers); //send event dispose for final taks (e.g. footer totalpage replacement)
	r.pdf.internal.events.publish('htmlRenderingFinished');out = r.dispose();if(typeof callback === 'function')callback(out);else if(found_images)console.error('jsPDF Warning: rendering issues? provide a callback to fromHTML!');});return out || {x:r.x,y:r.y};};Renderer.prototype.init = function(){this.paragraph = {text:[],style:[]};return this.pdf.internal.write("q");};Renderer.prototype.dispose = function(){this.pdf.internal.write("Q");return {x:this.x,y:this.y,ready:true};}; //Checks if we have to execute some watcher functions
	//e.g. to end text floating around an image
	Renderer.prototype.executeWatchFunctions = function(el){var ret=false;var narray=[];if(this.watchFunctions.length > 0){for(var i=0;i < this.watchFunctions.length;++i) {if(this.watchFunctions[i](el) === true){ret = true;}else {narray.push(this.watchFunctions[i]);}}this.watchFunctions = narray;}return ret;};Renderer.prototype.splitFragmentsIntoLines = function(fragments,styles){var currentLineLength,defaultFontSize,ff,fontMetrics,fontMetricsCache,fragment,fragmentChopped,fragmentLength,fragmentSpecificMetrics,fs,k,line,lines,maxLineLength,style;defaultFontSize = 12;k = this.pdf.internal.scaleFactor;fontMetricsCache = {};ff = void 0;fs = void 0;fontMetrics = void 0;fragment = void 0;style = void 0;fragmentSpecificMetrics = void 0;fragmentLength = void 0;fragmentChopped = void 0;line = [];lines = [line];currentLineLength = 0;maxLineLength = this.settings.width;while(fragments.length) {fragment = fragments.shift();style = styles.shift();if(fragment){ff = style["font-family"];fs = style["font-style"];fontMetrics = fontMetricsCache[ff + fs];if(!fontMetrics){fontMetrics = this.pdf.internal.getFont(ff,fs).metadata.Unicode;fontMetricsCache[ff + fs] = fontMetrics;}fragmentSpecificMetrics = {widths:fontMetrics.widths,kerning:fontMetrics.kerning,fontSize:style["font-size"] * defaultFontSize,textIndent:currentLineLength};fragmentLength = this.pdf.getStringUnitWidth(fragment,fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;if(fragment == '\u2028'){line = [];lines.push(line);}else if(currentLineLength + fragmentLength > maxLineLength){fragmentChopped = this.pdf.splitTextToSize(fragment,maxLineLength,fragmentSpecificMetrics);line.push([fragmentChopped.shift(),style]);while(fragmentChopped.length) {line = [[fragmentChopped.shift(),style]];lines.push(line);}currentLineLength = this.pdf.getStringUnitWidth(line[0][0],fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;}else {line.push([fragment,style]);currentLineLength += fragmentLength;}}} //if text alignment was set, set margin/indent of each line
	if(style['text-align'] !== undefined && (style['text-align'] === 'center' || style['text-align'] === 'right' || style['text-align'] === 'justify')){for(var i=0;i < lines.length;++i) {var length=this.pdf.getStringUnitWidth(lines[i][0][0],fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k; //if there is more than on line we have to clone the style object as all lines hold a reference on this object
	if(i > 0){lines[i][0][1] = clone(lines[i][0][1]);}var space=maxLineLength - length;if(style['text-align'] === 'right'){lines[i][0][1]['margin-left'] = space; //if alignment is not right, it has to be center so split the space to the left and the right
	}else if(style['text-align'] === 'center'){lines[i][0][1]['margin-left'] = space / 2; //if justify was set, calculate the word spacing and define in by using the css property
	}else if(style['text-align'] === 'justify'){var countSpaces=lines[i][0][0].split(' ').length - 1;lines[i][0][1]['word-spacing'] = space / countSpaces; //ignore the last line in justify mode
	if(i === lines.length - 1){lines[i][0][1]['word-spacing'] = 0;}}}}return lines;};Renderer.prototype.RenderTextFragment = function(text,style){var defaultFontSize,font,maxLineHeight;maxLineHeight = 0;defaultFontSize = 12;if(this.pdf.internal.pageSize.height - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize()){this.pdf.internal.write("ET","Q");this.pdf.addPage();this.y = this.pdf.margins_doc.top;this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),style.color,"Td"); //move cursor by one line on new page
	maxLineHeight = Math.max(maxLineHeight,style["line-height"],style["font-size"]);this.pdf.internal.write(0,(-1 * defaultFontSize * maxLineHeight).toFixed(2),"Td");}font = this.pdf.internal.getFont(style["font-family"],style["font-style"]); // text color
	var pdfTextColor=this.getPdfColor(style["color"]);if(pdfTextColor !== this.lastTextColor){this.pdf.internal.write(pdfTextColor);this.lastTextColor = pdfTextColor;} //set the word spacing for e.g. justify style
	if(style['word-spacing'] !== undefined && style['word-spacing'] > 0){this.pdf.internal.write(style['word-spacing'].toFixed(2),"Tw");}this.pdf.internal.write("/" + font.id,(defaultFontSize * style["font-size"]).toFixed(2),"Tf","(" + this.pdf.internal.pdfEscape(text) + ") Tj"); //set the word spacing back to neutral => 0
	if(style['word-spacing'] !== undefined){this.pdf.internal.write(0,"Tw");}}; // Accepts #FFFFFF, rgb(int,int,int), or CSS Color Name
	Renderer.prototype.getPdfColor = function(style){var textColor;var r,g,b;var rx=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/;var m=rx.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);}else {if(style.charAt(0) != '#'){style = CssColors.colorNameToHex(style);if(!style){style = '#000000';}}r = style.substring(1,3);r = parseInt(r,16);g = style.substring(3,5);g = parseInt(g,16);b = style.substring(5,7);b = parseInt(b,16);}if(typeof r === 'string' && /^#[0-9A-Fa-f]{6}$/.test(r)){var hex=parseInt(r.substr(1),16);r = hex >> 16 & 255;g = hex >> 8 & 255;b = hex & 255;}var f3=this.f3;if(r === 0 && g === 0 && b === 0 || typeof g === 'undefined'){textColor = f3(r / 255) + ' g';}else {textColor = [f3(r / 255),f3(g / 255),f3(b / 255),'rg'].join(' ');}return textColor;};Renderer.prototype.f3 = function(number){return number.toFixed(3); // Ie, %.3f
	},Renderer.prototype.renderParagraph = function(cb){var blockstyle,defaultFontSize,fontToUnitRatio,fragments,i,l,line,lines,maxLineHeight,out,paragraphspacing_after,paragraphspacing_before,priorblockstyle,styles,fontSize;fragments = PurgeWhiteSpace(this.paragraph.text);styles = this.paragraph.style;blockstyle = this.paragraph.blockstyle;this.paragraph = {text:[],style:[],blockstyle:{},priorblockstyle:blockstyle};if(!fragments.join("").trim()){return;}lines = this.splitFragmentsIntoLines(fragments,styles);line = void 0;maxLineHeight = void 0;defaultFontSize = 12;fontToUnitRatio = defaultFontSize / this.pdf.internal.scaleFactor;this.priorMarginBottom = this.priorMarginBottom || 0;paragraphspacing_before = (Math.max((blockstyle["margin-top"] || 0) - this.priorMarginBottom,0) + (blockstyle["padding-top"] || 0)) * fontToUnitRatio;paragraphspacing_after = ((blockstyle["margin-bottom"] || 0) + (blockstyle["padding-bottom"] || 0)) * fontToUnitRatio;this.priorMarginBottom = blockstyle["margin-bottom"] || 0;if(blockstyle['page-break-before'] === 'always'){this.pdf.addPage();this.y = 0;paragraphspacing_before = ((blockstyle["margin-top"] || 0) + (blockstyle["padding-top"] || 0)) * fontToUnitRatio;}out = this.pdf.internal.write;i = void 0;l = void 0;this.y += paragraphspacing_before;out("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"); //stores the current indent of cursor position
	var currentIndent=0;while(lines.length) {line = lines.shift();maxLineHeight = 0;i = 0;l = line.length;while(i !== l) {if(line[i][0].trim()){maxLineHeight = Math.max(maxLineHeight,line[i][1]["line-height"],line[i][1]["font-size"]);fontSize = line[i][1]["font-size"] * 7;}i++;} //if we have to move the cursor to adapt the indent
	var indentMove=0;var wantedIndent=0; //if a margin was added (by e.g. a text-alignment), move the cursor
	if(line[0][1]["margin-left"] !== undefined && line[0][1]["margin-left"] > 0){wantedIndent = this.pdf.internal.getCoordinateString(line[0][1]["margin-left"]);indentMove = wantedIndent - currentIndent;currentIndent = wantedIndent;}var indentMore=Math.max(blockstyle["margin-left"] || 0,0) * fontToUnitRatio; //move the cursor
	out(indentMove + indentMore,(-1 * defaultFontSize * maxLineHeight).toFixed(2),"Td");i = 0;l = line.length;while(i !== l) {if(line[i][0]){this.RenderTextFragment(line[i][0],line[i][1]);}i++;}this.y += maxLineHeight * fontToUnitRatio; //if some watcher function was executed successful, so e.g. margin and widths were changed,
	//reset line drawing and calculate position and lines again
	//e.g. to stop text floating around an image
	if(this.executeWatchFunctions(line[0][1]) && lines.length > 0){var localFragments=[];var localStyles=[]; //create fragment array of
	lines.forEach(function(localLine){var i=0;var l=localLine.length;while(i !== l) {if(localLine[i][0]){localFragments.push(localLine[i][0] + ' ');localStyles.push(localLine[i][1]);}++i;}}); //split lines again due to possible coordinate changes
	lines = this.splitFragmentsIntoLines(PurgeWhiteSpace(localFragments),localStyles); //reposition the current cursor
	out("ET","Q");out("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");}}if(cb && typeof cb === "function"){cb.call(this,this.x - 9,this.y - fontSize / 2);}out("ET","Q");return this.y += paragraphspacing_after;};Renderer.prototype.setBlockBoundary = function(cb){return this.renderParagraph(cb);};Renderer.prototype.setBlockStyle = function(css){return this.paragraph.blockstyle = css;};Renderer.prototype.addText = function(text,css){this.paragraph.text.push(text);return this.paragraph.style.push(css);};FontNameDB = {helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"};FontWeightMap = {100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"};FontStyleMap = {normal:"normal",italic:"italic",oblique:"italic"};TextAlignMap = {left:"left",right:"right",center:"center",justify:"justify"};FloatMap = {none:'none',right:'right',left:'left'};ClearMap = {none:'none',both:'both'};UnitedNumberMap = {normal:1}; /**
	  * Converts HTML-formatted text into formatted PDF text.
	  *
	  * Notes:
	  * 2012-07-18
	  * Plugin relies on having browser, DOM around. The HTML is pushed into dom and traversed.
	  * Plugin relies on jQuery for CSS extraction.
	  * Targeting HTML output from Markdown templating, which is a very simple
	  * markup - div, span, em, strong, p. No br-based paragraph separation supported explicitly (but still may work.)
	  * Images, tables are NOT supported.
	  *
	  * @public
	  * @function
	  * @param HTML {String or DOM Element} HTML-formatted text, or pointer to DOM element that is to be rendered into PDF.
	  * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	  * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	  * @param settings {Object} Additional / optional variables controlling parsing, rendering.
	  * @returns {Object} jsPDF instance
	  */jsPDFAPI.fromHTML = function(HTML,x,y,settings,callback,margins){"use strict";this.margins_doc = margins || {top:0,bottom:0};if(!settings)settings = {};if(!settings.elementHandlers)settings.elementHandlers = {};return process(this,HTML,isNaN(x)?4:x,isNaN(y)?4:y,settings,callback);};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * 
	 * ====================================================================
	 */ /*global jsPDF */(function(jsPDFAPI){'use strict';var jsNamesObj,jsJsObj,text;jsPDFAPI.addJS = function(txt){text = txt;this.internal.events.subscribe('postPutResources',function(txt){jsNamesObj = this.internal.newObject();this.internal.write('<< /Names [(EmbeddedJS) ' + (jsNamesObj + 1) + ' 0 R] >>','endobj');jsJsObj = this.internal.newObject();this.internal.write('<< /S /JavaScript /JS (',text,') >>','endobj');});this.internal.events.subscribe('putCatalog',function(){if(jsNamesObj !== undefined && jsJsObj !== undefined){this.internal.write('/Names <</JavaScript ' + jsNamesObj + ' 0 R>>');}});return this;};})(jsPDF.API); /**
	 * jsPDF Outline PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * Generates a PDF Outline
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['postPutResources',function(){var pdf=this;var rx=/^(\d+) 0 obj$/; // Write action goto objects for each page
	// this.outline.destsGoto = [];
	// for (var i = 0; i < totalPages; i++) {
	// var id = pdf.internal.newObject();
	// this.outline.destsGoto.push(id);
	// pdf.internal.write("<</D[" + (i * 2 + 3) + " 0 R /XYZ null
	// null null]/S/GoTo>> endobj");
	// }
	//
	// for (var i = 0; i < dests.length; i++) {
	// pdf.internal.write("(page_" + (i + 1) + ")" + dests[i] + " 0
	// R");
	// }
	//				
	if(this.outline.root.children.length > 0){var lines=pdf.outline.render().split(/\r\n/);for(var i=0;i < lines.length;i++) {var line=lines[i];var m=rx.exec(line);if(m != null){var oid=m[1];pdf.internal.newObjectDeferredBegin(oid);}pdf.internal.write(line);}} // This code will write named destination for each page reference
	// (page_1, etc)
	if(this.outline.createNamedDestinations){var totalPages=this.internal.pages.length; // WARNING: this assumes jsPDF starts on page 3 and pageIDs
	// follow 5, 7, 9, etc
	// Write destination objects for each page
	var dests=[];for(var i=0;i < totalPages;i++) {var id=pdf.internal.newObject();dests.push(id);var info=pdf.internal.getPageInfo(i + 1);pdf.internal.write("<< /D[" + info.objId + " 0 R /XYZ null null null]>> endobj");} // assign a name for each destination
	var names2Oid=pdf.internal.newObject();pdf.internal.write('<< /Names [ ');for(var i=0;i < dests.length;i++) {pdf.internal.write("(page_" + (i + 1) + ")" + dests[i] + " 0 R");}pdf.internal.write(' ] >>','endobj'); // var kids = pdf.internal.newObject();
	// pdf.internal.write('<< /Kids [ ' + names2Oid + ' 0 R');
	// pdf.internal.write(' ] >>', 'endobj');
	var namesOid=pdf.internal.newObject();pdf.internal.write('<< /Dests ' + names2Oid + " 0 R");pdf.internal.write('>>','endobj');}}]);jsPDFAPI.events.push(['putCatalog',function(){var pdf=this;if(pdf.outline.root.children.length > 0){pdf.internal.write("/Outlines",this.outline.makeRef(this.outline.root));if(this.outline.createNamedDestinations){pdf.internal.write("/Names " + namesOid + " 0 R");} // Open with Bookmarks showing
	// pdf.internal.write("/PageMode /UseOutlines");
	}}]);jsPDFAPI.events.push(['initialized',function(){var pdf=this;pdf.outline = {createNamedDestinations:false,root:{children:[]}};pdf.outline.add = function(parent,title,options){var item={title:title,options:options,children:[]};if(parent == null){parent = this.root;}parent.children.push(item);return item;};pdf.outline.render = function(){this.ctx = {};this.ctx.val = '';this.ctx.pdf = pdf;this.genIds_r(this.root);this.renderRoot(this.root);this.renderItems(this.root);return this.ctx.val;};pdf.outline.genIds_r = function(node){node.id = pdf.internal.newObjectDeferred();for(var i=0;i < node.children.length;i++) {this.genIds_r(node.children[i]);}};pdf.outline.renderRoot = function(node){this.objStart(node);this.line('/Type /Outlines');if(node.children.length > 0){this.line('/First ' + this.makeRef(node.children[0]));this.line('/Last ' + this.makeRef(node.children[node.children.length - 1]));}this.line('/Count ' + this.count_r({count:0},node));this.objEnd();};pdf.outline.renderItems = function(node){for(var i=0;i < node.children.length;i++) {var item=node.children[i];this.objStart(item);this.line('/Title ' + this.makeString(item.title));this.line('/Parent ' + this.makeRef(node));if(i > 0){this.line('/Prev ' + this.makeRef(node.children[i - 1]));}if(i < node.children.length - 1){this.line('/Next ' + this.makeRef(node.children[i + 1]));}if(item.children.length > 0){this.line('/First ' + this.makeRef(item.children[0]));this.line('/Last ' + this.makeRef(item.children[item.children.length - 1]));}var count=this.count = this.count_r({count:0},item);if(count > 0){this.line('/Count ' + count);}if(item.options){if(item.options.pageNumber){ // Explicit Destination
	//WARNING this assumes page ids are 3,5,7, etc.
	var info=pdf.internal.getPageInfo(item.options.pageNumber);this.line('/Dest ' + '[' + info.objId + ' 0 R /XYZ 0 ' + this.ctx.pdf.internal.pageSize.height + ' 0]'); // this line does not work on all clients (pageNumber instead of page ref)
	//this.line('/Dest ' + '[' + (item.options.pageNumber - 1) + ' /XYZ 0 ' + this.ctx.pdf.internal.pageSize.height + ' 0]');
	// Named Destination
	// this.line('/Dest (page_' + (item.options.pageNumber) + ')');
	// Action Destination
	// var id = pdf.internal.newObject();
	// pdf.internal.write('<</D[' + (item.options.pageNumber - 1) + ' /XYZ null null null]/S/GoTo>> endobj');
	// this.line('/A ' + id + ' 0 R' );
	}}this.objEnd();}for(var i=0;i < node.children.length;i++) {var item=node.children[i];this.renderItems(item);}};pdf.outline.line = function(text){this.ctx.val += text + '\r\n';};pdf.outline.makeRef = function(node){return node.id + ' 0 R';};pdf.outline.makeString = function(val){return '(' + pdf.internal.pdfEscape(val) + ')';};pdf.outline.objStart = function(node){this.ctx.val += '\r\n' + node.id + ' 0 obj' + '\r\n<<\r\n';};pdf.outline.objEnd = function(node){this.ctx.val += '>> \r\n' + 'endobj' + '\r\n';};pdf.outline.count_r = function(ctx,node){for(var i=0;i < node.children.length;i++) {ctx.count++;this.count_r(ctx,node.children[i]);}return ctx.count;};}]);return this;})(jsPDF.API); /**@preserve
	 *  ====================================================================
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /*
	  * @see http://www.w3.org/TR/PNG-Chunks.html
	  *
	  Color    Allowed      Interpretation
	  Type     Bit Depths
	 	   0       1,2,4,8,16  Each pixel is a grayscale sample.
	 	   2       8,16        Each pixel is an R,G,B triple.
	 	   3       1,2,4,8     Each pixel is a palette index;
	                        a PLTE chunk must appear.
	 	   4       8,16        Each pixel is a grayscale sample,
	                        followed by an alpha sample.
	 	   6       8,16        Each pixel is an R,G,B triple,
	                        followed by an alpha sample.
	 */ /*
	  * PNG filter method types
	  *
	  * @see http://www.w3.org/TR/PNG-Filters.html
	  * @see http://www.libpng.org/pub/png/book/chapter09.html
	  *
	  * This is what the value 'Predictor' in decode params relates to
	  *
	  * 15 is "optimal prediction", which means the prediction algorithm can change from line to line.
	  * In that case, you actually have to read the first byte off each line for the prediction algorthim (which should be 0-4, corresponding to PDF 10-14) and select the appropriate unprediction algorithm based on that byte.
	  *
	    0       None
	    1       Sub
	    2       Up
	    3       Average
	    4       Paeth
	  */var doesNotHavePngJS=function doesNotHavePngJS(){return typeof PNG !== 'function' || typeof FlateStream !== 'function';},canCompress=function canCompress(value){return value !== jsPDFAPI.image_compression.NONE && hasCompressionJS();},hasCompressionJS=function hasCompressionJS(){var inst=typeof Deflater === 'function';if(!inst)throw new Error("requires deflate.js for compression");return inst;},compressBytes=function compressBytes(bytes,lineLength,colorsPerPixel,compression){var level=5,filter_method=filterUp;switch(compression){case jsPDFAPI.image_compression.FAST:level = 3;filter_method = filterSub;break;case jsPDFAPI.image_compression.MEDIUM:level = 6;filter_method = filterAverage;break;case jsPDFAPI.image_compression.SLOW:level = 9;filter_method = filterPaeth; //uses to sum to choose best filter for each line
	break;}bytes = applyPngFilterMethod(bytes,lineLength,colorsPerPixel,filter_method);var header=new Uint8Array(createZlibHeader(level));var checksum=adler32(bytes);var deflate=new Deflater(level);var a=deflate.append(bytes);var cBytes=deflate.flush();var len=header.length + a.length + cBytes.length;var cmpd=new Uint8Array(len + 4);cmpd.set(header);cmpd.set(a,header.length);cmpd.set(cBytes,header.length + a.length);cmpd[len++] = checksum >>> 24 & 0xff;cmpd[len++] = checksum >>> 16 & 0xff;cmpd[len++] = checksum >>> 8 & 0xff;cmpd[len++] = checksum & 0xff;return jsPDFAPI.arrayBufferToBinaryString(cmpd);},createZlibHeader=function createZlibHeader(bytes,level){ /*
	   * @see http://www.ietf.org/rfc/rfc1950.txt for zlib header
	   */var cm=8;var cinfo=Math.LOG2E * Math.log(0x8000) - 8;var cmf=cinfo << 4 | cm;var hdr=cmf << 8;var flevel=Math.min(3,(level - 1 & 0xff) >> 1);hdr |= flevel << 6;hdr |= 0; //FDICT
	hdr += 31 - hdr % 31;return [cmf,hdr & 0xff & 0xff];},adler32=function adler32(array,param){var adler=1;var s1=adler & 0xffff,s2=adler >>> 16 & 0xffff;var len=array.length;var tlen;var i=0;while(len > 0) {tlen = len > param?param:len;len -= tlen;do {s1 += array[i++];s2 += s1;}while(--tlen);s1 %= 65521;s2 %= 65521;}return (s2 << 16 | s1) >>> 0;},applyPngFilterMethod=function applyPngFilterMethod(bytes,lineLength,colorsPerPixel,filter_method){var lines=bytes.length / lineLength,result=new Uint8Array(bytes.length + lines),filter_methods=getFilterMethods(),i=0,line,prevLine,offset;for(;i < lines;i++) {offset = i * lineLength;line = bytes.subarray(offset,offset + lineLength);if(filter_method){result.set(filter_method(line,colorsPerPixel,prevLine),offset + i);}else {var j=0,len=filter_methods.length,results=[];for(;j < len;j++) {results[j] = filter_methods[j](line,colorsPerPixel,prevLine);}var ind=getIndexOfSmallestSum(results.concat());result.set(results[ind],offset + i);}prevLine = line;}return result;},filterNone=function filterNone(line,colorsPerPixel,prevLine){ /*var result = new Uint8Array(line.length + 1);
	  result[0] = 0;
	  result.set(line, 1);*/var result=Array.apply([],line);result.unshift(0);return result;},filterSub=function filterSub(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left;result[0] = 1;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;result[i + 1] = line[i] - left + 0x0100 & 0xff;}return result;},filterUp=function filterUp(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,up;result[0] = 2;for(;i < len;i++) {up = prevLine && prevLine[i] || 0;result[i + 1] = line[i] - up + 0x0100 & 0xff;}return result;},filterAverage=function filterAverage(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left,up;result[0] = 3;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;up = prevLine && prevLine[i] || 0;result[i + 1] = line[i] + 0x0100 - (left + up >>> 1) & 0xff;}return result;},filterPaeth=function filterPaeth(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left,up,upLeft,paeth;result[0] = 4;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;up = prevLine && prevLine[i] || 0;upLeft = prevLine && prevLine[i - colorsPerPixel] || 0;paeth = paethPredictor(left,up,upLeft);result[i + 1] = line[i] - paeth + 0x0100 & 0xff;}return result;},paethPredictor=function paethPredictor(left,up,upLeft){var p=left + up - upLeft,pLeft=Math.abs(p - left),pUp=Math.abs(p - up),pUpLeft=Math.abs(p - upLeft);return pLeft <= pUp && pLeft <= pUpLeft?left:pUp <= pUpLeft?up:upLeft;},getFilterMethods=function getFilterMethods(){return [filterNone,filterSub,filterUp,filterAverage,filterPaeth];},getIndexOfSmallestSum=function getIndexOfSmallestSum(arrays){var i=0,len=arrays.length,sum,min,ind;while(i < len) {sum = absSum(arrays[i].slice(1));if(sum < min || !min){min = sum;ind = i;}i++;}return ind;},absSum=function absSum(array){var i=0,len=array.length,sum=0;while(i < len) {sum += Math.abs(array[i++]);}return sum;},getPredictorFromCompression=function getPredictorFromCompression(compression){var predictor;switch(compression){case jsPDFAPI.image_compression.FAST:predictor = 11;break;case jsPDFAPI.image_compression.MEDIUM:predictor = 13;break;case jsPDFAPI.image_compression.SLOW:predictor = 14;break;default:predictor = 12;break;}return predictor;};jsPDFAPI.processPNG = function(imageData,imageIndex,alias,compression,dataAsBinaryString){'use strict';var colorSpace=this.color_spaces.DEVICE_RGB,decode=this.decode.FLATE_DECODE,bpc=8,img,dp,trns,colors,pal,smask; /*	if(this.isString(imageData)) {
	  		}*/if(this.isArrayBuffer(imageData))imageData = new Uint8Array(imageData);if(this.isArrayBufferView(imageData)){if(doesNotHavePngJS())throw new Error("PNG support requires png.js and zlib.js");img = new PNG(imageData);imageData = img.imgData;bpc = img.bits;colorSpace = img.colorSpace;colors = img.colors; //logImg(img);
	/*
	    * colorType 6 - Each pixel is an R,G,B triple, followed by an alpha sample.
	    *
	    * colorType 4 - Each pixel is a grayscale sample, followed by an alpha sample.
	    *
	    * Extract alpha to create two separate images, using the alpha as a sMask
	    */if([4,6].indexOf(img.colorType) !== -1){ /*
	     * processes 8 bit RGBA and grayscale + alpha images
	     */if(img.bits === 8){var pixels=img.pixelBitlength == 32?new Uint32Array(img.decodePixels().buffer):img.pixelBitlength == 16?new Uint16Array(img.decodePixels().buffer):new Uint8Array(img.decodePixels().buffer),len=pixels.length,imgData=new Uint8Array(len * img.colors),alphaData=new Uint8Array(len),pDiff=img.pixelBitlength - img.bits,i=0,n=0,pixel,pbl;for(;i < len;i++) {pixel = pixels[i];pbl = 0;while(pbl < pDiff) {imgData[n++] = pixel >>> pbl & 0xff;pbl = pbl + img.bits;}alphaData[i] = pixel >>> pbl & 0xff;}} /*
	     * processes 16 bit RGBA and grayscale + alpha images
	     */if(img.bits === 16){var pixels=new Uint32Array(img.decodePixels().buffer),len=pixels.length,imgData=new Uint8Array(len * (32 / img.pixelBitlength) * img.colors),alphaData=new Uint8Array(len * (32 / img.pixelBitlength)),hasColors=img.colors > 1,i=0,n=0,a=0,pixel;while(i < len) {pixel = pixels[i++];imgData[n++] = pixel >>> 0 & 0xFF;if(hasColors){imgData[n++] = pixel >>> 16 & 0xFF;pixel = pixels[i++];imgData[n++] = pixel >>> 0 & 0xFF;}alphaData[a++] = pixel >>> 16 & 0xFF;}bpc = 8;}if(canCompress(compression)){imageData = compressBytes(imgData,img.width * img.colors,img.colors,compression);smask = compressBytes(alphaData,img.width,1,compression);}else {imageData = imgData;smask = alphaData;decode = null;}} /*
	    * Indexed png. Each pixel is a palette index.
	    */if(img.colorType === 3){colorSpace = this.color_spaces.INDEXED;pal = img.palette;if(img.transparency.indexed){var trans=img.transparency.indexed;var total=0,i=0,len=trans.length;for(;i < len;++i) {total += trans[i];}total = total / 255; /*
	      * a single color is specified as 100% transparent (0),
	      * so we set trns to use a /Mask with that index
	      */if(total === len - 1 && trans.indexOf(0) !== -1){trns = [trans.indexOf(0)]; /*
	       * there's more than one colour within the palette that specifies
	       * a transparency value less than 255, so we unroll the pixels to create an image sMask
	       */}else if(total !== len){var pixels=img.decodePixels(),alphaData=new Uint8Array(pixels.length),i=0,len=pixels.length;for(;i < len;i++) {alphaData[i] = trans[pixels[i]];}smask = compressBytes(alphaData,img.width,1);}}}var predictor=getPredictorFromCompression(compression);if(decode === this.decode.FLATE_DECODE)dp = '/Predictor ' + predictor + ' /Colors ' + colors + ' /BitsPerComponent ' + bpc + ' /Columns ' + img.width;else  //remove 'Predictor' as it applies to the type of png filter applied to its IDAT - we only apply with compression
	dp = '/Colors ' + colors + ' /BitsPerComponent ' + bpc + ' /Columns ' + img.width;if(this.isArrayBuffer(imageData) || this.isArrayBufferView(imageData))imageData = this.arrayBufferToBinaryString(imageData);if(smask && this.isArrayBuffer(smask) || this.isArrayBufferView(smask))smask = this.arrayBufferToBinaryString(smask);return this.createImageInfo(imageData,img.width,img.height,colorSpace,bpc,decode,imageIndex,alias,dp,trns,pal,smask,predictor);}throw new Error("Unsupported PNG image data, try using JPEG instead.");};})(jsPDF.API); /**
	 * jsPDF Autoprint Plugin
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.autoPrint = function(){'use strict';var refAutoPrintTag;this.internal.events.subscribe('postPutResources',function(){refAutoPrintTag = this.internal.newObject();this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj");});this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");});return this;};})(jsPDF.API); /** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */ /**
	 * 
	 * ====================================================================
	 */(function(API){'use strict'; /**
	 Returns an array of length matching length of the 'word' string, with each
	 cell ocupied by the width of the char in that position.
	 
	 @function
	 @param word {String}
	 @param widths {Object}
	 @param kerning {Object}
	 @returns {Array}
	 */var getCharWidthsArray=API.getCharWidthsArray = function(text,options){if(!options){options = {};}var widths=options.widths?options.widths:this.internal.getFont().metadata.Unicode.widths,widthsFractionOf=widths.fof?widths.fof:1,kerning=options.kerning?options.kerning:this.internal.getFont().metadata.Unicode.kerning,kerningFractionOf=kerning.fof?kerning.fof:1; // console.log("widths, kergnings", widths, kerning)
	var i,l,char_code,prior_char_code=0, // for kerning
	default_char_width=widths[0] || widthsFractionOf,output=[];for(i = 0,l = text.length;i < l;i++) {char_code = text.charCodeAt(i);output.push((widths[char_code] || default_char_width) / widthsFractionOf + (kerning[char_code] && kerning[char_code][prior_char_code] || 0) / kerningFractionOf);prior_char_code = char_code;}return output;};var getArraySum=function getArraySum(array){var i=array.length,output=0;while(i) {i--;output += array[i];}return output;}; /**
	 Returns a widths of string in a given font, if the font size is set as 1 point.
	 
	 In other words, this is "proportional" value. For 1 unit of font size, the length
	 of the string will be that much.
	 
	 Multiply by font size to get actual width in *points*
	 Then divide by 72 to get inches or divide by (72/25.6) to get 'mm' etc.
	 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */var getStringUnitWidth=API.getStringUnitWidth = function(text,options){return getArraySum(getCharWidthsArray.call(this,text,options));}; /**
	 returns array of lines
	 */var splitLongWord=function splitLongWord(word,widths_array,firstLineMaxLen,maxLen){var answer=[]; // 1st, chop off the piece that can fit on the hanging line.
	var i=0,l=word.length,workingLen=0;while(i !== l && workingLen + widths_array[i] < firstLineMaxLen) {workingLen += widths_array[i];i++;} // this is first line.
	answer.push(word.slice(0,i)); // 2nd. Split the rest into maxLen pieces.
	var startOfLine=i;workingLen = 0;while(i !== l) {if(workingLen + widths_array[i] > maxLen){answer.push(word.slice(startOfLine,i));workingLen = 0;startOfLine = i;}workingLen += widths_array[i];i++;}if(startOfLine !== i){answer.push(word.slice(startOfLine,i));}return answer;}; // Note, all sizing inputs for this function must be in "font measurement units"
	// By default, for PDF, it's "point".
	var splitParagraphIntoLines=function splitParagraphIntoLines(text,maxlen,options){ // at this time works only on Western scripts, ones with space char
	// separating the words. Feel free to expand.
	if(!options){options = {};}var line=[],lines=[line],line_length=options.textIndent || 0,separator_length=0,current_word_length=0,word,widths_array,words=text.split(' '),spaceCharWidth=getCharWidthsArray(' ',options)[0],i,l,tmp,lineIndent;if(options.lineIndent === -1){lineIndent = words[0].length + 2;}else {lineIndent = options.lineIndent || 0;}if(lineIndent){var pad=Array(lineIndent).join(" "),wrds=[];words.map(function(wrd){wrd = wrd.split(/\s*\n/);if(wrd.length > 1){wrds = wrds.concat(wrd.map(function(wrd,idx){return (idx && wrd.length?"\n":"") + wrd;}));}else {wrds.push(wrd[0]);}});words = wrds;lineIndent = getStringUnitWidth(pad,options);}for(i = 0,l = words.length;i < l;i++) {var force=0;word = words[i];if(lineIndent && word[0] == "\n"){word = word.substr(1);force = 1;}widths_array = getCharWidthsArray(word,options);current_word_length = getArraySum(widths_array);if(line_length + separator_length + current_word_length > maxlen || force){if(current_word_length > maxlen){ // this happens when you have space-less long URLs for example.
	// we just chop these to size. We do NOT insert hiphens
	tmp = splitLongWord(word,widths_array,maxlen - (line_length + separator_length),maxlen); // first line we add to existing line object
	line.push(tmp.shift()); // it's ok to have extra space indicator there
	// last line we make into new line object
	line = [tmp.pop()]; // lines in the middle we apped to lines object as whole lines
	while(tmp.length) {lines.push([tmp.shift()]); // single fragment occupies whole line
	}current_word_length = getArraySum(widths_array.slice(word.length - line[0].length));}else { // just put it on a new line
	line = [word];} // now we attach new line to lines
	lines.push(line);line_length = current_word_length + lineIndent;separator_length = spaceCharWidth;}else {line.push(word);line_length += separator_length + current_word_length;separator_length = spaceCharWidth;}}if(lineIndent){var postProcess=function postProcess(ln,idx){return (idx?pad:'') + ln.join(" ");};}else {var postProcess=function postProcess(ln){return ln.join(" ");};}return lines.map(postProcess);}; /**
	 Splits a given string into an array of strings. Uses 'size' value
	 (in measurement units declared as default for the jsPDF instance)
	 and the font's "widths" and "Kerning" tables, where available, to
	 determine display length of a given string for a given font.
	 
	 We use character's 100% of unit size (height) as width when Width
	 table or other default width is not available.
	 
	 @public
	 @function
	 @param text {String} Unencoded, regular JavaScript (Unicode, UTF-16 / UCS-2) string.
	 @param size {Number} Nominal number, measured in units default to this instance of jsPDF.
	 @param options {Object} Optional flags needed for chopper to do the right thing.
	 @returns {Array} with strings chopped to size.
	 */API.splitTextToSize = function(text,maxlen,options){'use strict';if(!options){options = {};}var fsize=options.fontSize || this.internal.getFontSize(),newOptions=(function(options){var widths={0:1},kerning={};if(!options.widths || !options.kerning){var f=this.internal.getFont(options.fontName,options.fontStyle),encoding='Unicode'; // NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE
	// Actual JavaScript-native String's 16bit char codes used.
	// no multi-byte logic here
	if(f.metadata[encoding]){return {widths:f.metadata[encoding].widths || widths,kerning:f.metadata[encoding].kerning || kerning};}}else {return {widths:options.widths,kerning:options.kerning};} // then use default values
	return {widths:widths,kerning:kerning};}).call(this,options); // first we split on end-of-line chars
	var paragraphs;if(Array.isArray(text)){paragraphs = text;}else {paragraphs = text.split(/\r?\n/);} // now we convert size (max length of line) into "font size units"
	// at present time, the "font size unit" is always 'point'
	// 'proportional' means, "in proportion to font size"
	var fontUnit_maxLen=1.0 * this.internal.scaleFactor * maxlen / fsize; // at this time, fsize is always in "points" regardless of the default measurement unit of the doc.
	// this may change in the future?
	// until then, proportional_maxlen is likely to be in 'points'
	// If first line is to be indented (shorter or longer) than maxLen
	// we indicate that by using CSS-style "text-indent" option.
	// here it's in font units too (which is likely 'points')
	// it can be negative (which makes the first line longer than maxLen)
	newOptions.textIndent = options.textIndent?options.textIndent * 1.0 * this.internal.scaleFactor / fsize:0;newOptions.lineIndent = options.lineIndent;var i,l,output=[];for(i = 0,l = paragraphs.length;i < l;i++) {output = output.concat(splitParagraphIntoLines(paragraphs[i],fontUnit_maxLen,newOptions));}return output;};})(jsPDF.API); /** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/ /**
	 * 
	 * ====================================================================
	 */(function(API){'use strict'; /*
	 # reference (Python) versions of 'compress' and 'uncompress'
	 # only 'uncompress' function is featured lower as JavaScript
	 # if you want to unit test "roundtrip", just transcribe the reference
	 # 'compress' function from Python into JavaScript
	 
	 def compress(data):
	 
	 	keys =   '0123456789abcdef'
	 	values = 'klmnopqrstuvwxyz'
	 	mapping = dict(zip(keys, values))
	 	vals = []
	 	for key in data.keys():
	 		value = data[key]
	 		try:
	 			keystring = hex(key)[2:]
	 			keystring = keystring[:-1] + mapping[keystring[-1:]]
	 		except:
	 			keystring = key.join(["'","'"])
	 			#print('Keystring is %s' % keystring)
	 
	 		try:
	 			if value < 0:
	 				valuestring = hex(value)[3:]
	 				numberprefix = '-'
	 			else:
	 				valuestring = hex(value)[2:]
	 				numberprefix = ''
	 			valuestring = numberprefix + valuestring[:-1] + mapping[valuestring[-1:]]
	 		except:
	 			if type(value) == dict:
	 				valuestring = compress(value)
	 			else:
	 				raise Exception("Don't know what to do with value type %s" % type(value))
	 
	 		vals.append(keystring+valuestring)
	 	
	 	return '{' + ''.join(vals) + '}'
	 
	 def uncompress(data):
	 
	 	decoded = '0123456789abcdef'
	 	encoded = 'klmnopqrstuvwxyz'
	 	mapping = dict(zip(encoded, decoded))
	 
	 	sign = +1
	 	stringmode = False
	 	stringparts = []
	 
	 	output = {}
	 
	 	activeobject = output
	 	parentchain = []
	 
	 	keyparts = ''
	 	valueparts = ''
	 
	 	key = None
	 
	 	ending = set(encoded)
	 
	 	i = 1
	 	l = len(data) - 1 # stripping starting, ending {}
	 	while i != l: # stripping {}
	 		# -, {, }, ' are special.
	 
	 		ch = data[i]
	 		i += 1
	 
	 		if ch == "'":
	 			if stringmode:
	 				# end of string mode
	 				stringmode = False
	 				key = ''.join(stringparts)
	 			else:
	 				# start of string mode
	 				stringmode = True
	 				stringparts = []
	 		elif stringmode == True:
	 			#print("Adding %s to stringpart" % ch)
	 			stringparts.append(ch)
	 
	 		elif ch == '{':
	 			# start of object
	 			parentchain.append( [activeobject, key] )
	 			activeobject = {}
	 			key = None
	 			#DEBUG = True
	 		elif ch == '}':
	 			# end of object
	 			parent, key = parentchain.pop()
	 			parent[key] = activeobject
	 			key = None
	 			activeobject = parent
	 			#DEBUG = False
	 
	 		elif ch == '-':
	 			sign = -1
	 		else:
	 			# must be number
	 			if key == None:
	 				#debug("In Key. It is '%s', ch is '%s'" % (keyparts, ch))
	 				if ch in ending:
	 					#debug("End of key")
	 					keyparts += mapping[ch]
	 					key = int(keyparts, 16) * sign
	 					sign = +1
	 					keyparts = ''
	 				else:
	 					keyparts += ch
	 			else:
	 				#debug("In value. It is '%s', ch is '%s'" % (valueparts, ch))
	 				if ch in ending:
	 					#debug("End of value")
	 					valueparts += mapping[ch]
	 					activeobject[key] = int(valueparts, 16) * sign
	 					sign = +1
	 					key = None
	 					valueparts = ''
	 				else:
	 					valueparts += ch
	 
	 			#debug(activeobject)
	 
	 	return output
	 
	 */ /**
	 Uncompresses data compressed into custom, base16-like format. 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */var uncompress=function uncompress(data){var decoded='0123456789abcdef',encoded='klmnopqrstuvwxyz',mapping={};for(var i=0;i < encoded.length;i++) {mapping[encoded[i]] = decoded[i];}var undef,output={},sign=1,stringparts, // undef. will be [] in string mode
	activeobject=output,parentchain=[],parent_key_pair,keyparts='',valueparts='',key, // undef. will be Truthy when Key is resolved.
	datalen=data.length - 1, // stripping ending }
	ch;i = 1; // stripping starting {
	while(i != datalen) { // - { } ' are special.
	ch = data[i];i += 1;if(ch == "'"){if(stringparts){ // end of string mode
	key = stringparts.join('');stringparts = undef;}else { // start of string mode
	stringparts = [];}}else if(stringparts){stringparts.push(ch);}else if(ch == '{'){ // start of object
	parentchain.push([activeobject,key]);activeobject = {};key = undef;}else if(ch == '}'){ // end of object
	parent_key_pair = parentchain.pop();parent_key_pair[0][parent_key_pair[1]] = activeobject;key = undef;activeobject = parent_key_pair[0];}else if(ch == '-'){sign = -1;}else { // must be number
	if(key === undef){if(mapping.hasOwnProperty(ch)){keyparts += mapping[ch];key = parseInt(keyparts,16) * sign;sign = +1;keyparts = '';}else {keyparts += ch;}}else {if(mapping.hasOwnProperty(ch)){valueparts += mapping[ch];activeobject[key] = parseInt(valueparts,16) * sign;sign = +1;key = undef;valueparts = '';}else {valueparts += ch;}}}} // end while
	return output;}; // encoding = 'Unicode' 
	// NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE. NO clever BOM behavior
	// Actual 16bit char codes used.
	// no multi-byte logic here
	// Unicode characters to WinAnsiEncoding:
	// {402: 131, 8211: 150, 8212: 151, 8216: 145, 8217: 146, 8218: 130, 8220: 147, 8221: 148, 8222: 132, 8224: 134, 8225: 135, 8226: 149, 8230: 133, 8364: 128, 8240:137, 8249: 139, 8250: 155, 710: 136, 8482: 153, 338: 140, 339: 156, 732: 152, 352: 138, 353: 154, 376: 159, 381: 142, 382: 158}
	// as you can see, all Unicode chars are outside of 0-255 range. No char code conflicts.
	// this means that you can give Win cp1252 encoded strings to jsPDF for rendering directly
	// as well as give strings with some (supported by these fonts) Unicode characters and 
	// these will be mapped to win cp1252 
	// for example, you can send char code (cp1252) 0x80 or (unicode) 0x20AC, getting "Euro" glyph displayed in both cases.
	var encodingBlock={'codePages':['WinAnsiEncoding'],'WinAnsiEncoding':uncompress("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},encodings={'Unicode':{'Courier':encodingBlock,'Courier-Bold':encodingBlock,'Courier-BoldOblique':encodingBlock,'Courier-Oblique':encodingBlock,'Helvetica':encodingBlock,'Helvetica-Bold':encodingBlock,'Helvetica-BoldOblique':encodingBlock,'Helvetica-Oblique':encodingBlock,'Times-Roman':encodingBlock,'Times-Bold':encodingBlock,'Times-BoldItalic':encodingBlock,'Times-Italic':encodingBlock //	, 'Symbol'
	//	, 'ZapfDingbats'
	} /** 
	  Resources:
	  Font metrics data is reprocessed derivative of contents of
	  "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
	  
	  Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
	  
	  This file and the 14 PostScript(R) AFM files it accompanies may be used,
	  copied, and distributed for any purpose and without charge, with or without
	  modification, provided that all copyright notices are retained; that the AFM
	  files are not distributed without this file; that all modifications to this
	  file or any of the AFM files are prominently noted in the modified file(s);
	  and that this paragraph is not modified. Adobe Systems has no responsibility
	  or obligation to support the use of the AFM files.
	  
	  */},fontMetrics={'Unicode':{ // all sizing numbers are n/fontMetricsFractionOf = one font size unit
	// this means that if fontMetricsFractionOf = 1000, and letter A's width is 476, it's
	// width is 476/1000 or 47.6% of its height (regardless of font size)
	// At this time this value applies to "widths" and "kerning" numbers.
	// char code 0 represents "default" (average) width - use it for chars missing in this table.
	// key 'fof' represents the "fontMetricsFractionOf" value
	'Courier-Oblique':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-BoldItalic':uncompress("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),'Helvetica-Bold':uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),'Courier':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Courier-BoldOblique':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-Bold':uncompress("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), //, 'Symbol': uncompress("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}")
	'Helvetica':uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),'Helvetica-BoldOblique':uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), //, 'ZapfDingbats': uncompress("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}")
	'Courier-Bold':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-Italic':uncompress("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),'Times-Roman':uncompress("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),'Helvetica-Oblique':uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}}; /*
	 This event handler is fired when a new jsPDF object is initialized
	 This event handler appends metrics data to standard fonts within
	 that jsPDF instance. The metrics are mapped over Unicode character
	 codes, NOT CIDs or other codes matching the StandardEncoding table of the
	 standard PDF fonts.
	 Future:
	 Also included is the encoding maping table, converting Unicode (UCS-2, UTF-16)
	 char codes to StandardEncoding character codes. The encoding table is to be used
	 somewhere around "pdfEscape" call.
	 */API.events.push(['addFont',function(font){var metrics,unicode_section,encoding='Unicode',encodingBlock;metrics = fontMetrics[encoding][font.PostScriptName];if(metrics){if(font.metadata[encoding]){unicode_section = font.metadata[encoding];}else {unicode_section = font.metadata[encoding] = {};}unicode_section.widths = metrics.widths;unicode_section.kerning = metrics.kerning;}encodingBlock = encodings[encoding][font.PostScriptName];if(encodingBlock){if(font.metadata[encoding]){unicode_section = font.metadata[encoding];}else {unicode_section = font.metadata[encoding] = {};}unicode_section.encoding = encodingBlock;if(encodingBlock.codePages && encodingBlock.codePages.length){font.encoding = encodingBlock.codePages[0];}}}]); // end of adding event handler
	})(jsPDF.API); /** @preserve
	jsPDF SVG plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	*/ /**
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /**
	 Parses SVG XML and converts only some of the SVG elements into
	 PDF elements.
	 
	 Supports:
	  paths
	 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */jsPDFAPI.addSVG = function(svgtext,x,y,w,h){ // 'this' is _jsPDF object returned when jsPDF is inited (new jsPDF())
	var undef;if(x === undef || y === undef){throw new Error("addSVG needs values for 'x' and 'y'");}function InjectCSS(cssbody,document){var styletag=document.createElement('style');styletag.type = 'text/css';if(styletag.styleSheet){ // ie
	styletag.styleSheet.cssText = cssbody;}else { // others
	styletag.appendChild(document.createTextNode(cssbody));}document.getElementsByTagName("head")[0].appendChild(styletag);}function createWorkerNode(document){var frameID='childframe', // Date.now().toString() + '_' + (Math.random() * 100).toString()
	frame=document.createElement('iframe');InjectCSS('.jsPDF_sillysvg_iframe {display:none;position:absolute;}',document);frame.name = frameID;frame.setAttribute("width",0);frame.setAttribute("height",0);frame.setAttribute("frameborder","0");frame.setAttribute("scrolling","no");frame.setAttribute("seamless","seamless");frame.setAttribute("class","jsPDF_sillysvg_iframe");document.body.appendChild(frame);return frame;}function attachSVGToWorkerNode(svgtext,frame){var framedoc=(frame.contentWindow || frame.contentDocument).document;framedoc.write(svgtext);framedoc.close();return framedoc.getElementsByTagName('svg')[0];}function convertPathToPDFLinesArgs(path){'use strict'; // we will use 'lines' method call. it needs:
	// - starting coordinate pair
	// - array of arrays of vector shifts (2-len for line, 6 len for bezier)
	// - scale array [horizontal, vertical] ratios
	// - style (stroke, fill, both)
	var x=parseFloat(path[1]),y=parseFloat(path[2]),vectors=[],position=3,len=path.length;while(position < len) {if(path[position] === 'c'){vectors.push([parseFloat(path[position + 1]),parseFloat(path[position + 2]),parseFloat(path[position + 3]),parseFloat(path[position + 4]),parseFloat(path[position + 5]),parseFloat(path[position + 6])]);position += 7;}else if(path[position] === 'l'){vectors.push([parseFloat(path[position + 1]),parseFloat(path[position + 2])]);position += 3;}else {position += 1;}}return [x,y,vectors];}var workernode=createWorkerNode(document),svgnode=attachSVGToWorkerNode(svgtext,workernode),scale=[1,1],svgw=parseFloat(svgnode.getAttribute('width')),svgh=parseFloat(svgnode.getAttribute('height'));if(svgw && svgh){ // setting both w and h makes image stretch to size.
	// this may distort the image, but fits your demanded size
	if(w && h){scale = [w / svgw,h / svgh];} // if only one is set, that value is set as max and SVG
	// is scaled proportionately.
	else if(w){scale = [w / svgw,w / svgw];}else if(h){scale = [h / svgh,h / svgh];}}var i,l,tmp,linesargs,items=svgnode.childNodes;for(i = 0,l = items.length;i < l;i++) {tmp = items[i];if(tmp.tagName && tmp.tagName.toUpperCase() === 'PATH'){linesargs = convertPathToPDFLinesArgs(tmp.getAttribute("d").split(' ')); // path start x coordinate
	linesargs[0] = linesargs[0] * scale[0] + x; // where x is upper left X of image
	// path start y coordinate
	linesargs[1] = linesargs[1] * scale[1] + y; // where y is upper left Y of image
	// the rest of lines are vectors. these will adjust with scale value auto.
	this.lines.call(this,linesargs[2], // lines
	linesargs[0], // starting x
	linesargs[1], // starting y
	scale);}} // clean up
	// workernode.parentNode.removeChild(workernode)
	return this;};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF total_pages plugin
	 * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 * 
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.putTotalPages = function(pageExpression){'use strict';var replaceExpression=new RegExp(pageExpression,'g');for(var n=1;n <= this.internal.getNumberOfPages();n++) {for(var i=0;i < this.internal.pages[n].length;i++) {this.internal.pages[n][i] = this.internal.pages[n][i].replace(replaceExpression,this.internal.getNumberOfPages());}}return this;};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF XMP metadata plugin
	 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	 * 
	 * 
	 * ====================================================================
	 */ /*global jsPDF */ /**
	* Adds XMP formatted metadata to PDF
	*
	* @param {String} metadata The actual metadata to be added. The metadata shall be stored as XMP simple value. Note that if the metadata string contains XML markup characters "<", ">" or "&", those characters should be written using XML entities.
	* @param {String} namespaceuri Sets the namespace URI for the metadata. Last character should be slash or hash.
	* @function
	* @returns {jsPDF}
	* @methodOf jsPDF#
	* @name addMetadata
	*/(function(jsPDFAPI){'use strict';var xmpmetadata="";var xmpnamespaceuri="";var metadata_object_number="";jsPDFAPI.addMetadata = function(metadata,namespaceuri){xmpnamespaceuri = namespaceuri || "http://jspdf.default.namespaceuri/"; //The namespace URI for an XMP name shall not be empty
	xmpmetadata = metadata;this.internal.events.subscribe('postPutResources',function(){if(!xmpmetadata){metadata_object_number = "";}else {var xmpmeta_beginning='<x:xmpmeta xmlns:x="adobe:ns:meta/">';var rdf_beginning='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + xmpnamespaceuri + '"><jspdf:metadata>';var rdf_ending='</jspdf:metadata></rdf:Description></rdf:RDF>';var xmpmeta_ending='</x:xmpmeta>';var utf8_xmpmeta_beginning=unescape(encodeURIComponent(xmpmeta_beginning));var utf8_rdf_beginning=unescape(encodeURIComponent(rdf_beginning));var utf8_metadata=unescape(encodeURIComponent(xmpmetadata));var utf8_rdf_ending=unescape(encodeURIComponent(rdf_ending));var utf8_xmpmeta_ending=unescape(encodeURIComponent(xmpmeta_ending));var total_len=utf8_rdf_beginning.length + utf8_metadata.length + utf8_rdf_ending.length + utf8_xmpmeta_beginning.length + utf8_xmpmeta_ending.length;metadata_object_number = this.internal.newObject();this.internal.write('<< /Type /Metadata /Subtype /XML /Length ' + total_len + ' >>');this.internal.write('stream');this.internal.write(utf8_xmpmeta_beginning + utf8_rdf_beginning + utf8_metadata + utf8_rdf_ending + utf8_xmpmeta_ending);this.internal.write('endstream');this.internal.write('endobj');}});this.internal.events.subscribe('putCatalog',function(){if(metadata_object_number){this.internal.write('/Metadata ' + metadata_object_number + ' 0 R');}});return this;};})(jsPDF.API); /* Blob.js
	 * A Blob implementation.
	 * 2014-07-24
	 *
	 * By Eli Grey, http://eligrey.com
	 * By Devin Samarin, https://github.com/dsamarin
	 * License: X11/MIT
	 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
	 */ /*global self, unescape */ /*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
	  plusplus: true */ /*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */(function(view){"use strict";view.URL = view.URL || view.webkitURL;if(view.Blob && view.URL){try{new Blob();return;}catch(e) {}} // Internally we use a BlobBuilder implementation to base Blob off of
	// in order to support older browsers that only have BlobBuilder
	var BlobBuilder=view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view){var get_class=function get_class(object){return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];},FakeBlobBuilder=function BlobBuilder(){this.data = [];},FakeBlob=function Blob(data,type,encoding){this.data = data;this.size = data.length;this.type = type;this.encoding = encoding;},FBB_proto=FakeBlobBuilder.prototype,FB_proto=FakeBlob.prototype,FileReaderSync=view.FileReaderSync,FileException=function FileException(type){this.code = this[this.name = type];},file_ex_codes=("NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR " + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR").split(" "),file_ex_code=file_ex_codes.length,real_URL=view.URL || view.webkitURL || view,real_create_object_URL=real_URL.createObjectURL,real_revoke_object_URL=real_URL.revokeObjectURL,URL=real_URL,btoa=view.btoa,atob=view.atob,ArrayBuffer=view.ArrayBuffer,Uint8Array=view.Uint8Array,origin=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;FakeBlob.fake = FB_proto.fake = true;while(file_ex_code--) {FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;} // Polyfill URL
	if(!real_URL.createObjectURL){URL = view.URL = function(uri){var uri_info=document.createElementNS("http://www.w3.org/1999/xhtml","a"),uri_origin;uri_info.href = uri;if(!("origin" in uri_info)){if(uri_info.protocol.toLowerCase() === "data:"){uri_info.origin = null;}else {uri_origin = uri.match(origin);uri_info.origin = uri_origin && uri_origin[1];}}return uri_info;};}URL.createObjectURL = function(blob){var type=blob.type,data_URI_header;if(type === null){type = "application/octet-stream";}if(blob instanceof FakeBlob){data_URI_header = "data:" + type;if(blob.encoding === "base64"){return data_URI_header + ";base64," + blob.data;}else if(blob.encoding === "URI"){return data_URI_header + "," + decodeURIComponent(blob.data);}if(btoa){return data_URI_header + ";base64," + btoa(blob.data);}else {return data_URI_header + "," + encodeURIComponent(blob.data);}}else if(real_create_object_URL){return real_create_object_URL.call(real_URL,blob);}};URL.revokeObjectURL = function(object_URL){if(object_URL.substring(0,5) !== "data:" && real_revoke_object_URL){real_revoke_object_URL.call(real_URL,object_URL);}};FBB_proto.append = function(data /*, endings*/){var bb=this.data; // decode data to a binary string
	if(Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)){var str="",buf=new Uint8Array(data),i=0,buf_len=buf.length;for(;i < buf_len;i++) {str += String.fromCharCode(buf[i]);}bb.push(str);}else if(get_class(data) === "Blob" || get_class(data) === "File"){if(FileReaderSync){var fr=new FileReaderSync();bb.push(fr.readAsBinaryString(data));}else { // async FileReader won't work as BlobBuilder is sync
	throw new FileException("NOT_READABLE_ERR");}}else if(data instanceof FakeBlob){if(data.encoding === "base64" && atob){bb.push(atob(data.data));}else if(data.encoding === "URI"){bb.push(decodeURIComponent(data.data));}else if(data.encoding === "raw"){bb.push(data.data);}}else {if(typeof data !== "string"){data += ""; // convert unsupported types to strings
	} // decode UTF-16 to binary string
	bb.push(unescape(encodeURIComponent(data)));}};FBB_proto.getBlob = function(type){if(!arguments.length){type = null;}return new FakeBlob(this.data.join(""),type,"raw");};FBB_proto.toString = function(){return "[object BlobBuilder]";};FB_proto.slice = function(start,end,type){var args=arguments.length;if(args < 3){type = null;}return new FakeBlob(this.data.slice(start,args > 1?end:this.data.length),type,this.encoding);};FB_proto.toString = function(){return "[object Blob]";};FB_proto.close = function(){this.size = 0;delete this.data;};return FakeBlobBuilder;})(view);view.Blob = function(blobParts,options){var type=options?options.type || "":"";var builder=new BlobBuilder();if(blobParts){for(var i=0,len=blobParts.length;i < len;i++) {if(Uint8Array && blobParts[i] instanceof Uint8Array){builder.append(blobParts[i].buffer);}else {builder.append(blobParts[i]);}}}var blob=builder.getBlob(type);if(!blob.slice && blob.webkitSlice){blob.slice = blob.webkitSlice;}return blob;};var getPrototypeOf=Object.getPrototypeOf || function(object){return object.__proto__;};view.Blob.prototype = getPrototypeOf(new view.Blob());})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content || undefined); /* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */var saveAs=saveAs || (function(view){"use strict"; // IE <10 is explicitly unsupported
	if(typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)){return;}var doc=view.document, // only get URL when necessary in case Blob.js hasn't overridden it yet
	get_URL=function get_URL(){return view.URL || view.webkitURL || view;},save_link=doc.createElementNS("http://www.w3.org/1999/xhtml","a"),can_use_save_link=("download" in save_link),click=function click(node){var event=new MouseEvent("click");node.dispatchEvent(event);},is_safari=/constructor/i.test(view.HTMLElement) || view.safari,is_chrome_ios=/CriOS\/[\d]+/.test(navigator.userAgent),throw_outside=function throw_outside(ex){(view.setImmediate || view.setTimeout)(function(){throw ex;},0);},force_saveable_type="application/octet-stream", // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	arbitrary_revoke_timeout=1000 * 40, // in ms
	revoke=function revoke(file){var revoker=function revoker(){if(typeof file === "string"){ // file is an object URL
	get_URL().revokeObjectURL(file);}else { // file is a File
	file.remove();}};setTimeout(revoker,arbitrary_revoke_timeout);},dispatch=function dispatch(filesaver,event_types,event){event_types = [].concat(event_types);var i=event_types.length;while(i--) {var listener=filesaver["on" + event_types[i]];if(typeof listener === "function"){try{listener.call(filesaver,event || filesaver);}catch(ex) {throw_outside(ex);}}}},auto_bom=function auto_bom(blob){ // prepend BOM for UTF-8 XML and text/* types (including HTML)
	// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
	if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)){return new Blob([String.fromCharCode(0xFEFF),blob],{type:blob.type});}return blob;},FileSaver=function FileSaver(blob,name,no_auto_bom){if(!no_auto_bom){blob = auto_bom(blob);} // First try a.download, then web filesystem, then object URLs
	var filesaver=this,type=blob.type,force=type === force_saveable_type,object_url,dispatch_all=function dispatch_all(){dispatch(filesaver,"writestart progress write writeend".split(" "));}, // on any filesys errors revert to saving with object URLs
	fs_error=function fs_error(){if((is_chrome_ios || force && is_safari) && view.FileReader){ // Safari doesn't allow downloading of blob urls
	var reader=new FileReader();reader.onloadend = function(){var url=is_chrome_ios?reader.result:reader.result.replace(/^data:[^;]*;/,'data:attachment/file;');var popup=view.open(url,'_blank');if(!popup)view.location.href = url;url = undefined; // release reference before dispatching
	filesaver.readyState = filesaver.DONE;dispatch_all();};reader.readAsDataURL(blob);filesaver.readyState = filesaver.INIT;return;} // don't create more object URLs than needed
	if(!object_url){object_url = get_URL().createObjectURL(blob);}if(force){view.location.href = object_url;}else {var opened=view.open(object_url,"_blank");if(!opened){ // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
	view.location.href = object_url;}}filesaver.readyState = filesaver.DONE;dispatch_all();revoke(object_url);};filesaver.readyState = filesaver.INIT;if(can_use_save_link){object_url = get_URL().createObjectURL(blob);setTimeout(function(){save_link.href = object_url;save_link.download = name;click(save_link);dispatch_all();revoke(object_url);filesaver.readyState = filesaver.DONE;});return;}fs_error();},FS_proto=FileSaver.prototype,saveAs=function saveAs(blob,name,no_auto_bom){return new FileSaver(blob,name || blob.name || "download",no_auto_bom);}; // IE 10+ (native saveAs)
	if(typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob){return function(blob,name,no_auto_bom){name = name || blob.name || "download";if(!no_auto_bom){blob = auto_bom(blob);}return navigator.msSaveOrOpenBlob(blob,name);};}FS_proto.abort = function(){};FS_proto.readyState = FS_proto.INIT = 0;FS_proto.WRITING = 1;FS_proto.DONE = 2;FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;return saveAs;})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content); // `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	if(typeof module !== "undefined" && module.exports){module.exports.saveAs = saveAs;}else if("function" !== "undefined" && __webpack_require__(167) !== null && __webpack_require__(1252) !== null){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return saveAs;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));} /*
	 * Copyright (c) 2012 chick307 <chick307@gmail.com>
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */void (function(global,callback){if(true){module.exports = callback();}else if(typeof define === 'function'){define(callback);}else {global.adler32cs = callback();}})(jsPDF,function(){var _hasArrayBuffer=typeof ArrayBuffer === 'function' && typeof Uint8Array === 'function';var _Buffer=null,_isBuffer=(function(){if(!_hasArrayBuffer)return function _isBuffer(){return false;};try{var buffer={};if(typeof buffer.Buffer === 'function')_Buffer = buffer.Buffer;}catch(error) {}return function _isBuffer(value){return value instanceof ArrayBuffer || _Buffer !== null && value instanceof _Buffer;};})();var _utf8ToBinary=(function(){if(_Buffer !== null){return function _utf8ToBinary(utf8String){return new _Buffer(utf8String,'utf8').toString('binary');};}else {return function _utf8ToBinary(utf8String){return unescape(encodeURIComponent(utf8String));};}})();var MOD=65521;var _update=function _update(checksum,binaryString){var a=checksum & 0xFFFF,b=checksum >>> 16;for(var i=0,length=binaryString.length;i < length;i++) {a = (a + (binaryString.charCodeAt(i) & 0xFF)) % MOD;b = (b + a) % MOD;}return (b << 16 | a) >>> 0;};var _updateUint8Array=function _updateUint8Array(checksum,uint8Array){var a=checksum & 0xFFFF,b=checksum >>> 16;for(var i=0,length=uint8Array.length;i < length;i++) {a = (a + uint8Array[i]) % MOD;b = (b + a) % MOD;}return (b << 16 | a) >>> 0;};var exports={};var Adler32=exports.Adler32 = (function(){var ctor=function Adler32(checksum){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(!isFinite(checksum = checksum == null?1:+checksum)){throw new Error('First arguments needs to be a finite number.');}this.checksum = checksum >>> 0;};var proto=ctor.prototype = {};proto.constructor = ctor;ctor.from = (function(from){from.prototype = proto;return from;})(function from(binaryString){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(binaryString == null)throw new Error('First argument needs to be a string.');this.checksum = _update(1,binaryString.toString());});ctor.fromUtf8 = (function(fromUtf8){fromUtf8.prototype = proto;return fromUtf8;})(function fromUtf8(utf8String){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());this.checksum = _update(1,binaryString);});if(_hasArrayBuffer){ctor.fromBuffer = (function(fromBuffer){fromBuffer.prototype = proto;return fromBuffer;})(function fromBuffer(buffer){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(!_isBuffer(buffer))throw new Error('First argument needs to be ArrayBuffer.');var array=new Uint8Array(buffer);return this.checksum = _updateUint8Array(1,array);});}proto.update = function update(binaryString){if(binaryString == null)throw new Error('First argument needs to be a string.');binaryString = binaryString.toString();return this.checksum = _update(this.checksum,binaryString);};proto.updateUtf8 = function updateUtf8(utf8String){if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());return this.checksum = _update(this.checksum,binaryString);};if(_hasArrayBuffer){proto.updateBuffer = function updateBuffer(buffer){if(!_isBuffer(buffer))throw new Error('First argument needs to be ArrayBuffer.');var array=new Uint8Array(buffer);return this.checksum = _updateUint8Array(this.checksum,array);};}proto.clone = function clone(){return new Adler32(this.checksum);};return ctor;})();exports.from = function from(binaryString){if(binaryString == null)throw new Error('First argument needs to be a string.');return _update(1,binaryString.toString());};exports.fromUtf8 = function fromUtf8(utf8String){if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());return _update(1,binaryString);};if(_hasArrayBuffer){exports.fromBuffer = function fromBuffer(buffer){if(!_isBuffer(buffer))throw new Error('First argument need to be ArrayBuffer.');var array=new Uint8Array(buffer);return _updateUint8Array(1,array);};}return exports;}); /**
	 * CssColors
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * Usage CssColors('red');
	 * Returns RGB hex color with '#' prefix
	 */var CssColors={};CssColors._colorsTable = {"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred ":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgrey":"#d3d3d3","lightgreen":"#90ee90","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370d8","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#d87093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"};CssColors.colorNameToHex = function(color){color = color.toLowerCase();if(typeof this._colorsTable[color] != 'undefined')return this._colorsTable[color];return false;}; /*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:
	
	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.
	
	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.
	
	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */ /*
	 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
	 * JZlib is based on zlib-1.1.3, so all credit should go authors
	 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
	 * and contributors of zlib.
	 */var Deflater=(function(obj){ // Global
	var MAX_BITS=15;var D_CODES=30;var BL_CODES=19;var LENGTH_CODES=29;var LITERALS=256;var L_CODES=LITERALS + 1 + LENGTH_CODES;var HEAP_SIZE=2 * L_CODES + 1;var END_BLOCK=256; // Bit length codes must not exceed MAX_BL_BITS bits
	var MAX_BL_BITS=7; // repeat previous bit length 3-6 times (2 bits of repeat count)
	var REP_3_6=16; // repeat a zero length 3-10 times (3 bits of repeat count)
	var REPZ_3_10=17; // repeat a zero length 11-138 times (7 bits of repeat count)
	var REPZ_11_138=18; // The lengths of the bit length codes are sent in order of decreasing
	// probability, to avoid transmitting the lengths for unused bit
	// length codes.
	var Buf_size=8 * 2; // JZlib version : "1.0.2"
	var Z_DEFAULT_COMPRESSION=-1; // compression strategy
	var Z_FILTERED=1;var Z_HUFFMAN_ONLY=2;var Z_DEFAULT_STRATEGY=0;var Z_NO_FLUSH=0;var Z_PARTIAL_FLUSH=1;var Z_FULL_FLUSH=3;var Z_FINISH=4;var Z_OK=0;var Z_STREAM_END=1;var Z_NEED_DICT=2;var Z_STREAM_ERROR=-2;var Z_DATA_ERROR=-3;var Z_BUF_ERROR=-5; // Tree
	// see definition of array dist_code below
	var _dist_code=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function Tree(){var that=this; // dyn_tree; // the dynamic tree
	// max_code; // largest code with non zero frequency
	// stat_desc; // the corresponding static tree
	// Compute the optimal bit lengths for a tree and update the total bit
	// length
	// for the current block.
	// IN assertion: the fields freq and dad are set, heap[heap_max] and
	// above are the tree nodes sorted by increasing frequency.
	// OUT assertions: the field len is set to the optimal bit length, the
	// array bl_count contains the frequencies for each bit length.
	// The length opt_len is updated; static_len is also updated if stree is
	// not null.
	function gen_bitlen(s){var tree=that.dyn_tree;var stree=that.stat_desc.static_tree;var extra=that.stat_desc.extra_bits;var base=that.stat_desc.extra_base;var max_length=that.stat_desc.max_length;var h; // heap index
	var n,m; // iterate over the tree elements
	var bits; // bit length
	var xbits; // extra bits
	var f; // frequency
	var overflow=0; // number of elements with bit length too large
	for(bits = 0;bits <= MAX_BITS;bits++) s.bl_count[bits] = 0; // In a first pass, compute the optimal bit lengths (which may
	// overflow in the case of the bit length tree).
	tree[s.heap[s.heap_max] * 2 + 1] = 0; // root of the heap
	for(h = s.heap_max + 1;h < HEAP_SIZE;h++) {n = s.heap[h];bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;if(bits > max_length){bits = max_length;overflow++;}tree[n * 2 + 1] = bits; // We overwrite tree[n*2+1] which is no longer needed
	if(n > that.max_code)continue; // not a leaf node
	s.bl_count[bits]++;xbits = 0;if(n >= base)xbits = extra[n - base];f = tree[n * 2];s.opt_len += f * (bits + xbits);if(stree)s.static_len += f * (stree[n * 2 + 1] + xbits);}if(overflow === 0)return; // This happens for example on obj2 and pic of the Calgary corpus
	// Find the first bit length which could increase:
	do {bits = max_length - 1;while(s.bl_count[bits] === 0) bits--;s.bl_count[bits]--; // move one leaf down the tree
	s.bl_count[bits + 1] += 2; // move one overflow item as its brother
	s.bl_count[max_length]--; // The brother of the overflow item also moves one step up,
	// but this does not affect bl_count[max_length]
	overflow -= 2;}while(overflow > 0);for(bits = max_length;bits !== 0;bits--) {n = s.bl_count[bits];while(n !== 0) {m = s.heap[--h];if(m > that.max_code)continue;if(tree[m * 2 + 1] != bits){s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];tree[m * 2 + 1] = bits;}n--;}}} // Reverse the first len bits of a code, using straightforward code (a
	// faster
	// method would use a table)
	// IN assertion: 1 <= len <= 15
	function bi_reverse(code, // the value to invert
	len // its bit length
	){var res=0;do {res |= code & 1;code >>>= 1;res <<= 1;}while(--len > 0);return res >>> 1;} // Generate the codes for a given tree and bit counts (which need not be
	// optimal).
	// IN assertion: the array bl_count contains the bit length statistics for
	// the given tree and the field len is set for all tree elements.
	// OUT assertion: the field code is set for all tree elements of non
	// zero code length.
	function gen_codes(tree, // the tree to decorate
	max_code, // largest code with non zero frequency
	bl_count // number of codes at each bit length
	){var next_code=[]; // next code value for each
	// bit length
	var code=0; // running code value
	var bits; // bit index
	var n; // code index
	var len; // The distribution counts are first used to generate the code values
	// without bit reversal.
	for(bits = 1;bits <= MAX_BITS;bits++) {next_code[bits] = code = code + bl_count[bits - 1] << 1;} // Check that the bit counts in bl_count are consistent. The last code
	// must be all ones.
	// Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	// "inconsistent bit counts");
	// Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	for(n = 0;n <= max_code;n++) {len = tree[n * 2 + 1];if(len === 0)continue; // Now reverse the bits
	tree[n * 2] = bi_reverse(next_code[len]++,len);}} // Construct one Huffman tree and assigns the code bit strings and lengths.
	// Update the total bit length for the current block.
	// IN assertion: the field freq is set for all tree elements.
	// OUT assertions: the fields len and code are set to the optimal bit length
	// and corresponding code. The length opt_len is updated; static_len is
	// also updated if stree is not null. The field max_code is set.
	that.build_tree = function(s){var tree=that.dyn_tree;var stree=that.stat_desc.static_tree;var elems=that.stat_desc.elems;var n,m; // iterate over heap elements
	var max_code=-1; // largest code with non zero frequency
	var node; // new node being created
	// Construct the initial heap, with least frequent element in
	// heap[1]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	// heap[0] is not used.
	s.heap_len = 0;s.heap_max = HEAP_SIZE;for(n = 0;n < elems;n++) {if(tree[n * 2] !== 0){s.heap[++s.heap_len] = max_code = n;s.depth[n] = 0;}else {tree[n * 2 + 1] = 0;}} // The pkzip format requires that at least one distance code exists,
	// and that at least one bit should be sent even if there is only one
	// possible code. So to avoid special checks later on we force at least
	// two codes of non zero frequency.
	while(s.heap_len < 2) {node = s.heap[++s.heap_len] = max_code < 2?++max_code:0;tree[node * 2] = 1;s.depth[node] = 0;s.opt_len--;if(stree)s.static_len -= stree[node * 2 + 1]; // node is 0 or 1 so it does not have extra bits
	}that.max_code = max_code; // The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	// establish sub-heaps of increasing lengths:
	for(n = Math.floor(s.heap_len / 2);n >= 1;n--) s.pqdownheap(tree,n); // Construct the Huffman tree by repeatedly combining the least two
	// frequent nodes.
	node = elems; // next internal node of the tree
	do { // n = node of least frequency
	n = s.heap[1];s.heap[1] = s.heap[s.heap_len--];s.pqdownheap(tree,1);m = s.heap[1]; // m = node of next least frequency
	s.heap[--s.heap_max] = n; // keep the nodes sorted by frequency
	s.heap[--s.heap_max] = m; // Create a new node father of n and m
	tree[node * 2] = tree[n * 2] + tree[m * 2];s.depth[node] = Math.max(s.depth[n],s.depth[m]) + 1;tree[n * 2 + 1] = tree[m * 2 + 1] = node; // and insert the new node in the heap
	s.heap[1] = node++;s.pqdownheap(tree,1);}while(s.heap_len >= 2);s.heap[--s.heap_max] = s.heap[1]; // At this point, the fields freq and dad are set. We can now
	// generate the bit lengths.
	gen_bitlen(s); // The field len is now set, we can generate the bit codes
	gen_codes(tree,that.max_code,s.bl_count);};}Tree._length_code = [0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28];Tree.base_length = [0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0];Tree.base_dist = [0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576]; // Mapping from a distance to a distance code. dist is the distance - 1 and
	// must not have side effects. _dist_code[256] and _dist_code[257] are never
	// used.
	Tree.d_code = function(dist){return dist < 256?_dist_code[dist]:_dist_code[256 + (dist >>> 7)];}; // extra bits for each length code
	Tree.extra_lbits = [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]; // extra bits for each distance code
	Tree.extra_dbits = [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]; // extra bits for each bit length code
	Tree.extra_blbits = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];Tree.bl_order = [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]; // StaticTree
	function StaticTree(static_tree,extra_bits,extra_base,elems,max_length){var that=this;that.static_tree = static_tree;that.extra_bits = extra_bits;that.extra_base = extra_base;that.elems = elems;that.max_length = max_length;}StaticTree.static_ltree = [12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8];StaticTree.static_dtree = [0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5];StaticTree.static_l_desc = new StaticTree(StaticTree.static_ltree,Tree.extra_lbits,LITERALS + 1,L_CODES,MAX_BITS);StaticTree.static_d_desc = new StaticTree(StaticTree.static_dtree,Tree.extra_dbits,0,D_CODES,MAX_BITS);StaticTree.static_bl_desc = new StaticTree(null,Tree.extra_blbits,0,BL_CODES,MAX_BL_BITS); // Deflate
	var MAX_MEM_LEVEL=9;var DEF_MEM_LEVEL=8;function Config(good_length,max_lazy,nice_length,max_chain,func){var that=this;that.good_length = good_length;that.max_lazy = max_lazy;that.nice_length = nice_length;that.max_chain = max_chain;that.func = func;}var STORED=0;var FAST=1;var SLOW=2;var config_table=[new Config(0,0,0,0,STORED),new Config(4,4,8,4,FAST),new Config(4,5,16,8,FAST),new Config(4,6,32,32,FAST),new Config(4,4,16,16,SLOW),new Config(8,16,32,32,SLOW),new Config(8,16,128,128,SLOW),new Config(8,32,128,256,SLOW),new Config(32,128,258,1024,SLOW),new Config(32,258,258,4096,SLOW)];var z_errmsg=["need dictionary", // Z_NEED_DICT
	// 2
	"stream end", // Z_STREAM_END 1
	"", // Z_OK 0
	"", // Z_ERRNO (-1)
	"stream error", // Z_STREAM_ERROR (-2)
	"data error", // Z_DATA_ERROR (-3)
	"", // Z_MEM_ERROR (-4)
	"buffer error", // Z_BUF_ERROR (-5)
	"", // Z_VERSION_ERROR (-6)
	""]; // block not completed, need more input or more output
	var NeedMore=0; // block flush performed
	var BlockDone=1; // finish started, need only more output at next deflate
	var FinishStarted=2; // finish done, accept no more input or output
	var FinishDone=3; // preset dictionary flag in zlib header
	var PRESET_DICT=0x20;var INIT_STATE=42;var BUSY_STATE=113;var FINISH_STATE=666; // The deflate compression method
	var Z_DEFLATED=8;var STORED_BLOCK=0;var STATIC_TREES=1;var DYN_TREES=2;var MIN_MATCH=3;var MAX_MATCH=258;var MIN_LOOKAHEAD=MAX_MATCH + MIN_MATCH + 1;function smaller(tree,n,m,depth){var tn2=tree[n * 2];var tm2=tree[m * 2];return tn2 < tm2 || tn2 == tm2 && depth[n] <= depth[m];}function Deflate(){var that=this;var strm; // pointer back to this zlib stream
	var status; // as the name implies
	// pending_buf; // output still pending
	var pending_buf_size; // size of pending_buf
	// pending_out; // next pending byte to output to the stream
	// pending; // nb of bytes in the pending buffer
	var last_flush; // value of flush param for previous deflate call
	var w_size; // LZ77 window size (32K by default)
	var w_bits; // log2(w_size) (8..16)
	var w_mask; // w_size - 1
	var window; // Sliding window. Input bytes are read into the second half of the window,
	// and move to the first half later to keep a dictionary of at least wSize
	// bytes. With this organization, matches are limited to a distance of
	// wSize-MAX_MATCH bytes, but this ensures that IO is always
	// performed with a length multiple of the block size. Also, it limits
	// the window size to 64K, which is quite useful on MSDOS.
	// To do: use the user input buffer as sliding window.
	var window_size; // Actual size of window: 2*wSize, except when the user input buffer
	// is directly used as sliding window.
	var prev; // Link to older string with same hash index. To limit the size of this
	// array to 64K, this link is maintained only for the last 32K strings.
	// An index in this array is thus a window index modulo 32K.
	var head; // Heads of the hash chains or NIL.
	var ins_h; // hash index of string to be inserted
	var hash_size; // number of elements in hash table
	var hash_bits; // log2(hash_size)
	var hash_mask; // hash_size-1
	// Number of bits by which ins_h must be shifted at each input
	// step. It must be such that after MIN_MATCH steps, the oldest
	// byte no longer takes part in the hash key, that is:
	// hash_shift * MIN_MATCH >= hash_bits
	var hash_shift; // Window position at the beginning of the current output block. Gets
	// negative when the window is moved backwards.
	var block_start;var match_length; // length of best match
	var prev_match; // previous match
	var match_available; // set if previous match exists
	var strstart; // start of string to insert
	var match_start; // start of matching string
	var lookahead; // number of valid bytes ahead in window
	// Length of the best match at previous step. Matches not greater than this
	// are discarded. This is used in the lazy match evaluation.
	var prev_length; // To speed up deflation, hash chains are never searched beyond this
	// length. A higher limit improves compression ratio but degrades the speed.
	var max_chain_length; // Attempt to find a better match only when the current match is strictly
	// smaller than this value. This mechanism is used only for compression
	// levels >= 4.
	var max_lazy_match; // Insert new strings in the hash table only if the match length is not
	// greater than this length. This saves time but degrades compression.
	// max_insert_length is used only for compression levels <= 3.
	var level; // compression level (1..9)
	var strategy; // favor or force Huffman coding
	// Use a faster search when the previous match is longer than this
	var good_match; // Stop searching when current match exceeds this
	var nice_match;var dyn_ltree; // literal and length tree
	var dyn_dtree; // distance tree
	var bl_tree; // Huffman tree for bit lengths
	var l_desc=new Tree(); // desc for literal tree
	var d_desc=new Tree(); // desc for distance tree
	var bl_desc=new Tree(); // desc for bit length tree
	// that.heap_len; // number of elements in the heap
	// that.heap_max; // element of largest frequency
	// The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	// The same heap array is used to build all trees.
	// Depth of each subtree used as tie breaker for trees of equal frequency
	that.depth = [];var l_buf; // index for literals or lengths */
	// Size of match buffer for literals/lengths. There are 4 reasons for
	// limiting lit_bufsize to 64K:
	// - frequencies can be kept in 16 bit counters
	// - if compression is not successful for the first block, all input
	// data is still in the window so we can still emit a stored block even
	// when input comes from standard input. (This can also be done for
	// all blocks if lit_bufsize is not greater than 32K.)
	// - if compression is not successful for a file smaller than 64K, we can
	// even emit a stored file instead of a stored block (saving 5 bytes).
	// This is applicable only for zip (not gzip or zlib).
	// - creating new Huffman trees less frequently may not provide fast
	// adaptation to changes in the input data statistics. (Take for
	// example a binary file with poorly compressible code followed by
	// a highly compressible string table.) Smaller buffer sizes give
	// fast adaptation but have of course the overhead of transmitting
	// trees more frequently.
	// - I can't count above 4
	var lit_bufsize;var last_lit; // running index in l_buf
	// Buffer for distances. To simplify the code, d_buf and l_buf have
	// the same number of elements. To use different lengths, an extra flag
	// array would be necessary.
	var d_buf; // index of pendig_buf
	// that.opt_len; // bit length of current block with optimal trees
	// that.static_len; // bit length of current block with static trees
	var matches; // number of string matches in current block
	var last_eob_len; // bit length of EOB code for last block
	// Output buffer. bits are inserted starting at the bottom (least
	// significant bits).
	var bi_buf; // Number of valid bits in bi_buf. All bits above the last valid bit
	// are always zero.
	var bi_valid; // number of codes at each bit length for an optimal tree
	that.bl_count = []; // heap used to build the Huffman trees
	that.heap = [];dyn_ltree = [];dyn_dtree = [];bl_tree = [];function lm_init(){var i;window_size = 2 * w_size;head[hash_size - 1] = 0;for(i = 0;i < hash_size - 1;i++) {head[i] = 0;} // Set the default configuration parameters:
	max_lazy_match = config_table[level].max_lazy;good_match = config_table[level].good_length;nice_match = config_table[level].nice_length;max_chain_length = config_table[level].max_chain;strstart = 0;block_start = 0;lookahead = 0;match_length = prev_length = MIN_MATCH - 1;match_available = 0;ins_h = 0;}function init_block(){var i; // Initialize the trees.
	for(i = 0;i < L_CODES;i++) dyn_ltree[i * 2] = 0;for(i = 0;i < D_CODES;i++) dyn_dtree[i * 2] = 0;for(i = 0;i < BL_CODES;i++) bl_tree[i * 2] = 0;dyn_ltree[END_BLOCK * 2] = 1;that.opt_len = that.static_len = 0;last_lit = matches = 0;} // Initialize the tree data structures for a new zlib stream.
	function tr_init(){l_desc.dyn_tree = dyn_ltree;l_desc.stat_desc = StaticTree.static_l_desc;d_desc.dyn_tree = dyn_dtree;d_desc.stat_desc = StaticTree.static_d_desc;bl_desc.dyn_tree = bl_tree;bl_desc.stat_desc = StaticTree.static_bl_desc;bi_buf = 0;bi_valid = 0;last_eob_len = 8; // enough lookahead for inflate
	// Initialize the first block of the first file:
	init_block();} // Restore the heap property by moving down the tree starting at node k,
	// exchanging a node with the smallest of its two sons if necessary,
	// stopping
	// when the heap property is re-established (each father smaller than its
	// two sons).
	that.pqdownheap = function(tree, // the tree to restore
	k // node to move down
	){var heap=that.heap;var v=heap[k];var j=k << 1; // left son of k
	while(j <= that.heap_len) { // Set j to the smallest of the two sons:
	if(j < that.heap_len && smaller(tree,heap[j + 1],heap[j],that.depth)){j++;} // Exit if v is smaller than both sons
	if(smaller(tree,v,heap[j],that.depth))break; // Exchange v with the smallest son
	heap[k] = heap[j];k = j; // And continue down the tree, setting j to the left son of k
	j <<= 1;}heap[k] = v;}; // Scan a literal or distance tree to determine the frequencies of the codes
	// in the bit length tree.
	function scan_tree(tree, // the tree to be scanned
	max_code // and its largest code of non zero frequency
	){var n; // iterates over all tree elements
	var prevlen=-1; // last emitted length
	var curlen; // length of current code
	var nextlen=tree[0 * 2 + 1]; // length of next code
	var count=0; // repeat count of the current code
	var max_count=7; // max repeat count
	var min_count=4; // min repeat count
	if(nextlen === 0){max_count = 138;min_count = 3;}tree[(max_code + 1) * 2 + 1] = 0xffff; // guard
	for(n = 0;n <= max_code;n++) {curlen = nextlen;nextlen = tree[(n + 1) * 2 + 1];if(++count < max_count && curlen == nextlen){continue;}else if(count < min_count){bl_tree[curlen * 2] += count;}else if(curlen !== 0){if(curlen != prevlen)bl_tree[curlen * 2]++;bl_tree[REP_3_6 * 2]++;}else if(count <= 10){bl_tree[REPZ_3_10 * 2]++;}else {bl_tree[REPZ_11_138 * 2]++;}count = 0;prevlen = curlen;if(nextlen === 0){max_count = 138;min_count = 3;}else if(curlen == nextlen){max_count = 6;min_count = 3;}else {max_count = 7;min_count = 4;}}} // Construct the Huffman tree for the bit lengths and return the index in
	// bl_order of the last bit length code to send.
	function build_bl_tree(){var max_blindex; // index of last bit length code of non zero freq
	// Determine the bit length frequencies for literal and distance trees
	scan_tree(dyn_ltree,l_desc.max_code);scan_tree(dyn_dtree,d_desc.max_code); // Build the bit length tree:
	bl_desc.build_tree(that); // opt_len now includes the length of the tree representations, except
	// the lengths of the bit lengths codes and the 5+5+4 bits for the
	// counts.
	// Determine the number of bit length codes to send. The pkzip format
	// requires that at least 4 bit length codes be sent. (appnote.txt says
	// 3 but the actual value used is 4.)
	for(max_blindex = BL_CODES - 1;max_blindex >= 3;max_blindex--) {if(bl_tree[Tree.bl_order[max_blindex] * 2 + 1] !== 0)break;} // Update opt_len to include the bit length tree and counts
	that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;return max_blindex;} // Output a byte on the stream.
	// IN assertion: there is enough room in pending_buf.
	function put_byte(p){that.pending_buf[that.pending++] = p;}function put_short(w){put_byte(w & 0xff);put_byte(w >>> 8 & 0xff);}function putShortMSB(b){put_byte(b >> 8 & 0xff);put_byte(b & 0xff & 0xff);}function send_bits(value,length){var val,len=length;if(bi_valid > Buf_size - len){val = value; // bi_buf |= (val << bi_valid);
	bi_buf |= val << bi_valid & 0xffff;put_short(bi_buf);bi_buf = val >>> Buf_size - bi_valid;bi_valid += len - Buf_size;}else { // bi_buf |= (value) << bi_valid;
	bi_buf |= value << bi_valid & 0xffff;bi_valid += len;}}function send_code(c,tree){var c2=c * 2;send_bits(tree[c2] & 0xffff,tree[c2 + 1] & 0xffff);} // Send a literal or distance tree in compressed form, using the codes in
	// bl_tree.
	function send_tree(tree, // the tree to be sent
	max_code // and its largest code of non zero frequency
	){var n; // iterates over all tree elements
	var prevlen=-1; // last emitted length
	var curlen; // length of current code
	var nextlen=tree[0 * 2 + 1]; // length of next code
	var count=0; // repeat count of the current code
	var max_count=7; // max repeat count
	var min_count=4; // min repeat count
	if(nextlen === 0){max_count = 138;min_count = 3;}for(n = 0;n <= max_code;n++) {curlen = nextlen;nextlen = tree[(n + 1) * 2 + 1];if(++count < max_count && curlen == nextlen){continue;}else if(count < min_count){do {send_code(curlen,bl_tree);}while(--count !== 0);}else if(curlen !== 0){if(curlen != prevlen){send_code(curlen,bl_tree);count--;}send_code(REP_3_6,bl_tree);send_bits(count - 3,2);}else if(count <= 10){send_code(REPZ_3_10,bl_tree);send_bits(count - 3,3);}else {send_code(REPZ_11_138,bl_tree);send_bits(count - 11,7);}count = 0;prevlen = curlen;if(nextlen === 0){max_count = 138;min_count = 3;}else if(curlen == nextlen){max_count = 6;min_count = 3;}else {max_count = 7;min_count = 4;}}} // Send the header for a block using dynamic Huffman trees: the counts, the
	// lengths of the bit length codes, the literal tree and the distance tree.
	// IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	function send_all_trees(lcodes,dcodes,blcodes){var rank; // index in bl_order
	send_bits(lcodes - 257,5); // not +255 as stated in appnote.txt
	send_bits(dcodes - 1,5);send_bits(blcodes - 4,4); // not -3 as stated in appnote.txt
	for(rank = 0;rank < blcodes;rank++) {send_bits(bl_tree[Tree.bl_order[rank] * 2 + 1],3);}send_tree(dyn_ltree,lcodes - 1); // literal tree
	send_tree(dyn_dtree,dcodes - 1); // distance tree
	} // Flush the bit buffer, keeping at most 7 bits in it.
	function bi_flush(){if(bi_valid == 16){put_short(bi_buf);bi_buf = 0;bi_valid = 0;}else if(bi_valid >= 8){put_byte(bi_buf & 0xff);bi_buf >>>= 8;bi_valid -= 8;}} // Send one empty static block to give enough lookahead for inflate.
	// This takes 10 bits, of which 7 may remain in the bit buffer.
	// The current inflate code requires 9 bits of lookahead. If the
	// last two codes for the previous block (real code plus EOB) were coded
	// on 5 bits or less, inflate may have only 5+3 bits of lookahead to decode
	// the last real code. In this case we send two empty static blocks instead
	// of one. (There are no problems if the previous block is stored or fixed.)
	// To simplify the code, we assume the worst case of last real code encoded
	// on one bit only.
	function _tr_align(){send_bits(STATIC_TREES << 1,3);send_code(END_BLOCK,StaticTree.static_ltree);bi_flush(); // Of the 10 bits for the empty block, we have already sent
	// (10 - bi_valid) bits. The lookahead for the last real code (before
	// the EOB of the previous block) was thus at least one plus the length
	// of the EOB plus what we have just sent of the empty static block.
	if(1 + last_eob_len + 10 - bi_valid < 9){send_bits(STATIC_TREES << 1,3);send_code(END_BLOCK,StaticTree.static_ltree);bi_flush();}last_eob_len = 7;} // Save the match info and tally the frequency counts. Return true if
	// the current block must be flushed.
	function _tr_tally(dist, // distance of matched string
	lc // match length-MIN_MATCH or unmatched char (if dist==0)
	){var out_length,in_length,dcode;that.pending_buf[d_buf + last_lit * 2] = dist >>> 8 & 0xff;that.pending_buf[d_buf + last_lit * 2 + 1] = dist & 0xff;that.pending_buf[l_buf + last_lit] = lc & 0xff;last_lit++;if(dist === 0){ // lc is the unmatched char
	dyn_ltree[lc * 2]++;}else {matches++; // Here, lc is the match length - MIN_MATCH
	dist--; // dist = match distance - 1
	dyn_ltree[(Tree._length_code[lc] + LITERALS + 1) * 2]++;dyn_dtree[Tree.d_code(dist) * 2]++;}if((last_lit & 0x1fff) === 0 && level > 2){ // Compute an upper bound for the compressed length
	out_length = last_lit * 8;in_length = strstart - block_start;for(dcode = 0;dcode < D_CODES;dcode++) {out_length += dyn_dtree[dcode * 2] * (5 + Tree.extra_dbits[dcode]);}out_length >>>= 3;if(matches < Math.floor(last_lit / 2) && out_length < Math.floor(in_length / 2))return true;}return last_lit == lit_bufsize - 1; // We avoid equality with lit_bufsize because of wraparound at 64K
	// on 16 bit machines and because stored blocks are restricted to
	// 64K-1 bytes.
	} // Send the block data compressed using the given Huffman trees
	function compress_block(ltree,dtree){var dist; // distance of matched string
	var lc; // match length or unmatched char (if dist === 0)
	var lx=0; // running index in l_buf
	var code; // the code to send
	var extra; // number of extra bits to send
	if(last_lit !== 0){do {dist = that.pending_buf[d_buf + lx * 2] << 8 & 0xff00 | that.pending_buf[d_buf + lx * 2 + 1] & 0xff;lc = that.pending_buf[l_buf + lx] & 0xff;lx++;if(dist === 0){send_code(lc,ltree); // send a literal byte
	}else { // Here, lc is the match length - MIN_MATCH
	code = Tree._length_code[lc];send_code(code + LITERALS + 1,ltree); // send the length
	// code
	extra = Tree.extra_lbits[code];if(extra !== 0){lc -= Tree.base_length[code];send_bits(lc,extra); // send the extra length bits
	}dist--; // dist is now the match distance - 1
	code = Tree.d_code(dist);send_code(code,dtree); // send the distance code
	extra = Tree.extra_dbits[code];if(extra !== 0){dist -= Tree.base_dist[code];send_bits(dist,extra); // send the extra distance bits
	}} // literal or match pair ?
	// Check that the overlay between pending_buf and d_buf+l_buf is
	// ok:
	}while(lx < last_lit);}send_code(END_BLOCK,ltree);last_eob_len = ltree[END_BLOCK * 2 + 1];} // Flush the bit buffer and align the output on a byte boundary
	function bi_windup(){if(bi_valid > 8){put_short(bi_buf);}else if(bi_valid > 0){put_byte(bi_buf & 0xff);}bi_buf = 0;bi_valid = 0;} // Copy a stored block, storing first the length and its
	// one's complement if requested.
	function copy_block(buf, // the input data
	len, // its length
	header // true if block header must be written
	){bi_windup(); // align on byte boundary
	last_eob_len = 8; // enough lookahead for inflate
	if(header){put_short(len);put_short(~len);}that.pending_buf.set(window.subarray(buf,buf + len),that.pending);that.pending += len;} // Send a stored block
	function _tr_stored_block(buf, // input block
	stored_len, // length of input block
	eof // true if this is the last block for a file
	){send_bits((STORED_BLOCK << 1) + (eof?1:0),3); // send block type
	copy_block(buf,stored_len,true); // with header
	} // Determine the best encoding for the current block: dynamic trees, static
	// trees or store, and output the encoded block to the zip file.
	function _tr_flush_block(buf, // input block, or NULL if too old
	stored_len, // length of input block
	eof // true if this is the last block for a file
	){var opt_lenb,static_lenb; // opt_len and static_len in bytes
	var max_blindex=0; // index of last bit length code of non zero freq
	// Build the Huffman trees unless a stored block is forced
	if(level > 0){ // Construct the literal and distance trees
	l_desc.build_tree(that);d_desc.build_tree(that); // At this point, opt_len and static_len are the total bit lengths
	// of
	// the compressed block data, excluding the tree representations.
	// Build the bit length tree for the above two trees, and get the
	// index
	// in bl_order of the last bit length code to send.
	max_blindex = build_bl_tree(); // Determine the best encoding. Compute first the block length in
	// bytes
	opt_lenb = that.opt_len + 3 + 7 >>> 3;static_lenb = that.static_len + 3 + 7 >>> 3;if(static_lenb <= opt_lenb)opt_lenb = static_lenb;}else {opt_lenb = static_lenb = stored_len + 5; // force a stored block
	}if(stored_len + 4 <= opt_lenb && buf != -1){ // 4: two words for the lengths
	// The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	// Otherwise we can't have processed more than WSIZE input bytes
	// since
	// the last block flush, because compression would have been
	// successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	// transform a block into a stored block.
	_tr_stored_block(buf,stored_len,eof);}else if(static_lenb == opt_lenb){send_bits((STATIC_TREES << 1) + (eof?1:0),3);compress_block(StaticTree.static_ltree,StaticTree.static_dtree);}else {send_bits((DYN_TREES << 1) + (eof?1:0),3);send_all_trees(l_desc.max_code + 1,d_desc.max_code + 1,max_blindex + 1);compress_block(dyn_ltree,dyn_dtree);} // The above check is made mod 2^32, for files larger than 512 MB
	// and uLong implemented on 32 bits.
	init_block();if(eof){bi_windup();}}function flush_block_only(eof){_tr_flush_block(block_start >= 0?block_start:-1,strstart - block_start,eof);block_start = strstart;strm.flush_pending();} // Fill the window when the lookahead becomes insufficient.
	// Updates strstart and lookahead.
	//
	// IN assertion: lookahead < MIN_LOOKAHEAD
	// OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	// At least one byte has been read, or avail_in === 0; reads are
	// performed for at least two bytes (required for the zip translate_eol
	// option -- not supported here).
	function fill_window(){var n,m;var p;var more; // Amount of free space at the end of the window.
	do {more = window_size - lookahead - strstart; // Deal with !@#$% 64K limit:
	if(more === 0 && strstart === 0 && lookahead === 0){more = w_size;}else if(more == -1){ // Very unlikely, but possible on 16 bit machine if strstart ==
	// 0
	// and lookahead == 1 (input done one byte at time)
	more--; // If the window is almost full and there is insufficient
	// lookahead,
	// move the upper half to the lower one to make room in the
	// upper half.
	}else if(strstart >= w_size + w_size - MIN_LOOKAHEAD){window.set(window.subarray(w_size,w_size + w_size),0);match_start -= w_size;strstart -= w_size; // we now have strstart >= MAX_DIST
	block_start -= w_size; // Slide the hash table (could be avoided with 32 bit values
	// at the expense of memory usage). We slide even when level ==
	// 0
	// to keep the hash table consistent if we switch back to level
	// > 0
	// later. (Using level 0 permanently is not an optimal usage of
	// zlib, so we don't care about this pathological case.)
	n = hash_size;p = n;do {m = head[--p] & 0xffff;head[p] = m >= w_size?m - w_size:0;}while(--n !== 0);n = w_size;p = n;do {m = prev[--p] & 0xffff;prev[p] = m >= w_size?m - w_size:0; // If n is not on any hash chain, prev[n] is garbage but
	// its value will never be used.
	}while(--n !== 0);more += w_size;}if(strm.avail_in === 0)return; // If there was no sliding:
	// strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	// more == window_size - lookahead - strstart
	// => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	// => more >= window_size - 2*WSIZE + 2
	// In the BIG_MEM or MMAP case (not yet supported),
	// window_size == input_size + MIN_LOOKAHEAD &&
	// strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	// Otherwise, window_size == 2*WSIZE so more >= 2.
	// If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	n = strm.read_buf(window,strstart + lookahead,more);lookahead += n; // Initialize the hash value now that we have some input:
	if(lookahead >= MIN_MATCH){ins_h = window[strstart] & 0xff;ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask;} // If the whole input has less than MIN_MATCH bytes, ins_h is
	// garbage,
	// but this is not important since only literal bytes will be
	// emitted.
	}while(lookahead < MIN_LOOKAHEAD && strm.avail_in !== 0);} // Copy without compression as much as possible from the input stream,
	// return
	// the current block state.
	// This function does not insert new strings in the dictionary since
	// uncompressible data is probably not useful. This function is used
	// only for the level=0 compression option.
	// NOTE: this function should be optimized to avoid extra copying from
	// window to pending_buf.
	function deflate_stored(flush){ // Stored blocks are limited to 0xffff bytes, pending_buf is limited
	// to pending_buf_size, and each stored block has a 5 byte header:
	var max_block_size=0xffff;var max_start;if(max_block_size > pending_buf_size - 5){max_block_size = pending_buf_size - 5;} // Copy as much as possible from input to output:
	while(true) { // Fill the window as much as possible:
	if(lookahead <= 1){fill_window();if(lookahead === 0 && flush == Z_NO_FLUSH)return NeedMore;if(lookahead === 0)break; // flush the current block
	}strstart += lookahead;lookahead = 0; // Emit a stored block if pending_buf will be full:
	max_start = block_start + max_block_size;if(strstart === 0 || strstart >= max_start){ // strstart === 0 is possible when wraparound on 16-bit machine
	lookahead = strstart - max_start;strstart = max_start;flush_block_only(false);if(strm.avail_out === 0)return NeedMore;} // Flush if we may have to slide, otherwise block_start may become
	// negative and the data will be gone:
	if(strstart - block_start >= w_size - MIN_LOOKAHEAD){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0)return flush == Z_FINISH?FinishStarted:NeedMore;return flush == Z_FINISH?FinishDone:BlockDone;}function longest_match(cur_match){var chain_length=max_chain_length; // max hash chain length
	var scan=strstart; // current string
	var match; // matched string
	var len; // length of current match
	var best_len=prev_length; // best match length so far
	var limit=strstart > w_size - MIN_LOOKAHEAD?strstart - (w_size - MIN_LOOKAHEAD):0;var _nice_match=nice_match; // Stop when cur_match becomes <= limit. To simplify the code,
	// we prevent matches with the string of window index 0.
	var wmask=w_mask;var strend=strstart + MAX_MATCH;var scan_end1=window[scan + best_len - 1];var scan_end=window[scan + best_len]; // The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of
	// 16.
	// It is easy to get rid of this optimization if necessary.
	// Do not waste too much time if we already have a good match:
	if(prev_length >= good_match){chain_length >>= 2;} // Do not look for matches beyond the end of the input. This is
	// necessary
	// to make deflate deterministic.
	if(_nice_match > lookahead)_nice_match = lookahead;do {match = cur_match; // Skip to next match if the match length cannot increase
	// or if the match length is less than 2:
	if(window[match + best_len] != scan_end || window[match + best_len - 1] != scan_end1 || window[match] != window[scan] || window[++match] != window[scan + 1])continue; // The check at best_len-1 can be removed because it will be made
	// again later. (This heuristic is not always a win.)
	// It is not necessary to compare scan[2] and match[2] since they
	// are always equal when the other bytes match, given that
	// the hash keys are equal and that HASH_BITS >= 8.
	scan += 2;match++; // We check for insufficient lookahead only every 8th comparison;
	// the 256th check will be made at strstart+258.
	do {}while(window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && scan < strend);len = MAX_MATCH - (strend - scan);scan = strend - MAX_MATCH;if(len > best_len){match_start = cur_match;best_len = len;if(len >= _nice_match)break;scan_end1 = window[scan + best_len - 1];scan_end = window[scan + best_len];}}while((cur_match = prev[cur_match & wmask] & 0xffff) > limit && --chain_length !== 0);if(best_len <= lookahead)return best_len;return lookahead;} // Compress as much as possible from the input stream, return the current
	// block state.
	// This function does not perform lazy evaluation of matches and inserts
	// new strings in the dictionary only for unmatched strings or for short
	// matches. It is used only for the fast compression options.
	function deflate_fast(flush){ // short hash_head = 0; // head of the hash chain
	var hash_head=0; // head of the hash chain
	var bflush; // set if current block must be flushed
	while(true) { // Make sure that we always have enough lookahead, except
	// at the end of the input file. We need MAX_MATCH bytes
	// for the next match, plus MIN_MATCH bytes to insert the
	// string following the next match.
	if(lookahead < MIN_LOOKAHEAD){fill_window();if(lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH){return NeedMore;}if(lookahead === 0)break; // flush the current block
	} // Insert the string window[strstart .. strstart+2] in the
	// dictionary, and set hash_head to the head of the hash chain:
	if(lookahead >= MIN_MATCH){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;} // Find the longest match, discarding those <= prev_length.
	// At this point we have always match_length < MIN_MATCH
	if(hash_head !== 0 && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD){ // To simplify the code, we prevent matches with the string
	// of window index 0 (in particular we have to avoid a match
	// of the string with itself at the start of the input file).
	if(strategy != Z_HUFFMAN_ONLY){match_length = longest_match(hash_head);} // longest_match() sets match_start
	}if(match_length >= MIN_MATCH){ // check_match(strstart, match_start, match_length);
	bflush = _tr_tally(strstart - match_start,match_length - MIN_MATCH);lookahead -= match_length; // Insert new strings in the hash table only if the match length
	// is not too large. This saves time but degrades compression.
	if(match_length <= max_lazy_match && lookahead >= MIN_MATCH){match_length--; // string at strstart already in hash table
	do {strstart++;ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart; // strstart never exceeds WSIZE-MAX_MATCH, so there are
	// always MIN_MATCH bytes ahead.
	}while(--match_length !== 0);strstart++;}else {strstart += match_length;match_length = 0;ins_h = window[strstart] & 0xff;ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask; // If lookahead < MIN_MATCH, ins_h is garbage, but it does
	// not
	// matter since it will be recomputed at next deflate call.
	}}else { // No match, output a literal byte
	bflush = _tr_tally(0,window[strstart] & 0xff);lookahead--;strstart++;}if(bflush){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0){if(flush == Z_FINISH)return FinishStarted;else return NeedMore;}return flush == Z_FINISH?FinishDone:BlockDone;} // Same as above, but achieves better compression. We use a lazy
	// evaluation for matches: a match is finally adopted only if there is
	// no better match at the next window position.
	function deflate_slow(flush){ // short hash_head = 0; // head of hash chain
	var hash_head=0; // head of hash chain
	var bflush; // set if current block must be flushed
	var max_insert; // Process the input block.
	while(true) { // Make sure that we always have enough lookahead, except
	// at the end of the input file. We need MAX_MATCH bytes
	// for the next match, plus MIN_MATCH bytes to insert the
	// string following the next match.
	if(lookahead < MIN_LOOKAHEAD){fill_window();if(lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH){return NeedMore;}if(lookahead === 0)break; // flush the current block
	} // Insert the string window[strstart .. strstart+2] in the
	// dictionary, and set hash_head to the head of the hash chain:
	if(lookahead >= MIN_MATCH){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;} // Find the longest match, discarding those <= prev_length.
	prev_length = match_length;prev_match = match_start;match_length = MIN_MATCH - 1;if(hash_head !== 0 && prev_length < max_lazy_match && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD){ // To simplify the code, we prevent matches with the string
	// of window index 0 (in particular we have to avoid a match
	// of the string with itself at the start of the input file).
	if(strategy != Z_HUFFMAN_ONLY){match_length = longest_match(hash_head);} // longest_match() sets match_start
	if(match_length <= 5 && (strategy == Z_FILTERED || match_length == MIN_MATCH && strstart - match_start > 4096)){ // If prev_match is also MIN_MATCH, match_start is garbage
	// but we will ignore the current match anyway.
	match_length = MIN_MATCH - 1;}} // If there was a match at the previous step and the current
	// match is not better, output the previous match:
	if(prev_length >= MIN_MATCH && match_length <= prev_length){max_insert = strstart + lookahead - MIN_MATCH; // Do not insert strings in hash table beyond this.
	// check_match(strstart-1, prev_match, prev_length);
	bflush = _tr_tally(strstart - 1 - prev_match,prev_length - MIN_MATCH); // Insert in hash table all strings up to the end of the match.
	// strstart-1 and strstart are already inserted. If there is not
	// enough lookahead, the last two strings are not inserted in
	// the hash table.
	lookahead -= prev_length - 1;prev_length -= 2;do {if(++strstart <= max_insert){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;}}while(--prev_length !== 0);match_available = 0;match_length = MIN_MATCH - 1;strstart++;if(bflush){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}else if(match_available !== 0){ // If there was no match at the previous position, output a
	// single literal. If there was a match but the current match
	// is longer, truncate the previous match to a single literal.
	bflush = _tr_tally(0,window[strstart - 1] & 0xff);if(bflush){flush_block_only(false);}strstart++;lookahead--;if(strm.avail_out === 0)return NeedMore;}else { // There is no previous match to compare with, wait for
	// the next step to decide.
	match_available = 1;strstart++;lookahead--;}}if(match_available !== 0){bflush = _tr_tally(0,window[strstart - 1] & 0xff);match_available = 0;}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0){if(flush == Z_FINISH)return FinishStarted;else return NeedMore;}return flush == Z_FINISH?FinishDone:BlockDone;}function deflateReset(strm){strm.total_in = strm.total_out = 0;strm.msg = null; //
	that.pending = 0;that.pending_out = 0;status = BUSY_STATE;last_flush = Z_NO_FLUSH;tr_init();lm_init();return Z_OK;}that.deflateInit = function(strm,_level,bits,_method,memLevel,_strategy){if(!_method)_method = Z_DEFLATED;if(!memLevel)memLevel = DEF_MEM_LEVEL;if(!_strategy)_strategy = Z_DEFAULT_STRATEGY; // byte[] my_version=ZLIB_VERSION;
	//
	// if (!version || version[0] != my_version[0]
	// || stream_size != sizeof(z_stream)) {
	// return Z_VERSION_ERROR;
	// }
	strm.msg = null;if(_level == Z_DEFAULT_COMPRESSION)_level = 6;if(memLevel < 1 || memLevel > MAX_MEM_LEVEL || _method != Z_DEFLATED || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY){return Z_STREAM_ERROR;}strm.dstate = that;w_bits = bits;w_size = 1 << w_bits;w_mask = w_size - 1;hash_bits = memLevel + 7;hash_size = 1 << hash_bits;hash_mask = hash_size - 1;hash_shift = Math.floor((hash_bits + MIN_MATCH - 1) / MIN_MATCH);window = new Uint8Array(w_size * 2);prev = [];head = [];lit_bufsize = 1 << memLevel + 6; // 16K elements by default
	// We overlay pending_buf and d_buf+l_buf. This works since the average
	// output size for (length,distance) codes is <= 24 bits.
	that.pending_buf = new Uint8Array(lit_bufsize * 4);pending_buf_size = lit_bufsize * 4;d_buf = Math.floor(lit_bufsize / 2);l_buf = (1 + 2) * lit_bufsize;level = _level;strategy = _strategy;return deflateReset(strm);};that.deflateEnd = function(){if(status != INIT_STATE && status != BUSY_STATE && status != FINISH_STATE){return Z_STREAM_ERROR;} // Deallocate in reverse order of allocations:
	that.pending_buf = null;head = null;prev = null;window = null; // free
	that.dstate = null;return status == BUSY_STATE?Z_DATA_ERROR:Z_OK;};that.deflateParams = function(strm,_level,_strategy){var err=Z_OK;if(_level == Z_DEFAULT_COMPRESSION){_level = 6;}if(_level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY){return Z_STREAM_ERROR;}if(config_table[level].func != config_table[_level].func && strm.total_in !== 0){ // Flush the last buffer:
	err = strm.deflate(Z_PARTIAL_FLUSH);}if(level != _level){level = _level;max_lazy_match = config_table[level].max_lazy;good_match = config_table[level].good_length;nice_match = config_table[level].nice_length;max_chain_length = config_table[level].max_chain;}strategy = _strategy;return err;};that.deflateSetDictionary = function(strm,dictionary,dictLength){var length=dictLength;var n,index=0;if(!dictionary || status != INIT_STATE)return Z_STREAM_ERROR;if(length < MIN_MATCH)return Z_OK;if(length > w_size - MIN_LOOKAHEAD){length = w_size - MIN_LOOKAHEAD;index = dictLength - length; // use the tail of the dictionary
	}window.set(dictionary.subarray(index,index + length),0);strstart = length;block_start = length; // Insert all strings in the hash table (except for the last two bytes).
	// s->lookahead stays null, so s->ins_h will be recomputed at the next
	// call of fill_window.
	ins_h = window[0] & 0xff;ins_h = (ins_h << hash_shift ^ window[1] & 0xff) & hash_mask;for(n = 0;n <= length - MIN_MATCH;n++) {ins_h = (ins_h << hash_shift ^ window[n + (MIN_MATCH - 1)] & 0xff) & hash_mask;prev[n & w_mask] = head[ins_h];head[ins_h] = n;}return Z_OK;};that.deflate = function(_strm,flush){var i,header,level_flags,old_flush,bstate;if(flush > Z_FINISH || flush < 0){return Z_STREAM_ERROR;}if(!_strm.next_out || !_strm.next_in && _strm.avail_in !== 0 || status == FINISH_STATE && flush != Z_FINISH){_strm.msg = z_errmsg[Z_NEED_DICT - Z_STREAM_ERROR];return Z_STREAM_ERROR;}if(_strm.avail_out === 0){_strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;}strm = _strm; // just in case
	old_flush = last_flush;last_flush = flush; // Write the zlib header
	if(status == INIT_STATE){header = Z_DEFLATED + (w_bits - 8 << 4) << 8;level_flags = (level - 1 & 0xff) >> 1;if(level_flags > 3)level_flags = 3;header |= level_flags << 6;if(strstart !== 0)header |= PRESET_DICT;header += 31 - header % 31;status = BUSY_STATE;putShortMSB(header);} // Flush as much pending output as possible
	if(that.pending !== 0){strm.flush_pending();if(strm.avail_out === 0){ // console.log(" avail_out==0");
	// Since avail_out is 0, deflate will be called again with
	// more output space, but possibly with both pending and
	// avail_in equal to zero. There won't be anything to do,
	// but this is not an error situation so make sure we
	// return OK instead of BUF_ERROR at next call of deflate:
	last_flush = -1;return Z_OK;} // Make sure there is something to do and avoid duplicate
	// consecutive
	// flushes. For repeated and useless calls with Z_FINISH, we keep
	// returning Z_STREAM_END instead of Z_BUFF_ERROR.
	}else if(strm.avail_in === 0 && flush <= old_flush && flush != Z_FINISH){strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;} // User must not provide more input after the first FINISH:
	if(status == FINISH_STATE && strm.avail_in !== 0){_strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;} // Start a new block or continue the current one.
	if(strm.avail_in !== 0 || lookahead !== 0 || flush != Z_NO_FLUSH && status != FINISH_STATE){bstate = -1;switch(config_table[level].func){case STORED:bstate = deflate_stored(flush);break;case FAST:bstate = deflate_fast(flush);break;case SLOW:bstate = deflate_slow(flush);break;default:}if(bstate == FinishStarted || bstate == FinishDone){status = FINISH_STATE;}if(bstate == NeedMore || bstate == FinishStarted){if(strm.avail_out === 0){last_flush = -1; // avoid BUF_ERROR next call, see above
	}return Z_OK; // If flush != Z_NO_FLUSH && avail_out === 0, the next call
	// of deflate should use the same flush parameter to make sure
	// that the flush is complete. So we don't have to output an
	// empty block here, this will be done at next call. This also
	// ensures that for a very small output buffer, we emit at most
	// one empty block.
	}if(bstate == BlockDone){if(flush == Z_PARTIAL_FLUSH){_tr_align();}else { // FULL_FLUSH or SYNC_FLUSH
	_tr_stored_block(0,0,false); // For a full flush, this empty block will be recognized
	// as a special marker by inflate_sync().
	if(flush == Z_FULL_FLUSH){ // state.head[s.hash_size-1]=0;
	for(i = 0;i < hash_size /*-1*/;i++)  // forget history
	head[i] = 0;}}strm.flush_pending();if(strm.avail_out === 0){last_flush = -1; // avoid BUF_ERROR at next call, see above
	return Z_OK;}}}if(flush != Z_FINISH)return Z_OK;return Z_STREAM_END;};} // ZStream
	function ZStream(){var that=this;that.next_in_index = 0;that.next_out_index = 0; // that.next_in; // next input byte
	that.avail_in = 0; // number of bytes available at next_in
	that.total_in = 0; // total nb of input bytes read so far
	// that.next_out; // next output byte should be put there
	that.avail_out = 0; // remaining free space at next_out
	that.total_out = 0; // total nb of bytes output so far
	// that.msg;
	// that.dstate;
	}ZStream.prototype = {deflateInit:function deflateInit(level,bits){var that=this;that.dstate = new Deflate();if(!bits)bits = MAX_BITS;return that.dstate.deflateInit(that,level,bits);},deflate:function deflate(flush){var that=this;if(!that.dstate){return Z_STREAM_ERROR;}return that.dstate.deflate(that,flush);},deflateEnd:function deflateEnd(){var that=this;if(!that.dstate)return Z_STREAM_ERROR;var ret=that.dstate.deflateEnd();that.dstate = null;return ret;},deflateParams:function deflateParams(level,strategy){var that=this;if(!that.dstate)return Z_STREAM_ERROR;return that.dstate.deflateParams(that,level,strategy);},deflateSetDictionary:function deflateSetDictionary(dictionary,dictLength){var that=this;if(!that.dstate)return Z_STREAM_ERROR;return that.dstate.deflateSetDictionary(that,dictionary,dictLength);}, // Read a new buffer from the current input stream, update the
	// total number of bytes read. All deflate() input goes through
	// this function so some applications may wish to modify it to avoid
	// allocating a large strm->next_in buffer and copying from it.
	// (See also flush_pending()).
	read_buf:function read_buf(buf,start,size){var that=this;var len=that.avail_in;if(len > size)len = size;if(len === 0)return 0;that.avail_in -= len;buf.set(that.next_in.subarray(that.next_in_index,that.next_in_index + len),start);that.next_in_index += len;that.total_in += len;return len;}, // Flush as much pending output as possible. All deflate() output goes
	// through this function so some applications may wish to modify it
	// to avoid allocating a large strm->next_out buffer and copying into it.
	// (See also read_buf()).
	flush_pending:function flush_pending(){var that=this;var len=that.dstate.pending;if(len > that.avail_out)len = that.avail_out;if(len === 0)return; // if (that.dstate.pending_buf.length <= that.dstate.pending_out || that.next_out.length <= that.next_out_index
	// || that.dstate.pending_buf.length < (that.dstate.pending_out + len) || that.next_out.length < (that.next_out_index +
	// len)) {
	// console.log(that.dstate.pending_buf.length + ", " + that.dstate.pending_out + ", " + that.next_out.length + ", " +
	// that.next_out_index + ", " + len);
	// console.log("avail_out=" + that.avail_out);
	// }
	that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out,that.dstate.pending_out + len),that.next_out_index);that.next_out_index += len;that.dstate.pending_out += len;that.total_out += len;that.avail_out -= len;that.dstate.pending -= len;if(that.dstate.pending === 0){that.dstate.pending_out = 0;}}}; // Deflater
	return function Deflater(level){var that=this;var z=new ZStream();var bufsize=512;var flush=Z_NO_FLUSH;var buf=new Uint8Array(bufsize);if(typeof level == "undefined")level = Z_DEFAULT_COMPRESSION;z.deflateInit(level);z.next_out = buf;that.append = function(data,onprogress){var err,buffers=[],lastIndex=0,bufferIndex=0,bufferSize=0,array;if(!data.length)return;z.next_in_index = 0;z.next_in = data;z.avail_in = data.length;do {z.next_out_index = 0;z.avail_out = bufsize;err = z.deflate(flush);if(err != Z_OK)throw "deflating: " + z.msg;if(z.next_out_index)if(z.next_out_index == bufsize)buffers.push(new Uint8Array(buf));else buffers.push(new Uint8Array(buf.subarray(0,z.next_out_index)));bufferSize += z.next_out_index;if(onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex){onprogress(z.next_in_index);lastIndex = z.next_in_index;}}while(z.avail_in > 0 || z.avail_out === 0);array = new Uint8Array(bufferSize);buffers.forEach(function(chunk){array.set(chunk,bufferIndex);bufferIndex += chunk.length;});return array;};that.flush = function(){var err,buffers=[],bufferIndex=0,bufferSize=0,array;do {z.next_out_index = 0;z.avail_out = bufsize;err = z.deflate(Z_FINISH);if(err != Z_STREAM_END && err != Z_OK)throw "deflating: " + z.msg;if(bufsize - z.avail_out > 0)buffers.push(new Uint8Array(buf.subarray(0,z.next_out_index)));bufferSize += z.next_out_index;}while(z.avail_in > 0 || z.avail_out === 0);z.deflateEnd();array = new Uint8Array(bufferSize);buffers.forEach(function(chunk){array.set(chunk,bufferIndex);bufferIndex += chunk.length;});return array;};};})(undefined); /*
	  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
	  Copyright (c) 2016 Niklas von Hertzen
	
	  Released under  License
	*/!(function(e){if(true)module.exports = e();else if("function" == typeof define && define.amd)define([],e);else {var f;"undefined" != typeof window?f = window:"undefined" != typeof global?f = global:"undefined" != typeof self && (f = self),f.html2canvas = e();}})(function(){var define;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require == "function" && require;if(!u && a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '" + o + "'");throw (f.code = "MODULE_NOT_FOUND",f);}var l=n[o] = {exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e);},l,l.exports,e,t,n,r);}return n[o].exports;}var i=typeof require == "function" && require;for(var o=0;o < r.length;o++) s(r[o]);return s;})({1:[function(_dereq_,module,exports){(function(global){ /*! http://mths.be/punycode v1.2.4 by @mathias */(function(root){ /** Detect free variables */var freeExports=typeof exports == 'object' && exports;var freeModule=typeof module == 'object' && module && module.exports == freeExports && module;var freeGlobal=typeof global == 'object' && global;if(freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal){root = freeGlobal;} /**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */var punycode, /** Highest positive signed 32-bit float value */maxInt=2147483647, // aka. 0x7FFFFFFF or 2^31-1
	/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128, // 0x80
	delimiter='-', // '\x2D'
	/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^ -~]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators=/\x2E|\u3002|\uFF0E|\uFF61/g, // RFC 3490 separators
	/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'}, /** Convenience shortcuts */baseMinusTMin=base - tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode, /** Temporary variable */key; /*--------------------------------------------------------------------------*/ /**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */function error(type){throw RangeError(errors[type]);} /**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */function map(array,fn){var length=array.length;while(length--) {array[length] = fn(array[length]);}return array;} /**
		 * A simple `Array#map`-like wrapper to work with domain name strings.
		 * @private
		 * @param {String} domain The domain name.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */function mapDomain(string,fn){return map(string.split(regexSeparators),fn).join('.');} /**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <http://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter < length) {value = string.charCodeAt(counter++);if(value >= 0xD800 && value <= 0xDBFF && counter < length){ // high surrogate, and there is a next character
	extra = string.charCodeAt(counter++);if((extra & 0xFC00) == 0xDC00){ // low surrogate
	output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);}else { // unmatched surrogate; only append this code unit, in case the next
	// code unit is the high surrogate of a surrogate pair
	output.push(value);counter--;}}else {output.push(value);}}return output;} /**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */function ucs2encode(array){return map(array,function(value){var output='';if(value > 0xFFFF){value -= 0x10000;output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);value = 0xDC00 | value & 0x3FF;}output += stringFromCharCode(value);return output;}).join('');} /**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */function basicToDigit(codePoint){if(codePoint - 48 < 10){return codePoint - 22;}if(codePoint - 65 < 26){return codePoint - 65;}if(codePoint - 97 < 26){return codePoint - 97;}return base;} /**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */function digitToBasic(digit,flag){ //  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);} /**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */function adapt(delta,numPoints,firstTime){var k=0;delta = firstTime?floor(delta / damp):delta >> 1;delta += floor(delta / numPoints);for(; /* no initialization */delta > baseMinusTMin * tMax >> 1;k += base) {delta = floor(delta / baseMinusTMin);}return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));} /**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */function decode(input){ // Don't use UCS-2
	var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t, /** Cached calculation results */baseMinusT; // Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.
	basic = input.lastIndexOf(delimiter);if(basic < 0){basic = 0;}for(j = 0;j < basic;++j) { // if it's not a basic code point
	if(input.charCodeAt(j) >= 0x80){error('not-basic');}output.push(input.charCodeAt(j));} // Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.
	for(index = basic > 0?basic + 1:0;index < inputLength;)  /* no final expression */{ // `index` is the index of the next character to be consumed.
	// Decode a generalized variable-length integer into `delta`,
	// which gets added to `i`. The overflow checking is easier
	// if we increase `i` as we go, then subtract off its starting
	// value at the end to obtain `delta`.
	for(oldi = i,w = 1,k = base;; /* no condition */k += base) {if(index >= inputLength){error('invalid-input');}digit = basicToDigit(input.charCodeAt(index++));if(digit >= base || digit > floor((maxInt - i) / w)){error('overflow');}i += digit * w;t = k <= bias?tMin:k >= bias + tMax?tMax:k - bias;if(digit < t){break;}baseMinusT = base - t;if(w > floor(maxInt / baseMinusT)){error('overflow');}w *= baseMinusT;}out = output.length + 1;bias = adapt(i - oldi,out,oldi == 0); // `i` was supposed to wrap around from `out` to `0`,
	// incrementing `n` each time, so we'll fix that now:
	if(floor(i / out) > maxInt - n){error('overflow');}n += floor(i / out);i %= out; // Insert `n` at position `i` of the output
	output.splice(i++,0,n);}return ucs2encode(output);} /**
		 * Converts a string of Unicode symbols to a Punycode string of ASCII-only
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[], /** `inputLength` will hold the number of code points in `input`. */inputLength, /** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT; // Convert the input in UCS-2 to Unicode
	input = ucs2decode(input); // Cache the length
	inputLength = input.length; // Initialize the state
	n = initialN;delta = 0;bias = initialBias; // Handle the basic code points
	for(j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue < 0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount = basicLength = output.length; // `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.
	// Finish the basic string - if it is not empty - with a delimiter
	if(basicLength){output.push(delimiter);} // Main encoding loop:
	while(handledCPCount < inputLength) { // All non-basic code points < n have been handled already. Find the next
	// larger one:
	for(m = maxInt,j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue >= n && currentValue < m){m = currentValue;}} // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	// but guard against overflow
	handledCPCountPlusOne = handledCPCount + 1;if(m - n > floor((maxInt - delta) / handledCPCountPlusOne)){error('overflow');}delta += (m - n) * handledCPCountPlusOne;n = m;for(j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue < n && ++delta > maxInt){error('overflow');}if(currentValue == n){ // Represent delta as a generalized variable-length integer
	for(q = delta,k = base;; /* no condition */k += base) {t = k <= bias?tMin:k >= bias + tMax?tMax:k - bias;if(q < t){break;}qMinusT = q - t;baseMinusT = base - t;output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT,0)));q = floor(qMinusT / baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias = adapt(delta,handledCPCountPlusOne,handledCPCount == basicLength);delta = 0;++handledCPCount;}}++delta;++n;}return output.join('');} /**
		 * Converts a Punycode string representing a domain name to Unicode. Only the
		 * Punycoded parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it on a string that has already been converted to
		 * Unicode.
		 * @memberOf punycode
		 * @param {String} domain The Punycode domain name to convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */function toUnicode(domain){return mapDomain(domain,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});} /**
		 * Converts a Unicode string representing a domain name to Punycode. Only the
		 * non-ASCII parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it with a domain that's already in ASCII.
		 * @memberOf punycode
		 * @param {String} domain The domain name to convert, as a Unicode string.
		 * @returns {String} The Punycode representation of the given domain name.
		 */function toASCII(domain){return mapDomain(domain,function(string){return regexNonASCII.test(string)?'xn--' + encode(string):string;});} /*--------------------------------------------------------------------------*/ /** Define the public API */punycode = { /**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */'version':'1.2.4', /**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <http://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */'ucs2':{'decode':ucs2decode,'encode':ucs2encode},'decode':decode,'encode':encode,'toASCII':toASCII,'toUnicode':toUnicode}; /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if(typeof define == 'function' && typeof define.amd == 'object' && define.amd){}else if(freeExports && !freeExports.nodeType){if(freeModule){ // in Node.js or RingoJS v0.8.0+
	freeModule.exports = punycode;}else { // in Narwhal or RingoJS v0.7.0-
	for(key in punycode) {punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);}}}else { // in Rhino or a web browser
	root.punycode = punycode;}})(this);}).call(this,typeof global !== "undefined"?global:typeof self !== "undefined"?self:typeof window !== "undefined"?window:{});},{}],2:[function(_dereq_,module,exports){var log=_dereq_('./log');function restoreOwnerScroll(ownerDocument,x,y){if(ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)){ownerDocument.defaultView.scrollTo(x,y);}}function cloneCanvasContents(canvas,clonedCanvas){try{if(clonedCanvas){clonedCanvas.width = canvas.width;clonedCanvas.height = canvas.height;clonedCanvas.getContext("2d").putImageData(canvas.getContext("2d").getImageData(0,0,canvas.width,canvas.height),0,0);}}catch(e) {log("Unable to copy canvas content from",canvas,e);}}function cloneNode(node,javascriptEnabled){var clone=node.nodeType === 3?document.createTextNode(node.nodeValue):node.cloneNode(false);var child=node.firstChild;while(child) {if(javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT'){clone.appendChild(cloneNode(child,javascriptEnabled));}child = child.nextSibling;}if(node.nodeType === 1){clone._scrollTop = node.scrollTop;clone._scrollLeft = node.scrollLeft;if(node.nodeName === "CANVAS"){cloneCanvasContents(node,clone);}else if(node.nodeName === "TEXTAREA" || node.nodeName === "SELECT"){clone.value = node.value;}}return clone;}function initNode(node){if(node.nodeType === 1){node.scrollTop = node._scrollTop;node.scrollLeft = node._scrollLeft;var child=node.firstChild;while(child) {initNode(child);child = child.nextSibling;}}}module.exports = function(ownerDocument,containerDocument,width,height,options,x,y){var documentElement=cloneNode(ownerDocument.documentElement,options.javascriptEnabled);var container=containerDocument.createElement("iframe");container.className = "html2canvas-container";container.style.visibility = "hidden";container.style.position = "fixed";container.style.left = "-10000px";container.style.top = "0px";container.style.border = "0";container.width = width;container.height = height;container.scrolling = "no"; // ios won't scroll without it
	containerDocument.body.appendChild(container);return new Promise(function(resolve){var documentClone=container.contentWindow.document; /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	         if window url is about:blank, we can assign the url to current by writing onto the document
	         */container.contentWindow.onload = container.onload = function(){var interval=setInterval(function(){if(documentClone.body.childNodes.length > 0){initNode(documentClone.documentElement);clearInterval(interval);if(options.type === "view"){container.contentWindow.scrollTo(x,y);if(/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (container.contentWindow.scrollY !== y || container.contentWindow.scrollX !== x)){documentClone.documentElement.style.top = -y + "px";documentClone.documentElement.style.left = -x + "px";documentClone.documentElement.style.position = 'absolute';}}resolve(container);}},50);};documentClone.open();documentClone.write("<!DOCTYPE html><html></html>"); // Chrome scrolls the parent document for some reason after the write to the cloned window???
	restoreOwnerScroll(ownerDocument,x,y);documentClone.replaceChild(documentClone.adoptNode(documentElement),documentClone.documentElement);documentClone.close();});};},{"./log":13}],3:[function(_dereq_,module,exports){ // http://dev.w3.org/csswg/css-color/
	function Color(value){this.r = 0;this.g = 0;this.b = 0;this.a = null;var result=this.fromArray(value) || this.namedColor(value) || this.rgb(value) || this.rgba(value) || this.hex6(value) || this.hex3(value);}Color.prototype.darken = function(amount){var a=1 - amount;return new Color([Math.round(this.r * a),Math.round(this.g * a),Math.round(this.b * a),this.a]);};Color.prototype.isTransparent = function(){return this.a === 0;};Color.prototype.isBlack = function(){return this.r === 0 && this.g === 0 && this.b === 0;};Color.prototype.fromArray = function(array){if(Array.isArray(array)){this.r = Math.min(array[0],255);this.g = Math.min(array[1],255);this.b = Math.min(array[2],255);if(array.length > 3){this.a = array[3];}}return Array.isArray(array);};var _hex3=/^#([a-f0-9]{3})$/i;Color.prototype.hex3 = function(value){var match=null;if((match = value.match(_hex3)) !== null){this.r = parseInt(match[1][0] + match[1][0],16);this.g = parseInt(match[1][1] + match[1][1],16);this.b = parseInt(match[1][2] + match[1][2],16);}return match !== null;};var _hex6=/^#([a-f0-9]{6})$/i;Color.prototype.hex6 = function(value){var match=null;if((match = value.match(_hex6)) !== null){this.r = parseInt(match[1].substring(0,2),16);this.g = parseInt(match[1].substring(2,4),16);this.b = parseInt(match[1].substring(4,6),16);}return match !== null;};var _rgb=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;Color.prototype.rgb = function(value){var match=null;if((match = value.match(_rgb)) !== null){this.r = Number(match[1]);this.g = Number(match[2]);this.b = Number(match[3]);}return match !== null;};var _rgba=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;Color.prototype.rgba = function(value){var match=null;if((match = value.match(_rgba)) !== null){this.r = Number(match[1]);this.g = Number(match[2]);this.b = Number(match[3]);this.a = Number(match[4]);}return match !== null;};Color.prototype.toString = function(){return this.a !== null && this.a !== 1?"rgba(" + [this.r,this.g,this.b,this.a].join(",") + ")":"rgb(" + [this.r,this.g,this.b].join(",") + ")";};Color.prototype.namedColor = function(value){value = value.toLowerCase();var color=colors[value];if(color){this.r = color[0];this.g = color[1];this.b = color[2];}else if(value === "transparent"){this.r = this.g = this.b = this.a = 0;return true;}return !!color;};Color.prototype.isColor = true; // JSON.stringify([].slice.call($$('.named-color-table tr'), 1).map(function(row) { return [row.childNodes[3].textContent, row.childNodes[5].textContent.trim().split(",").map(Number)] }).reduce(function(data, row) {data[row[0]] = row[1]; return data}, {}))
	var colors={"aliceblue":[240,248,255],"antiquewhite":[250,235,215],"aqua":[0,255,255],"aquamarine":[127,255,212],"azure":[240,255,255],"beige":[245,245,220],"bisque":[255,228,196],"black":[0,0,0],"blanchedalmond":[255,235,205],"blue":[0,0,255],"blueviolet":[138,43,226],"brown":[165,42,42],"burlywood":[222,184,135],"cadetblue":[95,158,160],"chartreuse":[127,255,0],"chocolate":[210,105,30],"coral":[255,127,80],"cornflowerblue":[100,149,237],"cornsilk":[255,248,220],"crimson":[220,20,60],"cyan":[0,255,255],"darkblue":[0,0,139],"darkcyan":[0,139,139],"darkgoldenrod":[184,134,11],"darkgray":[169,169,169],"darkgreen":[0,100,0],"darkgrey":[169,169,169],"darkkhaki":[189,183,107],"darkmagenta":[139,0,139],"darkolivegreen":[85,107,47],"darkorange":[255,140,0],"darkorchid":[153,50,204],"darkred":[139,0,0],"darksalmon":[233,150,122],"darkseagreen":[143,188,143],"darkslateblue":[72,61,139],"darkslategray":[47,79,79],"darkslategrey":[47,79,79],"darkturquoise":[0,206,209],"darkviolet":[148,0,211],"deeppink":[255,20,147],"deepskyblue":[0,191,255],"dimgray":[105,105,105],"dimgrey":[105,105,105],"dodgerblue":[30,144,255],"firebrick":[178,34,34],"floralwhite":[255,250,240],"forestgreen":[34,139,34],"fuchsia":[255,0,255],"gainsboro":[220,220,220],"ghostwhite":[248,248,255],"gold":[255,215,0],"goldenrod":[218,165,32],"gray":[128,128,128],"green":[0,128,0],"greenyellow":[173,255,47],"grey":[128,128,128],"honeydew":[240,255,240],"hotpink":[255,105,180],"indianred":[205,92,92],"indigo":[75,0,130],"ivory":[255,255,240],"khaki":[240,230,140],"lavender":[230,230,250],"lavenderblush":[255,240,245],"lawngreen":[124,252,0],"lemonchiffon":[255,250,205],"lightblue":[173,216,230],"lightcoral":[240,128,128],"lightcyan":[224,255,255],"lightgoldenrodyellow":[250,250,210],"lightgray":[211,211,211],"lightgreen":[144,238,144],"lightgrey":[211,211,211],"lightpink":[255,182,193],"lightsalmon":[255,160,122],"lightseagreen":[32,178,170],"lightskyblue":[135,206,250],"lightslategray":[119,136,153],"lightslategrey":[119,136,153],"lightsteelblue":[176,196,222],"lightyellow":[255,255,224],"lime":[0,255,0],"limegreen":[50,205,50],"linen":[250,240,230],"magenta":[255,0,255],"maroon":[128,0,0],"mediumaquamarine":[102,205,170],"mediumblue":[0,0,205],"mediumorchid":[186,85,211],"mediumpurple":[147,112,219],"mediumseagreen":[60,179,113],"mediumslateblue":[123,104,238],"mediumspringgreen":[0,250,154],"mediumturquoise":[72,209,204],"mediumvioletred":[199,21,133],"midnightblue":[25,25,112],"mintcream":[245,255,250],"mistyrose":[255,228,225],"moccasin":[255,228,181],"navajowhite":[255,222,173],"navy":[0,0,128],"oldlace":[253,245,230],"olive":[128,128,0],"olivedrab":[107,142,35],"orange":[255,165,0],"orangered":[255,69,0],"orchid":[218,112,214],"palegoldenrod":[238,232,170],"palegreen":[152,251,152],"paleturquoise":[175,238,238],"palevioletred":[219,112,147],"papayawhip":[255,239,213],"peachpuff":[255,218,185],"peru":[205,133,63],"pink":[255,192,203],"plum":[221,160,221],"powderblue":[176,224,230],"purple":[128,0,128],"rebeccapurple":[102,51,153],"red":[255,0,0],"rosybrown":[188,143,143],"royalblue":[65,105,225],"saddlebrown":[139,69,19],"salmon":[250,128,114],"sandybrown":[244,164,96],"seagreen":[46,139,87],"seashell":[255,245,238],"sienna":[160,82,45],"silver":[192,192,192],"skyblue":[135,206,235],"slateblue":[106,90,205],"slategray":[112,128,144],"slategrey":[112,128,144],"snow":[255,250,250],"springgreen":[0,255,127],"steelblue":[70,130,180],"tan":[210,180,140],"teal":[0,128,128],"thistle":[216,191,216],"tomato":[255,99,71],"turquoise":[64,224,208],"violet":[238,130,238],"wheat":[245,222,179],"white":[255,255,255],"whitesmoke":[245,245,245],"yellow":[255,255,0],"yellowgreen":[154,205,50]};module.exports = Color;},{}],4:[function(_dereq_,module,exports){var Support=_dereq_('./support');var CanvasRenderer=_dereq_('./renderers/canvas');var ImageLoader=_dereq_('./imageloader');var NodeParser=_dereq_('./nodeparser');var NodeContainer=_dereq_('./nodecontainer');var log=_dereq_('./log');var utils=_dereq_('./utils');var createWindowClone=_dereq_('./clone');var loadUrlDocument=_dereq_('./proxy').loadUrlDocument;var getBounds=utils.getBounds;var html2canvasNodeAttribute="data-html2canvas-node";var html2canvasCloneIndex=0;function html2canvas(nodeList,options){var index=html2canvasCloneIndex++;options = options || {};if(options.logging){log.options.logging = true;log.options.start = Date.now();}options.async = typeof options.async === "undefined"?true:options.async;options.allowTaint = typeof options.allowTaint === "undefined"?false:options.allowTaint;options.removeContainer = typeof options.removeContainer === "undefined"?true:options.removeContainer;options.javascriptEnabled = typeof options.javascriptEnabled === "undefined"?false:options.javascriptEnabled;options.imageTimeout = typeof options.imageTimeout === "undefined"?10000:options.imageTimeout;options.renderer = typeof options.renderer === "function"?options.renderer:CanvasRenderer;options.strict = !!options.strict;if(typeof nodeList === "string"){if(typeof options.proxy !== "string"){return Promise.reject("Proxy must be used when rendering url");}var width=options.width != null?options.width:window.innerWidth;var height=options.height != null?options.height:window.innerHeight;return loadUrlDocument(absoluteUrl(nodeList),options.proxy,document,width,height,options).then(function(container){return renderWindow(container.contentWindow.document.documentElement,container,options,width,height);});}var node=(nodeList === undefined?[document.documentElement]:nodeList.length?nodeList:[nodeList])[0];node.setAttribute(html2canvasNodeAttribute + index,index);return renderDocument(node.ownerDocument,options,node.ownerDocument.defaultView.innerWidth,node.ownerDocument.defaultView.innerHeight,index).then(function(canvas){if(typeof options.onrendered === "function"){log("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas");options.onrendered(canvas);}return canvas;});}html2canvas.CanvasRenderer = CanvasRenderer;html2canvas.NodeContainer = NodeContainer;html2canvas.log = log;html2canvas.utils = utils;var html2canvasExport=typeof document === "undefined" || typeof Object.create !== "function" || typeof document.createElement("canvas").getContext !== "function"?function(){return Promise.reject("No canvas support");}:html2canvas;module.exports = html2canvasExport;function renderDocument(document,options,windowWidth,windowHeight,html2canvasIndex){return createWindowClone(document,document,windowWidth,windowHeight,options,document.defaultView.pageXOffset,document.defaultView.pageYOffset).then(function(container){log("Document cloned");var attributeName=html2canvasNodeAttribute + html2canvasIndex;var selector="[" + attributeName + "='" + html2canvasIndex + "']";document.querySelector(selector).removeAttribute(attributeName);var clonedWindow=container.contentWindow;var node=clonedWindow.document.querySelector(selector);var oncloneHandler=typeof options.onclone === "function"?Promise.resolve(options.onclone(clonedWindow.document)):Promise.resolve(true);return oncloneHandler.then(function(){return renderWindow(node,container,options,windowWidth,windowHeight);});});}function renderWindow(node,container,options,windowWidth,windowHeight){var clonedWindow=container.contentWindow;var support=new Support(clonedWindow.document);var imageLoader=new ImageLoader(options,support);var bounds=getBounds(node);var width=options.type === "view"?windowWidth:documentWidth(clonedWindow.document);var height=options.type === "view"?windowHeight:documentHeight(clonedWindow.document);var renderer=new options.renderer(width,height,imageLoader,options,document);var parser=new NodeParser(node,renderer,support,imageLoader,options);return parser.ready.then(function(){log("Finished rendering");var canvas;if(options.type === "view"){canvas = crop(renderer.canvas,{width:renderer.canvas.width,height:renderer.canvas.height,top:0,left:0,x:0,y:0});}else if(node === clonedWindow.document.body || node === clonedWindow.document.documentElement || options.canvas != null){canvas = renderer.canvas;}else {canvas = crop(renderer.canvas,{width:options.width != null?options.width:bounds.width,height:options.height != null?options.height:bounds.height,top:bounds.top,left:bounds.left,x:0,y:0});}cleanupContainer(container,options);return canvas;});}function cleanupContainer(container,options){if(options.removeContainer){container.parentNode.removeChild(container);log("Cleaned up container");}}function crop(canvas,bounds){var croppedCanvas=document.createElement("canvas");var x1=Math.min(canvas.width - 1,Math.max(0,bounds.left));var x2=Math.min(canvas.width,Math.max(1,bounds.left + bounds.width));var y1=Math.min(canvas.height - 1,Math.max(0,bounds.top));var y2=Math.min(canvas.height,Math.max(1,bounds.top + bounds.height));croppedCanvas.width = bounds.width;croppedCanvas.height = bounds.height;var width=x2 - x1;var height=y2 - y1;log("Cropping canvas at:","left:",bounds.left,"top:",bounds.top,"width:",width,"height:",height);log("Resulting crop with width",bounds.width,"and height",bounds.height,"with x",x1,"and y",y1);croppedCanvas.getContext("2d").drawImage(canvas,x1,y1,width,height,bounds.x,bounds.y,width,height);return croppedCanvas;}function documentWidth(doc){return Math.max(Math.max(doc.body.scrollWidth,doc.documentElement.scrollWidth),Math.max(doc.body.offsetWidth,doc.documentElement.offsetWidth),Math.max(doc.body.clientWidth,doc.documentElement.clientWidth));}function documentHeight(doc){return Math.max(Math.max(doc.body.scrollHeight,doc.documentElement.scrollHeight),Math.max(doc.body.offsetHeight,doc.documentElement.offsetHeight),Math.max(doc.body.clientHeight,doc.documentElement.clientHeight));}function absoluteUrl(url){var link=document.createElement("a");link.href = url;link.href = link.href;return link;}},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(_dereq_,module,exports){var log=_dereq_('./log');var smallImage=_dereq_('./utils').smallImage;function DummyImageContainer(src){this.src = src;log("DummyImageContainer for",src);if(!this.promise || !this.image){log("Initiating DummyImageContainer");DummyImageContainer.prototype.image = new Image();var image=this.image;DummyImageContainer.prototype.promise = new Promise(function(resolve,reject){image.onload = resolve;image.onerror = reject;image.src = smallImage();if(image.complete === true){resolve(image);}});}}module.exports = DummyImageContainer;},{"./log":13,"./utils":26}],6:[function(_dereq_,module,exports){var smallImage=_dereq_('./utils').smallImage;function Font(family,size){var container=document.createElement('div'),img=document.createElement('img'),span=document.createElement('span'),sampleText='Hidden Text',baseline,middle;container.style.visibility = "hidden";container.style.fontFamily = family;container.style.fontSize = size;container.style.margin = 0;container.style.padding = 0;document.body.appendChild(container);img.src = smallImage();img.width = 1;img.height = 1;img.style.margin = 0;img.style.padding = 0;img.style.verticalAlign = "baseline";span.style.fontFamily = family;span.style.fontSize = size;span.style.margin = 0;span.style.padding = 0;span.appendChild(document.createTextNode(sampleText));container.appendChild(span);container.appendChild(img);baseline = img.offsetTop - span.offsetTop + 1;container.removeChild(span);container.appendChild(document.createTextNode(sampleText));container.style.lineHeight = "normal";img.style.verticalAlign = "super";middle = img.offsetTop - container.offsetTop + 1;document.body.removeChild(container);this.baseline = baseline;this.lineWidth = 1;this.middle = middle;}module.exports = Font;},{"./utils":26}],7:[function(_dereq_,module,exports){var Font=_dereq_('./font');function FontMetrics(){this.data = {};}FontMetrics.prototype.getMetrics = function(family,size){if(this.data[family + "-" + size] === undefined){this.data[family + "-" + size] = new Font(family,size);}return this.data[family + "-" + size];};module.exports = FontMetrics;},{"./font":6}],8:[function(_dereq_,module,exports){var utils=_dereq_('./utils');var getBounds=utils.getBounds;var loadUrlDocument=_dereq_('./proxy').loadUrlDocument;function FrameContainer(container,sameOrigin,options){this.image = null;this.src = container;var self=this;var bounds=getBounds(container);this.promise = (!sameOrigin?this.proxyLoad(options.proxy,bounds,options):new Promise(function(resolve){if(container.contentWindow.document.URL === "about:blank" || container.contentWindow.document.documentElement == null){container.contentWindow.onload = container.onload = function(){resolve(container);};}else {resolve(container);}})).then(function(container){var html2canvas=_dereq_('./core');return html2canvas(container.contentWindow.document.documentElement,{type:'view',width:container.width,height:container.height,proxy:options.proxy,javascriptEnabled:options.javascriptEnabled,removeContainer:options.removeContainer,allowTaint:options.allowTaint,imageTimeout:options.imageTimeout / 2});}).then(function(canvas){return self.image = canvas;});}FrameContainer.prototype.proxyLoad = function(proxy,bounds,options){var container=this.src;return loadUrlDocument(container.src,proxy,container.ownerDocument,bounds.width,bounds.height,options);};module.exports = FrameContainer;},{"./core":4,"./proxy":16,"./utils":26}],9:[function(_dereq_,module,exports){function GradientContainer(imageData){this.src = imageData.value;this.colorStops = [];this.type = null;this.x0 = 0.5;this.y0 = 0.5;this.x1 = 0.5;this.y1 = 0.5;this.promise = Promise.resolve(true);}GradientContainer.TYPES = {LINEAR:1,RADIAL:2}; // TODO: support hsl[a], negative %/length values
	// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
	GradientContainer.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i;module.exports = GradientContainer;},{}],10:[function(_dereq_,module,exports){function ImageContainer(src,cors){this.src = src;this.image = new Image();var self=this;this.tainted = null;this.promise = new Promise(function(resolve,reject){self.image.onload = resolve;self.image.onerror = reject;if(cors){self.image.crossOrigin = "anonymous";}self.image.src = src;if(self.image.complete === true){resolve(self.image);}});}module.exports = ImageContainer;},{}],11:[function(_dereq_,module,exports){var log=_dereq_('./log');var ImageContainer=_dereq_('./imagecontainer');var DummyImageContainer=_dereq_('./dummyimagecontainer');var ProxyImageContainer=_dereq_('./proxyimagecontainer');var FrameContainer=_dereq_('./framecontainer');var SVGContainer=_dereq_('./svgcontainer');var SVGNodeContainer=_dereq_('./svgnodecontainer');var LinearGradientContainer=_dereq_('./lineargradientcontainer');var WebkitGradientContainer=_dereq_('./webkitgradientcontainer');var bind=_dereq_('./utils').bind;function ImageLoader(options,support){this.link = null;this.options = options;this.support = support;this.origin = this.getOrigin(window.location.href);}ImageLoader.prototype.findImages = function(nodes){var images=[];nodes.reduce(function(imageNodes,container){switch(container.node.nodeName){case "IMG":return imageNodes.concat([{args:[container.node.src],method:"url"}]);case "svg":case "IFRAME":return imageNodes.concat([{args:[container.node],method:container.node.nodeName}]);}return imageNodes;},[]).forEach(this.addImage(images,this.loadImage),this);return images;};ImageLoader.prototype.findBackgroundImage = function(images,container){container.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(images,this.loadImage),this);return images;};ImageLoader.prototype.addImage = function(images,callback){return function(newImage){newImage.args.forEach(function(image){if(!this.imageExists(images,image)){images.splice(0,0,callback.call(this,newImage));log('Added image #' + images.length,typeof image === "string"?image.substring(0,100):image);}},this);};};ImageLoader.prototype.hasImageBackground = function(imageData){return imageData.method !== "none";};ImageLoader.prototype.loadImage = function(imageData){if(imageData.method === "url"){var src=imageData.args[0];if(this.isSVG(src) && !this.support.svg && !this.options.allowTaint){return new SVGContainer(src);}else if(src.match(/data:image\/.*;base64,/i)){return new ImageContainer(src.replace(/url\(['"]{0,}|['"]{0,}\)$/ig,''),false);}else if(this.isSameOrigin(src) || this.options.allowTaint === true || this.isSVG(src)){return new ImageContainer(src,false);}else if(this.support.cors && !this.options.allowTaint && this.options.useCORS){return new ImageContainer(src,true);}else if(this.options.proxy){return new ProxyImageContainer(src,this.options.proxy);}else {return new DummyImageContainer(src);}}else if(imageData.method === "linear-gradient"){return new LinearGradientContainer(imageData);}else if(imageData.method === "gradient"){return new WebkitGradientContainer(imageData);}else if(imageData.method === "svg"){return new SVGNodeContainer(imageData.args[0],this.support.svg);}else if(imageData.method === "IFRAME"){return new FrameContainer(imageData.args[0],this.isSameOrigin(imageData.args[0].src),this.options);}else {return new DummyImageContainer(imageData);}};ImageLoader.prototype.isSVG = function(src){return src.substring(src.length - 3).toLowerCase() === "svg" || SVGContainer.prototype.isInline(src);};ImageLoader.prototype.imageExists = function(images,src){return images.some(function(image){return image.src === src;});};ImageLoader.prototype.isSameOrigin = function(url){return this.getOrigin(url) === this.origin;};ImageLoader.prototype.getOrigin = function(url){var link=this.link || (this.link = document.createElement("a"));link.href = url;link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	return link.protocol + link.hostname + link.port;};ImageLoader.prototype.getPromise = function(container){return this.timeout(container,this.options.imageTimeout)['catch'](function(){var dummy=new DummyImageContainer(container.src);return dummy.promise.then(function(image){container.image = image;});});};ImageLoader.prototype.get = function(src){var found=null;return this.images.some(function(img){return (found = img).src === src;})?found:null;};ImageLoader.prototype.fetch = function(nodes){this.images = nodes.reduce(bind(this.findBackgroundImage,this),this.findImages(nodes));this.images.forEach(function(image,index){image.promise.then(function(){log("Succesfully loaded image #" + (index + 1),image);},function(e){log("Failed loading image #" + (index + 1),image,e);});});this.ready = Promise.all(this.images.map(this.getPromise,this));log("Finished searching images");return this;};ImageLoader.prototype.timeout = function(container,timeout){var timer;var promise=Promise.race([container.promise,new Promise(function(res,reject){timer = setTimeout(function(){log("Timed out loading image",container);reject(container);},timeout);})]).then(function(container){clearTimeout(timer);return container;});promise['catch'](function(){clearTimeout(timer);});return promise;};module.exports = ImageLoader;},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(_dereq_,module,exports){var GradientContainer=_dereq_('./gradientcontainer');var Color=_dereq_('./color');function LinearGradientContainer(imageData){GradientContainer.apply(this,arguments);this.type = GradientContainer.TYPES.LINEAR;var hasDirection=LinearGradientContainer.REGEXP_DIRECTION.test(imageData.args[0]) || !GradientContainer.REGEXP_COLORSTOP.test(imageData.args[0]);if(hasDirection){imageData.args[0].split(/\s+/).reverse().forEach(function(position,index){switch(position){case "left":this.x0 = 0;this.x1 = 1;break;case "top":this.y0 = 0;this.y1 = 1;break;case "right":this.x0 = 1;this.x1 = 0;break;case "bottom":this.y0 = 1;this.y1 = 0;break;case "to":var y0=this.y0;var x0=this.x0;this.y0 = this.y1;this.x0 = this.x1;this.x1 = x0;this.y1 = y0;break;case "center":break; // centered by default
	// Firefox internally converts position keywords to percentages:
	// http://www.w3.org/TR/2010/WD-CSS2-20101207/colors.html#propdef-background-position
	default: // percentage or absolute length
	// TODO: support absolute start point positions (e.g., use bounds to convert px to a ratio)
	var ratio=parseFloat(position,10) * 1e-2;if(isNaN(ratio)){ // invalid or unhandled value
	break;}if(index === 0){this.y0 = ratio;this.y1 = 1 - this.y0;}else {this.x0 = ratio;this.x1 = 1 - this.x0;}break;}},this);}else {this.y0 = 0;this.y1 = 1;}this.colorStops = imageData.args.slice(hasDirection?1:0).map(function(colorStop){var colorStopMatch=colorStop.match(GradientContainer.REGEXP_COLORSTOP);var value=+colorStopMatch[2];var unit=value === 0?"%":colorStopMatch[3]; // treat "0" as "0%"
	return {color:new Color(colorStopMatch[1]), // TODO: support absolute stop positions (e.g., compute gradient line length & convert px to ratio)
	stop:unit === "%"?value / 100:null};});if(this.colorStops[0].stop === null){this.colorStops[0].stop = 0;}if(this.colorStops[this.colorStops.length - 1].stop === null){this.colorStops[this.colorStops.length - 1].stop = 1;} // calculates and fills-in explicit stop positions when omitted from rule
	this.colorStops.forEach(function(colorStop,index){if(colorStop.stop === null){this.colorStops.slice(index).some(function(find,count){if(find.stop !== null){colorStop.stop = (find.stop - this.colorStops[index - 1].stop) / (count + 1) + this.colorStops[index - 1].stop;return true;}else {return false;}},this);}},this);}LinearGradientContainer.prototype = Object.create(GradientContainer.prototype); // TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
	LinearGradientContainer.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i;module.exports = LinearGradientContainer;},{"./color":3,"./gradientcontainer":9}],13:[function(_dereq_,module,exports){var logger=function logger(){if(logger.options.logging && window.console && window.console.log){Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now() - logger.options.start + "ms","html2canvas:"].concat([].slice.call(arguments,0)));}};logger.options = {logging:false};module.exports = logger;},{}],14:[function(_dereq_,module,exports){var Color=_dereq_('./color');var utils=_dereq_('./utils');var getBounds=utils.getBounds;var parseBackgrounds=utils.parseBackgrounds;var offsetBounds=utils.offsetBounds;function NodeContainer(node,parent){this.node = node;this.parent = parent;this.stack = null;this.bounds = null;this.borders = null;this.clip = [];this.backgroundClip = [];this.offsetBounds = null;this.visible = null;this.computedStyles = null;this.colors = {};this.styles = {};this.backgroundImages = null;this.transformData = null;this.transformMatrix = null;this.isPseudoElement = false;this.opacity = null;}NodeContainer.prototype.cloneTo = function(stack){stack.visible = this.visible;stack.borders = this.borders;stack.bounds = this.bounds;stack.clip = this.clip;stack.backgroundClip = this.backgroundClip;stack.computedStyles = this.computedStyles;stack.styles = this.styles;stack.backgroundImages = this.backgroundImages;stack.opacity = this.opacity;};NodeContainer.prototype.getOpacity = function(){return this.opacity === null?this.opacity = this.cssFloat('opacity'):this.opacity;};NodeContainer.prototype.assignStack = function(stack){this.stack = stack;stack.children.push(this);};NodeContainer.prototype.isElementVisible = function(){return this.node.nodeType === Node.TEXT_NODE?this.parent.visible:this.css('display') !== "none" && this.css('visibility') !== "hidden" && !this.node.hasAttribute("data-html2canvas-ignore") && (this.node.nodeName !== "INPUT" || this.node.getAttribute("type") !== "hidden");};NodeContainer.prototype.css = function(attribute){if(!this.computedStyles){this.computedStyles = this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null);}return this.styles[attribute] || (this.styles[attribute] = this.computedStyles[attribute]);};NodeContainer.prototype.prefixedCss = function(attribute){var prefixes=["webkit","moz","ms","o"];var value=this.css(attribute);if(value === undefined){prefixes.some(function(prefix){value = this.css(prefix + attribute.substr(0,1).toUpperCase() + attribute.substr(1));return value !== undefined;},this);}return value === undefined?null:value;};NodeContainer.prototype.computedStyle = function(type){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,type);};NodeContainer.prototype.cssInt = function(attribute){var value=parseInt(this.css(attribute),10);return isNaN(value)?0:value; // borders in old IE are throwing 'medium' for demo.html
	};NodeContainer.prototype.color = function(attribute){return this.colors[attribute] || (this.colors[attribute] = new Color(this.css(attribute)));};NodeContainer.prototype.cssFloat = function(attribute){var value=parseFloat(this.css(attribute));return isNaN(value)?0:value;};NodeContainer.prototype.fontWeight = function(){var weight=this.css("fontWeight");switch(parseInt(weight,10)){case 401:weight = "bold";break;case 400:weight = "normal";break;}return weight;};NodeContainer.prototype.parseClip = function(){var matches=this.css('clip').match(this.CLIP);if(matches){return {top:parseInt(matches[1],10),right:parseInt(matches[2],10),bottom:parseInt(matches[3],10),left:parseInt(matches[4],10)};}return null;};NodeContainer.prototype.parseBackgroundImages = function(){return this.backgroundImages || (this.backgroundImages = parseBackgrounds(this.css("backgroundImage")));};NodeContainer.prototype.cssList = function(property,index){var value=(this.css(property) || '').split(',');value = value[index || 0] || value[0] || 'auto';value = value.trim().split(' ');if(value.length === 1){value = [value[0],isPercentage(value[0])?'auto':value[0]];}return value;};NodeContainer.prototype.parseBackgroundSize = function(bounds,image,index){var size=this.cssList("backgroundSize",index);var width,height;if(isPercentage(size[0])){width = bounds.width * parseFloat(size[0]) / 100;}else if(/contain|cover/.test(size[0])){var targetRatio=bounds.width / bounds.height,currentRatio=image.width / image.height;return targetRatio < currentRatio ^ size[0] === 'contain'?{width:bounds.height * currentRatio,height:bounds.height}:{width:bounds.width,height:bounds.width / currentRatio};}else {width = parseInt(size[0],10);}if(size[0] === 'auto' && size[1] === 'auto'){height = image.height;}else if(size[1] === 'auto'){height = width / image.width * image.height;}else if(isPercentage(size[1])){height = bounds.height * parseFloat(size[1]) / 100;}else {height = parseInt(size[1],10);}if(size[0] === 'auto'){width = height / image.height * image.width;}return {width:width,height:height};};NodeContainer.prototype.parseBackgroundPosition = function(bounds,image,index,backgroundSize){var position=this.cssList('backgroundPosition',index);var left,top;if(isPercentage(position[0])){left = (bounds.width - (backgroundSize || image).width) * (parseFloat(position[0]) / 100);}else {left = parseInt(position[0],10);}if(position[1] === 'auto'){top = left / image.width * image.height;}else if(isPercentage(position[1])){top = (bounds.height - (backgroundSize || image).height) * parseFloat(position[1]) / 100;}else {top = parseInt(position[1],10);}if(position[0] === 'auto'){left = top / image.height * image.width;}return {left:left,top:top};};NodeContainer.prototype.parseBackgroundRepeat = function(index){return this.cssList("backgroundRepeat",index)[0];};NodeContainer.prototype.parseTextShadows = function(){var textShadow=this.css("textShadow");var results=[];if(textShadow && textShadow !== 'none'){var shadows=textShadow.match(this.TEXT_SHADOW_PROPERTY);for(var i=0;shadows && i < shadows.length;i++) {var s=shadows[i].match(this.TEXT_SHADOW_VALUES);results.push({color:new Color(s[0]),offsetX:s[1]?parseFloat(s[1].replace('px','')):0,offsetY:s[2]?parseFloat(s[2].replace('px','')):0,blur:s[3]?s[3].replace('px',''):0});}}return results;};NodeContainer.prototype.parseTransform = function(){if(!this.transformData){if(this.hasTransform()){var offset=this.parseBounds();var origin=this.prefixedCss("transformOrigin").split(" ").map(removePx).map(asFloat);origin[0] += offset.left;origin[1] += offset.top;this.transformData = {origin:origin,matrix:this.parseTransformMatrix()};}else {this.transformData = {origin:[0,0],matrix:[1,0,0,1,0,0]};}}return this.transformData;};NodeContainer.prototype.parseTransformMatrix = function(){if(!this.transformMatrix){var transform=this.prefixedCss("transform");var matrix=transform?parseMatrix(transform.match(this.MATRIX_PROPERTY)):null;this.transformMatrix = matrix?matrix:[1,0,0,1,0,0];}return this.transformMatrix;};NodeContainer.prototype.parseBounds = function(){return this.bounds || (this.bounds = this.hasTransform()?offsetBounds(this.node):getBounds(this.node));};NodeContainer.prototype.hasTransform = function(){return this.parseTransformMatrix().join(",") !== "1,0,0,1,0,0" || this.parent && this.parent.hasTransform();};NodeContainer.prototype.getValue = function(){var value=this.node.value || "";if(this.node.tagName === "SELECT"){value = selectionValue(this.node);}else if(this.node.type === "password"){value = Array(value.length + 1).join('•'); // jshint ignore:line
	}return value.length === 0?this.node.placeholder || "":value;};NodeContainer.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/;NodeContainer.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g;NodeContainer.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g;NodeContainer.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/;function selectionValue(node){var option=node.options[node.selectedIndex || 0];return option?option.text || "":"";}function parseMatrix(match){if(match && match[1] === "matrix"){return match[2].split(",").map(function(s){return parseFloat(s.trim());});}else if(match && match[1] === "matrix3d"){var matrix3d=match[2].split(",").map(function(s){return parseFloat(s.trim());});return [matrix3d[0],matrix3d[1],matrix3d[4],matrix3d[5],matrix3d[12],matrix3d[13]];}}function isPercentage(value){return value.toString().indexOf("%") !== -1;}function removePx(str){return str.replace("px","");}function asFloat(str){return parseFloat(str);}module.exports = NodeContainer;},{"./color":3,"./utils":26}],15:[function(_dereq_,module,exports){var log=_dereq_('./log');var punycode=_dereq_('punycode');var NodeContainer=_dereq_('./nodecontainer');var TextContainer=_dereq_('./textcontainer');var PseudoElementContainer=_dereq_('./pseudoelementcontainer');var FontMetrics=_dereq_('./fontmetrics');var Color=_dereq_('./color');var StackingContext=_dereq_('./stackingcontext');var utils=_dereq_('./utils');var bind=utils.bind;var getBounds=utils.getBounds;var parseBackgrounds=utils.parseBackgrounds;var offsetBounds=utils.offsetBounds;function NodeParser(element,renderer,support,imageLoader,options){log("Starting NodeParser");this.renderer = renderer;this.options = options;this.range = null;this.support = support;this.renderQueue = [];this.stack = new StackingContext(true,1,element.ownerDocument,null);var parent=new NodeContainer(element,null);if(options.background){renderer.rectangle(0,0,renderer.width,renderer.height,new Color(options.background));}if(element === element.ownerDocument.documentElement){ // http://www.w3.org/TR/css3-background/#special-backgrounds
	var canvasBackground=new NodeContainer(parent.color('backgroundColor').isTransparent()?element.ownerDocument.body:element.ownerDocument.documentElement,null);renderer.rectangle(0,0,renderer.width,renderer.height,canvasBackground.color('backgroundColor'));}parent.visibile = parent.isElementVisible();this.createPseudoHideStyles(element.ownerDocument);this.disableAnimations(element.ownerDocument);this.nodes = flatten([parent].concat(this.getChildren(parent)).filter(function(container){return container.visible = container.isElementVisible();}).map(this.getPseudoElements,this));this.fontMetrics = new FontMetrics();log("Fetched nodes, total:",this.nodes.length);log("Calculate overflow clips");this.calculateOverflowClips();log("Start fetching images");this.images = imageLoader.fetch(this.nodes.filter(isElement));this.ready = this.images.ready.then(bind(function(){log("Images loaded, starting parsing");log("Creating stacking contexts");this.createStackingContexts();log("Sorting stacking contexts");this.sortStackingContexts(this.stack);this.parse(this.stack);log("Render queue created with " + this.renderQueue.length + " items");return new Promise(bind(function(resolve){if(!options.async){this.renderQueue.forEach(this.paint,this);resolve();}else if(typeof options.async === "function"){options.async.call(this,this.renderQueue,resolve);}else if(this.renderQueue.length > 0){this.renderIndex = 0;this.asyncRenderer(this.renderQueue,resolve);}else {resolve();}},this));},this));}NodeParser.prototype.calculateOverflowClips = function(){this.nodes.forEach(function(container){if(isElement(container)){if(isPseudoElement(container)){container.appendToDOM();}container.borders = this.parseBorders(container);var clip=container.css('overflow') === "hidden"?[container.borders.clip]:[];var cssClip=container.parseClip();if(cssClip && ["absolute","fixed"].indexOf(container.css('position')) !== -1){clip.push([["rect",container.bounds.left + cssClip.left,container.bounds.top + cssClip.top,cssClip.right - cssClip.left,cssClip.bottom - cssClip.top]]);}container.clip = hasParentClip(container)?container.parent.clip.concat(clip):clip;container.backgroundClip = container.css('overflow') !== "hidden"?container.clip.concat([container.borders.clip]):container.clip;if(isPseudoElement(container)){container.cleanDOM();}}else if(isTextNode(container)){container.clip = hasParentClip(container)?container.parent.clip:[];}if(!isPseudoElement(container)){container.bounds = null;}},this);};function hasParentClip(container){return container.parent && container.parent.clip.length;}NodeParser.prototype.asyncRenderer = function(queue,resolve,asyncTimer){asyncTimer = asyncTimer || Date.now();this.paint(queue[this.renderIndex++]);if(queue.length === this.renderIndex){resolve();}else if(asyncTimer + 20 > Date.now()){this.asyncRenderer(queue,resolve,asyncTimer);}else {setTimeout(bind(function(){this.asyncRenderer(queue,resolve);},this),0);}};NodeParser.prototype.createPseudoHideStyles = function(document){this.createStyles(document,'.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }' + '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');};NodeParser.prototype.disableAnimations = function(document){this.createStyles(document,'* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; ' + '-webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}');};NodeParser.prototype.createStyles = function(document,styles){var hidePseudoElements=document.createElement('style');hidePseudoElements.innerHTML = styles;document.body.appendChild(hidePseudoElements);};NodeParser.prototype.getPseudoElements = function(container){var nodes=[[container]];if(container.node.nodeType === Node.ELEMENT_NODE){var before=this.getPseudoElement(container,":before");var after=this.getPseudoElement(container,":after");if(before){nodes.push(before);}if(after){nodes.push(after);}}return flatten(nodes);};function toCamelCase(str){return str.replace(/(\-[a-z])/g,function(match){return match.toUpperCase().replace('-','');});}NodeParser.prototype.getPseudoElement = function(container,type){var style=container.computedStyle(type);if(!style || !style.content || style.content === "none" || style.content === "-moz-alt-content" || style.display === "none"){return null;}var content=stripQuotes(style.content);var isImage=content.substr(0,3) === 'url';var pseudoNode=document.createElement(isImage?'img':'html2canvaspseudoelement');var pseudoContainer=new PseudoElementContainer(pseudoNode,container,type);for(var i=style.length - 1;i >= 0;i--) {var property=toCamelCase(style.item(i));pseudoNode.style[property] = style[property];}pseudoNode.className = PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER;if(isImage){pseudoNode.src = parseBackgrounds(content)[0].args[0];return [pseudoContainer];}else {var text=document.createTextNode(content);pseudoNode.appendChild(text);return [pseudoContainer,new TextContainer(text,pseudoContainer)];}};NodeParser.prototype.getChildren = function(parentContainer){return flatten([].filter.call(parentContainer.node.childNodes,renderableNode).map(function(node){var container=[node.nodeType === Node.TEXT_NODE?new TextContainer(node,parentContainer):new NodeContainer(node,parentContainer)].filter(nonIgnoredElement);return node.nodeType === Node.ELEMENT_NODE && container.length && node.tagName !== "TEXTAREA"?container[0].isElementVisible()?container.concat(this.getChildren(container[0])):[]:container;},this));};NodeParser.prototype.newStackingContext = function(container,hasOwnStacking){var stack=new StackingContext(hasOwnStacking,container.getOpacity(),container.node,container.parent);container.cloneTo(stack);var parentStack=hasOwnStacking?stack.getParentStack(this):stack.parent.stack;parentStack.contexts.push(stack);container.stack = stack;};NodeParser.prototype.createStackingContexts = function(){this.nodes.forEach(function(container){if(isElement(container) && (this.isRootElement(container) || hasOpacity(container) || isPositionedForStacking(container) || this.isBodyWithTransparentRoot(container) || container.hasTransform())){this.newStackingContext(container,true);}else if(isElement(container) && (isPositioned(container) && zIndex0(container) || isInlineBlock(container) || isFloating(container))){this.newStackingContext(container,false);}else {container.assignStack(container.parent.stack);}},this);};NodeParser.prototype.isBodyWithTransparentRoot = function(container){return container.node.nodeName === "BODY" && container.parent.color('backgroundColor').isTransparent();};NodeParser.prototype.isRootElement = function(container){return container.parent === null;};NodeParser.prototype.sortStackingContexts = function(stack){stack.contexts.sort(zIndexSort(stack.contexts.slice(0)));stack.contexts.forEach(this.sortStackingContexts,this);};NodeParser.prototype.parseTextBounds = function(container){return function(text,index,textList){if(container.parent.css("textDecoration").substr(0,4) !== "none" || text.trim().length !== 0){if(this.support.rangeBounds && !container.parent.hasTransform()){var offset=textList.slice(0,index).join("").length;return this.getRangeBounds(container.node,offset,text.length);}else if(container.node && typeof container.node.data === "string"){var replacementNode=container.node.splitText(text.length);var bounds=this.getWrapperBounds(container.node,container.parent.hasTransform());container.node = replacementNode;return bounds;}}else if(!this.support.rangeBounds || container.parent.hasTransform()){container.node = container.node.splitText(text.length);}return {};};};NodeParser.prototype.getWrapperBounds = function(node,transform){var wrapper=node.ownerDocument.createElement('html2canvaswrapper');var parent=node.parentNode,backupText=node.cloneNode(true);wrapper.appendChild(node.cloneNode(true));parent.replaceChild(wrapper,node);var bounds=transform?offsetBounds(wrapper):getBounds(wrapper);parent.replaceChild(backupText,wrapper);return bounds;};NodeParser.prototype.getRangeBounds = function(node,offset,length){var range=this.range || (this.range = node.ownerDocument.createRange());range.setStart(node,offset);range.setEnd(node,offset + length);return range.getBoundingClientRect();};function ClearTransform(){}NodeParser.prototype.parse = function(stack){ // http://www.w3.org/TR/CSS21/visuren.html#z-index
	var negativeZindex=stack.contexts.filter(negativeZIndex); // 2. the child stacking contexts with negative stack levels (most negative first).
	var descendantElements=stack.children.filter(isElement);var descendantNonFloats=descendantElements.filter(not(isFloating));var nonInlineNonPositionedDescendants=descendantNonFloats.filter(not(isPositioned)).filter(not(inlineLevel)); // 3 the in-flow, non-inline-level, non-positioned descendants.
	var nonPositionedFloats=descendantElements.filter(not(isPositioned)).filter(isFloating); // 4. the non-positioned floats.
	var inFlow=descendantNonFloats.filter(not(isPositioned)).filter(inlineLevel); // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
	var stackLevel0=stack.contexts.concat(descendantNonFloats.filter(isPositioned)).filter(zIndex0); // 6. the child stacking contexts with stack level 0 and the positioned descendants with stack level 0.
	var text=stack.children.filter(isTextNode).filter(hasText);var positiveZindex=stack.contexts.filter(positiveZIndex); // 7. the child stacking contexts with positive stack levels (least positive first).
	negativeZindex.concat(nonInlineNonPositionedDescendants).concat(nonPositionedFloats).concat(inFlow).concat(stackLevel0).concat(text).concat(positiveZindex).forEach(function(container){this.renderQueue.push(container);if(isStackingContext(container)){this.parse(container);this.renderQueue.push(new ClearTransform());}},this);};NodeParser.prototype.paint = function(container){try{if(container instanceof ClearTransform){this.renderer.ctx.restore();}else if(isTextNode(container)){if(isPseudoElement(container.parent)){container.parent.appendToDOM();}this.paintText(container);if(isPseudoElement(container.parent)){container.parent.cleanDOM();}}else {this.paintNode(container);}}catch(e) {log(e);if(this.options.strict){throw e;}}};NodeParser.prototype.paintNode = function(container){if(isStackingContext(container)){this.renderer.setOpacity(container.opacity);this.renderer.ctx.save();if(container.hasTransform()){this.renderer.setTransform(container.parseTransform());}}if(container.node.nodeName === "INPUT" && container.node.type === "checkbox"){this.paintCheckbox(container);}else if(container.node.nodeName === "INPUT" && container.node.type === "radio"){this.paintRadio(container);}else {this.paintElement(container);}};NodeParser.prototype.paintElement = function(container){var bounds=container.parseBounds();this.renderer.clip(container.backgroundClip,function(){this.renderer.renderBackground(container,bounds,container.borders.borders.map(getWidth));},this);this.renderer.clip(container.clip,function(){this.renderer.renderBorders(container.borders.borders);},this);this.renderer.clip(container.backgroundClip,function(){switch(container.node.nodeName){case "svg":case "IFRAME":var imgContainer=this.images.get(container.node);if(imgContainer){this.renderer.renderImage(container,bounds,container.borders,imgContainer);}else {log("Error loading <" + container.node.nodeName + ">",container.node);}break;case "IMG":var imageContainer=this.images.get(container.node.src);if(imageContainer){this.renderer.renderImage(container,bounds,container.borders,imageContainer);}else {log("Error loading <img>",container.node.src);}break;case "CANVAS":this.renderer.renderImage(container,bounds,container.borders,{image:container.node});break;case "SELECT":case "INPUT":case "TEXTAREA":this.paintFormValue(container);break;}},this);};NodeParser.prototype.paintCheckbox = function(container){var b=container.parseBounds();var size=Math.min(b.width,b.height);var bounds={width:size - 1,height:size - 1,top:b.top,left:b.left};var r=[3,3];var radius=[r,r,r,r];var borders=[1,1,1,1].map(function(w){return {color:new Color('#A5A5A5'),width:w};});var borderPoints=calculateCurvePoints(bounds,radius,borders);this.renderer.clip(container.backgroundClip,function(){this.renderer.rectangle(bounds.left + 1,bounds.top + 1,bounds.width - 2,bounds.height - 2,new Color("#DEDEDE"));this.renderer.renderBorders(calculateBorders(borders,bounds,borderPoints,radius));if(container.node.checked){this.renderer.font(new Color('#424242'),'normal','normal','bold',size - 3 + "px",'arial');this.renderer.text('✔',bounds.left + size / 6,bounds.top + size - 1);}},this);};NodeParser.prototype.paintRadio = function(container){var bounds=container.parseBounds();var size=Math.min(bounds.width,bounds.height) - 2;this.renderer.clip(container.backgroundClip,function(){this.renderer.circleStroke(bounds.left + 1,bounds.top + 1,size,new Color('#DEDEDE'),1,new Color('#A5A5A5'));if(container.node.checked){this.renderer.circle(Math.ceil(bounds.left + size / 4) + 1,Math.ceil(bounds.top + size / 4) + 1,Math.floor(size / 2),new Color('#424242'));}},this);};NodeParser.prototype.paintFormValue = function(container){var value=container.getValue();if(value.length > 0){var document=container.node.ownerDocument;var wrapper=document.createElement('html2canvaswrapper');var properties=['lineHeight','textAlign','fontFamily','fontWeight','fontSize','color','paddingLeft','paddingTop','paddingRight','paddingBottom','width','height','borderLeftStyle','borderTopStyle','borderLeftWidth','borderTopWidth','boxSizing','whiteSpace','wordWrap'];properties.forEach(function(property){try{wrapper.style[property] = container.css(property);}catch(e) { // Older IE has issues with "border"
	log("html2canvas: Parse: Exception caught in renderFormValue: " + e.message);}});var bounds=container.parseBounds();wrapper.style.position = "fixed";wrapper.style.left = bounds.left + "px";wrapper.style.top = bounds.top + "px";wrapper.textContent = value;document.body.appendChild(wrapper);this.paintText(new TextContainer(wrapper.firstChild,container));document.body.removeChild(wrapper);}};NodeParser.prototype.paintText = function(container){container.applyTextTransform();var characters=punycode.ucs2.decode(container.node.data);var textList=(!this.options.letterRendering || noLetterSpacing(container)) && !hasUnicode(container.node.data)?getWords(characters):characters.map(function(character){return punycode.ucs2.encode([character]);});var weight=container.parent.fontWeight();var size=container.parent.css('fontSize');var family=container.parent.css('fontFamily');var shadows=container.parent.parseTextShadows();this.renderer.font(container.parent.color('color'),container.parent.css('fontStyle'),container.parent.css('fontVariant'),weight,size,family);if(shadows.length){ // TODO: support multiple text shadows
	this.renderer.fontShadow(shadows[0].color,shadows[0].offsetX,shadows[0].offsetY,shadows[0].blur);}else {this.renderer.clearShadow();}this.renderer.clip(container.parent.clip,function(){textList.map(this.parseTextBounds(container),this).forEach(function(bounds,index){if(bounds){this.renderer.text(textList[index],bounds.left,bounds.bottom);this.renderTextDecoration(container.parent,bounds,this.fontMetrics.getMetrics(family,size));}},this);},this);};NodeParser.prototype.renderTextDecoration = function(container,bounds,metrics){switch(container.css("textDecoration").split(" ")[0]){case "underline": // Draws a line at the baseline of the font
	// TODO As some browsers display the line as more than 1px if the font-size is big, need to take that into account both in position and size
	this.renderer.rectangle(bounds.left,Math.round(bounds.top + metrics.baseline + metrics.lineWidth),bounds.width,1,container.color("color"));break;case "overline":this.renderer.rectangle(bounds.left,Math.round(bounds.top),bounds.width,1,container.color("color"));break;case "line-through": // TODO try and find exact position for line-through
	this.renderer.rectangle(bounds.left,Math.ceil(bounds.top + metrics.middle + metrics.lineWidth),bounds.width,1,container.color("color"));break;}};var borderColorTransforms={inset:[["darken",0.60],["darken",0.10],["darken",0.10],["darken",0.60]]};NodeParser.prototype.parseBorders = function(container){var nodeBounds=container.parseBounds();var radius=getBorderRadiusData(container);var borders=["Top","Right","Bottom","Left"].map(function(side,index){var style=container.css('border' + side + 'Style');var color=container.color('border' + side + 'Color');if(style === "inset" && color.isBlack()){color = new Color([255,255,255,color.a]); // this is wrong, but
	}var colorTransform=borderColorTransforms[style]?borderColorTransforms[style][index]:null;return {width:container.cssInt('border' + side + 'Width'),color:colorTransform?color[colorTransform[0]](colorTransform[1]):color,args:null};});var borderPoints=calculateCurvePoints(nodeBounds,radius,borders);return {clip:this.parseBackgroundClip(container,borderPoints,borders,radius,nodeBounds),borders:calculateBorders(borders,nodeBounds,borderPoints,radius)};};function calculateBorders(borders,nodeBounds,borderPoints,radius){return borders.map(function(border,borderSide){if(border.width > 0){var bx=nodeBounds.left;var by=nodeBounds.top;var bw=nodeBounds.width;var bh=nodeBounds.height - borders[2].width;switch(borderSide){case 0: // top border
	bh = borders[0].width;border.args = drawSide({c1:[bx,by],c2:[bx + bw,by],c3:[bx + bw - borders[1].width,by + bh],c4:[bx + borders[3].width,by + bh]},radius[0],radius[1],borderPoints.topLeftOuter,borderPoints.topLeftInner,borderPoints.topRightOuter,borderPoints.topRightInner);break;case 1: // right border
	bx = nodeBounds.left + nodeBounds.width - borders[1].width;bw = borders[1].width;border.args = drawSide({c1:[bx + bw,by],c2:[bx + bw,by + bh + borders[2].width],c3:[bx,by + bh],c4:[bx,by + borders[0].width]},radius[1],radius[2],borderPoints.topRightOuter,borderPoints.topRightInner,borderPoints.bottomRightOuter,borderPoints.bottomRightInner);break;case 2: // bottom border
	by = by + nodeBounds.height - borders[2].width;bh = borders[2].width;border.args = drawSide({c1:[bx + bw,by + bh],c2:[bx,by + bh],c3:[bx + borders[3].width,by],c4:[bx + bw - borders[3].width,by]},radius[2],radius[3],borderPoints.bottomRightOuter,borderPoints.bottomRightInner,borderPoints.bottomLeftOuter,borderPoints.bottomLeftInner);break;case 3: // left border
	bw = borders[3].width;border.args = drawSide({c1:[bx,by + bh + borders[2].width],c2:[bx,by],c3:[bx + bw,by + borders[0].width],c4:[bx + bw,by + bh]},radius[3],radius[0],borderPoints.bottomLeftOuter,borderPoints.bottomLeftInner,borderPoints.topLeftOuter,borderPoints.topLeftInner);break;}}return border;});}NodeParser.prototype.parseBackgroundClip = function(container,borderPoints,borders,radius,bounds){var backgroundClip=container.css('backgroundClip'),borderArgs=[];switch(backgroundClip){case "content-box":case "padding-box":parseCorner(borderArgs,radius[0],radius[1],borderPoints.topLeftInner,borderPoints.topRightInner,bounds.left + borders[3].width,bounds.top + borders[0].width);parseCorner(borderArgs,radius[1],radius[2],borderPoints.topRightInner,borderPoints.bottomRightInner,bounds.left + bounds.width - borders[1].width,bounds.top + borders[0].width);parseCorner(borderArgs,radius[2],radius[3],borderPoints.bottomRightInner,borderPoints.bottomLeftInner,bounds.left + bounds.width - borders[1].width,bounds.top + bounds.height - borders[2].width);parseCorner(borderArgs,radius[3],radius[0],borderPoints.bottomLeftInner,borderPoints.topLeftInner,bounds.left + borders[3].width,bounds.top + bounds.height - borders[2].width);break;default:parseCorner(borderArgs,radius[0],radius[1],borderPoints.topLeftOuter,borderPoints.topRightOuter,bounds.left,bounds.top);parseCorner(borderArgs,radius[1],radius[2],borderPoints.topRightOuter,borderPoints.bottomRightOuter,bounds.left + bounds.width,bounds.top);parseCorner(borderArgs,radius[2],radius[3],borderPoints.bottomRightOuter,borderPoints.bottomLeftOuter,bounds.left + bounds.width,bounds.top + bounds.height);parseCorner(borderArgs,radius[3],radius[0],borderPoints.bottomLeftOuter,borderPoints.topLeftOuter,bounds.left,bounds.top + bounds.height);break;}return borderArgs;};function getCurvePoints(x,y,r1,r2){var kappa=4 * ((Math.sqrt(2) - 1) / 3);var ox=r1 * kappa, // control point offset horizontal
	oy=r2 * kappa, // control point offset vertical
	xm=x + r1, // x-middle
	ym=y + r2; // y-middle
	return {topLeft:bezierCurve({x:x,y:ym},{x:x,y:ym - oy},{x:xm - ox,y:y},{x:xm,y:y}),topRight:bezierCurve({x:x,y:y},{x:x + ox,y:y},{x:xm,y:ym - oy},{x:xm,y:ym}),bottomRight:bezierCurve({x:xm,y:y},{x:xm,y:y + oy},{x:x + ox,y:ym},{x:x,y:ym}),bottomLeft:bezierCurve({x:xm,y:ym},{x:xm - ox,y:ym},{x:x,y:y + oy},{x:x,y:y})};}function calculateCurvePoints(bounds,borderRadius,borders){var x=bounds.left,y=bounds.top,width=bounds.width,height=bounds.height,tlh=borderRadius[0][0] < width / 2?borderRadius[0][0]:width / 2,tlv=borderRadius[0][1] < height / 2?borderRadius[0][1]:height / 2,trh=borderRadius[1][0] < width / 2?borderRadius[1][0]:width / 2,trv=borderRadius[1][1] < height / 2?borderRadius[1][1]:height / 2,brh=borderRadius[2][0] < width / 2?borderRadius[2][0]:width / 2,brv=borderRadius[2][1] < height / 2?borderRadius[2][1]:height / 2,blh=borderRadius[3][0] < width / 2?borderRadius[3][0]:width / 2,blv=borderRadius[3][1] < height / 2?borderRadius[3][1]:height / 2;var topWidth=width - trh,rightHeight=height - brv,bottomWidth=width - brh,leftHeight=height - blv;return {topLeftOuter:getCurvePoints(x,y,tlh,tlv).topLeft.subdivide(0.5),topLeftInner:getCurvePoints(x + borders[3].width,y + borders[0].width,Math.max(0,tlh - borders[3].width),Math.max(0,tlv - borders[0].width)).topLeft.subdivide(0.5),topRightOuter:getCurvePoints(x + topWidth,y,trh,trv).topRight.subdivide(0.5),topRightInner:getCurvePoints(x + Math.min(topWidth,width + borders[3].width),y + borders[0].width,topWidth > width + borders[3].width?0:trh - borders[3].width,trv - borders[0].width).topRight.subdivide(0.5),bottomRightOuter:getCurvePoints(x + bottomWidth,y + rightHeight,brh,brv).bottomRight.subdivide(0.5),bottomRightInner:getCurvePoints(x + Math.min(bottomWidth,width - borders[3].width),y + Math.min(rightHeight,height + borders[0].width),Math.max(0,brh - borders[1].width),brv - borders[2].width).bottomRight.subdivide(0.5),bottomLeftOuter:getCurvePoints(x,y + leftHeight,blh,blv).bottomLeft.subdivide(0.5),bottomLeftInner:getCurvePoints(x + borders[3].width,y + leftHeight,Math.max(0,blh - borders[3].width),blv - borders[2].width).bottomLeft.subdivide(0.5)};}function bezierCurve(start,startControl,endControl,end){var lerp=function lerp(a,b,t){return {x:a.x + (b.x - a.x) * t,y:a.y + (b.y - a.y) * t};};return {start:start,startControl:startControl,endControl:endControl,end:end,subdivide:function subdivide(t){var ab=lerp(start,startControl,t),bc=lerp(startControl,endControl,t),cd=lerp(endControl,end,t),abbc=lerp(ab,bc,t),bccd=lerp(bc,cd,t),dest=lerp(abbc,bccd,t);return [bezierCurve(start,ab,abbc,dest),bezierCurve(dest,bccd,cd,end)];},curveTo:function curveTo(borderArgs){borderArgs.push(["bezierCurve",startControl.x,startControl.y,endControl.x,endControl.y,end.x,end.y]);},curveToReversed:function curveToReversed(borderArgs){borderArgs.push(["bezierCurve",endControl.x,endControl.y,startControl.x,startControl.y,start.x,start.y]);}};}function drawSide(borderData,radius1,radius2,outer1,inner1,outer2,inner2){var borderArgs=[];if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",outer1[1].start.x,outer1[1].start.y]);outer1[1].curveTo(borderArgs);}else {borderArgs.push(["line",borderData.c1[0],borderData.c1[1]]);}if(radius2[0] > 0 || radius2[1] > 0){borderArgs.push(["line",outer2[0].start.x,outer2[0].start.y]);outer2[0].curveTo(borderArgs);borderArgs.push(["line",inner2[0].end.x,inner2[0].end.y]);inner2[0].curveToReversed(borderArgs);}else {borderArgs.push(["line",borderData.c2[0],borderData.c2[1]]);borderArgs.push(["line",borderData.c3[0],borderData.c3[1]]);}if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",inner1[1].end.x,inner1[1].end.y]);inner1[1].curveToReversed(borderArgs);}else {borderArgs.push(["line",borderData.c4[0],borderData.c4[1]]);}return borderArgs;}function parseCorner(borderArgs,radius1,radius2,corner1,corner2,x,y){if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",corner1[0].start.x,corner1[0].start.y]);corner1[0].curveTo(borderArgs);corner1[1].curveTo(borderArgs);}else {borderArgs.push(["line",x,y]);}if(radius2[0] > 0 || radius2[1] > 0){borderArgs.push(["line",corner2[0].start.x,corner2[0].start.y]);}}function negativeZIndex(container){return container.cssInt("zIndex") < 0;}function positiveZIndex(container){return container.cssInt("zIndex") > 0;}function zIndex0(container){return container.cssInt("zIndex") === 0;}function inlineLevel(container){return ["inline","inline-block","inline-table"].indexOf(container.css("display")) !== -1;}function isStackingContext(container){return container instanceof StackingContext;}function hasText(container){return container.node.data.trim().length > 0;}function noLetterSpacing(container){return (/^(normal|none|0px)$/.test(container.parent.css("letterSpacing")));}function getBorderRadiusData(container){return ["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(side){var value=container.css('border' + side + 'Radius');var arr=value.split(" ");if(arr.length <= 1){arr[1] = arr[0];}return arr.map(asInt);});}function renderableNode(node){return node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE;}function isPositionedForStacking(container){var position=container.css("position");var zIndex=["absolute","relative","fixed"].indexOf(position) !== -1?container.css("zIndex"):"auto";return zIndex !== "auto";}function isPositioned(container){return container.css("position") !== "static";}function isFloating(container){return container.css("float") !== "none";}function isInlineBlock(container){return ["inline-block","inline-table"].indexOf(container.css("display")) !== -1;}function not(callback){var context=this;return function(){return !callback.apply(context,arguments);};}function isElement(container){return container.node.nodeType === Node.ELEMENT_NODE;}function isPseudoElement(container){return container.isPseudoElement === true;}function isTextNode(container){return container.node.nodeType === Node.TEXT_NODE;}function zIndexSort(contexts){return function(a,b){return a.cssInt("zIndex") + contexts.indexOf(a) / contexts.length - (b.cssInt("zIndex") + contexts.indexOf(b) / contexts.length);};}function hasOpacity(container){return container.getOpacity() < 1;}function asInt(value){return parseInt(value,10);}function getWidth(border){return border.width;}function nonIgnoredElement(nodeContainer){return nodeContainer.node.nodeType !== Node.ELEMENT_NODE || ["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(nodeContainer.node.nodeName) === -1;}function flatten(arrays){return [].concat.apply([],arrays);}function stripQuotes(content){var first=content.substr(0,1);return first === content.substr(content.length - 1) && first.match(/'|"/)?content.substr(1,content.length - 2):content;}function getWords(characters){var words=[],i=0,onWordBoundary=false,word;while(characters.length) {if(isWordBoundary(characters[i]) === onWordBoundary){word = characters.splice(0,i);if(word.length){words.push(punycode.ucs2.encode(word));}onWordBoundary = !onWordBoundary;i = 0;}else {i++;}if(i >= characters.length){word = characters.splice(0,i);if(word.length){words.push(punycode.ucs2.encode(word));}}}return words;}function isWordBoundary(characterCode){return [32, // <space>
	13, // \r
	10, // \n
	9, // \t
	45 // -
	].indexOf(characterCode) !== -1;}function hasUnicode(string){return (/[^\u0000-\u00ff]/.test(string));}module.exports = NodeParser;},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,"punycode":1}],16:[function(_dereq_,module,exports){var XHR=_dereq_('./xhr');var utils=_dereq_('./utils');var log=_dereq_('./log');var createWindowClone=_dereq_('./clone');var decode64=utils.decode64;function Proxy(src,proxyUrl,document){var supportsCORS=('withCredentials' in new XMLHttpRequest());if(!proxyUrl){return Promise.reject("No proxy configured");}var callback=createCallback(supportsCORS);var url=createProxyUrl(proxyUrl,src,callback);return supportsCORS?XHR(url):jsonp(document,url,callback).then(function(response){return decode64(response.content);});}var proxyCount=0;function ProxyURL(src,proxyUrl,document){var supportsCORSImage=('crossOrigin' in new Image());var callback=createCallback(supportsCORSImage);var url=createProxyUrl(proxyUrl,src,callback);return supportsCORSImage?Promise.resolve(url):jsonp(document,url,callback).then(function(response){return "data:" + response.type + ";base64," + response.content;});}function jsonp(document,url,callback){return new Promise(function(resolve,reject){var s=document.createElement("script");var cleanup=function cleanup(){delete window.html2canvas.proxy[callback];document.body.removeChild(s);};window.html2canvas.proxy[callback] = function(response){cleanup();resolve(response);};s.src = url;s.onerror = function(e){cleanup();reject(e);};document.body.appendChild(s);});}function createCallback(useCORS){return !useCORS?"html2canvas_" + Date.now() + "_" + ++proxyCount + "_" + Math.round(Math.random() * 100000):"";}function createProxyUrl(proxyUrl,src,callback){return proxyUrl + "?url=" + encodeURIComponent(src) + (callback.length?"&callback=html2canvas.proxy." + callback:"");}function documentFromHTML(src){return function(html){var parser=new DOMParser(),doc;try{doc = parser.parseFromString(html,"text/html");}catch(e) {log("DOMParser not supported, falling back to createHTMLDocument");doc = document.implementation.createHTMLDocument("");try{doc.open();doc.write(html);doc.close();}catch(ee) {log("createHTMLDocument write not supported, falling back to document.body.innerHTML");doc.body.innerHTML = html; // ie9 doesnt support writing to documentElement
	}}var b=doc.querySelector("base");if(!b || !b.href.host){var base=doc.createElement("base");base.href = src;doc.head.insertBefore(base,doc.head.firstChild);}return doc;};}function loadUrlDocument(src,proxy,document,width,height,options){return new Proxy(src,proxy,window.document).then(documentFromHTML(src)).then(function(doc){return createWindowClone(doc,document,width,height,options,0,0);});}exports.Proxy = Proxy;exports.ProxyURL = ProxyURL;exports.loadUrlDocument = loadUrlDocument;},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(_dereq_,module,exports){var ProxyURL=_dereq_('./proxy').ProxyURL;function ProxyImageContainer(src,proxy){var link=document.createElement("a");link.href = src;src = link.href;this.src = src;this.image = new Image();var self=this;this.promise = new Promise(function(resolve,reject){self.image.crossOrigin = "Anonymous";self.image.onload = resolve;self.image.onerror = reject;new ProxyURL(src,proxy,document).then(function(url){self.image.src = url;})['catch'](reject);});}module.exports = ProxyImageContainer;},{"./proxy":16}],18:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function PseudoElementContainer(node,parent,type){NodeContainer.call(this,node,parent);this.isPseudoElement = true;this.before = type === ":before";}PseudoElementContainer.prototype.cloneTo = function(stack){PseudoElementContainer.prototype.cloneTo.call(this,stack);stack.isPseudoElement = true;stack.before = this.before;};PseudoElementContainer.prototype = Object.create(NodeContainer.prototype);PseudoElementContainer.prototype.appendToDOM = function(){if(this.before){this.parent.node.insertBefore(this.node,this.parent.node.firstChild);}else {this.parent.node.appendChild(this.node);}this.parent.node.className += " " + this.getHideClass();};PseudoElementContainer.prototype.cleanDOM = function(){this.node.parentNode.removeChild(this.node);this.parent.node.className = this.parent.node.className.replace(this.getHideClass(),"");};PseudoElementContainer.prototype.getHideClass = function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before?"BEFORE":"AFTER")];};PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";module.exports = PseudoElementContainer;},{"./nodecontainer":14}],19:[function(_dereq_,module,exports){var log=_dereq_('./log');function Renderer(width,height,images,options,document){this.width = width;this.height = height;this.images = images;this.options = options;this.document = document;}Renderer.prototype.renderImage = function(container,bounds,borderData,imageContainer){var paddingLeft=container.cssInt('paddingLeft'),paddingTop=container.cssInt('paddingTop'),paddingRight=container.cssInt('paddingRight'),paddingBottom=container.cssInt('paddingBottom'),borders=borderData.borders;var width=bounds.width - (borders[1].width + borders[3].width + paddingLeft + paddingRight);var height=bounds.height - (borders[0].width + borders[2].width + paddingTop + paddingBottom);this.drawImage(imageContainer,0,0,imageContainer.image.width || width,imageContainer.image.height || height,bounds.left + paddingLeft + borders[3].width,bounds.top + paddingTop + borders[0].width,width,height);};Renderer.prototype.renderBackground = function(container,bounds,borderData){if(bounds.height > 0 && bounds.width > 0){this.renderBackgroundColor(container,bounds);this.renderBackgroundImage(container,bounds,borderData);}};Renderer.prototype.renderBackgroundColor = function(container,bounds){var color=container.color("backgroundColor");if(!color.isTransparent()){this.rectangle(bounds.left,bounds.top,bounds.width,bounds.height,color);}};Renderer.prototype.renderBorders = function(borders){borders.forEach(this.renderBorder,this);};Renderer.prototype.renderBorder = function(data){if(!data.color.isTransparent() && data.args !== null){this.drawShape(data.args,data.color);}};Renderer.prototype.renderBackgroundImage = function(container,bounds,borderData){var backgroundImages=container.parseBackgroundImages();backgroundImages.reverse().forEach(function(backgroundImage,index,arr){switch(backgroundImage.method){case "url":var image=this.images.get(backgroundImage.args[0]);if(image){this.renderBackgroundRepeating(container,bounds,image,arr.length - (index + 1),borderData);}else {log("Error loading background-image",backgroundImage.args[0]);}break;case "linear-gradient":case "gradient":var gradientImage=this.images.get(backgroundImage.value);if(gradientImage){this.renderBackgroundGradient(gradientImage,bounds,borderData);}else {log("Error loading background-image",backgroundImage.args[0]);}break;case "none":break;default:log("Unknown background-image type",backgroundImage.args[0]);}},this);};Renderer.prototype.renderBackgroundRepeating = function(container,bounds,imageContainer,index,borderData){var size=container.parseBackgroundSize(bounds,imageContainer.image,index);var position=container.parseBackgroundPosition(bounds,imageContainer.image,index,size);var repeat=container.parseBackgroundRepeat(index);switch(repeat){case "repeat-x":case "repeat no-repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + borderData[3],bounds.top + position.top + borderData[0],99999,size.height,borderData);break;case "repeat-y":case "no-repeat repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + position.left + borderData[3],bounds.top + borderData[0],size.width,99999,borderData);break;case "no-repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + position.left + borderData[3],bounds.top + position.top + borderData[0],size.width,size.height,borderData);break;default:this.renderBackgroundRepeat(imageContainer,position,size,{top:bounds.top,left:bounds.left},borderData[3],borderData[0]);break;}};module.exports = Renderer;},{"./log":13}],20:[function(_dereq_,module,exports){var Renderer=_dereq_('../renderer');var LinearGradientContainer=_dereq_('../lineargradientcontainer');var log=_dereq_('../log');function CanvasRenderer(width,height){Renderer.apply(this,arguments);this.canvas = this.options.canvas || this.document.createElement("canvas");if(!this.options.canvas){this.canvas.width = width;this.canvas.height = height;}this.ctx = this.canvas.getContext("2d");this.taintCtx = this.document.createElement("canvas").getContext("2d");this.ctx.textBaseline = "bottom";this.variables = {};log("Initialized CanvasRenderer with size",width,"x",height);}CanvasRenderer.prototype = Object.create(Renderer.prototype);CanvasRenderer.prototype.setFillStyle = function(fillStyle){this.ctx.fillStyle = typeof fillStyle === "object" && !!fillStyle.isColor?fillStyle.toString():fillStyle;return this.ctx;};CanvasRenderer.prototype.rectangle = function(left,top,width,height,color){this.setFillStyle(color).fillRect(left,top,width,height);};CanvasRenderer.prototype.circle = function(left,top,size,color){this.setFillStyle(color);this.ctx.beginPath();this.ctx.arc(left + size / 2,top + size / 2,size / 2,0,Math.PI * 2,true);this.ctx.closePath();this.ctx.fill();};CanvasRenderer.prototype.circleStroke = function(left,top,size,color,stroke,strokeColor){this.circle(left,top,size,color);this.ctx.strokeStyle = strokeColor.toString();this.ctx.stroke();};CanvasRenderer.prototype.drawShape = function(shape,color){this.shape(shape);this.setFillStyle(color).fill();};CanvasRenderer.prototype.taints = function(imageContainer){if(imageContainer.tainted === null){this.taintCtx.drawImage(imageContainer.image,0,0);try{this.taintCtx.getImageData(0,0,1,1);imageContainer.tainted = false;}catch(e) {this.taintCtx = document.createElement("canvas").getContext("2d");imageContainer.tainted = true;}}return imageContainer.tainted;};CanvasRenderer.prototype.drawImage = function(imageContainer,sx,sy,sw,sh,dx,dy,dw,dh){if(!this.taints(imageContainer) || this.options.allowTaint){this.ctx.drawImage(imageContainer.image,sx,sy,sw,sh,dx,dy,dw,dh);}};CanvasRenderer.prototype.clip = function(shapes,callback,context){this.ctx.save();shapes.filter(hasEntries).forEach(function(shape){this.shape(shape).clip();},this);callback.call(context);this.ctx.restore();};CanvasRenderer.prototype.shape = function(shape){this.ctx.beginPath();shape.forEach(function(point,index){if(point[0] === "rect"){this.ctx.rect.apply(this.ctx,point.slice(1));}else {this.ctx[index === 0?"moveTo":point[0] + "To"].apply(this.ctx,point.slice(1));}},this);this.ctx.closePath();return this.ctx;};CanvasRenderer.prototype.font = function(color,style,variant,weight,size,family){this.setFillStyle(color).font = [style,variant,weight,size,family].join(" ").split(",")[0];};CanvasRenderer.prototype.fontShadow = function(color,offsetX,offsetY,blur){this.setVariable("shadowColor",color.toString()).setVariable("shadowOffsetY",offsetX).setVariable("shadowOffsetX",offsetY).setVariable("shadowBlur",blur);};CanvasRenderer.prototype.clearShadow = function(){this.setVariable("shadowColor","rgba(0,0,0,0)");};CanvasRenderer.prototype.setOpacity = function(opacity){this.ctx.globalAlpha = opacity;};CanvasRenderer.prototype.setTransform = function(transform){this.ctx.translate(transform.origin[0],transform.origin[1]);this.ctx.transform.apply(this.ctx,transform.matrix);this.ctx.translate(-transform.origin[0],-transform.origin[1]);};CanvasRenderer.prototype.setVariable = function(property,value){if(this.variables[property] !== value){this.variables[property] = this.ctx[property] = value;}return this;};CanvasRenderer.prototype.text = function(text,left,bottom){this.ctx.fillText(text,left,bottom);};CanvasRenderer.prototype.backgroundRepeatShape = function(imageContainer,backgroundPosition,size,bounds,left,top,width,height,borderData){var shape=[["line",Math.round(left),Math.round(top)],["line",Math.round(left + width),Math.round(top)],["line",Math.round(left + width),Math.round(height + top)],["line",Math.round(left),Math.round(height + top)]];this.clip([shape],function(){this.renderBackgroundRepeat(imageContainer,backgroundPosition,size,bounds,borderData[3],borderData[0]);},this);};CanvasRenderer.prototype.renderBackgroundRepeat = function(imageContainer,backgroundPosition,size,bounds,borderLeft,borderTop){var offsetX=Math.round(bounds.left + backgroundPosition.left + borderLeft),offsetY=Math.round(bounds.top + backgroundPosition.top + borderTop);this.setFillStyle(this.ctx.createPattern(this.resizeImage(imageContainer,size),"repeat"));this.ctx.translate(offsetX,offsetY);this.ctx.fill();this.ctx.translate(-offsetX,-offsetY);};CanvasRenderer.prototype.renderBackgroundGradient = function(gradientImage,bounds){if(gradientImage instanceof LinearGradientContainer){var gradient=this.ctx.createLinearGradient(bounds.left + bounds.width * gradientImage.x0,bounds.top + bounds.height * gradientImage.y0,bounds.left + bounds.width * gradientImage.x1,bounds.top + bounds.height * gradientImage.y1);gradientImage.colorStops.forEach(function(colorStop){gradient.addColorStop(colorStop.stop,colorStop.color.toString());});this.rectangle(bounds.left,bounds.top,bounds.width,bounds.height,gradient);}};CanvasRenderer.prototype.resizeImage = function(imageContainer,size){var image=imageContainer.image;if(image.width === size.width && image.height === size.height){return image;}var ctx,canvas=document.createElement('canvas');canvas.width = size.width;canvas.height = size.height;ctx = canvas.getContext("2d");ctx.drawImage(image,0,0,image.width,image.height,0,0,size.width,size.height);return canvas;};function hasEntries(array){return array.length > 0;}module.exports = CanvasRenderer;},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function StackingContext(hasOwnStacking,opacity,element,parent){NodeContainer.call(this,element,parent);this.ownStacking = hasOwnStacking;this.contexts = [];this.children = [];this.opacity = (this.parent?this.parent.stack.opacity:1) * opacity;}StackingContext.prototype = Object.create(NodeContainer.prototype);StackingContext.prototype.getParentStack = function(context){var parentStack=this.parent?this.parent.stack:null;return parentStack?parentStack.ownStacking?parentStack:parentStack.getParentStack(context):context.stack;};module.exports = StackingContext;},{"./nodecontainer":14}],22:[function(_dereq_,module,exports){function Support(document){this.rangeBounds = this.testRangeBounds(document);this.cors = this.testCORS();this.svg = this.testSVG();}Support.prototype.testRangeBounds = function(document){var range,testElement,rangeBounds,rangeHeight,support=false;if(document.createRange){range = document.createRange();if(range.getBoundingClientRect){testElement = document.createElement('boundtest');testElement.style.height = "123px";testElement.style.display = "block";document.body.appendChild(testElement);range.selectNode(testElement);rangeBounds = range.getBoundingClientRect();rangeHeight = rangeBounds.height;if(rangeHeight === 123){support = true;}document.body.removeChild(testElement);}}return support;};Support.prototype.testCORS = function(){return typeof new Image().crossOrigin !== "undefined";};Support.prototype.testSVG = function(){var img=new Image();var canvas=document.createElement("canvas");var ctx=canvas.getContext("2d");img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{ctx.drawImage(img,0,0);canvas.toDataURL();}catch(e) {return false;}return true;};module.exports = Support;},{}],23:[function(_dereq_,module,exports){var XHR=_dereq_('./xhr');var decode64=_dereq_('./utils').decode64;function SVGContainer(src){this.src = src;this.image = null;var self=this;this.promise = this.hasFabric().then(function(){return self.isInline(src)?Promise.resolve(self.inlineFormatting(src)):XHR(src);}).then(function(svg){return new Promise(function(resolve){window.html2canvas.svg.fabric.loadSVGFromString(svg,self.createCanvas.call(self,resolve));});});}SVGContainer.prototype.hasFabric = function(){return !window.html2canvas.svg || !window.html2canvas.svg.fabric?Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg")):Promise.resolve();};SVGContainer.prototype.inlineFormatting = function(src){return (/^data:image\/svg\+xml;base64,/.test(src)?this.decode64(this.removeContentType(src)):this.removeContentType(src));};SVGContainer.prototype.removeContentType = function(src){return src.replace(/^data:image\/svg\+xml(;base64)?,/,'');};SVGContainer.prototype.isInline = function(src){return (/^data:image\/svg\+xml/i.test(src));};SVGContainer.prototype.createCanvas = function(resolve){var self=this;return function(objects,options){var canvas=new window.html2canvas.svg.fabric.StaticCanvas('c');self.image = canvas.lowerCanvasEl;canvas.setWidth(options.width).setHeight(options.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(objects,options)).renderAll();resolve(canvas.lowerCanvasEl);};};SVGContainer.prototype.decode64 = function(str){return typeof window.atob === "function"?window.atob(str):decode64(str);};module.exports = SVGContainer;},{"./utils":26,"./xhr":28}],24:[function(_dereq_,module,exports){var SVGContainer=_dereq_('./svgcontainer');function SVGNodeContainer(node,_native){this.src = node;this.image = null;var self=this;this.promise = _native?new Promise(function(resolve,reject){self.image = new Image();self.image.onload = resolve;self.image.onerror = reject;self.image.src = "data:image/svg+xml," + new XMLSerializer().serializeToString(node);if(self.image.complete === true){resolve(self.image);}}):this.hasFabric().then(function(){return new Promise(function(resolve){window.html2canvas.svg.fabric.parseSVGDocument(node,self.createCanvas.call(self,resolve));});});}SVGNodeContainer.prototype = Object.create(SVGContainer.prototype);module.exports = SVGNodeContainer;},{"./svgcontainer":23}],25:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function TextContainer(node,parent){NodeContainer.call(this,node,parent);}TextContainer.prototype = Object.create(NodeContainer.prototype);TextContainer.prototype.applyTextTransform = function(){this.node.data = this.transform(this.parent.css("textTransform"));};TextContainer.prototype.transform = function(transform){var text=this.node.data;switch(transform){case "lowercase":return text.toLowerCase();case "capitalize":return text.replace(/(^|\s|:|-|\(|\))([a-z])/g,capitalize);case "uppercase":return text.toUpperCase();default:return text;}};function capitalize(m,p1,p2){if(m.length > 0){return p1 + p2.toUpperCase();}}module.exports = TextContainer;},{"./nodecontainer":14}],26:[function(_dereq_,module,exports){exports.smallImage = function smallImage(){return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";};exports.bind = function(callback,context){return function(){return callback.apply(context,arguments);};}; /*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */exports.decode64 = function(base64){var chars="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var len=base64.length,i,encoded1,encoded2,encoded3,encoded4,byte1,byte2,byte3;var output="";for(i = 0;i < len;i += 4) {encoded1 = chars.indexOf(base64[i]);encoded2 = chars.indexOf(base64[i + 1]);encoded3 = chars.indexOf(base64[i + 2]);encoded4 = chars.indexOf(base64[i + 3]);byte1 = encoded1 << 2 | encoded2 >> 4;byte2 = (encoded2 & 15) << 4 | encoded3 >> 2;byte3 = (encoded3 & 3) << 6 | encoded4;if(encoded3 === 64){output += String.fromCharCode(byte1);}else if(encoded4 === 64 || encoded4 === -1){output += String.fromCharCode(byte1,byte2);}else {output += String.fromCharCode(byte1,byte2,byte3);}}return output;};exports.getBounds = function(node){if(node.getBoundingClientRect){var clientRect=node.getBoundingClientRect();var width=node.offsetWidth == null?clientRect.width:node.offsetWidth;return {top:clientRect.top,bottom:clientRect.bottom || clientRect.top + clientRect.height,right:clientRect.left + width,left:clientRect.left,width:width,height:node.offsetHeight == null?clientRect.height:node.offsetHeight};}return {};};exports.offsetBounds = function(node){var parent=node.offsetParent?exports.offsetBounds(node.offsetParent):{top:0,left:0};return {top:node.offsetTop + parent.top,bottom:node.offsetTop + node.offsetHeight + parent.top,right:node.offsetLeft + parent.left + node.offsetWidth,left:node.offsetLeft + parent.left,width:node.offsetWidth,height:node.offsetHeight};};exports.parseBackgrounds = function(backgroundImage){var whitespace=' \r\n\t',method,definition,prefix,prefix_i,block,results=[],mode=0,numParen=0,quote,args;var appendResult=function appendResult(){if(method){if(definition.substr(0,1) === '"'){definition = definition.substr(1,definition.length - 2);}if(definition){args.push(definition);}if(method.substr(0,1) === '-' && (prefix_i = method.indexOf('-',1) + 1) > 0){prefix = method.substr(0,prefix_i);method = method.substr(prefix_i);}results.push({prefix:prefix,method:method.toLowerCase(),value:block,args:args,image:null});}args = [];method = prefix = definition = block = '';};args = [];method = prefix = definition = block = '';backgroundImage.split("").forEach(function(c){if(mode === 0 && whitespace.indexOf(c) > -1){return;}switch(c){case '"':if(!quote){quote = c;}else if(quote === c){quote = null;}break;case '(':if(quote){break;}else if(mode === 0){mode = 1;block += c;return;}else {numParen++;}break;case ')':if(quote){break;}else if(mode === 1){if(numParen === 0){mode = 0;block += c;appendResult();return;}else {numParen--;}}break;case ',':if(quote){break;}else if(mode === 0){appendResult();return;}else if(mode === 1){if(numParen === 0 && !method.match(/^url$/i)){args.push(definition);definition = '';block += c;return;}}break;}block += c;if(mode === 0){method += c;}else {definition += c;}});appendResult();return results;};},{}],27:[function(_dereq_,module,exports){var GradientContainer=_dereq_('./gradientcontainer');function WebkitGradientContainer(imageData){GradientContainer.apply(this,arguments);this.type = imageData.args[0] === "linear"?GradientContainer.TYPES.LINEAR:GradientContainer.TYPES.RADIAL;}WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);module.exports = WebkitGradientContainer;},{"./gradientcontainer":9}],28:[function(_dereq_,module,exports){function XHR(url){return new Promise(function(resolve,reject){var xhr=new XMLHttpRequest();xhr.open('GET',url);xhr.onload = function(){if(xhr.status === 200){resolve(xhr.responseText);}else {reject(new Error(xhr.statusText));}};xhr.onerror = function(){reject(new Error("Network Error"));};xhr.send();});}module.exports = XHR;},{}]},{},[4])(4);}); // Generated by CoffeeScript 1.4.0
	/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# 
	*/(function(global){var PNG;PNG = (function(){var APNG_BLEND_OP_OVER,APNG_BLEND_OP_SOURCE,APNG_DISPOSE_OP_BACKGROUND,APNG_DISPOSE_OP_NONE,APNG_DISPOSE_OP_PREVIOUS,makeImage,scratchCanvas,scratchCtx;PNG.load = function(url,canvas,callback){var xhr;if(typeof canvas === 'function'){callback = canvas;}xhr = new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType = "arraybuffer";xhr.onload = function(){var data,png;data = new Uint8Array(xhr.response || xhr.mozResponseArrayBuffer);png = new PNG(data);if(typeof (canvas != null?canvas.getContext:void 0) === 'function'){png.render(canvas);}return typeof callback === "function"?callback(png):void 0;};return xhr.send(null);};APNG_DISPOSE_OP_BACKGROUND = 1;APNG_DISPOSE_OP_PREVIOUS = 2;APNG_BLEND_OP_SOURCE = 0;function PNG(data){var chunkSize,colors,palLen,delayDen,delayNum,frame,i,index,key,section,palShort,text,_i,_j,_ref;this.data = data;this.pos = 8;this.palette = [];this.imgData = [];this.transparency = {};this.animation = null;this.text = {};frame = null;while(true) {chunkSize = this.readUInt32();section = (function(){var _i,_results;_results = [];for(i = _i = 0;_i < 4;i = ++_i) {_results.push(String.fromCharCode(this.data[this.pos++]));}return _results;}).call(this).join('');switch(section){case 'IHDR':this.width = this.readUInt32();this.height = this.readUInt32();this.bits = this.data[this.pos++];this.colorType = this.data[this.pos++];this.compressionMethod = this.data[this.pos++];this.filterMethod = this.data[this.pos++];this.interlaceMethod = this.data[this.pos++];break;case 'acTL':this.animation = {numFrames:this.readUInt32(),numPlays:this.readUInt32() || Infinity,frames:[]};break;case 'PLTE':this.palette = this.read(chunkSize);break;case 'fcTL':if(frame){this.animation.frames.push(frame);}this.pos += 4;frame = {width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()};delayNum = this.readUInt16();delayDen = this.readUInt16() || 100;frame.delay = 1000 * delayNum / delayDen;frame.disposeOp = this.data[this.pos++];frame.blendOp = this.data[this.pos++];frame.data = [];break;case 'IDAT':case 'fdAT':if(section === 'fdAT'){this.pos += 4;chunkSize -= 4;}data = (frame != null?frame.data:void 0) || this.imgData;for(i = _i = 0;0 <= chunkSize?_i < chunkSize:_i > chunkSize;i = 0 <= chunkSize?++_i:--_i) {data.push(this.data[this.pos++]);}break;case 'tRNS':this.transparency = {};switch(this.colorType){case 3:palLen = this.palette.length / 3;this.transparency.indexed = this.read(chunkSize);if(this.transparency.indexed.length > palLen)throw new Error('More transparent colors than palette size'); /*
	                 * According to the PNG spec trns should be increased to the same size as palette if shorter
	                 */ //palShort = 255 - this.transparency.indexed.length;
	palShort = palLen - this.transparency.indexed.length;if(palShort > 0){for(i = _j = 0;0 <= palShort?_j < palShort:_j > palShort;i = 0 <= palShort?++_j:--_j) {this.transparency.indexed.push(255);}}break;case 0:this.transparency.grayscale = this.read(chunkSize)[0];break;case 2:this.transparency.rgb = this.read(chunkSize);}break;case 'tEXt':text = this.read(chunkSize);index = text.indexOf(0);key = String.fromCharCode.apply(String,text.slice(0,index));this.text[key] = String.fromCharCode.apply(String,text.slice(index + 1));break;case 'IEND':if(frame){this.animation.frames.push(frame);}this.colors = (function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3;}}).call(this);this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;colors = this.colors + (this.hasAlphaChannel?1:0);this.pixelBitlength = this.bits * colors;this.colorSpace = (function(){switch(this.colors){case 1:return 'DeviceGray';case 3:return 'DeviceRGB';}}).call(this);this.imgData = new Uint8Array(this.imgData);return;default:this.pos += chunkSize;}this.pos += 4;if(this.pos > this.data.length){throw new Error("Incomplete or corrupt PNG file");}}return;}PNG.prototype.read = function(bytes){var i,_i,_results;_results = [];for(i = _i = 0;0 <= bytes?_i < bytes:_i > bytes;i = 0 <= bytes?++_i:--_i) {_results.push(this.data[this.pos++]);}return _results;};PNG.prototype.readUInt32 = function(){var b1,b2,b3,b4;b1 = this.data[this.pos++] << 24;b2 = this.data[this.pos++] << 16;b3 = this.data[this.pos++] << 8;b4 = this.data[this.pos++];return b1 | b2 | b3 | b4;};PNG.prototype.readUInt16 = function(){var b1,b2;b1 = this.data[this.pos++] << 8;b2 = this.data[this.pos++];return b1 | b2;};PNG.prototype.decodePixels = function(data){var abyte,c,col,i,left,length,p,pa,paeth,pb,pc,pixelBytes,pixels,pos,row,scanlineLength,upper,upperLeft,_i,_j,_k,_l,_m;if(data == null){data = this.imgData;}if(data.length === 0){return new Uint8Array(0);}data = new FlateStream(data);data = data.getBytes();pixelBytes = this.pixelBitlength / 8;scanlineLength = pixelBytes * this.width;pixels = new Uint8Array(scanlineLength * this.height);length = data.length;row = 0;pos = 0;c = 0;while(pos < length) {switch(data[pos++]){case 0:for(i = _i = 0;_i < scanlineLength;i = _i += 1) {pixels[c++] = data[pos++];}break;case 1:for(i = _j = 0;_j < scanlineLength;i = _j += 1) {abyte = data[pos++];left = i < pixelBytes?0:pixels[c - pixelBytes];pixels[c++] = (abyte + left) % 256;}break;case 2:for(i = _k = 0;_k < scanlineLength;i = _k += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];pixels[c++] = (upper + abyte) % 256;}break;case 3:for(i = _l = 0;_l < scanlineLength;i = _l += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;left = i < pixelBytes?0:pixels[c - pixelBytes];upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];pixels[c++] = (abyte + Math.floor((left + upper) / 2)) % 256;}break;case 4:for(i = _m = 0;_m < scanlineLength;i = _m += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;left = i < pixelBytes?0:pixels[c - pixelBytes];if(row === 0){upper = upperLeft = 0;}else {upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];}p = left + upper - upperLeft;pa = Math.abs(p - left);pb = Math.abs(p - upper);pc = Math.abs(p - upperLeft);if(pa <= pb && pa <= pc){paeth = left;}else if(pb <= pc){paeth = upper;}else {paeth = upperLeft;}pixels[c++] = (abyte + paeth) % 256;}break;default:throw new Error("Invalid filter algorithm: " + data[pos - 1]);}row++;}return pixels;};PNG.prototype.decodePalette = function(){var c,i,length,palette,pos,ret,transparency,_i,_ref,_ref1;palette = this.palette;transparency = this.transparency.indexed || [];ret = new Uint8Array((transparency.length || 0) + palette.length);pos = 0;c = 0;for(i = _i = 0,_ref = palette.length;_i < _ref;i = _i += 3) {ret[pos++] = palette[i];ret[pos++] = palette[i + 1];ret[pos++] = palette[i + 2];ret[pos++] = (_ref1 = transparency[c++]) != null?_ref1:255;}return ret;};PNG.prototype.copyToImageData = function(imageData,pixels){var alpha,colors,data,i,input,j,k,length,palette,v,_ref;colors = this.colors;palette = null;alpha = this.hasAlphaChannel;if(this.palette.length){palette = (_ref = this._decodedPalette) != null?_ref:this._decodedPalette = this.decodePalette();colors = 4;alpha = true;}data = imageData.data || imageData;length = data.length;input = palette || pixels;i = j = 0;if(colors === 1){while(i < length) {k = palette?pixels[i / 4] * 4:j;v = input[k++];data[i++] = v;data[i++] = v;data[i++] = v;data[i++] = alpha?input[k++]:255;j = k;}}else {while(i < length) {k = palette?pixels[i / 4] * 4:j;data[i++] = input[k++];data[i++] = input[k++];data[i++] = input[k++];data[i++] = alpha?input[k++]:255;j = k;}}};PNG.prototype.decode = function(){var ret;ret = new Uint8Array(this.width * this.height * 4);this.copyToImageData(ret,this.decodePixels());return ret;};try{scratchCanvas = global.document.createElement('canvas');scratchCtx = scratchCanvas.getContext('2d');}catch(e) {return -1;}makeImage = function(imageData){var img;scratchCtx.width = imageData.width;scratchCtx.height = imageData.height;scratchCtx.clearRect(0,0,imageData.width,imageData.height);scratchCtx.putImageData(imageData,0,0);img = new Image();img.src = scratchCanvas.toDataURL();return img;};PNG.prototype.decodeFrames = function(ctx){var frame,i,imageData,pixels,_i,_len,_ref,_results;if(!this.animation){return;}_ref = this.animation.frames;_results = [];for(i = _i = 0,_len = _ref.length;_i < _len;i = ++_i) {frame = _ref[i];imageData = ctx.createImageData(frame.width,frame.height);pixels = this.decodePixels(new Uint8Array(frame.data));this.copyToImageData(imageData,pixels);frame.imageData = imageData;_results.push(frame.image = makeImage(imageData));}return _results;};PNG.prototype.renderFrame = function(ctx,number){var frame,frames,prev;frames = this.animation.frames;frame = frames[number];prev = frames[number - 1];if(number === 0){ctx.clearRect(0,0,this.width,this.height);}if((prev != null?prev.disposeOp:void 0) === APNG_DISPOSE_OP_BACKGROUND){ctx.clearRect(prev.xOffset,prev.yOffset,prev.width,prev.height);}else if((prev != null?prev.disposeOp:void 0) === APNG_DISPOSE_OP_PREVIOUS){ctx.putImageData(prev.imageData,prev.xOffset,prev.yOffset);}if(frame.blendOp === APNG_BLEND_OP_SOURCE){ctx.clearRect(frame.xOffset,frame.yOffset,frame.width,frame.height);}return ctx.drawImage(frame.image,frame.xOffset,frame.yOffset);};PNG.prototype.animate = function(ctx){var doFrame,frameNumber,frames,numFrames,numPlays,_ref,_this=this;frameNumber = 0;_ref = this.animation,numFrames = _ref.numFrames,frames = _ref.frames,numPlays = _ref.numPlays;return (doFrame = function(){var f,frame;f = frameNumber++ % numFrames;frame = frames[f];_this.renderFrame(ctx,f);if(numFrames > 1 && frameNumber / numFrames < numPlays){return _this.animation._timeout = setTimeout(doFrame,frame.delay);}})();};PNG.prototype.stopAnimation = function(){var _ref;return clearTimeout((_ref = this.animation) != null?_ref._timeout:void 0);};PNG.prototype.render = function(canvas){var ctx,data;if(canvas._png){canvas._png.stopAnimation();}canvas._png = this;canvas.width = this.width;canvas.height = this.height;ctx = canvas.getContext("2d");if(this.animation){this.decodeFrames(ctx);return this.animate(ctx);}else {data = ctx.createImageData(this.width,this.height);this.copyToImageData(data,this.decodePixels());return ctx.putImageData(data,0,0);}};return PNG;})();global.PNG = PNG;})(typeof window !== "undefined" && window || undefined); /*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * 
	 */var DecodeStream=(function(){function constructor(){this.pos = 0;this.bufferLength = 0;this.eof = false;this.buffer = null;}constructor.prototype = {ensureBuffer:function decodestream_ensureBuffer(requested){var buffer=this.buffer;var current=buffer?buffer.byteLength:0;if(requested < current)return buffer;var size=512;while(size < requested) size <<= 1;var buffer2=new Uint8Array(size);for(var i=0;i < current;++i) buffer2[i] = buffer[i];return this.buffer = buffer2;},getByte:function decodestream_getByte(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return this.buffer[this.pos++];},getBytes:function decodestream_getBytes(length){var pos=this.pos;if(length){this.ensureBuffer(pos + length);var end=pos + length;while(!this.eof && this.bufferLength < end) this.readBlock();var bufEnd=this.bufferLength;if(end > bufEnd)end = bufEnd;}else {while(!this.eof) this.readBlock();var end=this.bufferLength;}this.pos = end;return this.buffer.subarray(pos,end);},lookChar:function decodestream_lookChar(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return String.fromCharCode(this.buffer[this.pos]);},getChar:function decodestream_getChar(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return String.fromCharCode(this.buffer[this.pos++]);},makeSubStream:function decodestream_makeSubstream(start,length,dict){var end=start + length;while(this.bufferLength <= end && !this.eof) this.readBlock();return new Stream(this.buffer,start,length,dict);},skip:function decodestream_skip(n){if(!n)n = 1;this.pos += n;},reset:function decodestream_reset(){this.pos = 0;}};return constructor;})();var FlateStream=(function(){if(typeof Uint32Array === 'undefined'){return undefined;}var codeLenCodeMap=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);var lengthDecode=new Uint32Array([0x00003,0x00004,0x00005,0x00006,0x00007,0x00008,0x00009,0x0000a,0x1000b,0x1000d,0x1000f,0x10011,0x20013,0x20017,0x2001b,0x2001f,0x30023,0x3002b,0x30033,0x3003b,0x40043,0x40053,0x40063,0x40073,0x50083,0x500a3,0x500c3,0x500e3,0x00102,0x00102,0x00102]);var distDecode=new Uint32Array([0x00001,0x00002,0x00003,0x00004,0x10005,0x10007,0x20009,0x2000d,0x30011,0x30019,0x40021,0x40031,0x50041,0x50061,0x60081,0x600c1,0x70101,0x70181,0x80201,0x80301,0x90401,0x90601,0xa0801,0xa0c01,0xb1001,0xb1801,0xc2001,0xc3001,0xd4001,0xd6001]);var fixedLitCodeTab=[new Uint32Array([0x70100,0x80050,0x80010,0x80118,0x70110,0x80070,0x80030,0x900c0,0x70108,0x80060,0x80020,0x900a0,0x80000,0x80080,0x80040,0x900e0,0x70104,0x80058,0x80018,0x90090,0x70114,0x80078,0x80038,0x900d0,0x7010c,0x80068,0x80028,0x900b0,0x80008,0x80088,0x80048,0x900f0,0x70102,0x80054,0x80014,0x8011c,0x70112,0x80074,0x80034,0x900c8,0x7010a,0x80064,0x80024,0x900a8,0x80004,0x80084,0x80044,0x900e8,0x70106,0x8005c,0x8001c,0x90098,0x70116,0x8007c,0x8003c,0x900d8,0x7010e,0x8006c,0x8002c,0x900b8,0x8000c,0x8008c,0x8004c,0x900f8,0x70101,0x80052,0x80012,0x8011a,0x70111,0x80072,0x80032,0x900c4,0x70109,0x80062,0x80022,0x900a4,0x80002,0x80082,0x80042,0x900e4,0x70105,0x8005a,0x8001a,0x90094,0x70115,0x8007a,0x8003a,0x900d4,0x7010d,0x8006a,0x8002a,0x900b4,0x8000a,0x8008a,0x8004a,0x900f4,0x70103,0x80056,0x80016,0x8011e,0x70113,0x80076,0x80036,0x900cc,0x7010b,0x80066,0x80026,0x900ac,0x80006,0x80086,0x80046,0x900ec,0x70107,0x8005e,0x8001e,0x9009c,0x70117,0x8007e,0x8003e,0x900dc,0x7010f,0x8006e,0x8002e,0x900bc,0x8000e,0x8008e,0x8004e,0x900fc,0x70100,0x80051,0x80011,0x80119,0x70110,0x80071,0x80031,0x900c2,0x70108,0x80061,0x80021,0x900a2,0x80001,0x80081,0x80041,0x900e2,0x70104,0x80059,0x80019,0x90092,0x70114,0x80079,0x80039,0x900d2,0x7010c,0x80069,0x80029,0x900b2,0x80009,0x80089,0x80049,0x900f2,0x70102,0x80055,0x80015,0x8011d,0x70112,0x80075,0x80035,0x900ca,0x7010a,0x80065,0x80025,0x900aa,0x80005,0x80085,0x80045,0x900ea,0x70106,0x8005d,0x8001d,0x9009a,0x70116,0x8007d,0x8003d,0x900da,0x7010e,0x8006d,0x8002d,0x900ba,0x8000d,0x8008d,0x8004d,0x900fa,0x70101,0x80053,0x80013,0x8011b,0x70111,0x80073,0x80033,0x900c6,0x70109,0x80063,0x80023,0x900a6,0x80003,0x80083,0x80043,0x900e6,0x70105,0x8005b,0x8001b,0x90096,0x70115,0x8007b,0x8003b,0x900d6,0x7010d,0x8006b,0x8002b,0x900b6,0x8000b,0x8008b,0x8004b,0x900f6,0x70103,0x80057,0x80017,0x8011f,0x70113,0x80077,0x80037,0x900ce,0x7010b,0x80067,0x80027,0x900ae,0x80007,0x80087,0x80047,0x900ee,0x70107,0x8005f,0x8001f,0x9009e,0x70117,0x8007f,0x8003f,0x900de,0x7010f,0x8006f,0x8002f,0x900be,0x8000f,0x8008f,0x8004f,0x900fe,0x70100,0x80050,0x80010,0x80118,0x70110,0x80070,0x80030,0x900c1,0x70108,0x80060,0x80020,0x900a1,0x80000,0x80080,0x80040,0x900e1,0x70104,0x80058,0x80018,0x90091,0x70114,0x80078,0x80038,0x900d1,0x7010c,0x80068,0x80028,0x900b1,0x80008,0x80088,0x80048,0x900f1,0x70102,0x80054,0x80014,0x8011c,0x70112,0x80074,0x80034,0x900c9,0x7010a,0x80064,0x80024,0x900a9,0x80004,0x80084,0x80044,0x900e9,0x70106,0x8005c,0x8001c,0x90099,0x70116,0x8007c,0x8003c,0x900d9,0x7010e,0x8006c,0x8002c,0x900b9,0x8000c,0x8008c,0x8004c,0x900f9,0x70101,0x80052,0x80012,0x8011a,0x70111,0x80072,0x80032,0x900c5,0x70109,0x80062,0x80022,0x900a5,0x80002,0x80082,0x80042,0x900e5,0x70105,0x8005a,0x8001a,0x90095,0x70115,0x8007a,0x8003a,0x900d5,0x7010d,0x8006a,0x8002a,0x900b5,0x8000a,0x8008a,0x8004a,0x900f5,0x70103,0x80056,0x80016,0x8011e,0x70113,0x80076,0x80036,0x900cd,0x7010b,0x80066,0x80026,0x900ad,0x80006,0x80086,0x80046,0x900ed,0x70107,0x8005e,0x8001e,0x9009d,0x70117,0x8007e,0x8003e,0x900dd,0x7010f,0x8006e,0x8002e,0x900bd,0x8000e,0x8008e,0x8004e,0x900fd,0x70100,0x80051,0x80011,0x80119,0x70110,0x80071,0x80031,0x900c3,0x70108,0x80061,0x80021,0x900a3,0x80001,0x80081,0x80041,0x900e3,0x70104,0x80059,0x80019,0x90093,0x70114,0x80079,0x80039,0x900d3,0x7010c,0x80069,0x80029,0x900b3,0x80009,0x80089,0x80049,0x900f3,0x70102,0x80055,0x80015,0x8011d,0x70112,0x80075,0x80035,0x900cb,0x7010a,0x80065,0x80025,0x900ab,0x80005,0x80085,0x80045,0x900eb,0x70106,0x8005d,0x8001d,0x9009b,0x70116,0x8007d,0x8003d,0x900db,0x7010e,0x8006d,0x8002d,0x900bb,0x8000d,0x8008d,0x8004d,0x900fb,0x70101,0x80053,0x80013,0x8011b,0x70111,0x80073,0x80033,0x900c7,0x70109,0x80063,0x80023,0x900a7,0x80003,0x80083,0x80043,0x900e7,0x70105,0x8005b,0x8001b,0x90097,0x70115,0x8007b,0x8003b,0x900d7,0x7010d,0x8006b,0x8002b,0x900b7,0x8000b,0x8008b,0x8004b,0x900f7,0x70103,0x80057,0x80017,0x8011f,0x70113,0x80077,0x80037,0x900cf,0x7010b,0x80067,0x80027,0x900af,0x80007,0x80087,0x80047,0x900ef,0x70107,0x8005f,0x8001f,0x9009f,0x70117,0x8007f,0x8003f,0x900df,0x7010f,0x8006f,0x8002f,0x900bf,0x8000f,0x8008f,0x8004f,0x900ff]),9];var fixedDistCodeTab=[new Uint32Array([0x50000,0x50010,0x50008,0x50018,0x50004,0x50014,0x5000c,0x5001c,0x50002,0x50012,0x5000a,0x5001a,0x50006,0x50016,0x5000e,0x00000,0x50001,0x50011,0x50009,0x50019,0x50005,0x50015,0x5000d,0x5001d,0x50003,0x50013,0x5000b,0x5001b,0x50007,0x50017,0x5000f,0x00000]),5];function error(e){throw new Error(e);}function constructor(bytes){ //var bytes = stream.getBytes();
	var bytesPos=0;var cmf=bytes[bytesPos++];var flg=bytes[bytesPos++];if(cmf == -1 || flg == -1)error('Invalid header in flate stream');if((cmf & 0x0f) != 0x08)error('Unknown compression method in flate stream');if(((cmf << 8) + flg) % 31 != 0)error('Bad FCHECK in flate stream');if(flg & 0x20)error('FDICT bit set in flate stream');this.bytes = bytes;this.bytesPos = bytesPos;this.codeSize = 0;this.codeBuf = 0;DecodeStream.call(this);}constructor.prototype = Object.create(DecodeStream.prototype);constructor.prototype.getBits = function(bits){var codeSize=this.codeSize;var codeBuf=this.codeBuf;var bytes=this.bytes;var bytesPos=this.bytesPos;var b;while(codeSize < bits) {if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad encoding in flate stream');codeBuf |= b << codeSize;codeSize += 8;}b = codeBuf & (1 << bits) - 1;this.codeBuf = codeBuf >> bits;this.codeSize = codeSize -= bits;this.bytesPos = bytesPos;return b;};constructor.prototype.getCode = function(table){var codes=table[0];var maxLen=table[1];var codeSize=this.codeSize;var codeBuf=this.codeBuf;var bytes=this.bytes;var bytesPos=this.bytesPos;while(codeSize < maxLen) {var b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad encoding in flate stream');codeBuf |= b << codeSize;codeSize += 8;}var code=codes[codeBuf & (1 << maxLen) - 1];var codeLen=code >> 16;var codeVal=code & 0xffff;if(codeSize == 0 || codeSize < codeLen || codeLen == 0)error('Bad encoding in flate stream');this.codeBuf = codeBuf >> codeLen;this.codeSize = codeSize - codeLen;this.bytesPos = bytesPos;return codeVal;};constructor.prototype.generateHuffmanTable = function(lengths){var n=lengths.length; // find max code length
	var maxLen=0;for(var i=0;i < n;++i) {if(lengths[i] > maxLen)maxLen = lengths[i];} // build the table
	var size=1 << maxLen;var codes=new Uint32Array(size);for(var len=1,code=0,skip=2;len <= maxLen;++len,code <<= 1,skip <<= 1) {for(var val=0;val < n;++val) {if(lengths[val] == len){ // bit-reverse the code
	var code2=0;var t=code;for(var i=0;i < len;++i) {code2 = code2 << 1 | t & 1;t >>= 1;} // fill the table entries
	for(var i=code2;i < size;i += skip) codes[i] = len << 16 | val;++code;}}}return [codes,maxLen];};constructor.prototype.readBlock = function(){function repeat(stream,array,len,offset,what){var repeat=stream.getBits(len) + offset;while(repeat-- > 0) array[i++] = what;} // read block header
	var hdr=this.getBits(3);if(hdr & 1)this.eof = true;hdr >>= 1;if(hdr == 0){ // uncompressed block
	var bytes=this.bytes;var bytesPos=this.bytesPos;var b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');var blockLen=b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');blockLen |= b << 8;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');var check=b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');check |= b << 8;if(check != (~blockLen & 0xffff))error('Bad uncompressed block length in flate stream');this.codeBuf = 0;this.codeSize = 0;var bufferLength=this.bufferLength;var buffer=this.ensureBuffer(bufferLength + blockLen);var end=bufferLength + blockLen;this.bufferLength = end;for(var n=bufferLength;n < end;++n) {if(typeof (b = bytes[bytesPos++]) == 'undefined'){this.eof = true;break;}buffer[n] = b;}this.bytesPos = bytesPos;return;}var litCodeTable;var distCodeTable;if(hdr == 1){ // compressed block, fixed codes
	litCodeTable = fixedLitCodeTab;distCodeTable = fixedDistCodeTab;}else if(hdr == 2){ // compressed block, dynamic codes
	var numLitCodes=this.getBits(5) + 257;var numDistCodes=this.getBits(5) + 1;var numCodeLenCodes=this.getBits(4) + 4; // build the code lengths code table
	var codeLenCodeLengths=Array(codeLenCodeMap.length);var i=0;while(i < numCodeLenCodes) codeLenCodeLengths[codeLenCodeMap[i++]] = this.getBits(3);var codeLenCodeTab=this.generateHuffmanTable(codeLenCodeLengths); // build the literal and distance code tables
	var len=0;var i=0;var codes=numLitCodes + numDistCodes;var codeLengths=new Array(codes);while(i < codes) {var code=this.getCode(codeLenCodeTab);if(code == 16){repeat(this,codeLengths,2,3,len);}else if(code == 17){repeat(this,codeLengths,3,3,len = 0);}else if(code == 18){repeat(this,codeLengths,7,11,len = 0);}else {codeLengths[i++] = len = code;}}litCodeTable = this.generateHuffmanTable(codeLengths.slice(0,numLitCodes));distCodeTable = this.generateHuffmanTable(codeLengths.slice(numLitCodes,codes));}else {error('Unknown block type in flate stream');}var buffer=this.buffer;var limit=buffer?buffer.length:0;var pos=this.bufferLength;while(true) {var code1=this.getCode(litCodeTable);if(code1 < 256){if(pos + 1 >= limit){buffer = this.ensureBuffer(pos + 1);limit = buffer.length;}buffer[pos++] = code1;continue;}if(code1 == 256){this.bufferLength = pos;return;}code1 -= 257;code1 = lengthDecode[code1];var code2=code1 >> 16;if(code2 > 0)code2 = this.getBits(code2);var len=(code1 & 0xffff) + code2;code1 = this.getCode(distCodeTable);code1 = distDecode[code1];code2 = code1 >> 16;if(code2 > 0)code2 = this.getBits(code2);var dist=(code1 & 0xffff) + code2;if(pos + len >= limit){buffer = this.ensureBuffer(pos + len);limit = buffer.length;}for(var k=0;k < len;++k,++pos) buffer[pos] = buffer[pos - dist];}};return constructor;})(); /**
	 * JavaScript Polyfill functions for jsPDF
	 * Collected from public resources by
	 * https://github.com/diegocr
	 */(function(global){var b64='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';if(typeof global.btoa === 'undefined'){global.btoa = function(data){ //  discuss at: http://phpjs.org/functions/base64_encode/
	// original by: Tyler Akins (http://rumkin.com)
	// improved by: Bayron Guevara
	// improved by: Thunder.m
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Rafal Kukawski (http://kukawski.pl)
	// bugfixed by: Pellentesque Malesuada
	//   example 1: base64_encode('Kevin van Zonneveld');
	//   returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
	var o1,o2,o3,h1,h2,h3,h4,bits,i=0,ac=0,enc='',tmp_arr=[];if(!data){return data;}do { // pack three octets into four hexets
	o1 = data.charCodeAt(i++);o2 = data.charCodeAt(i++);o3 = data.charCodeAt(i++);bits = o1 << 16 | o2 << 8 | o3;h1 = bits >> 18 & 0x3f;h2 = bits >> 12 & 0x3f;h3 = bits >> 6 & 0x3f;h4 = bits & 0x3f; // use hexets to index into b64, and append result to encoded string
	tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);}while(i < data.length);enc = tmp_arr.join('');var r=data.length % 3;return (r?enc.slice(0,r - 3):enc) + '==='.slice(r || 3);};}if(typeof global.atob === 'undefined'){global.atob = function(data){ //  discuss at: http://phpjs.org/functions/base64_decode/
	// original by: Tyler Akins (http://rumkin.com)
	// improved by: Thunder.m
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	//    input by: Aman Gupta
	//    input by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: Onno Marsman
	// bugfixed by: Pellentesque Malesuada
	// bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	//   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
	//   returns 1: 'Kevin van Zonneveld'
	var o1,o2,o3,h1,h2,h3,h4,bits,i=0,ac=0,dec='',tmp_arr=[];if(!data){return data;}data += '';do { // unpack four hexets into three octets using index points in b64
	h1 = b64.indexOf(data.charAt(i++));h2 = b64.indexOf(data.charAt(i++));h3 = b64.indexOf(data.charAt(i++));h4 = b64.indexOf(data.charAt(i++));bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;o1 = bits >> 16 & 0xff;o2 = bits >> 8 & 0xff;o3 = bits & 0xff;if(h3 == 64){tmp_arr[ac++] = String.fromCharCode(o1);}else if(h4 == 64){tmp_arr[ac++] = String.fromCharCode(o1,o2);}else {tmp_arr[ac++] = String.fromCharCode(o1,o2,o3);}}while(i < data.length);dec = tmp_arr.join('');return dec;};}if(!Array.prototype.map){Array.prototype.map = function(fun /*, thisArg */){if(this === void 0 || this === null || typeof fun !== "function")throw new TypeError();var t=Object(this),len=t.length >>> 0,res=new Array(len);var thisArg=arguments.length > 1?arguments[1]:void 0;for(var i=0;i < len;i++) { // NOTE: Absolute correctness would demand Object.defineProperty
	//       be used.  But this method is fairly new, and failure is
	//       possible only if Object.prototype or Array.prototype
	//       has a property |i| (very unlikely), so use a less-correct
	//       but more portable alternative.
	if(i in t)res[i] = fun.call(thisArg,t[i],i,t);}return res;};}if(!Array.isArray){Array.isArray = function(arg){return Object.prototype.toString.call(arg) === '[object Array]';};}if(!Array.prototype.forEach){Array.prototype.forEach = function(fun,thisArg){"use strict";if(this === void 0 || this === null || typeof fun !== "function")throw new TypeError();var t=Object(this),len=t.length >>> 0;for(var i=0;i < len;i++) {if(i in t)fun.call(thisArg,t[i],i,t);}};}if(!Object.keys){Object.keys = (function(){'use strict';var hasOwnProperty=Object.prototype.hasOwnProperty,hasDontEnumBug=!({toString:null}).propertyIsEnumerable('toString'),dontEnums=['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor'],dontEnumsLength=dontEnums.length;return function(obj){if(typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)){throw new TypeError();}var result=[],prop,i;for(prop in obj) {if(hasOwnProperty.call(obj,prop)){result.push(prop);}}if(hasDontEnumBug){for(i = 0;i < dontEnumsLength;i++) {if(hasOwnProperty.call(obj,dontEnums[i])){result.push(dontEnums[i]);}}}return result;};})();}if(!String.prototype.trim){String.prototype.trim = function(){return this.replace(/^\s+|\s+$/g,'');};}if(!String.prototype.trimLeft){String.prototype.trimLeft = function(){return this.replace(/^\s+/g,"");};}if(!String.prototype.trimRight){String.prototype.trimRight = function(){return this.replace(/\s+$/g,"");};}})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined);return jsPDF;}); // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var EditWidgetModalContent = (function (_React$Component) {
	    _inherits(EditWidgetModalContent, _React$Component);
	
	    function EditWidgetModalContent(props, context) {
	        _classCallCheck(this, EditWidgetModalContent);
	
	        _get(Object.getPrototypeOf(EditWidgetModalContent.prototype), 'constructor', this).call(this, props, context);
	        this.state = {};
	    }
	
	    _createClass(EditWidgetModalContent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.onRef(this);
	            this.setState({ location: this.props.nodeId });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.onRef(undefined);
	        }
	    }, {
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, parseInt(value)));
	        }
	    }, {
	        key: 'generateOptions',
	        value: function generateOptions(tree, options) {
	            var self = this;
	            if (tree.type != 'customer') {
	                options.push(_react2['default'].createElement(
	                    'option',
	                    { key: tree.id, value: tree.id },
	                    tree.info.name
	                ));
	            }
	            if (tree.children && tree.type != 'meeting_room' && tree.type != 'open_area') {
	                tree.children.forEach(function (element) {
	                    if (element.type != "sensor") {
	                        self.generateOptions(element, options);
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            if (this.props.nodeId == this.state.location || this.props.widgetLocations.includes(this.state.location)) {
	                _toastr2['default'].error("The location already exists, please, choose a different location");
	                return false;
	            } else {
	                this.props.editWidget(this.props.nodeId, this.state.location);
	                return true;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var options = [];
	            this.generateOptions(this.props.tree, options);
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'country' },
	                    _react2['default'].createElement(
	                        'label',
	                        { style: { paddingLeft: "20px", paddingBottom: '5px' } },
	                        'Location'
	                    ),
	                    _react2['default'].createElement(
	                        'select',
	                        { value: this.state.location, id: 'location', onChange: this.changeHandler.bind(this) },
	                        options
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditWidgetModalContent;
	})(_react2['default'].Component);
	
	exports['default'] = EditWidgetModalContent;
	module.exports = exports['default'];

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonSearchbardropdown = __webpack_require__(416);
	
	var _componentsCommonSearchbardropdown2 = _interopRequireDefault(_componentsCommonSearchbardropdown);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _containersTree = __webpack_require__(414);
	
	var _containersTree2 = _interopRequireDefault(_containersTree);
	
	var _reactClickOutside = __webpack_require__(1255);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var SearchContainer = (function (_React$Component) {
	    _inherits(SearchContainer, _React$Component);
	
	    function SearchContainer(props, context) {
	        _classCallCheck(this, SearchContainer);
	
	        _get(Object.getPrototypeOf(SearchContainer.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            showSearch: false,
	            showAllNodes: true
	        };
	        this.showSearchBar = this.showSearchBar.bind(this);
	        this.hideSearchBar = this.hideSearchBar.bind(this);
	        this.addNodeWidget = this.addNodeWidget.bind(this);
	    }
	
	    _createClass(SearchContainer, [{
	        key: 'showSearchBar',
	        value: function showSearchBar() {
	            this.setState({ showSearch: true });
	        }
	    }, {
	        key: 'hideSearchBar',
	        value: function hideSearchBar() {
	            this.setState({ showSearch: false });
	        }
	    }, {
	        key: 'addNodeWidget',
	        value: function addNodeWidget(node) {
	            var user = Object.assign({}, this.props.user);
	            if (!user.details || !user.details.location) {
	                user.details = user.details || {};
	                user.details.location = [node.id];
	                this.props.dispatch((0, _actionsMyaccount.updateUser)(user.username, user));
	            } else if (user.details.location.includes(node.id)) {
	                _toastr2['default'].error("Already has a widget for this location.");
	            } else {
	                user.details.location = [].concat(_toConsumableArray(user.details.location), [node.id]);
	                this.props.dispatch((0, _actionsMyaccount.updateUser)(user.username, user));
	            }
	        }
	    }, {
	        key: 'handleClickOutside',
	        value: function handleClickOutside() {
	            this.hideSearchBar();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            console.log("this.props.tree", this.props.tree);
	            return _react2['default'].createElement(
	                'div',
	                { className: 'grid-widget-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'widget-card widget-card-add box--shadow bg--white  cursor--pointer', onClick: this.showSearchBar },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'flex--vertical--horizontal search-dropdown-root', style: {
	                                minHeight: "525px",
	                                maxHeight: "525px"
	                            } },
	                        this.state.showSearch ? _react2['default'].createElement(
	                            'div',
	                            { className: ' location-dropdown-search-container', style: { width: "100%" } },
	                            _react2['default'].createElement(_componentsCommonSearchbardropdown2['default'], {
	                                onChange: function (node) {
	                                    _this.addNodeWidget(node);
	                                },
	                                tree: this.props.tree,
	                                onOpen: function () {
	                                    _this.setState({
	                                        showAllNodes: false
	                                    });
	                                },
	                                onClose: function () {
	                                    _this.setState({
	                                        showAllNodes: true
	                                    });
	                                }
	                            }),
	                            _react2['default'].createElement(_containersTree2['default'], { showAllNodes: this.state.showAllNodes,
	                                tree: this.props.tree,
	                                statistic: function (node) {
	                                    _this.addNodeWidget(node);_this.hideSearchBar();
	                                } })
	                        ) : _react2['default'].createElement(
	                            'div',
	                            { className: 'widget-card-add-btn cursor--pointer' },
	                            _react2['default'].createElement('span', { className: 'font-icon icon-addicon' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchContainer;
	})(_react2['default'].Component);
	
	exports.SearchContainer = SearchContainer;
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        tree: state.overviewReducer.customerOverview
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactClickOutside2['default'])(SearchContainer));
	/* set height of inner div equal to the height of the card to position center */

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hoistNonReactStatic = __webpack_require__(1256);
	var React = __webpack_require__(38);
	var ReactDOM = __webpack_require__(41);
	
	module.exports = function enhanceWithClickOutside(WrappedComponent) {
	  var componentName = WrappedComponent.displayName || WrappedComponent.name;
	
	  var EnhancedComponent = function (_React$Component) {
	    _inherits(EnhancedComponent, _React$Component);
	
	    function EnhancedComponent(props) {
	      _classCallCheck(this, EnhancedComponent);
	
	      var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));
	
	      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	      return _this;
	    }
	
	    _createClass(EnhancedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        document.addEventListener('click', this.handleClickOutside, true);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.removeEventListener('click', this.handleClickOutside, true);
	      }
	    }, {
	      key: 'handleClickOutside',
	      value: function handleClickOutside(e) {
	        var domNode = this.__domNode;
	        if ((!domNode || !domNode.contains(e.target)) && this.__wrappedInstance && typeof this.__wrappedInstance.handleClickOutside === 'function') {
	          this.__wrappedInstance.handleClickOutside(e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            wrappedRef = _props.wrappedRef,
	            rest = _objectWithoutProperties(_props, ['wrappedRef']);
	
	        return React.createElement(WrappedComponent, _extends({}, rest, {
	          ref: function ref(c) {
	            _this2.__wrappedInstance = c;
	            _this2.__domNode = ReactDOM.findDOMNode(c);
	            wrappedRef && wrappedRef(c);
	          }
	        }));
	      }
	    }]);
	
	    return EnhancedComponent;
	  }(React.Component);
	
	  EnhancedComponent.displayName = 'clickOutside(' + componentName + ')';
	
	  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
	};

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var StickyMenu = (function (_Component) {
	    _inherits(StickyMenu, _Component);
	
	    function StickyMenu(props, context) {
	        _classCallCheck(this, StickyMenu);
	
	        _get(Object.getPrototypeOf(StickyMenu.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            staticMenuHeight: "0px"
	        };
	        this.checkSticky = this.checkSticky.bind(this);
	    }
	
	    _createClass(StickyMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("scroll", this.checkSticky);
	            var staticMenuHeight = this.myStaticMenu.offsetHeight + 'px';
	            this.setState({
	                staticMenuHeight: staticMenuHeight
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("scroll", this.checkSticky);
	        }
	    }, {
	        key: 'checkSticky',
	        value: function checkSticky() {
	            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	            var menuTop = Math.max(65 - scrollTop, 0);
	            this.setState({
	                menuTop: menuTop
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { ref: function (input) {
	                            _this.myStaticMenu = input;
	                        }, className: 'sticky-menu', style: { top: this.props.withStickyHeader ? "65px" : this.state.menuTop } },
	                    this.props.children
	                ),
	                _react2['default'].createElement('div', { className: 'stats-spacing', style: { marginTop: this.props.withStickyHeader ? "0px" : this.state.staticMenuHeight } })
	            );
	        }
	    }]);
	
	    return StickyMenu;
	})(_react.Component);
	
	StickyMenu.propTypes = {
	    withStickyHeader: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = StickyMenu;
	module.exports = exports['default'];

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLocationsSettings = __webpack_require__(1259);
	
	var _componentsPagesLocationsSettings2 = _interopRequireDefault(_componentsPagesLocationsSettings);
	
	var LocationSettings = (function (_React$Component) {
	    _inherits(LocationSettings, _React$Component);
	
	    function LocationSettings() {
	        _classCallCheck(this, LocationSettings);
	
	        _get(Object.getPrototypeOf(LocationSettings.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(LocationSettings, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(_componentsPagesLocationsSettings2['default'], { location: this.props.location });
	        }
	    }]);
	
	    return LocationSettings;
	})(_react2['default'].Component);
	
	exports['default'] = LocationSettings;
	module.exports = exports['default'];

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsNode = __webpack_require__(202);
	
	var _actionsOverview = __webpack_require__(200);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _componentsPagesLocationsSettingsTree = __webpack_require__(1260);
	
	var _componentsPagesLocationsSettingsTree2 = _interopRequireDefault(_componentsPagesLocationsSettingsTree);
	
	var _componentsPagesLocationsModalformcomponentsAddlocationform = __webpack_require__(1262);
	
	var _componentsPagesLocationsModalformcomponentsAddlocationform2 = _interopRequireDefault(_componentsPagesLocationsModalformcomponentsAddlocationform);
	
	var _componentsPagesLocationsModalformcomponentsAddfloorplanform = __webpack_require__(1265);
	
	var _componentsPagesLocationsModalformcomponentsAddfloorplanform2 = _interopRequireDefault(_componentsPagesLocationsModalformcomponentsAddfloorplanform);
	
	var _componentsPagesLocationsModalformcomponentsEditlocationform = __webpack_require__(1266);
	
	var _componentsPagesLocationsModalformcomponentsEditlocationform2 = _interopRequireDefault(_componentsPagesLocationsModalformcomponentsEditlocationform);
	
	var _componentsPagesLocationsModalformcomponentsDeletelocationform = __webpack_require__(1267);
	
	var _componentsPagesLocationsModalformcomponentsDeletelocationform2 = _interopRequireDefault(_componentsPagesLocationsModalformcomponentsDeletelocationform);
	
	var _componentsPagesLocationsModalformcomponentsConfirmdeletelocation = __webpack_require__(1268);
	
	var _componentsPagesLocationsModalformcomponentsConfirmdeletelocation2 = _interopRequireDefault(_componentsPagesLocationsModalformcomponentsConfirmdeletelocation);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var LocationSettings = (function (_React$Component) {
	    _inherits(LocationSettings, _React$Component);
	
	    function LocationSettings(props, context) {
	        _classCallCheck(this, LocationSettings);
	
	        _get(Object.getPrototypeOf(LocationSettings.prototype), 'constructor', this).call(this, props, context);
	        this.openAddLocationForm = this.openAddLocationForm.bind(this);
	        this.confirmDeleteLocation = this.confirmDeleteLocation.bind(this);
	        this.state = {
	            currentNode: {},
	            isAddingLocation: false,
	            isEditing: false,
	            isAddingFloorplan: false,
	            isEditingLocation: false,
	            isDeletingLocation: false,
	            isConfirmingDeleteLocation: false,
	            type: 'only'
	        };
	    }
	
	    _createClass(LocationSettings, [{
	        key: 'openDeleteLocationForm',
	        value: function openDeleteLocationForm(node) {
	            this.setState({ isDeletingLocation: true, currentNode: node });
	        }
	    }, {
	        key: 'closeDeleteLocationForm',
	        value: function closeDeleteLocationForm() {
	            this.setState({ isDeletingLocation: false });
	        }
	    }, {
	        key: 'openEditLocationForm',
	        value: function openEditLocationForm(node) {
	            this.setState({ isEditingLocation: true, currentNode: node });
	        }
	    }, {
	        key: 'closeEditLocationForm',
	        value: function closeEditLocationForm() {
	            this.setState({ isEditingLocation: false });
	        }
	    }, {
	        key: 'openAddFloorplanForm',
	        value: function openAddFloorplanForm(node) {
	            this.setState({ isAddingFloorplan: true, currentNode: node });
	        }
	    }, {
	        key: 'closeAddFloorplanForm',
	        value: function closeAddFloorplanForm() {
	            this.setState({ isAddingFloorplan: false });
	        }
	    }, {
	        key: 'openAddLocationForm',
	        value: function openAddLocationForm(node) {
	            this.setState({ isAddingLocation: true, currentNode: node });
	        }
	    }, {
	        key: 'closeAddLocationForm',
	        value: function closeAddLocationForm() {
	            this.setState({ isAddingLocation: false });
	        }
	    }, {
	        key: 'openEditDropdown',
	        value: function openEditDropdown() {
	            this.setState({ isEditing: true });
	        }
	    }, {
	        key: 'closeEditDropdown',
	        value: function closeEditDropdown() {
	            this.setState({ isEditing: false });
	        }
	    }, {
	        key: 'openConfirmDeleteLocationForm',
	        value: function openConfirmDeleteLocationForm() {
	            this.setState({ isConfirmingDeleteLocation: true });
	        }
	    }, {
	        key: 'closeConfirmDeleteLocationForm',
	        value: function closeConfirmDeleteLocationForm() {
	            this.setState({ isConfirmingDeleteLocation: false });
	        }
	    }, {
	        key: 'addLocation',
	        value: function addLocation(parent, state) {
	            var _this = this;
	
	            var type = "location";
	            switch (state.option) {
	                case "Multi":
	                    type = "multicountry";
	                    break;
	                case "Customer":
	                    type = "customer";
	                    break;
	                default:
	                    type = "location";
	            }
	
	            var newNode = {
	                info: {
	                    name: state.name,
	                    details: {},
	                    location: state.timezone
	                },
	                type: type
	            };
	            if (state.name.length == 0) {
	                _toastr2['default'].error("Name must not be empty.");
	            }
	
	            if (state.location == 'sub') {
	                this.props.dispatch((0, _actionsNode.createNode)(parent.id, newNode)).then(function () {
	                    _this.props.dispatch((0, _actionsOverview.fetchCustomerOverview)());
	                    _toastr2['default'].success('Add ' + newNode.info.name + ' successfully');
	                })['catch'](function (error) {
	                    _toastr2['default'].error(error);
	                });
	            } else {
	                if (parent.type == "multicountry") {
	                    _toastr2['default'].error("Cannot add top location above a multi-country location.");
	                    return;
	                }
	                newNode.type = 'location';
	                this.props.dispatch((0, _actionsNode.createNode)(parent.parent.id, newNode)).then(function (response) {
	                    _this.props.dispatch((0, _actionsNode.setParent)(parent.id, response.id)).then(function () {
	                        _this.props.dispatch((0, _actionsOverview.fetchCustomerOverview)());
	                        _toastr2['default'].success('Add ' + newNode.info.name + ' successfully');
	                    })['catch'](function (error) {
	                        _toastr2['default'].error(error);
	                    });
	                })['catch'](function (error) {
	                    _toastr2['default'].error(error);
	                });
	            }
	        }
	    }, {
	        key: 'deleteLocation',
	        value: function deleteLocation(node, type) {
	            if (type == 'all') {
	                this.setState({ type: 'all' });
	            } else {
	                this.setState({ type: 'only' });
	            }
	            this.closeDeleteLocationForm();
	            this.openConfirmDeleteLocationForm();
	        }
	    }, {
	        key: 'confirmDeleteLocation',
	        value: function confirmDeleteLocation(node) {
	            var _this2 = this;
	
	            if (this.state.type == 'all' || node.children.length == 0) {
	                this.props.dispatch((0, _actionsNode.deleteNode)(node)).then(function () {
	                    _this2.props.dispatch((0, _actionsOverview.fetchCustomerOverview)());
	                    _toastr2['default'].error(node.info.name + ' has been deleted');
	                })['catch'](function (error) {
	                    _toastr2['default'].error(error);
	                });
	            } else {
	                (function () {
	                    var parent = node.parent;
	                    var length = node.children.length;
	
	                    var _loop = function (i) {
	                        _this2.props.dispatch((0, _actionsNode.setParent)(node.children[i].id, parent.id)).then(function () {
	                            if (i == length - 1) {
	                                _this2.props.dispatch((0, _actionsNode.deleteNode)(node)).then(function () {
	                                    _this2.props.dispatch((0, _actionsOverview.fetchCustomerOverview)());
	                                    _toastr2['default'].error(node.info.name + ' has been deleted');
	                                })['catch'](function (error) {
	                                    _toastr2['default'].error(error);
	                                });
	                            }
	                        })['catch'](function (error) {
	                            _toastr2['default'].error(error);
	                        });
	                    };
	
	                    for (var i = 0; i < length; i++) {
	                        _loop(i);
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'updateLocation',
	        value: function updateLocation(node, state) {
	            var _this3 = this;
	
	            if (!state.name && !state.timezone && !state.country) {
	                _toastr2['default'].info("Nothing changed");
	            } else {
	                var newNode = {
	                    id: node.id,
	                    info: {
	                        name: state.name,
	                        location: state.timezone
	                    }
	                };
	                if (state.country == "Multi") {
	                    newNode.info.type = "multicountry";
	                }
	                this.props.dispatch((0, _actionsNode.updateNode)(newNode)).then(function () {
	                    _this3.closeEditLocationForm();
	                });
	            }
	        }
	    }, {
	        key: 'uploadImage',
	        value: function uploadImage(node, image, state) {
	            var _this4 = this;
	
	            if (!node.info.hasfloorplan && state.hasfloorplan && state.useownfp && !image) {
	                return [false, "This location doesn't have any floorplan yet. Please upload a new one !"];
	            }
	            if (image) {
	                this.props.dispatch((0, _actionsNode.uploadFloorplanView)(node, image, state.type)).then(function () {
	                    _this4.closeAddFloorplanForm();
	                });
	                return [true, ""];
	            } else {
	                var hasfloorplan = state.hasfloorplan;
	                var useownfp = hasfloorplan && state.useownfp;
	                var newNode = {
	                    id: node.id,
	                    info: {
	                        name: node.info.name,
	                        hasfloorplan: hasfloorplan,
	                        useownfp: useownfp
	                    },
	                    type: state.type
	                };
	                this.props.dispatch((0, _actionsNode.updateNode)(newNode)).then(function () {
	                    _this4.closeAddFloorplanForm();
	                });
	                return [true, ""];
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'location-settings-page overwrite--modal--depth' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: false
	                    },
	                    _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                        overviewIsActive: false,
	                        comparisonIsActive: false,
	                        onlyLeftMenu: true
	                    }),
	                    _react2['default'].createElement(_componentsCommonStatsmenu2['default'], { leftItemBold: 'Location Settings' })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content page-content_padding-modifier' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'display--flex__flex--center' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'white-box-container box--shadow bg--white', style: { width: "50%" } },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'display--flex clearfix' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'display--flex__flex--start--center' },
	                                    _react2['default'].createElement(
	                                        'h3',
	                                        null,
	                                        this.props.tree.info.name
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'flex__end' },
	                                    _react2['default'].createElement(
	                                        'a',
	                                        { onClick: function () {
	                                                return _this5.openAddLocationForm(_this5.props.tree);
	                                            },
	                                            className: 'button btn--green add--loc--btn__icon--text ', 'data-toggle': 'modal' },
	                                        _react2['default'].createElement('span', { className: 'font-icon icon-addicon' }),
	                                        'Add ',
	                                        this.props.tree.type == "root" ? "Customer" : "Location"
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(_componentsPagesLocationsSettingsTree2['default'], { openAddLocationForm: this.openAddLocationForm.bind(this), style: 'location__list clearfix',
	                                tree: this.props.tree,
	                                openAddFloorplanForm: this.openAddFloorplanForm.bind(this),
	                                closeAddFloorplanForm: this.closeAddFloorplanForm.bind(this),
	                                openEditLocationForm: this.openEditLocationForm.bind(this),
	                                closeEditLocationForm: this.closeEditLocationForm.bind(this),
	                                openDeleteLocationForm: this.openDeleteLocationForm.bind(this),
	                                closeDeleteLocationForm: this.closeDeleteLocationForm.bind(this),
	                                location: this.props.location
	                            }),
	                            this.state.isAddingLocation && _react2['default'].createElement(_componentsPagesLocationsModalformcomponentsAddlocationform2['default'], {
	                                submit: this.addLocation.bind(this),
	                                node: this.state.currentNode,
	                                tree: this.props.tree,
	                                isAddingLocation: this.state.isAddingLocation,
	                                closeAddLocationForm: this.closeAddLocationForm.bind(this) }),
	                            this.state.isAddingFloorplan && _react2['default'].createElement(_componentsPagesLocationsModalformcomponentsAddfloorplanform2['default'], { submit: this.uploadImage.bind(this), node: this.state.currentNode, isAddingFloorplan: this.state.isAddingFloorplan, closeAddFloorplanForm: this.closeAddFloorplanForm.bind(this) }),
	                            this.state.isEditingLocation && _react2['default'].createElement(_componentsPagesLocationsModalformcomponentsEditlocationform2['default'], { submit: this.updateLocation.bind(this), node: this.state.currentNode, isEditingLocation: this.state.isEditingLocation, closeEditLocationForm: this.closeEditLocationForm.bind(this) }),
	                            this.state.isDeletingLocation && _react2['default'].createElement(_componentsPagesLocationsModalformcomponentsDeletelocationform2['default'], { submit: this.deleteLocation.bind(this), node: this.state.currentNode, isDeletingLocation: this.state.isDeletingLocation, closeDeleteLocationForm: this.closeDeleteLocationForm.bind(this) }),
	                            this.state.isConfirmingDeleteLocation && _react2['default'].createElement(_componentsPagesLocationsModalformcomponentsConfirmdeletelocation2['default'], { submit: this.confirmDeleteLocation.bind(this), type: this.state.type == 'all', node: this.state.currentNode, isConfirmingDeleteLocation: this.state.isConfirmingDeleteLocation, closeConfirmDeleteLocationForm: this.closeConfirmDeleteLocationForm.bind(this) })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LocationSettings;
	})(_react2['default'].Component);
	
	exports.LocationSettings = LocationSettings;
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        currentSensor: state.nodeReducer.map,
	        tree: state.overviewReducer.customerOverview
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocationSettings);

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLocationsSettingsLocation = __webpack_require__(1261);
	
	var _componentsPagesLocationsSettingsLocation2 = _interopRequireDefault(_componentsPagesLocationsSettingsLocation);
	
	var Tree = (function (_React$Component) {
	    _inherits(Tree, _React$Component);
	
	    function Tree() {
	        _classCallCheck(this, Tree);
	
	        _get(Object.getPrototypeOf(Tree.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Tree, [{
	        key: 'render',
	        value: function render() {
	            var childNodes;
	            var style = "collapse in";
	            var self = this;
	            if (this.props.tree.children != null && this.props.tree.type != 'meeting_room' && this.props.tree.type != 'open_area') {
	                childNodes = this.props.tree.children.map(function (node, index) {
	                    return _react2['default'].createElement(
	                        _componentsPagesLocationsSettingsLocation2['default'],
	                        {
	                            openAddLocationForm: self.props.openAddLocationForm,
	                            openAddFloorplanForm: self.props.openAddFloorplanForm,
	                            closeAddFloorplanForm: self.props.closeAddFloorplanForm,
	                            openEditLocationForm: self.props.openEditLocationForm,
	                            closeEditLocationForm: self.props.closeEditLocationForm,
	                            closeDeleteLocationForm: self.props.closeDeleteLocationForm,
	                            openDeleteLocationForm: self.props.openDeleteLocationForm, key: index, node: node,
	                            location: self.props.location
	                        },
	                        _react2['default'].createElement(Tree, { openAddLocationForm: self.props.openAddLocationForm, style: style, tree: node,
	                            openAddFloorplanForm: self.props.openAddFloorplanForm,
	                            closeAddFloorplanForm: self.props.closeAddFloorplanForm,
	                            openEditLocationForm: self.props.openEditLocationForm,
	                            closeEditLocationForm: self.props.closeEditLocationForm,
	                            closeDeleteLocationForm: self.props.closeDeleteLocationForm,
	                            openDeleteLocationForm: self.props.openDeleteLocationForm,
	                            location: self.props.location
	                        })
	                    );
	                });
	            }
	            return _react2['default'].createElement(
	                'ul',
	                { className: this.props.style },
	                childNodes
	            );
	        }
	    }]);
	
	    return Tree;
	})(_react2['default'].Component);
	
	exports['default'] = Tree;
	module.exports = exports['default'];

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var Location = (function (_React$Component) {
	    _inherits(Location, _React$Component);
	
	    function Location(props, context) {
	        _classCallCheck(this, Location);
	
	        _get(Object.getPrototypeOf(Location.prototype), 'constructor', this).call(this, props, context);
	        var node = this.props.nodeMap[this.props.location.query["n"]];
	        var qnode = node;
	        var open = false;
	        if (node) {
	            while (node.parent) {
	                if (node.parent.id == this.props.node.id) {
	                    open = true;
	                    break;
	                }
	                node = node.parent;
	            }
	        }
	
	        this.state = {
	            isShowingChildren: open,
	            isShowingEdit: false,
	            qnode: qnode
	        };
	    }
	
	    _createClass(Location, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.qnode) {
	                if (this.state.qnode.id == this.props.node.id) {
	                    this.name.scrollIntoView();
	                }
	            }
	        }
	    }, {
	        key: 'showChildren',
	        value: function showChildren() {
	            this.setState({ isShowingChildren: !this.state.isShowingChildren });
	        }
	    }, {
	        key: 'showEditDropdown',
	        value: function showEditDropdown() {
	            this.setState({ isShowingEdit: !this.state.isShowingEdit });
	        }
	    }, {
	        key: 'closeEditDropdown',
	        value: function closeEditDropdown() {
	            this.setState({ isShowingEdit: false });
	        }
	    }, {
	        key: 'renderIcon',
	        value: function renderIcon() {
	            var src;
	            switch (this.props.node.type) {
	                case "meeting_room":
	                    src = "src/assets/icons/baseline-group-24px.svg";
	                    return _react2['default'].createElement('img', { src: src, style: { marginRight: "5px" }, alt: 'toTopArrowUp' });
	                case "open_area":
	                    src = "src/assets/icons/baseline-nature_people-24px.svg";
	                    return _react2['default'].createElement('img', { src: src, style: { marginRight: "5px" }, alt: 'toTopArrowUp' });
	                case "location":
	                case "multicountry":
	                case "customer":
	                    src = this.state.isShowingChildren ? "src/assets/icons/baseline-remove_circle_outline-24px.svg" : "src/assets/icons/baseline-add_circle_outline-24px.svg";
	                    return _react2['default'].createElement('img', { src: src, style: { marginRight: "5px" } });
	                default:
	                    return null;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var icon = this.renderIcon();
	            var canBeParent = this.props.node.type != "open_area" && this.props.node.type != "meeting_room" && this.props.node.type != "sensor";
	            return _react2['default'].createElement(
	                'li',
	                { className: 'location__list__item-wrapper' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'location__list__item clearfix' },
	                    _react2['default'].createElement(
	                        'div',
	                        { ref: function (e) {
	                                return _this.name = e;
	                            }, className: "list__item__name pull-left" + (this.state.qnode && this.props.node.id == this.state.qnode.id ? " highlight" : ""), onClick: this.showChildren.bind(this) },
	                        icon,
	                        this.props.node.info.name,
	                        this.props.node.info.useownfp && _react2['default'].createElement(
	                            'div',
	                            { 'data-tooltip': 'Use its own floor plan. If this symbol is not showed, parent\'s floor plan is used instead.' },
	                            _react2['default'].createElement(
	                                'i',
	                                { className: 'material-icons add--loc--icons material-icons_size' },
	                                'picture_in_picture'
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'list__item__options pull-right' },
	                        canBeParent && _react2['default'].createElement(
	                            'i',
	                            { 'data-tooltip': 'Add location', onClick: function () {
	                                    return _this.props.openAddLocationForm(_this.props.node);
	                                }, className: ' material-icons_size material-icons add--loc--icons cursor--pointer pull-left', 'data-toggle': 'modal' },
	                            'add_location'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'edit__btn pull-left' },
	                            _react2['default'].createElement(
	                                'i',
	                                { 'data-tooltip': 'Edit', className: 'material-icons_size edit--icons material-icons cursor--pointer', id: 'dLabel', onClick: this.showEditDropdown.bind(this) },
	                                'edit'
	                            ),
	                            this.state.isShowingEdit && _react2['default'].createElement(
	                                'div',
	                                { 'aria-labelledby': 'dLabel' },
	                                _react2['default'].createElement('div', { style: { backgroundColor: 'transparent' }, className: "modals__overlay" + (this.state.isShowingEdit ? "" : " closed"), onClick: this.closeEditDropdown.bind(this) }),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: "dropdown-menu settings-location__dropdown " + (this.state.isShowingEdit ? "" : " closed") },
	                                    _react2['default'].createElement(
	                                        'ul',
	                                        null,
	                                        _react2['default'].createElement(
	                                            'li',
	                                            { onClick: function () {
	                                                    _this.closeEditDropdown();
	                                                    _this.props.openEditLocationForm(_this.props.node);
	                                                } },
	                                            _react2['default'].createElement(
	                                                'a',
	                                                null,
	                                                'Edit Location'
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'li',
	                                            { onClick: function () {
	                                                    _this.closeEditDropdown();
	                                                    _this.props.openAddFloorplanForm(_this.props.node);
	                                                } },
	                                            ' ',
	                                            _react2['default'].createElement(
	                                                'a',
	                                                null,
	                                                'Edit Floor Plan'
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'li',
	                                            null,
	                                            _react2['default'].createElement(
	                                                _reactRouter.Link,
	                                                { to: 'live/' + this.props.node.id },
	                                                'Add Sensor'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'i',
	                            { 'data-tooltip': 'Delete', className: 'material-icons_size delete--icons material-icons cursor--pointer red-500 pull-left', onClick: function () {
	                                    return _this.props.openDeleteLocationForm(_this.props.node);
	                                } },
	                            'delete_forever'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: !this.state.isShowingChildren ? "hidden" : "" },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Location;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        nodeMap: state.overviewReducer.nodeMap
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Location);
	module.exports = exports['default'];

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _countriesAndTimezones = __webpack_require__(1263);
	
	var _countriesAndTimezones2 = _interopRequireDefault(_countriesAndTimezones);
	
	//import getCountryName, { isoCountries } from '../../countries';
	
	var AddLocationForm = (function (_React$Component) {
	    _inherits(AddLocationForm, _React$Component);
	
	    function AddLocationForm(props, context) {
	        _classCallCheck(this, AddLocationForm);
	
	        _get(Object.getPrototypeOf(AddLocationForm.prototype), 'constructor', this).call(this, props, context);
	        var node = this.props.node;
	        this.state = {
	            option: node.type == "root" ? "Customer" : "Country",
	            name: "",
	            location: 'sub',
	            country: node.type == "multicountry" ? "Multi" : _countriesAndTimezones2['default'].getCountriesForTimezone(node.info.location)[0].id,
	            timezone: node.info.location
	        };
	    }
	
	    _createClass(AddLocationForm, [{
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, value));
	            if (key == 'country') {
	                if (value != this.state.country) {
	                    var locations = this.getTimeZonesOfCountry(value);
	                    this.setState({ timezone: locations[0] });
	                }
	            }
	        }
	    }, {
	        key: 'generateCountryOptions',
	        value: function generateCountryOptions() {
	            var parent = this.props.node;
	            var parentCode = parent.type == "multicountry" ? "Multi" : _countriesAndTimezones2['default'].getCountriesForTimezone(parent.info.location)[0].id;
	            var countries = _countriesAndTimezones2['default'].getAllCountries();
	            if (parentCode == 'Multi' || parent.type == "customer") {
	                var codes = Object.keys(countries);
	                codes.sort(function (a, b) {
	                    return countries[a].name.localeCompare(countries[b].name);
	                }); // sort country codes by full name.
	                return codes.map(function (code, index) {
	                    return _react2['default'].createElement(
	                        'option',
	                        { key: code, value: code },
	                        countries[code].name
	                    );
	                });
	            } else {
	                return _react2['default'].createElement(
	                    'option',
	                    { value: parentCode },
	                    countries[parentCode].name
	                );
	            }
	        }
	    }, {
	        key: 'getTimeZonesOfCountry',
	        value: function getTimeZonesOfCountry(country) {
	            return _countriesAndTimezones2['default'].getTimezonesForCountry(country).map(function (element) {
	                return element.name;
	            });
	        }
	    }, {
	        key: 'generateTimeZoneOptions',
	        value: function generateTimeZoneOptions() {
	            var options = this.getTimeZonesOfCountry(this.state.country);
	            return options.map(function (element, index) {
	                return _react2['default'].createElement(
	                    'option',
	                    { key: index, value: element },
	                    element
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var isArea = this.props.node.type == 'meeting_room' || this.props.node.type == 'open_area';
	            var node = this.props.node;
	            var allowMulti = this.state.location == "sub" && node.type == 'customer' || this.state.location == "top" && node.parent.type == 'customer';
	            var noTop = node.id == _store2['default'].getState().myAccountReducer.user.rootnodeid;
	            var timezones = this.generateTimeZoneOptions();
	            var countries = this.generateCountryOptions();
	            var addCustomer = this.props.node.type == "root";
	            if (addCustomer) {
	                noTop = true;
	                allowMulti = false;
	            }
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement('div', { className: "modals__overlay" + (this.props.isAddingLocation ? "" : " closed"), onClick: this.props.closeAddLocationForm }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: "modals__content " + (this.props.isAddingLocation ? "" : " closed") },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__header' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'close', onClick: this.props.closeAddLocationForm },
	                            '×'
	                        ),
	                        _react2['default'].createElement(
	                            'h4',
	                            { className: 'modals__content__header__title' },
	                            'Add Location'
	                        )
	                    ),
	                    !isArea ? _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__body settings-add-location-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'zone-type' },
	                            allowMulti && _react2['default'].createElement(
	                                'label',
	                                { htmlFor: 'country' },
	                                _react2['default'].createElement('input', { className: 'zone-radio', onChange: this.changeHandler.bind(this), id: 'option', value: 'Country', type: 'radio', name: 'zone', checked: this.state.option == 'Country' }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Country'
	                                )
	                            ),
	                            allowMulti && _react2['default'].createElement(
	                                'label',
	                                { htmlFor: 'multi' },
	                                _react2['default'].createElement('input', { className: 'zone-radio', onChange: this.changeHandler.bind(this), id: 'option', value: 'Multi', type: 'radio', name: 'zone', checked: this.state.option == 'Multi' }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Multi-Country Region'
	                                )
	                            ),
	                            addCustomer && _react2['default'].createElement(
	                                'label',
	                                { htmlFor: 'customer' },
	                                _react2['default'].createElement('input', { className: 'zone-radio', onChange: this.changeHandler.bind(this), id: 'option', value: 'Customer', type: 'radio', name: 'zone', checked: this.state.option == 'Customer' }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Customer'
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'user_email' },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Name '
	                                ),
	                                _react2['default'].createElement('input', { type: 'username', id: 'name', onChange: this.changeHandler.bind(this), required: true })
	                            )
	                        ),
	                        noTop || _react2['default'].createElement(
	                            'div',
	                            { className: 'country' },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                'Location'
	                            ),
	                            _react2['default'].createElement(
	                                'select',
	                                { value: this.state.location, id: 'location', onChange: this.changeHandler.bind(this) },
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: 'sub', disabled: this.state.option == "Multi" && node.type != "customer" },
	                                    'Sub location'
	                                ),
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: 'top' },
	                                    'Top location'
	                                )
	                            )
	                        ),
	                        this.state.option == 'Multi' || this.state.option == 'Customer' || _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'country' },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    'Country'
	                                ),
	                                _react2['default'].createElement(
	                                    'select',
	                                    { id: 'country', value: this.state.country, onChange: this.changeHandler.bind(this) },
	                                    countries
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'timezone' },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    'Timezone'
	                                ),
	                                _react2['default'].createElement(
	                                    'select',
	                                    { value: this.state.timezone, id: 'timezone', onChange: this.changeHandler.bind(this) },
	                                    timezones
	                                )
	                            )
	                        )
	                    ) : _react2['default'].createElement(
	                        'p',
	                        { className: 'add-location-form-notification' },
	                        ' Sorry, You cannot add sublocation of area/meeting room'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__footer' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-default', onClick: this.props.closeAddLocationForm, type: 'button', 'data-dismiss': 'modal' },
	                            'Cancel'
	                        ),
	                        isArea || _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-success', onClick: function () {
	                                    _this.props.submit(node, _this.state);
	                                    _this.props.closeAddLocationForm();
	                                }, type: 'button' },
	                            'Confirm'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddLocationForm;
	})(_react2['default'].Component);
	
	exports['default'] = AddLocationForm;
	module.exports = exports['default'];

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	var rawData = __webpack_require__(1264);
	
	var countriesAndTimezones = {
	  raw: rawData,
	
	  getAllCountries: function() {
	    return rawData.countries;
	  },
	
	  getAllTimezones: function() {
	    return rawData.timezones;
	  },
	
	  getTimezonesForCountry: function(countryId) {
	    var countries = this.getAllCountries();
	    var timezones = this.getAllTimezones();
	    var timezoneIds = (countries[countryId] || {}).timezones || [];
	    return timezoneIds.map(function(timezoneId) {
	      return timezones[timezoneId];
	    });
	  },
	
	  getCountriesForTimezone: function(timezoneId) {
	    var countries = this.getAllCountries();
	    var timezones = this.getAllTimezones();
	    var countryIds = (timezones[timezoneId] || {}).countries || [];
	    return countryIds.map(function(countryId) {
	      return countries[countryId];
	    });
	  }
	};
	
	module.exports = countriesAndTimezones;

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	module.exports = {"countries":{"AD":{"id":"AD","name":"Andorra","timezones":["Europe/Andorra"]},"AE":{"id":"AE","name":"United Arab Emirates","timezones":["Asia/Dubai"]},"AF":{"id":"AF","name":"Afghanistan","timezones":["Asia/Kabul"]},"AG":{"id":"AG","name":"Antigua & Barbuda","timezones":["America/Port_of_Spain"]},"AI":{"id":"AI","name":"Anguilla","timezones":["America/Port_of_Spain"]},"AL":{"id":"AL","name":"Albania","timezones":["Europe/Tirane"]},"AM":{"id":"AM","name":"Armenia","timezones":["Asia/Yerevan"]},"AO":{"id":"AO","name":"Angola","timezones":["Africa/Lagos"]},"AQ":{"id":"AQ","name":"Antarctica","timezones":["Antarctica/Rothera","Antarctica/Palmer","Antarctica/Mawson","Antarctica/Davis","Antarctica/Casey","Antarctica/Vostok","Antarctica/DumontDUrville","Antarctica/Syowa","Antarctica/Troll","Pacific/Auckland"]},"AR":{"id":"AR","name":"Argentina","timezones":["America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia"]},"AS":{"id":"AS","name":"Samoa (American)","timezones":["Pacific/Pago_Pago"]},"AT":{"id":"AT","name":"Austria","timezones":["Europe/Vienna"]},"AU":{"id":"AU","name":"Australia","timezones":["Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Currie","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla"]},"AW":{"id":"AW","name":"Aruba","timezones":["America/Curacao"]},"AX":{"id":"AX","name":"Åland Islands","timezones":["Europe/Helsinki"]},"AZ":{"id":"AZ","name":"Azerbaijan","timezones":["Asia/Baku"]},"BA":{"id":"BA","name":"Bosnia & Herzegovina","timezones":["Europe/Belgrade"]},"BB":{"id":"BB","name":"Barbados","timezones":["America/Barbados"]},"BD":{"id":"BD","name":"Bangladesh","timezones":["Asia/Dhaka"]},"BE":{"id":"BE","name":"Belgium","timezones":["Europe/Brussels"]},"BF":{"id":"BF","name":"Burkina Faso","timezones":["Africa/Abidjan"]},"BG":{"id":"BG","name":"Bulgaria","timezones":["Europe/Sofia"]},"BH":{"id":"BH","name":"Bahrain","timezones":["Asia/Qatar"]},"BI":{"id":"BI","name":"Burundi","timezones":["Africa/Maputo"]},"BJ":{"id":"BJ","name":"Benin","timezones":["Africa/Lagos"]},"BL":{"id":"BL","name":"St Barthelemy","timezones":["America/Port_of_Spain"]},"BM":{"id":"BM","name":"Bermuda","timezones":["Atlantic/Bermuda"]},"BN":{"id":"BN","name":"Brunei","timezones":["Asia/Brunei"]},"BO":{"id":"BO","name":"Bolivia","timezones":["America/La_Paz"]},"BQ":{"id":"BQ","name":"Caribbean Netherlands","timezones":["America/Curacao"]},"BR":{"id":"BR","name":"Brazil","timezones":["America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco"]},"BS":{"id":"BS","name":"Bahamas","timezones":["America/Nassau"]},"BT":{"id":"BT","name":"Bhutan","timezones":["Asia/Thimphu"]},"BW":{"id":"BW","name":"Botswana","timezones":["Africa/Maputo"]},"BY":{"id":"BY","name":"Belarus","timezones":["Europe/Minsk"]},"BZ":{"id":"BZ","name":"Belize","timezones":["America/Belize"]},"CA":{"id":"CA","name":"Canada","timezones":["America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Resolute","America/Atikokan","America/Rankin_Inlet","America/Winnipeg","America/Rainy_River","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Vancouver","America/Whitehorse","America/Dawson"]},"CC":{"id":"CC","name":"Cocos (Keeling) Islands","timezones":["Indian/Cocos"]},"CD":{"id":"CD","name":"Congo (Dem. Rep.)","timezones":["Africa/Maputo","Africa/Lagos"]},"CF":{"id":"CF","name":"Central African Rep.","timezones":["Africa/Lagos"]},"CG":{"id":"CG","name":"Congo (Rep.)","timezones":["Africa/Lagos"]},"CH":{"id":"CH","name":"Switzerland","timezones":["Europe/Zurich"]},"CI":{"id":"CI","name":"Côte d'Ivoire","timezones":["Africa/Abidjan"]},"CK":{"id":"CK","name":"Cook Islands","timezones":["Pacific/Rarotonga"]},"CL":{"id":"CL","name":"Chile","timezones":["America/Santiago","Pacific/Easter"]},"CM":{"id":"CM","name":"Cameroon","timezones":["Africa/Lagos"]},"CN":{"id":"CN","name":"China","timezones":["Asia/Shanghai","Asia/Urumqi"]},"CO":{"id":"CO","name":"Colombia","timezones":["America/Bogota"]},"CR":{"id":"CR","name":"Costa Rica","timezones":["America/Costa_Rica"]},"CU":{"id":"CU","name":"Cuba","timezones":["America/Havana"]},"CV":{"id":"CV","name":"Cape Verde","timezones":["Atlantic/Cape_Verde"]},"CW":{"id":"CW","name":"Curacao","timezones":["America/Curacao"]},"CX":{"id":"CX","name":"Christmas Island","timezones":["Indian/Christmas"]},"CY":{"id":"CY","name":"Cyprus","timezones":["Asia/Nicosia"]},"CZ":{"id":"CZ","name":"Czech Republic","timezones":["Europe/Prague"]},"DE":{"id":"DE","name":"Germany","timezones":["Europe/Zurich","Europe/Berlin"]},"DJ":{"id":"DJ","name":"Djibouti","timezones":["Africa/Nairobi"]},"DK":{"id":"DK","name":"Denmark","timezones":["Europe/Copenhagen"]},"DM":{"id":"DM","name":"Dominica","timezones":["America/Port_of_Spain"]},"DO":{"id":"DO","name":"Dominican Republic","timezones":["America/Santo_Domingo"]},"DZ":{"id":"DZ","name":"Algeria","timezones":["Africa/Algiers"]},"EC":{"id":"EC","name":"Ecuador","timezones":["America/Guayaquil","Pacific/Galapagos"]},"EE":{"id":"EE","name":"Estonia","timezones":["Europe/Tallinn"]},"EG":{"id":"EG","name":"Egypt","timezones":["Africa/Cairo"]},"EH":{"id":"EH","name":"Western Sahara","timezones":["Africa/El_Aaiun"]},"ER":{"id":"ER","name":"Eritrea","timezones":["Africa/Nairobi"]},"ES":{"id":"ES","name":"Spain","timezones":["Europe/Madrid","Africa/Ceuta","Atlantic/Canary"]},"ET":{"id":"ET","name":"Ethiopia","timezones":["Africa/Nairobi"]},"FI":{"id":"FI","name":"Finland","timezones":["Europe/Helsinki"]},"FJ":{"id":"FJ","name":"Fiji","timezones":["Pacific/Fiji"]},"FK":{"id":"FK","name":"Falkland Islands","timezones":["Atlantic/Stanley"]},"FM":{"id":"FM","name":"Micronesia","timezones":["Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae"]},"FO":{"id":"FO","name":"Faroe Islands","timezones":["Atlantic/Faroe"]},"FR":{"id":"FR","name":"France","timezones":["Europe/Paris"]},"GA":{"id":"GA","name":"Gabon","timezones":["Africa/Lagos"]},"GB":{"id":"GB","name":"Britain (UK)","timezones":["Europe/London"]},"GD":{"id":"GD","name":"Grenada","timezones":["America/Port_of_Spain"]},"GE":{"id":"GE","name":"Georgia","timezones":["Asia/Tbilisi"]},"GF":{"id":"GF","name":"French Guiana","timezones":["America/Cayenne"]},"GG":{"id":"GG","name":"Guernsey","timezones":["Europe/London"]},"GH":{"id":"GH","name":"Ghana","timezones":["Africa/Accra"]},"GI":{"id":"GI","name":"Gibraltar","timezones":["Europe/Gibraltar"]},"GL":{"id":"GL","name":"Greenland","timezones":["America/Godthab","America/Danmarkshavn","America/Scoresbysund","America/Thule"]},"GM":{"id":"GM","name":"Gambia","timezones":["Africa/Abidjan"]},"GN":{"id":"GN","name":"Guinea","timezones":["Africa/Abidjan"]},"GP":{"id":"GP","name":"Guadeloupe","timezones":["America/Port_of_Spain"]},"GQ":{"id":"GQ","name":"Equatorial Guinea","timezones":["Africa/Lagos"]},"GR":{"id":"GR","name":"Greece","timezones":["Europe/Athens"]},"GS":{"id":"GS","name":"South Georgia & the South Sandwich Islands","timezones":["Atlantic/South_Georgia"]},"GT":{"id":"GT","name":"Guatemala","timezones":["America/Guatemala"]},"GU":{"id":"GU","name":"Guam","timezones":["Pacific/Guam"]},"GW":{"id":"GW","name":"Guinea-Bissau","timezones":["Africa/Bissau"]},"GY":{"id":"GY","name":"Guyana","timezones":["America/Guyana"]},"HK":{"id":"HK","name":"Hong Kong","timezones":["Asia/Hong_Kong"]},"HN":{"id":"HN","name":"Honduras","timezones":["America/Tegucigalpa"]},"HR":{"id":"HR","name":"Croatia","timezones":["Europe/Belgrade"]},"HT":{"id":"HT","name":"Haiti","timezones":["America/Port-au-Prince"]},"HU":{"id":"HU","name":"Hungary","timezones":["Europe/Budapest"]},"ID":{"id":"ID","name":"Indonesia","timezones":["Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura"]},"IE":{"id":"IE","name":"Ireland","timezones":["Europe/Dublin"]},"IL":{"id":"IL","name":"Israel","timezones":["Asia/Jerusalem"]},"IM":{"id":"IM","name":"Isle of Man","timezones":["Europe/London"]},"IN":{"id":"IN","name":"India","timezones":["Asia/Kolkata"]},"IO":{"id":"IO","name":"British Indian Ocean Territory","timezones":["Indian/Chagos"]},"IQ":{"id":"IQ","name":"Iraq","timezones":["Asia/Baghdad"]},"IR":{"id":"IR","name":"Iran","timezones":["Asia/Tehran"]},"IS":{"id":"IS","name":"Iceland","timezones":["Atlantic/Reykjavik"]},"IT":{"id":"IT","name":"Italy","timezones":["Europe/Rome"]},"JE":{"id":"JE","name":"Jersey","timezones":["Europe/London"]},"JM":{"id":"JM","name":"Jamaica","timezones":["America/Jamaica"]},"JO":{"id":"JO","name":"Jordan","timezones":["Asia/Amman"]},"JP":{"id":"JP","name":"Japan","timezones":["Asia/Tokyo"]},"KE":{"id":"KE","name":"Kenya","timezones":["Africa/Nairobi"]},"KG":{"id":"KG","name":"Kyrgyzstan","timezones":["Asia/Bishkek"]},"KH":{"id":"KH","name":"Cambodia","timezones":["Asia/Bangkok"]},"KI":{"id":"KI","name":"Kiribati","timezones":["Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati"]},"KM":{"id":"KM","name":"Comoros","timezones":["Africa/Nairobi"]},"KN":{"id":"KN","name":"St Kitts & Nevis","timezones":["America/Port_of_Spain"]},"KP":{"id":"KP","name":"Korea (North)","timezones":["Asia/Pyongyang"]},"KR":{"id":"KR","name":"Korea (South)","timezones":["Asia/Seoul"]},"KW":{"id":"KW","name":"Kuwait","timezones":["Asia/Riyadh"]},"KY":{"id":"KY","name":"Cayman Islands","timezones":["America/Cayman"]},"KZ":{"id":"KZ","name":"Kazakhstan","timezones":["Asia/Almaty","Asia/Qyzylorda","Asia/Aqtobe","Asia/Aqtau","Asia/Oral"]},"LA":{"id":"LA","name":"Laos","timezones":["Asia/Bangkok"]},"LB":{"id":"LB","name":"Lebanon","timezones":["Asia/Beirut"]},"LC":{"id":"LC","name":"St Lucia","timezones":["America/Port_of_Spain"]},"LI":{"id":"LI","name":"Liechtenstein","timezones":["Europe/Zurich"]},"LK":{"id":"LK","name":"Sri Lanka","timezones":["Asia/Colombo"]},"LR":{"id":"LR","name":"Liberia","timezones":["Africa/Monrovia"]},"LS":{"id":"LS","name":"Lesotho","timezones":["Africa/Johannesburg"]},"LT":{"id":"LT","name":"Lithuania","timezones":["Europe/Vilnius"]},"LU":{"id":"LU","name":"Luxembourg","timezones":["Europe/Luxembourg"]},"LV":{"id":"LV","name":"Latvia","timezones":["Europe/Riga"]},"LY":{"id":"LY","name":"Libya","timezones":["Africa/Tripoli"]},"MA":{"id":"MA","name":"Morocco","timezones":["Africa/Casablanca"]},"MC":{"id":"MC","name":"Monaco","timezones":["Europe/Monaco"]},"MD":{"id":"MD","name":"Moldova","timezones":["Europe/Chisinau"]},"ME":{"id":"ME","name":"Montenegro","timezones":["Europe/Belgrade"]},"MF":{"id":"MF","name":"St Martin (French part)","timezones":["America/Port_of_Spain"]},"MG":{"id":"MG","name":"Madagascar","timezones":["Africa/Nairobi"]},"MH":{"id":"MH","name":"Marshall Islands","timezones":["Pacific/Majuro","Pacific/Kwajalein"]},"MK":{"id":"MK","name":"Macedonia","timezones":["Europe/Belgrade"]},"ML":{"id":"ML","name":"Mali","timezones":["Africa/Abidjan"]},"MM":{"id":"MM","name":"Myanmar (Burma)","timezones":["Asia/Rangoon"]},"MN":{"id":"MN","name":"Mongolia","timezones":["Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan"]},"MO":{"id":"MO","name":"Macau","timezones":["Asia/Macau"]},"MP":{"id":"MP","name":"Northern Mariana Islands","timezones":["Pacific/Guam"]},"MQ":{"id":"MQ","name":"Martinique","timezones":["America/Martinique"]},"MR":{"id":"MR","name":"Mauritania","timezones":["Africa/Abidjan"]},"MS":{"id":"MS","name":"Montserrat","timezones":["America/Port_of_Spain"]},"MT":{"id":"MT","name":"Malta","timezones":["Europe/Malta"]},"MU":{"id":"MU","name":"Mauritius","timezones":["Indian/Mauritius"]},"MV":{"id":"MV","name":"Maldives","timezones":["Indian/Maldives"]},"MW":{"id":"MW","name":"Malawi","timezones":["Africa/Maputo"]},"MX":{"id":"MX","name":"Mexico","timezones":["America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Santa_Isabel","America/Bahia_Banderas"]},"MY":{"id":"MY","name":"Malaysia","timezones":["Asia/Kuala_Lumpur","Asia/Kuching"]},"MZ":{"id":"MZ","name":"Mozambique","timezones":["Africa/Maputo"]},"NA":{"id":"NA","name":"Namibia","timezones":["Africa/Windhoek"]},"NC":{"id":"NC","name":"New Caledonia","timezones":["Pacific/Noumea"]},"NE":{"id":"NE","name":"Niger","timezones":["Africa/Lagos"]},"NF":{"id":"NF","name":"Norfolk Island","timezones":["Pacific/Norfolk"]},"NG":{"id":"NG","name":"Nigeria","timezones":["Africa/Lagos"]},"NI":{"id":"NI","name":"Nicaragua","timezones":["America/Managua"]},"NL":{"id":"NL","name":"Netherlands","timezones":["Europe/Amsterdam"]},"NO":{"id":"NO","name":"Norway","timezones":["Europe/Oslo"]},"NP":{"id":"NP","name":"Nepal","timezones":["Asia/Kathmandu"]},"NR":{"id":"NR","name":"Nauru","timezones":["Pacific/Nauru"]},"NU":{"id":"NU","name":"Niue","timezones":["Pacific/Niue"]},"NZ":{"id":"NZ","name":"New Zealand","timezones":["Pacific/Auckland","Pacific/Chatham"]},"OM":{"id":"OM","name":"Oman","timezones":["Asia/Dubai"]},"PA":{"id":"PA","name":"Panama","timezones":["America/Panama"]},"PE":{"id":"PE","name":"Peru","timezones":["America/Lima"]},"PF":{"id":"PF","name":"French Polynesia","timezones":["Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier"]},"PG":{"id":"PG","name":"Papua New Guinea","timezones":["Pacific/Port_Moresby","Pacific/Bougainville"]},"PH":{"id":"PH","name":"Philippines","timezones":["Asia/Manila"]},"PK":{"id":"PK","name":"Pakistan","timezones":["Asia/Karachi"]},"PL":{"id":"PL","name":"Poland","timezones":["Europe/Warsaw"]},"PM":{"id":"PM","name":"St Pierre & Miquelon","timezones":["America/Miquelon"]},"PN":{"id":"PN","name":"Pitcairn","timezones":["Pacific/Pitcairn"]},"PR":{"id":"PR","name":"Puerto Rico","timezones":["America/Puerto_Rico"]},"PS":{"id":"PS","name":"Palestine","timezones":["Asia/Gaza","Asia/Hebron"]},"PT":{"id":"PT","name":"Portugal","timezones":["Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores"]},"PW":{"id":"PW","name":"Palau","timezones":["Pacific/Palau"]},"PY":{"id":"PY","name":"Paraguay","timezones":["America/Asuncion"]},"QA":{"id":"QA","name":"Qatar","timezones":["Asia/Qatar"]},"RE":{"id":"RE","name":"Réunion","timezones":["Indian/Reunion"]},"RO":{"id":"RO","name":"Romania","timezones":["Europe/Bucharest"]},"RS":{"id":"RS","name":"Serbia","timezones":["Europe/Belgrade"]},"RU":{"id":"RU","name":"Russia","timezones":["Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Volgograd","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Sakhalin","Asia/Ust-Nera","Asia/Magadan","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr"]},"RW":{"id":"RW","name":"Rwanda","timezones":["Africa/Maputo"]},"SA":{"id":"SA","name":"Saudi Arabia","timezones":["Asia/Riyadh"]},"SB":{"id":"SB","name":"Solomon Islands","timezones":["Pacific/Guadalcanal"]},"SC":{"id":"SC","name":"Seychelles","timezones":["Indian/Mahe"]},"SD":{"id":"SD","name":"Sudan","timezones":["Africa/Khartoum"]},"SE":{"id":"SE","name":"Sweden","timezones":["Europe/Stockholm"]},"SG":{"id":"SG","name":"Singapore","timezones":["Asia/Singapore"]},"SH":{"id":"SH","name":"St Helena","timezones":["Africa/Abidjan"]},"SI":{"id":"SI","name":"Slovenia","timezones":["Europe/Belgrade"]},"SJ":{"id":"SJ","name":"Svalbard & Jan Mayen","timezones":["Europe/Oslo"]},"SK":{"id":"SK","name":"Slovakia","timezones":["Europe/Prague"]},"SL":{"id":"SL","name":"Sierra Leone","timezones":["Africa/Abidjan"]},"SM":{"id":"SM","name":"San Marino","timezones":["Europe/Rome"]},"SN":{"id":"SN","name":"Senegal","timezones":["Africa/Abidjan"]},"SO":{"id":"SO","name":"Somalia","timezones":["Africa/Nairobi"]},"SR":{"id":"SR","name":"Suriname","timezones":["America/Paramaribo"]},"SS":{"id":"SS","name":"South Sudan","timezones":["Africa/Khartoum"]},"ST":{"id":"ST","name":"Sao Tome & Principe","timezones":["Africa/Abidjan"]},"SV":{"id":"SV","name":"El Salvador","timezones":["America/El_Salvador"]},"SX":{"id":"SX","name":"St Maarten (Dutch part)","timezones":["America/Curacao"]},"SY":{"id":"SY","name":"Syria","timezones":["Asia/Damascus"]},"SZ":{"id":"SZ","name":"Swaziland","timezones":["Africa/Johannesburg"]},"TC":{"id":"TC","name":"Turks & Caicos Is","timezones":["America/Grand_Turk"]},"TD":{"id":"TD","name":"Chad","timezones":["Africa/Ndjamena"]},"TF":{"id":"TF","name":"French Southern & Antarctic Lands","timezones":["Indian/Reunion","Indian/Kerguelen"]},"TG":{"id":"TG","name":"Togo","timezones":["Africa/Abidjan"]},"TH":{"id":"TH","name":"Thailand","timezones":["Asia/Bangkok"]},"TJ":{"id":"TJ","name":"Tajikistan","timezones":["Asia/Dushanbe"]},"TK":{"id":"TK","name":"Tokelau","timezones":["Pacific/Fakaofo"]},"TL":{"id":"TL","name":"East Timor","timezones":["Asia/Dili"]},"TM":{"id":"TM","name":"Turkmenistan","timezones":["Asia/Ashgabat"]},"TN":{"id":"TN","name":"Tunisia","timezones":["Africa/Tunis"]},"TO":{"id":"TO","name":"Tonga","timezones":["Pacific/Tongatapu"]},"TR":{"id":"TR","name":"Turkey","timezones":["Europe/Istanbul"]},"TT":{"id":"TT","name":"Trinidad & Tobago","timezones":["America/Port_of_Spain"]},"TV":{"id":"TV","name":"Tuvalu","timezones":["Pacific/Funafuti"]},"TW":{"id":"TW","name":"Taiwan","timezones":["Asia/Taipei"]},"TZ":{"id":"TZ","name":"Tanzania","timezones":["Africa/Nairobi"]},"UA":{"id":"UA","name":"Ukraine","timezones":["Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye"]},"UG":{"id":"UG","name":"Uganda","timezones":["Africa/Nairobi"]},"UM":{"id":"UM","name":"US minor outlying islands","timezones":["Pacific/Pago_Pago","Pacific/Wake","Pacific/Honolulu"]},"US":{"id":"US","name":"United States","timezones":["America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Metlakatla","America/Anchorage","America/Juneau","America/Sitka","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu"]},"UY":{"id":"UY","name":"Uruguay","timezones":["America/Montevideo"]},"UZ":{"id":"UZ","name":"Uzbekistan","timezones":["Asia/Samarkand","Asia/Tashkent"]},"VA":{"id":"VA","name":"Vatican City","timezones":["Europe/Rome"]},"VC":{"id":"VC","name":"St Vincent","timezones":["America/Port_of_Spain"]},"VE":{"id":"VE","name":"Venezuela","timezones":["America/Caracas"]},"VG":{"id":"VG","name":"Virgin Islands (UK)","timezones":["America/Port_of_Spain"]},"VI":{"id":"VI","name":"Virgin Islands (US)","timezones":["America/Port_of_Spain"]},"VN":{"id":"VN","name":"Vietnam","timezones":["Asia/Bangkok","Asia/Ho_Chi_Minh"]},"VU":{"id":"VU","name":"Vanuatu","timezones":["Pacific/Efate"]},"WF":{"id":"WF","name":"Wallis & Futuna","timezones":["Pacific/Wallis"]},"WS":{"id":"WS","name":"Samoa (western)","timezones":["Pacific/Apia"]},"YE":{"id":"YE","name":"Yemen","timezones":["Asia/Riyadh"]},"YT":{"id":"YT","name":"Mayotte","timezones":["Africa/Nairobi"]},"ZA":{"id":"ZA","name":"South Africa","timezones":["Africa/Johannesburg"]},"ZM":{"id":"ZM","name":"Zambia","timezones":["Africa/Maputo"]},"ZW":{"id":"ZW","name":"Zimbabwe","timezones":["Africa/Maputo"]}},"timezones":{"Europe/Andorra":{"name":"Europe/Andorra","utcOffset":60,"offsetStr":"+01:00","countries":["AD"]},"Asia/Dubai":{"name":"Asia/Dubai","utcOffset":240,"offsetStr":"+04:00","countries":["AE","OM"]},"Asia/Kabul":{"name":"Asia/Kabul","utcOffset":270,"offsetStr":"+04:30","countries":["AF"]},"Europe/Tirane":{"name":"Europe/Tirane","utcOffset":60,"offsetStr":"+01:00","countries":["AL"]},"Asia/Yerevan":{"name":"Asia/Yerevan","utcOffset":240,"offsetStr":"+04:00","countries":["AM"]},"Antarctica/Rothera":{"name":"Antarctica/Rothera","utcOffset":-180,"offsetStr":"-03:00","countries":["AQ"]},"Antarctica/Palmer":{"name":"Antarctica/Palmer","utcOffset":-180,"offsetStr":"-03:00","countries":["AQ"]},"Antarctica/Mawson":{"name":"Antarctica/Mawson","utcOffset":300,"offsetStr":"+05:00","countries":["AQ"]},"Antarctica/Davis":{"name":"Antarctica/Davis","utcOffset":420,"offsetStr":"+07:00","countries":["AQ"]},"Antarctica/Casey":{"name":"Antarctica/Casey","utcOffset":480,"offsetStr":"+08:00","countries":["AQ"]},"Antarctica/Vostok":{"name":"Antarctica/Vostok","utcOffset":360,"offsetStr":"+06:00","countries":["AQ"]},"Antarctica/DumontDUrville":{"name":"Antarctica/DumontDUrville","utcOffset":600,"offsetStr":"+10:00","countries":["AQ"]},"Antarctica/Syowa":{"name":"Antarctica/Syowa","utcOffset":180,"offsetStr":"+03:00","countries":["AQ"]},"Antarctica/Troll":{"name":"Antarctica/Troll","utcOffset":0,"offsetStr":"+00:00","countries":["AQ"]},"America/Argentina/Buenos_Aires":{"name":"America/Argentina/Buenos_Aires","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Cordoba":{"name":"America/Argentina/Cordoba","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Salta":{"name":"America/Argentina/Salta","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Jujuy":{"name":"America/Argentina/Jujuy","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Tucuman":{"name":"America/Argentina/Tucuman","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Catamarca":{"name":"America/Argentina/Catamarca","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/La_Rioja":{"name":"America/Argentina/La_Rioja","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/San_Juan":{"name":"America/Argentina/San_Juan","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Mendoza":{"name":"America/Argentina/Mendoza","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/San_Luis":{"name":"America/Argentina/San_Luis","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Rio_Gallegos":{"name":"America/Argentina/Rio_Gallegos","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"America/Argentina/Ushuaia":{"name":"America/Argentina/Ushuaia","utcOffset":-180,"offsetStr":"-03:00","countries":["AR"]},"Pacific/Pago_Pago":{"name":"Pacific/Pago_Pago","utcOffset":-660,"offsetStr":"-11:00","countries":["AS","UM"]},"Europe/Vienna":{"name":"Europe/Vienna","utcOffset":60,"offsetStr":"+01:00","countries":["AT"]},"Australia/Lord_Howe":{"name":"Australia/Lord_Howe","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Antarctica/Macquarie":{"name":"Antarctica/Macquarie","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Australia/Hobart":{"name":"Australia/Hobart","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Australia/Currie":{"name":"Australia/Currie","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Australia/Melbourne":{"name":"Australia/Melbourne","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Australia/Sydney":{"name":"Australia/Sydney","utcOffset":660,"offsetStr":"+11:00","countries":["AU"]},"Australia/Broken_Hill":{"name":"Australia/Broken_Hill","utcOffset":630,"offsetStr":"+10:30","countries":["AU"]},"Australia/Brisbane":{"name":"Australia/Brisbane","utcOffset":600,"offsetStr":"+10:00","countries":["AU"]},"Australia/Lindeman":{"name":"Australia/Lindeman","utcOffset":600,"offsetStr":"+10:00","countries":["AU"]},"Australia/Adelaide":{"name":"Australia/Adelaide","utcOffset":630,"offsetStr":"+10:30","countries":["AU"]},"Australia/Darwin":{"name":"Australia/Darwin","utcOffset":570,"offsetStr":"+09:30","countries":["AU"]},"Australia/Perth":{"name":"Australia/Perth","utcOffset":480,"offsetStr":"+08:00","countries":["AU"]},"Australia/Eucla":{"name":"Australia/Eucla","utcOffset":525,"offsetStr":"+08:45","countries":["AU"]},"Asia/Baku":{"name":"Asia/Baku","utcOffset":240,"offsetStr":"+04:00","countries":["AZ"]},"America/Barbados":{"name":"America/Barbados","utcOffset":-240,"offsetStr":"-04:00","countries":["BB"]},"Asia/Dhaka":{"name":"Asia/Dhaka","utcOffset":360,"offsetStr":"+06:00","countries":["BD"]},"Europe/Brussels":{"name":"Europe/Brussels","utcOffset":60,"offsetStr":"+01:00","countries":["BE"]},"Europe/Sofia":{"name":"Europe/Sofia","utcOffset":120,"offsetStr":"+02:00","countries":["BG"]},"Atlantic/Bermuda":{"name":"Atlantic/Bermuda","utcOffset":-240,"offsetStr":"-04:00","countries":["BM"]},"Asia/Brunei":{"name":"Asia/Brunei","utcOffset":480,"offsetStr":"+08:00","countries":["BN"]},"America/La_Paz":{"name":"America/La_Paz","utcOffset":-240,"offsetStr":"-04:00","countries":["BO"]},"America/Noronha":{"name":"America/Noronha","utcOffset":-120,"offsetStr":"-02:00","countries":["BR"]},"America/Belem":{"name":"America/Belem","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Fortaleza":{"name":"America/Fortaleza","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Recife":{"name":"America/Recife","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Araguaina":{"name":"America/Araguaina","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Maceio":{"name":"America/Maceio","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Bahia":{"name":"America/Bahia","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Sao_Paulo":{"name":"America/Sao_Paulo","utcOffset":-120,"offsetStr":"-02:00","countries":["BR"]},"America/Campo_Grande":{"name":"America/Campo_Grande","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Cuiaba":{"name":"America/Cuiaba","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Santarem":{"name":"America/Santarem","utcOffset":-180,"offsetStr":"-03:00","countries":["BR"]},"America/Porto_Velho":{"name":"America/Porto_Velho","utcOffset":-240,"offsetStr":"-04:00","countries":["BR"]},"America/Boa_Vista":{"name":"America/Boa_Vista","utcOffset":-240,"offsetStr":"-04:00","countries":["BR"]},"America/Manaus":{"name":"America/Manaus","utcOffset":-240,"offsetStr":"-04:00","countries":["BR"]},"America/Eirunepe":{"name":"America/Eirunepe","utcOffset":-300,"offsetStr":"-05:00","countries":["BR"]},"America/Rio_Branco":{"name":"America/Rio_Branco","utcOffset":-300,"offsetStr":"-05:00","countries":["BR"]},"America/Nassau":{"name":"America/Nassau","utcOffset":-300,"offsetStr":"-05:00","countries":["BS"]},"Asia/Thimphu":{"name":"Asia/Thimphu","utcOffset":360,"offsetStr":"+06:00","countries":["BT"]},"Europe/Minsk":{"name":"Europe/Minsk","utcOffset":180,"offsetStr":"+03:00","countries":["BY"]},"America/Belize":{"name":"America/Belize","utcOffset":-360,"offsetStr":"-06:00","countries":["BZ"]},"America/St_Johns":{"name":"America/St_Johns","utcOffset":-210,"offsetStr":"-03:30","countries":["CA"]},"America/Halifax":{"name":"America/Halifax","utcOffset":-240,"offsetStr":"-04:00","countries":["CA"]},"America/Glace_Bay":{"name":"America/Glace_Bay","utcOffset":-240,"offsetStr":"-04:00","countries":["CA"]},"America/Moncton":{"name":"America/Moncton","utcOffset":-240,"offsetStr":"-04:00","countries":["CA"]},"America/Goose_Bay":{"name":"America/Goose_Bay","utcOffset":-240,"offsetStr":"-04:00","countries":["CA"]},"America/Blanc-Sablon":{"name":"America/Blanc-Sablon","utcOffset":-240,"offsetStr":"-04:00","countries":["CA"]},"America/Toronto":{"name":"America/Toronto","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Nipigon":{"name":"America/Nipigon","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Thunder_Bay":{"name":"America/Thunder_Bay","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Iqaluit":{"name":"America/Iqaluit","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Pangnirtung":{"name":"America/Pangnirtung","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Resolute":{"name":"America/Resolute","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Atikokan":{"name":"America/Atikokan","utcOffset":-300,"offsetStr":"-05:00","countries":["CA"]},"America/Rankin_Inlet":{"name":"America/Rankin_Inlet","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Winnipeg":{"name":"America/Winnipeg","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Rainy_River":{"name":"America/Rainy_River","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Regina":{"name":"America/Regina","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Swift_Current":{"name":"America/Swift_Current","utcOffset":-360,"offsetStr":"-06:00","countries":["CA"]},"America/Edmonton":{"name":"America/Edmonton","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Cambridge_Bay":{"name":"America/Cambridge_Bay","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Yellowknife":{"name":"America/Yellowknife","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Inuvik":{"name":"America/Inuvik","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Creston":{"name":"America/Creston","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Dawson_Creek":{"name":"America/Dawson_Creek","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Fort_Nelson":{"name":"America/Fort_Nelson","utcOffset":-420,"offsetStr":"-07:00","countries":["CA"]},"America/Vancouver":{"name":"America/Vancouver","utcOffset":-480,"offsetStr":"-08:00","countries":["CA"]},"America/Whitehorse":{"name":"America/Whitehorse","utcOffset":-480,"offsetStr":"-08:00","countries":["CA"]},"America/Dawson":{"name":"America/Dawson","utcOffset":-480,"offsetStr":"-08:00","countries":["CA"]},"Indian/Cocos":{"name":"Indian/Cocos","utcOffset":390,"offsetStr":"+06:30","countries":["CC"]},"Europe/Zurich":{"name":"Europe/Zurich","utcOffset":60,"offsetStr":"+01:00","countries":["CH","DE","LI"]},"Africa/Abidjan":{"name":"Africa/Abidjan","utcOffset":0,"offsetStr":"+00:00","countries":["CI","BF","GM","GN","ML","MR","SH","SL","SN","ST","TG"]},"Pacific/Rarotonga":{"name":"Pacific/Rarotonga","utcOffset":-600,"offsetStr":"-10:00","countries":["CK"]},"America/Santiago":{"name":"America/Santiago","utcOffset":-180,"offsetStr":"-03:00","countries":["CL"]},"Pacific/Easter":{"name":"Pacific/Easter","utcOffset":-300,"offsetStr":"-05:00","countries":["CL"]},"Asia/Shanghai":{"name":"Asia/Shanghai","utcOffset":480,"offsetStr":"+08:00","countries":["CN"]},"Asia/Urumqi":{"name":"Asia/Urumqi","utcOffset":360,"offsetStr":"+06:00","countries":["CN"]},"America/Bogota":{"name":"America/Bogota","utcOffset":-300,"offsetStr":"-05:00","countries":["CO"]},"America/Costa_Rica":{"name":"America/Costa_Rica","utcOffset":-360,"offsetStr":"-06:00","countries":["CR"]},"America/Havana":{"name":"America/Havana","utcOffset":-300,"offsetStr":"-05:00","countries":["CU"]},"Atlantic/Cape_Verde":{"name":"Atlantic/Cape_Verde","utcOffset":-60,"offsetStr":"-01:00","countries":["CV"]},"America/Curacao":{"name":"America/Curacao","utcOffset":-240,"offsetStr":"-04:00","countries":["CW","AW","BQ","SX"]},"Indian/Christmas":{"name":"Indian/Christmas","utcOffset":420,"offsetStr":"+07:00","countries":["CX"]},"Asia/Nicosia":{"name":"Asia/Nicosia","utcOffset":120,"offsetStr":"+02:00","countries":["CY"]},"Europe/Prague":{"name":"Europe/Prague","utcOffset":60,"offsetStr":"+01:00","countries":["CZ","SK"]},"Europe/Berlin":{"name":"Europe/Berlin","utcOffset":60,"offsetStr":"+01:00","countries":["DE"]},"Europe/Copenhagen":{"name":"Europe/Copenhagen","utcOffset":60,"offsetStr":"+01:00","countries":["DK"]},"America/Santo_Domingo":{"name":"America/Santo_Domingo","utcOffset":-240,"offsetStr":"-04:00","countries":["DO"]},"Africa/Algiers":{"name":"Africa/Algiers","utcOffset":60,"offsetStr":"+01:00","countries":["DZ"]},"America/Guayaquil":{"name":"America/Guayaquil","utcOffset":-300,"offsetStr":"-05:00","countries":["EC"]},"Pacific/Galapagos":{"name":"Pacific/Galapagos","utcOffset":-360,"offsetStr":"-06:00","countries":["EC"]},"Europe/Tallinn":{"name":"Europe/Tallinn","utcOffset":120,"offsetStr":"+02:00","countries":["EE"]},"Africa/Cairo":{"name":"Africa/Cairo","utcOffset":120,"offsetStr":"+02:00","countries":["EG"]},"Africa/El_Aaiun":{"name":"Africa/El_Aaiun","utcOffset":0,"offsetStr":"+00:00","countries":["EH"]},"Europe/Madrid":{"name":"Europe/Madrid","utcOffset":60,"offsetStr":"+01:00","countries":["ES"]},"Africa/Ceuta":{"name":"Africa/Ceuta","utcOffset":60,"offsetStr":"+01:00","countries":["ES"]},"Atlantic/Canary":{"name":"Atlantic/Canary","utcOffset":0,"offsetStr":"+00:00","countries":["ES"]},"Europe/Helsinki":{"name":"Europe/Helsinki","utcOffset":120,"offsetStr":"+02:00","countries":["FI","AX"]},"Pacific/Fiji":{"name":"Pacific/Fiji","utcOffset":720,"offsetStr":"+12:00","countries":["FJ"]},"Atlantic/Stanley":{"name":"Atlantic/Stanley","utcOffset":-180,"offsetStr":"-03:00","countries":["FK"]},"Pacific/Chuuk":{"name":"Pacific/Chuuk","utcOffset":600,"offsetStr":"+10:00","countries":["FM"]},"Pacific/Pohnpei":{"name":"Pacific/Pohnpei","utcOffset":660,"offsetStr":"+11:00","countries":["FM"]},"Pacific/Kosrae":{"name":"Pacific/Kosrae","utcOffset":660,"offsetStr":"+11:00","countries":["FM"]},"Atlantic/Faroe":{"name":"Atlantic/Faroe","utcOffset":0,"offsetStr":"+00:00","countries":["FO"]},"Europe/Paris":{"name":"Europe/Paris","utcOffset":60,"offsetStr":"+01:00","countries":["FR"]},"Europe/London":{"name":"Europe/London","utcOffset":0,"offsetStr":"+00:00","countries":["GB","GG","IM","JE"]},"Asia/Tbilisi":{"name":"Asia/Tbilisi","utcOffset":240,"offsetStr":"+04:00","countries":["GE"]},"America/Cayenne":{"name":"America/Cayenne","utcOffset":-180,"offsetStr":"-03:00","countries":["GF"]},"Africa/Accra":{"name":"Africa/Accra","utcOffset":0,"offsetStr":"+00:00","countries":["GH"]},"Europe/Gibraltar":{"name":"Europe/Gibraltar","utcOffset":60,"offsetStr":"+01:00","countries":["GI"]},"America/Godthab":{"name":"America/Godthab","utcOffset":-180,"offsetStr":"-03:00","countries":["GL"]},"America/Danmarkshavn":{"name":"America/Danmarkshavn","utcOffset":0,"offsetStr":"+00:00","countries":["GL"]},"America/Scoresbysund":{"name":"America/Scoresbysund","utcOffset":-60,"offsetStr":"-01:00","countries":["GL"]},"America/Thule":{"name":"America/Thule","utcOffset":-240,"offsetStr":"-04:00","countries":["GL"]},"Europe/Athens":{"name":"Europe/Athens","utcOffset":120,"offsetStr":"+02:00","countries":["GR"]},"Atlantic/South_Georgia":{"name":"Atlantic/South_Georgia","utcOffset":-120,"offsetStr":"-02:00","countries":["GS"]},"America/Guatemala":{"name":"America/Guatemala","utcOffset":-360,"offsetStr":"-06:00","countries":["GT"]},"Pacific/Guam":{"name":"Pacific/Guam","utcOffset":600,"offsetStr":"+10:00","countries":["GU","MP"]},"Africa/Bissau":{"name":"Africa/Bissau","utcOffset":0,"offsetStr":"+00:00","countries":["GW"]},"America/Guyana":{"name":"America/Guyana","utcOffset":-240,"offsetStr":"-04:00","countries":["GY"]},"Asia/Hong_Kong":{"name":"Asia/Hong_Kong","utcOffset":480,"offsetStr":"+08:00","countries":["HK"]},"America/Tegucigalpa":{"name":"America/Tegucigalpa","utcOffset":-360,"offsetStr":"-06:00","countries":["HN"]},"America/Port-au-Prince":{"name":"America/Port-au-Prince","utcOffset":-300,"offsetStr":"-05:00","countries":["HT"]},"Europe/Budapest":{"name":"Europe/Budapest","utcOffset":60,"offsetStr":"+01:00","countries":["HU"]},"Asia/Jakarta":{"name":"Asia/Jakarta","utcOffset":420,"offsetStr":"+07:00","countries":["ID"]},"Asia/Pontianak":{"name":"Asia/Pontianak","utcOffset":420,"offsetStr":"+07:00","countries":["ID"]},"Asia/Makassar":{"name":"Asia/Makassar","utcOffset":480,"offsetStr":"+08:00","countries":["ID"]},"Asia/Jayapura":{"name":"Asia/Jayapura","utcOffset":540,"offsetStr":"+09:00","countries":["ID"]},"Europe/Dublin":{"name":"Europe/Dublin","utcOffset":0,"offsetStr":"+00:00","countries":["IE"]},"Asia/Jerusalem":{"name":"Asia/Jerusalem","utcOffset":120,"offsetStr":"+02:00","countries":["IL"]},"Asia/Kolkata":{"name":"Asia/Kolkata","utcOffset":330,"offsetStr":"+05:30","countries":["IN"]},"Indian/Chagos":{"name":"Indian/Chagos","utcOffset":360,"offsetStr":"+06:00","countries":["IO"]},"Asia/Baghdad":{"name":"Asia/Baghdad","utcOffset":180,"offsetStr":"+03:00","countries":["IQ"]},"Asia/Tehran":{"name":"Asia/Tehran","utcOffset":210,"offsetStr":"+03:30","countries":["IR"]},"Atlantic/Reykjavik":{"name":"Atlantic/Reykjavik","utcOffset":0,"offsetStr":"+00:00","countries":["IS"]},"Europe/Rome":{"name":"Europe/Rome","utcOffset":60,"offsetStr":"+01:00","countries":["IT","SM","VA"]},"America/Jamaica":{"name":"America/Jamaica","utcOffset":-300,"offsetStr":"-05:00","countries":["JM"]},"Asia/Amman":{"name":"Asia/Amman","utcOffset":120,"offsetStr":"+02:00","countries":["JO"]},"Asia/Tokyo":{"name":"Asia/Tokyo","utcOffset":540,"offsetStr":"+09:00","countries":["JP"]},"Africa/Nairobi":{"name":"Africa/Nairobi","utcOffset":180,"offsetStr":"+03:00","countries":["KE","DJ","ER","ET","KM","MG","SO","TZ","UG","YT"]},"Asia/Bishkek":{"name":"Asia/Bishkek","utcOffset":360,"offsetStr":"+06:00","countries":["KG"]},"Pacific/Tarawa":{"name":"Pacific/Tarawa","utcOffset":720,"offsetStr":"+12:00","countries":["KI"]},"Pacific/Enderbury":{"name":"Pacific/Enderbury","utcOffset":780,"offsetStr":"+13:00","countries":["KI"]},"Pacific/Kiritimati":{"name":"Pacific/Kiritimati","utcOffset":840,"offsetStr":"+14:00","countries":["KI"]},"Asia/Pyongyang":{"name":"Asia/Pyongyang","utcOffset":510,"offsetStr":"+08:30","countries":["KP"]},"Asia/Seoul":{"name":"Asia/Seoul","utcOffset":540,"offsetStr":"+09:00","countries":["KR"]},"America/Cayman":{"name":"America/Cayman","utcOffset":-300,"offsetStr":"-05:00","countries":["KY"]},"Asia/Almaty":{"name":"Asia/Almaty","utcOffset":360,"offsetStr":"+06:00","countries":["KZ"]},"Asia/Qyzylorda":{"name":"Asia/Qyzylorda","utcOffset":360,"offsetStr":"+06:00","countries":["KZ"]},"Asia/Aqtobe":{"name":"Asia/Aqtobe","utcOffset":300,"offsetStr":"+05:00","countries":["KZ"]},"Asia/Aqtau":{"name":"Asia/Aqtau","utcOffset":300,"offsetStr":"+05:00","countries":["KZ"]},"Asia/Oral":{"name":"Asia/Oral","utcOffset":300,"offsetStr":"+05:00","countries":["KZ"]},"Asia/Beirut":{"name":"Asia/Beirut","utcOffset":120,"offsetStr":"+02:00","countries":["LB"]},"Asia/Colombo":{"name":"Asia/Colombo","utcOffset":330,"offsetStr":"+05:30","countries":["LK"]},"Africa/Monrovia":{"name":"Africa/Monrovia","utcOffset":0,"offsetStr":"+00:00","countries":["LR"]},"Europe/Vilnius":{"name":"Europe/Vilnius","utcOffset":120,"offsetStr":"+02:00","countries":["LT"]},"Europe/Luxembourg":{"name":"Europe/Luxembourg","utcOffset":60,"offsetStr":"+01:00","countries":["LU"]},"Europe/Riga":{"name":"Europe/Riga","utcOffset":120,"offsetStr":"+02:00","countries":["LV"]},"Africa/Tripoli":{"name":"Africa/Tripoli","utcOffset":120,"offsetStr":"+02:00","countries":["LY"]},"Africa/Casablanca":{"name":"Africa/Casablanca","utcOffset":0,"offsetStr":"+00:00","countries":["MA"]},"Europe/Monaco":{"name":"Europe/Monaco","utcOffset":60,"offsetStr":"+01:00","countries":["MC"]},"Europe/Chisinau":{"name":"Europe/Chisinau","utcOffset":120,"offsetStr":"+02:00","countries":["MD"]},"Pacific/Majuro":{"name":"Pacific/Majuro","utcOffset":720,"offsetStr":"+12:00","countries":["MH"]},"Pacific/Kwajalein":{"name":"Pacific/Kwajalein","utcOffset":720,"offsetStr":"+12:00","countries":["MH"]},"Asia/Rangoon":{"name":"Asia/Rangoon","utcOffset":390,"offsetStr":"+06:30","countries":["MM"]},"Asia/Ulaanbaatar":{"name":"Asia/Ulaanbaatar","utcOffset":480,"offsetStr":"+08:00","countries":["MN"]},"Asia/Hovd":{"name":"Asia/Hovd","utcOffset":420,"offsetStr":"+07:00","countries":["MN"]},"Asia/Choibalsan":{"name":"Asia/Choibalsan","utcOffset":480,"offsetStr":"+08:00","countries":["MN"]},"Asia/Macau":{"name":"Asia/Macau","utcOffset":480,"offsetStr":"+08:00","countries":["MO"]},"America/Martinique":{"name":"America/Martinique","utcOffset":-240,"offsetStr":"-04:00","countries":["MQ"]},"Europe/Malta":{"name":"Europe/Malta","utcOffset":60,"offsetStr":"+01:00","countries":["MT"]},"Indian/Mauritius":{"name":"Indian/Mauritius","utcOffset":240,"offsetStr":"+04:00","countries":["MU"]},"Indian/Maldives":{"name":"Indian/Maldives","utcOffset":300,"offsetStr":"+05:00","countries":["MV"]},"America/Mexico_City":{"name":"America/Mexico_City","utcOffset":-360,"offsetStr":"-06:00","countries":["MX"]},"America/Cancun":{"name":"America/Cancun","utcOffset":-300,"offsetStr":"-05:00","countries":["MX"]},"America/Merida":{"name":"America/Merida","utcOffset":-360,"offsetStr":"-06:00","countries":["MX"]},"America/Monterrey":{"name":"America/Monterrey","utcOffset":-360,"offsetStr":"-06:00","countries":["MX"]},"America/Matamoros":{"name":"America/Matamoros","utcOffset":-360,"offsetStr":"-06:00","countries":["MX"]},"America/Mazatlan":{"name":"America/Mazatlan","utcOffset":-420,"offsetStr":"-07:00","countries":["MX"]},"America/Chihuahua":{"name":"America/Chihuahua","utcOffset":-420,"offsetStr":"-07:00","countries":["MX"]},"America/Ojinaga":{"name":"America/Ojinaga","utcOffset":-420,"offsetStr":"-07:00","countries":["MX"]},"America/Hermosillo":{"name":"America/Hermosillo","utcOffset":-420,"offsetStr":"-07:00","countries":["MX"]},"America/Tijuana":{"name":"America/Tijuana","utcOffset":-480,"offsetStr":"-08:00","countries":["MX"]},"America/Santa_Isabel":{"name":"America/Santa_Isabel","utcOffset":-480,"offsetStr":"-08:00","countries":["MX"]},"America/Bahia_Banderas":{"name":"America/Bahia_Banderas","utcOffset":-360,"offsetStr":"-06:00","countries":["MX"]},"Asia/Kuala_Lumpur":{"name":"Asia/Kuala_Lumpur","utcOffset":480,"offsetStr":"+08:00","countries":["MY"]},"Asia/Kuching":{"name":"Asia/Kuching","utcOffset":480,"offsetStr":"+08:00","countries":["MY"]},"Africa/Maputo":{"name":"Africa/Maputo","utcOffset":120,"offsetStr":"+02:00","countries":["MZ","BI","BW","CD","MW","RW","ZM","ZW"]},"Africa/Windhoek":{"name":"Africa/Windhoek","utcOffset":120,"offsetStr":"+02:00","countries":["NA"]},"Pacific/Noumea":{"name":"Pacific/Noumea","utcOffset":660,"offsetStr":"+11:00","countries":["NC"]},"Pacific/Norfolk":{"name":"Pacific/Norfolk","utcOffset":660,"offsetStr":"+11:00","countries":["NF"]},"Africa/Lagos":{"name":"Africa/Lagos","utcOffset":60,"offsetStr":"+01:00","countries":["NG","AO","BJ","CD","CF","CG","CM","GA","GQ","NE"]},"America/Managua":{"name":"America/Managua","utcOffset":-360,"offsetStr":"-06:00","countries":["NI"]},"Europe/Amsterdam":{"name":"Europe/Amsterdam","utcOffset":60,"offsetStr":"+01:00","countries":["NL"]},"Europe/Oslo":{"name":"Europe/Oslo","utcOffset":60,"offsetStr":"+01:00","countries":["NO","SJ"]},"Asia/Kathmandu":{"name":"Asia/Kathmandu","utcOffset":345,"offsetStr":"+05:45","countries":["NP"]},"Pacific/Nauru":{"name":"Pacific/Nauru","utcOffset":720,"offsetStr":"+12:00","countries":["NR"]},"Pacific/Niue":{"name":"Pacific/Niue","utcOffset":-660,"offsetStr":"-11:00","countries":["NU"]},"Pacific/Auckland":{"name":"Pacific/Auckland","utcOffset":780,"offsetStr":"+13:00","countries":["NZ","AQ"]},"Pacific/Chatham":{"name":"Pacific/Chatham","utcOffset":825,"offsetStr":"+13:45","countries":["NZ"]},"America/Panama":{"name":"America/Panama","utcOffset":-300,"offsetStr":"-05:00","countries":["PA"]},"America/Lima":{"name":"America/Lima","utcOffset":-300,"offsetStr":"-05:00","countries":["PE"]},"Pacific/Tahiti":{"name":"Pacific/Tahiti","utcOffset":-600,"offsetStr":"-10:00","countries":["PF"]},"Pacific/Marquesas":{"name":"Pacific/Marquesas","utcOffset":-570,"offsetStr":"-09:30","countries":["PF"]},"Pacific/Gambier":{"name":"Pacific/Gambier","utcOffset":-540,"offsetStr":"-09:00","countries":["PF"]},"Pacific/Port_Moresby":{"name":"Pacific/Port_Moresby","utcOffset":600,"offsetStr":"+10:00","countries":["PG"]},"Pacific/Bougainville":{"name":"Pacific/Bougainville","utcOffset":660,"offsetStr":"+11:00","countries":["PG"]},"Asia/Manila":{"name":"Asia/Manila","utcOffset":480,"offsetStr":"+08:00","countries":["PH"]},"Asia/Karachi":{"name":"Asia/Karachi","utcOffset":300,"offsetStr":"+05:00","countries":["PK"]},"Europe/Warsaw":{"name":"Europe/Warsaw","utcOffset":60,"offsetStr":"+01:00","countries":["PL"]},"America/Miquelon":{"name":"America/Miquelon","utcOffset":-180,"offsetStr":"-03:00","countries":["PM"]},"Pacific/Pitcairn":{"name":"Pacific/Pitcairn","utcOffset":-480,"offsetStr":"-08:00","countries":["PN"]},"America/Puerto_Rico":{"name":"America/Puerto_Rico","utcOffset":-240,"offsetStr":"-04:00","countries":["PR"]},"Asia/Gaza":{"name":"Asia/Gaza","utcOffset":120,"offsetStr":"+02:00","countries":["PS"]},"Asia/Hebron":{"name":"Asia/Hebron","utcOffset":120,"offsetStr":"+02:00","countries":["PS"]},"Europe/Lisbon":{"name":"Europe/Lisbon","utcOffset":0,"offsetStr":"+00:00","countries":["PT"]},"Atlantic/Madeira":{"name":"Atlantic/Madeira","utcOffset":0,"offsetStr":"+00:00","countries":["PT"]},"Atlantic/Azores":{"name":"Atlantic/Azores","utcOffset":-60,"offsetStr":"-01:00","countries":["PT"]},"Pacific/Palau":{"name":"Pacific/Palau","utcOffset":540,"offsetStr":"+09:00","countries":["PW"]},"America/Asuncion":{"name":"America/Asuncion","utcOffset":-180,"offsetStr":"-03:00","countries":["PY"]},"Asia/Qatar":{"name":"Asia/Qatar","utcOffset":180,"offsetStr":"+03:00","countries":["QA","BH"]},"Indian/Reunion":{"name":"Indian/Reunion","utcOffset":240,"offsetStr":"+04:00","countries":["RE","TF"]},"Europe/Bucharest":{"name":"Europe/Bucharest","utcOffset":120,"offsetStr":"+02:00","countries":["RO"]},"Europe/Belgrade":{"name":"Europe/Belgrade","utcOffset":60,"offsetStr":"+01:00","countries":["RS","BA","HR","ME","MK","SI"]},"Europe/Kaliningrad":{"name":"Europe/Kaliningrad","utcOffset":120,"offsetStr":"+02:00","countries":["RU"]},"Europe/Moscow":{"name":"Europe/Moscow","utcOffset":180,"offsetStr":"+03:00","countries":["RU"]},"Europe/Simferopol":{"name":"Europe/Simferopol","utcOffset":180,"offsetStr":"+03:00","countries":["RU"]},"Europe/Volgograd":{"name":"Europe/Volgograd","utcOffset":180,"offsetStr":"+03:00","countries":["RU"]},"Europe/Samara":{"name":"Europe/Samara","utcOffset":240,"offsetStr":"+04:00","countries":["RU"]},"Asia/Yekaterinburg":{"name":"Asia/Yekaterinburg","utcOffset":300,"offsetStr":"+05:00","countries":["RU"]},"Asia/Omsk":{"name":"Asia/Omsk","utcOffset":360,"offsetStr":"+06:00","countries":["RU"]},"Asia/Novosibirsk":{"name":"Asia/Novosibirsk","utcOffset":360,"offsetStr":"+06:00","countries":["RU"]},"Asia/Novokuznetsk":{"name":"Asia/Novokuznetsk","utcOffset":420,"offsetStr":"+07:00","countries":["RU"]},"Asia/Krasnoyarsk":{"name":"Asia/Krasnoyarsk","utcOffset":420,"offsetStr":"+07:00","countries":["RU"]},"Asia/Irkutsk":{"name":"Asia/Irkutsk","utcOffset":480,"offsetStr":"+08:00","countries":["RU"]},"Asia/Chita":{"name":"Asia/Chita","utcOffset":480,"offsetStr":"+08:00","countries":["RU"]},"Asia/Yakutsk":{"name":"Asia/Yakutsk","utcOffset":540,"offsetStr":"+09:00","countries":["RU"]},"Asia/Khandyga":{"name":"Asia/Khandyga","utcOffset":540,"offsetStr":"+09:00","countries":["RU"]},"Asia/Vladivostok":{"name":"Asia/Vladivostok","utcOffset":600,"offsetStr":"+10:00","countries":["RU"]},"Asia/Sakhalin":{"name":"Asia/Sakhalin","utcOffset":600,"offsetStr":"+10:00","countries":["RU"]},"Asia/Ust-Nera":{"name":"Asia/Ust-Nera","utcOffset":600,"offsetStr":"+10:00","countries":["RU"]},"Asia/Magadan":{"name":"Asia/Magadan","utcOffset":600,"offsetStr":"+10:00","countries":["RU"]},"Asia/Srednekolymsk":{"name":"Asia/Srednekolymsk","utcOffset":660,"offsetStr":"+11:00","countries":["RU"]},"Asia/Kamchatka":{"name":"Asia/Kamchatka","utcOffset":720,"offsetStr":"+12:00","countries":["RU"]},"Asia/Anadyr":{"name":"Asia/Anadyr","utcOffset":720,"offsetStr":"+12:00","countries":["RU"]},"Asia/Riyadh":{"name":"Asia/Riyadh","utcOffset":180,"offsetStr":"+03:00","countries":["SA","KW","YE"]},"Pacific/Guadalcanal":{"name":"Pacific/Guadalcanal","utcOffset":660,"offsetStr":"+11:00","countries":["SB"]},"Indian/Mahe":{"name":"Indian/Mahe","utcOffset":240,"offsetStr":"+04:00","countries":["SC"]},"Africa/Khartoum":{"name":"Africa/Khartoum","utcOffset":180,"offsetStr":"+03:00","countries":["SD","SS"]},"Europe/Stockholm":{"name":"Europe/Stockholm","utcOffset":60,"offsetStr":"+01:00","countries":["SE"]},"Asia/Singapore":{"name":"Asia/Singapore","utcOffset":480,"offsetStr":"+08:00","countries":["SG"]},"America/Paramaribo":{"name":"America/Paramaribo","utcOffset":-180,"offsetStr":"-03:00","countries":["SR"]},"America/El_Salvador":{"name":"America/El_Salvador","utcOffset":-360,"offsetStr":"-06:00","countries":["SV"]},"Asia/Damascus":{"name":"Asia/Damascus","utcOffset":120,"offsetStr":"+02:00","countries":["SY"]},"America/Grand_Turk":{"name":"America/Grand_Turk","utcOffset":-240,"offsetStr":"-04:00","countries":["TC"]},"Africa/Ndjamena":{"name":"Africa/Ndjamena","utcOffset":60,"offsetStr":"+01:00","countries":["TD"]},"Indian/Kerguelen":{"name":"Indian/Kerguelen","utcOffset":300,"offsetStr":"+05:00","countries":["TF"]},"Asia/Bangkok":{"name":"Asia/Bangkok","utcOffset":420,"offsetStr":"+07:00","countries":["TH","KH","LA","VN"]},"Asia/Dushanbe":{"name":"Asia/Dushanbe","utcOffset":300,"offsetStr":"+05:00","countries":["TJ"]},"Pacific/Fakaofo":{"name":"Pacific/Fakaofo","utcOffset":780,"offsetStr":"+13:00","countries":["TK"]},"Asia/Dili":{"name":"Asia/Dili","utcOffset":540,"offsetStr":"+09:00","countries":["TL"]},"Asia/Ashgabat":{"name":"Asia/Ashgabat","utcOffset":300,"offsetStr":"+05:00","countries":["TM"]},"Africa/Tunis":{"name":"Africa/Tunis","utcOffset":60,"offsetStr":"+01:00","countries":["TN"]},"Pacific/Tongatapu":{"name":"Pacific/Tongatapu","utcOffset":780,"offsetStr":"+13:00","countries":["TO"]},"Europe/Istanbul":{"name":"Europe/Istanbul","utcOffset":120,"offsetStr":"+02:00","countries":["TR"]},"America/Port_of_Spain":{"name":"America/Port_of_Spain","utcOffset":-240,"offsetStr":"-04:00","countries":["TT","AG","AI","BL","DM","GD","GP","KN","LC","MF","MS","VC","VG","VI"]},"Pacific/Funafuti":{"name":"Pacific/Funafuti","utcOffset":720,"offsetStr":"+12:00","countries":["TV"]},"Asia/Taipei":{"name":"Asia/Taipei","utcOffset":480,"offsetStr":"+08:00","countries":["TW"]},"Europe/Kiev":{"name":"Europe/Kiev","utcOffset":120,"offsetStr":"+02:00","countries":["UA"]},"Europe/Uzhgorod":{"name":"Europe/Uzhgorod","utcOffset":120,"offsetStr":"+02:00","countries":["UA"]},"Europe/Zaporozhye":{"name":"Europe/Zaporozhye","utcOffset":120,"offsetStr":"+02:00","countries":["UA"]},"Pacific/Wake":{"name":"Pacific/Wake","utcOffset":720,"offsetStr":"+12:00","countries":["UM"]},"America/New_York":{"name":"America/New_York","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Detroit":{"name":"America/Detroit","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Kentucky/Louisville":{"name":"America/Kentucky/Louisville","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Kentucky/Monticello":{"name":"America/Kentucky/Monticello","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Indianapolis":{"name":"America/Indiana/Indianapolis","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Vincennes":{"name":"America/Indiana/Vincennes","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Winamac":{"name":"America/Indiana/Winamac","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Marengo":{"name":"America/Indiana/Marengo","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Petersburg":{"name":"America/Indiana/Petersburg","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Indiana/Vevay":{"name":"America/Indiana/Vevay","utcOffset":-300,"offsetStr":"-05:00","countries":["US"]},"America/Chicago":{"name":"America/Chicago","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/Indiana/Tell_City":{"name":"America/Indiana/Tell_City","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/Indiana/Knox":{"name":"America/Indiana/Knox","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/Menominee":{"name":"America/Menominee","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/North_Dakota/Center":{"name":"America/North_Dakota/Center","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/North_Dakota/New_Salem":{"name":"America/North_Dakota/New_Salem","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/North_Dakota/Beulah":{"name":"America/North_Dakota/Beulah","utcOffset":-360,"offsetStr":"-06:00","countries":["US"]},"America/Denver":{"name":"America/Denver","utcOffset":-420,"offsetStr":"-07:00","countries":["US"]},"America/Boise":{"name":"America/Boise","utcOffset":-420,"offsetStr":"-07:00","countries":["US"]},"America/Phoenix":{"name":"America/Phoenix","utcOffset":-420,"offsetStr":"-07:00","countries":["US"]},"America/Los_Angeles":{"name":"America/Los_Angeles","utcOffset":-480,"offsetStr":"-08:00","countries":["US"]},"America/Metlakatla":{"name":"America/Metlakatla","utcOffset":-480,"offsetStr":"-08:00","countries":["US"]},"America/Anchorage":{"name":"America/Anchorage","utcOffset":-540,"offsetStr":"-09:00","countries":["US"]},"America/Juneau":{"name":"America/Juneau","utcOffset":-540,"offsetStr":"-09:00","countries":["US"]},"America/Sitka":{"name":"America/Sitka","utcOffset":-540,"offsetStr":"-09:00","countries":["US"]},"America/Yakutat":{"name":"America/Yakutat","utcOffset":-540,"offsetStr":"-09:00","countries":["US"]},"America/Nome":{"name":"America/Nome","utcOffset":-540,"offsetStr":"-09:00","countries":["US"]},"America/Adak":{"name":"America/Adak","utcOffset":-600,"offsetStr":"-10:00","countries":["US"]},"Pacific/Honolulu":{"name":"Pacific/Honolulu","utcOffset":-600,"offsetStr":"-10:00","countries":["US","UM"]},"America/Montevideo":{"name":"America/Montevideo","utcOffset":-180,"offsetStr":"-03:00","countries":["UY"]},"Asia/Samarkand":{"name":"Asia/Samarkand","utcOffset":300,"offsetStr":"+05:00","countries":["UZ"]},"Asia/Tashkent":{"name":"Asia/Tashkent","utcOffset":300,"offsetStr":"+05:00","countries":["UZ"]},"America/Caracas":{"name":"America/Caracas","utcOffset":-270,"offsetStr":"-04:30","countries":["VE"]},"Asia/Ho_Chi_Minh":{"name":"Asia/Ho_Chi_Minh","utcOffset":420,"offsetStr":"+07:00","countries":["VN"]},"Pacific/Efate":{"name":"Pacific/Efate","utcOffset":660,"offsetStr":"+11:00","countries":["VU"]},"Pacific/Wallis":{"name":"Pacific/Wallis","utcOffset":720,"offsetStr":"+12:00","countries":["WF"]},"Pacific/Apia":{"name":"Pacific/Apia","utcOffset":840,"offsetStr":"+14:00","countries":["WS"]},"Africa/Johannesburg":{"name":"Africa/Johannesburg","utcOffset":120,"offsetStr":"+02:00","countries":["ZA","LS","SZ"]}}}

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var AddFloorPlanForm = (function (_React$Component) {
	    _inherits(AddFloorPlanForm, _React$Component);
	
	    function AddFloorPlanForm(props, context) {
	        _classCallCheck(this, AddFloorPlanForm);
	
	        _get(Object.getPrototypeOf(AddFloorPlanForm.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            type: this.props.node.type,
	            hasfloorplan: this.props.node.info.hasfloorplan,
	            useownfp: this.props.node.info.useownfp
	        };
	    }
	
	    _createClass(AddFloorPlanForm, [{
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            if (value == "true") {
	                value = true;
	            }
	            if (value == "false") {
	                value = false;
	            }
	            this.setState(_defineProperty({}, key, value));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.node.type && this.state.type != nextProps.node.type) {
	                this.setState({ type: nextProps.node.type });
	            }
	            if (nextProps.node.info.hasfloorplan && this.state.hasfloorplan != nextProps.node.info.hasfloorplan) {
	                this.setState({ hasfloorplan: nextProps.node.info.hasfloorplan });
	            }
	            if (nextProps.node.info.useownfp && this.state.useownfp != nextProps.node.info.useownfp) {
	                this.setState({ useownfp: nextProps.node.info.useownfp });
	            }
	        }
	    }, {
	        key: 'submitForm',
	        value: function submitForm() {
	            var img = document.getElementById("img");
	            if (img) img = img.files;
	            if (img) img = img[0];
	            var res = this.props.submit(this.props.node, img, this.state);
	            if (res[0]) {
	                // this.props.closeAddFloorplanForm();
	            } else {
	                    _toastr2['default'].error(res[1]);
	                }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var node = this.props.node;
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement('div', { className: "modals__overlay" + (this.props.isAddingFloorplan ? "" : " closed"), onClick: this.props.closeAddFloorplanForm }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: "modals__content " + (this.props.isAddingFloorplan ? "" : " closed") },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__header' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'close', onClick: this.props.closeAddFloorplanForm },
	                            '×'
	                        ),
	                        _react2['default'].createElement(
	                            'h4',
	                            { className: 'modals__content__header__title' },
	                            'Add Floor Plan'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__body settings-add-location-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                'Change area type'
	                            ),
	                            _react2['default'].createElement(
	                                'select',
	                                { id: 'type', value: this.state.type, onChange: this.changeHandler.bind(this) },
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: 'location' },
	                                    ' Mixed Area '
	                                ),
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: 'meeting_room' },
	                                    'Meeting Room'
	                                ),
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: 'open_area' },
	                                    'Open Area'
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                'Has floorplan ?'
	                            ),
	                            _react2['default'].createElement(
	                                'select',
	                                { id: 'hasfloorplan', value: this.state.hasfloorplan, onChange: this.changeHandler.bind(this) },
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: true },
	                                    ' Yes '
	                                ),
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: false },
	                                    ' No '
	                                )
	                            )
	                        ),
	                        this.state.hasfloorplan && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                'Use parent\'s floorplan ?'
	                            ),
	                            _react2['default'].createElement(
	                                'select',
	                                { id: 'useownfp', value: this.state.useownfp, onChange: this.changeHandler.bind(this) },
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: false },
	                                    ' Yes '
	                                ),
	                                _react2['default'].createElement(
	                                    'option',
	                                    { value: true },
	                                    ' No '
	                                )
	                            )
	                        ),
	                        this.state.hasfloorplan && this.state.useownfp && _react2['default'].createElement(
	                            'div',
	                            { className: 'upload-floorplan' },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                node.info.hasfloorplan ? _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    _react2['default'].createElement(
	                                        'b',
	                                        null,
	                                        'Already has floorplan.'
	                                    ),
	                                    ' Upload and replace :'
	                                ) : "Upload new floorplan :"
	                            ),
	                            _react2['default'].createElement('input', { type: 'file', id: 'img', ref: 'floorplanimage' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__footer' },
	                        _react2['default'].createElement(
	                            'button',
	                            { onClick: this.props.closeAddFloorplanForm, className: 'btn btn-default', type: 'button', 'data-dismiss': 'modal' },
	                            'Cancel'
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-success', onClick: this.submitForm.bind(this), type: 'button' },
	                            'Confirm'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddFloorPlanForm;
	})(_react2['default'].Component);
	
	exports['default'] = AddFloorPlanForm;
	module.exports = exports['default'];

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countriesAndTimezones = __webpack_require__(1263);
	
	var _countriesAndTimezones2 = _interopRequireDefault(_countriesAndTimezones);
	
	//import getCountryName, { isoCountries } from '../../countries';
	
	var EditLocationForm = (function (_React$Component) {
	    _inherits(EditLocationForm, _React$Component);
	
	    function EditLocationForm(props, context) {
	        _classCallCheck(this, EditLocationForm);
	
	        _get(Object.getPrototypeOf(EditLocationForm.prototype), 'constructor', this).call(this, props, context);
	        var node = this.props.node;
	        this.state = {
	            name: node.info.name,
	            country: node.type == "multicountry" ? "Multi" : _countriesAndTimezones2['default'].getCountriesForTimezone(node.info.location)[0].id,
	            timezone: node.info.location
	        };
	    }
	
	    _createClass(EditLocationForm, [{
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, value));
	            if (key == 'country') {
	                if (value != this.state.country) {
	                    var locations = this.getTimeZonesOfCountry(value);
	                    this.setState({ timezone: locations[0] });
	                }
	            }
	        }
	    }, {
	        key: 'generateCountryOptions',
	        value: function generateCountryOptions() {
	            var parent = this.props.node.parent;
	            var parentCountry = parent.type == "multicountry" ? "Multi" : _countriesAndTimezones2['default'].getCountriesForTimezone(parent.info.location)[0].id;
	            var countries = _countriesAndTimezones2['default'].getAllCountries();
	            if (parentCountry == 'Multi' || parent.type == "customer") {
	                var codes = Object.keys(countries);
	                codes.sort(function (a, b) {
	                    return countries[a].name.localeCompare(countries[b].name);
	                }); // sort country codes by full name.
	                return codes.map(function (code, index) {
	                    return _react2['default'].createElement(
	                        'option',
	                        { key: code, value: code },
	                        countries[code].name
	                    );
	                });
	            } else {
	                return _react2['default'].createElement(
	                    'option',
	                    { value: parentCountry },
	                    countries[parentCountry].name
	                );
	            }
	        }
	    }, {
	        key: 'getTimeZonesOfCountry',
	        value: function getTimeZonesOfCountry(country) {
	            return _countriesAndTimezones2['default'].getTimezonesForCountry(country).map(function (element) {
	                return element.name;
	            });
	        }
	    }, {
	        key: 'generateTimeZoneOptions',
	        value: function generateTimeZoneOptions() {
	            var options = this.getTimeZonesOfCountry(this.state.country);
	            return options.map(function (element, index) {
	                return _react2['default'].createElement(
	                    'option',
	                    { key: index, value: element },
	                    element
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var node = this.props.node;
	            var multi = node.type == "multicountry";
	            var timezones = this.generateTimeZoneOptions();
	            var countries = this.generateCountryOptions();
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement('div', { className: "modals__overlay" + (this.props.isEditingLocation ? "" : " closed"), onClick: this.props.closeEditLocationForm }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: "modals__content " + (this.props.isEditingLocation ? "" : " closed") },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__header' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'close', onClick: this.props.closeEditLocationForm },
	                            '×'
	                        ),
	                        _react2['default'].createElement(
	                            'h4',
	                            { className: 'modals__content__header__title' },
	                            'Edit Location'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__body settings--wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'user_email' },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Name '
	                                ),
	                                _react2['default'].createElement('input', { type: 'username', id: 'name', value: this.state.name, onChange: this.changeHandler.bind(this), required: true })
	                            )
	                        ),
	                        !multi && _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'country' },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    'Country'
	                                ),
	                                _react2['default'].createElement(
	                                    'select',
	                                    { value: this.state.country, id: 'country', onChange: this.changeHandler.bind(this) },
	                                    countries
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'timezone' },
	                                _react2['default'].createElement(
	                                    'label',
	                                    null,
	                                    'Timezone'
	                                ),
	                                _react2['default'].createElement(
	                                    'select',
	                                    { value: this.state.timezone, id: 'timezone', onChange: this.changeHandler.bind(this) },
	                                    timezones
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__footer' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-default', type: 'button', onClick: this.props.closeEditLocationForm },
	                            'Cancel'
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-success', type: 'button', onClick: function () {
	                                    _this.props.submit(node, _this.state);
	                                } },
	                            'Confirm'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditLocationForm;
	})(_react2['default'].Component);
	
	exports['default'] = EditLocationForm;
	module.exports = exports['default'];

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DeleteLocationForm = (function (_React$Component) {
	    _inherits(DeleteLocationForm, _React$Component);
	
	    function DeleteLocationForm(props, context) {
	        _classCallCheck(this, DeleteLocationForm);
	
	        _get(Object.getPrototypeOf(DeleteLocationForm.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            type: 'only'
	        };
	    }
	
	    _createClass(DeleteLocationForm, [{
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, value));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement('div', { style: { backgroundColor: 'transparent' }, className: "modals__overlay" + (this.props.isDeletingLocation ? "" : " closed"), onClick: this.props.closeDeleteLocationForm }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: "modals__content " + (this.props.isDeletingLocation ? "" : " closed") },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__header' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'close', onClick: this.props.closeDeleteLocationForm, type: 'button', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                            '×'
	                        ),
	                        _react2['default'].createElement(
	                            'h4',
	                            { className: 'modals__content__header__title' },
	                            'Delete Location'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__body delete-user-wrapper' },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Are you sure you want to delete ',
	                            this.props.node.info.name,
	                            ' ?'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'zone-type' },
	                            _react2['default'].createElement(
	                                'label',
	                                { htmlFor: 'country' },
	                                _react2['default'].createElement('input', { className: 'zone-radio', onChange: this.changeHandler.bind(this), id: 'type', value: 'only', type: 'radio', name: 'zone', checked: this.state.type == 'only' }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'Only this location'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'label',
	                                { htmlFor: 'multi' },
	                                _react2['default'].createElement('input', { className: 'zone-radio', onChange: this.changeHandler.bind(this), id: 'type', value: 'all', type: 'radio', name: 'zone', checked: this.state.type == 'all' }),
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    'This location and all sub-locations  '
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'modals__content__footer' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-default', onClick: this.props.closeDeleteLocationForm, type: 'button', 'data-dismiss': 'modal' },
	                            'Cancel'
	                        ),
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-danger', onClick: function () {
	                                    _this.props.submit(_this.props.node, _this.state.type);
	                                }, type: 'button' },
	                            'Delete'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeleteLocationForm;
	})(_react2['default'].Component);
	
	exports['default'] = DeleteLocationForm;
	module.exports = exports['default'];

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var ConfirmDeleteLocationForm = (function (_React$Component) {
	    _inherits(ConfirmDeleteLocationForm, _React$Component);
	
	    function ConfirmDeleteLocationForm() {
	        _classCallCheck(this, ConfirmDeleteLocationForm);
	
	        _get(Object.getPrototypeOf(ConfirmDeleteLocationForm.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(ConfirmDeleteLocationForm, [{
	        key: "render",
	        value: function render() {
	            var _this = this;
	
	            return _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement("div", { className: "modals__overlay" + (this.props.isConfirmingDeleteLocation ? "" : " closed"), onClick: this.props.closeConfirmDeleteLocationForm }),
	                _react2["default"].createElement(
	                    "div",
	                    { className: "modals__content " + (this.props.isConfirmingDeleteLocation ? "" : " closed") },
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "modals__content__header" },
	                        _react2["default"].createElement(
	                            "button",
	                            { className: "close", onClick: this.props.closeConfirmDeleteLocationForm, type: "button", "data-dismiss": "modal", "aria-hidden": "true" },
	                            "×"
	                        ),
	                        _react2["default"].createElement(
	                            "h4",
	                            { className: "modals__content__header__title" },
	                            "Confirm Delete Location"
	                        )
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "modals__content__body delete-user-wrapper" },
	                        _react2["default"].createElement(
	                            "p",
	                            null,
	                            "Chosen location ",
	                            this.props.type ? 'and all related data ' : '',
	                            "will be deleted !"
	                        )
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "modals__content__footer" },
	                        _react2["default"].createElement(
	                            "button",
	                            { className: "btn btn-default", onClick: this.props.closeConfirmDeleteLocationForm, type: "button", "data-dismiss": "modal" },
	                            "Cancel"
	                        ),
	                        _react2["default"].createElement(
	                            "button",
	                            { className: "btn btn-danger", onClick: function () {
	                                    _this.props.submit(_this.props.node);
	                                    _this.props.closeConfirmDeleteLocationForm();
	                                }, type: "button" },
	                            "OK"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConfirmDeleteLocationForm;
	})(_react2["default"].Component);
	
	exports["default"] = ConfirmDeleteLocationForm;
	module.exports = exports["default"];

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDateselector = __webpack_require__(456);
	
	var _componentsCommonDateselector2 = _interopRequireDefault(_componentsCommonDateselector);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var StatsMenu = function StatsMenu(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'stats-menu' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'pull-left display--flex--in-row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'stats-menu__list flex--vertical--horizontal' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'stats-menu__list-item stats-menu__list-item_bold' },
	                    props.leftItemBold
	                ),
	                props.leftItems
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'pull-right display--flex--in-row' },
	            props.withDateSelector && _react2['default'].createElement(
	                'div',
	                { className: 'stats-menu__list flex--vertical--horizontal' },
	                _react2['default'].createElement(_componentsCommonDateselector2['default'], null)
	            ),
	            props.rightItems && _react2['default'].createElement(
	                'div',
	                { className: 'stats-menu__list flex--vertical--horizontal' },
	                props.rightItems
	            )
	        )
	    );
	};
	StatsMenu.propTypes = {
	    withDateSelector: _propTypes2['default'].any,
	    leftItemBold: _propTypes2['default'].any,
	    leftItems: _propTypes2['default'].any,
	    rightItems: _propTypes2['default'].any
	};
	exports['default'] = StatsMenu;
	module.exports = exports['default'];

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _componentsPagesComparisonComparisoncard = __webpack_require__(1271);
	
	var _componentsPagesComparisonComparisoncard2 = _interopRequireDefault(_componentsPagesComparisonComparisoncard);
	
	var _componentsPagesComparisonCharts = __webpack_require__(1274);
	
	var _componentsPagesComparisonCharts2 = _interopRequireDefault(_componentsPagesComparisonCharts);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var Comparison = (function (_React$Component) {
	    _inherits(Comparison, _React$Component);
	
	    function Comparison() {
	        _classCallCheck(this, Comparison);
	
	        _get(Object.getPrototypeOf(Comparison.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Comparison, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'comparison-page' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: true
	                    },
	                    _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                        overviewIsActive: false,
	                        comparisonIsActive: true,
	                        onlyLeftMenu: false
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2['default'].createElement(_componentsPagesComparisonComparisoncard2['default'], null),
	                    _react2['default'].createElement(_componentsPagesComparisonCharts2['default'], null)
	                )
	            );
	        }
	    }]);
	
	    return Comparison;
	})(_react2['default'].Component);
	
	exports['default'] = Comparison;
	module.exports = exports['default'];

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonSearchbardropdown = __webpack_require__(416);
	
	var _componentsCommonSearchbardropdown2 = _interopRequireDefault(_componentsCommonSearchbardropdown);
	
	var _actionsComparison = __webpack_require__(205);
	
	var _componentsPagesComparisonComparisoncardWidgets = __webpack_require__(1272);
	
	var _componentsPagesComparisonComparisoncardWidgets2 = _interopRequireDefault(_componentsPagesComparisonComparisoncardWidgets);
	
	var _componentsPagesComparisonComparisoncardComparisonstats = __webpack_require__(1273);
	
	var _componentsPagesComparisonComparisoncardComparisonstats2 = _interopRequireDefault(_componentsPagesComparisonComparisoncardComparisonstats);
	
	var ComparisonCard = (function (_React$Component) {
	    _inherits(ComparisonCard, _React$Component);
	
	    function ComparisonCard(props) {
	        _classCallCheck(this, ComparisonCard);
	
	        _get(Object.getPrototypeOf(ComparisonCard.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            value: [{ label: undefined }, { label: undefined }]
	        };
	    }
	
	    _createClass(ComparisonCard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Default location
	            var nextProps = this.props;
	            if (nextProps.tree.id > 0) {
	                if (nextProps.tree.children) {
	                    if (nextProps.tree.type == 'customer') {
	                        this.chooseFirstLocation(nextProps.tree.children[0]);
	                        this.chooseSecondLocation(nextProps.tree.children[0]);
	                    } else {
	                        this.chooseFirstLocation(nextProps.tree);
	                        this.chooseSecondLocation(nextProps.tree);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'chooseFirstLocation',
	        value: function chooseFirstLocation(node) {
	            if (node.id) {
	                this.updateInput(0, node);
	                this.props.dispatch((0, _actionsComparison.putNode)(node, 0));
	            }
	        }
	    }, {
	        key: 'chooseSecondLocation',
	        value: function chooseSecondLocation(node) {
	            if (node.id) {
	                this.updateInput(1, node);
	                this.props.dispatch((0, _actionsComparison.putNode)(node, 1));
	            }
	        }
	    }, {
	        key: 'updateInput',
	        value: function updateInput(id, node) {
	            var value = this.state.value.slice();
	            value[id].label = node.info.name;
	            this.setState({
	                value: value
	            });
	        }
	    }, {
	        key: 'resetInput',
	        value: function resetInput(id) {
	            var value = this.state.value.slice();
	            value[id].label = undefined;
	            this.setState({
	                value: value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'comparison-grid-widget' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'grid-widget__first-location' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'comparison__search-container' },
	                        _react2['default'].createElement(_componentsCommonSearchbardropdown2['default'], {
	                            onChange: function (node) {
	                                _this.chooseFirstLocation(node);
	                            },
	                            onFocus: function () {
	                                _this.resetInput(0);
	                            },
	                            onOpen: function () {
	                                _this.resetInput(0);
	                            },
	                            onClose: function () {},
	                            value: this.state.value[0],
	                            tree: this.props.tree
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'grid-widget__second-location' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'comparison__search-container' },
	                        _react2['default'].createElement(_componentsCommonSearchbardropdown2['default'], {
	                            onChange: function (node) {
	                                _this.chooseSecondLocation(node);
	                            },
	                            onFocus: function () {
	                                _this.resetInput(1);
	                            },
	                            onOpen: function () {
	                                _this.resetInput(1);
	                            },
	                            onClose: function () {},
	                            value: this.state.value[1],
	                            tree: this.props.tree
	                        })
	                    )
	                ),
	                _react2['default'].createElement(_componentsPagesComparisonComparisoncardWidgets2['default'], { querySettings: this.props.querySettings, allSensors: this.props.allSensors }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'grid-widget-card' },
	                    _react2['default'].createElement(_componentsPagesComparisonComparisoncardComparisonstats2['default'], null)
	                )
	            );
	        }
	    }]);
	
	    return ComparisonCard;
	})(_react2['default'].Component);
	
	exports.ComparisonCard = ComparisonCard;
	
	function mapStateToProps(state) {
	    return {
	        tree: state.overviewReducer.customerOverview,
	        querySettings: state.querySettingsReducer,
	        allSensors: state.nodeReducer.map
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ComparisonCard);

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesOverviewWidgetsWidgetcontainer = __webpack_require__(1237);
	
	var _componentsPagesOverviewWidgetsWidgetcontainer2 = _interopRequireDefault(_componentsPagesOverviewWidgetsWidgetcontainer);
	
	var _actionsComparison = __webpack_require__(205);
	
	var Widgets = (function (_React$Component) {
	    _inherits(Widgets, _React$Component);
	
	    function Widgets() {
	        _classCallCheck(this, Widgets);
	
	        _get(Object.getPrototypeOf(Widgets.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Widgets, [{
	        key: 'deleteWidget',
	        value: function deleteWidget() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                this.props.nodes.map(function (node, index) {
	                    if (node) {
	                        return _react2['default'].createElement(_componentsPagesOverviewWidgetsWidgetcontainer2['default'], {
	                            isComparisonWidget: true,
	                            id: index, key: index, node: node,
	                            allSensors: _this.props.allSensors,
	                            deleteWidget: _this.deleteWidget.bind(_this),
	                            querySettings: _this.props.querySettings,
	                            action: index == 0 ? _actionsComparison.RECEIVE_FIRST_LOCATION_OVERVIEW : _actionsComparison.RECEIVE_SECOND_LOCATION_OVERVIEW
	                        });
	                    } else {
	                        return null;
	                    }
	                })
	            );
	        }
	    }]);
	
	    return Widgets;
	})(_react2['default'].Component);
	
	exports.Widgets = Widgets;
	
	function mapStateToProps(state) {
	    return {
	        nodes: state.comparisonReducer.nodes
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Widgets);

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	//import Modal from "components/common/modal";
	
	var ComparisonStats = (function (_React$Component) {
	    _inherits(ComparisonStats, _React$Component);
	
	    function ComparisonStats(props, context) {
	        _classCallCheck(this, ComparisonStats);
	
	        _get(Object.getPrototypeOf(ComparisonStats.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            peak: 0,
	            average: 0,
	            aboveHighMark: 0,
	            belowHighMark: 0
	        };
	    }
	
	    _createClass(ComparisonStats, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.nodes[0] && nextProps.nodes[1]) {
	                var overview0 = nextProps.overviewMap[nextProps.nodes[0].id];
	                var overview1 = nextProps.overviewMap[nextProps.nodes[1].id];
	                if (overview0 && overview1 && !overview0.loading && !overview1.loading) {
	                    var data0 = overview0.data;
	                    var data1 = overview1.data;
	                    if (data0 && data1) {
	                        var mHigh = 0,
	                            mLow = 0;
	                        if (data0.marks && data1.marks) {
	                            mHigh = Math.round((data0.marks[2] - data1.marks[2]) * 10000) / 100;
	                            mLow = Math.round((data0.marks[0] - data1.marks[0]) * 10000) / 100;
	                        }
	                        this.setState({
	                            peak: Math.round((data0.peak - data1.peak) * 10000) / 100,
	                            average: Math.round((data0.average - data1.average) * 10000) / 100,
	                            aboveHighMark: mHigh,
	                            belowHighMark: mLow
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'widget-card__comparison-stats box--shadow bg--white ' },
	                _react2['default'].createElement(
	                    'h2',
	                    { className: 'widget-card__comparison-stats__title' },
	                    'Comparison'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'widget-card__comparison-stats__body' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Peak: ',
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            ' ',
	                            this.state.peak > 0 ? '+' + this.state.peak : this.state.peak,
	                            '%'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Average: ',
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            '  ',
	                            this.state.average > 0 ? '+' + this.state.average : this.state.average,
	                            '%  '
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Above High Mark: ',
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            ' ',
	                            this.state.aboveHighMark > 0 ? '+' + this.state.aboveHighMark : this.state.aboveHighMark,
	                            '%  '
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Below Low Mark: ',
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            ' ',
	                            this.state.belowHighMark > 0 ? '+' + this.state.belowHighMark : this.state.belowHighMark,
	                            '%  '
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComparisonStats;
	})(_react2['default'].Component);
	
	exports.ComparisonStats = ComparisonStats;
	
	function mapStateToProps(state) {
	    return {
	        nodes: state.comparisonReducer.nodes,
	        overviewMap: state.statsReducer.overviewMap
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, null)(ComparisonStats);
	/*   <div className="clearfix">
	   <div className="col-xs-12">
	       <Modal
	           disableCloseButton={true}
	           ref={(elem) => { this.openInfoModal = elem }}
	           clickButton={() => { this.openInfoModal.close(); }}
	           header="Info Modal"
	           buttonText="Got it"
	           buttonClass="btn-success"
	           entry={
	               <div style={{ marginRight: "-5px" }} onClick={() => { this.openInfoModal.open() }} className="pull-right">
	                   <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	               </div>
	           }
	       >
	           <p>Comparison stats Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	       </Modal>
	   </div>
	       </div>*/

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesComparisonChartsTotalchart = __webpack_require__(1275);
	
	var _componentsPagesComparisonChartsTotalchart2 = _interopRequireDefault(_componentsPagesComparisonChartsTotalchart);
	
	var _componentsPagesComparisonChartsRangechart = __webpack_require__(1283);
	
	var _componentsPagesComparisonChartsRangechart2 = _interopRequireDefault(_componentsPagesComparisonChartsRangechart);
	
	var _componentsPagesComparisonChartsDailychart = __webpack_require__(1285);
	
	var _componentsPagesComparisonChartsDailychart2 = _interopRequireDefault(_componentsPagesComparisonChartsDailychart);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsComparison = __webpack_require__(205);
	
	var Charts = (function (_React$Component) {
	    _inherits(Charts, _React$Component);
	
	    function Charts() {
	        _classCallCheck(this, Charts);
	
	        _get(Object.getPrototypeOf(Charts.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Charts, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.getStats(nextProps, 0);
	            this.getStats(nextProps, 1);
	        }
	    }, {
	        key: 'getStats',
	        value: function getStats(nextProps, location) {
	            if (nextProps.comparisonStats.nodes !== this.props.comparisonStats.nodes || nextProps.querySettings != this.props.querySettings) {
	                var id = nextProps.comparisonStats.nodes[location].id;
	                var card = this.props.cards[nextProps.comparisonStats.nodes[location].info.cardid];
	                var tagType = nextProps.comparisonStats.nodes[location].type;
	                var params = (0, _actionsStats.getComparisonParams)({ querySettings: nextProps.querySettings }, id, card, tagType);
	                console.log("params to fetch");
	                console.log(params);
	                if (location === 0) {
	                    var params1 = Object.assign({}, params);
	                    params1.action = _actionsComparison.RECEIVE_FIRST_LOCATION_TOTAL;
	                    this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params1));
	                    var params2 = Object.assign({}, params);
	                    params2.action = _actionsComparison.RECEIVE_FIRST_LOCATION_DAILY;
	                    this.props.dispatch((0, _actionsStats.getStatsDaily)(params2));
	                    var params3 = Object.assign({}, params);
	                    params3.action = _actionsComparison.RECEIVE_FIRST_LOCATION_RANGE;
	                    params3.groupby = 'hour';
	                    this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params3));
	                } else {
	                    var params1 = Object.assign({}, params);
	                    params1.action = _actionsComparison.RECEIVE_SECOND_LOCATION_TOTAL;
	                    this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params1));
	                    var params2 = Object.assign({}, params);
	                    params2.action = _actionsComparison.RECEIVE_SECOND_LOCATION_DAILY;
	                    this.props.dispatch((0, _actionsStats.getStatsDaily)(params2));
	                    var params3 = Object.assign({}, params);
	                    params3.action = _actionsComparison.RECEIVE_SECOND_LOCATION_RANGE;
	                    params3.groupby = 'hour';
	                    this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params3));
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var first = {};
	            var second = {};
	            var isMeetingRoom = false;
	            if (this.props.comparisonStats.nodes[0] && this.props.comparisonStats.nodes[1]) {
	                first = this.props.comparisonStats.nodes[0];
	                second = this.props.comparisonStats.nodes[1];
	                // if isMeetingRoom is true, display TagSelector on charts
	                isMeetingRoom = this.props.comparisonStats.nodes[0].type === "meeting_room" && this.props.comparisonStats.nodes[0].type === this.props.comparisonStats.nodes[1].type;
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: 'comparison-stats-cards-wrapper' },
	                _react2['default'].createElement(_componentsPagesComparisonChartsTotalchart2['default'], { isMeetingRoom: isMeetingRoom, querySettings: this.props.querySettings, stats: this.props.comparisonStats.total, first: first, second: second }),
	                _react2['default'].createElement(_componentsPagesComparisonChartsRangechart2['default'], { isMeetingRoom: isMeetingRoom, querySettings: this.props.querySettings, stats: this.props.comparisonStats.range, first: first, second: second }),
	                _react2['default'].createElement(_componentsPagesComparisonChartsDailychart2['default'], { isMeetingRoom: isMeetingRoom, querySettings: this.props.querySettings, stats: this.props.comparisonStats.daily, first: first, second: second })
	            );
	        }
	    }]);
	
	    return Charts;
	})(_react2['default'].Component);
	
	exports.Charts = Charts;
	
	function mapStateToProps(state) {
	    return {
	        comparisonStats: state.comparisonReducer,
	        querySettings: state.querySettingsReducer,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Charts);

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsComparison = __webpack_require__(205);
	
	var _componentsCommonChartsLinechart = __webpack_require__(1276);
	
	var _componentsCommonChartsLinechart2 = _interopRequireDefault(_componentsCommonChartsLinechart);
	
	var _componentsCommonDropdowncomponentsModeselector = __webpack_require__(1281);
	
	var _componentsCommonDropdowncomponentsModeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsModeselector);
	
	var _componentsCommonDropdowncomponentsTagselector = __webpack_require__(1282);
	
	var _componentsCommonDropdowncomponentsTagselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsTagselector);
	
	//import Modal from "components/common/modal";
	
	var TotalChart = (function (_React$Component) {
	    _inherits(TotalChart, _React$Component);
	
	    function TotalChart(props, context) {
	        _classCallCheck(this, TotalChart);
	
	        _get(Object.getPrototypeOf(TotalChart.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            mode: 'Average',
	            tag: 'Occupancy'
	        };
	    }
	
	    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
	    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
	
	    _createClass(TotalChart, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.isMeetingRoom !== this.props.isMeetingRoom || nextProps.querySettings !== this.props.querySettings) {
	                this.setState({
	                    tag: 'Occupancy'
	                });
	            }
	        }
	    }, {
	        key: 'getLabels',
	        value: function getLabels() {
	            if (this.props.stats[0].data.constraint.startdate === this.props.stats[0].data.constraint.enddate) {
	                return this.props.stats[0].data.points.map(function (point) {
	                    return point.time.substr(0, 2);
	                });
	            } else if (this.props.stats[0].data.constraint.groupby === 'month') {
	                return this.props.stats[0].data.points.map(function (point) {
	                    return point.time.substr(0, 8);
	                });
	            } else {
	                return this.props.stats[0].data.points.map(function (point) {
	                    return point.time.substr(0, 11);
	                });
	            }
	        }
	    }, {
	        key: 'getData',
	        value: function getData(index) {
	            var _this = this;
	
	            if (this.props.stats[index]) {
	                return this.props.stats[index].data.points.map(function (point) {
	                    return Math.round(point[_this.state.mode === 'Average' ? 'avg' : 'pk'] * 100);
	                });
	            } else {
	                return [];
	            }
	        }
	    }, {
	        key: 'chooseMode',
	        value: function chooseMode(mode) {
	            this.setState({ mode: mode });
	        }
	    }, {
	        key: 'chooseTag',
	        value: function chooseTag(tag) {
	
	            this.setState({ tag: tag });
	            var params = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.first });
	            params.action = _actionsComparison.RECEIVE_FIRST_LOCATION_TOTAL;
	            var params1 = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.second });
	            params1.action = _actionsComparison.RECEIVE_SECOND_LOCATION_TOTAL;
	            if (tag === 'Occupancy') {
	                params.tag = (0, _actionsStats.findOccupancyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findOccupancyTag)(this.props.second);
	            } else {
	                params.tag = (0, _actionsStats.findEfficiencyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findEfficiencyTag)(this.props.second);
	            }
	            this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params));
	            this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params1));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = {};
	            if (this.props.stats) {
	                if (this.props.stats.length > 0) {
	                    data.labels = this.getLabels();
	                    data.avgs = this.getData(1);
	                    data.peaks = this.getData(0);
	                }
	            }
	            var first = '';
	            var second = '';
	            if (this.props.first.info && this.props.first.info) {
	                first = this.props.first.info.name;
	                second = this.props.second.info.name;
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'card__graph box--shadow bg--white' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'clearfix graph__header' },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: 'graph__header__title graph__header__title--comparison-title pull-left' },
	                            'Total ',
	                            this.state.tag,
	                            ' Comparison'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__header__options pull-right' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsModeselector2['default'], { mode: this.state.mode, chooseMode: this.chooseMode.bind(this) })
	                            ),
	                            this.props.isMeetingRoom && _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsTagselector2['default'], { roomType: 'meeting_room', tag: this.state.tag, chooseTag: this.chooseTag.bind(this) })
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body' },
	                        _react2['default'].createElement(_componentsCommonChartsLinechart2['default'], { id: 'totalOccupancy1', stats: data, first: first, second: second })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TotalChart;
	})(_react2['default'].Component);
	
	exports.TotalChart = TotalChart;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(TotalChart);
	/*
	<Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openInfoModal = elem }}
	   clickButton={() => { this.openInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	       <div className="header__options__child pull-left">
	           <div onClick={() => { this.openInfoModal.open() }} className="">
	               <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	           </div>
	       </div>
	   }
	>
	   <p>Total Comparsion Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>
	*/

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _zingchartReact = __webpack_require__(1277);
	
	var _componentsCommonChartsCommonchartconfig = __webpack_require__(1280);
	
	var _componentsCommonChartsCommonchartconfig2 = _interopRequireDefault(_componentsCommonChartsCommonchartconfig);
	
	/*
	This component is used in
	components/pages/comparison/charts/dailychart/index.jsx
	components/pages/comparison/charts/totalchart/index.jsx
	components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
	components/pages/stats/totaloccupancy/index.jsx
	components/pages/stats/totaloccupancy/linechartcontainer.jsx
	*/
	var LineChart = function LineChart(props) {
	    var myConfig = Object.assign({}, _componentsCommonChartsCommonchartconfig2['default'], {
	
	        type: "line",
	        plotarea: {
	            marginTop: '10px',
	            marginRight: '50px',
	            marginLeft: '40px',
	            backgroundColor: "#f6f7fa"
	        },
	        legend: {
	            layout: "float",
	            backgroundColor: "none",
	            borderWidth: 0,
	            shadow: 0,
	            align: "center",
	            adjustLayout: true,
	            item: {
	                padding: 7,
	                marginRight: 17,
	                cursor: "hand"
	            }
	        },
	        scaleX: {
	            labels: props.stats.labels,
	            minorTicks: 0
	        },
	        scaleY: {
	            values: "0:100:20",
	            lineColor: "#f6f7f8",
	            shadow: 0,
	            format: "%v%",
	            guide: {
	                lineStyle: "dashed",
	                lineColor: "white"
	            },
	            markers: [{
	                type: "area",
	                range: [80, 100],
	                lineColor: "#e39199",
	                lineWidth: 2
	
	            }, {
	                type: "area",
	                range: [0, 20],
	                lineColor: "#faf8f9",
	                lineWidth: 2
	
	            }],
	            minorTicks: 0,
	            thousandsSeparator: ","
	        },
	        crosshairX: {
	            lineColor: "#efefef",
	            plotLabel: {
	                borderRadius: "5px",
	                borderWidth: "1px",
	                borderColor: "#f6f7f8",
	                padding: "10px",
	                fontWeight: "bold"
	            },
	            scaleLabel: {
	                fontColor: "#000",
	                backgroundColor: "#f6f7fa",
	                borderRadius: "5px"
	            }
	        },
	        tooltip: {
	            visible: false
	        },
	        plot: {
	            highlight: true,
	            tooltipText: "%t views: %v<br>%k",
	            shadow: 0,
	            lineWidth: "2px",
	            marker: {
	                type: "circle",
	                size: 1.6
	            },
	            highlightState: {
	                lineWidth: 3
	            }
	        },
	        series: [{
	            values: props.stats.peaks,
	            text: props.first || "Peak",
	            lineColor: "#60aff4",
	            lineWidth: 5,
	            legendItem: {
	                backgroundColor: "#60aff4",
	                borderRadius: 5,
	                fontColor: "white",
	                fontSize: "16px"
	            },
	            legendMarker: {
	                visible: false
	            },
	            marker: {
	                backgroundColor: "#60aff4",
	                borderWidth: 0,
	                shadow: 0,
	                borderColor: "#69dbf1"
	            },
	            highlightMarker: {
	                size: 5,
	                backgroundColor: "#60aff4"
	            }
	        }, {
	            values: props.stats.avgs,
	            text: props.second || "Average",
	            lineColor: "#3cb449",
	            legendItem: {
	                backgroundColor: "#3cb449",
	                borderRadius: 5,
	                fontColor: "white",
	                fontSize: "16px"
	            },
	            lineWidth: 5,
	            legendMarker: {
	                visible: false
	            },
	            marker: {
	                backgroundColor: "#3cb449",
	                borderwidth: 0,
	                shadow: 0,
	                borderColor: "#3cb449"
	            },
	            highlightMarker: {
	                size: 5,
	                backgroundColor: "#3cb449"
	            }
	        }]
	    });
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(_zingchartReact.core, { id: props.id, data: myConfig, height: '450px', width: '100%' })
	    );
	};
	exports['default'] = LineChart;
	module.exports = exports['default'];

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(t){return t&&t.__esModule?t:{default:t}}function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function applyAttrs(t,e){t.legend&&"true"==t.legend.toLowerCase()&&(e.plotarea=e.plotarea||{},e.plotarea.marginRight="150px",e.legend={maxItems:"4",overflow:"page"}),t.title&&(e.title={text:t.title})}Object.defineProperty(exports,"__esModule",{value:!0}),exports.scatter=exports.pie=exports.bar=exports.area=exports.line=exports.core=void 0;var _createClass=function(){function t(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,r,i){return r&&t(e.prototype,r),i&&t(e,i),e}}(),_zingchart=__webpack_require__(1278),_zingchart2=_interopRequireDefault(_zingchart),_react=__webpack_require__(38),_react2=_interopRequireDefault(_react),Core=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){return _react2.default.createElement("div",{id:this.props.id})}},{key:"componentDidMount",value:function(){_zingchart2.default.render({id:this.props.id,width:this.props.width||600,height:this.props.height||400,data:this.props.data,theme:this.props.theme?this.props.theme:"light"})}},{key:"shouldComponentUpdate",value:function(t,e){return!(JSON.stringify(t.data)===JSON.stringify(this.props.data))}},{key:"componentWillUpdate",value:function(t){_zingchart2.default.exec(this.props.id,"setdata",{data:t.data})}},{key:"componentWillUnmount",value:function(){_zingchart2.default.exec(this.props.id,"destroy")}}]),e}(_react.Component),Line=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){var t={type:"line",series:this.props.series};return applyAttrs(this.props,t),_react2.default.createElement(Core,{id:this.props.id,height:this.props.height,width:this.props.width,data:t,theme:this.props.theme})}}]),e}(_react.Component),Area=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){var t={type:"area",series:this.props.series};return applyAttrs(this.props,t),_react2.default.createElement(Core,{id:this.props.id,height:this.props.height,width:this.props.width,data:t,theme:this.props.theme})}}]),e}(_react.Component),Bar=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){var t={type:"bar",series:this.props.series};return applyAttrs(this.props,t),_react2.default.createElement(Core,{id:this.props.id,height:this.props.height,width:this.props.width,data:t,theme:this.props.theme})}}]),e}(_react.Component),Scatter=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){var t={type:"scatter",series:this.props.series};return applyAttrs(this.props,t),_react2.default.createElement(Core,{id:this.props.id,height:this.props.height,width:this.props.width,data:t,theme:this.props.theme})}}]),e}(_react.Component),Pie=function(t){function e(){return _classCallCheck(this,e),_possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return _inherits(e,t),_createClass(e,[{key:"render",value:function(){var t={type:"pie",series:this.props.series};return applyAttrs(this.props,t),_react2.default.createElement(Core,{id:this.props.id,height:this.props.height,width:this.props.width,data:t,theme:this.props.theme})}}]),e}(_react.Component);exports.core=Core,exports.line=Line,exports.area=Area,exports.bar=Bar,exports.pie=Pie,exports.scatter=Scatter;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1279);
	zingchart.MODULESDIR = './modules/';
	module.exports = zingchart;


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	/*
	All of the code within the ZingChart software is developed and copyrighted by ZingChart, Inc., and may not be copied,
	replicated, or used in any other software or application without prior permission from ZingChart. All usage must coincide with the
	ZingChart End User License Agreement which can be requested by email at support@zingchart.com.
	
	Build 2.9.9
	*/
	if(typeof(ZC)==="undefined"){if(window.ZC={AV:function(e,i){if(e.indexOf)return e.indexOf(i);for(var t=0,n=e.length;t<n;t++)if(e[t]===i)return t;return-1},VERSION:"2.9.9",VERSIONID:"2.9.9.2022.03.07",LICENSEKEY:"",ABV:!1,CHARTS:["null","null3d","line","line3d","vline","area","area3d","varea","bar","bar3d","vbar","vbar3d","hbar","hbar3d","scatter","hscatter","bubble","hbubble","pie","pie3d","ring","ring3d","nestedpie","mixed","mixed3d","hmixed","radar","bullet","vbullet","hbullet","funnel","vfunnel","hfunnel","piano","heatmap","stock","range","vrange","gauge","venn"],EQUIV:{floatbar:["vfloatbar","hfloatbar"],boxplot:["vboxplot","hboxplot"],waterfall:["vwaterfall","hwaterfall"],populationpyramid:["population-pyramid","pop-pyramid"],bubblepie:["bubble-pie","bubblepie"],bar:["column","vbar"],radar:["polar","radar"],stream:["vstream"]},ALIAS:{ring:"pie"},execFn:function(e,i){var t=[].slice.call(arguments).splice(2);return ZC.evalFn(e,i).apply(i,t)},evalFn:function(e,i){for(var t=e.split("."),n=t.pop(),a=0;a<t.length;a++)i=i[t[a]];return i[n]},cache:{data:{},size:0,add:function(e,i){ZC.cache.data[e]=i,ZC.cache.size++,ZC.cache.size>2048&&(ZC.cache.data={},ZC.cache.size=0)}},DEBUG:0,TS:{},MAX:Number.MAX_VALUE,IMG404:[],BLANK:"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",TTLOCK:!1,REFRESH_TICK:{},ASYNC_TICK:[],COLORS:[],SEQ:0,LOGO_ABOUT:"data:image/png;base64,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",IMAGES:{"zc.logo":"data:image/gif;base64,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"},hosted:!1,adapter:"",flash:null,canvas:null,svg:null,vml:null,move:!1,objmove:!1,compat:function(){ZC.flash=ZC.canvas=ZC.svg=ZC.vml=!1;var e=!!document.createElement("canvas").getContext,i=!1;e&&(i="function"==typeof document.createElement("canvas").getContext("2d").fillText);ZC.canvas=e&&i,ZC.svg=document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1");var t=document.body.appendChild(document.createElement("div")),n=document.createElement("zcv:shape");n.className="zcvml",n.setAttribute("id","vml_flag1"),n.setAttribute("adj",new Object),t.appendChild(n),n.style.behavior="url(#default#VML)",ZC.vml=!n||"object"==typeof n.adj,t.parentNode.removeChild(t);var a=!1;navigator.mimeTypes&&navigator.mimeTypes["application/x-shockwave-flash"]?a=navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin:document.all&&-1===navigator.appVersion.indexOf("Mac")&&(a=new Function('try { var xObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");if (xObj) { xObj = null; return true; } } catch (e) { return false; }')()),ZC.flash=a?1:0},quirks:!(document.compatMode&&"CSS1Compat"===document.compatMode),ie67:!!/MSIE (\d+\.\d+);/.test(navigator.userAgent)&&parseFloat(RegExp.$1)<8,ie678:!!/MSIE (\d+\.\d+);/.test(navigator.userAgent)&&parseFloat(RegExp.$1)<9,mobile:/Mobile|BlackBerry|Opera Mini|PPC|Windows CE|Android/.test(navigator.userAgent),ipad:/iPad/.test(navigator.userAgent),iphone:/iPhone/.test(navigator.userAgent),websockets:"WebSocket"in window,webstorage:"sessionStorage"in window,RO:[],WG:[],E1:[0,0],ACO:null,_cp_:function(e,i,t,n,a,l){null===ZC._n_(t)&&(t=!0),null===ZC._n_(n)&&(n=!0),null===ZC._n_(a)&&(a=!1);var o=(l=l||[]).length;for(var r in e)if(0===o||o>0&&-1===ZC.AV(l,r))if(e[r]instanceof Array){if(n){(null===ZC._n_(i[r])||"override"!==r&&!a)&&(i[r]=[]);for(var s=0,A=e[r].length;s<A;s++)i[r].push(e[r][s])}}else e[r]instanceof Object&&!(e[r]instanceof Function)?n&&(null===ZC._n_(i[r])&&(i[r]={}),i[r]instanceof Object&&!(i[r]instanceof Function)&&ZC._cp_(e[r],i[r],t)):(null===ZC._n_(i[r])||t)&&(i[r]=e[r])},_cpa_:function(e,i){i||(i=[]);for(var t=0,n=e.length;t<n;t++)i.push(e[t])},_inj_:function(e,i){var t={};ZC._cp_(e,t),ZC._cp_(i,e),ZC._cp_(t,e)},_todash_:function(e,i,t){if("dashed"!==zingchart.SYNTAX){void 0===i&&(i=!0);var n,a,l=(t=t||[]).length;for(var o in e)if(e.hasOwnProperty(o)&&(0===l||l>0&&-1===ZC.AV(t,o))){var r=o.substring(0,1);if("."!==r&&"#"!==r)if(e[o]instanceof Array)if(ZC.UM(o)!==o){for(e[ZC.UM(o)]=[],n=0,a=e[o].length;n<a;n++)ZC._todash_(e[o][n]),e[ZC.UM(o)].push(e[o][n]);delete e[o]}else for(n=0,a=e[o].length;n<a;n++)ZC._todash_(e[o][n]);else e[o]instanceof Object&&!(e[o]instanceof Function)?(ZC.UM(o)!==o&&(e[ZC.UM(o)]={},ZC._cp_(e[o],e[ZC.UM(o)]),delete e[o]),i&&ZC._todash_(e[ZC.UM(o)],i,t)):ZC.UM(o)!==o&&(e[ZC.UM(o)]=e[o],delete e[o])}}},ZO:function(e,i){for(var t in e){var n;if(e.hasOwnProperty(t))if((n=t.replace(i+"-",""))!==t)if(e[n]=e[t],e[t]instanceof Array)for(var a=0,l=e[t].length;a<l;a++)ZC.ZO(e[t][a],i);else e[t]instanceof Object&&!(e[t]instanceof Function)&&ZC.ZO(e[t],i)}},A9J:function(e){for(var i="",t=0,n=e.length;t<n;t++){var a=t%2==0?t:e.length-t;i+=e.substring(a,a+1)}return i=i.replace(/\./g,"d")},AD8:function(e){var i=e;return i=(i=(i=i.replace("*","&")).replace("9","3")).replace("l","1")},A9E:function(e){return e.replace(/[a-zA-Z]/g,function(e){return String.fromCharCode((e<="Z"?90:122)>=(e=e.charCodeAt(0)+13)?e:e-26)})},ACA:function(e,i){var t=ZC.X1(ZC.ABX(e)),n=ZC.X1(ZC.A1Z(i)),a=t.length;if(0===a)return"";for(var l,o,r=t[a-1],s=t[0],A=2654435769,C=Math.floor(6+52/a)*A;0!==C;){o=C>>>2&3;for(var c=a-1;c>0;c--)l=((r=t[c-1])>>>5^s<<2)+(s>>>3^r<<4)^(C^s)+(n[3&c^o]^r),s=t[c]-=l;l=((r=t[a-1])>>>5^s<<2)+(s>>>3^r<<4)^(C^s)+(n[3&c^o]^r),s=t[0]-=l,C-=A}return decodeURIComponent(ZC.ABT(ZC.A5Y(t)))},AEU:function(e,i){e=encodeURIComponent(e);var t=ZC.X1(ZC.A1Z(e)),n=ZC.X1(ZC.A1Z(i)),a=t.length;if(0===a)return"";1===a&&(t[a++]=0);for(var l,o,r=t[a-1],s=t[0],A=Math.floor(6+52/a),C=0;A-- >0;){o=(C+=2654435769)>>>2&3;for(var c=0;c<a-1;c++)l=(r>>>5^(s=t[c+1])<<2)+(s>>>3^r<<4)^(C^s)+(n[3&c^o]^r),r=t[c]+=l;l=(r>>>5^(s=t[0])<<2)+(s>>>3^r<<4)^(C^s)+(n[3&c^o]^r),r=t[a-1]+=l}return ZC.ABW(ZC.A5Y(t))},X1:function(e){for(var i=new Array(Math.ceil(e.length/4)),t=0;t<i.length;t++)i[t]=e[4*t]+(e[4*t+1]<<8)+(e[4*t+2]<<16)+(e[4*t+3]<<24);return i},A5Y:function(e){for(var i=[],t=0;t<e.length;t++)i.push(255&e[t],e[t]>>>8&255,e[t]>>>16&255,e[t]>>>24&255);return i},ABW:function(e){for(var i="",t=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],n=0;n<e.length;n++)i+=t[e[n]>>4]+t[15&e[n]];return i},ABX:function(e){for(var i=[],t="0x"===e.substr(0,2)?2:0;t<e.length;t+=2)i.push(parseInt(e.substr(t,2),16));return i},ABT:function(e){for(var i="",t=0;t<e.length;t++)0!==e[t]&&(i+=String.fromCharCode(e[t]));return i},A1Z:function(e){for(var i=[],t=0;t<e.length;t++)i.push(e.charCodeAt(t));return i},_i_:function(e){return-1!==String(e).indexOf("e-")?0:""===(e=String(e).replace(/[^0-9\.\-]/gi,""))?0:Math.round(e)},_f_:function(e){return e=parseFloat(e),isNaN(e)?0:e},_x_:function(e,i){return void 0===i&&(i=2),parseFloat(Number(e).toFixed(i))},_a_:function(e){return Math.abs(e)},_b_:function(e){return"false"!==e&&"0"!==e&&("true"===e||"1"===e||!!e&&!0)},_p_:function(e){var i=(e=String(e).replace(/[^0-9\.\%\-]/gi,"")).indexOf("%");return-1!==i&&(e=e.substring(0,i),e=ZC._f_(e)/100),e},_h_:function(e){return window.toStaticHTML?window.toStaticHTML(e):e},_n_:function(e){return null===e||void 0===e?null:e},_c_:function(e,i){return null===e||void 0===e?i:e},_ang_:function(e){return(e%=360)<0&&(e+=360),e},II:function(e,i){return ZC._f_(e)+""==e+""?i?ZC._f_(e):ZC._a_(e):-1!==(e+="").indexOf("%")?ZC._f_(e.replace("%",""))/100:-1!==e.indexOf("px")?ZC._f_(e.replace("px","")):ZC._f_(e)},QY:function(e){return parseInt(e,16)},OV:function(e){return ZC._i_(e).toString(16)},_r_:function(e,i){return parseInt(e+(i-e)*Math.random(),10)},_l_:function(e,i,t){return e=(e=e<i?i:e)>t?t:e},DS:function(e,i,t,n){return n?i<e&&e<t||t<e&&e<i:i<=e&&e<=t||t<=e&&e<=i},BQ:function(e,i){return Math.max(e,i)},CY:function(e,i){return Math.min(e,i)},A1L:function(e,i){null===ZC._n_(i)&&(i=!1);for(var t=0,n=e.length,a=-Number.MAX_VALUE;t<n;t++)i&&0==e[t]||(a=Math.max(a,e[t]));return a},XZ:function(e,i){null===ZC._n_(i)&&(i=!1);for(var t=0,n=e.length,a=Number.MAX_VALUE;t<n;t++)i&&0==e[t]||(a=Math.min(a,e[t]));return a},_rcolor_:function(){for(var e=(16777215*Math.random()+1<<0).toString(16);e.length<6;)e="0"+e;return"#"+e},A9L:function(e,i){for(var t,n=ZC._f_(i),a=Number.MAX_VALUE,l=0,o=0,r=e.length;o<r;o++)(t=Math.abs(ZC._f_(e[o])-n))<a&&(l=o,a=t);return l},AEK:function(e){var i=e.split(".");return i[i.length-1]||""},GV:function(e){return e.replace(/^\s\s*/,"").replace(/\s\s*$/,"")},G6:function(e,i){return i=i||Math.E,isFinite(Math.log(e)/Math.log(i))?Math.log(e)/Math.log(i):0},TN:function(e){return 360*e/(2*Math.PI)},T8:function(e){return 2*e*Math.PI/360},EH:function(e){return Math.cos(ZC.T8(e))},EO:function(e){return Math.sin(ZC.T8(e))},P8:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},EE:function(e){return-1!==e.indexOf("-")?e.replace(/(\-[a-z0-9])/g,function(e){return e.toUpperCase().replace("-","")}):e},UM:function(e){return e.toUpperCase()!==e&&-1===e.indexOf("-")&&e.substring(0,1).toLowerCase()===e.substring(0,1)?e.replace(/([A-Z])/g,function(e){return"-"+e.toLowerCase()}).replace(/([0-9]+)/g,function(e){return"-"+e.toLowerCase()}).replace("-3d","3d"):e},AEL:function(e){return ZC.XR.md5(e)},AL:function(e){return document.getElementById(e)},A1H:function(e,i){return e[0].length<i[0].length?1:e[0].length>i[0].length?-1:0},ZJ:function(e){window.setTimeout(e,zingchart.TIMEOUT)},_fixed_:function(e,i){return i>=0&&i<=20?e.toFixed(i):""+e},_nfind_:function(e,i,t,n){var a=i.S[t].BT,l=i.S[n].BT;if(e==a)return t;if(e==l)return n;var o=ZC._i_((t+n)/2);if(!i.S[o]){for(;!i.S[o]&&o<n;)o++;if(o===n){for(o=ZC._i_((t+n)/2);!i.S[o]&&o>t;)o--;if(o===t)return null}}var r=i.S[o].BT;return o!==t&&o!==n?e==r?o:e>r?ZC._nfind_(e,i,o,n):ZC._nfind_(e,i,t,o):e==r?o:null},_tx_:function(e){var i,t,n,a,l=[1,1,0,0];if(zingchart.DEV.LOOKUPCSSTRANSFORM&&!ZC.vml&&ZC.AL(e)){var o=ZC.AL(e);for(i="";o&&(""===i||"none"===i);)i=ZC.A4(o).css("transform")||"",o=o.parentNode;-1!==(t=i.indexOf("matrix("))&&(n=i.indexOf(")",t),a=i.substring(t+7,n-t).split(","),l=[ZC._f_(a[0]),ZC._f_(a[3]),ZC._f_(a[4]),ZC._f_(a[5])])}return l},Utils_SetupFormat:function(e,i){return ZC.AP.O2(e,i)},Utils_Format:function(e,i,t,n){return ZC.AP.G2(e,i,t,n)},Loader_Api_Loader_Info:function(e){return e.FG()}},ZC.hasPassive=!1,ZC.SEC=1e3,ZC.MIN=60*ZC.SEC,ZC.HR=60*ZC.MIN,ZC.DAY=24*ZC.HR,ZC.MON=30*ZC.DAY,ZC.YR=365*ZC.DAY,ZC.MAPTX=0,window.JSON=window.JSON||{},JSON.stringify=JSON.stringify||function(e){var i=typeof e;if("object"!==i||null===e)return"string"===i&&(e='"'+e.replace("\\","\\\\").replace('"','"')+'"'),String(e);var t,n,a=[],l=e&&e.constructor===Array;for(t in e)"function"!=typeof e[t]&&("string"===(i=typeof(n=e[t]))?n='"'+n.replace("\\","\\\\").replace('"','\\"')+'"':"object"===i&&null!==n&&(n=JSON.stringify(n)),a.push((l?"":'"'+t+'":')+String(n)));return(l?"[":"{")+String(a)+(l?"]":"}")},JSON.parse=JSON.parse||function(KW){return""===KW&&(KW='""'),eval("("+KW+")")},function(){var e=!1,i=/xyz/.test(function(){xyz})?/\bb\b/:/.*/;ZC.C9=function(){},ZC.C9.CA=function(t){var n=this.prototype;e=!0;var a=new this;for(var l in e=!1,t)a[l]="function"==typeof a[l]&&"function"==typeof n[l]&&i.test(t[l])?function(e,i){return function(){var t=this.b;this.b=n[e];var a=i.apply(this,arguments);return this.b=t,a}}(l,t[l]):t[l];function o(){!e&&this.$i&&this.$i.apply(this,arguments)}return o.prototype=a,o.constructor=o,o.CA=arguments.callee,o}}(),ZC.AAT=function(e){this.H=e,this.A9Z=function(e,i){var t,n=this,a=n.B8.palette;if(null!==ZC._n_(i)&&null!==ZC._n_(a[i])&&(a=a[i]),null!==ZC._n_(a[e])){var l=a[e];return null===ZC._n_(l[2])&&(l[2]=ZC.AP.QR(l[1],10)),null===ZC._n_(l[3])&&(l[3]=ZC.AP.QR(l[1],10)),l}var o=["#00BAF2","#E80C60","#E2D51A","#9B26AF","#FB301E","#00AE4D","#20398B"];t=null!==ZC._n_(o[e-n.B8.palette.length])?o[e-n.B8.palette.length]:"#"+ZC.XR.md5(e).substr(e%20,6);var r=ZC.AP.QR(t,10),s=ZC.AP.QR(t,20),A="#FFF";return n.B8.palette&&n.B8.palette[0]&&n.B8.palette[0][0]&&(A=n.B8.palette[0][0]),[A,t,r,s]},this.A8U=function(e){e&&ZC._cp_(e,this.B8,!0)},this.AAY=function(e){var i=this;null!==ZC._n_(i.NV[e])&&(ZC._todash_(i.NV[e]),ZC._cp_(i.NV[e],i.B8))},this.NV={},ZC._cp_(zingchart.THEMES,this.NV),this.NV.classic={palette:[["#fff","#6a921f","#a7da47","#89b92e"],["#fff","#007fa3","#00b0e1","#0392bb"],["#fff","#a62b02","#ef4810","#cc3300"],["#fff","#b79007","#f9c332","#da9b04"],["#fff","#563d02","#84680a","#6e4503"],["#fff","#0b32a0","#4d62b1","#1540a0"]],graph:{refresh:{curtain:{alpha:.5,"background-color":"#999",color:"#000","font-size":15,bold:1,text:"Loading..."}},"background-color":"#e1eaec #edf3f5",title:{"font-size":14,bold:1,color:"#fff","background-color":"#00bbf1 #05a0cd",padding:6},subtitle:{"font-size":11,bold:1,color:"#333","margin-top":30,padding:6},source:{"font-size":10,color:"#333",width:"100%",bold:1,"text-align":"right",height:20,margin:"auto 0 0 auto",padding:5},nodata:{"font-size":12,color:"#333","text-align":"center","vertical-align":"middle",text:""},SCALE:{"font-size":11,"line-width":2,"line-color":"#3e6c7b",item:{flat:!0},"ref-line":{"line-width":1,"line-color":"#3e6c7b"},guide:{visible:1,"line-width":1,"line-style":"solid","line-color":"#2c4a59",alpha:.2},"minor-guide":{visible:1,"line-width":1,"line-style":"solid","line-color":"#aaa",alpha:.1},tick:{visible:1,size:6,placement:"outer","line-width":2,"line-color":"#3e6c7b"},"minor-tick":{visible:1,size:4,placement:"outer","line-width":1,"line-color":"#3e6c7b"},label:{color:"#2c4a59",flat:!0}},"scroll-x":{bar:{height:16},handle:{height:16}},"scroll-y":{bar:{width:16},handle:{width:16}},legend:{"background-color":"#fff","border-width":1,alpha:.75,"border-alpha":.75,"border-color":"#666","shadow-distance":3,header:{padding:"4 6",color:"#fff","border-width":1,"border-color":"#3e6c7b","background-color":"#3e6c7b"},footer:{padding:"2 6","background-color":"#ccc","border-width":1,"border-color":"#666"},marker:{"border-color":"#333","border-width":1}},plot:{"value-box":{flat:!0},marker:{shadow:1,"line-width":1,"border-width":1},"hover-marker":{"line-width":1,"border-width":1}},guide:{"line-width":1,"line-color":"#999",alpha:1,"scale-label":{text:"%l",padding:"3 6"},"plot-label":{padding:"3 6"}}},line:{plot:{"shadow-alpha":.5,marker:{size:4},"hover-marker":{size:5}}},area:{plot:{"shadow-alpha":.5,marker:{size:4},"hover-marker":{size:5}}},vbar:{plot:{"fill-angle":90,shadow:0}},hbar:{plot:{"fill-angle":180,shadow:0}},piano:{plotarea:{"mask-tolerance":[0,0]},plot:{shadow:0}},stock:{plot:{shadow:0}},vbullet:{plot:{shadow:0}},hbullet:{plot:{"fill-angle":0,shadow:0}},scatter:{plot:{marker:{size:4},"hover-marker":{size:5}}},hscatter:{plot:{marker:{size:4},"hover-marker":{size:5}}},bubble:{plot:{marker:{"border-width":0},"hover-marker":{"border-width":0}}},hbubble:{plot:{marker:{"border-width":0},"hover-marker":{"border-width":0}}},pie:{plot:{"border-width":1}},nestedpie:{plot:{"border-width":1}},radar:{plot:{marker:{size:3},"hover-marker":{size:4}},"scale-k":{guide:{alpha:.5,"background-color":"#eee #ddd"}}},gauge:{"scale-r":{"background-color":"-1",guide:{alpha:.5,"background-color":"#eee #ddd"},item:{"offset-r":0},ring:{size:1,items:[{"background-color":"#999",alpha:.8},{"background-color":"#666",alpha:.8}]}}},vfunnel:{plotarea:{margin:"50 100"},SCALE:{"line-width":0,tick:{"line-width":0},"minor-tick":{"line-width":0},guide:{"line-width":0},"minor-guide":{"line-width":0}},"scale-y":{guide:{alpha:.25,"background-color":"-1 #58595B"}},"scale-y-n":{guide:{alpha:.25,"background-color":"-1 #58595B"}},plot:{"border-width":1}},hfunnel:{plotarea:{margin:"50 100"},"scale-x":{label:{"font-angle":270}},"scale-x-n":{label:{"font-angle":90}},SCALE:{"line-width":0,tick:{"line-width":0},"minor-tick":{"line-width":0},guide:{"line-width":0},"minor-guide":{"line-width":0}},"scale-y":{label:{"font-angle":0},item:{"text-align":"center"},guide:{alpha:.25,"background-color":"#58595B -1"}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"},guide:{alpha:.25,"background-color":"#58595B -1"}},plot:{"border-width":1}},range:{plot:{marker:{type:"circle",size:4},"hover-marker":{size:5}}},line3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":0,"line-width":1}},area3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":0,"line-width":1}},mixed3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},vbar3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},hbar3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},pie3d:{plot:{"border-width":1}},"-":""},this.NV.light={palette:[["#fff","#29A2CC","#29A2CC","#1089B3"],["#fff","#D31E1E","#D31E1E","#BA0505"],["#fff","#7CA82B","#7CA82B","#638F12"],["#fff","#EF8535","#EF8535","#D66C1C"],["#fff","#A14BC9","#A14BC9","#8832B0"],["#fff","#A05F18","#A05F18","#874600"],["#fff","#265E96","#265E96","#0D457D"],["#fff","#6B7075","#6B7075","#52575C"],["#fff","#96C245","#96C245","#7CA82B"]],graph:{refresh:{curtain:{alpha:.5,"background-color":"#999",color:"#000","font-size":15,bold:1,text:"Loading..."}},"background-color":"#ffffff",title:{"font-size":21,bold:1,color:"#414042","background-color":"none",padding:6},subtitle:{"font-size":11,bold:1,color:"#414042","margin-top":30,padding:6},source:{"font-size":10,color:"#414042",width:"100%",bold:1,"text-align":"right",height:20,margin:"auto 0 0 auto",padding:5},nodata:{"font-size":12,color:"#333","text-align":"center","vertical-align":"middle",text:"No Data","background-color":"#BBBBBB",alpha:.8},SCALE:{"font-size":11,"line-width":1,"line-color":"#8C8C8C",item:{"font-size":12,flat:!0,color:"#808285"},"ref-line":{"line-width":1,"line-color":"#D1D3D4"},guide:{visible:1,"line-width":1,"line-style":"solid","line-color":"#DCDCDC",alpha:1},"minor-guide":{visible:1,"line-width":1,"line-style":"solid","line-color":"#aaa",alpha:.1},tick:{visible:1,size:5,placement:"outer","line-width":1,"line-color":"#8C8C8C"},"minor-tick":{visible:1,size:3,placement:"outer","line-width":1,"line-color":"#A7A9AC"},label:{color:"#414042",flat:!0}},"scale-x":{normalize:!0,guide:{visible:!1}},scroll:{bar:{"background-color":"#F0F1F1",margin:1},handle:{"background-color":"#A7A9AC","border-radius":6}},"scroll-x":{bar:{height:16,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"},handle:{height:10,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"}},"scroll-y":{bar:{width:16,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"},handle:{width:10,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"}},"scroll-xi":{bar:{width:16,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"},handle:{width:10,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"}},"scroll-yi":{bar:{height:16,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"},handle:{height:10,"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"}},preview:{"background-color":"#fff","border-width":1,"border-color":"#A7A9AC",live:!0,mask:{"background-color":"#999"},active:{alpha:0},handle:{width:11,"border-width":2,"border-radius":3,"line-color":"#C6C6C6","border-color":"#A7A9AC","background-color":"#F0F1F1"},"handle-top":{height:11},"handle-bottom":{height:11}},tooltip:{shadow:1,"shadow-angle":45,"shadow-distance":1,"shadow-alpha":.25,"border-width":1,"border-color":"#fff","border-alpha":1},zoom:{"preserve-zoom":1,"background-color":"#929497"},legend:{"background-color":"#fff","border-width":1,shadow:0,"shadow-alpha":.2,alpha:1,"border-alpha":1,"border-color":"#cccccc",header:{padding:"5 0 5 10",color:"#222222","background-color":"none","border-width":0,"border-top":"0px solid none","border-bottom":"1px solid #cccccc"},footer:{padding:"5 0 5 10","border-top":"1px solid #cccccc"},shader:{"background-color":"#F0F1F1","line-color":"#C6C6C6",margin:2,height:8,"line-width":2,"line-style":"dotted"},icon:{"line-color":"#C6C6C6","line-width":2,style:"small"},marker:{"border-color":"#fff","border-width":1},"page-on":{"background-color":"#929497"},"page-off":{"background-color":"#D1D2D3"},scroll:{bar:{"background-color":"none","margin-top":3,"margin-bottom":3},handle:{"background-color":"#D1D2D3","border-top":"none","border-right":"none","border-bottom":"none","border-left":"none","border-radius":6,width:12,height:12}}},plot:{"value-box":{flat:!0},marker:{shadow:0,"line-width":1,"border-width":1,"border-color":"#fff"},"hover-marker":{"line-width":1,"border-width":1},monotone:!0},guide:{"line-width":1,"line-color":"#8C8C8C",alpha:1,"scale-label":{text:"%l",padding:"3 6"},"plot-label":{padding:"3 6"}}},line:{plot:{"line-width":2,shadow:0,marker:{size:4},"hover-state":{},"hover-marker":{size:5,"border-width":1,"border-color":"#fff"}}},area:{plot:{"line-width":2,shadow:0,"alpha-area":.25,"background-color-style":"solid",marker:{size:4},"hover-state":{},"hover-marker":{size:5,"border-width":1,"border-color":"#fff"}}},vbar:{plot:{"fill-angle":90,shadow:0}},hbar:{plot:{"fill-angle":180,shadow:0}},piano:{plotarea:{"mask-tolerance":[0,0]},plot:{shadow:0},"scale-x":{guide:{visible:!0}}},stock:{plot:{shadow:0}},vbullet:{plot:{shadow:0,goal:{"border-width":1,"border-color":"#fff",height:8}}},hbullet:{plot:{"fill-angle":0,shadow:0,goal:{"border-width":1,"border-color":"#fff",width:8}}},scatter:{plot:{"line-color":"%palette-0","border-color":"%palette-0",marker:{size:5},"hover-marker":{size:6}},"scale-x":{guide:{visible:!0}}},hscatter:{plot:{"line-color":"%palette-0","border-color":"%palette-0",marker:{size:4},"hover-marker":{size:5}},"scale-x":{guide:{visible:!0}}},bubble:{plot:{marker:{"border-width":1,"border-color":"#fff"},"hover-marker":{"border-width":1,"border-color":"#fff"}},"scale-x":{guide:{visible:!0}}},hbubble:{plot:{marker:{"border-width":1,"border-color":"#fff"},"hover-marker":{"border-width":1,"border-color":"#fff"}},"scale-x":{guide:{visible:!0}}},pie:{plot:{shadow:0,"border-width":1,"value-box":{placement:"in","font-size":16,text:"%node-percent-value%"}}},nestedpie:{plot:{"border-width":1}},radar:{plot:{shadow:0,"line-width":2,"background-color":"%palette-1","active-area":!0,marker:{size:4},"hover-marker":{size:5,"border-color":"#fff"}},"scale-k":{guide:{"line-width":1,"line-style":"solid","line-color":"#8C8C8C","line-segment-size":6,"line-gap-size":6,alpha:1,"background-color":"#fff #F7F8F8"},tick:{"line-color":"#8C8C8C","line-width":1,size:10}},"scale-r":{},"scale-v":{"ref-line":{"line-color":"#8C8C8C","line-width":1},tick:{"line-color":"#8C8C8C","line-width":1},guide:{"line-color":"#CDCDCD","line-width":1}}},gauge:{plot:{shadow:0},scale:{"size-factor":1},"scale-r":{aperture:270,tick:{size:11,"line-width":2},"background-color":-1,guide:{"background-color":"#fff"},ring:{size:8,"background-color":"#CDCDCD"},center:{size:20,"background-color":"#fff","border-width":6,"border-color":"#1089B3"}}},vfunnel:{plotarea:{margin:"50 100"},SCALE:{"line-width":0,tick:{"line-width":0},"minor-tick":{"line-width":0},guide:{"line-width":1,"line-style":"solid","line-color":"#CDCDCD","line-segment-size":6,"line-gap-size":6,alpha:1},"minor-guide":{"line-width":0}},"scale-x":{visible:!1,guide:{visible:0}},"scale-y":{guide:{"background-color":"-1",alpha:1}},"scale-y-n":{guide:{"background-color":"-1"}},plot:{"border-width":1,"border-color":"#fff",shadow:0,"hover-state":{"line-color":"-1","border-color":"-1"}}},hfunnel:{plotarea:{margin:"50 100"},"scale-x":{visible:!1,guide:{visible:0},label:{"font-angle":270}},"scale-x-n":{label:{"font-angle":90}},SCALE:{"line-width":0,tick:{"line-width":0},"minor-tick":{"line-width":0},guide:{"line-width":1,"line-style":"solid","line-color":"#CDCDCD","line-segment-size":6,"line-gap-size":6,alpha:1},"minor-guide":{"line-width":0}},"scale-y":{guide:{"background-color":"-1",alpha:1},label:{"font-angle":0},item:{"text-align":"center"}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"},guide:{"background-color":"-1"}},plot:{"border-width":1,"border-color":"#fff",shadow:0,"hover-state":{"line-color":"-1","border-color":"-1"}}},range:{plot:{"background-color":"%palette-1",marker:{type:"circle",size:4},"hover-marker":{size:5}}},line3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":0,"line-width":1}},area3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":0,"line-width":1}},mixed3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},vbar3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},hbar3d:{SCALE:{"line-color":"#ddd",tick:{visible:!1}},plot:{"border-width":1}},pie3d:{plot:{"border-width":1}},venn:{plot:{"border-width":0,shadow:0,alpha:.75,"background-color":"%palette-1"}},root:{gui:{"context-menu":{visible:!0,width:"125px",padding:"5 0","background-color":"#595959","border-width":0,"border-color":"#595959",position:"left",button:{visible:ZC.mobile,alpha:0},gear:{"background-color":"#000",type:"hamburger",alpha:1},item:{"background-color":"#595959","text-align":"left",padding:"4 20 4 15","border-width":0,"border-color":"#595959","font-size":"12px",color:"#fff","hover-state":{"background-color":"#414141"}},separator:{"line-width":1,"line-color":"#969696"}},"context-menu[mobile]":{item:{padding:"6 10 6 6"}}}},"-":""},this.NV.light.graph["crosshair-x"]=this.NV.light.graph["crosshair-y"]=this.NV.light.graph.guide,this.NV.dark={},ZC._cp_(this.NV.light,this.NV.dark,!0,!0),ZC._cp_({graph:{"background-color":"#221F1F",title:{color:"#fff"},subtitle:{color:"#fff"},source:{color:"#fff"},SCALE:{"line-color":"#D1D3D4",item:{color:"#D1D3D4"},"ref-line":{"line-color":"#D1D3D4"},guide:{"line-color":"#58595B"},"minor-guide":{"line-color":"#58595B"},tick:{"line-color":"#D1D3D4"},"minor-tick":{"line-color":"#D1D3D4"},label:{color:"#D1D3D4"}},scroll:{bar:{"background-color":"#6C6D70"},handle:{"background-color":"#A7A9AC"}},"scroll-x":{bar:{"border-top":"0px solid none","border-right":"2px solid #D1D3D4","border-bottom":"2px solid #D1D3D4","border-left":"2px solid #D1D3D4"},handle:{"border-top":"none","border-right":"none","border-bottom":"none","border-left":"none"}},"scroll-y":{bar:{"border-top":"2px solid #D1D3D4","border-right":"0px solid none","border-bottom":"2px solid #D1D3D4","border-left":"2px solid #D1D3D4"}},preview:{"background-color":"#221F1F"},tooltip:{"border-color":"#000"},legend:{"background-color":"#221F1F",header:{color:"#fff",shader:{"background-color":"#414042","line-color":"#676667"}},footer:{color:"#D1D3D4","background-color":"#414042","border-top":"0px solid none","border-right":"2px solid #A7A9AC","border-bottom":"2px solid #A7A9AC","border-left":"2px solid #A7A9AC"},shader:{"background-color":"#414042","line-color":"#676667"},icon:{"line-color":"#676667"},"page-status":{color:"#D1D3D4"},"page-on":{"background-color":"#D1D2D3"},"page-off":{"background-color":"#929497"},marker:{"border-color":"#000"},item:{color:"#D1D3D4"}},plot:{marker:{"border-color":"#221F1F"}},guide:{"line-color":"#D1D3D4","scale-label":{"background-color":"#929497"},"plot-label":{"background-color":"#221F1F",color:"#FFF","border-color":"#5a5a5a"}}},line:{plot:{"hover-marker":{"border-color":"#221F1F"}}},area:{plot:{"hover-marker":{"border-color":"#221F1F"}}},vbullet:{plot:{goal:{"border-color":"#221F1F"}}},hbullet:{plot:{goal:{"border-color":"#221F1F"}}},bubble:{plot:{marker:{"border-color":"#221F1F"},"hover-marker":{"border-color":"#221F1F"}}},hbubble:{plot:{marker:{"border-color":"#221F1F"},"hover-marker":{"border-color":"#221F1F"}}},pie:{plot:{"border-color":"#221F1F"}},radar:{plot:{"hover-marker":{"border-color":"#221F1F"}},"scale-k":{guide:{"line-color":"#58595B","background-color":"#221F1F #312F30"},tick:{"line-color":"#D1D3D4"}},"scale-v":{"ref-line":{"line-color":"#58595B"},tick:{"line-color":"#58595B"},guide:{"line-color":"#58595B"}}},gauge:{"scale-r":{guide:{"background-color":"#221F1F"},ring:{"background-color":"#57585B"}}},vfunnel:{SCALE:{guide:{"line-color":"#58595B"}},plot:{"border-color":"#221F1F","hover-state":{"line-color":"#58595B","border-color":"#221F1F"}}},hfunnel:{SCALE:{guide:{"line-color":"#58595B"}},"scale-y":{guide:{alpha:.25,"background-color":"#b6c8cf -1"}},"scale-y-n":{guide:{alpha:.25,"background-color":"#b6c8cf -1"}},plot:{"border-color":"#221F1F","hover-state":{"line-color":"#58595B","border-color":"#221F1F"}}},root:{gui:{"context-menu":{gear:{"background-color":"#FFF"}}}},"-":""},this.NV.dark,!0,!0),this.NV.dark.graph["crosshair-x"]=this.NV.dark.graph["crosshair-y"]=this.NV.dark.graph.guide,this.NV.mini={graph:{title:{width:"100%",padding:"1 2 2","font-size":10},subtitle:{width:"100%",padding:"1 2 2","margin-top":14,"font-size":9},plotarea:{width:"100%",height:"100%",margin:"18 4 4 4"},SCALE:{visible:0},tooltip:{shadow:0,"border-radius":7},legend:{visible:0},preview:{visible:0},guide:{"line-width":1,"line-color":"#ccc",alpha:1,"scale-label":{text:"%l",padding:"3 6"},"plot-label":{"border-color":"#ccc","border-radius":5,padding:"3 6"}},plot:{shadow:0,"value-box":{visible:0},"hover-state":{visible:0},"hover-marker":{visible:0},"max-trackers":99999,"max-nodes":99999}},line:{plot:{"line-width":1,marker:{type:"none"}}},line3d:{"3d-aspect":{depth:20,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0,zoom:.9}},area:{plot:{"line-width":1,marker:{type:"none"}}},area3d:{"3d-aspect":{depth:20,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0,zoom:.9}},scatter:{SCALE:{offset:5},plot:{marker:{size:3,shadow:!1,alpha:.8}}},hscatter:{SCALE:{offset:5},plot:{marker:{size:3,shadow:!1,alpha:.8}}},bubble:{SCALE:{offset:15},plot:{marker:{"fill-type":"none",shadow:!1,alpha:.8},"min-size":3,"max-size":9}},hbubble:{SCALE:{offset:15},plot:{marker:{"fill-type":"none",shadow:!1,alpha:.8},"min-size":3,"max-size":9}},pie:{plotarea:{margin:"18 4 4 4"},plot:{"value-box":{visible:0}},scale:{"size-factor":.95}},pie3d:{plotarea:{margin:"32 4 4 4"},plot:{"value-box":{visible:0}},scale:{"size-factor":1}},nestedpie:{plotarea:{margin:"18 4 4 4"},plot:{"value-box":{visible:0}},scale:{"size-factor":.95}},radar:{plotarea:{margin:"18 4 4 4"},plot:{"line-width":1,marker:{shadow:0,size:2}},scale:{"size-factor":.95}},vbar3d:{"3d-aspect":{depth:20,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0,zoom:.9}},hbar3d:{"3d-aspect":{depth:20,angle:45,"x-angle":0,"y-angle":-20,"z-angle":0,zoom:.9}},venn:{plotarea:{margin:"18 4 4 4"},plot:{"border-width":0}},gauge:{plotarea:{margin:"18 4 4 4"},plot:{indicator:[5]},SCALE:{visible:1},scale:{"size-factor":.9},"scale-r":{"background-color":"-1",aperture:270,tick:{visible:0},item:{visible:0},guide:{visible:0},ring:{size:6,"background-color":"#CDCDCD",items:[]},center:{"border-width":0,size:2,"background-color":"#fff"}}},vfunnel:{plotarea:{margin:"18 4 4 4"}},hfunnel:{plotarea:{margin:"18 4 4 4"}},vbullet:{plot:{"bar-space":.5,goal:{"border-width":0,height:4}}},hbullet:{plot:{"bar-space":.5,goal:{"border-width":0,width:4}}},range:{plot:{"line-width":1,marker:{visible:0},"hover-state":{visible:0}}},"-":""},this.NV.negative={palette:[["#000","#909090","#969696","#9c9c9c"],["#000","#a0a0a0","#a6a6a6","#acacac"],["#000","#b0b0b0","#b6b6b6","#bcbcbc"],["#000","#c0c0c0","#c6c6c6","#cccccc"],["#000","#d0d0d0","#d6d6d6","#dcdcdc"],["#000","#e0e0e0","#e6e6e6","#ececec"],["#000","#f0f0f0","#f6f6f6","#fcfcfc"]],graph:{"background-color":"#111",title:{color:"#fff"},subtitle:{color:"#333"},SCALE:{"font-size":11,"line-width":2,"line-color":"#ccc",guide:{visible:1,"line-width":1,"line-style":"solid","line-color":"#ccc",alpha:.2},"minor-guide":{visible:1,"line-width":1,"line-style":"solid","line-color":"#ccc",alpha:.2},tick:{visible:1,size:6,placement:"outer","line-width":2,"line-color":"#ccc"},"minor-tick":{visible:1,size:4,placement:"outer","line-width":1,"line-color":"#ccc"},label:{color:"#fff"},item:{color:"#fff"}}},radar:{"scale-k":{guide:{alpha:.5,"background-color":"#222 #333"}}},"-":""},this.NV.spark=this.NV.mini,this.B8={root:{gui:{behaviors:[{id:"PageScroll",enabled:"all"},{id:"ViewSource",enabled:"all"},{id:"BugReport",enabled:"none"},{id:"LogScale",enabled:"none"},{id:"LinScale",enabled:"none"},{id:"FullScreen",enabled:"none"},{id:"3D",enabled:"none"},{id:"ExportData",enabled:"none"},{id:"SaveAsImageJPG",enabled:"none"},{id:"DownloadCSV",enabled:ZC.ie678?"none":"all"},{id:"DownloadXLS",enabled:ZC.ie678?"none":"all"}],watermark:{type:1,position:"rb"},history:{margin:"10 auto auto 10",width:30,height:22,padding:4,item:{"background-color":"#369","border-width":1,"border-color":"#69c"},"item-off":{"background-color":"#eee","border-color":"#ddd"}},progress:{"background-color":"#fff",color:"#000"},"context-menu":{padding:0,"border-width":1,"border-color":"#000",button:{visible:ZC.mobile,margin:"5 auto auto 5",alpha:.8,"background-color":"#333 #999","border-radius":8,width:40,height:40},gear:{"background-color":"#fff #f6f6f6",type:"gear6",alpha:.8},item:{"background-color":"#36393D","text-align":"left",padding:"4 20 4 8","border-width":1,"border-color":"#000",color:"#fff","hover-state":{"background-color":"#0084AA"}},separator:{"line-width":1,"line-color":"#000000"}},"context-menu[mobile]":{item:{padding:"6 10 6 6"}}}},palette:[],graph:{title:{width:"100%",bold:1,"font-size":13},subtitle:{width:"100%",bold:1,"font-size":11},scroll:{bar:{"background-color":"#e1eaec","border-color":"#ddd"},handle:{"background-color":"#ddd","border-color":"#ccc","border-width":2,"border-top":"2px solid #eee","border-left":"2px solid #eee","border-right":"2px solid #999","border-bottom":"2px solid #999"}},"scroll-x":{bar:{height:16},handle:{height:16}},"scroll-y":{bar:{width:16},handle:{width:16}},"scroll-xi":{bar:{width:16},handle:{width:16}},"scroll-yi":{bar:{height:16},handle:{height:16}},preview:{width:"100%",height:50,margin:"auto 50 20 50","border-width":1,shadow:0,"background-color":"#f0f0f0","border-color":"#999",mask:{alpha:.5,"background-color":"#333"},active:{alpha:.1,"background-color":"#999"},handle:{width:9,height:16,"border-width":1,"line-width":1,"line-color":"#111","border-color":"#444","border-radius":2,"background-color":"#e6e6e6"},"handle-top":{width:16,height:9},"handle-bottom":{width:16,height:9}},"preview[yx]":{width:50,height:"100%",margin:"60 auto 65 20"},plotarea:{width:"100%",height:"100%",margin:"60 50 65 50"},"plotarea[preview]":{margin:"60 50 105 50"},"plotarea[preview[yx]]":{margin:"60 50 65 105"},SCALE:{"line-width":1,guide:{"line-width":1,"line-color":"#ddd"},tick:{size:6,"line-width":2},"minor-guide":{"line-width":1,"line-color":"#ddd"},"minor-tick":{size:4,"line-width":1},label:{bold:1,padding:6,flat:!0},item:{padding:2,"auto-align":!0,flat:!0},marker:{"line-width":1,"line-color":"#000","background-color":"#ccc"},"transform[date]":{item:{"font-size":10,padding:2,color:"#000","background-color":"#fff"}}},"SCALE[3d]":{"background-color":"#ccc"},"scale-y[default]":{label:{"font-angle":270},item:{"text-align":"right"}},"scale-y[opposite]":{label:{"font-angle":90},item:{"text-align":"left"}},plot:{error:{"line-width":1,"line-color":"#333",size:.5},"value-box":{flat:!0,text:"%v",bold:1,placement:"auto",shadow:1},"tooltip-text":"%v",shadow:1,"line-width":1,marker:{type:"square",shadow:1},"highlight-state":{shadow:!0,"shadow-blur":2,"shadow-distance":1,"shadow-alpha":.91}},tooltip:{shadow:1,padding:"4 8","shadow-distance":3,"offset-y":ZC.mobile?-40:-20},"tooltip[dynamic]":{padding:"4 8","offset-y":0},guide:{marker:{type:"circle"},"plot-label[single]":{text:'<b style="color:%color">%plot-text:</b> %node-value',padding:10,"background-color":"#fff #eee","border-width":1,"border-color":"#999",color:"#000","text-align":"left"},"plot-label[multiple]":{text:'<b style="color:%color">%plot-text:</b> %node-value',padding:5,"background-color":"#fff #eee","border-width":1,"border-color":"#999",color:"#000","text-align":"left"}},zoom:{"preserve-zoom":1,"border-width":0,"background-color":"#369",alpha:.25,label:{visible:!1,"background-color":"#fff","font-size":10,padding:2,"border-width":1,"border-color":"#999"}},arrow:{"border-width":1,"border-color":"#000","background-color":"#666",size:4},"legend[position]":{margin:10},legend:{"background-color":"#eee",alpha:1,shadow:1,margin:"10 10 auto auto",padding:"4 2 4 2",item:{"text-align":"left",margin:"2 6 2 4",padding:"2 4"},"item-off":{alpha:.25},marker:{shadow:0,size:6,"border-color":"#999","border-width":1},header:{"font-size":12,"text-align":"left",bold:1},footer:{"text-align":"left"},icon:{"line-color":"#000","line-width":1},"page-status":{color:"#000"},"page-on":{"background-color":"#f90"},"page-off":{"background-color":"#999"},scroll:{bar:{width:12,height:12,"background-color":"#e1eaec","border-color":"#ddd"},handle:{width:12,height:12,"background-color":"#ddd","border-color":"#ccc","border-width":2,"border-top":"2px solid #eee","border-left":"2px solid #eee","border-right":"2px solid #999","border-bottom":"2px solid #999"}}}},vbar:{plot:{"value-box":{placement:"top-out"}}},vbar3d:{plot:{"value-box":{placement:"top-out"}},"3d-aspect":{depth:40,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0}},mixed3d:{"3d-aspect":{depth:40,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0}},hbar:{"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x[default]":{label:{"font-angle":270}},"scale-x[opposite]":{label:{"font-angle":90}},plot:{"value-box":{placement:"top-out"}}},vline:{"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x[default]":{label:{"font-angle":270}},"scale-x[opposite]":{label:{"font-angle":90}}},varea:{plot:{"fill-angle":0},"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x[default]":{label:{"font-angle":270}},"scale-x[opposite]":{label:{"font-angle":90}}},hbar3d:{"scale-y":{label:{"font-angle":0}},"scale-x":{label:{"font-angle":270}},"scale-y-n":{label:{"font-angle":0}},"scale-x-n":{label:{"font-angle":90}},"3d-aspect":{depth:40,angle:45,"x-angle":0,"y-angle":-20,"z-angle":0},plot:{"value-box":{placement:"top-out"}}},hbullet:{"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x":{label:{"font-angle":270}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x-n":{label:{"font-angle":90}}},line:{plot:{"line-width":4,marker:{type:"circle",size:4}}},area:{plot:{"line-width":4,marker:{type:"circle",size:4},"value-box":{placement:"top"}}},line3d:{"3d-aspect":{depth:40,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0},plot:{"border-width":1,"line-width":1,marker:{type:"circle",size:4,alpha:1,visible:0}}},area3d:{"3d-aspect":{depth:40,angle:45,"x-angle":-20,"y-angle":0,"z-angle":0},plot:{"border-width":1,"line-width":1,marker:{type:"circle",size:4,alpha:1,visible:0},"value-box":{placement:"top"}}},scatter:{SCALE:{offset:10},plot:{marker:{type:"circle",size:4},"value-box":{placement:"top"}}},poly:{SCALE:{offset:10},plot:{"alpha-area":.4,marker:{type:"none"},"value-box":{placement:"top"}}},hscatter:{SCALE:{offset:10},"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x":{label:{"font-angle":270}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x-n":{label:{"font-angle":90}},plot:{marker:{type:"circle",size:4},"value-box":{placement:"top"}}},bubble:{SCALE:{offset:40},plot:{marker:{type:"circle","fill-type":"radial","fill-offset-x":-.2,"fill-offset-y":-.2},"hover-marker":{"fill-type":"radial","fill-offset-x":-.2,"fill-offset-y":-.2},"value-box":{placement:"middle",text:"%node-size-value"},"tooltip-text":"%node-size-value"}},hbubble:{SCALE:{offset:40},"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x":{label:{"font-angle":270}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x-n":{label:{"font-angle":90}},plot:{marker:{type:"circle","fill-type":"radial","fill-offset-x":-.2,"fill-offset-y":-.2},"hover-marker":{"fill-type":"radial","fill-offset-x":-.2,"fill-offset-y":-.2},"value-box":{placement:"middle",text:"%node-size-value"},"tooltip-text":"%node-size-value"}},hmixed:{"scale-y":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x":{label:{"font-angle":270}},"scale-y-n":{label:{"font-angle":0},item:{"text-align":"center"}},"scale-x-n":{label:{"font-angle":90}}},pie:{plotarea:{margin:"35 5 5 5"},scale:{"size-factor":"auto","line-width":0,guide:{"line-width":0},"minor-guide":{"line-width":0}},plot:{"fill-type":"radial","value-box":{connector:{"line-width":1},placement:"out",text:"%t",visible:1}}},pie3d:{"3d-aspect":{"x-angle":38,"y-angle":0,"z-angle":0},plotarea:{margin:"25 5 5 5"},scale:{"size-factor":"auto","line-width":0,guide:{"line-width":0},"minor-guide":{"line-width":0}},plot:{"fill-type":"linear","value-box":{connector:{"line-width":1},placement:"out",text:"%t",visible:1}}},nestedpie:{plotarea:{margin:"40 5 15 5"},scale:{"size-factor":.8,"line-width":0,guide:{"line-width":0},"minor-guide":{"line-width":0}},plot:{"fill-type":"radial","value-box":{connector:{"line-width":1},text:"%t",visible:1}}},venn:{plotarea:{margin:"30 10 10 10"},plot:{alpha:.5,"border-width":4},scale:{"size-factor":.65,"line-width":0,guide:{"line-width":0},"minor-guide":{"line-width":0}}},radar:{SCALE:{guide:{"line-width":1,"line-color":"#999","background-color":"-1"},tick:{"line-width":1},item:{"auto-align":!1}},scale:{visible:0,"size-factor":.7},"scale-k":{"ref-angle":270},plotarea:{margin:"40 5 5 5"},plot:{"line-width":4,aspect:"line",marker:{type:"circle"}}},gauge:{SCALE:{guide:{"border-width":1,"border-color":"#999","background-color":"-1"}},scale:{"line-width":0,guide:{"line-width":0},"minor-guide":{"line-width":0},"size-factor":.7},"scale-r":{"ref-angle":270,"background-color":"#fff",guide:{"line-width":0},tick:{placement:"inner"},item:{"offset-r":"-45%"}},plot:{size:"85%"},plotarea:{margin:"40 5 5 5"}},stock:{plot:{"line-width":1,"border-width":1,"tooltip-text":"Open:&nbsp;$%open<br>High:&nbsp;$%high<br>Low:&nbsp;$%low<br>Close:&nbsp;$%close"}},range:{plot:{"line-width":2,"value-box":{text:"%node-min-value - %node-max-value"},"tooltip-text":"%node-min-value - %node-max-value"}},"-":""},this.PL=function(e,i){var t,n=this,a=!1;return null!==ZC._n_(t=n.B8.graph[e])&&null!==ZC._n_(t.enabled)&&(a=a||ZC._b_(t.enabled)),null!==ZC._n_(n.B8[i])&&null!==ZC._n_(t=n.B8[i][e])&&null!==ZC._n_(t.enabled)&&(a=a||ZC._b_(t.enabled)),a},this.load=function(e,i,t,n){var a,l,o,r=this;t=null===ZC._n_(t)||ZC._b_(t),n=null!==ZC._n_(n)&&ZC._b_(n),i instanceof Array||(i=new Array(i));var s=[],A="";for(l=0,o=i.length;l<o;l++)if(/(\(\w+\))(.*)/.test(i[l])){var C=RegExp.$1;A=i[l].replace(C,"graph"),-1===ZC.AV(s,A)&&s.push(A),A=i[l].replace(C,C.substring(1,C.length-1)),-1===ZC.AV(s,A)&&s.push(A)}else-1===ZC.AV(s,i[l])&&s.push(i[l]),/root(.*)/.test(i[l])&&-1===ZC.AV(s,i[l].replace("root","loader"))&&s.push(i[l].replace("root","loader")),/loader(.*)/.test(i[l])&&-1===ZC.AV(s,i[l].replace("loader","root"))&&s.push(i[l].replace("loader","root"));var c={};for(l=0,o=s.length;l<o;l++){for(var u=s[l].split("."),p=r.B8,Z=0,h=u.length;Z<h;Z++)if(null!==ZC._n_(a=p[u[Z]]))p=a;else if(null!==ZC._n_(a=p[ZC.UM(u[Z])]))p=a;else{if(null===ZC._n_(a=p[ZC.EE(u[Z])])){p=null;break}p=a}if(p)for(var d in p)null!==ZC._n_(p[d])&&(n||"object"!=typeof p[d]||p[d].length)&&(t||null===ZC._n_(e[d])?r.H.QV&&null!==ZC._n_(r.H.QV[d])||(c[d]=p[d]):t&&"object"==typeof p[d]&&(r.H.QV&&null!==ZC._n_(r.H.QV[d])||(c[d]=p[d])))}ZC._cp_(c,e)}},ZC.AP={AGL:function(e,i){for(var t=[],n=0,a=e.p.length;n<a;n++)if(e.p[n]){var l=(e.p[n][0]-e.x)/e.w,o=(e.p[n][1]-e.y)/e.h;t.push([i.x+i.w*l,i.y+i.h*o])}else t.push(null);return{l:i.w*e.l/e.w,r:i.w*e.r/e.w,p:t}},ACC:function(e,i,t){var n=document.getElementsByTagName("head")[0],a=document.createElement("script");a.type="text/javascript",a.src=i+"?v"+ZC.VERSION;var l=!1;a.onload=a.onreadystatechange=function(){if(!(l||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState)){l=!0,a.onload=a.onreadystatechange=null,n&&a.parentNode&&n.removeChild(a);var e=new RegExp("zingchart-(.+?).min.js","g").exec(i);e&&ZC.WG.push(e[1]),t&&t(i)}},a.onerror=function(){!e&&zingchart.HZ[0]&&(e=zingchart.HZ[0]),e?e.O1({name:"Network error",message:"Resource not found ("+a.src+")"},"Module loader"):alert("Resource not found ("+a.src+")")},n.insertBefore(a,n.firstChild)},_rcolor_:function(){return"#"+ZC.XR.md5(ZC._r_(0,99999)).substr(ZC._r_(0,20),6)},WO:function(){},A83:function(e,i){return zingchart[e]||i&&i.A18&&i.A18[e]||zingchart.hasEvent(null,e)||i&&zingchart.hasEvent(i.K,e)},BY:function(e,i,t,n,a){t instanceof Array||(t=[t]);var l=1;return null!==ZC._n_(n)&&t.push(n),a&&(l=2,t.push(a)),"touchstart"===e&&(e="mousedown"),"touchend"===e&&(e="mouseup"),"touchmove"===e&&(e="mousemove"),zingchart[e]&&"render"!==e&&(null!==ZC._n_(n)?t[t.length-l]=zingchart[e].apply(zingchart,t):zingchart[e].apply(zingchart,t)),i&&i.A18[e]&&(null!==ZC._n_(n)?t[t.length-l]=i.A18[e].apply(zingchart,t):i.A18[e].apply(zingchart,t)),zingchart.hasEvent(null,e)&&(null!==ZC._n_(n)?t[t.length-l]=zingchart.callEvent(null,e,t,n):zingchart.callEvent(null,e,t)),i&&zingchart.hasEvent(i.K,e)&&(null!==ZC._n_(n)?t[t.length-l]=zingchart.callEvent(i.K,e,t,n):zingchart.callEvent(i.K,e,t)),t[t.length-l]},O4:function(e,i){if(i.A9%360!=0){for(var t=[[-i.I/2,-i.F/2],[i.I/2,-i.F/2],[i.I/2,i.F/2],[-i.I/2,i.F/2]],n="",a=0;a<4;a++)t[a]=[i.iX+i.I/2+i.BL+ZC.MAPTX+t[a][0]*ZC.EH(i.A9)-t[a][1]*ZC.EO(i.A9),i.iY+i.F/2+i.BH+ZC.MAPTX+t[a][0]*ZC.EO(i.A9)+t[a][1]*ZC.EH(i.A9)],n+=ZC._i_(t[a][0])+","+ZC._i_(t[a][1])+",";return i.D=t,ZC.Q.FW("poly",i.EA,i.IP)+'class="'+e+'-label-area zc-label-area" id="'+i.K+'-area" coords="'+n.substring(0,n.length-1)+'" />'}return ZC.Q.FW("rect",i.EA,i.IP)+'class="'+e+'-label-area zc-label-area" id="'+i.K+'-area" coords="'+ZC._i_(i.iX+i.BL+ZC.MAPTX)+","+ZC._i_(i.iY+i.BH+ZC.MAPTX)+","+ZC._i_(i.iX+i.BL+i.I+ZC.MAPTX)+","+ZC._i_(i.iY+i.BH+i.F+ZC.MAPTX)+'" />'},N2:function(e){var i,t="",n=e.indexOf('id="');if(-1!==n){var a=e.indexOf('"',n+4);-1!==a&&(t=e.substring(n+4,a))}if(ZC.cache.data["area-score-"+t])return ZC.cache.data["area-score-"+t];var l=0;if(-1!==e.indexOf('shape="rect"')?(l+=1e4,5===(i=/coords=\"(\-*\d+),(\-*\d+),(\-*\d+),(\-*\d+)\"/.exec(e)).length&&(l+=(ZC._i_(i[3])-ZC._i_(i[1]))*(ZC._i_(i[4])-ZC._i_(i[2])))):-1!==e.indexOf('shape="circle"')?(l+=100,i=/coords=\"(\-*\d+),(\-*\d+),(\-*\d+)\"/.exec(e),null!==ZC._n_(i[3])&&(l+=ZC._i_(i[3])/10)):-1!==e.indexOf('shape="poly"')?-1!==e.indexOf("data-map")?l+=1e6:l+=1e3:l+=1,-1!==e.indexOf("data-z-sort")){var o=/data-z-sort=\"(\-*\d+)\"/.exec(e);o&&2===o.length&&(l*=ZC._i_(Math.pow(10,ZC._i_(o[1]))))}return""!==t&&ZC.cache.add("area-score-"+t,l),l},A5B:function(e,i,t){for(var n=[],a=0,l=e.length;a<l;a++)if(null!==ZC._n_(e[a])){var o=e[a].slice(0);null!==ZC._n_(o[0])&&"string"!=typeof o[0]&&(o[0]+=i),null!==ZC._n_(o[1])&&"string"!=typeof o[1]&&(o[1]+=t),null!==ZC._n_(o[2])&&"string"!=typeof o[2]&&o.length<=4&&(o[2]+=i),null!==ZC._n_(o[3])&&"string"!=typeof o[3]&&o.length<=4&&(o[3]+=t),n.push(o)}else n.push(null);return n},O2:function(e,i){var t;i=i||{},e=e||{};var n={};if(null!==ZC._n_(t=e.negation)&&(n.negation=t),null!==ZC._n_(t=e.short)&&(n.short=ZC._b_(t)),null!==ZC._n_(t=e["short-unit"])&&(n["short-unit"]=t),null!==ZC._n_(t=e.exponent)&&(n.exponent=ZC._b_(t)),null!==ZC._n_(t=e["exponent-decimals"])&&(n["exponent-decimals"]=ZC._i_(t)),null!==ZC._n_(t=e["decimals-separator"])?n["decimals-separator"]=t:null===ZC._n_(i["decimals-separator"])&&null!==ZC._n_(t=ZC.HJ["decimals-separator"])&&(n["decimals-separator"]=t),null!==ZC._n_(t=e["thousands-separator"])?n["thousands-separator"]=t:null===ZC._n_(i["thousands-separator"])&&null!==ZC._n_(t=ZC.HJ["thousands-separator"])&&(n["thousands-separator"]=t),null!==ZC._n_(t=e.decimals)&&(n.decimals=ZC._i_(t)),null!==ZC._n_(t=e["decimals-dyn"])&&(n["decimals-dyn"]=t),null!==ZC._n_(t=e.transform)&&null!==ZC._n_(t.type))switch(t.type){case"date":n["transform-date"]=!0,null!==ZC._n_(t.text)&&(t.all=t.text),null!==ZC._n_(t.all)&&(n["transform-date-format"]=t.all)}return n},G2:function(e,i,t,n){var a,l=e,o=e+"",r=!1;if(n&&null!==ZC._n_(i["transform-date"])&&i["transform-date"]&&""+Number(o)===o&&(o=ZC.AP.Y5(Number(o),i["transform-date-format"],i.utc,i.timezone),r=!0),null===ZC._n_(i["decimals-separator"])&&null!==ZC._n_(e=ZC.HJ["decimals-separator"])&&(i["decimals-separator"]=e),null===ZC._n_(i["thousands-separator"])&&null!==ZC._n_(e=ZC.HJ["thousands-separator"])&&(i["thousands-separator"]=e),null!==ZC._n_(i.decimals)&&-1!==i.decimals&&"undefined"!=typeof i["max-decimals"]&&-1!==i["max-decimals"]&&(i.decimals=ZC.BQ(i["max-decimals"],i.decimals)),!r)if(null!==ZC._n_(i.exponent)&&i.exponent)o=Number(o).toExponential(ZC.CY(20,i["exponent-decimals"])),null!==ZC._n_(i["decimals-separator"])&&(o=o.replace(/\./g,i["decimals-separator"]));else{if(null!==ZC._n_(i.short)&&i.short){a="";var s=i["short-unit"]||"";if("string"!=typeof s&&s.length){""+ZC._f_(s[0])!==s[0]&&(s=[1e3].concat(s));for(var A=1,C=s[0]||1e3,c=s.slice(1),u=null,p=0;p<c.length;p++)0===c[p].indexOf("#")&&(u=p,c[p]=c[p].substring(1));if(c.length){if(null!==u)A=u;else if(null!==ZC._n_(i["max-power"]))A=i["max-power"];else{var Z=ZC.G6(ZC._a_(Number(o)),C);A=Math.floor(Z),A=ZC.CY(A,c.length-1)}a=c[A];var h=(o=""+Number(o)/Math.pow(C,A)).split(".");2===h.length&&h[1].length>=9&&(o=null!==ZC._n_(i.decimals)&&-1!==i.decimals?""+ZC._x_(o,i.decimals):""+ZC._x_(o))}}else{var d=ZC.G6(ZC._a_(Number(o)))/Math.LN10;switch(ZC._a_(Number(o))){case 1e3:d=3;break;case 1e6:d=6;break;case 1e9:d=9}if(null!==ZC._n_(i["max-power"])&&(d=3*i["max-power"]),"KB"===s.toUpperCase())o=""+Number(o)/1024,a="KB";else if("MB"===s.toUpperCase())o=""+Number(o)/1048576,a="MB";else if("GB"===s.toUpperCase())o=""+Number(o)/1073741824,a="GB";else if("TB"===s.toUpperCase())o=""+Number(o)/1099511627776,a="TB";else if("PB"===s.toUpperCase())o=""+Number(o)/0x4000000000000,a="PB";else if(d>=0&&d<3)switch(s){default:o=o,a="";break;case"K":o=""+Number(o)/1e3,a="K";break;case"M":o=""+Number(o)/1e6,a="M";break;case"B":o=""+Number(o)/1e9,a="B"}else d>=3&&d<6&&""===s||"K"===s.toUpperCase()?(o=""+Number(o)/1e3,a="K"):d>=6&&d<9&&""===s||"M"===s.toUpperCase()?(o=""+Number(o)/1e6,a="M"):(d>=9&&""===s||"B"===s.toUpperCase())&&(o=""+Number(o)/1e9,a="B")}if(ZC.P8(o))if(null!==ZC._n_(i.decimals)&&-1!==i.decimals)o=ZC._fixed_(Number(o),ZC.BQ(0,ZC._i_(i.decimals)));else{var f=o.split(".")[1]||"";-1!==i["max-decimals"]&&i["max-decimals"]<f.length&&(o=ZC._fixed_(Number(o),ZC.BQ(0,ZC._i_(i["max-decimals"]))))}null!==ZC._n_(i["decimals-separator"])&&(o=o.replace(/\./g,i["decimals-separator"]))}var _=t?t.K:"";if(!isNaN(o)&&("string"!=typeof l||-1===_.indexOf("-scale-"))){if(null!==ZC._n_(i.decimals)&&-1!==i.decimals&&ZC.P8(o)&&(null!==ZC._n_(i.short)&&i.short||(o=ZC._fixed_(Number(o),ZC.BQ(0,ZC._i_(i.decimals))))),null!==ZC._n_(i["thousands-separator"])||null!==ZC._n_(i["decimals-separator"])){for(var g=o.split("."),v="",b=0,B=g[0].length;b<B;b++){var m=g[0].substring(b,b+1);v+=m,-1===ZC.AV(["-","+"],m)&&(g[0].length-b-1)%3==0&&g[0].length-b-1!=0&&(v+=i["thousands-separator"])}o=v+(null!==ZC._n_(g[1])?i["decimals-separator"]+g[1]:"")}null!==ZC._n_(i.short)&&i.short&&(o+=a)}}return o},AAE:function(e){var i=e.indexOf("("),t="",n="";-1!==i?(t=ZC.GV(e.substring(0,i)),n=ZC.GV(e.substring(i+1,e.length-1))):t=ZC.GV(e);var a=[],l="";if(""!==n){var o=!1,r=!1,s=!1;l="";for(var A=0,C=n.length;A<C;A++){var c=n.substring(A,A+1);switch(c){case"\\":s?(l+="\\",s=!1):s=!0;break;case'"':s?(l+='"',s=!1):r?(a.push(l),l="",r=!1):o?l+=c:r=!0;break;case"'":s?(l+="'",s=!1):o?(a.push(l),l="",o=!1):r?l+=c:o=!0;break;case" ":(o||r)&&(l+=c);break;case",":o||r?l+=c:(""!==l&&a.push(l),l="");break;default:l+=c}}}return""!==l&&a.push(l),[t,a]},A4T:function(e){return e.toString().replace(/^([0-9])$/,"0$1")},Y5:function(e,i,t,n){e=ZC._i_(e),i=i||ZC.HJ["date-formats"].minute,void 0===t&&(t=!1),void 0===n&&(n=0),t&&(e+=36e5*n);var a,l,o,r,s,A,C,c,u=new Date;u.setTime(e),t?(a=u.getUTCHours(),l=u.getUTCMinutes(),o=u.getUTCSeconds(),r=u.getUTCMilliseconds(),s=u.getUTCDay(),A=u.getUTCDate(),C=u.getUTCMonth(),c=u.getUTCFullYear()):(a=u.getHours(),l=u.getMinutes(),o=u.getSeconds(),r=u.getMilliseconds(),s=u.getDay(),A=u.getDate(),C=u.getMonth(),c=u.getFullYear());for(var p=[["mm",ZC.AP.A4T(C+1)],["dd",ZC.AP.A4T(A)],["Y",c],["y",c.toString().substr(2,2)],["F",ZC.HJ["months-long"][C]],["m",C+1],["M",ZC.HJ["months-short"][C]],["n",C],["d",A],["D",ZC.HJ["days-short"][s]],["j",A],["l",ZC.HJ["days-long"][s]],["N",s+1],["w",s],["S",function(){return A%10==1?"st":A%10==2?"nd":A%10==3?"rd":"th"}],["a",a<12?"am":"pm"],["A",a<12?"AM":"PM"],["g",a%12||12],["G",a],["h",ZC.AP.A4T(a%12||12)],["H",ZC.AP.A4T(a)],["i",ZC.AP.A4T(l)],["s",ZC.AP.A4T(o)],["q",r]],Z=0;Z<p.length;Z++)i=i.replace("%"+p[Z][0],p[Z][1]);return i},A0D:{},YN:function(e,i){var t=null;if(i&&i.BP?t=i.BP:i&&i.A&&i.A.BP&&(t=i.A.BP),"string"==typeof e&&-1!==e.indexOf("%color-")&&ZC.COLORS.length>0)for(var n=0;n<ZC.COLORS.length;n++)-1===e.indexOf("(+")&&-1===e.indexOf("(-")||(e=e.replace(/%color-(\d+?)\((\+|\-)(\d+?)\)/gi,function(){var e=ZC.AP.G9(ZC.COLORS[ZC._i_(arguments[1])]);return"+"===arguments[2]?e=ZC.AP.QR(e,ZC._i_(arguments[3])):"-"===arguments[2]&&(e=ZC.AP.JK(e,ZC._i_(arguments[3]))),e})),e=e.replace("%color-"+n,ZC.COLORS[n]);else"string"==typeof e&&t&&-1!==e.indexOf("%palette-")&&(e=t[ZC._i_(e.replace("%palette-",""))]);return e},G9:function(e,i){var t,n,a,l;if(null!==ZC._n_(ZC.AP.A0D[e]))return ZC.AP.A0D[e];var o=ZC.GV(String(e)),r=1,s=!1;return 0===o.length?"":("rgba("===(o=o.replace("0x","#")).substring(0,5)?(t=new RegExp("rgba\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3}),\\s*([0-9.]+)\\)","gi").exec(o))&&(1===(n=ZC.OV(t[1])).length&&(n="0"+n),1===(a=ZC.OV(t[2])).length&&(a="0"+a),1===(l=ZC.OV(t[3])).length&&(l="0"+l),o="#"+n+a+l,r=ZC.BQ(0,ZC.CY(1,parseFloat(t[4]))),s=!0):"rgb("===o.substring(0,4)?(t=new RegExp("rgb\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\)","gi").exec(o))&&(1===(n=ZC.OV(t[1])).length&&(n="0"+n),1===(a=ZC.OV(t[2])).length&&(a="0"+a),1===(l=ZC.OV(t[3])).length&&(l="0"+l),o="#"+n+a+l):"#"===o.substring(0,1)?4===o.length?o="#"+o.substring(1,2)+o.substring(1,2)+o.substring(2,3)+o.substring(2,3)+o.substring(3,4)+o.substring(3,4):7!==o.length&&(o=""):null!==ZC._n_(ZC.Q.A9S[o.toUpperCase()])&&(o="#"+ZC.Q.A9S[o.toUpperCase()]),"none"!==o&&"transparent"!==o||(o="-1"),i||(ZC.AP.A0D[e]=o),i&&s?[o,r]:o)},A1N:{},A32:function(e,i){if(-1===e&&(e="#ffffff",i=0),null!==ZC._n_(ZC.AP.A1N[e+","+i]))return ZC.AP.A1N[e+","+i];4===e.length&&(e=e.substring(0,1)+e.substring(1,2)+e.substring(1,2)+e.substring(2,3)+e.substring(2,3)+e.substring(3,4)+e.substring(3,4));var t="rgba("+[ZC.QY(e.substring(1,3)),ZC.QY(e.substring(3,5)),ZC.QY(e.substring(5,7)),i].join(",")+")";return ZC.AP.A1N[e+","+i]=t,t},AD9:function(e,i,t){e/=255,i/=255,t/=255;var n,a,l,o=Math.max(e,i,t),r=Math.min(e,i,t);l=o;var s=o-r;if(a=0===o?0:s/o,o===r)n=0;else{switch(o){case e:n=(i-t)/s+(i<t?6:0);break;case i:n=(t-e)/s+2;break;case t:n=(e-i)/s+4}n/=6}return[n,a,l]},AD7:function(e,i,t){var n,a,l,o=Math.floor(6*e),r=6*e-o,s=t*(1-i),A=t*(1-r*i),C=t*(1-(1-r)*i);switch(o%6){case 0:n=t,a=C,l=s;break;case 1:n=A,a=t,l=s;break;case 2:n=s,a=t,l=C;break;case 3:n=s,a=A,l=t;break;case 4:n=C,a=s,l=t;break;case 5:n=t,a=s,l=A}return[255*n,255*a,255*l]},JK:function(e,i){if(-1===e)return-1;if(i>=100)return"#000000";e=ZC.AP.G9(e),void 0===i&&(i=10);var t=ZC.QY(e.substring(1,3)),n=ZC.QY(e.substring(3,5)),a=ZC.QY(e.substring(5,7)),l=ZC.AP.AD9(t,n,a);l[2]=i>0?Math.max(0,l[2]-l[2]*i/100):Math.min(1,l[2]-l[2]*i/100);var o=ZC.AP.AD7(l[0],l[1],l[2]);return o[0]=ZC._i_(o[0])<16?"0"+ZC.OV(o[0]):ZC.OV(o[0]),o[1]=ZC._i_(o[1])<16?"0"+ZC.OV(o[1]):ZC.OV(o[1]),o[2]=ZC._i_(o[2])<16?"0"+ZC.OV(o[2]):ZC.OV(o[2]),e="#"+o[0]+o[1]+o[2]},QR:function(e,i){if(-1===e)return-1;if(i>=100)return"#ffffff";e=ZC.AP.G9(e),void 0===i&&(i=10);var t=parseInt(e.substr(1,2),16),n=parseInt(e.substr(3,2),16),a=parseInt(e.substr(5,2),16);return"#"+(0|256+t+(256-t)*i/100).toString(16).substr(1)+(0|256+n+(256-n)*i/100).toString(16).substr(1)+(0|256+a+(256-a)*i/100).toString(16).substr(1)},_hex2rgb_:function(e,i){var t=parseInt(e.substr(1,2),16),n=parseInt(e.substr(3,2),16),a=parseInt(e.substr(5,2),16);return ZC._n_(i)?"rgb("+t+","+n+","+a+")":{r:t,g:n,b:a}},_rgb2hex_:function(e,i,t){return"#"+((1<<24)+(e<<16)+(i<<8)+t).toString(16).slice(1)},A9O:function(e,i,t){var n=ZC.AP._hex2rgb_(e);return(299*n.r+587*n.g+114*n.b)/1e3>=128?t:i},_colorAlpha_:function(e,i,t){e=ZC.AP.G9(e),i=ZC.AP.G9(i);var n=ZC.AP._hex2rgb_(e),a=ZC.AP._hex2rgb_(i),l={};for(var o in n)l[o]=Math.floor(t*n[o]+(1-t)*a[o]);return ZC.AP._rgb2hex_(l.r,l.g,l.b)},A3E:function(){},ABR:function(){},gc:function(e,i){var t;for(t=0;t<i.length;t++)e[i[t]]=null;for(t in e)0===t.indexOf("zc_")&&"function"==typeof e[t]&&(e[t]=null)}},ZC.Q={A9S:{BLACK:"000000",BLUE:"0000FF",BROWN:"A52A2A",CYAN:"00FFFF",FUCHSIA:"FF00FF",GOLD:"FFD700",GRAY:"808080",GREEN:"008000",INDIGO:"4B0082",LIME:"00FF00",MAGENTA:"FF00FF",MAROON:"800000",NAVY:"000080",ORANGE:"FFA500",PINK:"FFC0CB",PURPLE:"800080",RED:"FF0000",SILVER:"C0C0C0",TURQUOISE:"40E0D0",VIOLET:"EE82EE",WHITE:"FFFFFF",YELLOW:"FFFF00"},FW:function(e,i,t){return"<area"+(t&&!i&&"hand"!==t?' style="cursor:'+t+'"':"")+(i&&"arrow"!==t||"hand"===t?' href="javascript:;"':"")+' shape="'+e+'" '},ABE:function(e){var i;if(ZC.A4.browser.msie)try{i=document.createElement("<iframe />")}catch(r){i=document.createElement("iframe")}else i=document.createElement("iframe");i.id=e.id+"-iframe",i.style.visibility="hidden",e.appendChild(i);var t=null,n=i.contentWindow||i.contentDocument;if(!(t=n.document?n.document:n).body){var a=t.createElement("HTML");t.appendChild(a);var l=t.createElement("HEAD");a.appendChild(l);var o=t.createElement("BODY");a.appendChild(o)}return t},BZ:function(e){var i;if("undefined"==typeof ZC.TOUCHEVENTS){if(ZC.ie678)i=!1;else{i=!0;try{document.createEvent("TouchEvent")}catch(t){i=!1}}i&&!ZC.mobile&&(i=!1),i&&(i="ontouchstart"in document.documentElement),ZC.TOUCHEVENTS=i}else i=ZC.TOUCHEVENTS;if(i)switch(e){case"mouseover":case"mousedown":e="touchstart";break;case"mousemove":e="touchmove";break;case"mouseout":case"mouseup":e="touchend";break;case"click":e="touchstart"}return e},_sh_:function(e,i){var t,n,a,l=[],o=i.JV,r=i.OH,s=i.P7,A=o-s/2;if(e.length>0){var C=0,c=0;for(0!==o&&(C=ZC._i_(A*ZC.EH(r)+s),c=ZC._i_(A*ZC.EO(r)+s)),t=0,n=e.length;t<n;t++)if(null!==ZC._n_(e[t])){var u=[];for(a=0;a<e[t].length;a++)u[a]=e[t][a];var p=u.length;if(2===p||4===p)for(a=0;a<p;a++)u[a]=e[t][a]+(a%2?c+ZC._c_(i.BH,0):C+ZC._c_(i.BL,0));l.push(u)}else l.push(null)}return l},_txp_:function(e,i,t,n,a){void 0===a&&(a=!1);var l,o,r=[e[0],e[1]];switch(e.length>=4&&(r[2]=e[2],r[3]=e[3]),e.length>=6&&(r[4]=e[4],r[5]=e[5]),7===e.length&&(r[6]=e[6]),i){case"canvas":case"svg":var s,A;if(t.CZ)s=A=t.AZ%2==1?.5:0,ZC.A4.browser.msie&&ZC.quirks&&"svg"===i&&(s=t.AZ%2==1?.5:0,A=t.AZ%2==1?0:.5),r[0]=Math.round(r[0])-s,r[1]=Math.round(r[1])-A,4===r.length&&(r[2]=Math.round(r[2])-s,r[3]=Math.round(r[3])-A);"svg"===i&&(r[0]=parseFloat(r[0].toFixed(4)),r[1]=parseFloat(r[1].toFixed(4)),4===r.length&&(r[2]=parseFloat(r[2].toFixed(4)),r[3]=parseFloat(r[3].toFixed(4)))),"canvas"!==i||n||"undefined"!=typeof t.BL&&"undefined"!=typeof t.BH&&(r[0]+=t.BL,r[1]+=t.BH,4===r.length&&(r[2]+=t.BL,r[3]+=t.BH));break;case"vml":t.A9%360==0?(l=10,o=t.AZ%2==1?0:l/2):(l=1,o=0),t.CZ?(r[0]=l*ZC._i_(ZC._i_(l*r[0])/l)-o,r[1]=l*ZC._i_(ZC._i_(l*r[1])/l)-o,4!==r.length&&7!==r.length||(r[2]=l*ZC._i_(ZC._i_(l*r[2])/l)-o,r[3]=l*ZC._i_(ZC._i_(l*r[3])/l)-o),7===r.length&&(r[4]=l*ZC._i_(ZC._i_(l*r[4])/l)-o,r[5]=l*ZC._i_(ZC._i_(l*r[5])/l)-o)):(r[0]=ZC._i_(l*r[0]),r[1]=ZC._i_(l*r[1]),4!==r.length&&7!==r.length||(r[2]=ZC._i_(l*r[2]),r[3]=ZC._i_(l*r[3])),7===r.length&&(r[4]=ZC._i_(l*r[4]),r[5]=ZC._i_(l*r[5])))}return r},A2W:function(e,i,t,n,a){var l,o,r,s,A,C,c;if(t.QP&&(t.E["fast-vector-path"]=!0),!t.E["fast-vector-path"]){for(l=0,o=e.length;l<o;l++)e[l]&&(e[l][0]=parseFloat(Number(e[l][0]).toFixed(2)),e[l][1]=parseFloat(Number(e[l][1]).toFixed(2)));if(t.O7&&(c=t.K+":"+t.A9+":"+e.join("#"),ZC.cache.data["path-points-"+c]))return ZC.cache.data["path-points-"+c].split("#")}var u=[ZC.MAX,ZC.MAX,-ZC.MAX,-ZC.MAX],p=[],Z=!1;for(l=0,o=e.length;l<o;l++)if(null!==ZC._n_(e[l])){if(t.E["fast-vector-path"]){if(r=e[l],"vml"===i){var h=t.A9%360==0?10:1;r[0]=ZC._i_(h*r[0]),r[1]=ZC._i_(h*r[1]),4===r.length&&(r[2]=ZC._i_(h*r[2]),r[3]=ZC._i_(h*r[3]))}}else r=ZC.Q._txp_(e[l],i,t,n,a);if(null!==ZC._n_(r)&&!isNaN(r[0])&&!isNaN(r[1])&&isFinite(r[0])&&isFinite(r[1]))if(o<=20&&n&&(u[0]=ZC.CY(u[0],r[0]/("vml"===i?10:1)),u[1]=ZC.CY(u[1],r[1]/("vml"===i?10:1)),u[2]=ZC.BQ(u[2],r[0]/("vml"===i?10:1)),u[3]=ZC.BQ(u[3],r[1]/("vml"===i?10:1))),0===l)p.push(("svg"===i?"M ":"m ")+r[0]+" "+r[1]);else if(Z&&(p.push(("svg"===i?"M ":"m ")+r[0]+" "+r[1]),Z=!1),2===r.length)p.push(("svg"===i?"L ":"l ")+r[0]+" "+r[1]);else if(4===r.length)p.push(("svg"===i?"Q ":"qb ")+r[0]+" "+r[1]+" "+r[2]+" "+r[3]),"vml"===i&&p.push("l "+r[2]+" "+r[3]);else if(6===r.length)if("svg"===i){var d=0;r[3]%360==r[4]%360&&(d=r[4]>=r[3]?.001:-.001),s=ZC.AR.BN(r[0],r[1],r[2],r[3]+d),A=ZC.AR.BN(r[0],r[1],r[2],r[4]-d),C="0 0",0===r[5]?r[4]-r[3]>360?(C="0 1",A[0]=s[0],A[1]=s[1]):C=r[4]-r[3]<=180?"0 1":"1 1":r[3]-r[4]>360?(C="0 0",A[0]=s[0],A[1]=s[1]):C=r[3]-r[4]<=180?"0 0":"1 0",p.push("a "+r[2]+","+r[2]+" 0 "+C+" "+(A[0]-s[0])+","+(A[1]-s[1]))}else"vml"===i&&(r[2]*=10,s=ZC.AR.BN(r[0],r[1],r[2],r[3]),A=ZC.AR.BN(r[0],r[1],r[2],r[4]),C=1===r[5]?"at":"wa",p.push(C+" "+ZC._i_(r[0]-r[2])+","+ZC._i_(r[1]-r[2])+","+ZC._i_(r[0]+r[2])+","+ZC._i_(r[1]+r[2])+" "+ZC._i_(s[0])+","+ZC._i_(s[1])+" "+ZC._i_(A[0])+","+ZC._i_(A[1])));else 7===r.length&&p.push(("svg"===i?"C ":"c ")+r[0]+" "+r[1]+" "+r[2]+" "+r[3]+" "+r[4]+" "+r[5])}else Z=!0;return t.E["fast-vector-path"]||t.O7&&ZC.cache.add("path-points-"+c,p.join("#")),t.H&&o<=20&&n&&(t.H.E[t.K+"-bounds"]=u),p},MF:function(e,i){var t,n,a=e.originalEvent||e.originalEventZC;return i=ZC._i_(i||"0"),a&&a.touches?a.touches.length>0?(t=a.touches[i].pageX,n=a.touches[i].pageY):a.changedTouches.length>0&&(t=a.changedTouches[i].pageX,n=a.changedTouches[i].pageY):(t=e.pageX,n=e.pageY),[ZC._i_(t||"0"),ZC._i_(n||"0")]},F6:function(e,i,t){var n;return t=t||document,null!==ZC._n_(i)?t.createElementNS?n=t.createElementNS(i,e):(n=t.createElement(e)).setAttribute("xmlns",i):n=t.createElement(e),"zcv:"===e.substring(0,4)&&(n.className="zcvml"),n},EU:function(e){var i;e instanceof Array||(e=[e]);for(var t=0,n=e.length;t<n;t++)"object"!=typeof(i=e[t])&&(i=ZC.AL(e[t])),i&&("undefined"!=typeof i.parentElement?i.parentElement.removeChild(i):"undefined"!=typeof i.parentNode&&i.parentNode.removeChild(i))},G3:function(e,i){for(var t in i)if("string"==typeof t&&"object"!=typeof i[t]&&"function"!=typeof i[t])try{e.setAttribute(t,i[t])}catch(n){}},PI:function(e,i){for(var t in i)"string"==typeof t&&"object"!=typeof i[t]&&"function"!=typeof i[t]&&(e.style[t]=i[t])},AB3:function(e){var i;if(e===document)return!0;if(!e)return!1;if(!e.parentNode)return!1;if(e.style){if("none"===e.style.display)return!1;if("hidden"===e.style.visibility)return!1}if(window.getComputedStyle){if("none"===(i=window.getComputedStyle(e,"")).display)return!1;if("hidden"===i.visibility)return!1}if(i=e.currentStyle){if("none"===i.display)return!1;if("hidden"===i.visibility)return!1}return ZC.Q.AB3(e.parentNode)},T4:function(e){var i=e.className||ZC.A4(e).attr("class");return null!==ZC._n_(i)&&"object"==typeof i&&(i="undefined"!=typeof i.baseVal?i.baseVal:""),i||""},IV:function(e,i,t,n,a,l,o,r){if(e)switch(o=o||"",i){case"canvas":r?e.getContext("2d").clearRect(t,n,a,l):e.width=e.width;break;case"vml":case"svg":var s=e.childNodes.length;if(s>1024&&"undefined"!=typeof e.innerHTML)return void(e.innerHTML="");if(s>0)for(var A=s-1;A>=0;A--)""===o?e.removeChild(e.childNodes[A]):0===e.childNodes[A].id.indexOf(o+"-")&&e.removeChild(e.childNodes[A])}},EB:function(e,i){switch("string"==typeof e&&(e=ZC.AL(e)),i){case"canvas":return e.getContext("2d");case"svg":case"vml":return e}},JZ:function(e,i){switch(i){case"svg":return ZC.Q.ABK(e);case"vml":case"canvas":return ZC.Q.HY(e)}},HE:function(e,i){switch(i){case"svg":return ZC.Q.ABK(e);case"vml":return ZC.Q.HY(e);case"canvas":return ZC.Q.ADB(e)}},ABK:function(e){var i;if(ZC.AL(e.id))return ZC.AL(e.id);var t=ZC.Q.F6("g","http://www.w3.org/2000/svg");return null!==ZC._n_(i=e.id)&&t.setAttribute("id",i),null!==ZC._n_(i=e.cls)&&t.setAttribute("class",i),null!==ZC._n_(i=e.zidx)&&t.setAttribute("z-index",i),null!==ZC._n_(i=e["clip-path"])&&t.setAttribute("clip-path",i),e.after?e.p.insertBefore(t,e.after.nextSibling):e.p.appendChild(t),t},XD:function(e){var i;ZC.Q.EU(e.id);var t=ZC.Q.F6("clipPath","http://www.w3.org/2000/svg");return t.id=e.id,null!==ZC._n_(e.cx)?((i=ZC.Q.F6("circle","http://www.w3.org/2000/svg")).id=e.id+"-shape",ZC.Q.G3(i,{cx:e.cx,cy:e.cy,r:e.r})):((i=ZC.Q.F6("polygon","http://www.w3.org/2000/svg")).id=e.id+"-shape",ZC.Q.G3(i,{points:e.path})),t.appendChild(i),t},ADB:function(e){var i;if(ZC.AL(e.id))return ZC.AL(e.id);var t=document.createElement("canvas"),n=t.style;if(null!==ZC._n_(i=e.id)&&(t.id=i),null!==ZC._n_(i=e.cls)&&(t.className=i),null!==ZC._n_(i=e.wh)){var a=(""+i).split("/");e.width=a[0],e.height=a[1]}if(null!==ZC._n_(i=e.tl)){var l=(""+i).split("/");e.top=l[0],e.left=l[1]}return t.width=e.width,t.height=e.height,null!==ZC._n_(i=e.left)&&(n.left=i+"px"),null!==ZC._n_(i=e.top)&&(n.top=i+"px"),null!==ZC._n_(i=e.display)&&(n.display=i),null!==ZC._n_(i=e.position)&&(n.position=i),null!==ZC._n_(i=e.zidx)&&(n.zIndex=i),e.p.appendChild(t),t},HY:function(e){var i,t,n,a,l,o;if(ZC.AL(e.id))return n=ZC.AL(e.id),null!==ZC._n_(i=e.wh)&&(l=(""+i).split("/"),n.style.width=l[0]+"px",n.style.height=l[1]+"px"),null!==ZC._n_(i=e.tl)&&(o=(""+i).split("/"),n.style.top=o[0]+"px",n.style.left=o[1]+"px"),n;(a=(n=document.createElement("div")).style).whiteSpace="nowrap",null!==ZC._n_(i=e.wh)&&(l=(""+i).split("/"),e.width=l[0],e.height=l[1]),null!==ZC._n_(i=e.tl)&&(o=(""+i).split("/"),e.top=o[0],e.left=o[1]),null!==ZC._n_(i=e.id)&&(n.id=i),null!==ZC._n_(i=e.cls)&&""!==i&&(n.className=i);for(var r=[["top","","px"],["left","","px"],["width","","px"],["height","","px"],"position","overflow",["float","cssFloat|styleFloat"],["zidx","zIndex"],"clip","display",["fontSize","","px"],"fontFamily","fontWeight","fontStyle","textDecoration","textAlign","verticalAlign","color","border","borderTop","borderRight","borderBottom","borderLeft","background","cursor",["margin","marginTop|marginRight|marginBottom|marginLeft","px"],["marginTop","","px"],["marginRight","","px"],["marginBottom","","px"],["marginLeft","","px"],["padding","paddingTop|paddingRight|paddingBottom|paddingLeft","px"],["paddingTop","","px"],["paddingRight","","px"],["paddingBottom","","px"],["paddingLeft","","px"],"lineHeight","filter"],s=null,A=null,C=null,c=0,u=r.length;c<u;c++)if("string"==typeof r[c]&&(r[c]=[r[c]]),i=null,null!==ZC._n_(t=e[r[c][0]])&&(i=t),null!==ZC._n_(i)){null!==ZC._n_(r[c][1])&&""!==r[c][1]||(r[c][1]=r[c][0]);for(var p=r[c][1].split("|"),Z=0,h=p.length;Z<h;Z++){var d=i+(null===ZC._n_(r[c][2])?"":r[c][2]);a[p[Z]]=d,"fontFamily"===p[Z]&&(s=d),"fontSize"===p[Z]&&(A=ZC._i_(d)),"fontWeight"===p[Z]&&(C=d)}}return null!==ZC._n_(i=e.opacity)&&(a.opacity=i,1!==ZC._f_(i)&&(a.filter="alpha(opacity = "+ZC._i_(100*ZC._f_(i))+")",a.opacity=i)),null!==ZC._n_(i=e.p)&&(e.after?i.insertBefore(n,e.after.nextSibling):i.appendChild(n)),null!==ZC._n_(i=e.html)&&(n.innerHTML=ZC._h_(i),-1!==i.indexOf("<")&&-1!==i.indexOf(">")&&ZC.A4(n).children().each(function(){null!==ZC._n_(s)&&(null!==ZC._n_(this.style.fontFamily)&&""!==this.style.fontFamily||(this.style.fontFamily=s)),null!==ZC._n_(A)&&(null!==ZC._n_(this.style.fontSize)&&""!==this.style.fontSize||(this.style.fontSize=A+"px")),null!==ZC._n_(C)&&(null!==ZC._n_(this.style.fontWeight)&&""!==this.style.fontWeight||(this.style.fontWeight=C))})),e.rtl&&(n.style.unicodeBidi="bidi-override",n.style.direction="rtl"),e.cursor&&"hand"===e.cursor&&(n.style.cursor="pointer"),n},W1:null,A43:function(e,i,t,n,a,l,o){var r,s,A,C;null===ZC._n_(o)&&(o=!1);var c=!1;"[HTMLMODE]"===i.substring(0,10)&&(c=!0,i=i.substring(10)),C=e+"-text-ruler",-1!==e.indexOf("-fullscreen")&&(C="zc-text-ruler");var u="{{"+i+"}}"+t.replace(/[^a-z]/gi,"").toLowerCase()+n+l+a;if(ZC.cache.data["text-width-"+u]&&!o)return ZC.cache.data["text-width-"+u];if(ZC.cache.data["text-height-"+u]&&o)return ZC.cache.data["text-height-"+u];var p,Z=i;return Z=Z.replace(/<hr>/g,'<hr style="margin:0;padding:0">'),(p=ZC.AL(C))?(ZC.Q.W1&&ZC.Q.W1===e+t+n+l+a||(p.style.fontFamily=t,p.style.fontSize=n+"px",p.style.fontWeight=a,p.style.lineHeight=c?"130%":-1!==l?ZC._i_(l)+"px":"130%",ZC.Q.W1=e+t+n+l+a),p.innerHTML=Z):(p=ZC.Q.HY({id:C,p:document.body,tl:"-9999/-9999",html:Z,position:"absolute",fontFamily:t,fontSize:n,cls:"zc-text-ruler",fontWeight:a})).style.lineHeight=c?"130%":-1!==l?ZC._i_(l)+"px":"130%",-1===i.indexOf("<")||-1===i.indexOf(">")||c||ZC.A4(p).children().each(function(){"BR"!==this.tagName.toUpperCase()&&(null!==ZC._n_(this.style.fontFamily)&&""!==this.style.fontFamily||(this.style.fontFamily=t),null!==ZC._n_(this.style.fontSize)&&""!==this.style.fontSize||(this.style.fontSize=n+"px"),this.style.lineHeight=-1!==l?ZC._i_(l)+"px":"130%","B"!==this.tagName.toUpperCase()&&"STRONG"!==this.tagName.toUpperCase()&&(null!==ZC._n_(this.style.fontWeight)&&""!==this.style.fontWeight||(this.style.fontWeight=a)))}),(r=p.getBoundingClientRect())&&r.width>0?(s=r.width,o&&(A=r.height)):(s=ZC.mobile&&ZC.A4.browser.webkit?p.offsetWidth:ZC.A4(p).width(),o&&(A=ZC.mobile&&ZC.A4.browser.webkit?p.offsetHeight:ZC.A4(p).height())),o?(ZC.cache.add("text-height-"+u,A),A):(ZC.cache.add("text-width-"+u,s),s)}},!document.getElementsByClassName&&document.querySelectorAll&&(document.getElementsByClassName=function(e){return document.querySelectorAll("."+e)}),ZC.A4=function(e,i,t){var n,a,l,o,r=this;if(void 0===t&&(t=!0),t)return new ZC.A4(e,i,!1);if(r.P2=[],r.QG=e,r.MA=i,r.length=0,r.MA=r.MA||document.getElementsByTagName("body")[0],"object"==typeof r.QG)r.P2=[r.QG];else if("string"==typeof r.QG)for(var s=r.QG.split(","),A=0;A<s.length;A++){var C=ZC.GV(s[A]),c=!1;if(2===(n=C.split(">")).length&&(c=!0,ZC.A4(n[0]).each(function(){var e=this;ZC.A4(n[1],this).each(function(){this.parentNode===e&&r.P2.push(this)})})),2===(n=C.split(" ")).length&&(c=!0,ZC.A4(n[0]).each(function(){ZC.A4(n[1],this).each(function(){r.P2.push(this)})})),!c)if("#"===C.substring(0,1))ZC.AL(C.substring(1))&&(r.P2=[ZC.AL(C.substring(1))]);else if("."===C.substring(0,1))if(document.getElementsByClassName){if(r.MA.getElementsByClassName)a=r.MA.getElementsByClassName(C.substring(1));else if(a=document.getElementsByClassName(C.substring(1)),r.MA!==document){var u=[];for(l=0,o=a.length;l<o;l++)ZC.A4.childof(a[l],r.MA)&&u.push(a[l]);a=u}for(l=0,o=a.length;l<o;l++)r.P2.push(a[l])}else{var p=new RegExp("(^|\\s)"+C.substring(1)+"(\\s|$)","i"),Z=r.MA.getElementsByTagName("*"),h="";for(l=0,o=Z.length;l<o;l++)"object"==typeof(h=Z[l].className)&&(h="undefined"!=typeof h.baseVal?h.baseVal:""),""!==h&&p.test(h)&&r.P2.push(Z[l])}else for(l=0,o=(a=r.MA.getElementsByTagName(C)).length;l<o;l++)r.P2.push(a[l])}return r.length=r.P2.length,this},ZC.A4.prototype={eachfn:function(){for(var e,i=[],t=0,n=this.P2.length;t<n;t++){var a=[this.P2[t]];if((e=arguments.length)>1)for(var l=1;l<e;l++)a.push(arguments[l]);i.push(arguments[0].apply(this,a))}return i},each:function(){for(var e,i=0,t=this.P2.length;i<t;i++){var n=[this.P2[i]];if((e=arguments.length)>1)for(var a=1;a<e;a++)n.push(arguments[a]);arguments[0].apply(this.P2[i],n)}return this},children:function(){var e=[];return this.each(function(){for(var i=0,t=this.childNodes.length;i<t;i++)1===this.childNodes[i].nodeType&&e.push(this.childNodes[i])}),this.P2=e,this},remove:function(){this.eachfn.call(this,function(e){e&&e.parentNode&&e.parentNode.removeChild(e)})},empty:function(){this.eachfn.call(this,function(e){if(e)for(;e.childNodes.length;)e.removeChild(e.childNodes[e.childNodes.length-1])})},A2V:function(e){var i,t;void 0===e&&(e=!0);var n=this.eachfn.call(this,function(n){if(!n)return null;if(n===window){var a=document.body;return n.innerWidth?(i=n.innerWidth,t=n.innerHeight):a&&a.parentElement&&a.parentElement.clientWidth?(i=a.parentElement.clientWidth,t=a.parentElement.clientHeight):a&&a.clientWidth&&(i=a.clientWidth,t=a.clientHeight),{width:i,height:t}}var l,o,r=e?"block":ZC.A4(n).getstyle("display");if(window.getComputedStyle){var s=window.getComputedStyle(n,null);l=s.getPropertyValue("width").slice(0,-2),o=s.getPropertyValue("height").slice(0,-2)}else if(n.getBoundingClientRect){var A=n.getBoundingClientRect();l=A.width?A.width:n.offsetWidth,o=A.height?A.height:n.offsetHeight}else l=n.offsetWidth,o=n.offsetHeight;if("none"===r||""===r||void 0===r){var C=n.style,c=C.visibility,u=C.position,p=C.display;C.visibility="hidden",C.position="absolute",C.display="block",i=l,t=o,C.display=p,C.position=u,C.visibility=c}else i=l||0,t=o||0;return{width:i,height:t}});return 1===n.length?n[0]:n},getstyle:function(e){var i=this.eachfn.call(this,function(e,i){if("display"===i)return e.style.display;var t,n=document;if(i=ZC.EE(i),!e||e===n)return undefined;if("opacity"===i&&"undefined"!=typeof e.filters){var a=(ZC.A4(e).getstyle("filter")||"").match(/alpha\(opacity=(.*)\)/);return a&&a[1]?parseFloat(a[1])/100:1}if(-1!==ZC.AV(["float","cssFloat","styleFloat"],i))return(t=e.style.float)?t:(t=e.style.cssFloat)?t:(t=e.style.styleFloat)?t:"none";var l=e.style?e.style[i]:null;if(!l)if(n.defaultView&&n.defaultView.getComputedStyle){var o=n.defaultView.getComputedStyle(e,null);i=i.replace(/([A-Z])/g,"-$1").toLowerCase(),l=o?o.getPropertyValue(i):null}else if(e.currentStyle&&(l=e.currentStyle[i],/^\d/.test(l)&&!/px$/.test(l)&&"fontWeight"!==i)){var r=e.style.left,s=e.runtimeStyle.left;e.runtimeStyle.left=e.currentStyle.left,e.style.left=l||0,l=e.style.pixelLeft+"px",e.style.left=r,e.runtimeStyle.left=s}return"opacity"===i&&(l=parseFloat(l)),/Opera/.test(navigator.userAgent)&&-1!==ZC.AV(["left","top","right","bottom"],i)&&"static"===ZC.A4(e).getstyle("position")&&(l="auto"),"auto"===l?null:l},e);return 1===i.length?i[0]:i},wh:function(){var e;return this.P2[0]?null!==ZC._n_(e=ZC.A4(this.P2[0]).A2V())?[ZC._i_(e.width),ZC._i_(e.height)]:[0,0]:null},width:function(e){var i;if(void 0===e){var t=this.eachfn.call(this,function(e){return null!==ZC._n_(i=ZC.A4(e).A2V())?ZC._i_(i.width):0});return 1===t.length?t[0]:t}return this.eachfn.call(this,function(e,i){e.style.width=i+"px"},e),this},height:function(e){var i;if(void 0===e){var t=this.eachfn.call(this,function(e){return null!==ZC._n_(i=ZC.A4(e).A2V())?ZC._i_(i.height):0});return 1===t.length?t[0]:t}return this.eachfn.call(this,function(e,i){e.style.height=i+"px"},e),this},scrollLeft:function(){return ZC.A4.scroll().left},scrollTop:function(){return ZC.A4.scroll().top},css:function(e,i){if(void 0===i){var t=this.eachfn.call(this,function(i){var t=ZC.A4(i).getstyle(e);return-1!==(""+t).indexOf("px")?ZC._i_(t):t});return 1===t.length?t[0]:t}return this.eachfn.call(this,function(e,i,t){e.style[i]=t},e,i),this},attr:function(e,i){if(void 0===i){var t=this.eachfn.call(this,function(i){return i.getAttribute(e)});return 1===t.length?t[0]:t}return this.eachfn.call(this,function(e,i,t){e.setAttribute(i,t)},e,i),this},val:function(e){if(void 0===e){var i=this.eachfn.call(this,function(e){return e.value});return 1===i.length?i[0]:i}return this.eachfn.call(this,function(e,i){e.value=i},e),this},show:function(){return this.eachfn.call(this,function(e){e.style.display="block"}),this},hide:function(){return this.eachfn.call(this,function(e){e.style.display="none"}),this},offset:function(){var e=this.eachfn.call(this,function(e){if(!(e&&(e.x&&e.y||null!==!e.parentNode&&"none"!==ZC.A4(e).getstyle("display"))))return undefined;var i,t,n,a,l,o,r,s={top:0,left:0},A={top:0,left:0},C=e&&e.ownerDocument;return C&&((t=C.body)===e&&(s={top:t.offsetTop,left:t.offsetLeft}),i=C.documentElement,"undefined"!=typeof e.getBoundingClientRect&&(A=e.getBoundingClientRect()),n=C.defaultView||C.parentWindow,a=i.clientTop||t.clientTop||0,l=i.clientLeft||t.clientLeft||0,o=n.pageYOffset||i.scrollTop,r=n.pageXOffset||i.scrollLeft,s={top:A.top+o-a,left:A.left+r-l}),s});return 1===e.length?e[0]:e},bind:function(e,i,t){if(""!==(e=ZC.A4.cleanTouchEvents(e))){if(t||(t=!ZC.hasPassive||{passive:!0}),-1!==e.indexOf(" ")){for(var n=e.split(/\s+/),a=0;a<n.length;a++)this.bind(n[a],i,t);return this}return this.eachfn.call(this,function(e,i,n){function a(e){var i=(e=e||window.event).target||e.srcElement,t=ZC.A4.BZ(e);null!==t&&n.call(i,t)}ZC.A4.IY||(ZC.A4.IY=[]),ZC.A4.IY.push([e,i,n,a]),e.addEventListener?e.addEventListener(i,a,t):e.attachEvent("on"+i,a)},e,i),this}},unbind:function(e,i){if(""!==(e=ZC.A4.cleanTouchEvents(e))){if(-1!==e.indexOf(" ")){for(var t=e.split(/\s+/),n=0;n<t.length;n++)this.unbind(t[n],i);return this}return this.eachfn.call(this,function(e,i,t){if("undefined"!=typeof ZC.A4.IY)for(var n=0,a=ZC.A4.IY.length;n<a;n++)if((ZC.A4.IY[n][0]===e||e.tagName&&"MAP"===e.tagName.toUpperCase()&&e.id===ZC.A4.IY[n][0].id)&&ZC.A4.IY[n][1]===i&&ZC.A4.IY[n][2]===t){e.removeEventListener?e.removeEventListener(i,ZC.A4.IY[n][3],!0):e.detachEvent("on"+i,ZC.A4.IY[n][3]),ZC.A4.IY.splice(n,1);break}},e,i),this}},live:function(e,i,t){if(""!==(e=ZC.A4.cleanTouchEvents(e))){if(t||(t=!ZC.hasPassive||{passive:!0}),-1===e.indexOf("touch")&&-1===e.indexOf("wheel")||(t={passive:!1}),-1!==e.indexOf(" ")){for(var n=e.split(/\s+/),a=0;a<n.length;a++)this.live(n[a],i,t);return this}var l=this.QG;return ZC.A4.EVENTS||(ZC.A4.EVENTS={}),ZC.A4.EVENTS[e]||(ZC.A4.EVENTS[e]=[],document.addEventListener?document.addEventListener(e,o,t):document.attachEvent("on"+e,o)),ZC.A4.EVENTS[e].push([l,i]),this}function o(i){var t=(i=i||window.event).target||i.srcElement,n=t.className||"";"object"==typeof n&&(n="undefined"!=typeof n.baseVal&&null!==ZC._n_(n.baseVal)?n.baseVal:"");var l,o,r=ZC.A4.EVENTS[e],s=null,A=null,C=[];for(l=0,o=r.length;l<o;l++)("object"==typeof r[l][0]&&t===r[a][0]||"string"==typeof r[l][0]&&("."===r[l][0].substring(0,1)&&-1!==ZC.AV(n.split(" "),r[l][0].replace(".",""))||"#"===r[l][0].substring(0,1)&&t.id===r[l][0].substring(1)))&&(s=r[l][1],A=ZC.A4.BZ(i),null!==ZC._n_(s)&&null!==ZC._n_(A)&&C.push([s,t,A]));for(l=0,o=C.length;l<o;l++)C[l][0].call(C[l][1],C[l][2])}},die:function(e,i){if(""!==(e=ZC.A4.cleanTouchEvents(e))){var t,n,a;if(-1!==e.indexOf(" ")){for(n=0,a=(t=e.split(/\s+/)).length;n<a;n++)this.die(t[n],i);return this}var l=this.QG;if(ZC.A4.EVENTS||(ZC.A4.EVENTS={}),t=ZC.A4.EVENTS[e])for(n=t.length-1;n>=0;n--)t[n][0]!==l||i&&t[n][1]!==i||ZC.A4.EVENTS[e].splice(n,1);return this}}},ZC.A4._list_=function(e){for(var i=[],t=0;t<ZC.A4.EVENTS[e].length;t++)i.push(ZC.A4.EVENTS[e][t][0]);return i.join(",")},ZC.A4.cleanTouchEvents=function(e){return ZC.ie678&&(e=ZC.GV(e.replace(/touchstart|touchend|touchmove/,""))),e},ZC.A4.cache={},ZC.A4.browser={},function(){var e=/(webkit)[ \/]([\w.]+)/,i=/(opera)(?:.*version)?[ \/]([\w.]+)/,t=/(msie) ([\w.]+)/,n=/(mozilla)(?:.*? rv:([\w.]+))?/,a=/(trident)(?:.*? rv:([\w.]+))?/,l=function(l){l=l.toLowerCase();var o=e.exec(l)||i.exec(l)||t.exec(l)||a.exec(l)||l.indexOf("compatible")<0&&n.exec(l)||[];return[o[1]||"",o[2]||"0"]}(navigator.userAgent);l[0]&&("trident"===l[0]&&(l[0]="msie"),ZC.A4.browser[l[0]]=!0,ZC.A4.browser.version=l[1])}(),ZC.A4.scroll=function(){var e={top:0,left:0},i=document,t=i.documentElement,n=i.body;return t&&(t.scrollTop||t.scrollLeft)?(e.left=t.scrollLeft,e.top=t.scrollTop):n&&(e.left=n.scrollLeft,e.top=n.scrollTop),e},ZC.A4.BZ=function(e){if(e.originalEventZC=e,e.target||(e.target=e.srcElement||document),3!==e.target.nodeType&&8!==e.target.nodeType||(e.target=e.target.parentNode),null===ZC._n_(e.pageX)&&null!==ZC._n_(e.clientX)){var i=e.target.ownerDocument||document,t=i.documentElement,n=i.body;e.pageX=e.clientX+(t&&t.scrollLeft||n&&n.scrollLeft||0)-(t&&t.clientLeft||n&&n.clientLeft||0),e.pageY=e.clientY+(t&&t.scrollTop||n&&n.scrollTop||0)-(t&&t.clientTop||n&&n.clientTop||0)}return e.which||e.button===undefined||(e.which=1&e.button?1:2&e.button?3:4&e.button?2:0),e.preventDefault||(e.preventDefault=function(){this.returnValue=!1}),e.stopPropagation||(e.stopPropagation=function(){this.cancelBubble=!0}),e},ZC.A4.childof=function(e,i){if(e===i)return!0;for(;e!==i&&e.parentNode;)if((e=e.parentNode)===i)return!0;return!1},ZC.A4.ajax=function(e){var i=e.url||"",t=e.type||"GET",n=e.data||"",a=!0;"undefined"!=typeof e.async&&(a=ZC._b_(e.async)),""===n.replace(/\&/g,"")&&(n="");var l=e.beforeSend||null,o=e.error||null,r=e.success||null,s=null;try{window.ActiveXObject?s=new ActiveXObject("Microsoft.XMLHTTP"):window.XMLHttpRequest&&(s=new XMLHttpRequest)}catch(C){}var A="file:"===window.location.protocol;if(s){a&&(s.onreadystatechange=function(){4===s.readyState&&((A||s.status>=200&&s.status<300)&&r&&r(s.responseText,s.status,s,i),s.status>=400&&o&&o(s,s.status,s.statusText,i),s.onreadystatechange=new window.Function,s=null)}),window.ActiveXObject||(s.onerror=function(){o&&o(s,0,"",i)}),"POST"===t.toUpperCase()?(s.open("POST",i,a),s.setRequestHeader("X-Requested-With","XMLHttpRequest"),s.setRequestHeader("Content-type","application/x-www-form-urlencoded")):(""!==n&&(-1===i.indexOf("?")&&(i+="?"),i+="&"+n),s.open("GET",i,a)),l&&l(s);try{s.send(n),a||((A||s.status>=200&&s.status<300)&&r&&r(s.responseText,s.status,s,i),s.status>=400&&o&&o(s,s.status,s.statusText,i),s=null)}catch(c){A&&o&&(o(s,s.status,s.statusText,i),s.onreadystatechange=new window.Function,s=null)}}},ZC.AR={ACI:function(e,i){var t,n,a=zingchart.DEV.SPREADFACTOR,l=[],o=0;function r(e,i){-1===ZC.AV(e,i)&&e.push(i)}for(t=0;t<e.length;t++)e[t]+=i;var s=-1;for(t=1;t<e.length;t++)ZC._a_(e[t]-e[t-1])<a?(l[o]=l[o]||{min:-1,max:-1,items:[]},-1===l[o].min&&(l[o].min=t>1?e[t-2]:i,-1===s&&(s=l[o].min),l[o].min),r(l[o].items,t-1),r(l[o].items,t)):l[o]&&(l[o].max=e[t],l[o].max,o++);l[o]&&-1===l[o].max&&(l[o].max=360+i);var A=l.length;if(A>1&&l[A-1].max-l[0].min==360){for(n=0;n<l[0].items.length;n++)e[l[0].items[n]]+=360;l[A-1].items=l[A-1].items.concat(l[0].items),l[A-1].max+=l[0].min,l=l.splice(1)}for(l.length>1&&(l[l.length-1].max=l[0].min+360),t=0;t<l.length;t++){var C=l[t],c=C.items.length,u=(C.max-C.min)/(c+4);u=ZC.CY(u,a);var p=0;for(n=0;n<C.items.length;n++)p+=e[C.items[n]];p/=C.items.length;for(var Z=!0;Z;)for(Z=!1,n=1;n<C.items.length;n++)if(e[C.items[n]]-e[C.items[n-1]]<u){e[C.items[n-1]]<p?(e[C.items[n-1]]-=.45,e[C.items[n]]+=.05):e[C.items[n]]+=.25,Z=!0;break}}return e},_int_:function(e){return Math.abs(e-ZC._i_(e))<Math.pow(10,-10)},XQ:function(e,i,t){return t=t||1,!(e.x>i.x+i.width+t)&&(!(i.x>e.x+e.width+t)&&(!(e.y>i.y+i.height+t)&&!(i.y>e.y+e.height+t)))},_boxoverlap2_:function(e,i,t){return t=t||1,!(e.iX>i.iX+i.I+t)&&(!(i.iX>e.iX+e.I+t)&&(!(e.iY>i.iY+i.F+t)&&!(i.iY>e.iY+e.F+t)))},AG6:function(e,i){return e.iX>=i.iX&&e.iX<=i.iX+i.I&&e.iY>=i.iY&&e.iY<=i.iY+i.F&&e.iX+e.I>=i.iX&&e.iX+e.I<=i.iX+i.I&&e.iY+e.F>=i.iY&&e.iY+e.F<=i.iY+i.F},A60:function(e,i,t){for(var n=Math.sqrt(e/Math.PI),a=Math.sqrt(i/Math.PI),l=Math.min(n,a),o=Math.max(n,a),r=ZC.MAX,s=0,A=l+o;A>o-l;A-=l/50){var C=l*l*Math.acos((A*A+l*l-o*o)/(2*A*l))+o*o*Math.acos((A*A+o*o-l*l)/(2*A*o))-.5*Math.sqrt((-A+l+o)*(A+l-o)*(A-l+o)*(A+l+o));Math.abs(C-t)<r&&(r=Math.abs(C-t),s=A)}return s},BN:function(e,i,t,n){return[e+t*Math.cos(2*n*Math.PI/360),i+t*Math.sin(2*n*Math.PI/360)]},A5I:function(e,i,t,n,a){var l=ZC.TN(Math.atan((n-i)/(t-e)));return[e+ZC._i_(ZC.EH(l)*a),i+ZC._i_(ZC.EO(l)*a)]},JU:function(e,i,t,n,a,l){if(a=null===ZC._n_(a)?0:a,l=null===ZC._n_(l)||l,t-e!=0){var o=0,r=0,s=Math.atan((n-i)/(t-e));return(a<1||l)&&(o=a/2.5*Math.cos(s),r=a/2.5*Math.sin(s)),[(e+t)/2+(e<t?o:-o),(i+n)/2+r]}return[e,(i+n)/2]},AB0:function(e,i){var t=(e[1]-i[1])/(e[0]-i[0]);return[t,e[1]-t*e[0]]},A4K:function(e,i,t,n){if(i[0]===n[0]&&i[1]===n[1])return i;if(e[0]===t[0]&&e[1]===t[1])return e;var a=ZC.AR.AB0(e,i),l=a[0],o=a[1],r=ZC.AR.AB0(t,n),s=r[0],A=(r[1]-o)/(l-s);return[A,l*A+o]},PR:function(e,i,t){null===ZC._n_(i)&&(i=5);var n=0,a=0;null!==ZC._n_(t)&&(n=t[0],a=t[1]);for(var l,o,r,s="",A=ZC.ie67?ZC.MAPTX:0,C=0,c=e.length;C<c;C++)e[C]&&(0===C?(o=e[C][0]+A+n,r=e[C][1]+A+a,l=C,s+=Math.round(o,10)+","+Math.round(r,10)+","):Math.sqrt((e[C][0]+A-o)*(e[C][0]+A-o)+(e[C][1]+A-r)*(e[C][1]+A-r))>i&&e[C-1]&&(Math.sqrt((e[C][0]-e[C-1][0])*(e[C][0]-e[C-1][0])+(e[C][1]-e[C-1][1])*(e[C][1]-e[C-1][1]))>i&&C-l>1&&(s+=Math.round(e[C-1][0]+A+n,10)+","+Math.round(e[C-1][1]+A+a,10)+","),o=e[C][0]+A+n,r=e[C][1]+A+a,l=C,s+=Math.round(o,10)+","+Math.round(r,10)+","));return s=s.substring(0,s.length-1)},Z0:function(e,i){if(null===ZC._n_(e)||e.length<2)return"";null===ZC._n_(i)&&(i=6,ZC.mobile&&(i+=10));var t,n,a,l,o,r=[];for(t=0,n=e.length;t<n;t++)(0===t||t>0&&null!==ZC._n_(e[t])&&null!==ZC._n_(e[t-1])&&e[t].join("/")!==e[t-1].join("/")||null===ZC._n_(e[t]))&&r.push(e[t]);var s=[],A=[],C=!1;for(t=0,n=r.length;t<n;t++)if(r[t]){var c,u,p,Z,h=r[t][0],d=r[t][1];if(r[t-1]&&(p=r[t-1][0],Z=r[t-1][1],p===h&&(p-=.1)),r[t+1]&&(c=r[t+1][0],u=r[t+1][1],c===h&&(c+=.1)),0===t)a=Math.atan((u-d)/(c-h)),o=l=ZC.TN(a),c>=h&&(o+=180),s.push(ZC.AR.BN(h,d,i,l+90),ZC.AR.BN(h,d,i,o),ZC.AR.BN(h,d,i,l+270));else if(t===r.length-1)a=Math.atan((Z-d)/(p-h)),o=l=ZC.TN(a),p>=h&&(o+=180),C?(A.push(ZC.AR.BN(h,d,i,l+270),ZC.AR.BN(h,d,i,o),ZC.AR.BN(h,d,i,l+90)),C=!1):s.push(ZC.AR.BN(h,d,i,l+270),ZC.AR.BN(h,d,i,o),ZC.AR.BN(h,d,i,l+90));else{var f=Math.atan((u-d)/(c-h)),_=Math.atan((d-Z)/(h-p));o=ZC.TN((f+_)/2),s.push(ZC.AR.BN(h,d,i,o+270)),c>=h&&p>=h?(s.push(ZC.AR.BN(h,d,i,o+180)),s.push(ZC.AR.BN(h,d,i,o+90)),A.push(ZC.AR.BN(h,d,i,o)),C=!0):c<=h&&p<=h?(s.push(ZC.AR.BN(h,d,i,o)),s.push(ZC.AR.BN(h,d,i,o+90)),A.push(ZC.AR.BN(h,d,i,o+180)),C=!0):A.push(ZC.AR.BN(h,d,i,o+90))}}for(t=A.length-1;t>=0;t--)s.push(A[t]);return s},A2C:function(e,i){var t=0,n=0,a=[];switch(e+=""){case"horizontal":case"h":t=1,n=i;break;case"vertical":case"v":t=i,n=1;break;default:a=e.split("x"),null!==ZC._n_(a[0])&&ZC._i_(a[0])+""===a[0]&&(t=ZC._i_(a[0])),null!==ZC._n_(a[1])&&ZC._i_(a[1])+""===a[1]&&(n=ZC._i_(a[1])),0===n&&0===t?(t=Math.ceil(Math.sqrt(i)),n=Math.ceil(i/t)):(0===n&&(n=Math.ceil(i/t)),0===t&&(t=Math.ceil(i/n)))}return[t,n]},AB4:function(e,i){return.5*(2*i[1]+(-i[0]+i[2])*e+(2*i[0]-5*i[1]+4*i[2]-i[3])*e*e+(-i[0]+3*i[1]-3*i[2]+i[3])*e*e*e)},AB7:function(e,i){var t,n,a,l,o,r=e.length,s=[],A=[],C=[];for(t=0;t<r-1;t++)n=e[t+1]-e[t],a=i[t+1]-i[t],A.push(n),s.push(a),C.push(a/n);var c=[C[0]];for(t=0;t<A.length-1;t++){l=C[t];var u=C[t+1];if(l*u<=0)c.push(0);else{n=A[t];var p=A[t+1];o=n+p,c.push(3*o/((o+p)/l+(o+n)/u))}}c.push(C[C.length-1]);var Z=[],h=[];for(t=0;t<c.length-1;t++){l=C[t];var d=c[t],f=1/A[t];o=d+c[t+1]-l-l,Z.push((l-d-o)*f),h.push(o*f*f)}return function(t){var n=e.length-1;if(t===e[n])return i[n];for(var a,l=0,o=h.length-1;l<=o;){a=Math.floor(.5*(l+o));var r=e[a];if(r<t)l=a+1;else{if(!(r>t))return i[a];o=a-1}}n=Math.max(0,o);var s=t-e[n],A=s*s;return i[n]+c[n]*s+Z[n]*A+h[n]*s*A}},Y9:function(e,i,t,n){null===ZC._n_(n)&&(n=1/(t/i.length*4));var a,l,o=[];if(e)if((a=[].concat(i))[1]&&a[2]){a[0]=a[0]||a[1]||a[2]||a[3],a[1]=a[1]||a[2]||a[0]||a[3],a[2]=a[2]||a[3]||a[1]||a[0],a[3]=a[3]||a[2]||a[1]||a[0];var r=ZC.AR.AB7([0,1,2,3],a);for(l=1;l<=2;l+=n)o.push([l-1,r(l)])}else o.push([]);else for(var s=1;s<i.length-2;s++)if(1!==n)if((a=[i[s-1],i[s],i[s+1],i[s+2]])[1]&&a[2])for(a[0]=a[0]||a[1]||a[2]||a[3],a[1]=a[1]||a[2]||a[0]||a[3],a[2]=a[2]||a[3]||a[1]||a[0],a[3]=a[3]||a[2]||a[1]||a[0],l=0;l<=1;l+=n){var A=s+l,C=ZC.AR.AB4(l,a);o.push([A-1,C])}else o.push([]);else o.push([s-1,i[s]]);return o},A0K:function(e){for(var i=Math.round(ZC.G6(ZC._a_(e))/Math.LN10),t=[1,2,4,5,6,8,10],n=ZC.MAX,a=1,l=0;l<t.length;l++){var o=t[l]*Math.pow(10,i)-e;ZC._a_(o)<n&&(a=t[l],n=ZC._a_(o))}return a*Math.pow(10,i)},_nice_number_:function(e,i){var t,n;return t=Math.floor(Math.log(e)/Math.log(10)),n=e/Math.pow(10,t),(i?n<1.5?1:n<3?2:n<7?5:10:n<=1?1:n<=2?2:n<=5?5:10)*Math.pow(10,t)},VS:function(e,i,t,n,a,l){var o,r,s,A,C,c;null===ZC._n_(a)&&(a=!0),l=null===ZC._n_(l)?10:Math.min(Math.max(2,l),100),null!==ZC._n_(n)&&0!==n||(n=1);var u=Math.floor(ZC.G6(ZC._a_(i))/Math.LN10);e===i&&(i+=Math.pow(10,u)),o=e,r=i,A=ZC.AR._nice_number_(r-o,!1),null===ZC._n_(t)?(s=A/(l-1),s=ZC.AR._nice_number_(s,!0),s*=n):s=t,a?(C=Math.floor(o/s)*s,c=Math.ceil(r/s)*s):(C=o,c=r,s=null===ZC._n_(t)?A/(l-1):t);var p=Math.floor(ZC.G6(ZC._a_(s))/Math.LN10),Z=p<0?ZC._a_(p):0;if(0===Z){var h=(""+s).split(".");2===h.length&&(Z=h[1].length)}return[C,c,s,Z,s]}},ZC.XR={md5:function(e){return ZC.XR.ACT(ZC.XR.ACU(ZC.XR.ACQ(e)))},ACU:function(e){return ZC.XR.AC6(ZC.XR.ACV(ZC.XR.ACD(e),8*e.length))},ACT:function(e){for(var i,t="",n=0,a=e.length;n<a;n++)i=e.charCodeAt(n),t+="0123456789abcdef".charAt(i>>>4&15)+"0123456789abcdef".charAt(15&i);return t},ACQ:function(e){for(var i,t,n="",a=-1,l=e.length;++a<l;)i=e.charCodeAt(a),t=a+1<l?e.charCodeAt(a+1):0,55296<=i&&i<=56319&&56320<=t&&t<=57343&&(i=65536+((1023&i)<<10)+(1023&t),a++),i<=127?n+=String.fromCharCode(i):i<=2047?n+=String.fromCharCode(192|i>>>6&31,128|63&i):i<=65535?n+=String.fromCharCode(224|i>>>12&15,128|i>>>6&63,128|63&i):i<=2097151&&(n+=String.fromCharCode(240|i>>>18&7,128|i>>>12&63,128|i>>>6&63,128|63&i));return n},ACD:function(e){var i,t=Array(e.length>>2);for(i=0;i<t.length;i++)t[i]=0;for(i=0;i<8*e.length;i+=8)t[i>>5]|=(255&e.charCodeAt(i/8))<<i%32;return t},AC6:function(e){for(var i="",t=0;t<32*e.length;t+=8)i+=String.fromCharCode(e[t>>5]>>>t%32&255);return i},ACV:function(e,i){function t(e,i,t,n,a,l){return r((o=r(r(i,e),r(n,l)))<<(s=a)|o>>>32-s,t);var o,s}function n(e,i,n,a,l,o,r){return t(i&n|~i&a,e,i,l,o,r)}function a(e,i,n,a,l,o,r){return t(i&a|n&~a,e,i,l,o,r)}function l(e,i,n,a,l,o,r){return t(i^n^a,e,i,l,o,r)}function o(e,i,n,a,l,o,r){return t(n^(i|~a),e,i,l,o,r)}function r(e,i){var t=(65535&e)+(65535&i);return(e>>16)+(i>>16)+(t>>16)<<16|65535&t}e[i>>5]|=128<<i%32,e[14+(i+64>>>9<<4)]=i;for(var s=1732584193,A=-271733879,C=-1732584194,c=271733878,u=0,p=e.length;u<p;u+=16){var Z=s,h=A,d=C,f=c;A=o(A=o(A=o(A=o(A=l(A=l(A=l(A=l(A=a(A=a(A=a(A=a(A=n(A=n(A=n(A=n(A,C=n(C,c=n(c,s=n(s,A,C,c,e[u],7,-680876936),A,C,e[u+1],12,-389564586),s,A,e[u+2],17,606105819),c,s,e[u+3],22,-1044525330),C=n(C,c=n(c,s=n(s,A,C,c,e[u+4],7,-176418897),A,C,e[u+5],12,1200080426),s,A,e[u+6],17,-1473231341),c,s,e[u+7],22,-45705983),C=n(C,c=n(c,s=n(s,A,C,c,e[u+8],7,1770035416),A,C,e[u+9],12,-1958414417),s,A,e[u+10],17,-42063),c,s,e[u+11],22,-1990404162),C=n(C,c=n(c,s=n(s,A,C,c,e[u+12],7,1804603682),A,C,e[u+13],12,-40341101),s,A,e[u+14],17,-1502002290),c,s,e[u+15],22,1236535329),C=a(C,c=a(c,s=a(s,A,C,c,e[u+1],5,-165796510),A,C,e[u+6],9,-1069501632),s,A,e[u+11],14,643717713),c,s,e[u],20,-373897302),C=a(C,c=a(c,s=a(s,A,C,c,e[u+5],5,-701558691),A,C,e[u+10],9,38016083),s,A,e[u+15],14,-660478335),c,s,e[u+4],20,-405537848),C=a(C,c=a(c,s=a(s,A,C,c,e[u+9],5,568446438),A,C,e[u+14],9,-1019803690),s,A,e[u+3],14,-187363961),c,s,e[u+8],20,1163531501),C=a(C,c=a(c,s=a(s,A,C,c,e[u+13],5,-1444681467),A,C,e[u+2],9,-51403784),s,A,e[u+7],14,1735328473),c,s,e[u+12],20,-1926607734),C=l(C,c=l(c,s=l(s,A,C,c,e[u+5],4,-378558),A,C,e[u+8],11,-2022574463),s,A,e[u+11],16,1839030562),c,s,e[u+14],23,-35309556),C=l(C,c=l(c,s=l(s,A,C,c,e[u+1],4,-1530992060),A,C,e[u+4],11,1272893353),s,A,e[u+7],16,-155497632),c,s,e[u+10],23,-1094730640),C=l(C,c=l(c,s=l(s,A,C,c,e[u+13],4,681279174),A,C,e[u],11,-358537222),s,A,e[u+3],16,-722521979),c,s,e[u+6],23,76029189),C=l(C,c=l(c,s=l(s,A,C,c,e[u+9],4,-640364487),A,C,e[u+12],11,-421815835),s,A,e[u+15],16,530742520),c,s,e[u+2],23,-995338651),C=o(C,c=o(c,s=o(s,A,C,c,e[u],6,-198630844),A,C,e[u+7],10,1126891415),s,A,e[u+14],15,-1416354905),c,s,e[u+5],21,-57434055),C=o(C,c=o(c,s=o(s,A,C,c,e[u+12],6,1700485571),A,C,e[u+3],10,-1894986606),s,A,e[u+10],15,-1051523),c,s,e[u+1],21,-2054922799),C=o(C,c=o(c,s=o(s,A,C,c,e[u+8],6,1873313359),A,C,e[u+15],10,-30611744),s,A,e[u+6],15,-1560198380),c,s,e[u+13],21,1309151649),C=o(C,c=o(c,s=o(s,A,C,c,e[u+4],6,-145523070),A,C,e[u+11],10,-1120210379),s,A,e[u+2],15,718787259),c,s,e[u+9],21,-343485551),s=r(s,Z),A=r(A,h),C=r(C,d),c=r(c,f)}return Array(s,A,C,c)}},"undefined"==typeof zingchart&&(zingchart={ADG:!0}),zingchart.clipart={},zingchart.widgets={},zingchart.plugins={},zingchart.pool={},zingchart.pool.size=0,zingchart.pool.data={},zingchart.pool.getInstance=function(e,i,t,n){var a;if(null!==ZC._n_(zingchart.pool.data[t]))(a=zingchart.pool.data[t])._POOL_=!0,ZC.SKIPOBJCOUNT=!0,n||(a.$i(i),a.K=t),ZC.SKIPOBJCOUNT=!1;else{switch(e){case"DN":a=new ZC.DN(i);break;case"HL":a=new ZC.HL(i);break;case"DT":a=new ZC.DT(i);break;case"P0":a=new ZC.P0(i);break;case"D0":a=new ZC.D0(i)}a.K=t,zingchart.pool.size++,zingchart.pool.size>zingchart.DEV.MAXPOOLSIZE?(zingchart.pool.data={},zingchart.pool.size=0):zingchart.pool.data[t]=a}return a},zingchart.i18n={},zingchart.THEMES={},zingchart.V3D=2,zingchart.QUOTEDVALUES=!1,zingchart.EDITSOURCE=1,zingchart.MODULESDEP={line:"xy",line3d:"3d,line",area:"xy",area3d:"3d,area",vline:"yx",varea:"yx",vbar:"xy",vbar3d:"3d,vbar",hbar:"yx",hbar3d:"3d,hbar",scatter:"xy",bubble:"xy",hscatter:"yx",hbubble:"yx",pie:"r",pie3d:"3d,pie",nestedpie:"r",gauge:"r",vbullet:"vbar",hbullet:"hbar",vfunnel:"xy",hfunnel:"yx",piano:"xy",radar:"r",range:"xy",vrange:"yx",stock:"xy,vbar",venn:"r"},zingchart.SKIP={EVENT:!1,ANIMATION:!1,LEGEND:!1,CSV:!1,PARSE3D:!1},zingchart.MODULESDIR=function(e){for(var i=0;i<e.length;i++){if(e[i].src)if(e[i].src.indexOf("zingchart.min.js")>-1)return e[i].src.split("zingchart.min.js")[0]+"modules/"}return"./modules/"}(document.getElementsByTagName("head")[0].childNodes),zingchart.DEV={DOMFRAGMENTS:1,SORTTOKENS:1,PLOTSTATS:1,RESOURCES:1,KEEPSOURCE:1,SPREADTYPE:0,SPREADFACTOR:10,IGNORESUBUNIT:0,DELAYEDTRACKERS:0,STACKINGLOGIC:-1,SMARTDATELABELS:0,GC:1,CACHECANVASTEXT:0,CHECKDECIMALS:0,CACHESELECTION:0,MEDIARULES:1,SKIPTRACKERS:0,PLOTSHLAYER:0,RESIZESPEED:250,DEBOUNCESPEED:250,LOCALSVGEXPORT:1,SKIPPROGRESS:0,SKIPCONTEXTMENU:0,COPYDATA:1,GUIDETIMEOUT:0,LOOKUPCSSTRANSFORM:0,MAPSONBOTTOM:0,MAXPOOLSIZE:1024,MINTRACKERDIFF:1.5},zingchart.CANVASTEXT=0,zingchart.ZINDEX=1,zingchart.CMZINDEX=9999,zingchart.FSZINDEX=9998,zingchart.FSID=null,zingchart.ZCOUTPUT=0,zingchart.ASYNC=0,zingchart.SORTTRACKERS=0,zingchart.TIMEOUT=0,zingchart.USERCSS={},zingchart.OBJECTMODE="normal",zingchart.SYNTAX="mixed",zingchart.THEME=null,zingchart.EXPORTURL=("file:"===document.location.protocol?"http:":document.location.protocol)+"//export.zingchart.com/",zingchart.AJAXEXPORT=!1,zingchart.TOUCHZOOM="normal",zingchart.DEFAULT={height:480,width:640},zingchart.FASTWIDTH=0,zingchart.FONTSIZE=11,zingchart.FONTFAMILY="Lucida Sans Unicode,Lucida Grande,Lucida Sans,Helvetica,Arial,sans-serif",ZC.mobile&&(zingchart.FONTFAMILY="Lucida Sans,Helvetica,Arial,sans-serif"),zingchart.loadModules=function(e,i){for(var t=(""+e).split(","),n=0,a=t.length;n<a;n++){var l=ZC.GV(t[n]);l=ZC.ALIAS[l]||l,-1!==ZC.AV(["bar","bar3d","funnel","bullet"],l)&&(l="v"+l);var o=zingchart.MODULESDEP[l];null!==ZC._n_(o)&&zingchart.loadModules(o),-1===ZC.AV(ZC.RO,l)&&ZC.RO.push(l)}i&&zingchart.A1E(null,ZC.RO,i)},zingchart.A1E=function(e,i,t){var n=0;if(0===i.length)t();else{if(!document.getElementsByTagName("head")[0])return void t();!function a(){var l,o=!0;function r(){++n===i.length?t():a()}zingchart.ACL(i[n])?l=zingchart.MODULESDIR+"zingchart-"+i[n]+".min.js":o=!1,o?ZC.AP.ACC(e,l,r):r()}()}},zingchart.ACL=function(e){return-1!==ZC.AV(ZC.RO,e)&&-1===ZC.AV(ZC.WG,e)},zingchart.LH=[],ZC.ie67||function(){for(var e in ZC.IMAGES)ZC.IMAGES.hasOwnProperty(e)&&(zingchart.LH[e]=new Image,zingchart.LH[e].src=ZC.IMAGES[e])}(),"undefined"!=typeof Ext&&(zingchart.LH["zc.blank"]=new Image,zingchart.LH["zc.blank"].src=ZC.BLANK),zingchart.exec=function(e,i,t){return zingchart.exec_flash?zingchart.exec_flash(e,i,t):null},zingchart.AD4=function(N){var QJ=N.dataurl||"",EV="",G,M9=null;null!==ZC._n_(G=N.data)&&("string"==typeof G?EV=G:M9=JSON.parse(JSON.stringify(G)));var DL=null;if(""!==QJ)ZC.A4.ajax({type:"GET",url:QJ,async:!1,data:zingchart.ZCOUTPUT?"zcoutput=userdef":"",error:function(){return!1},success:function(KC){function _f_(e){ZC.cache.data["data-"+QJ]=KC,N.output="auto",ZC._cp_(e.render,N)}try{DL=JSON.parse(KC),_f_(DL)}catch(J8){try{DL=eval("("+KC+")"),_f_(DL)}catch(J8){return!1}}}});else{if(""!==EV)try{DL=JSON.parse(EV)}catch(J8){return!1}else null!==M9&&(DL=M9);null===ZC._n_(N.output)&&(N.output="auto"),ZC._cp_(DL.render,N)}return zingchart.render(N)},zingchart.A01=null,zingchart.params={},zingchart.render=function(e,i){if(null===ZC._n_(i)&&(i=!1),i)return zingchart.AD4(e);null===ZC._n_(ZC.canvas)&&ZC.compat();var t=e.output||"auto";"html5"===t&&(t="auto"),ZC.mobile&&"auto"===t&&(t="svg");var n=!1;if("!"===t.substring(0,1)&&(n=!0,t=t.substring(1)),n||("auto"===t||"canvas"===t&&!ZC.canvas||"svg"===t&&!ZC.svg||"vml"===t&&!ZC.vml||"flash"===t&&!ZC.flash)&&(ZC.svg?t="svg":ZC.canvas?t="canvas":ZC.vml?t="vml":ZC.flash&&(t="flash")),"vml"===t&&null===ZC._n_(zingchart.A01)&&(zingchart.A01=!1),"flash"!==t)return zingchart.A91(e,t);zingchart.render_flash(e)},document.attachEvent&&("complete"===document.readyState?zingchart.A01=!0:document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&(zingchart.A01=!0)})),zingchart.setlabel=zingchart.setLabel=function(e,i){ZC.HJ[e]=i},zingchart.HZ=[],zingchart.Y1={},zingchart.ADF=0,zingchart.AD1=0,zingchart.ADD=!1,zingchart.AAB=!1,zingchart.AAA=!1,zingchart.ACX=!1,zingchart.css=null,zingchart.WX=function(e){if(e.target.id){for(var i=null,t=0,n=zingchart.HZ.length;t<n;t++)e.target.id.substr(0,zingchart.HZ[t].K.length+1)===zingchart.HZ[t].K+"-"&&(i=zingchart.HZ[t]);return i}},ZC.GESTURE={id:null,on:!1,ts:null,type:null,dist:-1,mp:[-1,-1]},"undefined"==typeof zingchart.MI&&(zingchart.MI=function(e){if(e.target&&e.target.tagName&&"INPUT"!==e.target.tagName.toUpperCase()&&"TEXTAREA"!==e.target.tagName.toUpperCase()){var i;if("pinch"===zingchart.TOUCHZOOM)switch(ZC.TOUCHEVENTS=!1,e.type){case"touchstart":for(var t=!1,n=0;n<zingchart.HZ.length;n++)i=ZC.A4("#"+zingchart.HZ[n].K+"-top"),ZC.DS(e.touches[0].pageX,i.offset().left,i.offset().left+i.width())&&ZC.DS(e.touches[0].pageY,i.offset().top,i.offset().top+i.height())&&(t=!0,ZC.GESTURE.id=zingchart.HZ[n].K);t&&(ZC.GESTURE.on=!0);break;case"touchmove":if(ZC.GESTURE.on&&2===e.touches.length){e.preventDefault();var a=(e.touches[0].clientX-e.touches[1].clientX)*(e.touches[0].clientX-e.touches[1].clientX)+(e.touches[0].clientY-e.touches[1].clientY)*(e.touches[0].clientY-e.touches[1].clientY);a=Math.round(Math.sqrt(a));var l=[Math.round((e.touches[0].clientX+e.touches[1].clientX)/2),Math.round((e.touches[0].clientY+e.touches[1].clientY)/2)];if(-1===ZC.GESTURE.dist)ZC.GESTURE.dist=a,ZC.GESTURE.mp=l,ZC.GESTURE.ts=(new Date).getTime();else if((new Date).getTime()-ZC.GESTURE.ts>100){if(a>ZC.GESTURE.dist+50)ZC.GESTURE.type="pinch-in",zingchart.exec(ZC.GESTURE.id,"zoomin");else if(a<ZC.GESTURE.dist-50)ZC.GESTURE.type="pinch-out",zingchart.exec(ZC.GESTURE.id,"zoomout");else{ZC.GESTURE.type="panning";var o={};l[0]>ZC.GESTURE.mp[0]+10?(o["x-"]=!0,o.xdist=ZC._a_(ZC.GESTURE.mp[0]-l[0])):l[0]<ZC.GESTURE.mp[0]-10&&(o["x+"]=!0,o.xdist=ZC._a_(ZC.GESTURE.mp[0]-l[0])),l[1]>ZC.GESTURE.mp[1]+10?(o["y+"]=!0,o.ydist=ZC._a_(ZC.GESTURE.mp[1]-l[1])):l[1]<ZC.GESTURE.mp[1]-10&&(o["y-"]=!0,o.ydist=ZC._a_(ZC.GESTURE.mp[1]-l[1])),ZC.GESTURE.mp=l,zingchart.exec(ZC.GESTURE.id,"pan",o)}ZC.GESTURE.ts=(new Date).getTime()}}break;case"touchend":ZC.GESTURE.id=null,ZC.GESTURE.on=!1,ZC.GESTURE.type=null,ZC.GESTURE.ts=null,ZC.GESTURE.dist=-1,ZC.GESTURE.mp=[-1,-1]}if(window.ZC){window.ZC.E1=[e.pageX,e.pageY];var r=zingchart.WX(e);if(r){if(!zingchart.SKIP.EVENT){if("mousedown"===e.type&&(window.ZC.aMDXY=[e.pageX,e.pageY]),"touchstart"===e.type&&r.AG)for(var s=0;s<r.AG.length;s++)r.AG[s].LD();if(-1!==ZC.AV(["mouseover","mouseout","mouseover"],e.type)&&"IMG"!==e.target.tagName.toUpperCase())return;if("mouseout"===e.type&&(i=ZC.A4("#"+r.K+"-top"),ZC.DS(e.pageX,i.offset().left,i.offset().left+i.width(),!0)&&ZC.DS(e.pageY,i.offset().top,i.offset().top+i.height(),!0)))return;ZC.AP.BY(e.type,r,zingchart.A0A(e,r))}zingchart.SKIP.EVENT=!1}}}},ZC.A4(document).bind(ZC.Q.BZ("mouseover"),zingchart.MI).bind(ZC.Q.BZ("mouseout"),zingchart.MI).bind(ZC.Q.BZ("mousemove"),zingchart.MI).bind(ZC.Q.BZ("mousedown"),zingchart.MI).bind(ZC.Q.BZ("mouseup"),zingchart.MI)),zingchart.A0A=function(e,i){var t=ZC.Q.MF(e),n=i.A4A(t[0],t[1]),a=ZC.A4("#"+i.K+"-top"),l=Math.round(t[0]-a.offset().left),o=Math.round(t[1]-a.offset().top),r="none";return/(.*)\-scale\_(.*)\-item\_title\-area(.*)/.test(e.target.id)&&(r="scale-title"),/(.*)\-scale\_(.*)\-item\_(\d+)\-area(.*)/.test(e.target.id)&&(r="scale-item"),/(.*)\-plotset\-plot\-(\d+)\-node\-(\d+)(.*)/.test(e.target.id)&&(r="node"),/(.*)\-legend\-item\_(\d+)\-area/.test(e.target.id)&&(r="legend-item"),/(.*)\-legend\-marker\_(\d+)\-area/.test(e.target.id)&&(r="legend-marker"),/(.*)\-legend\-(.+)\-area/.test(e.target.id)&&(r="legend-element"),/(.*)\-menu\-item\-(.*)/.test(e.target.id)&&(r="menu-item"),/(.*)\-preview\-handler\-x(.*)/.test(e.target.id)&&(r="preview"),/(.*)\-shape\-(.*?)\-area/.test(e.target.id)&&(r="shape"),/(.*)\-label\-(.*?)\-area/.test(e.target.id)&&(r="label"),{id:i.K,ev:ZC.A4.BZ(e),targetid:e.target.id,graphid:n?n.K:null,target:r,x:l,y:o,plotarea:!!n&&(l>=n.P.iX&&l<=n.P.iX+n.P.I&&o>=n.P.iY&&o<=n.P.iY+n.P.F),touch:ZC.mobile}},"undefined"==typeof zingchart.S8&&(zingchart.S8=function(e){for(var i=0,t=zingchart.HZ.length;i<t;i++)zingchart.HZ[i].hideCM();if(ZC.mobile&&ZC.move)ZC.move=!1;else if(ZC.mobile||!(e.which>1)){var n=zingchart.WX(e);if(n){if("click"===e.type&&ZC.aMDXY&&(ZC._a_(ZC.aMDXY[0]-e.pageX)>2||ZC._a_(ZC.aMDXY[1]-e.pageY)>2))return;if(!zingchart.SKIP.EVENT){var a=zingchart.A0A(e,n);a.target=zingchart.plugins.CLICK_TARGET||a.target,zingchart.plugins.CLICK_TARGET=null,ZC.mobile&&"touchend"===e.type&&(n.E["click-ts"]&&(new Date).getTime()-n.E["click-ts"]<500&&ZC.AP.BY("dblclick",n,a),n.E["click-ts"]=(new Date).getTime()),ZC.AP.BY("dblclick"===e.type?"dblclick":"click",n,a)}zingchart.SKIP.EVENT=!1,e.target.id!==n.K+"-menu-area"?n.hideCM():zingchart.YS(e)}}},ZC.mobile?(ZC.A4(document).bind("touchmove",function(){ZC.move=!0}),ZC.A4(document).bind("touchend",function(){ZC.move=!1})):(ZC.A4(document).bind("click",zingchart.S8),ZC.A4(document).bind("dblclick",zingchart.S8))),"undefined"==typeof zingchart.A2S&&(zingchart.A2S=function(e){e.touches.length>0&&(ZC.TOUCHEVENTS=!0)},ZC.A4(document).bind("touchstart",zingchart.A2S)),"undefined"==typeof zingchart.YS&&(zingchart.YS=function(e,i,t){if(!(e&&e.target&&e.target.tagName&&"IMG"!==e.target.tagName.toUpperCase()&&"AREA"!==e.target.tagName.toUpperCase()&&-1===ZC.Q.T4(e.target).indexOf("zc-scroll")&&-1===e.target.id.indexOf("-legend-")&&-1===e.target.id.indexOf("-preview-"))||zingchart.DEV.SKIPTRACKERS){var n,a,l,o,r,s;t=t||{};var A=null===ZC._n_(i)?zingchart.WX(e):zingchart.getLoader(i);if(A){if(-1!==ZC.AV(A.KQ,"skip_context_menu"))return!1;if(null===ZC._n_(i)?(a=ZC.Q.MF(e),n=A.A4A(a[0],a[1])):n=null!==ZC._n_(t.graphid)?A.OS(t.graphid):A.AG[0],!n)return!1;var C=ZC.A4("#"+A.K+"-top");null===ZC._n_(i)?(l=a[0]-C.offset().left,o=a[1]-C.offset().top):(l=A.I/2,o=A.F/2);var c={};e&&(c=zingchart.A0A(e,A));var u=ZC.AP.BY("contextmenu",A,c,!0);if(!u&&void 0!==u&&(!e&&!t["from-api"]||e&&e.target.id!==A.K+"-menu-area"))return e.preventDefault(),!1;var p=ZC._tx_(A.K);A.A5W(n?n.L:-1,e);var Z=-1;if(0!==zingchart.CMZINDEX)Z=zingchart.CMZINDEX;else for(var h=ZC.AL(A.K);-1===Z&&null!==h.parentNode;)"auto"!==(Z=ZC._i_(ZC.A4(h).css("zIndex")))&&""!==Z&&null!==ZC._n_(Z)||(Z=-1),h=h.parentNode;Z&&-1!==Z&&null!==ZC._n_(Z)||(Z=1);var d=ZC.A4("#"+A.K+"-menu");if(d.css("zIndex",zingchart.ZINDEX+Z+1),null===ZC._n_(i)){if(e.target.id===A.K+"-print-png"||e.target.id===A.K+"-print-jpeg")return!0;e.preventDefault()}if(!ZC.AL(A.K+"-menu"))return!1;l=C.offset().left,o=C.offset().top;var f=C.width(),_=C.height();null===ZC._n_(i)?(r=(a=ZC.Q.MF(e))[0]||ZC.E1[0],s=a[1]||ZC.E1[1]):(r=l+A.I/2,s=o+5);var g=!1;if(A.VK("goback",!1),A.NU>0&&(A.VK("goback",!0),g=!0),A.VK("goforward",!1),A.NU<A.QM.length-1&&(A.VK("goforward",!0),g=!0),A.VK("history",g,!0),r>=l&&r<=l+f*p[0]&&s>=o&&s<=o+_*p[1]){ZC.A4(".zc-menu").each(function(){this.id!==A.K+"-menu"&&A.hideCM()}),A.SQ=[r,s,null===ZC._n_(i)?e.target.id:i],d.css("opacity",0).show();var v,b,B=ZC._i_(d.css("width"))+ZC._i_(d.css("paddingLeft"))+ZC._i_(d.css("paddingRight")),m=ZC._i_(d.css("height"))+ZC._i_(d.css("paddingTop"))+ZC._i_(d.css("paddingBottom")),E=1,D=!1;if(A.o.gui&&A.o.gui["context-menu"]&&A.o.gui["context-menu"]&&(E=A.o.gui["context-menu"].alpha?A.o.gui["context-menu"].alpha:1,D=A.o.gui["context-menu"].docked),d.css("opacity",E).hide(),"classic"!==A.LI&&D){if(D){var F=A.B8.NV[A.LI].root.gui["context-menu"];ZC._cp_(A.o.gui["context-menu"],F),v="left"!==A.o.gui["context-menu"].position&&ZC._n_(A.o.gui["context-menu"].position)?C.offset().left+C.width()-B:C.offset().left}b=C.offset().top,d.css("left",ZC.BQ(1,v)+"px").css("top",ZC.BQ(1,b)+"px").css("height",C.height()+"px").css("box-sizing","border-box").show(),d=ZC.A4("#"+A.K+"-menu"),D&&d.P2[0].scrollHeight>C.height()&&d.css("overflow-y","scroll")}else{if(null===ZC._n_(i)&&e.target.id===A.K+"-menu-area"){ZC.AL(A.K+"-menu").style.paddingTop=0;var K=ZC.A4("#"+A.K+"-menu-area").attr("coords").split(","),x=ZC._i_(K[3])-ZC._i_(K[1]);ZC.AL(A.K+"-menu").style.backgroundPosition=ZC._i_(K[0])>A.I/2?"100% 0% !important":"0% 0% !important",v=l+(ZC._i_(K[0])>A.I/2?ZC._i_(K[2])-B:ZC._i_(K[0])),b=o+(ZC._i_(K[1])>A.F/1.25?ZC._i_(K[3])-m-x:ZC._i_(K[3]))}else ZC.AL(A.K+"-menu").style.backgroundPosition="50% 0% !important",v=A.SQ[0]-B/2,b=A.SQ[1],m>A.F*p[1]?b=o:b-o+m>A.F*p[1]&&(b=ZC.BQ(b-m,A.F*p[1]-m)),v<l&&(v=ZC.BQ(v,l)),v+B>l+A.I*p[0]&&(v=ZC.CY(l+A.I*p[0]-B/2,v-B/2));if(t.position)switch(t.position){case"top":break;case"top-left":v=v-(A.I*p[0]-B)/2+5;break;case"top-right":v=v+(A.I*p[0]-B)/2-5;break;case"bottom":b=b+(A.F*p[1]-m)-10;break;case"bottom-left":b=b+(A.F*p[1]-m)-10,v=v-(A.I*p[0]-B)/2+5;break;case"bottom-right":b=b+(A.F*p[1]-m)-10,v=v+(A.I*p[0]-B)/2-5;break;case"left":b=b+(A.F*p[1]-m)/2-5,v=v-(A.I*p[0]-B)/2+5;break;case"right":b=b+(A.F*p[1]-m)/2-5,v=v+(A.I*p[1]-B)/2-5}else null!==ZC._n_(t.x)&&null!==ZC._n_(t.y)&&(v=l+ZC._i_(t.x),b=o+ZC._i_(t.y));if(d.css("left",ZC.BQ(1,v)+"px").css("top",ZC.BQ(1,b)+"px").show(),ZC.ie67){var I=ZC.A4("#"+A.K+"-menu div").width()[0]||120;d.css("width",I+"px")}}return A.AA9=!0,!1}}}},ZC.A4(document).bind("contextmenu",zingchart.YS)),zingchart.AAG=function(e,i){if(zingchart.css)return zingchart.css.addRule?zingchart.css.addRule(e,i):zingchart.css.insertRule(e+"{"+i+"}",0)},zingchart.wh=function(e,i,t){"auto"===i&&(i="100%"),"auto"===t&&(t="100%");var n=[0,0];return-1===(""+i).indexOf("%")&&-1===(""+t).indexOf("%")||(n=e.wh()),[-1!==(""+i).indexOf("%")?n[0]*parseInt(i,10)/100:parseInt(i,10),-1!==(""+t).indexOf("%")?n[1]*parseInt(t,10)/100:parseInt(t,10)]},zingchart.IY={},zingchart.bind=function(e,i,t){e=e||"zingchart-global",zingchart.IY[e]||(zingchart.IY[e]={}),zingchart.IY[e][i]?zingchart.IY[e][i].push({fn:t}):zingchart.IY[e][i]=[{fn:t}]},zingchart.unbind=function(e,i,t){if(e=e||"zingchart-global",zingchart.IY[e]&&zingchart.IY[e][i])if(t){for(var n=0,a=zingchart.IY[e][i].length;n<a;n++)if(zingchart.IY[e][i][n].fn===t){zingchart.IY[e][i].splice(n,1);break}}else zingchart.IY[e][i]=null},zingchart.callEvent=function(e,i,t,n){if(e=e||"zingchart-global",zingchart.IY[e]&&zingchart.IY[e][i]){for(var a=0,l=zingchart.IY[e][i].length;a<l;a++)null!==ZC._n_(n)?t[t.length-1]=zingchart.IY[e][i][a].fn.apply(zingchart,t):zingchart.IY[e][i][a].fn.apply(zingchart,t);if(null!==ZC._n_(n))return t[t.length-1]}},zingchart.hasEvent=function(e,i){return e=e||"zingchart-global",zingchart.IY[e]&&zingchart.IY[e][i]},zingchart.A91=function(e,i){ZC._todash_(e,!1);var t,n,a,l,o,r,s,A,C=[];if(null!==ZC._n_(t=e.flags)&&(C=t.split(",")),null!==ZC._n_(t=e.mode))switch(t){case"static":C=["skip_context_menu","skip_segment_tracking","skip_marker_tracking","skip_interactivity","use_single_canvas"]}var c="";if(null!==ZC._n_(t=e.container)&&(c=t),null!==ZC._n_(t=e.id)&&(c=t),ZC.AL(c)){var u=null;for(a=0;a<zingchart.HZ.length;a++)zingchart.HZ[a].K===c&&(u=zingchart.HZ[a].ME);if(null!==ZC._n_(u)){if(""!==u)return;zingchart.exec(c,"destroy")}zingchart.params[c]={},ZC._cp_(e,zingchart.params[c]);var p=!1,Z=null;for(a=0;a<zingchart.HZ.length;a++)zingchart.HZ[a].K===c&&(zingchart.HZ[a]=new ZC.Q5,Z=zingchart.HZ[a],p=!0);if(p||((Z=new ZC.Q5).ME="init",zingchart.HZ.push(Z)),Z.K=c,zingchart.Y1[c]=!0,"vml"!==i||zingchart.A01||zingchart.A91(e,i),!zingchart.AAA){zingchart.AAA=!0;var h={".zc-style":"font-family:"+zingchart.FONTFAMILY+";font-size:"+zingchart.FONTSIZE+"px;font-weight:normal;font-style:normal;text-decoration:none;text-shadow:none;",".zc-style *":"font-family:"+zingchart.FONTFAMILY+";font-size:"+zingchart.FONTSIZE+"px;font-weight:normal;font-style:normal;text-decoration:none;text-shadow:none;",".zc-top *":"text-align:left;margin:auto;text-shadow:none;",".zc-menu *":"text-align:left;margin:auto;",".zc-main text":"-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;",".zc-img":"-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",".zc-map":"-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",".zc-pixmap":"-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",".zc-preview-mask":"cursor:default;-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",".zc-about":"position:absolute;overflow:hidden;border:5px solid #fff;background:#003C4F url("+(ZC.ie67?"//":ZC.LOGO_ABOUT)+") no-repeat center 10px",".zc-about-1":"padding:80px 5px 5px 5px;text-align:center !important;",".zc-about-1 a":"color:#1AB6E3;font-size:17px;line-height:125%;",".zc-about-2":"padding:5px;color:#fff;text-align:center !important;",".zc-about-3":"padding:5px;text-align:center;line-height:125%;",".zc-about-3 div":"background-color:#1AB6E3;line-height:125%;color:#fff;border:1px solid #fff;padding:5px 10px;font-weight:bold;width:60px;margin:0 auto;cursor:pointer;text-align:center",".zc-about-4":"color:#fff;line-height:125%;",".zc-about-4 div":"float:right;color:#fff;line-height:125%;",".zc-viewsource":"border:5px solid #fff;background:#999",".zc-error":"border:5px solid #fff;background:#900",".zc-bugreport":"border:5px solid #fff;background:#999",".zc-form-row-label":"padding:4px 10px 2px;text-align:left;color:#fff",".zc-form-row-element":"padding:2px 8px",".zc-form-row-last":"padding:8px 8px 2px !important",".zc-form-row-element textarea":"text-align:left;background:#fff;color:#000;border:1px solid #333;",".zc-form-row-label input":"color:#000;padding:2px;margin:0 5px 0 0;background-color:#999;",".zc-form-row-element input":"color:#000;padding:2px;margin:0;background-color:#fff",".zc-form-row-last input":"padding:4px 10px !important;margin:0 20px 0 0 !important;background-color:#eee !important;border:2px outset #ccc !important",".zc-form-s0":"font-size:27px !important;letter-spacing:-1px;line-height:125%",".zc-form-s1":"font-size:17px !important;line-height:125%",".zc-form-s1 a":"color:#fff;padding:3px 10px;position:relative;top:4px;border:1px solid #333;border-bottom:0px solid #333",".zc-tab-active":"background-color:#fff;color:#333 !important",".zc-tab-inactive":"background-color:#999;color:#ddd !important",".zc-bugreport label":"display:inline-block;position:relative;top:-2px",".zc-viewimage div":"position:absolute;text-align:center;padding:5px;background:#999;color:#fff",".zc-license-ie67":"padding:0;position:absolute;font-size:12px;font-weight:bold;font-family:"+zingchart.FONTFAMILY+";color:#369;text-align:left",".zc-license":"padding:0;position:absolute;","#zc-fullscreen":"display:block;position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;background:#fff;",".zc-menu":"position:absolute;display:none;background-repeat:no-repeat !important;background-position:50% 0% !important;",".zc-menu-sep":"font-size:1px;padding:0;line-height:1px;border-bottom:1px solid #000",".zc-menu-item":"cursor:pointer;white-space:nowrap",".zc-blocker":"background:#eee",".zc-blocker div.zc-blocker-msg":"position:absolute;border:2px solid #ccc;padding:10px 30px;background-color:#333;color:#fff",".zc-modal":"background-color:#fff;color:#000;border:2px solid #999",".zc-guide-label-table":"border-collapse:collapse",".zc-guide-label-table td":"padding:4px 10px 2px 2px",".zc-data-table":"border-collapse:collapse",".zc-data-table caption":"font-family:"+zingchart.FONTFAMILY+";text-align:left;font-size:17px;font-weight:600;padding:6px 14px 6px 4px;background-color:#ccc;border-bottom:2px solid #666",".zc-data-table th":"font-family:"+zingchart.FONTFAMILY+";text-align:left;font-size:13px;font-weight:600;padding:2px 14px 2px 4px;background-color:#ddd;border-bottom:1px solid #666",".zc-data-table td":"font-family:"+zingchart.FONTFAMILY+";text-align:left;font-size:11px;padding:1px 14px 1px 4px;background-color:#ffffff;border-bottom:1px solid #eee;white-space:nowrap",".zc-rel":"top:0;left:0;position:relative",".zc-abs":"top:0;left:0;position:absolute"};ZC.ie678||(h[".zc-data-table th:not(:last-child)"]="border-right:1px dotted #666",h[".zc-data-table td:not(:last-child)"]="border-right:1px solid #eee");var d=document.getElementsByTagName("head")[0],f=document.createElement("style");if(f.type="text/css",f.setAttribute("data-author","zingchart"),d.appendChild(f),!zingchart.css)for(a=0,l=document.styleSheets.length;a<l;a++)document.styleSheets[a].ownerNode&&"zingchart"===document.styleSheets[a].ownerNode.getAttribute("data-author")&&(zingchart.css=document.styleSheets[a]);for(var _ in zingchart.css||(zingchart.css=document.styleSheets[document.styleSheets.length-1]),h)null!==ZC._n_(zingchart.USERCSS[_])?zingchart.AAG(_,zingchart.USERCSS[_]):zingchart.AAG(_,h[_])}if("vml"===i&&!zingchart.AAB)document.namespaces.add("zcv","urn:schemas-microsoft-com:vml"),document.createStyleSheet().cssText=".zcvml { behavior:url(#default#VML); }",zingchart.AAB=!0;var g="";zingchart.THEME&&(g=zingchart.THEME),e.data&&null!==ZC._n_(t=e.data.theme)&&(g=t),null!==ZC._n_(t=e.theme)&&(g=t);var v={data:!1,defaults:!1,css:!1,csv:!1};if(null!==ZC._n_(t=e.cache))for(var b in v)null!==ZC._n_(n=t[b])&&(v[b]=ZC._b_(n));var B=!1;null!==ZC._n_(t=e.fullscreen)&&(B=ZC._b_(t));var m=!0;null!==ZC._n_(t=e["auto-resize"])&&(m=ZC._b_(t));var E=ZC.A4("#"+c);o=(e.width||"100%")+"",r=(e.height||""+zingchart.DEFAULT.height)+"","auto"===o&&(o="100%"),"auto"===r&&(r="100%");var D=zingchart.wh(E,o,r);s=D[0],A=D[1],B&&(s=ZC.A4(window).width(),A=ZC.A4(window).height(),document.body.style.overflow="hidden"),s<10&&(s=zingchart.DEFAULT.width),A<10&&(A=zingchart.DEFAULT.height),s=0===s?zingchart.DEFAULT.width:s,A=0===A?zingchart.DEFAULT.height:A;var F=e.dataurl||"",K=e.defaultsurl||"",x=null,I="",y=null;null!==ZC._n_(t=e.data)&&("string"==typeof t?I=t:y=zingchart.DEV.COPYDATA?JSON.parse(JSON.stringify(t)):t),null!==ZC._n_(t=e.defaults)&&("string"==typeof t&&(t=JSON.parse(t)),x=t),null!==ZC._n_(t=e.imggen)&&(Z.A19=ZC._b_(t)),Z.A19&&(Z.G1=null),Z.JN=o+"/"+r,Z.AB=i,Z.A=Z,Z.iX=0,Z.iY=0,Z.I=s,Z.F=A,Z.FY=o,Z.MT=r,Z.QJ=F,Z.EV=I,Z.M9=y,Z.QQ=K,Z.MP=x,Z.UC=!1,null!==ZC._n_(e.fullscreenmode)&&ZC._b_(e.fullscreenmode)&&(Z.QU=!0),Z.LR=B,Z.RV=v,Z.KQ=C,Z.LI=g,Z.H=Z,Z.E.hideprogresslogo=!1,null!==ZC._n_(t=e.hideprogresslogo)&&(Z.E.hideprogresslogo=ZC._b_(t)),null!==ZC._n_(t=e.customprogresslogo)&&(Z.E.customprogresslogo=t),null!==ZC._n_(t=e.customprogresstext)&&(Z.E.customprogresstext=t),null!==ZC._n_(t=e.exportdataurl)&&(Z.E.exportdataurl=t),null!==ZC._n_(t=e.exportimageurl)&&(Z.E.exportimageurl=t);var w={};for(var L in null!==ZC._n_(t=e.bgcolor)&&(w["background-color"]=t),null!==ZC._n_(t=e["background-color"])&&(w["background-color"]=t),null!==ZC._n_(t=e["border-color"])&&(w["border-color"]=t),null!==ZC._n_(t=e["border-width"])&&(w["border-width"]=t),null!==ZC._n_(t=e.color)&&(w.color=t),Z.E.progress=w,null!==ZC._n_(t=e["auto-load-modules"])&&(Z.A6J=ZC._b_(t)),null!==ZC._n_(t=e.events)&&(Z.A18=t),null!==ZC._n_(t=e.modules)&&(Z.A1A=t),null!==ZC._n_(t=e.format)&&(Z.CI=t),null!==ZC._n_(t=e.csvdata)&&(Z.O0=t),null!==ZC._n_(t=e.locale)&&null!==ZC._n_(zingchart.i18n[t])&&(Z.A14=t,ZC.HJ=zingchart.i18n[t]),null!==ZC._n_(t=e["cache-control"])&&(Z.N6=t),null!==ZC._n_(t=e.accessibility)&&(Z.bA11y=ZC._b_(t)),null!==ZC._n_(t=e.description)&&(Z.OZ=t+""),zingchart.params)if(!zingchart.Y1[L])for(var X in delete zingchart.params[L],delete ZC.TS[L],zingchart.pool.data)0===X.indexOf(L+"-")&&(delete zingchart.pool.data[X],zingchart.pool.size--);if(Z.render(),E.css("overflow","hidden"),Z.LR&&E.css("position","absolute").css("top",0).css("left",0),(-1!==Z.FY.indexOf("%")||-1!==Z.MT.indexOf("%")||Z.LR||Z.QU)&&m){var Y=Z.QU||Z.LR?ZC.A4(window):E,M=Y.width(),H=Y.height(),P=0;Z.A0P=!1,Z.YV=window.setInterval(function(){var e;if(ZC.AL(c)&&!Z.A2H){var i=ZC.A4("#"+c+"-top"),t=!1;if(-1!==(""+Z.FY).indexOf("%")&&i.length&&Y.length&&i.width()!==Y.width()&&(t=!0),0!==P||Y.width()===M&&Y.height()===H&&!t){if(Y.width()+Y.height()>0&&(Y.width()!==M||Y.height()!==H)&&(e=Z.LR||Z.QU?zingchart.wh(Y,""+Y.width(),""+Y.height()):zingchart.wh(Y,Z.FY,Z.MT))[0]>10&&e[1]>10){for(Z.I=ZC._i_(e[0]),Z.F=ZC._i_(e[1]),M=Y.width(),H=Y.height(),a=0,l=Z.AG.length;a<l;a++)Z.AG[a].MD[0]=0;S()}}else if(M=Y.width(),H=Y.height(),M>10&&H>10){for(-1!==(""+Z.FY).indexOf("%")?Z.I=ZC._i_(M*ZC.II(Z.FY)):Z.I=ZC._i_(M),-1!==(""+Z.MT).indexOf("%")?Z.F=ZC._i_(H*ZC.II(Z.MT)):Z.F=ZC._i_(H),a=0,l=Z.AG.length;a<l;a++)Z.AG[a].MD[0]=0;S()}P++}else window.clearInterval(Z.YV)},zingchart.DEV.RESIZESPEED)}return Z}function N(){if(!Z.E.wh||Z.E.wh!==Z.I+"/"+Z.F){for(var e=!1,i=0;i<zingchart.HZ.length;i++)zingchart.HZ[i].K===Z.K&&(e=!0);e&&Z.resize()}Z.A0P=!1}function S(){Z.A0P?Z.VA.width!==Z.I&&(clearTimeout(Z.A64),Z.VA.width=Z.I,Z.VA.height=Z.F,Z.A64=setTimeout(N,zingchart.DEV.DEBOUNCESPEED)):(Z.A0P=!0,Z.VA={width:Z.I,height:Z.F},Z.A64=setTimeout(N,zingchart.DEV.DEBOUNCESPEED))}},window.zingchart=zingchart,ZC.A4.browser.msie&&parseFloat(ZC.A4.browser.version)<9){var _window_onunload_=window.onunload;window.onunload=function(){for(;zingchart.HZ.length;)zingchart.exec(zingchart.HZ[0].K,"destroy");ZC.A4(document).unbind(ZC.Q.BZ("mouseover"),zingchart.MI).unbind(ZC.Q.BZ("mouseout"),zingchart.MI).unbind(ZC.Q.BZ("mousemove"),zingchart.MI).unbind(ZC.Q.BZ("mousedown"),zingchart.MI).unbind(ZC.Q.BZ("mouseup"),zingchart.MI).unbind("click",zingchart.S8).unbind("contextmenu",zingchart.YS),zingchart.HZ=[],_window_onunload_&&_window_onunload_()}}zingchart.i18n.en_us={rtl:!1,"decimals-separator":".","thousands-separator":"","menu-enablepagescroll":"Enable Page Scroll","menu-disablepagescroll":"Disable Page Scroll","menu-reload":"Reload","menu-print":"Print Chart","menu-viewaspng":"View As PNG","menu-viewasjpg":"View As JPG","menu-downloadpdf":"Download PDF","menu-downloadsvg":"Download SVG","menu-downloadcsv":"Download CSV","menu-downloadxls":"Download XLS","menu-viewdatatable":"View Data Table","menu-hidedatatable":"Hide Data Table","menu-exportdata":"Export Data","menu-zoomin":"Zoom In","menu-zoomout":"Zoom Out","menu-viewall":"View All","menu-viewsource":"View Source","menu-bugreport":"Submit Bug","menu-switchto2d":"Switch To 2D","menu-switchto3d":"Switch To 3D","menu-showguide":"Show Guide","menu-hideguide":"Hide Guide","menu-switchtolin":"Show Linear Scale","menu-switchtolog":"Show Log Scale","menu-fullscreen":"Full Screen","menu-exitfullscreen":"Exit Full Screen","menu-goback":"Go Back","menu-goforward":"Go Forward","date-formats":{msecond:"%d %M %Y<br>%g:%i:%s %A<br>%q ms",second:"%d %M %Y<br>%g:%i:%s %A",minute:"%d %M %Y<br>%g:%i %A",hour:"%d %M %Y<br>%g %A",day:"%d %M %Y",month:"%M %Y",year:"%Y"},"days-short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"days-long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"months-short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"months-long":["January","February","March","April","May","June","July","August","September","October","November","December"],"sync-wait":"Wait...","export-wait":"Exporting...","progress-wait-long":"Wait. Loading...","progress-wait-short":"Wait...","progress-wait-mini":"...","error-header":"An Error Has Occured","error-message":"Error Message:","error-close":"Close","bugreport-header":"Submit Bug Report","bugreport-senddata":"Send JSON Data","bugreport-sendcapture":"Send Graph Capture","bugreport-yourcomment":"Your Comment:","bugreport-jsondata":"JSON Data:","bugreport-youremail":"Your Email Address","bugreport-infoemail":"if you want to receive via email our reply to your problem","bugreport-emailmandatory":"Email address is mandatory...","bugreport-submit":"Submit","bugreport-cancel":"Cancel","bugreport-confirm":"Your bug report was sent.\n\nThank you!","about-close":"Close","viewsource-jsonsource":"Parsed JSON","viewsource-originalsource":"Original JSON","viewsource-close":"Close","viewsource-apply":"Apply","viewimage-close":"Close","legend-pagination":"Page %page% of %pages%"},ZC.HJ=zingchart.i18n.en_us,zingchart.getLoader=function(e){for(var i=0;i<zingchart.HZ.length;i++)if(zingchart.HZ[i].K===e)return zingchart.HZ[i];return null},zingchart.getGraph=function(e,i){return e.OS(i)},zingchart.clearLayer=function(e){e.A7&&e.A7.onmouseout();for(var i=0;i<e.AG.length;i++)e.AG[i].LD()},zingchart.getGraphInfo=function(e,i,t){return e.A4O(i,t)},zingchart.initThemes=function(e){e&&e.AA4(!0)},zingchart.setModule=function(e){ZC.WG.push(e)},zingchart.getModules=function(e){return e.A1A.split(",")},zingchart.defineModule=function(e,i,t){switch(zingchart.setModule(e),i){case"chart":zingchart.bind(null,"dataparse",function(i,n){for(var a=n.graphset.length,l=0;l<a;l++)if(n.graphset[l].type===e){var o=n.graphset[l];o.id?o.id=o.id:o.id=e.replace(/-/g,"")+l,n.graphset[l]=t(o)}return n});break;case"plugin":zingchart.bind(null,"dataparse",function(i,n){var a=zingchart.getLoader(i.id);if(-1!==zingchart.getModules(a).indexOf(e))for(var l=n.graphset.length,o=null,r=0;r<l;r++)(o=n.graphset[r]).hasOwnProperty(e)&&(n.graphset[r]=t(o,i.id));return n})}},zingchart.getPalette=function(e,i,t){return t=t||"bar",e.B8.A9Z(i,t)},zingchart.getObject=function(e,i,t){var n,a;switch(t=t||"label"){case"shape":for(n=0,a=e.FH.length;n<a;n++)if(e.FH[n].H5===i||n===i)return e.FH[n].BF;break;case"label":for(n=0,a=e.BX.length;n<a;n++)if(e.BX[n].H5===i||n===i)return e.BX[n]}return null},zingchart.getInstance=function(e,i){switch(i){case"style":return new ZC.D0(e);case"shape":return new ZC.DT(e);case"box":return new ZC.HL(e);case"textbox":return new ZC.DN(e)}return null},zingchart.normalize=function(e){ZC._todash_(e)},zingchart.copy=function(e,i){ZC._cp_(e,i)},zingchart.formatDate=function(e,i,t,n){return ZC.AP.Y5(e,i,t,n)},zingchart.formatNumber=function(e,i){return ZC.AP.G2(e,i)},zingchart.fireEvent=function(e,i,t){ZC.AP.BY(e,i,t)},zingchart.A95=[],zingchart.extendAPI=function(e,i){zingchart.A95.push({call:e,api:i})},zingchart.exec=function(e,i,t){return zingchart.getLoader(e)?zingchart.ACY(e,i,t):zingchart.exec_flash?zingchart.exec_flash(e,i,t):void 0},zingchart.ACY=function(e,i,t){var n,a,l;t=t||{},document.getElementById("zc-fullscreen")&&!t.skipfs&&(e="zc-fullscreen"),"string"==typeof t&&(t=JSON.parse(t));var o,r,s,A,C,c=zingchart.getLoader(e);if(null!==ZC._n_(t.preservezoom)&&(c.E.preservezoom=ZC._b_(t.preservezoom)),c)switch(i){case"goback":c.IC&&c.NU>0&&(ZC.AP.BY("history_back",c,c.FG()),c.NU--,zingchart.exec(c.K,"setdata",{data:c.QM[c.NU]}));break;case"goforward":c.IC&&c.NU<c.QM.length-1&&(ZC.AP.BY("history_forward",c,c.FG()),c.NU++,zingchart.exec(c.K,"setdata",{data:c.QM[c.NU]}));break;case"setmode":if("undefined"==typeof c.E["mode-flags"]&&(c.E["mode-flags"]=c.KQ.join(",")),""===t.mode&&"undefined"!=typeof c.E["mode-flags"])c.KQ=c.E["mode-flags"].split(",");else{c.KQ=[];var u=(""+t.mode).split(",");-1!==ZC.AV(u,"static")&&c.KQ.push("skip_context_menu","skip_objects_tracking","skip_segment_tracking","skip_marker_tracking","skip_interactivity")}break;case"showmenu":ZC.E1[0]=ZC._n_(t.x)?t.x:ZC.E1[0],ZC.E1[1]=ZC._n_(t.y)?t.y:ZC.E1[1],t["from-api"]=!0,zingchart.YS(null,c.K,t);break;case"hidemenu":c.hideCM();break;case"destroy":case"zcdestroy":for(ZC.AP.BY("beforedestroy",c,{id:e,loader:c}),delete zingchart.Y1[e],a=0,l=c.AG.length;a<l;a++)c.AG[a].MD[0]=0,c.AG[a].B9&&(c.AG[a].B9.IM=!1,c.AG[a].unbind(!1,!0)),c.H1&&(c.H1.IM=!1);for(var p in ZC.move=!1,c.A0C(),c.A99(t,!0),zingchart.DEV.GC&&c.gc(),c.YV&&window.clearInterval(c.YV),c.Z3&&window.clearInterval(c.Z3),zingchart.IY[e]&&delete zingchart.IY[e],ZC.Q.EU([e+"-wrapper",e+"-top",e+"-text-ruler",e+"-dummy",e+"-progress"]),c.A1K||delete zingchart.params[e],delete ZC.TS[e],delete ZC.cache.data["svg-rect"],zingchart.pool.data)0===p.indexOf(e+"-")&&(delete zingchart.pool.data[p],zingchart.pool.size--);var Z=ZC.AV(zingchart.HZ,c);-1!==Z&&zingchart.HZ.splice(Z,1),zingchart.HZ.length||(zingchart.GUIDE_EV=null,delete zingchart.LH["zc.logo"]),c=null,ZC.AP.BY("destroy",null,{id:e});break;case"getrender":return c.AB;case"clear":c.A99(t);break;case"reload":c.A8S(t);break;case"load":c.ACZ(t);break;case"enable":c.A42();break;case"disable":c.A7X(t.text);break;case"closemodal":ZC.Q.EU([c.K+"-modal",c.K+"-blocker"]);break;case"openmodal":if(!ZC.AL(c.K+"-modal"))return ZC.Q.HY({cls:"zc-abs zc-style zc-blocker",id:c.K+"-blocker",p:ZC.AL(c.K+"-top"),wh:c.I+"/"+c.F,opacity:.75}),ZC.Q.HY({cls:"zc-abs zc-style zc-modal",id:c.K+"-modal",p:ZC.AL(c.K+"-top"),tl:(c.F-t.height)/2+"/"+(c.I-t.width)/2,wh:t.width+"/"+t.height,opacity:1}),ZC.AL(c.K+"-modal");break;case"mapdata":c.AC5(t);break;case"print":c.A9B();break;case"fullscreen":c.A5S();break;case"exitfullscreen":zingchart.exec("zc-fullscreen","destroy"),ZC.Q.EU("zc-fullscreen");break;case"resize":c.A2H=!0;var h=c.I,d=c.F,f=c.JN.split("/"),_=!1,g=f[0],v=f[1];null!==ZC._n_(n=t.width)&&(g=n),null!==ZC._n_(n=t.height)&&(v=n),null!==ZC._n_(n=t.scale)&&(_=ZC._b_(n)),c.A1K&&(zingchart.params[c.K].width=g,zingchart.params[c.K].height=v);var b=zingchart.wh(ZC.A4("#"+c.K),g,v);(t.layout||(h!==b[0]||d!==b[1])&&b[0]>10&&b[1]>10)&&(c.I=b[0],c.F=b[1],null!==ZC._n_(n=t.layout)&&(c.o.layout=n),""===c.ME&&(c.E["from-api"]=!0,c.E.preservezoom=!0,c.resize(_),c.FY=g,c.MT=v,c.A2H=!1));break;case"plothide":case"hideplot":(o=c.C8(t.graphid))&&o.A3C(t,"hide");break;case"showguide":case"hideguide":ZC.E1[0]=ZC._n_(t.x)?t.x:ZC.E1[0],ZC.E1[1]=ZC._n_(t.y)?t.y:ZC.E1[1],(o=c.C8(t.graphid))&&c.Z7(o.K,"showguide"===i);break;case"showtooltip":case"hidetooltip":case"clicknode":if(o=c.C8(t.graphid)){var B=t.ev||{};"showtooltip"!==i&&"clicknode"!==i||((r=o.I0(t.plotindex,t.plotid))&&r.S.length&&!t.xy?(s=r.L,A=ZC._i_(t.nodeindex||"0"),B.targetid=o.K+"-plotset-plot-"+s+"-node-"+A,B.update=!0):B.targetid=o.K+"-xy-"+ZC._i_(t.y||"0")+"-"+ZC._i_(t.x||"0")),"clicknode"===i?(B.which=0,o.TG(B)):o.A.A7&&("showtooltip"===i?o.A.A7.onmouseover(B,t.data):o.A.A7.hide())}break;case"locktooltip":ZC.TTLOCK=!0;break;case"unlocktooltip":ZC.TTLOCK=!1;break;case"showhoverstate":if(o=c.C8(t.graphid)){r=o.I0(t.plotindex,t.plotid),s=ZC._i_(r?r.L:0),A=ZC._i_(t.nodeindex||"0");var m=o.AY.A5[s].FK(A);o.LD(),m.A0W()}break;case"plotshow":case"showplot":(o=c.C8(t.graphid))&&o.A3C(t,"show");break;case"togglesource":ZC.AL(c.K+"-viewsource")?ZC.Q.EU(c.K+"-viewsource"):c.A5R();break;case"togglebugreport":ZC.AL(c.K+"-bugreport")?ZC.Q.EU(c.K+"-bugreport"):c.A6K();break;case"toggleabout":ZC.AL(c.K+"-about")?ZC.Q.EU([c.K+"-about",c.K+"-about-mask"]):c.A9H();break;case"toggleplot":(o=c.C8(t.graphid))&&o.Q7(t);break;case"getcharttype":return(o=c.C8(t.graphid))?o.AF:null;case"showversion":case"getversion":return ZC.VERSION;case"get3dview":return(o=c.C8(t.graphid))?o.EZ:null;case"set3dview":(o=c.C8(t.graphid))&&(null===ZC._n_(c.o.graphset[o.L]["3d-aspect"])&&(c.o.graphset[o.L]["3d-aspect"]={}),ZC._cp_(t,c.o.graphset[o.L]["3d-aspect"]),null===ZC._n_(o.o["3d-aspect"])&&(o.o["3d-aspect"]={}),ZC._cp_(t,o.o["3d-aspect"]),zingchart.SKIP.PARSE3D=!0,o.autoFit(),o.K6(!0,!0),zingchart.SKIP.PARSE3D=!1);break;case"getpage":return c.L3;case"setpage":var E=0;null!==ZC._n_(n=t.page)&&(E=ZC._i_(n)),c.L3=E,ZC.ZJ(function(){c.clear(),c.parse(),c.paint()},!0);break;case"unbinddocument":ZC.A4(document).unbind(ZC.Q.BZ("mousemove"),zingchart.MI).unbind(ZC.Q.BZ("mousedown"),zingchart.MI).unbind(ZC.Q.BZ("mouseup"),zingchart.MI).unbind("click",zingchart.S8).unbind("contextmenu",zingchart.YS),c.D7&&c.D7.unbind()}var D=[];for(zingchart.ABJ&&null!==(C=zingchart.ABJ(e,i,t))&&(n=C),D=["addobject","removeobject","updateobject","repaintobjects","getobjectsbyclass","getallobjects","getlabelinfo","getshapeinfo","setobjectsmode","settweenmode"],zingchart.AB5&&-1!==ZC.AV(D,i)&&null!==(C=zingchart.AB5(e,i,t))&&(n=C),D=["getimagedata","exportimage","saveasimage","exportdata","downloadCSV","downloadXLS","downloadRAW","viewDataTable"],zingchart.AB6&&-1!==ZC.AV(D,i)&&null!==(C=zingchart.AB6(e,i,t))&&(n=C),D=["getzoom","pan","zoomin","zoomout","zoomto","zoomtovalues","viewall"],zingchart.ABP&&-1!==ZC.AV(D,i)&&null!==(C=zingchart.ABP(e,i,t))&&(n=C),D=["clearselection","getselection","setselection","select","deselect"],zingchart.AAQ&&-1!==ZC.AV(D,i)&&null!==(C=zingchart.AAQ(e,i,t))&&(n=C),D=["clearfeed","getinterval","setinterval","stopfeed","startfeed"],zingchart.ABH&&-1!==ZC.AV(D,i)&&null!==(C=zingchart.ABH(e,i,t))&&(n=C),a=0,l=zingchart.A95.length;a<l;a++)i===zingchart.A95[a].call&&null!==(C=zingchart.A95[a].api.call(zingchart,e,t))&&(n=C);return n},zingchart.extendAPI("addmenuitem",function(e,i){var t=zingchart.getLoader(e);t.DG["context-menu"]=t.DG["context-menu"]||{},t.DG["context-menu"]["custom-items"]=t.DG["context-menu"]["custom-items"]||[];for(var n=i.id||"",a=t.DG["context-menu"]["custom-items"],l=!1,o=0;o<a.length;o++)if(a[o].id===n){l=!0;break}l||t.DG["context-menu"]["custom-items"].push(i)}),zingchart.ABJ=function(e,i,t){var n;document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var a,l,o,r,s,A,C,c,u,p,Z,h,d,f,_,g,v,b,B,m,E,D,F,K=zingchart.getLoader(e),x=!(null!==ZC._n_(t.update)&&!ZC._b_(t.update)),I=null!==ZC._n_(t.history)&&ZC._b_(t.history),y="undefined"!=typeof t.smart&&ZC._b_(t.smart);if(K){switch(-1===ZC.AV(["resize","addplot","removeplot","modify","modifyplot","setnodevalue","addnode","removenode","setdata"],i)&&((l=K.FG()).params=t,ZC.AP.BY(i,K,l)),i){case"clearscroll":if(!(a=K.C8(t.graphid)))return null;a.HS&&a.HS.M6&&(a.HS.M6(),a.HS.unbind()),a.HQ&&a.HQ.M6&&(a.HQ.M6(),a.HQ.unbind());break;case"getbubblesize":return(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))?o.getSize(t.value||1):null;case"fastlinexycoords":var w=(a=K.AG[0]).BM("scale-x"),L=a.BM("scale-y");return w&&L?w.CO&&L.CO?[L.AT(t.val),w.AT(t.key)]:[w.AT(t.key),L.AT(t.val)]:[0,0];case"getscaleinfo":return(a=K.C8(t.graphid))&&(r=a.BM(t.name||""))?null!==ZC._n_(t.value)?r.AT?r.AT(t.value):null:null!==ZC._n_(t.coord)&&r.NE?r.NE(t.coord):null:null;case"getobjectinfo":if(!(a=K.C8(t.graphid)))return null;var X={id:"K",x:"iX",y:"iY",width:"I",height:"F",color:"C2",lineColor:"B7",lineWidth:"AZ",borderColor:"BW",borderWidth:"AU",backgroundColor1:"A0",backgroundColor2:"AE"};switch(t.object){case"graph":for(p in l={},X)l[p]=a[X[p]];return ZC._cp_({type:a.AF},l),l;case"plotarea":for(p in l={},X)l[p]=a.P[X[p]];return l;case"legend":if(l={},a.BD)for(p in X)l[p]=a.BD[X[p]];return l;case"scale":if(!(r=a.BM(t.name||"")))return null;for(p in l={},X)l[p]=r[X[p]];return ZC._cp_({type:r.AF,text:r.M&&r.M.AM||"",datetime:null!==r.F5&&"date"===r.F5.o.type,step:r.E5,step_:r.SG,stepSize:r.AA,values:r.V,placement:r.BA,aperture:r.EI,zooming:r.GN,offsetStart:r.AC,offsetEnd:r.BV,sizeFactor:r.JD,inversed:r.CO},l),r.M&&""!==r.M.AM&&(l.label={x:r.M.iX,y:r.M.iY,width:r.M.I,height:r.M.F,angle:r.M.A9}),"v"===r.AF?ZC._cp_({progression:r.C1,logBase:r.E6,minValue:r.B3,maxValue:r.BJ,minValue_:r.FX,maxValue_:r.H0},l):"scale-r"===t.name?ZC._cp_({refAngle:r.DJ},l):ZC._cp_({minValue:r.V[r.W],maxValue:r.V[r.A1],minValue_:r.V[r.DC],maxValue_:r.V[r.DX],minIndex:r.W,maxIndex:r.A1,minIndex_:r.DC,maxIndex_:r.DX},l),l;case"plot":if(!(o=a.I0(t.plotindex,t.plotid)))return null;for(p in l={},X)l[p]=o[X[p]];var Y=o.AN&&a.E["plot"+o.L+".visible"];return ZC._cp_({visible:Y,id:o.H5,index:o.L,type:o.AF,text:o.AM,values:o.V,scales:o.BO,stacked:o.CC,stackType:o.KR,stack:o.DZ,xdata:o.KH},l),o.TY&&ZC._cp_({marker:{visible:o.TY.AN,size:o.TY.AI,type:o.TY.DU,backgroundColor1:o.TY.A0,backgroundColor2:o.TY.AE,borderColor:o.TY.BW,borderWidth:o.TY.AU}},l),l;case"node":if(o=a.I0(t.plotindex,t.plotid)){if(B=null!==ZC._n_(t.nodeindex)?ZC._i_(t.nodeindex):0,!o.S[B])return null;for(p in s=o.FK(B),(l={}).bounds=s.H.E[s.K+"-bounds"],X)-1!==ZC.AV(["x","y","width","height"],p)?l[p]=s[X[p]]:l[p]=s.O[X[p]];if(ZC._cp_({plotindex:o.L,index:s.L,size:s.AI,value:s.AD,keyvalue:s.BT,onviewport:s.JE},l),-1!==o.AF.indexOf("pie")&&ZC._cp_({angleStart:s.B4,angleEnd:s.BK,slice:s.A.PQ,npv:100*s.AD/s.A.A.KL[s.L]},l),o.KH){var M={};for(p in o.KH)o.KH[p]instanceof Array?M[p]=o.KH[p][B]:M[p]=o.KH[p];l.xdata=M}return l}return null}break;case"getxyinfo":var H=[],P=t.x,N=t.y,S=ZC._tx_(K.K);P/=S[0],N/=S[1];for(var O=0;O<K.AG.length;O++){a=K.AG[O];for(var G=0;G<a.AY.A5.length;G++){o=a.AY.A5[G];var k=a.BM(o.BU("k")[0]),T=a.BM(o.BU("v")[0]);if(k&&T){if(k.O9&&k.O9){var z=k.O9(k.CO?N:P),Q=k.O9(k.CO?N:P,null,!0);H.push({infotype:"key-scale",xydistance:ZC._a_(P-k.IB(z)),graphid:a.K,plotidx:o.L,scalename:k.BE,scaleidx:z,scalepos:Q,scaletext:k.BX[z]||"",scalevalue:k.V[z],scalenumvalue:k.NE(k.CO?N:P)})}if(T.NE){var J=T.NE(T.CO?P:N,!0);H.push({infotype:"value-scale",xydistance:ZC._a_(T.CO?P:N-T.AT(J)),graphid:a.K,plotidx:o.L,scalename:T.BE,scalevalue:J})}for(var V,R=ZC.MAX,W=null,U=0,j=o.S.length;U<j;U++)if(null!==(s=o.FK(U)))switch(a.AJ.layout){case"xy":case"yx":var q=!1;"vbar"===s.A.AF?(V=s.getNodeData("h")||s.F,ZC.DS(P,s.iX-s.I/2,s.iX+s.I/2)&&ZC.DS(N,s.iY,s.iY+V)&&(q=!0,R=1)):"hbar"===s.A.AF&&(V=s.getNodeData("w")||s.I,ZC.DS(P,s.iX,s.iX+V)&&ZC.DS(N,s.iY-s.F/2,s.iY+s.F/2)&&(q=!0,R=1)),((n=Math.sqrt((s.iX-P)*(s.iX-P)+(s.iY-N)*(s.iY-N)))<R||q)&&(W={infotype:"node",xydistance:R,graphid:a.K,plotidx:o.L,plotid:o.H5,nodeidx:s.L,nodevalue:s.AD,nodekeyvalue:null===s.BT?k.V[s.L]:s.BT},q||(R=n));break;case"":var $=s.ACE();(n=Math.sqrt(($[0]-P)*($[0]-P)+($[1]-N)*($[1]-N)))<R&&(W={infotype:"node",xydistance:R,graphid:a.K,plotidx:o.L,plotid:o.H5,nodeidx:s.L,nodevalue:s.AD,nodekeyvalue:null===s.BT?k.V[s.L]:s.BT},R=n)}W&&H.push(W)}}}return H;case"update":t.objects?(a=K.C8(t.graphid))&&(a.OW(),a.QK()):null!==ZC._n_(t.graphid)&&(a=K.C8(t.graphid))?K.QE(function(){a.K6(y,y)}):K.K6();break;case"setcharttype":(a=K.C8(t.graphid))&&(null!==ZC._n_(t["preserve-state"])&&ZC._b_(t["preserve-state"])?K.E["graph-state-"+a.L]=JSON.stringify(a.E):K.E["graph-state-"+a.L]=null,K.o.graphset[a.L].type=a.o.type=a.AF=t.type,x&&K.K6());break;case"addgraph":K.o.graphset.push(t.data||{}),x&&K.K6();break;case"addplot":if(zingchart.SKIP.CSV=!0,h={},d=t.plotdata?"plotdata":"data",null!==ZC._n_(t[d])&&("object"==typeof t[d]?ZC._cp_(t[d],h):h=JSON.parse(t[d])),ZC._todash_(h),a=K.C8(t.graphid)){var ee=[];if(null===ZC._n_(a.o.series)&&(a.o.series=[]),Z=(null!==ZC._n_(t.plotindex)||null!==ZC._n_(t.plotid))&&(o=a.I0(t.plotindex,t.plotid))?o.L:a.o.series.length,null!==ZC._n_(a.IX)&&a.IX.splice(Z,0,!1),null!==ZC._n_(a.CB)){for(E in F={},a.CB)(D=ZC._i_(E.replace("p","")))<Z?F[E]=a.CB[E]:F["p"+(D+1)]=a.CB[E];F["p"+Z]={},a.CB=F}for(A=0,C=a.o.series.length;A<=C;A++)A===Z&&ee.push(h),a.o.series[A]&&ee.push(a.o.series[A]);ZC.AP.BY("plot_add",K,{id:K.K,graphid:a.K,plotindex:Z,data:h}),K.o.graphset[a.L].series=a.o.series=ee,K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,K.QE(function(){a.K6(y,y)}))}break;case"removeplot":if(zingchart.SKIP.CSV=!0,(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))){if(null!==ZC._n_(a.IX)&&a.IX.splice(o.L,1),null!==ZC._n_(a.CB)){for(E in F={},a.CB)(D=ZC._i_(E.replace("p","")))<o.L?F[E]=a.CB[E]:F["p"+(D-1)]=a.CB[E];a.CB=F}a.o.series.splice(o.L,1),K.o.graphset[a.L].series=a.o.series,K.E.json=ZC.GV(JSON.stringify(K.o)),ZC.AP.BY("plot_remove",K,{id:K.K,graphid:a.K,plotindex:o.L}),a.LV("on-change"),a.K6(y,y)}break;case"modify":if(zingchart.SKIP.CSV=!0,h={},null!==ZC._n_(t.data)&&("object"==typeof t.data?ZC._cp_(t.data,h):h=JSON.parse(t.data)),ZC._todash_(h),a=K.C8(t.graphid)){if(a.B9&&(a.B9.I2=!1,a.E["force-preview-parse"]=!0),null!==ZC._n_(t.object))switch(t.object){case"title":ZC._cp_(h,a.o.title);break;case"plotset":case"series":ZC._cp_(h,a.o.series);break;case"plotarea":ZC._cp_(h,a.o.plotarea);break;case"legend":ZC._cp_(h,a.o.legend);break;case"plot":ZC._cp_(h,a.o.plot);break;case"map":ZC._cp_(h,a.o.shapes[0])}else ZC._cp_(h,a.o);switch(t.object){case"title":K.o.graphset[a.L].title=a.o.title;break;case"plotset":case"series":K.o.graphset[a.L].series=a.o.series;break;case"plotarea":K.o.graphset[a.L].plotarea=a.o.plotarea;break;case"legend":K.o.graphset[a.L].legend=a.o.legend;break;case"plot":K.o.graphset[a.L].plot=a.o.plot;break;case"map":K.o.graphset[a.L].shapes[0]=a.o.shapes[0],K.XU(K.o),a.o.shapes=K.o.graphset[a.L].shapes;break;default:K.o.graphset[a.L]=a.o}K.E.json=ZC.GV(JSON.stringify(K.o)),ZC.AP.BY("modify",K,{id:K.K,graphid:a.K,data:h,object:t.object}),a.LV("on-change"),x&&(a.E["from-api"]=!0,K.QE(function(){a.K6(y,y)}))}break;case"modifyplot":zingchart.SKIP.CSV=!0,h={},d=t.plotdata?"plotdata":"data",null!==ZC._n_(t[d])&&("object"==typeof t[d]?ZC._cp_(t[d],h):h=JSON.parse(t[d])),ZC._todash_(h),(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))&&(null===ZC._n_(K.o.graphset[a.L].series)&&(K.o.graphset[a.L].series=[]),ZC._cp_(h,a.o.series[o.L]),K.o.graphset[a.L].series[o.L]=a.o.series[o.L],K.E.json=ZC.GV(JSON.stringify(K.o)),ZC.AP.BY("plot_modify",K,{id:K.K,graphid:a.K,plotindex:o.L,data:h}),a.LV("on-change"),x&&(a.E["from-api"]=!0,K.QE(function(){a.K6(y,y)})));break;case"setnodevalue":zingchart.SKIP.CSV=!0,(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))&&(B=0,null!==ZC._n_(t.nodeindex)&&(B=ZC._i_(t.nodeindex)),n=0,null!==ZC._n_(t.value)&&(n=t.value),ZC.AP.BY("node_set",K,{id:K.K,graphid:a.K,plotindex:o.L,nodeindex:B,key:B,value:n,text:n}),K.o.graphset[a.L].series[o.L].values[B]=a.o.series[o.L].values[B]=n,K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y)));break;case"setscalevalues":if(zingchart.SKIP.CSV=!0,a=K.C8(t.graphid)){for(f=t.scale||"scale-x",_=0,g=a.BO.length;_<g;_++)f===a.BO[_].BE&&null!==ZC._n_(a.o[f])&&(a.o[f].values=t.values,K.o.graphset[a.L][f]=K.o.graphset[a.L][f]||{},K.o.graphset[a.L][f].values=t.values);K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y))}break;case"addscalevalue":if(zingchart.SKIP.CSV=!0,a=K.C8(t.graphid)){for(f=t.scale||"scale-x",_=0,g=a.BO.length;_<g;_++)if(f===a.BO[_].BE&&null!==ZC._n_(a.o[f])&&null!==ZC._n_(a.o[f].values)){for(B=null===ZC._n_(t.nodeindex)?a.o[f].values.length:ZC._i_(t.nodeindex),(b=a.o[f].values).push(null),A=b.length-1;A>B;A--)b[A]=b[A-1];b[B]=t.value||"",K.o.graphset[a.L][f].values=b}K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y))}break;case"removescalevalue":if(zingchart.SKIP.CSV=!0,a=K.C8(t.graphid)){for(f=t.scale||"scale-x",_=0,g=a.BO.length;_<g;_++)f===a.BO[_].BE&&null!==ZC._n_(a.o[f])&&null!==ZC._n_(a.o[f].values)&&(B=null===ZC._n_(t.nodeindex)?a.o[f].values.length-1:ZC._i_(t.nodeindex),(b=a.o[f].values).splice(B,1),K.o.graphset[a.L][f].values=b);K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y))}break;case"addnode":zingchart.SKIP.CSV=!0,a=K.C8(t.graphid);var ie=t.value instanceof Array;if(a&&(o=a.I0(t.plotindex,t.plotid))){v=a.o.series[o.L].values,B=null===ZC._n_(t.nodeindex)?v.length:t.nodeindex,v.push(null);var te=v.length;for(B=ZC.BQ(0,ZC.CY(B,te)),A=te-1;A>B;A--)v[A]=v[A-1];if(v[B]=t.value,!ie)for(_=0,g=a.BO.length;_<g;_++)if(f=a.BO[_].BE,"k"===a.BO[_].AF&&null!==ZC._n_(t[f+"-value"])&&null!==ZC._n_(a.o[f])&&null!==ZC._n_(a.o[f].values)){for((b=a.o[f].values).push(null),A=b.length-1;A>B;A--)b[A]=b[A-1];b[B]=t[f+"-value"],K.o.graphset[a.L][f].values=b}ZC.AP.BY("node_add",K,{id:K.K,graphid:a.K,plotindex:o.L,nodeindex:B,key:B,value:t.value,text:t.value}),K.o.graphset[a.L].series[o.L].values=a.o.series[o.L].values,K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y))}break;case"removenode":if(zingchart.SKIP.CSV=!0,(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))){v=a.o.series[o.L].values,B=null===ZC._n_(t.nodeindex)?o.S.length-1:ZC._i_(t.nodeindex);var ne=!0;if(null!==ZC._n_(t.nodekeyvalue))for(ne=!1,_=0,g=o.S.length;_<g;_++){if(null===o.S[_]&&_===t.nodekeyvalue){ne=!0,B=_;break}if(o.S[_]&&null!==ZC._n_(o.S[_].BT)&&o.S[_].BT===t.nodekeyvalue){ne=!0,B=_;break}}if(ne&&ZC.DS(B,0,o.S.length-1)){for(v.splice(B,1),_=0,g=a.BO.length;_<g;_++)f=a.BO[_].BE,"k"===a.BO[_].AF&&null!==ZC._n_(t[f])&&ZC._b_(t[f])&&null!==ZC._n_(a.o[f])&&null!==ZC._n_(a.o[f].values)&&((b=a.o[f].values).splice(B,1),K.o.graphset[a.L][f].values=b);(ne||o.S[B])&&(ZC.AP.BY("node_remove",K,{id:K.K,graphid:a.K,plotindex:o.L,nodeindex:B,key:B,value:o.S[B]?o.S[B].AD:null,text:o.S[B]?o.S[B].AD:null}),K.o.graphset[a.L].series[o.L].values=a.o.series[o.L].values,K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&(a.E["from-api"]=!0,a.K6(y,y)))}}break;case"setdata":if(h={},null!==ZC._n_(t.data))if("object"==typeof t.data)zingchart.DEV.COPYDATA?h=JSON.parse(JSON.stringify(t.data)):ZC._cp_(t.data,h);else try{h=JSON.parse(t.data)}catch(fe){return K.O1(fe,"JSON parser"),!1}ZC._todash_(h),null===ZC._n_(t.preservezoom)&&(K.E.preservezoom=!1),a=null,null!==ZC._n_(t.graphid)&&(a=K.C8(t.graphid)),ZC.AP.BY("setdata",K,{id:K.K,graphid:a?a.K:null,data:h});var ae,le,oe=["x","y","width","height"];if(a){for(ae=0;ae<oe.length;ae++)delete K.E["graph-"+a.L+"-"+oe[ae]];K.o.graphset[a.L]=a.o=h;var re=!1;if(h.widgets)re=!0;else if(h.shapes)for(A=0;A<h.shapes.length;A++)"zingchart.maps"===h.shapes[A].type&&(re=!0);re&&K.XU(K.o),K.E.json=ZC.GV(JSON.stringify(K.o)),x&&(a.E["from-api"]=!0,I&&K.NU++,K.QE(function(){K.parse(a.K),K.AG[a.L].paint()}))}else{for(ae=0;ae<oe.length;ae++)for(le=0;le<K.AG.length;le++)delete K.E["graph-"+le+"-"+oe[ae]];K.o=h,K.E.json=ZC.GV(JSON.stringify(K.o)),K.XU(K.o),x&&(I&&K.NU++,K.K6())}break;case"getseriesdata":return(a=K.C8(t.graphid))?null!==ZC._n_(t.plotindex)||null!==ZC._n_(t.plotid)?(o=a.I0(t.plotindex,t.plotid,0))?a.o.series[o.L]:null:a.o.series:null;case"setseriesdata":case"appendseriesdata":if(zingchart.SKIP.CSV=!0,a=K.C8(t.graphid)){if(null!==ZC._n_(t.plotindex)||null!==ZC._n_(t.plotid)?(o=a.I0(t.plotindex,t.plotid,0),h="setseriesdata"===i?{}:a.o.series&&a.o.series[o.L]?a.o.series[o.L]:{}):h="setseriesdata"===i?[]:a.o.series||[],null!==ZC._n_(t.data)&&("object"==typeof t.data?ZC._cp_(t.data,h):ZC._cp_(JSON.parse(t.data),h)),ZC._todash_(h),null!==ZC._n_(t.plotindex)||null!==ZC._n_(t.plotid))o=a.I0(t.plotindex,t.plotid,0),K.o.graphset[a.L].series[o.L]=a.o.series[o.L]=h,h.hasOwnProperty("visible")&&(a.E["plot"+o.L+".visible"]=h.visible);else for(K.o.graphset[a.L].series=a.o.series=h,A=0;A<h.length;A++)h[A].hasOwnProperty("visible")&&(a.E["plot"+A+".visible"]=h[A].visible);K.E.json=ZC.GV(JSON.stringify(K.o)),a.LV("on-change"),x&&K.QE(function(){a.K6(y,y)})}break;case"getseriesvalues":if(a=K.C8(t.graphid)){if(null!==ZC._n_(t.plotindex)||null!==ZC._n_(t.plotid))return(o=a.I0(t.plotindex,t.plotid,0))&&a.o.series[o.L].values||[];for(m=[],A=0,C=a.AY.A5.length;A<C;A++)m.push(a.o.series[A].values||[]);return m}return null;case"setseriesvalues":case"appendseriesvalues":zingchart.SKIP.CSV=!0,m=[],null!==ZC._n_(t.values)&&(m="object"==typeof t.values?t.values:JSON.parse(t.values));var se=!1;if(a=K.C8(t.graphid)){if(null===ZC._n_(t.plotindex)&&null===ZC._n_(t.plotid)||(m=[m],se=!0),se||"setseriesvalues"!==i){for(o=a.I0(t.plotindex,t.plotid,0),A=0,C=m.length;A<C;A++)if(a.AY.A5[o.L+A])if("setseriesvalues"===i)se&&(K.o.graphset[a.L].series[o.L+A].values=a.o.series[o.L+A].values=m[A]);else{var Ae=K.o.graphset[a.L].series[o.L+A].values,Ce=m[A].length>0&&null!==ZC._n_(m[A][0])&&m[A][0].length>1,ce=!0;if(null!==ZC._n_(n=t.ignoreduplicates)&&(ce=ZC._b_(n)),Ce){var ue=Ae.length;for(c=0,u=m[A].length;c<u;c++){for(var pe=!1,Ze=ue-1;Ze>=0;Ze--){if(m[A][c][0]>Ae[Ze][0]){Ae.push(m[A][c]),pe=!0;break}if(m[A][c][0]===Ae[Ze][0]){pe=!0;break}}pe&&ce||Ae.push(m[A][c])}}else for(c=0,u=m[A].length;c<u;c++)Ae.push(m[A][c]);t["max-values"]&&ZC._i_(t["max-values"])<Ae.length&&(Ae=Ae.slice(-t["max-values"])),K.o.graphset[a.L].series[o.L+A].values=a.o.series[o.L+A].values=Ae}}else{for(_=0;_<m.length;_++)K.o.graphset[a.L].series[_]=K.o.graphset[a.L].series[_]||{},a.o.series[_]=a.o.series[_]||{},K.o.graphset[a.L].series[_].values=a.o.series[_].values=m[_];if(a.o.series.length>m.length)for(_=m.length;_<a.o.series.length;_++)delete K.o.graphset[a.L].series[_],delete a.o.series[_]}a.LV("on-change"),K.E.json=ZC.GV(JSON.stringify(K.o)),x&&a.K6(y,y)}break;case"togglelegend":if((a=K.C8(t.graphid))&&a.BD){var he=!0;"undefined"==typeof a.BD.o.visible||a.BD.o.visible||(he=!1),a.BD.o.visible=!he,a.BD.clear(!1),a.BD.parse(),a.BD.paint()}break;case"legendminimize":case"legendmaximize":(a=K.C8(t.graphid))&&a.BD&&("legendminimize"===i?(ZC.AP.BY("legend_minimize",K,a.GX()),ZC.AP.BY("legend_hide",K,a.GX())):(ZC.AP.BY("legend_maximize",K,a.GX()),ZC.AP.BY("legend_show",K,a.GX())),a.BD.NC="legendminimize"===i,a.BD.VT(),a.BD.clear(!1),a.BD.parse(),a.BD.paint());break;case"legendscroll":(a=K.C8(t.graphid))&&a.BD&&(o=a.I0(t.plotindex,t.plotid))&&(a.BD.scrollTo(ZC._i_(o.L)),a.BD.VT(),a.BD.clear(!0),a.BD.YG=!0,a.BD.parse(),a.BD.paint());break;case"toggledimension":(a=K.C8(t.graphid))&&K.A54(a.K);break;case"getdata":return h=JSON.parse(K.E.json),ZC._todash_(h,!0),h;case"getoriginaljson":return h=JSON.parse(K.E.source),ZC._todash_(h,!0),h;case"getgraphlength":return K.AG.length;case"getplotlength":return(a=K.C8(t.graphid))?a.AY.A5.length:0;case"getscales":if(a=K.C8(t.graphid)){var de=[];for(A=0;A<a.BO.length;A++)de.push(a.BO[A].BE);return de}return[];case"getnodelength":return(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))?o.S.length:null;case"getnodevalue":return(a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))&&null!==ZC._n_(t.nodeindex)&&(s=o.S[ZC._i_(t.nodeindex)])?o.EF?[s.BT,s.AD]:s.AD:null;case"getplotvalues":if((a=K.C8(t.graphid))&&(o=a.I0(t.plotindex,t.plotid))){for(m=[],A=0,C=o.S.length;A<C;A++)o.S[A]?o.EF?m.push([o.S[A].BT,o.S[A].AD]):m.push(o.S[A].AD):m.push(null);return m}return null}}return null};var A9G={$i:function(){var e=this;e.OB=null,e.o={},e.I6=null,e.JB=null,e.E={},e.E7=[],e.HT=null,e.MJ=""},H3:function(e,i,t,n,a){var l=this;if(e.HT){a=a||l.MJ;var o=e.HT.call(l,n,a);t&&o&&(o[t+"-state"]?o=o[t+"-state"]:o[t+"State"]&&(o=o[t+"State"]));var r,s,A=l.getPMap(),C={},c={};for(var u in o)r=ZC.EE(u),s=ZC.UM(u),"backgroundColor"===r?C.A0=C.AE=ZC.AP.G9(o[u]):"borderRadius"===r?C.F7=C.FS=C.FE=C.F2=o[u]:"padding"===u?C.FM=C.FN=C.FT=C.EQ=o[u]:A[r]?C[A[r]]=o[u]:C[r]=o[u],c[s]=o[u];i.o||ZC._cp_(o,C),ZC._cp_(C,i),i.o&&(ZC._cp_(c,i.o),i.KY())}},parse:function(){var s=this,G,i,oRule,KO;"dashed"!==zingchart.SYNTAX&&ZC._todash_(s.o);var AB="";if("undefined"!=typeof s.H&&(AB=s.H.AB),ZC.ZO(s.o,"html5"),""!==AB&&ZC.ZO(s.o,AB),zingchart.DEV.MEDIARULES&&s.o["media-rules"]&&"undefined"!=typeof s.H)for(i=0;i<s.o["media-rules"].length;i++)oRule=s.o["media-rules"][i],KO=!0,null!==ZC._n_(oRule["min-width"])&&ZC._i_(oRule["min-width"])>s.H.I&&(KO=!1),null!==ZC._n_(oRule["max-width"])&&ZC._i_(oRule["max-width"])<s.H.I&&(KO=!1),null!==ZC._n_(oRule["min-height"])&&ZC._i_(oRule["min-height"])>s.H.F&&(KO=!1),null!==ZC._n_(oRule["max-height"])&&ZC._i_(oRule["max-height"])<s.H.F&&(KO=!1),KO&&ZC._cp_(oRule,s.o);for(s.o.rules&&(s.E7=s.o.rules),i=0;i<s.E7.length;i++)if("*"===s.E7[i].rule&&s.E7[i].js){s.o["js-rule"]=s.E7[i].js,s.E7.splice(i,1);break}if(G=s.o["js-rule"])if("function"==typeof G)s.MJ="",s.HT=eval(G);else if("javascript:"===G.substring(0,11)||G.indexOf("(")<G.indexOf(")"))try{s.MJ="";var EC=G.replace("javascript:",""),iOpen=G.indexOf("("),iClose=G.indexOf(")");-1!==iOpen&&-1!==iClose&&(s.MJ=EC.substr(iOpen+1,iClose-iOpen-1),EC=EC.substr(0,iOpen)),s.HT=ZC.evalFn(EC,window)}catch(e){}if("undefined"!=typeof s.H&&null!==s.H.QV)for(var g in s.H.QV)s.H.QV.hasOwnProperty(g)&&null===ZC._n_(s.o[g])&&(s.o[g]=s.H.QV[g])},getPMap:function(){return{}},addPMap:function(e,i,t){for(var n=i.split(","),a=t.split(","),l=0,o=a.length;l<o;l++)e[n[l]]=a[l]},getData:function(){return this.o},setData:function(e){this.o=e},getAttributes:function(){return this.E},getAttribute:function(e){return this.E[e]},setAttribute:function(e,i){this.E[e]=i},get:function(e){var i=this.getPMap();return i[e]?this[i[e]]:null},set:function(e,i){var t=this.getPMap();t[e]&&(this[t[e]]=i)},append:function(e,i,t){null===i&&(i=!0);var n=this;e&&(n.I6||(n.I6={},ZC._cp_(n.o,n.I6,!0,t)),n.JB||(n.JB={}),ZC._cp_(e,n.JB,!0,t),ZC._cp_(e,n.o,!0,t)),"undefined"!=typeof n.AD2&&n.AD2()&&e&&ZC._cp_(e,n.o)},AD2:function(){},assign_a:function(e){for(var i=0,t=e.length;i<t;i++)this.o.hasOwnProperty(e[i][0])&&this.ZQ(e[i][0],e[i][1],e[i][2],e[i][3],e[i][4])},ZQ:function(e,i,t,n,a){var l,o=this;if(null!==(l=o.o[e])&&void 0!==l){if(t)switch(-1!==t.indexOf("p")&&(l=ZC._p_(l),t=t.replace("p","")),-1!==t.indexOf("a")&&(l=ZC._a_(l),t=t.replace("a","")),t){case"i":l=ZC._i_(l);break;case"f":l=ZC._f_(l);break;case"b":l=ZC._b_(l);break;case"c":l=ZC.AP.YN(l,o),(l=ZC.AP.G9(l,o))instanceof Array&&("color"===e||"font-color"===e?(o.o["text-alpha"]=l[1],o.UV=l[1],o.E["text-alpha"]=l[1]):"border-color"===e?(o.o["border-alpha"]=l[1],o.NY=l[1],o.E["b-alpha"]=l[1]):("line-color"===e&&(o.E["l-alpha"]=l[1]),null===ZC._n_(o.o.alpha)&&(o.C6=l[1])),l=l[0])}null!==ZC._n_(n)&&null!==ZC._n_(a)&&(l=ZC._l_(l,n,a)),o[i]=l}},DE:function(){for(var e=this,i=!1,t=0,n=e.E7.length;t<n;t++){var a=!1;try{a=new Function("return ("+e.J2(e.E7[t].rule)+")")()}catch(l){a=!1}a&&(i=!0,e.append(e.E7[t]))}return i},ACJ:function(e){for(var i="",t=0,n=e.length;t<n;t++){var a=!1;try{a=new Function("return ("+this.J2(e[t].rule)+")")()}catch(l){a=!1}a&&(i+="<"+e[t].rule+">")}return""!==i?[i,ZC.XR.md5(i)]:null},J2:function(){return!0},copy:function(e){var i=this;ZC._cp_(e.o,i.o),e.I6&&(i.I6=i.I6||{},ZC._cp_(e.I6,i.I6)),e.JB&&(i.JB=i.JB||{},ZC._cp_(e.JB,i.JB)),ZC._cp_(e.E,i.E),ZC._cp_(e.E7,i.E7)}};ZC.A9G=ZC.C9.CA(A9G);var D0={$i:function(e){this.b(e);var i=this;e&&e.H&&(i.H=e.H),i.K="",i.DH=null,i.AN=!0,i.A0="-1",i.AE="-1",i.GR="",i.HN="",i.VH=!0,i.DA="",i.M2="repeat",i.TA="50% 50%",i.WN="",i.KS=1,i.NI="linear",i.N9=90,i.VO=0,i.W5=0,i.AZ=0,i.B7="#000",i.GF="",i.EX=0,i.GA=0,i.AU=0,i.BW="#000",i.C6=1,i.NY=1,i.T1="butt",i.ZZ="round",i.M8=!1,i.OH=45,i.JV=2,i.T6=.75,i.RZ="#999",i.P7=0,i.CZ=!0,i.N5=!1,i.L4=!1,i.A2A=!1,i.LQ=null,i.BG=""},getPMap:function(){var e=this.b();return this.addPMap(e,"visible,backgroundColor1,backgroundColor2,gradientColors,gradientStops,backgroundImage,backgroundRepeat,backgroundPosition,backgroundFit,backgroundScale,fillType,fillAngle,fillOffsetX,fillOffsetY,lineWidth,lineColor,lineStyle,lineSegmentSize,lineGapSize,borderWidth,borderColor,borderAlpha,alpha,lineCap,shadow,shadowAngle,shadowDistance,shadowAlpha,shadowColor,shadowBlur,class,border","AN,A0,AE,GR,HN,DA,M2,TA,WN,KS,NI,N9,VO,W5,AZ,B7,GF,EX,GA,AU,BW,NY,C6,T1,M8,OH,JV,T6,RZ,P7,DH,BG"),e},copy:function(e){this.b(e);for(var i="AN,A0,AE,GR,HN,DA,VH,M2,TA,WN,KS,NI,N9,VO,W5,AZ,B7,GF,EX,GA,AU,BW,NY,C6,T1,M8,OH,JV,T6,RZ,P7,CZ,L4,DH,H,BG".split(","),t=0,n=i.length;t<n;t++)"undefined"!=typeof e[i[t]]&&(this[i[t]]=e[i[t]])},AD2:function(){var e,i,t=this,n=!1;if((t.o["class"]||t.o.cls||t.o.id)&&null!==t.H&&null!==t.H.O){if(e=t.o["class"]||t.o.cls)for(var a=e.split(/(\s+)/),l=0,o=a.length;l<o;l++)(i=t.H.O["."+a[l]])&&(n=!0,ZC._cp_(i,t.o));(e=t.o.id)&&(i=t.H.O["#"+e])&&(n=!0,ZC._cp_(i,t.o))}return null!==t.OB&&(i=t.H.O[t.OB])&&(n=!0,ZC._cp_(i,t.o)),n},KY:function(e){var i,t=this;switch(null===ZC._n_(e)&&(e=t.AZ),t.GF){case"dotted":t.EX=ZC.BQ(1,.75*e),t.GA=1.75*e;break;case"dashed":t.EX=4*e,t.GA=3*e;break;case"dashdot":t.EX=4*e,t.GA=2*e;break;default:t.EX=0,t.GA=0}null!==(i=ZC._n_(t.o["line-segment-size"]))&&(t.EX=parseInt(i,10)),null!==(i=ZC._n_(t.o["line-gap-size"]))&&(t.GA=parseInt(i,10))},parse:function(){var e,i,t,n,a,l,o,r,s;this.b();var A=this;if(null!==(e=ZC._n_(A.o.override))&&!A.A2A){var C,c,u,p=-1,Z=-1;for("undefined"!=typeof A.E.plotidx&&(p=ZC._i_(A.E.plotidx)),"undefined"!=typeof A.E.nodeidx&&(Z=ZC._i_(A.E.nodeidx)),o=0,r=e.length;o<r;o++){if(C=-1,c=-1,e[o].hook){if(null!==(i=ZC._n_(e[o].hook["node-index"]))){if(c=0,u=[],"object"==typeof i)u=i;else if("string"==typeof i){if(-1!==i.indexOf(","))u=i.split(",");else if(-1!==i.indexOf("-"))for(t=i.split("-"),n=ZC._i_(t[0]);n<=ZC._i_(t[1]);n++)u.push(n)}else u=[i];-1!==ZC.AV(u,Z)&&(c=1)}if(null!==(i=e[o].hook["plot-index"])&&void 0!==i){if(C=0,u=[],"object"==typeof i)u=i;else if("string"==typeof i){if(-1!==i.indexOf(","))u=i.split(",");else if(-1!==i.indexOf("-"))for(t=i.split("-"),n=ZC._i_(t[0]);n<ZC._i_(t[1]);n++)u.push(n)}else u=[i];-1!==ZC.AV(u,p)&&(C=1)}}0!==C&&0!==c&&A.append(e[o])}}if(null!==(e=A.LQ)&&A.append(e),e=A.o["background-color"]){if(e=ZC.AP.YN(e,this),"rgb("===String(e).substring(0,4))for(a=new RegExp("rgb\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\)");l=a.exec(e);)e=e.replace(l[0],ZC.AP.G9(l[0]));if("rgba("===String(e).substring(0,5))for(a=new RegExp("rgba\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\,\\s*([0-9.]+)\\)");l=a.exec(e);){var h=ZC.AP.G9(l[0],A);e=e.replace(l[0],h[0]),A.o.alpha=h[1],A.C6=h[1],A.E["bg-alpha"]=h[1],null===ZC._n_(A.E["b-alpha"])&&(A.E["b-alpha"]=1),null===ZC._n_(A.E["l-alpha"])&&(A.E["l-alpha"]=1)}var d=ZC.GV(String(e)).split(/\s+|;|,/);A.A0=ZC.AP.G9(d[0]),A.AE=1===d.length?A.A0:ZC.AP.G9(d[1])}if(!(null===ZC._n_(A.o["border-width"])&&null===ZC._n_(A.o["border-color"])&&null===ZC._n_(A.o["line-style"])||null===ZC._n_(A.o["border-top"])&&null===ZC._n_(A.o["border-right"])&&null===ZC._n_(A.o["border-bottom"])&&null===ZC._n_(A.o["border-left"])&&null===ZC._n_(A.o.border))){var f=["top","right","bottom","left"],_={top:[0,"solid","#000"],right:[0,"solid","#000"],bottom:[0,"solid","#000"],left:[0,"solid","#000"]};if(A.I6=A.I6||{},e=A.I6.border)for(s=e.split(/\s/),o=0;o<4;o++)_[f[o]]=[ZC._i_(s[0]||"0"),ZC.GV(s[1]||"solid"),ZC.AP.G9(s[2]||"#000000")];if(null!==ZC._n_(A.I6["border-width"]))for(o=0;o<4;o++)_[f[o]][0]=A.I6["border-width"];if(null!==ZC._n_(A.I6["line-style"]))for(o=0;o<4;o++)_[f[o]][1]=A.I6["line-style"];if(null!==ZC._n_(A.I6["border-color"]))for(o=0;o<4;o++)_[f[o]][2]=A.I6["border-color"];for(o=0;o<4;o++)(e=A.I6["border-"+f[o]])&&(s=e.split(/\s/),_[f[o]]=[ZC._i_(s[0]||"0"),ZC.GV(s[1]||"solid"),ZC.AP.G9(s[2]||"#000000")]);if(A.JB=A.JB||{},e=A.JB.border)for(s=e.split(/\s/),o=0;o<4;o++)_[f[o]]=[ZC._i_(s[0]||"0"),ZC.GV(s[1]||"solid"),ZC.AP.G9(s[2]||"#000000")];if(null!==ZC._n_(A.JB["border-width"]))for(o=0;o<4;o++)_[f[o]][0]=A.JB["border-width"];if(null!==ZC._n_(A.JB["line-style"]))for(o=0;o<4;o++)_[f[o]][1]=A.JB["line-style"];if(null!==ZC._n_(A.JB["border-color"]))for(o=0;o<4;o++)_[f[o]][2]=A.JB["border-color"];for(o=0;o<4;o++)(e=A.JB["border-"+f[o]])&&(s=e.split(/\s/),_[f[o]]=[ZC._i_(s[0]||"0"),ZC.GV(s[1]||"solid"),ZC.AP.G9(s[2]||"#000000")]);for(o=0;o<4;o++)null===ZC._n_(A.o["border-"+f[o]])&&(A.o["border-"+f[o]]=_[f[o]].join(" "))}A.assign_a([["visible","AN","b"],["background-color-1","A0","c"],["background-color-2","AE","c"],["gradient-colors","GR"],["gradient-stops","HN"],["pixel-correction","CZ","b"],["background-clip","VH","b"],["background-image","DA"],["background-repeat","M2"],["background-position","TA"],["background-fit","WN"],["background-scale","KS","f"],["fill-type","NI"],["fill-angle","N9","i"],["fill-offset-x","VO","f"],["fill-offset-y","W5","f"],["line-width","AZ","i"],["line-color","B7","c"],["line-style","GF",""],["class","DH"],["cls","DH"],["border","BG"]]),"none"===A.NI&&(A.AE=A.A0,A.NI="linear"),""!==A.BG&&(s=A.BG.split(/\s/),A.AU=ZC._i_(s[0]||"0"),A.GF=ZC.GV(s[1]||"solid"),A.BW=ZC.AP.G9(s[2]||"#000000")),A.GR=ZC.AP.YN(A.GR,this),A.KY(),A.assign_a([["line-segment-size","EX","i"],["line-gap-size","GA","i"],["border-width","AU","i"],["border-color","BW","c"],["alpha","C6","f",0,1],["shadow","M8","b"],["shadow-angle","OH","i",0,360],["shadow-distance","JV","i"],["shadow-alpha","T6","f",0,1],["shadow-color","RZ","c"],["shadow-blur","P7","i"]]),A.NY=A.C6,A.assign_a([["border-alpha","NY","f",0,1]])}};ZC.D0=ZC.A9G.CA(D0),ZC.CR={contour:function(e,i,t){var n,a,l;if(e&&t&&0!==t.length){if(!i.E["fast-vector-path"])for(n=0,a=t.length;n<a;n++)t[n]&&(t[n][0]=parseFloat(Number(t[n][0]).toFixed(2)),t[n][1]=parseFloat(Number(t[n][1]).toFixed(2)));var o=!1,r=t.length;for(n=0;n<r;n++)null!==ZC._n_(t[n])&&(l=[t[n][0],t[n][1]],null!==ZC._n_(t[n][2])&&l.push(t[n][2],t[n][3]),null!==ZC._n_(t[n][4])&&l.push(t[n][4],t[n][5]),i.N5&&(l[0]=Math.round(l[0]),l[1]=Math.round(l[1]),4===l.length&&(l[2]=Math.round(l[2]),l[3]=Math.round(l[3]))),i.CZ&&i.AZ%2==1&&(l[0]-=.5,l[1]-=.5,4===l.length&&(l[2]-=.5,l[3]-=.5))),0===n?e.moveTo(l[0],l[1]):t[n]?(o&&(e.moveTo(l[0],l[1]),o=!1),2===l.length?e.lineTo(l[0],l[1]):4===l.length?e.quadraticCurveTo(l[0],l[1],l[2],l[3]):6===l.length&&e.arc(l[0],l[1],l[2],ZC.T8(l[3]),ZC.T8(l[4]),l[5])):o=!0}},setup:function(e,i){var t=i.H.AB;if(1!==i.C6&&i.L4&&(null===ZC._n_(i.o["border-color"])&&(i.BW=i.A0),null===ZC._n_(i.o["border-width"])))switch(t){case"canvas":i.AU=.2;break;case"svg":i.AU=.1;break;case"vml":i.AU=.2,i.E.A8J=i.C6/10}},paint:function(e,i,t,n,a,l){if(null===ZC._n_(a)&&(a=2),null===ZC._n_(n)&&(n=!1),null===ZC._n_(l)&&(l=!1),e&&t&&0!==t.length&&i){var o,r,s,A,C,c;!l&&t.length>2&&null!==t[0]&&null!==t[t.length-1]&&t[0].join(",")===t[t.length-1].join(",")&&(i.T1="round");var u=i.H.AB;if("canvas"!==u||0!==i.AZ&&"-1"!==i.B7){if(i.M8&&!n){i.C7=i.C7||i.Z;var p,Z=ZC.Q._sh_(t,i);"undefined"!=typeof i.A4V?p=i.A4V:((p=new ZC.DT(i)).copy(i),p.K=i.K+"-sh",p.M8=!1,p.AZ+=p.P7,p.B7=p.RZ),p.C6=i.C6*p.T6,"undefined"==typeof i.ADH&&(i.A4V=p),p.CZ=!1,o=i.C7?ZC.Q.EB(i.C7,u):e,ZC.CR.setup(o,p),ZC.CR.paint(o,p,Z,!1,1,l)}var h=ZC._i_(i.EX||"0"),d=ZC._i_(i.GA||"0");"solid"===i.GF&&(h=d=0);var f=t.length;"undefined"==typeof i.A9&&(i.A9=0),"canvas"===u&&(e.lineJoin=i.ZZ,e.lineCap=i.T1,e.strokeStyle=ZC.AP.A32(ZC.AP.G9(i.B7),n?i.NY:i.C6),e.lineWidth=i.AZ,e.beginPath());var _=!1;if(-1!==ZC.AV(["svg","vml"],u))r=l?[]:ZC.Q.A2W(t,u,i,n);else{var g=!1;"dashdot"!==i.GF&&(g=e.setLineDash)&&e.setLineDash(0===h||0===d?[]:[h,d]);var v=0,b=[ZC.MAX,ZC.MAX,-ZC.MAX,-ZC.MAX];for(c=0;c<f;c++)if(null!==t[c]){if(null!==(s=ZC.objmove?t[c]:ZC.Q._txp_(t[c],u,i,n))&&!isNaN(s[0])&&!isNaN(s[1])&&isFinite(s[0])&&isFinite(s[1]))if(f<=6&&n&&(b[0]=ZC.CY(b[0],s[0]),b[1]=ZC.CY(b[1],s[1]),b[2]=ZC.BQ(b[2],s[0]),b[3]=ZC.BQ(b[3],s[1])),0===c)2===s.length?e.moveTo(s[0],s[1]):6===s.length&&e.arc(s[0],s[1],s[2],ZC.T8(s[3]),ZC.T8(s[4]),s[5]);else if(_&&(e.moveTo(s[0],s[1]),_=!1),g||0===h||0===d||4===s.length||6===s.length||7===s.length)2===s.length?e.lineTo(s[0],s[1]):4===s.length?e.quadraticCurveTo(s[0],s[1],s[2],s[3]):6===s.length?e.arc(s[0],s[1],s[2],ZC.T8(s[3]),ZC.T8(s[4]),s[5]):7===s.length&&e.bezierCurveTo(s[0],s[1],s[2],s[3],s[4],s[5]);else if(null!==t[c-1]){var B=ZC.Q._txp_(t[c-1],u,i,n),m=B[4===B.length?2:0],E=B[4===B.length?3:1],D=s[0],F=s[1],K=h+d,x=D-m,I=F-E,y=Math.sqrt(x*x+I*I)+v;if(y>h){var w;v=0,w="dashdot"===i.GF?Math.floor(ZC._a_(y/((K+i.AZ+d)/2))):Math.floor(ZC._a_(y/K));var L=Math.atan2(I,x),X=Math.cos(L),Y=Math.sin(L),M=m,H=E,P=h;for(A=0;A<w;A++)"dashdot"===i.GF&&(K=A%2?i.AZ+d:h+d,P=A%2?i.AZ:h),x=X*K,I=Y*K,e.moveTo(M,H),e.lineTo(M+X*P,H+Y*P),M+=x,H+=I;e.moveTo(M,H),(y=Math.sqrt((D-M)*(D-M)+(F-H)*(F-H)))>h?e.lineTo(M+X*h,H+Y*h):y>0&&e.lineTo(M+X*y,H+Y*y),e.moveTo(D,F)}else v=y}}else _=!0;i.H&&f<=6&&n&&(i.H.E[i.K+"-bounds"]=b)}switch(u){case"canvas":e.globalCompositeOperation=i.A0Z,e.stroke();break;case"svg":case"vml":if(null===ZC._n_(i.o["top-state"])&&i.H.O7&&(!n||i.E.areanode)){if(C=i.E.areanode?i.A0+"-"+i.AE+"-"+i.DA+"-"+i.AZ+"-"+i.GF+"-"+i.C6+"-"+i.BL+"-"+i.BH:i.B7+"-"+i.AZ+"-"+i.GF+"-"+i.C6+"-"+i.BL+"-"+i.BH,null===ZC._n_(i.H.NW[a])){i.H.NW[a]={uid:C,ctx:e,path:r,style:i,filled:n};break}if(i.H.NW[a].uid===C&&i.H.NW[a].path.length<2e3){A=i.H.NW[a].path,r&&r[0]&&(A.length>0&&A[A.length-1].replace(/[A-Z]+/,"")===r[0].replace(/[A-Z]+/,"")&&(r[0]=""),i.H.NW[a].path=i.H.NW[a].path.concat(r));break}"svg"===u?ZC.CR.VX(i.H.NW[a].ctx,i.H.NW[a].style,i.H.NW[a].path.join(" "),i.H.NW[a].filled):ZC.CR.VW(i.H.NW[a].ctx,i.H.NW[a].style,i.H.NW[a].path.join(" "),i.H.NW[a].filled),i.H.NW[a]={uid:C,ctx:e,path:r,style:i,filled:n};break}"svg"===u?ZC.CR.VX(e,i,r.join(" "),n,l):ZC.CR.VW(e,i,r.join(" "),n)}if(null!==ZC._n_(i.o["top-state"])&&!i.Y6&&!i.E["skip-top"]&&!i.VN){var N=new ZC.HL(i.A);N.copy(i),N.VN=!0,N.M8=!1,N.Z=i.Z,N.append(i.o["top-state"]),N.K=i.K+"-top",N.parse(),"svg"===u?ZC.CR.VX(e,N,r.join(" "),n,l):"vml"===u?ZC.CR.VW(e,N,r.join(" "),n):ZC.CR.paint(e,N,t,n,a,l)}}}},smooth:function(e,i,t){var n,a,l,o;ZC._n_(i)&&(i=!1),t=t||"h";var r=[],s=[];for(n=0,a=e.length;n<a;n++)e[n]&&("h"===t?(s.push(e[n][0]),r.push(e[n][1])):(s.push(e[n][1]),r.push(e[n][0])),0===n&&(s.push(s[0]),r.push(r[0])));for(s.push(s[s.length-1]),r.push(r[r.length-1]),e=[],l=1,o=r.length;l<o-1;l++){var A=[r[l-1],r[l],r[l+1],r[l+2]],C=ZC._a_(s[l+1]-s[l]),c=1/(C/A.length),u=ZC.AR.Y9(i,A,C,c);for(n=0,a=u.length;n<a;n++)null!==ZC._n_(u[n][0])&&null!==ZC._n_(u[n][1])?"h"===t?e.push([s[l]+u[n][0]*C,u[n][1]]):e.push([u[n][1],s[l]+u[n][0]*C]):e.push(null)}return e},_append_:function(e,i,t){i.H&&i.H.G1?(null===ZC._n_(i.H.G1[e.id])&&(i.H.G1[e.id]=document.createDocumentFragment()),i.H.G1[e.id].appendChild(t)):e.appendChild(t)},VX:function(e,i,t,n,a){if(""!==t||a){var l,o,r,s,A,C,c;ZC.cache.data["svg-rect"]||(ZC.cache.data["svg-rect"]=ZC.Q.F6("rect","http://www.w3.org/2000/svg")),l=a?ZC.cache.data["svg-rect"].cloneNode(!0):ZC.Q.F6("path","http://www.w3.org/2000/svg");var u={};if(i.DH&&""!==i.DH&&(u["class"]=i.DH),a||(u.d=t),a){i.I<0&&(i.iX-=i.I,i.I=-i.I),i.F<0&&(i.iY+=i.F,i.F=-i.F);var p=0,Z=0,h=1;i.CZ&&(h=0,p=Z=i.AZ/2,0===i.iX&&(p=0),0===i.iY&&(Z=0)),0===h||i.I<=3||i.F<=3?(o=Math.floor(i.iX)+p,r=Math.floor(i.iY)+Z,s=Math.ceil(i.I)-2*p,A=Math.ceil(i.F)-2*p,C=i.F7,c=i.F7):(o=parseFloat(i.iX.toFixed(h))+p,r=parseFloat(i.iY.toFixed(h))+Z,s=parseFloat(i.I.toFixed(h))-2*p,A=parseFloat(i.F.toFixed(h))-2*Z,C=i.F7,c=i.F7),u.x=o,u.y=r,u.width=ZC.BQ(0,s),u.height=ZC.BQ(0,A),u.rx=C,u.ry=c,i.H&&(i.H.E[i.K+"-bounds"]=[u.x,u.y,u.x+u.width,u.y+u.height])}var d="";"undefined"==typeof i.K||""===i.K?"undefined"!=typeof i.H&&(d=i.H.GRAPHID+"-path-"+ZC.SEQ,ZC.SEQ++):d=i.K+"-path";var f,_="";if("undefined"!=typeof i.BL&&"undefined"!=typeof i.BH&&(0===i.BL&&0===i.BH||(_+="translate("+i.BL+" "+i.BH+")")),"undefined"!=typeof i.A9&&0!==i.A9){var g=i.A9;"undefined"!=typeof i.E.cx&&(g+=","+(ZC._x_(i.E.cx)-.5)),"undefined"!=typeof i.E.cy&&(g+=","+(ZC._x_(i.E.cy)-.5)),_+=" rotate("+g+")"}if(n&&-1!==i.E.fill?(u.fill=i.E.fill,u["fill-opacity"]=i.C6):u.fill="none",u["stroke-linecap"]=i.T1,u["stroke-linejoin"]=i.ZZ,i.AZ>0&&(u.stroke=i.B7,u["stroke-width"]=i.AZ,u["stroke-opacity"]=n?i.NY:i.C6,"solid"===i.GF||0===i.EX&&0===i.GA||("dashdot"===i.GF?u["stroke-dasharray"]=[i.EX,i.GA,i.AZ,i.GA].join(" "):u["stroke-dasharray"]=i.EX+","+i.GA)),l.id=d,""!==_&&(u.transform=_),i.o["fast-line"]&&i.AZ>0?(l.setAttribute("stroke",u.stroke),l.setAttribute("stroke-width",u["stroke-width"]),l.setAttribute("stroke-opacity",u["stroke-opacity"]),l.setAttribute("d",t)):ZC.Q.G3(l,u),ZC.CR._append_(e,i,l),(!i.E.border||"all"===i.E.border)&&"undefined"!=typeof i.E.imgfill)if("string"==typeof i.E.imgfill)ZC.AL(d+"-imgfill")||(f=a?ZC.Q.F6("rect","http://www.w3.org/2000/svg"):ZC.Q.F6("path","http://www.w3.org/2000/svg"),ZC.Q.G3(f,{id:d+"-imgfill",transform:_,fill:i.E.imgfill,"fill-opacity":i.C6}),a?ZC.Q.G3(f,{x:o,y:r,width:ZC.BQ(0,s),height:ZC.BQ(0,A),rx:C,ry:c}):ZC.Q.G3(f,{d:t}),ZC.CR._append_(e,i,f));else if(!ZC.AL(d+"-imgfill")){var v=i.E.imgfill,b=ZC.Q.F6("image","http://www.w3.org/2000/svg");b.setAttributeNS?"zc."===i.DA.substring(0,3)?b.setAttributeNS("http://www.w3.org/1999/xlink","href",ZC.IMAGES[i.DA]):b.setAttributeNS("http://www.w3.org/1999/xlink","href",i.DA):"zc."===i.DA.substring(0,3)?b.setAttribute("src",ZC.IMAGES[i.DA]):b.setAttribute("src",i.DA),null!==ZC._n_(i.E["clip-path"])&&ZC.Q.G3(b,{"clip-path":"url(#"+i.E["clip-path"]+")"}),ZC.Q.G3(b,{id:d+"-imgfill",x:v[1],y:v[2],"fill-opacity":i.C6,width:i.E["bg-image-width"],height:i.E["bg-image-height"],preserveAspectRatio:"none"}),ZC.CR._append_(e,i,b)}}},VW:function(e,i,t,n){var a,l,o,r,s,A;n&&(t+=" x e");var C="";"undefined"==typeof i.K||""===i.K?"undefined"!=typeof i.H&&(C=i.H.GRAPHID+"-path-"+ZC.SEQ,ZC.SEQ++):C=i.K+"-path";var c=ZC.Q.F6("zcv:shape");c.style.position="absolute",c.style.rotation=i.A9,c.id=C;var u=ZC.Q.F6("zcv:path");if(u.v=t,u.setAttribute("VMLv",t),c.appendChild(u),0===i.AZ)c.stroked=!1;else{var p=ZC.Q.F6("zcv:stroke");if(r=i.C6,"undefined"!=typeof i.E.A8J&&(r=i.E.A8J),"undefined"!=typeof i.E.stroke)l=i.E.stroke.weight,o=i.E.stroke.color,r=i.E.stroke.opacity,s=i.E.stroke.dashstyle;else{switch(s="solid",i.GF){case"solid":s="solid";break;case"dotted":s="dot";break;case"dashed":s="dash";break;default:s=i.GF}"solid"!==s&&"0 0"!=(a=ZC.CY(6,i.EX*i.AZ)+" "+ZC.CY(8,i.GA*i.AZ))&&(s=a),l=i.AZ,o=i.B7}ZC.Q.G3(p,{weight:l+"px",color:o,opacity:r,miterlimit:10,endcap:"flat",joinstyle:"round",dashstyle:s}),c.appendChild(p)}n&&"undefined"!=typeof i.E.fill&&-1!==i.E.fill?(c.filled=!0,c.appendChild(i.E.fill)):c.filled=!1,ZC.Q.G3(c,{coordorigin:"0 0",coordsize:i.A9%360==0?"100 100":i.H.I+" "+i.H.F});var Z=0,h=0;if(i.A9%360!=0&&"undefined"!=typeof i.E.cx&&"undefined"!=typeof i.E.cy){var d=i.H.I/2-i.E.cx,f=i.H.F/2-i.E.cy,_=0===f?0:ZC.TN(Math.atan(d/f));i.E.cy>i.H.F/2&&(_+=180);var g=Math.sqrt(d*d+f*f);Z=d-g*ZC.EO(_-i.A9),h=f-g*ZC.EH(_-i.A9)}var v=0-Z;null!==ZC._n_(i.BL)&&(v+=i.BL);var b=0-h;if(null!==ZC._n_(i.BH)&&(b+=i.BH),c.style.left=v+"px",c.style.top=b+"px",e.appendChild(c),i.A9%360==0?(c.style.width="10px",c.style.height="10px"):(c.style.width=i.H.I+"px",c.style.height=i.H.F+"px"),("all"===i.E.border||"undefined"!=typeof i.E.imgfill)&&"undefined"!=typeof i.E.imgfill){var B=i.E.imgfill;1===B.length?((c=ZC.Q.F6("zcv:shape")).style.position="absolute",c.style.rotation=i.A9,(u=ZC.Q.F6("zcv:path")).v=t,c.appendChild(u),c.appendChild(B[0]),c.stroked=!1,ZC.Q.G3(c,{id:C+"-imgfill",filled:!0,coordorigin:"0 0",coordsize:i.A9%360==0?"100 100":i.H.I+" "+i.H.F}),c.style.left=v+"px",c.style.top=b+"px",e.appendChild(c),i.A9%360==0?(c.style.width="10px",c.style.height="10px"):(c.style.width=i.H.I+"px",c.style.height=i.H.F+"px")):3===B.length&&((A=ZC.Q.F6("img")).id=C+"-img","zc."===i.DA.substring(0,3)?A.src=ZC.IMAGES[i.DA]:A.src=i.DA,A.style.position="absolute",A.style.left=B[1]+"px",A.style.top=B[2]+"px",A.style.width=i.E["bg-image-width"]+"px",A.style.height=i.E["bg-image-height"]+"px",e.appendChild(A))}}};var DT={$i:function(e){this.b(e);var i=this;i.A=e,i.Z=null,i.C7=null,i.H5="",i.iX=-1,i.iY=-1,i.DU="poly",i.D=[],i.D1=[0,0,0,0],i.A9=0,i.AI=0,i.JO=0,i.BL=0,i.BH=0,i.A9R=0,i.DV=0,i.B4=0,i.BK=360,i.CN=0,i.TJ=!1,i.ADA=!1,i.A5F=0,i.AAL="",i.O7=!1,i.A74=1,i.JS=1,i.EA=null,i.FC=null,i.IP="auto",i.K9=!1,i.A0Z="source-over",i.QP=!1},getPMap:function(){var e=this.b();return this.addPMap(e,"objectId,x,y,points,bounds,pieAngleStart,pieAngleEnd,pieSlice,url,target,offsetX,offsetY,offsetR,size,size2,angle,shape,flat,cursor","H5,iX,iY,D,D1,B4,BK,CN,EA,FC,BL,BH,DV,AI,JO,A9,DU,K9,IP"),e},build:function(){},copy:function(e){this.b(e);var i,t,n=this,a="BL,BH,DV,AI,JO,A9,DU,K9,IP".split(",");for(i=0,t=a.length;i<t;i++)"undefined"!=typeof e[a[i]]&&(n[a[i]]=e[a[i]]);if(e.D&&e.D.length>0)for(n.D=[],i=0,t=e.D.length;i<t;i++)n.D.push(e.D[i])},ll_:function(e,i){var t=this;-1!==(""+e).indexOf("lat")&&(i="y"),-1!==(""+e).indexOf("lon")&&(i="x"),e=ZC._f_((""+e).replace("lat","").replace("lon",""));var n=zingchart.maps.maps[t.A5F];return n&&(e=zingchart.maps.lonlat2xy(n._INFO_.x,n._INFO_.y,n._INFO_.width,n._INFO_.height,"x"===i?[e,0]:[0,e],n._INFO_.bbox,{map:t.A5F,item:t.AAL,zoom:n._INFO_.zoom,offsetX:n._INFO_.offsetX,offsetY:n._INFO_.offsetY},!0)),e=ZC._i_("x"===i?e[0]:e[1])},kv_:function(e,i){var t;-1!==(""+e).indexOf("val")&&(i="y"),-1!==(""+e).indexOf("key")&&(i="x"),e=ZC._f_((""+e).replace("key","").replace("val",""));var n=this.H||zingchart.HZ[0];if(n){var a=this.A||n.AG[0];a&&("x"===i?null!==(t=a.BU("k")[0])&&(e=ZC._i_(t.AT(e))):null!==(t=a.BU("v")[0])&&(e=ZC._i_(t.AT(e))))}return ZC._i_(e)},xy_:function(e,i,t){var n=this;i=i||"x";var a=""+e;if(-1!==a.indexOf("lat")||-1!==a.indexOf("lon"))return n.ll_(e,i);if(-1!==a.indexOf("val")||-1!==a.indexOf("key"))return n.kv_(e,i);if(""+ZC._f_(e)!==a)return-1!==(e+="").indexOf("%")?n.xy_(parseFloat(e.replace("%",""))/100,i,!0):-1!==e.indexOf("px")?n.xy_(parseFloat(e.replace("px","")),i):n.xy_(parseFloat(e),i);var l="undefined"!=typeof n.E["p-x"]?n.E["p-x"]:n.A.iX,o="undefined"!=typeof n.E["p-y"]?n.E["p-y"]:n.A.iY,r="undefined"!=typeof n.E["p-width"]?n.E["p-width"]:n.A.I,s="undefined"!=typeof n.E["p-height"]?n.E["p-height"]:n.A.F;return(e>=1||e<0||zingchart.DEV.IGNORESUBUNIT)&&!t?"x"===i?l+parseFloat(e):o+parseFloat(e):e>=0&&e<1||t?"x"===i?(r=r||1,Math.round(l+r*e)):(s=s||1,Math.round(o+s*e)):void 0},locate:function(e){var i,t=this;if(t.TJ)return-1!==(""+t.o.x).indexOf("lon")?t.iX=t.ll_(t.o.x,"x"):t.ZQ("x","iX"),-1!==(""+t.o.y).indexOf("lat")?t.iY=t.ll_(t.o.y,"y"):t.ZQ("y","iY"),void t.A3W();1===e?(null!==(i=ZC._n_(t.o.x))&&(t.iX=t.xy_(i,"x")),null!==(i=ZC._n_(t.o.y))&&(t.iY=t.xy_(i,"y")),-1===t.iX&&(t.iX=t.A.iX),-1===t.iY&&(t.iY=t.A.iY)):2===e&&(t.A3W(),t.I=t.D1[2]-t.D1[0],t.F=t.D1[3]-t.D1[1])},A3W:function(){var e,i=this,t=ZC.MAX,n=ZC.MAX,a=-ZC.MAX,l=-ZC.MAX;switch(i.DU){case"custom":t=0,n=0,a=0,l=0;break;case"circle":case"arc":case"pie":t=i.iX-i.AI,n=i.iY-i.AI,a=i.iX+i.AI,l=i.iY+i.AI;break;default:for(var o=0,r=i.D.length;o<r;o++)null!==(e=i.D[o])&&(t=Math.min(t,e[0]),n=Math.min(n,e[1]),a=Math.max(a,e[0]),l=Math.max(l,e[1]))}i.D1=[t,n,a,l]},FF:function(){var e,i=this;if("pie"===i.DU){var t=1,n=[],a=i.B4+i.A9,l=i.BK+i.A9,o=i.AI+Math.floor(i.AU/2),r=i.CN-Math.floor(i.AU/2);for(o>50&&(t=2),o>100&&(t=4),0===r?a%360!=l%360&&n.push([i.iX,i.iY]):n.push(ZC.AR.BN(i.iX,i.iY,r,a),ZC.AR.BN(i.iX,i.iY,(o+r)/2,a-.25*i.AU),ZC.AR.BN(i.iX,i.iY,o,a)),e=a;e<=l;e+=t)n.push(ZC.AR.BN(i.iX,i.iY,o,e));if(n.push(ZC.AR.BN(i.iX,i.iY,o,l)),n.push(ZC.AR.BN(i.iX,i.iY,(o+r)/2,l+.25*i.AU)),0===r)a%360!=l%360&&n.push([i.iX,i.iY]);else{for(n.push(ZC.AR.BN(i.iX,i.iY,r,l)),e=l;e>=a;e-=t)n.push(ZC.AR.BN(i.iX,i.iY,r,e));n.push(ZC.AR.BN(i.iX,i.iY,r,a))}return n.push([n[0][0],n[0][1]]),ZC.AR.PR(n,Math.min(5,o/5),[i.BL,i.BH])}if(0===i.A9||"rectangle"!==i.DU&&"rect"!==i.DU)return ZC.AR.PR(i.D,Math.min(5,i.AI/5),[i.BL,i.BH]);var s,A,C,c,u,p,Z,h,d=[];for(C=ZC._i_((i.D1[0]+i.D1[2])/2),c=ZC._i_((i.D1[1]+i.D1[3])/2),s=0,A=i.D.length;s<A;s++)null!==i.D[s]&&(u=i.D[s][0]-C,p=i.D[s][1]-c,Z=u*ZC.EH(i.A9)-p*ZC.EO(i.A9),h=u*ZC.EO(i.A9)+p*ZC.EH(i.A9),d[s]=[Z+C,h+c]);return ZC.AR.PR(d,Math.min(5,i.AI/5),[i.BL,i.BH])},A4Y:function(){var e,i,t,n,a,l,o,r,s,A=this,C=ZC.ie67?ZC.MAPTX:0;switch(A.DU){case"line":if(t=[].concat(A.D),0!==A.A9)for(n=(A.D1[0]+A.D1[2])/2,a=(A.D1[1]+A.D1[3])/2,e=0,i=t.length;e<i;e++)null!==t[e]&&(l=t[e][0]-n,o=t[e][1]-a,r=l*ZC.EH(A.A9)-o*ZC.EO(A.A9),s=l*ZC.EO(A.A9)+o*ZC.EH(A.A9),t[e]=[r+n,s+a]);var c=["poly"];for(e=0,i=t.length;e<i-1;e++)null!==t[e]&&null!==t[e+1]&&c.push(ZC.AR.PR(ZC.AR.Z0([t[e],t[e+1]]),4,[A.BL,A.BH]));return c;case"cross":case"plus":return["circle",ZC._i_(A.iX+C+A.BL)+","+ZC._i_(A.iY+C+A.BH)+","+ZC._i_(A.AI)];case"circle":case"arc":return["circle",ZC._i_(A.iX+C+A.BL)+","+ZC._i_(A.iY+C+A.BH)+","+ZC._i_(A.AI+2)];case"pie":return["poly",A.FF()];default:var u,p=["poly"];for(t=[],e=0,i=A.D.length;e<i;e++)if(null!==A.D[e])if(6===A.D[e].length)for(var Z=A.D[e][3];Z<A.D[e][4];Z+=1)t.push(ZC.AR.BN(A.D[e][0],A.D[e][1],A.D[e][2],Z));else if(4===A.D[e].length&&t[e-1]){var h={x:t[t.length-1][0],y:t[t.length-1][1]},d={x:A.D[e][2],y:A.D[e][3]},f={x:A.D[e][0],y:A.D[e][1]};for(u=0;u<=1;u+=.1)t.push([(1-u)*(1-u)*h.x+2*u*(1-u)*f.x+u*u*d.x,(1-u)*(1-u)*h.y+2*u*(1-u)*f.y+u*u*d.y])}else if(7===A.D[e].length&&t[e-1]){var _={x:t[t.length-1][0],y:t[t.length-1][1]},g={x:A.D[e][0],y:A.D[e][1]},v={x:A.D[e][2],y:A.D[e][3]},b={x:A.D[e][4],y:A.D[e][5]};for(u=0;u<=1;u+=.1){var B=(1-u)*(1-u)*(1-u),m=3*u*(1-u)*(1-u),E=3*u*u*(1-u),D=u*u*u;t.push([B*_.x+m*g.x+E*v.x+D*b.x,B*_.y+m*g.y+E*v.y+D*b.y])}}else t.push(A.D[e]);else t.length>-1&&p.push(ZC.AR.PR(t,Math.min(5,A.AI/5),[A.BL,A.BH])),t=[];if(0!==A.A9)for(n=ZC._i_((A.D1[0]+A.D1[2])/2),a=ZC._i_((A.D1[1]+A.D1[3])/2),e=0,i=t.length;e<i;e++)null!==t[e]&&(l=t[e][0]-n,o=t[e][1]-a,r=l*ZC.EH(A.A9)-o*ZC.EO(A.A9),s=l*ZC.EO(A.A9)+o*ZC.EH(A.A9),t[e]=[r+n,s+a]);return t.length>-1&&p.push(ZC.AR.PR(t,Math.min(5,A.AI/5),[A.BL,A.BH])),p}},parse:function(e){var i,t,n,a,l,o,r;null===ZC._n_(e)&&(e=!1),this.o.tween||e||this.b();var s=this;if(!s.o.tween&&!e){s.assign_a([["map","A5F"]]),"string"==typeof s.o.item&&s.assign_a([["item","AAL"]]),0!==s.A5F&&(null===ZC._n_(s.o["map-item"])||s.o["map-item"])&&(s.o["map-item"]=!0,s.o["map-skip-z-sort"]=!0);var A=["offset-x","offset-y"];for(t=0;t<2;t++){var C=A[t],c="offset-x"===C?"lon":"lat";if(null!==(i=s.o[C])&&void 0!==i&&-1!==(i=""+i).indexOf(c)){i=ZC._f_(i.replace(c,""));var u=zingchart.maps.maps[s.A5F];u&&(i=zingchart.maps.translate(C.replace("offset-"),i,s.A.I,s.A.F,u._INFO_.bbox),s.o[C]=i)}}for(s.assign_a([["url","EA"],["target","FC"],["cursor","IP"],["id","H5"],["angle","A9","i"],["static","K9","b"],["flat","K9","b"],["angle-start","B4","f"],["angle-end","BK","f"],["slice","CN","i"],["size","AI","f"],["size-2","JO","f"],["fast-vector-path","QP","b"],["type","DU"],["points","D"],["offset-x","BL"],["offset-y","BH"],["offset-z","A9R","i"],["offset-r","DV","i"],["z-sort","A74","i"],["z-index","JS","f"],["composite","A0Z"]]),s.BL=ZC.II(s.BL,!0),s.BH=ZC.II(s.BH,!0),s.BL>-1&&s.BL<1&&"undefined"!=typeof s.E["p-width"]&&(s.BL*=s.E["p-width"]),s.BH>-1&&s.BH<1&&"undefined"!=typeof s.E["p-height"]&&(s.BH*=s.E["p-height"]),s.AI=ZC.BQ(1,s.AI),s.JO=ZC.BQ(1,s.JO),null!==s.o["z-sort"]&&"undefined"!=typeof s.o["z-sort"]||(s.A74=s.JS),"rectangle"!==s.DU&&"rect"!==s.DU||s.assign_a([["width","AI","f"],["height","JO","f"]]),s.A59?(s.D=JSON.parse(JSON.stringify(s.FB)),s.A59=!1):s.FB=JSON.parse(JSON.stringify(s.D)),t=0,n=s.D.length;t<n;t++)if(null!==s.D[t])for(var p=0;p<s.D[t].length;p++)-1===(""+s.D[t][p]).indexOf("lat")&&-1===(""+s.D[t][p]).indexOf("lon")||(s.A59=!0,s.D[t][p]=s.ll_(s.D[t][p],p%2==0?"x":"y")),-1===(""+s.D[t][p]).indexOf("key")&&-1===(""+s.D[t][p]).indexOf("val")||(s.A59=!0,s.D[t][p]=s.kv_(s.D[t][p],p%2==0?"x":"y"))}if(s.o.tween=null,s.A9=s.A9%360,s.locate(1),"bar"!==s.DU){var Z=s.AI,h=s.JO;switch(s.DU){case"custom":break;case"triangle":Z=s.AI;var d=.1*s.AI;s.D=[[s.iX-Z,s.iY+Z-d],[s.iX,s.iY-Z-d],[s.iX+Z,s.iY+Z-d],[s.iX-Z,s.iY+Z-d]];break;case"square":Z=ZC._i_(.9*s.AI),s.D=[[s.iX-Z,s.iY-Z],[s.iX-Z,s.iY+Z],[s.iX+Z,s.iY+Z],[s.iX+Z,s.iY-Z],[s.iX-Z,s.iY-Z]];break;case"diamond":Z=ZC._i_(1.2*s.AI),h=ZC._i_(1.2*(1===s.JO?s.AI:s.JO)),s.D=[[s.iX-Z,s.iY],[s.iX,s.iY+h],[s.iX+Z,s.iY],[s.iX,s.iY-h],[s.iX-Z,s.iY]];break;case"trapezoid":s.D=[[s.iX-Z/2,s.iY+s.JO],[s.iX+Z/2,s.iY+s.JO],[s.iX+Z,s.iY-s.JO],[s.iX-Z,s.iY-s.JO],[s.iX-Z/2,s.iY+s.JO]];break;case"rectangle":case"rect":s.D=[[s.iX-Z/2,s.iY-s.JO/2],[s.iX+Z/2,s.iY-s.JO/2],[s.iX+Z/2,s.iY+s.JO/2],[s.iX-Z/2,s.iY+s.JO/2],[s.iX-Z/2,s.iY-s.JO/2]];break;case"parallelogram":s.D=[[s.iX-Z/2,s.iY-s.JO/2],[s.iX+3*Z/2,s.iY-s.JO/2],[s.iX+Z,s.iY+s.JO/2],[s.iX-Z,s.iY+s.JO/2],[s.iX-Z/2,s.iY-s.JO/2]];break;case"plus":Z=s.AI,s.D=[[s.iX,s.iY-Z],[s.iX,s.iY+Z],null,[s.iX-Z,s.iY],[s.iX+Z,s.iY]];break;case"cross":Z=s.AI,s.D=[[s.iX-Z,s.iY-Z],[s.iX+Z,s.iY+Z],null,[s.iX-Z,s.iY+Z],[s.iX+Z,s.iY-Z]];break;case"ic_line":Z=s.AI/4,s.D=[[s.iX-2*Z,s.iY+Z],[s.iX-Z,s.iY],[s.iX,s.iY+Z],[s.iX+Z,s.iY-Z],[s.iX+2*Z,s.iY]];break;case"ic_area":Z=s.AI/4,s.D=[[s.iX-2*Z,s.iY+2*Z],[s.iX-2*Z,s.iY+Z],[s.iX-Z,s.iY],[s.iX,s.iY+Z],[s.iX+Z,s.iY-Z],[s.iX+2*Z,s.iY],[s.iX+2*Z,s.iY+2*Z],[s.iX-2*Z,s.iY+2*Z]];break;case"ic_bars":s.CZ=!1,Z=s.AI/4,s.D=[[s.iX-2*Z,s.iY+2*Z],[s.iX-2*Z,s.iY-Z],[s.iX-Z,s.iY-Z],[s.iX-Z,s.iY+2*Z],[s.iX-2*Z,s.iY+2*Z],[s.iX-2*Z,s.iY+2*Z-Z],null,[s.iX-Z/2,s.iY+2*Z],[s.iX-Z/2,s.iY],[s.iX+Z/2,s.iY],[s.iX+Z/2,s.iY+2*Z],[s.iX-Z/2,s.iY+2*Z],[s.iX-Z/2,s.iY+2*Z-Z],null,[s.iX+2*Z,s.iY+2*Z],[s.iX+2*Z,s.iY-2*Z],[s.iX+Z,s.iY-2*Z],[s.iX+Z,s.iY+2*Z],[s.iX+2*Z,s.iY+2*Z],[s.iX+2*Z,s.iY+2*Z-Z]];break;case"arrow":Z=2*s.AI;var f=s.A9;s.A9=0;var _=ZC.AR.BN(s.iX,s.iY,Z,f-35),g=ZC.AR.BN(s.iX,s.iY,Z,f+35);s.D=[[s.iX,s.iY],_,null,[s.iX,s.iY],g];break;case"star3":case"star4":case"star5":case"star6":case"star7":case"star8":case"star9":for(s.D=[],Z=2*s.AI,l=360/(a=ZC._i_(s.DU.replace("star",""))),o=a%2==0?0:-90,r=Z/(a>4?2:7-a),t=0+o;t<360+o;t+=l)s.D.push(ZC.AR.BN(s.iX,s.iY,.75*Z,t),ZC.AR.BN(s.iX,s.iY,.75*r,t+l/2));s.D.push([s.D[0][0],s.D[0][1]]);break;case"rpoly3":case"rpoly4":case"rpoly5":case"rpoly6":case"rpoly7":case"rpoly8":case"rpoly9":for(s.D=[],Z=s.AI,l=360/(a=ZC._i_(s.DU.replace("rpoly",""))),o=a%2==0?0:-90,null!==ZC._n_(s.o["angle-offset"])&&(o=ZC._i_(s.o["angle-offset"])),t=0+o;t<360+o;t+=l)s.D.push(ZC.AR.BN(s.iX,s.iY,Z,t));s.D.push([s.D[0][0],s.D[0][1]]);break;case"gear3":case"gear4":case"gear5":case"gear6":case"gear7":case"gear8":case"gear9":for(s.D=[],Z=2*s.AI,l=360/(2*(a=ZC._i_(s.DU.replace("gear","")))),r=.75*Z,t=0+(o=a%2==0?0:-90);t<360+o;t+=2*l){var v=t+l/2;s.D.push(ZC.AR.BN(s.iX,s.iY,.75*Z,v),ZC.AR.BN(s.iX,s.iY,.75*Z,v+l),ZC.AR.BN(s.iX,s.iY,.75*r,v+l+0*l),ZC.AR.BN(s.iX,s.iY,.75*r,v+2*l-0*l))}s.D.push([s.D[0][0],s.D[0][1]]);break;case"hamburger":Z*=2;var b=s.iX,B=s.iY-10;s.D=s.D.concat([[b-Z/2,B-s.JO/2],[b+Z/2,B-s.JO/2],[b+Z/2,B+s.JO/2],[b-Z/2,B+s.JO/2],[b-Z/2,B-s.JO/2],null]),B+=5,s.D=s.D.concat([[b-Z/2,B-s.JO/2],[b+Z/2,B-s.JO/2],[b+Z/2,B+s.JO/2],[b-Z/2,B+s.JO/2],[b-Z/2,B-s.JO/2],null]),B+=5,s.D=s.D.concat([[b-Z/2,B-s.JO/2],[b+Z/2,B-s.JO/2],[b+Z/2,B+s.JO/2],[b-Z/2,B+s.JO/2],[b-Z/2,B-s.JO/2],null]);break;case"ellipse":for(s.CZ=!1,s.D=[],t=0;t<=360;t+=5)s.D.push([s.iX+s.AI*ZC.EH(t),s.iY+s.JO*ZC.EO(t)]);s.D.push([s.D[0][0],s.D[0][1]]);break;case"arc":s.CZ=!1,s.D=[ZC.AR.BN(s.iX,s.iY,s.AI,s.B4),[s.iX,s.iY,s.AI,s.B4,s.BK,0]];break;case"pie":for(var m=(s.o["pie-transform"]||"").split(/=|,/);s.B4<0||s.BK<0;)s.B4+=360,s.BK+=360;s.CZ=!1;var E=!1;-1!==ZC.AV(["svg","vml"],s.H.AB)&&s.B4%360==s.BK%360&&(s.B4+=.05,s.BK-=.05,E=!0);var D,F,K,x,I,y=s.iX,w=s.iY,L=ZC._x_(s.B4,2),X=ZC._x_(s.BK,2),Y=ZC._x_((L+X)/2,2),M=Z,H=s.CN,P=0===H&&L%360!=X%360&&!E;switch(s.D=[],"circle"!==m[0]&&(0===H?L%360==X%360||E||s.D.push([y,w]):s.D.push(ZC.AR.BN(y,w,H,L))),m[0]){case"flat":case"fold":s.D.push(ZC.AR.BN(y,w,M,L),ZC.AR.BN(y,w,M-("fold"===m[0]?ZC._i_(m[1]):0),X)),P||s.D.push(ZC.AR.BN(y,w,H,X));break;case"callout":s.D.push(ZC.AR.BN(y,w,M,L),[y,w,M,L,X,0]),P||(D=1.5*ZC._i_(m[1])*360/(2*Math.PI*M),s.D.push(ZC.AR.BN(y,w,M,X),ZC.AR.BN(y,w,H,X),[y,w,H,X,Y+D,1],ZC.AR.BN(y,w,H-ZC._i_(m[1]),Y),ZC.AR.BN(y,w,H,Y-D),[y,w,H,Y-D,L,1]));break;case"flow":D=ZC._i_(m[1]),x=ZC.AR.BN(y,w,(H+M)/2,L),99===D||-99===D?s.D.push([x[0],x[1],(M-H)/2,L+180,L,99===D?1:0]):s.D.push(ZC.AR.BN(y,w,(H+M)/2,L+D)),s.D.push(ZC.AR.BN(y,w,M,L),[y,w,M,L,X,0]),I=ZC.AR.BN(y,w,(H+M)/2,X),P?99===D||-99===D?s.D.push(ZC.AR.BN(y,w,M,X),[I[0],I[1],(M-H)/2,X,X+180,99===D?0:1]):s.D.push(ZC.AR.BN(y,w,(H+M)/2,X+D)):(99===D||-99===D?s.D.push([I[0],I[1],(M-H)/2,X,X+180,99===D?0:1]):s.D.push(ZC.AR.BN(y,w,(H+M)/2,X+D)),s.D.push(ZC.AR.BN(y,w,H,X),[y,w,H,X,L,1]));break;case"circle":var N=ZC._f_(m[1]||"1"),S=(5+ZC._a_(X-L)%360*50/360)*N;K=X%360==L%360||E?[y,w]:ZC.AR.BN(y,w,(M+H)/2,(L+X)/2),s.D.push(ZC.AR.BN(K[0],K[1],S,0),[K[0],K[1],S,0,360,0]);break;case"bite":D=ZC._i_(m[1]),F=ZC._i_(2*M*ZC.EO(D/2)),K=ZC.AR.BN(y,w,M,L),s.D.push(ZC.AR.BN(y,w,M-F,L),[K[0],K[1],F,L+180,L+90+(90-(180-D)/2),1],[y,w,M,L+D,X,0]),P||s.D.push(ZC.AR.BN(y,w,H,X),[y,w,H,X,L,1]);break;case"droplet":for(var O=M,G=1,k=0;M*G+k>=O;)G=ZC._x_(G-.02,2),F=ZC._i_(M*G/ZC.EH((X-L)/2)),k=ZC._i_(M*G*Math.tan(ZC.T8((X-L)/2)));K=ZC.AR.BN(y,w,F,Y),s.D.push(ZC.AR.BN(y,w,M*G,L),[K[0],K[1],k,Y-(360-(180-(X-L)))/2,Y+(360-(180-(X-L)))/2,0]),P||s.D.push(ZC.AR.BN(y,w,H,X),[y,w,H,X,L,1]);break;default:s.D.push(ZC.AR.BN(y,w,M,L),[y,w,M,L,X,0]),0===H?L%360==X%360||E||s.D.push([y,w]):s.D.push(ZC.AR.BN(y,w,M,X),ZC.AR.BN(y,w,H,X),[y,w,H,X,L,1])}s.D.push([s.D[0][0],s.D[0][1]])}}s.locate(2)},paint:function(){var e=this;if("none"!==e.DU&&("custom"===e.DU||"circle"===e.DU||"arc"===e.DU||0!==e.D.length)){var i,t,n={x:"iX",y:"iY",width:"I",height:"F",size:"AI"};if(e.o["bottom-state"]&&!e.Y6&&!e.VN&&!e.bIsBottom){var a=new ZC.DT(e.A);for(i in a.copy(e),a.bIsBottom=!0,a.M8=!1,a.Z=e.Z,a.append({x:e.iX-e.A.iX,y:e.iY-e.A.iY}),a.append(e.o["bottom-state"]),a.K=e.K+"-bottom",a.parse(),t=!1,n)null===ZC._n_(a.o[i])||-1===(""+a.o[i]).indexOf("+")&&-1===(""+a.o[i]).indexOf("-")||(a.o[i]=a[n[i]]=e[n[i]]+ZC._i_(a.o[i]),t=!0);t&&a.parse(),a.paint()}var l=e.H.AB;switch(e.M8&&e.C7&&e.A9Y(),l){case"canvas":e.A1V();break;case"svg":e.VX();break;case"vml":e.VW()}if(e.o["top-state"]&&!e.Y6&&!e.VN&&!e.bIsBottom){var o=new ZC.DT(e.A);for(i in o.copy(e),o.VN=!0,o.M8=!1,o.Z=e.Z,o.append({x:e.iX-e.A.iX,y:e.iY-e.A.iY}),o.append(e.o["top-state"]),o.K=e.K+"-top",o.parse(),t=!1,n)null===ZC._n_(o.o[i])||-1===(""+o.o[i]).indexOf("+")&&-1===(""+o.o[i]).indexOf("-")||(o.o[i]=o[n[i]]=e[n[i]]+ZC._i_(o.o[i]),t=!0);t&&o.parse(),o.paint()}}},A9Y:function(){var e,i=this,t=new ZC.DT(i.A);t.K=i.K+"-sh",t.copy(i),t.O7=i.O7,t.Z=i.C7,t.M8=!1,t.Y6=!0,t.A0=t.AE=t.RZ,t.GR=t.HN="",t.DA="",t.GF="solid",t.BW=t.RZ,t.AZ=0,t.C6=t.T6*i.C6,t.K=i.K+"-sh";var n=(i.JV-i.P7)*ZC.EH(i.OH)+i.P7,a=(i.JV-i.P7)*ZC.EO(i.OH)+i.P7;if(t.iX=i.iX+parseInt(n,10),t.iY=i.iY+parseInt(a,10),t.AI=i.AI+i.P7,i.D.length>0){e=[];for(var l=0,o=i.D.length;l<o;l++)if(null!==i.D[l]){for(var r=[],s=0;s<i.D[l].length;s++)r[s]=i.D[l][s];r[0]=i.D[l][0]+parseInt(n,10),r[1]=i.D[l][1]+parseInt(a,10),e.push(r)}else e.push(null)}t.D1=[i.D1[0]+n,i.D1[1]+a,i.D1[2]+n,i.D1[3]+a],t.D=e,t.paint()},A1I:function(){var e=this;return{lc:"-1"===e.B7?"rgba(255,255,255,0)":1===e.C6?e.B7:ZC.AP.A32(ZC.AP.G9(e.B7),e.C6),bc:"-1"===e.BW?"rgba(255,255,255,0)":1===e.NY?e.BW:ZC.AP.A32(ZC.AP.G9(e.BW),e.NY),bgc1:"-1"===e.A0?"rgba(255,255,255,0)":1===e.C6?e.A0:ZC.AP.A32(ZC.AP.G9(e.A0),e.C6),bgc2:"-1"===e.AE?"rgba(255,255,255,0)":1===e.C6?e.AE:ZC.AP.A32(ZC.AP.G9(e.AE),e.C6)}},YD:function(e){var i,t,n,a=this;switch(a.DU){case"circle":case"arc":case"pie":i=a.iX,t=a.iY,n=a.AI;break;default:i=a.D1[0]+(a.D1[2]-a.D1[0])/2,t=a.D1[1]+(a.D1[3]-a.D1[1])/2,n=ZC._a_(ZC.EH(a.N9)*(a.D1[2]-a.D1[0])/2+ZC.EO(a.N9)*(a.D1[3]-a.D1[1])/2)}ZC.P8(i)||(i=0),ZC.P8(t)||(t=0),ZC.P8(n)||(n=0);var l=a.VO,o=a.W5;if(ZC._a_(l)<=1&&(l=l*(a.D1[2]-a.D1[0])/2),ZC._a_(o)<=1&&(o=o*(a.D1[3]-a.D1[1])/2),i+=l,t+=o,"radial"===e)return{cx:i,cy:t,r:ZC._a_(n)};if("linear"===e){var r=n*ZC.EH(a.N9),s=n*ZC.EO(a.N9),A=i-r,C=t-s,c=i+r,u=t+s;return ZC._i_(C)===ZC._i_(u)&&ZC._a_(c-A)<5&&(u+=1),ZC._i_(A)===ZC._i_(c)&&ZC._a_(u-C)<5&&(c+=1),{x1:A,y1:C,x2:c,y2:u}}},RD:function(){var e,i,t,n,a,l,o,r=this;switch(ZC.cache.data[r.DA]?e=ZC.cache.data[r.DA]:((e=new Image).src=r.DA,ZC.cache.data[r.DA]=e),1!==r.KS&&(e._width_?(e.width=e._width_,e.height=e._height_):(e._width_=e.width,e._height_=e.height)),i=e.width*r.KS,t=e.height*r.KS,r.WN){case"x":i=r.I;break;case"y":t=r.F;break;case"xy":case"both":i=r.I,t=r.F}var s=r.TA.split(" "),A=s[0]||"",C=0,c=0;switch(A){case"":case"left":n=0,C=0;break;case"center":n=(r.I-i)/2,C=.5;break;case"right":n=r.I-i,C=1;break;default:-1!==A.indexOf("%")?(C=ZC._i_(A.replace(/[^0-9\-]/g,""))/100,n=(r.I-i)*C):(C=ZC._i_(A.replace(/[^0-9\-]/g,""))/r.I,n=ZC._i_(A.replace(/[^0-9\-]/g,"")))}l=n/r.I,"undefined"!=typeof r.KT?n+=r.iX+r.BL:n+=r.D1[0]+r.BL;var u=s[1]||"";switch(u){case"":case"top":a=0,c=0;break;case"middle":a=(r.F-t)/2,c=.5;break;case"bottom":a=r.F-t,c=1;break;default:-1!==u.indexOf("%")?(c=ZC._i_(u.replace(/[^0-9\-]/g,""))/100,a=(r.F-t)*c):(c=ZC._i_(u.replace(/[^0-9\-]/g,""))/r.F,a=ZC._i_(u.replace(/[^0-9\-]/g,"")))}if(o=a/r.F,"undefined"!=typeof r.KT?a+=r.iY+r.BH:a+=r.D1[1]+r.BH,"pie"===r.DU){var p=r.A9+r.B4+(r.BK-r.B4)*C,Z=ZC.AR.BN(r.iX,r.iY,r.CN+(r.AI-r.CN)*c,p);n=Z[0]-e.width/2,a=Z[1]-e.height/2}return r.E["bg-image-width"]=i,r.E["bg-image-height"]=t,{image:e,x:ZC._i_(n)+.5,y:ZC._i_(a)+.5,cx:ZC._f_(l),cy:ZC._f_(o),hPos:C,vPos:c}},ZH:function(e){for(var i=this,t=i.GR.split(/\s+|;/),n=i.HN.split(/\s+|;/),a=0,l=t.length;a<l;a++){var o=ZC.AP.G9(t[a],i);"object"!=typeof o&&(o=[o,i.C6]);var r=ZC.AP.A32(o[0],o[1]),s=ZC._f_(n[a]||"1");ZC.DS(s,0,1)||(s=1),e.addColorStop(s,r)}},A1V:function(){var e,i,t,n,a,l,o,r,s=this,A=s.Z.getContext("2d");A.save(),"poly"===s.DU||"line"===s.DU?(i=s.D1[0]+(s.D1[2]-s.D1[0])/2,t=s.D1[1]+(s.D1[3]-s.D1[1])/2):(i=s.iX,t=s.iY);var C=s.A1I(),c=C.lc,u=C.bc,p=C.bgc1,Z=C.bgc2;if(p!==Z||""!==s.GR&&""!==s.HN){var h=s.YD(s.NI);"radial"===s.NI?n=A.createRadialGradient(h.cx,h.cy,1,h.cx,h.cy,h.r):"linear"===s.NI&&(n=A.createLinearGradient(h.x1,h.y1,h.x2,h.y2)),""!==s.GR&&""!==s.HN?s.ZH(n):(n.addColorStop(0,p),n.addColorStop(1,Z)),A.fillStyle=n}else""!==s.DA&&-1!==ZC.AV(["repeat","true",!0],s.M2)&&"-1"===s.A0&&"-1"===s.AE&&(p="rgba(255,255,255,0)"),A.fillStyle=p;switch(s.DU){case"custom":if((e=s.o.url)&&(ZC.cache.data[e]?a=ZC.cache.data[e]:((a=new Image).src=e,ZC.cache.data[e]=a),a.width=s.o.width?s.o.width:a.width,a.height=s.o.height?s.o.height:a.height,A.drawImage(a,s.iX-a.width/2+s.BL,s.iY-a.height/2+s.BH,a.width,a.height),0===p.indexOf("#")&&7===p.length)){for(var d=parseInt(p.substring(1,3),16),f=parseInt(p.substring(3,5),16),_=parseInt(p.substring(5,7),16),g=A.getImageData(s.iX-a.width/2+s.BL,s.iY-a.height/2+s.BH,a.width,a.height),v=0;v<g.data.length;v+=4)g.data[v]=d|g.data[v],g.data[v+1]=f|g.data[v+1],g.data[v+2]=_|g.data[v+2];A.putImageData(g,s.iX-a.width/2+s.BL,s.iY-a.height/2+s.BH)}break;case"plus":case"cross":case"line":case"ic_line":case"arc":A.strokeStyle=c,A.lineWidth=s.AZ;break;default:A.strokeStyle=u,A.lineWidth=s.AU}0!==s.A9&&(A.translate(i,t),isNaN(s.A9)||A.rotate(ZC.T8(s.A9)),A.translate(-i,-t));var b=-1===ZC.AV(["cross","plus","arc","line","ic_line"],s.DU);switch(isNaN(s.BL)||isNaN(s.BH)||0===s.BL&&0===s.BH||!b&&"arc"!==s.DU||A.translate(s.BL,s.BH),A.beginPath(),s.DU){case"circle":case"arc":A.setLineDash&&"circle"===s.DU&&(s.KY(s.AU),A.setLineDash(0===s.EX||0===s.GA?[]:[s.EX,s.GA])),A.arc(s.iX,s.iY,s.AI,ZC.T8(s.B4),ZC.T8(s.BK),!1);break;case"line":break;default:-1!==ZC.AV(["square","plus"],s.DU)&&(s.N5=!0),ZC.CR.contour(A,s,s.D),-1!==ZC.AV(["square","plus"],s.DU)&&(s.N5=!1)}if(A.globalCompositeOperation=s.A0Z,b)if(""!==s.DA&&-1===ZC.AV(ZC.IMG404,s.DA)){var B;A.fill(),A.save(),A.clip(),B=A.globalAlpha,A.globalAlpha=s.C6;var m=s.RD();switch(a=m.image,s.M2){case"repeat":case!0:case"true":l=s.D1[0]-(a.width-(s.D1[2]-s.D1[0]))/2,o=s.D1[1]-(a.height-(s.D1[3]-s.D1[1]))/2,A.translate(l,o),r=A.createPattern(a,"repeat"),A.fillStyle=r,A.fill(),A.translate(-l,-o);break;case"no-repeat":case!1:case"false":A.drawImage(a,m.x-s.BL,m.y-s.BH,s.E["bg-image-width"],s.E["bg-image-height"])}A.globalAlpha=B,A.restore()}else A.fill();switch(A.closePath(),A.beginPath(),s.DU){case"circle":case"arc":A.arc(s.iX,s.iY,s.AI,ZC.T8(s.B4),ZC.T8(s.BK),!1),("circle"===s.DU&&s.AU>0||"arc"===s.DU&&s.AZ>0)&&A.stroke(),A.closePath();break;case"plus":case"cross":case"line":case"ic_line":s.AZ>0&&(ZC.CR.setup(A,s),s.o.spline?(s.CZ=!1,s.QP=!0,ZC.CR.paint(A,s,ZC.CR.smooth(s.D,!1,s.o.direction||"h"))):ZC.CR.paint(A,s,s.D));break;default:if(s.AU>0){var E=s.B7,D=s.AZ;s.B7=s.BW,s.AZ=s.AU,s.KY(),ZC.CR.setup(A,s),ZC.CR.paint(A,s,s.D,!0),s.B7=E,s.AZ=D,s.KY()}A.closePath()}A.restore()},A2O:function(e){var i=this,t=e.info,n=t.image,a=!0;switch(i.M2){default:a=!0;break;case"no-repeat":case"false":case!1:a=!1}var l=i.DA;0===n.src.indexOf("data:")&&(l=n.src),n.width*=i.KS,n.height*=i.KS;var o=""===i.K?"pattern-"+ZC.SEQ++:i.K+"-pattern";ZC.Q.EU(o);var r=ZC.Q.F6("image","http://www.w3.org/2000/svg");r.setAttributeNS?r.setAttributeNS("http://www.w3.org/1999/xlink","href",l):r.setAttribute("src",l),ZC.Q.G3(r,{id:o+"-image",preserveAspectRatio:"none",width:i.E["bg-image-width"],height:i.E["bg-image-height"]});var s=n.width,A=n.height;if(!a){var C,c;s=A=1,i.I>0&&i.F>0?(C=i.I,c=i.F):(C=i.D1[2]-i.D1[0],c=i.D1[3]-i.D1[1]);var u=ZC._i_(C*t.cx),p=ZC._i_(c*t.cy);if("pie"===i.DU){s=i.H?i.H.I:i.A.I,A=i.H?i.H.F:i.A.F;var Z=i.A9+i.B4+(i.BK-i.B4)*t.hPos,h=ZC.AR.BN(i.iX,i.iY,i.CN+(i.AI-i.CN)*t.vPos,Z);u=h[0]-n.width/2,p=h[1]-n.height/2}i.E["pattern-image-id"]=o+"-image",i.E["pattern-tx"]=u,i.E["pattern-ty"]=p,ZC.Q.G3(r,{transform:"translate("+u+","+p+")"})}var d=ZC.Q.F6("pattern","http://www.w3.org/2000/svg");ZC.Q.G3(d,{x:a?e.x:0,y:a?e.y:0,width:s,height:A,id:o,patternUnits:a||"pie"===i.DU?"userSpaceOnUse":"objectBoundingBox"}),i.H.KD.childNodes[0].appendChild(d),d.appendChild(r),i.E.imgfill="url(#"+o+")"},WZ:function(e){null!==e&&void 0!==e||(e=!1);var i,t,n=this;if(n.A0!==n.AE||""!==n.GR&&""!==n.HN){var a=""===n.K?"gradient-"+ZC.SEQ++:n.K+"-gradient";(n.TJ||e&&!ZC.AL(a))&&(e=!1),ZC.A4.browser.msie&&9===ZC._i_(ZC.A4.browser.version)&&(e=!1),ZC.AL(a)&&!e&&ZC.Q.EU(a);var l=n.YD(n.NI);if("radial"===n.NI?(i=e?ZC.AL(a):ZC.Q.F6("radialGradient","http://www.w3.org/2000/svg"),ZC.Q.G3(i,{cx:ZC._i_(l.cx),cy:ZC._i_(l.cy),r:ZC._i_(l.r),fx:ZC._i_(l.cx),fy:ZC._i_(l.cy)})):"linear"===n.NI&&(i=e?ZC.AL(a):ZC.Q.F6("linearGradient","http://www.w3.org/2000/svg"),ZC.Q.G3(i,{x1:ZC._i_(l.x1),x2:ZC._i_(l.x2),y1:ZC._i_(l.y1),y2:ZC._i_(l.y2)})),!e){if(ZC.Q.G3(i,{id:a,gradientUnits:"userSpaceOnUse"}),n.H.KD.childNodes[0].appendChild(i),""!==n.GR&&""!==n.HN)for(var o=n.GR.split(/\s+|;/),r=n.HN.split(/\s+|;/),s=0,A=o.length;s<A;s++){var C=ZC.AP.G9(o[s],n);"object"!=typeof C&&(C=[C,n.C6]),o[s]=C[0];var c=r[s]||1;ZC.DS(c,0,1)||(c=1);var u=C[1];t=o[s],"-1"===o[s]&&(u=0,t="rgb(255,255,255)");var p=ZC.Q.F6("stop","http://www.w3.org/2000/svg");ZC.Q.G3(p,{offset:c,"stop-color":t,"stop-opacity":u}),i.appendChild(p)}else{var Z=1,h=n.A0;"-1"===n.A0&&(Z=0,h="rgb(255,255,255)");var d=ZC.Q.F6("stop","http://www.w3.org/2000/svg");ZC.Q.G3(d,{offset:0,"stop-color":h,"stop-opacity":Z});var f=1,_=n.AE;"-1"===n.AE&&(f=0,_="rgb(255,255,255)");var g=ZC.Q.F6("stop","http://www.w3.org/2000/svg");ZC.Q.G3(g,{offset:1,"stop-color":_,"stop-opacity":f}),i.appendChild(d),i.appendChild(g)}n.E.fill="url(#"+a+")"}}else"-1"!==n.A0&&(n.E.fill=n.A0)},A3G:function(){var e=this;if("object"==typeof e.E.imgfill&&"undefined"!=typeof e.H&&e.H){var i=e.A4Y()[1].split(",");if("circle"===e.DU)e.H.KD.appendChild(ZC.Q.XD({id:e.K+"_image-clip",cx:i[0],cy:i[1],r:i[2]})),e.E["clip-path"]=e.K+"_image-clip";else if(i.length>6){for(var t="",n=0,a=i.length;n<a;n+=2)t+=ZC._i_(i[n])+ZC._i_(e.BL)+","+(ZC._i_(i[n+1])+ZC._i_(e.BH))+" ";e.H.KD.appendChild(ZC.Q.XD({id:e.K+"_image-clip",path:t})),e.E["clip-path"]=e.K+"_image-clip"}}},VX:function(){var e,i,t,n,a,l,o=this,r=o.Z;if("poly"===o.DU||"line"===o.DU?(i=o.D1[0]+(o.D1[2]-o.D1[0])/2,t=o.D1[1]+(o.D1[3]-o.D1[1])/2):(i=o.iX,t=o.iY),o.E.cx=i,o.E.cy=t,o.E.fill=-1,""!==o.DA){var s=o.RD();o.A2O({info:s,x:i-s.image.width/2,y:t-s.image.height/2})}switch(o.VH&&o.A3G(),o.WZ(),o.DU){case"custom":if(e=o.o.url){var A,C;ZC.cache.data[e]?n=ZC.cache.data[e]:((n=new Image).src=e,ZC.cache.data[e]=n),(A=e.indexOf(".svg")>0&&e.indexOf("#")>=0)?(C=ZC.Q.F6("svg","http://www.w3.org/2000/svg"),ZC.Q.G3(C,{viewBox:"0 0 8 8",fill:o.E.fill}),l=ZC.Q.F6("use","http://www.w3.org/2000/svg")):l=ZC.Q.F6("image","http://www.w3.org/2000/svg"),l.setAttributeNS?l.setAttributeNS("http://www.w3.org/1999/xlink","href",e):l.setAttribute("src",e);var c=o.o.width?o.o.width:n.width,u=o.o.height?o.o.height:n.height;n.width=c,n.height=u,A?ZC.Q.G3(C,{id:o.K+"-image",x:o.iX-n.width/2+o.BL,y:o.iY-n.height/2+o.BH,width:n.width,height:n.height}):ZC.Q.G3(l,{id:o.K+"-image",x:o.iX-n.width/2+o.BL,y:o.iY-n.height/2+o.BH,width:n.width,height:n.height}),A?(C.appendChild(l),r.appendChild(C)):r.appendChild(l)}break;case"circle":if(!ZC.AL(o.K+"-circle")&&(a=ZC.Q.F6("circle","http://www.w3.org/2000/svg"),-1!==o.E.fill?ZC.Q.G3(a,{fill:o.E.fill,"fill-opacity":o.C6}):ZC.Q.G3(a,{fill:"none"}),o.DH&&""!==o.DH&&ZC.Q.G3(a,{"class":o.DH}),ZC.Q.G3(a,{id:o.K+"-circle",cx:o.iX+o.BL,cy:o.iY+o.BH,r:o.AI}),o.AU>0&&(ZC.Q.G3(a,{stroke:o.BW,"stroke-width":o.AU,"stroke-opacity":o.NY}),o.KY(o.AU),"solid"===o.GF||0===o.EX&&0===o.GA||ZC.Q.G3(a,{"stroke-dasharray":"dashdot"===o.GF?[o.EX,o.GA,o.AZ,o.GA].join(" "):[o.EX,o.GA].join(",")})),o.H&&o.H.G1?(o.H.G1[r.id]||(o.H.G1[r.id]=document.createDocumentFragment()),o.H.G1[r.id].appendChild(a)):r.appendChild(a),"undefined"!=typeof o.E.imgfill))if("string"==typeof o.E.imgfill)a=ZC.Q.F6("circle","http://www.w3.org/2000/svg"),ZC.Q.G3(a,{id:o.K+"-imgfill",fill:o.E.imgfill,"fill-opacity":o.C6,cx:o.iX+o.BL,cy:o.iY+o.BH,r:o.AI,"stroke-width":0}),o.H&&o.H.G1?o.H.G1[r.id].appendChild(a):r.appendChild(a);else{var p=o.E.imgfill;(l=ZC.Q.F6("image","http://www.w3.org/2000/svg")).setAttributeNS&&l.setAttributeNS("http://www.w3.org/1999/xlink","href",o.DA),o.E["clip-path"]&&ZC.Q.G3(l,{"clip-path":"url(#"+o.E["clip-path"]+(ZC.A4.browser.webkit?"-shape":"")+")"}),ZC.Q.G3(l,{id:o.K+"-imgfill",x:p[1],y:p[2],width:p[0].width,height:p[0].height}),r.appendChild(l)}break;case"plus":case"cross":case"line":case"ic_line":case"arc":o.AZ>0&&(ZC.CR.setup(r,o),o.o.spline?(o.CZ=!1,o.QP=!0,ZC.CR.paint(r,o,ZC.CR.smooth(o.D,!1,o.o.direction||"h"))):ZC.CR.paint(r,o,o.D));break;default:var Z=o.B7,h=o.AZ;o.B7=o.BW,o.AZ=o.AU,o.KY(),ZC.CR.setup(r,o),ZC.CR.paint(r,o,o.D,!0,0),o.B7=Z,o.AZ=h,o.KY()}},WY:function(e,i){null!==i&&void 0!==i||(i=!1);var t,n=this;if(n.A0!==n.AE||""!==n.GR&&""!==n.HN){var a=""===n.K?"gradient-"+ZC.SEQ++:n.K+"-gradient";if(i&&!ZC.AL(a)&&(i=!1),ZC.AL(a)&&!i&&ZC.A4(a).remove(),t=i?ZC.AL(a):ZC.Q.F6("zcv:fill"),i&&(e=ZC.A4("#"+a).attr("focusposition")),""!==n.GR&&""!==n.HN){for(var l=n.GR.split(/\s+|;/),o=n.HN.split(/\s+|;/),r="",s="",A="",C=0,c=l.length;C<c;C++){l[C]=ZC.AP.G9(l[C]);var u="-1"===l[C]?"rgb(255,255,255)":l[C],p=o[C]||1;ZC.DS(p,0,1)||(p=1);var Z=ZC._i_(100*p);0===C?r=u:C===c-1?s=u:A+=Z+"% "+ZC.AP.G9(u)+","}""!==A&&(A=A.substring(0,A.length-1)),"radial"===n.NI?ZC.Q.G3(t,{id:a,type:"gradientradial",focusposition:e,color:r,color2:s,colors:A}):"linear"===n.NI&&ZC.Q.G3(t,{id:a,type:"gradient",method:"sigma",angle:270-n.N9-n.A9,color:r,color2:s,colors:A})}else{var h=n.A0;"-1"===n.A0&&(h="rgb(255,255,255)");var d=n.AE;"-1"===n.AE&&(d="rgb(255,255,255)"),"radial"===n.NI?ZC.Q.G3(t,{id:a,type:"gradientradial",focusposition:e,color:d,color2:h}):"linear"===n.NI&&ZC.Q.G3(t,{id:a,type:"gradient",method:"sigma",angle:270-n.N9-n.A9,color:h,color2:d})}var f="undefined"!=typeof n.E.opacity2?n.E.opacity2:n.C6;ZC.Q.G3(t,{opacity:n.C6,"o:opacity2":f}),n.E.fill=t}else t=ZC.Q.F6("zcv:fill"),"-1"!==n.A0&&(ZC.Q.G3(t,{type:"solid",color:n.A0,opacity:n.C6}),n.E.fill=t)},VW:function(){var e,i,t,n,a,l,o=this,r=o.Z;"poly"===o.DU||"line"===o.DU?(i=o.D1[0]+(o.D1[2]-o.D1[0])/2,t=o.D1[1]+(o.D1[3]-o.D1[1])/2):(i=o.iX,t=o.iY),o.E.cx=i,o.E.cy=t,o.E.fill=-1;var s=-1===ZC.AV(["cross","plus","arc","line","ic_line"],o.DU),A=ZC.Q.F6("zcv:fill");if(""!==o.DA){var C=o.RD();switch(n=C.image,o.M2){default:A.type="tile",A.src=o.DA,ZC.Q.G3(A,{position:C.cx+","+C.cy,opacity:o.C6,"o:opacity2":o.C6}),o.E.imgfill=[A];break;case"no-repeat":case"false":case!1:o.E.imgfill=[n,C.x,C.y]}}o.WY("0,0");var c=ZC.Q.F6("zcv:stroke");switch(o.DU){case"custom":(e=o.o.url)&&(ZC.cache.data[e]?n=ZC.cache.data[e]:((n=new Image).src=e,ZC.cache.data[e]=n),(l=ZC.Q.F6("img")).id=o.K+"-img",l.src=e,l.style.position="absolute",1!==o.KS&&(l.width*=o.KS,l.height*=o.KS,l.style.width=l.width+"px",l.style.height=l.height+"px"),l.style.left=o.iX-n.width/2+o.BL+"px",l.style.top=o.iY-n.height/2+o.BH+"px",r.appendChild(l));break;case"plus":case"cross":case"line":case"ic_line":case"arc":c.weight=o.AZ+"px",c.color=o.B7;break;default:c.weight=o.AU+"px",c.color=o.BW}switch(c.opacity=o.NY,o.GF){case"solid":c.dashstyle="solid";break;case"dotted":c.dashstyle="dot";break;case"dashed":c.dashstyle="dash"}switch(-1===ZC.AV(["plus","cross","line","ic_line"],o.DU)&&(o.E.stroke=c),o.DU){case"circle":case"arc":if(!ZC.AL(o.K+"-circle")&&((a=ZC.Q.F6("circle"===o.DU?"zcv:oval":"zcv:arc")).id=o.K+"-circle",a.style.position="absolute",-1!==o.E.fill&&s?a.appendChild(o.E.fill):a.filled=!1,o.AU>0||o.AZ>0?a.appendChild(c):a.stroked=!1,a.style.left=o.iX+o.BL-o.AI+"px",a.style.top=o.iY+o.BH-o.AI+"px",a.style.width=2*o.AI+"px",a.style.height=2*o.AI+"px","arc"===o.DU&&ZC.Q.G3(a,{startangle:o.BK+90,endangle:o.B4+90}),r.appendChild(a),s&&"undefined"!=typeof o.E.imgfill)){var u=o.E.imgfill;1===u.length?((a=ZC.Q.F6("zcv:oval")).id=o.K+"-imgfill",a.style.position="absolute",r.appendChild(a),a.appendChild(u[0]),a.style.left=o.iX+o.BL-o.AI+"px",a.style.top=o.iY+o.BH-o.AI+"px",a.style.width=2*o.AI+"px",a.style.height=2*o.AI+"px",a.stroked=!1,"arc"===o.DU&&ZC.Q.G3(a,{startangle:o.BK+90,endangle:o.B4+90})):3===u.length&&((l=ZC.Q.F6("img")).id=o.K+"-img",l.src=o.DA,l.style.position="absolute",l.style.left=u[1]+"px",l.style.top=u[2]+"px",1!==o.KS&&(l.width*=o.KS,l.height*=o.KS,l.style.width=l.width+"px",l.style.height=l.height+"px"),r.appendChild(l))}break;case"plus":case"cross":case"line":case"ic_line":o.AZ>0&&(ZC.CR.setup(r,o),o.o.spline?(o.CZ=!1,o.QP=!0,ZC.CR.paint(r,o,ZC.CR.smooth(o.D,!1,o.o.direction||"h"))):ZC.CR.paint(r,o,o.D));break;default:var p=o.B7,Z=o.AZ;o.B7=o.BW,o.AZ=o.AU,o.KY(),ZC.CR.setup(r,o),ZC.CR.paint(r,o,o.D,!0,0),o.B7=p,o.AZ=Z,o.KY()}}};ZC.DT=ZC.D0.CA(DT);var HL={$i:function(e){this.b(e);var i=this;i.DU="box",i.I=0,i.F=0,i.A8L="",i.E8=-1,i.E9=-1,i.DR=-1,i.DY=-1,i.F7=0,i.FS=0,i.F2=0,i.FE=0,i.A79=!1,i.KT=!1,i.EM="bottom",i.EW=0,i.M3=0,i.H9=8,i.G8=8,i.XN=[1,1],i.DM=null,i.OK=null,i.PU=!1,i.N5=!0,i.PX="",i.OJ="",i.NN="",i.P4="",i.WV="tl",i.FD=!1},getPMap:function(){var e=this.b();return this.addPMap(e,"width,height,borderRadiusTopLeft,borderRadiusTopRight,borderRadiusBottomRight,borderRadiusBottomLeft,callout,calloutType,calloutPosition,calloutHook,calloutWidth,calloutHeight,calloutOffset,calloutExtension,position,borderTop,borderRight,borderBottom,borderLeft,rectShortcut","I,F,F7,FS,F2,FE,KT,EM,DM,H9,G8,EW,M3,A8L,PX,OJ,NN,P4,FD"),e},build:function(){},wh_:function(e,i,t){var n=this;if(i=i||"w",ZC._f_(e)+""!=e+"")return-1!==(e+="").indexOf("%")?n.wh_(ZC._f_(e.replace("%",""))/100,i,!0):-1!==e.indexOf("px")?n.wh_(ZC._f_(e.replace("px","")),i):n.wh_(ZC._f_(e),i);var a="undefined"!=typeof n.E["p-width"]?n.E["p-width"]:n.A.I,l="undefined"!=typeof n.E["p-height"]?n.E["p-height"]:n.A.F;return(e=ZC._a_(e))>1&&!t?ZC._i_(e):e<=1||t?"w"===i?ZC._i_(a*e):ZC._i_(l*e):void 0},m_:function(e,i,t,n,a){var l,o,r=this;if(t=t||0,n=n||0,i=i||"all",a=a||"n","all"===i){var s=String(e).split(/\s+|;|,/);return 1===s.length?[r.m_(s[0],"tb",t,n,a),r.m_(s[0],"lr",t,n,a),r.m_(s[0],"tb",t,n,a),r.m_(s[0],"lr",t,n,a)]:2===s.length?[r.m_(s[0],"tb",t,n,a),r.m_(s[1],"lr",t,n,a),r.m_(s[0],"tb",t,n,a),r.m_(s[1],"lr",t,n,a)]:3===s.length?[r.m_(s[0],"tb",t,n,a),r.m_(s[1],"lr",t,n,a),r.m_(s[2],"tb",t,n,a),r.m_(s[1],"lr",t,n,a)]:[r.m_(s[0],"tb",t,n,a),r.m_(s[1],"lr",t,n,a),r.m_(s[2],"tb",t,n,a),r.m_(s[3],"lr",t,n,a)]}return e+""=="auto"?-2:e+""=="dynamic"&&"y"===a?"dynamic":ZC._f_(e)+""!=e+""?-1!==(e+="").indexOf("%")?r.m_(ZC._f_(e.replace("%",""))/100,i):-1!==e.indexOf("px")?r.m_(ZC._f_(e.replace("px","")),i):r.m_(ZC._f_(e),i):((r.A||"undefined"!=typeof r.E["p-width"])&&(l="undefined"!=typeof r.E["p-width"]?r.E["p-width"]:r.A.I),(r.A||"undefined"!=typeof r.E["p-height"])&&(o="undefined"!=typeof r.E["p-height"]?r.E["p-height"]:r.A.F),(e=ZC._a_(e))>=1?ZC._i_(e):e<1?"lr"===i?ZC._i_((r.A?l:t)*e):ZC._i_((r.A?o:n)*e):void 0)},copy:function(e){this.b(e);for(var i="I,F,E8,DR,DY,E9,F7,FS,F2,FE,KT,EM,DM,XN,H9,G8,EW,M3,A8L,PX,OJ,NN,P4,FD".split(","),t=0,n=i.length;t<n;t++)"undefined"!=typeof e[i[t]]&&(this[i[t]]=e[i[t]])},locate:function(e){var i,t,n,a,l,o=this;if(2!==(e=e||1))if(o.TJ)o.assign_a([["x","iX"],["y","iY"],["width","I"],["height","F"]]);else{var r="undefined"!=typeof o.E["p-x"]?o.E["p-x"]:o.A.iX,s="undefined"!=typeof o.E["p-y"]?o.E["p-y"]:o.A.iY,A="undefined"!=typeof o.E["p-width"]?o.E["p-width"]:o.A.I,C="undefined"!=typeof o.E["p-height"]?o.E["p-height"]:o.A.F;if(!o.PU){var c=0,u=0,p=0,Z=0;if(null!==ZC._n_(o.o.margin)){var h=""+o.o.margin;if(-1!==h.indexOf("dynamic")){var d=o.m_(h,"all",0,0,"y");"dynamic"===d[0]&&(o.E["d-margin-top"]=o.E["d-margin"]=!0),"dynamic"===d[1]&&(o.E["d-margin-right"]=o.E["d-margin"]=!0),"dynamic"===d[2]&&(o.E["d-margin-bottom"]=o.E["d-margin"]=!0),"dynamic"===d[3]&&(o.E["d-margin-left"]=o.E["d-margin"]=!0),o.o.margin=h.replace(/dynamic/g,"20")}}"dynamic"===o.o.margin&&(o.E["d-margin"]=o.E["d-margin-top"]=o.E["d-margin-right"]=o.E["d-margin-bottom"]=o.E["d-margin-left"]=!0,o.o.margin=null),"undefined"==typeof o.E["force-margins"]||null!==ZC._n_(o.o["adjust-layout"])&&ZC._b_(o.o["adjust-layout"])||(null!==ZC._n_(o.o["margin-top"])&&null===ZC._n_(o.o["margin-bottom"])&&(o.o["margin-bottom"]="auto"),null!==ZC._n_(o.o["margin-bottom"])&&null===ZC._n_(o.o["margin-top"])&&(o.o["margin-top"]="auto"),null!==ZC._n_(o.o["margin-left"])&&null===ZC._n_(o.o["margin-right"])&&(o.o["margin-right"]="auto"),null!==ZC._n_(o.o["margin-right"])&&null===ZC._n_(o.o["margin-left"])&&(o.o["margin-left"]="auto"));for(var f=["margin-top","margin-right","margin-bottom","margin-left"],_=0,g=f.length;_<g;_++)"dynamic"===o.o[f[_]]&&(o.E["d-"+f[_]]=o.E["d-margin"]=!0,o.o[f[_]]=null);null!==(i=ZC._n_(o.o.margin))&&(t=o.m_(i,"all"),null===ZC._n_(o.o["margin-top"])&&(c=t[0]),null===ZC._n_(o.o["margin-right"])&&(u=t[1]),null===ZC._n_(o.o["margin-bottom"])&&(p=t[2]),null===ZC._n_(o.o["margin-left"])&&(Z=t[3])),null!==(i=ZC._n_(o.o["margin-top"]))&&(c=t=o.m_(i,"tb")),null!==(i=ZC._n_(o.o["margin-right"]))&&(u=t=o.m_(i,"lr")),null!==(i=ZC._n_(o.o["margin-bottom"]))&&(p=t=o.m_(i,"tb")),null!==(i=ZC._n_(o.o["margin-left"]))&&(Z=t=o.m_(i,"lr"));var v,b=[c,u,p,Z];if(null!==ZC._n_(o.o.x)&&(o.iX=o.xy_(o.o.x,"x")),null!==ZC._n_(o.o.y)&&(o.iY=o.xy_(o.o.y,"y")),null!==(i=ZC._n_(o.o.width))){var B=ZC._p_(i);v=-1!==(""+i).indexOf("%"),o.I=B>1&&!v?ZC._i_(B):-2===Z&&-2===u?ZC._i_(A*B):-2===Z&&-2!==u?ZC._i_((A-u)*B):-2!==Z&&-2===u?ZC._i_((A-Z)*B):ZC._i_((A-Z-u)*B),-1!==o.iX?(o.DY=o.iX-r,o.E9=r+A-o.DY-o.I):-2===Z&&-2===u?(o.DY=o.E9=(A-o.I)/2,o.iX=r+o.DY):-2===Z&&-2!==u?(o.E9=u,o.DY=A-o.E9-o.I,o.iX=r+o.DY):(o.DY=Z,o.iX=r+o.DY,o instanceof ZC.DN?o.E9=u:o.E9=A-o.DY-o.I)}else-1!==o.iX?(o.DY=o.iX-r,o.E9=-2===u?0:u,o.I=A-o.DY-o.E9):-2===Z&&-2===u?(o.DY=o.E9=0,o.iX=r+o.DY,o.I=A-o.DY-o.E9):-2===Z&&-2!==u?(o.E9=u,o.DY=0,o.iX=r+o.DY,o.I=A-o.DY-o.E9):-2!==Z&&-2===u?(o.DY=Z,o instanceof ZC.DN?o.E9=u:o.E9=0,o.iX=r+o.DY,o.I=A-o.DY-o.E9):(o.DY=Z,o.E9=u,o.iX=r+o.DY,o.I=A-o.DY-o.E9);if(null!==(i=ZC._n_(o.o.height))){var m=ZC._p_(i);v=-1!==(""+i).indexOf("%"),o.F=m>1&&!v?ZC._i_(m):-2===c&&-2===p?ZC._i_(C*m):-2===c&&-2!==p?ZC._i_((C-p)*m):-2!==c&&-2===p?ZC._i_((C-c)*m):ZC._i_((C-c-p)*m),-1!==o.iY?(o.E8=o.iY-s,o.DR=s+C-o.E8-o.F):-2===c&&-2===p?(o.E8=o.DR=(C-o.F)/2,o.iY=s+o.E8):-2===c&&-2!==p?(o.DR=p,o.E8=C-o.DR-o.F,o.iY=s+o.E8):(o.E8=c,o.iY=s+o.E8,o instanceof ZC.DN?o.DR=p:o.DR=C-o.E8-o.F)}else-1!==o.iY?(o.E8=o.iY-s,o.DR=-2===p?0:p,o.F=C-o.E8-o.DR):-2===c&&-2===c?(o.E8=o.E8=0,o.iY=s+o.E8,o.F=C-o.E8-o.DR):-2===c&&-2!==p?(o.DR=p,o.E8=0,o.iY=s+o.E8,o.F=C-o.E8-o.DR):-2===c&&-2!==p?(o.E8=c,o instanceof ZC.DN?o.DR=p:o.DR=0,o.iY=s+o.E8,o.F=C-o.E8-o.DR):(o.E8=c,o.DR=p,o.iY=s+o.E8,o.F=C-o.E8-o.DR);if(null!==(i=ZC._n_(o.o.position))){if(o.A&&"undefined"!=typeof o.A.iX&&"undefined"!=typeof o.A.iY&&"undefined"!=typeof o.A.I&&"undefined"!=typeof o.A.F){switch(n=0,a=0,(l=String(i).split(/\s+/))[0]){case"left":n=0;break;case"right":n=1;break;case"center":n=.5;break;default:(n=ZC.II(l[0]))>1&&(n/=o.A.I)}switch(l[1]){case"top":a=0;break;case"bottom":a=1;break;case"middle":a=.5;break;default:(a=ZC.II(l[1]))>1&&(a/=o.A.F)}}o.E["position-info"]=[n,a],o.iX=o.A.iX+ZC._i_(n*(o.A.I-o.I-b[1]-b[3]))+b[3],o.iY=o.A.iY+ZC._i_(a*(o.A.F-o.F-b[0]-b[2]))+b[0]}o.D1=[o.iX,o.iY,o.iX+o.I,o.iY+o.F]}}},parse:function(){this.b();var e,i=this;if(!i.o.tween){if(i.assign_a([["anchor","WV"],["rect-shortcut","FD","b"],["center-ref","A79","b"],["callout","KT","b"],["callout-type","ACR"],["callout-position","EM"],["callout-hook","DM"],["callout-ratio","XN"],["callout-width","H9","i"],["callout-height","G8","i"],["callout-offset","EW","i"],["callout-extension","M3","i"],["border-top","PX"],["border-right","OJ"],["border-bottom","NN"],["border-left","P4"]]),null!==(e=ZC._n_(i.o["border-radius"]))){var t=String(e).split(/\s+|;|,/);2===t.length?(i.F7=i.FS=ZC._i_(t[0]),i.F2=i.FE=ZC._i_(t[1])):4===t.length?(i.F7=ZC._i_(t[0]),i.FS=ZC._i_(t[1]),i.F2=ZC._i_(t[2]),i.FE=ZC._i_(t[3])):i.F7=i.FS=i.F2=i.FE=ZC._i_(t[0])}null!==ZC._n_(i.o["callout-tip"])&&(i.OK=new ZC.DT(i.A)),i.assign_a([["border-radius-top-left","F7","i"],["border-radius-top-right","FS","i"],["border-radius-bottom-right","F2","i"],["border-radius-bottom-left","FE","i"]])}},WH:function(e){var i=e.split(/\s/);return i[0]=ZC._i_(i[0]),i[2]=ZC.AP.G9(i[2]),i},paint:function(){var e=this;if(null!==e.DM&&!(e.DM instanceof Array)&&"zcgraph"===e.A.OA){var i=e.A.UU(e.DM);e.DM=[i[0],i[1]],e.DM[0]-=e.BL,e.DM[1]-=e.BH}if(e.A79&&(e.iX-=e.I/2,e.iY-=e.F/2),"-1"!==e.BW&&0!==e.AU||e.PX+e.OJ+e.NN+e.P4!==""||"-1"!==e.A0||"-1"!==e.AE||""!==e.DA||""!==e.GR||""!==e.HN){var t,n=e.H.AB;e.M8&&e.C7&&e.A9Y();var a={x:"iX",y:"iY",width:"I",height:"F"};if(e.o["bottom-state"]&&!e.Y6&&!e.bIsBottom&&!e.VN){var l=new ZC.HL(e.A);for(t in l.copy(e),l.bIsBottom=!0,l.M8=!1,l.Z=e.Z,l.WV=e.WV,l.append({x:e.iX-e.A.iX,y:e.iY-e.A.iY,width:e.I,height:e.F}),l.append(e.o["bottom-state"]),l.K=e.K+"-bottom",l.parse(),l.setAnchor(),!1,a)null===ZC._n_(l.o[t])||-1===(""+l.o[t]).indexOf("+")&&-1===(""+l.o[t]).indexOf("-")||(l[a[t]]=e[a[t]]+ZC._i_(l.o[t]),!0);l.paint()}if(e.PX+e.OJ+e.NN+e.P4===""){switch(n){case"canvas":e.A1V();break;case"svg":e.VX();break;case"vml":e.VW()}if(e.KT&&e.OK){var o,r;if(e.DM&&2===e.DM.length?(o=e.DM[0],r=e.DM[1]):e.E.cp&&(o=e.E.cp[0],r=e.E.cp[1]),e.OK.Z=e.OK.C7=e.Z,e.OK.copy(e),e.OK.append(e.o["callout-tip"]),e.OK.K=e.K+"-callout-tip",e.OK.o.x=o,e.OK.o.y=r,e.E.cm){var s=e.E.cm[0],A=e.E.cm[1],C=Math.atan2(ZC._i_(A)-ZC._i_(r),ZC._i_(s)-ZC._i_(o));isNaN(C)&&(C=0),null===ZC._n_(e.OK.o.angle)&&(e.OK.o.angle=ZC.TN(C))}e.OK.parse(),e.OK.paint()}}else{var c=e.AU,u=e.BW,p=e.GF;switch(e.AU=0,n){case"canvas":e.A1V();break;case"svg":e.VX();break;case"vml":e.VW()}e.AU=c;var Z=e.A0,h=e.AE;e.A0=e.AE="-1";for(var d,f=["top","right","bottom","left"],_=["PX","OJ","NN","P4"],g=0;g<f.length;g++)if(""!==(d=e[_[g]])&&"none"!==d){var v=e.WH(d);switch(e.AU=v[0],e.GF=v[1],e.BW=v[2],n){case"canvas":e.A1V(f[g]);break;case"svg":e.VX(f[g]);break;case"vml":e.VW(f[g])}e.AU=c,e.BW=u,e.GF=p}e.A0=Z,e.AE=h}if(e.o["top-state"]&&!e.Y6&&!e.VN&&!e.bIsBottom){var b=new ZC.HL(e.A);for(t in b.copy(e),b.VN=!0,b.M8=!1,b.Z=e.Z,b.WV=e.WV,b.append({x:e.iX-e.A.iX,y:e.iY-e.A.iY,width:e.I,height:e.F}),b.append(e.o["top-state"]),b.K=e.K+"-top",b.parse(),b.setAnchor(),!1,a)null===ZC._n_(b.o[t])||-1===(""+b.o[t]).indexOf("+")&&-1===(""+b.o[t]).indexOf("-")||(b[a[t]]=e[a[t]]+ZC._i_(b.o[t]),!0);b.paint()}}},setAnchor:function(){var e=this;switch(e.WV){case"tl":break;case"tr":e.iX-=e.I;break;case"bl":e.iY-=e.F;break;case"br":e.iX-=e.I,e.iY-=e.F;break;case"c":e.iX-=e.I/2,e.iY-=e.F/2;break;case"t":e.iX-=e.I/2;break;case"r":e.iX-=e.I,e.iY-=e.F/2;break;case"b":e.iX-=e.I/2,e.iY-=e.F;break;case"l":e.iY-=e.F/2}},A9Y:function(){var e=this,i=new ZC.HL(e.A);i.K=e.K+"-sh",i.copy(e),i.Z=e.C7,i.M8=!1,i.Y6=!0,i.PX=i.OJ=i.NN=i.P4="",i.A0=i.AE=i.RZ,i.GR=i.HN="",i.DA="",i.GF="solid",i.BW=i.RZ,i.AZ=0;var t=e.JV*ZC.EH(e.OH),n=e.JV*ZC.EO(e.OH);i.I=e.I+("vml"===e.H.AB?0:.5)-ZC.EH(e.OH)*e.P7/2,i.F=e.F+("vml"===e.H.AB?0:.5)-ZC.EO(e.OH)*e.P7/2,i.NY=i.C6=i.T6*e.C6,i.K=e.K+"-sh",i.iX=e.iX+ZC._i_(t),i.iY=e.iY+ZC._i_(n),i.paint()},YD:function(e){var i,t=this,n=t.iX,a=t.iY,l=n+t.I/2,o=a+t.F/2,r=t.VO,s=t.W5;if(ZC._a_(r)<=1&&(r=r*t.I/2),ZC._a_(s)<=1&&(s=s*t.F/2),l+=r,o+=s,"radial"===e){var A=ZC._i_((t.I+t.F)/2),C=ZC.CY(t.I,t.F);return i=C<A/4?(C+A)/2:C,{cx:l,cy:o,r:ZC._a_(i)}}if("linear"===e){var c=(i=t.I>=t.F?ZC._a_(ZC.EO(t.N9))>.5?t.F/2:t.I/2:ZC._a_(ZC.EH(t.N9))>.5?t.I/2:t.F/2)*ZC.EH(t.N9),u=i*ZC.EO(t.N9);return{x1:l-c,y1:o-u,x2:l+c,y2:o+u}}},W0:function(e){var i,t=this;void 0===e&&(e="all");var n,a,l=t.iX,o=t.iY;t.D=[],n=a=t.AU/2;var r=1;switch(t.H.AB){case"vml":r=2,t.AU%2==1&&(n=ZC._i_((t.AU-1)/2),a=ZC._i_((t.AU+1)/2))}var s=null,A=ZC._x_(l+n,2),C=ZC._x_(l-a,2),c=ZC._x_(o+n,2),u=ZC._x_(o-a,2),p=t.DM&&2===t.DM.length,Z=ZC._i_(t.EW*(t.I-t.H9)/100),h=ZC._i_(t.EW*(t.F-t.G8)/100),d=0!==t.F7||0!==t.FS||0!==t.F2||0!==t.FE,f=t.XN[0],_=t.XN[1];switch(t.EM){case"top":t.E.cm=[t.iX+t.I/2+Z,t.iY];break;case"bottom":t.E.cm=[t.iX+t.I/2+Z,t.iY+t.F];break;case"left":t.E.cm=[t.iX,t.iY+t.F/2+h];break;case"right":t.E.cm=[t.iX+t.I,t.iY+t.F/2+h]}if(d){var g,v=ZC.CY(t.I/2,t.F/2);"top"!==e&&"all"!==e||(0!==t.F7?(g=t.I/2>=t.F7&&t.F/2>=t.F7?ZC._a_(t.F7):v,t.D.push([A,c+g]),t.F7>0&&t.D.push([A,c,A+r*g,c]),t.D.push([A+g,c])):t.D.push([A,c]),t.KT&&"top"===t.EM&&(t.D.push([A+t.I/2-f*t.H9/2-t.AU/2+Z,c]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[A+t.I/2-t.AU/2+Z,c-t.G8],t.D.push(s)),t.M3>0&&(i=t.D[t.D.length-1],t.D.push([i[0],i[1]-t.M3*(t.G8>0?1:-1)]),t.D.push([i[0],i[1]])),t.D.push([A+t.I/2-t.AU/2+_*t.H9/2+Z,c])),"top"===e&&(0!==t.FS?(g=t.I/2>=t.FS&&t.F/2>=t.FS?ZC._a_(t.FS):v,t.D.push([C+t.I-g,c])):t.D.push([C+t.I,c]))),"right"!==e&&"all"!==e||(0!==t.FS?(g=t.I/2>=t.FS&&t.F/2>=t.FS?ZC._a_(t.FS):v,t.D.push([C+t.I-g,c]),t.FS>0?t.D.push([C+t.I,c,C+t.I,c+r*g]):t.D.push([C+t.I,c+g])):t.D.push([C+t.I,c]),t.KT&&"right"===t.EM&&(t.D.push([C+t.I,c+t.F/2-f*t.G8/2-t.AU/2+h]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[C+t.I+t.H9,c+t.F/2-t.AU/2+h],t.D.push(s)),t.D.push([C+t.I,c+t.F/2+_*t.G8/2-t.AU/2+h])),"right"===e&&(0!==t.F2?(g=t.I/2>=t.F2&&t.F/2>=t.F2?ZC._a_(t.F2):v,t.D.push([C+t.I,u+t.F-g])):t.D.push([C+t.I,u+t.F]))),"bottom"!==e&&"all"!==e||(0!==t.F2?(g=t.I/2>=t.F2&&t.F/2>=t.F2?ZC._a_(t.F2):v,t.D.push([C+t.I,u+t.F-g]),t.F2>0?t.D.push([C+t.I,u+t.F,C+t.I-r*g,u+t.F]):t.D.push([C+t.I-g,u+t.F])):t.D.push([C+t.I,u+t.F]),t.KT&&"bottom"===t.EM&&(t.D.push([C+t.I/2+f*t.H9/2+t.AU/2+Z,u+t.F]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[C+t.I/2+t.AU/2+Z,u+t.F+t.G8],t.D.push(s)),t.M3>0&&(i=t.D[t.D.length-1],t.D.push([i[0],i[1]+t.M3*(t.G8>0?1:-1)]),t.D.push([i[0],i[1]])),t.D.push([C+t.I/2-_*t.H9/2+t.AU/2+Z,u+t.F])),"bottom"===e&&(0!==t.FE?(g=t.I/2>=t.FE&&t.F/2>=t.FE?ZC._a_(t.FE):v,t.D.push([A+g,u+t.F])):t.D.push([A,u+t.F]))),"left"!==e&&"all"!==e||(0!==t.FE?(g=t.I/2>=t.FE&&t.F/2>=t.FE?ZC._a_(t.FE):v,t.D.push([A+g,u+t.F]),t.FE>0?t.D.push([A,u+t.F,A,u+t.F-r*g]):t.D.push([A,u+t.F-g])):t.D.push([A,u+t.F]),t.KT&&"left"===t.EM&&(t.D.push([A,u+t.F/2+f*t.G8/2+t.AU/2+h]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[A-t.H9,u+t.F/2+t.AU/2+h],t.D.push(s)),t.D.push([A,u+t.F/2-_*t.G8/2+t.AU/2+h])),0!==t.F7?(g=t.I/2>=t.F7&&t.F/2>=t.F7?ZC._a_(t.F7):v,t.D.push([A,c+g])):(t.D.push([A,c]),t.D.push([A+.1,c])))}else"top"!==e&&"all"!==e||("top"===e?t.D.push([A+.5,c+.5]):t.D.push([A,c]),t.KT&&"top"===t.EM&&(t.D.push([A+t.I/2-f*t.H9/2-t.AU/2+Z,c]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[A+t.I/2-t.AU/2+Z,c-t.G8],t.D.push(s)),t.M3>0&&(i=t.D[t.D.length-1],t.D.push([i[0],i[1]-t.M3*(t.G8>0?1:-1)]),t.D.push([i[0],i[1]])),t.D.push([A+t.I/2+_*t.H9/2-t.AU/2+Z,c])),"top"===e&&t.D.push([C+t.I+.5,c+.5])),"right"!==e&&"all"!==e||("right"===e?t.D.push([C+t.I+.5,c+.5]):t.D.push([C+t.I,c]),t.KT&&"right"===t.EM&&(t.D.push([C+t.I,c+t.F/2-t.AU/2-f*t.G8/2+h]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[C+t.I+t.H9,c+t.F/2-t.AU/2+h],t.D.push(s)),t.D.push([C+t.I,c+t.F/2-t.AU/2+_*t.G8/2+h])),"right"===e&&t.D.push([C+t.I+.5,u+t.F+.5])),"bottom"!==e&&"all"!==e||("bottom"===e?t.D.push([C+t.I+.5,u+t.F+.5]):t.D.push([C+t.I,u+t.F]),t.KT&&"bottom"===t.EM&&(t.D.push([C+t.I/2+f*t.H9/2+t.AU/2+Z,u+t.F]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[C+t.I/2+t.AU/2+Z,u+t.F+t.G8],t.D.push(s)),t.M3>0&&(i=t.D[t.D.length-1],t.D.push([i[0],i[1]+t.M3*(t.G8>0?1:-1)]),t.D.push([i[0],i[1]])),t.D.push([C+t.I/2-_*t.H9/2+t.AU/2+Z,u+t.F])),"bottom"===e&&t.D.push([A+.5,u+t.F+.5])),"left"!==e&&"all"!==e||("left"===e?t.D.push([A+.5,u+t.F+.5]):t.D.push([A,u+t.F]),t.KT&&"left"===t.EM&&(t.D.push([A,u+t.F/2+t.AU/2+f*t.G8/2+h]),p?t.D.push([t.DM[0],t.DM[1]]):(s=[A-t.H9,u+t.F/2+t.AU/2+h],t.D.push(s)),t.D.push([A,u+t.F/2+t.AU/2-_*t.G8/2+h])),"left"===e?t.D.push([A+.5,c+.5]):(t.D.push([A,c]),t.D.push([A+.1,c])));s&&(t.E.cp=s)},A1V:function(e){e=e||"all";var i,t,n,a=this,l=a.Z.getContext("2d");l.save(),l.globalCompositeOperation=a.A0Z;var o=a.iX,r=a.iY,s=a.A1I(),A=s.bc,C=s.bgc1,c=s.bgc2;if("all"===e)if(C!==c||""!==a.GR&&""!==a.HN){var u=a.YD(a.NI);"radial"===a.NI?i=l.createRadialGradient(u.cx,u.cy,1,u.cx,u.cy,u.r):"linear"===a.NI&&(u.x1=isNaN(u.x1)?0:u.x1,u.x2=isNaN(u.x2)?0:u.x2,u.y1=isNaN(u.y1)?0:u.y1,u.y2=isNaN(u.y2)?0:u.y2,i=l.createLinearGradient(u.x1,u.y1,u.x2,u.y2)),""!==a.GR&&""!==a.HN?a.ZH(i):(i.addColorStop(0,C),i.addColorStop(1,c)),l.fillStyle=i}else""!==a.DA&&-1!==ZC.AV(["repeat","true",!0],a.M2)&&"-1"===a.A0&&"-1"===a.AE&&(C="rgba(255,255,255,0)"),l.fillStyle=C;l.strokeStyle=A,l.lineWidth=a.AU,l.translate(a.BL,a.BH),0!==a.A9&&(l.translate(o+a.I/2,r+a.F/2),l.rotate(ZC.T8(a.A9)),l.translate(-(o+a.I/2),-(r+a.F/2))),l.beginPath(),a.W0(e);var p=a.F7+a.FS+a.F2+a.FE!==0;n=a.AZ,a.AZ=a.AU;var Z=a.GF;if(a.GF="",a.KY(),ZC.CR.contour(l,a,a.D),a.AZ=n,a.GF=Z,a.KY(),"all"===e)if(""!==a.DA&&-1===ZC.AV(ZC.IMG404,a.DA)){l.fill(),l.save(),l.clip();var h=l.globalAlpha;l.globalAlpha=a.C6;var d=a.RD(),f=d.image;switch(a.M2){default:l.translate(a.iX,a.iY),t=l.createPattern(f,"repeat"),l.fillStyle=t,l.fill(),l.translate(-d.x,-d.y);break;case"no-repeat":case"false":case!1:l.drawImage(f,d.x-a.BL,d.y-a.BH,a.E["bg-image-width"],a.E["bg-image-height"])}l.globalAlpha=h,l.restore()}else l.fill();if(a.AU>0){var _=a.B7;n=a.AZ,a.B7=a.BW,a.AZ=a.AU,a.KY(),ZC.CR.setup(l,a),a.T1=p?"round":"square",a.EX+a.GA>0&&(a.T1="butt"),a.ZZ=p?"round":"miter",a.E["skip-top"]=!0,a.E.border=e,ZC.CR.paint(l,a,a.D,!0),a.B7=_,a.AZ=n,a.KY()}l.closePath(),l.restore()},VX:function(e){e=e||"all";var i=this,t=i.Z;i.E.fill=-1;var n=!1;if("all"===e){if(""!==i.DA&&-1===ZC.AV(ZC.IMG404,i.DA)){var a=i.RD();i.A2O({info:a,x:i.iX,y:i.iY}),n=!0}i.WZ()}if(i.W0(e),n&&"repeat"!==i.M2&&i.KT){var l=0,o=0;i.D1[1]<i.iY&&(o=i.D1[3]-i.D1[1]-i.F),i.D1[0]<i.iX&&(l=i.D1[2]-i.D1[0]-i.I),null===ZC._n_(i.E["pattern-tx"])?i.E["pattern-tx"]=l:i.E["pattern-tx"]+=l,null===ZC._n_(i.E["pattern-ty"])?i.E["pattern-ty"]=o:i.E["pattern-ty"]+=o,ZC.Q.G3(ZC.AL(i.E["pattern-image-id"]),{transform:"translate("+i.E["pattern-tx"]+","+i.E["pattern-ty"]+")"})}var r=i.F7+i.FS+i.F2+i.FE!==0;i.E.cx=i.iX+i.I/2,i.E.cy=i.iY+i.F/2,i.VH&&i.A3G();var s=i.B7,A=i.AZ;i.B7=i.BW,i.AZ=i.AU,i.KY(),ZC.CR.setup(t,i),i.T1=r?"round":"square",i.EX+i.GA>0&&(i.T1="butt"),i.ZZ=r?"round":"miter";var C=!1;ZC.A4.browser.msie||!i.FD||i.KT||""!==i.PX||""!==i.OJ||""!==i.NN||""!==i.P4||0!==i.F7||0!==i.FS||0!==i.F2||0!==i.FE||(C=!0),i.E["skip-top"]=!0,i.E.border=e,ZC.CR.paint(t,i,i.D,!0,null,C),i.B7=s,i.AZ=A,i.KY()},VW:function(e){e=e||"all";var i=this,t=i.Z;if("all"===e){var n=ZC.Q.F6("zcv:fill");if(""!==i.DA&&-1===ZC.AV(ZC.IMG404,i.DA)){var a=i.RD(),l=a.image;switch(i.M2){default:n.type="tile",n.src=i.DA,ZC.Q.G3(n,{position:a.cx+","+a.cy,opacity:i.C6,"o:opacity2":i.C6}),i.E.imgfill=[n];break;case"no-repeat":case"false":case!1:i.E.imgfill=[l,a.x,a.y]}}i.WY("0.5,0.5")}var o=ZC.Q.F6("zcv:stroke");switch(o.weight=i.AU+"px",o.color=i.BW,o.opacity=i.C6,i.GF){case"solid":o.dashstyle="solid";break;case"dotted":o.dashstyle="dot";break;case"dashed":o.dashstyle="dash"}i.E.stroke=o,i.W0(e);var r=i.F7+i.FS+i.F2+i.FE!==0;i.E.cx=i.iX+i.I/2,i.E.cy=i.iY+i.F/2;var s=i.B7,A=i.AZ;i.B7=i.BW,i.AZ=i.AU,i.KY(),ZC.CR.setup(t,i),i.T1=r?"round":"square",i.EX+i.GA>0&&(i.T1="butt"),i.ZZ=r?"round":"miter",i.E.border=e,ZC.CR.paint(t,i,i.D,"all"===e),i.B7=s,i.AZ=A,i.KY()}};ZC.HL=ZC.DT.CA(HL);var P0={$i:function(e){this.b(e);var i=this;i.WW=null,i.BF=null,i.M=null,i.SL=null,i.A7=null,i.K9=!1,i.O7=!1,i.KZ=!1,i.A61=!1},parse:function(){var e,i=this;i.BF=zingchart.pool.getInstance("box"===i.WW.type?"HL":"DT",i.A,i.K+"-shape",i.WW.tween),i.BF.append(i.WW),i.BF.iX=i.iX,i.BF.iY=i.iY,i.BF.K=i.K+"-gshape",i.BF.O7=i.O7,i.A61||null===ZC._n_(e=i.BF.o.points)||(i.BF.o.points=ZC.AP.A5B(e,i.A.iX,i.A.iY),i.A61=!0),i.BF.parse(),null!==ZC._n_(e=i.BF.o.label)&&null!==ZC._n_(e.text)&&""!==e.text&&("undefined"==typeof e.visible||ZC._b_(e.visible))&&(i.M=zingchart.pool.getInstance("DN",i,i.A.K+"-shape-label-"+i.H5,ZC.objmove),ZC.objmove||i.M.append(e)),null!==ZC._n_(e=i.BF.o["static"])&&(i.K9=ZC._b_(e)),null!==ZC._n_(e=i.BF.o.flat)&&(i.K9=ZC._b_(e)),null!==ZC._n_(e=i.BF.o.dynamic)&&(i.KZ=ZC._b_(e)),null!==ZC._n_(e=i.BF.o.connector)&&(i.SL=new ZC.DT(i),i.SL.append(e),i.SL.parse())},paint:function(){var e,i=this;if(i.BF.Z=i.Z,i.BF.C7=i.C7,i.BF.locate(2),i.BF.VN=!1,"box"===i.BF.o.type&&(i.iX-=i.BF.I/2,i.iY-=i.BF.F/2,i.BF.iX-=i.BF.I/2,i.BF.iY-=i.BF.F/2),i.BF.paint(),i.M){if(i.M.Z=i.M.C7=i.Z,i.M.IL=ZC.AL(i.A.A.K+"-text"),i.M.K=i.A.K+"-shape-label-"+i.H5,i.M.GL=i.A.K+"-shape-label zc-shape-label",i.M.o.anchor=i.M.o.anchor||"c",!i.WW["map-item"])switch(i.DU){default:i.M.o.x=i.iX,i.M.o.y=i.iY;break;case"line":case"poly":case"rect":case"rectangle":i.M.o.x=ZC._i_((i.BF.D1[0]+i.BF.D1[2])/2),i.M.o.y=ZC._i_((i.BF.D1[1]+i.BF.D1[3])/2)}if(ZC.objmove||i.M.parse(),i.M.iX=i.M.iX+i.BF.BL,i.M.iY=i.M.iY+i.BF.BH,i.M.AN){if(i.SL&&i.SL.D.length>0){if(!ZC.AL(i.A.K+"-objects-front")){var t=i.A.A.I+"/"+i.A.A.F;ZC.Q.JZ({cls:"zc-abs",wh:t,id:i.A.K+"-objects-front",p:ZC.AL(i.A.A.K+"-objects-front")},i.A.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:i.A.K+"-objects-front-c",p:ZC.AL(i.A.K+"-objects-front"),wh:t},i.A.A.AB)}var n=i.SL.D,a=i.SL.o.anchor||"",l=n[n.length-1];switch(a){case"l":i.M.iX=l[0]+i.BF.BL,i.M.iY=l[1]-i.M.F/2+i.BF.BH;break;case"r":i.M.iX=l[0]-i.M.I+i.BF.BL,i.M.iY=l[1]-i.M.F/2+i.BF.BH;break;case"t":i.M.iX=l[0]-i.M.I/2+i.BF.BL,i.M.iY=l[1]+i.BF.BH;break;case"b":i.M.iX=l[0]-i.M.I/2+i.BF.BL,i.M.iY=l[1]-i.M.F+i.BF.BH;break;default:i.M.iX=l[0]-i.M.I/2+i.BF.BL,i.M.iY=l[1]-i.M.F/2+i.BF.BH}e=ZC.Q.EB(ZC.AL(i.A.K+"-objects-front-c"),i.A.H.AB),ZC.CR.setup(e,i.SL),ZC.CR.paint(e,i.SL,n)}if(i.M.VN=!1,i.WW["map-item"]&&(i.M.GL=i.A.K+"-mapshape-label zc-mapshape-label",i.M.iX<i.A.iX||i.M.iX+i.M.I>i.A.iX+i.A.I||i.M.iY<i.A.iY||i.M.iY+i.M.F>i.A.iY+i.A.F))return;i.M.paint(),i.E["print-canvas"]?i.M.EK(ZC.AL(i.E["print-canvas"])):i.M.EK()}}}};ZC.P0=ZC.DT.CA(P0);var DN={$i:function(e){this.b(e);var i=this;i.IL=null,i.GL="",i.AM=null,i.OD="center",i.JY="middle",i.DI=zingchart.FONTSIZE,i.GH=zingchart.FONTFAMILY,i.C2="#000",i.A93=!1,i.N1=!1,i.QT=!1,i.K8="none",i.sFontWeight="normal",i.YB=0,i.FM=2,i.FN=2,i.FT=2,i.EQ=2,i.A8K=!1,i.A29=!1,i.FI=-1,i.KB=0,i.NJ=0,i.OM=ZC.MAX,i.bRTL=!1,i.A1D=!0,i.V2=zingchart.FASTWIDTH,i.A62=1.65,i.UV=1,i.VP=!1,i.A7=null,i.V9=!1,i.A5J=!1},getPMap:function(){var e=this.b();return this.addPMap(e,"textAlign,verticalAlign,fontSize,fontFamily,color,bold,fontWeight,italic,underline,textDecoration,paddingTop,paddingRight,paddingBottom,paddingLeft,text","OD,JY,DI,GH,C2,A93,sFontWeight,N1,QT,K8,FM,FN,FT,EQ,AM"),e},copy:function(e){this.b(e);for(var i="OD,JY,DI,GH,C2,A93,sFontWeight,N1,K8,QT,FM,FN,FT,EQ,AM".split(","),t=0,n=i.length;t<n;t++)"undefined"!=typeof e[i[t]]&&(this[i[t]]=e[i[t]])},overrideFormat:function(e){for(var i=["decimals","thousands-separator","decimals-separator"],t=0;t<i.length;t++)e[i[t]]="undefined"!=typeof this.o[i[t]]?this.o[i[t]]:e[i[t]];return e},JT:function(e){return e},isBold:function(e){return"bold"===e||"bolder"===e||"500"===e||"600"===e||"700"===e||"800"===e||"900"===e},cwidth:function(e){var i=this;if(i.V2)return e.replace(/(<([^>]+)>)/gi,"").length*i.DI/(i.A62*(i.isBold(i.sFontWeight)?.87:1)*(i.N1?.95:1));var t="";return"undefined"!=typeof i.o["html-mode"]&&ZC._b_(i.o["html-mode"])&&(t="[HTMLMODE]"),ZC.Q.A43(this.H.K,t+e,this.GH,this.DI,this.sFontWeight,this.FI)},parse:function(){this.I=this.F=this.NJ=this.KB=0,this.b();var e,i,t,n,a,l=this;if(!l.o.tween){if(l.ZQ("text","AM"),null!==ZC._n_(l.AM)&&(l.AM=""+l.AM,l.AM=l.JT(l.AM),l.AM=l.AM.replace(/\n/g,"<br>").replace(/\\n/g,"<br>"),"svg"===l.H.AB&&(l.AM=l.AM.replace(/&nbsp;/g," ")),l.AM=l.AM.replace(/<audio|<video|<embed|<object/gi,""),-1!==l.AM.indexOf("<img")&&(l.AM=l.AM.replace(/onload=|onerror=/gi,""))),l.assign_a([["overlap","A1D","b"],["fast-width","V2","b"],["max-width","OM","i"],["line-height","FI","i"],["width-ratio","A62","f"],["wrap-text","A29","b"],["clip-text","A8K","b"],["bold","A93","b"],["italic","N1","b"],["underline","QT","b"],["text-decoration","K8"],["rtl","bRTL","b"],["text-align","OD"],["align","OD"],["vertical-align","JY"],["font-size","DI","f"],["max-chars","YB","i"],["font-family","GH"],["font-angle","A9","i"],["color","C2","c"],["font-color","C2","c"],["text-alpha","UV","f",0,1],["lock-rotation","V9","b"]]),l.DI=ZC.BQ(1,l.DI),null===ZC._n_(l.o["text-alpha"])&&(l.UV=l.C6),l.A93&&(l.sFontWeight="bold"),null!==(e=ZC._n_(l.o["font-weight"]))&&(l.sFontWeight=e),null===ZC._n_(l.o["text-decoration"])&&(l.K8=l.QT?"underline":"none"),null!==(e=ZC._n_(l.o["font-style"]))&&(l.N1="italic"===e||"oblique"===e),null!==(e=ZC._n_(l.o.padding))){var o=String(e).split(/\s+|;|,/);i=1===o.length?[ZC._i_(o[0]),ZC._i_(o[0]),ZC._i_(o[0]),ZC._i_(o[0])]:2===o.length?[ZC._i_(o[0]),ZC._i_(o[1]),ZC._i_(o[0]),ZC._i_(o[1])]:3===o.length?[ZC._i_(o[0]),ZC._i_(o[1]),ZC._i_(o[2]),ZC._i_(o[0])]:[ZC._i_(o[0]),ZC._i_(o[1]),ZC._i_(o[2]),ZC._i_(o[3])],l.FM=i[0],l.FN=i[1],l.FT=i[2],l.EQ=i[3]}if(l.assign_a([["padding-top","FM","i"],["padding-right","FN","i"],["padding-bottom","FT","i"],["padding-left","EQ","i"]]),l.AM){l.YB>0&&l.AM.length>l.YB&&(l.AM=l.AM.substring(0,l.YB)+"...");var r=l.AM.split(/<br>|<br\/>|<br \/>|\n/),s="";"undefined"!=typeof l.o["html-mode"]&&ZC._b_(l.o["html-mode"])&&(r=[l.AM],s="[HTMLMODE]");r.length;for(l.V2?l.KB=1.65*this.DI:l.KB=ZC.Q.A43(this.H.K,s+l.AM,this.GH,this.DI,this.sFontWeight,this.FI,!0)+l.FM+l.FT,t=0,n=r.length;t<n;t++)l.NJ=ZC.BQ(l.NJ,l.cwidth(r[t])+l.EQ+l.FN)}else l.AM="",l.NJ=ZC._i_(1.25*l.DI),l.KB=-1===l.FI?ZC._i_(1.25*l.DI):l.FI;if((null===ZC._n_(l.o.width)||isNaN(l.I)||0===l.I)&&(l.I=l.NJ),(null===ZC._n_(l.o.height)||isNaN(l.F)||0===l.F)&&(l.F=l.KB),l.I=ZC.CY(l.I,l.OM),l.A29&&l.NJ>l.I&&!l.E.wrapped&&l.I>2*l.DI){var A,C="",c=0,u=l.AM.replace(/<br>/gi," [##] ").split(/\s|<br>/),p=[];for(t=0,n=u.length;t<n;t++)if((A=l.cwidth(u[t]))>.9*l.I){var Z=Math.ceil(A/l.I*.9),h=Math.ceil(u[t].length/Z);for(a=0;a<Z;a++)p.push(u[t].substr(a*h,h))}else p.push(u[t]);for(t=0,n=p.length;t<n;t++)""!==p[t]&&("[##]"===p[t]?(C+="<br>",c=0):(c+=A=1+l.cwidth(p[t]+" "))>.9*l.I?(t>0&&(C+="<br>"),C+=p[t]+" ",c=A):C+=p[t]+" ");C=(C=C.replace(/<br><br>/g,"<br>").replace(/ <br> <br>/g," <br>")).replace(/(.+?)<br> $/g,"$1");var d=l.o.text;l.o.text=C,l.E.wrapped=!0,l.parse(),l.o.text=d,l.E.wrapped=!1}if("canvas"!==l.H.AB&&(l.AM=l.AM.replace(/&lt;/g,"<").replace(/&gt;/g,">")),!(null!==ZC._n_(l.o.width)&&null!==ZC._n_(l.o.height)||null===ZC._n_(l.o.position)&&null===ZC._n_(l.o.margin)&&null===ZC._n_(l.o["margin-top"])&&null===ZC._n_(l.o["margin-right"])&&null===ZC._n_(l.o["margin-bottom"])&&null===ZC._n_(l.o["margin-left"]))){l.iX=-1,l.iY=-1;var f=l.o.width,_=l.o.height;null===ZC._n_(f)&&(l.o.width=l.I),null===ZC._n_(_)&&(l.o.height=l.F),l.locate(),l.o.width=f,l.o.height=_}if("undefined"==typeof l.o["html-mode"]||!l.o["html-mode"]){var g=Math.ceil((l.NJ-l.EQ-l.FN)/l.DI);g>0&&(l.AM=l.AM.replace(/<hr>/g,new Array(g).join("\u2014")))}}l.setAnchor()},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c=this;if(!c.VP&&!c.A1D){var u=!0;null!==ZC._n_(c.o.flexible)&&(u=ZC._b_(c.o.flexible));var p,Z,h={x:c.iX+c.EQ-1,y:c.iY+c.FM-1,width:c.I-c.EQ-c.FN+2,height:c.F-c.FM-c.FT+2,type:c.E.lbltype||""},d=[[0,0]];for(u&&(d=[[0,0],[0,2],[0,-4],[0,4],[0,-8],[3,0],[-6,0],[5,0],[-10,0]]),Z=0;Z<d.length;Z++){for(p=!0,h.x+=d[Z][0],h.y+=d[Z][0],a=0,l=c.H.SR.length;a<l;a++)ZC.AR.XQ(h,c.H.SR[a],-2)&&(p=!1);if(p){c.iX=h.x,c.iY=h.y;break}}if(!p)return;c.H.SR.push(h)}var f=c.H.AB;if(e=ZC.Q.EB(c.Z,f),c.VP||c.b(),!c.A5J&&(c.o.width||!(c.I-c.EQ-c.FN<2))&&(c.o.height||!(c.KB-c.FM-c.FT<2))){var _=c.A9%360==0?"0":"";if((c.VP||zingchart.CANVASTEXT&&"canvas"===f)&&(_=""),ZC.vml&&"svg"===f&&""===c.GL&&(c.GL=c.K+"-class"),!c.VP&&ZC.AL(c.K)&&(f="_",ZC.objmove))return ZC.AL(c.K).style.top=c.iY+c.BH+"px",void(ZC.AL(c.K).style.left=c.iX+c.BL+"px");var g="undefined"!=typeof c.E["html-mode"]&&c.E["html-mode"],v=g;"undefined"!=typeof c.o["html-mode"]&&(g=ZC._b_(c.o["html-mode"]));var b,B,m,E,D,F,K,x,I,y,w,L,X,Y,M,H,P,N,S,O,G,k,T=[c.AM];g||(T=c.AM.split(/<br>|<br\/>|<br \/>|\n/)),g&&!v&&"svg"===f&&"0"===_&&(_="0html");var z=c.IL?c.IL:c.Z.parentNode;switch(f+_){case"canvas0":case"vml0":case"svg0html":if(n=1,!g)switch(c.JY){case"middle":n+=(c.F-c.KB)/2;break;case"bottom":n+=c.F-c.KB}if(o=ZC.Q.HY({id:c.K,cls:c.GL,tl:ZC._x_(c.iY+c.BH)+"/"+ZC._x_(c.iX+c.BL),wh:c.I+"/"+c.F,position:"absolute",padding:0,margin:0,overflow:g?"visible":"hidden",textAlign:c.OD}),g&&(v||f+_!=="svg0html"||(z=ZC.AL(c.H.K+"-top")),z.appendChild(o)),ZC.Q.HY({id:c.K+"-t",cls:""!==c.GL?c.GL+"-t":"",p:o,width:c.I-c.EQ-c.FN,height:g?null:c.KB-c.FM-c.FT,tl:n+"/0",html:c.AM+"",position:"absolute",whiteSpace:"nowrap",opacity:c.UV,color:c.C2,fontWeight:c.sFontWeight,fontStyle:c.N1?"oblique":"normal",textDecoration:c.K8,fontSize:c.DI,fontFamily:c.GH,marginTop:c.FM,marginRight:c.FN,marginBottom:c.FT,marginLeft:c.EQ,verticalAlign:c.JY,textAlign:c.OD,lineHeight:-1===c.FI?"125%":c.FI+"px",rtl:c.bRTL,padding:0}),c.E["css-display"]&&(o.style.display=c.E["css-display"],c.E["css-display"]=null),v&&c.H&&c.H.A7&&!c.o.width&&!c.o.height){var Q=ZC.A4("#"+c.K+"-t");"canvas"===f&&(ZC.AL(c.H.K+"-tooltip-c").width=Q.width()+c.EQ+c.FN,ZC.AL(c.H.K+"-tooltip-c").height=Q.height()+c.FM+c.FT),c.H.A7.clear(),c.I=Q.width()+c.EQ+c.FN,c.F=Q.height()+c.FM+c.FT,c.paint()}break;case"canvas":var J=!1;if(ZC.A4.browser.opera&&c.A9%90==0&&0!==c.A9&&(c.A9+=.5,J=!0),e=c.Z.getContext("2d"),zingchart.DEV.CACHECANVASTEXT&&(ZC.CanvasCache||(ZC.CanvasCache={})),!zingchart.DEV.CACHECANVASTEXT||zingchart.DEV.CACHECANVASTEXT&&!ZC.CanvasCache[c.K]){for(zingchart.DEV.CACHECANVASTEXT&&(ZC.CanvasCache[c.K]=document.createElement("canvas"),ZC.CanvasCache[c.K].width=c.NJ,ZC.CanvasCache[c.K].height=c.KB),b=-1===c.FI?0:ZC._x_(c.FI-1.25*c.DI)/2,a=0,l=T.length;a<l;a++)if(""!==ZC.GV(T[a])){switch(i=1===l?c.NJ:c.cwidth(T[a])+c.FN+c.EQ,m=-1===(B=T[a]).indexOf("<")?B:B.replace(/<.+?>/gi,"").replace(/<\/.+?>/gi,""),t=0,n=0,c.OD){case"center":t+=(c.I-i)/2;break;case"right":t+=c.I-i}switch(c.JY){case"middle":n+=(c.F-c.KB)/2;break;case"bottom":n+=c.F-c.KB}if(E=0,B!==m){for(;F=/<(.+?)>(.*?)<\/(.+?)>/.exec(B);){switch(K="",x="",(A=/(.+?)style=(.+?)(\'|")(.*?)/.exec(F[1]))&&(x=A[2].replace(/\'|"/g,"")),F[3]){case"b":case"strong":K="font-weight:bold";break;case"i":case"em":K="font-style:italic";break;case"u":K="text-decoration:underline"}y='[[span style="'+(""===K?"":K+";")+x+'"]]'+F[2]+"[[/span]]",B=B.replace(F[0],y)}for(w=!1,S=0,O=(F=(B=B.replace(/\[\[/g,"<").replace(/\]\]/g,">").replace(/<span/g,"[[*]]<span").replace(/<\/span>/g,"</span>[[*]]")).split("[[*]]")).length;S<O;S++)if(""!==F[S]){if(r=c.C2,L=c.sFontWeight,X=c.N1,Y=c.QT,M=c.DI,H=c.GH,N=c.FI,P=c.K8,D=F[S],C=/<span style=(.+?)>(.+?)<\/(.+?)>/.exec(F[S]))for(D=C[2],G=0,k=(I=C[1].replace(/\'|"/g,"").split(/;|:/)).length;G<k-1;G+=2)switch(ZC.GV(I[G])){case"font-size":M=ZC._i_(ZC.GV(I[G+1]));break;case"font-family":H=ZC.GV(I[G+1]);break;case"font-weight":L=ZC.GV(I[G+1]);break;case"font-style":-1!==ZC.AV(["italic","oblique"],ZC.GV(I[G+1]))&&(X=!0);break;case"text-decoration":P=ZC.GV(I[G+1]);break;case"line-height":N=ZC._i_(ZC.GV(I[G+1]));break;case"color":r=ZC.AP.G9(ZC.GV(I[G+1]))}0===a&&(b=-1===N?0:ZC._x_(N-1.25*M)/2);var V={idx:a,ctx:e,i:X,fw:L,fs:M,lh:N,ff:H,c:r,t:D,dx:t,dy:n};V.dy+=ZC._x_(b),V.dy+=w||c.isBold(L)||Y?2:0,c.paintCANVASText(V),w=X,E++,t+=ZC.Q.A43(this.H.K,D,H,M,L,N)}null!==ZC._n_(N)&&null!==ZC._n_(M)&&(b+=-1===N?1.25*M:N)}else c.paintCANVASText({idx:a,ctx:e,i:c.N1,fw:c.sFontWeight,fs:c.DI,lh:c.FI,ff:c.GH,c:c.C2,t:T[a],dx:t,dy:n+b}),b+=-1===c.FI?1.25*c.DI:c.FI}}else e.drawImage(ZC.CanvasCache[c.K],c.iX+c.BL,c.iY+c.BH);J&&(c.A9-=.5);break;case"vml":switch(n=0,c.JY){case"top":n-=(c.F-c.KB)/2;break;case"bottom":n+=(c.F-c.KB)/2}var R=ZC.Q.F6("zcv:line"),W=c.iX+c.BL+c.I/2,U=c.iY+c.BH+c.F/2,j=ZC.EH(c.A9)*(c.I-c.EQ-c.FN)/2,q=ZC.EO(c.A9)*(c.I-c.EQ-c.FN)/2,$=ZC._i_(W-j-ZC.EH(90-c.A9)*n),ee=ZC._i_(U-q+ZC.EO(90-c.A9)*n),ie=ZC._i_(W+j-ZC.EH(90-c.A9)*n),te=ZC._i_(U+q+ZC.EO(90-c.A9)*n);$===ie&&($-=.01,ie+=.01),ee===te&&(ee-=.01,te+=.01),r=c.C2,0!==c.A9&&c.C6<1&&(r=ZC.AP.QR(r,99*(1-c.C6))),ZC.Q.G3(R,{id:c.K+"-line",from:$+"px,"+ee+"px",to:ie+"px,"+te+"px",fillcolor:r}),R.filled=!0,R.stroked=!1;var ne=ZC.Q.F6("zcv:path");ne.setAttribute("textpathok",!0),R.appendChild(ne);var ae=ZC.Q.F6("zcv:textpath"),le=c.AM.replace(/<br>|<br\/>|<br \/>/gi,"\n").replace(/<.+?>/gi,"").replace(/<\/.+?>/gi,"");ZC.Q.G3(ae,{on:!0,string:le}),ZC.Q.PI(ae,{color:r,fontWeight:c.sFontWeight,fontStyle:c.N1?"oblique":"normal",textDecoration:c.K8,fontSize:c.DI+"px",fontFamily:c.GH,"v-text-align":c.OD}),R.appendChild(ae),e.appendChild(R);break;case"svg":case"svg0":var oe=c.iX+c.EQ+c.BL,re=c.iY+c.FM+c.BH;if(o=ZC.Q.F6("text","http://www.w3.org/2000/svg"),ZC.Q.G3(o,{x:ZC._x_(oe),y:ZC._x_(re),id:c.K,"class":c.GL,opacity:c.UV}),c.E["css-display"]&&(o.style.display=c.E["css-display"],c.E["css-display"]=null),c.bRTL&&ZC.Q.G3(o,{"text-anchor":ZC.A4.browser.msie?"":"end","writing-mode":"rl",direction:"rtl","unicode-bidi":"bidi-override"}),c.A8K&&(c.H.KD.appendChild(ZC.Q.XD({id:c.K+"-clip",path:[[c.iX+c.EQ+c.AU+c.BL,c.iY+c.FM+c.AU+c.BH].join(","),[c.iX+c.I-c.FN-c.AU+c.BL,c.iY+c.FM+c.AU+c.BH].join(","),[c.iX+c.I-c.FN-c.AU+c.BL,c.iY+c.F-c.FT-c.AU+c.BH].join(","),[c.iX+c.EQ+c.AU+c.BL,c.iY+c.F-c.FT-c.AU+c.BH].join(","),[c.iX+c.EQ+c.AU+c.BL,c.iY+c.FM+c.AU+c.BH].join(",")].join(" ")})),ZC.Q.G3(o,{"clip-path":"url(#"+c.K+"-clip)"})),c.A9%360!=0&&o.setAttribute("transform","rotate("+c.A9+" "+(oe+(c.I-c.EQ-c.FN)/2)+" "+(re+(c.F-c.FM-c.FT)/2)+")"),g&&z.appendChild(o),g){ZC.Q.EU(c.K+"-float");var se=ZC.Q.F6("div");ZC.Q.PI(se,{position:"absolute",left:0,top:0,width:c.I-c.EQ-c.FN+"px",height:c.F-c.FM-c.FT+"px",color:c.C2,fontSize:c.DI+"px",fontFamily:c.GH,fontWeight:c.sFontWeight,textDecoration:c.K8,textAlign:c.OD,fontStyle:c.N1?"italic":"normal"}),se.id=c.K+"-float",se.className="zc-style zc-html-mode",se.innerHTML=T[0],1===c.o["z-index"]?ZC.AL(c.H.K+"-top").append(se):ZC.AL(c.H.K+"-top").insertBefore(se,ZC.AL(c.H.K+"-img")),v&&c.H&&c.H.A7&&(c.o.width||c.o.height||(c.H.A7.clear(),se.style.width="",se.style.height="",c.I=ZC.A4(se).width()+c.EQ+c.FN,c.F=ZC.A4(se).height()+c.FM+c.FT,c.paint()))}else for(b=-1===c.FI?0:ZC._x_(c.FI-1.25*c.DI)/2,a=0,l=T.length;a<l;a++){switch(i=1===l?c.NJ:c.cwidth(T[a])+c.FN+c.EQ,m=-1===(B=T[a]).indexOf("<")?B:B.replace(/<.+?>/gi,"").replace(/<\/.+?>/gi,""),t=0,n=c.DI,c.OD){case"center":t=(c.I-i)/2;break;case"right":t=c.I-i}switch(c.JY){case"middle":n+=(c.F-c.KB)/2;break;case"bottom":n+=c.F-c.KB}if(E=0,B!==m){for(;F=/<(.+?)>(.*?)<\/(.+?)>/.exec(B);){switch(K="",x="",(A=/(.+?)style=(.+?)(\'|")(.*?)/.exec(F[1]))&&(x=A[2].replace(/\'|"/g,"")),F[3]){case"b":case"strong":K="font-weight:bold";break;case"i":case"em":K="font-style:italic";break;case"u":K="text-decoration:underline"}y='[[span style="'+(""===K?"":K+";")+x+'"]]'+F[2]+"[[/span]]",B=B.replace(F[0],y)}for(w=!1,S=0,O=(F=(B=B.replace(/\[\[/g,"<").replace(/\]\]/g,">").replace(/<span/g,"[[*]]<span").replace(/<\/span>/g,"</span>[[*]]")).split("[[*]]")).length;S<O;S++)if(""!==F[S]){if(r=c.C2,L=c.sFontWeight,X=c.N1,Y=c.QT,M=c.DI,H=c.GH,P=c.K8,N=c.FI,D=F[S],C=/<span style=(.+?)>(.+?)<\/(.+?)>/.exec(F[S]))for(D=C[2],G=0,k=(I=C[1].replace(/\'|"/g,"").split(/;|:/)).length;G<k-1;G+=2)switch(ZC.GV(I[G])){case"font-size":M=ZC._i_(ZC.GV(I[G+1]));break;case"font-family":H=ZC.GV(I[G+1]);break;case"font-weight":L=ZC.GV(I[G+1]);break;case"font-style":-1!==ZC.AV(["italic","oblique"],ZC.GV(I[G+1]))&&(X=!0);break;case"text-decoration":P=ZC.GV(I[G+1]);break;case"line-height":N=ZC._i_(ZC.GV(I[G+1]));break;case"color":r=ZC.AP.G9(ZC.GV(I[G+1]))}n=M,s=ZC.Q.F6("tspan","http://www.w3.org/2000/svg"),0===E?(ZC.Q.G3(s,{x:ZC._x_(oe+t),y:ZC._x_(re+n),dy:ZC._x_(b)}),b+=-1===N?1.25*M:ZC.BQ(1.5*M,N)):ZC.Q.G3(s,{dx:w||c.isBold(L)||Y?2:0}),ZC.Q.G3(s,{color:r,fill:r}),ZC.Q.PI(s,{fontWeight:L,fontStyle:X?"oblique":"normal",textDecoration:P,fontSize:M+"px",fontFamily:H,dominantBaseline:"auto"});var Ae=document.createElement("span");-1!==D.indexOf("<")||-1!==D.indexOf(">")?Ae.innerText=D:Ae.innerHTML=D,D=Ae.innerText||Ae.textContent,Ae=null,s.textContent=D,o.appendChild(s),w=X,E++}}else c.bRTL&&ZC.A4.browser.msie&&(t+=i-c.EQ-c.FN),s=ZC.Q.F6("tspan","http://www.w3.org/2000/svg"),ZC.Q.G3(s,{x:ZC._x_(oe+t),y:ZC._x_(re+n),color:c.C2,fill:c.C2,dy:ZC._x_(b)}),ZC.Q.PI(s,{fontWeight:c.sFontWeight,fontStyle:c.N1?"oblique":"normal",textDecoration:c.K8,fontSize:c.DI+"px",fontFamily:c.GH,dominantBaseline:"auto"}),s.textContent=m,o.appendChild(s),b+=-1===c.FI?1.25*c.DI:c.FI}}if(!g)if(!c.VP&&o&&z)if(c.H.G1)-1!==ZC.Q.T4(z).indexOf("zc-text")&&null===ZC._n_(c.H.G1[z.id])&&(c.H.G1[z.id]=document.createDocumentFragment()),c.H.G1[z.id]?c.H.G1[z.id].appendChild(o):z.appendChild(o);else z.appendChild(o)}},paintCANVASText:function(e){var i=this,t=e.idx,n=e.ctx,a=e.i,l=e.fw,o=e.fs,r=e.ff,s=e.c,A=e.dx,C=e.dy,c=e.t;n.save(),n.globalAlpha=i.UV;var u;if(u=(a?"italic":"normal")+" normal "+l+" "+o+"px "+r,n.font=u,n.fillStyle=s,n.textAlign="left",n.textBaseline="alphabetic",n.translate(i.iX+i.BL,i.iY+i.BH),0!==i.A9&&(n.translate(i.I/2,i.F/2),n.rotate(ZC.T8(i.A9)),n.translate(-i.I/2,-i.F/2)),n.translate(i.EQ,i.FM+o),n.translate(A,C),n.fillText(c,0,0),zingchart.DEV.CACHECANVASTEXT){var p=ZC.CanvasCache[i.K].getContext("2d");p.font=u,p.fillStyle=s,p.textAlign="left",p.textBaseline="alphabetic",p.fillText(c,i.EQ,i.FM+o+1.25*t*o)}n.restore()},EK:function(e){var i=this;if(ZC.canvas&&"canvas"===i.H.AB&&(e||(e=ZC.AL(i.H.K+"-textprint-c")),!zingchart.CANVASTEXT&&i.A9%360==0)){var t=i.Z;i.Z=e,i.VP=!0;var n=i.H.AB;i.H.AB="canvas",i.paint(),i.VP=!1,i.H.AB=n,i.Z=t}}};ZC.DN=ZC.HL.CA(DN);var Q5={$i:function(e){this.b(e);var i=this;i.CI="json",i.NR={graphset:!0,graph:!0,"objects-bottom":!0,"objects-top":!0,maps:!0,plotarea:!0,plots:!0,guide:!0,"static":!0,"value-box":!0},i.bA11y=!1,i.OZ="",i.A19=!1,i.A14="en_us",i.QV=null,i.JN="",i.UC=!1,i.RV={},i.N6="",i.ADI={},i.QJ="",i.EV="",i.M9={},i.HP=null,i.AG=[],i.LI="",i.A7=null,i.H1=null,i.D7=null,i.B8=new ZC.AAT(i),i.QQ="",i.MP=null,i.NW=[null,null,null,null],i.O7=!1,i.NF="x",i.K9=!1,i.TM=!1,i.ABL=!1,i.A3D=!1,i.GN=!1,i.A9V={},i.O0=null,i.QO={},i.LR=!1,i.QU=!1,i.AD3=null,i.SQ=[],i.O={},i.MX=null,i.DG=null,i.UP=0,i.A28=0,i.A4G=1,i.MH=null,i.SD="",i.AAZ="F*nStrlng4Cu$tOmLlc9nc9!",i.ME="",i.A18={},i.A0L=!1,i.AB="",i.KD=null,i.ZT=!1,i.QL=["",""],i.L3=0,i.KQ=[],i.A8C=0,i.A8A=0,i.AA9=!1,i.A1A="",i.A6J=!0,i.IC=null,i.QM=[],i.NU=0,i.AAO=!1,i.S9={},i.A1K=!1,i.G1=zingchart.DEV.DOMFRAGMENTS?{}:null,i.A2H=!1,i.SR=[]},clearLabelBoxes:function(e){var i=this;if(e)for(var t=i.SR.length-1;t>=0;t--)i.SR[t].type===e&&i.SR.splice(t,1);else i.SR=[]},usc:function(){return-1!==ZC.AV(this.KQ,"use_single_canvas")},mc:function(e){return e=e||"",ZC.AL(this.K+"-main-c"+(""===e?e:"-"+e))},hideCM:function(){var e;(e=ZC.AL(this.K+"-menu"))&&(e.style.display="none"),this.AA9=!1},ZV:function(){for(var e=this,i=e.NW.length,t=0;t<i;t++)if(null!==ZC._n_(e.NW[t])){switch(e.AB){case"svg":ZC.CR.VX(e.NW[t].ctx,e.NW[t].style,e.NW[t].path.join(" "),e.NW[t].filled);break;case"vml":ZC.CR.VW(e.NW[t].ctx,e.NW[t].style,e.NW[t].path.join(" "),e.NW[t].filled)}e.NW[t]=null}},A92:function(){var s=this,i,A6,EY,A5L;ZC.LICENSE=ZC.LICENSE||zingchart.LICENSE||"",ZC.BUILDCODE=ZC.BUILDCODE||zingchart.BUILDCODE||"",ZC.LICENSEKEY=ZC.LICENSEKEY||zingchart.LICENSEKEY||"",A5L="file:"===document.location.protocol?ZC.HOSTNAME||"":document.location.hostname;var A1S=[A5L],CV=A5L.split(".");for("www"===CV[0]?A1S.push(A5L.replace("www.","")):A1S.push("www."+A5L),i=0;i<=CV.length-2;i++){for(var ABB="*",j=i;j<CV.length;j++)ABB+="."+CV[j];A1S.push(ABB)}function X4(e){if(ZC.NOABOUT&&ZC.NOABOUT instanceof Array){var i=ZC.XR.md5(ZC.A9J(ZC.A9E(e)));-1!==ZC.AV(ZC.NOABOUT,i)&&(s.ABL=!0)}}if(-1!==ZC.AV(A1S,"localhost")||-1!==ZC.AV(A1S,"127.0.0.1"))s.TM=!0,s.A3D=!0,X4("localhost");else{var A2F=[["window.AC.Core.zflags","Q^fhx]XKoJJLnmLPUYiWUuQKAOGnuAIWrSN_ZIj_LYvS`jRkihLOSfysvRQTBtQOUUO^`SdgZUHWKDVQ[xST_SWRLyFKogwOclSB"],["window.jsNorthNine.AppIdentity","09Vczmfsf/Q5G8dRWLio+7PVG0KjUnLRqnRSPOeqf6gu/hpxK6BeHRUtuasojuRTPFQYdzNGN57nxLviTf1hV4lwaFjtbv/tA1g0W0k7AKV1g1ouow1nG/+EJLl0khmPDSKBJa8fkP70KLNtrxt5pE2yjx+IvQ40ajd/03rqqtR="]];for(i=0,A6=A2F.length;i<A6;i++)try{if(eval(A2F[i][0])===ZC.A9E(A2F[i][1])){s.TM=!0;break}}catch(e){}for(i=0,A6=A1S.length;i<A6;i++){var A4H=ZC.XR.md5(ZC.A9J(ZC.A9E(A1S[i])));ZC.LICENSE instanceof Array&&-1!==ZC.AV(ZC.LICENSE,A4H)&&(s.TM=!0,X4(A4H))}ZC.BUILDCODE instanceof Array&&2===ZC.BUILDCODE.length&&(EY=ZC.AD8(s.AAZ),EY=EY.replace("O","0"),s.SD=ZC.ACA(ZC.BUILDCODE[0],EY),s.SD===ZC.BUILDCODE[1]&&(s.TM=!0,s.A3D=!0,X4(ZC.BUILDCODE[0])))}},A8U:function(){var e=this;if(null!==e.MP)ZC._todash_(e.MP),e.load();else if(null===ZC._n_(ZC.cache.data["defaults-"+e.QQ])){var i=["query-string"===e.N6?"zcrandom="+Math.random():"",zingchart.ZCOUTPUT?"zcoutput="+e.AB:""].join("&");ZC.A4.ajax({type:"GET",url:e.QQ,dataType:"text",beforeSend:function(i){e.RV.defaults||"http-headers"!==e.N6||i.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:i,error:function(i,t,n,a){return e.O1({name:"Network error",message:"Resource not found ("+a+")"},"URL Data loader"),!1},success:function(i){var t;try{t=JSON.parse(i),ZC.cache.data["defaults-"+e.QQ]=i}catch(n){return e.O1(n,"JSON parser"),!1}e.MP=t,ZC._todash_(e.MP),e.load()}})}else{var t;try{t=JSON.parse(ZC.cache.data["defaults-"+e.QQ])}catch(n){return e.O1(n,"JSON parser"),!1}e.MP=t,ZC._todash_(e.MP),e.load()}},load:function(e,i){var t=this;if(t.ME="load",""!==(i=i||t.QJ)&&0!==i.indexOf("javascript:"))if(null===ZC._n_(ZC.cache.data["data-"+i])){var n=["query-string"===t.N6?"zcrandom="+Math.random():"",zingchart.ZCOUTPUT?"zcoutput="+t.AB:""].join("&");ZC.A4.ajax({type:"GET",url:i,dataType:"text",beforeSend:function(e){t.RV.data||"http-headers"!==t.N6||e.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:n,error:function(e,i,n,a){return t.O1({name:"Network error",message:"Resource not found ("+a+")"},"URL Data loader"),!1},success:function(i){t.data_(e,i)}})}else t.data_(e,ZC.cache.data["data-"+i]),ZC.cache.data["data-"+i]=null;else""!==t.EV?t.data_(e,t.EV):null!==t.M9&&(t.A71?t.M9=JSON.parse(JSON.stringify(t.A71)):t.A71=JSON.parse(JSON.stringify(t.M9)),t.data_(e,t.M9))},data_:function(e,i){var t=this;ZC.TS[t.K]=(new Date).getTime(),ZC.AP.A83("dataload",t)?ZC.AP.BY("dataload",t,t.FG(),i,function(i){t.load_(e,i)}):t.load_(e,i)},A4W:function(e){var i,t;if(!zingchart.DEV.RESOURCES)return[];e||(e=this.o);var n=[];if(e.graphset)for(i=0,t=e.graphset.length;i<t;i++){var a=e.graphset[i].type||"null";if(-1===ZC.AV(ZC.CHARTS,a)){for(var l in"3d"===a.substring(a.length-2)&&(a=a.substring(0,a.length-2)),ZC.EQUIV)ZC.EQUIV.hasOwnProperty(l)&&-1!==ZC.AV(ZC.EQUIV[l],a)&&(a=l);zingchart.loadModules(a),n.push(a)}}for(this.ACM(e),i=0,t=ZC.RO.length;i<t;i++)""!==ZC.GV(ZC.RO[i])&&-1===ZC.AV(ZC.WG,ZC.GV(ZC.RO[i]))&&n.push(ZC.GV(ZC.RO[i]));return n},ACM:function(e){e||(e=this.o)},load_:function(JJ,U0){var s=this,G;s.E.rawsource=zingchart.DEV.KEEPSOURCE?U0:"N/A";var DL=null;if("string"==typeof U0)try{DL=JSON.parse(U0)}catch(J8){try{DL=eval("("+U0+")")}catch(J8){return s.O1(J8,"JSON parser"),!1}}else DL=U0;null===ZC._n_(DL.graphset)&&(DL={graphset:[DL]}),s.E.source="N/A",zingchart.DEV.KEEPSOURCE&&(s.E.source=ZC.GV(JSON.stringify(DL))),zingchart.A1E(s,s.A4W(DL),function(){DL=ZC.AP.BY("dataparse",s,s.FG(),DL),zingchart.A1E(s,s.A4W(DL),function(){if(ZC.AP.BY("modulesready",s,{id:s.K}),null===ZC._n_(JJ))s.XU(DL),s.o=DL,s.A19?(s.parse(),s.paint()):s.QE(function(){s.parse(),s.paint()});else{var e=s.OS(JJ);if(null!==e&&null!==ZC._n_(G=DL.graphset)){var i=G.length>1?G[e.L]:G[0];i.id||(i.id=e.o.id||""),s.o.graphset[e.L]=i,s.QE(function(){s.parse(JJ),s.AG[e.L].paint()})}}})})},XU:function(DL){var s=this,G,i,A6,j,J9;for(null===ZC._n_(DL.graphset)&&(DL={graphset:[DL]}),1===DL.graphset.length&&null===ZC._n_(DL.graphset[0])&&(DL.graphset=[{type:"null"}]),i=0,A6=DL.graphset.length;i<A6;i++)if(null!==ZC._n_(DL.graphset[i])){if(null!==ZC._n_(G=DL.graphset[i].shapes)){var FH=[];for(DL.graphset[i].labels=DL.graphset[i].labels||[],j=0,J9=G.length;j<J9;j++)if(G[j].generated&&G[j]["map-item"]||FH.push(G[j]),null!==ZC._n_(G[j].type)&&0===G[j].type.indexOf("zingchart."))try{var LW=G[j].options||{},EC=G[j].type+"."+(LW.name||"");LW.graphid=i;var A30=eval(EC).call(s,LW,DL,G[j]);for(var A3F in A30)A30.hasOwnProperty(A3F)&&("label"===A30[A3F].objtype?DL.graphset[i].labels.push(A30[A3F]):FH.push(A30[A3F]))}catch(e){}DL.graphset[i].shapes=FH}var A6U;if(null!==ZC._n_(A6U=DL.graphset[i].widgets))for(var AAX=s.A4O(DL,i),k=0;k<A6U.length;k++){var A36=A6U[k];if(null!==ZC._n_(A36.type)&&null!==ZC._n_(zingchart.widgets[A36.type])&&"function"==typeof zingchart.widgets[A36.type].parse)try{var BI={};ZC._cp_(A36,BI),BI.graph=AAX.graph,BI.loader={id:s.K,width:s.I,height:s.F};var o=zingchart.widgets[A36.type].parse.call(s,BI);if(null!==ZC._n_(G=o.graphs))for(j=0;j<G.length;j++)DL.graphset.push({}),ZC._cp_(G[j],DL.graphset[DL.graphset.length-1]);if(null!==ZC._n_(G=o.labels))for(null===ZC._n_(DL.graphset[i].labels)&&(DL.graphset[i].labels=[]),j=0;j<G.length;j++)DL.graphset[i].labels.push(G[j]);if(null!==ZC._n_(G=o.shapes))for(null===ZC._n_(DL.graphset[i].shapes)&&(DL.graphset[i].shapes=[]),j=0;j<G.length;j++)DL.graphset[i].shapes.push(G[j])}catch(e){}}}},AAC:function(e,i){var t=this;switch(e){case"line":return new ZC.A6C(t);case"area":return new ZC.A6D(t);case"vline":return new ZC.A9F(t);case"varea":return new ZC.A9D(t);case"bar":case"vbar":case"column":return new ZC.A2N(t);case"hbar":return new ZC.A2G(t);case"mixed":case"hmixed":case"mixed3d":for(var n=!1,a=t.o.graphset[i].series,l=0,o=a.length;l<o;l++)a[l]&&a[l].type&&-1!==a[l].type.indexOf("3d")&&(n=!0);return n?new ZC.A31(t):t.o.graphset[i].plot&&t.o.graphset[i].type&&t.o.graphset[i].plot&&t.o.graphset[i].plot.type&&-1!==t.o.graphset[i].plot.type.indexOf("3d")?new ZC.A31(t):"mixed"===e?new ZC.A58(t):new ZC.A8Z(t);case"scatter":return new ZC.A89(t);case"hscatter":return new ZC.A7G(t);case"bubble":return new ZC.A8P(t);case"hbubble":return new ZC.A84(t);case"ring":case"pie":return new ZC.A3U(t);case"nestedpie":return new ZC.A6N(t);case"radar":case"polar":return new ZC.A9W(t);case"venn":return new ZC.AAI(t);case"bullet":case"vbullet":return new ZC.A80(t);case"hbullet":return new ZC.A82(t);case"funnel":case"vfunnel":return new ZC.A87(t);case"hfunnel":return new ZC.A86(t);case"heatmap":case"piano":return new ZC.A9C(t);case"stock":return new ZC.AA3(t);case"range":return new ZC.A98(t);case"vrange":return new ZC.ZCVRangeGraph(t);case"gauge":return new ZC.AA7(t);case"line3d":return new ZC.A8T(t);case"area3d":return new ZC.A8W(t);case"ring3d":case"pie3d":return new ZC.A5G(t);case"bar3d":case"vbar3d":return new ZC.A8Y(t);case"hbar3d":return new ZC.A8Q(t);case"null3d":return new ZC.A8V(t);default:return new ZC.AAD(t)}},OS:function(e){for(var i=this,t=0,n=i.AG.length;t<n;t++)if(i.AG[t].K===i.K+"-graph-"+e||i.AG[t].K===i.K+"-graph-id"+e||i.AG[t].K===e||t===e)return i.AG[t];return null},A4A:function(e,i){var t=this,n=ZC.A4("#"+t.K+("svg"===t.AB?"-top":"-main")),a=ZC._tx_(t.K);e-=n.offset().left,i-=n.offset().top;for(var l=null,o=0,r=t.AG.length;o<r;o++)ZC.DS(e,t.AG[o].iX,t.AG[o].iX+t.AG[o].I*a[0])&&ZC.DS(i,t.AG[o].iY,t.AG[o].iY+t.AG[o].F*a[1])&&(l=t.AG[o]);return l},AA4:function(e){var i,t=this;if("undefined"==typeof t.E.themesloaded){void 0===e&&(e=!1),t.assign_a([["theme","LI"]]),t.o.graphset&&1===t.o.graphset.length&&null!==ZC._n_(i=t.o.graphset[0].theme)&&(t.LI=i),""===t.LI&&(t.LI="light"),t.LI=String(t.LI).replace("zingchart","classic");for(var n=t.LI.split(/\s+|;|,/),a=0,l=n.length;a<l;a++)t.B8.AAY(n[a]);t.B8.A8U(t.MP),ZC.mobile&&t.B8.AAY("mobile"),e||(t.E.themesloaded=!0)}},parse:function(e){var i,t,n,a,l,o,r=this;r.NF="x",r.E.json=ZC.GV(JSON.stringify(r.o)),ZC._cp_(r.o.layers,r.NR),1===r.o.graphset.length&&ZC._cp_(r.o.graphset[0].layers,r.NR);var s=r.FG();if(null!==ZC._n_(e)&&(s.graphid=e),ZC.AP.BY("dataready",r,s),r.ME="parse",r.QL[1]=r.QL[0],r.QL[0]="",r.QL[0]+=r.I+":"+r.F+":",null!==ZC._n_(i=r.o.graphset))for(r.QL[0]+=i.length+":",a=0;a<i.length;a++)r.QL[0]+=(i[a].type||"")+":",r.QL[0]+=(i[a].x||"")+":"+(i[a].y||"")+":"+(i[a].width||"")+":"+(i[a].height||"")+":",null!==ZC._n_(i[a].series)&&(r.QL[0]+=i[a].series.length+":");if(ZC.AL(r.K+"-main-c")&&r.clear(e,!1),"undefined"!=typeof ZC.A4Z&&(r.H1=new ZC.A4Z(r)),null===ZC._n_(e)){r.AA4(),r.B8.B8["font-family"]&&(zingchart.FONTFAMILY=r.B8.B8["font-family"]);var A=!!r.o.gui;if(r.B8.load(r.o,"loader",!1,!0),r.assign_a([["gui","DG"],["globals","QV"]]),r.o.graphset&&1===r.o.graphset.length&&(t=r.o.graphset[0],null!==ZC._n_(i=t.gui)&&(r.DG=i),null!==ZC._n_(i=t.globals)&&(r.QV=i)),ZC._todash_(r.QV),ZC._cp_(r.B8.B8.root.gui,r.DG,!1,!0,!0),r.DG.behaviors)for(a=r.DG.behaviors.length-1;a>=0;a--)for(o=0;o<a;o++)if(r.DG.behaviors[a].id===r.DG.behaviors[o].id){r.DG.behaviors.splice(a,1);break}if(A||delete r.o.gui,ZC._todash_(r.DG),r.O={},null!==ZC._n_(i=r.o.style))for(n in i)"url"!==n&&(r.O[n]=i[n]);if(r.o.graphset&&1===r.o.graphset.length&&(t=r.o.graphset[0],null!==ZC._n_(i=t.style)))for(n in i)"url"!==n&&(r.O[n]=i[n]);ZC._todash_(r.O),r.NR.graphset&&r.b(),r.assign_a([["locale","A14"],["set-locale","A14"],["layout","NF"],["h-space","A8C","i"],["v-space","A8A","i"],["flat","K9","b"],["show-progress","A0L","b"]]),r.o.graphset&&1===r.o.graphset.length&&(t=r.o.graphset[0],null!==ZC._n_(i=t.locale)&&(r.A14=i),null!==ZC._n_(i=t["set-locale"])&&(r.A14=i),null!==ZC._n_(i=t.flat)&&(r.K9=ZC._b_(i)),null!==ZC._n_(i=t["show-progress"])&&(r.A0L=ZC._b_(i))),null!==ZC._n_(i=zingchart.i18n[r.A14])&&(ZC.HJ=i),r.AG=[]}var C=0,c=0,u=r.I,p=r.F;if(null!==ZC._n_(r.o.margin)||null!==ZC._n_(r.o["margin-top"])||null!==ZC._n_(r.o["margin-right"])||null!==ZC._n_(r.o["margin-bottom"])||null!==ZC._n_(r.o["margin-left"])){var Z=new ZC.HL(r);Z.append(r.o,!1,!1),Z.parse(),C=Z.DY,c=Z.E8,u=u-Z.DY-Z.E9,p=p-Z.E8-Z.DR}var h,d,f=r.OS(e);if(null!==ZC._n_(h=r.o.graphset)){var _=0;for(a=0,l=h.length;a<l;a++)d=0,null!==ZC._n_(i=h[a].page)&&(d=ZC._i_(i)),_+=r.L3===d?1:0;var g=ZC.AR.A2C(r.NF,_),v=ZC._i_(g[0]),b=ZC._i_(g[1]),B=0,m=0,E=0;for(a=0,l=h.length;a<l;a++){if(d=0,null===f&&null!==ZC._n_(i=h[a].page)&&(d=ZC._i_(i)),(null===f||E===f.L)&&r.L3===d){if(r.AG[E]=r.AAC(h[a].type||"null",a),r.AG[E].OB=r.AG[E].AF+"graph",r.B8.load(r.AG[E].o,"graph"),r.B8.load(r.AG[E].o,h[a].type||"null"),r.AG[E].append(r.o.graph),r.AG[E].append(h[a]),r.AG[E].L=E,null===ZC._n_(h[E].id)||""===h[E].id?r.AG[E].K=r.K+"-graph-id"+E:r.AG[E].K=r.K+"-graph-"+h[a].id,h.length>0){for(var D=0,F=0,K=ZC._i_((u-(b+1)*r.A8C)/b),x=ZC._i_((p-(v+1)*r.A8A)/v),I=["x","y","width","height"],y=0;y<I.length;y++)null!==ZC._n_(r.E["graph-"+E+"-"+I[y]])&&(delete r.E["graph-"+E+"-"+I[y]],delete r.AG[E].o[I[y]]);null===ZC._n_(r.AG[E].o.x)?r.E["graph-"+E+"-x"]=r.AG[E].o.x=ZC._i_(r.iX+(B+1)*r.A8C+B*K)+C:(D=ZC.II(r.AG[E].o.x))<1&&(D=ZC._i_(r.I*D)),null===ZC._n_(r.AG[E].o.y)?r.E["graph-"+E+"-y"]=r.AG[E].o.y=ZC._i_(r.iY+(m+1)*r.A8A+m*x)+c:(F=ZC.II(r.AG[E].o.y))<1&&(F=ZC._i_(r.F*F)),null===ZC._n_(r.AG[E].o.width)&&(r.E["graph-"+E+"-width"]=r.AG[E].o.width=Math.max(K,K-D)),null===ZC._n_(r.AG[E].o.height)&&(r.E["graph-"+E+"-height"]=r.AG[E].o.height=Math.max(x,x-F))}r.AG[E].parse()}r.L3===d&&(E++,++B===b&&(m++,B=0))}}null===ZC._n_(e)&&null!==ZC._n_(i=r.o.refresh)&&(r.HP={type:"full",interval:10},ZC._cp_(i,r.HP))},A41:function(e,i){i=i||"";var t=[];for(var n in e)if("object"==typeof e[n])for(var a=this.A41(e[n],i+"."+n),l=0,o=a.length;l<o;l++)-1===ZC.AV(t,a[l])&&t.push(a[l]);else{var r=i+"."+n;"background-image"!==n&&"backgroundImage"!==n||""===e[n]||"zc."===e[n].substring(0,3)||(!ZC.ie67&&ZC.PATTERNS&&"PATTERN_"===e[n].substring(0,8)&&(e[n]=ZC.PATTERNS[e[n].substring(8)]),"!"===e[n].charAt(0)&&(e[n]=e[n].substring(1),this.E["safe-images"]=this.E["safe-images"]||[],this.E["safe-images"].push(e[n])),t.push([e[n],"image"])),"src"===n&&""!==e[n]&&"zc."!==e[n].substring(0,3)&&-1!==r.indexOf(".images.")&&(!ZC.ie67&&ZC.PATTERNS&&"PATTERN_"===e[n].substring(0,8)&&(e[n]=ZC.PATTERNS[e[n].substring(8)]),"!"===e[n].charAt(0)&&(e[n]=e[n].substring(1),this.E["safe-images"]=this.E["safe-images"]||[],this.E["safe-images"].push(e[n])),t.push([e[n],"image"])),".csv"===r.substr(r.length-4,4)&&"string"==typeof e[n]&&t.push([e[n],"csv"]),"url"===n&&(-1!==r.indexOf(".style.")&&t.push([e[n],"css"]),-1!==r.indexOf(".csv.")&&t.push([e[n],"csv"]),-1!==r.indexOf(".marker.")&&t.push([e[n],"image"])),"string"==typeof e[n]&&"url"!==n&&(0===e[n].indexOf("url:")&&"values"===n||0===e[n].indexOf("javascript:"))&&-1===ZC.AV(["format","text","tooltipText"],ZC.EE(n))&&t.push([e[n],"data"])}return t},QE:function(JA){var s=this;if(zingchart.DEV.RESOURCES){var J4=s.A41(s.o).concat(s.A41(s.MP));if(0!==J4.length){var UP=0,LH={},A1W=0;s.E["safe-images"]=s.E["safe-images"]||[];var C4=window.setInterval(function(){if(UP>=J4.length){for(var e in window.clearInterval(C4),s.ABM(s.o),LH)if(0!==e.indexOf("data:")&&-1===ZC.AV(s.E["safe-images"],e))try{var i=document.createElement("canvas");i.width=LH[e].width,i.height=LH[e].height,i.getContext("2d").drawImage(LH[e],0,0);var t=i.toDataURL("image/png");LH[e].onload=null,LH[e].onerror=null,LH[e].src=t,ZC.cache.data[e]=LH[e]}catch(n){}window.setTimeout(function(){zingchart.Y1[s.K]&&JA()},1)}else A2Q(++A1W)},20);A2Q(A1W)}else zingchart.Y1[s.K]&&JA()}else zingchart.Y1[s.K]&&JA();function A2Q(i){if(!(i>=J4.length)){var EV,MG,KE=J4[i][0],A0I=J4[i][1];if("url:"===KE.substring(0,4)){var QJ=KE.substring(4);s.QO["url:"+QJ]="[]";try{EV=["query-string"===s.N6?"zcrandom="+Math.random():""].join("&"),ZC.A4.ajax({type:"GET",url:QJ,beforeSend:function(e){s.RV.data||"http-headers"!==s.N6||e.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:EV,error:function(e,i,t,n){return s.O1({name:"Network error",message:"Resource not found ("+n+")"},"URL Data loader"),!1},success:function(e,i,t,n){s.QO["url:"+n]=e,UP++}})}catch(J8){return s.O1(J8,"URL Data loader"),!1}}else if("javascript:"===KE.substring(0,11))if("zc.ext.load"===s.QO[KE]){s.QO[KE]="[]";var DW=ZC.AP.AAE(KE.substring(11)),N={id:s.K,resource:KE,callback:function(e){s.QO[KE]=e,UP++}},ZY=DW[0];N.arguments=DW[1];try{var ZN=eval(ZY).call(s,N);null!==ZC._n_(ZN)&&ZN&&(s.QO[KE]=ZN,UP++)}catch(J8){return s.O1(J8,"JavaScript data loader"),!1}}else UP++;else"image"===A0I?(LH[KE]=new Image,LH[KE].crossOrigin="anonymous",LH[KE].onload=function(){UP++},LH[KE].onerror=function(){var e=ZC._b_(s.o.strict);if(ZC.IMG404.push(KE),e)return s.O1({name:"Network error",message:"Resource not found ("+this.src+")"},"Resource loader (image)"),!1;this.src=ZC.BLANK,UP++},LH[KE].src=KE,ZC.cache.data[KE]=LH[KE]):"css"===A0I?(EV=["query-string"===s.N6?"zcrandom="+Math.random():""].join("&"),ZC.A4.ajax({type:"GET",url:KE,beforeSend:function(e){s.RV.css||"http-headers"!==s.N6||e.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:EV,error:function(e,i,t){return s.O1(t,"Resource loader"),!1},success:function(e){for(var i={},t=e.match(/[a-zA-Z0-9\.\#\-](.+?)\{((.|\s)+?)\}/gi),n=0,a=t.length;n<a;n++){MG=t[n].split("{");var l=ZC.GV(MG[0]),o=l.split(/\s+/);if(1===o.length||2===o.length&&ZC.GV(o[0])==="#"+s.K){i[l=ZC.GV(1===o.length?o[0]:o[1])]||(i[l]={});for(var r=0,A=(MG=MG[1].replace("}","").split(";")).length;r<A;r++){var C=MG[r].split(":");2===C.length&&(i[l][ZC.GV(C[0])]=""+ZC.GV(C[1]))}}}null!==ZC._n_(s.o.style)?ZC._cp_(i,s.o.style):null!==ZC._n_(s.o.graphset)&&1===s.o.graphset.length&&s.o.graphset[0].style&&ZC._cp_(i,s.o.graphset[0].style),UP++}})):"csv"===A0I&&(EV=["query-string"===s.N6?"zcrandom="+Math.random():""].join("&"),ZC.A4.ajax({type:"GET",url:KE,beforeSend:function(e){s.RV.csv||"http-headers"!==s.N6||e.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:EV,error:function(e,i,t){return s.O1(t,"Resource loader"),!1},success:function(e,i,t,n){s.A9V[n]=e,UP++}}))}}},ABM:function(C0){var s=this;for(var p in C0)if("object"==typeof C0[p])s.ABM(C0[p]);else for(var EV in s.QO)EV===C0[p]&&(C0[p]=eval(s.QO[EV]))},resize:function(e){var i,t,n,a,l=this;if(l.E.resize=!0,l.E.wh=l.I+"/"+l.F,l.o.graphset)if(l.A1K)zingchart.exec(l.K,"destroy"),zingchart.render(zingchart.params[l.K]);else{for(void 0===e&&(e=!1),t=0;t<l.AG.length;t++)null!==ZC._n_(l.H1)&&l.H1.IM&&l.H1.TI(null),null!==ZC._n_(l.AG[t].HS)&&l.AG[t].HS.IM&&l.AG[t].HS.M6(null),null!==ZC._n_(l.AG[t].HQ)&&l.AG[t].HQ.IM&&l.AG[t].HQ.M6(null),null!==ZC._n_(l.AG[t].B9)&&l.AG[t].B9.A3X&&l.AG[t].B9.TO();if(ZC.AP.BY("resize",l,l.FG()),e=!1);else{for(t=0;t<l.AG.length;t++)for(a=0;a<l.AG[t].AY.A5.length;a++)l.E["g-"+t+"-p-"+a+".visible"]=l.AG[t].E["plot"+a+".visible"];for(t=0;t<l.AG.length;t++)l.E["g-"+l.AG[t].L+"-selection"]=JSON.stringify(l.AG[t].CB);for(var o=l.o.graphset,r=["labels","shapes"],s=0,A=o.length;s<A;s++)for(var C=0;C<r.length;C++){var c=r[C],u=[];if(null!==ZC._n_(o[s][c])){for(t=0,n=o[s][c].length;t<n;t++)o[s][c][t].generated||u.push(o[s][c][t]);o[s][c]=u}}if(l.XU(l.o),l.o=ZC.AP.BY("dataparse",l,l.FG(),l.o),ZC.A4("#"+l.K+"-top").width(l.I).height(l.F),l.E["from-api"]&&(ZC.A4("#"+l.K+"-wrapper").width(l.I).height(l.F),delete l.E["from-api"]),1===(i=ZC.A4("#"+l.K+"-img")).length&&i.width(l.I).height(l.F).css("clip","rect(1px,"+(l.I-1)+"px,"+(l.F-1)+"px,1px)"),"svg"===l.AB&&(l.KD.setAttribute("width",l.I),l.KD.setAttribute("height",l.F)),"canvas"===l.AB||"vml"===l.AB){for(ZC.A4("#"+l.K+"-main").width(l.I).height(l.F),t=0,n=l.AG.length;t<n;t++)ZC.A4("#"+l.AG[t].K+"-hover").remove();ZC.A4("#"+l.K+"-main>div").width(l.I).height(l.F)}for("canvas"===l.AB&&((i=ZC.AL(l.K+"-main-c"))&&(i.width=l.I,i.height=l.F),(i=ZC.AL(l.K+"-main-c-top"))&&(i.width=l.I,i.height=l.F),ZC.A4("#"+l.K+"-objects-bottom canvas, #"+l.K+"-objects-top canvas, #"+l.K+"-tools canvas").each(function(){this.width=l.I,this.height=l.F})),"vml"===l.AB&&ZC.A4("#"+l.K+"-objects-bottom div, #"+l.K+"-objects-top div, #"+l.K+"-tools div").each(function(){this.style.width=l.I+"px",this.style.height=l.F+"px"}),l.parse(),t=0,n=l.AG.length;t<n;t++)l.AG[t].U7&&l.AG[t].U7(),l.AG[t].HH=!0,l.AG[t].A63=l.AG[t].GD,l.AG[t].GD=!1;for(l.paint(),t=0;t<l.AG.length;t++)for(a=0;a<l.AG[t].AY.A5.length;a++)delete l.E["g-"+t+"-p-"+a+".visible"];for(t=0;t<l.AG.length;t++)l.AG[t].HH=!1,l.AG[t].GD=l.AG[t].A63,delete l.AG[t].A63,delete l.E["g-"+l.AG[t].L+"-selection"]}}},clearGenerated:function(){var e=this.o.graphset,i=["labels","shapes"];if(e)for(var t=0,n=e.length;t<n;t++)for(var a=0;a<i.length;a++){var l=i[a],o=[];if(null!==ZC._n_(e[t][l])){for(var r=0,s=e[t][l].length;r<s;r++)e[t][l][r].generated||o.push(e[t][l][r]);e[t][l]=o}}},clear:function(e,i,t){var n=this;for(var a in n.E)-1!==a.indexOf("-label-")&&-1!==a.indexOf("-bounds")&&delete n.E[a];if(void 0===i&&(i=!0),ZC.A4("."+n.K+"-history-area").die("click",n.A0Q),ZC.A4("."+n.K+"-history-area").remove(),null!==ZC._n_(e))n.OS(e).clear();else{i&&n.clearGenerated(),n._unbind_();for(var l=0,o=n.AG.length;l<o;l++)"vml"===n.AB&&t?n.AG[l].destroy():n.AG[l].clear();var r,s,A;null!==(r=ZC.AL(n.K+"-main-c"))&&ZC.Q.IV(r,n.AB,n.iX,n.iY,n.I,n.F),null!==(A=ZC.AL(n.K+"-main-c-top"))&&ZC.Q.IV(A,n.AB,n.iX,n.iY,n.I,n.F),null!==(s=ZC.AL(n.K+"-trigger-c"))&&(ZC.Q.IV(s,n.AB,n.iX,n.iY,n.I,n.F),ZC.A4("#"+n.K+"-menu-area").remove()),n.A7&&n.A7.hide(),ZC.A4("."+n.K+"-menu-item").remove(),ZC.Q.EU([n.K+"-menu-trigger",n.K+"-menu"]),ZC.Q.EU(n.K+"-license-text"),null!==n.IC&&ZC.Q.EU([n.K+"-history-path",n.K+"-history-back-path",n.K+"-history-forw-path",n.K+"-history-gradient",n.K+"-history-back-gradient",n.K+"-history-forw-gradient"])}},AAS:function(){var e,i,t,n=this,a=n.I+"/"+n.F,l=ZC.Q.HY({id:n.K+"-wrapper",position:"relative",p:ZC.AL(n.K)});ZC.Q.PI(l,{height:"100%"===n.MT?n.MT:n.F+"px",width:"100%"===n.FY?n.FY:n.I+"px"}),n.bA11y&&ZC.Q.G3(l,{tabindex:0,"aria-label":"ZingChart "+n.OZ});var o=ZC.Q.HY({cls:"zc-rel zc-top",wh:a,id:n.K+"-top",overflow:"hidden",position:"absolute",p:l});switch(zingchart.OFFSET&&(o.style.left="-0.5px",o.style.top="-0.5px"),n.AB){case"svg":n.KD=ZC.Q.F6("svg","http://www.w3.org/2000/svg"),n.KD.setAttributeNS&&n.KD.setAttributeNS(null,"xlink","http://www.w3.org/1999/xlink"),ZC.Q.G3(n.KD,{version:"1.1",id:n.K+"-svg","class":"zc-svg",width:n.I,height:n.F,display:"block"}),o.appendChild(n.KD);var r=ZC.Q.F6("defs","http://www.w3.org/2000/svg");if(r.id=n.K+"-defs",n.KD.appendChild(r),ZC.Q.JZ({cls:"zc-rel zc-main",wh:a,id:n.K+"-main",p:n.KD},n.AB),n.A24=[],n.o.graphset)for(e=0,i=n.o.graphset.length;e<i;e++)if((t=n.o.graphset[e].resources)&&t.length)for(var s=0;s<t.length;s++)if("css"===t[s].type&&t[s].url){var A=ZC.Q.F6("link","http://www.w3.org/2000/svg");ZC.Q.G3(A,{xmlns:"http://www.w3.org/1999/xhtml",href:t[s].url,rel:"stylesheet",type:"text/css"}),n.A24.push(t[s].url),r.appendChild(A)}break;case"vml":case"canvas":ZC.Q.HY({cls:"zc-rel zc-main",wh:a,id:n.K+"-main",p:o})}},paintHistory:function(){},paint:function(){var e=this;e.ME="paint";var i=e.I+"/"+e.F;if(e.A0C(),null===ZC.AL(e.K+"-top")){e.AAS();var t=ZC.AL(e.K+"-main");if(e.NR.graphset&&ZC.Q.HE({cls:"zc-abs",id:e.K+"-main-c",wh:i,p:t},e.AB),e.H.usc())ZC.Q.HE({cls:"zc-abs",id:e.K+"-main-c-top",wh:i,p:t},e.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-print-c",p:t,wh:i,display:"none"},e.AB);else{ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-bottom",p:t},e.AB),zingchart.DEV.MAPSONBOTTOM&&ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-maps",p:t},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-graphset",p:t},e.AB),zingchart.DEV.MAPSONBOTTOM||ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-maps",p:t},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-top",p:t},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-hover",p:t},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-front",p:t},e.AB),ZC.Q.JZ({cls:"zc-abs zc-text",wh:i,id:e.K+"-text",p:t},e.AB);var n="legend",a="tools";("legend"===e.o["top-layer"]||e.o.graphset&&1===e.o.graphset.length&&"legend"===e.o.graphset[0]["top-layer"])&&(n="tools",a="legend"),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-"+n,p:t},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-"+a,p:t},e.AB);var l=ZC.AL(e.K+"-tools");e.NR["static"]&&ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-static-c",wh:i,p:l},e.AB),e.NR.guide&&ZC.Q.HE({cls:"zc-abs zc-layer zc-guide-c",id:e.K+"-guide-c",wh:i,p:l},e.AB),(ZC.A4.browser.opera&&ZC._i_(ZC.A4.browser.version)<=9.5||ZC.mobile||"classic"!==e.LI)&&ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-trigger-c",wh:i,p:l},e.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-print-c",p:l,wh:i,display:"none"},e.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-textprint-c",p:l,wh:i,display:"none"},e.AB),ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-text-top",p:t},e.AB)}if(!zingchart.DEV.SKIPTRACKERS){var o=document.createElement("img");if(o.id=e.K+"-img",o.className="zc-img",o.setAttribute("useMap","#"+e.K+"-map"),o.setAttribute("alt","ZingChart "+e.OZ),ZC.Q.PI(o,{position:"absolute",borderWidth:0,width:e.I+2*ZC.MAPTX+"px",height:e.F+2*ZC.MAPTX+"px",left:-ZC.MAPTX+"px",top:-ZC.MAPTX+"px",zIndex:0,opacity:0,filter:"alpha(opacity=0)",clip:"rect("+(ZC.MAPTX+1)+"px,"+(e.I+ZC.MAPTX-1)+"px,"+(e.F+ZC.MAPTX-1)+"px,"+(ZC.MAPTX+1)+"px)"}),o.src=(ZC.ie67?"//":"")+ZC.BLANK,ZC.AL(e.K+"-top").appendChild(o),!e.H.usc()){var r=document.createElement("map");r.className="zc-map",ZC.Q.G3(r,{id:e.K+"-map",name:e.K+"-map"}),ZC.AL(e.K+"-top").appendChild(r);for(var s=0;s<e.AG.length;s++)r.innerHTML+='<area shape="rect" coords="0,0,1,1" id="mark'+s+'">'}}}e.Z=ZC.AL(e.K+"-main-c"),e.b();var A,C,c=!1,u=!1;for(A=0,C=e.AG.length;A<C;A++){e.AG[A].paint(),(null!==e.AG[A].CX&&e.AG[A].CX.AN||null!==e.AG[A].HB&&e.AG[A].HB.AN)&&(c=!0);for(var p=0;p<e.AG[A].BO.length;p++)if(e.AG[A].BO[p].GN){u=!0;break}}if(e.G1){for(var Z in e.G1)ZC.AL(Z).appendChild(e.G1[Z]);e.G1=null}if(e.E.preservezoom=null,e.TM||e.UC||(e.Z3?e.A8R():e.Z3=window.setInterval(function(){e.A92(),e.TM||e.UC?(window.clearInterval(e.Z3),ZC.Q.EU(e.K+"-license-text")):ZC.AL(e.K+"-license-text")||e.A8R()},2e3)),ZC.A4("."+e.K+"-node-area").live("focus",function(e){var i=e.target.id.split("-");"plot"===i[4]&&"node"===i[6]&&zingchart.exec(i[0],"showtooltip",{graphid:i[2],plotindex:i[5],nodeindex:i[7]})}),-1===ZC.AV(e.KQ,"skip_context_menu")&&e.A5W(),-1===ZC.AV(e.KQ,"skip_interactivity")?("undefined"!=typeof ZC.A27&&(e.A7=new ZC.A27(e)),u&&e.H1.bind(),c&&"undefined"!=typeof ZC.JR&&(e.D7=new ZC.JR(e),e.D7.bind()),ZC.mobile&&(e.AFW=function(i){ZC.swipe={xy:ZC.Q.MF(i),ts:(new Date).getTime()},i.target.id===e.K+"-menu-area"?(ZC.move=!1,e.A7&&e.A7.hide(),zingchart.YS(i)):(null===e.DG||null===ZC._n_(e.DG["page-scroll"])||e.DG["page-scroll"]||i.preventDefault(),ZC.move=!1,e.hideCM(),e.A7&&e.A7.hide(),e.YI(i))},e.OT=function(){window.clearTimeout(e.AAW),e.A3S=null},e.AFT=function(i){if(ZC.swipe){var t=ZC.Q.MF(i);if(ZC._a_(t[0]-ZC.swipe.xy[0])>100&&(new Date).getTime()-ZC.swipe.ts<1e3){var n=e.FG();n.direction=t[0]>ZC.swipe.xy[0]?"right":"left",ZC.AP.BY("swipe",e,n)}ZC.swipe=null}e.AA9||ZC.move||zingchart.S8(i),e.OT(i)},ZC.A4("#"+e.K+"-img").bind("touchstart",e.AFW).bind("touchmove",e.OT).bind("touchend",e.AFT),ZC.A4("#"+e.K+"-menu-area").live("touchstart",e.AFW)),e.zc_loader_mousewheel=function(i){var t=e.FG();t.ev=i,ZC.AP.BY("mousewheel",e,t)},ZC.A4("#"+e.K+"-img").bind("mousewheel",e.zc_loader_mousewheel),ZC.A4("#"+e.K+"-map").bind("mousewheel",e.zc_loader_mousewheel),"svg"===e.AB&&ZC.A4("#"+e.K+"-svg").bind("mousewheel",e.zc_loader_mousewheel),e.A25=function(i){27===i.keyCode&&e.QU&&(e.A7S||e.A96())},ZC.A4(document).bind("keyup",e.A25),e.A96=function(){ZC.A4("#"+e.K+"-menu-item-exitfullscreen").die("click",e.A96),ZC.FSSTATUS=null,ZC.Q.EU(e.K+"-data-table"),e.destroy(),zingchart.FSID&&ZC.AL(zingchart.FSID)&&(ZC.AL(zingchart.FSID).style.display="none")},ZC.A4("#"+e.K+"-menu-item-exitfullscreen").live("click",e.A96)):ZC.mobile&&(e.zc_loader_touchstart_static=function(e){return e.preventDefault(),zingchart.S8(e),!1},ZC.A4("#"+e.K+"-img").bind("touchstart",e.zc_loader_touchstart_static)),null!==e.HP){var h=ZC._i_(e.HP.interval);h=h>=50?h:1e3*h,window.setTimeout(function(){e.N4(),e.load()},h)}e.ME="",ZC.TS[e.K]=(new Date).getTime()-ZC.TS[e.K],e.E["fire-complete"]&&(ZC.AP.BY("complete",e,e.FG()),e.E["fire-complete"]=null),e.E["fire-load"]&&(ZC.AP.BY("load",e,e.FG()),e.E["fire-load"]=null)},togglePreviewMasks:function(e){for(var i=this,t=0;t<i.AG.length;t++)i.AG[t].B9&&i.AG[t].B9.toggleMasks(e)},createPreviewMasks:function(){var e=this,i=document.createElement("canvas");i.width=e.I,i.height=e.F,i.setAttribute("class","");for(var t=0;t<e.AG.length;t++)e.AG[t].B9&&e.AG[t].B9.toggleMasks(!0,i);return i},AGC:function(){null===ZC._n_(ZC.showZCAbout)&&(ZC.showZCAbout=function(e){zingchart.exec(e.id,"toggleabout")}),zingchart.exec(this.K,"addmenuitem",{text:"About ZingChart","function":"ZC.showZCAbout()",order:100})},A8R:function(){var e,i=this,t={},n=i.DG.watermark;i.B8.load(t,"loader.gui.watermark"),n&&ZC._cp_(n,t),1===i.o.graphset.length&&i.o.graphset[0].gui&&(e=i.o.graphset[0].gui.watermark)&&ZC._cp_(e,t);var a=ZC._l_(ZC._i_(t.type||1),1,2),l=t.position||"br";-1===ZC.AV(["tl","tr","br","bl"],l)&&(l="br"),i.ACS=l;var o,r=32,s=146,A=0,C=1;ZC.ie67&&(r=30,s=168,A=8,C=1),s=126,r=22;var c={light:["#6D6E71","#00384A"],dark:["#FFFFFF","#09A9DA"]},u=c.light;if(zingchart.THEME&&(u="light"===i.LI||"classic"===i.LI?c.light:c.dark),1===i.o.graphset.length)if(i.o.graphset[0]["background-color"]){var p=ZC.AP.G9(i.o.graphset[0]["background-color"]);7===p.length&&(u=ZC.AP.A9O(p,c.dark,c.light))}else if(i.o.graphset[0].theme){var Z=i.o.graphset[0].theme;u="light"===Z||"classic"===Z?c.light:c.dark}var h,d,f="undefined"!=typeof window&&window.location?window.location.origin:"",_="undefined"!=typeof window&&window.location?window.location.pathname:"";switch(o='<a title="JavaScript Charts by ZingChart" style="color:'+u[0]+' !important;font-size:11px !important;display:block !important;opacity:1 !important; text-decoration:none;" href="http://www.zingchart.com/?origin='+f+"&pathname="+_+'">Powered by <span style="color:'+u[1]+'; font-weight:bold;">ZingChart</span></a>',l){case"br":h=i.F-r,d=i.I-s;break;case"bl":h=i.F-r,d=6;break;case"tr":h=2,d=i.I-s;break;case"tl":h=2,d=6}null!==ZC._n_(e=ZC.AL(i.K+"-top"))&&ZC.Q.HY({cls:ZC.ie67?"-ie67":"",p:e,id:i.K+"-license-text",tl:h+"/"+d,wh:s+"/"+(r-A),color:ZC.ie67?1===a?"#369":"#fff":"",padding:A,opacity:C,position:"absolute",cursor:"pointer",fontFamily:zingchart.FONTFAMILY,html:o})},_unbind_:function(){var e=this;ZC.A4("#"+e.K+"-menu").die("mousedown",e.TP),ZC.A4("."+e.K+"-menu-item").die("mousedown",e.TP),ZC.A4("."+e.K+"-menu-item").die("click touchend",e.AGR).die("mouseover",e.AG8).die("mouseout",e.AGN),e.E["menu-item-events"]=!1,ZC.A4("."+e.K+"-node-area").die("focus"),null!==e.H1&&e.H1.unbind(),null!==e.D7&&e.D7.unbind(),ZC.mobile&&(ZC.A4("#"+e.K+"-img").unbind("touchstart",e.AFW).unbind("touchmove",e.OT).unbind("touchend",e.AFT),ZC.A4("#"+e.K+"-menu-area").die("touchstart",e.AFW),ZC.A4("#"+e.K+"-img").unbind("touchstart",e.zc_loader_touchstart_static)),ZC.A4("#"+e.K+"-img").unbind("mousewheel",e.zc_loader_mousewheel),ZC.A4("#"+e.K+"-map").unbind("mousewheel",e.zc_loader_mousewheel),"svg"===e.AB&&ZC.A4("#"+e.K+"-svg").unbind("mousewheel",e.zc_loader_mousewheel),ZC.A4(document).unbind("keyup",e.A25),ZC.A4("#"+e.K+"-menu-item-exitfullscreen").die("click",e.A96)},VK:function(e,i,t){void 0===t&&(t=!1);var n=ZC.AL("zc-menu-"+(t?"sep":"item")+"-"+e);n&&(n.style.display=i?"block":"none")},A5W:function(LG,ev){if(!zingchart.DEV.SKIPCONTEXTMENU){var s=this,G,i,A6,j,J9;void 0===LG&&(LG=-1);var DG={};ZC._cp_(s.DG,DG),-1!==LG&&s.o.graphset[LG]&&ZC._cp_(s.o.graphset[LG].gui,DG,null,null,!0),ZC.A4("#"+s.K+"-menu").remove();var PG=[];for("undefined"==typeof ZC.AO&&PG.push({id:"3D",enabled:"none"},{id:"SwitchTo3D",enabled:"none"},{id:"SwitchTo2D",enabled:"none"}),i=DG.behaviors.length-1;i>0;i--)for(var sBId=DG.behaviors[i].id,ii=i-1;ii>=0;ii--)DG.behaviors[ii].id===sBId&&DG.behaviors.splice(ii,1);if(null!==ZC._n_(G=DG.behaviors))for(i=0,A6=G.length;i<A6;i++){var NA=!1;for(j=0,J9=PG.length;j<J9;j++)PG[j].id===G[i].id&&(NA=!0);NA||PG.push(G[i])}var JI=DG["context-menu"],OI=DG["context-menu[mobile]"];for(i=0,A6=PG.length;i<A6;i++)null!==ZC._n_(PG[i]["function"])&&(null===ZC._n_(JI)&&(JI={}),null===ZC._n_(JI["custom-items"])&&(JI["custom-items"]=[]),JI["custom-items"].push(PG[i]));JI["custom-items"]&&JI["custom-items"].sort(function(e,i){return ZC._i_(e.order||"0")>ZC._i_(i.order||"0")}),s.MX=new ZC.DN(s);var A15=s.LI.split(/\s+|;|,/),E0,LB,U6,ABA,GS;for(i=0,A6=A15.length;i<A6;i++)if(s.B8.NV[A15[i]]){var A10=s.B8.NV[A15[i]].root||{};A10&&A10.gui&&A10.gui.contextMenu&&ZC._cp_(A10.gui.contextMenu,s.MX.o)}if(s.B8.load(s.MX.o,"loader.gui.context-menu"),JI&&s.MX.append(JI),ZC.mobile&&(s.B8.load(s.MX.o,"loader.gui.context-menu[mobile]"),OI&&s.MX.append(OI)),s.MX.V2=!0,s.MX.parse(),s.MX.AN||!s.A3D){if(!ZC.AL(s.K+"-menu-area")){var A55=!!(s.DG&&s.DG["context-menu"]&&s.DG["context-menu"].button)&&ZC._n_(s.DG["context-menu"].button.visible);if(A55||"classic"!==s.LI&&A55){GS=new ZC.DN(s),s.B8.load(GS.o,"loader.gui.context-menu.button"),JI&&ZC._n_(null!==(G=JI.button))&&GS.append(G),ZC.mobile&&(s.B8.load(GS.o,"loader.gui.context-menu[mobile].button"),OI&&null!==ZC._n_(G=OI.button)&&GS.append(G)),ZC._cp_(s.MX.o,JI);var A6T="left"===JI.position||"classic"===s.LI;if(GS.K=s.K+"-menu-trigger",GS.IL=ZC.AL(s.K+"-tools"),GS.Z=GS.C7=ZC.AL(s.K+"-trigger-c"),GS.V2=!0,GS.parse(),GS.AN){GS.paint();var DD=ZC.A4("#"+s.H.K+"-top");if(""===GS.AM){var N0=new ZC.DT(s);if(N0.CZ=!1,s.B8.load(N0.o,"loader.gui.context-menu.gear"),JI&&null!==ZC._n_(G=JI.gear)&&N0.append(G),ZC.mobile&&(s.B8.load(N0.o,"loader.gui.context-menu[mobile].gear"),OI&&null!==ZC._n_(G=OI.gear)&&N0.append(G)),N0.K=s.K+"-menu-trigger-gear",N0.IL=ZC.AL(s.K+"-tools"),N0.Z=ZC.AL(s.K+"-trigger-c"),N0.iX=A6T?GS.iX+GS.I/2:DD.width()-(GS.iX+GS.I/2),N0.iY=GS.iY+GS.F/2,N0.AI=ZC.CY(GS.I,GS.F)/4.5,N0.parse(),N0.paint(),"hamburger"!==N0.DU){var QH=new ZC.DT(s);QH.copy(GS),QH.K=s.K+"-menu-trigger-gear-hole",QH.IL=ZC.AL(s.K+"-tools"),QH.Z=ZC.AL(s.K+"-trigger-c"),QH.DU="circle",QH.AI=ZC.CY(GS.I,GS.F)/7,QH.parse(),QH.iX=A6T?GS.iX+GS.I/2:DD.width()-(GS.iX+GS.I/2),QH.iY=GS.iY+GS.F/2,QH.paint()}}var _iX=A6T?GS.iX:DD.width()-(GS.iX+GS.I);ZC.AL(s.K+"-map").innerHTML+=ZC.Q.FW("rect")+'id="'+s.K+'-menu-area" coords="'+ZC._i_(_iX+ZC.MAPTX)+","+ZC._i_(GS.iY+ZC.MAPTX)+","+ZC._i_(_iX+GS.I+ZC.MAPTX)+","+ZC._i_(GS.iY+GS.F+ZC.MAPTX)+'" />'}}}E0=new ZC.DN(s),s.B8.load(E0.o,"loader.gui.context-menu.item"),JI&&null!==ZC._n_(G=JI.item)&&E0.append(G),ZC.mobile&&(s.B8.load(E0.o,"loader.gui.context-menu[mobile].item"),OI&&null!==ZC._n_(G=OI.item)&&E0.append(G)),E0.V2=!0,E0.parse(),LB=new ZC.DN(s),LB.copy(E0),s.B8.load(LB.o,"loader.gui.context-menu.item.hover-state"),JI&&null!==ZC._n_(JI.item)&&null!==ZC._n_(G=JI.item["hover-state"])&&LB.append(G),ZC.mobile&&(s.B8.load(LB.o,"loader.gui.context-menu[mobile].item.hover-state"),OI&&null!==ZC._n_(OI.item)&&null!==ZC._n_(G=OI.item["hover-state"])&&LB.append(G)),LB.V2=!0,LB.parse(),U6={},JI&&null!==ZC._n_(JI.separator)&&(U6=JI.separator);var JW=[],EJ=null;if(ABA=null!==ZC._n_(s.MX.o.empty)&&ZC._b_(s.MX.o.empty),ZC.mobile&&(EJ=G7("PageScroll"),"none"!==EJ.enabled&&(null===s.DG||null===ZC._n_(s.DG["page-scroll"])||s.DG["page-scroll"]?JW.push(GU("disablepagescroll",EJ.text)):JW.push(GU("enablepagescroll",EJ.text)),JW.push(JC("pagescroll")))),EJ=G7("Reload"),"none"!==EJ.enabled&&(JW.push(GU("reload",EJ.text)),JW.push(JC("reload"))),"undefined"!=typeof ZC.A7W){EJ=G7("SaveAsImage"),"none"!==EJ.enabled&&(EJ=G7("SaveAsImagePNG"),"none"!==EJ.enabled&&JW.push(GU("viewaspng",EJ.text?EJ.text:null)),EJ=G7("SaveAsImageJPG"),"none"!==EJ.enabled&&JW.push(GU("viewasjpg",EJ.text?EJ.text:null)),JW.push(JC("export")));var TC=["DownloadPDF","DownloadSVG","DownloadCSV","DownloadXLS","ViewDataTable","ExportData","Print"],A67=0,A23=0;for(i=0;i<TC.length;i++)"ViewDataTable"===TC[i]&&ZC.AL(s.K+"-data-table")&&(TC[i]="HideDataTable"),EJ=G7(TC[i]),"none"!==EJ.enabled&&(A67++,A23=i,JW.push(GU(TC[i].toLowerCase(),EJ.text)));A67>0&&JW.push(JC(TC[A23].toLowerCase()))}if(-1!==LG){var GN=!1;for(j=0,J9=s.AG[LG].BO.length;j<J9;j++)s.AG[LG].BO[j].GN&&(GN=!0);if(GN&&"undefined"!=typeof ZC.A4Z){var A13=!1;EJ=G7("ZoomIn"),"none"!==EJ.enabled&&(JW.push(GU("zoomin",EJ.text)),A13=!0),EJ=G7("ZoomOut"),"none"!==EJ.enabled&&(JW.push(GU("zoomout",EJ.text)),A13=!0),EJ=G7("ViewAll"),"none"!==EJ.enabled&&(JW.push(GU("viewall",EJ.text)),A13=!0),A13&&JW.push(JC("zoom"))}}var b2D=!1,b3D=!1;if(-1!==LG&&(-1!==ZC.AV(["line","area","bar","vbar","hbar","pie","mixed"],s.AG[LG].AF)&&(b2D=!0,s.XC="2d"),-1!==ZC.AV(["line3d","area3d","bar3d","vbar3d","hbar3d","pie3d","mixed3d"],s.AG[LG].AF)&&(b3D=!0,s.XC="3d")),(b2D||b3D)&&(EJ=G7("3D"),"none"!==EJ.enabled&&(EJ=G7(b2D?"SwitchTo3D":"SwitchTo2D"),"none"!==EJ.enabled&&(JW.push(GU(b2D?"switchto3d":"switchto2d",EJ.text)),JW.push(JC("dimension"))))),-1!==LG){var C=s.AG[LG],AAP=!1,ABI=!1;for(j=0;j<C.BO.length;j++){var B=C.BO[j];0===B.BE.indexOf("scale-y")&&(AAP=!0),"log"===B.C1&&(ABI=!0)}AAP&&(EJ=G7("Progression"),"none"!==EJ.enabled&&(EJ=G7(ABI?"LinScale":"LogScale"),"none"!==EJ.enabled&&(JW.push(GU(ABI?"switchtolin":"switchtolog",EJ.text)),JW.push(JC("progression"))))),(C.CX||C.HB)&&(EJ=G7("Guide"),"none"!==EJ.enabled&&(EJ=G7(C.A1J?"HideGuide":"ShowGuide"),"none"!==EJ.enabled&&(JW.push(GU(C.A1J?"hideguide":"showguide",EJ.text)),JW.push(JC("guide")))))}var AAU=0,B6;if("undefined"!=typeof ZC.A90&&(EJ=G7("ViewSource"),"none"!==EJ.enabled&&(JW.push(GU("viewsource",EJ.text)),AAU++),EJ=G7("BugReport"),"none"!==EJ.enabled&&(JW.push(GU("bugreport",EJ.text)),AAU++)),AAU>0&&JW.push(JC("tools")),EJ=G7("FullScreen"),"none"===EJ.enabled||s.LR||(s.QU?(EJ=G7("ExitFullScreen"),JW.push(GU("exitfullscreen",EJ.text)),JW.push(JC("exitfullscreen"))):(JW.push(GU("fullscreen",EJ.text)),JW.push(JC("fullscreen")))),s.IC&&(EJ=G7("GoBack"),"none"!==EJ.enabled&&JW.push(GU("goback",EJ.text)),EJ=G7("GoForward"),"none"!==EJ.enabled&&JW.push(GU("goforward",EJ.text)),JW.push(JC("history"))),JW.length>0&&-1!==JW[JW.length-1].indexOf("zc-menu-sep")&&JW.splice(JW.length-1,1),s.A1T={},-1!==LG)if(JI&&null!==ZC._n_(B6=JI["custom-items"]))for(JW.length>0&&JW.push(JC("custom")),i=0,A6=B6.length;i<A6;i++){var A3L=!0;if(null!==ZC._n_(B6[i].enabled)&&("none"===B6[i].enabled?A3L=!1:"all"!==B6[i].enabled&&(A3L=!ev||eval(B6[i].enabled).call(s,zingchart.A0A(ev,s),B6[i].id,ev))),A3L){var AM,K=B6[i].id||"custom-"+i;"sep"===B6[i].id||"sep"===B6[i].type?JW.push(JC(K,!0)):"header"===B6[i].type?(AM=B6[i].text||"Custom Menu "+i,JW.push(A2R(K,AM,!0))):(AM=B6[i].text||"Custom Menu "+i,s.A1T[K]={fn:B6[i]["function"]||"",url:B6[i].url||"",target:B6[i].target||""},JW.push(GU(K,AM,!0)))}}s.TM||(JW.push(JC("zingchart")),JW.push(GU("xmiabt","About ZingChart"))),ZC.Q.HY({id:s.K+"-menu",p:document.body,cls:"zc-menu zc-style",top:null===ZC._n_(GS)?0:GS.iY+GS.F/2,left:null===ZC._n_(GS)?0:GS.iX+GS.I/2,borderBottom:s.MX.AU+"px solid "+s.MX.BW,background:(-1===s.MX.A0?"transparent":s.MX.A0)+" "+A1P(s.MX.DA),paddingTop:s.MX.FM,paddingRight:s.MX.FN,paddingBottom:s.MX.FT,paddingLeft:s.MX.EQ,html:JW.join("")}),s.E["menu-item-events"]||(s.AGR=function(e){var i,t=1!==e.target.nodeType?e.target.parentNode.id:e.target.id,n=t.substring(0,t.indexOf("-menu-item-")),a=zingchart.getLoader(n);ZC.mobile&&a.OT();var l=a.A4A(a.SQ[0],a.SQ[1]);a.hideCM(),ZC.mobile&&zingchart.S8(e);var o=t.replace(a.K+"-menu-item-","");a.AAJ({graphid:l?l.K:null,menuitemid:o,ev:ZC.A4.BZ(e)});var r=a.o["export-filename"]||a.o.graphset[0]["export-filename"]||"";switch(o){case"switchto2d":case"switchto3d":l&&a.A54(l.K);break;case"enablepagescroll":s.DG=s.DG||{},s.DG["page-scroll"]=!0;break;case"disablepagescroll":s.DG=s.DG||{},s.DG["page-scroll"]=!1;break;case"showguide":a.Z7(l.K,!0);break;case"hideguide":a.Z7(l.K,!1);break;case"switchtolin":a.A0Y(l.K,"lin");break;case"switchtolog":a.A0Y(l.K,"log");break;case"reload":a.A8S();break;case"viewaspng":a.OE("png");break;case"viewasjpg":a.OE("jpeg");break;case"downloadpdf":a.OE("pdf",""===r?null:{fn:r+".pdf"});break;case"downloadsvg":a.OE("svg",""===r?null:{fn:r+".svg"});break;case"exportdata":zingchart.exec(a.K,"exportdata");break;case"downloadcsv":zingchart.exec(a.K,"downloadCSV",""===r?null:{fn:r});break;case"downloadxls":var A=a.o["export-sheetname"]||a.o.graphset[0]["export-sheetname"]||"ZingChart";(i=G7("DownloadXLS"))["custom-function"]?a.A47({graphid:l?l.K:null,menuitemid:o,filename:r,sheetname:A,"function":i["custom-function"]}):zingchart.exec(a.K,"downloadXLS",""===r?null:{fn:r,sn:A});break;case"viewdatatable":case"hidedatatable":zingchart.exec(a.K,"viewDataTable",{menuid:o});break;case"print":a.A9B();break;case"viewsource":a.A5R();break;case"bugreport":a.A6K();break;case"fullscreen":a.A5S();break;case"goback":zingchart.exec(a.K,"goback");break;case"goforward":zingchart.exec(a.K,"goforward");break;case"zoomin":l&&(a.H1.C=l,a.A8N({graphid:l.K,ev:e}));break;case"zoomout":l&&(a.H1.C=l,a.A8D({graphid:l.K,ev:e}));break;case"viewall":l&&(a.H1.C=l,a.A88({graphid:l.K,ev:e}));break;case"xmiabt":a.A9H();break;default:null!==ZC._n_(G=s.A1T[o])&&(""!==G.fn?a.A47({graphid:l?l.K:null,menuitemid:o,"function":G.fn}):""!==G.url&&l&&l.V4(e,G.url,G.target))}},s.AG8=function(){this.style.backgroundColor=LB.A0,this.style.color=LB.C2,this.style.borderLeft=this.style.borderRight=LB.AU+"px solid "+LB.BW},s.AGN=function(){this.style.backgroundColor=E0.A0,this.style.color=E0.C2,this.style.borderLeft=this.style.borderRight=E0.AU+"px solid "+E0.BW},s.TP=function(e){return e.preventDefault(),!1},ZC.A4("#"+s.K+"-menu").live("mousedown",s.TP),ZC.A4("."+s.K+"-menu-item").live("mousedown",s.TP),ZC.A4("."+s.K+"-menu-item").live("click touchend",s.AGR).live("mouseover",s.AG8).live("mouseout",s.AGN),s.E["menu-item-events"]=!0)}}function A1P(e){return""!==e&&e?"url("+(0===e.indexOf("zc.")?ZC.IMAGES[e]:e)+")":"none"}function JC(e){return'<div id="'+s.K+"-menu-sep-"+e+'" class="zc-menu-sep" style="background-color:'+E0.A0+";background-image:"+A1P(E0.DA)+" repeat-x 50% 0%;border-bottom-width:"+U6["line-width"]+";border-bottom-color:"+U6["line-color"]+';">&nbsp;</div>'}function GU(e,i,t){i=i||ZC.HJ["menu-"+e];var n=void 0!==t&&t?" zc-custom-menu-item "+s.K+"-custom-menu-item":"";return'<div class="'+s.K+"-menu-item"+n+'" style="width:'+s.MX.o.width+";color:"+E0.C2+";font-family:"+E0.GH+";font-size:"+E0.DI+"px;background-color:"+E0.A0+";background-image:"+A1P(E0.DA)+" repeat-x 50% 0%;border-top:"+(ZC.ie67?E0.AU:1)+"px solid "+E0.BW+";border-left:"+E0.AU+"px solid "+E0.BW+";border-right:"+E0.AU+"px solid "+E0.BW+";padding:"+E0.FM+"px "+E0.FN+"px "+E0.FT+"px "+E0.EQ+"px;text-align:"+E0.OD+";"+(ZC.HJ.rtl?"unicode-bidi:bidi-override;direction:rtl;":"")+'" id="'+s.K+"-menu-item-"+e+'">'+i+"</div>"}function A2R(e,i,t){var n=void 0!==t&&t?" zc-custom-menu-header "+s.K+"-custom-menu-header":"";return'<div class="zc-menu-header '+s.K+"-menu-header"+n+'" style="color:'+E0.C2+";background-color:#666;border-top:"+(ZC.ie67?E0.AU:1)+"px solid "+E0.BW+";border-left:"+E0.AU+"px solid "+E0.BW+";border-right:"+E0.AU+"px solid "+E0.BW+";padding:"+E0.FM+"px "+E0.FN+"px "+E0.FT+"px "+E0.EQ+"px;text-align:"+E0.OD+";"+(ZC.HJ.rtl?"unicode-bidi:bidi-override;direction:rtl;":"")+'" id="'+s.K+"-menu-item-"+e+'">'+i+"</div>"}function G7(e){var i={ViewAsImage:"SaveAsImage",ViewAsImagePNG:"SaveAsImagePNG",ViewAsImageJPG:"SaveAsImageJPG"};if(ABA)return{enabled:"none"};for(var t=0,n=PG.length;t<n;t++){if(PG[t].id===e)return PG[t];if(i[PG[t].id]&&i[PG[t].id]===e)return PG[t]}return{enabled:"all"}}},destroy:function(){this._unbind_(),zingchart.HZ.length-=1,this.clear(),ZC.A4("#zc-fullscreen").remove(),document.body.style.overflow=""},N4:function(e,i){var t,n=this;if(null===ZC._n_(i)&&(i=!1),(i||n.A0L)&&-1===ZC.AV(n.KQ,"skip_interactivity"))if(n.ZT=!0,i&&ZC.Q.HY({id:n.K+"-dummy",p:ZC.AL(n.K),wh:n.I+"/"+n.F}),n.E.hideprogresslogo||zingchart.DEV.SKIPPROGRESS)n.ZT=!1;else{var a=ZC.A4("#"+n.K);if(!(void 0===a.offset()||a.width()+a.height()===0||n.E.hideprogresslogo&&n.TM)){var l=a.offset().left+ZC._i_(a.css("border-left-width"))+(null===e?n.iX:e.iX),o=a.offset().top+ZC._i_(a.css("border-top-width"))+(null===e?n.iY:e.iY);(ZC.ipad||ZC.iphone)&&(l-=ZC.A4(window).scrollLeft(),o-=ZC.A4(window).scrollTop());var r=null===e?n.I:e.I,s=null===e?n.F:e.F,A=ZC._i_(.8*n.I),C=30,c=new ZC.DN(n);n.B8.load(c.o,"loader.gui.progress"),c.append(n.E.progress),null!==n.DG&&null!==ZC._n_(t=n.DG.progress)&&c.append(t),c.parse();var u,p=ZC.HJ["progress-wait-long"];if(ZC.ie67)u=c.A0;else{var Z=n.E.customprogresslogo||ZC.IMAGES["zc.logo"];u=c.A0+" url("+Z+") no-repeat center center"}(r<180||s<90)&&(u=c.A0,C=-12),r<120&&r>60?(A=60,p=ZC.HJ["progress-wait-short"]):r<60&&(A=20,p=ZC.HJ["progress-wait-mini"]),p=n.E.customprogresstext||p;var h=ZC.Q.HY({id:n.K+"-progress",p:document.body,tl:o+"/"+l,width:r-2*c.AU,height:s-2*c.AU,position:"absolute",opacity:.8,border:c.AU+"px solid "+c.BW,background:u});ZC.Q.HY({id:n.K+"-progress-text",p:h,width:A,html:p,textAlign:"center",marginLeft:ZC._i_((r-A)/2),marginTop:ZC._i_(s/2+C),fontFamily:zingchart.FONTFAMILY,fontSize:zingchart.FONTSIZE,color:c.C2,fontWeight:"bold"})}}},A0C:function(){var e=this;ZC.Q.EU(e.K+"-dummy"),e.E.hideprogresslogo||(e.ZT=!1,ZC.Q.EU([e.K+"-progress-text",e.K+"-progress"]))},A4O:function(e,i){var t,n,a=this;t=null!==ZC._n_(n=e.graphset)?n:[e];var l=e.layout||"",o=ZC.AR.A2C(l,t.length),r=t[i],s=a.I/o[1],A=a.F/o[0],C=Math.floor(i/o[1]),c=i%o[1]*s,u=C*A;r&&(null!==ZC._n_(n=r.x)&&(c=ZC._p_(n))<=1&&(c=ZC._i_(c*a.I)),null!==ZC._n_(n=r.y)&&(u=ZC._p_(n))<=1&&(u=ZC._i_(u*a.F)),null!==ZC._n_(n=r.width)&&(s=ZC._p_(n))<=1&&(s=ZC._i_(s*a.I)),null!==ZC._n_(n=r.height)&&(A=ZC._p_(n))<=1&&(A=ZC._i_(A*a.F)));var p=[0,0,0,0];if(r.plotarea){if(a.B8.load(r.plotarea,["("+r.type+").plotarea"],!1,!0),null!==ZC._n_(r.plotarea.margin))p=new ZC.HL(null).m_(r.plotarea.margin,"all",s,A);for(var Z=["top","right","bottom","left"],h=0;h<4;h++)if(null!==ZC._n_(r.plotarea["margin-"+Z[h]])){var d=r.plotarea["margin-"+Z[h]];ZC._i_(d)+""==d+""&&(p[h]=ZC._i_(d))}}return{graph:{x:ZC._i_(c),y:ZC._i_(u),width:ZC._i_(s),height:ZC._i_(A),index:i},plotarea:{x:p[3],y:p[0],width:s-p[1]-p[3],height:A-p[0]-p[2]}}},K6:function(){var e=this;null===ZC._n_(e.o.graphset)&&(e.o={graphset:[e.o]}),e.N4(),zingchart.A1E(e,e.A4W(),function(){e.o=ZC.AP.BY("dataparse",e,e.FG(),e.o),zingchart.Y1[e.K]&&e.QE(function(){e.parse(),e.paint()})})},render:function(){var e=this;!function(){function i(){""!==e.QQ||null!==e.MP?e.A8U():e.load()}e.UC||e.A92(),e.N4(null,!0),zingchart.TIMEOUT>0?ZC.ZJ(i):i()}()},YI:function(e){var i=this;null===ZC._n_(i.A3S)&&(i.A3S=(new Date).getTime(),i.AAW=window.setTimeout(function(){null!==ZC._n_(i.A3S)&&(i.A3S=null,zingchart.YS(e))},1500))},FG:function(){var e,i=this,t=0,n=0;return t="undefined"!=typeof i.SQ[0]?i.SQ[0]-t:0,n="undefined"!=typeof i.SQ[1]?i.SQ[1]-n:0,e=i.LI?i.LI:"light",{id:i.K,width:i.I,height:i.F,output:i.AB,x:t,y:n,targetid:i.SQ[2],theme:e}},AC5:function(e){e=e||{},null!==ZC._n_(e.resource)&&(this.QO[e.resource]=e.data||"[]",this.UP++)},A8N:function(){},A8D:function(){},A88:function(){},PZ:function(){},A99:function(e,i){var t=this;if(e=e||{},null!==ZC._n_(e.graphid)){var n=t.OS(e.graphid);null!==n&&n.clear()}else t.clear(null,null,i);ZC.JR&&ZC.JR.GUIDES&&(ZC.JR.GUIDES[t.K]=null)},A7X:function(e){e=e||ZC.HJ["sync-wait"];var i=this;if(null===ZC.AL(i.K+"-blocker")){ZC.Q.HY({cls:"zc-abs zc-style zc-blocker",id:i.K+"-blocker",p:ZC.AL(i.K+"-top"),wh:i.I+"/"+i.F,opacity:.75}),ZC.Q.HY({cls:"zc-blocker-msg",id:i.K+"-blocker-t",p:ZC.AL(i.K+"-blocker"),html:e});var t=ZC.A4("#"+i.K+"-blocker-t");t.css("top",i.F/2-t.height()/2+"px").css("left",i.I/2-t.width()/2+"px")}},A42:function(){ZC.Q.EU(this.K+"-blocker")},A9H:function(){var e=this;ZC.AP.BY("about_show",e,e.FG()),ZC.Q.HY({cls:"zc-abs",id:e.K+"-about-mask",p:ZC.AL(e.K+"-top"),wh:e.I+"/"+e.F,background:"#ccc",opacity:.75});var i=ZC.CY(320,e.I),t=ZC.CY(215,e.F),n=ZC.BQ(0,(e.I-i)/2),a=ZC.BQ(0,(e.F-t)/2),l=ZC.Q.HY({cls:"zc-about zc-style",id:e.K+"-about",p:ZC.AL(e.K+"-top"),tl:a+"/"+n,wh:i-(ZC.quirks?0:10)+"/"+(t-(ZC.quirks?0:10))}),o="";""!==e.SD&&(o="Custom Built for<br />"+e.SD),l.innerHTML='<div class="zc-about-1"><a href="http://www.zingchart.com" target="_blank">zingchart.com</a></div><div class="zc-about-2">&copy;2009-'+(new Date).getFullYear()+'</div><div class="zc-about-3"><div id="'+e.K+'-about-close">'+ZC.HJ["about-close"]+'</div></div><div class="zc-about-4" style="padding:'+(t-215)+'px 5px 5px 5px;"><div>&nbsp;<br />Build '+ZC.VERSION+" ["+e.AB+"]</div>"+o+"</div>",ZC.A4("#"+e.K+"-about-close").bind("click",function(){ZC.AP.BY("about_hide",e,e.FG()),ZC.Q.EU([e.K+"-about",e.K+"-about-mask"])})},O1:function(e,i){var t=this;if(ZC.AP.A83("error",t))ZC.AP.BY("error",t,{id:t.K,error:e,section:i,json:t.E.json||t.E.rawsource});else{var n="";n+="object"==typeof e?e.name+":"+e.message+"\n\n":e+"\n\n",null!==ZC._n_(i)&&(n+="Section:"+i+"\n\n"),n+="JSON data:\n\n"+t.E.json+"\n\n",t.A0C(),null===ZC.AL(t.K+"-top")&&t.AAS(),ZC.Q.HY({cls:"zc-abs zc-error zc-style",id:t.K+"-error",p:ZC.AL(t.K+"-top"),wh:t.I-(ZC.quirks?0:10)+"/"+(t.F-(ZC.quirks?0:10))}).innerHTML='<div class="zc-form-row-label zc-form-s0">'+ZC.HJ["error-header"]+'</div><div class="zc-form-row-label zc-form-s1">'+ZC.HJ["error-message"]+'</div><div class="zc-form-row-element"><textarea id="'+t.K+'-error-message" style="width:'+(t.I-35)+"px;height:"+(t.F-135)+'px;"></textarea></div><div class="zc-form-row-element zc-form-row-last"><input type="button" value="'+ZC.HJ["error-close"]+'" id="'+t.K+'-error-close" /></div>',ZC.A4("#"+t.K+"-error-message").val(ZC.GV(n)),ZC.A4("#"+t.K+"-error-close").bind("click",function(){ZC.Q.EU(t.K+"-error")})}},A5R:function(){},A6K:function(){},A5S:function(){var e=this,i=document.createElement("div");i.id="zc-fullscreen",i.style.zIndex=zingchart.FSZINDEX,i.style.overflow="hidden";var t,n,a=document.body,l=!1;for(zingchart.FSID&&ZC.AL(zingchart.FSID)&&(l=!0,(a=ZC.AL(zingchart.FSID)).style.display="block"),a.appendChild(i),ZC.FSSTATUS={},t=0,n=e.AG.length;t<n;t++){var o=e.AG[t];if(null!==o.AY)for(var r=0,s=o.AY.A5.length;r<s;r++)ZC.FSSTATUS["g-"+o.L+"-p-"+r]=o.E["plot"+r+".visible"]}ZC.Q.EU(e.K+"-data-table");var A,C=JSON.parse(e.E.json),c=C.graphset;for(t=c.length-1;t>=0;t--)if(c[t].generated)c.splice(t,1);else{if(null!==ZC._n_(c[t].shapes))for(A=c[t].shapes.length-1;A>=0;A--)c[t].shapes[A].generated&&c[t].shapes.splice(A,1);if(null!==ZC._n_(c[t].labels))for(A=c[t].labels.length-1;A>=0;A--)c[t].labels[A].generated&&c[t].labels.splice(A,1)}l||window.scroll(0,0),zingchart.render({id:"zc-fullscreen",output:e.AB,width:ZC.A4(l?a:window).width(),height:ZC.A4(l?a:window).height(),fullscreenmode:!0,theme:e.LI,modules:e.A1A,data:C,defaults:e.MP,defaultsurl:e.QQ})},A0Y:function(e,i){var t,n,a,l=this,o=0,r=!1;for(t=0,n=l.AG.length;t<n;t++)if(e===l.AG[t].K){for(o=t,a=0;a<l.AG[t].AY.A5.length;a++)if(l.AG[t].AY.A5[a].I3){r=!0;break}var s;for(s=l.AG[o].AJ["3d"]||r?l.o.graphset[t]:l.AG[t].o,a=0;a<10;a++){var A="scale-y"+(0===a?"":"-"+a);null===ZC._n_(s[A])&&null===ZC._n_(s[ZC.EE(A)])&&null!==l.AG[t].BM(A)?s[A]={progression:i}:(null!==ZC._n_(s[A])&&(s[A].progression=i),null!==ZC._n_(s[ZC.EE(A)])&&(s[ZC.EE(A)].progression=i))}}delete l.E["graph"+o+".zoom"],l.AG[o].AJ["3d"]||r?l.K6():l.AG[o].K6(!0,!0)},Z7:function(e,i){var t=this;if(t.D7){for(var n=0,a=t.AG.length;n<a;n++)e===t.AG[n].K&&(t.AG[n].A1J=i,t.AG[n].E["guide-on"]=i);if(i){var l=ZC.A4("#"+t.K+"-top"),o={_pageX_:ZC.E1[0]-l.offset().left,_pageY_:ZC.E1[1]-l.offset().top,type:"mousemove",target:{id:t.K+"-img"}};t.D7.QA(o)}else ZC.JR.clearGuide(t.K)}},A54:function(e){for(var i=this,t=["line","area","bar","vbar","hbar","pie","mixed"],n=0,a=i.AG.length;n<a;n++)if(e===i.AG[n].K){var l=i.o.graphset[n];if("mixed"===l.type)for(var o=0,r=l.series.length;o<r;o++){var s=l.series[o];s.type=s.type||"line","3d"===i.XC?s.type=s.type.replace("3d",""):-1!==ZC.AV(t,s.type)&&(s.type=s.type+"3d")}else"3d"===i.XC?l.type=l.type.replace("3d",""):-1!==ZC.AV(t,l.type)&&(l.type=l.type+"3d")}i.XC="3d"===i.XC?"2d":"3d",i.E.json=ZC.GV(JSON.stringify(i.o)),i.K6()},A8S:function(e){for(var i,t=this,n=0;n<t.AG.length;n++)delete t.E["g"+n+"-legend-collapsed"];if(e=e||{},ZC.AP.BY("reload",t,{id:t.K,graphid:e.graphid}),null!==ZC._n_(i=e.graphid)){var a=t.C8(i);null!==a&&(t.N4(a),t.load(a.K))}else t.QM=[],t.NU=-1,t.N4(),t.clearGenerated(),t.load()},ACZ:function(e){var i,t=this;if(e=e||{},null!==ZC._n_(i=e.graphid)){var n=t.C8(i);null!==n&&null!==ZC._n_(e.dataurl)&&(t.N4(n),t.load(i,e.dataurl))}else null!==ZC._n_(i=e.dataurl)&&(t.QJ=i,t.N4(),t.load())},A9B:function(){},OE:function(){},Z4:function(){},AAJ:function(e){ZC._cp_(this.FG(),e),ZC.AP.BY("menu_item_click",this,e)},A47:function(N){var s=this;try{var DW=ZC.AP.AAE(N["function"]);N["function"]=DW[0],N.arguments=DW[1],ZC._cp_(s.FG(),N),eval(N["function"]).call(s,N)}catch(J8){return s.O1(J8,"JavaScript data loader"),!1}},C8:function(e){var i=this;return null!==ZC._n_(e)?i.OS(e):i.AG.length>0?i.AG[0]:null},bind:function(e,i){zingchart.bind(this.K,e,i)},unbind:function(e,i){zingchart.unbind(this.K,e,i)},exec:function(e,i){return zingchart.exec(this.K,e,i)},gc:function(){for(var e=0,i=this.AG.length;e<i;e++)this.AG[e].gc()}};ZC.Q5=ZC.HL.CA(Q5),ZC.Q5.prototype.AD6=function(e){var i,t,n,a,l,o=this;if((e=e||{}).action="pan",i=null!==ZC._n_(e.graphid)?o.OS(e.graphid):o.AG[0]){for(t=0,n=i.BU("k").length;t<n;t++){var r=i.BU("k")[t];if(a=1===r.L?"":"-"+r.L,r.GN&&(null===ZC._n_(e["zoomx"+a])||e["zoomx"+a])){e["zoomx"+a]=!0;var s,A=e.xdist||50;l=r.I/ZC.CY(r.I,Math.abs(A));var C=r.W,c=r.A1;A<0?(s=ZC.CY(r.W-r.DC,ZC._i_((r.A1-r.W)/l)),C=r.W-s,c=r.A1-s):(s=ZC.CY(r.DX-r.A1,ZC._i_((r.A1-r.W)/l)),C=r.W+s,c=r.A1+s),e["xmin"+a]=C,e["xmax"+a]=c}}for(t=0,n=i.BU("v").length;t<n;t++){var u=i.BU("v")[t];if(a=1===u.L?"":"-"+u.L,u.GN&&(null===ZC._n_(e["zoomy"+a])||e["zoomy"+a])){e["zoomy"+a]=!0;var p,Z=e.ydist||50;l=u.F/ZC.CY(u.F,Math.abs(Z));var h=u.B3,d=u.BJ;A<0?(p=ZC.CY(u.B3-u.FX,ZC._i_((u.BJ-u.B3)/l)),h=u.B3-p,d=u.BJ-p):(p=ZC.CY(u.H0-u.BJ,ZC._i_((u.BJ-u.B3)/l)),h=u.B3+p,d=u.BJ+p),u.PV&&1===u.E5&&(h=Math.round(h),d=Math.round(d)),e["ymin"+a]=h,e["ymax"+a]=d}}o.PZ(e)}},ZC.Q5.prototype.A8N=function(e){var i,t,n,a,l=this;if((e=e||{}).action="zoomin",i=null!==ZC._n_(e.graphid)?l.OS(e.graphid):l.AG[0]){for(t=0,n=i.BU("k").length;t<n;t++){var o=i.BU("k")[t];if(a=1===o.L?"":"-"+o.L,o.GN&&(null===ZC._n_(e["zoomx"+a])||e["zoomx"+a])){e["zoomx"+a]=!0;var r=o.A1-o.W,s=o.W+(r<2?0:ZC._i_(r/4)),A=o.A1-(r<2?0:ZC._i_(r/4));s<A?(e["xmin"+a]=s,e["xmax"+a]=A):(e["xmin"+a]=o.W,e["xmax"+a]=o.A1)}}for(t=0,n=i.BU("v").length;t<n;t++){var C=i.BU("v")[t];if(a=1===C.L?"":"-"+C.L,C.GN&&(null===ZC._n_(e["zoomy"+a])||e["zoomy"+a])){e["zoomy"+a]=!0;var c=C.BJ-C.B3,u=C.B3+ZC._f_(c/4),p=C.BJ-ZC._f_(c/4);C.PV&&1===C.E5&&(u=Math.round(u),p=Math.round(p)),u<p&&(e["ymin"+a]=u,e["ymax"+a]=p)}}l.PZ(e)}},ZC.Q5.prototype.A8D=function(e){var i,t,n,a,l,o,r,s=this;if((e=e||{}).action="zoomout",e.previewscale=!0,i=null!==ZC._n_(e.graphid)?s.OS(e.graphid):s.AG[0]){for(t=0,n=i.BU("k").length;t<n;t++){var A=i.BU("k")[t];if(r=1===A.L?"":"-"+A.L,A.GN&&(null===ZC._n_(e["zoomx"+r])||e["zoomx"+r]))if(e["zoomx"+r]=!0,i.B9&&i.B9.LL){var C=ZC._i_(i.B9.NM[A.BE].values.length*i.B9.IG/i.B9.AQ.I),c=ZC._i_(i.B9.NM[A.BE].values.length*i.B9.H6/i.B9.AQ.I);a=ZC.BQ(2,c-C),(l=ZC.BQ(0,C-ZC._i_(a/2)))<(o=ZC.CY(i.B9.NM[A.BE].values.length-1,c+ZC._i_(a/2)))&&(e["xmin"+r]=l,e["xmax"+r]=o)}else a=ZC.BQ(2,A.A1-A.W),(l=ZC.BQ(A.DC,A.W-ZC._i_(a/2)))<(o=ZC.CY(A.DX,A.A1+ZC._i_(a/2)))&&(e["xmin"+r]=l,e["xmax"+r]=o)}for(t=0,n=i.BU("v").length;t<n;t++){var u=i.BU("v")[t];if(r=1===u.L?"":"-"+u.L,u.GN&&(null===ZC._n_(e["zoomy"+r])||e["zoomy"+r])){e["zoomy"+r]=!0;var p=u.BJ-u.B3,Z=ZC.BQ(u.FX,u.B3-ZC._f_(p/2)),h=ZC.CY(u.H0,u.BJ+ZC._f_(p/2));u.PV&&1===u.E5&&(Math.round(h)-Math.round(Z)>1?(Z=Math.round(Z),h=Math.round(h)):(Z=Math.floor(Z),h=Math.ceil(h))),(Z=ZC.BQ(u.FX,Z))<(h=ZC.CY(u.H0,h))&&(e["ymin"+r]=Z,e["ymax"+r]=h)}}s.PZ(e)}},ZC.Q5.prototype.A88=function(e){var i,t,n,a,l,o=this;for(e=e||{},t=null!==ZC._n_(e.graphid)?o.OS(e.graphid):o.AG[0],e.action="viewall",n=0,a=t.BU("k").length;n<a;n++)if(e["zoomx"+(l=1===(i=t.BU("k")[n]).L?"":"-"+i.L)]=!0,e["xmin"+l]=null,e["xmax"+l]=null,t.o[i.BE]&&(t.o[i.BE]["zoom-to"]=null,t.o[i.BE]["zoom-to-values"]=null),t.B9&&t.B9.LL){var r=t.B9.NM[i.BE].values;e["kmin"+l+"-async"]=r[0],e["kmax"+l+"-async"]=r[r.length-1]}for(n=0,a=t.BU("v").length;n<a;n++)i=t.BU("v")[n],t.o[i.BE]&&(t.o[i.BE]["zoom-to"]=null,t.o[i.BE]["zoom-to-values"]=null),i.DQ=null!==ZC._n_(i.E.decimals)&&-1!==i.E.decimals?i.E.decimals:null,l=1===i.L?"":"-"+i.L,i.KM=null,e["zoomy"+l]=!0,e["ymin"+l]=null,e["ymax"+l]=null;o.PZ(e)},ZC.Q5.prototype.PZ=function(e){var i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d=this;(e=e||{}).id=d.K;var f=null!==ZC._n_(e.zoom)&&!e.zoom;if(t=null!==ZC._n_(e.graphid)?d.OS(e.graphid):d.AG[0]){f&&(d.E["graph."+t.L+".ignore-zoom"]=!0),d.E["graph."+t.L+".ignore-zoom"]&&(f=!0),"undefined"==typeof e.scroll&&(ZC.Q.IV(ZC.AL(t.K+"-scroll-x-c"),t.A.AB,t.iX,t.iY,t.I,t.F),ZC.Q.IV(ZC.AL(t.K+"-scroll-y-c"),t.A.AB,t.iX,t.iY,t.I,t.F)),t.B9&&(t.B9.I2=!1);var _=d.E["graph"+t.L+".zoom"]||{};for(e.yzoomed=!1,(l=t.BU("v")[0])&&null!==ZC._n_(e.ymin)&&null!==ZC._n_(e.ymax)&&(e.ymin===l.FX&&e.ymax===l.H0||(e.yzoomed=!0)),s=0,A=t.BU("k").length;s<A;s++)if(C=1===(a=t.BU("k")[s]).L?"":"-"+a.L,null!==ZC._n_(e["kmin"+C])&&null!==ZC._n_(e["kmax"+C]))if(e["kmin"+C]===e["kmax"+C])delete e["kmin"+C],delete e["kmax"+C];else{for(var g=!1,v=!1,b=0,B=a.V.length;b<B&&(e["kmin"+C]<=a.V[b]&&!g&&(e["xmin"+C]=b,g=!0),e["kmax"+C]<=a.V[b]&&!v&&(e["xmax"+C]=b,v=!0),!g||!v);b++);g||(e["xmin"+C]=0),v||(e["xmax"+C]=a.V.length-1),e["zoomx"+C]=!0,e.xzoomed=!(g&&v)}else n=t.B9&&t.B9.LL&&e.previewscale?t.B9.NM[a.BE].values:a.V,null!==ZC._n_(i=n[e["xmin"+C]])&&(e["kmin"+C]=i),null!==ZC._n_(i=n[e["xmax"+C]])&&(e["kmax"+C]=i),e.xzoomed=!(e["xmin"+C]===a.DC&&e["xmax"+C]===a.DX);"viewall"===e.action&&(e.xzoomed=!1,e.yzoomed=!1);var m=ZC.AP.BY("zoom",t.A,e,!0);if(e.async&&!f)return;if(t.B9&&t.B9.LL){n=t.B9.NM[a.BE].values;var E=ZC.XZ(n),D=ZC.A1L(n);null!==ZC._n_(e.kmin)&&"undefined"!=typeof e.kmin?(o=ZC._i_(t.B9.AQ.I*(e.kmin-E)/(D-E)),o=ZC.BQ(o,0)):o=0,null!==ZC._n_(e.kmax)&&"undefined"!=typeof e.kmax?(r=ZC._i_(t.B9.AQ.I*(e.kmax-E)/(D-E)),r=ZC.CY(r,t.B9.AQ.I)):r=t.B9.AQ.I,f||t.B9.update(o,r,t.B9.KP,t.B9.HA)}if(m||void 0===m){for(s=0,A=t.BU("k").length;s<A;s++)e["zoomx"+(C=1===(a=t.BU("k")[s]).L?"":"-"+a.L)]&&(f||a.zoomTo(e["xmin"+C],e["xmax"+C]),_["xmin"+C]=e["xmin"+C],_["xmax"+C]=e["xmax"+C]);for(s=0,A=t.BU("v").length;s<A;s++)e["zoomy"+(C=1===(l=t.BU("v")[s]).L?"":"-"+l.L)]&&null!==ZC._n_(l)&&(f||l.zoomTo(e["ymin"+C],e["ymax"+C]),_["ymin"+C]=e["ymin"+C],_["ymax"+C]=e["ymax"+C]);if(f&&(d.H1.C=t),d.H1.parse(),d.H1.A0G)for(d.E["graph"+t.L+".zoom"]=_,Z=0,h=d.AG.length;Z<h;Z++)t.K!==d.AG[Z].K&&d.AG[Z].H1&&ZC._b_(d.AG[Z].H1.o.shared)&&(d.E["graph"+d.AG[Z].L+".zoom"]=_);if(t.B9&&!e.preview&&t.B9.update(e.xmin,e.xmax,e.ymin,e.ymax,!0),f)return;t.clear(!0);for(var F=t.BU("v"),K=0;K<F.length;K++)if((l=t.BU("v")[K])&&(l.aAutoFit[0]||l.aAutoFit[1])){for(var x=l.aAutoFit[0]?ZC.MAX:l.FX,I=l.aAutoFit[1]?-ZC.MAX:l.H0,y=0,w=t.AY.A5.length;y<w;y++)if(t.AY.A5[y].AN&&-1!==ZC.AV(t.AY.A5[y].BO,l.BE))if(a.EF){for(s=0,A=t.AY.A5[y].S.length;s<A;s++)if((p=t.AY.A5[y].S[s])&&ZC.DS(p.BT,a.V[a.W],a.V[a.A1]))for(l.aAutoFit[0]&&(x=ZC.CY(x,p.CS)),l.aAutoFit[1]&&(I=ZC.BQ(I,p.CS)),c=0,u=p.DP.length;c<u;c++)l.aAutoFit[0]&&(x=ZC.CY(x,p.DP[c])),l.aAutoFit[1]&&(I=ZC.BQ(I,p.DP[c]))}else for(s=a.W;s<=a.A1;s++)if(p=t.AY.A5[y].S[s])for(l.aAutoFit[0]&&(x=ZC.CY(x,p.CS)),l.aAutoFit[1]&&(I=ZC.BQ(I,p.CS)),c=0,u=p.DP.length;c<u;c++)l.aAutoFit[0]&&(x=ZC.CY(x,p.DP[c])),l.aAutoFit[1]&&(I=ZC.BQ(I,p.DP[c]));"log"===l.C1&&(x=ZC.G6(x,l.E6),I=ZC.G6(I,l.E6)),l.RQ(x,I,!0),l.IZ();var L=t.BU("v");for(s=0;s<L.length;s++)L[s].BE!==l.BE&&L[s].sMaster===l.BE&&(L[s].RQ(x,I,!0),L[s].IZ())}var X=ZC._b_(e.zoomto);t.E["skip-preview"]=!0;var Y=["top","right","bottom","left"];for(s=0;s<Y.length;s++)(t.P.E["d-margin-"+Y[s]]||t.E["plotarea.d-margin-"+Y[s]]||ZC._b_(t.P.o["adjust-layout"]))&&(t.o.plotarea["margin-"+Y[s]]&&!Number.isNaN(t.o.plotarea["margin-"+Y[s]])||(t.o.plotarea["margin-"+Y[s]]=t.P.o["margin-"+Y[s]]="dynamic",t.E["plotarea.d-margin"]=t.E["plotarea.d-margin-"+Y[s]]=!0));t.setupDynamicPlotArea(),t.paint(!X),d.H1.C=null,ZC.AP.BY("postzoom",t.A,e)}}},zingchart.ABP=function(e,i,t){var n,a,l,o,r,s,A,C,c;document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var u=zingchart.getLoader(e);if(null!==ZC._n_(t.preservezoom)&&(u.E.preservezoom=ZC._b_(t.preservezoom)),u)switch(i){case"getzoom":if(o={},l=u.C8(t.graphid))for(n=0,a=l.BO.length;n<a;n++){var p=l.BO[n];"k"===p.AF?o[p.BE]={xmin:p.W,xmax:p.A1,vmin:p.V[p.W],vmax:p.V[p.A1]}:o[p.BE]={ymin:p.B3,ymax:p.BJ,vmin:p.V[p.W],vmax:p.V[p.A1]}}return o;case"pan":u.AD6(t);break;case"zoomin":u.A8N(t);break;case"zoomout":u.A8D(t);break;case"zoomto":if(l=u.C8(t.graphid),null!==ZC._n_(t.xall)&&t.xall)for(n=0,a=l.BU("k").length;n<a;n++)t["xmin"+(A=1===(r=l.BU("k")[n]).L?"":"-"+r.L)]=t.xmin||null,t["xmax"+A]=t.xmax||null,t["kmin"+A]=t.kmin||null,t["kmax"+A]=t.kmax||null;for(n=0,a=l.BU("k").length;n<a;n++)null===t["xmin"+(A=1===(r=l.BU("k")[n]).L?"":"-"+r.L)]&&null===ZC._n_(t["xmax"+A])&&null===ZC._n_(t["kmin"+A])&&null===ZC._n_(t["kmax"+A])||(t["zoomx"+A]=!0),"log"===r.C1&&(null!==ZC._n_(t["xmin"+A])&&(t["xmin"+A]=ZC.G6(t["xmin"+A],r.E6)),null!==ZC._n_(t["xmax"+A])&&(t["xmax"+A]=ZC.G6(t["xmax"+A],r.E6)));if(null!==ZC._n_(t.yall)&&t.yall)for(n=0,a=l.BU("v").length;n<a;n++)t["ymin"+(A=1===(s=l.BU("v")[n]).L?"":"-"+s.L)]=t.ymin||null,t["ymax"+A]=t.ymax||null;for(n=0,a=l.BU("v").length;n<a;n++)A=1===(s=l.BU("v")[n]).L?"":"-"+s.L,null===ZC._n_(t["ymin"+A])&&null===ZC._n_(t["ymax"+A])||(t["zoomy"+A]=!0),"log"===s.C1&&(null!==ZC._n_(t["ymin"+A])&&(t["ymin"+A]=ZC.G6(t["ymin"+A],s.E6)),null!==ZC._n_(t["ymax"+A])&&(t["ymax"+A]=ZC.G6(t["ymax"+A],s.E6)));u.PZ(t);break;case"zoomtovalues":if(l=u.C8(t.graphid),null!==ZC._n_(t.xall)&&t.xall)for(n=0,a=l.BU("k").length;n<a;n++)t["xmin"+(A=1===(r=l.BU("k")[n]).L?"":"-"+r.L)]=t.xmin||null,t["xmax"+A]=t.xmax||null;for(n=0,a=l.BU("k").length;n<a;n++)A=1===(r=l.BU("k")[n]).L?"":"-"+r.L,null===ZC._n_(t["xmin"+A])&&null===ZC._n_(t["xmax"+A])||(l.B9&&l.B9.LL?(t.previewscale=!0,t["kmin"+A+"-async"]=t["xmin"+A],t["xmin"+A]=ZC.A9L(l.B9.NM[r.BE].values,t["xmin"+A])):-1!==(C=ZC.AV(r.V,t["xmin"+A]))&&(t["xmin"+A]=C),l.B9&&l.B9.LL?(t.previewscale=!0,t["kmax"+A+"-async"]=t["xmax"+A],t["xmax"+A]=ZC.A9L(l.B9.NM[r.BE].values,t["xmax"+A])):-1!==(c=ZC.AV(r.V,t["xmax"+A]))&&(t["xmax"+A]=c),t["zoomx"+A]=!0);if(null!==ZC._n_(t.yall)&&t.yall)for(n=0,a=l.BU("v").length;n<a;n++)t["ymin"+(A=1===(s=l.BU("v")[n]).L?"":"-"+s.L)]=t.ymin||null,t["ymax"+A]=t.ymax||null;for(n=0,a=l.BU("v").length;n<a;n++)A=1===(s=l.BU("v")[n]).L?"":"-"+s.L,null===ZC._n_(t["ymin"+A])&&null===ZC._n_(t["ymax"+A])||(t["zoomy"+A]=!0);u.PZ(t);break;case"viewall":u.A88(t)}return null},ZC.A7W={},ZC.AP.A3E=function(e,i,t,n){"jpg"===(n=n||"png")&&(n="jpeg");var a=document.createElement("canvas");a.width=i,a.height=t,a.style.width=i+"px",a.style.height=t+"px";var l,o=a.getContext("2d");e instanceof Array||(e=[e]);for(var r=0,s=e.length;r<s;r++)if(-1===e[r].className.indexOf("zc-no-print")){var A=!1;try{e[r].toDataURL("image/"+n)}catch(c){A=!0}if(!A)if(l=e[r].getAttribute("data-clip")){var C=l.split(",");o.drawImage(e[r],ZC.BQ(0,C[0]),ZC.BQ(0,C[1]),ZC.CY(C[2],e[r].width),ZC.CY(C[3],e[r].height),ZC.BQ(0,C[0]),ZC.BQ(0,C[1]),ZC.CY(C[2],e[r].width),ZC.CY(C[3],e[r].height))}else o.drawImage(e[r],0,0,e[r].width,e[r].height,0,0,i,t)}return a.toDataURL("image/"+n)},ZC.AP.ABR=function(e,i,t,n,a){null===ZC._n_(a)&&(a=!1);var l=ZC.AP.A3E(e,i,t,n);if(a){var o=document.createElement("img");return o.src=l,o}l=l.replace("image/"+n,"image/octet-stream"),document.location.href=l},ZC.Q5.prototype.A9B=function(){var e=this,i=[];if(!e.A7S){e.A7S=!0;var t=document.body.childNodes,n=ZC.A4(document.body).css("background-color"),a=ZC.A4(document.body).css("background-image");ZC.A4(document.body).css("background-color","#fff").css("background-image","none");for(var l=0,o=t.length;l<o;l++)1===t[l].nodeType&&(i[l]=t[l].style.display,t[l].style.display="none");document.body.appendChild(ZC.AL(e.K+"-wrapper")),window.setTimeout(function(){window.print(),window.setTimeout(function(){ZC.A4(document.body).css("background-color",n).css("background-image",a),ZC.AL(e.K+"-wrapper")&&ZC.AL(e.K).appendChild(ZC.AL(e.K+"-wrapper"));for(var l=0,o=t.length;l<o;l++)1===t[l].nodeType&&(t[l].style.display=i[l]);e.A7S=!1},1e3)},50)}},ZC.Q5.prototype.OE=function(e,i,t,n){var a=this;if(i=i||{},void 0===t&&(t=!1),!ZC.AL(a.K+"-viewimage")){e=e||"png";var l=i.download,o=i.fn||"";ZC.Q.IV(ZC.AL(a.K+"-guide-c"),a.AB,0,0,a.I,a.F),ZC.A4(".zc-guide-label").remove();var r,s,A=("canvas"===a.AB||zingchart.AJAXEXPORT||zingchart.DEV.LOCALSVGEXPORT)&&"pdf"!==e&&"svg"!==e;if(ZC.mobile||!A||t||l||(r=ZC.Q.HY({cls:"zc-abs zc-viewimage zc-style",id:a.K+"-viewimage",zidx:5,p:ZC.AL(a.K+"-top"),wh:a.I+"/"+a.F}),s=ZC.Q.HY({id:a.K+"-viewimage-close",p:r,zidx:10,tl:"5/"+(a.I-15),html:ZC.HJ["viewimage-close"]}),ZC.A4(s).css("cursor","pointer").css("left",a.I-15-ZC.A4(s).width()+"px"),ZC.A4(s).bind("click",function(){ZC.A4(r).remove()})),ZC.mobile&&(l=!0),!zingchart.DEV.LOCALSVGEXPORT||l||"svg"!==a.AB||"png"!==e&&"jpeg"!==e){var C;if("canvas"===a.AB&&"pdf"!==e&&"svg"!==e){var c,u,p=document.createElement("canvas");for(p.width=a.I,p.height=a.F,c=0,u=a.AG.length;c<u;c++)a.AG[c].BD&&a.AG[c].BD.EK(p);var Z=[];ZC.A4("#"+a.K+" canvas").each(function(){-1===ZC.AV([a.K+"-guide-c",a.K+"-trigger-c"],this.id)&&Z.push(this)}),Z.push(p),Z.push(a.createPreviewMasks());var h=ZC.AP.ABR(Z,a.I,a.F,e,!0);h.id=a.K+"-print-"+e,r.appendChild(h)}else if(t||a.A7X(ZC.HJ["export-wait"]),"vml"===a.AB||"canvas"===a.AB&&("pdf"===e||"svg"===e)){var d=document.createElement("div"),f="zc-export-svg-"+a.K;d.id=f,d.style.display="none",document.body.appendChild(d),zingchart.render({id:f,output:"!svg",imggen:!0,width:a.I,height:a.F,data:a.E.json,defaults:a.MP,theme:a.LI,hideprogresslogo:!0,events:{load:function(){window.setTimeout(function(){var e=zingchart.getLoader(f);if(e.E["dynamic-objects"])var i=window.setInterval(function(){"ready"===e.E["dynamic-objects"]&&(window.clearInterval(i),e.togglePreviewMasks(!0),C=ZC.AL(f+"-top").innerHTML,e.togglePreviewMasks(!1),zingchart.exec(f,"destroy",{skipfs:!0}),_())},100);else e.togglePreviewMasks(!0),C=ZC.AL(f+"-top").innerHTML,e.togglePreviewMasks(!1),zingchart.exec(f,"destroy",{skipfs:!0}),_()},100)}}})}else"svg"===a.AB&&(a.togglePreviewMasks(!0),C=ZC.AL(a.K+"-top").innerHTML,_(),a.togglePreviewMasks(!1));A&&!t&&(ZC.A4(s).css("cursor","pointer").css("left",a.I-15-ZC.A4(s).width()+"px"),ZC.A4(s).bind("click",function(){ZC.A4(r).remove()}))}else zingchart.exec(a.K,"getimagedata",{callback:function(l){if(-1!==l){var o=document.createElement("img");o.id=a.K+"-print-"+e,o.src=l,r.appendChild(o)}else ZC.Q.EU(a.K+"-viewimage"),zingchart.DEV.LOCALSVGEXPORT=0,a.OE(e,i,t,n)}})}function _(){var s,A,c={svg:C=(C=C.replace(/<foreignObject(.+?)<\/foreignObject>/g,"")).replace(' xmlns="http://www.w3.org/2000/svg"',""),w:a.I,h:a.F,t:e,fn:o};if(ZC._cp_(i,c),zingchart.AJAXEXPORT&&"pdf"!==e&&"svg"!==e&&!l){var u="base64=1&";for(A in c)u+=A+"="+encodeURIComponent(c[A])+"&";ZC.A4.ajax({type:"post",url:zingchart.EXPORTURL,data:u,success:function(i,l,o){if(a.A42(),t)n&&n(i,l,o);else{var s=document.createElement("img");s.src=i,s.id=a.K+"-print-"+e,r.appendChild(s)}}})}else{ZC.AL(a.K+"-export")&&ZC.Q.EU(a.K+"-export");var p=ZC.Q.HY({cls:"zc-abs zc-style",id:a.K+"-export",p:ZC.AL(a.K+"-top"),display:"none"}),Z=(s=null!==ZC._n_(c.uid)&&null!==ZC._n_(c.page)?ZC.Q.ABE(ZC.AL(a.K+"-export")):document).createElement("FORM");for(A in Z.action=zingchart.EXPORTURL,Z.method="post",Z.enctype="multipart/form-data",null!==ZC._n_(c.uid)&&null!==ZC._n_(c.page)?s.body.appendChild(Z):p.appendChild(Z),Z.style.display="none",c){var h=s.createElement("INPUT");h.type="hidden",h.name=A,h.value=c[A],Z.appendChild(h)}Z.submit(),Z=null,null!==ZC._n_(c.uid)&&null!==ZC._n_(c.page)&&window.setTimeout(function(){ZC.A4("#"+a.K+"-export").remove()},6e4),window.setTimeout(function(){a.A42()},1e3)}}},ZC.Q5.prototype.Z4=function(e){var i=this;e=e||"png";var t,n,a=[],l=document.createElement("canvas");for(l.width=i.I,l.height=i.F,t=0,n=i.AG.length;t<n;t++)i.AG[t].BD&&i.AG[t].BD.EK(l);return ZC.A4("#"+i.K+" canvas").each(function(){-1===ZC.AV([i.K+"-guide-c",i.K+"-tooltip-c"],this.id)&&a.push(this)}),a.push(l),a.push(i.createPreviewMasks()),ZC.AP.A3E(a,i.I,i.F,e)},ZC.AP.downloadFile=function(e,i,t){if(!ZC.ie678){t=t||"application/octet-stream";var n=document.createElement("a");navigator.msSaveBlob?navigator.msSaveBlob(new Blob([e],{type:t}),i):URL&&"download"in n?(n.href=URL.createObjectURL(new Blob([e],{type:t})),n.setAttribute("download",i),document.body.appendChild(n),n.click(),document.body.removeChild(n)):location.href="data:application/octet-stream,"+encodeURIComponent(e)}},ZC.AP.XM=function(e,i){var t,n,a,l,o,r,s,A,C,c,u,p,Z,h=[],d="",f=[];for("xls"===(i=i||"csv")&&h.push('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">',"<head>","\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>[ZC]</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e",'<style>td{border:none;font-family:Calibri,sans-serif} .number{mso-number-format:"0.00";} .text{mso-number-format:"@";}</style>',"<meta name=ProgId content=Excel.Sheet>","<meta charset=UTF-8>","</head>","<body>"),t=0,n=e.AG.length;t<n;t++){var _=e.AG[t],g=_.AY.A5;e.E.fastlinedata&&(g=e.E.fastlinedata);var v={},b=[],B=_.BU("k")[0];"html"!==i&&"xls"!==i&&"raw"!==i||(h.push("<table>"),_.IQ&&""!==_.IQ.AM&&(f.push([_.IQ.AM]),h.push("<caption>"+_.IQ.AM+"</caption>")),h.push("<thead>"),h.push("<tr>")),u=[],Z=[];var m="Category",E=!1,D="%Y-%mm-%dd %H:%i:%s";for(B&&(B.F5&&"date"===B.F5.o.type&&(m="Date",E=!0,B.F5.o["export-format"]&&(D=B.F5.o["export-format"])),B.M&&B.M.AM&&(m=B.M.AM.replace(/\"|\'/g,""))),"csv"===i?u.push('"'+m+'"'):"raw"===i?Z.push(m):"html"!==i&&"xls"!==i||u.push("<th>"+m+"</th>"),a=0,l=g.length;a<l;a++)(null===ZC._n_(g[a].o["export"])||ZC._b_(g[a].o["export"]))&&(p=(p=null!==ZC._n_(g[a].AM)?g[a].AM+"":"Series "+a).replace(/\"|\'/g,""),"csv"===i?u.push('"'+p+'"'):"raw"===i?Z.push(p):"html"!==i&&"xls"!==i||u.push("<th"+("xls"===i?' scope="col" class="text"':"")+">"+p+"</th>"),b.push(""));if("csv"===i?h.push(u.join(",")):"raw"===i?f.push(Z):"html"!==i&&"xls"!==i||h.push(u.join("")),"html"!==i&&"xls"!==i||(h.push("</tr>"),h.push("</thead>"),h.push("<tbody>")),B){for(s=0,A=B.V.length;s<A;s++)v[s+""]={hasData:!1,nodes:[].concat(b)};var F=[];for(a=0,l=g.length;a<l;a++)if(null===ZC._n_(g[a].o["export"])||ZC._b_(g[a].o["export"]))for(o=0,r=g[a].S.length;o<r;o++){var K=g[a].S[o];K&&(v[s=null!==ZC._n_(K.BT)?""+K.BT:""+o]=v[s]||{hasData:!0,nodes:[].concat(b)},v[s].nodes[a]=K.AD,v[s].hasData=!0,null!==ZC._n_(K.BT)&&F.push(""+K.BT))}var x=[];for(s in v)v[s].hasData&&x.push([s,v[s].nodes]);x.sort(function(e,i){return e[0]-i[0]});var I=null;for(C=0,c=x.length;C<c;C++){if("html"!==i&&"xls"!==i||h.push("<tr>"),"pie"!==_.AF&&"pie3d"!==_.AF&&"nestedpie"!==_.AF||B.V[x[C][0]]&&(x[C][0]=B.V[x[C][0]]),B.BX[x[C][0]]&&(x[C][0]=B.BX[x[C][0]]),B.V[x[C][0]]&&-1===ZC.AV(F,x[C][0])&&(x[C][0]=B.V[x[C][0]]),(I=_.A.FG()).row=C,I.col=0,I.value=x[C][0],x[C][0]=ZC.AP.BY("dataexport",_.A,I,x[C][0],null),ZC._n_(x[C][1]))for(var y=0;y<x[C][1].length;y++)(I=_.A.FG()).row=C,I.col=y+1,I.value=x[C][1][y],x[C][1][y]=ZC.AP.BY("dataexport",_.A,I,x[C][1][y],null);E&&(x[C][0]=ZC.AP.Y5(x[C][0],D,_.UN,_.ND),"csv"===i&&(x[C][0]='"'+x[C][0]+'"')),"csv"===i?h.push([].concat(x[C][0]).concat(x[C][1]).join(",")):"raw"===i?f.push([].concat(x[C][0]).concat(x[C][1])):"html"!==i&&"xls"!==i||h.push("<td"+("xls"===i?' scope="row"':"")+">"+[].concat(x[C][0]).concat(x[C][1]).join("</td><td>")+"</td>"),"html"!==i&&"xls"!==i||h.push("</tr>")}}"html"!==i&&"xls"!==i||(h.push("</tbody>"),h.push("</table>")),n>1&&t<n-1&&("csv"===i?h.push("","",""):"html"!==i&&"xls"!==i||h.push("<p>&nbsp;</p>"))}return"xls"===i&&h.push("</body>","</html>"),"raw"===i?f:("csv"===i?d=h.join("\n"):"html"!==i&&"xls"!==i||(d=h.join("")),d)},zingchart.AB6=function(e,i,t){var n,a,l,o,r,s="",A="";function C(e){ZC.A4.ajax({type:"post",url:a,data:e,success:function(e,i,t){l&&l(e,i,t)}})}document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var c=zingchart.getLoader(e);if(c)switch(i){case"getimagedata":if(o="png",null!==ZC._n_(n=t.format)&&(o=n),null!==ZC._n_(n=t.filetype)&&(o=n),"jpg"===o&&(o="jpeg"),zingchart.DEV.LOCALSVGEXPORT&&"svg"===c.AB&&("png"===o||"jpeg"===o)){c.togglePreviewMasks(!0);var u=ZC.AL(c.K+"-svg").parentNode.innerHTML,p=u.indexOf(">"),Z=u.indexOf("</svg>");u=(u='<svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" width="'+c.I+'" height="'+c.F+'">[CSS]'+u.substring(p+1,Z+6)).replace(/<foreignObject(.+?)<\/foreignObject>/g,"");var h=function(){var e,i=window.URL||window.webkitURL||window,n=!1;navigator&&navigator.userAgent&&-1!==navigator.userAgent.indexOf("Safari")&&-1===navigator.userAgent.indexOf("Chrome")&&(n=!0),e=i.createObjectURL&&window.Blob&&!n?i.createObjectURL(new window.Blob([u],{type:"image/svg+xml;charset-utf-16"})):"data:image/svg+xml;charset=UTF-8,"+encodeURIComponent(u),c.togglePreviewMasks(!1);var a=new window.Image;a.crossOrigin="anonymous",a.src=e,a.onload=function(){var i=document.createElement("canvas"),n=i.getContext("2d");if(i.width=a.width,i.height=a.height,n.drawImage(a,0,0,i.width,i.height),t.callback&&"function"==typeof t.callback)try{t.callback(i.toDataURL("image/"+o))}catch(l){t.callback(e)}}},d=0,f=function(){var e=new XMLHttpRequest;e.open("get",c.A24[d]),e.responseType="text",e.onloadend=function(e){var i=e.target.response,t=i.match(/https?:\/\/[^ \)]+/g),n=0;t.forEach(function(e){var a=new XMLHttpRequest;a.open("get",e),a.responseType="blob",a.onloadend=function(a){var l=new FileReader;l.onloadend=function(a){i=i.replace(new RegExp(e),a.target.result),++n===t.length&&(u=u.replace("[CSS]","[CSS]<style><![CDATA["+i+"]]></style>"),++d===c.A24.length?(u=u.replace("[CSS]",""),h()):f())},l.readAsDataURL(a.target.response)},a.send()})},e.send()};c.A24.length?f():(u=u.replace("[CSS]",""),h())}if("canvas"!==c.AB&&!zingchart.AJAXEXPORT)return-1;if("canvas"===c.AB){if(!t.callback||"function"!=typeof t.callback)return c.Z4(o);try{t.callback(c.Z4(o))}catch(b){t.callback(-1)}}else c.OE(o,{},!0,t.callback);break;case"exportimage":case"saveasimage":if(!t.download&&"canvas"!==c.AB&&!zingchart.AJAXEXPORT)return-1;if(o="png",r={},null!==ZC._n_(n=t.options)&&(r=n),null!==ZC._n_(n=t.uid)&&(r.uid=n),null!==ZC._n_(n=t.page)&&(r.page=n),null!==ZC._n_(n=t.format)&&(o=n),null!==ZC._n_(n=t.filetype)&&(o=n),null!==ZC._n_(n=t.filename)&&(s=n),a=c.E.exportimageurl||"",null!==ZC._n_(n=t.url)&&(a=n),l=null,null!==ZC._n_(n=t.callback)&&(l=n),"jpg"===o&&(o="jpeg"),t.download&&("canvas"!==c.AB||"pdf"===o))return r.download=!0,""!==s&&(r.fn=s),void c.OE(o,r);if(""!==a){if("canvas"===c.AB)return C(c.Z4(o));c.OE(o,r,!0,function(e){return C(e)})}break;case"exportdata":if(a=c.E.exportdataurl||"",null!==ZC._n_(n=t.url)&&(a=n),A=ZC.AP.XM(c,"csv"),""===a)return A;l=null,null!==ZC._n_(n=t.callback)&&(l=n),ZC.A4.ajax({type:"post",url:a,data:A,success:function(e,i,t){l&&l(e,i,t)}});break;case"downloadCSV":A=ZC.AP.XM(c,"csv"),ZC.AP.downloadFile(A,(t.fn||c.K)+".csv","text/csv;encoding:utf-8");break;case"downloadXLS":A=ZC.AP.XM(c,"xls");var _=t.sn||"ZingChart";A=A.replace("<x:Name>[ZC]</x:Name>","<x:Name>"+_+"</x:Name>"),ZC.AP.downloadFile(A,(t.fn||c.K)+".xls","application/vnd.ms-excel;encoding:utf-8");break;case"downloadRAW":var g=ZC.AP.XM(c,"raw");if(!t.callback||"function"!=typeof t.callback)return g;try{t.callback(g,t.fn||c.K)}catch(b){t.callback(-1)}break;case"viewDataTable":if("viewdatatable"===t.menuid)if(A=ZC.AP.XM(c,"html"),ZC.AL(c.K+"-data-table"))ZC.AL(c.K+"-data-table").innerHTML=A;else{var v=ZC.Q.HY({id:c.K+"-data-table",cls:"zc-data-table "+c.K+"-data-table"});ZC.Q.PI(v,{width:c.I+"px","max-height":"400px",overflow:"auto"}),v.innerHTML=A,ZC.AL(c.K).parentNode.insertBefore(v,ZC.AL(c.K).nextSibling)}else"hidedatatable"===t.menuid&&ZC.Q.EU(c.K+"-data-table")}return null},ZC.A90={},ZC.AP.WO=function(e){for(var i,t="",n=!1,a=!1,l=0,o="",r=0,s=(e=e.replace(/\t|\r|\n/g,"")).length;r<s;r++)switch(i=e.substr(r,1)){case'"':n=!n,t+=e.substr(r,1),o=i;break;case"{":t+=e.substr(r,1),n||(t+="\n"+new Array(l+1).join("    "),l++,o=i);break;case"}":n||(t+="\n"+new Array(l).join("    "),l--,o=i),t+=e.substr(r,1);break;case"[":var A=e.indexOf("]",r),C=e.indexOf("}",r);C=-1===C?999999:C;var c=e.indexOf("{",r);c=-1===c?999999:c,A<ZC.CY(C,c)?(a=!0,t+=e.substr(r,1)):(a=!1,t+=e.substr(r,1),t+="\n"+new Array(l+1).join("    "),l++),o=i;break;case"]":a&&(a=!1),"}"===o&&(l--,t+="\n"+new Array(l).join("    ")),t+=e.substr(r,1),o=i;break;case" ":n&&(t+=e.substr(r,1),o=i);break;case",":t+=e.substr(r,1),n||a||(t+="\n"+new Array(l).join("    ")),o=i;break;default:t+=e.substr(r,1),o=i}return t},ZC.Q5.prototype.A5R=function(){var e=this;ZC.AP.BY("source_show",e,e.FG());var i=ZC.Q.HY({cls:"zc-abs zc-viewsource zc-style",id:e.K+"-viewsource",p:ZC.AL(e.K+"-top"),wh:e.I-(ZC.quirks?0:10)+"/"+(e.F-(ZC.quirks?0:10))});i.style.zIndex=99,i.innerHTML=ZC._h_('<div class="zc-form-row-label zc-form-s1">&nbsp;<a href="javascript:void(0)" id="'+e.K+'-viewsource-originalsource" class="zc-tab-active">'+ZC.HJ["viewsource-originalsource"]+'</a>&nbsp;<a href="javascript:void(0)" id="'+e.K+'-viewsource-jsonsource" class="zc-tab-inactive">'+ZC.HJ["viewsource-jsonsource"]+'</a></div><div class="zc-form-row-element"><textarea id="'+e.K+'-viewsource-json" style="width:'+(e.I-35)+"px;height:"+(e.F-95)+'px;"></textarea></div><div class="zc-form-row-element zc-form-row-last" id="'+e.K+'-viewsource-actions"><input type="button" value="'+ZC.HJ["viewsource-close"]+'" id="'+e.K+'-viewsource-close" /></div>'),zingchart.EDITSOURCE&&(ZC.AL(e.K+"-viewsource-actions").innerHTML+='<input type="button" value="'+ZC.HJ["viewsource-apply"]+'" id="'+e.K+'-viewsource-apply" />'),ZC.A4("#"+e.K+"-viewsource-json").val(ZC.AP.WO(e.E.source)),ZC.A4("#"+e.K+"-viewsource-jsonsource").bind("click",function(){ZC.AL(e.K+"-viewsource-jsonsource").className="zc-tab-active",ZC.AL(e.K+"-viewsource-originalsource").className="zc-tab-inactive",ZC.A4("#"+e.K+"-viewsource-json").val(ZC.AP.WO(e.E.json))}),ZC.A4("#"+e.K+"-viewsource-originalsource").bind("click",function(){ZC.AL(e.K+"-viewsource-jsonsource").className="zc-tab-inactive",ZC.AL(e.K+"-viewsource-originalsource").className="zc-tab-active",ZC.A4("#"+e.K+"-viewsource-json").val(ZC.AP.WO(e.E.source))}),ZC.A4("#"+e.K+"-viewsource-close").bind("click",function(){ZC.AP.BY("source_hide",e,e.FG()),ZC.Q.EU(e.K+"-viewsource")}),zingchart.EDITSOURCE&&ZC.A4("#"+e.K+"-viewsource-apply").bind("click",function(){ZC.AP.BY("source_hide",e,e.FG());var i=ZC.A4("#"+e.K+"-viewsource-json").val();ZC.Q.EU(e.K+"-viewsource"),zingchart.exec(e.K,"setdata",{data:i})})},ZC.Q5.prototype.A6K=function(){var e=this;if(e.I<300||e.F<300)window.open("http://www.zingchart.com/support/","","");else{var i=ZC.Q.HY({cls:"zc-abs zc-bugreport zc-style",id:e.K+"-bugreport",p:ZC.AL(e.K+"-top"),wh:e.I-(ZC.quirks?0:10)+"/"+(e.F-(ZC.quirks?0:10))}),t="";t+='<div class="zc-form-row-label zc-form-s0">'+ZC.HJ["bugreport-header"]+'</div><div class="zc-form-row-label"><input type="checkbox" id="'+e.K+'-chkdata" checked="checked" /><label for="'+e.K+'-chkdata">'+ZC.HJ["bugreport-senddata"]+"</label>",ZC.canvas&&(t+='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" id="'+e.K+'-chkcapture" checked="checked" /><label for="'+e.K+'-chkcapture">'+ZC.HJ["bugreport-sendcapture"]+"</label>"),t+='</div><div class="zc-form-row-label zc-form-s1">'+ZC.HJ["bugreport-yourcomment"]+'</div><div class="zc-form-row-element"><textarea id="'+e.K+'-bugreport-comment" style="width:'+(e.I-35)+"px;height:"+((e.F-300)/2-10)+'px;"></textarea></div><div class="zc-form-row-label zc-form-s1">'+ZC.HJ["bugreport-jsondata"]+'</div><div class="zc-form-row-element"><textarea id="'+e.K+'-bugreport-json" style="width:'+(e.I-35)+"px;height:"+(e.F-210)/2+'px;"></textarea></div><div class="zc-form-row-label zc-form-s1">'+ZC.HJ["bugreport-youremail"]+(e.I>=510?" <span>("+ZC.HJ["bugreport-infoemail"]+")</span>":"")+'</div><div class="zc-form-row-element"><input type="text" id="'+e.K+'-bugreport-email" style="width:'+(e.I-35)+'px;" /></div><div class="zc-form-row-element zc-form-row-last"><input type="button" value="'+ZC.HJ["bugreport-submit"]+'" id="'+e.K+'-bugreport-submit" /><input type="button" value="'+ZC.HJ["bugreport-cancel"]+'" id="'+e.K+'-bugreport-cancel" /></div>',i.innerHTML=ZC._h_(t),ZC.A4("#"+e.K+"-bugreport-json").val("PARSED\n----------\n"+ZC.AP.WO(e.E.json)+"\n\nORIGINAL\n----------\n"+ZC.AP.WO(e.E.source)),ZC.A4("#"+e.K+"-bugreport-cancel").bind("click",function(){ZC.Q.EU(e.K+"-bugreport")}),ZC.A4("#"+e.K+"-bugreport-submit").bind("click",function(){var i=ZC.A4("#"+e.K+"-bugreport-email"),t="",n=function(){var n=("Parsed:"+e.E.json+" Original:"+e.E.source).replace(/\r|\n|\t|(\s{2,})/g,""),a="",l=[];ZC.A4("#"+e.K+"-chkcapture").attr("checked")&&l.push("****IMAGE:",t),ZC.A4("#"+e.K+"-chkdata").attr("checked")&&l.push("****JSON:",n),l.push("****COMMENT:",ZC.A4("#"+e.K+"-bugreport-comment").val(),"****EMAIL:",i.val(),"****VERSION:",ZC.VERSION,"****WIDTH:",e.I,"****HEIGHT:",e.F,"****URL:",window.location.href,"****UA:",navigator.userAgent,"****RENDER:",e.AB.toUpperCase(),"****RESOLUTION:",screen.width+"x"+screen.height);for(var o=0;o<l.length-1;o+=2)a+=l[o]+encodeURIComponent(l[o+1]);a+="****END";var r=ZC.Q.ABE(ZC.AL(e.K+"-bugreport")),s=r.createElement("FORM");s.action=document.location.protocol+"//www.zingchart.com/support/submitreportH5.php",s.method="post",r.body.appendChild(s);var A=r.createElement("INPUT");A.type="text",A.name="data",A.value=a,s.appendChild(A),s.submit(),window.setTimeout(function(){alert(ZC.HJ["bugreport-confirm"]),ZC.Q.EU(e.K+"-bugreport")},1e3)};"canvas"===e.AB?(t=zingchart.exec(e.K,"getimagedata",{}),n()):t=zingchart.exec(e.K,"getimagedata",{callback:function(e){t=e,n()}})})}},ZC.Q5.prototype.paintHistory=function(){var e,i,t,n=this;ZC.Q.EU([n.K+"-history-path",n.K+"-history-back-path",n.K+"-history-forw-path",n.K+"-history-gradient",n.K+"-history-back-gradient",n.K+"-history-forw-gradient"]),null!==ZC._n_(e=n.o.history)&&(n.IC=new ZC.DN(n),n.B8.load(n.IC.o,"loader.gui.history"),n.IC.append(e),n.IC.parse(),n.IC.A5J=!0,i=new ZC.DT(n),n.B8.load(i.o,"loader.gui.history.item"),i.append(e.item),i.parse(),t=new ZC.DT(n),n.B8.load(t.o,"loader.gui.history.item-off"),t.append(e.item),t.append(e["item-off"]),t.parse());var a="";if(n.IC){n.IC.K=n.K+"-history",n.IC.Z=n.IC.C7=ZC.AL(n.K+"-static-c"),n.IC.paint();var l=n.IC.iX+n.IC.EQ,o=n.IC.iY+n.IC.FM,r=n.IC.I-n.IC.EQ-n.IC.FN,s=n.IC.F-n.IC.FM-n.IC.FT,A=new ZC.DT(n);A.K=n.K+"-history-back",A.copy(i),A.CZ=!1,0===n.NU&&A.copy(t),A.D=[[l,o+s/2],[l+r/3,o],[l+r/3,o+s],[l,o+s/2]],A.IL=ZC.AL(n.A.K+"-text"),A.Z=A.C7=ZC.AL(n.K+"-static-c"),A.parse(),A.paint(),n.NU>0&&(a+=ZC.Q.FW("rect",!0)+'class="'+n.K+'-history-area zc-history-area" id="'+n.K+'-history-back-area" coords="',a+=ZC._i_(l+ZC.MAPTX)+","+ZC._i_(o+ZC.MAPTX)+","+ZC._i_(l+r/3+ZC.MAPTX)+","+ZC._i_(o+s+ZC.MAPTX),a+='" />');var C=new ZC.DT(n);C.K=n.K+"-history-forw",C.copy(i),C.CZ=!1,n.NU!==n.QM.length-1&&0!==n.QM.length||C.copy(t),C.D=[[l+r,o+s/2],[l+2*r/3,o],[l+2*r/3,o+s],[l+r,o+s/2]],C.IL=ZC.AL(n.A.K+"-text"),C.Z=C.C7=ZC.AL(n.K+"-static-c"),C.parse(),C.paint(),n.NU<n.QM.length-1&&(a+=ZC.Q.FW("rect",!0)+'class="'+n.K+'-history-area zc-history-area" id="'+n.K+'-history-forw-area" coords="',a+=ZC._i_(l+2*r/3+ZC.MAPTX)+","+ZC._i_(o+ZC.MAPTX)+","+ZC._i_(l+r+ZC.MAPTX)+","+ZC._i_(o+s+ZC.MAPTX),a+='" />'),""!==a&&(ZC.AL(n.K+"-map").innerHTML+=a),n.A0Q=function(e){e.target.id===n.K+"-history-back-area"?zingchart.exec(n.K,"goback"):e.target.id===n.K+"-history-forw-area"&&zingchart.exec(n.K,"goforward")},ZC.A4("."+n.K+"-history-area").live("click",n.A0Q)}},ZC.AO={A4S:1,E2:0,E3:0,FU:40},ZC.DK={A2T:function(e,i){var t,n;return i.A9%180==0?(t=new ZC.CE(e,-e.I/2,i.iY-e.iY-e.F/4,0),n=new ZC.CE(e,e.I/2,i.iY-e.iY-e.F/4,0)):(t=new ZC.CE(e,i.iX-e.iX-e.I/4,-e.F/2,0),n=new ZC.CE(e,i.iX-e.iX-e.I/4,e.F/2,0)),ZC.TN(Math.atan((n.ED[1]-t.ED[1])/(n.ED[0]-t.ED[0])))+(i.A9%180==0?0:i.A9%360==90?90:-90)},DB:function(e,i,t,n,a,l,o,r,s){s=s||"z";var A,C,c,u,p=new ZC.W6(e,i);switch(s){case"x":A=new ZC.CE(i,t,a,o),C=new ZC.CE(i,n,a,o),c=new ZC.CE(i,n,l,r),u=new ZC.CE(i,t,l,r);break;case"y":A=new ZC.CE(i,t,a,o),C=new ZC.CE(i,t,l,o),c=new ZC.CE(i,n,l,r),u=new ZC.CE(i,n,a,r);break;case"z":A=new ZC.CE(i,t,a,o),C=new ZC.CE(i,t,a,r),c=new ZC.CE(i,n,l,r),u=new ZC.CE(i,n,l,o)}return p.add(A),p.add(C),p.add(c),p.add(u),p},D8:function(e,i,t,n){void 0===n&&(n=!1);var a,l=null,o=null;t instanceof Array?l=t:(l=t.points,o=t.mathpoints);for(var r=new ZC.W6(e,i),s=0,A=l.length;s<A;s++)null!==ZC._n_(l[s])&&(n?r.add(l[s],o?o[s]:null):r.add(new ZC.CE(i,l[s][0],l[s][1],l[s][2]),o?new ZC.CE(i,o[s][0],o[s][1],o[s][2]):null));return(a=e.o["z-modifier"])&&(r.MC=[ZC._i_(a),ZC._i_(a),ZC._i_(a)]),r}};var CE={$i:function(e,i,t,n){this.parse(e,i,t,n)},parse:function(e,i,t,n){var a=this;a.C=e,a.iX=i,a.iY=t,n-=a.C.EZ.depth/2,a.iZ=n,a.EL=0,a.EP=0,a.AAM=0,a.ED=[];var l=a.C.EZ.angle,o=a.C.EZ.zoom;if(a.C.EZ.true3d){var r={x:i,y:t,z:n},s={x:0,y:0,z:0},A={x:a.C.EZ["x-angle"],y:a.C.EZ["y-angle"],z:a.C.EZ["z-angle"]},C=2*Math.PI/360,c=Math.sin(A.x*C),u=Math.sin(A.y*C),p=Math.sin(A.z*C),Z=Math.cos(A.x*C),h=Math.cos(A.y*C),d=Math.cos(A.z*C);a.EL=h*(p*(r.y-s.y)+d*(r.x-s.x))-u*(r.z-s.z),a.EP=c*(h*(r.z-s.z)+u*(p*(r.y-s.y)+d*(r.x-s.x)))+Z*(d*(r.y-s.y)-p*(r.x-s.x)),a.AAM=Z*(h*(r.z-s.z)+u*(p*(r.y-s.y)+d*(r.x-s.x)))-c*(d*(r.y-s.y)-p*(r.x-s.x)),a.ED[0]=ZC.AO.E2+ZC.AO.A4S/(ZC.AO.A4S+a.AAM)*a.EL*o,a.ED[1]=ZC.AO.E3+ZC.AO.A4S/(ZC.AO.A4S+a.AAM)*a.EP*o}else a.ED[0]=ZC.AO.E2+i+n*ZC.EH(l)*o,a.ED[1]=ZC.AO.E3+t-n*ZC.EO(l)*o}};ZC.CE=ZC.C9.CA(CE);var W6={$i:function(e,i){var t=this;t.C=i,t.O=e,t.K="",t.K9=!1,t.MC=[1,1,1],t.FZ=-1,t.D=[],t.PB=[],t.SJ=-9999,t.ZS=-9999,t.A5C=9999,t.A4U=9999,t.A9A=9999,t.A3M=0,t.A20=0,t.ABY=0},add:function(e,i){this.D.push(e),this.PB.push(i||e)},ADC:function(){for(var e=this,i=e.PB.length,t=0;t<i;t++){var n=e.PB[t];e.SJ=ZC.BQ(e.SJ,n.iZ),ZC._b_(e.C.EZ.true3d)?(e.A5C=ZC.CY(e.A5C,n.iZ),e.ZS=ZC.BQ(e.ZS,n.AAM),e.A20+=n.iY):(e.A4U=ZC.CY(e.A4U,n.iX),e.A9A=ZC.CY(e.A9A,n.iY),e.A3M+=n.iX,e.A20+=n.iY,e.ABY+=n.iZ)}e.A3M/=i,e.A20/=i,e.ABY/=i},FF:function(){for(var e=this,i="",t=0,n=e.D.length;t<n;t++)i+=ZC._i_(e.D[t].ED[0]+ZC.MAPTX)+","+ZC._i_(e.D[t].ED[1]+ZC.MAPTX)+",";return i=i.substring(0,i.length-1)}};ZC.W6=ZC.C9.CA(W6);var SN={$i:function(){var e=this;e.A52=[],e.A6L={},e.WI=[],e.SE={}},clear:function(){var e=this;e.A52=[],e.WI=[],e.SE={}},add:function(e){this.A52.push(e)},sortFaces:function(e,i){return 1===zingchart.V3D?e[0][0]>i[0][0]?-1:e[0][0]<i[0][0]?1:e[0][1]>i[0][1]?1:e[0][1]<i[0][1]?-1:e[0][2]>i[0][2]?-1:e[0][2]<i[0][2]?1:e[0][3]>i[0][3]?-1:e[0][3]<i[0][3]?1:0:2===zingchart.V3D?-1!==e[0][3]||-1!==i[0][3]?e[0][3]>i[0][3]?1:e[0][3]<i[0][3]?-1:0:e[0][0]>i[0][0]?-1:e[0][0]<i[0][0]?1:e[0][1]>i[0][1]?1:e[0][1]<i[0][1]?-1:e[0][2]>i[0][2]?1:e[0][2]<i[0][2]?-1:0:3===zingchart.V3D?e[0]>i[0]?-1:e[0]<i[0]?1:0:void 0}};ZC.SN=ZC.C9.CA(SN);var A27={$i:function(e){var i=this;i.H=e,i.VB=!1,i.OP=250,i.GI=0,i.IH=0,i.GZ=20,i.BA="",i.CG=[],i.A7=null},onmouseout:function(){var e=this;ZC.mobile||(e.VB?(null!==ZC._n_(e.C4)&&window.clearInterval(e.C4),e.C4=window.setInterval(function(){var i=e.H.K,t=ZC.A4("#"+i+("svg"===e.H.AB?"-top":"-main")),n=ZC.E1[0]-t.offset().left,a=ZC.E1[1]-t.offset().top;ZC.DS(n,e.GI,e.GI+e.A7.I)&&ZC.DS(a,e.IH,e.IH+e.A7.F)||(null!==ZC._n_(e.C4)&&window.clearInterval(e.C4),e.hide())},e.OP)):e.hide())},clear:function(){var e=this;ZC.Q.IV(ZC.AL(e.H.K+"-tooltip-c"),e.H.AB,e.iX,e.iY,e.I,e.F,e.K)},hide:function(){if(!ZC.TTLOCK){var e=this.H.K;ZC.Q.EU([e+"-tooltip-text",e+"-tooltip",e+"-tooltip-text-float"]),"svg"===this.H.AB&&ZC.A4("clipPath").each(function(){-1!==this.id.indexOf("-hover_image-clip")&&ZC.Q.EU(this.id)})}},show:function(e){var i,t=this;null!==ZC._n_(t.C4)&&window.clearInterval(t.C4);var n=t.H.K;if(0!==ZC.A4("#"+n+"-tooltip-c").length&&t.A7){var a=ZC._tx_(t.H.K),l=ZC.Q.MF(e),o=ZC.A4("#"+n+("svg"===t.H.AB?"-top":"-main")),r=null===ZC._n_(e.target)?t.A7.o.x:l[0]-o.offset().left,s=null===ZC._n_(e.target)?t.A7.o.y:l[1]-o.offset().top,A=r-t.A7.I*a[0]/2,C=s-t.A7.F*a[1],c=A,u=1+2*t.A7.JV;if(null!==ZC._n_(t.A7.o.x)&&((A=ZC.II(t.A7.o.x,!0))>0&&A<1&&(A=ZC._i_(t.H.I*A)),t.A7.o.fixed&&(A-=t.A7.I/2)),null!==ZC._n_(t.A7.o.y)&&((C=ZC.II(t.A7.o.y,!0))>0&&C<1&&(C=ZC._i_(t.H.F*C)),t.A7.o.fixed&&(C-=t.A7.F/2)),A+=ZC._i_(t.A7.E["offset-x"]),C+=ZC._i_(t.A7.E["offset-y"]),"svg"===t.H.AB||!t.A7.o.placement||t.A7.o.fixed){var p=0,Z=!1,h=t.A7.EM;A/a[0]<u&&(p=c/a[0]-u-t.A7.H9/2,A=u),A/a[0]+t.A7.I>t.H.I-u&&(p=c/a[0]+t.A7.I-t.H.I+u+t.A7.H9/2,A=(t.H.I-u-t.A7.I)*a[0]),C/a[1]<u&&(t.CG.node||!t.A7.o.placement||t.A7.o.fixed?(C=u+ZC._i_(t.A7.E["offset-y"]),C=t.CG.node?C<u?u:C:C<u?s-ZC._i_(t.A7.E["offset-y"]):C,h="top",Z=!0):C=u+(s-ZC._i_(t.A7.E["offset-y"]))),C/a[1]+t.A7.F>t.H.F-u&&(C=t.H.F-u-t.A7.F,(t.CG.node||!t.A7.o.placement||t.A7.o.fixed)&&(h="top",Z=!0)),Z&&(t.A7.EM=h),(0!==p||Z)&&t.A7.Z&&(t.clear(),Z&&(t.A7.EM=h),p=ZC.CY(p,t.A7.I/2-t.A7.H9/2),p=48*(p=ZC.BQ(p,-t.A7.I/2+t.A7.H9/2))/(t.A7.I/2-t.A7.H9/2),t.A7.EW=p,t.A7.AN&&t.A7.paint())}switch(t.GI=A,t.IH=C,t.H.AB){case"svg":null===ZC._n_(t.A7.o.x)&&null===ZC._n_(t.A7.o.y)&&ZC.AL(n+"-tooltip").setAttribute("transform","translate("+A/a[0]+","+C/a[1]+")"),t.A7.E["html-mode"]&&ZC.Q.PI(ZC.AL(n+"-tooltip-text-float"),{left:(""===t.BA?A/a[0]:t.A7.iX)+t.A7.EQ+"px",top:(""===t.BA?C/a[1]:t.A7.iY)+t.A7.FM+"px"});break;case"vml":null===ZC._n_(t.A7.o.x)&&null===ZC._n_(t.A7.o.y)&&ZC.Q.PI(ZC.AL(n+"-tooltip"),{left:A+"px",top:C+"px"});break;case"canvas":null!==ZC._n_(t.CG.x)&&(A=t.CG.x),null!==ZC._n_(t.CG.y)&&(C=t.CG.y);var d=t.A7.E["html-mode"]?0:20;switch(t.A7.WV){case"tl":break;case"tr":A-=t.A7.I;break;case"bl":C-=t.A7.F;break;case"br":A-=t.A7.I,C-=t.A7.F;break;case"c":A-=t.A7.I/2,C-=t.A7.F/2;break;case"t":A-=t.A7.I/2;break;case"r":A-=t.A7.I,C-=t.A7.F/2;break;case"b":A-=t.A7.I/2,C-=t.A7.F;break;case"l":C-=t.A7.F/2}ZC.Q.PI(ZC.AL(n+"-tooltip-c"),{left:A/a[0]-d+"px",top:C/a[1]-d+"px"}),null!==(i=ZC.AL(n+"-tooltip-text"))&&(i.style.display="none",ZC.Q.PI(i,{width:t.A7.I+"px",height:t.A7.F+"px",left:A/a[0]+"px",top:C/a[1]+"px"}),i.style.display="block")}}},onmousemove:function(e){this.show(e)},onmouseover:function(e,i){var t,n,a,l,o,r,s,A=this,C=A.H.K,c=e.targetid||e.target.id,u=c.replace(/--([a-zA-Z0-9]+)/,"").replace("-gshape-area","-area").replace("-area-path","").replace("-path","").replace("-marker-circle","").replace("-marker","").split("-").reverse(),p=c.split("--"),Z=!1,h=!1,d=!1;if("node"===u[1]&&"plot"===u[3]&&"plotset"===u[4]&&(Z=!0),ZC.Q.EU([C+"-tooltip-text",C+"-tooltip",C+"-tooltip-text-float"]),Z){if(!(l=A.H.OS(u[5])))return;if(o=l.AY.A5[u[2]],r=o.FK(u[0]),"xy"===l.AJ.layout&&r.T7(),!r)return;ZC.A4("#"+C+"-graph-"+u[5]+"-plot-"+u[2]+"-bg-hover-c").show()}else"legend"===u[2]&&0===u[1].indexOf("item")&&(h=!0),0!==u[2].indexOf("scale")||0!==u[1].indexOf("item")&&0!==u[1].indexOf("marker")||(d=!0),l=A.H.OS(u[3]);if(ZC.AL(C+"-tooltip")||(ZC.Q.JZ({id:C+"-tooltip",p:ZC.AL(C+"-main"),cls:"zc-abs zc-tooltip",wh:A.H.I+"/"+A.H.F,overflow:"hidden"},A.H.AB),ZC.Q.HE({id:C+"-tooltip-c",p:ZC.AL(C+"-tooltip"),cls:"zc-abs",tl:"-999/-999",width:140,height:60},A.H.AB)),A.A7=zingchart.pool.getInstance("DN",A,C+"-tooltip-text"),A.A7.OB="tooltip",A.A7.A=A.H,l&&l.A7&&A.A7.copy(l.A7),Z)A.A7.append(o.A7.o),l.CB["p"+o.L]&&l.CB["p"+o.L]["n"+r.L]&&A.A7.append(o.A7.o["selected-state"]),2===p.length&&A.A7.append(o.ABZ(p[1]));else{var f=!1;if(h&&l.BD&&null!==ZC._n_(l.BD.o.tooltip)&&(A.A7.o.text="",A.A7.append(l.BD.o.tooltip),f=!0),d){A.A7.append({"background-color":"#fff","border-width":1,"border-color":"#999"});var _=l.BM(u[2].replace(/\_/g,"-"));if(_&&null!==ZC._n_(_.o.tooltip)&&(A.A7.o.text="",A.A7.append(_.o.tooltip),f=!0),0===u[1].indexOf("item_"))_&&(-1!==u[1].indexOf("_title")&&_.o.label&&_.o.label.tooltip?(A.A7.o.text="",A.A7.append(_.o.label.tooltip),f=!0):_.o.item&&_.o.item.tooltip&&(A.A7.o.text="",A.A7.append(_.o.item.tooltip),f=!0));else if(0===u[1].indexOf("marker_")){var g=ZC._i_(u[1].replace("marker_",""));_.Q1[g]&&_.Q1[g].o.label&&_.Q1[g].o.label.tooltip&&(A.A7.o.text="",A.A7.append(_.Q1[g].o.label.tooltip),f=!0)}}if("shape"===u[2])if(A.A7.append({"background-color":"#fff","border-width":1,"border-color":"#999"}),e.target.getAttribute("data-lowlevel"))A.A7.append({text:e.target.getAttribute("data-tooltip-text")}),f=!0;else for(n=0,a=l.FH.length;n<a;n++)if(null!==ZC._n_(l.FH[n])){var v=l.FH[n]instanceof ZC.P0?l.FH[n].BF:l.FH[n];l.K+"-shape-"+u[1]===l.FH[n].K&&null!==ZC._n_(t=v.o.tooltip)&&(A.A7.append(t),A.A7.o.fixed&&(A.A7.o.x=v.iX,A.A7.o.y=v.iY),f=!0)}if("label"===u[2])for(A.A7.append({"background-color":"#fff","border-width":1,"border-color":"#999"}),n=0,a=l.BX.length;n<a;n++)l.K+"-label-"+u[1]===l.BX[n].K&&null!==ZC._n_(t=l.BX[n].o.tooltip)&&(A.A7.append(t),A.A7.o.fixed&&(A.A7.o.x=l.BX[n].iX+l.BX[n].I/2,A.A7.o.y=l.BX[n].iY+l.BX[n].F/2),f=!0);if("xy"===u[2]&&(A.A7.append({"background-color":"#fff","border-width":1,"border-color":"#999"}),f=!0),!f)return}i&&A.A7.append(i),A.VB=!1,A.OP=250,null!==ZC._n_(t=A.A7.o.sticky)&&(A.VB=ZC._b_(t)),null!==ZC._n_(t=A.A7.o.timeout)&&(A.OP=ZC._i_(t)),null!==ZC._n_(t=A.A7.o.placement)?A.BA=t:A.BA="",null!==ZC._n_(t=A.A7.o.distance)&&(A.GZ=ZC._i_(t)),A.A7.iX=0,A.A7.iY=0,A.A7.Z=A.A7.C7=ZC.AL(C+"-tooltip-c");var b={};if(Z)s=r.Y2(),r.H3(s),null!==ZC._n_(s["line-color"])?A.A7.A0=A.A7.AE=ZC.AP.JK(s["line-color"]):A.A7.A0=A.A7.AE=ZC.AP.JK(s["background-color"]),A.A7.BW=s["border-color"],A.A7.C2=s.color,null!==ZC._n_(o.o.rules)?(A.A00||(A.A00=new ZC.HV(o.A),A.A00.E["quick-parse"]=!0),A.A00.append(o.o),A.A00.parse(),A.A00.J2=function(e){return r.J2(e)},A.A00.DE()&&A.A00.parse(),A.A7.AM=A.A00.J7):A.A7.AM=o.J7,b=ZC.AP.O2(A.A7.o,o.o),A.A7.JT=function(e){return r.JT(e,b)},A.A7.E.plotidx=r.A.L,A.A7.E.nodeidx=r.L;else if(h){for(o=l.AY.A5[u[1].replace("item_","")],A.A7.append(o.o["legend-tooltip"]),r=null,n=0,a=o.S.length;n<a;n++)if(null!==o.S[n]){r=o.FK(n);break}if(r){if("-1"===(s=r.Y2())["background-color"])return;A.A7.A0=A.A7.AE=ZC.AP.JK(s["background-color"]),A.A7.C2=s.color}else A.A7.A0=A.A7.AE=ZC.AP.JK(o.BP[1]),A.A7.C2=o.BP[0];A.A7.AM=o.OZ,A.A7.JT=function(e){return e=(e=e.replace(/%plot-description/g,o.OZ)).replace(/%plot-text|%t/g,o.AM)}}else if(d){if(0===u[1].indexOf("item_")){var B=u[1].replace("item_","").split("_"),m=1===B.length?ZC._i_(B[0]):ZC._i_(B[1]);A.A7.JT=function(e){e=e||"%scale-value";var i=_.BX[m]||_.V[m];if(_.F5){var t={"transform-date":!0,"transform-date-format":_.F5.o.all||_.F5.o.text||"",utc:l.UN,timezone:l.ND};i=ZC.AP.G2(i,t,A.A,!!_.F5&&_.F5)}for(var n in"number"==typeof i&&_.IT&&null!==ZC._n_(_.IT[i])&&(i=_.IT[i]),e=(e=e.replace(/%text|%item-text|%scale-value|%v/g,i)).replace(/%tooltip-text/g,_.A53[m]||""),_.o)_.o.hasOwnProperty(n)&&"data-"===n.substring(0,5)&&(e=e.replace("%"+n,_.o[n][m]||"","g"));return e}}}else A.A7.JT=function(e){return e};if(null===ZC._n_(A.A7.o["text-alpha"])&&(A.A7.o["text-alpha"]=1),A.A7.parse(),!Z&&"canvas"!==A.H.AB&&A.A7.o.fixed&&(A.A7.iX=A.A7.iX-A.A7.I/2+A.A7.BL,A.A7.iY=A.A7.iY-A.A7.F/2+A.A7.BH),A.A7.AN){var E,D;if(A.A7.HT&&(Z&&A.A7.H3(A.A7,A.A7,null,r.LY(e,!1)),A.A7.parse()),A.A7.E["html-mode"]=!1,null!==ZC._n_(t=A.A7.o["html-mode"])&&(A.A7.E["html-mode"]=ZC._b_(t)),Z&&(A.A7.J2=function(e){return r.J2(e)},A.A7.DE()&&(b=A.A7.overrideFormat(b),A.A7.parse())),"canvas"!==A.H.AB&&"vml"!==A.H.AB||0===A.A7.A9)E=A.A7.I+A.A7.JV,D=A.A7.F+A.A7.JV,E+=40,D+=40,A.A7.E["offset-x"]=A.A7.BL,A.A7.E["offset-y"]=A.A7.BH;else{var F=1.25*ZC.BQ(A.A7.I,A.A7.F)+A.A7.JV;E=F,D=F,A.A7.iX+=(F-A.A7.I)/2,A.A7.iY+=(F-A.A7.F)/2,A.A7.E["offset-x"]=-(F-A.A7.I)/2+A.A7.BL,A.A7.E["offset-y"]=-(F-A.A7.F)/2+A.A7.BH}if(ZC.A4("#"+C+"-tooltip-c").attr("width",E).attr("height",D),"vml"===A.H.AB&&ZC.Q.PI(ZC.AL(C+"-tooltip-c"),{top:0,left:0}),A.A7.Q9=A.A7.BL,A.A7.MB=A.A7.BH,A.A7.BL=0,A.A7.BH=0,!e.type&&Z){var K=r.iX,x=r.iY;if(null!==ZC._n_(r.bCXY)){var I=r.ACE();K=I[0],x=I[1]}"canvas"===A.H.AB?(null===ZC._n_(A.A7.o.x)&&(A.A7.o.x=K-A.A7.I/2),null===ZC._n_(A.A7.o.y)&&(A.A7.o.y=x-A.A7.F)):(null===ZC._n_(A.A7.o.x)&&(A.A7.iX=K-A.A7.I/2),null===ZC._n_(A.A7.o.y)&&(A.A7.iY=x-A.A7.F-20))}if(Z&&(A.CG=A.getPlacementInfo(r),""!==A.BA&&("canvas"!==A.H.AB?(A.A7.o.x=A.A7.iX=A.CG.x,A.A7.o.y=A.A7.iY=A.CG.y):(A.A7.o.x=A.A7.iX=0,A.A7.o.y=A.A7.iY=0),A.A7.EM=A.CG.cp,A.A7.EW=A.CG.co)),A.A7.AN&&""!==A.A7.AM&&("canvas"===A.H.AB&&(A.A7.E["html-mode"]||(A.A7.iX=20,A.A7.iY=20)),A.A7.paint()),(e.type&&Z||e.update)&&(r.AB2(),r.C.QK(!0)),e.type||"canvas"===A.H.AB)A.show(e);else if(A.A7.E["html-mode"]){var y=A.A7.iX+A.A7.EQ,w=A.A7.iY+A.A7.FM;ZC.Q.PI(ZC.AL(C+"-tooltip-text-float"),{left:y+"px",top:w+"px",zIndex:zingchart.ZINDEX})}}},getPlacementInfo:function(e){var i,t=this,n={},a=t.A7.H9,l=t.A7.G8,o=t.A7.I,r=t.A7.F;if(t.A7.E["html-mode"]&&("horizontal"===t.BA||"vertical"===t.BA||"node:"===t.BA.substring(0,5))&&(t.A7.iX=-9999,t.A7.iY=-9999,t.A7.AN)){t.A7.paint();var s=ZC.A4("#"+t.H.K+"-tooltip-text-"+("canvas"===t.H.AB?"t":"float"));o=s.width()+t.A7.EQ+t.A7.FN,r=s.height()+t.A7.FM+t.A7.FT,null!==ZC._n_(t.A7.o.width)&&(o=ZC._i_(t.A7.o.width)),null!==ZC._n_(t.A7.o.height)&&(r=ZC._i_(t.A7.o.height))}if("horizontal"===t.BA)e.iX+e.I/2<e.C.iX+e.C.I/2?(n.x=e.iX+0*e.I+t.GZ,n.y=e.iY+0*e.F/2-r/2,n.cp="left"):(n.x=e.iX-o-t.GZ,n.y=e.iY+0*e.F/2-r/2,n.cp="right"),n.y<5&&(i=5-n.y,n.co=-ZC._i_(100*i/(r-l)),n.y=5),n.y+r>t.H.F-5&&(i=t.H.F-5-n.y-r,n.co=-ZC._i_(100*i/(r-l)),n.y=t.H.F-5-r);else if("vertical"===t.BA)e.iY+e.F/2<e.C.iY+e.C.F/2?(n.y=e.iY+0*e.F+t.GZ,n.x=e.iX+0*e.I/2-o/2,n.cp="top"):(n.y=e.iY-r-t.GZ,n.x=e.iX+0*e.I/2-o/2,n.cp="bottom"),n.x<5&&(i=5-n.x,n.co=-ZC._i_(100*i/(t.A7.I-a)),n.x=5),n.x+o>t.H.I-5&&(i=t.H.I-5-n.x-o,n.co=-ZC._i_(100*i/(o-a)),n.x=t.H.I-5-o);else if("node:"===t.BA.substring(0,5)&&e.getTooltipPosition){switch((n=e.getTooltipPosition(t.A7,t.BA.substring(5))).node=!0,n.side=t.BA.substring(5),n.side){case"left":n.x=n.x-o+t.A7.Q9,n.y=n.y-r/2+t.A7.MB;break;case"right":n.x=n.x+t.A7.Q9,n.y=n.y-r/2+t.A7.MB;break;case"top":n.x=n.x-o/2+t.A7.Q9,n.y=n.y-r+t.A7.MB;break;case"bottom":n.x=n.x-o/2+t.A7.Q9,n.y=n.y+t.A7.MB;break;case"center":n.x=n.x-o/2+t.A7.Q9,n.y=n.y-r/2+t.A7.MB}n.cp=t.A7.EM}if(n.node){var A=0;n.y+r>t.H.F-5&&("top"===n.side||"bottom"===n.side?(n.y=n.y-r-("bottom"===n.side?0:t.A7.G8)-t.A7.MB,n.cp="bottom"):n.y=t.H.F-r-5),n.y<5&&("top"===n.side||"bottom"===n.side?(n.y=n.y+("top"===n.side?0:t.A7.G8)+r-t.A7.MB,n.cp="top"):n.y=5),n.x+o>t.H.I-5&&("left"===n.side||"right"===n.side?(n.x=n.x-o-t.A7.Q9-5,n.cp="right"):(A=48*(o-t.H.I+n.x+t.A7.H9/2)/(t.A7.I/2),n.x=t.H.I-o-t.A7.Q9-5),n.co=A),n.x<5&&("left"===n.side||"right"===n.side?(n.x=n.x+t.A7.I-t.A7.Q9+5,n.cp="left"):(A=48*(n.x-t.A7.H9/2)/(t.A7.I/2),n.x=5),n.co=A)}return n}};ZC.A27=ZC.C9.CA(A27);var A4Z={$i:function(e){this.b(e);var i=this;i.H=e,i.IM=!1,i.C=null,i.R2=null,i.WP=null,i.I8=0,i.LC=0,i.I7=0,i.LF=0,i.A8=null,i.AK=null,i.Z9=!1,i.AB9=0,i.A0G=!1,i.M=null},parse:function(){var e=this;e.C&&(e.C.H1&&e.append(e.C.H1.o),e.b(),e.ZQ("preserve-zoom","A0G","b"),e.M=new ZC.DN(e),e.C.A.B8.load(e.M.o,"graph.zoom.label"),e.M.append(e.o.label),e.M.parse(),e.o.label&&!1!==e.o.label.visible&&(e.M.AN=!0))},unbind:function(){var e=this;zingchart.DEV.SKIPTRACKERS?ZC.A4(document.body).unbind("mousedown touchstart",e.R3):ZC.A4("#"+e.H.K+"-img").unbind("mousedown touchstart",e.R3),ZC.A4(".zc-node-area").die("mousedown touchstart",e.R3),ZC.A4(document.body).unbind("mousemove touchmove",e.U8),ZC.A4(document.body).unbind("mouseup touchend",e.TI)},bind:function(){var e=this,i=e.H.K;e.R3=function(t){if((!ZC.mobile||"pinch"!==zingchart.TOUCHZOOM)&&!(t.which>1||-1!==ZC.Q.T4(t.target).indexOf("zc-menu-item")||ZC.move)&&("mousedown"!==t.type||!ZC.TOUCHEVENTS)&&-1===t.target.id.indexOf("-legend-header-area")&&(ZC.mobile||t.preventDefault(),e.H.hideCM(),(ZC.mobile||!(t.which>1))&&("vml"!==e.H.AB||-1===t.target.className.indexOf("zc-node-area")))){t.shiftKey&&(e.Z9=!0);var n=ZC.Q.MF(t),a=ZC._tx_(e.H.K),l=ZC.A4("#"+i+"-top").offset(),o=(n[0]-l.left)/a[0],r=(n[1]-l.top)/a[1];e.R2=o,e.WP=r,e.Z9&&(e.AB9=o);for(var s,A=!1,C=0,c=e.H.AG.length;C<c;C++)s=e.H.AG[C].P,ZC.DS(o,s.iX-5,s.iX+s.I+5)&&ZC.DS(r,s.iY-5,s.iY+s.F+5)&&(e.C=e.H.AG[C]);if(null!==e.C){var u={id:e.H.K,graphid:e.C.K,ev:t},p=ZC.AP.BY("beforezoom",e.H,u,!0);if(void 0!==p&&!p)return;if(e.C.H1&&null!==ZC._n_(e.C.H1.o.active)&&!ZC._b_(e.C.H1.o.active))return;s=e.C.P,e.C.AY.A5.length>0&&(e.A8=e.C.BM(e.C.AY.A5[0].BU("k")[0]),e.AK=e.C.BM(e.C.AY.A5[0].BU("v")[0])),null!==e.A8&&null!==e.AK&&e.C.AJ["enable-zooming"]&&(e.A8.GN||e.AK.GN)&&(e.I8=e.A8.CO?r:o,e.I7=e.AK.CO?o:r,A=!0,e.A8.GN?e.A8.CO?e.I8=ZC._l_(e.I8,s.iY,s.iY+s.F):e.I8=ZC._l_(e.I8,s.iX,s.iX+s.I):e.I8=e.A8.CO?s.iY:s.iX,e.AK.GN?e.AK.CO?e.I7=ZC._l_(e.I7,s.iX,s.iX+s.I):e.I7=ZC._l_(e.I7,s.iY,s.iY+s.F):e.I7=e.AK.CO?s.iX:s.iY)}return A&&(e.LC=e.I8,e.LF=e.I7,e.IM=!0,ZC.A4(document.body).bind("mousemove touchmove",e.U8),ZC.A4(document.body).bind("mouseup touchend",e.TI),e.Z9?document.body.style.cursor="pointer":(e.parse(),e.C.AJ["3d"]||ZC.Q.HY({id:i+"-zoom",p:ZC.AL(i+"-top"),top:-9,left:-9,wh:"1/1",position:"absolute",border:e.AU+"px solid "+e.BW,background:e.A0,opacity:e.C6}),e.M.AN&&(ZC.Q.HY({id:i+"-from",p:ZC.AL(i+"-top"),top:-9999,left:-9999,position:"absolute",paddingTop:e.M.FM,paddingRight:e.M.FN,paddingBottom:e.M.FT,paddingLeft:e.M.EQ,border:e.M.AU+"px solid "+e.M.BW,background:e.M.A0,color:e.M.C2,fontFamily:e.M.GH,fontWeight:e.M.sFontWeight,fontStyle:e.M.N1?"oblique":"normal",fontSize:e.M.DI,text:""}),ZC.Q.HY({id:i+"-to",p:ZC.AL(i+"-top"),top:-9999,left:-9999,position:"absolute",paddingTop:e.M.FM,paddingRight:e.M.FN,paddingBottom:e.M.FT,paddingLeft:e.M.EQ,border:e.M.AU+"px solid "+e.M.BW,background:e.M.A0,color:e.M.C2,fontFamily:e.M.GH,fontWeight:e.M.sFontWeight,fontStyle:e.M.N1?"oblique":"normal",fontSize:e.M.DI,text:""})),document.body.style.cursor="crosshair")),!!ZC.mobile&&void 0}},e.U8=function(t){if("mousemove"!==t.type||!ZC.TOUCHEVENTS){var n,a;if(ZC.mobile||t.preventDefault(),ZC.move=!0,e.C||(ZC.move=!1,e.IM=!1,ZC.A4(document.body).unbind("mousemove touchmove",e.U8),ZC.A4(document.body).unbind("mouseup touchend",e.TI),document.body.style.cursor="auto",ZC.Q.EU([i+"-zoom",i+"-from",i+"-to"])),e.IM){e.C.A.A7.hide();var l=ZC.Q.MF(t),o=ZC._tx_(e.H.K),r=ZC.A4("#"+i+"-top").offset(),s=(l[0]-r.left)/o[0],A=(l[1]-r.top)/o[1];t.ctrlKey;var C=e.A8.DF?e.A8.AA:0;if(e.LC=e.A8.CO?A:s,e.LF=e.AK.CO?s:A,!e.Z9){var c,u,p,Z,h=e.C.P;n=e.A8.AW?e.A8.BV:e.A8.AC,a=e.A8.AW?e.A8.AC:e.A8.BV,e.A8.GN?e.A8.CO?(e.A8.Y7&&(e.I8=e.A8.iY+n+e.A8.AA*ZC._i_((e.I8-e.A8.iY-n-C/2)/e.A8.AA),e.LC=e.A8.iY+n+C+e.A8.AA*ZC._i_((e.LC-e.A8.iY-n-C/2)/e.A8.AA)),e.I8=ZC._l_(e.I8,h.iY+a,h.iY+h.F-n),e.LC=ZC._l_(e.LC,h.iY+a,h.iY+h.F-n)):(e.A8.Y7&&(e.I8=e.A8.iX+n+e.A8.AA*ZC._i_((e.I8-e.A8.iX-n-C/2)/e.A8.AA),e.LC=e.A8.iX+n+C+e.A8.AA*ZC._i_((e.LC-e.A8.iX-n-C/2)/e.A8.AA)),e.I8=ZC._l_(e.I8,h.iX+n,h.iX+h.I-a),e.LC=ZC._l_(e.LC,h.iX+n,h.iX+h.I-a)):(e.I8=e.A8.CO?h.iY+a:h.iX+n,e.LC=e.A8.CO?h.iY+h.F-n:h.iX+h.I-a),n=e.AK.AW?e.AK.AC:e.AK.BV,a=e.AK.AW?e.AK.BV:e.AK.AC,e.AK.GN?e.AK.CO?(e.AK.Y7&&(e.I7=e.AK.iX+n+e.AK.AA*ZC._i_((e.I7-e.AK.iX-n)/e.AK.AA),e.LF=e.AK.iX+n+e.AK.AA*ZC._i_((e.LF-e.AK.iX-n)/e.AK.AA)),e.I7=ZC._l_(e.I7,h.iX+a,h.iX+h.I-n),e.LF=ZC._l_(e.LF,h.iX+a,h.iX+h.I-n)):(e.AK.Y7&&(e.I7=e.AK.iY+n+e.AK.AA*ZC._i_((e.I7-e.AK.iY-n)/e.AK.AA),e.LF=e.AK.iY+n+e.AK.AA*ZC._i_((e.LF-e.AK.iY-n)/e.AK.AA)),e.I7=ZC._l_(e.I7,h.iY+n,h.iY+h.F-a),e.LF=ZC._l_(e.LF,h.iY+n,h.iY+h.F-a)):(e.I7=e.AK.CO?h.iX+a:h.iY+n,e.LF=e.AK.CO?h.iX+h.I-n:h.iY+h.F-a);var d=ZC.A4.browser.msie?0:2*e.AU;e.C.AJ["3d"]&&(d=0);var f=ZC.AL(i+"-zoom");if(e.A8.CO&&e.AK.CO?(c=ZC._a_(e.LF-e.I7-d),u=ZC._a_(e.LC-e.I8-d),p=ZC.CY(e.I7,e.LF),Z=ZC.CY(e.I8,e.LC)):(c=ZC._a_(e.LC-e.I8-d),u=ZC._a_(e.LF-e.I7-d),p=ZC.CY(e.I8,e.LC),Z=ZC.CY(e.I7,e.LF)),e.C.AJ["3d"]){e.C.NX();var _=ZC.AL(e.H.K+"-guide-c");_&&(ZC.Q.IV(_,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F),ZC.A4(".zc-guide-label").remove()),(f=new ZC.DT(e)).Z=_,f.A0=f.AE=e.A0,f.BW=e.BW,f.AU=e.AU,f.C6=e.C6,f.D=[[p,Z],[p+c,Z],[p+c,Z+u],[p,Z+u],[p,Z]];for(var g=0;g<f.D.length;g++){var v=new ZC.CE(e.C,f.D[g][0]-ZC.AO.E2,f.D[g][1]-ZC.AO.E3,0);f.D[g][0]=v.ED[0],f.D[g][1]=v.ED[1]}f.parse(),f.paint()}else ZC.Q.PI(f,{width:c+"px",height:u+"px",left:p+"px",top:Z+"px"});if(e.M.AN){var b=ZC.CY(e.I8,e.LC),B=ZC.BQ(e.I8,e.LC),m=ZC.CY(e.I7,e.LF),E=ZC.BQ(e.I7,e.LF),D=ZC.AL(i+"-from"),F=ZC.AL(i+"-to"),K={decimals:null===ZC._n_(e.AK.DQ)?1:e.AK.DQ};D.innerHTML=e.A8.FQ(e.A8.O9(b))+"/"+e.AK.FQ(-1,e.AK.NE(m),K),F.innerHTML=e.A8.FQ(e.A8.O9(B))+"/"+e.AK.FQ(-1,e.AK.NE(E),K),ZC.Q.PI(D,{left:p-e.AU-ZC._i_(ZC.A4(D).width())+"px",top:Z-e.AU-ZC._i_(ZC.A4(D).height())+"px"}),ZC.Q.PI(F,{left:p+e.AU+e.M.AU+c+"px",top:Z+e.AU+e.M.AU+u+"px"})}}}return!1}},e.TI=function(t){if((!t||"mouseup"!==t.type||!ZC.TOUCHEVENTS)&&e.C){if(ZC.move=!1,e.IM=!1,document.body.style.cursor="auto",ZC.Q.EU([i+"-zoom",i+"-from",i+"-to"]),e.C.AJ["3d"]){e.C.NX();var n=ZC.AL(e.H.K+"-guide-c");n&&(ZC.Q.IV(n,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F),ZC.A4(".zc-guide-label").remove())}if(ZC.A4(document.body).unbind("mousemove touchmove",e.U8),ZC.A4(document.body).unbind("mouseup touchend",e.TI),e.Z9)e.Z9=!1;else{var a,l,o,r,s,A,C,c,u,p,Z={graphid:e.C.K,ev:t};if(ZC._a_(e.I8-e.LC)>10&&ZC._a_(e.I7-e.LF)>10){var h,d,f=!1,_=!1;for(r=0,s=(o=e.C.BU("k")).length;r<s;r++)(h=o[r])&&o[r].GN&&(p=h.DF?h.AA:0,A=1===h.L?"":"-"+h.L,a=h.O9(ZC.CY(e.I8,e.LC)+p/2),l=h.O9(ZC.BQ(e.I8,e.LC)-p/2),ZC._a_(l-a)>=1&&(Z["zoomx"+A]=!0,Z["xmin"+A]=ZC.CY(a,l),Z["xmax"+A]=ZC.BQ(a,l),"log"===h.C1&&(Z["kmin"+A]=h.V[ZC._i_(ZC.G6(Z["xmin"+A],h.E6))],Z["kmax"+A]=h.V[ZC._i_(ZC.G6(Z["xmax"+A],h.E6))],delete Z["xmin"+A],delete Z["xmax"+A]),f=!0));for(r=0,s=(o=e.C.BU("v")).length;r<s;r++)(d=o[r])&&o[r].GN&&(A=1===d.L?"":"-"+d.L,C=d.NE(ZC.BQ(e.I7,e.LF)),c=d.NE(ZC.CY(e.I7,e.LF)),u=(d.H0-d.FX)/Math.pow(10,10),ZC._a_(c-C)>=u&&(Z["zoomy"+A]=!0,Z["ymin"+A]=ZC.CY(C,c),Z["ymax"+A]=ZC.BQ(C,c),_=!0));f||_?(zingchart.SKIP.EVENT=!0,e.C.A.PZ(Z)):zingchart.SKIP.EVENT=!0}else(ZC._a_(e.I8-e.LC)>5||ZC._a_(e.I7-e.LF)>5)&&(zingchart.SKIP.EVENT=!0);e.C=null}}},ZC.mobile&&"normal"!==zingchart.TOUCHZOOM||(zingchart.DEV.SKIPTRACKERS?ZC.A4(document.body).bind("mousedown touchstart",e.R3):ZC.A4("#"+i+"-img").bind("mousedown touchstart",e.R3),ZC.A4(".zc-node-area").live("mousedown touchstart",e.R3))}};ZC.A4Z=ZC.HL.CA(A4Z);var A2D={$i:function(e){this.b(e);var i=this;i.I2=!0,i.ABU=!1,i.C=e,i.H=e.A,i.IM=!1,i.A3X=!1,i.H7=null,i.AQ=null,i.Z=null,i.IG=0,i.H6=0,i.P9=0,i.A0N=0,i.LL=!1,i.NM=null,i.bBind=!1,i.BX=null,i.A1R=!1},parse:function(){var e,i=this;i.K=i.C.K+"-preview",i.assign_a([["live","ABU","b"],["async","LL","b"],["min-distance","P9","i"],["min-distance-x","P9","i"],["min-distance-y","P9","i"],["visible","AN","b"]]);var t="("+i.C.AF+").preview",n=i.H.B8;function a(e){return[t+".handler",t+".handler-"+e,t+".handle",t+".handle-"+e]}i.AQ=new ZC.HL(i.C),i.AQ.K=i.C.K+"-preview-viewport",n.load(i.AQ.o,[t]),i.AQ.append(i.o),i.AQ.parse(),i.o.label&&(i.BX=[]),i.o.handle&&i.o.handle.label&&(i.J5=new ZC.DN(i.C),i.J5.append(i.o.handle.label),i.J5.append({text:" "}),i.J5.parse(),i.J5.AN&&(i.A1R=!0)),i.OR=new ZC.D0(i.C),n.load(i.OR.o,[t+".mask"]),null!==ZC._n_(e=i.o.mask)&&i.OR.append(e),i.OR.parse(),i.UK=new ZC.D0(i.C),n.load(i.UK.o,[t+".active"]),null!==ZC._n_(e=i.o.active)&&i.UK.append(e),i.UK.parse(),i.IR=new ZC.HL(i.AQ),i.HG=new ZC.HL(i.AQ),i.J6=new ZC.HL(i.AQ),i.H4=new ZC.HL(i.AQ),n.load(i.IR.o,a("left")),n.load(i.HG.o,a("right")),n.load(i.J6.o,a("top")),n.load(i.H4.o,a("bottom"));for(var l=["handle","handler"],o=0;o<l.length;o++)null!==ZC._n_(e=i.o[l[o]])&&(i.IR.append(e),i.HG.append(e),i.J6.append(e),i.H4.append(e)),null!==ZC._n_(e=i.o[l[o]+"-left"])&&i.IR.append(e),null!==ZC._n_(e=i.o[l[o]+"-right"])&&i.HG.append(e),null!==ZC._n_(e=i.o[l[o]+"-top"])&&i.J6.append(e),null!==ZC._n_(e=i.o[l[o]+"-bottom"])&&i.H4.append(e);i.IR.parse(),i.HG.parse(),i.J6.parse(),i.H4.parse()},setScalesInfo:function(){var e=this;e.NM={};for(var i,t=e.C.BO,n=0,a=t.length;n<a;n++)(i=t[n])&&("k"===i.AF?e.NM[i.BE]={minindex:i.DC,maxindex:i.DX,minvalue:i.V[i.DC],maxvalue:i.V[i.DX],stepsize:i.AA,values:[].concat(i.V)}:e.NM[i.BE]={minvalue:i.FX,maxvalue:i.H0})},toggleMasks:function(e,i){for(var t=this,n=["x-left","x-right","y-top","y-bottom"],a=0;a<n.length;a++)if(e){var l=new ZC.HL(t.C);switch(l.K=t.C.K+"-preview-mask-"+n[a],l.A0=l.AE=t.OR.A0,l.C6=t.OR.C6,l.Z=l.C7=i||ZC.AL(t.C.K+"-preview-c"),n[a]){case"x-left":l.iX=t.AQ.iX,l.iY=t.AQ.iY,l.I=ZC.A4(t.A3A).css("width"),l.F=t.AQ.F;break;case"x-right":l.iX=t.AQ.iX+t.AQ.I-ZC.A4(t.XJ).css("width"),l.iY=t.AQ.iY,l.I=ZC.A4(t.XJ).css("width"),l.F=t.AQ.F;break;case"y-top":l.iX=t.AQ.iX,l.iY=t.AQ.iY,l.I=t.AQ.I,l.F=ZC.A4(t.A4B).css("height");break;case"y-bottom":l.iX=t.AQ.iX,l.iY=t.AQ.iY+t.AQ.F-ZC.A4(t.W3).css("height"),l.I=t.AQ.I,l.F=ZC.A4(t.W3).css("height")}l.paint()}else ZC.Q.EU(t.C.K+"-preview-mask-"+n[a]+"-path")},paint:function(){var e,i,t,n,a,l,o,r,s,A=this;if(A.PS=ZC.mobile?40:ZC.ie67?0:20,A.AN){A.Z=A.AQ.Z=A.AQ.C7=ZC.AL(A.C.K+"-preview-c"),A.AQ.paint();var C=ZC.AL(A.H.K+"-top"),c=A.C.BU("k")[0],u=A.C.BU("v")[0];if(null===A.NM&&A.setScalesInfo(),"svg"!==A.H.AB?(e=ZC.AL(A.C.K+"-preview"))&&ZC.Q.PI(e,{clip:A.C.M7(0,"canvas",A.AQ)}):(e=ZC.AL(A.C.K+"-clip-preview-shape"))&&ZC.Q.G3(e,{points:A.C.M7(0,"svg",A.AQ)}),0===A.P9&&c&&(A.P9=ZC.BQ(1,ZC._i_(2*A.AQ.I/c.V.length)),"log"===c.C1&&(A.P9=ZC.BQ(1,ZC._i_(A.P9/c.E6)))),A.BX){var p=ZC.ie67?ZC.AL(A.H.K):null;ZC.A4("."+A.C.K+"-preview-item",p).remove();for(var Z=[],h=0;h<A.BX.length;h++){var d=(A.BX[h].x-c.iX)/c.I,f=ZC._i_(A.AQ.iX+d*A.AQ.I),_=new ZC.DN(A.C);if(_.append({"line-width":1,"line-color":"#999",text:A.BX[h].text,x:f,y:A.AQ.iY}),_.append(A.o.label),_.parse(),_.Z=A.Z,_.IL=A.H.usc()?ZC.AL(A.H.K+"-main"):ZC.AL(A.H.K+"-text"),_.GL=A.K+"-item "+A.C.K+"-preview-item zc-preview-item",_.K=A.K+"-item-"+h,_.iX>=A.AQ.iX&&_.iX+_.I<=A.AQ.iX+A.AQ.I){for(var g=!1,v=0;v<Z.length;v++)_.iX>Z[v].x&&_.iX<Z[v].x+Z[v].width&&(g=!0);!g&&_.AN&&(_.paint(),Z.push({x:_.iX,width:_.I}));var b=[[f,A.AQ.iY],[f,A.AQ.iY+A.AQ.F]];n=ZC.Q.EB(A.Z,A.H.AB),ZC.CR.paint(n,_,b)}}}if((c.GN||u.GN)&&(A.KF=ZC.Q.HY({cls:"zc-abs zc-preview-handler zc-preview-handler-middle "+A.C.K+"-preview-handler",id:A.K+"-handler-middle",wh:A.AQ.I+"/"+A.AQ.F,tl:A.AQ.iY+"/"+A.AQ.iX,background:A.UK.A0,opacity:A.UK.C6,cursor:"pointer",p:C})),!c.CO&&c.GN||u.CO&&u.GN){A.A3A=ZC.Q.HY({cls:"zc-abs zc-preview-mask zc-preview-mask-left "+A.C.K+"-preview-mask",id:A.K+"-mask-x-left",wh:"0/"+A.AQ.F,tl:A.AQ.iY+"/"+A.AQ.iX,background:A.OR.A0,opacity:A.OR.C6,p:C}),A.XJ=ZC.Q.HY({cls:"zc-abs zc-preview-mask zc-preview-mask-right "+A.C.K+"-preview-mask",id:A.K+"-mask-x-right",wh:"0/"+A.AQ.F,tl:A.AQ.iY+"/"+(A.AQ.iX+A.AQ.I),background:A.OR.A0,opacity:A.OR.C6,p:C}),i=A.IR.I,t=A.IR.F,A.KJ=ZC.Q.HY({cls:"zc-abs zc-preview-handler zc-preview-handler-left "+A.C.K+"-preview-handler",id:A.K+"-handler-x-left",wh:ZC.quirks?null:i+"/"+t,tl:ZC._i_(A.AQ.iY+(A.AQ.F-t)/4-A.PS/2)+"/"+ZC._i_(A.AQ.iX-i/2-A.PS/2),lineHeight:"10%",cursor:"pointer",p:C,border:A.PS/2+"px solid transparent"});var B=A.KJ;if("svg"===A.H.AB&&!ZC.AL(A.K+"-handler-x-left-svg")){var m=ZC.Q.F6("svg","http://www.w3.org/2000/svg");ZC.Q.G3(m,{version:"1.1",id:A.K+"-handler-x-left-svg",width:i,height:t}),A.KJ.appendChild(m),B=m}if(!ZC.AL(A.K+"-handler-x-left-c")){var E=ZC.Q.HE({cls:"zc-no-print",id:A.K+"-handler-x-left-c",wh:i+"/"+t,p:B},A.H.AB);A.IR.Z=E,A.IR.K=A.K+"-handler-x-left-c-preview",A.IR.iX=0,A.IR.iY=0,A.IR.paint(),n=ZC.Q.EB(A.H.usc()?A.H.K+"-main-c":A.K+"-handler-x-left-c",A.H.AB);var D=A.IR.AZ,F=A.IR.AU;r=ZC._i_(i/2-D),o=ZC._i_(i/2+D),s=[[r,l=F+3],[r,a=t-F-2],null,[o,l],[o,a]],A.IR.CZ=!0,ZC.CR.paint(n,A.IR,s)}i=A.HG.I,t=A.HG.F,A.JX=ZC.Q.HY({cls:"zc-abs zc-preview-handler zc-preview-handler-right "+A.C.K+"-preview-handler",id:A.K+"-handler-x-right",wh:ZC.quirks?null:i+"/"+t,tl:ZC._i_(A.AQ.iY+A.AQ.F-A.HG.F-(A.AQ.F-t)/4-A.PS/2)+"/"+ZC._i_(A.AQ.iX+A.AQ.I-A.HG.I/2-A.PS/2),lineHeight:"10%",cursor:"pointer",p:C,border:A.PS/2+"px solid transparent"});var K=A.JX;if("svg"===A.H.AB&&!ZC.AL(A.K+"-handler-x-right-svg")){var x=ZC.Q.F6("svg","http://www.w3.org/2000/svg");ZC.Q.G3(x,{version:"1.1",id:A.K+"-handler-x-right-svg",width:i,height:t}),A.JX.appendChild(x),K=x}if(!ZC.AL(A.K+"-handler-x-right-c")){var I=ZC.Q.HE({cls:"zc-no-print",id:A.K+"-handler-x-right-c",wh:i+"/"+t,p:K},A.H.AB);A.HG.Z=I,A.HG.K=A.K+"-handler-x-right-c-preview",A.HG.iX=0,A.HG.iY=0,A.HG.paint(),n=ZC.Q.EB(A.H.usc()?A.H.K+"-main-c":A.K+"-handler-x-right-c",A.H.AB);var y=A.HG.AZ,w=A.HG.AU;r=ZC._i_(i/2-y),o=ZC._i_(i/2+y),s=[[r,l=w+3],[r,a=t-w-2],null,[o,l],[o,a]],A.HG.CZ=!0,ZC.CR.paint(n,A.HG,s)}}if(!u.CO&&u.GN||c.CO&&c.GN){A.A4B=ZC.Q.HY({cls:"zc-abs zc-preview-mask zc-preview-mask-top "+A.C.K+"-preview-mask",id:A.K+"-mask-x-top",wh:A.AQ.I+"/0",tl:A.AQ.iY+"/"+A.AQ.iX,background:A.OR.A0,opacity:A.OR.C6,p:C}),A.W3=ZC.Q.HY({cls:"zc-abs zc-preview-mask zc-preview-mask-bottom "+A.C.K+"-preview-mask",id:A.K+"-mask-x-bottom",wh:A.AQ.I+"/0",tl:A.AQ.iY+A.AQ.F+"/"+A.AQ.iX,background:A.OR.A0,opacity:A.OR.C6,p:C}),i=A.J6.I,t=A.J6.F,A.L2=ZC.Q.HY({cls:"zc-abs zc-preview-handler zc-preview-handler-top "+A.C.K+"-preview-handler",id:A.K+"-handler-y-top",wh:ZC.quirks?null:i+"/"+t,tl:ZC._i_(A.AQ.iY-t/2-A.PS/2)+"/"+ZC._i_(A.AQ.iX+(A.AQ.I-i)/4-A.PS/2),lineHeight:"10%",cursor:"pointer",p:C,border:A.PS/2+"px solid transparent"});var L=A.L2;if("svg"===A.H.AB&&!ZC.AL(A.K+"-handler-y-top-svg")){var X=ZC.Q.F6("svg","http://www.w3.org/2000/svg");ZC.Q.G3(X,{version:"1.1",id:A.K+"-handler-y-top-svg",width:i,height:t}),A.L2.appendChild(X),L=X}if(!ZC.AL(A.K+"-handler-y-top-c")){var Y=ZC.Q.HE({cls:"zc-no-print",id:A.K+"-handler-y-top-c",wh:i+"/"+t,p:L},A.H.AB);A.J6.Z=Y,A.J6.K=A.K+"-handler-y-top-c-preview",A.J6.iX=0,A.J6.iY=0,A.J6.paint(),n=ZC.Q.EB(A.H.usc()?A.H.K+"-main-c":A.K+"-handler-y-top-c",A.H.AB);var M=A.J6.AZ,H=A.J6.AU;a=ZC._i_(t/2-M),s=[[r=i-H-2,l=ZC._i_(t/2+M)],[o=H+3,l],null,[r,a],[o,a]],A.J6.CZ=!0,ZC.CR.paint(n,A.J6,s)}i=A.H4.I,t=A.H4.F,A.JF=ZC.Q.HY({cls:"zc-abs zc-preview-handler zc-preview-handler-bottom "+A.C.K+"-preview-handler",id:A.K+"-handler-y-bottom",wh:ZC.quirks?null:i+"/"+t,tl:ZC._i_(A.AQ.iY+A.AQ.F-A.H4.F/2-A.PS/2)+"/"+ZC._i_(A.AQ.iX+A.AQ.I-A.H4.I-(A.AQ.I-i)/4-A.PS/2),lineHeight:"10%",cursor:"pointer",p:C,border:A.PS/2+"px solid transparent"});var P=A.JF;if("svg"===A.H.AB&&!ZC.AL(A.K+"-handler-y-bottom-svg")){var N=ZC.Q.F6("svg","http://www.w3.org/2000/svg");ZC.Q.G3(N,{version:"1.1",id:A.K+"-handler-y-bottom-svg",width:i,height:t}),A.JF.appendChild(N),P=N}if(!ZC.AL(A.K+"-handler-y-bottom-c")){var S=ZC.Q.HE({cls:"zc-no-print",id:A.K+"-handler-y-bottom-c",wh:i+"/"+t,p:P},A.H.AB);A.H4.Z=S,A.H4.K=A.K+"-handler-y-bottom-c-preview",A.H4.iX=0,A.H4.iY=0,A.H4.paint(),n=ZC.Q.EB(A.H.usc()?A.H.K+"-main-c":A.K+"-handler-y-bottom-c",A.H.AB);var O=A.H4.AZ,G=A.H4.AU;a=ZC._i_(t/2-O),s=[[r=i-G-2,l=ZC._i_(t/2+O)],[o=G+3,l],null,[r,a],[o,a]],A.H4.CZ=!0,ZC.CR.paint(n,A.H4,s)}}if(A.IG=0,A.H6=A.AQ.I,A.KP=0,A.HA=A.AQ.F,c.GN&&A.A1R){var k=c.W,T=c.A1;c.F5&&"date"===c.F5.o.type&&(k=c.FQ(c.W,null,null).replace(/<br>/g," "),T=c.FQ(c.A1,null,null).replace(/<br>/g," ")),A.R4=ZC.Q.HY({cls:"zc-abs zc-preview-label "+A.C.K+"-preview-label",id:A.K+"-min-label",background:A.J5.A0,opacity:A.J5.C6,fontFamily:A.J5.GH,fontSize:A.J5.DI,fontWeight:A.J5.sFontWeight,color:A.J5.C2,padding:0,html:k+"",p:C}),A.R4.style.left=A.AQ.iX+"px",A.R4.style.top=A.AQ.iY+A.AQ.F+"px",A.R6=ZC.Q.HY({cls:"zc-abs zc-preview-label "+A.C.K+"-preview-label",id:A.K+"-max-label",background:A.J5.A0,opacity:A.J5.C6,fontFamily:A.J5.GH,fontSize:A.J5.DI,fontWeight:A.J5.sFontWeight,color:A.J5.C2,padding:0,html:T+"",p:C}),A.R6.style.left=A.AQ.iX+A.AQ.I+"px",A.R6.style.top=A.AQ.iY+A.AQ.F+"px",A.IG>ZC.A4(A.R4).width()?A.R4.style.left=A.AQ.iX+A.IG-ZC.A4(A.R4).width()+"px":A.R4.style.left=A.AQ.iX+"px",A.AQ.I-A.H6>ZC.A4(A.R6).width()?A.R6.style.left=A.AQ.iX+A.H6+"px":A.R6.style.left=A.AQ.iX+A.H6-ZC.A4(A.R6).width()+"px"}A.bind(),A.BX&&(A.BX=[])}},reset:function(){var e=this,i=e.C.BU("k")[0],t=e.C.BU("v",!0)[0];t||(t=e.C.BU("v")[0]),i&&t&&e.update(i.DC,i.DX,t.FX,t.H0,!0)},update:function(e,i,t,n,a){null===ZC._n_(a)&&(a=!1);var l=this;if(a||(e>=i&&(e=i-1),t>=n&&(t=n-1)),l.AN){var o=l.C.BU("k")[0],r=l.C.BU("v",!0)[0];r||(r=l.C.BU("v")[0]);var s=!0;if(a){if(o&&r){if(o.CO&&r.CO){var A=e,C=i;e=t,i=n,t=A,n=C}o.CO?(null===ZC._n_(n)&&(n=o.A1),null===ZC._n_(t)&&(t=o.W)):(null===ZC._n_(e)&&(e=o.W),null===ZC._n_(i)&&(i=o.A1)),r.CO?(null===ZC._n_(e)&&(e=r.aAutoFit[0]?r.FX:r.B3),null===ZC._n_(i)&&(i=r.aAutoFit[1]?r.H0:r.BJ)):(null===ZC._n_(t)&&(t=r.aAutoFit[0]?r.FX:r.B3),null===ZC._n_(n)&&(n=r.aAutoFit[1]?r.H0:r.BJ));var c=o.DF?1:0;o.CO||r.CO?o.AW?l.update((e-r.FX)*l.AQ.I/(r.H0-r.FX),(i-r.FX)*l.AQ.I/(r.H0-r.FX),(t-o.DC)*l.AQ.F/(o.DX-o.DC),(n-o.DC)*l.AQ.F/(o.DX-o.DC)):l.update((e-r.FX)*l.AQ.I/(r.H0-r.FX),(i-r.FX)*l.AQ.I/(r.H0-r.FX),l.AQ.F-(n-o.DC)*l.AQ.F/(o.DX-o.DC),l.AQ.F-(t-o.DC)*l.AQ.F/(o.DX-o.DC)):o.AW?l.update(l.AQ.I-(i-o.DC+c)*l.AQ.I/(o.DX-o.DC+c),l.AQ.I-(e-o.DC)*l.AQ.I/(o.DX-o.DC+c),l.AQ.F-(n-r.FX)*l.AQ.F/(r.H0-r.FX),l.AQ.F-(t-r.FX)*l.AQ.F/(r.H0-r.FX)):l.update((e-o.DC)*l.AQ.I/(o.DX-o.DC+c),(i-o.DC+c)*l.AQ.I/(o.DX-o.DC+c),l.AQ.F-(n-r.FX)*l.AQ.F/(r.H0-r.FX),l.AQ.F-(t-r.FX)*l.AQ.F/(r.H0-r.FX))}}else if(i-e<l.P9&&(l.H7===l.JX?i=e+l.P9:l.H7===l.KJ&&(e=i-l.P9)),n-t<l.A0N&&(l.H7===l.JF?n=t+l.A0N:l.H7===l.L2&&(t=n-l.A0N)),e>i&&(l.H7===l.KJ?l.update(i-1,i,t,n):l.H7===l.JX&&l.update(e,e+1,t,n),s=!1),e<0&&(l.H7===l.KJ?l.update(0,i,t,n):l.H7===l.KF&&l.update(0,ZC.A4(l.KF).width(),t,n),s=!1),i>l.AQ.I&&(l.H7===l.JX?l.update(e,l.AQ.I,t,n):l.H7===l.KF&&l.update(l.AQ.I-ZC.A4(l.KF).width(),l.AQ.I,t,n),s=!1),t>n&&(l.H7===l.L2?l.update(e,i,t-1,n):l.H7===l.JF&&l.update(e,i,t,n+1),s=!1),t<0&&(l.H7===l.L2?l.update(e,i,0,n):l.H7===l.KF&&l.update(e,i,0,ZC.A4(l.KF).height()),s=!1),n>l.AQ.F&&(l.H7===l.JF?l.update(e,i,t,l.AQ.F):l.H7===l.KF&&l.update(e,i,l.AQ.F-ZC.A4(l.KF).height(),l.AQ.F),s=!1),s){var u;if(o&&o.Y7)o.CO?(t=(u=l.AQ.F/(o.V.length-(o.DF?0:1)))*Math.round(t/u),n=ZC.CY(u*Math.round(n/u),l.AQ.F)):(e=(u=l.AQ.I/(o.V.length-(o.DF?0:1)))*Math.round(e/u),i=ZC.CY(u*Math.round(i/u),l.AQ.I));l.IG=e,l.H6=i,l.KP=t,l.HA=n,(!o.CO&&o.GN||r.CO&&r.GN)&&(l.KJ.style.left=ZC._i_(l.AQ.iX+l.IG-l.IR.I/2-l.PS/2)+"px",l.A3A.style.width=ZC._i_(l.IG)+"px",l.JX.style.left=ZC._i_(l.AQ.iX+l.H6-l.HG.I/2-l.PS/2)+"px",l.XJ.style.left=ZC._i_(l.AQ.iX+l.H6)+"px",l.XJ.style.width=ZC._i_(l.AQ.I-l.H6)+"px"),(!r.CO&&r.GN||o.CO&&o.GN)&&(l.L2.style.top=ZC._i_(l.AQ.iY+l.KP-l.J6.F/2-l.PS/2)+"px",l.A4B.style.height=ZC._i_(l.KP)+"px",l.JF.style.top=ZC._i_(l.AQ.iY+l.HA-l.H4.F/2-l.PS/2)+"px",l.W3.style.top=ZC._i_(l.AQ.iY+l.HA)+"px",l.W3.style.height=ZC._i_(l.AQ.F-l.HA)+"px"),(o.GN||r.GN)&&(l.KF.style.left=ZC._i_(l.AQ.iX+l.IG)+"px",l.KF.style.width=ZC._i_(l.H6-l.IG)+"px",l.KF.style.top=ZC._i_(l.AQ.iY+l.KP)+"px",l.KF.style.height=ZC._i_(l.HA-l.KP)+"px"),l.ABU&&l.IM&&(l.C.OF=!0,l.zoom(!0)),o.GN&&l.A1R&&(o.F5&&"date"===o.F5.o.type?(l.R4.innerHTML=o.FQ(o.W,null,null).replace(/<br>/g," "),l.R6.innerHTML=o.FQ(o.A1,null,null).replace(/<br>/g," ")):(l.R4.innerHTML=o.W,l.R6.innerHTML=o.A1),l.IG>ZC.A4(l.R4).width()?l.R4.style.left=l.AQ.iX+l.IG-ZC.A4(l.R4).width()+"px":l.R4.style.left=l.AQ.iX+"px",l.AQ.I-l.H6>ZC.A4(l.R6).width()?l.R6.style.left=l.AQ.iX+l.H6+"px":l.R6.style.left=l.AQ.iX+l.H6-ZC.A4(l.R6).width()+"px")}}},zoom:function(e){for(var i,t=this,n={graphid:t.C.K,preview:1,async:t.LL,previewscale:!0,zooming:e},a=t.C.BO,l=t.C.BU("k")[0],o=t.C.BU("v")[0],r=0,s=a.length;r<s;r++)if(i=a[r]){var A=1===i.L?"":"-"+i.L;if("k"===i.AF){if(l.GN){var C=t.LL?t.NM[i.BE].minindex:i.DC,c=t.LL?t.NM[i.BE].maxindex:i.DX;n["zoomx"+A]=!0;var u=l.DF?1:0;if(l.CO?(n["xmin"+A]=ZC._i_((t.AQ.F-t.HA)/t.AQ.F*(c-C)),n["xmax"+A]=ZC._i_((t.AQ.F-t.KP)/t.AQ.F*(c-C))):(n["xmin"+A]=ZC._i_(t.IG/(t.AQ.I/(c-C+u))),n["xmax"+A]=ZC._i_(t.H6/(t.AQ.I/(c-C+u))-u)),l.AW){n["xmin"+A]=c-n["xmin"+A],n["xmax"+A]=c-n["xmax"+A];var p=n["xmin"+A];n["xmin"+A]=n["xmax"+A],n["xmax"+A]=p}}}else if(o.GN){var Z=t.LL?t.NM[i.BE].minvalue:i.FX,h=t.LL?t.NM[i.BE].maxvalue:i.H0;n["zoomy"+A]=!0,o.CO?(n["ymin"+A]=Z+t.IG/t.AQ.I*(h-Z),n["ymax"+A]=Z+t.H6/t.AQ.I*(h-Z)):(n["ymin"+A]=Z+(t.AQ.F-t.HA)/t.AQ.F*(h-Z),n["ymax"+A]=Z+(t.AQ.F-t.KP)/t.AQ.F*(h-Z))}}t.H.PZ(n)},unbind:function(){var e=this;ZC.A4("."+e.C.K+"-preview-handler").unbind("mousedown touchstart",e.Z2),ZC.A4("."+e.C.K+"-preview-mask").unbind("click",e.AEJ),ZC.A4(document.body).unbind("mousemove touchmove",e.V3),ZC.A4(document.body).unbind("mouseup touchend",e.TO),e.bBind=!1},bind:function(){var e=this;if(!e.bBind){var i=e.H.K,t=0,n=0;e.AEJ=function(t){if(t.preventDefault(),e.H.H1){e.H.H1.C=e.C,e.H.H1.parse();var n=ZC.Q.MF(t),a=ZC.A4("#"+i+"-top").offset();if(-1!==t.target.id.indexOf("preview-mask-x-left")||-1!==t.target.id.indexOf("preview-mask-x-right")){var l=n[0]-a.left-e.AQ.iX,o=e.H6-e.IG;l-o/2<0?(e.IG=0,e.H6=o):l+o/2>e.AQ.I?(e.IG=e.AQ.I-o,e.H6=e.AQ.I):(e.IG=ZC._i_(l-o/2),e.H6=ZC._i_(l+o/2))}else{var r=n[1]-a.top-e.AQ.iY,s=e.HA-e.KP;r-s/2<0?(e.KP=0,e.HA=s):r+s/2>e.AQ.F?(e.KP=e.AQ.F-s,e.HA=e.AQ.F):(e.KP=ZC._i_(r-s/2),e.HA=ZC._i_(r+s/2))}return e.IM=!1,e.C.OF=!1,e.update(e.IG,e.H6,e.KP,e.HA),e.zoom(!1),!1}},e.Z2=function(a){if(a.preventDefault(),e.H.H1){e.H.H1.C=e.C,e.H.H1.parse();for(var l=a.target;l&&"BODY"!==l.tagName.toUpperCase();){if(-1!==ZC.Q.T4(l).indexOf("zc-preview-handler"))break;l=l.parentNode}if((ZC.mobile||!(a.which>1))&&l){var o=ZC.Q.MF(a),r=ZC._tx_(e.H.K),s=ZC.A4("#"+i+"-top").offset(),A=(o[0]-s.left)/r[0]-e.AQ.iX,C=(o[1]-s.top)/r[1]-e.AQ.iY;return-1!==l.id.indexOf("handler-x-left")?e.H7=e.KJ:-1!==l.id.indexOf("handler-x-right")?e.H7=e.JX:-1!==l.id.indexOf("handler-y-top")?e.H7=e.L2:-1!==l.id.indexOf("handler-y-bottom")?e.H7=e.JF:-1!==l.id.indexOf("handler-middle")&&(e.H7=e.KF,t=A-e.IG,n=C-e.KP),ZC.A4(document.body).bind("mousemove touchmove",e.V3),ZC.A4(document.body).bind("mouseup touchend",e.TO),e.IM=!0,e.A3X=!1,!1}}},e.V3=function(a){if(e.IM){e.A3X=!0,zingchart.exec(e.H.K,"setmode",{mode:"static,fast"});var l=ZC._tx_(e.H.K),o=ZC.Q.MF(a),r=ZC.A4("#"+i+"-top").offset(),s=(o[0]-r.left)/l[0]-e.AQ.iX,A=(o[1]-r.top)/l[1]-e.AQ.iY;e.H7===e.KJ?e.update(s,e.H6,e.KP,e.HA):e.H7===e.JX?e.update(e.IG,s,e.KP,e.HA):e.H7===e.L2?e.update(e.IG,e.H6,A,e.HA):e.H7===e.JF?e.update(e.IG,e.H6,e.KP,A):e.H7===e.KF&&e.update(s-t,s-t+ZC.A4(e.KF).width(),A-n,A-n+ZC.A4(e.KF).height())}return!1},e.TO=function(){return zingchart.exec(e.H.K,"setmode",{mode:""}),e.IM&&(ZC.A4(document.body).unbind("mousemove touchmove",e.V3),ZC.A4(document.body).unbind("mouseup touchend",e.TO),e.IM=!1,e.C.OF=!1,e.A3X&&e.zoom(!1),e.A3X=!1),!1},ZC.A4("."+e.C.K+"-preview-handler").bind("mousedown touchstart",e.Z2),ZC.A4("."+e.C.K+"-preview-mask").bind("click",e.AEJ),e.bBind=!0}},gc:function(){ZC.AP.gc(this,["Z","C7","o","I6","JB","C","H","AQ","UK","KJ","JX","L2","JF","KF","J6","HG","H4","IR","oMask","OR","A3A","XJ","A4B","W3"])}};ZC.A2D=ZC.D0.CA(A2D);var ZF={$i:function(e,i){this.b(e);var t=this;t.C=e,t.H=e.A,t.IM=!1,t.Z=null,t.BL=0,t.BH=0,t.A70="",t.bYX="yx"===t.C.AJ.layout,t.AF=t.sTypeE=t.sTypeN="scroll-"+(i||"x"),t.bYX&&(t.AF+="i",t.sTypeE="scroll-xi"===t.AF?"scroll-y":"scroll-x")},parse:function(){var e,i=this;i.K=i.C.K+"-"+i.sTypeE,i.assign_a([["offset-x","BL"],["offset-y","BH"]]);var t="("+i.C.AF+").",n=i.H.B8;i.B0=new ZC.HL(i.C),n.load(i.B0.o,[t+"scroll.bar",t+i.AF+".bar"]),null!==ZC._n_(e=i.o.bar)&&i.B0.append(e),i.B0.parse(),i.B2=new ZC.HL(i.C),n.load(i.B2.o,[t+"scroll.handle",t+i.AF+".handle"]),null!==ZC._n_(e=i.o.handle)&&i.B2.append(e),i.B2.parse()},paint:function(){var e=this,i=e.C.BU("k")[0],t=e.C.BU("v")[0],n=e.C.P;if(("scroll-x"===e.AF||"scroll-xi"===e.AF)&&i.DC===i.W&&i.DX===i.A1||("scroll-y"===e.AF||"scroll-yi"===e.AF)&&t.FX===t.B3&&t.H0===t.BJ)return e.unbind(),ZC.A4("#"+e.C.K+"-"+e.AF+"-handle").remove(),ZC.A4("#"+e.C.K+"-"+e.AF+"-bar").remove(),void ZC.Q.IV(e.Z,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F);e.Z=ZC.AL(e.C.K+"-"+e.sTypeN+"-c");var a=ZC.AL(e.H.K+"-top");"scroll-x"===e.AF||"scroll-yi"===e.AF?(e.B0.iX=n.iX+e.BL,e.B0.iY=n.iY+n.F+i.AZ-1+e.BH,e.B0.I=n.I,e.bYX?(e.B2.I=ZC._i_(ZC.BQ(4,e.B0.I*((t.BJ-t.B3)/(t.H0-t.FX)))),t.FX===t.B3?t.AW?e.B2.iX=e.B0.iX+e.B0.I-e.B2.I:e.B2.iX=e.B0.iX:t.H0===t.BJ?t.AW?e.B2.iX=e.B0.iX:e.B2.iX=e.B0.iX+e.B0.I-e.B2.I:t.AW?e.B2.iX=ZC._i_(e.B0.iX+e.B0.I-e.B2.I-e.B0.I*(t.B3-t.FX)/(t.H0-t.FX)):e.B2.iX=ZC._i_(e.B0.iX+e.B0.I*(t.B3-t.FX)/(t.H0-t.FX))):(e.B2.I=ZC._i_(ZC.BQ(4,e.B0.I*((i.A1-i.W)/(i.DX-i.DC)))),i.DC===i.W?i.AW?e.B2.iX=e.B0.iX+e.B0.I-e.B2.I:e.B2.iX=e.B0.iX:i.DX===i.A1?i.AW?e.B2.iX=e.B0.iX:e.B2.iX=e.B0.iX+e.B0.I-e.B2.I:i.AW?e.B2.iX=ZC._i_(e.B0.iX+e.B0.I-e.B2.I-e.B0.I*(i.W-i.DC)/(i.DX-i.DC)):e.B2.iX=ZC._i_(e.B0.iX+e.B0.I*(i.W-i.DC)/(i.DX-i.DC))),ZC.AL(e.K+"-handle")?(ZC.A4("#"+e.K+"-bar").css("top",e.B0.iY+"px"),ZC.A4("#"+e.K+"-handle").css("left",e.B2.iX+"px").css("top",e.B0.iY+"px").css("width",ZC.BQ(15,e.B2.I)+"px"),e.paint_()):(e.AAH=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-x-bar "+e.C.K+"-scroll-x-bar",id:e.K+"-bar",wh:e.B0.I+"/"+e.B0.F,tl:e.B0.iY+"/"+e.B0.iX,opacity:0,p:a}),e.Z8=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-x-handle "+e.C.K+"-scroll-x-handle",id:e.K+"-handle",wh:ZC.BQ(15,e.B2.I)+"/"+e.B0.F,tl:e.B0.iY+"/"+(e.B2.iX-2),background:"#fff",opacity:0,p:a}),e.Z8.style.cursor="pointer",e.paint_(),e.IM||e.bind())):(e.B0.iX=n.iX-e.B0.I-1+e.BL,e.B0.iY=n.iY+e.BH,e.B0.F=n.F,e.bYX?(e.B2.F=ZC._i_(ZC.BQ(4,e.B0.F*((i.A1-i.W)/(i.DX-i.DC)))),i.DC===i.W?i.AW?e.B2.iY=e.B0.iY:e.B2.iY=e.B0.iY+e.B0.F-e.B2.F:i.DX===i.A1?i.AW?e.B2.iY=e.B0.iY+e.B0.F-e.B2.F:e.B2.iY=e.B0.iY:i.AW?e.B2.iY=ZC._i_(e.B0.iY+e.B0.F*(i.W-i.DC)/(i.DX-i.DC)):e.B2.iY=ZC._i_(e.B0.iY+e.B0.F-e.B2.F-e.B0.F*(i.W-i.DC)/(i.DX-i.DC))):(e.B2.F=ZC._i_(ZC.BQ(4,e.B0.F*((t.BJ-t.B3)/(t.H0-t.FX)))),t.FX===t.B3?t.AW?e.B2.iY=e.B0.iY:e.B2.iY=e.B0.iY+e.B0.F-e.B2.F:t.H0===t.BJ?t.AW?e.B2.iY=e.B0.iY+e.B0.F-e.B2.F:e.B2.iY=e.B0.iY:t.AW?e.B2.iY=ZC._i_(e.B0.iY+e.B0.F*(t.B3-t.FX)/(t.H0-t.FX)):e.B2.iY=ZC._i_(e.B0.iY+e.B0.F-e.B2.F-e.B0.F*(t.B3-t.FX)/(t.H0-t.FX))),ZC.AL(e.K+"-handle")?(ZC.A4("#"+e.K+"-bar").css("left",e.B0.iX+"px"),ZC.A4("#"+e.K+"-handle").css("top",e.B2.iY+"px").css("left",e.B0.iX+"px").css("height",ZC.BQ(15,e.B2.F)+"px"),e.paint_()):(e.AAF=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-y-bar "+e.C.K+"-scroll-y-bar",id:e.K+"-bar",wh:e.B0.I+"/"+e.B0.F,tl:e.B0.iY+"/"+e.B0.iX,opacity:0,p:a}),e.ZM=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-y-handle "+e.C.K+"-scroll-y-handle",id:e.K+"-handle",wh:e.B0.I+"/"+ZC.BQ(15,e.B2.F),tl:e.B2.iY-2+"/"+e.B0.iX,background:"#fff",opacity:0,p:a}),e.ZM.style.cursor="pointer",e.paint_(),e.IM||e.bind()))},zoom:function(e){for(var i,t,n,a=this,l={graphid:a.C.K,zooming:e,scroll:!0},o=a.C.BO,r=a.C.BU("k")[0],s=a.C.BU("v")[0],A=0,C=o.length;A<C;A++)if(i=o[A]){var c=1===i.L?"":"-"+i.L;if(r.GN&&"scroll-x"===a.AF&&"k"===i.AF&&!a.bYX){var u=i.A1-i.W;l["zoomx"+c]=!0,t=(a.B2.iX-a.B0.iX)/a.B0.I,n=(a.B2.iX-a.B0.iX+a.B2.I)/a.B0.I,r.AW?(l["xmin"+c]=i.DX-ZC._i_(n*(i.DX-i.DC)),l["xmax"+c]=i.DX-ZC._i_(t*(i.DX-i.DC))):(l["xmin"+c]=i.DC+ZC._i_(t*(i.DX-i.DC)),l["xmax"+c]=i.DC+ZC._i_(n*(i.DX-i.DC))),l["xmax"+c]-l["xmin"+c]!==u&&(l["xmax"+c]===i.DX?l["xmin"+c]=l["xmax"+c]-u:l["xmax"+c]=l["xmin"+c]+u)}else if(s.GN&&"scroll-y"===a.AF&&"v"===i.AF&&!a.bYX)l["zoomy"+c]=!0,t=(a.B0.F-(a.B2.iY-a.B0.iY+a.B2.F))/a.B0.F,n=(a.B0.F-(a.B2.iY-a.B0.iY))/a.B0.F,s.AW?(l["ymin"+c]=i.H0-ZC._f_(n*(i.H0-i.FX)),l["ymax"+c]=i.H0-ZC._f_(t*(i.H0-i.FX))):(l["ymin"+c]=i.FX+ZC._f_(t*(i.H0-i.FX)),l["ymax"+c]=i.FX+ZC._f_(n*(i.H0-i.FX)));else if(r.GN&&"scroll-xi"===a.AF&&"k"===i.AF&&a.bYX){u=i.A1-i.W;l["zoomx"+c]=!0,t=(a.B0.F-a.B2.iY+a.B0.iY-a.B2.F)/a.B0.F,n=(a.B0.F-a.B2.iY+a.B0.iY)/a.B0.F,r.AW?(l["xmin"+c]=i.DX-ZC._i_(n*(i.DX-i.DC)),l["xmax"+c]=i.DX-ZC._i_(t*(i.DX-i.DC))):(l["xmin"+c]=i.DC+ZC._i_(t*(i.DX-i.DC)),l["xmax"+c]=i.DC+ZC._i_(n*(i.DX-i.DC))),l["xmax"+c]-l["xmin"+c]!==u&&(l["xmax"+c]===i.DX?l["xmin"+c]=l["xmax"+c]-u:l["xmax"+c]=l["xmin"+c]+u)}else s.GN&&"scroll-yi"===a.AF&&"v"===i.AF&&a.bYX&&(l["zoomy"+c]=!0,t=(a.B2.iX-a.B0.iX)/a.B0.I,n=(a.B2.iX-a.B0.iX+a.B2.I)/a.B0.I,s.AW?(l["ymin"+c]=i.H0-ZC._f_(n*(i.H0-i.FX)),l["ymax"+c]=i.H0-ZC._f_(t*(i.H0-i.FX))):(l["ymin"+c]=i.FX+ZC._f_(t*(i.H0-i.FX)),l["ymax"+c]=i.FX+ZC._f_(n*(i.H0-i.FX))))}a.H.PZ(l)},paint_:function(){var e,i,t=this;ZC.Q.IV(t.Z,t.H.AB,t.C.iX,t.C.iY,t.C.I,t.C.F),"scroll-x"===t.AF||"scroll-yi"===t.AF?((e=new ZC.HL(t)).K=t.C.K+"-scroll-x-bar",e.copy(t.B0),e.Z=e.C7=t.Z,e.iX=t.B0.iX,e.iY=t.B0.iY,e.I=t.B0.I,e.F=t.B0.F,e.paint(),(i=new ZC.HL(t)).K=t.C.K+"-scroll-x-handle",i.copy(t.B2),i.Z=i.C7=t.Z,i.iX=t.B2.iX,i.iY=t.B0.iY+(t.B0.F-t.B2.F)/2-1,i.I=ZC.BQ(15,t.B2.I),i.iX+i.I>t.C.P.iX+t.C.P.I&&(i.iX=t.C.P.iX+t.C.P.I-i.I),i.iX<t.C.P.iX&&(i.iX=t.C.P.iX),i.F=t.B2.F,i.paint(),ZC.A4("#"+t.K+"-handle").css("left",i.iX+"px")):((e=new ZC.HL(t)).K=t.C.K+"-scroll-y-bar",e.copy(t.B0),e.Z=e.C7=t.Z,e.iX=t.B0.iX,e.iY=t.B0.iY,e.I=t.B0.I,e.F=t.B0.F,e.paint(),(i=new ZC.HL(t)).K=t.C.K+"-scroll-y-handle",i.copy(t.B2),i.Z=i.C7=t.Z,i.iX=t.B0.iX+(t.B0.I-t.B2.I)/2,i.iY=t.B2.iY,i.I=t.B2.I,i.F=ZC.BQ(15,t.B2.F),i.iY+i.F>t.C.P.iY+t.C.P.F&&(i.iY=t.C.P.iY+t.C.P.F-i.F),i.iY<t.C.P.iY&&(i.iY=t.C.P.iY),i.paint(),ZC.A4("#"+t.K+"-handle").css("top",i.iY+"px"))},setScrollingFlag:function(e){var i=this;if(i.C.OF=e,i.C.H1&&ZC._b_(i.C.H1.o.shared))for(var t=0;t<i.H.AG.length;t++)i.H.AG[t].H1&&ZC._b_(i.H.AG[t].H1.o.shared)&&(i.H.AG[t].OF=e)},update:function(e){var i=this;"scroll-x"===i.AF||"scroll-yi"===i.AF?(i.B2.iX=e,ZC.A4("#"+i.K+"-handle").css("left",e+"px"),i.paint_()):(i.B2.iY=e,ZC.A4("#"+i.K+"-handle").css("top",e+"px"),i.paint_()),i.IM&&(i.setScrollingFlag(!0),i.zoom(!0))},unbind:function(){var e=this;ZC.A4("."+e.C.K+"-"+e.AF+"-handle").unbind("mousedown touchstart",e.RA),ZC.A4("."+e.C.K+"-"+e.AF+"-bar").unbind("click",e.RE)},overscroll:function(e){var i=this.C.GX();i.type=e,ZC.AP.BY("overscroll",this.H,i)},bind:function(){var e=this,i=e.H.K,t=0,n=0;e.RA=function(a){if(a.preventDefault(),!(a.button>1)&&(e.A70=e.H.KQ.join(","),e.H.KQ.push("skip_context_menu","skip_objects_tracking","skip_segment_tracking","skip_marker_tracking","skip_interactivity"),e.H.H1)){e.H.H1.C=e.C,e.H.H1.parse();for(var l=a.target;l&&"BODY"!==l.tagName.toUpperCase();){if(-1!==ZC.Q.T4(l).indexOf("zc-"+e.AF+"-handle"))break;l=l.parentNode}if((ZC.mobile||!(a.which>1))&&l){var o=ZC.Q.MF(a),r=ZC.A4("#"+i+"-top").offset();if("scroll-x"===e.AF||"scroll-yi"===e.AF){var s=o[0]-r.left;t=s-e.B2.iX}else{var A=o[1]-r.top;n=A-e.B2.iY}return ZC.A4(document.body).bind("mousemove touchmove",e.RG),ZC.A4(document.body).bind("mouseup touchend",e.M6),e.IM=!0,!1}}},e.RG=function(a){if(e.IM){e.setScrollingFlag(!1);var l=ZC.Q.MF(a),o=ZC.A4("#"+i+"-top").offset();if("scroll-x"===e.AF||"scroll-yi"===e.AF){var r=l[0]-o.left;r-t<e.B0.iX&&(r<e.B0.iX-15&&e.overscroll("scroll-x-left"),r=e.B0.iX+t),r-t+e.B2.I>e.B0.iX+e.B0.I&&(r>e.B0.iX+e.B0.I+15&&e.overscroll("scroll-x-right"),r=e.B0.iX+e.B0.I+t-e.B2.I),e.update(r-t)}else{var s=l[1]-o.top;s-n<e.B0.iY&&(s<e.B0.iY-15&&e.overscroll("scroll-y-top"),s=e.B0.iY+n),s-n+e.B2.F>e.B0.iY+e.B0.F&&(s>e.B0.iY+e.B0.F+15&&e.overscroll("scroll-y-bottom"),s=e.B0.iY+e.B0.F+n-e.B2.F),e.update(s-n)}}return!1},e.M6=function(i){return e.H.KQ=e.A70.split(","),e.IM&&(ZC.A4(document.body).unbind("mousemove touchmove",e.RG),ZC.A4(document.body).unbind("mouseup touchend",e.M6),e.IM=!1,e.setScrollingFlag(!1),i&&e.zoom(!1)),!1},e.RE=function(t){e.IM=!1,e.setScrollingFlag(!1);var n=ZC.Q.MF(t),a=ZC.A4("#"+i+"-top").offset();"scroll-x"===e.AF||"scroll-yi"===e.AF?n[0]-a.left>e.B2.iX?e.update(ZC.CY(e.B0.iX+e.B0.I-e.B2.I-2*e.B2.AU,e.B2.iX+(n[0]-a.left-e.B2.iX)/4)):e.update(ZC.BQ(e.B0.iX,n[0]-a.left+(e.B2.iX-n[0]+a.left-e.B2.I)/4)):n[1]-a.top>e.B2.iY?e.update(ZC.CY(e.B0.iY+e.B0.F-e.B2.F-2*e.B2.AU,e.B2.iY+(n[1]-a.top-e.B2.iY)/4)):e.update(ZC.BQ(e.B0.iY,n[1]-a.top+(e.B2.iY-n[1]+a.top-e.B2.F)/4)),e.zoom(!1)},ZC.A4("."+e.C.K+"-"+e.sTypeE+"-handle").bind("mousedown touchstart",e.RA),ZC.A4("."+e.C.K+"-"+e.sTypeE+"-bar").bind("click",e.RE)}};ZC.ZF=ZC.D0.CA(ZF);var WT={$i:function(e,i){this.b(e);var t=this;t.BD=e,t.IM=!1,t.Z=null,t.A70="",t.KU=1,t.H2=1,t.AF="scroll-"+(i||"y")},parse:function(){var e,i=this;i.K=i.BD.K+"-legend-"+i.AF;var t=i.BD.A.H.B8,n="("+i.BD.A.AF+")";i.B0=new ZC.HL(i.BD),t.load(i.B0.o,[n+".legend.scroll.bar",i.AF+".bar"]),null!==ZC._n_(e=i.o.bar)&&i.B0.append(e),i.B0.parse(),i.B2=new ZC.HL(i.BD),t.load(i.B2.o,[n+".legend.scroll.handle",i.AF+".handle"]),null!==ZC._n_(e=i.o.handle)&&i.B2.append(e),i.B2.parse()},paint:function(){var e,i=this;if(!i.IM){i.Z=ZC.AL(i.BD.A.K+"-legend-scroll-c");var t=ZC.AL(i.H.K+"-top");"scroll-y"===i.AF?(i.B0.iX=i.BD.iX+i.BD.I-i.B0.I-1,i.B0.iY=i.BD.EP,i.B0.F=i.BD.F-(i.BD.KN?i.BD.KN.F:0)-(i.BD.EP-i.BD.iY),e=Math.ceil(i.BD.B6.length/i.H2-i.BD.EG/i.H2)+1,i.B2.F=i.B0.F/e,i.B2.iY=i.B0.iY,0!==i.BD.D4.min&&(i.B2.iY+=i.BD.D4.min/i.H2*i.B2.F),ZC.AL(i.K+"-legend-handle")?(ZC.A4("#"+i.K+"-legend-handle").css("left",i.B0.iX+"px").css("top",i.B2.iY+"px").css("height",i.B2.F-0*i.B2.AU+"px"),ZC.A4("#"+i.K+"-legend-bar").css("left",i.B0.iX+"px").css("top",i.B0.iY+"px"),ZC.A4("#"+i.BD.K+"-frame").css("left",i.BD.iX+"px").css("top",i.BD.EP+"px"),i.paint_()):(i.AAF=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-y-bar "+i.BD.K+"-scroll-y-legend-bar",id:i.K+"-legend-bar",wh:i.B0.I+"/"+i.B0.F,tl:i.B0.iY+"/"+i.B0.iX,background:"#fff",opacity:0,zidx:1,p:t}),i.ZM=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-y-handle "+i.BD.K+"-scroll-y-legend-handle",id:i.K+"-legend-handle",wh:i.B0.I-0*i.B2.AU+"/"+(i.B2.F-0*i.B2.AU),tl:i.B2.iY+"/"+i.B0.iX,background:"#fff",opacity:0,zidx:1,p:t}),i.ZM.style.cursor="pointer",i.paint_())):"scroll-x"===i.AF&&(i.B0.iX=i.BD.iX,i.B0.iY=i.BD.iY+i.BD.F-i.B0.F-1,i.B0.I=i.BD.I,e=Math.ceil(i.BD.B6.length/i.KU-i.BD.EG/i.KU)+1,i.B2.I=i.B0.I/e,i.B2.iX=i.B0.iX,0!==i.BD.D4.min&&(i.B2.iX+=i.BD.D4.min/i.KU*i.B2.I),ZC.AL(i.K+"-legend-handle")?(ZC.A4("#"+i.K+"-legend-handle").css("left",i.B2.iX+"px").css("top",i.B0.iY+"px").css("width",i.B2.I-0*i.B2.AU+"px"),ZC.A4("#"+i.K+"-legend-bar").css("left",i.B0.iX+"px").css("top",i.B0.iY+"px"),ZC.A4("#"+i.BD.K+"-frame").css("left",i.BD.iX+"px").css("top",i.BD.EP+"px"),i.paint_()):(i.AAH=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-x-bar "+i.BD.K+"-scroll-x-legend-bar",id:i.K+"-legend-bar",wh:i.B0.I+"/"+i.B0.F,tl:i.B0.iY+"/"+i.B0.iX,background:"#fff",opacity:0,zidx:1,p:t}),i.Z8=ZC.Q.HY({cls:"zc-abs zc-scroll zc-scroll-x-handle "+i.BD.K+"-scroll-x-legend-handle",id:i.K+"-legend-handle",wh:i.B2.I-0*i.B2.AU+"/"+(i.B0.F-0*i.B2.AU),tl:i.B0.iY+"/"+i.B2.iX,background:"#fff",opacity:0,zidx:1,p:t}),i.Z8.style.cursor="pointer",i.paint_())),ZC.move||i.bind()}},paint_:function(){var e,i,t=this;"scroll-y"===t.AF?((e=new ZC.HL(t)).K=t.BD.K+"-scroll-y-legend-bar",e.copy(t.B0),e.Z=t.Z,e.iX=t.B0.iX,e.iY=t.B0.iY,e.I=t.B0.I,e.F=t.B0.F,e.paint(),(i=new ZC.HL(t)).K=t.BD.K+"-scroll-y-legend-handle",i.copy(t.B2),i.Z=t.Z,i.iX=t.B0.iX,i.iY=t.B2.iY,i.I=t.B2.I,i.F=t.B2.F,i.paint()):"scroll-x"===t.AF&&((e=new ZC.HL(t)).K=t.BD.K+"-scroll-x-legend-bar",e.copy(t.B0),e.Z=t.Z,e.iX=t.B0.iX,e.iY=t.B0.iY,e.I=t.B0.I,e.F=t.B0.F,e.paint(),(i=new ZC.HL(t)).K=t.BD.K+"-scroll-x-legend-handle",i.copy(t.B2),i.Z=t.Z,i.iX=t.B2.iX,i.iY=t.B0.iY,i.I=t.B2.I,i.F=t.B0.F,i.paint())},update:function(e){var i,t,n,a,l,o,r=this,s=r.BD;if("scroll-y"===r.AF){if(e<r.B2.iY&&!1,e===r.B2.iY)return;r.B2.iY=e,ZC.A4("#"+r.K+"-legend-handle").css("top",e+"px"),i=r.B2.iY-r.B0.iY,a=Math.ceil(s.B6.length/r.H2-s.EG/r.H2)+1,t=r.B0.F/a,o=r.H2}else if("scroll-x"===r.AF){if(e>r.B2.iX&&!1,e===r.B2.iX)return;r.B2.iX=e,ZC.A4("#"+r.K+"-legend-handle").css("left",e+"px"),i=r.B2.iX-r.B0.iX,a=Math.ceil(s.B6.length/r.KU-s.EG/r.KU)+1,t=r.B0.I/a,o=r.KU}n=Math.round(i/t),l=s.B6.length-s.EG,s.B6.length%o&&(l+=o-s.B6.length%o),s.D4.min=Math.min(n*o,l),s.D4.max=s.D4.min+s.EG,s.VT(),s.clear(!1),s.parse(),s.paint(),r.paint_(),r.bind()},unbind:function(){var e=this;ZC.A4("."+e.BD.K+"-"+e.AF+"-legend-handle").unbind("mousedown touchstart",e.RA),ZC.A4("."+e.BD.K+"-"+e.AF+"-legend-bar").unbind("click",e.RE)},bind:function(){var e=this,i=e.H.K,t=0,n=0;e.RA=function(a){if(a.preventDefault(),!(a.button>1)){for(var l=a.target;l&&"BODY"!==l.tagName.toUpperCase();){if(-1!==ZC.Q.T4(l).indexOf("zc-"+e.AF+"-handle"))break;l=l.parentNode}if((ZC.mobile||!(a.which>1))&&l){var o=ZC.Q.MF(a),r=ZC.A4("#"+i+"-top").offset();if("scroll-y"===e.AF){var s=o[1]-r.top;n=s-e.B2.iY}else if("scroll-x"===e.AF){var A=o[0]-r.left;t=A-e.B2.iX}return ZC.A4(document.body).bind("mousemove touchmove",e.RG),ZC.A4(document.body).bind("mouseup touchend",e.M6),e.IM=!0,!1}}},e.RG=function(a){if(a.preventDefault(),e.IM){var l=ZC.Q.MF(a),o=ZC.A4("#"+i+"-top").offset();if("scroll-y"===e.AF){var r=l[1]-o.top;r-n<e.B0.iY&&(r=e.B0.iY+n),r-n+e.B2.F>e.B0.iY+e.B0.F&&(r=e.B0.iY+e.B0.F+n-e.B2.F),e.update(r-n)}else if("scroll-x"===e.AF){var s=l[0]-o.left;s-t<e.B0.iX&&(s=e.B0.iX+t),s-t+e.B2.I>e.B0.iX+e.B0.I&&(s=e.B0.iX+e.B0.I+t-e.B2.I),e.update(s-t)}}return!1},e.M6=function(){return e.H.KQ=e.A70.split(","),e.IM&&(ZC.A4(document.body).unbind("mousemove touchmove",e.RG),ZC.A4(document.body).unbind("mouseup touchend",e.M6),e.IM=!1),!1},e.A3V=function(i){(i.detail?-120*i.detail:i.wheelDelta)/120>0?e.update(ZC.BQ(e.B0.iY,e.B2.iY-e.B2.F)):e.update(ZC.CY(e.B0.iY+e.B0.F-e.B2.F,e.B2.iY+e.B2.F))},e.RE=function(t){e.IM=!0;var n=ZC.Q.MF(t),a=ZC.A4("#"+i+"-top").offset();"scroll-y"===e.AF?n[1]-a.top>e.B2.iY?e.update(ZC.CY(e.B0.iY+e.B0.F-e.B2.F,e.B2.iY+e.B2.F)):e.update(ZC.BQ(e.B0.iY,e.B2.iY-e.B2.F)):"scroll-x"===e.AF&&(n[0]-a.left>e.B2.iX?e.update(ZC.CY(e.B0.iX+e.B0.I-e.B2.I,e.B2.iX+e.B2.I)):e.update(ZC.BQ(e.B0.iX,e.B2.iX-e.B2.I))),e.IM=!1},ZC.A4("."+e.BD.K+"-"+e.AF+"-legend-handle").bind("mousedown touchstart",e.RA),ZC.A4("."+e.BD.K+"-"+e.AF+"-legend-bar").bind("click",e.RE)}};ZC.WT=ZC.D0.CA(WT);var V6={$i:function(e){this.b(e);var i=this;i.OB="legend",i.B6=null,i.Q1=null,i.NF="x1",i.IJ="hide",i.R0="",i.PO="",i.UT=!1,i.UY=!1,i.TS="none",i.UJ="header",i.EG=9999,i.D2=null,i.BR=null,i.ZG=null,i.A2=null,i.NK=null,i.FP=null,i.KN=null,i.Q9=0,i.MB=0,i.YG=!0,i.EP=0,i.GM=0,i.sAlign="",i.JY="",i.D4={enabled:!1,min:-1,max:-1,page:-1,pages:-1},i.M0=!1,i.NC=!1,i.N8=-1,i.PP=!1,i.A4I=1,i.WJ=0,i.L9=!1,i.XT=!1,i.YF=!1,i.XL=[]},highlightItem:function(e){var i,t,n=this,a=!1,l=ZC.move,o=n.L9;-1!==e&&(o=n.L9||n.A.AY.A5[e].L9),n.o.item&&null!==ZC._n_(i=n.o.item["highlight-item"])&&(a=ZC._b_(i),null===ZC._n_(n.o["highlight-legend"])&&null===n.A.AY.A5[e].o["highlight-legend"]&&(o=a)),(a||o)&&(a&&(n.E["highlight-item"]=e),o&&(n.E["highlight-legend"]=ZC._i_(e)),t=n.scrollTo(ZC._i_(e)),n.VT(),n.clear(!0,t),n.YG=!0,n.parse(),n.fixPlacement(!0),n.paint(),ZC.move=l)},scrollTo:function(e){var i,t,n=this,a=!1;return e>=0&&(e<n.D4.min||e>=n.D4.max)&&(a=!0,"scroll"===n.TS?(e%(t="scroll-y"===n.D2.AF?n.D2.H2:n.D2.KU)&&(e-=e%t),n.D4.min=e,n.D4.max=e+n.EG,n.D4.max>n.B6.length&&(n.D4.min=n.B6.length-n.EG,n.B6.length%t&&(n.D4.min=n.D4.min+(t-n.B6.length%t)),n.D4.max=n.B6.length)):"page"===n.TS&&(i=Math.floor(e/n.EG),n.D4.min=i*n.EG,n.D4.max=n.D4.min+n.EG,n.D4.page=i+1)),a},parse:function(){var e,i,t,n,a=this;if(a.E["force-margins"]=!0,a.Q9=0,a.MB=0,null!==ZC._n_(e=a.A.A.E["graph-"+a.A.K+"-legend-info"])&&(a.o.x=e.x-a.A.iX,a.o.y=e.y-a.A.iY),ZC.move)a.FP&&a.FP.parse(),a.KN&&a.KN.parse();else{n=a.A.H.B8;var l="("+a.A.AF+")";a.b(),a.assign_a([["collapse","M0","b"],["minimize","UT","b"],["draggable","UY","b"],["shared","PP","b"],["overflow","TS"],["max-items","EG","i"],["group","A4I","i"],["drag-handler","UJ"],["highlight-plot","WJ","b"],["highlight-legend","L9","b"],["align","sAlign"],["vertical-align","JY"]]),a.M0&&!a.UT&&(a.M0=!1),zingchart.DEV.MEDIARULES&&(a.E["forced-align-position"]||(a.alignPosition({align:a.sAlign,"vertical-align":a.JY,layout:a.NF}),a.E["forced-align-position"]=!0)),a.WJ&&null===ZC._n_(a.o["highlight-legend"])&&(a.L9=a.WJ),a.BR=new ZC.DN(a),n.load(a.BR.o,l+".legend.item"),a.o.item&&null===ZC._n_(a.o.item.visible)&&(a.o.item.visible=!0),a.BR.append(a.o.item),a.BR.parse(),a.ZG=new ZC.DN(a),n.load(a.ZG.o,l+".legend.item-off"),a.o["item-off"]&&null===ZC._n_(a.o["item-off"].visible)&&(a.o["item-off"].visible=!0),a.ZG.append(a.o["item-off"]),a.ZG.parse(),a.A2=new ZC.DT(a),n.load(a.A2.o,l+".legend.marker"),a.o.marker&&null===ZC._n_(a.o.marker.visible)&&(a.o.marker.visible=!0),a.A2.append(a.o.marker),a.A2.E.type="default",a.A2.E["show-marker"]=!0,a.A2.E["show-line"]=!1,null!==ZC._n_(e=a.A2.o.type)&&(a.A2.E.type=e),null!==ZC._n_(e=a.A2.o["show-line"])&&(a.A2.E["show-line"]=ZC._b_(e)),null!==ZC._n_(e=a.BR.o["marker-style"])&&(a.A2.E.type=e),null!==ZC._n_(e=a.BR.o["show-line"])&&(a.A2.E["show-line"]=ZC._b_(e)),null!==ZC._n_(e=a.BR.o["show-marker"])&&(a.A2.o.visible=ZC._b_(e)),a.A2.parse(),a.NK=new ZC.DT(a),n.load(a.NK.o,l+".legend.marker-off"),a.o["marker-off"]&&(a.o["marker-off"].visible=!0),a.NK.append(a.o["marker-off"]),a.NK.E.type="default",a.NK.E["show-marker"]=!0,a.NK.E["show-line"]=!1,null!==ZC._n_(e=a.NK.o.type)&&(a.NK.E.type=e),null!==ZC._n_(e=a.NK.o["show-line"])&&(a.NK.E["show-line"]=ZC._b_(e)),null!==ZC._n_(e=a.BR.o["marker-style"])&&(a.NK.E.type=e),null!==ZC._n_(e=a.BR.o["show-line"])&&(a.NK.E["show-line"]=ZC._b_(e)),null!==ZC._n_(e=a.BR.o["show-marker"])&&(a.NK.o.visible=ZC._b_(e)),a.NK.parse(),(null!==ZC._n_(e=a.o.header)||a.UY||a.UT)&&(a.FP=new ZC.DN(a),a.FP.OB="legendheader",a.FP.GL="zc-legend-item "+a.K+"-header",a.FP.K=a.K+"-header",n.load(a.FP.o,l+".legend.header"),a.FP.o.text=a.FP.o.text||" ",a.FP.append(e),a.FP.parse(),a.FP.AN||(a.FP=null)),null!==ZC._n_(e=a.o.footer)&&(a.KN=new ZC.DN(a),a.KN.OB="legendfooter",a.KN.GL="zc-legend-item "+a.K+"-footer",a.KN.K=a.K+"-footer",n.load(a.KN.o,l+".legend.footer"),a.KN.append(e),a.KN.parse(),a.KN.AN||(a.KN=null));var o=a.A.AY.A5;null!==ZC._n_(e=a.o.layout)?a.NF=e:25*o.length>a.A.F&&(a.NF="x"+Math.ceil(25*o.length/a.A.F)),null!==ZC._n_(e=a.o["toggle-action"])&&(a.IJ=e),a.R0=a.PO=a.IJ,null!==ZC._n_(a.o.item)&&null!==ZC._n_(e=a.o.item["toggle-action"])&&(a.R0=e),null!==ZC._n_(a.o.marker)&&null!==ZC._n_(e=a.o.marker["toggle-action"])&&(a.PO=e);var r=function(e){if(o[i]&&o[i].FK(0)){var t=ZC.AP.O2(a.BR.o,o[i].o);e=o[i].FK(0).JT(e,t)}return e},s=[];for(a.B6=[],i=0,t=o.length;i<t;i++){var A=a.A.AY.M4[i],C=new ZC.DN(a);C.copy(a.BR),C.append(o[A].o["legend-item"]),null===ZC._n_(C.o.text)&&null!==ZC._n_(e=o[A].A68)&&(C.o.text=e),null===ZC._n_(C.o.text)&&null!==ZC._n_(e=o[A].AM)&&(C.o.text=e),C.AM=null===ZC._n_(C.o.text)?"Series "+(A+1):C.o.text,C.E.order=A,C.E.index=A,null!==ZC._n_(o[A].o["legend-item"])&&null!==ZC._n_(e=o[A].o["legend-item"].order)&&(C.E.order=ZC._i_(e)),s.push([i,A,C.E.order]),-1!==C.AM.indexOf("%")&&(C.JT=r),C.parse(),a.B6.push(C)}for(s.sort(function(e,i){return e[2]-i[2]}),i=0;i<s.length;i++)s[i][2]=i,o[s[i][1]].o["legend-item"]=o[s[i][1]].o["legend-item"]||{},o[s[i][1]].o["legend-item"].order=s[i][2],a.B6[s[i][0]].E.order=s[i][2];(e=a.A.E["legend-info"])&&(a.NC=e.collapsed)}if(a.B6&&a.A2){"page"===a.TS?((e=a.A.E["legend-info"])?(a.D4.min=e.min,a.D4.max=e.max,a.D4.page=e.page):(a.D4.min=0,a.D4.max=a.EG,a.D4.page=1),a.D4.pages=Math.ceil(a.B6.length/a.EG),a.D4.page>a.D4.pages&&(a.D4.page=a.D4.pages,a.D4.min=(a.D4.page-1)*a.EG,a.D4.max=a.D4.page*a.EG-1),a.D4.page=ZC.CY(a.D4.page,a.D4.pages)):"scroll"===a.TS?(e=a.A.E["legend-info"])?(a.D4.min=e.min,a.D4.max=e.max,a.D4.page=e.page):(a.D4.min=0,a.D4.max=a.EG,a.D4.page=1):(a.D4.min=0,a.D4.max="hidden"===a.TS?a.EG:a.B6.length,a.D4.page=1),a.VT(!1),a.B6.sort(function(e,i){return e.E.order-i.E.order}),a.o["reverse-series"]&&a.B6.reverse();var c=.9*a.A.I;null!==ZC._n_(a.o.width)&&(c=a.I);var u=0,p=0,Z=-ZC.MAX,h=-ZC.MAX,d=a.A2.E["show-line"]?3:2,f=0,_=1,g=1;if("float"===a.NF){for(i=0,t=a.B6.length;i<t;i++)if(f+=a.B6[i].AN?1:0,!(i<a.D4.min||i>=a.D4.max||a.NC)&&a.B6[i].AN){var v=a.B6[i].I+a.B6[i].DY+a.B6[i].E9+d*a.B6[i].DI;h=ZC.BQ(h,a.B6[i].F+a.B6[i].E8+a.B6[i].DR),u+v>c?(Z=ZC.BQ(Z,u),p+=h,u=v,h=ZC.BQ(h,a.B6[i].F+a.B6[i].E8+a.B6[i].DR)):u+=v}Z=ZC.BQ(Z,u),h!==-ZC.MAX&&(p+=h),Z!==-ZC.MAX&&(u=Z)}else{var b=0;for(i=0,t=a.B6.length;i<t;i++)f+=a.B6[i].AN?1:0,i<a.D4.min||i>=a.D4.max||a.NC||(b+=a.B6[i].AN?1:0);var B=ZC.AR.A2C(a.NF,b);for(_=B[0],g=B[1],i=0,t=a.B6.length;i<t;i++)(i<a.D4.min||i>=a.D4.max||a.NC)&&("scroll"!==a.TS||f<=a.EG)||a.B6[i].AN&&(Z=ZC.BQ(Z,a.B6[i].I+a.B6[i].DY+a.B6[i].E9+d*a.B6[i].DI),h=ZC.BQ(h,a.B6[i].F+a.B6[i].E8+a.B6[i].DR),1===g&&(p+=a.B6[i].F+a.B6[i].E8+a.B6[i].DR));u=g*Z,p=_*h}if("page"===a.TS&&f>a.EG&&(a.D4.enabled=!0),"scroll"===a.TS&&f>a.EG&&(a.D2||(!_||_>g?(a.D2=new ZC.WT(a,"y"),n.load(a.D2.o,".scroll-y")):(a.D2=new ZC.WT(a,"x"),n.load(a.D2.o,".scroll-x")),a.D2.append(a.o.scroll),a.D2.KU=_,a.D2.H2=g,a.D2.parse()),a.NC||("scroll-y"===a.D2.AF?u+=a.D2.B0.I:p+=a.D2.B0.F)),a.FP){var m=a.FP.I;a.UY&&"icon"===a.UJ?(m+=15,a.UT&&(m+=25)):a.UT&&(m+=15),u=ZC.BQ(u,m)}a.KN&&(u=ZC.BQ(u,a.KN.I));var E=!1,D=!1;if(null===ZC._n_(a.o.width)&&(a.o.width=u,E=!0),null===ZC._n_(a.o.height)&&(a.o.height=p,D=!0),a.iX=-1,a.iY=-1,!ZC.move&&a.FP&&null!==ZC._n_(e=a.A.A.E["legend"+a.A.L+"-xy-ratio"])){a.locate();var F=a.I+a.EQ+a.FN,K=a.F+a.FM+a.FT,x=a.PP?a.A.A:a.A;a.iX=x.I*e[0],a.iX=ZC.BQ(a.iX,1.1),a.o.x=a.iX=ZC.CY(a.iX,x.I-F-2),a.iY=(x.F-a.FP.F)*e[1],a.iY=ZC.BQ(a.iY,1.1),a.o.y=a.iY=ZC.CY(a.iY,x.F-K-a.FP.F-2)}if(a.locate(),null!==ZC._n_(a.o.position)&&"undefined"!=typeof a.E["position-info"]?(a.E["position-info"][0]>.5&&(a.Q9+=a.EQ+a.FN),a.E["position-info"][1]>.5?a.MB+=a.FM+a.FT:(a.FP&&(a.MB-=a.FP.F),a.KN&&(a.MB-=a.KN.F),a.D4&&a.D4.enabled&&(a.MB-=20))):((0===a.A.iX||a.iX+a.I/2>a.A.iX+a.A.I/2)&&(a.Q9+=a.EQ+a.FN),(0===a.A.iY||a.iY+a.F/2>a.A.iY+a.A.F/2)&&(a.MB+=a.FM+a.FT)),!ZC.move&&(e=a.A.A.E["graph-"+a.A.K+"-legend-info"])&&(e.x&&(a.iX=e.x),e.y&&(a.iY=e.y)),a.GM=a.F,a.EP=a.iY,a.FP&&(a.F+=a.FP.F,a.EP+=a.FP.F,a.MB+=a.FP.F),a.KN&&(a.F+=a.KN.F,a.MB+=a.KN.F),a.D4.enabled&&!a.NC){var I=new ZC.DN(a);I.AM=" ",I.append(a.o["page-status"]),null!==ZC._n_(I.o.text)&&""!==I.o.text||(I.o.text="#"),I.parse(),a.F+=I.F+4,a.MB+=I.F+4}E&&(a.o.width=null),D&&(a.o.height=null),a.NC||(a.I+=a.EQ+a.FN,a.F+=a.FM+a.FT),a.E["default-width"]&&(a.I=a.E["default-width"])}},alignPosition:function(e){var i=this;if(null!==ZC._n_(e)){var t=i.A.H.B8.B8.graph.legend,n=e.align||t.align,a=e["vertical-align"]||t["vertical-align"],l=e.layout||t.layout;(n||a)&&("center"===n?(null===ZC._n_(i.o.layout)&&(l=i.o.layout="horizontal"),i.o.position="50% "):i.o.position="left"===n?"0% ":"100% ",i.o.position+="middle"===a?"50%":"bottom"===a?"100%":"0%","horizontal"!==l&&"middle"!==a||(i.o["adjust-layout"]=!0))}},VT:function(e){var i=this;void 0===e&&(e=!0),i.A.E["legend-info"]={collapsed:i.NC,min:i.D4.min,max:i.D4.max,page:i.D4.page},e&&(i.A.A.E["graph-"+i.A.K+"-legend-info"]={x:i.iX,y:i.iY})},clear:function(e,i){null===ZC._n_(e)&&(e=!1),null===ZC._n_(i)&&(i=!1);var t=this,n=t.A.K+"-legend-",a=null;ZC.A4("."+n+"item",a).remove(),ZC.A4("."+n+"header",a).remove(),ZC.A4("."+n+"footer",a).remove(),ZC.A4("#"+n+"page-status",a).remove(),e&&!i||(ZC.move||t.unbind(),ZC.A4("."+n+"page-area",a).remove(),ZC.A4("."+n+"header-area",a).remove(),ZC.A4("."+n+"item-area",a).remove(),ZC.A4("."+n+"marker-area",a).remove()),ZC.move?ZC.Q.IV(ZC.AL(n+"c"),t.A.H.AB,t.A.iX,t.A.iY,t.A.I,t.A.F):ZC.Q.IV(ZC.AL(n+"c"),t.A.H.AB,t.iX-2*t.AU-2*t.JV,t.iY-2*t.AU-2*t.JV,t.I+4*t.AU+4*t.JV,t.F+4*t.AU+4*t.JV),t.D2&&ZC.Q.IV(ZC.AL(n+"scroll-c"),t.A.H.AB,t.A.iX,t.A.iY,t.A.I,t.A.F)},unbind:function(){var e=this;ZC.A4("#"+e.K+"-frame").die(ZC.Q.BZ("mouseover"),e.zc_legend_mouseover).die(ZC.Q.BZ("mouseout"),e.zc_legend_mouseout),ZC.A4("#"+e.K+"-move-area").die(ZC.Q.BZ("mousedown"),e.Z5),ZC.A4("#"+e.K+"-minimize-area").die(ZC.Q.BZ("click"),e.XY),ZC.A4("."+e.K+"-page-area").die(ZC.Q.BZ("click"),e.YY),e.D2&&e.D2.unbind(),e.BR&&e.BR.o.reorder&&ZC.A4("."+e.A.K+"-legend-item-area").die("mousedown",e.W8)},fixPlacement:function(e){var i=this;if(i.YG&&null===ZC._n_(i.o.y)||e){if(!i.o.position&&e||(i.iX-=i.Q9),i.iX<i.DY&&(i.DY<i.E9||-2===i.E9)&&(i.iX=i.DY),!i.o.position&&e||(i.iY-=i.MB,i.EP-=i.MB),i.iY<i.E8&&(i.E8<i.DR||-2===i.DR)){var t=i.EP-i.iY;i.iY=i.E8,i.EP=i.E8+t}i.YG=!1}},EK:function(e){var i=this;i.FP&&i.FP.EK(e),i.KN&&i.KN.EK(e);for(var t=0;t<i.XL.length;t++)i.XL[t].EK(e)},paint:function(e){var i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f=this;if(f.AN&&(f.E["default-width"]||(f.E["default-width"]=f.I),f.B6)){var _=ZC.AL(f.H.K+"-top"),g=f.A.AY.A5,v=0;for(o=0,r=f.B6.length;o<r;o++)o<f.D4.min||o>=f.D4.max||f.NC||(v+=f.B6[o].AN?1:0);f.A5J=!0,f.b(),f.FP&&(f.FP.iX=f.iX,f.FP.iY=f.iY,f.FP.I=f.I,f.FP.Z=f.FP.C7=f.Z,f.FP.paint(),ZC.move||"canvas"!==f.A.A.AB&&f.FP.EK(),f.UY&&"icon"===f.UJ&&((n=new ZC.DT(f)).Z=f.Z,n.B7="#000",n.AZ=1,n.DU="line",n.append(f.o.icon),a=f.FP.iX+f.FP.I-10,l=f.FP.iY+f.FP.F/2,n.D=[[a-7,l],[a+7,l],null,[a,l-7],[a,l+7],null,[a-6,l-1],[a-6,l+1],null,[a-5,l-2],[a-5,l+2],null,[a+6,l-1],[a+6,l+1],null,[a+5,l-2],[a+5,l+2],null,[a-1,l-6],[a+1,l-6],null,[a-2,l-5],[a+2,l-5],null,[a-1,l+6],[a+1,l+6],null,[a-2,l+5],[a+2,l+5]],n.parse(),n.paint()),f.UT&&((t=new ZC.DT(f)).Z=f.Z,t.B7=ZC.AP.A9O(f.A0,"#fff","#000"),t.AZ=1,t.append(f.o.icon),t.DU="line",a=f.FP.iX+f.FP.I-10-(f.UY&&"icon"===f.UJ?20:0),l=f.FP.iY+f.FP.F/2,t.D=[[a-7,l-2],[a+2,l-2],[a+2,l+7],[a-7,l+7],[a-7,l-2],[a+2,l-2],null,[a-4,l-5],[a+5,l-5],[a+5,l+4],[a-4,l+4],[a-4,l-5],[a+5,l-5]],t.parse(),t.paint())),f.KN&&(f.KN.iX=f.iX,f.KN.iY=f.iY+f.F-f.KN.F,f.KN.I=f.I,f.KN.Z=f.KN.C7=f.Z,f.KN.paint(),ZC.move||"canvas"!==f.A.A.AB&&f.KN.EK());var b=ZC.AR.A2C(f.NF,v),B=b[0],m=b[1],E=f.I/m,D=f.GM/B,F=0,K=0;f.Q1=[];var x,I=0,y=-ZC.MAX,w=f.A2.E["show-line"]?3:2,L=null,X=function(i){var t=i;if(null===ZC._n_(e)&&(e=0),g[x]&&g[x].S[e]){var n=ZC.AP.O2(f.BR.o,g[x].o);i=g[x].FK(e).JT(i,n)}return f.XT=f.XT||i!==t,i},Y=0;for(f.XT=!1,o=0,r=f.B6.length;o<r;o++)if(!(o-Y<f.D4.min||o-Y>=f.D4.max||f.NC)){var M=new ZC.DN(f);M.copy(f.B6[o]),f.E["highlight-legend"]===o&&(M.append({bold:!0}),null!==ZC._n_(f.o.item)&&M.append(f.o.item["highlight-state"])),x=M.E.index;var H=new ZC.DN(f);H.OB="legenditem",H.K=f.K+"-item_"+x,H.GL="zc-legend-item "+f.K+"-item",H.copy(M),f.A.E["plot"+x+".visible"]&&"off"!==g[x].o["legend-status"]||H.append(f.ZG.o),H.append(g[x].o["legend-item"]),H.JT=X,H.parse(),H.AN?("float"===f.NF?(y=ZC.BQ(y,M.F),null===ZC._n_(L)?(M.iX=f.iX+f.EQ+M.DY+w*M.DI,M.iY=f.EP+f.FM+M.E8,I=f.EP):(M.iX=L.iX+L.I+L.E9+M.DY+w*M.DI,ZC._i_(M.iX+M.I+M.E9)>ZC._i_(f.iX+f.I)&&(M.iX=f.iX+f.EQ+M.DY+w*M.DI,I+=y+M.E8+M.DR,y=-ZC.MAX),M.iY=I+f.FM+M.E8)):(M.iX=f.iX+(0===K?f.EQ:0)+K*E+M.DY+w*M.DI,M.iY=f.EP+f.FM+F*D+M.E8,++K===m&&(K=0,F++)),L=M,H.iX=M.iX=ZC._i_(M.iX),H.iY=M.iY=ZC._i_(M.iY),H.Z=H.C7=f.Z,H.iX+=f.BL,H.iY+=f.BH,x===f.N8&&(f.E["calculate-y"]&&(f.E["calculate-y"]=!1,f.E["dragged-offset-y"]=f.E["dragged-y"]-H.iY),H.iY=f.E["dragged-y"]-f.E["dragged-offset-y"]-H.DI/4),H.paint(),"undefined"!=typeof f.E.showhide&&null!==ZC._n_(f.E.showhide)||ZC.move||("canvas"!==f.A.A.AB?H.EK():f.XL.push(H))):Y++;var P=f.A2.E.type;null!==ZC._n_(i=g[x].o["legend-marker"])&&null!==ZC._n_(i.type)&&(P=i.type);var N,S=!1;switch("match"!==P&&"inherit"!==P||(S=!0,P=null!==ZC._n_(i=g[x].A2.o.type)?i:"default"),-1!==ZC.AV(["default","square"],P)?N=new ZC.HL(f):(N=new ZC.DT(f)).DU=P,N.OB="legendmarker",N.append(f.A2.o),f.A.E["plot"+x+".visible"]&&"off"!==g[x].o["legend-status"]||N.append(f.NK.o),N.N9=g[x].N9,g[x].AF){case"pie":case"pie3d":case"nestedpie":case"vbar":case"vbar3d":case"hbar":case"hbar3d":case"vbullet":case"hbullet":case"area":case"area3d":case"gauge":case"vfunnel":case"hfunnel":case"venn":N.A0=g[x].A0,N.AE=g[x].AE,N.GR=g[x].GR,N.HN=g[x].HN;break;case"scatter":case"hscatter":case"bubble":case"hbubble":N.A0="-1"!==g[x].A2.A0?g[x].A2.A0:g[x].A0,N.AE="-1"!==g[x].A2.AE?g[x].A2.AE:g[x].AE,N.GR=""!==g[x].A2.GR?g[x].A2.GR:g[x].GR,N.HN=""!==g[x].A2.HN?g[x].A2.HN:g[x].HN;break;default:N.A0=g[x].B7,N.AE=g[x].B7}"line"!==N.DU&&"area"!==N.DU||(N.B7=N.A0,N.AZ=2),S&&N.append(g[x].A2.o),N.o["line-style"]="solid",N.o.type=N.DU,N.append(g[x].o["legend-marker"]),S&&(N.o.type=N.DU),N.E["show-marker"]=!0,N.E["show-line"]=!1,null!==ZC._n_(i=N.o["show-line"])&&(N.E["show-line"]=ZC._b_(i)),null!==ZC._n_(i=H.o["show-line"])&&(N.E["show-line"]=ZC._b_(i)),null!==ZC._n_(i=H.o["show-marker"])&&(N.o.visible=ZC._b_(i)),-1!==ZC.AV(["default","square"],P)&&null!==ZC._n_(i=N.o.size)&&(null===ZC._n_(N.o.width)&&(N.o.width=2*ZC._i_(i)),null===ZC._n_(N.o.height)&&(N.o.height=2*ZC._i_(i))),N.K=f.K+"-marker_"+x,N.Z=N.C7=f.Z,N.iX=H.iX-w*H.DI+(w-1)*H.DI/2+H.DI/2,N.iY=H.iY+(H.F-H.DI)/2+H.DI/2,N.parse(),f.E["highlight-legend"]===o&&(N.append({size:N.AI+1,width:N.I+2,height:N.F+2}),g[x]&&g[x].S[e]&&g[x].S[e].GJ&&N.append({A0:g[x].S[e].GJ.A0,AE:g[x].S[e].GJ.AE}),null!==ZC._n_(f.o.marker)&&N.append(f.o.marker["highlight-state"]),N.parse()),"line"===N.DU?(N.o.points=[[N.iX-1.75*N.AI,N.iY],[N.iX+1.75*N.AI,N.iY]],N.parse()):"area"===N.DU&&(N.o.points=[[N.iX-1.75*N.AI,N.iY+N.AI],[N.iX+1.75*N.AI,N.iY+N.AI],[N.iX+1*N.AI,N.iY-N.AI/2],[N.iX,N.iY],[N.iX-1.25*N.AI,N.iY-N.AI],[N.iX-1.75*N.AI,N.iY+N.AI]],N.parse());var O=N.iX+N.BL,G=N.iY+N.BH;if(-1!==ZC.AV(["default","square"],P)&&(N.iX-=N.I/2,N.iY-=N.F/2),f.A.E["plot"+x+".visible"]&&"off"!==g[x].o["legend-status"]||(N.C6/=4),H.AN&&N.E["show-line"]){var k=ZC.Q.EB(f.Z,f.A.H.AB),T=new ZC.D0(f);T.Z=f.Z,T.copy(g[x]),T.o["line-style"]=f.A2.GF,T.append(g[x].o),T.append(f.A2.o),T.append(g[x].o["legend-item"]),T.append(g[x].o["legend-marker"]),T.parse(),f.A.E["plot"+x+".visible"]||(T.C6=.25);var z=[],Q=N.AN?2:1;s="box"===N.DU?N.I/2:N.AI,z.push([O-Q*s-(T.AZ>1?1:0),G-(T.AZ>1?.5:0)]),z.push([O+Q*s,G-(T.AZ>1?.5:0)]),T.CZ=!0,ZC.CR.paint(k,T,z)}x===f.N8&&(N.iY=f.E["dragged-y"]-f.E["dragged-offset-y"]/2),N.AN&&H.AN&&N.paint(),f.Q1.push(N);var J=!0;if(null!==ZC._n_(i=f.BR.o.toggle)&&(J=ZC._b_(i)),f.E["item.toggle"]=J,(H.AN||N.AN)&&-1===ZC.AV(f.A.H.KQ,"skip_interactivity")){var V=N.BL+("box"===N.DU?N.iX+N.I/2:N.iX),R=N.BH+("box"===N.DU?N.iY+N.F/2:N.iY);s="box"===N.DU?N.I/2:N.AI,A="box"===N.DU?N.F/2:N.AI;var W=(N.E["show-line"]?2:1)*s;ZC.AL(H.K+"-area")||(N.AN&&"disabled"!==f.PO&&"disabled"!==N.o["toggle-action"]&&(ZC.AL(N.K+"-area")||ZC.Q.HY({cls:f.K+"-marker-area zc-legend-marker-area zc-abs",id:N.K+"-area",wh:2*W+"/"+2*A,tl:R-A+"/"+(V-W),opacity:0,background:"#fff",cursor:N.IP,p:_,zidx:1})),H.AN&&"disabled"!==f.R0&&"disabled"!==H.o["toggle-action"]&&(ZC.AL(H.K+"-area")||ZC.Q.HY({cls:f.K+"-item-area zc-legend-item-area zc-abs",id:H.K+"-area",wh:H.I+"/"+H.F,tl:H.iY+H.BH+"/"+(H.iX+H.BL),opacity:0,background:"#fff",cursor:H.IP,p:_,zidx:1})))}}if(f.D2&&!f.NC&&(f.D2.paint(),ZC.AL(f.K+"-scroll-c").style.display="block"),f.D2&&f.NC&&(ZC.AL(f.K+"-scroll-c").style.display="none"),f.D4.enabled&&!f.NC){var U=new ZC.DN(f);U.Z=U.C7=f.Z,U.K=f.K+"-page-status",U.AM=ZC.HJ["legend-pagination"].replace("%page%",f.D4.page).replace("%pages%",f.D4.pages),U.append(f.o["page-status"]),U.parse(),f.I<U.I+48&&(U.AM=f.D4.page+"/"+f.D4.pages,U.parse()),U.iX=f.iX+f.I/2-U.I/2,U.iY=f.iY+f.F-(f.KN?f.KN.F:0)-U.F-4,U.AN&&U.paint();var j=f.A.H.B8,q="("+f.A.AF+")",$={"background-color":"#999"},ee={"background-color":"#f90"};j.load($,q+".legend.page-off"),j.load(ee,q+".legend.page-on"),(c=new ZC.DT(f)).Z=c.C7=f.Z,c.K=f.K+"-page-prev",c.A0=c.AE=f.D4.page>1?ee["background-color"]:$["background-color"],c.append(f.D4.page>1?f.o["page-on"]:f.o["page-off"]),C=f.iX+f.I/2-U.I/2-6,u=U.iY+U.F/2,c.parse(),c.AI=ZC.BQ(c.AI,8),d=ZC._i_(.75*c.AI),c.D=[[C,u-d],[C,u+d],[C-c.AI,u],[C,u-d]],c.parse(),c.AN&&c.paint(),(Z=new ZC.DT(f)).Z=Z.C7=f.Z,Z.K=f.K+"-page-next",Z.A0=Z.AE=f.D4.page<f.D4.pages?ee["background-color"]:$["background-color"],Z.append(f.D4.page<f.D4.pages?f.o["page-on"]:f.o["page-off"]),p=f.iX+f.I/2+U.I/2+6,h=U.iY+U.F/2,Z.parse(),Z.AI=ZC.BQ(Z.AI,8),d=ZC._i_(.75*Z.AI),Z.D=[[p,h-d],[p,h+d],[p+Z.AI,h],[p,h-d]],Z.parse(),Z.AN&&Z.paint()}if(!ZC.move){var ie,te,ne=f.F,ae=f.iY;f.FP&&(ne-=f.FP.F,ae+=f.FP.F),ZC.AL(f.K+"-frame")?ZC.A4("#"+f.K+"-frame").css("top",ae+"px").css("left",f.iX+"px").css("width",f.I+"px").css("height",ne+"px"):ZC.Q.HY({cls:"zc-abs zc-legend-frame "+f.K+"-frame",id:f.K+"-frame",wh:f.I+"/"+ne,tl:ae+"/"+f.iX,opacity:0,background:"#fff",p:_,zidx:0}),f.D4.enabled&&!f.NC&&(f.D4.page>1&&ZC.Q.HY({cls:f.K+"-page-area zc-legend-page-area zc-abs",id:f.K+"-page-prev-area",wh:c.AI+"/"+2*c.AI,tl:ZC._i_(u+c.BH-c.AI)+"/"+ZC._i_(C+c.BL-c.AI),opacity:0,p:_,zidx:1}),f.D4.page<f.D4.pages&&ZC.Q.HY({cls:f.K+"-page-area zc-legend-page-area zc-abs",id:f.K+"-page-next-area",wh:Z.AI+"/"+2*Z.AI,tl:ZC._i_(h+c.BH-Z.AI)+"/"+ZC._i_(p+Z.BL),opacity:0,p:_,zidx:1})),f.FP&&f.UY&&("icon"===f.UJ?(te=ZC._i_(f.FP.iY+ZC.MAPTX+n.BH)+"/"+ZC._i_(f.FP.iX+f.FP.I-20+ZC.MAPTX+n.BL),ie="20/"+f.FP.F):(te=ZC._i_(f.FP.iY+ZC.MAPTX)+"/"+ZC._i_(f.FP.iX+ZC.MAPTX),ie=f.FP.I-(f.UT?23:0)+"/"+f.FP.F),ZC.Q.HY({cls:f.K+"-header-area zc-legend-header-area zc-abs",id:f.K+"-move-area",wh:ie,tl:te,opacity:0,p:_,zidx:1})),f.UT&&(f.UY&&"icon"===f.UJ?(te=ZC._i_(f.FP.iY+ZC.MAPTX+t.BH)+"/"+ZC._i_(f.FP.iX+f.FP.I-41+ZC.MAPTX+t.BL),ie="20/"+f.FP.F):(te=ZC._i_(f.FP.iY+ZC.MAPTX+t.BH)+"/"+ZC._i_(f.FP.iX+f.FP.I-22+ZC.MAPTX+t.BL),ie="20/"+f.FP.F),ZC.Q.HY({cls:f.K+"-header-area zc-legend-header-area zc-abs",id:f.K+"-minimize-area",wh:ie,tl:te,opacity:0,p:_,zidx:1})),f.OQ=0,f.ZW=0,f.zc_legend_mouseover=function(){f.YF=!0},f.zc_legend_mouseout=function(){f.YF=!1},f.Z5=function(e){if(e.preventDefault(),f.H.hideCM(),ZC.move=!0,ZC.mobile||!(e.which>1)){f.A.A.E["graph-"+f.A.K+"-legend-info"]=null;var i=ZC.Q.MF(e),t=ZC.A4("#"+f.A.A.K+"-top").offset();f.OQ=i[0]-t.left-f.FP.iX,f.ZW=i[1]-t.top-f.FP.iY,f.oldcursor=document.body.style.cursor,document.body.style.cursor="move",ZC.A4(document.body).bind(ZC.Q.BZ("mousemove"),f.Z6),ZC.A4(document.body).bind(ZC.Q.BZ("mouseup"),f.A0T)}},f.Z6=function(e){var i=ZC.Q.MF(e),t=ZC.A4("#"+f.A.A.K+"-top").offset(),n=i[0]-t.left-f.OQ,a=i[1]-t.top-f.ZW;if(f.PP?(n=ZC.BQ(n,f.H.iX+2),n=ZC.CY(n,f.H.iX+f.H.I-f.I-2),a=ZC.BQ(a,f.H.iY+2),a=ZC.CY(a,f.H.iY+f.H.F-f.F-4)):(n=ZC.BQ(n,f.A.iX+2),n=ZC.CY(n,f.A.iX+f.A.I-f.I-2),a=ZC.BQ(a,f.A.iY+2),a=ZC.CY(a,f.A.iY+f.A.F-f.F-4)),f.PP||(n-=f.A.iX,a-=f.A.iY),f.o.x=n,f.o.y=a,f.o.position=null,f.clear(!0),f.parse(),f.paint(),f.FP){var l=f.PP?f.A.A:f.A;f.A.A.E["legend"+f.A.L+"-xy-ratio"]=[n/l.I,a/(l.F-f.FP.F)]}},f.A0T=function(){ZC.move=!1,document.body.style.cursor=f.oldcursor,delete f.oldcursor,ZC.A4(document.body).unbind(ZC.Q.BZ("mousemove"),f.Z6),ZC.A4(document.body).unbind(ZC.Q.BZ("mouseup"),f.A0T),f.XL=[],f.clear(!1),f.parse(),f.paint(),f.VT()},f.YY=function(e){f.E["default-width"]=null,-1!==(e.targetid||e.target.id).indexOf("-page-next-area")?(f.D4.min+=f.EG,f.D4.max+=f.EG,f.D4.page+=1):(f.D4.min-=f.EG,f.D4.max-=f.EG,f.D4.page-=1),(!(i=f.A.A.E["graph-"+f.A.K+"-legend-info"])||null===ZC._n_(i.x)&&null===ZC._n_(i.y))&&(f.iX=null,f.iY=null),f.VT(),f.A.K6()},f.XY=function(e){var i=f.NC?"legendmaximize":"legendminimize";e&&(f.A.A.E["legend-toggling"]=1),zingchart.exec(f.A.H.K,i,{graphid:f.A.L}),e&&(f.A.A.E["legend-toggling"]=0),e&&(f.A.A.E["g"+f.A.L+"-legend-collapsed"]="legendminimize"===i)},f.MQ=function(e){ZC.move=!0;var i=ZC.Q.MF(e),t=ZC.A4("#"+f.A.A.K+"-top").offset(),n=i[0]-t.left,a=i[1]-t.top;f.E["dragged-x"]=n,f.E["dragged-y"]=a,f.VT(),f.clear(!1),f.parse(),f.paint()},f.W8=function(e){if(e.preventDefault(),f.H.hideCM(),f.IP=document.body.style.cursor,document.body.style.cursor="move",ZC.mobile||!(e.which>1)){var i=new RegExp("-legend-item_([0-9]+)-area","g").exec(e.target.id);i&&(f.E["dragged-offset-y"]=0,f.E["calculate-y"]=!0,f.E["dragged-x"]=0,f.E["dragged-y"]=0,f.N8=ZC._i_(i[1]),f.iDragPos=ZC.AV(f.A.AY.M4,f.N8),ZC.A4(document.body).bind(ZC.Q.BZ("mousemove"),f.MQ),ZC.A4(document.body).bind(ZC.Q.BZ("mouseup"),f.XI))}},f.XI=function(){var e=f.N8,i=f.iDragPos;if(f.N8=-1,f.iDragPos=-1,f.E["calculate-y"]=!1,document.body.style.cursor=f.IP,ZC.move||(e=-1,i=-1),ZC.A4(document.body).unbind(ZC.Q.BZ("mousemove"),f.MQ),ZC.A4(document.body).unbind(ZC.Q.BZ("mouseup"),f.XI),ZC.move&&-1!==e){for(var t=f.A.AY.A5,n=f.A.AY.M4,a=0,l=t.length;a<l;a++)t[a].o["legend-item"]=t[a].o["legend-item"]||{},null===ZC._n_(t[a].o["legend-item"].order)&&(t[a].o["legend-item"].order=ZC._i_(t[a].o["z-index"]||a+1));for(var o=t[e].o["legend-item"].order,r=-1,s=0,A=f.Q1.length;s<A;s++)f.E["dragged-y"]-f.E["dragged-offset-y"]/2>f.Q1[s].iY&&(r=s);for(t[e].o["legend-item"].order=-1===r?.5:t[n[r]].o["legend-item"].order+.5,s=0,A=f.Q1.length;s<A;s++)r>i?t[s].o["legend-item"].order<t[e].o["legend-item"].order&&t[s].o["legend-item"].order>o&&t[s].o["legend-item"].order--:t[s].o["legend-item"].order>t[e].o["legend-item"].order&&t[s].o["legend-item"].order<o&&t[s].o["legend-item"].order++;for(t[e].o["legend-item"].order=r>i?Math.floor(t[e].o["legend-item"].order):Math.ceil(t[e].o["legend-item"].order),s=0,A=f.Q1.length;s<A;s++)f.A.o.series[s]["z-index"]=t[s].o["legend-item"].order}f.A.AY.E["plot-sort"]=!0,ZC.move=!1,f.clear(!1),f.A.K6()},ZC.A4("#"+f.K+"-frame").live(ZC.Q.BZ("mouseover"),f.zc_legend_mouseover).live(ZC.Q.BZ("mouseout"),f.zc_legend_mouseout),ZC.A4("#"+f.K+"-move-area").live(ZC.Q.BZ("mousedown"),f.Z5),ZC.A4("#"+f.K+"-minimize-area").live(ZC.Q.BZ("click"),f.XY),ZC.A4("."+f.K+"-page-area").live(ZC.Q.BZ("click"),f.YY),f.BR.o.reorder&&ZC.A4("."+f.A.K+"-legend-item-area").live("mousedown",f.W8)}f.E.showhide=null,1===f.A.A.E["legend-toggling"]||ZC.move||(f.M0&&null===ZC._n_(f.A.A.E["g"+f.A.L+"-legend-collapsed"])||f.A.A.E["g"+f.A.L+"-legend-collapsed"]&&!f.NC)&&(window.setTimeout(function(){f.XY(!0)},0),f.A.A.E["g"+f.A.L+"-legend-collapsed"]=!0)}},gc:function(){ZC.AP.gc(this,["B6","D","Q1","Z","C7","o","JB","I6","KN","FP","BR","ZG","H","A","A2","NK","D4"])}};ZC.V6=ZC.DN.CA(V6);var A81={$i:function(e){this.b(e);var i=this;i.MW=null,i.BB=null,i.M=null,i.JS=0,i.BF=null,i.GG="bottom",i.L1=40,i.A37=[2,4]},parse:function(){var e,i,t,n=this;(n.assign_a([["z-index","JS","i"],["length","L1","i"],["aspect","A37"],["direction","GG"]]),null===ZC._n_(n.o.from)&&null===ZC._n_(n.o.to))&&(null!==ZC._n_(n.o.x)&&null!==ZC._n_(n.o.y)&&null!==ZC._n_(n.o.length)&&null!==ZC._n_(n.o.angle)&&(i="string"==typeof n.o.x?n.A.UU(n.o.x)[0]:ZC._i_(n.o.x),t="string"==typeof n.o.y?n.A.UU(n.o.y)[1]:ZC._i_(n.o.y),n.o.from={x:i+n.L1*ZC.EO(n.A9+180),y:t+n.L1*ZC.EH(n.A9+180)},n.o.to={x:i+n.L1*ZC.EO(n.A9),y:t+n.L1*ZC.EH(n.A9)}));null!==ZC._n_(e=n.o.from)&&(n.MW=new ZC.DT(n.A),n.MW.append(e),null!==e.hook&&(n.MW.E.hook=e.hook),n.MW.parse(),"string"==typeof e&&(n.MW.E.hook=e)),null!==ZC._n_(e=n.o.to)&&(n.BB=new ZC.DT(n.A),n.BB.append(e),null!==e.hook&&(n.BB.E.hook=e.hook),n.BB.parse(),"string"==typeof e&&(n.BB.E.hook=e)),(null!==ZC._n_(e=n.o.label)||""!==n.o.text&&"undefined"!=typeof n.o.text)&&(n.M=new ZC.DN(n),n.M.append(n.o),n.M.append(e),n.M.parse()),n.b()},paint:function(){var e,i,t=this;if(t.AN&&(null!==t.MW||null!==t.BB))if(t.AI<1&&(t.AI=1),!t.MW||null===ZC._n_(e=t.MW.E.hook)||(i=t.A.UU(e),t.MW.iX=i[0],t.MW.iY=i[1],t.MW.iX+=t.MW.BL,t.MW.iY+=t.MW.BH,ZC.DS(t.MW.iX,t.A.P.iX-2,t.A.P.iX+t.A.P.I+2)&&ZC.DS(t.MW.iY,t.A.P.iY-2,t.A.P.iY+t.A.P.F+2)))if(!t.BB||null===ZC._n_(e=t.BB.E.hook)||(i=t.A.UU(e),t.BB.iX=i[0],t.BB.iY=i[1],t.BB.iX+=t.BB.BL,t.BB.iY+=t.BB.BH,ZC.DS(t.BB.iX,t.A.P.iX-2,t.A.P.iX+t.A.P.I+2)&&ZC.DS(t.BB.iY,t.A.P.iY-2,t.A.P.iY+t.A.P.F+2))){var n,a;if(t.MW&&t.BB)n=[t.MW.iX,t.MW.iY],a=[t.BB.iX,t.BB.iY];else if(t.MW&&!t.BB)switch(n=[t.MW.iX,t.MW.iY],t.GG){case"top":a=[t.MW.iX,t.MW.iY+t.L1];break;case"right":a=[t.MW.iX+t.L1,t.MW.iY];break;case"bottom":a=[t.MW.iX,t.MW.iY-t.L1];break;case"left":a=[t.MW.iX-t.L1,t.MW.iY]}else if(!t.MW&&t.BB)switch(a=[t.BB.iX,t.BB.iY],t.GG){case"top":n=[t.BB.iX,t.BB.iY+t.L1];break;case"right":n=[t.BB.iX-t.L1,t.BB.iY];break;case"bottom":n=[t.BB.iX,t.BB.iY-t.L1];break;case"left":n=[t.BB.iX+t.L1,t.BB.iY]}var l,o=a[0]-n[0],r=a[1]-n[1],s=ZC.TN(Math.atan2(r,o)),A=Math.sqrt(o*o+r*r),C=[];if(C.push(n),l=ZC.AR.BN(n[0],n[1],t.AI/2,s+90),C.push(l),l=ZC.AR.BN(l[0],l[1],A-t.A37[1]*t.AI/2,s),C.push(l),l=ZC.AR.BN(l[0],l[1],t.A37[0]*t.AI/2,s+90),C.push(l),C.push(a),l=ZC.AR.BN(l[0],l[1],(2*t.A37[0]+2)*t.AI/2,s-90),C.push(l),l=ZC.AR.BN(l[0],l[1],t.A37[0]*t.AI/2,s+90),C.push(l),l=ZC.AR.BN(n[0],n[1],t.AI/2,s-90),C.push(l),C.push(n),t.BF=new ZC.DT(t.A),t.BF.K=t.K,t.BF.Z=t.BF.C7=t.Z,t.BF.copy(t),t.BF.D=C,t.BF.CZ=!1,t.BF.parse(),t.BF.paint(),null!==t.M&&t.M.AN){t.M.Z=t.Z,t.M.K=t.A.K+"-arrow-label-"+t.H5,t.M.GL=t.A.K+"-arrow-label zc-arrow-label";var c=ZC.AR.JU(n[0],n[1],a[0],a[1]);t.M.iX=c[0],t.M.iY=c[1],t.M.BL-=t.M.I/2,t.M.BH-=t.M.F/2,null!==ZC._n_(t.M.o["font-angle"])&&"inherit"===t.M.o["font-angle"]&&(t.M.A9=s),t.M.paint(),t.M.EK()}}else t.AN=!1;else t.AN=!1}};ZC.A81=ZC.DT.CA(A81);var JR={$i:function(e){var i=this;i.H=e,i.S4=!1,i.C4=null,i.Z1=null,i.QA=null,i.zc_guide_touchend=null},unbind:function(){var e=this;e.C4&&window.clearInterval(e.C4),e.Z1&&window.clearInterval(e.Z1),ZC.A4(document.body).unbind("mousemove touchstart touchmove",e.QA),ZC.A4(document.body).unbind("touchend",e.zc_guide_touchend)},bind:function(){var e,i=this,t=i.H.K,n=ZC.AL(t+"-guide-c"),a=ZC.Q.EB(n,i.H.AB),l={},o={},r={},s={},A=null,C=null,c=null;function u(){!C&&c&&(c.E["guide-active-plot"]=null),ZC.JR.GUIDES&&ZC.JR.GUIDES[t]&&!ZC.JR.GUIDES[t].blocked&&ZC.JR.clearGuide(t),C=null}ZC.mobile||null!==ZC._n_(ZC.Z1)||(i.Z1=window.setInterval(function(){for(var e=!0,n=0,a=zingchart.HZ.length;n<a;n++)if(t===zingchart.HZ[n].K)if(ZC.AL(zingchart.HZ[n].K+"-top")){var l=ZC._tx_(t),o=ZC.A4("#"+zingchart.HZ[n].K+"-top").offset();ZC.E1[0]>=o.left&&ZC.E1[0]<=o.left+zingchart.HZ[n].I*l[0]&&ZC.E1[1]>=o.top&&ZC.E1[1]<=o.top+zingchart.HZ[n].F*l[1]&&(e=!1)}else window.clearInterval(i.Z1);e&&(u(),ZC.JR.GUIDES&&ZC.JR.GUIDES[t]&&ZC.JR.GUIDES[t].active&&(ZC.AP.BY("guide_mouseout",i.H,i.H.FG()),ZC.JR.GUIDES[t].active=!1))},500)),i.QA=function(p){if(zingchart.GUIDE_EV=p,!p.target.id||-1===p.target.id.indexOf("-menu-item-")){var Z,h,d,f,_,g,v,b,B,m,E,D,F,K,x,I,y,w,L,X,Y,M,H,P,N,S,O;ZC.MAX,ZC.MAX;for(Z=0;Z<zingchart.HZ.length;Z++)if(zingchart.HZ[Z].K!==i.H.K&&-1!==zingchart.HZ[Z].K.indexOf("-fullscreen"))return;if((ZC.ie67||"mousemove"!==p.type||!ZC.TOUCHEVENTS)&&-1!==p.target.id.indexOf(i.H.K+"-")&&(!ZC.move||ZC.mobile)){if(i.H.ZT||!ZC.AL(t+"-top"))return!1;if(!ZC.Q.AB3(ZC.AL(t+"-top")))return!1;var G=[],k=ZC.Q.MF(p),T=k[0],z=k[1];if(null!==ZC._n_(p._pageX_)&&(T=p._pageX_),null!==ZC._n_(p._pageY_)&&(z=p._pageY_),null===ZC._n_(p._pageX_)&&null===ZC._n_(p._pageY_)){var Q=ZC.A4("#"+t+"-top").offset();d=T-Q.left,f=z-Q.top}else d=T,f=z;var J=ZC._tx_(i.H.K);for(d/=J[0],f/=J[1],Z=0,h=i.H.AG.length;Z<h;Z++)_=i.H.AG[Z].P,ZC.DS(d,_.iX-15,_.iX+_.I+15)&&ZC.DS(f,_.iY-15,_.iY+_.F+15)&&(C=i.H.AG[Z]),ZC.DS(d,i.H.AG[Z].iX,i.H.AG[Z].iX+i.H.AG[Z].I)&&ZC.DS(f,i.H.AG[Z].iY,i.H.AG[Z].iY+i.H.AG[Z].F)&&(A=i.H.AG[Z]);var V=null,R=!1;if(C){if(ZC.JR.GUIDES=ZC.JR.GUIDES||{},ZC.JR.GUIDES[t]=ZC.JR.GUIDES[t]||{},p.fromAPI||(ZC.JR.GUIDES[t].blocked=!1,ZC.JR.GUIDES[t].active=!0),c=C,C.CX&&"hover"===C.CX.o.trigger){null!==ZC._n_(C.E["guide-active-plot"])&&(V=C.E["guide-active-plot"]);var W=/(.+)-plotset-plot-(.+)-node-(.+)/.exec(p.target.id);if(W&&W.length&&(V=parseInt(W[2],10),C.E["guide-active-plot"]=V),null===ZC._n_(V))return}if(!C.A1J)return void u();for(G.push(C),C&&C.CX&&(R=null!==ZC._n_(C.CX.o.shared)&&ZC._b_(C.CX.o.shared)),Z=0,h=i.H.AG.length;Z<h;Z++)if(i.H.AG[Z]!==C){_=i.H.AG[Z].P;var U=i.H.AG[Z].CX,j=i.H.AG[Z].HB,q=U&&null!==ZC._n_(U.o.shared)&&ZC._b_(U.o.shared);q&&("xy"===C.AJ.layout&&"xy"===i.H.AG[Z].AJ.layout&&(U||j)&&ZC.DS(d,_.iX-5,_.iX+_.I+5)&&(ZC.DS(f,_.iY-5,_.iY+_.F+5)||R&&q)||"yx"===C.AJ.layout&&"yx"===i.H.AG[Z].AJ.layout&&(U||j)&&ZC.DS(f,_.iY-5,_.iY+_.F+5)&&(ZC.DS(d,_.iX-5,_.iX+_.I+5)||R&&q))&&G.push(i.H.AG[Z])}}else if(ZC.JR.GUIDES)for(var $ in ZC.JR.GUIDES)if(ZC.JR.GUIDES[$]&&ZC.JR.GUIDES[$].active){var ee=zingchart.getLoader($);N=ee.FG(),ZC.AP.BY("guide_mouseout",ee,N),ZC.JR.GUIDES[$].active=!1}if(0===G.length&&(l={},o={},r={},i.S4&&(null===ZC._n_(p._pageX_)&&u(),i.S4=!1),c&&c.A.A7&&A&&A.K!==c.K&&c.A.A7.hide()),G.length>0){i.S4=!0;for(var ie=!1,te=0,ne=G.length;te<ne;te++){var ae=!1;if(null===ZC._n_(l[te])&&(l[te]={}),null===ZC._n_(o[te])&&(o[te]={}),null===ZC._n_(r[te])&&(r[te]={}),(G[te].CX||G[te].HB)&&"ready"===G[te].ME){var le,oe=[],re=[],se=[],Ae=!1,Ce="",ce=[],ue=[],pe=[],Ze=[],he={},de={},fe=[];_=G[te].P;var _e=G[te].CX&&null!==ZC._n_(G[te].CX.o.exact)&&ZC._b_(G[te].CX.o.exact),ge=-1;G[te].CX&&(ge=ZC._i_(ZC._c_(G[te].CX.o.tolerance||-1))),K=[-1,ZC.MAX],x=[-1,ZC.MAX],ZC.MAX,ZC.MAX;var ve,be,Be=!0,me=[],Ee="";G[te].CX&&(null!==ZC._n_(G[te].CX.o["plot-label"])&&ZC._n_(null!==(e=G[te].CX.o["plot-label"].multiple))&&(Be=ZC._b_(e)),null!==ZC._n_(G[te].CX.o["value-label"])&&ZC._n_(null!==(e=G[te].CX.o["value-label"].multiple))&&(Be=ZC._b_(e)));var De={};for(M=0,H=G[te].AY.A5.length;M<H;M++)if(!G[te].AY.A5[M].LN&&(Z=M,G[te].CX&&G[te].CX.o["reverse-series"]&&(Z=H-M-1),G[te].E["plot"+Z+".visible"])){if(null!==ZC._n_(V)&&Z!==V)continue;if(!(ve=G[te].BM(G[te].AY.A5[Z].BU("k")[0])))continue;if(ve.CO){var Fe=ve.AW?ve.iY+ve.BV:ve.iY+ve.AC,Ke=ve.AW?ve.iY+ve.F-ve.BV:ve.iY+ve.F-ve.AC;f=ZC._l_(f,Fe,Ke),g=ve.EF&&G[te].AY.A5[Z].EF?ve.O9(f,G[te].AY.A5[Z]):ve.O9(f)}else{var xe=ve.AW?ve.iX+ve.BV:ve.iX+ve.AC,Ie=ve.AW?ve.iX+ve.I-ve.AC:ve.iX+ve.I-ve.BV;d=ZC._l_(d,xe,Ie),g=ve.EF&&G[te].AY.A5[Z].EF?ve.O9(d,G[te].AY.A5[Z]):ve.O9(d)}if(null===ZC._n_(g))continue;var ye,we,Le,Xe,Ye,Me,He,Pe,Ne=[];if(Ne="undefined"==typeof g.length||0===g.length?[g]:g,G[te].CX){for(var Se=0,Oe=Ne.length;Se<Oe;Se++)if(g=Ne[Se],v=G[te].AY.A5[Z].FK(g)){le=v,v.setup(),v.O?(ZC.COLORS=[v.O.C2,v.O.A0,v.O.AE,v.O.BW,v.O.B7],v.NB&&ZC.COLORS.push(v.NB.A0,v.NB.AE,v.NB.BW,v.NB.B7)):ZC.COLORS=[],v.A.I3&&"undefined"!=typeof v.E.A5M&&v.paint(!0),I=v.iX,y=v.iY,"undefined"!=typeof v.E.A5M&&(I=parseInt(v.E.A5M,10)),"undefined"!=typeof v.E.A7N&&(y=parseInt(v.E.A7N,10)),D=I,F=y,he[Z]={index:g,y:y},G[te].BD&&G[te].BD.XT&&(G[te].BD.clear(!0),G[te].BD.parse(),G[te].BD.paint(g)),(b=new ZC.DN(ve)).Z=b.C7=n,b.K=G[te].K+"-guide-label-"+g+"-"+Z,b.GL=G[te].A.K+"-guide-label "+G[te].K+"-guide-label zc-guide-label",Be&&(Y=v.A8F(),b.AM=v.A.J7),Be?b.append(G[te].CX.o["plot-label[multiple]"]):b.append(G[te].CX.o["plot-label[single]"]),b.append(G[te].CX.o["plot-label"]),b.append(G[te].CX.o["value-label"]),b.append(G[te].AY.A5[Z].o["guide-label"]),E=ZC.AP.O2(b.o,G[te].AY.A5[Z].o),b.JT=function(e){return v?v.JT(e,E):e},v.AB2();var Ge="auto";if(null!==ZC._n_(e=b.o.placement)&&(Ge=e),b.E.placement=Ge,b.KT=Be,b.E.plotidx=v.A.L,b.E.nodeidx=v.L,b.parse(),P=null!==ZC._n_(b.o.distance)?ZC._i_(b.o.distance):6,b.E7&&b.E7.length&&(b.J2=function(e){return e=v?v.JT(e,E):e.replace(/(%i)|(%node-index)/g,g)},b.DE()&&(E=b.overrideFormat(E),b.parse())),b.HT&&v&&(b.H3(b,b,null,v.LY(null,!1),b.MJ),b.parse()),ZC.DS(v.iX,_.iX-.5,_.iX+_.I+.5)){switch(Be||(0===re.length&&(null===ZC._n_(b.o["header-text"])||Ae||(Ae=!0,Ee+=v.JT(b.o["header-text"],E)+"<br>"),null!==ZC._n_(b.o["footer-text"])&&""===Ce&&(Ce=v.JT(b.o["footer-text"],E)+"<br>")),b.AN&&""!==b.AM&&(ZC._b_(b.o["single-text"])?me.push(v.JT(b.AM,E)):me.push(v.JT(b.AM,E)+"<br>"))),b.E.pos=re.length,b.E["node-value"]=v.AD,b.E["marker-x"]=I,b.E["marker-y"]=y,b.E["guide-style"]=v.A8F(),Ge){default:null===ZC._n_(b.o.x)?ve.CO?v.iY<=_.iY+_.F/2?(b.iY=y-b.F-P,b.EM="bottom"):(b.iY=y+P,b.EM="top"):v.iX>=_.iX+_.I/2?(b.iX=I-b.I-P,b.EM="right"):(b.iX=I+P,b.EM="left"):b.iX-=_.iX,null===ZC._n_(b.o.y)?ve.CO?(b.iX=I-b.I/2,b.iX<_.iX&&(b.iX=_.iX),b.iX+b.I>_.iX+_.I&&(b.iX=_.iX+_.I-b.I)):(b.iY=y-b.F/2,b.iY<_.iY&&(b.iY=_.iY),b.iY+b.F>_.iY+_.F&&(b.iY=_.iY+_.F-b.F)):b.iY-=_.iY,b.DM=[I,y];break;case"left":b.iX=I-b.I-P,b.iY=y-b.F/2,b.DM=[I,y];break;case"right":b.iX=I+P,b.iY=y-b.F/2,b.DM=[I,y];break;case"top":ve.CO?(b.iX=_.iX+_.I-b.I,b.iY=y-b.F/2,b.EM="left",b.DM=[_.iX+_.I-b.I-P,y]):(b.iX=I-b.I/2,b.iY=_.iY,b.EM="bottom",b.DM=[I,b.iY+b.F+P]);break;case"node-top":ve.CO?(b.iX=I+2*P,b.iY=y-b.F/2,b.EM="left",b.DM=[I+P,y]):(b.iX=I-b.I/2,b.iY=y-b.F-2*P,b.EM="bottom",b.DM=[I,y-P]);break;case"bottom":ve.CO?(b.iX=_.iX,b.iY=y-b.F/2,b.EM="right",b.DM=[_.iX+b.I+P,y]):(b.iX=I-b.I/2,b.iY=_.iY+_.F-b.F,b.EM="top",b.DM=[I,b.iY-P])}oe.push({plotindex:v.A.L,nodeindex:v.L,keyvalue:v.BT||ve.V[v.L],value:v.AD,text:b.AM,x:b.iX,y:b.iY,refx:I,refy:y}),-1===ZC.AV(se,b.AM)&&(s[b]=v,se.push(b.AM)),ve.CO?b.E.diff=_e||-1!==ge?ZC._a_(y-f):-1:b.E.diff=_e||-1!==ge?ZC._a_(I-d):-1,b.AN&&re.push(b),o[te][Z]=b,ae=!0}}if(!v)continue}if(G[te].CX&&ZC.DS(v.iX,_.iX-1,_.iX+_.I+1)){if((m=new ZC.DN(ve)).Z=m.C7=n,m.K=G[te].K+"-guide-scale-x-label-"+Z,m.GL=G[te].A.K+"-guide-label "+G[te].K+"-guide-label zc-guide-label",m.A0=m.AE=ve.B7,m.C2=G[te].AJ["3d"]?"#999":"#fff",m.append(G[te].CX.o["scale-label"]),m.append(G[te].CX.o[ve.BE+"-label"]),m.append(G[te].AY.A5[Z].o["scale-label"]),m.KT=!0,m.E.nodeidx=v.L,E=ZC.AP.O2(m.o),null===ZC._n_(E.decimals)){var ke=Math.floor(ZC.G6(null!==v.BT?v.BT:v.L,10));E.decimals=ke<0?1-ke:0}if(m.JT=function(e){e=ve.JT(e,g,ve.EF&&G[te].AY.A5[Z].EF?G[te].AY.A5[Z]:null,E,!0);var i=G[te].AY.A5[Z].KH;if(v&&i)for(var t in i){var n;n=i[t]instanceof Array?ZC._c_(i[t][v.L],""):ZC._c_(i[t],""),e=e.replace("%data-"+t,n,"g")}return e},m.parse(),P=null!==ZC._n_(m.o.distance)?ZC._i_(m.o.distance):6,m.E7&&m.E7.length&&(m.J2=function(e){return e=v?v.JT(e,E):e.replace(/(%i)|(%node-index)/g,g)},m.DE()&&m.parse()),m.HT&&v&&(m.H3(m,m,null,v.LY(null,!1),m.MJ),m.parse()),de[ve.BE]=m.AM,ye=ZC._b_(m.o["callout-position"]),we=m.o.x,Le=m.o.y,"opposite"!==ve.BA?ve.CO?(Xe="right",Me=ve.E.iX-m.I-P,Ye=[ve.E.iX,F],He=F-m.F/2):(Xe="top",Me=D-m.I/2,Ye=[D,ve.E.iY],He=ve.E.iY+P):ve.CO?(Xe="left",Me=ve.E.iX+P,Ye=[ve.E.iX,F],He=F-m.F/2):(Xe="bottom",Me=D-m.I/2,Ye=[D,ve.E.iY],He=ve.E.iY-m.F-P),ye||(m.EM=Xe),we||(m.iX=Me),ye||we||Le||(m.DM=Ye),Le||(m.iY=He),m.AN&&ve.AN&&""!==m.AM){var Te=!1;if(fe.length)for(var ze=0;ze<fe.length;ze++)m.AM+"@"+ve.BE===fe[ze]&&(Te=!0);Te||(fe.push(m.AM+"@"+ve.BE),ve.CO?m.E.diff=_e||-1!==ge?ZC._a_(F-f):-1:m.E.diff=_e||-1!==ge?ZC._a_(D-d):-1,pe.push(m)),Ze.push(ve.BE),r[te][Z]=m,ae=!0}-1!==String(G[te].CX.o["line-width"]).indexOf("%")&&(Pe=ZC.II(G[te].CX.o["line-width"]))>0&&Pe<=1&&(G[te].CX.AZ=ZC._i_(Pe*ve.AA)),ve.CO?((-1===x[0]||x[1]>ZC._a_(F-f))&&(x=[F,ZC._a_(F-f)]),ce.push([_e||-1!==ge?ZC._a_(F-f):-1,[null,[ve.E.iX,F],[G[te].P.iX+("opposite"===ve.BA?0:G[te].P.I),F]]])):((-1===K[0]||K[1]>ZC._a_(D-d))&&(K=[D,ZC._a_(D-d)]),ce.push([_e||-1!==ge?ZC._a_(D-d):-1,[null,[D,ve.E.iY],[D,G[te].P.iY+("opposite"===ve.BA?G[te].P.F:0)]]]))}if(be=G[te].BM(G[te].AY.A5[Z].BU("v")[0]),-1===ZC.AV(Ze,be.BE)&&G[te].HB&&("xy"===G[te].AJ.layout&&ZC.DS(f,be.iY,be.iY+be.F)||"yx"===G[te].AJ.layout&&ZC.DS(f,be.iX,be.iX+be.I))){var Qe="single";G[te].HB.o.type&&"multiple"===G[te].HB.o.type&&(Qe="multiple"),"multiple"===Qe&&null!==ZC._n_(he[Z])&&(be.CO?d=he[Z].x:f=he[Z].y),(m=new ZC.DN(be)).Z=m.C7=n,m.K=G[te].K+"-guide-scale-y-label-"+Z,m.GL=G[te].A.K+"-guide-label "+G[te].K+"-guide-label zc-guide-label";var Je=be.B7;"multiple"===Qe&&(Je=G[te].AY.A5[Z].B7),m.A0=m.AE=Je,m.C2=G[te].AJ["3d"]&&"multiple"!==Qe?"#999":"#fff",m.append(G[te].HB.o["scale-label"]),m.append(G[te].HB.o[be.BE+"-label"]),m.KT=!0;var Ve=be.CO?be.NE(d,!0):be.NE(f,!0),Re=Ve;if(E=be.MR(),ZC._cp_(ZC.AP.O2(m.o,be.o),E),null===ZC._n_(E.decimals)){ke=Math.floor(ZC.G6(Ve,10));E.decimals=ke<=0?1-ke:0}Ve=be.FQ(0,Ve,E),m.o.text=Ve,m.parse(),P=null!==ZC._n_(m.o.distance)?ZC._i_(m.o.distance):6,m.E7&&m.E7.length&&(m.J2=function(e){return e=e.replace(/(%v)|(%scale-value)/g,Re).replace(/(%t)|(%scale-text)/g,Ve).replace(/(%coord)/,be.CO?d:f)},m.DE()&&m.parse()),m.HT&&v&&(De={value:Re,text:Ve,coord:be.CO?d:f},m.H3(m,m,null,De,m.MJ),m.parse()),de[be.BE]=m.AM,ye=ZC._b_(m.o["callout-position"]),we=m.o.x,Le=m.o.y,"opposite"!==be.BA?be.CO?(Xe="top",Me=d-m.I/2,He=be.E.iY+P,Ye=[d,be.E.iY]):(Xe="right",Me=be.E.iX-m.I-P,He=f-m.F/2,Ye=[be.E.iX,f]):be.CO?(Xe="bottom",Me=d-m.I/2,He=be.E.iY-m.F-P,Ye=[d,be.E.iY]):(Xe="left",Me=be.E.iX+P,He=f-m.F/2,Ye=[be.E.iX,f]),ye||(m.EM=Xe),we||(m.iX=Me),ye||we||Le||(m.DM=Ye),Le||(m.iY=He),m.AN&&be.AN&&(m.E.diff=-1,pe.push(m),"multiple"===Qe&&null!==ZC._n_(he[Z])||Ze.push(be.BE),r[te][Z]=m,ae=!0),-1!==String(G[te].HB.o["line-width"]).indexOf("%")&&(Pe=ZC.II(G[te].HB.o["line-width"]))>0&&Pe<=1&&(G[te].HB.AZ=ZC._i_(Pe*be.AA)),be.CO?ue.push(null,[d,be.E.iY],[d,G[te].P.iY+("opposite"===be.BA?G[te].P.F:0)]):ue.push(null,[be.E.iX,f],[G[te].P.iX+("opposite"===be.BA?0:G[te].P.I),f])}}if(!_e&&pe.length>1)for(var We=pe[pe.length-1],Ue=ZC._i_((We.FM+We.FT+We.EQ+We.FN)/4),je=pe.length-1;je>=0;je--)for(var qe=je;qe>=0;qe--)je!==qe&&ZC.AR._boxoverlap2_(pe[je],pe[qe],-Ue)&&(pe[qe].C6=.3,pe[qe].UV=.1);for(B=ZC.MAX,Z=0,h=re.length;Z<h;Z++)re[Z].E.diff>=0&&(B=ZC.CY(re[Z].E.diff,B));-1!==ge&&(B=ZC.BQ(B,ge));var $e=!1,ei=1,ii=!1;re[0]&&(ii=ZC._b_(re[0].o["single-text"]),re[0].o["table-columns"]&&ZC._b_(re[0].o["html-mode"])&&($e=!0,ei=ZC._i_(re[0].o["table-columns"]||"1"),Ee+='<table class="zc-guide-label-table '+i.H.K+'-guide-label-table">')),!Be&&re.length>0&&("asc"!==re[0].o["sort-by-value"]&&"desc"!==re[0].o["sort-by-value"]||re.sort(function(e,i){return(e.E["node-value"]-i.E["node-value"])*("asc"===re[0].o["sort-by-value"]?1:-1)}));var ti=0;for(S=0,O=re.length;S<O&&(!(-1===re[S].E.diff||re[S].E.diff<=B)||($e?(ti%ei==0&&(Ee+="<tr>"),Ee+="<td>"+me[S]+"</td>",ti%ei==ei-1&&(Ee+="</tr>"),ti++):Ee+=me[re[S].E.pos],$e||!ii));S++);if($e&&(ti%ei!=ei-1&&(Ee+="</tr>"),Ee+="</table>"),""!==Ce&&(Ee+=Ce),!Be&&re.length>0&&(_e?ve.CO?(d=I=D,f=y=x[0]):(d=I=K[0],f=y=F):(d=I=D,f=y=F),""!==Ee&&(re[0].o.text=$e||ii?Ee:Ee.substring(0,Ee.length-4),re[0].parse()),P=null!==ZC._n_(b.o.distance)?ZC._i_(b.o.distance):6,null===ZC._n_(b.o.x)?ve.CO?d<G[te].iX+G[te].I/2?re[0].iX=d+P+14:re[0].iX=d-re[0].I-P-14:le&&le.iX>=_.iX+_.I/2?re[0].iX=I-re[0].I-P:re[0].iX=I+P:re[0].iX-=_.iX,null===ZC._n_(b.o.y)?ve.CO?le&&le.iY>=_.iY+_.F/2?re[0].iY=y-re[0].F-P:re[0].iY=y+P:f<G[te].iY+G[te].F/2?re[0].iY=f+P+14:re[0].iY=f-re[0].F-P-14:re[0].iY-=_.iY),ae){var ni=-1,ai=-1;if(ie||(null===ZC._n_(p._pageX_)&&u(),ie=!0),ce.length>0){var li=[];for(B=ZC.MAX,w=0,L=ce.length;w<L;w++)ce[w][0]>=0&&(B=ZC.CY(ce[w][0],B));for(-1!==ge&&(B=ZC.BQ(B,ge)),w=0,L=ce.length;w<L;w++)null!==ZC._n_(ce[w])&&(-1===ce[w][0]||ce[w][0]<=B)&&(G[te].CX&&G[te].CX.o["single-line"]&&ZC._b_(G[te].CX.o["single-line"])?(li=[].concat(ce[w][1]),"xy"===G[te].AJ.layout?ni=ZC._x_(ce[w][1][1][0]):"yx"===G[te].AJ.layout&&(ai=ZC._x_(ce[w][1][1][1]))):li=li.concat(ce[w][1]));if(G[te].CX.o.mask){var oi=-1;li.length>1&&li[1]&&(oi=li[1][0]||-1),G[te].CX.oMask||(G[te].CX.oMask=new ZC.HL(G[te]),G[te].CX.oMask.append({"background-color":"#fff",alpha:.85}),G[te].CX.oMask.append(G[te].CX.o.mask),G[te].CX.oMask.Z=n,G[te].CX.oMask.parse()),G[te].CX.oMask.iX=oi,G[te].CX.oMask.iY=G[te].P.iY,G[te].CX.oMask.I=Math.max(2,G[te].P.iX+G[te].P.I-oi+2),G[te].CX.oMask.F=G[te].P.F,G[te].CX.oMask.paint()}if(G[te].AJ["3d"])for(G[te].NX(),w=0,L=li.length;w<L;w++)li[w]&&(X=new ZC.CE(G[te],li[w][0]-ZC.AO.E2,li[w][1]-ZC.AO.E3,0),li[w][0]=X.ED[0],li[w][1]=X.ED[1]);G[te].CX.K=G[te].K+"-crosshair-x",G[te].CX.HT&&v&&(G[te].CX.H3(G[te].CX,G[te].CX,null,v.LY(null,!1),G[te].CX.MJ),G[te].CX.parse()),G[te].CX.AN&&ZC.CR.paint(a,G[te].CX,li)}if(ue.length>0){if(G[te].AJ["3d"])for(G[te].NX(),w=0,L=ue.length;w<L;w++)null!==ZC._n_(ue[w])&&(X=new ZC.CE(G[te],ue[w][0]-ZC.AO.E2,ue[w][1]-ZC.AO.E3,0),ue[w][0]=X.ED[0],ue[w][1]=X.ED[1]);G[te].HB.HT&&v&&(G[te].HB.H3(G[te].HB,G[te].HB,null,De,G[te].HB.MJ),G[te].HB.parse()),G[te].HB.AN&&ZC.CR.paint(a,G[te].HB,ue)}if(Be){for(Z=re.length-1;Z>=0;Z--)ZC.DS(re[Z].DM[0],_.iX-5,_.iX+_.I+5)&&ZC.DS(re[Z].DM[1],_.iY-5,_.iY+_.F+5)||re.splice(Z,1);if(re.length>1)for(var ri=!0;ri;)for(ri=!1,Z=0;Z<re.length-1;Z++)if(re[Z].AN&&(be.CO&&re[Z].iX>re[Z+1].iX||!be.CO&&re[Z].iY>re[Z+1].iY)){var si=re[Z];re[Z]=re[Z+1],re[Z+1]=si,ri=!0}if(re.length>0){var Ai=[],Ci=[];for(Z=0;Z<re.length;Z++)null!==ZC._n_(re[Z].o.x)&&null!==ZC._n_(re[Z].o.y)&&Ci.push(re[Z]);for(var ci,ui,pi,Zi=!0,hi=0,di=re.length*re.length;Zi&&hi<di;)for(hi++,Zi=!1,Z=0;Z<re.length-1;Z++)if(re[Z].AN&&-1===ZC.AV(Ci,re[Z]))if(ve.CO){if(re[Z+1].iX<re[Z].iX+re[Z].I){if(re[Z+1].iX-re[Z].I-4<_.iX&&-1===ZC.AV(Ai,re[Z])&&(Ai.push(re[Z]),re[Z].iX=_.iX),re[Z+1].iX=re[Z].iX+re[Z].I+4,re[Z+1].iX+re[Z+1].I>_.iX+_.I)for(pi=re[Z+1].iX-(_.iX+_.I-re[Z+1].I),ci=0,ui=re.length;ci<ui;ci++)re[ci].iX-pi>=_.iX?re[ci].iX-=pi:(re[ci].iX=_.iX,ci>0&&(re[Z+1].E["marker-y"]<_.iY+_.F/2?re[ci].iY=re[ci-1].iY+re[ci-1].F+4:re[ci].iY=re[ci-1].iY-re[ci].F-4));Zi=!0}}else if(re[Z+1].iY<re[Z].iY+re[Z].F){if(re[Z+1].iY-re[Z].F-4<_.iY&&-1===ZC.AV(Ai,re[Z])&&(Ai.push(re[Z]),re[Z].iY=_.iY),re[Z+1].iY=re[Z].iY+re[Z].F+4,re[Z+1].iY+re[Z+1].F>_.iY+_.F)for(pi=re[Z+1].iY-(_.iY+_.F-re[Z+1].F),ci=0,ui=re.length;ci<ui;ci++)re[ci].iY-pi>=_.iY?re[ci].iY-=pi:(re[ci].iY=_.iY,ci>0&&(re[Z+1].E["marker-x"]<_.iX+_.I/2?re[ci].iX=re[ci-1].iX+re[ci-1].I+4:re[ci].iX=re[ci-1].iX-re[ci].I-4));Zi=!0}}}var fi=!1;for(Z=0,h=pe.length;Z<h;Z++)if(-1===pe[Z].E.diff||pe[Z].E.diff<=B){var _i=pe[Z];G[te].AJ["3d"]&&(G[te].NX(),X=new ZC.CE(G[te],_i.iX+_i.I/2-ZC.AO.E2,_i.iY+_i.F/2-ZC.AO.E3,0),_i.iX=X.ED[0]-_i.I/2,_i.iY=X.ED[1]-_i.F/2,X=new ZC.CE(G[te],_i.DM[0]-ZC.AO.E2,_i.DM[1]-ZC.AO.E3,0),_i.DM[0]=X.ED[0],_i.DM[1]=X.ED[1]),G[te].CX&&G[te].CX.o["single-line"]&&ZC._b_(G[te].CX.o["single-line"])?("xy"===G[te].AJ.layout&&ni===ZC._x_(_i.iX+_i.I/2)||"yx"===G[te].AJ.layout&&ai===ZC._x_(_i.iY+_i.F/2))&&!fi&&(_i.paint(),fi=!0):_i.paint()}for(B=ZC.MAX,S=0,O=re.length;S<O;S++)re[S].E.diff>=0&&(B=ZC.CY(re[S].E.diff,B));for(-1!==ge&&(B=ZC.BQ(B,ge)),M=0,S=0,O=re.length;S<O;S++)if(-1===re[S].E.diff||re[S].E.diff<=B){var gi=ZC.DS(re[S].DM[0],_.iX-5,_.iX+_.I+5)&&ZC.DS(re[S].DM[1],_.iY-5,_.iY+_.F+5);if(!Be||gi){if(re[S].AN){switch(re[S].E.placement){case"top":ve.CO?re[S].DM[0]=re[S].iX-re[S].G8:re[S].DM[1]=re[S].iY+re[S].F+re[S].G8;break;case"bottom":ve.CO?re[S].DM[0]=re[S].iX+re[S].I+re[S].G8:re[S].DM[1]=re[S].iY-re[S].G8}if(-1!==ZC.AV(["top","bottom"],re[S].E.placement)){var vi=re[S].iX+re[S].I/2;re[S].iX=ZC.BQ(re[S].iX,0),re[S].iX=ZC.CY(re[S].iX,i.H.I-re[S].I),re[S].iY=ZC.BQ(re[S].iY,0),re[S].iY=ZC.CY(re[S].iY,i.H.F-re[S].F),null===ZC._n_(re[S].o["callout-offset"])&&(re[S].EW=parseInt(100*(vi-re[S].iX-re[S].I/2)/(re[S].I-re[S].H9),10))}if(G[te].AJ["3d"]&&(G[te].NX(),X=new ZC.CE(G[te],re[S].iX+re[S].I/2-ZC.AO.E2,re[S].iY+re[S].F/2-ZC.AO.E3,0),re[S].iX=X.ED[0]-re[S].I/2,re[S].iY=X.ED[1]-re[S].F/2,X=new ZC.CE(G[te],re[S].DM[0]-ZC.AO.E2,re[S].DM[1]-ZC.AO.E3,0),re[S].DM[0]=X.ED[0],re[S].DM[1]=X.ED[1],"left"===re[S].EM?re[S].iX=re[S].DM[0]+P:re[S].iX=re[S].DM[0]-re[S].I-P),G[te].AJ["3d"]||Be||0!==M||(re[S].iX=ZC.BQ(_.iX-5,re[S].iX),re[S].iY=ZC.BQ(_.iY-5,re[S].iY),re[S].iX=ZC.CY(_.iX+_.I-re[S].I+5,re[S].iX),re[S].iY=ZC.CY(_.iY+_.F-re[S].F+5,re[S].iY)),Be||!Be&&0===M){var bi=Be?S:0;(!Be||"canvas"===i.H.AB&&re[bi].o["background-image"]&&""!==re[bi].o["background-image"])&&re[bi].parse(),0!==re[bi].C6&&re[bi].paint(),M++}}if(gi){var Bi=new ZC.DT(G[te]);if(i.H.B8.load(Bi.o,"("+G[te].AF+").guide.marker"),Bi.K=re[S].K+"-marker",Bi.Z=Bi.C7=n,Bi.iX=re[S].E["marker-x"],Bi.iY=re[S].E["marker-y"],G[te].AJ["3d"]&&(G[te].NX(),X=new ZC.CE(G[te],Bi.iX-ZC.AO.E2,Bi.iY-ZC.AO.E3,0),Bi.iX=X.ED[0],Bi.iY=X.ED[1]),Y=re[S].E["guide-style"],Bi.A0=Bi.AE=ZC.AP.JK(Y["background-color"]),Bi.BW=Y.color,Bi.append(G[te].CX.o.marker),Bi.append(G[te].AY.A5[re[S].E.plotidx].o["guide-marker"]),"inherit"===Bi.o.type){var mi=G[te].AY.A5[re[S].E.plotidx];mi.A2&&mi.A2.o.type&&(Bi.o.type=mi.A2.o.type)}Bi.parse(),Bi.AN&&"none"!==Bi.DU&&Bi.AI>1&&Bi.paint()}}}(N=G[te].GX()).items=oe,N.guide={x:I,y:y},N.ev=p,N["scale-label"]=de,ZC.AP.BY("guide_mousemove",i.H,N),G[te].QK(!0)}else(N={}).guide={x:I,y:y},N.ev=p,ZC.AP.BY("guide_mousemove",i.H,N)}}}}}},i.zc_guide_touchend=function(){0!==zingchart.DEV.GUIDETIMEOUT&&window.setTimeout(function(){u()},ZC._i_(zingchart.DEV.GUIDETIMEOUT))},ZC.A4(document.body).bind("mousemove touchstart touchmove",i.QA),ZC.A4(document.body).bind("touchend",i.zc_guide_touchend)}};ZC.JR=ZC.C9.CA(JR),ZC.JR.clearGuide=function(e){var i=zingchart.getLoader(e);if(i){zingchart.GUIDE_EV=null;var t=ZC.AL(e+"-guide-c"),n=ZC.A4(t).width(),a=ZC.A4(t).height();ZC.A4("."+e+"-guide-label").remove(),ZC.Q.IV(t,i.AB,0,0,n,a),ZC.A4("#"+e+"-defs").children().each(function(){this.id&&-1!==this.id.indexOf("-guide-label-")&&ZC.Q.EU(this.id)})}},zingchart.extendAPI("resetguide",function(e,i){"string"==typeof(i=i||{})&&(i=JSON.parse(i)),ZC.JR.GUIDES[e]=ZC.JR.GUIDES[e]||{},ZC.JR.GUIDES[e].blocked=!1,ZC.JR.clearGuide(e)}),zingchart.extendAPI("setguide",function(e,i){"string"==typeof(i=i||{})&&(i=JSON.parse(i));var t,n,a=zingchart.getLoader(e),l=a.C8(i.graphid),o=l.BM("scale-x");"xy"===l.AJ.layout?(t=i.x||o.AT(i.keyvalue),n=l.iY+l.F/2):(t=l.iX+l.I/2,n=i.y||o.AT(i.keyvalue));var r={_pageX_:t,_pageY_:n,type:ZC.mobile?"touchstart":"mousemove",target:{id:e+"-img"}};ZC.JR.GUIDES=ZC.JR.GUIDES||{},ZC.JR.GUIDES[e]=ZC.JR.GUIDES[e]||{},ZC.JR.GUIDES[e].blocked=!0,ZC.JR.clearGuide(e),r.fromAPI=!0,a.D7.QA(r)});var A2M={$i:function(e,i){var t=this;t.o=null,t.C=e,t.O0=i},parse:function(){var e,i=this;i.o=i.C.o;var t,n,a,l,o,r,s,A,C,c=i.O0,u="\r\n",p=",",Z=!1,h=null,d=null,f=null,_=null,g=null,v=!1,b=!1,B=null,m={};null!==ZC._n_(e=i.o["html5-csv"])&&(m=e),null!==ZC._n_(e=i.o.csv)&&(m=e),null!==ZC._n_(e=m.separator)&&(p=e),null!==ZC._n_(e=m.mirrored)&&(Z=ZC._b_(e)),null!==ZC._n_(e=m.title)&&(h=ZC._b_(e)),null!==ZC._n_(e=m["string-values"])&&(b=ZC._b_(e)),Z?(null!==ZC._n_(e=m["horizontal-labels"])&&(f=ZC._b_(e)),null!==ZC._n_(e=m["vertical-labels"])&&(d=ZC._b_(e))):(null!==ZC._n_(e=m["horizontal-labels"])&&(d=ZC._b_(e)),null!==ZC._n_(e=m["vertical-labels"])&&(f=ZC._b_(e))),null!==ZC._n_(e=m["smart-scales"])&&(_=ZC._b_(e)),null!==ZC._n_(e=m["separate-scales"])&&(g=ZC._b_(e)),null!==ZC._n_(e=m["keyval-format"])&&(v=ZC._b_(e)),null!==ZC._n_(e=m.columns)&&(B=e);var E=null;null!==ZC._n_(e=m["thousands-separator"])&&(E=e);var D=null;if(null!==ZC._n_(e=m["decimals-separator"])&&(D=e),null!==E&&null===D&&(D="."===E?",":"."),null!==D&&null===E&&(E="."===D?",":"."),null!==ZC._n_(B)&&B.length>0){t=[],null!==ZC._n_(e=m["row-separator"])?u=e:c.split(/\n/).length>0?u="\n":c.split(/\r/).length>0&&(u="\r");var F=c.split(u),K=0;for(l=0,o=F.length;l<o;l++)if(""!==F[l].replace(/\s+/g,"")){t[K]=[];for(var x=0,I=0;x<F[l].length-1;)a=F[l].substring(x,x+B[I]),t[K].push(a),x+=B[I],I++;K++}}else{t=[[]],n=null!==ZC._n_(e=m["row-separator"])?new RegExp("(\\"+p+"|"+e+'|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\'+p+e+"]*))","gi"):new RegExp("(\\"+p+'|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\'+p+"\\r\\n]*))","gi");for(var y=null;y=n.exec(c);){var w=y[1];w.length&&w!==p&&t.push([]),a=y[2]?y[2].replace(new RegExp('""',"g"),'"'):y[3],t[t.length-1].push(a)}}var L=[];for(l=0,o=t.length;l<o;l++)0!==t[l].join("").replace(/\s+/g,"").length&&L.push(t[l]);var X=0,Y=0;if((null===ZC._n_(h)||h)&&(L.length>1&&1===L[0].length?(null===ZC._n_(i.o.title)?i.o.title={text:L[0][0]}:null===ZC._n_(i.o.title.text)&&(i.o.title.text=L[0][0]),h=!0):h=!1),h&&X++,Z){for(t=[],h&&t.push(L[0]),r=X,s=L.length;r<s;r++)for(A=0,C=L[r].length;A<C;A++)null===ZC._n_(t[A+X])&&(t[A+X]=[]),t[A+X].push(L[r][A]);L=t}if("function"==typeof zingchart.csvParser)for(r=0,s=L.length;r<s;r++)for(A=0,C=L[r].length;A<C;A++)L[r][A]=zingchart.csvParser.call(this,L[r][A],r,A,i.C.A.K);var M=0;for(l=0,o=L.length;l<o;l++)M=ZC.BQ(M,L[l].length);var H=[];if(null===ZC._n_(d)){var P=L[X].join("").length;d=L[X].join("").replace(/[0-9]/g,"").length/P>.75}d&&(H=L[X],X++);var N=[];if(null===ZC._n_(f))if(d&&-1!==H[0].indexOf("\\"))f=!0;else{var S="";for(r=X,s=L.length;r<s;r++)S+=L[r][0];var O=S.length;f=S.replace(/[0-9]/g,"").length/O>.75}if(f){for(r=X,s=L.length;r<s;r++)v?N.push(ZC._i_(L[r][Y])):N.push(L[r][Y]);Y++}var G=[],k=[];for(A=Y;A<M;A++){k[A-Y]=[];var T=E,z=D,Q=0,J=null;for(r=X,s=L.length;r<s;r++)if(null!==ZC._n_(L[r][A])&&""!==L[r][A]&&"undefined"!=typeof L[r][A]){if(a=L[r][A],null!==ZC._n_(J)||b||(J=a.replace(/[0-9\-\,\.\+\e]+/g,"%v")),b||(a=a.replace(/[^0-9\-\,\.\+\e]+/g,"")),null===T||null===z){var V=a.indexOf("."),R=a.indexOf(",");-1!==V&&-1!==R?V<R?(T=".",z=",",Q=ZC.BQ(0,a.length-R)):(T=",",z=".",Q=ZC.BQ(0,a.length-V)):-1===V&&-1!==R?a.length-R-1==3?(T=",",z="."):(T=".",z=",",Q=ZC.BQ(0,a.length-R)):-1!==V&&-1===R&&(a.length-V-1==3?(T=".",z=","):(T=",",z=".",Q=ZC.BQ(0,a.length-V)))}"."===T&&(a=a.replace(/\./g,"").replace(/,/g,".")),","===T&&(a=a.replace(/,/g,"")),k[A-Y].push(b?a:ZC._f_(a))}else k[A-Y].push(null);G[A-Y]={},null!==ZC._n_(J)&&(G[A-Y].format=J),null!==ZC._n_(T)&&(G[A-Y]["thousands-separator"]=T),null!==ZC._n_(T)&&(G[A-Y]["decimals-separator"]=z),0!==Q&&(G[A-Y].decimals=Q)}if(v)for(l=0,o=k.length;l<o;l++)for(var W=0;W<k[l].length;W++)k[l][W]=[N[W],k[l][W]];var U=[];switch(i.C.AF){case"line":case"area":case"vbar":case"hbar":case"line3d":case"area3d":case"vbar3d":case"hbar3d":case"mixed":null===ZC._n_(i.o["scale-x"])&&(i.o["scale-x"]={});var j=[];f&&null!==ZC._n_(H[0])&&(j=H[0].split(/\\/)),null!==ZC._n_(j[0])&&(null===ZC._n_(i.o["scale-x"].label)&&(i.o["scale-x"].label={}),null===ZC._n_(i.o["scale-x"].label.text)&&(i.o["scale-x"].label.text=j[0])),f&&(null===ZC._n_(i.o["scale-x"].values)?i.o["scale-x"].values=N:null===ZC._n_(i.o["scale-x"].labels)&&(i.o["scale-x"].labels=N));var q=[];if(null!==ZC._n_(g)&&g)for(l=0,o=k.length;l<o;l++)q[l]="scale-y"+(0===l?"":"-"+(l+1));else if(null!==ZC._n_(_)&&_){var $={},ee=0,ie=[];for(l=0,o=k.length;l<o;l++){for(var te=0,ne=0,ae=k[l].length;ne<ae;ne++)te+=k[l][ne];te/=k[l].length;var le=Math.round(ZC.G6(te)/Math.LN10/2);null===ZC._n_($[le])&&($[le]="scale-y"+(0===ee?"":"-"+(ee+1))),-1===ZC.AV(ie,G[l].format)?(q[l]="scale-y"+(0===ee?"":"-"+(ee+1)),ee++):(q[l]=$[le],ee++),ie.push(G[l].format)}}for(0===q.length&&(q[0]="scale-y"),null===ZC._n_(i.o.series)&&(i.o.series=[]),l=0,o=k.length;l<o;l++)null===ZC._n_(i.o.series[l])&&(i.o.series[l]={}),i.o.series[l].values=k[l],d&&(null===ZC._n_(i.o.series[l].text)&&(i.o.series[l].text=H[l+Y],U.push(H[l+Y])),null===ZC._n_(i.o.series[l]["legend-text"])&&(i.o.series[l]["legend-text"]=H[l+Y],U.push(H[l+Y])),null===ZC._n_(i.o.series[l]["tooltip-text"])&&null!==ZC._n_(G[l].format)&&(i.o.series[l]["tooltip-text"]=G[l].format)),null!==ZC._n_(q[l])&&(null===ZC._n_(i.o[q[l]])&&(i.o[q[l]]={}),null!==ZC._n_(j[1])&&(null===ZC._n_(i.o[q[l]].label)&&(i.o[q[l]].label={}),null===ZC._n_(i.o[q[l]].label.text)&&(i.o[q[l]].label.text=j[1])),null===ZC._n_(i.o.series[l].scales)&&(i.o.series[l].scales="scale-x,"+q[l]),null===ZC._n_(i.o[q[l]].decimals)&&null!==ZC._n_(G[l].decimals)&&(i.o[q[l]].decimals=G[l].decimals),null===ZC._n_(i.o[q[l]]["thousands-separator"])&&null!==ZC._n_(G[l]["thousands-separator"])&&(i.o[q[l]]["thousands-separator"]=G[l]["thousands-separator"]),null===ZC._n_(i.o[q[l]]["decimals-separator"])&&null!==ZC._n_(G[l]["decimals-separator"])&&(i.o[q[l]]["decimals-separator"]=G[l]["decimals-separator"]),null===ZC._n_(i.o[q[l]].format)&&null!==ZC._n_(G[l].format)&&(i.o[q[l]].format=G[l].format));break;case"pie":case"pie3d":case"gauge":case"nestedpie":if(null===ZC._n_(i.o.scale)&&(i.o.scale={}),f&&null!==ZC._n_(H[0])){var oe=H[0].split(/\\/);null===ZC._n_(i.o.scale.label)&&(i.o.scale.label={}),null===ZC._n_(i.o.scale.label.text)&&(i.o.scale.label.text=oe[0])}for(f&&(null===ZC._n_(i.o.scale.values)?i.o.scale.values=N:null===ZC._n_(i.o.scale.labels)&&(i.o.scale.labels=N)),null===ZC._n_(i.o.series)&&(i.o.series=[]),l=0,o=k.length;l<o;l++)null===ZC._n_(i.o.series[l])&&(i.o.series[l]={}),i.o.series[l].values=k[l],d&&(null===ZC._n_(i.o.series[l].text)&&(i.o.series[l].text=H[l+Y],U.push(H[l+Y])),null===ZC._n_(i.o.series[l]["legend-text"])&&(i.o.series[l]["legend-text"]=H[l+Y],U.push(H[l+Y])),null===ZC._n_(i.o.series[l]["tooltip-text"])&&null!==ZC._n_(G[l].format)&&(i.o.series[l]["tooltip-text"]=G[l].format)),null===ZC._n_(i.o["scale-v"])&&(i.o["scale-v"]={}),null===ZC._n_(i.o["scale-v"].decimals)&&null!==ZC._n_(G[l].decimals)&&(i.o["scale-v"].decimals=G[l].decimals),null===ZC._n_(i.o["scale-v"]["thousands-separator"])&&null!==ZC._n_(G[l]["thousands-separator"])&&(i.o["scale-v"]["thousands-separator"]=G[l]["thousands-separator"]),null===ZC._n_(i.o["scale-v"]["decimals-separator"])&&null!==ZC._n_(G[l]["decimals-separator"])&&(i.o["scale-v"]["decimals-separator"]=G[l]["decimals-separator"]),null===ZC._n_(i.o["scale-v"].format)&&null!==ZC._n_(G[l].format)&&(i.o["scale-v"].format=G[l].format)}return""!==U.join("")&&null===ZC._n_(i.o.legend)&&(i.o.legend={}),i.o=JSON.parse(JSON.stringify(i.o).replace(/\\\\/g,"\\")),i.o}};ZC.A2M=ZC.C9.CA(A2M),ZC.JH=ZC.HL.CA({$i:function(e){this.b(e);var i=this;i.OA="zcgraph",i.H=e,i.AF="",i.IQ=null,i.OZ="",i.K1=null,i.MU=null,i.S5=null,i.P=null,i.B9=null,i.HS=null,i.HQ=null,i.A5U=1,i.VF=1,i.A50=1,i.L=0,i.HP=null,i.MD=[1,0],i.A9Q=null,i.CC=!1,i.KR="normal",i.BO=[],i.BX=[],i.YC=[],i.FH=[],i.LH=[],i.AY=new ZC.LK(i),i.H1=null,i.BD=null,i.A7=null,i.CX=null,i.HB=null,i.A1Q="always",i.ABO=!0,i.ME="",i.RI=null,i.LL=!1,i.UN=!1,i.ND=0,i.YK=!1,i.Q4=!1,i.EZ={true3d:1,angle:45,depth:40,"x-angle":0,"y-angle":0,"z-angle":0,zoom:1},i.AJ={"enable-guide":!1,"enable-preview":!1,"enable-scroll":!1,"enable-zooming":!0,"3d":!1,clip:!1,layout:"","enable-animation":!0,"angle-min":15,"angle-max":75,"x-angle-min":-65,"x-angle-max":65,"y-angle-min":-65,"y-angle-max":65,"z-angle-min":-65,"z-angle-max":65},i.OF=!1,i.A17=!1,i.AA2=[],i.A1J=!0,"undefined"!=typeof ZC.PH&&(i.LZ=new ZC.PH(i)),i.GD=!1,i.CB={},i.IX=[],i.KI=!1,i.HH=!1,i.L3=0,i.BP=[],i.A4C=!0,i.UB=zingchart.DEV.STACKINGLOGIC,-1===i.UB&&(i.UB=0)},a11y:function(){if(this.A.bA11y){return ZC.Q.FW("rect","","")+'class="zc-graph-descriptor" tabindex="0" aria-label="Chart '+(this.L+1)+" of "+this.A.AG.length+", "+({vbar:"column",vbar3d:"3d column",hbar:"bar",hbar3d:"3d bar",line3d:"3d line",area3d:"3d area",pie3d:"3d pie"}[this.AF]||this.AF)+" chart. "+(this.IQ?this.IQ.AM:"Untitled")+". "+(this.K1?this.K1.AM:"")+". "+this.OZ+'" id="'+this.K+'--graph" coords="0,0,0,0" data-z-sort="-200" />'}return""},getPMap:function(){var e=this.b();return this.addPMap(e,"index","L"),e},getToggleAction:function(){var e,i=this,t="hide";return i.BD&&""!==i.E["legend-last-trigger"]&&"undefined"!=typeof i.E["legend-last-trigger"]?t="item"===i.E["legend-last-trigger"]?i.BD.R0:i.BD.PO:(i.o.legend&&(e=i.o.legend["toggle-action"])&&(t=e),i.o.legend&&i.o.legend.item&&(e=i.o.legend.item["toggle-action"])&&(t=e)),(i.A.K9||i.E["toggle-action-remove"])&&(t="remove"),t},BU:function(e,i){void 0===i&&(i=!1);for(var t=[],n=this,a=0,l=n.BO.length;a<l;a++)n.BO[a].AF===e&&(!i||i&&n.BO[a].V.length>0)&&t.push(n.BO[a]);return t},BM:function(e){for(var i=this,t=0,n=i.BO.length;t<n;t++)if(i.BO[t].BE===e)return i.BO[t];return null},A2P:function(e){return e},ACH:function(e){return new ZC.A2M(this,e)},ACN:function(){for(var e=this,i=0,t=e.BO.length;i<t;i++){var n=e.BO[i],a=n.BE;e.A.B8.load(n.o,["("+e.AF+").SCALE","("+e.AF+")."+a.replace(/\-[0-9]+/,""),"("+e.AF+")."+a.replace(/\-[0-9]+/,"-n"),"("+e.AF+")."+a],!1,!0);var l=a.replace(/\-[0-9]+/,"")+"-n";e.o[l]&&n.append(e.o[l]),e.o[a]&&n.append(e.o[a]),e.AJ["3d"]&&e.A.B8.load(n.o,["("+e.AF+").SCALE[3d]","("+e.AF+")."+a.replace(/\-[0-9]+/,"")+"[3d]","("+e.AF+")."+a.replace(/\-[0-9]+/,"-n")+"[3d]","("+e.AF+")."+a+"[3d]"],!1,!0),e.AJ["3d"]&&n.append(e.o[a+"[3d]"]),n.parse()}},ABG:function(){return null},A9M:function(e){var i,t,n,a=this,l=0,o=a.AY.A5.length;for(i=0;i<o;i++)l=ZC.BQ(l,a.AY.A5[i].S.length);function r(e){return e=(e=(e=e.replace(/(%N|%node-count)/g,l)).replace(/(%P|%plot-count)/g,o)).replace(/(%S|%scale-values-count)/g,n.V.length)}for(i=0,t=a.BO.length;i<t;i++)(n=a.BO[i]).A9T(e),2===e&&(n.J2=r,n.DE()&&n.parse()),null===ZC._n_(n.o["max-items"])&&null===ZC._n_(n.o["max-labels"])&&n.A7U(),null===ZC._n_(n.o["max-ticks"])&&n.AC9()},UU:function(){},NX:function(){},ADE:function(){},AC1:function(){},setupPlotArea:function(){var e=this,i=e.A.B8,t="("+e.AF+")";e.P=new ZC.HL(e),e.P.OB="plotarea",e.P.K=e.K+"-plotarea";var n=[t+".plotarea"];if(e.B9&&("xy"===e.AJ.layout?n.push(t+".plotarea[preview]"):n.push(t+".plotarea[preview[yx]]")),e.AJ["3d"]&&n.push(t+".plotarea[3d]"),i.load(e.P.o,n),e.P.append(e.o.chart),e.P.append(e.o.plotarea),e.B9&&e.P.append(e.o["plotarea[preview]"]),e.AJ["3d"]&&e.P.append(e.o["plotarea[3d]"]),"dynamic"===e.P.o["margin-top"]||"dynamic"===e.P.o["margin-right"]||"dynamic"===e.P.o["margin-bottom"]||"dynamic"===e.P.o["margin-left"]){var a=String(e.P.o.margin||"").split(/\s+|;|,/),l=a.length>0?a[0]:"",o=a.length>1?a[1]:"",r=a.length>0?a[2]||a[0]:"",s=a.length>1?a[3]||a[1]:"";"dynamic"===e.P.o["margin-top"]&&(l="dynamic"),"dynamic"===e.P.o["margin-right"]&&(o="dynamic"),"dynamic"===e.P.o["margin-bottom"]&&(r="dynamic"),"dynamic"===e.P.o["margin-left"]&&(s="dynamic"),e.P.o.margin=[l,o,r,s].join(" ")}if(e.E["plotarea-margins"]?e.P.o.margin=e.E["plotarea-margin"]:(e.E["plotarea-margins"]=!0,e.E["plotarea-margin"]=e.P.o.margin,e.E["plotarea-margin-top"]=e.P.o["margin-top"],e.E["plotarea-margin-right"]=e.P.o["margin-right"],e.E["plotarea-margin-bottom"]=e.P.o["margin-bottom"],e.E["plotarea-margin-left"]=e.P.o["margin-left"]),"undefined"!=typeof e.E["plotarea-p-x"]&&(e.P.E["p-x"]=e.E["plotarea-p-x"],e.P.E["p-y"]=e.E["plotarea-p-y"],e.P.E["p-width"]=e.E["plotarea-p-width"],e.P.E["p-height"]=e.E["plotarea-p-height"]),null!==ZC._n_(e.P.o["adjust-layout"])&&ZC._b_(e.P.o["adjust-layout"])&&(e.P.o.margin="dynamic"),e.P.parse(),e.AJ["3d"]&&!e.EZ.true3d){var A=ZC._a_(ZC._i_(e.EZ.depth*ZC.EO(e.EZ.angle)));e.P.iY+=A,e.P.F-=A,e.P.I-=ZC._i_(e.EZ.depth*ZC.EH(e.EZ.angle))}if("undefined"!=typeof e.E["plotarea-p-x"])for(var C=0,c=e.BO.length;C<c;C++)e.BO[C].A51(),e.BO[C].IZ()},setupDynamicPlotArea:function(){var e,i,t,n=this,a=["top","right","bottom","left"],l={};for(i=0;i<a.length;i++)l[a[i]]=!1,n.E["plotarea.d-margin-"+a[i]]&&(n.o.plotarea["margin-"+a[i]]=null),n.o.plotarea&&"dynamic"===n.o.plotarea["margin-"+a[i]]&&(l[a[i]]=!0,n.o.plotarea["margin-"+a[i]]="20");var o=!1,r={};if("xy"===n.AJ.layout&&(o=!0),("xy"===n.AJ.layout||"yx"===n.AJ.layout)&&(n.P.E["d-margin"]||n.E["plotarea.d-margin"])){for(var s=0,A=n.BO.length;s<A;s++){var C=0,c=0,u="",p=n.BO[s];if(p.AN&&p.T9){"k"===p.AF?u=p.CO?"default"===p.BA?"left":"right":"default"===p.BA?"bottom":"top":"v"===p.AF&&(u=p.CO?"default"===p.BA?"bottom":"top":"default"===p.BA?"left":"right");var Z=0;if(n.P.E["d-margin-"+u]||n.E["plotarea.d-margin-"+u]){var h=new ZC.DN(p);h.copy(p.BR);var d=ZC.BQ(1,ZC._i_((p.A1-p.W)/p.EG));for(i=p.W;i<=p.A1;i+=d)if(h.AM=p.FQ(i),h.A29&&("k"===p.AF&&!p.CO||"v"===p.AF&&p.CO)&&(h.o.width=ZC._i_(.9*p.AA)),h.parse(),h.AN)if(c=ZC.BQ(c,h.A9%180==0?h.F:h.I),C=ZC.BQ(C,h.A9%180==0?h.I:h.F),Z=ZC.BQ(Z,1.5*h.DI*(h.AM||"").split(/<br>|<br\/>|<br \/>|\n/).length),"top"===u||"bottom"===u){if(Z=ZC.BQ(Z,.465*h.DI+1.025*ZC._a_(ZC.EO(h.A9))*ZC.BQ(h.I,h.F)),C=h.I,c=Z,o&&"k"===p.AF){r[p.BE]||(r[p.BE]=[]);var f=null===ZC._n_(h.o["auto-align"])||ZC._b_(h.o["auto-align"]),_=.465*h.DI+1.025*ZC._a_(ZC.EH(h.A9))*ZC.BQ(h.I,h.F);"default"===p.BA?(f&&(ZC.DS(ZC._ang_(h.A9),90,180)||ZC.DS(ZC._ang_(h.A9),270,360))&&r[p.BE].push(_),f||r[p.BE].push(_/2)):(f&&(ZC.DS(ZC._ang_(h.A9),0,90)||ZC.DS(ZC._ang_(h.A9),180,270))&&r[p.BE].push(_),f||r[p.BE].push(_/2))}}else C=Z=ZC.BQ(Z,.465*h.DI+1.025*ZC._a_(ZC.EH(h.A9))*ZC.BQ(h.I,h.F)),c=h.F;var g=new ZC.DN(p);g.copy(p.M),g.AM=p.M.AM,g.parse(),""!==g.AM&&g.AN&&(c+=g.A9%180==0?g.F:g.I,C+=g.A9%180==0?g.I:g.F)}if(n.o.plotarea||(n.o.plotarea={}),("dynamic"===n.o.plotarea["margin-"+u]||n.P.E["d-margin-"+u])&&(n.P.E["d-margin-"+u]=!1,l[u]=!0,n.o.plotarea["margin-"+u]="0"),l[u]){n.o.plotarea["margin-"+u]=ZC._f_(n.o.plotarea["margin-"+u]||"0"),n.E[p.BE+"-distance"]=n.o.plotarea["margin-"+u];var v=("top"===u||"bottom"===u?ZC._i_(c):ZC._i_(C))+10+(n.AJ["3d"]?20:0);if(p.VB?n.o.plotarea["margin-"+u]=ZC.BQ(n.o.plotarea["margin-"+u],v):n.o.plotarea["margin-"+u]+=v,null!==ZC._n_(n.o.plotarea["margin-"+u+"-offset"])&&(n.o.plotarea["margin-"+u]+=ZC._i_(n.o.plotarea["margin-"+u+"-offset"])),!n.A.TM){var b={},B=n.A.DG.watermark;n.A.B8.load(b,"loader.gui.watermark"),B&&ZC._cp_(B,b),1===n.A.o.graphset.length&&n.A.o.graphset[0].gui&&(e=n.A.o.graphset[0].gui.watermark)&&ZC._cp_(e,b);var m=b.position||"br";-1===ZC.AV(["tl","tr","br","bl"],m)&&(m="br"),("bottom"!==u||"bl"!==m&&"br"!==m)&&("top"!==u||"tl"!==m&&"tr"!==m)||(n.o.plotarea["margin-"+u]+=15)}"bottom"===u&&("xy"===n.AJ.layout&&n.HS||"yx"===n.AJ.layout&&n.HQ)&&(n.o.plotarea["margin-"+u]+=15),"left"===u&&("xy"===n.AJ.layout&&n.HQ||"yx"===n.AJ.layout&&n.HS)&&(n.o.plotarea["margin-"+u]+=15),n.E["plotarea.d-margin-"+u]=!0}}}if(o&&l.left&&null!==ZC._n_(n.o.plotarea["margin-left"]))for(var E in r){var D=n.BM(E);for(i=0;i<r[E].length;i++){ZC._i_(n.o.plotarea["margin-left"])+i*D.AA+(D.DF?D.AA/2:0)-r[E][i]<0&&(n.o.plotarea["margin-left"]=r[E][i]-i*D.AA-(D.DF?D.AA/2:0))}}ZC.Q.IV(ZC.AL(n.K+"-plotarea-c"),n.H.AB,n.P.iX,n.P.iY,n.P.I,n.P.F,n.K),n.E["plotarea.paint"]=!0,n.setupPlotArea();var F=2,K=6;null!==ZC._n_(e=n.P.o["mask-tolerance"])&&(e instanceof Array?(F=K=ZC._i_(e[0]),e.length>1&&(K=ZC._i_(e[1]))):F=K=ZC._i_(e)),n.P.E.tolerance=F,"svg"===n.H.AB?((e=ZC.AL(n.K+"-clip-shape"))&&e.setAttribute("points",n.M7(F,"svg")),(e=ZC.AL(n.K+"-clip-hover-shape"))&&e.setAttribute("points",n.M7(K,"svg"))):(ZC.A4("#"+n.K+" div").each(function(){""!==this.style.clip&&(this.style.clip=n.M7(F))}),(e=ZC.AL(n.K+"-hover"))&&""!==e.style.clip&&(e.style.clip=n.M7(K)))}for(i=0,t=n.BO.length;i<t;i++)n.BO[i].A51(),n.BO[i].IZ()},parse:function(){var e,i,t,n,a,l,o,r,s,A=this,C=A.A.B8,c="("+A.AF+")";(e=A.A.E["graph-state-"+A.L])&&(A.E=JSON.parse(e),null===ZC._n_(A.E["guide-on"])||ZC._b_(A.E["guide-on"])||(A.A1J=!1)),A.E.legend_toggle_action||(A.A.E["graph-"+A.K+"-legend-info"]=null),A.E.legend_toggle_action=null,A.ME="parse.init",A.b(),A.ADE(),-1!==JSON.stringify(A.o).indexOf("zingchart.maps")&&(A.o.plotarea=A.o.plotarea||{},A.o.plotarea.margin=0);var u=null;if(!zingchart.SKIP.CSV&&((e=A.o["html5-csv"])&&(A.RI=e["html5-url"]),(e=A.o.csv)&&("object"==typeof e?e.url?A.RI=e.url:e["data-string"]&&(u=e["data-string"]):A.RI=e),""!==A.RI&&null!==ZC._n_(A.A.A9V[A.RI])&&(u=A.A.A9V[A.RI]),A.H.O0&&(u=A.H.O0),u)){var p=A.ACH(u);A.o=p.parse()}if(A.LL=zingchart.ASYNC,A.assign_a([["utc","UN","b"],["timezone","ND","f"],["async","LL","b"],["stacked","CC","b"],["stack-type","KR"],["animate-type","A1Q"],["url-data","A9Q"],["page","L3","i"],["palette","BP"],["sort-objects","A4C","b"],["description","OZ"]]),A.BP.length>0)for(C.B8.palette=[],n=0;n<A.BP.length;n++){var Z=A.BP[n],h=ZC.AP.JK(A.BP[n],10),d=ZC.AP.QR(A.BP[n],10);C.B8.palette.push(["#fff",Z,h,d])}"pie3d"===A.AF&&(A.EZ.true3d=!0),(A.AJ["3d"]||A.A.A19)&&(A.LL=!1),A.AC1(),-1===ZC.AV(A.H.KQ,"skip_interactivity")&&((null!==ZC._n_(e=A.o.preview)||C.PL("preview",A.AF))&&A.AJ["enable-preview"]&&(A.B9&&!A.E["force-preview-parse"]||"undefined"==typeof ZC.A2D||(A.E["force-preview-parse"]=!1,A.B9=new ZC.A2D(A),A.B9.OB="preview",C.load(A.B9.o,c+".preview"),"yx"===A.AJ.layout&&C.load(A.B9.o,c+".preview[yx]"),(i=A.o.plotarea)&&A.B9.append({"background-color":i["background-color"],"background-color-1":i["background-color-1"],"background-color-2":i["background-color-2"],"gradient-stops":i["gradient-stops"],"gradient-colors":i["gradient-colors"]}),A.B9.append(e),A.B9.parse())),(null!==ZC._n_(e=A.o["scroll-x"])||C.PL("scroll-x",A.AF))&&A.AJ["enable-scroll"]&&(A.HS||"undefined"==typeof ZC.ZF||(A.HS=new ZC.ZF(A,"x"),A.HS.OB="scrollx",C.load(A.HS.o,c+".scroll-x"),A.HS.append(e),A.HS.parse())),(null!==ZC._n_(e=A.o["scroll-y"])||C.PL("scroll-y",A.AF))&&A.AJ["enable-scroll"]&&(A.HQ||"undefined"==typeof ZC.ZF||(A.HQ=new ZC.ZF(A,"y"),A.HQ.OB="scrolly",C.load(A.HQ.o,c+".scroll-y"),A.HQ.append(e),A.HQ.parse()))),A.setupPlotArea(),A.NX(),A.BO=[],A.ACN(),A.A9M(1),null!==ZC._n_(e=A.o.series)&&(A.AY.o=e);var f=A.AY.o;for(n=0;n<f.length;n++)if(f[n].rel)for(s=0;s<f.length;s++)f[s].id&&f[s].id===f[n].rel&&(A.AY.o[n].values=[].concat(A.AY.o[s].values));if(A.AY.parse(),A.A9M(2),(null!==ZC._n_(e=A.o.title)||C.PL("title",A.AF))&&(A.IQ=new ZC.DN(A),A.IQ.OB="title",C.load(A.IQ.o,c+".title"),A.IQ.append(e),A.IQ.K=A.K+"-title",A.IQ.K9=!0,A.IQ.parse(),null===ZC._n_(A.IQ.o.x))){var _=A.iX,g=A.I;switch("plotarea"===A.IQ.o["center-point"]&&(_=A.P.iX,g=A.P.I),A.IQ.OD){case"left":A.IQ.iX=_;break;case"center":A.IQ.iX=_+g/2-A.IQ.I/2;break;case"right":A.IQ.iX=_+g-A.IQ.I}}(null!==ZC._n_(e=A.o.subtitle)||C.PL("subtitle",A.AF))&&(A.K1=new ZC.DN(A),A.K1.OB="subtitle",C.load(A.K1.o,c+".subtitle"),A.K1.append(e),A.K1.K=A.K+"-subtitle",A.K1.parse()),null!==ZC._n_(e=A.o.source)&&(A.MU=new ZC.DN(A),A.MU.OB="source",C.load(A.MU.o,c+".source"),A.MU.append(e),A.MU.K=A.K+"-source",A.MU.parse()),"undefined"!=typeof ZC.V6&&(null!==ZC._n_(e=A.o.legend)||C.PL("legend",A.AF))&&(A.BD=new ZC.V6(A),A.BD.K=A.K+"-legend","undefined"!=typeof e.alpha&&e.alpha<.1&&"undefined"==typeof e["border-width"]&&"undefined"==typeof e["border-alpha"]&&(e["border-alpha"]=e.alpha),C.load(A.BD.o,c+".legend"),A.BD.alignPosition(e),(null!==ZC._n_(e)&&null!==ZC._n_(e.position)||null!==ZC._n_(A.BD.o.position))&&C.load(A.BD.o,c+".legend[position]"),A.BD.append(e),ZC._b_(A.BD.o.shared)&&(A.BD.E["p-x"]=A.A.iX,A.BD.E["p-y"]=A.A.iY,A.BD.E["p-width"]=A.A.I,A.BD.E["p-height"]=A.A.F),A.BD.alignPosition(e),A.BD.parse());var v=!1,b=A.iX,B=A.iY,m=A.I,E=A.F,D="";if(A.IQ&&A.IQ.AN&&A.IQ.o["adjust-layout"]&&(v=!0,(t=A.IQ.iY+A.IQ.F/2)<B+E/2&&(D="top",E=B+E-A.IQ.F-A.IQ.iY,B=A.IQ.iY+A.IQ.F,A.K1&&A.K1.o["adjust-layout"]))){var F=A.K1.iY+A.K1.F/2;F<B+E/2&&F>t&&(E-=A.K1.F,B+=A.K1.F)}if(A.MU&&A.MU.AN&&A.MU.o["adjust-layout"]&&(v=!0,(t=A.MU.iY+A.MU.F/2)>B+E/2&&(E-=A.MU.F)),A.B9&&A.B9.AN&&A.B9.o["adjust-layout"]&&(v=!0,"xy"===A.AJ.layout?(t=A.B9.AQ.iY+A.B9.AQ.F/2)>B+E/2?E-=A.B9.AQ.F+A.B9.AQ.DR:(B=A.B9.AQ.iY+A.B9.AQ.F,E-=A.B9.AQ.F):(_=A.B9.AQ.iX+A.B9.AQ.I/2)<b+m/2?(m-=A.B9.AQ.I+A.B9.AQ.DY,b+=A.B9.AQ.I+A.B9.AQ.DY):(b=A.B9.AQ.iX+A.B9.AQ.I,m-=A.B9.AQ.I)),A.BD&&A.BD.AN&&A.BD.o["adjust-layout"]){v=!0;var K=A.BD.D4&&A.BD.D4.enabled?15:5;if("top"===D&&A.BD.iY<A.IQ.iY+A.IQ.F+5){if(null!==ZC._n_(A.BD.o.position)){var x=(""+A.BD.o.position).split(" ");A.BD.o.position=x[0]+" "+(A.IQ.iY-A.iY+A.IQ.F+A.BD.MB+K)}else A.BD.o["margin-top"]=A.IQ.iY-A.iY+A.IQ.F+A.BD.MB;A.BD.parse()}A.BD.fixPlacement(),t=A.BD.iY+A.BD.F/2;var I="",y=(ZC.MAX,A.BD.E["position-info"]),w={Bottom:A.BD.iY-A.iY,Top:A.iY+A.F-A.BD.iY-A.BD.F,Right:A.BD.iX-A.iX,Left:A.iX+A.I-A.BD.iX-A.BD.I},L="";if(A.BD.I/A.BD.F>2)L="v";else if(A.BD.F/A.BD.I>2)L="h";else{L=Math.max(w.Left*A.F,w.Right*A.F)/Math.max(w.Top*A.I,w.Bottom*A.I)>1?"h":"v"}if(y)y[0]>=.8?I=y[1]<=.2?"v"===L?"top":"right":y[1]>=.8&&"v"===L?"bottom":"right":y[0]<=.2?I=y[1]<=.2?"v"===L?"top":"left":y[1]>=.8&&"v"===L?"bottom":"left":y[1]<=.2?I="top":y[1]>=.8&&(I="bottom");else Math.min(w.Top,w.Bottom)/Math.max(w.Top,w.Bottom)<Math.min(w.Left,w.Right)/Math.max(w.Left,w.Right)?w.Top>w.Bottom?(I="top",A.BD.E8):(I="bottom",A.BD.DR):w.Left>w.Right?(I="left",A.BD.DY):(I="right",A.BD.E9);var X=0;"top"===I&&(E=B+E-A.BD.F-A.BD.iY,B=A.BD.iY+A.BD.F),"bottom"===I&&(E-=X=E-A.BD.iY+B+A.BD.FM+A.BD.FT),"left"===I&&(b+=X=A.BD.iX-A.iX+A.BD.I,m-=X),"right"===I&&(m-=X=m-(A.BD.iX-A.iX)+A.BD.EQ+A.BD.FN)}else A.BD&&A.BD.fixPlacement();v&&(A.E["plotarea-p-x"]=b,A.E["plotarea-p-y"]=B,A.E["plotarea-p-width"]=m,A.E["plotarea-p-height"]=E,A.setupPlotArea()),A.setupDynamicPlotArea(),A.AY.parseLayout&&A.AY.parseLayout(!0),A.B9&&A.B9.o["adjust-layout"]&&("xy"===A.AJ.layout?(null===ZC._n_(A.B9.JB.x)&&(A.B9.AQ.iX=A.P.iX),null===ZC._n_(A.B9.JB.width)&&(A.B9.AQ.I=A.P.I)):(null===ZC._n_(A.B9.JB.y)&&(A.B9.AQ.iY=A.P.iY),null===ZC._n_(A.B9.JB.height)&&(A.B9.AQ.F=A.P.F)));var Y=0;for(n=0;n<A.AY.A5.length;n++)Y+=A.AY.A5[n].S.length;null!==ZC._n_(e=A.o["no-data"])&&0===Y?(A.S5=new ZC.DN(A),A.S5.OB="nodata",C.load(A.S5.o,c+".noData"),A.S5.append({x:A.P.iX,y:A.P.iY,width:A.P.I,height:A.P.F}),A.S5.append(e),A.S5.K=A.K+"-nodata",A.S5.parse()):A.S5=null,A.E["plotarea-margins"]&&(A.E["plotarea-margins"]=null,A.o.plotarea=A.o.plotarea||{},A.o.plotarea.margin=A.E["plotarea-margin"],A.o.plotarea["margin-top"]=A.E["plotarea-margin-top"],A.o.plotarea["margin-right"]=A.E["plotarea-margin-right"],A.o.plotarea["margin-bottom"]=A.E["plotarea-margin-bottom"],A.o.plotarea["margin-left"]=A.E["plotarea-margin-left"]);var M=["top","right","bottom","left"];for(n=0;n<M.length;n++)A.E["plotarea.d-margin-"+M[n]]=null;if(ZC.Q.EU(A.A.K+"-tooltip"),"undefined"!=typeof A.E.datalength&&null!==ZC._n_(A.E.datalength)&&A.E.datalength.length>0&&"canvas"!==A.H.AB&&A.AY.A5)for(var H=0,P=A.AY.A5.length;H<P;H++){if(A.AY.A5[H].S.length<A.E.datalength[H])for(o=A.AY.A5[H].S.length,r=A.E.datalength[H];o<r;o++)l=A.K+"-plotset-plot-"+H+"-node-"+o,ZC.Q.EU([l+"-path",l+"-area-path",l+"-sh-path"]),-1!==ZC.AV(["scatter","bubble"],A.AF)&&ZC.Q.EU([l+"-marker-gradient",l+"-marker-path",l+"-marker-sh-path",l+"-marker-circle",l+"-marker-sh-circle"]),A.EN[H+"-"+o]=null;if(-1===ZC.AV(["scatter","bubble"],A.AF)||ZC.A4.browser.webkit)for(o=0,r=A.E.datalength[H];o<r;o++)l=A.K+"-plotset-plot-"+H+"-node-"+o,ZC.Q.EU([l+"-marker-gradient",l+"-marker-path",l+"-marker-sh-path",l+"-marker-circle",l+"-marker-sh-circle"])}for(A.E.datalength=null,n=0,a=A.AY.A5.length;n<a;n++)A.GD=A.GD||A.AY.A5[n].GD;(A.HH||"undefined"==typeof ZC.PH)&&(A.GD=!1),A.GD&&(A.LZ.onStop=function(){A.ME="ready"}),-1===ZC.AV(A.H.KQ,"skip_interactivity")&&(A.H1=new ZC.HL(A),A.H1.K=A.K+"-zoom",C.load(A.H1.o,c+".zoom"),A.H1.append(A.o.zoom),A.A7=new ZC.DN(A),A.A7.OB="tooltip",A.o.tooltip&&A.o.tooltip.placement&&A.o.tooltip.placement.indexOf("node")>-1?C.load(A.A7.o,c+".tooltip[dynamic]"):C.load(A.A7.o,c+".tooltip"),A.A7.append(A.o.tooltip),A.A7.PU=!0,A.A7.parse(),null!==ZC._n_(e=A.o.guide)&&(A.o["crosshair-x"]=e),(null!==ZC._n_(e=A.o["crosshair-x"])||C.PL("guide",A.AF)||C.PL("crosshair-x",A.AF))&&A.AJ["enable-guide"]&&(A.CX=new ZC.D0(A),A.CX.OB="crosshairx",C.load(A.CX.o,[c+".guide",c+".crosshair-x"],!0,!0),A.CX.append(e),A.CX.parse(),A.E["guide-on"]=!0),(null!==ZC._n_(e=A.o["crosshair-y"])||C.PL("crosshair-y",A.AF))&&A.AJ["enable-guide"]&&(A.HB=new ZC.D0(A),A.HB.OB="crosshairy",C.load(A.HB.o,[c+".guide",c+".crosshair-y"],!0,!0),A.HB.append(e),A.HB.parse(),A.E["guide-on"]=!0)),A.OW(),ZC.AP.BY("gparse",A.A,A.GX()),null!==ZC._n_(e=A.o.refresh)&&(A.HP={type:"full",interval:10,transport:"http",method:"pull","adjust-scale":!1,"max-ticks":20,"reset-timeout":100,"stop-timeout":0,storage:!1,"storage-size":1e3},ZC._cp_(e,A.HP),A.UB=1),A.ME="parse.complete"},OW:function(){},PW:function(){},M7:function(e,i,t){var n=this,a=(t=t||n.P).iX,l=t.iY,o=t.I,r=t.F;if("svg"===i){if(n.AJ["3d"]){var s,A=[];e=1;var C,c,u,p,Z=[],h=a-ZC.AO.E2,d=l-ZC.AO.E3;s=new ZC.CE(n,h+o/2-e,d-e,ZC.AO.FU),p=ZC._i_(s.ED[1]),s=new ZC.CE(n,h+o/2-e,d-e,0),u=ZC._i_(s.ED[1]),Z.push(new ZC.CE(n,h-e,d-e,p<u?ZC.AO.FU:0),new ZC.CE(n,h+o+e,d-e,p<u?ZC.AO.FU:0)),s=new ZC.CE(n,h+o-e,d+r/2-e,ZC.AO.FU),C=ZC._i_(s.ED[0]),s=new ZC.CE(n,h+o-e,d+r/2-e,0),c=ZC._i_(s.ED[0]),Z.push(new ZC.CE(n,h+o+e,d-e,C>c?ZC.AO.FU:0),new ZC.CE(n,h+o+e,d+r+e,C>c?ZC.AO.FU:0)),s=new ZC.CE(n,h+o/2-e,d+r+e,ZC.AO.FU),p=ZC._i_(s.ED[1]),s=new ZC.CE(n,h+o/2-e,d+r+e,0),u=ZC._i_(s.ED[1]),Z.push(new ZC.CE(n,h+o+e,d+r+e,p>u?ZC.AO.FU:0),new ZC.CE(n,h-e,d+r+e,p>u?ZC.AO.FU:0)),s=new ZC.CE(n,h-e,d+r/2-e,ZC.AO.FU),C=ZC._i_(s.ED[0]),s=new ZC.CE(n,h-e,d+r/2-e,0),c=ZC._i_(s.ED[0]),Z.push(new ZC.CE(n,h-e,d+r+e,C<c?ZC.AO.FU:0),new ZC.CE(n,h-e,d-e,C<c?ZC.AO.FU:0)),Z.push(Z[0]);for(var f=0;f<Z.length;f++)s=Z[f],A.push([ZC._i_(s.ED[0]),ZC._i_(s.ED[1])].join(","));return A.join(" ")}return[[a-e,l-e].join(","),[a+o+e,l-e].join(","),[a+o+e,l+r+e].join(","),[a-e,l+r+e].join(","),[a-e,l-e].join(",")].join(" ")}return"box"===i?a-e+","+(l-e)+","+(o+2*e)+","+(r+2*e):(n.AJ["3d"]&&(e+=10),"rect("+(l-e)+"px,"+(a+o+e)+"px,"+(l+r+e)+"px,"+(a-e)+"px)")},autoFit:function(){var e,i=this;if(i.AJ["3d"]&&i.EZ["auto-fit"]){var t=!1;for(i.EZ.zoom=1;!t&&i.EZ.zoom>.25;){t=!0;var n=i.M7(0,"svg").split(" ");for(e=0;e<n.length;e++){var a=n[e].split(",");(ZC._i_(a[0])<i.iX+i.P.DY||ZC._i_(a[0])>i.iX+i.I-i.P.E9||ZC._i_(a[1])<i.iY+i.P.E8||ZC._i_(a[1])>i.iY+i.F-i.P.DR)&&(t=!1)}t||(i.EZ.zoom-=.05),t&&(i.EZ.zoom-=.025)}}},build:function(){var e,i,t,n,a,l,o,r,s=this,A=s.A.I+"/"+s.A.F,C="0/0";if(s.autoFit(),!s.H.usc()){var c=2,u=6;if(null!==ZC._n_(e=s.P.o["mask-tolerance"])&&(e instanceof Array?(c=u=ZC._i_(e[0]),e.length>1&&(u=ZC._i_(e[1]))):c=u=ZC._i_(e)),"svg"===s.A.AB&&s.AJ.clip&&(ZC.Q.EU([s.K+"-clip",s.K+"-clip-hover",s.K+"-clip-preview"]),s.A.KD.appendChild(ZC.Q.XD({id:s.K+"-clip",path:s.M7(c,"svg")})),s.A.KD.appendChild(ZC.Q.XD({id:s.K+"-clip-hover",path:s.M7(u,"svg")})),s.B9)){var p=s.AJ["3d"];s.AJ["3d"]=!1,s.A.KD.appendChild(ZC.Q.XD({id:s.K+"-clip-preview",path:s.M7(0,"svg",s.B9.AQ)})),s.AJ["3d"]=p}var Z=!s.AJ.clip,h=Z?null:s.M7(c),d=Z?null:"url(#"+s.K+"-clip)",f=Z?null:s.M7(u),_=Z?null:"url(#"+s.K+"-clip-hover)";if(s.B9&&(a=Z?null:s.M7(0,s.A.AB,s.B9.AQ),l=Z?null:"url(#"+s.K+"-clip-preview)"),ZC.Q.JZ({cls:"zc-abs",id:s.K,p:ZC.AL(s.A.K+"-graphset"),tl:C,wh:A},s.A.AB),s.A.NR.graph&&ZC.Q.HE({cls:"zc-abs zc-layer zc-persistent",id:s.K+"-c",p:ZC.AL(s.K),wh:A},s.A.AB),ZC.Q.JZ({id:s.K+"-plotarea",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute"},s.A.AB),s.o.plotarea&&s.A.NR.plotarea&&ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-plotarea-c",p:ZC.AL(s.K+"-plotarea"),wh:A},s.A.AB),"null"!==s.AF&&s.A.NR.plots){for(ZC.Q.JZ({id:s.K+"-scales-bl",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute","clip-path":d,clip:h},s.A.AB),i=0;i<s.A5U;i++)ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-scales-bl-"+i+"-c",p:ZC.AL(s.K+"-scales-bl"),wh:A},s.A.AB);if(s.AY.E["plot-sort"]){for(i=0,t=s.AY.A5.length;i<t;i++){for(s.AY.A5[i].UD={},n=0;n<s.AY.A5[i].SW;n++)ZC.Q.EU(s.K+"-plots-bl-"+n);for(n=0;n<s.AY.A5[i].A1G;n++)ZC.Q.EU(s.K+"-plots-fl-"+n)}delete s.AY.E["plot-sort"]}if(s.A.K9||s.AJ["3d"])ZC.AL(s.K+"-plots-bl")||ZC.Q.JZ({id:s.K+"-plots-bl",p:ZC.AL(s.K),after:ZC.AL(s.K+"-scales-bl"),tl:C,wh:A,position:"absolute","clip-path":d,clip:h},s.A.AB),(o=ZC.Q.HE({cls:"zc-abs zc-layer zc-bl",id:s.K+"-plots-bl-c",p:ZC.AL(s.K+"-plots-bl"),wh:A},s.A.AB)).setAttribute("data-clip",s.M7(c,"box"));else for(i=0,t=s.AY.A5.length;i<t;i++)for(r=s.AY.M4[i],n=s.AY.A5[i].SW-1;n>=0;n--)ZC.AL(s.K+"-plots-bl-"+n)||ZC.Q.JZ({id:s.K+"-plots-bl-"+n,p:ZC.AL(s.K),after:ZC.AL(s.K+"-scales-bl"),tl:C,wh:A,position:"absolute","clip-path":d,clip:h},s.A.AB),(o=ZC.Q.HE({cls:"zc-abs zc-layer zc-bl",id:s.K+"-plot-"+r+"-bl-"+n+"-c",p:ZC.AL(s.K+"-plots-bl-"+n),wh:A},s.A.AB)).setAttribute("data-clip",s.M7(c,"box")),o.style.display="block";for(i=0;i<s.VF;i++)ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-scales-ml-"+i+"-c",p:ZC.AL(s.K),wh:A},s.A.AB);if(s.A.K9||s.AJ["3d"])ZC.AL(s.K+"-plots-fl")||ZC.Q.JZ({id:s.K+"-plots-fl",p:ZC.AL(s.K),after:ZC.AL(s.K+"-scales-ml-"+(s.VF-1)+"-c"),tl:C,wh:A,position:"absolute"},s.A.AB),(o=ZC.Q.HE({cls:"zc-abs zc-layer zc-fl",id:s.K+"-plots-fl-c",p:ZC.AL(s.K+"-plots-fl"),wh:A},s.A.AB)).setAttribute("data-clip",s.M7(u,"box"));else for(i=0,t=s.AY.A5.length;i<t;i++)for(r=s.AY.M4[i],n=s.AY.A5[i].A1G-1;n>=0;n--)ZC.AL(s.K+"-plots-fl-"+n)||ZC.Q.JZ({id:s.K+"-plots-fl-"+n,p:ZC.AL(s.K),after:ZC.AL(s.K+"-scales-ml-"+(s.VF-1)+"-c"),tl:C,wh:A,position:"absolute"},s.A.AB),(o=ZC.Q.HE({cls:"zc-abs zc-layer zc-fl",id:s.K+"-plot-"+r+"-fl-"+n+"-c",p:ZC.AL(s.K+"-plots-fl-"+n),wh:A},s.A.AB)).setAttribute("data-clip",s.M7(u,"box")),o.style.display="block";for(zingchart.DEV.PLOTSHLAYER&&(ZC.Q.JZ({id:s.K+"-plots-hover",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute"},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer zc-fl",id:s.K+"-plots-hover-c",p:ZC.AL(s.K+"-plots-hover"),wh:A},s.A.AB)),ZC.Q.JZ({id:s.K+"-scales-fl",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute","clip-path":d,clip:h},s.A.AB),i=0;i<s.A50;i++)ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-scales-fl-"+i+"-c",p:ZC.AL(s.K+"-scales-fl"),wh:A},s.A.AB);if(s.B9&&(ZC.Q.JZ({id:s.K+"-preview",p:ZC.AL(s.A.K+"-tools"),tl:C,wh:A,position:"absolute","clip-path":l,clip:a},s.A.AB),ZC.Q.HE({cls:"zc-abs",id:s.K+"-preview-c",p:ZC.AL(s.K+"-preview"),wh:A},s.A.AB)),ZC.Q.JZ({id:s.K+"-scroll",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute"},s.A.AB),s.o["scroll-x"]&&ZC.Q.HE({cls:"zc-abs",id:s.K+"-scroll-x-c",p:ZC.AL(s.K+"-scroll"),wh:A},s.A.AB),s.o["scroll-y"]&&ZC.Q.HE({cls:"zc-abs",id:s.K+"-scroll-y-c",p:ZC.AL(s.K+"-scroll"),wh:A},s.A.AB),ZC.Q.JZ({id:s.K+"-plots-vb",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute"},s.A.AB),s.A.NR["value-box"])if(s.A.K9||s.AJ["3d"])ZC.Q.HE({cls:"zc-abs zc-layer zc-vb",id:s.K+"-plots-vb-c",p:ZC.AL(s.K+"-plots-vb"),wh:A},s.A.AB);else for(i=0,t=s.AY.A5.length;i<t;i++)ZC.Q.HE({cls:"zc-abs zc-layer zc-vb",id:s.K+"-plot-"+i+"-vb-c",p:ZC.AL(s.K+"-plots-vb"),wh:A},s.A.AB)}(s.o.title||s.o.subtitle||s.o.source||s.o["no-data"])&&(ZC.Q.JZ({id:s.K+"-titles",p:ZC.AL(s.K),tl:C,wh:A,position:"absolute"},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-titles-c",p:ZC.AL(s.K+"-titles"),wh:A},s.A.AB)),ZC.Q.JZ({cls:"zc-abs",wh:A,id:s.K+"-hover",p:ZC.AL(s.A.K+"-hover"),"clip-path":_,clip:f},s.A.AB),"canvas"===s.A.AB&&(ZC.AL(s.K+"-hover").style.clip=f),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-hover-c",p:ZC.AL(s.K+"-hover"),wh:A},s.A.AB),s.A.NR.maps&&-1!==JSON.stringify(s.o).indexOf("zingchart.maps")&&(ZC.Q.JZ({cls:"zc-abs",wh:A,id:s.K+"-objects-maps",p:ZC.AL(s.A.K+"-objects-maps"),"clip-path":_,clip:f},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-objects-maps-sh-c",p:ZC.AL(s.K+"-objects-maps"),wh:A},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-objects-maps-c",p:ZC.AL(s.K+"-objects-maps"),wh:A},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-objects-maps-click-c",p:ZC.AL(s.K+"-objects-maps"),wh:A},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-objects-maps-hover-c",p:ZC.AL(s.K+"-objects-maps"),wh:A},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-objects-maps-print-c",p:ZC.AL(s.K+"-objects-maps"),wh:A,display:"none"},s.A.AB)),s.initObjectsLayers(),s.o.legend&&(ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-legend-c",p:ZC.AL(s.A.K+"-legend"),wh:A},s.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:s.K+"-legend-scroll-c",p:ZC.AL(s.A.K+"-legend"),wh:A},s.A.AB))}s.Z=s.H.usc()?s.H.mc():ZC.AL(s.K+"-c")},initObjectsLayers:function(){var e=this,i=e.A.I+"/"+e.A.F;!ZC.AL(e.K+"-objects-bottom")&&e.A.NR["objects-bottom"]&&(e.o.shapes||e.o.labels||e.o.arrows||e.o.images)&&(ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-bottom",p:ZC.AL(e.A.K+"-objects-bottom")},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-bottom-sh-c",p:ZC.AL(e.K+"-objects-bottom"),wh:i},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-bottom-c",p:ZC.AL(e.K+"-objects-bottom"),wh:i},e.A.AB)),!ZC.AL(e.K+"-objects-top")&&e.A.NR["objects-top"]&&(e.o.shapes||e.o.labels||e.o.arrows||e.o.images)&&(ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-top",p:ZC.AL(e.A.K+"-objects-top")},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-top-sh-c",p:ZC.AL(e.K+"-objects-top"),wh:i},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-top-c",p:ZC.AL(e.K+"-objects-top"),wh:i},e.A.AB)),(e.A.NR["objects-bottom"]||e.A.NR["objects-top"])&&(e.o.shapes||e.o.labels||e.o.arrows)&&ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-print-c",p:ZC.AL(e.K+"-objects-top"),wh:i,display:"none"},e.A.AB),!ZC.AL(e.K+"-objects-click")&&(e.A.NR["objects-bottom"]||e.A.NR["objects-top"])&&(e.o.shapes||e.o.labels||e.o.arrows||e.o.images)&&(ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-click",p:ZC.AL(e.A.K+"-hover")},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-click-c",p:ZC.AL(e.K+"-objects-click"),wh:i},e.A.AB)),!ZC.AL(e.K+"-objects-hover")&&(e.A.NR["objects-bottom"]||e.A.NR["objects-top"])&&(e.o.shapes||e.o.labels||e.o.arrows||e.o.images)&&(ZC.Q.JZ({cls:"zc-abs",wh:i,id:e.K+"-objects-hover",p:ZC.AL(e.A.K+"-hover")},e.A.AB),ZC.Q.HE({cls:"zc-abs zc-layer",id:e.K+"-objects-hover-c",p:ZC.AL(e.K+"-objects-hover"),wh:i},e.A.AB))},A0M:function(){},clear_:function(){},destroy:function(){var e,i=this;null!==ZC._n_(e=i.A.S9[i.K])&&"feed"===i.HP.type&&(e.send("zingchart.stopfeed"),e.close(),i.A.S9[i.K]=null),i.GD&&i.LZ.stop(!0),i.ME="clear.init",i.unbind(),i.BD&&i.BD.unbind(),i.B9&&i.B9.unbind(),i.HS&&i.HS.unbind(),i.HQ&&i.HQ.unbind(),i.ME="clear.complete"},clear:function(e,i){null===ZC._n_(e)&&(e=!1),null===ZC._n_(i)&&(i=!1);var t,n,a,l,o=this;o.TE={},null===ZC._n_(t=o.A.S9[o.K])||e||"feed"===o.HP.type&&(t.send("zingchart.stopfeed"),t.close(),o.A.S9[o.K]=null),o.GD&&o.LZ.stop(!0),o.ME="clear.init",o.unbind(e),o.A0M(!1,!0),o.LD(),o.LD("click"),o.LD("guide",!0),o.LD("print",!0),o.LD("textprint",!0),e||(!o.B9||o.B9&&!o.B9.LL)&&o.LD("static",!0),o.AY.YZ=[],o.A.SR=[],zingchart.SKIP.LEGEND||o.BD&&o.BD.clear(),o.E.datalength=[];var r,s,A,C=ZC.ie67?ZC.AL(o.A.K):null;if(ZC.mobile||ZC.ie67)ZC.A4("."+o.K+"-node-area",C).remove();else if(ZC.AL(o.A.K+"-img")&&ZC.AL(o.A.K+"-map")){ZC.AL(o.A.K+"-img").setAttribute("useMap","");var c=ZC.AL(o.A.K+"-map").cloneNode(!0);for(n=(a=c.childNodes.length)-1;n>=0;n--)-1!==c.childNodes[n].className.indexOf(o.K+"-node-area")&&c.removeChild(c.childNodes[n]);ZC.Q.EU(o.A.K+"-map"),ZC.AL(o.A.K+"-top").appendChild(c),ZC.AL(o.A.K+"-img").setAttribute("useMap","#"+o.A.K+"-map")}switch(ZC.Q.EU(o.K+"--graph"),o.AY.HF=[],ZC.A4("."+o.K+"-value-box",C).remove(),ZC.A4("."+o.K+"-scale-marker-label",C).remove(),ZC.A4("."+o.K+"-scale-item",C).remove(),ZC.A4("."+o.K+"-scale-label",C).remove(),ZC.A4("."+o.K+"-guide-label",C).remove(),ZC.A4("."+o.K+"-shape-label",C).remove(),ZC.A4("."+o.K+"-mapshape-label",C).remove(),ZC.A4("."+o.K+"-node-errorbars",C).remove(),e||ZC.A4("."+o.K+"-preview-item",C).remove(),o.A.AB){case"svg":for(n=0,a=o.AY.A5.length;n<a;n++)o.AY.A5[n].HI=null;ZC.A4("#"+o.A.K+"-defs").children().each(function(){"LINK"!==this.tagName.toUpperCase()&&(0!==this.id.indexOf(o.K+"-")&&1!==o.A.AG.length||(e?this.id!==o.K+"-gradient"&&-1===this.id.indexOf("-preview-gradient")&&-1===this.id.indexOf("-menu-trigger-gradient")&&-1!==this.id.indexOf(o.K+"-plotset-plot-")&&(i&&o.GD||-1!==this.id.indexOf(o.K+"-legend-")&&zingchart.SKIP.LEGEND||ZC.A4(this).remove()):-1===this.id.indexOf("zc-menu-")&&-1===this.id.indexOf("-menu-trigger-")&&(-1!==this.id.indexOf(o.K+"-legend-")?zingchart.SKIP.LEGEND||ZC.A4(this).remove():o.B9&&o.B9.LL?-1===this.id.indexOf("-preview-gradient")&&ZC.A4(this).remove():ZC.A4(this).remove())))}),e||ZC.Q.EU([o.K+"-clip",o.K+"-clip-hover",o.K+"-clip-preview"]),ZC.A4("#"+o.A.K+"-svg").children().each(function(){var e=o.K+"-";"clippath"===this.tagName.toLowerCase()&&this.id.substring(0,e.length)===e&&this.id!==o.K+"-clip"&&this.id!==o.K+"-clip-hover"&&this.id!==o.K+"-clip-preview"&&ZC.Q.EU(this.id)})}(ZC.Q.EU(o.K+"-nodata"),ZC.Q.EU(o.A.K+"-tooltip-text-float"),e||(ZC.Q.EU([o.K+"-title",o.K+"-subtitle",o.K+"-source",o.K+"-hover"]),zingchart.SKIP.LEGEND||o.BD&&(ZC.Q.EU(o.K+"-legend-c"),ZC.Q.EU(o.K+"-legend-scroll-c"),ZC.A4("."+o.K+"-legend-item-area",C).remove(),ZC.A4("."+o.K+"-legend-marker-area",C).remove(),ZC.A4("."+o.K+"-legend-item",C).remove(),ZC.A4("."+o.K+"-legend-header",C).remove(),ZC.A4("."+o.K+"-legend-footer",C).remove(),ZC.A4("."+o.K+"-legend-frame",C).remove(),o.BD.gc(),o.BD=null),o.B9&&(o.B9.LL&&!o.A.E.resize||(o.B9.unbind(),ZC.A4("."+o.K+"-preview-handler").remove(),ZC.A4("."+o.K+"-preview-mask").remove(),ZC.A4("#"+o.K+"-preview").remove(),o.B9.gc(),o.B9=null)),o.HS&&(o.HS.unbind(),o.HS=null),ZC.Q.IV(ZC.AL(o.K+"-scroll-x-c"),o.A.AB,o.iX,o.iY,o.I,o.F,o.K),ZC.Q.IV(ZC.AL(o.K+"-scroll-y-c"),o.A.AB,o.iX,o.iY,o.I,o.F,o.K),ZC.A4("#"+o.K+"-scroll-x-handle").remove(),ZC.A4("#"+o.K+"-scroll-x-bar").remove(),o.HQ&&(o.HQ.unbind(),o.HQ=null),ZC.A4("#"+o.K+"-scroll-y-handle").remove(),ZC.A4("#"+o.K+"-scroll-y-bar").remove(),ZC.A4("#"+o.K+"-c").empty(),o.H.QL[0]!==o.H.QL[1]&&""!==o.H.QL[1]&&("canvas"===o.H.AB&&ZC.A4("#"+o.K+" canvas").each(function(){this.width=1,this.height=1,ZC.Q.EU(this)}),ZC.A4("#"+o.K+" div").each(function(){ZC.Q.EU(this)}),ZC.Q.EU(o.K))),ZC.A4("#"+o.K+" .zc-layer").each(function(){var t=ZC.Q.T4(this);if(-1===t.indexOf("zc-persistent")){if(e&&(this.id===o.K+"-plotarea-c"||this.id===o.K+"-titles-c"))return;if(-1===this.id.indexOf(o.K+"-plot-")&&-1===this.id.indexOf(o.K+"-plots-"))ZC.Q.IV(this,o.H.AB,o.iX,o.iY,o.I,o.F,o.K);else if(i&&o.GD&&!o.HH){if("canvas"!==o.H.AB)for(var n=0,a=o.AY.A5.length;n<a;n++)o.E.datalength[n]=o.AY.A5[n].S.length;(l=o.A.K9?new RegExp("-plots-[a-z]+-c","g").exec(this.id):new RegExp("-plot-(\\d+)-[a-z]+-\\d+-","g").exec(this.id))&&(!o.E["plot"+l[1]+".visible"]&&"remove"===o.getToggleAction()||o.A.K9)&&ZC.Q.IV(this,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),-1===t.indexOf("zc-vb")&&-1===t.indexOf("zc-fl")||ZC.Q.IV(this,o.H.AB,o.iX,o.iY,o.I,o.F,o.K)}else ZC.Q.IV(this,o.H.AB,o.iX,o.iY,o.I,o.F,o.K)}}),-1!==ZC.AV(o.H.KQ,"use_single_canvas"))&&((r=ZC.AL(o.H.K+"-main-c"))&&ZC.Q.IV(r,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),(s=ZC.AL(o.H.K+"-main-c-top"))&&ZC.Q.IV(s,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),(A=ZC.AL(o.H.K+"-print-c"))&&ZC.Q.IV(A,o.H.AB,o.iX,o.iY,o.I,o.F,o.K));o.clear_(),o.A.E.resize=!1,o.ME="clear.complete"},unbind:function(e,i){null===ZC._n_(e)&&(e=!1);var t=this;(-1===ZC.AV(t.H.KQ,"skip_interactivity")||i)&&(ZC.A4("."+t.K+"-node-area").die("mousedown mouseover touchstart",t.X5).die("mouseup mouseout touchend",t.A1U).die("mousemove touchmove",t.A0R).die("click",t.TG).die("contextmenu",t.TG).die("dblclick",t.A1B),t.BD&&(zingchart.SKIP.LEGEND||(ZC.A4("."+t.K+"-legend-item-area").die("mouseup touchstart",t.SM).die("DOMMouseScroll",t.zc_legend_mousescroll).die("mousewheel",t.zc_legend_mousescroll),ZC.A4("."+t.K+"-legend-marker-area").die("mouseup touchstart",t.SM).die("DOMMouseScroll",t.zc_legend_mousescroll).die("mousewheel",t.zc_legend_mousescroll),ZC.A4("#"+t.K+"-legend-frame").die("DOMMouseScroll",t.zc_legend_mousescroll).die("mousewheel",t.zc_legend_mousescroll),ZC.mobile||(ZC.A4("."+t.K+"-legend-item-area").die(ZC.Q.BZ("mouseover"),t.QI).die(ZC.Q.BZ("mouseout"),t.R9).die(ZC.Q.BZ("mousemove"),t.PM),ZC.A4("."+t.K+"-legend-marker-area").die(ZC.Q.BZ("mouseover"),t.QI).die(ZC.Q.BZ("mouseout"),t.R9).die(ZC.Q.BZ("mousemove"),t.PM))))),t.AC7()},AC7:function(){},S7:function(){},QK:function(){},KK:function(){},SF:function(){},RW:function(){},LD:function(e,i){var t=this;e=e||"hover",null===ZC._n_(i)&&(i=!1);var n=ZC.AL((i?t.A.K:t.K)+"-"+e+"-c");n&&(ZC.Q.IV(n,t.H.AB,t.iX,t.iY,t.I,t.F,t.K,"textprint"===e),ZC.A4("."+t.K+"-label-hover").remove()),"hover"===e&&(ZC.Q.IV(ZC.AL(t.K+"-objects-hover-c"),t.H.AB,t.iX,t.iY,t.I,t.F,t.K),ZC.Q.IV(ZC.AL(t.K+"-objects-maps-hover-c"),t.H.AB,t.iX,t.iY,t.I,t.F,t.K),zingchart.DEV.PLOTSHLAYER&&ZC.Q.IV(ZC.AL(t.K+"-plots-hover-c"),t.H.AB,t.iX,t.iY,t.I,t.F,t.K)),"click"===e&&(ZC.Q.IV(ZC.AL(t.K+"-objects-click-c"),t.H.AB,t.iX,t.iY,t.I,t.F,t.K),ZC.Q.IV(ZC.AL(t.K+"-objects-maps-click-c"),t.H.AB,t.iX,t.iY,t.I,t.F,t.K)),t.hideLayer_(e,i)},hideLayer_:function(){},A6P:function(e,i){var t,n=this;if(null!==ZC._n_(e)&&null!==ZC._n_(i)){var a=n.AY.A5[e].J0,l=n.AY.A5[e].RN;if("none"===a)return;if(null!==ZC._n_(n.CB["p"+e])){if(null!==ZC._n_(n.CB["p"+e]["n"+i])){if(delete n.CB["p"+e]["n"+i],l)for(t=0;t<n.AY.A5.length;t++)delete n.CB["p"+t]["n"+i]}else if("graph"===a?(n.CB={},n.CB["p"+e]={}):"plot"===a&&(n.CB["p"+e]={}),n.CB["p"+e]["n"+i]=!0,l)for(t=0;t<n.AY.A5.length;t++)n.CB["p"+t]=n.CB["p"+t]||{},n.CB["p"+t]["n"+i]=!0}else if("graph"===a&&(n.CB={}),n.CB["p"+e]={},n.CB["p"+e]["n"+i]=!0,l)for(t=0;t<n.AY.A5.length;t++)n.CB["p"+t]=n.CB["p"+t]||{},n.CB["p"+t]["n"+i]=!0}null!==ZC._n_(e)&&null!==ZC._n_(i)&&(n.HH=!0,n.K6(!0,!0))},paint:function(e){null===ZC._n_(e)&&(e=!1);var i,t,n,a,l,o,r=this;r.A.GRAPHID=r.K,r.V0=e,window.clearTimeout(ZC.ASYNC_TICK[r.K]),r.A.clearLabelBoxes("vb"+r.L);var s,A,C,c,u,p,Z,h=r.BU("k")[0],d=ZC.MAX,f=-ZC.MAX,_={},g=r.AY.A5,v=0;for(c=0;c<g.length;c++)if(g[c].o.rel)for(C=0;C<g.length;C++)if(g[C].o.id&&g[C].o.id===g[c].o.rel){v++,Z=!0;var b=[];for(l=0;l<g[C].S.length;l++)(h.EF?g[C].S[l].BT>=h.B3&&g[C].S[l].BT<=h.BJ:g[C].S[l].L>=h.W&&g[C].S[l].L<=h.A1)?(s=g[C].S[l].AD,d=Math.min(d,s),f=Math.max(f,s),Z?(Z=!1,g[C].S[l].BT?b.push([g[C].S[l].BT,0]):b.push(0),p=s):g[C].S[l].BT?b.push([g[C].S[l].BT,100*(s-p)/p]):b.push(100*(s-p)/p)):g[C].S[l].BT?b.push([g[C].S[l].BT,0]):b.push(0);_["p-"+c]=[].concat(b)}if(v>0){for(d=ZC.MAX,f=-ZC.MAX,c=0;c<g.length;c++)if(g[c].o.rel&&_["p-"+c])for(l=0;l<g[c].S.length;l++)2===(A=_["p-"+c][l]).length?(s=A[1],g[c].V[l]=A,g[c].S[l].AD=g[c].S[l].CS=A[1]):(s=A,g[c].V[l]=g[c].S[l].AD=g[c].S[l].CS=A),g[c].FK(l),d=Math.min(d,s),f=Math.max(f,s);var B=r.BU("v")[0];B.RQ(d,f,!0),B.IZ()}for(r.A.E["g-"+r.L+"-selection"]&&(r.CB=JSON.parse(r.A.E["g-"+r.L+"-selection"])),r.KI=!1,t=0,n=r.AY.A5.length;t<n;t++)r.IX[t]=!1;for(t in r.CB)if(r.CB.hasOwnProperty(t)){var m=ZC._i_(t.replace("p",""));for(u in r.CB[t])if(r.CB[t].hasOwnProperty(u)){r.IX[m]=!0,r.KI=!0;break}}function E(){if(r.AJ["3d"]){var e=ZC.DK.DB(r.P,r,r.P.iX-ZC.AO.E2,r.P.iX-ZC.AO.E2+r.P.I,r.P.iY-ZC.AO.E3,r.P.iY-ZC.AO.E3+r.P.F,ZC.AO.FU+10,ZC.AO.FU+10,"y"),t=ZC.DK.DB(r.P,r,r.P.iX-ZC.AO.E2,r.P.iX-ZC.AO.E2+r.P.I,r.P.iY-ZC.AO.E3,r.P.iY-ZC.AO.E3+r.P.F,ZC.AO.FU,ZC.AO.FU,"y");t.K=r.K+"-plotarea",t.PB=e.D,r.CL.add(t)}else{r.P.Z=r.P.C7=r.H.usc()?r.H.mc():ZC.AL(r.K+"-plotarea-c");var n,a=[r.P.iX,r.P.iY,r.P.I,r.P.F],l=r.P.AU,o=r.P.AU,s=r.P.AU,A=r.P.AU;""!==(i=r.P.PX)&&(n=i.split(/\s/),l=ZC._i_(n[0])),""!==(i=r.P.OJ)&&(n=i.split(/\s/),o=ZC._i_(n[0])),""!==(i=r.P.NN)&&(n=i.split(/\s/),s=ZC._i_(n[0])),""!==(i=r.P.P4)&&(n=i.split(/\s/),A=ZC._i_(n[0])),r.P.iX-=A+1,r.P.iY-=l+1,r.P.I+=A+o+1,r.P.F+=l+s+1,r.P.paint(),r.P.iX=a[0],r.P.iY=a[1],r.P.I=a[2],r.P.F=a[3]}}if(r.A.A0C(),r.NX(),r.V0?r.E["plotarea.paint"]&&(E(),r.E["plotarea.paint"]=null):(r.build(),r.Z&&(r.C7=r.Z,r.b()),E()),"xy"===r.AJ.layout||"yx"===r.AJ.layout){var D=r.BU("v"),F=null;for(l=0;l<D.length;l++)(0===l||D[l].o["ref-zero"])&&D[l].FX<=0&&D[l].H0>=0&&D[l].T9&&(F=l);if(null!==ZC._n_(F)){var K=D[F].AT(0);for(l=0;l<D.length;l++)if(l!==F&&D[l].o["sync-zero"]&&D[l].FX<=0&&D[l].H0>=0&&D[l].T9){var x=D[l].AT(0);if(ZC._a_(x-K)>=1)for(var I=!0,y=0;I;)x>K?D[l].CO?D[l].AW?D[l].AC+=1:D[l].BV+=1:D[l].AW?D[l].BV+=1:D[l].AC+=1:D[l].CO?D[l].AW?D[l].BV+=1:D[l].AC+=1:D[l].AW?D[l].AC+=1:D[l].BV+=1,y++,D[l].IZ(),D[l].A7U(),(y>(D[l].CO?r.P.I:r.P.F)||ZC._a_(D[l].AT(0)-K)<1)&&(I=!1)}}}for(l=0,o=r.BO.length;l<o;l++)r.BO[l].Z=r.BO[l].C7=r.H.usc()?r.H.mc():ZC.AL(r.K+"-scales-bl-0-c"),r.A.O7=!0,r.BO[l].paint(),r.A.ZV(),r.A.O7=!1;var w="undefined"!=typeof r.E["shared-zoom"]&&null!==ZC._n_(r.E["shared-zoom"])&&r.E["shared-zoom"];if(r.B9&&r.B9.LL?r.B9.I2&&(r.B9.I2=!0,r.B9.paint()):r.E["skip-preview"]||!r.B9||r.V0&&!r.B9.I2||w||(r.B9.I2=!0,r.B9.paint()),r.E["shared-zoom"]=null,r.E["skip-preview"]=null,r.HS&&r.HS.paint(),r.HQ&&r.HQ.paint(),r.V0||(a=r.H.usc()?r.H.mc():ZC.AL(r.K+"-titles-c"),r.IQ&&r.IQ.AN&&null!==ZC._n_(r.IQ.AM)&&(r.IQ.Z=r.IQ.C7=a,r.IQ.paint(),!r.IQ.K9&&ZC.AL(r.A.K+"-map")&&(ZC.AL(r.A.K+"-map").innerHTML+=ZC.AP.O4(r.K,r.IQ))),r.K1&&r.K1.AN&&null!==ZC._n_(r.K1.AM)&&(r.K1.Z=r.K1.C7=a,r.K1.paint(),!r.K1.K9&&ZC.AL(r.A.K+"-map")&&(ZC.AL(r.A.K+"-map").innerHTML+=ZC.AP.O4(r.K,r.K1))),r.MU&&r.MU.AN&&null!==ZC._n_(r.MU.AM)&&(r.MU.Z=r.MU.C7=a,r.MU.paint(),!r.MU.K9&&ZC.AL(r.A.K+"-map")&&(ZC.AL(r.A.K+"-map").innerHTML+=ZC.AP.O4(r.K,r.MU))),r.S5&&r.S5.AN&&null!==ZC._n_(r.S5.AM)&&(r.S5.Z=r.S5.C7=a,r.S5.paint())),r.IQ&&r.IQ.EK(),r.K1&&r.K1.EK(),r.MU&&r.MU.EK(),r.AJ["3d"]||r.UL(),r.A.O7=!r.GD,zingchart.DEV.SKIPTRACKERS&&(r.A.O7=!1),r.A.E["graph."+r.K+".disableanimation"])for(l=0,o=r.AY.A5.length;l<o;l++)r.AY.A5[l].GD=!1;r.AY.paint(),r.H.paintHistory()},UL:function(){},clearPreview:function(){var e=this;e.B9&&(ZC.Q.IV(ZC.AL(e.K+"-preview-c"),e.A.AB,e.iX,e.iY,e.I,e.F,e.K),e.A.H1&&!e.A.H1.A0G&&e.B9.reset(),e.B9.I2=!0)},flatten:function(){},_end_:function(){var e,i,t,n,a=this;for(a.E["toggle-action-remove"]=null,a.GD||a.A.ZV(),a.A.O7=!1,(a.LL||!a.GD||a.H.E["graph."+a.K+".disableanimation"]||!a.AJ["enable-animation"]||-1!==ZC.AV(a.H.KQ,"skip_interactivity")||zingchart.SKIP.ANIMATION)&&(a.ME="ready"),"initial"===a.A1Q&&(a.ABO=!1,a.H.E["graph."+a.K+".disableanimation"]=!0),i=0,t=a.BO.length;i<t;i++)a.BO[i].paint_();if(!a.A.E["fire-load"]){var l=ZC.AP.BY("objectsinit",a.A,a.GX(),!0);if(l)for(var o=["labels","shapes","imges","arrows"],r=0;r<o.length;r++)l[o[r]]&&(a.o[o[r]]=(a.o[o[r]]||[]).concat(l[o[r]]))}function s(e){var i,t,n=(e.targetid||e.target.id).replace("-area-path","").replace("-path","").replace(/--([a-zA-Z0-9]+)/,"").replace("-marker","").replace("-circle","").split("-").reverse();return"node"===n[1]&&(i=n[2],t=n[0]),[i,t]}if(a.AJ["3d"]||(a.flatten(),a.PW(),a.KK(),-1===ZC.AV(a.H.KQ,"skip_interactivity")&&a.RW()),-1===ZC.AV(a.H.KQ,"skip_interactivity")){var A=ZC.A4("."+a.K+"-node-area");a.X5=function(e){if(!(zingchart.NODE_EV&&"mouseover"===zingchart.NODE_EV_TYPE&&"mouseover"===e.type||(zingchart.NODE_EV_CHART=a.A.K,zingchart.NODE_EV=e,zingchart.NODE_EV_TYPE=e.type,ZC.move||a.BD&&a.BD.YF||-1===ZC.Q.T4(e.target).indexOf("zc-node-area")||"ready"!==a.ME))){ZC.mobile&&(a.E["node-target-id"]=e.target.id,ZC.move=!1,a.H.hideCM(),null===a.H.DG||null===ZC._n_(a.H.DG["page-scroll"])||a.H.DG["page-scroll"]||e.preventDefault(),a.A.YI(e));var n=s(e);if(a.AY.A5[n[0]]){var l=a.AY.A5[n[0]].FK(n[1]);if(l&&(l.O?(ZC.COLORS=[l.O.C2,l.O.A0,l.O.AE,l.O.BW,l.O.B7],l.NB&&ZC.COLORS.push(l.NB.A0,l.NB.AE,l.NB.BW,l.NB.B7)):ZC.COLORS=[],a.E["plot"+n[0]+".visible"])){var o=ZC.mobile?"mousedown":e.xtype||e.type;(ZC.mobile||"mousedown"!==o)&&a.A.A7&&a.A7&&a.A7.AN&&a.A.A7.onmouseover(e);var r=a.AY.A5[n[0]];if("plot"===r.A3K)for(i=0,t=r.S.length;i<t;i++)r.S[i]&&r.FK(i).A0W("hover");else l.A0W("hover");if(l.X6(e,o),l.A.X0(e,o),a.BD){ZC.move=!0;var A=n[0];a.AY.A5[A].o["legend-item"]&&null!==ZC._n_(a.AY.A5[A].o["legend-item"].order)&&(A=ZC._i_(a.AY.A5[A].o["legend-item"].order)),a.BD.o["reverse-series"]&&(A=a.AY.A5.length-1-A),a.BD.PP?a.L===a.A.AG.length-1&&a.BD.highlightItem(A):a.BD.highlightItem(A),ZC.move=!1}}}}},A.live("mousedown mouseover touchstart",a.X5),a.A1U=function(e){if(zingchart.NODE_EV=zingchart.NODE_EV_TYPE=null,zingchart.NODE_EV_CHART=null,!(ZC.move||a.BD&&a.BD.YF)){var i=e.target;if(ZC.mobile&&document.elementFromPoint){var t=ZC.Q.MF(e),n=Math.max(window.pageXOffset,document.documentElement.scrollLeft,document.body.scrollLeft),l=Math.max(window.pageYOffset,document.documentElement.scrollTop,document.body.scrollTop);if((i=document.elementFromPoint(t[0]-n,t[1]-l))&&a.E["node-target-id"]&&a.E["node-target-id"]!==i.id)return}if(-1!==ZC.Q.T4(e.target).indexOf("zc-node-area")&&"ready"===a.ME){ZC.mobile&&a.A.OT(e);var o=s(e),r=a.AY.A5[o[0]].FK(o[1]);if(r){if(a.E["plot"+o[0]+".visible"]){a.A.A7&&a.A7&&a.A7.AN&&a.A.A7.onmouseout(e),a.AY.A5[o[0]].D=[],r.LD(),a.LD();var A=ZC.mobile?"mouseup":e.xtype||e.type;r.X6(e,A),r.A.X0(e,A),a.BD&&(ZC.move=!0,a.BD.PP?a.L===a.A.AG.length-1&&a.BD.highlightItem(-1):a.BD.highlightItem(-1),ZC.move=!1)}!ZC.mobile||a.H.AA9||ZC.move||"touchend"!==e.type||(zingchart.S8(e),a.TG(e))}}}},A.live("mouseup mouseout touchend",a.A1U),a.A0R=function(e){if(zingchart.NODE_EV=e,zingchart.NODE_EV_CHART=a.A.K,zingchart.NODE_EV_TYPE=e.type,-1!==ZC.Q.T4(e.target).indexOf("zc-node-area")&&"ready"===a.ME){ZC.mobile&&a.A.OT(e);var i=s(e);a.E["plot"+i[0]+".visible"]&&a.A.A7&&a.A7&&a.A7.AN&&a.A.A7.onmousemove(e)}},A.live("mousemove touchmove",a.A0R),a.TG=function(e){if((e.targetid||-1!==ZC.Q.T4(e.target).indexOf("zc-node-area"))&&"ready"===a.ME){var i=s(e),t=a.AY.A5[i[0]].FK(i[1]);if(t&&("none"===t.A.J0||!ZC.mobile&&0!==e.button||(a.A.E.preservezoom=!0,a.clearPreview(),a.A6P(t.A.L,t.L)),t.X6(e,"click"),t.A.X0(e,"click"),null!==ZC._n_(t.A.EA)&&"NULL"!==t.A.EA))if(t.A.EA instanceof Array)for(var n=0;n<t.A.EA.length;n++){var l=t.A.FC;t.A.FC instanceof Array&&(l=t.A.FC[n]||"graph="+(a.o.id||"")),n===t.L&&a.V4(e,t.JT(t.A.EA[n],null,null,!0),l)}else a.V4(e,t.JT(t.A.EA,null,null,!0),t.A.FC||"graph="+(a.o.id||""))}},a.A1B=function(e){if(-1!==ZC.Q.T4(e.target).indexOf("zc-node-area")&&"ready"===a.ME){var i=s(e),t=a.AY.A5[i[0]].FK(i[1]);t&&(t.X6(e,"doubleclick"),t.A.X0(e,"doubleclick"))}},ZC.mobile||A.live("click",a.TG).live("contextmenu",a.TG).live("dblclick",a.A1B)}if(a.AC2(),a.A.E["tr-ev-"+a.L]?(a.A.E["tr-ev-"+a.L]=null,a.A7Q()):a.A7Q(),a.A17){a.A17=!1;var C={graphid:a.K};for(i=0,t=a.BU("k").length;i<t;i++){var c=a.BU("k")[i];null!==ZC._n_(e=c.KM)&&(C["zoomx"+(n=1===c.L?"":"-"+c.L)]=!0,C["xmin"+n]=e[0],C["xmax"+n]=e[1])}for(i=0,t=a.BU("v").length;i<t;i++){var u=a.BU("v")[i];null!==ZC._n_(e=u.KM)&&(C["zoomy"+(n=1===u.L?"":"-"+u.L)]=!0,C["ymin"+n]=e[0],C["ymax"+n]=e[1])}if(C.zoomto=!0,a.A.G1){for(var p in a.A.G1)ZC.AL(p).appendChild(a.A.G1[p]);a.A.G1=null}a.A.PZ(C)}},AC2:function(){},A7Q:function(){var e=this;if(e.A.A28<e.A.AG.length&&(e.A.A28++,ZC.AP.BY("gload",e.A,e.GX())),ZC.AP.BY("gcomplete",e.A,e.GX()),e.B9&&(e.B9.I2=!1),zingchart.NODE_EV&&zingchart.NODE_EV_CHART&&zingchart.NODE_EV_CHART===e.A.K){var i=ZC.A4("#"+e.A.K+"-top"),t=ZC.E1[0]-i.offset().left,n=ZC.E1[1]-i.offset().top,a=zingchart.exec(e.A.K,"getxyinfo",{x:t,y:n});if(a)for(var l=0;l<a.length;l++)if("node"===a[l].infotype&&a[l].xydistance<10){var o=a[l].graphid+"-plotset-plot-"+a[l].plotidx+"-node-"+a[l].nodeidx;zingchart.NODE_EV&&zingchart.NODE_EV.target&&zingchart.NODE_EV.target.id===o&&(e.X5(zingchart.NODE_EV),zingchart.NODE_EV=null)}}zingchart.GUIDE_EV&&e.A.D7&&e.A.D7.QA(zingchart.GUIDE_EV),e.A.A4G<e.A.AG.length?e.A.A4G++:(e.A.A4G=1,e.A.A28===e.A.AG.length&&(e.A.A28++,e.A.E["fire-load"]=!0,e.LL&&e.AY.A5.length>1&&(zingchart.SKIP.EVENT||ZC.AP.BY("load",e.A,e.A.FG()))),e.A.E["fire-complete"]=!0,(e.E["graph-K6"]||e.LL&&e.AY.A5.length>1)&&(zingchart.SKIP.EVENT||ZC.AP.BY("complete",e.A,e.A.FG()),e.E["graph-K6"]=null)),0!==e.A.QM.length&&e.A.QM[e.A.QM.length-1]===e.A.E.json||(e.A.QM[e.A.NU]!==e.A.E.json&&(e.A.QM.length=e.A.NU+1),e.A.QM[e.A.NU]=e.A.E.json)},K6:function(e,i){var t=this;null===ZC._n_(e)&&(e=!1),null===ZC._n_(i)&&(i=!1),t.A.N4(t),t.E["graph-K6"]=!0,t.clear(e,i),t.parse(),t.U7&&t.U7(),t.paint(e),t.B9&&t.B9.setScalesInfo(),t.HH=!1,zingchart.SKIP.CSV=!1},V4:function(ev,EA,FC){if(2!==ev.button){var s=this,C,P5=[""];switch(null!==ZC._n_(FC)&&(P5=FC.split("=")),P5[0]){case"_blank":window.open(EA,"_blank");break;case"_top":window.top.location.href=EA;break;case"_parent":window.parent.location.href=EA;break;case"window":null!==ZC._n_(P5[1])&&""!==P5[1]&&(window.top[P5[1]].location.href=EA);break;case"graph":var Y4=null;if("()"===EA.substring(EA.length-2)||"javascript:"===EA.substring(0,11))try{var EC=EA.replace("javascript:","").replace("()","");eval(EC)&&(Y4=eval(EC).call(s))}catch(e){}null!==ZC._n_(P5[1])&&""!==P5[1]?"_top"===P5[1]||"_parent"===P5[1]?(s.A.N4(),Y4?zingchart.exec(s.A.K,"setdata",{data:Y4}):s.A.load(null,EA)):(C=s.A.OS(P5[1]),C&&(s.A.N4(C),s.A.E["tr-ev-"+C.L]=!0,s.A.NU++,Y4?zingchart.exec(s.A.K,"setdata",{graphid:P5[1],data:Y4}):s.A.load(P5[1],EA))):(C=s.A.AG[0],s.A.N4(C),Y4?zingchart.exec(s.A.K,"setdata",{graphid:C.K,data:Y4}):(s.A.E["tr-ev-"+C.L]=!0,s.A.NU++,s.A.load(C.K,EA)));break;default:window.location.href=EA}}},I0:function(e,i,t){var n=this;if(null===ZC._n_(t)&&(t=n.AY.A5.length-1),null!==ZC._n_(e)&&void 0!==e)return n.AY.A5[e];if(null===ZC._n_(i)||void 0===i)return n.AY.A5[t];for(var a=0,l=n.AY.A5.length;a<l;a++)if(i===n.AY.A5[a].H5)return n.AY.A5[a];return null},A3C:function(e,i){var t,n,a=this;(e=e||{})["toggle-action"]=e["toggle-action"]||a.getToggleAction();var l=null;if("undefined"!=typeof e.plotindex&&(l=ZC._i_(e.plotindex)),-1===l)for(l=[],t=0,n=a.AY.A5.length;t<n;t++)l.push(t);l instanceof Array||(l=[l]);var o=e.plotid||"";o instanceof Array||(o=[o]);var r=[];for(t=0,n=ZC.BQ(l.length,o.length);t<n;t++){var s=a.I0(l[t],o[t]);if(s){var A={};ZC._cp_(e,A);var C=s.L;A.plotindex=C,A.plotid=s.H5,("show"===i&&!a.E["plot"+C+".visible"]||"hide"===i&&a.E["plot"+C+".visible"])&&r.push(A)}}for(t=0,n=r.length;t<n;t++)a.A.o.graphset[a.L].series[r[t].plotindex].visible="show"===i,t===n-1&&(r[t].K6=1),a.Q7(r[t])},Q7:function(e){var i,t,n,a=this;a.A.E["graph."+a.K+".disableanimation"]=!1,e=e||{};var l=!1;null!==ZC._n_(e.skip)&&e.skip&&(l=!0),null===ZC._n_(e.update)||e.update||(l=!0);var o=!1;e["toggle-action"]=e["toggle-action"]||a.getToggleAction(),null!==ZC._n_(i=e["ignore-legend"])&&(o=ZC._b_(i));var r=a.I0(e.plotindex,e.plotid);if(r){var s=r.L;switch(e["toggle-action"]){case"hide":if(a.BD&&(a.BD.E.showhide=!0),a.E["plot"+s+".visible"]=!a.E["plot"+s+".visible"],null!==ZC._n_(a.A.o.graphset[a.L].series)&&(a.A.o.graphset[a.L].series[s].visible=a.E["plot"+s+".visible"]),a.AJ["3d"])o=!0,l||a.K6();else{var A=a.E["plot"+s+".visible"]?"block":"none";if(zingchart.DEV.SKIPTRACKERS||ZC.A4("."+a.K+"-plotset-plot-"+s+"-node-area").each(function(){if("AREA"===this.tagName.toUpperCase()){var e=ZC.A4(this),i=e.attr("coords"),n=e.attr("shape");"none"===A?(i="-"+i.replace(/,/g,",-"),"rect"===n?4===(t=i.split(",")).length&&(i=[t[2],t[3],t[0],t[1]].join(",")):"circle"===n&&3===(t=i.split(",")).length&&(i=[t[0],t[1],-t[2]].join(","))):(i=i.replace(/\-/g,""),"rect"===n&&4===(t=i.split(",")).length&&(i=[t[2],t[3],t[0],t[1]].join(","))),e.attr("coords",i)}}),a.A.K9)ZC.AL(a.K+"-plots-bl-c").style.display=A,ZC.AL(a.K+"-plots-fl-c").style.display=A,ZC.AL(a.K+"-plots-vb-c").style.display=A;else{for(n=0;n<r.SW;n++)(i=ZC.AL(a.K+"-plot-"+s+"-bl-"+n+"-c"))&&(i.style.display=A);for(n=0;n<r.A1G;n++)(i=ZC.AL(a.K+"-plot-"+s+"-fl-"+n+"-c"))&&(i.style.display=A);(i=ZC.AL(a.K+"-plot-"+s+"-vb-c"))&&(i.style.display=A)}var C=ZC.A4("."+a.K+"-plot-"+s+"-value-box");a.E["plot"+s+".visible"]?(C.show(),ZC.A4("."+a.K+"-plotset-plot-"+s+"-preview").show()):(C.hide(),ZC.A4("."+a.K+"-plotset-plot-"+s+"-preview").hide())}break;case"remove":a.clearPreview(),o=!0,a.E["toggle-action-remove"]=!0,a.E["plot"+s+".visible"]=!a.E["plot"+s+".visible"],e.K6&&(l||(a.LV("on-legend-toggle"),a.K6(!0,!0)))}a.BD&&!o&&(a.BD.clear(),a.BD.paint())}},LV:function(e){var i=this,t=!0,n=i.o.plot||{};null!==ZC._n_(n.animation)&&null!==ZC._n_(n.animation[e])&&(t=ZC._b_(n.animation[e])),i.HH="initial"===i.A1Q||!t},GX:function(){return{id:this.A.K,graphidx:this.L,graphid:this.K.replace(this.A.K+"-graph-",""),x:this.iX,y:this.iY,width:this.I,height:this.F,loader:this.A.FG()}},RT:function(){},S1:function(){},gc:function(){for(var e=0;e<this.BO.length;e++)this.BO[e].gc();for(var i=0;i<this.AY.A5.length;i++)this.AY.A5[i].gc();ZC.AP.gc(this.AY,["A","C","H","F8","o","I6","JB"]),ZC.AP.gc(this,["Z","C7","AJ","IQ","K1","MU","EZ"])}}),ZC.JH.prototype.PW=function(){var e,i,t,n,a,l,o,r,s=this;s.initObjectsLayers(),s.BX=[],s.FH=[],s.YC=[],s.LH=[],s.FA=[],s.XF={};var A,C,c,u=s.A.B8,p="("+s.AF+")";if(null!==ZC._n_(A=s.o.labels))for(i=0,t=A.length;i<t;i++){A[i].id||(A[i].id="lbl_"+i+"_"+ZC._r_(1e3,9999)),n=A[i].id||i,a=!1,l=!1,s.E["objects.updates"]&&-1===ZC.AV(s.E["objects.updates"],n)&&(a=!0,l=!0),A[i].tween&&(a=!0);var Z=zingchart.pool.getInstance("DN",s,s.K+"-label-"+n,a);if(!l||!Z._POOL_){if(u.load(Z.o,p+".label"),Z.append(A[i]),null!==ZC._n_(e=Z.o.parent))for(var h=0;h<s.BX.length;h++)if(""+s.BX[h].H5==""+e){Z.E["p-x"]=s.BX[h].iX,Z.E["p-y"]=s.BX[h].iY,Z.E["p-width"]=s.BX[h].I,Z.E["p-height"]=s.BX[h].F;break}if(Z.H5=n,Z.K=s.K+"-label-"+n,Z.GL=s.K+"-label zc-label",null!==ZC._n_(e=A[i].hook)&&(Z.E.hook=e),Z.JT=function(i){if(!i||-1===(""+i).indexOf("%"))return i;i=""+i;var t,n=[];n.push(["%id",s.A.K]),n.push(["%graphid",s.K.replace(s.A.K+"-graph-","")]);var a=s.E.update;for(var l in a)n.push(["%"+l,a[l]]);n.sort(ZC.A1H);for(var o=0,r=n.length;o<r;o++)t=new RegExp(n[o][0],"g"),i=i.replace(t,n[o][1]);var A,C,c,u,p=Z.o["default-value"]||" ";for(t=new RegExp("(%plot-([0-9]+?)-value(-*)([0-9]*?))|(%plot-value-([0-9]+?))|(%plot-value)|(%npv)|(%node-percent-value)","g"),i=i.replace(t,p),t=new RegExp("%plot-([0-9]+?)-data-([a-zA-Z0-9-]+)","g"),i=i.replace(t,p),t=new RegExp("\\((.+?)\\)\\(([0-9]*)\\)\\(([0-9]*)\\)");A=t.exec(i);)if("%node-value"===A[1]){C="";var h=0,d=0;""!==(e=A[2])&&(h=ZC._i_(e)),""!==(e=A[3])&&(d=ZC._i_(e)),(u=s.AY.A5[h])&&(c=u.FK(d,3))&&(C=c.JT(A[1])),i=i.replace(A[0],C)}return i},Z.parse(),A[i]["3d"]){var d=new ZC.CE(s,Z.iX+Z.I/2-ZC.AO.E2,Z.iY+Z.F/2-ZC.AO.E3,ZC._i_(A[i].z||"0"));Z.iX=d.ED[0]-Z.I/2,Z.iY=d.ED[1]-Z.F/2}}s.BX.push(Z),s.FA.push({type:"label",index:i,zindex:Z.JS}),s.XF[n]={shape:"label",idx:i}}if(null!==ZC._n_(C=s.o.arrows))for(i=0,t=C.length;i<t;i++){var f=new ZC.A81(s);u.load(f.o,p+".arrow"),f.append(C[i]),n=C[i].id||i,f.K=s.K+"-arrow-"+n,f.parse(),s.YC.push(f),s.FA.push({type:"arrow",index:i,zindex:f.JS})}var _,g=0;if(null!==ZC._n_(c=s.o.shapes))for(i=0,t=c.length;i<t;i++)if(null===ZC._n_(c[i].type)||0!==c[i].type.indexOf("zingchart.")){var v,b,B;if(c[i].id||(c[i].id="shp_"+i+"_"+ZC._r_(1e3,9999)),n=c[i].id||i,l=null!==ZC._n_(zingchart.pool[s.K+"-shape-"+n])&&zingchart.SKIP.PARSE3D,a=!1,s.E["objects.updates"]&&-1===ZC.AV(s.E["objects.updates"],n)&&(a=!0,l=!0),c[i].tween&&(a=!0),c[i]["3d"]?((o=zingchart.pool.getInstance("DT",s,s.K+"-shape-"+n,!0)).o=c[i],("poly"!==c[i].type||c[i]["map-item"])&&(l=!1)):(null!==ZC._n_(c[i].label)?(o=zingchart.pool.getInstance("P0",s,s.K+"-shape-"+n,a)).WW=c[i]:((o=zingchart.pool.getInstance("DT",s,s.K+"-shape-"+n,a)).o=c[i],o.append({},!0)),a&&o._POOL_||(l=!1)),l||(o.H5=n,o.K=s.K+"-shape-"+n,o.O7=!0,c[i]["map-item"]&&(o.O7=!1),o.parse()),null!==ZC._n_(e=c[i].hook)&&(o.E.hook=e),c[i]["3d"]){if(c[i]["map-item"]){for(v=[],b=0,B=o.D.length;b<B;b++)null!==o.D[b]?(r=new ZC.CE(s,o.D[b][0]-ZC.AO.E2,o.D[b][1]-ZC.AO.E3,ZC._i_(o.D[b][2]||c[i].z||"0")),v.push(r.ED)):v.push(null);o.D=v,s.FH.push(o),s.FA.push({type:"shape",index:g,zindex:o.JS,z3d:r.AAM}),s.XF[n]={shape:o.DU,idx:g}}else if("poly"===c[i].type){var m=ZC.DK.D8(o,s,c[i].points,!1);s.CL.add(m),s.FH.push(null)}else{if(o.D.length>0){for(v=[],b=0,B=o.D.length;b<B;b++)r=new ZC.CE(s,o.D[b][0]-ZC.AO.E2,o.D[b][1]-ZC.AO.E3,ZC._i_(o.D[b][2]||c[i].z||"0")),v.push(r.ED);o.D=v}else r=new ZC.CE(s,o.iX-ZC.AO.E2,o.iY-ZC.AO.E3,ZC._i_(c[i].z||"0")),o.iX=ZC._i_(r.ED[0]),o.iY=ZC._i_(r.ED[1]);s.FH.push(o),s.FA.push({type:"shape",index:g,zindex:o.JS,z3d:r.AAM})}o.E["3dtx"]=!0,o.E["3d"]=!0}else s.FH.push(o),o instanceof ZC.P0?(s.FA.push({type:"shape",index:g,zindex:o.BF.JS}),s.XF[n]={shape:o.BF.DU,idx:g}):(s.FA.push({type:"shape",index:g,zindex:o.JS}),s.XF[n]={shape:o.DU,idx:g});g++}if(null!==ZC._n_(_=s.o.images))for(i=0,t=_.length;i<t;i++){var E=_[i].src;if(ZC.cache.data[E]){var D=new ZC.HL(s);D.append({"background-repeat":"no-repeat","background-image":E,width:ZC.cache.data[E].width,height:ZC.cache.data[E].height}),D.append(_[i]),n=_[i].id||i,D.H5=n,D.K=s.K+"-image-"+n,D.L=i,D.parse(),s.LH.push(D),s.FA.push({type:"image",index:i,zindex:D.JS})}}s.E["objects.updates"]=null,s.FA=s.FA.sort(function(e,i){return null!==ZC._n_(e.z3d)&&null!==ZC._n_(i.z3d)?e.z3d-i.z3d>0?1:-1:0}),s.FA=s.FA.sort(function(e,i){return e.zindex-i.zindex==0?e.index-i.index:e.zindex-i.zindex})},ZC.JH.prototype.A0M=function(e,i){void 0===e&&(e=!1),void 0===i&&(i=!1);var t,n=this,a=[n.K+"-objects-bottom-sh-c",n.K+"-objects-bottom-c",n.K+"-objects-top-sh-c",n.K+"-objects-top-c",n.K+"-objects-front-c",n.K+"-objects-print-c"];ZC.SKIPMAPS||a.push(n.K+"-objects-maps-sh-c",n.K+"-objects-maps-c");for(var l=0;l<a.length;l++)(t=ZC.AL(a[l]))&&ZC.Q.IV(t,n.H.AB,n.iX,n.iY,n.I,n.F,n.K);"canvas"===n.A.AB&&!zingchart.CANVASTEXT&&ZC.objmove||(ZC.A4("."+n.K+"-label").remove(),ZC.A4("."+n.K+"-shape-label").remove(),ZC.A4("."+n.K+"-arrow-label").remove()),e||(ZC.A4("."+n.K+"-label-area").each(function(){if(-1===ZC.AV([n.K+"-title-area",n.K+"-subtitle-area",n.K+"-source-area"],this.id)){var e=new RegExp("scale_(x|y|k|v)((_[0-9]+)*)-(item_|marker_)([0-9]+)").exec(this.id);!i&&e&&e.length||ZC.Q.EU(this.id)}}),ZC.A4("."+n.K+"-shape-area").each(function(){(!ZC.SKIPMAPS||ZC.SKIPMAPS&&"1"!==this.getAttribute("data-map"))&&ZC.Q.EU(this.id)}),ZC.A4("."+n.K+"-arrow-area").remove()),"svg"===n.A.AB&&ZC.A4("#"+n.A.K+"-svg").children().each(function(){var e=n.K+"-label-";"clippath"===this.tagName.toLowerCase()&&this.id.substring(0,e.length)===e&&ZC.Q.EU(this.id)})},ZC.JH.prototype.AC7=function(){var e=this;(e.H.NR["objects-top"]||e.H.NR["objects-bottom"])&&(ZC.A4("."+e.K+"-label-area").die(ZC.mobile?"touchstart":"mousedown mouseover",e.A07).die(ZC.mobile?"touchend":"mouseup mouseout",e.A0S).die(ZC.mobile?"touchmove":"mousemove",e.A06),ZC.mobile||ZC.A4("."+e.K+"-label-area").die("click",e.UO).die("dblclick",e.UO),ZC.A4("."+e.K+"-shape-area").die(ZC.mobile?"touchstart":"mousedown mouseover",e.A05).die(ZC.mobile?"touchend":"mouseup mouseout",e.A0U).die(ZC.mobile?"touchmove":"mousemove",e.A03),ZC.mobile||ZC.A4("."+e.K+"-shape-area").die("click",e.UA).die("dblclick",e.UA))},ZC.JH.prototype.OW=function(){var e,i,t,n,a=this;if(a.YK=!1,null!==ZC._n_(t=a.o.labels))for(e=0,i=t.length;e<i;e++){var l=""+(t[e].text||"");if(-1!==l.indexOf("%node-")||-1!==l.indexOf("%plot-")||-1!==l.indexOf("%npv")||-1!==l.indexOf("%node-percent-value")||ZC._b_(t[e].dynamic)){a.YK=!0;break}}if(null!==ZC._n_(n=a.o.shapes))for(e=0,i=n.length;e<i;e++)if(ZC._b_(n[e].dynamic)){a.YK=!0;break}},ZC.JH.prototype.QK=function(e){var i=this;i.A0M(e),i.PW(),i.KK(e),ZC.SKIPMAPS=!1},ZC.JH.prototype.KK=function(e){void 0===e&&(e=!1);var i,t,n,a=this,l=[],o=[];function r(e){var i=a.YC[e];if(i.AN&&(i.Z=i.C7=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(i.JS<0?"bottom":"top")+"-c"),i.paint(),i.AN&&ZC.AL(a.A.K+"-map"))){var t=i.BF.A4Y(),n=ZC.Q.FW(t[0],i.BF.EA,i.BF.IP)+'class="'+a.K+'-arrow-area zc-arrow-area" id="'+i.BF.K+'-area" coords="'+t[1]+'" />';"top"===i.o.placement?o.push(n):l.push(n)}}function s(e){if(a.FH[e]){var t=a.FH[e],n=t instanceof ZC.P0?t.BF:t;if((!ZC.SKIPMAPS||!n.o["map-item"])&&n.AN){if(null!==ZC._n_(i=t.E.hook)){var r=a.UU(i);-1!==r[0]&&(n.iX=ZC._i_(r[0])),-1!==r[1]&&(n.iY=ZC._i_(r[1]))}if(!t.E["3d"]||t.E["3dtx"]){t.Z=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(n.JS<0?"bottom":"top")+"-c"),t.C7=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(n.JS<0?"bottom":"top")+"-sh-c"),n.o["map-item"]&&(t.Z=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-maps-c"),t.C7=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-maps-sh-c"));var s="";null!==ZC._n_(i=n.o.limit)&&("x"===i?s="x":"y"===i?s="y":"xy"===i&&(s="xy")),(""===s||"x"===s&&ZC.DS(n.iX-n.BL,a.P.iX-2,a.P.iX+a.P.I+2)||"y"===s&&ZC.DS(n.iY-n.BH,a.P.iY-2,a.P.iY+a.P.F+2)||"xy"===s&&ZC.DS(n.iX+n.BL,a.P.iX-2,a.P.iX+a.P.I-2)&&ZC.DS(n.iY+n.BH,a.P.iY-2,a.P.iY+a.P.F+2))&&(t.VN=!1,t.E["print-canvas"]=a.K+"-"+(n.o["map-item"]?"maps":"objects")+"-print-c",t.paint())}if(!t.K9&&!a.Q4&&"normal"===zingchart.OBJECTMODE){var A=n.A4Y();if(ZC.AL(a.A.K+"-map"))for(var C=1,c=A.length;C<c;C++)if(""!==A[C]){var u=n.o["map-item"]&&!n.o["map-skip-z-sort"]?' data-map="1"':"",p=ZC.Q.FW(A[0],n.EA,n.IP)+'class="'+a.K+'-shape-area zc-shape-area" id="'+n.K+"-area"+(C>1?"--"+C:"")+'" coords="'+A[C]+'" data-z-sort="'+n.A74+'"'+u+" />";if("top"===t.o.placement?o.push(p):l.push(p),t.M){var Z=[ZC._i_(t.M.iX+t.M.BL),ZC._i_(t.M.iY+t.M.BH),ZC._i_(t.M.iX+t.M.BL+t.M.I),ZC._i_(t.M.iY+t.M.BH+t.M.F)].join(",");p=ZC.Q.FW("rect",n.EA,n.IP)+'class="'+a.K+'-shape-area zc-shape-area" id="'+n.K+"-area"+(C>1?"--"+C:"")+'" coords="'+Z+'" data-z-sort="'+n.A74+'"'+u+" />","top"===t.o.placement?o.push(p):l.push(p)}}}}}}function A(e){var i=a.LH[e];if(i.AN)if(i.Z=i.C7=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(i.JS<0?"bottom":"top")+"-c"),null!==ZC._n_(i.o.repeat)&&ZC._b_(i.o.repeat)){var t=ZC._i_(ZC._c_(i.o.items,0)),n=null;if(i.o.inactive&&((n=new ZC.HL(i.A)).copy(i),n.append(i.o.inactive),n.parse(),n.Z=n.C7=i.Z),t>0||n){var l=ZC._i_(ZC._c_(i.o.rows,-1)),o=ZC._i_(ZC._c_(i.o.cols,-1)),r=ZC._i_(ZC._c_(i.o["space-x"],0)),s=ZC._i_(ZC._c_(i.o["space-y"],0)),A=ZC._i_(ZC._c_(i.o["offset-row"],0)),C=ZC._i_(ZC._c_(i.o["offset-col"],0));-1!==l&&-1===o?o=Math.ceil(t/l):-1===l&&-1!==o?l=Math.ceil(t/o):-1===l&&-1===o&&(o=Math.ceil(Math.sqrt(t)),l=Math.ceil(t/o));for(var c=i.iX,u=i.iY,p=i.K,Z=0;Z<l;Z++)for(var h=0;h<o;h++)i.iX=c+h*r+Z*A,i.iY=u+Z*s+h*C,i.K=p+(Z*o+h),Z*o+h<t?i.paint():n&&(n.iX=i.iX,n.iY=i.iY,n.K=i.K,n.paint())}else i.paint()}else i.paint()}function C(e){var t=a.BX[e];if(t.AN){if(t.E.lbltype="label",null!==ZC._n_(i=t.E.hook)){var n=a.UU(i);if(-1===n[0]&&-1===n[1])return;if(-1!==n[0]&&(t.iX=n[0]),-1!==n[1]&&(t.iY=n[1]),null===ZC._n_(n[2])||t.o.anchor||null!==ZC._n_(n[2].center)&&n[2].center&&(t.iX-=t.I/2,t.iY-=t.F/2),t.o.anchor&&t.setAnchor(),t.o["3d"]){var r=0;n[2]&&n[2].z?r=n[2].z:t.o.z&&(r=ZC._i_(t.o.z));var s=new ZC.CE(a,t.iX+t.I/2-ZC.AO.E2,t.iY+t.F/2-ZC.AO.E3,r);t.iX=s.ED[0]-t.I/2,t.iY=s.ED[1]-t.F/2}}t.iX=ZC._i_(t.iX),t.iY=ZC._i_(t.iY),t.IL=ZC.AL(a.A.K+"-text"),t.Z=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(t.JS<0?"bottom":"top")+"-c"),t.C7=a.H.usc()?a.H.mc("top"):ZC.AL(a.K+"-objects-"+(t.JS<0?"bottom":"top")+"-sh-c");var A="";if(null!==ZC._n_(i=t.o.limit)&&("x"===i?A="x":"y"===i?A="y":"xy"===i&&(A="xy")),(""===A||"x"===A&&ZC.DS(t.iX-t.BL,a.P.iX-t.I/2-2,a.P.iX+a.P.I-t.I/2+2)||"y"===A&&ZC.DS(t.iY-t.BH,a.P.iY-t.F/2-2,a.P.iY+a.P.F-t.F/2+2)||"xy"===A&&ZC.DS(t.iX+t.BL,a.P.iX-t.I/2-2,a.P.iX+a.P.I-t.I/2+2)&&ZC.DS(t.iY+t.BH,a.P.iY-t.F/2-2,a.P.iY+a.P.F-t.F/2+2))&&(t.VN=!1,t.paint(),t.EK(ZC.AL(a.K+"-objects-print-c")),!t.K9&&!a.Q4&&"normal"===zingchart.OBJECTMODE&&ZC.AL(a.A.K+"-map"))){var C=ZC.AP.O4(a.K,t);"top"===t.o.placement?o.push(C):l.push(C)}}}if(a.H.clearLabelBoxes("label"),a.FA)for(t=0,n=a.FA.length;t<n;t++){var c=a.FA[t].index;switch(a.FA[t].type){case"arrow":r(c);break;case"shape":s(c);break;case"image":A(c);break;case"label":C(c)}}for(t=0;t<a.AY.A5.length;t++)a.AY.A5[t].RJ=null;if(!e&&"normal"===zingchart.OBJECTMODE&&(o.length>0||l.length>0)&&ZC.AL(a.A.K+"-map")){if(a.A4C){var u=function(e,i){return-1!==e.indexOf("data-map")&&-1!==i.indexOf("data-map")?ZC.AP.N2(i)-ZC.AP.N2(e):ZC.AP.N2(e)-ZC.AP.N2(i)};o.sort(u),l.sort(u)}zingchart.DEV.MAPSONBOTTOM?window.setTimeout(function(){ZC.AL(a.A.K+"-map").innerHTML=o.join("")+ZC.AL(a.A.K+"-map").innerHTML+l.join("")},33):ZC.AL(a.A.K+"-map").innerHTML=o.join("")+ZC.AL(a.A.K+"-map").innerHTML+l.join("")}a.A.E["fire-load"]||ZC.AP.BY("objectsready",a.A,a.GX())},ZC.JH.prototype.SF=function(e,i,t,n){var a,l,o,r,s=this;switch(t=t||"hover",e){case"shape":var A=s.FH[i],C=A instanceof ZC.P0?A.BF:A;if(null!==ZC._n_(C.o[t+"-state"])){if(!n&&C.o.group)for(o=0,r=s.FH.length;o<r;o++)o!==i&&(s.FH[o].o.group===C.o.group||s.FH[o].BF&&s.FH[o].BF.o.group===C.o.group)&&s.SF(e,o,t,!0);if((a=new ZC.DT(s)).append(C.o),a.append(C.o[t+"-state"]),l=C.o.id||i,a.H5=l+"-"+t,a.K=s.K+"-shape-"+l+"-"+t,a.parse(),A.E["3d"]&&(a.D=C.D,a.iX=A.iX,a.iY=A.iY),a.AN)if(a.Z=a.C7=ZC.AL(s.K+"-objects-"+t+"-c"),a.o["map-item"]&&(a.Z=a.C7=ZC.AL(s.K+"-objects-maps-"+t+"-c")),a.o["map-item"]&&zingchart.maps.LITE&&"canvas"!==s.A.AB){if("svg"===s.A.AB){var c=ZC.A4("#"+s.K+"-shape-"+a.H5+"-gshape-path");s.E["map-shape-info"]={fill:c.attr("fill"),stroke:c.attr("stroke"),"stroke-width":c.attr("stroke-width")},"poly"===a.DU?(c.attr("fill",a.A0),c.attr("stroke-width",a.AU),c.attr("stroke",a.BW)):"line"===a.DU&&(c.attr("stroke-width",a.AZ),c.attr("stroke",a.B7))}else if("vml"===s.A.AB){var u=ZC.AL(s.K+"-shape-"+a.H5+"-gshape-path"),p=ZC.A4(u.childNodes[1]),Z=ZC.A4(u.childNodes[2]);s.E["map-shape-info"]={fill:""+Z.attr("color"),stroke:""+p.attr("color"),"stroke-width":""+p.attr("weight")},"poly"===a.DU?(Z.attr("color",a.A0),p.attr("weight",a.AU),p.attr("color",a.BW)):"line"===a.DU&&(p.attr("weight",a.AZ),p.attr("color",a.B7))}}else a.paint(),"canvas"===s.A.AB&&zingchart.CANVASTEXT&&A.M&&(A.M.Z=A.M.C7=ZC.AL(s.K+"-objects-"+t+"-c"),A.M.paint())}break;case"label":var h=s.BX[i];if(h&&null!==ZC._n_(h.o[t+"-state"])){if(!n&&h.o.group)for(o=0,r=s.BX.length;o<r;o++)o!==i&&s.BX[o].o.group===h.o.group&&s.SF(e,o,t,!0);var d=zingchart.pool.getInstance("DN",s,s.K+"-label-"+t);d.append(h.o),d.append(h.o[t+"-state"]),l=h.id||i,d.H5=l+"-"+t,d.K=s.K+"-label-"+l+"-"+t,d.GL=s.K+"-label "+s.K+"-label-"+t+" zc-label zc-label-"+t,d.IL=ZC.AL(s.A.K+"-text"),d.parse(),d.AN&&(d.iX=h.iX,d.iY=h.iY,d.I=h.I,d.F=h.F,d.Z=d.C7=ZC.AL(s.K+"-objects-"+t+"-c"),ZC.AL(s.K+"-label-"+l)&&(ZC.AL(s.K+"-label-"+l).style.display="none"),d.paint())}}},ZC.JH.prototype.RW=function(){var e,i,t,n=this;(n.H.NR["objects-top"]||n.H.NR["objects-bottom"])&&(n.A05=function(e){ZC.mobile&&(n.LD(),ZC.move=!1,n.H.hideCM(),null===n.H.DG||null===ZC._n_(n.H.DG["page-scroll"])||n.H.DG["page-scroll"]||e.preventDefault(),n.A.YI(e));var i=a(e);i.tooltip&&n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmouseover(e);var t=ZC.mobile?"mousedown":e.xtype||e.type;i.lowlevel||n.SF("shape",i.shapeindex),n.S1(t,i)},n.A0U=function(e){ZC.mobile&&(n.H.AA9||ZC.move||(zingchart.S8(e),n.UA(e)),n.A.OT(e)),n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmouseout(e),ZC.mobile||n.LD();var i=ZC.mobile?"mouseup":e.xtype||e.type,t=a(e);if(t.shape&&t.shape.mapItem&&zingchart.maps.LITE&&"canvas"!==n.A.AB)if("svg"===n.A.AB){var l=ZC.A4("#"+n.K+"-shape-"+t.shape.id+"-gshape-path");"poly"===t.shape.type&&l.attr("fill",n.E["map-shape-info"].fill),l.attr("stroke",n.E["map-shape-info"].stroke),l.attr("stroke-width",n.E["map-shape-info"]["stroke-width"])}else if("vml"===n.A.AB){var o=ZC.AL(n.K+"-shape-"+t.shape.id+"-gshape-path"),r=o.childNodes[1],s=o.childNodes[2],A=n.E["map-shape-info"];"poly"===t.shape.type&&ZC.Q.G3(s,{color:A.fill}),ZC.Q.G3(r,{weight:A["stroke-width"],color:A.stroke})}n.S1(i,t)},n.A03=function(e){var i=a(e);i.tooltip&&n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmousemove(e),n.S1("mousemove",i)},n.UA=function(e){var i=a(e);if("dblclick"!==e.type){e.ctrlKey||n.LD("click"),n.TE=n.TE||{},n.TE["s_"+i.shapeid]?(n.TE["s_"+i.shapeid]=null,n.LD("click")):(e.ctrlKey||(n.TE={}),n.TE["s_"+i.shapeid]=1,n.SF("shape",i.shapeindex,"click")),n.S1("click",i);var t=n.FH[i.shapeindex].BF||n.FH[i.shapeindex];if(ZC.mobile&&(n.E["click-ts"]&&(new Date).getTime()-n.E["click-ts"]<500&&n.S1("dblclick",i),n.E["click-ts"]=(new Date).getTime()),t&&t.EA&&"NULL"!==t.EA)if(t.EA instanceof Array)for(var l=0;l<t.EA.length;l++)null!==ZC._n_(t.FC[l])&&n.V4(e,t.EA[l],t.FC[l]);else n.V4(e,t.EA,t.FC)}else n.S1("dblclick",i)},ZC.A4("."+n.K+"-shape-area").live(ZC.mobile?"touchstart":"mousedown mouseover",n.A05).live(ZC.mobile?"touchend":"mouseup mouseout",n.A0U).live(ZC.mobile?"touchmove":"mousemove",n.A03),ZC.mobile||ZC.A4("."+n.K+"-shape-area").live("click",n.UA).live("dblclick",n.UA),n.A07=function(e){ZC.mobile&&(n.LD(),ZC.move=!1,n.H.hideCM(),null===n.H.DG||null===ZC._n_(n.H.DG["page-scroll"])||n.H.DG["page-scroll"]||e.preventDefault(),n.A.YI(e));var i=l(e);if(i.tooltip&&n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmouseover(e),null!==i&&"label"===i.type){var t=ZC.mobile?"mousedown":e.xtype||e.type;i["data-active"]||n.SF("label",i.labelindex),n.RT(t,i)}},n.A0S=function(e){ZC.mobile&&(n.H.AA9||ZC.move||(zingchart.S8(e),n.UO(e)),n.A.OT(e)),n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmouseout(e),ZC.mobile||n.LD();var i=l(e);if(null!==i){var t=ZC.mobile?"mouseup":e.xtype||e.type;ZC.AL(n.K+"-label-"+i.label.id)&&(ZC.AL(n.K+"-label-"+i.label.id).style.display="block"),n.RT(t,i)}},n.A06=function(e){var i=l(e);i.tooltip&&n.A7&&n.A.A7&&n.A7.AN&&n.A.A7.onmousemove(e),n.RT("mousemove",i)},n.UO=function(e){var i=l(e);if("dblclick"!==e.type){e.ctrlKey||n.LD("click"),n.TE=n.TE||{},n.TE["l_"+i.labelid]?(n.TE["l_"+i.labelid]=null,n.LD("click")):(e.ctrlKey||(n.TE={}),n.TE["l_"+i.labelid]=1,n.SF("label",i.labelindex,"click")),n.RT("click",i),ZC.mobile&&(n.E["click-ts"]&&(new Date).getTime()-n.E["click-ts"]<500&&n.RT("dblclick",i),n.E["click-ts"]=(new Date).getTime());var t=n.BX[i.labelindex];if(!t)switch(i.type){case"graph-title":t={EA:n.IQ.EA,FC:n.IQ.FC};break;case"graph-subtitle":t={EA:n.K1.EA,FC:n.K1.FC};break;case"graph-source":t={EA:n.MU.EA,FC:n.MU.FC}}if(t&&t.EA&&"NULL"!==t.EA)if(t.EA instanceof Array)for(var a=0;a<t.EA.length;a++)null!==ZC._n_(t.FC[a])&&(t.EA[a]=t.EA[a].replace("%id",n.A.K),t.EA[a]=t.EA[a].replace("%graphid",n.K.replace(n.A.K+"-graph-","")),n.V4(e,t.EA[a],t.FC[a]));else t.EA=t.EA.replace("%id",n.A.K),t.EA=t.EA.replace("%graphid",n.K.replace(n.A.K+"-graph-","")),n.V4(e,t.EA,t.FC)}else n.RT("dblclick",i)},ZC.A4("."+n.K+"-label-area").live(ZC.mobile?"touchstart":"mousedown mouseover",n.A07).live(ZC.mobile?"touchend":"mouseup mouseout",n.A0S).live(ZC.mobile?"touchmove":"mousemove",n.A06),ZC.mobile||ZC.A4("."+n.K+"-label-area").live("click",n.UO).live("dblclick",n.UO));function a(e){for(var i=(e.targetid||e.target.id).replace(/\-\-\d+/g,"").replace(n.K+"-shape-","").replace("-gshape-area","").replace("-area",""),t=-1,a=null,l=0,o=n.FH.length;l<o;l++)if(n.FH[l]&&""+n.FH[l].H5==""+i){t=l,a=n.FH[l]instanceof ZC.P0?n.FH[l].BF:n.FH[l];break}if(!a&&e.target.getAttribute("data-lowlevel"))return{shapeid:e.target.id,lowlevel:!0,ev:e};if(-1===t)return null;var r={shapeid:i,shapeindex:t,tooltip:a.o.tooltip?1:0,shape:{id:i,index:t,cls:a.DH,x:a.iX,y:a.iY,type:a.DU,mapItem:a.o["map-item"],points:a.D,width:a.I,height:a.F,size:a.AI,size2:a.JO,angle:a.A9,zIndex:a.JS},ev:e};for(var s in a.o)a.o.hasOwnProperty(s)&&"data-"===s.substring(0,5)&&(r[s]=a.o[s]);return r}function l(a){var l,o=a.targetid||a.target.id;if(o===n.K+"-title-area"||o===n.K+"-subtitle-area"||o===n.K+"-source-area"){var r=null,s=-1;switch(l=o.replace(n.K+"-","").replace("-area","")){case"title":r=n.IQ,s=-1;break;case"subtitle":r=n.K1,s=-2;break;case"source":r=n.MU,s=-3}return{type:"graph-"+l,labelid:r.K,labelindex:s,text:r.AM,label:{id:r.K,index:s,text:r.AM},ev:a}}if(-1===o.indexOf("-scale")||-1===o.indexOf("-item")&&-1===o.indexOf("-marker")){if(-1!==o.indexOf("-value-box-")){e=o.replace(n.K+"-plotset-plot-","").replace("-value-box-area",""),i=e.split("-node-");var A=n.AY.A5[ZC._i_(i[0])].FK(ZC._i_(i[1]));return A?{type:"value-box",labelid:"vb_"+i.join("_"),plotindex:ZC._i_(i[0]),nodeindex:ZC._i_(i[1]),text:A.AD,label:{id:"vb_"+i.join("_"),text:A.AD},ev:a}:null}e=o.replace(n.K+"-label-","").replace("-area","");for(var C=-1,c=null,u=0,p=n.BX.length;u<p;u++)if(""+n.BX[u].H5==""+e){C=u,c=n.BX[u];break}if(t=-1===C?"":n.BX[C].AM,-1===C)return null;var Z={type:"label",labelid:e,labelindex:C,text:t,tooltip:c.o.tooltip?1:0,label:{id:e,index:C,cls:c.DH,x:c.iX+c.BL,y:c.iY+c.BH,width:c.I,height:c.F,text:t},ev:a};for(var h in c.o)c.o.hasOwnProperty(h)&&"data-"===h.substring(0,5)&&(Z[h]=c.o[h]);return Z}e=o.replace(n.K+"-","").replace("-area","");var d=(i=e.split("-"))[1].split("_"),f=0;2===d.length?f=ZC._i_(d[1]):3===d.length&&(f=ZC._i_(d[2]));var _,g=i[0].replace(/_/g,"-"),v=n.BM(g);return-1!==o.indexOf("-item")?(l="scale-item",_="si_"+i[1].replace("item_",""),t=v.BX[f]||v.V[f],"si_title"===_&&(t=v.M.AM)):(l="scale-marker",_="sm_"+i[1].replace("marker_",""),t=v.E["marker_text_"+f]||""),{type:l,labelid:_,labelindex:f,scale:g,text:t,tooltip:v.o.tooltip||v.o.item&&v.o.item.tooltip?1:0,label:{id:_,index:f,text:t},ev:a}}},ZC.JH.prototype.RT=function(e,i){ZC._cp_(this.GX(),i),i.ev=ZC.A4.BZ(i.ev),ZC.AP.BY("label_"+e,this.A,i)},ZC.JH.prototype.S1=function(e,i){ZC._cp_(this.GX(),i),i.ev=ZC.A4.BZ(i.ev),ZC.AP.BY("shape_"+e,this.A,i)},ZC.JH.prototype.UU=function(e){var i,t,n=this;if("string"==typeof e){var a={},l=e.split(":");if(2===l.length){a.type=l[0];for(var o=0,r=(l=l[1].split(/\s|,|;/)).length;o<r;o++){var s=l[o].split("=");a[s[0]]=s[1]}}e=a}var A=[-1,-1];switch(n.E.hooks=!0,e.type){case"scale":var C,c,u,p="",Z=-1,h=null;if(null!==ZC._n_(i=e.name)&&(p=i),null!==ZC._n_(i=e.index)&&(Z=ZC._i_(i)),null!==ZC._n_(i=e.value)&&(h=ZC._i_(i)),t=null,""===p&&(p="scale-x"),t=n.BM(p))switch(t.IB&&-1!==Z?u=t.IB(Z):t.AT&&(null!==ZC._n_(h)?u=t.AT(h):-1!==Z&&(u=t.AT(t.V[Z]))),n.AJ.layout){case"radar":case"gauge":C=u[0],c=u[1];break;case"xy":"k"===t.AF?(C=u,c=t.iY,"default"===t.BA&&(c+=t.F)):"v"===t.AF&&(c=u,C=t.iX,"opposite"===t.BA&&(C+=t.I));break;case"yx":"k"===t.AF?(c=u,C=t.iX,"opposite"===t.BA&&(C+=t.I)):"v"===t.AF&&(C=u,c=t.iY,"default"===t.BA&&(c+=t.F))}A=[C,c,{center:!0}];break;case"node":var d=-1,f=null,_=null,g=null,v=null;null!==ZC._n_(i=e.plot)&&(g=i),null!==ZC._n_(i=e.plotindex)&&(g=i),null!==ZC._n_(i=e.plotid)&&(v=i);var b=n.I0(g,v);null!==ZC._n_(i=e.index)&&(d=ZC._i_(i)),null!==ZC._n_(i=e.value)&&(f=i),null!==ZC._n_(i=e.keyvalue)&&(_=i);var B=null;if(b){if(-1!==d&&b.S[d])B=b.FK(d,3);else if(null!==ZC._n_(f)||null!==ZC._n_(_)){var m,E;if(t=b.C.BM(b.BO[0]),null!==_&&null===f&&b.S.length>4096&&t.F5&&"date"===t.F5.o.type&&null!==(m=ZC._nfind_(_,b,0,b.S.length-1))&&(B=b.FK(m,3)),!B)for(m=0,E=b.S.length;m<E;m++)b.S[m]&&(null!==f&&b.S[m].AD==f&&(B=b.FK(m,3)),null!==_&&null!==ZC._n_(b.S[m].BT)&&b.S[m].BT==_&&(B=b.FK(m,3)))}B&&(B.setup(),A=B.UU(e),!B.JE&&ZC.DS(A[0],n.P.iX,n.P.iX+n.P.I)&&ZC.DS(A[1],n.P.iY,n.P.iY+n.P.F)&&(B.JE=!0),B.JE&&B.AN&&B.A.AN&&B.C.E["plot"+B.A.L+".visible"]||(A=[-1,-1])),b.E["z-mid"]&&(A[2].z=b.E["z-mid"])}}return null!==ZC._n_(e.x)&&(A[0]=ZC._i_(e.x)),null!==ZC._n_(e.y)&&(A[1]=ZC._i_(e.y)),null!==ZC._n_(i=e["offset-x"])&&(A[0]+=ZC._i_(i)),null!==ZC._n_(i=e["offset-y"])&&(A[1]+=ZC._i_(i)),A},zingchart.AB5=function(e,i,t){document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f=!(null!==ZC._n_(t.update)&&!ZC._b_(t.update)),_=!!t.dynamic&&ZC._b_(t.dynamic),g=zingchart.getLoader(e);if(g)switch(i){case"addobject":if((n=g.C8(t.graphid))&&t.data){if(c=(C=t.data instanceof Array)?[]:{},ZC._cp_(t.data,c),a=t.type||"label",C)for(r=0,s=c.length;r<s;r++)a=t.type||c[r].objtype||"label",n.o[a+"s"]||(n.o[a+"s"]=[]),_&&(c[r]["map-item"]=!1),n.o[a+"s"].push(c[r]);else n.o[a+"s"]||(n.o[a+"s"]=[]),_&&(c["map-item"]=!1),n.o[a+"s"].push(c);f&&(n.OW(),n.QK(_))}t.callback&&"function"==typeof t.callback&&t.callback(t);break;case"removeobject":if(n=g.C8(t.graphid),t["class"]&&(t.cls=t["class"]),n&&(t.id||t.cls||t.group)){a=t.type||"label",A=n.o[a+"s"]||[],l=t.id?"string"==typeof t.id?[t.id]:t.id:[],o=t.cls?"string"==typeof t.cls?[t.cls]:t.cls:[],u=!1;var v=[];for(r=A.length-1;r>=0;r--)(null!==ZC._n_(A[r].id)&&-1!==ZC.AV(l,A[r].id)||null!==ZC._n_(A[r].cls)&&-1!==ZC.AV(o,A[r].cls)||null!==ZC._n_(A[r]["class"])&&-1!==ZC.AV(o,A[r]["class"])||t.group&&A[r].group===t.group)&&(null!==ZC._n_(A[r].id)&&v.push(A[r].id),A.splice(r,1),u=!0);for(r=0;r<v.length;r++)ZC.Q.EU([n.K+"-label-"+v[r]+"-gradient",n.K+"-label-"+v[r]+"-top-gradient",n.K+"-shape-"+v[r]+"-gradient",n.K+"-shape-"+v[r]+"-top-gradient",n.K+"-shape-"+v[r]+"-gshape-gradient",n.K+"-shape-"+v[r]+"-gshape-top-gradient"]);u&&f&&(n.OW(),n.QK(_))}t.callback&&"function"==typeof t.callback&&t.callback(t);break;case"updateobject":if(t["class"]&&(t.cls=t["class"]),(n=g.C8(t.graphid))&&t.data){n.E["objects.updates"]=[],a=t.type||"label",A=n.o[a+"s"]||[],d="label"===a?n.BX:n.FH,c=(C=t.data instanceof Array)?[]:{},ZC._cp_(t.data,c),u=!1;var b=!0,B=function(e,i){var t,l,o,r=n.XF[e.id||""],s=!1;if(r&&("label"===r.shape?(o=n.BX[r.idx],Object.keys&&3===Object.keys(e).length&&null!==ZC._n_(e.x)&&null!==ZC._n_(e.y)&&(o.iX=e.x,o.iY=e.y,s=!0)):((o=n.FH[r.idx]).BF&&o.BF.o["map-item"]&&(b=!1),"circle"===r.shape?Object.keys&&3===Object.keys(e).length&&null!==ZC._n_(e.x)&&null!==ZC._n_(e.y)&&(o.BF?(o.BF.iX=e.x,o.BF.iY=e.y):(o.iX=e.x,o.iY=e.y),s=!0):"line"===r.shape&&Object.keys&&2===Object.keys(e).length&&null!==ZC._n_(e.points)&&(o.BF?o.BF.D=e.points:o.D=e.points,s=!0))),s||n.E["objects.updates"].push(e.id),ZC._cp_(e,i),null!==ZC._n_(e.animation)){var A=null;if("label"===a){for(t=0,l=n.BX.length;t<l;t++)if(n.BX[t].H5===e.id){A=n.BX[t];break}}else if("shape"===a)for(t=0,l=n.FH.length;t<l;t++)if(n.FH[t].H5===e.id){A=n.FH[t]instanceof ZC.P0?n.FH[t].BF:n.FH[t];break}var C=n.LZ,c={};if(ZC._cp_(e,c),null!==ZC._n_(c.x)&&(c.x+=n.iX),null!==ZC._n_(c.y)&&(c.y+=n.iY),null!==ZC._n_(c.points))for(t=0,l=c.points.length;t<l;t++)null!==ZC._n_(c.points[t])&&(c.points[t][0]+=n.iX,c.points[t][1]+=n.iY,null!==ZC._n_(c.points[t][2])&&(c.points[t][2]+=n.iX),null!==ZC._n_(c.points[t][3])&&(c.points[t][3]+=n.iY));c.animation=null;var p=new ZC.E4(A,c,ZC._i_(e.animation.speed||"300"),ZC._i_(e.animation.delay||"0"),ZC.E4.RK[ZC._i_(e.animation.method||"0")],function(){null!==ZC._n_(e.animation.end)&&e.animation.end.call()});n.Q4=!0,window.setTimeout(function(){C.add(p)},33)}u=!0};if(C){var m=!1,E=!1;for(r=0,s=c.length;r<s;r++){if(null!==ZC._n_(c[r].objtype)&&(A=n.o[c[r].objtype+"s"]),A)for(p=0,Z=A.length;p<Z;p++)null!==ZC._n_(c[r].id)&&null!==ZC._n_(A[p].id)&&A[p].id===c[r].id&&B(c[r],A[p]);null!==ZC._n_(c[r].animation)?m=!0:E=!0,E&&m&&(ZC.SKIPMAPS=b,n.PW())}}else if(t.group)for(p=0,Z=A.length;p<Z;p++)A[p].group===t.group&&(c.id=A[p].id,B(c,A[p]));else if(t.cls)for(p=0,Z=A.length;p<Z;p++)A[p].cls===t.cls&&(c.id=A[p].id,B(c,A[p]));else for(e=c.id||t.id,p=0,Z=A.length;p<Z;p++)null!==ZC._n_(A[p].id)&&null!==ZC._n_(e)&&A[p].id===e&&(c.id=e,B(c,A[p]));ZC.SKIPMAPS=b,!u||!f&&n.Q4||n.Q4||(n.OW(),n.QK(_))}t.callback&&"function"==typeof t.callback&&t.callback(t);break;case"repaintobjects":(n=g.C8(t.graphid))&&(n.OW(),n.QK(_)),t.callback&&"function"==typeof t.callback&&t.callback(t);break;case"getallobjects":if(l=[],n=g.C8(t.graphid))for(a=t.type||"label",r=0,s=(A=n.o[a+"s"]||[]).length;r<s;r++)null!==ZC._n_(A[r].id)&&l.push(A[r].id);return l;case"getobjectsbyclass":if(t["class"]&&(t.cls=t["class"]),l=[],(n=g.C8(t.graphid))&&t.cls){a=t.type||"label",A=n.o[a+"s"]||[];var D=t.cls instanceof Array?t.cls:[t.cls];for(r=0,s=A.length;r<s;r++)-1===ZC.AV(D,A[r].cls)&&-1===ZC.AV(D,A[r]["class"])||null===ZC._n_(A[r].id)||l.push(A[r].id)}return l;case"getlabelinfo":case"getshapeinfo":var F={x:"iX",y:"iY",width:"I",height:"F",color:"C2",lineColor:"B7",lineWidth:"AZ",borderColor:"BW",borderWidth:"AU",backgroundColor1:"A0",backgroundColor2:"AE",size:"AI",type:"DU",text:"AM",fontSize:"DI",callout:"KT",calloutPosition:"EM",offsetX:"BL",offsetY:"BH"};if(n=g.C8(t.graphid),a=t.type||"label","getlabelinfo"===i&&"label"!==a||"getshapeinfo"===i&&"shape"!==a)return null;if(e=t.id||"",n&&""!==e){d=[],"label"===a?d=n.BX:"shape"===a&&(d=n.FH);var K=null;for(r=0,s=d.length;r<s;r++)d[r].H5===e&&(K=d[r]);if(K){var x={};if("shape"===a){if(K.M)for(h in x.label={},F)x.label[h]=K.M[F[h]];K.BF&&(K=K.BF)}for(h in F)x[h]=K[F[h]];return x}}return null;case"setobjectsmode":zingchart.OBJECTMODE="normal",t.mode&&"flat"===t.mode&&(zingchart.OBJECTMODE="flat");break;case"settweenmode":ZC.objmove=!1,t.mode&&"position"===t.mode&&(ZC.objmove=!0)}return null},ZC.JH.prototype.A2Z=function(){var e,i,t=this,n=0;for(e=0,i=t.BO.length;e<i;e++)"k"===t.BO[e].AF&&t.o[t.BO[e].BE]&&t.o[t.BO[e].BE].values&&(n=ZC.BQ(n,t.o[t.BO[e].BE].values.length));for(e=0,i=t.AY.A5.length;e<i;e++)null!==ZC._n_(t.o.series[e])&&t.o.series[e].values&&(n=ZC.BQ(n,t.o.series[e].values.length));return n},ZC.JH.prototype.U7=function(){var e,i=this;if(i.HP)for(var t=i.A2Z(),n=0,a=i.BO.length;n<a;n++)"k"===i.BO[n].AF&&(i.BO[n].CO?(e=(i.BO[n].F-i.BO[n].AC-i.BO[n].BV)/ZC._i_(i.HP["max-ticks"]),i.BO[n].OL=ZC.BQ(0,i.BO[n].F-t*e)):(e=(i.BO[n].I-i.BO[n].AC-i.BO[n].BV)/ZC._i_(i.HP["max-ticks"]),i.BO[n].OL=ZC.BQ(0,i.BO[n].I-t*e)),ZC._b_(i.HP["adjust-scale"])&&(i.BO[n].OL=0),i.BO[n].AC=i.BO[n].A46+i.BO[n].OL,i.A.E[i.BO[n].BE+"-feed-offset-start"]=i.BO[n].AC,i.BO[n].W=ZC.BQ(0,i.BO[n].A1-i.HP["max-ticks"]+1),i.BO[n].IZ())},ZC.JH.prototype.AC2=function(){var s=this,G,MO,ws;if(s.E["from-api"]&&(window.clearTimeout(ZC.REFRESH_TICK[s.K]),delete s.E["from-api"]),s.HP){var OP=ZC._i_(s.HP.interval);if(OP=OP>=50?OP:1e3*OP,"full"===s.HP.type)"http"===s.HP.transport?ZC.REFRESH_TICK[s.K]=window.setTimeout(function(){s.A.N4(s),ZC.ZJ(function(){s.A.load(s.K,s.A9Q)})},OP):"websockets"===s.HP.transport&&ZC.websockets&&(s.H.S9[s.K]?"pull"===s.HP.method&&(ZC.REFRESH_TICK[s.K]=window.setTimeout(function(){s.H.S9[s.K].send("zingchart.getdata")},OP)):(ws=new WebSocket(s.HP.url,"zingchart"),ws.onopen=function(){ws.send("zingchart."+s.HP.type),ws.send("zingchart."+s.HP.method),ws.send("zingchart.getdata")},ws.onmessage=function(e){"ready"===s.ME&&(s.A.N4(s),s.ME="full",ZC.ZJ(function(){zingchart.exec(s.A.K,"setdata",{graphid:s.K,data:e.data,softclear:!0})}))},s.H.S9[s.K]=ws));else if("feed"===s.HP.type&&null!==ZC._n_(s.HP.url)){if(null!==ZC._n_(s.HP.curtain)){var O8=s.BU("k");if(O8.length>0&&(ZC.Q.EU(s.K+"-curtain-t"),O8[0].OL>0)){var LT=new ZC.DN(s);s.A.B8.load(LT.o,"("+s.AF+").refresh.curtain"),LT.append(s.HP.curtain),LT.parse(),LT.AN&&(O8[0].CO&&LT.F<=O8[0].OL||!O8[0].CO&&LT.I<=O8[0].OL)&&(LT.K=s.K+"-curtain-t",LT.IL=ZC.AL(s.A.K+"-text-top"),O8[0].CO?(LT.F>O8[0].OL&&(LT.AM="",LT.parse()),LT.iX=s.P.iX,LT.iY=O8[0].AW?s.P.iY:s.P.iY+s.P.F-O8[0].OL,LT.I=s.P.I,LT.F=O8[0].OL):(LT.I>O8[0].OL&&(LT.AM="",LT.parse()),LT.iX=O8[0].AW?s.P.iX+s.P.I-O8[0].OL:s.P.iX,LT.iY=s.P.iY,LT.I=O8[0].OL,LT.F=s.P.F),LT.Z=LT.C7=ZC.AL(s.K+"-scales-ml-0-c"),LT.paint())}}var A12=s.HP.transport,A45=ZC._i_(s.HP["reset-timeout"]),A5A=ZC._i_(s.HP["stop-timeout"]),A97=ZC._b_(s.HP.storage),A08=!0;null!==ZC._n_(s.HP["preserve-data"])&&(A08=ZC._b_(s.HP["preserve-data"]));var A4M=function(KC){for(var U0=eval("("+KC+")"),i,A6,A8M=U0 instanceof Array?U0:[U0],r=0,rLen=A8M.length;r<rLen;r++){var DL=A8M[r];for(i=0,A6=s.BO.length;i<A6;i++)if("k"===s.BO[i].AF){var BE=s.BO[i].BE;null!==ZC._n_(DL[BE])&&null!==ZC._n_(s.o[BE])&&(null===ZC._n_(s.o[BE].values)&&(s.H.o.graphset[s.L][BE].values=[],s.o[BE].values=[]),s.o[BE].values.push(DL[BE]),!A08&&s.o[BE].values.length>ZC._i_(s.HP["max-ticks"])&&s.o[BE].values.splice(0,1),s.H.o.graphset[s.L][BE].values.push(DL[BE]),(s.o[BE].values.length>A45||1===s.MD[1])&&(s.H.o.graphset[s.L][BE].values=[],s.o[BE].values=[],s.H.E["graph"+s.L+".zoom"]&&(s.H.E["graph"+s.L+".zoom"].xmin=null,s.H.E["graph"+s.L+".zoom"].xmax=null),s.HS&&(s.HS.unbind(),ZC.Q.IV(ZC.AL(s.K+"-scroll-x-c"),s.A.AB,s.iX,s.iY,s.I,s.F,s.K),ZC.A4("#"+s.K+"-scroll-x-handle").remove(),ZC.A4("#"+s.K+"-scroll-x-bar").remove()),s.HQ&&(s.HQ.unbind(),ZC.Q.IV(ZC.AL(s.K+"-scroll-y-c"),s.A.AB,s.iX,s.iY,s.I,s.F,s.K),ZC.A4("#"+s.K+"-scroll-y-handle").remove(),ZC.A4("#"+s.K+"-scroll-y-bar").remove())),ZC.webstorage&&A97&&ZC.AP.storage.push("zingchart.scale."+s.K+"."+BE,""+DL[BE]))}for(i=0,A6=s.AY.A5.length;i<A6;i++)if(null!==ZC._n_(s.o.series[i])){var A3I=null;null!==ZC._n_(G=DL["plot-"+i])?A3I=G:null!==ZC._n_(G=DL["plot"+i])&&(A3I=G),"xy"===s.AJ.layout||"yx"===s.AJ.layout?(s.H.o.graphset[s.L].series[i].values.push(A3I),!A08&&s.H.o.graphset[s.L].series[i].values.length>ZC._i_(s.HP["max-ticks"])&&s.H.o.graphset[s.L].series[i].values.splice(0,1)):s.H.o.graphset[s.L].series[i].values=[A3I],ZC.webstorage&&A97&&(G=DL["plot"+i],"object"==typeof G&&(G=G.join("###")),ZC.AP.storage.push("zingchart.plot."+s.K+".plot"+i,""+G)),(s.o.series[i].values.length>A45||1===s.MD[1])&&(ZC.AP.BY("feed_clear",s.A,s.GX(),DL),s.H.o.graphset[s.L].series[i].values=[])}MO=s.A2Z()}("ready"===s.ME||s.GD)&&(1===s.MD[1]&&(s.MD[1]=0),(MO<=A5A||0===A5A)&&(s.ME="feed",ZC.ZJ(function(){ZC.AL(s.A.K+"-main")&&(ZC.AP.BY("feed_step",s.H,s.GX(),s.o),s.parse(),s.clear(!0),s.U7(),s.paint(!0,!0))})))};if("http"===A12||"js"===A12){var EA=s.HP.url;ZC.REFRESH_TICK[s.K]=window.setTimeout(function(){if(1===s.MD[0]||1===s.MD[1])if(s.A.N4(s),"http"===A12){var EV=["query-string"===s.A.N6?"zcrandom="+Math.random():"",zingchart.ZCOUTPUT?"zcoutput="+s.H.AB:""].join("&");ZC.A4.ajax({type:"GET",url:EA,beforeSend:function(e){s.A.RV.data||"http-headers"!==s.A.N6||e.setRequestHeader("If-Modified-Since","Thu, 01 Jan 1970 00:00:00 GMT")},data:EV,dataType:"text",error:function(){},success:function(e){A4M(e)}})}else if("()"===EA.substring(EA.length-2)||"javascript:"===EA.substring(0,11))try{var EC=EA.replace("javascript:","").replace("()","");eval(EC)&&eval(EC).call(s,function(e){A4M(e)},s.GX())}catch(e){}},OP)}else"websockets"===A12&&ZC.websockets&&(s.H.S9[s.K]?"pull"===s.HP.method&&(ZC.REFRESH_TICK[s.K]=window.setTimeout(function(){s.H.S9[s.K].send("zingchart.getdata")},OP)):(ws=new WebSocket(s.HP.url,"zingchart"),ws.onopen=function(){ws.send("zingchart."+s.HP.type),ws.send("zingchart."+s.HP.method),ws.send("zingchart.startfeed"),"pull"===s.HP.method&&ws.send("zingchart.getdata")},ws.onmessage=function(e){1!==s.MD[0]&&1!==s.MD[1]||A4M(e.data)},s.H.S9[s.K]=ws))}}},zingchart.ABH=function(e,i,t){var n;document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var a=zingchart.getLoader(e);if(a){var l=a.C8(t.graphid);switch(i){case"clearfeed":l.MD[1]=1,0===l.MD[0]&&ZC.ZJ(function(){l.parse(),l.clear(!0),l.U7(),l.paint(!0,!0)});break;case"getinterval":return l.HP.interval;case"setinterval":ZC.AP.BY("feed_interval_modify",a,l.GX()),l.o.refresh=l.o.refresh||{},l.o.refresh.interval=t.interval||1;break;case"stopfeed":1===l.MD[0]&&(ZC.AP.BY("feed_stop",a,l.GX()),l.MD[0]=0,null!==ZC._n_(n=a.S9[l.K])&&n.send("zingchart.stopfeed"));break;case"startfeed":0===l.MD[0]&&(ZC.AP.BY("feed_start",a,l.GX()),l.MD[0]=1,null!==ZC._n_(n=a.S9[l.K])&&n.send("zingchart.startfeed"),ZC.ZJ(function(){l.parse(),l.clear(!0),l.U7(),l.paint(!0,!0)}))}}return null},ZC.AP.A48=function(e){for(var i={},t=[],n=0,a=(t="object"==typeof e?e:JSON.parse(e)).length;n<a;n++)if(null!==ZC._n_(e=t[n])){i["p"+n]={};var l=[];if("object"==typeof e)l=e;else if("string"==typeof e&&/\d+\-\d+/.test(e)){var o=e.split("-");if(2===o.length){l=[];for(var r=ZC._i_(o[0]);r<=ZC._i_(o[1]);r++)l.push(r)}}else l=[e];for(var s=0,A=l.length;s<A;s++)i["p"+n]["n"+l[s]]=!0}return i},ZC.JH.prototype.AC1=function(){var e,i=this;null!==ZC._n_(e=i.o.selection)&&(i.CB=ZC.AP.A48(e),i.o.selection=null)},zingchart.AAQ=function(e,i,t){var n,a,l,o,r,s,A,C,c;document.getElementById("zc-fullscreen")&&(e="zc-fullscreen"),"string"==typeof(t=t||{})&&(t=JSON.parse(t));var u=zingchart.getLoader(e);if(u)switch(i){case"clearselection":if(a=u.C8(t.graphid)){for(a.CB={},l=0,o=a.AY.A5.length;l<o;l++)a.IX[l]=!1;a.HH=!0,a.clearPreview(),a.K6(!0,!0)}break;case"getselection":if(a=u.C8(t.graphid)){for(s=[],l=0,o=a.AY.A5.length;l<o;l++)if(s[l]=null,null!==ZC._n_(a.CB["p"+l])){var p=[];for(A in a.CB["p"+l])a.CB["p"+l].hasOwnProperty(A)&&a.CB["p"+l][A]&&p.push(ZC._i_(A.replace("n","")));s[l]=p}return s}return{};case"setselection":var Z={};s=[],null!==ZC._n_(n=t.selection)&&(Z=ZC.AP.A48(n)),(a=u.C8(t.graphid))&&(a.CB=Z,a.HH=!0,a.clearPreview(),a.K6(!0,!0));break;case"select":case"deselect":var h=[],d=function(e){var t=!1;null!==ZC._n_(n=e.toggle)&&(t=ZC._b_(n));var a=u.C8(e.graphid);if(a){for(l=0,o=a.AY.A5.length;l<o;l++)a.IX[l]=!1;var s=null,p=null;if(null!==ZC._n_(n=e.plotindex))if("object"==typeof n)s=n;else if("string"==typeof n&&/\d+\-\d+/.test(n)){if(2===(r=n.split("-")).length)for(s=[],c=ZC._i_(r[0]);c<=ZC._i_(r[1]);c++)s.push(c)}else s=[n];if(null!==ZC._n_(n=e.plotid)){var Z=[];for(Z="object"==typeof n?n:[n],c=0;c<Z.length;c++){var d=a.I0(null,Z[c]);d&&(s||(s=[]),s.push(d.L))}}if(null!==ZC._n_(n=e.nodeindex))if("object"==typeof n)p=n;else if("string"==typeof n&&/\d+\-\d+/.test(n)){if(2===(r=n.split("-")).length)for(p=[],c=ZC._i_(r[0]);c<=ZC._i_(r[1]);c++)p.push(c)}else p=[n];if(null===ZC._n_(s))for(s=[],l=0,o=a.AY.A5.length;l<o;l++)s.push(l);for(l=0,o=s.length;l<o;l++){var f=s[l];if(a.AY.A5[f])if(null===ZC._n_(a.CB["p"+f])&&(a.CB["p"+f]={}),null===ZC._n_(p))for(A=0,C=a.AY.A5[f].S.length;A<C;A++)"select"===i?t&&a.CB["p"+f]["n"+A]?delete a.CB["p"+f]["n"+A]:a.CB["p"+f]["n"+A]=!0:"deselect"===i&&delete a.CB["p"+f]["n"+A];else for(A=0,C=p.length;A<C;A++)"select"===i?t&&a.CB["p"+f]["n"+p[A]]?delete a.CB["p"+f]["n"+p[A]]:a.CB["p"+f]["n"+p[A]]=!0:"deselect"===i&&delete a.CB["p"+f]["n"+p[A]]}-1===ZC.AV(h,a)&&h.push(a)}};if(t instanceof Array)for(c=0;c<t.length;c++)d(t[c]);else d(t);for(c=0;c<h.length;c++)h[c].HH=!0,h[c].clearPreview(),h[c].K6(!0,!0)}return null},ZC.JH.prototype.NX=function(){var e=this;e.AJ["3d"]&&"undefined"!=typeof ZC.AO&&(ZC.AO.A4S=2.5*ZC.BQ(e.I,e.F),ZC.AO.E2=e.P.iX+e.P.I/2,ZC.AO.E3=e.P.iY+e.P.F/2,ZC.AO.FU=ZC._i_(e.EZ.depth),ZC.AO.E2+=e.EZ["offset-x"],ZC.AO.E3+=e.EZ["offset-y"])},ZC.JH.prototype.ADE=function(){var e,i,t=this;if(t.AJ["3d"]&&"undefined"!=typeof ZC.AO){if(t.A.B8.load(t.EZ,"graph.3d-aspect"),t.A.B8.load(t.EZ,t.AF+".3d-aspect"),null!==ZC._n_(e=t.o["3d-aspect"])&&ZC._cp_(e,t.EZ),"pie3d"===t.AF&&t.o.plot&&t.o.plot.tilt){var n=ZC._l_(ZC._f_(t.o.plot.tilt),1,3);t.EZ["x-angle"]=25+(n-1)/2*(t.AJ["x-angle-max"]-t.AJ["x-angle-min"])}var a=["angle","depth","x-angle","y-angle","z-angle","zoom","offset-x","offset-y"];for(i=0;i<a.length;i++)t.EZ[a[i]]=ZC._f_(t.EZ[a[i]]);var l=["angle","x-angle","y-angle","z-angle"];for(i=0;i<l.length;i++)ZC.DS(t.EZ[l[i]],t.AJ[l[i]+"-min"],t.AJ[l[i]+"-max"])||(t.EZ[l[i]]=t.AJ[l[i]+"-min"]);t.EZ.true3d=ZC._b_(t.EZ.true3d)}},ZC.JH.prototype.S7=function(){var e,i,t,n,a=this;3!==zingchart.V3D&&(zingchart.V3D=a.EZ.true3d?1:2);var l=a.CL.A52.length;for(e=0;e<l;e++)(i=a.CL.A52[e]).ADC(),a.EZ.true3d?3===zingchart.V3D?a.CL.WI[e]=[ZC._f_(i.ZS.toFixed(1))*i.MC[2],e]:a.CL.WI[e]=[[ZC._f_(i.SJ.toFixed(1))*i.MC[0],ZC._f_(i.A5C.toFixed(1))*i.MC[1],ZC._f_(i.ZS.toFixed(1))*i.MC[2],ZC._f_(i.A20.toFixed(1))],e]:a.CL.WI[e]=[[ZC._f_(i.SJ.toFixed(1))*i.MC[0],ZC._f_(i.A4U.toFixed(1))*i.MC[1],ZC._f_(i.A3M.toFixed(1))*i.MC[2],ZC._i_(i.FZ)],e];a.CL.WI.sort(a.CL.sortFaces);var o=new ZC.DT(a);for(t=a.H.usc()?a.H.mc():ZC.AL(a.K+"-plots-bl-c"),n=ZC.Q.EB(t,a.H.AB),e=0;e<l;e++){var r=[],s=a.CL.WI[e][1],A=(i=a.CL.A52[s]).D.length;if(A>0){for(var C=0;C<A;C++)r.push(i.D[C].ED);r.push(i.D[0].ED),o.$i(a),o.K=a.K+"-3dshape-"+(""!==i.K?i.K:ZC.SEQ++),o.copy(i.O),o.CZ=!1,o.Z=t,o.locate(1),o.D=r,o.DU="poly",o.locate(2),o.paint()}}var c=[];for(var u in a.CL.SE)c.push([u,a.CL.SE[u].zIndex]);c.sort(function(e,i){return i[1]-e[1]});for(var p=0;p<c.length;p++){var Z=a.CL.SE[c[p][0]];ZC.CR.setup(n,Z.style),ZC.CR.paint(n,Z.style,Z.points)}},ZC.JH.prototype.UL=function(){if(!zingchart.SKIP.LEGEND){var e,i=this;if(i.BD){if(i.BD.PP&&i.L!==i.A.AG.length-1&&!i.BD.o.force)return;i.BD.Z=i.BD.C7=i.H.usc()?i.H.mc("top"):ZC.AL(i.K+"-legend-c"),i.BD.paint(),-1===ZC.AV(i.H.KQ,"skip_interactivity")&&(i.QI=function(e){var t,n;if(!ZC.move){i.A7&&i.A.A7&&i.A7.AN&&i.A.A7.onmouseover(e);var a=e.targetid||e.target.id,l=ZC._i_(a.replace(i.K,"").replace("-legend-item_","").replace("-legend-marker_","").replace("-area","").replace("-marker","")),o=i.AY.A5[l];if(o.G0&&(i.BD.WJ||o.IA)&&o.S.length)for(t=0,n=o.S.length;t<n;t++)if(null!==o.S[t]&&o.S[t].JE&&(o.FK(t).A0W("highlight"),i.BD.PP))for(var r=0;r<i.A.AG.length;r++)if(i.A.AG[r].BD&&i.A.AG[r].BD.PP&&i.A.AG[r].AY.A5[o.L]){var s=i.A.AG[r].AY.A5[o.L];s.FK(t)&&s.FK(t).A0W("highlight")}ZC.move=!0;var A=o.L;o.o["legend-item"]&&null!==ZC._n_(o.o["legend-item"].order)&&(A=ZC._i_(o.o["legend-item"].order)),i.BD.o["reverse-series"]&&(A=i.AY.A5.length-1-A),i.BD.highlightItem(A),ZC.move=!1;var C=i.AY.A5[l].UZ(e);i.E["legend-action-index"]=l,ZC.AP.BY("legend_mouseover",i.A,C)}},i.PM=function(e){ZC.move||i.A7&&i.A.A7&&i.A7.AN&&i.A.A7.onmousemove(e)},i.R9=function(e){if(!ZC.move){if(i.A7&&i.A.A7&&i.A7.AN&&i.A.A7.onmouseout(e),i.LD(),i.BD.PP)for(var t=0;t<i.A.AG.length;t++)i.A.AG[t].BD&&i.A.AG[t].BD.PP&&i.A.AG[t].LD();ZC.move=!0,i.BD.highlightItem(-1),ZC.move=!1;var n=ZC._c_(i.E["legend-action-index"],0),a=i.AY.A5[n].UZ(e);ZC.AP.BY("legend_mouseout",i.A,a)}},i.zc_legend_mousescroll=function(e){i.BD.D2&&"scroll-y"===i.BD.D2.AF&&(e.preventDefault(),i.BD.D2.A3V(e))},i.SM=function(t){if(i.E.legend_toggle_action=!0,!(ZC.move||(zingchart.S8(t),t.which>1))){var n,a,l,o=t.targetid||t.target.id,r=ZC._b_(i.BD.BR.o.reorder);ZC.mobile&&i.H.A7&&i.H.A7.hide();var s="item";-1!==o.indexOf("-legend-marker_")&&(s="marker"),i.LD(),t.preventDefault();var A=i.BD.IJ;"item"===s?A=i.BD.R0:"marker"===s&&(A=i.BD.PO),i.A.K9&&(A="remove"),i.E["legend-last-trigger"]=s;var C=ZC._i_(o.replace(i.K+"-legend-item_","").replace(i.K+"-legend-marker_","").replace("-area",""));if(i.o.series&&i.o.series[C]){if(null!==ZC._n_(e=i.o.series[C]["legend-item"])){var c=e.url||"",u=e.target||"";""!==c&&i.V4(t,c,u)}i.o.series[C].visible=!0}var p,Z,h,d=i.AY.A5[C].UZ(t);switch(d.visible=ZC._b_(i.E["plot"+C+".visible"]),ZC.AP.BY("legend_click",i.A,d),ZC.AP.BY("legend_"+s+"_click",i.A,d),A){default:break;case"hide":case"remove":if(t.shiftKey){var f=0;for(n=0,a=i.AY.A5.length;n<a;n++)if(n!==C&&(l=++f===a-1,i.Q7({"ignore-legend":r,K6:l,plotindex:n,"toggle-action":A}),i.BD.PP))for(p=0,Z=i.H.AG.length;p<Z;p++)(h=i.H.AG[p]).BD&&h.BD.PP&&h.BD.A4I===i.BD.A4I&&h.K!==i.K&&h.Q7({"ignore-legend":!0,K6:l,plotindex:n,"toggle-action":A})}else if(i.Q7({"ignore-legend":r,K6:1,plotindex:C,"toggle-action":A}),i.BD.PP)for(p=0,Z=i.H.AG.length;p<Z;p++)(h=i.H.AG[p]).BD&&h.BD.PP&&h.BD.A4I===i.BD.A4I&&h.K!==i.K&&h.Q7({"ignore-legend":!0,K6:1,plotindex:C,"toggle-action":A})}"hide"===A&&i.E.hooks&&(i.OW(),i.QK())}},ZC.A4("."+i.K+"-legend-item-area").live("mouseup touchstart",i.SM).live("DOMMouseScroll",i.zc_legend_mousescroll).live("mousewheel",i.zc_legend_mousescroll),ZC.A4("."+i.K+"-legend-marker-area").live("mouseup touchstart",i.SM).live("DOMMouseScroll",i.zc_legend_mousescroll).live("mousewheel",i.zc_legend_mousescroll),ZC.A4("#"+i.K+"-legend-frame").live("DOMMouseScroll",i.zc_legend_mousescroll).live("mousewheel",i.zc_legend_mousescroll),ZC.mobile||(ZC.A4("."+i.K+"-legend-item-area").live(ZC.Q.BZ("mouseover"),i.QI).live(ZC.Q.BZ("mouseout"),i.R9).live(ZC.Q.BZ("mousemove"),i.PM),ZC.A4("."+i.K+"-legend-marker-area").live(ZC.Q.BZ("mouseover"),i.QI).live(ZC.Q.BZ("mouseout"),i.R9).live(ZC.Q.BZ("mousemove"),i.PM)))}}},ZC.AAD=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="null",i.AJ.clip=!0,i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0}}),ZC.A8V=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="null3d",i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["x-angle-min"]=-1800,i.AJ["x-angle-max"]=1800,i.AJ["y-angle-min"]=-1800,i.AJ["y-angle-max"]=1800,i.AJ["z-angle-min"]=-1800,i.AJ["z-angle-max"]=1800,zingchart.V3D=3},clear:function(){this.b(),this.CL.clear()},paint:function(){var e=this;e.b(),e.PW(),e.S7(),e.flatten(),e.KK(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.NH=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="xy",i.AJ.clip=!0,i.AJ.layout="xy"},MN:function(e){switch(e){case"x":return new ZC.Q2(this);case"y":return new ZC.Q3(this)}},ACN:function(){var e,i=this,t=i.MN("x","scale-x");for(t.BE="scale-x",t.K=i.K+"-scale-x",i.BO.push(t),e=2;e<200;e++)if(null!==ZC._n_(i.o["scale-x-"+e])){var n=i.MN("x","scale-x-"+e);n.L=e,n.BE="scale-x-"+e,n.K=i.K+"-scale-x-"+e,i.BO.push(n)}var a=i.MN("y","scale-y");for(a.BE="scale-y",a.K=i.K+"-scale-y",i.BO.push(a),e=2;e<200;e++)if(null!==ZC._n_(i.o["scale-y-"+e])){var l=i.MN("y","scale-y-"+e);l.L=e,l.BE="scale-y-"+e,l.K=i.K+"-scale-y-"+e,i.BO.push(l)}i.b()}}),ZC.A6C=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="line",i.AY=new ZC.A40(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0}}),ZC.A6D=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="area",i.AY=new ZC.A3Z(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0}}),ZC.A9F=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="vline",i.AJ.layout="yx",i.AY=new ZC.A7L(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0},MN:function(e){switch(e){case"x":return new ZC.SU(this);case"y":return new ZC.SV(this)}}}),ZC.A9D=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="varea",i.AJ.layout="yx",i.AY=new ZC.A7M(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0},MN:function(e){switch(e){case"x":return new ZC.SU(this);case"y":return new ZC.SV(this)}}}),ZC.A2N=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="vbar",i.AY=new ZC.A09(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0},MN:function(e,i){switch(e){case"x":var t=this.b(e,i);return t.DF=!0,t;case"y":return this.b(e,i)}}}),ZC.A2G=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="hbar",i.AJ.layout="yx",i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0,i.AY=new ZC.A0H(i)},MN:function(e){switch(e){case"x":var i=new ZC.SU(this);return i.DF=!0,i;case"y":return new ZC.SV(this)}}}),ZC.A58=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="mixed",i.AY=new ZC.ZE(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0},MN:function(e,i){switch(e){case"x":var t=!1;if(this.o.series)for(var n=0;n<this.o.series.length;n++)if(this.o.series[n]&&this.o.series[n].type&&-1!==ZC.AV(["bar","vbar","bullet","vbullet","stock","vbar3d"],this.o.series[n].type)){var a=(this.o.series[n].scales||"scale-x,scale-y").split(",");-1!==ZC.AV(a,i)&&(t=!0)}var l=this.b(e,i);return l.DF=t,l;case"y":return this.b(e,i)}}}),ZC.A8Z=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="hmixed",i.AJ.layout="yx",i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!1,i.AJ["enable-scroll"]=!0,i.AY=new ZC.ZE(i)},MN:function(e,i){switch(e){case"x":var t=new ZC.SU(this),n=!1;if(this.o.series)for(var a=0;a<this.o.series.length;a++)if(this.o.series[a]&&this.o.series[a].type&&-1!==ZC.AV(["hbar","hbullet"],this.o.series[a].type)){var l=(this.o.series[a].scales||"scale-x,scale-y").split(",");-1!==ZC.AV(l,i)&&(n=!0)}return t.DF=n,t;case"y":return new ZC.SV(this)}}}),ZC.A31=ZC.A58.CA({$i:function(e){this.b(e);var i=this;i.AF="mixed3d",i.AY=new ZC.ZE(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-preview"]=!1,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0},clear:function(){this.b(),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.A89=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="scatter",i.AY=new ZC.A6R(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0}}),ZC.A7G=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="hscatter",i.AJ.layout="yx",i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!1,i.AJ["enable-scroll"]=!0,i.AY=new ZC.A5T(i)},MN:function(e){switch(e){case"x":return new ZC.SU(this);case"y":return new ZC.SV(this)}}}),ZC.A8P=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="bubble",i.AY=new ZC.A77(i),i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-scroll"]=!0}}),ZC.A84=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="hbubble",i.AJ.layout="yx",i.AJ["enable-guide"]=!0,i.AJ["enable-preview"]=!1,i.AJ["enable-scroll"]=!0,i.AY=new ZC.A6F(i)},MN:function(e){switch(e){case"x":return new ZC.SU(this);case"y":return new ZC.SV(this)}}}),ZC.A3U=ZC.JH.CA({$i:function(e){this.b(e),this.AF="pie",this.AY=new ZC.A4Q(this)},A2P:function(){return""},MN:function(e){switch(e){case"m":return new ZC.T5(this);case"v":return new ZC.VQ(this);case"r":return new ZC.A2B(this)}},ACN:function(){var e=this,i=e.MN("m","scale"),t=e.MN("v","scale-v"),n=e.MN("r","scale-r");i.BE="scale",i.K=e.K+"-scale",e.o.series&&e.o.series.length&&e.o.series[0].values&&(i.NF="1x"+e.o.series[0].values.length),t.BE="scale-v",t.K=e.K+"-scale-v",n.BE="scale-r",n.K=e.K+"-scale-r",e.BO.push(i,t,n),e.b()},clear_:function(){-1!==ZC.AV(["svg","vml"],this.H.AB)&&ZC.A4("#"+this.K+" .zc-layer").each(function(){/\-plot-\d+\-bl\-\d+\-/.test(this.id)&&ZC.A4(this).children().each(function(){/\-connector\-path/.test(this.id)&&ZC.Q.EU(this)})})}}),ZC.A6N=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="nestedpie",i.AY=new ZC.A4R(i)},A2P:function(){return""},MN:function(e){switch(e){case"m":return new ZC.T5(this)}},ACN:function(){var e=this,i=e.MN("m","scale");i.BE="scale",i.K=e.K+"-scale",e.BO.push(i),e.b()}}),ZC.A9W=ZC.JH.CA({$i:function(e){this.b(e);var i=this;if(i.AF="radar",i.AJ.layout="radar",i.AY=new ZC.A8B(i),-1!==ZC.AV(i.A.K,"polar")){for(var t=1,n=0;n<i.A.M9.series.length;n++)t=ZC.BQ(t,i.A.M9.series[n].values.length);t=Math.round(360/t).toString(),null===ZC._n_(i.A.M9.plot)?i.A.M9.plot={aspect:"area"}:ZC._cp_({aspect:"area"},i.A.M9.plot),null===ZC._n_(i.A.M9["scale-k"])?i.A.M9["scale-k"]={aspect:"circle",format:"%v\xb0",values:"0:330:"+t}:ZC._cp_({aspect:"circle",format:"%v\xb0",values:"0:330:"+t},i.A.M9["scale-k"],!0)}},A2P:function(){return""},MN:function(e){var i=this;switch(e){case"m":return new ZC.T5(i);case"k":return new ZC.ZL(i);case"v":return new ZC.ZK(i)}},ACN:function(){var e=this,i=e.MN("k","scale-k");i.BE="scale-k",i.K=e.K+"-scale-k",e.BO.push(i);var t=e.MN("v","scale-v");t.BE="scale-v",t.K=e.K+"-scale-v",e.BO.push(t);var n=e.MN("m","scale");n.BE="scale",n.K=e.K+"-scale",e.BO.push(n),e.b()}}),ZC.A80=ZC.A2N.CA({$i:function(e){this.b(e);var i=this;i.AF="vbullet",i.AY=new ZC.A6O(i),i.AJ["enable-animation"]=!1}}),ZC.A82=ZC.A2G.CA({$i:function(e){this.b(e);var i=this;i.AF="hbullet",i.AJ.layout="yx",i.AY=new ZC.A6M(i),i.AJ["enable-animation"]=!1}}),ZC.A9C=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="piano",i.AY=new ZC.A7P(i),i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0},ABG:function(e){var i=this;if("v"===e){var t=[];if(i.o.series&&i.o.series.length)for(var n=0;n<i.o.series.length;n++)t.push(i.o.series[n].text||"Metric "+(n+1));return t}},MN:function(e){switch(e){case"x":var i=new ZC.Q2(this);return i.DF=!0,i;case"y":var t=new ZC.Q3(this);return t.DF=!0,t.append({step:1,"fixed-step":!0}),t}}}),ZC.A87=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="vfunnel",i.AY=new ZC.A6G(i),i.AJ["enable-animation"]=!1,i.AJ["enable-zooming"]=!1,i.AJ["enable-scroll"]=!1},MN:function(e,i){switch(e){case"x":var t=this.b(e,i);return t.DF=!0,t;case"y":var n=this.b(e,i);return n.DF=!0,n}},ABG:function(e){if("v"===e){for(var i=[],t=0;t<this.o.series.length;t++)i.push("Step "+(t+1));return i}},paint:function(){for(var e=this,i=0,t=e.BO.length;i<t;i++)"v"===e.BO[i].AF&&(e.BO[i].AW=!e.BO[i].AW);e.b()}}),ZC.A86=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="hfunnel",i.AY=new ZC.A6X(i),i.AJ["enable-animation"]=!1,i.AJ["enable-zooming"]=!1,i.AJ["enable-scroll"]=!1},ABG:function(e){if("v"===e){for(var i=[],t=0;t<this.o.series.length;t++)i.push("Step "+(t+1));return i}},MN:function(e){switch(e){case"x":var i=new ZC.SU(this);return i.DF=!0,i;case"y":var t=new ZC.SV(this);return t.DF=!0,t}}}),ZC.AA3=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="stock",i.AY=new ZC.A7Y(i),i.AJ["enable-guide"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0,i.AJ["enable-preview"]=!0},MN:function(e,i){switch(e){case"x":var t=this.b(e,i);return t.DF=!0,t;case"y":return this.b(e,i)}}}),ZC.AA7=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="gauge",i.AJ.layout="gauge",i.AY=new ZC.A7T(i)},A2P:function(){return""},MN:function(e){var i=this;switch(e){case"m":return new ZC.T5(i);case"r":return new ZC.A7Z(i);case"v":return new ZC.VQ(i)}},ACN:function(){var e,i=this,t=i.MN("m","scale");for(t.BE="scale",t.K=i.K+"-scale",i.BO.push(t),e=2;e<10;e++)if(null!==ZC._n_(i.o["scale-"+e])){var n=i.MN("m","scale-"+e);n.L=e,n.BE="scale-"+e,n.K=i.K+"-scale-"+e,i.BO.push(n)}var a=i.MN("r","scale-r");for(a.BE="scale-r",a.K=i.K+"-scale-r",i.BO.push(a),e=2;e<10;e++)if(null!==ZC._n_(i.o["scale-r-"+e])){var l=i.MN("r","scale-r-"+e);l.L=e,l.BE="scale-r-"+e,l.K=i.K+"-scale-r-"+e,i.BO.push(l)}i.b()},hideLayer_:function(){var e=this;ZC.A4("#"+e.K+"-plots-bl-2").children().each(function(){ZC.Q.IV(this,e.H.AB,e.iX,e.iY,e.I,e.F,e.K)})}}),ZC.A98=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="range",i.AY=new ZC.A7K(i),i.AJ["enable-guide"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0,i.AJ["enable-preview"]=!0}}),ZC.ZCVRangeGraph=ZC.NH.CA({$i:function(e){this.b(e);var i=this;i.AF="range",i.AJ.layout="yx",i.AY=new ZC.ZCVRangePlotSet(i),i.AJ["enable-guide"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0,i.AJ["enable-preview"]=!1},MN:function(e){switch(e){case"x":return new ZC.SU(this);case"y":return new ZC.SV(this)}}}),ZC.A5G=ZC.A3U.CA({$i:function(e){this.b(e);var i=this;i.AF="pie3d",i.AY=new ZC.A7V(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-animation"]=!1,i.AJ["x-angle-min"]=15,i.AJ["x-angle-max"]=75,i.AJ["y-angle-min"]=0,i.AJ["y-angle-max"]=0,i.AJ["z-angle-min"]=0,i.AJ["z-angle-max"]=0},clear:function(){this.b(),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.A8Q=ZC.A2G.CA({$i:function(e){this.b(e);var i=this;i.AF="hbar3d",i.AY=new ZC.A7H(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-preview"]=!1,i.AJ["enable-animation"]=!1,i.AJ["x-angle-min"]=-20,i.AJ["x-angle-max"]=20,i.AJ["y-angle-min"]=-20,i.AJ["y-angle-max"]=0},clear:function(){this.b(),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.A8Y=ZC.A2N.CA({$i:function(e){this.b(e);var i=this;i.AF="vbar3d",i.AY=new ZC.A7I(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0},clear:function(e,i){this.b(e,i),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.A8T=ZC.A6C.CA({$i:function(e){this.b(e);var i=this;i.AF="line3d",i.AY=new ZC.A7F(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0},clear:function(e,i){this.b(e,i),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.A8W=ZC.A6D.CA({$i:function(e){this.b(e);var i=this;i.AF="area3d",i.AY=new ZC.A7D(i),i.CL=new ZC.SN,i.AJ["3d"]=!0,i.AJ["enable-preview"]=!0,i.AJ["enable-animation"]=!1,i.AJ["enable-scroll"]=!0},clear:function(e,i){this.b(e,i),this.CL.clear()},paint:function(){var e=this;e.b(),e.S7(),e.flatten(),e.PW(),e.FA.length&&(e.CL.clear(),e.KK(),e.S7()),e.UL(),-1===ZC.AV(e.H.KQ,"skip_interactivity")&&e.RW()}}),ZC.AAI=ZC.JH.CA({$i:function(e){this.b(e);var i=this;i.AF="venn",i.AY=new ZC.A8X(i)},A2P:function(){return""},MN:function(e){switch(e){case"m":return new ZC.T5(this)}},parse:function(){var e=this;e.b(),e.BD&&(e.BD.IJ="remove",e.BD.R0="remove",e.BD.PO="remove")},ACN:function(){var e=this,i=e.MN("m","scale");i.BE="scale",i.K=e.K+"-scale",e.BO.push(i),e.b()}}),ZC.LK=ZC.HL.CA({$i:function(e){this.b(e);var i=this;i.C=e,i.H=i.C.A,i.A5=[],i.HF=null,i.KA=[],i.K2=[],i.PU=!0,i.F8=null,i.A4X=!0,i.YZ=[]},ACW:function(){return new ZC.HV(this)},parse:function(){var e,i,t,n=this;for(n.K=n.A.K+"-plotset",n.F8=null,i=n.o.length-1;i>=0;i--)"undefined"==typeof n.o[i]&&n.o.splice(i,1);if(null===ZC._n_(n.E["plot-sort"])&&(n.E["plot-sort"]=!1),n.o.length>1){for(i=0,t=n.o.length;i<t;i++)"undefined"==typeof n.o[i].palette&&(n.o[i].palette=i);var a=[],l=[];for(i=0,t=n.o.length;i<t;i++)l[i]=i,a[i]={"z-index":n.o[i]["z-index"]||0};for(var o=!1;!o;)for(o=!0,i=0,t=a.length;i<t-1;i++){if(a[i]["z-index"]>a[i+1]["z-index"]){n.E["plot-sort"]=!0;var r=a[i];a[i]=a[i+1],a[i+1]=r;var s=l[i];l[i]=l[i+1],l[i+1]=s,o=!1}}n.M4=l}else n.M4=[0];for(n.A5=[],i=0,t=n.o.length;i<t;i++){var A="";n.A.o.plot&&null!==ZC._n_(e=n.A.o.plot.type)&&(A=e),null!==ZC._n_(e=n.o[i].type)&&(A=e);var C=n.ACW(A,i);C.OB=C.AF+"plot",C.L=i,C.JS=i,n.C.A.B8.load(C.o,["("+C.AF+").plot"]),C.sTypeX&&n.C.A.B8.load(C.o,["("+C.sTypeX+").plot"]),n.C.A.B8.load(C.o,["("+C.AF+").plot.animation"]),null!==ZC._n_(e=n.A.o.plot)&&C.append(e),C.append(n.o[i]),C.CC=n.A.CC,C.parse(),n.A5.push(C)}var c={},u=[],p=[],Z={},h={},d=0,f=0;for(i=0,t=n.A5.length;i<t;i++)if(null!==ZC._n_(n.A.A.E["g-"+n.A.L+"-p-"+i+".visible"])&&(n.C.E["plot"+i+".visible"]=n.A.A.E["g-"+n.A.L+"-p-"+i+".visible"]),!n.A5[i].HM&&(n.C.E["plot"+i+".visible"]||"hide"===n.C.getToggleAction())){n.A5[i].CC?(-1===(f=ZC.AV(p,n.A5[i].DZ))&&(p.push(n.A5[i].DZ),f=p.length-1),null===ZC._n_(u[f])?u[f]=[i]:u[f].push(i)):(p.push(-1),f=p.length-1,null===ZC._n_(u[f])?u[f]=[i]:u[f].push(i));var _=n.A5[i].AF;if(n.A5[i].o.type&&_!==n.A5[i].o.type){var g=_.indexOf("3d"),v=n.A5[i].o.type.indexOf("3d");(-1===g&&-1!==v||-1===g&&-1===v)&&(_=n.A5[i].o.type)}-1!==ZC.AV(["bar","bar3d","bullet"],_)&&(_="v"+_),-1===ZC.AV(["vbar","hbar","vbullet","hbullet","stock","vbar3d","hbar3d"],_)||n.A5[i].HM||(null===ZC._n_(Z[_])&&(Z[_]=[]),null===ZC._n_(h[_])&&(h[_]=[]),n.A5[i].CC?(null===ZC._n_(c[n.A5[i].DZ])?c[n.A5[i].DZ]=1:c[n.A5[i].DZ]++,-1===(d=ZC.AV(h[_],n.A5[i].DZ))&&(h[_].push(n.A5[i].DZ),d=h[_].length-1),null===ZC._n_(Z[_][d])?Z[_][d]=[i]:Z[_][d].push(i)):(h[_].push(-1),d=h[_].length-1,null===ZC._n_(Z[_][d])?Z[_][d]=[i]:Z[_][d].push(i)))}if(n.KA=u,n.K2=Z,n.WM)for(var b in n.WM)n.WM[b].sort();for(n.A1C=[],i=0;i<n.KA.length;i++)n.A1C.push(n.KA[i][n.KA[i].length-1])},paint:function(){var e=this;function i(t){var n=e.M4[t];(e.A5[n].HT||e.A5[n].E7.length&&e.A.B9||"none"!==e.A5[n].J0)&&(e.H.O7=!1),e.A4X=!0;var a=e.C.getToggleAction();e.A5[n].o["skip-paint"]||(e.C.AJ["3d"]?e.C.E["plot"+n+".visible"]&&(e.A5[n].paint(),e.H.ZV()):(e.C.E["plot"+n+".visible"]||"hide"===a)&&("undefined"!=typeof e.C.E["plot-"+n+"-first-run"]&&(e.A5[n].TQ=0),e.A5[n].paint(),e.A5[n].TQ=0,e.H.ZV(),e.C.E["plot"+n+".visible"]||"hide"!==a||(e.C.E["plot"+n+".visible"]=!0,e.A.Q7({plotindex:n,"ignore-legend":!0})))),e.C.E["plot-"+n+"-first-run"]=!1,t<e.A5.length-1?e.C.LL?ZC.ASYNC_TICK[e.C.K]=window.setTimeout(function(){i(t+1)},10):e.A5.length<=100&&i(t+1):(!e.C.LL||e.C.LL&&e.A4X)&&e._end_()}if(e.HF=[],e.A5.length>0)if(e.A5.length>100&&!e.C.LL)for(var t=0;t<e.A5.length;t++)i(t);else i(0);else e._end_()},_end_:function(){var e,i=this;i.RS=null,i.VJ=null;for(var t=0;t<i.C.BO.length;t++)i.C.BO[t].ET=null,i.C.BO[t].WK=null;function n(e){var t=0,n=e.indexOf("-plotset-plot-"),a=e.indexOf("-node-",n);return-1!==n&&-1!==a&&(t=e.substr(n+14,a-n-14)),"undefined"!=typeof i.A5[t].E["z-mid"]?i.A5[t].E["z-mid"]:t}if((e=ZC.AL(i.C.A.K+"-map"))&&!i.H.A19){-1===ZC.AV(["bubble","hbubble","vbullet","hbullet","radar","vbar3d","hbar3d","mixed","mixed3d","pie3d","hmixed","hmixed3d"],i.C.AF)&&1!==zingchart.SORTTRACKERS||i.HF.sort(function(e,t){return"pie3d"===i.C.AF?ZC.AP.N2(e)>ZC.AP.N2(t)?1:ZC.AP.N2(e)<ZC.AP.N2(t)?-1:0:n(e)>n(t)&&i.A.AJ["3d"]?1:n(e)<n(t)&&i.A.AJ["3d"]?-1:ZC.AP.N2(e)>ZC.AP.N2(t)?1:ZC.AP.N2(e)<ZC.AP.N2(t)?-1:0});var a='<area shape="rect" coords="0,0,1,1" id="mark'+i.A.L+'">',l=i.A.a11y(),o=e.innerHTML.indexOf(a);zingchart.DEV.DELAYEDTRACKERS?window.setTimeout(function(){-1!==o?e.innerHTML=e.innerHTML.substring(0,o+a.length)+l+i.HF.join("")+e.innerHTML.substring(o+a.length):e.innerHTML+=l+i.HF.join("")},500):-1!==o?e.innerHTML=e.innerHTML.substring(0,o+a.length)+l+i.HF.join("")+e.innerHTML.substring(o+a.length):e.innerHTML+=l+i.HF.join("")}i.F1=null,i.D6=null,i.C.AA2=[],i.A._end_()}}),ZC.A40=ZC.LK.CA({ACW:function(){return new ZC.QW(this)}}),ZC.A3Z=ZC.LK.CA({ACW:function(){return new ZC.QX(this)}}),ZC.A7L=ZC.LK.CA({ACW:function(){var e=new ZC.QW(this);return e.O6=!0,e}}),ZC.A7M=ZC.LK.CA({ACW:function(){var e=new ZC.QX(this);return e.O6=!0,e}}),ZC.A09=ZC.LK.CA({ACW:function(){return new ZC.QZ(this)}}),ZC.A0H=ZC.LK.CA({ACW:function(){return new ZC.QS(this)}}),ZC.ZE=ZC.LK.CA({ACW:function(e){var i=this;switch(e){default:return new ZC.QW(i);case"vline":var t=new ZC.QW(i);return t.O6=!0,t;case"poly":var n=new ZC.PC(i);return n.bPoly=!0,n.sTypeX="poly",n;case"area":return new ZC.QX(i);case"varea":var a=new ZC.QX(i);return a.O6=!0,a;case"bar":case"vbar":return new ZC.QZ(i);case"hbar":return new ZC.QS(i);case"scatter":return new ZC.PC(i);case"hscatter":return new ZC.PC(i,"hscatter");case"bubble":return new ZC.RU(i);case"hbubble":return new ZC.RU(i,"hbubble");case"stock":return new ZC.VC(i);case"range":return new ZC.ST(i);case"vrange":var l=new ZC.ST(i);return l.O6=!0,l;case"line3d":return new ZC.UG(i);case"area3d":return new ZC.UI(i);case"bar3d":case"vbar3d":return new ZC.UF(i);case"bullet":case"vbullet":return new ZC.TD(i);case"hbullet":return new ZC.TB(i)}}}),ZC.A6R=ZC.LK.CA({ACW:function(){return new ZC.PC(this)}}),ZC.ACG=ZC.LK.CA({ACW:function(){var e=new ZC.PC(this);return e.bPoly=!0,e.sTypeX="poly",e}}),ZC.A5T=ZC.LK.CA({ACW:function(){return new ZC.PC(this,"hscatter")}}),ZC.A77=ZC.LK.CA({ACW:function(){return new ZC.RU(this)}}),ZC.A6F=ZC.LK.CA({ACW:function(){return new ZC.RU(this,"hbubble")}}),ZC.A4Q=ZC.LK.CA({$i:function(e){this.b(e);var i=this;i.KL=[],i.PD=[],i.TH=[]},ACW:function(){return new ZC.VV(this)},parseLayout:function(e){var i,t,n,a,l=this;e&&(l.TH=[],l.PD=[]);var o,r=l.A.BM("scale-r"),s=l.A.BM("scale"),A=.9,C=1;l.A5.length>=10&&(C=1),l.A5.length>=20&&(C=1.25),l.A5.length>=30&&(C=1.5);var c=r.DJ;for(i=0,t=l.A5.length;i<t;i++)null!==ZC._n_(l.A5[i].o["ref-angle"])&&(c=l.A5[i].DJ);for(i=0,t=l.A5.length;i<t;i++)if(l.C.E["plot"+i+".visible"]||"hide"===l.C.getToggleAction())for(var u=0,p=l.A5[i].S.length;u<p;u++)if(l.A5[i].S[u]){l.YE["n"+u]=l.YE["n"+u]||[];var Z,h,d=l.A5[i].S[u];null===ZC._n_(l.PD[u])&&(l.PD[u]=c),Z=null!==ZC._n_(a=l.A5[i].o["angle-start"])?ZC._f_(a):l.PD[u],h=l.KL[u],null!==ZC._n_(l.A5[i].o.totals)&&null!==ZC._n_(l.A5[i].o.totals[u])&&(h=l.KL[u]=ZC._f_(l.A5[i].o.totals[u])),n=0===h?Z+r.EI*(1/t):0===d.AD&&l.A5[i].TK?Z+r.EI*(.005*l.KL[u])/h:Z+r.EI*d.AD/h,l.PD[u]=n,d.B4=Z,d.BK=n;var f=d.GW(!0);if("out"===f.o.placement&&f.AN){var _=ZC._i_((Z+n)/2);l.YE["n"+u][i]=_-c,o=ZC.CY(s.I/2-C*f.I-f.DV-35,s.F/2-C*f.F-f.DV-15),A=ZC.CY(A,2*o/ZC.CY(s.I,s.F))}}if("pie3d"===l.A.AF&&(A*=.75),A=ZC.BQ(.1,ZC.CY(.9,A)),"auto"===s.o["size-factor"]&&(s.JD=A),e)for(var g in l.YE)l.YE[g]=ZC.AR.ACI(l.YE[g],c)},parse:function(){var e=this;e.A.o.plot&&"auto"===e.A.o.plot.layout&&(null===ZC._n_(e.A.o.plot["ref-angle"])&&(e.A.o.plot["ref-angle"]=-90),e.o.sort(function(e,i){return i.values[0]-e.values[0]})),e.TH=[],e.KL=[],e.PD=[],e.YE={},e.b();for(var i=0,t=e.A5.length;i<t;i++)for(var n=0,a=e.A5[i].S.length;n<a;n++)e.A5[i].S[n]&&e.A5[i].S[n]&&(e.C.E["plot"+i+".visible"]||"hide"===e.C.getToggleAction())&&0===e.A5[i].S[n].AD&&e.A5[i].TK&&(e.KL[n]+=.005*e.KL[n]);e.parseLayout()}}),ZC.A4R=ZC.LK.CA({$i:function(e){this.b(e);this.KL=[],this.PD=[]},ACW:function(){return new ZC.TW(this)},parse:function(){var e=this;e.KL=[],e.PD=[],e.b();for(var i,t=e.A.BM("scale"),n=t.iX+t.I/2,a=1,l=0,o=e.A5.length;l<o;l++)if(e.C.E["plot"+l+".visible"]||"hide"===e.C.getToggleAction())for(var r=0,s=e.A5[l].S.length;r<s;r++)if(e.A5[l].S[r]){var A=e.A5[l].S[r];null===ZC._n_(e.PD[r])&&(e.PD[r]=e.A5[l].DJ);var C=e.PD[r],c=C+360*A.AD/e.KL[r];e.PD[r]=c,A.B4=C,A.BK=c;var u=A.GW(!0);if(u&&"in"!==u.o.placement){var p=ZC._i_((C+c)/2);i=((p>=0&&p<=90||p>=270&&p<=360?t.iX+t.I-(u.I+25):t.iX+(u.I+25))-n)/ZC.EH(p),a=ZC.CY(a,2*i/t.I),i=t.F/2-(u.F/2+10),a=ZC.CY(a,2*i/t.F)}}a=ZC.BQ(.15,ZC.CY(.85,a)),"auto"===t.o["size-factor"]&&(t.o["size-factor"]=t.JD=a)}}),ZC.A8B=ZC.LK.CA({A2E:{},$i:function(e){this.b(e)},ACW:function(){return new ZC.X8(this)},paint:function(){this.A2E={},this.b()}}),ZC.A6O=ZC.A09.CA({ACW:function(){return new ZC.TD(this)}}),ZC.A6M=ZC.A0H.CA({ACW:function(){return new ZC.TB(this)}}),ZC.A7P=ZC.LK.CA({ACW:function(){return new ZC.XB(this)}}),ZC.A22=ZC.LK.CA({parse:function(){var e,i,t,n,a,l=this;for(l.B3=ZC.MAX,l.BJ=-ZC.MAX,l.A8E=[],l.SB=[],l.b(),e=0,i=l.A5.length;e<i;e++)for(t=0,n=l.A5[e].S.length;t<n;t++)l.A5[e].S[t]&&(a=l.A5[e].S[t],null===ZC._n_(l.SB[t])&&(l.SB[t]=ZC.MAX),null===ZC._n_(l.A8E[t])&&(l.A8E[t]=-ZC.MAX),l.SB[t]=ZC.CY(l.SB[t],a.AD),l.A8E[t]=ZC.BQ(l.A8E[t],a.AD));for(e=0,i=l.A5.length;e<i;e++)for(t=0,n=l.A5[e].S.length;t<n;t++)l.A5[e].S[t]&&(a=l.A5[e].S[t],l.B3=ZC.CY(l.B3,a.AD),l.BJ=ZC.BQ(l.BJ,a.AD))}}),ZC.A6G=ZC.A22.CA({ACW:function(){return new ZC.V8(this)}}),ZC.A6X=ZC.A22.CA({ACW:function(){return new ZC.V7(this)}}),ZC.A7Y=ZC.LK.CA({ACW:function(){return new ZC.VC(this)}}),ZC.A7T=ZC.LK.CA({ACW:function(){return new ZC.XE(this)}}),ZC.A7K=ZC.LK.CA({ACW:function(){return new ZC.ST(this)}}),ZC.ZCVRangePlotSet=ZC.LK.CA({ACW:function(){var e=new ZC.ST(this);return e.O6=!0,e}}),ZC.A7V=ZC.A4Q.CA({ACW:function(){return new ZC.XA(this)}}),ZC.A7I=ZC.A09.CA({ACW:function(){return new ZC.UF(this)}}),ZC.A7H=ZC.A0H.CA({ACW:function(){return new ZC.VZ(this)}}),ZC.A7F=ZC.A40.CA({ACW:function(){return new ZC.UG(this)}}),ZC.A7D=ZC.A3Z.CA({ACW:function(){return new ZC.UI(this)}}),ZC.A8X=ZC.LK.CA({$i:function(e){this.b(e),this.DW=[],this.NS=[],this.X7=[]},ACW:function(){return new ZC.YU(this)},paint:function(){var e,i,t,n,a,l,o,r,s,A,C=this,c=C.A.BM("scale"),u=ZC.CY(c.GE,c.GK),p=-ZC.MAX,Z=ZC.CY(3,C.A5.length);for(e=0,i=Z;e<i;e++)for(A=C.A5[e].S,a=ZC.AP.O2(C.A5[e].o["value-box"],C.A5[e].o),t=0,n=A.length;t<n;t++)A[t].setup(),p=ZC.BQ(p,A[t].AD),A[t].WF=ZC.AP.G2(C.A5[e].AC0[t],a);var h=u/(4*Math.sqrt(p/Math.PI));function d(e,i){var t=ZC._a_(e[0]-i[0]),n=ZC._a_(e[1]-i[1]);return Math.sqrt(t*t+n*n)}var f,_,g,v=[],b=[],B=[],m=[],E=null;for(C.NS=[],e=0,i=Z;e<i;e++)for(v[e]||(v[e]=[]),b[e]||(b[e]=[],B[e]=[]),C.DW[e]||(C.DW[e]=[]),A=C.A5[e].S,m=C.A5[e+1]&&e+1<3?C.A5[e+1].S:C.A5[0].S,t=0,n=A.length;t<n;t++){C.NS[t]||(C.NS[t]=[]),C.X7[t]||(C.X7[t]={}),A[t].WR=m[t].AD,0===e?(f=h*Math.sqrt(A[t].AD/Math.PI),_=h*Math.sqrt(A[t].WR/Math.PI),v[e][t]=h*ZC.AR.A60(A[t].AD,A[t].WR,A[t].WF),b[e][t]=A[t].iX-ZC.BQ(f,_)/2,B[e][t]=A[t].iY+A[t].F/4):1===e?(v[e][t]=h*ZC.AR.A60(A[t].AD,A[t].WR,A[t].WF),b[e][t]=b[0][t]+v[0][t],B[e][t]=B[0][t],2===Z&&(g=(b[0][t]-f-(c.GK-(b[1][t]+_)))/2,C.A5[e-1].S[t].iX-=g,b[1][t]-=g,C.DW[0][t].x-=g,C.NS[t][0][0]-=g,C.A5[e-1].S[t].iY=c.iY+c.GE/2,B[1][t]=c.iY+c.GE/2,C.DW[0][t].y=c.iY+c.GE/2)):2===e&&(v[e][t]=h*ZC.AR.A60(A[t].AD,A[t].WR,A[t].WF),o=(v[0][t]*v[0][t]-v[1][t]*v[1][t]+v[2][t]*v[2][t])/(2*v[0][t]),b[e][t]=b[0][t]+o,r=Math.sqrt(v[2][t]*v[2][t]-o*o),B[e][t]=B[0][t]-r,3===Z&&(g=(b[0][t]-f-(c.GK-(b[1][t]+_)))/2,C.A5[0].S[t].iX-=g,C.A5[1].S[t].iX-=g,C.DW[0][t].x-=g,C.DW[1][t].x-=g,C.NS[t][0][0]-=g,b[2][t]-=g)),A[t].iX=b[e][t]+c.iX,A[t].iY=B[e][t],A[t].I=h*Math.sqrt(A[t].AD/Math.PI),A[t].F=h*Math.sqrt(A[t].AD/Math.PI),A[t].AI=h*Math.sqrt(A[t].AD/Math.PI),null===ZC._n_(E)&&(E=A[t].AD/(Math.PI*A[t].AI*A[t].AI));var D=h*Math.sqrt(A[t].AD/Math.PI),F=h*Math.sqrt(A[t].WR/Math.PI),K=D+F-v[e][t],x=(2*K*F-K*K)/(2*(D+F-K)),I=K-x;if(C.DW[e][t]={x:b[e][t],y:B[e][t],sz:A[t].AI,r1:D,r2:F,dx1:I,dx2:x},0===e?(r=Math.sqrt(D*D-(D-x)*(D-x)),C.NS[t].push([b[0][t]+D-x,B[0][t]-r])):2===e&&(D=C.DW[1][t].r1,F=C.DW[1][t].r2,I=C.DW[1][t].dx1,x=C.DW[1][t].dx2,l=ZC.TN(Math.asin((B[1][t]-B[2][t])/v[1][t]))-ZC.TN(Math.acos((D-x)/D)),C.NS[t].push([b[1][t]-D*ZC.EH(l)-g,B[1][t]-D*ZC.EO(l)]),D=C.DW[2][t].r1,F=C.DW[2][t].r2,I=C.DW[2][t].dx1,x=C.DW[2][t].dx2,l=ZC.TN(Math.asin((B[0][t]-B[2][t])/v[2][t]))-ZC.TN(Math.acos((F-I)/F)),C.NS[t].push([b[0][t]+F*ZC.EH(l)-g,B[0][t]-F*ZC.EO(l)])),e===Z-1)if(3===Z){if(null!==ZC._n_(C.A5[0].AA5[t]))C.X7[t].area=C.A5[0].AA5[t];else{var y=[-1],w=[-1];y[1]=d(C.NS[t][0],C.NS[t][2]),y[2]=d(C.NS[t][0],C.NS[t][1]),y[3]=d(C.NS[t][2],C.NS[t][1]),w[1]=C.DW[0][t].sz,w[2]=C.DW[1][t].sz,w[3]=C.DW[2][t].sz;var L=.25*Math.sqrt((y[1]+y[2]+y[3])*(y[1]+y[2]-y[3])*(y[1]+y[3]-y[2])*(y[2]+y[3]-y[1]));for(s=1;s<=3;s++)L+=w[s]*w[s]*Math.asin(y[s]/(2*w[s]))-y[s]/4*Math.sqrt(4*w[s]*w[s]-y[s]*y[s]);C.X7[t].area=E*L}C.DW[0][t].intxy=ZC.AR.A5I(C.DW[0][t].x,C.DW[0][t].y,C.DW[1][t].x,C.DW[1][t].y,C.DW[0][t].r1-(C.DW[0][t].dx1+C.DW[0][t].dx2)/2),C.DW[1][t].intxy=ZC.AR.A5I(C.DW[1][t].x,C.DW[1][t].y,C.DW[2][t].x,C.DW[2][t].y,-(C.DW[1][t].r1-(C.DW[1][t].dx1+C.DW[1][t].dx2)/2)),C.DW[2][t].intxy=ZC.AR.A5I(C.DW[2][t].x,C.DW[2][t].y,C.DW[0][t].x,C.DW[0][t].y,-(C.DW[2][t].r1-(C.DW[2][t].dx1+C.DW[2][t].dx2)/2)),C.X7[t].xy=[(C.NS[t][0][0]+C.NS[t][1][0]+C.NS[t][2][0])/3,(C.NS[t][0][1]+C.NS[t][1][1]+C.NS[t][2][1])/3]}else C.DW[0][t].intxy=ZC.AR.A5I(C.DW[0][t].x,C.DW[0][t].y,C.DW[1][t].x,C.DW[1][t].y,C.DW[0][t].r1-(C.DW[0][t].dx1+C.DW[0][t].dx2)/2),C.DW[1][t].intxy=[-9999,-9999]}if(3===Z)for(e=0,i=Z;e<i;e++)for(a=ZC.AP.O2(C.A5[e].o["value-box"],C.A5[e].o),null!==ZC._n_(a.decimals)&&-1!==a.decimals||(a.decimals=0),t=0,n=C.A5[e].S.length;t<n;t++)C.X7[t].area=ZC.AP.G2(C.X7[t].area,a);C.b()}});var HV={$i:function(e){this.b(e);var i=this;i.C=e.A,i.H=i.C.A,i.A66={},i.HM=!1,i.SW=3,i.A1G=1,i.V=[],i.KH={},i.S=[],i.AF="",i.sTypeX=null,i.IE=null,i.RN=!1,i.J0="none",i.O5="plot",i.UR=!0,i.SX=null,i.T3=null,i.TX={},i.A2=null,i.GC=null,i.PN=null,i.PJ=null,i.BP=null,i.L=-1,i.BO=[],i.CC=!1,i.KR="normal",i.DZ=0,i.U=null,i.NZ=null,i.A7=null,i.JL=null,i.AM=null,i.J7=null,i.A68=null,i.OZ=null,i.DQ=-1,i.I1=-1,i.RF=null,i.RX=null,i.ZX=!1,i.SH=2,i.A33=!1,i.TT="",i.A04="standard",i.CW=null,i.A0X=null,i.MS=null,i.S0=null,i.Y3=!0,i.XW=null,i.YA=1,i.Q6=!1,i.QN=!0,i.JS=0,i.XX=null,i.SZ=null,i.PU=!0,i.K4=null,i.AAK=1,i.A2K=1,i.S2=[],i.J8=null,i.EF=!1,i.T0=[],i.A6S=-1,i.GD=!1,i.L7=0,i.JG=.6,i.L8=0,i.AC3=0,i.AC4=null,i.TQ=0,i.FV=null,i.I3=!1,i.YH=!0,i.A73=!1,i.Y0=1,i.YL=0,i.IA=!1,i.L9=!1,i.A3K="node",i.LN=!1,i.R8=-1,i.RM=0,i.Q8=!1,i.GQ=[null,null,null,null],i.P1="line"},applyRGBA:function(){var e,i=this;null!==ZC._n_(e=i.E["l-alpha"])&&null===ZC._n_(i.JB.alpha)&&(i.C6=e),null!==ZC._n_(e=i.E["bg-alpha"])&&null===ZC._n_(i.JB["alpha-area"])&&(i.o["alpha-area"]=e)},FK:function(e,i,t){var n=this;return void 0===t&&(t=!1),(void 0===i||!n.GQ[i]&&n.GQ[1])&&(i=1),e=parseInt(e,10),!n.I3||"xy"!==n.C.AJ.layout&&"yx"!==n.C.AJ.layout?n.S[e]:n.S[e]&&n.GQ[i]?(n.GQ[i].K=n.K+"-node-"+e,n.GQ[i].o={value:n.V[e]},"string"==typeof n.V[e]&&(n.GQ[i].A26=!0),n.GQ[i].L=e,"line"!==n.AF&&"area"!==n.AF&&"vline"!==n.AF&&"varea"!==n.AF||n.U?n.GQ[i].parse():(t||null!==n.S[e].BT||"undefined"!=typeof n.C.E["plot-"+n.L+"-first-run"])&&n.GQ[i].parse(),"line"===n.AF||"area"===n.AF||"vline"===n.AF||"varea"===n.AF?"xy"===n.C.AJ.layout?(null!==n.S[e].BT?n.GQ[i].iX=n.S[e].iX=n.B1.AT(n.S[e].BT):n.GQ[i].iX=n.S[e].iX=n.B1.IB(e),n.CC&&"100%"===n.KR?n.GQ[i].iY=n.S[e].iY=n.CM.AT(100*n.S[e].CS/n.A.F8[e]["%total-"+n.DZ]):n.GQ[i].iY=n.S[e].iY=n.CM.AT(n.S[e].CS)):(null!==n.S[e].BT?n.GQ[i].iY=n.S[e].iY=n.B1.AT(n.S[e].BT):n.GQ[i].iY=n.S[e].iY=n.B1.IB(e),n.CC&&"100%"===n.KR?n.GQ[i].iX=n.S[e].iX=n.CM.AT(100*n.S[e].CS/n.A.F8[e]["%total-"+n.DZ]):n.GQ[i].iX=n.S[e].iX=n.CM.AT(n.S[e].CS)):n.GQ[i].T7(),n.GQ[i].JE=n.S[e].JE,n.GQ[i]):null},UW:function(e,i){var t=this;t.K4[e]||(t.K4[e]=[]),(!t.I3||t.I3&&-1===ZC.AV(t.K4[e],i))&&t.K4[e].push(i)},TV:function(){return new ZC.LE(this)},ABZ:function(){return{}},NQ:function(){return this.ZQ("palette","A6S","i"),this.C.A.B8.A9Z(-1!==this.A6S?this.A6S:this.L,this.C.AF)},NO:function(){var e=this;if(e.BP[4]){var i,t={};for(var n in e.BP[4])-1===(i=n.indexOf("."))?null===ZC._n_(e.o[n])&&(t[n]=!0,e.o[n]=e.BP[4][n]):n.substring(0,i)===e.AF&&(null===ZC._n_(e.o[n.substring(i+1)])||t[n.substring(i+1)])&&(e.o[n.substring(i+1)]=e.BP[4][n])}},ID:function(e,i){var t,n,a=this,l=!1,o="";if("none"!==a.J0&&(a.C.IX[a.L]||a.C.KI)){var r=!(e.E["selected-state"]||e.E["background-state"]);a.C.CB["p"+a.L]&&a.C.CB["p"+a.L]["n"+e.L]?zingchart.DEV.CACHESELECTION&&r&&a.TX["selected-state"]?(n=a.TX["selected-state"],l=!0):(o="selected-state",(n=new ZC.DN(a)).copy(i),e.E["selected-state"]?n.LQ=e.E["selected-state"]:n.LQ=a.SX?a.SX.o:{}):"none"!==a.O5&&("plot"===a.O5&&a.C.IX[a.L]||"graph"===a.O5&&a.C.KI)&&(zingchart.DEV.CACHESELECTION&&r&&a.TX["background-state"]?(n=a.TX["background-state"],l=!0):(o="background-state",(n=new ZC.DN(a)).copy(i),e.E["background-state"]?n.LQ=e.E["background-state"]:n.LQ=a.T3?a.T3.o:{})),l||(n?(n.PU=!0,n.parse()):(n=new ZC.DN(a)).copy(i),zingchart.DEV.CACHESELECTION&&r&&""!==o&&(a.TX[o]=n))}else(n=new ZC.DN(a)).copy(i);return null!==ZC._n_(t=a.T0[e.L])&&(0===e.A.E7.length&&(e.A.E7=[{}]),"string"==typeof a.T0[e.L]?n.append({"background-color":ZC.AP.JK(t,20)+" "+t,"line-color":t,"border-color":ZC.AP.JK(t,20)}):n.append(a.T0[e.L]),n.parse()),n.Z=i.Z,n.C7=i.C7,n},BU:function(e){var i=this,t=[];if(null!==ZC._n_(e))for(var n=0,a=i.BO.length;n<a;n++){var l=i.C.BM(i.BO[n]);l&&l.AF===e&&t.push(i.BO[n])}else t=i.BO;return t},MR:function(){var e=this;return{negation:e.A04,"thousands-separator":e.RF,"decimals-separator":e.RX,decimals:e.DQ,"max-decimals":e.I1,short:e.A33,"short-unit":e.TT,exponent:e.ZX,"exponent-decimals":e.SH}},parse:function(){var e,i,t,n=this;if(n.UD={},n.b(),n.K4={},null!==ZC._n_(e=n.o.scales))for(n.BO=e.split(/,|;|\s/),Z=0;Z<n.BO.length;Z++)n.BO[Z]=ZC.UM(ZC.GV(n.BO[Z]));if(n.C.o.legend&&n.C.o.legend["highlight-plot"]&&(n.IA=!0),null!==ZC._n_(n.o.multiplier)&&null===ZC._n_(n.o.short)&&(n.o.short=n.o.multiplier),null!==ZC._n_(n.o["click-marker"])&&null===ZC._n_(n.o["selection-mode"])&&null===ZC._n_(n.o["selected-marker"])&&(n.o["selection-mode"]="multiple",n.o["selected-marker"]={},ZC._cp_(n.o["click-marker"],n.o["selected-marker"])),n.KR=n.C.KR,n.assign_a([["ignore","HM","b"],["exponent","ZX","b"],["exponent-decimals","SH","ia"],["decimals","DQ","ia"],["max-decimals","I1","i"],["preview","QN","b"],["stacked","CC","b"],["stack-type","KR"],["exact","Q6","b"],["text","AM"],["tooltip-text","J7"],["legend-text","A68"],["description","OZ"],["stack","DZ","i"],["z-index","JS","i"],["aspect","CW"],["mode","A0X"],["density","Y0","f"],["max-nodes","MS"],["max-trackers","S0"],["segment-trackers","Y3","b"],["sampling-step","XW","i"],["scroll-step-multiplier","YA","i"],["url","EA"],["target","FC"],["decimals-separator","RX"],["thousands-separator","RF"],["short","A33","b"],["negation","A04"],["short-unit","TT"],["fast-rules","A73","b"],["errors","S2"],["styles","T0"],["monotone","Q8","b"],["highlight","IA","b"],["highlight-legend","L9","b"],["hover-mode","A3K"],["mid-point","UR","b"],["clustered","LN","b"],["cluster-index","R8","i"],["cluster-offset","RM","i"],["animate","GD","b"],["effect","L7","i"],["speed","JG","f"],["selection-mode","J0"],["group-selections","RN","b"],["background-mode","O5"],["extra-values","YL","ia"]]),n.AAR=n.Q6,!n.E["quick-parse"]){var a;if(ZC._todash_(n.T0),n.IA&&(null===ZC._n_(n.C.o.legend)||null===ZC._n_(n.C.o.legend["highlight-legend"]))&&ZC._n_(null===n.o["highlight-legend"])&&(n.L9=n.IA),null!==ZC._n_(e=n.o.animation))n.GD=!0,null!==ZC._n_(i=e.effect)&&(0===(i+"").indexOf("ANIMATION_")&&null!==ZC._n_(a=ZC.ANIMATION[(i+"").substring(10)])&&(i=a),n.L7=ZC._i_(i),0===n.L7&&(n.GD=!1)),null!==ZC._n_(i=e.speed)&&(0===(i+"").indexOf("ANIMATION_")&&null!==ZC._n_(a=ZC.ANIMATION[(i+"").substring(10)])&&(i=a),n.JG=ZC._f_(i)),null!==ZC._n_(i=e.delay)&&(n.L6=ZC._f_(i)),null!==ZC._n_(i=e.method)&&(0===(i+"").indexOf("ANIMATION_")&&null!==ZC._n_(a=ZC.ANIMATION[(i+"").substring(10)])&&(i=a),n.L8=ZC._i_(i)),null!==ZC._n_(i=e.sequence)&&(0===(i+"").indexOf("ANIMATION_")&&null!==ZC._n_(a=ZC.ANIMATION[(i+"").substring(10)])&&(i=a),n.TQ=ZC._i_(i)),null!==ZC._n_(i=e.attributes)&&(n.FV=i);for(var l in n.JG<10&&(n.JG*=1e3),n.L6<10&&(n.L6*=1e3),"undefined"!=typeof ZC.PH&&(n.JG=ZC.BQ(ZC.PH.U3,n.JG)),("fast"===n.A0X||"undefined"==typeof ZC.PH||zingchart.SKIP.ANIMATION)&&(n.GD=!1),n.H.A19&&(n.GD=!1),-1!==ZC.AV(["line","area","vbar","hbar","stock","scatter","bubble","radar","piano"],n.AF)&&("fast"===n.A0X?n.I3=!0:"normal"===n.A0X||n.GD||-1!==JSON.stringify(n.o).indexOf('"rules"')||-1!==JSON.stringify(n.o).indexOf('"js-rule"')||0!==n.T0.length||-1!==n.H.E.json.indexOf('"override"')||-1!==n.H.E.json.indexOf('"errors"')||"none"!==n.J0?n.I3=!1:n.I3=!0),n.o)if("data-"===l.substring(0,5)){var o=l.substring(5);n.KH[o]=n.o[l]}var r=n.H.B8;if(n.IE=new ZC.D0(n),n.IE.append(n.o),r.load(n.IE.o,B("hover-state")),n.IE.append(n.o["hover-state"]),null!==ZC._n_(n.o["hover-state"])||"line"!==n.AF&&"area"!==n.AF||(n.IE.AN=!1),n.IA&&(n.S3=new ZC.D0(n),r.load(n.S3.o,B("highlight-state")),n.S3.append(n.o),null!==ZC._n_(e=n.o["highlight-state"])&&n.S3.append(e),null===ZC._n_(n.S3.o.shadow)&&(n.S3.o.shadow=!0)),null!==ZC._n_(e=n.o["selected-state"])&&(n.SX=new ZC.D0(n),r.load(n.SX.o,B("selected-state")),n.SX.append(e)),null!==ZC._n_(e=n.o["background-state"])&&(n.T3=new ZC.D0(n),r.load(n.T3.o,B("background-state")),n.T3.append(e)),n.A2=new ZC.D0(n),r.load(n.A2.o,B("marker")),r.load(n.A2.o,B("marker["+n.CW+"]")),n.A2.append(n.o.marker),"auto"===n.A2.o.type){var s=["circle","square","diamond","triangle","star5"];n.A2.o.type=s[n.L%s.length]}if(n.A2.parse(),(n.A2.E7.length>0||n.T0.length>0||n.A2.o["top-state"])&&(n.YH=!1),n.GC=new ZC.D0(n),r.load(n.GC.o,B("hover-marker")),n.GC.append(n.o.marker),n.GC.append(n.o["hover-marker"]),null!==ZC._n_(e=n.o["selected-marker"])&&(n.PN=new ZC.D0(n),r.load(n.PN.o,B("selected-marker")),n.PN.append(e)),null!==ZC._n_(e=n.o["background-marker"])&&(n.PJ=new ZC.D0(n),r.load(n.PJ.o,B("background-marker")),n.PJ.append(e)),n.IA&&(n.V5=new ZC.D0(n),n.V5.append(n.o.marker),null!==ZC._n_(e=n.o["highlight-marker"])&&(r.load(n.V5.o,B("highlight-marker")),n.V5.append(e))),"normal"!==n.A0X&&(n.SX||n.PN)&&(n.I3=!1),"fast"===n.A0X&&(n.I3=!0),n.A7=new ZC.DN(n),n.o.tooltip&&n.o.tooltip.placement&&n.o.tooltip.placement.indexOf("node")>-1?r.load(n.A7.o,"("+n.AF+").tooltip[dynamic]"):r.load(n.A7.o,n.AF+".tooltip"),n.A7.append(n.o.tooltip),null!==ZC._n_(e=n.o.error)&&(n.J8=new ZC.DT(n),r.load(n.J8.o,B("error")),n.J8.append(e),null===ZC._n_(n.J8.o.size)&&(n.J8.o.size=4)),null!==ZC._n_(e=n.o["value-box"])){if(e instanceof Array)for(n.U=new ZC.D0(n),r.load(n.U.o,B("value-box")),null!==ZC._n_(i=n.C.o.plot)&&n.U.append(i["value-box"]),n.U.append(e[0]),e.length>1&&(n.NZ=[]),Z=1;Z<e.length;Z++)n.NZ[Z-1]=new ZC.D0(n),r.load(n.NZ[Z-1].o,B("value-box")),null!==ZC._n_(i=n.C.o.plot)&&n.NZ[Z-1].append(i["value-box"]),n.NZ[Z-1].append(e[Z]);else n.U=new ZC.D0(n),r.load(n.U.o,B("value-box")),null!==ZC._n_(i=n.C.o.plot)&&n.U.append(i["value-box"]),n.U.append(e);n.U.parse()}n.H.QU&&(n.AN=ZC.FSSTATUS["g-"+n.C.L+"-p-"+n.L]);var A=!1;for("undefined"==typeof n.C.E["plot"+n.L+".visible"]&&(A=!0),A?n.C.E["plot"+n.L+".visible"]=!0:n.AN=n.C.E["plot"+n.L+".visible"],n.AN||A&&(n.C.E["plot"+n.L+".visible"]=!1),Z=0,t=n.C.BO.length;Z<t;Z++)null!==ZC._n_(n.C.BO[Z].o.values)?n.C.BO[Z].T9=!0:-1!==ZC.AV(n.BO,n.C.BO[Z].BE)&&("remove"===n.C.getToggleAction()||n.C.A.K9?n.AN&&n.C.E["plot"+n.L+".visible"]&&(n.C.BO[Z].T9=!0):n.C.BO[Z].T9=!0);var C,c=null;if(n.K=n.A.K+"-plot-"+n.L,n.S=[],n.A.F8||(n.A.F8={}),-1!==n.AF.indexOf("area")&&-1===n.AF.indexOf("3d")&&n.CC){n.A.WM||(n.A.WM={}),n.A.WM["s"+n.DZ]||(n.A.WM["s"+n.DZ]=[]);var u=!1;if(null!==ZC._n_(n.o.values))for(Z=0,t=n.o.values.length;Z<t;Z++)if("object"==typeof n.o.values[Z]&&null!==ZC._n_(n.o.values[Z])){u=!0;break}u&&(n.GD=!1,n.HT||0!==n.E7.length||(n.I3=!0,-1===zingchart.DEV.STACKINGLOGIC&&(n.C.UB=1)))}if(n.B1=n.C.BM(n.BU("k")[0]),n.CM=n.C.BM(n.BU("v")[0]),null!==ZC._n_(n.o.values)&&""!==n.AF){if(n.V=n.o.values,n.I3&&"area"===n.AF&&"spline"===n.CW){for(var p=!1,Z=0;Z<n.V.length;Z++)if(null===ZC._n_(n.V[Z])){p=!0;break}p&&(n.I3=!1)}var h=null;n.Q0=[ZC.MAX,-ZC.MAX];var d=[],f=[],_=0;for(Z=0,t=n.V.length;Z<t;Z++){var g=!1;if(n.o["hint-ts"]||(null!==ZC._n_(n.V[Z])&&"object"==typeof n.V[Z]&&n.V[Z].length>1?(null===ZC._n_(n.V[Z][1])||"string"==typeof n.V[Z][1]&&"NULL"===n.V[Z][1].toUpperCase())&&(g=!0):(null===ZC._n_(n.V[Z])||"string"==typeof n.V[Z]&&"NULL"===n.V[Z].toUpperCase())&&(g=!0),"piano"===n.C.AF&&(g=!1)),g)n.S.push(null);else{!n.I3||"xy"!==n.C.AJ.layout&&"yx"!==n.C.AJ.layout?c=n.TV():n.GQ[1]||("bubble"===n.AF||"scatter"===n.AF?n.GQ[1]=c=n.TV():(n.GQ[0]=n.TV(),n.GQ[1]=c=n.TV(),n.GQ[2]=n.TV(),n.GQ[3]=n.TV())),c.K=n.K+"-node-"+Z,"string"==typeof n.V[Z]&&zingchart.QUOTEDVALUES&&(n.V[Z]=ZC._f_(n.V[Z])),c.o={value:n.V[Z]},"string"==typeof n.V[Z]&&(c.A26=!0),c.L=Z,n.o["hint-ts"]?(c.E.plotidx=n.L,c.E.nodeidx=c.L,c.K=n.K+"-node-"+c.L,c.BT=n.V[Z][0],c.AD=n.V[Z][1]):c.parse(),(t<256||zingchart.DEV.CHECKDECIMALS)&&null!==ZC._n_(c.AD)&&2===(C=c.AD.toString().split(".")).length&&(_=ZC.BQ(_,C[1].length)),c.BT&&(null!==h&&ZC._a_(c.BT-h)>0&&d.push(ZC._a_(c.BT-h)),h=c.BT),n.A.WM=n.A.WM||{};var v=n.A.WM["s"+n.DZ];if(v&&(null!==h?-1===ZC.AV(v,c.BT)&&v.push(c.BT):-1===ZC.AV(v,Z)&&v.push(Z)),!n.I3||"xy"!==n.C.AJ.layout&&"yx"!==n.C.AJ.layout)n.S.push(c);else{var b={iX:c.iX,iY:c.iY,L:c.L,BT:c.BT,AD:c.AD,CS:c.AD,DP:c.DP,JE:c.JE};"bubble"===n.AF&&(b.SP=c.SP),n.S.push(b)}null!==c.BT&&(n.Q0[0]=Math.min(n.Q0[0],c.BT),n.Q0[1]=Math.max(n.Q0[1],c.BT)),n.C.E["plot"+n.L+".visible"]&&(zingchart.DEV.PLOTSTATS||"100%"===n.KR)&&n.CC&&(null===ZC._n_(n.A.F8[Z])?(n.A.F8[Z]={},n.A.F8[Z]["%total-"+n.DZ]=c.AD):null===ZC._n_(n.A.F8[Z]["%total-"+n.DZ])?n.A.F8[Z]["%total-"+n.DZ]=c.AD:n.A.F8[Z]["%total-"+n.DZ]+=c.AD),zingchart.DEV.PLOTSTATS&&(f.push(c.AD),n.JL?(n.JL["%plot-max-index"]=Z,n.JL["%plot-sum"]+=c.AD,t<256&&(n.JL["%plot-values"]+=","+c.AD)):n.JL={"%plot-min-index":Z,"%plot-max-index":Z,"%plot-sum":c.AD,"%plot-values":c.AD},n.A.F8||(n.A.F8={}),n.AN&&(null===ZC._n_(n.A.F8["%pstack-"+Z+"-"+n.DZ+"-sum"])?(n.A.F8["%pstack-"+Z+"-"+n.DZ+"-sum"]=c.AD,n.A.F8["%pstack-"+Z+"-"+n.DZ+"-stack-length"]=1):(n.A.F8["%pstack-"+Z+"-"+n.DZ+"-sum"]+=c.AD,n.A.F8["%pstack-"+Z+"-"+n.DZ+"-stack-length"]+=1)))}}(n.V.length<256||zingchart.DEV.CHECKDECIMALS)&&n.JL&&null!==ZC._n_(n.JL["%plot-sum"])&&2===(C=n.JL["%plot-sum"].toString().split(".")).length&&ZC._i_(C[1])>_&&(n.JL["%plot-sum"]=ZC._f_(n.JL["%plot-sum"].toFixed(ZC.CY(20,_)))),zingchart.DEV.PLOTSTATS?(n.JL&&(n.JL["%plot-average"]=n.JL["%plot-sum"]/n.V.length,n.JL["%plot-average"]=ZC._f_(n.JL["%plot-average"].toFixed(ZC.CY(20,_+2)))),f.length>0&&(n.JL["%plot-min-value"]=ZC.XZ(f),n.JL["%plot-max-value"]=ZC.A1L(f))):n.JL={"%plot-min-index":0,"%plot-max-index":n.V.length,"%plot-sum":-1,"%plot-values":"","%plot-average":-1,"%plot-min-value":-1,"%plot-max-value":-1},h&&d.length>0&&(n.AAK=ZC.XZ(d),n.A2K=ZC.A1L(d))}}function B(e){var i=["("+n.AF+").plot."+e];return n.sTypeX&&i.push("("+n.sTypeX+").plot."+e),i}},mapPointsToPreview:function(e,i){for(var t=this,n=t.C.P,a=t.C.B9.AQ,l=[],o=0,r=e.length;o<r;o++)if(e[o]){"vml"===t.H.AB&&i&&(e[o][0]=e[o][0]/10,e[o][1]=e[o][1]/10);var s=(e[o][0]-n.iX)/n.I,A=(e[o][1]-n.iY)/n.F,C=a.iX+a.AU+s*(a.I-2*a.AU),c=a.iY+a.AU+A*(a.F-2*a.AU);l.push([C,c])}else l.push(null);return l},paint:function(){var e=this,i=e.C.P.I;switch(e.C.AF){case"scatter":case"bubble":i=1e6;break;case"hbar":case"hbar3d":i=e.C.P.F}null===ZC._n_(e.MS)&&(e.MS=ZC._i_(i/4)),null===ZC._n_(e.S0)&&(e.S0=ZC._i_(i/4)),e.YH&&(e.HC=null,e.HI=null,e.RB=null,e.QD=null)},XP:function(e){var i,t,n,a=this;for(i=0,t=a.S.length;i<t;i++)a.S[i]&&(a.S[i].JE=!1);var l=a.C.P;if(a.R5=!1,a.G0=!0,a.U5=!1,n=0,a.C.OF||"undefined"!=typeof a.AAR&&(a.Q6=a.AAR),e)a.R5=!0,a.S0<a.S.length&&(a.G0=!1);else{if(a.B1.EF&&a.EF){for(i=0,t=a.S.length;i<t;i++)a.S[i]&&(a.B1.IT.length>0||ZC.DS(a.S[i].BT,a.B1.V[a.B1.W],a.B1.V[a.B1.A1]))&&n++;a.S0<n&&(a.G0=!1),n*a.Y0>l.I&&(a.U5=!0),a.MS>=n&&(a.R5=!0)}else a.MS>a.B1.A1-a.B1.W&&(a.R5=!0);a.Y=1,a.B1.EF&&a.EF||(n=a.B1.A1-a.B1.W,a.S0<n&&(a.G0=!1),n*a.Y0>l.I&&(a.U5=!0),!a.Q6&&n*a.Y0>l.I&&(a.Y=ZC.BQ(1,ZC._i_(n*a.Y0/l.I)))),a.B1.EF&&a.EF&&(a.Q6||n*a.Y0>l.I&&(a.Y=ZC.BQ(1,ZC._i_(n*a.Y0/l.I)))),a.C.OF&&(a.Q6=!1,a.Y*=a.YA)}null!==ZC._n_(a.XW)&&a.Y>a.XW&&(a.Y=a.XW)},P6:function(e){var i,t,n,a=this;null!==ZC._n_(e)&&e||(e=!1),a.B1&&"log"===a.B1.C1&&(e=!0),a.XP(e);var l=null;if(e||a.LN)a.A.A4X=!1,function Z(e,i){for(var t=e;t<ZC.CY(e+i,a.S.length);t++)a.S[t]?((l=a.FK(t)).Z=a.KG,l.paint(),l.JE=!0,a.S[t].JE=!0):"radar"===a.C.AF&&(t===a.S.length-1?"line"!==a.CW&&"area"!==a.CW&&"range"!==a.CW||ZC.CR.paint(a.QC,a,a.D):a.D.push(null));e+i<a.S.length?a.C.LL?window.setTimeout(function(){Z(e+i,i)},10):Z(e+i,i):a.C.LL&&a.L===a.A.A5.length-1&&a.A._end_()}(0,ZC.ie678||ZC.mobile?200:2e3);else{var o="vbar"!==a.AF&&"hbar"!==a.AF;if(a.B1.EF&&a.EF){n=a.GB=a.HD=a.Y;var r=!0,s=0,A=0;for(i=0,t=a.S.length;i<t;i+=n)o&&(t-i==1?(a.GB=n,a.HD=1):t-i<a.Y&&(a.GB=a.Y,a.HD=t-i-1,n=t-i-1)),a.S[i]&&(a.B1.IT.length>0||ZC.DS(a.S[i].BT,a.B1.V[a.B1.W],a.B1.V[a.B1.A1])||o&&r&&a.S[i+n]&&a.S[i+n].BT>=a.B1.V[a.B1.W])&&(o&&r&&a.S[i-n]&&((l=a.FK(i-n)).Z=a.KG,l.paint(),l.JE=!0,r=!1,A++),(l=a.FK(i)).Z=a.KG,l.paint(),l.JE=!0,A++,r=!1,s=i);o&&A>0&&a.S[s+n]&&((l=a.FK(s+n)).Z=a.KG,l.paint(),l.JE=!0)}else{n=a.GB=a.HD=a.Y;var C=0,c=1,u=null;if(!o){var p="vbar"===a.AF?a.C.P.I:a.C.P.F;C=4/("vbar"===a.AF?a.C.P.F:a.C.P.I)*(a.CM.BJ-a.CM.B3),c=1+ZC._i_((a.B1.A1-a.B1.W)/(2*p)),n=1}for(i=a.B1.W;i<=a.B1.A1;i+=n)(a.B1.A1-a.B1.W)%a.Y!=0&&o&&(a.B1.A1-i==0?(a.GB=n,a.HD=1):a.B1.A1-i<=a.Y&&(a.GB=a.Y,a.HD=a.B1.A1-i,n=a.B1.A1-i)),a.S[i]?(l=a.FK(i),(o||a.Q6||!o&&null===u||ZC._a_(l.AD-u)>C||i%c==0)&&(l.Z=a.KG,l.paint(),l.JE=!0,a.S[i].JE=!0),u=l.AD):a.CC&&-1!==ZC.AV(["vbar","hbar","vbar3d","hbar3d"],a.AF)&&a.SO()}}},CP:function(e,i){var t=this;if(t.UD[e+i])return t.UD[e+i];var n=null;return n=t.H.usc()?ZC.AL(t.H.K+"-main-c"+("fl"===e?"-top":"")):t.H.K9||t.C.AJ["3d"]?ZC.AL(t.C.K+"-plots-"+e+"-c"):ZC.AL(t.C.K+"-plot-"+t.L+"-"+e+"-"+i+"-c"),t.UD[e+i]||(t.UD[e+i]=n),n},UZ:function(e){var i=this;return{id:i.H.K,graphid:i.C.K,graphidx:i.C.L,plotid:i.H5,plotindex:i.L,plottext:i.AM,ev:e?ZC.A4.BZ(e):null,xdata:i.KH}},X0:function(e,i){ZC.AP.BY("plot_"+i,this.H,this.UZ(e))},applyJsRuleSvg:function(e,i,t){var n;if(n=e.o["js-rule-svg"]){var a=ZC.AL(i),l=ZC.evalFn(n.replace("javascript:","").replace("()",""),window);if(a&&l)try{var o=l.call(this,t);for(var r in o)a.setAttribute(r,o[r])}catch(s){}}},sharedZScale:function(){var e=this,i=e.C,t=i.P;if(i.o["scale-z"]&&i.E["plot"+e.L+".visible"]){var n,a,l,o,r;if(n=new ZC.CE(i,t.iX+t.I-ZC.AO.E2+10,t.iY+t.F-ZC.AO.E3,e.E["z-mid"]),(a=new ZC.DN(e)).GL=i.K+"-scale-z-item "+i.K+"-scale-item zc-scale-item",a.K=i.K+"-scale-z-item_"+e.L,a.AM=i.o["scale-z"].values[e.L],a.Z=a.C7=e.H.usc()?e.H.mc():ZC.AL(i.K+"-scales-ml-0-c"),r=ZC.Q.EB(a.Z,e.H.AB),a.IL=e.H.usc()?ZC.AL(e.H.K+"-main"):ZC.AL(e.H.K+"-text"),a.append(i.o["scale-z"].item),a.parse(),a.A9+=a.V9?0:ZC.DK.A2T(i,a),a.iX=n.ED[0],a.iY=n.ED[1],a.o["auto-align"]&&a.V9&&(a.iY-=a.F/2),a.paint(),null===ZC._n_(e.E["scale-z-item-max-width"])&&(e.E["scale-z-item-max-width"]=0),e.E["scale-z-item-max-width"]=ZC.BQ(e.E["scale-z-item-max-width"],a.I),e.E["z-cnt"]===e.E["z-plots"]-1&&i.o["scale-z"].label){var s,A;n=new ZC.CE(i,t.iX+t.I-ZC.AO.E2+20+e.E["scale-z-item-max-width"],t.iY+t.F-ZC.AO.E3,ZC.AO.FU/2),(a=new ZC.DN(e)).GL=i.K+"-scale-z-label "+i.K+"-scale-label zc-scale-label",a.K=i.K+"-scale-z-label",a.Z=a.C7=e.H.usc()?e.H.mc():ZC.AL(i.K+"-scales-ml-0-c"),r=ZC.Q.EB(a.Z,e.H.AB),a.IL=e.H.usc()?ZC.AL(e.H.K+"-main"):ZC.AL(e.H.K+"-text"),a.append(i.o["scale-z"].label),a.parse(),s=new ZC.CE(i,t.iX+t.I-ZC.AO.E2,t.iY+t.F-ZC.AO.E3,0),A=new ZC.CE(i,t.iX+t.I-ZC.AO.E2,t.iY+t.F-ZC.AO.E3,ZC.AO.FU);var C=ZC.TN(Math.atan((A.ED[1]-s.ED[1])/(A.ED[0]-s.ED[0])));a.A9+=a.V9?0:C,a.iX=n.ED[0],a.iY=n.ED[1],a.paint()}if(i.o["scale-z"].tick&&((o=new ZC.DT(e)).B7="#cccccc",o.AZ=1,o.AI=6,o.append(i.o["scale-z"].tick),o.parse(),o.AN&&o.AZ>0)){o.K=i.K+"-scale-z-tick-"+e.L;for(var c=[],u=[[t.iX+t.I,t.iY+t.F],[t.iX+t.I+o.AI,t.iY+t.F]],p=0;p<u.length;p++)n=new ZC.CE(i,u[p][0]-ZC.AO.E2,u[p][1]-ZC.AO.E3,e.E["z-mid"]),c.push([n.ED[0],n.ED[1]]);ZC.CR.paint(r,o,c)}if(0===e.E["z-cnt"]&&((o=new ZC.D0(e)).B7="#cccccc",o.AZ=1,o.append(i.o["scale-z"].axis),o.parse(),o.AZ>0&&o.AN&&(o.A0=o.AE=o.B7,(l=ZC.DK.DB(o,i,t.iX+t.I-ZC.AO.E2-o.AZ,t.iX+t.I-ZC.AO.E2,t.iY+t.F-ZC.AO.E3,t.iY+t.F-ZC.AO.E3,0,ZC.AO.FU,"x")).K=i.K+"-scale-z-axis",i.CL.add(l))),e.E["z-cnt"]>0&&i.o["scale-z"].guide&&((o=new ZC.D0(e)).B7="#cccccc",o.AZ=1,o.append(i.o["scale-z"].guide),o.parse(),o.AZ>0&&o.AN&&(o.A0=o.AE=o.B7,(l=ZC.DK.DB(o,i,t.iX-ZC.AO.E2,t.iX+t.I-ZC.AO.E2,t.iY+t.F-ZC.AO.E3,t.iY+t.F-ZC.AO.E3+o.AZ,e.E["z-cnt"]*e.E["z-depth"],e.E["z-cnt"]*e.E["z-depth"],"y")).K=i.K+"-scale-z-guideh-"+e.L,i.CL.add(l),(l=ZC.DK.DB(o,i,t.iX-ZC.AO.E2,t.iX-ZC.AO.E2,t.iY-ZC.AO.E3,t.iY+t.F-ZC.AO.E3,e.E["z-cnt"]*e.E["z-depth"],e.E["z-cnt"]*e.E["z-depth"]+o.AZ,"y")).K=i.K+"-scale-z-guidev-"+e.L,i.CL.add(l))),i.o["scale-z"].items&&i.o["scale-z"].items.length){(o=new ZC.D0(e)).A0=o.AE="#ff9900",o.C6=.25;var Z=e.E["z-cnt"]%i.o["scale-z"].items.length;o.append(i.o["scale-z"].items[Z]),o.parse(),(l=ZC.DK.DB(o,i,t.iX-ZC.AO.E2,t.iX+t.I-ZC.AO.E2,t.iY+t.F-ZC.AO.E3,t.iY+t.F-ZC.AO.E3,e.E["z-cnt"]*e.E["z-depth"],e.E["z-cnt"]*e.E["z-depth"]+e.E["z-depth"],"z")).K=e.K+"-item-",i.CL.add(l)}}},gc:function(){if(this.S)for(var e=0;e<this.S.length;e++)this.S[e]&&this.S[e].A&&ZC.AP.gc(this.S[e],["Z","C7","o","JB","I6","A","C","H","O","NB"]);ZC.AP.gc(this,["V","S","GQ","K4","V1","A7","Z","C7","UD","A2","TY","HC","GC","IE","KG","QC","B1","CM","S","GQ","K4","JL","o","JB","I6","A","C","H"])}};ZC.HV=ZC.HL.CA(HV),ZC.VY=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.bXY=!0,i.AF="xy",i.BO=["scale-x","scale-y"]},paint:function(){this.b()}}),ZC.QW=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.AF="line",i.CW="segmented",i.Y=1,i.SI="middle",i.V1=[],i.MZ=!0,i.O6=!1},TV:function(){return new ZC.A38(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.NO(),e.b(),e.assign_a([["step-start","SI"],["smart-sampling","MZ","b"]]),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0])},paint:function(){var e,i,t,n,a,l,o,r=this;r.b(),r.V1=[];var s=r.O6;if(r.KG=r.CP("bl",0),r.QC=ZC.Q.EB(r.CP("bl",1),r.H.AB),!r.I3||r.C.AJ["3d"])r.P6(),r.D=null;else{r.XP(),r.C7=r.CP("bl",0);var A=!0;(null!==ZC._n_(r.A2.o.visible)&&!ZC._b_(r.A2.o.visible)||null!==ZC._n_(r.A.o.type)&&"none"===r.A2.o.type)&&(A=!1);var C=[],c=[],u=[],p=!0,Z=0,h=null;n=0;var d=-1,f=-1,_=r.A.A5[0].S2&&r.A.A5[0].S2.length,g=r.Y,v=r.CW;if(r.Y>1&&"spline"===v&&(v="segmented"),r.B1.EF&&r.EF){for(t=r.Y,r.MZ&&(t=1),e=0,i=r.S.length;e<i;e+=t)f-e<=r.Y&&(t=ZC.BQ(1,f-e)),r.S[e]&&(r.B1.IT.length>0||ZC.DS(r.S[e].BT,r.B1.V[r.B1.W],r.B1.V[r.B1.A1])||p&&r.S[e+t]&&r.S[e+t].BT>=r.B1.V[r.B1.W])&&(p&&r.S[e-t]&&(-1===d&&(d=e-t),f=e-t,p=!1,Z++),-1===d&&(d=e),f=e,Z++,p=!1,n=e);Z>0&&r.S[n+t]&&(-1===d&&(d=n+t),f=n+t,r.S[n+t].JE=!0)}else d=r.B1.W,f=r.LN||"log"===r.B1.C1?r.S.length:r.B1.A1;r.Y=g;var b=-1;t=r.Y,r.MZ&&(t=1);var B=null,m=null,E=0,D=1;n=d,s?f-d>r.C.P.F&&(E=4/r.C.P.I*(r.CM.BJ-r.CM.B3),D=ZC._f_((f-d)/(4*r.C.P.F))):f-d>r.C.P.I&&(E=4/r.C.P.F*(r.CM.BJ-r.CM.B3),D=ZC._f_((f-d)/(4*r.C.P.I))),r.o["sampling-threshold"]&&(E*=Math.max(1,(f-d)/ZC._i_(r.o["sampling-threshold"])),D*=Math.max(1,(f-d)/ZC._i_(r.o["sampling-threshold"])));for(r.D=[],e=d;e<=f;e+=t){var F=!1;if(((f-d)%r.Y!=0||r.B1.EF&&r.EF)&&f-e<=r.Y&&(t=ZC.BQ(1,f-e),F=!0),r.MZ&&!F&&r.S[e])if(null===ZC._n_(B))B=r.S[e].CS,n=e,m=0;else{if(Math.abs(r.S[e].CS-B)<E&&e-n<D&&(!r.EF||r.S[e].BT-m<4*r.B1.SG))continue;B=r.S[e].CS,m=r.S[e].BT,n=e}if(0,h=r.FK(e)){switch(r.S[e].JE=!0,(r.G0||r.LN)&&h.paint(!0),-1===b&&(b=h.iX),v){default:C.push([h.iX,h.iY]);break;case"spline":s?(c.push(h.iX),u.push(h.iY),1===c.length&&(c.push(h.iX),u.push(h.iY))):(c.push(h.iY),u.push(h.iX),1===c.length&&(c.push(h.iY),u.push(h.iX)));break;case"stepped":switch(r.SI){default:(l=r.FK(e-t,0))&&(l.setup(),a=ZC.AR.JU(r.S[e-t].iX,r.S[e-t].iY,h.iX,h.iY),C.push(s?[h.iX,a[1]]:[a[0],h.iY])),C.push([h.iX,h.iY]),(o=r.FK(e+t,0))&&(o.setup(),a=ZC.AR.JU(h.iX,h.iY,r.S[e+t].iX,r.S[e+t].iY),C.push(s?[h.iX,a[1]]:[a[0],h.iY]));break;case"before":(l=r.FK(e-t,0))&&(l.setup(),C.push([r.S[e-t].iX,r.S[e-t].iY],[r.S[e-t].iX,h.iY])),C.push([h.iX,h.iY]);break;case"after":C.push([h.iX,h.iY]),(o=r.FK(e+t,0))&&(o.setup(),C.push([r.S[e+t].iX,h.iY],[r.S[e+t].iX,r.S[e+t].iY]))}break;case"jumped":(l=r.FK(e-t,0))?(l.setup(),a=ZC.AR.JU(r.S[e-t].iX,r.S[e-t].iY,h.iX,h.iY),C.push(s?[h.iX,a[1]]:[a[0],h.iY])):C.push(s?[h.iX,h.iY-r.B1.AA/2]:[h.iX-r.B1.AA/2,h.iY]),C.push([h.iX,h.iY]),(o=r.FK(e+t,0))?(o.setup(),a=ZC.AR.JU(h.iX,h.iY,r.S[e+t].iX,r.S[e+t].iY),C.push(s?[h.iX,a[1]]:[a[0],h.iY])):C.push(s?[h.iX,h.iY+r.B1.AA/2]:[h.iX+r.B1.AA/2,h.iY]),C.push(null)}_&&h.N3(ZC.Q.EB(r.CP("fl",0),r.H.AB)),(r.R5&&A||r.G0||r.U)&&h.PA(),h.JE=!0}else null!==ZC._n_(r.o["connect-nulls"])&&ZC._b_(r.o["connect-nulls"])||(C.push(null),c.push(null),u.push(null))}if("spline"===v){c.push(c[c.length-1]),u.push(u[u.length-1]),C=[];for(var K=1;K<c.length-1;K++){var x=[c[K-1],c[K],c[K+1],c[K+2]],I=ZC._a_(u[K+1]-u[K]);I=Math.min(I,Math.max(r.C.I,r.C.F));var y=ZC.AR.Y9(r.Q8,x,I);for(e=0;e<y.length;e++)null!==ZC._n_(y[e][0])&&null!==ZC._n_(y[e][1])?s?C.push([y[e][1],u[K]+(r.B1.AW?1:-1)*y[e][0]*I]):C.push([u[K]+(r.B1.AW?-1:1)*y[e][0]*I,y[e][1]]):C.push(null)}}r.CZ=!1;var w=r.H.O7;if(r.H.O7=!1,r.E["fast-vector-path"]=!0,ZC.CR.setup(r.QC,r),ZC.CR.paint(r.QC,r,C),r.H.O7=w,r.C.B9&&r.C.B9.I2&&r.QN){var L=r.mapPointsToPreview(C,!0),X=ZC.Q.EB(r.C.B9.Z,r.H.AB),Y=new ZC.D0(r);Y.copy(r),Y.K=r.K+"-preview",Y.DH=r.K+"-preview",Y.AZ=1;var M=r.o["preview-state"];M&&(Y.append(M),Y.parse()),ZC.CR.paint(X,Y,L,null,3)}}}}),ZC.QX=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.AF="area",i.Y=1,i.CW="segmented",i.SW=3,i.HX=i.C.AJ["3d"]?1:.5,i.SI="middle",i.A44=!0,i.V1=[],i.MZ=!0,i.XH=!1,i.O6=!1},TV:function(){return new ZC.A35(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.C.AJ["3d"]||"solid"===e.o["background-color-style"]?e.A0=e.AE=e.BP[1]:(e.A0=e.BP[0],e.AE=e.BP[1]),e.NO(),e.b(),e.applyRGBA(),e.assign_a([["alpha-area","HX","f",0,1],["step-start","SI"],["active-area","XH","b"],["contour-on-top","A44","b"],["smart-sampling","MZ","b"]]),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0])},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c=this;c.b(),c.V1=[];var u=c.O6;if(-1===ZC.AV(["segmented","spline","stepped"],c.CW)&&(c.CW="segmented"),c.KG=c.CP("bl",0),c.A56=ZC.Q.EB(c.CP("bl",1),c.H.AB),c.QC=ZC.Q.EB(c.CP("bl",c.A44?2:1),c.H.AB),A=c.C.P,!c.I3||c.C.AJ["3d"]){var p=ZC.MAX,Z=-ZC.MAX;for(e=0,i=c.S.length;e<i;e++)c.S[e]&&(p=ZC.CY(p,c.S[e].CS),Z=ZC.BQ(Z,c.S[e].CS));var h=c.CM.AT(p),d=c.CM.AT(Z),f=c.CM.AT(c.CM.H8);if(ZC.DS(f,h,d)&&(c.CM.AW?f<h&&(h=f):f>d&&(d=f)),c.E["min-y"]=Math.min(h,d),c.E["max-y"]=Math.max(h,d),c.CC&&c.A.F1){var _=ZC.MAX,g=-ZC.MAX;for(e=0,i=c.A.F1.length;e<i;e++)if(c.A.F1[e])for(var v=0,b=c.A.F1[e].length;v<b;v++)_=ZC.CY(_,c.A.F1[e][v][1]),g=ZC.BQ(g,c.A.F1[e][v][1]);c.CM.AW?c.E["min-y"]=_:c.E["max-y"]=g}c.E["max-y"]-c.E["min-y"]<100&&(c.E["max-y"]+=50,c.E["min-y"]-=50),c.P6(),c.D=null,c.D6=null,c.AH=null}else{c.XP(),c.C7=c.CP("bl",0);var B=!0;(null!==ZC._n_(c.A2.o.visible)&&!ZC._b_(c.A2.o.visible)||null!==ZC._n_(c.A.o.type)&&"none"===c.A2.o.type)&&(B=!1);var m=c.CC&&0===c.C.UB,E=[],D=[],F=[],K=[],x=[],I=c.CM.H8;c.o["ref-value"]&&(I=ZC._f_(c.o["ref-value"]));var y=c.CM.AT(I);u?"xy"===c.C.AJ.layout?(y=c.B1.AT(I),y=ZC._l_(y,c.B1.iX,c.B1.iX+c.B1.I)):y=ZC._l_(y,c.CM.iX,c.CM.iX+c.CM.I):"yx"===c.C.AJ.layout?(y=c.B1.AT(I),y=ZC._l_(y,c.B1.iY,c.B1.iY+c.B1.F)):y=ZC._l_(y,c.CM.iY,c.CM.iY+c.CM.F);var w=!0,L=0,X=null;t=0;var Y=-1,M=-1,H=c.A.A5[0].S2&&c.A.A5[0].S2.length,P=c.Y,N=c.CW;if(c.Y>1&&"spline"===N&&(N="segmented"),c.B1.EF&&c.EF){for(n=c.Y,c.MZ&&(n=1),e=0,i=c.S.length;e<i;e+=n)M-e<=c.Y&&(n=ZC.BQ(1,M-e)),c.S[e]&&(c.B1.IT.length>0||ZC.DS(c.S[e].BT,c.B1.V[c.B1.W],c.B1.V[c.B1.A1])||w&&c.S[e+n]&&c.S[e+n].BT>=c.B1.V[c.B1.W])&&(w&&c.S[e-n]&&(-1===Y&&(Y=e-n),M=e-n,w=!1,L++),-1===Y&&(Y=e),M=e,L++,w=!1,t=e);L>0&&c.S[t+n]&&(-1===Y&&(Y=t+n),M=t+n,c.S[t+n].JE=!0)}else Y=c.B1.W,M=c.LN||"log"===c.B1.C1?c.S.length:c.B1.A1;c.Y=P,m||c.A.D6&&(D=c.A.D6.reverse());var S=null,O=null,G=0,k=1;t=Y,u?M-Y>c.C.P.F&&(G=4/c.C.P.I*(c.CM.BJ-c.CM.B3),k=ZC._f_((M-Y)/(4*c.C.P.F))):M-Y>c.C.P.I&&(G=4/c.C.P.F*(c.CM.BJ-c.CM.B3),k=ZC._f_((M-Y)/(4*c.C.P.I)));var T=!1,z=!1,Q=-1;n=c.Y,c.MZ&&(n=1),T=!0,!c.A.RS&&m&&(c.A.RS={},c.A.VJ={});var J=null,V=null;if(c.A.RS&&!c.A.RS["s"+c.DZ]&&m){c.A.RS["s"+c.DZ]={},c.A.VJ["s"+c.DZ]={};var R=c.A.WM["s"+c.DZ];for(e=0;e<=R.length;e++)null!==ZC._n_(R[e])&&(a=c.B1.EF?ZC._i_(c.B1.AT(R[e])):ZC._i_(c.B1.IB(R[e])),c.A.RS["s"+c.DZ][a]=y,c.A.VJ["s"+c.DZ][a]=y)}for(m&&(J=c.A.RS["s"+c.DZ],V=c.A.VJ["s"+c.DZ]),e=Y;e<=M;e+=n){var W=!1;if(((M-Y)%c.Y!=0||c.B1.EF&&c.EF)&&M-e<=c.Y&&(n=ZC.BQ(1,M-e),W=!0),c.MZ&&!W&&c.S[e])if(null===ZC._n_(S))S=c.S[e].CS,t=e,O=0;else{if(Math.abs(c.S[e].CS-S)<G&&e-t<k&&(!c.EF||c.S[e].BT-O<4*c.B1.SG))continue;S=c.S[e].CS,O=c.S[e].BT,t=e}if(X=c.FK(e)){switch(c.S[e].JE=!0,(c.G0||c.LN)&&X.paint(!0),(z||("segmented"===N||"stepped"===N)&&e===Y&&0===D.length)&&(m||(D.push(u?[y,X.iY]:[X.iX,y]),z&&F.push(u?[y,X.iY]:[X.iX,y]))),z=!1,-1===Q&&(Q=X.iX),N){default:m||T&&(u?X.iY>c.B1.iY&&(F.push([y,c.B1.iY]),F.push([y,X.iY]),D.push([y,X.iY])):X.iX>c.B1.iX&&(F.push([c.B1.iX,y]),F.push([X.iX,y]),D.push([X.iX,y])),T=!1),E.push([X.iX,X.iY]),m?u?V[ZC._i_(X.iY)]=X.iX:V[ZC._i_(X.iX)]=X.iY:(F.push([X.iX,X.iY]),D.push([X.iX,X.iY]));break;case"spline":u?(K.push(X.iX),x.push(X.iY),1===K.length&&(K.push(X.iX),x.push(X.iY))):(K.push(X.iY),x.push(X.iX),1===K.length&&(K.push(X.iY),x.push(X.iX)));break;case"stepped":var U=c.B1.AW?-1:1;switch(c.SI){default:(o=c.FK(e-n,0))&&(o.setup(),l=ZC.AR.JU(c.S[e-n].iX,c.S[e-n].iY,X.iX,X.iY),E.push(u?[X.iX,l[1]]:[l[0],X.iY]),m?u?V[ZC._i_(l[1])-U]=X.iX:V[ZC._i_(l[0])+U]=X.iY:(F.push(u?[X.iX,l[1]]:[l[0],X.iY]),D.push(u?[X.iX,l[1]]:[l[0],X.iY]))),E.push([X.iX,X.iY]),m?u?V[ZC._i_(X.iY)]=X.iX:V[ZC._i_(X.iX)]=X.iY:(F.push([X.iX,X.iY]),D.push([X.iX,X.iY])),(r=c.FK(e+n,0))&&(r.setup(),l=ZC.AR.JU(X.iX,X.iY,c.S[e+n].iX,c.S[e+n].iY),E.push(u?[X.iX,l[1]]:[l[0],X.iY]),m?u?V[ZC._i_(l[1])+U]=X.iX:V[ZC._i_(l[0])-U]=X.iY:(F.push(u?[X.iX,l[1]]:[l[0],X.iY]),D.push(u?[X.iX,l[1]]:[l[0],X.iY])));break;case"before":(o=c.FK(e-n,0))&&(o.setup(),E.push([c.S[e-n].iX,c.S[e-n].iY],[c.S[e-n].iX,X.iY]),m?u?(V[ZC._i_(X.iY)+U]=c.S[e-n].iX,V[ZC._i_(X.iY)]=c.S[e-n].iX):(V[ZC._i_(c.S[e-n].iX)]=c.S[e-n].iY,V[ZC._i_(c.S[e-n].iX)+U]=X.iY):(F.push([c.S[e-n].iX,c.S[e-n].iY],[c.S[e-n].iX,X.iY]),D.push([c.S[e-n].iX,c.S[e-n].iY],[c.S[e-n].iX,X.iY]))),E.push([X.iX,X.iY]),m?u?V[ZC._i_(X.iY)]=X.iX:V[ZC._i_(X.iX)]=X.iY:(F.push([X.iX,X.iY]),D.push([X.iX,X.iY]));break;case"after":E.push([X.iX,X.iY]),m?u?V[ZC._i_(X.iY)]=X.iX:V[ZC._i_(X.iX)]=X.iY:(F.push([X.iX,X.iY]),D.push([X.iX,X.iY])),(r=c.FK(e+n,0))&&(r.setup(),E.push([c.S[e+n].iX,X.iY],[c.S[e+n].iX,c.S[e+n].iY]),m?u?(V[ZC._i_(X.iY)-U]=c.S[e+n].iX,V[ZC._i_(c.S[e+n].iY)]=c.S[e+n].iX):(V[ZC._i_(c.S[e+n].iX)-U]=X.iY,V[ZC._i_(c.S[e+n].iX)]=c.S[e+n].iY):(F.push([c.S[e+n].iX,X.iY],[c.S[e+n].iX,c.S[e+n].iY]),D.push([c.S[e+n].iX,X.iY],[c.S[e+n].iX,c.S[e+n].iY])))}}H&&X.N3(ZC.Q.EB(c.CP("fl",0),c.H.AB)),(c.R5&&B||c.G0||c.U)&&X.PA(),X.JE=!0}else null!==ZC._n_(c.o["connect-nulls"])&&ZC._b_(c.o["connect-nulls"])||(E.push(null),K.push(null),x.push(null),m||(D.length-1>=0&&D.push(u?[y,D[D.length-1][1]]:[D[D.length-1][0],y]),F.length-1>=0&&F.push(u?[y,D[D.length-1][1]]:[D[D.length-1][0],y]),z=!0))}if("segmented"!==N&&"stepped"!==N||m||D.length-1>=0&&(u?D.push([y,D[D.length-1][1]]):D.push([D[D.length-1][0],y])),"spline"===N){K.push(K[K.length-1]),x.push(x[x.length-1]),E=[],m||D.push(u?[y,x[0]]:[x[0],y]);for(var j=1;j<K.length-1;j++){var q=[K[j-1],K[j],K[j+1],K[j+2]],$=ZC._a_(x[j+1]-x[j]);$=Math.min($,Math.max(c.C.I,c.C.F));var ee=ZC.AR.Y9(c.Q8,q,$);for(e=0;e<ee.length;e++)null!==ZC._n_(ee[e][0])&&null!==ZC._n_(ee[e][1])?(s=u?[ee[e][1],x[j]+(c.B1.AW?1:-1)*ee[e][0]*$]:[x[j]+(c.B1.AW?-1:1)*ee[e][0]*$,ee[e][1]],E.push(s),m?u?V[ZC._i_(s[1])]=s[0]:V[ZC._i_(s[0])]=s[1]:(D.push(s),F.push(s))):E.push(null)}m||D.push(u?[y,D[D.length-1][1]]:[D[D.length-1][0],y])}if(!m&&F.length>0){var ie=F[F.length-1];u||ie[0]<c.B1.iX+c.B1.I&&(F.push(u?[y,ie[1]]:[ie[0],y]),F.push(u?[y,c.B1.iY]:[c.B1.iX+c.B1.I,y]))}if(m){var te=[],ne=[],ae=[],le=[];for(C in V)ae.push([C,V[C]]);for(C in ae.sort(function(e,i){return e[0]-i[0]}),J)le.push([C,J[C]]);for(le.sort(function(e,i){return e[0]-i[0]}),e=0;e<ae.length;e++)u?te.push([ae[e][1],ae[e][0]]):te.push([ae[e][0],ae[e][1]]);for(e=0;e<le.length;e++)u?ne.push([le[e][1],le[e][0]]):ne.push([le[e][0],le[e][1]]);for(C in(D=te.concat(ne.reverse()))[0]&&D.push(D[0]),J=c.A.RS["s"+c.DZ]={},V)J[C]=V[C]}var oe=new ZC.DT(c);if(oe.copy(c),oe.CZ=!0,oe.L4=!0,oe.AZ=0,oe.AU=0,oe.EX=0,oe.GA=0,oe.N9=c.O6?180:90,oe.parse(),oe.C6=c.HX,oe.Z=c.CP("bl",c.C.CC?0:1),oe.D=D,oe.A3W(),oe.K=c.K+"-area",oe.paint(),c.CZ=!1,ZC.CR.setup(c.QC,c),ZC.CR.paint(c.QC,c,E),c.C.B9&&c.C.B9.I2&&c.QN){var re,se=c.C.B9,Ae=c.mapPointsToPreview(D),Ce=new ZC.DT(c.A);Ce.copy(c),Ce.CZ=!0,Ce.L4=!0,Ce.AZ=0,Ce.AU=0,Ce.EX=0,Ce.GA=0,Ce.C6=c.HX,Ce.D1=[A.iX,A.iY,A.iX+A.I,A.iY+A.F],Ce.K=c.K+"-area-preview",Ce.DH=c.K+"-preview",Ce.Z=se.Z;var ce=c.o["preview-state"];ce&&(null!==ZC._n_(ce["alpha-area"])?(re=ce.alpha,ce.alpha=c.o["preview-state"]["alpha-area"]):ce.alpha=Ce.C6,Ce.append(ce),Ce.parse(),null!==ZC._n_(re)?ce.alpha=re:delete ce.alpha),Ce.D=Ae,Ce.paint();var ue=c.mapPointsToPreview(E),pe=ZC.Q.EB(se.Z,c.H.AB),Ze=new ZC.D0(c);Ze.copy(c),Ze.CZ=!0,Ze.L4=!0,Ze.K=c.K+"-line-preview",Ze.DH=c.K+"-preview",Ze.AZ=1,ce&&(Ze.append(ce),Ze.parse()),ZC.CR.paint(pe,Ze,ue,null,3)}c.CC&&(c.A.D6=F)}}}),ZC.A21=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.AF="bar",i.sMetaType="bar",i.F4=.1,i.D3=0,i.bKeyWidth=!1,i.YO=-1,i.CF=.1,i.CT=.1,i.F0=0,i.TK=!1,i.LX=[],i.P1="bg",i.A3H=!0,i.MZ=!1},parse:function(){var e=this;if(e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.BW=e.BP[1],e.A0=e.BP[1],e.AE=e.BP[2],e.NO(),e.b(),"histogram"===e.CW&&(e.F4=e.CF=e.CT=0),e.assign_a([["group-bars","A3H","b"],["show-zero","TK","b"],["offset-values","LX"],["bar-space","F4","fp"],["bar-width","D3","fp"],["key-width","bKeyWidth","b"],["bar-max-width","YO","fp"],["bars-space-left","CF","fp"],["bars-space-right","CT","fp"],["bars-overlap","F0","fp"],["smart-sampling","MZ","b"]]),e.A3H||(e.F0=1),0===e.F4&&0===e.CF&&0===e.CT&&(e.FD=!1),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0]),null!==ZC._n_(e.o.column)){var i=e.o.column.split("/");if(2===i.length){var t=ZC._i_(i[0]),n=ZC._i_(i[1]),a=e.CF;e.CF>=1&&(a=e.CF/e.B1.AA);var l=e.CT;e.CT>=1&&(l=e.CT/e.B1.AA);var o=1-a-l,r=ZC._x_(o/(3*n+1));e.CF=a+r+3*(t-1)*r,e.CT=1-e.CF-2*r}}},SO:function(){var e,i=this;if(i.RJ)return i.RJ;if(i.o["fast-dimensions"]&&i.A.A5[0].RJ)return i.A.A5[0].RJ;i.bKeyWidth&&(i.assign_a([["bar-width","D3","fp"]]),i.D3=((i.B1.CO?i.B1.F:i.B1.I)-i.B1.AC-i.B1.BV)*(i.D3/(i.B1.BJ-i.B1.B3)));var t,n=i.B1.AA*i.Y,a=0;for(i.A.K2[i.AF]=i.A.K2[i.AF]||[],e=0;e<i.A.K2[i.AF].length;e++){var l=i.A.K2[i.AF][e][0];i.A.A5[l].BO[0]===i.BO[0]&&a++}if(i.LN)for(a=0,e=0;e<i.A.A5.length;e++)"bar"===i.A.A5[e].sMetaType&&(a=ZC.BQ(a,i.A.A5[e].S.length));if(null===ZC._n_(i.B1.ET)&&(i.B1.ET=0,i.B1.WK={}),i.CC&&null!==ZC._n_(i.B1.WK["stack-"+i.DZ]))t=i.B1.WK["stack-"+i.DZ];else{for(t=i.B1.ET,e=0;e<i.L;e++)if((i.A.A5[e].AN||"hide"===i.C.getToggleAction())&&i.BO[0]===i.A.A5[e].BO[0]&&i.A.A5[e].AF===i.AF&&(!i.CC||i.A.A5[e].DZ!==i.DZ)&&!i.A.A5[e].HM){t++;break}i.B1.ET=t,i.B1.WK["stack-"+i.DZ]=t}for(var o=!0,r=0,s=[],A=0;A<i.A.A5.length;A++)i.A.A5[A].D3<=1?o=!1:null!==ZC._n_(i.A.A5[A].D3)&&(i.A.A5[A].CC&&-1!==ZC.AV(s,i.A.A5[A].DZ)||(s.push(i.A.A5[A].DZ),r+=i.A.A5[A].D3));var C=i.CF;C<=1&&(C*=n);var c,u=i.CT;u<=1&&(u*=n),C=ZC._i_(C),u=ZC._i_(u);var p,Z,h,d,f=i.F0;return o?(c=r,0===i.F0||a<=1?((p=i.F4)<=1&&(p*=c/a),u=(h=n-c-(p=ZC.BQ(0,p))*(a-1))-(C=h*(d=0===u?1:C/u)/(1+d)),C<1&&(C=u=0,p=n-c,a>1&&(p/=a-1),p<0&&(c=n-C-u-(p=0)*(a-1))),Z=(c=ZC.BQ(c,1*a))/a):a>1&&(p=0,Z=c/a,f<=1&&(f*=Z),u=(h=n-(c=a*(Z-(f=ZC.CY(f,Z)))+f)-p*(a-1))-(C=h*(d=0===u?1:C/u)/(1+d)),C<1&&(c-=1-C))):(c=n-C-u,0===i.F0||a<=1?((p=i.F4)<=1&&(p*=c/a),u=(h=n-c-(p=ZC.BQ(0,p))*(a-1))-(C=h*(d=0===u?1:C/u)/(1+d)),C<1&&(C=u=0,p=n-c,a>1&&(p/=a-1),p<0&&(c=n-C-u-(p=0)*(a-1))),Z=(c=ZC.BQ(c,1*a))/a):a>1&&(p=0,Z=c/a,f>1&&(f=Z/f),f*=Z=c/(a-a*f+f),u=(h=n-c-p*(a-1))-(C=h*(d=0===u?1:C/u)/(1+d)),C<1&&(c-=1-C))),-1!==i.YO&&Z>i.YO&&!i.E.bw&&(i.D3=i.YO),i.RJ={AA:n,ET:t,CF:C,CT:u,F4:p,D3:Z,F0:f},{AA:n,ET:t,CF:C,CT:u,F4:p,D3:Z,F0:f}},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0);var i=e.FD;e.A2L=!1,e.SC=null;var t=1;e.B1.EF&&(t=e.S.length/(e.B1.DX-e.B1.DC)),0!==e.E7.length||e.HT||e.C.KI||"svg"!==e.H.AB||!(e.B1.A1-e.B1.W>2048||e.B1.EF&&t*(e.B1.A1-e.B1.W)>2048)||(e.A2L=!0,null===ZC._n_(e.o["rect-shortcut"])&&(e.FD=!0)),e.FD||(e.A2L=!1),e.P6(),e.FD=i,e.RefNode=null,e.WA=null}}),ZC.QZ=ZC.A21.CA({$i:function(e){this.b(e),this.AF="vbar"},TV:function(){return new ZC.ZB(this)}}),ZC.QS=ZC.A21.CA({$i:function(e){this.b(e),this.AF="hbar"},TV:function(){return new ZC.ZA(this)}}),ZC.PC=ZC.VY.CA({$i:function(e,i){this.b(e),this.AF=i||"scatter",this.P1="markerbg",this.bPoly=!1,this.HX=.5},TV:function(){return new ZC.A5O(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.A0=e.BP[1],e.AE=e.BP[1],e.B7=e.BP[2],e.BW=e.BP[2],e.NO(),e.b(),e.assign_a([["alpha-area","HX","f",0,1]]),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0])},paint:function(){var e,i,t,n=this;if(n.b(),n.KG=n.CP("bl",0),n._oCtxNode=ZC.Q.EB(n.CP("bl",0),n.H.AB),!n.I3||n.C.AJ["3d"]||"fast"!==n.A0X||0!==n.S0)n.P6(!0);else{var a=null,l=n.B1,o=n.CM;n.XP(!0);var r=new ZC.DT(n.A);for(r.Z=n.CP("bl",1),r.C7=n.CP("bl",0),r.B7=n.BP[3],r.BW=n.BP[3],r.A0=n.BP[2],"bubble"===n.AF||"hbubble"===n.AF?r.AE=n.BP[1]:r.AE=n.BP[2],r.append(n.A2.o),r.parse(),i=0;i<=n.S.length;i++)if(a=n.FK(i)){var s=!1;l.CO?ZC.DS(a.iX,o.iX+(o.AW?o.BV:o.AC)-1,o.iX+o.I-(o.AW?o.AC:o.BV)+1)&&ZC.DS(a.iY,l.iY+(l.AW?l.BV:l.AC)-1,l.iY+l.F-(l.AW?l.AC:l.BV)+1)&&(s=!0):ZC.DS(a.iX,l.iX+(l.AW?l.BV:l.AC)-1,l.iX+l.I-(l.AW?l.AC:l.BV)+1)&&ZC.DS(a.iY,o.iY+(o.AW?o.AC:o.BV)-1,o.iY+o.F-(o.AW?o.BV:o.AC)+1)&&(s=!0),s&&(a.JE=!0,n.S[i].JE=!0,r.K=a.K+"-marker",r.iX=a.iX,r.iY=a.iY,"circle"!==r.DU&&r.parse(),"none"!==n.J0&&(n.C.IX[n.L]||n.C.KI)&&(r.o={},r.LQ={},n.C.CB["p"+n.L]&&n.C.CB["p"+n.L]["n"+i]?r.LQ=n.PN?n.PN.o:{}:"none"!==n.O5&&("plot"===n.O5&&n.C.IX[i]||"graph"===n.O5&&n.C.KI)&&(r.LQ=n.PJ?n.PJ.o:{}),r.B7=n.BP[3],r.BW=n.BP[3],r.A0=n.BP[2],"bubble"===n.AF||"hbubble"===n.AF?r.AE=n.BP[1]:r.AE=n.BP[2],r.append(n.A2.o),r.parse()),r.paint())}}if(n.bPoly){for(e=[],i=0,t=n.S.length;i<t;i++)e.push([n.S[i].iX,n.S[i].iY]);e.length&&e.push(e[0]);var A=new ZC.DT(n);A.copy(n),A.C6=n.HX,A.CZ=!0,A.L4=!0,A.AZ=0,A.AU=0,A.EX=0,A.GA=0,A.Z=n.KG,A.D=e,A.A3W(),A.K=n.K+"-area",A.paint(),n.CZ=!1,ZC.CR.setup(n._oCtxNode,n),ZC.CR.paint(n._oCtxNode,n,e)}}}),ZC.RU=ZC.VY.CA({$i:function(e,i){this.b(e),this.AF=i||"bubble",this.VR=null,this.W4=null,this.A1M=1,this.JD=1,this.AA8="area",this.P1="markerbg"},TV:function(){return new ZC.A6W(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.A0=e.BP[2],e.AE=e.BP[1],e.B7=e.BP[2],e.BW=e.BP[2],e.NO(),e.b(),e.assign_a([["min-size","VR","i"],["max-size","W4","i"],["scaling","AA8"],["sizing-group","A1M","i"],["size-factor","JD","f"]]),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0]),null===ZC._n_(e.VR)&&(e.VR=15),null===ZC._n_(e.W4)&&(e.W4=.75*Math.min(e.B1.AC,e.B1.BV,e.CM.AC,e.CM.BV),e.W4=ZC.BQ(25,ZC.CY(50,e.W4)))},getSize:function(e){var i,t=this,n=null;switch(e=ZC.BQ(e,t.RL),i=t.WU===t.RL?e-t.RL:(e-t.RL)/(t.WU-t.RL),t.AA8){case"radius":n=t.VR+t.JD*(t.W4-t.VR)*i;break;case"area":case"sqrt":n=t.VR+t.JD*(t.W4-t.VR)*Math.sqrt(i)}return ZC.BQ(t.VR,n)},paint:function(){var e=this;if(e.b(),e.KG=e.CP("bl",0),null!==ZC._n_(e.W4)){e.WU=-ZC.MAX,e.RL=ZC.MAX;for(var i=e.A.A5,t=0,n=i.length;t<n;t++)if(i[t].A1M===e.A1M)for(var a=0,l=i[t].S.length;a<l;a++)e.WU=ZC.BQ(e.WU,ZC._a_(i[t].S[a].SP)),e.RL=ZC.CY(e.RL,ZC._a_(i[t].S[a].SP))}e.P6(!0)}}),ZC.VV=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.AF="pie",i.BO=["scale","scale-v","scale-r"],i.PQ=0,i.DJ=0,i.TK=!1,i.A7O=!0,i.C3=null,i.P1="bg"},TV:function(){return new ZC.A8O(this)},parse:function(){var e,i,t=this;null===ZC._n_(t.o["value-box"])&&(t.o["value-box"]={}),"ring"!==t.A.A.o.type&&"ring3d"!==t.A.A.o.type||(t.PQ=.35),t.BP=t.NQ(),t.C2=t.BP[0],t.A0=t.BP[1],t.AE=t.BP[2],t.BW=t.BP[0],t.B7=t.BP[0],t.NO(),t.b(),t.C3=new ZC.D0(t),t.C.A.B8.load(t.C3.o,["graph.plot.value-box.connector",t.AF+".plot.value-box.connector"]),null!==ZC._n_(e=t.C.o.plot)&&null!==ZC._n_(e["value-box"])&&null!==ZC._n_(i=e["value-box"].connector)&&t.C3.append(i),t.C3.append(t.o["value-box"].connector),t.assign_a([["offset","DV","fp"],["slice","PQ","fp"],["show-zero","TK","b"],["detach","A7O","b"],["ref-angle","DJ","i"]]),t.DJ%=360;for(var n=0,a=t.S.length;n<a;n++)t.S[n]&&(t.S[n].CN=t.PQ,t.S[n]&&(t.C.E["plot"+t.L+".visible"]||"hide"===t.C.getToggleAction())&&(null===ZC._n_(t.A.KL[n])&&(t.A.KL[n]=0),t.A.KL[n]+=ZC._f_(t.S[n].AD)))},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.P6(!0)}}),ZC.TW=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.AF="nestedpie",i.BO=["scale"],i.U1=0,i.SK=0,i.DJ=0,i.C3=null,i.P1="bg",i.aBandWidths=null},TV:function(){return new ZC.A49(this)},parse:function(){var e,i,t=this;t.BP=t.NQ(),t.C2=t.BP[0],t.A0=t.BP[1],t.AE=t.BP[2],t.BW=t.BP[0],t.B7=t.BP[0],t.NO(),t.b(),t.U&&(t.C3=new ZC.D0(t),t.C.A.B8.load(t.C3.o,["graph.plot.value-box.connector",t.AF+".plot.value-box.connector"]),null!==ZC._n_(e=t.C.o.plot)&&null!==ZC._n_(e["value-box"])&&null!==ZC._n_(i=e["value-box"].connector)&&t.C3.append(i),t.C3.append(t.o["value-box"].connector)),t.assign_a([["slice-start","U1","fp"],["offset","U1","fp"],["slice","U1","fp"],["band-space","SK","fp"],["ref-angle","DJ","i"],["band-widths","aBandWidths"]]),t.DJ%=360;for(var n=0,a=t.S.length;n<a;n++)t.S[n]&&(t.C.E["plot"+t.L+".visible"]||"hide"===t.C.getToggleAction())&&(null===ZC._n_(t.A.KL[n])&&(t.A.KL[n]=0),t.A.KL[n]+=ZC._f_(t.S[n].AD))},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.P6(!0)}}),ZC.X8=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.AF="radar",i.SW=3,i.BO=["scale-k","scale-v","scale"],i.HX=.5,i.CW="line",i.A65=null,i.XH=!1,i.D=[],i.AH=[]},TV:function(){return new ZC.A72(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.A0=e.BP[3],e.AE=e.BP[3],e.NO(),e.b(),e.applyRGBA(),e.assign_a([["active-area","XH","b"],["alpha-area","HX","f",0,1],["angle-space","A65","f"]]),e.B1=e.C.BM("scale-k"),e.CM=e.C.BM("scale-v"),"range"===e.CW&&(e.A0X="normal",e.I3=!1)},paint:function(){var e=this;e.b(),e.B1.V.length===e.V.length&&-1===ZC.AV(e.V,null)||(e.A0X="normal",e.I3=!1),e.KG=ZC.AL(e.C.K+"-plot-"+e.L+"-bl-0-c"),e.A56=ZC.Q.EB(e.CP("bl",0),e.H.AB),e.QC=ZC.Q.EB(e.CP("bl",2),e.H.AB),e.P6(!0)}}),ZC.A4P=ZC.A21.CA({$i:function(e){this.b(e);var i=this;i.F4=.2,i.CF=.28,i.CT=.28,i.F0=0,i.FJ=null,i.A34=[],i.PT=[],i.AA6=!0,i.P1="bg"},ABZ:function(e){var i;if("goal"===e){if(null!==ZC._n_(i=this.FJ.o.tooltip))return i;if(null!==ZC._n_(i=this.FJ.o["tooltip-text"]))return{text:i}}return{}},parse:function(){var e,i=this;if(i.BP=i.NQ(),i.b(),null!==ZC._n_(i.A34=i.o.goals))for(var t=0,n=i.A34.length;t<n;t++)null!==ZC._n_(i.A34[t])?"string"==typeof i.A34[t]?i.PT[t]=ZC.AV(i.CM.JM,i.A34[t]):i.PT[t]=ZC._f_(i.A34[t]):i.PT[t]=null;i.FJ=new ZC.HL(i),i.FJ.copy(i),i.FJ.append({"background-color":i.BP[3]}),i.FJ.o["tooltip-text"]="%node-goal-value",i.H.B8.load(i.FJ.o,["("+i.AF+").plot.goal"],!0,!0),null!==ZC._n_(e=i.o.goal)&&i.FJ.append(e),i.FJ.parse()}}),ZC.TD=ZC.A4P.CA({$i:function(e){this.b(e),this.AF="vbullet"},TV:function(){return new ZC.A5P(this)}}),ZC.TB=ZC.A4P.CA({$i:function(e){this.b(e),this.AF="hbullet"},TV:function(){return new ZC.A5Q(this)}}),ZC.XB=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.AF="piano",i.CW="alpha",i.A7J="plot-max",i.QB=.2,i.US=1,i.P1="bg"},TV:function(){return new ZC.A76(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.BW=e.BP[1],e.A0=e.BP[2],e.AE=e.BP[1],e.NO(),e.b(),e.assign_a([["min-ratio","QB","f",0,1],["max-ratio","US","f",0,1],["reference","A7J",""]]),e.QB>=e.US&&(e.QB=.2,e.US=1),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0])},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.A4J=e.A3B=-ZC.MAX,e.Y8=e.WQ=ZC.MAX,e.A5Z=e.A4L=0;for(var i=0,t=e.A.A5.length;i<t;i++)for(var n=e.A.A5[i],a=0,l=n.S.length;a<l;a++)if(n.S[a]){var o=ZC._f_(n.S[a].AD);n.L===e.L&&(e.A4J=ZC.BQ(e.A4J,o),e.Y8=ZC.CY(e.Y8,o),e.A5Z+=o),e.A3B=ZC.BQ(e.A3B,o),e.WQ=ZC.CY(e.WQ,o),e.A4L+=o}e.P6()}}),ZC.W7=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.L0=.1,i.OG=.1,i.LU=0,i.A2I="dynamic",i.OU=[],i.VL=[],i.P1="bg"},parse:function(){var e,i,t,n,a=this;if(a.BP=a.NQ(),a.C2=a.BP[0],a.B7=a.BP[1],a.BW=a.BP[1],a.A0=a.BP[2],a.AE=a.BP[1],a.NO(),a.b(),a.assign_a([["start-width","A2I"],["min-exit","LU","fp"],["space-entry","L0","fp"],["offset","L0","fp"],["offset","OG","fp"]]),null!==ZC._n_(t=a.o.entry))for(t instanceof Array||(t=[t]),e=0,i=t.length;e<i;e++){var l=new ZC.DT(a);l.o=t[e],l.parse(),a.OU.push(l)}if(null!==ZC._n_(n=a.o.exit))for(n instanceof Array||(n=[n]),e=0,i=n.length;e<i;e++){var o=new ZC.DT(a);o.o=n[e],o.parse(),a.VL.push(o)}a.B1=a.C.BM(a.BU("k")[0]),a.CM=a.C.BM(a.BU("v")[0])},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.P6()}}),ZC.V8=ZC.W7.CA({$i:function(e){this.b(e),this.AF="vfunnel"},TV:function(){return new ZC.A5V(this)}}),ZC.V7=ZC.W7.CA({$i:function(e){this.b(e),this.AF="hfunnel"},TV:function(){return new ZC.A5X(this)}}),ZC.VC=ZC.A21.CA({$i:function(e){this.b(e);var i=this;i.AF="stock",i.CW="candlestick",i.MV={size:0},i.P1="bg"},TV:function(){return new ZC.A6Z(this)},parse:function(){this.b()},paint:function(){this.b(),this.paintPreview()},paintPreview:function(){var e=this,i=e.C.BM(e.BU("v")[0]),t=i.AT(i.H8);if(e.C.B9&&e.C.B9.I2&&e.QN){for(var n=e.C.P,a=e.C.B9,l=[],o=[],r=!0,s=0,A=e.S.length;s<A;s++)if(null!==ZC._n_(e.S[s])&&null!==ZC._n_(e.S[s].DP[2])){var C=i.AT(e.S[s].DP[2]);r&&(o.push([e.S[s].iX,t]),r=!1),l.push([e.S[s].iX,C]),o.push([e.S[s].iX,C])}o.length&&o.push([o[o.length-1][0],t]);var c=e.mapPointsToPreview(o),u=e.o.preview||{};if("area"===(u.type||"area")){var p=new ZC.DT(e.A);p.copy(e),p.append({"background-color":e.BW,"alpha-area":.2}),p.append(u),p.parse(),p.CZ=!0,p.L4=!0,p.AZ=0,p.AU=0,p.EX=0,p.GA=0,p.C6=ZC._f_(p.o["alpha-area"]),p.D1=[n.iX,n.iY,n.iX+n.I,n.iY+n.F],p.K=e.K+"-area-preview",p.Z=a.Z,p.D=c,p.paint()}var Z=e.mapPointsToPreview(l),h=ZC.Q.EB(a.Z,e.H.AB),d=new ZC.D0(e);d.copy(e),d.append({"line-color":e.BW,"line-width":1}),d.append(u),d.parse(),ZC.CR.paint(h,d,Z,null,3)}}}),ZC.XE=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.AF="gauge",i.SW=3,i.BO=["scale-r","scale-v","scale"],i.HX=.5,i.HW=[10,0,0,0,0],i.P1="bg"},TV:function(){return new ZC.A75(this)},parse:function(){var e,i=this;i.BP=i.NQ(),i.C2=i.BP[0],i.B7=i.BP[1],i.A0=i.BP[3],i.AE=i.BP[3],i.NO(),i.b(),i.assign_a([["alpha-area","HX","f",0,1],["indicator","HW"]]),null!==ZC._n_(e=i.o.csize)&&(i.HW[0]=ZC._i_(e)),i.HW=[ZC._f_(i.HW[0]||"10"),ZC._f_(i.HW[1]||"0"),ZC._f_(i.HW[2]||"0"),ZC._f_(i.HW[3]||"0"),ZC._f_(i.HW[4]||"0")]},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.P6(!0)}}),ZC.ST=ZC.VY.CA({$i:function(e){this.b(e);var i=this;i.AF="range",i.Y=1,i.CW="segmented",i.SW=3,i.HX=.5},TV:function(){return new ZC.A7E(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.B7=e.BP[1],e.A0=e.BP[0],e.AE=e.BP[1],e.NO(),e.b(),e.applyRGBA(),e.ZQ("alpha-area","HX","f",0,1),e.B1=e.C.BM(e.BU("k")[0]),e.CM=e.C.BM(e.BU("v")[0])},P6:function(){var e,i,t=this,n=t.O6;t.XP(!1);var a=t.C.P;t.Y=1;var l=n?a.F:a.I;t.B1.EF||!t.Q6&&5*(t.B1.A1-t.B1.W)>l&&(t.Y=ZC._i_(5*(t.B1.A1-t.B1.W)/l));var o=t.B1.EF;if(o&&t.Q0[0]===ZC.MAX&&t.Q0[1]===-ZC.MAX&&(o=!1),o)for(e=0,i=t.S.length;e<i;e++)t.S[e]&&ZC.DS(t.S[e].BT,t.B1.V[t.B1.W],t.B1.V[t.B1.A1])&&(t.S[e].Z=t.KG,t.S[e].MM="min",t.S[e].paint(),t.S[e].MM="max",t.S[e].paint(),delete t.S[e].E["intersect.index"]);else for(e=t.B1.W;e<=t.B1.A1;e+=t.Y)t.S[e]&&(t.S[e].MM="min",t.S[e].paint(),t.S[e].MM="max",t.S[e].paint(),delete t.S[e].E["intersect.index"])},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.A56=ZC.Q.EB(e.CP("bl",1),e.H.AB),e.QC=ZC.Q.EB(e.CP("bl",2),e.H.AB),e.P6(),e.D=null,e.D6=null,e.ZR=null,e.S6=null}}),ZC.XA=ZC.VV.CA({$i:function(e){this.b(e);this.AF="pie3d",this.NL=-1},parse:function(){this.b(),this.assign_a([["thickness","NL","ia"]])},TV:function(){return new ZC.A7B(this)}}),ZC.UF=ZC.QZ.CA({$i:function(e){this.b(e),this.AF="vbar3d"},TV:function(){return new ZC.A6V(this)},parse:function(){var e=this;e.b(),null===ZC._n_(e.o["border-color"])&&(e.BW=e.BP[0]),null===ZC._n_(e.o["line-color"])&&(e.B7=e.BP[0])},paint:function(){this.b(),this.sharedZScale()}}),ZC.VZ=ZC.QS.CA({$i:function(e){this.b(e),this.AF="hbar3d"},TV:function(){return new ZC.A6Y(this)},parse:function(){var e=this;e.b(),null===ZC._n_(e.o["border-color"])&&(e.BW=e.BP[0]),null===ZC._n_(e.o["line-color"])&&(e.B7=e.BP[0])}}),ZC.UG=ZC.QW.CA({$i:function(e){this.b(e),this.AF="line3d"},TV:function(){return new ZC.A6E(this)},parse:function(){var e=this;e.b(),null===ZC._n_(e.o["border-color"])&&(e.BW=e.BP[1])},paint:function(){this.b(),this.sharedZScale()}}),ZC.UI=ZC.QX.CA({$i:function(e){this.b(e),this.AF="area3d"},TV:function(){return new ZC.A6H(this)},parse:function(){var e=this;e.b(),null===ZC._n_(e.o["border-color"])&&(e.BW=e.BP[1])},paint:function(){this.b(),this.sharedZScale()}}),ZC.YU=ZC.HV.CA({$i:function(e){this.b(e);var i=this;i.AF="venn",i.AC0=[],i.AA5=[],i.BO=["scale"],i.P1="bg"},TV:function(){return new ZC.A85(this)},parse:function(){var e=this;e.BP=e.NQ(),e.C2=e.BP[0],e.BW=e.BP[1],e.A0=e.BP[3],e.AE=e.BP[3],e.NO(),e.b(),e.assign_a([["join","AC0"],["share","AA5"]])},paint:function(){var e=this;e.b(),e.KG=e.CP("bl",0),e.P6(!0)}});var LE={$i:function(e){this.b(e);var i=this;i.C=e.A.A,i.H=i.C.A,i.L=-1,i.AD=null,i.DP=[],i.CS=null,i.BT=null,i.CK=null,i.JP=[],i.I2=!1,i.PU=!0,i.O=i,i.JE=!1,i.A26=!1},H3:function(e,i){this.b(this.A,e,i,this.LY(null,!1),this.A.MJ)},UU:function(){return[this.iX,this.iY,{reference:this,center:!0}]},ACE:function(){return[this.iX,this.iY]},getTooltipPosition:function(e,i,t){var n,a,l,o,r=this;switch(r.paint(!0),n=r.iX,a=r.iY,l=r.I,o=r.F,i){case"center":n=r.iX+l/2,a=r.iY+o/2;break;case"top":n=r.iX+l/2,a=r.iY,a=t?a-t:a;break;case"bottom":n=r.iX+l/2,a=r.iY+o,a=t?a+t:a;break;case"left":n=r.iX,a=r.iY+o/2,n=t?n-t:n;break;case"right":n=r.iX+l,a=r.iY+o/2,n=t?n+t:n;break;default:n+=r.BL,a+=r.BH}return{x:n,y:a}},setNodeData:function(e){var i=this;for(var t in e)e.hasOwnProperty(t)&&(i.A.I3?i.A.S[i.L][t]=e[t]:i.E[t]=e[t])},getNodeData:function(e){return this.A.I3?this.A.S[this.L][e]:this.E[e]},AB2:function(){var e,i,t=this,n=t.C.E,a=t.A.L;null===ZC._n_(n.update)&&(n.update={});var l=n.update,o=""+t.AD,r=t.A.MR();for(ZC.P8(o)&&ZC._f_(o)<0&&"currency"===r.negation&&(o=ZC._a_(ZC._f_(o))),r.utc=t.C.UN,r.timezone=t.C.ND,o=ZC.AP.G2(o,r,t.A),l["plot-"+a+"-value"]=o,l["plot-"+a+"-value-0"]=o,e=0,i=t.DP.length;e<i;e++)l["plot-"+a+"-value-"+(e+1)]=t.DP[e];for(l["plot-value"]=l["plot-value-0"]=o,e=0,i=t.DP.length;e<i;e++)l["plot-value-"+(e+1)]=t.DP[e];for(var s in t.A.KH){var A=null;A="object"==typeof t.A.KH[s]&&t.A.KH[s].length?t.A.KH[s][t.L]:t.A.KH[s],l["plot-"+a+"-data-"+s]=A}},T7:function(){var e,i,t=this,n=t.A.B1,a=t.A.CM,l=[n.W,n.A1,a.W,a.A1];if(t.A.I3&&(t.CS=t.A.S[t.L].CS),t.JP!==l){n.CO?(null!==t.BT?t.iY=n.AT(t.BT):t.iY=n.IB(t.L),t.A.CC&&"100%"===t.A.KR?t.A.A.F8[t.L]["%total-"+t.A.DZ]>0?t.iX=a.AT(100*t.CS/t.A.A.F8[t.L]["%total-"+t.A.DZ]):t.iX=a.AT(100*t.CS):t.iX=a.AT(t.CS+0)):(null!==t.BT?t.iX=n.AT(t.BT):t.A.LN?"bar"===t.A.sMetaType?t.iX=n.IB(t.A.R8):t.iX=n.IB(t.A.R8)+t.A.RM+t.L*(n.AA-2*t.A.RM)/(t.A.S.length-1)-n.AA/2:"log"===n.C1?t.iX=n.AT(t.L):t.iX=n.IB(t.L),t.A.CC&&"100%"===t.A.KR?t.A.A.F8[t.L]["%total-"+t.A.DZ]>0?t.iY=a.AT(100*t.CS/t.A.A.F8[t.L]["%total-"+t.A.DZ]):t.iY=a.AT(100*t.CS):t.iY=a.AT(t.CS+0)),t.A.I3&&(t.A.S[t.L].iX=t.iX,t.A.S[t.L].iY=t.iY),t.JP=l}t.I2||(0!==t.A.E7.length||-1===ZC.AV(["line","area","vbar","hbar","line3d","area3d","vbar3d","hbar3d"],t.A.AF)||t.A.o.override?ZC.A4.browser.mozilla?(t.copy(t.A),t.E7=t.A.E7,t.DE(),t.parse(!1),t.O=t):t.A.o.override?(t.copy(t.A),t.E7=t.A.E7,t.DE(),t.parse(!1),t.O=t):(e=t.ACJ(t.A.E7),null===ZC._n_(i=t.A.A66[e])?(t.copy(t.A),t.E7=t.A.E7,t.DE(),t.parse(!1),t.O=t,t.A.A66[e]=t):t.O=i):t.O=t.A,t.A.o.override&&(t.O.E.plotidx=t.A.L,t.O.E.nodeidx=t.L,t.O.parse(!1)),t.I2=!0)},a11y:function(){var e=this,i="";if(e.H.bA11y){if(e.A.I3){var t=this.A.FK(e.L,1,!0);t&&(i=t.JT(this.C.A7.o.text||this.A.A7.o.text||this.A.J7))}else i=e.JT(this.C.A7.o.text||this.A.A7.o.text||this.A.J7);return e.A.AM&&-1===i.indexOf(e.A.AM)&&(i=e.A.AM+":"+i),i=i.replace(/<.+?>/gi," "),'tabindex="0" aria-label="Series '+(this.A.L+1)+" of "+this.A.A.A5.length+", point "+(this.L+1)+" of "+this.A.S.length+". "+i+'"'}return""},A9T:function(){var e,i=this;if(i.o.value instanceof Array&&(i.CK=i.o.value.join(" "),"string"==typeof i.o.value[0]?-1!==(e=ZC.AV(i.A.B1.IT,i.o.value[0]))?i.BT=e:(i.A.B1.IT.push(i.o.value[0]),i.BT=i.A.B1.IT.length-1):i.BT=parseFloat(i.o.value[0]),"string"==typeof i.o.value[1]?-1!==(e=ZC.AV(i.A.CM.JM,i.o.value[1]))?i.AD=e:(i.A.CM.JM.push(i.o.value[1]),i.AD=i.A.CM.JM.length-1):i.AD=parseFloat(i.o.value[1]),null!==i.BT&&i.A.UW(i.BT,i.L),i.A.YL>0&&i.o.value.length>i.A.YL))for(var t=i.o.value.length-i.A.YL;t<i.o.value.length;t++)i.DP.push(i.o.value[t])},parse:function(e){var i=this;if(i.E.plotidx=i.A.L,i.E.nodeidx=i.L,i.K=i.A.K+"-node-"+i.L,null===ZC._n_(e)&&(e=!0),e){if(i.o.value instanceof Array||i.A.AA6)i.A9T();else if(i.CK=i.o.value,"string"==typeof i.o.value){var t=ZC.AV(i.A.CM.JM,i.o.value);-1!==t?i.AD=t:(i.A.CM.JM.push(i.o.value),i.AD=i.A.CM.JM.length-1)}else i.AD=i.o.value;null===i.CS&&(i.CS=i.AD)}else i.b()},J2:function(e){return this.JT(e,{})},getFormatValue:function(){return this.AD},JT:function(AM,ER,LM,bUrl){var s=this,G,CK,BC,i,A6,D5,oRE;void 0===LM&&(LM=!1);var oPPI=s.A.JL,oPS=s.A.A,EY,PF;if(!bUrl&&"javascript:"===AM.substring(0,11))try{var EC=AM.replace("javascript:","").replace("()","");eval(EC)&&(G=0===s.DP.length?s.AD:[s.AD].concat(s.DP),AM=eval(EC).call(s,G,{nodeindex:s.L,plotindex:s.A.L,plotid:s.A.H5,nodeinfo:s.LY(null,!1),plotinfo:s.A.UZ()})||AM)}catch(e){}if(AM+="",s.A.A73){for(EY in CK=s.getFormatValue(),null!==ZC._n_(s.A.CM.JM[CK])&&s.A26&&(CK=s.A.CM.JM[CK]),AM=AM.replace(/%node-numeric-value/g,s.AD).replace(/%node-value/g,CK).replace(/%previous-node-value/g,s.A.S[s.L-1]?s.A.S[s.L-1].AD:null).replace(/%next-node-value/g,s.A.S[s.L+1]?s.A.S[s.L+1].AD:null).replace(/%node-index/g,s.L).replace(/%plot-text/g,s.A.AM).replace(/%plot-index/g,s.A.L).replace(/%plot-count/g,oPS.A5.length).replace(/%p/g,s.A.L).replace(/%P/g,oPS.A5.length).replace(/%v/g,CK).replace(/%V/g,s.AD).replace(/%i/g,s.L).replace(/%n/g,s.L),s.A.KH)PF="",PF=s.A.KH[EY]instanceof Array?null!==s.A.KH[EY][s.L]?s.A.KH[EY][s.L]:"":null!==s.A.KH[EY]?s.A.KH[EY]:"",oRE=new RegExp("%data-"+EY,"g"),AM=AM.replace(oRE,PF);return AM}var PK="",RR="",RH="",WE="",R=s.C.BM(s.A.BU("k")[0]),X=s.C.BM(s.A.BU("v")[0]);R&&(null!==s.BT?PK=RR=RH=s.BT:(null!==ZC._n_(R.V[s.L])&&(PK=RR=RH=R.V[s.L]),null!==ZC._n_(R.BX[s.L])&&(RH=RR=R.BX[s.L]))),null!==ZC._n_(G=s.A.B1.IT[PK])&&"number"==typeof PK&&(PK=G),null!==ZC._n_(G=s.A.B1.IT[RR])&&"number"==typeof RR&&(RR=G),null!==ZC._n_(G=s.A.B1.IT[RH])&&"number"==typeof RH&&(RH=G),WE=null!==ZC._n_(s.A.AM)?s.A.AM:"Series "+(s.A.L+1),s.A.LN&&s.A.A.A5[s.L]&&(WE=s.A.A.A5[s.L].AM||"Series "+s.L);var TU=(WE+"").split(/\s+/),A6B=PK;R&&(BC=R.MR(),ER&&ER["transform-date"]&&ZC._cp_({"transform-date":!0,"transform-date-format":ER["transform-date-format"]},BC),BC.utc=s.C.UN,BC.timezone=s.C.ND,RH=RR=ZC.AP.G2(PK,BC,R,!0),null===s.BT&&(null===ZC._n_(R.BX[s.BT])&&null===ZC._n_(R.BX[s.L])||(RR=RH=R.BX[s.BT]||R.BX[s.L])),BC["transform-date"]&&(RH=ZC.AP.G2(RH,BC,R,!0)));var A4D=(RR+"").split(/\s+/),A6Q=(RH+"").split(/\s+/),W2=(PK+"").split(/\s+/);CK=s.getFormatValue(),s.A.CM&&null!==ZC._n_(s.A.CM.JM[CK])&&s.A26&&(CK=s.A.CM.JM[CK]);var OO=ZC.P8(CK)&&ZC._f_(CK)<0;if(BC=s.A.MR(),ZC._cp_(ER,BC),OO&&"currency"===BC.negation&&(CK=ZC._a_(ZC._f_(CK))),BC.utc=s.C.UN,BC.timezone=s.C.ND,CK=ZC.AP.G2(CK,BC,s.A,!(!X||!X.F5)&&X.F5),"%v"===AM&&"%vv"!==AM||"%node-value"===AM)return CK;if("%t"===AM||"%plot-text"===AM)return WE;var CV=s.CV||[],oNode_,YP,A69,oPlot_,p,pLen;if(X&&X.NE){var YW=X.MR();null===ZC._n_(YW.decimals)&&(YW.decimals=0);var AB1=X.CO?X.NE(this.iX,!0,"piano"===s.A.AF):X.NE(this.iY,!0,"piano"===s.A.AF),WL=X.FQ(0,AB1,YW);CV.push(["%scale-value-value",WL],["%vv",WL]),null!==ZC._n_(G=X.BX[s.L])?CV.push(["%scale-value-label",G],["%vl",G]):CV.push(["%scale-value-label",WL],["%vl",WL])}if(X&&(-1!==AM.indexOf("%scale-value-text")||-1!==AM.indexOf("%vt")))for(-1!==(G=ZC.AV(X.V,s.AD))&&null!==ZC._n_(X.BX)&&null!==ZC._n_(X.BX[G])?CV.push(["%scale-value-text",X.BX[G]],["%vt",X.BX[G]]):CV.push(["%scale-value-text",s.AD],["%vt",s.AD]),oRE=-1!==AM.indexOf("%vt(")?new RegExp("(%vt)\\(([0-9]*)\\)"):new RegExp("(%scale-value-text)\\(([0-9]*)\\)");D5=oRE.exec(AM);)YP="",""!==(G=D5[2])&&(A69=ZC._i_(G),null!==ZC._n_(oPlot_=s.A.A.A5[A69])&&(oNode_=oPlot_.FK(s.L),null!==oNode_&&(YP=oNode_.JT(D5[1])))),AM=AM.replace(D5[0],YP),""!==YP&&CV.push([D5[0],YP]);for(EY in null!==ZC._n_(s.A.LX)&&null!==ZC._n_(s.A.LX[s.L])&&CV.push(["%offset-values",s.A.LX[s.L]]),s.A.A.A1C&&CV.push(["%stack-top",-1!==ZC.AV(s.A.A.A1C,s.A.L)?1:0]),s.A.KH)PF="",PF=s.A.KH[EY]instanceof Array?null!==s.A.KH[EY][s.L]?s.A.KH[EY][s.L]:"":null!==s.A.KH[EY]?s.A.KH[EY]:"","number"==typeof PF&&(PF=ZC.AP.G2(PF,BC,s.A,!(!X||!X.F5)&&X.F5)),CV.push(["%data-"+EY,PF]);for(i=0;i<A4D.length;i++)CV.push(["%scale-key-label-"+i,A4D[i]],["%kl"+i,A4D[i]]);for(i=0;i<A6Q.length;i++)CV.push(["%scale-key-text-"+i,A6Q[i]],["%kt"+i,A6Q[i]]);for(i=0;i<W2.length;i++)CV.push(["%scale-key-value-"+i,W2[i]],["%kv"+i,W2[i]],["%k"+i,W2[i]]);for(p=0,pLen=oPS.A5.length;p<pLen;p++)null!==ZC._n_(oPS.A5[p].S[s.L])&&CV.push(["%plot-"+p+"-value",oPS.A5[p].S[s.L].AD]);CV.push(["%scale-key-label",RR],["%scale-key-text",RH],["%scale-key-value",PK],["%scale-key-value-ts",A6B],["%kvts",A6B],["%kt",RH],["%kl",RR],["%kv",PK],["%k",PK],["%node-value",CK],["%v",CK],["%node-numeric-value",s.AD],["%previous-node-value",s.A.S[s.L-1]?s.A.S[s.L-1].AD:null],["%next-node-value",s.A.S[s.L+1]?s.A.S[s.L+1].AD:null],["%V",s.AD],["%node-index",s.L],["%node-x",s.iX],["%node-y",s.iY],["%chart-width",s.H.I],["%chart-height",s.H.F],["%i",s.L],["%n",s.L],["%node-count",s.A.S.length],["%N",s.A.S.length]);var ABN=oPPI["%plot-sum"],A3R=ABN+"",ABQ=oPPI["%plot-average"],A3Q=ABQ+"",A8H=ZC._f_(oPS.F8["%pstack-"+s.L+"-"+s.A.DZ+"-sum"]||"0"),A4N=A8H+"",ABC=ZC._f_(A8H/oPS.F8["%pstack-"+s.L+"-"+s.A.DZ+"-stack-length"]),A5D=String(ABC),A9I=String(oPS.F8["%pstack-"+s.L+"-"+s.A.DZ+"-stack-length"]),A78=0;null!==ZC._n_(oPS.F8)&&null!==ZC._n_(oPS.F8[s.L])&&(A78=ZC._f_(oPS.F8[s.L]["%total-"+s.A.DZ]||"0"));var A39=A78+"";A3R=ZC.AP.G2(A3R,BC),A3Q=ZC.AP.G2(A3Q,BC),A39=ZC.AP.G2(A39,BC),A4N=ZC.AP.G2(A4N,BC),A5D=ZC.AP.G2(A5D,BC),CV.push(["%node-error-plus",s.E["node-error-plus"]],["%node-error-minus",s.E["node-error-minus"]],["%stack-total",A4N],["%stack-average",A5D],["%stack-length",A9I],["%total",A39],["%plot-min-index",oPPI["%plot-min-index"]],["%pmi",oPPI["%plot-min-index"]],["%plot-max-index",oPPI["%plot-max-index"]],["%pxi",oPPI["%plot-max-index"]],["%plot-min-value",oPPI["%plot-min-value"]],["%pmv",oPPI["%plot-min-value"]],["%plot-max-value",oPPI["%plot-max-value"]],["%pxv",oPPI["%plot-max-value"]],["%plot-sum",A3R],["%psum",A3R],["%plot-average",A3Q],["%pavg",A3Q],["%plot-values",oPPI["%plot-values"]],["%pv",oPPI["%plot-values"]]);var AA0=100*s.AD/oPPI["%plot-sum"],YX=AA0+"";null!==ZC._n_(BC.decimals)&&(YX=ZC.AP.G2(YX,BC)),CV.push(["%plot-percent",YX],["%pper",YX]);var bNpv=!1,VM,AX,J,C0;for(i=0,A6=CV.length;i<A6;i++)if("%npv"===CV[i][0]){bNpv=!0;break}if(!bNpv&&null!==ZC._n_(s.A.A.F8)&&null!==ZC._n_(s.A.A.F8[s.L])){var JQ=100*s.AD/s.A.A.F8[s.L]["%total-"+s.A.DZ],HO=JQ+"";null!==ZC._n_(BC.decimals)&&(HO=ZC.AP.G2(HO,BC)),CV.push(["%node-percent-value",HO],["%npv",HO])}for(i=0;i<TU.length;i++)CV.push(["%plot-text-"+i,TU[i]],["%t"+i,TU[i]]);for(CV.push(["%plot-text",WE],["%t",WE],["%plot-description",s.A.OZ],["%plot-index",s.A.L],["%p",s.A.L],["%plot-count",oPS.A5.length],["%P",oPS.A5.length],["%id",s.H.K],["%graphid",s.C.K.replace(s.H.K+"-graph-","")]),-1!==AM.indexOf("%negation")&&(OO&&"currency"===BC.negation?(CV.push(["%negation","-"]),OO=!1):CV.push(["%negation",""])),CV.push(["%node-x",s.iX],["%node-y",s.iY],["%node-width",s.I],["%node-height",s.F],["%node-size",s.E["marker.size"]||1]),zingchart.DEV.SORTTOKENS&&CV.sort(ZC.A1H),oRE=new RegExp("\\(([^(]+?)\\)\\(([0-9]*)\\)(\\(*)([0-9]*)(\\)*)");D5=oRE.exec(AM);){VM="";var CQ=s.A.L,D9=s.L;""!==(G=D5[2])&&(CQ=ZC._i_(G)),""!==(G=D5[4])&&(D9=ZC._i_(G)),null!==(J=oPS.A5[CQ])&&(AX=J.FK(D9,3),null!==AX&&(VM=AX.JT(D5[1],ER))),AM=AM.replace(D5[0],VM)}if(-1!==AM.indexOf("%prop-")){oRE=new RegExp("%prop-([a-zA-Z0-9-]+)");for(var oMap=s.getPMap();D5=oRE.exec(AM);)null!==ZC._n_(oMap[D5[1]])&&null!==ZC._n_(s[oMap[D5[1]]])&&(AM=AM.replace(D5[0],s[oMap[D5[1]]]))}if(-1!==AM.indexOf("%linecolor"))for(oRE=new RegExp("%linecolor([0-9]*)");D5=oRE.exec(AM);)""===D5[1]?(C0=s.O||s,C0.B7||(C0=s.A)):C0=oPS.A5[D5[1]],AM=AM.replace(D5[0],C0&&C0.B7||"#000");if(-1!==AM.indexOf("%backgroundcolor"))for(oRE=new RegExp("%backgroundcolor([0-9]*)");D5=oRE.exec(AM);)""===D5[1]?(C0=s.O||s,C0.B7||(C0=s.A)):C0=oPS.A5[D5[1]],AM="markerbg"===s.A.P1?AM.replace(D5[0],C0&&C0.A2&&C0.A2.A0||"#000"):AM.replace(D5[0],C0&&C0.A0||"#000");if(-1!==AM.indexOf("%color"))for(oRE=new RegExp("%color([0-9]*)");D5=oRE.exec(AM);)""===D5[1]?(C0=s.O||s,C0.B7&&"line"!==s.A.P1||(C0=s.A)):C0=oPS.A5[D5[1]],AM="line"===s.A.P1?AM.replace(D5[0],C0&&C0.B7||"#000"):"markerbg"===s.A.P1?AM.replace(D5[0],C0&&C0.A2&&C0.A2.A0||"#000"):AM.replace(D5[0],C0&&C0.A0||"#000");for(AM=ZC.AP.YN(AM,this),i=0,A6=CV.length;i<A6;i++)oRE=new RegExp(CV[i][0],"g"),AM="undefined"==typeof CV[i][1]?AM.replace(oRE,""):LM?AM.replace(oRE,encodeURIComponent(CV[i][1])):AM.replace(oRE,CV[i][1]);return AM=AM.replace(new RegExp("%data-([a-zA-Z0-9]+)","g"),""),OO&&"currency"===BC.negation&&(AM="-"+AM),AM},paint:function(){},paint_:function(){},ABF:function(){return{color:this.O.A0}},Y2:function(){return{"border-color":this.O.A0,"background-color":this.O.AE,color:this.O.C2}},A8F:function(){return this.Y2()},GW:function(e,i){var t,n,a,l=this;if(i||(i=1),l.A.NZ&&l.A.NZ.length>0&&l.A.NZ.length>i-1&&l.GW(e,i+1),l.AN||"pie"===l.A.AF||"pie3d"===l.A.AF){var o,r=1===i?l.A.U:l.A.NZ[i-2];if(r){if(l.A.A7C)(o=l.A.A7C).K=l.K+"-value-box-"+i,o.Z=o.C7=l.H.usc()?l.H.mc("top"):l.C.AJ["3d"]||l.H.K9?ZC.AL(l.C.K+"-plots-vb-c"):ZC.AL(l.C.K+"-plot-"+l.A.L+"-vb-c"),o.IL=l.H.usc()?ZC.AL(l.C.A.K+"-top"):ZC.AL(l.C.A.K+"-text"),o.E.plotidx=l.A.L,o.E.nodeidx=l.L,a=ZC.AP.O2(o.o,l.A.o),o.JT=function(e){return l.JT(e,a)},o.parse();else{o=new ZC.DN(l.A),r.o.rules||l.A.U.HT||(n="all",null!==ZC._n_(t=r.o.type)&&(n=t),"pie"===l.C.AF||"nestedpie"===l.C.AF||"pie3d"===l.C.AF||"all"!==n||l.A.NZ&&0!==l.A.NZ.length||(l.A.A7C=o)),o.append(r.o),l.appendToValueBox&&!e&&(o.parse(),o.append(l.appendToValueBox(o))),o.GL=l.C.K+"-value-box "+l.C.K+"-plot-"+l.A.L+"-value-box zc-value-box",o.K=l.K+"-value-box-"+i,o.Z=o.C7=l.H.usc()?l.H.mc("top"):l.C.AJ["3d"]||l.H.K9?ZC.AL(l.C.K+"-plots-vb-c"):ZC.AL(l.C.K+"-plot-"+l.A.L+"-vb-c"),o.IL=l.H.usc()?ZC.AL(l.C.A.K+"-top"):ZC.AL(l.C.A.K+"-text"),a=ZC.AP.O2(o.o,l.A.o),o.JT=function(e){return l.JT(e,a)};var s=l.ABF(o);if(null!==ZC._n_(t=s.color)&&(o.C2=t),null!==ZC._n_(t=s["background-color"])&&(o.A0=o.AE=t),o.E.plotidx=l.A.L,o.E.nodeidx=l.L,l.A.U.HT&&(l.A.U.H3(l.A.U,o,null,l.LY(null,!1)),o.parse()),o.parse(),o.J2=function(e){return l.J2(e)},o.DE()&&(a=o.overrideFormat(a),o.parse()),!l.A.YJ){var A=new ZC.DN(l.A);A.copy(o),l.A.YJ=A}if(n="all",null!==ZC._n_(t=r.o.type)&&(n=t),o.AN){o.AN=!1;var C=l.A.o["value-box"].text||"";if("values("===n.substring(0,7)){var c=n.substring(7,n.length).replace(")","").split(",");-1!==ZC.AV(c,l.AD)&&(o.AN=!0)}else{var u=n.split(","),p={min:"%plot-min-value",max:"%plot-max-value",first:"%plot-min-index",last:"%plot-max-index"};for(var Z in p)-1!==ZC.AV(u,Z)&&(("first"!==Z&&"last"!==Z||l.L!==l.A.JL[p[Z]])&&("min"!==Z&&"max"!==Z||l.AD!==l.A.JL[p[Z]])||("object"==typeof C&&null!==ZC._n_(C[Z])&&(o.o.text=C[Z],o.parse()),o.AN=!0));-1!==ZC.AV(u,"all")&&(o.AN=!0)}}}if(l.C.E["plot"+l.A.L+".visible"]||(o.E["css-display"]="none"),e)return o;if(o.AN&&null!==ZC._n_(o.AM)&&""!==o.AM){var h=l.AC8(o);o.E.positioninfo=h,o.iX=h[0],o.iY=h[1];var d={};if(-1!==o.iX&&-1!==o.iY){var f=!1;if(null!==ZC._n_(o.o.overlap)&&!ZC._b_(o.o.overlap)){d={x:o.iX,y:o.iY,width:o.I,height:o.F};for(var _=0,g=l.A.A.YZ.length;_<g;_++)if(ZC.AR.XQ(d,l.A.A.YZ[_])){f=!0;break}}f||(l.C.E["plot"+l.A.L+".visible"]||(o.E["css-display"]="none"),o.E.lbltype="vb"+l.C.L,o.paint(),o.EK(),l.A.A.YZ.push(d),!o.K9&&ZC.AL(l.H.K+"-map")&&l.A.A.HF.push(ZC.AP.O4(l.C.K,o)))}}return o}}},setupValueBoxWH:function(e){if(null!==ZC._n_(e.o.width)){var i=ZC.II(e.o.width);i<=1&&(i=this.I*i),e.I=i}if(null!==ZC._n_(e.o.height)){var t=ZC.II(e.o.height);t<=1&&(t=this.I*t),e.F=t}return e},AC8:function(e){var i,t=this,n=t.C.BM(t.A.BU("v")[0]),a=t.AD>=n.LA&&!n.AW||t.AD<n.LA&&n.AW?-1:1,l="auto";if(null!==ZC._n_(i=e.o.placement)&&(l=i),"auto"===l){var o=null!==ZC._n_(t.A.S[t.L-1])?t.A.S[t.L-1].AD:t.AD,r=null!==ZC._n_(t.A.S[t.L+1])?t.A.S[t.L+1].AD:t.AD;o>=t.AD&&t.AD<=r?l="bottom":o<=t.AD&&t.AD>=r?l="top":o>=t.AD&&t.AD>=r?l=o/t.AD>t.AD/r?"bottom":"top":o<=t.AD&&t.AD<=r&&(l=t.AD/o>r/t.AD?"top":"bottom")}var s=e.I,A=e.F,C=t.iX-s/2,c=t.iY-A/2;switch(l){case"top":c-=a*(A/2+4);break;case"bottom":c+=a*(A/2+4);break;case"left":C-=s/2+4;break;case"right":C+=s/2+4}return t.C.AJ["3d"]||(C=ZC.BQ(t.C.P.iX-s/2,C),C=ZC.CY(t.C.P.iX+t.C.P.I-s/2,C),c=ZC.BQ(t.C.P.iY-A,c),c=ZC.CY(t.C.P.iY+t.C.P.F,c)),null!==ZC._n_(e.o.x)&&(C=e.iX),null!==ZC._n_(e.o.y)&&(c=e.iY),[ZC._i_(C),ZC._i_(c)]},PA:function(e,i){var t,n,a,l,o,r=this;if("undefined"==typeof r.A.bBS&&(r.A.bBS=-1===ZC.AV(["bubble","hbubble","scatter","hscatter"],r.A.AF)),null!==ZC._n_(r.A.o["markers-on-top"])&&(r.A.bBS=ZC._b_(r.A.o["markers-on-top"])),!r.C.OF||!r.A.bBS){null===ZC._n_(e)&&(e=!1),null===ZC._n_(i)&&(i=!1);var s=r.C.P.E.tolerance||2;if(ZC.DS(r.iX,r.C.P.iX-s,r.C.P.iX+r.C.P.I+s)&&ZC.DS(r.iY,r.C.P.iY-s,r.C.P.iY+r.C.P.F+s)){var A=r.C.K+"-node-area "+r.C.K+"-plotset-plot-"+r.A.L+"-node-area zc-node-area";if(-1===ZC.AV(r.H.KQ,"skip_segment_tracking")&&r.A.G0){if(r.A.Y3&&!zingchart.DEV.SKIPTRACKERS){var C=r.getNodeData("points");-1!==ZC.AV(r.H.KQ,"use_fast_mode")&&-1!==ZC.AV(["line","area"],r.A.AF)&&void 0===C&&r.paint(!0),""!==(a="undefined"==typeof r.E.polypoints?ZC.AR.PR(ZC.AR.Z0(C,ZC.BQ(6,r.A.AZ/2)),4):ZC.AR.PR(C,4))&&r.A.A.HF.push(ZC.Q.FW("poly",r.A.EA,r.O.IP)+'class="'+A+'" id="'+r.K+'" coords="'+a+'" />')}if(("area"===r.A.AF||"area3d"===r.A.AF||"radar"===r.A.AF&&("area"===r.A.CW||"range"===r.A.CW))&&r.A.XH){var c=r.getNodeData("pointsarea");""!==(a=ZC.AR.PR(c,4))&&r.A.A.HF.push(ZC.Q.FW("poly",r.A.EA,r.A.IP)+'class="'+A+'" id="'+r.K+'--area" coords="'+a+'" />')}}if(r.A.U||!r.A.I3||!r.A.A2.o||"none"!==r.A.A2.o.type&&(null===ZC._n_(r.A.A2.o.visible)||ZC._b_(r.A.A2.o.visible))){if(i||r.A.R5){if(r.A.HC)l=r.A.HC,"svg"!==r.H.AB&&(e?(o=new ZC.CE(r.C,r.iX-ZC.AO.E2,r.iY-ZC.AO.E3,r.A.E["z-start"]||0),l.iX=ZC._x_(o.ED[0]),l.iY=ZC._x_(o.ED[1]),r.E["3dxy"]=[l.iX,l.iY]):(l.iX=ZC._x_(r.iX),l.iY=ZC._x_(r.iY)),l.E.plotidx=r.A.L,l.E.nodeidx=r.L,l.K=r.K+"-marker",l.parse(!0));else{if(r.I3?r.A._oMarker?l=r.A._oMarker:r.A._oMarker=l=new ZC.DT(r.A):l=new ZC.DT(r.A),l.K=r.K+"-marker",l.E["p-width"]=r.A.B1.AA,l.E["p-height"]=r.A.CM.AA,r.A.bBS)l.Z=r.A.CP("fl",0),l.C7=r.A.CP("fl",0);else if(l.Z=r.A.CP("bl",1),l.C7=r.A.CP("bl",0),Object&&Object.keys&&Object.keys(r.C.CB).length>0){var u=r.C.CB["p"+r.A.L];"none"!==r.A.J0&&u&&u["n"+r.L]&&(l.Z=r.A.CP("bl",2))}if(e?(o=new ZC.CE(r.C,r.iX-ZC.AO.E2,r.iY-ZC.AO.E3,r.A.E["z-start"]||0),l.iX=ZC._x_(o.ED[0]),l.iY=ZC._x_(o.ED[1]),r.E["3dxy"]=[l.iX,l.iY]):(l.iX=ZC._x_(r.iX),l.iY=ZC._x_(r.iY)),l.B7=r.A.BP[3],l.BW=r.A.BP[3],l.A0=r.A.BP[2],"bubble"===r.A.AF||"hbubble"===r.A.AF?l.AE=r.A.BP[1]:l.AE=r.A.BP[2],l.append(r.A.A2.o),null!==ZC._n_(r.E["marker.size"])&&(l.AI=r.E["marker.size"]),l.E.plotidx=r.A.L,l.E.nodeidx=r.L,"none"!==r.A.J0&&(r.C.IX[r.A.L]||r.C.KI))if(r.C.CB["p"+r.A.L]&&r.C.CB["p"+r.A.L]["n"+r.L]){if(l.LQ={},r.A.PN&&ZC._cp_(r.A.PN.o,l.LQ),l.LQ.rules){var p=new ZC.DT(r.A);p.o=l.LQ,p.parse(),p.J2=function(e){return r.J2(e)},p.DE()&&(l.LQ=p.o)}}else"none"!==r.A.O5&&("plot"===r.A.O5&&r.C.IX[r.A.L]||"graph"===r.A.O5&&r.C.KI)&&(l.LQ=r.A.PJ?r.A.PJ.o:{});null!==ZC._n_(t=r.A.o.marker)&&null!==ZC._n_(t.styles)&&null!==ZC._n_(n=t.styles[r.L])&&("string"==typeof n?l.append({"background-color":ZC.AP.QR(n,20),"line-color":ZC.AP.JK(n,20),"border-color":ZC.AP.JK(n,20)}):l.append(n)),l.parse(),l.J2=function(e){return r.J2(e)},l.DE()&&l.parse()}if(r.E["marker.size"]=ZC.BQ(2.02,r.E["marker.size"]||l.AI),l.DH=A,!(e||ZC.DS(l.iX,r.C.P.iX-2,r.C.P.iX+r.C.P.I+2)&&ZC.DS(l.iY,r.C.P.iY-2,r.C.P.iY+r.C.P.F+2)))return;if(l.HT&&(r.A.YH=!1,l.H3(l,l,null,r.LY(null,!1)),l.parse()),r.NB=l,l.AN&&"none"!==l.AF){var Z=function(){if(r.A.bBS||r.N3(ZC.Q.EB(r.A.CP("bl",0),r.H.AB)),r.E["marker.type"]=l.DU,r.A.G0&&-1===ZC.AV(r.H.KQ,"skip_marker_tracking")&&!zingchart.DEV.SKIPTRACKERS){var e=r.E["3dxy"]?r.E["3dxy"][0]:r.iX,i=r.E["3dxy"]?r.E["3dxy"][1]:r.iY,t=parseInt(e+l.BL+ZC.MAPTX,10),n=parseInt(i+l.BH+ZC.MAPTX,10),a=parseInt(ZC.BQ(ZC.mobile?6:3,r.E["marker.size"]+1)*(ZC.mobile?1.25:1.05),10),o=!0;if("undefined"!=typeof r.A.aLastMarkerXY)Math.sqrt((t-r.A.aLastMarkerXY[0])*(t-r.A.aLastMarkerXY[0])+(n-r.A.aLastMarkerXY[1])*(n-r.A.aLastMarkerXY[1]))<zingchart.DEV.MINTRACKERDIFF&&(o=!1);else r.A.aLastMarkerXY=[t,n];o&&(r.A.aLastMarkerXY=[t,n],-1!==ZC.AV(["pie","square","rect","rectangle"],l.DU)?r.A.A.HF.push(ZC.Q.FW("poly",r.A.EA,r.A.IP)+'class="'+A+'" id="'+r.K+'--marker" coords="'+l.FF()+'" />'):r.A.A.HF.push(ZC.Q.FW("circle",r.A.EA,r.A.IP)+'class="'+A+'" '+r.a11y()+' id="'+r.K+'--marker" coords="'+t+","+n+","+a+'" />'))}if(r.A.U&&(r.A.E.vboxid=r.K,r.GW()),!r.A.bBS&&r.C.B9&&r.C.B9.I2&&r.A.QN&&r.C.B9.AN){var s=r.C.P,C=r.C.B9,c=C.AQ,u=r.A.HC||l,p=new ZC.DT(r.A);p.copy(u);var Z=(r.iX-s.iX)/s.I,h=(r.iY-s.iY)/s.F,d=Math.min(c.F/s.F,c.I/s.I);p.iX=c.iX+c.AU+Z*(c.I-2*c.AU),p.iY=c.iY+c.AU+h*(c.F-2*c.AU),p.K=r.K+"-marker-preview",p.DH=r.A.K+"-preview";var f=u.AI;null!==ZC._n_(r.E["marker.size"])&&(f=r.E["marker.size"]),p.AI=ZC.BQ(2.02,.9*d*f),p.Z=p.C7=C.Z,p.parse(),p.paint()}},h=!1;if((!r.A.bBS||"radar"===r.A.AF&&"dots"===r.A.CW)&&(h=!0),r.A.GD&&h&&!r.C.HH){var d=l,f={},_=l.C6,g=l.AI,v=l.iX,b=l.iY;d.iX=v,d.iY=b,f.x=v,f.y=b;var B,m=r.A.L7,E=r.C.P;for(B in d.C6=0,f.alpha=_,3===m?(d.AI=2,f.size=g):8===m?(d.iX=v-E.iX,f.x=v):9===m?(d.iX=v+E.iX,f.x=v):10===m?(d.iY=b-E.iY,f.y=b):11===m&&(d.iY=b+E.iY,f.y=b),r.A.FV)d[ZC.E4.GO[ZC.EE(B)]]=r.A.FV[B],f[ZC.EE(B)]=r.O[ZC.E4.GO[ZC.EE(B)]];if(null===ZC._n_(r.C.EN)&&(r.C.EN={}),null!==ZC._n_(r.C.EN[r.A.L+"-"+r.L]))for(B in r.C.EN[r.A.L+"-"+r.L])d[ZC.E4.GO[ZC.EE(B)]]=r.C.EN[r.A.L+"-"+r.L][B];r.C.EN[r.A.L+"-"+r.L]={},ZC._cp_(f,r.C.EN[r.A.L+"-"+r.L]);var D=new ZC.E4(d,f,r.A.JG,r.A.L6,ZC.E4.RK[r.A.L8],function(){Z()});D.AX=r,D.OC=function(){r.N3(ZC.Q.EB(r.A.CP("bl",0),r.H.AB))},r.LO(D)}else{var F="circle"===l.DU?"circle":"path";if(r.A.HI){var K=function(i,t){var n=i.cloneNode(!1),a=r.iX,o=r.iY;if(e){var s=new ZC.CE(r.C,a-ZC.AO.E2,o-ZC.AO.E3,r.A.E["z-start"]||0);a=ZC._x_(s.ED[0]),o=ZC._x_(s.ED[1]),r.E["3dxy"]=[a,o]}n.setAttribute("transform","translate("+ZC._i_(a-l.iX)+","+ZC._i_(o-l.iY)+") "+(n.getAttribute("transform")||"")),n.setAttribute("id",t),"bubble"!==r.A.AF&&"hbubble"!==r.A.AF||n.setAttribute("r",r.E["marker.size"]),i.parentNode.appendChild(n)};l.M8&&K(r.A.RB,r.K+"-marker-sh-"+F),K(r.A.HI,r.K+"-marker-"+F),l.DA&&K(r.A.QD,r.K+"-marker-imgfill")}else{l.paint();var x=l.A0!==l.AE;if(!r.C.IX[r.A.L]&&r.A.YH&&!x)if("svg"===r.H.AB){if(-1===ZC.AV(["pie","square","rect","rectangle","cross","plus","custom"],l.DU))if(r.A.HC=l,zingchart.DEV.DOMFRAGMENTS&&document.querySelector){for(var I in r.H.G1)r.A.HI||(r.A.HI=r.H.G1[I].querySelector("#"+r.K+"-marker-"+F)),l.M8&&!r.A.RB&&(r.A.RB=r.H.G1[I].querySelector("#"+r.K+"-marker-sh-"+F)),l.DA&&!r.A.QD&&(r.A.QD=r.H.G1[I].querySelector("#"+r.K+"-marker-imgfill")||r.H.G1[I].querySelector("#"+r.K+"-marker-path-imgfill"));r.A.HI||(r.A.HI=ZC.AL(r.K+"-marker-"+F),l.M8&&(r.A.RB=ZC.AL(r.K+"-marker-sh-"+F)),l.DA&&(r.A.QD=ZC.AL(r.K+"-marker-imgfill")))}else r.A.HI=ZC.AL(r.K+"-marker-"+F),l.M8&&(r.A.RB=ZC.AL(r.K+"-marker-sh-"+F)),l.DA&&(r.A.QD=ZC.AL(r.K+"-marker-imgfill")||ZC.AL(r.K+"-marker-path-imgfill"))}else"bubble"!==r.A.AF&&"hbubble"!==r.A.AF&&(e||(r.A.HC=l))}"svg"===r.H.AB&&r.A.applyJsRuleSvg(r.A.A2,r.K+"-marker-"+F,r.LY()),Z()}}else r.A.U&&r.GW()}else r.A.U&&r.GW()}}}},LO:function(e,i){var t,n=this,a=n.C.LZ,l=a.PE,o=n.A.TQ;switch(o){default:i&&a.add(i),a.add(e);break;case 1:case 2:case 3:if(i){var r="all";if(1===o?r="plots-group-"+n.L+"-area":2===o&&(r="nodes-group-"+n.A.L+"-area"),null===ZC._n_(l[r])){var s=new ZC.VI(r);a.A9P(s,i.X9)}l[r].add(i)}if(t="all",1===o?t="plots-group-"+n.L:2===o&&(t="nodes-group-"+n.A.L),null===ZC._n_(l[t])){var A=new ZC.VI(t);a.A9P(A,e.X9)}l[t].add(e)}},TR:function(e){var i=this;i.A.I3&&i.A.bXY&&(i.T7(),e&&("scatter"!==i.A.AF&&"hscatter"!==i.A.AF&&"bubble"!==i.A.AF&&"hbubble"!==i.A.AF||i.paint(!0)));var t=i.A.BP;i.M5({layer:e,type:"shape",id:"marker",marker:!0,initcb:function(){this.DU=i.E["marker.type"],this.iX=i.iX,this.iY=i.iY,"bubble"===i.A.AF||"hbubble"===i.A.AF?(this.AE=t[3],this.A0=t[2]):(this.B7=t[3],this.BW=t[3],this.A0=t[2],this.AE=t[1]),this.AI=i.E["marker.size"]}})},A1F:function(e){var i=this;i.M5({layer:e,type:"line",id:"line",initcb:function(){this.B7=i.A.BP[3]}})},M5:function(e){if(!ZC.move){var i,t,n,a,l,o,r=this,s=e.layer||"hover",A=e.id||"",C=!1;switch(r.GJ=null,null!==ZC._n_(i=e.marker)&&(C=ZC._b_(i)),s){case"hover":null!==ZC._n_(r.C.CB["p"+r.A.L])&&null!==ZC._n_(r.C.CB["p"+r.A.L]["n"+r.L])||(n=C?r.A.GC:r.A.IE,a="hover");break;case"highlight":n=C?r.A.V5:r.A.S3,a="hover"}if(null!==ZC._n_(e.state)&&(n=e.state),n&&r.C.E["plot"+r.A.L+".visible"]&&n.AN){switch(e.type){case"box":(o=new ZC.HL(r.A)).PU=!0;break;case"line":o=new ZC.DT(r.A),l=ZC.Q.EB(r.C.K+"-"+a+"-c",r.H.AB),o.CZ=!1;break;case"shape":o=new ZC.DT(r.A);break;case"area":o=new ZC.DT(r.A),l=ZC.Q.EB(r.C.K+"-"+a+"-c",r.H.AB)}if(C&&(o.E["p-width"]=r.A.B1.AA,o.E["p-height"]=r.A.CM.AA),zingchart.DEV.PLOTSHLAYER&&"hover"===a?o.Z=o.C7=ZC.AL(r.C.K+"-plots-hover-c"):o.Z=o.C7=ZC.AL(r.C.K+"-"+a+"-c"),o.K=r.K+"-"+(""!==A?A+"-":"")+s,o.E.plotidx=r.A.L,o.E.nodeidx=r.L,"hover"!==s&&(o.A2A=!0),e.initcb&&e.initcb.call(o),o.append(n.o),e.parsecb&&e.parsecb.call(o),"hover"===s&&null!==ZC._n_(i=r.A.o)&&null!==ZC._n_(i.styles)&&null!==ZC._n_(t=i.styles[r.L])&&("string"==typeof t?o.append({"background-color":t,"line-color":t,"border-color":t}):o.append(t)),null!==ZC._n_(i=r.A.o[s+"-state"])&&null!==ZC._n_(i.styles)&&null!==ZC._n_(t=i.styles[r.L])&&("string"==typeof t?o.append({"background-color":t,"line-color":t,"border-color":t}):o.append(t)),r.A.HT&&r.H3(o,s),"hover"===s&&r.A.A2&&r.A.A2.HT&&(r.A.A2.H3(r.A.A2,o,null,r.LY(null,!1)),o.parse()),o.parse(),o.J2=function(e){return r.J2(e)},o.DE()&&o.parse(),o.AN){switch(e.setupcb&&e.setupcb.call(o),e.type){case"box":case"shape":o.locate(2),o.paint();break;case"line":ZC.CR.setup(l,o),"plot"===r.A.A3K?ZC.CR.paint(l,o,r.A.V1):ZC.CR.paint(l,o,r.getNodeData("points"));break;case"area":"spline"!==r.A.CW&&(null!==ZC._n_(i=n.o["alpha-area"])&&(o.C6=ZC._f_(i)),ZC.CR.setup(l,o),o.paint())}r.GJ=o}}}},N3:function(){},setup:function(){},A0W:function(){},LD:function(){var e=this;ZC.Q.EU([e.K+"-hover-gradient",e.K+"-marker-hover-gradient",e.H.K+"-tooltip-text-gradient",e.H.K+"-tooltip-text-sh-gradient"])},LY:function(e,i){var t=this;void 0===i&&(i=!0);var n=!1;"none"!==t.A.J0&&t.C.CB&&t.C.CB["p"+t.A.L]&&t.C.CB["p"+t.A.L]["n"+t.L]&&(n=!0);var a={id:t.C.A.K,graphid:t.C.K,graphindex:t.C.L,plotid:t.A.H5,plotindex:t.A.L,nodeindex:t.L,key:null===t.BT?t.L:t.BT,scaleval:t.A.B1?t.A.B1.V[null===t.BT?t.L:t.BT]:null,scaletext:t.A.B1?t.A.B1.FQ(t.L,null===t.BT?null:t.A):null,value:t.AD,text:i?t.JT(t.A.J7):t.A.J7,ev:e?ZC.A4.BZ(e):null,x:t.iX,y:t.iY,width:t.I,height:t.F,size:t.E["marker.size"]||1,selected:n};for(var l in t.A.KH)t.A.KH[l]instanceof Array?null!==ZC._n_(t.A.KH[l][t.L])&&(a["data-"+l]=t.A.KH[l][t.L]):a["data-"+l]=t.A.KH[l];return a},X6:function(e,i){ZC.AP.BY("node_"+i,this.H,this.LY(e))}};ZC.LE=ZC.DN.CA(LE),ZC.A38=ZC.LE.CA({setup:function(){this.T7()},ABF:function(){return{color:this.A.I3?this.A.B7:this.O.B7}},Y2:function(){return{"background-color":this.O.B7,"border-color":this.O.B7,color:this.O.C2}},getTooltipPosition:function(e,i){return this.b(e,i,this.NB.AI)},paint:function(e){var i=this;void 0===e&&(e=!1),i.b();var t=i.A.O6,n=i.A.QC,a=i.A.B1,l=i.A.S;if(i.setup(),!i.A.I3||i.C.AJ["3d"]||i.A.G0){i.O.CZ=i.CZ=!1,i.O.C7=i.A.CP("bl",0);var o=[],r=i.A.CW;(i.C.OF||i.A.U5)&&"spline"===i.A.CW&&(r="segmented");var s="undefined"!=typeof i.A.GB?i.A.GB:i.A.Y,A="undefined"!=typeof i.A.HD?i.A.HD:i.A.Y,C=!0,c=!0;(null===ZC._n_(l[i.L-s])||"log"!==a.C1&&!a.EF&&i.L<=a.W)&&(C=!1);var u,p,Z,h,d=i.A.LN?i.A.S.length:a.A1;switch((null===ZC._n_(l[i.L+A])||"log"!==a.C1&&!a.EF&&i.L>=d)&&(c=!1),r){default:C&&(i.A.FK(i.L-s,0).setup(),i.A.UR&&(u=ZC.AR.JU(i.A.S[i.L-s].iX,i.A.S[i.L-s].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),o.push(u))),o.push([i.iX,i.iY]),c&&(i.A.FK(i.L+A,2).setup(),u=i.A.UR?ZC.AR.JU(i.A.S[i.L].iX,i.A.S[i.L].iY,i.A.S[i.L+A].iX,i.A.S[i.L+A].iY,i.O.C6):[l[i.L+A].iX,l[i.L+A].iY],o.push(u));break;case"spline":if(i.A.D&&(o=i.A.D),i.A.D=[],l[i.L+1]){var f=[],_=[];for(p=-1;p<3;p++)l[i.L+p]?(i.A.FK(i.L+p,2).setup(),t?(f.push(l[i.L+p].iX),_.push(l[i.L+p].iY)):(f.push(l[i.L+p].iY),_.push(l[i.L+p].iX))):0===f.length?t?(_.push(i.iY),f.push(i.iX)):(_.push(i.iX),f.push(i.iY)):(f.push(f[f.length-1]),_.push(_[_.length-1]));var g=ZC._a_(_[2]-_[1]);g=Math.min(g,Math.max(i.C.I,i.C.F));var v=ZC.AR.Y9(i.A.Q8,f,g);if(i.A.UR){for(p=0;p<ZC._i_(v.length/2)+(1===i.O.C6?1:0);p++)v[p]&&(t?o.push([v[p][1],i.iY+(a.AW?1:-1)*v[p][0]*g]):o.push([i.iX+(a.AW?-1:1)*v[p][0]*g,v[p][1]]));for(p=ZC._i_(v.length/2)-1,Z=v.length;p<Z;p++)v[p]&&(t?i.A.D.push([v[p][1],i.iY+(a.AW?1:-1)*v[p][0]*g]):i.A.D.push([i.iX+(a.AW?-1:1)*v[p][0]*g,v[p][1]]))}else for(p=0;p<ZC._i_(v.length);p++)t?o.push([v[p][1],i.iY+(a.AW?1:-1)*v[p][0]*g]):o.push([i.iX+(a.AW?-1:1)*v[p][0]*g,v[p][1]])}break;case"stepped":if(C)switch(i.A.FK(i.L-s,0).setup(),u=ZC.AR.JU(i.A.S[i.L-s].iX,i.A.S[i.L-s].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),i.A.SI){default:t?o.push([l[i.L-s].iX,u[1]],[i.iX,u[1]]):o.push([u[0],l[i.L-s].iY],[u[0],i.iY]);break;case"before":o.push([i.A.S[i.L-s].iX,l[i.L-s].iY],[i.A.S[i.L-s].iX,i.iY]);break;case"after":}if(o.push([i.iX,i.iY]),c)switch(i.A.FK(i.L+A,0).setup(),u=ZC.AR.JU(i.A.S[i.L+s].iX,i.A.S[i.L+s].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),i.A.SI){default:o.push(t?[i.iX,u[1]]:[u[0],i.iY]);break;case"before":break;case"after":o.push([i.A.S[i.L+s].iX,i.iY],[i.A.S[i.L+s].iX,l[i.L+A].iY])}break;case"jumped":C?(i.A.FK(i.L-s,0).setup(),u=ZC.AR.JU(i.A.S[i.L-s].iX,i.A.S[i.L-s].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),o.push(t?[i.iX,u[1]]:[u[0],i.iY])):o.push(t?[i.iX,i.iY-a.AA/2]:[i.iX-a.AA/2,i.iY]),o.push([i.iX,i.iY]),c?(i.A.FK(i.L+A,0).setup(),u=ZC.AR.JU(i.A.S[i.L+s].iX,i.A.S[i.L+s].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),o.push(t?[i.iX,u[1]]:[u[0],i.iY])):o.push(t?[i.iX,i.iY+a.AA/2]:[i.iX+a.AA/2,i.iY])}if(i.setNodeData({points:o}),"ready"!==i.C.ME&&(i.A.V1=i.A.V1.concat(o)),!e&&!i.C.AJ["3d"]){var b=i.O=i.A.ID(i,i.O),B=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area";if(b.DH=B,b.K=i.K,i.A.HT&&i.H3(b),ZC.CR.setup(n,b),i.paintPreview(b,o),i.A.GD&&!i.C.HH){var m=new ZC.DT(i),E={};m.copy(b),m.K=i.K,m.Z=i.A.CP("bl",1),m.C7=i.A.CP("bl",0),m.D=o,E.points=o;var D=[],F=i.A.L7,K=i.C.P;for(m.C6=0,E.alpha=b.C6,p=0;p<o.length;p++)2===F?D[p]=[o[p][0],K.iY+K.F/2]:3===F?D[p]=[o[p][0],K.iY-5]:4===F?D[p]=[o[p][0],K.iY+K.F+5]:5===F?D[p]=[K.iX-5,o[p][1]]:6===F?D[p]=[K.iX+K.I+5,o[p][1]]:7===F?D[p]=[K.iX+K.I/2,o[p][1]]:8===F?D[p]=[o[p][0]-K.I,o[p][1]]:9===F?D[p]=[o[p][0]+K.I,o[p][1]]:10===F?D[p]=[o[p][0],o[p][1]-K.F]:11===F?D[p]=[o[p][0],o[p][1]+K.F]:12===F?D[p]=[(o[0][0]+o[o.length-1][0])/2,o[0][1]]:13===F&&(D[p]=[o[0][0],(o[0][1]+o[o.length-1][1])/2]),F>1&&(m.D=D,E.points=o);for(h in i.A.FV)m[ZC.E4.GO[ZC.EE(h)]]=i.A.FV[h],E[ZC.EE(h)]=b[ZC.E4.GO[ZC.EE(h)]];if(i.C.EN||(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(h in i.C.EN[i.A.L+"-"+i.L])m[ZC.E4.GO[ZC.EE(h)]]=i.C.EN[i.A.L+"-"+i.L][h];i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(E,i.C.EN[i.A.L+"-"+i.L]);var x=new ZC.E4(m,E,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){I()});x.AX=i,x.OC=function(){i.N3(ZC.Q.EB(i.A.CP("bl",1),i.H.AB))},x.IK=n,i.LO(x)}else ZC.CR.paint(n,b,o),I()}}function I(){!i.C.OF&&ZC.DS(i.iX,a.iX-1,a.iX+a.I+1)&&ZC.DS(i.iY,a.iY-1,a.iY+a.F+1)&&(i.PA(),i.N3(ZC.Q.EB(i.A.CP("bl",1),i.H.AB)),i.A.U&&i.A.U.AN&&i.A.E.vboxid!==i.K&&i.GW())}},paintPreview:function(e,i){var t=this;if(t.C.B9&&t.C.B9.I2&&t.A.QN){var n,a=t.A.mapPointsToPreview(i);t.A.WB?n=t.A.WB:(n=new ZC.D0(t),t.A.WB=n),n.copy(e),n.K=t.K+"-line-preview",n.DH=t.A.K+"-preview";var l=ZC.Q.EB(t.C.B9.Z,t.H.AB);n.AZ=1;var o=t.o["preview-state"];o&&(n.append(o),n.parse()),ZC.CR.paint(l,n,a,null,3)}},A0W:function(e){var i=this;ZC.move||(i.A1F(e),i.A.R5&&i.TR(e))}}),ZC.A35=ZC.LE.CA({setup:function(){this.T7()},ABF:function(){return{color:this.A.I3?this.A.B7:this.O.B7}},Y2:function(){return{"background-color":this.O.B7,"border-color":this.O.B7,color:this.O.C2}},getTooltipPosition:function(e,i){return this.b(e,i,this.NB.AI)},paint:function(e){var i,t,n,a,l,o,r,s,A=this;void 0===e&&(e=!1),A.b();var C=A.A.O6,c=A.A.QC,u=A.A.B1,p=A.A.CM,Z=A.A.S;if(A.setup(),!A.A.I3||A.C.AJ["3d"]||A.A.G0){A.O.CZ=A.CZ=!1,A.O.C7=A.A.CP("bl",1);var h=p.H8,d=p.AT(h);d=C?ZC._l_(d,p.iX,p.iY+p.I):ZC._l_(d,p.iY,p.iY+p.F);var f=u.DF?u.AA/2:0,_=[],g=[],v=[],b=null;null!==ZC._n_(A.A.A.F1)&&null!==ZC._n_(A.A.A.F1[A.L])&&(b=A.A.A.F1[A.L]);var B=A.A.CW;(A.C.OF||A.A.U5)&&"spline"===A.A.CW&&(B="segmented"),t=A.O.AZ/2-1,n="svg"===A.H.AB&&ZC.mobile?A.O.HX/4:0,"vml"===A.H.AB&&A.A.GD&&(n=.5),A.C.AJ["3d"]&&(1===A.A.HX?n=1:(n=A.A.HX/3,"canvas"===A.H.AB&&(ZC.A4.browser.msie||ZC.A4.browser.opera)&&(n=.5)),u.AW&&(n=-n));var m,E="undefined"!=typeof A.A.GB?A.A.GB:A.A.Y,D="undefined"!=typeof A.A.HD?A.A.HD:A.A.Y,F=!0,K=!0;(!Z[A.L-E]||"log"!==u.C1&&!u.EF&&A.L<=u.W)&&(F=!1);var x=A.A.LN?A.A.S.length:u.A1;switch((!Z[A.L+D]||"log"!==u.C1&&!u.EF&&A.L>=x)&&(K=!1),B){default:if(F)A.A.FK(A.L-E,0).setup(),A.A.UR?(l=ZC.AR.JU(Z[A.L-E].iX,Z[A.L-E].iY,Z[A.L].iX,Z[A.L].iY),v.push([ZC._i_(l[0])-n,l[1]-t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(l[0])-n,d]),g.push([ZC._i_(l[0])-n,l[1]+t]),_.push([l[0],l[1]])):g.push([ZC._i_(A.iX),d]);else if(u.EF||A.L!==u.W)A.A.CC&&null!==ZC._n_(b)?(m=A.A.A.A5[A.A.L-1])&&m.S[A.L]&&g.push([ZC._i_(A.iX),m.S[A.L].iY+t]):(g.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX-u.AA/2),d]),v.push([ZC._i_(A.iX),d]));else if(u.AW)A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.I-u.BV-f),d]),g.push([ZC._i_(u.iX+u.I-u.BV-f),A.iY+t]);else{var I=ZC._i_(u.iX+u.AC+f);A.A.LN&&(I=u.IB(A.A.R8)-u.AA/2),A.A.CC&&null!==ZC._n_(b)||g.push([I,d]),g.push([I,A.iY+t])}v.push([ZC._i_(A.iX),A.iY-t]),g.push([ZC._i_(A.iX),A.iY+t]),_.push([A.iX,A.iY]),K?(A.A.FK(A.L+D,2).setup(),a=A.A.UR?ZC.AR.JU(Z[A.L].iX,Z[A.L].iY,Z[A.L+D].iX,Z[A.L+D].iY):[Z[A.L+D].iX,Z[A.L+D].iY],v.push([ZC._i_(a[0]),a[1]-t]),g.push([ZC._i_(a[0]),a[1]+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(a[0]),d]),l=A.A.UR?ZC.AR.JU(Z[A.L].iX,Z[A.L].iY,Z[A.L+D].iX,Z[A.L+D].iY,A.O.C6):[Z[A.L+D].iX,Z[A.L+D].iY],_.push([l[0],l[1]])):A.L===u.A1?u.AW?(g.push([u.iX+u.AC-f,A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.AC-f),d])):(g.push([u.iX+u.I-u.BV-f,A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.I-u.BV-f),d])):A.A.CC&&null!==ZC._n_(b)?(m=A.A.A.A5[A.A.L-1])&&m.S[A.L]&&g.push([ZC._i_(A.iX),m.S[A.L].iY+t]):(g.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX+u.AA/2),d]));break;case"spline":if(null!==ZC._n_(A.A.D6)&&(v=A.A.D6),null!==ZC._n_(A.A.AH)&&(g=A.A.AH),A.A.D6=[],A.A.AH=[],null!==ZC._n_(A.A.D)&&(_=A.A.D),A.A.D=[],Z[A.L+1]){var y=[],w=[];for(o=-1;o<3;o++)Z[A.L+o]?(A.A.FK(A.L+o,2).setup(),C?(y.push(Z[A.L+o].iX),w.push(Z[A.L+o].iY)):(y.push(Z[A.L+o].iY),w.push(Z[A.L+o].iX))):0===y.length?C?(w.push(A.iY),y.push(A.iX)):(w.push(A.iX),y.push(A.iY)):(y.push(y[y.length-1]),w.push(w[w.length-1]));var L=ZC._a_(w[2]-w[1]);L=Math.min(L,Math.max(A.C.I,A.C.F));var X=ZC.AR.Y9(A.A.Q8,y,L);if(A.A.UR){for(0===g.length&&(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(A.iX+(u.AW?-1:1)*X[0][0]*L),d])),o=0;o<ZC._i_(X.length/2)+(1===A.O.C6?1:0);o++)X[o]&&(C?_.push([X[o][1],A.iY+(u.AW?1:-1)*X[o][0]*L]):_.push([A.iX+(u.AW?-1:1)*X[o][0]*L,X[o][1]]));for(o=0;o<ZC._i_(X.length/2)+(1===A.O.HX?1:0);o++)v.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]-t]),g.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]]);for(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(g[g.length-1][0]),d]),s=1===A.HX?ZC.CY(2,ZC._i_(X.length/2)):1,o=ZC._i_(X.length/2)-1,r=X.length;o<r;o++)X[o]&&(C?A.A.D.push([X[o][1],A.iY+(u.AW?1:-1)*X[o][0]*L]):A.A.D.push([A.iX+(u.AW?-1:1)*X[o][0]*L,X[o][1]]));for(o=ZC._i_(X.length/2)-s,r=X.length;o<r;o++)0===A.A.AH.length&&(A.A.CC&&null!==ZC._n_(b)||A.A.AH.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),d])),A.A.AH.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]]),A.A.D6.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]-t])}else{for(0===g.length&&(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(A.iX+(u.AW?-1:1)*X[0][0]*L),d])),o=0;o<X.length;o++)C?_.push([X[o][1],A.iY+(u.AW?1:-1)*X[o][0]*L]):_.push([A.iX+(u.AW?-1:1)*X[o][0]*L,X[o][1]]);for(o=0;o<X.length;o++)v.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]-t]),g.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]]);for(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(g[g.length-1][0]),d]),s=1===A.HX?ZC.CY(2,ZC._i_(X.length/2)):1,o=X.length,r=X.length;o<r;o++)C?A.A.D.push([X[o][1],A.iY+(u.AW?1:-1)*X[o][0]*L]):A.A.D.push([A.iX+(u.AW?-1:1)*X[o][0]*L,X[o][1]]);for(o=X.length-s,r=X.length;o<r;o++)0===A.A.AH.length&&(A.A.CC&&null!==ZC._n_(b)||A.A.AH.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),d])),A.A.AH.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]]),A.A.D6.push([ZC._i_(A.iX+(u.AW?-1:1)*X[o][0]*L),X[o][1]-t])}}else g.length>0&&g.push([g[g.length-1][0],d]);break;case"stepped":if(F)switch(A.A.FK(A.L-E,0).setup(),l=ZC.AR.JU(Z[A.L-E].iX,Z[A.L-E].iY,Z[A.L].iX,Z[A.L].iY),A.A.SI){default:v.push([ZC._i_(l[0])-n,A.iY-t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(l[0])-n,d]),g.push([ZC._i_(l[0])-n,A.iY+t]),_.push(C?[Z[A.L-E].iX,l[1]]:[l[0],Z[A.L-E].iY]),_.push(C?[A.iX,l[1]]:[l[0],A.iY]);break;case"before":v.push([ZC._i_(Z[A.L-E].iX)-n,A.iY-t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(Z[A.L-E].iX)-n,d]),g.push([ZC._i_(Z[A.L-E].iX)-n,A.iY+t]),_.push([Z[A.L-E].iX,Z[A.L-E].iY]),_.push([Z[A.L-E].iX,A.iY]);break;case"after":v.push([ZC._i_(A.iX)-n,A.iY-t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(A.iX)-n,d]),g.push([ZC._i_(A.iX)-n,A.iY+t])}else u.EF||A.L!==u.W?A.A.CC&&null!==ZC._n_(b)?(m=A.A.A.A5[A.A.L-1])&&m.S[A.L]&&g.push([ZC._i_(A.iX),m.S[A.L].iY+t]):(g.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX-u.AA/2),d]),v.push([ZC._i_(A.iX),d])):u.AW?(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.I-u.BV-f),d]),g.push([ZC._i_(u.iX+u.I-u.BV-f),A.iY+t])):(A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.AC+f),d]),g.push([ZC._i_(u.iX+u.AC+f),A.iY+t]));if(v.push([ZC._i_(A.iX),A.iY-t]),g.push([ZC._i_(A.iX),A.iY+t]),_.push([A.iX,A.iY]),K)switch(A.A.FK(A.L+D,2).setup(),l=ZC.AR.JU(Z[A.L].iX,Z[A.L].iY,Z[A.L+D].iX,Z[A.L+D].iY,A.O.C6),A.A.SI){default:v.push([ZC._i_(l[0]),A.iY-t]),g.push([ZC._i_(l[0]),A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(l[0]),d]),_.push(C?[A.iX,l[1]]:[l[0],A.iY]);break;case"before":v.push([ZC._i_(A.iX),A.iY-t]),g.push([ZC._i_(A.iX),A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(A.iX),d]);break;case"after":v.push([ZC._i_(Z[A.L+D].iX),A.iY-t]),g.push([ZC._i_(Z[A.L+D].iX),A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(Z[A.L+D].iX),d]),_.push([Z[A.L+D].iX,A.iY]),_.push([Z[A.L+D].iX,Z[A.L+D].iY])}else A.L===u.A1?u.AW?(g.push([u.iX+u.AC-f,A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.AC-f),d])):(g.push([u.iX+u.I-u.BV-f,A.iY+t]),A.A.CC&&null!==ZC._n_(b)||g.push([ZC._i_(u.iX+u.I-u.BV-f),d])):A.A.CC&&null!==ZC._n_(b)?(m=A.A.A.A5[A.A.L-1])&&m.S[A.L]&&g.push([ZC._i_(A.iX),m.S[A.L].iY+t]):(g.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX),d]),v.push([ZC._i_(A.iX+u.AA/2),d]))}if(A.A.CC&&null!==ZC._n_(b))for(o=b.length-1;o>=0;o--)g.push(b[o]);if(A.setNodeData({points:_,pointsarea:g}),"ready"!==A.C.ME&&(A.A.V1=A.A.V1.concat(_)),null===ZC._n_(A.A.A.F1)&&(A.A.A.F1=[]),A.A.A.F1[A.L]=v,!e&&!A.C.AJ["3d"]){var Y=A.O=A.A.ID(A,A.O),M=A.C.K+"-node-area "+A.C.K+"-plotset-plot-"+A.A.L+"-node-area zc-node-area";Y.DH=M,Y.K=A.K,A.A.HT&&A.H3(Y);var H,P=A.C.P;if(0!==A.A.E7.length||A.A.HT||"undefined"==typeof A.A.A9N||A.O.o.override||A.C.KI?((H=new ZC.DT(A.A)).copy(Y),H.C6=A.A.HX):H=A.A.A9N,A.H3(H),H.C6=ZC._f_(H.o["alpha-area"]||"1"),H.CZ=!1,H.L4=!0,H.AZ=0,H.AU=0,H.EX=0,H.GA=0,H.Z=A.A.CP("bl",A.C.CC?0:1),H.D=g,H.D1=[P.iX,P.iY,P.iX+P.I,P.iY+P.F],null!==ZC._n_(i=A.A.E["min-y"])&&(H.E["bound-1"]=i,H.D1[1]=i),null!==ZC._n_(i=A.A.E["max-y"])&&(H.E["bound-3"]=i,H.D1[3]=i),H.K=A.K+"-area",A.A.GD||(H.E.areanode=!0),ZC.CR.setup(c,Y),A.paintPreview(Y,_,g),A.A.GD&&!A.C.HH){var N=new ZC.DT(A),S={};N.copy(Y),N.K=A.K,N.Z=A.A.CP("bl",2),N.C7=A.A.CP("bl",1),N.D=_;var O=H,G={},k=[],T=[];N.D=_,S.points=_,O.D=g,G.points=g;var z=A.A.L7,Q=A.C.P;N.C6=0,S.alpha=Y.C6,O.C6=0,G.alpha=A.A.HX;var J,V=function(e){for(var i=e?g:_,t=e?T:k,n=0;n<i.length;n++)2===z?t[n]=[i[n][0],Q.iY+A.C.P.F/2]:3===z?t[n]=[i[n][0],Q.iY-5]:4===z?t[n]=[i[n][0],Q.iY+Q.F+5]:5===z?t[n]=[Q.iX-5,i[n][1]]:6===z?t[n]=[Q.iX+Q.I+5,i[n][1]]:7===z?t[n]=[Q.iX+Q.I/2,i[n][1]]:8===z?t[n]=[i[n][0]-Q.I,i[n][1]]:9===z?t[n]=[i[n][0]+Q.I,i[n][1]]:10===z?t[n]=[i[n][0],i[n][1]-Q.F]:11===z?t[n]=[i[n][0],i[n][1]+Q.F]:12===z?t[n]=[(i[0][0]+i[i.length-1][0])/2,i[0][1]]:13===z&&(t[n]=[i[0][0],(i[0][1]+i[i.length-1][1])/2]),z>1&&(e?(O.D=T,G.points=g):(N.D=k,S.points=_))};for(J in V(),V(!0),A.A.FV)N[ZC.E4.GO[ZC.EE(J)]]=A.A.FV[J],S[ZC.EE(J)]=Y[ZC.E4.GO[ZC.EE(J)]],O[ZC.E4.GO[ZC.EE(J)]]=A.A.FV[J],G[ZC.EE(J)]=Y[ZC.E4.GO[ZC.EE(J)]];if(null===ZC._n_(A.C.EN)&&(A.C.EN={}),null===ZC._n_(A.C.SS)&&(A.C.SS={}),null!==ZC._n_(A.C.EN[A.A.L+"-"+A.L])){for(J in A.C.EN[A.A.L+"-"+A.L])N[ZC.E4.GO[ZC.EE(J)]]=A.C.EN[A.A.L+"-"+A.L][J];for(J in A.C.SS[A.A.L+"-"+A.L])O[ZC.E4.GO[ZC.EE(J)]]=A.C.SS[A.A.L+"-"+A.L][J]}A.C.EN[A.A.L+"-"+A.L]={},ZC._cp_(S,A.C.EN[A.A.L+"-"+A.L]),A.C.SS[A.A.L+"-"+A.L]={},ZC._cp_(G,A.C.SS[A.A.L+"-"+A.L]);var R=new ZC.E4(N,S,A.A.JG,A.A.L6,ZC.E4.RK[A.A.L8],function(){U()});R.AX=A,R.OC=function(){A.N3(ZC.Q.EB(A.A.CP("bl",1),A.H.AB))},R.IK=c;var W=new ZC.E4(O,G,A.A.JG,A.A.L6,ZC.E4.RK[A.A.L8],function(){});W.AX=A,A.LO(R,W)}else H.paint(),0!==A.A.E7.length||"undefined"!=typeof A.A.A9N||A.O.o.override||A.C.KI||A.C.HH||(A.A.A9N=H),ZC.CR.paint(c,Y,_),U()}}function U(){!A.C.OF&&ZC.DS(A.iX,u.iX-1,u.iX+u.I+1)&&ZC.DS(A.iY,u.iY-1,u.iY+u.F+1)&&(A.PA(),A.N3(ZC.Q.EB(A.A.CP("bl",1),A.H.AB)),A.A.U&&A.A.U.AN&&A.A.E.vboxid!==A.K&&A.GW())}},paintPreview:function(e,i,t){var n=this;if(n.C.B9&&n.C.B9.I2&&n.A.QN){var a,l=n.C.P,o=n.C.B9,r=n.A.mapPointsToPreview(t),s=new ZC.DT(n.A);s.copy(e),s.CZ=!0,s.L4=!0,s.AZ=0,s.AU=0,s.EX=0,s.GA=0,s.C6=n.A.HX,s.D1=[l.iX,l.iY,l.iX+l.I,l.iY+l.F],s.K=n.K+"-area-preview",s.DH=n.A.K+"-preview",s.Z=o.Z;var A,C=n.A.o["preview-state"];C&&(null!==ZC._n_(C["alpha-area"])?(a=C.alpha,C.alpha=C["alpha-area"]):C.alpha=s.C6,s.append(C),s.parse(),null!==ZC._n_(a)?C.alpha=a:delete C.alpha),s.D=r,s.paint();var c=n.A.mapPointsToPreview(i);n.A.WB?A=n.A.WB:(A=new ZC.D0(n),n.A.WB=A),A.copy(e),A.K=n.K+"-line-preview",A.DH=n.A.K+"-preview";var u=ZC.Q.EB(o.Z,n.H.AB);A.AZ=1,C&&(A.append(C),A.parse()),ZC.CR.paint(u,A,c,null,3)}},A0W:function(e){var i=this;ZC.move||(i.A.O6||i.M5({layer:e,type:"area",initcb:function(){this.A0=i.A.BP[2],this.AE=i.A.BP[2],this.D=i.getNodeData("pointsarea")||[]},setupcb:function(){this.AZ=0,this.AU=0,this.C6=i.A.HX;var e=i.C.P;this.D1=[e.iX,e.iY,e.iX+e.I,e.iY+e.F]}}),i.A1F(e),i.A.R5&&i.TR(e))}}),ZC.ZB=ZC.LE.CA({setup:function(){this.T7()},UU:function(){var e=this;e.paint(!0);var i=e.C.BM(e.A.BU("v")[0]);return[e.iX+e.I/2,e.iY+(i.AW?e.F:0),{reference:e,center:!0}]},AC8:function(e){var i=this,t="top-out",n=i.C.BM(i.A.BU("v")[0]),a=i.AD>=n.H8&&!n.AW||i.AD<n.H8&&n.AW?1:-1;e=i.setupValueBoxWH(e),null!==ZC._n_(e.o.placement)&&(t=e.o.placement);var l=e.I,o=e.F,r=i.iX+i.I/2-l/2,s=i.iYVal-o/2,A=e.A9%180==90,C=A?l/2:o/2,c=A?l/2-o/2:0;switch(t){case"top-out":case"top":s-=a*(C+5);break;case"top-in":s+=a*(C+5);break;case"middle":s+=a*(i.F/2);break;case"bottom-in":s+=a*(i.F-C-5);break;case"bottom-out":case"bottom":s+=a*(i.F+o/2+5)}if(null!==ZC._n_(e.o.x)||null!==ZC._n_(e.o.y))null!==ZC._n_(e.o.x)&&(r=e.iX),null!==ZC._n_(e.o.y)&&(s=e.iY);else{var u=ZC._c_(i.A.o.tolerance,5);if(!ZC.AR._boxoverlap2_(i,i.C.P,u))return[-1,-1]}var p=e.o.tolerance||[i.C.P.E8,i.C.P.E9,i.C.P.DR,i.C.P.DY];return i.C.AJ["3d"]||(r=ZC.BQ(i.C.P.iX+0-p[3],r),r=ZC.CY(i.C.P.iX+i.C.P.I-l-0+p[1],r),s-c<i.C.P.iY+5-p[0]&&(s=i.C.P.iY+5-p[0]+c),s+c>i.C.P.iY+i.C.P.F-o-5+p[2]&&(s=i.C.P.iY+i.C.P.F-o-5+p[2]-c)),[ZC._i_(r),ZC._i_(s)]},getPMap:function(){var e=this.b();return this.addPMap(e,"barWidth","I"),e},paint:function(e){var i,t=this;if(t.b(),!t.C.AJ["3d"]){void 0===e&&(e=!1);var n=t.A.B1,a=t.A.CM;t.setup();var l,o,r,s,A,C=a.H8,c=a.AT(C),u=t.A.SO(),p=u.AA,Z=u.ET,h=u.CF,d=u.CT,f=u.F4,_=u.D3,g=u.F0;if(e?Z=t.A.E["node-"+t.L+"-bar-index"]:t.A.E["node-"+t.L+"-bar-index"]=u.ET,t.A.CC){l=0;for(var v=t.A.A.KA[Z],b=0;b<v.length;b++){var B=t.A.A.A5[v[b]].S[t.L];B&&(l+=B.AD)}}var m=1,E=1;if(t.A.CC&&(t.CS!==t.AD&&(m=(l-t.CS+t.AD)/l),E=(l-t.CS)/l),a.AW){var D=m;m=E,E=D}t.A.LN&&(Z=t.L);var F=t.iX-p/2+h+Z*(_+f)-Z*g;if(F=ZC._l_(F,t.iX-p/2+h,t.iX+p/2-d),t.A.D3>0){var K=_;(_=t.A.D3)<=1&&(_*=K),F+=(K-_)/2}var x=_,I=t.iY,y=null!==ZC._n_(t.A.LX[t.L])?t.A.LX[t.L]:0;if(I=t.A.CC&&"100%"===t.A.KR?a.AT(100*(t.CS+y)/t.A.A.F8[t.L]["%total-"+t.A.DZ]):a.AT(t.CS+y),t.A.CC){o="100%"===t.A.KR?a.AT(100*(t.CS-t.AD+y)/t.A.A.F8[t.L]["%total-"+t.A.DZ]):a.AT(t.CS-t.AD+y),I=ZC._i_(I),o=ZC._i_(o);var w=!a.AW&&t.AD>=0||a.AW&&t.AD<=0?-1:1,L=0,X=0;""!==t.A.PX?(L=t.WH(t.A.PX)[0],X=0):L=t.A.AU,""!==t.A.NN?(X=t.WH(t.A.NN)[0],L=0):X=t.A.AU,L!==X&&(w=0),r=I-o+w*L,t.AD<0&&(I=o),a.AW?r>0&&(r=ZC._a_(r),I=o):r<0&&(r=ZC._a_(r),I=o-r),a.AW&&t.AD<0&&(r+=X)}else o=a.AT(y),(r=I-o)<0?(r=ZC._a_(r),I=o-r):I=o;if(t.A.TK&&t.A.CC&&t.A.L>0&&t.A.A.A5[t.A.L-1].S[t.L]&&0===t.A.A.A5[t.A.L-1].S[t.L].AD&&(r-=1,I+=a.AW?1:-1),r<2&&(t.AD>0||t.A.TK)&&(r=1,a.AW?t.A.CC&&t.A.L>0&&(I-=1):t.A.CC?0===t.A.L&&(I-=1):I=y?o-1:c-2),t.I=x,t.F=r,t.iX=F,t.iY=I,a.AW?t.AD>=a.H8?t.iYVal=I+t.F:t.iYVal=I:t.AD>=a.H8?t.iYVal=I:t.iYVal=I+t.F,t.C.CX){var Y="middle";t.C.CX.o.marker&&null!==ZC._n_(i=t.C.CX.o.marker.alignment)&&(Y=i),null!==ZC._n_(t.A.o["guide-marker"])&&null!==ZC._n_(i=t.A.o["guide-marker"].alignment)&&(Y=i),"node"===Y&&(t.E.A5M=t.iX+t.I/2)}if(!e){var M;t.setNodeData({x:F,y:I,w:x,h:r});var H=!0;if("none"!==t.A.J0||t.C.IX[t.A.L]||t.C.KI||t.A.T0&&t.A.T0[t.L]?(M=t.O=t.A.ID(t,t.O),H=!1):M=t.O,(0!==t.A.E7.length||t.A.HT||t.O.o.override||t.C.KI)&&(H=!1),t.AN){var P;switch(t.A.CW){default:0!==t.A.E7.length||t.A.HT||"undefined"==typeof t.A.TL||t.O.o.override||t.C.KI?(P=new ZC.HL(t.A)).copy(M):P=t.A.TL,t.A.HT&&(t.H3(P),P.parse()),P.FD=t.A.FD,P.K=t.K,P.iX=F,P.iY=I,P.I=t.I,P.F=t.F,n.AA<5&&P.I<5?(P.I=ZC.BQ(1,P.I)+1,P.N5=!1,P.CZ=!1):P.N5=!0,P.I<5&&n.A1!==n.W&&t.C.P.I/(n.A1-n.W)<1&&(P.QP=!0);break;case"pyramid":case"cone":0!==t.A.E7.length||t.A.HT||"undefined"==typeof t.A.TL||t.O.o.override||t.C.KI?(P=new ZC.DT(t.A)).copy(M):P=t.A.TL,t.A.HT&&(t.H3(P),P.parse()),P.K=t.K,a.AW&&!t.A.CC?(A=t.AD>=0?0:t.F,s=t.AD>=0?t.F:0):(A=t.AD>=0?t.F:0,s=t.AD>=0?0:t.F),P.D=[],P.D.push([F+t.I/2-m*t.I/2,I+A],[F+t.I/2+m*t.I/2,I+A]),t.A.CC&&0!==E?P.D.push([F+t.I/2+E*t.I/2,I+s],[F+t.I/2-E*t.I/2,I+s]):P.D.push([F+t.I/2,I+s]),P.D.push([P.D[0][0],P.D[0][1]]),t.setNodeData({points:P.D}),P.iX=F,P.iY=I,P.locate(2)}P.Z=t.A.CP("bl",1),P.C7=t.A.CP("bl",0),t.paintPreview(M,H);var N=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area";P.DH=N;var S=ZC._c_(t.A.o.tolerance,5),O=function(){if("undefined"!=typeof t.paint_&&t.paint_(),t.N3(ZC.Q.EB(P.Z,t.H.AB)),ZC.AR._boxoverlap2_(t,t.C.P,S)&&t.A.G0&&-1===ZC.AV(t.H.KQ,"skip_segment_tracking")){var e=x<5?.5:-.5,i=r<3?.5:-.5,n=ZC.Q.FW("rect",t.A.EA,P.IP)+'class="'+N+'" '+t.a11y()+' id="'+t.K+'" coords="'+ZC._i_(F+t.A.BL+ZC.MAPTX-e)+","+ZC._i_(I+t.A.BH+ZC.MAPTX-i)+","+ZC._i_(F+t.A.BL+x+ZC.MAPTX+e)+","+ZC._i_(I+t.A.BH+r+ZC.MAPTX+i)+'" />';t.A.A.HF.push(n)}t.A.U&&t.A.U.AN&&t.GW()};if(t.A.GD&&!t.C.HH){var G=P,k={};G.iX=F,G.iY=I,G.I=x,G.F=r,k.x=F,k.y=I,k.width=x,k.height=r;var T,z=t.A.L7,Q=t.C.P;for(T in G.C6=0,k.alpha=M.C6,2===z?(G.iY=Q.iY+Q.F/2,G.F=1,k.height=t.F,k.y=I):3===z?(G.iY=Q.iY,G.F=1,k.height=t.F,k.y=I):4===z?(G.iY=Q.iY+Q.F,G.F=1,k.height=t.F,k.y=I):5===z?(G.iX=Q.iX,G.I=1,k.width=t.I,k.x=F):6===z?(G.iX=Q.iX+Q.I,G.I=1,k.width=t.I,k.x=F):7===z?(G.iX=Q.iX+Q.I/2,G.I=1,k.width=t.I,k.x=F):8===z?(G.iX=F-Q.I,k.x=F):9===z?(G.iX=F+Q.I,k.x=F):10===z?(G.iY=I-Q.F,k.y=I):11===z?(G.iY=I+Q.F,k.y=I):12===z?(G.I=1,k.width=t.I):13===z&&(G.F=1,k.height=t.F),t.A.FV)G[ZC.E4.GO[ZC.EE(T)]]=t.A.FV[T],k[ZC.EE(T)]=M[ZC.E4.GO[ZC.EE(T)]];if(null===ZC._n_(t.C.EN)&&(t.C.EN={}),null!==ZC._n_(t.C.EN[t.A.L+"-"+t.L]))for(T in t.C.EN[t.A.L+"-"+t.L])G[ZC.E4.GO[ZC.EE(T)]]=t.C.EN[t.A.L+"-"+t.L][T];if(t.C.EN[t.A.L+"-"+t.L]={},ZC._cp_(k,t.C.EN[t.A.L+"-"+t.L]),ZC.AR._boxoverlap2_(t,t.C.P,S)){var J=new ZC.E4(G,k,t.A.JG,t.A.L6,ZC.E4.RK[t.A.L8],function(){O()});J.AX=t,J.OC=function(){t.N3(ZC.Q.EB(P.Z,t.H.AB))},t.LO(J)}}else{if(P.AN||0===t.A.E7.length&&!t.A.HT)if(t.A.WA||(t.A.WA={iX:P.iX,iY:P.iY,F:P.F}),t.A.A2L)if(t.A.SC)if(t.A.SC.el&&"RECT"===t.A.SC.el.tagName.toUpperCase()){var V=!1;if(t.A.MZ&&t.A.WA&&ZC._a_(P.iX-t.A.WA.iX)<.75&&ZC._a_(P.iY-t.A.WA.iY)<1.5&&ZC._a_(P.F-t.A.WA.F)<1.5&&(V=!0),!V){t.A.WA={iX:P.iX,iY:P.iY,F:P.F};var R=t.A.SC.el.cloneNode(!1);R.setAttribute("id",t.K),R.setAttribute("x",t.iX),R.setAttribute("y",t.iY),R.setAttribute("height",t.F),t.A.SC.df?t.H.G1[P.Z.id].appendChild(R):t.A.SC.el.parentNode.appendChild(R)}}else P.paint();else P.paint(),t.A.SC={id:P.K+"-path"},zingchart.DEV.DOMFRAGMENTS&&document.querySelector&&t.H.G1&&t.H.G1[P.Z.id]?(t.A.SC.df=!0,t.A.SC.el=t.H.G1[P.Z.id].querySelector("#"+P.K+"-path")):(t.A.SC.df=!1,t.A.SC.el=ZC.AL(t.A.SC.id));else ZC.AR._boxoverlap2_(t,t.C.P,S)&&P.paint();P.AN&&O()}"svg"===t.H.AB&&t.A.applyJsRuleSvg(t.A,t.K+"-path",t.LY()),0!==t.A.E7.length||t.A.HT||"undefined"!=typeof t.A.TL||t.O.o.override||t.C.KI||t.A.GD||(t.A.TL=P)}}}},paintPreview:function(e,i){var t,n,a=this;if(a.C.B9&&a.C.B9.I2&&a.A.QN){var l=a.C.P,o=a.C.B9,r=o.AQ,s=(a.iX-l.iX)/l.I,A=(a.iY-l.iY)/l.F;a.A.WC?t=a.A.WC:(t=new ZC.HL(a.A),a.A.WC=t,t.copy(e),(n=a.A.o["preview-state"])&&(t.append(n),t.parse())),i||(t.copy(e),(n=a.A.o["preview-state"])&&(t.append(n),t.parse())),t.K=a.K+"-preview",t.DH=a.A.K+"-preview",t.iX=r.iX+r.AU+s*(r.I-2*r.AU),t.iY=r.iY+r.AU+A*(r.F-2*r.AU),t.I=a.I/l.I*(r.I-2*r.AU),t.F=a.F/l.F*(r.F-2*r.AU),r.I/a.A.S.length<10?(t.I=t.I+.5,t.N5=!1,t.CZ=!1):(t.N5=!0,t.CZ=!0),t.Z=t.C7=o.Z,t.paint()}},A0W:function(e){var i=this;if(e=e||"hover",!ZC.move){var t="";switch(i.A.CW){default:t="box";break;case"pyramid":t="shape"}i.M5({layer:e,type:t,initcb:function(){this.A0=i.A.BP[3],this.B7=i.A.BP[1],this.BW=i.A.BP[1],this.AE=i.A.BP[2]},setupcb:function(){switch(i.A.CW){default:this.iX=i.getNodeData("x"),this.iY=i.getNodeData("y"),this.I=i.getNodeData("w"),this.F=i.getNodeData("h");var e=i.C.P;this.iY<e.iY&&(this.F=this.F-(e.iY-this.iY),this.iY=e.iY),this.iY+this.F>e.iY+e.F&&(this.F=e.iY+e.F-this.iY);break;case"pyramid":case"cone":this.D=i.getNodeData("points")}}}),i.N3(ZC.Q.EB(i.C.K+"-hover-c",i.H.AB),!0),i.A.RJ=null}}}),ZC.ZA=ZC.LE.CA({setup:function(){this.T7()},UU:function(){var e=this;e.paint(!0);var i=e.C.BM(e.A.BU("v")[0]);return[e.iX+(i.AW?0:e.I),e.iY+e.F/2,{reference:e,center:!0}]},AC8:function(e){var i=this,t="top-out",n=i.C.BM(i.A.BU("v")[0]),a=i.AD>=n.H8&&!n.AW||i.AD<n.H8&&n.AW?-1:1;null!==ZC._n_(e.o.placement)&&(t=e.o.placement);var l=e.I,o=e.F,r=i.iXVal-l/2,s=i.iY+i.F/2-o/2,A=e.A9%180==90?o/2:l/2;switch(t){case"top-out":case"top":r-=a*(A+5);break;case"top-in":r+=a*(A+5);break;case"middle":r+=a*(i.I/2);break;case"bottom-in":r+=a*(i.I-A-5);break;case"bottom-out":case"bottom":r+=a*(i.I+A+5)}if(null!==ZC._n_(e.o.x)||null!==ZC._n_(e.o.y))null!==ZC._n_(e.o.x)&&(r=e.iX),null!==ZC._n_(e.o.y)&&(s=e.iY);else{var C=ZC._c_(i.A.o.tolerance,5);if(!ZC.AR._boxoverlap2_(i,i.C.P,C))return[-1,-1]}var c=e.o.tolerance||[i.C.P.E8,i.C.P.E9,i.C.P.DR,i.C.P.DY];return i.C.AJ["3d"]||(r=ZC.BQ(i.C.P.iX+5-c[3],r),r=ZC.CY(i.C.P.iX+i.C.P.I-l-5+c[1],r),s=ZC.BQ(i.C.P.iY+0-c[0],s),s=ZC.CY(i.C.P.iY+i.C.P.F-o/2-0+c[2],s)),[ZC._i_(r),ZC._i_(s)]},paint:function(e){var i=this;if(i.b(),!i.C.AJ["3d"]){void 0===e&&(e=!1);var t=i.A.B1,n=i.A.CM;i.setup();var a,l,o,r,s,A=i.A.SO(),C=A.AA,c=A.ET,u=A.CF,p=A.CT,Z=A.F4,h=A.D3,d=A.F0;if(e?c=i.A.E["node-"+i.L+"-bar-index"]:i.A.E["node-"+i.L+"-bar-index"]=A.ET,i.A.CC){a=0;for(var f=i.A.A.KA[c],_=0;_<f.length;_++){var g=i.A.A.A5[f[_]].S[i.L];g&&(a+=g.AD)}}var v=1,b=1;if(i.A.CC&&(i.CS!==i.AD&&(v=(a-i.CS+i.AD)/a),b=(a-i.CS)/a),n.AW){var B=v;v=b,b=B}i.A.LN&&(c=i.L);var m=i.iY-C/2+u+c*(h+Z)-c*d;if(m=ZC._l_(m,i.iY-C/2+u,i.iY+C/2-p),i.A.D3>0){var E=h;(h=i.A.D3)<=1&&(h*=E),m+=(E-h)/2}var D=h,F=i.iX,K=null!==ZC._n_(i.A.LX[i.L])?i.A.LX[i.L]:0;if(F=i.A.CC&&"100%"===i.A.KR?n.AT(100*(i.CS+K)/i.A.A.F8[i.L]["%total-"+i.A.DZ]):n.AT(i.CS+K),i.A.CC){l="100%"===i.A.KR?n.AT(100*(i.CS-i.AD+K)/i.A.A.F8[i.L]["%total-"+i.A.DZ]):n.AT(i.CS-i.AD+K),F=ZC._i_(F),l=ZC._i_(l);var x=!n.AW&&i.AD>=0||n.AW&&i.AD<=0?1:-1,I=0,y=0;""!==i.A.OJ?(I=i.WH(i.A.OJ)[0],y=0):I=i.A.AU,""!==i.A.P4?(y=i.WH(i.A.P4)[0],I=0):y=i.A.AU,I!==y&&(x=0),o=F-l+x*I,i.AD>0?F=l:o=ZC._a_(o),n.AW?o>0?(o=ZC._a_(o),F=l):(o=ZC._a_(o),F-=o):o<0&&(o=ZC._a_(o),F=l-o)}else l=n.AT(K),(o=F-l)<0?(o=ZC._a_(o),F=l-o):F=l;if(i.A.TK&&i.A.CC&&i.A.L>0&&i.A.A.A5[i.A.L-1].S[i.L]&&0===i.A.A.A5[i.A.L-1].S[i.L].AD&&(o-=1,F+=n.AW?-1:1),o<1&&(i.AD>0||i.A.TK)&&(o=1,n.AW?i.A.CC?0===i.A.L&&(F-=1):F-=2:i.A.L>0&&i.A.CC&&(F-=1)),i.I=o,i.F=D,i.iX=F,i.iY=m,n.AW?i.AD>=n.H8?i.iXVal=F:i.iXVal=F+i.I:i.AD>=n.H8?i.iXVal=F+i.I:i.iXVal=F,!e){var w;i.setNodeData({x:F,y:m,w:o,h:D});var L=!0;if("none"!==i.A.J0||i.C.IX[i.A.L]||i.C.KI||i.A.T0&&i.A.T0[i.L]?(w=i.O=i.A.ID(i,i.O),L=!1):w=i.O,(0!==i.A.E7.length||i.A.HT||i.O.o.override||i.C.KI)&&(L=!1),i.AN){var X;switch(i.A.CW){default:0!==i.A.E7.length||i.A.HT||"undefined"==typeof i.A.TL||i.O.o.override||i.C.KI?(X=new ZC.HL(i.A)).copy(w):X=i.A.TL,i.A.HT&&(i.H3(X),X.parse()),X.FD=i.A.FD,X.K=i.K,X.iX=F,X.iY=m,X.I=i.I,X.F=i.F,t.AA<5&&X.F<5?(X.F=ZC.BQ(1,X.F)+1,X.N5=!1,X.CZ=!1):X.N5=!0,X.F<5&&t.A1!==t.W&&i.C.P.F/(t.A1-t.W)<1&&(X.QP=!0);break;case"pyramid":case"cone":0!==i.A.E7.length||i.A.HT||"undefined"==typeof i.A.TL||i.O.o.override||i.C.KI?(X=new ZC.DT(i.A)).copy(w):X=i.A.TL,i.A.HT&&(i.H3(X),X.parse()),X.K=i.K,n.AW&&!i.A.CC?(s=i.AD>=0?i.I:0,r=i.AD>=0?0:i.I):(s=i.AD>=0?0:i.I,r=i.AD>=0?i.I:0),X.D=[],X.D.push([F+s,m+i.F/2-v*i.F/2],[F+s,m+i.F/2+v*i.F/2]),i.A.CC&&0!==b?X.D.push([F+r,m+i.F/2+b*i.F/2],[F+r,m+i.F/2-b*i.F/2]):X.D.push([F+r,m+i.F/2]),X.D.push([X.D[0][0],X.D[0][1]]),i.E.points=X.D,X.iX=F,X.iY=m,X.locate(2)}X.Z=i.A.CP("bl",1),X.C7=i.A.CP("bl",0),i.paintPreview(w,L);var Y=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area";X.DH=Y;var M=ZC._c_(i.A.o.tolerance,5),H=function(){if("undefined"!=typeof i.paint_&&i.paint_(),i.N3(ZC.Q.EB(X.Z,i.H.AB)),ZC.AR._boxoverlap2_(i,i.C.P,M)&&i.A.G0&&-1===ZC.AV(i.H.KQ,"skip_segment_tracking")){var e=o<3?.5:-.5,t=D<5?.5:-.5,n=ZC.Q.FW("rect",i.A.EA,X.IP)+'class="'+Y+'" '+i.a11y()+' id="'+i.K+'" coords="'+ZC._i_(F+i.A.BL+ZC.MAPTX-e)+","+ZC._i_(m+i.A.BH+ZC.MAPTX-t)+","+ZC._i_(F+i.A.BL+o+ZC.MAPTX+e)+","+ZC._i_(m+i.A.BH+D+ZC.MAPTX+t)+'" />';i.A.A.HF.push(n)}i.A.U&&i.A.U.AN&&i.GW()};if(i.A.GD&&!i.C.HH){var P=X,N={};P.iX=F,P.iY=m,P.I=o,P.F=D,N.x=F,N.y=m,N.width=o,N.height=D;var S,O=i.A.L7,G=i.C.P;for(S in P.C6=0,N.alpha=w.C6,2===O?(P.iX=G.iX+G.I/2,P.I=1,N.width=i.I,N.x=F):3===O?(P.iX=G.iX+G.I,P.I=1,N.width=i.I,N.x=F):4===O?(P.iX=G.iX,P.I=1,N.width=i.I,N.x=F):5===O?(P.iY=G.iY+G.F,P.F=1,N.height=i.F,N.y=m):6===O?(P.iY=G.iY,P.F=1,N.height=i.F,N.y=m):7===O?(P.iY=G.iY+G.F/2,P.F=1,N.height=i.F,N.y=m):8===O?(P.iY=m+G.F,N.y=m):9===O?(P.iY=m-G.F,N.y=m):10===O?(P.iX=F+G.I,N.x=F):11===O?(P.iX=F-G.I,N.x=F):12===O?(P.F=1,N.height=i.F):13===O&&(P.I=1,N.width=i.I),i.A.FV)P[ZC.E4.GO[ZC.EE(S)]]=i.A.FV[S],N[ZC.EE(S)]=i.O[ZC.E4.GO[ZC.EE(S)]];if(null===ZC._n_(i.C.EN)&&(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(S in i.C.EN[i.A.L+"-"+i.L])P[ZC.E4.GO[ZC.EE(S)]]=i.C.EN[i.A.L+"-"+i.L][S];if(i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(N,i.C.EN[i.A.L+"-"+i.L]),ZC.AR._boxoverlap2_(i,i.C.P,M)){var k=new ZC.E4(P,N,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){H()});k.AX=i,k.OC=function(){i.N3(ZC.Q.EB(X.Z,i.H.AB))},i.LO(k)}}else(X.AN||0===i.A.E7.length&&!i.A.HT)&&ZC.AR._boxoverlap2_(i,i.C.P,M)&&X.paint(),X.AN&&H();"svg"===i.H.AB&&i.A.applyJsRuleSvg(i.A,i.K+"-path",i.LY()),0!==i.A.E7.length||i.A.HT||"undefined"!=typeof i.A.TL||i.O.o.override||i.C.KI||i.A.GD||(i.A.TL=X)}}}},paintPreview:function(e,i){var t,n,a=this;if(a.C.B9&&a.C.B9.I2&&a.A.QN){var l=a.C.P,o=a.C.B9,r=o.AQ,s=(a.iX-l.iX)/l.I,A=(a.iY-l.iY)/l.F;a.A.WC?t=a.A.WC:(t=new ZC.HL(a.A),a.A.WC=t,t.copy(e),(n=a.A.o["preview-state"])&&(t.append(n),t.parse())),i||(t.copy(e),(n=a.A.o["preview-state"])&&(t.append(n),t.parse())),t.K=a.K+"-preview",t.DH=a.A.K+"-preview",t.iX=r.iX+r.AU+s*(r.I-2*r.AU),t.iY=r.iY+r.AU+A*(r.F-2*r.AU),t.I=a.I/l.I*(r.I-2*r.AU),t.F=a.F/l.F*(r.F-2*r.AU),r.I/a.A.S.length<10?(t.I=t.I+.5,t.N5=!1,t.CZ=!1):(t.N5=!0,t.CZ=!0),t.Z=t.C7=o.Z,t.paint()}},A0W:function(e){var i=this;if(!ZC.move){var t="";switch(i.A.CW){default:t="box";break;case"pyramid":t="shape"}i.M5({layer:e,type:t,initcb:function(){this.B7=i.A.BP[1],this.BW=i.A.BP[1],this.A0=i.A.BP[3],this.AE=i.A.BP[2]},setupcb:function(){switch(i.A.CW){default:this.iX=i.getNodeData("x"),this.iY=i.getNodeData("y"),this.I=i.getNodeData("w"),this.F=i.getNodeData("h");var e=i.C.P;this.iX<e.iX&&(this.I=this.I-(e.iX-this.iX),this.iX=e.iX),this.iX+this.I>e.iX+e.I&&(this.I=e.iX+e.I-this.iX);break;case"pyramid":case"cone":this.D=i.getNodeData("points")}}}),i.N3(ZC.Q.EB(i.C.K+"-hover-c",i.H.AB),!0),i.A.RJ=null}}}),ZC.A5O=ZC.LE.CA({setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];if(e.JP!==n){if("scatter"===e.A.AF){if(e.A.LN&&e.A.Q0){var a=ZC.AR.VS(e.A.Q0[0],e.A.Q0[1]),l=(e.BT-a[0])/(a[1]-a[0]);e.iX=i.IB(e.A.R8)-i.AA/2+e.A.RM+l*(i.AA-2*e.A.RM)}else e.iX=i.AT(e.BT);e.iY=t.AT(e.AD)}else e.iY=i.AT(e.BT),e.iX=t.AT(e.AD);e.JP=n}e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},parse:function(){this.b(),this.o.value instanceof Array||(this.BT=this.L)},ABF:function(){return{color:"-1"===this.A.A2.A0?this.O.A0:this.A.A2.A0}},getTooltipPosition:function(e,i){return this.b(e,i,this.NB.AI)},Y2:function(){return{"background-color":"-1"===this.A.A2.AE?this.O.AE:this.A.A2.AE,"border-color":"-1"===this.A.A2.AE?this.O.AE:this.A.A2.AE,color:this.O.C2}},paint:function(e){var i=this;i.b();var t=i.A.B1,n=i.A.CM;i.setup(),e||(t.CO?ZC.DS(i.iX,n.iX+(n.AW?n.BV:n.AC)-1,n.iX+n.I-(n.AW?n.AC:n.BV)+1)&&ZC.DS(i.iY,t.iY+(t.AW?t.BV:t.AC)-1,t.iY+t.F-(t.AW?t.AC:t.BV)+1)&&i.PA(!1,!0):ZC.DS(i.iX,t.iX+(t.AW?t.BV:t.AC)-1,t.iX+t.I-(t.AW?t.AC:t.BV)+1)&&ZC.DS(i.iY,n.iY+(n.AW?n.AC:n.BV)-1,n.iY+n.F-(n.AW?n.BV:n.AC)+1)&&i.PA(!1,!0))},A0W:function(e){ZC.move||this.TR(e)}}),ZC.A6W=ZC.LE.CA({$i:function(e){this.b(e),this.SP=null},parse:function(){this.b(),this.o.value instanceof Array||(this.BT=this.L),this.o.value instanceof Array&&null!==ZC._n_(this.o.value[2])?this.SP=ZC._f_(this.o.value[2]):this.SP=2},ABF:function(){return{color:"-1"===this.A.A2.A0?this.O.A0:this.A.A2.A0}},getTooltipPosition:function(e,i){var t=this.A.getSize(ZC._a_(this.SP));return this.b(e,i,t)},Y2:function(){return{"background-color":"-1"===this.A.A2.AE?this.O.AE:this.A.A2.AE,"border-color":"-1"===this.A.A2.AE?this.O.AE:this.A.A2.AE,color:this.O.C2}},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l);var o=ZC.AP.G2(a.SP,l);return a.CV=[["%v0",a.BT],["%v1",a.AD],["%v2",o],["%node-size-value",o]],e=a.b(e,i,t,n)},setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];if(e.JP!==n){if("bubble"===e.A.AF){if(e.A.LN&&e.A.Q0){var a=ZC.AR.VS(e.A.Q0[0],e.A.Q0[1]),l=(e.BT-a[0])/(a[1]-a[0]);e.iX=i.IB(e.A.R8)-i.AA/2+e.A.RM+l*(i.AA-2*e.A.RM)}else e.iX=i.AT(e.BT);e.iY=t.AT(e.AD)}else e.iY=i.AT(e.BT),e.iX=t.AT(e.AD);e.JP=n}e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},AC8:function(e){var i,t=this,n="auto";null!==ZC._n_(i=e.o.placement)&&(n=i);var a=e.I,l=e.F,o=t.E["marker.size"],r=t.iX-a/2,s=t.iY-l/2,A=0,C=0;switch(n){case"top":s-=l/2+o,C=t.iY-t.C.P.iY+o;break;case"bottom":s+=l/2+o,C=t.C.P.iY+t.C.P.F-t.iY+o;break;case"left":r-=a/2+o,A=t.iX-t.C.P.iX+o;break;case"right":r+=a/2+o,A=t.C.P.iX+t.C.P.I-t.iX+o}return null!==ZC._n_(e.o.x)&&(r=e.iX),null!==ZC._n_(e.o.y)&&(s=e.iY),r<t.C.P.iX&&(r=t.C.P.iX+A),r+a>t.C.P.iX+t.C.P.I&&(r=t.C.P.iX+t.C.P.I-a-A),s<t.C.P.iY&&(s=t.C.P.iY+C),s+l>t.C.P.iY+t.C.P.F&&(s=t.C.P.iY+t.C.P.F-l-C),[ZC._i_(r),ZC._i_(s)]},paint:function(e){var i=this;void 0===e&&(e=!1),i.b();var t=i.A.B1,n=i.A.CM;i.setup(),i.E["marker.size"]=i.A.getSize(ZC._a_(i.SP)),e||(t.CO?ZC.DS(i.iX,n.iX+(n.AW?n.BV:n.AC)-1,n.iX+n.I-(n.AW?n.AC:n.BV)+1)&&ZC.DS(i.iY,t.iY+(t.AW?t.BV:t.AC)-1,t.iY+t.F-(t.AW?t.AC:t.BV)+1)&&i.PA(!1,!0):ZC.DS(i.iX,t.iX+(t.AW?t.BV:t.AC)-1,t.iX+t.I-(t.AW?t.AC:t.BV)+1)&&ZC.DS(i.iY,n.iY+(n.AW?n.AC:n.BV)-1,n.iY+n.F-(n.AW?n.BV:n.AC)+1)&&i.PA(!1,!0))},A0W:function(e){ZC.move||this.TR(e)}}),ZC.A8O=ZC.LE.CA({bCXY:!0,U:null,$i:function(e){this.b(e)},parse:function(){this.b()},AB2:function(){this.b();var e=this.C.E;e.update.npv=e.update["node-percent-value"]=this.JT("%npv")},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l),-1===e.indexOf("%npv")&&-1===e.indexOf("%node-percent-value")||null!==ZC._n_(l.decimals)&&-1!==l.decimals||(l.decimals=1);var o=0,r="0";if(a.A.A.KL[a.L]>0&&(r=""+(o=100*a.AD/a.A.A.KL[a.L])),a.A.A.A5.length>1&&a.A.L===a.A.A.A5.length-1){var s=0;if(null===ZC._n_(a.A.o.totals)){for(var A=0;A<a.A.A.A5.length-1;A++)if(a.A.A.A5[A].AN&&null!==ZC._n_(a.A.A.A5[A].S[a.L])){var C=0,c="0";a.A.A.KL[a.L]>0&&(c=""+(C=100*a.A.A.A5[A].S[a.L].AD/a.A.A.KL[a.L])),null!==ZC._n_(l.decimals)&&(c=C.toFixed(ZC.BQ(0,ZC._i_(l.decimals)))),s+=ZC._f_(c)}r=""+(o=Math.max(0,100-s))}}null!==ZC._n_(l.decimals)&&(r=o.toFixed(ZC.BQ(0,ZC._i_(l.decimals))));var u,p=ZC._f_(a.A.A.KL[a.L]||"0");return u=ZC.AP.G2(p,l,a.A),a.CV=[["%node-percent-value",r],["%npv",r],["%pie-total-value",u]],e=a.b(e,i,t,n)},getTooltipPosition:function(e,i){var t,n,a,l=this,o=(l.B4+l.BK)/2%360;switch(i){case"out":n=(t=ZC.AR.BN(l.iX,l.iY,l.AI+l.DV+e.DV,o))[0]+l.BL,a=t[1]+l.BH,o>270&&o<=360?a-=e.F:o>90&&o<=180?n-=e.I:o>180&&o<=270&&(n-=e.I,a-=e.F);break;case"center":n=(t=ZC.AR.BN(l.iX,l.iY,l.CN+.5*(l.AI-l.CN)+l.DV,o))[0]+l.BL,a=t[1]+l.BH;break;default:n=l.iX+l.BL,a=l.iY+l.BH}return{x:n,y:a}},UU:function(e){var i,t=this,n=(t.B4+t.BK)/2%360,a=0;null!==ZC._n_(i=e["offset-r"])&&(a=ZC._f_(ZC._p_(i))),a<1&&(a*=t.AI);var l=ZC.AR.BN(t.iX,t.iY,t.CN+.6*(t.AI-t.CN)+t.DV+a,n);return[l[0],l[1],{reference:t,center:!0}]},ACE:function(){var e=this,i=(e.B4+e.BK)/2%360,t=ZC.AR.BN(e.iX,e.iY,e.CN+.5*(e.AI-e.CN)+e.DV,i);return[t[0],t[1]]},setup:function(){var e=this,i=e.C.BM(e.A.BU("k")[0]),t=e.L%i.H2,n=Math.floor(e.L/i.H2);e.iX=i.iX+t*i.GK+i.GK/2+i.BL,e.iY=i.iY+n*i.GE+i.GE/2+i.BH,e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},ABF:function(e){var i,t={},n="out";return null!==ZC._n_(i=e.o.placement)&&(n=i),t.color="out"===n?this.A0:this.C2,t},AC8:function(e){var i,t=this,n="out";null!==ZC._n_(i=e.o.placement)&&(n=i);var a,l,o,r,s,A=e.I,C=e.F,c=(t.B4+t.BK)/2%360,u=c;if("out"===n){c=u=t.A.A.YE["n"+t.L][t.A.L];var p=function(i,n){n<0&&(n=360+n),n%=360;var a=(s=ZC.AR.BN(t.iX,t.iY,i+t.DV+e.DV+20,n))[0]+e.BL-A/2,l=s[1]+e.BH-C/2;return n>=0&&n<=90||n>=270&&n<=360?a+=A/2+10:a-=A/2+10,[a,l]},Z=p(t.AI,u);a=Z[0],l=Z[1],t.U=e;var h={x:a,y:l,width:A,height:C},d=zingchart.DEV.SPREADTYPE;r=!0;for(var f=0,_=0,g=-1,v=0,b=0;r&&b<1024;){r=!1;for(var B=0,m=t.A.A.TH.length;B<m;B++)o=t.A.A.TH[B],(ZC.AR.XQ(h,o)||h.x+e.I>t.C.P.iX+t.C.P.I||h.x<t.C.P.iX||h.y+e.F>t.C.P.iY+t.C.P.F||h.y<t.C.P.iY)&&(r=!0,0===d?(f+=.4,g*=-1):1===d&&(_+=2),Z=p(t.AI+_,u+f*g),h.x=Z[0],h.y=Z[1],b++,++v>100&&(v=0,0===d?(f=0,_+=2):1===d&&(_=0,f+=.4,g*=-1)))}a=h.x,l=h.y,c=u+f,o={text:t.A.AM,x:h.x,y:h.y,width:A,height:C,plotindex:t.A.L,nodeindex:t.L},t.A.A.TH.push(o)}else if("in"===n||"radial"===n){var E=t.CN<30?.65:.5;a=(s=t.B4%360==t.BK%360?0===t.CN?[t.iX,t.iY]:ZC.AR.BN(t.iX,t.iY,t.CN+.3*(t.AI-t.CN)+t.DV+e.DV,270):ZC.AR.BN(t.iX,t.iY,t.CN+E*(t.AI-t.CN)+t.DV+e.DV,c))[0]-A/2+t.BL,l=s[1]-C/2+t.BH}else if(-1!==n.indexOf("fixed=")){var D=n.split(/=|;|,/),F=(t.AI+t.CN)/2,K=c;D[1]&&(F=(F=ZC.II(D[1],!0))>=-1&&F<=1||-1!==D[1].indexOf("%")?t.CN+t.DV+F*(t.AI-t.CN):t.CN+t.DV+F),D[2]&&(K=(K=ZC.II(D[2],!0))>=-1&&K<=1||-1!==D[2].indexOf("%")?t.B4+K*(t.BK-t.B4):t.B4+K),D[3]&&("+"===D[3].charAt(0)||"-"===D[3].charAt(0)?(K%=360,e.A9=K+ZC._f_(D[3]),e.A9>90&&e.A9<270&&(e.A9+=180)):e.A9=ZC._f_(D[3])),a=(s=ZC.AR.BN(t.iX,t.iY,F,K))[0]-A/2,l=s[1]-C/2}else"center"===n&&(a=t.iX-A/2+t.BL,l=t.iY-C/2+t.BH);return r&&(a=-9999,l=-9999,e.AN=!1),null!==ZC._n_(e.o.x)&&(a=e.iX),null!==ZC._n_(e.o.y)&&(l=e.iY),a>=-2&&(a=ZC._a_(a)),l>=-2&&(l=ZC._a_(l)),[ZC._i_(a),ZC._i_(l),c]},appendToValueBox:function(e){var i=this,t={};if("radial"===e.o.placement){var n=.9*ZC._a_(i.AI-i.CN),a=Math.PI*(i.AI+i.CN)*.9*ZC._a_(i.BK-i.B4)/360,l=ZC._i_(Math.max(n,a)/(.75*e.DI));if(null===ZC._n_(e.o.visible)?t.visible=1===i.A.A.A5.length||a>1.25*e.DI:t.visible=e.JB.visible,null===ZC._n_(e.o["max-chars"])&&(t["max-chars"]=l),null===ZC._n_(e.o.angle)){var o=(i.B4+i.BK)/2%360;i.A.A.A5.length>1?a>n?o>0&&o<180?o-=90:o+=90:o>90&&o<270&&(o+=180):o=0,t.angle=o}}return t},GW:function(e,i){var t,n=this,a=n.b(e,i);if(e)return a;if(n.AN&&a.AN&&null!==ZC._n_(a.AM)&&""!==a.AM){var l="out";if(null!==ZC._n_(t=a.o.placement)&&(l=t),"out"===l){var o=!0;if(null!==ZC._n_(t=a.o.connected)&&(o=ZC._b_(t)),o){var r=new ZC.DT(n.A);r.Z=r.C7=n.A.CP("bl",0),r.append(n.A.C3.o),r.K=n.K+"-connector",r.B7=n.A0,r.DU="line",r.D=[];var s=a.E.positioninfo,A=(n.B4+n.BK)/2%360,C=ZC.AR.BN(n.iX,n.iY,n.AI+n.DV,A);C[0]+=n.BL,C[1]+=n.BH,r.D.push(C);var c=ZC.AR.BN(n.iX,n.iY,n.AI+n.DV+10,A);c[0]+=n.BL,c[1]+=n.BH,a.iX>=n.iX?"vml"===n.H.AB?r.D.push([s[0],s[1]+a.F/2]):r.D.push([c[0],c[1],s[0],s[1]+a.F/2]):"vml"===n.H.AB?r.D.push([s[0]+a.I+2,s[1]+a.F/2]):r.D.push([c[0],c[1],s[0]+a.I+2,s[1]+a.F/2]),r.parse(),r.J2=function(e){return n.J2(e)},r.DE()&&r.parse(),r.AN&&r.paint()}}}},paint:function(){var e,i=this;if(i.b(),!(i.AD<0)){var t=i.C.BM(i.A.BU("k")[0]);i.setup();var n="pie-sel-"+i.A.L+"-"+i.L;if(i.o.detached&&"undefined"==typeof i.C.E[n]&&(i.C.E[n]=!0),i.AI=ZC.CY(t.GE,t.GK)/2,null!==ZC._n_(i.A.o.size)){var a=ZC.II(i.A.o.size,!1);i.AI=a<=1?i.AI*a:a}else i.AI=t.JD*i.AI;i.CN<=1&&(i.CN*=i.AI),i.CN=Math.max(0,i.CN),i.o.slice=i.CN,i.DV<=1&&(i.DV*=i.AI),i.o["offset-r"]=i.DV,i.C.E[n]&&(i.DV+=ZC._i_(.15*i.AI));var l=i.O=i.A.ID(i,i);if(i.H3(l),i.AD>=0||0===i.A.A.KL[i.L]){var o=new ZC.DT(i.A);o.K=i.K,o.Z=i.A.CP("bl",1),o.C7=i.A.CP("bl",0),o.copy(l);var r=i.iX,s=i.iY;i.DV>0&&(r=(e=ZC.AR.BN(i.iX,i.iY,i.DV,(i.B4+i.BK)/2))[0],s=e[1]),o.iX=r,o.iY=s,o.AI=i.AI,o.o.size=i.AI,o.DU="pie",o.B4=ZC._f_(i.B4),o.BK=ZC._f_(i.BK),o.CN=i.CN,o.E.plotidx=i.A.L,o.E.nodeidx=i.L,o.parse(),i.G4=o;var A=function(){if(!i.A.K9&&i.AN){var e=o.FF(),t=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",n=ZC.Q.FW("poly",i.A.EA,i.A.IP)+'class="'+t+'" '+i.a11y()+' id="'+i.K+'" coords="'+e+'" />';i.A.A.HF.push(n)}i.A.U&&i.GW()};if(i.AN)if(i.A.GD&&!i.C.HH){var C=o,c={};C.iX=r,C.iY=s,C.B4=i.B4,C.BK=i.BK,c.angleStart=i.B4,c.angleEnd=i.BK,c.x=r,c.y=s;var u,p=i.A.L7;for(u in C.C6=0,c.alpha=l.C6,2===p?(C.BK=i.B4,c.angleEnd=i.BK):3===p?(C.AI=i.CN,c.size=i.AI):4===p?(e=ZC.AR.BN(i.iX,i.iY,1.2*i.AI,(i.B4+i.BK)/2),C.iX=e[0],C.iY=e[1],c.x=r,c.y=s):5===p&&(C.B4=C.BK=(i.B4+i.BK)/2,c.angleStart=i.B4,c.angleEnd=i.BK),i.A.FV)C[ZC.E4.GO[ZC.EE(u)]]=i.A.FV[u],c[ZC.EE(u)]=l[ZC.E4.GO[ZC.EE(u)]];if(null===ZC._n_(i.C.EN)&&(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(u in i.C.EN[i.A.L+"-"+i.L])C[ZC.E4.GO[ZC.EE(u)]]=i.C.EN[i.A.L+"-"+i.L][u];i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(c,i.C.EN[i.A.L+"-"+i.L]);var Z=new ZC.E4(C,c,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){A()});Z.AX=i,i.LO(Z)}else o.paint(),A()}else i.A.U&&i.GW()}},A0W:function(e){var i=this;ZC.move||i.M5({layer:e,type:"shape",initcb:function(){if(this.copy(i),this.iX=i.iX,this.iY=i.iY,i.DV>0){var e=ZC.AR.BN(i.iX,i.iY,i.DV,(i.B4+i.BK)/2);this.iX=e[0],this.iY=e[1]}this.AI=i.AI,this.DU="pie",this.A0=i.A.BP[3],this.AE=i.A.BP[2],this.B4=ZC._f_(i.B4),this.BK=ZC._f_(i.BK),this.CN=i.CN},parsecb:function(){this.o.size=i.AI,this.o.slice=i.CN,this.o["offset-r"]=i.DV}})},X6:function(e,i){var t=this;if(t.b(e,i),"click"===i&&e.which<=1&&t.A.A7O){zingchart.SKIP.ANIMATION=!0,zingchart.SKIP.EVENT=!0;var n="pie-sel-"+t.A.L+"-"+t.L;t.C.E[n]="undefined"==typeof t.C.E[n]||!t.C.E[n],t.C.K6(),zingchart.SKIP.EVENT=!1,zingchart.SKIP.ANIMATION=!1}}}),ZC.A49=ZC.LE.CA({bCXY:!0,$i:function(e){this.b(e)},setup:function(){var e=this,i=e.C.BM(e.A.BU("k")[0]);e.iX=i.iX+i.I/2+i.BL,e.iY=i.iY+i.F/2+i.BH,e.I2||(e.copy(e.A),e.o.slice=null,e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},ACE:function(){var e=this,i=(e.B4+e.BK)/2%360,t=ZC.AR.BN(e.iX,e.iY,e.CN+e.E.bandwidth/2+e.DV,i);return[t[0],t[1]]},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l);var o=100*a.AD/a.A.A.KL[a.L],r=""+o;return null!==ZC._n_(l.decimals)&&(r=o.toFixed(ZC.BQ(0,ZC._i_(l.decimals)))),a.CV=[["%node-percent-value",r],["%npv",r]],e=a.b(e,i,t,n)},ABF:function(e){var i={},t="in";return null!==ZC._n_(e.o.placement)&&(t=e.o.placement),i.color="out"===t?this.A0:this.C2,i},AC8:function(e){var i=this,t="in";null!==ZC._n_(e.o.placement)&&(t=e.o.placement);var n,a,l,o=e.I,r=e.F,s=(i.B4+i.BK)/2%360;return"out"===t?i.L===i.A.S.length-1?(l=ZC.AR.BN(i.iX,i.iY,i.A.U1+i.A.S.length*(i.E.bandwidth+i.E.bandspace)+15+e.DV,s),n=s>=0&&s<90||s>=270&&s<360?l[0]+10+i.BL:l[0]-o-10+i.BL,a=l[1]-r/2+i.BH):(n=-1,a=-1):(n=(l=ZC.AR.BN(i.iX,i.iY,i.CN+i.E.bandwidth/2+e.DV,s))[0]-o/2+i.BL,a=l[1]-r/2+i.BH),null!==ZC._n_(e.o.x)&&(n=e.iX),null!==ZC._n_(e.o.y)&&(a=e.iY),[ZC._i_(n),ZC._i_(a),s]},GW:function(e){var i=this,t=i.b(e);if(e)return t;if(t.AN&&null!==ZC._n_(t.AM)&&""!==t.AM){var n="in";if(null!==ZC._n_(t.o.placement)&&(n=t.o.placement),"out"===n&&i.L===i.A.S.length-1){var a=new ZC.DT(i.A);a.Z=a.C7=i.H.usc()?i.H.mc("top"):i.C.AJ["3d"]||i.H.K9?ZC.AL(i.C.K+"-plots-vb-c"):ZC.AL(i.C.K+"-plot-"+i.A.L+"-vb-c"),a.append(i.A.C3.o),a.B7=i.A0,a.DU="line",a.D=[];var l=(i.B4+i.BK)/2%360,o=ZC.AR.BN(i.iX,i.iY,i.CN+i.E.bandwidth+t.DV,l),r=ZC.AR.BN(i.iX,i.iY,i.A.U1+i.A.S.length*(i.E.bandwidth+i.E.bandspace)+15+t.DV,l);o[0]+=i.BL,r[0]+=i.BL,o[1]+=i.BH,r[1]+=i.BH,a.D.push(o),l>=0&&l<90||l>=270&&l<360?a.D.push([r[0],r[1],r[0]+10,r[1]]):a.D.push([r[0],r[1],r[0]-10,r[1]]),a.parse(),a.J2=function(e){return i.J2(e)},a.DE()&&a.parse(),a.AN&&a.paint()}}},paint:function(){var e,i=this;i.b();var t=i.C.BM(i.A.BU("k")[0]);i.setup(),i.AI=ZC.CY(t.I,t.F)/2,i.AI=t.JD*i.AI,i.CN=i.A.U1,i.CN<1&&(i.CN=i.A.U1*i.AI);var n=i.A.SK;n<1&&(n=i.A.SK*i.AI);var a=2,l=i.AI-i.CN;if(null!==ZC._n_(i.A.aBandWidths)&&null!==ZC._n_(i.A.aBandWidths[i.L])){(a=ZC._f_(i.A.aBandWidths[i.L]))>1&&(a/=100),a=ZC._i_(l*a),a=ZC.BQ(a,2);for(var o=0,r=0;r<i.L;r++)o+=ZC._f_(i.A.aBandWidths[r]);o>1&&(o/=100),o=ZC._i_(l*o),i.CN+=o,i.AI=i.CN+a}else a=(l-(i.A.S.length-1)*n)/i.A.S.length,a=ZC.BQ(a,2),i.CN+=i.L*(a+n),i.AI=i.CN+a;var s=i.O=i.A.ID(i,i);i.H3(s);var A=new ZC.DT(i.A);A.K=i.K,A.Z=i.A.CP("bl",1),A.C7=i.A.CP("bl",0),A.copy(s),A.iX=i.iX,A.iY=i.iY,A.DU="pie",A.B4=i.B4,A.BK=i.BK,A.CN=i.CN,A.AI=i.AI,A.parse();var C=A.CN;function c(){var e=A.FF(),t=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",n=ZC.Q.FW("poly",i.A.EA,i.A.IP)+'class="'+t+'" '+i.a11y()+' id="'+i.K+'" coords="'+e+'" />';i.A.A.HF.push(n),i.A.U&&i.A.U.AN&&i.GW()}if(i.E.bandwidth=a,i.E.bandspace=n,i.A.GD&&!i.C.HH){var u=A,p={};u.B4=i.B4,u.BK=i.BK,p.angleStart=i.B4,p.angleEnd=i.BK;var Z=i.A.L7;if(u.C6=0,p.alpha=s.C6,2===Z)u.BK=i.B4,p.angleEnd=i.BK;else if(3===Z)u.CN=C+i.E.bandwidth,p.slice=C;else if(4===Z){var h=ZC.AR.BN(i.iX,i.iY,i.AI,(i.B4+i.BK)/2);u.iX=h[0],u.iY=h[1],p.x=i.iX,p.y=i.iY}else 5===Z&&(u.B4=u.BK=(i.B4+i.BK)/2,p.angleStart=i.B4,p.angleEnd=i.BK);for(e in i.A.FV)u[ZC.E4.GO[ZC.EE(e)]]=i.A.FV[e],p[ZC.EE(e)]=s[ZC.E4.GO[ZC.EE(e)]];if(i.C.EN||(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(e in i.C.EN[i.A.L+"-"+i.L])u[ZC.E4.GO[ZC.EE(e)]]=i.C.EN[i.A.L+"-"+i.L][e];i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(p,i.C.EN[i.A.L+"-"+i.L]);var d=new ZC.E4(u,p,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){c()});d.AX=i,i.LO(d)}else A.paint(),c()},A0W:function(e){var i=this;ZC.move||i.M5({layer:e,type:"shape",initcb:function(){this.copy(i),this.iX=i.iX,this.iY=i.iY,this.DU="pie",this.A0=i.A.BP[3],this.AE=i.A.BP[2],this.B4=i.B4,this.BK=i.BK,this.CN=i.CN,this.AI=i.AI},parsecb:function(){this.o.slice=null}})}}),ZC.A72=ZC.LE.CA({$i:function(e){this.b(e);var i=this;i.CD=null,i.CJ=null,i.MM="max"},JT:function(e,i,t,n){var a=this;return"range"===a.A.CW&&(a.CV=[["%node-min-value",a.CD],["%node-max-value",a.CJ]]),e=a.b(e,i,t,n)},A9T:function(){var e=this;if("range"===e.A.CW&&e.o.value instanceof Array){var i=e.o.value.length;i>2&&(e.BT=ZC._f_(e.o.value[0])),e.CD=ZC._f_(e.o.value[i-2]),e.CJ=ZC._f_(e.o.value[i-1]),e.AD=e.CS=e.CJ,e.DP.push(e.CD)}else e.b()},setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];if(e.JP!==n){var a;a="range"===e.A.CW?t.U4("min"===e.MM?e.CD:e.CJ):t.U4(e.CS);var l=null!==ZC._n_(e.BT),o=i.A7A(l?e.BT:e.L,a,l);e.iX=o[0],e.iY=o[1],e.JP=n}e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},AC8:function(e){var i,t=this,n=t.A.B1,a=t.A.CM,l=t.C.BM("scale"),o=l.iX+l.I/2,r=l.iY+l.F/2,s=e.I,A=e.F,C="out";null!==ZC._n_(e.o.placement)&&(C=e.o.placement);var c=1.15;switch(C){case"out":c=1.15;break;case"over":c=1;break;case"in":c=.85;break;case"middle":c=.5}var u,p,Z=n.EI/(n.V.length-(360===n.EI||n.DF?0:1)),h=a.U4(t.CS);switch(t.A.CW){case"matrix":case"piano":var d=(ZC.CY(l.I/2,l.F/2)*l.JD-a.AC)/t.A.A.A5.length;u=a.AC+t.A.L*d,p=a.AC+(t.A.L+1)*d,i=ZC.AR.BN(o,r,(u+p)/2*c+e.DV,n.DJ+(n.DF?Z/2:0)+t.L*Z);break;default:if(null!==ZC._n_(t.BT)){var f=n.DJ+n.EI*(t.BT-n.B3)/(n.BJ-n.B3);i=ZC.AR.BN(o,r,a.AC+h*c+e.DV,f)}else i=ZC.AR.BN(o,r,a.AC+h*c+e.DV,n.DJ+(n.DF?Z/2:0)+t.L*Z)}return i[0]-=s/2,i[1]-=A/2,null!==ZC._n_(e.o.x)&&(i[0]=e.iX),null!==ZC._n_(e.o.y)&&(i[1]=e.iY),[ZC._i_(i[0]),ZC._i_(i[1])]},ABF:function(){return{color:"rose"===this.A.CW?this.A0:this.B7}},Y2:function(){return{"background-color":"rose"===this.A.CW?this.A0:this.B7,"border-color":"rose"===this.A.CW?this.A0:this.B7,color:this.C2}},paint:function(){var e,i,t=this;t.b();var n,a,l=t.A.QC,o=t.A.A56,r=t.A.B1,s=t.A.CM,A=t.A.S;t.setup(),t.CZ=!1,t.C7=t.A.CP("bl",0);var C,c=[],u=[],p=[],Z=[],h="range"===t.A.CW;function d(){if(t.A.S0>=t.A.S.length&&t.A.Y3){var e=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area",i="",a="";-1!==ZC.AV(["line","area","range"],t.A.CW)?""!==(a="range"!==t.A.CW||t.A.XH?ZC.AR.PR(ZC.AR.Z0(t.E.points),4):ZC.AR.PR(u,4))&&(i=ZC.Q.FW("poly",t.A.EA,t.A.IP)+'class="'+e+'" '+t.a11y()+' id="'+t.K+'" coords="'+a+'" />'):-1!==ZC.AV(["rose","column","bar","matrix","piano"],t.A.CW)&&(a=n.FF(),i=ZC.Q.FW("poly",t.A.EA,t.A.IP)+'class="'+e+'" '+t.a11y()+' id="'+t.K+'" coords="'+a+'" data-z-sort="'+(t.A.A.A5.length-t.A.L)+'" />'),t.A.A.HF.push(i)}t.A.U&&t.A.E.vboxid!==t.K&&t.GW()}var f,_,g,v,b,B=t.O=t.A.ID(t,t);if(t.A.HT&&t.H3(B),-1!==ZC.AV(["line","area","range"],t.A.CW)){c=[],u=[],p=[],Z=[];var m=t.iX,E=t.iY,D=t.iX,F=t.iY;h&&(t.MM="max",t.setup(),m=t.iX,E=t.iY,t.MM="min",t.setup(),D=t.iX,F=t.iY),t.A.I3&&(t.A.D.push([m,E]),t.A.AH.push([m,E])),t.L>0?(C=A[t.L-1])&&(C.MM="max",C.setup(),a=ZC.AR.JU(C.iX,C.iY,m,E),c.push(a),u.push(a),h&&(C.MM="min",C.setup(),a=ZC.AR.JU(C.iX,C.iY,D,F),p.push(a),Z.push(a))):(C=A[t.A.S.length-1])&&(C.MM="max",C.setup(),a=ZC.AR.JU(C.iX,C.iY,m,E),c.push(a),u.push(a),h&&(C.MM="min",C.setup(),a=ZC.AR.JU(C.iX,C.iY,D,F),p.push(a),Z.push(a))),c.push([m,E]),u.push([m,E]),h&&(p.push([D,F]),Z.push([D,F])),t.L<t.A.S.length-1?(C=A[t.L+1])&&(C.MM="max",C.setup(),a=ZC.AR.JU(m,E,C.iX,C.iY),c.push(a),u.push(a),h&&(C.MM="min",C.setup(),a=ZC.AR.JU(D,F,C.iX,C.iY),p.push(a),Z.push(a))):(C=A[0])&&(C.MM="max",C.setup(),a=ZC.AR.JU(m,E,C.iX,C.iY),c.push(a),u.push(a),h&&(C.MM="min",C.setup(),a=ZC.AR.JU(D,F,C.iX,C.iY),p.push(a),Z.push(a))),ZC.CR.setup(l,B)}h&&(c.push(null),c=c.concat(p.reverse()),u=u.concat(Z.reverse()));var K,x,I,y,w,L,X,Y,M,H,P,N=t.C.P;if(f=t.C.BM("scale"),"area"!==t.A.CW&&"range"!==t.A.CW||(_=f.iX+f.I/2,g=f.iY+f.F/2,v=360/r.V.length,"area"===t.A.CW&&u.push([_,g]),t.A.I3||((b=new ZC.DT(t.A)).K=t.K+"-area",b.Z=t.A.CP("bl",0),b.copy(B),b.L4=!0,b.D=u,b.parse(),b.C6=t.A.HX,1===b.C6&&0===b.AU&&(b.A0=ZC.AP.QR(ZC.AP.G9(b.A0),20),b.AE=ZC.AP.QR(ZC.AP.G9(b.AE),20),b.AU=2,b.BW=b.A0),b.D1=[N.iX,N.iY,N.iX+N.I,N.iY+N.F],ZC.CR.setup(o,b))),t.E.points=c,t.E.pointsarea=u,t.setNodeData({points:c,pointsarea:u}),t.A.I3&&t.L===r.A1&&("area"===t.A.CW&&((b=new ZC.DT(t.A)).K=t.K+"-area",b.Z=t.A.CP("bl",0),b.copy(t.A),b.L4=!0,b.D=t.A.AH,b.parse(),b.C6=t.A.HX,b.D1=[N.iX,N.iY,N.iX+N.I,N.iY+N.F],b.paint()),"line"!==t.A.CW&&"area"!==t.A.CW&&"range"!==t.A.CW||(t.A.D[0]&&t.A.D.push([t.A.D[0][0],t.A.D[0][1]]),ZC.CR.paint(l,B,t.A.D))),-1!==ZC.AV(["dots","scatter","area","line"],t.A.CW))t.PA(!1,!0);else if(-1!==ZC.AV(["rose","column","bar","piano","matrix"],t.A.CW)){(n=new ZC.DT(t.A)).K=t.K+"-pie",n.copy(B),n.Z=t.A.CP("bl",1),n.C7=t.A.CP("bl",0),_=(f=t.C.BM("scale")).iX+f.I/2,g=f.iY+f.F/2;var S=.1*(v=r.EI/(r.V.length-(360===r.EI||r.DF?0:1)));t.A.CC||(S=.1*v+.4*v*t.A.L/t.A.A.A5.length),null!==ZC._n_(e=t.A.A65)&&(S=e<1?v*e:e),L=s.AC;var O=t.A.A;t.A.CC&&null!==ZC._n_(O.A2E["stack"+t.L])&&(L+=O.A2E["stack"+t.L]);var G=ZC._i_(s.U4(t.CS));if(t.A.CC&&(O.A2E["stack"+t.L]=G),null===ZC._n_(t.BT))I=r.DJ+t.L*v-v/2+S+(r.DF?v/2:0),y=r.DJ+(t.L+1)*v-v/2-S+(r.DF?v/2:0);else{var k=r.DJ+r.EI*(t.BT-r.B3)/(r.BJ-r.B3);I=k-v/2+S,y=k+v/2-S}if(w=G+s.AC,"piano"===t.A.CW||"matrix"===t.A.CW){var T=(ZC.CY(f.I/2,f.F/2)*f.JD-s.AC)/t.A.A.A5.length;w=s.AC+t.A.L*T,L=s.AC+(t.A.L+1)*T}t.setNodeData({x:_,y:g,sz:w,sl:L,as:I,ae:y}),n.iX=_,n.iY=g,n.DU="pie",n.B4=I,n.BK=y,n.AI=w,n.CN=L,n.parse(),n.J2=function(e){return t.J2(e)},n.DE()&&n.parse()}if(t.A.GD&&-1!==ZC.AV(["line","area","rose","column","bar","matrix","piano"],t.A.CW)){switch(t.A.CW){case"line":case"area":x={},(K=new ZC.DT(t)).copy(B),K.K=t.K,K.Z=t.A.CP("bl",1),K.C7=t.A.CP("bl",0),K.D=c,K.C6=0,x.alpha=B.C6,x.points=c;var z=[];"area"===t.A.CW&&(M={},X=[],(Y=b).D=u,Y.C6=0,M.points=u,M.alpha=t.A.HX);break;case"rose":case"column":case"bar":case"matrix":case"piano":x={},(K=n).iX=_,K.iY=g,K.B4=I,K.BK=y,K.C6=0,x.angleStart=I,x.angleEnd=y,x.x=_,x.y=g,x.size=w,x.alpha=B.C6}var Q,J=t.A.L7,V=t.C.P;switch(J){case 1:break;case 7:switch(t.A.CW){case"line":case"area":for(i=0;i<c.length;i++)z[i]=[c[i][0],V.iY+V.F/2];if(K.D=z,x.points=c,"area"===t.A.CW){for(i=0;i<u.length;i++)X[i]=[u[i][0],V.iY+V.F/2];Y.D=X,M.points=u}}break;case 2:switch(t.A.CW){case"line":case"area":for(i=0;i<c.length;i++)z[i]=[V.iX+V.I/2,c[i][1]];if(K.D=z,x.points=c,"area"===t.A.CW){for(i=0;i<u.length;i++)X[i]=[V.iX+V.I/2,u[i][1]];Y.D=X,M.points=u}break;case"rose":case"column":case"bar":case"matrix":case"piano":K.BK=I,x.angleEnd=y}break;case 3:switch(t.A.CW){case"line":case"area":for(i=0;i<c.length;i++)z[i]=[V.iX+V.I/2,V.iY+V.F/2];if(K.D=z,x.points=c,"area"===t.A.CW){for(i=0;i<u.length;i++)X[i]=[V.iX+V.I/2,V.iY+V.F/2];Y.D=X,M.points=u}break;case"rose":case"column":case"bar":case"matrix":case"piano":K.AI=s.AC,x.size=w}break;case 4:switch(t.A.CW){case"line":case"area":for(i=0;i<c.length;i++)H=V.iX+V.I/2-c[i][0],P=V.iY+V.F/2-c[i][1],z[i]=[V.iX+V.I/2-2.5*H,V.iY+V.F/2-2.5*P];if(K.D=z,x.points=c,"area"===t.A.CW){for(i=0;i<u.length;i++)H=V.iX+V.I/2-u[i][0],P=V.iY+V.F/2-u[i][1],X[i]=[V.iX+V.I/2-2.5*H,V.iY+V.F/2-2.5*P];Y.D=X,M.points=u}break;case"rose":case"column":case"bar":case"matrix":case"piano":K.AI=2*w,x.size=w}break;case 5:switch(t.A.CW){case"rose":case"column":case"bar":case"matrix":case"piano":K.B4=K.BK=(I+y)/2,x.angleStart=I,x.angleEnd=y}}for(Q in t.A.FV)K[ZC.E4.GO[ZC.EE(Q)]]=t.A.FV[Q],x[ZC.EE(Q)]=B[ZC.E4.GO[ZC.EE(Q)]];if(null===ZC._n_(t.C.EN)&&(t.C.EN={},"area"===t.A.CW&&(t.C.SS={})),null!==ZC._n_(t.C.EN[t.A.L+"-"+t.L])){for(Q in t.C.EN[t.A.L+"-"+t.L])K[ZC.E4.GO[ZC.EE(Q)]]=t.C.EN[t.A.L+"-"+t.L][Q];if("area"===t.A.CW)for(Q in t.C.SS[t.A.L+"-"+t.L])Y[ZC.E4.GO[ZC.EE(Q)]]=t.C.SS[t.A.L+"-"+t.L][Q]}t.C.EN[t.A.L+"-"+t.L]={},ZC._cp_(x,t.C.EN[t.A.L+"-"+t.L]),"area"===t.A.CW&&(t.C.SS[t.A.L+"-"+t.L]={},ZC._cp_(M,t.C.SS[t.A.L+"-"+t.L]));var R=new ZC.E4(K,x,t.A.JG,t.A.L6,ZC.E4.RK[t.A.L8],function(){d()});R.AX=t,-1!==ZC.AV(["line","area"],t.A.CW)&&(R.IK=l);var W=null;"area"===t.A.CW&&((W=new ZC.E4(Y,M,t.A.JG,t.A.L6,ZC.E4.RK[t.A.L8],function(){})).AX=t),t.LO(R,W)}else{switch(t.A.CW){case"line":case"area":case"range":t.A.I3||(ZC.CR.paint(l,B,c),"area"!==t.A.CW&&"range"!==t.A.CW||b.paint());break;case"rose":case"column":case"bar":case"matrix":case"piano":n.paint()}d()}},A0W:function(e){var i=this;ZC.move||(i.A.IE&&i.A.AN&&(-1!==ZC.AV(["line","area","range"],i.A.CW)?(i.A1F(e),"area"!==i.A.CW&&"range"!==i.A.CW||i.M5({layer:e,type:"area",initcb:function(){this.D=i.E.pointsarea},setupcb:function(){this.AZ=0,this.AU=0,this.C6=i.A.HX;var e=i.C.P;this.D1=[e.iX,e.iY,e.iX+e.I,e.iY+e.F]}})):-1!==ZC.AV(["rose","column","bar","matrix","piano"],i.A.CW)&&i.M5({layer:e,type:"shape",initcb:function(){this.copy(i),this.B7=i.A.BP[1],this.BW=i.A.BP[1],this.A0=i.A.BP[3],this.AE=i.A.BP[2],this.iX=i.getNodeData("x"),this.iY=i.getNodeData("y"),this.CN=i.getNodeData("sl"),this.B4=i.getNodeData("as"),this.BK=i.getNodeData("ae"),this.DU="pie",this.AI=i.getNodeData("sz")}})),-1!==ZC.AV(["dots","scatter","line"],i.A.CW)&&i.TR(e))}}),ZC.A5P=ZC.ZB.CA({$i:function(e){this.b(e),this.FJ=null},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l);var o=ZC.AP.G2(a.A.PT[a.L],l);return a.CV=[["%node-goal-value",o],["%g",o]],e=a.b(e,i,t,n)},AC8:function(e){var i=this;return"goal"===ZC._n_(e.o.placement)?[i.FJ.iX+i.FJ.I/2-e.I/2,i.FJ.iY-e.F]:i.b(e)},A9T:function(){var e,i=this;if(i.DP=[],i.CK=i.o.value,"string"==typeof i.o.value){var t=ZC.AV(i.A.CM.JM,i.o.value);-1!==t?i.AD=t:(i.A.CM.JM.push(i.o.value),i.AD=i.A.CM.JM.length-1)}else i.AD=ZC._f_(i.o.value);i.A.o.goals&&null!==ZC._n_(e=i.A.o.goals[i.L])&&i.DP.push(ZC._f_(e))},paint:function(){this.b()},paint_:function(){var e,i,t=this;if(null!==ZC._n_(t.A.PT[t.L])&&t.AN){var n=t.A.CM.AT(t.A.PT[t.L]);t.FJ=new ZC.HL(t.A),t.FJ.K=t.K+"-goal",t.FJ.copy(t.A.FJ),t.FJ.Z=t.A.CP("fl",0),t.FJ.C7=t.A.CP("fl",0),t.FJ.J2=function(e){return t.J2(e)},t.FJ.DE()&&t.FJ.parse(),null!==ZC._n_(e=t.FJ.o)&&null!==ZC._n_(e.styles)&&null!==ZC._n_(i=e.styles[t.L])&&("string"==typeof i?t.FJ.append({"background-color":i}):t.FJ.append(i),t.FJ.parse());var a=.2;if(null!==ZC._n_(e=t.FJ.o.extension)&&(a=ZC._f_(e)),t.FJ.iX=t.getNodeData("x")-t.I*a,t.FJ.I=t.I*(1+2*a),null===ZC._n_(t.A.FJ.o.height)&&(t.FJ.F=ZC.CY(5,t.C.P.F/30)),t.FJ.iY=n-t.FJ.F/2,t.FJ.AN){t.FJ.paint();var l=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area";t.A.A.HF.push(ZC.Q.FW("rect",t.A.EA,t.A.IP)+'class="'+l+'" id="'+t.K+'--goal" coords="'+ZC._i_(t.FJ.iX+t.A.BL+ZC.MAPTX)+","+ZC._i_(t.FJ.iY+t.A.BH+ZC.MAPTX)+","+ZC._i_(t.FJ.iX+t.A.BL+t.FJ.I+ZC.MAPTX)+","+ZC._i_(t.FJ.iY+t.A.BH+t.FJ.F+ZC.MAPTX)+'" />')}}},A0W:function(e){var i=this;if(!ZC.move&&(i.b(e),i.FJ&&i.FJ.AN)){var t=new ZC.HL(i.A);t.copy(i.FJ),t.Z=ZC.AL(i.C.K+"-hover-c"),t.M8=!1,t.iX=i.FJ.iX,t.iY=i.FJ.iY,t.paint()}}}),ZC.A5Q=ZC.ZA.CA({$i:function(e){this.b(e),this.FJ=null},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l);var o=ZC.AP.G2(a.A.PT[a.L],l);return a.CV=[["%node-goal-value",o],["%g",o]],e=a.b(e,i,t,n)},AC8:function(e){var i=this;return"goal"===ZC._n_(e.o.placement)?[i.FJ.iX+i.FJ.I,i.FJ.iY+i.FJ.F/2-e.F/2]:i.b(e)},A9T:function(){var e,i=this;if(i.DP=[],i.CK=i.o.value,"string"==typeof i.o.value){var t=ZC.AV(i.A.CM.JM,i.o.value);-1!==t?i.AD=t:(i.A.CM.JM.push(i.o.value),i.AD=i.A.CM.JM.length-1)}else i.AD=ZC._f_(i.o.value);i.A.o.goals&&null!==ZC._n_(e=i.A.o.goals[i.L])&&i.DP.push(ZC._f_(e))},paint:function(){this.b()},paint_:function(){var e,i,t=this;if(null!==ZC._n_(t.A.PT[t.L])&&t.AN){var n=t.A.CM.AT(t.A.PT[t.L]);t.FJ=new ZC.HL(t.A),t.FJ.K=t.K+"-goal",t.FJ.copy(t.A.FJ),t.FJ.Z=t.A.CP("fl",0),t.FJ.C7=t.A.CP("fl",0),t.FJ.J2=function(e){return t.J2(e)},t.FJ.DE()&&t.FJ.parse(),null!==ZC._n_(e=t.FJ.o)&&null!==ZC._n_(e.styles)&&null!==ZC._n_(i=e.styles[t.L])&&("string"==typeof i?t.FJ.append({"background-color":i}):t.FJ.append(i),t.FJ.parse());var a=.2;if(null!==ZC._n_(e=t.FJ.o.extension)&&(a=ZC._f_(e)),t.FJ.iY=t.getNodeData("y")-t.F*a,t.FJ.F=t.F*(1+2*a),null===ZC._n_(t.A.FJ.o.width)&&(t.FJ.I=ZC.CY(5,t.C.P.I/30)),t.FJ.iX=n-t.FJ.I/2,t.FJ.AN){t.FJ.paint();var l=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area";t.A.A.HF.push(ZC.Q.FW("rect",t.A.EA,t.A.IP)+'class="'+l+'" id="'+t.K+'--goal" coords="'+ZC._i_(t.FJ.iX+t.A.BL+ZC.MAPTX)+","+ZC._i_(t.FJ.iY+t.A.BH+ZC.MAPTX)+","+ZC._i_(t.FJ.iX+t.A.BL+t.FJ.I+ZC.MAPTX)+","+ZC._i_(t.FJ.iY+t.A.BH+t.FJ.F+ZC.MAPTX)+'" />')}}},A0W:function(e){var i=this;if(!ZC.move&&(i.b(e),i.FJ&&i.FJ.AN)){var t=new ZC.HL(i.A);t.copy(i.FJ),t.Z=ZC.AL(i.C.K+"-hover-c"),t.M8=!1,t.iX=i.FJ.iX,t.iY=i.FJ.iY,t.paint()}}}),ZC.A76=ZC.LE.CA({A9T:function(){var e,i=this;i.o.value instanceof Array&&null!==ZC._n_(i.o.value[1])&&(i.CK=i.o.value[1],"string"==typeof i.o.value[0]?-1!==(e=ZC.AV(i.A.B1.IT,i.o.value[0]))?i.BT=e:(i.A.B1.IT.push(i.o.value[0]),i.BT=i.A.B1.IT.length-1):i.BT=ZC._f_(i.o.value[0]),"string"==typeof i.o.value[1]?-1!==(e=ZC.AV(i.A.CM.JM,i.o.value[1]))?i.AD=e:(i.A.CM.JM.push(i.o.value[1]),i.AD=i.A.CM.JM.length-1):i.AD=ZC._f_(i.o.value[1]),null!==i.BT&&i.A.UW(i.BT,i.L))},setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];e.JP!==n&&(i.AW?e.iX=i.iX+i.I-i.AC-(e.L-i.W+1)*i.AA:e.iX=i.iX+i.AC+(e.L-i.W)*i.AA,t.AW?e.iY=t.iY+t.AC+(e.A.L-t.B3)*t.AA:e.iY=t.iY+t.F-t.AC-(e.A.L-t.B3+1)*t.AA,e.JP=n),e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0),e.H3(e)},AC8:function(e){var i=this,t="over";null!==ZC._n_(e.o.placement)&&(t=e.o.placement);var n=e.I,a=e.F,l=i.iX+i.I/2-n/2,o=i.iY+i.F/2-a/2;switch(t){case"top":o-=i.F/2+a/2+2;break;case"left":l-=i.I/2+n/2+2;break;case"bottom":o+=i.F/2+a/2+2;break;case"right":l+=i.I/2+n/2+2}return null!==ZC._n_(e.o.x)&&(l=e.iX),null!==ZC._n_(e.o.y)&&(o=e.iY),[ZC._i_(l),ZC._i_(o)]},ABF:function(){return{color:"#000"}},getFormatValue:function(){return this.CK},JT:function(e,i,t,n){var a,l=this,o=l.A.CM,r=l.A.L;return a=null!==ZC._n_(o.BX[r])?o.BX[r]:o.V[r],l.CV=[["%y",a],["%scale-value-label",a]],e=l.b(e,i,t,n)},T7:function(){var e=this;e.setup();var i,t=e.A.B1,n=e.A.CM;switch(e.A.A7J){case"plot-max":i=(ZC._f_(e.AD)-e.A.Y8)/(e.A.A4J-e.A.Y8);break;case"plot-total":i=(ZC._f_(e.AD)-e.A.Y8)/(e.A.A5Z-e.A.Y8);break;case"chart-max":i=(ZC._f_(e.AD)-e.A.WQ)/(e.A.A3B-e.A.WQ);break;case"chart-total":i=(ZC._f_(e.AD)-e.A.WQ)/(e.A.A4L-e.A.WQ)}switch(ZC.P8(i)||(i=.5),e.I=t.AA,e.F=n.AA,e.A.CW){case"alpha":case"brightness":e.C6=e.A.QB+i*(e.A.US-e.A.QB);break;case"horizontal":e.I=1.01+e.A.QB*t.AA+i*t.AA*(e.A.US-e.A.QB),t.AW&&(e.iX=e.iX+t.AA-e.I);break;case"vertical":e.F=1.01+e.A.QB*n.AA+i*n.AA*(e.A.US-e.A.QB),n.AW||(e.iY=e.iY+n.AA-e.F);break;case"size":e.I=1.01+e.A.QB*t.AA+i*t.AA*(e.A.US-e.A.QB),e.F=1.01+e.A.QB*n.AA+i*n.AA*(e.A.US-e.A.QB),e.iX+=(t.AA-e.I)/2,e.iY+=(n.AA-e.F)/2}e.iX-=e.AU/2,e.iY-=e.AU/2,e.I+=e.AU,e.F+=e.AU},paint:function(){var e=this;e.b(),e.T7();var i=e.C.P;if(!(e.iY+5<i.iY||e.iY+5>=i.iY+i.F)){if(e.AN){var t=zingchart.pool.getInstance("HL",e,e.A.K+"-piano-box");if(t.K=e.K,t.copy(e),("none"!==e.A.J0||e.C.IX[e.A.L]||e.C.KI||e.A.T0&&e.A.T0[e.L])&&t.copy(e.A.ID(e,t)),t.iX=e.iX,t.iY=e.iY,t.I=e.I,t.F=e.F,t.Z=e.A.CP("bl",1),t.C7=e.A.CP("bl",0),(-1!==t.BW&&t.AU>0||t.PX+t.OJ+t.NN+t.P4!==""||-1!==t.A0||-1!==t.AE||""!==t.DA||""!==t.GR||""!==t.HN)&&(t.paint(),!t.K9)){var n=e.C.K+"-node-area "+e.C.K+"-plotset-plot-"+e.A.L+"-node-area zc-node-area";e.A.A.HF.push(ZC.Q.FW("rect",e.A.EA,e.A.IP)+'class="'+n+'" '+e.a11y()+' id="'+e.K+'" coords="'+ZC._i_(e.iX+ZC.MAPTX)+","+ZC._i_(e.iY+ZC.MAPTX)+","+ZC._i_(e.iX+e.I+ZC.MAPTX)+","+ZC._i_(e.iY+e.F+ZC.MAPTX)+'" />')}}e.A.U&&e.A.U.AN&&e.GW()}},A0W:function(e){var i=this;ZC.move||i.M5({layer:e,type:"box",initcb:function(){this.AE=i.A.BP[3],this.B7=i.A.BP[1],this.BW=i.A.BP[1],this.A0=i.A.BP[2]},setupcb:function(){this.iX=i.iX,this.iY=i.iY,this.I=i.I,this.F=i.F}})}}),ZC.A5V=ZC.LE.CA({setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];e.JP!==n&&(i.AW?e.iX=i.iX+i.I-i.AC-(e.L+1)*i.AA:e.iX=i.iX+i.AC+e.L*i.AA,t.AW?e.iY=t.iY+t.AC+e.A.L*t.AA:e.iY=t.iY+t.F-t.AC-(e.A.L+1)*t.AA,e.JP=n),e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},JT:function(e,i,t,n){var a,l,o=this,r=ZC._f_(o.A.A.F8["%pstack-"+o.L+"-0-sum"]||"0"),s=o.A.MR();if(ZC._cp_(i,s),o.CV=[],o.A.L>0&&o.A.A.A5[o.A.L-1]&&o.A.A.A5[o.A.L-1].S[o.L]?l=""+(a=100*o.AD/o.A.A.A5[o.A.L-1].S[o.L].AD):(a=100,l="100"),null!==ZC._n_(s.decimals)&&(l=a.toFixed(ZC.BQ(0,ZC._i_(s.decimals)))),o.CV.push(["%output-percent-value",l]),r>0){var A=100*o.AD/r,C=""+A;null!==ZC._n_(s.decimals)&&(C=A.toFixed(ZC.BQ(0,ZC._i_(s.decimals)))),o.CV.push(["%node-percent-value",C]),o.CV.push(["%npv",C])}return e=o.b(e,i,t,n)},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p=this;p.b();var Z=p.A.B1,h=p.A.CM;p.setup(),"static"===p.A.A2I?(p.C.AY.SB[p.L],e=p.C.AY.A8E[p.L]):(p.C.AY.B3,e=p.C.AY.BJ);var d=p.A.L0;d<=1&&(d*=Z.AA);var f=p.A.OG;f<=1&&(f*=Z.AA);var _=p.A.LU;_<=1&&(_*=Z.AA);var g=Z.AA-d-f-_,v=_+g*(p.AD/e),b=0;p.A.L+1<p.A.A.A5.length&&p.A.A.A5[p.A.L+1].S[p.L]&&(b=p.A.A.A5[p.A.L+1].S[p.L].AD);var B=_+g*(b/e);p.E["entry-exit"]=[v,B];var m=p.iX+(Z.AW?f:d)+g/2+_/2;if(n=[],h.AW?n.push([m-v/2,p.iY],[m+v/2,p.iY],[m+B/2,p.iY+h.AA],[m-B/2,p.iY+h.AA],[m-v/2,p.iY]):n.push([m-v/2,p.iY+h.AA],[m+v/2,p.iY+h.AA],[m+B/2,p.iY],[m-B/2,p.iY],[m-v/2,p.iY+h.AA]),p.E.points=n,p.AN){var E=new ZC.DT(p.A);E.K=p.K+"-trapeze",E.copy(p),E.D=n,E.parse(),E.Z=p.A.CP("bl",1),E.C7=p.A.CP("bl",0),E.paint();var D=E.FF(),F=p.C.K+"-node-area "+p.C.K+"-plotset-plot-"+p.A.L+"-node-area zc-node-area";p.A.A.HF.push(ZC.Q.FW("poly",p.A.EA,p.A.IP)+'class="'+F+'" id="'+p.K+'" coords="'+D+'" />')}for(i=0,t=p.A.OU.length;i<t;i++){var K=p.A.OU[i];K&&null!==ZC._n_(K.o.values)&&null!==ZC._n_(K.o.values[p.L])&&(null===ZC._n_(K.o.width)&&null===ZC._n_(K.o.height)||((a=new ZC.HL(p.A)).append(K.o),a.parse()),l=0,o=0,null!==ZC._n_(K.o.width)&&(l=a.I),null!==ZC._n_(K.o.height)&&(o=a.F),0===l&&(l=ZC.BQ(20,Z.AA/10)),0===o&&(o=ZC.BQ(16,h.AA/10)),(r=new ZC.DT(p.A)).K=p.K+"-arrow-entry",r.copy(p),r.append(K.o),r.parse(),n=[],1===p.A.OU.length?A=p.iY+h.AA/2:(C=h.AA/(p.A.OU.length+1),A=p.iY+C+i*C),Z.AW?(s=p.iX+Z.AA+l-d-g/2+(v+B)/4-_/2+2,n.push([s,A-2*o/6],[s-2*l/3,A-o/6],[s-2*l/3,A-3*o/6],[s-l,A],[s-2*l/3,A+3*o/6],[s-2*l/3,A+o/6],[s,A+2*o/6],[s,A-2*o/6])):(s=p.iX+d-l+g/2-(v+B)/4+_/2-2,n.push([s,A-2*o/6],[s+2*l/3,A-o/6],[s+2*l/3,A-3*o/6],[s+l,A],[s+2*l/3,A+3*o/6],[s+2*l/3,A+o/6],[s,A+2*o/6],[s,A-2*o/6])),r.D=n,r.parse(),r.Z=p.A.CP("bl",1),r.C7=p.A.CP("bl",0),r.paint(),null!==ZC._n_(K.o.labels)&&null!==ZC._n_(K.o.labels[p.L])&&""!==K.o.labels[p.L]&&(c=K.o.labels[p.L],(u=new ZC.DN(p.A)).K=p.K+"-entry-label-"+i,u.GL=p.K+"-entry-label "+p.A.K+"-entry-label zc-entry-label",u.copy(p),u.o.text=c,u.append(K.o),null!==ZC._n_(K.o.label)&&u.append(K.o.label),u.Z=p.A.CP("fl",0),u.parse(),Z.AW?u.iX=s+2:u.iX=s-u.I-2,u.iY=A-u.F/2,u.paint(),u.EK()))}for(i=0,t=p.A.VL.length;i<t;i++){var x=p.A.VL[i];x&&null!==ZC._n_(x.o.values)&&null!==ZC._n_(x.o.values[p.L])&&(null===ZC._n_(x.o.width)&&null===ZC._n_(x.o.height)||((a=new ZC.HL(p.A)).append(x.o),a.parse()),l=0,o=0,null!==ZC._n_(x.o.width)&&(l=a.I),null!==ZC._n_(x.o.height)&&(o=a.F),0===l&&(l=ZC.BQ(20,Z.AA/10)),0===o&&(o=ZC.BQ(16,h.AA/10)),(r=new ZC.DT(p.A)).K=p.K+"-arrow-exit",r.copy(p),r.append(x.o),r.parse(),n=[],1===p.A.VL.length?A=p.iY+h.AA/2:(C=h.AA/(p.A.VL.length+1),A=p.iY+C+i*C),Z.AW?(s=p.iX+f+g/2-(v+B)/4+_/2-2,n.push([s,A-2*o/6],[s-2*l/3,A-o/6],[s-2*l/3,A-3*o/6],[s-l,A],[s-2*l/3,A+3*o/6],[s-2*l/3,A+o/6],[s,A+2*o/6],[s,A-2*o/6])):(s=p.iX+Z.AA-f-g/2+(v+B)/4-_/2+2,n.push([s,A-2*o/6],[s+2*l/3,A-o/6],[s+2*l/3,A-3*o/6],[s+l,A],[s+2*l/3,A+3*o/6],[s+2*l/3,A+o/6],[s,A+2*o/6],[s,A-2*o/6])),r.D=n,r.parse(),r.Z=p.A.CP("bl",1),r.C7=p.A.CP("bl",0),r.paint(),null!==ZC._n_(x.o.labels)&&null!==ZC._n_(x.o.labels[p.L])&&""!==x.o.labels[p.L]&&(c=x.o.labels[p.L],(u=new ZC.DN(p.A)).K=p.K+"-exit-label-"+i,u.GL=p.K+"-exit-label "+p.A.K+"-exit-label zc-exit-label",u.copy(p),u.o.text=c,u.append(x.o),null!==ZC._n_(x.o.label)&&u.append(x.o.label),u.parse(),u.Z=p.A.CP("fl",0),Z.AW?u.iX=s-l-u.I-2:u.iX=s+l+2,u.iY=A-u.F/2,u.paint(),u.EK()))}p.A.U&&p.GW()},AC8:function(e){var i,t=this,n=t.A.B1,a=t.A.CM;null!==ZC._n_(e.o.placement)&&(i=e.o.placement);var l=t.iX+n.AA/2-e.I/2,o=t.iY+a.AA/2-e.F/2,r=t.E["entry-exit"],s=(r[0]+r[1])/2;switch(i){case"in":case"auto":break;case"top":o=t.iY+5;break;case"bottom":o=t.iY+a.AA-e.F-5;break;case"left":l=t.iX+n.AA/2-s/2+5;break;case"left-out":l=t.iX+n.AA/2-s/2-e.I-5;break;case"right":l=t.iX+n.AA/2+s/2-e.I-5;break;case"right-out":l=t.iX+n.AA/2+s/2+5}return null!==ZC._n_(e.o.x)&&(l=e.iX),null!==ZC._n_(e.o.y)&&(o=e.iY),[ZC._i_(l),ZC._i_(o)]},A0W:function(){var e=this;if(!ZC.move&&e.A.IE&&e.A.AN){e.b();var i=new ZC.DT(e.A);i.K=e.K+"-trapeze-hover",i.Z=ZC.AL(e.C.K+"-hover-c"),i.D=e.E.points,i.parse(),i.B7=e.A.BP[1],i.BW=e.A.BP[1],i.A0=e.A.BP[2],i.AE=e.A.BP[3],i.append(e.A.IE.o),i.parse(),i.J2=function(i){return e.J2(i)},i.DE()&&i.parse(),i.AN&&i.paint()}}}),ZC.A5X=ZC.LE.CA({setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];e.JP!==n&&(i.AW?e.iY=i.iY+i.AC+e.L*i.AA:e.iY=i.iY+i.F-i.AC-(e.L+1)*i.AA,t.AW?e.iX=t.iX+t.I-t.AC-(e.A.L+1)*t.AA:e.iX=t.iX+t.AC+e.A.L*t.AA,e.JP=n),e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},JT:function(e,i,t,n){var a,l,o=this,r=ZC._f_(o.A.A.F8["%pstack-"+o.L+"-0-sum"]||"0"),s=o.A.MR();if(ZC._cp_(i,s),o.CV=[],o.A.L>0&&o.A.A.A5[o.A.L-1]&&o.A.A.A5[o.A.L-1].S[o.L]?l=""+(a=100*o.AD/o.A.A.A5[o.A.L-1].S[o.L].AD):(a=100,l="100"),null!==ZC._n_(s.decimals)&&(l=a.toFixed(ZC.BQ(0,ZC._i_(s.decimals)))),o.CV.push(["%output-percent-value",l]),r>0){var A=100*o.AD/r,C=""+A;null!==ZC._n_(s.decimals)&&(C=A.toFixed(ZC.BQ(0,ZC._i_(s.decimals)))),o.CV.push(["%node-percent-value",C]),o.CV.push(["%npv",C])}return e=o.b(e,i,t,n)},AC8:function(e){var i,t=this,n=t.A.B1,a=t.A.CM;null!==ZC._n_(e.o.placement)&&(i=e.o.placement);var l=t.iX+a.AA/2-e.I/2,o=t.iY+n.AA/2-e.F/2,r=t.E["entry-exit"],s=(r[0]+r[1])/2;switch(i){case"in":case"auto":break;case"top":l=t.iX+a.AA-e.I-5;break;case"bottom":l=t.iX+5;break;case"left":o=t.iY+n.AA/2-s/2+5;break;case"left-out":o=t.iY+n.AA/2-s/2-e.F-5;break;case"right":o=t.iY+n.AA/2+s/2-e.F-5;break;case"right-out":o=t.iY+n.AA/2+s/2+5}return null!==ZC._n_(e.o.x)&&(l=e.iX),null!==ZC._n_(e.o.y)&&(o=e.iY),[ZC._i_(l),ZC._i_(o)]},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p=this;p.b();var Z=p.A.B1,h=p.A.CM;p.setup(),"static"===p.A.A2I?(p.C.AY.SB[p.L],e=p.C.AY.A8E[p.L]):(p.C.AY.B3,e=p.C.AY.BJ);var d=p.A.L0;d<=1&&(d*=Z.AA);var f=p.A.OG;f<=1&&(f*=Z.AA);var _=p.A.LU;_<=1&&(_*=Z.AA);var g=Z.AA-d-f-_,v=_+g*(p.AD/e),b=0;p.A.L+1<p.A.A.A5.length&&p.A.A.A5[p.A.L+1].S[p.L]&&(b=p.A.A.A5[p.A.L+1].S[p.L].AD);var B=_+g*(b/e);p.E["entry-exit"]=[v,B];var m=p.iY+(Z.AW?d:f)+g/2+_/2;if(o=[],h.AW?o.push([p.iX+h.AA,m-v/2],[p.iX+h.AA,m+v/2],[p.iX,m+B/2],[p.iX,m-B/2],[p.iX+h.AA,m-v/2]):o.push([p.iX,m-v/2],[p.iX,m+v/2],[p.iX+h.AA,m+B/2],[p.iX+h.AA,m-B/2],[p.iX,m-v/2]),p.E.points=o,p.AN){var E=new ZC.DT(p.A);E.K=p.K+"-trapeze",E.copy(p),E.D=o,E.parse(),E.Z=p.A.CP("bl",1),E.C7=p.A.CP("bl",0),E.paint();var D=E.FF(),F=p.C.K+"-node-area "+p.C.K+"-plotset-plot-"+p.A.L+"-node-area zc-node-area";p.A.A.HF.push(ZC.Q.FW("poly",p.A.EA,p.A.IP)+'class="'+F+'" id="'+p.K+'" coords="'+D+'" />')}for(i=0,t=p.A.OU.length;i<t;i++){var K=p.A.OU[i];K&&null!==ZC._n_(K.o.values)&&null!==ZC._n_(K.o.values[p.L])&&(null===ZC._n_(K.o.width)&&null===ZC._n_(K.o.height)||((l=new ZC.HL(p.A)).append(K.o),l.parse()),n=0,a=0,null!==ZC._n_(K.o.width)&&(n=l.I),null!==ZC._n_(K.o.height)&&(a=l.F),0===a&&(a=ZC.BQ(20,Z.AA/10)),0===n&&(n=ZC.BQ(16,h.AA/10)),(r=new ZC.DT(p.A)).K=p.K+"-arrow-entry",r.copy(p),r.append(K.o),r.parse(),o=[],1===p.A.OU.length?s=p.iX+h.AA/2:(C=h.AA/(p.A.OU.length+1),s=p.iX+C+i*C),Z.AW?(A=p.iY+d-a+g/2-(v+B)/4+_/2-2,o.push([s-2*n/6,A],[s+2*n/6,A],[s+n/6,A+2*a/3],[s+3*n/6,A+2*a/3],[s,A+a],[s-3*n/6,A+2*a/3],[s-n/6,A+2*a/3])):(A=p.iY+Z.AA+a-d-g/2+(v+B)/4-_/2+2,o.push([s-2*n/6,A],[s+2*n/6,A],[s+n/6,A-2*a/3],[s+3*n/6,A-2*a/3],[s,A-a],[s-3*n/6,A-2*a/3],[s-n/6,A-2*a/3])),r.D=o,r.parse(),r.Z=p.A.CP("bl",1),r.C7=p.A.CP("bl",0),r.paint(),null!==ZC._n_(K.o.labels)&&null!==ZC._n_(K.o.labels[p.L])&&""!==K.o.labels[p.L]&&(c=K.o.labels[p.L],(u=new ZC.DN(p.A)).K=p.K+"-entry-label-"+i,u.GL=p.K+"-entry-label "+p.A.K+"-entry-label zc-entry-label",u.copy(p),u.o.text=c,u.append(K.o),null!==ZC._n_(K.o.label)&&u.append(K.o.label),u.AM=c,u.Z=p.A.CP("fl",0),u.parse(),u.iX=s-u.I/2,Z.AW?u.iY=A-u.F-2:u.iY=A+2,u.paint(),u.EK()))}for(i=0,t=p.A.VL.length;i<t;i++){var x=p.A.VL[i];x&&null!==ZC._n_(x.o.values)&&null!==ZC._n_(x.o.values[p.L])&&(null===ZC._n_(x.o.width)&&null===ZC._n_(x.o.height)||((l=new ZC.HL(p.A)).append(x.o),l.parse()),n=0,a=0,null!==ZC._n_(x.o.width)&&(n=l.I),null!==ZC._n_(x.o.height)&&(a=l.F),0===a&&(a=ZC.BQ(20,Z.AA/10)),0===n&&(n=ZC.BQ(16,h.AA/10)),(r=new ZC.DT(p.A)).K=p.K+"-arrow-exit",r.copy(p),r.append(x.o),r.parse(),o=[],1===p.A.OU.length?s=p.iX+h.AA/2:(C=h.AA/(p.A.OU.length+1),s=p.iX+C+i*C),Z.AW?(A=p.iY+d+g/2+(v+B)/4+_/2+2,o.push([s-2*n/6,A],[s+2*n/6,A],[s+n/6,A+2*a/3],[s+3*n/6,A+2*a/3],[s,A+a],[s-3*n/6,A+2*a/3],[s-n/6,A+2*a/3])):(A=p.iY+Z.AA-d-g/2-(v+B)/4-_/2-2,o.push([s-2*n/6,A],[s+2*n/6,A],[s+n/6,A-2*a/3],[s+3*n/6,A-2*a/3],[s,A-a],[s-3*n/6,A-2*a/3],[s-n/6,A-2*a/3])),r.D=o,r.parse(),r.Z=p.A.CP("bl",1),r.C7=p.A.CP("bl",0),r.paint(),null!==ZC._n_(x.o.labels)&&null!==ZC._n_(x.o.labels[p.L])&&""!==x.o.labels[p.L]&&(c=x.o.labels[p.L],(u=new ZC.DN(p.A)).K=p.K+"-exit-label-"+i,u.GL=p.K+"-exit-label "+p.A.K+"-exit-label zc-exit-label",u.copy(p),u.o.text=c,u.append(x.o),null!==ZC._n_(x.o.label)&&u.append(x.o.label),u.AM=c,u.Z=p.A.CP("fl",0),u.parse(),u.iX=s-u.I/2,Z.AW?u.iY=A+a+2:u.iY=A-a-u.F-2,u.paint(),u.EK()))}p.A.U&&p.GW()},A0W:function(){var e=this;if(!ZC.move&&e.A.IE&&e.A.AN){e.b();var i=new ZC.DT(e.A);i.K=e.K+"-trapeze-hover",i.Z=ZC.AL(e.C.K+"-hover-c"),i.D=e.E.points,i.parse(),i.B7=e.A.BP[1],i.BW=e.A.BP[1],i.A0=e.A.BP[2],i.AE=e.A.BP[3],i.append(e.A.IE.o),i.parse(),i.J2=function(i){return e.J2(i)},i.DE()&&i.parse(),i.AN&&i.paint()}}}),ZC.A6Z=ZC.LE.CA({$i:function(e){this.b(e),this.J1=null},setup:function(){var e=this,i=e.A.B1,t=e.A.CM,n=[i.W,i.A1,t.W,t.A1];if(e.JP!==n&&(null!==e.BT?e.iX=i.AT(e.BT):e.iX=i.IB(e.L),e.iY=t.AT(e.AD),e.E.XG=t.AT(e.AD),e.E.A9X=t.AT(e.DP[0]),e.E.AAV=t.AT(e.DP[1]),e.E.VE=t.AT(e.DP[2]),e.JP=n),(!e.I2||e.A.I3&&e.A.MV.size<3)&&(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.J1=new ZC.DN(e.A),e.J1.copy(e),e.DP[2]<e.AD&&(e.J1.A0=e.J1.AE=e.C2,e.J1.BW=e.B7),e.DP[2]<e.AD?(e.A.o["trend-down"]&&(e.J1.append(e.A.o["trend-down"]),e.J1.parse()),e.A.MV.down||(e.A.MV.down=new ZC.DN(e.A),e.A.MV.down.copy(e.J1),e.A.MV.size++)):e.DP[2]>e.AD?(e.A.o["trend-up"]&&(e.J1.append(e.A.o["trend-up"]),e.J1.parse()),e.A.MV.up||(e.A.MV.up=new ZC.DN(e.A),e.A.MV.up.copy(e.J1),e.A.MV.size++)):(e.A.o["trend-equal"]&&(e.J1.append(e.A.o["trend-equal"]),e.J1.parse()),e.A.MV.equal||(e.A.MV.equal=new ZC.DN(e.A),e.A.MV.equal.copy(e.J1),e.A.MV.size++)),e.I2=!0),e.A.I3){e.DP[2]<e.AD?e.J1=e.A.MV.down:e.DP[2]>e.AD?e.J1=e.A.MV.up:e.J1=e.A.MV.equal;var a=ZC.CY(e.E.XG,e.E.VE),l=ZC.BQ(e.E.XG,e.E.VE)-ZC.CY(e.E.XG,e.E.VE);l<2&&(l=2),e.E.A7N=a+l/2}},JT:function(e,i,t,n){var a=this,l=a.A.MR();function o(e){return ZC.AP.G2(e,l)}return ZC._cp_(i,l),a.CV=[["%node-value-stock-open",o(a.AD)],["%open",o(a.AD)],["%v0",o(a.AD)],["%node-value-stock-high",o(a.DP[0])],["%high",o(a.DP[0])],["%v1",o(a.DP[0])],["%node-value-stock-low",o(a.DP[1])],["%low",o(a.DP[1])],["%v2",o(a.DP[1])],["%node-value-stock-close",o(a.DP[2])],["%close",o(a.DP[2])],["%v3",o(a.DP[2])]],e=a.b(e,i,t,n)},A9T:function(){var e,i,t=this;if(t.DP=[],t.o.value instanceof Array&&5===t.o.value.length)t.BT=ZC._f_(t.o.value[0]),null!==t.BT&&(null!==ZC._n_(t.A.K4[t.BT])&&-1!==ZC.AV(t.A.K4[t.BT],t.L)||t.A.UW(t.BT,t.L)),i=[t.o.value[1],t.o.value[2],t.o.value[3],t.o.value[4]];else if(t.o.value[1]instanceof Array){if("string"==typeof t.o.value[0]){var n=ZC.AV(t.A.B1.IT,t.o.value[0]);-1!==n?t.BT=n:(t.A.B1.IT.push(t.o.value[0]),t.BT=t.A.B1.IT.length-1)}else t.BT=ZC._f_(t.o.value[0]);null!==t.BT&&(null!==ZC._n_(t.A.K4[t.BT])&&-1!==ZC.AV(t.A.K4[t.BT],t.L)||t.A.UW(t.BT,t.L)),i=t.o.value[1]}else i=t.o.value;t.CK=i.join(" "),t.AD=ZC._f_(i[0]),null!==ZC._n_(e=i[1])&&t.DP.push(ZC._f_(e)),null!==ZC._n_(e=i[2])&&t.DP.push(ZC._f_(e)),null!==ZC._n_(e=i[3])&&t.DP.push(ZC._f_(e))},ABF:function(){var e=this,i={};return e.DP[2]<e.AD?i["background-color"]=e.J1.B7:i["background-color"]=e.J1.A0,i.color=e.J1.C2,i},Y2:function(){var e=this,i={};return e.DP[2]<e.AD?i["background-color"]=e.J1.B7:i["background-color"]=e.J1.A0,i["border-color"]=i["background-color"],i.color=e.J1.C2,i},A8F:function(){return this.Y2()},paint:function(){var e,i=this;i.b();var t=i.A.B1;i.setup();for(var n=t.AA*i.A.Y,a=i.A.L,l=0,o=0;o<i.A.A.K2.stock.length;o++)l++,-1!==ZC.AV(i.A.A.K2[i.A.AF][o],i.A.L)&&(a=o);var r=i.A.CF;r<=1&&(r*=n);var s=i.A.CT;s<=1&&(s*=n);var A=n-r-s,C=i.A.F4;C<=1&&(C*=A),A<1&&(A=.8*n,r=.1*n,s=.1*n);var c=A,u=i.A.F0;0!==u&&(C=0),l>1&&(u>1?c=(A-(l-1)*C+(l-1)*u)/l:u*=c=(A-(l-1)*C)/(l-(l-1)*u)),c=ZC._l_(c,1,A);var p=i.iX-n/2+r+a*(c+C)-a*u;p=ZC._l_(p,i.iX-n/2+r,i.iX+n/2-s);var Z,h=c,d=ZC.CY(i.E.XG,i.E.VE),f=ZC.BQ(i.E.XG,i.E.VE)-ZC.CY(i.E.XG,i.E.VE);if(f<2&&(f=2),r+s===0&&(p-=.5,h+=1),i.I=h,i.F=f,i.iX=p,i.E.A7N=d+f/2,i.setNodeData({x:p,y:d,w:h,h:f}),i.AN){Z=ZC.Q.EB(i.H.usc()?i.H.K+"-main-c":i.H.K9?i.C.K+"-plots-bl-c":i.C.K+"-plot-"+i.A.L+"-bl-1-c",i.H.AB);var _,g=i.iX+i.I/2;i.DP[2]<i.AD&&(e=i.A.o["trend-down"])?(i.E["selected-state"]=e["selected-state"],i.E["background-state"]=e["background-state"]):i.DP[2]>i.AD&&(e=i.A.o["trend-up"])?(i.E["selected-state"]=e["selected-state"],i.E["background-state"]=e["background-state"]):i.DP[2]===i.AD&&(e=i.A.o["trend-equal"])&&(i.E["selected-state"]=e["selected-state"],i.E["background-state"]=e["background-state"]);var v=i.A.ID(i,i.J1);switch(i.A.CW){default:var b,B;(_=[]).push([g,i.E.A9X],[g,ZC.CY(i.E.XG,i.E.VE)],null,[g,i.E.AAV],[g,ZC.BQ(i.E.XG,i.E.VE)]),ZC.CR.paint(Z,v,_),B=i.DP[2]<i.AD?i.A.ABS:i.DP[2]>i.AD?i.A.ACP:i.A.AB8,0!==i.A.E7.length||void 0===B||i.O.o.override||i.C.KI?(b=new ZC.HL(i.A)).copy(v):b=B,i.H3(b),b.Z=i.A.CP("bl",1),b.C7=i.A.CP("bl",0),b.K=i.K,b.iX=p,b.iY=d,b.I=i.I,b.F=i.F,b.paint(),0!==i.A.E7.length||void 0!==B||i.O.o.override||i.C.KI||(i.DP[2]<i.AD?i.A.ABS=b:i.DP[2]>i.AD?i.A.ACP=b:i.A.AB8=b);break;case"whisker":case"ohlc":_=[];var m=Math.max(i.I/4,4);_.push([g,i.E.A9X],[g,i.E.AAV],null,[g-m,i.E.XG],[g,i.E.XG],null,[g+m,i.E.VE],[g,i.E.VE]),i.H3(v),ZC.CR.paint(Z,v,_)}if(i.A.G0){var E=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area";i.A.A.HF.push(ZC.Q.FW("rect",i.A.EA,i.A.IP)+'class="'+E+'" id="'+i.K+'" coords="'+ZC._i_(p+ZC.MAPTX)+","+ZC._i_(i.E.A9X+ZC.MAPTX)+","+ZC._i_(p+h+ZC.MAPTX)+","+ZC._i_(i.E.AAV+ZC.MAPTX)+'" />')}i.A.U&&i.A.U.AN&&i.GW()}},A0W:function(){var e=this;if(!ZC.move&&e.A.IE&&e.A.AN)switch(e.b(),e.A.CW){case"candlestick":var i=new ZC.HL(e.A);i.K=e.K+"-hover",i.Z=ZC.AL(e.C.K+"-hover-c"),i.C2=e.A.BP[0],i.AE=e.A.BP[3],i.B7=e.A.BP[1],i.BW=e.A.BP[1],i.A0=e.A.BP[2],i.append(e.A.IE.o),i.PU=!0,i.parse(),i.J2=function(i){return e.J2(i)},i.DE()&&i.parse(),e.DP[2]<e.AD&&(i.A0=i.AE=i.C2,i.BW=i.B7),e.DP[2]<e.AD&&e.A.o["trend-down"]?(i.append(e.A.o["trend-down"]),i.append(e.A.o["hover-state"]),e.A.o["trend-down"]["hover-state"]&&i.append(e.A.o["trend-down"]["hover-state"]),i.parse()):e.DP[2]>e.AD&&e.A.o["trend-up"]?(i.append(e.A.o["trend-up"]),i.append(e.A.o["hover-state"]),e.A.o["trend-up"]["hover-state"]&&i.append(e.A.o["trend-up"]["hover-state"]),i.parse()):e.DP[2]===e.AD&&e.A.o["trend-equal"]&&(i.append(e.A.o["trend-equal"]),i.append(e.A.o["hover-state"]),e.A.o["trend-equal"]["hover-state"]&&i.append(e.A.o["trend-equal"]["hover-state"]),i.parse()),i.iX=e.getNodeData("x"),i.iY=e.getNodeData("y"),i.I=e.getNodeData("w"),i.F=e.getNodeData("h");var t=e.C.P;i.iY<t.iY&&(i.F=i.F-(t.iY-i.iY),i.iY=t.iY),i.iY+i.F>t.iY+t.F&&(i.F=t.iY+t.F-i.iY),i.AN&&i.paint()}}}),ZC.A75=ZC.LE.CA({setup:function(){var e=this,i=e.C.BM(e.A.BU("k")[0]),t=e.C.BM(e.A.BU("v")[0]),n=e.L%i.H2,a=Math.floor(e.L/i.H2),l=t.EI/(t.BJ-t.B3);e.iX=i.iX+n*i.GK+i.GK/2,e.iY=i.iY+a*i.GE+i.GE/2,e.E.angle=t.DJ-t.EI/2+l*(e.AD-t.B3),t.AW&&(e.E.angle=t.DJ+t.EI/2-l*(e.AD-t.B3)),e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0)},AC8:function(e){var i,t,n,a=e.I,l=e.F,o=this,r=o.C.BM(o.A.BU("k")[0]),s=ZC.CY(r.GK/2,r.GE/2)*r.JD,A=o.L%r.H2,C=Math.floor(o.L/r.H2),c=r.iX+A*r.GK+r.GK/2+r.BL,u=r.iY+C*r.GE+r.GE/2+r.BH;switch(e.o.placement){case"center":t=c-a/2+o.BL,n=u-l/2+o.BH;break;case"edge":t=(i=ZC.AR.BN(c,u,s+e.DV,o.E.angle))[0]-a/2+o.BL,n=i[1]-l/2+o.BH;break;case"tip":t=(i=ZC.AR.BN(c,u,o.E.size+e.DV,o.E.angle))[0]-a/2+o.BL,n=i[1]-l/2+o.BH;break;default:t=(i=ZC.AR.BN(c,u,s/2+e.DV,o.E.angle))[0]-a/2+o.BL,n=i[1]-l/2+o.BH}return null!==ZC._n_(e.o.x)&&(t=e.iX),null!==ZC._n_(e.o.y)&&(n=e.iY),[ZC._i_(t),ZC._i_(n)]},ABF:function(){return{color:this.A0}},Y2:function(){return{"background-color":this.A0,"border-color":this.B7,color:this.C2}},paint:function(){var e,i=this;i.b(),i.setup(),i.CZ=!1;var t=i.C.BM(i.A.BU("k")[0]),n=ZC.CY(t.GK/2,t.GE/2)*t.JD,a=i.L%t.H2,l=Math.floor(i.L/t.H2),o=t.iX+a*t.GK+t.GK/2+t.BL,r=t.iY+l*t.GE+t.GE/2+t.BH,s=ZC.II(i.A.o.size||"0.9",!1);s>0&&s<=1&&(s*=n),i.E.size=s;var A=i.O=i.A.ID(i,i),C=new ZC.DT(i.A);function c(t){var a=[],l=i.A.HW;l[4]>-1&&l[4]<1&&(l[4]=ZC._i_(l[4]*n));var A=ZC.AR.BN(o,r,l[4],t);if(l[0]>=0)for(e=-l[2];e<=180+l[2];e+=5)a.push(ZC.AR.BN(A[0],A[1],l[0],t+270-e));else a.push(ZC.AR.BN(A[0],A[1],ZC._a_(l[0]),t-90)),a.push(ZC.AR.BN(A[0],A[1],ZC._a_(l[0]),t+90));if(0===l[1])a.push(ZC.AR.BN(o,r,s>0?s:.9*n,t));else if(l[1]>0)for(A=ZC.AR.BN(o,r,s>0?s:.9*n,t),e=-l[3];e<=180+l[3];e+=5)a.push(ZC.AR.BN(A[0],A[1],l[1],t-270-e));else A=ZC.AR.BN(o,r,(s>0?s:.9*n)+l[1],t),a.push(ZC.AR.BN(A[0],A[1],ZC._a_(l[1]/(90/l[3])),t+90),ZC.AR.BN(A[0],A[1],ZC._a_(l[1]),t+90),ZC.AR.BN(o,r,s>0?s:.9*n,t),ZC.AR.BN(A[0],A[1],ZC._a_(l[1]),t+270),ZC.AR.BN(A[0],A[1],ZC._a_(l[1]/(90/l[3])),t+270));return a.push([a[0][0],a[0][1]]),a}function u(){var e=C.FF(),t=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",n=ZC.Q.FW("poly",i.A.EA,i.A.IP)+'class="'+t+'" id="'+i.K+'" coords="'+e+'" />';i.A.A.HF.push(n)}C.copy(A),C.Z=i.A.CP("bl",1),C.C7=i.A.CP("bl",0),C.K=i.K+"-arrow";var p=i.C.BM(i.A.BU("v")[0]),Z=p.DJ-p.EI/2,h=c(i.E.angle);if(i.E.points=h,C.DU="poly",C.D=h,C.parse(),C.J2=function(e){return i.J2(e)},C.DE()&&C.parse(),i.A.GD&&!i.C.HH){var d,f=C,_={},g=i.A.L7;for(d in f.C6=0,_.alpha=A.C6,2===g&&(f.A2J=Z,_.A2J=i.E.angle),i.A.FV)f[ZC.E4.GO[ZC.EE(d)]]=i.A.FV[d],_[ZC.EE(d)]=A[ZC.E4.GO[ZC.EE(d)]];if(i.C.EN||(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(d in i.C.EN[i.A.L+"-"+i.L]){var v=ZC.E4.GO[ZC.EE(d)];null===ZC._n_(v)&&(v=d),f[v]=i.C.EN[i.A.L+"-"+i.L][d]}i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(_,i.C.EN[i.A.L+"-"+i.L]);var b=new ZC.E4(f,_,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){u()});b.AX=i,b.A0B=function(e,i){null!==ZC._n_(i.A2J)&&(e.D=c(i.A2J))},i.LO(b),i.A.U&&i.GW()}else C.paint(),i.A.U&&i.GW(),u()},A0W:function(e){var i=this;ZC.move||i.M5({layer:e,type:"shape",initcb:function(){this.copy(i),this.B7=i.A.BP[1],this.BW=i.A.BP[1],this.A0=i.A.BP[3],this.AE=i.A.BP[2],this.D=i.E.points,this.Z=this.C7=i.A.CP("bl",2)}})}}),ZC.A7E=ZC.LE.CA({$i:function(e){this.b(e);var i=this;i.CD=null,i.CJ=null,i.MM="min"},JT:function(e,i,t,n){var a=this;return a.CV=[["%range-set",a.MM],["%node-min-value",a.CD],["%node-max-value",a.CJ]],e=a.b(e,i,t,n)},A9T:function(){var e,i,t=this;t.o.value[1]instanceof Array?("string"==typeof t.o.value[0]?-1!==(i=ZC.AV(t.A.B1.IT,t.o.value[0]))?t.BT=i:(t.A.B1.IT.push(t.o.value[0]),t.BT=t.A.B1.IT.length-1):t.BT=ZC._f_(t.o.value[0]),null!==t.BT&&(null!==ZC._n_(t.A.K4[t.BT])&&-1!==ZC.AV(t.A.K4[t.BT],t.L)||t.A.UW(t.BT,t.L)),e=t.o.value[1]):e=t.o.value,"string"==typeof e[0]?-1!==(i=ZC.AV(t.A.CM.JM,e[0]))?t.CD=i:(t.A.CM.JM.push(e[0]),t.CD=t.A.CM.JM.length-1):t.CD=ZC._f_(e[0]),t.DP.push(t.CD),"string"==typeof e[1]?-1!==(i=ZC.AV(t.A.CM.JM,e[1]))?t.CJ=i:(t.A.CM.JM.push(e[1]),t.CJ=t.A.CM.JM.length-1):t.CJ=ZC._f_(e[1]),t.CK=e.join(" "),t.AD=t.CJ},setup:function(){var e=this,i=e.A.O6,t=e.A.B1,n=e.A.CM,a=[t.W,t.A1,n.W,n.A1,e.MM];null===ZC._n_(e.AH)&&(e.AH=[]),e.JP!==a&&(i?(null!==e.BT?e.iY=t.AT(e.BT):e.iY=t.IB(e.L),e.iX=n.AT("min"===e.MM?e.CD:e.CJ)):(null!==e.BT?e.iX=t.AT(e.BT):e.iX=t.IB(e.L),e.iY=n.AT("min"===e.MM?e.CD:e.CJ)),e.JP=a),e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse()),e.E.N7=n.AT(e.CD),e.E.R7=n.AT(e.CJ),e.I2=!0},ABF:function(){return{color:this.B7}},Y2:function(){return{"background-color":this.B7,"border-color":this.B7,color:this.C2}},paint:function(){var e,i=this;i.b();var t=i.A.B1,n=i.A.QC,a=i.A.O6,l=i.A.S;i.setup(),null!==ZC._n_(i.A.o[i.MM+"-line"])&&(i.append(i.A.o[i.MM+"-line"]),i.parse()),i.CZ=!1,i.C7=i.A.CP("bl",1);var o,r,s,A,C,c,u,p,Z,h,d,f,_,g=[],v=[];switch(i.A.CW){default:var b=!0;!t.EF&&i.L<=t.W&&(b=!1),l[i.L-i.A.Y]||(b=!1),b&&(l[i.L-i.A.Y].MM=i.MM,l[i.L-i.A.Y].setup(),a?(r=[i.E.N7,i.iY],s=[l[i.L-i.A.Y].E.N7,l[i.L-i.A.Y].iY],A=[i.E.R7,i.iY],C=[l[i.L-i.A.Y].E.R7,l[i.L-i.A.Y].iY],c=ZC.AR.A4K(r,s,A,C),o=ZC.DS(c[1],l[i.L-i.A.Y].iY,i.iY)?c:ZC.AR.JU(l[i.L-i.A.Y].iX,l[i.L-i.A.Y].iY,l[i.L].iX,l[i.L].iY),v.push([o[0],ZC._i_(o[1])]),g.push([o[0],o[1]])):(r=[i.iX,i.E.N7],s=[l[i.L-i.A.Y].iX,l[i.L-i.A.Y].E.N7],A=[i.iX,i.E.R7],C=[l[i.L-i.A.Y].iX,l[i.L-i.A.Y].E.R7],c=ZC.AR.A4K(r,s,A,C),o=ZC.DS(c[0],l[i.L-i.A.Y].iX,i.iX)?c:ZC.AR.JU(l[i.L-i.A.Y].iX,l[i.L-i.A.Y].iY,l[i.L].iX,l[i.L].iY),v.push([ZC._i_(o[0]),o[1]]),g.push([o[0],o[1]]))),a?v.push([i.iX,ZC._i_(i.iY)]):v.push([ZC._i_(i.iX),i.iY]),g.push([i.iX,i.iY]);var B=!0;!t.EF&&i.L>=t.A1&&(B=!1),l[i.L+i.A.Y]||(B=!1),B&&(l[i.L+i.A.Y].MM=i.MM,l[i.L+i.A.Y].setup(),a?(r=[i.E.N7,i.iY],s=[l[i.L+i.A.Y].E.N7,l[i.L+i.A.Y].iY],A=[i.E.R7,i.iY],C=[l[i.L+i.A.Y].E.R7,l[i.L+i.A.Y].iY],c=ZC.AR.A4K(r,s,A,C),o=ZC.DS(c[1],l[i.L+i.A.Y].iY,i.iY)?c:ZC.AR.JU(l[i.L].iX,l[i.L].iY,l[i.L+i.A.Y].iX,l[i.L+i.A.Y].iY),v.push([o[0],ZC._i_(o[1])]),g.push([o[0],o[1]])):(r=[i.iX,i.E.N7],s=[l[i.L+i.A.Y].iX,l[i.L+i.A.Y].E.N7],A=[i.iX,i.E.R7],C=[l[i.L+i.A.Y].iX,l[i.L+i.A.Y].E.R7],c=ZC.AR.A4K(r,s,A,C),o=ZC.DS(c[0],l[i.L+i.A.Y].iX,i.iX)?c:ZC.AR.JU(l[i.L].iX,l[i.L].iY,l[i.L+i.A.Y].iX,l[i.L+i.A.Y].iY),v.push([ZC._i_(o[0]),o[1]]),g.push([o[0],o[1]])));break;case"spline":if("undefined"==typeof i.E["intersect.index"]&&(i.E["intersect.index"]=-1,l[i.L+i.A.Y])){var m=[],E=[],D=[];for(u=-1;u<3;u++)l[i.L+u]?(l[i.L+u].setup(),m.push(l[i.L+u].E.N7),D.push(l[i.L+u].E.R7),a?E.push(l[i.L+u].iY):E.push(l[i.L+u].iX)):(m.push(i.E.N7),D.push(i.E.R7),a?E.push(i.iY):E.push(i.iX));Z=ZC._a_(E[2]-E[1]);var F=ZC.AR.Y9(i.A.Q8,m,ZC._i_(Z)),K=ZC.AR.Y9(i.A.Q8,D,ZC._i_(Z));if(l[i.L+i.A.Y].CD===l[i.L+i.A.Y].CJ)i.E["intersect.index"]=F.length;else{var x=F[0][1]-K[0][1];for(u=1,p=F.length;u<p;u++)if(Math.round(x*(F[u][1]-K[u][1]),2)<=0){i.E["intersect.index"]=u+1;break}}i.E["spline.points.min"]=F,i.E["spline.points.max"]=K,i.E["spline.xdiff"]=Z}Z=i.E["spline.xdiff"]||t.AA,null===ZC._n_(i.A.ZR)&&(i.A.ZR={}),null===ZC._n_(i.A.S6)&&(i.A.S6={});var I=[],y=[];if("min"===i.MM){if(null!==ZC._n_(e=i.A.S6.max))for(u=e.length-1;u>=0;u--)i.AH.push(i.A.S6.max[u]);if(null!==ZC._n_(e=i.A.S6.min))for(u=0,p=e.length;u<p;u++)i.AH.push(e[u])}if(null!==ZC._n_(e=i.A.ZR[i.MM]))for(g=[],u=0,p=e.length;u<p;u++)g.push(e[u]);if(l[i.L+i.A.Y]&&i.L<t.A1){"min"===i.MM?h=i.E["spline.points.min"]:"max"===i.MM&&(h=i.E["spline.points.max"]),d=-1===i.E["intersect.index"]?ZC._i_(h.length/2):i.E["intersect.index"];var w=a?t.AW?1:-1:t.AW?-1:1;for(u=0;u<d;u++)a?(g.push([h[u][1],i.iY+w*h[u][0]*Z]),v.push([h[u][1],ZC._i_(i.iY+w*h[u][0]*Z)])):(g.push([i.iX+w*h[u][0]*Z,h[u][1]]),v.push([ZC._i_(i.iX+w*h[u][0]*Z),h[u][1]]));var L=1===i.HX?ZC.CY(2,d):1;for(u=d-1,p=h.length;u<p;u++)a?I.push([h[u][1],i.iY+w*h[u][0]*Z]):I.push([i.iX+w*h[u][0]*Z,h[u][1]]);for(u=d-L,p=h.length;u<p;u++)a?y.push([h[u][1],ZC._i_(i.iY+w*h[u][0]*Z)]):y.push([ZC._i_(i.iX+w*h[u][0]*Z),h[u][1]])}else g.push([l[i.L].iX,l[i.L].iY]),a?(I.push([l[i.L].iX,ZC._i_(l[i.L].iY)]),v.push([l[i.L].iX,ZC._i_(l[i.L].iY)]),y.push([l[i.L].iX,ZC._i_(l[i.L].iY)])):(I.push([ZC._i_(l[i.L].iX),l[i.L].iY]),v.push([ZC._i_(l[i.L].iX),l[i.L].iY]),y.push([ZC._i_(l[i.L].iX),l[i.L].iY]));i.A.ZR[i.MM]=I,i.A.S6[i.MM]=y}if("min"===i.MM)for(u=0,p=v.length;u<p;u++)i.AH.push(v[u]);else for(u=v.length-1;u>=0;u--)i.AH.push(v[u]);if("max"===i.MM){var X=new ZC.DT(i.A);X.K=i.K+"-area",X.Z=i.A.CP("bl",0),X.copy(i),X.AZ=0,X.AU=0,X.EX=0,X.GA=0,X.parse(),X.D=i.AH,X.C6=i.A.HX;var Y=i.C.P;for(X.D1=[Y.iX,Y.iY,Y.iX+Y.I,Y.iY+Y.F],X.paint(),i.E.pointsarea=[],u=0,p=i.AH.length;u<p;u++)i.E.pointsarea.push(i.AH[u]);i.AH=[],i.A.G0&&(_=X.FF(),f=i.C.K+"-node-area "+i.C.K+"-plot-"+i.A.L+"-node-area zc-node-area",i.A.A.HF.push(ZC.Q.FW("poly",i.A.EA,i.A.IP)+'class="'+f+'" id="'+i.K+'--area" coords="'+_+'" />'))}"min"===i.MM?i.E.points=g:(i.E.points.push(null),i.E.points=i.E.points.concat(g));var M=new ZC.D0(i);M.copy(i),M.append(i.A.o[i.MM+"-line"]),M.K=i.K+"-line",M.parse(),ZC.CR.setup(n,M),ZC.CR.paint(n,M,g),"max"===i.MM&&i.paintPreview(i,i.E.points,i.E.pointsarea);if(a?ZC.DS(i.iY,t.iY-1,t.iY+t.F+1)&&ZC.DS(i.iX,t.iX-1,t.iX+t.I+1):ZC.DS(i.iX,t.iX-1,t.iX+t.I+1)&&ZC.DS(i.iY,t.iY-1,t.iY+t.F+1)){var H=new ZC.DT(i.A);H.K=i.K+"-marker-"+i.MM,H.Z=H.C7=i.A.CP("fl",0),H.iX=i.iX,H.iY=i.iY,H.B7=i.A.BP[3],H.BW=i.A.BP[3],H.A0=i.A.BP[2],H.AE=i.A.BP[2],H.append(i.A.A2.o),i.A.o[i.MM+"-marker"]&&H.append(i.A.o[i.MM+"-marker"]),H.parse(),H.J2=function(e){return i.J2(e)},H.DE()&&H.parse(),H.AN&&"none"!==H.AF&&(i.A.MS>t.A1-t.W&&H.paint(),i.E["marker.type"]=H.DU,f=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",t.AW&&g.reverse(),i.A.G0&&(""!==(_=ZC.AR.PR(ZC.AR.Z0(i.E.points),4))?i.A.A.HF.push(ZC.Q.FW("poly",i.A.EA,i.A.IP)+'class="'+f+'" '+i.a11y()+' id="'+i.K+"--"+i.MM+'" coords="'+_+'" />'):i.A.A.HF.push(ZC.Q.FW("circle",i.A.EA,i.A.IP)+'class="'+f+'" '+i.a11y()+' id="'+i.K+"--"+i.MM+'" coords="'+ZC._i_(H.iX+ZC.MAPTX)+","+ZC._i_(H.iY+ZC.MAPTX)+","+ZC._i_(1.5*ZC.BQ(3,H.AI))+'" />'))),i.A.U&&i.A.U.AN&&i.GW()}},paintPreview:function(e,i,t){var n=this;if(n.C.B9&&n.C.B9.I2&&n.A.QN){var a,l=n.C.P,o=n.C.B9,r=n.A.mapPointsToPreview(t),s=new ZC.DT(n.A);s.copy(e),s.CZ=!0,s.L4=!0,s.AZ=0,s.AU=0,s.EX=0,s.GA=0,s.C6=n.A.HX,s.D1=[l.iX,l.iY,l.iX+l.I,l.iY+l.F],s.K=n.K+"-area-preview",s.Z=o.Z,s.D=r,s.paint();var A=n.A.mapPointsToPreview(i);n.A.WB?a=n.A.WB:(a=new ZC.D0(n),n.A.WB=a),a.copy(e);var C=ZC.Q.EB(o.Z,n.H.AB);a.AZ=1,ZC.CR.paint(C,a,A,null,3)}},A0W:function(){var e=this,i=e.A.O6;if(!ZC.move){var t=e.A.B1;if(e.A.GC&&e.A.AN){var n=ZC.Q.EB(e.C.K+"-hover-c",e.H.AB),a=new ZC.DT(e.A);if(a.K=e.K+"-area-hover",a.Z=ZC.AL(e.C.K+"-hover-c"),a.L4=!0,a.copy(e),a.append(e.A.IE.o),a.D=e.E.pointsarea,a.parse(),a.AN){a.C6=e.A.HX;var l=e.C.P;a.D1=[l.iX,l.iY,l.iX+l.I,l.iY+l.F],ZC.CR.setup(n,a),a.paint()}var o=ZC.Q.EB(e.C.K+"-hover-c",e.H.AB),r=new ZC.D0(e.A);r.K=e.K+"-line-hover",r.CZ=!1,r.B7=e.A.BP[3],r.append(e.A.IE.o),r.parse(),r.J2=function(i){return e.J2(i)},r.DE()&&r.parse(),r.AN&&(ZC.CR.setup(o,r),ZC.CR.paint(o,r,e.E.points))}if(e.A.MS>t.A1-t.W&&e.A.GC&&e.A.AN){e.b();var s=new ZC.DT(e.A);s.K=e.K+"-marker-max-hover",s.Z=ZC.AL(e.C.K+"-hover-c"),s.DU=e.E["marker.type"],i?(s.iY=e.iY,s.iX=e.E.R7):(s.iX=e.iX,s.iY=e.E.R7),s.B7=e.A.BP[3],s.BW=e.A.BP[3],s.A0=e.A.BP[2],s.AE=e.A.BP[2],s.append(e.A.GC.o),s.parse(),s.J2=function(i){return e.J2(i)},s.DE()&&s.parse(),s.AN&&"none"!==s.AF&&s.paint(),s.K=e.K+"-marker-min-hover",i?s.iX=e.E.N7:s.iY=e.E.N7,s.AN&&"none"!==s.AF&&s.paint()}}}}),ZC.A7B=ZC.LE.CA({bCXY:!0,U:null,$i:function(e){this.b(e)},parse:function(){this.b()},AB2:function(){this.b();var e=this.C.E;e.update.npv=e.update["node-percent-value"]=this.JT("%npv")},JT:function(e,i,t,n){var a=this,l=a.A.MR();ZC._cp_(i,l),-1===e.indexOf("%npv")&&-1===e.indexOf("%node-percent-value")||null!==ZC._n_(l.decimals)&&-1!==l.decimals||(l.decimals=1);var o=0,r="0";if(a.A.A.KL[a.L]>0&&(r=""+(o=100*a.AD/a.A.A.KL[a.L])),a.A.A.A5.length>1&&a.A.L===a.A.A.A5.length-1){var s=0;if(null===ZC._n_(a.A.o.totals)){for(var A=0;A<a.A.A.A5.length-1;A++)if(a.A.A.A5[A].AN&&null!==ZC._n_(a.A.A.A5[A].S[a.L])){var C=0,c="0";a.A.A.KL[a.L]>0&&(c=""+(C=100*a.A.A.A5[A].S[a.L].AD/a.A.A.KL[a.L])),null!==ZC._n_(l.decimals)&&(c=C.toFixed(ZC.BQ(0,ZC._i_(l.decimals)))),s+=ZC._f_(c)}r=""+(o=Math.max(0,100-s))}}null!==ZC._n_(l.decimals)&&(r=o.toFixed(ZC.BQ(0,ZC._i_(l.decimals))));var u,p=ZC._f_(a.A.A.KL[a.L]||"0");return u=ZC.AP.G2(p,l,a.A),a.CV=[["%node-percent-value",r],["%npv",r],["%pie-total-value",u]],e=a.b(e,i,t,n)},UU:function(e){var i,t=this,n=(t.B4+t.BK)/2%360,a=0;null!==ZC._n_(i=e["offset-r"])&&(a=ZC._f_(ZC._p_(i))),a<1&&(a*=t.AI);var l=new ZC.CE(t.C,(t.CN+.5*(t.AI-t.CN)+t.DV+a)*ZC.EH(n),(t.CN+.5*(t.AI-t.CN)+t.DV+a)*ZC.EO(n),0).ED;return[l[0],l[1],{reference:t,center:!0}]},setup:function(){var e=this,i=e.C.BM(e.A.BU("k")[0]),t=e.L%i.H2,n=Math.floor(e.L/i.H2);e.iX=i.iX+t*i.GK+i.GK/2+i.BL,e.iY=i.iY+n*i.GE+i.GE/2+i.BH,e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(),e.I2=!0)},ABF:function(e){var i={},t="out";return null!==ZC._n_(e.o.placement)&&(t=e.o.placement),i.color="out"===t?this.A0:this.C2,i},AC8:function(e){var i,t=this,n="out";null!==ZC._n_(i=e.o.placement)&&(n=i);var a,l,o,r,s,A=e.I,C=e.F,c=(t.B4+t.BK)/2%360,u=c;if("out"===n){c=u=t.A.A.YE["n"+t.L][t.A.L];var p=function(i,n){n<0&&(n=360+n),n%=360;var a=ZC.AR.BN(t.iX,t.iY,i+t.DV+e.DV+20,n),l=t.C.EZ["x-angle"];l>45&&t.A.A.A5.length>10&&(t.C.EZ["x-angle"]=45+(l-45)/3),s=new ZC.CE(t.C,a[0]-ZC.AO.E2,a[1]-ZC.AO.E3,0),t.C.EZ["x-angle"]=l,a[0]=s.ED[0],a[1]=s.ED[1];var o=a[0]+e.BL-A/2,r=a[1]+e.BH-C/2;return n>=0&&n<=90||n>=270&&n<=360?o+=A/2+10:o-=A/2+10,[o,r]},Z=p(t.AI,u);a=Z[0],l=Z[1],t.U=e;var h={x:a,y:l,width:A,height:C},d=zingchart.DEV.SPREADTYPE;r=!0;for(var f=0,_=0,g=-1,v=0,b=0;r&&b<1024;){r=!1;for(var B=0,m=t.A.A.TH.length;B<m;B++)o=t.A.A.TH[B],(ZC.AR.XQ(h,o,t.A.A.A5.length>10?-8:-2)||h.x+e.I>t.C.P.iX+t.C.P.I||h.x<t.C.P.iX||h.y+e.F>t.C.P.iY+t.C.P.F||h.y<t.C.P.iY)&&(r=!0,0===d?(f+=.4,g*=-1):1===d&&(_+=1),Z=p(t.AI+_,u+f*g),h.x=Z[0],h.y=Z[1],b++,++v>100&&(v=0,0===d?(f=0,_+=4):1===d&&(_=0,f+=1,g*=-1)))}a=h.x,l=h.y,c=u+f,o={text:t.A.AM,x:h.x,y:h.y,width:A,height:C,plotindex:t.A.L,nodeindex:t.L},t.A.A.TH.push(o)}else if("in"===n){var E=t.CN<30?.65:.5,D=ZC.AR.BN(t.iX,t.iY,t.CN+E*(t.AI-t.CN)+t.DV+e.DV,c);s=new ZC.CE(t.C,D[0]-ZC.AO.E2,D[1]-ZC.AO.E3,0),D[0]=s.ED[0],D[1]=s.ED[1],a=D[0]+e.BL-A/2,l=D[1]+e.BH-C/2}else"center"===n&&(a=(s=new ZC.CE(t.C,t.iX-ZC.AO.E2,t.iY-ZC.AO.E3,0)).ED[0]+e.BL-A/2,l=s.ED[1]+e.BH-C/2);return r&&(a=-9999,l=-9999,e.AN=!1),null!==ZC._n_(e.o.x)&&(a=e.iX),null!==ZC._n_(e.o.y)&&(l=e.iY),a>=-2&&(a=ZC._a_(a)),l>=-2&&(l=ZC._a_(l)),[ZC._i_(a),ZC._i_(l),c]},GW:function(e,i){var t,n=this,a=n.b(e,i);if(e)return a;if(n.AN&&a.AN&&null!==ZC._n_(a.AM)&&""!==a.AM){var l="out";if(null!==ZC._n_(a.o.placement)&&(l=a.o.placement),"out"===l){var o=!0;if(null!==ZC._n_(t=a.o.connected)&&(o=ZC._b_(t)),o){var r=new ZC.DT(n.A);r.Z=r.C7=n.A.CP("bl",0),r.append(n.A.C3.o),r.B7=n.A0,r.DU="line",r.D=[];var s=a.E.positioninfo,A=(n.B4+n.BK)/2%360,C=0;A>=0&&A<=180&&(C=n.E.thickness/2);var c=ZC.AR.BN(n.iX,n.iY,n.AI+n.DV+a.DV,A);(c=new ZC.CE(n.C,c[0]-ZC.AO.E2,c[1]-ZC.AO.E3,C).ED)[0]+=n.BL,c[1]+=n.BH,r.D.push(c);var u=ZC.AR.BN(n.iX,n.iY,n.AI+n.DV+a.DV+20,A);(u=new ZC.CE(n.C,u[0]-ZC.AO.E2,u[1]-ZC.AO.E3,C).ED)[0]+=n.BL,u[1]+=n.BH,a.iX>=n.iX?r.D.push([u[0],u[1],s[0],s[1]+a.F/2]):r.D.push([u[0],u[1],s[0]+a.I+2,s[1]+a.F/2]),r.parse(),r.J2=function(e){return n.J2(e)},r.DE()&&r.parse(),r.AN&&r.paint()}}}},paint:function(){var e,i,t,n,a,l,o,r,s,A=this,C=A.C.CL,c=A.C.BM(A.A.BU("k")[0]),u=A.C.EZ["x-angle"],p=A.C.EZ["y-angle"];A.setup();var Z="pie-sel-"+A.A.L+"-"+A.L;if(A.o.detached&&"undefined"==typeof A.C.E[Z]&&(A.C.E[Z]=!0),!(A.AD<0)){var h=ZC.BQ(.7,ZC.EH(u));A.AI=ZC.CY(c.GE/h,c.GK)/2,null!==ZC._n_(A.A.o.size)?A.AI=A.A.AI:A.AI=c.JD*A.AI,A.CN<1&&(A.CN*=A.AI),A.CN=Math.max(0,A.CN),A.o.slice=A.CN,A.DV<1&&(A.DV*=A.AI),A.o["offset-r"]=A.DV;var d=A.A.NL;-1===d&&(d=A.AI/5),A.E.thickness=d;var f=A.iX-ZC.AO.E2,_=A.iY-ZC.AO.E3;A.B4=ZC._i_(A.B4),A.BK=ZC._i_(A.BK);var g=(A.B4+A.BK)/2;A.C.E[Z]&&(A.DV+=ZC._i_(.15*A.AI)),A.DV>0&&(f+=A.DV*ZC.EH(g),_+=A.DV*ZC.EO(g));var v=A.O=A.A.ID(A,A);v.DH=A.K+"-3dfacet";var b=new ZC.D0(A);if(b.copy(v),b.A0=ZC.AP.JK(ZC.AP.G9(b.A0)),b.AE=ZC.AP.JK(ZC.AP.G9(b.AE)),A.AD>=0||0===A.A.A.KL[A.L]){for(o=[],e=A.B4,o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),0]),e=A.B4;e<=A.BK;e+=1)o.push([f+A.AI*ZC.EH(e),_+A.AI*ZC.EO(e),0]);for(e=A.BK,o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),0]),e=A.BK;e>=A.B4;e-=1)o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),0]);if((i=ZC.DK.D8(v,A.C,o)).K=A.K+"-facet1",C.add(i),t=null,A.B4%360>=0+p&&A.B4%360<180+p||A.BK%360>0+p){r=A.B4,s=A.BK;var B=function(e,i,n){var a,l=[];for(a=e,l.push([f+A.AI*ZC.EH(a),_+A.AI*ZC.EO(a),0]),a=e;a<=i;a+=1)l.push([f+A.AI*ZC.EH(a),_+A.AI*ZC.EO(a),0]);for(a=i,l.push([f+A.AI*ZC.EH(a),_+A.AI*ZC.EO(a),d]),a=i;a>=e;a-=1)l.push([f+A.AI*ZC.EH(a),_+A.AI*ZC.EO(a),d]);(t=ZC.DK.D8(b,A.C,l)).MC=[.01,1,1,1],t.K=A.K+"-facet2"+n,C.add(t)};r<180&&s>360?(B(r=r<0?r+360:r,180,1),B(360,s,2)):(r=ZC.BQ(r,s>360?365:5),(s=ZC.CY(s,s>360?535:175))>r&&B(r,s,1))}if(l=null,A.CN>0+p&&A.BK>180+p){for(o=[],e=A.B4,r=A.B4,A.B4<180+p&&A.BK>180+p&&(e=180+p,r=180+p),o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),0]),e=r;e<=A.BK;e+=1)o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),0]);for(e=A.BK,o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),d]),e=A.BK;e>=r;e-=1)o.push([f+A.CN*ZC.EH(e),_+A.CN*ZC.EO(e),d]);(l=ZC.DK.D8(b,A.C,o)).K=A.K+"-facet3",C.add(l)}var m=function(e,i,t){return[[f+e*ZC.EH(t),_+e*ZC.EO(t),0],[f+e*ZC.EH(t),_+e*ZC.EO(t),d],[f+i*ZC.EH(t),_+i*ZC.EO(t),d],[f+i*ZC.EH(t),_+i*ZC.EO(t),0]]};(n=ZC.DK.D8(b,A.C,{points:m(A.CN,A.AI,A.B4),mathpoints:m(A.CN+1,A.AI+1,A.B4-1)})).K=A.K+"-facet4",C.add(n),(a=ZC.DK.D8(b,A.C,{points:m(A.CN,A.AI,A.BK),mathpoints:m(A.CN+1,A.AI+1,A.BK+1)})).K=A.K+"-facet5",C.add(a);var E=A.C.K+"-node-area "+A.C.K+"-plotset-plot-"+A.A.L+"-node-area zc-node-area",D=ZC.Q.FW("poly",A.A.EA)+'class="'+E+'" id="'+A.K,F=A.A.A.HF;F.push(D+'--top" '+A.a11y()+' data-z-sort="1" coords="'+i.FF()+'" />'),t&&F.push(D+'--outer" data-z-sort="1" coords="'+t.FF()+'" />'),(A.CN>0||A.DV>0)&&(l&&F.push(D+'--inner" data-z-sort="2" coords="'+l.FF()+'" />'),F.push(D+'--start" data-z-sort="2" coords="'+n.FF()+'" />',D+'--end" data-z-sort="2" coords="'+a.FF()+'" />'))}A.A.U&&A.GW()}},X6:function(e,i){var t=this;if(t.b(e,i),"click"===i&&e.which<=1&&t.A.A7O){var n="pie-sel-"+t.A.L+"-"+t.L;t.C.E[n]="undefined"==typeof t.C.E[n]||!t.C.E[n],t.C.K6()}}}),ZC.A6V=ZC.ZB.CA({setup:function(){this.T7()},UU:function(){var e=this;e.paint(!0);var i=e.C.BM(e.A.BU("v")[0]),t=e.iX+e.I/2,n=e.iY+(i.AW?e.F:0),a=new ZC.CE(e.C,t-ZC.AO.E2,n-ZC.AO.E3,e.A.E["z-start"]);return[ZC._i_(a.ED[0]),ZC._i_(a.ED[1]),{reference:e,center:!0}]},AC8:function(e){var i=this,t=i.b(e);if("-1/-1"!==t.join("/")){var n=new ZC.CE(i.C,t[0]+e.I/2-ZC.AO.E2,t[1]+e.F/2-ZC.AO.E3,i.A.E["z-mid"]);return[ZC._i_(n.ED[0])-e.I/2,ZC._i_(n.ED[1])-e.F/2]}return t},paint:function(e){var i,t=this;t.b(),void 0===e&&(e=!1);var n=t.C.CL,a=t.A.B1,l=t.A.CM;t.setup();var o,r,s,A,C,c,u,p,Z,h,d,f,_,g,v,b,B=t.A.SO(),m=B.AA,E=B.ET,D=B.CF,F=B.CT,K=B.F4,x=B.D3,I=B.F0;if(e?E=t.A.E["node-"+t.L+"-bar-index"]:t.A.E["node-"+t.L+"-bar-index"]=B.ET,t.A.CC){s=0;var y=t.A.A.KA[E];for(o=0;o<y.length;o++){var w=t.A.A.A5[y[o]].S[t.L];w&&(s+=w.AD)}}var L=1,X=1;if(t.A.CC&&s>0&&(t.CS!==t.AD&&(L=(s-t.CS+t.AD)/s),X=(s-t.CS)/s),l.AW){var Y=L;L=X,X=Y}t.A.LN&&(E=t.L);var M=t.iX-m/2+D+E*(x+K)-E*I;if(M=ZC._l_(M,t.iX-m/2+D,t.iX+m/2-F),t.A.D3>0){var H=x;(x=t.A.D3)<=1&&(x*=H),M+=(H-x)/2}var P=x,N=t.iY,S=null!==ZC._n_(t.A.LX[t.L])?t.A.LX[t.L]:0;if(N=t.A.CC&&"100%"===t.A.KR?l.AT(100*(t.CS+S)/t.A.A.F8[t.L]["%total-"+t.A.DZ]):l.AT(t.CS+S),t.A.CC?(C=N-(A="100%"===t.A.KR?l.AT(100*(t.CS-t.AD+S)/t.A.A.F8[t.L]["%total-"+t.A.DZ]):l.AT(t.CS-t.AD+S)),t.AD<0&&(N=A),l.AW?C>0&&(C=ZC._a_(C),N=A):C<0&&(N=A-(C=ZC._a_(C)))):N=(C=N-(A=l.AT(S)))<0?A-(C=ZC._a_(C)):A,D+F===0&&(M-=.5,P+=1),t.I=P,t.F=C,t.iX=M,t.iY=N,l.AW?t.AD>=l.H8?t.iYVal=N+t.F:t.iYVal=N:t.AD>=l.H8?t.iYVal=N:t.iYVal=N+t.F,t.C.CX){var O="middle";t.C.CX.o.marker&&null!==ZC._n_(i=t.C.CX.o.marker.alignment)&&(O=i),null!==ZC._n_(t.A.o["guide-marker"])&&null!==ZC._n_(i=t.A.o["guide-marker"].alignment)&&(O=i),"node"===O&&(t.E.A5M=t.iX+t.I/2)}if(!e){var G,k,T,z=M-ZC.AO.E2,Q=N-ZC.AO.E3,J=0,V=ZC.AO.FU,R=0,W=V;if(t.A.A3H){if(k=J,"mixed3d"===t.C.AF||"mixed"===t.C.AF){for(G=1,o=0,r=t.A.A.A5.length;o<r;o++)"vbar3d"!==t.A.A.A5[o].AF&&G++;k=(G-1)*(ZC.AO.FU/G),V=ZC._i_(.9*V/G)}T=k+V}else{if(G=0,R=-1,W=ZC.AO.FU,"hide"===t.C.getToggleAction())G=t.A.A.A5.length,R=t.A.L,W/=G;else if(t.A.CC)R=0;else{for(o=0;o<t.A.A.A5.length;o++)t.C.E["plot"+o+".visible"]&&R++;for(o=0;o<t.A.A.A5.length;o++)t.C.E["plot"+o+".visible"]&&(G++,t.A.L>o&&R--);W/=G,R=G-R-1}k=R*W+.2*W,T=(R+1)*W-.2*W}if(null!==ZC._n_(t.A.o["z-start"])&&(k=ZC._i_(t.A.o["z-start"])),null!==ZC._n_(t.A.o["z-end"])&&(T=ZC._i_(t.A.o["z-end"])),null!==ZC._n_(t.A.o.depth)){var U=ZC._i_(t.A.o.depth);k=R*W+W/2-U,T=R*W+W/2+U}J=k,V=T-k,t.A.E["z-plots"]=G,t.A.E["z-cnt"]=R,t.A.E["z-depth"]=W,t.A.E["z-start"]=k,t.A.E["z-mid"]=(k+T)/2;var j=t.O=t.A.ID(t,t.O);if(j.DH=t.K+"-3dfacet",t.A.HT&&(t.H3(j),j.parse()),j.AN){var q=new ZC.D0(t);q.copy(j),q.A0=ZC.AP.JK(ZC.AP.G9(q.A0)),q.AE=ZC.AP.JK(ZC.AP.G9(q.AE)),q.BW=ZC.AP.JK(ZC.AP.G9(q.BW));var $=new ZC.D0(t);$.copy(j),$.A0=ZC.AP.JK(ZC.AP.G9($.A0),15),$.AE=ZC.AP.JK(ZC.AP.G9($.AE),15),$.BW=ZC.AP.JK(ZC.AP.G9($.BW),15);var ee=new ZC.D0(t);ee.copy(j);var ie=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area",te=ZC.Q.FW("poly",t.A.EA,t.O.IP)+'class="'+ie+'" id="'+t.K,ne=t.C.EZ.true3d,ae=t.I/2,le=V/2,oe=L*ae,re=X*ae,se=X*le,Ae=L*le;l.AW&&!t.A.CC?(c=t.AD>=0?0:t.F,u=t.AD>=0?t.F:0):(c=t.AD>=0?t.F:0,u=t.AD>=0?0:t.F);var Ce=t.A.A.HF,ce=ZC.CY(le,ae),ue=t.C.EZ["y-angle"],pe=t.C.EZ.angle,Ze=ZC.EH(pe)*le,he=ZC.EO(pe)*le;ne||(ce=ZC.CY(2*Ze,ae));var de=function(e){var i=0,n=t.A.L,o=t.L,r=t.A.A.A5.length,s=t.A.S.length;switch((t.A.CC?"s":"")+(a.AW?"k":"")+(l.AW?"v":"")){case"":case"v":i=10*n+1e4*o+e;break;case"sv":i=10*(r-n)+1e4*o+e;break;case"k":i=10*n+1e4*(s-o)+e;break;case"skv":i=10*(r-n)+1e4*(s-o)+e;break;case"kv":i=10*n+1e4*(s-o)+e;break;case"s":i=10*n+1e4*o+e;break;case"sk":i=10*n+1e4*(s-o)+e}return i},fe=ZC.MAX,_e=-ZC.MAX,ge=ZC.MAX,ve=-ZC.MAX,be=ZC.MAX,Be=-ZC.MAX,me=ZC.MAX,Ee=-ZC.MAX;if("cylinder"===t.A.CW)for(b=0;b<=360;b+=4)(Z=new ZC.CE(t.C,z+ZC.EO(b)*ce+ae,Q,J+ZC.EH(b)*ce+le)).ED[0]<ge&&(ge=Z.ED[0],fe=b),Z.ED[0]>ve&&(ve=Z.ED[0],_e=b),(Z=new ZC.CE(t.C,z+ZC.EO(b)*ce+ae,Q+t.F,J+ZC.EH(b)*ce+le)).ED[0]<me&&(me=Z.ED[0],be=b),Z.ED[0]>Ee&&(Ee=Z.ED[0],Be=b);var De=t.A.o.facets||{};switch(t.A.CW){default:De.bottom?((p=new ZC.D0(t)).copy(q),p.append(De.bottom),p.parse(),_=ZC.DK.DB(p,t.C,z+.1,z+t.I-.1,Q+t.F-.1,Q+t.F-.1,J+.1,J+V-.1,"x")):_=ZC.DK.DB(q,t.C,z+.1,z+t.I-.1,Q+t.F-.1,Q+t.F-.1,J+.1,J+V-.1,"x"),_.K=t.K+"-facet1",_.FZ=de(1),n.add(_),De.top?((p=new ZC.D0(t)).copy(q),p.append(De.top),p.parse(),f=ZC.DK.DB(p,t.C,z+.1,z+t.I-.1,Q+.1,Q+.1,J+.1,J+V-.1,"x")):f=ZC.DK.DB(q,t.C,z+.1,z+t.I-.1,Q+.1,Q+.1,J+.1,J+V-.1,"x"),f.K=t.K+"-facet2",f.FZ=de(3),n.add(f),De.left?((p=new ZC.D0(t)).copy($),p.append(De.left),p.parse(),g=ZC.DK.DB(p,t.C,z+.1,z+.1,Q+.1,Q+t.F-.1,J+.1,J+V-.1,"z")):g=ZC.DK.DB($,t.C,z+.1,z+.1,Q+.1,Q+t.F-.1,J+.1,J+V-.1,"z"),g.K=t.K+"-facet3",g.FZ=de(2),n.add(g),De.right?((p=new ZC.D0(t)).copy($),p.append(De.right),p.parse(),v=ZC.DK.DB(p,t.C,z+t.I-.1,z+t.I-.1,Q+.1,Q+t.F-.1,J+.1,J+V-.1,"z")):v=ZC.DK.DB($,t.C,z+t.I-.1,z+t.I-.1,Q+.1,Q+t.F-.1,J+.1,J+V-.1,"z"),v.K=t.K+"-facet4",v.FZ=de(4),n.add(v),De.front?((p=new ZC.D0(t)).copy(ee),p.append(De.front),p.parse(),d=ZC.DK.DB(p,t.C,z+.1,z+t.I-.1,Q+.1,Q+t.F-.1,J+.1,J+.1,"y")):d=ZC.DK.DB(ee,t.C,z+.1,z+t.I-.1,Q+.1,Q+t.F-.1,J+.1,J+.1,"y"),d.K=t.K+"-facet5",d.FZ=de(5),n.add(d),t.A.G0&&(1===X&&Ce.push(te+'--top" coords="'+f.FF()+'" />'),Ce.push(te+'--left" coords="'+g.FF()+'" />',te+'--right" coords="'+v.FF()+'" />',te+'--front" coords="'+d.FF()+'" '+t.a11y()+' data-z-sort="-100" />'));break;case"pyramid":De.bottom?((p=new ZC.D0(t)).copy(q),p.append(De.bottom),p.parse(),_=ZC.DK.DB(p,t.C,z+ae-oe,z+ae+oe,Q+c,Q+c,J+le-Ae,J+le+Ae,"x")):_=ZC.DK.DB(q,t.C,z+ae-oe,z+ae+oe,Q+c,Q+c,J+le-Ae,J+le+Ae,"x"),_.K=t.K+"-facet1",_.FZ=de(l.AW&&!t.A.CC?6:1),n.add(_),h=[[z+ae-oe,Q+c,J+le-Ae],[z+ae+oe,Q+c,J+le-Ae]],t.A.CC&&0!==X?h.push([z+ae+re,Q+u,J+le-se],[z+ae-re,Q+u,J+le-se]):h.push([z+ae,Q+u,J+le]),De.front?((p=new ZC.D0(t)).copy(j),p.append(De.front),p.parse(),d=ZC.DK.D8(p,t.C,h)):d=ZC.DK.D8(j,t.C,h),d.K=t.K+"-facet2",d.FZ=de(3),n.add(d),h=[[z+ae-oe,Q+c,J+le-Ae],[z+ae-oe,Q+c,J+le+Ae]],t.A.CC&&0!==X?h.push([z+ae-re,Q+u,J+le+se],[z+ae-re,Q+u,J+le-se]):h.push([z+ae,Q+u,J+le]),De.left?((p=new ZC.D0(t)).copy($),p.append(De.left),p.parse(),g=ZC.DK.D8(p,t.C,h)):g=ZC.DK.D8($,t.C,h),g.K=t.K+"-facet3",g.FZ=de(2),n.add(g),h=[[z+ae+oe,Q+c,J+le-Ae],[z+ae+oe,Q+c,J+le+Ae]],t.A.CC&&0!==X?h.push([z+ae+re,Q+u,J+le+se],[z+ae+re,Q+u,J+le-se]):h.push([z+ae,Q+u,J+le]),De.right?((p=new ZC.D0(t)).copy($),p.append(De.right),p.parse(),v=ZC.DK.D8(p,t.C,h)):v=ZC.DK.D8($,t.C,h),v.K=t.K+"-facet4",v.FZ=de(4),n.add(v),t.A.CC&&0!==X&&(h=[[z+ae-re,Q+u,J+le-se],[z+ae-re,Q+u,J+le+se],[z+ae+re,Q+u,J+le+se],[z+ae+re,Q+u,J+le-se]],De.top?((p=new ZC.D0(t)).copy(q),p.append(De.top),p.parse(),f=ZC.DK.D8(p,t.C,h)):f=ZC.DK.D8(q,t.C,h),f.K=t.K+"-facet5",f.FZ=de(5),n.add(f)),t.A.G0&&Ce.push(te+'--left" coords="'+g.FF()+'" />',te+'--right" coords="'+v.FF()+'" />',te+'--front" coords="'+d.FF()+'" '+t.a11y()+' data-z-sort="-100" />');break;case"cylinder":if(h=[],ne)for(b=0;b<=360;b+=5)h.push([z+ZC.EO(b)*ce+ae,Q+t.F,J+ZC.EH(b)*ce+le]);else for(b=0;b<=360;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce+ae+Ze,N+t.F+ZC.EO(b)*(ce/2)-he],h.push(Z);if(De.bottom?((p=new ZC.D0(t)).copy(q),p.append(De.bottom),p.parse(),_=ZC.DK.D8(p,t.C,h,!ne)):_=ZC.DK.D8(q,t.C,h,!ne),_.K=t.K+"-facet1",_.FZ=de(1),n.add(_),h=[],ne)for(b=0;b<=360;b+=5)h.push([z+ZC.EO(b)*ce+ae,Q,J+ZC.EH(b)*ce+le]);else for(b=0;b<=360;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce+ae+Ze,N+ZC.EO(b)*(ce/2)-he],h.push(Z);if(De.top?((p=new ZC.D0(t)).copy(q),p.append(De.top),p.parse(),f=ZC.DK.D8(p,t.C,h,!ne)):f=ZC.DK.D8(q,t.C,h,!ne),f.K=t.K+"-facet2",f.FZ=de(3),n.add(f),h=[],ne){for(b=ZC.CY(fe,_e);b<=ZC.BQ(fe,_e);b+=1)h.push([z+ZC.EO(b)*ce+ae,Q,J+ZC.EH(b)*ce+le]);for(h.push([z+ZC.EO(b)*ce+ae,Q+t.F,J+ZC.EH(b)*ce+le]),b=ZC.BQ(be,Be);b>=ZC.CY(be,Be);b-=1)h.push([z+ZC.EO(b)*ce+ae,Q+t.F,J+ZC.EH(b)*ce+le])}else{for(b=0;b<=180;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce+ae+Ze,N+t.F+ZC.EO(b)*(ce/2)-he],h.push(Z);for(b=180;b>=0;b-=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce+ae+Ze,N+ZC.EO(b)*(ce/2)-he],h.push(Z)}De.front?((p=new ZC.D0(t)).copy(j),p.append(De.front),p.parse(),d=ZC.DK.D8(p,t.C,h,!ne)):d=ZC.DK.D8(j,t.C,h,!ne),d.K=t.K+"-facet3",d.FZ=de(2),n.add(d),t.A.G0&&Ce.push(te+'--front" coords="'+d.FF()+'" '+t.a11y()+' data-z-sort="-100" />',te+'--top" coords="'+f.FF()+'" />');break;case"cone":if(h=[],ne)for(b=0;b<=360;b+=5)h.push([z+ZC.EO(b)*ce*L+ae,Q+c,J+ZC.EH(b)*ce*L+le]);else for(b=0;b<=360;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce*L+ae+Ze,N+c+ZC.EO(b)*(ce/2)*L-he],h.push(Z);if(De.bottom?((p=new ZC.D0(t)).copy(q),p.append(De.bottom),p.parse(),_=ZC.DK.D8(p,t.C,h,!ne)):_=ZC.DK.D8(q,t.C,h,!ne),_.K=t.K+"-facet1",_.FZ=de(1),n.add(_),h=[],ne){for(b=90+ue;b<=270+ue;b+=5)h.push([z+ZC.EO(b)*ce*L+ae,Q+c,J+ZC.EH(b)*ce*L+le]);if(t.A.CC&&0!==X)for(b=270+ue;b>=90+ue;b-=5)h.push([z+ZC.EO(b)*ce*X+ae,Q+u,J+ZC.EH(b)*ce*X+le]);else h.push([z+ae,Q+u,J+le])}else{for(b=0;b<=180;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce*L+ae+Ze,N+c+ZC.EO(b)*(ce/2)*L-he],h.push(Z);if(t.A.CC&&0!==X)for(b=180;b>=0;b-=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce*X+ae+Ze,N+u+ZC.EO(b)*(ce/2)*X-he],h.push(Z);else(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ae+Ze,N+u-he],h.push(Z)}if(De.front?((p=new ZC.D0(t)).copy(j),p.append(De.front),p.parse(),d=ZC.DK.D8(p,t.C,h,!ne)):d=ZC.DK.D8(j,t.C,h,!ne),d.K=t.K+"-facet2",d.FZ=de(2),n.add(d),t.A.CC&&0!==X){if(h=[],ne)for(b=0;b<=360;b+=5)h.push([z+ZC.EO(b)*ce*X+ae,Q+u,J+ZC.EH(b)*ce*X+le]);else for(b=0;b<=360;b+=5)(Z=new ZC.CE(t.C,0,0,0)).ED=[M+ZC.EH(b)*ce*X+ae+Ze,N+u+ZC.EO(b)*(ce/2)*X-he],h.push(Z);De.top?((p=new ZC.D0(t)).copy(q),p.append(De.top),p.parse(),f=ZC.DK.D8(p,t.C,h,!ne)):f=ZC.DK.D8(q,t.C,h,!ne),f.K=t.K+"-facet3",n.add(f),f.FZ=de(3)}t.A.G0&&Ce.push(te+'--front" coords="'+d.FF()+'" data-z-sort="-100" />')}t.A.U&&t.A.U.AN&&t.GW()}t.paintPreview(j)}},A0W:function(){}}),ZC.A6Y=ZC.ZA.CA({setup:function(){this.T7()},UU:function(){var e=this;e.paint(!0);var i=e.C.BM(e.A.BU("v")[0]),t=e.iX+(i.AW?0:e.I),n=e.iY+e.F/2,a=new ZC.CE(e.C,t-ZC.AO.E2,n-ZC.AO.E3,e.A.E["z-start"]);return[ZC._i_(a.ED[0]),ZC._i_(a.ED[1]),{reference:e,center:!0}]},AC8:function(e){var i=this,t=i.b(e);if("-1/-1"!==t.join("/")){var n=new ZC.CE(i.C,t[0]-ZC.AO.E2,t[1]-ZC.AO.E3,i.A.E["z-start"]);return[ZC._i_(n.ED[0]),ZC._i_(n.ED[1])]}return t},paint:function(e){var i=this;i.b(),void 0===e&&(e=!1);var t=i.C.CL,n=i.A.B1,a=i.A.CM;i.setup();var l,o,r,s,A,C,c,u,p,Z,h,d,f,_,g=i.A.SO(),v=g.AA,b=g.ET,B=g.CF,m=g.CT,E=g.F4,D=g.D3,F=g.F0;if(e?b=i.A.E["node-"+i.L+"-bar-index"]:i.A.E["node-"+i.L+"-bar-index"]=g.ET,i.A.CC){l=0;for(var K=i.A.A.KA[b],x=0;x<K.length;x++){var I=i.A.A.A5[K[x]].S[i.L];I&&(l+=I.AD)}}var y=1,w=1;if(i.A.CC&&(i.CS!==i.AD&&(y=(l-i.CS+i.AD)/l),w=(l-i.CS)/l),a.AW){var L=y;y=w,w=L}i.A.LN&&(b=i.L);var X=i.iY-v/2+B+b*(D+E)-b*F;if(X=ZC._l_(X,i.iY-v/2+B,i.iY+v/2-m),i.A.D3>0){var Y=D;(D=i.A.D3)<=1&&(D*=Y),X+=(Y-D)/2}var M=D,H=i.iX,P=null!==ZC._n_(i.A.LX[i.L])?i.A.LX[i.L]:0;if(H=i.A.CC&&"100%"===i.A.KR?a.AT(100*(i.CS+P)/i.A.A.F8[i.L]["%total-"+i.A.DZ]):a.AT(i.CS+P),i.A.CC?(r=H-(o="100%"===i.A.KR?a.AT(100*(i.CS-i.AD+P)/i.A.A.F8[i.L]["%total-"+i.A.DZ]):a.AT(i.CS-i.AD+P)),i.AD>0?H=o:r=ZC._a_(r),a.AW?r>0?(r=ZC._a_(r),H=o):H-=r=ZC._a_(r):r<0&&(H=o-(r=ZC._a_(r)))):H=(r=H-(o=a.AT(P)))<0?o-(r=ZC._a_(r)):o,B+m===0&&(X-=.5,M+=1),i.I=r,i.F=M,i.iX=H,i.iY=X,a.AW?i.AD>=a.H8?i.iXVal=H:i.iXVal=H+i.I:i.AD>=a.H8?i.iXVal=H+i.I:i.iXVal=H,!e){var N=H+r-ZC.AO.E2,S=X-ZC.AO.E3,O=0,G=ZC.AO.FU;null!==ZC._n_(i.A.o["z-start"])&&(O=ZC._i_(i.A.o["z-start"])),null!==ZC._n_(i.A.o["z-end"])&&(G=ZC._i_(i.A.o["z-end"])-O),i.A.E["z-start"]=O,i.A.E["z-mid"]=O+G/2;var k=i.O=i.A.ID(i,i.O);if(k.DH=i.K+"-3dfacet",i.A.HT&&(i.H3(k),k.parse()),k.AN){var T=new ZC.D0(i);T.copy(k),T.A0=ZC.AP.JK(ZC.AP.G9(T.A0)),T.AE=ZC.AP.JK(ZC.AP.G9(T.AE)),T.BW=ZC.AP.JK(ZC.AP.G9(T.BW));var z=new ZC.D0(i);z.copy(k),z.A0=ZC.AP.JK(ZC.AP.G9(z.A0),15),z.AE=ZC.AP.JK(ZC.AP.G9(z.AE),15),z.BW=ZC.AP.JK(ZC.AP.G9(z.BW),15);var Q=new ZC.D0(i);Q.copy(k);var J=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",V=ZC.Q.FW("poly",i.A.EA,i.O.IP)+'class="'+J+'" id="'+i.K,R=i.C.EZ.true3d,W=i.F/2,U=G/2,j=y*W,q=w*W,$=w*U,ee=y*U;a.AW&&!i.A.CC?(A=i.AD>=0?0:i.I,s=i.AD>=0?i.I:0):(A=i.AD>=0?i.I:0,s=i.AD>=0?0:i.I);var ie=i.A.A.HF,te=ZC.CY(U,W),ne=i.C.EZ["x-angle"],ae=i.C.EZ.angle,le=ZC.EH(ae)*U,oe=ZC.EO(ae)*U;R||(te=ZC.CY(2*oe,W));var re=function(e){var t=-1,l=i.A.L,o=i.L,r=i.A.A.A5.length,s=i.A.S.length;switch((i.A.CC?"s":"")+(n.AW?"k":"")+(a.AW?"v":"")){case"":case"v":case"sv":t=10*(r-l)+1e4*o+e;break;case"k":case"skv":case"kv":t=10*(r-l)+1e4*(s-o)+e;break;case"s":t=10*l+1e4*o+e;break;case"sk":t=10*l+1e4*(s-o)+e}return ZC._i_(t)},se=i.A.o.facets||{};switch(i.A.CW){default:se.left?((C=new ZC.D0(i)).copy(z),C.append(se.left),C.parse(),c=ZC.DK.DB(C,i.C,N-i.I+.1,N-.1,S+.1,S+.1,O+.1,O+G-.1,"x")):c=ZC.DK.DB(z,i.C,N-i.I+.1,N-.1,S+.1,S+.1,O+.1,O+G-.1,"x"),c.K=i.K+"-facet1",c.FZ=re(5),t.add(c),se.right?((C=new ZC.D0(i)).copy(z),C.append(se.right),C.parse(),h=ZC.DK.DB(C,i.C,N-i.I+.1,N-.1,S+i.F-.1,S+i.F-.1,O+.1,O+G-.1,"x")):h=ZC.DK.DB(z,i.C,N-i.I+.1,N-.1,S+i.F-.1,S+i.F-.1,O+.1,O+G-.1,"x"),h.K=i.K+"-facet2",h.FZ=re(1),t.add(h),se.bottom?((C=new ZC.D0(i)).copy(T),C.append(se.bottom),C.parse(),u=ZC.DK.DB(C,i.C,N-i.I+.1,N-i.I+.1,S+i.F-.1,S+.1,O+.1,O+G-.1,"z")):u=ZC.DK.DB(T,i.C,N-i.I+.1,N-i.I+.1,S+i.F-.1,S+.1,O+.1,O+G-.1,"z"),u.K=i.K+"-facet3",u.FZ=re(2),t.add(u),se.top?((C=new ZC.D0(i)).copy(T),C.append(se.top),C.parse(),p=ZC.DK.DB(C,i.C,N-.1,N-.1,S+i.F-.1,S+.1,O+.1,O+G-.1,"z")):p=ZC.DK.DB(T,i.C,N-.1,N-.1,S+i.F-.1,S+.1,O+.1,O+G-.1,"z"),p.K=i.K+"-facet4",p.FZ=re(3),t.add(p),se.front?((C=new ZC.D0(i)).copy(Q),C.append(se.front),C.parse(),Z=ZC.DK.DB(C,i.C,N-i.I+.1,N-.1,S+i.F-.1,S+.1,O+.1,O+.1,"y")):Z=ZC.DK.DB(Q,i.C,N-i.I+.1,N-.1,S+i.F-.1,S+.1,O+.1,O+.1,"y"),Z.K=i.K+"-facet5",Z.FZ=re(4),t.add(Z),i.A.G0&&(i.A.CC||ie.push(V+'--top" coords="'+p.FF()+'" />'),ie.push(V+'--left" coords="'+c.FF()+'" />',V+'--right" coords="'+h.FF()+'" />',V+'--front" coords="'+Z.FF()+'" '+i.a11y()+' data-z-sort="-100" />'));break;case"pyramid":se.bottom?((C=new ZC.D0(i)).copy(T),C.append(se.bottom),C.parse(),u=ZC.DK.DB(C,i.C,N-A,N-A,S+W-j,S+W+j,U-ee,U+ee,"z")):u=ZC.DK.DB(T,i.C,N-A,N-A,S+W-j,S+W+j,U-ee,U+ee,"z"),u.K=i.K+"-facet1",u.FZ=re(a.AW&&!i.A.CC?6:1),t.add(u),_=[[N-A,S+W-j,U-ee],[N-A,S+W+j,U-ee]],i.A.CC&&0!==w?_.push([N-s,S+W+q,U-$],[N-s,S+W-q,U-$]):_.push([N-s,S+W,G/2]),se.front?((C=new ZC.D0(i)).copy(k),C.append(se.front),C.parse(),Z=ZC.DK.D8(C,i.C,_)):Z=ZC.DK.D8(k,i.C,_),Z.K=i.K+"-facet2",Z.FZ=re(3),t.add(Z),_=[[N-A,S+W-j,U-ee],[N-A,S+W-j,U+ee]],i.A.CC&&0!==w?_.push([N-s,S+W-q,U+$],[N-s,S+W-q,U-$]):_.push([N-s,S+i.F/2,G/2]),se.left?((C=new ZC.D0(i)).copy(z),C.append(se.left),C.parse(),c=ZC.DK.D8(C,i.C,_)):c=ZC.DK.D8(z,i.C,_),c.K=i.K+"-facet3",c.FZ=re(4),t.add(c),_=[[N-A,S+W+j,U-ee],[N-A,S+W+j,U+ee]],i.A.CC&&0!==w?_.push([N-s,S+W+q,U+$],[N-s,S+W+q,U-$]):_.push([N-s,S+W,G/2]),se.right?((C=new ZC.D0(i)).copy(z),C.append(se.right),C.parse(),h=ZC.DK.D8(C,i.C,_)):h=ZC.DK.D8(z,i.C,_),h.K=i.K+"-facet4",h.FZ=re(2),t.add(h),i.A.CC&&0!==w&&(se.top?((C=new ZC.D0(i)).copy(T),C.append(se.top),C.parse(),p=ZC.DK.DB(C,i.C,N-s,N-s,S+W-q,S+W+q,U-$,U+$,"z")):p=ZC.DK.DB(T,i.C,N-s,N-s,S+W-q,S+W+q,U-$,U+$,"z"),p.K=i.K+"-facet5",p.FZ=re(5),t.add(p)),i.A.G0&&ie.push(V+'--left" coords="'+c.FF()+'" />',V+'--right" coords="'+h.FF()+'" />',V+'--front" coords="'+Z.FF()+'" '+i.a11y()+' data-z-sort="-100" />');break;case"cylinder":if(_=[],R)for(d=0;d<=360;d+=5)_.push([N-i.I,S+ZC.EO(d)*te+W,O+ZC.EH(d)*te+U]);else for(d=0;d<=360;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+ZC.EH(d)*(te/2)+le,X+W+ZC.EO(d)*te-oe],_.push(f);if(se.bottom?((C=new ZC.D0(i)).copy(T),C.append(se.bottom),C.parse(),u=ZC.DK.D8(C,i.C,_,!R)):u=ZC.DK.D8(T,i.C,_,!R),u.K=i.K+"-facet1",u.FZ=re(1),t.add(u),_=[],R){for(d=90-ne;d<=270-ne;d+=5)_.push([N-i.I,S+ZC.EO(d)*te+W,O+ZC.EH(d)*te+U]);for(_.push([N,S+ZC.EO(d)*te+W,O+ZC.EH(d)*te+U]),d=270-ne;d>=90-ne;d-=5)_.push([N,S+ZC.EO(d)*te+W,O+ZC.EH(d)*te+U])}else{for(d=90;d<=270;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+ZC.EH(d)*(te/2)+le,X+W+ZC.EO(d)*te-oe],_.push(f);for(d=270;d>=90;d-=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+ZC.EH(d)*(te/2)+i.I+le,X+W+ZC.EO(d)*te-oe],_.push(f)}if(se.front?((C=new ZC.D0(i)).copy(k),C.append(se.front),C.parse(),Z=ZC.DK.D8(C,i.C,_,!R)):Z=ZC.DK.D8(k,i.C,_,!R),Z.K=i.K+"-facet2",Z.FZ=re(2),t.add(Z),_=[],R)for(d=0;d<=360;d+=5)_.push([N,S+ZC.EO(d)*te+W,O+ZC.EH(d)*te+U]);else for(d=0;d<=360;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+ZC.EH(d)*(te/2)+i.I+le,X+W+ZC.EO(d)*te-oe],_.push(f);se.top?((C=new ZC.D0(i)).copy(T),C.append(se.top),C.parse(),p=ZC.DK.D8(C,i.C,_,!R)):p=ZC.DK.D8(T,i.C,_,!R),p.K=i.K+"-facet3",p.FZ=re(3),t.add(p),i.A.G0&&ie.push(V+'--front" coords="'+Z.FF()+'" '+i.a11y()+' data-z-sort="-100" />',V+'--top" coords="'+p.FF()+'" />');break;case"cone":if(_=[],R)for(d=0;d<=360;d+=5)_.push([N-A,S+ZC.EO(d)*te*y+W,ZC.EH(d)*te*y+U]);else for(d=0;d<=360;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+s+ZC.EH(d)*(te/2)*y+le,X+W+ZC.EO(d)*te*y-oe],_.push(f);if(se.bottom?((C=new ZC.D0(i)).copy(T),C.append(se.bottom),C.parse(),u=ZC.DK.D8(C,i.C,_,!R)):u=ZC.DK.D8(T,i.C,_,!R),u.K=i.K+"-facet1",u.FZ=re(1),t.add(u),_=[],R){for(d=90-ne;d<=270-ne;d+=5)_.push([N-A,S+ZC.EO(d)*te*y+W,ZC.EH(d)*te*y+U]);if(i.A.CC&&0!==w)for(d=270-ne;d>=90-ne;d-=5)_.push([N-s,S+ZC.EO(d)*te*w+W,ZC.EH(d)*te*w+U]);else _.push([N-s,S+W,te])}else{for(d=90;d<=270;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+s+ZC.EH(d)*(te/2)*y+le,X+W+ZC.EO(d)*te*y-oe],_.push(f);if(i.A.CC&&0!==w)for(d=270;d>=90;d-=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+A+ZC.EH(d)*(te/2)*w+le,X+W+ZC.EO(d)*te*w-oe],_.push(f);else(f=new ZC.CE(i.C,0,0,0)).ED=[H+A+le,X+W-oe],_.push(f)}if(se.front?((C=new ZC.D0(i)).copy(k),C.append(se.front),C.parse(),Z=ZC.DK.D8(C,i.C,_,!R)):Z=ZC.DK.D8(k,i.C,_,!R),Z.K=i.K+"-facet2",Z.FZ=re(2),t.add(Z),i.A.CC&&0!==w){if(_=[],R)for(d=0;d<=360;d+=5)_.push([N-s,S+ZC.EO(d)*te*w+W,ZC.EH(d)*te*w+U]);else for(d=0;d<=360;d+=5)(f=new ZC.CE(i.C,0,0,0)).ED=[H+A+ZC.EH(d)*(te/2)*w+le,X+W+ZC.EO(d)*te*w-oe],_.push(f);se.top?((C=new ZC.D0(i)).copy(T),C.append(se.top),C.parse(),p=ZC.DK.D8(C,i.C,_,!R)):p=ZC.DK.D8(T,i.C,_,!R),p.K=i.K+"-facet3",p.FZ=re(3),t.add(p)}i.A.G0&&ie.push(V+'--front" coords="'+Z.FF()+'" data-z-sort="-100" />')}}i.A.U&&i.A.U.AN&&i.GW()}},A0W:function(){}}),ZC.A6E=ZC.A38.CA({setup:function(){this.T7()},ABF:function(){return{color:this.O.B7}},Y2:function(){return{"background-color":this.O.B7,"border-color":this.O.B7,color:this.O.C2}},AC8:function(e){var i=this,t=i.b(e);return new ZC.CE(i.C,t[0]-ZC.AO.E2,t[1]-ZC.AO.E3,i.A.E["z-start"]).ED},paint:function(){var e,i,t=this;t.b();var n,a=t.E.points;(n="none"!==t.A.J0?t.O=t.A.ID(t,t.O):t.O).DH=t.K+"-3dfacet",t.A.HT&&t.H3(n);var l=0,o=-1,r=ZC.AO.FU;if("hide"===t.C.getToggleAction())t.A.CC?o=0:(l=t.A.A.A5.length,o=t.A.L,r/=l);else if(t.A.CC)o=0;else{for(e=0;e<t.A.A.A5.length;e++)t.C.E["plot"+e+".visible"]&&o++;for(e=0;e<t.A.A.A5.length;e++)t.C.E["plot"+e+".visible"]&&(l++,t.A.L>e&&o--);r/=l,o=l-o-1}n.A0=n.AE=n.B7,"spline"===t.A.CW&&(n.BW=n.B7);var s=t.A.A.HF,A=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area",C=ZC.Q.FW("poly",t.A.EA,t.O.IP)+'class="'+A+'" id="'+t.K,c=o*r,u=(o+1)*r;if(null!==ZC._n_(t.A.o["z-start"])&&(c=ZC._i_(t.A.o["z-start"])),null!==ZC._n_(t.A.o["z-end"])&&(u=ZC._i_(t.A.o["z-end"])),null!==ZC._n_(t.A.o.depth)){var p=ZC._i_(t.A.o.depth);c=o*r+r/2-p,u=o*r+r/2+p}t.A.E["z-plots"]=l,t.A.E["z-cnt"]=o,t.A.E["z-depth"]=r,t.A.E["z-start"]=c,t.A.E["z-mid"]=(c+u)/2;var Z,h,d,f=[],_=[],g=n;ZC._a_(c-u)<=2&&(t.C.CL.SE[t.A.K]||(t.C.CL.SE[t.A.K]={zIndex:t.A.L,style:n,points:[]},t.C.CL.SE[t.A.K].style.M8=!1,t.C.CL.SE[t.A.K].style.AZ=ZC.BQ(1,ZC._i_(ZC._a_(c-u)/1))));for(var v=0;v<a.length-1;v++){if(ZC._a_(c-u)>2){var b=-ZC._i_(ZC.TN(Math.atan((a[v+1][1]-a[v][1])/(a[v+1][0]-a[v][0]))));(g=new ZC.D0(t)).copy(n),g.A0=ZC.AP.JK(ZC.AP.G9(g.A0),b),g.AE=ZC.AP.JK(ZC.AP.G9(g.AE),b),g.BW=ZC.AP.JK(ZC.AP.G9(g.BW),b)}var B,m,E,D;if(t.A.oP0&&ZC._a_(c-u)<=2?((B=t.A.oP0).parse(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,c),(m=t.A.oP1).parse(t.C,a[v+1][0]-ZC.AO.E2,a[v+1][1]-ZC.AO.E3,c),(E=t.A.oP2).parse(t.C,a[v+1][0]-ZC.AO.E2,a[v+1][1]-ZC.AO.E3,u-1),(D=t.A.oP3).parse(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,u-1)):(B=t.A.oP0=new ZC.CE(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,c),m=t.A.oP1=new ZC.CE(t.C,a[v+1][0]-ZC.AO.E2,a[v+1][1]-ZC.AO.E3,c),E=t.A.oP2=new ZC.CE(t.C,a[v+1][0]-ZC.AO.E2,a[v+1][1]-ZC.AO.E3,u-1),D=t.A.oP3=new ZC.CE(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,u-1)),ZC._a_(c-u)>2?((Z=new ZC.W6(g,t.C)).K=t.K+"-facet"+v,Z.add(B),Z.add(m),Z.add(E),Z.add(D),t.C.CL.add(Z)):(t.C.CL.SE[t.A.K].points.push(B.ED),v===a.length-2&&t.C.CL.SE[t.A.K].points.push(m.ED),"spline"===t.A.CW&&(B=new ZC.CE(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,c-10),D=new ZC.CE(t.C,a[v][0]-ZC.AO.E2,a[v][1]-ZC.AO.E3,u-1+10))),f.push(B.ED),_.push(D.ED),t.A.G0&&"spline"!==t.A.CW)if(ZC._a_(c-u)>2)i=Z.FF();else{for(h=ZC.AR.Z0([B.ED,m.ED],4),d=0;d<h.length;d++)h[d][0]=Math.round(h[d][0]),h[d][1]=Math.round(h[d][1]);i=h.join(",")}"spline"!==t.A.CW&&t.A.G0&&s.push(C+"--face"+v+'" '+t.a11y()+' coords="'+i+'" />')}"spline"===t.A.CW?(t.E.polypoints=!0,t.E.points=f.concat(_.reverse())):t.E.points=null,t.A.A2.o&&("spline"===t.A.CW||"none"===t.A.A2.o.type||null!==ZC._n_(t.A.A2.o.visible)&&!ZC._b_(t.A.A2.o.visible))&&"spline"!==t.A.CW||t.PA(!0),t.A.U&&t.A.U.AN&&t.GW(),t.paintPreview(n,a)},A0W:function(){}}),ZC.A6H=ZC.A35.CA({setup:function(){this.T7()},ABF:function(){return{color:this.O.B7}},Y2:function(){return{"background-color":this.O.B7,"border-color":this.O.B7,color:this.O.C2}},AC8:function(e){var i=this,t=i.b(e);return new ZC.CE(i.C,t[0]-ZC.AO.E2,t[1]-ZC.AO.E3,i.A.E["z-start"]).ED},paint:function(){var e,i,t=this;t.b();var n=t.A.CM,a=n.H8,l=n.AT(a);l=ZC._l_(l,n.iY,n.iY+n.F);var o,r=t.E.points,s=t.E.pointsarea;(o="none"!==t.A.J0?t.O=t.A.ID(t,t.O):t.O).DH=t.K+"-3dfacet",t.A.HT&&t.H3(o);var A=0,C=-1,c=ZC.AO.FU;if("hide"===t.C.getToggleAction())t.A.CC?C=0:(A=t.A.A.A5.length,C=t.A.L,c/=A);else if(t.A.CC)C=0;else{for(e=0;e<t.A.A.A5.length;e++)t.C.E["plot"+e+".visible"]&&C++;for(e=0;e<t.A.A.A5.length;e++)t.C.E["plot"+e+".visible"]&&(A++,t.A.L>e&&C--);c/=A,C=A-C-1}var u=new ZC.D0(t);u.copy(o),u.A0=u.AE=o.B7,"spline"===t.A.CW&&(u.BW=o.B7);var p=new ZC.D0(t);p.copy(o),p.L4=!0,p.AU=0,p.C6=t.A.HX,p.A0=ZC.AP.QR(ZC.AP.G9(p.A0),30),p.AE=ZC.AP.QR(ZC.AP.G9(p.AE),30);var Z,h,d=t.A.A.HF,f=t.C.K+"-node-area "+t.C.K+"-plotset-plot-"+t.A.L+"-node-area zc-node-area",_=ZC.Q.FW("poly",t.A.EA,t.O.IP)+'class="'+f+'" id="'+t.K,g=[],v=[],b=C*c,B=(C+1)*c;if(null!==ZC._n_(t.A.o["z-start"])&&(b=ZC._i_(t.A.o["z-start"])),null!==ZC._n_(t.A.o["z-end"])&&(B=ZC._i_(t.A.o["z-end"])),null!==ZC._n_(t.A.o.depth)){var m=ZC._i_(t.A.o.depth);b=C*c+c/2-m,B=C*c+c/2+m}t.A.E["z-plots"]=A,t.A.E["z-cnt"]=C,t.A.E["z-depth"]=c,t.A.E["z-start"]=b,t.A.E["z-mid"]=(b+B)/2;var E=new ZC.W6(p,t.C);for(Z=0,h=s.length;Z<h;Z++){var D=new ZC.CE(t.C,s[Z][0]-ZC.AO.E2,s[Z][1]-ZC.AO.E3,b);E.add(D)}t.C.CL.add(E),t.E.pointsarea=s,t.L===t.A.S.length-1&&((E=new ZC.W6(p,t.C)).add(new ZC.CE(t.C,t.iX-.5-ZC.AO.E2,t.iY-ZC.AO.E3,b)),E.add(new ZC.CE(t.C,t.iX-.5-ZC.AO.E2,l-ZC.AO.E3,b)),E.add(new ZC.CE(t.C,t.iX-.5-ZC.AO.E2,l-ZC.AO.E3,B-1)),E.add(new ZC.CE(t.C,t.iX-.5-ZC.AO.E2,t.iY-ZC.AO.E3,B-1)),E.K=t.K+"-facet99",t.C.CL.add(E));var F=o;for(ZC._a_(b-B)<=2&&(t.C.CL.SE[t.A.K]||(t.C.CL.SE[t.A.K]={zIndex:t.A.L,style:o,points:[]},t.C.CL.SE[t.A.K].style.M8=!1,t.C.CL.SE[t.A.K].style.AZ=ZC.BQ(1,ZC._i_(ZC._a_(b-B)/1)))),Z=0;Z<r.length-1;Z++){if(ZC._a_(b-B)>2){var K=-ZC._i_(ZC.TN(Math.atan((r[Z+1][1]-r[Z][1])/(r[Z+1][0]-r[Z][0]))));(F=new ZC.D0(t)).copy(u),F.A0=ZC.AP.JK(ZC.AP.G9(F.A0),K),F.AE=ZC.AP.JK(ZC.AP.G9(F.AE),K),F.BW=ZC.AP.JK(ZC.AP.G9(F.BW),K)}var x=new ZC.CE(t.C,r[Z][0]-ZC.AO.E2,r[Z][1]-ZC.AO.E3,b),I=new ZC.CE(t.C,r[Z+1][0]-ZC.AO.E2,r[Z+1][1]-ZC.AO.E3,b),y=new ZC.CE(t.C,r[Z+1][0]-ZC.AO.E2,r[Z+1][1]-ZC.AO.E3,B-1),w=new ZC.CE(t.C,r[Z][0]-ZC.AO.E2,r[Z][1]-ZC.AO.E3,B-1);if(ZC._a_(b-B)>2?((E=new ZC.W6(F,t.C)).K=t.K+"-facet"+Z,E.add(x),E.add(I),E.add(y),E.add(w),t.C.CL.add(E)):(t.C.CL.SE[t.A.K].points.push(x.ED),Z===r.length-2&&t.C.CL.SE[t.A.K].points.push(I.ED),"spline"===t.A.CW&&(x=new ZC.CE(t.C,r[Z][0]-ZC.AO.E2,r[Z][1]-ZC.AO.E3,b-10),w=new ZC.CE(t.C,r[Z][0]-ZC.AO.E2,r[Z][1]-ZC.AO.E3,B-1+10))),g.push(x.ED),v.push(w.ED),t.A.G0&&"spline"!==t.A.CW)if(ZC._a_(b-B)>2)i=E.FF();else{for(var L=ZC.AR.Z0([E.D[0].ED,E.D[1].ED],4),X=0;X<L.length;X++)L[X][0]=Math.round(L[X][0]),L[X][1]=Math.round(L[X][1]);i=L.join(",")}"spline"!==t.A.CW&&t.A.G0&&d.push(_+"--face"+Z+'" coords="'+i+'" />')}"spline"===t.A.CW?(t.E.polypoints=!0,t.E.points=g.concat(v.reverse())):t.E.points=null,t.A.A2.o&&("none"===t.A.A2.o.type||null!==ZC._n_(t.A.A2.o.visible)&&!ZC._b_(t.A.A2.o.visible))&&"spline"!==t.A.CW||t.PA(!0),t.A.U&&t.A.U.AN&&t.GW(),t.paintPreview(o,r,s)},A0W:function(){}}),ZC.A85=ZC.LE.CA({$i:function(e){this.b(e),this.WR=0,this.WF=0},JT:function(e,i,t,n){var a=this,l=null;return l=a.A.L<a.A.A.A5.length-1?a.A.A.A5[a.A.L+1]:a.A.A.A5[0],a.CV=[["%paired-plot-text",l.AM],["%paired-node-value",l.S[a.L].AD],["%joined-value",a.WF],["%shared-value",null===ZC._n_(a.A.A.X7[a.L])?0:a.A.A.X7[a.L].area]],e=a.b(e,i,t,n)},setup:function(){var e=this,i=e.C.BM("scale"),t=e.L%i.H2,n=Math.floor(e.L/i.H2);e.iX=i.iX+t*i.GK+i.GK/2+i.BL,e.iY=i.iY+n*i.GE+i.GE/2+i.BH,e.I2||(e.copy(e.A),e.E7=e.A.E7,e.DE()&&e.parse(!1),e.I2=!0),e.I=i.GK/2,e.F=i.GE/2},AC8:function(e){var i=this,t=e.I,n=e.F,a=i.iX-t/2,l=i.iY-n/2;if(3===i.A.A.A5.length)switch(i.A.L){case 0:a-=i.AI/4,l+=i.AI/8;break;case 1:a+=i.AI/4,l+=i.AI/8;break;case 2:l-=i.AI/4}else switch(i.A.L){case 0:a-=i.AI/4;break;case 1:a+=i.AI/4}return null!==ZC._n_(e.o.x)&&(a=e.iX),null!==ZC._n_(e.o.y)&&(l=e.iY),a+=e.BL,l+=e.BH,[ZC._i_(a),ZC._i_(l)]},GW:function(){var e,i,t=this,n=t.b(),a=t.C.K+"-value-box "+t.C.K+"-plot-"+t.A.L+"-value-box zc-value-box",l=t.H.usc()?t.H.mc("top"):t.C.AJ["3d"]||t.H.K9?ZC.AL(t.C.K+"-plots-vb-c"):ZC.AL(t.C.K+"-plot-"+t.A.L+"-vb-c"),o=t.H.usc()?ZC.AL(t.C.A.K+"-top"):ZC.AL(t.C.A.K+"-text");if(null!==ZC._n_(n.o.joined)){if(0===t.A.L&&!t.C.E["plot1.visible"]||1===t.A.L&&!t.C.E["plot2.visible"]||2===t.A.L&&!t.C.E["plot0.visible"])return;t.A.L<t.A.A.A5.length-1?t.A.A.A5[t.A.L+1]:t.A.A.A5[0],e=t.A.A.DW[t.A.L][t.L].intxy,(i=new ZC.DN(t)).copy(n),i.o.text=""+t.WF,i.append(n.o.joined),i.JT=function(e){return t.JT(e,{})},i.parse(),i.GL=a,i.K=t.K+"-value-box-join",i.Z=n.C7=l,i.IL=o,i.iX=e[0]-i.I/2,i.iY=e[1]-i.F/2,i.AN&&(i.paint(),i.EK())}if(null!==ZC._n_(n.o.shared)&&2===t.A.L){if(!t.C.E["plot0.visible"]||!t.C.E["plot1.visible"]||!t.C.E["plot2.visible"])return;e=t.A.A.X7[t.L].xy,(i=new ZC.DN(t)).copy(n),i.o.text=""+t.A.A.HF[t.A.L],i.append(n.o.shared),i.JT=function(e){return t.JT(e,{})},i.parse(),i.GL=a,i.K=t.K+"-value-box-shared",i.Z=n.C7=l,i.IL=o,i.iX=e[0]-i.I/2,i.iY=e[1]-i.F/2,i.AN&&(i.paint(),i.EK())}},ABF:function(){return{color:this.B7}},Y2:function(){return{"background-color":this.BW,"border-color":this.BW,color:this.C2}},paint:function(){var e,i=this;if(i.A.L>=3)i.A.U&&i.GW();else{i.b();var t=i.O=i.A.ID(i,i),n=new ZC.DT(i.A);n.K=i.K,n.Z=i.A.CP("bl",1),n.C7=i.A.CP("bl",0),n.copy(t);var a=i.iX,l=i.iY;if(n.iX=a,n.iY=l,n.AI=i.AI,n.DU="circle",n.E.plotidx=i.A.L,n.E.nodeidx=i.L,n.parse(),i.FO=n,i.A.GD&&!i.C.HH){var o=n,r={};o.iX=a,o.iY=l,r.x=a,r.y=l;var s=i.A.L7;if(o.C6=0,r.alpha=t.C6,3===s)o.AI=2,r.size=i.AI;else if(4===s){switch(i.A.L){case 0:o.iX=a-3*i.AI,o.iY=l;break;case 1:o.iX=a+3*i.AI,o.iY=l;break;case 2:o.iX=a,o.iY=l-3*i.AI}r.x=a,r.y=l}for(e in i.A.FV)o[ZC.E4.GO[ZC.EE(e)]]=i.A.FV[e],r[ZC.EE(e)]=t[ZC.E4.GO[ZC.EE(e)]];if(i.C.EN||(i.C.EN={}),null!==ZC._n_(i.C.EN[i.A.L+"-"+i.L]))for(e in i.C.EN[i.A.L+"-"+i.L])o[ZC.E4.GO[ZC.EE(e)]]=i.C.EN[i.A.L+"-"+i.L][e];i.C.EN[i.A.L+"-"+i.L]={},ZC._cp_(r,i.C.EN[i.A.L+"-"+i.L]);var A=new ZC.E4(o,r,i.A.JG,i.A.L6,ZC.E4.RK[i.A.L8],function(){C()});A.AX=i,i.LO(A)}else n.paint(),C()}function C(){var e=i.C.K+"-node-area "+i.C.K+"-plotset-plot-"+i.A.L+"-node-area zc-node-area",t=ZC.Q.FW("circle",i.A.EA,i.A.IP)+'class="'+e+'" '+i.a11y()+' id="'+i.K+'" coords="'+ZC._i_(i.iX+ZC.MAPTX)+","+ZC._i_(i.iY+ZC.MAPTX)+","+ZC._i_(ZC.BQ(ZC.mobile?6:3,i.AI)*(ZC.mobile?2:1.2))+'" />';i.A.A.HF.push(t),i.A.U&&i.GW()}},A0W:function(e){var i=this;ZC.move||i.M5({layer:e,type:"shape",initcb:function(){this.DU="circle",this.A0=i.A.BP[3],this.AE=i.A.BP[3]},setupcb:function(){this.iX=i.iX,this.iY=i.iY,this.AI=i.AI}})}}),ZC.LE.prototype.N3=function(e,i){var t,n,a=this;if(void 0===i&&(i=!1),i)"undefined"!=typeof a.E.pointserror&&((t=new ZC.D0(a)).copy(a.A),a.A.J8&&(t.copy(a.A.J8),t.append(a.A.J8.o["hover-state"])),t.parse(),t.K=a.K+"--error-hover",t.DH=a.A.A.A.K+"-node-errorbars",t.AN&&ZC.CR.paint(e,t,a.E.pointserror));else{var l=a.A.CM,o=a.A.B1;if(0!==a.A.S2.length){var r=null,s=null,A=!0;a.A.S2.length<=2?(null!==ZC._n_(a.A.S2[0])&&a.A.S2[0]instanceof Array&&(A=!1),null!==ZC._n_(a.A.S2[1])&&a.A.S2[1]instanceof Array&&(A=!1)):A=!1,A?(r=a.A.S2[0],s=a.A.S2[1]):null!==ZC._n_(n=a.A.S2[a.L])&&n instanceof Array&&(r=s=n[0],2===n.length&&(s=n[1])),a.E["node-error-plus"]=r,a.E["node-error-minus"]=s,-1!==(r+"").indexOf("%")&&(r=ZC.II(r))<=1&&(r*=a.AD),-1!==(s+"").indexOf("%")&&(s=ZC.II(s))<=1&&(s*=a.AD);var C=[],c=ZC.II(a.A.J8&&a.A.J8.o.size||.5);c<=1&&(c="vbar"===a.A.AF?ZC._i_(c*a.I):"hbar"===a.A.AF?ZC._i_(c*a.F):ZC._i_(c*o.AA));var u,p=0;if(p=o.CO?a.F:a.I,null!==ZC._n_(r)){var Z=l.AT(a.CS+r);o.CO?(u=l.AW?a.AD<0?a.iX+a.I:a.iX:a.AD>0?a.iX+a.I:a.iX,C.push([Z,a.iY+p/2-c/2],[Z,a.iY+p/2+c/2],null,[Z,a.iY+p/2],[u,a.iY+p/2])):(u=l.AW?a.AD>0?a.iY+a.F:a.iY:a.AD<0?a.iY+a.F:a.iY,C.push([a.iX+p/2-c/2,Z],[a.iX+p/2+c/2,Z],null,[a.iX+p/2,Z],[a.iX+p/2,u]))}if(null!==ZC._n_(s)){var h=l.AT(a.CS-s);o.CO?(u=l.AW?a.AD<0?a.iX+a.I:a.iX:a.AD>0?a.iX+a.I:a.iX,C.push(null,[h,a.iY+p/2-c/2],[h,a.iY+p/2+c/2],null,[h,a.iY+p/2],[u,a.iY+p/2])):(u=l.AW?a.AD>0?a.iY+a.F:a.iY:a.AD<0?a.iY+a.F:a.iY,C.push(null,[a.iX+p/2-c/2,h],[a.iX+p/2+c/2,h],null,[a.iX+p/2,h],[a.iX+p/2,u]))}(t=new ZC.D0(a)).copy(a.A),a.A.J8&&t.copy(a.A.J8),t.parse(),t.K=a.K+"--error",t.DH=a.A.A.A.K+"-node-errorbars",t.CZ=!1,ZC.CR.paint(e,t,C),a.E.pointserror=C}}};var F3={$i:function(e){this.b(e);var i=this;i.H=i.A.A,i.BE="",i.V=[],i.BX=[],i.A53=[],i.DF=!1,i.M=null,i.BR=null,i.IU=null,i.D7=null,i.FR=0,i.I9=null,i.G5=null,i.H8=0,i.P3=null,i.L=1,i.AC=0,i.A46=0,i.BV=0,i.AW=!1,i.CO=!1,i.AA=0,i.iStepMultiplier=1,i.DQ=-1,i.RF=ZC.HJ["thousands-separator"]||"",i.RX=ZC.HJ["decimals-separator"]||".",i.ZX=!1,i.SH=2,i.A33=!1,i.TT="",i.A04="standard",i.CI=null,i.AF="",i.EG=ZC.MAX,i.M1=ZC.MAX,i.GN=!1,i.Y7=!1,i.KM=null,i.NP=null,i.Q1=[],i.E5=1,i.B3=-1,i.BJ=-1,i.SG=-1,i.FX=-1,i.H0=-1,i.C1="lin",i.E6=10,i.F5=null,i.OY=1,i.PU=!0,i.A0J=!1,i.aAutoFit=[!1,!1],i.LS=null,i.WS=null,i.T9=!1,i.I1=-1,i.YQ=!1,i.BA="default",i.PV=!1,i.VB=!1,i.R1=1,i.sMaster="",i.bNormalize=!0,i.bAllowDuplicates=!1},parse:function(){this.b();var e,i=this;if(null!==ZC._n_(e=i.o.step))if(ZC.P8(e))i.E5=ZC._f_(e);else{var t=e.replace(/[0-9]/gi,""),n=parseInt(e.replace(/[^0-9]/gi,""),10);switch(n=n||1,t){case"second":i.E5=1e3*n;break;case"minute":i.E5=1e3*n*60;break;case"hour":i.E5=1e3*n*60*60;break;case"day":i.E5=1e3*n*60*60*24;break;case"week":i.E5=1e3*n*60*60*24*7;break;case"month":i.E5=2629743e3*n;break;case"year":i.E5=31556926e3*n}}if(null!==ZC._n_(i.o.multiplier)&&null===ZC._n_(i.o.short)&&(i.o.short=i.o.multiplier),i.assign_a([["labels","BX"],["tooltip-text","A53"],["format","CI"],["offset-start","AC","i"],["offset-start","A46","i"],["offset-end","BV","i"],["minor-ticks","FR","i"],["step-multiplier","iStepMultiplier","i"],["index","L","i"],["mirrored","AW","b"],["zooming","GN","b"],["zoom-snap","Y7","b"],["fixed-step","PV","b"],["zoom-to","KM"],["force-view","YQ","b"],["zoom-to-values","NP"],["items-overlap","A0J","b"],["used","T9","b"],["max-labels","EG","i"],["max-items","EG","i"],["ref-value","H8","f"],["decimals","DQ","ia"],["decimals-separator","RX"],["thousands-separator","RF"],["short","A33","b"],["short-unit","TT"],["negation","A04"],["exponent","ZX","b"],["exponent-decimals","SH","ia"],["progression","C1"],["log-base","E6","fa"],["scale-factor","OY","fa"],["show-labels","LS"],["max-decimals","I1","i"],["placement","BA"],["factor","R1","f"],["master","sMaster"],["blended","VB","b"],["ranged","DF","b"],["normalize","bNormalize","b"],["allow-duplicates","bAllowDuplicates","b"]]),"log"===i.C1&&(null===ZC._n_(i.o["minor-ticks"])&&(i.FR=Math.max(0,i.E6-2)),null!==ZC._n_(i.KM)&&"v"===i.AF&&(i.KM[0]=ZC.G6(i.KM[0],i.E6),i.KM[1]=ZC.G6(i.KM[1],i.E6))),null!==ZC._n_(e=i.o["auto-fit"])&&(e.length?(i.aAutoFit[0]=ZC._b_(e[0]),i.aAutoFit[1]=ZC._b_(e[e.length-1])):i.aAutoFit[0]=i.aAutoFit[1]=ZC._b_(e)),"string"==typeof i.BX){var a=i.BX.split(":"),l=1;3===a.length&&(l=ZC._f_(a[2])),i.BX=[];for(var o=ZC._f_(a[0]);o<ZC._f_(a[1]);o+=l)i.BX.push(""+o);i.BX.push(""+a[1])}null!==ZC._n_(i.o["fixed-items"])&&(i.EG=ZC.MAX),i.EG=ZC.BQ(i.EG,2),null!==ZC._n_(e=i.o.offset)&&(i.AC=i.BV=ZC._i_(e),0!==ZC._i_(e)||"mixed"!==i.A.AF&&"mixed3d"!==i.A.AF||(i.DF=!1)),null!==ZC._n_(e=i.o["max-ticks"])?i.M1=ZC._i_(e):i.M1=i.EG,i.M1=ZC.BQ(2,i.M1),null!==ZC._n_(e=i.o.transform)&&(i.F5=new ZC.D0,i.F5.append(e));var r=i.A.A.B8,s="("+i.A.AF+")",A=i.BE.replace(/\-[0-9]/,""),C=i.BE.replace(/\-[0-9]/,"-n");function c(e){var t=[s+".SCALE."+e,s+"."+i.BE+"."+e,s+"."+A+"."+e,s+"."+A+"["+i.BA+"]."+e,s+"."+C+"."+e];return i.A.AJ["3d"]&&(t=t.concat([s+".SCALE[3d]."+e,s+"."+i.BE+"[3d]."+e,s+"."+A+"[3d]."+e,s+"."+C+"[3d]."+e])),t}if(null===ZC._n_(i.o.placement)&&i.L>1&&(i.BA="opposite"),null!==ZC._n_(e=i.o.markers))for(var u=0,p=e.length;u<p;u++){var Z=new ZC.A0F(i);Z.L=u,Z.K=i.K+"-marker-"+u,r.load(Z.o,c("marker")),Z.append(e[u]),Z.parse(),i.Q1.push(Z)}i.P3=new ZC.D0(i),r.load(i.P3.o,c("ref-line")),i.P3.append(i.o["ref-line"]),"k"===i.AF&&(i.P3.AN=!1),i.P3.parse(),i.M=new ZC.DN(i),r.load(i.M.o,c("label")),i.M.append(i.o.label),i.M.K=i.K+"-label",i.M.parse(),i.BR=new ZC.DN(i),r.load(i.BR.o,c("item")),i.BR.append(i.o.item),i.BR.K=i.K+"-item",i.BR.parse(),i.IU=new ZC.D0(i),r.load(i.IU.o,c("tick")),i.IU.append(i.o.tick),i.IU.parse(),i.D7=new ZC.D0(i),r.load(i.D7.o,c("guide")),i.D7.append(i.o.guide),i.D7.parse(),null===ZC._n_(i.D7.o.items)&&"-1"!==i.D7.A0&&"-1"!==i.D7.AE&&i.D7.A0!==i.D7.AE&&(i.D7.o.items=[{alpha:i.D7.C6,"background-color":i.D7.A0},{alpha:i.D7.C6,"background-color":i.D7.AE}]),i.I9=new ZC.D0(i),r.load(i.I9.o,c("minor-tick")),i.I9.append(i.o["minor-tick"]),i.I9.parse(),i.G5=new ZC.D0(i),r.load(i.G5.o,c("minor-guide")),i.G5.append(i.o["minor-guide"]),i.G5.parse(),i.A51()},A51:function(){var e,i=this,t={x:"iX",y:"iY",width:"I",height:"F"};for(var n in t){var a=i.A.P[t[n]];null!==ZC._n_(i.o[n])&&(a=ZC.II(i.o[n]))>=0&&a<=1&&(a="x"===n||"y"===n?i.A.P["x"===n?"iX":"iY"]+ZC._i_(a*i.A.P["x"===n?"I":"F"]):ZC._i_(a*i.A.P[t[n]])),i[t[n]]=a}null!==ZC._n_(e=i.o.offset)&&(i.AC=i.BV=ZC._f_(ZC._p_(e))),null!==ZC._n_(e=i.o["offset-start"])&&(i.AC=ZC._f_(ZC._p_(e))),null!==ZC._n_(e=i.o["offset-end"])&&(i.BV=ZC._f_(ZC._p_(e)));var l="k"===i.AF&&!i.CO||"v"===i.AF&&i.CO?i.I:i.F;i.AC<1&&(i.AC*=l),i.BV<1&&(i.BV*=l)},YM:function(e){var i=this;null!==ZC._n_(i.o.rules)&&(i.WS||(i.WS=new ZC.F3(i.A)),i.WS.append(i.o),i.WS.parse(),i.WS.J2=e,i.WS.DE()&&(i.WS.parse(),i.DQ=i.WS.DQ,i.CI=i.WS.CI))},IZ:function(){},A7U:function(){},AC9:function(){},A9T:function(){},clear:function(){},build:function(){},MR:function(){var e,i=this,t={negation:i.A04,"thousands-separator":i.RF,"decimals-separator":i.RX,decimals:i.DQ,"max-decimals":i.I1,short:i.A33,"short-unit":i.TT,exponent:i.ZX,"exponent-decimals":i.SH};if(i.F5)switch(i.F5.o.type){case"date":t["transform-date"]=!0,null!==ZC._n_(e=i.F5.o.text)&&(i.F5.o.all=e);var n=i.V[i.A1]-i.V[i.W],a="",l="",o={},r=["msecond","second","minute","hour","day","month","year"];for(var s in r)o[r[s]]=ZC.HJ["date-formats"][r[s]];l=0<=n&&n<=1e3?"msecond":1e3<n&&n<=36e5?"second":36e5<n&&n<=864e5?"minute":864e5<n&&n<=26784e5?"hour":26784e5<n&&n<=316224e5?"day":316224e5<n&&n<=632448e6?"month":"year",a=null!==ZC._n_(i.F5.o[l])?i.F5.o[l]:null!==ZC._n_(i.F5.o.all)?i.F5.o.all:o[l],i.E.dateformat=a,t["transform-date-format"]=i.E.dateformat}return t},A0E:function(){for(var e=this,i=e.A.AY.A5,t=-1,n=0,a=i.length;n<a;n++){var l=i[n].BU(e.AF);if(-1!==ZC.AV(l,e.BE)){switch(i[n].AF){case"pie":case"pie3d":case"nestedpie":case"vbar":case"vbar3d":case"hbar":case"hbar3d":case"vbullet":case"hbullet":case"area":case"area3d":case"gauge":case"vfunnel":case"hfunnel":case"venn":t=i[n].A0;break;case"scatter":case"bubble":t=-1!==i[n].A2.A0?i[n].A2.A0:i[n].A0;break;default:t=i[n].B7}break}}return t},paint:function(){var e=this;e.build(),e.A.AJ["3d"]||e.b()},MY:function(e,i,t,n){var a=this;if(null===ZC._n_(n)&&(n=5),a.A.AJ["3d"]){var l=new ZC.CE(a.A,e.iX+e.I/2-ZC.AO.E2,e.iY+e.F/2-ZC.AO.E3,0+e.A9R);e.iX=l.ED[0]-e.I/2+("v"===t?"default"===a.BA?-n:n:0),e.iY=l.ED[1]-e.F/2+("h"===t?"default"===a.BA?n:-n:0);var o=ZC.DK.A2T(a.A,e);null===ZC._n_(i)&&(i=e.A9,e.A9%90==0&&(i+=e.V9?0:o)),e.A9=i}return i},X3:function(e,i,t){var n=this,a=(t.items,t.lcoords),l=t.lstep,o=t.tdim,r=t.mdim,s=t.dim,A=t.html,C=[e.iX+e.BL,e.iY+e.BH,e.I,e.F],c=ZC._a_(e.A9%180),u=!1;c%360!=0&&(u=!0),u&&(C=[e.iX+e.BL+e.I/2-e.F/2,e.iY+e.BH+e.F/2-e.I/2,e.F,e.I]);var p=!0;if(e.AN){if(!n.A0J)if("log"===n.C1||i!==n.W&&i!==n.A1){i%l==0&&(p=!0);for(var Z=0,h=a.length;Z<h;Z++)if(ZC.AR.XQ({x:C[0],y:C[1],width:C[2],height:C[3]},{x:a[Z][0],y:a[Z][1],width:a[Z][2],height:a[Z][3]})){p=!1;break}}else p=!0;p&&(a.push(C),e.paint(),0,r=ZC.BQ(r,1.5*e.DI*(e.AM||"").split("<br>").length),"h"===s?(o+=e.F,r=ZC.BQ(r,ZC._a_(ZC.EO(c))*ZC.BQ(e.I,e.F))):"w"===s&&(o+=e.I,r=ZC.BQ(r,ZC._a_(ZC.EH(c))*ZC.BQ(e.I,e.F))),e.EK(),null===ZC._n_(n.o.tooltip)&&e.K9||(null!==ZC._n_(n.o.tooltip)&&(n.o.tooltip.text=n.o.tooltip.text||"%scale-value"),A.push(ZC.AP.O4(n.A.K,e))))}return{tdim:o,mdim:r,overlaps:!p}},VG:function(e,i){var t=this;if("v"===t.AF&&(t.H8!==t.B3&&t.H8!==t.BJ||(null===ZC._n_(t.o["ref-line"])||null!==ZC._n_(t.o["ref-line"])&&null===ZC._n_(t.o["ref-line"].visible))&&(t.P3.AN=!1)),t.P3.K=t.K+"-ref-line",t.V.length>0&&t.P3.AN&&!t.A.AJ["3d"]&&t.P3.AZ>0){"inherit"===t.P3.o["line-color"]&&-1!==i&&(t.P3.B7=i);var n=t.H8;if("k"===t.AF&&!t.CO||"v"===t.AF&&t.CO){var a=t.AT(n);a>=t.iX&&a<=t.iX+t.I&&ZC.CR.paint(e,t.P3,[[a,t.iY],[a,t.iY+t.F]])}else{var l=t.AT(n);l>=t.iY&&l<=t.iY+t.F&&ZC.CR.paint(e,t.P3,[[t.iX,l],[t.iX+t.I,l]])}}},paint_:function(){},XO:function(){for(var e=this,i=0,t=e.Q1.length;i<t;i++)e.V.length>0&&e.Q1[i].paint()},gc:function(){ZC.AP.gc(this,["V","BX","Z","C7","D7","BR","M","G5","I9","P3","IU","J2","o","I6","JB","A","H"])}};ZC.F3=ZC.HL.CA(F3);var ZI={$i:function(e){this.b(e);var i=this;i.EF=!1,i.AF="k",i.DC=-1,i.DX=-1,i.W=-1,i.A1=-1,i.UX=1,i.DQ=null,i.OL=0,i.A5E=!1,i.NT=!1,i.U9={},i.IT=[],i.iMinOffset=0},zoomTo:function(e,i){var t=this;if(t.GN){null!==ZC._n_(e)?t.W=e:t.W=t.DC,null!==ZC._n_(i)?t.A1=i:t.A1=t.DX;var n=t.IT;if(n.length>0?(t.B3=ZC.AV(n,t.V[t.W]),t.BJ=ZC.AV(n,t.V[t.A1])):(t.B3=t.V[t.W],t.BJ=t.V[t.A1]),t.H.H1.C||(t.H.H1.C=t.A),t.A.H1&&null!==ZC._n_(t.A.H1.o.shared)&&ZC._b_(t.A.H1.o.shared)&&t.A.K===t.H.H1.C.K)for(var a=0,l=t.H.AG.length;a<l;a++){var o=t.H.AG[a];if(o.K!==t.A.K&&null!==ZC._n_(o.H1.o.shared)&&ZC._b_(o.H1.o.shared)){var r=o.BM(t.BE);r&&r.GN&&(e=Math.max(r.DC,Math.min(r.DX,t.W)),i=Math.max(r.DC,Math.min(r.DX,t.A1)),r.zoomTo(e,i),ZC.AL(o.K)&&(o.clear(!0),o.E["shared-zoom"]=!0,o.paint(),o.B9&&o.B9.update(e,i,null,null,!0)))}}t.IZ()}},zoomToV:function(e,i){var t=this;null!==ZC._n_(e)?t.B3=e:t.B3=t.FX,null!==ZC._n_(i)?t.BJ=i:t.BJ=t.H0,t.RQ(t.B3,t.BJ,null===ZC._n_(e)&&null===ZC._n_(i))},FQ:function(L,J,ER,bKeep,AD){var s=this,CU="";J?(CU=J.S[L].BT,s.F5&&"date"===s.F5.o.type||"number"==typeof CU||(null!==ZC._n_(s.BX[CU])?CU=s.BX[CU]:null!==ZC._n_(s.V[CU])&&(CU=s.V[CU]))):CU="log"===s.C1&&bKeep?L+1:null!==ZC._n_(s.BX[L])?s.BX[L]:s.V[L],"number"==typeof CU&&null!==ZC._n_(s.IT[CU])&&(CU=s.IT[CU]),null!==ZC._n_(AD)&&(CU=AD);var OO=ZC.P8(CU)&&ZC._f_(CU)<0,BC=s.MR();if(ZC._cp_(ER,BC),OO&&"currency"===BC.negation&&(CU=ZC._a_(ZC._f_(CU))),BC.utc=s.A.UN,BC.timezone=s.A.ND,CU=ZC.AP.G2(CU,BC,s,!0),s.CI)if("()"===s.CI.substring(s.CI.length-2)||"javascript:"===s.CI.substring(0,11))try{var EC=s.CI.replace("javascript:","").replace("()","");eval(EC)&&(CU=eval(EC).call(s,CU))}catch(e){}else CU=OO&&"currency"===BC.negation?"-"+s.CI.replace(/%v|%scale-value/g,CU):s.CI.replace(/%v|%scale-value/g,CU);return CU},JT:function(e,i,t,n,a){var l=this,o=l.FQ(i,t,n,a),r=[];r.push(["%scale-label",o],["%scale-index",i],["%scale-position",i]),l.F5&&"date"===l.F5.o.type?r.push(["%scale-value",o],["%v",o]):"log"===l.C1&&a?r.push(["%scale-value",Math.pow(l.E6,i)],["%v",Math.pow(l.E6,i)]):r.push(["%scale-value",ZC._c_(l.V[i],"")],["%v",ZC._c_(l.V[i],"")]),r.push(["%l",o],["%t",o],["%i",i],["%c",i]),r.sort(ZC.A1H);for(var s=0,A=r.length;s<A;s++){var C=new RegExp(r[s][0],"g");e=e.replace(C,r[s][1])}return e},A7U:function(){var e=this,i=ZC.BQ(e.V.length,e.BX.length),t=0;if(i>0&&e.BR.A9%180==0){for(var n=ZC.BQ(1,ZC._i_(i/20)),a=0,l=0;l<i;l+=n){for(var o=((e.BX[l]||e.V[l])+"").split(/<br>|<br\/>|<br \/>|\n/),r=0,s=0,A=o.length;s<A;s++)r=ZC.BQ(r,11*o[s].replace(/<.+?>/gi,"").replace(/<\/.+?>/gi,"").length);t+=r,a++}t=.75*t/Math.max(1,a)}else t=15;e.CO?e.EG=ZC._i_((e.F-e.AC-e.BV)/15):e.EG=ZC._i_((e.I-e.AC-e.BV)/t),e.EG=ZC.CY(e.EG,20),(e.BJ-e.B3)/e.E5+1<e.EG?e.EG=ZC.BQ(e.EG,ZC._i_((e.BJ-e.B3)/e.E5)+1):(e.BJ-e.B3)/(2*e.E5)+1<e.EG&&(e.EG=ZC.BQ(e.EG,ZC._i_((e.BJ-e.B3)/(2*e.E5))+1)),e.EG=ZC.BQ(2,e.EG)},AC9:function(){var e=this;null===ZC._n_(e.o["max-ticks"])&&(e.M1=e.EG)},A9T:function(e){var i,t,n,a,l,o=this;if(1===e&&o.o.transform&&"date"===o.o.transform.type&&(null===ZC._n_(o.o.transform.uniform)||ZC._b_(o.o.transform.uniform)||(o.NT=!0)),1===e&&null!==ZC._n_(o.o.values))if(o.V=[],"object"==typeof o.o.values)for(o.V=o.o.values,0===o.BX.length&&(o.BX=o.V),n=0,a=o.V.length;n<a;n++)"string"==typeof o.V[n]&&(o.A5E=!0,o.IT.push(o.V[n]));else{var r=o.o.values.split(":"),s=o.E5;if(3===r.length&&(s=ZC._f_(r[2])),o.E5=o.SG=s,ZC._f_(r[0])>ZC._f_(r[1])){var A=r[0];r[0]=r[1],r[1]=A}if(s<=0&&(s=1),r.length>1){for(var C=0,c=0,u=0,p=(""+s).split("."),Z=ZC._f_(r[0]);Z<=ZC._f_(r[1]);Z+=s){var h=(""+Z).split(".");p.length>1&&h.length>1&&p[1].length>0&&h[1].length>=9&&ZC._a_(h[1].length-p[1].length)>2?(C+=p[1].length,c=ZC.BQ(c,p[1].length),u++,null!==(l=ZC._n_(o.o.decimals))?o.V.push(ZC._f_(Number(Z).toFixed(ZC._i_(l)))):o.V.push(ZC._f_(ZC._fixed_(Number(Z),p[1].length))),Z=ZC._f_(ZC._fixed_(Number(Z),p[1].length))):(C+=h[1]?h[1].length:0,c=ZC.BQ(c,h[1]?h[1].length:0),u++,null!==(l=ZC._n_(o.o.decimals))?o.V.push(ZC._f_(Number(Z).toFixed(ZC._i_(l)))):o.V.push(Z))}null===ZC._n_(o.o.decimals)&&(C=Math.ceil(C/u),o.DQ=ZC._a_(c-C)<=1?c:C)}}if(2===e){var d=0,f=[];0===o.V.length?(i=ZC.MAX,t=-ZC.MAX):(i=o.V[0],t=o.V[o.V.length-1]);var _,g,v=o.A.AY.A5,b=!1;for(n=0,a=v.length;n<a;n++){var B=v[n].BU();if(-1!==ZC.AV(B,o.BE)){for(var m=0===f.length,E=0,D=v[n].S.length;E<D;E++)if(v[n].S[E])if(null!==v[n].S[E].BT){var F=v[n].S[E].BT;i=ZC.CY(i,F),t=ZC.BQ(t,F),o.NT&&m&&f.push(F),o.EF=!0,v[n].EF=!0}else b=!0;else o.NT&&m&&f.push("");v[n].EF||(d=ZC.BQ(d,v[n].S.length))}}if(null!==ZC._n_(o.o.values))for(n=0;n<o.V.length;n++)null===o.V[n]&&(o.V[n]="");if(null!==ZC._n_(o.o.labels))for(n=0;n<o.BX.length;n++)null===o.BX[n]&&(o.BX[n]="");if(d>o.V.length&&o.V.length>0&&!o.EF)for(n=o.V.length;n<d;n++);var K=0;for(n=0;n<v.length;n++)v[n].LN&&(-1===v[n].R8&&(v[n].R8=K),K++,o.DF=!0);if(0===o.V.length)for(n=0;n<K;n++)o.V.push(n),o.BX.push(n);if(0===o.V.length)if(o.EF)b&&i>0&&(i=0),b&&t<d-1&&(t=d-1),null!==ZC._n_(o.o["min-value"])&&(i=ZC._f_(o.o["min-value"])),null!==ZC._n_(o.o["max-value"])&&(t=ZC._f_(o.o["max-value"])),t-i<o.E5&&t-i>0&&(o.E5=Math.pow(10,Math.floor(ZC.G6(t-i)/Math.LN10))),o.NT||o.RQ(i,t,!0),0===i&&0===t&&"0,1"===o.V.join(",")&&(o.V=[0]);else if(null!==ZC._n_(o.o["max-value"])){_=0,g=0,null!==ZC._n_(o.o["min-value"])&&(_=ZC._f_(o.o["min-value"])),g=ZC._f_(o.o["max-value"]),n=0;var x=_;if(o.F5&&null!==ZC._n_(o.F5.o.type))switch(o.F5.o.type){case"date":o.E5=o.A1X(_,g)}else(g-_)/o.E5>1e4&&(o.E5=Math.pow(10,ZC.BQ(1,ZC._i_(ZC.G6(ZC._a_(g-_),10)-4))));for(;x<g;)x=o.A.A2P(n*o.E5+_),null===ZC._n_(o.V[n])&&(o.V[n]=x),n++}else if(g=(_=null!==ZC._n_(o.o["min-value"])?ZC._f_(o.o["min-value"]):0)+(d-1)*o.E5,"log"===o.C1)o.RQ(_,g,!0);else for(n=0;n<d;n++)null===ZC._n_(o.V[n])&&(o.V[n]=o.A.A2P(n*o.E5+_));o.NT&&o.EF&&(o.V=[].concat(f),o.BX=[].concat(f))}if(o.NT)for(o.U9={},n=0,a=o.BX.length;n<a;n++)o.U9[o.BX[n]]=n;if(o.W=0,o.A1=o.V.length-1,o.DC=0,o.DX=o.V.length-1,o.IT.length>0?(o.B3=o.W,o.BJ=o.A1):(o.B3=ZC._f_(o.V[o.W]),o.BJ=ZC._f_(o.V[o.A1])),o.NP){-1===ZC.AV(o.V,o.NP[0])&&ZC.P8(o.NP[0])&&null!==ZC._n_(o.V[0])&&-1!==o.SG&&(o.NP[0]=o.V[0]+o.SG*Math.floor((o.NP[0]-o.V[0])/o.SG)),-1===ZC.AV(o.V,o.NP[1])&&ZC.P8(o.NP[1])&&null!==ZC._n_(o.V[0])&&-1!==o.SG&&(o.NP[1]=o.V[0]+o.SG*Math.ceil((o.NP[1]-o.V[0])/o.SG));var I=ZC.AV(o.V,o.NP[0]),y=ZC.AV(o.V,o.NP[1]);o.KM=[-1===I?0:I,-1===y?o.V.length-1:y]}o.KM&&-1!==o.W&&-1!==o.A1&&((o.KM[0]>o.A1||o.KM[0]<o.W)&&(o.KM[0]=o.W),(o.KM[1]>o.A1||o.KM[1]<o.W)&&(o.KM[1]=o.A1));var w=o.H.E["graph"+o.A.L+".zoom"];if(null===ZC._n_(o.H.E.preservezoom)||o.H.E.preservezoom){var L=1===o.L?"":"-"+o.L;void 0!==w&&null!==ZC._n_(w["xmin"+L])&&null!==ZC._n_(w["xmax"+L])&&(o.KM=[w["xmin"+L],w["xmax"+L]])}else o.H.E["graph"+o.A.L+".zoom"]={};o.KM&&(o.A.A17=!0)},RQ:function(e,i,t){var n,a,l,o,r=this,s=!1,A=null!==ZC._n_(r.o.step)&&-1!==(""+r.o.step).indexOf("month");if(r.F5&&null!==ZC._n_(r.F5.o.type))switch(r.F5.o.type){case"date":var C=r.A1X(e,i);(i-e)%C!=0&&(A||(i+=C-(i-e)%C)),n=[e,i,C,1,C],s=!0}else if("log"===r.C1)n=[e,i,1,1,1];else{var c=null!==ZC._n_(r.o.step)||null!==ZC._n_(r.o["min-value"])||null!==ZC._n_(r.o["max-value"]);n=e!==i?ZC.AR.VS(e,i,r.E5,r.OY,c):[e,i,r.E5,1,r.E5]}-1===r.SG&&(r.SG=n[4]);var u=n[0],p=n[1];o=n[2],t&&"log"===r.C1&&(u=Math.floor(ZC.G6(u,r.E6)),p=Math.ceil(ZC.G6(p,r.E6))),null===ZC._n_(r.o.step)&&(p-u)/o>1e4&&(o=(p-u)/1e4,l=Math.ceil(ZC.G6(o)/Math.LN10),o=Math.pow(10,l)),null===ZC._n_(r.o["min-value"])&&u!==p&&(s&&A||(u-=u%o)),null===ZC._n_(r.o["max-value"])&&u!==p&&(s&&A||(p=p-p%o+(p%o==0?0:o))),l=Math.floor(ZC.G6(o)/Math.LN10);var Z,h=n[3];if(l<h&&l<0&&(h=l),"log"===r.C1&&(h=ZC.BQ(1,h)),r.V=[],s&&A){var d=ZC.AP.Y5(u,"%Y-%n-%d-%H-%i-%s",!1,0).split("-"),f=new Date(u).getTimezoneOffset(),_=!0,g=ZC._i_((""+r.o.step).replace("month",""));0===g&&(g=1);var v=ZC._i_(d[1]),b=ZC._i_(d[0]);for(r.V.push(u);_&&u!==p;){_=!1;var B=ZC._i_(d[2]);v+g>=12&&b++,v=(v+g)%12,(31===B&&(3===v||5===v||8===v||10===v)||B>28&&1===v)&&(B=1===v?b%4==0&&b%100!=0||b%400==0?29:28:30);var m=new Date(b,v,B,ZC._i_(d[3]),ZC._i_(d[4]),ZC._i_(d[5])),E=m.getTimezoneOffset(),D=m.getTime()+6e4*(f-E);r.V.push(D),D<p&&D<=i&&(_=!0)}}else if(t){r.FX=e,r.H0=i,r.UX=ZC._i_((p-u)/o);var F=(""+o).split("."),K=new String(F[1]||"0").length;for((p-u)%o!=0&&(p-=(p-u)%o)<i&&(p=p-(p-u)%o+o),a=u;a<=p+1e-4;a+=o){var x,I;Z=a;var y=r.DQ;if("log"===r.C1)for(var w=!0;w;)w=!1,I=x=Math.pow(r.E6,Z),x=ZC._f_(ZC._fixed_(x,y)),I<1&&I!==x&&ZC.BQ(I,x)/ZC.CY(I,x)>1.005&&(w=!0,++y>ZC.CY(20,-1===r.I1?99:r.I1)&&(w=!1));else x=null!==y?ZC._f_(ZC._fixed_(Z,Math.max(y,K))):ZC._f_(ZC._fixed_(Z,K));r.V.push(x)}}else for(o=ZC._f_((i-e)/r.UX),a=0;a<=r.UX;a++)Z=e+o*a,h<0&&(Z=ZC._f_(Z.toFixed(-h))),r.V.push(Z);r.W=0,r.A1=r.V.length-1,r.DC=0,r.DX=r.V.length-1,r.B3=ZC._f_(r.V[r.W]),r.BJ=ZC._f_(r.V[r.A1])},A1X:function(e,i,t){void 0===t&&(t=!1);var n=i-e,a=Math.floor(ZC.G6(n)/Math.LN10);return null===ZC._n_(this.o.step)||t?a<=3?1:4===a?1e3:5===a?1e4:6===a?2e4:7===a?3e4:8===a?6e4:9===a?6e5:10===a?12e5:11===a?18e5:36e5:this.E5},parse:function(){this.b()},clear:function(){this.b()},build:function(){this.b()},paint:function(){this.b(),null!==ZC._n_(this.o.values)&&(this.T9=!0)}};ZC.ZI=ZC.F3.CA(ZI);var VQ={$i:function(e){this.b(e);var i=this;i.AF="v",i.W=-1,i.A1=-1,i.UX=0,i.DQ=null,i.KR="normal",i.JM=[],i.bExtendMinValue=!0,i.bExtendMaxValue=!0},zoomTo:function(e,i){var t,n,a=this;if(a.GN){null!==ZC._n_(e)?a.B3=e:a.B3=a.FX,null!==ZC._n_(i)?a.BJ=i:a.BJ=a.H0,("piano"===a.A.AF||a.PV)&&(a.B3=ZC._i_(a.B3),a.BJ=ZC._i_(a.BJ)),a.RQ(a.B3,a.BJ,!1);var l=a.A.BU("v");for(t=0;t<l.length;t++)l[t].BE!==a.BE&&l[t].sMaster===a.BE&&l[t].zoomTo(e,i);if(""===a.sMaster){if(a.H.H1.C||(a.H.H1.C=a.A),a.A.H1&&null!==ZC._n_(a.A.H1.o.shared)&&ZC._b_(a.A.H1.o.shared)&&a.A.K===a.H.H1.C.K)for(t=0,n=a.H.AG.length;t<n;t++){var o=a.H.AG[t];if(o.K!==a.A.K&&null!==ZC._n_(o.H1.o.shared)&&ZC._b_(o.H1.o.shared)){var r=o.BM(a.BE);r&&r.GN&&(e=Math.max(r.FX,Math.min(r.H0,a.B3)),i=Math.max(r.FX,Math.min(r.H0,a.BJ)),r.zoomTo(e,i),ZC.AL(o.K)&&(o.clear(!0),o.E["shared-zoom"]=!0,o.paint(),o.B9&&o.B9.update(null,null,e,i,!0)))}}a.IZ()}}},FQ:function(L,CU,ER){var s=this;void 0===CU&&(CU="",CU=null!==ZC._n_(s.BX[L])?s.BX[L]:s.V[L]),"number"==typeof CU&&null!==ZC._n_(s.JM[CU])&&(CU=s.JM[CU]);var OO=ZC.P8(CU)&&ZC._f_(CU)<0,BC=s.MR();if(ZC._cp_(ER,BC),null!==ZC._n_(s.E["max-power"])&&(BC["max-power"]=s.E["max-power"]),OO&&"currency"===BC.negation&&(CU=ZC._a_(ZC._f_(CU))),BC.utc=s.A.UN,BC.timezone=s.A.ND,CU=ZC.AP.G2(CU,BC,s,!0),s.CI)if("()"===s.CI.substring(s.CI.length-2)||"javascript:"===s.CI.substring(0,11))try{var EC=s.CI.replace("javascript:","").replace("()","");eval(EC)&&(CU=eval(EC).call(s,CU))}catch(e){}else CU=OO&&"currency"===BC.negation?"-"+s.CI.replace(/%v|%scale-value/g,CU):s.CI.replace(/%v|%scale-value/g,CU);return CU},A7U:function(){var e=this,i=ZC.BQ(e.V.length,e.BX.length);if(0===i&&(i=10),"log"===e.C1)e.EG=999;else{var t=Math.max(15,10*ZC.BQ(e.V.join("").length,e.BX.join("").length)/i);e.CO?e.EG=ZC._i_((e.I-e.AC-e.BV)/t):e.EG=ZC._i_((e.F-e.AC-e.BV)/10),e.EG=ZC.CY(e.EG,10),e.EG=ZC.BQ(2,e.EG)}},AC9:function(){var e=this;null===ZC._n_(e.o["max-ticks"])&&(e.M1=e.EG)},A9T:function(e){var i,t,n,a,l,o,r,s=this;if(""!==s.sMaster&&2===e){var A=s.A.BM(s.sMaster);if(A)return s.B3=A.B3,s.FX=A.FX,s.BJ=A.BJ,s.H0=A.H0,s.E5=A.E5,s.SG=A.SG,s.W=A.W,s.A1=A.A1,s.DC=A.DC,s.DX=A.DX,s.V=[].concat(A.V),void(s.BX=[].concat(A.BX))}1===e&&null===ZC._n_(s.o.values)&&null!==ZC._n_(i=s.A.ABG("v"))&&(s.o.values=i);var C,c=0,u=s.JM;if(1===e&&null!==ZC._n_(s.o.values)){if(s.V=[],"object"==typeof s.o.values){var p=s.o.values,Z=ZC.XZ(p),h=ZC.A1L(p),d=!0;for(t=0,n=p.length-2;t<n;t++)if("number"==typeof p[t+2]&&"number"==typeof p[t+1]&&"number"==typeof p[t]&&ZC._f_(p[t+2])-ZC._f_(p[t+1])!=ZC._f_(p[t+1])-ZC._f_(p[t])){d=!1;break}if(!d&&(s.o.values=Z+":"+h,!s.LS))for(s.LS=[],t=0,n=p.length;t<n;t++)s.LS.push(""+p[t])}if("object"==typeof s.o.values){for(ZC._cpa_(s.o.values,s.V),0===s.BX.length&&ZC._cpa_(s.BX,s.V),t=0,n=s.V.length;t<n;t++)if("string"==typeof s.V[t]){var f=s.V[t],_=ZC.AV(u,s.V[t]);-1===_||s.bAllowDuplicates?(u.push(s.V[t]),s.V[t]=u.length-1):s.V[t]=_,null===ZC._n_(s.BX[t])&&(s.BX[t]=f)}}else{var g=s.o.values.split(":");if(r=1,3===g.length&&(r=ZC._f_(g[2])),ZC._f_(g[0])>ZC._f_(g[1])){var v=g[0];g[0]=g[1],g[1]=v}if(r<=0&&(r=1),null!==ZC._n_(s.o["fixed-items"])&&(r=(ZC._f_(g[1])-ZC._f_(g[0]))/ZC.BQ(1,ZC._i_(s.o["fixed-items"])-1),s.UX=ZC.BQ(1,ZC._i_(s.o["fixed-items"])-1)),g.length>1){for(var b=0,B=0,m=0,E=(""+r).split("."),D=ZC._f_(g[0]);D<=ZC._f_(g[1]);D+=r)a=(""+D).split("."),E.length>1&&a.length>1&&E[1].length>0&&a[1].length>=9&&ZC._a_(a[1].length-E[1].length)>2?(b+=E[1].length,B=ZC.BQ(B,E[1].length),m++,s.V.push(ZC._f_(ZC._fixed_(Number(D),E[1].length)))):(b+=ZC._i_(a[1]?a[1].length:0),B=ZC.BQ(B,a[1]?a[1].length:0),m++,s.V.push(D));D-ZC._f_(g[1])!=0&&ZC._a_(D-ZC._f_(g[1]))/r<1e-8&&s.V.push(ZC._f_(g[1])),null===ZC._n_(s.o.decimals)&&(b=(a=(""+r).split("."))[1]?a[1].length:Math.ceil(b/m),s.DQ=ZC._a_(B-b)<=1?B:b)}}s.W=0,s.A1=s.V.length-1,s.E5=r,u.length>1?(c=ZC.XZ(s.V,!0),s.B3=ZC.XZ(s.V),s.BJ=ZC.A1L(s.V)):(s.B3=s.V[0],s.BJ=s.V[s.V.length-1]),"log"===s.C1&&(0===s.B3&&(C=Math.floor(ZC.G6(c,s.E6)),s.B3=Math.pow(s.E6,Math.min(-1,C))),s.RQ(ZC.G6(s.B3,s.E6),ZC.G6(s.BJ,s.E6),!1))}if(2===e){var F={};null===ZC._n_(s.o.values)&&(s.V=[],l=ZC.MAX,o=-ZC.MAX);var K=[],x=s.A.AY.A5;for(t=0,n=x.length;t<n;t++)if(s.A.E["plot"+t+".visible"]||"hide"===s.A.getToggleAction()){var I=x[t].BU();if(-1!==ZC.AV(I,s.BE))for(var y=-1!==ZC.AV(["vbar","hbar","vbar3d","hbar3d"],x[t].AF),w=[],L=0,X=x[t].V.length;L<X;L++)if(x[t].S[L]){var Y=null===x[t].S[L].BT?L:x[t].S[L].BT;if(x[t].CC&&-1!==ZC.AV(w,Y))continue;w.push(Y);var M=x[t].LX&&null!==ZC._n_(x[t].LX[L])?ZC._f_(x[t].LX[L]):0;if(x[t].CC)null===ZC._n_(F[x[t].DZ])&&(F[x[t].DZ]=[]),null===ZC._n_(F[x[t].DZ][Y])?x[t].S[L].AD>=0||!y?F[x[t].DZ][Y]=[x[t].S[L].AD,0]:F[x[t].DZ][Y]=[0,x[t].S[L].AD]:x[t].S[L].AD>=0||!y?F[x[t].DZ][Y][0]+=x[t].S[L].AD:F[x[t].DZ][Y][1]+=x[t].S[L].AD,x[t].S[L].AD>=0||!y?x[t].S[L].CS=F[x[t].DZ][Y][0]:x[t].S[L].CS=F[x[t].DZ][Y][1],null===ZC._n_(s.o.values)&&K.push(F[x[t].DZ][Y][0]+M,F[x[t].DZ][Y][1]+M);else if(null===ZC._n_(s.o.values)){K.push(x[t].S[L].AD+M),0!==M&&K.push(M);for(var H=0,P=x[t].S[L].DP.length;H<P;H++)K.push(x[t].S[L].DP[H]+M)}}}K.length>0&&(c=ZC.XZ(K,!0),l=ZC.XZ(K),o=ZC.A1L(K)),0!==s.V.length||l!==Number.MAX_VALUE&&o!==Number.MIN_VALUE||(s.V=[0,1],l=0,o=1),null===ZC._n_(s.o.values)&&(null!==ZC._n_(s.o["min-value"])&&"auto"!==s.o["min-value"]?l=ZC._f_(s.o["min-value"]):l>0&&"auto"!==s.o["min-value"]&&"log"!==s.C1&&(l=0),null!==ZC._n_(s.o["max-value"])&&(o=ZC._f_(s.o["max-value"])),l===ZC.MAX&&o===-ZC.MAX?(s.W=0,s.A1=0,s.B3=0,s.BJ=0):"log"===s.C1?(0===l&&(C=Math.floor(ZC.G6(c,s.E6)),l=Math.pow(s.E6,Math.min(-1,C))),s.RQ(ZC.G6(l,s.E6),ZC.G6(o,s.E6),!1)):s.RQ(l,o,!0))}2===e&&(-1===s.FX&&-1===s.H0&&(s.FX=s.B3,s.H0=s.BJ),-1===s.SG&&(s.SG=s.E5)),"auto"===s.o["min-value"]&&null===ZC._n_(s.o["ref-value"])&&(s.H8=s.B3),0===s.UX&&(s.UX=ZC._i_((s.BJ-s.B3)/s.E5));var N=s.H.E["graph"+s.A.L+".zoom"];if(null===ZC._n_(s.H.E.preservezoom)||s.H.E.preservezoom){var S=1===s.L?"":"-"+s.L;2===e&&void 0!==N&&null!==ZC._n_(N["ymin"+S])&&null!==ZC._n_(N["ymax"+S])&&(ZC.DS(N["ymin"+S],s.B3,s.BJ)||(N["ymin"+S]=s.B3),ZC.DS(N["ymax"+S],s.B3,s.BJ)||(N["ymax"+S]=s.BJ),s.KM=[N["ymin"+S],N["ymax"+S]])}else s.H.E["graph"+s.A.L+".zoom"]={};s.KM&&(s.A.A17=!0)},RQ:function(e,i,t){var n,a,l,o,r=this;"piano"!==r.A.AF&&!r.PV&&r.JM.length>1&&(e=0),r.TT.length&&null===ZC._n_(r.o["scale-factor"])&&(l=Math.floor(ZC.G6(ZC._a_(i),ZC._f_(r.TT[0]))),r.OY=Math.pow(ZC._f_(r.TT[0]),l)/Math.pow(1e3,l),r.E["max-power"]=l);var s=(o=r.F5&&"date"===r.F5.o.type?ZC.AR.VS(e,i,"lin"===r.C1?r.E5:null,r.OY,r.bNormalize,r.EG):ZC.AR.VS(e,i,"lin"===r.C1?r.o.step:null,r.OY,r.bNormalize,r.EG))[0],A=o[1],C=!1;a=Math.floor(o[0]),"log"===r.C1&&(l=Math.ceil(o[1]),o[1]-o[0]>=.5?C=!0:o=ZC.AR.VS(Math.pow(r.E6,o[0]),Math.pow(r.E6,o[1]),null,r.OY,r.bNormalize));var c,u,p=o[0],Z=o[1],h=o[2];if(null!==ZC._n_(r.o["fixed-items"])&&(h=(Z-p)/ZC.BQ(1,ZC._i_(r.o["fixed-items"])-1)),r.PV&&i===e&&(i+h<=r.BJ?i+=h:e-=h),1!==r.R1&&(p*=r.R1,Z*=r.R1,h*=r.R1),null!==ZC._n_(r.E["o-decimals"])?r.DQ=r.E["o-decimals"]:r.E["o-decimals"]=r.DQ,null===ZC._n_(r.o.decimals))if("log"===r.C1&&C)r.DQ=a<0?null:0;else if(r.bNormalize)r.A33||(r.DQ=0);else{var d=ZC.G6(i-e,10);r.DQ=o[3],r.DQ>9&&(d>=1?r.DQ=1:d>0&&d<1&&(r.DQ=2))}var f,_,g,v=!0;if(C){var b,B;a=Math.floor(p),l=Math.ceil(Z),f=Math.pow(r.E6,e),_=Math.pow(r.E6,i),r.V=[];var m=[0,2,5];for(B=[0,1,2,3,4,5,6,7,8,9,10],n=a;n<=l;n++){var E=o[3];if(E=n<0?Math.max(ZC._a_(n),E):0,n===l)for(b=0;b<m.length;b++)g=Math.pow(r.E6,n)+m[b]*Math.pow(r.E6,n-1),g=ZC._f_(g.toFixed(E)),-1===ZC.AV(r.V,g)&&r.V.push(g);for(b=0;b<B.length;b++)g=B[b]*Math.pow(r.E6,n),g=ZC._f_(g.toFixed(E)),-1===ZC.AV(r.V,g)&&r.V.push(g)}r.V.sort(function(e,i){return e-i});for(var D=-1,F=-1,K=0;K<r.V.length-1;K++)r.V[K]<=f&&f<=r.V[K+1]&&(D=K),r.V[K]===_?F=K:r.V[K]<=_&&_<=r.V[K+1]&&(F=K+1);r.V=r.V.slice(D,F+1),0===r.V[0]&&r.V.shift(),s=ZC.G6(r.V[0],r.E6),A=ZC.G6(r.V[r.V.length-1],r.E6)}else{for("log"===r.C1&&(f=Math.pow(r.E6,e),_=Math.pow(r.E6,i));v;){v=!1,r.V=[],c=u=p;do{u=c,u=ZC._f_(u.toFixed(r.DQ)),-1!==ZC.AV(r.V,u)&&(v=!0),"log"===r.C1?u>=p&&u<=Z&&r.V.push(u):r.V.push(u),c+=h,c=ZC._f_(c.toFixed(o[3]))}while(c<=Z);v&&(r.DQ+=1)}"log"===r.C1&&(s=ZC.G6(p,r.E6),A=ZC.G6(Z,r.E6),r.V.push(p),r.V.push(Z),r.V.sort(function(e,i){return e-i}))}r.E5=h,r.W=0,r.A1=r.V.length-1,t?(r.B3=r.bExtendMinValue?s:e,r.BJ=r.bExtendMaxValue?A:i):(r.B3=e,r.BJ=i)},parse:function(){var e=this;e.assign_a([["stack-type","KR"],["extend-min-value","bExtendMinValue","b"],["extend-max-value","bExtendMaxValue","b"]]),(e.A.CC&&"100%"===e.A.KR||"100%"===e.KR)&&null===ZC._n_(e.o.values)&&(e.o.values="0:100:20",e.o.format="%v%"),this.b()},clear:function(){this.b()},build:function(){this.b()},paint:function(){this.b(),null===ZC._n_(this.E.decimals)&&(this.E.decimals=null!==ZC._n_(this.DQ)?this.DQ:-1),null!==ZC._n_(this.o.values)&&(this.T9=!0)}};ZC.VQ=ZC.F3.CA(VQ);var Q2={$i:function(e){this.b(e)},parse:function(){this.b()},IZ:function(){var e=this;e.A1===e.W?e.AA=e.I-e.AC-e.BV:e.AA=(e.I-e.AC-e.BV)/(e.A1-e.W+(e.DF?1:0))},A9T:function(e){this.b(e),this.IZ()},zoomTo:function(e,i){this.b(e,i);this.IZ()},clear:function(){},build:function(){this.b()},NE:function(e){var i,t=this;return i=t.AW?(t.iX+t.I-t.AC-e)/(t.I-t.AC-t.BV):(e-t.iX-t.AC)/(t.I-t.AC-t.BV),t.B3+ZC._f_((t.BJ-t.B3)*i)},O9:function(e,i,t){var n,a,l,o=this;void 0===t&&(t=!1);var r=o.DF?o.AA:0;l=o.AW?(o.iX+o.I-e-o.AC-r/2)/(o.I-o.AC-o.BV-r):(e-o.iX-o.AC-r/2)/(o.I-o.AC-o.BV-r);var s,A=!1;if(i)for(s in i.K4){A=!0;break}if(i&&!o.NT&&A){var C=o.V[o.W];"string"==typeof C&&(C=ZC.AV(o.IT,C)),"log"===o.C1&&(C=ZC.G6(C,o.E6));var c=o.V[o.A1];"string"==typeof c&&(c=ZC.AV(o.IT,c)),"log"===o.C1&&(c=ZC.G6(c,o.E6));var u=C+ZC._f_((c-C)*l);"log"===o.C1&&(u=Math.pow(o.E6,u));var p=ZC.MAX;for(s in a=null,i.K4)(n=Math.abs(s-u))<p&&(p=n,a=i.K4[s]);if(null===ZC._n_(a)&&(a=u),p>i.A2K){var Z=Math.ceil((c-C)/(o.I-o.AC-o.BV));if(i.V.length<2&&(Z*=100),p>Z)return null}return a}var h=o.W,d=o.A1;return o.EF&&(null!==ZC._n_(n=o.V[h])&&(h=n),null!==ZC._n_(n=o.V[d])&&(d=n)),"log"===o.C1&&(h=ZC.G6(h,o.E6),d=ZC.G6(d,o.E6)),a=t?o.DF?h+(d-h+1)*l:h+(d-h)*l:(o.DF,o.W+(o.A1-o.W)*l),"log"===o.C1?(a=Math.pow(o.E6,a),a=Math.round(a)-1):(a=ZC._i_(a),a=ZC.BQ(0,a),a=ZC.CY(o.DX,a)),a},IB:function(e){var i=this;i.W,i.A1;return i.EF&&!i.NT&&(i.B3,i.BJ),"log"===i.C1&&(e=ZC.G6(e+1,i.E6)),i.AW?i.iX+i.I-i.AC-(e-i.W+(i.DF?1:0))*i.AA+(i.DF?i.AA/2:0):i.iX+i.AC+(e-i.W)*i.AA+(i.DF?i.AA/2:0)},AT:function(e){var i,t,n,a,l,o=this;if("log"===o.C1&&(0===e&&(e=o.B3),e=ZC.G6(e,o.E6)),o.NT){var r=o.U9[e];return o.IB(r)}if(-1!==(i=ZC.AV(o.IT,e)))return o.IB(i);if(!o.A5E&&(o.EF||o.F5&&"date"===o.F5.o.type)){a=o.V[o.W],l=o.V[o.A1];var s=o.I;return"log"===o.C1&&(a=ZC.G6(a,o.E6),l=ZC.G6(l,o.E6),o.W===o.DC&&o.A1===o.DX&&(s=(o.A1-o.W)*o.AA)),l===a?t=0:(n=l-a,t=(s-o.AC-o.BV-(o.DF?o.AA:0))/n),o.AW?o.iX+o.I-o.AC-(e-a)*t-(o.DF?o.AA/2:0)+o.iMinOffset:o.iX+o.AC+(e-a)*t+(o.DF?o.AA/2:0)-o.iMinOffset}return a=o.B3,l=o.BJ,"log"===o.C1&&(a=ZC.G6(a,o.E6),l=ZC.G6(l,o.E6)),l===a?t=0:(n=l-a+(o.DF?1:0),t=(o.I-o.AC-o.BV)/n),o.AW?o.iX+o.I-o.AC-(e-a)*t-(o.DF?o.AA/2:0):o.iX+o.AC+(e-a)*t+(o.DF?o.AA/2:0)},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f=this;f.b(),null!==ZC._n_(f.A.A.E[f.BE+"-feed-offset-start"])&&(f.AC=f.A.A.E[f.BE+"-feed-offset-start"]),"bubble"!==f.A.AF&&"scatter"!==f.A.AF||(-1===f.AC&&-1===f.BV||1===f.V.length)&&(f.AC=f.BV=f.I/(f.V.length+1),f.IZ());var _=f.BJ,g=f.B3;if("log"===f.C1&&(null!==ZC._n_(f.o["max-value"])&&(_=ZC._f_(f.o["max-value"])),null!==ZC._n_(f.o["min-value"])&&(g=ZC._f_(f.o["min-value"])),(_!==f.BJ||g!==f.B3)&&f.W===f.DC&&f.A1===f.DX)){var v=f.AA;f.AA=(f.I-f.AC-f.BV)/(ZC.G6(_,f.E6)-ZC.G6(g,f.E6))-.1;var b=ZC.G6(g,f.E6)-ZC.G6(f.B3,f.E6),B=ZC.G6(f.BJ,f.E6)-ZC.G6(_,f.E6);f.iMinOffset=b*(f.AA-v)*(f.V.length-1)/(B+b)}var m=f.A0E(),E=0,D=1,F=1,K={};for(i=0,t=f.A.BO.length;i<t;i++)"scale-x"===f.A.BO[i].BE.substring(0,7)&&f.A.BO[i].BA===f.BA&&E++,"scale-x"===f.A.BO[i].BE.substring(0,7)&&("default"===f.A.BO[i].BA?(K[f.A.BO[i].BE]=D,D++):(K[f.A.BO[i].BE]=F,F++));var x=K[f.BE],I="default"===f.BA,y=null,w=null;for(i=0,t=f.A.AY.A5.length;i<t;i++){var L=f.A.AY.A5[i],X=L.BU();if(-1!==ZC.AV(X,f.BE)){var Y=f.A.BM(L.BU("v")[0]);y=Y.AT(Y.H8),w=L;break}}var M=8;null!==ZC._n_(f.IU.o.size)&&(M=ZC._i_(f.IU.o.size));var H=4;null!==ZC._n_(f.I9.o.size)&&(H=ZC._i_(f.I9.o.size));var P=ZC._i_(f.A.E[f.BE+"-distance"]||-1);f.VB&&(P=0),"default"===f.BA?(A=ZC._i_(f.A.P.DR/E),a=f.iY+f.F+(x-1)*A,-1!==P&&(a=f.iY+f.F+P)):(A=ZC._i_(f.A.P.E8/E),a=f.iY-(x-1)*A,-1!==P&&(a=f.iY-P));var N=a;if(f.A.HS&&(f.A.HS.AN=!0,f.DC===f.W&&f.DX===f.A1&&(f.A.HS.AN=!1),f.A.HS.AN&&0===f.A.HS.B0.BH&&"default"===f.BA&&(a+=f.A.HS.B0.F+f.AZ/2)),f.E.iY=a,f.AN&&f.T9){null!==ZC._n_(f.o["fixed-items"])&&(f.M1=f.EG=ZC._i_(f.o["fixed-items"]));var S=ZC.BQ(1,Math.ceil((f.A1-f.W)/(f.M1-1))),O=ZC.BQ(1,Math.ceil((f.A1-f.W)/(f.EG-1)));null===ZC._n_(f.o["fixed-items"])&&ZC._b_(f.o.normalize)&&(S=ZC.AR.A0K(S),O=ZC.AR.A0K(O));for(var G=f.iStepMultiplier,k=3;k>0;k--)f.iStepMultiplier>k&&f.A1-f.W<=k*f.iStepMultiplier&&(G=k);S*=G,O*=G;var T,z,Q,J=0,V=f.AA*S/(f.FR+1),R=f.AW?f.iX+f.BV:f.iX+f.AC,W=f.AW?f.iX+f.I-f.AC:f.iX+f.I-f.BV;if(null===ZC._n_(y)&&(y=a),l=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),r=ZC.Q.EB(l,f.H.AB),o=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-bl-0-c"),s=ZC.Q.EB(o,f.H.AB),"inherit"===f.o["line-color"]&&-1!==m&&(f.B7=m),f.A.AJ["3d"]){if((Z=ZC.DK.DB(f,f.A,f.iX-ZC.AO.E2,f.iX-ZC.AO.E2+f.I,a-ZC.AO.E3,a-ZC.AO.E3,-1,ZC.AO.FU+1,"x")).K=f.K+"-line",f.A.EZ.true3d&&(f.A.EZ["x-angle"]>0?Z.MC=[1===f.L?-100:100,1,1]:Z.MC=[1===f.L?100:-100,1,1]),f.A.CL.add(Z),null!==ZC._n_(f.o.axis)){var U=new ZC.D0(f);U.append(f.o.axis),U.parse(),U.A0=U.AE=U.B7,(Z=ZC.DK.DB(U,f.A,f.iX-ZC.AO.E2,f.iX-ZC.AO.E2+f.I,a-ZC.AO.E3,a-ZC.AO.E3,-U.AZ/2,U.AZ/2,"x")).K=f.K+"-axis",f.A.CL.add(Z)}}else{C=[[f.iX-1,N],[f.iX+f.I+1,N]];var j=f.K;f.K+="-line",ZC.CR.paint(r,f,C),f.K=j}if(f.V.length>0&&f.D7.AN){var q=null===ZC._n_(f.D7.o["offset-start"])?0:ZC._i_(f.D7.o["offset-start"]),$=null===ZC._n_(f.D7.o["offset-end"])?0:ZC._i_(f.D7.o["offset-end"]);if(f.D7.o.items&&f.D7.o.items.length>0&&!f.A.AJ["3d"])for(h=new ZC.HL(f),i=f.W;i<f.A1+(f.DF?1:0);i++)c=i-f.W,d=i%f.D7.o.items.length,h.append(f.D7.o.items[d]),h.K=f.K+"-guide-"+i,h.Z=o,h.parse(),f.AW?h.iX=f.iX+f.I-f.AC-c*f.AA-f.AA:h.iX=f.iX+f.AC+c*f.AA,h.iY=f.iY+q,h.I=f.AA,h.F=f.F-q-$,h.paint();if(f.D7.AZ>0)for(f.GT=0,i=f.W;i<=f.A1+(f.DF?1:0);i++)if(f.K3=i,i===f.W||i===f.A1+(f.DF?1:0)||(i-f.W)%S==0){(f.D7.E7.length>0||i===f.W)&&((p=new ZC.D0(f)).Z=p.C7=o,p.copy(f.D7),p.J2=Xe,p.DE()&&p.parse()),C=[],c=i-f.W,u="log"===f.C1?f.AT(f.V[i]):f.AW?f.iX+f.I-f.AC-c*f.AA:f.iX+f.AC+c*f.AA;var ee=f.iY+q,ie=f.F-q-$;if(p.AN)if(f.A.AJ["3d"]){var te=new ZC.D0(f);te.copy(p),null!==ZC._n_(f.o["scale-z"])&&null!==ZC._n_(e=f.o["scale-z"].guide)&&(te.append(e),te.parse()),te.A0=te.AE=te.B7,Z=ZC.DK.DB(te,f.A,u-ZC.AO.E2-te.AZ/2,u-ZC.AO.E2+te.AZ/2,a-ZC.AO.E3,a-ZC.AO.E3,0,ZC.AO.FU,"z"),f.A.CL.add(Z),p.A0=p.AE=p.B7,(Z=ZC.DK.DB(p,f.A,u-ZC.AO.E2-p.AZ/2,u-ZC.AO.E2+p.AZ/2,ee-ZC.AO.E3,ee+ie-ZC.AO.E3,ZC.AO.FU+2,ZC.AO.FU+2,"y")).K=f.K+"-guide-"+i,f.A.CL.add(Z)}else C.push([u,ee],[u,ee+ie]),p.K=f.K+"-guide-"+i,ZC.CR.paint(s,p,C);f.GT++}}if(f.V.length>0&&f.G5.AN&&!f.A.AJ["3d"]&&f.G5.o.items&&f.G5.o.items.length>0)for(h=new ZC.HL(f),i=f.W;i<f.A1+(f.DF?1:0);i++)for(f.K3=i,c=i-f.W,f.GT=0,n=1;n<=f.FR;n++)d=f.GT%f.G5.o.items.length,h.append(f.G5.o.items[d]),h.K=f.K+"-guide-"+i+"-"+n,h.Z=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-bl-0-c"),h.parse(),f.AW?h.iX=f.iX+f.I-f.AC-c*f.AA-(n+1)*V:h.iX=f.iX+f.AC+c*f.AA+n*V,h.iY=f.iY,h.I=V,h.F=f.F,h.paint(),f.GT++;if(f.G5.AZ>0)for(i=f.W;i<f.A1+(f.DF?1:0);i++)if(f.K3=i,i%S==0)for(c=i-f.W,f.GT=0,n=1;n<=f.FR;n++)C=[],(p=new ZC.D0(f)).copy(f.G5),p.J2=Xe,p.DE()&&p.parse(),u="log"===f.C1?f.AT(f.V[i]+n*(f.V[i+1]-f.V[i])/(f.FR+1)):f.AW?f.iX+f.I-f.AC-c*f.AA-n*V:f.iX+f.AC+c*f.AA+n*V,ZC.DS(u,R,W)&&(C.push([u,f.iY],[u,f.iY+f.F]),p.AN&&(p.K=f.K+"-minor-guide-"+n,ZC.CR.paint(s,p,C))),f.GT++;if(f.VG(s,m),f.V.length>0&&f.IU.AN){switch(f.IU.o.placement){case"inner":break;case"outer":J+=M;break;default:J+=M/2}if(!zingchart.DEV.SMARTDATELABELS||!f.F5||"date"!==f.F5.o.type)for(f.GT=0,i=f.W;i<=f.A1+(f.DF?1:0);i++)if(i===f.W||i===f.A1+(f.DF?1:0)||(i-f.W)%S==0){f.K3=i;var ne=M;if(C=[],c=i-f.W,(f.IU.E7.length>0||i===f.W)&&((p=new ZC.DT(f)).copy(f.IU),"inherit"===f.IU.o["line-color"]&&-1!==m&&(p.B7=m),p.J2=Xe,p.DE()&&p.parse(),p.AI>1&&(ne=p.AI)),u="log"===f.C1?f.AT(f.V[i]):f.AW?f.iX+f.I-f.AC-c*f.AA:f.iX+f.AC+c*f.AA,ZC.DS(u,R,W)){switch(p.o.placement){case"ref-auto":C.push([u,y+ne/2],[u,y-ne/2]);break;case"ref-top":C.push([u,y-ne],[u,y]);break;case"ref-bottom":C.push([u,y+ne],[u,y]);break;case"inner":C.push([u,a-(I?ne:-ne)],[u,a]);break;case"outer":C.push([u,a],[u,a+(I?ne:-ne)]);break;default:C.push([u,a+ne/2],[u,a-ne/2])}if(p.AN){for(z=ZC._i_(p.o["offset-x"]||"0"),Q=ZC._i_(p.o["offset-y"]||"0"),T=0;T<C.length;T++)C[T][0]+=z,C[T][1]+=Q;if(p.K=f.K+"-tick-"+i,f.A.AJ["3d"]&&f.A.EZ.true3d){var ae,le=[];for(T=0;T<C.length;T++)ae=new ZC.CE(f.A,C[T][0]-ZC.AO.E2,C[T][1]-ZC.AO.E3,0),le.push([ae.ED[0],ae.ED[1]]);ZC.CR.paint(r,p,le)}else ZC.CR.paint(r,p,C)}}f.GT++}}var oe=[];if(f.V.length>0&&f.FR>0&&f.I9.AN&&!f.A.AJ["3d"])for(i=f.W;i<f.A1+(f.DF?1:0);i++)if(f.K3=i,i%S==0)for(c=i-f.W,f.GT=0,n=1;n<=f.FR;n++){if(C=[],(p=new ZC.D0(f)).copy(f.I9),"inherit"===f.I9.o["line-color"]&&-1!==m&&(p.B7=m),p.J2=Xe,p.DE()&&p.parse(),"log"===f.C1){var re=Math.round(ZC.G6(f.V[i],f.E6)),se=f.V[i]+n*(f.V[i+1]-f.V[i])/(f.FR+1);se=re<0?ZC._f_(se.toFixed(-re)):ZC._f_(se.toFixed(re)),oe.push(se),u=f.AT(se)}else u=f.AW?f.iX+f.I-f.AC-c*f.AA-n*V:f.iX+f.AC+c*f.AA+n*V;if(ZC.DS(u,R,W)){switch(p.o.placement){case"ref-auto":C.push([u,y+H/2],[u,y-H/2]);break;case"ref-top":C.push([u,y],[u,y-H]);break;case"ref-bottom":C.push([u,y],[u,y+H]);break;case"inner":C.push([u,a-(I?H:-H)],[u,a]);break;case"outer":C.push([u,a],[u,a+(I?H:-H)]);break;default:C.push([u,a+H/2],[u,a-H/2])}if(p.AN){for(z=ZC._i_(p.o["offset-x"]||"0"),Q=ZC._i_(p.o["offset-y"]||"0"),T=0;T<C.length;T++)C[T][0]+=z,C[T][1]+=Q;p.K=f.K+"-minor-tick-"+i,ZC.CR.paint(r,p,C)}}f.GT++}f.XO();var Ae=null,Ce=null,ce=f.CI,ue=f.DQ,pe=[],Ze=new ZC.DT(f);Ze.copy(f.IU);var he,de=0,fe=0,_e=0,ge=[],ve=[];if(f.o["custom-items"])for(i=0;i<f.o["custom-items"].length;i++)Ye(f.o["custom-items"][i][0],!1,!0,f.o["custom-items"][i][1]);if(f.V.length>0&&f.BR.AN)if(zingchart.DEV.SMARTDATELABELS&&f.F5&&"date"===f.F5.o.type){var be=f.getOptimalDateInterval(f.V[f.A1]-f.V[f.W]),Be=be[0];he=be[1];var me=be[2],Ee=be[3];_e=be[4];var De=me*Math.ceil(f.V[f.W]/me),Fe=me*Math.floor(f.V[f.A1]/me),Ke="";f.GT=0;var xe=!0;for(i=De;i<=Fe;i+=me){xe=!0;var Ie=ZC.AP.Y5(i,Be,f.A.UN,f.A.ND);if(Ie!==Ke){switch(Ee){case"yr":_e>15&&(xe=ZC._i_(Ie)%2==0);break;case"mon":_e>15&&(xe=ZC._i_(Ie)%3==0);break;case"day":_e>45?xe=1===ZC._i_(Ie)||15===ZC._i_(Ie):_e>30?xe=1===ZC._i_(Ie)||10===ZC._i_(Ie)||20===ZC._i_(Ie):_e>15&&(xe=1===ZC._i_(Ie)||10===ZC._i_(Ie)||15===ZC._i_(Ie)||20===ZC._i_(Ie)||25===ZC._i_(Ie));break;case"hr":_e>45?xe=ZC._i_(Ie)%12==0:_e>30?xe=ZC._i_(Ie)%6==0:_e>15&&(xe=ZC._i_(Ie)%3==0);break;case"min":case"sec":_e>45?xe=ZC._i_(Ie)%30==0:_e>30?xe=ZC._i_(Ie)%10==0:_e>15&&(xe=ZC._i_(Ie)%5==0)}xe&&(Ye(i,!0),Ke=Ie)}}Ze.AN&&(Ze.K=f.K+"-ticks",ZC.CR.paint(r,Ze,pe))}else for(f.GT=0,Ye(f.W),f.GT=f.A1-f.W,Ye(f.A1),f.GT=1,i=f.W+1;i<f.A1;i++)(i-f.W)%O==0&&Ye(i);for(i=0;i<oe.length;i++){var ye=f.FQ(i,null,null,!1,oe[i]);Ye(ye,!1,!0,ye)}if(f.M.AN&&f.M.AM&&""!==f.M.AM){(Ae=new ZC.DN(f)).copy(f.M),Ae.K=f.A.K+"-"+f.BE.replace(/\-/g,"_")+"-item_title",Ae.GL=f.K+"-label "+f.A.K+"-scale-label zc-scale-label",Ae.AM=f.M.AM,Ae.Z=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),Ae.IL=f.H.usc()?ZC.AL(f.H.K+"-main"):ZC.AL(f.H.K+"-text"),Ae.parse(),"inherit"!==f.M.o["font-color"]&&"inherit"!==f.M.o.color||-1===m||(Ae.C2=m);var we=f.iX+(f.AW?f.BV:f.AC),Le=f.I-f.AC-f.BV;switch("chart"===Ae.o["center-point"]&&(we=f.A.iX,Le=f.A.I),Ae.OD){case"left":Ae.iX=we;break;case"center":Ae.iX=we+Le/2-Ae.I/2;break;case"right":Ae.iX=we+Le-Ae.I}Ae.iY=I?a+J+fe:a-Ae.F-J-fe,f.M.iX=Ae.iX,f.M.iY=Ae.iY,Ae.AN&&(f.MY(Ae,null,"h"),Ae.paint(),Ae.EK(),null===ZC._n_(Ae.o.tooltip)&&Ae.K9||ve.push(ZC.AP.O4(f.A.K,Ae)))}ve.length>0&&ZC.AL(f.A.A.K+"-map")&&(ZC.AL(f.A.A.K+"-map").innerHTML+=ve.join("")),null!==ZC._n_(f.o.transform)&&"date"===f.o.transform.type&&f.paintTransformDate()}function Xe(e){return e=(e=(e=(e=(e=(e=e.replace(/%scale-last-position/g,f.A1-f.W)).replace(/(%c)|(%scale-position)/g,f.GT)).replace(/(%i)|(%scale-index)/g,f.K3)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(f.V[f.K3])?f.V[f.K3]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(f.BX[f.K3])?f.BX[f.K3]:"")).replace(/%scale-day-of-week/g,ZC.AP.Y5(f.V[f.K3],"%w",f.A.UN,f.A.ND))}function Ye(e,i,t,n){var l;if(f.K3=e,c=e-f.W,(f.BR.E7.length>0||e===f.W||!Ae||f.BR.HT||t)&&(Ae=new ZC.DN(f)),Ae.copy(f.BR),Ae.GL=f.K+"-item "+f.A.K+"-scale-item zc-scale-item",Ae.K=f.A.K+"-"+f.BE.replace(/\-/g,"_")+"-item_"+(n?"c"+n:e),Ae.E["p-width"]=f.AA,f.CI=ce,f.DQ=ue,t||f.YM(Xe),l=i?ZC.AP.Y5(e,he,f.A.UN,f.A.ND):n||f.FQ(e,null,null),!t&&f.BR.HT){var o=f.A.GX();ZC._cp_({index:e,cnt:c,text:l},o),f.H3(f.BR,Ae,null,o,f.BR.MJ)}if(!(null!==ZC._n_(f.LS)&&-1===ZC.AV(f.LS,l)||(Ae.AM=l,Ae.Z=Ae.C7=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),Ae.IL=f.H.usc()?ZC.AL(f.H.K+"-main"):ZC.AL(f.H.K+"-text"),Ae.E.nodeidx=e,Ae.parse(),f.BR.A29&&f.BR.A9%180==0&&(Ae.o.width=ZC._i_(.9*f.AA),Ae.parse()),"inherit"!==f.BR.o["font-color"]&&"inherit"!==f.BR.o.color||-1===m||(Ae.C2=m),t||(Ae.J2=Xe,Ae.DE()&&Ae.parse()),Ae.o["auto-fit"]&&(Ae.I=ZC._i_(f.AA)),i?(u=f.AT(e),Ae.iX=u-Ae.I/2-(f.DF?f.AA/2:0)):t?(u=f.AT(e),Ae.iX=u-Ae.I/2):"log"===f.C1?(u=f.AT(f.V[e]),Ae.iX=u-Ae.I/2+(f.DF?f.AA/2:0)*(f.AW?-1:1)):f.AW?(u=f.iX+f.I-f.AC-c*f.AA,Ae.iX=u-Ae.I/2-(f.DF?f.AA/2:0)):(u=f.iX+f.AC+c*f.AA,Ae.iX=u-Ae.I/2+(f.DF?f.AA/2:0)),u<f.iX-1||u>f.iX+f.I+1))){if(f.A.B9&&f.A.B9.BX&&f.A.B9.I2){for(var r=!1,s=0;s<f.A.B9.BX.length;s++)f.A.B9.BX[s].text===Ae.AM&&(r=!0);r||f.A.B9.BX.push({x:ZC._i_(u),text:Ae.AM})}switch(Ae.o.placement){case"inner":Ae.iY=I?a-Ae.F-M:a+M;break;case"ref-top":Ae.iY=y-Ae.F-M;break;case"ref-bottom":Ae.iY=y+M;break;case"ref-auto":w&&w.S[e]?(w.FK(e).setup(),w.FK(e).iY<y?Ae.iY=y+M:Ae.iY=y-Ae.F-M):Ae.iY=y+M;break;default:Ae.iY=I?a+M:a-Ae.F-M}if(Ce=f.MY(Ae,Ce,"h",0),f.BR.o["auto-align"]&&f.BR.A9%180!=0){var A=ZC.DS(f.BR.A9,0,180)?I?1:-1:I?-1:1;Ae.iX+=A*Ae.I*ZC.EH(f.BR.A9)/2,Ae.iY+=A*(Ae.I*ZC.EO(f.BR.A9)/2-Ae.F*ZC.EO(f.BR.A9)/2)}var C=f.X3(Ae,e,{items:_e,lcoords:ge,lstep:O,tdim:de,mdim:fe,dim:"h",html:ve});if(de=C.tdim,fe=C.mdim,!C.overlaps&&i&&f.IU.AN)switch(Ze.o.placement){case"ref-auto":pe.push([u,y+M/2],[u,y-M/2],null);break;case"ref-top":pe.push([u,y-M],[u,y],null);break;case"ref-bottom":pe.push([u,y+M],[u,y],null);break;case"inner":pe.push([u,a-(I?M:-M)],[u,a],null);break;case"outer":pe.push([u,a],[u,a+(I?M:-M)],null);break;default:pe.push([u,a+M/2],[u,a-M/2],null)}f.GT++}}},getOptimalDateInterval:function(e){var i,t,n,a,l;return 0<=e&&e<=3*ZC.SEC?(i="%q",t="%q ms",n=10,a="ms",l=ZC._i_(e/10)):3*ZC.SEC<e&&e<=3*ZC.MIN?(i="%s",t="%h:%i:%s %A",n=ZC.SEC,a="sec",l=ZC._i_(e/ZC.SEC)):3*ZC.MIN<e&&e<=3*ZC.HR?(i="%i",t="%h:%i %A",n=ZC.MIN,a="min",l=ZC._i_(e/ZC.MIN)):3*ZC.HR<e&&e<=3*ZC.DAY?(i="%h:%i",t="%M %d, %h %A",n=ZC.HR,a="hr",l=ZC._i_(e/ZC.HR)):3*ZC.DAY<e&&e<=3*ZC.MON?(i="%d",t="%M %d",n=ZC.DAY,a="day",l=ZC._i_(e/ZC.DAY)):3*ZC.MON<e&&e<=3*ZC.YR?(i="%m",t="%M %Y",n=ZC.DAY,a="mon",l=ZC._i_(e/ZC.MON)):(i="%Y",t="%Y",n=ZC.DAY,a="yr",l=ZC._i_(e/ZC.YR)),[i,t,n,a,l]},paintTransformDate:function(){var e,i,t,n,a=this;i=ZC.Q.EB(a.H.usc()?a.H.K+"-main-c":a.A.K+"-scales-bl-0-c",a.H.AB);var l=[],o=1;function r(e,i){void 0===i&&(i=!1),0<=e&&e<=2*ZC.SEC?(t="%q",n="%q ms",i&&r(60*e)):2*ZC.SEC<e&&e<=2*ZC.MIN?(t="%s",n="%h:%i:%s %A",i&&r(60*e),e>10*ZC.SEC&&(o=2),e>30*ZC.SEC&&(o=5),e>60*ZC.SEC&&(o=10)):2*ZC.MIN<e&&e<=2*ZC.HR?(t="%i",n="%h:%i %A",i&&r(24*e),e>10*ZC.MIN&&(o=2),e>30*ZC.MIN&&(o=5),e>60*ZC.MIN&&(o=10)):2*ZC.HR<e&&e<=2*ZC.DAY?(t="%h",n="%M %d, %h %A",i&&r(30*e),e>6*ZC.HR&&(o=2),e>12*ZC.HR&&(o=4),e>24*ZC.HR&&(o=6)):2*ZC.DAY<e&&e<=2*ZC.MON?(t="%d",n="%M %d",i&&r(366*e),e>12*ZC.DAY&&(l=[1,5,9,13,17,21,25,29]),e>24*ZC.DAY&&(l=[1,6,11,16,21,26])):2*ZC.MON<e&&e<=2*ZC.YR?(t="%m",n="%M %Y",i&&r(10*e),e>9*ZC.MON&&(l=[1,4,7,10])):(t="%Y",n="%Y",e>9*ZC.YR&&(o=3),e>16*ZC.YR&&(o=4),e>25*ZC.YR&&(o=5))}r(a.V[a.A1]-a.V[a.W]);var s=null,A=null,C=[],c=!1,u=!1;function p(e){var u,p;if(null!==ZC._n_(a.V[e])&&""!==a.V[e]){if(a.NT&&e!==a.W&&e!==a.A1&&null!==ZC._n_(a.V[e-1])&&""!==a.V[e-1]&&null!==ZC._n_(a.V[e])&&""!==a.V[e]){var Z=a.V[e]-a.V[e-1];null!==ZC._n_(A)&&A!==Z&&r(A,!0),A=Z}var h=ZC.AP.Y5(a.V[e],t,a.A.UN,a.A.ND);if(h!==s&&ZC._i_(h)%o==0&&(0===l.length||-1!==ZC.AV(l,ZC._i_(h)))){var d,f=!0,_=e-a.W;u=a.AW?a.iX+a.I-a.AC-_*a.AA:a.iX+a.AC+_*a.AA+(a.DF?a.AA/2:0);var g=new ZC.DN(a);a.H.B8.load(g.o,"graph.SCALE.transform[date].item"),null!==ZC._n_(d=a.o.transform.item)&&g.append(d),g.GL=a.K+"-item "+a.A.K+"-scale-item zc-scale-item",g.K=a.K+"-date-item-"+e;var v=ZC.AP.Y5(a.V[e],n,a.A.UN,a.A.ND);g.AM=v,g.Z=g.C7=a.H.usc()?a.H.mc():ZC.AL(a.A.K+"-scales-ml-0-c"),g.IL=a.H.usc()?ZC.AL(a.H.K+"-main"):ZC.AL(a.H.K+"-text"),g.parse(),a.AW?g.iX=u-g.I/2-(a.DF?a.AA/2:0):g.iX=u,g.iY=a.iY,a.A.AJ["3d"]&&(a.A.NX(),p=new ZC.CE(a.A,g.iX+g.I/2-ZC.AO.E2,g.iY+g.F/2-ZC.AO.E3,0),g.iX=p.ED[0]-g.I/2,g.iY=p.ED[1]-g.F/2);var b=[g.iX+g.BL,g.iY+g.BH,g.I,g.F];if(g.A9%180==90&&(b=[g.iX+g.BL+g.I/2-g.F/2,g.iY+g.BH+g.F/2-g.I/2,g.F,g.I]),a.A.B9&&a.A.B9.I2){for(var B=!1,m=0;m<a.A.B9.BX.length;m++)a.A.B9.BX[m].text===g.AM&&(B=!0);B||g.iX>=a.iX&&g.iX+g.I<=a.iX+a.I&&a.A.B9.BX.push({x:ZC._i_(g.iX),text:g.AM})}if(g.AN&&c){if(f=!0,!a.A0J){if(e===a.W||e===a.A1)f=!0;else for(var E=0,D=C.length;E<D;E++)if(ZC.DS(b[0],C[E][0],C[E][0]+C[E][2])||ZC.DS(b[0]+b[2],C[E][0],C[E][0]+C[E][2])){f=!1;break}g.iX+g.BL+g.I>a.iX+a.BL+a.I&&(f=!1)}if(f){C.push(b),g.paint(),g.EK();var F=new ZC.D0(a);null!==ZC._n_(d=a.o.transform.guide)&&F.append(d),F.AZ=1,F.B7="#ccc",F.parse();var K=[];if(K.push([u,a.iY],[u,a.iY+a.F]),a.A.AJ["3d"]){a.A.NX();for(var x=0,I=K.length;x<I;x++)p=new ZC.CE(a.A,K[x][0]-ZC.AO.E2,K[x][1]-ZC.AO.E3,0),K[x][0]=p.ED[0],K[x][1]=p.ED[1]}F.AN&&ZC.CR.paint(i,F,K)}}0}s=h}}if(a.A.B9&&a.A.B9.I2&&(a.A.B9.BX=[]),a.V.length>0&&(c=!1,null!==ZC._n_(e=a.o.transform.item)&&(c=!(null!==ZC._n_(e.visible)&&!ZC._b_(e.visible))),u=!1,a.A.B9&&a.A.B9.BX&&(u=!0),c||u)){p(a.W),p(a.A1);for(var Z=a.W+1;Z<a.A1;Z++)p(Z)}}};ZC.Q2=ZC.ZI.CA(Q2);var Q3={$i:function(e){this.b(e)},parse:function(){this.b()},IZ:function(){var e=this;e.A1===e.W?e.AA=e.F-e.AC-e.BV:e.AA=(e.F-e.AC-e.BV)/(e.A1-e.W+(e.DF?1:0))},A9T:function(e){this.b(e),this.IZ()},clear:function(){},build:function(){this.b()},zoomTo:function(e,i){this.b(e,i),this.IZ()},NE:function(e,i,t){var n,a=this;n=a.AW?(e-a.iY-a.AC)/(a.F-a.AC-a.BV):(a.iY+a.F-a.AC-e)/(a.F-a.AC-a.BV);var l=a.B3+ZC._f_((a.BJ-a.B3)*n);return t&&(l=ZC._a_(a.AW?Math.ceil(l):Math.floor(l))),"log"===a.C1&&i&&(l=Math.pow(a.E6,l)),l},AT:function(e){var i=this,t=i.BJ-i.B3,n=0===t?0:(i.F-i.AC-i.BV-(i.DF?i.AA:0))/t;return"log"===i.C1&&(e=0===e?i.FX:ZC.G6(e,i.E6)),i.AW?i.iY+i.AC+(e-i.B3)*n:i.iY+i.F-i.AC-(e-i.B3)*n},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f,_,g=this;g.b(),"bubble"!==g.A.AF&&"scatter"!==g.A.AF||1!==g.V.length||(g.AC=g.F/2);var v=g.A0E(),b=0,B=1,m=1,E={};for(i=0,t=g.A.BO.length;i<t;i++)g.A.BO[i].AN&&g.A.BO[i].T9&&("scale-y"===g.A.BO[i].BE.substring(0,7)&&g.A.BO[i].BA===g.BA&&b++,"scale-y"===g.A.BO[i].BE.substring(0,7)&&("default"===g.A.BO[i].BA?(E[g.A.BO[i].BE]=B,B++):(E[g.A.BO[i].BE]=m,m++)));var D=E[g.BE],F="default"===g.BA,K=null,x=null;for(i=0,t=g.A.AY.A5.length;i<t;i++){var I=g.A.AY.A5[i],y=I.BU();if(-1!==ZC.AV(y,g.BE)){var w=g.A.BM(I.BU("k")[0]);K=w.AT(w.H8),x=I;break}}var L=8;null!==ZC._n_(g.IU.o.size)&&(L=ZC._i_(g.IU.o.size));var X=4;null!==ZC._n_(g.I9.o.size)&&(X=ZC._i_(g.I9.o.size));var Y=ZC._i_(g.A.E[g.BE+"-distance"]||-1);g.VB&&(Y=0),"default"===g.BA?(_=ZC._i_(g.A.P.DY/b),n=g.iX-(D-1)*_,-1!==Y&&(n=g.iX-Y)):(_=ZC._i_(g.A.P.E9/b),n=g.iX+g.I+(D-1)*_,-1!==Y&&(n=g.iX+g.I+Y));var M=n;if(g.A.HQ&&"scale-y"===g.BE&&(g.A.HQ.AN=!0,g.FX===g.B3&&g.H0===g.BJ&&(g.A.HQ.AN=!1),g.A.HQ.AN&&0===g.A.HQ.B0.BL&&"default"===g.BA&&(n-=g.A.HQ.B0.I+g.AZ/2)),g.E.iX=n,g.AN&&g.T9){for(var H=Math.ceil((g.A1-g.W)/(g.EG-1)),P=Math.ceil((g.A1-g.W)/(g.M1-1)),N=g.iStepMultiplier,S=3;S>0;S--)g.iStepMultiplier>S&&g.A1-g.W<=S*g.iStepMultiplier&&(N=S);P*=N,H*=N;var O=0,G=g.AA*P/(g.FR+1);if(a=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),l=ZC.Q.EB(a,g.H.AB),o=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-bl-0-c"),r=ZC.Q.EB(o,g.H.AB),g.T9||g.YQ||null!==ZC._n_(g.A.o[g.BE])){if("inherit"===g.o["line-color"]&&-1!==v&&(g.B7=v),g.A.AJ["3d"]){if((u=ZC.DK.DB(g,g.A,n-ZC.AO.E2,n-ZC.AO.E2,g.iY-ZC.AO.E3,g.iY-ZC.AO.E3+g.F,-1,ZC.AO.FU+1,"y")).K=g.K+"-line",g.A.EZ.true3d&&(g.A.EZ["y-angle"]>0?u.MC=[1===g.L?-100:100,1,1]:u.MC=[1===g.L?100:-100,1,1]),g.A.CL.add(u),null!==ZC._n_(g.o.axis)){var k=new ZC.D0(g);k.append(g.o.axis),k.parse(),k.A0=k.AE=k.B7,(u=ZC.DK.DB(k,g.A,n-ZC.AO.E2,n-ZC.AO.E2,g.iY-ZC.AO.E3,g.iY-ZC.AO.E3+g.F,-k.AZ/2,k.AZ/2,"y")).K=g.K+"-axis",g.A.CL.add(u)}}else{A=[[M,g.iY+g.F],[M,g.iY]];var T=g.K;g.K+="-line",ZC.CR.paint(l,g,A),g.K=T}var z=0,Q=0,J=[],V=[];if(g.T9||g.YQ){if(g.V.length>0&&g.D7.AN){var R=null===ZC._n_(g.D7.o["offset-start"])?0:ZC._i_(g.D7.o["offset-start"]),W=null===ZC._n_(g.D7.o["offset-end"])?0:ZC._i_(g.D7.o["offset-end"]);if(g.D7.o.items&&g.D7.o.items.length>0&&!g.A.AJ["3d"])for(g.GT=0,p=new ZC.HL(g),i=g.W;i<g.A1+(g.DF?1:0);i++)g.K3=i,i%P==0&&(C=i-g.W,Z=g.GT%g.D7.o.items.length,p.append(g.D7.o.items[Z]),p.K=g.K+"-guide-"+i,p.Z=o,p.parse(),p.iX=g.iX+R,s="log"===g.C1?g.AT(g.V[i]):g.AT(g.V[i])-(g.AW?0:g.AA*P),p.iY=s,p.I=g.I-R-W,p.F=g.AA*P,p.paint(),g.GT++);if(g.D7.AZ>0)for(g.GT=0,i=g.W;i<=g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%P==0){(g.D7.E7.length>0||i===g.W||"log"===g.C1)&&((c=new ZC.D0(g)).Z=c.C7=o,"log"===g.C1?ZC.AR._int_(ZC.G6(g.V[i],g.E6))?c.copy(g.D7):c.copy(g.G5):c.copy(g.D7),c.J2=ue,c.DE()&&c.parse()),A=[],C=i-g.W;var U=g.iX+R,j=g.I-R-W;if(s=(g.C1,g.AT(g.V[i])),c.AN)if(g.A.AJ["3d"]){var q=new ZC.D0(g);q.copy(c),null!==ZC._n_(g.o["scale-z"])&&null!==ZC._n_(e=g.o["scale-z"].guide)&&(q.append(e),q.parse()),q.A0=q.AE=q.B7,u=ZC.DK.DB(q,g.A,n-ZC.AO.E2,n-ZC.AO.E2,s-ZC.AO.E3-q.AZ/2,s-ZC.AO.E3+q.AZ/2,0,ZC.AO.FU,"y"),g.A.CL.add(u),c.A0=c.AE=c.B7,(u=ZC.DK.DB(c,g.A,U-ZC.AO.E2,U-ZC.AO.E2+j,s-ZC.AO.E3-c.AZ/2,s-ZC.AO.E3+c.AZ/2,ZC.AO.FU+2,ZC.AO.FU+2,"x")).K=g.K+"-guide-"+i,g.A.CL.add(u)}else A.push([U,s],[U+j,s]),c.K=g.K+"-guide-"+i,ZC.CR.paint(r,c,A);g.GT++}}if(g.V.length>0&&g.G5.AN&&G>2&&!g.A.AJ["3d"]){if(g.G5.o.items&&g.G5.o.items.length>0)for(p=new ZC.HL(g),i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i%P==0)for(C=i-g.W,g.GT=0,h=1;h<=g.FR;h++)Z=g.GT%g.G5.o.items.length,p.append(g.G5.o.items[Z]),p.K=g.K+"-guide-"+i+"-"+h,p.Z=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-bl-0-c"),p.parse(),p.iX=g.iX,s=g.AW?g.iY+g.AC+C*g.AA+h*G:g.iY+g.F-g.AC-C*g.AA-(h+1)*G,p.iY=s,p.I=g.I,p.F=G,p.paint(),g.GT++;if(g.G5.AZ>0&&"log"!==g.C1)for(i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%P==0)for(C=i-g.W,g.GT=0,h=1;h<=g.FR;h++)A=[],(c=new ZC.D0(g)).copy(g.G5),c.J2=ue,c.DE()&&c.parse(),s="log"===g.C1?g.AT(g.V[i]+h*(g.V[i+1]-g.V[i])/(g.FR+1)):g.AT(g.V[i]+h*H*(g.V[i+1]-g.V[i])/(g.FR+1)),ZC.DS(s,g.iY,g.iY+g.F)&&(A.push([g.iX,s],[g.iX+g.I,s]),c.AN&&(c.K=g.K+"-minor-guide-"+h,ZC.CR.paint(r,c,A))),g.GT++}var $,ee,ie;if(g.VG(r,v),g.V.length>0&&g.IU.AN){switch(g.IU.o.placement){case"inner":break;case"outer":O+=L;break;default:O+=L/2}for(g.GT=0,d=ZC.AV(g.V,0),i=g.W;i<=g.A1+(g.DF?1:0);i++){g.K3=i;var te=-1;if((i===g.W||i===g.A1||i%P==0||ZC._b_(g.o["show-zero"])&&i===d)&&(A=[],C=i-g.W,(g.IU.E7.length>0||i===g.W||"log"===g.C1)&&(c=new ZC.D0(g),"log"===g.C1?ZC.AR._int_(ZC.G6(g.V[i],g.E6))?c.copy(g.IU):(c.copy(g.I9),te=L,L=X):c.copy(g.IU),"inherit"===g.IU.o["line-color"]&&-1!==v&&(c.B7=v),c.J2=ue,c.DE()&&c.parse()),s=(g.C1,g.AT(g.V[i])),ZC.DS(s,g.A.P.iY,g.A.P.iY+g.A.P.F))){switch(c.o.placement){case"ref-right":A.push([K,s],[K+L,s]);break;case"ref-left":A.push([K,s],[K-L,s]);break;case"ref-auto":A.push([K-L/2,s],[K+L/2,s]);break;case"inner":A.push([n,s],[n+(F?L:-L),s]);break;case"outer":A.push([n,s],[n-(F?L:-L),s]);break;default:A.push([n+L/2,s],[n-L/2,s])}if(-1!==te&&(L=te,te=-1),c.AN){for(ee=ZC._i_(c.o["offset-x"]||"0"),ie=ZC._i_(c.o["offset-y"]||"0"),$=0;$<A.length;$++)A[$][0]+=ee,A[$][1]+=ie;if(c.K=g.K+"-tick-"+i,g.A.AJ["3d"]&&g.A.EZ.true3d){var ne,ae=[];for($=0;$<A.length;$++)ne=new ZC.CE(g.A,A[$][0]-ZC.AO.E2,A[$][1]-ZC.AO.E3,0),ae.push([ne.ED[0],ne.ED[1]]);ZC.CR.paint(l,c,ae)}else ZC.CR.paint(l,c,A)}g.GT++}}}if(g.V.length>0&&g.I9.AN&&g.FR>0&&G>5&&!g.A.AJ["3d"]&&"log"!==g.C1)for(i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%P==0)for(C=i-g.W,g.GT=0,h=1;h<=g.FR;h++){if(A=[],(c=new ZC.D0(g)).copy(g.I9),"inherit"===g.I9.o["line-color"]&&-1!==v&&(c.B7=v),c.J2=ue,c.DE()&&c.parse(),s="log"===g.C1?g.AT(g.V[i]+h*(g.V[i+1]-g.V[i])/(g.FR+1)):g.AT(g.V[i]+h*H*(g.V[i+1]-g.V[i])/(g.FR+1)),ZC.DS(s,g.iY,g.iY+g.F)){switch(c.o.placement){case"ref-right":A.push([K,s],[K+X,s]);break;case"ref-left":A.push([K,s],[K-X,s]);break;case"ref-auto":A.push([K-X/2,s],[K+X/2,s]);break;case"inner":A.push([n,s],[n+(F?X:-X),s]);break;default:A.push([n,s],[n-(F?X:-X),s]);break;case"cross":A.push([n+X/2,s],[n-X/2,s])}if(c.AN){for(ee=ZC._i_(c.o["offset-x"]||"0"),ie=ZC._i_(c.o["offset-y"]||"0"),$=0;$<A.length;$++)A[$][0]+=ee,A[$][1]+=ie;c.K=g.K+"-minor-tick-"+i,ZC.CR.paint(l,c,A)}}g.GT++}g.XO();var le=null,oe=g.CI,re=g.DQ,se=function(e){var i;if(g.K3=e,C=e-g.W,(g.BR.E7.length>0||e===g.W||!f||g.BR.HT)&&(f=new ZC.DN(g)),f.copy(g.BR),f.GL=g.K+"-item "+g.A.K+"-scale-item zc-scale-item",f.K=g.A.K+"-"+g.BE.replace(/\-/g,"_")+"-item_"+e,g.CI=oe,g.DQ=re,g.YM(ue),i=("piano"===g.A.AF||g.PV)&&g.BX.length?g.FQ(e+g.B3):g.FQ(e),g.BR.HT){var t=g.A.GX();ZC._cp_({index:e,cnt:C,text:i},t),g.H3(g.BR,f,null,t,g.BR.MJ)}if(null===ZC._n_(g.LS)||-1!==ZC.AV(g.LS,i)){switch(f.AM=i,f.Z=f.C7=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),f.IL=g.H.usc()?ZC.AL(g.H.K+"-main"):ZC.AL(g.H.K+"-text"),f.parse(),"inherit"!==g.BR.o["font-color"]&&"inherit"!==g.BR.o.color||-1===v||(f.C2=v),f.J2=ue,f.DE()&&f.parse(),f.o.placement){case"ref-left":f.iX=K-f.I-L;break;case"ref-right":f.iX=K+L;break;case"ref-auto":x&&x.S[e]?(x.FK(e).setup(),x.FK(e).iX<K?f.iX=K+L:f.iX=K-f.I-L):f.iX=K+L;break;case"middle":f.iX=n-f.I/2;break;case"inner":f.iX=F?n+L:n-f.I-L;break;default:f.iX=F?n-f.I-L:n+L}if("log"===g.C1?f.iY=g.AT(g.V[e])-f.F/2:f.iY=g.AT(g.V[e])-f.F/2+(g.AW?1:-1)*(g.DF?g.AA/2:0),le=g.MY(f,le,"v"),g.BR.o["auto-align"]&&g.BR.A9%180!=0){var a=F?1:-1;90===g.BR.A9||270===g.BR.A9?f.iX+=a*(f.I/2-f.F/2):ZC.DS(g.BR.A9,0,90)||ZC.DS(g.BR.A9,270,360)?(f.iX+=a*(f.I-f.I*ZC.EH(g.BR.A9))/2,f.iY-=a*f.I*ZC.EO(g.BR.A9)/2):ZC.DS(g.BR.A9,90,270)&&(f.iX+=a*(f.I+f.I*ZC.EH(g.BR.A9))/2,f.iY+=a*f.I*ZC.EO(g.BR.A9)/2)}if(ZC.DS(f.iY+f.F/2,g.A.P.iY,g.A.P.iY+g.A.P.F)){var l=g.X3(f,e,{items:0,lcoords:J,lstep:H,tdim:z,mdim:Q,dim:"w",html:V});z=l.tdim,Q=l.mdim,g.GT++}}};if(g.V.length>0&&g.BR.AN)if("log"===g.C1){var Ae=[];for(i=g.W;i<=g.A1;i++)ZC.AR._int_(ZC.G6(g.V[i],g.E6))&&(g.GT=i,se(i),Ae.push(i));for(i=g.W;i<=g.A1;i++)-1===ZC.AV(Ae,i)&&(g.GT=i,se(i))}else for(g.GT=0,se(g.W),g.GT=g.A1-g.W,se(g.A1),-1!==(d=ZC.AV(g.V,0))&&ZC._b_(g.o["show-zero"])&&(g.GT=d,se(d)),g.GT=1,i=g.W+1;i<g.A1;i++)i%H==0&&se(i)}if(g.M.AN&&g.M.AM&&""!==g.M.AM){(f=new ZC.DN(g)).copy(g.M),f.K=g.A.K+"-"+g.BE.replace(/\-/g,"_")+"-item_title",f.GL=g.K+"-label "+g.A.K+"-scale-label zc-scale-label",f.AM=g.M.AM,f.Z=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),f.IL=g.H.usc()?ZC.AL(g.H.K+"-main"):ZC.AL(g.H.K+"-text"),f.parse(),"inherit"!==g.M.o["font-color"]&&"inherit"!==g.M.o.color||-1===v||(f.C2=v);var Ce=g.iY+(g.AW?g.AC:g.BV),ce=g.F-g.BV-g.AC;switch("chart"===f.o["center-point"]&&(Ce=g.A.iY,ce=g.A.F),f.JY){case"top":f.iY=Ce+f.I/2-f.F/2;break;case"middle":f.iY=Ce+ce/2-f.F/2;break;case"bottom":f.iY=Ce+ce-f.I/2-f.F/2}f.iX=F?n-f.I/2-f.F/2-O-Q:n+Q+f.F/2+O-f.I/2,g.M.iX=f.iX,g.M.iY=f.iY,f.AN&&(g.MY(f,null,"v",10),f.paint(),f.EK(),null===ZC._n_(f.o.tooltip)&&f.K9||V.push(ZC.AP.O4(g.A.K,f)))}V.length>0&&ZC.AL(g.A.A.K+"-map")&&(ZC.AL(g.A.A.K+"-map").innerHTML+=V.join(""))}}function ue(e){return e=(e=(e=(e=(e=e.replace(/%scale-last-position/g,g.A1-g.W)).replace(/(%c)|(%scale-position)/g,g.GT)).replace(/(%i)|(%scale-index)/g,g.K3)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(g.V[g.K3])?g.V[g.K3]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(g.BX[g.K3])?g.BX[g.K3]:"")}}};ZC.Q3=ZC.VQ.CA(Q3);var SU={$i:function(e){this.b(e),this.CO=!0},parse:function(){this.b()},IZ:function(){var e=this;e.A1===e.W?e.AA=e.F-e.AC-e.BV:e.AA=(e.F-e.AC-e.BV)/(e.A1-e.W+(e.DF?1:0))},A9T:function(e){this.b(e),this.IZ()},clear:function(){},build:function(){this.b()},zoomTo:function(e,i){this.b(e,i),this.IZ()},NE:function(e){var i,t=this;return i=t.AW?(e-t.iY-t.AC)/(t.F-t.AC-t.BV):(t.iY+t.F-t.AC-e)/(t.F-t.AC-t.BV),t.B3+ZC._f_((t.BJ-t.B3)*i)},O9:function(e,i,t){var n,a,l,o,r=this;void 0===t&&(t=!1);var s=r.DF?r.AA:0;l=r.AW?(e-r.iY-r.AC-s/2)/(r.F-r.AC-r.BV-s):(r.iY+r.F-e-r.AC-s/2)/(r.F-r.AC-r.BV-s);var A=!1;if(i)for(o in i.K4){A=!0;break}if(i&&!r.NT&&A){var C=r.V[r.W];"string"==typeof C&&(C=ZC.AV(r.IT,C)),"log"===r.C1&&(C=ZC.G6(C,r.E6));var c=r.V[r.A1];"string"==typeof c&&(c=ZC.AV(r.IT,c)),"log"===r.C1&&(c=ZC.G6(c,r.E6));var u=C+ZC._f_((c-C)*l);"log"===r.C1&&(u=Math.pow(r.E6,u));var p=ZC.MAX;for(o in a=null,i.K4)(n=Math.abs(o-u))<p&&(p=n,a=i.K4[o]);if(null===ZC._n_(a)&&(a=u),p>i.A2K){var Z=Math.ceil((c-C)/(r.I-r.AC-r.BV));if(i.V.length<2&&(Z*=100),p>Z)return null}return a}var h=r.W,d=r.A1;return r.EF&&(null!==ZC._n_(n=r.V[h])&&(h=n),null!==ZC._n_(n=r.V[d])&&(d=n)),"log"===r.C1&&(h=ZC.G6(h,r.E6),d=ZC.G6(d,r.E6)),a=t?r.DF?h+(d-h+1)*l:h+(d-h)*l:(r.DF,r.W+(r.A1-r.W)*l),"log"===r.C1?(a=Math.pow(r.E6,a),a=Math.floor(a)-1):(a=ZC._i_(a),a=ZC.BQ(0,a),a=ZC.CY(r.DX,a)),a},IB:function(e){var i=this;i.W,i.A1;return i.EF&&!i.NT&&(i.B3,i.BJ),"log"===i.C1&&(e=ZC.G6(e+1,i.E6)),i.AW?i.iY+i.AC+(e-i.W)*i.AA+(i.DF?i.AA/2:0):i.iY+i.F-i.AC-(e-i.W)*i.AA-(i.DF?i.AA/2:0)},AT:function(e){var i,t,n,a,l,o=this;if("log"===o.C1&&(0===e&&(e=o.B3),e=ZC.G6(e,o.E6)),o.NT){var r=o.U9[e];return o.IB(r)}return-1!==(i=ZC.AV(o.IT,e))?o.IB(i):!o.A5E&&(o.EF||o.F5&&"date"===o.F5.o.type)?(a=o.V[o.W],l=o.V[o.A1],"log"===o.C1&&(a=ZC.G6(a,o.E6),l=ZC.G6(l,o.E6)),l===a?n=0:(t=l-a,n=(o.F-o.AC-o.BV-(o.DF?o.AA:0))/t),o.AW?o.iY+o.AC+(e-a)*n+(o.DF?o.AA/2:0):o.iY+o.F-o.AC-(e-a)*n-(o.DF?o.AA/2:0)):(a=o.B3,l=o.BJ,"log"===o.C1&&(a=ZC.G6(a,o.E6),l=ZC.G6(l,o.E6)),l===a?n=0:(t=l-a+(o.DF?1:0),n=(o.F-o.AC-o.BV)/t),o.AW?o.iY+o.AC+(e-a)*n+(o.DF?o.AA/2:0):o.iY+o.F-o.AC-(e-a)*n-(o.DF?o.AA/2:0))},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f=this;if(f.AN){f.b(),null!==ZC._n_(f.A.A.E[f.BE+"-feed-offset-start"])&&(f.AC=f.A.A.E[f.BE+"-feed-offset-start"]),"hbubble"!==f.A.AF&&"hscatter"!==f.A.AF||(-1===f.AC&&-1===f.BV||1===f.V.length)&&(f.AC=f.BV=f.F/(f.V.length+1),f.IZ());var _=f.A0E(),g=0,v=1,b=1,B={};for(i=0,t=f.A.BO.length;i<t;i++)"scale-x"===f.A.BO[i].BE.substring(0,7)&&f.A.BO[i].BA===f.BA&&g++,"scale-x"===f.A.BO[i].BE.substring(0,7)&&("default"===f.A.BO[i].BA?(B[f.A.BO[i].BE]=v,v++):(B[f.A.BO[i].BE]=b,b++));var m=B[f.BE],E="default"===f.BA,D=null,F=null;for(i=0,t=f.A.AY.A5.length;i<t;i++){var K=f.A.AY.A5[i],x=K.BU();if(-1!==ZC.AV(x,f.BE)){var I=f.A.BM(K.BU("v")[0]);D=I.AT(I.H8),F=K;break}}var y=8;null!==ZC._n_(f.IU.o.size)&&(y=ZC._i_(f.IU.o.size));var w=4;null!==ZC._n_(f.I9.o.size)&&(w=ZC._i_(f.I9.o.size));var L=ZC._i_(f.A.E[f.BE+"-distance"]||-1);f.VB&&(L=0),"default"===f.BA?(n=ZC._i_(f.A.P.DY/g),a=f.iX-(m-1)*n,-1!==L&&(a=f.iX-L)):(n=ZC._i_(f.A.P.E9/g),a=f.iX+f.I+(m-1)*n,-1!==L&&(a=f.iX+f.I+L));var X=a;if(f.A.HS&&"scale-x"===f.BE&&(f.A.HS.AN=!0,f.DC===f.W&&f.DX===f.A1&&(f.A.HS.AN=!1),f.A.HS.AN&&0===f.A.HS.B0.BL&&"default"===f.BA&&(a-=f.A.HS.B0.I+f.AZ/2)),f.E.iX=a,f.AN&&f.T9){null!==ZC._n_(f.o["fixed-items"])&&(f.M1=f.EG=ZC._i_(f.o["fixed-items"]));var Y=Math.ceil((f.A1-f.W)/(f.M1-1)),M=Math.ceil((f.A1-f.W)/(f.EG-1));null===ZC._n_(f.o["fixed-items"])&&ZC._b_(f.o.normalize)&&(Y=ZC.AR.A0K(Y),M=ZC.AR.A0K(M));for(var H=f.iStepMultiplier,P=3;P>0;P--)f.iStepMultiplier>P&&f.A1-f.W<=P*f.iStepMultiplier&&(H=P);Y*=H,M*=H;var N,S,O,G=0,k=f.AA*Y/(f.FR+1);if(null===ZC._n_(D)&&(D=a),l=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),o=ZC.Q.EB(l,f.H.AB),r=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-bl-0-c"),s=ZC.Q.EB(r,f.H.AB),"inherit"===f.o["line-color"]&&-1!==_&&(f.B7=_),f.A.AJ["3d"])(p=ZC.DK.DB(f,f.A,a-ZC.AO.E2,a-ZC.AO.E2,f.iY-ZC.AO.E3,f.iY-ZC.AO.E3+f.F,-1,ZC.AO.FU+1,"y")).K=f.K+"-line",f.A.EZ.true3d&&(f.A.EZ["x-angle"]>0?p.MC=[1===f.L?-100:100,1,1]:p.MC=[1===f.L?100:-100,1,1]),f.A.CL.add(p);else{C=[[X,f.iY+f.F],[X,f.iY]];var T=f.K;f.K+="-line",ZC.CR.paint(o,f,C),f.K=T}if(f.V.length>0&&f.D7.AN){var z=null===ZC._n_(f.D7.o["offset-start"])?0:ZC._i_(f.D7.o["offset-start"]),Q=null===ZC._n_(f.D7.o["offset-end"])?0:ZC._i_(f.D7.o["offset-end"]);if(f.D7.o.items&&f.D7.o.items.length>0&&!f.A.AJ["3d"])for(Z=new ZC.HL(f),i=f.W;i<f.A1+(f.DF?1:0);i++)A=i-f.W,d=i%f.D7.o.items.length,Z.append(f.D7.o.items[d]),Z.K=f.K+"-guide-"+i,Z.Z=r,Z.parse(),Z.iX=f.iX+z,f.AW?Z.iY=f.iY+f.AC+A*f.AA:Z.iY=f.iY+f.F-f.AC-(A+1)*f.AA,Z.I=f.I-z-Q,Z.F=f.AA,Z.paint();if(f.D7.AZ>0)for(f.GT=0,i=f.W;i<=f.A1+(f.DF?1:0);i++)if(f.K3=i,i===f.W||i===f.A1+(f.DF?1:0)||(i-f.W)%Y==0){(f.D7.E7.length>0||i===f.W)&&((u=new ZC.D0(f)).Z=u.C7=r,u.copy(f.D7),u.J2=Ce,u.DE()&&u.parse()),A=i-f.W,C=[],c=f.AW?f.iY+f.AC+A*f.AA:f.iY+f.F-f.AC-A*f.AA;var J=f.iX+z,V=f.I-z-Q;if(u.AN)if(f.A.AJ["3d"]){var R=new ZC.D0(f);R.copy(u),null!==ZC._n_(f.o["scale-z"])&&null!==ZC._n_(e=f.o["scale-z"].guide)&&(R.append(e),R.parse()),R.A0=R.AE=R.B7,p=ZC.DK.DB(R,f.A,a-ZC.AO.E2,a-ZC.AO.E2,c-ZC.AO.E3-R.AZ/2,c-ZC.AO.E3+R.AZ/2,0,ZC.AO.FU,"z"),f.A.CL.add(p),u.A0=u.AE=u.B7,(p=ZC.DK.DB(u,f.A,J-ZC.AO.E2,J-ZC.AO.E2+V,c-ZC.AO.E3-R.AZ/2,c-ZC.AO.E3+R.AZ/2,ZC.AO.FU+2,ZC.AO.FU+2,"x")).K=f.K+"-guide-"+i,f.A.CL.add(p)}else C.push([J,c],[J+V,c]),u.K=f.K+"-guide-"+i,ZC.CR.paint(s,u,C);f.GT++}}if(f.V.length>0&&f.G5.AN&&!f.A.AJ["3d"]){if(f.G5.o.items&&f.G5.o.items.length>0)for(Z=new ZC.HL(f),i=f.W;i<f.A1+(f.DF?1:0);i++)for(f.K3=i,A=i-f.W,f.GT=0,h=1;h<=f.FR;h++)d=f.GT%f.G5.o.items.length,Z.append(f.G5.o.items[d]),Z.K=f.K+"-guide-"+i+"-"+h,Z.Z=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-bl-0-c"),Z.parse(),Z.iX=f.iX,f.AW?Z.iY=f.iY+f.AC+(A+1)*f.AA-(h+1)*k:Z.iY=f.iY+f.F-f.AC-(A+1)*f.AA+h*k,Z.I=f.I,Z.F=k,Z.paint(),f.GT++;if(f.G5.AZ>0)for(i=f.W;i<f.A1+(f.DF?1:0);i++)if(f.K3=i,i%Y==0)for(A=i-f.W,f.GT=0,h=1;h<=f.FR;h++)C=[],(u=new ZC.D0(f)).copy(f.G5),u.J2=Ce,u.DE()&&u.parse(),c="log"===f.C1?f.AT(f.V[i]+h*(f.V[i+1]-f.V[i])/(f.FR+1)):f.AW?f.iY+f.AC+A*f.AA+h*k:f.iY+f.F-f.AC-A*f.AA-h*k,ZC.DS(c,f.iY,f.iY+f.F)&&(C.push([f.iX,c],[f.iX+f.I,c]),u.AN&&(u.K=f.K+"-minor-guide-"+h,ZC.CR.paint(s,u,C))),f.GT++}if(f.VG(s,_),f.V.length>0&&f.IU.AN&&(!f.A.AJ["3d"]||!f.A.EZ.true3d)){switch(f.IU.o.placement){case"inner":break;case"outer":G+=y;break;default:G+=y/2}for(f.GT=0,i=f.W;i<=f.A1+(f.DF?1:0);i++)if(f.K3=i,i===f.W||i===f.A1+(f.DF?1:0)||(i-f.W)%Y==0){switch(C=[],A=i-f.W,(f.IU.E7.length>0||i===f.W)&&((u=new ZC.D0(f)).copy(f.IU),"inherit"===f.IU.o["line-color"]&&-1!==_&&(u.B7=_),u.J2=Ce,u.DE()&&u.parse()),c=f.AW?f.iY+f.AC+A*f.AA:f.iY+f.F-f.AC-A*f.AA,u.o.placement){case"ref-auto":C.push([D-y/2,c],[D+y/2,c]);break;case"ref-left":C.push([D-y,c],[D,c]);break;case"ref-right":C.push([D+y,c],[D,c]);break;case"inner":C.push([a,c],[a+(E?y:-y),c]);break;case"outer":C.push([a,c],[a-(E?y:-y),c]);break;default:C.push([a+y/2,c],[a-y/2,c])}if(u.AN){for(S=ZC._i_(u.o["offset-x"]||"0"),O=ZC._i_(u.o["offset-y"]||"0"),N=0;N<C.length;N++)C[N][0]+=S,C[N][1]+=O;u.K=f.K+"-tick-"+i,ZC.CR.paint(o,u,C)}f.GT++}}var W,U=[];if(f.V.length>0&&f.FR>0&&f.I9.AN&&!f.A.AJ["3d"])for(i=f.W;i<f.A1+(f.DF?1:0);i++)if(i===f.W||i===f.A1+(f.DF?1:0)||i%Y==0)for(A=i-f.W,h=1;h<=f.FR;h++){if(C=[],(u=new ZC.D0(f)).copy(f.I9),"inherit"===f.I9.o["line-color"]&&-1!==_&&(u.B7=_),u.J2=Ce,u.DE()&&u.parse(),"log"===f.C1){c=f.AT(f.V[i]+h*(f.V[i+1]-f.V[i])/(f.FR+1));var j=Math.round(ZC.G6(f.V[i],f.E6)),q=f.V[i]+h*(f.V[i+1]-f.V[i])/(f.FR+1);q=j<0?ZC._f_(q.toFixed(-j)):ZC._f_(q.toFixed(j)),U.push(q),c=f.AT(q)}else c=f.AW?f.iY+f.AC+A*f.AA+h*k:f.iY+f.F-f.AC-A*f.AA-h*k;if(ZC.DS(c,f.iY,f.iY+f.F)){switch(u.o.placement){case"ref-auto":C.push([D-w/2,c],[D+w/2,c]);break;case"ref-left":C.push([D-w,c],[D,c]);break;case"ref-right":C.push([D+w,c],[D,c]);break;case"inner":C.push([a,c],[a+(E?w:-w),c]);break;case"outer":C.push([a,c],[a-(E?w:-w),c]);break;default:C.push([a+w/2,c],[a-w/2,c])}if(u.AN){for(S=ZC._i_(u.o["offset-x"]||"0"),O=ZC._i_(u.o["offset-y"]||"0"),N=0;N<C.length;N++)C[N][0]+=S,C[N][1]+=O;u.K=f.K+"-minor-tick-"+i,ZC.CR.paint(o,u,C)}}f.GT++}f.XO();var $=null,ee=f.CI,ie=f.DQ,te=0,ne=0,ae=0,le=[],oe=[];if(1===f.V.length&&f.BR.AN)f.GT=0,ce(f.W);else if(f.V.length>1&&f.BR.AN)for(f.GT=0,ce(f.W),f.GT=f.A1-f.W,ce(f.A1),f.GT=1,i=f.W+1;i<f.A1;i++)(i-f.W)%M==0&&ce(i);for(i=0;i<U.length;i++){var re=f.FQ(i,null,null,!1,U[i]);ce(re,!0,re)}if(f.M.AN&&f.M.AM&&""!==f.M.AM){(W=new ZC.DN(f)).copy(f.M),W.K=f.A.K+"-"+f.BE.replace(/\-/g,"_")+"-item_title",W.GL=f.K+"-label "+f.A.K+"-scale-label zc-scale-label",W.AM=f.M.AM,W.Z=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),W.IL=f.H.usc()?ZC.AL(f.H.K+"-main"):ZC.AL(f.H.K+"-text"),W.parse(),"inherit"!==f.M.o["font-color"]&&"inherit"!==f.M.o.color||-1===_||(W.C2=_);var se=f.iY+(f.AW?f.AC:f.BV),Ae=f.F-f.AC-f.BV;switch("chart"===W.o["center-point"]&&(se=f.A.iY,Ae=f.A.F),W.JY){case"top":W.iY=se+W.I/2-W.F/2;break;case"middle":W.iY=se+Ae/2-W.F/2;break;case"bottom":W.iY=se+Ae-W.I/2-W.F/2}W.iX=E?a-W.I/2-W.F/2-G-ne:a+W.F/2+ne+G-W.I/2,f.M.iX=W.iX,f.M.iY=W.iY,W.AN&&(f.MY(W,null,"v"),W.paint(),W.EK(),null===ZC._n_(W.o.tooltip)&&W.K9||oe.push(ZC.AP.O4(f.A.K,W)))}oe.length>0&&ZC.AL(f.A.A.K+"-map")&&(ZC.AL(f.A.A.K+"-map").innerHTML+=oe.join(""))}}function Ce(e){return e=(e=(e=(e=(e=e.replace(/%scale-last-position/g,f.A1-f.W)).replace(/(%c)|(%scale-position)/g,f.GT)).replace(/(%i)|(%scale-index)/g,f.K3)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(f.V[f.K3])?f.V[f.K3]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(f.BX[f.K3])?f.BX[f.K3]:"")}function ce(e,i,t){f.K3=e,A=e-f.W,(f.BR.E7.length>0||e===f.W||!W||f.BR.HT)&&(W=new ZC.DN(f)),W.copy(f.BR),W.K=f.A.K+"-"+f.BE.replace(/\-/g,"_")+"-item_"+(t?"c"+t:e),W.GL=f.K+"-item "+f.A.K+"-scale-item zc-scale-item",W.E["p-height"]=f.AA,f.CI=ee,f.DQ=ie,f.YM(Ce);var n="";if(n=t||f.FQ(e),f.BR.HT){var l=f.A.GX();ZC._cp_({index:e,cnt:A,text:n},l),f.H3(f.BR,W,null,l,f.BR.MJ)}if(null===ZC._n_(f.LS)||-1!==ZC.AV(f.LS,n)){switch(W.AM=n,W.Z=W.C7=f.H.usc()?f.H.mc():ZC.AL(f.A.K+"-scales-ml-0-c"),W.IL=f.H.usc()?ZC.AL(f.H.K+"-main"):ZC.AL(f.H.K+"-text"),W.E.nodeidx=e,W.parse(),"inherit"!==f.BR.o["font-color"]&&"inherit"!==f.BR.o.color||-1===_||(W.C2=_),W.J2=Ce,W.DE()&&W.parse(),W.o["auto-fit"]&&(W.F=ZC._i_(f.AA)),W.o.placement){case"inner":W.iX=E?a+y:a-W.I-y;break;case"ref-left":W.iX=D-W.I-y;break;case"ref-right":W.iX=D+y;break;case"ref-auto":F&&F.S[e]?(F.S[e].setup(),F.S[e].iX<D?W.iX=D+y:W.iX=D-W.I-y):W.iX=D+y;break;default:W.iX=E?a-W.I-y:a+y}if(i?(c=f.AT(e),W.iY=c-W.F/2-(f.DF?f.AA/2:0)):f.AW?W.iY=f.iY+f.AC+A*f.AA-W.F/2+(f.DF?f.AA/2:0):W.iY=f.iY+f.F-f.AC-A*f.AA-W.F/2-(f.DF?f.AA/2:0),$=f.MY(W,$,"v"),f.BR.o["auto-align"]&&f.BR.A9%180!=0){var o=E?1:-1;90===f.BR.A9||270===f.BR.A9?W.iX+=o*(W.I/2-W.F/2):ZC.DS(f.BR.A9,0,90)||ZC.DS(f.BR.A9,270,360)?(W.iX+=o*(W.I-W.I*ZC.EH(f.BR.A9))/2,W.iY-=o*W.I*ZC.EO(f.BR.A9)/2):ZC.DS(f.BR.A9,90,270)&&(W.iX+=o*(W.I+W.I*ZC.EH(f.BR.A9))/2,W.iY+=o*W.I*ZC.EO(f.BR.A9)/2)}var r=f.X3(W,e,{items:ae,lcoords:le,lstep:M,tdim:te,mdim:ne,dim:"w",html:oe});te=r.tdim,ne=r.mdim,f.GT++}}}};ZC.SU=ZC.ZI.CA(SU);var SV={$i:function(e){this.b(e),this.CO=!0},parse:function(){this.b()},IZ:function(){var e=this;e.A1===e.W?e.AA=e.I-e.AC-e.BV:e.AA=(e.I-e.AC-e.BV)/(e.A1-e.W+(e.DF?1:0))},A9T:function(e){this.b(e),this.IZ()},zoomTo:function(e,i){this.b(e,i),this.IZ()},clear:function(){},build:function(){this.b()},NE:function(e,i){var t,n=this;t=n.AW?(n.iX+n.I-n.AC-e)/(n.I-n.AC-n.BV):(e-n.iX-n.AC)/(n.I-n.AC-n.BV);var a=n.B3+ZC._f_((n.BJ-n.B3)*t);return"log"===n.C1&&i&&(a=Math.pow(n.E6,a)),a},AT:function(e){var i=this,t=i.BJ-i.B3,n=0===t?0:(i.I-i.AC-i.BV-(i.DF?i.AA:0))/t;return"log"===i.C1&&(e=0===e?i.FX:ZC.G6(e,i.E6)),i.AW?i.iX+i.I-i.AC-(e-i.B3)*n:i.iX+i.AC+(e-i.B3)*n},paint:function(){var e,i,t,n,a,l,o,r,s,A,C,c,u,p,Z,h,d,f,_,g=this;if(g.AN&&0!==g.V.length){g.b(),"hbubble"!==g.A.AF&&"hscatter"!==g.A.AF||1!==g.V.length||(g.AC=g.I/2);var v=g.A0E(),b=0,B=1,m=1,E={};for(i=0,t=g.A.BO.length;i<t;i++)"scale-y"===g.A.BO[i].BE.substring(0,7)&&g.A.BO[i].BA===g.BA&&b++,"scale-y"===g.A.BO[i].BE.substring(0,7)&&("default"===g.A.BO[i].BA?(E[g.A.BO[i].BE]=B,B++):(E[g.A.BO[i].BE]=m,m++));var D=E[g.BE],F="default"===g.BA;for(i=0,t=g.A.AY.A5.length;i<t;i++){var K=g.A.AY.A5[i],x=K.BU();if(-1!==ZC.AV(x,g.BE)){var I=g.A.BM(K.BU("k")[0]);I.AT(I.H8),K;break}}var y=8;null!==ZC._n_(g.IU.o.size)&&(y=ZC._i_(g.IU.o.size));var w=4;null!==ZC._n_(g.I9.o.size)&&(w=ZC._i_(g.I9.o.size));var L=ZC._i_(g.A.E[g.BE+"-distance"]||-1);g.VB&&(L=0),"default"===g.BA?(Z=ZC._i_(g.A.P.DR/b),n=g.iY+g.F+(D-1)*Z,-1!==L&&(n=g.iY+g.F+L)):(Z=ZC._i_(g.A.P.E8/b),n=g.iY-(D-1)*Z,-1!==L&&(n=g.iY-L));var X=n;if(g.A.HQ&&(g.A.HQ.AN=!0,g.FX===g.B3&&g.H0===g.BJ&&(g.A.HQ.AN=!1),g.A.HQ.AN&&0===g.A.HQ.B0.BH&&"default"===g.BA&&(n+=g.A.HQ.B0.F+g.AZ/2)),g.E.iY=n,g.AN&&g.T9){for(var Y=Math.ceil((g.A1-g.W)/(g.EG-1)),M=Math.ceil((g.A1-g.W)/(g.M1-1)),H=g.iStepMultiplier,P=3;P>0;P--)g.iStepMultiplier>P&&g.A1-g.W<=P*g.iStepMultiplier&&(H=P);M*=H,Y*=H;var N=0,S=g.AA*M/(g.FR+1);if(a=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),l=ZC.Q.EB(a,g.H.AB),o=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-bl-0-c"),r=ZC.Q.EB(o,g.H.AB),g.T9||g.YQ||null!==ZC._n_(g.A.o[g.BE])){if("inherit"===g.o["line-color"]&&-1!==v&&(g.B7=v),g.A.AJ["3d"])(u=ZC.DK.DB(g,g.A,g.iX-ZC.AO.E2,g.iX-ZC.AO.E2+g.I,n-ZC.AO.E3,n-ZC.AO.E3,-1,ZC.AO.FU+1,"x")).K=g.K+"-line",g.A.EZ.true3d&&(g.A.EZ["y-angle"]>0?u.MC=[1===g.L?-100:100,1,1]:u.MC=[1===g.L?100:-100,1,1]),g.A.CL.add(u);else{s=[[g.iX,X],[g.iX+g.I,X]];var O=g.K;g.K+="-line",ZC.CR.paint(l,g,s),g.K=O}var G=[],k=0,T=0,z=[];if(g.T9||g.YQ){if(g.V.length>0&&g.D7.AN){var Q=null===ZC._n_(g.D7.o["offset-start"])?0:ZC._i_(g.D7.o["offset-start"]),J=null===ZC._n_(g.D7.o["offset-end"])?0:ZC._i_(g.D7.o["offset-end"]);if(g.D7.o.items&&g.D7.o.items.length>0&&!g.A.AJ["3d"])for(g.GT=0,d=new ZC.HL(g),i=g.W;i<g.A1+(g.DF?1:0);i++)g.K3=i,i%M==0&&(A=i-g.W,h=g.GT%g.D7.o.items.length,d.append(g.D7.o.items[h]),d.K=g.K+"-guide-"+i,d.Z=o,d.parse(),C="log"===g.C1?g.AT(g.V[i]):g.AT(g.V[i])-(g.AW?g.AA*M:0),d.iX=C,d.iY=g.iY+Q,d.I=g.AA*M,d.F=g.F-Q-J,d.paint(),g.GT++);if(g.D7.AZ>0)for(g.GT=0,i=g.W;i<=g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%M==0){(g.D7.E7.length>0||i===g.W||"log"===g.C1)&&((c=new ZC.D0(g)).Z=c.C7=o,"log"===g.C1?ZC.AR._int_(ZC.G6(g.V[i],g.E6))?c.copy(g.D7):c.copy(g.G5):c.copy(g.D7),c.J2=re,c.DE()&&c.parse()),s=[],A=i-g.W;var V=g.iY+Q,R=g.F-Q-J;if(C=(g.C1,g.AT(g.V[i])),c.AN)if(g.A.AJ["3d"]){var W=new ZC.D0(g);W.copy(c),null!==ZC._n_(g.o["scale-z"])&&null!==ZC._n_(e=g.o["scale-z"].guide)&&(W.append(e),W.parse()),W.A0=W.AE=W.B7,u=ZC.DK.DB(W,g.A,C-ZC.AO.E2-W.AZ/2,C-ZC.AO.E2+W.AZ/2,n-ZC.AO.E3,n-ZC.AO.E3,0,ZC.AO.FU,"z"),g.A.CL.add(u),c.A0=c.AE=c.B7,(u=ZC.DK.DB(c,g.A,C-ZC.AO.E2-c.AZ/2,C-ZC.AO.E2+c.AZ/2,V-ZC.AO.E3,V-ZC.AO.E3+R,ZC.AO.FU+2,ZC.AO.FU+2,"y")).K=g.K+"-guide-"+i,g.A.CL.add(u)}else s.push([C,V],[C,V+R]),c.K=g.K+"-guide-"+i,ZC.CR.paint(r,c,s);g.GT++}}if(g.V.length>0&&g.G5.AN&&S>2&&!g.A.AJ["3d"]){if(g.G5.o.items&&g.G5.o.items.length>0)for(d=new ZC.HL(g),i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i%M==0)for(A=i-g.W,g.GT=0,p=0;p<=g.FR;p++)h=g.GT%g.G5.o.items.length,d.append(g.G5.o.items[h]),d.K=g.K+"-guide-"+i+"-"+p,d.Z=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-bl-0-c"),d.parse(),C=g.AW?g.iX+g.I-g.AC-A*g.AA-(p+1)*S:g.iX+g.AC+A*g.AA+p*S,d.iX=C,d.iY=g.iY,d.I=S,d.F=g.F,d.paint(),g.GT++;if(g.G5.AZ>0&&"log"!==g.C1)for(i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%M==0)for(A=i-g.W,g.GT=0,p=1;p<=g.FR;p++)s=[],(c=new ZC.D0(g)).copy(g.G5),c.J2=re,c.DE()&&c.parse(),C="log"===g.C1?g.AT(g.V[i]+p*(g.V[i+1]-g.V[i])/(g.FR+1)):g.AT(g.V[i]+p*Y*(g.V[i+1]-g.V[i])/(g.FR+1)),ZC.DS(C,g.iX,g.iX+g.I)&&(s.push([C,g.iY],[C,g.iY+g.F]),c.AN&&(c.K=g.K+"-minor-guide-"+p,ZC.CR.paint(r,c,s))),g.GT++}var U,j,q;if(g.VG(r,v),g.V.length>0&&g.IU.AN&&(!g.A.AJ["3d"]||!g.A.EZ.true3d)){switch(g.IU.o.placement){case"inner":break;case"outer":N+=y;break;default:N+=y/2}for(g.GT=0,f=ZC.AV(g.V,0),i=g.W;i<=g.A1+(g.DF?1:0);i++){g.K3=i;var $=-1;if((i===g.W||i===g.A1||i%M==0||ZC._b_(g.o["show-zero"])&&i===f)&&(s=[],A=i-g.W,(g.IU.E7.length>0||i===g.W||"log"===g.C1)&&(c=new ZC.D0(g),"log"===g.C1?ZC.AR._int_(ZC.G6(g.V[i],g.E6))?c.copy(g.IU):(c.copy(g.I9),$=y,y=w):c.copy(g.IU),"inherit"===g.IU.o["line-color"]&&-1!==v&&(c.B7=v),c.J2=re,c.DE()&&c.parse()),C=(g.C1,g.AT(g.V[i])),ZC.DS(C,g.A.P.iX,g.A.P.iX+g.A.P.I))){switch(c.o.placement){case"inner":s.push([C,n-(F?y:-y)],[C,n]);break;case"outer":s.push([C,n],[C,n+(F?y:-y)]);break;default:s.push([C,n+y/2],[C,n-y/2])}if(-1!==$&&(y=$,$=-1),c.AN){for(j=ZC._i_(c.o["offset-x"]||"0"),q=ZC._i_(c.o["offset-y"]||"0"),U=0;U<s.length;U++)s[U][0]+=j,s[U][1]+=q;c.K=g.K+"-tick-"+i,ZC.CR.paint(l,c,s)}g.GT++}}}if(g.V.length>0&&g.I9.AN&&g.FR>0&&S>5&&!g.A.AJ["3d"]&&"log"!==g.C1)for(i=g.W;i<g.A1+(g.DF?1:0);i++)if(g.K3=i,i===g.W||i===g.A1||i%M==0)for(A=i-g.W,g.GT=0,p=1;p<=g.FR;p++){if(s=[],(c=new ZC.D0(g)).copy(g.I9),"inherit"===g.I9.o["line-color"]&&-1!==v&&(c.B7=v),c.J2=re,c.DE()&&c.parse(),C="log"===g.C1?g.AT(g.V[i]+p*(g.V[i+1]-g.V[i])/(g.FR+1)):g.AT(g.V[i]+p*Y*(g.V[i+1]-g.V[i])/(g.FR+1)),ZC.DS(C,g.iX,g.iX+g.I)){switch(c.o.placement){case"inner":s.push([C,n-(F?w:-w)],[C,n]);break;default:s.push([C,n],[C,n+(F?w:-w)]);break;case"cross":s.push([C,n+w/2],[C,n-w/2])}if(c.AN){for(j=ZC._i_(c.o["offset-x"]||"0"),q=ZC._i_(c.o["offset-y"]||"0"),U=0;U<s.length;U++)s[U][0]+=j,s[U][1]+=q;c.K=g.K+"-minor-tick-"+i,ZC.CR.paint(l,c,s)}}g.GT++}g.XO();var ee=null,ie=g.CI,te=g.DQ,ne=function(e){var i;if(g.K3=e,A=e-g.W,(g.BR.E7.length>0||e===g.W||!_||g.BR.HT)&&(_=new ZC.DN(g)),_.copy(g.BR),_.GL=g.K+"-item "+g.A.K+"-scale-item zc-scale-item",_.K=g.A.K+"-"+g.BE.replace(/\-/g,"_")+"-item_"+e,g.CI=ie,g.DQ=te,g.YM(re),i=("piano"===g.A.AF||g.PV)&&g.BX.length?g.FQ(e+g.B3):g.FQ(e),g.BR.HT){var t=g.A.GX();ZC._cp_({index:e,cnt:A,text:i},t),g.H3(g.BR,_,null,t,g.BR.MJ)}if(null===ZC._n_(g.LS)||-1!==ZC.AV(g.LS,i)){switch(_.AM=i,_.Z=_.C7=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),_.IL=g.H.usc()?ZC.AL(g.H.K+"-main"):ZC.AL(g.H.K+"-text"),_.parse(),"inherit"!==g.BR.o["font-color"]&&"inherit"!==g.BR.o.color||-1===v||(_.C2=v),_.J2=re,_.E7=g.BR.E7,_.DE()&&_.parse(),_.o.placement){case"inner":_.iY=F?n-_.KB-y:n+y;break;default:_.iY=F?n+y:n-_.KB-y}if("log"===g.C1?_.iX=g.AT(g.V[e])-_.I/2:_.iX=g.AT(g.V[e])-_.I/2-(g.AW?1:-1)*(g.DF?g.AA/2:0),ee=g.MY(_,ee,"h"),g.BR.o["auto-align"]&&g.BR.A9%180!=0){var a=ZC.DS(g.BR.A9,0,180)?F?1:-1:1===F?-1:1;_.iX+=a*_.I*ZC.EH(g.BR.A9)/2,_.iY+=a*(_.I*ZC.EO(g.BR.A9)/2-_.F*ZC.EO(g.BR.A9)/2)}if(ZC.DS(_.iX+_.I/2,g.A.P.iX,g.A.P.iX+g.A.P.I)){var l=g.X3(_,e,{items:0,lcoords:G,lstep:Y,tdim:k,mdim:T,dim:"h",html:z});k=l.tdim,T=l.mdim,g.GT++}}};if(g.V.length>0&&g.BR.AN)if("log"===g.C1){var ae=[];for(i=g.W;i<=g.A1;i++)ZC.AR._int_(ZC.G6(g.V[i],g.E6))&&(g.GT=i,ne(i),ae.push(i));for(i=g.W;i<=g.A1;i++)-1===ZC.AV(ae,i)&&(g.GT=i,ne(i))}else for(g.GT=0,ne(g.W),g.GT=g.A1-g.W,ne(g.A1),-1!==(f=ZC.AV(g.V,0))&&ZC._b_(g.o["show-zero"])&&(g.GT=f,ne(f)),g.GT=1,i=g.W+1;i<g.A1;i++)i%Y==0&&ne(i)}if(g.M.AN&&g.M.AM&&""!==g.M.AM){(_=new ZC.DN(g)).copy(g.M),_.K=g.A.K+"-"+g.BE.replace(/\-/g,"_")+"-item_title",_.GL=g.K+"-label "+g.A.K+"-scale-label zc-scale-label",_.AM=g.M.AM,_.Z=g.H.usc()?g.H.mc():ZC.AL(g.A.K+"-scales-ml-0-c"),_.IL=g.H.usc()?ZC.AL(g.H.K+"-main"):ZC.AL(g.H.K+"-text"),_.parse(),"inherit"!==g.M.o["font-color"]&&"inherit"!==g.M.o.color||-1===v||(_.C2=v);var le=g.iX+(g.AW?g.BV:g.AC),oe=g.I-g.AC-g.BV;switch("chart"===_.o["center-point"]&&(le=g.A.iX,oe=g.A.I),_.OD){case"left":_.iX=le;break;case"center":_.iX=le+oe/2-_.I/2;break;case"right":_.iX=le+oe-_.I}_.iY=F?n+N+T:n-T-_.F-N,g.M.iX=_.iX,g.M.iY=_.iY,_.AN&&(g.MY(_,null,"h"),_.paint(),_.EK(),null===ZC._n_(_.o.tooltip)&&_.K9||z.push(ZC.AP.O4(g.A.K,_)))}z.length>0&&ZC.AL(g.A.A.K+"-map")&&(ZC.AL(g.A.A.K+"-map").innerHTML+=z.join(""))}}}function re(e){return e=(e=(e=(e=(e=e.replace(/%scale-last-position/g,g.A1-g.W)).replace(/(%c)|(%scale-position)/g,g.GT)).replace(/(%i)|(%scale-index)/g,g.K3)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(g.V[g.K3])?g.V[g.K3]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(g.BX[g.K3])?g.BX[g.K3]:"")}}};ZC.SV=ZC.VQ.CA(SV);var T5={$i:function(e){this.b(e);var i=this;i.NF="",i.KU=1,i.H2=1,i.GK=0,i.GE=0,i.JD=.6},parse:function(){var e=this;e.b(),e.iX+=e.DY,e.iY+=e.E8,e.I-=e.DY+e.E9,e.F-=e.E8+e.DR,e.ZQ("layout","NF"),null!==ZC._n_(e.o["size-factor"])&&(e.JD=ZC._f_(ZC._p_(e.o["size-factor"])))},A9T:function(e){var i=this;i.b(e),0===i.V.length&&(i.V=[""]);var t=ZC.AR.A2C(i.NF,i.V.length,!1);i.KU=t[0],i.H2=t[1],i.GK=i.I/i.H2,i.GE=i.F/i.KU},A51:function(){var e=this;e.b(),e.GK=e.I/e.H2,e.GE=e.F/e.KU},clear:function(){},build:function(){this.b()},paint:function(){var e,i,t,n,a,l=this;if(l.AN){if(l.b(),e=ZC.Q.EB(l.H.usc()?l.H.K+"-main-c":l.A.K+"-scales-ml-0-c",l.H.AB),i=ZC.Q.EB(l.H.usc()?l.H.K+"-main-c":l.A.K+"-scales-bl-0-c",l.H.AB),(t=[]).push([l.iX,l.iY],[l.iX+l.I,l.iY],[l.iX+l.I,l.iY+l.F],[l.iX,l.iY+l.F],[l.iX,l.iY]),ZC.CR.paint(e,l,t),l.D7.AN){if(l.D7.o.items&&l.D7.o.items.length>0)for(n=0,a=l.V.length;n<a;n++){var o=n%l.H2,r=Math.floor(n/l.H2),s=new ZC.HL(l),A=n%l.D7.o.items.length;s.o=l.D7.o.items[A],s.K=l.K+"-guide-"+n,s.Z=l.H.usc()?l.H.mc():ZC.AL(l.A.K+"-scales-bl-0-c"),s.parse(),s.iX=l.iX+o*l.GK,s.iY=l.iY+r*l.GE,s.I=l.GK,s.F=l.GE,s.paint()}if(l.D7.AZ>0){for(t=[],n=0;n<=l.H2;n++)t.push([l.iX+n*l.GK,l.iY],[l.iX+n*l.GK,l.iY+l.F],null);for(n=0;n<=l.KU;n++)t.push([l.iX,l.iY+n*l.GE],[l.iX+l.I,l.iY+n*l.GE],null);ZC.CR.paint(i,l.D7,t)}}var C,c=[];if(l.BR.AN){for(n=0,a=l.V.length;n<a;n++)u(n);c.length>0&&ZC.AL(l.A.A.K+"-map")&&(ZC.AL(l.A.A.K+"-map").innerHTML+=c.join(""))}}function u(e){(l.BR.E7.length>0||0===e)&&(C=new ZC.DN(l)),C.copy(l.BR);var i=e%l.H2,t=Math.floor(e/l.H2);C.GL=l.K+"-item "+l.A.K+"-scale-item zc-scale-item",C.K=l.A.K+"-"+l.BE.replace(/\-/g,"_")+"-item_"+e;var n=l.FQ(e);if((null===ZC._n_(l.LS)||-1!==ZC.AV(l.LS,n))&&(C.AM=n,C.Z=l.H.usc()?l.H.mc():ZC.AL(l.A.K+"-scales-ml-0-c"),C.parse(),C.J2=function(i){return i=(i=(i=i.replace(/%i/g,e)).replace(/%v/g,null!==ZC._n_(l.V[e])?l.V[e]:"")).replace(/%l/g,null!==ZC._n_(l.BX[e])?l.BX[e]:"")},C.E7=l.BR.E7,C.DE()&&C.parse(),C.AN)){var a="bottom";null!==ZC._n_(l.BR.o.placement)&&(a=l.BR.o.placement);var o=l.iX+i*l.GK,r=l.iY+t*l.GE;switch(a){case"top-left":C.iX=o,C.iY=r;break;case"top-right":C.iX=o+l.GK-C.I,C.iY=r;break;case"bottom-left":C.iX=o,C.iY=r+l.GE-C.F;break;case"bottom-right":C.iX=o+l.GK-C.I,C.iY=r+l.GE-C.F;break;case"top":C.iX=o+l.GK/2-C.I/2,C.iY=r;break;case"right":C.iX=o+l.GK-C.I,C.iY=r+l.GE/2-C.F/2;break;case"left":C.iX=o,C.iY=r+l.GE/2-C.F/2;break;default:C.iX=o+l.GK/2-C.I/2,C.iY=r+l.GE-C.F}C.paint(),C.EK(),null===ZC._n_(l.o.tooltip)&&C.K9||c.push(ZC.AP.O4(l.A.K,C))}}}};ZC.T5=ZC.ZI.CA(T5);var A2B={$i:function(e){this.b(e);this.DJ=0,this.EI=360},parse:function(){var e,i=this;i.b(),null!==ZC._n_(e=i.o["ref-angle"])&&(i.DJ=ZC._i_(e)%360),null!==ZC._n_(e=i.o.aperture)&&(i.EI=ZC._i_(e)%360,0===i.EI&&(i.EI=360))}};ZC.A2B=ZC.ZI.CA(A2B);var A4E={$i:function(e){this.b(e)},parse:function(){this.b()},IZ:function(){},A9T:function(e){this.b(e),this.IZ()},clear:function(){this.b()},build:function(){this.b()},paint:function(){this.b()}};ZC.A4E=ZC.VQ.CA(A4E),ZC.A7Z=ZC.A4E.CA({$i:function(e){this.b(e);var i=this;i.DJ=-90,i.EI=180,i.QF=null,i.IW=null,i.CW="circle"},parse:function(){var e,i=this;i.b(),null!==ZC._n_(e=i.o["ref-angle"])&&(i.DJ=ZC._i_(e)%360),null!==ZC._n_(e=i.o.aperture)&&(i.EI=ZC._i_(e)),null!==ZC._n_(e=i.o.center)&&(i.QF=new ZC.DT(i),i.QF.append(e),i.QF.parse()),null!==ZC._n_(e=i.o.ring)&&(i.IW=new ZC.DT(i),i.H.B8.load(i.IW.o,[i.A.AF+"."+i.BE+".ring"]),i.IW.append(e),i.IW.parse())},A9T:function(e){this.b(e)},clear:function(){},build:function(){this.b()},AT:function(e){var i=this,t=i.A.BM("scale"),n=t.iX+t.I/2,a=t.iY+t.F/2,l=i.A.BM("scale-"+i.L);l||(l=i.A.BM("scale"));var o=ZC.CY(l.GK/2,l.GE/2)*l.JD,r=i.BJ-i.B3,s=i.EI/r;return ZC.AR.BN(n,a,o,i.DJ-i.EI/2+s*(e-i.B3))},IB:function(e){return this.AT(this.V[e])},paintMarker:function(e){var i,t=this;if(e.F9){var n,a=t.A.BM("scale-"+t.L);if(a||(a=t.A.BM("scale")),e.AN){var l=t.A.K+"-scales-"+("top"===e.BA?"f":"b")+"l-0-c";e.Z=e.C7=ZC.AL(t.H.usc()?a.H.K+"-main-c":l),n=ZC.Q.EB(e.Z,t.H.AB);var o=ZC.CY(a.GK/2,a.GE/2)*a.JD,r=ZC.II(e.o["offset-start"]||"0");r>0&&r<1&&(r*=o);var s=ZC.II(e.o["offset-end"]||"0");s>0&&s<1&&(s*=o),e.M&&(e.M.Z=t.H.usc()?t.H.mc():ZC.AL(t.A.K+"-scales-ml-0-c"),e.M.K=e.A.A.K+"-"+e.A.BE.replace(/\-/g,"_")+"-marker_"+e.L,e.M.GL=e.A.K+"-marker-label "+e.A.A.K+"-scale-marker-label zc-scale-marker-label");for(var A=0;A<a.V.length;A++){var C,c=A%a.H2,u=Math.floor(A/a.H2),p=a.iX+c*a.GK+a.GK/2+a.BL,Z=a.iY+u*a.GE+a.GE/2+a.BH;switch(e.AF){case"line":if(e.F9.length>0){var h=t.DJ-t.EI/2+t.EI*(e.F9[0]-t.B3)/(t.BJ-t.B3);C=h;var d=[];d.push(ZC.AR.BN(p,Z,r,h)),d.push(ZC.AR.BN(p,Z,o-s,h)),2===d.length&&(ZC.CR.setup(n,e),ZC.CR.paint(n,e,d))}break;case"area":if(e.F9.length>1){var f=t.DJ-t.EI/2+t.EI*(e.F9[0]-t.B3)/(t.BJ-t.B3),_=t.DJ-t.EI/2+t.EI*(e.F9[1]-t.B3)/(t.BJ-t.B3);C=(f+_)/2;var g=new ZC.DT(e);g.Z=e.Z,g.append(e.o),g.append({size:o-s,slice:r,type:"pie","angle-start":f,"angle-end":_}),g.K=a.K+"-marker-"+e.L,g.iX=p,g.iY=Z,g.parse(),g.paint()}}if(e.M){var v;null!==ZC._n_(i=e.M.o["offset-r"])?v=ZC._f_(ZC._p_(i)):v<1?v*=o-s-r:v=0;var b=ZC.AR.BN(p,Z,(o-s-r)/2+v,C);e.M.iX=b[0]-e.M.I/2,e.M.iY=b[1]-e.M.F/2,e.M.paint()}}}}},paint:function(){var e,i,t,n,a,l,o,r,s,A=this;if(A.AN&&0!==A.V.length){A.AW&&A.V.reverse(),e=ZC.Q.EB(A.H.usc()?A.H.K+"-main-c":A.A.K+"-scales-bl-0-c",A.H.AB);var C=ZC._i_(A.IU.o.size||8),c=ZC._i_(A.I9.o.size||4),u=0,p=ZC.BQ(1,Math.ceil((A.A1-A.W)/(A.M1-1))),Z=ZC.BQ(1,Math.ceil((A.A1-A.W)/(A.EG-1))),h=A.A.BM("scale-"+A.L);h||(h=A.A.BM("scale"));for(var d,f,_,g=ZC.CY(h.GK/2,h.GE/2)*h.JD,v=A.EI/(A.V.length-1),b=0;b<h.V.length;b++){var B=b%h.H2,m=Math.floor(b/h.H2),E=h.iX+B*h.GK+h.GK/2+h.BL,D=h.iY+m*h.GE+h.GE/2+h.BH,F=new ZC.DT(A);if(F.Z=A.H.usc()?A.H.mc():ZC.AL(A.A.K+"-scales-bl-0-c"),F.copy(A),F.K=A.K+"-"+b,F.iX=E,F.iY=D,F.AI=g-.5,F.DU=360===A.EI?"circle":"pie",F.B4=A.DJ-A.EI/2+360,F.BK=A.DJ+A.EI/2+360,F.CN=0,F.parse(),F.paint(),A.D7.AN){if(A.D7.o.items&&A.D7.o.items.length>0)for(i=0;i<A.V.length-1;i++)F=new ZC.DT(A),o=i%A.D7.o.items.length,F.append(A.D7.o.items[o]),F.Z=A.H.usc()?A.H.mc():ZC.AL(A.A.K+"-scales-bl-0-c"),F.iX=E,F.iY=D,F.K=A.K+"-pie-"+i,F.o.type="pie",F.o.size=g-A.BV,F.CN=A.AC,F.B4=A.DJ-A.EI/2+i*v+360,F.BK=A.DJ-A.EI/2+(i+1)*v+360,F.parse(),F.paint();if(A.D7.AZ>0)for(i=0,t=A.V.length;i<t;i++)(d=new ZC.D0(A)).copy(A.D7),d.J2=L,d.E7=A.D7.E7,d.DE()&&d.parse(),(l=[]).push(ZC.AR.BN(E,D,g-A.BV,A.DJ-A.EI/2+i*v)),l.push(ZC.AR.BN(E,D,A.AC,A.DJ-A.EI/2+i*v)),ZC.CR.paint(e,d,l)}if(A.G5.AN&&A.G5.AZ>0&&A.FR>0)for(i=0,t=A.V.length;i<t-1;i++)for(r=A.DJ-A.EI/2+i*v,f=v/(A.FR+1),_=1;_<=A.FR;_++)(d=new ZC.D0(A)).copy(A.G5),d.J2=L,d.E7=A.G5.E7,d.DE()&&d.parse(),(l=[]).push(ZC.AR.BN(E,D,g-A.BV,A.DJ-A.EI/2+i*v+_*f)),l.push(ZC.AR.BN(E,D,A.AC,A.DJ-A.EI/2+i*v+_*f)),ZC.CR.paint(e,d,l);if(A.XO(),A.H.ZV(),A.IW&&((a=new ZC.DT(A)).append(A.IW.o),a.Z=A.H.usc()?A.H.mc():ZC.AL(A.A.K+"-scales-bl-0-c"),a.K=A.K+"-ring",a.iX=E,a.iY=D,360!==A.EI?(a.o.type="pie",n=ZC._i_(a.o.size),n=ZC.BQ(1,ZC.CY(n,g)),a.CN=g-n,a.o.size=g,a.B4=A.DJ-A.EI/2+360,a.BK=A.DJ+A.EI/2+360):(a.o.type="circle",n=ZC._i_(a.o.size),n=ZC.BQ(1,ZC.CY(n,g)),a.o.size=g),a.parse(),a.AN&&n+a.AU>0&&(a.paint(),360===A.EI&&(a.K=A.K+"-ring-inner",a.o.size=g-n,a.parse(),a.paint())),A.IW.o.items&&A.IW.o.items.length>0||A.IW.o.rules))for(i=0;i<A.V.length-1;i++)(a=new ZC.DT(A)).append(A.IW.o),A.IW.o.items&&(o=i%A.IW.o.items.length,a.append(A.IW.o.items[o])),a.Z=A.H.usc()?A.H.mc():ZC.AL(A.A.K+"-scales-bl-0-c"),a.K=A.K+"-ring-"+i,a.iX=E,a.iY=D,a.o.type="pie",n=ZC._i_(a.o.size),n=ZC.BQ(0,ZC.CY(n,g)),a.CN=g-n,a.o.size=g,a.B4=A.DJ-A.EI/2+i*v+360,a.BK=A.DJ-A.EI/2+(i+1)*v+360+.25,a.parse(),a.J2=L,a.E7=A.IW.E7,a.DE()&&a.parse(),a.AN&&n+a.AU>0&&a.paint();if(A.IU.AN){switch(A.IU.o.placement){case"outer":u+=C;break;default:u+=C/2}for(l=[],i=0,t=A.V.length;i<t;i++)if(i===A.W||i===A.A1||i%p==0){switch(r=A.DJ-A.EI/2+i*v,s=[0,0],A.IU.o.placement){case"inner":s=[-C,0];break;case"outer":s=[0,C];break;default:s=[-C/2,C/2]}l.push(ZC.AR.BN(E,D,g+s[0],r),ZC.AR.BN(E,D,g+s[1],r),null)}ZC.CR.paint(e,A.IU,l)}if(A.I9.AN&&A.FR>0){for(l=[],i=0,t=A.V.length;i<t-1;i++)for(r=A.DJ-A.EI/2+i*v,f=v/(A.FR+1),_=1;_<=A.FR;_++){switch(s=[0,0],A.I9.o.placement){case"inner":s=[-c,0];break;case"outer":s=[0,c];break;default:s=[-c/2,c/2]}l.push(ZC.AR.BN(E,D,g+s[0],r+_*f),ZC.AR.BN(E,D,g+s[1],r+_*f),null)}ZC.CR.paint(e,A.I9,l)}if(A.BR.AN){var K=[];for(i=0,t=A.V.length;i<t;i++)if(i===A.W||i===A.A1||i%Z==0){var x=new ZC.DN(A);x.append(A.BR.o),x.GL=A.K+"-item "+A.A.K+"-scale-item zc-scale-item",x.K=A.A.K+"-"+A.BE.replace(/\-/g,"_")+"-item_"+b+"_"+i;var I=A.FQ(i);if(x.AM=I,x.Z=x.C7=A.H.usc()?A.H.mc():ZC.AL(A.A.K+"-scales-ml-0-c"),x.parse(),"auto"===x.o.angle&&(x.A9=A.DJ-A.EI/2+i*v+90),x.J2=L,x.E7=A.BR.E7,x.DE()&&x.parse(),x.AN){x.F=x.KB;var y,w=1.15*Math.sqrt(x.I*x.I/4+x.F*x.F/4);switch(A.BR.o.placement){case"inner":y=ZC.AR.BN(E,D,g+A.BR.DV-w-5+u,A.DJ-A.EI/2+i*v);break;default:y=ZC.AR.BN(E,D,g+A.BR.DV+w+u,A.DJ-A.EI/2+i*v)}x.iX=y[0]-x.I/2,x.iY=y[1]-x.F/2,x.paint(),x.EK(),null===ZC._n_(A.o.tooltip)&&x.K9||(null!==ZC._n_(A.o.tooltip)&&(A.o.tooltip.text=A.o.tooltip.text||"%scale-value"),K.push(ZC.AP.O4(A.A.K,x)))}}K.length>0&&ZC.AL(A.A.A.K+"-map")&&(ZC.AL(A.A.A.K+"-map").innerHTML+=K.join(""))}}}function L(e){return e=(e=(e=(e=e.replace(/%i/g,i)).replace(/%k/g,i)).replace(/%v/g,null!==ZC._n_(A.V[i])?A.V[i]:"")).replace(/%l/g,null!==ZC._n_(A.BX[i])?A.BX[i]:"")}},paint_:function(){var e=this,i=e.A.BM("scale-"+e.L);i||(i=e.A.BM("scale"));for(var t=0;t<i.V.length;t++){var n=t%i.H2,a=Math.floor(t/i.H2),l=i.iX+n*i.GK+i.GK/2+i.BL,o=i.iY+a*i.GE+i.GE/2+i.BH;if(e.QF){var r=new ZC.DT(e);r.append(e.QF.o),r.Z=r.C7=e.H.usc()?e.H.mc("top"):ZC.AL(e.A.K+"-scales-ml-0-c"),r.K=e.K+"-"+t+"-center",r.iX=l,r.iY=o,r.o.type=r.o.type||"circle",r.parse(),r.AN&&r.paint()}}}});var ZL={$i:function(e){this.b(e);var i=this;i.DJ=0,i.CW="star",i.DF=!1},parse:function(){this.b(),this.assign_a([["aspect","CW"],["ref-angle","DJ","i"],["ranged","DF","b"]])},A7U:function(){var e=this,i=ZC.BQ(e.V.length,e.BX.length);e.EG=ZC.CY(30,i)},A9T:function(e){this.b(e)},clear:function(){},build:function(){this.b()},A7A:function(e,i,t){var n=this,a=n.A.BM("scale"),l=a.iX+a.I/2,o=a.iY+a.F/2,r=n.A.BM("scale-v");if(t){var s=n.DJ+n.EI*(e-n.B3)/(n.BJ-n.B3);return ZC.AR.BN(l,o,i+r.AC,s)}var A=n.EI/(n.V.length-(360===n.EI||n.DF?0:1));return ZC.AR.BN(l,o,i+r.AC,n.DJ+e*A)},IB:function(e){var i=this.A.BM("scale"),t=ZC.CY(i.I/2,i.F/2)*i.JD;return this.A7A(e,t)},AT:function(e){var i=this,t=ZC.AV(i.V,e);-1===t&&(t=0);var n=i.A.BM("scale"),a=ZC.CY(n.I/2,n.F/2)*n.JD;return i.A7A(t,a)},paint:function(){var e,i,t,n,a,l,o,r,s=this;if(s.AN&&0!==s.V.length){s.b();var A=ZC.BQ(1,Math.floor((s.A1-s.W)/(s.M1-1))),C=ZC.BQ(1,Math.floor((s.A1-s.W)/(s.EG-1)));e=ZC.Q.EB(s.H.usc()?s.H.K+"-main-c":s.A.K+"-scales-ml-0-c",s.H.AB),i=ZC.Q.EB(s.H.usc()?s.H.K+"-main-c":s.A.K+"-scales-bl-0-c",s.H.AB);var c,u=ZC._i_(s.IU.o.size||8),p=0,Z=s.A.BM("scale"),h=ZC.CY(Z.I/2,Z.F/2)*Z.JD,d=s.A.BM("scale-v"),f=Z.iX+Z.I/2,_=Z.iY+Z.F/2,g=s.EI/(s.V.length-(360===s.EI||s.DF?0:1));if(s.D7.AN){if(s.D7.o.items&&s.D7.o.items.length>0){var v=0;for(t=0,n=s.V.length-(360===s.EI||s.DF?0:1);t<n;t+=A){if(r=s.DJ+t*g,"circle"===s.CW){var b=new ZC.DT(s);a=v%s.D7.o.items.length,b.append(s.D7.o.items[a]),b.Z=s.H.usc()?s.H.mc():ZC.AL(s.A.K+"-scales-bl-0-c"),b.iX=f,b.iY=_,b.o.type="pie",b.o.size=h,b.CN=d.AC,b.B4=r,b.BK=r+A*g,b.parse(),b.paint()}else{var B=new ZC.DT(s);a=v%s.D7.o.items.length,B.o=s.D7.o.items[a],B.Z=s.H.usc()?s.H.mc():ZC.AL(s.A.K+"-scales-bl-0-c"),B.AZ=0,B.AU=0,B.EX=0,B.GA=0,(l=[]).push(ZC.AR.BN(f,_,d.AC,r),ZC.AR.BN(f,_,h,r),ZC.AR.BN(f,_,h,r+A*g),ZC.AR.BN(f,_,d.AC,r+A*g)),B.D=l,B.parse();var m=s.A.P;B.D1=[m.iX,m.iY,m.iX+m.I,m.iY+m.F],B.paint()}v++}}if(s.D7.AZ>0)for(t=0,n=s.V.length+(s.DF?1:0);t<n;t+=A)r=s.DJ+t*g,(o=new ZC.D0(s)).copy(s.D7),o.K=s.K+"-guide-"+t,o.J2=I,o.E7=s.D7.E7,o.DE()&&o.parse(),(l=[]).push(ZC.AR.BN(f,_,h,r),ZC.AR.BN(f,_,d.AC,r)),ZC.CR.paint(i,o,l)}if(s.IU.AN){switch(s.IU.o.placement){case"inner":break;case"outer":p+=u;break;default:p+=u/2}for(l=[],t=0,n=s.V.length+(s.DF?1:0);t<n;t+=A){switch(r=s.DJ+t*g,(o=new ZC.D0(s)).copy(s.IU),o.o.placement){case"inner":l=[ZC.AR.BN(f,_,h-u,r),ZC.AR.BN(f,_,h,r)];break;case"outer":l=[ZC.AR.BN(f,_,h,r),ZC.AR.BN(f,_,h+u,r)];break;default:l=[ZC.AR.BN(f,_,h-u/2,r),ZC.AR.BN(f,_,h+u/2,r)]}for(var E=ZC._i_(o.o["offset-x"]||"0"),D=ZC._i_(o.o["offset-y"]||"0"),F=0;F<l.length;F++)l[F]&&(l[F][0]+=E,l[F][1]+=D);o.K=s.K+"-tick-"+t,ZC.CR.paint(e,o,l)}}var K,x=[];if(s.BR.AN){for(t=0,n=s.V.length;t<n;t+=C)y(t);x.length>0&&ZC.AL(s.A.A.K+"-map")&&(ZC.AL(s.A.A.K+"-map").innerHTML+=x.join(""))}}function I(e){return e=(e=(e=e.replace(/(%i)|(%scale-index)/g,t)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(s.V[t])?s.V[t]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(s.BX[t])?s.BX[t]:"")}function y(e){(s.BR.E7.length>0||0===e)&&(c=new ZC.DN(s)),c.copy(s.BR),c.GL=s.K+"-item "+s.A.K+"-scale-item zc-scale-item",c.K=s.A.K+"-"+s.BE.replace(/\-/g,"_")+"-item_"+e;var i=s.FQ(e);if(null===ZC._n_(s.LS)||-1!==ZC.AV(s.LS,i)){c.AM=i,c.Z=c.C7=s.H.usc()?s.H.mc():ZC.AL(s.A.K+"-scales-ml-0-c"),c.parse(),c.J2=function(i){return i=(i=(i=i.replace(/(%i)|(%scale-index)/g,e)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(s.V[e])?s.V[e]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(s.BX[e])?s.BX[e]:"")},c.E7=s.BR.E7,c.DE()&&c.parse();var t=ZC.II(c.DV,!0);if(t>-1&&t<1&&(t*=h),r=s.DJ+e*g+(s.DF?g/2:0),s.BR.o["auto-align"]){var n=1.25;1-ZC._a_(ZC.EH(r))>.7&&(n=2.5*(1-ZC._a_(ZC.EH(r))));var a=(1-ZC._a_(ZC.EH(r)))*c.DI*n;K=ZC.AR.BN(f,_,h+t+p+a,r),ZC.EH(r)>0?(c.iX=K[0],c.iY=K[1]-c.F/2):(c.iX=K[0]-c.I,c.iY=K[1]-c.F/2)}else s.BR.o["auto-rotate"]?(K=ZC.AR.BN(f,_,h+t+p+c.F/2,r),c.iX=K[0]-c.I/2,c.iY=K[1]-c.F/2,c.A9=r+90):(K=ZC.AR.BN(f,_,h+t+p+ZC._a_(10*ZC.EO(r))+ZC._a_(c.I/2*ZC.EH(r)),r),c.iX=K[0]-c.I/2,c.iY=K[1]-c.F/2);c.AN&&(c.paint(),c.EK(),null===ZC._n_(s.o.tooltip)&&c.K9||(null!==ZC._n_(s.o.tooltip)&&(s.o.tooltip.text=s.o.tooltip.text||"%scale-value"),x.push(ZC.AP.O4(s.A.K,c))))}}}};ZC.ZL=ZC.A2B.CA(ZL);var ZK={$i:function(e){this.b(e)},parse:function(){this.b()},IZ:function(){var e=this,i=e.A.BM("scale"),t=ZC.CY(i.I/2,i.F/2)*i.JD;e.AA=(t-e.AC-e.BV)/(e.A1-e.W)},A9T:function(e){this.b(e),this.IZ()},A7U:function(){var e=this,i=e.A.BM("scale"),t=ZC.CY(i.I/2,i.F/2)*i.JD;e.EG=ZC.BQ(2,ZC._i_((t-e.AC-e.BV)/20))},U4:function(e){var i=this,t=i.A.BM("scale"),n=ZC.CY(t.I/2,t.F/2)*t.JD,a=i.BJ-i.B3,l=(n-i.AC-i.BV)/a;return(e-i.B3)*l},AT:function(e){var i=this,t=i.U4(e),n=i.A.BM("scale-k"),a=i.A.BM("scale"),l=a.iX+a.I/2+a.BL,o=a.iY+a.F/2+a.BH;return ZC.AR.BN(l,o,t,n.DJ)},clear:function(){},build:function(){this.b()},paint:function(){var e,i,t,n,a,l,o,r=this;if(r.AN&&0!==r.V.length){r.b(),e=ZC.Q.EB(r.H.usc()?r.H.K+"-main-c":r.A.K+"-scales-ml-0-c",r.H.AB),i=ZC.Q.EB(r.H.usc()?r.H.K+"-main-c":r.A.K+"-scales-bl-0-c",r.H.AB);var s,A,C=r.A.BM("scale-k"),c=ZC._i_(r.IU.o.size||8),u=Math.ceil((r.A1-r.W)/(r.EG-1)),p=Math.ceil((r.A1-r.W)/(r.M1-1)),Z=r.A.BM("scale"),h=ZC.CY(Z.I/2,Z.F/2)*Z.JD,d=Z.iX+Z.I/2+Z.BL,f=Z.iY+Z.F/2+Z.BH,_=C.EI/(C.V.length-(360===C.EI||C.DF?0:1));if(r.D7.AN){if(r.D7.o.items&&r.D7.o.items.length>0)for(t=0,n=r.V.length;t<n-1;t++){var g=t%r.D7.o.items.length;if("circle"===C.CW){var v=new ZC.DT(r);v.Z=r.H.usc()?r.H.mc():ZC.AL(r.A.K+"-scales-bl-0-c"),v.append(r.D7.o.items[g]),v.o.type="pie",v.o.size=r.AC+(t+1)*r.AA,v.iX=d,v.iY=f,v.CN=r.AC+t*r.AA,360===C.EI?(v.B4=0,v.BK=360):(v.B4=C.DJ,v.BK=C.DJ+C.EI),v.parse(),v.paint()}else{var b=new ZC.DT(r);for(b.append(r.D7.o.items[g]),b.Z=r.H.usc()?r.H.mc():ZC.AL(r.A.K+"-scales-bl-0-c"),o=[],a=0,l=C.V.length;a<l;a++)o.push(ZC.AR.BN(d,f,r.AC+t*r.AA,C.DJ+a*_));for(360===C.EI&&o.push(ZC.AR.BN(d,f,r.AC+t*r.AA,C.DJ),ZC.AR.BN(d,f,r.AC+(t+1)*r.AA,C.DJ)),a=C.V.length-1;a>=0;a--)o.push(ZC.AR.BN(d,f,r.AC+(t+1)*r.AA,C.DJ+a*_));b.D=o,b.parse(),b.AZ=0,b.AU=0,b.EX=0,b.GA=0;var B=r.A.P;b.D1=[B.iX,B.iY,B.iX+B.I,B.iY+B.F],b.paint()}}if(r.D7.AZ>0)for(t=0,n=r.V.length;t<n;t++)if(t===r.W||t===r.A1||t%p==0)if("circle"===C.CW){var m=new ZC.DT(r);m.Z=r.H.usc()?r.H.mc():ZC.AL(r.A.K+"-scales-bl-0-c"),m.append(r.D7.o);var E=C.EI;360===E&&(E=359),m.append({type:"arc",size:r.AC+t*r.AA,angleStart:C.DJ-.25,angleEnd:C.DJ+E+.25}),m.K=r.K+"-guide-"+t,m.iX=d,m.iY=f,m.parse(),m.J2=y,m.E7=r.D7.E7,m.DE()&&m.parse(),m.paint()}else{var D=new ZC.D0(r);for(D.copy(r.D7),D.K=r.K+"-guide-"+t,D.J2=y,D.E7=r.D7.E7,D.DE()&&D.parse(),o=[],a=0,l=C.V.length-(360===C.EI||C.DF?0:1);a<l;a++)o.push(ZC.AR.BN(d,f,r.AC+t*r.AA,C.DJ+a*_),ZC.AR.BN(d,f,r.AC+t*r.AA,C.DJ+(a+1)*_));ZC.CR.paint(i,D,o)}}if(r.P3.AN&&r.P3.AZ>0&&((o=[]).push(ZC.AR.BN(d,f,r.AC,C.DJ),ZC.AR.BN(d,f,h-r.BV,C.DJ)),ZC.CR.paint(e,r.P3,o)),r.IU.AN){switch(r.IU.o.placement){case"inner":break;case"outer":c;break;default:c/2}for(o=[],t=0,n=r.V.length;t<n;t++)if(t===r.W||t===r.A1||t%p==0){var F=ZC.AR.BN(d,f,r.AC+t*r.AA,C.DJ);switch(r.IU.o.placement){case"inner":o.push([F[0],F[1]]),C.DJ%180==0?o.push([F[0],F[1]-c]):o.push([F[0]-c,F[1]]),o.push(null);break;case"outer":o.push([F[0],F[1]]),C.DJ%180==0?o.push([F[0],F[1]+c]):o.push([F[0]+c,F[1]]),o.push(null);break;default:C.DJ%180==0?o.push([F[0],F[1]-c/2],[F[0],F[1]+c/2]):o.push([F[0]-c/2,F[1]],[F[0]+c/2,F[1]]),o.push(null)}}for(var K=ZC._i_(r.IU.o["offset-x"]||"0"),x=ZC._i_(r.IU.o["offset-y"]||"0"),I=0;I<o.length;I++)o[I]&&(o[I][0]+=K,o[I][1]+=x);ZC.CR.paint(e,r.IU,o)}if(A=[],r.V.length>0&&r.BR.AN)for(r.GT=0,L(r.W),r.GT=r.A1-r.W,L(r.A1),r.GT=1,t=r.W+1;t<r.A1;t++)t%u==0&&L(t);A.length>0&&ZC.AL(r.A.A.K+"-map")&&(ZC.AL(r.A.A.K+"-map").innerHTML+=A.join(""))}function y(e){return e=(e=(e=e.replace(/(%i)|(%scale-index)/g,t)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(r.V[t])?r.V[t]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(r.BX[t])?r.BX[t]:"")}function w(e){return e=(e=(e=(e=e.replace(/(%c)|(%scale-position)/g,r.GT)).replace(/(%i)|(%scale-index)/g,r.K3)).replace(/(%v)|(%scale-value)/g,null!==ZC._n_(r.V[r.K3])?r.V[r.K3]:"")).replace(/(%l)|(%scale-label)/g,null!==ZC._n_(r.BX[r.K3])?r.BX[r.K3]:"")}function L(e){r.K3=e,(s=new ZC.DN(r)).copy(r.BR),s.K=r.A.K+"-"+r.BE.replace(/\-/g,"_")+"-item_"+e,s.GL=r.K+"-item "+r.A.K+"-scale-item zc-scale-item";var i=r.FQ(e);if(s.AM=i,null===ZC._n_(r.LS)||-1!==ZC.AV(r.LS,i)){s.Z=s.C7=r.H.usc()?r.H.mc():ZC.AL(r.A.K+"-scales-fl-0-c"),s.parse(),s.J2=w,s.DE()&&s.parse();var t=ZC.AR.BN(d,f,r.AC+e*r.AA,C.DJ);switch(s.F=s.KB,s.I=s.NJ,C.DJ%180==0?(s.iX=t[0]-s.I/2,s.iY=t[1]):(s.iX=t[0],s.iY=t[1]-s.F/2),r.IU.o.placement){case"inner":break;case"outer":C.DJ%180==0?s.iY+=c:s.iX+=c;break;default:C.DJ%180==0?s.iY+=c/2:s.iX+=c/2}s.AN&&(s.paint(),s.EK(),null===ZC._n_(r.o.tooltip)&&s.K9||(null!==ZC._n_(r.o.tooltip)&&(r.o.tooltip.text=r.o.tooltip.text||"%scale-value"),A.push(ZC.AP.O4(r.A.K,s))))}}}};ZC.ZK=ZC.VQ.CA(ZK);var A0F={$i:function(e){this.b(e);var i=this;i.C6=.95,i.L=0,i.AF=null,i.M=null,i.F9=null,i.A6A=!1,i.BA="bottom",i.AC=0,i.BV=0,i.MK="normal",i.O3="normal",i.K7=[5,5],i.A0O=[0,0],i.YT=""},parse:function(){this.b();var e,i=this;i.assign_a([["type","AF"],["value-range","A6A","b"],["offset-start","AC","i"],["offset-end","BV","i"],["placement","BA"],["pair-scale","YT"],["label-placement","MK"],["label-alignment","O3"],["range","F9"]]),null===ZC._n_(i.o.alpha)&&(i.o.alpha="area"===i.AF?.25:.95),null!==ZC._n_(e=i.o["label-tolerance"])&&("object"==typeof e&&e.length?(i.K7[0]=ZC._i_(e[0]||"5"),i.K7[1]=ZC._i_(e[1]||"5")):i.K7[0]=i.K7[1]=ZC._i_(e||"5")),i.assign_a([["alpha","C6","f",0,1]]),null===ZC._n_(e=i.o.label)&&null===ZC._n_(i.o.text)||(i.M=new ZC.DN(i),i.A.A.A.B8.load(i.M.o,["("+i.A.AF+").SCALE.marker.label"]),null!==ZC._n_(i.o.text)&&i.M.append({text:i.o.text}),i.M.append(e),i.M.parse(),i.A0O=[i.M.BL,i.M.BH])},paint:function(){var e,i,t,n,a,l,o,r=this;if(r.F9)if(-1===r.A.BE.indexOf("scale-r")){if(r.AN){var s,A,C,c,u=r.A,p=r.A.A.P.AU,Z=u.A.K+"-scales-"+("top"===r.BA?"f":"b")+"l-0-c";r.Z=r.C7=ZC.AL(u.H.usc()?u.H.K+"-main-c":Z),e=ZC.Q.EB(r.Z,u.H.AB),a=[];var h,d=0,f=0;r.BL>-1&&r.BL<1&&(r.BL=Math.ceil(r.BL*u.AA)),r.BH>-1&&r.BH<1&&(r.BH=Math.ceil(r.BH*u.AA)),r.M&&(r.M.Z=u.H.usc()?u.H.mc():ZC.AL(u.A.K+"-scales-ml-0-c"),r.M.K=r.A.A.K+"-"+r.A.BE.replace(/\-/g,"_")+"-marker_"+r.L,r.M.GL=r.A.K+"-marker-label "+r.A.A.K+"-scale-marker-label zc-scale-marker-label");var _=r.A.A,g=function(e,i){var t;return-1!==(i+"").indexOf("%")?(t=ZC._f_(i.replace("%","")),t="k"===e.AF?ZC._i_(t*(e.DX-e.DC)/100):t*(e.H0-e.FX)/100):t=i,r.A6A||"v"===e.AF?e.AT(t):e.IB(t)};if("poly"===r.AF){var v,b,B,m;for(_=r.A.A,"k"===u.AF?(v=u,b=""===r.YT?_.BU("v")[0]:_.BM(r.YT)||_.BU("v")[0]):"v"===u.AF&&(b=u,v=""===r.YT?_.BU("k")[0]:_.BM(r.YT)||_.BU("k")[0]),l=0,o=r.F9.length;l<o;l++)B=g(v,r.F9[l][0]),m=b.AT(r.F9[l][1]),a.push([B,m]),d+=B,f+=m;if(d/=a.length,f/=a.length,a.length>=3){if(a[0].join("/")!==a[a.length-1].join("/")&&a.push([a[0][0],a[0][1]]),u.A.AJ["3d"])for(u.A.NX(),i=0,t=a.length;i<t;i++)n=new ZC.CE(u.A,a[i][0]-ZC.AO.E2,a[i][1]-ZC.AO.E3,ZC.AO.FU),a[i][0]=n.ED[0],a[i][1]=n.ED[1];(h=new ZC.DT(r.A)).K=u.K+"-marker-"+r.L,h.Z=h.C7=u.H.usc()?u.H.mc():ZC.AL(Z),h.copy(r),h.AZ=0,h.AU=0,h.EX=0,h.GA=0,h.D=a,h.parse(),h.paint()}}else if("line"===r.AF){if(-1!==u.BE.indexOf("scale-x")?1===r.F9.length?s=A=g(u,r.F9[0]):2===r.F9.length&&(s=g(u,r.F9[0]),A=g(u,r.F9[1])):-1!==u.BE.indexOf("scale-y")&&(1===r.F9.length?s=A=g(u,r.F9[0]):2===r.F9.length&&(s=g(u,r.F9[0]),A=g(u,r.F9[1]))),-1!==u.BE.indexOf("scale-x")&&u.CO||-1!==u.BE.indexOf("scale-y")&&!u.CO?(a.push([u.iX+r.AC,s],[u.iX+u.I-r.BV,A]),r.o&&r.o.tooltip&&(_.o.labels=_.o.labels||[],_.o.labels.push({x:u.iX,y:s-r.AZ,width:u.I,height:2*r.AZ,alpha:0,tooltip:r.o.tooltip})),r.M&&("opposite"===r.MK?r.M.iX=u.iX+u.I-r.M.I-r.BV:r.M.iX=u.iX+r.AC,"opposite"===r.MK?r.M.iY=A-(u.AW?0:r.M.F):r.M.iY=s-(u.AW?0:r.M.F))):(a.push([s,u.iY+u.F-r.AC],[A,u.iY+r.BV]),r.o&&r.o.tooltip&&(_.o.labels=_.o.labels||[],_.o.labels.push({x:s-r.AZ,y:u.iY,width:2*r.AZ,height:u.F,alpha:0,tooltip:r.o.tooltip})),r.M&&("opposite"===r.MK?r.M.iX=A-(u.AW?r.M.I:0):r.M.iX=s-(u.AW?r.M.I:0),"opposite"===r.MK?r.M.iY=u.iY+r.M.I-r.M.F+r.BV:r.M.iY=u.iY+u.F-r.M.F-r.AC)),u.A.AJ["3d"])for(u.A.NX(),i=0,t=a.length;i<t;i++)n=new ZC.CE(u.A,a[i][0]-ZC.AO.E2,a[i][1]-ZC.AO.E3,ZC.AO.FU),a[i][0]=n.ED[0],a[i][1]=n.ED[1];2===a.length&&(ZC.CR.setup(e,r),ZC.CR.paint(e,r,a))}else if("area"===r.AF&&(-1!==u.BE.indexOf("scale-x")?2===r.F9.length?(s=C=g(u,r.F9[0]),A=c=g(u,r.F9[1])):4===r.F9.length&&(s=g(u,r.F9[0]),A=g(u,r.F9[1]),C=g(u,r.F9[2]),c=g(u,r.F9[3])):-1!==u.BE.indexOf("scale-y")&&(2===r.F9.length?(s=C=u.AT(r.F9[0]),A=c=u.AT(r.F9[1])):4===r.F9.length&&(s=u.AT(r.F9[0]),A=u.AT(r.F9[1]),C=u.AT(r.F9[2]),c=u.AT(r.F9[3]))),A=s===A?A+1:A,c=C===c?c+1:c,-1!==u.BE.indexOf("scale-x")&&u.CO||-1!==u.BE.indexOf("scale-y")&&!u.CO?(a.push([u.iX+p,s],[u.iX+u.I-p,C],[u.iX+u.I-p,c],[u.iX+p,A],[u.iX+p,s]),r.M&&("opposite"===r.MK?r.M.iX=u.iX+u.I-r.M.I-r.BV:r.M.iX=u.iX+r.AC,"opposite"===r.MK?r.M.iY=A-(u.AW?0:r.M.F):r.M.iY=s-(u.AW?0:r.M.F))):(a.push([s,u.iY+u.F-p],[C,u.iY+p],[c,u.iY+p],[A,u.iY+u.F-p],[s,u.iY+u.F-p]),r.M&&("opposite"===r.MK?r.M.iX=A-(u.AW?r.M.I:0):r.M.iX=s-(u.AW?r.M.I:0),"opposite"===r.MK?r.M.iY=u.iY+r.M.I-r.M.F+r.BV:r.M.iY=u.iY+u.F-r.M.F-r.AC)),a.length>=4)){if(u.A.AJ["3d"])for(u.A.NX(),i=0,t=a.length;i<t;i++)n=new ZC.CE(u.A,a[i][0]-ZC.AO.E2,a[i][1]-ZC.AO.E3,ZC.AO.FU),a[i][0]=n.ED[0],a[i][1]=n.ED[1];(h=new ZC.DT(r.A)).K=u.K+"-marker-"+r.L,h.Z=h.C7=u.H.usc()?u.H.mc():ZC.AL(Z),h.copy(r),h.AZ=0,h.AU=0,h.EX=0,h.GA=0,h.D=a,h.parse(),h.BL=r.BL,h.BH=r.BH,h.paint()}var E=!0,D=u.A.P;2===a.length&&(-1!==u.BE.indexOf("scale-x")&&u.CO||-1!==u.BE.indexOf("scale-y")&&!u.CO?ZC.DS(a[0][1],D.iY-r.K7[1],D.iY+D.F+r.K7[1])&&ZC.DS(a[1][1],D.iY-r.K7[1],D.iY+D.F+r.K7[1])||(E=!1):ZC.DS(a[0][0],D.iX-r.K7[0],D.iX+D.I+r.K7[0])&&ZC.DS(a[1][0],D.iX-r.K7[0],D.iX+D.I+r.K7[0])||(E=!1));var F=r.O3;if(r.M&&E&&("poly"===r.AF?(r.M.iX=ZC._i_(d-r.M.I/2),r.M.iY=ZC._i_(f-r.M.F/2)):("auto"===r.O3&&(F=-1!==u.BE.indexOf("scale-x")&&!u.CO||-1!==u.BE.indexOf("scale-y")&&u.CO?s<u.iX+u.I/2?"normal":"opposite":s>u.iY+u.F/2?"normal":"opposite"),r.M.BL=r.M.BH=0,(-1!==u.BE.indexOf("scale-x")&&!u.CO||-1!==u.BE.indexOf("scale-y")&&u.CO)&&null===ZC._n_(r.M.o.angle)&&(r.M.A9=270),-1!==u.BE.indexOf("scale-x")&&!u.CO||-1!==u.BE.indexOf("scale-y")&&u.CO?(r.M.A9%180==90&&(r.M.BL-=(u.AW?-1:1)*(r.M.I/2-r.M.F/2),r.M.BH-=r.M.I/2-r.M.F/2,"opposite"===r.MK&&(r.M.BH=-r.M.I/2+r.M.F/2),"opposite"===F&&(r.M.BL-=r.M.F)),r.M.A9%180==0&&("opposite"===r.MK&&(r.M.BH=-r.M.I+r.M.F),"opposite"===F&&(r.M.BL-=r.M.I))):(r.M.A9%180==90&&(r.M.BL-=r.M.I/2-r.M.F/2,r.M.BH-=(u.AW?-1:1)*(r.M.I/2-r.M.F/2),"opposite"===r.MK&&(r.M.BL=r.M.I/2-r.M.F/2),"opposite"===F&&(r.M.BH+=r.M.I)),r.M.A9%180==0&&"opposite"===F&&(r.M.BH+=r.M.F)),r.M.BL+=r.A0O[0]+r.BL,r.M.BH+=r.A0O[1]+r.BH),u.A.AJ["3d"]&&(n=new ZC.CE(u.A,r.M.iX-ZC.AO.E2,r.M.iY-ZC.AO.E3,ZC.AO.FU),r.M.iX=n.ED[0],r.M.iY=n.ED[1]),ZC.DS(r.M.iX+r.M.BL+(r.M.A9%180==0?r.M.I/2:r.M.F/2),r.A.A.P.iX-r.K7[0],r.A.A.P.iX+r.A.A.P.I+r.K7[0])&&ZC.DS(r.M.iY+r.M.BH+(r.M.A9%180==0?r.M.F/2:r.M.I/2),r.A.A.P.iY-r.K7[1],r.A.A.P.iY+r.A.A.P.F+r.K7[1])&&(r.M.paint(),r.M.EK(),!r.M.K9&&"normal"===zingchart.OBJECTMODE&&(u.E["marker_text_"+r.L]=r.M.AM,ZC.AL(_.A.K+"-map"))))){var K=ZC.AP.O4(_.K,r.M);ZC.AL(_.A.K+"-map").innerHTML=ZC.AL(_.A.K+"-map").innerHTML+K}}}else r.A.paintMarker(r)}};ZC.A0F=ZC.DT.CA(A0F);var VI={$i:function(e){var i=this;i.LZ=null,i.A5H=0,i.OX=[],i.BE=e,i.A3J=!0},add:function(e){var i=this;i.OX.push(e),e.K0=i,e.LZ=i.LZ,e.C0.TJ=!0,e.X2=i.OX.length-1,i.A3J=!1}};ZC.VI=ZC.C9.CA(VI);var E4={$i:function(e,i,t,n,a,l){var o=this;for(var r in o.LZ=null,o.C0=e,o.AX=null,o.A57=0,o.IK=null,o.N=i||{},o.A5K=t||500,o.X9=n||-1,o.A0B=null,o.T2=null,o.OC=null,null!==ZC._n_(l)&&(o.T2=l),o.A4F=ZC.E4.linear,null!==ZC._n_(a)&&""!==a&&(o.A4F=a),o.ADJ={},o.C5={},o.ACK=[],o.RC=ZC._i_(o.A5K/ZC.PH.U3),o.RC>100&&(o.RC=100),(ZC.vml||ZC.mobile)&&(o.RC=ZC._i_(o.RC/4)),o.RC<5&&(o.RC=5),o.N)null!==ZC._n_(ZC.E4.GO[r])?o.C5[r]=o.C0[ZC.E4.GO[r]]:o.C5[r]=o.C0[r];o.Y=0,o.K0=null,o.X2=-1},status:function(){return this.Y+1>this.RC?0:1},step:function(){var e,i,t,n,a,l,o=this,r=1,s=o.LZ.C.H.AB;if(o.Y++,o.Y>o.RC&&(o.Y===o.RC+1&&-1!==o.X2&&(o.K0.A5H++,o.K0.A5H===o.K0.OX.length&&(o.K0.A3J=!0)),r=0),r){var A={};if(o.Y===o.RC)A=o.N,o.A57=1;else for(var C in o.A57=o.A4F(o.Y,0,1,o.RC),o.N)switch(C){case"points":var c=[];for(a=0,l=o.N[C].length;a<l;a++)if(null!==ZC._n_(o.C5[C][a])){c[a]=[];for(var u=0,p=o.N[C][a].length;u<p;u++)c[a][u]=o.A4F(o.Y,o.C5[C][a][u],o.N[C][a][u]-o.C5[C][a][u],o.RC)}A[C]=c;break;case"lineColor":case"borderColor":case"backgroundColor1":case"backgroundColor2":var Z=o.C5[C].replace("#",""),h=ZC.AP.G9(o.N[C]).replace("#",""),d=ZC.QY(Z.slice(0,2)),f=ZC.QY(Z.slice(2,4)),_=ZC.QY(Z.slice(4,6)),g=ZC.QY(h.slice(0,2)),v=ZC.QY(h.slice(2,4)),b=ZC.QY(h.slice(4,6)),B=ZC.OV(ZC._i_(o.A4F(o.Y,d,g-d,o.RC)));1===B.length&&(B="0"+B);var m=ZC.OV(ZC._i_(o.A4F(o.Y,f,v-f,o.RC)));1===m.length&&(m="0"+m);var E=ZC.OV(ZC._i_(o.A4F(o.Y,_,b-_,o.RC)));1===E.length&&(E="0"+E),A[C]="#"+B+m+E;break;default:A[C]=o.A4F(o.Y,o.C5[C],o.N[C]-o.C5[C],o.RC)}if(o.C0.append(A),o.C0.TJ=!0,o.C0.parse(),o.AX&&(null!==ZC._n_(e=o.C0.E["bound-1"])&&(o.C0.D1[1]=e),null!==ZC._n_(e=o.C0.E["bound-3"])&&(o.C0.D1[3]=e),"vml"===s&&1===o.Y&&("undefined"!=typeof o.AX.A.HX?o.C0.E.opacity2=o.AX.A.HX:o.C0.E.opacity2=o.AX.A.C6),o.AX.H&&(o.AX.H.E[o.AX.K+"-bounds"]=[o.AX.iX,o.AX.iY,o.AX.iX+o.AX.I,o.AX.iY+o.AX.F])),o.A0B)try{o.A0B(o.C0,A)}catch(X){}if(o.AX){var D={id:o.AX.H.K,graphid:o.AX.C.K,plotindex:o.AX.A.L,nodeindex:o.AX.L,stage:o.A57,value:o.AX.AD*o.A57};ZC.AP.BY("animation_step",o.AX.H,D)}}if(o.AX){if(1===o.Y||"canvas"===s)-1!==ZC.AV(["svg","vml"],s)?0===ZC.A4("#"+o.C0.K+"-path").length&&o.paint():o.paint();else if(o.Y<=o.RC){switch(s){case"svg":o.C0.WZ(!0);break;case"vml":o.C0.WY(null,!0)}o.C0.W0&&o.C0.W0(),"vml"===s&&/\-plotset\-plot-\d+\-node\-\d+\-area/.test(o.C0.K)&&(o.C0.AZ=0),i=null,"undefined"!=typeof o.C0.DU&&"box"===o.C0.DU&&(i=o.C0.AZ,o.C0.AZ=o.C0.AU);var F=!1;if("svg"===s&&ZC.AL(o.C0.K+"-path")&&"rect"===ZC.AL(o.C0.K+"-path").tagName&&(F=!0),F)t=[],n=[];else if(t=ZC.Q.A2W(o.C0.D,s,o.C0,!1,!0),o.C0.M8){var K=ZC.Q._sh_(o.C0.D,o.C0);n=ZC.Q.A2W(K,s,o.C0,!1,!0)}null!==ZC._n_(i)&&(o.C0.AZ=i);var x=o.C0.C6,I=o.C0.NY,y=o.C0.T6,w=o.C0.JV,L=o.C0.AI;switch(s){case"svg":ZC.A4("#"+o.C0.K+"-path").attr("d",t.join(" ")).attr("stroke-opacity",I).attr("fill-opacity",x),o.C0.M8&&ZC.A4("#"+o.C0.K+"-sh-path").attr("d",n.join(" ")).attr("stroke-opacity",I*y).attr("fill-opacity",x*y),F&&(ZC.A4("#"+o.C0.K+"-path").attr("x",o.C0.iX).attr("y",o.C0.iY).attr("width",ZC.BQ(0,o.C0.I)).attr("height",ZC.BQ(0,o.C0.F)),o.C0.M8&&ZC.A4("#"+o.C0.K+"-sh-path").attr("x",o.C0.iX+w*ZC.EH(o.C0.OH)).attr("y",o.C0.iY+w*ZC.EO(o.C0.OH)).attr("width",ZC.BQ(0,o.C0.I)).attr("height",ZC.BQ(0,o.C0.F))),ZC.A4("#"+o.C0.K+"-circle").attr("stroke-opacity",I).attr("cx",o.C0.iX).attr("cy",o.C0.iY).attr("r",L).attr("fill-opacity",x),o.C0.M8&&ZC.A4("#"+o.C0.K+"-sh-circle").attr("stroke-opacity",I*y).attr("cx",o.C0.iX+w).attr("r",L).attr("cy",o.C0.iY+w).attr("fill-opacity",x*y),""!==o.C0.DA&&ZC.A4("#"+o.C0.K+"-path-imgfill").attr("d",t.join(" ")).attr("stroke-opacity",I).attr("fill-opacity",x),ZC.A4("#"+o.C0.K+"-goal-path").remove();break;case"vml":ZC.A4("#"+o.C0.K+"-path").children().each(function(){this.v=t.join(" "),this.opacity=x}),o.C0.M8&&ZC.A4("#"+o.C0.K+"-sh-path").children().each(function(){this.v=n.join(" "),this.opacity=x*y}),ZC.A4("#"+o.C0.K+"-circle").children().each(function(){this.opacity=x}),ZC.A4("#"+o.C0.K+"-circle").each(function(){this.style.left=o.C0.iX-L+"px",this.style.top=o.C0.iY-L+"px",this.style.width=2*L+"px",this.style.height=2*L+"px"}),o.C0.M8&&(ZC.A4("#"+o.C0.K+"-sh-circle").children().each(function(){this.opacity=x*y}),ZC.A4("#"+o.C0.K+"-sh-circle").each(function(){this.style.left=o.C0.iX-L+w+"px",this.style.top=o.C0.iY-L+w+"px",this.style.width=2*L+"px",this.style.height=2*L+"px"})),ZC.A4("#"+o.C0.K+"-goal-path").remove()}}}else o.LZ.C.Q4=!0,o.LZ.C.A0M(),o.LZ.C.KK();return o.Y===o.RC+1&&null!==ZC._n_(o.T2)&&o.T2(),r},paint:function(){var e=this;if(null!==ZC._n_(e.IK)?ZC.CR.paint(e.IK,e.C0,e.C0.D):e.C0.paint(),e.OC)try{1===e.A57&&e.OC()}catch(i){}}};ZC.E4=ZC.C9.CA(E4),ZC.E4.GO={angleStart:"B4",angleEnd:"BK",slice:"CN",size:"AI",x:"iX",y:"iY",width:"I",height:"F",alpha:"C6",angle:"A9",fillAngle:"N9",points:"D",lineWidth:"AZ",lineColor:"B7",borderWidth:"AU",borderColor:"BW",backgroundColor1:"A0",backgroundColor2:"AE"},ZC.E4.linear=function(e,i,t,n){return t*e/n+i},ZC.E4.backEaseOut=function(e,i,t,n){var a=(e/=n)*e;return i+t*(4*(a*e)+-9*a+6*e)},ZC.E4.elasticEaseOut=function(e,i,t,n){var a=(e/=n)*e,l=a*e;return i+t*(37.045*l*a+-116.2825*a*a+134.08*l+-68.59*a+14.7475*e)},ZC.E4.bounceEaseOut=function(e,i,t,n){return(e/=n)<1/2.75?t*(7.5625*e*e)+i:e<2/2.75?t*(7.5625*(e-=1.5/2.75)*e+.75)+i:e<2.5/2.75?t*(7.5625*(e-=2.25/2.75)*e+.9375)+i:t*(7.5625*(e-=2.625/2.75)*e+.984375)+i},ZC.E4.regularEaseOut=function(e,i,t,n){var a=(e/=n)*e;return i+t*(a*e+-3*a+3*e)},ZC.E4.strongEaseOut=function(e,i,t,n){var a=(e/=n)*e,l=a*e;return i+t*(l*a+-5*a*a+10*l+-10*a+5*e)},ZC.E4.RK=[ZC.E4.linear,ZC.E4.backEaseOut,ZC.E4.elasticEaseOut,ZC.E4.bounceEaseOut,ZC.E4.strongEaseOut,ZC.E4.regularEaseOut],ZC.ANIMATION={SLOW:4e3,FAST:1e3,LINEAR:0,BACK_EASE_OUT:1,ELASTIC_EASE_OUT:2,BOUNCE_EASE_OUT:3,STRONG_EASE_OUT:4,REGULAR_EASE_OUT:5,NO_SEQUENCE:0,BY_PLOT:1,BY_NODE:2,BY_PLOT_AND_NODE:3,FADE_IN:1,EXPAND_VERTICAL:2,EXPAND_TOP:3,EXPAND_BOTTOM:4,EXPAND_LEFT:5,EXPAND_RIGHT:6,EXPAND_HORIZONTAL:7,SLIDE_LEFT:8,SLIDE_RIGHT:9,SLIDE_TOP:10,SLIDE_BOTTOM:11,UNFOLD_HORIZONTAL:12,UNFOLD_VERTICAL:13,EXPAND:2,GROW:3,FLY_IN:4,UNFOLD:5},ZC.PH=ZC.C9.CA({$i:function(e){var i=this;i.C=e,i.RP=!1,i.C4=null,i.OX=[],i.PE={},i.onStop=null},A9P:function(e,i){var t=this;null===ZC._n_(t.PE[e.BE])&&(t.PE[e.BE]=e,e.LZ=t,t.RP||(null!==ZC._n_(i)&&i>0?window.setTimeout(function(){t.start()},i+1):t.start()))},add:function(e){var i=this;e.LZ=i,e.X9>0?(i.OX.push(e),window.setTimeout(function(){e.C0.TJ=!0,i.RP||i.start()},e.X9+1)):(e.C0.TJ=!0,i.OX.push(e),i.RP||i.start())},start:function(){var e=this;e.RP=!0,ZC.AP.BY("animation_start",e.C.A,{id:e.C.A.K,graphid:e.C.K});var i=!0;!function t(){i||e.step(),i=!1,e.RP&&(e.C4=window.requestAnimFrame(t))}()},step:function(){var e,i=this,t=0;if(i.RP){for(var n=0,a=i.OX.length;n<a;n++)t+=i.OX[n].status();if("canvas"===i.C.H.AB)if(i.C.H.K9)null!==ZC._n_(e=ZC.AL(i.C.K+"-plots-bl-c"))&&e.getContext("2d").clearRect(i.C.iX,i.C.iY,i.C.I,i.C.F);else for(n=0,a=i.C.AY.A5.length;n<a;n++)for(var l=0;l<i.C.AY.A5[n].SW;l++)null!==ZC._n_(e=ZC.AL(i.C.K+"-plot-"+n+"-bl-"+l+"-c"))&&e.getContext("2d").clearRect(i.C.iX,i.C.iY,i.C.I,i.C.F);for(n=0,a=i.OX.length;n<a;n++)0===i.OX[n].step()&&(i.OX[n].C0.TJ=!1);for(var o in i.PE)for(i.PE[o].A3J||(t+=1),n=0,a=i.PE[o].OX.length;n<a;n++)i.PE[o].OX[n].X2===i.PE[o].A5H?0===i.PE[o].OX[n].step()&&(i.PE[o].OX[n].C0.TJ=!1):"canvas"===i.C.H.AB&&i.PE[o].OX[n].paint();0===t&&(i.PE={},i.OX=[],i.stop())}},stop:function(e){null===ZC._n_(e)&&(e=!1);var i,t=this;if(e&&(t.bDead=!0),window.clearAnimFrame(t.C4),t.C.A0M(),t.C.Q4=!1,ZC.AL(t.C.H.K)){t.C.KK(),window.setTimeout(function(){if((i=ZC.AL(t.C.A.K+"-map"))&&t.C.AY.HF){-1===ZC.AV(["bubble","mixed","vbullet","hbullet","radar"],t.C.AF)&&1!==zingchart.SORTTRACKERS||t.C.AY.HF.sort(function(e,i){return ZC.AP.N2(e)>ZC.AP.N2(i)?1:-1});var e='<area shape="rect" coords="0,0,1,1" id="mark'+t.C.L+'">',n=i.innerHTML.indexOf(e);-1!==n?i.innerHTML=i.innerHTML.substring(0,n+e.length)+t.C.a11y()+t.C.AY.HF.join("")+i.innerHTML.substring(n+e.length):i.innerHTML+=t.C.a11y()+t.C.AY.HF.join("")}},33),t.C.A6P(),t.RP=!1;for(var n=0,a=t.OX.length;n<a;n++)t.OX[n].T2=null;if(t.OX=[],t.PE={},e||ZC.AP.BY("animation_end",t.C.A,{id:t.C.A.K,graphid:t.C.K}),null!==ZC._n_(t.onStop))try{t.onStop()}catch(l){}}}}),ZC.PH.U3=33,function(){for(var e=["ms","moz","webkit","o"],i=0,t=e.length;i<t&&!window.requestAnimFrame;++i)window.requestAnimFrame=window.requestAnimationFrame||window[e[i]+"RequestAnimationFrame"],window.cancelAnimFrame=window.cancelAnimationFrame||window[e[i]+"CancelAnimationFrame"]||window[e[i]+"CancelRequestAnimationFrame"];window.requestAnimFrame||(window.requestAnimFrame=function(e){return window.setTimeout(e,ZC.PH.U3)}),window.clearAnimFrame||(window.clearAnimFrame=function(e){window.clearTimeout(e)})}(),zingchart.bind(null,"dataparse",function(e,i){for(var t,n,a=0,l=i.graphset.length;a<l;a++)if(i.graphset[a].type&&-1!==ZC.AV(["pie","line","vline","area","varea","bar","vbar","hbar","line3d","area3d","bar3d","vbar3d","hbar3d"],i.graphset[a].type)&&i.graphset[a].nav){var o=i.graphset[a];ZC._todash_(o);var r=o.nav||{};ZC._todash_(r);var s,A,C,c=ZC.II(r.threshold||"10%"),u=r.others||{text:"Others"},p=r.back||{},Z=r.slice||"0.3",h=o.series||[],d=[];if("pie"===i.graphset[a].type){var f=0;for(t=0;t<h.length;t++)h[t].values&&null!==ZC._n_(h[t].values[0])&&(f+=h[t].values[0]);c>0&&c<1&&(c*=f),s=[].concat(h);var _=0,g="";for(A=1,t=h.length-1;t>=0;t--)h[t].values&&null!==ZC._n_(h[t].values[0])&&h[t].values[0]<c&&(_+=h[t].values[0],g+=(h[t].text||"Item no."+A)+":"+h[t].values[0]+"<br>",h[t].slice=Z,d.push(h[t]),h.splice(t,1),A++);_>0&&(A>2?(C={values:[_],detach:!1,"data-group":[1],"tooltip-text":g=g.substring(0,g.length-4)},ZC._cp_(u,C),h.push(C),zingchart.bind(e.id,"plot_click",function(i){if(i.xdata.group){var t=zingchart.getLoader(i.id);if(!t)return;var n=zingchart.getGraph(t,i.graphid);for(var a in n.getAttributes())"pie-sel-"===a.substring(0,8)&&n.setAttribute(a,null);zingchart.exec(e.id,"setseriesdata",{data:d}),window.setTimeout(function(){var i=zingchart.exec(e.id,"getobjectinfo",{object:"node",plotindex:0,nodeindex:0}),t={id:"navpie_btnback",x:i.x,y:i.y,text:"< Back",anchor:"c",cursor:"hand"};ZC._cp_(p,t),zingchart.exec(e.id,"addobject",{type:"label",data:t})},1)}}),zingchart.bind(e.id,"label_click",function(i){if("navpie_btnback"===i.label.id){var t=zingchart.getLoader(i.id);if(!t)return;var n=zingchart.getGraph(t,i.graphid);for(var a in n.getAttributes())"pie-sel-"===a.substring(0,8)&&n.setAttribute(a,null);zingchart.exec(e.id,"removeobject",{type:"label",id:"navpie_btnback"}),zingchart.exec(e.id,"setseriesdata",{data:h})}})):o.series=[].concat(s))}else{var v=0,b=[];for(t=0;t<h.length;t++){if(b[t]=0,h[t].values&&h[t].values.length)for(n=0;n<h[t].values.length;n++)b[t]+=ZC._a_(h[t].values[n]);v=ZC.BQ(v,b[t])}c>0&&c<1&&(c*=v),s=[].concat(h);var B=[],m=[];for(A=1,t=h.length-1;t>=0;t--)if(b[t]<c){if(h[t].values&&h[t].values.length)for(n=0;n<h[t].values.length;n++)B[n]=ZC._f_(B[n]||"0"),B[n]+=h[t].values[n],m[n]=m[n]||"",m[n]+=(h[t].text||"Item no."+A)+":"+h[t].values[n]+"<br>";d.push(h[t]),h.splice(t,1),A++}if(B.length)if(A>2){for(n=0;n<m.length;n++)m[n]=m[n].substring(0,m[n].length-4);C={values:B,detach:!1,"data-group":[1],"data-tt-text":m,"tooltip-text":"%data-tt-text"},ZC._cp_(u,C),h.push(C),zingchart.bind(e.id,"plot_click",function(i){if(i.xdata.group){if(!zingchart.getLoader(i.id))return;zingchart.exec(e.id,"setseriesdata",{data:d}),window.setTimeout(function(){var i=zingchart.exec(e.id,"getobjectinfo",{object:"plotarea"}),t={id:"navxy_btnback",x:i.x+i.width/2,y:i.y,text:"< Back",anchor:"c",cursor:"hand"};ZC._cp_(p,t),zingchart.exec(e.id,"addobject",{type:"label",data:t})},1)}}),zingchart.bind(e.id,"label_click",function(i){if("navxy_btnback"===i.label.id){if(!zingchart.getLoader(i.id))return;zingchart.exec(e.id,"removeobject",{type:"label",id:"navxy_btnback"}),zingchart.exec(e.id,"setseriesdata",{data:h})}})}else o.series=[].concat(s)}}return i});}


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	/*This configuration is used in
	    components/common/breakdownchart.jsx
	    components/common/linechart.jsx
	    components/common/rangechart.jsx
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = {
	    gui: {
	        "behaviors": [{
	            "id": "ViewSource",
	            "enabled": "none"
	        }, {
	            "id": "Reload",
	            "enabled": "none"
	        }, {
	            "id": "Print",
	            "enabled": "none"
	        }, {
	            "id": "DownloadSVG",
	            "enabled": "none"
	        }, {
	            id: "SaveAsImage",
	            enabled: "all"
	        }],
	        contextMenu: {
	            button: {
	                alpha: 0.1,
	                borderRadius: 15,
	                visible: true
	            }
	        }
	    }
	};
	module.exports = exports["default"];

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	/*
	This component is used in
	components/pages/comparison/charts/dailychart/index.jsx
	components/pages/comparison/charts/rangechart/index.jsx
	components/pages/comparison/charts/totalchart/index.jsx
	components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
	components/pages/stats/occupancybreakdown/index.jsx
	*/
	var optionClicked = function optionClicked(props, mode) {
	    props.chooseMode(mode);
	};
	var ModeSelector = function ModeSelector(props) {
	    return _react2['default'].createElement(
	        _componentsCommonDropdowncomponentsDropdown2['default'],
	        { className: props.className, header: props.mode, toggleable: true },
	        _react2['default'].createElement(
	            _componentsCommonDropdowncomponentsDropdownitem2['default'],
	            null,
	            _react2['default'].createElement(
	                'div',
	                { onClick: optionClicked.bind(undefined, props, _config2['default'].mode.AVERAGE.code) },
	                _config2['default'].mode.AVERAGE.code
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonDropdowncomponentsDropdownitem2['default'],
	            null,
	            _react2['default'].createElement(
	                'div',
	                { onClick: optionClicked.bind(undefined, props, _config2['default'].mode.PEAK.code) },
	                _config2['default'].mode.PEAK.code
	            )
	        )
	    );
	};
	exports['default'] = ModeSelector;
	module.exports = exports['default'];

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	/* This component is used in
	components/common/statsmenu.jsx
	components/pages/comparison/charts/dailychart/index.jsx
	components/pages/comparison/charts/rangechart/index.jsx
	components/pages/comparison/charts/totalchart/index.jsx
	*/
	var optionClicked = function optionClicked(props, tag) {
	  props.chooseTag(tag);
	};
	var TagSelector = function TagSelector(props) {
	  var multiOption = props.roomType === 'meeting_room';
	  return multiOption ? _react2['default'].createElement(
	    _componentsCommonDropdowncomponentsDropdown2['default'],
	    { className: props.className, header: props.tag, toggleable: true },
	    _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	        null,
	        _react2['default'].createElement(
	          'div',
	          { onClick: optionClicked.bind(undefined, props, "Occupancy") },
	          _config2['default'].tag.OCCUPANCY.type
	        )
	      ),
	      _react2['default'].createElement(
	        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	        null,
	        _react2['default'].createElement(
	          'div',
	          { onClick: optionClicked.bind(undefined, props, "Efficiency") },
	          _config2['default'].tag.EFFICIENCY.type
	        )
	      )
	    )
	  ) : _react2['default'].createElement(
	    'div',
	    { className: 'dropdown-default-text ' + props.className },
	    props.tag
	  );
	};
	exports['default'] = TagSelector;
	module.exports = exports['default'];

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsComparison = __webpack_require__(205);
	
	var _componentsCommonChartsRangechart = __webpack_require__(1284);
	
	var _componentsCommonChartsRangechart2 = _interopRequireDefault(_componentsCommonChartsRangechart);
	
	var _componentsCommonDropdowncomponentsModeselector = __webpack_require__(1281);
	
	var _componentsCommonDropdowncomponentsModeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsModeselector);
	
	var _componentsCommonDropdowncomponentsTagselector = __webpack_require__(1282);
	
	var _componentsCommonDropdowncomponentsTagselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsTagselector);
	
	//import Modal from "components/common/modal";
	
	var RangeChartComparison = (function (_React$Component) {
	    _inherits(RangeChartComparison, _React$Component);
	
	    function RangeChartComparison(props, context) {
	        _classCallCheck(this, RangeChartComparison);
	
	        _get(Object.getPrototypeOf(RangeChartComparison.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            mode: 'Average',
	            tag: 'Occupancy'
	        };
	    }
	
	    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
	    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
	
	    _createClass(RangeChartComparison, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.isMeetingRoom !== this.props.isMeetingRoom || nextProps.querySettings != this.props.querySettings) {
	                this.setState({
	                    tag: 'Occupancy'
	                });
	            }
	        }
	    }, {
	        key: 'chooseMode',
	        value: function chooseMode(mode) {
	            this.setState({ mode: mode });
	        }
	    }, {
	        key: 'chooseTag',
	        value: function chooseTag(tag) {
	            this.setState({ tag: tag });
	            var params = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.first });
	            params.action = _actionsComparison.RECEIVE_FIRST_LOCATION_RANGE;
	            var params1 = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.second });
	            params1.action = _actionsComparison.RECEIVE_SECOND_LOCATION_RANGE;
	            params.groupby = "hour";
	            params1.groupby = "hour";
	
	            if (tag === 'Occupancy') {
	                params.tag = (0, _actionsStats.findOccupancyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findOccupancyTag)(this.props.second);
	            } else {
	                params.tag = (0, _actionsStats.findEfficiencyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findEfficiencyTag)(this.props.second);
	            }
	            this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params));
	            this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params1));
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues(index) {
	            var attribute = this.state.mode == 'Average' ? 'avg' : 'pk';
	            var values = [0, 0, 0, 0, 0, 0, 0];
	            this.props.stats[index].data.points.forEach(function (point) {
	                if (point[attribute] < 0.00001) {
	                    values[0] += 1;
	                    values[1] += 1;
	                } else if (point[attribute] < 0.2) {
	                    values[1] += 1;
	                } else if (point[attribute] < 0.4) {
	                    values[2] += 1;
	                } else if (point[attribute] < 0.6) {
	                    values[3] += 1;
	                } else if (point[attribute] < 0.8) {
	                    values[4] += 1;
	                } else if (point[attribute] < 0.99999) {
	                    values[5] += 1;
	                } else {
	                    values[5] += 1;
	                    values[6] += 1;
	                }
	            });
	            return values;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var values = [];
	            var values1 = [];
	            if (this.props.stats.length == 2 && this.props.stats[0] && this.props.stats[1]) {
	                values = this.getValues(0);
	                values1 = this.getValues(1);
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'box--shadow bg--white card__graph' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'clearfix graph__header' },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: 'graph__header__title graph__header__title--comparison-title pull-left' },
	                            this.state.tag,
	                            ' Range Comparison'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__header__options pull-right clearfix' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsModeselector2['default'], { mode: this.state.mode, chooseMode: this.chooseMode.bind(this) })
	                            ),
	                            this.props.isMeetingRoom && _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsTagselector2['default'], { roomType: 'meeting_room', tag: this.state.tag, chooseTag: this.chooseTag.bind(this) })
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body' },
	                        _react2['default'].createElement(_componentsCommonChartsRangechart2['default'], { id: 'rangecomparisonchart', values: values, values1: values1 })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body-legend-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'legend__location flex--center pull-left' },
	                            _react2['default'].createElement('div', { className: 'legend__location__square legend__location__square--blue  pull-left' }),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'legend__location__name pull-left' },
	                                this.props.first.info ? this.props.first.info.name : 'Location 1',
	                                ' '
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'legend__location flex--center pull-left' },
	                            _react2['default'].createElement('div', { className: 'legend__location__square legend__location__square--green  pull-left' }),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'legend__location__name pull-left' },
	                                this.props.second.info ? this.props.second.info.name : 'Location 2'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RangeChartComparison;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(RangeChartComparison);
	module.exports = exports['default'];
	/*    <Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openInfoModal = elem }}
	   clickButton={() => { this.openInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	       <div className="header__options__child pull-left">
	           <div onClick={() => { this.openInfoModal.open() }} className="">
	               <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	           </div>
	       </div>
	   }
	>
	   <p>Range Comparison Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>*/

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _zingchartReact = __webpack_require__(1277);
	
	var _componentsCommonChartsCommonchartconfig = __webpack_require__(1280);
	
	var _componentsCommonChartsCommonchartconfig2 = _interopRequireDefault(_componentsCommonChartsCommonchartconfig);
	
	/* This component is used in
	components/pages/comparison/charts/index.jsx
	components/pages/comparison/charts/rangechart/index.jsx
	components/pages/stats/occupancyrange/rangechartcontainer.jsx
	*/
	var RangeChart = function RangeChart(props) {
	    var values = [];
	    values.push({ values: props.values, backgroundColor: props.values1 ? "#60aff4" : "#3cb449" });
	    /* because the linechart default value of first line is blue and rangechart is green,
	     hence push values1 with color blue at the begining of the array value
	     this fixes color label issue in range chart in comparison page.
	     */
	    props.values1 && values.push({ values: props.values1, backgroundColor: "#3cb449" });
	
	    var myConfig = Object.assign({}, _componentsCommonChartsCommonchartconfig2['default'], {
	        type: "bar",
	        plotarea: {
	            backgroundColor: "#f6f7fa"
	        },
	        scaleX: {
	            labels: ["0%", "0-20%", "20-40%", "40-60%", "60-80%", "80-100%", "100%"],
	            minorTicks: 0
	        },
	        scaleY: {
	            lineColor: "#f6f7f8",
	            shadow: 0,
	            format: "%vhr",
	            guide: {
	                lineStyle: "dashed",
	                lineColor: "white"
	            },
	            minorTicks: 0,
	            thousandsSeparator: ","
	        },
	        plot: {
	            barWidth: "50px",
	            /*rules: [
	                   props.values1 ?
	                       (
	                           {
	                               rule: " %p==0 && %n==0 || %n==6",
	                               backgroundColor: "#60aff4" // values0(pale-blue)
	                           },
	                           {
	                               rule: " %p===1 && %n===0 || %n===6",
	                               backgroundColor: "#93d69b" // values1(pale-green)
	                           }
	                       )
	                       :
	                       {
	                           rule: " %p===0 && %n===0 || %n===6",
	                           backgroundColor: "#93d69b" // values1(pale-green)
	                       }
	               ]*/
	            rules: [{
	                rule: " %p==0 && %node-index ==0 || %p==0 && %node-index==6 ",
	                backgroundColor: props.values1 ? "#95c1e5" : "#dfdfdf"
	            }, {
	                rule: " %p==1 && %node-index ==0 || %p==1 && %node-index==6",
	                backgroundColor: props.values1 ? "#93d69b" : "#dfdfdf"
	            }]
	
	            // animation: {
	            //     effect: 1,
	            //     sequence: 2,
	            //     speed: 100
	            // }
	        },
	        series: values
	    });
	    return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_zingchartReact.core, { id: props.id, data: myConfig, height: '450px', width: '100%' })
	    );
	};
	exports['default'] = RangeChart;
	module.exports = exports['default'];

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsComparison = __webpack_require__(205);
	
	var _componentsCommonChartsLinechart = __webpack_require__(1276);
	
	var _componentsCommonChartsLinechart2 = _interopRequireDefault(_componentsCommonChartsLinechart);
	
	var _componentsCommonDropdowncomponentsModeselector = __webpack_require__(1281);
	
	var _componentsCommonDropdowncomponentsModeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsModeselector);
	
	var _componentsCommonDropdowncomponentsTagselector = __webpack_require__(1282);
	
	var _componentsCommonDropdowncomponentsTagselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsTagselector);
	
	var _componentsCommonDropdowncomponentsDayselector = __webpack_require__(1286);
	
	var _componentsCommonDropdowncomponentsDayselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDayselector);
	
	//import Modal from "components/common/modal";
	
	var DailyChart = (function (_React$Component) {
	    _inherits(DailyChart, _React$Component);
	
	    function DailyChart(props, context) {
	        _classCallCheck(this, DailyChart);
	
	        _get(Object.getPrototypeOf(DailyChart.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            mode: 'Average',
	            tag: 'Occupancy',
	            day: 'Mondays'
	        };
	    }
	
	    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
	    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
	
	    _createClass(DailyChart, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.isMeetingRoom !== this.props.isMeetingRoom || nextProps.querySettings != this.props.querySettings) {
	                this.setState({
	                    tag: 'Occupancy'
	                });
	            }
	        }
	    }, {
	        key: 'chooseDay',
	        value: function chooseDay(day) {
	            this.setState({ day: day });
	        }
	    }, {
	        key: 'chooseMode',
	        value: function chooseMode(mode) {
	            this.setState({ mode: mode });
	        }
	    }, {
	        key: 'chooseTag',
	        value: function chooseTag(tag) {
	            this.setState({ tag: tag });
	            var params = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.first });
	            params.action = _actionsComparison.RECEIVE_FIRST_LOCATION_DAILY;
	            var params1 = (0, _actionsStats.getParams)({ querySettings: this.props.querySettings, currentNode: this.props.second });
	            params1.action = _actionsComparison.RECEIVE_SECOND_LOCATION_DAILY;
	            if (tag === 'Occupancy') {
	                params.tag = (0, _actionsStats.findOccupancyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findOccupancyTag)(this.props.second);
	            } else {
	                params.tag = (0, _actionsStats.findEfficiencyTag)(this.props.first);
	                params1.tag = (0, _actionsStats.findEfficiencyTag)(this.props.second);
	            }
	            this.props.dispatch((0, _actionsStats.getStatsDaily)(params));
	            this.props.dispatch((0, _actionsStats.getStatsDaily)(params1));
	        }
	    }, {
	        key: 'sortUnique',
	        value: function sortUnique(arr) {
	            if (arr.length === 0) return arr;
	            var srt = arr.sort(function (a, b) {
	                return a * 1 - b * 1;
	            });
	            var ret = [srt[0]];
	            for (var i = 1; i < srt.length; i++) {
	                //Start loop at 1: arr[0] can never be a duplicate
	                if (srt[i - 1] !== srt[i]) {
	                    ret.push(srt[i]);
	                }
	            }
	            return ret;
	        }
	    }, {
	        key: 'getLineChartData',
	        value: function getLineChartData() {
	            var _this = this;
	
	            var mode = this.state.mode == 'Average' ? 'avg' : 'pk';
	            var data = {
	                labels: [],
	                peaks: [],
	                avgs: []
	            };
	            if (this.props.stats.length == 2 && this.props.stats[0] && this.props.stats[1]) {
	                var k1;
	                var k2;
	                var hours;
	
	                (function () {
	                    var first = _this.props.stats[0].data.values[_config2['default'].day.indexOf(_this.state.day)];
	                    var second = _this.props.stats[1].data.values[_config2['default'].day.indexOf(_this.state.day)];
	                    k1 = Object.keys(first ? first : []).map(function (x) {
	                        return parseInt(x);
	                    });
	                    k2 = Object.keys(second ? second : []).map(function (x) {
	                        return parseInt(x);
	                    });
	                    hours = _this.sortUnique(k1.concat(k2)).map(function (x) {
	                        return x + "";
	                    });
	
	                    hours.forEach(function (hour) {
	                        data.labels.push(hour);
	                        if (second[hour] && second[hour][mode] >= 0) {
	                            data.avgs.push(Math.round(second[hour][mode] * 100));
	                        } else {
	                            data.avgs.push(null);
	                        }
	                        if (first[hour] && first[hour][mode] >= 0) {
	                            data.peaks.push(Math.round(first[hour][mode] * 100));
	                        } else {
	                            data.peaks.push(null);
	                        }
	                    });
	                })();
	            }
	            return data;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = this.getLineChartData();
	            var first = '';
	            var second = '';
	            if (this.props.first.info && this.props.first.info) {
	                first = this.props.first.info.name;
	                second = this.props.second.info.name;
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'box--shadow bg--white card__graph' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'clearfix graph__header' },
	                        _react2['default'].createElement(
	                            'h2',
	                            { className: 'graph__header__title graph__header__title--comparison-title pull-left' },
	                            this.state.tag,
	                            ' Daily Comparison'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__header__options pull-right clearfix' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsDayselector2['default'], { day: this.state.day, chooseDay: this.chooseDay.bind(this), items: _config2['default'].day })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsModeselector2['default'], { mode: this.state.mode, chooseMode: this.chooseMode.bind(this) })
	                            ),
	                            this.props.isMeetingRoom && _react2['default'].createElement(
	                                'div',
	                                { className: 'header__options__child pull-left' },
	                                _react2['default'].createElement(_componentsCommonDropdowncomponentsTagselector2['default'], { roomType: 'meeting_room', tag: this.state.tag, chooseTag: this.chooseTag.bind(this) })
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body  clearfix' },
	                        _react2['default'].createElement(_componentsCommonChartsLinechart2['default'], { id: 'dailycomparison', stats: data, first: first, second: second })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DailyChart;
	})(_react2['default'].Component);
	
	exports.DailyChart = DailyChart;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(DailyChart);
	/*  <Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openInfoModal = elem }}
	   clickButton={() => { this.openInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	       <div className="header__options__child pull-left">
	           <div onClick={() => { this.openInfoModal.open() }} className="">
	               <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	           </div>
	       </div>
	   }
	>
	   <p>Daily comparsion Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>      */

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	/* This component is used in
	components/pages/comparison/charts/dailychart/index.jsx
	components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
	*/
	var optionClicked = function optionClicked(props, day) {
	    props.chooseDay(day);
	};
	var generateDropdownItems = function generateDropdownItems(props) {
	    return props.items.map(function (item, index) {
	        return _react2['default'].createElement(
	            _componentsCommonDropdowncomponentsDropdownitem2['default'],
	            { key: index },
	            _react2['default'].createElement(
	                'div',
	                { onClick: optionClicked.bind(undefined, props, item) },
	                item
	            )
	        );
	    });
	};
	
	var DaySelector = function DaySelector(props) {
	    var items = generateDropdownItems(props);
	    return _react2['default'].createElement(
	        _componentsCommonDropdowncomponentsDropdown2['default'],
	        { className: props.className, header: props.day, toggleable: true },
	        items
	    );
	};
	exports['default'] = DaySelector;
	module.exports = exports['default'];

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _customstatsmenu = __webpack_require__(1288);
	
	var _customstatsmenu2 = _interopRequireDefault(_customstatsmenu);
	
	var _componentsPagesStatsCharts = __webpack_require__(1290);
	
	var _componentsPagesStatsCharts2 = _interopRequireDefault(_componentsPagesStatsCharts);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var Stats = (function (_React$Component) {
	    _inherits(Stats, _React$Component);
	
	    function Stats(props, context) {
	        _classCallCheck(this, Stats);
	
	        _get(Object.getPrototypeOf(Stats.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            currentNode: {
	                info: {
	                    name: "",
	                    empty: true
	                }
	            },
	            path: []
	        };
	    }
	
	    _createClass(Stats, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.prepare(this.props);
	        }
	    }, {
	        key: 'empty',
	        value: function empty(node) {
	            return node.info.empty == true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.prepare(nextProps);
	        }
	    }, {
	        key: 'prepare',
	        value: function prepare(props) {
	            var path = [];
	            var res = { currentNode: {} };
	            this.findNode(props.nodeMap, props.params.id, path, res);
	            this.setState({ currentNode: res.currentNode, path: path });
	        }
	    }, {
	        key: 'findNode',
	        value: function findNode(nodeMap, id, path, res) {
	            res.currentNode = nodeMap[id];
	            if (!res.currentNode) {
	                res.currentNode = {};
	                return;
	            }
	            var tmp = [],
	                cur = res.currentNode;
	            while (cur) {
	                tmp.push(cur);
	                cur = cur.parent;
	            }
	            while (tmp.length) {
	                path.push(tmp[tmp.length - 1]);
	                tmp.pop();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'statistic-page overwrite--modal--depth' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: false
	                    },
	                    _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                        overviewIsActive: false,
	                        comparisonIsActive: false,
	                        onlyLeftMenu: false
	                    }),
	                    _react2['default'].createElement(_customstatsmenu2['default'], {
	                        name: this.state.currentNode.info.name,
	                        id: this.state.currentNode.id,
	                        node: this.state.currentNode,
	                        querySettings: this.props.querySettings
	                    }),
	                    _react2['default'].createElement(_componentsCommonPath2['default'], { path: this.state.path, linkOn: function (x) {
	                            return x.info.hasfloorplan;
	                        }, link: function (x) {
	                            return "statistic/" + x.id;
	                        } })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2['default'].createElement(_componentsPagesStatsCharts2['default'], {
	                        currentNode: this.state.currentNode,
	                        querySettings: this.props.querySettings
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Stats;
	})(_react2['default'].Component);
	
	exports.Stats = Stats;
	
	function mapStateToProps(state) {
	    return {
	        tree: state.overviewReducer.customerOverview,
	        nodeMap: state.overviewReducer.nodeMap,
	        querySettings: state.querySettingsReducer,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Stats);

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _actionsQuerysettings = __webpack_require__(346);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonDropdowncomponentsRoomtypeselector = __webpack_require__(1239);
	
	var _componentsCommonDropdowncomponentsRoomtypeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsRoomtypeselector);
	
	var _componentsCommonDropdowncomponentsTagselector = __webpack_require__(1282);
	
	var _componentsCommonDropdowncomponentsTagselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsTagselector);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownStatsexport = __webpack_require__(1289);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownStatsexport2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDataexportdropdownStatsexport);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	// This component is used in components/pages/stats/index.jsx
	
	var CustomStatsMenu = (function (_React$Component) {
	    _inherits(CustomStatsMenu, _React$Component);
	
	    function CustomStatsMenu(props) {
	        _classCallCheck(this, CustomStatsMenu);
	
	        _get(Object.getPrototypeOf(CustomStatsMenu.prototype), 'constructor', this).call(this, props);
	        var cntTypes = this.countTypes(props.node);
	
	        this.state = {
	            typeCount: cntTypes
	        };
	    }
	
	    _createClass(CustomStatsMenu, [{
	        key: 'chooseTag',
	        value: function chooseTag(tag) {
	            this.props.dispatch((0, _actionsQuerysettings.selectTag)(tag));
	        }
	    }, {
	        key: 'chooseType',
	        value: function chooseType(type) {
	            this.props.dispatch((0, _actionsQuerysettings.selectRoomType)(type));
	            if (type.code == "open_area" || type.code == "all_areas") {
	                this.chooseTag(_config2['default'].tag.OCCUPANCY.type);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var typeCount = this.countTypes(nextProps.node);
	            this.setState({ typeCount: typeCount });
	
	            if (typeCount.cntOA > 0 && typeCount.cntMR == 0) {
	                // only OA
	                if (nextProps.room.code != 'open_area') {
	                    nextProps.dispatch((0, _actionsQuerysettings.selectRoomType)(_config2['default'].room.OPENAREA));
	                }
	                if (nextProps.tag == 'Efficiency') {
	                    nextProps.dispatch((0, _actionsQuerysettings.selectTag)('Occupancy'));
	                }
	            } else if (typeCount.cntOA == 0 && typeCount.cntMR > 0) {
	                // only MR
	                if (nextProps.room.code != 'meeting_room') {
	                    nextProps.dispatch((0, _actionsQuerysettings.selectRoomType)(_config2['default'].room.MEETINGROOM));
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // for room type selector. If a location node has only MRs then only "Meeting rooms" is selected. So the same for OA.
	            var type = this.props.node.type;
	            if (this.state.typeCount.cntOA > 0 && this.state.typeCount.cntMR == 0) {
	                type = "open_area";
	            } else if (this.state.typeCount.cntMR > 0 && this.state.typeCount.cntOA == 0) {
	                type = "meeting_room";
	            }
	            var statsClass = "stats-menu__list-item  stats-menu__select";
	            var statsClassClickable = statsClass + " cursor--pointer";
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
	                    leftItemBold: this.props.name,
	                    leftItems: _react2['default'].createElement(
	                        _react2['default'].Fragment,
	                        null,
	                        _react2['default'].createElement(
	                            'span',
	                            { className: type === "location" ? statsClassClickable : statsClass },
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsRoomtypeselector2['default'], { roomType: type, chooseType: this.chooseType.bind(this), type: this.props.room.type })
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: this.props.room.code === "meeting_room" ? statsClassClickable : statsClass },
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsTagselector2['default'], { roomType: this.props.room.code, chooseTag: this.chooseTag.bind(this), tag: this.props.tag })
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'cursor--pointer stats-menu__list-item ' },
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsDataexportdropdownStatsexport2['default'], { node: this.props.node })
	                        )
	                    ),
	                    rightItems: _react2['default'].createElement(
	                        _react2['default'].Fragment,
	                        null,
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { className: 'stats-menu__list-item stats-menu__list-item_link', to: this.props.node.info.hasfloorplan ? 'heatmap/' + this.props.id : null },
	                            _react2['default'].createElement('span', { className: 'font-icon icon-heatmap' }),
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'text' },
	                                'Heatmap'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { className: 'stats-menu__list-item stats-menu__list-item_link', to: this.props.node.info.hasfloorplan ? 'live/' + this.props.id : null },
	                            _react2['default'].createElement('span', { className: 'font-icon icon-live' }),
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'text' },
	                                'Live'
	                            )
	                        )
	                    )
	                })
	            );
	        }
	    }, {
	        key: 'countTypes',
	        value: function countTypes(node) {
	            var self = this;
	            var res = {
	                cntMR: node.type == "meeting_room" ? 1 : 0,
	                cntOA: node.type == "open_area" ? 1 : 0
	            };
	            if (node.children) {
	                node.children.map(function (child) {
	                    if (child.type != "sensor") {
	                        var resChild = self.countTypes(child);
	                        res.cntMR += resChild.cntMR;
	                        res.cntOA += resChild.cntOA;
	                    }
	                });
	            }
	            return res;
	        }
	    }]);
	
	    return CustomStatsMenu;
	})(_react2['default'].Component);
	
	exports.CustomStatsMenu = CustomStatsMenu;
	
	function mapStateToProps(state) {
	    return {
	        tag: state.querySettingsReducer.tag,
	        room: state.querySettingsReducer.room
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomStatsMenu);

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _actionsStats = __webpack_require__(207);
	
	var _functions = __webpack_require__(1249);
	
	var StatsExport = (function (_React$Component) {
	    _inherits(StatsExport, _React$Component);
	
	    function StatsExport(props, context) {
	        _classCallCheck(this, StatsExport);
	
	        _get(Object.getPrototypeOf(StatsExport.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loading: false
	        };
	    }
	
	    _createClass(StatsExport, [{
	        key: 'downloadCSV',
	        value: function downloadCSV() {
	            var _this = this;
	
	            this.setState({ loading: true }, function () {
	                (0, _actionsStats.downloadCSV)(_this.props.node, _this.props.querySettings, function () {
	                    _this.setState({ loading: false });
	                });
	            });
	        }
	    }, {
	        key: 'downloadPDF',
	        value: function downloadPDF() {
	            var _this2 = this;
	
	            this.setState({ loading: true }, function () {
	                var images = [];
	                (0, _functions.chainGetPNG)([document.charts.totalOccupancy, document.charts.occupancyrange, document.charts.occupancyBreakDown, document.charts.dailyOccupancy1, document.charts.dailyOccupancy2], images, function () {
	                    _this2.setState({ loading: false });
	                    (0, _functions.dumpAllToPDF)(images, _this2.getPDFName());
	                });
	            });
	        }
	    }, {
	        key: 'getPDFName',
	        value: function getPDFName() {
	            var settings = (0, _actionsStats.getParams)({
	                querySettings: this.props.querySettings,
	                currentNode: this.props.node
	            });
	            var locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
	            return 'STATS_' + locationName + '_' + settings.startdate + '_' + settings.enddate + '_' + settings.starthour + ':00_' + settings.endhour + ':59.pdf';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-export__container' },
	                _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdown2['default'],
	                    { className: this.props.className, header: _react2['default'].createElement(
	                            'div',
	                            { className: "stats-export display--flex__flex--center " + (this.state.loading ? "loading" : "") },
	                            this.state.loading ? _react2['default'].createElement('img', { src: 'src/assets/icons/loading.gif' }) : _react2['default'].createElement('span', { className: 'font-icon icon-export' }),
	                            _react2['default'].createElement(
	                                'span',
	                                { style: { marginLeft: "8px", fontFamily: "GTWalsheimProBold" } },
	                                'Export'
	                            )
	                        ), toggleable: !this.state.loading, noArrow: true },
	                    _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return _this3.downloadCSV();
	                                } },
	                            'CSV : Data of sensors'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return _this3.downloadPDF();
	                                } },
	                            'PDF : Pictures of charts'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StatsExport;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        tree: state.overviewReducer.customerOverview,
	        nodeMap: state.overviewReducer.nodeMap,
	        querySettings: state.querySettingsReducer,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatsExport);
	module.exports = exports['default'];

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _componentsPagesStatsTotaloccupancy = __webpack_require__(1291);
	
	var _componentsPagesStatsTotaloccupancy2 = _interopRequireDefault(_componentsPagesStatsTotaloccupancy);
	
	var _componentsPagesStatsOccupancyrange = __webpack_require__(1293);
	
	var _componentsPagesStatsOccupancyrange2 = _interopRequireDefault(_componentsPagesStatsOccupancyrange);
	
	var _componentsPagesStatsDailyoccupancy = __webpack_require__(1295);
	
	var _componentsPagesStatsDailyoccupancy2 = _interopRequireDefault(_componentsPagesStatsDailyoccupancy);
	
	var _componentsPagesStatsOccupancybreakdown = __webpack_require__(1298);
	
	var _componentsPagesStatsOccupancybreakdown2 = _interopRequireDefault(_componentsPagesStatsOccupancybreakdown);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Charts = (function (_Component) {
	    _inherits(Charts, _Component);
	
	    function Charts() {
	        _classCallCheck(this, Charts);
	
	        _get(Object.getPrototypeOf(Charts.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Charts, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-cards-wrapper' },
	                _react2['default'].createElement(_componentsPagesStatsTotaloccupancy2['default'], { currentNode: this.props.currentNode, querySettings: this.props.querySettings }),
	                _react2['default'].createElement(_componentsPagesStatsOccupancyrange2['default'], { querySettings: this.props.querySettings, currentNode: this.props.currentNode }),
	                _react2['default'].createElement(_componentsPagesStatsOccupancybreakdown2['default'], { querySettings: this.props.querySettings, currentNode: this.props.currentNode }),
	                _react2['default'].createElement(_componentsPagesStatsDailyoccupancy2['default'], { querySettings: this.props.querySettings, currentNode: this.props.currentNode })
	            );
	        }
	    }]);
	
	    return Charts;
	})(_react.Component);
	
	exports['default'] = Charts;
	module.exports = exports['default'];

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesStatsTotaloccupancyLinechartcontainer = __webpack_require__(1292);
	
	var _componentsPagesStatsTotaloccupancyLinechartcontainer2 = _interopRequireDefault(_componentsPagesStatsTotaloccupancyLinechartcontainer);
	
	var _actionsStats = __webpack_require__(207);
	
	var TotalOccupancy = (function (_React$Component) {
	    _inherits(TotalOccupancy, _React$Component);
	
	    function TotalOccupancy() {
	        _classCallCheck(this, TotalOccupancy);
	
	        _get(Object.getPrototypeOf(TotalOccupancy.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(TotalOccupancy, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentNode.id) {
	                var params = (0, _actionsStats.getParams)(nextProps);
	                this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var showPeak = true;
	            if (this.props.querySettings.tag == "Efficiency" && this.props.currentNode.type != "meeting_room" || this.props.querySettings.tag == "Occupancy" && this.props.currentNode.type == "meeting_room") {
	                showPeak = false;
	            }
	            return _react2['default'].createElement(_componentsPagesStatsTotaloccupancyLinechartcontainer2['default'], { tag: this.props.querySettings.tag, showPeak: showPeak });
	        }
	    }]);
	
	    return TotalOccupancy;
	})(_react2['default'].Component);
	
	exports.TotalOccupancy = TotalOccupancy;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(TotalOccupancy);

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonChartsLinechart = __webpack_require__(1276);
	
	var _componentsCommonChartsLinechart2 = _interopRequireDefault(_componentsCommonChartsLinechart);
	
	//import Modal from "components/common/modal";
	
	var LineChartContainer = (function (_React$Component) {
	    _inherits(LineChartContainer, _React$Component);
	
	    function LineChartContainer() {
	        _classCallCheck(this, LineChartContainer);
	
	        _get(Object.getPrototypeOf(LineChartContainer.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(LineChartContainer, [{
	        key: 'getLabels',
	        value: function getLabels() {
	            if (this.props.stats.constraint.startdate == this.props.stats.constraint.enddate) {
	                return this.props.stats.points.map(function (point) {
	                    return point.time.substr(0, 2);
	                });
	            } else if (this.props.stats.constraint.groupby == 'month') {
	                return this.props.stats.points.map(function (point) {
	                    return point.time.substr(0, 8);
	                });
	            } else {
	                return this.props.stats.points.map(function (point) {
	                    return point.time.substr(0, 11);
	                });
	            }
	        }
	    }, {
	        key: 'getAverage',
	        value: function getAverage() {
	            return this.props.stats.points.map(function (point) {
	                return Math.round(point.avg * 100);
	            });
	        }
	    }, {
	        key: 'getPeak',
	        value: function getPeak() {
	            var max = 0;
	            if (this.props.stats.constraint.startdate == this.props.stats.constraint.enddate) {
	                return this.props.stats.points.map(function (point) {
	                    max = Math.round(point.pk * 100) > max ? Math.round(point.pk * 100) : max;
	                    return max;
	                });
	            } else {
	                return this.props.stats.points.map(function (point) {
	                    return Math.round(point.pk * 100);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = {};
	            data.labels = this.getLabels();
	            data.avgs = this.getAverage();
	            if (this.props.showPeak) {
	                data.peaks = this.getPeak();
	            } else {
	                data.peaks = [];
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'box--shadow bg--white card__graph', ref: function (e) {
	                            document.charts.totalOccupancy = e;
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'clearfix graph__header' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__header__title col-sm-offset-3 col-sm-6 clearfix' },
	                            _react2['default'].createElement(
	                                'h2',
	                                null,
	                                'Total ',
	                                this.props.tag
	                            )
	                        ),
	                        _react2['default'].createElement('div', { className: 'graph__header__options clearfix' })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body' },
	                        _react2['default'].createElement(_componentsCommonChartsLinechart2['default'], { id: 'totalOccupancy', stats: data })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LineChartContainer;
	})(_react2['default'].Component);
	
	exports.LineChartContainer = LineChartContainer;
	
	function mapStateToProps(state) {
	    return {
	        stats: state.statsReducer.stats
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, null)(LineChartContainer);
	/* <Modal
	disableCloseButton={true}
	ref={(elem) => { this.openInfoModal = elem }}
	clickButton={() => { this.openInfoModal.close(); }}
	header="Info Modal"
	buttonText="Got it"
	buttonClass="btn-success"
	entry={
	   <div className="pull-right header__options__child">
	       <div onClick={() => { this.openInfoModal.open() }}>
	           <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	       </div>
	   </div>
	}
	>
	<p>Total Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>
	*/

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesStatsOccupancyrangeRangechartcontainer = __webpack_require__(1294);
	
	var _componentsPagesStatsOccupancyrangeRangechartcontainer2 = _interopRequireDefault(_componentsPagesStatsOccupancyrangeRangechartcontainer);
	
	var _actionsStats = __webpack_require__(207);
	
	//import Modal from "components/common/modal";
	
	var OccupancyRange = (function (_React$Component) {
	    _inherits(OccupancyRange, _React$Component);
	
	    function OccupancyRange() {
	        _classCallCheck(this, OccupancyRange);
	
	        _get(Object.getPrototypeOf(OccupancyRange.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(OccupancyRange, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentNode.id) {
	                var params = (0, _actionsStats.getParams)(nextProps);
	                params.groupby = 'hour';
	                params.chart = 'range';
	                this.props.dispatch((0, _actionsStats.getNodeSeriesStats)(params));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'stats-card' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'box--shadow bg--white card__graph', ref: function (e) {
	                            document.charts.occupancyrange = e;
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'clearfix graph__header' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__header__title col-sm-offset-3 col-sm-6 clearfix' },
	                            _react2['default'].createElement(
	                                'h2',
	                                null,
	                                this.props.querySettings.tag,
	                                ' Range'
	                            )
	                        ),
	                        _react2['default'].createElement('div', { className: 'graph__header__options clearfix' })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'graph__body' },
	                        _react2['default'].createElement(_componentsPagesStatsOccupancyrangeRangechartcontainer2['default'], null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OccupancyRange;
	})(_react2['default'].Component);
	
	exports.OccupancyRange = OccupancyRange;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(OccupancyRange);
	/*<Modal
	disableCloseButton={true}
	ref={(elem) => { this.openInfoModal = elem }}
	clickButton={() => { this.openInfoModal.close(); }}
	header="Info Modal"
	buttonText="Got it"
	buttonClass="btn-success"
	entry={
	   <div className="pull-right header__options__child">
	       <div onClick={() => { this.openInfoModal.open() }}>
	           <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	       </div>
	   </div>
	}
	>
	<p>Range Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>*/

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonChartsRangechart = __webpack_require__(1284);
	
	var _componentsCommonChartsRangechart2 = _interopRequireDefault(_componentsCommonChartsRangechart);
	
	var RangeChartContainer = (function (_React$Component) {
	    _inherits(RangeChartContainer, _React$Component);
	
	    function RangeChartContainer() {
	        _classCallCheck(this, RangeChartContainer);
	
	        _get(Object.getPrototypeOf(RangeChartContainer.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(RangeChartContainer, [{
	        key: 'getValues',
	        value: function getValues() {
	            var values = [0, 0, 0, 0, 0, 0, 0];
	            this.props.range.points.forEach(function (point) {
	                if (point.avg == 0) {
	                    values[0] += 1;
	                    values[1] += 1;
	                } else if (point.avg < 0.2) {
	                    values[1] += 1;
	                } else if (point.avg < 0.4) {
	                    values[2] += 1;
	                } else if (point.avg < 0.6) {
	                    values[3] += 1;
	                } else if (point.avg < 0.8) {
	                    values[4] += 1;
	                } else if (point.avg < 1) {
	                    values[5] += 1;
	                } else {
	                    values[5] += 1;
	                    values[6] += 1;
	                }
	            });
	            return values;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var values = this.getValues();
	            return _react2['default'].createElement(_componentsCommonChartsRangechart2['default'], { id: 'occupancyrange', values: values });
	        }
	    }]);
	
	    return RangeChartContainer;
	})(_react2['default'].Component);
	
	exports.RangeChartContainer = RangeChartContainer;
	
	function mapStateToProps(state) {
	    return {
	        range: state.statsReducer.range
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, null)(RangeChartContainer);

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesStatsDailyoccupancyPianochartcontainer = __webpack_require__(1296);
	
	var _componentsPagesStatsDailyoccupancyPianochartcontainer2 = _interopRequireDefault(_componentsPagesStatsDailyoccupancyPianochartcontainer);
	
	var _actionsStats = __webpack_require__(207);
	
	var DailyOccupancy = (function (_React$Component) {
	    _inherits(DailyOccupancy, _React$Component);
	
	    function DailyOccupancy(props, context) {
	        _classCallCheck(this, DailyOccupancy);
	
	        _get(Object.getPrototypeOf(DailyOccupancy.prototype), 'constructor', this).call(this, props, context);
	        this.state = {};
	    }
	
	    _createClass(DailyOccupancy, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentNode.id) {
	                var params = (0, _actionsStats.getParams)(nextProps);
	                this.props.dispatch((0, _actionsStats.getStatsDaily)(params));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var show = this.props.querySettings.startdate == this.props.querySettings.enddate;
	            var showPeak = true;
	            if (this.props.querySettings.tag == "Efficiency" && this.props.currentNode.type != "meeting_room" || this.props.querySettings.tag == "Occupancy" && this.props.currentNode.type == "meeting_room") {
	                showPeak = false;
	            }
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                show || _react2['default'].createElement(_componentsPagesStatsDailyoccupancyPianochartcontainer2['default'], { tag: this.props.querySettings.tag, showPeak: showPeak })
	            );
	        }
	    }]);
	
	    return DailyOccupancy;
	})(_react2['default'].Component);
	
	exports.DailyOccupancy = DailyOccupancy;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(DailyOccupancy);

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonChartsPianochart = __webpack_require__(1297);
	
	var _componentsCommonChartsPianochart2 = _interopRequireDefault(_componentsCommonChartsPianochart);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonDropdowncomponentsModeselector = __webpack_require__(1281);
	
	var _componentsCommonDropdowncomponentsModeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsModeselector);
	
	var _componentsCommonDropdowncomponentsDayselector = __webpack_require__(1286);
	
	var _componentsCommonDropdowncomponentsDayselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDayselector);
	
	var _componentsCommonChartsLinechart = __webpack_require__(1276);
	
	var _componentsCommonChartsLinechart2 = _interopRequireDefault(_componentsCommonChartsLinechart);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	//import Modal from "components/common/modal";
	
	var PianoChartContainer = (function (_React$Component) {
	    _inherits(PianoChartContainer, _React$Component);
	
	    function PianoChartContainer(props, context) {
	        _classCallCheck(this, PianoChartContainer);
	
	        _get(Object.getPrototypeOf(PianoChartContainer.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            mode: 'Average',
	            day: 'Mondays',
	            pianoChart: this.getDataForPianoChart(this.props, "Average"),
	            lineChart: this.getLineChartData(this.props, "Mondays")
	        };
	    }
	
	    _createClass(PianoChartContainer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this = this;
	
	            this.setState({
	                pianoChart: this.getDataForPianoChart(nextProps, this.state.mode),
	                lineChart: this.getLineChartData(nextProps, this.state.day)
	            }, function () {
	                if (!nextProps.showPeak) {
	                    _this.chooseMode("Average");
	                }
	            });
	        }
	    }, {
	        key: 'chooseMode',
	        value: function chooseMode(mode) {
	            var _this2 = this;
	
	            this.setState({ mode: mode }, function () {
	                _this2.setState({
	                    pianoChart: _this2.getDataForPianoChart(_this2.props, _this2.state.mode)
	                });
	            });
	        }
	    }, {
	        key: 'chooseDay',
	        value: function chooseDay(day) {
	            var _this3 = this;
	
	            this.setState({ day: day }, function () {
	                _this3.setState({
	                    lineChart: _this3.getLineChartData(_this3.props, _this3.state.day)
	                });
	            });
	        }
	
	        // Piano chart functions
	
	    }, {
	        key: 'getDataForPianoChart',
	        value: function getDataForPianoChart(props, mode) {
	            var data = {
	                labelsY: [],
	                labelsX: [],
	                values: []
	            };
	            this.getStatsDayInWeek(props, data, mode);
	            this.getStatsAllDay(data, mode);
	            if (props.stats.constraint) {
	                for (var i = parseInt(props.stats.constraint.starthour); i <= parseInt(props.stats.constraint.endhour); i++) {
	                    data.labelsX.push(i);
	                }
	            }
	            for (var _i in data.values) {
	                for (var j in data.values[_i]) {
	                    data.values[_i][j] = Math.round(data.values[_i][j]);
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'getStatsDayInWeek',
	        value: function getStatsDayInWeek(props, data, mode) {
	            var count = 0;
	            for (var _name in props.stats.values) {
	                data.values[count] = [];
	                for (var hour in props.stats.values[parseInt(_name)]) {
	                    if (mode == 'Average') {
	                        data.values[count].push(props.stats.values[_name][hour].avg * 100);
	                    } else {
	                        data.values[count].push(props.stats.values[_name][hour].pk * 100);
	                    }
	                }
	                count++;
	                data.labelsY.push(_config2['default'].day[parseInt(_name)]);
	            }
	        }
	    }, {
	        key: 'getStatsAllDay',
	        value: function getStatsAllDay(data, mode) {
	            var res = [];
	            if (data.values.length == 0) return;
	            for (var hour = 0; hour < data.values[0].length; hour++) {
	                // all hours (column)
	                var avg = 0;
	                var count = 0;
	                var pk = 0;
	                for (var weekday = 0; weekday < data.values.length; weekday++) {
	                    // all weekdays (rows, except last rows which is for all days)
	                    if (data.values[weekday][hour] >= 0) {
	                        avg += data.values[weekday][hour];
	                        pk = Math.max(pk, data.values[weekday][hour]);
	                        count++;
	                    }
	                }
	                if (mode == "Average") {
	                    res.push(count != 0 ? avg / count : -100);
	                } else {
	                    res.push(pk);
	                }
	            }
	            data.values.push(res);
	            data.labelsY.push("All days");
	        }
	
	        // Line chart functions
	
	    }, {
	        key: 'getLineChartData',
	        value: function getLineChartData(props, day) {
	            var data = {
	                labels: [],
	                peaks: [],
	                avgs: []
	            };
	            if (props.stats.constraint && props.stats.values) {
	                var values = props.stats.values;
	                var starthour = props.stats.constraint.starthour;
	                var endhour = props.stats.constraint.endhour;
	
	                for (var hour = starthour; hour <= endhour; hour++) {
	                    var sumAvg = 0,
	                        cntAvg = 0,
	                        peak = 0;
	                    for (var weekday in values) {
	                        if (day == "All days" || _config2['default'].day.indexOf(day) == parseInt(weekday)) {
	                            if (values[weekday][hour].avg >= 0 && values[weekday][hour].pk >= 0) {
	                                sumAvg += values[weekday][hour].avg;
	                                cntAvg++;
	                                peak = Math.max(peak, values[weekday][hour].pk);
	                            }
	                        }
	                    }
	                    var avg = sumAvg / cntAvg;
	                    data.labels.push(hour);
	                    if (avg >= 0 && peak >= 0) {
	                        data.avgs.push(Math.round(avg * 100));
	                        data.peaks.push(Math.round(peak * 100));
	                    } else {
	                        data.peaks.push(null);
	                        data.avgs.push(null);
	                    }
	                }
	            }
	            if (!props.showPeak) {
	                data.peaks = [];
	            }
	            return data;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'stats-card' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'box--shadow bg--white card__graph clearfix', style: { minHeight: '650px' }, ref: function (e) {
	                                document.charts.dailyOccupancy1 = e;
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'clearfix graph__header' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__title col-sm-offset-3 col-sm-6 col-xs-12  clearfix' },
	                                _react2['default'].createElement(
	                                    'h2',
	                                    null,
	                                    'Daily ',
	                                    this.props.tag,
	                                    ': All Weekdays'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__options clearfix' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'header__options__child pull-right' },
	                                    this.props.showPeak ? _react2['default'].createElement(_componentsCommonDropdowncomponentsModeselector2['default'], { mode: this.state.mode, chooseMode: this.chooseMode.bind(this) }) : _react2['default'].createElement(_componentsCommonDropdowncomponentsDropdown2['default'], { className: ' no--cursor--pointer', header: this.state.mode, noArrow: true, toggleable: false })
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__body' },
	                            _react2['default'].createElement(
	                                'div',
	                                { style: { marginLeft: "-10px" } },
	                                _react2['default'].createElement(_componentsCommonChartsPianochart2['default'], { id: 'dailyOccupancy1', data: this.state.pianoChart })
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { style: { marginLeft: '90px' } },
	                                _react2['default'].createElement('img', { src: 'src/assets/icons/degree.png' }),
	                                _react2['default'].createElement(
	                                    'h5',
	                                    { style: { marginLeft: '0px', marginTop: '5px' } },
	                                    '0 - 20%      20 - 40%     40 - 60%     60  -80%     80 - 100% '
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'stats-card' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'box--shadow bg--white card__graph', ref: function (e) {
	                                document.charts.dailyOccupancy2 = e;
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'clearfix graph__header' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__title col-sm-offset-3 col-sm-6 clearfix' },
	                                _react2['default'].createElement(
	                                    'h2',
	                                    null,
	                                    'Daily ',
	                                    this.props.tag
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__options clearfix' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'header__options__child pull-right' },
	                                    _react2['default'].createElement(_componentsCommonDropdowncomponentsDayselector2['default'], { day: this.state.day, chooseDay: this.chooseDay.bind(this), items: this.state.pianoChart.labelsY })
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__body' },
	                            _react2['default'].createElement(_componentsCommonChartsLinechart2['default'], { id: 'dailyOccupancy2', stats: this.state.lineChart })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PianoChartContainer;
	})(_react2['default'].Component);
	
	exports.PianoChartContainer = PianoChartContainer;
	
	function mapStateToProps(state) {
	    return {
	        stats: state.statsReducer.daily
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, null)(PianoChartContainer);
	/*  <Modal
	disableCloseButton={true}
	ref={(elem) => { this.openPianoInfoModal = elem }}
	clickButton={() => { this.openPianoInfoModal.close(); }}
	header="Info Modal"
	buttonText="Got it"
	buttonClass="btn-success"
	entry={
	   <div className="pull-right header__options__child">
	       <div onClick={() => { this.openPianoInfoModal.open() }}>
	           <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	       </div>
	   </div>}
	>
	<p>Daily Piano chart : All Weekdays Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>
	*/ /*
	   <Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openLineChartInfoModal = elem }}
	   clickButton={() => { this.openLineChartInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	      <div className="pull-right header__options__child">
	          <div onClick={() => { this.openLineChartInfoModal.open() }}>
	              <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	          </div>
	      </div>
	   }
	   >
	   <p>Daily Linechart Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	   </Modal>
	   */

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _zingchartReact = __webpack_require__(1277);
	
	//import commonChartConfig from "components/common/charts/commonchartconfig"
	// This component is used in components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
	var generateSeries = function generateSeries(props) {
	    return props.data.values.map(function (values) {
	        return {
	            values: values
	        };
	    });
	};
	var PianoChart = function PianoChart(props) {
	    var values = generateSeries(props);
	    var myConfig = {
	        gui: {
	            "behaviors": [{
	                "id": "ViewSource",
	                "enabled": "none"
	            }, {
	                "id": "Reload",
	                "enabled": "none"
	            }, {
	                "id": "Print",
	                "enabled": "none"
	            }, {
	                "id": "DownloadSVG",
	                "enabled": "none"
	            }, {
	                id: "SaveAsImage",
	                enabled: "all"
	            }],
	            contextMenu: {
	                button: {
	                    visible: false // There is a bug with zingchart, can not display the button
	                }
	            }
	        },
	        graphset: [{
	            type: "piano",
	            theme: "classic",
	            backgroundColor: "#fff",
	            plotarea: {
	                margin: "dynamic"
	            },
	            scaleX: {
	                lineWidth: 0,
	                item: {
	                    borderColor: "none",
	                    size: "13px",
	                    fontColor: "#05636c"
	                },
	                guide: {
	                    visible: false
	                },
	                tick: {
	                    visible: false
	                },
	                values: props.data.labelsX,
	                zooming: true,
	                zoomSnap: true
	                //"zoomTo": [2,5]
	            },
	            zoom: {
	                preserveZoom: true,
	                backgroundColor: "#e5e8ea",
	                borderColor: "#009",
	                borderWidth: 2,
	                alpha: 0.75
	            },
	            scrollX: {
	                bar: {
	                    borderRadius: 3,
	                    backgroundColor: "#01579B",
	                    alpha: .5
	                },
	                handle: {
	                    borderRadius: 5,
	                    backgroundColor: "#01579B",
	                    borderTop: "none",
	                    borderRight: "none",
	                    borderBottom: "none",
	                    borderLeft: "none"
	                }
	            },
	            scrollY: {
	                bar: {
	                    borderradius: 3,
	                    backgroundColor: "#01579B",
	                    alpha: .5
	                },
	                handle: {
	                    borderRadius: 5,
	                    backgroundColor: "#01579B",
	                    borderTop: "none",
	                    borderRight: "none",
	                    borderBottom: "none",
	                    borderLeft: "none"
	                }
	            },
	            scaleY: {
	                zooming: true,
	                lineWidth: 0,
	                mirrored: true,
	                tick: {
	                    visible: false
	                },
	                guide: {
	                    visible: false
	                },
	                item: {
	                    borderColor: "none",
	                    size: "13px",
	                    fontColor: "#05636c"
	                },
	                values: props.data.labelsY
	            },
	            plot: {
	                aspect: "none",
	                borderWidth: 10,
	                borderColor: "#eeeeee",
	                text: "XX",
	                tooltip: {
	                    fontSize: "14px",
	                    fontColor: "white",
	                    text: "Occupancy: %v%.",
	                    textAlign: "left"
	                },
	                rules: [{
	                    rule: "%node-value >= 80",
	                    backgroundColor: "#ee4d51",
	                    fontColor: "#05636c"
	                }, {
	                    rule: "%node-value >= 60 && %node-value < 80",
	                    backgroundColor: "#f06c67",
	                    fontColor: "#05636c"
	                }, {
	                    rule: "%node-value >= 40 && %node-value < 60",
	                    backgroundColor: "#f39986",
	                    fontColor: "#05636c"
	                }, {
	                    rule: "%node-value >=20 && %node-value < 40",
	                    backgroundColor: "#f6c5a2",
	                    fontColor: "#05636c"
	                }, {
	                    rule: "%node-value >= 0 && %node-value <20",
	                    backgroundColor: "#fae9ba",
	                    fontColor: "#05636c",
	                    legendMarker: {
	                        backgroundColor: "#fae9ba"
	                    }
	                }, {
	                    rule: "%node-value < 0",
	                    backgroundColor: "white",
	                    fontColor: "#05636c",
	                    visible: "false",
	                    legendMarker: {
	                        backgroundColor: "white"
	                    }
	                }]
	            },
	            series: values
	        }]
	    };
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(_zingchartReact.core, { id: 'pianodaily', data: myConfig, width: '100%', height: '430px' })
	    );
	};
	exports['default'] = PianoChart;
	module.exports = exports['default'];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsPagesStatsOccupancybreakdownBreakdownchartcontainer = __webpack_require__(1299);
	
	var _componentsPagesStatsOccupancybreakdownBreakdownchartcontainer2 = _interopRequireDefault(_componentsPagesStatsOccupancybreakdownBreakdownchartcontainer);
	
	var _actionsStats = __webpack_require__(207);
	
	var _componentsCommonDropdowncomponentsModeselector = __webpack_require__(1281);
	
	var _componentsCommonDropdowncomponentsModeselector2 = _interopRequireDefault(_componentsCommonDropdowncomponentsModeselector);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _multiselect = __webpack_require__(1301);
	
	var _multiselect2 = _interopRequireDefault(_multiselect);
	
	//import Modal from "components/common/modal";
	
	var OccupancyBreakDown = (function (_React$Component) {
	    _inherits(OccupancyBreakDown, _React$Component);
	
	    function OccupancyBreakDown(props, context) {
	        _classCallCheck(this, OccupancyBreakDown);
	
	        _get(Object.getPrototypeOf(OccupancyBreakDown.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            isArea: false,
	            mode: "Average",
	            areas: []
	        };
	    }
	
	    _createClass(OccupancyBreakDown, [{
	        key: 'chooseMode',
	        value: function chooseMode(mode) {
	            this.setState({ mode: mode });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this = this;
	
	            if (nextProps.currentNode.id) {
	                if (nextProps.currentNode.type == "meeting_room" || nextProps.currentNode.type == "open_area") {
	                    this.setState({ isArea: true });
	                } else {
	                    var params = (0, _actionsStats.getParams)(nextProps);
	                    params.id = [];
	                    // params.areas = new Map();
	                    params.areaOptions = [];
	                    this.getAreaChildren(nextProps.currentNode, params.id, params.areaOptions);
	                    this.setState({
	                        isArea: false,
	                        areaOptions: params.areaOptions
	                    }, function () {
	                        if (nextProps.querySettings.tag == "Efficiency") {
	                            _this.chooseMode("Average");
	                        }
	                    });
	                    this.props.dispatch((0, _actionsStats.getStatsBreakdown)(params));
	                }
	            }
	        }
	    }, {
	        key: 'getAreaChildren',
	        value: function getAreaChildren(tree, ids, areaOptions) {
	            var self = this;
	            tree.children.forEach(function (node) {
	                if (node.type == 'meeting_room' || node.type == 'open_area') {
	                    ids.push(node.id);
	                    // areas.set(node.id, node.info.name + "\n" + node.children.length + " desks");
	                    areaOptions.push({ value: node.id, label: node.info.name, length: node.children.length, selected: false });
	                } else {
	                    self.getAreaChildren(node, ids, areaOptions);
	                }
	            });
	        }
	    }, {
	        key: 'handleSelectChange',
	        value: function handleSelectChange(value) {
	            var areaOptions = this.state.areaOptions.slice();
	            var index = areaOptions.indexOf(value);
	
	            areaOptions[index].selected = !areaOptions[index].selected;
	
	            var areas = [];
	            var count = 0;
	            for (var i = 0; i < areaOptions.length; i++) {
	                if (areaOptions[i].selected) {
	                    count++;
	                    areas.push({ id: areaOptions[i].value, label: areaOptions[i].label + "\n(" + areaOptions[i].length + " desks)" });
	                }
	            }
	            var displayValue;
	            switch (count) {
	                case 0:
	                    displayValue = "No room selected.";
	                    break;
	                case 1:
	                    displayValue = "1 room selected.";
	                    break;
	                default:
	                    displayValue = count + " rooms selected.";
	            }
	            this.setState({
	                areas: areas,
	                value: value,
	                areaOptions: areaOptions,
	                displayValue: displayValue
	            });
	        }
	    }, {
	        key: 'clearSelect',
	        value: function clearSelect() {
	            var areaOptions = this.state.areaOptions.slice();
	            for (var i = 0; i < areaOptions.length; i++) {
	                areaOptions[i].selected = false;
	            }
	
	            this.setState({
	                areas: [],
	                areaOptions: areaOptions,
	                value: 0,
	                displayValue: "No room selected."
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                !this.state.isArea && _react2['default'].createElement(
	                    'div',
	                    { className: 'stats-card' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'box--shadow bg--white card__graph', ref: function (e) {
	                                document.charts.occupancyBreakDown = e;
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'clearfix graph__header' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__options pull-right clearfix' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        style: {
	                                            marginLeft: "45px"
	                                        },
	                                        className: 'header__options__child pull-left' },
	                                    this.props.querySettings.tag != "Efficiency" ? _react2['default'].createElement(_componentsCommonDropdowncomponentsModeselector2['default'], { mode: this.state.mode, chooseMode: this.chooseMode.bind(this) }) : _react2['default'].createElement(_componentsCommonDropdowncomponentsDropdown2['default'], { className: 'no--cursor--pointer', noArrow: true, header: this.state.mode, toggleable: false })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'header__options__child breakdown-chart-select pull-left' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { 'data-tooltip': 'Open for more details' },
	                                        _react2['default'].createElement(_multiselect2['default'], {
	                                            onChange: function (value) {
	                                                _this2.handleSelectChange(value);
	                                            },
	                                            onFocus: function () {},
	                                            onClose: function () {},
	
	                                            options: this.state.areaOptions,
	                                            displayValue: this.state.displayValue,
	                                            value: this.state.value
	                                        })
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'header__options__child multi--select--clear pull-left' },
	                                    _react2['default'].createElement(
	                                        'i',
	                                        { className: 'material-icons multi-select-clear', onClick: function () {
	                                                _this2.clearSelect();
	                                            }, 'data-tooltip': 'Clear all' },
	                                        'clear'
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'graph__header__title pull-right' },
	                                _react2['default'].createElement(
	                                    'h2',
	                                    null,
	                                    this.props.querySettings.tag,
	                                    ' Breakdown'
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'graph__body' },
	                            _react2['default'].createElement(_componentsPagesStatsOccupancybreakdownBreakdownchartcontainer2['default'], { mode: this.state.mode, areas: this.state.areas })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OccupancyBreakDown;
	})(_react2['default'].Component);
	
	exports.OccupancyBreakDown = OccupancyBreakDown;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(OccupancyBreakDown);
	/*
	<Modal
	   disableCloseButton={true}
	   ref={(elem) => { this.openInfoModal = elem }}
	   clickButton={() => { this.openInfoModal.close(); }}
	   header="Info Modal"
	   buttonText="Got it"
	   buttonClass="btn-success"
	   entry={
	       <div className="header__options__child pull-left">
	           <div onClick={() => { this.openInfoModal.open() }}>
	               <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
	           </div>
	       </div>
	   }
	>
	   <p>Breakdown Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
	</Modal>
	*/

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonChartsBreakdownchart = __webpack_require__(1300);
	
	var _componentsCommonChartsBreakdownchart2 = _interopRequireDefault(_componentsCommonChartsBreakdownchart);
	
	var BreakdownChartContainer = (function (_React$Component) {
	    _inherits(BreakdownChartContainer, _React$Component);
	
	    function BreakdownChartContainer() {
	        _classCallCheck(this, BreakdownChartContainer);
	
	        _get(Object.getPrototypeOf(BreakdownChartContainer.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(BreakdownChartContainer, [{
	        key: 'getData',
	        value: function getData() {
	            var data = {
	                labels: [],
	                stats: []
	            };
	            if (this.props.areas) {
	                for (var i = 0; i < this.props.areas.length; i++) {
	                    var id = this.props.areas[i].id;
	                    var label = this.props.areas[i].label;
	                    var statIndex = this.props.stats.findIndex(function (a) {
	                        return a.id == id;
	                    });
	                    if (this.props.mode == 'Average') {
	                        data.stats.push(Math.round(this.props.stats[statIndex].average * 100));
	                    } else {
	                        data.stats.push(Math.round(this.props.stats[statIndex].peak * 100));
	                    }
	
	                    data.labels.push(label);
	                }
	            }
	            var id1 = 478;
	            var statIndex1 = this.props.stats.findIndex(function (a) {
	                return a.id == id1;
	            });
	            return data;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = this.getData();
	
	            return _react2['default'].createElement(_componentsCommonChartsBreakdownchart2['default'], { id: 'occupancyBreakDown', data: data });
	        }
	    }]);
	
	    return BreakdownChartContainer;
	})(_react2['default'].Component);
	
	exports.BreakdownChartContainer = BreakdownChartContainer;
	
	function mapStateToProps(state) {
	    return {
	        stats: state.statsReducer.breakdown
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, null)(BreakdownChartContainer);

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _zingchartReact = __webpack_require__(1277);
	
	var _componentsCommonChartsCommonchartconfig = __webpack_require__(1280);
	
	var _componentsCommonChartsCommonchartconfig2 = _interopRequireDefault(_componentsCommonChartsCommonchartconfig);
	
	// This component is used in components/pages/stats/occupancybreakdown/breakdownchartcontainer.jsx
	var BreakDownChart = function BreakDownChart(props) {
	    var myConfig = Object.assign({}, _componentsCommonChartsCommonchartconfig2["default"], {
	        type: "bar",
	        plotarea: {
	            backgroundColor: "#f6f7fa"
	        },
	        scaleX: {
	            minorTicks: "0",
	            maxTicks: "0",
	            labels: props.data.labels,
	            maxLabels: "999",
	            item: {
	                maxWidth: "180px",
	                wrapText: "true"
	            },
	            tooltip: {
	                text: "%v",
	                backgroundColor: "#424242",
	                borderRadius: 3,
	                borderWidth: 0,
	                fontColor: "white",
	                fontFamily: "Roboto",
	                fontSize: "14px",
	                padding: "6px 12px"
	            }
	        },
	        scaleY: {
	            lineColor: "#f6f7f8",
	            shadow: 0,
	            values: "0:100:20",
	            format: "%v%",
	            guide: {
	                lineStyle: "dashed",
	                lineColor: "white"
	            },
	            minorTicks: 0,
	            markers: [{
	                type: "area",
	                range: [80, 100],
	                lineColor: "#e39199",
	                lineWidth: 2,
	                label: { //define label within marker
	                    fontColor: "#9e9e9e",
	                    alpha: 0.7,
	                    textAlpha: 1,
	                    offsetX: 100,
	                    offsetY: -5,
	                    fontSize: 16
	                }
	            }, {
	                type: "area",
	                range: [0, 20],
	                lineColor: "#faf8f9",
	                lineWidth: 2,
	                label: { //define label within marker
	                    fontColor: "#9e9e9e",
	                    alpha: 0.7,
	                    textAlpha: 1,
	                    offsetX: 100,
	                    offsetY: -5,
	                    fontSize: 16
	                }
	            }],
	            thousandsSeparator: ","
	        },
	        plot: {
	            barWidth: "75%"
	            // animation: {
	            //     effect: 1,
	            //     sequence: 2,
	            //     speed: 100
	            // }
	        },
	        series: [{
	            values: props.data.stats,
	            backgroundColor: "#3cb449"
	        }]
	    });
	    return _react2["default"].createElement(
	        _react2["default"].Fragment,
	        null,
	        _react2["default"].createElement(_zingchartReact.core, { id: "breakdownchart", data: myConfig, height: "450px", width: "100%" })
	    );
	};
	
	exports["default"] = BreakDownChart;
	module.exports = exports["default"];

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	// Searchbar used in:
	// OccupancyBreakDown chart
	
	var MultiSelect = (function (_React$Component) {
	    _inherits(MultiSelect, _React$Component);
	
	    function MultiSelect() {
	        _classCallCheck(this, MultiSelect);
	
	        _get(Object.getPrototypeOf(MultiSelect.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(MultiSelect, [{
	        key: 'optionRenderer',
	        value: function optionRenderer(option) {
	            if (option.selected) {
	                var render = _react2['default'].createElement(
	                    'div',
	                    { className: 'multi-option-container ' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'multi-label-selected' },
	                        option.label
	                    ),
	                    _react2['default'].createElement(
	                        'i',
	                        { className: 'material-icons multi-indicator-selected' },
	                        'check'
	                    )
	                );
	            } else {
	                render = _react2['default'].createElement(
	                    'div',
	                    { className: 'multi-option-container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'multi-label' },
	                        option.label
	                    ),
	                    _react2['default'].createElement('i', { className: 'material-icons multi-indicator' })
	                );
	            }
	            return render;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(_reactSelect2['default'], {
	                onBlurResetsInput: true,
	                onSelectResetsInput: true,
	                onChange: this.props.onChange,
	                onOpen: this.props.onOpen,
	                onFocus: this.props.onFocus,
	                onClose: this.props.onClose,
	                clearable: false,
	                openOnFocus: true,
	                openOnClick: true,
	                closeOnSelect: false,
	                placeholder: 'Select rooms to display',
	                optionRenderer: this.optionRenderer,
	                options: this.props.options,
	                value: this.props.value,
	                valueRenderer: function () {
	                    return _this.props.displayValue;
	                }
	            });
	        }
	    }]);
	
	    return MultiSelect;
	})(_react2['default'].Component);
	
	exports['default'] = MultiSelect;
	module.exports = exports['default'];

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(86);
	
	/*
	This component is used in
	components/pages/live/index.jsx
	components/pages/sensorsettings/index.jsx
	components/pages/stats/index.jsx
	*/
	var onClick = function onClick(e, x, props) {
		if (typeof props.onClick == "function") {
			props.onClick(e, x);
		}
	};
	var Path = function Path(props) {
		return _react2['default'].createElement(
			'div',
			{ className: "breadcrumbs" },
			!props.regularBc ? props.path.map(function (x, idx) {
				return idx == 0 ? _react2['default'].createElement(
					'a',
					{ className: 'breadcrumb__root', key: idx },
					x.info.name
				) : [_react2['default'].createElement(
					'span',
					{ className: 'breadcrumb--divider', key: -idx },
					' > '
				), props.linkOn(x) ? _react2['default'].createElement(
					_reactRouter.Link,
					{ className: 'breadcrumb__element--on', key: idx, to: props.link(x), onClick: function (e) {
							return onClick(e, x, props);
						} },
					x.info.name
				) : _react2['default'].createElement(
					_reactRouter.Link,
					{ className: 'breadcrumb__element--off', key: idx },
					x.info.name
				)];
			}) : props.path.map(function (item, index) {
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					{ key: index },
					item.shouldReload ? _react2['default'].createElement(
						'a',
						{ className: 'breadcrumb__element--on', onClick: function () {
								return location.reload();
							} },
						item.name
					) : _react2['default'].createElement(
						_reactRouter.Link,
						{ className: 'breadcrumb__element--on', to: item.path },
						item.name
					),
					index < props.path.length - 1 && _react2['default'].createElement(
						'span',
						{ className: 'breadcrumb--divider' },
						' > '
					)
				);
			})
		);
	};
	exports['default'] = Path;
	module.exports = exports['default'];

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _componentsCommonDropdowncomponentsNodedropdown = __webpack_require__(1304);
	
	var _componentsCommonDropdowncomponentsNodedropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsNodedropdown);
	
	var _componentsCommonDropdowncomponentsListdropdown = __webpack_require__(1305);
	
	var _componentsCommonDropdowncomponentsListdropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsListdropdown);
	
	var _componentsCommonColornote = __webpack_require__(1306);
	
	var _componentsCommonColornote2 = _interopRequireDefault(_componentsCommonColornote);
	
	var _summary = __webpack_require__(1307);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _floorplan = __webpack_require__(1308);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _componentsCommonLivestatsmenuitems = __webpack_require__(1314);
	
	var _componentsCommonLivestatsmenuitems2 = _interopRequireDefault(_componentsCommonLivestatsmenuitems);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _actionsNode = __webpack_require__(202);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var Live = (function (_React$Component) {
		_inherits(Live, _React$Component);
	
		function Live(props, context) {
			_classCallCheck(this, Live);
	
			_get(Object.getPrototypeOf(Live.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				currentNode: {
					info: {
						name: "",
						empty: true
					},
					children: [],
					type: null
				},
				path: [],
				showDetails: true,
				I: {}
			};
		}
	
		_createClass(Live, [{
			key: 'fetchLive',
			value: function fetchLive() {
				this.props.dispatch((0, _actionsNode.fetchLiveData)());
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.prepare(this.props);
				var I = setInterval(this.fetchLive.bind(this), 5000);
				this.setState({ I: I });
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.state.I);
			}
		}, {
			key: 'empty',
			value: function empty(node) {
				return node.info.empty == true;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.prepare(nextProps);
			}
		}, {
			key: 'prepare',
			value: function prepare(props) {
				var path = [];
				var res = { currentNode: {} };
				this.findNode(props.nodeMap, props.params.id, path, res);
				this.setState({ currentNode: res.currentNode, path: path });
	
				var oldnode = this.state.currentNode;
				var currentNode = res.currentNode;
	
				var cond1 = oldnode.id != currentNode.id && !this.empty(currentNode);
				var cond2 = props.nodeFilter.info.empty && !this.empty(currentNode);
				var cond3 = oldnode.id == currentNode.id && oldnode.children.length != currentNode.children.length;
				// console.log(oldnode, currentNode, cond1, cond2);
				if (cond1 || cond2 || cond3) {
					// either floor changed or no node filter yet => set node filter to all areas.
					this.props.dispatch((0, _actionsLiveFilter.selectNodeFilter)(currentNode));
				}
				if (currentNode.type == _config2['default'].room.MEETINGROOM.code || props.nodeFilter.type == _config2['default'].room.MEETINGROOM.code || props.viewFilter == _config2['default'].viewFilter.MAINTENANCE) {
					this.setState({
						showDetails: true
					});
				}
			}
		}, {
			key: 'findNode',
			value: function findNode(nodeMap, id, path, res) {
				res.currentNode = nodeMap[id];
				if (!res.currentNode) {
					res.currentNode = {};
					return;
				}
				var tmp = [],
				    cur = res.currentNode;
				while (cur) {
					tmp.push(cur);
					cur = cur.parent;
				}
				while (tmp.length) {
					path.push(tmp[tmp.length - 1]);
					tmp.pop();
				}
			}
		}, {
			key: 'changeMRMode',
			value: function changeMRMode() {
				this.setState({
					showDetails: !this.state.showDetails
				});
			}
		}, {
			key: 'listNodeFilter',
			value: function listNodeFilter(root, res) {
				var self = this;
				if (root) {
					if (root.type == _config2['default'].room.MEETINGROOM.code || root.type == _config2['default'].room.OPENAREA.code) {
						res.push(root);
					}
					if (root.children) {
						root.children.forEach(function (child) {
							self.listNodeFilter(child, res);
						});
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					'div',
					{ className: 'live-page overwrite--modal--depth' },
					_react2['default'].createElement(
						_componentsCommonStickymenu2['default'],
						{
							withStickyHeader: false
						},
						_react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
							leftItemBold: this.state.currentNode.info.name,
							leftItems: _react2['default'].createElement(_componentsCommonLivestatsmenuitems2['default'], {
								id: this.state.currentNode.id,
								node: this.state.currentNode
							})
						}),
						_react2['default'].createElement(_componentsCommonPath2['default'], { path: this.state.path, linkOn: function (x) {
								return x.info.hasfloorplan;
							}, link: function (x) {
								return "live/" + x.id;
							} })
					),
					_react2['default'].createElement(
						'div',
						{ className: 'page-content' },
						_react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(_componentsCommonColornote2['default'], { mode: "sensors" }),
							_react2['default'].createElement(
								_floorplan2['default'],
								{
									changeMRMode: function () {
										_this.changeMRMode();
									},
									root: this.props.nodeMap[this.props.nodeFilter.id],
									viewFilter: this.props.viewFilter,
									showDetails: this.state.showDetails,
									tooltipGroup: 'index',
									thumbnail: false,
									currentNode: this.state.currentNode
								},
								_react2['default'].createElement(_componentsCommonDropdowncomponentsListdropdown2['default'], {
									outsideClass: 'view-filter',
									items: _config2['default'].viewFilter,
									getText: function (x) {
										return x.text;
									},
									selected: this.props.viewFilter,
									click: function (view) {
										_this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(view));
									}
								}),
								_react2['default'].createElement(_componentsCommonDropdowncomponentsNodedropdown2['default'], {
									outsideClass: 'view-filter',
									root: this.state.currentNode,
									nodeFilter: this.props.nodeFilter,
									click: function (node) {
										_this.props.dispatch((0, _actionsLiveFilter.selectNodeFilter)(node));
									},
									list: this.listNodeFilter.bind(this),
									header: 'All areas'
								})
							),
							_react2['default'].createElement(_summary2['default'], {
								root: this.state.currentNode,
								sensorMap: this.props.sensorMap
							})
						)
					)
				);
			}
		}]);
	
		return Live;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap,
			nodeFilter: state.liveReducer.nodeFilter,
			viewFilter: state.liveReducer.viewFilter,
			sensorMap: state.nodeReducer.map
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Live);
	module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	/*
	This component is used in
	components/pages/live/index.jsx
	components/pages/sensorsettings/index.jsx
	components/pages/user/index.js
	*/
	var optionClicked = function optionClicked(props, node) {
		props.click(node);
	};
	var NodeDropdown = function NodeDropdown(props) {
		var areas = [];
		props.root.children.forEach(function (child) {
			props.list(child, areas);
		});
		var header = props.nodeFilter.id == props.root.id ? props.header : props.nodeFilter.info.name;
	
		return _react2['default'].createElement(
			'div',
			{ className: props.outsideClass },
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdown2['default'],
				{
					toggleable: true,
					header: header,
					className: props.className
				},
				_react2['default'].createElement(
					_componentsCommonDropdowncomponentsDropdownitem2['default'],
					null,
					_react2['default'].createElement(
						'div',
						{ onClick: optionClicked.bind(undefined, props, props.root) },
						props.header
					)
				),
				areas.map(function (x, idx) {
					return _react2['default'].createElement(
						_componentsCommonDropdowncomponentsDropdownitem2['default'],
						{ key: x.id },
						_react2['default'].createElement(
							'div',
							{ onClick: optionClicked.bind(undefined, props, x) },
							x.info.name
						)
					);
				})
			)
		);
	};
	exports['default'] = NodeDropdown;
	module.exports = exports['default'];

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	/*
	This component is used in
	components/pages/live/floorplan.jsx
	components/pages/live/index.jsx
	components/pages/sensorsettings/index.jsx
	components/pages/user/index.js
	*/
	var optionClicked = function optionClicked(props, node) {
		props.click(node);
	};
	var ListDropdown = function ListDropdown(props) {
	
		var header = props.getText(props.selected);
		var items = props.items.slice();
		// By default, filter out CONFIGURATION view
		if (props.isConfigurationView === undefined) {
			items = items.filter(function (item) {
				return item.code !== "CONFIGURATION";
			});
		}
		return _react2['default'].createElement(
			'div',
			{ className: props.outsideClass },
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdown2['default'],
				{
					toggleable: true,
					header: header,
					className: props.className
				},
				items.map(function (x, idx) {
					return _react2['default'].createElement(
						_componentsCommonDropdowncomponentsDropdownitem2['default'],
						{ key: idx },
						_react2['default'].createElement(
							'div',
							{ onClick: optionClicked.bind(undefined, props, x) },
							props.getText(x)
						)
					);
				})
			)
		);
	};
	exports['default'] = ListDropdown;
	module.exports = exports['default'];

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	// this component is used in components/pages/live/index.jsx
	var ColorNote = function ColorNote(props) {
	    var descs;
	    switch (props.mode) {
	        case "sensors":
	            descs = ["Occupied", "Standby", "Unoccupied", "Offline", "Maintenance"];
	            break;
	
	        case "heatmap":
	            descs = ["Above average", "Average", "Below average"];
	            break;
	
	        default:
	
	    }
	    return _react2["default"].createElement(
	        "table",
	        { className: "popup-color-note" },
	        _react2["default"].createElement(
	            "tbody",
	            null,
	            _react2["default"].createElement(
	                "tr",
	                null,
	                _react2["default"].createElement(
	                    "td",
	                    null,
	                    _react2["default"].createElement(
	                        "span",
	                        { className: "popup-color-note-td red" },
	                        descs[0]
	                    )
	                )
	            ),
	            _react2["default"].createElement(
	                "tr",
	                null,
	                _react2["default"].createElement(
	                    "td",
	                    null,
	                    _react2["default"].createElement(
	                        "span",
	                        { className: "popup-color-note-td yellow" },
	                        descs[1]
	                    )
	                )
	            ),
	            _react2["default"].createElement(
	                "tr",
	                null,
	                _react2["default"].createElement(
	                    "td",
	                    null,
	                    _react2["default"].createElement(
	                        "span",
	                        { className: "popup-color-note-td green" },
	                        descs[2]
	                    )
	                )
	            ),
	            props.mode == "sensors" && _react2["default"].createElement(
	                _react2["default"].Fragment,
	                null,
	                _react2["default"].createElement(
	                    "tr",
	                    null,
	                    _react2["default"].createElement("td", null)
	                ),
	                _react2["default"].createElement(
	                    "tr",
	                    null,
	                    _react2["default"].createElement(
	                        "td",
	                        null,
	                        _react2["default"].createElement(
	                            "span",
	                            { className: "popup-color-note-td blue" },
	                            descs[3]
	                        )
	                    )
	                ),
	                _react2["default"].createElement(
	                    "tr",
	                    null,
	                    _react2["default"].createElement(
	                        "td",
	                        null,
	                        _react2["default"].createElement(
	                            "span",
	                            { className: "popup-color-note-td brown" },
	                            descs[4]
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports["default"] = ColorNote;
	module.exports = exports["default"];

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var LiveSummary = function LiveSummary(props) {
	
		/*function optionClicked(node) {
	 	props.click(node);
	 }*/
		function listAreas(root, type, res) {
	
			if (root) {
				if (root.type == type.code) {
					res.push(root);
				}
				if (root.children) {
					root.children.forEach(function (child) {
						if (child.type == type.code) {
							res.push(child);
						}
					});
				}
			}
		}
	
		function summary(node) {
			var res = {
				total: 0,
				inUse: 0
			};
			node.children.forEach(function (child) {
				if (child.type == "sensor") {
					var ss = props.sensorMap.get(child.id);
					if (typeof ss != "undefined") {
						res.total++;
						if (ss.inuse) {
							res.inUse++;
						}
					}
				}
			});
			return res;
		}
	
		var OAs = [],
		    MRs = [];
		listAreas(props.root, _config2['default'].room.OPENAREA, OAs);
		listAreas(props.root, _config2['default'].room.MEETINGROOM, MRs);
	
		return _react2['default'].createElement(
			'div',
			{ className: 'live-stats-card' },
			_react2['default'].createElement(
				'table',
				{ className: 'table text-center' },
				_react2['default'].createElement(
					'tbody',
					null,
					_react2['default'].createElement(
						'tr',
						null,
						_react2['default'].createElement('td', null),
						_react2['default'].createElement(
							'td',
							{ className: 'live-stats-heading' },
							'Capacity:'
						),
						_react2['default'].createElement(
							'td',
							{ className: 'live-stats-heading', colSpan: '3' },
							'Current Usage:'
						)
					),
					OAs.length > 0 ? [_react2['default'].createElement(
						'tr',
						{ className: 'objects-list', key: 'OAs' },
						_react2['default'].createElement(
							'td',
							{ className: 'live-stats-heading' },
							'Open Areas '
						),
						_react2['default'].createElement(
							'td',
							null,
							' '
						),
						_react2['default'].createElement(
							'td',
							null,
							'In Use'
						),
						_react2['default'].createElement(
							'td',
							null,
							'Unused'
						),
						_react2['default'].createElement(
							'td',
							null,
							'Occupancy'
						)
					), OAs.map(function (x) {
						var smr = summary(x);
						return _react2['default'].createElement(
							'tr',
							{ className: 'objects-list', key: x.id },
							_react2['default'].createElement(
								'td',
								{ className: 'object-name' },
								x.info.name
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.total
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.inUse
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.total - smr.inUse
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.total > 0 ? Math.round(100 * smr.inUse / smr.total) : 0,
								'%'
							)
						);
					})] : [],
					MRs.length > 0 ? [_react2['default'].createElement(
						'tr',
						{ className: 'objects-list', key: 'MRs' },
						_react2['default'].createElement(
							'td',
							{ className: 'live-stats-heading' },
							'Meeting Rooms'
						),
						_react2['default'].createElement(
							'td',
							null,
							' '
						),
						_react2['default'].createElement(
							'td',
							null,
							'Status'
						),
						_react2['default'].createElement(
							'td',
							null,
							'Users'
						),
						_react2['default'].createElement(
							'td',
							null,
							'Efficiency'
						)
					), MRs.map(function (x) {
						var smr = summary(x);
						return _react2['default'].createElement(
							'tr',
							{ className: 'objects-list', key: x.id },
							_react2['default'].createElement(
								'td',
								{ className: 'object-name' },
								x.info.name
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.total
							),
							_react2['default'].createElement(
								'td',
								null,
								_react2['default'].createElement(Status, { taken: smr.inUse > 0 })
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.inUse
							),
							_react2['default'].createElement(
								'td',
								null,
								smr.inUse > 0 ? Math.round(100 * smr.inUse / smr.total) + "%" : "--"
							)
						);
					})] : []
				)
			)
		);
	};
	LiveSummary.propTypes = {
		root: _propTypes2['default'].object.isRequired,
		sensorMap: _propTypes2['default'].object.isRequired
	};
	exports['default'] = LiveSummary;
	
	var Status = function Status(props) {
		if (props.taken) {
			return _react2['default'].createElement('img', { src: '/src/assets/icons/point-red.svg', alt: 'Taken', 'data-tooltip': 'Taken' });
		} else {
			return _react2['default'].createElement('img', { src: '/src/assets/icons/point-green.svg', alt: 'Free', 'data-tooltip': 'Available' });
		}
	};
	module.exports = exports['default'];

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _sensor = __webpack_require__(1309);
	
	var _sensor2 = _interopRequireDefault(_sensor);
	
	var _area = __webpack_require__(1312);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _sensorform = __webpack_require__(1313);
	
	var _sensorform2 = _interopRequireDefault(_sensorform);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var _actionsOverview = __webpack_require__(200);
	
	var _actionsNode = __webpack_require__(202);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var FloorPlan = (function (_React$Component) {
		_inherits(FloorPlan, _React$Component);
	
		function FloorPlan(props, context) {
			_classCallCheck(this, FloorPlan);
	
			_get(Object.getPrototypeOf(FloorPlan.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				loading: false,
				mode: "done", // "move", "add", "editing"
				lastMode: "done",
				hasPermission: this.hasPermission(),
	
				editedSensor: {},
				deletedSensor: {},
	
				dragging: false,
				draggedSensor: {},
	
				mousePos: {},
				upFunc: {},
				moveFunc: {},
				cancelFunc: {},
				url: ""
			};
		}
	
		_createClass(FloorPlan, [{
			key: 'getImage',
			value: function getImage(urlList, node) {
				while (node) {
					if (node.info.useownfp) {
						return urlList[node.id.toString()];
					}
					node = node.parent;
				}
				// return undefined
			}
	
			// default view filter is Live
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(_config2['default'].viewFilter[1]));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.setState({ hasPermission: this.hasPermission(nextProps) });
				if (this.state.loading) {
					var url = this.getImage(nextProps.images, nextProps.root);
					if (url != this.state.url) {
						this.setState({ url: url, loading: false });
					}
				}
			}
		}, {
			key: 'querySettingsChanged',
			value: function querySettingsChanged(q1, q2) {
				return q1.startdate !== q2.startdate || q1.enddate !== q2.enddate || q1.starthour !== q2.starthour || q1.endhour !== q2.endhour || q1.weekdaymask !== q2.weekdaymask;
			}
		}, {
			key: 'imageError',
			value: function imageError() {
				this.setState({
					loading: true
				});
				this.props.dispatch((0, _actionsFloorplan.fetchImage)(this.props.user.companyid));
			}
		}, {
			key: 'getMousePos',
			value: function getMousePos(evt) {
				var imageElement = this.refs['floorplan-image'].getBoundingClientRect();
				var mouseX = evt.clientX - imageElement.left;
				var mouseY = evt.clientY - imageElement.top;
				imageElement = this.refs['floorplan-image'];
				var containerX = imageElement.offsetWidth;
				var containerY = imageElement.offsetHeight;
				var xpercent = mouseX / containerX * 100;
				var ypercent = mouseY / containerY * 100;
				xpercent = Math.max(0, Math.min(100, xpercent));
				ypercent = Math.max(0, Math.min(100, ypercent));
				return {
					x: xpercent,
					y: ypercent
				};
			}
		}, {
			key: 'onMouseDown',
			value: function onMouseDown(e, sensor) {
				var _this = this;
	
				if (this.state.mode == "move") {
					var upFunc = function upFunc(e) {
						return _this.onMouseUp(e, sensor);
					};
					var moveFunc = function moveFunc(e) {
						return _this.onMouseMove(e, sensor);
					};
	
					var mousePos = this.getMousePos(e);
					this.setState({
						dragging: true,
						draggedSensor: sensor,
						mousePos: mousePos,
						upFunc: upFunc,
						moveFunc: moveFunc
					});
					window.addEventListener("mouseup", upFunc);
					window.addEventListener("mousemove", moveFunc);
				}
			}
		}, {
			key: 'onMouseUp',
			value: function onMouseUp(e, sensor) {
				var _this2 = this;
	
				if (this.state.mode == "move") {
					e.stopPropagation();
					window.removeEventListener("mouseup", this.state.upFunc);
					window.removeEventListener("mousemove", this.state.moveFunc);
					var reset = function reset(respond) {
						if (respond.status == 200) {
							_this2.setState({
								dragging: false,
								draggedSensor: {},
								mousePos: {},
								upFunc: {},
								moveFunc: {}
							});
						} else {
							_toastr2['default'].error(respond.data);
						}
					};
					if (this.props.nodeMap[sensor.id]) {
						var node = this.props.nodeMap[sensor.id];
						if (node.type == "sensor") {
							this.props.dispatch(this.moveSensor(this.state.draggedSensor, this.state.mousePos)).then(reset);
						} else {
							var newNode = {
								id: node.id,
								info: {
									name: node.info.name,
									xpercent: this.state.mousePos.x,
									ypercent: this.state.mousePos.y
								}
							};
							this.props.dispatch((0, _actionsNode.updateNode)(newNode)).then(reset);
						}
					}
				} else if (this.state.mode == "add" && e.which == 1) {
					// e.which = 1 <=> left mouse
					window.removeEventListener("mousemove", this.state.moveFunc);
					window.removeEventListener("mouseup", this.state.upFunc);
					window.removeEventListener("contextmenu", this.state.cancelFunc);
					window.removeEventListener("keydown", this.state.escCancelFunc);
					this.setState({
						moveFunc: {},
						upFunc: {},
						cancelFunc: {},
						escCancelFunc: {}
					});
					this.sensorForm.reset();
					this.sensorForm.open(e);
				}
			}
		}, {
			key: 'onCancel',
			value: function onCancel(e, callback) {
				if (this.state.mode == "add") {
					if (typeof callback != "function") {
						e.stopPropagation();
						e.preventDefault();
					}
					window.removeEventListener("mousemove", this.state.moveFunc);
					window.removeEventListener("mouseup", this.state.upFunc);
					window.removeEventListener("contextmenu", this.state.cancelFunc);
					window.removeEventListener("keydown", this.state.escCancelFunc);
					this.setState({
						mode: "done",
						mousePos: {},
						moveFunc: {},
						upFunc: {},
						cancelFunc: {},
						escCancelFunc: {}
					}, callback);
				}
				return false;
			}
		}, {
			key: 'onMouseMove',
			value: function onMouseMove(e, sensor) {
				var pos = this.getMousePos(e);
				this.setState({
					mousePos: pos
				});
				if (this.state.mode == "add") {
					if (pos.x == 0 || pos.x == 100 || pos.y == 0 || pos.y == 100) {
						// this.onCancel(e); // ONLY CANCEL BY RIGHT-CLICK OR PRESSING "ESC"
					}
				}
			}
		}, {
			key: 'changeMode',
			value: function changeMode(mode, e) {
				var _this3 = this;
	
				this.setState({ mode: mode, lastMode: this.state.mode });
				if (mode == "add") {
					if (this.props.viewFilter.code == "LIVE") {
						// Select mode SHOW ALL
						this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(_config2['default'].viewFilter[0]));
					}
	
					var moveFunc = function moveFunc(e) {
						return _this3.onMouseMove(e);
					};
					var upFunc = function upFunc(e) {
						return _this3.onMouseUp(e);
					};
					var cancelFunc = function cancelFunc(e) {
						return _this3.onCancel(e);
					};
					var escCancelFunc = function escCancelFunc(e) {
						if (e.keyCode === 27) {
							// ESC is pressed.
							cancelFunc(e);
						}
					};
	
					var mousePos = this.getMousePos(e);
					this.setState({
						mousePos: mousePos,
						moveFunc: moveFunc,
						upFunc: upFunc,
						cancelFunc: cancelFunc,
						escCancelFunc: escCancelFunc
					});
					window.addEventListener("mousemove", moveFunc);
					window.addEventListener("mouseup", upFunc);
					window.addEventListener("contextmenu", cancelFunc);
					window.addEventListener("keydown", escCancelFunc);
				}
			}
		}, {
			key: 'moveSensor',
			value: function moveSensor(ss, pos) {
				var newSensor = {
					id: ss.id,
					xpercent: pos.x,
					ypercent: pos.y
				};
				return (0, _actionsFloorplan.updateSensor)(newSensor);
			}
		}, {
			key: 'addSensor',
			value: function addSensor(e, state, mousePos) {
				var _this4 = this;
	
				var sensor = {
					name: state.name,
					macaddress: this.cleanMACAddress(state.macaddress),
					xpercent: mousePos.x,
					ypercent: mousePos.y
				};
				var evt = Object.assign({}, e);
				var location = state.location;
				if (state.location == -1) {
					_toastr2['default'].error("Error happened : please reload the page.");
				} else if (sensor.macaddress) {
					this.props.dispatch((0, _actionsFloorplan.createSensor)(location, sensor)).then(function (response) {
						if (response.status == 201) {
							_this4.props.dispatch((0, _actionsOverview.fetchCustomerOverview)()).then(function () {
								_this4.props.dispatch((0, _actionsNode.fetchLiveData)());
								_toastr2['default'].success('Add new sensor successfully');
								_this4.sensorForm.close(evt);
							})['catch'](function (error) {
								_toastr2['default'].error(error.data);
							});
						} else {
							_toastr2['default'].error(response.data);
						}
					})['catch'](function (error) {
						_toastr2['default'].error(error.data);
					});
				} else {
					_toastr2['default'].error("MAC address must be filled");
				}
			}
		}, {
			key: 'updateSensor',
			value: function updateSensor(e, state) {
				var _this5 = this;
	
				var sensor = {
					id: state.id,
					name: state.name,
					macaddress: this.cleanMACAddress(state.macaddress),
					hidden: state.hidden
				};
				var location = Number(state.location);
				if (state.location == -1 || state.id == -1) {
					_toastr2['default'].error("Error happened : please reload the page.");
				} else if (sensor.name && sensor.macaddress) {
					var parentId = this.props.nodeMap[sensor.id].parent.id;
	
					var updateInfo = function updateInfo() {
						_this5.props.dispatch((0, _actionsFloorplan.updateSensor)(sensor)).then(function (response) {
							if (response.status == 200) {
								_toastr2['default'].success('Update sensor successfully');
								_this5.sensorForm.close();
							} else {
								_toastr2['default'].error(response.data);
							}
						})['catch'](function (error) {
							_toastr2['default'].error(error.data);
						});
					};
					// Parent of this sensor changed.
					if (parentId != location) {
						this.props.dispatch((0, _actionsNode.setParent)(sensor.id, location)).then(function (response) {
							if (response.status == 200) {
								updateInfo();
							} else {
								_toastr2['default'].error(response.data);
							}
						})['catch'](function (error) {
							_toastr2['default'].error(error.data);
						});
					} else {
						// doesn't changed
						updateInfo();
					}
				} else {
					_toastr2['default'].error("Name and MAC address must be filled");
				}
			}
		}, {
			key: 'deleteSensor',
			value: function deleteSensor(sensor) {
				var _this6 = this;
	
				this.props.dispatch((0, _actionsNode.deleteNode)(sensor)).then(function (response) {
					if (response.status == 200) {
						_this6.props.dispatch((0, _actionsOverview.fetchCustomerOverview)()).then(function (response) {
							_this6.props.dispatch((0, _actionsNode.fetchLiveData)());
							_toastr2['default'].success('Delete sensor successfully');
							_this6.selectDeletedSensor({}); // also close delete modal.
						})['catch'](function (error) {
							_toastr2['default'].error(error.data);
						});
					} else {
						_toastr2['default'].error(response.data);
					}
				})['catch'](function (error) {
					_toastr2['default'].error(error.data);
				});
			}
		}, {
			key: 'toggleMove',
			value: function toggleMove() {
				var mode;
				if (this.state.mode == "move") {
					mode = "done";
				} else if (this.state.mode == "done") {
					mode = "move";
				}
				this.setState({
					mode: mode
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				if (!this.props.root) {
					return null;
				}
				var areas = [],
				    sensors = [];
	
				this.listNodes(this.props.root, areas, sensors);
	
				if (!this.state.loading && !this.props.root.info.empty) {
					var url = this.getImage(this.props.images, this.props.root);
					if (url && this.props.root.info.hasfloorplan) {
						return _react2['default'].createElement(
							'div',
							{ className: "floorplan-outer-container " + (!this.props.thumbnail ? "not-thumbnail" : "") },
							!this.props.thumbnail && _react2['default'].createElement(
								'div',
								{ className: 'floorplan-options-container' },
								_react2['default'].createElement(
									'div',
									{ className: 'floorplan-options' },
									_react2['default'].createElement(
										'div',
										{ className: 'options-help' },
										_react2['default'].createElement(
											'div',
											{ className: 'help-icon ' },
											_react2['default'].createElement('img', { 'data-tooltip': 'Tooltip text', className: 'card-info ', src: 'src/assets/icons/info.svg', alt: 'info-icon' })
										),
										_react2['default'].createElement(
											'div',
											{ className: this.state.mode == "done" ? "help-text ht-show" : "help-text ht-hide" },
											'Hover over a sensor for more info.'
										),
										_react2['default'].createElement(
											'div',
											{ className: this.state.mode == "move" ? "help-text ht-show" : "help-text ht-hide" },
											'Hold and drag a sensor to move it.'
										),
										_react2['default'].createElement(
											'div',
											{ className: this.state.mode == "add" ? "help-text ht-show" : "help-text ht-hide" },
											'Left-click to place new sensor, right-click to cancel.'
										)
									),
									_react2['default'].createElement(
										'div',
										{ className: 'options-buttons-container' },
										_react2['default'].createElement(
											'div',
											{ className: 'options-buttons-wrapper' },
											this.props.children,
											this.state.hasPermission && _react2['default'].createElement(
												_react2['default'].Fragment,
												null,
												_react2['default'].createElement(
													'div',
													{ className: 'options-buttons' },
													_react2['default'].createElement(
														'i',
														{
															className: 'material-icons',
															'data-tooltip': this.state.mode == "move" ? "Sensors can be moved" : "Sensors can not be moved",
															onClick: function () {
																return _this7.toggleMove();
															}
														},
														this.state.mode == "move" ? "location_searching" : "location_disabled"
													)
												),
												_react2['default'].createElement(
													'div',
													{ className: 'options-buttons' },
													_react2['default'].createElement(
														'i',
														{
															className: 'material-icons',
															'data-tooltip': 'Add sensor',
															onClick: function (e) {
																_this7.changeMode("add", e);
															}
														},
														'add_circle_outline'
													)
												)
											),
											_react2['default'].createElement(
												'div',
												{ className: 'options-buttons' },
												_react2['default'].createElement(
													'i',
													{
														className: 'material-icons',
														'data-tooltip': this.props.showDetails ? "Showing details" : "Hiding details",
														onClick: function () {
															return _this7.props.changeMRMode();
														}
													},
													this.props.showDetails ? "settings_ethernet" : "code"
												)
											)
										)
									)
								),
								_react2['default'].createElement('div', { className: 'floorplan--divider' })
							),
							_react2['default'].createElement(
								'div',
								{ ref: function (e) {
										_this7.floorplan = e;
									}, className: !this.props.thumbnail ? "floorplan-container" : "floorplan-container-thumbnail" },
								_react2['default'].createElement('img', {
									src: url,
									alt: 'Floorplan',
									className: 'floorplan-image',
									ref: 'floorplan-image',
									onError: this.imageError.bind(this),
									draggable: 'false',
									key: 'image'
								}),
								this.state.mode == "add" && _react2['default'].createElement(_sensor2['default'], {
									sensor: { dummy: true },
									dragged: true,
									draggingX: this.state.mousePos.x,
									draggingY: this.state.mousePos.y
								}),
								sensors.map(function (sensor) {
									var ss = _this7.props.sensorMap.get(sensor.id);
									return ss && _react2['default'].createElement(_sensor2['default'], {
										key: sensor.id,
										sensor: ss,
										viewFilter: _this7.props.viewFilter,
										onEdit: _this7.selectEditedSensor.bind(_this7),
										onDelete: _this7.selectDeletedSensor.bind(_this7),
										onMouseDown: function (e, ss) {
											return _this7.onMouseDown(e, ss);
										},
										dragged: _this7.state.dragging && _this7.state.draggedSensor.id == sensor.id,
										draggingX: _this7.state.dragging && _this7.state.mousePos.x,
										draggingY: _this7.state.dragging && _this7.state.mousePos.y,
										thumbnail: _this7.props.thumbnail,
										hasPermission: _this7.state.hasPermission && _this7.state.mode != "add"
									});
								}),
								areas.map(function (node) {
									return _react2['default'].createElement(_area2['default'], {
										key: node.id,
										node: node,
										viewFilter: _this7.props.viewFilter,
										onMouseDown: function (e, ss) {
											return _this7.onMouseDown(e, ss);
										},
										dragged: _this7.state.dragging && _this7.state.draggedSensor.id == node.id,
										draggingX: _this7.state.dragging && _this7.state.mousePos.x,
										draggingY: _this7.state.dragging && _this7.state.mousePos.y,
										thumbnail: _this7.props.thumbnail
									});
								})
							),
							_react2['default'].createElement(_sensorform2['default'], { ref: function (elem) {
									_this7.sensorForm = elem;
								},
								mode: this.state.mode,
								node: this.props.root,
								sensor: this.state.editedSensor,
								nodeMap: this.props.nodeMap,
								onClose: function (e) {
									if (_this7.state.mode == "add") {
										_this7.onCancel(e, function () {
											return _this7.changeMode("add", e);
										});
									} else if (_this7.state.mode == "editing") {
										_this7.changeMode(_this7.state.lastMode);
									}
								},
								onSubmit: function (e, state) {
									if (_this7.state.mode == "add") {
										_this7.addSensor(e, state, _this7.state.mousePos);
									} else if (_this7.state.mode == "editing") {
										_this7.updateSensor(e, state);
									}
								}
							}),
							_react2['default'].createElement(
								_componentsCommonModal2['default'],
								{
									ref: function (elem) {
										_this7.deleteModal = elem;
									},
									clickButton: function () {
										_this7.deleteSensor(_this7.state.deletedSensor);
									},
									header: 'Delete Sensor',
									buttonText: 'Delete Sensor',
									buttonClass: 'btn-danger',
									entry: null,
									onClose: this.props.onClose
								},
								_react2['default'].createElement(
									'p',
									null,
									'Are you sure you want to delete sensor ',
									_react2['default'].createElement(
										'b',
										null,
										this.state.deletedSensor.name
									),
									' (',
									this.state.deletedSensor.macaddress,
									') ?'
								)
							)
						);
					} else {
						return _react2['default'].createElement(
							'div',
							{ className: 'floorplan-error' },
							_react2['default'].createElement('br', null),
							_react2['default'].createElement(
								'h2',
								null,
								'Oops ! We can\'t find this location\'s floorplan...'
							)
						);
					}
				} else {
					return _react2['default'].createElement(
						'div',
						{ className: 'floorplan-error' },
						_react2['default'].createElement('br', null),
						_react2['default'].createElement(
							'h2',
							null,
							'Loading...'
						)
					);
				}
			}
		}, {
			key: 'selectEditedSensor',
			value: function selectEditedSensor(sensor) {
				var _this8 = this;
	
				if (this.state.mode == "add") {
					this.sensorForm.reset();
					return;
				}
				this.setState({
					editedSensor: sensor,
					mode: "editing",
					lastMode: this.state.mode
				}, function () {
					_this8.sensorForm.reset();
					_this8.sensorForm.open();
				});
			}
		}, {
			key: 'hasPermission',
			value: function hasPermission(Props) {
				var props = Props || this.props;
				var node = props.root;
				if (props.user.role != "ADMIN" && props.user.role != "SUPPORTUSER") {
					return false;
				}
				while (node) {
					if (node.id == props.user.rootnodeid) {
						return true;
					}
					node = node.parent;
				}
				return false;
			}
		}, {
			key: 'selectDeletedSensor',
			value: function selectDeletedSensor(sensor) {
				var _this9 = this;
	
				if (this.state.mode == "add") {
					return;
				}
				this.setState({
					deletedSensor: sensor
				}, function () {
					if (sensor.id) {
						_this9.deleteModal.open();
					} else {
						_this9.deleteModal.close();
					}
				});
			}
		}, {
			key: 'listNodes',
			value: function listNodes(root, areas, sensors) {
				var self = this;
				if (root) {
					var isArea = root.type == "meeting_room" && !this.props.showDetails;
					isArea |= root.id != this.props.root.id && root.info.useownfp && root.type != "sensor";
					if (isArea) {
						areas.push(root);
					} else {
						if (root.type == "sensor") {
							sensors.push(root);
						}
						if (root.children) {
							root.children.forEach(function (child) {
								self.listNodes(child, areas, sensors);
							});
						}
					}
				}
			}
		}, {
			key: 'cleanMACAddress',
			value: function cleanMACAddress(mac) {
				// ABCDEF123456 -> ab:cd:ef:12:34:56
				if (/^([0-9A-F]{2}){6}$/.test(mac.toUpperCase())) {
					return (mac.substring(0, 2) + ":" + mac.substring(2, 4) + ":" + mac.substring(4, 6) + ":" + mac.substring(6, 8) + ":" + mac.substring(8, 10) + ":" + mac.substring(10, 12)).toLowerCase();
				}
				return mac;
			}
		}]);
	
		return FloorPlan;
	})(_react2['default'].Component);
	
	exports.FloorPlan = FloorPlan;
	
	function mapStateToProps(state) {
		return {
			sensorMap: state.nodeReducer.map,
			nodeMap: state.overviewReducer.nodeMap,
			images: state.floorPlanReducer.images,
			user: state.myAccountReducer.user
		};
	}
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FloorPlan);

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactTimestamp = __webpack_require__(1311);
	
	var _reactTimestamp2 = _interopRequireDefault(_reactTimestamp);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var Sensor = (function (_React$Component) {
		_inherits(Sensor, _React$Component);
	
		function Sensor(props) {
			_classCallCheck(this, Sensor);
	
			_get(Object.getPrototypeOf(Sensor.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Sensor, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				this.setState({ tooltipOpen: true });
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				this.setState({ tooltipOpen: false });
			}
		}, {
			key: 'onMouseDown',
			value: function onMouseDown(e) {
				e.stopPropagation();
				e.preventDefault();
				if (typeof this.props.onMouseDown == "function") {
					this.props.onMouseDown(e, this.props.sensor);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.dragged && this.state.tooltipOpen) {
					this.setState({ tooltipOpen: false });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var sensor = this.props.sensor;
				var parentName = null;
				if (sensor.id) {
					if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
						parentName = this.props.nodeMap[sensor.id].parent.info.name;
					}
				}
				var style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
				if (this.props.dragged) {
					style = { left: this.props.draggingX + '%', top: this.props.draggingY + '%' };
				}
				var className = 'point';
				// after one hour of offline turn the sensor into faulty one to indicate that it need mainetenance
				if (sensor.registered && sensor.lastonl + 60 * 60 > (0, _moment2['default'])().unix()) {
					if (sensor.faulty) {
						className += ' faulty';
					} else {
						if (sensor.inuse) {
							className += ' inuse';
						} else if (sensor.standby) {
							className += ' standby';
						}
					}
				} else {
					className += ' unregistered';
				}
				if (this.props.viewFilter) {
					if (this.props.viewFilter.code == "LIVE" && (!sensor.registered || sensor.faulty)) {
						// hide broken / unregistered sensor in live view.
						className += ' hidden';
					}
					if (this.props.viewFilter.code == "MAINTENANCE" && sensor.registered && !sensor.faulty) {
						// hide good and registered sensor in maintenance view.
						className += ' hidden';
					}
				}
				if (sensor.dummy || this.props.dragged) {
					return _react2['default'].createElement('div', { className: className, style: style });
				} else {
					if (!this.props.thumbnail) {
						return _react2['default'].createElement(
							_react2['default'].Fragment,
							null,
							_react2['default'].createElement('div', { className: className, style: style,
								id: "sensor" + sensor.id,
								onMouseEnter: this.onMouseEnter.bind(this),
								onMouseLeave: this.onMouseLeave.bind(this),
								onMouseDown: this.onMouseDown.bind(this)
							}),
							_react2['default'].createElement(
								_reactPortalTooltip2['default'],
								{ active: this.state.tooltipOpen, parent: "#sensor" + sensor.id, position: 'right', arrow: 'center',
									style: {
										style: {
											background: "rgba(0,0,0,.9)",
											padding: 10,
											color: "#EEE",
											boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
											borderRadius: 4
										},
										arrowStyle: {
											color: 'rgba(0,0,0,.8)',
											borderColor: false
										}
									}
								},
								_react2['default'].createElement(
									'table',
									null,
									_react2['default'].createElement(
										'tbody',
										null,
										_react2['default'].createElement(
											'tr',
											null,
											_react2['default'].createElement(
												'td',
												null,
												_react2['default'].createElement(
													'div',
													null,
													sensor.name
												),
												_react2['default'].createElement(
													'div',
													null,
													sensor.macaddress.toUpperCase()
												),
												_react2['default'].createElement(
													'div',
													null,
													parentName
												),
												!sensor.registered ? _react2['default'].createElement(
													'div',
													null,
													' Maintenance ',
													' '
												) : sensor.faulty ? _react2['default'].createElement(
													'div',
													null,
													'Offline since ',
													_react2['default'].createElement(_reactTimestamp2['default'], { time: sensor.lastonl })
												) : ""
											),
											this.props.hasPermission && _react2['default'].createElement(
												'td',
												null,
												_react2['default'].createElement(
													'i',
													{ 'data-tooltip': 'Delete', className: 'material-icons cursor--pointer red-500 material--btn__icons pull-right', onClick: function () {
															return _this.props.onDelete(sensor);
														} },
													'delete_forever'
												),
												_react2['default'].createElement(
													'i',
													{ 'data-tooltip': 'Edit', className: 'material-icons cursor--pointer material--btn__icons pull-right', onClick: function () {
															return _this.props.onEdit(sensor);
														} },
													'edit'
												)
											)
										)
									)
								)
							)
						);
					} else {
						return _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement('div', { className: className, style: style,
								'data-tip': true, 'data-for': "sensor" + sensor.id,
								onMouseDown: this.onMouseDown.bind(this)
							}),
							_react2['default'].createElement(
								_reactTooltip2['default'],
								{ id: "sensor" + sensor.id, place: 'right', type: 'dark', effect: 'solid' },
								sensor.name,
								_react2['default'].createElement('br', null),
								sensor.macaddress.toUpperCase()
							)
						);
					}
				}
			}
		}]);
	
		return Sensor;
	})(_react2['default'].Component);
	
	exports.Sensor = Sensor;
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Sensor.propTypes = {
		nodeMap: _propTypes2['default'].object.isRequired,
		sensor: _propTypes2['default'].object.isRequired,
		viewFilter: _propTypes2['default'].object,
		onEdit: _propTypes2['default'].func,
		onDelete: _propTypes2['default'].func,
		onMouseDown: _propTypes2['default'].func,
		dragged: _propTypes2['default'].bool.isRequired,
		thumbnail: _propTypes2['default'].bool,
		hasPermission: _propTypes2['default'].bool
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Sensor);
	/*Change from Unregistered to Maintenance*/

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	
	function ___$insertStyle(css) {
	  if (!css) {
	    return;
	  }
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var style = document.createElement('style');
	
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	  document.head.appendChild(style);
	  return css;
	}
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(38));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: "__react_tooltip_hide_event",
	    REBUILD: "__react_tooltip_rebuild_event",
	    SHOW: "__react_tooltip_show_event"
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event;
	
	  if (typeof window.CustomEvent === "function") {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent("Event");
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	};
	
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	
	
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	
	
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = {
	        currentTarget: event.detail.target
	      };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
	
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
	
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
	
	    if (resizeHide) {
	      window.removeEventListener("resize", this.onWindowResize);
	      window.addEventListener("resize", this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener("resize", this.onWindowResize);
	  };
	  /**
	   * invoked by resize event of window
	   */
	
	
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute("currentItem");
	  if (!isCapture) e.stopPropagation();
	
	  if (show && currentItem === "true") {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute("currentItem", "true");
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute("currentItem", "false");
	    } else {
	      targetArray[i].setAttribute("currentItem", "true");
	    }
	  }
	};
	
	var customListeners = {
	  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute("data-event");
	  };
	  /* Bind listener for custom event */
	
	
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute("data-event") || event;
	    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
	    dataEvent.split(" ").forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	
	    if (dataEventOff) {
	      dataEventOff.split(" ").forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	  /* Unbind listener for custom event */
	
	
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	        event = _this$state2.event,
	        eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute("data-event");
	    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute("data-effect");
	    return dataEffect || this.props.effect || "float";
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	
	  for (var key in e) {
	    if (typeof e[key] === "function") {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	
	  return proxy;
	};
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = e.target.getAttribute("data-tip") || null;
	  var forId = e.target.getAttribute("data-for") || null;
	  var target = e.target;
	
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(" ").forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName("body")[0];
	};
	
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff,
	        possibleCustomEvents = _this$state.possibleCustomEvents,
	        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, "data-event");
	    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(" ").forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(" ").forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  }; //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	
	
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  }; // Check whether the tooltip with orientation p is completely inside the client window
	
	
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ["top", "bottom", "left", "right"];
	  var insideList = [];
	
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace;
	  var shouldUpdatePlace = desiredPlace !== place;
	
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	}; // Get current mouse offset
	
	
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === "float") {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	}; // List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	
	
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === "float") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === "solid") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	}; // Consider additional offset into position calculation
	
	
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === "[object String]") {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
	  }
	
	  for (var key in offset) {
	    if (key === "top") {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === "bottom") {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === "left") {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === "right") {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return {
	    extraOffset_X: extraOffset_X,
	    extraOffset_Y: extraOffset_Y
	  };
	}; // Get the offset of the parent elements
	
	
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function getTipContent (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	
	  if (!multiline || multiline === "false" || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  } // Multiline tooltip content
	
	
	  return tip.split(regexp).map(function (d, i) {
	    return React.createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
	
	var _class, _class2, _temp;
	
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, ReactTooltip);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
	    _this.state = {
	      place: props.place || "top",
	      // Direction of tooltip
	      desiredPlace: props.place || "top",
	      type: "dark",
	      // Color theme of tooltip
	      effect: "float",
	      // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: "",
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || "",
	      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          insecure = _this$props.insecure,
	          resizeHide = _this$props.resizeHide;
	
	      this.bindListener(); // Bind listener for tooltip
	
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	
	        return this.tooltipRef.matches(":hover");
	      }
	
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray;
	
	      if (!id) {
	        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
	      } else {
	        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
	      } // targetArray is a NodeList, convert it to a real array
	
	
	      return nodeListToArray(targetArray);
	    }
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          globalEventOff = _this$props2.globalEventOff,
	          isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute("currentItem") === null) {
	          target.setAttribute("currentItem", "false");
	        }
	
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	
	          var effect = _this3.getEffect(target);
	
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	
	            return;
	          }
	
	          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
	
	          if (effect === "float") {
	            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
	          }
	
	          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
	        });
	      } // Global event to hide tooltip
	
	
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      } // Track removal of targetArray elements from DOM
	
	
	      this.bindRemovalTracker();
	    }
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          globalEventOff = _this$props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
	      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
	      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	          getContent = _this$props4.getContent,
	          children = _this$props4.children; // Generate tooltip content
	
	      var content;
	
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
	    }
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      } // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	
	
	      var _this$props5 = this.props,
	          multiline = _this$props5.multiline,
	          getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute("data-tip");
	      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
	
	      var scrollHide = true;
	
	      if (e.currentTarget.getAttribute("data-scroll-hide")) {
	        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      } // Make sure the correct place is set
	
	
	      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
	      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
	
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute("data-type") || self.props.type || "dark",
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
	          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
	          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
	          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
	          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
	          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      }; // If there is no delay call immediately, don't allow events to get in first.
	
	
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _this$state = this.state,
	          delayShow = _this$state.delayShow,
	          disable = _this$state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	
	          return;
	        }
	
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener() {
	      window.removeEventListener("scroll", this.hideTooltipOnScroll);
	    } // Calculation the position
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _this$state2 = this.state,
	          currentEvent = _this$state2.currentEvent,
	          currentTarget = _this$state2.currentTarget,
	          place = _this$state2.place,
	          desiredPlace = _this$state2.desiredPlace,
	          effect = _this$state2.effect,
	          offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      } // Set tooltip position
	
	
	      node.style.left = result.position.left + "px";
	      node.style.top = result.position.top + "px";
	    }
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	    /* setStyleHeader() {
	      const head = document.getElementsByTagName("head")[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        const tag = document.createElement("style");
	        tag.id = "react-tooltip";
	        tag.innerHTML = cssStyle; */
	
	    /* eslint-disable */
	
	    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	            tag.setAttribute('nonce', __webpack_nonce__)
	          }*/
	
	    /* eslint-enable */
	
	    /*    head.insertBefore(tag, head.firstChild);
	      }
	    } */
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _this$state3 = this.state,
	          extraClass = _this$state3.extraClass,
	          html = _this$state3.html,
	          ariaProps = _this$state3.ariaProps,
	          disable = _this$state3.disable;
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
	      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
	      var Wrapper = this.props.wrapper;
	
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
	
	      if (html) {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: placeholder
	          }
	        }));
	      } else {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this8.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), placeholder);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	
	      if (!isChanged) {
	        return null;
	      }
	
	      return _objectSpread2({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(React.Component), _defineProperty(_class2, "propTypes", {
	  children: propTypes.any,
	  place: propTypes.string,
	  type: propTypes.string,
	  effect: propTypes.string,
	  offset: propTypes.object,
	  multiline: propTypes.bool,
	  border: propTypes.bool,
	  insecure: propTypes.bool,
	  "class": propTypes.string,
	  className: propTypes.string,
	  id: propTypes.string,
	  html: propTypes.bool,
	  delayHide: propTypes.number,
	  delayUpdate: propTypes.number,
	  delayShow: propTypes.number,
	  event: propTypes.string,
	  eventOff: propTypes.string,
	  watchWindow: propTypes.bool,
	  isCapture: propTypes.bool,
	  globalEventOff: propTypes.string,
	  getContent: propTypes.any,
	  afterShow: propTypes.func,
	  afterHide: propTypes.func,
	  overridePosition: propTypes.func,
	  disable: propTypes.bool,
	  scrollHide: propTypes.bool,
	  resizeHide: propTypes.bool,
	  wrapper: propTypes.string,
	  bodyMode: propTypes.bool,
	  possibleCustomEvents: propTypes.string,
	  possibleCustomEventsOff: propTypes.string,
	  clickable: propTypes.bool
	}), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: "div",
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(38);
	
	var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	function plural(string, count, many) {
	  if (count == 1) {
	    return string;
	  } else if (many) {
	    return many;
	  } else {
	    return string + 's';
	  }
	}
	
	var Timestamp = function (_React$Component) {
	  _inherits(Timestamp, _React$Component);
	
	  function Timestamp() {
	    _classCallCheck(this, Timestamp);
	
	    return _possibleConstructorReturn(this, (Timestamp.__proto__ || Object.getPrototypeOf(Timestamp)).apply(this, arguments));
	  }
	
	  _createClass(Timestamp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoUpdate) {
	        var interval = (typeof this.props.autoUpdate === 'number' ? this.props.autoUpdate : 1) * 1000;
	        this.updateInterval = setInterval(function () {
	          _this2.forceUpdate();
	        }, interval);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.updateInterval) {
	        clearInterval(this.updateInterval);
	      }
	    }
	  }, {
	    key: '_distanceOfTimeInWords',
	    value: function _distanceOfTimeInWords(date, compare_to) {
	      var is_comparing = false;
	
	      if (compare_to) {
	        if (compare_to.toDate) compare_to = compare_to.toDate();
	        is_comparing = true;
	      } else {
	        compare_to = new Date();
	      }
	
	      var seconds = Math.floor((compare_to.getTime() - date.getTime()) / 1000);
	      var is_ago = seconds >= 0;
	
	      seconds = Math.abs(seconds);
	
	      if (!this.props.actualSeconds) {
	        if (seconds < 60) {
	          // 1 minute
	          if (is_comparing) {
	            return is_ago ? 'Just then' : 'Soon';
	          } else {
	            return 'A few seconds';
	          }
	        }
	      }
	
	      var distance;
	      var when = [];
	
	      if (this.props.precision == 1) {
	        if (seconds < 60) {
	          // 1 minute
	          when = seconds + ' ' + plural('second', seconds);
	        } else if (seconds < 60 * 60) {
	          // 1 hour
	          distance = Math.round(seconds / 60);
	          when = distance + ' ' + plural('minute', distance);
	        } else if (seconds < 60 * 60 * 24) {
	          // 1 day
	          distance = Math.round(seconds / (60 * 60));
	          when = distance + ' ' + plural('hour', distance);
	        } else if (seconds < 60 * 60 * 24 * 7) {
	          // 1 week
	          distance = Math.round(seconds / (60 * 60 * 24));
	          when = distance + ' ' + plural('day', distance);
	        } else if (seconds < 60 * 60 * 24 * (365 / 12)) {
	          // 1 month
	          distance = Math.round(seconds / (60 * 60 * 24 * 7));
	          when = distance + ' ' + plural('week', distance);
	        } else if (seconds < 60 * 60 * 24 * 30 * 12) {
	          // # 1 year
	          distance = Math.round(seconds / (60 * 60 * 24 * (365 / 12)));
	          when = distance + ' ' + plural('month', distance);
	        } else {
	          return this._prettyTime(date);
	        }
	      } else {
	        when = [];
	
	        // Years
	        var YEAR = 60 * 60 * 24 * 365;
	        if (seconds > YEAR) {
	          distance = Math.floor(seconds / YEAR);
	          when.push(distance + ' ' + plural('year', distance));
	          seconds -= distance * YEAR;
	        }
	
	        // Months
	        var MONTH = 60 * 60 * 24 * (365 / 12);
	        if (seconds > MONTH) {
	          distance = Math.floor(seconds / MONTH);
	          when.push(distance + ' ' + plural('month', distance));
	          seconds -= distance * MONTH;
	        }
	
	        // Days
	        var DAY = 60 * 60 * 24;
	        if (seconds > DAY) {
	          distance = Math.floor(seconds / DAY);
	          when.push(distance + ' ' + plural('day', distance));
	          seconds -= distance * DAY;
	        }
	
	        // Hours
	        var HOUR = 60 * 60;
	        if (seconds > HOUR) {
	          distance = Math.floor(seconds / HOUR);
	          when.push(distance + ' ' + plural('hour', distance));
	          seconds -= distance * HOUR;
	        }
	
	        // Minutes
	        var MINUTE = 60;
	        if (seconds > MINUTE) {
	          distance = Math.floor(seconds / MINUTE);
	          when.push(distance + ' ' + plural('minute', distance));
	          seconds -= distance * MINUTE;
	        }
	
	        if (seconds > 0) {
	          when.push(seconds + ' ' + plural('second', seconds));
	        }
	
	        when = when.slice(0, this.props.precision).join(', ');
	      }
	
	      if (is_comparing) {
	        return when;
	      } else if (is_ago) {
	        return when + ' ago';
	      } else {
	        return 'in ' + when;
	      }
	    }
	  }, {
	    key: '_prettyTime',
	    value: function _prettyTime(date) {
	      var hours, minutes, ampm;
	
	      // eg. 5 Nov 12, 1:37pm
	      if (this.props.twentyFourHour) {
	        hours = date.getHours();
	        ampm = '';
	      } else {
	        if (date.getHours() % 12 == 0) {
	          hours = 12;
	        } else {
	          hours = date.getHours() % 12;
	        }
	
	        if (date.getHours() > 11) {
	          ampm = 'pm';
	        } else {
	          ampm = 'am';
	        }
	      }
	
	      if (date.getMinutes() < 10) {
	        minutes = '0' + date.getMinutes();
	      } else {
	        minutes = '' + date.getMinutes();
	      }
	
	      var day = this.props.includeDay ? DAYS[date.getDay()] + ', ' : '';
	
	      switch (this.props.format) {
	        case 'date':
	          return '' + day + date.getDate() + ' ' + MONTHS[date.getMonth()] + ' ' + date.getFullYear();
	        case 'time':
	          return hours + ':' + minutes + ampm;
	        case 'full':
	        default:
	          return '' + day + date.getDate() + ' ' + MONTHS[date.getMonth()] + ' ' + date.getFullYear() + ', ' + hours + ':' + minutes + ampm;
	      }
	    }
	  }, {
	    key: '_parseDate',
	    value: function _parseDate(date) {
	      if (date === '' || date === false || date === null) return false;
	
	      if (typeof date === 'number' || '' + parseInt(date, 10) == date) {
	        date = parseInt(date, 10);
	
	        if (isNaN(date)) return false;
	
	        date = new Date(date * 1000);
	      }
	
	      if (date.toJSON) {
	        date = date.toJSON();
	      } else {
	        date = date.toString();
	      }
	
	      var t = date.split(/[:\-\+TZ\. ]/);
	      for (var i in t) {
	        if (t[i] !== '' && isNaN(parseInt(t[i], 10))) return false;
	      }
	
	      var d;
	
	      if (this.props.utc) {
	        d = new Date('Sun Jan 01 00:00:00 UTC 2012');
	        d.setUTCFullYear(t[0]);
	        d.setUTCMonth(t[1] - 1);
	        d.setUTCDate(t[2]);
	        d.setUTCHours(t[3]);
	        d.setUTCMinutes(t[4]);
	        d.setUTCSeconds(t[5]);
	      } else {
	        d = new Date('1/1/1970');
	        d.setFullYear(t[0]);
	        d.setMonth(t[1] - 1);
	        d.setDate(t[2]);
	        d.setHours(t[3]);
	        d.setMinutes(t[4]);
	        d.setSeconds(t[5]);
	      }
	
	      return d;
	    }
	  }, {
	    key: '_formatDate',
	    value: function _formatDate(date) {
	      var d = this._parseDate(date);
	
	      if (d === false) {
	        return 'never';
	      }
	
	      if (this.props.format == 'ago' || this.props.format == 'future' || this.props.format == 'relative' || this.props.since || this.props.until) {
	        return this._distanceOfTimeInWords(d, this.props.since || this.props.until || null);
	      } else {
	        return this._prettyTime(d);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.createElement(this.props.component, { className: this.props.className, style: this.props.style }, this._formatDate(this.props.time));
	    }
	  }]);
	
	  return Timestamp;
	}(React.Component);
	
	Timestamp.defaultProps = {
	  time: new Date(),
	  utc: true,
	  format: 'ago',
	  precision: 1,
	  since: null,
	  until: null,
	  includeDay: false,
	  component: 'span',
	  className: '',
	  style: {},
	  autoUpdate: false,
	  twentyFourHour: false,
	  actualSeconds: false
	};
	
	module.exports = Timestamp;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactRouter = __webpack_require__(86);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsNode = __webpack_require__(202);
	
	var _floorplan = __webpack_require__(1308);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var Area = (function (_React$Component) {
		_inherits(Area, _React$Component);
	
		function Area(props) {
			_classCallCheck(this, Area);
	
			_get(Object.getPrototypeOf(Area.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Area, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				if (!this.props.dragged) {
					this.setState({ tooltipOpen: true });
				}
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				if (!this.props.dragged) {
					this.setState({ tooltipOpen: false });
				}
			}
		}, {
			key: 'onMouseDown',
			value: function onMouseDown(e) {
				e.stopPropagation();
				e.preventDefault();
				if (typeof this.props.onMouseDown == "function") {
					this.props.onMouseDown(e, this.props.node);
				}
			}
		}, {
			key: 'getPos',
			value: function getPos(node) {
				if (this.props.dragged) {
					return { x: this.props.draggingX, y: this.props.draggingY };
				}
				if (node.info.xpercent != -1 && node.info.ypercent != -1) {
					return { x: node.info.xpercent, y: node.info.ypercent };
				}
				// Mean position of all sensors
				var res = { x: 0, y: 0 };
				node.children.forEach(function (child) {
					if (child.type == "sensor") {
						res.x += child.info.xpercent;
						res.y += child.info.ypercent;
					}
				});
				res.x /= node.children.length;
				res.y /= node.children.length;
				return res;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.dragged && this.state.tooltipOpen) {
					this.setState({ tooltipOpen: false });
				}
			}
		}, {
			key: 'listSensors',
			value: function listSensors(root, res) {
				var self = this;
				if (root) {
					if (root.type == "sensor") {
						res.push(root);
					} else {
						root.children.map(function (x) {
							return self.listSensors(x, res);
						});
					}
				}
			}
		}, {
			key: 'getStatus',
			value: function getStatus(node) {
				var status = {
					inuse: 0,
					faulty: 0,
					total: node.children.length,
					registered: 0,
					standby: 0,
					displayValue: 0,
					type: "free"
				};
				var sensors = [];
				this.listSensors(node, sensors);
				var sensorMap = this.props.sensorMap;
				sensors.forEach(function (sensor) {
					var ss = sensorMap.get(sensor.id);
					if (ss) {
						status.inuse += ss.inuse;
						status.faulty += ss.faulty;
						status.registered += ss.registered;
						status.standby += ss.standby;
					}
				});
				if (status.registered > 0) {
					if (status.faulty == status.registered) {
						status.type = 'faulty';
					} else {
						if (status.inuse > 0) {
							status.type = 'inuse';
						} else if (status.standby) {
							status.type = 'standby';
						}
					}
				} else {
					status.type = 'unregistered';
				}
	
				switch (status.type) {
					case "free":
						status.displayValue = status.total;
						break;
					case "inuse":
						status.displayValue = status.inuse;
						break;
					case "standby":
						status.displayValue = status.total;
						break;
					case "faulty":
						status.displayValue = status.total;
						break;
					case "unregistered":
						status.displayValue = status.total;
				}
	
				return status;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var node = this.props.node;
				var pos = this.getPos(node);
				var status = this.getStatus(node);
	
				var style = { left: pos.x + '%', top: pos.y + '%' };
				var className = 'circle';
	
				className += " " + status.type;
	
				if (this.props.viewFilter.code == "LIVE" && (status.type == "unregistered" || status.type == "faulty")) {
					// hide broken / unregistered meeting room in live view.
					className += ' hidden';
				}
				if (this.props.viewFilter.code == "MAINTENANCE" && status.type != "unregistered" && status.type != "faulty") {
					// hide good and registered meeting room in maintenance view.
					className += ' hidden';
				}
	
				if (this.props.dragged) {
					return _react2['default'].createElement(
						'div',
						{ className: className, style: style },
						status.displayValue
					);
				} else {
					if (!this.props.thumbnail) {
						var tooltipPos = "top";
						if (pos.y < 50) {
							tooltipPos = "bottom";
						}
						return _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(
								'div',
								{ id: "area" + node.id, className: className, style: style,
									onMouseEnter: function (e) {
										return _this.onMouseEnter(e);
									},
									onMouseLeave: function (e) {
										return _this.onMouseLeave(e);
									},
									onMouseDown: function (e) {
										return _this.onMouseDown(e);
									} },
								status.displayValue
							),
							_react2['default'].createElement(
								_reactPortalTooltip2['default'],
								{ active: this.state.tooltipOpen, parent: "#area" + node.id, position: tooltipPos, arrow: 'center',
									style: {
										style: {
											background: "rgba(0,0,0,.8)",
											padding: 10,
											color: "#EEE",
											boxShadow: "5px 5px 3px rgba(0,0,0,.5)",
											borderRadius: 8,
											transition: 'all .2s ease-in-out',
											zIndex: 7091
										},
										arrowStyle: {
											color: 'rgba(0,0,0,.8)',
											borderColor: false,
											transition: 'all .2s ease-in-out'
										}
									},
									tooltipTimeout: 200
								},
								_react2['default'].createElement(
									'div',
									null,
									_react2['default'].createElement(
										'div',
										{ className: 'tooltip-header' },
										node.info.name,
										_react2['default'].createElement('br', null)
									),
									node.info.useownfp && _react2['default'].createElement(
										'div',
										null,
										'This ',
										_config2['default'].textOf[node.type],
										' has its own floorplan :',
										_react2['default'].createElement('br', null),
										_react2['default'].createElement(
											_reactRedux.Provider,
											{ store: _store2['default'] },
											_react2['default'].createElement(_floorplan2['default'], {
												root: node,
												viewFilter: this.props.viewFilter,
												sensorMap: this.props.sensorMap,
												showDetails: true,
												thumbnail: true
											})
										),
										_react2['default'].createElement('br', null),
										_react2['default'].createElement(
											_reactRouter.Link,
											{ to: "/live/" + node.id, target: '_blank', rel: 'noopener noreferrer' },
											'Detailed floorplan'
										),
										_react2['default'].createElement('br', null),
										_react2['default'].createElement(
											_reactRouter.Link,
											{ to: "/locations?n=" + node.id, target: '_blank', rel: 'noopener noreferrer' },
											'Edit setting'
										),
										_react2['default'].createElement('br', null)
									)
								)
							)
						);
					} else {
						return _react2['default'].createElement(
							_react2['default'].Fragment,
							null,
							_react2['default'].createElement(
								'div',
								{
									className: className, style: style,
									'data-tip': true, 'data-for': "area" + node.id,
									onMouseEnter: function (e) {
										return _this.onMouseEnter(e);
									},
									onMouseLeave: function (e) {
										return _this.onMouseLeave(e);
									},
									onMouseDown: function (e) {
										return _this.onMouseDown(e);
									} },
								status.displayValue
							),
							_react2['default'].createElement(
								_reactTooltip2['default'],
								{ id: "area" + node.id, place: 'top', type: 'dark', effect: 'solid' },
								node.info.name
							)
						);
					}
				}
			}
		}, {
			key: 'setOwnFloorPlan',
			value: function setOwnFloorPlan(node, useownfp) {
				var newNode = { id: node.id, info: { useownfp: useownfp } };
				this.props.dispatch((0, _actionsNode.updateNode)(newNode));
			}
		}]);
	
		return Area;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			sensorMap: state.nodeReducer.map
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Area.propTypes = {
		viewFilter: _propTypes2['default'].object.isRequired,
		node: _propTypes2['default'].object.isRequired,
		onMouseDown: _propTypes2['default'].func.isRequired,
		dragged: _propTypes2['default'].bool.isRequired,
		thumbnail: _propTypes2['default'].bool.isRequired,
		sensorMap: _propTypes2['default'].object.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Area);
	module.exports = exports['default'];

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var SensorForm = (function (_React$Component) {
		_inherits(SensorForm, _React$Component);
	
		function SensorForm(props, context) {
			var _this = this;
	
			_classCallCheck(this, SensorForm);
	
			_get(Object.getPrototypeOf(SensorForm.prototype), "constructor", this).call(this, props, context);
			var submitFunc = function submitFunc(e) {
				_this.props.onSubmit(e, _this.state);
			};
			this.state = {
				id: -1,
				name: "",
				macaddress: "",
				location: -1,
				enterFunc: function enterFunc(e) {
					if (e.keyCode === 13) {
						// Enter is pressed.
						submitFunc(e);
					}
				},
				submitFunc: submitFunc
			};
		}
	
		_createClass(SensorForm, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.reset();
			}
		}, {
			key: "reset",
			value: function reset() {
				var nodes = [];
				this.getAllAreas(this.props.node, nodes);
				var location = -1;
				if (nodes.length > 0) {
					location = nodes[0].id;
				}
				if (this.props.mode == "editing") {
					if (this.props.sensor.id && this.props.nodeMap[this.props.sensor.id] && this.props.nodeMap[this.props.sensor.id].parent) {
						var parent = this.props.nodeMap[this.props.sensor.id].parent;
						if (parent.id && parent.type == "open_area" || parent.type == "meeting_room") {
							location = parent.id;
						}
					}
					this.setState({
						id: this.props.sensor.id || -1,
						name: this.props.sensor.name || "",
						macaddress: this.props.sensor.macaddress || "",
						location: location
					});
				} else {
					this.setState({
						id: -1,
						name: "",
						macaddress: "",
						location: location
					});
				}
			}
		}, {
			key: "createLocationOptions",
			value: function createLocationOptions(options) {
				return options.map(function (element, index) {
					return _react2["default"].createElement(
						"option",
						{ key: index, value: element.id },
						element.info.name
					);
				});
			}
		}, {
			key: "getAllAreas",
			value: function getAllAreas(tree, options) {
				var self = this;
				if (tree.type == 'meeting_room' || tree.type == 'open_area') {
					options.push(tree);
				} else {
					tree.children.forEach(function (element) {
						self.getAllAreas(element, options);
					});
				}
			}
		}, {
			key: "open",
			value: function open(e) {
				this.modal.open(e);
				if (this.props.mode == "add") {
					this.MAC.focus();
				}
				window.addEventListener("keydown", this.state.enterFunc);
			}
		}, {
			key: "close",
			value: function close(e) {
				this.modal.close(e);
				window.removeEventListener("keydown", this.state.enterFunc);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var options = [];
				this.getAllAreas(this.props.node, options);
				var locations = this.createLocationOptions(options);
				return _react2["default"].createElement(
					_componentsCommonModal2["default"],
					{
						ref: function (elem) {
							_this2.modal = elem;
						},
						clickButton: this.state.submitFunc,
						header: this.props.mode == "add" ? "Add Sensor" : "Edit Sensor",
						buttonText: this.props.mode == "add" ? "Add Sensor" : "Edit Sensor",
						buttonClass: "btn-success",
						entry: null,
						onClose: this.props.onClose
					},
					_react2["default"].createElement(
						"label",
						null,
						_react2["default"].createElement(
							"span",
							null,
							"MAC address "
						),
						_react2["default"].createElement("input", { ref: function (elem) {
								return _this2.MAC = elem;
							}, type: "username", id: "macaddress", placeholder: "AABBCC112233 / aa:bb:cc:11:22:33", value: this.state.macaddress, onChange: this.changeHandler.bind(this), required: true })
					),
					_react2["default"].createElement(
						"label",
						null,
						_react2["default"].createElement(
							"span",
							null,
							"Name"
						),
						_react2["default"].createElement("input", { type: "username", id: "name", value: this.state.name, onChange: this.changeHandler.bind(this), placeholder: "e.g. Meeting Room 23", required: true })
					),
					_react2["default"].createElement(
						"div",
						null,
						_react2["default"].createElement(
							"label",
							null,
							"Room / Area"
						),
						_react2["default"].createElement(
							"select",
							{ value: this.state.location, id: "location", onChange: this.changeHandler.bind(this) },
							locations
						)
					)
				);
			}
		}, {
			key: "changeHandler",
			value: function changeHandler(e) {
				var key = e.target.id;
				var value = e.target.value;
				this.setState(_defineProperty({}, key, value));
			}
		}]);
	
		return SensorForm;
	})(_react2["default"].Component);
	
	exports["default"] = SensorForm;
	module.exports = exports["default"];

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(86);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(47);
	
	var LiveStatsMenuItems = function LiveStatsMenuItems(props) {
	    function activeItem(url) {
	        var regex = new RegExp("^/" + url + "/", "ig");
	        return window.location.href.split('#')[1].match(regex) ? "stats-menu__list-item_active" : "";
	    }
	    var tree = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.customerOverview;
	    });
	    var companyAdminRoute = tree.type === "customer";
	    console.log("companyAdminRoute", companyAdminRoute);
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            _reactRouter.Link,
	            { className: 'stats-menu__list-item stats-menu__list-item_link', to: props.node.info.hasfloorplan ? 'statistic/' + props.id : null },
	            _react2['default'].createElement('span', { className: 'font-icon icon-stats' }),
	            _react2['default'].createElement(
	                'span',
	                { className: 'text' },
	                'Stats'
	            )
	        ),
	        _react2['default'].createElement(
	            _reactRouter.Link,
	            { className: 'stats-menu__list-item ' + activeItem("heatmap") + ' stats-menu__list-item_link', to: props.node.info.hasfloorplan ? 'heatmap/' + props.id : null },
	            _react2['default'].createElement('span', { className: 'font-icon icon-heatmap' }),
	            _react2['default'].createElement(
	                'span',
	                { className: 'text' },
	                'Heatmap'
	            )
	        ),
	        _react2['default'].createElement(
	            _reactRouter.Link,
	            { className: 'stats-menu__list-item ' + activeItem("live") + ' stats-menu__list-item_link', to: props.node.info.hasfloorplan ? 'live/' + props.id : null },
	            _react2['default'].createElement('span', { className: 'font-icon icon-live' }),
	            _react2['default'].createElement(
	                'span',
	                { className: 'text' },
	                'Live'
	            )
	        ),
	        companyAdminRoute && _react2['default'].createElement(
	            _reactRouter.Link,
	            { className: 'stats-menu__list-item ' + activeItem("devicemanagement") + ' stats-menu__list-item_link', to: props.node.info.hasfloorplan ? 'devicemanagement/' + props.id : null },
	            _react2['default'].createElement('span', { className: 'font-icon icon-devicem' }),
	            _react2['default'].createElement(
	                'span',
	                { className: 'text' },
	                'Device Management'
	            )
	        )
	    );
	};
	LiveStatsMenuItems.propTypes = {
	    node: _propTypes2['default'].object.isRequired,
	    id: _propTypes2['default'].number
	};
	
	exports['default'] = LiveStatsMenuItems;
	module.exports = exports['default'];

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _componentsCommonColornote = __webpack_require__(1306);
	
	var _componentsCommonColornote2 = _interopRequireDefault(_componentsCommonColornote);
	
	var _floorplan = __webpack_require__(1316);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _componentsCommonLivestatsmenuitems = __webpack_require__(1314);
	
	var _componentsCommonLivestatsmenuitems2 = _interopRequireDefault(_componentsCommonLivestatsmenuitems);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _actionsNode = __webpack_require__(202);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var HeatMap = (function (_React$Component) {
	    _inherits(HeatMap, _React$Component);
	
	    function HeatMap(props, context) {
	        _classCallCheck(this, HeatMap);
	
	        _get(Object.getPrototypeOf(HeatMap.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            currentNode: {
	                info: {
	                    name: "",
	                    empty: true
	                },
	                children: [],
	                type: null
	            },
	            path: [],
	            showDetails: true,
	            I: {}
	        };
	    }
	
	    _createClass(HeatMap, [{
	        key: 'fetchLive',
	        value: function fetchLive() {
	            this.props.dispatch((0, _actionsNode.fetchLiveData)());
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.prepare(this.props);
	            var I = setInterval(this.fetchLive.bind(this), 5000);
	            this.setState({ I: I });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.I);
	        }
	    }, {
	        key: 'empty',
	        value: function empty(node) {
	            return node.info.empty == true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.prepare(nextProps);
	        }
	    }, {
	        key: 'prepare',
	        value: function prepare(props) {
	            var path = [];
	            var res = { currentNode: {} };
	            this.findNode(props.nodeMap, props.params.id, path, res);
	            this.setState({ currentNode: res.currentNode, path: path });
	
	            var oldnode = this.state.currentNode;
	            var currentNode = res.currentNode;
	
	            var cond1 = oldnode.id != currentNode.id && !this.empty(currentNode);
	            var cond2 = props.nodeFilter.info.empty && !this.empty(currentNode);
	            var cond3 = oldnode.id == currentNode.id && oldnode.children.length != currentNode.children.length;
	            // console.log(oldnode, currentNode, cond1, cond2);
	            if (cond1 || cond2 || cond3) {
	                // either floor changed or no node filter yet => set node filter to all areas.
	                this.props.dispatch((0, _actionsLiveFilter.selectNodeFilter)(currentNode));
	            }
	            if (currentNode.type == _config2['default'].room.MEETINGROOM.code || props.nodeFilter.type == _config2['default'].room.MEETINGROOM.code) {
	                this.setState({
	                    showDetails: true
	                });
	            }
	        }
	    }, {
	        key: 'findNode',
	        value: function findNode(nodeMap, id, path, res) {
	            res.currentNode = nodeMap[id];
	            if (!res.currentNode) {
	                res.currentNode = {};
	                return;
	            }
	            var tmp = [],
	                cur = res.currentNode;
	            while (cur) {
	                tmp.push(cur);
	                cur = cur.parent;
	            }
	            while (tmp.length) {
	                path.push(tmp[tmp.length - 1]);
	                tmp.pop();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'live-page overwrite--modal--depth' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: false
	                    },
	                    _react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
	                        leftItemBold: this.state.currentNode.info.name,
	                        leftItems: _react2['default'].createElement(_componentsCommonLivestatsmenuitems2['default'], {
	                            id: this.state.currentNode.id,
	                            node: this.state.currentNode
	                        }),
	                        withDateSelector: true
	                    }),
	                    _react2['default'].createElement(_componentsCommonPath2['default'], { path: this.state.path, linkOn: function (x) {
	                            return x.info.hasfloorplan;
	                        }, link: function (x) {
	                            return "heatmap/" + x.id;
	                        } })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'heatmap-content' },
	                        _react2['default'].createElement(_componentsCommonColornote2['default'], { mode: "heatmap" }),
	                        _react2['default'].createElement(_floorplan2['default'], {
	                            root: this.props.nodeMap[this.props.nodeFilter.id],
	                            showDetails: this.state.showDetails,
	                            tooltipGroup: 'index',
	                            thumbnail: false,
	                            currentNode: this.state.currentNode
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeatMap;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        nodeMap: state.overviewReducer.nodeMap,
	        nodeFilter: state.liveReducer.nodeFilter,
	        user: state.myAccountReducer.user,
	        images: state.floorPlanReducer.images
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HeatMap);
	module.exports = exports['default'];

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _mathjs = __webpack_require__(1317);
	
	var _mathjs2 = _interopRequireDefault(_mathjs);
	
	var _sensor = __webpack_require__(1881);
	
	var _sensor2 = _interopRequireDefault(_sensor);
	
	var _area = __webpack_require__(1882);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _componentsCommonDropdowncomponentsListdropdown = __webpack_require__(1305);
	
	var _componentsCommonDropdowncomponentsListdropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsListdropdown);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownHeatmapexport = __webpack_require__(1883);
	
	var _componentsCommonDropdowncomponentsDataexportdropdownHeatmapexport2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDataexportdropdownHeatmapexport);
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var _actionsStats = __webpack_require__(207);
	
	var FloorPlan = (function (_React$Component) {
	    _inherits(FloorPlan, _React$Component);
	
	    function FloorPlan(props, context) {
	        _classCallCheck(this, FloorPlan);
	
	        _get(Object.getPrototypeOf(FloorPlan.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loading: false,
	            isFetched: false,
	            isNodeVisible: false,
	            heatmapFilter: "ALL", // Show all
	            hasPermission: this.hasPermission(),
	            url: ""
	        };
	    }
	
	    _createClass(FloorPlan, [{
	        key: 'getImage',
	        value: function getImage(urlList, node) {
	            while (node) {
	                if (node.info.useownfp) {
	                    return urlList[node.id.toString()];
	                }
	                node = node.parent;
	            }
	            // return undefined
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ hasPermission: this.hasPermission(nextProps) });
	            if (this.state.loading) {
	                var url = this.getImage(nextProps.images, nextProps.root);
	                if (url != this.state.url) {
	                    this.setState({ url: url, loading: false });
	                }
	            } else {
	                // Check if fetching sensors' average is needed
	                var fetchNeeded = false;
	                fetchNeeded = fetchNeeded || !this.props.root && nextProps.root; // first time receive props.root
	                fetchNeeded = fetchNeeded || this.querySettingsChanged(this.props.query, nextProps.query);
	                fetchNeeded = fetchNeeded || this.props.root.id != nextProps.root.id;
	                fetchNeeded = fetchNeeded || !this.state.isFetched; // fetch once for direct link to heatmap
	                fetchNeeded && this.fetchSensorAvg(nextProps);
	            }
	        }
	    }, {
	        key: 'fetchSensorAvg',
	        value: function fetchSensorAvg(props) {
	            var params = (0, _actionsStats.getParams)({
	                querySettings: props.query,
	                currentNode: props.root
	            });
	            this.props.dispatch((0, _actionsStats.getSensorAverage)(params, props.root));
	            this.setState({
	                isFetched: !this.state.isFetched
	            });
	        }
	    }, {
	        key: 'querySettingsChanged',
	        value: function querySettingsChanged(q1, q2) {
	            return q1.startdate !== q2.startdate || q1.enddate !== q2.enddate || q1.starthour !== q2.starthour || q1.endhour !== q2.endhour || q1.weekdaymask !== q2.weekdaymask;
	        }
	    }, {
	        key: 'imageError',
	        value: function imageError() {
	            this.setState({
	                loading: true
	            });
	            this.props.dispatch((0, _actionsFloorplan.fetchImage)(this.props.user.companyid));
	        }
	    }, {
	        key: 'onClickHeatNode',
	        value: function onClickHeatNode(e, id) {
	            if (this.state.isNodeVisible) {
	                var ss = this.props.sensorMap.get(id);
	                var currentHidden = ss.hidden;
	                var hidden;
	
	                if (currentHidden === true) {
	                    // console.log("Not visible!");
	                    hidden = false;
	                } else if (currentHidden === false) {
	                    // console.log("Visible!");
	                    hidden = true;
	                } else {
	                    console.log("UNSET !!!");
	                    hidden = true;
	                }
	
	                var sensor = {
	                    id: id,
	                    hidden: hidden
	                };
	                this.props.dispatch((0, _actionsFloorplan.updateSensor)(sensor)).then(function (response) {
	                    if (response.status == 200) {
	                        _toastr2['default'].success('Update heat node successfully.');
	                    } else {
	                        _toastr2['default'].error(response.data);
	                    }
	                })['catch'](function (error) {
	                    _toastr2['default'].error(error.data);
	                });
	            }
	        }
	    }, {
	        key: 'toggleHide',
	        value: function toggleHide() {
	            this.setState({
	                isNodeVisible: !this.state.isNodeVisible
	            });
	        }
	    }, {
	        key: 'calculateNormalizer',
	        value: function calculateNormalizer() {
	            var _this = this;
	
	            // return mean and std
	            var values = [];
	            Object.keys(this.props.sensorAverage.values).map(function (mac) {
	                var value = _this.props.sensorAverage.values[mac];
	                if (_this.props.MACMap[mac] && _this.props.MACMap[mac].info.details && !_this.props.MACMap[mac].info.details.hidden) {
	                    if (0 <= value && value <= 1) {
	                        values.push(value);
	                    }
	                }
	            });
	            if (values.length == 0) {
	                return [0.5, 1, 1];
	            }
	
	            // Lowest 5% value
	            var count = Math.round(values.length * 5 / 100);
	            var sorted = _mathjs2['default'].sort(values);
	
	            return [_mathjs2['default'].mean(values), _mathjs2['default'].std(values), sorted[count]];
	        }
	    }, {
	        key: 'chooseHeatmapFilter',
	        value: function chooseHeatmapFilter(f) {
	            this.setState({
	                heatmapFilter: f
	            });
	        }
	    }, {
	        key: 'getHeatmapFilterText',
	        value: function getHeatmapFilterText(f) {
	            var text;
	            switch (f) {
	                case "ALL":
	                    text = "Show all";
	                    break;
	
	                case "ABOVE":
	                    text = "Above average";
	                    break;
	
	                case "BELOW":
	                    text = "Below average";
	                    break;
	
	                case "LOWEST":
	                    text = "Lowest 5%";
	                    break;
	
	                default:
	                    text = "";
	            }
	
	            return text;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.props.root) {
	                return null;
	            }
	            var areas = [],
	                sensors = [];
	            this.listNodes(this.props.root, areas, sensors);
	
	            var normalizer = this.calculateNormalizer();
	
	            if (!this.state.loading && !this.props.root.info.empty) {
	                var url = this.getImage(this.props.images, this.props.root);
	                if (url && this.props.root.info.hasfloorplan) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: "floorplan-outer-container " + (!this.props.thumbnail ? "not-thumbnail" : "") },
	                        !this.props.thumbnail && _react2['default'].createElement(
	                            'div',
	                            { className: 'floorplan-options-container' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'floorplan-options' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'options-help' },
	                                    _react2['default'].createElement(
	                                        _react2['default'].Fragment,
	                                        null,
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'help-icon ' },
	                                            _react2['default'].createElement('img', { className: 'card-info', src: 'src/assets/icons/info.svg', alt: 'info-icon' })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: !this.state.isNodeVisible ? "help-text ht-show" : "help-text ht-hide" },
	                                            'Hover over a heat node for more info.'
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: this.state.isNodeVisible ? "help-text ht-show" : "help-text ht-hide" },
	                                            'Click on a heat node to hide/unhide it.'
	                                        )
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'options-buttons-container' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'options-buttons-wrapper' },
	                                        _react2['default'].createElement(_componentsCommonDropdowncomponentsListdropdown2['default'], {
	                                            outsideClass: 'heatmap-filter',
	                                            items: ["ALL", "ABOVE", "BELOW", "LOWEST"],
	                                            getText: function (f) {
	                                                return _this2.getHeatmapFilterText(f);
	                                            },
	                                            selected: this.state.heatmapFilter,
	                                            click: function (f) {
	                                                return _this2.chooseHeatmapFilter(f);
	                                            }
	                                        }),
	                                        this.state.hasPermission && _react2['default'].createElement(
	                                            'div',
	                                            { className: 'options-buttons' },
	                                            _react2['default'].createElement(
	                                                'i',
	                                                {
	                                                    className: 'material-icons',
	                                                    'data-tooltip': this.state.isNodeVisible ? "Showing hidden heat nodes" : "Not showing hidden heat nodes",
	                                                    onClick: function () {
	                                                        return _this2.toggleHide();
	                                                    }
	                                                },
	                                                this.state.isNodeVisible ? "visibility" : "visibility_off"
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'options-buttons' },
	                                            _react2['default'].createElement(_componentsCommonDropdowncomponentsDataexportdropdownHeatmapexport2['default'], { node: this.props.root, heatmap: this.floorplan })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement('div', { className: 'floorplan--divider' }),
	                            this.props.children
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { ref: function (e) {
	                                    _this2.floorplan = e;
	                                }, className: !this.props.thumbnail ? "floorplan-container" : "floorplan-container-thumbnail" },
	                            _react2['default'].createElement('img', {
	                                src: url,
	                                alt: 'Floorplan',
	                                className: 'floorplan-image',
	                                ref: 'floorplan-image',
	                                onError: this.imageError.bind(this),
	                                draggable: 'false',
	                                key: 'image'
	                            }),
	                            sensors.map(function (sensor) {
	                                var ss = _this2.props.sensorMap.get(sensor.id);
	                                return ss && _react2['default'].createElement(_sensor2['default'], {
	                                    key: sensor.id,
	                                    normalizer: normalizer,
	                                    sensor: ss,
	                                    average: _this2.props.sensorAverage.values[ss.macaddress],
	                                    heatmapFilter: _this2.state.heatmapFilter,
	                                    showHiddenHeatNodes: _this2.state.isNodeVisible,
	                                    thumbnail: _this2.props.thumbnail,
	                                    onClickHeatNode: function (e, id) {
	                                        _this2.onClickHeatNode(e, id);
	                                    }
	                                });
	                            }),
	                            areas.map(function (node) {
	                                return _react2['default'].createElement(_area2['default'], {
	                                    key: node.id,
	                                    node: node,
	                                    thumbnail: _this2.props.thumbnail
	                                });
	                            })
	                        )
	                    );
	                } else {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'floorplan-error' },
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'Oops ! We can\'t find this location\'s floorplan...'
	                        )
	                    );
	                }
	            } else {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'floorplan-error' },
	                    _react2['default'].createElement('br', null),
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'Loading...'
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'hasPermission',
	        value: function hasPermission(Props) {
	            var props = Props || this.props;
	            var node = props.root;
	            if (props.user.role != "ADMIN" && props.user.role != "SUPPORTUSER") {
	                return false;
	            }
	            while (node) {
	                if (node.id == props.user.rootnodeid) {
	                    return true;
	                }
	                node = node.parent;
	            }
	            return false;
	        }
	    }, {
	        key: 'listNodes',
	        value: function listNodes(root, areas, sensors) {
	            var self = this;
	            if (root) {
	                var isArea = root.type == "meeting_room" && !this.props.showDetails;
	                isArea |= root.id != this.props.root.id && root.info.useownfp && root.type != "sensor";
	                if (isArea) {
	                    areas.push(root);
	                } else {
	                    if (root.type == "sensor") {
	                        sensors.push(root);
	                    }
	                    if (root.children) {
	                        root.children.forEach(function (child) {
	                            self.listNodes(child, areas, sensors);
	                        });
	                    }
	                }
	            }
	        }
	    }]);
	
	    return FloorPlan;
	})(_react2['default'].Component);
	
	exports.FloorPlan = FloorPlan;
	
	function mapStateToProps(state) {
	    return {
	        sensorMap: state.nodeReducer.map,
	        nodeMap: state.overviewReducer.nodeMap,
	        MACMap: state.overviewReducer.MACMap,
	        images: state.floorPlanReducer.images,
	        user: state.myAccountReducer.user,
	        query: state.querySettingsReducer,
	        sensorAverage: state.statsReducer.sensorAverage
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FloorPlan);

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(1318);
	
	/**
	 * math.js factory function. Creates a new instance of math.js
	 *
	 * @param {Object} [config] Available configuration options:
	 *                            {number} epsilon
	 *                              Minimum relative difference between two
	 *                              compared values, used by all comparison functions.
	 *                            {string} matrix
	 *                              A string 'matrix' (default) or 'array'.
	 *                            {string} number
	 *                              A string 'number' (default), 'bignumber', or
	 *                              'fraction'
	 *                            {number} precision
	 *                              The number of significant digits for BigNumbers.
	 *                              Not applicable for Numbers.
	 *                            {boolean} predictable
	 *                              Predictable output type of functions. When true,
	 *                              output type depends only on the input types. When
	 *                              false (default), output type can vary depending
	 *                              on input values. For example `math.sqrt(-4)`
	 *                              returns `complex('2i')` when predictable is false, and
	 *                              returns `NaN` when true.
	 */
	function create (config) {
	  // create a new math.js instance
	  var math = core.create(config);
	  math.create = create;
	
	  // import data types, functions, constants, expression parser, etc.
	  math['import'](__webpack_require__(1331));
	
	  return math;
	}
	
	// return a new instance of math.js
	module.exports = create();


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1319);

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isFactory = __webpack_require__(1320).isFactory;
	var typedFactory = __webpack_require__(1322);
	var emitter = __webpack_require__(1326);
	
	var importFactory = __webpack_require__(1328);
	var configFactory = __webpack_require__(1330);
	
	/**
	 * Math.js core. Creates a new, empty math.js instance
	 * @param {Object} [options] Available options:
	 *                            {number} epsilon
	 *                              Minimum relative difference between two
	 *                              compared values, used by all comparison functions.
	 *                            {string} matrix
	 *                              A string 'Matrix' (default) or 'Array'.
	 *                            {string} number
	 *                              A string 'number' (default), 'BigNumber', or 'Fraction'
	 *                            {number} precision
	 *                              The number of significant digits for BigNumbers.
	 *                              Not applicable for Numbers.
	 *                            {boolean} predictable
	 *                              Predictable output type of functions. When true,
	 *                              output type depends only on the input types. When
	 *                              false (default), output type can vary depending
	 *                              on input values. For example `math.sqrt(-4)`
	 *                              returns `complex('2i')` when predictable is false, and
	 *                              returns `NaN` when true.
	 *                            {string} randomSeed
	 *                              Random seed for seeded pseudo random number generator.
	 *                              Set to null to randomly seed.
	 * @returns {Object} Returns a bare-bone math.js instance containing
	 *                   functions:
	 *                   - `import` to add new functions
	 *                   - `config` to change configuration
	 *                   - `on`, `off`, `once`, `emit` for events
	 */
	exports.create = function create (options) {
	  // simple test for ES5 support
	  if (typeof Object.create !== 'function') {
	    throw new Error('ES5 not supported by this JavaScript engine. ' +
	    'Please load the es5-shim and es5-sham library for compatibility.');
	  }
	
	  // cached factories and instances
	  var factories = [];
	  var instances = [];
	
	  // create a namespace for the mathjs instance, and attach emitter functions
	  var math = emitter.mixin({});
	  math.type = {};
	  math.expression = {
	    transform: {},
	    mathWithTransform: {}
	  };
	
	  // create a new typed instance
	  math.typed = typedFactory.create(math.type);
	
	  // create configuration options. These are private
	  var _config = {
	    // minimum relative difference between two compared values,
	    // used by all comparison functions
	    epsilon: 1e-12,
	
	    // type of default matrix output. Choose 'matrix' (default) or 'array'
	    matrix: 'Matrix',
	
	    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
	    number: 'number',
	
	    // number of significant digits in BigNumbers
	    precision: 64,
	
	    // predictable output type of functions. When true, output type depends only
	    // on the input types. When false (default), output type can vary depending
	    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
	    // predictable is false, and returns `NaN` when true.
	    predictable: false,
	
	    // random seed for seeded pseudo random number generation
	    // null = randomly seed
	    randomSeed: null
	  };
	
	  /**
	   * Load a function or data type from a factory.
	   * If the function or data type already exists, the existing instance is
	   * returned.
	   * @param {{type: string, name: string, factory: Function}} factory
	   * @returns {*}
	   */
	  function load (factory) {
	    if (!isFactory(factory)) {
	      throw new Error('Factory object with properties `type`, `name`, and `factory` expected');
	    }
	
	    var index = factories.indexOf(factory);
	    var instance;
	    if (index === -1) {
	      // doesn't yet exist
	      if (factory.math === true) {
	        // pass with math namespace
	        instance = factory.factory(math.type, _config, load, math.typed, math);
	      }
	      else {
	        instance = factory.factory(math.type, _config, load, math.typed);
	      }
	
	      // append to the cache
	      factories.push(factory);
	      instances.push(instance);
	    }
	    else {
	      // already existing function, return the cached instance
	      instance = instances[index];
	    }
	
	    return instance;
	  }
	
	  // load the import and config functions
	  math['import'] = load(importFactory);
	  math['config'] = load(configFactory);
	  math.expression.mathWithTransform['config'] = math['config']
	
	  // apply options
	  if (options) {
	    math.config(options);
	  }
	
	  return math;
	};


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isBigNumber = __webpack_require__(1321);
	
	/**
	 * Clone an object
	 *
	 *     clone(x)
	 *
	 * Can clone any primitive type, array, and object.
	 * If x has a function clone, this function will be invoked to clone the object.
	 *
	 * @param {*} x
	 * @return {*} clone
	 */
	exports.clone = function clone(x) {
	  var type = typeof x;
	
	  // immutable primitive types
	  if (type === 'number' || type === 'string' || type === 'boolean' ||
	      x === null || x === undefined) {
	    return x;
	  }
	
	  // use clone function of the object when available
	  if (typeof x.clone === 'function') {
	    return x.clone();
	  }
	
	  // array
	  if (Array.isArray(x)) {
	    return x.map(function (value) {
	      return clone(value);
	    });
	  }
	
	  if (x instanceof Number)    return new Number(x.valueOf());
	  if (x instanceof String)    return new String(x.valueOf());
	  if (x instanceof Boolean)   return new Boolean(x.valueOf());
	  if (x instanceof Date)      return new Date(x.valueOf());
	  if (isBigNumber(x))         return x; // bignumbers are immutable
	  if (x instanceof RegExp)  throw new TypeError('Cannot clone ' + x);  // TODO: clone a RegExp
	
	  // object
	  return exports.map(x, clone);
	};
	
	/**
	 * Apply map to all properties of an object
	 * @param {Object} object
	 * @param {function} callback
	 * @return {Object} Returns a copy of the object with mapped properties
	 */
	exports.map = function(object, callback) {
	  var clone = {};
	
	  for (var key in object) {
	    if (exports.hasOwnProperty(object, key)) {
	      clone[key] = callback(object[key]);
	    }
	  }
	
	  return clone;
	}
	
	/**
	 * Extend object a with the properties of object b
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 */
	exports.extend = function(a, b) {
	  for (var prop in b) {
	    if (exports.hasOwnProperty(b, prop)) {
	      a[prop] = b[prop];
	    }
	  }
	  return a;
	};
	
	/**
	 * Deep extend an object a with the properties of object b
	 * @param {Object} a
	 * @param {Object} b
	 * @returns {Object}
	 */
	exports.deepExtend = function deepExtend (a, b) {
	  // TODO: add support for Arrays to deepExtend
	  if (Array.isArray(b)) {
	    throw new TypeError('Arrays are not supported by deepExtend');
	  }
	
	  for (var prop in b) {
	    if (exports.hasOwnProperty(b, prop)) {
	      if (b[prop] && b[prop].constructor === Object) {
	        if (a[prop] === undefined) {
	          a[prop] = {};
	        }
	        if (a[prop].constructor === Object) {
	          deepExtend(a[prop], b[prop]);
	        }
	        else {
	          a[prop] = b[prop];
	        }
	      } else if (Array.isArray(b[prop])) {
	        throw new TypeError('Arrays are not supported by deepExtend');
	      } else {
	        a[prop] = b[prop];
	      }
	    }
	  }
	  return a;
	};
	
	/**
	 * Deep test equality of all fields in two pairs of arrays or objects.
	 * @param {Array | Object} a
	 * @param {Array | Object} b
	 * @returns {boolean}
	 */
	exports.deepEqual = function deepEqual (a, b) {
	  var prop, i, len;
	  if (Array.isArray(a)) {
	    if (!Array.isArray(b)) {
	      return false;
	    }
	
	    if (a.length != b.length) {
	      return false;
	    }
	
	    for (i = 0, len = a.length; i < len; i++) {
	      if (!exports.deepEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	  else if (a instanceof Object) {
	    if (Array.isArray(b) || !(b instanceof Object)) {
	      return false;
	    }
	
	    for (prop in a) {
	      //noinspection JSUnfilteredForInLoop
	      if (!exports.deepEqual(a[prop], b[prop])) {
	        return false;
	      }
	    }
	    for (prop in b) {
	      //noinspection JSUnfilteredForInLoop
	      if (!exports.deepEqual(a[prop], b[prop])) {
	        return false;
	      }
	    }
	    return true;
	  }
	  else {
	    return (typeof a === typeof b) && (a == b);
	  }
	};
	
	/**
	 * Test whether the current JavaScript engine supports Object.defineProperty
	 * @returns {boolean} returns true if supported
	 */
	exports.canDefineProperty = function () {
	  // test needed for broken IE8 implementation
	  try {
	    if (Object.defineProperty) {
	      Object.defineProperty({}, 'x', { get: function () {} });
	      return true;
	    }
	  } catch (e) {}
	
	  return false;
	};
	
	/**
	 * Attach a lazy loading property to a constant.
	 * The given function `fn` is called once when the property is first requested.
	 * On older browsers (<IE8), the function will fall back to direct evaluation
	 * of the properties value.
	 * @param {Object} object   Object where to add the property
	 * @param {string} prop     Property name
	 * @param {Function} fn     Function returning the property value. Called
	 *                          without arguments.
	 */
	exports.lazy = function (object, prop, fn) {
	  if (exports.canDefineProperty()) {
	    var _uninitialized = true;
	    var _value;
	    Object.defineProperty(object, prop, {
	      get: function () {
	        if (_uninitialized) {
	          _value = fn();
	          _uninitialized = false;
	        }
	        return _value;
	      },
	
	      set: function (value) {
	        _value = value;
	        _uninitialized = false;
	      },
	
	      configurable: true,
	      enumerable: true
	    });
	  }
	  else {
	    // fall back to immediate evaluation
	    object[prop] = fn();
	  }
	};
	
	/**
	 * Traverse a path into an object.
	 * When a namespace is missing, it will be created
	 * @param {Object} object
	 * @param {string} path   A dot separated string like 'name.space'
	 * @return {Object} Returns the object at the end of the path
	 */
	exports.traverse = function(object, path) {
	  var obj = object;
	
	  if (path) {
	    var names = path.split('.');
	    for (var i = 0; i < names.length; i++) {
	      var name = names[i];
	      if (!(name in obj)) {
	        obj[name] = {};
	      }
	      obj = obj[name];
	    }
	  }
	
	  return obj;
	};
	
	/**
	 * A safe hasOwnProperty
	 * @param {Object} object
	 * @param {string} property
	 */
	exports.hasOwnProperty = function (object, property) {
	  return object && Object.hasOwnProperty.call(object, property);
	}
	
	/**
	 * Test whether an object is a factory. a factory has fields:
	 *
	 * - factory: function (type: Object, config: Object, load: function, typed: function [, math: Object])   (required)
	 * - name: string (optional)
	 * - path: string    A dot separated path (optional)
	 * - math: boolean   If true (false by default), the math namespace is passed
	 *                   as fifth argument of the factory function
	 *
	 * @param {*} object
	 * @returns {boolean}
	 */
	exports.isFactory = function (object) {
	  return object && typeof object.factory === 'function';
	};


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	'use strict';
	/**
	 * Test whether a value is a BigNumber
	 * @param {*} x
	 * @return {boolean}
	 */
	module.exports = function isBigNumber(x) {
	  return x && x.constructor.prototype.isBigNumber || false
	}


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var typedFunction = __webpack_require__(1323);
	var digits = __webpack_require__(1324).digits;
	var isBigNumber = __webpack_require__(1321);
	var isMatrix = __webpack_require__(1325);
	
	// returns a new instance of typed-function
	var createTyped = function () {
	  // initially, return the original instance of typed-function
	  // consecutively, return a new instance from typed.create.
	  createTyped = typedFunction.create;
	  return typedFunction;
	};
	
	/**
	 * Factory function for creating a new typed instance
	 * @param {Object} type   Object with data types like Complex and BigNumber
	 * @returns {Function}
	 */
	exports.create = function create(type) {
	  // TODO: typed-function must be able to silently ignore signatures with unknown data types
	
	  // type checks for all known types
	  //
	  // note that:
	  //
	  // - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
	  //   instanceof cannot be used because that would not allow to pass data from
	  //   one instance of math.js to another since each has it's own instance of Unit.
	  // - check the `isUnit` property via the constructor, so there will be no
	  //   matches for "fake" instances like plain objects with a property `isUnit`.
	  //   That is important for security reasons.
	  // - It must not be possible to override the type checks used internally,
	  //   for security reasons, so these functions are not exposed in the expression
	  //   parser.
	  type.isNumber = function (x) { return typeof x === 'number' };
	  type.isComplex = function (x) { return type.Complex && x instanceof type.Complex || false };
	  type.isBigNumber = isBigNumber;
	  type.isFraction = function (x) { return type.Fraction && x instanceof type.Fraction || false };
	  type.isUnit = function (x) { return x && x.constructor.prototype.isUnit || false };
	  type.isString = function (x) { return typeof x === 'string' };
	  type.isArray = Array.isArray;
	  type.isMatrix = isMatrix;
	  type.isDenseMatrix = function (x) { return x && x.isDenseMatrix && x.constructor.prototype.isMatrix || false };
	  type.isSparseMatrix = function (x) { return x && x.isSparseMatrix && x.constructor.prototype.isMatrix || false };
	  type.isRange = function (x) { return x && x.constructor.prototype.isRange || false };
	  type.isIndex = function (x) { return x && x.constructor.prototype.isIndex || false };
	  type.isBoolean = function (x) { return typeof x === 'boolean' };
	  type.isResultSet = function (x) { return x && x.constructor.prototype.isResultSet || false };
	  type.isHelp = function (x) { return x && x.constructor.prototype.isHelp || false };
	  type.isFunction = function (x) { return typeof x === 'function'};
	  type.isDate = function (x) { return x instanceof Date };
	  type.isRegExp = function (x) { return x instanceof RegExp };
	  type.isObject = function (x) {
	    return typeof x === 'object' &&
	        x.constructor === Object &&
	        !type.isComplex(x) &&
	        !type.isFraction(x)
	  };
	  type.isNull = function (x) { return x === null };
	  type.isUndefined = function (x) { return x === undefined };
	
	  type.isAccessorNode = function (x) { return x && x.isAccessorNode && x.constructor.prototype.isNode || false };
	  type.isArrayNode = function (x) { return x && x.isArrayNode && x.constructor.prototype.isNode || false };
	  type.isAssignmentNode = function (x) { return x && x.isAssignmentNode && x.constructor.prototype.isNode || false };
	  type.isBlockNode = function (x) { return x && x.isBlockNode && x.constructor.prototype.isNode || false };
	  type.isConditionalNode = function (x) { return x && x.isConditionalNode && x.constructor.prototype.isNode || false };
	  type.isConstantNode = function (x) { return x && x.isConstantNode && x.constructor.prototype.isNode || false };
	  type.isFunctionAssignmentNode = function (x) { return x && x.isFunctionAssignmentNode && x.constructor.prototype.isNode || false };
	  type.isFunctionNode = function (x) { return x && x.isFunctionNode && x.constructor.prototype.isNode || false };
	  type.isIndexNode = function (x) { return x && x.isIndexNode && x.constructor.prototype.isNode || false };
	  type.isNode = function (x) { return x && x.isNode && x.constructor.prototype.isNode || false };
	  type.isObjectNode = function (x) { return x && x.isObjectNode && x.constructor.prototype.isNode || false };
	  type.isOperatorNode = function (x) { return x && x.isOperatorNode && x.constructor.prototype.isNode || false };
	  type.isParenthesisNode = function (x) { return x && x.isParenthesisNode && x.constructor.prototype.isNode || false };
	  type.isRangeNode = function (x) { return x && x.isRangeNode && x.constructor.prototype.isNode || false };
	  type.isSymbolNode = function (x) { return x && x.isSymbolNode && x.constructor.prototype.isNode || false };
	
	  type.isChain = function (x) { return x && x.constructor.prototype.isChain || false };
	
	  // get a new instance of typed-function
	  var typed = createTyped();
	
	  // define all types. The order of the types determines in which order function
	  // arguments are type-checked (so for performance it's important to put the
	  // most used types first).
	  typed.types = [
	    { name: 'number',          test: type.isNumber },
	    { name: 'Complex',         test: type.isComplex },
	    { name: 'BigNumber',       test: type.isBigNumber },
	    { name: 'Fraction',        test: type.isFraction },
	    { name: 'Unit',            test: type.isUnit },
	    { name: 'string',          test: type.isString },
	    { name: 'Array',           test: type.isArray },
	    { name: 'Matrix',          test: type.isMatrix },
	    { name: 'DenseMatrix',     test: type.isDenseMatrix },
	    { name: 'SparseMatrix',    test: type.isSparseMatrix },
	    { name: 'Range',           test: type.isRange },
	    { name: 'Index',           test: type.isIndex },
	    { name: 'boolean',         test: type.isBoolean },
	    { name: 'ResultSet',       test: type.isResultSet },
	    { name: 'Help',            test: type.isHelp },
	    { name: 'function',        test: type.isFunction },
	    { name: 'Date',            test: type.isDate },
	    { name: 'RegExp',          test: type.isRegExp },
	    { name: 'null',            test: type.isNull },
	    { name: 'undefined',       test: type.isUndefined },
	
	    { name: 'OperatorNode',    test: type.isOperatorNode },
	    { name: 'ConstantNode',    test: type.isConstantNode },
	    { name: 'SymbolNode',      test: type.isSymbolNode },
	    { name: 'ParenthesisNode', test: type.isParenthesisNode },
	    { name: 'FunctionNode',    test: type.isFunctionNode },
	    { name: 'FunctionAssignmentNode',    test: type.isFunctionAssignmentNode },
	    { name: 'ArrayNode',                 test: type.isArrayNode },
	    { name: 'AssignmentNode',            test: type.isAssignmentNode },
	    { name: 'BlockNode',                 test: type.isBlockNode },
	    { name: 'ConditionalNode',           test: type.isConditionalNode },
	    { name: 'IndexNode',                 test: type.isIndexNode },
	    { name: 'RangeNode',                 test: type.isRangeNode },
	    { name: 'Node',                      test: type.isNode },
	
	    { name: 'Object',          test: type.isObject } // order 'Object' last, it's a tricky one
	  ];
	
	  // TODO: add conversion from BigNumber to number?
	  typed.conversions = [
	    {
	      from: 'number',
	      to: 'BigNumber',
	      convert: function (x) {
	        // note: conversion from number to BigNumber can fail if x has >15 digits
	        if (digits(x) > 15) {
	          throw new TypeError('Cannot implicitly convert a number with >15 significant digits to BigNumber ' +
	          '(value: ' + x + '). ' +
	          'Use function bignumber(x) to convert to BigNumber.');
	        }
	        return new type.BigNumber(x);
	      }
	    }, {
	      from: 'number',
	      to: 'Complex',
	      convert: function (x) {
	        return new type.Complex(x, 0);
	      }
	    }, {
	      from: 'number',
	      to: 'string',
	      convert: function (x) {
	        return x + '';
	      }
	    }, {
	      from: 'BigNumber',
	      to: 'Complex',
	      convert: function (x) {
	        return new type.Complex(x.toNumber(), 0);
	      }
	    }, {
	      from: 'Fraction',
	      to: 'BigNumber',
	      convert: function (x) {
	        throw new TypeError('Cannot implicitly convert a Fraction to BigNumber or vice versa. ' +
	            'Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.');
	      }
	    }, {
	      from: 'Fraction',
	      to: 'Complex',
	      convert: function (x) {
	        return new type.Complex(x.valueOf(), 0);
	      }
	    }, {
	      from: 'number',
	      to: 'Fraction',
	      convert: function (x) {
	        var f = new type.Fraction(x);
	        if (f.valueOf() !== x) {
	          throw new TypeError('Cannot implicitly convert a number to a Fraction when there will be a loss of precision ' +
	              '(value: ' + x + '). ' +
	              'Use function fraction(x) to convert to Fraction.');
	        }
	        return new type.Fraction(x);
	      }
	    }, {
	    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
	    //  from: 'Fraction',
	    //  to: 'number',
	    //  convert: function (x) {
	    //    return x.valueOf();
	    //  }
	    //}, {
	      from: 'string',
	      to: 'number',
	      convert: function (x) {
	        var n = Number(x);
	        if (isNaN(n)) {
	          throw new Error('Cannot convert "' + x + '" to a number');
	        }
	        return n;
	      }
	    }, {
	      from: 'string',
	      to: 'BigNumber',
	      convert: function (x) {
	        try {
	          return new type.BigNumber(x);
	        }
	        catch (err) {
	          throw new Error('Cannot convert "' + x + '" to BigNumber');
	        }
	      }
	    }, {
	      from: 'string',
	      to: 'Fraction',
	      convert: function (x) {
	        try {
	          return new type.Fraction(x);
	        }
	        catch (err) {
	          throw new Error('Cannot convert "' + x + '" to Fraction');
	        }
	      }
	    }, {
	      from: 'string',
	      to: 'Complex',
	      convert: function (x) {
	        try {
	          return new type.Complex(x);
	        }
	        catch (err) {
	          throw new Error('Cannot convert "' + x + '" to Complex');
	        }
	      }
	    }, {
	      from: 'boolean',
	      to: 'number',
	      convert: function (x) {
	        return +x;
	      }
	    }, {
	      from: 'boolean',
	      to: 'BigNumber',
	      convert: function (x) {
	        return new type.BigNumber(+x);
	      }
	    }, {
	      from: 'boolean',
	      to: 'Fraction',
	      convert: function (x) {
	        return new type.Fraction(+x);
	      }
	    }, {
	      from: 'boolean',
	      to: 'string',
	      convert: function (x) {
	        return +x;
	      }
	    }, {
	      from: 'Array',
	      to: 'Matrix',
	      convert: function (array) {
	        return new type.DenseMatrix(array);
	      }
	    }, {
	      from: 'Matrix',
	      to: 'Array',
	      convert: function (matrix) {
	        return matrix.valueOf();
	      }
	    }
	  ];
	
	  return typed;
	};


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * typed-function
	 *
	 * Type checking for JavaScript functions
	 *
	 * https://github.com/josdejong/typed-function
	 */
	'use strict';
	
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // OldNode. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like OldNode.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.typed = factory();
	  }
	}(this, function () {
	
	  function ok () {
	    return true;
	  }
	
	  function notOk () {
	    return false;
	  }
	
	  function undef () {
	    return undefined;
	  }
	
	  /**
	   * @typedef {{
	   *   params: Param[],
	   *   fn: function
	   * }} Signature
	   *
	   * @typedef {{
	   *   types: Type[],
	   *   restParam: boolean
	   * }} Param
	   *
	   * @typedef {{
	   *   name: string,
	   *   typeIndex: number,
	   *   test: function,
	   *   conversion?: ConversionDef,
	   *   conversionIndex: number,
	   * }} Type
	   *
	   * @typedef {{
	   *   from: string,
	   *   to: string,
	   *   convert: function (*) : *
	   * }} ConversionDef
	   *
	   * @typedef {{
	   *   name: string,
	   *   test: function(*) : boolean
	   * }} TypeDef
	   */
	
	  // create a new instance of typed-function
	  function create () {
	    // data type tests
	    var _types = [
	      { name: 'number',    test: function (x) { return typeof x === 'number' } },
	      { name: 'string',    test: function (x) { return typeof x === 'string' } },
	      { name: 'boolean',   test: function (x) { return typeof x === 'boolean' } },
	      { name: 'Function',  test: function (x) { return typeof x === 'function'} },
	      { name: 'Array',     test: Array.isArray },
	      { name: 'Date',      test: function (x) { return x instanceof Date } },
	      { name: 'RegExp',    test: function (x) { return x instanceof RegExp } },
	      { name: 'Object',    test: function (x) {
	        return typeof x === 'object' && x.constructor === Object
	      }},
	      { name: 'null',      test: function (x) { return x === null } },
	      { name: 'undefined', test: function (x) { return x === undefined } }
	    ];
	
	    var anyType = {
	      name: 'any',
	      test: ok
	    }
	
	    // types which need to be ignored
	    var _ignore = [];
	
	    // type conversions
	    var _conversions = [];
	
	    // This is a temporary object, will be replaced with a typed function at the end
	    var typed = {
	      types: _types,
	      conversions: _conversions,
	      ignore: _ignore
	    };
	
	    /**
	     * Find the test function for a type
	     * @param {String} typeName
	     * @return {TypeDef} Returns the type definition when found,
	     *                    Throws a TypeError otherwise
	     */
	    function findTypeByName (typeName) {
	      var entry = findInArray(typed.types, function (entry) {
	        return entry.name === typeName;
	      });
	
	      if (entry) {
	        return entry;
	      }
	
	      if (typeName === 'any') { // special baked-in case 'any'
	        return anyType;
	      }
	
	      var hint = findInArray(typed.types, function (entry) {
	        return entry.name.toLowerCase() === typeName.toLowerCase();
	      });
	
	      throw new TypeError('Unknown type "' + typeName + '"' +
	          (hint ? ('. Did you mean "' + hint.name + '"?') : ''));
	    }
	
	    /**
	     * Find the index of a type definition. Handles special case 'any'
	     * @param {TypeDef} type
	     * @return {number}
	     */
	    function findTypeIndex(type) {
	      if (type === anyType) {
	        return 999;
	      }
	
	      return typed.types.indexOf(type);
	    }
	
	    /**
	     * Find a type that matches a value.
	     * @param {*} value
	     * @return {string} Returns the name of the first type for which
	     *                  the type test matches the value.
	     */
	    function findTypeName(value) {
	      var entry = findInArray(typed.types, function (entry) {
	        return entry.test(value);
	      });
	
	      if (entry) {
	        return entry.name;
	      }
	
	      throw new TypeError('Value has unknown type. Value: ' + value);
	    }
	
	    /**
	     * Find a specific signature from a (composed) typed function, for example:
	     *
	     *   typed.find(fn, ['number', 'string'])
	     *   typed.find(fn, 'number, string')
	     *
	     * Function find only only works for exact matches.
	     *
	     * @param {Function} fn                   A typed-function
	     * @param {string | string[]} signature   Signature to be found, can be
	     *                                        an array or a comma separated string.
	     * @return {Function}                     Returns the matching signature, or
	     *                                        throws an error when no signature
	     *                                        is found.
	     */
	    function find (fn, signature) {
	      if (!fn.signatures) {
	        throw new TypeError('Function is no typed-function');
	      }
	
	      // normalize input
	      var arr;
	      if (typeof signature === 'string') {
	        arr = signature.split(',');
	        for (var i = 0; i < arr.length; i++) {
	          arr[i] = arr[i].trim();
	        }
	      }
	      else if (Array.isArray(signature)) {
	        arr = signature;
	      }
	      else {
	        throw new TypeError('String array or a comma separated string expected');
	      }
	
	      var str = arr.join(',');
	
	      // find an exact match
	      var match = fn.signatures[str];
	      if (match) {
	        return match;
	      }
	
	      // TODO: extend find to match non-exact signatures
	
	      throw new TypeError('Signature not found (signature: ' + (fn.name || 'unnamed') + '(' + arr.join(', ') + '))');
	    }
	
	    /**
	     * Convert a given value to another data type.
	     * @param {*} value
	     * @param {string} type
	     */
	    function convert (value, type) {
	      var from = findTypeName(value);
	
	      // check conversion is needed
	      if (type === from) {
	        return value;
	      }
	
	      for (var i = 0; i < typed.conversions.length; i++) {
	        var conversion = typed.conversions[i];
	        if (conversion.from === from && conversion.to === type) {
	          return conversion.convert(value);
	        }
	      }
	
	      throw new Error('Cannot convert from ' + from + ' to ' + type);
	    }
	    
	    /**
	     * Stringify parameters in a normalized way
	     * @param {Param[]} params
	     * @return {string}
	     */
	    function stringifyParams (params) {
	      return params
	          .map(function (param) {
	            var typeNames = param.types.map(getTypeName);
	
	            return (param.restParam ? '...' : '') + typeNames.join('|');
	          })
	          .join(',');
	    }
	
	    /**
	     * Parse a parameter, like "...number | boolean"
	     * @param {string} param
	     * @param {ConversionDef[]} conversions
	     * @return {Param} param
	     */
	    function parseParam (param, conversions) {
	      var restParam = param.indexOf('...') === 0;
	      var types = (!restParam)
	          ? param
	          : (param.length > 3)
	              ? param.slice(3)
	              : 'any';
	
	      var typeNames = types.split('|').map(trim)
	          .filter(notEmpty)
	          .filter(notIgnore);
	
	      var matchingConversions = filterConversions(conversions, typeNames);
	
	      var exactTypes = typeNames.map(function (typeName) {
	        var type = findTypeByName(typeName);
	
	        return {
	          name: typeName,
	          typeIndex: findTypeIndex(type),
	          test: type.test,
	          conversion: null,
	          conversionIndex: -1
	        };
	      });
	
	      var convertibleTypes = matchingConversions.map(function (conversion) {
	        var type = findTypeByName(conversion.from);
	
	        return {
	          name: conversion.from,
	          typeIndex: findTypeIndex(type),
	          test: type.test,
	          conversion: conversion,
	          conversionIndex: conversions.indexOf(conversion)
	        };
	      });
	
	      return {
	        types: exactTypes.concat(convertibleTypes),
	        restParam: restParam
	      };
	    }
	
	    /**
	     * Parse a signature with comma separated parameters,
	     * like "number | boolean, ...string"
	     * @param {string} signature
	     * @param {function} fn
	     * @param {ConversionDef[]} conversions
	     * @return {Signature | null} signature
	     */
	    function parseSignature (signature, fn, conversions) {
	      var params = [];
	
	      if (signature.trim() !== '') {
	        params = signature
	            .split(',')
	            .map(trim)
	            .map(function (param, index, array) {
	              var parsedParam = parseParam(param, conversions);
	
	              if (parsedParam.restParam && (index !== array.length - 1)) {
	                throw new SyntaxError('Unexpected rest parameter "' + param + '": ' +
	                    'only allowed for the last parameter');
	              }
	
	              return parsedParam;
	          });
	      }
	
	      if (params.some(isInvalidParam)) {
	        // invalid signature: at least one parameter has no types
	        // (they may have been filtered)
	        return null;
	      }
	
	      return {
	        params: params,
	        fn: fn
	      };
	    }
	
	    /**
	     * Test whether a set of params contains a restParam
	     * @param {Param[]} params
	     * @return {boolean} Returns true when the last parameter is a restParam
	     */
	    function hasRestParam(params) {
	      var param = last(params)
	      return param ? param.restParam : false;
	    }
	
	    /**
	     * Test whether a parameter contains conversions
	     * @param {Param} param
	     * @return {boolean} Returns true when at least one of the parameters
	     *                   contains a conversion.
	     */
	    function hasConversions(param) {
	      return param.types.some(function (type) {
	        return type.conversion != null;
	      });
	    }
	
	    /**
	     * Create a type test for a single parameter, which can have one or multiple
	     * types.
	     * @param {Param} param
	     * @return {function(x: *) : boolean} Returns a test function
	     */
	    function compileTest(param) {
	      if (!param || param.types.length === 0) {
	        // nothing to do
	        return ok;
	      }
	      else if (param.types.length === 1) {
	        return findTypeByName(param.types[0].name).test;
	      }
	      else if (param.types.length === 2) {
	        var test0 = findTypeByName(param.types[0].name).test;
	        var test1 = findTypeByName(param.types[1].name).test;
	        return function or(x) {
	          return test0(x) || test1(x);
	        }
	      }
	      else { // param.types.length > 2
	        var tests = param.types.map(function (type) {
	          return findTypeByName(type.name).test;
	        })
	        return function or(x) {
	          for (var i = 0; i < tests.length; i++) {
	            if (tests[i](x)) {
	              return true;
	            }
	          }
	          return false;
	        }
	      }
	    }
	
	    /**
	     * Create a test for all parameters of a signature
	     * @param {Param[]} params
	     * @return {function(args: Array<*>) : boolean}
	     */
	    function compileTests(params) {
	      var tests, test0, test1;
	
	      if (hasRestParam(params)) {
	        // variable arguments like '...number'
	        tests = initial(params).map(compileTest);
	        var varIndex = tests.length;
	        var lastTest = compileTest(last(params));
	        var testRestParam = function (args) {
	          for (var i = varIndex; i < args.length; i++) {
	            if (!lastTest(args[i])) {
	              return false;
	            }
	          }
	          return true;
	        }
	
	        return function testArgs(args) {
	          for (var i = 0; i < tests.length; i++) {
	            if (!tests[i](args[i])) {
	              return false;
	            }
	          }
	          return testRestParam(args) && (args.length >= varIndex + 1);
	        };
	      }
	      else {
	        // no variable arguments
	        if (params.length === 0) {
	          return function testArgs(args) {
	            return args.length === 0;
	          };
	        }
	        else if (params.length === 1) {
	          test0 = compileTest(params[0]);
	          return function testArgs(args) {
	            return test0(args[0]) && args.length === 1;
	          };
	        }
	        else if (params.length === 2) {
	          test0 = compileTest(params[0]);
	          test1 = compileTest(params[1]);
	          return function testArgs(args) {
	            return test0(args[0]) && test1(args[1]) && args.length === 2;
	          };
	        }
	        else { // arguments.length > 2
	          tests = params.map(compileTest);
	          return function testArgs(args) {
	            for (var i = 0; i < tests.length; i++) {
	              if (!tests[i](args[i])) {
	                return false;
	              }
	            }
	            return args.length === tests.length;
	          };
	        }
	      }
	    }
	
	    /**
	     * Find the parameter at a specific index of a signature.
	     * Handles rest parameters.
	     * @param {Signature} signature
	     * @param {number} index
	     * @return {Param | null} Returns the matching parameter when found,
	     *                        null otherwise.
	     */
	    function getParamAtIndex(signature, index) {
	      return index < signature.params.length
	          ? signature.params[index]
	          : hasRestParam(signature.params)
	              ? last(signature.params)
	              : null
	    }
	
	    /**
	     * Get all type names of a parameter
	     * @param {Signature} signature
	     * @param {number} index
	     * @param {boolean} excludeConversions
	     * @return {string[]} Returns an array with type names
	     */
	    function getExpectedTypeNames (signature, index, excludeConversions) {
	      var param = getParamAtIndex(signature, index);
	      var types = param
	          ? excludeConversions
	                  ? param.types.filter(isExactType)
	                  : param.types
	          : [];
	
	      return types.map(getTypeName);
	    }
	
	    /**
	     * Returns the name of a type
	     * @param {Type} type
	     * @return {string} Returns the type name
	     */
	    function getTypeName(type) {
	      return type.name;
	    }
	
	    /**
	     * Test whether a type is an exact type or conversion
	     * @param {Type} type
	     * @return {boolean} Returns true when
	     */
	    function isExactType(type) {
	      return type.conversion === null || type.conversion === undefined;
	    }
	
	    /**
	     * Helper function for creating error messages: create an array with
	     * all available types on a specific argument index.
	     * @param {Signature[]} signatures
	     * @param {number} index
	     * @return {string[]} Returns an array with available types
	     */
	    function mergeExpectedParams(signatures, index) {
	      var typeNames = uniq(flatMap(signatures, function (signature) {
	        return getExpectedTypeNames(signature, index, false);
	      }));
	
	      return (typeNames.indexOf('any') !== -1) ? ['any'] : typeNames;
	    }
	
	    /**
	     * Create
	     * @param {string} name             The name of the function
	     * @param {array.<*>} args          The actual arguments passed to the function
	     * @param {Signature[]} signatures  A list with available signatures
	     * @return {TypeError} Returns a type error with additional data
	     *                     attached to it in the property `data`
	     */
	    function createError(name, args, signatures) {
	      var err, expected;
	      var _name = name || 'unnamed';
	
	      // test for wrong type at some index
	      var matchingSignatures = signatures;
	      var index;
	      for (index = 0; index < args.length; index++) {
	        var nextMatchingDefs = matchingSignatures.filter(function (signature) {
	          var test = compileTest(getParamAtIndex(signature, index));
	          return (index < signature.params.length || hasRestParam(signature.params)) &&
	              test(args[index]);
	        });
	
	        if (nextMatchingDefs.length === 0) {
	          // no matching signatures anymore, throw error "wrong type"
	          expected = mergeExpectedParams(matchingSignatures, index);
	          if (expected.length > 0) {
	            var actualType = findTypeName(args[index]);
	
	            err = new TypeError('Unexpected type of argument in function ' + _name +
	                ' (expected: ' + expected.join(' or ') +
	                ', actual: ' + actualType + ', index: ' + index + ')');
	            err.data = {
	              category: 'wrongType',
	              fn: _name,
	              index: index,
	              actual: actualType,
	              expected: expected
	            }
	            return err;
	          }
	        }
	        else {
	          matchingSignatures = nextMatchingDefs;
	        }
	      }
	
	      // test for too few arguments
	      var lengths = matchingSignatures.map(function (signature) {
	        return hasRestParam(signature.params) ? Infinity : signature.params.length;
	      });
	      if (args.length < Math.min.apply(null, lengths)) {
	        expected = mergeExpectedParams(matchingSignatures, index);
	        err = new TypeError('Too few arguments in function ' + _name +
	            ' (expected: ' + expected.join(' or ') +
	            ', index: ' + args.length + ')');
	        err.data = {
	          category: 'tooFewArgs',
	          fn: _name,
	          index: args.length,
	          expected: expected
	        }
	        return err;
	      }
	
	      // test for too many arguments
	      var maxLength = Math.max.apply(null, lengths);
	      if (args.length > maxLength) {
	        err = new TypeError('Too many arguments in function ' + _name +
	            ' (expected: ' + maxLength + ', actual: ' + args.length + ')');
	        err.data = {
	          category: 'tooManyArgs',
	          fn: _name,
	          index: args.length,
	          expectedLength: maxLength
	        }
	        return err;
	      }
	
	      err = new TypeError('Arguments of type "' + args.join(', ') +
	          '" do not match any of the defined signatures of function ' + _name + '.');
	      err.data = {
	        category: 'mismatch',
	        actual: args.map(findTypeName)
	      }
	      return err;
	    }
	
	    /**
	     * Find the lowest index of all exact types of a parameter (no conversions)
	     * @param {Param} param
	     * @return {number} Returns the index of the lowest type in typed.types
	     */
	    function getLowestTypeIndex (param) {
	      var min = 999;
	
	      for (var i = 0; i < param.types.length; i++) {
	        if (isExactType(param.types[i])) {
	          min = Math.min(min, param.types[i].typeIndex);
	        }
	      }
	
	      return min;
	    }
	
	    /**
	     * Find the lowest index of the conversion of all types of the parameter
	     * having a conversion
	     * @param {Param} param
	     * @return {number} Returns the lowest index of the conversions of this type
	     */
	    function getLowestConversionIndex (param) {
	      var min = 999;
	
	      for (var i = 0; i < param.types.length; i++) {
	        if (!isExactType(param.types[i])) {
	          min = Math.min(min, param.types[i].conversionIndex);
	        }
	      }
	
	      return min;
	    }
	
	    /**
	     * Compare two params
	     * @param {Param} param1
	     * @param {Param} param2
	     * @return {number} returns a negative number when param1 must get a lower
	     *                  index than param2, a positive number when the opposite,
	     *                  or zero when both are equal
	     */
	    function compareParams (param1, param2) {
	      var c;
	
	      // compare having a rest parameter or not
	      c = param1.restParam - param2.restParam;
	      if (c !== 0) {
	        return c;
	      }
	
	      // compare having conversions or not
	      c = hasConversions(param1) - hasConversions(param2);
	      if (c !== 0) {
	        return c;
	      }
	
	      // compare the index of the types
	      c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
	      if (c !== 0) {
	        return c;
	      }
	
	      // compare the index of any conversion
	      return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
	    }
	
	    /**
	     * Compare two signatures
	     * @param {Signature} signature1
	     * @param {Signature} signature2
	     * @return {number} returns a negative number when param1 must get a lower
	     *                  index than param2, a positive number when the opposite,
	     *                  or zero when both are equal
	     */
	    function compareSignatures (signature1, signature2) {
	      var len = Math.min(signature1.params.length, signature2.params.length);
	      var i;
	      var c;
	
	      // compare whether the params have conversions at all or not
	      c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions)
	      if (c !== 0) {
	        return c;
	      }
	
	      // next compare whether the params have conversions one by one
	      for (i = 0; i < len; i++) {
	        c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
	        if (c !== 0) {
	          return c;
	        }
	      }
	
	      // compare the types of the params one by one
	      for (i = 0; i < len; i++) {
	        c = compareParams(signature1.params[i], signature2.params[i]);
	        if (c !== 0) {
	          return c;
	        }
	      }
	
	      // compare the number of params
	      return signature1.params.length - signature2.params.length;
	    }
	
	    /**
	     * Get params containing all types that can be converted to the defined types.
	     *
	     * @param {ConversionDef[]} conversions
	     * @param {string[]} typeNames
	     * @return {ConversionDef[]} Returns the conversions that are available
	     *                        for every type (if any)
	     */
	    function filterConversions(conversions, typeNames) {
	      var matches = {};
	
	      conversions.forEach(function (conversion) {
	        if (typeNames.indexOf(conversion.from) === -1 &&
	            typeNames.indexOf(conversion.to) !== -1 &&
	            !matches[conversion.from]) {
	          matches[conversion.from] = conversion;
	        }
	      });
	
	      return Object.keys(matches).map(function (from) {
	        return matches[from];
	      });
	    }
	
	    /**
	     * Preprocess arguments before calling the original function:
	     * - if needed convert the parameters
	     * - in case of rest parameters, move the rest parameters into an Array
	     * @param {Param[]} params
	     * @param {function} fn
	     * @return {function} Returns a wrapped function
	     */
	    function compileArgsPreprocessing(params, fn) {
	      var fnConvert = fn;
	
	      // TODO: can we make this wrapper function smarter/simpler?
	
	      if (params.some(hasConversions)) {
	        var restParam = hasRestParam(params);
	        var compiledConversions = params.map(compileArgConversion)
	
	        fnConvert = function convertArgs() {
	          var args = [];
	          var last = restParam ? arguments.length - 1 : arguments.length;
	          for (var i = 0; i < last; i++) {
	            args[i] = compiledConversions[i](arguments[i]);
	          }
	          if (restParam) {
	            args[last] = arguments[last].map(compiledConversions[last]);
	          }
	
	          return fn.apply(null, args);
	        }
	      }
	
	      var fnPreprocess = fnConvert;
	      if (hasRestParam(params)) {
	        var offset = params.length - 1;
	
	        fnPreprocess = function preprocessRestParams () {
	          return fnConvert.apply(null,
	              slice(arguments, 0, offset).concat([slice(arguments, offset)]));
	        }
	      }
	
	      return fnPreprocess;
	    }
	
	    /**
	     * Compile conversion for a parameter to the right type
	     * @param {Param} param
	     * @return {function} Returns the wrapped function that will convert arguments
	     *
	     */
	    function compileArgConversion(param) {
	      var test0, test1, conversion0, conversion1;
	      var tests = [];
	      var conversions = [];
	
	      param.types.forEach(function (type) {
	        if (type.conversion) {
	          tests.push(findTypeByName(type.conversion.from).test);
	          conversions.push(type.conversion.convert);
	        }
	      });
	
	      // create optimized conversion functions depending on the number of conversions
	      switch (conversions.length) {
	        case 0:
	          return function convertArg(arg) {
	            return arg;
	          }
	
	        case 1:
	          test0 = tests[0]
	          conversion0 = conversions[0];
	          return function convertArg(arg) {
	            if (test0(arg)) {
	              return conversion0(arg)
	            }
	            return arg;
	          }
	
	        case 2:
	          test0 = tests[0]
	          test1 = tests[1]
	          conversion0 = conversions[0];
	          conversion1 = conversions[1];
	          return function convertArg(arg) {
	            if (test0(arg)) {
	              return conversion0(arg)
	            }
	            if (test1(arg)) {
	              return conversion1(arg)
	            }
	            return arg;
	          }
	
	        default:
	          return function convertArg(arg) {
	            for (var i = 0; i < conversions.length; i++) {
	              if (tests[i](arg)) {
	                return conversions[i](arg);
	              }
	            }
	            return arg;
	          }
	      }
	    }
	
	    /**
	     * Convert an array with signatures into a map with signatures,
	     * where signatures with union types are split into separate signatures
	     *
	     * Throws an error when there are conflicting types
	     *
	     * @param {Signature[]} signatures
	     * @return {Object.<string, function>}  Returns a map with signatures
	     *                                      as key and the original function
	     *                                      of this signature as value.
	     */
	    function createSignaturesMap(signatures) {
	      var signaturesMap = {};
	      signatures.forEach(function (signature) {
	        if (!signature.params.some(hasConversions)) {
	          splitParams(signature.params, true).forEach(function (params) {
	            signaturesMap[stringifyParams(params)] = signature.fn;
	          });
	        }
	      });
	
	      return signaturesMap;
	    }
	
	    /**
	     * Split params with union types in to separate params.
	     *
	     * For example:
	     *
	     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
	     *     // returns:
	     *     // [
	     *     //   ['Array', 'string'],
	     *     //   ['Array', 'RegExp'],
	     *     //   ['Object', 'string'],
	     *     //   ['Object', 'RegExp']
	     *     // ]
	     *
	     * @param {Param[]} params
	     * @param {boolean} ignoreConversionTypes
	     * @return {Param[]}
	     */
	    function splitParams(params, ignoreConversionTypes) {
	      function _splitParams(params, index, types) {
	        if (index < params.length) {
	          var param = params[index]
	          var filteredTypes = ignoreConversionTypes
	              ? param.types.filter(isExactType)
	              : param.types;
	          var typeGroups
	
	          if (param.restParam) {
	            // split the types of a rest parameter in two:
	            // one with only exact types, and one with exact types and conversions
	            var exactTypes = filteredTypes.filter(isExactType)
	            typeGroups = exactTypes.length < filteredTypes.length
	                ? [exactTypes, filteredTypes]
	                : [filteredTypes]
	
	          }
	          else {
	            // split all the types of a regular parameter into one type per group
	            typeGroups = filteredTypes.map(function (type) {
	              return [type]
	            })
	          }
	
	          // recurse over the groups with types
	          return flatMap(typeGroups, function (typeGroup) {
	            return _splitParams(params, index + 1, types.concat([typeGroup]));
	          });
	
	        }
	        else {
	          // we've reached the end of the parameters. Now build a new Param
	          var splittedParams = types.map(function (type, typeIndex) {
	            return {
	              types: type,
	              restParam: (typeIndex === params.length - 1) && hasRestParam(params)
	            }
	          });
	
	          return [splittedParams];
	        }
	      }
	
	      return _splitParams(params, 0, []);
	    }
	
	    /**
	     * Test whether two signatures have a conflicting signature
	     * @param {Signature} signature1
	     * @param {Signature} signature2
	     * @return {boolean} Returns true when the signatures conflict, false otherwise.
	     */
	    function hasConflictingParams(signature1, signature2) {
	      var ii = Math.max(signature1.params.length, signature2.params.length);
	
	      for (var i = 0; i < ii; i++) {
	        var typesNames1 = getExpectedTypeNames(signature1, i, true);
	        var typesNames2 = getExpectedTypeNames(signature2, i, true);
	
	        if (!hasOverlap(typesNames1, typesNames2)) {
	          return false;
	        }
	      }
	
	      var len1 = signature1.params.length;
	      var len2 = signature2.params.length;
	      var restParam1 = hasRestParam(signature1.params);
	      var restParam2 = hasRestParam(signature2.params);
	
	      return restParam1
	          ? restParam2 ? (len1 === len2) : (len2 >= len1)
	          : restParam2 ? (len1 >= len2)  : (len1 === len2)
	    }
	
	    /**
	     * Create a typed function
	     * @param {String} name               The name for the typed function
	     * @param {Object.<string, function>} signaturesMap
	     *                                    An object with one or
	     *                                    multiple signatures as key, and the
	     *                                    function corresponding to the
	     *                                    signature as value.
	     * @return {function}  Returns the created typed function.
	     */
	    function createTypedFunction(name, signaturesMap) {
	      if (Object.keys(signaturesMap).length === 0) {
	        throw new SyntaxError('No signatures provided');
	      }
	
	      // parse the signatures, and check for conflicts
	      var parsedSignatures = [];
	      Object.keys(signaturesMap)
	          .map(function (signature) {
	            return parseSignature(signature, signaturesMap[signature], typed.conversions);
	          })
	          .filter(notNull)
	          .forEach(function (parsedSignature) {
	            // check whether this parameter conflicts with already parsed signatures
	            var conflictingSignature = findInArray(parsedSignatures, function (s) {
	              return hasConflictingParams(s, parsedSignature)
	            });
	            if (conflictingSignature) {
	              throw new TypeError('Conflicting signatures "' +
	                  stringifyParams(conflictingSignature.params) + '" and "' +
	                  stringifyParams(parsedSignature.params) + '".');
	            }
	
	            parsedSignatures.push(parsedSignature);
	          });
	
	      // split and filter the types of the signatures, and then order them
	      var signatures = flatMap(parsedSignatures, function (parsedSignature) {
	        var params = parsedSignature ? splitParams(parsedSignature.params, false) : []
	
	        return params.map(function (params) {
	          return {
	            params: params,
	            fn: parsedSignature.fn
	          };
	        });
	      }).filter(notNull);
	
	      signatures.sort(compareSignatures);
	
	      // we create a highly optimized checks for the first couple of signatures with max 2 arguments
	      var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
	      var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
	      var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
	      var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
	      var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
	      var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
	      var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
	
	      // compile the tests
	      var tests = signatures.map(function (signature) {
	        return compileTests(signature.params);
	      });
	
	      var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
	      var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
	      var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
	      var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
	      var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
	      var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
	
	      var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
	      var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
	      var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
	      var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
	      var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
	      var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
	
	      // compile the functions
	      var fns = signatures.map(function(signature) {
	        return compileArgsPreprocessing(signature.params, signature.fn)
	      });
	
	      var fn0 = ok0 ? fns[0] : undef;
	      var fn1 = ok1 ? fns[1] : undef;
	      var fn2 = ok2 ? fns[2] : undef;
	      var fn3 = ok3 ? fns[3] : undef;
	      var fn4 = ok4 ? fns[4] : undef;
	      var fn5 = ok5 ? fns[5] : undef;
	
	      var len0 = ok0 ? signatures[0].params.length : -1;
	      var len1 = ok1 ? signatures[1].params.length : -1;
	      var len2 = ok2 ? signatures[2].params.length : -1;
	      var len3 = ok3 ? signatures[3].params.length : -1;
	      var len4 = ok4 ? signatures[4].params.length : -1;
	      var len5 = ok5 ? signatures[5].params.length : -1;
	
	      // simple and generic, but also slow
	      var iStart = allOk ? 6 : 0;
	      var iEnd = signatures.length;
	      var generic = function generic() {
	        'use strict';
	
	        for (var i = iStart; i < iEnd; i++) {
	          if (tests[i](arguments)) {
	            return fns[i].apply(null, arguments);
	          }
	        }
	
	        throw createError(name, arguments, signatures);
	      }
	
	      // create the typed function
	      // fast, specialized version. Falls back to the slower, generic one if needed
	      var fn = function fn(arg0, arg1) {
	        'use strict';
	
	        if (arguments.length === len0 && test00(arg0) && test01(arg1)) { return fn0.apply(null, arguments); }
	        if (arguments.length === len1 && test10(arg0) && test11(arg1)) { return fn1.apply(null, arguments); }
	        if (arguments.length === len2 && test20(arg0) && test21(arg1)) { return fn2.apply(null, arguments); }
	        if (arguments.length === len3 && test30(arg0) && test31(arg1)) { return fn3.apply(null, arguments); }
	        if (arguments.length === len4 && test40(arg0) && test41(arg1)) { return fn4.apply(null, arguments); }
	        if (arguments.length === len5 && test50(arg0) && test51(arg1)) { return fn5.apply(null, arguments); }
	
	        return generic.apply(null, arguments);
	      }
	
	      // attach name the typed function
	      try {
	        Object.defineProperty(fn, 'name', {value: name});
	      }
	      catch (err) {
	        // old browsers do not support Object.defineProperty and some don't support setting the name property
	        // the function name is not essential for the functioning, it's mostly useful for debugging,
	        // so it's fine to have unnamed functions.
	      }
	
	      // attach signatures to the function
	      fn.signatures = createSignaturesMap(signatures);
	
	      return fn;
	    }
	
	    /**
	     * Test whether a type should be NOT be ignored
	     * @param {string} typeName
	     * @return {boolean}
	     */
	    function notIgnore(typeName) {
	      return typed.ignore.indexOf(typeName) === -1;
	    }
	
	    /**
	     * trim a string
	     * @param {string} str
	     * @return {string}
	     */
	    function trim(str) {
	      return str.trim();
	    }
	
	    /**
	     * Test whether a string is not empty
	     * @param {string} str
	     * @return {boolean}
	     */
	    function notEmpty(str) {
	      return !!str;
	    }
	
	    /**
	     * test whether a value is not strict equal to null
	     * @param {*} value
	     * @return {boolean}
	     */
	    function notNull(value) {
	      return value !== null;
	    }
	
	    /**
	     * Test whether a parameter has no types defined
	     * @param {Param} param
	     * @return {boolean}
	     */
	    function isInvalidParam (param) {
	      return param.types.length === 0;
	    }
	
	    /**
	     * Return all but the last items of an array
	     * @param {Array} arr
	     * @return {Array}
	     */
	    function initial(arr) {
	      return arr.slice(0, arr.length - 1);
	    }
	
	    /**
	     * return the last item of an array
	     * @param {Array} arr
	     * @return {*}
	     */
	    function last(arr) {
	      return arr[arr.length - 1];
	    }
	
	    /**
	     * Slice an array or function Arguments
	     * @param {Array | Arguments | IArguments} arr
	     * @param {number} start
	     * @param {number} [end]
	     * @return {Array}
	     */
	    function slice(arr, start, end) {
	      return Array.prototype.slice.call(arr, start, end);
	    }
	
	    /**
	     * Test whether an array contains some item
	     * @param {Array} array
	     * @param {*} item
	     * @return {boolean} Returns true if array contains item, false if not.
	     */
	    function contains(array, item) {
	      return array.indexOf(item) !== -1;
	    }
	
	    /**
	     * Test whether two arrays have overlapping items
	     * @param {Array} array1
	     * @param {Array} array2
	     * @return {boolean} Returns true when at least one item exists in both arrays
	     */
	    function hasOverlap(array1, array2) {
	      for (var i = 0; i < array1.length; i++) {
	        if (contains(array2, array1[i])) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    /**
	     * Return the first item from an array for which test(arr[i]) returns true
	     * @param {Array} arr
	     * @param {function} test
	     * @return {* | undefined} Returns the first matching item
	     *                         or undefined when there is no match
	     */
	    function findInArray(arr, test) {
	      for (var i = 0; i < arr.length; i++) {
	        if (test(arr[i])) {
	          return arr[i];
	        }
	      }
	      return undefined;
	    }
	
	    /**
	     * Filter unique items of an array with strings
	     * @param {string[]} arr
	     * @return {string[]}
	     */
	    function uniq(arr) {
	      var entries = {}
	      for (var i = 0; i < arr.length; i++) {
	        entries[arr[i]] = true;
	      }
	      return Object.keys(entries);
	    }
	
	    /**
	     * Flat map the result invoking a callback for every item in an array.
	     * https://gist.github.com/samgiles/762ee337dff48623e729
	     * @param {Array} arr
	     * @param {function} callback
	     * @return {Array}
	     */
	    function flatMap(arr, callback) {
	      return Array.prototype.concat.apply([], arr.map(callback));
	    }
	
	    /**
	     * Retrieve the function name from a set of typed functions,
	     * and check whether the name of all functions match (if given)
	     * @param {function[]} fns
	     */
	    function getName (fns) {
	      var name = '';
	
	      for (var i = 0; i < fns.length; i++) {
	        var fn = fns[i];
	
	        // check whether the names are the same when defined
	        if (fn.signatures && fn.name !== '') {
	          if (name === '') {
	            name = fn.name;
	          }
	          else if (name !== fn.name) {
	            var err = new Error('Function names do not match (expected: ' + name + ', actual: ' + fn.name + ')');
	            err.data = {
	              actual: fn.name,
	              expected: name
	            };
	            throw err;
	          }
	        }
	      }
	
	      return name;
	    }
	
	    typed = createTypedFunction('typed', {
	      'string, Object': createTypedFunction,
	      'Object': function (signaturesMap) {
	        // find existing name
	        var fns = [];
	        for (var signature in signaturesMap) {
	          if (signaturesMap.hasOwnProperty(signature)) {
	            fns.push(signaturesMap[signature]);
	          }
	        }
	        var name = getName(fns);
	        return createTypedFunction(name, signaturesMap);
	      },
	      '...Function': function (fns) {
	        var err;
	        var name = getName(fns);
	        var signaturesMap = {};
	
	        for (var i = 0; i < fns.length; i++) {
	          var fn = fns[i];
	
	          // test whether this is a typed-function
	          if (!(typeof fn.signatures === 'object')) {
	            err = new TypeError('Function is no typed-function (index: ' + i + ')');
	            err.data = {index: i};
	            throw err;
	          }
	
	          // merge the signatures
	          for (var signature in fn.signatures) {
	            if (fn.signatures.hasOwnProperty(signature)) {
	              if (signaturesMap.hasOwnProperty(signature)) {
	                if (fn.signatures[signature] !== signaturesMap[signature]) {
	                  err = new Error('Signature "' + signature + '" is defined twice');
	                  err.data = {signature: signature};
	                  throw err;
	                }
	                // else: both signatures point to the same function, that's fine
	              }
	              else {
	                signaturesMap[signature] = fn.signatures[signature];
	              }
	            }
	          }
	        }
	
	        return createTypedFunction(name, signaturesMap);
	      }
	    });
	
	    typed.create = create;
	    typed.types = _types;
	    typed.conversions = _conversions;
	    typed.ignore = _ignore;
	    typed.convert = convert;
	    typed.find = find;
	
	    // add a type
	    typed.addType = function (type) {
	      if (!type || typeof type.name !== 'string' || typeof type.test !== 'function') {
	        throw new TypeError('Object with properties {name: string, test: function} expected');
	      }
	
	      typed.types.push(type);
	    };
	
	    // add a conversion
	    typed.addConversion = function (conversion) {
	      if (!conversion
	          || typeof conversion.from !== 'string'
	          || typeof conversion.to !== 'string'
	          || typeof conversion.convert !== 'function') {
	        throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');
	      }
	
	      typed.conversions.push(conversion);
	    };
	
	    return typed;
	  }
	
	  return create();
	}));

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var objectUtils = __webpack_require__(1320);
	
	/**
	 * @typedef {{sign: '+' | '-' | '', coefficients: number[], exponent: number}} SplitValue
	 */
	
	/**
	 * Test whether value is a number
	 * @param {*} value
	 * @return {boolean} isNumber
	 */
	exports.isNumber = function(value) {
	  return typeof value === 'number';
	};
	
	/**
	 * Check if a number is integer
	 * @param {number | boolean} value
	 * @return {boolean} isInteger
	 */
	exports.isInteger = function(value) {
	  return isFinite(value)
	      ? (value == Math.round(value))
	      : false;
	  // Note: we use ==, not ===, as we can have Booleans as well
	};
	
	/**
	 * Calculate the sign of a number
	 * @param {number} x
	 * @returns {*}
	 */
	exports.sign = Math.sign || function(x) {
	  if (x > 0) {
	    return 1;
	  }
	  else if (x < 0) {
	    return -1;
	  }
	  else {
	    return 0;
	  }
	};
	
	/**
	 * Convert a number to a formatted string representation.
	 *
	 * Syntax:
	 *
	 *    format(value)
	 *    format(value, options)
	 *    format(value, precision)
	 *    format(value, fn)
	 *
	 * Where:
	 *
	 *    {number} value   The value to be formatted
	 *    {Object} options An object with formatting options. Available options:
	 *                     {string} notation
	 *                         Number notation. Choose from:
	 *                         'fixed'          Always use regular number notation.
	 *                                          For example '123.40' and '14000000'
	 *                         'exponential'    Always use exponential notation.
	 *                                          For example '1.234e+2' and '1.4e+7'
	 *                         'engineering'    Always use engineering notation.
	 *                                          For example '123.4e+0' and '14.0e+6'
	 *                         'auto' (default) Regular number notation for numbers
	 *                                          having an absolute value between
	 *                                          `lowerExp` and `upperExp` bounds, and 
	 *                                          uses exponential notation elsewhere.
	 *                                          Lower bound is included, upper bound
	 *                                          is excluded.
	 *                                          For example '123.4' and '1.4e7'.
	 *                     {number} precision   A number between 0 and 16 to round
	 *                                          the digits of the number.
	 *                                          In case of notations 'exponential' and
	 *                                          'auto', `precision` defines the total
	 *                                          number of significant digits returned.
	 *                                          In case of notation 'fixed',
	 *                                          `precision` defines the number of
	 *                                          significant digits after the decimal 
	 *                                          point.
	 *                                          `precision` is undefined by default,
	 *                                          not rounding any digits.
	 *                     {number} lowerExp    Exponent determining the lower boundary
	 *                                          for formatting a value with an exponent
	 *                                          when `notation='auto`. 
	 *                                          Default value is `-3`.
	 *                     {number} upperExp    Exponent determining the upper boundary
	 *                                          for formatting a value with an exponent
	 *                                          when `notation='auto`. 
	 *                                          Default value is `5`.
	 *    {Function} fn    A custom formatting function. Can be used to override the
	 *                     built-in notations. Function `fn` is called with `value` as
	 *                     parameter and must return a string. Is useful for example to
	 *                     format all values inside a matrix in a particular way.
	 *
	 * Examples:
	 *
	 *    format(6.4);                                        // '6.4'
	 *    format(1240000);                                    // '1.24e6'
	 *    format(1/3);                                        // '0.3333333333333333'
	 *    format(1/3, 3);                                     // '0.333'
	 *    format(21385, 2);                                   // '21000'
	 *    format(12.071, {notation: 'fixed'});                // '12'
	 *    format(2.3,    {notation: 'fixed', precision: 2});  // '2.30'
	 *    format(52.8,   {notation: 'exponential'});          // '5.28e+1'
	 *    format(12345678, {notation: 'engineering'});        // '12.345678e+6'
	 *
	 * @param {number} value
	 * @param {Object | Function | number} [options]
	 * @return {string} str The formatted value
	 */
	exports.format = function(value, options) {
	  if (typeof options === 'function') {
	    // handle format(value, fn)
	    return options(value);
	  }
	
	  // handle special cases
	  if (value === Infinity) {
	    return 'Infinity';
	  }
	  else if (value === -Infinity) {
	    return '-Infinity';
	  }
	  else if (isNaN(value)) {
	    return 'NaN';
	  }
	
	  // default values for options
	  var notation = 'auto';
	  var precision = undefined;
	
	  if (options) {
	    // determine notation from options
	    if (options.notation) {
	      notation = options.notation;
	    }
	
	    // determine precision from options
	    if (exports.isNumber(options)) {
	      precision = options;
	    }
	    else if (options.precision) {
	      precision = options.precision;
	    }
	  }
	
	  // handle the various notations
	  switch (notation) {
	    case 'fixed':
	      return exports.toFixed(value, precision);
	
	    case 'exponential':
	      return exports.toExponential(value, precision);
	
	    case 'engineering':
	      return exports.toEngineering(value, precision);
	
	    case 'auto':
	      // TODO: clean up some day. Deprecated since: 2018-01-24
	      // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
	      if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
	        var fixedOptions = objectUtils.map(options, function(x) { return x; });
	        fixedOptions.exponential = undefined;
	        if (options.exponential.lower !== undefined) {
	          fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
	        }
	        if (options.exponential.upper !== undefined) {
	          fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
	        }
	
	        console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + 
	            '(minimum and maximum value) ' +
	            'are replaced with exponential.lowerExp and exponential.upperExp ' + 
	            '(minimum and maximum exponent) since version 4.0.0. ' + 
	            'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));
	
	        return exports.toPrecision(value, precision, fixedOptions);
	      }
	
	      return exports
	          .toPrecision(value, precision, options && options)
	
	          // remove trailing zeros after the decimal point
	          .replace(/((\.\d*?)(0+))($|e)/, function () {
	            var digits = arguments[2];
	            var e = arguments[4];
	            return (digits !== '.') ? digits + e : e;
	          });
	
	    default:
	      throw new Error('Unknown notation "' + notation + '". ' +
	          'Choose "auto", "exponential", or "fixed".');
	  }
	};
	
	/**
	 * Split a number into sign, coefficients, and exponent
	 * @param {number | string} value
	 * @return {SplitValue}
	 *              Returns an object containing sign, coefficients, and exponent
	 */
	exports.splitNumber = function (value) {
	  // parse the input value
	  var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
	  if (!match) {
	    throw new SyntaxError('Invalid number ' + value);
	  }
	
	  var sign         = match[1];
	  var digits       = match[2];
	  var exponent     = parseFloat(match[4] || '0');
	
	  var dot = digits.indexOf('.');
	  exponent += (dot !== -1) ? (dot - 1) : (digits.length - 1);
	
	  var coefficients = digits
	      .replace('.', '')  // remove the dot (must be removed before removing leading zeros)
	      .replace(/^0*/, function (zeros) {
	        // remove leading zeros, add their count to the exponent
	        exponent -= zeros.length;
	        return '';
	      })
	      .replace(/0*$/, '') // remove trailing zeros
	      .split('')
	      .map(function (d) {
	        return parseInt(d);
	      });
	
	  if (coefficients.length === 0) {
	    coefficients.push(0);
	    exponent++;
	  }
	
	  return {
	    sign: sign,
	    coefficients: coefficients,
	    exponent: exponent
	  };
	};
	
	
	/**
	 * Format a number in engineering notation. Like '1.23e+6', '2.3e+0', '3.500e-3'
	 * @param {number | string} value
	 * @param {number} [precision=0]        Optional number of decimals after the
	 *                                      decimal point. Zero by default.
	 */
	exports.toEngineering = function (value, precision) {
	  if (isNaN(value) || !isFinite(value)) {
	    return String(value);
	  }
	  
	  var rounded = exports.roundDigits(exports.splitNumber(value), precision);
	
	  var e = rounded.exponent;
	  var c = rounded.coefficients;
	
	  // find nearest lower multiple of 3 for exponent
	  var newExp = e % 3 === 0 ? e : (e < 0 ? (e - 3) - (e % 3) : e - (e % 3));
	
	  // concatenate coefficients with necessary zeros
	  var significandsDiff = e >= 0 ? e : Math.abs(newExp);
	
	  // add zeros if necessary (for ex: 1e+8)
	  if (c.length - 1 < significandsDiff) c = c.concat(zeros(significandsDiff - (c.length - 1)));
	
	  // find difference in exponents
	  var expDiff = Math.abs(e - newExp);
	
	  var decimalIdx = 1;
	
	  // push decimal index over by expDiff times
	  while (--expDiff >= 0) decimalIdx++;
	
	  // if all coefficient values are zero after the decimal point, don't add a decimal value.
	  // otherwise concat with the rest of the coefficients
	  var decimals = c.slice(decimalIdx).join('');
	  var decimalVal = decimals.match(/[1-9]/) ? ('.' + decimals) : '';
	
	  var str = c.slice(0, decimalIdx).join('') +
	      decimalVal +
	      'e' + (e >= 0 ? '+' : '') + newExp.toString();
	  return rounded.sign + str;
	};
	
	/**
	 * Format a number with fixed notation.
	 * @param {number | string} value
	 * @param {number} [precision=undefined]  Optional number of decimals after the
	 *                                        decimal point. null by default.
	 */
	exports.toFixed = function (value, precision) {
	  if (isNaN(value) || !isFinite(value)) {
	    return String(value);
	  }
	
	  var splitValue = exports.splitNumber(value)
	  var rounded = (typeof precision === 'number')
	      ? exports.roundDigits(splitValue, splitValue.exponent + 1 + precision)
	      : splitValue;
	  var c = rounded.coefficients;
	  var p = rounded.exponent + 1; // exponent may have changed
	
	  // append zeros if needed
	  var pp = p + (precision || 0);
	  if (c.length < pp) {
	    c = c.concat(zeros(pp - c.length));
	  }
	
	  // prepend zeros if needed
	  if (p < 0) {
	    c = zeros(-p + 1).concat(c);
	    p = 1;
	  }
	
	  // insert a dot if needed
	  if (p < c.length) {
	    c.splice(p, 0, (p === 0) ? '0.' : '.');
	  }
	
	  return rounded.sign + c.join('');
	};
	
	/**
	 * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
	 * @param {number | string} value
	 * @param {number} [precision]  Number of digits in formatted output.
	 *                              If not provided, the maximum available digits
	 *                              is used.
	 */
	exports.toExponential = function (value, precision) {
	  if (isNaN(value) || !isFinite(value)) {
	    return String(value);
	  }
	
	  // round if needed, else create a clone
	  var split = exports.splitNumber(value)
	  var rounded = precision ? exports.roundDigits(split, precision) : split;
	  var c = rounded.coefficients;
	  var e = rounded.exponent;
	
	  // append zeros if needed
	  if (c.length < precision) {
	    c = c.concat(zeros(precision - c.length));
	  }
	
	  // format as `C.CCCe+EEE` or `C.CCCe-EEE`
	  var first = c.shift();
	  return rounded.sign + first + (c.length > 0 ? ('.' + c.join('')) : '') +
	      'e' + (e >= 0 ? '+' : '') + e;
	}
	
	/**
	 * Format a number with a certain precision
	 * @param {number | string} value
	 * @param {number} [precision=undefined] Optional number of digits.
	 * @param {{lowerExp: number | undefined, upperExp: number | undefined}} [options]
	 *                                       By default:
	 *                                         lowerExp = -3 (incl)
	 *                                         upper = +5 (excl)
	 * @return {string}
	 */
	exports.toPrecision = function (value, precision, options) {
	  if (isNaN(value) || !isFinite(value)) {
	    return String(value);
	  }
	
	  // determine lower and upper bound for exponential notation.
	  var lowerExp = (options && options.lowerExp !== undefined) ? options.lowerExp : -3;
	  var upperExp = (options && options.upperExp !== undefined) ? options.upperExp : 5;
	
	  var split = exports.splitNumber(value)
	  if (split.exponent < lowerExp || split.exponent >= upperExp) {
	    // exponential notation
	    return exports.toExponential(value, precision);
	  }
	  else {
	    var rounded = precision ? exports.roundDigits(split, precision) : split;
	    var c = rounded.coefficients;
	    var e = rounded.exponent;
	
	    // append trailing zeros
	    if (c.length < precision) {
	      c = c.concat(zeros(precision - c.length));
	    }
	
	    // append trailing zeros
	    // TODO: simplify the next statement
	    c = c.concat(zeros(e - c.length + 1 +
	        (c.length < precision ? precision - c.length : 0)));
	
	    // prepend zeros
	    c = zeros(-e).concat(c);
	
	    var dot = e > 0 ? e : 0;
	    if (dot < c.length - 1) {
	      c.splice(dot + 1, 0, '.');
	    }
	
	    return rounded.sign + c.join('');
	  }
	}
	
	/**
	 * Round the number of digits of a number *
	 * @param {SplitValue} split       A value split with .splitNumber(value)
	 * @param {number} precision  A positive integer
	 * @return {SplitValue}
	 *              Returns an object containing sign, coefficients, and exponent
	 *              with rounded digits
	 */
	exports.roundDigits = function (split, precision) {
	  // create a clone
	  var rounded = {
	    sign: split.sign,
	    coefficients: split.coefficients,
	    exponent: split.exponent
	  }
	  var c = rounded.coefficients;
	
	  // prepend zeros if needed
	  while (precision <= 0) {
	    c.unshift(0);
	    rounded.exponent++;
	    precision++;
	  }
	
	  if (c.length > precision) {
	    var removed = c.splice(precision, c.length - precision);
	
	    if (removed[0] >= 5) {
	      var i = precision - 1;
	      c[i]++;
	      while (c[i] === 10) {
	        c.pop();
	        if (i === 0) {
	          c.unshift(0);
	          rounded.exponent++;
	          i++;
	        }
	        i--;
	        c[i]++;
	      }
	    }
	  }
	
	  return rounded;
	};
	
	/**
	 * Create an array filled with zeros.
	 * @param {number} length
	 * @return {Array}
	 */
	function zeros(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(0);
	  }
	  return arr;
	}
	
	/**
	 * Count the number of significant digits of a number.
	 *
	 * For example:
	 *   2.34 returns 3
	 *   0.0034 returns 2
	 *   120.5e+30 returns 4
	 *
	 * @param {number} value
	 * @return {number} digits   Number of significant digits
	 */
	exports.digits = function(value) {
	  return value
	      .toExponential()
	      .replace(/e.*$/, '')          // remove exponential notation
	      .replace( /^0\.?0*|\./, '')   // remove decimal point and leading zeros
	      .length
	};
	
	/**
	 * Minimum number added to one that makes the result different than one
	 */
	exports.DBL_EPSILON = Number.EPSILON || 2.2204460492503130808472633361816E-16;
	
	/**
	 * Compares two floating point numbers.
	 * @param {number} x          First value to compare
	 * @param {number} y          Second value to compare
	 * @param {number} [epsilon]  The maximum relative difference between x and y
	 *                            If epsilon is undefined or null, the function will
	 *                            test whether x and y are exactly equal.
	 * @return {boolean} whether the two numbers are nearly equal
	*/
	exports.nearlyEqual = function(x, y, epsilon) {
	  // if epsilon is null or undefined, test whether x and y are exactly equal
	  if (epsilon == null) {
	    return x == y;
	  }
	
	  // use "==" operator, handles infinities
	  if (x == y) {
	    return true;
	  }
	
	  // NaN
	  if (isNaN(x) || isNaN(y)) {
	    return false;
	  }
	
	  // at this point x and y should be finite
	  if(isFinite(x) && isFinite(y)) {
	    // check numbers are very close, needed when comparing numbers near zero
	    var diff = Math.abs(x - y);
	    if (diff < exports.DBL_EPSILON) {
	      return true;
	    }
	    else {
	      // use relative error
	      return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
	    }
	  }
	
	  // Infinite and Number or negative Infinite and positive Infinite cases
	  return false;
	};


/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Test whether a value is a Matrix
	 * @param {*} x
	 * @returns {boolean} returns true with input is a Matrix
	 *                    (like a DenseMatrix or SparseMatrix)
	 */
	module.exports = function isMatrix (x) {
	  return x && x.constructor.prototype.isMatrix || false;
	};


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Emitter = __webpack_require__(1327);
	
	/**
	 * Extend given object with emitter functions `on`, `off`, `once`, `emit`
	 * @param {Object} obj
	 * @return {Object} obj
	 */
	exports.mixin = function (obj) {
	  // create event emitter
	  var emitter = new Emitter();
	
	  // bind methods to obj (we don't want to expose the emitter.e Array...)
	  obj.on   = emitter.on.bind(emitter);
	  obj.off  = emitter.off.bind(emitter);
	  obj.once = emitter.once.bind(emitter);
	  obj.emit = emitter.emit.bind(emitter);
	
	  return obj;
	};


/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var lazy = __webpack_require__(1320).lazy;
	var isFactory = __webpack_require__(1320).isFactory;
	var traverse = __webpack_require__(1320).traverse;
	var ArgumentsError = __webpack_require__(1329);
	
	function factory (type, config, load, typed, math) {
	  /**
	   * Import functions from an object or a module
	   *
	   * Syntax:
	   *
	   *    math.import(object)
	   *    math.import(object, options)
	   *
	   * Where:
	   *
	   * - `object: Object`
	   *   An object with functions to be imported.
	   * - `options: Object` An object with import options. Available options:
	   *   - `override: boolean`
	   *     If true, existing functions will be overwritten. False by default.
	   *   - `silent: boolean`
	   *     If true, the function will not throw errors on duplicates or invalid
	   *     types. False by default.
	   *   - `wrap: boolean`
	   *     If true, the functions will be wrapped in a wrapper function
	   *     which converts data types like Matrix to primitive data types like Array.
	   *     The wrapper is needed when extending math.js with libraries which do not
	   *     support these data type. False by default.
	   *
	   * Examples:
	   *
	   *    // define new functions and variables
	   *    math.import({
	   *      myvalue: 42,
	   *      hello: function (name) {
	   *        return 'hello, ' + name + '!';
	   *      }
	   *    });
	   *
	   *    // use the imported function and variable
	   *    math.myvalue * 2;               // 84
	   *    math.hello('user');             // 'hello, user!'
	   *
	   *    // import the npm module 'numbers'
	   *    // (must be installed first with `npm install numbers`)
	   *    math.import(require('numbers'), {wrap: true});
	   *
	   *    math.fibonacci(7); // returns 13
	   *
	   * @param {Object | Array} object   Object with functions to be imported.
	   * @param {Object} [options]        Import options.
	   */
	  function math_import(object, options) {
	    var num = arguments.length;
	    if (num !== 1 && num !== 2) {
	      throw new ArgumentsError('import', num, 1, 2);
	    }
	
	    if (!options) {
	      options = {};
	    }
	
	    if (isFactory(object)) {
	      _importFactory(object, options);
	    }
	    // TODO: allow a typed-function with name too
	    else if (Array.isArray(object)) {
	      object.forEach(function (entry) {
	        math_import(entry, options);
	      });
	    }
	    else if (typeof object === 'object') {
	      // a map with functions
	      for (var name in object) {
	        if (object.hasOwnProperty(name)) {
	          var value = object[name];
	          if (isSupportedType(value)) {
	            _import(name, value, options);
	          }
	          else if (isFactory(object)) {
	            _importFactory(object, options);
	          }
	          else {
	            math_import(value, options);
	          }
	        }
	      }
	    }
	    else {
	      if (!options.silent) {
	        throw new TypeError('Factory, Object, or Array expected');
	      }
	    }
	  }
	
	  /**
	   * Add a property to the math namespace and create a chain proxy for it.
	   * @param {string} name
	   * @param {*} value
	   * @param {Object} options  See import for a description of the options
	   * @private
	   */
	  function _import(name, value, options) {
	    // TODO: refactor this function, it's to complicated and contains duplicate code
	    if (options.wrap && typeof value === 'function') {
	      // create a wrapper around the function
	      value = _wrap(value);
	    }
	
	    if (isTypedFunction(math[name]) && isTypedFunction(value)) {
	      if (options.override) {
	        // give the typed function the right name
	        value = typed(name, value.signatures);
	      }
	      else {
	        // merge the existing and typed function
	        value = typed(math[name], value);
	      }
	
	      math[name] = value;
	      _importTransform(name, value);
	      math.emit('import', name, function resolver() {
	        return value;
	      });
	      return;
	    }
	
	    if (math[name] === undefined || options.override) {
	      math[name] = value;
	      _importTransform(name, value);
	      math.emit('import', name, function resolver() {
	        return value;
	      });
	      return;
	    }
	
	    if (!options.silent) {
	      throw new Error('Cannot import "' + name + '": already exists');
	    }
	  }
	
	  function _importTransform (name, value) {
	    if (value && typeof value.transform === 'function') {
	      math.expression.transform[name] = value.transform;
	      if (allowedInExpressions(name)) {
	        math.expression.mathWithTransform[name] = value.transform
	      }
	    }
	    else {
	      // remove existing transform
	      delete math.expression.transform[name]
	      if (allowedInExpressions(name)) {
	        math.expression.mathWithTransform[name] = value
	      }
	    }
	  }
	
	  /**
	   * Create a wrapper a round an function which converts the arguments
	   * to their primitive values (like convert a Matrix to Array)
	   * @param {Function} fn
	   * @return {Function} Returns the wrapped function
	   * @private
	   */
	  function _wrap (fn) {
	    var wrapper = function wrapper () {
	      var args = [];
	      for (var i = 0, len = arguments.length; i < len; i++) {
	        var arg = arguments[i];
	        args[i] = arg && arg.valueOf();
	      }
	      return fn.apply(math, args);
	    };
	
	    if (fn.transform) {
	      wrapper.transform = fn.transform;
	    }
	
	    return wrapper;
	  }
	
	  /**
	   * Import an instance of a factory into math.js
	   * @param {{factory: Function, name: string, path: string, math: boolean}} factory
	   * @param {Object} options  See import for a description of the options
	   * @private
	   */
	  function _importFactory(factory, options) {
	    if (typeof factory.name === 'string') {
	      var name = factory.name;
	      var existingTransform = name in math.expression.transform
	      var namespace = factory.path ? traverse(math, factory.path) : math;
	      var existing = namespace.hasOwnProperty(name) ? namespace[name] : undefined;
	
	      var resolver = function () {
	        var instance = load(factory);
	        if (instance && typeof instance.transform === 'function') {
	          throw new Error('Transforms cannot be attached to factory functions. ' +
	              'Please create a separate function for it with exports.path="expression.transform"');
	        }
	
	        if (isTypedFunction(existing) && isTypedFunction(instance)) {
	          if (options.override) {
	            // replace the existing typed function (nothing to do)
	          }
	          else {
	            // merge the existing and new typed function
	            instance = typed(existing, instance);
	          }
	
	          return instance;
	        }
	
	        if (existing === undefined || options.override) {
	          return instance;
	        }
	
	        if (!options.silent) {
	          throw new Error('Cannot import "' + name + '": already exists');
	        }
	      };
	
	      if (factory.lazy !== false) {
	        lazy(namespace, name, resolver);
	
	        if (!existingTransform) {
	          if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
	            lazy(math.expression.mathWithTransform, name, resolver);
	          }
	        }
	      }
	      else {
	        namespace[name] = resolver();
	
	        if (!existingTransform) {
	          if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
	            math.expression.mathWithTransform[name] = resolver();
	          }
	        }
	      }
	
	      math.emit('import', name, resolver, factory.path);
	    }
	    else {
	      // unnamed factory.
	      // no lazy loading
	      load(factory);
	    }
	  }
	
	  /**
	   * Check whether given object is a type which can be imported
	   * @param {Function | number | string | boolean | null | Unit | Complex} object
	   * @return {boolean}
	   * @private
	   */
	  function isSupportedType(object) {
	    return typeof object === 'function'
	        || typeof object === 'number'
	        || typeof object === 'string'
	        || typeof object === 'boolean'
	        || object === null
	        || (object && type.isUnit(object))
	        || (object && type.isComplex(object))
	        || (object && type.isBigNumber(object))
	        || (object && type.isFraction(object))
	        || (object && type.isMatrix(object))
	        || (object && Array.isArray(object))
	  }
	
	  /**
	   * Test whether a given thing is a typed-function
	   * @param {*} fn
	   * @return {boolean} Returns true when `fn` is a typed-function
	   */
	  function isTypedFunction (fn) {
	    return typeof fn === 'function' && typeof fn.signatures === 'object';
	  }
	
	  function allowedInExpressions (name) {
	    return !unsafe.hasOwnProperty(name);
	  }
	
	  function factoryAllowedInExpressions (factory) {
	    return factory.path === undefined && !unsafe.hasOwnProperty(factory.name);
	  }
	
	  // namespaces and functions not available in the parser for safety reasons
	  var unsafe = {
	    'expression': true,
	    'type': true,
	    'docs': true,
	    'error': true,
	    'json': true,
	    'chain': true // chain method not supported. Note that there is a unit chain too.
	  };
	
	  return math_import;
	}
	
	exports.math = true; // request access to the math namespace as 5th argument of the factory function
	exports.name = 'import';
	exports.factory = factory;
	exports.lazy = true;


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Create a syntax error with the message:
	 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
	 * @param {string} fn     Function name
	 * @param {number} count  Actual argument count
	 * @param {number} min    Minimum required argument count
	 * @param {number} [max]  Maximum required argument count
	 * @extends Error
	 */
	function ArgumentsError(fn, count, min, max) {
	  if (!(this instanceof ArgumentsError)) {
	    throw new SyntaxError('Constructor must be called with the new operator');
	  }
	
	  this.fn = fn;
	  this.count = count;
	  this.min = min;
	  this.max = max;
	
	  this.message = 'Wrong number of arguments in function ' + fn +
	      ' (' + count + ' provided, ' +
	      min + ((max != undefined) ? ('-' + max) : '') + ' expected)';
	
	  this.stack = (new Error()).stack;
	}
	
	ArgumentsError.prototype = new Error();
	ArgumentsError.prototype.constructor = Error;
	ArgumentsError.prototype.name = 'ArgumentsError';
	ArgumentsError.prototype.isArgumentsError = true;
	
	module.exports = ArgumentsError;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object = __webpack_require__(1320);
	
	function factory (type, config, load, typed, math) {
	  var MATRIX = ['Matrix', 'Array'];                   // valid values for option matrix
	  var NUMBER = ['number', 'BigNumber', 'Fraction'];   // valid values for option number
	
	  /**
	   * Set configuration options for math.js, and get current options.
	   * Will emit a 'config' event, with arguments (curr, prev, changes).
	   *
	   * Syntax:
	   *
	   *     math.config(config: Object): Object
	   *
	   * Examples:
	   *
	   *     math.config().number;                // outputs 'number'
	   *     math.eval('0.4');                    // outputs number 0.4
	   *     math.config({number: 'Fraction'});
	   *     math.eval('0.4');                    // outputs Fraction 2/5
	   *
	   * @param {Object} [options] Available options:
	   *                            {number} epsilon
	   *                              Minimum relative difference between two
	   *                              compared values, used by all comparison functions.
	   *                            {string} matrix
	   *                              A string 'Matrix' (default) or 'Array'.
	   *                            {string} number
	   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
	   *                            {number} precision
	   *                              The number of significant digits for BigNumbers.
	   *                              Not applicable for Numbers.
	   *                            {string} parenthesis
	   *                              How to display parentheses in LaTeX and string
	   *                              output.
	   *                            {string} randomSeed
	   *                              Random seed for seeded pseudo random number generator.
	   *                              Set to null to randomly seed.
	   * @return {Object} Returns the current configuration
	   */
	  function _config(options) {
	    if (options) {
	      var prev = object.map(config, object.clone);
	
	      // validate some of the options
	      validateOption(options, 'matrix', MATRIX);
	      validateOption(options, 'number', NUMBER);
	
	      // merge options
	      object.deepExtend(config, options);
	
	      var curr = object.map(config, object.clone);
	
	      var changes = object.map(options, object.clone);
	
	      // emit 'config' event
	      math.emit('config', curr, prev, changes);
	
	      return curr;
	    }
	    else {
	      return object.map(config, object.clone);
	    }
	  }
	
	  // attach the valid options to the function so they can be extended
	  _config.MATRIX = MATRIX;
	  _config.NUMBER = NUMBER;
	
	  return _config;
	}
	
	/**
	 * Test whether an Array contains a specific item.
	 * @param {Array.<string>} array
	 * @param {string} item
	 * @return {boolean}
	 */
	function contains (array, item) {
	  return array.indexOf(item) !== -1;
	}
	
	/**
	 * Find a string in an array. Case insensitive search
	 * @param {Array.<string>} array
	 * @param {string} item
	 * @return {number} Returns the index when found. Returns -1 when not found
	 */
	function findIndex (array, item) {
	  return array
	      .map(function (i) {
	        return i.toLowerCase();
	      })
	      .indexOf(item.toLowerCase());
	}
	
	/**
	 * Validate an option
	 * @param {Object} options         Object with options
	 * @param {string} name            Name of the option to validate
	 * @param {Array.<string>} values  Array with valid values for this option
	 */
	function validateOption(options, name, values) {
	  if (options[name] !== undefined && !contains(values, options[name])) {
	    var index = findIndex(values, options[name]);
	    if (index !== -1) {
	      // right value, wrong casing
	      // TODO: lower case values are deprecated since v3, remove this warning some day.
	      console.warn('Warning: Wrong casing for configuration option "' + name + '", should be "' + values[index] + '" instead of "' + options[name] + '".');
	
	      options[name] = values[index]; // change the option to the right casing
	    }
	    else {
	      // unknown value
	      console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". Available options: ' + values.map(JSON.stringify).join(', ') + '.');
	    }
	  }
	}
	
	exports.name = 'config';
	exports.math = true; // request the math namespace as fifth argument
	exports.factory = factory;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1332),        // data types (Matrix, Complex, Unit, ...)
	  __webpack_require__(1414),   // constants
	  __webpack_require__(1416),  // expression parsing
	  __webpack_require__(1679),    // functions
	  __webpack_require__(1878),        // serialization utility (math.json.reviver)
	  __webpack_require__(1880)        // errors
	];


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1333),
	  __webpack_require__(1338),
	  __webpack_require__(1339),
	  __webpack_require__(1344),
	  __webpack_require__(1350),
	  __webpack_require__(1354),
	  __webpack_require__(1386),
	  __webpack_require__(1387),
	  __webpack_require__(1389),
	  __webpack_require__(1390)
	];


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1334),
	
	  // construction function
	  __webpack_require__(1336)
	];


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Decimal = __webpack_require__(1335); // make sure to pick the es5 version
	
	function factory (type, config, load, typed, math) {
	  var BigNumber = Decimal.clone({precision: config.precision});
	
	  /**
	   * Attach type information
	   */
	  BigNumber.prototype.type = 'BigNumber';
	  BigNumber.prototype.isBigNumber = true;
	
	  /**
	   * Get a JSON representation of a BigNumber containing
	   * type information
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
	   */
	  BigNumber.prototype.toJSON = function () {
	    return {
	      mathjs: 'BigNumber',
	      value: this.toString()
	    };
	  };
	
	  /**
	   * Instantiate a BigNumber from a JSON object
	   * @param {Object} json  a JSON object structured as:
	   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
	   * @return {BigNumber}
	   */
	  BigNumber.fromJSON = function (json) {
	    return new BigNumber(json.value);
	  };
	
	  // listen for changed in the configuration, automatically apply changed precision
	  math.on('config', function (curr, prev) {
	    if (curr.precision !== prev.precision) {
	      BigNumber.config({ precision: curr.precision });
	    }
	  });
	
	  return BigNumber;
	}
	
	exports.name = 'BigNumber';
	exports.path = 'type';
	exports.factory = factory;
	exports.math = true; // request access to the math namespace


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js v9.0.1 https://github.com/MikeMcl/decimal.js/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js v9.0.1
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js
	   *  Copyright (c) 2017 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The maximum exponent magnitude.
	    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
	  var EXP_LIMIT = 9e15,                      // 0 to 9e15
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	    MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	    // Base conversion alphabet.
	    NUMERALS = '0123456789abcdef',
	
	    // The natural logarithm of 10 (1025 digits).
	    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058',
	
	    // Pi (1025 digits).
	    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789',
	
	
	    // The initial configuration properties of the Decimal constructor.
	    DEFAULTS = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed at run-time using the `Decimal.config` method.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used when rounding to `precision`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The modulo mode used when calculating the modulus: a mod n.
	      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
	      // The remainder (r) is calculated as: r = a - n * q.
	      //
	      // UP         0 The remainder is positive if the dividend is negative, else is negative.
	      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
	      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
	      // HALF_EVEN  6 The IEEE 754 remainder function.
	      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
	      //
	      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
	      // division (9) are commonly used for the modulus operation. The other rounding modes can also
	      // be used, but they may not give useful results.
	      modulo: 1,                             // 0 to 9
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -EXP_LIMIT
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to EXP_LIMIT
	
	      // The minimum exponent value, beneath which underflow to zero occurs.
	      // JavaScript numbers: -324  (5e-324)
	      minE: -EXP_LIMIT,                      // -1 to -EXP_LIMIT
	
	      // The maximum exponent value, above which overflow to Infinity occurs.
	      // JavaScript numbers: 308  (1.7976931348623157e+308)
	      maxE: EXP_LIMIT,                       // 1 to EXP_LIMIT
	
	      // Whether to use cryptographically-secure random number generation, if available.
	      crypto: false                          // true/false
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    Decimal, inexact, noConflict, quadrant,
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    precisionLimitExceeded = decimalError + 'Precision limit exceeded',
	    cryptoUnavailable = decimalError + 'crypto unavailable',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
	    isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
	    isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	
	    LN10_PRECISION = LN10.length - 1,
	    PI_PRECISION = PI.length - 1,
	
	    // Decimal.prototype object
	    P = { name: '[object Decimal]' };
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue             abs
	   *  ceil
	   *  comparedTo                cmp
	   *  cosine                    cos
	   *  cubeRoot                  cbrt
	   *  decimalPlaces             dp
	   *  dividedBy                 div
	   *  dividedToIntegerBy        divToInt
	   *  equals                    eq
	   *  floor
	   *  greaterThan               gt
	   *  greaterThanOrEqualTo      gte
	   *  hyperbolicCosine          cosh
	   *  hyperbolicSine            sinh
	   *  hyperbolicTangent         tanh
	   *  inverseCosine             acos
	   *  inverseHyperbolicCosine   acosh
	   *  inverseHyperbolicSine     asinh
	   *  inverseHyperbolicTangent  atanh
	   *  inverseSine               asin
	   *  inverseTangent            atan
	   *  isFinite
	   *  isInteger                 isInt
	   *  isNaN
	   *  isNegative                isNeg
	   *  isPositive                isPos
	   *  isZero
	   *  lessThan                  lt
	   *  lessThanOrEqualTo         lte
	   *  logarithm                 log
	   *  [maximum]                 [max]
	   *  [minimum]                 [min]
	   *  minus                     sub
	   *  modulo                    mod
	   *  naturalExponential        exp
	   *  naturalLogarithm          ln
	   *  negated                   neg
	   *  plus                      add
	   *  precision                 sd
	   *  round
	   *  sine                      sin
	   *  squareRoot                sqrt
	   *  tangent                   tan
	   *  times                     mul
	   *  toBinary
	   *  toDecimalPlaces           toDP
	   *  toExponential
	   *  toFixed
	   *  toFraction
	   *  toHexadecimal             toHex
	   *  toNearest
	   *  toNumber
	   *  toOctal
	   *  toPower                   pow
	   *  toPrecision
	   *  toSignificantDigits       toSD
	   *  toString
	   *  truncated                 trunc
	   *  valueOf                   toJSON
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s < 0) x.s = 1;
	    return finalise(x);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
	   * direction of positive Infinity.
	   *
	   */
	  P.ceil = function () {
	    return finalise(new this.constructor(this), this.e + 1, 2);
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value,
	   *   NaN  if the value of either Decimal is NaN.
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this,
	      xd = x.d,
	      yd = (y = new x.constructor(y)).d,
	      xs = x.s,
	      ys = y.s;
	
	    // Either NaN or ±Infinity?
	    if (!xd || !yd) {
	      return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
	    }
	
	    // Either zero?
	    if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
	
	    // Signs differ?
	    if (xs !== ys) return xs;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
	
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * cos(0)         = 1
	   * cos(-0)        = 1
	   * cos(Infinity)  = NaN
	   * cos(-Infinity) = NaN
	   * cos(NaN)       = NaN
	   *
	   */
	  P.cosine = P.cos = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.d) return new Ctor(NaN);
	
	    // cos(0) = cos(-0) = 1
	    if (!x.d[0]) return new Ctor(1);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
	    Ctor.rounding = 1;
	
	    x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   *
	   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   *  cbrt(0)  =  0
	   *  cbrt(-0) = -0
	   *  cbrt(1)  =  1
	   *  cbrt(-1) = -1
	   *  cbrt(N)  =  N
	   *  cbrt(-I) = -I
	   *  cbrt(I)  =  I
	   *
	   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
	   *
	   */
	  P.cubeRoot = P.cbrt = function () {
	    var e, m, n, r, rep, s, sd, t, t3, t3plusx,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	    external = false;
	
	    // Initial estimate.
	    s = x.s * Math.pow(x.s * x, 1 / 3);
	
	     // Math.cbrt underflow/overflow?
	     // Pass x to Math.pow as integer, then adjust the exponent of the result.
	    if (!s || Math.abs(s) == 1 / 0) {
	      n = digitsToString(x.d);
	      e = x.e;
	
	      // Adjust n exponent so it is a multiple of 3 away from x exponent.
	      if (s = (e - n.length + 1) % 3) n += (s == 1 || s == -2 ? '0' : '00');
	      s = Math.pow(n, 1 / 3);
	
	      // Rarely, e may be one less than the result exponent value.
	      e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	      r.s = x.s;
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    sd = (e = Ctor.precision) + 3;
	
	    // Halley's method.
	    // TODO? Compare Newton's method.
	    for (;;) {
	      t = r;
	      t3 = t.times(t).times(t);
	      t3plusx = t3.plus(x);
	      r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
	
	      // TODO? Replace with for-loop and checkRoundingDigits.
	      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
	        n = n.slice(sd - 3, sd + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
	        // , i.e. approaching a rounding boundary, continue the iteration.
	        if (n == '9999' || !rep && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          if (!rep) {
	            finalise(t, e + 1, 0);
	
	            if (t.times(t).times(t).eq(x)) {
	              r = t;
	              break;
	            }
	          }
	
	          sd += 4;
	          rep = 1;
	        } else {
	
	          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
	          // If not, then there are further digits and m will be truthy.
	          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
	
	            // Truncate to the first rounding digit.
	            finalise(r, e + 1, 1);
	            m = !r.times(r).times(r).eq(x);
	          }
	
	          break;
	        }
	      }
	    }
	
	    external = true;
	
	    return finalise(r, e, Ctor.rounding, m);
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var w,
	      d = this.d,
	      n = NaN;
	
	    if (d) {
	      w = d.length - 1;
	      n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
	
	      // Subtract the number of trailing zeros of the last word.
	      w = d[w];
	      if (w) for (; w % 10 == 0; w /= 10) n--;
	      if (n < 0) n = 0;
	    }
	
	    return n;
	  };
	
	
	  /*
	   *  n / 0 = I
	   *  n / N = N
	   *  n / I = 0
	   *  0 / n = 0
	   *  0 / 0 = N
	   *  0 / N = N
	   *  0 / I = 0
	   *  N / n = N
	   *  N / 0 = N
	   *  N / N = N
	   *  N / I = N
	   *  I / n = I
	   *  I / 0 = I
	   *  I / N = N
	   *  I / I = N
	   *
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.dividedToIntegerBy = P.divToInt = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return this.cmp(y) === 0;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
	   * direction of negative Infinity.
	   *
	   */
	  P.floor = function () {
	    return finalise(new this.constructor(this), this.e + 1, 3);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    var k = this.cmp(y);
	    return k == 1 || k === 0;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [1, Infinity]
	   *
	   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
	   *
	   * cosh(0)         = 1
	   * cosh(-0)        = 1
	   * cosh(Infinity)  = Infinity
	   * cosh(-Infinity) = Infinity
	   * cosh(NaN)       = NaN
	   *
	   *  x        time taken (ms)   result
	   * 1000      9                 9.8503555700852349694e+433
	   * 10000     25                4.4034091128314607936e+4342
	   * 100000    171               1.4033316802130615897e+43429
	   * 1000000   3817              1.5166076984010437725e+434294
	   * 10000000  abandoned after 2 minute wait
	   *
	   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
	   *
	   */
	  P.hyperbolicCosine = P.cosh = function () {
	    var k, n, pr, rm, len,
	      x = this,
	      Ctor = x.constructor,
	      one = new Ctor(1);
	
	    if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
	    if (x.isZero()) return one;
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
	    Ctor.rounding = 1;
	    len = x.d.length;
	
	    // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
	    // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
	
	    // Estimate the optimum number of times to use the argument reduction.
	    // TODO? Estimation reused from cosine() and may not be optimal here.
	    if (len < 32) {
	      k = Math.ceil(len / 3);
	      n = Math.pow(4, -k).toString();
	    } else {
	      k = 16;
	      n = '2.3283064365386962890625e-10';
	    }
	
	    x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
	
	    // Reverse argument reduction
	    var cosh2_x,
	      i = k,
	      d8 = new Ctor(8);
	    for (; i--;) {
	      cosh2_x = x.times(x);
	      x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
	    }
	
	    return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
	   *
	   * sinh(0)         = 0
	   * sinh(-0)        = -0
	   * sinh(Infinity)  = Infinity
	   * sinh(-Infinity) = -Infinity
	   * sinh(NaN)       = NaN
	   *
	   * x        time taken (ms)
	   * 10       2 ms
	   * 100      5 ms
	   * 1000     14 ms
	   * 10000    82 ms
	   * 100000   886 ms            1.4033316802130615897e+43429
	   * 200000   2613 ms
	   * 300000   5407 ms
	   * 400000   8824 ms
	   * 500000   13026 ms          8.7080643612718084129e+217146
	   * 1000000  48543 ms
	   *
	   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
	   *
	   */
	  P.hyperbolicSine = P.sinh = function () {
	    var k, pr, rm, len,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
	    Ctor.rounding = 1;
	    len = x.d.length;
	
	    if (len < 3) {
	      x = taylorSeries(Ctor, 2, x, x, true);
	    } else {
	
	      // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
	      // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
	      // 3 multiplications and 1 addition
	
	      // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
	      // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
	      // 4 multiplications and 2 additions
	
	      // Estimate the optimum number of times to use the argument reduction.
	      k = 1.4 * Math.sqrt(len);
	      k = k > 16 ? 16 : k | 0;
	
	      x = x.times(Math.pow(5, -k));
	
	      x = taylorSeries(Ctor, 2, x, x, true);
	
	      // Reverse argument reduction
	      var sinh2_x,
	        d5 = new Ctor(5),
	        d16 = new Ctor(16),
	        d20 = new Ctor(20);
	      for (; k--;) {
	        sinh2_x = x.times(x);
	        x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
	      }
	    }
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(x, pr, rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * tanh(x) = sinh(x) / cosh(x)
	   *
	   * tanh(0)         = 0
	   * tanh(-0)        = -0
	   * tanh(Infinity)  = 1
	   * tanh(-Infinity) = -1
	   * tanh(NaN)       = NaN
	   *
	   */
	  P.hyperbolicTangent = P.tanh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(x.s);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 7;
	    Ctor.rounding = 1;
	
	    return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
	   * this Decimal.
	   *
	   * Domain: [-1, 1]
	   * Range: [0, pi]
	   *
	   * acos(x) = pi/2 - asin(x)
	   *
	   * acos(0)       = pi/2
	   * acos(-0)      = pi/2
	   * acos(1)       = 0
	   * acos(-1)      = pi
	   * acos(1/2)     = pi/3
	   * acos(-1/2)    = 2*pi/3
	   * acos(|x| > 1) = NaN
	   * acos(NaN)     = NaN
	   *
	   */
	  P.inverseCosine = P.acos = function () {
	    var halfPi,
	      x = this,
	      Ctor = x.constructor,
	      k = x.abs().cmp(1),
	      pr = Ctor.precision,
	      rm = Ctor.rounding;
	
	    if (k !== -1) {
	      return k === 0
	        // |x| is 1
	        ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0)
	        // |x| > 1 or x is NaN
	        : new Ctor(NaN);
	    }
	
	    if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
	
	    // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
	
	    Ctor.precision = pr + 6;
	    Ctor.rounding = 1;
	
	    x = x.asin();
	    halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return halfPi.minus(x);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
	   * value of this Decimal.
	   *
	   * Domain: [1, Infinity]
	   * Range: [0, Infinity]
	   *
	   * acosh(x) = ln(x + sqrt(x^2 - 1))
	   *
	   * acosh(x < 1)     = NaN
	   * acosh(NaN)       = NaN
	   * acosh(Infinity)  = Infinity
	   * acosh(-Infinity) = NaN
	   * acosh(0)         = NaN
	   * acosh(-0)        = NaN
	   * acosh(1)         = 0
	   * acosh(-1)        = NaN
	   *
	   */
	  P.inverseHyperbolicCosine = P.acosh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
	    if (!x.isFinite()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
	    Ctor.rounding = 1;
	    external = false;
	
	    x = x.times(x).minus(1).sqrt().plus(x);
	
	    external = true;
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.ln();
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
	   * of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * asinh(x) = ln(x + sqrt(x^2 + 1))
	   *
	   * asinh(NaN)       = NaN
	   * asinh(Infinity)  = Infinity
	   * asinh(-Infinity) = -Infinity
	   * asinh(0)         = 0
	   * asinh(-0)        = -0
	   *
	   */
	  P.inverseHyperbolicSine = P.asinh = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite() || x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
	    Ctor.rounding = 1;
	    external = false;
	
	    x = x.times(x).plus(1).sqrt().plus(x);
	
	    external = true;
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.ln();
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
	   * value of this Decimal.
	   *
	   * Domain: [-1, 1]
	   * Range: [-Infinity, Infinity]
	   *
	   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
	   *
	   * atanh(|x| > 1)   = NaN
	   * atanh(NaN)       = NaN
	   * atanh(Infinity)  = NaN
	   * atanh(-Infinity) = NaN
	   * atanh(0)         = 0
	   * atanh(-0)        = -0
	   * atanh(1)         = Infinity
	   * atanh(-1)        = -Infinity
	   *
	   */
	  P.inverseHyperbolicTangent = P.atanh = function () {
	    var pr, rm, wpr, xsd,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    xsd = x.sd();
	
	    if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
	
	    Ctor.precision = wpr = xsd - x.e;
	
	    x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
	
	    Ctor.precision = pr + 4;
	    Ctor.rounding = 1;
	
	    x = x.ln();
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.times(0.5);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
	   * Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi/2, pi/2]
	   *
	   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
	   *
	   * asin(0)       = 0
	   * asin(-0)      = -0
	   * asin(1/2)     = pi/6
	   * asin(-1/2)    = -pi/6
	   * asin(1)       = pi/2
	   * asin(-1)      = -pi/2
	   * asin(|x| > 1) = NaN
	   * asin(NaN)     = NaN
	   *
	   * TODO? Compare performance of Taylor series.
	   *
	   */
	  P.inverseSine = P.asin = function () {
	    var halfPi, k,
	      pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (x.isZero()) return new Ctor(x);
	
	    k = x.abs().cmp(1);
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    if (k !== -1) {
	
	      // |x| is 1
	      if (k === 0) {
	        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
	        halfPi.s = x.s;
	        return halfPi;
	      }
	
	      // |x| > 1 or x is NaN
	      return new Ctor(NaN);
	    }
	
	    // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
	
	    Ctor.precision = pr + 6;
	    Ctor.rounding = 1;
	
	    x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return x.times(2);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
	   * of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi/2, pi/2]
	   *
	   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
	   *
	   * atan(0)         = 0
	   * atan(-0)        = -0
	   * atan(1)         = pi/4
	   * atan(-1)        = -pi/4
	   * atan(Infinity)  = pi/2
	   * atan(-Infinity) = -pi/2
	   * atan(NaN)       = NaN
	   *
	   */
	  P.inverseTangent = P.atan = function () {
	    var i, j, k, n, px, t, r, wpr, x2,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      rm = Ctor.rounding;
	
	    if (!x.isFinite()) {
	      if (!x.s) return new Ctor(NaN);
	      if (pr + 4 <= PI_PRECISION) {
	        r = getPi(Ctor, pr + 4, rm).times(0.5);
	        r.s = x.s;
	        return r;
	      }
	    } else if (x.isZero()) {
	      return new Ctor(x);
	    } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
	      r = getPi(Ctor, pr + 4, rm).times(0.25);
	      r.s = x.s;
	      return r;
	    }
	
	    Ctor.precision = wpr = pr + 10;
	    Ctor.rounding = 1;
	
	    // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
	
	    // Argument reduction
	    // Ensure |x| < 0.42
	    // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
	
	    k = Math.min(28, wpr / LOG_BASE + 2 | 0);
	
	    for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));
	
	    external = false;
	
	    j = Math.ceil(wpr / LOG_BASE);
	    n = 1;
	    x2 = x.times(x);
	    r = new Ctor(x);
	    px = x;
	
	    // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
	    for (; i !== -1;) {
	      px = px.times(x2);
	      t = r.minus(px.div(n += 2));
	
	      px = px.times(x2);
	      r = t.plus(px.div(n += 2));
	
	      if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--;);
	    }
	
	    if (k) r = r.times(2 << (k - 1));
	
	    external = true;
	
	    return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is a finite number, otherwise return false.
	   *
	   */
	  P.isFinite = function () {
	    return !!this.d;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isInt = function () {
	    return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is NaN, otherwise return false.
	   *
	   */
	  P.isNaN = function () {
	    return !this.s;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isNeg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.isPos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return !!this.d && this.d[0] === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * If no base is specified, return log[10](arg).
	   *
	   * log[base](arg) = ln(arg) / ln(base)
	   *
	   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
	   * otherwise:
	   *
	   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
	   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
	   * between the result and the correctly rounded result will be one ulp (unit in the last place).
	   *
	   * log[-b](a)       = NaN
	   * log[0](a)        = NaN
	   * log[1](a)        = NaN
	   * log[NaN](a)      = NaN
	   * log[Infinity](a) = NaN
	   * log[b](0)        = -Infinity
	   * log[b](-0)       = -Infinity
	   * log[b](-a)       = NaN
	   * log[b](1)        = 0
	   * log[b](Infinity) = Infinity
	   * log[b](NaN)      = NaN
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var isBase10, d, denominator, k, inf, num, sd, r,
	      arg = this,
	      Ctor = arg.constructor,
	      pr = Ctor.precision,
	      rm = Ctor.rounding,
	      guard = 5;
	
	    // Default base is 10.
	    if (base == null) {
	      base = new Ctor(10);
	      isBase10 = true;
	    } else {
	      base = new Ctor(base);
	      d = base.d;
	
	      // Return NaN if base is negative, or non-finite, or is 0 or 1.
	      if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
	
	      isBase10 = base.eq(10);
	    }
	
	    d = arg.d;
	
	    // Is arg negative, non-finite, 0 or 1?
	    if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
	      return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
	    }
	
	    // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
	    // integer power of 10.
	    if (isBase10) {
	      if (d.length > 1) {
	        inf = true;
	      } else {
	        for (k = d[0]; k % 10 === 0;) k /= 10;
	        inf = k !== 1;
	      }
	    }
	
	    external = false;
	    sd = pr + guard;
	    num = naturalLogarithm(arg, sd);
	    denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
	
	    // The result will have 5 rounding digits.
	    r = divide(num, denominator, sd, 1);
	
	    // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
	    // calculate 10 further digits.
	    //
	    // If the result is known to have an infinite decimal expansion, repeat this until it is clear
	    // that the result is above or below the boundary. Otherwise, if after calculating the 10
	    // further digits, the last 14 are nines, round up and assume the result is exact.
	    // Also assume the result is exact if the last 14 are zero.
	    //
	    // Example of a result that will be incorrectly rounded:
	    // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
	    // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
	    // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
	    // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
	    // place is still 2.6.
	    if (checkRoundingDigits(r.d, k = pr, rm)) {
	
	      do {
	        sd += 10;
	        num = naturalLogarithm(arg, sd);
	        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
	        r = divide(num, denominator, sd, 1);
	
	        if (!inf) {
	
	          // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
	          if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
	            r = finalise(r, pr + 1, 0);
	          }
	
	          break;
	        }
	      } while (checkRoundingDigits(r.d, k += 10, rm));
	    }
	
	    external = true;
	
	    return finalise(r, pr, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
	   *
	   * arguments {number|string|Decimal}
	   *
	  P.max = function () {
	    Array.prototype.push.call(arguments, this);
	    return maxOrMin(this.constructor, arguments, 'lt');
	  };
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
	   *
	   * arguments {number|string|Decimal}
	   *
	  P.min = function () {
	    Array.prototype.push.call(arguments, this);
	    return maxOrMin(this.constructor, arguments, 'gt');
	  };
	   */
	
	
	  /*
	   *  n - 0 = n
	   *  n - N = N
	   *  n - I = -I
	   *  0 - n = -n
	   *  0 - 0 = 0
	   *  0 - N = N
	   *  0 - I = -I
	   *  N - n = N
	   *  N - 0 = N
	   *  N - N = N
	   *  N - I = N
	   *  I - n = I
	   *  I - 0 = I
	   *  I - N = N
	   *  I - I = N
	   *
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // If either is not finite...
	    if (!x.d || !y.d) {
	
	      // Return NaN if either is NaN.
	      if (!x.s || !y.s) y = new Ctor(NaN);
	
	      // Return y negated if x is finite and y is ±Infinity.
	      else if (x.d) y.s = -y.s;
	
	      // Return x if y is finite and x is ±Infinity.
	      // Return x if both are ±Infinity with different signs.
	      // Return NaN if both are ±Infinity with the same sign.
	      else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
	
	      return y;
	    }
	
	    // If signs differ...
	    if (x.s != y.s) {
	      y.s = -y.s;
	      return x.plus(y);
	    }
	
	    xd = x.d;
	    yd = y.d;
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    // If either is zero...
	    if (!xd[0] || !yd[0]) {
	
	      // Return y negated if x is zero and y is non-zero.
	      if (yd[0]) y.s = -y.s;
	
	      // Return x if y is zero and x is non-zero.
	      else if (xd[0]) y = new Ctor(x);
	
	      // Return zero if both are zero.
	      // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
	      else return new Ctor(rm === 3 ? -0 : 0);
	
	      return external ? finalise(y, pr, rm) : y;
	    }
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    // Calculate base 1e7 exponents.
	    e = mathfloor(y.e / LOG_BASE);
	    xe = mathfloor(x.e / LOG_BASE);
	
	    xd = xd.slice();
	    k = xe - e;
	
	    // If base 1e7 exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of
	      // zeros needing to be prepended, but this can be avoided while still ensuring correct
	      // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to `xd` if shorter.
	    // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
	
	    y.d = xd;
	    y.e = getBase10Exponent(xd, e);
	
	    return external ? finalise(y, pr, rm) : y;
	  };
	
	
	  /*
	   *   n % 0 =  N
	   *   n % N =  N
	   *   n % I =  n
	   *   0 % n =  0
	   *  -0 % n = -0
	   *   0 % 0 =  N
	   *   0 % N =  N
	   *   0 % I =  0
	   *   N % n =  N
	   *   N % 0 =  N
	   *   N % N =  N
	   *   N % I =  N
	   *   I % n =  N
	   *   I % 0 =  N
	   *   I % N =  N
	   *   I % I =  N
	   *
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * The result depends on the modulo mode.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
	    if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
	
	    // Return x if y is ±Infinity or x is ±0.
	    if (!y.d || x.d && !x.d[0]) {
	      return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
	    }
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	
	    if (Ctor.modulo == 9) {
	
	      // Euclidian division: q = sign(y) * floor(x / abs(y))
	      // result = x - q * y    where  0 <= result < abs(y)
	      q = divide(x, y.abs(), 0, 3, 1);
	      q.s *= y.s;
	    } else {
	      q = divide(x, y, 0, Ctor.modulo, 1);
	    }
	
	    q = q.times(y);
	
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return naturalExponential(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return naturalLogarithm(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s;
	    return finalise(x);
	  };
	
	
	  /*
	   *  n + 0 = n
	   *  n + N = N
	   *  n + I = I
	   *  0 + n = n
	   *  0 + 0 = 0
	   *  0 + N = N
	   *  0 + I = I
	   *  N + n = N
	   *  N + 0 = N
	   *  N + N = N
	   *  N + I = N
	   *  I + n = I
	   *  I + 0 = I
	   *  I + N = N
	   *  I + I = I
	   *
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var carry, d, e, i, k, len, pr, rm, xd, yd,
	      x = this,
	      Ctor = x.constructor;
	
	    y = new Ctor(y);
	
	    // If either is not finite...
	    if (!x.d || !y.d) {
	
	      // Return NaN if either is NaN.
	      if (!x.s || !y.s) y = new Ctor(NaN);
	
	      // Return x if y is finite and x is ±Infinity.
	      // Return x if both are ±Infinity with the same sign.
	      // Return NaN if both are ±Infinity with different signs.
	      // Return y if x is finite and y is ±Infinity.
	      else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
	
	      return y;
	    }
	
	     // If signs differ...
	    if (x.s != y.s) {
	      y.s = -y.s;
	      return x.minus(y);
	    }
	
	    xd = x.d;
	    yd = y.d;
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    // If either is zero...
	    if (!xd[0] || !yd[0]) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!yd[0]) y = new Ctor(x);
	
	      return external ? finalise(y, pr, rm) : y;
	    }
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    // Calculate base 1e7 exponents.
	    k = mathfloor(x.e / LOG_BASE);
	    e = mathfloor(y.e / LOG_BASE);
	
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = getBase10Exponent(xd, e);
	
	    return external ? finalise(y, pr, rm) : y;
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var k,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    if (x.d) {
	      k = getPrecision(x.d);
	      if (z && x.e + 1 > k) k = x.e + 1;
	    } else {
	      k = NaN;
	    }
	
	    return k;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.round = function () {
	    var x = this,
	      Ctor = x.constructor;
	
	    return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-1, 1]
	   *
	   * sin(x) = x - x^3/3! + x^5/5! - ...
	   *
	   * sin(0)         = 0
	   * sin(-0)        = -0
	   * sin(Infinity)  = NaN
	   * sin(-Infinity) = NaN
	   * sin(NaN)       = NaN
	   *
	   */
	  P.sine = P.sin = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
	    Ctor.rounding = 1;
	
	    x = sine(Ctor, toLessThanHalfPi(Ctor, x));
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   *  sqrt(-n) =  N
	   *  sqrt(N)  =  N
	   *  sqrt(-I) =  N
	   *  sqrt(I)  =  I
	   *  sqrt(0)  =  0
	   *  sqrt(-0) = -0
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var m, n, sd, r, rep, t,
	      x = this,
	      d = x.d,
	      e = x.e,
	      s = x.s,
	      Ctor = x.constructor;
	
	    // Negative/NaN/Infinity/zero?
	    if (s !== 1 || !d || !d[0]) {
	      return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
	    }
	
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(d);
	
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '1e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    sd = (e = Ctor.precision) + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
	
	      // TODO? Replace with for-loop and checkRoundingDigits.
	      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
	        n = n.slice(sd - 3, sd + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (n == '9999' || !rep && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          if (!rep) {
	            finalise(t, e + 1, 0);
	
	            if (t.times(t).eq(x)) {
	              r = t;
	              break;
	            }
	          }
	
	          sd += 4;
	          rep = 1;
	        } else {
	
	          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
	          // If not, then there are further digits and m will be truthy.
	          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
	
	            // Truncate to the first rounding digit.
	            finalise(r, e + 1, 1);
	            m = !r.times(r).eq(x);
	          }
	
	          break;
	        }
	      }
	    }
	
	    external = true;
	
	    return finalise(r, e, Ctor.rounding, m);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-Infinity, Infinity]
	   *
	   * tan(0)         = 0
	   * tan(-0)        = -0
	   * tan(Infinity)  = NaN
	   * tan(-Infinity) = NaN
	   * tan(NaN)       = NaN
	   *
	   */
	  P.tangent = P.tan = function () {
	    var pr, rm,
	      x = this,
	      Ctor = x.constructor;
	
	    if (!x.isFinite()) return new Ctor(NaN);
	    if (x.isZero()) return new Ctor(x);
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	    Ctor.precision = pr + 10;
	    Ctor.rounding = 1;
	
	    x = x.sin();
	    x.s = 1;
	    x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
	
	    Ctor.precision = pr;
	    Ctor.rounding = rm;
	
	    return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
	  };
	
	
	  /*
	   *  n * 0 = 0
	   *  n * N = N
	   *  n * I = I
	   *  0 * n = 0
	   *  0 * 0 = 0
	   *  0 * N = N
	   *  0 * I = N
	   *  N * n = N
	   *  N * 0 = N
	   *  N * N = N
	   *  N * I = N
	   *  I * n = I
	   *  I * 0 = N
	   *  I * N = N
	   *  I * I = I
	   *
	   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    y.s *= x.s;
	
	     // If either is NaN, ±Infinity or ±0...
	    if (!xd || !xd[0] || !yd || !yd[0]) {
	
	      return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd
	
	        // Return NaN if either is NaN.
	        // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
	        ? NaN
	
	        // Return ±Infinity if either is ±Infinity.
	        // Return ±0 if either is ±0.
	        : !xd || !yd ? y.s / 0 : y.s * 0);
	    }
	
	    e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = getBase10Exponent(r, e);
	
	    return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toBinary = function (sd, rm) {
	    return toStringBinary(this, 2, sd, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.toDP = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return finalise(x, dp + x.e + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = finiteToString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = finalise(new Ctor(x), dp + 1, rm);
	      str = finiteToString(x, true, dp + 1);
	    }
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = finiteToString(x);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      y = finalise(new Ctor(x), dp + x.e + 1, rm);
	      str = finiteToString(y, false, dp + y.e + 1);
	    }
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return an array representing the value of this Decimal as a simple fraction with an integer
	   * numerator and an integer denominator.
	   *
	   * The denominator will be a positive non-zero value less than or equal to the specified maximum
	   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
	   * value necessary to represent the number exactly.
	   *
	   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
	   *
	   */
	  P.toFraction = function (maxD) {
	    var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r,
	      x = this,
	      xd = x.d,
	      Ctor = x.constructor;
	
	    if (!xd) return new Ctor(x);
	
	    n1 = d0 = new Ctor(1);
	    d1 = n0 = new Ctor(0);
	
	    d = new Ctor(d1);
	    e = d.e = getPrecision(xd) - x.e - 1;
	    k = e % LOG_BASE;
	    d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
	
	    if (maxD == null) {
	
	      // d is 10**e, the minimum max-denominator needed.
	      maxD = e > 0 ? d : n1;
	    } else {
	      n = new Ctor(maxD);
	      if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
	      maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
	    }
	
	    external = false;
	    n = new Ctor(digitsToString(xd));
	    pr = Ctor.precision;
	    Ctor.precision = e = xd.length * LOG_BASE * 2;
	
	    for (;;)  {
	      q = divide(n, d, 0, 1, 1);
	      d2 = d0.plus(q.times(d1));
	      if (d2.cmp(maxD) == 1) break;
	      d0 = d1;
	      d1 = d2;
	      d2 = n1;
	      n1 = n0.plus(q.times(d2));
	      n0 = d2;
	      d2 = d;
	      d = n.minus(q.times(d2));
	      n = d2;
	    }
	
	    d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
	    n0 = n0.plus(d2.times(n1));
	    d0 = d0.plus(d2.times(d1));
	    n0.s = n1.s = x.s;
	
	    // Determine which fraction is closer to x, n0/d0 or n1/d1?
	    r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
	        ? [n1, d1] : [n0, d0];
	
	    Ctor.precision = pr;
	    external = true;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toHexadecimal = P.toHex = function (sd, rm) {
	    return toStringBinary(this, 16, sd, rm);
	  };
	
	
	
	  /*
	   * Returns a new Decimal whose value is the nearest multiple of the magnitude of `y` to the value
	   * of this Decimal.
	   *
	   * If the value of this Decimal is equidistant from two multiples of `y`, the rounding mode `rm`,
	   * or `Decimal.rounding` if `rm` is omitted, determines the direction of the nearest multiple.
	   *
	   * In the context of this method, rounding mode 4 (ROUND_HALF_UP) is the same as rounding mode 0
	   * (ROUND_UP), and so on.
	   *
	   * The return value will always have the same sign as this Decimal, unless either this Decimal
	   * or `y` is NaN, in which case the return value will be also be NaN.
	   *
	   * The return value is not affected by the value of `precision`.
	   *
	   * y {number|string|Decimal} The magnitude to round to a multiple of.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * 'toNearest() rounding mode not an integer: {rm}'
	   * 'toNearest() rounding mode out of range: {rm}'
	   *
	   */
	  P.toNearest = function (y, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	
	    if (y == null) {
	
	      // If x is not finite, return x.
	      if (!x.d) return x;
	
	      y = new Ctor(1);
	      rm = Ctor.rounding;
	    } else {
	      y = new Ctor(y);
	      if (rm !== void 0) checkInt32(rm, 0, 8);
	
	      // If x is not finite, return x if y is not NaN, else NaN.
	      if (!x.d) return y.s ? x : y;
	
	      // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
	      if (!y.d) {
	        if (y.s) y.s = x.s;
	        return y;
	      }
	    }
	
	    // If y is not zero, calculate the nearest multiple of y to x.
	    if (y.d[0]) {
	      external = false;
	      if (rm < 4) rm = [4, 5, 7, 8][rm];
	      x = divide(x, y, 0, rm, 1).times(y);
	      external = true;
	      finalise(x);
	
	    // If y is zero, return zero with the sign of x.
	    } else {
	      y.s = x.s;
	      x = y;
	    }
	
	    return x;
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   * Zero keeps its sign.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
	   * digits using rounding mode `rm`.
	   *
	   * If the optional `sd` argument is present then return binary exponential notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toOctal = function (sd, rm) {
	    return toStringBinary(this, 8, sd, rm);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
	   * to `precision` significant digits using rounding mode `rounding`.
	   *
	   * ECMAScript compliant.
	   *
	   *   pow(x, NaN)                           = NaN
	   *   pow(x, ±0)                            = 1
	
	   *   pow(NaN, non-zero)                    = NaN
	   *   pow(abs(x) > 1, +Infinity)            = +Infinity
	   *   pow(abs(x) > 1, -Infinity)            = +0
	   *   pow(abs(x) == 1, ±Infinity)           = NaN
	   *   pow(abs(x) < 1, +Infinity)            = +0
	   *   pow(abs(x) < 1, -Infinity)            = +Infinity
	   *   pow(+Infinity, y > 0)                 = +Infinity
	   *   pow(+Infinity, y < 0)                 = +0
	   *   pow(-Infinity, odd integer > 0)       = -Infinity
	   *   pow(-Infinity, even integer > 0)      = +Infinity
	   *   pow(-Infinity, odd integer < 0)       = -0
	   *   pow(-Infinity, even integer < 0)      = +0
	   *   pow(+0, y > 0)                        = +0
	   *   pow(+0, y < 0)                        = +Infinity
	   *   pow(-0, odd integer > 0)              = -0
	   *   pow(-0, even integer > 0)             = +0
	   *   pow(-0, odd integer < 0)              = -Infinity
	   *   pow(-0, even integer < 0)             = +Infinity
	   *   pow(finite x < 0, finite non-integer) = NaN
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
	   * probability of an incorrectly rounded result
	   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
	   * i.e. 1 in 250,000,000,000,000
	   *
	   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, rm, s,
	      x = this,
	      Ctor = x.constructor,
	      yn = +(y = new Ctor(y));
	
	    // Either ±Infinity, NaN or ±0?
	    if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
	
	    x = new Ctor(x);
	
	    if (x.eq(1)) return x;
	
	    pr = Ctor.precision;
	    rm = Ctor.rounding;
	
	    if (y.eq(1)) return finalise(x, pr, rm);
	
	    // y exponent
	    e = mathfloor(y.e / LOG_BASE);
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = intPow(Ctor, x, k, pr);
	      return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
	    }
	
	    s = x.s;
	
	    // if x is negative
	    if (s < 0) {
	
	      // if y is not an integer
	      if (e < y.d.length - 1) return new Ctor(NaN);
	
	      // Result is positive if x is negative and the last digit of integer y is even.
	      if ((y.d[e] & 1) == 0) s = 1;
	
	      // if x.eq(-1)
	      if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
	        x.s = s;
	        return x;
	      }
	    }
	
	    // Estimate result exponent.
	    // x^y = 10^e,  where e = y * log10(x)
	    // log10(x) = log10(x_significand) + x_exponent
	    // log10(x_significand) = ln(x_significand) / ln(10)
	    k = mathpow(+x, yn);
	    e = k == 0 || !isFinite(k)
	      ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1))
	      : new Ctor(k + '').e;
	
	    // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
	
	    // Overflow/underflow?
	    if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
	
	    external = false;
	    Ctor.rounding = x.s = 1;
	
	    // Estimate the extra guard digits needed to ensure five correct rounding digits from
	    // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
	    // new Decimal(2.32456).pow('2087987436534566.46411')
	    // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
	    k = Math.min(12, (e + '').length);
	
	    // r = x^y = exp(y*ln(x))
	    r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
	
	    // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
	    if (r.d) {
	
	      // Truncate to the required precision plus five rounding digits.
	      r = finalise(r, pr + 5, 1);
	
	      // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
	      // the result.
	      if (checkRoundingDigits(r.d, pr, rm)) {
	        e = pr + 10;
	
	        // Truncate to the increased precision plus five rounding digits.
	        r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
	
	        // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
	        if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
	          r = finalise(r, pr + 1, 0);
	        }
	      }
	    }
	
	    r.s = s;
	    external = true;
	    Ctor.rounding = rm;
	
	    return finalise(r, pr, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = finalise(new Ctor(x), sd, rm);
	      str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
	    }
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * 'toSD() digits out of range: {sd}'
	   * 'toSD() digits not an integer: {sd}'
	   * 'toSD() rounding mode not an integer: {rm}'
	   * 'toSD() rounding mode out of range: {rm}'
	   *
	   */
	  P.toSignificantDigits = P.toSD = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return finalise(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = function () {
	    var x = this,
	      Ctor = x.constructor,
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	
	    return x.isNeg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
	   *
	   */
	  P.truncated = P.trunc = function () {
	    return finalise(new this.constructor(this), this.e + 1, 1);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   * Unlike `toString`, negative zero will include the minus sign.
	   *
	   */
	  P.valueOf = P.toJSON = function () {
	    var x = this,
	      Ctor = x.constructor,
	      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
	
	    return x.isNeg() ? '-' + str : str;
	  };
	
	
	  /*
	  // Add aliases to match BigDecimal method names.
	  // P.add = P.plus;
	  P.subtract = P.minus;
	  P.multiply = P.times;
	  P.divide = P.div;
	  P.remainder = P.mod;
	  P.compareTo = P.cmp;
	  P.negate = P.neg;
	   */
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
	   *                           finiteToString, naturalExponential, naturalLogarithm
	   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
	   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
	   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
	   *  convertBase              toStringBinary, parseOther
	   *  cos                      P.cos
	   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
	   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
	   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
	   *                           taylorSeries, atan2, parseOther
	   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
	   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
	   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
	   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
	   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
	   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
	   *                           naturalLogarithm, ceil, floor, round, trunc
	   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
	   *                           toStringBinary
	   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
	   *  getLn10                  P.logarithm, naturalLogarithm
	   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
	   *  getPrecision             P.precision, P.toFraction
	   *  getZeroString            digitsToString, finiteToString
	   *  intPow                   P.toPower, parseOther
	   *  isOdd                    toLessThanHalfPi
	   *  maxOrMin                 max, min
	   *  naturalExponential       P.naturalExponential, P.toPower
	   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
	   *                           P.toPower, naturalExponential
	   *  nonFiniteToString        finiteToString, toStringBinary
	   *  parseDecimal             Decimal
	   *  parseOther               Decimal
	   *  sin                      P.sin
	   *  taylorSeries             P.cosh, P.sinh, cos, sin
	   *  toLessThanHalfPi         P.cos, P.sin
	   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
	   *  truncate                 intPow
	   *
	   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
	   *                           naturalLogarithm, config, parseOther, random, Decimal
	   */
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  /*
	   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
	   * `repeating == null` if caller is `log` or `pow`,
	   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
	   */
	  function checkRoundingDigits(d, i, rm, repeating) {
	    var di, k, r, rd;
	
	    // Get the length of the first word of the array d.
	    for (k = d[0]; k >= 10; k /= 10) --i;
	
	    // Is the rounding digit in the first word of d?
	    if (--i < 0) {
	      i += LOG_BASE;
	      di = 0;
	    } else {
	      di = Math.ceil((i + 1) / LOG_BASE);
	      i %= LOG_BASE;
	    }
	
	    // i is the index (0 - 6) of the rounding digit.
	    // E.g. if within the word 3487563 the first rounding digit is 5,
	    // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
	    k = mathpow(10, LOG_BASE - i);
	    rd = d[di] % k | 0;
	
	    if (repeating == null) {
	      if (i < 3) {
	        if (i == 0) rd = rd / 100 | 0;
	        else if (i == 1) rd = rd / 10 | 0;
	        r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
	      } else {
	        r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) &&
	          (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 ||
	            (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
	      }
	    } else {
	      if (i < 4) {
	        if (i == 0) rd = rd / 1000 | 0;
	        else if (i == 1) rd = rd / 100 | 0;
	        else if (i == 2) rd = rd / 10 | 0;
	        r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
	      } else {
	        r = ((repeating || rm < 4) && rd + 1 == k ||
	        (!repeating && rm > 3) && rd + 1 == k / 2) &&
	          (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
	      }
	    }
	
	    return r;
	  }
	
	
	  // Convert string of `baseIn` to an array of numbers of `baseOut`.
	  // Eg. convertBase('255', 10, 16) returns [15, 15].
	  // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
	  function convertBase(str, baseIn, baseOut) {
	    var j,
	      arr = [0],
	      arrL,
	      i = 0,
	      strL = str.length;
	
	    for (; i < strL;) {
	      for (arrL = arr.length; arrL--;) arr[arrL] *= baseIn;
	      arr[0] += NUMERALS.indexOf(str.charAt(i++));
	      for (j = 0; j < arr.length; j++) {
	        if (arr[j] > baseOut - 1) {
	          if (arr[j + 1] === void 0) arr[j + 1] = 0;
	          arr[j + 1] += arr[j] / baseOut | 0;
	          arr[j] %= baseOut;
	        }
	      }
	    }
	
	    return arr.reverse();
	  }
	
	
	  /*
	   * cos(x) = 1 - x^2/2! + x^4/4! - ...
	   * |x| < pi/2
	   *
	   */
	  function cosine(Ctor, x) {
	    var k, y,
	      len = x.d.length;
	
	    // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
	    // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
	
	    // Estimate the optimum number of times to use the argument reduction.
	    if (len < 32) {
	      k = Math.ceil(len / 3);
	      y = Math.pow(4, -k).toString();
	    } else {
	      k = 16;
	      y = '2.3283064365386962890625e-10';
	    }
	
	    Ctor.precision += k;
	
	    x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
	
	    // Reverse argument reduction
	    for (var i = k; i--;) {
	      var cos2x = x.times(x);
	      x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
	    }
	
	    Ctor.precision -= k;
	
	    return x;
	  }
	
	
	  /*
	   * Perform division in the specified base.
	   */
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k, base) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % base | 0;
	        carry = temp / base | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL, base) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * base + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, rm, dp, base) {
	      var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0,
	        yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either NaN, Infinity or 0?
	      if (!xd || !xd[0] || !yd || !yd[0]) {
	
	        return new Ctor(// Return NaN if either NaN, or both Infinity or 0.
	          !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN :
	
	          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
	          xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
	      }
	
	      if (base) {
	        logBase = 1;
	        e = x.e - y.e;
	      } else {
	        base = BASE;
	        logBase = LOG_BASE;
	        e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
	      }
	
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      // The digit array of a Decimal from toStringBinary may have trailing zeros.
	      for (i = 0; yd[i] == (xd[i] || 0); i++);
	
	      if (yd[i] > (xd[i] || 0)) e--;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	        rm = Ctor.rounding;
	      } else if (dp) {
	        sd = pr + (x.e - y.e) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) {
	        qd.push(1);
	        more = true;
	      } else {
	
	        // Convert precision in number of base 10 digits to base 1e7 digits.
	        sd = sd / logBase + 2 | 0;
	        i = 0;
	
	        // divisor < 1e7
	        if (yL == 1) {
	          k = 0;
	          yd = yd[0];
	          sd++;
	
	          // k is the carry.
	          for (; (i < xL || k) && sd--; i++) {
	            t = k * base + (xd[i] || 0);
	            qd[i] = t / yd | 0;
	            k = t % yd | 0;
	          }
	
	          more = k || i < xL;
	
	        // divisor >= 1e7
	        } else {
	
	          // Normalise xd and yd so highest order digit of yd is >= base/2
	          k = base / (yd[0] + 1) | 0;
	
	          if (k > 1) {
	            yd = multiplyInteger(yd, k, base);
	            xd = multiplyInteger(xd, k, base);
	            yL = yd.length;
	            xL = xd.length;
	          }
	
	          xi = yL;
	          rem = xd.slice(0, yL);
	          remL = rem.length;
	
	          // Add zeros to make remainder as long as divisor.
	          for (; remL < yL;) rem[remL++] = 0;
	
	          yz = yd.slice();
	          yz.unshift(0);
	          yd0 = yd[0];
	
	          if (yd[1] >= base / 2) ++yd0;
	
	          do {
	            k = 0;
	
	            // Compare divisor and remainder.
	            cmp = compare(yd, rem, yL, remL);
	
	            // If divisor < remainder.
	            if (cmp < 0) {
	
	              // Calculate trial digit, k.
	              rem0 = rem[0];
	              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
	
	              // k will be how many times the divisor goes into the current remainder.
	              k = rem0 / yd0 | 0;
	
	              //  Algorithm:
	              //  1. product = divisor * trial digit (k)
	              //  2. if product > remainder: product -= divisor, k--
	              //  3. remainder -= product
	              //  4. if product was < remainder at 2:
	              //    5. compare new remainder and divisor
	              //    6. If remainder > divisor: remainder -= divisor, k++
	
	              if (k > 1) {
	                if (k >= base) k = base - 1;
	
	                // product = divisor * trial digit.
	                prod = multiplyInteger(yd, k, base);
	                prodL = prod.length;
	                remL = rem.length;
	
	                // Compare product and remainder.
	                cmp = compare(prod, rem, prodL, remL);
	
	                // product > remainder.
	                if (cmp == 1) {
	                  k--;
	
	                  // Subtract divisor from product.
	                  subtract(prod, yL < prodL ? yz : yd, prodL, base);
	                }
	              } else {
	
	                // cmp is -1.
	                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	                if (k == 0) cmp = k = 1;
	                prod = yd.slice();
	              }
	
	              prodL = prod.length;
	              if (prodL < remL) prod.unshift(0);
	
	              // Subtract product from remainder.
	              subtract(rem, prod, remL, base);
	
	              // If product was < previous remainder.
	              if (cmp == -1) {
	                remL = rem.length;
	
	                // Compare divisor and new remainder.
	                cmp = compare(yd, rem, yL, remL);
	
	                // If divisor < new remainder, subtract divisor from remainder.
	                if (cmp < 1) {
	                  k++;
	
	                  // Subtract divisor from remainder.
	                  subtract(rem, yL < remL ? yz : yd, remL, base);
	                }
	              }
	
	              remL = rem.length;
	            } else if (cmp === 0) {
	              k++;
	              rem = [0];
	            }    // if cmp === 1, k will be 0
	
	            // Add the next digit, k, to the result array.
	            qd[i++] = k;
	
	            // Update the remainder.
	            if (cmp && rem[0]) {
	              rem[remL++] = xd[xi] || 0;
	            } else {
	              rem = [xd[xi]];
	              remL = 1;
	            }
	
	          } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	
	          more = rem[0] !== void 0;
	        }
	
	        // Leading zero?
	        if (!qd[0]) qd.shift();
	      }
	
	      // logBase is 1 when divide is being used for base conversion.
	      if (logBase == 1) {
	        q.e = e;
	        inexact = more;
	      } else {
	
	        // To calculate q.e, first get the number of digits of qd[0].
	        for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
	        q.e = i + e * logBase - 1;
	
	        finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
	      }
	
	      return q;
	    };
	  })();
	
	
	  /*
	   * Round `x` to `sd` significant digits using rounding mode `rm`.
	   * Check for over/under-flow.
	   */
	   function finalise(x, sd, rm, isTruncated) {
	    var digits, i, j, k, rd, roundUp, w, xd, xdi,
	      Ctor = x.constructor;
	
	    // Don't round if sd is null or undefined.
	    out: if (sd != null) {
	      xd = x.d;
	
	      // Infinity/NaN.
	      if (!xd) return x;
	
	      // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	      // w: the word of xd containing rd, a base 1e7 number.
	      // xdi: the index of w within xd.
	      // digits: the number of digits of w.
	      // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	      // they had leading zeros)
	      // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	      // Get the length of the first word of the digits array xd.
	      for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
	      i = sd - digits;
	
	      // Is the rounding digit in the first word of xd?
	      if (i < 0) {
	        i += LOG_BASE;
	        j = sd;
	        w = xd[xdi = 0];
	
	        // Get the rounding digit at index j of w.
	        rd = w / mathpow(10, digits - j - 1) % 10 | 0;
	      } else {
	        xdi = Math.ceil((i + 1) / LOG_BASE);
	        k = xd.length;
	        if (xdi >= k) {
	          if (isTruncated) {
	
	            // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
	            for (; k++ <= xdi;) xd.push(0);
	            w = rd = 0;
	            digits = 1;
	            i %= LOG_BASE;
	            j = i - LOG_BASE + 1;
	          } else {
	            break out;
	          }
	        } else {
	          w = k = xd[xdi];
	
	          // Get the number of digits of w.
	          for (digits = 1; k >= 10; k /= 10) digits++;
	
	          // Get the index of rd within w.
	          i %= LOG_BASE;
	
	          // Get the index of rd within w, adjusted for leading zeros.
	          // The number of leading zeros of w is given by LOG_BASE - digits.
	          j = i - LOG_BASE + digits;
	
	          // Get the rounding digit at index j of w.
	          rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
	        }
	      }
	
	      // Are there any non-zero digits after the rounding digit?
	      isTruncated = isTruncated || sd < 0 ||
	        xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
	
	      // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
	      // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
	      // will give 714.
	
	      roundUp = rm < 4
	        ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	
	      if (sd < 1 || !xd[0]) {
	        xd.length = 0;
	        if (roundUp) {
	
	          // Convert sd to decimal places.
	          sd -= x.e + 1;
	
	          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	          xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	          x.e = -sd || 0;
	        } else {
	
	          // Zero.
	          xd[0] = x.e = 0;
	        }
	
	        return x;
	      }
	
	      // Remove excess digits.
	      if (i == 0) {
	        xd.length = xdi;
	        k = 1;
	        xdi--;
	      } else {
	        xd.length = xdi + 1;
	        k = mathpow(10, LOG_BASE - i);
	
	        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	        // j > 0 means i > number of leading zeros of w.
	        xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
	      }
	
	      if (roundUp) {
	        for (;;) {
	
	          // Is the digit to be rounded up in the first word of xd?
	          if (xdi == 0) {
	
	            // i will be the length of xd[0] before k is added.
	            for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
	            j = xd[0] += k;
	            for (k = 1; j >= 10; j /= 10) k++;
	
	            // if i != k the length has increased.
	            if (i != k) {
	              x.e++;
	              if (xd[0] == BASE) xd[0] = 1;
	            }
	
	            break;
	          } else {
	            xd[xdi] += k;
	            if (xd[xdi] != BASE) break;
	            xd[xdi--] = 0;
	            k = 1;
	          }
	        }
	      }
	
	      // Remove trailing zeros.
	      for (i = xd.length; xd[--i] === 0;) xd.pop();
	    }
	
	    if (external) {
	
	      // Overflow?
	      if (x.e > Ctor.maxE) {
	
	        // Infinity.
	        x.d = null;
	        x.e = NaN;
	
	      // Underflow?
	      } else if (x.e < Ctor.minE) {
	
	        // Zero.
	        x.e = 0;
	        x.d = [0];
	        // Ctor.underflow = true;
	      } // else Ctor.underflow = false;
	    }
	
	    return x;
	  }
	
	
	  function finiteToString(x, isExp, sd) {
	    if (!x.isFinite()) return nonFiniteToString(x);
	    var k,
	      e = x.e,
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return str;
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(digits, e) {
	    var w = digits[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for ( e *= LOG_BASE; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	    if (sd > LN10_PRECISION) {
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(precisionLimitExceeded);
	    }
	    return finalise(new Ctor(LN10), sd, 1, true);
	  }
	
	
	  function getPi(Ctor, sd, rm) {
	    if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
	    return finalise(new Ctor(PI), sd, rm, true);
	  }
	
	
	  function getPrecision(digits) {
	    var w = digits.length - 1,
	      len = w * LOG_BASE + 1;
	
	    w = digits[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) len--;
	
	      // Add the number of digits of the first word.
	      for (w = digits[0]; w >= 10; w /= 10) len++;
	    }
	
	    return len;
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
	   * integer of type number.
	   *
	   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
	   *
	   */
	  function intPow(Ctor, x, n, pr) {
	    var isTruncated,
	      r = new Ctor(1),
	
	      // Max n of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      k = Math.ceil(pr / LOG_BASE + 4);
	
	    external = false;
	
	    for (;;) {
	      if (n % 2) {
	        r = r.times(x);
	        if (truncate(r.d, k)) isTruncated = true;
	      }
	
	      n = mathfloor(n / 2);
	      if (n === 0) {
	
	        // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
	        n = r.d.length - 1;
	        if (isTruncated && r.d[n] === 0) ++r.d[n];
	        break;
	      }
	
	      x = x.times(x);
	      truncate(x.d, k);
	    }
	
	    external = true;
	
	    return r;
	  }
	
	
	  function isOdd(n) {
	    return n.d[n.d.length - 1] & 1;
	  }
	
	
	  /*
	   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
	   */
	  function maxOrMin(Ctor, args, ltgt) {
	    var y,
	      x = new Ctor(args[0]),
	      i = 0;
	
	    for (; ++i < args.length;) {
	      y = new Ctor(args[i]);
	      if (!y.s) {
	        x = y;
	        break;
	      } else if (x[ltgt](y)) {
	        x = y;
	      }
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
	   * digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
	   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(Infinity)  = Infinity
	   *  exp(-Infinity) = 0
	   *  exp(NaN)       = NaN
	   *  exp(±0)        = 1
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   *  The result will always be correctly rounded.
	   *
	   */
	  function naturalExponential(x, sd) {
	    var denominator, guard, j, pow, sum, t, wpr,
	      rep = 0,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      rm = Ctor.rounding,
	      pr = Ctor.precision;
	
	    // 0/NaN/Infinity?
	    if (!x.d || !x.d[0] || x.e > 17) {
	
	      return new Ctor(x.d
	        ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0
	        : x.s ? x.s < 0 ? 0 : x : 0 / 0);
	    }
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    // while abs(x) >= 0.1
	    while (x.e > -2) {
	
	      // x = x / 2^5
	      x = x.times(t);
	      k += 5;
	    }
	
	    // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
	    // necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(1);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = finalise(pow.times(x), wpr, 1);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr, 1));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        j = k;
	        while (j--) sum = finalise(sum.times(sum), wpr, 1);
	
	        // Check to see if the first 4 rounding digits are [49]999.
	        // If so, repeat the summation with a higher precision, otherwise
	        // e.g. with precision: 18, rounding: 1
	        // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
	        // `wpr - guard` is the index of first rounding digit.
	        if (sd == null) {
	
	          if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
	            Ctor.precision = wpr += 10;
	            denominator = pow = t = new Ctor(1);
	            i = 0;
	            rep++;
	          } else {
	            return finalise(sum, Ctor.precision = pr, rm, external = true);
	          }
	        } else {
	          Ctor.precision = pr;
	          return sum;
	        }
	      }
	
	      sum = t;
	    }
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
	   * digits.
	   *
	   *  ln(-n)        = NaN
	   *  ln(0)         = -Infinity
	   *  ln(-0)        = -Infinity
	   *  ln(1)         = 0
	   *  ln(Infinity)  = Infinity
	   *  ln(-Infinity) = NaN
	   *  ln(NaN)       = NaN
	   *
	   *  ln(n) (n != 1) is non-terminating.
	   *
	   */
	  function naturalLogarithm(y, sd) {
	    var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      rm = Ctor.rounding,
	      pr = Ctor.precision;
	
	    // Is x negative or Infinity, NaN, 0 or 1?
	    if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
	      return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
	    }
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    Ctor.precision = wpr += guard;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	
	    if (Math.abs(e = x.e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = x.e;
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	      Ctor.precision = pr;
	
	      return sd == null ? finalise(x, pr, rm, external = true) : x;
	    }
	
	    // x1 is x reduced to a value near 1.
	    x1 = x;
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
	    x2 = finalise(x.times(x), wpr, 1);
	    denominator = 3;
	
	    for (;;) {
	      numerator = finalise(numerator.times(x2), wpr, 1);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
	        // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr, 1);
	
	        // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
	        // been repeated previously) and the first 4 rounding digits 9999?
	        // If so, restart the summation with a higher precision, otherwise
	        // e.g. with precision: 12, rounding: 1
	        // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
	        // `wpr - guard` is the index of first rounding digit.
	        if (sd == null) {
	          if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
	            Ctor.precision = wpr += guard;
	            t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
	            x2 = finalise(x.times(x), wpr, 1);
	            denominator = rep = 1;
	          } else {
	            return finalise(sum, Ctor.precision = pr, rm, external = true);
	          }
	        } else {
	          Ctor.precision = pr;
	          return sum;
	        }
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  // ±Infinity, NaN.
	  function nonFiniteToString(x) {
	    // Unsigned.
	    return String(x.s * x.s / 0);
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48; i++);
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48; --len);
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      x.e = e = e - i - 1;
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external) {
	
	        // Overflow?
	        if (x.e > x.constructor.maxE) {
	
	          // Infinity.
	          x.d = null;
	          x.e = NaN;
	
	        // Underflow?
	        } else if (x.e < x.constructor.minE) {
	
	          // Zero.
	          x.e = 0;
	          x.d = [0];
	          // x.constructor.underflow = true;
	        } // else x.constructor.underflow = false;
	      }
	    } else {
	
	      // Zero.
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
	   */
	  function parseOther(x, str) {
	    var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
	
	    if (str === 'Infinity' || str === 'NaN') {
	      if (!+str) x.s = NaN;
	      x.e = NaN;
	      x.d = null;
	      return x;
	    }
	
	    if (isHex.test(str))  {
	      base = 16;
	      str = str.toLowerCase();
	    } else if (isBinary.test(str))  {
	      base = 2;
	    } else if (isOctal.test(str))  {
	      base = 8;
	    } else {
	      throw Error(invalidArgument + str);
	    }
	
	    // Is there a binary exponent part?
	    i = str.search(/p/i);
	
	    if (i > 0) {
	      p = +str.slice(i + 1);
	      str = str.substring(2, i);
	    } else {
	      str = str.slice(2);
	    }
	
	    // Convert `str` as an integer then divide the result by `base` raised to a power such that the
	    // fraction part will be restored.
	    i = str.indexOf('.');
	    isFloat = i >= 0;
	    Ctor = x.constructor;
	
	    if (isFloat) {
	      str = str.replace('.', '');
	      len = str.length;
	      i = len - i;
	
	      // log[10](16) = 1.2041... , log[10](88) = 1.9444....
	      divisor = intPow(Ctor, new Ctor(base), i, i * 2);
	    }
	
	    xd = convertBase(str, base, BASE);
	    xe = xd.length - 1;
	
	    // Remove trailing zeros.
	    for (i = xe; xd[i] === 0; --i) xd.pop();
	    if (i < 0) return new Ctor(x.s * 0);
	    x.e = getBase10Exponent(xd, xe);
	    x.d = xd;
	    external = false;
	
	    // At what precision to perform the division to ensure exact conversion?
	    // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
	    // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
	    // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
	    // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
	    // Therefore using 4 * the number of digits of str will always be enough.
	    if (isFloat) x = divide(x, divisor, len * 4);
	
	    // Multiply by the binary exponent part if present.
	    if (p) x = x.times(Math.abs(p) < 54 ? Math.pow(2, p) : Decimal.pow(2, p));
	    external = true;
	
	    return x;
	  }
	
	
	  /*
	   * sin(x) = x - x^3/3! + x^5/5! - ...
	   * |x| < pi/2
	   *
	   */
	  function sine(Ctor, x) {
	    var k,
	      len = x.d.length;
	
	    if (len < 3) return taylorSeries(Ctor, 2, x, x);
	
	    // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
	    // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
	    // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
	
	    // Estimate the optimum number of times to use the argument reduction.
	    k = 1.4 * Math.sqrt(len);
	    k = k > 16 ? 16 : k | 0;
	
	    // Max k before Math.pow precision loss is 22
	    x = x.times(Math.pow(5, -k));
	    x = taylorSeries(Ctor, 2, x, x);
	
	    // Reverse argument reduction
	    var sin2_x,
	      d5 = new Ctor(5),
	      d16 = new Ctor(16),
	      d20 = new Ctor(20);
	    for (; k--;) {
	      sin2_x = x.times(x);
	      x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
	    }
	
	    return x;
	  }
	
	
	  // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
	  function taylorSeries(Ctor, n, x, y, isHyperbolic) {
	    var j, t, u, x2,
	      i = 1,
	      pr = Ctor.precision,
	      k = Math.ceil(pr / LOG_BASE);
	
	    external = false;
	    x2 = x.times(x);
	    u = new Ctor(y);
	
	    for (;;) {
	      t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
	      u = isHyperbolic ? y.plus(t) : y.minus(t);
	      y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
	      t = u.plus(y);
	
	      if (t.d[k] !== void 0) {
	        for (j = k; t.d[j] === u.d[j] && j--;);
	        if (j == -1) break;
	      }
	
	      j = u;
	      u = y;
	      y = t;
	      t = j;
	      i++;
	    }
	
	    external = true;
	    t.d.length = k + 1;
	
	    return t;
	  }
	
	
	  // Return the absolute value of `x` reduced to less than or equal to half pi.
	  function toLessThanHalfPi(Ctor, x) {
	    var t,
	      isNeg = x.s < 0,
	      pi = getPi(Ctor, Ctor.precision, 1),
	      halfPi = pi.times(0.5);
	
	    x = x.abs();
	
	    if (x.lte(halfPi)) {
	      quadrant = isNeg ? 4 : 1;
	      return x;
	    }
	
	    t = x.divToInt(pi);
	
	    if (t.isZero()) {
	      quadrant = isNeg ? 3 : 2;
	    } else {
	      x = x.minus(t.times(pi));
	
	      // 0 <= x < pi
	      if (x.lte(halfPi)) {
	        quadrant = isOdd(t) ? (isNeg ? 2 : 3) : (isNeg ? 4 : 1);
	        return x;
	      }
	
	      quadrant = isOdd(t) ? (isNeg ? 1 : 4) : (isNeg ? 3 : 2);
	    }
	
	    return x.minus(pi).abs();
	  }
	
	
	  /*
	   * Return the value of Decimal `x` as a string in base `baseOut`.
	   *
	   * If the optional `sd` argument is present include a binary exponent suffix.
	   */
	  function toStringBinary(x, baseOut, sd, rm) {
	    var base, e, i, k, len, roundUp, str, xd, y,
	      Ctor = x.constructor,
	      isExp = sd !== void 0;
	
	    if (isExp) {
	      checkInt32(sd, 1, MAX_DIGITS);
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    } else {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    }
	
	    if (!x.isFinite()) {
	      str = nonFiniteToString(x);
	    } else {
	      str = finiteToString(x);
	      i = str.indexOf('.');
	
	      // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
	      // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
	      // minBinaryExponent = floor(decimalExponent * log[2](10))
	      // log[2](10) = 3.321928094887362347870319429489390175864
	
	      if (isExp) {
	        base = 2;
	        if (baseOut == 16) {
	          sd = sd * 4 - 3;
	        } else if (baseOut == 8) {
	          sd = sd * 3 - 2;
	        }
	      } else {
	        base = baseOut;
	      }
	
	      // Convert the number as an integer then divide the result by its base raised to a power such
	      // that the fraction part will be restored.
	
	      // Non-integer.
	      if (i >= 0) {
	        str = str.replace('.', '');
	        y = new Ctor(1);
	        y.e = str.length - i;
	        y.d = convertBase(finiteToString(y), 10, base);
	        y.e = y.d.length;
	      }
	
	      xd = convertBase(str, 10, base);
	      e = len = xd.length;
	
	      // Remove trailing zeros.
	      for (; xd[--len] == 0;) xd.pop();
	
	      if (!xd[0]) {
	        str = isExp ? '0p+0' : '0';
	      } else {
	        if (i < 0) {
	          e--;
	        } else {
	          x = new Ctor(x);
	          x.d = xd;
	          x.e = e;
	          x = divide(x, y, sd, rm, 0, base);
	          xd = x.d;
	          e = x.e;
	          roundUp = inexact;
	        }
	
	        // The rounding digit, i.e. the digit after the digit that may be rounded up.
	        i = xd[sd];
	        k = base / 2;
	        roundUp = roundUp || xd[sd + 1] !== void 0;
	
	        roundUp = rm < 4
	          ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2))
	          : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 ||
	            rm === (x.s < 0 ? 8 : 7));
	
	        xd.length = sd;
	
	        if (roundUp) {
	
	          // Rounding up may mean the previous digit has to be rounded up and so on.
	          for (; ++xd[--sd] > base - 1;) {
	            xd[sd] = 0;
	            if (!sd) {
	              ++e;
	              xd.unshift(1);
	            }
	          }
	        }
	
	        // Determine trailing zeros.
	        for (len = xd.length; !xd[len - 1]; --len);
	
	        // E.g. [4, 11, 15] becomes 4bf.
	        for (i = 0, str = ''; i < len; i++) str += NUMERALS.charAt(xd[i]);
	
	        // Add binary exponent suffix?
	        if (isExp) {
	          if (len > 1) {
	            if (baseOut == 16 || baseOut == 8) {
	              i = baseOut == 16 ? 4 : 3;
	              for (--len; len % i; len++) str += '0';
	              xd = convertBase(str, base, baseOut);
	              for (len = xd.length; !xd[len - 1]; --len);
	
	              // xd[0] will always be be 1
	              for (i = 1, str = '1.'; i < len; i++) str += NUMERALS.charAt(xd[i]);
	            } else {
	              str = str.charAt(0) + '.' + str.slice(1);
	            }
	          }
	
	          str =  str + (e < 0 ? 'p' : 'p+') + e;
	        } else if (e < 0) {
	          for (; ++e;) str = '0' + str;
	          str = '0.' + str;
	        } else {
	          if (++e > len) for (e -= len; e-- ;) str += '0';
	          else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
	        }
	      }
	
	      str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  abs
	   *  acos
	   *  acosh
	   *  add
	   *  asin
	   *  asinh
	   *  atan
	   *  atanh
	   *  atan2
	   *  cbrt
	   *  ceil
	   *  clone
	   *  config
	   *  cos
	   *  cosh
	   *  div
	   *  exp
	   *  floor
	   *  hypot
	   *  ln
	   *  log
	   *  log2
	   *  log10
	   *  max
	   *  min
	   *  mod
	   *  mul
	   *  pow
	   *  random
	   *  round
	   *  set
	   *  sign
	   *  sin
	   *  sinh
	   *  sqrt
	   *  sub
	   *  tan
	   *  tanh
	   *  trunc
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of `x`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function abs(x) {
	    return new this(x).abs();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arccosine in radians of `x`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function acos(x) {
	    return new this(x).acos();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function acosh(x) {
	    return new this(x).acosh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function add(x, y) {
	    return new this(x).plus(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function asin(x) {
	    return new this(x).asin();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function asinh(x) {
	    return new this(x).asinh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function atan(x) {
	    return new this(x).atan();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
	   * `precision` significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function atanh(x) {
	    return new this(x).atanh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
	   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * Domain: [-Infinity, Infinity]
	   * Range: [-pi, pi]
	   *
	   * y {number|string|Decimal} The y-coordinate.
	   * x {number|string|Decimal} The x-coordinate.
	   *
	   * atan2(±0, -0)               = ±pi
	   * atan2(±0, +0)               = ±0
	   * atan2(±0, -x)               = ±pi for x > 0
	   * atan2(±0, x)                = ±0 for x > 0
	   * atan2(-y, ±0)               = -pi/2 for y > 0
	   * atan2(y, ±0)                = pi/2 for y > 0
	   * atan2(±y, -Infinity)        = ±pi for finite y > 0
	   * atan2(±y, +Infinity)        = ±0 for finite y > 0
	   * atan2(±Infinity, x)         = ±pi/2 for finite x
	   * atan2(±Infinity, -Infinity) = ±3*pi/4
	   * atan2(±Infinity, +Infinity) = ±pi/4
	   * atan2(NaN, x) = NaN
	   * atan2(y, NaN) = NaN
	   *
	   */
	  function atan2(y, x) {
	    y = new this(y);
	    x = new this(x);
	    var r,
	      pr = this.precision,
	      rm = this.rounding,
	      wpr = pr + 4;
	
	    // Either NaN
	    if (!y.s || !x.s) {
	      r = new this(NaN);
	
	    // Both ±Infinity
	    } else if (!y.d && !x.d) {
	      r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
	      r.s = y.s;
	
	    // x is ±Infinity or y is ±0
	    } else if (!x.d || y.isZero()) {
	      r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
	      r.s = y.s;
	
	    // y is ±Infinity or x is ±0
	    } else if (!y.d || x.isZero()) {
	      r = getPi(this, wpr, 1).times(0.5);
	      r.s = y.s;
	
	    // Both non-zero and finite
	    } else if (x.s < 0) {
	      this.precision = wpr;
	      this.rounding = 1;
	      r = this.atan(divide(y, x, wpr, 1));
	      x = getPi(this, wpr, 1);
	      this.precision = pr;
	      this.rounding = rm;
	      r = y.s < 0 ? r.minus(x) : r.plus(x);
	    } else {
	      r = this.atan(divide(y, x, wpr, 1));
	    }
	
	    return r;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function cbrt(x) {
	    return new this(x).cbrt();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function ceil(x) {
	    return finalise(x = new this(x), x.e + 1, 2);
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *   maxE       {number}
	   *   minE       {number}
	   *   modulo     {number}
	   *   crypto     {boolean|number}
	   *   defaults   {true}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
	    var i, p, v,
	      useDefaults = obj.defaults === true,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -EXP_LIMIT, 0,
	        'toExpPos', 0, EXP_LIMIT,
	        'maxE', 0, EXP_LIMIT,
	        'minE', -EXP_LIMIT, 0,
	        'modulo', 0, 9
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
	      if ((v = obj[p]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
	    if ((v = obj[p]) !== void 0) {
	      if (v === true || v === false || v === 0 || v === 1) {
	        if (v) {
	          if (typeof crypto != 'undefined' && crypto &&
	            (crypto.getRandomValues || crypto.randomBytes)) {
	            this[p] = true;
	          } else {
	            throw Error(cryptoUnavailable);
	          }
	        } else {
	          this[p] = false;
	        }
	      } else {
	        throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    return this;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function cos(x) {
	    return new this(x).cos();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function cosh(x) {
	    return new this(x).cosh();
	  }
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * v {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(v) {
	      var e, i, t,
	        x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(v);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (v instanceof Decimal) {
	        x.s = v.s;
	        x.e = v.e;
	        x.d = (v = v.d) ? v.slice() : v;
	        return;
	      }
	
	      t = typeof v;
	
	      if (t === 'number') {
	        if (v === 0) {
	          x.s = 1 / v < 0 ? -1 : 1;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        if (v < 0) {
	          v = -v;
	          x.s = -1;
	        } else {
	          x.s = 1;
	        }
	
	        // Fast path for small integers.
	        if (v === ~~v && v < 1e7) {
	          for (e = 0, i = v; i >= 10; i /= 10) e++;
	          x.e = e;
	          x.d = [v];
	          return;
	
	        // Infinity, NaN.
	        } else if (v * 0 !== 0) {
	          if (!v) x.s = NaN;
	          x.e = NaN;
	          x.d = null;
	          return;
	        }
	
	        return parseDecimal(x, v.toString());
	
	      } else if (t !== 'string') {
	        throw Error(invalidArgument + v);
	      }
	
	      // Minus sign?
	      if (v.charCodeAt(0) === 45) {
	        v = v.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	    Decimal.EUCLID = 9;
	
	    Decimal.config = Decimal.set = config;
	    Decimal.clone = clone;
	    Decimal.isDecimal = isDecimalInstance;
	
	    Decimal.abs = abs;
	    Decimal.acos = acos;
	    Decimal.acosh = acosh;        // ES6
	    Decimal.add = add;
	    Decimal.asin = asin;
	    Decimal.asinh = asinh;        // ES6
	    Decimal.atan = atan;
	    Decimal.atanh = atanh;        // ES6
	    Decimal.atan2 = atan2;
	    Decimal.cbrt = cbrt;          // ES6
	    Decimal.ceil = ceil;
	    Decimal.cos = cos;
	    Decimal.cosh = cosh;          // ES6
	    Decimal.div = div;
	    Decimal.exp = exp;
	    Decimal.floor = floor;
	    Decimal.hypot = hypot;        // ES6
	    Decimal.ln = ln;
	    Decimal.log = log;
	    Decimal.log10 = log10;        // ES6
	    Decimal.log2 = log2;          // ES6
	    Decimal.max = max;
	    Decimal.min = min;
	    Decimal.mod = mod;
	    Decimal.mul = mul;
	    Decimal.pow = pow;
	    Decimal.random = random;
	    Decimal.round = round;
	    Decimal.sign = sign;          // ES6
	    Decimal.sin = sin;
	    Decimal.sinh = sinh;          // ES6
	    Decimal.sqrt = sqrt;
	    Decimal.sub = sub;
	    Decimal.tan = tan;
	    Decimal.tanh = tanh;          // ES6
	    Decimal.trunc = trunc;        // ES6
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      if (obj.defaults !== true) {
	        ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'maxE', 'minE', 'modulo', 'crypto'];
	        for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	      }
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function div(x, y) {
	    return new this(x).div(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} The power to which to raise the base of the natural log.
	   *
	   */
	  function exp(x) {
	    return new this(x).exp();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function floor(x) {
	    return finalise(x = new this(x), x.e + 1, 3);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
	   * rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
	   *
	   */
	  function hypot() {
	    var i, n,
	      t = new this(0);
	
	    external = false;
	
	    for (i = 0; i < arguments.length;) {
	      n = new this(arguments[i++]);
	      if (!n.d) {
	        if (n.s) {
	          external = true;
	          return new this(1 / 0);
	        }
	        t = n;
	      } else if (t.d) {
	        t = t.plus(n.times(n));
	      }
	    }
	
	    external = true;
	
	    return t.sqrt();
	  }
	
	
	  /*
	   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
	   * otherwise return false.
	   *
	   */
	  function isDecimalInstance(obj) {
	    return obj instanceof Decimal || obj && obj.name === '[object Decimal]' || false;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function ln(x) {
	    return new this(x).ln();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
	   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
	   *
	   * log[y](x)
	   *
	   * x {number|string|Decimal} The argument of the logarithm.
	   * y {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  function log(x, y) {
	    return new this(x).log(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function log2(x) {
	    return new this(x).log(2);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function log10(x) {
	    return new this(x).log(10);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the maximum of the arguments.
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function max() {
	    return maxOrMin(this, arguments, 'lt');
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the minimum of the arguments.
	   *
	   * arguments {number|string|Decimal}
	   *
	   */
	  function min() {
	    return maxOrMin(this, arguments, 'gt');
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function mod(x, y) {
	    return new this(x).mod(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function mul(x, y) {
	    return new this(x).mul(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} The base.
	   * y {number|string|Decimal} The exponent.
	   *
	   */
	  function pow(x, y) {
	    return new this(x).pow(y);
	  }
	
	
	  /*
	   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
	   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
	   * are produced).
	   *
	   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
	   *
	   */
	  function random(sd) {
	    var d, e, k, n,
	      i = 0,
	      r = new this(1),
	      rd = [];
	
	    if (sd === void 0) sd = this.precision;
	    else checkInt32(sd, 1, MAX_DIGITS);
	
	    k = Math.ceil(sd / LOG_BASE);
	
	    if (!this.crypto) {
	      for (; i < k;) rd[i++] = Math.random() * 1e7 | 0;
	
	    // Browsers supporting crypto.getRandomValues.
	    } else if (crypto.getRandomValues) {
	      d = crypto.getRandomValues(new Uint32Array(k));
	
	      for (; i < k;) {
	        n = d[i];
	
	        // 0 <= n < 4294967296
	        // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
	        if (n >= 4.29e9) {
	          d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
	        } else {
	
	          // 0 <= n <= 4289999999
	          // 0 <= (n % 1e7) <= 9999999
	          rd[i++] = n % 1e7;
	        }
	      }
	
	    // Node.js supporting crypto.randomBytes.
	    } else if (crypto.randomBytes) {
	
	      // buffer
	      d = crypto.randomBytes(k *= 4);
	
	      for (; i < k;) {
	
	        // 0 <= n < 2147483648
	        n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
	
	        // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
	        if (n >= 2.14e9) {
	          crypto.randomBytes(4).copy(d, i);
	        } else {
	
	          // 0 <= n <= 2139999999
	          // 0 <= (n % 1e7) <= 9999999
	          rd.push(n % 1e7);
	          i += 4;
	        }
	      }
	
	      i = k / 4;
	    } else {
	      throw Error(cryptoUnavailable);
	    }
	
	    k = rd[--i];
	    sd %= LOG_BASE;
	
	    // Convert trailing digits to zeros according to sd.
	    if (k && sd) {
	      n = mathpow(10, LOG_BASE - sd);
	      rd[i] = (k / n | 0) * n;
	    }
	
	    // Remove trailing words which are zero.
	    for (; rd[i] === 0; i--) rd.pop();
	
	    // Zero?
	    if (i < 0) {
	      e = 0;
	      rd = [0];
	    } else {
	      e = -1;
	
	      // Remove leading words which are zero and adjust exponent accordingly.
	      for (; rd[0] === 0; e -= LOG_BASE) rd.shift();
	
	      // Count the digits of the first word of rd to determine leading zeros.
	      for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;
	
	      // Adjust the exponent for leading zeros of the first word of rd.
	      if (k < LOG_BASE) e -= LOG_BASE - k;
	    }
	
	    r.e = e;
	    r.d = rd;
	
	    return r;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
	   *
	   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function round(x) {
	    return finalise(x = new this(x), x.e + 1, this.rounding);
	  }
	
	
	  /*
	   * Return
	   *   1    if x > 0,
	   *  -1    if x < 0,
	   *   0    if x is 0,
	   *  -0    if x is -0,
	   *   NaN  otherwise
	   *
	   */
	  function sign(x) {
	    x = new this(x);
	    return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function sin(x) {
	    return new this(x).sin();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function sinh(x) {
	    return new this(x).sinh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function sqrt(x) {
	    return new this(x).sqrt();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
	   * using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal}
	   * y {number|string|Decimal}
	   *
	   */
	  function sub(x, y) {
	    return new this(x).sub(y);
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
	   * digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function tan(x) {
	    return new this(x).tan();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
	   * significant digits using rounding mode `rounding`.
	   *
	   * x {number|string|Decimal} A value in radians.
	   *
	   */
	  function tanh(x) {
	    return new this(x).tanh();
	  }
	
	
	  /*
	   * Return a new Decimal whose value is `x` truncated to an integer.
	   *
	   * x {number|string|Decimal}
	   *
	   */
	  function trunc(x) {
	    return finalise(x = new this(x), x.e + 1, 1);
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(DEFAULTS);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Create the internal constants from their string values.
	  LN10 = new Decimal(LN10);
	  PI = new Decimal(PI);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	  // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    noConflict = globalScope.Decimal;
	    Decimal.noConflict = function () {
	      globalScope.Decimal = noConflict;
	      return Decimal;
	    };
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a BigNumber, which can store numbers with arbitrary precision.
	   * When a matrix is provided, all elements will be converted to BigNumber.
	   *
	   * Syntax:
	   *
	   *    math.bignumber(x)
	   *
	   * Examples:
	   *
	   *    0.1 + 0.2;                                  // returns number 0.30000000000000004
	   *    math.bignumber(0.1) + math.bignumber(0.2);  // returns BigNumber 0.3
	   *
	   *
	   *    7.2e500;                                    // returns number Infinity
	   *    math.bignumber('7.2e500');                  // returns BigNumber 7.2e500
	   *
	   * See also:
	   *
	   *    boolean, complex, index, matrix, string, unit
	   *
	   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
	   *                                                    0 by default.
	   * @returns {BigNumber} The created bignumber
	   */
	  var bignumber = typed('bignumber', {
	    '': function () {
	      return new type.BigNumber(0);
	    },
	
	    'number': function (x) {
	      // convert to string to prevent errors in case of >15 digits
	      return new type.BigNumber(x + '');
	    },
	
	    'string': function (x) {
	      return new type.BigNumber(x);
	    },
	
	    'BigNumber': function (x) {
	      // we assume a BigNumber is immutable
	      return x;
	    },
	
	    'Fraction': function (x) {
	      return new type.BigNumber(x.n).div(x.d);
	    },
	
	    'null': function (x) {
	      return new type.BigNumber(0);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, bignumber);
	    }
	  });
	
	  bignumber.toTex = {
	    0: '0',
	    1: '\\left(${args[0]}\\right)'
	  };
	
	  return bignumber;
	}
	
	exports.name = 'bignumber';
	exports.factory = factory;


/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Execute the callback function element wise for each element in array and any
	 * nested array
	 * Returns an array with the results
	 * @param {Array | Matrix} array
	 * @param {Function} callback   The callback is called with two parameters:
	 *                              value1 and value2, which contain the current
	 *                              element of both arrays.
	 * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	 *
	 * @return {Array | Matrix} res
	 */
	module.exports = function deepMap(array, callback, skipZeros) {
	  if (array && (typeof array.map === 'function')) {
	    // TODO: replace array.map with a for loop to improve performance
	    return array.map(function (x) {
	      return deepMap(x, callback, skipZeros);
	    });
	  }
	  else {
	    return callback(array);
	  }
	};


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a boolean or convert a string or number to a boolean.
	   * In case of a number, `true` is returned for non-zero numbers, and `false` in
	   * case of zero.
	   * Strings can be `'true'` or `'false'`, or can contain a number.
	   * When value is a matrix, all elements will be converted to boolean.
	   *
	   * Syntax:
	   *
	   *    math.boolean(x)
	   *
	   * Examples:
	   *
	   *    math.boolean(0);     // returns false
	   *    math.boolean(1);     // returns true
	   *    math.boolean(-3);     // returns true
	   *    math.boolean('true');     // returns true
	   *    math.boolean('false');     // returns false
	   *    math.boolean([1, 0, 1, 1]);     // returns [true, false, true, true]
	   *
	   * See also:
	   *
	   *    bignumber, complex, index, matrix, string, unit
	   *
	   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
	   * @return {boolean | Array | Matrix} The boolean value
	   */
	  var bool = typed('bool', {
	    '': function () {
	      return false;
	    },
	
	    'boolean': function (x) {
	      return x;
	    },
	
	    'number': function (x) {
	      return !!x;
	    },
	
	    'null': function (x) {
	      return false;
	    },
	
	    'BigNumber': function (x) {
	      return !x.isZero();
	    },
	
	    'string': function (x) {
	      // try case insensitive
	      var lcase = x.toLowerCase();
	      if (lcase === 'true') {
	        return true;
	      }
	      else if (lcase === 'false') {
	        return false;
	      }
	
	      // test whether value is a valid number
	      var num = Number(x);
	      if (x != '' && !isNaN(num)) {
	        return !!num;
	      }
	
	      throw new Error('Cannot convert "' + x + '" to a boolean');
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, bool);
	    }
	  });
	
	  return bool;
	}
	
	exports.name = 'boolean';
	exports.factory = factory;


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1340),
	
	  // construction function
	  __webpack_require__(1343)
	];


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var format = __webpack_require__(1341).format;
	var lazy = __webpack_require__(1320).lazy;
	
	function factory (type, config, load, typed, math) {
	  /**
	   * @constructor Chain
	   * Wrap any value in a chain, allowing to perform chained operations on
	   * the value.
	   *
	   * All methods available in the math.js library can be called upon the chain,
	   * and then will be evaluated with the value itself as first argument.
	   * The chain can be closed by executing chain.done(), which will return
	   * the final value.
	   *
	   * The Chain has a number of special functions:
	   * - done()             Finalize the chained operation and return the
	   *                      chain's value.
	   * - valueOf()          The same as done()
	   * - toString()         Returns a string representation of the chain's value.
	   *
	   * @param {*} [value]
	   */
	  function Chain (value) {
	    if (!(this instanceof Chain)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (type.isChain(value)) {
	      this.value = value.value;
	    }
	    else {
	      this.value = value;
	    }
	  }
	
	  /**
	   * Attach type information
	   */
	  Chain.prototype.type = 'Chain';
	  Chain.prototype.isChain = true;
	
	  /**
	   * Close the chain. Returns the final value.
	   * Does the same as method valueOf()
	   * @returns {*} value
	   */
	  Chain.prototype.done = function () {
	    return this.value;
	  };
	
	  /**
	   * Close the chain. Returns the final value.
	   * Does the same as method done()
	   * @returns {*} value
	   */
	  Chain.prototype.valueOf = function () {
	    return this.value;
	  };
	
	  /**
	   * Get a string representation of the value in the chain
	   * @returns {string}
	   */
	  Chain.prototype.toString = function () {
	    return format(this.value);
	  };
	
	  /**
	   * Get a JSON representation of the chain
	   * @returns {Object}
	   */
	  Chain.prototype.toJSON = function () {
	    return {
	      mathjs: 'Chain',
	      value: this.value
	    };
	  };
	
	  /**
	   * Instantiate a Chain from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "Chain", value: ...}`,
	   *                       where mathjs is optional
	   * @returns {Chain}
	   */
	  Chain.fromJSON = function (json) {
	    return new Chain(json.value);
	  };
	
	  /**
	   * Create a proxy method for the chain
	   * @param {string} name
	   * @param {Function} fn      The function to be proxied
	   *                           If fn is no function, it is silently ignored.
	   * @private
	   */
	  function createProxy(name, fn) {
	    if (typeof fn === 'function') {
	      Chain.prototype[name] = chainify(fn);
	    }
	  }
	
	  /**
	   * Create a proxy method for the chain
	   * @param {string} name
	   * @param {function} resolver   The function resolving with the
	   *                              function to be proxied
	   * @private
	   */
	  function createLazyProxy(name, resolver) {
	    lazy(Chain.prototype, name, function outerResolver() {
	      var fn = resolver();
	      if (typeof fn === 'function') {
	        return chainify(fn);
	      }
	
	      return undefined; // if not a function, ignore
	    });
	  }
	
	  /**
	   * Make a function chainable
	   * @param {function} fn
	   * @return {Function} chain function
	   * @private
	   */
	  function chainify (fn) {
	    return function () {
	      var args = [this.value];  // `this` will be the context of a Chain instance
	      for (var i = 0; i < arguments.length; i++) {
	        args[i + 1] = arguments[i];
	      }
	
	      return new Chain(fn.apply(fn, args));
	    }
	  }
	
	  /**
	   * Create a proxy for a single method, or an object with multiple methods.
	   * Example usage:
	   *
	   *   Chain.createProxy('add', function add (x, y) {...});
	   *   Chain.createProxy({
	   *     add:      function add (x, y) {...},
	   *     subtract: function subtract (x, y) {...}
	   *   }
	   *
	   * @param {string | Object} arg0   A name (string), or an object with
	   *                                 functions
	   * @param {*} [arg1]               A function, when arg0 is a name
	   */
	  Chain.createProxy = function (arg0, arg1) {
	    if (typeof arg0 === 'string') {
	      // createProxy(name, value)
	      createProxy(arg0, arg1);
	    }
	    else {
	      // createProxy(values)
	      for (var prop in arg0) {
	        if (arg0.hasOwnProperty(prop)) {
	          createProxy(prop, arg0[prop]);
	        }
	      }
	    }
	  };
	
	  // create proxy for everything that is in math.js
	  Chain.createProxy(math);
	
	  // register on the import event, automatically add a proxy for every imported function.
	  math.on('import', function (name, resolver, path) {
	    if (path === undefined) {
	      // an imported function (not a data type or something special)
	      createLazyProxy(name, resolver);
	    }
	  });
	
	  return Chain;
	}
	
	exports.name = 'Chain';
	exports.path = 'type';
	exports.factory = factory;
	exports.math = true;  // require providing the math namespace as 5th argument
	exports.lazy = false; // we need to register a listener on the import events, so no lazy loading


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var formatNumber = __webpack_require__(1324).format;
	var formatBigNumber = __webpack_require__(1342).format;
	var isBigNumber = __webpack_require__(1321);
	
	/**
	 * Test whether value is a string
	 * @param {*} value
	 * @return {boolean} isString
	 */
	exports.isString = function(value) {
	  return typeof value === 'string';
	};
	
	/**
	 * Check if a text ends with a certain string.
	 * @param {string} text
	 * @param {string} search
	 */
	exports.endsWith = function(text, search) {
	  var start = text.length - search.length;
	  var end = text.length;
	  return (text.substring(start, end) === search);
	};
	
	/**
	 * Format a value of any type into a string.
	 *
	 * Usage:
	 *     math.format(value)
	 *     math.format(value, precision)
	 *
	 * When value is a function:
	 *
	 * - When the function has a property `syntax`, it returns this
	 *   syntax description.
	 * - In other cases, a string `'function'` is returned.
	 *
	 * When `value` is an Object:
	 *
	 * - When the object contains a property `format` being a function, this
	 *   function is invoked as `value.format(options)` and the result is returned.
	 * - When the object has its own `toString` method, this method is invoked
	 *   and the result is returned.
	 * - In other cases the function will loop over all object properties and
	 *   return JSON object notation like '{"a": 2, "b": 3}'.
	 *
	 * Example usage:
	 *     math.format(2/7);                // '0.2857142857142857'
	 *     math.format(math.pi, 3);         // '3.14'
	 *     math.format(new Complex(2, 3));  // '2 + 3i'
	 *     math.format('hello');            // '"hello"'
	 *
	 * @param {*} value             Value to be stringified
	 * @param {Object | number | Function} [options]  Formatting options. See
	 *                                                lib/utils/number:format for a
	 *                                                description of the available
	 *                                                options.
	 * @return {string} str
	 */
	exports.format = function(value, options) {
	  if (typeof value === 'number') {
	    return formatNumber(value, options);
	  }
	
	  if (isBigNumber(value)) {
	    return formatBigNumber(value, options);
	  }
	
	  // note: we use unsafe duck-typing here to check for Fractions, this is
	  // ok here since we're only invoking toString or concatenating its values
	  if (looksLikeFraction(value)) {
	    if (!options || options.fraction !== 'decimal') {
	      // output as ratio, like '1/3'
	      return (value.s * value.n) + '/' + value.d;
	    }
	    else {
	      // output as decimal, like '0.(3)'
	      return value.toString();
	    }
	  }
	
	  if (Array.isArray(value)) {
	    return formatArray(value, options);
	  }
	
	  if (exports.isString(value)) {
	    return '"' + value + '"';
	  }
	
	  if (typeof value === 'function') {
	    return value.syntax ? String(value.syntax) : 'function';
	  }
	
	  if (value && typeof value === 'object') {
	    if (typeof value.format === 'function') {
	      return value.format(options);
	    }
	    else if (value && value.toString() !== {}.toString()) {
	      // this object has a non-native toString method, use that one
	      return value.toString();
	    }
	    else {
	      var entries = [];
	
	      for (var key in value) {
	        if (value.hasOwnProperty(key)) {
	          entries.push('"' + key + '": ' + exports.format(value[key], options));
	        }
	      }
	
	      return '{' + entries.join(', ') + '}';
	    }
	  }
	
	  return String(value);
	};
	
	/**
	 * Stringify a value into a string enclosed in double quotes.
	 * Unescaped double quotes and backslashes inside the value are escaped.
	 * @param {*} value
	 * @return {string}
	 */
	exports.stringify = function (value) {
	  var text = String(value);
	  var escaped = '';
	  var i = 0;
	  while (i < text.length) {
	    var c = text.charAt(i);
	
	    if (c === '\\') {
	      escaped += c;
	      i++;
	
	      c = text.charAt(i);
	      if (c === '' || '"\\/bfnrtu'.indexOf(c) === -1) {
	        escaped += '\\';  // no valid escape character -> escape it
	      }
	      escaped += c;
	    }
	    else if (c === '"') {
	      escaped += '\\"';
	    }
	    else {
	      escaped += c;
	    }
	    i++;
	  }
	
	  return '"' + escaped + '"';
	}
	
	/**
	 * Escape special HTML characters
	 * @param {*} value
	 * @return {string}
	 */
	exports.escape = function (value) {
	  var text = String(value);
	  text = text.replace(/&/g, '&amp;')
				 .replace(/"/g, '&quot;')
				 .replace(/'/g, '&#39;')
				 .replace(/</g, '&lt;')
				 .replace(/>/g, '&gt;');
	  
	  return text;
	}
	
	/**
	 * Recursively format an n-dimensional matrix
	 * Example output: "[[1, 2], [3, 4]]"
	 * @param {Array} array
	 * @param {Object | number | Function} [options]  Formatting options. See
	 *                                                lib/utils/number:format for a
	 *                                                description of the available
	 *                                                options.
	 * @returns {string} str
	 */
	function formatArray (array, options) {
	  if (Array.isArray(array)) {
	    var str = '[';
	    var len = array.length;
	    for (var i = 0; i < len; i++) {
	      if (i != 0) {
	        str += ', ';
	      }
	      str += formatArray(array[i], options);
	    }
	    str += ']';
	    return str;
	  }
	  else {
	    return exports.format(array, options);
	  }
	}
	
	/**
	 * Check whether a value looks like a Fraction (unsafe duck-type check)
	 * @param {*} value
	 * @return {boolean}
	 */
	function looksLikeFraction (value) {
	  return (value &&
	      typeof value === 'object' &&
	      typeof value.s === 'number' &&
	      typeof value.n === 'number' &&
	      typeof value.d === 'number') || false;
	}


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var objectUtils = __webpack_require__(1320);
	
	/**
	 * Convert a BigNumber to a formatted string representation.
	 *
	 * Syntax:
	 *
	 *    format(value)
	 *    format(value, options)
	 *    format(value, precision)
	 *    format(value, fn)
	 *
	 * Where:
	 *
	 *    {number} value   The value to be formatted
	 *    {Object} options An object with formatting options. Available options:
	 *                     {string} notation
	 *                         Number notation. Choose from:
	 *                         'fixed'          Always use regular number notation.
	 *                                          For example '123.40' and '14000000'
	 *                         'exponential'    Always use exponential notation.
	 *                                          For example '1.234e+2' and '1.4e+7'
	 *                         'auto' (default) Regular number notation for numbers
	 *                                          having an absolute value between
	 *                                          `lower` and `upper` bounds, and uses
	 *                                          exponential notation elsewhere.
	 *                                          Lower bound is included, upper bound
	 *                                          is excluded.
	 *                                          For example '123.4' and '1.4e7'.
	 *                     {number} precision   A number between 0 and 16 to round
	 *                                          the digits of the number.
	 *                                          In case of notations 'exponential' and
	 *                                          'auto', `precision` defines the total
	 *                                          number of significant digits returned.
	 *                                          In case of notation 'fixed',
	 *                                          `precision` defines the number of
	 *                                          significant digits after the decimal 
	 *                                          point. 
	 *                                          `precision` is undefined by default.
	 *                     {number} lowerExp    Exponent determining the lower boundary
	 *                                          for formatting a value with an exponent
	 *                                          when `notation='auto`. 
	 *                                          Default value is `-3`.
	 *                     {number} upperExp    Exponent determining the upper boundary
	 *                                          for formatting a value with an exponent
	 *                                          when `notation='auto`. 
	 *                                          Default value is `5`.
	 *    {Function} fn    A custom formatting function. Can be used to override the
	 *                     built-in notations. Function `fn` is called with `value` as
	 *                     parameter and must return a string. Is useful for example to
	 *                     format all values inside a matrix in a particular way.
	 *
	 * Examples:
	 *
	 *    format(6.4);                                        // '6.4'
	 *    format(1240000);                                    // '1.24e6'
	 *    format(1/3);                                        // '0.3333333333333333'
	 *    format(1/3, 3);                                     // '0.333'
	 *    format(21385, 2);                                   // '21000'
	 *    format(12e8, {notation: 'fixed'});                  // returns '1200000000'
	 *    format(2.3,    {notation: 'fixed', precision: 4});  // returns '2.3000'
	 *    format(52.8,   {notation: 'exponential'});          // returns '5.28e+1'
	 *    format(12400,  {notation: 'engineering'});          // returns '12.400e+3'
	 *
	 * @param {BigNumber} value
	 * @param {Object | Function | number} [options]
	 * @return {string} str The formatted value
	 */
	exports.format = function (value, options) {
	  if (typeof options === 'function') {
	    // handle format(value, fn)
	    return options(value);
	  }
	
	  // handle special cases
	  if (!value.isFinite()) {
	    return value.isNaN() ? 'NaN' : (value.gt(0) ? 'Infinity' : '-Infinity');
	  }
	
	  // default values for options
	  var notation = 'auto';
	  var precision = undefined;
	
	  if (options !== undefined) {
	    // determine notation from options
	    if (options.notation) {
	      notation = options.notation;
	    }
	
	    // determine precision from options
	    if (typeof options === 'number') {
	      precision = options;
	    }
	    else if (options.precision) {
	      precision = options.precision;
	    }
	  }
	
	  // handle the various notations
	  switch (notation) {
	    case 'fixed':
	      return exports.toFixed(value, precision);
	
	    case 'exponential':
	      return exports.toExponential(value, precision);
	
	    case 'auto':
	      // TODO: clean up some day. Deprecated since: 2018-01-24
	      // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
	      if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
	        var fixedOptions = objectUtils.map(options, function (x) { return x; });
	        fixedOptions.exponential = undefined;
	        if (options.exponential.lower !== undefined) {
	          fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
	        }
	        if (options.exponential.upper !== undefined) {
	          fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
	        }
	
	        console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + 
	            '(minimum and maximum value) ' +
	            'are replaced with exponential.lowerExp and exponential.upperExp ' + 
	            '(minimum and maximum exponent) since version 4.0.0. ' + 
	            'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));
	
	        return exports.format(value, fixedOptions);
	      }
	
	      // determine lower and upper bound for exponential notation.
	      // TODO: implement support for upper and lower to be BigNumbers themselves
	      var lowerExp = (options && options.lowerExp !== undefined) ? options.lowerExp : -3;
	      var upperExp = (options && options.upperExp !== undefined) ? options.upperExp : 5;
	
	      // handle special case zero
	      if (value.isZero()) return '0';
	
	      // determine whether or not to output exponential notation
	      var str;
	      var exp = value.logarithm();
	      if (exp.gte(lowerExp) && exp.lt(upperExp)) {
	        // normal number notation
	        str = value.toSignificantDigits(precision).toFixed();
	      }
	      else {
	        // exponential notation
	        str = exports.toExponential(value, precision);
	      }
	
	      // remove trailing zeros after the decimal point
	      return str.replace(/((\.\d*?)(0+))($|e)/, function () {
	        var digits = arguments[2];
	        var e = arguments[4];
	        return (digits !== '.') ? digits + e : e;
	      });
	
	    default:
	      throw new Error('Unknown notation "' + notation + '". ' +
	          'Choose "auto", "exponential", or "fixed".');
	  }
	};
	
	/**
	 * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
	 * @param {BigNumber} value
	 * @param {number} [precision]  Number of digits in formatted output.
	 *                              If not provided, the maximum available digits
	 *                              is used.
	 * @returns {string} str
	 */
	exports.toExponential = function (value, precision) {
	  if (precision !== undefined) {
	    return value.toExponential(precision - 1); // Note the offset of one
	  }
	  else {
	    return value.toExponential();
	  }
	};
	
	/**
	 * Format a number with fixed notation.
	 * @param {BigNumber} value
	 * @param {number} [precision=undefined] Optional number of decimals after the
	 *                                       decimal point. Undefined by default.
	 */
	exports.toFixed = function (value, precision) {
	  return value.toFixed(precision);
	};


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * Wrap any value in a chain, allowing to perform chained operations on
	   * the value.
	   *
	   * All methods available in the math.js library can be called upon the chain,
	   * and then will be evaluated with the value itself as first argument.
	   * The chain can be closed by executing `chain.done()`, which returns
	   * the final value.
	   *
	   * The chain has a number of special functions:
	   *
	   * - `done()`     Finalize the chain and return the chain's value.
	   * - `valueOf()`  The same as `done()`
	   * - `toString()` Executes `math.format()` onto the chain's value, returning
	   *                a string representation of the value.
	   *
	   * Syntax:
	   *
	   *    math.chain(value)
	   *
	   * Examples:
	   *
	   *     math.chain(3)
	   *         .add(4)
	   *         .subtract(2)
	   *         .done();     // 5
	   *
	   *     math.chain( [[1, 2], [3, 4]] )
	   *         .subset(math.index(0, 0), 8)
	   *         .multiply(3)
	   *         .done();     // [[24, 6], [9, 12]]
	   *
	   * @param {*} [value]   A value of any type on which to start a chained operation.
	   * @return {math.type.Chain} The created chain
	   */
	  return typed('chain', {
	    '': function() {
	      return new type.Chain();
	    },
	
	    'any': function(value) {
	      return new type.Chain(value);
	    }
	  });
	}
	
	exports.name = 'chain';
	exports.factory = factory;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1345),
	
	  // construction function
	  __webpack_require__(1347)
	];


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Complex = __webpack_require__(1346);
	var format = __webpack_require__(1324).format;
	var isNumber = __webpack_require__(1324).isNumber;
	
	function factory (type, config, load, typed, math) {
	
	  /**
	   * Attach type information
	   */
	  Complex.prototype.type = 'Complex';
	  Complex.prototype.isComplex = true;
	
	
	  /**
	   * Get a JSON representation of the complex number
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
	   */
	  Complex.prototype.toJSON = function () {
	    return {
	      mathjs: 'Complex',
	      re: this.re,
	      im: this.im
	    };
	  };
	
	  /*
	   * Return the value of the complex number in polar notation
	   * The angle phi will be set in the interval of [-pi, pi].
	   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
	   */
	  Complex.prototype.toPolar = function () {
	    return {
	      r: this.abs(),
	      phi: this.arg()
	    };
	  };
	
	  /**
	   * Get a string representation of the complex number,
	   * with optional formatting options.
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @return {string} str
	   */
	  Complex.prototype.format = function (options) {
	    var str = '';
	    var im = this.im;
	    var re = this.re;
	    var strRe = format(this.re, options);
	    var strIm = format(this.im, options);
	
	    // round either re or im when smaller than the configured precision
	    var precision = isNumber(options) ? options : options ? options.precision : null;
	    if (precision !== null) {
	      var epsilon = Math.pow(10, -precision);
	      if (Math.abs(re / im) < epsilon) {
	        re = 0;
	      }
	      if (Math.abs(im / re) < epsilon) {
	        im = 0;
	      }
	    }
	
	    if (im == 0) {
	      // real value
	      str = strRe;
	    } else if (re == 0) {
	      // purely complex value
	      if (im == 1) {
	        str = 'i';
	      } else if (im == -1) {
	        str = '-i';
	      } else {
	        str = strIm + 'i';
	      }
	    } else {
	      // complex value
	      if (im < 0) {
	        if (im == -1) {
	          str = strRe + ' - i';
	        } else {
	          str = strRe + ' - ' + strIm.substring(1) + 'i';
	        }
	      } else {
	        if (im == 1) {
	          str = strRe + ' + i';
	        } else {
	          str = strRe + ' + ' + strIm + 'i';
	        }
	      }
	    }
	    return str;
	  };
	
	  /**
	   * Create a complex number from polar coordinates
	   *
	   * Usage:
	   *
	   *     Complex.fromPolar(r: number, phi: number) : Complex
	   *     Complex.fromPolar({r: number, phi: number}) : Complex
	   *
	   * @param {*} args...
	   * @return {Complex}
	   */
	  Complex.fromPolar = function (args) {
	    switch (arguments.length) {
	      case 1:
	        var arg = arguments[0];
	        if (typeof arg === 'object') {
	          return Complex(arg);
	        }
	        throw new TypeError('Input has to be an object with r and phi keys.');
	
	      case 2:
	        var r = arguments[0],
	            phi = arguments[1];
	        if (isNumber(r)) {
	          if (type.isUnit(phi) && phi.hasBase('ANGLE')) {
	            // convert unit to a number in radians
	            phi = phi.toNumber('rad');
	          }
	
	          if (isNumber(phi)) {
	            return new Complex({r: r, phi: phi});
	          }
	
	          throw new TypeError('Phi is not a number nor an angle unit.');
	        } else {
	          throw new TypeError('Radius r is not a number.');
	        }
	
	      default:
	        throw new SyntaxError('Wrong number of arguments in function fromPolar');
	    }
	  };
	
	
	  Complex.prototype.valueOf = Complex.prototype.toString;
	
	  /**
	   * Create a Complex number from a JSON object
	   * @param {Object} json  A JSON Object structured as
	   *                       {"mathjs": "Complex", "re": 2, "im": 3}
	   *                       All properties are optional, default values
	   *                       for `re` and `im` are 0.
	   * @return {Complex} Returns a new Complex number
	   */
	  Complex.fromJSON = function (json) {
	    return new Complex(json);
	  };
	
	  // apply the current epsilon
	  Complex.EPSILON = config.epsilon;
	
	  // listen for changed in the configuration, automatically apply changed epsilon
	  math.on('config', function (curr, prev) {
	    if (curr.epsilon !== prev.epsilon) {
	      Complex.EPSILON = curr.epsilon;
	    }
	  });
	
	  /**
	   * Compare two complex numbers, `a` and `b`:
	   *
	   * - Returns 1 when the real part of `a` is larger than the real part of `b`
	   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
	   * - Returns 1 when the real parts are equal
	   *   and the imaginary part of `a` is larger than the imaginary part of `b`
	   * - Returns -1 when the real parts are equal
	   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
	   * - Returns 0 when both real and imaginary parts are equal.
	   *
	   * @params {Complex} a
	   * @params {Complex} b
	   * @returns {number} Returns the comparison result: -1, 0, or 1
	   */
	  Complex.compare = function (a, b) {
	    if (a.re > b.re) { return 1; }
	    if (a.re < b.re) { return -1; }
	
	    if (a.im > b.im) { return 1; }
	    if (a.im < b.im) { return -1; }
	
	    return 0;
	  }
	
	  return Complex;
	}
	
	exports.name = 'Complex';
	exports.path = 'type';
	exports.factory = factory;
	exports.math = true; // request access to the math namespace


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/**
	 * @license Complex.js v2.0.10 11/02/2016
	 *
	 * Copyright (c) 2016, Robert Eisele (robert@xarg.org)
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 **/
	
	/**
	 *
	 * This class allows the manipulation of complex numbers.
	 * You can pass a complex number in different formats. Either as object, double, string or two integer parameters.
	 *
	 * Object form
	 * { re: <real>, im: <imaginary> }
	 * { arg: <angle>, abs: <radius> }
	 * { phi: <angle>, r: <radius> }
	 *
	 * Array / Vector form
	 * [ real, imaginary ]
	 *
	 * Double form
	 * 99.3 - Single double value
	 *
	 * String form
	 * '23.1337' - Simple real number
	 * '15+3i' - a simple complex number
	 * '3-i' - a simple complex number
	 *
	 * Example:
	 *
	 * var c = new Complex('99.3+8i');
	 * c.mul({r: 3, i: 9}).div(4.9).sub(3, 2);
	 *
	 */
	
	(function(root) {
	
	  'use strict';
	
	  var cosh = function(x) {
	    return (Math.exp(x) + Math.exp(-x)) * 0.5;
	  };
	
	  var sinh = function(x) {
	    return (Math.exp(x) - Math.exp(-x)) * 0.5;
	  };
	
	  /**
	   * Calculates cos(x) - 1 using Taylor series if x is small.
	   *
	   * @param {number} x
	   * @returns {number} cos(x) - 1
	   */
	
	  var cosm1 = function(x) {
	    var limit = Math.PI/4;
	    if (x < -limit || x > limit) {
	      return (Math.cos(x) - 1.0);
	    }
	
	    var xx = x * x;
	    return xx *
	      (-0.5 + xx *
	        (1/24 + xx *
	          (-1/720 + xx *
	            (1/40320 + xx *
	              (-1/3628800 + xx *
	                (1/4790014600 + xx *
	                  (-1/87178291200 + xx *
	                    (1/20922789888000)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	  };
	
	  var hypot = function(x, y) {
	
	    var a = Math.abs(x);
	    var b = Math.abs(y);
	
	    if (a < 3000 && b < 3000) {
	      return Math.sqrt(a * a + b * b);
	    }
	
	    if (a < b) {
	      a = b;
	      b = x / y;
	    } else {
	      b = y / x;
	    }
	    return a * Math.sqrt(1 + b * b);
	  };
	
	  var parser_exit = function() {
	    throw SyntaxError('Invalid Param');
	  };
	
	  /**
	   * Calculates log(sqrt(a^2+b^2)) in a way to avoid overflows
	   *
	   * @param {number} a
	   * @param {number} b
	   * @returns {number}
	   */
	  function logHypot(a, b) {
	
	    var _a = Math.abs(a);
	    var _b = Math.abs(b);
	
	    if (a === 0) {
	      return Math.log(_b);
	    }
	
	    if (b === 0) {
	      return Math.log(_a);
	    }
	
	    if (_a < 3000 && _b < 3000) {
	      return Math.log(a * a + b * b) * 0.5;
	    }
	
	    /* I got 4 ideas to compute this property without overflow:
	     *
	     * Testing 1000000 times with random samples for a,b ∈ [1, 1000000000] against a big decimal library to get an error estimate
	     *
	     * 1. Only eliminate the square root: (OVERALL ERROR: 3.9122483030951116e-11)
	
	     Math.log(a * a + b * b) / 2
	
	     *
	     *
	     * 2. Try to use the non-overflowing pythagoras: (OVERALL ERROR: 8.889760039210159e-10)
	
	     var fn = function(a, b) {
	     a = Math.abs(a);
	     b = Math.abs(b);
	     var t = Math.min(a, b);
	     a = Math.max(a, b);
	     t = t / a;
	
	     return Math.log(a) + Math.log(1 + t * t) / 2;
	     };
	
	     * 3. Abuse the identity cos(atan(y/x) = x / sqrt(x^2+y^2): (OVERALL ERROR: 3.4780178737037204e-10)
	
	     Math.log(a / Math.cos(Math.atan2(b, a)))
	
	     * 4. Use 3. and apply log rules: (OVERALL ERROR: 1.2014087502620896e-9)
	
	     Math.log(a) - Math.log(Math.cos(Math.atan2(b, a)))
	
	     */
	
	    return Math.log(a / Math.cos(Math.atan2(b, a)));
	  }
	
	  var parse = function(a, b) {
	
	    var z = {'re': 0, 'im': 0};
	
	    if (a === undefined || a === null) {
	      z['re'] =
	              z['im'] = 0;
	    } else if (b !== undefined) {
	      z['re'] = a;
	      z['im'] = b;
	    } else
	      switch (typeof a) {
	
	        case 'object':
	
	          if ('im' in a && 're' in a) {
	            z['re'] = a['re'];
	            z['im'] = a['im'];
	          } else if ('abs' in a && 'arg' in a) {
	            if (!Number.isFinite(a['abs']) && Number.isFinite(a['arg'])) {
	              return Complex['INFINITY'];
	            }
	            z['re'] = a['abs'] * Math.cos(a['arg']);
	            z['im'] = a['abs'] * Math.sin(a['arg']);
	          } else if ('r' in a && 'phi' in a) {
	            if (!Number.isFinite(a['r']) && Number.isFinite(a['phi'])) {
	              return Complex['INFINITY'];
	            }
	            z['re'] = a['r'] * Math.cos(a['phi']);
	            z['im'] = a['r'] * Math.sin(a['phi']);
	          } else if (a.length === 2) { // Quick array check
	            z['re'] = a[0];
	            z['im'] = a[1];
	          } else {
	            parser_exit();
	          }
	          break;
	
	        case 'string':
	
	          z['im'] = /* void */
	                  z['re'] = 0;
	
	          var tokens = a.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
	          var plus = 1;
	          var minus = 0;
	
	          if (tokens === null) {
	            parser_exit();
	          }
	
	          for (var i = 0; i < tokens.length; i++) {
	
	            var c = tokens[i];
	
	            if (c === ' ' || c === '\t' || c === '\n') {
	              /* void */
	            } else if (c === '+') {
	              plus++;
	            } else if (c === '-') {
	              minus++;
	            } else if (c === 'i' || c === 'I') {
	
	              if (plus + minus === 0) {
	                parser_exit();
	              }
	
	              if (tokens[i + 1] !== ' ' && !isNaN(tokens[i + 1])) {
	                z['im'] += parseFloat((minus % 2 ? '-' : '') + tokens[i + 1]);
	                i++;
	              } else {
	                z['im'] += parseFloat((minus % 2 ? '-' : '') + '1');
	              }
	              plus = minus = 0;
	
	            } else {
	
	              if (plus + minus === 0 || isNaN(c)) {
	                parser_exit();
	              }
	
	              if (tokens[i + 1] === 'i' || tokens[i + 1] === 'I') {
	                z['im'] += parseFloat((minus % 2 ? '-' : '') + c);
	                i++;
	              } else {
	                z['re'] += parseFloat((minus % 2 ? '-' : '') + c);
	              }
	              plus = minus = 0;
	            }
	          }
	
	          // Still something on the stack
	          if (plus + minus > 0) {
	            parser_exit();
	          }
	          break;
	
	        case 'number':
	          z['im'] = 0;
	          z['re'] = a;
	          break;
	
	        default:
	          parser_exit();
	      }
	
	    if (isNaN(z['re']) || isNaN(z['im'])) {
	      // If a calculation is NaN, we treat it as NaN and don't throw
	      //parser_exit();
	    }
	
	    return z;
	  };
	
	  /**
	   * @constructor
	   * @returns {Complex}
	   */
	  function Complex(a, b) {
	
	    if (!(this instanceof Complex)) {
	      return new Complex(a, b);
	    }
	
	    var z = parse(a, b);
	
	    this['re'] = z['re'];
	    this['im'] = z['im'];
	  }
	
	  Complex.prototype = {
	
	    're': 0,
	    'im': 0,
	
	    /**
	     * Calculates the sign of a complex number, which is a normalized complex
	     *
	     * @returns {Complex}
	     */
	    'sign': function() {
	
	      var abs = this['abs']();
	
	      return new Complex(
	              this['re'] / abs,
	              this['im'] / abs);
	    },
	
	    /**
	     * Adds two complex numbers
	     *
	     * @returns {Complex}
	     */
	    'add': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      // Infinity + Infinity = NaN
	      if (this.isInfinite() && z.isInfinite()) {
	        return Complex['NAN'];
	      }
	
	      // Infinity + z = Infinity { where z != Infinity }
	      if (this.isInfinite() || z.isInfinite()) {
	        return Complex['INFINITY'];
	      }
	
	      return new Complex(
	              this['re'] + z['re'],
	              this['im'] + z['im']);
	    },
	
	    /**
	     * Subtracts two complex numbers
	     *
	     * @returns {Complex}
	     */
	    'sub': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      // Infinity - Infinity = NaN
	      if (this.isInfinite() && z.isInfinite()) {
	        return Complex['NAN'];
	      }
	
	      // Infinity - z = Infinity { where z != Infinity }
	      if (this.isInfinite() || z.isInfinite()) {
	        return Complex['INFINITY'];
	      }
	
	      return new Complex(
	              this['re'] - z['re'],
	              this['im'] - z['im']);
	    },
	
	    /**
	     * Multiplies two complex numbers
	     *
	     * @returns {Complex}
	     */
	    'mul': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      // Infinity * 0 = NaN
	      if ((this.isInfinite() && z.isZero()) || (this.isZero() && z.isInfinite())) {
	        return Complex['NAN'];
	      }
	
	      // Infinity * z = Infinity { where z != 0 }
	      if (this.isInfinite() || z.isInfinite()) {
	        return Complex['INFINITY'];
	      }
	
	      // Short circuit for real values
	      if (z['im'] === 0 && this['im'] === 0) {
	        return new Complex(this['re'] * z['re'], 0);
	      }
	
	      return new Complex(
	              this['re'] * z['re'] - this['im'] * z['im'],
	              this['re'] * z['im'] + this['im'] * z['re']);
	    },
	
	    /**
	     * Divides two complex numbers
	     *
	     * @returns {Complex}
	     */
	    'div': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      // 0 / 0 = NaN and Infinity / Infinity = NaN
	      if ((this.isZero() && z.isZero()) || (this.isInfinite() && z.isInfinite())) {
	        return Complex['NAN'];
	      }
	
	      // Infinity / 0 = Infinity
	      if (this.isInfinite() || z.isZero()) {
	        return Complex['INFINITY'];
	      }
	
	      // 0 / Infinity = 0
	      if (this.isZero() || z.isInfinite()) {
	        return Complex['ZERO'];
	      }
	
	      a = this['re'];
	      b = this['im'];
	
	      var c = z['re'];
	      var d = z['im'];
	      var t, x;
	
	      if (0 === d) {
	        // Divisor is real
	        return new Complex(a / c, b / c);
	      }
	
	      if (Math.abs(c) < Math.abs(d)) {
	
	        x = c / d;
	        t = c * x + d;
	
	        return new Complex(
	                (a * x + b) / t,
	                (b * x - a) / t);
	
	      } else {
	
	        x = d / c;
	        t = d * x + c;
	
	        return new Complex(
	                (a + b * x) / t,
	                (b - a * x) / t);
	      }
	    },
	
	    /**
	     * Calculate the power of two complex numbers
	     *
	     * @returns {Complex}
	     */
	    'pow': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      a = this['re'];
	      b = this['im'];
	
	      if (z.isZero()) {
	        return Complex['ONE'];
	      }
	
	      // If the exponent is real
	      if (z['im'] === 0) {
	
	        if (b === 0 && a >= 0) {
	
	          return new Complex(Math.pow(a, z['re']), 0);
	
	        } else if (a === 0) { // If base is fully imaginary
	
	          switch ((z['re'] % 4 + 4) % 4) {
	            case 0:
	              return new Complex(Math.pow(b, z['re']), 0);
	            case 1:
	              return new Complex(0, Math.pow(b, z['re']));
	            case 2:
	              return new Complex(-Math.pow(b, z['re']), 0);
	            case 3:
	              return new Complex(0, -Math.pow(b, z['re']));
	          }
	        }
	      }
	
	      /* I couldn't find a good formula, so here is a derivation and optimization
	       *
	       * z_1^z_2 = (a + bi)^(c + di)
	       *         = exp((c + di) * log(a + bi)
	       *         = pow(a^2 + b^2, (c + di) / 2) * exp(i(c + di)atan2(b, a))
	       * =>...
	       * Re = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * cos(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
	       * Im = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * sin(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
	       *
	       * =>...
	       * Re = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * cos(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
	       * Im = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * sin(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
	       *
	       * =>
	       * Re = exp(c * logsq2 - d * arg(z_1)) * cos(d * logsq2 + c * arg(z_1))
	       * Im = exp(c * logsq2 - d * arg(z_1)) * sin(d * logsq2 + c * arg(z_1))
	       *
	       */
	
	      if (a === 0 && b === 0 && z['re'] > 0 && z['im'] >= 0) {
	        return Complex['ZERO'];
	      }
	
	      var arg = Math.atan2(b, a);
	      var loh = logHypot(a, b);
	
	      a = Math.exp(z['re'] * loh - z['im'] * arg);
	      b = z['im'] * loh + z['re'] * arg;
	      return new Complex(
	              a * Math.cos(b),
	              a * Math.sin(b));
	    },
	
	    /**
	     * Calculate the complex square root
	     *
	     * @returns {Complex}
	     */
	    'sqrt': function() {
	
	      var a = this['re'];
	      var b = this['im'];
	      var r = this['abs']();
	
	      var re, im;
	
	      if (a >= 0) {
	
	        if (b === 0) {
	          return new Complex(Math.sqrt(a), 0);
	        }
	
	        re = 0.5 * Math.sqrt(2.0 * (r + a));
	      } else {
	        re = Math.abs(b) / Math.sqrt(2 * (r - a));
	      }
	
	      if (a <= 0) {
	        im = 0.5 * Math.sqrt(2.0 * (r - a));
	      } else {
	        im = Math.abs(b) / Math.sqrt(2 * (r + a));
	      }
	
	      return new Complex(re, b < 0 ? -im : im);
	    },
	
	    /**
	     * Calculate the complex exponent
	     *
	     * @returns {Complex}
	     */
	    'exp': function() {
	
	      var tmp = Math.exp(this['re']);
	
	      if (this['im'] === 0) {
	        //return new Complex(tmp, 0);
	      }
	      return new Complex(
	              tmp * Math.cos(this['im']),
	              tmp * Math.sin(this['im']));
	    },
	
	    /**
	     * Calculate the complex exponent and subtracts one.
	     *
	     * This may be more accurate than `Complex(x).exp().sub(1)` if
	     * `x` is small.
	     *
	     * @returns {Complex}
	     */
	    'expm1': function() {
	
	      /**
	       * exp(a + i*b) - 1
	       = exp(a) * (cos(b) + j*sin(b)) - 1
	       = expm1(a)*cos(b) + cosm1(b) + j*exp(a)*sin(b)
	       */
	
	      var a = this['re'];
	      var b = this['im'];
	
	      return new Complex(
	              Math.expm1(a) * Math.cos(b) + cosm1(b),
	              Math.exp(a) * Math.sin(b));
	    },
	
	    /**
	     * Calculate the natural log
	     *
	     * @returns {Complex}
	     */
	    'log': function() {
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (b === 0 && a > 0) {
	        //return new Complex(Math.log(a), 0);
	      }
	
	      return new Complex(
	              logHypot(a, b),
	              Math.atan2(b, a));
	    },
	
	    /**
	     * Calculate the magnitude of the complex number
	     *
	     * @returns {number}
	     */
	    'abs': function() {
	
	      return hypot(this['re'], this['im']);
	    },
	
	    /**
	     * Calculate the angle of the complex number
	     *
	     * @returns {number}
	     */
	    'arg': function() {
	
	      return Math.atan2(this['im'], this['re']);
	    },
	
	    /**
	     * Calculate the sine of the complex number
	     *
	     * @returns {Complex}
	     */
	    'sin': function() {
	
	      // sin(c) = (e^b - e^(-b)) / (2i)
	
	      var a = this['re'];
	      var b = this['im'];
	
	      return new Complex(
	              Math.sin(a) * cosh(b),
	              Math.cos(a) * sinh(b));
	    },
	
	    /**
	     * Calculate the cosine
	     *
	     * @returns {Complex}
	     */
	    'cos': function() {
	
	      // cos(z) = (e^b + e^(-b)) / 2
	
	      var a = this['re'];
	      var b = this['im'];
	
	      return new Complex(
	              Math.cos(a) * cosh(b),
	              -Math.sin(a) * sinh(b));
	    },
	
	    /**
	     * Calculate the tangent
	     *
	     * @returns {Complex}
	     */
	    'tan': function() {
	
	      // tan(c) = (e^(ci) - e^(-ci)) / (i(e^(ci) + e^(-ci)))
	
	      var a = 2 * this['re'];
	      var b = 2 * this['im'];
	      var d = Math.cos(a) + cosh(b);
	
	      return new Complex(
	              Math.sin(a) / d,
	              sinh(b) / d);
	    },
	
	    /**
	     * Calculate the cotangent
	     *
	     * @returns {Complex}
	     */
	    'cot': function() {
	
	      // cot(c) = i(e^(ci) + e^(-ci)) / (e^(ci) - e^(-ci))
	
	      var a = 2 * this['re'];
	      var b = 2 * this['im'];
	      var d = Math.cos(a) - cosh(b);
	
	      return new Complex(
	              -Math.sin(a) / d,
	              sinh(b) / d);
	    },
	
	    /**
	     * Calculate the secant
	     *
	     * @returns {Complex}
	     */
	    'sec': function() {
	
	      // sec(c) = 2 / (e^(ci) + e^(-ci))
	
	      var a = this['re'];
	      var b = this['im'];
	      var d = 0.5 * cosh(2 * b) + 0.5 * Math.cos(2 * a);
	
	      return new Complex(
	              Math.cos(a) * cosh(b) / d,
	              Math.sin(a) * sinh(b) / d);
	    },
	
	    /**
	     * Calculate the cosecans
	     *
	     * @returns {Complex}
	     */
	    'csc': function() {
	
	      // csc(c) = 2i / (e^(ci) - e^(-ci))
	
	      var a = this['re'];
	      var b = this['im'];
	      var d = 0.5 * cosh(2 * b) - 0.5 * Math.cos(2 * a);
	
	      return new Complex(
	              Math.sin(a) * cosh(b) / d,
	              -Math.cos(a) * sinh(b) / d);
	    },
	
	    /**
	     * Calculate the complex arcus sinus
	     *
	     * @returns {Complex}
	     */
	    'asin': function() {
	
	      // asin(c) = -i * log(ci + sqrt(1 - c^2))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      var t1 = new Complex(
	              b * b - a * a + 1,
	              -2 * a * b)['sqrt']();
	
	      var t2 = new Complex(
	              t1['re'] - b,
	              t1['im'] + a)['log']();
	
	      return new Complex(t2['im'], -t2['re']);
	    },
	
	    /**
	     * Calculate the complex arcus cosinus
	     *
	     * @returns {Complex}
	     */
	    'acos': function() {
	
	      // acos(c) = i * log(c - i * sqrt(1 - c^2))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      var t1 = new Complex(
	              b * b - a * a + 1,
	              -2 * a * b)['sqrt']();
	
	      var t2 = new Complex(
	              t1['re'] - b,
	              t1['im'] + a)['log']();
	
	      return new Complex(Math.PI / 2 - t2['im'], t2['re']);
	    },
	
	    /**
	     * Calculate the complex arcus tangent
	     *
	     * @returns {Complex}
	     */
	    'atan': function() {
	
	      // atan(c) = i / 2 log((i + x) / (i - x))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (a === 0) {
	
	        if (b === 1) {
	          return new Complex(0, Infinity);
	        }
	
	        if (b === -1) {
	          return new Complex(0, -Infinity);
	        }
	      }
	
	      var d = a * a + (1.0 - b) * (1.0 - b);
	
	      var t1 = new Complex(
	              (1 - b * b - a * a) / d,
	              -2 * a / d).log();
	
	      return new Complex(-0.5 * t1['im'], 0.5 * t1['re']);
	    },
	
	    /**
	     * Calculate the complex arcus cotangent
	     *
	     * @returns {Complex}
	     */
	    'acot': function() {
	
	      // acot(c) = i / 2 log((c - i) / (c + i))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (b === 0) {
	        return new Complex(Math.atan2(1, a), 0);
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).atan()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).atan();
	    },
	
	    /**
	     * Calculate the complex arcus secant
	     *
	     * @returns {Complex}
	     */
	    'asec': function() {
	
	      // asec(c) = -i * log(1 / c + sqrt(1 - i / c^2))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (a === 0 && b === 0) {
	        return new Complex(0, Infinity);
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).acos()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).acos();
	    },
	
	    /**
	     * Calculate the complex arcus cosecans
	     *
	     * @returns {Complex}
	     */
	    'acsc': function() {
	
	      // acsc(c) = -i * log(i / c + sqrt(1 - 1 / c^2))
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (a === 0 && b === 0) {
	        return new Complex(Math.PI / 2, Infinity);
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).asin()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).asin();
	    },
	
	    /**
	     * Calculate the complex sinh
	     *
	     * @returns {Complex}
	     */
	    'sinh': function() {
	
	      // sinh(c) = (e^c - e^-c) / 2
	
	      var a = this['re'];
	      var b = this['im'];
	
	      return new Complex(
	              sinh(a) * Math.cos(b),
	              cosh(a) * Math.sin(b));
	    },
	
	    /**
	     * Calculate the complex cosh
	     *
	     * @returns {Complex}
	     */
	    'cosh': function() {
	
	      // cosh(c) = (e^c + e^-c) / 2
	
	      var a = this['re'];
	      var b = this['im'];
	
	      return new Complex(
	              cosh(a) * Math.cos(b),
	              sinh(a) * Math.sin(b));
	    },
	
	    /**
	     * Calculate the complex tanh
	     *
	     * @returns {Complex}
	     */
	    'tanh': function() {
	
	      // tanh(c) = (e^c - e^-c) / (e^c + e^-c)
	
	      var a = 2 * this['re'];
	      var b = 2 * this['im'];
	      var d = cosh(a) + Math.cos(b);
	
	      return new Complex(
	              sinh(a) / d,
	              Math.sin(b) / d);
	    },
	
	    /**
	     * Calculate the complex coth
	     *
	     * @returns {Complex}
	     */
	    'coth': function() {
	
	      // coth(c) = (e^c + e^-c) / (e^c - e^-c)
	
	      var a = 2 * this['re'];
	      var b = 2 * this['im'];
	      var d = cosh(a) - Math.cos(b);
	
	      return new Complex(
	              sinh(a) / d,
	              -Math.sin(b) / d);
	    },
	
	    /**
	     * Calculate the complex coth
	     *
	     * @returns {Complex}
	     */
	    'csch': function() {
	
	      // csch(c) = 2 / (e^c - e^-c)
	
	      var a = this['re'];
	      var b = this['im'];
	      var d = Math.cos(2 * b) - cosh(2 * a);
	
	      return new Complex(
	              -2 * sinh(a) * Math.cos(b) / d,
	              2 * cosh(a) * Math.sin(b) / d);
	    },
	
	    /**
	     * Calculate the complex sech
	     *
	     * @returns {Complex}
	     */
	    'sech': function() {
	
	      // sech(c) = 2 / (e^c + e^-c)
	
	      var a = this['re'];
	      var b = this['im'];
	      var d = Math.cos(2 * b) + cosh(2 * a);
	
	      return new Complex(
	              2 * cosh(a) * Math.cos(b) / d,
	              -2 * sinh(a) * Math.sin(b) / d);
	    },
	
	    /**
	     * Calculate the complex asinh
	     *
	     * @returns {Complex}
	     */
	    'asinh': function() {
	
	      // asinh(c) = log(c + sqrt(c^2 + 1))
	
	      var tmp = this['im'];
	      this['im'] = -this['re'];
	      this['re'] = tmp;
	      var res = this['asin']();
	
	      this['re'] = -this['im'];
	      this['im'] = tmp;
	      tmp = res['re'];
	
	      res['re'] = -res['im'];
	      res['im'] = tmp;
	      return res;
	    },
	
	    /**
	     * Calculate the complex asinh
	     *
	     * @returns {Complex}
	     */
	    'acosh': function() {
	
	      // acosh(c) = log(c + sqrt(c^2 - 1))
	
	      var res = this['acos']();
	      if (res['im'] <= 0) {
	        var tmp = res['re'];
	        res['re'] = -res['im'];
	        res['im'] = tmp;
	      } else {
	        var tmp = res['im'];
	        res['im'] = -res['re'];
	        res['re'] = tmp;
	      }
	      return res;
	    },
	
	    /**
	     * Calculate the complex atanh
	     *
	     * @returns {Complex}
	     */
	    'atanh': function() {
	
	      // atanh(c) = log((1+c) / (1-c)) / 2
	
	      var a = this['re'];
	      var b = this['im'];
	
	      var noIM = a > 1 && b === 0;
	      var oneMinus = 1 - a;
	      var onePlus = 1 + a;
	      var d = oneMinus * oneMinus + b * b;
	
	      var x = (d !== 0)
	              ? new Complex(
	                      (onePlus * oneMinus - b * b) / d,
	                      (b * oneMinus + onePlus * b) / d)
	              : new Complex(
	                      (a !== -1) ? (a / 0) : 0,
	                      (b !== 0) ? (b / 0) : 0);
	
	      var temp = x['re'];
	      x['re'] = logHypot(x['re'], x['im']) / 2;
	      x['im'] = Math.atan2(x['im'], temp) / 2;
	      if (noIM) {
	        x['im'] = -x['im'];
	      }
	      return x;
	    },
	
	    /**
	     * Calculate the complex acoth
	     *
	     * @returns {Complex}
	     */
	    'acoth': function() {
	
	      // acoth(c) = log((c+1) / (c-1)) / 2
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (a === 0 && b === 0) {
	        return new Complex(0, Math.PI / 2);
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).atanh()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).atanh();
	    },
	
	    /**
	     * Calculate the complex acsch
	     *
	     * @returns {Complex}
	     */
	    'acsch': function() {
	
	      // acsch(c) = log((1+sqrt(1+c^2))/c)
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (b === 0) {
	
	        return new Complex(
	                (a !== 0)
	                ? Math.log(a + Math.sqrt(a * a + 1))
	                : Infinity, 0);
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).asinh()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).asinh();
	    },
	
	    /**
	     * Calculate the complex asech
	     *
	     * @returns {Complex}
	     */
	    'asech': function() {
	
	      // asech(c) = log((1+sqrt(1-c^2))/c)
	
	      var a = this['re'];
	      var b = this['im'];
	
	      if (this.isZero()) {
	        return Complex['INFINITY'];
	      }
	
	      var d = a * a + b * b;
	      return (d !== 0)
	              ? new Complex(
	                      a / d,
	                      -b / d).acosh()
	              : new Complex(
	                      (a !== 0) ? a / 0 : 0,
	                      (b !== 0) ? -b / 0 : 0).acosh();
	    },
	
	    /**
	     * Calculate the complex inverse 1/z
	     *
	     * @returns {Complex}
	     */
	    'inverse': function() {
	
	      // 1 / 0 = Infinity and 1 / Infinity = 0
	      if (this.isZero()) {
	        return Complex['INFINITY'];
	      }
	
	      if (this.isInfinite()) {
	        return Complex['ZERO'];
	      }
	
	      var a = this['re'];
	      var b = this['im'];
	
	      var d = a * a + b * b;
	
	      return new Complex(a / d, -b / d);
	    },
	
	    /**
	     * Returns the complex conjugate
	     *
	     * @returns {Complex}
	     */
	    'conjugate': function() {
	
	      return new Complex(this['re'], -this['im']);
	    },
	
	    /**
	     * Gets the negated complex number
	     *
	     * @returns {Complex}
	     */
	    'neg': function() {
	
	      return new Complex(-this['re'], -this['im']);
	    },
	
	    /**
	     * Ceils the actual complex number
	     *
	     * @returns {Complex}
	     */
	    'ceil': function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      return new Complex(
	              Math.ceil(this['re'] * places) / places,
	              Math.ceil(this['im'] * places) / places);
	    },
	
	    /**
	     * Floors the actual complex number
	     *
	     * @returns {Complex}
	     */
	    'floor': function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      return new Complex(
	              Math.floor(this['re'] * places) / places,
	              Math.floor(this['im'] * places) / places);
	    },
	
	    /**
	     * Ceils the actual complex number
	     *
	     * @returns {Complex}
	     */
	    'round': function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      return new Complex(
	              Math.round(this['re'] * places) / places,
	              Math.round(this['im'] * places) / places);
	    },
	
	    /**
	     * Compares two complex numbers
	     *
	     * **Note:** new Complex(Infinity).equals(Infinity) === false
	     *
	     * @returns {boolean}
	     */
	    'equals': function(a, b) {
	
	      var z = new Complex(a, b);
	
	      return Math.abs(z['re'] - this['re']) <= Complex['EPSILON'] &&
	              Math.abs(z['im'] - this['im']) <= Complex['EPSILON'];
	    },
	
	    /**
	     * Clones the actual object
	     *
	     * @returns {Complex}
	     */
	    'clone': function() {
	
	      return new Complex(this['re'], this['im']);
	    },
	
	    /**
	     * Gets a string of the actual complex number
	     *
	     * @returns {string}
	     */
	    'toString': function() {
	
	      var a = this['re'];
	      var b = this['im'];
	      var ret = '';
	
	      if (this.isNaN()) {
	        return 'NaN';
	      }
	
	      if (this.isZero()) {
	        return '0';
	      }
	
	      if (this.isInfinite()) {
	        return 'Infinity';
	      }
	
	      if (a !== 0) {
	        ret += a;
	      }
	
	      if (b !== 0) {
	
	        if (a !== 0) {
	          ret += b < 0 ? ' - ' : ' + ';
	        } else if (b < 0) {
	          ret += '-';
	        }
	
	        b = Math.abs(b);
	
	        if (1 !== b) {
	          ret += b;
	        }
	        ret += 'i';
	      }
	
	      if (!ret)
	        return '0';
	
	      return ret;
	    },
	
	    /**
	     * Returns the actual number as a vector
	     *
	     * @returns {Array}
	     */
	    'toVector': function() {
	
	      return [this['re'], this['im']];
	    },
	
	    /**
	     * Returns the actual real value of the current object
	     *
	     * @returns {number|null}
	     */
	    'valueOf': function() {
	
	      if (this['im'] === 0) {
	        return this['re'];
	      }
	      return null;
	    },
	
	    /**
	     * Determines whether a complex number is not on the Riemann sphere.
	     *
	     * @returns {boolean}
	     */
	    'isNaN': function() {
	      return isNaN(this['re']) || isNaN(this['im']);
	    },
	
	    /**
	     * Determines whether or not a complex number is at the zero pole of the
	     * Riemann sphere.
	     *
	     * @returns {boolean}
	     */
	    'isZero': function() {
	      return (
	              (this['re'] === 0 || this['re'] === -0) &&
	              (this['im'] === 0 || this['im'] === -0)
	              );
	    },
	
	    /**
	     * Determines whether a complex number is not at the infinity pole of the
	     * Riemann sphere.
	     *
	     * @returns {boolean}
	     */
	    'isFinite': function() {
	      return isFinite(this['re']) && isFinite(this['im']);
	    },
	
	    /**
	     * Determines whether or not a complex number is at the infinity pole of the
	     * Riemann sphere.
	     *
	     * @returns {boolean}
	     */
	    'isInfinite': function() {
	      return !(this.isNaN() || this.isFinite());
	    }
	  };
	
	  Complex['ZERO'] = new Complex(0, 0);
	  Complex['ONE'] = new Complex(1, 0);
	  Complex['I'] = new Complex(0, 1);
	  Complex['PI'] = new Complex(Math.PI, 0);
	  Complex['E'] = new Complex(Math.E, 0);
	  Complex['INFINITY'] = new Complex(Infinity, Infinity);
	  Complex['NAN'] = new Complex(NaN, NaN);
	  Complex['EPSILON'] = 1e-16;
	
	  if ("function" === 'function' && __webpack_require__(167)['amd']) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return Complex;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (true) {
	    Object.defineProperty(exports, "__esModule", {'value': true});
	    Complex['default'] = Complex;
	    Complex['Complex'] = Complex;
	    module['exports'] = Complex;
	  } else {
	    root['Complex'] = Complex;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Create a complex value or convert a value to a complex value.
	   *
	   * Syntax:
	   *
	   *     math.complex()                           // creates a complex value with zero
	   *                                              // as real and imaginary part.
	   *     math.complex(re : number, im : string)   // creates a complex value with provided
	   *                                              // values for real and imaginary part.
	   *     math.complex(re : number)                // creates a complex value with provided
	   *                                              // real value and zero imaginary part.
	   *     math.complex(complex : Complex)          // clones the provided complex value.
	   *     math.complex(arg : string)               // parses a string into a complex value.
	   *     math.complex(array : Array)              // converts the elements of the array
	   *                                              // or matrix element wise into a
	   *                                              // complex value.
	   *     math.complex({re: number, im: number})   // creates a complex value with provided
	   *                                              // values for real an imaginary part.
	   *     math.complex({r: number, phi: number})   // creates a complex value with provided
	   *                                              // polar coordinates
	   *
	   * Examples:
	   *
	   *    var a = math.complex(3, -4);     // a = Complex 3 - 4i
	   *    a.re = 5;                        // a = Complex 5 - 4i
	   *    var i = a.im;                    // Number -4;
	   *    var b = math.complex('2 + 6i');  // Complex 2 + 6i
	   *    var c = math.complex();          // Complex 0 + 0i
	   *    var d = math.add(a, b);          // Complex 5 + 2i
	   *
	   * See also:
	   *
	   *    bignumber, boolean, index, matrix, number, string, unit
	   *
	   * @param {* | Array | Matrix} [args]
	   *            Arguments specifying the real and imaginary part of the complex number
	   * @return {Complex | Array | Matrix} Returns a complex value
	   */
	  var complex = typed('complex', {
	    '': function () {
	      return type.Complex.ZERO;
	    },
	
	    'number': function (x) {
	      return new type.Complex(x, 0);
	    },
	
	    'number, number': function (re, im) {
	      return new type.Complex(re, im);
	    },
	
	    // TODO: this signature should be redundant
	    'BigNumber, BigNumber': function (re, im) {
	      return new type.Complex(re.toNumber(), im.toNumber());
	    },
	
	    'Complex': function (x) {
	      return x.clone();
	    },
	
	    'string': function (x) {
	      return type.Complex(x); // for example '2 + 3i'
	    },
	
	    'null': function (x) {
	      return type.Complex(0);
	    },
	
	    'Object': function (x) {
	      if('re' in x && 'im' in x) {
	        return new type.Complex(x.re, x.im);
	      }
	
	      if ('r' in x && 'phi' in x) {
	        return new type.Complex(x);
	      }
	
	      throw new Error('Expected object with either properties re and im, or properties r and phi.');
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, complex);
	    }
	  });
	
	  complex.toTex = {
	    0: '0',
	    1: '\\left(${args[0]}\\right)',
	    2: '\\left(\\left(${args[0]}\\right)+'
	      + latex.symbols['i'] + '\\cdot\\left(${args[1]}\\right)\\right)'
	  };
	
	  return complex;
	}
	
	exports.name = 'complex';
	exports.factory = factory;


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var escape_latex = __webpack_require__(1349)
	
	exports.symbols = {
	  // GREEK LETTERS
	  Alpha: 'A',     alpha: '\\alpha',
	  Beta: 'B',      beta: '\\beta',
	  Gamma: '\\Gamma',    gamma: '\\gamma',
	  Delta: '\\Delta',    delta: '\\delta',
	  Epsilon: 'E',   epsilon: '\\epsilon',  varepsilon: '\\varepsilon',
	  Zeta: 'Z',      zeta: '\\zeta',
	  Eta: 'H',       eta: '\\eta',
	  Theta: '\\Theta',    theta: '\\theta',    vartheta: '\\vartheta',
	  Iota: 'I',      iota: '\\iota',
	  Kappa: 'K',     kappa: '\\kappa',    varkappa: '\\varkappa',
	  Lambda: '\\Lambda',   lambda: '\\lambda',
	  Mu: 'M',        mu: '\\mu',
	  Nu: 'N',        nu: '\\nu',
	  Xi: '\\Xi',       xi: '\\xi',
	  Omicron: 'O',   omicron: 'o',
	  Pi: '\\Pi',       pi: '\\pi',       varpi: '\\varpi',
	  Rho: 'P',       rho: '\\rho',      varrho: '\\varrho',
	  Sigma: '\\Sigma',    sigma: '\\sigma',    varsigma: '\\varsigma',
	  Tau: 'T',       tau: '\\tau',
	  Upsilon: '\\Upsilon',  upsilon: '\\upsilon',
	  Phi: '\\Phi',      phi: '\\phi',      varphi: '\\varphi',
	  Chi: 'X',       chi: '\\chi',
	  Psi: '\\Psi',      psi: '\\psi',
	  Omega: '\\Omega',    omega: '\\omega',
	  //logic
	  'true': '\\mathrm{True}',
	  'false': '\\mathrm{False}',
	  //other
	  i: 'i', //TODO use \i ??
	  inf: '\\infty',
	  Inf: '\\infty',
	  infinity: '\\infty',
	  Infinity: '\\infty',
	  oo: '\\infty',
	  lim: '\\lim',
	  'undefined': '\\mathbf{?}'
	};
	
	exports.operators = {
	  'transpose': '^\\top',
	  'factorial': '!',
	  'pow': '^',
	  'dotPow': '.^\\wedge', //TODO find ideal solution
	  'unaryPlus': '+',
	  'unaryMinus': '-',
	  'bitNot': '~', //TODO find ideal solution
	  'not': '\\neg',
	  'multiply': '\\cdot',
	  'divide': '\\frac', //TODO how to handle that properly?
	  'dotMultiply': '.\\cdot', //TODO find ideal solution
	  'dotDivide': '.:', //TODO find ideal solution
	  'mod': '\\mod',
	  'add': '+',
	  'subtract': '-',
	  'to': '\\rightarrow',
	  'leftShift': '<<',
	  'rightArithShift': '>>',
	  'rightLogShift': '>>>',
	  'equal': '=',
	  'unequal': '\\neq',
	  'smaller': '<',
	  'larger': '>',
	  'smallerEq': '\\leq',
	  'largerEq': '\\geq',
	  'bitAnd': '\\&',
	  'bitXor': '\\underline{|}',
	  'bitOr': '|',
	  'and': '\\wedge',
	  'xor': '\\veebar',
	  'or': '\\vee'
	};
	
	exports.defaultTemplate = '\\mathrm{${name}}\\left(${args}\\right)';
	
	var units = {
	  deg: '^\\circ'
	};
	
	exports.escape = function (string) {
	  return escape_latex(string, {'preserveFormatting': true});
	}
	
	//@param {string} name
	//@param {boolean} isUnit
	exports.toSymbol = function (name, isUnit) {
	  isUnit = typeof isUnit === 'undefined' ? false : isUnit;
	  if (isUnit) {
	    if (units.hasOwnProperty(name)) {
	      return units[name];
	    }
	
	    return '\\mathrm{' + exports.escape(name) + '}';
	  }
	
	  if (exports.symbols.hasOwnProperty(name)) {
	    return exports.symbols[name];
	  }
	
	  return exports.escape(name);
	};


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	"use strict";
	
	// Map the characters to escape to their escaped values. The list is derived
	// from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters
	
	var defaultEscapes = {
	  "{": "\\{",
	  "}": "\\}",
	  "\\": "\\textbackslash{}",
	  "#": "\\#",
	  $: "\\$",
	  "%": "\\%",
	  "&": "\\&",
	  "^": "\\textasciicircum{}",
	  _: "\\_",
	  "~": "\\textasciitilde{}"
	};
	var formatEscapes = {
	  "–": "\\--",
	  "—": "\\---",
	  " ": "~",
	  "\t": "\\qquad{}",
	  "\r\n": "\\\\newline{}",
	  "\n": "\\\\newline{}"
	};
	
	var defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
	  return Object.assign({}, defaultEscapes, formatEscapes);
	};
	
	/**
	 * Escape a string to be used in LaTeX documents.
	 * @param {string} str the string to be escaped.
	 * @param {boolean} params.preserveFormatting whether formatting escapes should
	 *  be performed (default: false).
	 * @param {function} params.escapeMapFn the function to modify the escape maps.
	 * @return {string} the escaped string, ready to be used in LaTeX.
	 */
	module.exports = function (str) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$preserveFormatti = _ref.preserveFormatting,
	      preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti,
	      _ref$escapeMapFn = _ref.escapeMapFn,
	      escapeMapFn = _ref$escapeMapFn === undefined ? defaultEscapeMapFn : _ref$escapeMapFn;
	
	  var runningStr = String(str);
	  var result = "";
	
	  var escapes = escapeMapFn(Object.assign({}, defaultEscapes), preserveFormatting ? Object.assign({}, formatEscapes) : {});
	  var escapeKeys = Object.keys(escapes); // as it is reused later on
	
	  // Algorithm: Go through the string character by character, if it matches
	  // with one of the special characters then we'll replace it with the escaped
	  // version.
	
	  var _loop = function _loop() {
	    var specialCharFound = false;
	    escapeKeys.forEach(function (key, index) {
	      if (specialCharFound) {
	        return;
	      }
	      if (runningStr.startsWith(key)) {
	        result += escapes[escapeKeys[index]];
	        runningStr = runningStr.slice(key.length, runningStr.length);
	        specialCharFound = true;
	      }
	    });
	    if (!specialCharFound) {
	      result += runningStr.slice(0, 1);
	      runningStr = runningStr.slice(1, runningStr.length);
	    }
	  };
	
	  while (runningStr) {
	    _loop();
	  }
	  return result;
	};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1351),
	
	  // construction function
	  __webpack_require__(1353)
	];


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Fraction = __webpack_require__(1352);
	
	/**
	 * Attach type information
	 */
	Fraction.prototype.type = 'Fraction';
	Fraction.prototype.isFraction = true;
	
	/**
	 * Get a JSON representation of a Fraction containing type information
	 * @returns {Object} Returns a JSON object structured as:
	 *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
	 */
	Fraction.prototype.toJSON = function () {
	  return {
	    mathjs: 'Fraction',
	    n: this.s * this.n,
	    d: this.d
	  };
	};
	
	/**
	 * Instantiate a Fraction from a JSON object
	 * @param {Object} json  a JSON object structured as:
	 *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
	 * @return {BigNumber}
	 */
	Fraction.fromJSON = function (json) {
	  return new Fraction(json);
	};
	
	
	function factory (type, config, load, typed) {
	  return Fraction;
	}
	
	exports.name = 'Fraction';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/**
	 * @license Fraction.js v4.0.8 09/09/2015
	 * http://www.xarg.org/2014/03/rational-numbers-in-javascript/
	 *
	 * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 **/
	
	
	/**
	 *
	 * This class offers the possibility to calculate fractions.
	 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
	 *
	 * Array/Object form
	 * [ 0 => <nominator>, 1 => <denominator> ]
	 * [ n => <nominator>, d => <denominator> ]
	 *
	 * Integer form
	 * - Single integer value
	 *
	 * Double form
	 * - Single double value
	 *
	 * String form
	 * 123.456 - a simple double
	 * 123/456 - a string fraction
	 * 123.'456' - a double with repeating decimal places
	 * 123.(456) - synonym
	 * 123.45'6' - a double with repeating last place
	 * 123.45(6) - synonym
	 *
	 * Example:
	 *
	 * var f = new Fraction("9.4'31'");
	 * f.mul([-4, 3]).div(4.9);
	 *
	 */
	
	(function(root) {
	
	  "use strict";
	
	  // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
	  // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
	  // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
	  var MAX_CYCLE_LEN = 2000;
	
	  // Parsed data to avoid calling "new" all the time
	  var P = {
	    "s": 1,
	    "n": 0,
	    "d": 1
	  };
	
	  function createError(name) {
	
	    function errorConstructor() {
	      var temp = Error.apply(this, arguments);
	      temp['name'] = this['name'] = name;
	      this['stack'] = temp['stack'];
	      this['message'] = temp['message'];
	    }
	
	    /**
	     * Error constructor
	     *
	     * @constructor
	     */
	    function IntermediateInheritor() {}
	    IntermediateInheritor.prototype = Error.prototype;
	    errorConstructor.prototype = new IntermediateInheritor();
	
	    return errorConstructor;
	  }
	
	  var DivisionByZero = Fraction['DivisionByZero'] = createError('DivisionByZero');
	  var InvalidParameter = Fraction['InvalidParameter'] = createError('InvalidParameter');
	
	  function assign(n, s) {
	
	    if (isNaN(n = parseInt(n, 10))) {
	      throwInvalidParam();
	    }
	    return n * s;
	  }
	
	  function throwInvalidParam() {
	    throw new InvalidParameter();
	  }
	
	  var parse = function(p1, p2) {
	
	    var n = 0, d = 1, s = 1;
	    var v = 0, w = 0, x = 0, y = 1, z = 1;
	
	    var A = 0, B = 1;
	    var C = 1, D = 1;
	
	    var N = 10000000;
	    var M;
	
	    if (p1 === undefined || p1 === null) {
	      /* void */
	    } else if (p2 !== undefined) {
	      n = p1;
	      d = p2;
	      s = n * d;
	    } else
	      switch (typeof p1) {
	
	        case "object":
	        {
	          if ("d" in p1 && "n" in p1) {
	            n = p1["n"];
	            d = p1["d"];
	            if ("s" in p1)
	              n *= p1["s"];
	          } else if (0 in p1) {
	            n = p1[0];
	            if (1 in p1)
	              d = p1[1];
	          } else {
	            throwInvalidParam();
	          }
	          s = n * d;
	          break;
	        }
	        case "number":
	        {
	          if (p1 < 0) {
	            s = p1;
	            p1 = -p1;
	          }
	
	          if (p1 % 1 === 0) {
	            n = p1;
	          } else if (p1 > 0) { // check for != 0, scale would become NaN (log(0)), which converges really slow
	
	            if (p1 >= 1) {
	              z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
	              p1 /= z;
	            }
	
	            // Using Farey Sequences
	            // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
	
	            while (B <= N && D <= N) {
	              M = (A + C) / (B + D);
	
	              if (p1 === M) {
	                if (B + D <= N) {
	                  n = A + C;
	                  d = B + D;
	                } else if (D > B) {
	                  n = C;
	                  d = D;
	                } else {
	                  n = A;
	                  d = B;
	                }
	                break;
	
	              } else {
	
	                if (p1 > M) {
	                  A += C;
	                  B += D;
	                } else {
	                  C += A;
	                  D += B;
	                }
	
	                if (B > N) {
	                  n = C;
	                  d = D;
	                } else {
	                  n = A;
	                  d = B;
	                }
	              }
	            }
	            n *= z;
	          } else if (isNaN(p1) || isNaN(p2)) {
	            d = n = NaN;
	          }
	          break;
	        }
	        case "string":
	        {
	          B = p1.match(/\d+|./g);
	
	          if (B === null)
	            throwInvalidParam();
	
	          if (B[A] === '-') {// Check for minus sign at the beginning
	            s = -1;
	            A++;
	          } else if (B[A] === '+') {// Check for plus sign at the beginning
	            A++;
	          }
	
	          if (B.length === A + 1) { // Check if it's just a simple number "1234"
	            w = assign(B[A++], s);
	          } else if (B[A + 1] === '.' || B[A] === '.') { // Check if it's a decimal number
	
	            if (B[A] !== '.') { // Handle 0.5 and .5
	              v = assign(B[A++], s);
	            }
	            A++;
	
	            // Check for decimal places
	            if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
	              w = assign(B[A], s);
	              y = Math.pow(10, B[A].length);
	              A++;
	            }
	
	            // Check for repeating places
	            if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
	              x = assign(B[A + 1], s);
	              z = Math.pow(10, B[A + 1].length) - 1;
	              A += 3;
	            }
	
	          } else if (B[A + 1] === '/' || B[A + 1] === ':') { // Check for a simple fraction "123/456" or "123:456"
	            w = assign(B[A], s);
	            y = assign(B[A + 2], 1);
	            A += 3;
	          } else if (B[A + 3] === '/' && B[A + 1] === ' ') { // Check for a complex fraction "123 1/2"
	            v = assign(B[A], s);
	            w = assign(B[A + 2], s);
	            y = assign(B[A + 4], 1);
	            A += 5;
	          }
	
	          if (B.length <= A) { // Check for more tokens on the stack
	            d = y * z;
	            s = /* void */
	                    n = x + d * v + z * w;
	            break;
	          }
	
	          /* Fall through on error */
	        }
	        default:
	          throwInvalidParam();
	      }
	
	    if (d === 0) {
	      throw new DivisionByZero();
	    }
	
	    P["s"] = s < 0 ? -1 : 1;
	    P["n"] = Math.abs(n);
	    P["d"] = Math.abs(d);
	  };
	
	  function modpow(b, e, m) {
	
	    var r = 1;
	    for (; e > 0; b = (b * b) % m, e >>= 1) {
	
	      if (e & 1) {
	        r = (r * b) % m;
	      }
	    }
	    return r;
	  }
	
	
	  function cycleLen(n, d) {
	
	    for (; d % 2 === 0;
	            d /= 2) {
	    }
	
	    for (; d % 5 === 0;
	            d /= 5) {
	    }
	
	    if (d === 1) // Catch non-cyclic numbers
	      return 0;
	
	    // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
	    // 10^(d-1) % d == 1
	    // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
	    // as we want to translate the numbers to strings.
	
	    var rem = 10 % d;
	    var t = 1;
	
	    for (; rem !== 1; t++) {
	      rem = rem * 10 % d;
	
	      if (t > MAX_CYCLE_LEN)
	        return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
	    }
	    return t;
	  }
	
	
	     function cycleStart(n, d, len) {
	
	    var rem1 = 1;
	    var rem2 = modpow(10, len, d);
	
	    for (var t = 0; t < 300; t++) { // s < ~log10(Number.MAX_VALUE)
	      // Solve 10^s == 10^(s+t) (mod d)
	
	      if (rem1 === rem2)
	        return t;
	
	      rem1 = rem1 * 10 % d;
	      rem2 = rem2 * 10 % d;
	    }
	    return 0;
	  }
	
	  function gcd(a, b) {
	
	    if (!a)
	      return b;
	    if (!b)
	      return a;
	
	    while (1) {
	      a %= b;
	      if (!a)
	        return b;
	      b %= a;
	      if (!b)
	        return a;
	    }
	  };
	
	  /**
	   * Module constructor
	   *
	   * @constructor
	   * @param {number|Fraction=} a
	   * @param {number=} b
	   */
	  function Fraction(a, b) {
	
	    if (!(this instanceof Fraction)) {
	      return new Fraction(a, b);
	    }
	
	    parse(a, b);
	
	    if (Fraction['REDUCE']) {
	      a = gcd(P["d"], P["n"]); // Abuse a
	    } else {
	      a = 1;
	    }
	
	    this["s"] = P["s"];
	    this["n"] = P["n"] / a;
	    this["d"] = P["d"] / a;
	  }
	
	  /**
	   * Boolean global variable to be able to disable automatic reduction of the fraction
	   *
	   */
	  Fraction['REDUCE'] = 1;
	
	  Fraction.prototype = {
	
	    "s": 1,
	    "n": 0,
	    "d": 1,
	
	    /**
	     * Calculates the absolute value
	     *
	     * Ex: new Fraction(-4).abs() => 4
	     **/
	    "abs": function() {
	
	      return new Fraction(this["n"], this["d"]);
	    },
	
	    /**
	     * Inverts the sign of the current fraction
	     *
	     * Ex: new Fraction(-4).neg() => 4
	     **/
	    "neg": function() {
	
	      return new Fraction(-this["s"] * this["n"], this["d"]);
	    },
	
	    /**
	     * Adds two rational numbers
	     *
	     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
	     **/
	    "add": function(a, b) {
	
	      parse(a, b);
	      return new Fraction(
	              this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"],
	              this["d"] * P["d"]
	              );
	    },
	
	    /**
	     * Subtracts two rational numbers
	     *
	     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
	     **/
	    "sub": function(a, b) {
	
	      parse(a, b);
	      return new Fraction(
	              this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"],
	              this["d"] * P["d"]
	              );
	    },
	
	    /**
	     * Multiplies two rational numbers
	     *
	     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
	     **/
	    "mul": function(a, b) {
	
	      parse(a, b);
	      return new Fraction(
	              this["s"] * P["s"] * this["n"] * P["n"],
	              this["d"] * P["d"]
	              );
	    },
	
	    /**
	     * Divides two rational numbers
	     *
	     * Ex: new Fraction("-17.(345)").inverse().div(3)
	     **/
	    "div": function(a, b) {
	
	      parse(a, b);
	      return new Fraction(
	              this["s"] * P["s"] * this["n"] * P["d"],
	              this["d"] * P["n"]
	              );
	    },
	
	    /**
	     * Clones the actual object
	     *
	     * Ex: new Fraction("-17.(345)").clone()
	     **/
	    "clone": function() {
	      return new Fraction(this);
	    },
	
	    /**
	     * Calculates the modulo of two rational numbers - a more precise fmod
	     *
	     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
	     **/
	    "mod": function(a, b) {
	
	      if (isNaN(this['n']) || isNaN(this['d'])) {
	        return new Fraction(NaN);
	      }
	
	      if (a === undefined) {
	        return new Fraction(this["s"] * this["n"] % this["d"], 1);
	      }
	
	      parse(a, b);
	      if (0 === P["n"] && 0 === this["d"]) {
	        Fraction(0, 0); // Throw DivisionByZero
	      }
	
	      /*
	       * First silly attempt, kinda slow
	       *
	       return that["sub"]({
	       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
	       "d": num["d"],
	       "s": this["s"]
	       });*/
	
	      /*
	       * New attempt: a1 / b1 = a2 / b2 * q + r
	       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
	       * => (b2 * a1 % a2 * b1) / (b1 * b2)
	       */
	      return new Fraction(
	              this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]),
	              P["d"] * this["d"]
	              );
	    },
	
	    /**
	     * Calculates the fractional gcd of two rational numbers
	     *
	     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
	     */
	    "gcd": function(a, b) {
	
	      parse(a, b);
	
	      // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
	
	      return new Fraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
	    },
	
	    /**
	     * Calculates the fractional lcm of two rational numbers
	     *
	     * Ex: new Fraction(5,8).lcm(3,7) => 15
	     */
	    "lcm": function(a, b) {
	
	      parse(a, b);
	
	      // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
	
	      if (P["n"] === 0 && this["n"] === 0) {
	        return new Fraction;
	      }
	      return new Fraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
	    },
	
	    /**
	     * Calculates the ceil of a rational number
	     *
	     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
	     **/
	    "ceil": function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      if (isNaN(this["n"]) || isNaN(this["d"])) {
	        return new Fraction(NaN);
	      }
	      return new Fraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
	    },
	
	    /**
	     * Calculates the floor of a rational number
	     *
	     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
	     **/
	    "floor": function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      if (isNaN(this["n"]) || isNaN(this["d"])) {
	        return new Fraction(NaN);
	      }
	      return new Fraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
	    },
	
	    /**
	     * Rounds a rational numbers
	     *
	     * Ex: new Fraction('4.(3)').round() => (4 / 1)
	     **/
	    "round": function(places) {
	
	      places = Math.pow(10, places || 0);
	
	      if (isNaN(this["n"]) || isNaN(this["d"])) {
	        return new Fraction(NaN);
	      }
	      return new Fraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
	    },
	
	    /**
	     * Gets the inverse of the fraction, means numerator and denumerator are exchanged
	     *
	     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
	     **/
	    "inverse": function() {
	
	      return new Fraction(this["s"] * this["d"], this["n"]);
	    },
	
	    /**
	     * Calculates the fraction to some integer exponent
	     *
	     * Ex: new Fraction(-1,2).pow(-3) => -8
	     */
	    "pow": function(m) {
	
	      if (m < 0) {
	        return new Fraction(Math.pow(this['s'] * this["d"], -m), Math.pow(this["n"], -m));
	      } else {
	        return new Fraction(Math.pow(this['s'] * this["n"], m), Math.pow(this["d"], m));
	      }
	    },
	
	    /**
	     * Check if two rational numbers are the same
	     *
	     * Ex: new Fraction(19.6).equals([98, 5]);
	     **/
	    "equals": function(a, b) {
	
	      parse(a, b);
	      return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
	    },
	
	    /**
	     * Check if two rational numbers are the same
	     *
	     * Ex: new Fraction(19.6).equals([98, 5]);
	     **/
	    "compare": function(a, b) {
	
	      parse(a, b);
	      var t = (this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"]);
	      return (0 < t) - (t < 0);
	    },
	    
	    "simplify": function(eps) {
	      
	      // First naive implementation, needs improvement
	      
	      if (isNaN(this['n']) || isNaN(this['d'])) {
	        return this;
	      }
	
	      var cont = this['abs']()['toContinued']();
	      
	      eps = eps || 0.001;
	      
	      function rec(a) {
	        if (a.length === 1)
	          return new Fraction(a[0]);
	        return rec(a.slice(1))['inverse']()['add'](a[0]);
	      }
	      
	      for (var i = 0; i < cont.length; i++) {
	        var tmp = rec(cont.slice(0, i + 1));
	        if (tmp['sub'](this['abs']())['abs']().valueOf() < eps) {
	          return tmp['mul'](this['s']);
	        }
	      }
	      return this;
	    },
	
	    /**
	     * Check if two rational numbers are divisible
	     *
	     * Ex: new Fraction(19.6).divisible(1.5);
	     */
	    "divisible": function(a, b) {
	
	      parse(a, b);
	      return !(!(P["n"] * this["d"]) || ((this["n"] * P["d"]) % (P["n"] * this["d"])));
	    },
	
	    /**
	     * Returns a decimal representation of the fraction
	     *
	     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
	     **/
	    'valueOf': function() {
	
	      return this["s"] * this["n"] / this["d"];
	    },
	
	    /**
	     * Returns a string-fraction representation of a Fraction object
	     *
	     * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
	     **/
	    'toFraction': function(excludeWhole) {
	
	      var whole, str = "";
	      var n = this["n"];
	      var d = this["d"];
	      if (this["s"] < 0) {
	        str += '-';
	      }
	
	      if (d === 1) {
	        str += n;
	      } else {
	
	        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
	          str += whole;
	          str += " ";
	          n %= d;
	        }
	
	        str += n;
	        str += '/';
	        str += d;
	      }
	      return str;
	    },
	
	    /**
	     * Returns a latex representation of a Fraction object
	     *
	     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
	     **/
	    'toLatex': function(excludeWhole) {
	
	      var whole, str = "";
	      var n = this["n"];
	      var d = this["d"];
	      if (this["s"] < 0) {
	        str += '-';
	      }
	
	      if (d === 1) {
	        str += n;
	      } else {
	
	        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
	          str += whole;
	          n %= d;
	        }
	
	        str += "\\frac{";
	        str += n;
	        str += '}{';
	        str += d;
	        str += '}';
	      }
	      return str;
	    },
	
	    /**
	     * Returns an array of continued fraction elements
	     *
	     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
	     */
	    'toContinued': function() {
	
	      var t;
	      var a = this['n'];
	      var b = this['d'];
	      var res = [];
	
	      if (isNaN(this['n']) || isNaN(this['d'])) {
	        return res;
	      }
	
	      do {
	        res.push(Math.floor(a / b));
	        t = a % b;
	        a = b;
	        b = t;
	      } while (a !== 1);
	
	      return res;
	    },
	
	    /**
	     * Creates a string representation of a fraction with all digits
	     *
	     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
	     **/
	    'toString': function() {
	
	      var g;
	      var N = this["n"];
	      var D = this["d"];
	
	      if (isNaN(N) || isNaN(D)) {
	        return "NaN";
	      }
	
	      if (!Fraction['REDUCE']) {
	        g = gcd(N, D);
	        N /= g;
	        D /= g;
	      }
	
	      var dec = 15; // 15 = decimal places when no repitation
	
	      var cycLen = cycleLen(N, D); // Cycle length
	      var cycOff = cycleStart(N, D, cycLen); // Cycle start
	
	      var str = this['s'] === -1 ? "-" : "";
	
	      str += N / D | 0;
	
	      N %= D;
	      N *= 10;
	
	      if (N)
	        str += ".";
	
	      if (cycLen) {
	
	        for (var i = cycOff; i--; ) {
	          str += N / D | 0;
	          N %= D;
	          N *= 10;
	        }
	        str += "(";
	        for (var i = cycLen; i--; ) {
	          str += N / D | 0;
	          N %= D;
	          N *= 10;
	        }
	        str += ")";
	      } else {
	        for (var i = dec; N && i--; ) {
	          str += N / D | 0;
	          N %= D;
	          N *= 10;
	        }
	      }
	      return str;
	    }
	  };
	
	  if ("function" === "function" && __webpack_require__(167)["amd"]) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return Fraction;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (true) {
	    Object.defineProperty(exports, "__esModule", {'value': true});
	    Fraction['default'] = Fraction;
	    Fraction['Fraction'] = Fraction;
	    module['exports'] = Fraction;
	  } else {
	    root['Fraction'] = Fraction;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a fraction convert a value to a fraction.
	   *
	   * Syntax:
	   *     math.fraction(numerator, denominator)
	   *     math.fraction({n: numerator, d: denominator})
	   *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
	   *                                                   into fractions
	   *
	   * Examples:
	   *
	   *     math.fraction(1, 3);
	   *     math.fraction('2/3');
	   *     math.fraction({n: 2, d: 3});
	   *     math.fraction([0.2, 0.25, 1.25]);
	   *
	   * See also:
	   *
	   *    bignumber, number, string, unit
	   *
	   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
	   *            Arguments specifying the numerator and denominator of
	   *            the fraction
	   * @return {Fraction | Array | Matrix} Returns a fraction
	   */
	  var fraction = typed('fraction', {
	    'number': function (x) {
	      if (!isFinite(x) || isNaN(x)) {
	        throw new Error(x + ' cannot be represented as a fraction');
	      }
	
	      return new type.Fraction(x);
	    },
	
	    'string': function (x) {
	      return new type.Fraction(x);
	    },
	
	    'number, number': function (numerator, denominator) {
	      return new type.Fraction(numerator, denominator);
	    },
	
	    'null': function (x) {
	      return new type.Fraction(0);
	    },
	
	    'BigNumber': function (x) {
	      return new type.Fraction(x.toString());
	    },
	
	    'Fraction': function (x) {
	      return x; // fractions are immutable
	    },
	
	    'Object': function (x) {
	      return new type.Fraction(x);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, fraction);
	    }
	  });
	
	  return fraction;
	}
	
	exports.name = 'fraction';
	exports.factory = factory;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // types
	  __webpack_require__(1355),
	  __webpack_require__(1362),
	  __webpack_require__(1363),
	  __webpack_require__(1366),
	  __webpack_require__(1375),
	  __webpack_require__(1381),
	  __webpack_require__(1382),
	  __webpack_require__(1383),
	
	  // construction functions
	  __webpack_require__(1384),
	  __webpack_require__(1368),
	  __webpack_require__(1385)
	];


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	var string = util.string;
	
	var isString = string.isString;
	
	function factory (type, config, load, typed) {
	  /**
	   * @constructor Matrix
	   *
	   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
	   * array. A matrix can be constructed as:
	   *     var matrix = math.matrix(data)
	   *
	   * Matrix contains the functions to resize, get and set values, get the size,
	   * clone the matrix and to convert the matrix to a vector, array, or scalar.
	   * Furthermore, one can iterate over the matrix using map and forEach.
	   * The internal Array of the Matrix can be accessed using the function valueOf.
	   *
	   * Example usage:
	   *     var matrix = math.matrix([[1, 2], [3, 4]]);
	   *     matix.size();              // [2, 2]
	   *     matrix.resize([3, 2], 5);
	   *     matrix.valueOf();          // [[1, 2], [3, 4], [5, 5]]
	   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
	   *
	   */
	  function Matrix() {
	    if (!(this instanceof Matrix)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	  }
	
	  /**
	   * Attach type information
	   */
	  Matrix.prototype.type = 'Matrix';
	  Matrix.prototype.isMatrix = true;
	
	  /**
	   * Get the Matrix storage constructor for the given format.
	   *
	   * @param {string} format       The Matrix storage format.
	   *
	   * @return {Function}           The Matrix storage constructor.
	   */
	  Matrix.storage = function (format) {
	    // check storage format is a string
	    if (!isString(format)) {
	      throw new TypeError('format must be a string value');
	    }
	
	    // get storage format constructor
	    var constructor = Matrix._storage[format];
	    if (!constructor) {
	      throw new SyntaxError('Unsupported matrix storage format: ' + format);
	    }
	
	    // return storage constructor
	    return constructor;
	  };
	
	  // a map with all constructors for all storage types
	  Matrix._storage = {};
	
	  /**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @return {string}           The storage format.
	   */
	  Matrix.prototype.storage = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke storage on a Matrix interface');
	  };
	  
	  /**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @return {string}           The datatype.
	   */
	  Matrix.prototype.datatype = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke datatype on a Matrix interface');
	  };
	
	  /**
	   * Create a new Matrix With the type of the current matrix instance
	   * @param {Array | Object} data
	   * @param {string} [datatype]
	   */
	  Matrix.prototype.create = function (data, datatype) {
	    throw new Error('Cannot invoke create on a Matrix interface');
	  };
	
	  /**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @param {Index} index
	   * @param {Array | Matrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */
	  Matrix.prototype.subset = function (index, replacement, defaultValue) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke subset on a Matrix interface');
	  };
	
	  /**
	   * Get a single element from the matrix.
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */
	  Matrix.prototype.get = function (index) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke get on a Matrix interface');
	  };
	
	  /**
	   * Replace a single element in the matrix.
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {Matrix} self
	   */
	  Matrix.prototype.set = function (index, value, defaultValue) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke set on a Matrix interface');
	  };
	
	  /**
	   * Resize the matrix to the given size. Returns a copy of the matrix when 
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */
	  Matrix.prototype.resize = function (size, defaultValue) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke resize on a Matrix interface');
	  };
	
	  /**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */
	  Matrix.prototype.reshape = function (size, defaultValue) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke reshape on a Matrix interface');
	  };
	
	  /**
	   * Create a clone of the matrix
	   * @return {Matrix} clone
	   */
	  Matrix.prototype.clone = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke clone on a Matrix interface');
	  };
	
	  /**
	   * Retrieve the size of the matrix.
	   * @returns {number[]} size
	   */
	  Matrix.prototype.size = function() {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke size on a Matrix interface');
	  };
	
	  /**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   *
	   * @return {Matrix} matrix
	   */
	  Matrix.prototype.map = function (callback, skipZeros) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke map on a Matrix interface');
	  };
	
	  /**
	   * Execute a callback function on each entry of the matrix.
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   */
	  Matrix.prototype.forEach = function (callback) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke forEach on a Matrix interface');
	  };
	
	  /**
	   * Create an Array with a copy of the data of the Matrix
	   * @returns {Array} array
	   */
	  Matrix.prototype.toArray = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke toArray on a Matrix interface');
	  };
	
	  /**
	   * Get the primitive value of the Matrix: a multidimensional array
	   * @returns {Array} array
	   */
	  Matrix.prototype.valueOf = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke valueOf on a Matrix interface');
	  };
	
	  /**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */
	  Matrix.prototype.format = function (options) {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke format on a Matrix interface');
	  };
	
	  /**
	   * Get a string representation of the matrix
	   * @returns {string} str
	   */
	  Matrix.prototype.toString = function () {
	    // must be implemented by each of the Matrix implementations
	    throw new Error('Cannot invoke toString on a Matrix interface');
	  };
	   
	  // exports
	  return Matrix;
	}
	
	exports.name = 'Matrix';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.array = __webpack_require__(1357);
	exports['boolean'] = __webpack_require__(1360);
	exports['function'] = __webpack_require__(1361);
	exports.number = __webpack_require__(1324);
	exports.object = __webpack_require__(1320);
	exports.string = __webpack_require__(1341);
	exports.emitter = __webpack_require__(1326);


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var number = __webpack_require__(1324);
	var string = __webpack_require__(1341);
	
	var DimensionError = __webpack_require__(1358);
	var IndexError = __webpack_require__(1359);
	
	/**
	 * Calculate the size of a multi dimensional array.
	 * This function checks the size of the first entry, it does not validate
	 * whether all dimensions match. (use function `validate` for that)
	 * @param {Array} x
	 * @Return {Number[]} size
	 */
	exports.size = function (x) {
	  var s = [];
	
	  while (Array.isArray(x)) {
	    s.push(x.length);
	    x = x[0];
	  }
	
	  return s;
	};
	
	/**
	 * Recursively validate whether each element in a multi dimensional array
	 * has a size corresponding to the provided size array.
	 * @param {Array} array    Array to be validated
	 * @param {number[]} size  Array with the size of each dimension
	 * @param {number} dim   Current dimension
	 * @throws DimensionError
	 * @private
	 */
	function _validate(array, size, dim) {
	  var i;
	  var len = array.length;
	
	  if (len != size[dim]) {
	    throw new DimensionError(len, size[dim]);
	  }
	
	  if (dim < size.length - 1) {
	    // recursively validate each child array
	    var dimNext = dim + 1;
	    for (i = 0; i < len; i++) {
	      var child = array[i];
	      if (!Array.isArray(child)) {
	        throw new DimensionError(size.length - 1, size.length, '<');
	      }
	      _validate(array[i], size, dimNext);
	    }
	  }
	  else {
	    // last dimension. none of the childs may be an array
	    for (i = 0; i < len; i++) {
	      if (Array.isArray(array[i])) {
	        throw new DimensionError(size.length + 1, size.length, '>');
	      }
	    }
	  }
	}
	
	/**
	 * Validate whether each element in a multi dimensional array has
	 * a size corresponding to the provided size array.
	 * @param {Array} array    Array to be validated
	 * @param {number[]} size  Array with the size of each dimension
	 * @throws DimensionError
	 */
	exports.validate = function(array, size) {
	  var isScalar = (size.length == 0);
	  if (isScalar) {
	    // scalar
	    if (Array.isArray(array)) {
	      throw new DimensionError(array.length, 0);
	    }
	  }
	  else {
	    // array
	    _validate(array, size, 0);
	  }
	};
	
	/**
	 * Test whether index is an integer number with index >= 0 and index < length
	 * when length is provided
	 * @param {number} index    Zero-based index
	 * @param {number} [length] Length of the array
	 */
	exports.validateIndex = function(index, length) {
	  if (!number.isNumber(index) || !number.isInteger(index)) {
	    throw new TypeError('Index must be an integer (value: ' + index + ')');
	  }
	  if (index < 0 || (typeof length === 'number' && index >= length)) {
	    throw new IndexError(index, length);
	  }
	};
	
	/**
	 * Resize a multi dimensional array. The resized array is returned.
	 * @param {Array} array         Array to be resized
	 * @param {Array.<number>} size Array with the size of each dimension
	 * @param {*} [defaultValue=0]  Value to be filled in in new entries,
	 *                              zero by default. Specify for example `null`,
	 *                              to clearly see entries that are not explicitly
	 *                              set.
	 * @return {Array} array         The resized array
	 */
	exports.resize = function(array, size, defaultValue) {
	  // TODO: add support for scalars, having size=[] ?
	
	  // check the type of the arguments
	  if (!Array.isArray(array) || !Array.isArray(size)) {
	    throw new TypeError('Array expected');
	  }
	  if (size.length === 0) {
	    throw new Error('Resizing to scalar is not supported');
	  }
	
	  // check whether size contains positive integers
	  size.forEach(function (value) {
	    if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
	      throw new TypeError('Invalid size, must contain positive integers ' +
	          '(size: ' + string.format(size) + ')');
	    }
	  });
	
	  // recursively resize the array
	  var _defaultValue = (defaultValue !== undefined) ? defaultValue : 0;
	  _resize(array, size, 0, _defaultValue);
	
	  return array;
	};
	
	/**
	 * Recursively resize a multi dimensional array
	 * @param {Array} array         Array to be resized
	 * @param {number[]} size       Array with the size of each dimension
	 * @param {number} dim          Current dimension
	 * @param {*} [defaultValue]    Value to be filled in in new entries,
	 *                              undefined by default.
	 * @private
	 */
	function _resize (array, size, dim, defaultValue) {
	  var i;
	  var elem;
	  var oldLen = array.length;
	  var newLen = size[dim];
	  var minLen = Math.min(oldLen, newLen);
	
	  // apply new length
	  array.length = newLen;
	
	  if (dim < size.length - 1) {
	    // non-last dimension
	    var dimNext = dim + 1;
	
	    // resize existing child arrays
	    for (i = 0; i < minLen; i++) {
	      // resize child array
	      elem = array[i];
	      if (!Array.isArray(elem)) {
	        elem = [elem]; // add a dimension
	        array[i] = elem;
	      }
	      _resize(elem, size, dimNext, defaultValue);
	    }
	
	    // create new child arrays
	    for (i = minLen; i < newLen; i++) {
	      // get child array
	      elem = [];
	      array[i] = elem;
	
	      // resize new child array
	      _resize(elem, size, dimNext, defaultValue);
	    }
	  }
	  else {
	    // last dimension
	
	    // remove dimensions of existing values
	    for (i = 0; i < minLen; i++) {
	      while (Array.isArray(array[i])) {
	        array[i] = array[i][0];
	      }
	    }
	
	    // fill new elements with the default value
	    for (i = minLen; i < newLen; i++) {
	      array[i] = defaultValue;
	    }
	  }
	}
	
	/**
	 * Re-shape a multi dimensional array to fit the specified dimensions
	 * @param {Array} array           Array to be reshaped
	 * @param {Array.<number>} sizes  List of sizes for each dimension
	 * @returns {Array}               Array whose data has been formatted to fit the
	 *                                specified dimensions
	 *
	 * @throws {DimensionError}       If the product of the new dimension sizes does
	 *                                not equal that of the old ones
	 */
	exports.reshape = function(array, sizes) {
	  var flatArray = exports.flatten(array);
	  var newArray;
	
	  var product = function (arr) {
	    return arr.reduce(function (prev, curr) {
	      return prev * curr;
	    });
	  };
	
	  if (!Array.isArray(array) || !Array.isArray(sizes)) {
	    throw new TypeError('Array expected');
	  }
	
	  if (sizes.length === 0) {
	    throw new DimensionError(0, product(exports.size(array)), '!=');
	  }
	
	  try {
	    newArray  = _reshape(flatArray, sizes);
	  } catch (e) {
	    if (e instanceof DimensionError) {
	      throw new DimensionError(
	        product(sizes),
	        product(exports.size(array)),
	        '!='
	      );
	    }
	    throw e;
	  }
	
	  if (flatArray.length > 0) {
	    throw new DimensionError(
	      product(sizes),
	      product(exports.size(array)),
	      '!='
	    );
	  }
	
	  return newArray;
	};
	
	/**
	 * Recursively re-shape a multi dimensional array to fit the specified dimensions
	 * @param {Array} array           Array to be reshaped
	 * @param {Array.<number>} sizes  List of sizes for each dimension
	 * @returns {Array}               Array whose data has been formatted to fit the
	 *                                specified dimensions
	 *
	 * @throws {DimensionError}       If the product of the new dimension sizes does
	 *                                not equal that of the old ones
	 */
	function _reshape(array, sizes) {
	  var accumulator = [];
	  var i;
	
	  if (sizes.length === 0) {
	    if (array.length === 0) {
	      throw new DimensionError(null, null, '!=');
	    }
	    return array.shift();
	  }
	  for (i = 0; i < sizes[0]; i += 1) {
	    accumulator.push(_reshape(array, sizes.slice(1)));
	  }
	  return accumulator;
	}
	
	
	/**
	 * Squeeze a multi dimensional array
	 * @param {Array} array
	 * @param {Array} [size]
	 * @returns {Array} returns the array itself
	 */
	exports.squeeze = function(array, size) {
	  var s = size || exports.size(array);
	
	  // squeeze outer dimensions
	  while (Array.isArray(array) && array.length === 1) {
	    array = array[0];
	    s.shift();
	  }
	
	  // find the first dimension to be squeezed
	  var dims = s.length;
	  while (s[dims - 1] === 1) {
	    dims--;
	  }
	
	  // squeeze inner dimensions
	  if (dims < s.length) {
	    array = _squeeze(array, dims, 0);
	    s.length = dims;
	  }
	
	  return array;
	};
	
	/**
	 * Recursively squeeze a multi dimensional array
	 * @param {Array} array
	 * @param {number} dims Required number of dimensions
	 * @param {number} dim  Current dimension
	 * @returns {Array | *} Returns the squeezed array
	 * @private
	 */
	function _squeeze (array, dims, dim) {
	  var i, ii;
	
	  if (dim < dims) {
	    var next = dim + 1;
	    for (i = 0, ii = array.length; i < ii; i++) {
	      array[i] = _squeeze(array[i], dims, next);
	    }
	  }
	  else {
	    while (Array.isArray(array)) {
	      array = array[0];
	    }
	  }
	
	  return array;
	}
	
	/**
	 * Unsqueeze a multi dimensional array: add dimensions when missing
	 * 
	 * Paramter `size` will be mutated to match the new, unqueezed matrix size.
	 * 
	 * @param {Array} array
	 * @param {number} dims     Desired number of dimensions of the array
	 * @param {number} [outer]  Number of outer dimensions to be added
	 * @param {Array} [size]    Current size of array.
	 * @returns {Array} returns the array itself
	 * @private
	 */
	exports.unsqueeze = function(array, dims, outer, size) {
	  var s = size || exports.size(array);
	
	  // unsqueeze outer dimensions
	  if (outer) {
	    for (var i = 0; i < outer; i++) {
	      array = [array];
	      s.unshift(1);
	    }
	  }
	
	  // unsqueeze inner dimensions
	  array = _unsqueeze(array, dims, 0);
	  while (s.length < dims) {
	    s.push(1);
	  }
	
	  return array;
	};
	
	/**
	 * Recursively unsqueeze a multi dimensional array
	 * @param {Array} array
	 * @param {number} dims Required number of dimensions
	 * @param {number} dim  Current dimension
	 * @returns {Array | *} Returns the squeezed array
	 * @private
	 */
	function _unsqueeze (array, dims, dim) {
	  var i, ii;
	
	  if (Array.isArray(array)) {
	    var next = dim + 1;
	    for (i = 0, ii = array.length; i < ii; i++) {
	      array[i] = _unsqueeze(array[i], dims, next);
	    }
	  }
	  else {
	    for (var d = dim; d < dims; d++) {
	      array = [array];
	    }
	  }
	
	  return array;
	}
	/**
	 * Flatten a multi dimensional array, put all elements in a one dimensional
	 * array
	 * @param {Array} array   A multi dimensional array
	 * @return {Array}        The flattened array (1 dimensional)
	 */
	exports.flatten = function(array) {
	  if (!Array.isArray(array)) {
	    //if not an array, return as is
	    return array;
	  }
	  var flat = [];
	
	  array.forEach(function callback(value) {
	    if (Array.isArray(value)) {
	      value.forEach(callback);  //traverse through sub-arrays recursively
	    }
	    else {
	      flat.push(value);
	    }
	  });
	
	  return flat;
	};
	
	/**
	 * A safe map
	 * @param {Array} array
	 * @param {function} callback
	 */
	exports.map = function (array, callback) {
	  return Array.prototype.map.call(array, callback);
	}
	
	/**
	 * A safe forEach
	 * @param {Array} array
	 * @param {function} callback
	 */
	exports.forEach = function (array, callback) {
	  Array.prototype.forEach.call(array, callback);
	}
	
	/**
	 * A safe filter
	 * @param {Array} array
	 * @param {function} callback
	 */
	exports.filter = function (array, callback) {
	  if (exports.size(array).length !== 1) {
	    throw new Error('Only one dimensional matrices supported');
	  }
	
	  return Array.prototype.filter.call(array, callback);
	}
	
	/**
	 * Filter values in a callback given a regular expression
	 * @param {Array} array
	 * @param {RegExp} regexp
	 * @return {Array} Returns the filtered array
	 * @private
	 */
	exports.filterRegExp = function (array, regexp) {
	  if (exports.size(array).length !== 1) {
	    throw new Error('Only one dimensional matrices supported');
	  }
	
	  return Array.prototype.filter.call(array, function (entry) {
	    return regexp.test(entry);
	  });
	}
	
	/**
	 * A safe join
	 * @param {Array} array
	 * @param {string} separator
	 */
	exports.join = function (array, separator) {
	  return Array.prototype.join.call(array, separator);
	}
	
	/**
	 * Assign a numeric identifier to every element of a sorted array
	 * @param {Array}	a  An array
	 * @return {Array}	An array of objects containing the original value and its identifier
	 */
	exports.identify = function(a) {
	  if (!Array.isArray(a)) {
		throw new TypeError('Array input expected');
	  }
		
	  if (a.length === 0) {
		return a;
	  }
		
	  var b = [];
	  var count = 0;
	  b[0] = {value: a[0], identifier: 0};
	  for (var i=1; i<a.length; i++) {
	    if (a[i] === a[i-1]) {
	  	count++;
	    }
	    else {
	      count = 0;
	    }
	    b.push({value: a[i], identifier: count});
	  }
	  return b;
	}
	
	/**
	 * Remove the numeric identifier from the elements
	 * @param	a  An array
	 * @return	An array of values without identifiers
	 */
	exports.generalize = function(a) {
	  if (!Array.isArray(a)) {
		throw new TypeError('Array input expected');
	  }
		
	  if (a.length === 0) {
		return a;
	  }
		
	  var b = [];
	  for (var i=0; i<a.length; i++) {
	    b.push(a[i].value);
	  }
	  return b;
	}
	
	/**
	 * Test whether an object is an array
	 * @param {*} value
	 * @return {boolean} isArray
	 */
	exports.isArray = Array.isArray;


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Create a range error with the message:
	 *     'Dimension mismatch (<actual size> != <expected size>)'
	 * @param {number | number[]} actual        The actual size
	 * @param {number | number[]} expected      The expected size
	 * @param {string} [relation='!=']          Optional relation between actual
	 *                                          and expected size: '!=', '<', etc.
	 * @extends RangeError
	 */
	function DimensionError(actual, expected, relation) {
	  if (!(this instanceof DimensionError)) {
	    throw new SyntaxError('Constructor must be called with the new operator');
	  }
	
	  this.actual   = actual;
	  this.expected = expected;
	  this.relation = relation;
	
	  this.message = 'Dimension mismatch (' +
	      (Array.isArray(actual) ? ('[' + actual.join(', ') + ']') : actual) +
	      ' ' + (this.relation || '!=') + ' ' +
	      (Array.isArray(expected) ? ('[' + expected.join(', ') + ']') : expected) +
	      ')';
	
	  this.stack = (new Error()).stack;
	}
	
	DimensionError.prototype = new RangeError();
	DimensionError.prototype.constructor = RangeError;
	DimensionError.prototype.name = 'DimensionError';
	DimensionError.prototype.isDimensionError = true;
	
	module.exports = DimensionError;


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Create a range error with the message:
	 *     'Index out of range (index < min)'
	 *     'Index out of range (index < max)'
	 *
	 * @param {number} index     The actual index
	 * @param {number} [min=0]   Minimum index (included)
	 * @param {number} [max]     Maximum index (excluded)
	 * @extends RangeError
	 */
	function IndexError(index, min, max) {
	  if (!(this instanceof IndexError)) {
	    throw new SyntaxError('Constructor must be called with the new operator');
	  }
	
	  this.index = index;
	  if (arguments.length < 3) {
	    this.min = 0;
	    this.max = min;
	  }
	  else {
	    this.min = min;
	    this.max = max;
	  }
	
	  if (this.min !== undefined && this.index < this.min) {
	    this.message = 'Index out of range (' + this.index + ' < ' + this.min + ')';
	  }
	  else if (this.max !== undefined && this.index >= this.max) {
	    this.message = 'Index out of range (' + this.index + ' > ' + (this.max - 1) + ')';
	  }
	  else {
	    this.message = 'Index out of range (' + this.index + ')';
	  }
	
	  this.stack = (new Error()).stack;
	}
	
	IndexError.prototype = new RangeError();
	IndexError.prototype.constructor = RangeError;
	IndexError.prototype.name = 'IndexError';
	IndexError.prototype.isIndexError = true;
	
	module.exports = IndexError;


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Test whether value is a boolean
	 * @param {*} value
	 * @return {boolean} isBoolean
	 */
	exports.isBoolean = function(value) {
	  return typeof value == 'boolean';
	};


/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	'use strict';
	// function utils
	
	/**
	 * Memoize a given function by caching the computed result.
	 * The cache of a memoized function can be cleared by deleting the `cache`
	 * property of the function.
	 *
	 * @param {function} fn                     The function to be memoized.
	 *                                          Must be a pure function.
	 * @param {function(args: Array)} [hasher]  A custom hash builder.
	 *                                          Is JSON.stringify by default.
	 * @return {function}                       Returns the memoized function
	 */
	exports.memoize = function(fn, hasher) {
	  return function memoize() {
	    if (typeof memoize.cache !== 'object') {
	      memoize.cache = {};
	    }
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    var hash = hasher ? hasher(args) : JSON.stringify(args);
	    if (!(hash in memoize.cache)) {
	      return memoize.cache[hash] = fn.apply(fn, args);
	    }
	    return memoize.cache[hash];
	  };
	};
	
	/**
	 * Find the maximum number of arguments expected by a typed function.
	 * @param {function} fn   A typed function
	 * @return {number} Returns the maximum number of expected arguments.
	 *                  Returns -1 when no signatures where found on the function.
	 */
	exports.maxArgumentCount = function (fn) {
	  return Object.keys(fn.signatures || {})
	      .reduce(function (args, signature) {
	        var count = (signature.match(/,/g) || []).length + 1;
	        return Math.max(args, count);
	      }, -1);
	};
	
	/**
	 * Call a typed function with the
	 * @param {function} fn   A function or typed function
	 * @return {number} Returns the maximum number of expected arguments.
	 *                  Returns -1 when no signatures where found on the function.
	 */
	exports.callWithRightArgumentCount = function (fn, args, argCount) {
	  return Object.keys(fn.signatures || {})
	      .reduce(function (args, signature) {
	        var count = (signature.match(/,/g) || []).length + 1;
	        return Math.max(args, count);
	      }, -1);
	};


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	var DimensionError = __webpack_require__(1358);
	
	var string = util.string;
	var array = util.array;
	var object = util.object;
	var number = util.number;
	
	var isArray = Array.isArray;
	var isNumber = number.isNumber;
	var isInteger = number.isInteger;
	var isString = string.isString;
	
	var validateIndex = array.validateIndex;
	
	function factory (type, config, load, typed) {
	  var Matrix = load(__webpack_require__(1355)); // force loading Matrix (do not use via type.Matrix)
	
	  /**
	   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
	   * @class DenseMatrix
	   */
	  function DenseMatrix(data, datatype) {
	    if (!(this instanceof DenseMatrix))
	      throw new SyntaxError('Constructor must be called with the new operator');
	    if (datatype && !isString(datatype))
	      throw new Error('Invalid datatype: ' + datatype);
	
	    if (type.isMatrix(data)) {
	      // check data is a DenseMatrix
	      if (data.type === 'DenseMatrix') {
	        // clone data & size
	        this._data = object.clone(data._data);
	        this._size = object.clone(data._size);
	        this._datatype = datatype || data._datatype;
	      }
	      else {
	        // build data from existing matrix
	        this._data = data.toArray();
	        this._size = data.size();
	        this._datatype = datatype || data._datatype;
	      }
	    }
	    else if (data && isArray(data.data) && isArray(data.size)) {
	      // initialize fields from JSON representation
	      this._data = data.data;
	      this._size = data.size;
	      this._datatype = datatype || data.datatype;
	    }
	    else if (isArray(data)) {
	      // replace nested Matrices with Arrays
	      this._data = preprocess(data);
	      // get the dimensions of the array
	      this._size = array.size(this._data);
	      // verify the dimensions of the array, TODO: compute size while processing array
	      array.validate(this._data, this._size);
	      // data type unknown
	      this._datatype = datatype;
	    }
	    else if (data) {
	      // unsupported type
	      throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
	    }
	    else {
	      // nothing provided
	      this._data = [];
	      this._size = [0];
	      this._datatype = datatype;
	    }
	  }
	  
	  DenseMatrix.prototype = new Matrix();
	
	  /**
	   * Attach type information
	   */
	  DenseMatrix.prototype.type = 'DenseMatrix';
	  DenseMatrix.prototype.isDenseMatrix = true;
	
	  /**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @memberof DenseMatrix
	   * @return {string}           The storage format.
	   */
	  DenseMatrix.prototype.storage = function () {
	    return 'dense';
	  };
	
	  /**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @memberof DenseMatrix
	   * @return {string}           The datatype.
	   */
	  DenseMatrix.prototype.datatype = function () {
	    return this._datatype;
	  };
	
	  /**
	   * Create a new DenseMatrix
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {string} [datatype]
	   */
	  DenseMatrix.prototype.create = function (data, datatype) {
	    return new DenseMatrix(data, datatype);
	  };
	
	  /**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @memberof DenseMatrix
	   * @param {Index} index
	   * @param {Array | DenseMatrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */
	  DenseMatrix.prototype.subset = function (index, replacement, defaultValue) {
	    switch (arguments.length) {
	      case 1:
	        return _get(this, index);
	
	        // intentional fall through
	      case 2:
	      case 3:
	        return _set(this, index, replacement, defaultValue);
	
	      default:
	        throw new SyntaxError('Wrong number of arguments');
	    }
	  };
	  
	  /**
	   * Get a single element from the matrix.
	   * @memberof DenseMatrix
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */
	  DenseMatrix.prototype.get = function (index) {
	    if (!isArray(index))
	      throw new TypeError('Array expected');
	    if (index.length != this._size.length)
	      throw new DimensionError(index.length, this._size.length);
	
	    // check index
	    for (var x = 0; x < index.length; x++)
	      validateIndex(index[x], this._size[x]);
	
	    var data = this._data;
	    for (var i = 0, ii = index.length; i < ii; i++) {
	      var index_i = index[i];
	      validateIndex(index_i, data.length);
	      data = data[index_i];
	    }
	
	    return data;
	  };
	  
	  /**
	   * Replace a single element in the matrix.
	   * @memberof DenseMatrix
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {DenseMatrix} self
	   */
	  DenseMatrix.prototype.set = function (index, value, defaultValue) {
	    if (!isArray(index))
	      throw new TypeError('Array expected');
	    if (index.length < this._size.length)
	      throw new DimensionError(index.length, this._size.length, '<');
	
	    var i, ii, index_i;
	
	    // enlarge matrix when needed
	    var size = index.map(function (i) {
	      return i + 1;
	    });
	    _fit(this, size, defaultValue);
	
	    // traverse over the dimensions
	    var data = this._data;
	    for (i = 0, ii = index.length - 1; i < ii; i++) {
	      index_i = index[i];
	      validateIndex(index_i, data.length);
	      data = data[index_i];
	    }
	
	    // set new value
	    index_i = index[index.length - 1];
	    validateIndex(index_i, data.length);
	    data[index_i] = value;
	
	    return this;
	  };
	  
	  /**
	   * Get a submatrix of this matrix
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix
	   * @param {Index} index   Zero-based index
	   * @private
	   */
	  function _get (matrix, index) {
	    if (!type.isIndex(index)) {
	      throw new TypeError('Invalid index');
	    }
	
	    var isScalar = index.isScalar();
	    if (isScalar) {
	      // return a scalar
	      return matrix.get(index.min());
	    }
	    else {
	      // validate dimensions
	      var size = index.size();
	      if (size.length != matrix._size.length) {
	        throw new DimensionError(size.length, matrix._size.length);
	      }
	
	      // validate if any of the ranges in the index is out of range
	      var min = index.min();
	      var max = index.max();
	      for (var i = 0, ii = matrix._size.length; i < ii; i++) {
	        validateIndex(min[i], matrix._size[i]);
	        validateIndex(max[i], matrix._size[i]);
	      }
	
	      // retrieve submatrix
	      // TODO: more efficient when creating an empty matrix and setting _data and _size manually
	      return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
	    }
	  }
	  
	  /**
	   * Recursively get a submatrix of a multi dimensional matrix.
	   * Index is not checked for correct number or length of dimensions.
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {Index} index
	   * @param {number} dims   Total number of dimensions
	   * @param {number} dim    Current dimension
	   * @return {Array} submatrix
	   * @private
	   */
	  function _getSubmatrix (data, index, dims, dim) {
	    var last = (dim === dims - 1);
	    var range = index.dimension(dim);
	
	    if (last) {
	      return range.map(function (i) {
	        validateIndex(i, data.length);
	        return data[i];
	      }).valueOf();
	    }
	    else {
	      return range.map(function (i) {
	        validateIndex(i, data.length);
	        var child = data[i];
	        return _getSubmatrix(child, index, dims, dim + 1);
	      }).valueOf();
	    }
	  }
	  
	  /**
	   * Replace a submatrix in this matrix
	   * Indexes are zero-based.
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix
	   * @param {Index} index
	   * @param {DenseMatrix | Array | *} submatrix
	   * @param {*} defaultValue          Default value, filled in on new entries when
	   *                                  the matrix is resized.
	   * @return {DenseMatrix} matrix
	   * @private
	   */
	  function _set (matrix, index, submatrix, defaultValue) {
	    if (!index || index.isIndex !== true) {
	      throw new TypeError('Invalid index');
	    }
	
	    // get index size and check whether the index contains a single value
	    var iSize = index.size(),
	        isScalar = index.isScalar();
	
	    // calculate the size of the submatrix, and convert it into an Array if needed
	    var sSize;
	    if (type.isMatrix(submatrix)) {
	      sSize = submatrix.size();
	      submatrix = submatrix.valueOf();
	    }
	    else {
	      sSize = array.size(submatrix);
	    }
	
	    if (isScalar) {
	      // set a scalar
	
	      // check whether submatrix is a scalar
	      if (sSize.length !== 0) {
	        throw new TypeError('Scalar expected');
	      }
	
	      matrix.set(index.min(), submatrix, defaultValue);
	    }
	    else {
	      // set a submatrix
	
	      // validate dimensions
	      if (iSize.length < matrix._size.length) {
	        throw new DimensionError(iSize.length, matrix._size.length, '<');
	      }
	
	      if (sSize.length < iSize.length) {
	        // calculate number of missing outer dimensions
	        var i = 0;
	        var outer = 0;
	        while (iSize[i] === 1 && sSize[i] === 1) {
	          i++;
	        }
	        while (iSize[i] === 1) {
	          outer++;
	          i++;
	        }
	
	        // unsqueeze both outer and inner dimensions
	        submatrix = array.unsqueeze(submatrix, iSize.length, outer, sSize);
	      }
	
	      // check whether the size of the submatrix matches the index size
	      if (!object.deepEqual(iSize, sSize)) {
	        throw new DimensionError(iSize, sSize, '>');
	      }
	
	      // enlarge matrix when needed
	      var size = index.max().map(function (i) {
	        return i + 1;
	      });
	      _fit(matrix, size, defaultValue);
	
	      // insert the sub matrix
	      var dims = iSize.length,
	          dim = 0;
	      _setSubmatrix (matrix._data, index, submatrix, dims, dim);
	    }
	
	    return matrix;
	  }
	  
	  /**
	   * Replace a submatrix of a multi dimensional matrix.
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @param {Index} index
	   * @param {Array} submatrix
	   * @param {number} dims   Total number of dimensions
	   * @param {number} dim
	   * @private
	   */
	  function _setSubmatrix (data, index, submatrix, dims, dim) {
	    var last = (dim === dims - 1),
	        range = index.dimension(dim);
	
	    if (last) {
	      range.forEach(function (dataIndex, subIndex) {
	        validateIndex(dataIndex);
	        data[dataIndex] = submatrix[subIndex[0]];
	      });
	    }
	    else {
	      range.forEach(function (dataIndex, subIndex) {
	        validateIndex(dataIndex);
	        _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
	      });
	    }
	  }
	  
	  /**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @memberof DenseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */
	  DenseMatrix.prototype.resize = function (size, defaultValue, copy) {
	    // validate arguments
	    if (!isArray(size))
	      throw new TypeError('Array expected');
	
	    // matrix to resize
	    var m = copy ? this.clone() : this;
	    // resize matrix
	    return _resize(m, size, defaultValue);
	  };
	  
	  var _resize = function (matrix, size, defaultValue) {
	    // check size
	    if (size.length === 0) {
	      // first value in matrix
	      var v = matrix._data;
	      // go deep
	      while (isArray(v)) {
	        v = v[0];
	      }
	      return v;
	    }
	    // resize matrix
	    matrix._size = size.slice(0); // copy the array
	    matrix._data = array.resize(matrix._data, matrix._size, defaultValue);
	    // return matrix
	    return matrix;
	  };
	
	  /**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * NOTE: This might be better suited to copy by default, instead of modifying
	   *       in place. For now, it operates in place to remain consistent with
	   *       resize().
	   *
	   * @memberof DenseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */
	  DenseMatrix.prototype.reshape = function (size, copy) {
	    var m = copy ? this.clone() : this;
	
	    m._data = array.reshape(m._data, size);
	    m._size = size.slice(0);
	    return m;
	  };
	  
	  /**
	   * Enlarge the matrix when it is smaller than given size.
	   * If the matrix is larger or equal sized, nothing is done.
	   * @memberof DenseMatrix
	   * @param {DenseMatrix} matrix           The matrix to be resized
	   * @param {number[]} size
	   * @param {*} defaultValue          Default value, filled in on new entries.
	   * @private
	   */
	  function _fit(matrix, size, defaultValue) {
	    var newSize = matrix._size.slice(0), // copy the array
	        changed = false;
	
	    // add dimensions when needed
	    while (newSize.length < size.length) {
	      newSize.push(0);
	      changed = true;
	    }
	
	    // enlarge size when needed
	    for (var i = 0, ii = size.length; i < ii; i++) {
	      if (size[i] > newSize[i]) {
	        newSize[i] = size[i];
	        changed = true;
	      }
	    }
	
	    if (changed) {
	      // resize only when size is changed
	      _resize(matrix, newSize, defaultValue);
	    }
	  }
	  
	  /**
	   * Create a clone of the matrix
	   * @memberof DenseMatrix
	   * @return {DenseMatrix} clone
	   */
	  DenseMatrix.prototype.clone = function () {
	    var m = new DenseMatrix({
	      data: object.clone(this._data),
	      size: object.clone(this._size),
	      datatype: this._datatype
	    });
	    return m;
	  };
	  
	  /**
	   * Retrieve the size of the matrix.
	   * @memberof DenseMatrix
	   * @returns {number[]} size
	   */
	  DenseMatrix.prototype.size = function() {
	    return this._size.slice(0); // return a clone of _size
	  };
	  
	  /**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @memberof DenseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   *
	   * @return {DenseMatrix} matrix
	   */
	  DenseMatrix.prototype.map = function (callback) {
	    // matrix instance
	    var me = this;
	    var recurse = function (value, index) {
	      if (isArray(value)) {
	        return value.map(function (child, i) {
	          return recurse(child, index.concat(i));
	        });
	      }
	      else {
	        return callback(value, index, me);
	      }
	    };
	    // return dense format
	    return new DenseMatrix({
	      data: recurse(this._data, []),
	      size: object.clone(this._size),
	      datatype: this._datatype
	    });
	  };
	  
	  /**
	   * Execute a callback function on each entry of the matrix.
	   * @memberof DenseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   */
	  DenseMatrix.prototype.forEach = function (callback) {
	    // matrix instance
	    var me = this;
	    var recurse = function (value, index) {
	      if (isArray(value)) {
	        value.forEach(function (child, i) {
	          recurse(child, index.concat(i));
	        });
	      }
	      else {
	        callback(value, index, me);
	      }
	    };
	    recurse(this._data, []);
	  };
	  
	  /**
	   * Create an Array with a copy of the data of the DenseMatrix
	   * @memberof DenseMatrix
	   * @returns {Array} array
	   */
	  DenseMatrix.prototype.toArray = function () {
	    return object.clone(this._data);
	  };
	  
	  /**
	   * Get the primitive value of the DenseMatrix: a multidimensional array
	   * @memberof DenseMatrix
	   * @returns {Array} array
	   */
	  DenseMatrix.prototype.valueOf = function () {
	    return this._data;
	  };
	  
	  /**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @memberof DenseMatrix
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */
	  DenseMatrix.prototype.format = function (options) {
	    return string.format(this._data, options);
	  };
	  
	  /**
	   * Get a string representation of the matrix
	   * @memberof DenseMatrix
	   * @returns {string} str
	   */
	  DenseMatrix.prototype.toString = function () {
	    return string.format(this._data);
	  };
	  
	  /**
	   * Get a JSON representation of the matrix
	   * @memberof DenseMatrix
	   * @returns {Object}
	   */
	  DenseMatrix.prototype.toJSON = function () {
	    return {
	      mathjs: 'DenseMatrix',
	      data: this._data,
	      size: this._size,
	      datatype: this._datatype
	    };
	  };
	  
	  /**
	   * Get the kth Matrix diagonal.
	   *
	   * @memberof DenseMatrix
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
	   *
	   * @returns {Array}                      The array vector with the diagonal values.
	   */
	  DenseMatrix.prototype.diagonal = function(k) {
	    // validate k if any
	    if (k) {
	      // convert BigNumber to a number
	      if (type.isBigNumber(k))
	        k = k.toNumber();
	      // is must be an integer
	      if (!isNumber(k) || !isInteger(k)) {
	        throw new TypeError ('The parameter k must be an integer number');
	      }
	    }
	    else {
	      // default value
	      k = 0;
	    }
	
	    var kSuper = k > 0 ? k : 0;
	    var kSub = k < 0 ? -k : 0;
	
	    // rows & columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	
	    // number diagonal values
	    var n = Math.min(rows - kSub, columns -  kSuper);
	    
	    // x is a matrix get diagonal from matrix
	    var data = [];
	    
	    // loop rows
	    for (var i = 0; i < n; i++) {
	      data[i] = this._data[i + kSub][i + kSuper];
	    }
	
	    // create DenseMatrix
	    return new DenseMatrix({
	      data: data,
	      size: [n],
	      datatype: this._datatype
	    });
	  };
	  
	  /**
	   * Create a diagonal matrix.
	   *
	   * @memberof DenseMatrix
	   * @param {Array} size                   The matrix size.
	   * @param {number | Array} value          The values for the diagonal.
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will be filled in.
	   * @param {number} [defaultValue]        The default value for non-diagonal
	   *
	   * @returns {DenseMatrix}
	   */
	  DenseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
	    if (!isArray(size))
	      throw new TypeError('Array expected, size parameter');
	    if (size.length !== 2)
	      throw new Error('Only two dimensions matrix are supported');
	
	    // map size & validate
	    size = size.map(function (s) {
	      // check it is a big number
	      if (type.isBigNumber(s)) {
	        // convert it
	        s = s.toNumber();
	      }
	      // validate arguments
	      if (!isNumber(s) || !isInteger(s) || s < 1) {
	        throw new Error('Size values must be positive integers');
	      } 
	      return s;
	    });
	
	    // validate k if any
	    if (k) {
	      // convert BigNumber to a number
	      if (type.isBigNumber(k))
	        k = k.toNumber();
	      // is must be an integer
	      if (!isNumber(k) || !isInteger(k)) {
	        throw new TypeError ('The parameter k must be an integer number');
	      }
	    }
	    else {
	      // default value
	      k = 0;
	    }
	    
	    if (defaultValue && isString(datatype)) {
	      // convert defaultValue to the same datatype
	      defaultValue = typed.convert(defaultValue, datatype);
	    }
	
	    var kSuper = k > 0 ? k : 0;
	    var kSub = k < 0 ? -k : 0;
	    
	    // rows and columns
	    var rows = size[0];
	    var columns = size[1];
	
	    // number of non-zero items
	    var n = Math.min(rows - kSub, columns -  kSuper);
	
	    // value extraction function
	    var _value;
	
	    // check value
	    if (isArray(value)) {
	      // validate array
	      if (value.length !== n) {
	        // number of values in array must be n
	        throw new Error('Invalid value array length');
	      }
	      // define function
	      _value = function (i) {
	        // return value @ i
	        return value[i];
	      };      
	    }
	    else if (type.isMatrix(value)) {
	      // matrix size
	      var ms = value.size();
	      // validate matrix
	      if (ms.length !== 1 || ms[0] !== n) {
	        // number of values in array must be n
	        throw new Error('Invalid matrix length');
	      }
	      // define function
	      _value = function (i) {
	        // return value @ i
	        return value.get([i]);
	      };
	    }
	    else {
	      // define function
	      _value = function () {
	        // return value
	        return value;
	      };
	    }
	    
	    // discover default value if needed
	    if (!defaultValue) {
	      // check first value in array
	      defaultValue = type.isBigNumber(_value(0)) ? new type.BigNumber(0) : 0;
	    }
	
	    // empty array
	    var data = [];
	
	    // check we need to resize array
	    if (size.length > 0) {
	      // resize array
	      data = array.resize(data, size, defaultValue);
	      // fill diagonal
	      for (var d = 0; d < n; d++) {
	        data[d + kSub][d + kSuper] = _value(d);
	      }
	    }
	    
	    // create DenseMatrix
	    return new DenseMatrix({
	      data: data,
	      size: [rows, columns]
	    });
	  };
	
	  /**
	   * Generate a matrix from a JSON object
	   * @memberof DenseMatrix
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
	   *                       where mathjs is optional
	   * @returns {DenseMatrix}
	   */
	  DenseMatrix.fromJSON = function (json) {
	    return new DenseMatrix(json);
	  };
	  
	  /**
	   * Swap rows i and j in Matrix.
	   *
	   * @memberof DenseMatrix
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */
	  DenseMatrix.prototype.swapRows = function (i, j) {
	    // check index
	    if (!isNumber(i) || !isInteger(i) || !isNumber(j) || !isInteger(j)) {
	      throw new Error('Row index must be positive integers');
	    }
	    // check dimensions
	    if (this._size.length !== 2) {
	      throw new Error('Only two dimensional matrix is supported');
	    }
	    // validate index
	    validateIndex(i, this._size[0]);
	    validateIndex(j, this._size[0]);
	
	    // swap rows
	    DenseMatrix._swapRows(i, j, this._data);
	    // return current instance
	    return this;
	  };
	
	  /**
	   * Swap rows i and j in Dense Matrix data structure.
	   *
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   */
	  DenseMatrix._swapRows = function (i, j, data) {
	    // swap values i <-> j
	    var vi = data[i];
	    data[i] = data[j];
	    data[j] = vi;
	  };
	
	  /**
	   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
	   * Matrices. Replaces all nested Matrices with Arrays
	   * @memberof DenseMatrix
	   * @param {Array} data
	   * @return {Array} data
	   */
	  function preprocess(data) {
	    for (var i = 0, ii = data.length; i < ii; i++) {
	      var elem = data[i];
	      if (isArray(elem)) {
	        data[i] = preprocess(elem);
	      }
	      else if (elem && elem.isMatrix === true) {
	        data[i] = preprocess(elem.valueOf());
	      }
	    }
	
	    return data;
	  }
	
	  // register this type in the base class Matrix
	  type.Matrix._storage.dense = DenseMatrix;
	  type.Matrix._storage['default'] = DenseMatrix;
	
	  // exports
	  return DenseMatrix;
	}
	
	exports.name = 'DenseMatrix';
	exports.path = 'type';
	exports.factory = factory;
	exports.lazy = false;  // no lazy loading, as we alter type.Matrix._storage


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	var DimensionError = __webpack_require__(1358);
	
	var array = util.array;
	var object = util.object;
	var string = util.string;
	var number = util.number;
	
	var isArray = Array.isArray;
	var isNumber = number.isNumber;
	var isInteger = number.isInteger;
	var isString = string.isString;
	
	var validateIndex = array.validateIndex;
	
	function factory (type, config, load, typed) {
	  var Matrix = load(__webpack_require__(1355)); // force loading Matrix (do not use via type.Matrix)
	  var equalScalar = load(__webpack_require__(1364));
	
	  /**
	   * Sparse Matrix implementation. This type implements a Compressed Column Storage format
	   * for sparse matrices.
	   * @class SparseMatrix
	   */
	  function SparseMatrix(data, datatype) {
	    if (!(this instanceof SparseMatrix))
	      throw new SyntaxError('Constructor must be called with the new operator');
	    if (datatype && !isString(datatype))
	      throw new Error('Invalid datatype: ' + datatype);
	    
	    if (type.isMatrix(data)) {
	      // create from matrix
	      _createFromMatrix(this, data, datatype);
	    }
	    else if (data && isArray(data.index) && isArray(data.ptr) && isArray(data.size)) {
	      // initialize fields
	      this._values = data.values;
	      this._index = data.index;
	      this._ptr = data.ptr;
	      this._size = data.size;
	      this._datatype = datatype || data.datatype;
	    }
	    else if (isArray(data)) {
	      // create from array
	      _createFromArray(this, data, datatype);
	    }
	    else if (data) {
	      // unsupported type
	      throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
	    }
	    else {
	      // nothing provided
	      this._values = [];
	      this._index = [];
	      this._ptr = [0];
	      this._size = [0, 0];
	      this._datatype = datatype;
	    }
	  }
	  
	  var _createFromMatrix = function (matrix, source, datatype) {
	    // check matrix type
	    if (source.type === 'SparseMatrix') {
	      // clone arrays
	      matrix._values = source._values ? object.clone(source._values) : undefined;
	      matrix._index = object.clone(source._index);
	      matrix._ptr = object.clone(source._ptr);
	      matrix._size = object.clone(source._size);
	      matrix._datatype = datatype || source._datatype;
	    }
	    else {
	      // build from matrix data
	      _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
	    }
	  };
	  
	  var _createFromArray = function (matrix, data, datatype) {
	    // initialize fields
	    matrix._values = [];
	    matrix._index = [];
	    matrix._ptr = [];
	    matrix._datatype = datatype;
	    // discover rows & columns, do not use math.size() to avoid looping array twice
	    var rows = data.length;
	    var columns = 0;
	    
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    
	    if (isString(datatype)) {
	      // find signature that matches (datatype, datatype)
	      eq = typed.find(equalScalar, [datatype, datatype]) || equalScalar;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, datatype);
	    }
	
	    // check we have rows (empty array)
	    if (rows > 0) {
	      // column index
	      var j = 0;
	      do {
	        // store pointer to values index
	        matrix._ptr.push(matrix._index.length);
	        // loop rows
	        for (var i = 0; i < rows; i++) {
	          // current row
	          var row = data[i];
	          // check row is an array
	          if (isArray(row)) {
	            // update columns if needed (only on first column)
	            if (j === 0 && columns < row.length)
	              columns = row.length;
	            // check row has column
	            if (j < row.length) {
	              // value
	              var v = row[j];
	              // check value != 0
	              if (!eq(v, zero)) {
	                // store value
	                matrix._values.push(v);
	                // index
	                matrix._index.push(i);
	              }
	            }
	          }
	          else {
	            // update columns if needed (only on first column)
	            if (j === 0 && columns < 1)
	              columns = 1;
	            // check value != 0 (row is a scalar)
	            if (!eq(row, zero)) {
	              // store value
	              matrix._values.push(row);
	              // index
	              matrix._index.push(i);
	            }
	          }
	        }
	        // increment index
	        j++;      
	      }
	      while (j < columns);
	    }
	    // store number of values in ptr
	    matrix._ptr.push(matrix._index.length);
	    // size
	    matrix._size = [rows, columns];
	  };
	  
	  SparseMatrix.prototype = new Matrix();
	
	  /**
	   * Attach type information
	   */
	  SparseMatrix.prototype.type = 'SparseMatrix';
	  SparseMatrix.prototype.isSparseMatrix = true;
	
	  /**
	   * Get the storage format used by the matrix.
	   *
	   * Usage:
	   *     var format = matrix.storage()                   // retrieve storage format
	   *
	   * @memberof SparseMatrix
	   * @return {string}           The storage format.
	   */
	  SparseMatrix.prototype.storage = function () {
	    return 'sparse';
	  };
	
	  /**
	   * Get the datatype of the data stored in the matrix.
	   *
	   * Usage:
	   *     var format = matrix.datatype()                   // retrieve matrix datatype
	   *
	   * @memberof SparseMatrix
	   * @return {string}           The datatype.
	   */
	  SparseMatrix.prototype.datatype = function () {
	    return this._datatype;
	  };
	
	  /**
	   * Create a new SparseMatrix
	   * @memberof SparseMatrix
	   * @param {Array} data
	   * @param {string} [datatype]
	   */
	  SparseMatrix.prototype.create = function (data, datatype) {
	    return new SparseMatrix(data, datatype);
	  };
	
	  /**
	   * Get the matrix density.
	   *
	   * Usage:
	   *     var density = matrix.density()                   // retrieve matrix density
	   *
	   * @memberof SparseMatrix
	   * @return {number}           The matrix density.
	   */
	  SparseMatrix.prototype.density = function () {
	    // rows & columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    // calculate density
	    return rows !== 0 && columns !== 0 ? (this._index.length / (rows * columns)) : 0;
	  };
	  
	  /**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @memberof SparseMatrix
	   * @param {Index} index
	   * @param {Array | Maytrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */
	  SparseMatrix.prototype.subset = function (index, replacement, defaultValue) { // check it is a pattern matrix
	    if (!this._values)
	      throw new Error('Cannot invoke subset on a Pattern only matrix');
	
	    // check arguments
	    switch (arguments.length) {
	      case 1:
	        return _getsubset(this, index);
	
	        // intentional fall through
	      case 2:
	      case 3:
	        return _setsubset(this, index, replacement, defaultValue);
	
	      default:
	        throw new SyntaxError('Wrong number of arguments');
	    }
	  };
	  
	  var _getsubset = function (matrix, idx) {
	    // check idx
	    if (!type.isIndex(idx)) {
	      throw new TypeError('Invalid index');
	    }
	
	    var isScalar = idx.isScalar();
	    if (isScalar) {
	      // return a scalar
	      return matrix.get(idx.min());
	    }
	    // validate dimensions
	    var size = idx.size();
	    if (size.length != matrix._size.length) {
	      throw new DimensionError(size.length, matrix._size.length);
	    }
	
	    // vars
	    var i, ii, k, kk;
	    
	    // validate if any of the ranges in the index is out of range
	    var min = idx.min();
	    var max = idx.max();
	    for (i = 0, ii = matrix._size.length; i < ii; i++) {
	      validateIndex(min[i], matrix._size[i]);
	      validateIndex(max[i], matrix._size[i]);
	    }
	    
	    // matrix arrays
	    var mvalues = matrix._values;
	    var mindex = matrix._index;
	    var mptr = matrix._ptr;
	        
	    // rows & columns dimensions for result matrix
	    var rows = idx.dimension(0);
	    var columns = idx.dimension(1);
	    
	    // workspace & permutation vector
	    var w = [];
	    var pv = [];
	    
	    // loop rows in resulting matrix
	    rows.forEach(function (i, r) {
	      // update permutation vector
	      pv[i] = r[0];  
	      // mark i in workspace
	      w[i] = true;
	    });
	
	    // result matrix arrays
	    var values = mvalues ? [] : undefined;
	    var index = [];
	    var ptr = [];
	        
	    // loop columns in result matrix
	    columns.forEach(function (j) {
	      // update ptr
	      ptr.push(index.length);
	      // loop values in column j
	      for (k = mptr[j], kk = mptr[j + 1]; k < kk; k++) {
	        // row
	        i = mindex[k];
	        // check row is in result matrix
	        if (w[i] === true) {
	          // push index
	          index.push(pv[i]);
	          // check we need to process values
	          if (values)
	            values.push(mvalues[k]);
	        }
	      }
	    });
	    // update ptr
	    ptr.push(index.length);
	    
	    // return matrix
	    return new SparseMatrix({
	      values: values,
	      index: index,
	      ptr: ptr,
	      size: size,
	      datatype: matrix._datatype
	    });
	  };
	  
	  var _setsubset = function (matrix, index, submatrix, defaultValue) {
	    // check index
	    if (!index || index.isIndex !== true) {
	      throw new TypeError('Invalid index');
	    }
	    
	    // get index size and check whether the index contains a single value
	    var iSize = index.size(),
	        isScalar = index.isScalar();
	    
	    // calculate the size of the submatrix, and convert it into an Array if needed
	    var sSize;
	    if (type.isMatrix(submatrix)) {
	      // submatrix size
	      sSize = submatrix.size();
	      // use array representation
	      submatrix = submatrix.toArray();
	    }
	    else {
	      // get submatrix size (array, scalar)
	      sSize = array.size(submatrix);
	    }
	    
	    // check index is a scalar
	    if (isScalar) {
	      // verify submatrix is a scalar
	      if (sSize.length !== 0) {
	        throw new TypeError('Scalar expected');
	      }
	      // set value
	      matrix.set(index.min(), submatrix, defaultValue);
	    }
	    else {
	      // validate dimensions, index size must be one or two dimensions
	      if (iSize.length !== 1 && iSize.length !== 2) {
	        throw new DimensionError(iSize.length, matrix._size.length, '<');
	      }
	      
	      // check submatrix and index have the same dimensions
	      if (sSize.length < iSize.length) {
	        // calculate number of missing outer dimensions
	        var i = 0;
	        var outer = 0;
	        while (iSize[i] === 1 && sSize[i] === 1) {
	          i++;
	        }
	        while (iSize[i] === 1) {
	          outer++;
	          i++;
	        }
	        // unsqueeze both outer and inner dimensions
	        submatrix = array.unsqueeze(submatrix, iSize.length, outer, sSize);
	      }
	      
	      // check whether the size of the submatrix matches the index size
	      if (!object.deepEqual(iSize, sSize)) {
	        throw new DimensionError(iSize, sSize, '>');
	      }
	      
	      // offsets
	      var x0 = index.min()[0];
	      var y0 = index.min()[1];      
	      
	      // submatrix rows and columns
	      var m = sSize[0];
	      var n = sSize[1];
	
	      // loop submatrix
	      for (var x = 0; x < m; x++) {
	        // loop columns
	        for (var y = 0; y < n; y++) {
	          // value at i, j
	          var v = submatrix[x][y];
	          // invoke set (zero value will remove entry from matrix)
	          matrix.set([x + x0, y + y0], v, defaultValue);
	        }
	      }
	    }
	    return matrix;
	  };
	
	  /**
	   * Get a single element from the matrix.
	   * @memberof SparseMatrix
	   * @param {number[]} index   Zero-based index
	   * @return {*} value
	   */
	  SparseMatrix.prototype.get = function (index) {
	    if (!isArray(index))
	      throw new TypeError('Array expected');
	    if (index.length != this._size.length)
	      throw new DimensionError(index.length, this._size.length);
	
	    // check it is a pattern matrix
	    if (!this._values)
	      throw new Error('Cannot invoke get on a Pattern only matrix');
	
	    // row and column
	    var i = index[0];
	    var j = index[1];
	
	    // check i, j are valid
	    validateIndex(i, this._size[0]);
	    validateIndex(j, this._size[1]);
	
	    // find value index
	    var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
	    // check k is prior to next column k and it is in the correct row
	    if (k < this._ptr[j + 1] && this._index[k] === i)
	      return this._values[k];
	
	    return 0;
	  };
	  
	  /**
	   * Replace a single element in the matrix.
	   * @memberof SparseMatrix
	   * @param {number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be set to zero.
	   * @return {SparseMatrix} self
	   */
	  SparseMatrix.prototype.set = function (index, v, defaultValue) {
	    if (!isArray(index))
	      throw new TypeError('Array expected');
	    if (index.length != this._size.length)
	      throw new DimensionError(index.length, this._size.length);
	
	    // check it is a pattern matrix
	    if (!this._values)
	      throw new Error('Cannot invoke set on a Pattern only matrix');
	      
	    // row and column
	    var i = index[0];
	    var j = index[1];
	
	    // rows & columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    if (isString(this._datatype)) {
	      // find signature that matches (datatype, datatype)
	      eq = typed.find(equalScalar, [this._datatype, this._datatype]) || equalScalar;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, this._datatype);
	    }
	
	    // check we need to resize matrix
	    if (i > rows - 1 || j > columns - 1) {
	      // resize matrix
	      _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue);
	      // update rows & columns
	      rows = this._size[0];
	      columns = this._size[1];
	    }
	
	    // check i, j are valid
	    validateIndex(i, rows);
	    validateIndex(j, columns);
	
	    // find value index
	    var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
	    // check k is prior to next column k and it is in the correct row
	    if (k < this._ptr[j + 1] && this._index[k] === i) {
	      // check value != 0
	      if (!eq(v, zero)) {
	        // update value
	        this._values[k] = v;
	      }
	      else {
	        // remove value from matrix
	        _remove(k, j, this._values, this._index, this._ptr);
	      }
	    }
	    else {
	      // insert value @ (i, j)
	      _insert(k, i, j, v, this._values, this._index, this._ptr);
	    }
	
	    return this;
	  };
	  
	  var _getValueIndex = function(i, top, bottom, index) {
	    // check row is on the bottom side
	    if (bottom - top === 0)
	      return bottom;
	    // loop rows [top, bottom[
	    for (var r = top; r < bottom; r++) {
	      // check we found value index
	      if (index[r] === i)
	        return r;
	    }
	    // we did not find row
	    return top;
	  };
	
	  var _remove = function (k, j, values, index, ptr) {
	    // remove value @ k
	    values.splice(k, 1);
	    index.splice(k, 1);
	    // update pointers
	    for (var x = j + 1; x < ptr.length; x++)
	      ptr[x]--;
	  };
	
	  var _insert = function (k, i, j, v, values, index, ptr) {
	    // insert value
	    values.splice(k, 0, v);
	    // update row for k
	    index.splice(k, 0, i);
	    // update column pointers
	    for (var x = j + 1; x < ptr.length; x++)
	      ptr[x]++;
	  };
	  
	  /**
	   * Resize the matrix to the given size. Returns a copy of the matrix when 
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @memberof SparseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */
	  SparseMatrix.prototype.resize = function (size, defaultValue, copy) {    
	    // validate arguments
	    if (!isArray(size))
	      throw new TypeError('Array expected');
	    if (size.length !== 2)
	      throw new Error('Only two dimensions matrix are supported');
	
	    // check sizes
	    size.forEach(function (value) {
	      if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
	        throw new TypeError('Invalid size, must contain positive integers ' +
	                            '(size: ' + string.format(size) + ')');
	      }
	    });
	    
	    // matrix to resize
	    var m = copy ? this.clone() : this;
	    // resize matrix
	    return _resize(m, size[0], size[1], defaultValue);
	  };
	  
	  var _resize = function (matrix, rows, columns, defaultValue) {
	    // value to insert at the time of growing matrix
	    var value = defaultValue || 0;
	    
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    if (isString(matrix._datatype)) {
	      // find signature that matches (datatype, datatype)
	      eq = typed.find(equalScalar, [matrix._datatype, matrix._datatype]) || equalScalar;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, matrix._datatype);
	      // convert value to the same datatype
	      value = typed.convert(value, matrix._datatype);
	    }
	    
	    // should we insert the value?
	    var ins = !eq(value, zero);
	
	    // old columns and rows
	    var r = matrix._size[0];
	    var c = matrix._size[1];
	
	    var i, j, k;
	
	    // check we need to increase columns
	    if (columns > c) {
	      // loop new columns
	      for (j = c; j < columns; j++) {
	        // update matrix._ptr for current column
	        matrix._ptr[j] = matrix._values.length;
	        // check we need to insert matrix._values
	        if (ins) {
	          // loop rows
	          for (i = 0; i < r; i++) {
	            // add new matrix._values
	            matrix._values.push(value);
	            // update matrix._index
	            matrix._index.push(i);
	          }
	        }        
	      }
	      // store number of matrix._values in matrix._ptr
	      matrix._ptr[columns] = matrix._values.length;
	    }
	    else if (columns < c) {
	      // truncate matrix._ptr
	      matrix._ptr.splice(columns + 1, c - columns);
	      // truncate matrix._values and matrix._index
	      matrix._values.splice(matrix._ptr[columns], matrix._values.length);
	      matrix._index.splice(matrix._ptr[columns], matrix._index.length);
	    }
	    // update columns
	    c = columns;
	
	    // check we need to increase rows
	    if (rows > r) {
	      // check we have to insert values
	      if (ins) {
	        // inserts
	        var n = 0;
	        // loop columns
	        for (j = 0; j < c; j++) {
	          // update matrix._ptr for current column
	          matrix._ptr[j] = matrix._ptr[j] + n;
	          // where to insert matrix._values
	          k = matrix._ptr[j + 1] + n;
	          // pointer
	          var p = 0;
	          // loop new rows, initialize pointer
	          for (i = r; i < rows; i++, p++) {
	            // add value
	            matrix._values.splice(k + p, 0, value);
	            // update matrix._index
	            matrix._index.splice(k + p, 0, i);
	            // increment inserts
	            n++;
	          }
	        }
	        // store number of matrix._values in matrix._ptr
	        matrix._ptr[c] = matrix._values.length;
	      }
	    }
	    else if (rows < r) {
	      // deletes
	      var d = 0;
	      // loop columns
	      for (j = 0; j < c; j++) {
	        // update matrix._ptr for current column
	        matrix._ptr[j] = matrix._ptr[j] - d;
	        // where matrix._values start for next column
	        var k0 = matrix._ptr[j];
	        var k1 = matrix._ptr[j + 1] - d;
	        // loop matrix._index
	        for (k = k0; k < k1; k++) {
	          // row
	          i = matrix._index[k];
	          // check we need to delete value and matrix._index
	          if (i > rows - 1) {
	            // remove value
	            matrix._values.splice(k, 1);
	            // remove item from matrix._index
	            matrix._index.splice(k, 1);
	            // increase deletes
	            d++;
	          }
	        }
	      }
	      // update matrix._ptr for current column
	      matrix._ptr[j] = matrix._values.length;
	    }
	    // update matrix._size
	    matrix._size[0] = rows;
	    matrix._size[1] = columns;
	    // return matrix
	    return matrix;
	  };
	
	  /**
	   * Reshape the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (reshape in place).
	   *
	   * NOTE: This might be better suited to copy by default, instead of modifying
	   *       in place. For now, it operates in place to remain consistent with
	   *       resize().
	   *
	   * @memberof SparseMatrix
	   * @param {number[]} size           The new size the matrix should have.
	   * @param {boolean} [copy]          Return a reshaped copy of the matrix
	   *
	   * @return {Matrix}                 The reshaped matrix
	   */
	  SparseMatrix.prototype.reshape = function (size, copy) {
	
	    // validate arguments
	    if (!isArray(size))
	      throw new TypeError('Array expected');
	    if (size.length !== 2)
	      throw new Error('Sparse matrices can only be reshaped in two dimensions');
	
	    // check sizes
	    size.forEach(function (value) {
	      if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
	        throw new TypeError('Invalid size, must contain positive integers ' +
	                            '(size: ' + string.format(size) + ')');
	      }
	    });
	
	    // m * n must not change
	    if(this._size[0] * this._size[1] !== size[0] * size[1]) {
	      throw new Error('Reshaping sparse matrix will result in the wrong number of elements');
	    }
	
	    // matrix to reshape
	    var m = copy ? this.clone() : this;
	
	    // return unchanged if the same shape
	    if(this._size[0] === size[0] && this._size[1] === size[1]) {
	      return m;
	    }
	
	    // Convert to COO format (generate a column index)
	    var colIndex = [];
	    for(var i=0; i<m._ptr.length; i++) {
	      for(var j=0; j<m._ptr[i+1]-m._ptr[i]; j++) {
	        colIndex.push(i);
	      }
	    }
	
	    // Clone the values array
	    var values = m._values.slice();
	
	    // Clone the row index array
	    var rowIndex = m._index.slice();
	
	    // Transform the (row, column) indices
	    for(var i=0; i<m._index.length; i++) {
	      var r1 = rowIndex[i];
	      var c1 = colIndex[i];
	      var flat = r1 * m._size[1] + c1;
	      colIndex[i] = flat % size[1];
	      rowIndex[i] = Math.floor(flat / size[1]);
	    }
	
	    // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
	    // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
	    // sorting several arrays based on some other array.
	
	    // OR, we could easily just:
	
	    // 1. Remove all values from the matrix
	    m._values.length = 0;
	    m._index.length = 0;
	    m._ptr.length = size[1] + 1;
	    m._size = size.slice();
	    for(var i=0; i<m._ptr.length; i++) {
	      m._ptr[i] = 0;
	    }
	
	    // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
	    // This step is probably the most time-consuming
	    for(var h=0; h<values.length; h++) {
	      var i = rowIndex[h];
	      var j = colIndex[h];
	      var v = values[h];
	      var k = _getValueIndex(i, m._ptr[j], m._ptr[j + 1], m._index);
	      _insert(k, i, j, v, m._values, m._index, m._ptr);
	    }
	
	    // The value indices are inserted out of order, but apparently that's... still OK?
	
	    return m;
	  }
	  
	  /**
	   * Create a clone of the matrix
	   * @memberof SparseMatrix
	   * @return {SparseMatrix} clone
	   */
	  SparseMatrix.prototype.clone = function () {
	    var m = new SparseMatrix({
	      values: this._values ? object.clone(this._values) : undefined,
	      index: object.clone(this._index),
	      ptr: object.clone(this._ptr),
	      size: object.clone(this._size),
	      datatype: this._datatype
	    });
	    return m;
	  };
	  
	  /**
	   * Retrieve the size of the matrix.
	   * @memberof SparseMatrix
	   * @returns {number[]} size
	   */
	  SparseMatrix.prototype.size = function() {
	    return this._size.slice(0); // copy the Array
	  };
	  
	  /**
	   * Create a new matrix with the results of the callback function executed on
	   * each entry of the matrix.
	   * @memberof SparseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   *
	   * @return {SparseMatrix} matrix
	   */
	  SparseMatrix.prototype.map = function (callback, skipZeros) {
	    // check it is a pattern matrix
	    if (!this._values)
	      throw new Error('Cannot invoke map on a Pattern only matrix');
	    // matrix instance
	    var me = this;
	    // rows and columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    // invoke callback
	    var invoke = function (v, i, j) {
	      // invoke callback
	      return callback(v, [i, j], me);
	    };
	    // invoke _map
	    return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
	  };
	
	  /**
	   * Create a new matrix with the results of the callback function executed on the interval
	   * [minRow..maxRow, minColumn..maxColumn].
	   */
	  var _map = function (matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
	    // result arrays
	    var values = [];
	    var index = [];
	    var ptr = [];
	    
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    if (isString(matrix._datatype)) {
	      // find signature that matches (datatype, datatype)
	      eq = typed.find(equalScalar, [matrix._datatype, matrix._datatype]) || equalScalar;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, matrix._datatype);
	    }
	    
	    // invoke callback
	    var invoke = function (v, x, y) {
	      // invoke callback
	      v = callback(v, x, y);
	      // check value != 0
	      if (!eq(v, zero)) {
	        // store value
	        values.push(v);
	        // index
	        index.push(x);
	      }
	    };
	    // loop columns
	    for (var j = minColumn; j <= maxColumn; j++) {
	      // store pointer to values index
	      ptr.push(values.length);
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = matrix._ptr[j];
	      var k1 = matrix._ptr[j + 1];
	      // row pointer
	      var p = minRow;
	      // loop k within [k0, k1[
	      for (var k = k0; k < k1; k++) {
	        // row index
	        var i = matrix._index[k];
	        // check i is in range
	        if (i >= minRow && i <= maxRow) {
	          // zero values
	          if (!skipZeros) {
	           for (var x = p; x < i; x++)
	             invoke(0, x - minRow, j - minColumn);
	          }
	          // value @ k
	          invoke(matrix._values[k], i - minRow, j - minColumn);
	        }
	        // update pointer
	        p = i + 1;
	      }
	      // zero values
	      if (!skipZeros) {
	        for (var y = p; y <= maxRow; y++)
	          invoke(0, y - minRow, j - minColumn);
	      }
	    }
	    // store number of values in ptr
	    ptr.push(values.length);
	    // return sparse matrix
	    return new SparseMatrix({
	      values: values,
	      index: index,
	      ptr: ptr,
	      size: [maxRow - minRow + 1, maxColumn - minColumn + 1]
	    });
	  };
	  
	  /**
	   * Execute a callback function on each entry of the matrix.
	   * @memberof SparseMatrix
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
	   */
	  SparseMatrix.prototype.forEach = function (callback, skipZeros) {
	    // check it is a pattern matrix
	    if (!this._values)
	      throw new Error('Cannot invoke forEach on a Pattern only matrix');
	    // matrix instance
	    var me = this;
	    // rows and columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = this._ptr[j];
	      var k1 = this._ptr[j + 1];
	      // column pointer
	      var p = 0;
	      // loop k within [k0, k1[
	      for (var k = k0; k < k1; k++) {
	        // row index
	        var i = this._index[k];
	        // check we need to process zeros
	        if (!skipZeros) {
	          // zero values
	          for (var x = p; x < i; x++)
	            callback(0, [x, j], me);
	        }
	        // value @ k
	        callback(this._values[k], [i, j], me);
	        // update pointer
	        p = i + 1;
	      }
	      // check we need to process zeros
	      if (!skipZeros) {
	        // zero values
	        for (var y = p; y < rows; y++)
	          callback(0, [y, j], me);
	      }
	    }
	  };
	  
	  /**
	   * Create an Array with a copy of the data of the SparseMatrix
	   * @memberof SparseMatrix
	   * @returns {Array} array
	   */
	  SparseMatrix.prototype.toArray = function () {
	    return _toArray(this._values, this._index, this._ptr, this._size, true);
	  };
	
	  /**
	   * Get the primitive value of the SparseMatrix: a two dimensions array
	   * @memberof SparseMatrix
	   * @returns {Array} array
	   */
	  SparseMatrix.prototype.valueOf = function () {
	    return _toArray(this._values, this._index, this._ptr, this._size, false);
	  };
	  
	  var _toArray = function (values, index, ptr, size, copy) {    
	    // rows and columns
	    var rows = size[0];
	    var columns = size[1];
	    // result
	    var a = [];
	    // vars
	    var i, j;
	    // initialize array
	    for (i = 0; i < rows; i++) {
	      a[i] = [];
	      for (j = 0; j < columns; j++)
	        a[i][j] = 0;
	    }
	
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = ptr[j];
	      var k1 = ptr[j + 1];
	      // loop k within [k0, k1[
	      for (var k = k0; k < k1; k++) {
	        // row index
	        i = index[k];
	        // set value (use one for pattern matrix)
	        a[i][j] = values ? (copy ? object.clone(values[k]) : values[k]) : 1;
	      }
	    }
	    return a;
	  };
	  
	  /**
	   * Get a string representation of the matrix, with optional formatting options.
	   * @memberof SparseMatrix
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */
	  SparseMatrix.prototype.format = function (options) {
	    // rows and columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    // density
	    var density = this.density();
	    // rows & columns
	    var str = 'Sparse Matrix [' + string.format(rows, options) + ' x ' + string.format(columns, options) + '] density: ' + string.format(density, options) + '\n';
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = this._ptr[j];
	      var k1 = this._ptr[j + 1];
	      // loop k within [k0, k1[
	      for (var k = k0; k < k1; k++) {
	        // row index
	        var i = this._index[k];
	        // append value
	        str += '\n    (' + string.format(i, options) + ', ' + string.format(j, options) + ') ==> ' + (this._values ? string.format(this._values[k], options) : 'X');
	      }
	    }
	    return str;
	  };
	  
	  /**
	   * Get a string representation of the matrix
	   * @memberof SparseMatrix
	   * @returns {string} str
	   */
	  SparseMatrix.prototype.toString = function () {
	    return string.format(this.toArray());
	  };
	  
	  /**
	   * Get a JSON representation of the matrix
	   * @memberof SparseMatrix
	   * @returns {Object}
	   */
	  SparseMatrix.prototype.toJSON = function () {
	    return {
	      mathjs: 'SparseMatrix',
	      values: this._values,
	      index: this._index,
	      ptr: this._ptr,
	      size: this._size,
	      datatype: this._datatype
	    };
	  };
	
	  /**
	   * Get the kth Matrix diagonal.
	   *
	   * @memberof SparseMatrix
	   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
	   *
	   * @returns {Matrix}                     The matrix vector with the diagonal values.
	   */
	  SparseMatrix.prototype.diagonal = function(k) {
	    // validate k if any
	    if (k) {
	      // convert BigNumber to a number
	      if (type.isBigNumber(k))
	        k = k.toNumber();
	      // is must be an integer
	      if (!isNumber(k) || !isInteger(k)) {
	        throw new TypeError ('The parameter k must be an integer number');
	      }
	    }
	    else {
	      // default value
	      k = 0;
	    }
	
	    var kSuper = k > 0 ? k : 0;
	    var kSub = k < 0 ? -k : 0;
	    
	    // rows & columns
	    var rows = this._size[0];
	    var columns = this._size[1];
	    
	    // number diagonal values
	    var n = Math.min(rows - kSub, columns -  kSuper);
	    
	    // diagonal arrays
	    var values = [];
	    var index = [];
	    var ptr = [];
	    // initial ptr value
	    ptr[0] = 0;
	    // loop columns
	    for (var j = kSuper; j < columns && values.length < n; j++) {
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = this._ptr[j];
	      var k1 = this._ptr[j + 1];
	      // loop x within [k0, k1[
	      for (var x = k0; x < k1; x++) {
	        // row index
	        var i = this._index[x];
	        // check row
	        if (i === j - kSuper + kSub) {
	          // value on this column
	          values.push(this._values[x]);
	          // store row
	          index[values.length - 1] = i - kSub;
	          // exit loop
	          break;
	        }
	      }
	    }
	    // close ptr
	    ptr.push(values.length);
	    // return matrix
	    return new SparseMatrix({
	      values: values,
	      index: index,
	      ptr: ptr,
	      size: [n, 1]
	    });
	  };
	  
	  /**
	   * Generate a matrix from a JSON object
	   * @memberof SparseMatrix
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
	   *                       where mathjs is optional
	   * @returns {SparseMatrix}
	   */
	  SparseMatrix.fromJSON = function (json) {
	    return new SparseMatrix(json);
	  };
	
	  /**
	   * Create a diagonal matrix.
	   *
	   * @memberof SparseMatrix
	   * @param {Array} size                       The matrix size.
	   * @param {number | Array | Matrix } value   The values for the diagonal.
	   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
	   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
	   *
	   * @returns {SparseMatrix}
	   */
	  SparseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
	    if (!isArray(size))
	      throw new TypeError('Array expected, size parameter');
	    if (size.length !== 2)
	      throw new Error('Only two dimensions matrix are supported');
	    
	    // map size & validate
	    size = size.map(function (s) {
	      // check it is a big number
	      if (type.isBigNumber(s)) {
	        // convert it
	        s = s.toNumber();
	      }
	      // validate arguments
	      if (!isNumber(s) || !isInteger(s) || s < 1) {
	        throw new Error('Size values must be positive integers');
	      } 
	      return s;
	    });
	    
	    // validate k if any
	    if (k) {
	      // convert BigNumber to a number
	      if (type.isBigNumber(k))
	        k = k.toNumber();
	      // is must be an integer
	      if (!isNumber(k) || !isInteger(k)) {
	        throw new TypeError ('The parameter k must be an integer number');
	      }
	    }
	    else {
	      // default value
	      k = 0;
	    }
	
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    if (isString(datatype)) {
	      // find signature that matches (datatype, datatype)
	      eq = typed.find(equalScalar, [datatype, datatype]) || equalScalar;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, datatype);
	    }
	    
	    var kSuper = k > 0 ? k : 0;
	    var kSub = k < 0 ? -k : 0;
	    
	    // rows and columns
	    var rows = size[0];
	    var columns = size[1];
	    
	    // number of non-zero items
	    var n = Math.min(rows - kSub, columns -  kSuper);
	    
	    // value extraction function
	    var _value;
	      
	    // check value
	    if (isArray(value)) {
	      // validate array
	      if (value.length !== n) {
	        // number of values in array must be n
	        throw new Error('Invalid value array length');
	      }
	      // define function
	      _value = function (i) {
	        // return value @ i
	        return value[i];
	      };
	    }
	    else if (type.isMatrix(value)) {
	      // matrix size
	      var ms = value.size();
	      // validate matrix
	      if (ms.length !== 1 || ms[0] !== n) {
	        // number of values in array must be n
	        throw new Error('Invalid matrix length');
	      }
	      // define function
	      _value = function (i) {
	        // return value @ i
	        return value.get([i]);
	      };
	    }
	    else {
	      // define function
	      _value = function () {
	        // return value
	        return value;
	      };
	    }
	    
	    // create arrays
	    var values = [];
	    var index = [];
	    var ptr = [];
	    
	    // loop items
	    for (var j = 0; j < columns; j++) {
	      // number of rows with value
	      ptr.push(values.length);
	      // diagonal index
	      var i = j - kSuper;      
	      // check we need to set diagonal value
	      if (i >= 0 && i < n) {
	        // get value @ i
	        var v = _value(i);
	        // check for zero
	        if (!eq(v, zero)) {
	          // column
	          index.push(i + kSub);
	          // add value
	          values.push(v);
	        }
	      }
	    }
	    // last value should be number of values
	    ptr.push(values.length);
	    // create SparseMatrix
	    return new SparseMatrix({
	      values: values,
	      index: index,
	      ptr: ptr,
	      size: [rows, columns]
	    });
	  };
	  
	  /**
	   * Swap rows i and j in Matrix.
	   *
	   * @memberof SparseMatrix
	   * @param {number} i       Matrix row index 1
	   * @param {number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */
	  SparseMatrix.prototype.swapRows = function (i, j) {
	    // check index
	    if (!isNumber(i) || !isInteger(i) || !isNumber(j) || !isInteger(j)) {
	      throw new Error('Row index must be positive integers');
	    }
	    // check dimensions
	    if (this._size.length !== 2) {
	      throw new Error('Only two dimensional matrix is supported');
	    }
	    // validate index
	    validateIndex(i, this._size[0]);
	    validateIndex(j, this._size[0]);
	    
	    // swap rows
	    SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr);
	    // return current instance
	    return this;
	  };
	  
	  /**
	   * Loop rows with data in column j.
	   *
	   * @param {number} j            Column
	   * @param {Array} values        Matrix values
	   * @param {Array} index         Matrix row indeces
	   * @param {Array} ptr           Matrix column pointers
	   * @param {Function} callback   Callback function invoked for every row in column j
	   */
	  SparseMatrix._forEachRow = function (j, values, index, ptr, callback) {
	    // indeces for column j
	    var k0 = ptr[j];
	    var k1 = ptr[j + 1];
	    // loop
	    for (var k = k0; k < k1; k++) {
	      // invoke callback
	      callback(index[k], values[k]);
	    }
	  };
	  
	  /**
	   * Swap rows x and y in Sparse Matrix data structures.
	   *
	   * @param {number} x         Matrix row index 1
	   * @param {number} y         Matrix row index 2
	   * @param {number} columns   Number of columns in matrix
	   * @param {Array} values     Matrix values
	   * @param {Array} index      Matrix row indeces
	   * @param {Array} ptr        Matrix column pointers
	   */
	  SparseMatrix._swapRows = function (x, y, columns, values, index, ptr) {
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = ptr[j];
	      var k1 = ptr[j + 1];
	      // find value index @ x
	      var kx = _getValueIndex(x, k0, k1, index);
	      // find value index @ x
	      var ky = _getValueIndex(y, k0, k1, index);
	      // check both rows exist in matrix
	      if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
	        // swap values (check for pattern matrix)
	        if (values) {
	          var v = values[kx];
	          values[kx] = values[ky];
	          values[ky] = v;
	        }
	        // next column
	        continue;
	      }
	      // check x row exist & no y row
	      if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
	        // value @ x (check for pattern matrix)
	        var vx = values ? values[kx] : undefined;
	        // insert value @ y
	        index.splice(ky, 0, y);
	        if (values)
	          values.splice(ky, 0, vx);        
	        // remove value @ x (adjust array index if needed)
	        index.splice(ky <= kx ? kx + 1 : kx, 1);
	        if (values)
	          values.splice(ky <= kx ? kx + 1 : kx, 1);
	        // next column
	        continue;
	      }
	      // check y row exist & no x row
	      if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
	        // value @ y (check for pattern matrix)
	        var vy = values ? values[ky] : undefined;
	        // insert value @ x
	        index.splice(kx, 0, x);
	        if (values)
	          values.splice(kx, 0, vy);
	        // remove value @ y (adjust array index if needed)
	        index.splice(kx <= ky ? ky + 1 : ky, 1);
	        if (values)
	          values.splice(kx <= ky ? ky + 1 : ky, 1);
	      }
	    }
	  };
	
	  // register this type in the base class Matrix
	  type.Matrix._storage.sparse = SparseMatrix;
	
	  return SparseMatrix;
	}
	
	exports.name = 'SparseMatrix';
	exports.path = 'type';
	exports.factory = factory;
	exports.lazy = false;  // no lazy loading, as we alter type.Matrix._storage


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	  
	  /**
	   * Test whether two values are equal.
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
	   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
	   * @private
	   */
	  var equalScalar = typed('equalScalar', {
	
	    'boolean, boolean': function (x, y) {
	      return x === y;
	    },
	
	    'number, number': function (x, y) {
	      return x === y || nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.eq(y) || bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.equals(y);
	    },
	
	    'Complex, Complex': function (x, y) {
	      return x.equals(y);
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return equalScalar(x.value, y.value);
	    }
	  });
	  
	  return equalScalar;
	}
	
	exports.factory = factory;


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Compares two BigNumbers.
	 * @param {BigNumber} x       First value to compare
	 * @param {BigNumber} y       Second value to compare
	 * @param {number} [epsilon]  The maximum relative difference between x and y
	 *                            If epsilon is undefined or null, the function will
	 *                            test whether x and y are exactly equal.
	 * @return {boolean} whether the two numbers are nearly equal
	 */
	module.exports = function nearlyEqual(x, y, epsilon) {
	  // if epsilon is null or undefined, test whether x and y are exactly equal
	  if (epsilon == null) {
	    return x.eq(y);
	  }
	
	
	  // use "==" operator, handles infinities
	  if (x.eq(y)) {
	    return true;
	  }
	
	  // NaN
	  if (x.isNaN() || y.isNaN()) {
	    return false;
	  }
	
	  // at this point x and y should be finite
	  if(x.isFinite() && y.isFinite()) {
	    // check numbers are very close, needed when comparing numbers near zero
	    var diff = x.minus(y).abs();
	    if (diff.isZero()) {
	      return true;
	    }
	    else {
	      // use relative error
	      var max = x.constructor.max(x.abs(), y.abs());
	      return diff.lte(max.times(epsilon));
	    }
	  }
	
	  // Infinite and Number or negative Infinite and positive Infinite cases
	  return false;
	};


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	  
	  var add = load(__webpack_require__(1367));
	  var equalScalar = load(__webpack_require__(1364));
	  
	  /**
	   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array 
	   * of the vector elements and an ordered list of non-zero elements.
	   */
	  function Spa() {
	    if (!(this instanceof Spa))
	      throw new SyntaxError('Constructor must be called with the new operator');
	    
	    // allocate vector, TODO use typed arrays
	    this._values = [];
	    this._heap = new type.FibonacciHeap();
	  }
	
	  /**
	   * Attach type information
	   */
	  Spa.prototype.type = 'Spa';
	  Spa.prototype.isSpa = true;
	
	  /**
	   * Set the value for index i.
	   *
	   * @param {number} i                       The index
	   * @param {number | BigNumber | Complex}   The value at index i
	   */
	  Spa.prototype.set = function (i, v) {
	    // check we have a value @ i
	    if (!this._values[i]) {
	      // insert in heap
	      var node = this._heap.insert(i, v);
	      // set the value @ i
	      this._values[i] = node;
	    }
	    else {
	      // update the value @ i
	      this._values[i].value = v;
	    }
	  };
	  
	  Spa.prototype.get = function (i) {
	    var node = this._values[i];
	    if (node)
	      return node.value;
	    return 0;
	  };
	  
	  Spa.prototype.accumulate = function (i, v) {
	    // node @ i
	    var node = this._values[i];
	    if (!node) {
	      // insert in heap
	      node = this._heap.insert(i, v);
	      // initialize value
	      this._values[i] = node;
	    }
	    else {
	      // accumulate value
	      node.value = add(node.value, v);
	    }
	  };
	  
	  Spa.prototype.forEach = function (from, to, callback) {
	    // references
	    var heap = this._heap;
	    var values = this._values;
	    // nodes
	    var nodes = [];
	    // node with minimum key, save it
	    var node = heap.extractMinimum();
	    if (node)
	      nodes.push(node);
	    // extract nodes from heap (ordered)
	    while (node && node.key <= to) {
	      // check it is in range
	      if (node.key >= from) {
	        // check value is not zero
	        if (!equalScalar(node.value, 0)) {
	          // invoke callback
	          callback(node.key, node.value, this);
	        }
	      }
	      // extract next node, save it
	      node = heap.extractMinimum();
	      if (node)
	        nodes.push(node);
	    }
	    // reinsert all nodes in heap
	    for (var i = 0; i < nodes.length; i++) {
	      // current node
	      var n = nodes[i];
	      // insert node in heap
	      node = heap.insert(n.key, n.value);
	      // update values
	      values[node.key] = node;
	    }
	  };
	  
	  Spa.prototype.swap = function (i, j) {
	    // node @ i and j
	    var nodei = this._values[i];
	    var nodej = this._values[j];
	    // check we need to insert indeces
	    if (!nodei && nodej) {
	      // insert in heap
	      nodei = this._heap.insert(i, nodej.value);
	      // remove from heap
	      this._heap.remove(nodej);
	      // set values
	      this._values[i] = nodei;
	      this._values[j] = undefined;
	    }
	    else if (nodei && !nodej) {
	      // insert in heap
	      nodej = this._heap.insert(j, nodei.value);
	      // remove from heap
	      this._heap.remove(nodei);
	      // set values
	      this._values[j] = nodej;
	      this._values[i] = undefined;
	    }
	    else if (nodei && nodej) {
	      // swap values
	      var v = nodei.value;
	      nodei.value = nodej.value;
	      nodej.value = v;
	    }
	  };
	  
	  return Spa;
	}
	
	exports.name = 'Spa';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(1320).extend;
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var addScalar = load(__webpack_require__(1369));
	  var latex = __webpack_require__(1348);
	  
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm04 = load(__webpack_require__(1371));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Add two or more values, `x + y`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.add(x, y)
	   *    math.add(x, y, z, ...)
	   *
	   * Examples:
	   *
	   *    math.add(2, 3);               // returns number 5
	   *    math.add(2, 3, 4);            // returns number 9
	   *
	   *    var a = math.complex(2, 3);
	   *    var b = math.complex(-4, 1);
	   *    math.add(a, b);               // returns Complex -2 + 4i
	   *
	   *    math.add([1, 2, 3], 4);       // returns Array [5, 6, 7]
	   *
	   *    var c = math.unit('5 cm');
	   *    var d = math.unit('2.1 mm');
	   *    math.add(c, d);               // returns Unit 52.1 mm
	   *
	   *    math.add("2.3", "4");         // returns number 6.3
	   *
	   * See also:
	   *
	   *    subtract, sum
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
	   */
	  var add = typed('add', extend({
	    // we extend the signatures of addScalar with signatures dealing with matrices
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      return algorithm13(x, y, addScalar);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      return algorithm01(x, y, addScalar, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      return algorithm01(y, x, addScalar, true);
	    },
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      return algorithm04(x, y, addScalar);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return add(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return add(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return add(x, matrix(y));
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, addScalar, false);
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm10(x, y, addScalar, false);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, addScalar, true);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm10(y, x, addScalar, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, addScalar, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, addScalar, true).valueOf();
	    },
	
	    'any, any': addScalar,
	
	    'any, any, ...any': function (x, y, rest) {
	      var result = add(x, y);
	
	      for (var i = 0; i < rest.length; i++) {
	        result = add(result, rest[i]);
	      }
	
	      return result;
	    }
	  }, addScalar.signatures));
	
	  add.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['add'] + '${args[1]}\\right)'
	  };
	  
	  return add;
	}
	
	exports.name = 'add';
	exports.factory = factory;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a Matrix. The function creates a new `math.type.Matrix` object from
	   * an `Array`. A Matrix has utility functions to manipulate the data in the
	   * matrix, like getting the size and getting or setting values in the matrix.
	   * Supported storage formats are 'dense' and 'sparse'.
	   *
	   * Syntax:
	   *
	   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
	   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
	   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
	   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
	   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
	   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
	   *
	   * Examples:
	   *
	   *    var m = math.matrix([[1, 2], [3, 4]]);
	   *    m.size();                        // Array [2, 2]
	   *    m.resize([3, 2], 5);
	   *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
	   *    m.get([1, 0])                    // number 3
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, number, string, unit, sparse
	   *
	   * @param {Array | Matrix} [data]    A multi dimensional array
	   * @param {string} [format]          The Matrix storage format
	   *
	   * @return {Matrix} The created matrix
	   */
	  var matrix = typed('matrix', {
	    '': function () {
	      return _create([]);
	    },
	
	    'string': function (format) {
	      return _create([], format);
	    },
	    
	    'string, string': function (format, datatype) {
	      return _create([], format, datatype);
	    },
	
	    'Array': function (data) {
	      return _create(data);
	    },
	      
	    'Matrix': function (data) {
	      return _create(data, data.storage());
	    },
	    
	    'Array | Matrix, string': _create,
	    
	    'Array | Matrix, string, string': _create
	  });
	
	  matrix.toTex = {
	    0: '\\begin{bmatrix}\\end{bmatrix}',
	    1: '\\left(${args[0]}\\right)',
	    2: '\\left(${args[0]}\\right)'
	  };
	
	  return matrix;
	
	  /**
	   * Create a new Matrix with given storage format
	   * @param {Array} data
	   * @param {string} [format]
	   * @param {string} [datatype]
	   * @returns {Matrix} Returns a new Matrix
	   * @private
	   */
	  function _create(data, format, datatype) {
	    // get storage format constructor
	    var M = type.Matrix.storage(format || 'default');
	
	    // create instance
	    return new M(data, datatype);
	  }
	}
	
	exports.name = 'matrix';
	exports.factory = factory;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory(type, config, load, typed) {
	
	  /**
	   * Add two scalar values, `x + y`.
	   * This function is meant for internal use: it is used by the public function
	   * `add`
	   *
	   * This function does not support collections (Array or Matrix), and does
	   * not validate the number of of inputs.
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
	   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
	   * @return {number | BigNumber | Fraction | Complex | Unit}                      Sum of `x` and `y`
	   * @private
	   */
	  var add = typed('add', {
	
	    'number, number': function (x, y) {
	      return x + y;
	    },
	
	    'Complex, Complex': function (x, y) {
	      return x.add(y);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.plus(y);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.add(y);
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (x.value == null) throw new Error('Parameter x contains a unit with undefined value');
	      if (y.value == null) throw new Error('Parameter y contains a unit with undefined value');
	      if (!x.equalBase(y)) throw new Error('Units do not match');
	
	      var res = x.clone();
	      res.value = add(res.value, y.value);
	      res.fixPrefix = false;
	      return res;
	    }
	  });
	
	  return add;
	}
	
	exports.factory = factory;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij). 
	   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
	   *
	   *
	   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  Dij          ; otherwise
	   *
	   *
	   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
	   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
	   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
	   */
	  var algorithm01 = function (denseMatrix, sparseMatrix, callback, inverse) {
	    // dense matrix arrays
	    var adata = denseMatrix._data;
	    var asize = denseMatrix._size;
	    var adt = denseMatrix._datatype;
	    // sparse matrix arrays
	    var bvalues = sparseMatrix._values;
	    var bindex = sparseMatrix._index;
	    var bptr = sparseMatrix._ptr;
	    var bsize = sparseMatrix._size;
	    var bdt = sparseMatrix._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!bvalues)
	      throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // process data types
	    var dt = typeof adt === 'string' && adt === bdt ? adt : undefined;
	    // callback function
	    var cf = dt ? typed.find(callback, [dt, dt]) : callback;
	
	    // vars
	    var i, j;
	    
	    // result (DenseMatrix)
	    var cdata = [];
	    // initialize c
	    for (i = 0; i < rows; i++)
	      cdata[i] = [];      
	    
	    // workspace
	    var x = [];
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // loop columns in b
	    for (j = 0; j < columns; j++) {
	      // column mark
	      var mark = j + 1;
	      // values in column j
	      for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = bindex[k];
	        // update workspace
	        x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
	        // mark i as updated
	        w[i] = mark;
	      }
	      // loop rows
	      for (i = 0; i < rows; i++) {
	        // check row is in workspace
	        if (w[i] === mark) {
	          // c[i][j] was already calculated
	          cdata[i][j] = x[i];
	        }
	        else {
	          // item does not exist in S
	          cdata[i][j] = adata[i][j];
	        }
	      }
	    }
	
	    // return dense matrix
	    return new DenseMatrix({
	      data: cdata,
	      size: [rows, columns],
	      datatype: dt
	    });
	  };
	  
	  return algorithm01;
	}
	
	exports.name = 'algorithm01';
	exports.factory = factory;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked MAX(NNZA, NNZB) times
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
	   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
	   *          └  B(i,j)       ; B(i,j) !== 0
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm04 = function (a, b, callback) {
	    // sparse matrix arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = avalues && bvalues ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspace
	    var xa = avalues && bvalues ? [] : undefined;
	    var xb = avalues && bvalues ? [] : undefined;
	    // marks indicating we have a value in x for a given column
	    var wa = [];
	    var wb = [];
	
	    // vars 
	    var i, j, k, k0, k1;
	    
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // columns mark
	      var mark = j + 1;
	      // loop A(:,j)
	      for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = aindex[k];
	        // update c
	        cindex.push(i);
	        // update workspace
	        wa[i] = mark;
	        // check we need to process values
	        if (xa)
	          xa[i] = avalues[k];
	      }
	      // loop B(:,j)
	      for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = bindex[k];
	        // check row exists in A
	        if (wa[i] === mark) {
	          // update record in xa @ i
	          if (xa) {
	            // invoke callback
	            var v = cf(xa[i], bvalues[k]);
	            // check for zero
	            if (!eq(v, zero)) {
	              // update workspace
	              xa[i] = v;              
	            }
	            else {
	              // remove mark (index will be removed later)
	              wa[i] = null;
	            }
	          }
	        }
	        else {
	          // update c
	          cindex.push(i);
	          // update workspace
	          wb[i] = mark;
	          // check we need to process values
	          if (xb)
	            xb[i] = bvalues[k];
	        }
	      }
	      // check we need to process values (non pattern matrix)
	      if (xa && xb) {
	        // initialize first index in j
	        k = cptr[j];
	        // loop index in j
	        while (k < cindex.length) {
	          // row
	          i = cindex[k];
	          // check workspace has value @ i
	          if (wa[i] === mark) {
	            // push value (Aij != 0 || (Aij != 0 && Bij != 0))
	            cvalues[k] = xa[i];
	            // increment pointer
	            k++;
	          }
	          else if (wb[i] === mark) {
	            // push value (bij != 0)
	            cvalues[k] = xb[i];
	            // increment pointer
	            k++;
	          }
	          else {
	            // remove index @ k
	            cindex.splice(k, 1);
	          }
	        }
	      }
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	  
	  return algorithm04;
	}
	
	exports.name = 'algorithm04';
	exports.factory = factory;


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
	   * Callback function invoked NZ times (number of nonzero items in S).
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  b          ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */
	  var algorithm10 = function (s, b, callback, inverse) {
	    // sparse matrix arrays
	    var avalues = s._values;
	    var aindex = s._index;
	    var aptr = s._ptr;
	    var asize = s._size;
	    var adt = s._datatype;
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!avalues)
	      throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // convert b to the same datatype
	      b = typed.convert(b, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cdata = [];
	    // matrix
	    var c = new DenseMatrix({
	      data: cdata,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var x = [];
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // columns mark
	      var mark = j + 1;
	      // values in j
	      for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        var r = aindex[k];
	        // update workspace
	        x[r] = avalues[k];
	        w[r] = mark;
	      }
	      // loop rows
	      for (var i = 0; i < rows; i++) {
	        // initialize C on first column
	        if (j === 0) {
	          // create row array
	          cdata[i] = [];
	        }
	        // check sparse matrix has a value @ i,j
	        if (w[i] === mark) {
	          // invoke callback, update C
	          cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
	        }
	        else {
	          // dense matrix value @ i, j
	          cdata[i][j] = b;
	        }
	      }
	    }
	
	    // return sparse matrix
	    return c;
	  };
	
	  return algorithm10;
	}
	
	exports.name = 'algorithm10';
	exports.factory = factory;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	var DimensionError = __webpack_require__(1358);
	
	var string = util.string,
	    isString = string.isString;
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z). 
	   * Callback function invoked MxN times.
	   *
	   * C(i,j,...z) = f(Aij..z, Bij..z)
	   *
	   * @param {Matrix}   a                 The DenseMatrix instance (A)
	   * @param {Matrix}   b                 The DenseMatrix instance (B)
	   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
	   */
	  var algorithm13 = function (a, b, callback) {
	    // a arrays
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    // b arrays
	    var bdata = b._data;
	    var bsize = b._size;
	    var bdt = b._datatype;
	    // c arrays
	    var csize = [];
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // validate each one of the dimension sizes
	    for (var s = 0; s < asize.length; s++) {
	      // must match
	      if (asize[s] !== bsize[s])
	        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	      // update dimension in c
	      csize[s] = asize[s];
	    }
	
	    // datatype
	    var dt;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // convert b to the same datatype
	      b = typed.convert(b, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // populate cdata, iterate through dimensions
	    var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : [];
	    
	    // c matrix
	    return new DenseMatrix({
	      data: cdata,
	      size: csize,
	      datatype: dt
	    });
	  };
	  
	  // recursive function
	  var _iterate = function (f, level, s, n, av, bv) {
	    // initialize array for this level
	    var cv = [];
	    // check we reach the last level
	    if (level === s.length - 1) {
	      // loop arrays in last level
	      for (var i = 0; i < n; i++) {
	        // invoke callback and store value
	        cv[i] = f(av[i], bv[i]);
	      }
	    }
	    else {
	      // iterate current level
	      for (var j = 0; j < n; j++) {
	        // iterate next level
	        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
	      }
	    }
	    return cv;
	  };
	  
	  return algorithm13;
	}
	
	exports.name = 'algorithm13';
	exports.factory = factory;


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b). 
	   * Callback function invoked MxN times.
	   *
	   * C(i,j,...z) = f(Aij..z, b)
	   *
	   * @param {Matrix}   a                 The DenseMatrix instance (A)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij..z,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
	   */
	  var algorithm14 = function (a, b, callback, inverse) {
	    // a arrays
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    
	    // datatype
	    var dt;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // convert b to the same datatype
	      b = typed.convert(b, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	    
	    // populate cdata, iterate through dimensions
	    var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : [];
	
	    // c matrix
	    return new DenseMatrix({
	      data: cdata,
	      size: clone(asize),
	      datatype: dt
	    });
	  };
	  
	  // recursive function
	  var _iterate = function (f, level, s, n, av, bv, inverse) {
	    // initialize array for this level
	    var cv = [];
	    // check we reach the last level
	    if (level === s.length - 1) {
	      // loop arrays in last level
	      for (var i = 0; i < n; i++) {
	        // invoke callback and store value
	        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
	      }
	    }
	    else {
	      // iterate current level
	      for (var j = 0; j < n; j++) {
	        // iterate next level
	        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
	      }
	    }
	    return cv;
	  };
	
	  return algorithm14;
	}
	
	exports.name = 'algorithm14';
	exports.factory = factory;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  
	  var smaller = load(__webpack_require__(1376));
	  var larger = load(__webpack_require__(1380));
	  
	  var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
	  
	  /**
	   * Fibonacci Heap implementation, used interally for Matrix math.
	   * @class FibonacciHeap
	   * @constructor FibonacciHeap
	   */
	  function FibonacciHeap() {
	    if (!(this instanceof FibonacciHeap))
	      throw new SyntaxError('Constructor must be called with the new operator');
	
	    // initialize fields
	    this._minimum = null;
	    this._size = 0;
	  }
	
	  /**
	   * Attach type information
	   */
	  FibonacciHeap.prototype.type = 'FibonacciHeap';
	  FibonacciHeap.prototype.isFibonacciHeap = true;
	
	  /**
	   * Inserts a new data element into the heap. No heap consolidation is
	   * performed at this time, the new node is simply inserted into the root
	   * list of this heap. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.insert = function (key, value) {
	    // create node
	    var node = {
	      key: key,
	      value: value,
	      degree: 0
	    };
	    // check we have a node in the minimum
	    if (this._minimum) {
	      // minimum node
	      var minimum = this._minimum;
	      // update left & right of node
	      node.left = minimum;
	      node.right = minimum.right;
	      minimum.right = node;
	      node.right.left = node;
	      // update minimum node in heap if needed
	      if (smaller(key, minimum.key)) {
	        // node has a smaller key, use it as minimum
	        this._minimum = node;
	      }
	    }
	    else {
	      // set left & right
	      node.left = node;
	      node.right = node;
	      // this is the first node
	      this._minimum = node;
	    }
	    // increment number of nodes in heap
	    this._size++;
	    // return node
	    return node;
	  };
	
	  /**
	   * Returns the number of nodes in heap. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.size = function () {
	    return this._size;
	  };
	
	  /**
	   * Removes all elements from this heap.
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.clear = function () {
	    this._minimum = null;
	    this._size = 0;
	  };
	
	  /**
	   * Returns true if the heap is empty, otherwise false.
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.isEmpty = function () {
	    return this._size === 0;
	  };
	  
	  /**
	   * Extracts the node with minimum key from heap. Amortized running 
	   * time: O(log n).
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.extractMinimum = function () {
	    // node to remove
	    var node = this._minimum;
	    // check we have a minimum
	    if (node === null)
	      return node;
	    // current minimum
	    var minimum = this._minimum;
	    // get number of children
	    var numberOfChildren = node.degree;
	    // pointer to the first child
	    var x = node.child;
	    // for each child of node do...
	    while (numberOfChildren > 0) {
	      // store node in right side
	      var tempRight = x.right;
	      // remove x from child list
	      x.left.right = x.right;
	      x.right.left = x.left;
	      // add x to root list of heap
	      x.left = minimum;
	      x.right = minimum.right;
	      minimum.right = x;
	      x.right.left = x;
	      // set Parent[x] to null
	      x.parent = null;
	      x = tempRight;
	      numberOfChildren--;
	    }
	    // remove node from root list of heap
	    node.left.right = node.right;
	    node.right.left = node.left;
	    // update minimum
	    if (node == node.right) {
	      // empty
	      minimum = null;
	    }
	    else {
	      // update minimum
	      minimum = node.right;
	      // we need to update the pointer to the root with minimum key
	      minimum = _findMinimumNode(minimum, this._size);
	    }
	    // decrement size of heap
	    this._size--;
	    // update minimum
	    this._minimum = minimum;
	    // return node
	    return node;
	  };
	  
	  /**
	   * Removes a node from the heap given the reference to the node. The trees
	   * in the heap will be consolidated, if necessary. This operation may fail
	   * to remove the correct element if there are nodes with key value -Infinity.
	   * Running time: O(log n) amortized.
	   * @memberof FibonacciHeap
	   */
	  FibonacciHeap.prototype.remove = function (node) {
	    // decrease key value
	    this._minimum = _decreaseKey(this._minimum, node, -1);
	    // remove the smallest
	    this.extractMinimum();
	  };
	  
	  /**
	   * Decreases the key value for a heap node, given the new value to take on.
	   * The structure of the heap may be changed and will not be consolidated. 
	   * Running time: O(1) amortized.
	   * @memberof FibonacciHeap
	   */
	  var _decreaseKey = function (minimum, node, key) {
	    // set node key
	    node.key = key;
	    // get parent node
	    var parent = node.parent;
	    if (parent && smaller(node.key, parent.key)) {
	      // remove node from parent
	      _cut(minimum, node, parent);
	      // remove all nodes from parent to the root parent
	      _cascadingCut(minimum, parent);
	    }
	    // update minimum node if needed
	    if (smaller(node.key, minimum.key))
	      minimum = node;
	    // return minimum
	    return minimum;
	  };
	  
	  /**
	   * The reverse of the link operation: removes node from the child list of parent.
	   * This method assumes that min is non-null. Running time: O(1).
	   * @memberof FibonacciHeap
	   */
	  var _cut = function (minimum, node, parent) {
	    // remove node from parent children and decrement Degree[parent]
	    node.left.right = node.right;
	    node.right.left = node.left;
	    parent.degree--;
	    // reset y.child if necessary
	    if (parent.child == node)
	      parent.child = node.right;
	    // remove child if degree is 0
	    if (parent.degree === 0)
	      parent.child = null;
	    // add node to root list of heap
	    node.left = minimum;
	    node.right = minimum.right;
	    minimum.right = node;
	    node.right.left = node;
	    // set parent[node] to null
	    node.parent = null;
	    // set mark[node] to false
	    node.mark = false;
	  };
	  
	  /**
	   * Performs a cascading cut operation. This cuts node from its parent and then
	   * does the same for its parent, and so on up the tree.
	   * Running time: O(log n); O(1) excluding the recursion.
	   * @memberof FibonacciHeap
	   */
	  var _cascadingCut= function (minimum, node) {
	    // store parent node
	    var parent = node.parent;
	    // if there's a parent...
	    if (!parent)
	      return;
	    // if node is unmarked, set it marked
	    if (!node.mark) {
	      node.mark = true;
	    }
	    else {
	      // it's marked, cut it from parent
	      _cut(minimum, node, parent);
	      // cut its parent as well
	      _cascadingCut(parent);
	    }
	  };
	  
	  /**
	   * Make the first node a child of the second one. Running time: O(1) actual.
	   * @memberof FibonacciHeap
	   */
	  var _linkNodes = function (node, parent) {
	    // remove node from root list of heap
	    node.left.right = node.right;
	    node.right.left = node.left;
	    // make node a Child of parent
	    node.parent = parent;
	    if (!parent.child) {
	      parent.child = node;
	      node.right = node;
	      node.left = node;
	    }
	    else {
	      node.left = parent.child;
	      node.right = parent.child.right;
	      parent.child.right = node;
	      node.right.left = node;
	    }
	    // increase degree[parent]
	    parent.degree++;
	    // set mark[node] false
	    node.mark = false;
	  };
	  
	  var _findMinimumNode = function (minimum, size) {
	    // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
	    var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1;
	    // create list with initial capacity
	    var array = new Array(arraySize);
	    // find the number of root nodes.
	    var numRoots = 0;
	    var x = minimum;
	    if (x) {
	      numRoots++;
	      x = x.right;
	      while (x !== minimum) {
	        numRoots++;
	        x = x.right;
	      }
	    }
	    // vars
	    var y;
	    // For each node in root list do...
	    while (numRoots > 0) {
	      // access this node's degree..
	      var d = x.degree;
	      // get next node
	      var next = x.right;
	      // check if there is a node already in array with the same degree
	      while (true) {
	        // get node with the same degree is any
	        y = array[d];
	        if (!y)
	          break;
	        // make one node with the same degree a child of the other, do this based on the key value.
	        if (larger(x.key, y.key)) {
	          var temp = y;
	          y = x;
	          x = temp;
	        }
	        // make y a child of x
	        _linkNodes(y, x);
	        // we have handled this degree, go to next one.
	        array[d] = null;
	        d++;
	      }
	      // save this node for later when we might encounter another of the same degree.
	      array[d] = x;
	      // move forward through list.
	      x = next;
	      numRoots--;
	    }
	    // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
	    minimum = null;
	    // loop nodes in array
	    for (var i = 0; i < arraySize; i++) {
	      // get current node
	      y = array[i];
	      if (!y)
	        continue;
	      // check if we have a linked list
	      if (minimum) {
	        // First remove node from root list.
	        y.left.right = y.right;
	        y.right.left = y.left;
	        // now add to root list, again.
	        y.left = minimum;
	        y.right = minimum.right;
	        minimum.right = y;
	        y.right.left = y;
	        // check if this is a new min.
	        if (smaller(y.key, minimum.key))
	          minimum = y;
	      }
	      else
	        minimum = y;
	    }
	    return minimum;
	  };
	  
	  return FibonacciHeap;
	}
	
	exports.name = 'FibonacciHeap';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether value x is smaller than y.
	   *
	   * The function returns true when x is smaller than y and the relative
	   * difference between x and y is smaller than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.smaller(x, y)
	   *
	   * Examples:
	   *
	   *    math.smaller(2, 3);            // returns true
	   *    math.smaller(5, 2 * 2);        // returns false
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('2 inch');
	   *    math.smaller(a, b);            // returns true
	   *
	   * See also:
	   *
	   *    equal, unequal, smallerEq, smaller, smallerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
	   */
	  var smaller = typed('smaller', {
	
	    'boolean, boolean': function (x, y) {
	      return x < y;
	    },
	
	    'number, number': function (x, y) {
	      return x < y && !nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.lt(y) && !bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.compare(y) === -1;
	    },
	
	    'Complex, Complex': function (x, y) {
	      throw new TypeError('No ordering relation is defined for complex numbers');
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return smaller(x.value, y.value);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, smaller);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, smaller, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, smaller, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, smaller);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return smaller(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return smaller(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return smaller(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, smaller, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, smaller, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, smaller, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, smaller, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, smaller, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, smaller, true).valueOf();
	    }
	  });
	
	  smaller.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['smaller'] + '${args[1]}\\right)'
	  };
	
	  return smaller;
	}
	
	exports.name = 'smaller';
	exports.factory = factory;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
	   * Callback function invoked M*N times.
	   *
	   *
	   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  f(Dij, 0)    ; otherwise
	   *
	   *
	   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
	   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
	   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
	   */
	  var algorithm03 = function (denseMatrix, sparseMatrix, callback, inverse) {
	    // dense matrix arrays
	    var adata = denseMatrix._data;
	    var asize = denseMatrix._size;
	    var adt = denseMatrix._datatype;
	    // sparse matrix arrays
	    var bvalues = sparseMatrix._values;
	    var bindex = sparseMatrix._index;
	    var bptr = sparseMatrix._ptr;
	    var bsize = sparseMatrix._size;
	    var bdt = sparseMatrix._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!bvalues)
	      throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result (DenseMatrix)
	    var cdata = [];
	
	    // initialize dense matrix
	    for (var z = 0; z < rows; z++) {
	      // initialize row
	      cdata[z] = [];
	    }
	
	    // workspace
	    var x = [];
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // loop columns in b
	    for (var j = 0; j < columns; j++) {
	      // column mark
	      var mark = j + 1;
	      // values in column j
	      for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        var i = bindex[k];
	        // update workspace
	        x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
	        w[i] = mark;
	      }
	      // process workspace
	      for (var y = 0; y < rows; y++) {
	        // check we have a calculated value for current row
	        if (w[y] === mark) {
	          // use calculated value
	          cdata[y][j] = x[y];
	        }
	        else {
	          // calculate value
	          cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
	        }
	      }
	    }
	
	    // return dense matrix
	    return new DenseMatrix({
	      data: cdata,
	      size: [rows, columns],
	      datatype: dt
	    });
	  };
	  
	  return algorithm03;
	}
	
	exports.name = 'algorithm03';
	exports.factory = factory;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked MxN times.
	   *
	   * C(i,j) = f(Aij, Bij)
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm07 = function (a, b, callback) {
	    // sparse matrix arrays
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // vars
	    var i, j;
	    
	    // result arrays
	    var cdata = [];
	    // initialize c
	    for (i = 0; i < rows; i++)
	      cdata[i] = [];
	
	    // matrix
	    var c = new DenseMatrix({
	      data: cdata,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var xa = [];
	    var xb = [];
	    // marks indicating we have a value in x for a given column
	    var wa = [];
	    var wb = [];
	
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // columns mark
	      var mark = j + 1;
	      // scatter the values of A(:,j) into workspace
	      _scatter(a, j, wa, xa, mark);
	      // scatter the values of B(:,j) into workspace
	      _scatter(b, j, wb, xb, mark);
	      // loop rows
	      for (i = 0; i < rows; i++) {
	        // matrix values @ i,j
	        var va = wa[i] === mark ? xa[i] : zero;
	        var vb = wb[i] === mark ? xb[i] : zero;
	        // invoke callback
	        cdata[i][j] = cf(va, vb);
	      }          
	    }
	
	    // return sparse matrix
	    return c;
	  };
	  
	  var _scatter = function (m, j, w, x, mark) {
	    // a arrays
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    // loop values in column j
	    for (var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++) {
	      // row
	      var i = index[k];
	      // update workspace
	      w[i] = mark;
	      x[i] = values[k];
	    }
	  };
	  
	  return algorithm07;
	}
	
	exports.name = 'algorithm07';
	exports.factory = factory;


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
	   * Callback function invoked MxN times.
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  f(0, b)    ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    DenseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */
	  var algorithm12 = function (s, b, callback, inverse) {
	    // sparse matrix arrays
	    var avalues = s._values;
	    var aindex = s._index;
	    var aptr = s._ptr;
	    var asize = s._size;
	    var adt = s._datatype;
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!avalues)
	      throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // convert b to the same datatype
	      b = typed.convert(b, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	    
	    // result arrays
	    var cdata = [];
	    // matrix
	    var c = new DenseMatrix({
	      data: cdata,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var x = [];
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // columns mark
	      var mark = j + 1;
	      // values in j
	      for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        var r = aindex[k];
	        // update workspace
	        x[r] = avalues[k];
	        w[r] = mark;
	      }
	      // loop rows
	      for (var i = 0; i < rows; i++) {
	        // initialize C on first column
	        if (j === 0) {
	          // create row array
	          cdata[i] = [];
	        }
	        // check sparse matrix has a value @ i,j
	        if (w[i] === mark) {
	          // invoke callback, update C
	          cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
	        }
	        else {
	          // dense matrix value @ i, j
	          cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
	        }
	      }
	    }
	
	    // return sparse matrix
	    return c;
	  };
	  
	  return algorithm12;
	}
	
	exports.name = 'algorithm12';
	exports.factory = factory;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether value x is larger than y.
	   *
	   * The function returns true when x is larger than y and the relative
	   * difference between x and y is larger than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.larger(x, y)
	   *
	   * Examples:
	   *
	   *    math.larger(2, 3);             // returns false
	   *    math.larger(5, 2 + 2);         // returns true
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('2 inch');
	   *    math.larger(a, b);             // returns false
	   *
	   * See also:
	   *
	   *    equal, unequal, smaller, smallerEq, largerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
	   */
	  var larger = typed('larger', {
	
	    'boolean, boolean': function (x, y) {
	      return x > y;
	    },
	
	    'number, number': function (x, y) {
	      return x > y && !nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.gt(y) && !bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.compare(y) === 1;
	    },
	
	    'Complex, Complex': function () {
	      throw new TypeError('No ordering relation is defined for complex numbers');
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return larger(x.value, y.value);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, larger);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, larger, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, larger, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, larger);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return larger(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return larger(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return larger(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, larger, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, larger, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, larger, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, larger, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, larger, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, larger, true).valueOf();
	    }
	  });
	
	  larger.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['larger'] + '${args[1]}\\right)'
	  };
	
	  return larger;
	}
	
	exports.name = 'larger';
	exports.factory = factory;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	var string = util.string;
	var object = util.object;
	
	var isArray = Array.isArray;
	var isString = string.isString;
	
	function factory (type, config, load) {
	
	  var DenseMatrix = load(__webpack_require__(1362));
	
	  var smaller = load(__webpack_require__(1376));
	
	  function ImmutableDenseMatrix(data, datatype) {
	    if (!(this instanceof ImmutableDenseMatrix))
	      throw new SyntaxError('Constructor must be called with the new operator');
	    if (datatype && !isString(datatype))
	      throw new Error('Invalid datatype: ' + datatype);
	
	    if (type.isMatrix(data) || isArray(data)) {
	      // use DenseMatrix implementation
	      var matrix = new DenseMatrix(data, datatype);
	      // internal structures
	      this._data = matrix._data;
	      this._size = matrix._size;
	      this._datatype = matrix._datatype;
	      this._min = null;
	      this._max = null;
	    }
	    else if (data && isArray(data.data) && isArray(data.size)) {
	      // initialize fields from JSON representation
	      this._data = data.data;
	      this._size = data.size;
	      this._datatype = data.datatype;
	      this._min = typeof data.min !== 'undefined' ? data.min : null;
	      this._max = typeof data.max !== 'undefined' ? data.max : null;
	    }
	    else if (data) {
	      // unsupported type
	      throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
	    }
	    else {
	      // nothing provided
	      this._data = [];
	      this._size = [0];
	      this._datatype = datatype;
	      this._min = null;
	      this._max = null;
	    }
	  }
	
	  ImmutableDenseMatrix.prototype = new DenseMatrix();
	
	  /**
	   * Attach type information
	   */
	  ImmutableDenseMatrix.prototype.type = 'ImmutableDenseMatrix';
	  ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
	
	  /**
	   * Get a subset of the matrix, or replace a subset of the matrix.
	   *
	   * Usage:
	   *     var subset = matrix.subset(index)               // retrieve subset
	   *     var value = matrix.subset(index, replacement)   // replace subset
	   *
	   * @param {Index} index
	   * @param {Array | ImmutableDenseMatrix | *} [replacement]
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be filled with zeros.
	   */
	  ImmutableDenseMatrix.prototype.subset = function (index) {
	    switch (arguments.length) {
	      case 1:
	        // use base implementation
	        var m = DenseMatrix.prototype.subset.call(this, index);
	        // check result is a matrix
	        if (type.isMatrix(m)) {
	          // return immutable matrix
	          return new ImmutableDenseMatrix({
	            data: m._data,
	            size: m._size,
	            datatype: m._datatype
	          });
	        }
	        return m;
	        
	        // intentional fall through
	      case 2:
	      case 3:
	        throw new Error('Cannot invoke set subset on an Immutable Matrix instance');
	
	      default:
	        throw new SyntaxError('Wrong number of arguments');
	    }
	  };
	
	  /**
	   * Replace a single element in the matrix.
	   * @param {Number[]} index   Zero-based index
	   * @param {*} value
	   * @param {*} [defaultValue]        Default value, filled in on new entries when
	   *                                  the matrix is resized. If not provided,
	   *                                  new matrix elements will be left undefined.
	   * @return {ImmutableDenseMatrix} self
	   */
	  ImmutableDenseMatrix.prototype.set = function () {
	    throw new Error('Cannot invoke set on an Immutable Matrix instance');
	  };
	
	  /**
	   * Resize the matrix to the given size. Returns a copy of the matrix when
	   * `copy=true`, otherwise return the matrix itself (resize in place).
	   *
	   * @param {Number[]} size           The new size the matrix should have.
	   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
	   *                                  If not provided, the matrix elements will
	   *                                  be filled with zeros.
	   * @param {boolean} [copy]          Return a resized copy of the matrix
	   *
	   * @return {Matrix}                 The resized matrix
	   */
	  ImmutableDenseMatrix.prototype.resize = function () {
	    throw new Error('Cannot invoke resize on an Immutable Matrix instance');
	  };
	
	  /**
	   * Disallows reshaping in favor of immutability.
	   *
	   * @throws {Error} Operation not allowed
	   */
	  ImmutableDenseMatrix.prototype.reshape = function () {
	    throw new Error('Cannot invoke reshape on an Immutable Matrix instance');
	  };
	
	  /**
	   * Create a clone of the matrix
	   * @return {ImmutableDenseMatrix} clone
	   */
	  ImmutableDenseMatrix.prototype.clone = function () {
	    var m = new ImmutableDenseMatrix({
	      data: object.clone(this._data),
	      size: object.clone(this._size),
	      datatype: this._datatype
	    });
	    return m;
	  };
	
	  /**
	   * Get a JSON representation of the matrix
	   * @returns {Object}
	   */
	  ImmutableDenseMatrix.prototype.toJSON = function () {
	    return {
	      mathjs: 'ImmutableDenseMatrix',
	      data: this._data,
	      size: this._size,
	      datatype: this._datatype
	    };
	  };
	
	  /**
	   * Generate a matrix from a JSON object
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
	   *                       where mathjs is optional
	   * @returns {ImmutableDenseMatrix}
	   */
	  ImmutableDenseMatrix.fromJSON = function (json) {
	    return new ImmutableDenseMatrix(json);
	  };
	
	  /**
	   * Swap rows i and j in Matrix.
	   *
	   * @param {Number} i       Matrix row index 1
	   * @param {Number} j       Matrix row index 2
	   *
	   * @return {Matrix}        The matrix reference
	   */
	  ImmutableDenseMatrix.prototype.swapRows = function () {
	    throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');
	  };
	
	  /**
	   * Calculate the minimum value in the set
	   * @return {Number | undefined} min
	   */
	  ImmutableDenseMatrix.prototype.min = function () {
	    // check min has been calculated before
	    if (this._min === null) {
	      // minimum
	      var m = null;
	      // compute min
	      this.forEach(function (v) {
	        if (m === null || smaller(v, m))
	          m = v;
	      });
	      this._min = m !== null ? m : undefined;
	    }
	    return this._min;
	  };
	
	  /**
	   * Calculate the maximum value in the set
	   * @return {Number | undefined} max
	   */
	  ImmutableDenseMatrix.prototype.max = function () {
	    // check max has been calculated before
	    if (this._max === null) {
	      // maximum
	      var m = null;
	      // compute max
	      this.forEach(function (v) {
	        if (m === null || smaller(m, v))
	          m = v;
	      });
	      this._max = m !== null ? m : undefined;
	    }
	    return this._max;
	  };
	
	  // exports
	  return ImmutableDenseMatrix;
	}
	
	exports.name = 'ImmutableDenseMatrix';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type) {
	  
	  /**
	   * Create an index. An Index can store ranges and sets for multiple dimensions.
	   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
	   *
	   * Usage:
	   *     var index = new Index(range1, range2, matrix1, array1, ...);
	   *
	   * Where each parameter can be any of:
	   *     A number
	   *     A string (containing a name of an object property)
	   *     An instance of Range
	   *     An Array with the Set values
	   *     A Matrix with the Set values
	   *
	   * The parameters start, end, and step must be integer numbers.
	   *
	   * @class Index
	   * @Constructor Index
	   * @param {...*} ranges
	   */
	  function Index(ranges) {
	    if (!(this instanceof Index)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this._dimensions = [];
	    this._isScalar = true;
	
	    for (var i = 0, ii = arguments.length; i < ii; i++) {
	      var arg = arguments[i];
	
	      if (type.isRange(arg)) {
	        this._dimensions.push(arg);
	        this._isScalar = false;
	      }
	      else if (Array.isArray(arg) || type.isMatrix(arg)) {
	        // create matrix
	        var m = _createImmutableMatrix(arg.valueOf());
	        this._dimensions.push(m);
	        // size
	        var size = m.size();
	        // scalar
	        if (size.length !== 1 || size[0] !== 1) {
	          this._isScalar = false;
	        }
	      }
	      else if (typeof arg === 'number') {
	        this._dimensions.push(_createImmutableMatrix([arg]));
	      }
	      else if (typeof arg === 'string') {
	        // object property (arguments.count should be 1)
	        this._dimensions.push(arg);
	      }
	      // TODO: implement support for wildcard '*'
	      else {
	        throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
	      }
	    }
	  }
	
	  /**
	   * Attach type information
	   */
	  Index.prototype.type = 'Index';
	  Index.prototype.isIndex = true;
	
	  function _createImmutableMatrix(arg) {
	    // loop array elements
	    for (var i = 0, l = arg.length; i < l; i++) {
	      if (typeof arg[i] !== 'number' || !isInteger(arg[i])) {
	        throw new TypeError('Index parameters must be positive integer numbers');
	      }
	    }
	    // create matrix
	    return new type.ImmutableDenseMatrix(arg);
	  }
	
	  /**
	   * Create a clone of the index
	   * @memberof Index
	   * @return {Index} clone
	   */
	  Index.prototype.clone = function () {
	    var index = new Index();
	    index._dimensions = clone(this._dimensions);
	    index._isScalar = this._isScalar;
	    return index;
	  };
	
	  /**
	   * Create an index from an array with ranges/numbers
	   * @memberof Index
	   * @param {Array.<Array | number>} ranges
	   * @return {Index} index
	   * @private
	   */
	  Index.create = function (ranges) {
	    var index = new Index();
	    Index.apply(index, ranges);
	    return index;
	  };
	
	  /**
	   * Retrieve the size of the index, the number of elements for each dimension.
	   * @memberof Index
	   * @returns {number[]} size
	   */
	  Index.prototype.size = function () {
	    var size = [];
	
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      var d = this._dimensions[i];
	      size[i] = (typeof d === 'string') ? 1 : d.size()[0];
	    }
	
	    return size;
	  };
	
	  /**
	   * Get the maximum value for each of the indexes ranges.
	   * @memberof Index
	   * @returns {number[]} max
	   */
	  Index.prototype.max = function () {
	    var values = [];
	
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      var range = this._dimensions[i];
	      values[i] = (typeof range === 'string') ? range : range.max();
	    }
	
	    return values;
	  };
	
	  /**
	   * Get the minimum value for each of the indexes ranges.
	   * @memberof Index
	   * @returns {number[]} min
	   */
	  Index.prototype.min = function () {
	    var values = [];
	
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      var range = this._dimensions[i];
	      values[i] = (typeof range === 'string') ? range : range.min();
	    }
	
	    return values;
	  };
	
	  /**
	   * Loop over each of the ranges of the index
	   * @memberof Index
	   * @param {Function} callback   Called for each range with a Range as first
	   *                              argument, the dimension as second, and the
	   *                              index object as third.
	   */
	  Index.prototype.forEach = function (callback) {
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      callback(this._dimensions[i], i, this);
	    }
	  };
	
	  /**
	   * Retrieve the dimension for the given index
	   * @memberof Index
	   * @param {Number} dim                  Number of the dimension
	   * @returns {Range | null} range
	   */
	  Index.prototype.dimension = function (dim) {
	    return this._dimensions[dim] || null;
	  };
	
	  /**
	   * Test whether this index contains an object property
	   * @returns {boolean} Returns true if the index is an object property
	   */
	  Index.prototype.isObjectProperty = function () {
	    return this._dimensions.length === 1 && typeof this._dimensions[0] === 'string';
	  };
	
	  /**
	   * Returns the object property name when the Index holds a single object property,
	   * else returns null
	   * @returns {string | null}
	   */
	  Index.prototype.getObjectProperty = function () {
	    return this.isObjectProperty() ? this._dimensions[0] : null;
	  };
	
	  /**
	   * Test whether this index contains only a single value.
	   *
	   * This is the case when the index is created with only scalar values as ranges,
	   * not for ranges resolving into a single value.
	   * @memberof Index
	   * @return {boolean} isScalar
	   */
	  Index.prototype.isScalar = function () {
	    return this._isScalar;
	  };
	
	  /**
	   * Expand the Index into an array.
	   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
	   * @memberof Index
	   * @returns {Array} array
	   */
	  Index.prototype.toArray = function () {
	    var array = [];
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      var dimension = this._dimensions[i];
	      array.push((typeof dimension === 'string') ? dimension : dimension.toArray());
	    }
	    return array;
	  };
	
	  /**
	   * Get the primitive value of the Index, a two dimensional array.
	   * Equivalent to Index.toArray().
	   * @memberof Index
	   * @returns {Array} array
	   */
	  Index.prototype.valueOf = Index.prototype.toArray;
	
	  /**
	   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
	   * @memberof Index
	   * @returns {String} str
	   */
	  Index.prototype.toString = function () {
	    var strings = [];
	
	    for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
	      var dimension = this._dimensions[i];
	      if (typeof dimension === 'string') {
	        strings.push(JSON.stringify(dimension));
	      }
	      else {
	        strings.push(dimension.toString());
	      }
	    }
	
	    return '[' + strings.join(', ') + ']';
	  };
	
	  /**
	   * Get a JSON representation of the Index
	   * @memberof Index
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
	   */
	  Index.prototype.toJSON = function () {
	    return {
	      mathjs: 'Index',
	      dimensions: this._dimensions
	    };
	  };
	
	  /**
	   * Instantiate an Index from a JSON object
	   * @memberof Index
	   * @param {Object} json A JSON object structured as:
	   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
	   * @return {Index}
	   */
	  Index.fromJSON = function (json) {
	    return Index.create(json.dimensions);
	  };
	
	  return Index;
	}
	
	exports.name = 'Index';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a range. A range has a start, step, and end, and contains functions
	   * to iterate over the range.
	   *
	   * A range can be constructed as:
	   *     var range = new Range(start, end);
	   *     var range = new Range(start, end, step);
	   *
	   * To get the result of the range:
	   *     range.forEach(function (x) {
	   *         console.log(x);
	   *     });
	   *     range.map(function (x) {
	   *         return math.sin(x);
	   *     });
	   *     range.toArray();
	   *
	   * Example usage:
	   *     var c = new Range(2, 6);         // 2:1:5
	   *     c.toArray();                     // [2, 3, 4, 5]
	   *     var d = new Range(2, -3, -1);    // 2:-1:-2
	   *     d.toArray();                     // [2, 1, 0, -1, -2]
	   *
	   * @class Range
	   * @constructor Range
	   * @param {number} start  included lower bound
	   * @param {number} end    excluded upper bound
	   * @param {number} [step] step size, default value is 1
	   */
	  function Range(start, end, step) {
	    if (!(this instanceof Range)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (start != null) {
	      if (type.isBigNumber(start))
	        start = start.toNumber();
	      else if (typeof start !== 'number')
	        throw new TypeError('Parameter start must be a number');
	    }
	    if (end != null) {
	      if (type.isBigNumber(end))
	        end = end.toNumber();
	      else if (typeof end !== 'number')
	        throw new TypeError('Parameter end must be a number');
	    }
	    if (step != null) {
	      if (type.isBigNumber(step))
	        step = step.toNumber();
	      else if (typeof step !== 'number')
	        throw new TypeError('Parameter step must be a number');
	    }
	
	    this.start = (start != null) ? parseFloat(start) : 0;
	    this.end   = (end != null)   ? parseFloat(end)   : 0;
	    this.step  = (step != null)  ? parseFloat(step)  : 1;
	  }
	
	  /**
	   * Attach type information
	   */
	  Range.prototype.type = 'Range';
	  Range.prototype.isRange = true;
	
	  /**
	   * Parse a string into a range,
	   * The string contains the start, optional step, and end, separated by a colon.
	   * If the string does not contain a valid range, null is returned.
	   * For example str='0:2:11'.
	   * @memberof Range
	   * @param {string} str
	   * @return {Range | null} range
	   */
	  Range.parse = function (str) {
	    if (typeof str !== 'string') {
	      return null;
	    }
	
	    var args = str.split(':');
	    var nums = args.map(function (arg) {
	      return parseFloat(arg);
	    });
	
	    var invalid = nums.some(function (num) {
	      return isNaN(num);
	    });
	    if (invalid) {
	      return null;
	    }
	
	    switch (nums.length) {
	      case 2:
	        return new Range(nums[0], nums[1]);
	      case 3:
	        return new Range(nums[0], nums[2], nums[1]);
	      default:
	        return null;
	    }
	  };
	
	  /**
	   * Create a clone of the range
	   * @return {Range} clone
	   */
	  Range.prototype.clone = function () {
	    return new Range(this.start, this.end, this.step);
	  };
	
	  /**
	   * Retrieve the size of the range.
	   * Returns an array containing one number, the number of elements in the range.
	   * @memberof Range
	   * @returns {number[]} size
	   */
	  Range.prototype.size = function () {
	    var len = 0,
	        start = this.start,
	        step = this.step,
	        end = this.end,
	        diff = end - start;
	
	    if (number.sign(step) == number.sign(diff)) {
	      len = Math.ceil((diff) / step);
	    }
	    else if (diff == 0) {
	      len = 0;
	    }
	
	    if (isNaN(len)) {
	      len = 0;
	    }
	    return [len];
	  };
	
	  /**
	   * Calculate the minimum value in the range
	   * @memberof Range
	   * @return {number | undefined} min
	   */
	  Range.prototype.min = function () {
	    var size = this.size()[0];
	
	    if (size > 0) {
	      if (this.step > 0) {
	        // positive step
	        return this.start;
	      }
	      else {
	        // negative step
	        return this.start + (size - 1) * this.step;
	      }
	    }
	    else {
	      return undefined;
	    }
	  };
	
	  /**
	   * Calculate the maximum value in the range
	   * @memberof Range
	   * @return {number | undefined} max
	   */
	  Range.prototype.max = function () {
	    var size = this.size()[0];
	
	    if (size > 0) {
	      if (this.step > 0) {
	        // positive step
	        return this.start + (size - 1) * this.step;
	      }
	      else {
	        // negative step
	        return this.start;
	      }
	    }
	    else {
	      return undefined;
	    }
	  };
	
	
	  /**
	   * Execute a callback function for each value in the range.
	   * @memberof Range
	   * @param {function} callback   The callback method is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Range being traversed.
	   */
	  Range.prototype.forEach = function (callback) {
	    var x = this.start;
	    var step = this.step;
	    var end = this.end;
	    var i = 0;
	
	    if (step > 0) {
	      while (x < end) {
	        callback(x, [i], this);
	        x += step;
	        i++;
	      }
	    }
	    else if (step < 0) {
	      while (x > end) {
	        callback(x, [i], this);
	        x += step;
	        i++;
	      }
	    }
	  };
	
	  /**
	   * Execute a callback function for each value in the Range, and return the
	   * results as an array
	   * @memberof Range
	   * @param {function} callback   The callback method is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix being traversed.
	   * @returns {Array} array
	   */
	  Range.prototype.map = function (callback) {
	    var array = [];
	    this.forEach(function (value, index, obj) {
	      array[index[0]] = callback(value, index, obj);
	    });
	    return array;
	  };
	
	  /**
	   * Create an Array with a copy of the Ranges data
	   * @memberof Range
	   * @returns {Array} array
	   */
	  Range.prototype.toArray = function () {
	    var array = [];
	    this.forEach(function (value, index) {
	      array[index[0]] = value;
	    });
	    return array;
	  };
	
	  /**
	   * Get the primitive value of the Range, a one dimensional array
	   * @memberof Range
	   * @returns {Array} array
	   */
	  Range.prototype.valueOf = function () {
	    // TODO: implement a caching mechanism for range.valueOf()
	    return this.toArray();
	  };
	
	  /**
	   * Get a string representation of the range, with optional formatting options.
	   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
	   * @memberof Range
	   * @param {Object | number | function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @returns {string} str
	   */
	  Range.prototype.format = function (options) {
	    var str = number.format(this.start, options);
	
	    if (this.step != 1) {
	      str += ':' + number.format(this.step, options);
	    }
	    str += ':' + number.format(this.end, options);
	    return str;
	  };
	
	  /**
	   * Get a string representation of the range.
	   * @memberof Range
	   * @returns {string}
	   */
	  Range.prototype.toString = function () {
	    return this.format();
	  };
	
	  /**
	   * Get a JSON representation of the range
	   * @memberof Range
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
	   */
	  Range.prototype.toJSON = function () {
	    return {
	      mathjs: 'Range',
	      start: this.start,
	      end: this.end,
	      step: this.step
	    };
	  };
	
	  /**
	   * Instantiate a Range from a JSON object
	   * @memberof Range
	   * @param {Object} json A JSON object structured as:
	   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
	   * @return {Range}
	   */
	  Range.fromJSON = function (json) {
	    return new Range(json.start, json.end, json.step);
	  };
	
	  return Range;
	}
	
	exports.name = 'Range';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * Create an index. An Index can store ranges having start, step, and end
	   * for multiple dimensions.
	   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
	   *
	   * Syntax:
	   *
	   *     math.index(range1, range2, ...)
	   *
	   * Where each range can be any of:
	   *
	   * - A number
	   * - A string for getting/setting an object property
	   * - An instance of `Range`
	   * - A one-dimensional Array or a Matrix with numbers
	   *
	   * Indexes must be zero-based, integer numbers.
	   *
	   * Examples:
	   *
	   *    var math = math.js
	   *
	   *    var b = [1, 2, 3, 4, 5];
	   *    math.subset(b, math.index([1, 2, 3]));     // returns [2, 3, 4]
	   *
	   *    var a = math.matrix([[1, 2], [3, 4]]);
	   *    a.subset(math.index(0, 1));             // returns 2
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, matrix, number, string, unit
	   *
	   * @param {...*} ranges   Zero or more ranges or numbers.
	   * @return {Index}        Returns the created index
	   */
	  return typed('index', {
	    '...number | string | BigNumber | Range | Array | Matrix': function (args) {
	      var ranges = args.map(function (arg) {
	        if (type.isBigNumber(arg)) {
	          return arg.toNumber(); // convert BigNumber to Number
	        }
	        else if (Array.isArray(arg) || type.isMatrix(arg)) {
	          return arg.map(function (elem) {
	            // convert BigNumber to Number
	            return type.isBigNumber(elem) ? elem.toNumber() : elem;
	          });
	        }
	        else {
	          return arg;
	        }
	      });
	
	      var res = new type.Index();
	      type.Index.apply(res, ranges);
	      return res;
	    }
	  });
	}
	
	exports.name = 'index';
	exports.factory = factory;


/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Create a Sparse Matrix. The function creates a new `math.type.Matrix` object from
	   * an `Array`. A Matrix has utility functions to manipulate the data in the
	   * matrix, like getting the size and getting or setting values in the matrix.
	   *
	   * Syntax:
	   *
	   *    math.sparse()               // creates an empty sparse matrix.
	   *    math.sparse(data)           // creates a sparse matrix with initial data.
	   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
	   *
	   * Examples:
	   *
	   *    var m = math.sparse([[1, 2], [3, 4]]);
	   *    m.size();                        // Array [2, 2]
	   *    m.resize([3, 2], 5);
	   *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
	   *    m.get([1, 0])                    // number 3
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, number, string, unit, matrix
	   *
	   * @param {Array | Matrix} [data]    A two dimensional array
	   *
	   * @return {Matrix} The created matrix
	   */
	  var sparse = typed('sparse', {
	    '': function () {
	      return new SparseMatrix([]);
	    },
	    
	    'string': function (datatype) {
	      return new SparseMatrix([], datatype);
	    },
	
	    'Array | Matrix': function (data) {
	      return new SparseMatrix(data);
	    },
	    
	    'Array | Matrix, string': function (data, datatype) {
	      return new SparseMatrix(data, datatype);
	    }
	  });
	
	  sparse.toTex = {
	    0: '\\begin{bsparse}\\end{bsparse}',
	    1: '\\left(${args[0]}\\right)'
	  };
	
	  return sparse;
	}
	
	exports.name = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a number or convert a string, boolean, or unit to a number.
	   * When value is a matrix, all elements will be converted to number.
	   *
	   * Syntax:
	   *
	   *    math.number(value)
	   *    math.number(unit, valuelessUnit)
	   *
	   * Examples:
	   *
	   *    math.number(2);                         // returns number 2
	   *    math.number('7.2');                     // returns number 7.2
	   *    math.number(true);                      // returns number 1
	   *    math.number([true, false, true, true]); // returns [1, 0, 1, 1]
	   *    math.number(math.unit('52cm'), 'm');    // returns 0.52
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, matrix, string, unit
	   *
	   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
	   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
	   * @return {number | Array | Matrix} The created number
	   */
	  var number = typed('number', {
	    '': function () {
	      return 0;
	    },
	
	    'number': function (x) {
	      return x;
	    },
	
	    'string': function (x) {
	      var num = Number(x);
	      if (isNaN(num)) {
	        throw new SyntaxError('String "' + x + '" is no valid number');
	      }
	      return num;
	    },
	
	    'BigNumber': function (x) {
	      return x.toNumber();
	    },
	
	    'Fraction': function (x) {
	      return x.valueOf();
	    },
	
	    'Unit': function (x) {
	      throw new Error('Second argument with valueless unit expected');
	    },
	
	    'null': function (x) {
	      return 0;
	    },
	
	    'Unit, string | Unit': function (unit, valuelessUnit) {
	      return unit.toNumber(valuelessUnit);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, number);
	    }
	  });
	
	  number.toTex = {
	    0: '0',
	    1: '\\left(${args[0]}\\right)',
	    2: '\\left(\\left(${args[0]}\\right)${args[1]}\\right)'
	  };
	
	  return number;
	}
	
	exports.name = 'number';
	exports.factory = factory;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1388)
	];


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * A ResultSet contains a list or results
	   * @class ResultSet
	   * @param {Array} entries
	   * @constructor ResultSet
	   */
	  function ResultSet(entries) {
	    if (!(this instanceof ResultSet)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this.entries = entries || [];
	  }
	
	  /**
	   * Attach type information
	   */
	  ResultSet.prototype.type = 'ResultSet';
	  ResultSet.prototype.isResultSet = true;
	
	  /**
	   * Returns the array with results hold by this ResultSet
	   * @memberof ResultSet
	   * @returns {Array} entries
	   */
	  ResultSet.prototype.valueOf = function () {
	    return this.entries;
	  };
	
	  /**
	   * Returns the stringified results of the ResultSet
	   * @memberof ResultSet
	   * @returns {string} string
	   */
	  ResultSet.prototype.toString = function () {
	    return '[' + this.entries.join(', ') + ']';
	  };
	
	  /**
	   * Get a JSON representation of the ResultSet
	   * @memberof ResultSet
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "ResultSet", "entries": [...]}`
	   */
	  ResultSet.prototype.toJSON = function () {
	    return {
	      mathjs: 'ResultSet',
	      entries: this.entries
	    };
	  };
	
	  /**
	   * Instantiate a ResultSet from a JSON object
	   * @memberof ResultSet
	   * @param {Object} json  A JSON object structured as:
	   *                       `{"mathjs": "ResultSet", "entries": [...]}`
	   * @return {ResultSet}
	   */
	  ResultSet.fromJSON = function (json) {
	    return new ResultSet(json.entries);
	  };
	
	  return ResultSet;
	}
	
	exports.name = 'ResultSet';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a string or convert any object into a string.
	   * Elements of Arrays and Matrices are processed element wise.
	   *
	   * Syntax:
	   *
	   *    math.string(value)
	   *
	   * Examples:
	   *
	   *    math.string(4.2);               // returns string '4.2'
	   *    math.string(math.complex(3, 2); // returns string '3 + 2i'
	   *
	   *    var u = math.unit(5, 'km');
	   *    math.string(u.to('m'));         // returns string '5000 m'
	   *
	   *    math.string([true, false]);     // returns ['true', 'false']
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, matrix, number, unit
	   *
	   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
	   * @return {string | Array | Matrix} The created string
	   */
	  var string = typed('string', {
	    '': function () {
	      return '';
	    },
	
	    'number': number.format,
	
	    'null': function (x) {
	      return 'null';
	    },
	
	    'boolean': function (x) {
	      return x + '';
	    },
	
	    'string': function (x) {
	      return x;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, string);
	    },
	
	    'any': function (x) {
	      return String(x);
	    }
	  });
	
	  string.toTex = {
	    0: '\\mathtt{""}',
	    1: '\\mathrm{string}\\left(${args[0]}\\right)'
	  };
	
	  return string;
	}
	
	exports.name = 'string';
	exports.factory = factory;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // type
	  __webpack_require__(1391),
	
	  // construction function
	  __webpack_require__(1410),
	
	  // create new units
	  __webpack_require__(1411),
	
	  // split units
	  __webpack_require__(1412),
	
	  // physical constants
	  __webpack_require__(1413)
	];


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var endsWith = __webpack_require__(1341).endsWith;
	var clone = __webpack_require__(1320).clone;
	var constants = __webpack_require__(1392);
	
	function factory (type, config, load, typed, math) {
	  var add       = load(__webpack_require__(1369));
	  var subtract  = load(__webpack_require__(1393));
	  var multiply  = load(__webpack_require__(1396));
	  var divide    = load(__webpack_require__(1397));
	  var pow       = load(__webpack_require__(1398));
	  var abs       = load(__webpack_require__(1402));
	  var fix       = load(__webpack_require__(1403));
	  var round     = load(__webpack_require__(1404));
	  var equal     = load(__webpack_require__(1406));
	  var isNumeric = load(__webpack_require__(1407));
	  var format    = load(__webpack_require__(1408));
	  var getTypeOf = load(__webpack_require__(1409));
	  var toNumber  = load(__webpack_require__(1386));
	  var Complex   = load(__webpack_require__(1345));
	
	  /**
	   * A unit can be constructed in the following ways:
	   *     var a = new Unit(value, name);
	   *     var b = new Unit(null, name);
	   *     var c = Unit.parse(str);
	   *
	   * Example usage:
	   *     var a = new Unit(5, 'cm');               // 50 mm
	   *     var b = Unit.parse('23 kg');             // 23 kg
	   *     var c = math.in(a, new Unit(null, 'm');  // 0.05 m
	   *     var d = new Unit(9.81, "m/s^2");         // 9.81 m/s^2
	   *
	   * @class Unit
	   * @constructor Unit
	   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
	   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
	   */
	  function Unit(value, name) {
	    if (!(this instanceof Unit)) {
	      throw new Error('Constructor must be called with the new operator');
	    }
	
	    if (!(value == undefined || isNumeric(value) || type.isComplex(value))) {
	      throw new TypeError('First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined');
	    }
	    if (name != undefined && (typeof name !== 'string' || name === '')) {
	      throw new TypeError('Second parameter in Unit constructor must be a string');
	    }
	
	    if (name != undefined) {
	      var u = Unit.parse(name);
	      this.units = u.units;
	      this.dimensions = u.dimensions;
	    }
	    else {
	      this.units = [
	        {
	          unit: UNIT_NONE,
	          prefix: PREFIXES.NONE,  // link to a list with supported prefixes
	          power: 0
	        }
	      ];
	      this.dimensions = []; 
	      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	        this.dimensions[i] = 0;
	      }
	    }
	
	    this.value = (value != undefined) ? this._normalize(value) : null;
	
	    this.fixPrefix = false; // if true, function format will not search for the
	                            // best prefix but leave it as initially provided.
	                            // fixPrefix is set true by the method Unit.to
	
	    // The justification behind this is that if the constructor is explicitly called,
	    // the caller wishes the units to be returned exactly as he supplied.
	    this.isUnitListSimplified = true;
	
	  }
	
	  /**
	   * Attach type information
	   */
	  Unit.prototype.type = 'Unit';
	  Unit.prototype.isUnit = true;
	
	  // private variables and functions for the Unit parser
	  var text, index, c;
	
	  function skipWhitespace() {
	    while (c == ' ' || c == '\t') {
	      next();
	    }
	  }
	
	  function isDigitDot(c) {
	    return ((c >= '0' && c <= '9') || c == '.');
	  }
	
	  function isDigit(c) {
	    return ((c >= '0' && c <= '9'));
	  }
	
	  function next() {
	    index++;
	    c = text.charAt(index);
	  }
	
	  function revert(oldIndex) {
	    index = oldIndex;
	    c = text.charAt(index);
	  }
	
	  function parseNumber() {
	    var number = '';
	    var oldIndex;
	    oldIndex = index;
	
	    if (c == '+') {
	      next();
	    }
	    else if (c == '-') {
	      number += c;
	      next();
	    }
	
	    if (!isDigitDot(c)) {
	      // a + or - must be followed by a digit
	      revert(oldIndex);
	      return null;
	    }
	
	    // get number, can have a single dot
	    if (c == '.') {
	      number += c;
	      next();
	      if (!isDigit(c)) {
	        // this is no legal number, it is just a dot
	        revert(oldIndex);
	        return null;
	      }
	    }
	    else {
	      while (isDigit(c)) {
	        number += c;
	        next();
	      }
	      if (c == '.') {
	        number += c;
	        next();
	      }
	    }
	    while (isDigit(c)) {
	      number += c;
	      next();
	    }
	
	    // check for exponential notation like "2.3e-4" or "1.23e50"
	    if (c == 'E' || c == 'e') {
	      // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
	
	      var tentativeNumber = '';
	      var tentativeIndex = index;
	
	      tentativeNumber += c;
	      next();
	
	      if (c == '+' || c == '-') {
	        tentativeNumber += c;
	        next();
	      }
	
	      // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
	      if (!isDigit(c)) {
	        // The e or E must belong to something else, so return the number without the e or E.
	        revert(tentativeIndex);
	        return number;
	      }
	      
	      // We can now safely say that this is scientific notation.
	      number = number + tentativeNumber;
	      while (isDigit(c)) {
	        number += c;
	        next();
	      }
	    }
	
	    return number;
	  }
	
	  function parseUnit() {
	    var unitName = '';
	
	    // Alphanumeric characters only; matches [a-zA-Z0-9]
	    var code = text.charCodeAt(index);
	    while ( (code >= 48 && code <= 57) ||
	            (code >= 65 && code <= 90) ||
	            (code >= 97 && code <= 122)) {
	      unitName += c;
	      next();
	      code = text.charCodeAt(index);
	    }
	
	    // Must begin with [a-zA-Z]
	    code = unitName.charCodeAt(0);
	    if ((code >= 65 && code <= 90) ||
	        (code >= 97 && code <= 122)) {
	        return unitName || null;
	    } 
	    else {
	      return null;
	    }
	  }
	
	  function parseCharacter(toFind) {
	    if (c === toFind) {
	      next();
	      return toFind;
	    }
	    else {
	      return null;
	    }
	  }
	
	  /**
	   * Parse a string into a unit. The value of the unit is parsed as number,
	   * BigNumber, or Fraction depending on the math.js config setting `number`.
	   *
	   * Throws an exception if the provided string does not contain a valid unit or
	   * cannot be parsed.
	   * @memberof Unit
	   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
	   * @return {Unit} unit
	   */
	  Unit.parse = function (str, options) {
	    options = options || {};
	    text = str;
	    index = -1;
	    c = '';
	
	    if (typeof text !== 'string') {
	      throw new TypeError('Invalid argument in Unit.parse, string expected');
	    }
	
	    var unit = new Unit();
	    unit.units = [];
	
	    var powerMultiplierCurrent = 1;
	    var expectingUnit = false;
	
	    // A unit should follow this pattern:
	    // [number] ...[ [*/] unit[^number] ]
	    // unit[^number] ... [ [*/] unit[^number] ]
	
	    // Rules:
	    // number is any floating point number.
	    // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
	    // The string may optionally begin with a number.
	    // Each unit may optionally be followed by ^number.
	    // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
	    //   2m^2kg/s^2
	    // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
	    //   4erg
	
	    next();
	    skipWhitespace();
	
	    // Optional number at the start of the string
	    var valueStr = parseNumber();
	    var value = null;
	    if(valueStr) {
	      if (config.number === 'BigNumber') {
	        value = new type.BigNumber(valueStr);
	      }
	      else if (config.number === 'Fraction') {
	        value = new type.Fraction(valueStr);
	      }
	      else { // number
	        value = parseFloat(valueStr);
	      }
	
	      skipWhitespace();    // Whitespace is not required here
	
	      // handle multiplication or division right after the value, like '1/s'
	      if (parseCharacter('*')) {
	        powerMultiplierCurrent = 1;
	        expectingUnit = true;
	      }
	      else if (parseCharacter('/')) {
	        powerMultiplierCurrent = -1;
	        expectingUnit = true;
	      }
	    }
	
	    // Stack to keep track of powerMultipliers applied to each parentheses group
	    var powerMultiplierStack = [];
	
	    // Running product of all elements in powerMultiplierStack
	    var powerMultiplierStackProduct = 1;
	
	    while (true) {
	      skipWhitespace();
	
	      // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
	      // A '(' will always appear directly before a unit.
	      while (c === '(') {
	        powerMultiplierStack.push(powerMultiplierCurrent);
	        powerMultiplierStackProduct *= powerMultiplierCurrent;
	        powerMultiplierCurrent = 1;
	        next();
	        skipWhitespace();
	      }
	
	      // Is there something here?
	      if(c) {
	        var oldC = c;
	        var uStr = parseUnit();
	        if(uStr == null) {
	          throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
	        }
	      }
	      else {
	        // End of input.
	        break;
	      }
	
	      // Verify the unit exists and get the prefix (if any)
	      var res = _findUnit(uStr);
	      if(res == null) {
	        // Unit not found.
	        throw new SyntaxError('Unit "' + uStr + '" not found.');
	      }
	
	      var power = powerMultiplierCurrent * powerMultiplierStackProduct;
	      // Is there a "^ number"?
	      skipWhitespace();
	      if (parseCharacter('^')) {
	        skipWhitespace();
	        var p = parseNumber();
	        if(p == null) {
	          // No valid number found for the power!
	          throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
	        }
	        power *= p;
	      }
	
	      // Add the unit to the list
	      unit.units.push( {
	        unit: res.unit,
	        prefix: res.prefix,
	        power: power
	      });
	      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	        unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
	      }
	
	      // Check for and consume closing parentheses, popping from the stack.
	      // A ')' will always follow a unit.
	      skipWhitespace();
	      while (c === ')') {
	        if(powerMultiplierStack.length === 0) {
	          throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
	        }
	        powerMultiplierStackProduct /= powerMultiplierStack.pop();
	        next();
	        skipWhitespace();
	      }
	
	      // "*" and "/" should mean we are expecting something to come next.
	      // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
	      expectingUnit = false;
	
	      if (parseCharacter('*')) {
	        // explicit multiplication
	        powerMultiplierCurrent = 1;
	        expectingUnit = true;
	      }
	      else if (parseCharacter('/')) {
	        // division
	        powerMultiplierCurrent = -1;
	        expectingUnit = true;
	      }
	      else {
	        // implicit multiplication
	        powerMultiplierCurrent = 1;
	      }
	
	      // Replace the unit into the auto unit system
	      if(res.unit.base) {
	        var baseDim = res.unit.base.key;
	        UNIT_SYSTEMS.auto[baseDim] = {
	          unit: res.unit,
	          prefix: res.prefix
	        };
	      }
	    }
	    
	    // Has the string been entirely consumed?
	    skipWhitespace();
	    if(c) {
	      throw new SyntaxError('Could not parse: "' + str + '"');
	    }
	
	    // Is there a trailing slash?
	    if(expectingUnit) {
	      throw new SyntaxError('Trailing characters: "' + str + '"');
	    }
	
	    // Is the parentheses stack empty?
	    if(powerMultiplierStack.length !== 0) {
	      throw new SyntaxError('Unmatched "(" in "' + text + '"');
	    }
	
	    // Are there any units at all?
	    if(unit.units.length == 0 && !options.allowNoUnits) {
	      throw new SyntaxError('"' + str + '" contains no units');
	    }
	
	    unit.value = (value != undefined) ? unit._normalize(value) : null;
	    return unit;
	  };
	
	  /**
	   * create a copy of this unit
	   * @memberof Unit
	   * @return {Unit} Returns a cloned version of the unit
	   */
	  Unit.prototype.clone = function () {
	    var unit = new Unit();
	
	    unit.fixPrefix = this.fixPrefix;
	    unit.isUnitListSimplified = this.isUnitListSimplified;
	
	    unit.value = clone(this.value);
	    unit.dimensions = this.dimensions.slice(0);
	    unit.units = [];
	    for(var i = 0; i < this.units.length; i++) {
	      unit.units[i] = { };
	      for (var p in this.units[i]) {
	        if (this.units[i].hasOwnProperty(p)) {
	          unit.units[i][p] = this.units[i][p];
	        }
	      }
	    }
	
	    return unit;
	  };
	
	  /**
	   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
	   * @memberof Unit
	   * @return {boolean} True if the unit is derived
	   */
	  Unit.prototype._isDerived = function() {
	    if(this.units.length === 0) {
	      return false;
	    }
	    return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
	  };
	
	  /**
	   * Normalize a value, based on its currently set unit(s)
	   * @memberof Unit
	   * @param {number | BigNumber | Fraction | boolean} value
	   * @return {number | BigNumber | Fraction | boolean} normalized value
	   * @private
	   */
	  Unit.prototype._normalize = function (value) {
	    var unitValue, unitOffset, unitPower, unitPrefixValue;
	    var convert;
	
	    if (value == null || this.units.length === 0) {
	      return value;
	    }
	    else if (this._isDerived()) {
	      // This is a derived unit, so do not apply offsets.
	      // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
	      var res = value;
	      convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed
	
	      for(var i=0; i < this.units.length; i++) {
	        unitValue       = convert(this.units[i].unit.value);
	        unitPrefixValue = convert(this.units[i].prefix.value);
	        unitPower       = convert(this.units[i].power);
	        res = multiply(res, pow(multiply(unitValue, unitPrefixValue), unitPower));
	      }
	
	      return res;
	    }
	    else {
	      // This is a single unit of power 1, like kg or degC
	      convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed
	
	      unitValue       = convert(this.units[0].unit.value);
	      unitOffset      = convert(this.units[0].unit.offset);
	      unitPrefixValue = convert(this.units[0].prefix.value);
	
	      return multiply(add(value, unitOffset), multiply(unitValue, unitPrefixValue));
	    }
	  };
	
	  /**
	   * Denormalize a value, based on its currently set unit(s)
	   * @memberof Unit
	   * @param {number} value
	   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
	   * @return {number} denormalized value
	   * @private
	   */
	  Unit.prototype._denormalize = function (value, prefixValue) {
	    var unitValue, unitOffset, unitPower, unitPrefixValue;
	    var convert;
	
	    if (value == null || this.units.length === 0) {
	      return value;
	    }
	    else if (this._isDerived()) {
	      // This is a derived unit, so do not apply offsets.
	      // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
	      // Also, prefixValue is ignored--but we will still use the prefix value stored in each unit, since kg is usually preferable to g unless the user decides otherwise.
	      var res = value;
	      convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed
	
	      for (var i = 0; i < this.units.length; i++) {
	        unitValue       = convert(this.units[i].unit.value);
	        unitPrefixValue = convert(this.units[i].prefix.value);
	        unitPower       = convert(this.units[i].power);
	        res = divide(res, pow(multiply(unitValue, unitPrefixValue), unitPower));
	      }
	
	      return res;
	    }
	    else {
	      // This is a single unit of power 1, like kg or degC
	      convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed
	
	      unitValue       = convert(this.units[0].unit.value);
	      unitPrefixValue = convert(this.units[0].prefix.value);
	      unitOffset      = convert(this.units[0].unit.offset);
	
	      if (prefixValue == undefined) {
	        return subtract(divide(divide(value, unitValue), unitPrefixValue), unitOffset);
	      }
	      else {
	        return subtract(divide(divide(value, unitValue), prefixValue), unitOffset);
	      }
	    }
	  };
	
	  /**
	   * Find a unit from a string
	   * @memberof Unit
	   * @param {string} str              A string like 'cm' or 'inch'
	   * @returns {Object | null} result  When found, an object with fields unit and
	   *                                  prefix is returned. Else, null is returned.
	   * @private
	   */
	  function _findUnit(str) {
	  
	    // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
	    if(UNITS.hasOwnProperty(str)) {
	      var unit = UNITS[str];
	      var prefix = unit.prefixes[''];
	      return {
	        unit: unit,
	        prefix: prefix
	      }
	    }
	
	    for (var name in UNITS) {
	      if (UNITS.hasOwnProperty(name)) {
	        if (endsWith(str, name)) {
	          var unit = UNITS[name];
	          var prefixLen = (str.length - name.length);
	          var prefixName = str.substring(0, prefixLen);
	          var prefix = unit.prefixes.hasOwnProperty(prefixName)
	              ? unit.prefixes[prefixName]
	              : undefined;
	          if (prefix !== undefined) {
	            // store unit, prefix, and value
	            return {
	              unit: unit,
	              prefix: prefix
	            };
	          }
	        }
	      }
	    }
	
	    return null;
	  }
	
	  /**
	   * Test if the given expression is a unit.
	   * The unit can have a prefix but cannot have a value.
	   * @memberof Unit
	   * @param {string} name   A string to be tested whether it is a value less unit.
	   *                        The unit can have prefix, like "cm"
	   * @return {boolean}      true if the given string is a unit
	   */
	  Unit.isValuelessUnit = function (name) {
	    return (_findUnit(name) != null);
	  };
	
	  /**
	   * check if this unit has given base unit
	   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
	   * @memberof Unit
	   * @param {BASE_UNITS | string | undefined} base
	   */
	  Unit.prototype.hasBase = function (base) {
	
	    if(typeof(base) === "string") {
	      base = BASE_UNITS[base];
	    }
	
	    if(!base)
	      return false;
	
	
	    // All dimensions must be the same
	    for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	      if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) {
	        return false;
	      }
	    }
	    return true;
	
	  };
	
	  /**
	   * Check if this unit has a base or bases equal to another base or bases
	   * For derived units, the exponent on each base also must match
	   * @memberof Unit
	   * @param {Unit} other
	   * @return {boolean} true if equal base
	   */
	  Unit.prototype.equalBase = function (other) {
	    // All dimensions must be the same
	    for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	      if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  /**
	   * Check if this unit equals another unit
	   * @memberof Unit
	   * @param {Unit} other
	   * @return {boolean} true if both units are equal
	   */
	  Unit.prototype.equals = function (other) {
	    return (this.equalBase(other) && equal(this.value, other.value));
	  };
	
	  /**
	   * Multiply this unit with another one
	   * @memberof Unit
	   * @param {Unit} other
	   * @return {Unit} product of this unit and the other unit
	   */
	  Unit.prototype.multiply = function (other) {
	    var res = this.clone();
	    
	    for(var i = 0; i<BASE_DIMENSIONS.length; i++) {
	      // Dimensions arrays may be of different lengths. Default to 0.
	      res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
	    }
	
	    // Append other's units list onto res (simplify later in Unit.prototype.format)
	    for(var i=0; i<other.units.length; i++) {
	      // Make a deep copy
	      var inverted = {};
	      for(var key in other.units[i]) {
	        inverted[key] = other.units[i][key];
	      }
	      res.units.push(inverted);
	    }
	
	    // If at least one operand has a value, then the result should also have a value
	    if(this.value != null || other.value != null) {
	      var valThis = this.value == null ? this._normalize(1) : this.value;
	      var valOther = other.value == null ? other._normalize(1) : other.value;
	      res.value = multiply(valThis, valOther);
	    }
	    else {
	      res.value = null;
	    }
	
	    // Trigger simplification of the unit list at some future time
	    res.isUnitListSimplified = false;
	
	    return getNumericIfUnitless(res);
	  };
	
	  /**
	   * Divide this unit by another one
	   * @memberof Unit
	   * @param {Unit} other
	   * @return {Unit} result of dividing this unit by the other unit
	   */
	  Unit.prototype.divide = function (other) {
	    var res = this.clone();
	    
	    for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	      // Dimensions arrays may be of different lengths. Default to 0.
	      res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
	    }
	
	    // Invert and append other's units list onto res (simplify later in Unit.prototype.format)
	    for(var i=0; i<other.units.length; i++) {
	      // Make a deep copy
	      var inverted = {};
	      for(var key in other.units[i]) {
	        inverted[key] = other.units[i][key];
	      }
	      inverted.power = -inverted.power;
	      res.units.push(inverted);
	    }
	
	    // If at least one operand has a value, the result should have a value
	    if (this.value != null || other.value != null) {
	      var valThis = this.value == null ? this._normalize(1) : this.value;
	      var valOther = other.value == null ? other._normalize(1) : other.value;
	      res.value = divide(valThis, valOther);
	    }
	    else {
	      res.value = null;
	    }
	
	    // Trigger simplification of the unit list at some future time
	    res.isUnitListSimplified = false;
	
	    return getNumericIfUnitless(res);
	  };
	
	  /**
	   * Calculate the power of a unit
	   * @memberof Unit
	   * @param {number | Fraction | BigNumber} p
	   * @returns {Unit}      The result: this^p
	   */
	  Unit.prototype.pow = function (p) {
	    var res = this.clone();
	    
	    for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	      // Dimensions arrays may be of different lengths. Default to 0.
	      res.dimensions[i] = (this.dimensions[i] || 0) * p;
	    }
	
	    // Adjust the power of each unit in the list
	    for(var i=0; i<res.units.length; i++) {
	      res.units[i].power *= p;
	    }
	
	    if(res.value != null) {
	      res.value = pow(res.value, p);
	
	      // only allow numeric output, we don't want to return a Complex number
	      //if (!isNumeric(res.value)) {
	      //  res.value = NaN;
	      //}
	      // Update: Complex supported now
	    }
	    else {
	      res.value = null;
	    }
	
	    // Trigger lazy evaluation of the unit list
	    res.isUnitListSimplified = false;
	
	    return getNumericIfUnitless(res);
	  };
	
	  /**
	   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
	   * @param {Unit} unit
	   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
	   */
	  var getNumericIfUnitless = function(unit) {
	    if(unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) {
	      return unit.value;
	    }
	    else {
	      return unit;
	    }
	  }
	    
	
	  /**
	   * Calculate the absolute value of a unit
	   * @memberof Unit
	   * @param {number | Fraction | BigNumber} x
	   * @returns {Unit}      The result: |x|, absolute value of x
	   */
	  Unit.prototype.abs = function () {
	    // This gives correct, but unexpected, results for units with an offset.
	    // For example, abs(-283.15 degC) = -263.15 degC !!!
	    var ret = this.clone();
	    ret.value = ret.value !== null ? abs(ret.value) : null;
	
	    for(var i in ret.units) {
	      if(ret.units[i].unit.name === 'VA' || ret.units[i].unit.name === 'VAR') {
	        ret.units[i].unit = UNITS["W"];
	      }
	    }
	
	    return ret;
	  };
	
	  /**
	   * Convert the unit to a specific unit name.
	   * @memberof Unit
	   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
	   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
	   */
	  Unit.prototype.to = function (valuelessUnit) {
	    var other;
	    var value = this.value == null ? this._normalize(1) : this.value;
	    if (typeof valuelessUnit === 'string') {
	      //other = new Unit(null, valuelessUnit);
	      other = Unit.parse(valuelessUnit);
	      if (!this.equalBase(other)) {
	        throw new Error('Units do not match');
	      }
	      if (other.value !== null) {
	        throw new Error('Cannot convert to a unit with a value');
	      }
	
	      other.value = clone(value);
	      other.fixPrefix = true;
	      other.isUnitListSimplified = true;
	      return other;
	    }
	    else if (type.isUnit(valuelessUnit)) {
	      if (!this.equalBase(valuelessUnit)) {
	        throw new Error('Units do not match');
	      }
	      if (valuelessUnit.value !== null) {
	        throw new Error('Cannot convert to a unit with a value');
	      }
	      other = valuelessUnit.clone();
	      other.value = clone(value);
	      other.fixPrefix = true;
	      other.isUnitListSimplified = true;
	      return other;
	    }
	    else {
	      throw new Error('String or Unit expected as parameter');
	    }
	  };
	
	  /**
	   * Return the value of the unit when represented with given valueless unit
	   * @memberof Unit
	   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
	   * @return {number} Returns the unit value as number.
	   */
	  // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
	  Unit.prototype.toNumber = function (valuelessUnit) {
	    return toNumber(this.toNumeric(valuelessUnit));
	  };
	
	  /**
	   * Return the value of the unit in the original numeric type
	   * @memberof Unit
	   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
	   * @return {number | BigNumber | Fraction} Returns the unit value
	   */
	  Unit.prototype.toNumeric = function (valuelessUnit) {
	    var other = this;
	    if(valuelessUnit) {
	      // Allow getting the numeric value without converting to a different unit
	      other = this.to(valuelessUnit);
	    }
	
	    other.simplifyUnitListLazy();
	
	    if(other._isDerived()) {
	      return other._denormalize(other.value);
	    }
	    else {
	      return other._denormalize(other.value, other.units[0].prefix.value);
	    }
	  };
	
	  /**
	   * Get a string representation of the unit.
	   * @memberof Unit
	   * @return {string}
	   */
	  Unit.prototype.toString = function () {
	    return this.format();
	  };
	
	  /**
	   * Get a JSON representation of the unit
	   * @memberof Unit
	   * @returns {Object} Returns a JSON object structured as:
	   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
	   */
	  Unit.prototype.toJSON = function () {
	    return {
	      mathjs: 'Unit',
	      value: this._denormalize(this.value),
	      unit: this.formatUnits(),
	      fixPrefix: this.fixPrefix
	    };
	  };
	
	  /**
	   * Instantiate a Unit from a JSON object
	   * @memberof Unit
	   * @param {Object} json  A JSON object structured as:
	   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
	   * @return {Unit}
	   */
	  Unit.fromJSON = function (json) {
	    var unit = new Unit(json.value, json.unit);
	    unit.fixPrefix = json.fixPrefix || false;
	    return unit;
	  };
	
	  /**
	   * Returns the string representation of the unit.
	   * @memberof Unit
	   * @return {string}
	   */
	  Unit.prototype.valueOf = Unit.prototype.toString;
	
	  /**
	   * Attempt to simplify the list of units for this unit according to the dimensions array and the current unit system. After the call, this Unit will contain a list of the "best" units for formatting.
	   * Intended to be evaluated lazily. You must set isUnitListSimplified = false before the call! After the call, isUnitListSimplified will be set to true.
	   */
	  Unit.prototype.simplifyUnitListLazy = function() {
	
	    if (this.isUnitListSimplified || this.value == null) {
	      return;
	    }
	
	    var proposedUnitList = [];
	
	    // Search for a matching base
	    var matchingBase;
	    for(var key in currentUnitSystem) {
	      if(this.hasBase(BASE_UNITS[key])) {
	        matchingBase = key;
	        break;
	      }
	    }
	
	    if(matchingBase === 'NONE')
	    {
	      this.units = [];
	    }
	    else {
	      var matchingUnit;
	      if(matchingBase) {
	        // Does the unit system have a matching unit?
	        if(currentUnitSystem.hasOwnProperty(matchingBase)) {
	          matchingUnit = currentUnitSystem[matchingBase];
	        }
	      }
	      var value;
	      var str;
	      if(matchingUnit) {
	        this.units = [{
	          unit: matchingUnit.unit,
	          prefix: matchingUnit.prefix,
	          power: 1.0
	        }];
	      }
	      else {
	        // Multiple units or units with powers are formatted like this:
	        // 5 (kg m^2) / (s^3 mol)
	        // Build an representation from the base units of the current unit system
	        var missingBaseDim = false;
	        for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	          var baseDim = BASE_DIMENSIONS[i];
	          if(Math.abs(this.dimensions[i] || 0) > 1e-12) {
	            if(currentUnitSystem.hasOwnProperty(baseDim)) {
	              proposedUnitList.push({
	                unit: currentUnitSystem[baseDim].unit,
	                prefix: currentUnitSystem[baseDim].prefix,
	                power: this.dimensions[i] || 0
	              });
	            }
	            else {
	              missingBaseDim = true;
	            }
	          }
	        }
	
	        // Is the proposed unit list "simpler" than the existing one?
	        if(proposedUnitList.length < this.units.length && !missingBaseDim) {
	          // Replace this unit list with the proposed list
	          this.units = proposedUnitList;
	        }
	      }
	    }
	
	    this.isUnitListSimplified = true;
	  };
	
	  Unit.prototype.toSI = function() {
	
	    var ret = this.clone();
	
	    var proposedUnitList = [];
	
	    // Multiple units or units with powers are formatted like this:
	    // 5 (kg m^2) / (s^3 mol)
	    // Build an representation from the base units of the SI unit system
	    var missingBaseDim = false;
	    for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	      var baseDim = BASE_DIMENSIONS[i];
	      if(Math.abs(ret.dimensions[i] || 0) > 1e-12) {
	        if(UNIT_SYSTEMS["si"].hasOwnProperty(baseDim)) {
	          proposedUnitList.push({
	            unit: UNIT_SYSTEMS["si"][baseDim].unit,
	            prefix: UNIT_SYSTEMS["si"][baseDim].prefix,
	            power: ret.dimensions[i] || 0
	          });
	        }
	        else {
	          throw new Error("Cannot express custom unit " + baseDim + " in SI units");
	        }
	      }
	    }
	
	    // Replace this unit list with the proposed list
	    ret.units = proposedUnitList;
	
	    ret.isUnitListSimplified = true;
	
	    return ret;
	  }
	
	  /**
	   * Get a string representation of the units of this Unit, without the value.
	   * @memberof Unit
	   * @return {string}
	   */
	  Unit.prototype.formatUnits = function () {
	
	    // Lazy evaluation of the unit list
	    this.simplifyUnitListLazy();
	
	    var strNum = "";
	    var strDen = "";
	    var nNum = 0;
	    var nDen = 0;
	
	    for(var i=0; i<this.units.length; i++) {
	      if(this.units[i].power > 0) {
	        nNum++;
	        strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
	        if(Math.abs(this.units[i].power - 1.0) > 1e-15) {
	          strNum += "^" + this.units[i].power;
	        }
	      }
	      else if(this.units[i].power < 0) {
	        nDen++;
	      }
	    }
	
	    if(nDen > 0) {
	      for(var i=0; i<this.units.length; i++) {
	        if(this.units[i].power < 0) {
	          if(nNum > 0) {
	            strDen += " " + this.units[i].prefix.name + this.units[i].unit.name;
	            if(Math.abs(this.units[i].power + 1.0) > 1e-15) {
	              strDen += "^" + (-this.units[i].power);
	            }
	          }
	          else {
	            strDen += " " + this.units[i].prefix.name + this.units[i].unit.name;
	            strDen += "^" + (this.units[i].power);
	          }
	        }
	      }
	    }
	    // Remove leading " "
	    strNum = strNum.substr(1);
	    strDen = strDen.substr(1);
	
	    // Add parans for better copy/paste back into the eval, for example, or for better pretty print formatting
	    if(nNum > 1 && nDen > 0) {
	      strNum = "(" + strNum + ")";
	    }
	    if(nDen > 1 && nNum > 0) {
	      strDen = "(" + strDen + ")";
	    }
	
	    var str = strNum;
	    if(nNum > 0 && nDen > 0) {
	      str += " / ";
	    }
	    str += strDen;
	
	    return str;
	  };
	
	  /**
	   * Get a string representation of the Unit, with optional formatting options.
	   * @memberof Unit
	   * @param {Object | number | Function} [options]  Formatting options. See
	   *                                                lib/utils/number:format for a
	   *                                                description of the available
	   *                                                options.
	   * @return {string}
	   */
	  Unit.prototype.format = function (options) {
	
	    // Simplfy the unit list, if necessary
	    this.simplifyUnitListLazy();
	
	    // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
	    var isImaginary = false;
	    var isReal = true;
	    if(typeof(this.value) !== 'undefined' && this.value !== null && type.isComplex(this.value)) {
	      // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
	      isImaginary = Math.abs(this.value.re) < 1e-14;
	      isReal = Math.abs(this.value.im) < 1e-14;
	    }
	    
	    for(var i in this.units) {
	      if(this.units[i].unit) {
	        if(this.units[i].unit.name === 'VA' && isImaginary) {
	          this.units[i].unit = UNITS["VAR"];
	        }
	        else if(this.units[i].unit.name === 'VAR' && !isImaginary) {
	          this.units[i].unit = UNITS["VA"];
	        }
	      }
	    }
	
	
	    // Now apply the best prefix
	    // Units must have only one unit and not have the fixPrefix flag set
	    if (this.units.length === 1 && !this.fixPrefix) {
	      // Units must have integer powers, otherwise the prefix will change the
	      // outputted value by not-an-integer-power-of-ten
	      if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) < 1e-14) {
	        // Apply the best prefix
	        this.units[0].prefix = this._bestPrefix();
	      }
	    }
	
	
	    var value = this._denormalize(this.value);
	    var str = (this.value !== null) ? format(value, options || {}) : '';
	    var unitStr = this.formatUnits();
	    if(this.value && type.isComplex(this.value)) {
	      str = "(" + str + ")";    // Surround complex values with ( ) to enable better parsing 
	    }
	    if(unitStr.length > 0 && str.length > 0) {
	      str += " ";
	    }
	    str += unitStr;
	
	    return str;
	  };
	
	  /**
	   * Calculate the best prefix using current value.
	   * @memberof Unit
	   * @returns {Object} prefix
	   * @private
	   */
	  Unit.prototype._bestPrefix = function () {
	    if (this.units.length !== 1) {
	      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
	    }
	    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) {
	      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
	    }
	
	    // find the best prefix value (resulting in the value of which
	    // the absolute value of the log10 is closest to zero,
	    // though with a little offset of 1.2 for nicer values: you get a
	    // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
	
	    // Note: the units value can be any numeric type, but to find the best
	    // prefix it's enough to work with limited precision of a regular number
	    // Update: using mathjs abs since we also allow complex numbers
	    var absValue = this.value !== null ? abs(this.value) : 0;
	    var absUnitValue = abs(this.units[0].unit.value);
	    var bestPrefix = this.units[0].prefix;
	    if (absValue === 0) {
	      return bestPrefix;
	    }
	    var power = this.units[0].power;
	    var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
	    if(bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix;    // Allow the original prefix
	    bestDiff = Math.abs(bestDiff);
	    var prefixes = this.units[0].unit.prefixes;
	    for (var p in prefixes) {
	      if (prefixes.hasOwnProperty(p)) {
	        var prefix = prefixes[p];
	        if (prefix.scientific) {
	
	          var diff = Math.abs(
	              Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
	
	          if (diff < bestDiff
	              || (diff === bestDiff && prefix.name.length < bestPrefix.name.length)) {
	                // choose the prefix with the smallest diff, or if equal, choose the one
	                // with the shortest name (can happen with SHORTLONG for example)
	                bestPrefix = prefix;
	                bestDiff = diff;
	          }
	        }
	      }
	    }
	
	    return bestPrefix;
	  };
	
	  /**
	   * Returns an array of units whose sum is equal to this unit
	   * @memberof Unit
	   * @param {Array} [parts] An array of strings or valueless units. 
	   *
	   *   Example:
	   *
	   *   var u = new Unit(1, 'm');
	   *   u.splitUnit(['feet', 'inch']);
	   *     [ 3 feet, 3.3700787401575 inch ]
	   *
	   * @return {Array} An array of units.
	   */
	  Unit.prototype.splitUnit = function(parts) {
	
	    var x = this.clone();
	    var ret = [];
	    for(var i=0; i<parts.length; i++) {
	      // Convert x to the requested unit
	      x = x.to(parts[i]);
	      if(i==parts.length-1) break;
	
	      // Get the numeric value of this unit
	      var xNumeric = x.toNumeric();
	
	      // Check to see if xNumeric is nearly equal to an integer,
	      // since fix can incorrectly round down if there is round-off error
	      var xRounded = round(xNumeric);
	      var xFixed;
	      var isNearlyEqual = equal(xRounded, xNumeric);
	      if (isNearlyEqual) {
	        xFixed = xRounded;
	      }
	      else {
	        xFixed = fix(x.toNumeric());
	      }
	
	      var y = new Unit(xFixed, parts[i].toString());
	      ret.push(y);
	      x = subtract(x, y);
	    }
	
	    // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
	    // But instead of comparing x, the remainder, with zero--we will compare the sum of
	    // all the parts so far with the original value. If they are nearly equal,
	    // we set the remainder to 0.
	    var testSum = 0;
	    for(var i=0; i<ret.length; i++) {
	      testSum = add(testSum, ret[i].value);
	    }
	    if(equal(testSum, this.value)) {
	      x.value = 0;
	    }
	
	    ret.push(x);
	
	    return ret;
	  };
	
	  var PREFIXES = {
	    NONE: {
	      '': {name: '', value: 1, scientific: true}
	    },
	    SHORT: {
	      '': {name: '', value: 1, scientific: true},
	
	      'da': {name: 'da', value: 1e1, scientific: false},
	      'h': {name: 'h', value: 1e2, scientific: false},
	      'k': {name: 'k', value: 1e3, scientific: true},
	      'M': {name: 'M', value: 1e6, scientific: true},
	      'G': {name: 'G', value: 1e9, scientific: true},
	      'T': {name: 'T', value: 1e12, scientific: true},
	      'P': {name: 'P', value: 1e15, scientific: true},
	      'E': {name: 'E', value: 1e18, scientific: true},
	      'Z': {name: 'Z', value: 1e21, scientific: true},
	      'Y': {name: 'Y', value: 1e24, scientific: true},
	
	      'd': {name: 'd', value: 1e-1, scientific: false},
	      'c': {name: 'c', value: 1e-2, scientific: false},
	      'm': {name: 'm', value: 1e-3, scientific: true},
	      'u': {name: 'u', value: 1e-6, scientific: true},
	      'n': {name: 'n', value: 1e-9, scientific: true},
	      'p': {name: 'p', value: 1e-12, scientific: true},
	      'f': {name: 'f', value: 1e-15, scientific: true},
	      'a': {name: 'a', value: 1e-18, scientific: true},
	      'z': {name: 'z', value: 1e-21, scientific: true},
	      'y': {name: 'y', value: 1e-24, scientific: true}
	    },
	    LONG: {
	      '': {name: '', value: 1, scientific: true},
	
	      'deca': {name: 'deca', value: 1e1, scientific: false},
	      'hecto': {name: 'hecto', value: 1e2, scientific: false},
	      'kilo': {name: 'kilo', value: 1e3, scientific: true},
	      'mega': {name: 'mega', value: 1e6, scientific: true},
	      'giga': {name: 'giga', value: 1e9, scientific: true},
	      'tera': {name: 'tera', value: 1e12, scientific: true},
	      'peta': {name: 'peta', value: 1e15, scientific: true},
	      'exa': {name: 'exa', value: 1e18, scientific: true},
	      'zetta': {name: 'zetta', value: 1e21, scientific: true},
	      'yotta': {name: 'yotta', value: 1e24, scientific: true},
	
	      'deci': {name: 'deci', value: 1e-1, scientific: false},
	      'centi': {name: 'centi', value: 1e-2, scientific: false},
	      'milli': {name: 'milli', value: 1e-3, scientific: true},
	      'micro': {name: 'micro', value: 1e-6, scientific: true},
	      'nano': {name: 'nano', value: 1e-9, scientific: true},
	      'pico': {name: 'pico', value: 1e-12, scientific: true},
	      'femto': {name: 'femto', value: 1e-15, scientific: true},
	      'atto': {name: 'atto', value: 1e-18, scientific: true},
	      'zepto': {name: 'zepto', value: 1e-21, scientific: true},
	      'yocto': {name: 'yocto', value: 1e-24, scientific: true}
	    },
	    SQUARED: {
	      '': {name: '', value: 1, scientific: true},
	
	      'da': {name: 'da', value: 1e2, scientific: false},
	      'h': {name: 'h', value: 1e4, scientific: false},
	      'k': {name: 'k', value: 1e6, scientific: true},
	      'M': {name: 'M', value: 1e12, scientific: true},
	      'G': {name: 'G', value: 1e18, scientific: true},
	      'T': {name: 'T', value: 1e24, scientific: true},
	      'P': {name: 'P', value: 1e30, scientific: true},
	      'E': {name: 'E', value: 1e36, scientific: true},
	      'Z': {name: 'Z', value: 1e42, scientific: true},
	      'Y': {name: 'Y', value: 1e48, scientific: true},
	
	      'd': {name: 'd', value: 1e-2, scientific: false},
	      'c': {name: 'c', value: 1e-4, scientific: false},
	      'm': {name: 'm', value: 1e-6, scientific: true},
	      'u': {name: 'u', value: 1e-12, scientific: true},
	      'n': {name: 'n', value: 1e-18, scientific: true},
	      'p': {name: 'p', value: 1e-24, scientific: true},
	      'f': {name: 'f', value: 1e-30, scientific: true},
	      'a': {name: 'a', value: 1e-36, scientific: true},
	      'z': {name: 'z', value: 1e-42, scientific: true},
	      'y': {name: 'y', value: 1e-48, scientific: true}
	    },
	    CUBIC: {
	      '': {name: '', value: 1, scientific: true},
	
	      'da': {name: 'da', value: 1e3, scientific: false},
	      'h': {name: 'h', value: 1e6, scientific: false},
	      'k': {name: 'k', value: 1e9, scientific: true},
	      'M': {name: 'M', value: 1e18, scientific: true},
	      'G': {name: 'G', value: 1e27, scientific: true},
	      'T': {name: 'T', value: 1e36, scientific: true},
	      'P': {name: 'P', value: 1e45, scientific: true},
	      'E': {name: 'E', value: 1e54, scientific: true},
	      'Z': {name: 'Z', value: 1e63, scientific: true},
	      'Y': {name: 'Y', value: 1e72, scientific: true},
	
	      'd': {name: 'd', value: 1e-3, scientific: false},
	      'c': {name: 'c', value: 1e-6, scientific: false},
	      'm': {name: 'm', value: 1e-9, scientific: true},
	      'u': {name: 'u', value: 1e-18, scientific: true},
	      'n': {name: 'n', value: 1e-27, scientific: true},
	      'p': {name: 'p', value: 1e-36, scientific: true},
	      'f': {name: 'f', value: 1e-45, scientific: true},
	      'a': {name: 'a', value: 1e-54, scientific: true},
	      'z': {name: 'z', value: 1e-63, scientific: true},
	      'y': {name: 'y', value: 1e-72, scientific: true}
	    },
	    BINARY_SHORT: {
	      '': {name: '', value: 1, scientific: true},
	      'k': {name: 'k', value: 1e3, scientific: true},
	      'M': {name: 'M', value: 1e6, scientific: true},
	      'G': {name: 'G', value: 1e9, scientific: true},
	      'T': {name: 'T', value: 1e12, scientific: true},
	      'P': {name: 'P', value: 1e15, scientific: true},
	      'E': {name: 'E', value: 1e18, scientific: true},
	      'Z': {name: 'Z', value: 1e21, scientific: true},
	      'Y': {name: 'Y', value: 1e24, scientific: true},
	
	      'Ki': {name: 'Ki', value: 1024, scientific: true},
	      'Mi': {name: 'Mi', value: Math.pow(1024, 2), scientific: true},
	      'Gi': {name: 'Gi', value: Math.pow(1024, 3), scientific: true},
	      'Ti': {name: 'Ti', value: Math.pow(1024, 4), scientific: true},
	      'Pi': {name: 'Pi', value: Math.pow(1024, 5), scientific: true},
	      'Ei': {name: 'Ei', value: Math.pow(1024, 6), scientific: true},
	      'Zi': {name: 'Zi', value: Math.pow(1024, 7), scientific: true},
	      'Yi': {name: 'Yi', value: Math.pow(1024, 8), scientific: true}
	    },
	    BINARY_LONG: {
	      '': {name: '', value: 1, scientific: true},
	      'kilo': {name: 'kilo', value: 1e3, scientific: true},
	      'mega': {name: 'mega', value: 1e6, scientific: true},
	      'giga': {name: 'giga', value: 1e9, scientific: true},
	      'tera': {name: 'tera', value: 1e12, scientific: true},
	      'peta': {name: 'peta', value: 1e15, scientific: true},
	      'exa': {name: 'exa', value: 1e18, scientific: true},
	      'zetta': {name: 'zetta', value: 1e21, scientific: true},
	      'yotta': {name: 'yotta', value: 1e24, scientific: true},
	
	      'kibi': {name: 'kibi', value: 1024, scientific: true},
	      'mebi': {name: 'mebi', value: Math.pow(1024, 2), scientific: true},
	      'gibi': {name: 'gibi', value: Math.pow(1024, 3), scientific: true},
	      'tebi': {name: 'tebi', value: Math.pow(1024, 4), scientific: true},
	      'pebi': {name: 'pebi', value: Math.pow(1024, 5), scientific: true},
	      'exi': {name: 'exi', value: Math.pow(1024, 6), scientific: true},
	      'zebi': {name: 'zebi', value: Math.pow(1024, 7), scientific: true},
	      'yobi': {name: 'yobi', value: Math.pow(1024, 8), scientific: true}
	    },
	    BTU: {
	      '':   {name: '',   value: 1,   scientific: true},
	      'MM': {name: 'MM', value: 1e6, scientific: true}
	    }
	  };
	
	  // Add a prefix list for both short and long prefixes (for example for ohm and bar which support both Mohm and megaohm, mbar and millibar):
	  PREFIXES.SHORTLONG = {};
	  for (var key in PREFIXES.SHORT) {
	    if(PREFIXES.SHORT.hasOwnProperty(key)) {
	      PREFIXES.SHORTLONG[key] = PREFIXES.SHORT[key];
	    }
	  }
	  for (var key in PREFIXES.LONG) {
	    if(PREFIXES.LONG.hasOwnProperty(key)) {
	      PREFIXES.SHORTLONG[key] = PREFIXES.LONG[key];
	    }
	  }
	
	  /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
	   * Index  Dimension
	   * -----  ---------
	   *   0    Length
	   *   1    Mass
	   *   2    Time
	   *   3    Current
	   *   4    Temperature
	   *   5    Luminous intensity
	   *   6    Amount of substance
	   *   7    Angle
	   *   8    Bit (digital)
	   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
	   *
	   */
	
	  var BASE_DIMENSIONS = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"];
	
	  var BASE_UNITS = {
	    NONE: {
	      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
	    },
	    MASS: {
	      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
	    },
	    LENGTH: {
	      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
	    },
	    TIME: {
	      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
	    },
	    CURRENT: {
	      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
	    },
	    TEMPERATURE: {
	      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
	    },
	    LUMINOUS_INTENSITY: {
	      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
	    },
	    AMOUNT_OF_SUBSTANCE: {
	      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
	    },
	
	    FORCE: {
	      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
	    },
	    SURFACE: {
	      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
	    },
	    VOLUME: {
	      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
	    },
	    ENERGY: {
	      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
	    },
	    POWER: {
	      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
	    },
	    PRESSURE: {
	      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
	    },
	
	    ELECTRIC_CHARGE: {
	      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
	    },
	    ELECTRIC_CAPACITANCE: {
	      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
	    },
	    ELECTRIC_POTENTIAL: {
	      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
	    },
	    ELECTRIC_RESISTANCE: {
	      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
	    },
	    ELECTRIC_INDUCTANCE: {
	      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
	    },
	    ELECTRIC_CONDUCTANCE: {
	      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
	    },
	    MAGNETIC_FLUX: {
	      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
	    },
	    MAGNETIC_FLUX_DENSITY: {
	      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
	    },
	
	    FREQUENCY: {
	      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
	    },
	    ANGLE: {
	      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
	    },
	    BIT: {
	      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
	    }
	  };
	
	  for(var key in BASE_UNITS) {
	    BASE_UNITS[key].key = key;
	  }
	
	  var BASE_UNIT_NONE = {};
	
	  var UNIT_NONE = {name: '', base: BASE_UNIT_NONE, value: 1, offset: 0, dimensions: [0,0,0,0,0,0,0,0,0]};
	
	  var UNITS = {
	    // length
	    meter: {
	      name: 'meter',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    inch: {
	      name: 'inch',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.0254,
	      offset: 0
	    },
	    foot: {
	      name: 'foot',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.3048,
	      offset: 0
	    },
	    yard: {
	      name: 'yard',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.9144,
	      offset: 0
	    },
	    mile: {
	      name: 'mile',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 1609.344,
	      offset: 0
	    },
	    link: {
	      name: 'link',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.201168,
	      offset: 0
	    },
	    rod: {
	      name: 'rod',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 5.029210,
	      offset: 0
	    },
	    chain: {
	      name: 'chain',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 20.1168,
	      offset: 0
	    },
	    angstrom: {
	      name: 'angstrom',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 1e-10,
	      offset: 0
	    },
	
	    m: {
	      name: 'm',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    'in': {
	      name: 'in',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.0254,
	      offset: 0
	    },
	    ft: {
	      name: 'ft',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.3048,
	      offset: 0
	    },
	    yd: {
	      name: 'yd',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.9144,
	      offset: 0
	    },
	    mi: {
	      name: 'mi',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 1609.344,
	      offset: 0
	    },
	    li: {
	      name: 'li',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.201168,
	      offset: 0
	    },
	    rd: {
	      name: 'rd',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 5.029210,
	      offset: 0
	    },
	    ch: {
	      name: 'ch',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 20.1168,
	      offset: 0
	    },
	    mil: {
	      name: 'mil',
	      base: BASE_UNITS.LENGTH,
	      prefixes: PREFIXES.NONE,
	      value: 0.0000254,
	      offset: 0
	    }, // 1/1000 inch
	
	    // Surface
	    m2: {
	      name: 'm2',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.SQUARED,
	      value: 1,
	      offset: 0
	    },
	    sqin: {
	      name: 'sqin',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 0.00064516,
	      offset: 0
	    }, // 645.16 mm2
	    sqft: {
	      name: 'sqft',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 0.09290304,
	      offset: 0
	    }, // 0.09290304 m2
	    sqyd: {
	      name: 'sqyd',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 0.83612736,
	      offset: 0
	    }, // 0.83612736 m2
	    sqmi: {
	      name: 'sqmi',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 2589988.110336,
	      offset: 0
	    }, // 2.589988110336 km2
	    sqrd: {
	      name: 'sqrd',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 25.29295,
	      offset: 0
	    }, // 25.29295 m2
	    sqch: {
	      name: 'sqch',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 404.6873,
	      offset: 0
	    }, // 404.6873 m2
	    sqmil: {
	      name: 'sqmil',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 6.4516e-10,
	      offset: 0
	    }, // 6.4516 * 10^-10 m2
	    acre: {
	      name: 'acre',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 4046.86,
	      offset: 0
	    }, // 4046.86 m2
	    hectare: {
	      name: 'hectare',
	      base: BASE_UNITS.SURFACE,
	      prefixes: PREFIXES.NONE,
	      value: 10000,
	      offset: 0
	    }, // 10000 m2
	
	    // Volume
	    m3: {
	      name: 'm3',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.CUBIC,
	      value: 1,
	      offset: 0
	    },
	    L: {
	      name: 'L',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.SHORT,
	      value: 0.001,
	      offset: 0
	    }, // litre
	    l: {
	      name: 'l',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.SHORT,
	      value: 0.001,
	      offset: 0
	    }, // litre
	    litre: {
	      name: 'litre',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.LONG,
	      value: 0.001,
	      offset: 0
	    },
	    cuin: {
	      name: 'cuin',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 1.6387064e-5,
	      offset: 0
	    }, // 1.6387064e-5 m3
	    cuft: {
	      name: 'cuft',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.028316846592,
	      offset: 0
	    }, // 28.316 846 592 L
	    cuyd: {
	      name: 'cuyd',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.764554857984,
	      offset: 0
	    }, // 764.554 857 984 L
	    teaspoon: {
	      name: 'teaspoon',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.000005,
	      offset: 0
	    }, // 5 mL
	    tablespoon: {
	      name: 'tablespoon',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.000015,
	      offset: 0
	    }, // 15 mL
	    //{name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
	    drop: {
	      name: 'drop',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 5e-8,
	      offset: 0
	    },  // 0.05 mL = 5e-8 m3
	    gtt: {
	      name: 'gtt',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 5e-8,
	      offset: 0
	    },  // 0.05 mL = 5e-8 m3
	
	    // Liquid volume
	    minim: {
	      name: 'minim',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.00000006161152,
	      offset: 0
	    }, // 0.06161152 mL
	    fluiddram: {
	      name: 'fluiddram',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0000036966911,
	      offset: 0
	    },  // 3.696691 mL
	    fluidounce: {
	      name: 'fluidounce',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.00002957353,
	      offset: 0
	    }, // 29.57353 mL
	    gill: {
	      name: 'gill',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0001182941,
	      offset: 0
	    }, // 118.2941 mL
	    cc: {
	      name: 'cc',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 1e-6,
	      offset: 0
	    }, // 1e-6 L
	    cup: {
	      name: 'cup',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0002365882,
	      offset: 0
	    }, // 236.5882 mL
	    pint: {
	      name: 'pint',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0004731765,
	      offset: 0
	    }, // 473.1765 mL
	    quart: {
	      name: 'quart',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0009463529,
	      offset: 0
	    }, // 946.3529 mL
	    gallon: {
	      name: 'gallon',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.003785412,
	      offset: 0
	    }, // 3.785412 L
	    beerbarrel: {
	      name: 'beerbarrel',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.1173478,
	      offset: 0
	    }, // 117.3478 L
	    oilbarrel: {
	      name: 'oilbarrel',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.1589873,
	      offset: 0
	    }, // 158.9873 L
	    hogshead: {
	      name: 'hogshead',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.2384810,
	      offset: 0
	    }, // 238.4810 L
	
	    //{name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
	    fldr: {
	      name: 'fldr',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0000036966911,
	      offset: 0
	    },  // 3.696691 mL
	    floz: {
	      name: 'floz',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.00002957353,
	      offset: 0
	    }, // 29.57353 mL
	    gi: {
	      name: 'gi',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0001182941,
	      offset: 0
	    }, // 118.2941 mL
	    cp: {
	      name: 'cp',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0002365882,
	      offset: 0
	    }, // 236.5882 mL
	    pt: {
	      name: 'pt',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0004731765,
	      offset: 0
	    }, // 473.1765 mL
	    qt: {
	      name: 'qt',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.0009463529,
	      offset: 0
	    }, // 946.3529 mL
	    gal: {
	      name: 'gal',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.003785412,
	      offset: 0
	    }, // 3.785412 L
	    bbl: {
	      name: 'bbl',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.1173478,
	      offset: 0
	    }, // 117.3478 L
	    obl: {
	      name: 'obl',
	      base: BASE_UNITS.VOLUME,
	      prefixes: PREFIXES.NONE,
	      value: 0.1589873,
	      offset: 0
	    }, // 158.9873 L
	    //{name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
	
	    // Mass
	    g: {
	      name: 'g',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.SHORT,
	      value: 0.001,
	      offset: 0
	    },
	    gram: {
	      name: 'gram',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.LONG,
	      value: 0.001,
	      offset: 0
	    },
	
	    ton: {
	      name: 'ton',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.SHORT,
	      value: 907.18474,
	      offset: 0
	    },
	    tonne: {
	      name: 'tonne',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.SHORT,
	      value: 1000,
	      offset: 0
	    },
	
	    grain: {
	      name: 'grain',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 64.79891e-6,
	      offset: 0
	    },
	    dram: {
	      name: 'dram',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 1.7718451953125e-3,
	      offset: 0
	    },
	    ounce: {
	      name: 'ounce',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 28.349523125e-3,
	      offset: 0
	    },
	    poundmass: {
	      name: 'poundmass',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 453.59237e-3,
	      offset: 0
	    },
	    hundredweight: {
	      name: 'hundredweight',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 45.359237,
	      offset: 0
	    },
	    stick: {
	      name: 'stick',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 115e-3,
	      offset: 0
	    },
	    stone: {
	      name: 'stone',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 6.35029318,
	      offset: 0
	    },
	
	    gr: {
	      name: 'gr',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 64.79891e-6,
	      offset: 0
	    },
	    dr: {
	      name: 'dr',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 1.7718451953125e-3,
	      offset: 0
	    },
	    oz: {
	      name: 'oz',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 28.349523125e-3,
	      offset: 0
	    },
	    lbm: {
	      name: 'lbm',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 453.59237e-3,
	      offset: 0
	    },
	    cwt: {
	      name: 'cwt',
	      base: BASE_UNITS.MASS,
	      prefixes: PREFIXES.NONE,
	      value: 45.359237,
	      offset: 0
	    },
	
	    // Time
	    s: {
	      name: 's',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    min: {
	      name: 'min',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 60,
	      offset: 0
	    },
	    h: {
	      name: 'h',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 3600,
	      offset: 0
	    },
	    second: {
	      name: 'second',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    sec: {
	      name: 'sec',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    minute: {
	      name: 'minute',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 60,
	      offset: 0
	    },
	    hour: {
	      name: 'hour',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 3600,
	      offset: 0
	    },
	    day: {
	      name: 'day',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 86400,
	      offset: 0
	    },
	    week: {
	      name: 'week',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 7*86400,
	      offset: 0
	    },
	    month: {
	      name: 'month',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 2629800, //1/12th of Julian year
	      offset: 0
	    },
	    year: {
	      name: 'year',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 31557600, //Julian year
	      offset: 0
	    },
	    decade: {
	      name: 'decade',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 315576000, //Julian decade
	      offset: 0
	    },
	    century: {
	      name: 'century',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 3155760000, //Julian century
	      offset: 0
	    },
	    millennium: {
	      name: 'millennium',
	      base: BASE_UNITS.TIME,
	      prefixes: PREFIXES.NONE,
	      value: 31557600000, //Julian millennium
	      offset: 0
	    },
	
	    // Frequency
	    hertz: {
	      name: 'Hertz',
	      base: BASE_UNITS.FREQUENCY,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0,
	      reciprocal: true
	    },
	    Hz: {
	      name: 'Hz',
	      base: BASE_UNITS.FREQUENCY,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0,
	      reciprocal: true
	    },
	
	    // Angle
	    rad: {
	      name: 'rad',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    radian: {
	      name: 'radian',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
	    deg: {
	      name: 'deg',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.SHORT,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    degree: {
	      name: 'degree',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.LONG,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
	    grad: {
	      name: 'grad',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.SHORT,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    gradian: {
	      name: 'gradian',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.LONG,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
	    cycle: {
	      name: 'cycle',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.NONE,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
	    arcsec: {
	      name: 'arcsec',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.NONE,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
	    arcmin: {
	      name: 'arcmin',
	      base: BASE_UNITS.ANGLE,
	      prefixes: PREFIXES.NONE,
	      value: null, // will be filled in by calculateAngleValues()
	      offset: 0
	    },
	    
	    // Electric current
	    A: {
	      name: 'A',
	      base: BASE_UNITS.CURRENT,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    ampere: {
	      name: 'ampere',
	      base: BASE_UNITS.CURRENT,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	
	    // Temperature
	    // K(C) = °C + 273.15
	    // K(F) = (°F + 459.67) / 1.8
	    // K(R) = °R / 1.8
	    K: {
	      name: 'K',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 0
	    },
	    degC: {
	      name: 'degC',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 273.15
	    },
	    degF: {
	      name: 'degF',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1 / 1.8,
	      offset: 459.67
	    },
	    degR: {
	      name: 'degR',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1 / 1.8,
	      offset: 0
	    },
	    kelvin: {
	      name: 'kelvin',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 0
	    },
	    celsius: {
	      name: 'celsius',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 273.15
	    },
	    fahrenheit: {
	      name: 'fahrenheit',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1 / 1.8,
	      offset: 459.67
	    },
	    rankine: {
	      name: 'rankine',
	      base: BASE_UNITS.TEMPERATURE,
	      prefixes: PREFIXES.NONE,
	      value: 1 / 1.8,
	      offset: 0
	    },
	
	    // amount of substance
	    mol: {
	      name: 'mol',
	      base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    mole: {
	      name: 'mole',
	      base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	
	    // luminous intensity
	    cd: {
	      name: 'cd',
	      base: BASE_UNITS.LUMINOUS_INTENSITY,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 0
	    },
	    candela: {
	      name: 'candela',
	      base: BASE_UNITS.LUMINOUS_INTENSITY,
	      prefixes: PREFIXES.NONE,
	      value: 1,
	      offset: 0
	    },
	    // TODO: units STERADIAN
	    //{name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
	    //{name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
	
	    // Force
	    N: {
	      name: 'N',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    newton: {
	      name: 'newton',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    dyn: {
	      name: 'dyn',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.SHORT,
	      value: 0.00001,
	      offset: 0
	    },
	    dyne: {
	      name: 'dyne',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.LONG,
	      value: 0.00001,
	      offset: 0
	    },
	    lbf: {
	      name: 'lbf',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.NONE,
	      value: 4.4482216152605,
	      offset: 0
	    },
	    poundforce: {
	      name: 'poundforce',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.NONE,
	      value: 4.4482216152605,
	      offset: 0
	    },
	    kip: {
	      name: 'kip',
	      base: BASE_UNITS.FORCE,
	      prefixes: PREFIXES.LONG,
	      value: 4448.2216,
	      offset: 0
	    },
		
	    // Energy
	    J: {
	      name: 'J',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    joule: {
	      name: 'joule',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    erg: {
	      name: 'erg',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.NONE,
	      value: 1e-7,
	      offset: 0
	    },
	    Wh: {
	      name: 'Wh',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.SHORT,
	      value: 3600,
	      offset: 0
	    },
	    BTU: {
	      name: 'BTU',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.BTU,
	      value: 1055.05585262,
	      offset: 0
	    },
	    eV: {
	      name: 'eV',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.SHORT,
	      value: 1.602176565e-19,
	      offset: 0
	    },
	    electronvolt: {
	      name: 'electronvolt',
	      base: BASE_UNITS.ENERGY,
	      prefixes: PREFIXES.LONG,
	      value: 1.602176565e-19,
	      offset: 0
	    },
	
	
	    // Power
	    W: {
	      name: 'W',
	      base: BASE_UNITS.POWER,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    watt: {
	      name: 'watt',
	      base: BASE_UNITS.POWER,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    hp: {
	      name: 'hp',
	      base: BASE_UNITS.POWER,
	      prefixes: PREFIXES.NONE,
	      value: 745.6998715386,
	      offset: 0
	    },
	
	    // Electrical power units
	    VAR: {
	      name: 'VAR',
	      base: BASE_UNITS.POWER,
	      prefixes: PREFIXES.SHORT,
	      value: Complex.I,
	      offset: 0
	    },
	    
	    VA: {
	      name: 'VA',
	      base: BASE_UNITS.POWER,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	
	    // Pressure
	    Pa: {
	      name: 'Pa',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    psi: {
	      name: 'psi',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 6894.75729276459,
	      offset: 0
	    },
	    atm: {
	      name: 'atm',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 101325,
	      offset: 0
	    },
	    bar: {
	      name: 'bar',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.SHORTLONG,
	      value: 100000,
	      offset: 0
	    },
	    torr: {
	      name: 'torr',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 133.322,
	      offset: 0
	    },
	    mmHg: {
	      name: 'mmHg',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 133.322,
	      offset: 0
	    },
	    mmH2O: {
	      name: 'mmH2O',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 9.80665,
	      offset: 0
	    },
	    cmH2O: {
	      name: 'cmH2O',
	      base: BASE_UNITS.PRESSURE,
	      prefixes: PREFIXES.NONE,
	      value: 98.0665,
	      offset: 0
	    },
	
	    // Electric charge
	    coulomb: {
	      name: 'coulomb',
	      base: BASE_UNITS.ELECTRIC_CHARGE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    C: {
	      name: 'C',
	      base: BASE_UNITS.ELECTRIC_CHARGE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Electric capacitance
	    farad: {
	      name: 'farad',
	      base: BASE_UNITS.ELECTRIC_CAPACITANCE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    F: {
	      name: 'F',
	      base: BASE_UNITS.ELECTRIC_CAPACITANCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Electric potential
	    volt: {
	      name: 'volt',
	      base: BASE_UNITS.ELECTRIC_POTENTIAL,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    V: {
	      name: 'V',
	      base: BASE_UNITS.ELECTRIC_POTENTIAL,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Electric resistance
	    ohm: {
	      name: 'ohm',
	      base: BASE_UNITS.ELECTRIC_RESISTANCE,
	      prefixes: PREFIXES.SHORTLONG,    // Both Mohm and megaohm are acceptable
	      value: 1,
	      offset: 0
	    },
	    /*
	     * Unicode breaks in browsers if charset is not specified
	    Ω: {
	      name: 'Ω',
	      base: BASE_UNITS.ELECTRIC_RESISTANCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    */
	    // Electric inductance
	    henry: {
	      name: 'henry',
	      base: BASE_UNITS.ELECTRIC_INDUCTANCE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    H: {
	      name: 'H',
	      base: BASE_UNITS.ELECTRIC_INDUCTANCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Electric conductance
	    siemens: {
	      name: 'siemens',
	      base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    S: {
	      name: 'S',
	      base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Magnetic flux
	    weber: {
	      name: 'weber',
	      base: BASE_UNITS.MAGNETIC_FLUX,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    Wb: {
	      name: 'Wb',
	      base: BASE_UNITS.MAGNETIC_FLUX,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	    // Magnetic flux density
	    tesla: {
	      name: 'tesla',
	      base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
	      prefixes: PREFIXES.LONG,
	      value: 1,
	      offset: 0
	    },
	    T: {
	      name: 'T',
	      base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
	      prefixes: PREFIXES.SHORT,
	      value: 1,
	      offset: 0
	    },
	
	    // Binary
	    b: {
	      name: 'b',
	      base: BASE_UNITS.BIT,
	      prefixes: PREFIXES.BINARY_SHORT,
	      value: 1,
	      offset: 0
	    },
	    bits: {
	      name: 'bits',
	      base: BASE_UNITS.BIT,
	      prefixes: PREFIXES.BINARY_LONG,
	      value: 1,
	      offset: 0
	    },
	    B: {
	      name: 'B',
	      base: BASE_UNITS.BIT,
	      prefixes: PREFIXES.BINARY_SHORT,
	      value: 8,
	      offset: 0
	    },
	    bytes: {
	      name: 'bytes',
	      base: BASE_UNITS.BIT,
	      prefixes: PREFIXES.BINARY_LONG,
	      value: 8,
	      offset: 0
	    }
	  };
	
	  // aliases (formerly plurals)
	  var ALIASES = {
	    meters: 'meter',
	    inches: 'inch',
	    feet: 'foot',
	    yards: 'yard',
	    miles: 'mile',
	    links: 'link',
	    rods: 'rod',
	    chains: 'chain',
	    angstroms: 'angstrom',
	
	    lt: 'l',
	    litres: 'litre',
	    liter: 'litre',
	    liters: 'litre',
	    teaspoons: 'teaspoon',
	    tablespoons: 'tablespoon',
	    minims: 'minim',
	    fluiddrams: 'fluiddram',
	    fluidounces: 'fluidounce',
	    gills: 'gill',
	    cups: 'cup',
	    pints: 'pint',
	    quarts: 'quart',
	    gallons: 'gallon',
	    beerbarrels: 'beerbarrel',
	    oilbarrels: 'oilbarrel',
	    hogsheads: 'hogshead',
	    gtts: 'gtt',
	
	    grams: 'gram',
	    tons: 'ton',
	    tonnes: 'tonne',
	    grains: 'grain',
	    drams: 'dram',
	    ounces: 'ounce',
	    poundmasses: 'poundmass',
	    hundredweights: 'hundredweight',
	    sticks: 'stick',
	    lb: 'lbm',
	    lbs: 'lbm',
		
	    kips: 'kip',
	
	    acres: 'acre',
	    hectares: 'hectare',
	    sqfeet: 'sqft',
	    sqyard: 'sqyd',
	    sqmile: 'sqmi',
	    sqmiles: 'sqmi',
	
	    mmhg: 'mmHg',
	    mmh2o: 'mmH2O',
	    cmh2o: 'cmH2O',
	
	    seconds: 'second',
	    secs: 'second',
	    minutes: 'minute',
	    mins: 'minute',
	    hours: 'hour',
	    hr: 'hour',
	    hrs: 'hour',
	    days: 'day',
	    weeks: 'week',
	    months: 'month',
	    years: 'year',
	    decades: 'decade',
	    centuries: 'century',
	    millennia: 'millennium',
	
	    hertz: 'hertz',
	
	    radians: 'radian',
	    degrees: 'degree',
	    gradians: 'gradian',
	    cycles: 'cycle',
	    arcsecond: 'arcsec',
	    arcseconds: 'arcsec',
	    arcminute: 'arcmin',
	    arcminutes: 'arcmin',
	
	    BTUs: 'BTU',
	    watts: 'watt',
	    joules: 'joule',
	
	    amperes: 'ampere',
	    coulombs: 'coulomb',
	    volts: 'volt',
	    ohms: 'ohm',
	    farads: 'farad',
	    webers: 'weber',
	    teslas: 'tesla',
	    electronvolts: 'electronvolt',
	    moles: 'mole'
	
	  };
	
	  /**
	   * Calculate the values for the angle units.
	   * Value is calculated as number or BigNumber depending on the configuration
	   * @param {{number: 'number' | 'BigNumber'}} config
	   */
	  function calculateAngleValues (config) {
	    if (config.number === 'BigNumber') {
	      var pi = constants.pi(type.BigNumber);
	      UNITS.rad.value = new type.BigNumber(1);
	      UNITS.deg.value = pi.div(180);        // 2 * pi / 360;
	      UNITS.grad.value = pi.div(200);       // 2 * pi / 400;
	      UNITS.cycle.value = pi.times(2);      // 2 * pi
	      UNITS.arcsec.value = pi.div(648000);  // 2 * pi / 360 / 3600
	      UNITS.arcmin.value = pi.div(10800);   // 2 * pi / 360 / 60
	    }
	    else { // number
	      UNITS.rad.value = 1;
	      UNITS.deg.value = Math.PI / 180;        // 2 * pi / 360;
	      UNITS.grad.value = Math.PI / 200;       // 2 * pi / 400;
	      UNITS.cycle.value = Math.PI * 2;        // 2 * pi
	      UNITS.arcsec.value = Math.PI / 648000;  // 2 * pi / 360 / 3600;
	      UNITS.arcmin.value = Math.PI / 10800;   // 2 * pi / 360 / 60;
	    }
	
	    // copy to the full names of the angles
	    UNITS.radian.value = UNITS.rad.value;
	    UNITS.degree.value = UNITS.deg.value;
	    UNITS.gradian.value = UNITS.grad.value;
	  }
	
	  // apply the angle values now
	  calculateAngleValues(config);
	
	  // recalculate the values on change of configuration
	  math.on('config', function (curr, prev) {
	    if (curr.number !== prev.number) {
	      calculateAngleValues(curr);
	    }
	  });
	
	  /**
	   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
	   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
	   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
	   */
	  var UNIT_SYSTEMS = {
	    si: {
	      // Base units
	      NONE:                  {unit: UNIT_NONE, prefix: PREFIXES.NONE['']},
	      LENGTH:                {unit: UNITS.m,   prefix: PREFIXES.SHORT['']},
	      MASS:                  {unit: UNITS.g,   prefix: PREFIXES.SHORT['k']}, 
	      TIME:                  {unit: UNITS.s,   prefix: PREFIXES.SHORT['']}, 
	      CURRENT:               {unit: UNITS.A,   prefix: PREFIXES.SHORT['']}, 
	      TEMPERATURE:           {unit: UNITS.K,   prefix: PREFIXES.SHORT['']}, 
	      LUMINOUS_INTENSITY:    {unit: UNITS.cd,  prefix: PREFIXES.SHORT['']}, 
	      AMOUNT_OF_SUBSTANCE:   {unit: UNITS.mol, prefix: PREFIXES.SHORT['']}, 
	      ANGLE:                 {unit: UNITS.rad, prefix: PREFIXES.SHORT['']}, 
	      BIT:                   {unit: UNITS.bit, prefix: PREFIXES.SHORT['']}, 
	
	      // Derived units
	      FORCE:                 {unit: UNITS.N,   prefix: PREFIXES.SHORT['']}, 
	      ENERGY:                {unit: UNITS.J,   prefix: PREFIXES.SHORT['']},
	      POWER:                 {unit: UNITS.W,   prefix: PREFIXES.SHORT['']},
	      PRESSURE:              {unit: UNITS.Pa,  prefix: PREFIXES.SHORT['']},
	      ELECTRIC_CHARGE:       {unit: UNITS.C,   prefix: PREFIXES.SHORT['']},
	      ELECTRIC_CAPACITANCE:  {unit: UNITS.F,   prefix: PREFIXES.SHORT['']},
	      ELECTRIC_POTENTIAL:    {unit: UNITS.V,   prefix: PREFIXES.SHORT['']},
	      ELECTRIC_RESISTANCE:   {unit: UNITS.ohm, prefix: PREFIXES.SHORT['']},
	      ELECTRIC_INDUCTANCE:   {unit: UNITS.H,   prefix: PREFIXES.SHORT['']},
	      ELECTRIC_CONDUCTANCE:  {unit: UNITS.S,   prefix: PREFIXES.SHORT['']},
	      MAGNETIC_FLUX:         {unit: UNITS.Wb,  prefix: PREFIXES.SHORT['']},
	      MAGNETIC_FLUX_DENSITY: {unit: UNITS.T,   prefix: PREFIXES.SHORT['']},
	      FREQUENCY:             {unit: UNITS.Hz,  prefix: PREFIXES.SHORT['']}
	    }
	  };
	
	  // Clone to create the other unit systems
	  UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
	  UNIT_SYSTEMS.cgs.LENGTH = {unit: UNITS.m,   prefix: PREFIXES.SHORT['c']};
	  UNIT_SYSTEMS.cgs.MASS =   {unit: UNITS.g,   prefix: PREFIXES.SHORT['']};
	  UNIT_SYSTEMS.cgs.FORCE =  {unit: UNITS.dyn, prefix: PREFIXES.SHORT['']};
	  UNIT_SYSTEMS.cgs.ENERGY = {unit: UNITS.erg, prefix: PREFIXES.NONE['']};
	  // there are wholly 4 unique cgs systems for electricity and magnetism,
	  // so let's not worry about it unless somebody complains
	  
	  UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
	  UNIT_SYSTEMS.us.LENGTH =      {unit: UNITS.ft,   prefix: PREFIXES.NONE['']};
	  UNIT_SYSTEMS.us.MASS =        {unit: UNITS.lbm,  prefix: PREFIXES.NONE['']};
	  UNIT_SYSTEMS.us.TEMPERATURE = {unit: UNITS.degF, prefix: PREFIXES.NONE['']};
	  UNIT_SYSTEMS.us.FORCE =       {unit: UNITS.lbf,  prefix: PREFIXES.NONE['']};
	  UNIT_SYSTEMS.us.ENERGY =      {unit: UNITS.BTU,  prefix: PREFIXES.BTU['']};
	  UNIT_SYSTEMS.us.POWER =       {unit: UNITS.hp,   prefix: PREFIXES.NONE['']};
	  UNIT_SYSTEMS.us.PRESSURE =    {unit: UNITS.psi,  prefix: PREFIXES.NONE['']};
	
	  // Add additional unit systems here.
	
	
	
	  // Choose a unit system to seed the auto unit system.
	  UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
	
	  // Set the current unit system
	  var currentUnitSystem = UNIT_SYSTEMS.auto;
	
	  /**
	   * Set a unit system for formatting derived units.
	   * @param {string} [name] The name of the unit system.
	   */
	  Unit.setUnitSystem = function(name) {
	    if(UNIT_SYSTEMS.hasOwnProperty(name)) {
	      currentUnitSystem = UNIT_SYSTEMS[name];
	    }
	    else {
	      throw new Error('Unit system ' + name + ' does not exist. Choices are: ' + Object.keys(UNIT_SYSTEMS).join(', '));
	    }
	  };
	
	  /**
	   * Return the current unit system.
	   * @return {string} The current unit system.
	   */
	  Unit.getUnitSystem = function() {
	    for(var key in UNIT_SYSTEMS) {
	      if(UNIT_SYSTEMS[key] === currentUnitSystem) {
	        return key;
	      }
	    }
	  };
	
	  /**
	   * Converters to convert from number to an other numeric type like BigNumber
	   * or Fraction
	   */
	  Unit.typeConverters = {
	    BigNumber: function (x) {
	      return new type.BigNumber(x + ''); // stringify to prevent constructor error
	    },
	
	    Fraction: function (x) {
	      return new type.Fraction(x);
	    },
	
	    Complex: function (x) {
	      return x;
	    },
	
	    number: function (x) {
	      return x;
	    }
	  };
	
	  /**
	   * Retrieve the right convertor function corresponding with the type
	   * of provided exampleValue.
	   *
	   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
	   *                        In case of an unknown type,
	   * @return {Function}
	   */
	  Unit._getNumberConverter = function (type) {
	    if (!Unit.typeConverters[type]) {
	      throw new TypeError('Unsupported type "' + type + '"');
	    }
	
	    return Unit.typeConverters[type];
	  };
	
	  // Add dimensions to each built-in unit
	  for (var key in UNITS) {
	    var unit = UNITS[key];
	    unit.dimensions = unit.base.dimensions;
	  }    
	
	  // Create aliases
	  for (var name in ALIASES) {
	    if(ALIASES.hasOwnProperty(name)) {
	      var unit = UNITS[ALIASES[name]];
	      var alias = {};
	      for(var key in unit) {
	        if(unit.hasOwnProperty(key)) {
	          alias[key] = unit[key];
	        }
	      }
	      alias.name = name;
	      UNITS[name] = alias;
	    }
	  }
	
	  function assertUnitNameIsValid(name) {
	    for(var i=0; i<name.length; i++) {
	      var c = name.charAt(i);
	       
	      var isValidAlpha = function (p) {
	        return /^[a-zA-Z]$/.test(p);
	      };
	
	      var isDigit = function (c) {
	        return (c >= '0' && c <= '9');
	      }
	
	      if(i === 0 && !isValidAlpha(c))
	        throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
	
	      if(i > 0 && !( isValidAlpha(c)
	                  || isDigit(c)))
	        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
	
	    }
	  }
	
	  /**
	   * Wrapper around createUnitSingle.
	   * Example: 
	   *  createUnit({
	   *    foo: { },
	   *    bar: {
	   *      definition: 'kg/foo',
	   *      aliases: ['ba', 'barr', 'bars'],
	   *      offset: 200
	   *    },
	   *    baz: '4 bar'
	   *  }, 
	   *  {
	   *    override: true;
	   *  });
	   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
	   * @param {object} options
	   */
	  Unit.createUnit = function(obj, options) {
	    
	    if(typeof(obj) !== 'object') {
	      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
	    }
	
	    // Remove all units and aliases we are overriding
	    if(options && options.override) {
	      for(var key in obj) {
	        if(obj.hasOwnProperty(key)) {
	          Unit.deleteUnit(key);
	        }
	        if(obj[key].aliases) {
	          for(var i=0; i<obj[key].aliases.length; i++) {
	            Unit.deleteUnit(obj[key].aliases[i]);
	          }
	        }
	      }
	    }
	
	    // TODO: traverse multiple times until all units have been added
	    var lastUnit;
	    for(var key in obj) {
	      if(obj.hasOwnProperty(key)) {
	        lastUnit = Unit.createUnitSingle(key, obj[key]);
	      }
	    }
	    return lastUnit;
	  };
	
	  /**
	   * Create a user-defined unit and register it with the Unit type.
	   * Example: 
	   *  createUnitSingle('knot', '0.514444444 m/s')
	   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
	   *
	   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
	   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
	   * @param {Object} options   (optional) An object containing any of the following properties:
	   *     prefixes {string} "none", "short", "long", "binary_short", or "binary_long". The default is "none".
	   *     aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
	   *     offset {Numeric} An offset to apply when converting from the unit. For example, the offset for celsius is 273.15 and the offset for farhenheit is 459.67. Default is 0.
	   *
	   * @return {Unit} 
	   */
	  Unit.createUnitSingle = function(name, obj, options) {
	
	    if(typeof(obj) === 'undefined' || obj === null) {
	      obj = {};
	    }
	    
	    if(typeof(name) !== 'string') {
	      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
	    }
	   
	    // Check collisions with existing units
	    if(UNITS.hasOwnProperty(name)) {
	      throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
	    }
	
	    // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
	
	    assertUnitNameIsValid(name);
	
	    var defUnit = null;   // The Unit from which the new unit will be created.
	    var aliases = [];
	    var offset = 0;
	    var definition;
	    var prefixes;
	    if(obj && obj.type === 'Unit') {
	      defUnit = obj.clone();
	    }
	    else if(typeof(obj) === 'string') {
	      if(obj !== '') {
	        definition = obj;
	      }
	    }
	    else if(typeof(obj) === 'object') {
	      definition = obj.definition;
	      prefixes = obj.prefixes; 
	      offset = obj.offset;
	      if (obj.aliases) {
	        aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
	      }
	    }
	    else {
	      throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
	    }
	
	    if(aliases) {
	      for (var i=0; i<aliases.length; i++) {
	        if(UNITS.hasOwnProperty(aliases[i])) {
	          throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
	        }
	      }
	    }
	
	    if(definition && typeof(definition) === 'string' && !defUnit) {
	      try {
	        defUnit = Unit.parse(definition, {allowNoUnits: true});
	      }
	      catch (ex) {
	        ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
	        throw(ex);
	      }
	    }
	    else if(definition && definition.type === 'Unit') {
	      defUnit = definition.clone();
	    }
	
	    aliases = aliases || [];
	    offset = offset || 0;
	    if(prefixes && prefixes.toUpperCase) 
	      prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
	    else
	      prefixes = PREFIXES.NONE;
	
	
	    // If defUnit is null, it is because the user did not
	    // specify a defintion. So create a new base dimension.
	    var newUnit = {};
	    if(!defUnit) {
	      // Add a new base dimension
	      var baseName = name + "_STUFF";   // foo --> foo_STUFF, or the essence of foo
	      if(BASE_DIMENSIONS.indexOf(baseName) >= 0) {
	        throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
	      }
	      BASE_DIMENSIONS.push(baseName);
	
	      // Push 0 onto existing base units
	      for(var b in BASE_UNITS) {
	        if(BASE_UNITS.hasOwnProperty(b)) {
	          BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length-1] = 0;
	        }
	      }
	
	      // Add the new base unit
	      var newBaseUnit = { dimensions: [] };
	      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
	        newBaseUnit.dimensions[i] = 0;
	      }
	      newBaseUnit.dimensions[BASE_DIMENSIONS.length-1] = 1;
	      newBaseUnit.key = baseName;
	      BASE_UNITS[baseName] = newBaseUnit;
	       
	      newUnit = {
	        name: name,
	        value: 1,
	        dimensions: BASE_UNITS[baseName].dimensions.slice(0),
	        prefixes: prefixes,
	        offset: offset,
	        base: baseName
	      };
	
	      currentUnitSystem[baseName] = {
	        unit: newUnit,
	        prefix: PREFIXES.NONE['']
	      };
	
	    }
	    else {
	
	      newUnit = {
	        name: name,
	        value: defUnit.value,
	        dimensions: defUnit.dimensions.slice(0),
	        prefixes: prefixes,
	        offset: offset,
	      };
	      
	      // Create a new base if no matching base exists
	      var anyMatch = false;
	      for(var i in BASE_UNITS) {
	        if(BASE_UNITS.hasOwnProperty(i)) {
	          var match = true;
	          for(var j=0; j<BASE_DIMENSIONS.length; j++) {
	            if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[i].dimensions[j] || 0)) > 1e-12) {
	              match = false;
	              break;
	            }
	          }
	          if(match) {
	            anyMatch = true;
	            break;
	          }
	        }
	      }
	      if(!anyMatch) {
	        var baseName = name + "_STUFF";   // foo --> foo_STUFF, or the essence of foo
	        // Add the new base unit
	        var newBaseUnit = { dimensions: defUnit.dimensions.slice(0) };
	        newBaseUnit.key = baseName;
	        BASE_UNITS[baseName] = newBaseUnit;
	
	        currentUnitSystem[baseName] = {
	          unit: newUnit,
	          prefix: PREFIXES.NONE['']
	        };
	
	        newUnit.base = baseName;
	      }
	    }
	
	    Unit.UNITS[name] = newUnit;
	
	    for (var i=0; i<aliases.length; i++) {
	      var aliasName = aliases[i];
	      var alias = {};
	      for(var key in newUnit) {
	        if(newUnit.hasOwnProperty(key)) {
	          alias[key] = newUnit[key];
	        }
	      }
	      alias.name = aliasName;
	      Unit.UNITS[aliasName] = alias;
	    }
	
	    return new Unit(null, name);
	  };
	
	  Unit.deleteUnit = function(name) {
	    delete Unit.UNITS[name];
	  };
	
	  // expose arrays with prefixes, dimensions, units, systems
	  Unit.PREFIXES = PREFIXES;
	  Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
	  Unit.BASE_UNITS = BASE_UNITS;
	  Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
	  Unit.UNITS = UNITS;
	
	  return Unit;
	}
	
	exports.name = 'Unit';
	exports.path = 'type';
	exports.factory = factory;
	exports.math = true; // request access to the math namespace


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var memoize = __webpack_require__(1361).memoize;
	
	/**
	 * Calculate BigNumber e
	 * @param {function} BigNumber   BigNumber constructor
	 * @returns {BigNumber} Returns e
	 */
	exports.e = memoize(function (BigNumber) {
	  return new BigNumber(1).exp();
	}, hasher);
	
	/**
	 * Calculate BigNumber golden ratio, phi = (1+sqrt(5))/2
	 * @param {function} BigNumber   BigNumber constructor
	 * @returns {BigNumber} Returns phi
	 */
	exports.phi = memoize(function (BigNumber) {
	  return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
	}, hasher);
	
	/**
	 * Calculate BigNumber pi.
	 * @param {function} BigNumber   BigNumber constructor
	 * @returns {BigNumber} Returns pi
	 */
	exports.pi = memoize(function (BigNumber) {
	  return BigNumber.acos(-1);
	}, hasher);
	
	/**
	 * Calculate BigNumber tau, tau = 2 * pi
	 * @param {function} BigNumber   BigNumber constructor
	 * @returns {BigNumber} Returns tau
	 */
	exports.tau = memoize(function (BigNumber) {
	  return exports.pi(BigNumber).times(2);
	}, hasher);
	
	/**
	 * Create a hash for a BigNumber constructor function. The created has is
	 * the configured precision
	 * @param {Array} args         Supposed to contain a single entry with
	 *                             a BigNumber constructor
	 * @return {number} precision
	 * @private
	 */
	function hasher (args) {
	  return args[0].precision;
	}


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	  var addScalar = load(__webpack_require__(1369));
	  var unaryMinus = load(__webpack_require__(1394));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm05 = load(__webpack_require__(1395));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  // TODO: split function subtract in two: subtract and subtractScalar
	
	  /**
	   * Subtract two values, `x - y`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.subtract(x, y)
	   *
	   * Examples:
	   *
	   *    math.subtract(5.3, 2);        // returns number 3.3
	   *
	   *    var a = math.complex(2, 3);
	   *    var b = math.complex(4, 1);
	   *    math.subtract(a, b);          // returns Complex -2 + 2i
	   *
	   *    math.subtract([5, 7, 4], 4);  // returns Array [1, 3, 0]
	   *
	   *    var c = math.unit('2.1 km');
	   *    var d = math.unit('500m');
	   *    math.subtract(c, d);          // returns Unit 1.6 km
	   *
	   * See also:
	   *
	   *    add
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
	   *            Initial value
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
	   *            Value to subtract from `x`
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
	   *            Subtraction of `x` and `y`
	   */
	  var subtract = typed('subtract', {
	
	    'number, number': function (x, y) {
	      return x - y;
	    },
	
	    'Complex, Complex': function (x, y) {
	      return x.sub(y);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.minus(y);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.sub(y);
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (x.value == null) {
	        throw new Error('Parameter x contains a unit with undefined value');
	      }
	
	      if (y.value == null) {
	        throw new Error('Parameter y contains a unit with undefined value');
	      }
	
	      if (!x.equalBase(y)) {
	        throw new Error('Units do not match');
	      }
	
	      var res = x.clone();
	      res.value = subtract(res.value, y.value);
	      res.fixPrefix = false;
	
	      return res;
	    },
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      checkEqualDimensions(x, y)
	      return algorithm05(x, y, subtract);
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      checkEqualDimensions(x, y)
	      return algorithm03(y, x, subtract, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      checkEqualDimensions(x, y)
	      return algorithm01(x, y, subtract, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      checkEqualDimensions(x, y)
	      return algorithm13(x, y, subtract);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return subtract(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return subtract(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return subtract(x, matrix(y));
	    },
	    
	    'SparseMatrix, any': function (x, y) {
	      return algorithm10(x, unaryMinus(y), addScalar);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, subtract);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm10(y, x, subtract, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, subtract, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, subtract, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, subtract, true).valueOf();
	    }
	  });
	
	  subtract.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['subtract'] + '${args[1]}\\right)'
	  };
	
	  return subtract;
	}
	
	/**
	 * Check whether matrix x and y have the same number of dimensions.
	 * Throws a DimensionError when dimensions are not equal
	 * @param {Matrix} x
	 * @param {Matrix} y
	 */
	function checkEqualDimensions(x, y) {
	  var xsize = x.size();
	  var ysize = y.size();
	
	  if (xsize.length !== ysize.length) {
	    throw new DimensionError(xsize.length, ysize.length);
	  }
	}
	
	exports.name = 'subtract';
	exports.factory = factory;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Inverse the sign of a value, apply a unary minus operation.
	   *
	   * For matrices, the function is evaluated element wise. Boolean values and
	   * strings will be converted to a number. For complex numbers, both real and
	   * complex value are inverted.
	   *
	   * Syntax:
	   *
	   *    math.unaryMinus(x)
	   *
	   * Examples:
	   *
	   *    math.unaryMinus(3.5);      // returns -3.5
	   *    math.unaryMinus(-4.2);     // returns 4.2
	   *
	   * See also:
	   *
	   *    add, subtract, unaryPlus
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
	   */
	  var unaryMinus = typed('unaryMinus', {
	    'number': function (x) {
	      return -x;
	    },
	
	    'Complex': function (x) {
	      return x.neg();
	    },
	
	    'BigNumber': function (x) {
	      return x.neg();
	    },
	
	    'Fraction': function (x) {
	      return x.neg();
	    },
	
	    'Unit': function (x) {
	      var res = x.clone();
	      res.value = unaryMinus(x.value);
	      return res;
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since unaryMinus(0) = 0
	      return deepMap(x, unaryMinus, true);
	    }
	
	    // TODO: add support for string
	  });
	
	  unaryMinus.toTex = {
	    1: latex.operators['unaryMinus'] + '\\left(${args[0]}\\right)'
	  };
	
	  return unaryMinus;
	}
	
	exports.name = 'unaryMinus';
	exports.factory = factory;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	  
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked MAX(NNZA, NNZB) times
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  0            ; otherwise
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm05 = function (a, b, callback) {
	    // sparse matrix arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = avalues && bvalues ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var xa = cvalues ? [] : undefined;
	    var xb = cvalues ? [] : undefined;
	    // marks indicating we have a value in x for a given column
	    var wa = [];
	    var wb = [];
	
	    // vars
	    var i, j, k, k1;
	    
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // columns mark
	      var mark = j + 1;
	      // loop values A(:,j)
	      for (k = aptr[j], k1 = aptr[j + 1]; k < k1; k++) {
	        // row
	        i = aindex[k];
	        // push index
	        cindex.push(i);
	        // update workspace
	        wa[i] = mark;
	        // check we need to process values
	        if (xa)
	          xa[i] = avalues[k];
	      }
	      // loop values B(:,j)
	      for (k = bptr[j], k1 = bptr[j + 1]; k < k1; k++) {
	        // row
	        i = bindex[k];
	        // check row existed in A
	        if (wa[i] !== mark) {
	          // push index
	          cindex.push(i);
	        }
	        // update workspace
	        wb[i] = mark;
	        // check we need to process values
	        if (xb)
	          xb[i] = bvalues[k];
	      }
	      // check we need to process values (non pattern matrix)
	      if (cvalues) {
	        // initialize first index in j
	        k = cptr[j];
	        // loop index in j
	        while (k < cindex.length) {
	          // row
	          i = cindex[k];
	          // marks
	          var wai = wa[i];
	          var wbi = wb[i];
	          // check Aij or Bij are nonzero
	          if (wai === mark || wbi === mark) {
	            // matrix values @ i,j
	            var va = wai === mark ? xa[i] : zero;
	            var vb = wbi === mark ? xb[i] : zero;
	            // Cij
	            var vc = cf(va, vb);
	            // check for zero
	            if (!eq(vc, zero)) {
	              // push value
	              cvalues.push(vc);
	              // increment pointer
	              k++;
	            }
	            else {
	              // remove value @ i, do not increment pointer
	              cindex.splice(k, 1);
	            }
	          }
	        }
	      }
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	
	  return algorithm05;
	}
	
	exports.name = 'algorithm05';
	exports.factory = factory;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory(type, config, load, typed) {
	  
	  /**
	   * Multiply two scalar values, `x * y`.
	   * This function is meant for internal use: it is used by the public function
	   * `multiply`
	   *
	   * This function does not support collections (Array or Matrix), and does
	   * not validate the number of of inputs.
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
	   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
	   * @return {number | BigNumber | Fraction | Complex | Unit}                      Multiplication of `x` and `y`
	   * @private
	   */
	  var multiplyScalar = typed('multiplyScalar', {
	
	    'number, number': function (x, y) {
	      return x * y;
	    },
	
	    'Complex, Complex': function (x, y) {
	      return x.mul(y);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.times(y);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.mul(y);
	    },
	
	    'number | Fraction | BigNumber | Complex, Unit': function (x, y) {
	      var res = y.clone();
	      res.value = (res.value === null) ? res._normalize(x) : multiplyScalar(res.value, x);
	      return res;
	    },
	
	    'Unit, number | Fraction | BigNumber | Complex': function (x, y) {
	      var res = x.clone();
	      res.value = (res.value === null) ? res._normalize(y) : multiplyScalar(res.value, y);
	      return res;
	    },
	
	    'Unit, Unit': function (x, y) {
	      return x.multiply(y);
	    }
	
	  });
	
	  return multiplyScalar;
	}
	
	exports.factory = factory;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory(type, config, load, typed) {
	  var multiplyScalar = load(__webpack_require__(1396));
	
	  /**
	   * Divide two scalar values, `x / y`.
	   * This function is meant for internal use: it is used by the public functions
	   * `divide` and `inv`.
	   *
	   * This function does not support collections (Array or Matrix), and does
	   * not validate the number of of inputs.
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
	   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
	   * @return {number | BigNumber | Fraction | Complex | Unit}                      Quotient, `x / y`
	   * @private
	   */
	  var divideScalar = typed('divide', {
	    'number, number': function (x, y) {
	      return x / y;
	    },
	
	    'Complex, Complex': function (x, y) {
	      return x.div(y);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.div(y);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.div(y);
	    },
	
	    'Unit, number | Fraction | BigNumber': function (x, y) {
	      var res = x.clone();
	      // TODO: move the divide function to Unit.js, it uses internals of Unit
	      res.value = divideScalar(((res.value === null) ? res._normalize(1) : res.value), y);
	      return res;
	    },
	
	    'number | Fraction | BigNumber, Unit': function (x, y) {
	      var res = y.pow(-1);
	      // TODO: move the divide function to Unit.js, it uses internals of Unit
	      res.value = multiplyScalar(((res.value === null) ? res._normalize(1) : res.value), x);
	      return res;
	    },
	
	    'Unit, Unit': function (x, y) {
	      return x.divide(y);
	    }
	
	  });
	
	  return divideScalar;
	}
	
	exports.factory = factory;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var size = __webpack_require__(1357).size;
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	  var eye = load(__webpack_require__(1399));
	  var multiply = load(__webpack_require__(1400));
	  var matrix = load(__webpack_require__(1368));
	  var fraction = load(__webpack_require__(1353));
	  var number = load(__webpack_require__(1386));
	
	  /**
	   * Calculates the power of x to y, `x ^ y`.
	   * Matrix exponentiation is supported for square matrices `x`, and positive
	   * integer exponents `y`.
	   *
	   * For cubic roots of negative numbers, the function returns the principal
	   * root by default. In order to let the function return the real root,
	   * math.js can be configured with `math.config({predictable: true})`.
	   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
	   *
	   * Syntax:
	   *
	   *    math.pow(x, y)
	   *
	   * Examples:
	   *
	   *    math.pow(2, 3);               // returns number 8
	   *
	   *    var a = math.complex(2, 3);
	   *    math.pow(a, 2)                // returns Complex -5 + 12i
	   *
	   *    var b = [[1, 2], [4, 3]];
	   *    math.pow(b, 2);               // returns Array [[9, 8], [16, 17]]
	   *
	   * See also:
	   *
	   *    multiply, sqrt, cbrt, nthRoot
	   *
	   * @param  {number | BigNumber | Complex | Array | Matrix} x  The base
	   * @param  {number | BigNumber | Complex} y                   The exponent
	   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
	   */
	  var pow = typed('pow', {
	    'number, number': _pow,
	
	    'Complex, Complex': function (x, y) {
	      return x.pow(y);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      if (y.isInteger() || x >= 0 || config.predictable) {
	        return x.pow(y);
	      }
	      else {
	        return new type.Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
	      }
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      if (y.d !== 1) {
	        if (config.predictable) {
	          throw new Error('Function pow does not support non-integer exponents for fractions.');
	        }
	        else {
	          return _pow(x.valueOf(), y.valueOf());
	        }
	      }
	      else {
	        return x.pow(y);
	     }
	    },
	
	    'Array, number': _powArray,
	
	    'Array, BigNumber': function (x, y) {
	      return _powArray(x, y.toNumber());
	    },
	
	    'Matrix, number': _powMatrix,
	
	    'Matrix, BigNumber': function (x, y) {
	      return _powMatrix(x, y.toNumber());
	    },
	
	    'Unit, number': function (x, y) {
	      return x.pow(y);
	    }
	
	  });
	
	  /**
	   * Calculates the power of x to y, x^y, for two numbers.
	   * @param {number} x
	   * @param {number} y
	   * @return {number | Complex} res
	   * @private
	   */
	  function _pow(x, y) {
	
	    // Alternatively could define a 'realmode' config option or something, but
	    // 'predictable' will work for now
	    if (config.predictable && !isInteger(y) && x < 0) {
	      // Check to see if y can be represented as a fraction
	      try {
	        var yFrac = fraction(y);
	        var yNum = number(yFrac);
	        if(y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
	          if(yFrac.d % 2 === 1) {
	            return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
	          }
	        }
	      }
	      catch (ex) {
	        // fraction() throws an error if y is Infinity, etc.
	      }
	
	      // Unable to express y as a fraction, so continue on
	    }
	
	
	    // x^Infinity === 0 if -1 < x < 1
	    // A real number 0 is returned instead of complex(0)
	    if ((x*x < 1 && y ===  Infinity) ||
	        (x*x > 1 && y === -Infinity)) {
	      return 0;
	    }
	
	    // **for predictable mode** x^Infinity === NaN if x < -1
	    // N.B. this behavour is different from `Math.pow` which gives
	    // (-2)^Infinity === Infinity
	    if (config.predictable &&
	        ((x < -1 &&          y ===  Infinity) ||
	         (x > -1 && x < 0 && y === -Infinity))) {
	      return NaN;
	    }
	
	    if (isInteger(y) || x >= 0 || config.predictable) {
	      return Math.pow(x, y);
	    }
	    else {
	      return new type.Complex(x, 0).pow(y, 0);
	    }
	  }
	
	  /**
	   * Calculate the power of a 2d array
	   * @param {Array} x     must be a 2 dimensional, square matrix
	   * @param {number} y    a positive, integer value
	   * @returns {Array}
	   * @private
	   */
	  function _powArray(x, y) {
	    if (!isInteger(y) || y < 0) {
	      throw new TypeError('For A^b, b must be a positive integer (value is ' + y + ')');
	    }
	    // verify that A is a 2 dimensional square matrix
	    var s = size(x);
	    if (s.length != 2) {
	      throw new Error('For A^b, A must be 2 dimensional (A has ' + s.length + ' dimensions)');
	    }
	    if (s[0] != s[1]) {
	      throw new Error('For A^b, A must be square (size is ' + s[0] + 'x' + s[1] + ')');
	    }
	
	    var res = eye(s[0]).valueOf();
	    var px = x;
	    while (y >= 1) {
	      if ((y & 1) == 1) {
	        res = multiply(px, res);
	      }
	      y >>= 1;
	      px = multiply(px, px);
	    }
	    return res;
	  }
	
	  /**
	   * Calculate the power of a 2d matrix
	   * @param {Matrix} x     must be a 2 dimensional, square matrix
	   * @param {number} y    a positive, integer value
	   * @returns {Matrix}
	   * @private
	   */
	  function _powMatrix (x, y) {
	    return matrix(_powArray(x.valueOf(), y));
	  }
	
	
	
	  pow.toTex = {
	    2: '\\left(${args[0]}\\right)' + latex.operators['pow'] + '{${args[1]}}'
	  };
	
	  return pow;
	}
	
	exports.name = 'pow';
	exports.factory = factory;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var array = __webpack_require__(1357);
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	  
	  /**
	   * Create a 2-dimensional identity matrix with size m x n or n x n.
	   * The matrix has ones on the diagonal and zeros elsewhere.
	   *
	   * Syntax:
	   *
	   *    math.eye(n)
	   *    math.eye(n, format)
	   *    math.eye(m, n)
	   *    math.eye(m, n, format)
	   *    math.eye([m, n])
	   *    math.eye([m, n], format)
	   *
	   * Examples:
	   *
	   *    math.eye(3);                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
	   *    math.eye(3, 2);                 // returns [[1, 0], [0, 1], [0, 0]]
	   *
	   *    var A = [[1, 2, 3], [4, 5, 6]];
	   *    math.eye(math.size(A));         // returns [[1, 0, 0], [0, 1, 0]]
	   *
	   * See also:
	   *
	   *    diag, ones, zeros, size, range
	   *
	   * @param {...number | Matrix | Array} size   The size for the matrix
	   * @param {string} [format]                   The Matrix storage format
	   *
	   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
	   */
	  var eye = typed('eye', {
	    '': function () {
	      return (config.matrix === 'Matrix') ? matrix([]) : [];
	    },
	
	    'string': function (format) {
	      return matrix(format);
	    },
	
	    'number | BigNumber': function (rows) {
	      return _eye(rows, rows, config.matrix === 'Matrix' ? 'default' : undefined);
	    },
	    
	    'number | BigNumber, string': function (rows, format) {
	      return _eye(rows, rows, format);
	    },
	
	    'number | BigNumber, number | BigNumber': function (rows, cols) {
	      return _eye(rows, cols, config.matrix === 'Matrix' ? 'default' : undefined);
	    },
	    
	    'number | BigNumber, number | BigNumber, string': function (rows, cols, format) {
	      return _eye(rows, cols, format);
	    },
	
	    'Array':  function (size) {
	      return _eyeVector(size);
	    },
	    
	    'Array, string':  function (size, format) {
	      return _eyeVector(size, format);
	    },
	
	    'Matrix': function (size) {
	      return _eyeVector(size.valueOf(), size.storage());
	    },
	    
	    'Matrix, string': function (size, format) {
	      return _eyeVector(size.valueOf(), format);
	    }
	  });
	
	  eye.toTex = undefined; // use default template
	
	  return eye;
	
	  function _eyeVector (size, format) {
	    switch (size.length) {
	      case 0: return format ? matrix(format) : [];
	      case 1: return _eye(size[0], size[0], format);
	      case 2: return _eye(size[0], size[1], format);
	      default: throw new Error('Vector containing two values expected');
	    }
	  }
	
	  /**
	   * Create an identity matrix
	   * @param {number | BigNumber} rows
	   * @param {number | BigNumber} cols
	   * @param {string} [format]
	   * @returns {Matrix}
	   * @private
	   */
	  function _eye (rows, cols, format) {
	    // BigNumber constructor with the right precision
	    var Big = (type.isBigNumber(rows) || type.isBigNumber(cols))
	            ? type.BigNumber
	            : null;
	
	    if (type.isBigNumber(rows)) rows = rows.toNumber();
	    if (type.isBigNumber(cols)) cols = cols.toNumber();
	
	    if (!isInteger(rows) || rows < 1) {
	      throw new Error('Parameters in function eye must be positive integers');
	    }
	    if (!isInteger(cols) || cols < 1) {
	      throw new Error('Parameters in function eye must be positive integers');
	    }
	    
	    var one = Big ? new type.BigNumber(1) : 1;
	    var defaultValue = Big ? new Big(0) : 0;
	    var size = [rows, cols];
	    
	    // check we need to return a matrix
	    if (format) {
	      // get matrix storage constructor
	      var F = type.Matrix.storage(format);
	      // create diagonal matrix (use optimized implementation for storage format)
	      return F.diagonal(size, one, 0, defaultValue);
	    }
	    
	    // create and resize array
	    var res = array.resize([], size, defaultValue);
	    // fill in ones on the diagonal
	    var minimum = rows < cols ? rows : cols;
	    // fill diagonal
	    for (var d = 0; d < minimum; d++) {
	      res[d][d] = one;
	    }
	    return res;
	  }
	}
	
	exports.name = 'eye';
	exports.factory = factory;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(1320).extend;
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	  var addScalar = load(__webpack_require__(1369));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var equalScalar = load(__webpack_require__(1364));
	
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  var DenseMatrix = type.DenseMatrix;
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Multiply two or more values, `x * y`.
	   * For matrices, the matrix product is calculated.
	   *
	   * Syntax:
	   *
	   *    math.multiply(x, y)
	   *    math.multiply(x, y, z, ...)
	   *
	   * Examples:
	   *
	   *    math.multiply(4, 5.2);        // returns number 20.8
	   *    math.multiply(2, 3, 4);       // returns number 24
	   *
	   *    var a = math.complex(2, 3);
	   *    var b = math.complex(4, 1);
	   *    math.multiply(a, b);          // returns Complex 5 + 14i
	   *
	   *    var c = [[1, 2], [4, 3]];
	   *    var d = [[1, 2, 3], [3, -4, 7]];
	   *    math.multiply(c, d);          // returns Array [[7, -6, 17], [13, -4, 33]]
	   *
	   *    var e = math.unit('2.1 km');
	   *    math.multiply(3, e);          // returns Unit 6.3 km
	   *
	   * See also:
	   *
	   *    divide, prod, cross, dot
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
	   */
	  var multiply = typed('multiply', extend({
	    // we extend the signatures of multiplyScalar with signatures dealing with matrices
	
	    'Array, Array': function (x, y) {
	      // check dimensions
	      _validateMatrixDimensions(array.size(x), array.size(y));
	
	      // use dense matrix implementation
	      var m = multiply(matrix(x), matrix(y));
	      // return array or scalar
	      return type.isMatrix(m) ? m.valueOf() : m;
	    },
	
	    'Matrix, Matrix': function (x, y) {
	      // dimensions
	      var xsize = x.size();
	      var ysize = y.size();
	
	      // check dimensions
	      _validateMatrixDimensions(xsize, ysize);
	
	      // process dimensions
	      if (xsize.length === 1) {
	        // process y dimensions
	        if (ysize.length === 1) {
	          // Vector * Vector
	          return _multiplyVectorVector(x, y, xsize[0]);
	        }
	        // Vector * Matrix
	        return _multiplyVectorMatrix(x, y);
	      }
	      // process y dimensions
	      if (ysize.length === 1) {
	        // Matrix * Vector
	        return _multiplyMatrixVector(x, y);
	      }
	      // Matrix * Matrix
	      return _multiplyMatrixMatrix(x, y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use Matrix * Matrix implementation
	      return multiply(x, matrix(y));
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use Matrix * Matrix implementation
	      return multiply(matrix(x, y.storage()), y);
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, multiplyScalar, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, multiplyScalar, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm11(y, x, multiplyScalar, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, multiplyScalar, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
	    },
	
	    'any, any': multiplyScalar,
	
	    'any, any, ...any': function (x, y, rest) {
	      var result = multiply(x, y);
	
	      for (var i = 0; i < rest.length; i++) {
	        result = multiply(result, rest[i]);
	      }
	      
	      return result;
	    }
	  }, multiplyScalar.signatures));
	
	  var _validateMatrixDimensions = function (size1, size2) {
	    // check left operand dimensions
	    switch (size1.length) {
	      case 1:
	        // check size2
	        switch (size2.length) {
	          case 1:
	            // Vector x Vector
	            if (size1[0] !== size2[0]) {
	              // throw error
	              throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');
	            }
	            break;
	          case 2:
	            // Vector x Matrix
	            if (size1[0] !== size2[0]) {
	              // throw error
	              throw new RangeError('Dimension mismatch in multiplication. Vector length (' + size1[0] + ') must match Matrix rows (' + size2[0] + ')');
	            }
	            break;
	          default:
	            throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
	        }
	        break;
	      case 2:
	        // check size2
	        switch (size2.length) {
	          case 1:
	            // Matrix x Vector
	            if (size1[1] !== size2[0]) {
	              // throw error
	              throw new RangeError('Dimension mismatch in multiplication. Matrix columns (' + size1[1] + ') must match Vector length (' + size2[0] + ')');
	            }
	            break;
	          case 2:
	            // Matrix x Matrix
	            if (size1[1] !== size2[0]) {
	              // throw error
	              throw new RangeError('Dimension mismatch in multiplication. Matrix A columns (' + size1[1] + ') must match Matrix B rows (' + size2[0] + ')');
	            }
	            break;
	          default:
	            throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
	        }
	        break;
	      default:
	        throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has ' + size1.length + ' dimensions)');
	    }
	  };
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (N)
	   * @param {Matrix} b            Dense Vector   (N)
	   *
	   * @return {number}             Scalar value
	   */
	  var _multiplyVectorVector = function (a, b, n) {
	    // check empty vector
	    if (n === 0)
	      throw new Error('Cannot multiply two empty vectors');
	
	    // a dense
	    var adata = a._data;
	    var adt = a._datatype;
	    // b dense
	    var bdata = b._data;
	    var bdt = b._datatype;
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	    }
	    
	    // result (do not initialize it with zero)
	    var c = mf(adata[0], bdata[0]);
	    // loop data
	    for (var i = 1; i < n; i++) {
	      // multiply and accumulate
	      c = af(c, mf(adata[i], bdata[i]));
	    }
	    return c;
	  };
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (M)
	   * @param {Matrix} b            Matrix         (MxN)
	   *
	   * @return {Matrix}             Dense Vector   (N)
	   */
	  var _multiplyVectorMatrix = function (a, b) {
	    // process storage
	    if (b.storage() !== 'dense') {
	      throw new Error('Support for SparseMatrix not implemented');
	    }
	    return _multiplyVectorDenseMatrix(a, b);
	  };
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            Dense Vector   (M)
	   * @param {Matrix} b            Dense Matrix   (MxN)
	   *
	   * @return {Matrix}             Dense Vector   (N)
	   */
	  var _multiplyVectorDenseMatrix = function (a, b) {
	    // a dense
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    // b dense
	    var bdata = b._data;
	    var bsize = b._size;
	    var bdt = b._datatype;
	    // rows & columns
	    var alength = asize[0];
	    var bcolumns = bsize[1];
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	    }
	
	    // result
	    var c = [];
	
	    // loop matrix columns
	    for (var j = 0; j < bcolumns; j++) {
	      // sum (do not initialize it with zero)
	      var sum = mf(adata[0], bdata[0][j]);      
	      // loop vector
	      for (var i = 1; i < alength; i++) {
	        // multiply & accumulate
	        sum = af(sum, mf(adata[i], bdata[i][j]));
	      }
	      c[j] = sum;
	    }
	
	    // return matrix
	    return new DenseMatrix({
	      data: c,
	      size: [bcolumns],
	      datatype: dt
	    });
	  };
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            Matrix         (MxN)
	   * @param {Matrix} b            Dense Vector   (N)
	   *
	   * @return {Matrix}             Dense Vector   (M)
	   */
	  var _multiplyMatrixVector = typed('_multiplyMatrixVector', {
	    'DenseMatrix, any': _multiplyDenseMatrixVector,
	    'SparseMatrix, any': _multiplySparseMatrixVector
	  });
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            Matrix         (MxN)
	   * @param {Matrix} b            Matrix         (NxC)
	   *
	   * @return {Matrix}             Matrix         (MxC)
	   */
	  var _multiplyMatrixMatrix = typed('_multiplyMatrixMatrix', {
	    'DenseMatrix, DenseMatrix': _multiplyDenseMatrixDenseMatrix,
	    'DenseMatrix, SparseMatrix': _multiplyDenseMatrixSparseMatrix,
	    'SparseMatrix, DenseMatrix': _multiplySparseMatrixDenseMatrix,
	    'SparseMatrix, SparseMatrix': _multiplySparseMatrixSparseMatrix
	  });
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix  (MxN)
	   * @param {Matrix} b            Dense Vector (N)
	   *
	   * @return {Matrix}             Dense Vector (M) 
	   */ 
	  function _multiplyDenseMatrixVector(a, b) {
	    // a dense
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    // b dense
	    var bdata = b._data;
	    var bdt = b._datatype;
	    // rows & columns
	    var arows = asize[0];
	    var acolumns = asize[1];
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	    }
	
	    // result
	    var c = [];
	
	    // loop matrix a rows
	    for (var i = 0; i < arows; i++) {
	      // current row
	      var row = adata[i];
	      // sum (do not initialize it with zero)
	      var sum = mf(row[0], bdata[0]);
	      // loop matrix a columns
	      for (var j = 1; j < acolumns; j++) {
	        // multiply & accumulate
	        sum = af(sum, mf(row[j], bdata[j]));
	      }
	      c[i] = sum;
	    }
	
	    // return matrix
	    return new DenseMatrix({
	      data: c,
	      size: [arows],
	      datatype: dt
	    });
	  }
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix    (MxN)
	   * @param {Matrix} b            DenseMatrix    (NxC)
	   *
	   * @return {Matrix}             DenseMatrix    (MxC)
	   */
	  function _multiplyDenseMatrixDenseMatrix (a, b) {
	    // a dense
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    // b dense
	    var bdata = b._data;
	    var bsize = b._size;
	    var bdt = b._datatype;
	    // rows & columns
	    var arows = asize[0];
	    var acolumns = asize[1];
	    var bcolumns = bsize[1];
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	    }
	    
	    // result
	    var c = [];
	
	    // loop matrix a rows
	    for (var i = 0; i < arows; i++) {
	      // current row
	      var row = adata[i];
	      // initialize row array
	      c[i] = [];
	      // loop matrix b columns
	      for (var j = 0; j < bcolumns; j++) {
	        // sum (avoid initializing sum to zero)
	        var sum = mf(row[0], bdata[0][j]);
	        // loop matrix a columns
	        for (var x = 1; x < acolumns; x++) {
	          // multiply & accumulate
	          sum = af(sum, mf(row[x], bdata[x][j]));
	        }
	        c[i][j] = sum;
	      }
	    }
	
	    // return matrix
	    return new DenseMatrix({
	      data: c,
	      size: [arows, bcolumns],
	      datatype: dt
	    });
	  }
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            DenseMatrix    (MxN)
	   * @param {Matrix} b            SparseMatrix   (NxC)
	   *
	   * @return {Matrix}             SparseMatrix   (MxC)
	   */
	  function _multiplyDenseMatrixSparseMatrix (a, b) {
	    // a dense
	    var adata = a._data;
	    var asize = a._size;
	    var adt = a._datatype;
	    // b sparse
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bsize = b._size;
	    var bdt = b._datatype;
	    // validate b matrix
	    if (!bvalues)
	      throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');
	    // rows & columns
	    var arows = asize[0];
	    var bcolumns = bsize[1];
	    
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	    // equalScalar signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	    }
	
	    // result
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	    // c matrix
	    var c = new SparseMatrix({
	      values : cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [arows, bcolumns],
	      datatype: dt
	    });
	
	    // loop b columns
	    for (var jb = 0; jb < bcolumns; jb++) {
	      // update ptr
	      cptr[jb] = cindex.length;
	      // indeces in column jb
	      var kb0 = bptr[jb];
	      var kb1 = bptr[jb + 1];
	      // do not process column jb if no data exists
	      if (kb1 > kb0) {
	        // last row mark processed
	        var last = 0;
	        // loop a rows
	        for (var i = 0; i < arows; i++) {
	          // column mark
	          var mark = i + 1;
	          // C[i, jb]
	          var cij;
	          // values in b column j
	          for (var kb = kb0; kb < kb1; kb++) {
	            // row
	            var ib = bindex[kb];
	            // check value has been initialized
	            if (last !== mark) {
	              // first value in column jb
	              cij = mf(adata[i][ib], bvalues[kb]);
	              // update mark
	              last = mark;
	            }
	            else {
	              // accumulate value
	              cij = af(cij, mf(adata[i][ib], bvalues[kb]));
	            }
	          }
	          // check column has been processed and value != 0
	          if (last === mark && !eq(cij, zero)) {
	            // push row & value
	            cindex.push(i);
	            cvalues.push(cij);
	          }
	        }
	      }
	    }
	    // update ptr
	    cptr[bcolumns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  }
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix    (MxN)
	   * @param {Matrix} b            Dense Vector (N)
	   *
	   * @return {Matrix}             SparseMatrix    (M, 1) 
	   */
	  function _multiplySparseMatrixVector(a, b) {
	    // a sparse
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var adt = a._datatype;
	    // validate a matrix
	    if (!avalues)
	      throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
	    // b dense
	    var bdata = b._data;
	    var bdt = b._datatype;
	    // rows & columns
	    var arows = a._size[0];
	    var brows = b._size[0];
	    // result
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	    
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	    // equalScalar signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	    }
	
	    // workspace
	    var x = [];
	    // vector with marks indicating a value x[i] exists in a given column
	    var w = [];
	
	    // update ptr
	    cptr[0] = 0;
	    // rows in b
	    for (var ib = 0; ib < brows; ib++) {
	      // b[ib]
	      var vbi = bdata[ib];
	      // check b[ib] != 0, avoid loops
	      if (!eq(vbi, zero)) {
	        // A values & index in ib column
	        for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
	          // a row
	          var ia = aindex[ka];
	          // check value exists in current j
	          if (!w[ia]) {
	            // ia is new entry in j
	            w[ia] = true;
	            // add i to pattern of C
	            cindex.push(ia);
	            // x(ia) = A
	            x[ia] = mf(vbi, avalues[ka]);
	          }
	          else {
	            // i exists in C already
	            x[ia] = af(x[ia], mf(vbi, avalues[ka]));
	          }
	        }
	      }
	    }
	    // copy values from x to column jb of c
	    for (var p1 = cindex.length, p = 0; p < p1; p++) {
	      // row
	      var ic = cindex[p];
	      // copy value
	      cvalues[p] = x[ic];
	    }
	    // update ptr
	    cptr[1] = cindex.length;
	
	    // return sparse matrix
	    return new SparseMatrix({
	      values : cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [arows, 1],
	      datatype: dt
	    });
	  }
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix      (MxN)
	   * @param {Matrix} b            DenseMatrix       (NxC)
	   *
	   * @return {Matrix}             SparseMatrix      (MxC)
	   */
	  function _multiplySparseMatrixDenseMatrix(a, b) {
	    // a sparse
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var adt = a._datatype;
	    // validate a matrix
	    if (!avalues)
	      throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
	    // b dense
	    var bdata = b._data;
	    var bdt = b._datatype;
	    // rows & columns
	    var arows = a._size[0];
	    var brows = b._size[0];
	    var bcolumns = b._size[1];
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	    // equalScalar signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	    }
	
	    // result
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	    // c matrix
	    var c = new SparseMatrix({
	      values : cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [arows, bcolumns],
	      datatype: dt
	    });
	
	    // workspace
	    var x = [];
	    // vector with marks indicating a value x[i] exists in a given column
	    var w = [];
	
	    // loop b columns
	    for (var jb = 0; jb < bcolumns; jb++) {
	      // update ptr
	      cptr[jb] = cindex.length;
	      // mark in workspace for current column
	      var mark = jb + 1;
	      // rows in jb
	      for (var ib = 0; ib < brows; ib++) {
	        // b[ib, jb]
	        var vbij = bdata[ib][jb];
	        // check b[ib, jb] != 0, avoid loops
	        if (!eq(vbij, zero)) {
	          // A values & index in ib column
	          for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
	            // a row
	            var ia = aindex[ka];
	            // check value exists in current j
	            if (w[ia] !== mark) {
	              // ia is new entry in j
	              w[ia] = mark;
	              // add i to pattern of C
	              cindex.push(ia);
	              // x(ia) = A
	              x[ia] = mf(vbij, avalues[ka]);
	            }
	            else {
	              // i exists in C already
	              x[ia] = af(x[ia], mf(vbij, avalues[ka]));
	            }
	          }
	        }
	      }
	      // copy values from x to column jb of c
	      for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
	        // row
	        var ic = cindex[p];
	        // copy value
	        cvalues[p] = x[ic];
	      }
	    }
	    // update ptr
	    cptr[bcolumns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  }
	
	  /**
	   * C = A * B
	   *
	   * @param {Matrix} a            SparseMatrix      (MxN)
	   * @param {Matrix} b            SparseMatrix      (NxC)
	   *
	   * @return {Matrix}             SparseMatrix      (MxC)
	   */
	  function _multiplySparseMatrixSparseMatrix(a, b) {
	    // a sparse
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var adt = a._datatype;
	    // b sparse
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bdt = b._datatype;
	    
	    // rows & columns
	    var arows = a._size[0];
	    var bcolumns = b._size[1];
	    // flag indicating both matrices (a & b) contain data
	    var values = avalues && bvalues;
	
	    // datatype
	    var dt;
	    // addScalar signature to use
	    var af = addScalar;
	    // multiplyScalar signature to use
	    var mf = multiplyScalar;
	
	    // process data types
	    if (adt && bdt && adt === bdt && typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signatures that matches (dt, dt)
	      af = typed.find(addScalar, [dt, dt]);
	      mf = typed.find(multiplyScalar, [dt, dt]);
	    }
	    
	    // result
	    var cvalues = values ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // c matrix
	    var c = new SparseMatrix({
	      values : cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [arows, bcolumns],
	      datatype: dt
	    });
	
	    // workspace
	    var x = values ? [] : undefined;
	    // vector with marks indicating a value x[i] exists in a given column
	    var w = [];
	    // variables
	    var ka, ka0, ka1, kb, kb0, kb1, ia, ib;
	    // loop b columns
	    for (var jb = 0; jb < bcolumns; jb++) {
	      // update ptr
	      cptr[jb] = cindex.length;
	      // mark in workspace for current column
	      var mark = jb + 1;
	      // B values & index in j
	      for (kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++) {
	        // b row
	        ib = bindex[kb];
	        // check we need to process values
	        if (values) {
	          // loop values in a[:,ib]
	          for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
	            // row
	            ia = aindex[ka];
	            // check value exists in current j
	            if (w[ia] !== mark) {
	              // ia is new entry in j
	              w[ia] = mark;
	              // add i to pattern of C
	              cindex.push(ia);
	              // x(ia) = A
	              x[ia] = mf(bvalues[kb], avalues[ka]);
	            }
	            else {
	              // i exists in C already
	              x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
	            }
	          }
	        }
	        else {
	          // loop values in a[:,ib]
	          for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
	            // row
	            ia = aindex[ka];
	            // check value exists in current j
	            if (w[ia] !== mark) {
	              // ia is new entry in j
	              w[ia] = mark;
	              // add i to pattern of C
	              cindex.push(ia);
	            }
	          }
	        }
	      }
	      // check we need to process matrix values (pattern matrix)
	      if (values) {
	        // copy values from x to column jb of c
	        for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
	          // row
	          var ic = cindex[p];
	          // copy value
	          cvalues[p] = x[ic];
	        }
	      }
	    }
	    // update ptr
	    cptr[bcolumns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  }
	
	  multiply.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['multiply'] + '${args[1]}\\right)'
	  };
	
	  return multiply;
	}
	
	exports.name = 'multiply';
	exports.factory = factory;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
	   * Callback function invoked NZ times (number of nonzero items in S).
	   *
	   *
	   *          ┌  f(Sij, b)  ; S(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  0          ; otherwise
	   *
	   *
	   * @param {Matrix}   s                 The SparseMatrix instance (S)
	   * @param {Scalar}   b                 The Scalar value
	   * @param {Function} callback          The f(Aij,b) operation to invoke
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
	   */
	  var algorithm11 = function (s, b, callback, inverse) {
	    // sparse matrix arrays
	    var avalues = s._values;
	    var aindex = s._index;
	    var aptr = s._ptr;
	    var asize = s._size;
	    var adt = s._datatype;
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!avalues)
	      throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string') {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // convert b to the same datatype
	      b = typed.convert(b, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // initialize ptr
	      cptr[j] = cindex.length;
	      // values in j
	      for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        var i = aindex[k];
	        // invoke callback
	        var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b);
	        // check value is zero
	        if (!eq(v, zero)) {
	          // push index & value
	          cindex.push(i);
	          cvalues.push(v);
	        }
	      }
	    }
	    // update ptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	
	  return algorithm11;
	}
	
	exports.name = 'algorithm11';
	exports.factory = factory;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the absolute value of a number. For matrices, the function is
	   * evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.abs(x)
	   *
	   * Examples:
	   *
	   *    math.abs(3.5);                // returns number 3.5
	   *    math.abs(-4.2);               // returns number 4.2
	   *
	   *    math.abs([3, -5, -1, 0, 2]);  // returns Array [3, 5, 1, 0, 2]
	   *
	   * See also:
	   *
	   *    sign
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
	   *            A number or matrix for which to get the absolute value
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
	   *            Absolute value of `x`
	   */
	  var abs = typed('abs', {
	    'number': Math.abs,
	
	    'Complex': function (x) {
	      return x.abs();
	    },
	
	    'BigNumber': function (x) {
	      return x.abs();
	    },
	
	    'Fraction': function (x) {
	      return x.abs();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since abs(0) = 0
	      return deepMap(x, abs, true);
	    },
	
	    'Unit': function(x) {
	      return x.abs();
	    }
	  });
	
	  abs.toTex = {1: '\\left|${args[0]}\\right|'};
	
	  return abs;
	}
	
	exports.name = 'abs';
	exports.factory = factory;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Round a value towards zero.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.fix(x)
	   *
	   * Examples:
	   *
	   *    math.fix(3.2);                // returns number 3
	   *    math.fix(3.8);                // returns number 3
	   *    math.fix(-4.2);               // returns number -4
	   *    math.fix(-4.7);               // returns number -4
	   *
	   *    var c = math.complex(3.2, -2.7);
	   *    math.fix(c);                  // returns Complex 3 - 2i
	   *
	   *    math.fix([3.2, 3.8, -4.7]);   // returns Array [3, 3, -4]
	   *
	   * See also:
	   *
	   *    ceil, floor, round
	   *
	   * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
	   */
	  var fix = typed('fix', {
	    'number': function (x) {
	      return (x > 0) ? Math.floor(x) : Math.ceil(x);
	    },
	
	    'Complex': function (x) {
	      return new type.Complex(
	          (x.re > 0) ? Math.floor(x.re) : Math.ceil(x.re),
	          (x.im > 0) ? Math.floor(x.im) : Math.ceil(x.im)
	      );
	    },
	
	    'BigNumber': function (x) {
	      return x.isNegative() ? x.ceil() : x.floor();
	    },
	
	    'Fraction': function (x) {
	      return x.s < 0 ? x.ceil() : x.floor();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since fix(0) = 0
	      return deepMap(x, fix, true);
	    }
	  });
	
	  fix.toTex = {1: '\\mathrm{${name}}\\left(${args[0]}\\right)'};
	
	  return fix;
	}
	
	exports.name = 'fix';
	exports.factory = factory;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var toFixed = __webpack_require__(1324).toFixed;
	var deepMap = __webpack_require__(1337);
	
	var NO_INT = 'Number of decimals in function round must be an integer';
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  var equalScalar = load(__webpack_require__(1364));
	  var zeros = load(__webpack_require__(1405));
	
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Round a value towards the nearest integer.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.round(x)
	   *    math.round(x, n)
	   *
	   * Examples:
	   *
	   *    math.round(3.2);              // returns number 3
	   *    math.round(3.8);              // returns number 4
	   *    math.round(-4.2);             // returns number -4
	   *    math.round(-4.7);             // returns number -5
	   *    math.round(math.pi, 3);       // returns number 3.142
	   *    math.round(123.45678, 2);     // returns number 123.46
	   *
	   *    var c = math.complex(3.2, -2.7);
	   *    math.round(c);                // returns Complex 3 - 3i
	   *
	   *    math.round([3.2, 3.8, -4.7]); // returns Array [3, 4, -5]
	   *
	   * See also:
	   *
	   *    ceil, fix, floor
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
	   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
	   */
	  var round = typed('round', {
	
	    'number': Math.round,
	
	    'number, number': function (x, n) {
	      if (!isInteger(n))   {throw new TypeError(NO_INT);}
	      if (n < 0 || n > 15) {throw new Error('Number of decimals in function round must be in te range of 0-15');}
	
	      return _round(x, n);
	    },
	
	    'Complex': function (x) {
	      return x.round();
	    },
	
	    'Complex, number': function (x, n) {
	      if (n % 1) {throw new TypeError(NO_INT);}
	      
	      return x.round(n);
	    },
	
	    'Complex, BigNumber': function (x, n) {
	      if (!n.isInteger()) {throw new TypeError(NO_INT);}
	
	      var _n = n.toNumber();
	      return x.round(_n);
	    },
	
	    'number, BigNumber': function (x, n) {
	      if (!n.isInteger()) {throw new TypeError(NO_INT);}
	
	      return new type.BigNumber(x).toDecimalPlaces(n.toNumber());
	    },
	
	    'BigNumber': function (x) {
	      return x.toDecimalPlaces(0);
	    },
	
	    'BigNumber, BigNumber': function (x, n) {
	      if (!n.isInteger()) {throw new TypeError(NO_INT);}
	
	      return x.toDecimalPlaces(n.toNumber());
	    },
	
	    'Fraction': function (x) {
	      return x.round();
	    },
	
	    'Fraction, number': function (x, n) {
	      if (n % 1) {throw new TypeError(NO_INT);}
	      return x.round(n);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since round(0) = 0
	      return deepMap(x, round, true);
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      return algorithm11(x, y, round, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      return algorithm14(x, y, round, false);
	    },
	
	    'number | Complex | BigNumber, SparseMatrix': function (x, y) {
	      // check scalar is zero
	      if (equalScalar(x, 0)) {
	        // do not execute algorithm, result will be a zero matrix
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm12(y, x, round, true);
	    },
	
	    'number | Complex | BigNumber, DenseMatrix': function (x, y) {
	      // check scalar is zero
	      if (equalScalar(x, 0)) {
	        // do not execute algorithm, result will be a zero matrix
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm14(y, x, round, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, round, false).valueOf();
	    },
	
	    'number | Complex | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, round, true).valueOf();
	    }
	  });
	
	  round.toTex = {
	    1: '\\left\\lfloor${args[0]}\\right\\rceil',
	    2: undefined  // use default template
	  };
	
	  return round;
	}
	
	/**
	 * round a number to the given number of decimals, or to zero if decimals is
	 * not provided
	 * @param {number} value
	 * @param {number} decimals       number of decimals, between 0 and 15 (0 by default)
	 * @return {number} roundedValue
	 * @private
	 */
	function _round (value, decimals) {
	  return parseFloat(toFixed(value, decimals));
	}
	
	exports.name = 'round';
	exports.factory = factory;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var resize = __webpack_require__(1357).resize;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Create a matrix filled with zeros. The created matrix can have one or
	   * multiple dimensions.
	   *
	   * Syntax:
	   *
	   *    math.zeros(m)
	   *    math.zeros(m, format)
	   *    math.zeros(m, n)
	   *    math.zeros(m, n, format)
	   *    math.zeros([m, n])
	   *    math.zeros([m, n], format)
	   *
	   * Examples:
	   *
	   *    math.zeros(3);                  // returns [0, 0, 0]
	   *    math.zeros(3, 2);               // returns [[0, 0], [0, 0], [0, 0]]
	   *    math.zeros(3, 'dense');         // returns [0, 0, 0]
	   *
	   *    var A = [[1, 2, 3], [4, 5, 6]];
	   *    math.zeros(math.size(A));       // returns [[0, 0, 0], [0, 0, 0]]
	   *
	   * See also:
	   *
	   *    ones, eye, size, range
	   *
	   * @param {...number | Array} size    The size of each dimension of the matrix
	   * @param {string} [format]           The Matrix storage format
	   *
	   * @return {Array | Matrix}           A matrix filled with zeros
	   */
	  var zeros = typed('zeros', {
	    '': function () {
	      return (config.matrix === 'Array')
	          ? _zeros([])
	          : _zeros([], 'default');
	    },
	
	    // math.zeros(m, n, p, ..., format)
	    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
	    '...number | BigNumber | string': function (size) {
	      var last = size[size.length - 1];
	      if (typeof last === 'string') {
	        var format = size.pop();
	        return _zeros(size, format);
	      }
	      else if (config.matrix === 'Array') {
	        return _zeros(size);
	      }
	      else {
	        return _zeros(size, 'default');
	      }
	    },
	
	    'Array': _zeros,
	
	    'Matrix': function (size) {
	      var format = size.storage();
	      return _zeros(size.valueOf(), format);
	    },
	
	    'Array | Matrix, string': function (size, format) {
	      return _zeros (size.valueOf(), format);
	    }
	  });
	
	  zeros.toTex = undefined; // use default template
	
	  return zeros;
	
	  /**
	   * Create an Array or Matrix with zeros
	   * @param {Array} size
	   * @param {string} [format='default']
	   * @return {Array | Matrix}
	   * @private
	   */
	  function _zeros(size, format) {
	    var hasBigNumbers = _normalize(size);
	    var defaultValue = hasBigNumbers ? new type.BigNumber(0) : 0;
	    _validate(size);
	
	    if (format) {
	      // return a matrix
	      var m = matrix(format);
	      if (size.length > 0) {
	        return m.resize(size, defaultValue);
	      }
	      return m;
	    }
	    else {
	      // return an Array
	      var arr = [];
	      if (size.length > 0) {
	        return resize(arr, size, defaultValue);
	      }
	      return arr;
	    }
	  }
	
	  // replace BigNumbers with numbers, returns true if size contained BigNumbers
	  function _normalize(size) {
	    var hasBigNumbers = false;
	    size.forEach(function (value, index, arr) {
	      if (type.isBigNumber(value)) {
	        hasBigNumbers = true;
	        arr[index] = value.toNumber();
	      }
	    });
	    return hasBigNumbers;
	  }
	
	  // validate arguments
	  function _validate (size) {
	    size.forEach(function (value) {
	      if (typeof value !== 'number' || !isInteger(value) || value < 0) {
	        throw new Error('Parameters in function zeros must be positive integers');
	      }
	    });
	  }
	}
	
	// TODO: zeros contains almost the same code as ones. Reuse this?
	
	exports.name = 'zeros';
	exports.factory = factory;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	  var equalScalar = load(__webpack_require__(1364));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether two values are equal.
	   *
	   * The function tests whether the relative difference between x and y is
	   * smaller than the configured epsilon. The function cannot be used to
	   * compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
	   *
	   * Values `null` and `undefined` are compared strictly, thus `null` is only
	   * equal to `null` and nothing else, and `undefined` is only equal to
	   * `undefined` and nothing else. Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.equal(x, y)
	   *
	   * Examples:
	   *
	   *    math.equal(2 + 2, 3);         // returns false
	   *    math.equal(2 + 2, 4);         // returns true
	   *
	   *    var a = math.unit('50 cm');
	   *    var b = math.unit('5 m');
	   *    math.equal(a, b);             // returns true
	   *
	   *    var c = [2, 5, 1];
	   *    var d = [2, 7, 1];
	   *
	   *    math.equal(c, d);             // returns [true, false, true]
	   *    math.deepEqual(c, d);         // returns false
	   *
	   *    math.equal("1000", "1e3");    // returns true
	   *    math.equal(0, null);          // returns false
	   *
	   * See also:
	   *
	   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
	   *
	   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
	   */
	  var equal = typed('equal', {
	    
	    'any, any': function (x, y) {
	      // strict equality for null and undefined?
	      if (x === null) { return y === null; }
	      if (y === null) { return x === null; }
	      if (x === undefined) { return y === undefined; }
	      if (y === undefined) { return x === undefined; }
	
	      return equalScalar(x, y);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, equalScalar);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, equalScalar, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, equalScalar, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, equalScalar);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return equal(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return equal(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return equal(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, equalScalar, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, equalScalar, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, equalScalar, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, equalScalar, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, equalScalar, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, equalScalar, true).valueOf();
	    }
	  });
	
	  equal.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['equal'] + '${args[1]}\\right)'
	  };
	
	  return equal;
	}
	
	exports.name = 'equal';
	exports.factory = factory;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is an numeric value.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isNumeric(x)
	   *
	   * Examples:
	   *
	   *    math.isNumeric(2);                     // returns true
	   *    math.isNumeric(0);                     // returns true
	   *    math.isNumeric(math.bignumber(500));   // returns true
	   *    math.isNumeric(math.fraction(4));      // returns true
	   *    math.isNumeric(math.complex('2-4i');   // returns false
	   *    math.isNumeric('3');                   // returns false
	   *    math.isNumeric([2.3, 'foo', false]);   // returns [true, false, true]
	   *
	   * See also:
	   *
	   *    isZero, isPositive, isNegative, isInteger
	   *
	   * @param {*} x       Value to be tested
	   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
	   *                    `Fraction`, or `boolean`. Returns false for other types.
	   *                    Throws an error in case of unknown types.
	   */
	  var isNumeric = typed('isNumeric', {
	    'number | BigNumber | Fraction | boolean': function () {
	      return true;
	    },
	
	    'Complex | Unit | string': function () {
	      return false;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isNumeric);
	    }
	  });
	
	  return isNumeric;
	}
	
	exports.name = 'isNumeric';
	exports.factory = factory;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var string = __webpack_require__(1341);
	
	function factory (type, config, load, typed) {
	  /**
	   * Format a value of any type into a string.
	   *
	   * Syntax:
	   *
	   *    math.format(value)
	   *    math.format(value, options)
	   *    math.format(value, precision)
	   *    math.format(value, callback)
	   *
	   * Where:
	   *
	   *  - `value: *`
	   *    The value to be formatted
	   *  - `options: Object`
	   *    An object with formatting options. Available options:
	   *    - `notation: string`
	   *      Number notation. Choose from:
	   *      - 'fixed'
	   *        Always use regular number notation.
	   *        For example '123.40' and '14000000'
	   *      - 'exponential'
	   *        Always use exponential notation.
	   *        For example '1.234e+2' and '1.4e+7'
	   *      - 'engineering'
	   *        Always use engineering notation.
	   *        For example '123.4e+0' and '14.0e+6'
	   *      - 'auto' (default)
	   *        Regular number notation for numbers having an absolute value between
	   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
	   *        Lower bound is included, upper bound is excluded.
	   *        For example '123.4' and '1.4e7'.
	   *    - `precision: number`
	   *      A number between 0 and 16 to round the digits of the number. In case
	   *      of notations 'exponential' and 'auto', `precision` defines the total
	   *      number of significant digits returned.
	   *      In case of notation 'fixed', `precision` defines the number of
	   *      significant digits after the decimal point.
	   *      `precision` is undefined by default.
	   *    - `lowerExp: number`
	   *      Exponent determining the lower boundary for formatting a value with 
	   *      an exponent when `notation='auto`. Default value is `-3`.
	   *    - `upperExp: number` 
	   *      Exponent determining the upper boundary for formatting a value with 
	   *      an exponent when `notation='auto`. Default value is `5`.
	   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
	   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
	   *      configured, and will output `0.(3)` when 'decimal' is configured.
	   * - `callback: function`
	   *   A custom formatting function, invoked for all numeric elements in `value`,
	   *   for example all elements of a matrix, or the real and imaginary
	   *   parts of a complex number. This callback can be used to override the
	   *   built-in numeric notation with any type of formatting. Function `callback`
	   *   is called with `value` as parameter and must return a string.
	   *
	   * When `value` is an Object:
	   *
	   * - When the object contains a property `format` being a function, this function
	   *   is invoked as `value.format(options)` and the result is returned.
	   * - When the object has its own `toString` method, this method is invoked
	   *   and the result is returned.
	   * - In other cases the function will loop over all object properties and
	   *   return JSON object notation like '{"a": 2, "b": 3}'.
	   *
	   * When value is a function:
	   *
	   * - When the function has a property `syntax`, it returns this
	   *   syntax description.
	   * - In other cases, a string `'function'` is returned.
	   *
	   * Examples:
	   *
	   *    math.format(6.4);                                        // returns '6.4'
	   *    math.format(1240000);                                    // returns '1.24e6'
	   *    math.format(1/3);                                        // returns '0.3333333333333333'
	   *    math.format(1/3, 3);                                     // returns '0.333'
	   *    math.format(21385, 2);                                   // returns '21000'
	   *    math.format(12e8, {notation: 'fixed'});                  // returns '1200000000'
	   *    math.format(2.3,  {notation: 'fixed', precision: 4});    // returns '2.3000'
	   *    math.format(52.8, {notation: 'exponential'});            // returns '5.28e+1'
	   *    math.format(12400,{notation: 'engineering'});            // returns '12.400e+3'
	   *    math.format(2000, {lowerExp: -2, upperExp: 2});          // returns '2e+3'
	   *
	   *    function formatCurrency(value) {
	   *      // return currency notation with two digits:
	   *      return '$' + value.toFixed(2);
	   *
	   *      // you could also use math.format inside the callback:
	   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2});
	   *    }
	   *    math.format([2.1, 3, 0.016], formatCurrency};            // returns '[$2.10, $3.00, $0.02]'
	   *
	   * See also:
	   *
	   *    print
	   *
	   * @param {*} value                               Value to be stringified
	   * @param {Object | Function | number} [options]  Formatting options
	   * @return {string} The formatted value
	   */
	  var format = typed('format', {
	    'any': string.format,
	    'any, Object | function | number': string.format
	  });
	
	  format.toTex = undefined; // use default template
	
	  return format;
	}
	
	exports.name = 'format';
	exports.factory = factory;


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * Determine the type of a variable.
	   *
	   * Function `typeof` recognizes the following types of objects:
	   *
	   * Object                 | Returns       | Example
	   * ---------------------- | ------------- | ------------------------------------------
	   * null                   | `'null'`      | `math.typeof(null)`
	   * number                 | `'number'`    | `math.typeof(3.5)`
	   * boolean                | `'boolean'`   | `math.typeof(true)`
	   * string                 | `'string'`    | `math.typeof('hello world')`
	   * Array                  | `'Array'`     | `math.typeof([1, 2, 3])`
	   * Date                   | `'Date'`      | `math.typeof(new Date())`
	   * Function               | `'Function'`  | `math.typeof(function () {})`
	   * Object                 | `'Object'`    | `math.typeof({a: 2, b: 3})`
	   * RegExp                 | `'RegExp'`    | `math.typeof(/a regexp/)`
	   * undefined              | `'undefined'` | `math.typeof(undefined)`
	   * math.type.BigNumber    | `'BigNumber'` | `math.typeof(math.bignumber('2.3e500'))`
	   * math.type.Chain        | `'Chain'`     | `math.typeof(math.chain(2))`
	   * math.type.Complex      | `'Complex'`   | `math.typeof(math.complex(2, 3))`
	   * math.type.Fraction     | `'Fraction'`  | `math.typeof(math.fraction(1, 3))`
	   * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
	   * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
	   * math.type.Index        | `'Index'`     | `math.typeof(math.index(1, 3))`
	   * math.type.Matrix       | `'Matrix'`    | `math.typeof(math.matrix([[1,2], [3, 4]]))`
	   * math.type.Range        | `'Range'`     | `math.typeof(math.range(0, 10))`
	   * math.type.ResultSet    | `'ResultSet'` | `math.typeof(math.eval('a=2\nb=3'))`
	   * math.type.Unit         | `'Unit'`      | `math.typeof(math.unit('45 deg'))`
	   * math.expression.node.AccessorNode            | `'AccessorNode'`            | `math.typeof(math.parse('A[2]'))`
	   * math.expression.node.ArrayNode               | `'ArrayNode'`               | `math.typeof(math.parse('[1,2,3]'))`
	   * math.expression.node.AssignmentNode          | `'AssignmentNode'`          | `math.typeof(math.parse('x=2'))`
	   * math.expression.node.BlockNode               | `'BlockNode'`               | `math.typeof(math.parse('a=2; b=3'))`
	   * math.expression.node.ConditionalNode         | `'ConditionalNode'`         | `math.typeof(math.parse('x<0 ? -x : x'))`
	   * math.expression.node.ConstantNode            | `'ConstantNode'`            | `math.typeof(math.parse('2.3'))`
	   * math.expression.node.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeof(math.parse('f(x)=x^2'))`
	   * math.expression.node.FunctionNode            | `'FunctionNode'`            | `math.typeof(math.parse('sqrt(4)'))`
	   * math.expression.node.IndexNode               | `'IndexNode'`               | `math.typeof(math.parse('A[2]').index)`
	   * math.expression.node.ObjectNode              | `'ObjectNode'`              | `math.typeof(math.parse('{a:2}'))`
	   * math.expression.node.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeof(math.parse('(2+3)'))`
	   * math.expression.node.RangeNode               | `'RangeNode'`               | `math.typeof(math.parse('1:10'))`
	   * math.expression.node.SymbolNode              | `'SymbolNode'`              | `math.typeof(math.parse('x'))`
	   *
	   * Syntax:
	   *
	   *    math.typeof(x)
	   *
	   * Examples:
	   *
	   *    math.typeof(3.5);                     // returns 'number'
	   *    math.typeof(math.complex('2-4i'));    // returns 'Complex'
	   *    math.typeof(math.unit('45 deg'));     // returns 'Unit'
	   *    math.typeof('hello world');           // returns 'string'
	   *
	   * @param {*} x     The variable for which to test the type.
	   * @return {string} Returns the name of the type. Primitive types are lower case,
	   *                  non-primitive types are upper-camel-case.
	   *                  For example 'number', 'string', 'Array', 'Date'.
	   */
	  var _typeof = typed('_typeof', {
	    'any': function (x) {
	      var t = typeof x;
	
	      if (t === 'object') {
	        // JavaScript types
	        if (x === null)           return 'null';
	        if (Array.isArray(x))     return 'Array';
	        if (x instanceof Date)    return 'Date';
	        if (x instanceof RegExp)  return 'RegExp';
	        if (x instanceof Boolean) return 'boolean';
	        if (x instanceof Number)  return 'number';
	        if (x instanceof String)  return 'string';
	
	        // math.js types
	        if (type.isBigNumber(x)) return 'BigNumber';
	        if (type.isComplex(x))   return 'Complex';
	        if (type.isFraction(x))  return 'Fraction';
	        if (type.isMatrix(x))    return 'Matrix';
	        if (type.isUnit(x))      return 'Unit';
	        if (type.isIndex(x))     return 'Index';
	        if (type.isRange(x))     return 'Range';
	        if (type.isResultSet(x)) return 'ResultSet';
	        if (type.isNode(x))      return x.type;
	        if (type.isChain(x))     return 'Chain';
	        if (type.isHelp(x))      return 'Help';
	
	        return 'Object';
	      }
	
	      if (t === 'function') return 'Function';
	
	      return t; // can be 'string', 'number', 'boolean', ...
	    }
	  });
	
	  _typeof.toTex = undefined; // use default template
	
	  return _typeof;
	}
	
	exports.name = 'typeof';
	exports.factory = factory;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a unit. Depending on the passed arguments, the function
	   * will create and return a new math.type.Unit object.
	   * When a matrix is provided, all elements will be converted to units.
	   *
	   * Syntax:
	   *
	   *     math.unit(unit : string)
	   *     math.unit(value : number, unit : string)
	   *
	   * Examples:
	   *
	   *    var a = math.unit(5, 'cm');    // returns Unit 50 mm
	   *    var b = math.unit('23 kg');    // returns Unit 23 kg
	   *    a.to('m');                     // returns Unit 0.05 m
	   *
	   * See also:
	   *
	   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
	   *
	   * @param {* | Array | Matrix} args   A number and unit.
	   * @return {Unit | Array | Matrix}    The created unit
	   */
	
	  var unit = typed('unit', {
	    'Unit': function (x) {
	      return x.clone();
	    },
	
	    'string': function (x) {
	      if (type.Unit.isValuelessUnit(x)) {
	        return new type.Unit(null, x); // a pure unit
	      }
	
	      return type.Unit.parse(x); // a unit with value, like '5cm'
	    },
	
	    'number | BigNumber | Fraction | Complex, string': function (value, unit) {
	      return new type.Unit(value, unit);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, unit);
	    }
	  });
	
	  unit.toTex = {
	    1: '\\left(${args[0]}\\right)',
	    2: '\\left(\\left(${args[0]}\\right)${args[1]}\\right)'
	  };
	
	  return unit;
	}
	
	exports.name = 'unit';
	exports.factory = factory;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a user-defined unit and register it with the Unit type.
	   *
	   * Syntax:
	   *
	   *     math.createUnit({
	   *       baseUnit1: {
	   *         aliases: [string, ...]
	   *         prefixes: object
	   *       },
	   *       unit2: {
	   *         definition: string,
	   *         aliases: [string, ...]
	   *         prefixes: object,
	   *         offset: number
	   *       },
	   *       unit3: string    // Shortcut
	   *     })
	   *
	   *     // Another shortcut:
	   *     math.createUnit(string, unit : string, [object])
	   *
	   * Examples: 
	   *
	   *     math.createUnit('foo');
	   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']});
	   *     math.createUnit('mph', '1 mile/hour');
	   *
	   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
	   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
	   * @param {Object} options   (optional) An object containing any of the following properties:
	   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
	   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
	   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
	   *
	   * See also:
	   *
	   *     unit
	   *
	   * @return {Unit} The new unit
	   */
	  var createUnit = typed('createUnit', {
	
	    // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
	    'Object, Object': function(obj, options) {
	      return type.Unit.createUnit(obj, options);
	    },
	
	    // Same as above but without the options.
	    'Object': function(obj) {
	      return type.Unit.createUnit(obj, {});
	    },
	
	    // Shortcut method for creating one unit.
	    'string, Unit | string | Object, Object': function (name, def, options) {
	      var obj = {};
	      obj[name] = def;
	      return type.Unit.createUnit(obj, options);
	    },
	
	    // Same as above but without the options.
	    'string, Unit | string | Object': function (name, def) {
	      var obj = {};
	      obj[name] = def;
	      return type.Unit.createUnit(obj, {});
	    },
	
	    // Without a definition, creates a base unit.
	    'string': function (name) {
	      var obj = {};
	      obj[name] = {};
	      return type.Unit.createUnit(obj, {});
	    },
	  });
	
	  return createUnit;
	}
	
	exports.name = 'createUnit';
	exports.factory = factory;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Split a unit in an array of units whose sum is equal to the original unit.
	   *
	   * Syntax:
	   *
	   *     splitUnit(unit: Unit, parts: Array.<Unit>)
	   *
	   * Example:
	   *
	   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch']);
	   *     // [ 3 feet, 3.3700787401575 inch ]
	   *
	   * See also:
	   *
	   *     unit
	   *
	   * @param {Array} [parts] An array of strings or valueless units.
	   * @return {Array} An array of units.
	   */
	  var splitUnit = typed('splitUnit', {
	    'Unit, Array': function(unit, parts) {
	      return unit.splitUnit(parts);
	    }
	  });
	
	  return splitUnit;
	
	}
	
	exports.name = 'splitUnit';
	exports.factory = factory;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var lazy = __webpack_require__(1320).lazy;
	
	
	function factory (type, config, load, typed, math) {
	
	  // helper function to create a unit with a fixed prefix
	  function fixedUnit(str) {
	    var unit = type.Unit.parse(str);
	    unit.fixPrefix = true;
	    return unit;
	  }
	
	  // Source: http://www.wikiwand.com/en/Physical_constant
	
	  // Universal constants
	  setLazyConstant(math, 'speedOfLight',         function () {return fixedUnit('299792458 m s^-1')});
	  setLazyConstant(math, 'gravitationConstant',  function () {return fixedUnit('6.6738480e-11 m^3 kg^-1 s^-2')});
	  setLazyConstant(math, 'planckConstant',       function () {return fixedUnit('6.626069311e-34 J s')});
	  setLazyConstant(math, 'reducedPlanckConstant',function () {return fixedUnit('1.05457172647e-34 J s')});
	
	  // Electromagnetic constants
	  setLazyConstant(math, 'magneticConstant',          function () {return fixedUnit('1.2566370614e-6 N A^-2')});
	  setLazyConstant(math, 'electricConstant',          function () {return fixedUnit('8.854187817e-12 F m^-1')});
	  setLazyConstant(math, 'vacuumImpedance',           function () {return fixedUnit('376.730313461 ohm')});
	  setLazyConstant(math, 'coulomb',                   function () {return fixedUnit('8.9875517873681764e9 N m^2 C^-2')});
	  setLazyConstant(math, 'elementaryCharge',          function () {return fixedUnit('1.60217656535e-19 C')});
	  setLazyConstant(math, 'bohrMagneton',              function () {return fixedUnit('9.2740096820e-24 J T^-1')});
	  setLazyConstant(math, 'conductanceQuantum',        function () {return fixedUnit('7.748091734625e-5 S')});
	  setLazyConstant(math, 'inverseConductanceQuantum', function () {return fixedUnit('12906.403721742 ohm')});
	  setLazyConstant(math, 'magneticFluxQuantum',       function () {return fixedUnit('2.06783375846e-15 Wb')});
	  setLazyConstant(math, 'nuclearMagneton',           function () {return fixedUnit('5.0507835311e-27 J T^-1')});
	  setLazyConstant(math, 'klitzing',                  function () {return fixedUnit('25812.807443484 ohm')});
	  //setLazyConstant(math, 'josephson',                 function () {return fixedUnit('4.8359787011e-14 Hz V^-1')});  // TODO: support for Hz needed
	
	  // Atomic and nuclear constants
	  setLazyConstant(math, 'bohrRadius',              function () {return fixedUnit('5.291772109217e-11 m')});
	  setLazyConstant(math, 'classicalElectronRadius', function () {return fixedUnit('2.817940326727e-15 m')});
	  setLazyConstant(math, 'electronMass',            function () {return fixedUnit('9.1093829140e-31 kg')});
	  setLazyConstant(math, 'fermiCoupling',           function () {return fixedUnit('1.1663645e-5 GeV^-2')});
	  setLazyConstant(math, 'fineStructure',           function () {return 7.297352569824e-3});
	  setLazyConstant(math, 'hartreeEnergy',           function () {return fixedUnit('4.3597443419e-18 J')});
	  setLazyConstant(math, 'protonMass',              function () {return fixedUnit('1.67262177774e-27 kg')});
	  setLazyConstant(math, 'deuteronMass',            function () {return fixedUnit('3.3435830926e-27 kg')});
	  setLazyConstant(math, 'neutronMass',             function () {return fixedUnit('1.6749271613e-27 kg')});
	  setLazyConstant(math, 'quantumOfCirculation',    function () {return fixedUnit('3.636947552024e-4 m^2 s^-1')});
	  setLazyConstant(math, 'rydberg',                 function () {return fixedUnit('10973731.56853955 m^-1')});
	  setLazyConstant(math, 'thomsonCrossSection',     function () {return fixedUnit('6.65245873413e-29 m^2')});
	  setLazyConstant(math, 'weakMixingAngle',         function () {return 0.222321});
	  setLazyConstant(math, 'efimovFactor',            function () {return 22.7});
	
	  // Physico-chemical constants
	  setLazyConstant(math, 'atomicMass',          function () {return fixedUnit('1.66053892173e-27 kg')});
	  setLazyConstant(math, 'avogadro',            function () {return fixedUnit('6.0221412927e23 mol^-1')});
	  setLazyConstant(math, 'boltzmann',           function () {return fixedUnit('1.380648813e-23 J K^-1')});
	  setLazyConstant(math, 'faraday',             function () {return fixedUnit('96485.336521 C mol^-1')});
	  setLazyConstant(math, 'firstRadiation',      function () {return fixedUnit('3.7417715317e-16 W m^2')});
	  // setLazyConstant(math, 'spectralRadiance',   function () {return fixedUnit('1.19104286953e-16 W m^2 sr^-1')}); // TODO spectralRadiance
	  setLazyConstant(math, 'loschmidt',           function () {return fixedUnit('2.686780524e25 m^-3')});
	  setLazyConstant(math, 'gasConstant',         function () {return fixedUnit('8.314462175 J K^-1 mol^-1')});
	  setLazyConstant(math, 'molarPlanckConstant', function () {return fixedUnit('3.990312717628e-10 J s mol^-1')});
	  setLazyConstant(math, 'molarVolume',         function () {return fixedUnit('2.241396820e-10 m^3 mol^-1')});
	  setLazyConstant(math, 'sackurTetrode',       function () {return -1.164870823});
	  setLazyConstant(math, 'secondRadiation',     function () {return fixedUnit('1.438777013e-2 m K')});
	  setLazyConstant(math, 'stefanBoltzmann',     function () {return fixedUnit('5.67037321e-8 W m^-2 K^-4')});
	  setLazyConstant(math, 'wienDisplacement',    function () {return fixedUnit('2.897772126e-3 m K')});
	
	  // Adopted values
	  setLazyConstant(math, 'molarMass',         function () {return fixedUnit('1e-3 kg mol^-1')});
	  setLazyConstant(math, 'molarMassC12',      function () {return fixedUnit('1.2e-2 kg mol^-1')});
	  setLazyConstant(math, 'gravity',           function () {return fixedUnit('9.80665 m s^-2')});
	  // atm is defined in Unit.js
	
	  // Natural units
	  setLazyConstant(math, 'planckLength',      function () {return fixedUnit('1.61619997e-35 m')});
	  setLazyConstant(math, 'planckMass',        function () {return fixedUnit('2.1765113e-8 kg')});
	  setLazyConstant(math, 'planckTime',        function () {return fixedUnit('5.3910632e-44 s')});
	  setLazyConstant(math, 'planckCharge',      function () {return fixedUnit('1.87554595641e-18 C')});
	  setLazyConstant(math, 'planckTemperature', function () {return fixedUnit('1.41683385e+32 K')});
	
	}
	
	// create a lazy constant in both math and mathWithTransform
	function setLazyConstant (math, name, resolver) {
	  lazy(math, name,  resolver);
	  lazy(math.expression.mathWithTransform, name,  resolver);
	}
	
	exports.factory = factory;
	exports.lazy = false;  // no lazy loading of constants, the constants themselves are lazy when needed
	exports.math = true;   // request access to the math namespace


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object = __webpack_require__(1320);
	var bigConstants = __webpack_require__(1392);
	
	function factory (type, config, load, typed, math) {
	  // listen for changed in the configuration, automatically reload
	  // constants when needed
	  math.on('config', function (curr, prev) {
	    if (curr.number !== prev.number) {
	      factory(type, config, load, typed, math);
	    }
	  });
	
	  setConstant(math, 'true', true);
	  setConstant(math, 'false', false);
	  setConstant(math, 'null', null);
	  setConstant(math, 'uninitialized', 'Error: Constant uninitialized is removed since v4.0.0. Use null instead');
	
	  if (config.number === 'BigNumber') {
	    setConstant(math, 'Infinity', new type.BigNumber(Infinity));
	    setConstant(math, 'NaN', new type.BigNumber(NaN));
	
	    setLazyConstant(math, 'pi',  function () {return bigConstants.pi(type.BigNumber)});
	    setLazyConstant(math, 'tau', function () {return bigConstants.tau(type.BigNumber)});
	    setLazyConstant(math, 'e',   function () {return bigConstants.e(type.BigNumber)});
	    setLazyConstant(math, 'phi', function () {return bigConstants.phi(type.BigNumber)}); // golden ratio, (1+sqrt(5))/2
	
	    // uppercase constants (for compatibility with built-in Math)
	    setLazyConstant(math, 'E',       function () {return math.e;});
	    setLazyConstant(math, 'LN2',     function () {return new type.BigNumber(2).ln();});
	    setLazyConstant(math, 'LN10',    function () {return new type.BigNumber(10).ln()});
	    setLazyConstant(math, 'LOG2E',   function () {return new type.BigNumber(1).div(new type.BigNumber(2).ln());});
	    setLazyConstant(math, 'LOG10E',  function () {return new type.BigNumber(1).div(new type.BigNumber(10).ln())});
	    setLazyConstant(math, 'PI',      function () {return math.pi});
	    setLazyConstant(math, 'SQRT1_2', function () {return new type.BigNumber('0.5').sqrt()});
	    setLazyConstant(math, 'SQRT2',   function () {return new type.BigNumber(2).sqrt()});
	  }
	  else {
	    setConstant(math, 'Infinity', Infinity);
	    setConstant(math, 'NaN',      NaN);
	
	    setConstant(math, 'pi',  Math.PI);
	    setConstant(math, 'tau', Math.PI * 2);
	    setConstant(math, 'e',   Math.E);
	    setConstant(math, 'phi', 1.61803398874989484820458683436563811772030917980576286213545); // golden ratio, (1+sqrt(5))/2
	
	    // uppercase constants (for compatibility with built-in Math)
	    setConstant(math, 'E',           math.e);
	    setConstant(math, 'LN2',         Math.LN2);
	    setConstant(math, 'LN10',        Math.LN10);
	    setConstant(math, 'LOG2E',       Math.LOG2E);
	    setConstant(math, 'LOG10E',      Math.LOG10E);
	    setConstant(math, 'PI',          math.pi);
	    setConstant(math, 'SQRT1_2',     Math.SQRT1_2);
	    setConstant(math, 'SQRT2',       Math.SQRT2);
	  }
	
	  // complex i
	  setConstant(math, 'i', type.Complex.I);
	
	  // meta information
	  setConstant(math, 'version', __webpack_require__(1415));
	}
	
	// create a constant in both math and mathWithTransform
	function setConstant(math, name, value) {
	  math[name] = value;
	  math.expression.mathWithTransform[name] = value;
	}
	
	// create a lazy constant in both math and mathWithTransform
	function setLazyConstant (math, name, resolver) {
	  object.lazy(math, name,  resolver);
	  object.lazy(math.expression.mathWithTransform, name,  resolver);
	}
	
	exports.factory = factory;
	exports.lazy = false;  // no lazy loading of constants, the constants themselves are lazy when needed
	exports.math = true;   // request access to the math namespace


/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	module.exports = '4.4.2';
	// Note: This file is automatically generated when building math.js.
	// Changes made in this file will be overwritten.


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  // Note that the docs folder is called "embeddedDocs" and not "docs" to prevent issues
	  // with yarn autoclean. See https://github.com/josdejong/mathjs/issues/969
	  __webpack_require__(1417),
	  __webpack_require__(1619),
	  __webpack_require__(1650),
	  __webpack_require__(1652),
	
	  __webpack_require__(1678),
	  __webpack_require__(1621),
	  __webpack_require__(1649)
	];


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	function factory (construction, config, load, typed) {
	  var docs = {};
	
	
	  // construction functions
	  docs.bignumber = __webpack_require__(1418);
	  docs['boolean'] = __webpack_require__(1419);
	  docs.complex = __webpack_require__(1420);
	  docs.createUnit = __webpack_require__(1421);
	  docs.fraction = __webpack_require__(1422);
	  docs.index = __webpack_require__(1423);
	  docs.matrix = __webpack_require__(1424);
	  docs.number = __webpack_require__(1425);
	  docs.sparse = __webpack_require__(1426);
	  docs.splitUnit = __webpack_require__(1427);
	  docs.string = __webpack_require__(1428);
	  docs.unit = __webpack_require__(1429);
	
	  // constants
	  docs.e = __webpack_require__(1430);
	  docs.E = __webpack_require__(1430);
	  docs['false'] = __webpack_require__(1431);
	  docs.i = __webpack_require__(1432);
	  docs['Infinity'] = __webpack_require__(1433);
	  docs.LN2 = __webpack_require__(1434);
	  docs.LN10 = __webpack_require__(1435);
	  docs.LOG2E = __webpack_require__(1436);
	  docs.LOG10E = __webpack_require__(1437);
	  docs.NaN = __webpack_require__(1438);
	  docs['null'] = __webpack_require__(1439);
	  docs.pi = __webpack_require__(1440);
	  docs.PI = __webpack_require__(1440);
	  docs.phi = __webpack_require__(1441);
	  docs.SQRT1_2 = __webpack_require__(1442);
	  docs.SQRT2 = __webpack_require__(1443);
	  docs.tau = __webpack_require__(1444);
	  docs['true'] = __webpack_require__(1445);
	  docs.version = __webpack_require__(1446);
	
	  // physical constants
	  // TODO: more detailed docs for physical constants
	  docs.speedOfLight = {description: 'Speed of light in vacuum', examples: ['speedOfLight']};
	  docs.gravitationConstant = {description: 'Newtonian constant of gravitation', examples: ['gravitationConstant']};
	  docs.planckConstant = {description: 'Planck constant', examples: ['planckConstant']};
	  docs.reducedPlanckConstant = {description: 'Reduced Planck constant', examples: ['reducedPlanckConstant']};
	
	  docs.magneticConstant = {description: 'Magnetic constant (vacuum permeability)', examples: ['magneticConstant']};
	  docs.electricConstant = {description: 'Electric constant (vacuum permeability)', examples: ['electricConstant']};
	  docs.vacuumImpedance = {description: 'Characteristic impedance of vacuum', examples: ['vacuumImpedance']};
	  docs.coulomb = {description: 'Coulomb\'s constant', examples: ['coulomb']};
	  docs.elementaryCharge = {description: 'Elementary charge', examples: ['elementaryCharge']};
	  docs.bohrMagneton = {description: 'Borh magneton', examples: ['bohrMagneton']};
	  docs.conductanceQuantum = {description: 'Conductance quantum', examples: ['conductanceQuantum']};
	  docs.inverseConductanceQuantum = {description: 'Inverse conductance quantum', examples: ['inverseConductanceQuantum']};
	  //docs.josephson = {description: 'Josephson constant', examples: ['josephson']};
	  docs.magneticFluxQuantum = {description: 'Magnetic flux quantum', examples: ['magneticFluxQuantum']};
	  docs.nuclearMagneton = {description: 'Nuclear magneton', examples: ['nuclearMagneton']};
	  docs.klitzing = {description: 'Von Klitzing constant', examples: ['klitzing']};
	
	  docs.bohrRadius = {description: 'Borh radius', examples: ['bohrRadius']};
	  docs.classicalElectronRadius = {description: 'Classical electron radius', examples: ['classicalElectronRadius']};
	  docs.electronMass = {description: 'Electron mass', examples: ['electronMass']};
	  docs.fermiCoupling = {description: 'Fermi coupling constant', examples: ['fermiCoupling']};
	  docs.fineStructure = {description: 'Fine-structure constant', examples: ['fineStructure']};
	  docs.hartreeEnergy = {description: 'Hartree energy', examples: ['hartreeEnergy']};
	  docs.protonMass = {description: 'Proton mass', examples: ['protonMass']};
	  docs.deuteronMass = {description: 'Deuteron Mass', examples: ['deuteronMass']};
	  docs.neutronMass = {description: 'Neutron mass', examples: ['neutronMass']};
	  docs.quantumOfCirculation = {description: 'Quantum of circulation', examples: ['quantumOfCirculation']};
	  docs.rydberg = {description: 'Rydberg constant', examples: ['rydberg']};
	  docs.thomsonCrossSection = {description: 'Thomson cross section', examples: ['thomsonCrossSection']};
	  docs.weakMixingAngle = {description: 'Weak mixing angle', examples: ['weakMixingAngle']};
	  docs.efimovFactor = {description: 'Efimov factor', examples: ['efimovFactor']};
	
	  docs.atomicMass = {description: 'Atomic mass constant', examples: ['atomicMass']};
	  docs.avogadro = {description: 'Avogadro\'s number', examples: ['avogadro']};
	  docs.boltzmann = {description: 'Boltzmann constant', examples: ['boltzmann']};
	  docs.faraday = {description: 'Faraday constant', examples: ['faraday']};
	  docs.firstRadiation = {description: 'First radiation constant', examples: ['firstRadiation']};
	  docs.loschmidt = {description: 'Loschmidt constant at T=273.15 K and p=101.325 kPa', examples: ['loschmidt']};
	  docs.gasConstant = {description: 'Gas constant', examples: ['gasConstant']};
	  docs.molarPlanckConstant = {description: 'Molar Planck constant', examples: ['molarPlanckConstant']};
	  docs.molarVolume = {description: 'Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa', examples: ['molarVolume']};
	  docs.sackurTetrode = {description: 'Sackur-Tetrode constant at T=1 K and p=101.325 kPa', examples: ['sackurTetrode']};
	  docs.secondRadiation = {description: 'Second radiation constant', examples: ['secondRadiation']};
	  docs.stefanBoltzmann = {description: 'Stefan-Boltzmann constant', examples: ['stefanBoltzmann']};
	  docs.wienDisplacement = {description: 'Wien displacement law constant', examples: ['wienDisplacement']};
	  //docs.spectralRadiance = {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']};
	
	  docs.molarMass = {description: 'Molar mass constant', examples: ['molarMass']};
	  docs.molarMassC12 = {description: 'Molar mass constant of carbon-12', examples: ['molarMassC12']};
	  docs.gravity = {description: 'Standard acceleration of gravity (standard acceleration of free-fall on Earth)', examples: ['gravity']};
	
	  docs.planckLength = {description: 'Planck length', examples: ['planckLength']};
	  docs.planckMass = {description: 'Planck mass', examples: ['planckMass']};
	  docs.planckTime = {description: 'Planck time', examples: ['planckTime']};
	  docs.planckCharge = {description: 'Planck charge', examples: ['planckCharge']};
	  docs.planckTemperature = {description: 'Planck temperature', examples: ['planckTemperature']};
	
	  // functions - algebra
	  docs.derivative = __webpack_require__(1447);
	  docs.lsolve = __webpack_require__(1448);
	  docs.lup = __webpack_require__(1449);
	  docs.lusolve = __webpack_require__(1450);
	  docs.simplify = __webpack_require__(1451);
	  docs.rationalize = __webpack_require__(1452);
	  docs.slu = __webpack_require__(1453);
	  docs.usolve = __webpack_require__(1454);
	  docs.qr = __webpack_require__(1455);
	
	  // functions - arithmetic
	  docs.abs = __webpack_require__(1456);
	  docs.add = __webpack_require__(1457);
	  docs.cbrt = __webpack_require__(1458);
	  docs.ceil = __webpack_require__(1459);
	  docs.cube = __webpack_require__(1460);
	  docs.divide = __webpack_require__(1461);
	  docs.dotDivide = __webpack_require__(1462);
	  docs.dotMultiply = __webpack_require__(1463);
	  docs.dotPow = __webpack_require__(1464);
	  docs.exp = __webpack_require__(1465);
	  docs.expm = __webpack_require__(1466);
	  docs.expm1 = __webpack_require__(1467);
	  docs.fix = __webpack_require__(1468);
	  docs.floor = __webpack_require__(1469);
	  docs.gcd = __webpack_require__(1470);
	  docs.hypot = __webpack_require__(1471);
	  docs.lcm = __webpack_require__(1472);
	  docs.log = __webpack_require__(1473);
	  docs.log2 = __webpack_require__(1474);
	  docs.log1p = __webpack_require__(1475);
	  docs.log10 = __webpack_require__(1476);
	  docs.mod = __webpack_require__(1477);
	  docs.multiply = __webpack_require__(1478);
	  docs.norm = __webpack_require__(1479);
	  docs.nthRoot = __webpack_require__(1480);
	  docs.pow = __webpack_require__(1481);
	  docs.round = __webpack_require__(1482);
	  docs.sign = __webpack_require__(1483);
	  docs.sqrt = __webpack_require__(1484);
	  docs.sqrtm = __webpack_require__(1485);
	  docs.square = __webpack_require__(1486);
	  docs.subtract = __webpack_require__(1487);
	  docs.unaryMinus = __webpack_require__(1488);
	  docs.unaryPlus = __webpack_require__(1489);
	  docs.xgcd = __webpack_require__(1490);
	
	  // functions - bitwise
	  docs.bitAnd = __webpack_require__(1491);
	  docs.bitNot = __webpack_require__(1492);
	  docs.bitOr = __webpack_require__(1493);
	  docs.bitXor = __webpack_require__(1494);
	  docs.leftShift = __webpack_require__(1495);
	  docs.rightArithShift = __webpack_require__(1496);
	  docs.rightLogShift = __webpack_require__(1497);
	
	  // functions - combinatorics
	  docs.bellNumbers = __webpack_require__(1498);
	  docs.catalan = __webpack_require__(1499);
	  docs.composition = __webpack_require__(1500);
	  docs.stirlingS2 = __webpack_require__(1501);
	
	  // functions - core
	  docs['config'] =  __webpack_require__(1502);
	  docs['import'] =  __webpack_require__(1503);
	  docs['typed'] =  __webpack_require__(1504);
	
	  // functions - complex
	  docs.arg = __webpack_require__(1505);
	  docs.conj = __webpack_require__(1506);
	  docs.re = __webpack_require__(1507);
	  docs.im = __webpack_require__(1508);
	
	  // functions - expression
	  docs['eval'] =  __webpack_require__(1509);
	  docs.help =  __webpack_require__(1510);
	
	  // functions - geometry
	  docs.distance = __webpack_require__(1511);
	  docs.intersect = __webpack_require__(1512);
	
	  // functions - logical
	  docs['and'] = __webpack_require__(1513);
	  docs['not'] = __webpack_require__(1514);
	  docs['or'] = __webpack_require__(1515);
	  docs['xor'] = __webpack_require__(1516);
	
	  // functions - matrix
	  docs['concat'] = __webpack_require__(1517);
	  docs.cross = __webpack_require__(1518);
	  docs.det = __webpack_require__(1519);
	  docs.diag = __webpack_require__(1520);
	  docs.dot = __webpack_require__(1521);
	  docs.eye = __webpack_require__(1522);
	  docs.filter =  __webpack_require__(1523);
	  docs.flatten = __webpack_require__(1524);
	  docs.forEach =  __webpack_require__(1525);
	  docs.inv = __webpack_require__(1526);
	  docs.kron = __webpack_require__(1527);
	  docs.map =  __webpack_require__(1528);
	  docs.ones = __webpack_require__(1529);
	  docs.partitionSelect =  __webpack_require__(1530);
	  docs.range = __webpack_require__(1531);
	  docs.resize = __webpack_require__(1532);
	  docs.reshape = __webpack_require__(1533);
	  docs.size = __webpack_require__(1534);
	  docs.sort =  __webpack_require__(1535);
	  docs.squeeze = __webpack_require__(1536);
	  docs.subset = __webpack_require__(1537);
	  docs.trace = __webpack_require__(1538);
	  docs.transpose = __webpack_require__(1539);
	  docs.zeros = __webpack_require__(1540);
	
	  // functions - probability
	  docs.combinations = __webpack_require__(1541);
	  //docs.distribution = require('./function/probability/distribution');
	  docs.factorial = __webpack_require__(1542);
	  docs.gamma = __webpack_require__(1543);
	  docs.kldivergence = __webpack_require__(1544);
	  docs.multinomial = __webpack_require__(1545);
	  docs.permutations = __webpack_require__(1546);
	  docs.pickRandom = __webpack_require__(1547);
	  docs.random = __webpack_require__(1548);
	  docs.randomInt = __webpack_require__(1549);
	
	  // functions - relational
	  docs.compare = __webpack_require__(1550);
	  docs.compareNatural = __webpack_require__(1551);
	  docs.compareText = __webpack_require__(1552);
	  docs.deepEqual = __webpack_require__(1553);
	  docs['equal'] = __webpack_require__(1554);
	  docs.equalText = __webpack_require__(1555);
	  docs.larger = __webpack_require__(1556);
	  docs.largerEq = __webpack_require__(1557);
	  docs.smaller = __webpack_require__(1558);
	  docs.smallerEq = __webpack_require__(1559);
	  docs.unequal = __webpack_require__(1560);
	
	  // functions - set
	  docs.setCartesian = __webpack_require__(1561);
	  docs.setDifference = __webpack_require__(1562);
	  docs.setDistinct = __webpack_require__(1563);
	  docs.setIntersect = __webpack_require__(1564);
	  docs.setIsSubset = __webpack_require__(1565);
	  docs.setMultiplicity = __webpack_require__(1566);
	  docs.setPowerset = __webpack_require__(1567);
	  docs.setSize = __webpack_require__(1568);
	  docs.setSymDifference = __webpack_require__(1569);
	  docs.setUnion = __webpack_require__(1570);
	
	  // functions - special
	  docs.erf = __webpack_require__(1571);
	
	  // functions - statistics
	  docs.mad = __webpack_require__(1572);
	  docs.max = __webpack_require__(1573);
	  docs.mean = __webpack_require__(1574);
	  docs.median = __webpack_require__(1575);
	  docs.min = __webpack_require__(1576);
	  docs.mode = __webpack_require__(1577);
	  docs.prod = __webpack_require__(1578);
	  docs.quantileSeq = __webpack_require__(1579);
	  docs.std = __webpack_require__(1580);
	  docs.sum = __webpack_require__(1581);
	  docs['var'] = __webpack_require__(1582);
	
	  // functions - trigonometry
	  docs.acos = __webpack_require__(1583);
	  docs.acosh = __webpack_require__(1584);
	  docs.acot = __webpack_require__(1585);
	  docs.acoth = __webpack_require__(1586);
	  docs.acsc = __webpack_require__(1587);
	  docs.acsch = __webpack_require__(1588);
	  docs.asec = __webpack_require__(1589);
	  docs.asech = __webpack_require__(1590);
	  docs.asin = __webpack_require__(1591);
	  docs.asinh = __webpack_require__(1592);
	  docs.atan = __webpack_require__(1593);
	  docs.atanh = __webpack_require__(1594);
	  docs.atan2 = __webpack_require__(1595);
	  docs.cos = __webpack_require__(1596);
	  docs.cosh = __webpack_require__(1597);
	  docs.cot = __webpack_require__(1598);
	  docs.coth = __webpack_require__(1599);
	  docs.csc = __webpack_require__(1600);
	  docs.csch = __webpack_require__(1601);
	  docs.sec = __webpack_require__(1602);
	  docs.sech = __webpack_require__(1603);
	  docs.sin = __webpack_require__(1604);
	  docs.sinh = __webpack_require__(1605);
	  docs.tan = __webpack_require__(1606);
	  docs.tanh = __webpack_require__(1607);
	
	  // functions - units
	  docs.to = __webpack_require__(1608);
	
	  // functions - utils
	  docs.clone = __webpack_require__(1609);
	  docs.format = __webpack_require__(1610);
	  docs.isNaN = __webpack_require__(1611);
	  docs.isInteger = __webpack_require__(1612);
	  docs.isNegative = __webpack_require__(1613);
	  docs.isNumeric = __webpack_require__(1614);
	  docs.isPositive = __webpack_require__(1615);
	  docs.isPrime = __webpack_require__(1616);
	  docs.isZero = __webpack_require__(1617);
	  // docs.print = require('./function/utils/print'); // TODO: add documentation for print as soon as the parser supports objects.
	  docs['typeof'] =  __webpack_require__(1618);
	
	  return docs;
	}
	
	exports.name = 'docs';
	exports.path = 'expression';
	exports.factory = factory;


/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bignumber',
	  'category': 'Construction',
	  'syntax': [
	    'bignumber(x)'
	  ],
	  'description':
	      'Create a big number from a number or string.',
	  'examples': [
	    '0.1 + 0.2',
	    'bignumber(0.1) + bignumber(0.2)',
	    'bignumber("7.2")',
	    'bignumber("7.2e500")',
	    'bignumber([0.1, 0.2, 0.3])'
	  ],
	  'seealso': [
	    'boolean', 'complex', 'fraction', 'index', 'matrix', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'boolean',
	  'category': 'Construction',
	  'syntax': [
	    'x',
	    'boolean(x)'
	  ],
	  'description':
	      'Convert a string or number into a boolean.',
	  'examples': [
	    'boolean(0)',
	    'boolean(1)',
	    'boolean(3)',
	    'boolean("true")',
	    'boolean("false")',
	    'boolean([1, 0, 1, 1])'
	  ],
	  'seealso': [
	    'bignumber', 'complex', 'index', 'matrix', 'number', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'complex',
	  'category': 'Construction',
	  'syntax': [
	    'complex()',
	    'complex(re, im)',
	    'complex(string)'
	  ],
	  'description':
	      'Create a complex number.',
	  'examples': [
	    'complex()',
	    'complex(2, 3)',
	    'complex("7 - 2i")'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'index', 'matrix', 'number', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'createUnit',
	  'category': 'Construction',
	  'syntax': [
	    'createUnit(definitions)',
	    'createUnit(name, definition)'
	  ],
	  'description':
	      'Create a user-defined unit and register it with the Unit type.',
	  'examples': [
	    'createUnit("foo")',
	    'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
	    'createUnit("mph", "1 mile/hour")'
	  ],
	  'seealso': [
	    'unit', 'splitUnit'
	  ]
	};


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'fraction',
	  'category': 'Construction',
	  'syntax': [
	    'fraction(num)',
	    'fraction(num,den)'
	  ],
	  'description':
	    'Create a fraction from a number or from a numerator and denominator.',
	  'examples': [
	    'fraction(0.125)',
	    'fraction(1, 3) + fraction(2, 5)'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'index', 'matrix', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'index',
	  'category': 'Construction',
	  'syntax': [
	    '[start]',
	    '[start:end]',
	    '[start:step:end]',
	    '[start1, start 2, ...]',
	    '[start1:end1, start2:end2, ...]',
	    '[start1:step1:end1, start2:step2:end2, ...]'
	  ],
	  'description':
	      'Create an index to get or replace a subset of a matrix',
	  'examples': [
	    '[]',
	    '[1, 2, 3]',
	    'A = [1, 2, 3; 4, 5, 6]',
	    'A[1, :]',
	    'A[1, 2] = 50',
	    'A[0:2, 0:2] = ones(2, 2)'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'matrix,', 'number', 'range', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'matrix',
	  'category': 'Construction',
	  'syntax': [
	    '[]',
	    '[a1, b1, ...; a2, b2, ...]',
	    'matrix()',
	    'matrix("dense")',
	    'matrix([...])'
	  ],
	  'description':
	      'Create a matrix.',
	  'examples': [
	    '[]',
	    '[1, 2, 3]',
	    '[1, 2, 3; 4, 5, 6]',
	    'matrix()',
	    'matrix([3, 4])',
	    'matrix([3, 4; 5, 6], "sparse")',
	    'matrix([3, 4; 5, 6], "sparse", "number")'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'index', 'number', 'string', 'unit', 'sparse'
	  ]
	};


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'number',
	  'category': 'Construction',
	  'syntax': [
	    'x',
	    'number(x)',
	    'number(unit, valuelessUnit)'
	  ],
	  'description':
	      'Create a number or convert a string or boolean into a number.',
	  'examples': [
	    '2',
	    '2e3',
	    '4.05',
	    'number(2)',
	    'number("7.2")',
	    'number(true)',
	    'number([true, false, true, true])',
	    'number(unit("52cm"), "m")'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'fraction', 'index', 'matrix', 'string', 'unit'
	  ]
	};


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sparse',
	  'category': 'Construction',
	  'syntax': [
	    'sparse()',
	    'sparse([a1, b1, ...; a1, b2, ...])',
	    'sparse([a1, b1, ...; a1, b2, ...], "number")'
	  ],
	  'description':
	  'Create a sparse matrix.',
	  'examples': [
	    'sparse()',
	    'sparse([3, 4; 5, 6])',
	    'sparse([3, 0; 5, 0], "number")'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'index', 'number', 'string', 'unit', 'matrix'
	  ]
	};


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'splitUnit',
	  'category': 'Construction',
	  'syntax': [
	    'splitUnit(unit: Unit, parts: Unit[])'
	  ],
	  'description':
	      'Split a unit in an array of units whose sum is equal to the original unit.',
	  'examples': [
	    'splitUnit(1 m, ["feet", "inch"])'
	  ],
	  'seealso': [
	    'unit', 'createUnit'
	  ]
	};


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'string',
	  'category': 'Construction',
	  'syntax': [
	    '"text"',
	    'string(x)'
	  ],
	  'description':
	      'Create a string or convert a value to a string',
	  'examples': [
	    '"Hello World!"',
	    'string(4.2)',
	    'string(3 + 2i)'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'index', 'matrix', 'number', 'unit'
	  ]
	};


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'unit',
	  'category': 'Construction',
	  'syntax': [
	    'value unit',
	    'unit(value, unit)',
	    'unit(string)'
	  ],
	  'description':
	      'Create a unit.',
	  'examples': [
	    '5.5 mm',
	    '3 inch',
	    'unit(7.1, "kilogram")',
	    'unit("23 deg")'
	  ],
	  'seealso': [
	    'bignumber', 'boolean', 'complex', 'index', 'matrix', 'number', 'string'
	  ]
	};


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'e',
	  'category': 'Constants',
	  'syntax': [
	    'e'
	  ],
	  'description': 'Euler\'s number, the base of the natural logarithm. Approximately equal to 2.71828',
	  'examples': [
	    'e',
	    'e ^ 2',
	    'exp(2)',
	    'log(e)'
	  ],
	  'seealso': ['exp']
	};


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'false',
	  'category': 'Constants',
	  'syntax': [
	    'false'
	  ],
	  'description': 'Boolean value false',
	  'examples': [
	    'false'
	  ],
	  'seealso': ['true']
	};


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'i',
	  'category': 'Constants',
	  'syntax': [
	    'i'
	  ],
	  'description': 'Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.',
	  'examples': [
	    'i',
	    'i * i',
	    'sqrt(-1)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'Infinity',
	  'category': 'Constants',
	  'syntax': [
	    'Infinity'
	  ],
	  'description': 'Infinity, a number which is larger than the maximum number that can be handled by a floating point number.',
	  'examples': [
	    'Infinity',
	    '1 / 0'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'LN2',
	  'category': 'Constants',
	  'syntax': [
	    'LN2'
	  ],
	  'description': 'Returns the natural logarithm of 2, approximately equal to 0.693',
	  'examples': [
	    'LN2',
	    'log(2)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'LN10',
	  'category': 'Constants',
	  'syntax': [
	    'LN10'
	  ],
	  'description': 'Returns the natural logarithm of 10, approximately equal to 2.302',
	  'examples': [
	    'LN10',
	    'log(10)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'LOG2E',
	  'category': 'Constants',
	  'syntax': [
	    'LOG2E'
	  ],
	  'description': 'Returns the base-2 logarithm of E, approximately equal to 1.442',
	  'examples': [
	    'LOG2E',
	    'log(e, 2)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'LOG10E',
	  'category': 'Constants',
	  'syntax': [
	    'LOG10E'
	  ],
	  'description': 'Returns the base-10 logarithm of E, approximately equal to 0.434',
	  'examples': [
	    'LOG10E',
	    'log(e, 10)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'NaN',
	  'category': 'Constants',
	  'syntax': [
	    'NaN'
	  ],
	  'description': 'Not a number',
	  'examples': [
	    'NaN',
	    '0 / 0'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'null',
	  'category': 'Constants',
	  'syntax': [
	    'null'
	  ],
	  'description': 'Value null',
	  'examples': [
	    'null'
	  ],
	  'seealso': ['true', 'false']
	};


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'pi',
	  'category': 'Constants',
	  'syntax': [
	    'pi'
	  ],
	  'description': 'The number pi is a mathematical constant that is the ratio of a circle\'s circumference to its diameter, and is approximately equal to 3.14159',
	  'examples': [
	    'pi',
	    'sin(pi/2)'
	  ],
	  'seealso': ['tau']
	};


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'phi',
	  'category': 'Constants',
	  'syntax': [
	    'phi'
	  ],
	  'description': 'Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...',
	  'examples': [
	    'phi'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'SQRT1_2',
	  'category': 'Constants',
	  'syntax': [
	    'SQRT1_2'
	  ],
	  'description': 'Returns the square root of 1/2, approximately equal to 0.707',
	  'examples': [
	    'SQRT1_2',
	    'sqrt(1/2)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'SQRT2',
	  'category': 'Constants',
	  'syntax': [
	    'SQRT2'
	  ],
	  'description': 'Returns the square root of 2, approximately equal to 1.414',
	  'examples': [
	    'SQRT2',
	    'sqrt(2)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'tau',
	  'category': 'Constants',
	  'syntax': [
	    'tau'
	  ],
	  'description': 'Tau is the ratio constant of a circle\'s circumference to radius, equal to 2 * pi, approximately 6.2832.',
	  'examples': [
	    'tau',
	    '2 * pi'
	  ],
	  'seealso': ['pi']
	};


/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'true',
	  'category': 'Constants',
	  'syntax': [
	    'true'
	  ],
	  'description': 'Boolean value true',
	  'examples': [
	    'true'
	  ],
	  'seealso': ['false']
	};


/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'version',
	  'category': 'Constants',
	  'syntax': [
	    'version'
	  ],
	  'description': 'A string with the version number of math.js',
	  'examples': [
	    'version'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'derivative',
	  'category': 'Algebra',
	  'syntax': [
	    'derivative(expr, variable)',
	    'derivative(expr, variable, {simplify: boolean})'
	  ],
	  'description': 'Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.',
	  'examples': [
	    'derivative("2x^3", "x")',
	    'derivative("2x^3", "x", {simplify: false})',
	    'derivative("2x^2 + 3x + 4", "x")',
	    'derivative("sin(2x)", "x")',
	    'f = parse("x^2 + x")',
	    'x = parse("x")',
	    'df = derivative(f, x)',
	    'df.eval({x: 3})'
	  ],
	  'seealso': [
	    'simplify', 'parse', 'eval'
	  ]
	};


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'lsolve',
	  'category': 'Algebra',
	  'syntax': [
	    'x=lsolve(L, b)'
	  ],
	  'description':
	  'Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.',
	  'examples': [
	    'a = [-2, 3; 2, 1]',
	    'b = [11, 9]',
	    'x = lsolve(a, b)'
	  ],
	  'seealso': [
	    'lup', 'lusolve', 'usolve', 'matrix', 'sparse'
	  ]
	};


/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'lup',
	  'category': 'Algebra',
	  'syntax': [
	    'lup(m)'
	  ],
	  'description':
	  'Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U',
	  'examples': [
	    'lup([[2, 1], [1, 4]])',
	    'lup(matrix([[2, 1], [1, 4]]))',
	    'lup(sparse([[2, 1], [1, 4]]))'
	  ],
	  'seealso': [
	    'lusolve', 'lsolve', 'usolve', 'matrix', 'sparse', 'slu', 'qr'
	  ]
	};


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'lusolve',
	  'category': 'Algebra',
	  'syntax': [
	    'x=lusolve(A, b)',
	    'x=lusolve(lu, b)'
	  ],
	  'description': 'Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.',
	  'examples': [
	    'a = [-2, 3; 2, 1]',
	    'b = [11, 9]',
	    'x = lusolve(a, b)'
	  ],
	  'seealso': [
	    'lup', 'slu', 'lsolve', 'usolve', 'matrix', 'sparse'
	  ]
	};


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'simplify',
	  'category': 'Algebra',
	  'syntax': [
	    'simplify(expr)',
	    'simplify(expr, rules)'
	  ],
	  'description': 'Simplify an expression tree.',
	  'examples': [
	    'simplify("3 + 2 / 4")',
	    'simplify("2x + x")',
	    'f = parse("x * (x + 2 + x)")',
	    'simplified = simplify(f)',
	    'simplified.eval({x: 2})'
	  ],
	  'seealso': [
	    'derivative', 'parse', 'eval'
	  ]
	};


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'rationalize',
	  'category': 'Algebra',
	  'syntax': [
	    'rationalize(expr)',
	    'rationalize(expr, scope)',
	    'rationalize(expr, scope, detailed)'
	  ],
	  'description': 'Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.',
	  'examples': [
	    'rationalize("2x/y - y/(x+1)")',
	    'rationalize("2x/y - y/(x+1)", true)',
	  ],
	  'seealso': [
	    'simplify'
	  ]
	};


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'slu',
	  'category': 'Algebra',
	  'syntax': [
	    'slu(A, order, threshold)'
	  ],
	  'description': 'Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U',
	  'examples': [
	    'slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)'
	  ],
	  'seealso': [
	    'lusolve', 'lsolve', 'usolve', 'matrix', 'sparse', 'lup', 'qr'
	  ]
	};


/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'usolve',
	  'category': 'Algebra',
	  'syntax': [
	    'x=usolve(U, b)'
	  ],
	  'description':
	  'Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.',
	  'examples': [
	    'x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])'
	  ],
	  'seealso': [
	    'lup', 'lusolve', 'lsolve', 'matrix', 'sparse'
	  ]
	};


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'qr',
	  'category': 'Algebra',
	  'syntax': [
	    'qr(A)'
	  ],
	  'description':
	  'Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.',
	  'examples': [
	    'qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])'
	  ],
	  'seealso': [
	    'lup', 'slu', 'matrix'
	  ]
	};


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'abs',
	  'category': 'Arithmetic',
	  'syntax': [
	    'abs(x)'
	  ],
	  'description': 'Compute the absolute value.',
	  'examples': [
	    'abs(3.5)',
	    'abs(-4.2)'
	  ],
	  'seealso': ['sign']
	};


/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'add',
	  'category': 'Operators',
	  'syntax': [
	    'x + y',
	    'add(x, y)'
	  ],
	  'description': 'Add two values.',
	  'examples': [
	    'a = 2.1 + 3.6',
	    'a - 3.6',
	    '3 + 2i',
	    '3 cm + 2 inch',
	    '"2.3" + "4"'
	  ],
	  'seealso': [
	    'subtract'
	  ]
	};


/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cbrt',
	  'category': 'Arithmetic',
	  'syntax': [
	    'cbrt(x)',
	    'cbrt(x, allRoots)'
	  ],
	  'description':
	      'Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned',
	  'examples': [
	    'cbrt(64)',
	    'cube(4)',
	    'cbrt(-8)',
	    'cbrt(2 + 3i)',
	    'cbrt(8i)',
	    'cbrt(8i, true)',
	    'cbrt(27 m^3)'
	  ],
	  'seealso': [
	    'square',
	    'sqrt',
	    'cube',
	    'multiply'
	  ]
	};


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'ceil',
	  'category': 'Arithmetic',
	  'syntax': [
	    'ceil(x)'
	  ],
	  'description':
	      'Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.',
	  'examples': [
	    'ceil(3.2)',
	    'ceil(3.8)',
	    'ceil(-4.2)'
	  ],
	  'seealso': ['floor', 'fix', 'round']
	};


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cube',
	  'category': 'Arithmetic',
	  'syntax': [
	    'cube(x)'
	  ],
	  'description': 'Compute the cube of a value. The cube of x is x * x * x.',
	  'examples': [
	    'cube(2)',
	    '2^3',
	    '2 * 2 * 2'
	  ],
	  'seealso': [
	    'multiply',
	    'square',
	    'pow'
	  ]
	};


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'divide',
	  'category': 'Operators',
	  'syntax': [
	    'x / y',
	    'divide(x, y)'
	  ],
	  'description': 'Divide two values.',
	  'examples': [
	    'a = 2 / 3',
	    'a * 3',
	    '4.5 / 2',
	    '3 + 4 / 2',
	    '(3 + 4) / 2',
	    '18 km / 4.5'
	  ],
	  'seealso': [
	    'multiply'
	  ]
	};


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'dotDivide',
	  'category': 'Operators',
	  'syntax': [
	    'x ./ y',
	    'dotDivide(x, y)'
	  ],
	  'description': 'Divide two values element wise.',
	  'examples': [
	    'a = [1, 2, 3; 4, 5, 6]',
	    'b = [2, 1, 1; 3, 2, 5]',
	    'a ./ b'
	  ],
	  'seealso': [
	    'multiply',
	    'dotMultiply',
	    'divide'
	  ]
	};


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'dotMultiply',
	  'category': 'Operators',
	  'syntax': [
	    'x .* y',
	    'dotMultiply(x, y)'
	  ],
	  'description': 'Multiply two values element wise.',
	  'examples': [
	    'a = [1, 2, 3; 4, 5, 6]',
	    'b = [2, 1, 1; 3, 2, 5]',
	    'a .* b'
	  ],
	  'seealso': [
	    'multiply',
	    'divide',
	    'dotDivide'
	  ]
	};


/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'dotpow',
	  'category': 'Operators',
	  'syntax': [
	    'x .^ y',
	    'dotpow(x, y)'
	  ],
	  'description':
	      'Calculates the power of x to y element wise.',
	  'examples': [
	    'a = [1, 2, 3; 4, 5, 6]',
	    'a .^ 2'
	  ],
	  'seealso': [
	    'pow'
	  ]
	};


/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'exp',
	  'category': 'Arithmetic',
	  'syntax': [
	    'exp(x)'
	  ],
	  'description': 'Calculate the exponent of a value.',
	  'examples': [
	    'exp(1.3)',
	    'e ^ 1.3',
	    'log(exp(1.3))',
	    'x = 2.4',
	    '(exp(i*x) == cos(x) + i*sin(x))   # Euler\'s formula'
	  ],
	  'seealso': [
	    'expm',
	    'expm1',
	    'pow',
	    'log'
	  ]
	};


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'expm',
	  'category': 'Arithmetic',
	  'syntax': [
	    'exp(x)'
	  ],
	  'description': 'Compute the matrix exponential, expm(A) = e^A. ' +
	    'The matrix must be square. ' +
	    'Not to be confused with exp(a), which performs element-wise exponentiation.',
	  'examples': [
	    'expm([[0,2],[0,0]])'
	  ],
	  'seealso': [
	    'exp'
	  ]
	};


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'expm1',
	  'category': 'Arithmetic',
	  'syntax': [
	    'expm1(x)'
	  ],
	  'description': 'Calculate the value of subtracting 1 from the exponential value.',
	  'examples': [
	    'expm1(2)',
	    'pow(e, 2) - 1',
	    'log(expm1(2) + 1)'
	  ],
	  'seealso': [
	    'exp',
	    'pow',
	    'log'
	  ]
	};


/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'fix',
	  'category': 'Arithmetic',
	  'syntax': [
	    'fix(x)'
	  ],
	  'description':
	      'Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.',
	  'examples': [
	    'fix(3.2)',
	    'fix(3.8)',
	    'fix(-4.2)',
	    'fix(-4.8)'
	  ],
	  'seealso': ['ceil', 'floor', 'round']
	};


/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'floor',
	  'category': 'Arithmetic',
	  'syntax': [
	    'floor(x)'
	  ],
	  'description':
	      'Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.',
	  'examples': [
	    'floor(3.2)',
	    'floor(3.8)',
	    'floor(-4.2)'
	  ],
	  'seealso': ['ceil', 'fix', 'round']
	};


/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'gcd',
	  'category': 'Arithmetic',
	  'syntax': [
	    'gcd(a, b)',
	    'gcd(a, b, c, ...)'
	  ],
	  'description': 'Compute the greatest common divisor.',
	  'examples': [
	    'gcd(8, 12)',
	    'gcd(-4, 6)',
	    'gcd(25, 15, -10)'
	  ],
	  'seealso': [ 'lcm', 'xgcd' ]
	};


/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'hypot',
	  'category': 'Arithmetic',
	  'syntax': [
	    'hypot(a, b, c, ...)',
	    'hypot([a, b, c, ...])'
	  ],
	  'description': 'Calculate the hypotenusa of a list with values. ',
	  'examples': [
	    'hypot(3, 4)',
	    'sqrt(3^2 + 4^2)',
	    'hypot(-2)',
	    'hypot([3, 4, 5])'
	  ],
	  'seealso': [ 'abs', 'norm' ]
	};


/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'lcm',
	  'category': 'Arithmetic',
	  'syntax': [
	    'lcm(x, y)'
	  ],
	  'description': 'Compute the least common multiple.',
	  'examples': [
	    'lcm(4, 6)',
	    'lcm(6, 21)',
	    'lcm(6, 21, 5)'
	  ],
	  'seealso': [ 'gcd' ]
	};


/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'log',
	  'category': 'Arithmetic',
	  'syntax': [
	    'log(x)',
	    'log(x, base)'
	  ],
	  'description': 'Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).',
	  'examples': [
	    'log(3.5)',
	    'a = log(2.4)',
	    'exp(a)',
	    '10 ^ 4',
	    'log(10000, 10)',
	    'log(10000) / log(10)',
	    'b = log(1024, 2)',
	    '2 ^ b'
	  ],
	  'seealso': [
	    'exp',
	    'log1p',
	    'log2',
	    'log10'
	  ]
	};

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'log2',
	  'category': 'Arithmetic',
	  'syntax': [
	    'log2(x)'
	  ],
	  'description': 'Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.',
	  'examples': [
	    'log2(0.03125)',
	    'log2(16)',
	    'log2(16) / log2(2)',
	    'pow(2, 4)'
	  ],
	  'seealso': [
	    'exp',
	    'log1p',
	    'log',
	    'log10'
	  ]
	};

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'log1p',
	  'category': 'Arithmetic',
	  'syntax': [
	    'log1p(x)',
	    'log1p(x, base)'
	  ],
	  'description': 'Calculate the logarithm of a `value+1`',
	  'examples': [
	    'log1p(2.5)',
	    'exp(log1p(1.4))',
	    'pow(10, 4)',
	    'log1p(9999, 10)',
	    'log1p(9999) / log(10)'
	  ],
	  'seealso': [
	    'exp',
	    'log',
	    'log2',
	    'log10'
	  ]
	};

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'log10',
	  'category': 'Arithmetic',
	  'syntax': [
	    'log10(x)'
	  ],
	  'description': 'Compute the 10-base logarithm of a value.',
	  'examples': [
	    'log10(0.00001)',
	    'log10(10000)',
	    '10 ^ 4',
	    'log(10000) / log(10)',
	    'log(10000, 10)'
	  ],
	  'seealso': [
	    'exp',
	    'log'
	  ]
	};


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'mod',
	  'category': 'Operators',
	  'syntax': [
	    'x % y',
	    'x mod y',
	    'mod(x, y)'
	  ],
	  'description':
	      'Calculates the modulus, the remainder of an integer division.',
	  'examples': [
	    '7 % 3',
	    '11 % 2',
	    '10 mod 4',
	    'isOdd(x) = x % 2',
	    'isOdd(2)',
	    'isOdd(3)'
	  ],
	  'seealso': ['divide']
	};


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'multiply',
	  'category': 'Operators',
	  'syntax': [
	    'x * y',
	    'multiply(x, y)'
	  ],
	  'description': 'multiply two values.',
	  'examples': [
	    'a = 2.1 * 3.4',
	    'a / 3.4',
	    '2 * 3 + 4',
	    '2 * (3 + 4)',
	    '3 * 2.1 km'
	  ],
	  'seealso': [
	    'divide'
	  ]
	};


/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'norm',
	  'category': 'Arithmetic',
	  'syntax': [
	    'norm(x)',
	    'norm(x, p)'
	  ],
	  'description': 'Calculate the norm of a number, vector or matrix.',
	  'examples': [
	    'abs(-3.5)',
	    'norm(-3.5)',
	    'norm(3 - 4i)',
	    'norm([1, 2, -3], Infinity)',
	    'norm([1, 2, -3], -Infinity)',
	    'norm([3, 4], 2)',
	    'norm([[1, 2], [3, 4]], 1)',
	    'norm([[1, 2], [3, 4]], "inf")',
	    'norm([[1, 2], [3, 4]], "fro")'
	  ]
	};


/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'nthRoot',
	  'category': 'Arithmetic',
	  'syntax': [
	    'nthRoot(a)',
	    'nthRoot(a, root)'
	  ],
	  'description': 'Calculate the nth root of a value. ' +
	      'The principal nth root of a positive real number A, ' +
	      'is the positive real solution of the equation "x^root = A".',
	  'examples': [
	    '4 ^ 3',
	    'nthRoot(64, 3)',
	    'nthRoot(9, 2)',
	    'sqrt(9)'
	  ],
	  'seealso': [
	    'sqrt',
	    'pow'
	  ]
	};

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'pow',
	  'category': 'Operators',
	  'syntax': [
	    'x ^ y',
	    'pow(x, y)'
	  ],
	  'description':
	      'Calculates the power of x to y, x^y.',
	  'examples': [
	    '2^3',
	    '2*2*2',
	    '1 + e ^ (pi * i)'
	  ],
	  'seealso': [ 'multiply' ]
	};


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'round',
	  'category': 'Arithmetic',
	  'syntax': [
	    'round(x)',
	    'round(x, n)'
	  ],
	  'description':
	      'round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.',
	  'examples': [
	    'round(3.2)',
	    'round(3.8)',
	    'round(-4.2)',
	    'round(-4.8)',
	    'round(pi, 3)',
	    'round(123.45678, 2)'
	  ],
	  'seealso': ['ceil', 'floor', 'fix']
	};


/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sign',
	  'category': 'Arithmetic',
	  'syntax': [
	    'sign(x)'
	  ],
	  'description':
	      'Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.',
	  'examples': [
	    'sign(3.5)',
	    'sign(-4.2)',
	    'sign(0)'
	  ],
	  'seealso': [
	    'abs'
	  ]
	};


/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sqrt',
	  'category': 'Arithmetic',
	  'syntax': [
	    'sqrt(x)'
	  ],
	  'description':
	      'Compute the square root value. If x = y * y, then y is the square root of x.',
	  'examples': [
	    'sqrt(25)',
	    '5 * 5',
	    'sqrt(-1)'
	  ],
	  'seealso': [
	    'square',
	    'sqrtm',
	    'multiply'
	  ]
	};


/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sqrtm',
	  'category': 'Arithmetic',
	  'syntax': [
	    'sqrtm(x)'
	  ],
	  'description':
	      'Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.',
	  'examples': [
	    'sqrtm([[1, 2], [3, 4]])'
	  ],
	  'seealso': [
	    'sqrt',
	    'abs',
	    'square',
	    'multiply'
	  ]
	};


/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'square',
	  'category': 'Arithmetic',
	  'syntax': [
	    'square(x)'
	  ],
	  'description':
	      'Compute the square of a value. The square of x is x * x.',
	  'examples': [
	    'square(3)',
	    'sqrt(9)',
	    '3^2',
	    '3 * 3'
	  ],
	  'seealso': [
	    'multiply',
	    'pow',
	    'sqrt',
	    'cube'
	  ]
	};


/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'subtract',
	  'category': 'Operators',
	  'syntax': [
	    'x - y',
	    'subtract(x, y)'
	  ],
	  'description': 'subtract two values.',
	  'examples': [
	    'a = 5.3 - 2',
	    'a + 2',
	    '2/3 - 1/6',
	    '2 * 3 - 3',
	    '2.1 km - 500m'
	  ],
	  'seealso': [
	    'add'
	  ]
	};


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'unaryMinus',
	  'category': 'Operators',
	  'syntax': [
	    '-x',
	    'unaryMinus(x)'
	  ],
	  'description':
	      'Inverse the sign of a value. Converts booleans and strings to numbers.',
	  'examples': [
	    '-4.5',
	    '-(-5.6)',
	    '-"22"'
	  ],
	  'seealso': [
	    'add', 'subtract', 'unaryPlus'
	  ]
	};


/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'unaryPlus',
	  'category': 'Operators',
	  'syntax': [
	    '+x',
	    'unaryPlus(x)'
	  ],
	  'description':
	      'Converts booleans and strings to numbers.',
	  'examples': [
	    '+true',
	    '+"2"'
	  ],
	  'seealso': [
	    'add', 'subtract', 'unaryMinus'
	  ]
	};


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'xgcd',
	  'category': 'Arithmetic',
	  'syntax': [
	    'xgcd(a, b)'
	  ],
	  'description': 'Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.',
	  'examples': [
	    'xgcd(8, 12)',
	    'gcd(8, 12)',
	    'xgcd(36163, 21199)'
	  ],
	  'seealso': [ 'gcd', 'lcm' ]
	};


/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bitAnd',
	  'category': 'Bitwise',
	  'syntax': [
	    'x & y',
	    'bitAnd(x, y)'
	  ],
	  'description': 'Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0',
	  'examples': [
	    '5 & 3',
	    'bitAnd(53, 131)',
	    '[1, 12, 31] & 42'
	  ],
	  'seealso': [
	    'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bitNot',
	  'category': 'Bitwise',
	  'syntax': [
	    '~x',
	    'bitNot(x)'
	  ],
	  'description': 'Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.',
	  'examples': [
	    '~1',
	    '~2',
	    'bitNot([2, -3, 4])'
	  ],
	  'seealso': [
	    'bitAnd', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bitOr',
	  'category': 'Bitwise',
	  'syntax': [
	    'x | y',
	    'bitOr(x, y)'
	  ],
	  'description': 'Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.',
	  'examples': [
	    '5 | 3',
	    'bitOr([1, 2, 3], 4)'
	  ],
	  'seealso': [
	    'bitAnd', 'bitNot', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bitXor',
	  'category': 'Bitwise',
	  'syntax': [
	    'bitXor(x, y)'
	  ],
	  'description': 'Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.',
	  'examples': [
	    'bitOr(1, 2)',
	    'bitXor([2, 3, 4], 4)'
	  ],
	  'seealso': [
	    'bitAnd', 'bitNot', 'bitOr', 'leftShift', 'rightArithShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'leftShift',
	  'category': 'Bitwise',
	  'syntax': [
	    'x << y',
	    'leftShift(x, y)'
	  ],
	  'description': 'Bitwise left logical shift of a value x by y number of bits.',
	  'examples': [
	    '4 << 1',
	    '8 >> 1'
	  ],
	  'seealso': [
	    'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'rightArithShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'rightArithShift',
	  'category': 'Bitwise',
	  'syntax': [
	    'x >> y',
	    'rightArithShift(x, y)'
	  ],
	  'description': 'Bitwise right arithmetic shift of a value x by y number of bits.',
	  'examples': [
	    '8 >> 1',
	    '4 << 1',
	    '-12 >> 2'
	  ],
	  'seealso': [
	    'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightLogShift'
	  ]
	};


/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'rightLogShift',
	  'category': 'Bitwise',
	  'syntax': [
	    'x >>> y',
	    'rightLogShift(x, y)'
	  ],
	  'description': 'Bitwise right logical shift of a value x by y number of bits.',
	  'examples': [
	    '8 >>> 1',
	    '4 << 1',
	    '-12 >>> 2'
	  ],
	  'seealso': [
	    'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift'
	  ]
	};


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'bellNumbers',
	  'category': 'Combinatorics',
	  'syntax': [
	    'bellNumbers(n)'
	  ],
	  'description': 'The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.',
	  'examples': [
	    'bellNumbers(3)',
	    'bellNumbers(8)'
	  ],
	  'seealso': ['stirlingS2']
	};

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'catalan',
	  'category': 'Combinatorics',
	  'syntax': [
	    'catalan(n)'
	  ],
	  'description': 'The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.',
	  'examples': [
	    'catalan(3)',
	    'catalan(8)'
	  ],
	  'seealso': ['bellNumbers']
	};

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'composition',
	  'category': 'Combinatorics',
	  'syntax': [
	    'composition(n, k)'
	  ],
	  'description': 'The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.',
	  'examples': [
	    'composition(5, 3)'
	  ],
	  'seealso': ['combinations']
	};

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'stirlingS2',
	  'category': 'Combinatorics',
	  'syntax': [
	    'stirlingS2(n, k)'
	  ],
	  'description': 'he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.',
	  'examples': [
	    'stirlingS2(5, 3)'
	  ],
	  'seealso': ['bellNumbers']
	};


/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'config',
	  'category': 'Core',
	  'syntax': [
	    'config()',
	    'config(options)'
	  ],
	  'description': 'Get configuration or change configuration.',
	  'examples': [
	    'config()',
	    '1/3 + 1/4',
	    'config({number: "Fraction"})',
	    '1/3 + 1/4'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'import',
	  'category': 'Core',
	  'syntax': [
	    'import(functions)',
	    'import(functions, options)'
	  ],
	  'description': 'Import functions or constants from an object.',
	  'examples': [
	    'import({myFn: f(x)=x^2, myConstant: 32 })',
	    'myFn(2)',
	    'myConstant'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'typed',
	  'category': 'Core',
	  'syntax': [
	    'typed(signatures)',
	    'typed(name, signatures)'
	  ],
	  'description': 'Create a typed function.',
	  'examples': [
	    'double = typed({ "number, number": f(x)=x+x })',
	    'double(2)',
	    'double("hello")'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'arg',
	  'category': 'Complex',
	  'syntax': [
	    'arg(x)'
	  ],
	  'description':
	      'Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).',
	  'examples': [
	    'arg(2 + 2i)',
	    'atan2(3, 2)',
	    'arg(2 + 3i)'
	  ],
	  'seealso': [
	    're',
	    'im',
	    'conj',
	    'abs'
	  ]
	};


/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'conj',
	  'category': 'Complex',
	  'syntax': [
	    'conj(x)'
	  ],
	  'description':
	      'Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.',
	  'examples': [
	    'conj(2 + 3i)',
	    'conj(2 - 3i)',
	    'conj(-5.2i)'
	  ],
	  'seealso': [
	    're',
	    'im',
	    'abs',
	    'arg'
	  ]
	};


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 're',
	  'category': 'Complex',
	  'syntax': [
	    're(x)'
	  ],
	  'description': 'Get the real part of a complex number.',
	  'examples': [
	    're(2 + 3i)',
	    'im(2 + 3i)',
	    're(-5.2i)',
	    're(2.4)'
	  ],
	  'seealso': [
	    'im',
	    'conj',
	    'abs',
	    'arg'
	  ]
	};


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'im',
	  'category': 'Complex',
	  'syntax': [
	    'im(x)'
	  ],
	  'description': 'Get the imaginary part of a complex number.',
	  'examples': [
	    'im(2 + 3i)',
	    're(2 + 3i)',
	    'im(-5.2i)',
	    'im(2.4)'
	  ],
	  'seealso': [
	    're',
	    'conj',
	    'abs',
	    'arg'
	  ]
	};


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'eval',
	  'category': 'Expression',
	  'syntax': [
	    'eval(expression)',
	    'eval([expr1, expr2, expr3, ...])'
	  ],
	  'description': 'Evaluate an expression or an array with expressions.',
	  'examples': [
	    'eval("2 + 3")',
	    'eval("sqrt(" + 4 + ")")'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'help',
	  'category': 'Expression',
	  'syntax': [
	    'help(object)',
	    'help(string)'
	  ],
	  'description': 'Display documentation on a function or data type.',
	  'examples': [
	    'help(sqrt)',
	    'help("complex")'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'distance',
	  'category': 'Geometry',
	  'syntax': [
	    'distance([x1, y1], [x2, y2])',
	    'distance([[x1, y1], [x2, y2])'
	  ],
	  'description': 'Calculates the Euclidean distance between two points.',
	  'examples': [
	    'distance([0,0], [4,4])',
	    'distance([[0,0], [4,4]])'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'intersect',
	  'category': 'Geometry',
	  'syntax': [
	    'intersect(expr1, expr2, expr3, expr4)',
	    'intersect(expr1, expr2, expr3)'
	  ],
	  'description': 'Computes the intersection point of lines and/or planes.',
	  'examples': [
	    'intersect([0, 0], [10, 10], [10, 0], [0, 10])',
	    'intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'and',
	  'category': 'Logical',
	  'syntax': [
	    'x and y',
	    'and(x, y)'
	  ],
	  'description': 'Logical and. Test whether two values are both defined with a nonzero/nonempty value.',
	  'examples': [
	    'true and false',
	    'true and true',
	    '2 and 4'
	  ],
	  'seealso': [
	    'not', 'or', 'xor'
	  ]
	};


/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'not',
	  'category': 'Logical',
	  'syntax': [
	    'not x',
	    'not(x)'
	  ],
	  'description': 'Logical not. Flips the boolean value of given argument.',
	  'examples': [
	    'not true',
	    'not false',
	    'not 2',
	    'not 0'
	  ],
	  'seealso': [
	    'and', 'or', 'xor'
	  ]
	};


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'or',
	  'category': 'Logical',
	  'syntax': [
	    'x or y',
	    'or(x, y)'
	  ],
	  'description': 'Logical or. Test if at least one value is defined with a nonzero/nonempty value.',
	  'examples': [
	    'true or false',
	    'false or false',
	    '0 or 4'
	  ],
	  'seealso': [
	    'not', 'and', 'xor'
	  ]
	};


/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'xor',
	  'category': 'Logical',
	  'syntax': [
	    'x xor y',
	    'xor(x, y)'
	  ],
	  'description': 'Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.',
	  'examples': [
	    'true xor false',
	    'false xor false',
	    'true xor true',
	    '0 xor 4'
	  ],
	  'seealso': [
	    'not', 'and', 'or'
	  ]
	};


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'concat',
	  'category': 'Matrix',
	  'syntax': [
	    'concat(A, B, C, ...)',
	    'concat(A, B, C, ..., dim)'
	  ],
	  'description': 'Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.',
	  'examples': [
	    'A = [1, 2; 5, 6]',
	    'B = [3, 4; 7, 8]',
	    'concat(A, B)',
	    'concat(A, B, 1)',
	    'concat(A, B, 2)'
	  ],
	  'seealso': [
	    'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cross',
	  'category': 'Matrix',
	  'syntax': [
	    'cross(A, B)'
	  ],
	  'description': 'Calculate the cross product for two vectors in three dimensional space.',
	  'examples': [
	    'cross([1, 1, 0],  [0, 1, 1])',
	    'cross([3, -3, 1], [4, 9, 2])',
	    'cross([2, 3, 4],  [5, 6, 7])'
	  ],
	  'seealso': [
	    'multiply',
	    'dot'
	  ]
	};


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'det',
	  'category': 'Matrix',
	  'syntax': [
	    'det(x)'
	  ],
	  'description': 'Calculate the determinant of a matrix',
	  'examples': [
	    'det([1, 2; 3, 4])',
	    'det([-2, 2, 3; -1, 1, 3; 2, 0, -1])'
	  ],
	  'seealso': [
	    'concat', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'diag',
	  'category': 'Matrix',
	  'syntax': [
	    'diag(x)',
	    'diag(x, k)'
	  ],
	  'description': 'Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.',
	  'examples': [
	    'diag(1:3)',
	    'diag(1:3, 1)',
	    'a = [1, 2, 3; 4, 5, 6; 7, 8, 9]',
	    'diag(a)'
	  ],
	  'seealso': [
	    'concat', 'det', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'dot',
	  'category': 'Matrix',
	  'syntax': [
	    'dot(A, B)',
	    'A * B'
	  ],
	  'description': 'Calculate the dot product of two vectors. ' +
	      'The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] ' +
	      'is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn',
	  'examples': [
	    'dot([2, 4, 1], [2, 2, 3])',
	    '[2, 4, 1] * [2, 2, 3]'
	  ],
	  'seealso': [
	    'multiply',
	    'cross'
	  ]
	};


/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'eye',
	  'category': 'Matrix',
	  'syntax': [
	    'eye(n)',
	    'eye(m, n)',
	    'eye([m, n])'
	  ],
	  'description': 'Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.',
	  'examples': [
	    'eye(3)',
	    'eye(3, 5)',
	    'a = [1, 2, 3; 4, 5, 6]',
	    'eye(size(a))'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'filter',
	  'category': 'Matrix',
	  'syntax': [
	    'filter(x, test)'
	  ],
	  'description': 'Filter items in a matrix.',
	  'examples': [
	    'isPositive(x) = x > 0',
	    'filter([6, -2, -1, 4, 3], isPositive)',
	    'filter([6, -2, 0, 1, 0], x != 0)'
	  ],
	  'seealso': ['sort', 'map', 'forEach']
	};


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'flatten',
	  'category': 'Matrix',
	  'syntax': [
	    'flatten(x)'
	  ],
	  'description': 'Flatten a multi dimensional matrix into a single dimensional matrix.',
	  'examples': [
	    'a = [1, 2, 3; 4, 5, 6]',
	    'size(a)',
	    'b = flatten(a)',
	    'size(b)'
	  ],
	  'seealso': [
	    'concat', 'resize', 'size', 'squeeze'
	  ]
	};


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'forEach',
	  'category': 'Matrix',
	  'syntax': [
	    'forEach(x, callback)'
	  ],
	  'description': 'Iterates over all elements of a matrix/array, and executes the given callback function.',
	  'examples': [
	    'forEach([1, 2, 3], function(val) { console.log(val) })'
	  ],
	  'seealso': ['map', 'sort', 'filter']
	};


/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'inv',
	  'category': 'Matrix',
	  'syntax': [
	    'inv(x)'
	  ],
	  'description': 'Calculate the inverse of a matrix',
	  'examples': [
	    'inv([1, 2; 3, 4])',
	    'inv(4)',
	    '1 / 4'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'kron',
	  'category': 'Matrix',
	  'syntax': [
	    'kron(x, y)'
	  ],
	  'description': 'Calculates the kronecker product of 2 matrices or vectors.',
	  'examples': [
	    'kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])',
	    'kron([1,1], [2,3,4])'
	  ],
	  'seealso': [
	    'multiply', 'dot', 'cross'
	  ]
	};


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'map',
	  'category': 'Matrix',
	  'syntax': [
	    'map(x, callback)'
	  ],
	  'description': 'Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.',
	  'examples': [
	    'map([1, 2, 3], square)'
	  ],
	  'seealso': ['filter', 'forEach']
	};


/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'ones',
	  'category': 'Matrix',
	  'syntax': [
	    'ones(m)',
	    'ones(m, n)',
	    'ones(m, n, p, ...)',
	    'ones([m])',
	    'ones([m, n])',
	    'ones([m, n, p, ...])'
	  ],
	  'description': 'Create a matrix containing ones.',
	  'examples': [
	    'ones(3)',
	    'ones(3, 5)',
	    'ones([2,3]) * 4.5',
	    'a = [1, 2, 3; 4, 5, 6]',
	    'ones(size(a))'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'partitionSelect',
	  'category': 'Matrix',
	  'syntax': [
	    'partitionSelect(x, k)',
	    'partitionSelect(x, k, compare)'
	  ],
	  'description': 'Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.',
	  'examples': [
	    'partitionSelect([5, 10, 1], 2)',
	    'partitionSelect(["C", "B", "A", "D"], 1)'
	  ],
	  'seealso': ['sort']
	};


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'range',
	  'category': 'Type',
	  'syntax': [
	    'start:end',
	    'start:step:end',
	    'range(start, end)',
	    'range(start, end, step)',
	    'range(string)'
	  ],
	  'description':
	      'Create a range. Lower bound of the range is included, upper bound is excluded.',
	  'examples': [
	    '1:5',
	    '3:-1:-3',
	    'range(3, 7)',
	    'range(0, 12, 2)',
	    'range("4:10")',
	    'a = [1, 2, 3, 4; 5, 6, 7, 8]',
	    'a[1:2, 1:2]'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'resize',
	  'category': 'Matrix',
	  'syntax': [
	    'resize(x, size)',
	    'resize(x, size, defaultValue)'
	  ],
	  'description': 'Resize a matrix.',
	  'examples': [
	    'resize([1,2,3,4,5], [3])',
	    'resize([1,2,3], [5])',
	    'resize([1,2,3], [5], -1)',
	    'resize(2, [2, 3])',
	    'resize("hello", [8], "!")'
	  ],
	  'seealso': [
	    'size', 'subset', 'squeeze', 'reshape'
	  ]
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'reshape',
	  'category': 'Matrix',
	  'syntax': [
	    'reshape(x, sizes)'
	  ],
	  'description': 'Reshape a multi dimensional array to fit the specified dimensions.',
	  'examples': [
	    'reshape([1, 2, 3, 4, 5, 6], [2, 3])',
	    'reshape([[1, 2], [3, 4]], [1, 4])',
	    'reshape([[1, 2], [3, 4]], [4])'
	  ],
	  'seealso': [
	    'size', 'squeeze', 'resize'
	  ]
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'size',
	  'category': 'Matrix',
	  'syntax': [
	    'size(x)'
	  ],
	  'description': 'Calculate the size of a matrix.',
	  'examples': [
	    'size(2.3)',
	    'size("hello world")',
	    'a = [1, 2; 3, 4; 5, 6]',
	    'size(a)',
	    'size(1:6)'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sort',
	  'category': 'Matrix',
	  'syntax': [
	    'sort(x)',
	    'sort(x, compare)'
	  ],
	  'description': 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
	  'examples': [
	    'sort([5, 10, 1])',
	    'sort(["C", "B", "A", "D"])',
	    'sortByLength(a, b) = size(a)[1] - size(b)[1]',
	    'sort(["Langdon", "Tom", "Sara"], sortByLength)',
	    'sort(["10", "1", "2"], "natural")'
	  ],
	  'seealso': ['map', 'filter', 'forEach']
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'squeeze',
	  'category': 'Matrix',
	  'syntax': [
	    'squeeze(x)'
	  ],
	  'description': 'Remove inner and outer singleton dimensions from a matrix.',
	  'examples': [
	    'a = zeros(3,2,1)',
	    'size(squeeze(a))',
	    'b = zeros(1,1,3)',
	    'size(squeeze(b))'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'subset', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'subset',
	  'category': 'Matrix',
	  'syntax': [
	    'value(index)',
	    'value(index) = replacement',
	    'subset(value, [index])',
	    'subset(value, [index], replacement)'
	  ],
	  'description': 'Get or set a subset of a matrix or string. ' +
	      'Indexes are one-based. ' +
	      'Both the ranges lower-bound and upper-bound are included.',
	  'examples': [
	    'd = [1, 2; 3, 4]',
	    'e = []',
	    'e[1, 1:2] = [5, 6]',
	    'e[2, :] = [7, 8]',
	    'f = d * e',
	    'f[2, 1]',
	    'f[:, 1]'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'trace', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'trace',
	  'category': 'Matrix',
	  'syntax': [
	    'trace(A)'
	  ],
	  'description': 'Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.',
	  'examples': [
	    'A = [1, 2, 3; -1, 2, 3; 2, 0, 3]',
	    'trace(A)'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'transpose', 'zeros'
	  ]
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'transpose',
	  'category': 'Matrix',
	  'syntax': [
	    'x\'',
	    'transpose(x)'
	  ],
	  'description': 'Transpose a matrix',
	  'examples': [
	    'a = [1, 2, 3; 4, 5, 6]',
	    'a\'',
	    'transpose(a)'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'zeros'
	  ]
	};


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'zeros',
	  'category': 'Matrix',
	  'syntax': [
	    'zeros(m)',
	    'zeros(m, n)',
	    'zeros(m, n, p, ...)',
	    'zeros([m])',
	    'zeros([m, n])',
	    'zeros([m, n, p, ...])'
	  ],
	  'description': 'Create a matrix containing zeros.',
	  'examples': [
	    'zeros(3)',
	    'zeros(3, 5)',
	    'a = [1, 2, 3; 4, 5, 6]',
	    'zeros(size(a))'
	  ],
	  'seealso': [
	    'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose'
	  ]
	};


/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'combinations',
	  'category': 'Probability',
	  'syntax': [
	    'combinations(n, k)'
	  ],
	  'description': 'Compute the number of combinations of n items taken k at a time',
	  'examples': [
	    'combinations(7, 5)'
	  ],
	  'seealso': ['permutations', 'factorial']
	};


/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'factorial',
	  'category': 'Probability',
	  'syntax': [
	    'n!',
	    'factorial(n)'
	  ],
	  'description': 'Compute the factorial of a value',
	  'examples': [
	    '5!',
	    '5 * 4 * 3 * 2 * 1',
	    '3!'
	  ],
	  'seealso': ['combinations', 'permutations', 'gamma']
	};


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'gamma',
	  'category': 'Probability',
	  'syntax': [
	    'gamma(n)'
	  ],
	  'description': 'Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.',
	  'examples': [
	    'gamma(4)',
	    '3!',
	    'gamma(1/2)',
	    'sqrt(pi)'
	  ],
	  'seealso': ['factorial']
	};


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'kldivergence',
	  'category': 'Probability',
	  'syntax': [
	    'kldivergence(x, y)'
	  ],
	  'description': 'Calculate the Kullback-Leibler (KL) divergence  between two distributions.',
	  'examples': [
	    'kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'multinomial',
	  'category': 'Probability',
	  'syntax': [
	    'multinomial(A)'
	  ],
	  'description': 'Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.',
	  'examples': [
	    'multinomial([1, 2, 1])'
	  ],
	  'seealso': ['combinations', 'factorial']
	};

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'permutations',
	  'category': 'Probability',
	  'syntax': [
	    'permutations(n)',
	    'permutations(n, k)'
	  ],
	  'description': 'Compute the number of permutations of n items taken k at a time',
	  'examples': [
	    'permutations(5)',
	    'permutations(5, 3)'
	  ],
	  'seealso': ['combinations', 'factorial']
	};


/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'pickRandom',
	  'category': 'Probability',
	  'syntax': [
	    'pickRandom(array)',
	    'pickRandom(array, number)',
	    'pickRandom(array, weights)',
	    'pickRandom(array, number, weights)',
	    'pickRandom(array, weights, number)'
	  ],
	  'description':
	      'Pick a random entry from a given array.',
	  'examples': [
	    'pickRandom(0:10)',
	    'pickRandom([1, 3, 1, 6])',
	    'pickRandom([1, 3, 1, 6], 2)',
	    'pickRandom([1, 3, 1, 6], [2, 3, 2, 1])',
	    'pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])',
	    'pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)'
	  ],
	  'seealso': ['random', 'randomInt']
	};


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'random',
	  'category': 'Probability',
	  'syntax': [
	    'random()',
	    'random(max)',
	    'random(min, max)',
	    'random(size)',
	    'random(size, max)',
	    'random(size, min, max)'
	  ],
	  'description':
	      'Return a random number.',
	  'examples': [
	    'random()',
	    'random(10, 20)',
	    'random([2, 3])'
	  ],
	  'seealso': ['pickRandom', 'randomInt']
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'randomInt',
	  'category': 'Probability',
	  'syntax': [
	    'randomInt(max)',
	    'randomInt(min, max)',
	    'randomInt(size)',
	    'randomInt(size, max)',
	    'randomInt(size, min, max)'
	  ],
	  'description':
	      'Return a random integer number',
	  'examples': [
	    'randomInt(10, 20)',
	    'randomInt([2, 3], 10)'
	  ],
	  'seealso': ['pickRandom', 'random']
	};

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'compare',
	  'category': 'Relational',
	  'syntax': [
	    'compare(x, y)'
	  ],
	  'description':
	      'Compare two values. ' +
	      'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
	  'examples': [
	    'compare(2, 3)',
	    'compare(3, 2)',
	    'compare(2, 2)',
	    'compare(5cm, 40mm)',
	    'compare(2, [1, 2, 3])'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compareNatural', 'compareText'
	  ]
	};


/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'compareNatural',
	  'category': 'Relational',
	  'syntax': [
	    'compareNatural(x, y)'
	  ],
	  'description':
	      'Compare two values of any type in a deterministic, natural way. ' +
	      'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
	  'examples': [
	    'compareNatural(2, 3)',
	    'compareNatural(3, 2)',
	    'compareNatural(2, 2)',
	    'compareNatural(5cm, 40mm)',
	    'compareNatural("2", "10")',
	    'compareNatural(2 + 3i, 2 + 4i)',
	    'compareNatural([1, 2, 4], [1, 2, 3])',
	    'compareNatural([1, 5], [1, 2, 3])',
	    'compareNatural([1, 2], [1, 2])',
	    'compareNatural({a: 2}, {a: 4})'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compare', 'compareText'
	  ]
	};


/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'compareText',
	  'category': 'Relational',
	  'syntax': [
	    'compareText(x, y)'
	  ],
	  'description':
	      'Compare two strings lexically. Comparison is case sensitive. ' +
	      'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
	  'examples': [
	    'compareText("B", "A")',
	    'compareText("A", "B")',
	    'compareText("A", "A")',
	    'compareText("2", "10")',
	    'compare("2", "10")',
	    'compare(2, 10)',
	    'compareNatural("2", "10")',
	    'compareText("B", ["A", "B", "C"])'
	  ],
	  'seealso': [
	    'compare', 'compareNatural'
	  ]
	};


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'deepEqual',
	  'category': 'Relational',
	  'syntax': [
	    'deepEqual(x, y)'
	  ],
	  'description':
	      'Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.',
	  'examples': [
	    'deepEqual([1,3,4], [1,3,4])',
	    'deepEqual([1,3,4], [1,3])'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare'
	  ]
	};


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'equal',
	  'category': 'Relational',
	  'syntax': [
	    'x == y',
	    'equal(x, y)'
	  ],
	  'description':
	      'Check equality of two values. Returns true if the values are equal, and false if not.',
	  'examples': [
	    '2+2 == 3',
	    '2+2 == 4',
	    'a = 3.2',
	    'b = 6-2.8',
	    'a == b',
	    '50cm == 0.5m'
	  ],
	  'seealso': [
	    'unequal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare', 'deepEqual', 'equalText'
	  ]
	};


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'equalText',
	  'category': 'Relational',
	  'syntax': [
	    'equalText(x, y)'
	  ],
	  'description':
	      'Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.',
	  'examples': [
	    'equalText("Hello", "Hello")',
	    'equalText("a", "A")',
	    'equal("2e3", "2000")',
	    'equalText("2e3", "2000")',
	    'equalText("B", ["A", "B", "C"])'
	  ],
	  'seealso': [
	    'compare', 'compareNatural', 'compareText', 'equal'
	  ]
	};


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'larger',
	  'category': 'Relational',
	  'syntax': [
	    'x > y',
	    'larger(x, y)'
	  ],
	  'description':
	      'Check if value x is larger than y. Returns true if x is larger than y, and false if not.',
	  'examples': [
	    '2 > 3',
	    '5 > 2*2',
	    'a = 3.3',
	    'b = 6-2.8',
	    '(a > b)',
	    '(b < a)',
	    '5 cm > 2 inch'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compare'
	  ]
	};


/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'largerEq',
	  'category': 'Relational',
	  'syntax': [
	    'x >= y',
	    'largerEq(x, y)'
	  ],
	  'description':
	      'Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.',
	  'examples': [
	    '2 >= 1+1',
	    '2 > 1+1',
	    'a = 3.2',
	    'b = 6-2.8',
	    '(a >= b)'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'smallerEq', 'smaller', 'compare'
	  ]
	};


/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'smaller',
	  'category': 'Relational',
	  'syntax': [
	    'x < y',
	    'smaller(x, y)'
	  ],
	  'description':
	      'Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.',
	  'examples': [
	    '2 < 3',
	    '5 < 2*2',
	    'a = 3.3',
	    'b = 6-2.8',
	    '(a < b)',
	    '5 cm < 2 inch'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'larger', 'smallerEq', 'largerEq', 'compare'
	  ]
	};


/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'smallerEq',
	  'category': 'Relational',
	  'syntax': [
	    'x <= y',
	    'smallerEq(x, y)'
	  ],
	  'description':
	      'Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.',
	  'examples': [
	    '2 <= 1+1',
	    '2 < 1+1',
	    'a = 3.2',
	    'b = 6-2.8',
	    '(a <= b)'
	  ],
	  'seealso': [
	    'equal', 'unequal', 'larger', 'smaller', 'largerEq', 'compare'
	  ]
	};


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'unequal',
	  'category': 'Relational',
	  'syntax': [
	    'x != y',
	    'unequal(x, y)'
	  ],
	  'description':
	      'Check unequality of two values. Returns true if the values are unequal, and false if they are equal.',
	  'examples': [
	    '2+2 != 3',
	    '2+2 != 4',
	    'a = 3.2',
	    'b = 6-2.8',
	    'a != b',
	    '50cm != 0.5m',
	    '5 cm != 2 inch'
	  ],
	  'seealso': [
	    'equal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare', 'deepEqual'
	  ]
	};


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setCartesian',
	  'category': 'Set',
	  'syntax': [
	    'setCartesian(set1, set2)'
	  ],
	  'description':
	      'Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setCartesian([1, 2], [3, 4])'
	  ],
	  'seealso': [
	    'setUnion', 'setIntersect', 'setDifference', 'setPowerset'
	  ]
	};


/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setDifference',
	  'category': 'Set',
	  'syntax': [
	    'setDifference(set1, set2)'
	  ],
	  'description':
	      'Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setDifference([1, 2, 3, 4], [3, 4, 5, 6])',
	    'setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
	  ],
	  'seealso': [
	    'setUnion', 'setIntersect', 'setSymDifference'
	  ]
	};


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setDistinct',
	  'category': 'Set',
	  'syntax': [
	    'setDistinct(set)'
	  ],
	  'description':
	      'Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.',
	  'examples': [
	    'setDistinct([1, 1, 1, 2, 2, 3])'
	  ],
	  'seealso': [
	    'setMultiplicity'
	  ]
	};


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setIntersect',
	  'category': 'Set',
	  'syntax': [
	    'setIntersect(set1, set2)'
	  ],
	  'description':
	      'Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setIntersect([1, 2, 3, 4], [3, 4, 5, 6])',
	    'setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
	  ],
	  'seealso': [
	    'setUnion', 'setDifference'
	  ]
	};


/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setIsSubset',
	  'category': 'Set',
	  'syntax': [
	    'setIsSubset(set1, set2)'
	  ],
	  'description':
	      'Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setIsSubset([1, 2], [3, 4, 5, 6])',
	    'setIsSubset([3, 4], [3, 4, 5, 6])'
	  ],
	  'seealso': [
	    'setUnion', 'setIntersect', 'setDifference'
	  ]
	};


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setMultiplicity',
	  'category': 'Set',
	  'syntax': [
	    'setMultiplicity(element, set)'
	  ],
	  'description':
	      'Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.',
	  'examples': [
	    'setMultiplicity(1, [1, 2, 2, 4])',
	    'setMultiplicity(2, [1, 2, 2, 4])'
	  ],
	  'seealso': [
	    'setDistinct', 'setSize'
	  ]
	};


/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setPowerset',
	  'category': 'Set',
	  'syntax': [
	    'setPowerset(set)'
	  ],
	  'description':
	      'Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.',
	  'examples': [
	    'setPowerset([1, 2, 3])'
	  ],
	  'seealso': [
	    'setCartesian'
	  ]
	};


/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setSize',
	  'category': 'Set',
	  'syntax': [
	    'setSize(set)',
	    'setSize(set, unique)'
	  ],
	  'description':
	      'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
	  'examples': [
	    'setSize([1, 2, 2, 4])',
	    'setSize([1, 2, 2, 4], true)'
	  ],
	  'seealso': [
	    'setUnion', 'setIntersect', 'setDifference'
	  ]
	};


/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setSymDifference',
	  'category': 'Set',
	  'syntax': [
	    'setSymDifference(set1, set2)'
	  ],
	  'description':
	      'Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])',
	    'setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
	  ],
	  'seealso': [
	    'setUnion', 'setIntersect', 'setDifference'
	  ]
	};


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'setUnion',
	  'category': 'Set',
	  'syntax': [
	    'setUnion(set1, set2)'
	  ],
	  'description':
	      'Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
	  'examples': [
	    'setUnion([1, 2, 3, 4], [3, 4, 5, 6])',
	    'setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
	  ],
	  'seealso': [
	    'setIntersect', 'setDifference'
	  ]
	};


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'erf',
	  'category': 'Special',
	  'syntax': [
	    'erf(x)'
	  ],
	  'description': 'Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x',
	  'examples': [
	    'erf(0.2)',
	    'erf(-0.5)',
	    'erf(4)'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'mad',
	  'category': 'Statistics',
	  'syntax': [
	    'mad(a, b, c, ...)',
	    'mad(A)'
	  ],
	  'description': 'Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.',
	  'examples': [
	    'mad(10, 20, 30)',
	    'mad([1, 2, 3])'
	  ],
	  'seealso': [
	    'mean',
	    'median',
	    'std',
	    'abs'
	  ]
	};


/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'max',
	  'category': 'Statistics',
	  'syntax': [
	    'max(a, b, c, ...)',
	    'max(A)',
	    'max(A, dim)'
	  ],
	  'description': 'Compute the maximum value of a list of values.',
	  'examples': [
	    'max(2, 3, 4, 1)',
	    'max([2, 3, 4, 1])',
	    'max([2, 5; 4, 3])',
	    'max([2, 5; 4, 3], 1)',
	    'max([2, 5; 4, 3], 2)',
	    'max(2.7, 7.1, -4.5, 2.0, 4.1)',
	    'min(2.7, 7.1, -4.5, 2.0, 4.1)'
	  ],
	  'seealso': [
	    'mean',
	    'median',
	    'min',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'mean',
	  'category': 'Statistics',
	  'syntax': [
	    'mean(a, b, c, ...)',
	    'mean(A)',
	    'mean(A, dim)'
	  ],
	  'description': 'Compute the arithmetic mean of a list of values.',
	  'examples': [
	    'mean(2, 3, 4, 1)',
	    'mean([2, 3, 4, 1])',
	    'mean([2, 5; 4, 3])',
	    'mean([2, 5; 4, 3], 1)',
	    'mean([2, 5; 4, 3], 2)',
	    'mean([1.0, 2.7, 3.2, 4.0])'
	  ],
	  'seealso': [
	    'max',
	    'median',
	    'min',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'median',
	  'category': 'Statistics',
	  'syntax': [
	    'median(a, b, c, ...)',
	    'median(A)'
	  ],
	  'description': 'Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.',
	  'examples': [
	    'median(5, 2, 7)',
	    'median([3, -1, 5, 7])'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'min',
	    'prod',
	    'std',
	    'sum',
	    'var',
	    'quantileSeq'
	  ]
	};


/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'min',
	  'category': 'Statistics',
	  'syntax': [
	    'min(a, b, c, ...)',
	    'min(A)',
	    'min(A, dim)'
	  ],
	  'description': 'Compute the minimum value of a list of values.',
	  'examples': [
	    'min(2, 3, 4, 1)',
	    'min([2, 3, 4, 1])',
	    'min([2, 5; 4, 3])',
	    'min([2, 5; 4, 3], 1)',
	    'min([2, 5; 4, 3], 2)',
	    'min(2.7, 7.1, -4.5, 2.0, 4.1)',
	    'max(2.7, 7.1, -4.5, 2.0, 4.1)'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'median',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'mode',
	  'category': 'Statistics',
	  'syntax': [
	    'mode(a, b, c, ...)',
	    'mode(A)',
	    'mode(A, a, b, B, c, ...)'
	  ],
	  'description': 'Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.',
	  'examples': [
	    'mode(2, 1, 4, 3, 1)',
	    'mode([1, 2.7, 3.2, 4, 2.7])',
	    'mode(1, 4, 6, 1, 6)'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'min',
	    'median',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'prod',
	  'category': 'Statistics',
	  'syntax': [
	    'prod(a, b, c, ...)',
	    'prod(A)'
	  ],
	  'description': 'Compute the product of all values.',
	  'examples': [
	    'prod(2, 3, 4)',
	    'prod([2, 3, 4])',
	    'prod([2, 5; 4, 3])'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'min',
	    'median',
	    'min',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'quantileSeq',
	  'category': 'Statistics',
	  'syntax': [
	    'quantileSeq(A, prob[, sorted])',
	    'quantileSeq(A, [prob1, prob2, ...][, sorted])',
	    'quantileSeq(A, N[, sorted])'
	  ],
	  'description': 'Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.',
	  'examples': [
	    'quantileSeq([3, -1, 5, 7], 0.5)',
	    'quantileSeq([3, -1, 5, 7], [1/3, 2/3])',
	    'quantileSeq([3, -1, 5, 7], 2)',
	    'quantileSeq([-1, 3, 5, 7], 0.5, true)'
	  ],
	  'seealso': [
	    'mean',
	    'median',
	    'min',
	    'max',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'std',
	  'category': 'Statistics',
	  'syntax': [
	    'std(a, b, c, ...)',
	    'std(A)',
	    'std(A, normalization)'
	  ],
	  'description': 'Compute the standard deviation of all values, defined as std(A) = sqrt(var(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
	  'examples': [
	    'std(2, 4, 6)',
	    'std([2, 4, 6, 8])',
	    'std([2, 4, 6, 8], "uncorrected")',
	    'std([2, 4, 6, 8], "biased")',
	    'std([1, 2, 3; 4, 5, 6])'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'min',
	    'median',
	    'min',
	    'prod',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sum',
	  'category': 'Statistics',
	  'syntax': [
	    'sum(a, b, c, ...)',
	    'sum(A)'
	  ],
	  'description': 'Compute the sum of all values.',
	  'examples': [
	    'sum(2, 3, 4, 1)',
	    'sum([2, 3, 4, 1])',
	    'sum([2, 5; 4, 3])'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'median',
	    'min',
	    'prod',
	    'std',
	    'sum',
	    'var'
	  ]
	};


/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'var',
	  'category': 'Statistics',
	  'syntax': [
	    'var(a, b, c, ...)',
	    'var(A)',
	    'var(A, normalization)'
	  ],
	  'description': 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
	  'examples': [
	    'var(2, 4, 6)',
	    'var([2, 4, 6, 8])',
	    'var([2, 4, 6, 8], "uncorrected")',
	    'var([2, 4, 6, 8], "biased")',
	    'var([1, 2, 3; 4, 5, 6])'
	  ],
	  'seealso': [
	    'max',
	    'mean',
	    'min',
	    'median',
	    'min',
	    'prod',
	    'std',
	    'sum'
	  ]
	};


/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acos',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acos(x)'
	  ],
	  'description': 'Compute the inverse cosine of a value in radians.',
	  'examples': [
	    'acos(0.5)',
	    'acos(cos(2.3))'
	  ],
	  'seealso': [
	    'cos',
	    'atan',
	    'asin'
	  ]
	};


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acosh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acosh(x)'
	  ],
	  'description': 'Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.',
	  'examples': [
	    'acosh(1.5)'
	  ],
	  'seealso': [
	    'cosh',
	    'asinh',
	    'atanh'
	  ]
	};

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acot',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acot(x)'
	  ],
	  'description': 'Calculate the inverse cotangent of a value.',
	  'examples': [
	    'acot(0.5)',
	    'acot(cot(0.5))',
	    'acot(2)'
	  ],
	  'seealso': [
	    'cot',
	    'atan'
	  ]
	};


/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acoth',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acoth(x)'
	  ],
	  'description': 'Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.',
	  'examples': [
	    'acoth(2)',
	    'acoth(0.5)'
	  ],
	  'seealso': [
	    'acsch',
	    'asech'
	  ]
	};

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acsc',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acsc(x)'
	  ],
	  'description': 'Calculate the inverse cotangent of a value.',
	  'examples': [
	    'acsc(2)',
	    'acsc(csc(0.5))',
	    'acsc(0.5)'
	  ],
	  'seealso': [
	    'csc',
	    'asin',
	    'asec'
	  ]
	};


/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'acsch',
	  'category': 'Trigonometry',
	  'syntax': [
	    'acsch(x)'
	  ],
	  'description': 'Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.',
	  'examples': [
	    'acsch(0.5)'
	  ],
	  'seealso': [
	    'asech',
	    'acoth'
	  ]
	};


/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'asec',
	  'category': 'Trigonometry',
	  'syntax': [
	    'asec(x)'
	  ],
	  'description': 'Calculate the inverse secant of a value.',
	  'examples': [
	    'asec(0.5)',
	    'asec(sec(0.5))',
	    'asec(2)'
	  ],
	  'seealso': [
	    'acos',
	    'acot',
	    'acsc'
	  ]
	};


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'asech',
	  'category': 'Trigonometry',
	  'syntax': [
	    'asech(x)'
	  ],
	  'description': 'Calculate the inverse secant of a value.',
	  'examples': [
	    'asech(0.5)'
	  ],
	  'seealso': [
	    'acsch',
	    'acoth'
	  ]
	};


/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'asin',
	  'category': 'Trigonometry',
	  'syntax': [
	    'asin(x)'
	  ],
	  'description': 'Compute the inverse sine of a value in radians.',
	  'examples': [
	    'asin(0.5)',
	    'asin(sin(0.5))'
	  ],
	  'seealso': [
	    'sin',
	    'acos',
	    'atan'
	  ]
	};


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'asinh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'asinh(x)'
	  ],
	  'description': 'Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.',
	  'examples': [
	    'asinh(0.5)'
	  ],
	  'seealso': [
	    'acosh',
	    'atanh'
	  ]
	};


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'atan',
	  'category': 'Trigonometry',
	  'syntax': [
	    'atan(x)'
	  ],
	  'description': 'Compute the inverse tangent of a value in radians.',
	  'examples': [
	    'atan(0.5)',
	    'atan(tan(0.5))'
	  ],
	  'seealso': [
	    'tan',
	    'acos',
	    'asin'
	  ]
	};


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'atanh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'atanh(x)'
	  ],
	  'description': 'Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.',
	  'examples': [
	    'atanh(0.5)'
	  ],
	  'seealso': [
	    'acosh',
	    'asinh'
	  ]
	};


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'atan2',
	  'category': 'Trigonometry',
	  'syntax': [
	    'atan2(y, x)'
	  ],
	  'description':
	      'Computes the principal value of the arc tangent of y/x in radians.',
	  'examples': [
	    'atan2(2, 2) / pi',
	    'angle = 60 deg in rad',
	    'x = cos(angle)',
	    'y = sin(angle)',
	    'atan2(y, x)'
	  ],
	  'seealso': [
	    'sin',
	    'cos',
	    'tan'
	  ]
	};


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cos',
	  'category': 'Trigonometry',
	  'syntax': [
	    'cos(x)'
	  ],
	  'description': 'Compute the cosine of x in radians.',
	  'examples': [
	    'cos(2)',
	    'cos(pi / 4) ^ 2',
	    'cos(180 deg)',
	    'cos(60 deg)',
	    'sin(0.2)^2 + cos(0.2)^2'
	  ],
	  'seealso': [
	    'acos',
	    'sin',
	    'tan'
	  ]
	};


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cosh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'cosh(x)'
	  ],
	  'description': 'Compute the hyperbolic cosine of x in radians.',
	  'examples': [
	    'cosh(0.5)'
	  ],
	  'seealso': [
	    'sinh',
	    'tanh',
	    'coth'
	  ]
	};


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'cot',
	  'category': 'Trigonometry',
	  'syntax': [
	    'cot(x)'
	  ],
	  'description': 'Compute the cotangent of x in radians. Defined as 1/tan(x)',
	  'examples': [
	    'cot(2)',
	    '1 / tan(2)'
	  ],
	  'seealso': [
	    'sec',
	    'csc',
	    'tan'
	  ]
	};


/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'coth',
	  'category': 'Trigonometry',
	  'syntax': [
	    'coth(x)'
	  ],
	  'description': 'Compute the hyperbolic cotangent of x in radians.',
	  'examples': [
	    'coth(2)',
	    '1 / tanh(2)'
	  ],
	  'seealso': [
	    'sech',
	    'csch',
	    'tanh'
	  ]
	};


/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'csc',
	  'category': 'Trigonometry',
	  'syntax': [
	    'csc(x)'
	  ],
	  'description': 'Compute the cosecant of x in radians. Defined as 1/sin(x)',
	  'examples': [
	    'csc(2)',
	    '1 / sin(2)'
	  ],
	  'seealso': [
	    'sec',
	    'cot',
	    'sin'
	  ]
	};


/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'csch',
	  'category': 'Trigonometry',
	  'syntax': [
	    'csch(x)'
	  ],
	  'description': 'Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)',
	  'examples': [
	    'csch(2)',
	    '1 / sinh(2)'
	  ],
	  'seealso': [
	    'sech',
	    'coth',
	    'sinh'
	  ]
	};


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sec',
	  'category': 'Trigonometry',
	  'syntax': [
	    'sec(x)'
	  ],
	  'description': 'Compute the secant of x in radians. Defined as 1/cos(x)',
	  'examples': [
	    'sec(2)',
	    '1 / cos(2)'
	  ],
	  'seealso': [
	    'cot',
	    'csc',
	    'cos'
	  ]
	};


/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sech',
	  'category': 'Trigonometry',
	  'syntax': [
	    'sech(x)'
	  ],
	  'description': 'Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)',
	  'examples': [
	    'sech(2)',
	    '1 / cosh(2)'
	  ],
	  'seealso': [
	    'coth',
	    'csch',
	    'cosh'
	  ]
	};


/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sin',
	  'category': 'Trigonometry',
	  'syntax': [
	    'sin(x)'
	  ],
	  'description': 'Compute the sine of x in radians.',
	  'examples': [
	    'sin(2)',
	    'sin(pi / 4) ^ 2',
	    'sin(90 deg)',
	    'sin(30 deg)',
	    'sin(0.2)^2 + cos(0.2)^2'
	  ],
	  'seealso': [
	    'asin',
	    'cos',
	    'tan'
	  ]
	};


/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'sinh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'sinh(x)'
	  ],
	  'description': 'Compute the hyperbolic sine of x in radians.',
	  'examples': [
	    'sinh(0.5)'
	  ],
	  'seealso': [
	    'cosh',
	    'tanh'
	  ]
	};


/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'tan',
	  'category': 'Trigonometry',
	  'syntax': [
	    'tan(x)'
	  ],
	  'description': 'Compute the tangent of x in radians.',
	  'examples': [
	    'tan(0.5)',
	    'sin(0.5) / cos(0.5)',
	    'tan(pi / 4)',
	    'tan(45 deg)'
	  ],
	  'seealso': [
	    'atan',
	    'sin',
	    'cos'
	  ]
	};


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'tanh',
	  'category': 'Trigonometry',
	  'syntax': [
	    'tanh(x)'
	  ],
	  'description': 'Compute the hyperbolic tangent of x in radians.',
	  'examples': [
	    'tanh(0.5)',
	    'sinh(0.5) / cosh(0.5)'
	  ],
	  'seealso': [
	    'sinh',
	    'cosh'
	  ]
	};


/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'to',
	  'category': 'Units',
	  'syntax': [
	    'x to unit',
	    'to(x, unit)'
	  ],
	  'description': 'Change the unit of a value.',
	  'examples': [
	    '5 inch to cm',
	    '3.2kg to g',
	    '16 bytes in bits'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'clone',
	  'category': 'Utils',
	  'syntax': [
	    'clone(x)'
	  ],
	  'description': 'Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices',
	  'examples': [
	    'clone(3.5)',
	    'clone(2 - 4i)',
	    'clone(45 deg)',
	    'clone([1, 2; 3, 4])',
	    'clone("hello world")'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'format',
	  'category': 'Utils',
	  'syntax': [
	    'format(value)',
	    'format(value, precision)'
	  ],
	  'description': 'Format a value of any type as string.',
	  'examples': [
	    'format(2.3)',
	    'format(3 - 4i)',
	    'format([])',
	    'format(pi, 3)'
	  ],
	  'seealso': ['print']
	};


/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isNaN',
	  'category': 'Utils',
	  'syntax': [
	    'isNaN(x)'
	  ],
	  'description': 'Test whether a value is NaN (not a number)',
	  'examples': [
	    'isNaN(2)',
	    'isNaN(0 / 0)',
	    'isNaN(NaN)',
	    'isNaN(Infinity)'
	  ],
	  'seealso': ['isNegative', 'isNumeric', 'isPositive', 'isZero']
	};


/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isInteger',
	  'category': 'Utils',
	  'syntax': [
	    'isInteger(x)'
	  ],
	  'description': 'Test whether a value is an integer number.',
	  'examples': [
	    'isInteger(2)',
	    'isInteger(3.5)',
	    'isInteger([3, 0.5, -2])'
	  ],
	  'seealso': ['isNegative', 'isNumeric', 'isPositive', 'isZero']
	};


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isNegative',
	  'category': 'Utils',
	  'syntax': [
	    'isNegative(x)'
	  ],
	  'description': 'Test whether a value is negative: smaller than zero.',
	  'examples': [
	    'isNegative(2)',
	    'isNegative(0)',
	    'isNegative(-4)',
	    'isNegative([3, 0.5, -2])'
	  ],
	  'seealso': ['isInteger', 'isNumeric', 'isPositive', 'isZero']
	};


/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isNumeric',
	  'category': 'Utils',
	  'syntax': [
	    'isNumeric(x)'
	  ],
	  'description': 'Test whether a value is a numeric value. ' +
	    'Returns true when the input is a number, BigNumber, Fraction, or boolean.',
	  'examples': [
	    'isNumeric(2)',
	    'isNumeric(0)',
	    'isNumeric(bignumber(500))',
	    'isNumeric(fraction(0.125))',
	    'isNumeric("3")',
	    'isNumeric(2 + 3i)',
	    'isNumeric([2.3, "foo", false])'
	  ],
	  'seealso': ['isInteger', 'isZero', 'isNegative', 'isPositive', 'isNaN']
	};


/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isPositive',
	  'category': 'Utils',
	  'syntax': [
	    'isPositive(x)'
	  ],
	  'description': 'Test whether a value is positive: larger than zero.',
	  'examples': [
	    'isPositive(2)',
	    'isPositive(0)',
	    'isPositive(-4)',
	    'isPositive([3, 0.5, -2])'
	  ],
	  'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isZero']
	};


/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isPrime',
	  'category': 'Utils',
	  'syntax': [
	    'isPrime(x)'
	  ],
	  'description': 'Test whether a value is prime: has no divisors other than itself and one.',
	  'examples': [
	    'isPrime(3)',
	    'isPrime(-2)',
	    'isPrime([2, 17, 100])'
	  ],
	  'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isZero']
	};

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'isZero',
	  'category': 'Utils',
	  'syntax': [
	    'isZero(x)'
	  ],
	  'description': 'Test whether a value is zero.',
	  'examples': [
	    'isZero(2)',
	    'isZero(0)',
	    'isZero(-4)',
	    'isZero([3, 0, -2, 0])'
	  ],
	  'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isPositive']
	};


/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	module.exports = {
	  'name': 'typeof',
	  'category': 'Utils',
	  'syntax': [
	    'typeof(x)'
	  ],
	  'description': 'Get the type of a variable.',
	  'examples': [
	    'typeof(3.5)',
	    'typeof(2 - 4i)',
	    'typeof(45 deg)',
	    'typeof("hello world")'
	  ],
	  'seealso': []
	};


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1620),
	  __webpack_require__(1645),
	  __webpack_require__(1646),
	  __webpack_require__(1647),
	  __webpack_require__(1648)
	];


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var parse = load(__webpack_require__(1621));
	
	  /**
	   * Parse and compile an expression.
	   * Returns a an object with a function `eval([scope])` to evaluate the
	   * compiled expression.
	   *
	   * Syntax:
	   *
	   *     math.compile(expr)                       // returns one node
	   *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
	   *
	   * Examples:
	   *
	   *     var code = math.compile('sqrt(3^2 + 4^2)');
	   *     code.eval(); // 5
	   *
	   *     var scope = {a: 3, b: 4}
	   *     var code = math.compile('a * b'); // 12
	   *     code.eval(scope); // 12
	   *     scope.a = 5;
	   *     code.eval(scope); // 20
	   *
	   *     var nodes = math.compile(['a = 3', 'b = 4', 'a * b']);
	   *     nodes[2].eval(); // 12
	   *
	   * See also:
	   *
	   *    parse, eval
	   *
	   * @param {string | string[] | Array | Matrix} expr
	   *            The expression to be compiled
	   * @return {{eval: Function} | Array.<{eval: Function}>} code
	   *            An object with the compiled expression
	   * @throws {Error}
	   */
	  return typed('compile', {
	    'string': function (expr) {
	      return parse(expr).compile();
	    },
	
	    'Array | Matrix': function (expr) {
	      return deepMap(expr, function (entry) {
	        return parse(entry).compile();
	      });
	    }
	  });
	}
	
	exports.name = 'compile';
	exports.factory = factory;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ArgumentsError = __webpack_require__(1329);
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var numeric = load(__webpack_require__(1622));
	
	  var AccessorNode            = load(__webpack_require__(1623));
	  var ArrayNode               = load(__webpack_require__(1631));
	  var AssignmentNode          = load(__webpack_require__(1632));
	  var BlockNode               = load(__webpack_require__(1635));
	  var ConditionalNode         = load(__webpack_require__(1636));
	  var ConstantNode            = load(__webpack_require__(1637));
	  var FunctionAssignmentNode  = load(__webpack_require__(1638));
	  var IndexNode               = load(__webpack_require__(1627));
	  var ObjectNode              = load(__webpack_require__(1639));
	  var OperatorNode            = load(__webpack_require__(1640));
	  var ParenthesisNode         = load(__webpack_require__(1641));
	  var FunctionNode            = load(__webpack_require__(1642));
	  var RangeNode               = load(__webpack_require__(1644));
	  var SymbolNode              = load(__webpack_require__(1643));
	
	  /**
	   * Parse an expression. Returns a node tree, which can be evaluated by
	   * invoking node.eval();
	   *
	   * Syntax:
	   *
	   *     parse(expr)
	   *     parse(expr, options)
	   *     parse([expr1, expr2, expr3, ...])
	   *     parse([expr1, expr2, expr3, ...], options)
	   *
	   * Example:
	   *
	   *     var node = parse('sqrt(3^2 + 4^2)');
	   *     node.compile(math).eval(); // 5
	   *
	   *     var scope = {a:3, b:4}
	   *     var node = parse('a * b'); // 12
	   *     var code = node.compile(math);
	   *     code.eval(scope); // 12
	   *     scope.a = 5;
	   *     code.eval(scope); // 20
	   *
	   *     var nodes = math.parse(['a = 3', 'b = 4', 'a * b']);
	   *     nodes[2].compile(math).eval(); // 12
	   *
	   * @param {string | string[] | Matrix} expr
	   * @param {{nodes: Object<string, Node>}} [options]  Available options:
	   *                                                   - `nodes` a set of custom nodes
	   * @return {Node | Node[]} node
	   * @throws {Error}
	   */
	  function parse (expr, options) {
	    if (arguments.length !== 1 && arguments.length !== 2) {
	      throw new ArgumentsError('parse', arguments.length, 1, 2);
	    }
	
	    // pass extra nodes
	    extra_nodes = (options && options.nodes) ? options.nodes : {};
	
	    if (typeof expr === 'string') {
	      // parse a single expression
	      expression = expr;
	      return parseStart();
	    }
	    else if (Array.isArray(expr) || expr instanceof type.Matrix) {
	      // parse an array or matrix with expressions
	      return deepMap(expr, function (elem) {
	        if (typeof elem !== 'string') throw new TypeError('String expected');
	
	        expression = elem;
	        return parseStart();
	      });
	    }
	    else {
	      // oops
	      throw new TypeError('String or matrix expected');
	    }
	  }
	
	  // token types enumeration
	  var TOKENTYPE = {
	    NULL : 0,
	    DELIMITER : 1,
	    NUMBER : 2,
	    SYMBOL : 3,
	    UNKNOWN : 4
	  };
	
	  // map with all delimiters
	  var DELIMITERS = {
	    ',': true,
	    '(': true,
	    ')': true,
	    '[': true,
	    ']': true,
	    '{': true,
	    '}': true,
	    '\"': true,
	    ';': true,
	
	    '+': true,
	    '-': true,
	    '*': true,
	    '.*': true,
	    '/': true,
	    './': true,
	    '%': true,
	    '^': true,
	    '.^': true,
	    '~': true,
	    '!': true,
	    '&': true,
	    '|': true,
	    '^|': true,
	    '\'': true,
	    '=': true,
	    ':': true,
	    '?': true,
	
	    '==': true,
	    '!=': true,
	    '<': true,
	    '>': true,
	    '<=': true,
	    '>=': true,
	
	    '<<': true,
	    '>>': true,
	    '>>>': true
	  };
	
	  // map with all named delimiters
	  var NAMED_DELIMITERS = {
	    'mod': true,
	    'to': true,
	    'in': true,
	    'and': true,
	    'xor': true,
	    'or': true,
	    'not': true
	  };
	
	  var CONSTANTS = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  }
	
	  var NUMERIC_CONSTANTS = [
	    'NaN',
	    'Infinity'
	  ]
	
	  var extra_nodes = {};             // current extra nodes
	  var expression = '';              // current expression
	  var comment = '';                 // last parsed comment
	  var index = 0;                    // current index in expr
	  var c = '';                       // current token character in expr
	  var token = '';                   // current token
	  var token_type = TOKENTYPE.NULL;  // type of the token
	  var nesting_level = 0;            // level of nesting inside parameters, used to ignore newline characters
	  var conditional_level = null;     // when a conditional is being parsed, the level of the conditional is stored here
	  var tokenStates = [];             // holds saved token states
	
	  /**
	   * Get the first character from the expression.
	   * The character is stored into the char c. If the end of the expression is
	   * reached, the function puts an empty string in c.
	   * @private
	   */
	  function first() {
	    index = 0;
	    c = expression.charAt(0);
	    nesting_level = 0;
	    conditional_level = null;
	  }
	
	  /**
	   * Get the next character from the expression.
	   * The character is stored into the char c. If the end of the expression is
	   * reached, the function puts an empty string in c.
	   * @private
	   */
	  function next() {
	    index++;
	    c = expression.charAt(index);
	  }
	
	  /**
	   * Preview the previous character from the expression.
	   * @return {string} cNext
	   * @private
	   */
	  function prevPreview() {
	    return expression.charAt(index - 1);
	  }
	
	  /**
	   * Preview the next character from the expression.
	   * @return {string} cNext
	   * @private
	   */
	  function nextPreview() {
	    return expression.charAt(index + 1);
	  }
	
	  /**
	   * Preview the second next character from the expression.
	   * @return {string} cNext
	   * @private
	   */
	  function nextNextPreview() {
	    return expression.charAt(index + 2);
	  }
	
	  /**
	   * Save the current token state so we can rewind later if necessary.
	   * @private
	   */
	  function pushTokenState() {
	    tokenStates.push({
	      token_type: token_type,
	      token: token,
	      comment: comment,
	      index: index,
	      c: c
	    });
	  }
	
	  /**
	   * Rewind the parser by one token by restoring the last saved token state
	   * @private
	   */
	  function popTokenState() {
	    var restoredState = tokenStates.pop();
	    token_type = restoredState.token_type;
	    token = restoredState.token;
	    comment = restoredState.comment;
	    index = restoredState.index;
	    c = restoredState.c;
	  }
	
	  /**
	   * Discard the most recent token state without restoring it
	   * @private
	   */
	  function discardTokenState() {
	    tokenStates.pop();
	  }
	
	  /**
	   * Get next token in the current string expr.
	   * The token and token type are available as token and token_type
	   * @private
	   */
	  function getToken() {
	    token_type = TOKENTYPE.NULL;
	    token = '';
	    comment = '';
	
	    // skip over whitespaces
	    // space, tab, and newline when inside parameters
	    while (parse.isWhitespace(c, nesting_level)) {
	      next();
	    }
	
	    // skip comment
	    if (c === '#') {
	      while (c !== '\n' && c !== '') {
	        comment += c;
	        next();
	      }
	    }
	
	    // check for end of expression
	    if (c === '') {
	      // token is still empty
	      token_type = TOKENTYPE.DELIMITER;
	      return;
	    }
	
	    // check for new line character
	    if (c === '\n' && !nesting_level) {
	      token_type = TOKENTYPE.DELIMITER;
	      token = c;
	      next();
	      return;
	    }
	
	    // check for delimiters consisting of 3 characters
	    var c2 = c + nextPreview();
	    var c3 = c2 + nextNextPreview();
	    if (c3.length === 3 && DELIMITERS[c3]) {
	      token_type = TOKENTYPE.DELIMITER;
	      token = c3;
	      next();
	      next();
	      next();
	      return;
	    }
	
	    // check for delimiters consisting of 2 characters
	    if (c2.length === 2 && DELIMITERS[c2]) {
	      token_type = TOKENTYPE.DELIMITER;
	      token = c2;
	      next();
	      next();
	      return;
	    }
	
	    // check for delimiters consisting of 1 character
	    if (DELIMITERS[c]) {
	      token_type = TOKENTYPE.DELIMITER;
	      token = c;
	      next();
	      return;
	    }
	
	    // check for a number
	    if (parse.isDigitDot(c)) {
	      token_type = TOKENTYPE.NUMBER;
	
	      // get number, can have a single dot
	      if (c === '.') {
	        token += c;
	        next();
	
	        if (!parse.isDigit(c)) {
	          // this is no number, it is just a dot (can be dot notation)
	          token_type = TOKENTYPE.DELIMITER;
	        }
	      }
	      else {
	        while (parse.isDigit(c)) {
	          token += c;
	          next();
	        }
	        if (parse.isDecimalMark(c, nextPreview())) {
	          token += c;
	          next();
	        }
	      }
	      while (parse.isDigit(c)) {
	        token += c;
	        next();
	      }
	
	      // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
	      c2 = nextPreview();
	      if (c === 'E' || c === 'e') {
	        if (parse.isDigit(c2) || c2 === '-' || c2 === '+') {
	          token += c;
	          next();
	
	          if (c === '+' || c === '-') {
	            token += c;
	            next();
	          }
	
	          // Scientific notation MUST be followed by an exponent
	          if (!parse.isDigit(c)) {
	            throw createSyntaxError('Digit expected, got "' + c + '"');
	          }
	
	          while (parse.isDigit(c)) {
	            token += c;
	            next();
	          }
	
	          if (parse.isDecimalMark(c, nextPreview())) {
	            throw createSyntaxError('Digit expected, got "' + c + '"');
	          }
	        }
	        else if (c2 === '.') {
	          next();
	          throw createSyntaxError('Digit expected, got "' + c + '"');
	        }
	      }
	
	      return;
	    }
	
	    // check for variables, functions, named operators
	    if (parse.isAlpha(c, prevPreview(), nextPreview())) {
	      while (parse.isAlpha(c, prevPreview(), nextPreview()) || parse.isDigit(c)) {
	        token += c;
	        next();
	      }
	
	      if (NAMED_DELIMITERS.hasOwnProperty(token)) {
	        token_type = TOKENTYPE.DELIMITER;
	      }
	      else {
	        token_type = TOKENTYPE.SYMBOL;
	      }
	
	      return;
	    }
	
	    // something unknown is found, wrong characters -> a syntax error
	    token_type = TOKENTYPE.UNKNOWN;
	    while (c !== '') {
	      token += c;
	      next();
	    }
	    throw createSyntaxError('Syntax error in part "' + token + '"');
	  }
	
	  /**
	   * Get next token and skip newline tokens
	   */
	  function getTokenSkipNewline () {
	    do {
	      getToken();
	    }
	    while (token === '\n');
	  }
	
	  /**
	   * Open parameters.
	   * New line characters will be ignored until closeParams() is called
	   */
	  function openParams() {
	    nesting_level++;
	  }
	
	  /**
	   * Close parameters.
	   * New line characters will no longer be ignored
	   */
	  function closeParams() {
	    nesting_level--;
	  }
	
	  /**
	   * Checks whether the current character `c` is a valid alpha character:
	   *
	   * - A latin letter (upper or lower case) Ascii: a-z, A-Z
	   * - An underscore                        Ascii: _
	   * - A dollar sign                        Ascii: $
	   * - A latin letter with accents          Unicode: \u00C0 - \u02AF
	   * - A greek letter                       Unicode: \u0370 - \u03FF
	   * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
	   *
	   * The previous and next characters are needed to determine whether
	   * this character is part of a unicode surrogate pair.
	   *
	   * @param {string} c      Current character in the expression
	   * @param {string} cPrev  Previous character
	   * @param {string} cNext  Next character
	   * @return {boolean}
	   */
	  parse.isAlpha = function isAlpha (c, cPrev, cNext) {
	    return parse.isValidLatinOrGreek(c)
	        || parse.isValidMathSymbol(c, cNext)
	        || parse.isValidMathSymbol(cPrev, c);
	  };
	
	  /**
	   * Test whether a character is a valid latin, greek, or letter-like character
	   * @param {string} c
	   * @return {boolean}
	   */
	  parse.isValidLatinOrGreek = function isValidLatinOrGreek (c) {
	    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
	  };
	
	  /**
	   * Test whether two given 16 bit characters form a surrogate pair of a
	   * unicode math symbol.
	   *
	   * http://unicode-table.com/en/
	   * http://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
	   *
	   * Note: In ES6 will be unicode aware:
	   * http://stackoverflow.com/questions/280712/javascript-unicode-regexes
	   * https://mathiasbynens.be/notes/es6-unicode-regex
	   *
	   * @param {string} high
	   * @param {string} low
	   * @return {boolean}
	   */
	  parse.isValidMathSymbol = function isValidMathSymbol (high, low) {
	    return /^[\uD835]$/.test(high) &&
	        /^[\uDC00-\uDFFF]$/.test(low) &&
	        /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
	  };
	
	  /**
	   * Check whether given character c is a white space character: space, tab, or enter
	   * @param {string} c
	   * @param {number} nestingLevel
	   * @return {boolean}
	   */
	  parse.isWhitespace = function isWhitespace (c, nestingLevel) {
	    // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
	    return c === ' ' || c === '\t' || (c === '\n' && nestingLevel > 0);
	  };
	
	  /**
	   * Test whether the character c is a decimal mark (dot).
	   * This is the case when it's not the start of a delimiter '.*', './', or '.^'
	   * @param {string} c
	   * @param {string} cNext
	   * @return {boolean}
	   */
	  parse.isDecimalMark = function isDecimalMark (c, cNext) {
	    return c === '.' && cNext !== '/' && cNext !== '*' && cNext !== '^';
	  };
	
	  /**
	   * checks if the given char c is a digit or dot
	   * @param {string} c   a string with one character
	   * @return {boolean}
	   */
	  parse.isDigitDot = function isDigitDot (c) {
	    return ((c >= '0' && c <= '9') || c === '.');
	  };
	
	  /**
	   * checks if the given char c is a digit
	   * @param {string} c   a string with one character
	   * @return {boolean}
	   */
	  parse.isDigit = function isDigit (c) {
	    return (c >= '0' && c <= '9');
	  };
	
	  /**
	   * Start of the parse levels below, in order of precedence
	   * @return {Node} node
	   * @private
	   */
	  function parseStart () {
	    // get the first character in expression
	    first();
	
	    getToken();
	
	    var node = parseBlock();
	
	    // check for garbage at the end of the expression
	    // an expression ends with a empty character '' and token_type DELIMITER
	    if (token !== '') {
	      if (token_type === TOKENTYPE.DELIMITER) {
	        // user entered a not existing operator like "//"
	
	        // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
	        throw createError('Unexpected operator ' + token);
	      }
	      else {
	        throw createSyntaxError('Unexpected part "' + token + '"');
	      }
	    }
	
	    return node;
	  }
	
	  /**
	   * Parse a block with expressions. Expressions can be separated by a newline
	   * character '\n', or by a semicolon ';'. In case of a semicolon, no output
	   * of the preceding line is returned.
	   * @return {Node} node
	   * @private
	   */
	  function parseBlock () {
	    var node;
	    var blocks = [];
	    var visible;
	
	    if (token !== '' && token !== '\n' && token !== ';') {
	      node = parseAssignment();
	      node.comment = comment;
	    }
	
	    // TODO: simplify this loop
	    while (token === '\n' || token === ';') {
	      if (blocks.length === 0 && node) {
	        visible = (token !== ';');
	        blocks.push({
	          node: node,
	          visible: visible
	        });
	      }
	
	      getToken();
	      if (token !== '\n' && token !== ';' && token !== '') {
	        node = parseAssignment();
	        node.comment = comment;
	
	        visible = (token !== ';');
	        blocks.push({
	          node: node,
	          visible: visible
	        });
	      }
	    }
	
	    if (blocks.length > 0) {
	      return new BlockNode(blocks);
	    }
	    else {
	      if (!node) {
	        node = new ConstantNode(undefined);
	        node.comment = comment;
	      }
	
	      return node
	    }
	  }
	
	  /**
	   * Assignment of a function or variable,
	   * - can be a variable like 'a=2.3'
	   * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
	   * - defining a function like 'f(x) = x^2'
	   * @return {Node} node
	   * @private
	   */
	  function parseAssignment () {
	    var name, args, value, valid;
	
	    var node = parseConditional();
	
	    if (token === '=') {
	      if (type.isSymbolNode(node)) {
	        // parse a variable assignment like 'a = 2/3'
	        name = node.name;
	        getTokenSkipNewline();
	        value = parseAssignment();
	        return new AssignmentNode(new SymbolNode(name), value);
	      }
	      else if (type.isAccessorNode(node)) {
	        // parse a matrix subset assignment like 'A[1,2] = 4'
	        getTokenSkipNewline();
	        value = parseAssignment();
	        return new AssignmentNode(node.object, node.index, value);
	      }
	      else if (type.isFunctionNode(node) && type.isSymbolNode(node.fn)) {
	        // parse function assignment like 'f(x) = x^2'
	        valid = true;
	        args = [];
	
	        name = node.name;
	        node.args.forEach(function (arg, index) {
	          if (type.isSymbolNode(arg)) {
	            args[index] = arg.name;
	          }
	          else {
	            valid = false;
	          }
	        });
	
	        if (valid) {
	          getTokenSkipNewline();
	          value = parseAssignment();
	          return new FunctionAssignmentNode(name, args, value);
	        }
	      }
	
	      throw createSyntaxError('Invalid left hand side of assignment operator =');
	    }
	
	    return node;
	  }
	
	  /**
	   * conditional operation
	   *
	   *     condition ? truePart : falsePart
	   *
	   * Note: conditional operator is right-associative
	   *
	   * @return {Node} node
	   * @private
	   */
	  function parseConditional () {
	    var node = parseLogicalOr();
	
	    while (token === '?') {
	      // set a conditional level, the range operator will be ignored as long
	      // as conditional_level === nesting_level.
	      var prev = conditional_level;
	      conditional_level = nesting_level;
	      getTokenSkipNewline();
	
	      var condition = node;
	      var trueExpr = parseAssignment();
	
	      if (token !== ':') throw createSyntaxError('False part of conditional expression expected');
	
	      conditional_level = null;
	      getTokenSkipNewline();
	
	      var falseExpr = parseAssignment(); // Note: check for conditional operator again, right associativity
	
	      node = new ConditionalNode(condition, trueExpr, falseExpr);
	
	      // restore the previous conditional level
	      conditional_level = prev;
	    }
	
	    return node;
	  }
	
	  /**
	   * logical or, 'x or y'
	   * @return {Node} node
	   * @private
	   */
	  function parseLogicalOr() {
	    var node = parseLogicalXor();
	
	    while (token === 'or') {
	      getTokenSkipNewline();
	      node = new OperatorNode('or', 'or', [node, parseLogicalXor()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * logical exclusive or, 'x xor y'
	   * @return {Node} node
	   * @private
	   */
	  function parseLogicalXor() {
	    var node = parseLogicalAnd();
	
	    while (token === 'xor') {
	      getTokenSkipNewline();
	      node = new OperatorNode('xor', 'xor', [node, parseLogicalAnd()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * logical and, 'x and y'
	   * @return {Node} node
	   * @private
	   */
	  function parseLogicalAnd() {
	    var node = parseBitwiseOr();
	
	    while (token === 'and') {
	      getTokenSkipNewline();
	      node = new OperatorNode('and', 'and', [node, parseBitwiseOr()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * bitwise or, 'x | y'
	   * @return {Node} node
	   * @private
	   */
	  function parseBitwiseOr() {
	    var node = parseBitwiseXor();
	
	    while (token === '|') {
	      getTokenSkipNewline();
	      node = new OperatorNode('|', 'bitOr', [node, parseBitwiseXor()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * bitwise exclusive or (xor), 'x ^| y'
	   * @return {Node} node
	   * @private
	   */
	  function parseBitwiseXor() {
	    var node = parseBitwiseAnd();
	
	    while (token === '^|') {
	      getTokenSkipNewline();
	      node = new OperatorNode('^|', 'bitXor', [node, parseBitwiseAnd()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * bitwise and, 'x & y'
	   * @return {Node} node
	   * @private
	   */
	  function parseBitwiseAnd () {
	    var node = parseRelational();
	
	    while (token === '&') {
	      getTokenSkipNewline();
	      node = new OperatorNode('&', 'bitAnd', [node, parseRelational()]);
	    }
	
	    return node;
	  }
	
	  /**
	   * relational operators
	   * @return {Node} node
	   * @private
	   */
	  function parseRelational () {
	    var node, operators, name, fn, params;
	
	    node = parseShift();
	
	    operators = {
	      '==': 'equal',
	      '!=': 'unequal',
	      '<': 'smaller',
	      '>': 'larger',
	      '<=': 'smallerEq',
	      '>=': 'largerEq'
	    };
	    while (operators.hasOwnProperty(token)) {
	      name = token;
	      fn = operators[name];
	
	      getTokenSkipNewline();
	      params = [node, parseShift()];
	      node = new OperatorNode(name, fn, params);
	    }
	
	    return node;
	  }
	
	  /**
	   * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
	   * @return {Node} node
	   * @private
	   */
	  function parseShift () {
	    var node, operators, name, fn, params;
	
	    node = parseConversion();
	
	    operators = {
	      '<<' : 'leftShift',
	      '>>' : 'rightArithShift',
	      '>>>' : 'rightLogShift'
	    };
	
	    while (operators.hasOwnProperty(token)) {
	      name = token;
	      fn = operators[name];
	
	      getTokenSkipNewline();
	      params = [node, parseConversion()];
	      node = new OperatorNode(name, fn, params);
	    }
	
	    return node;
	  }
	
	  /**
	   * conversion operators 'to' and 'in'
	   * @return {Node} node
	   * @private
	   */
	  function parseConversion () {
	    var node, operators, name, fn, params;
	
	    node = parseRange();
	
	    operators = {
	      'to' : 'to',
	      'in' : 'to'   // alias of 'to'
	    };
	
	    while (operators.hasOwnProperty(token)) {
	      name = token;
	      fn = operators[name];
	
	      getTokenSkipNewline();
	      
	      if (name === 'in' && token === '') {
	        // end of expression -> this is the unit 'in' ('inch')
	        node = new OperatorNode('*', 'multiply', [node, new SymbolNode('in')], true);
	      }
	      else {
	        // operator 'a to b' or 'a in b'
	        params = [node, parseRange()];
	        node = new OperatorNode(name, fn, params);
	      }
	    }
	
	    return node;
	  }
	
	  /**
	   * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
	   * @return {Node} node
	   * @private
	   */
	  function parseRange () {
	    var node, params = [];
	
	    if (token === ':') {
	      // implicit start=1 (one-based)
	      node = new ConstantNode(1);
	    }
	    else {
	      // explicit start
	      node = parseAddSubtract();
	    }
	
	    if (token === ':' && (conditional_level !== nesting_level)) {
	      // we ignore the range operator when a conditional operator is being processed on the same level
	      params.push(node);
	
	      // parse step and end
	      while (token === ':' && params.length < 3) {
	        getTokenSkipNewline();
	
	        if (token === ')' || token === ']' || token === ',' || token === '') {
	          // implicit end
	          params.push(new SymbolNode('end'));
	        }
	        else {
	          // explicit end
	          params.push(parseAddSubtract());
	        }
	      }
	
	      if (params.length === 3) {
	        // params = [start, step, end]
	        node = new RangeNode(params[0], params[2], params[1]); // start, end, step
	      }
	      else { // length === 2
	        // params = [start, end]
	        node = new RangeNode(params[0], params[1]); // start, end
	      }
	    }
	
	    return node;
	  }
	
	  /**
	   * add or subtract
	   * @return {Node} node
	   * @private
	   */
	  function parseAddSubtract ()  {
	    var node, operators, name, fn, params;
	
	    node = parseMultiplyDivide();
	
	    operators = {
	      '+': 'add',
	      '-': 'subtract'
	    };
	    while (operators.hasOwnProperty(token)) {
	      name = token;
	      fn = operators[name];
	
	      getTokenSkipNewline();
	      params = [node, parseMultiplyDivide()];
	      node = new OperatorNode(name, fn, params);
	    }
	
	    return node;
	  }
	
	  /**
	   * multiply, divide, modulus
	   * @return {Node} node
	   * @private
	   */
	  function parseMultiplyDivide () {
	    var node, last, operators, name, fn;
	
	    node = parseImplicitMultiplication();
	    last = node;
	
	    operators = {
	      '*': 'multiply',
	      '.*': 'dotMultiply',
	      '/': 'divide',
	      './': 'dotDivide',
	      '%': 'mod',
	      'mod': 'mod'
	    };
	
	    while (true) {
	      if (operators.hasOwnProperty(token)) {
	        // explicit operators
	        name = token;
	        fn = operators[name];
	
	        getTokenSkipNewline();
	
	        last = parseImplicitMultiplication();
	        node = new OperatorNode(name, fn, [node, last]);
	      }
	      else {
	        break;
	      }
	    }
	
	    return node;
	  }
	  
	  /**
	   * implicit multiplication
	   * @return {Node} node
	   * @private
	   */
	  function parseImplicitMultiplication () {
	    var node, last;
	
	    node = parseRule2();
	    last = node;
	
	    while (true) {
	      if ((token_type === TOKENTYPE.SYMBOL) ||
	          (token === 'in' && type.isConstantNode(node)) ||
	          (token_type === TOKENTYPE.NUMBER &&
	              !type.isConstantNode(last) &&
	              (!type.isOperatorNode(last) || last.op === '!')) ||
	          (token === '(')) {
	        // parse implicit multiplication
	        //
	        // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
	        // number:      implicit multiplication like '(2+3)2'
	        // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
	        last = parseRule2();
	        node = new OperatorNode('*', 'multiply', [node, last], true /*implicit*/);
	      }
	      else {
	        break;
	      }
	    }
	
	    return node;
	  }
	  
	  /**
	   * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
	   * Explicit division gets higher precedence than implicit multiplication
	   * when the division matches this pattern: [number] / [number] [symbol]
	   * @return {Node} node
	   * @private
	   */
	  function parseRule2 () {
	    var node, last;
	    
	    node = parseUnary();
	    last = node;
	    
	    
	    while(true) {
	      
	      // Match the "number /" part of the pattern "number / number symbol"
	      if(token === '/' && type.isConstantNode(last)) {
	        
	        // Look ahead to see if the next token is a number
	        pushTokenState();
	        getTokenSkipNewline();
	        
	        // Match the "number / number" part of the pattern 
	        if(token_type === TOKENTYPE.NUMBER) {
	       
	          // Look ahead again
	          pushTokenState();
	          getTokenSkipNewline();
	          
	          // Match the "symbol" part of the pattern, or a left parenthesis
	          if(token_type === TOKENTYPE.SYMBOL || token === '(') {
	            // We've matched the pattern "number / number symbol".
	            // Rewind once and build the "number / number" node; the symbol will be consumed later
	            popTokenState();
	            discardTokenState();
	            last = parseUnary();
	            node = new OperatorNode('/', 'divide', [node, last]);
	          }
	          else {
	            // Not a match, so rewind
	            popTokenState();
	            popTokenState();
	            break;
	          }
	        } 
	        else {
	          // Not a match, so rewind
	          popTokenState();
	          break;
	        }
	      }
	      else {
	        break;
	      }
	    }
	    
	    return node;
	  }
	  
	  /**
	   * Unary plus and minus, and logical and bitwise not
	   * @return {Node} node
	   * @private
	   */
	  function parseUnary () {
	    var name, params, fn;
	    var operators = {
	      '-': 'unaryMinus',
	      '+': 'unaryPlus',
	      '~': 'bitNot',
	      'not': 'not'
	    };
	
	    if (operators.hasOwnProperty(token)) {
	      fn = operators[token];
	      name = token;
	
	      getTokenSkipNewline();
	      params = [parseUnary()];
	
	      return new OperatorNode(name, fn, params);
	    }
	
	    return parsePow();
	  }
	
	  /**
	   * power
	   * Note: power operator is right associative
	   * @return {Node} node
	   * @private
	   */
	  function parsePow () {
	    var node, name, fn, params;
	
	    node = parseLeftHandOperators();
	
	    if (token === '^' || token === '.^') {
	      name = token;
	      fn = (name === '^') ? 'pow' : 'dotPow';
	
	      getTokenSkipNewline();
	      params = [node, parseUnary()]; // Go back to unary, we can have '2^-3'
	      node = new OperatorNode(name, fn, params);
	    }
	
	    return node;
	  }
	
	  /**
	   * Left hand operators: factorial x!, transpose x'
	   * @return {Node} node
	   * @private
	   */
	  function parseLeftHandOperators ()  {
	    var node, operators, name, fn, params;
	
	    node = parseCustomNodes();
	
	    operators = {
	      '!': 'factorial',
	      '\'': 'transpose'
	    };
	
	    while (operators.hasOwnProperty(token)) {
	      name = token;
	      fn = operators[name];
	
	      getToken();
	      params = [node];
	
	      node = new OperatorNode(name, fn, params);
	      node = parseAccessors(node);
	    }
	
	    return node;
	  }
	
	  /**
	   * Parse a custom node handler. A node handler can be used to process
	   * nodes in a custom way, for example for handling a plot.
	   *
	   * A handler must be passed as second argument of the parse function.
	   * - must extend math.expression.node.Node
	   * - must contain a function _compile(defs: Object) : string
	   * - must contain a function find(filter: Object) : Node[]
	   * - must contain a function toString() : string
	   * - the constructor is called with a single argument containing all parameters
	   *
	   * For example:
	   *
	   *     nodes = {
	   *       'plot': PlotHandler
	   *     };
	   *
	   * The constructor of the handler is called as:
	   *
	   *     node = new PlotHandler(params);
	   *
	   * The handler will be invoked when evaluating an expression like:
	   *
	   *     node = math.parse('plot(sin(x), x)', nodes);
	   *
	   * @return {Node} node
	   * @private
	   */
	  function parseCustomNodes () {
	    var params = [];
	
	    if (token_type === TOKENTYPE.SYMBOL && extra_nodes.hasOwnProperty(token)) {
	      var CustomNode = extra_nodes[token];
	
	      getToken();
	
	      // parse parameters
	      if (token === '(') {
	        params = [];
	
	        openParams();
	        getToken();
	
	        if (token !== ')') {
	          params.push(parseAssignment());
	
	          // parse a list with parameters
	          while (token === ',') {
	            getToken();
	            params.push(parseAssignment());
	          }
	        }
	
	        if (token !== ')') {
	          throw createSyntaxError('Parenthesis ) expected');
	        }
	        closeParams();
	        getToken();
	      }
	
	      // create a new custom node
	      //noinspection JSValidateTypes
	      return new CustomNode(params);
	    }
	
	    return parseSymbol();
	  }
	
	  /**
	   * parse symbols: functions, variables, constants, units
	   * @return {Node} node
	   * @private
	   */
	  function parseSymbol () {
	    var node, name;
	
	    if (token_type === TOKENTYPE.SYMBOL ||
	        (token_type === TOKENTYPE.DELIMITER && token in NAMED_DELIMITERS)) {
	      name = token;
	
	      getToken();
	
	      if (CONSTANTS.hasOwnProperty(name)) { // true, false, null, ...
	        node = new ConstantNode(CONSTANTS[name]);
	      }
	      else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) { // NaN, Infinity
	        node = new ConstantNode(numeric(name));
	      }
	      else {
	        node = new SymbolNode(name);
	      }
	
	      // parse function parameters and matrix index
	      node = parseAccessors(node);
	      return node;
	    }
	
	    return parseString();
	  }
	
	  /**
	   * parse accessors:
	   * - function invocation in round brackets (...), for example sqrt(2)
	   * - index enclosed in square brackets [...], for example A[2,3]
	   * - dot notation for properties, like foo.bar
	   * @param {Node} node    Node on which to apply the parameters. If there
	   *                       are no parameters in the expression, the node
	   *                       itself is returned
	   * @param {string[]} [types]  Filter the types of notations
	   *                            can be ['(', '[', '.']
	   * @return {Node} node
	   * @private
	   */
	  function parseAccessors (node, types) {
	    var params;
	
	    while ((token === '(' || token === '[' || token === '.') &&
	        (!types || types.indexOf(token) !== -1)) {
	      params = [];
	
	      if (token === '(') {
	        if (type.isSymbolNode(node) || type.isAccessorNode(node)) {
	          // function invocation like fn(2, 3) or obj.fn(2, 3)
	          openParams();
	          getToken();
	
	          if (token !== ')') {
	            params.push(parseAssignment());
	
	            // parse a list with parameters
	            while (token === ',') {
	              getToken();
	              params.push(parseAssignment());
	            }
	          }
	
	          if (token !== ')') {
	            throw createSyntaxError('Parenthesis ) expected');
	          }
	          closeParams();
	          getToken();
	
	          node = new FunctionNode(node, params);
	        }
	        else {
	          // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
	          // don't parse it here but let it be handled by parseImplicitMultiplication
	          // with correct precedence
	          return node;
	        }
	      }
	      else if (token === '[') {
	        // index notation like variable[2, 3]
	        openParams();
	        getToken();
	
	        if (token !== ']') {
	          params.push(parseAssignment());
	
	          // parse a list with parameters
	          while (token === ',') {
	            getToken();
	            params.push(parseAssignment());
	          }
	        }
	
	        if (token !== ']') {
	          throw createSyntaxError('Parenthesis ] expected');
	        }
	        closeParams();
	        getToken();
	
	        node = new AccessorNode(node, new IndexNode(params));
	      }
	      else {
	        // dot notation like variable.prop
	        getToken();
	
	        if (token_type !== TOKENTYPE.SYMBOL) {
	          throw createSyntaxError('Property name expected after dot');
	        }
	        params.push(new ConstantNode(token));
	        getToken();
	
	        var dotNotation = true;
	        node = new AccessorNode(node, new IndexNode(params, dotNotation));
	      }
	    }
	
	    return node;
	  }
	
	  /**
	   * parse a string.
	   * A string is enclosed by double quotes
	   * @return {Node} node
	   * @private
	   */
	  function parseString () {
	    var node, str;
	
	    if (token === '"') {
	      str = parseStringToken();
	
	      // create constant
	      node = new ConstantNode(str);
	
	      // parse index parameters
	      node = parseAccessors(node);
	
	      return node;
	    }
	
	    return parseMatrix();
	  }
	
	  /**
	   * Parse a string surrounded by double quotes "..."
	   * @return {string}
	   */
	  function parseStringToken () {
	    var str = '';
	
	    while (c !== '' && c !== '\"') {
	      if (c === '\\') {
	        // escape character, immediately process the next
	        // character to prevent stopping at a next '\"'
	        str += c;
	        next();
	      }
	
	      str += c;
	      next();
	    }
	
	    getToken();
	    if (token !== '"') {
	      throw createSyntaxError('End of string " expected');
	    }
	    getToken();
	
	    return JSON.parse('"' + str + '"'); // unescape escaped characters
	  }
	
	  /**
	   * parse the matrix
	   * @return {Node} node
	   * @private
	   */
	  function parseMatrix () {
	    var array, params, rows, cols;
	
	    if (token === '[') {
	      // matrix [...]
	      openParams();
	      getToken();
	
	      if (token !== ']') {
	        // this is a non-empty matrix
	        var row = parseRow();
	
	        if (token === ';') {
	          // 2 dimensional array
	          rows = 1;
	          params = [row];
	
	          // the rows of the matrix are separated by dot-comma's
	          while (token === ';') {
	            getToken();
	
	            params[rows] = parseRow();
	            rows++;
	          }
	
	          if (token !== ']') {
	            throw createSyntaxError('End of matrix ] expected');
	          }
	          closeParams();
	          getToken();
	
	          // check if the number of columns matches in all rows
	          cols = params[0].items.length;
	          for (var r = 1; r < rows; r++) {
	            if (params[r].items.length !== cols) {
	              throw createError('Column dimensions mismatch ' +
	                  '(' + params[r].items.length + ' !== ' + cols + ')');
	            }
	          }
	
	          array = new ArrayNode(params);
	        }
	        else {
	          // 1 dimensional vector
	          if (token !== ']') {
	            throw createSyntaxError('End of matrix ] expected');
	          }
	          closeParams();
	          getToken();
	
	          array = row;
	        }
	      }
	      else {
	        // this is an empty matrix "[ ]"
	        closeParams();
	        getToken();
	        array = new ArrayNode([]);
	      }
	
	      return parseAccessors(array);
	    }
	
	    return parseObject();
	  }
	
	  /**
	   * Parse a single comma-separated row from a matrix, like 'a, b, c'
	   * @return {ArrayNode} node
	   */
	  function parseRow () {
	    var params = [parseAssignment()];
	    var len = 1;
	
	    while (token === ',') {
	      getToken();
	
	      // parse expression
	      params[len] = parseAssignment();
	      len++;
	    }
	
	    return new ArrayNode(params);
	  }
	
	  /**
	   * parse an object, enclosed in angle brackets{...}, for example {value: 2}
	   * @return {Node} node
	   * @private
	   */
	  function parseObject () {
	    if (token === '{') {
	      var key;
	
	      var properties = {};
	      do {
	        getToken();
	
	        if (token !== '}') {
	          // parse key
	          if (token === '"') {
	            key = parseStringToken();
	          }
	          else if (token_type === TOKENTYPE.SYMBOL) {
	            key = token;
	            getToken();
	          }
	          else {
	            throw createSyntaxError('Symbol or string expected as object key');
	          }
	
	          // parse key/value separator
	          if (token !== ':') {
	            throw createSyntaxError('Colon : expected after object key');
	          }
	          getToken();
	
	          // parse key
	          properties[key] = parseAssignment();
	        }
	      }
	      while (token === ',');
	
	      if (token !== '}') {
	        throw createSyntaxError('Comma , or bracket } expected after object value');
	      }
	      getToken();
	
	      var node = new ObjectNode(properties);
	
	      // parse index parameters
	      node = parseAccessors(node);
	
	      return node;
	    }
	
	    return parseNumber();
	  }
	
	  /**
	   * parse a number
	   * @return {Node} node
	   * @private
	   */
	  function parseNumber () {
	    var numberStr;
	
	    if (token_type === TOKENTYPE.NUMBER) {
	      // this is a number
	      numberStr = token;
	      getToken();
	
	      return new ConstantNode(numeric(numberStr, config.number));
	    }
	
	    return parseParentheses();
	  }
	
	  /**
	   * parentheses
	   * @return {Node} node
	   * @private
	   */
	  function parseParentheses () {
	    var node;
	
	    // check if it is a parenthesized expression
	    if (token === '(') {
	      // parentheses (...)
	      openParams();
	      getToken();
	
	      node = parseAssignment(); // start again
	
	      if (token !== ')') {
	        throw createSyntaxError('Parenthesis ) expected');
	      }
	      closeParams();
	      getToken();
	
	      node = new ParenthesisNode(node);
	      node = parseAccessors(node);
	      return node;
	    }
	
	    return parseEnd();
	  }
	
	  /**
	   * Evaluated when the expression is not yet ended but expected to end
	   * @return {Node} res
	   * @private
	   */
	  function parseEnd () {
	    if (token === '') {
	      // syntax error or unexpected end of expression
	      throw createSyntaxError('Unexpected end of expression');
	    } else if (token === "'") {
	      throw createSyntaxError('Value expected. Note: strings must be enclosed by double quotes');
	    } else {
	      throw createSyntaxError('Value expected');
	    }
	  }
	
	  /**
	   * Shortcut for getting the current row value (one based)
	   * Returns the line of the currently handled expression
	   * @private
	   */
	  /* TODO: implement keeping track on the row number
	  function row () {
	    return null;
	  }
	  */
	
	  /**
	   * Shortcut for getting the current col value (one based)
	   * Returns the column (position) where the last token starts
	   * @private
	   */
	  function col () {
	    return index - token.length + 1;
	  }
	
	  /**
	   * Create an error
	   * @param {string} message
	   * @return {SyntaxError} instantiated error
	   * @private
	   */
	  function createSyntaxError (message) {
	    var c = col();
	    var error = new SyntaxError(message + ' (char ' + c + ')');
	    error['char'] = c;
	
	    return error;
	  }
	
	  /**
	   * Create an error
	   * @param {string} message
	   * @return {Error} instantiated error
	   * @private
	   */
	  function createError (message) {
	    var c = col();
	    var error = new SyntaxError(message + ' (char ' + c + ')');
	    error['char'] = c;
	
	    return error;
	  }
	
	  return parse;
	}
	
	exports.name = 'parse';
	exports.path = 'expression';
	exports.factory = factory;


/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory(type, config, load, typed) {
	
	  // TODO: expose this function to mathjs, add documentation
	
	  /**
	   * Create a numeric value with a specific type: number, BigNumber, or Fraction
	   *
	   * @param {string | number} value
	   * @param {'number' | 'BigNumber' | 'Fraction'}
	   * @return {number | BigNumber | Fraction} Returns an instance of the
	   *                                         numeric requested type
	   */
	  return function numeric (value, valueType) {
	    if (valueType === 'BigNumber') {
	      return new type.BigNumber(value);
	    }
	    else if (valueType === 'Fraction') {
	      return new type.Fraction(value);
	    }
	    else {
	      // valueType === 'number' or undefined // TODO: check this
	      if (typeof value === 'number') {
	        return value;
	      }
	      else {
	        if (value === 'Infinity') {
	          return Infinity;
	        }
	
	        if (value === 'NaN') {
	          return NaN;
	        }
	
	        // The following regexp is relatively permissive
	        if (!/^[\-+]?((\d+\.?\d*)|(\d*\.?\d+))([eE][+\-]?\d+)?$/.test(value)) {
	          throw new Error('Invalid numeric value "' + value + '"');
	        }
	
	        // remove leading zeros like '003.2' which are not allowed by JavaScript
	        return parseFloat(value.replace(/^(0*)[0-9]/, function (match, zeros) {
	          return match.substring(zeros.length);
	        }));
	      }
	    }
	  }
	}
	
	exports.factory = factory;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var IndexNode = load(__webpack_require__(1627));
	  var access = load(__webpack_require__(1628));
	
	  /**
	   * @constructor AccessorNode
	   * @extends {Node}
	   * Access an object property or get a matrix subset
	   *
	   * @param {Node} object                 The object from which to retrieve
	   *                                      a property or subset.
	   * @param {IndexNode} index             IndexNode containing ranges
	   */
	  function AccessorNode(object, index) {
	    if (!(this instanceof AccessorNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (!type.isNode(object)) {
	      throw new TypeError('Node expected for parameter "object"');
	    }
	    if (!type.isIndexNode(index)) {
	      throw new TypeError('IndexNode expected for parameter "index"');
	    }
	
	    this.object = object || null;
	    this.index = index;
	
	    // readonly property name
	    Object.defineProperty(this, 'name', {
	      get: function () {
	        if (this.index) {
	          return (this.index.isObjectProperty())
	              ? this.index.getObjectProperty()
	              : '';
	        }
	        else {
	          return this.object.name || '';
	        }
	      }.bind(this),
	      set: function () {
	        throw new Error('Cannot assign a new name, name is read-only');
	      }
	    });
	  }
	
	  AccessorNode.prototype = new Node();
	
	  AccessorNode.prototype.type = 'AccessorNode';
	
	  AccessorNode.prototype.isAccessorNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  AccessorNode.prototype._compile = function (math, argNames) {
	    var evalObject = this.object._compile(math, argNames);
	    var evalIndex = this.index._compile(math, argNames);
	
	    if (this.index.isObjectProperty()) {
	      var prop = this.index.getObjectProperty();
	      return function evalAccessorNode(scope, args, context) {
	        return getSafeProperty(evalObject(scope, args, context), prop);
	      };
	    }
	    else {
	      return function evalAccessorNode (scope, args, context) {
	        var object = evalObject(scope, args, context);
	        var index = evalIndex(scope, args, object); // we pass object here instead of context
	        return access(object, index);
	      };
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  AccessorNode.prototype.forEach = function (callback) {
	    callback(this.object, 'object', this);
	    callback(this.index, 'index', this);
	  };
	
	  /**
	   * Create a new AccessorNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {AccessorNode} Returns a transformed copy of the node
	   */
	  AccessorNode.prototype.map = function (callback) {
	    return new AccessorNode(
	        this._ifNode(callback(this.object, 'object', this)),
	        this._ifNode(callback(this.index, 'index', this))
	    );
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {AccessorNode}
	   */
	  AccessorNode.prototype.clone = function () {
	    return new AccessorNode(this.object, this.index);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AccessorNode.prototype._toString = function (options) {
	    var object = this.object.toString(options);
	    if (needParenthesis(this.object)) {
	      object = '(' + object + ')';
	    }
	
	    return object + this.index.toString(options);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AccessorNode.prototype.toHTML = function (options) {
	    var object = this.object.toHTML(options);
	    if (needParenthesis(this.object)) {
	      object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	
	    return object + this.index.toHTML(options);
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AccessorNode.prototype._toTex = function (options) {
	    var object = this.object.toTex(options);
	    if (needParenthesis(this.object)) {
	      object = '\\left(' + object + '\\right)';
	    }
	
	    return object + this.index.toTex(options);
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  AccessorNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'AccessorNode',
	      object: this.object,
	      index: this.index
	    };
	  };
	
	  /**
	   * Instantiate an AccessorNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
	   *                       where mathjs is optional
	   * @returns {AccessorNode}
	   */
	  AccessorNode.fromJSON = function (json) {
	    return new AccessorNode(json.object, json.index);
	  };
	
	  /**
	   * Are parenthesis needed?
	   * @private
	   */
	  function needParenthesis(node) {
	    // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
	    return !(
	        type.isAccessorNode(node) ||
	        type.isArrayNode(node) ||
	        type.isConstantNode(node) ||
	        type.isFunctionNode(node) ||
	        type.isObjectNode(node) ||
	        type.isParenthesisNode(node) ||
	        type.isSymbolNode(node));
	  }
	
	  return AccessorNode;
	}
	
	exports.name = 'AccessorNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasOwnProperty = __webpack_require__(1320).hasOwnProperty;
	
	/**
	 * Get a property of a plain object
	 * Throws an error in case the object is not a plain object or the
	 * property is not defined on the object itself
	 * @param {Object} object
	 * @param {string} prop
	 * @return {*} Returns the property value when safe
	 */
	function getSafeProperty (object, prop) {
	  // only allow getting safe properties of a plain object
	  if (isPlainObject(object) && isSafeProperty(object, prop)) {
	    return object[prop];
	  }
	
	  if (typeof object[prop] === 'function' && isSafeMethod(object, prop)) {
	    throw new Error('Cannot access method "' + prop + '" as a property');
	  }
	
	  throw new Error('No access to property "' + prop + '"');
	}
	
	/**
	 * Set a property on a plain object.
	 * Throws an error in case the object is not a plain object or the
	 * property would override an inherited property like .constructor or .toString
	 * @param {Object} object
	 * @param {string} prop
	 * @param {*} value
	 * @return {*} Returns the value
	 */
	// TODO: merge this function into access.js?
	function setSafeProperty (object, prop, value) {
	  // only allow setting safe properties of a plain object
	  if (isPlainObject(object) && isSafeProperty(object, prop)) {
	    return object[prop] = value;
	  }
	
	  throw new Error('No access to property "' + prop + '"');
	}
	
	/**
	 * Test whether a property is safe to use for an object.
	 * For example .toString and .constructor are not safe
	 * @param {string} prop
	 * @return {boolean} Returns true when safe
	 */
	function isSafeProperty (object, prop) {
	  if (!object || typeof object !== 'object') {
	    return false;
	  }
	  // SAFE: whitelisted
	  // e.g length
	  if (hasOwnProperty(safeNativeProperties, prop)) {
	    return true;
	  }
	  // UNSAFE: inherited from Object prototype
	  // e.g constructor
	  if (prop in Object.prototype) {
	    // 'in' is used instead of hasOwnProperty for nodejs v0.10
	    // which is inconsistent on root prototypes. It is safe
	    // here because Object.prototype is a root object
	    return false;
	  }
	  // UNSAFE: inherited from Function prototype
	  // e.g call, apply
	  if (prop in Function.prototype) {
	    // 'in' is used instead of hasOwnProperty for nodejs v0.10
	    // which is inconsistent on root prototypes. It is safe
	    // here because Function.prototype is a root object
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Validate whether a method is safe.
	 * Throws an error when that's not the case.
	 * @param {Object} object
	 * @param {string} method
	 */
	// TODO: merge this function into assign.js?
	function validateSafeMethod (object, method) {
	  if (!isSafeMethod(object, method)) {
	    throw new Error('No access to method "' + method + '"');
	  }
	}
	
	/**
	 * Check whether a method is safe.
	 * Throws an error when that's not the case (for example for `constructor`).
	 * @param {Object} object
	 * @param {string} method
	 * @return {boolean} Returns true when safe, false otherwise
	 */
	function isSafeMethod (object, method) {
	  if (!object || typeof object[method] !== 'function') {
	    return false;
	  }
	  // UNSAFE: ghosted
	  // e.g overridden toString
	  // Note that IE10 doesn't support __proto__ and we can't do this check there.
	  if (hasOwnProperty(object, method) &&
	      (object.__proto__ && (method in object.__proto__))) {
	    return false;
	  }
	  // SAFE: whitelisted
	  // e.g toString
	  if (hasOwnProperty(safeNativeMethods, method)) {
	    return true;
	  }
	  // UNSAFE: inherited from Object prototype
	  // e.g constructor
	  if (method in Object.prototype) {
	    // 'in' is used instead of hasOwnProperty for nodejs v0.10
	    // which is inconsistent on root prototypes. It is safe
	    // here because Object.prototype is a root object
	    return false;
	  }
	  // UNSAFE: inherited from Function prototype
	  // e.g call, apply
	  if (method in Function.prototype) {
	    // 'in' is used instead of hasOwnProperty for nodejs v0.10
	    // which is inconsistent on root prototypes. It is safe
	    // here because Function.prototype is a root object
	    return false;
	  }
	  return true;
	}
	
	function isPlainObject (object) {
	  return typeof object === 'object' && object && object.constructor === Object;
	}
	
	var safeNativeProperties = {
	  length: true,
	  name: true
	};
	
	var safeNativeMethods = {
	  toString: true,
	  valueOf: true,
	  toLocaleString: true
	};
	
	exports.getSafeProperty = getSafeProperty;
	exports.setSafeProperty = setSafeProperty;
	exports.isSafeProperty = isSafeProperty;
	exports.validateSafeMethod = validateSafeMethod;
	exports.isSafeMethod = isSafeMethod;
	exports.isPlainObject = isPlainObject;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keywords = __webpack_require__(1626);
	var deepEqual= __webpack_require__(1320).deepEqual;
	var hasOwnProperty = __webpack_require__(1320).hasOwnProperty;
	
	function factory (type, config, load, typed, math) {
	
	  /**
	   * Node
	   */
	  function Node() {
	    if (!(this instanceof Node)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	  }
	
	  /**
	   * Evaluate the node
	   * @param {Object} [scope]  Scope to read/write variables
	   * @return {*}              Returns the result
	   */
	  Node.prototype.eval = function(scope) {
	    return this.compile().eval(scope);
	  };
	
	  Node.prototype.type = 'Node';
	
	  Node.prototype.isNode = true;
	
	  Node.prototype.comment = '';
	
	  /**
	   * Compile the node into an optimized, evauatable JavaScript function 
	   * @return {{eval: function([Object])}} expr  Returns an object with a function 'eval',
	   *                                  which can be invoked as expr.eval([scope: Object]),
	   *                                  where scope is an optional object with
	   *                                  variables.
	   */
	  Node.prototype.compile = function () {
	    var expr = this._compile(math.expression.mathWithTransform, {});
	    var args = {};
	    var context = null;
	    return {
	      eval: function evalNode(scope) {
	        var s = scope ? scope : {};
	        _validateScope(s);
	        return expr(s, args, context);
	      }
	    }
	  };
	  
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  Node.prototype._compile = function (math, argNames) {
	    throw new Error('Method _compile should be implemented by type ' + this.type);
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  Node.prototype.forEach = function (callback) {
	    // must be implemented by each of the Node implementations
	    throw new Error('Cannot run forEach on a Node interface');
	  };
	
	  /**
	   * Create a new Node having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {OperatorNode} Returns a transformed copy of the node
	   */
	  Node.prototype.map = function (callback) {
	    // must be implemented by each of the Node implementations
	    throw new Error('Cannot run map on a Node interface');
	  };
	
	  /**
	   * Validate whether an object is a Node, for use with map
	   * @param {Node} node
	   * @returns {Node} Returns the input if it's a node, else throws an Error
	   * @protected
	   */
	  Node.prototype._ifNode = function (node) {
	    if (!type.isNode(node)) {
	      throw new TypeError('Callback function must return a Node');
	    }
	
	    return node;
	  };
	
	  /**
	   * Recursively traverse all nodes in a node tree. Executes given callback for
	   * this node and each of its child nodes.
	   * @param {function(node: Node, path: string, parent: Node)} callback
	   *          A callback called for every node in the node tree.
	   */
	  Node.prototype.traverse = function (callback) {
	    // execute callback for itself
	    callback(this, null, null);
	
	    // recursively traverse over all childs of a node
	    function _traverse(node, callback) {
	      node.forEach(function (child, path, parent) {
	        callback(child, path, parent);
	        _traverse(child, callback);
	      });
	    }
	
	    _traverse(this, callback);
	  };
	
	  /**
	   * Recursively transform a node tree via a transform function.
	   *
	   * For example, to replace all nodes of type SymbolNode having name 'x' with a
	   * ConstantNode with value 2:
	   *
	   *     var res = Node.transform(function (node, path, parent) {
	   *       if (node && node.isSymbolNode) && (node.name == 'x')) {
	   *         return new ConstantNode(2);
	   *       }
	   *       else {
	   *         return node;
	   *       }
	   *     });
	   *
	   * @param {function(node: Node, path: string, parent: Node) : Node} callback
	   *          A mapping function accepting a node, and returning
	   *          a replacement for the node or the original node.
	   *          Signature: callback(node: Node, index: string, parent: Node) : Node
	   * @return {Node} Returns the original node or its replacement
	   */
	  Node.prototype.transform = function (callback) {
	    // traverse over all childs
	    function _transform (node, callback) {
	      return node.map(function(child, path, parent) {
	        var replacement = callback(child, path, parent);
	        return _transform(replacement, callback);
	      });
	    }
	
	    var replacement = callback(this, null, null);
	    return _transform(replacement, callback);
	  };
	
	  /**
	   * Find any node in the node tree matching given filter function. For example, to
	   * find all nodes of type SymbolNode having name 'x':
	   *
	   *     var results = Node.filter(function (node) {
	   *       return (node && node.isSymbolNode) && (node.name == 'x');
	   *     });
	   *
	   * @param {function(node: Node, path: string, parent: Node) : Node} callback
	   *            A test function returning true when a node matches, and false
	   *            otherwise. Function signature:
	   *            callback(node: Node, index: string, parent: Node) : boolean
	   * @return {Node[]} nodes       An array with nodes matching given filter criteria
	   */
	  Node.prototype.filter = function (callback) {
	    var nodes = [];
	
	    this.traverse(function (node, path, parent) {
	      if (callback(node, path, parent)) {
	        nodes.push(node);
	      }
	    });
	
	    return nodes;
	  };
	
	  // TODO: deprecated since version 1.1.0, remove this some day
	  Node.prototype.find = function () {
	    throw new Error('Function Node.find is deprecated. Use Node.filter instead.');
	  };
	
	  // TODO: deprecated since version 1.1.0, remove this some day
	  Node.prototype.match = function () {
	    throw new Error('Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.');
	  };
	
	  /**
	   * Create a shallow clone of this node
	   * @return {Node}
	   */
	  Node.prototype.clone = function () {
	    // must be implemented by each of the Node implementations
	    throw new Error('Cannot clone a Node interface');
	  };
	
	  /**
	   * Create a deep clone of this node
	   * @return {Node}
	   */
	  Node.prototype.cloneDeep = function () {
	    return this.map(function (node) {
	      return node.cloneDeep();
	    });
	  };
	
	  /**
	   * Deep compare this node with another node.
	   * @param {Node} other
	   * @return {boolean} Returns true when both nodes are of the same type and
	   *                   contain the same values (as do their childs)
	   */
	  Node.prototype.equals = function (other) {
	    return other
	        ? deepEqual(this, other)
	        : false
	  };
	
	  /**
	   * Get string representation. (wrapper function)
	   *
	   * This function can get an object of the following form:
	   * {
	   *    handler: //This can be a callback function of the form
	   *             // "function callback(node, options)"or
	   *             // a map that maps function names (used in FunctionNodes)
	   *             // to callbacks
	   *    parenthesis: "keep" //the parenthesis option (This is optional)
	   * }
	   *
	   * @param {Object} [options]
	   * @return {string}
	   */
	  Node.prototype.toString = function (options) {
	    var customString;
	    if (options && typeof options === 'object') {
	        switch (typeof options.handler) {
	          case 'object':
	          case 'undefined':
	            break;
	          case 'function':
	            customString = options.handler(this, options);
	            break;
	          default:
	            throw new TypeError('Object or function expected as callback');
	        }
	    }
	
	    if (typeof customString !== 'undefined') {
	      return customString;
	    }
	
	    return this._toString(options);
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * Both .toJSON() and the static .fromJSON(json) should be implemented by all
	   * implementations of Node
	   * @returns {Object}
	   */
	  Node.prototype.toJSON = function () {
	    throw new Error('Cannot serialize object: toJSON not implemented by ' + this.type);
	  };
	
	  /**
	   * Get HTML representation. (wrapper function)
	   *
	   * This function can get an object of the following form:
	   * {
	   *    handler: //This can be a callback function of the form
	   *             // "function callback(node, options)" or
	   *             // a map that maps function names (used in FunctionNodes)
	   *             // to callbacks
	   *    parenthesis: "keep" //the parenthesis option (This is optional)
	   * }
	   *
	   * @param {Object} [options]
	   * @return {string}
	   */
	  Node.prototype.toHTML = function (options) {
	    var customString;
	    if (options && typeof options === 'object') {
	        switch (typeof options.handler) {
	          case 'object':
	          case 'undefined':
	            break;
	          case 'function':
	            customString = options.handler(this, options);
	            break;
	          default:
	            throw new TypeError('Object or function expected as callback');
	        }
	    }
	
	    if (typeof customString !== 'undefined') {
	      return customString;
	    }
	
	    return this.toHTML(options);
	  };
	
	  /**
	   * Internal function to generate the string output.
	   * This has to be implemented by every Node
	   *
	   * @throws {Error}
	   */
	  Node.prototype._toString = function () {
	    //must be implemented by each of the Node implementations
	    throw new Error('_toString not implemented for ' + this.type);
	  };
	
	  /**
	   * Get LaTeX representation. (wrapper function)
	   *
	   * This function can get an object of the following form:
	   * {
	   *    handler: //This can be a callback function of the form
	   *             // "function callback(node, options)"or
	   *             // a map that maps function names (used in FunctionNodes)
	   *             // to callbacks
	   *    parenthesis: "keep" //the parenthesis option (This is optional)
	   * }
	   *
	   * @param {Object} [options]
	   * @return {string}
	   */
	  Node.prototype.toTex = function (options) {
	    var customTex;
	    if (options && typeof options == 'object') {
	      switch (typeof options.handler) {
	        case 'object':
	        case 'undefined':
	          break;
	        case 'function':
	          customTex = options.handler(this, options);
	          break;
	        default:
	          throw new TypeError('Object or function expected as callback');
	      }
	    }
	
	    if (typeof customTex !== 'undefined') {
	      return customTex;
	    }
	
	    return this._toTex(options);
	  };
	
	  /**
	   * Internal function to generate the LaTeX output.
	   * This has to be implemented by every Node
	   *
	   * @param {Object} [options]
	   * @throws {Error}
	   */
	  Node.prototype._toTex = function (options) {
	    //must be implemented by each of the Node implementations
	    throw new Error('_toTex not implemented for ' + this.type);
	  };
	
	  /**
	   * Get identifier.
	   * @return {string}
	   */
	  Node.prototype.getIdentifier = function () {
	    return this.type;
	  };
	
	  /**
	   * Get the content of the current Node.
	   * @return {Node} node
	   **/
	  Node.prototype.getContent = function () {
	    return this;
	  };
	
	  /**
	   * Validate the symbol names of a scope.
	   * Throws an error when the scope contains an illegal symbol.
	   * @param {Object} scope
	   */
	  function _validateScope(scope) {
	    for (var symbol in scope) {
	      if (hasOwnProperty(scope, symbol)) {
	        if (symbol in keywords) {
	          throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
	        }
	      }
	    }
	  }
	
	  return Node;
	}
	
	exports.name = 'Node';
	exports.path = 'expression.node';
	exports.math = true; // request access to the math namespace as 5th argument of the factory function
	exports.factory = factory;


/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	'use strict';
	
	// Reserved keywords not allowed to use in the parser
	module.exports = {
	  end: true
	};


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var map = __webpack_require__(1357).map;
	var escape = __webpack_require__(1341).escape;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var Range = load(__webpack_require__(1383));
	
	  var isArray = Array.isArray;
	
	  /**
	   * @constructor IndexNode
	   * @extends Node
	   *
	   * Describes a subset of a matrix or an object property.
	   * Cannot be used on its own, needs to be used within an AccessorNode or
	   * AssignmentNode.
	   *
	   * @param {Node[]} dimensions
	   * @param {boolean} [dotNotation=false]  Optional property describing whether
	   *                                       this index was written using dot
	   *                                       notation like `a.b`, or using bracket
	   *                                       notation like `a["b"]` (default).
	   *                                       Used to stringify an IndexNode.
	   */
	  function IndexNode(dimensions, dotNotation) {
	    if (!(this instanceof IndexNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this.dimensions = dimensions;
	    this.dotNotation = dotNotation || false;
	
	    // validate input
	    if (!isArray(dimensions) || !dimensions.every(type.isNode)) {
	      throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
	    }
	    if (this.dotNotation && !this.isObjectProperty()) {
	      throw new Error('dotNotation only applicable for object properties');
	    }
	
	    // TODO: deprecated since v3, remove some day
	    var deprecated = function () {
	      throw new Error('Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead');
	    };
	    Object.defineProperty(this, 'object', { get: deprecated, set: deprecated });
	  }
	
	  IndexNode.prototype = new Node();
	
	  IndexNode.prototype.type = 'IndexNode';
	
	  IndexNode.prototype.isIndexNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  IndexNode.prototype._compile = function (math, argNames) {
	    // TODO: implement support for bignumber (currently bignumbers are silently
	    //       reduced to numbers when changing the value to zero-based)
	
	    // TODO: Optimization: when the range values are ConstantNodes,
	    //       we can beforehand resolve the zero-based value
	
	    // optimization for a simple object property
	    var evalDimensions = map(this.dimensions, function (range, i) {
	      if (type.isRangeNode(range)) {
	        if (range.needsEnd()) {
	          // create a range containing end (like '4:end')
	          var childArgNames = Object.create(argNames);
	          childArgNames['end'] = true;
	
	          var evalStart = range.start._compile(math, childArgNames);
	          var evalEnd = range.end._compile(math, childArgNames);
	          var evalStep = range.step 
	              ? range.step._compile(math, childArgNames) 
	              : function () { return 1 };
	
	          return function evalDimension(scope, args, context) {
	            var size = math.size(context).valueOf();
	            var childArgs = Object.create(args);
	            childArgs['end'] = size[i];
	
	            return createRange(
	              evalStart(scope, childArgs, context),
	              evalEnd(scope, childArgs, context),
	              evalStep(scope, childArgs, context)
	            );
	          };
	        }
	        else {
	          // create range
	          var evalStart = range.start._compile(math, argNames);
	          var evalEnd = range.end._compile(math, argNames);
	          var evalStep = range.step 
	              ? range.step._compile(math, argNames) 
	              : function () { return 1 };
	
	          return function evalDimension(scope, args, context) {
	            return createRange(
	              evalStart(scope, args, context),
	              evalEnd(scope, args, context),
	              evalStep(scope, args, context)
	            );
	          };
	        }
	      }
	      else if (type.isSymbolNode(range) && range.name === 'end') {
	        // SymbolNode 'end'
	        var childArgNames = Object.create(argNames);
	        childArgNames['end'] = true;
	
	        var evalRange = range._compile(math, childArgNames);
	        
	        return function evalDimension(scope, args, context) {
	          var size = math.size(context).valueOf();
	          var childArgs = Object.create(args);
	          childArgs['end'] = size[i];
	
	          return evalRange(scope, childArgs, context);
	        };
	      }
	      else {
	        // ConstantNode
	        var evalRange = range._compile(math, argNames);
	        return function evalDimension(scope, args, context) {
	          return evalRange(scope, args, context);
	        };
	      }
	    });
	
	    return function evalIndexNode (scope, args, context) {
	      var dimensions = map(evalDimensions, function (evalDimension) {
	        return evalDimension(scope, args, context);
	      });
	      return math.index.apply(math, dimensions);
	    };
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  IndexNode.prototype.forEach = function (callback) {
	    for (var i = 0; i < this.dimensions.length; i++) {
	      callback(this.dimensions[i], 'dimensions[' + i + ']', this);
	    }
	  };
	
	  /**
	   * Create a new IndexNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {IndexNode} Returns a transformed copy of the node
	   */
	  IndexNode.prototype.map = function (callback) {
	    var dimensions = [];
	    for (var i = 0; i < this.dimensions.length; i++) {
	      dimensions[i] = this._ifNode(callback(this.dimensions[i], 'dimensions[' + i + ']', this));
	    }
	
	    return new IndexNode(dimensions);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {IndexNode}
	   */
	  IndexNode.prototype.clone = function () {
	    return new IndexNode(this.dimensions.slice(0));
	  };
	
	  /**
	   * Test whether this IndexNode contains a single property name
	   * @return {boolean}
	   */
	  IndexNode.prototype.isObjectProperty = function () {
	    return this.dimensions.length === 1 &&
	        type.isConstantNode(this.dimensions[0]) &&
	        typeof this.dimensions[0].value === 'string';
	  };
	
	  /**
	   * Returns the property name if IndexNode contains a property.
	   * If not, returns null.
	   * @return {string | null}
	   */
	  IndexNode.prototype.getObjectProperty = function () {
	    return this.isObjectProperty() ? this.dimensions[0].value : null;
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  IndexNode.prototype._toString = function (options) {
	    // format the parameters like "[1, 0:5]"
	    return this.dotNotation
	        ? ('.' + this.getObjectProperty())
	        : ('[' + this.dimensions.join(', ') + ']');
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  IndexNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'IndexNode',
	      dimensions: this.dimensions,
	      dotNotation: this.dotNotation
	    };
	  };
	
	  /**
	   * Instantiate an IndexNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
	   *                       where mathjs is optional
	   * @returns {IndexNode}
	   */
	  IndexNode.fromJSON = function (json) {
	    return new IndexNode(json.dimensions, json.dotNotation);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  IndexNode.prototype.toHTML = function (options) {
	    // format the parameters like "[1, 0:5]"
		var dimensions = []
		for (var i=0; i<this.dimensions.length; i++)	{
		  dimensions[i] = this.dimensions[i].toHTML();
		}
		if (this.dotNotation) {
		  return '<span class="math-operator math-accessor-operator">.</span>' + '<span class="math-symbol math-property">' + escape(this.getObjectProperty()) + '</span>';}
		else {
		  return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>'}
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  IndexNode.prototype._toTex = function (options) {
	    var dimensions = this.dimensions.map(function (range) {
	      return range.toTex(options);
	    });
	
	    return this.dotNotation
	        ? ('.' + this.getObjectProperty() + '')
	        : ('_{' + dimensions.join(',') + '}');
	  };
	
	  // helper function to create a Range from start, step and end
	  function createRange(start, end, step) {
	    return new Range(
	        type.isBigNumber(start) ? start.toNumber() : start,
	        type.isBigNumber(end)   ? end.toNumber()   : end,
	        type.isBigNumber(step)  ? step.toNumber()  : step
	    );
	  };
	
	  return IndexNode;
	}
	
	exports.name = 'IndexNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	
	function factory (type, config, load, typed) {
	  var subset = load(__webpack_require__(1630));
	
	  /**
	   * Retrieve part of an object:
	   *
	   * - Retrieve a property from an object
	   * - Retrieve a part of a string
	   * - Retrieve a matrix subset
	   *
	   * @param {Object | Array | Matrix | string} object
	   * @param {Index} index
	   * @return {Object | Array | Matrix | string} Returns the subset
	   */
	  return function access(object, index) {
	    try {
	      if (Array.isArray(object)) {
	        return subset(object, index);
	      }
	      else if (object && typeof object.subset === 'function') { // Matrix
	        return object.subset(index);
	      }
	      else if (typeof object === 'string') {
	        // TODO: move getStringSubset into a separate util file, use that
	        return subset(object, index);
	      }
	      else if (typeof object === 'object') {
	        if (!index.isObjectProperty()) {
	          throw new TypeError('Cannot apply a numeric index as object property');
	        }
	
	        return getSafeProperty(object, index.getObjectProperty());
	      }
	      else {
	        throw new TypeError('Cannot apply index: unsupported type of object');
	      }
	    }
	    catch (err) {
	      throw errorTransform(err);
	    }
	  }
	}
	
	exports.factory = factory;


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var IndexError = __webpack_require__(1359);
	
	/**
	 * Transform zero-based indices to one-based indices in errors
	 * @param {Error} err
	 * @returns {Error} Returns the transformed error
	 */
	exports.transform = function (err) {
	  if (err && err.isIndexError) {
	    return new IndexError(
	        err.index + 1,
	        err.min + 1,
	        err.max !== undefined ? err.max + 1 : undefined);
	  }
	
	  return err;
	};


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var validateIndex = __webpack_require__(1357).validateIndex;
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	var setSafeProperty = __webpack_require__(1624).setSafeProperty;
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Get or set a subset of a matrix or string.
	   *
	   * Syntax:
	   *     math.subset(value, index)                                // retrieve a subset
	   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
	   *
	   * Examples:
	   *
	   *     // get a subset
	   *     var d = [[1, 2], [3, 4]];
	   *     math.subset(d, math.index(1, 0));        // returns 3
	   *     math.subset(d, math.index([0, 2], 1));   // returns [[2], [4]]
	   *
	   *     // replace a subset
	   *     var e = [];
	   *     var f = math.subset(e, math.index(0, [0, 2]), [5, 6]);  // f = [[5, 6]]
	   *     var g = math.subset(f, math.index(1, 1), 7, 0);         // g = [[5, 6], [0, 7]]
	   *
	   * See also:
	   *
	   *     size, resize, squeeze, index
	   *
	   * @param {Array | Matrix | string} matrix  An array, matrix, or string
	   * @param {Index} index                     An index containing ranges for each
	   *                                          dimension
	   * @param {*} [replacement]                 An array, matrix, or scalar.
	   *                                          If provided, the subset is replaced with replacement.
	   *                                          If not provided, the subset is returned
	   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
	   *                                          the matrix is resized. If not provided,
	   *                                          math.matrix elements will be left undefined.
	   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
	   */
	  var subset = typed('subset', {
	    // get subset
	    'Array, Index': function (value, index) {
	      var m = matrix(value);
	      var subset = m.subset(index);       // returns a Matrix
	      return index.isScalar()
	          ? subset
	          : subset.valueOf();  // return an Array (like the input)
	    },
	
	    'Matrix, Index': function (value, index) {
	      return value.subset(index);
	    },
	
	    'Object, Index': _getObjectProperty,
	
	    'string, Index': _getSubstring,
	
	    // set subset
	    'Array, Index, any': function (value, index, replacement) {
	      return matrix(clone(value))
	          .subset(index, replacement, undefined)
	          .valueOf();
	    },
	
	    'Array, Index, any, any': function (value, index, replacement, defaultValue) {
	      return matrix(clone(value))
	          .subset(index, replacement, defaultValue)
	          .valueOf();
	    },
	
	    'Matrix, Index, any': function (value, index, replacement) {
	      return value.clone().subset(index, replacement);
	    },
	
	    'Matrix, Index, any, any': function (value, index, replacement, defaultValue) {
	      return value.clone().subset(index, replacement, defaultValue);
	    },
	
	    'string, Index, string': _setSubstring,
	    'string, Index, string, string': _setSubstring,
	    'Object, Index, any': _setObjectProperty
	  });
	
	  subset.toTex = undefined; // use default template
	
	  return subset;
	
	  /**
	   * Retrieve a subset of a string
	   * @param {string} str            string from which to get a substring
	   * @param {Index} index           An index containing ranges for each dimension
	   * @returns {string} substring
	   * @private
	   */
	  function _getSubstring(str, index) {
	    if (!type.isIndex(index)) {
	      // TODO: better error message
	      throw new TypeError('Index expected');
	    }
	    if (index.size().length != 1) {
	      throw new DimensionError(index.size().length, 1);
	    }
	
	    // validate whether the range is out of range
	    var strLen = str.length;
	    validateIndex(index.min()[0], strLen);
	    validateIndex(index.max()[0], strLen);
	
	    var range = index.dimension(0);
	
	    var substr = '';
	    range.forEach(function (v) {
	      substr += str.charAt(v);
	    });
	
	    return substr;
	  }
	
	  /**
	   * Replace a substring in a string
	   * @param {string} str            string to be replaced
	   * @param {Index} index           An index containing ranges for each dimension
	   * @param {string} replacement    Replacement string
	   * @param {string} [defaultValue] Default value to be uses when resizing
	   *                                the string. is ' ' by default
	   * @returns {string} result
	   * @private
	   */
	  function _setSubstring(str, index, replacement, defaultValue) {
	    if (!index || index.isIndex !== true) {
	      // TODO: better error message
	      throw new TypeError('Index expected');
	    }
	    if (index.size().length != 1) {
	      throw new DimensionError(index.size().length, 1);
	    }
	    if (defaultValue !== undefined) {
	      if (typeof defaultValue !== 'string' || defaultValue.length !== 1) {
	        throw new TypeError('Single character expected as defaultValue');
	      }
	    }
	    else {
	      defaultValue = ' ';
	    }
	
	    var range = index.dimension(0);
	    var len = range.size()[0];
	
	    if (len != replacement.length) {
	      throw new DimensionError(range.size()[0], replacement.length);
	    }
	
	    // validate whether the range is out of range
	    var strLen = str.length;
	    validateIndex(index.min()[0]);
	    validateIndex(index.max()[0]);
	
	    // copy the string into an array with characters
	    var chars = [];
	    for (var i = 0; i < strLen; i++) {
	      chars[i] = str.charAt(i);
	    }
	
	    range.forEach(function (v, i) {
	      chars[v] = replacement.charAt(i[0]);
	    });
	
	    // initialize undefined characters with a space
	    if (chars.length > strLen) {
	      for (i = strLen - 1, len = chars.length; i < len; i++) {
	        if (!chars[i]) {
	          chars[i] = defaultValue;
	        }
	      }
	    }
	
	    return chars.join('');
	  }
	}
	
	/**
	 * Retrieve a property from an object
	 * @param {Object} object
	 * @param {Index} index
	 * @return {*} Returns the value of the property
	 * @private
	 */
	function _getObjectProperty (object, index) {
	  if (index.size().length !== 1) {
	    throw new DimensionError(index.size(), 1);
	  }
	
	  var key = index.dimension(0);
	  if (typeof key !== 'string') {
	    throw new TypeError('String expected as index to retrieve an object property');
	  }
	
	  return getSafeProperty(object, key);
	}
	
	/**
	 * Set a property on an object
	 * @param {Object} object
	 * @param {Index} index
	 * @param {*} replacement
	 * @return {*} Returns the updated object
	 * @private
	 */
	function _setObjectProperty (object, index, replacement) {
	  if (index.size().length !== 1) {
	    throw new DimensionError(index.size(), 1);
	  }
	
	  var key = index.dimension(0);
	  if (typeof key !== 'string') {
	    throw new TypeError('String expected as index to retrieve an object property');
	  }
	
	  // clone the object, and apply the property to the clone
	  var updated = clone(object);
	  setSafeProperty(updated, key, replacement);
	
	  return updated;
	}
	
	exports.name = 'subset';
	exports.factory = factory;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var map = __webpack_require__(1357).map;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor ArrayNode
	   * @extends {Node}
	   * Holds an 1-dimensional array with items
	   * @param {Node[]} [items]   1 dimensional array with items
	   */
	  function ArrayNode(items) {
	    if (!(this instanceof ArrayNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this.items = items || [];
	
	    // validate input
	    if (!Array.isArray(this.items) || !this.items.every(type.isNode)) {
	      throw new TypeError('Array containing Nodes expected');
	    }
	
	    // TODO: deprecated since v3, remove some day
	    var deprecated = function () {
	      throw new Error('Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead');
	    };
	    Object.defineProperty(this, 'nodes', { get: deprecated, set: deprecated });
	  }
	
	  ArrayNode.prototype = new Node();
	
	  ArrayNode.prototype.type = 'ArrayNode';
	
	  ArrayNode.prototype.isArrayNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  ArrayNode.prototype._compile = function (math, argNames) {
	    var evalItems = map(this.items, function (item) {
	      return item._compile(math, argNames);
	    });
	
	    var asMatrix = (math.config().matrix !== 'Array');
	    if (asMatrix) {
	      var matrix = math.matrix;
	      return function evalArrayNode (scope, args, context) {
	        return matrix(map(evalItems, function (evalItem) {
	          return evalItem(scope, args, context);
	        }));
	      };
	    }
	    else {
	      return function evalArrayNode (scope, args, context) {
	        return map(evalItems, function (evalItem) {
	          return evalItem(scope, args, context);
	        });
	      };
	    }
	  }
	
	      /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  ArrayNode.prototype.forEach = function (callback) {
	    for (var i = 0; i < this.items.length; i++) {
	      var node = this.items[i];
	      callback(node, 'items[' + i + ']', this);
	    }
	  };
	
	  /**
	   * Create a new ArrayNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {ArrayNode} Returns a transformed copy of the node
	   */
	  ArrayNode.prototype.map = function (callback) {
	    var items = [];
	    for (var i = 0; i < this.items.length; i++) {
	      items[i] = this._ifNode(callback(this.items[i], 'items[' + i + ']', this));
	    }
	    return new ArrayNode(items);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {ArrayNode}
	   */
	  ArrayNode.prototype.clone = function() {
	    return new ArrayNode(this.items.slice(0));
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ArrayNode.prototype._toString = function(options) {
	    var items = this.items.map(function (node) {
	      return node.toString(options);
	    });
	    return '[' + items.join(', ') + ']';
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  ArrayNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'ArrayNode',
	      items: this.items
	    };
	  };
	
	  /**
	   * Instantiate an ArrayNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ArrayNode", items: [...]}`,
	   *                       where mathjs is optional
	   * @returns {ArrayNode}
	   */
	  ArrayNode.fromJSON = function (json) {
	    return new ArrayNode(json.items);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ArrayNode.prototype.toHTML = function(options) {
	    var items = this.items.map(function (node) {
	      return node.toHTML(options);
	    });
	    return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ArrayNode.prototype._toTex = function(options) {
	    var s = '\\begin{bmatrix}';
	
	    this.items.forEach(function(node) {
	      if (node.items) {
	        s += node.items.map(function(childNode) {
	          return childNode.toTex(options);
	        }).join('&');
	      }
	      else {
	        s += node.toTex(options);
	      }
	
	      // new line
	      s += '\\\\';
	    });
	    s += '\\end{bmatrix}';
	    return s;
	  };
	
	  return ArrayNode;
	}
	
	exports.name = 'ArrayNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	var setSafeProperty = __webpack_require__(1624).setSafeProperty;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var assign = load(__webpack_require__(1633));
	  var access = load(__webpack_require__(1628));
	
	  var operators = __webpack_require__(1634);
	
	  /**
	   * @constructor AssignmentNode
	   * @extends {Node}
	   *
	   * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
	   * replace a subset of a matrix like `A[2,2]=42`.
	   *
	   * Syntax:
	   *
	   *     new AssignmentNode(symbol, value)
	   *     new AssignmentNode(object, index, value)
	   *
	   * Usage:
	   *
	   *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2));                      // a=2
	   *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
	   *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
	   *
	   * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
	   * @param {IndexNode} [index=null]            Index, property name or matrix
	   *                                            index. Optional. If not provided
	   *                                            and `object` is a SymbolNode,
	   *                                            the property is assigned to the
	   *                                            global scope.
	   * @param {Node} value                        The value to be assigned
	   */
	  function AssignmentNode(object, index, value) {
	    if (!(this instanceof AssignmentNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this.object = object;
	    this.index = value ? index : null;
	    this.value = value ? value : index;
	
	    // validate input
	    if (!type.isSymbolNode(object) && !type.isAccessorNode(object)) {
	      throw new TypeError('SymbolNode or AccessorNode expected as "object"');
	    }
	    if (type.isSymbolNode(object) && object.name === 'end') {
	      throw new Error('Cannot assign to symbol "end"');
	    }
	    if (this.index && !type.isIndexNode(this.index)) { // index is optional
	      throw new TypeError('IndexNode expected as "index"');
	    }
	    if (!type.isNode(this.value)) {
	      throw new TypeError('Node expected as "value"');
	    }
	
	    // readonly property name
	    Object.defineProperty(this, 'name', {
	      get: function () {
	        if (this.index) {
	          return (this.index.isObjectProperty())
	              ? this.index.getObjectProperty()
	              : '';
	        }
	        else {
	          return this.object.name || '';
	        }
	      }.bind(this),
	      set: function () {
	        throw new Error('Cannot assign a new name, name is read-only');
	      }
	    });
	  }
	
	  AssignmentNode.prototype = new Node();
	
	  AssignmentNode.prototype.type = 'AssignmentNode';
	
	  AssignmentNode.prototype.isAssignmentNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  AssignmentNode.prototype._compile = function (math, argNames) {
	    var size;
	    var evalObject = this.object._compile(math, argNames);
	    var evalIndex = this.index ? this.index._compile(math, argNames) : null;
	    var evalValue = this.value._compile(math, argNames);
	    var name = this.object.name;
	    
	    if (!this.index) {
	      // apply a variable to the scope, for example `a=2`
	      if (!type.isSymbolNode(this.object)) {
	        throw new TypeError('SymbolNode expected as object');
	      }
	
	      return function evalAssignmentNode (scope, args, context) {
	        return setSafeProperty(scope, name, evalValue(scope, args, context));
	      };
	    }
	    else if (this.index.isObjectProperty()) {
	      // apply an object property for example `a.b=2`
	      var prop = this.index.getObjectProperty();
	
	      return function evalAssignmentNode (scope, args, context) {
	        var object = evalObject(scope, args, context);
	        var value = evalValue(scope, args, context);
	        return setSafeProperty(object, prop, value);
	      };
	    }
	    else if (type.isSymbolNode(this.object)) {
	      // update a matrix subset, for example `a[2]=3`
	      return function evalAssignmentNode(scope, args, context) {
	        var childObject = evalObject(scope, args, context);
	        var value = evalValue(scope, args, context);
	        var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
	        setSafeProperty(scope, name, assign(childObject, index, value));
	        return value;
	      }
	    }
	    else { // type.isAccessorNode(node.object) === true
	      // update a matrix subset, for example `a.b[2]=3`
	
	      // we will not use the compile function of the AccessorNode, but compile it
	      // ourselves here as we need the parent object of the AccessorNode:
	      // wee need to apply the updated object to parent object
	      var evalParentObject = this.object.object._compile(math, argNames);
	
	      if (this.object.index.isObjectProperty()) {
	        var parentProp = this.object.index.getObjectProperty();
	
	        return function evalAssignmentNode(scope, args, context) {
	          var parent = evalParentObject(scope, args, context);
	          var childObject = getSafeProperty(parent, parentProp);
	          var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context
	          var value = evalValue(scope, args, context);
	          setSafeProperty(parent, parentProp, assign(childObject, index, value));
	          return value;
	        }
	      }
	      else {
	        // if some parameters use the 'end' parameter, we need to calculate the size
	        var evalParentIndex = this.object.index._compile(math, argNames);
	
	        return function evalAssignmentNode(scope, args, context) {
	          var parent = evalParentObject(scope, args, context);
	          var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context
	          var childObject = access(parent, parentIndex);
	          var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
	          var value = evalValue(scope, args, context);
	
	          assign(parent, parentIndex, assign(childObject, index, value));
	
	          return value;
	        }
	      }
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  AssignmentNode.prototype.forEach = function (callback) {
	    callback(this.object, 'object', this);
	    if (this.index) {
	      callback(this.index, 'index', this);
	    }
	    callback(this.value, 'value', this);
	  };
	
	  /**
	   * Create a new AssignmentNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {AssignmentNode} Returns a transformed copy of the node
	   */
	  AssignmentNode.prototype.map = function (callback) {
	    var object = this._ifNode(callback(this.object, 'object', this));
	    var index = this.index
	        ? this._ifNode(callback(this.index, 'index', this))
	        : null;
	    var value = this._ifNode(callback(this.value, 'value', this));
	
	    return new AssignmentNode(object, index, value);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {AssignmentNode}
	   */
	  AssignmentNode.prototype.clone = function() {
	    return new AssignmentNode(this.object, this.index, this.value);
	  };
	
	  /*
	   * Is parenthesis needed?
	   * @param {node} node
	   * @param {string} [parenthesis='keep']
	   * @private
	   */
	  function needParenthesis(node, parenthesis) {
	    if (!parenthesis) {
	      parenthesis = 'keep';
	    }
	
	    var precedence = operators.getPrecedence(node, parenthesis);
	    var exprPrecedence = operators.getPrecedence(node.value, parenthesis);
	    return (parenthesis === 'all')
	      || ((exprPrecedence !== null) && (exprPrecedence <= precedence));
	  }
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AssignmentNode.prototype._toString = function(options) {
	    var object = this.object.toString(options);
	    var index = this.index ? this.index.toString(options) : '';
	    var value = this.value.toString(options);
	    if (needParenthesis(this, options && options.parenthesis)) {
	      value = '(' + value + ')';
	    }
	
	    return object + index + ' = ' + value;
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  AssignmentNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'AssignmentNode',
	      object: this.object,
	      index: this.index,
	      value: this.value
	    };
	  };
	
	  /**
	   * Instantiate an AssignmentNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
	   *                       where mathjs is optional
	   * @returns {AssignmentNode}
	   */
	  AssignmentNode.fromJSON = function (json) {
	    return new AssignmentNode(json.object, json.index, json.value);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AssignmentNode.prototype.toHTML = function(options) {
	    var object = this.object.toHTML(options);
	    var index = this.index ? this.index.toHTML(options) : '';
	    var value = this.value.toHTML(options);
	    if (needParenthesis(this, options && options.parenthesis)) {
	      value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
	    }
	
	    return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string}
	   */
	  AssignmentNode.prototype._toTex = function(options) {
	    var object = this.object.toTex(options);
	    var index = this.index ? this.index.toTex(options) : '';
	    var value = this.value.toTex(options);
	    if (needParenthesis(this, options && options.parenthesis)) {
	      value = '\\left(' + value + '\\right)';
	    }
	
	    return object + index + ':=' + value;
	  };
	
	  return AssignmentNode;
	}
	
	exports.name = 'AssignmentNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	var setSafeProperty = __webpack_require__(1624).setSafeProperty;
	
	function factory (type, config, load, typed) {
	  var subset = load(__webpack_require__(1630));
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Replace part of an object:
	   *
	   * - Assign a property to an object
	   * - Replace a part of a string
	   * - Replace a matrix subset
	   *
	   * @param {Object | Array | Matrix | string} object
	   * @param {Index} index
	   * @param {*} value
	   * @return {Object | Array | Matrix | string} Returns the original object
	   *                                            except in case of a string
	   */
	  // TODO: change assign to return the value instead of the object
	  return function assign(object, index, value) {
	    try {
	      if (Array.isArray(object)) {
	        return matrix(object).subset(index, value).valueOf();
	      }
	      else if (object && typeof object.subset === 'function') { // Matrix
	        return object.subset(index, value);
	      }
	      else if (typeof object === 'string') {
	        // TODO: move setStringSubset into a separate util file, use that
	        return subset(object, index, value);
	      }
	      else if (typeof object === 'object') {
	        if (!index.isObjectProperty()) {
	          throw TypeError('Cannot apply a numeric index as object property');
	        }
	        setSafeProperty(object, index.getObjectProperty(), value);
	        return object;
	      }
	      else {
	        throw new TypeError('Cannot apply index: unsupported type of object');
	      }
	    }
	    catch (err) {
	        throw errorTransform(err);
	    }
	  }
	}
	
	exports.factory = factory;


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	'use strict'
	
	//list of identifiers of nodes in order of their precedence
	//also contains information about left/right associativity
	//and which other operator the operator is associative with
	//Example:
	// addition is associative with addition and subtraction, because:
	// (a+b)+c=a+(b+c)
	// (a+b)-c=a+(b-c)
	//
	// postfix operators are left associative, prefix operators 
	// are right associative
	//
	//It's also possible to set the following properties:
	// latexParens: if set to false, this node doesn't need to be enclosed
	//              in parentheses when using LaTeX
	// latexLeftParens: if set to false, this !OperatorNode's! 
	//                  left argument doesn't need to be enclosed
	//                  in parentheses
	// latexRightParens: the same for the right argument
	var properties = [
	  { //assignment
	    'AssignmentNode': {},
	    'FunctionAssignmentNode': {}
	  },
	  { //conditional expression
	    'ConditionalNode': {
	      latexLeftParens: false,
	      latexRightParens: false,
	      latexParens: false
	      //conditionals don't need parentheses in LaTeX because
	      //they are 2 dimensional
	    }
	  },
	  { //logical or
	    'OperatorNode:or': {
	      associativity: 'left',
	      associativeWith: []
	    }
	
	  },
	  { //logical xor
	    'OperatorNode:xor': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //logical and
	    'OperatorNode:and': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //bitwise or
	    'OperatorNode:bitOr': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //bitwise xor
	    'OperatorNode:bitXor': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //bitwise and
	    'OperatorNode:bitAnd': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //relational operators
	    'OperatorNode:equal': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:unequal': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:smaller': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:larger': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:smallerEq': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:largerEq': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //bitshift operators
	    'OperatorNode:leftShift': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:rightArithShift': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:rightLogShift': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //unit conversion
	    'OperatorNode:to': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //range
	    'RangeNode': {}
	  },
	  { //addition, subtraction
	    'OperatorNode:add': {
	      associativity: 'left',
	      associativeWith: ['OperatorNode:add', 'OperatorNode:subtract']
	    },
	    'OperatorNode:subtract': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //multiply, divide, modulus
	    'OperatorNode:multiply': {
	      associativity: 'left',
	      associativeWith: [
	        'OperatorNode:multiply',
	        'OperatorNode:divide',
	        'Operator:dotMultiply',
	        'Operator:dotDivide'
	      ]
	    },
	    'OperatorNode:divide': {
	      associativity: 'left',
	      associativeWith: [],
	      latexLeftParens: false,
	      latexRightParens: false,
	      latexParens: false
	      //fractions don't require parentheses because
	      //they're 2 dimensional, so parens aren't needed
	      //in LaTeX
	    },
	    'OperatorNode:dotMultiply': {
	      associativity: 'left',
	      associativeWith: [
	        'OperatorNode:multiply',
	        'OperatorNode:divide',
	        'OperatorNode:dotMultiply',
	        'OperatorNode:doDivide'
	      ]
	    },
	    'OperatorNode:dotDivide': {
	      associativity: 'left',
	      associativeWith: []
	    },
	    'OperatorNode:mod': {
	      associativity: 'left',
	      associativeWith: []
	    }
	  },
	  { //unary prefix operators
	    'OperatorNode:unaryPlus': {
	      associativity: 'right'
	    },
	    'OperatorNode:unaryMinus': {
	      associativity: 'right'
	    },
	    'OperatorNode:bitNot': {
	      associativity: 'right'
	    },
	    'OperatorNode:not': {
	      associativity: 'right'
	    }
	  },
	  { //exponentiation
	    'OperatorNode:pow': {
	      associativity: 'right',
	      associativeWith: [],
	      latexRightParens: false
	      //the exponent doesn't need parentheses in
	      //LaTeX because it's 2 dimensional
	      //(it's on top)
	    },
	    'OperatorNode:dotPow': {
	      associativity: 'right',
	      associativeWith: []
	    }
	  },
	  { //factorial
	    'OperatorNode:factorial': {
	      associativity: 'left'
	    }
	  },
	  { //matrix transpose
	    'OperatorNode:transpose': {
	      associativity: 'left'
	    }
	  }
	];
	
	/**
	 * Get the precedence of a Node.
	 * Higher number for higher precedence, starting with 0.
	 * Returns null if the precedence is undefined.
	 *
	 * @param {Node}
	 * @param {string} parenthesis
	 * @return {number|null}
	 */
	function getPrecedence (_node, parenthesis) {
	  var node = _node;
	  if (parenthesis !== 'keep') {
	    //ParenthesisNodes are only ignored when not in 'keep' mode
	    node = _node.getContent();
	  }
	  var identifier = node.getIdentifier();
	  for (var i = 0; i < properties.length; i++) {
	    if (identifier in properties[i]) {
	      return i;
	    }
	  }
	  return null;
	}
	
	/**
	 * Get the associativity of an operator (left or right).
	 * Returns a string containing 'left' or 'right' or null if
	 * the associativity is not defined.
	 *
	 * @param {Node}
	 * @param {string} parenthesis
	 * @return {string|null}
	 * @throws {Error}
	 */
	function getAssociativity (_node, parenthesis) {
	  var node = _node;
	  if (parenthesis !== 'keep') {
	    //ParenthesisNodes are only ignored when not in 'keep' mode
	    node = _node.getContent();
	  }
	  var identifier = node.getIdentifier();
	  var index = getPrecedence(node, parenthesis);
	  if (index === null) {
	    //node isn't in the list
	    return null;
	  }
	  var property = properties[index][identifier];
	
	  if (property.hasOwnProperty('associativity')) {
	    if (property.associativity === 'left') {
	      return 'left';
	    }
	    if (property.associativity === 'right') {
	      return 'right';
	    }
	    //associativity is invalid
	    throw Error('\'' + identifier + '\' has the invalid associativity \''
	                + property.associativity + '\'.');
	  }
	
	  //associativity is undefined
	  return null;
	}
	
	/**
	 * Check if an operator is associative with another operator.
	 * Returns either true or false or null if not defined.
	 *
	 * @param {Node} nodeA
	 * @param {Node} nodeB
	 * @param {string} parenthesis
	 * @return {bool|null}
	 */
	function isAssociativeWith (nodeA, nodeB, parenthesis) {
	  var a = nodeA;
	  var b = nodeB;
	  if (parenthesis !== 'keep') {
	    //ParenthesisNodes are only ignored when not in 'keep' mode
	    var a = nodeA.getContent();
	    var b = nodeB.getContent();
	  }
	  var identifierA = a.getIdentifier();
	  var identifierB = b.getIdentifier();
	  var index = getPrecedence(a, parenthesis);
	  if (index === null) {
	    //node isn't in the list
	    return null;
	  }
	  var property = properties[index][identifierA];
	
	  if (property.hasOwnProperty('associativeWith')
	      && (property.associativeWith instanceof Array)) {
	    for (var i = 0; i < property.associativeWith.length; i++) {
	      if (property.associativeWith[i] === identifierB) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  //associativeWith is not defined
	  return null;
	}
	
	module.exports.properties = properties;
	module.exports.getPrecedence = getPrecedence;
	module.exports.getAssociativity = getAssociativity;
	module.exports.isAssociativeWith = isAssociativeWith;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(1357).forEach;
	var map = __webpack_require__(1357).map;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var ResultSet = load(__webpack_require__(1388));
	
	  /**
	   * @constructor BlockNode
	   * @extends {Node}
	   * Holds a set with blocks
	   * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
	   *            An array with blocks, where a block is constructed as an Object
	   *            with properties block, which is a Node, and visible, which is
	   *            a boolean. The property visible is optional and is true by default
	   */
	  function BlockNode(blocks) {
	    if (!(this instanceof BlockNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    // validate input, copy blocks
	    if (!Array.isArray(blocks)) throw new Error('Array expected');
	    this.blocks = blocks.map(function (block) {
	      var node = block && block.node;
	      var visible = block && block.visible !== undefined ? block.visible : true;
	
	      if (!type.isNode(node)) throw new TypeError('Property "node" must be a Node');
	      if (typeof visible !== 'boolean') throw new TypeError('Property "visible" must be a boolean');
	
	      return {
	        node: node,
	        visible: visible
	      }
	    });
	  }
	
	  BlockNode.prototype = new Node();
	
	  BlockNode.prototype.type = 'BlockNode';
	
	  BlockNode.prototype.isBlockNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  BlockNode.prototype._compile = function (math, argNames) {
	    var evalBlocks = map(this.blocks, function (block) {
	      return {
	        eval: block.node._compile(math, argNames),
	        visible: block.visible
	      };
	    });
	
	    return function evalBlockNodes (scope, args, context) {
	      var results = [];
	
	      forEach(evalBlocks, function evalBlockNode(block) {
	        var result = block.eval(scope, args, context)
	        if (block.visible) {
	          results.push(result);
	        }
	      });
	
	      return new ResultSet(results);
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child blocks of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  BlockNode.prototype.forEach = function (callback) {
	    for (var i = 0; i < this.blocks.length; i++) {
	      callback(this.blocks[i].node, 'blocks[' + i + '].node', this);
	    }
	  };
	
	  /**
	   * Create a new BlockNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {BlockNode} Returns a transformed copy of the node
	   */
	  BlockNode.prototype.map = function (callback) {
	    var blocks = [];
	    for (var i = 0; i < this.blocks.length; i++) {
	      var block = this.blocks[i];
	      var node = this._ifNode(callback(block.node, 'blocks[' + i + '].node', this));
	      blocks[i] = {
	        node: node,
	        visible: block.visible
	      };
	    }
	    return new BlockNode(blocks);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {BlockNode}
	   */
	  BlockNode.prototype.clone = function () {
	    var blocks = this.blocks.map(function (block) {
	      return {
	        node: block.node,
	        visible: block.visible
	      };
	    });
	
	    return new BlockNode(blocks);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  BlockNode.prototype._toString = function (options) {
	    return this.blocks.map(function (param) {
	      return param.node.toString(options) + (param.visible ? '' : ';');
	    }).join('\n');
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  BlockNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'BlockNode',
	      blocks: this.blocks
	    };
	  };
	
	  /**
	   * Instantiate an BlockNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
	   *                       where mathjs is optional
	   * @returns {BlockNode}
	   */
	  BlockNode.fromJSON = function (json) {
	    return new BlockNode(json.blocks);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  BlockNode.prototype.toHTML = function (options) {
	    return this.blocks.map(function (param) {
	      return param.node.toHTML(options) + (param.visible ? '' : '<span class="math-separator">;</span>');
	    }).join('<span class="math-separator"><br /></span>');
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  BlockNode.prototype._toTex = function (options) {
	    return this.blocks.map(function (param) {
	      return param.node.toTex(options) + (param.visible ? '' : ';');
	    }).join('\\;\\;\n');
	  };
	
	  return BlockNode;
	}
	
	exports.name = 'BlockNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var operators = __webpack_require__(1634);
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var mathTypeOf = load(__webpack_require__(1409));
	
	  /**
	   * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
	   *
	   * @param {Node} condition   Condition, must result in a boolean
	   * @param {Node} trueExpr    Expression evaluated when condition is true
	   * @param {Node} falseExpr   Expression evaluated when condition is true
	   *
	   * @constructor ConditionalNode
	   * @extends {Node}
	   */
	  function ConditionalNode(condition, trueExpr, falseExpr) {
	    if (!(this instanceof ConditionalNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	    if (!type.isNode(condition)) throw new TypeError('Parameter condition must be a Node');
	    if (!type.isNode(trueExpr))  throw new TypeError('Parameter trueExpr must be a Node');
	    if (!type.isNode(falseExpr)) throw new TypeError('Parameter falseExpr must be a Node');
	
	    this.condition = condition;
	    this.trueExpr = trueExpr;
	    this.falseExpr = falseExpr;
	  }
	
	  ConditionalNode.prototype = new Node();
	
	  ConditionalNode.prototype.type = 'ConditionalNode';
	
	  ConditionalNode.prototype.isConditionalNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  ConditionalNode.prototype._compile = function (math, argNames) {
	    var evalCondition = this.condition._compile(math, argNames);
	    var evalTrueExpr = this.trueExpr._compile(math, argNames);
	    var evalFalseExpr = this.falseExpr._compile(math, argNames);
	
	    return function evalConditionalNode(scope, args, context) {
	      return testCondition(evalCondition(scope, args, context)) 
	          ? evalTrueExpr(scope, args, context) 
	          : evalFalseExpr(scope, args, context);
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  ConditionalNode.prototype.forEach = function (callback) {
	    callback(this.condition, 'condition', this);
	    callback(this.trueExpr, 'trueExpr', this);
	    callback(this.falseExpr, 'falseExpr', this);
	  };
	
	  /**
	   * Create a new ConditionalNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {ConditionalNode} Returns a transformed copy of the node
	   */
	  ConditionalNode.prototype.map = function (callback) {
	    return new ConditionalNode(
	        this._ifNode(callback(this.condition, 'condition', this)),
	        this._ifNode(callback(this.trueExpr, 'trueExpr', this)),
	        this._ifNode(callback(this.falseExpr, 'falseExpr', this))
	    );
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {ConditionalNode}
	   */
	  ConditionalNode.prototype.clone = function () {
	    return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConditionalNode.prototype._toString = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var precedence = operators.getPrecedence(this, parenthesis);
	
	    //Enclose Arguments in parentheses if they are an OperatorNode
	    //or have lower or equal precedence
	    //NOTE: enclosing all OperatorNodes in parentheses is a decision
	    //purely based on aesthetics and readability
	    var condition = this.condition.toString(options);
	    var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.condition.type === 'OperatorNode')
	        || ((conditionPrecedence !== null) && (conditionPrecedence <= precedence))) {
	      condition = '(' + condition + ')';
	    }
	
	    var trueExpr = this.trueExpr.toString(options);
	    var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.trueExpr.type === 'OperatorNode')
	        || ((truePrecedence !== null) && (truePrecedence <= precedence))) {
	      trueExpr = '(' + trueExpr + ')';
	    }
	
	    var falseExpr = this.falseExpr.toString(options);
	    var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.falseExpr.type === 'OperatorNode')
	        || ((falsePrecedence !== null) && (falsePrecedence <= precedence))) {
	      falseExpr = '(' + falseExpr + ')';
	    }
	    return condition + ' ? ' + trueExpr + ' : ' + falseExpr;
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  ConditionalNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'ConditionalNode',
	      condition: this.condition,
	      trueExpr: this.trueExpr,
	      falseExpr: this.falseExpr
	    };
	  };
	
	  /**
	   * Instantiate an ConditionalNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
	   *                       where mathjs is optional
	   * @returns {ConditionalNode}
	   */
	  ConditionalNode.fromJSON = function (json) {
	    return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConditionalNode.prototype.toHTML = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var precedence = operators.getPrecedence(this, parenthesis);
	
	    //Enclose Arguments in parentheses if they are an OperatorNode
	    //or have lower or equal precedence
	    //NOTE: enclosing all OperatorNodes in parentheses is a decision
	    //purely based on aesthetics and readability
	    var condition = this.condition.toHTML(options);
	    var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.condition.type === 'OperatorNode')
	        || ((conditionPrecedence !== null) && (conditionPrecedence <= precedence))) {
	      condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	
	    var trueExpr = this.trueExpr.toHTML(options);
	    var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.trueExpr.type === 'OperatorNode')
	        || ((truePrecedence !== null) && (truePrecedence <= precedence))) {
	      trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	
	    var falseExpr = this.falseExpr.toHTML(options);
	    var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);
	    if ((parenthesis === 'all')
	        || (this.falseExpr.type === 'OperatorNode')
	        || ((falsePrecedence !== null) && (falsePrecedence <= precedence))) {
	      falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	    return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConditionalNode.prototype._toTex = function (options) {
	    return '\\begin{cases} {'
	        + this.trueExpr.toTex(options) + '}, &\\quad{\\text{if }\\;'
	        + this.condition.toTex(options)
	        + '}\\\\{' + this.falseExpr.toTex(options)
	        + '}, &\\quad{\\text{otherwise}}\\end{cases}';
	  };
	
	  /**
	   * Test whether a condition is met
	   * @param {*} condition
	   * @returns {boolean} true if condition is true or non-zero, else false
	   */
	  function testCondition (condition) {
	    if (typeof condition === 'number'
	        || typeof condition === 'boolean'
	        || typeof condition === 'string') {
	      return condition ? true : false;
	    }
	
	    if (condition) {
	      if (type.isBigNumber(condition)) {
	        return condition.isZero() ? false : true;
	      }
	
	      if (type.isComplex(condition)) {
	        return (condition.re || condition.im) ? true : false;
	      }
	
	      if (type.isUnit(condition)) {
	        return condition.value ? true : false;
	      }
	    }
	
	    if (condition === null || condition === undefined) {
	      return false;
	    }
	
	    throw new TypeError('Unsupported type of condition "' + mathTypeOf(condition) + '"');
	  };
	
	  return ConditionalNode;
	}
	
	exports.name = 'ConditionalNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var format = __webpack_require__(1341).format;
	var escapeLatex = __webpack_require__(1348).escape;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	  var getType = load(__webpack_require__(1409));
	
	  /**
	   * A ConstantNode holds a constant value like a number or string.
	   *
	   * Usage:
	   *
	   *     new ConstantNode(2.3);
	   *     new ConstantNode('hello');
	   *
	   * @param {*} value    Value can be any type (number, BigNumber, string, ...)
	   * @constructor ConstantNode
	   * @extends {Node}
	   */
	  function ConstantNode(value) {
	    if (!(this instanceof ConstantNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (arguments.length === 2) {
	      // TODO: remove deprecation error some day (created 2018-01-23)
	      throw new SyntaxError('new ConstantNode(valueStr, valueType) is not supported anymore since math v4.0.0. Use new ConstantNode(value) instead, where value is a non-stringified value.');
	    }
	
	    this.value = value;
	  }
	
	  ConstantNode.prototype = new Node();
	
	  ConstantNode.prototype.type = 'ConstantNode';
	
	  ConstantNode.prototype.isConstantNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants.
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  ConstantNode.prototype._compile = function (math, argNames) {
	    var value = this.value;
	
	    return function evalConstantNode() {
	      return value;
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  ConstantNode.prototype.forEach = function (callback) {
	    // nothing to do, we don't have childs
	  };
	
	  /**
	   * Create a new ConstantNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node) : Node} callback
	   * @returns {ConstantNode} Returns a clone of the node
	   */
	  ConstantNode.prototype.map = function (callback) {
	    return this.clone();
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {ConstantNode}
	   */
	  ConstantNode.prototype.clone = function () {
	    return new ConstantNode(this.value);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConstantNode.prototype._toString = function (options) {
	    return format (this.value, options);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConstantNode.prototype.toHTML = function (options) {
	    var value = this._toString(options);
	
	    switch (getType(this.value)) {
	  	  case 'number':
	  	  case 'BigNumber':
	  	  case 'Fraction':
		    return '<span class="math-number">' + value + '</span>';
	      case 'string':
		    return '<span class="math-string">' + value + '</span>';
	      case 'boolean':
		    return '<span class="math-boolean">' + value + '</span>';
	      case 'null':
		    return '<span class="math-null-symbol">' + value + '</span>';
	      case 'undefined':
		    return '<span class="math-undefined">' + value + '</span>';
	
	      default:
	        return '<span class="math-symbol">' + value + '</span>';
	    }
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  ConstantNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'ConstantNode',
	      value: this.value
	    };
	  };
	
	  /**
	   * Instantiate a ConstantNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "SymbolNode", value: 2.3}`,
	   *                       where mathjs is optional
	   * @returns {ConstantNode}
	   */
	  ConstantNode.fromJSON = function (json) {
	    return new ConstantNode(json.value);
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ConstantNode.prototype._toTex = function (options) {
	    var value = this._toString(options);
	
	    switch (getType(this.value)) {
	      case 'string':
	        return '\\mathtt{' + escapeLatex(value) + '}';
	
	      case 'number':
	      case 'BigNumber':
	        var index = value.toLowerCase().indexOf('e');
	        if (index !== -1) {
	          return value.substring(0, index) + '\\cdot10^{' +
	              value.substring(index + 1) + '}';
	        }
	        return value;
	
	      case 'Fraction':
	        return this.value.toLatex();
	
	      default:
	        return value;
	    }
	  };
	
	  return ConstantNode;
	}
	
	exports.name = 'ConstantNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keywords = __webpack_require__(1626);
	var escape = __webpack_require__(1341).escape;
	var forEach = __webpack_require__(1357).forEach;
	var join = __webpack_require__(1357).join;
	var latex = __webpack_require__(1348);
	var operators = __webpack_require__(1634);
	var setSafeProperty = __webpack_require__(1624).setSafeProperty;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor FunctionAssignmentNode
	   * @extends {Node}
	   * Function assignment
	   *
	   * @param {string} name           Function name
	   * @param {string[] | Array.<{name: string, type: string}>} params
	   *                                Array with function parameter names, or an
	   *                                array with objects containing the name
	   *                                and type of the parameter
	   * @param {Node} expr             The function expression
	   */
	  function FunctionAssignmentNode(name, params, expr) {
	    if (!(this instanceof FunctionAssignmentNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    // validate input
	    if (typeof name !== 'string') throw new TypeError('String expected for parameter "name"');
	    if (!Array.isArray(params))  throw new TypeError('Array containing strings or objects expected for parameter "params"');
	    if (!type.isNode(expr)) throw new TypeError('Node expected for parameter "expr"');
	    if (name in keywords) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
	
	    this.name = name;
	    this.params = params.map(function (param) {
	      return param && param.name || param;
	    });
	    this.types = params.map(function (param) {
	      return param && param.type || 'any'
	    });
	    this.expr = expr;
	  }
	
	  FunctionAssignmentNode.prototype = new Node();
	
	  FunctionAssignmentNode.prototype.type = 'FunctionAssignmentNode';
	
	  FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants.
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  FunctionAssignmentNode.prototype._compile = function (math, argNames) {
	    var childArgNames = Object.create(argNames);
	    forEach(this.params, function (param) {
	      childArgNames[param] = true;
	    })
	
	    // compile the function expression with the child args
	    var evalExpr = this.expr._compile(math, childArgNames);
	    var name = this.name;
	    var params = this.params;
	    var signature = join(this.types, ',');
	    var syntax = name + '(' + join(this.params, ', ') + ')';
	
	    return function evalFunctionAssignmentNode(scope, args, context) {
	      var signatures = {}
	      signatures[signature] = function () {
	        var childArgs = Object.create(args);
	
	        for (var i = 0; i < params.length; i++) {
	          childArgs[params[i]] = arguments[i];
	        }
	
	        return evalExpr(scope, childArgs, context);
	      }
	      var fn = typed(name, signatures);
	      fn.syntax = syntax;
	
	      setSafeProperty(scope, name, fn);
	
	      return fn;
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  FunctionAssignmentNode.prototype.forEach = function (callback) {
	    callback(this.expr, 'expr', this);
	  };
	
	  /**
	   * Create a new FunctionAssignmentNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
	   */
	  FunctionAssignmentNode.prototype.map = function (callback) {
	    var expr = this._ifNode(callback(this.expr, 'expr', this));
	
	    return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {FunctionAssignmentNode}
	   */
	  FunctionAssignmentNode.prototype.clone = function () {
	    return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
	  };
	
	  /**
	   * Is parenthesis needed?
	   * @param {Node} node
	   * @param {Object} parenthesis
	   * @private
	   */
	  function needParenthesis(node, parenthesis) {
	    var precedence = operators.getPrecedence(node, parenthesis);
	    var exprPrecedence = operators.getPrecedence(node.expr, parenthesis);
	
	    return (parenthesis === 'all')
	      || ((exprPrecedence !== null) && (exprPrecedence <= precedence));
	  }
	
	  /**
	   * get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  FunctionAssignmentNode.prototype._toString = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var expr = this.expr.toString(options);
	    if (needParenthesis(this, parenthesis)) {
	      expr = '(' + expr + ')';
	    }
	    return this.name + '(' + this.params.join(', ') + ') = ' + expr;
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  FunctionAssignmentNode.prototype.toJSON = function () {
	    var types = this.types;
	
	    return {
	      mathjs: 'FunctionAssignmentNode',
	      name: this.name,
	      params: this.params.map(function(param, index) {
	        return {
	          name: param,
	          type: types[index]
	        }
	      }),
	      expr: this.expr
	    };
	  };
	
	  /**
	   * Instantiate an FunctionAssignmentNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
	   *                       where mathjs is optional
	   * @returns {FunctionAssignmentNode}
	   */
	  FunctionAssignmentNode.fromJSON = function (json) {
	    return new FunctionAssignmentNode(json.name, json.params, json.expr);
	  };
	
	  /**
	   * get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	   FunctionAssignmentNode.prototype.toHTML = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
		var params = [];
		for (var i=0; i<this.params.length; i++)	{
		  params.push('<span class="math-symbol math-parameter">' + escape(this.params[i]) + '</span>');
		}
	    var expr = this.expr.toHTML(options);
	    if (needParenthesis(this, parenthesis)) {
	      expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	    return '<span class="math-function">' + escape(this.name) + '</span>' + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
	  };
	
	  /**
	   * get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  FunctionAssignmentNode.prototype._toTex = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var expr = this.expr.toTex(options);
	    if (needParenthesis(this, parenthesis)) {
	      expr = '\\left(' + expr + '\\right)';
	    }
	
	    return '\\mathrm{' + this.name
	        + '}\\left(' + this.params.map(latex.toSymbol).join(',') + '\\right):=' + expr;
	  };
	
	  return FunctionAssignmentNode;
	}
	exports.name = 'FunctionAssignmentNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1341).stringify;
	var escape = __webpack_require__(1341).escape;
	var isSafeProperty = __webpack_require__(1624).isSafeProperty;
	var hasOwnProperty = __webpack_require__(1320).hasOwnProperty;
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor ObjectNode
	   * @extends {Node}
	   * Holds an object with keys/values
	   * @param {Object.<string, Node>} [properties]   object with key/value pairs
	   */
	  function ObjectNode(properties) {
	    if (!(this instanceof ObjectNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    this.properties = properties || {};
	
	    // validate input
	    if (properties) {
	      if (!(typeof properties === 'object') || !Object.keys(properties).every(function (key) {
	            return type.isNode(properties[key]);
	          })) {
	        throw new TypeError('Object containing Nodes expected');
	      }
	    }
	  }
	
	  ObjectNode.prototype = new Node();
	
	  ObjectNode.prototype.type = 'ObjectNode';
	
	  ObjectNode.prototype.isObjectNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  ObjectNode.prototype._compile = function (math, argNames) {
	    var evalEntries = {};
	
	    for (var key in this.properties) {
	      if (hasOwnProperty(this.properties, key)) {
	        // we stringify/parse the key here to resolve unicode characters,
	        // so you cannot create a key like {"co\\u006Estructor": null} 
	        var stringifiedKey = stringify(key)
	        var parsedKey = JSON.parse(stringifiedKey)
	        if (!isSafeProperty(this.properties, parsedKey)) {
	          throw new Error('No access to property "' + parsedKey + '"');
	        }
	
	        evalEntries[parsedKey]= this.properties[key]._compile(math, argNames);
	      }
	    }
	
	    return function evalObjectNode (scope, args, context) {
	      var obj = {};
	
	      for (var key in evalEntries) {
	        if (hasOwnProperty(evalEntries, key)) {
	          obj[key] = evalEntries[key](scope, args, context);
	        }
	      }
	
	      return obj;
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  ObjectNode.prototype.forEach = function (callback) {
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        callback(this.properties[key], 'properties[' + stringify(key) + ']', this);
	      }
	    }
	  };
	
	  /**
	   * Create a new ObjectNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {ObjectNode} Returns a transformed copy of the node
	   */
	  ObjectNode.prototype.map = function (callback) {
	    var properties = {};
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        properties[key] = this._ifNode(callback(this.properties[key],
	            'properties[' + stringify(key) + ']', this));
	      }
	    }
	    return new ObjectNode(properties);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {ObjectNode}
	   */
	  ObjectNode.prototype.clone = function() {
	    var properties = {};
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        properties[key] = this.properties[key];
	      }
	    }
	    return new ObjectNode(properties);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ObjectNode.prototype._toString = function(options) {
	    var entries = [];
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        entries.push(stringify(key) + ': ' + this.properties[key].toString(options));
	      }
	    }
	    return '{' + entries.join(', ') + '}';
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  ObjectNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'ObjectNode',
	      properties: this.properties
	    };
	  };
	
	  /**
	   * Instantiate an OperatorNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
	   *                       where mathjs is optional
	   * @returns {ObjectNode}
	   */
	  ObjectNode.fromJSON = function (json) {
	    return new ObjectNode(json.properties);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ObjectNode.prototype.toHTML = function(options) {
	    var entries = [];
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        entries.push('<span class="math-symbol math-property">' + escape(key) + '</span>' + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
	      }
	    }
	    return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  ObjectNode.prototype._toTex = function(options) {
	    var entries = [];
	    for (var key in this.properties) {
	      if (this.properties.hasOwnProperty(key)) {
	        entries.push("\\mathbf{" + key + ':} & ' + this.properties[key].toTex(options) + "\\\\");
	      }
	    }
	    return '\\left\\{\\begin{array}{ll}' + entries.join('\n') + '\\end{array}\\right\\}';
	  };
	
	  return ObjectNode;
	}
	
	exports.name = 'ObjectNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var latex = __webpack_require__(1348);
	var map = __webpack_require__(1357).map;
	var escape = __webpack_require__(1341).escape;
	var isSafeMethod = __webpack_require__(1624).isSafeMethod;
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	var operators = __webpack_require__(1634);
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor OperatorNode
	   * @extends {Node}
	   * An operator with two arguments, like 2+3
	   *
	   * @param {string} op           Operator name, for example '+'
	   * @param {string} fn           Function name, for example 'add'
	   * @param {Node[]} args         Operator arguments
	   * @param {boolean} [implicit]  Is this an implicit multiplication?
	   */
	  function OperatorNode(op, fn, args, implicit) {
	    if (!(this instanceof OperatorNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    //validate input
	    if (typeof op !== 'string') {
	      throw new TypeError('string expected for parameter "op"');
	    }
	    if (typeof fn !== 'string') {
	      throw new TypeError('string expected for parameter "fn"');
	    }
	    if (!Array.isArray(args) || !args.every(type.isNode)) {
	      throw new TypeError('Array containing Nodes expected for parameter "args"');
	    }
	
	    this.implicit = (implicit === true);
	    this.op = op;
	    this.fn = fn;
	    this.args = args || [];
	  }
	
	  OperatorNode.prototype = new Node();
	
	  OperatorNode.prototype.type = 'OperatorNode';
	
	  OperatorNode.prototype.isOperatorNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  OperatorNode.prototype._compile = function (math, argNames) {
	    // validate fn
	    if (typeof this.fn !== 'string' || !isSafeMethod(math, this.fn)) {
	      if (!math[this.fn]) {
	        throw new Error('Function ' + this.fn + ' missing in provided namespace "math"');
	      }
	      else {
	        throw new Error('No access to function "' + this.fn + '"');
	      }
	    }
	
	    var fn = getSafeProperty(math, this.fn);
	    var evalArgs = map(this.args, function (arg) {
	      return arg._compile(math, argNames);
	    });
	
	    if (evalArgs.length === 1) {
	      var evalArg0 = evalArgs[0];
	      return function evalOperatorNode(scope, args, context) {
	        return fn(evalArg0(scope, args, context));
	      };
	    }
	    else if (evalArgs.length === 2) {
	      var evalArg0 = evalArgs[0];
	      var evalArg1 = evalArgs[1];
	      return function evalOperatorNode(scope, args, context) {
	        return fn(evalArg0(scope, args, context), evalArg1(scope, args, context))
	      };
	    }
	    else {
	      return function evalOperatorNode(scope, args, context) {
	        return fn.apply(null, map(evalArgs, function (evalArg) {
	          return evalArg(scope, args, context)
	        }));
	      };
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  OperatorNode.prototype.forEach = function (callback) {
	    for (var i = 0; i < this.args.length; i++) {
	      callback(this.args[i], 'args[' + i + ']', this);
	    }
	  };
	
	  /**
	   * Create a new OperatorNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {OperatorNode} Returns a transformed copy of the node
	   */
	  OperatorNode.prototype.map = function (callback) {
	    var args = [];
	    for (var i = 0; i < this.args.length; i++) {
	      args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
	    }
	    return new OperatorNode(this.op, this.fn, args, this.implicit);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {OperatorNode}
	   */
	  OperatorNode.prototype.clone = function () {
	    return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit);
	  };
	
	  /**
	   * Check whether this is an unary OperatorNode:
	   * has exactly one argument, like `-a`.
	   * @return {boolean} Returns true when an unary operator node, false otherwise.
	   */
	  OperatorNode.prototype.isUnary = function () {
	    return this.args.length === 1;
	  };
	
	  /**
	   * Check whether this is a binary OperatorNode:
	   * has exactly two arguments, like `a + b`.
	   * @return {boolean} Returns true when a binary operator node, false otherwise.
	   */
	  OperatorNode.prototype.isBinary = function () {
	    return this.args.length === 2;
	  };
	
	  /**
	   * Calculate which parentheses are necessary. Gets an OperatorNode
	   * (which is the root of the tree) and an Array of Nodes
	   * (this.args) and returns an array where 'true' means that an argument
	   * has to be enclosed in parentheses whereas 'false' means the opposite.
	   *
	   * @param {OperatorNode} root
	   * @param {string} parenthesis
	   * @param {Node[]} args
	   * @param {boolean} latex
	   * @return {boolean[]}
	   * @private
	   */
	  function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
	    //precedence of the root OperatorNode
	    var precedence = operators.getPrecedence(root, parenthesis);
	    var associativity = operators.getAssociativity(root, parenthesis);
	
	    if ((parenthesis === 'all') || ((args.length > 2) && (root.getIdentifier() !== 'OperatorNode:add') && (root.getIdentifier() !== 'OperatorNode:multiply'))) {
	      var parens = args.map(function (arg) {
	        switch (arg.getContent().type) { //Nodes that don't need extra parentheses
	          case 'ArrayNode':
	          case 'ConstantNode':
	          case 'SymbolNode':
	          case 'ParenthesisNode':
	            return false;
	            break;
	          default:
	            return true;
	        }
	      });
	      return parens;
	    }
	
	    var result = undefined;
	    switch (args.length) {
	      case 0:
	        result = [];
	        break;
	
	      case 1: //unary operators
	        //precedence of the operand
	        var operandPrecedence = operators.getPrecedence(args[0], parenthesis);
	
	        //handle special cases for LaTeX, where some of the parentheses aren't needed
	        if (latex && (operandPrecedence !== null)) {
	          var operandIdentifier;
	          var rootIdentifier;
	          if (parenthesis === 'keep') {
	            operandIdentifier = args[0].getIdentifier();
	            rootIdentifier = root.getIdentifier();
	          }
	          else {
	            //Ignore Parenthesis Nodes when not in 'keep' mode
	            operandIdentifier = args[0].getContent().getIdentifier();
	            rootIdentifier = root.getContent().getIdentifier();
	          }
	          if (operators.properties[precedence][rootIdentifier].latexLeftParens === false) {
	            result = [false];
	            break;
	          }
	
	          if (operators.properties[operandPrecedence][operandIdentifier].latexParens === false) {
	            result = [false];
	            break;
	          }
	        }
	
	        if (operandPrecedence === null) {
	          //if the operand has no defined precedence, no parens are needed
	          result = [false];
	          break;
	        }
	
	        if (operandPrecedence <= precedence) {
	          //if the operands precedence is lower, parens are needed
	          result = [true];
	          break;
	        }
	
	        //otherwise, no parens needed
	        result = [false];
	        break;
	
	      case 2: //binary operators
	        var lhsParens; //left hand side needs parenthesis?
	        //precedence of the left hand side
	        var lhsPrecedence = operators.getPrecedence(args[0], parenthesis);
	        //is the root node associative with the left hand side
	        var assocWithLhs = operators.isAssociativeWith(root, args[0], parenthesis);
	
	        if (lhsPrecedence === null) {
	          //if the left hand side has no defined precedence, no parens are needed
	          //FunctionNode for example
	          lhsParens = false;
	        }
	        else if ((lhsPrecedence === precedence) && (associativity === 'right') && !assocWithLhs) {
	          //In case of equal precedence, if the root node is left associative
	          // parens are **never** necessary for the left hand side.
	          //If it is right associative however, parens are necessary
	          //if the root node isn't associative with the left hand side
	          lhsParens = true;
	        }
	        else if (lhsPrecedence < precedence) {
	          lhsParens = true;
	        }
	        else {
	          lhsParens = false;
	        }
	
	        var rhsParens; //right hand side needs parenthesis?
	        //precedence of the right hand side
	        var rhsPrecedence = operators.getPrecedence(args[1], parenthesis);
	        //is the root node associative with the right hand side?
	        var assocWithRhs = operators.isAssociativeWith(root, args[1], parenthesis);
	
	        if (rhsPrecedence === null) {
	          //if the right hand side has no defined precedence, no parens are needed
	          //FunctionNode for example
	          rhsParens = false;
	        }
	        else if ((rhsPrecedence === precedence) && (associativity === 'left') && !assocWithRhs) {
	          //In case of equal precedence, if the root node is right associative
	          // parens are **never** necessary for the right hand side.
	          //If it is left associative however, parens are necessary
	          //if the root node isn't associative with the right hand side
	          rhsParens = true;
	        }
	        else if (rhsPrecedence < precedence) {
	          rhsParens = true;
	        }
	        else {
	          rhsParens = false;
	        }
	
	        //handle special cases for LaTeX, where some of the parentheses aren't needed
	        if (latex) {
	          var rootIdentifier;
	          var lhsIdentifier;
	          var rhsIdentifier;
	          if (parenthesis === 'keep') {
	            rootIdentifier = root.getIdentifier();
	            lhsIdentifier = root.args[0].getIdentifier();
	            rhsIdentifier = root.args[1].getIdentifier();
	          }
	          else {
	            //Ignore ParenthesisNodes when not in 'keep' mode
	            rootIdentifier = root.getContent().getIdentifier();
	            lhsIdentifier = root.args[0].getContent().getIdentifier();
	            rhsIdentifier = root.args[1].getContent().getIdentifier();
	          }
	
	          if (lhsPrecedence !== null) {
	            if (operators.properties[precedence][rootIdentifier].latexLeftParens === false) {
	              lhsParens = false;
	            }
	
	            if (operators.properties[lhsPrecedence][lhsIdentifier].latexParens === false) {
	              lhsParens = false;
	            }
	          }
	
	          if (rhsPrecedence !== null) {
	            if (operators.properties[precedence][rootIdentifier].latexRightParens === false) {
	              rhsParens = false;
	            }
	
	            if (operators.properties[rhsPrecedence][rhsIdentifier].latexParens === false) {
	              rhsParens = false;
	            }
	          }
	        }
	
	        result = [lhsParens, rhsParens];
	        break;
	
	      default:
	        if ((root.getIdentifier() === 'OperatorNode:add') || (root.getIdentifier() === 'OperatorNode:multiply')) {
	          var result = args.map(function (arg) {
	            var argPrecedence = operators.getPrecedence(arg, parenthesis);
	            var assocWithArg = operators.isAssociativeWith(root, arg, parenthesis);
	            var argAssociativity = operators.getAssociativity(arg, parenthesis);
	            if (argPrecedence === null) {
	              //if the argument has no defined precedence, no parens are needed
	              return false;
	            } else if ((precedence === argPrecedence) && (associativity === argAssociativity) && !assocWithArg) {
	              return true;
	            } else if (argPrecedence < precedence) {
	              return true;
	            }
	
	            return false;
	          });
	        }
	        break;
	    }
	
	    //handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
	    //In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
	    //printed.
	    if ((args.length >= 2) && (root.getIdentifier() === 'OperatorNode:multiply') && root.implicit && (parenthesis === 'auto') && (implicit === 'hide')) {
	      result = args.map(function (arg, index) {
	        var isParenthesisNode = (arg.getIdentifier() === 'ParenthesisNode');
	        if (result[index] || isParenthesisNode) { //put in parenthesis?
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return result;
	  }
	
	  /**
	   * Get string representation.
	   * @param {Object} options
	   * @return {string} str
	   */
	  OperatorNode.prototype._toString = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var implicit = (options && options.implicit) ? options.implicit : 'hide';
	    var args = this.args;
	    var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
	
	    if (args.length === 1) { //unary operators
	      var assoc = operators.getAssociativity(this, parenthesis);
	
	      var operand = args[0].toString(options);
	      if (parens[0]) {
	        operand = '(' + operand + ')';
	      }
	
	      if (assoc === 'right') { //prefix operator
	        return this.op + operand;
	      }
	      else if (assoc === 'left') { //postfix
	        return operand + this.op;
	      }
	
	      //fall back to postfix
	      return operand + this.op;
	    } else if (args.length == 2) {
	      var lhs = args[0].toString(options); //left hand side
	      var rhs = args[1].toString(options); //right hand side
	      if (parens[0]) { //left hand side in parenthesis?
	        lhs = '(' + lhs + ')';
	      }
	      if (parens[1]) { //right hand side in parenthesis?
	        rhs = '(' + rhs + ')';
	      }
	
	      if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit == 'hide')) {
	        return lhs + ' ' + rhs;
	      }
	
	      return lhs + ' ' + this.op + ' ' + rhs;
	    } else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
	      var stringifiedArgs = args.map(function (arg, index) {
	        arg = arg.toString(options);
	        if (parens[index]) { //put in parenthesis?
	          arg = '(' + arg + ')';
	        }
	
	        return arg;
	      });
	
	      if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit === 'hide')) {
	        return stringifiedArgs.join(' ');
	      }
	
	      return stringifiedArgs.join(' ' + this.op + ' ');
	    } else {
	      //fallback to formatting as a function call
	      return this.fn + '(' + this.args.join(', ') + ')';
	    }
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  OperatorNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'OperatorNode',
	      op: this.op,
	      fn: this.fn,
	      args: this.args,
	      implicit: this.implicit
	    };
	  };
	
	  /**
	   * Instantiate an OperatorNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false}`,
	   *                       where mathjs is optional
	   * @returns {OperatorNode}
	   */
	  OperatorNode.fromJSON = function (json) {
	    return new OperatorNode(json.op, json.fn, json.args, json.implicit);
	  };
	
	  /**
	   * Get HTML representation.
	   * @param {Object} options
	   * @return {string} str
	   */
	  OperatorNode.prototype.toHTML = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var implicit = (options && options.implicit) ? options.implicit : 'hide';
	    var args = this.args;
	    var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);
	
	    if (args.length === 1) { //unary operators
	      var assoc = operators.getAssociativity(this, parenthesis);
	
	      var operand = args[0].toHTML(options);
	      if (parens[0]) {
	        operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	      }
	
	      if (assoc === 'right') { //prefix operator
	        return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape(this.op) + '</span>' + operand;
	      }
	      else if (assoc === 'left') { //postfix
	        return '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape(this.op) + '</span>' + operand;
	      }
	
	      //fall back to postfix
	      return '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape(this.op) + '</span>' + operand;
	    }
		else if (args.length == 2) { // binary operatoes
	      var lhs = args[0].toHTML(options); //left hand side
	      var rhs = args[1].toHTML(options); //right hand side
	      if (parens[0]) { //left hand side in parenthesis?
	        lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	      }
	      if (parens[1]) { //right hand side in parenthesis?
	        rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	      }
		  
		  if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit == 'hide')) {
		    return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
		  }
	      
		  return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + '</span>' + rhs;
	    }
		else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
	      var stringifiedArgs = args.map(function (arg, index) {
	        arg = arg.toHTML(options);
	        if (parens[index]) { //put in parenthesis?
	          arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	        }
	
	        return arg;
	      });
	
	      if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit === 'hide')) {
	        return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
	      }
	
	      return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + '</span>');
	    } else {
	      //fallback to formatting as a function call
	      return '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
	    }
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  OperatorNode.prototype._toTex = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var implicit = (options && options.implicit) ? options.implicit : 'hide';
	    var args = this.args;
	    var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
	    var op = latex.operators[this.fn];
	    op = typeof op === 'undefined' ? this.op : op; //fall back to using this.op
	
	    if (args.length === 1) { //unary operators
	      var assoc = operators.getAssociativity(this, parenthesis);
	
	      var operand = args[0].toTex(options);
	      if (parens[0]) {
	        operand = '\\left(' + operand + '\\right)';
	      }
	
	      if (assoc === 'right') { //prefix operator
	        return op + operand;
	      }
	      else if (assoc === 'left') { //postfix operator
	        return operand + op;
	      }
	
	      //fall back to postfix
	      return operand + op;
	    } else if (args.length === 2) { //binary operators
	      var lhs = args[0]; //left hand side
	      var lhsTex = lhs.toTex(options);
	      if (parens[0]) {
	        lhsTex = '\\left(' + lhsTex + '\\right)';
	      }
	
	      var rhs = args[1]; //right hand side
	      var rhsTex = rhs.toTex(options);
	      if (parens[1]) {
	        rhsTex = '\\left(' + rhsTex + '\\right)';
	      }
	
	      //handle some exceptions (due to the way LaTeX works)
	      var lhsIdentifier;
	      if (parenthesis === 'keep') {
	        lhsIdentifier = lhs.getIdentifier();
	      }
	      else {
	        //Ignore ParenthesisNodes if in 'keep' mode
	        lhsIdentifier = lhs.getContent().getIdentifier();
	      }
	      switch (this.getIdentifier()) {
	        case 'OperatorNode:divide':
	          //op contains '\\frac' at this point
	          return op + '{' + lhsTex + '}' + '{' + rhsTex + '}';
	        case 'OperatorNode:pow':
	          lhsTex = '{' + lhsTex + '}';
	          rhsTex = '{' + rhsTex + '}';
	          switch (lhsIdentifier) {
	            case 'ConditionalNode': //
	            case 'OperatorNode:divide':
	              lhsTex = '\\left(' + lhsTex + '\\right)';
	          }
	        case 'OperatorNode:multiply':
	          if (this.implicit && (implicit === 'hide')) {
	            return lhsTex + '~' + rhsTex;
	          }
	      }
	      return lhsTex + op + rhsTex;
	    } else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
	      var texifiedArgs = args.map(function (arg, index) {
	        arg = arg.toTex(options);
	        if (parens[index]) {
	          arg = '\\left(' + arg + '\\right)';
	        }
	        return arg;
	      });
	
	      if ((this.getIdentifier() === 'OperatorNode:multiply') && this.implicit) {
	        return texifiedArgs.join('~');
	      }
	
	      return texifiedArgs.join(op)
	    } else {
	      //fall back to formatting as a function call
	      //as this is a fallback, it doesn't use
	      //fancy function names
	      return '\\mathrm{' + this.fn + '}\\left('
	          + args.map(function (arg) {
	            return arg.toTex(options);
	          }).join(',') + '\\right)';
	    }
	  };
	
	  /**
	   * Get identifier.
	   * @return {string}
	   */
	  OperatorNode.prototype.getIdentifier = function () {
	    return this.type + ':' + this.fn;
	  };
	
	  return OperatorNode;
	}
	
	exports.name = 'OperatorNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor ParenthesisNode
	   * @extends {Node}
	   * A parenthesis node describes manual parenthesis from the user input
	   * @param {Node} content
	   * @extends {Node}
	   */
	  function ParenthesisNode(content) {
	    if (!(this instanceof ParenthesisNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    // validate input
	    if (!type.isNode(content)) {
	      throw new TypeError('Node expected for parameter "content"');
	    }
	
	    this.content = content;
	  }
	
	  ParenthesisNode.prototype = new Node();
	
	  ParenthesisNode.prototype.type = 'ParenthesisNode';
	
	  ParenthesisNode.prototype.isParenthesisNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  ParenthesisNode.prototype._compile = function (math, argNames) {
	    return this.content._compile(math, argNames);
	  }
	
	  /**
	   * Get the content of the current Node.
	   * @return {Node} content
	   * @override
	   **/
	  ParenthesisNode.prototype.getContent = function () {
	    return this.content.getContent();
	  };
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  ParenthesisNode.prototype.forEach = function (callback) {
	    callback(this.content, 'content', this);
	  };
	
	  /**
	   * Create a new ParenthesisNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node) : Node} callback
	   * @returns {ParenthesisNode} Returns a clone of the node
	   */
	  ParenthesisNode.prototype.map = function (callback) {
	    var content = callback(this.content, 'content', this);
	    return new ParenthesisNode(content);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {ParenthesisNode}
	   */
	  ParenthesisNode.prototype.clone = function() {
	    return new ParenthesisNode(this.content);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ParenthesisNode.prototype._toString = function(options) {
	    if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
	      return '(' + this.content.toString(options) + ')';
	    }
	    return this.content.toString(options);
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  ParenthesisNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'ParenthesisNode',
	      content: this.content
	    };
	  };
	
	  /**
	   * Instantiate an ParenthesisNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
	   *                       where mathjs is optional
	   * @returns {ParenthesisNode}
	   */
	  ParenthesisNode.fromJSON = function (json) {
	    return new ParenthesisNode(json.content);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ParenthesisNode.prototype.toHTML = function(options) {
	    if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
	      return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	    return this.content.toHTML(options);
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  ParenthesisNode.prototype._toTex = function(options) {
	    if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
	      return '\\left(' + this.content.toTex(options) + '\\right)';
	    }
	    return this.content.toTex(options);
	  };
	
	  return ParenthesisNode;
	}
	
	exports.name = 'ParenthesisNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var latex = __webpack_require__(1348);
	var escape = __webpack_require__(1341).escape;
	var hasOwnProperty = __webpack_require__(1320).hasOwnProperty;
	var map = __webpack_require__(1357).map;
	var validateSafeMethod = __webpack_require__(1624).validateSafeMethod;
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	
	function factory (type, config, load, typed, math) {
	  var Node = load(__webpack_require__(1625));
	  var SymbolNode = load(__webpack_require__(1643));
	
	  /**
	   * @constructor FunctionNode
	   * @extends {./Node}
	   * invoke a list with arguments on a node
	   * @param {./Node | string} fn Node resolving with a function on which to invoke
	   *                             the arguments, typically a SymboNode or AccessorNode
	   * @param {./Node[]} args
	   */
	  function FunctionNode(fn, args) {
	    if (!(this instanceof FunctionNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (typeof fn === 'string') {
	      fn = new SymbolNode(fn);
	    }
	
	    // validate input
	    if (!type.isNode(fn)) throw new TypeError('Node expected as parameter "fn"');
	    if (!Array.isArray(args) || !args.every(type.isNode)) {
	      throw new TypeError('Array containing Nodes expected for parameter "args"');
	    }
	
	    this.fn = fn;
	    this.args = args || [];
	
	    // readonly property name
	    Object.defineProperty(this, 'name', {
	      get: function () {
	        return this.fn.name || '';
	      }.bind(this),
	      set: function () {
	        throw new Error('Cannot assign a new name, name is read-only');
	      }
	    });
	
	    // TODO: deprecated since v3, remove some day
	    var deprecated = function () {
	      throw new Error('Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead');
	    };
	    Object.defineProperty(this, 'object', { get: deprecated, set: deprecated });
	  }
	
	  FunctionNode.prototype = new Node();
	
	  FunctionNode.prototype.type = 'FunctionNode';
	
	  FunctionNode.prototype.isFunctionNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  FunctionNode.prototype._compile = function (math, argNames) {
	    if (!(this instanceof FunctionNode)) {
	      throw new TypeError('No valid FunctionNode')
	    }
	
	    // compile arguments
	    var evalArgs = map(this.args, function (arg) {
	      return arg._compile(math, argNames);
	    });
	    // var jsScope = compileScope(defs, args); // TODO: jsScope
	    var argsName;
	
	    if (type.isSymbolNode(this.fn)) {
	      // we can statically determine whether the function has an rawArgs property
	      var name = this.fn.name;
	      var fn = name in math ? getSafeProperty(math, name) : undefined;
	      var isRaw = (typeof fn === 'function') && (fn.rawArgs == true);
	
	      if (isRaw) {
	        // pass unevaluated parameters (nodes) to the function
	        // "raw" evaluation
	        var rawArgs = this.args;
	        return function evalFunctionNode(scope, args, context) {
	          return (name in scope ? getSafeProperty(scope, name) : fn)(rawArgs, math, scope);
	        };
	      }
	      else {
	        // "regular" evaluation
	        if (evalArgs.length === 1) {
	          var evalArg0 = evalArgs[0];
	          return function evalFunctionNode(scope, args, context) {
	            return (name in scope ? getSafeProperty(scope, name) : fn)(evalArg0(scope, args, context));
	          };
	        }
	        else if (evalArgs.length === 2) {
	          var evalArg0 = evalArgs[0];
	          var evalArg1 = evalArgs[1];
	          return function evalFunctionNode(scope, args, context) {
	            return (name in scope ? getSafeProperty(scope, name) : fn)(evalArg0(scope, args, context), evalArg1(scope, args, context));
	          };
	        }
	        else {
	          return function evalFunctionNode(scope, args, context) {
	            return (name in scope ? getSafeProperty(scope, name) : fn).apply(null, map(evalArgs, function (evalArg) {
	              return evalArg(scope, args, context);
	            }));
	          }
	        }
	      }
	    }
	    else if (type.isAccessorNode(this.fn) &&
	        type.isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
	      // execute the function with the right context: the object of the AccessorNode
	
	      var evalObject = this.fn.object._compile(math, argNames);
	      var prop = this.fn.index.getObjectProperty();
	      var rawArgs = this.args;
	
	      return function evalFunctionNode (scope, args, context) {
	        var object = evalObject(scope, args, context);
	        validateSafeMethod(object, prop);
	        var isRaw = object[prop] && object[prop].rawArgs;
	
	        return isRaw 
	          ? object[prop](rawArgs, math, scope)                             // "raw" evaluation
	          : object[prop].apply(object, map(evalArgs, function (evalArg) {  // "regular" evaluation
	              return evalArg(scope, args, context);
	            }));
	      }
	    }
	    else { // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
	      // we have to dynamically determine whether the function has a rawArgs property
	      var evalFn = this.fn._compile(math, argNames);
	
	      return function evalFunctionNode (scope, args, context) {
	        var fn = evalFn(scope, args, context);
	        var isRaw = fn && fn.rawArgs;
	
	        return isRaw 
	          ? fn(rawArgs, math, scope)                         // "raw" evaluation
	          : fn.apply(fn, map(evalArgs, function (evalArg) {  // "regular" evaluation
	              return evalArg(scope, args, context);
	            }));
	      };
	    }
	  }
	  
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  FunctionNode.prototype.forEach = function (callback) {
	    for (var i = 0; i < this.args.length; i++) {
	      callback(this.args[i], 'args[' + i + ']', this);
	    }
	  };
	
	  /**
	   * Create a new FunctionNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {FunctionNode} Returns a transformed copy of the node
	   */
	  FunctionNode.prototype.map = function (callback) {
	    var fn = this.fn.map(callback);
	    var args = [];
	    for (var i = 0; i < this.args.length; i++) {
	      args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
	    }
	    return new FunctionNode(fn, args);
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {FunctionNode}
	   */
	  FunctionNode.prototype.clone = function () {
	    return new FunctionNode(this.fn, this.args.slice(0));
	  };
	
	  //backup Node's toString function
	  //@private
	  var nodeToString = FunctionNode.prototype.toString;
	
	  /**
	   * Get string representation. (wrapper function)
	   * This overrides parts of Node's toString function.
	   * If callback is an object containing callbacks, it
	   * calls the correct callback for the current node,
	   * otherwise it falls back to calling Node's toString
	   * function.
	   *
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  FunctionNode.prototype.toString = function (options) {
	    var customString;
	    var name = this.fn.toString(options);
	    if (options && (typeof options.handler === 'object') && hasOwnProperty(options.handler, name)) {
	      //callback is a map of callback functions
	      customString = options.handler[name](this, options);
	    }
	
	    if (typeof customString !== 'undefined') {
	      return customString;
	    }
	
	    //fall back to Node's toString
	    return nodeToString.call(this, options);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  FunctionNode.prototype._toString = function (options) {
	    var args = this.args.map(function (arg) {
	      return arg.toString(options);
	    });
	
	    var fn = type.isFunctionAssignmentNode(this.fn)
	        ? ('(' + this.fn.toString(options) + ')')
	        : this.fn.toString(options)
	
	    // format the arguments like "add(2, 4.2)"
	    return fn + '(' + args.join(', ') + ')';
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  FunctionNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'FunctionNode',
	      fn: this.fn,
	      args: this.args
	    };
	  };
	
	  /**
	   * Instantiate an AssignmentNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
	   *                       where mathjs is optional
	   * @returns {FunctionNode}
	   */
	  FunctionNode.fromJSON = function (json) {
	    return new FunctionNode(json.fn, json.args);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  FunctionNode.prototype.toHTML = function (options) {
	    var args = this.args.map(function (arg) {
	      return arg.toHTML(options);
	    });
	
	    // format the arguments like "add(2, 4.2)"
	    return '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
	  };
	
	  /*
	   * Expand a LaTeX template
	   *
	   * @param {string} template
	   * @param {Node} node
	   * @param {Object} options
	   * @private
	   **/
	  function expandTemplate(template, node, options) {
	    var latex = '';
	
	    // Match everything of the form ${identifier} or ${identifier[2]} or $$
	    // while submatching identifier and 2 (in the second case)
	    var regex = new RegExp('\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)', 'ig');
	
	    var inputPos = 0;   //position in the input string
	    var match;
	    while ((match = regex.exec(template)) !== null) {   //go through all matches
	      // add everything in front of the match to the LaTeX string
	      latex += template.substring(inputPos, match.index);
	      inputPos = match.index;
	
	      if (match[0] === '$$') { // escaped dollar sign
	        latex += '$';
	        inputPos++;
	      }
	      else { // template parameter
	        inputPos += match[0].length;
	        var property = node[match[1]];
	        if (!property) {
	          throw new ReferenceError('Template: Property ' + match[1] + ' does not exist.');
	        }
	        if (match[2] === undefined) { //no square brackets
	          switch (typeof property) {
	            case 'string':
	              latex += property;
	              break;
	            case 'object':
	              if (type.isNode(property)) {
	                latex += property.toTex(options);
	              }
	              else if (Array.isArray(property)) {
	                //make array of Nodes into comma separated list
	                latex += property.map(function (arg, index) {
	                  if (type.isNode(arg)) {
	                    return arg.toTex(options);
	                  }
	                  throw new TypeError('Template: ' + match[1] + '[' + index + '] is not a Node.');
	                }).join(',');
	              }
	              else {
	                throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
	              }
	              break;
	            default:
	              throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
	          }
	        }
	        else { //with square brackets
	          if (type.isNode(property[match[2]] && property[match[2]])) {
	            latex += property[match[2]].toTex(options);
	          }
	          else {
	            throw new TypeError('Template: ' + match[1] + '[' + match[2] + '] is not a Node.');
	          }
	        }
	      }
	    }
	    latex += template.slice(inputPos);  //append rest of the template
	
	    return latex;
	  }
	
	  //backup Node's toTex function
	  //@private
	  var nodeToTex = FunctionNode.prototype.toTex;
	
	  /**
	   * Get LaTeX representation. (wrapper function)
	   * This overrides parts of Node's toTex function.
	   * If callback is an object containing callbacks, it
	   * calls the correct callback for the current node,
	   * otherwise it falls back to calling Node's toTex
	   * function.
	   *
	   * @param {Object} options
	   * @return {string}
	   */
	  FunctionNode.prototype.toTex = function (options) {
	    var customTex;
	    if (options && (typeof options.handler === 'object') && hasOwnProperty(options.handler, this.name)) {
	      //callback is a map of callback functions
	      customTex = options.handler[this.name](this, options);
	    }
	
	    if (typeof customTex !== 'undefined') {
	      return customTex;
	    }
	
	    //fall back to Node's toTex
	    return nodeToTex.call(this, options);
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  FunctionNode.prototype._toTex = function (options) {
	    var args = this.args.map(function (arg) { //get LaTeX of the arguments
	      return arg.toTex(options);
	    });
	
	    var latexConverter;
	
	    if (math[this.name] && ((typeof math[this.name].toTex === 'function') || (typeof math[this.name].toTex === 'object') || (typeof math[this.name].toTex === 'string'))) {
	      //.toTex is a callback function
	      latexConverter = math[this.name].toTex;
	    }
	
	    var customToTex;
	    switch (typeof latexConverter) {
	      case 'function': //a callback function
	        customToTex = latexConverter(this, options);
	        break;
	      case 'string': //a template string
	        customToTex = expandTemplate(latexConverter, this, options);
	        break;
	      case 'object': //an object with different "converters" for different numbers of arguments
	        switch (typeof latexConverter[args.length]) {
	          case 'function':
	            customToTex = latexConverter[args.length](this, options);
	            break;
	          case 'string':
	            customToTex = expandTemplate(latexConverter[args.length], this, options);
	            break;
	        }
	    }
	
	    if (typeof customToTex !== 'undefined') {
	      return customToTex;
	    }
	
	    return expandTemplate(latex.defaultTemplate, this, options);
	  };
	
	  /**
	   * Get identifier.
	   * @return {string}
	   */
	  FunctionNode.prototype.getIdentifier = function () {
	    return this.type + ':' + this.name;
	  };
	
	  return FunctionNode;
	}
	
	exports.name = 'FunctionNode';
	exports.path = 'expression.node';
	exports.math = true; // request access to the math namespace as 5th argument of the factory function
	exports.factory = factory;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var latex = __webpack_require__(1348);
	var escape = __webpack_require__(1341).escape;
	var hasOwnProperty = __webpack_require__(1320).hasOwnProperty;
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	
	function factory (type, config, load, typed, math) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * Check whether some name is a valueless unit like "inch".
	   * @param {string} name
	   * @return {boolean}
	   */
	  function isValuelessUnit (name) {
	    return type.Unit ? type.Unit.isValuelessUnit(name) : false;
	  }
	
	  /**
	   * @constructor SymbolNode
	   * @extends {Node}
	   * A symbol node can hold and resolve a symbol
	   * @param {string} name
	   * @extends {Node}
	   */
	  function SymbolNode(name) {
	    if (!(this instanceof SymbolNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    // validate input
	    if (typeof name !== 'string')  throw new TypeError('String expected for parameter "name"');
	
	    this.name = name;
	  }
	
	  SymbolNode.prototype = new Node();
	
	  SymbolNode.prototype.type = 'SymbolNode';
	
	  SymbolNode.prototype.isSymbolNode = true;
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  SymbolNode.prototype._compile = function (math, argNames) {
	    var name = this.name;
	
	    if (hasOwnProperty(argNames, name)) {
	      // this is a FunctionAssignment argument
	      // (like an x when inside the expression of a function assignment `f(x) = ...`)
	      return function (scope, args, context) {
	        return args[name];
	      }
	    }
	    else if (name in math) {
	      return function (scope, args, context) {
	        return name in scope 
	          ? getSafeProperty(scope, name) 
	          : getSafeProperty(math, name);
	      }
	    }
	    else {
	      var isUnit = isValuelessUnit(name);
	
	      return function (scope, args, context) {
	        return name in scope 
	          ? getSafeProperty(scope, name) 
	          : isUnit 
	            ? new type.Unit(null, name)
	            : undef(name);
	      }
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  SymbolNode.prototype.forEach = function (callback) {
	    // nothing to do, we don't have childs
	  };
	
	  /**
	   * Create a new SymbolNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node) : Node} callback
	   * @returns {SymbolNode} Returns a clone of the node
	   */
	  SymbolNode.prototype.map = function (callback) {
	    return this.clone();
	  };
	
	  /**
	   * Throws an error 'Undefined symbol {name}'
	   * @param {string} name
	   */
	  function undef (name) {
	    throw new Error('Undefined symbol ' + name);
	  }
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {SymbolNode}
	   */
	  SymbolNode.prototype.clone = function() {
	    return new SymbolNode(this.name);
	  };
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  SymbolNode.prototype._toString = function(options) {
	    return this.name;
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  SymbolNode.prototype.toHTML = function(options) {
		var name = escape(this.name);
		
	    if (name == "true" || name == "false") {
		  return '<span class="math-symbol math-boolean">' + name + '</span>';
		}
		else if (name == "i") {
		  return '<span class="math-symbol math-imaginary-symbol">' + name + '</span>';
		}
		else if (name == "Infinity") {
		  return '<span class="math-symbol math-infinity-symbol">' + name + '</span>';
		}
		else if (name == "NaN") {
		  return '<span class="math-symbol math-nan-symbol">' + name + '</span>';
		}
		else if (name == "null") {
		  return '<span class="math-symbol math-null-symbol">' + name + '</span>';
		}
		else if (name == "undefined") {
		  return '<span class="math-symbol math-undefined-symbol">' + name + '</span>';
		}
		
		return '<span class="math-symbol">' + name + '</span>';
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  SymbolNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'SymbolNode',
	      name: this.name
	    };
	  };
	
	  /**
	   * Instantiate a SymbolNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "SymbolNode", name: "x"}`,
	   *                       where mathjs is optional
	   * @returns {SymbolNode}
	   */
	  SymbolNode.fromJSON = function (json) {
	    return new SymbolNode(json.name);
	  };
	
	  /**
	   * Get LaTeX representation
	   * @param {Object} options
	   * @return {string} str
	   * @override
	   */
	  SymbolNode.prototype._toTex = function(options) {
	    var isUnit = false;
	    if ((typeof math[this.name] === 'undefined') && isValuelessUnit(this.name)) {
	      isUnit = true;
	    }
	    var symbol = latex.toSymbol(this.name, isUnit);
	    if (symbol[0] === '\\') {
	      //no space needed if the symbol starts with '\'
	      return symbol;
	    }
	    //the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol
	    return ' ' + symbol;
	  };
	
	  return SymbolNode;
	}
	
	exports.name = 'SymbolNode';
	exports.path = 'expression.node';
	exports.math = true; // request access to the math namespace as 5th argument of the factory function
	exports.factory = factory;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var operators = __webpack_require__(1634);
	
	function factory (type, config, load, typed) {
	  var Node = load(__webpack_require__(1625));
	
	  /**
	   * @constructor RangeNode
	   * @extends {Node}
	   * create a range
	   * @param {Node} start  included lower-bound
	   * @param {Node} end    included upper-bound
	   * @param {Node} [step] optional step
	   */
	  function RangeNode(start, end, step) {
	    if (!(this instanceof RangeNode)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    // validate inputs
	    if (!type.isNode(start)) throw new TypeError('Node expected');
	    if (!type.isNode(end)) throw new TypeError('Node expected');
	    if (step && !type.isNode(step)) throw new TypeError('Node expected');
	    if (arguments.length > 3) throw new Error('Too many arguments');
	
	    this.start = start;         // included lower-bound
	    this.end = end;           // included upper-bound
	    this.step = step || null;  // optional step
	  }
	
	  RangeNode.prototype = new Node();
	
	  RangeNode.prototype.type = 'RangeNode';
	
	  RangeNode.prototype.isRangeNode = true;
	
	  /**
	   * Check whether the RangeNode needs the `end` symbol to be defined.
	   * This end is the size of the Matrix in current dimension.
	   * @return {boolean}
	   */
	  RangeNode.prototype.needsEnd = function () {
	    // find all `end` symbols in this RangeNode
	    var endSymbols = this.filter(function (node) {
	      return type.isSymbolNode(node) && (node.name === 'end');
	    });
	
	    return endSymbols.length > 0;
	  };
	
	  /**
	   * Compile a node into a JavaScript function.
	   * This basically pre-calculates as much as possible and only leaves open
	   * calculations which depend on a dynamic scope with variables.
	   * @param {Object} math     Math.js namespace with functions and constants. 
	   * @param {Object} argNames An object with argument names as key and `true`
	   *                          as value. Used in the SymbolNode to optimize
	   *                          for arguments from user assigned functions
	   *                          (see FunctionAssignmentNode) or special symbols
	   *                          like `end` (see IndexNode).
	   * @return {function} Returns a function which can be called like:
	   *                        evalNode(scope: Object, args: Object, context: *)
	   */
	  RangeNode.prototype._compile = function (math, argNames) {
	    var range = math.range;
	    var evalStart = this.start._compile(math, argNames);
	    var evalEnd = this.end._compile(math, argNames);
	
	    if (this.step) {
	      var evalStep = this.step._compile(math, argNames);
	      
	      return function evalRangeNode(scope, args, context) {
	        return range(
	          evalStart(scope, args, context), 
	          evalEnd(scope, args, context), 
	          evalStep(scope, args, context)
	        );
	      }
	    }
	    else {
	      return function evalRangeNode(scope, args, context) {
	        return range(
	          evalStart(scope, args, context), 
	          evalEnd(scope, args, context)
	        );
	      }
	    }
	  }
	
	  /**
	   * Execute a callback for each of the child nodes of this node
	   * @param {function(child: Node, path: string, parent: Node)} callback
	   */
	  RangeNode.prototype.forEach = function (callback) {
	    callback(this.start, 'start', this);
	    callback(this.end, 'end', this);
	    if (this.step) {
	      callback(this.step, 'step', this);
	    }
	  };
	
	  /**
	   * Create a new RangeNode having it's childs be the results of calling
	   * the provided callback function for each of the childs of the original node.
	   * @param {function(child: Node, path: string, parent: Node): Node} callback
	   * @returns {RangeNode} Returns a transformed copy of the node
	   */
	  RangeNode.prototype.map = function (callback) {
	    return new RangeNode(
	        this._ifNode(callback(this.start, 'start', this)),
	        this._ifNode(callback(this.end, 'end', this)),
	        this.step && this._ifNode(callback(this.step, 'step', this))
	    );
	  };
	
	  /**
	   * Create a clone of this node, a shallow copy
	   * @return {RangeNode}
	   */
	  RangeNode.prototype.clone = function () {
	    return new RangeNode(this.start, this.end, this.step && this.step);
	  };
	
	  /**
	   * Calculate the necessary parentheses
	   * @param {Node} node
	   * @param {string} parenthesis
	   * @return {Object} parentheses
	   * @private
	   */
	  function calculateNecessaryParentheses(node, parenthesis) {
	    var precedence = operators.getPrecedence(node, parenthesis);
	    var parens = {};
	
	    var startPrecedence = operators.getPrecedence(node.start, parenthesis);
	    parens.start = ((startPrecedence !== null) && (startPrecedence <= precedence))
	      || (parenthesis === 'all');
	
	    if (node.step) {
	      var stepPrecedence = operators.getPrecedence(node.step, parenthesis);
	      parens.step = ((stepPrecedence !== null) && (stepPrecedence <= precedence))
	        || (parenthesis === 'all');
	    }
	
	    var endPrecedence = operators.getPrecedence(node.end, parenthesis);
	    parens.end = ((endPrecedence !== null) && (endPrecedence <= precedence))
	      || (parenthesis === 'all');
	
	    return parens;
	  }
	
	  /**
	   * Get string representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  RangeNode.prototype._toString = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var parens = calculateNecessaryParentheses(this, parenthesis);
	
	    //format string as start:step:stop
	    var str;
	
	    var start = this.start.toString(options);
	    if (parens.start) {
	      start = '(' + start + ')';
	    }
	    str = start;
	
	    if (this.step) {
	      var step = this.step.toString(options);
	      if (parens.step) {
	        step = '(' + step + ')';
	      }
	      str += ':' + step;
	    }
	
	    var end = this.end.toString(options);
	    if (parens.end) {
	      end = '(' + end + ')';
	    }
	    str += ':' + end;
	
	    return str;
	  };
	
	  /**
	   * Get a JSON representation of the node
	   * @returns {Object}
	   */
	  RangeNode.prototype.toJSON = function () {
	    return {
	      mathjs: 'RangeNode',
	      start: this.start,
	      end: this.end,
	      step: this.step
	    };
	  };
	
	  /**
	   * Instantiate an RangeNode from its JSON representation
	   * @param {Object} json  An object structured like
	   *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
	   *                       where mathjs is optional
	   * @returns {RangeNode}
	   */
	  RangeNode.fromJSON = function (json) {
	    return new RangeNode(json.start, json.end, json.step);
	  };
	
	  /**
	   * Get HTML representation
	   * @param {Object} options
	   * @return {string} str
	   */
	  RangeNode.prototype.toHTML = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var parens = calculateNecessaryParentheses(this, parenthesis);
	
	    //format string as start:step:stop
	    var str;
	
	    var start = this.start.toHTML(options);
	    if (parens.start) {
	      start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	    str = start;
	
	    if (this.step) {
	      var step = this.step.toHTML(options);
	      if (parens.step) {
	        step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	      }
	      str += '<span class="math-operator math-range-operator">:</span>' + step;
	    }
	
	    var end = this.end.toHTML(options);
	    if (parens.end) {
	      end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
	    }
	    str += '<span class="math-operator math-range-operator">:</span>' + end;
	
	    return str;
	  };
	
	  /**
	   * Get LaTeX representation
	   * @params {Object} options
	   * @return {string} str
	   */
	  RangeNode.prototype._toTex = function (options) {
	    var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
	    var parens = calculateNecessaryParentheses(this, parenthesis);
	
	    var str = this.start.toTex(options);
	    if (parens.start) {
	      str = '\\left(' + str + '\\right)';
	    }
	
	    if (this.step) {
	      var step = this.step.toTex(options);
	      if (parens.step) {
	        step = '\\left(' + step + '\\right)';
	      }
	      str += ':' + step;
	    }
	
	    var end = this.end.toTex(options);
	    if (parens.end) {
	      end = '\\left(' + end + '\\right)';
	    }
	    str += ':' + end;
	
	    return str;
	  };
	
	  return RangeNode;
	}
	
	exports.name = 'RangeNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var parse = load(__webpack_require__(1621));
	
	  /**
	   * Evaluate an expression.
	   *
	   * Note the evaluating arbitrary expressions may involve security risks,
	   * see [http://mathjs.org/docs/expressions/security.html](http://mathjs.org/docs/expressions/security.html) for more information.
	   *
	   * Syntax:
	   *
	   *     math.eval(expr)
	   *     math.eval(expr, scope)
	   *     math.eval([expr1, expr2, expr3, ...])
	   *     math.eval([expr1, expr2, expr3, ...], scope)
	   *
	   * Example:
	   *
	   *     math.eval('(2+3)/4');                // 1.25
	   *     math.eval('sqrt(3^2 + 4^2)');        // 5
	   *     math.eval('sqrt(-4)');               // 2i
	   *     math.eval(['a=3', 'b=4', 'a*b']);,   // [3, 4, 12]
	   *
	   *     var scope = {a:3, b:4};
	   *     math.eval('a * b', scope);           // 12
	   *
	   * See also:
	   *
	   *    parse, compile
	   *
	   * @param {string | string[] | Matrix} expr   The expression to be evaluated
	   * @param {Object} [scope]                    Scope to read/write variables
	   * @return {*} The result of the expression
	   * @throws {Error}
	   */
	  return typed('compile', {
	    'string': function (expr) {
	      var scope = {};
	      return parse(expr).compile().eval(scope);
	    },
	
	    'string, Object': function (expr, scope) {
	      return parse(expr).compile().eval(scope);
	    },
	
	    'Array | Matrix': function (expr) {
	      var scope = {};
	      return deepMap(expr, function (entry) {
	        return parse(entry).compile().eval(scope);
	      });
	    },
	
	    'Array | Matrix, Object': function (expr, scope) {
	      return deepMap(expr, function (entry) {
	        return parse(entry).compile().eval(scope);
	      });
	    }
	  });
	}
	
	exports.name = 'eval';
	exports.factory = factory;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSafeProperty = __webpack_require__(1624).getSafeProperty;
	
	function factory (type, config, load, typed, math) {
	  var docs = load(__webpack_require__(1417));
	
	  /**
	   * Retrieve help on a function or data type.
	   * Help files are retrieved from the documentation in math.expression.docs.
	   *
	   * Syntax:
	   *
	   *    math.help(search)
	   *
	   * Examples:
	   *
	   *    console.log(math.help('sin').toString());
	   *    console.log(math.help(math.add).toString());
	   *    console.log(math.help(math.add).toJSON());
	   *
	   * @param {Function | string | Object} search   A function or function name
	   *                                              for which to get help
	   * @return {Help} A help object
	   */
	  return typed('help', {
	    'any': function (search) {
	      var prop;
	      var name = search;
	
	      if (typeof search !== 'string') {
	        for (prop in math) {
	          // search in functions and constants
	          if (math.hasOwnProperty(prop) && (search === math[prop])) {
	            name = prop;
	            break;
	          }
	        }
	
	        /* TODO: implement help for data types
	         if (!text) {
	         // search data type
	         for (prop in math.type) {
	         if (math.type.hasOwnProperty(prop)) {
	         if (search === math.type[prop]) {
	         text = prop;
	         break;
	         }
	         }
	         }
	         }
	         */
	      }
	
	      var doc = getSafeProperty(docs, name);
	      if (!doc) {
	        throw new Error('No documentation found on "' + name + '"');
	      }
	      return new type.Help(doc);
	    }
	  });
	}
	
	exports.math = true; // request access to the math namespace as 5th argument of the factory function
	exports.name = 'help';
	exports.factory = factory;


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var parse = load(__webpack_require__(1621));
	
	  /**
	   * Parse an expression. Returns a node tree, which can be evaluated by
	   * invoking node.eval();
	   *
	   * Note the evaluating arbitrary expressions may involve security risks,
	   * see [http://mathjs.org/docs/expressions/security.html](http://mathjs.org/docs/expressions/security.html) for more information.
	   *
	   * Syntax:
	   *
	   *     math.parse(expr)
	   *     math.parse(expr, options)
	   *     math.parse([expr1, expr2, expr3, ...])
	   *     math.parse([expr1, expr2, expr3, ...], options)
	   *
	   * Example:
	   *
	   *     var node = math.parse('sqrt(3^2 + 4^2)');
	   *     node.compile().eval(); // 5
	   *
	   *     var scope = {a:3, b:4}
	   *     var node = math.parse('a * b'); // 12
	   *     var code = node.compile();
	   *     code.eval(scope); // 12
	   *     scope.a = 5;
	   *     code.eval(scope); // 20
	   *
	   *     var nodes = math.parse(['a = 3', 'b = 4', 'a * b']);
	   *     nodes[2].compile().eval(); // 12
	   *
	   * See also:
	   *
	   *     eval, compile
	   *
	   * @param {string | string[] | Matrix} expr          Expression to be parsed
	   * @param {{nodes: Object<string, Node>}} [options]  Available options:
	   *                                                   - `nodes` a set of custom nodes
	   * @return {Node | Node[]} node
	   * @throws {Error}
	   */
	  return typed('parse', {
	    'string | Array | Matrix': parse,
	    'string | Array | Matrix, Object': parse
	  });
	}
	
	exports.name = 'parse';
	exports.factory = factory;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed, math) {
	  var Parser = load(__webpack_require__(1649));
	
	  /**
	   * Create a parser. The function creates a new `math.expression.Parser` object.
	   *
	   * Syntax:
	   *
	   *    math.parser()
	   *
	   * Examples:
	   *
	   *     var parser = new math.parser();
	   *
	   *     // evaluate expressions
	   *     var a = parser.eval('sqrt(3^2 + 4^2)'); // 5
	   *     var b = parser.eval('sqrt(-4)');        // 2i
	   *     var c = parser.eval('2 inch in cm');    // 5.08 cm
	   *     var d = parser.eval('cos(45 deg)');     // 0.7071067811865476
	   *
	   *     // define variables and functions
	   *     parser.eval('x = 7 / 2');               // 3.5
	   *     parser.eval('x + 3');                   // 6.5
	   *     parser.eval('function f(x, y) = x^y');  // f(x, y)
	   *     parser.eval('f(2, 3)');                 // 8
	   *
	   *     // get and set variables and functions
	   *     var x = parser.get('x');                // 7
	   *     var f = parser.get('f');                // function
	   *     var g = f(3, 2);                        // 9
	   *     parser.set('h', 500);
	   *     var i = parser.eval('h / 2');           // 250
	   *     parser.set('hello', function (name) {
	   *       return 'hello, ' + name + '!';
	   *     });
	   *     parser.eval('hello("user")');           // "hello, user!"
	   *
	   *     // clear defined functions and variables
	   *     parser.clear();
	   *
	   * See also:
	   *
	   *    eval, compile, parse
	   *
	   * @return {Parser} Parser
	   */
	  return typed('parser', {
	    '': function () {
	      return new Parser(math);
	    }
	  });
	}
	
	exports.name = 'parser';
	exports.factory = factory;
	exports.math = true; // requires the math namespace as 5th argument


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(1320).extend;
	var customs = __webpack_require__(1624);
	
	function factory (type, config, load, typed, math) {
	  var _parse = load(__webpack_require__(1621));
	
	  /**
	   * @constructor Parser
	   * Parser contains methods to evaluate or parse expressions, and has a number
	   * of convenience methods to get, set, and remove variables from memory. Parser
	   * keeps a scope containing variables in memory, which is used for all
	   * evaluations.
	   *
	   * Methods:
	   *    var result = parser.eval(expr);    // evaluate an expression
	   *    var value = parser.get(name);      // retrieve a variable from the parser
	   *    var values = parser.getAll();      // retrieve all defined variables
	   *    parser.set(name, value);           // set a variable in the parser
	   *    parser.remove(name);               // clear a variable from the
	   *                                       // parsers scope
	   *    parser.clear();                    // clear the parsers scope
	   *
	   * Example usage:
	   *    var parser = new Parser();
	   *    // Note: there is a convenience method which can be used instead:
	   *    // var parser = new math.parser();
	   *
	   *    // evaluate expressions
	   *    parser.eval('sqrt(3^2 + 4^2)');         // 5
	   *    parser.eval('sqrt(-4)');                // 2i
	   *    parser.eval('2 inch in cm');            // 5.08 cm
	   *    parser.eval('cos(45 deg)');             // 0.7071067811865476
	   *
	   *    // define variables and functions
	   *    parser.eval('x = 7 / 2');               // 3.5
	   *    parser.eval('x + 3');                   // 6.5
	   *    parser.eval('function f(x, y) = x^y');  // f(x, y)
	   *    parser.eval('f(2, 3)');                 // 8
	   *
	   *    // get and set variables and functions
	   *    var x = parser.get('x');                // 7
	   *    var f = parser.get('f');                // function
	   *    var g = f(3, 2);                        // 9
	   *    parser.set('h', 500);
	   *    var i = parser.eval('h / 2');           // 250
	   *    parser.set('hello', function (name) {
	   *        return 'hello, ' + name + '!';
	   *    });
	   *    parser.eval('hello("user")');           // "hello, user!"
	   *
	   *    // clear defined functions and variables
	   *    parser.clear();
	   *
	   */
	  function Parser() {
	    if (!(this instanceof Parser)) {
	      throw new SyntaxError(
	          'Constructor must be called with the new operator');
	    }
	    this.scope = {};
	  }
	
	  /**
	   * Attach type information
	   */
	  Parser.prototype.type = 'Parser';
	  Parser.prototype.isParser = true;
	
	  /**
	   * Parse an expression and return the parsed function node.
	   * The node tree can be compiled via `code = node.compile(math)`,
	   * and the compiled code can be executed as `code.eval([scope])`
	   * @param {string} expr
	   * @return {Node} node
	   * @throws {Error}
	   */
	  Parser.prototype.parse = function (expr) {
	    throw new Error('Parser.parse is deprecated. Use math.parse instead.');
	  };
	
	  /**
	   * Parse and compile an expression, return the compiled javascript code.
	   * The node can be evaluated via code.eval([scope])
	   * @param {string} expr
	   * @return {{eval: function}} code
	   * @throws {Error}
	   */
	  Parser.prototype.compile = function (expr) {
	    throw new Error('Parser.compile is deprecated. Use math.compile instead.');
	  };
	
	  /**
	   * Parse and evaluate the given expression
	   * @param {string} expr   A string containing an expression, for example "2+3"
	   * @return {*} result     The result, or undefined when the expression was empty
	   * @throws {Error}
	   */
	  Parser.prototype.eval = function (expr) {
	    // TODO: validate arguments
	    return _parse(expr)
	        .compile()
	        .eval(this.scope);
	  };
	
	  /**
	   * Get a variable (a function or variable) by name from the parsers scope.
	   * Returns undefined when not found
	   * @param {string} name
	   * @return {* | undefined} value
	   */
	  Parser.prototype.get = function (name) {
	    // TODO: validate arguments
	    return name in this.scope
	        ? customs.getSafeProperty(this.scope, name)
	        : undefined;
	  };
	
	  /**
	   * Get a map with all defined variables
	   * @return {Object} values
	   */
	  Parser.prototype.getAll = function () {
	    return extend({}, this.scope);
	  };
	
	  /**
	   * Set a symbol (a function or variable) by name from the parsers scope.
	   * @param {string} name
	   * @param {* | undefined} value
	   */
	  Parser.prototype.set = function (name, value) {
	    // TODO: validate arguments
	    return customs.setSafeProperty(this.scope, name, value);
	  };
	
	  /**
	   * Remove a variable from the parsers scope
	   * @param {string} name
	   */
	  Parser.prototype.remove = function (name) {
	    // TODO: validate arguments
	    delete this.scope[name];
	  };
	
	  /**
	   * Clear the scope with variables and functions
	   */
	  Parser.prototype.clear = function () {
	    for (var name in this.scope) {
	      if (this.scope.hasOwnProperty(name)) {
	        delete this.scope[name];
	      }
	    }
	  };
	
	  return Parser;
	}
	
	exports.name = 'Parser';
	exports.path = 'expression';
	exports.factory = factory;
	exports.math = true; // requires the math namespace as 5th argument


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1623),
	  __webpack_require__(1631),
	  __webpack_require__(1632),
	  __webpack_require__(1635),
	  __webpack_require__(1636),
	  __webpack_require__(1637),
	  __webpack_require__(1627),
	  __webpack_require__(1638),
	  __webpack_require__(1642),
	  __webpack_require__(1625),
	  __webpack_require__(1639),
	  __webpack_require__(1640),
	  __webpack_require__(1641),
	  __webpack_require__(1644),
	  __webpack_require__(1643),
	  __webpack_require__(1651)
	];


/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  /**
	   * @constructor UpdateNode
	   */
	  function UpdateNode() {
	    // TODO: deprecated since v3. Cleanup some day
	    throw new Error('UpdateNode is deprecated. Use AssignmentNode instead.');
	  }
	
	  return UpdateNode;
	}
	
	exports.name = 'UpdateNode';
	exports.path = 'expression.node';
	exports.factory = factory;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1653),
	  __webpack_require__(1655),
	  __webpack_require__(1657),
	  __webpack_require__(1658),
	  __webpack_require__(1659),
	  __webpack_require__(1660),
	  __webpack_require__(1667),
	  __webpack_require__(1673),
	  __webpack_require__(1675),
	  __webpack_require__(1677)
	];


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	
	/**
	 * Attach a transform function to math.range
	 * Adds a property transform containing the transform function.
	 *
	 * This transform changed the last `dim` parameter of function concat
	 * from one-based to zero based
	 */
	function factory (type, config, load, typed) {
	  var concat = load(__webpack_require__(1654));
	
	  // @see: comment of concat itself
	 return typed('concat', {
	    '...any': function (args) {
	      // change last argument from one-based to zero-based
	      var lastIndex = args.length - 1;
	      var last = args[lastIndex];
	      if (type.isNumber(last)) {
	        args[lastIndex] = last - 1;
	      }
	      else if (type.isBigNumber(last)) {
	        args[lastIndex] = last.minus(1);
	      }
	
	      try {
	        return concat.apply(null, args);
	      }
	      catch (err) {
	        throw errorTransform(err);
	      }
	    }
	  });
	}
	
	exports.name = 'concat';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var isInteger = __webpack_require__(1324).isInteger;
	var array = __webpack_require__(1357);
	var IndexError = __webpack_require__(1359);
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Concatenate two or more matrices.
	   *
	   * Syntax:
	   *
	   *     math.concat(A, B, C, ...)
	   *     math.concat(A, B, C, ..., dim)
	   *
	   * Where:
	   *
	   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
	   *   By default the last dimension of the matrices.
	   *
	   * Examples:
	   *
	   *    var A = [[1, 2], [5, 6]];
	   *    var B = [[3, 4], [7, 8]];
	   *
	   *    math.concat(A, B);                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
	   *    math.concat(A, B, 0);               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
	   *    math.concat('hello', ' ', 'world'); // returns 'hello world'
	   *
	   * See also:
	   *
	   *    size, squeeze, subset, transpose
	   *
	   * @param {... Array | Matrix} args     Two or more matrices
	   * @return {Array | Matrix} Concatenated matrix
	   */
	  var concat = typed('concat', {
	    // TODO: change signature to '...Array | Matrix, dim?' when supported
	    '...Array | Matrix | number | BigNumber': function (args) {
	      var i;
	      var len = args.length;
	      var dim = -1;  // zero-based dimension
	      var prevDim;
	      var asMatrix = false;
	      var matrices = [];  // contains multi dimensional arrays
	
	      for (i = 0; i < len; i++) {
	        var arg = args[i];
	
	        // test whether we need to return a Matrix (if not we return an Array)
	        if (type.isMatrix(arg)) {
	          asMatrix = true;
	        }
	
	        if (type.isNumber(arg) || type.isBigNumber(arg)) {
	          if (i !== len - 1) {
	            throw new Error('Dimension must be specified as last argument');
	          }
	
	          // last argument contains the dimension on which to concatenate
	          prevDim = dim;
	          dim = arg.valueOf(); // change BigNumber to number
	
	          if (!isInteger(dim)) {
	            throw new TypeError('Integer number expected for dimension');
	          }
	
	          if (dim < 0 || (i > 0 && dim > prevDim)) {
	            // TODO: would be more clear when throwing a DimensionError here
	            throw new IndexError(dim, prevDim + 1);
	          }
	        }
	        else {
	          // this is a matrix or array
	          var m = clone(arg).valueOf();
	          var size = array.size(m);
	          matrices[i] = m;
	          prevDim = dim;
	          dim = size.length - 1;
	
	          // verify whether each of the matrices has the same number of dimensions
	          if (i > 0 && dim != prevDim) {
	            throw new DimensionError(prevDim + 1, dim + 1);
	          }
	        }
	      }
	
	      if (matrices.length == 0) {
	        throw new SyntaxError('At least one matrix expected');
	      }
	
	      var res = matrices.shift();
	      while (matrices.length) {
	        res = _concat(res, matrices.shift(), dim, 0);
	      }
	
	      return asMatrix ? matrix(res) : res;
	    },
	
	    '...string': function (args) {
	      return args.join('');
	    }
	  });
	
	  concat.toTex = undefined; // use default template
	
	  return concat;
	}
	
	/**
	 * Recursively concatenate two matrices.
	 * The contents of the matrices is not cloned.
	 * @param {Array} a             Multi dimensional array
	 * @param {Array} b             Multi dimensional array
	 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
	 * @param {number} dim          The current dim (zero-based)
	 * @return {Array} c            The concatenated matrix
	 * @private
	 */
	function _concat(a, b, concatDim, dim) {
	  if (dim < concatDim) {
	    // recurse into next dimension
	    if (a.length != b.length) {
	      throw new DimensionError(a.length, b.length);
	    }
	
	    var c = [];
	    for (var i = 0; i < a.length; i++) {
	      c[i] = _concat(a[i], b[i], concatDim, dim + 1);
	    }
	    return c;
	  }
	  else {
	    // concatenate this dimension
	    return a.concat(b);
	  }
	}
	
	exports.name = 'concat';
	exports.factory = factory;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var filter = __webpack_require__(1357).filter;
	var filterRegExp = __webpack_require__(1357).filterRegExp;
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	
	/**
	 * Attach a transform function to math.filter
	 * Adds a property transform containing the transform function.
	 *
	 * This transform adds support for equations as test function for math.filter,
	 * so you can do something like 'filter([3, -2, 5], x > 0)'.
	 */
	function factory (type, config, load, typed) {
	  var compileInlineExpression = load(__webpack_require__(1656));
	  var matrix = load(__webpack_require__(1368));
	
	  function filterTransform(args, math, scope) {
	    var x, callback;
	
	    if (args[0]) {
	      x = args[0].compile().eval(scope);
	    }
	
	    if (args[1]) {
	      if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
	        // a function pointer, like filter([3, -2, 5], myTestFunction);
	        callback = args[1].compile().eval(scope);
	      }
	      else {
	        // an expression like filter([3, -2, 5], x > 0)
	        callback = compileInlineExpression(args[1], math, scope);
	      }
	    }
	
	    return filter(x, callback);
	  }
	  filterTransform.rawArgs = true;
	
	  // one based version of function filter
	  var filter = typed('filter', {
	    'Array, function': _filter,
	
	    'Matrix, function': function (x, test) {
	      return matrix(_filter(x.toArray(), test));
	    },
	
	    'Array, RegExp': filterRegExp,
	
	    'Matrix, RegExp': function (x, test) {
	      return matrix(filterRegExp(x.toArray(), test));
	    }
	  });
	
	  filter.toTex = undefined; // use default template
	
	  return filterTransform;
	}
	
	/**
	 * Filter values in a callback given a callback function
	 *
	 * !!! Passes a one-based index !!!
	 *
	 * @param {Array} x
	 * @param {Function} callback
	 * @return {Array} Returns the filtered array
	 * @private
	 */
	function _filter (x, callback) {
	  // figure out what number of arguments the callback function expects
	  var args = maxArgumentCount(callback);
	
	  return filter(x, function (value, index, array) {
	    // invoke the callback function with the right number of arguments
	    if (args === 1) {
	      return callback(value);
	    }
	    else if (args === 2) {
	      return callback(value, [index + 1]);
	    }
	    else { // 3 or -1
	      return callback(value, [index + 1], array);
	    }
	  });
	}
	
	exports.name = 'filter';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	'use strict';
	function factory (type, config, load, typed) {
	  /**
	   * Compile an inline expression like "x > 0"
	   * @param {Node} expression
	   * @param {Object} math
	   * @param {Object} scope
	   * @return {function} Returns a function with one argument which fills in the
	   *                    undefined variable (like "x") and evaluates the expression
	   */
	  return function compileInlineExpression(expression, math, scope) {
	    // find an undefined symbol
	    var symbol = expression.filter(function (node) {
	      return type.isSymbolNode(node) &&
	          !(node.name in math) &&
	          !(node.name in scope);
	    })[0];
	
	    if (!symbol) {
	      throw new Error('No undefined variable found in inline expression "' + expression + '"');
	    }
	
	    // create a test function for this equation
	    var name = symbol.name; // variable name
	    var subScope = Object.create(scope);
	    var eq = expression.compile();
	    return function inlineExpression(x) {
	      subScope[name] = x;
	      return eq.eval(subScope);
	    }
	  };
	}
	
	exports.factory = factory;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	var forEach = __webpack_require__(1357).forEach;
	
	/**
	 * Attach a transform function to math.forEach
	 * Adds a property transform containing the transform function.
	 *
	 * This transform creates a one-based index instead of a zero-based index
	 */
	function factory (type, config, load, typed) {
	  var compileInlineExpression = load(__webpack_require__(1656));
	
	  function forEachTransform(args, math, scope) {
	    var x, callback;
	
	    if (args[0]) {
	      x = args[0].compile().eval(scope);
	    }
	
	    if (args[1]) {
	        if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
	        // a function pointer, like forEach([3, -2, 5], myTestFunction);
	        callback = args[1].compile().eval(scope);
	      }
	      else {
	        // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
	        callback = compileInlineExpression(args[1], math, scope);
	      }
	    }
	
	    return _forEach(x, callback);
	  }
	  forEachTransform.rawArgs = true;
	
	  // one-based version of forEach
	  var _forEach = typed('forEach', {
	    'Array | Matrix, function': function (array, callback) {
	      // figure out what number of arguments the callback function expects
	      var args = maxArgumentCount(callback);
	
	      var recurse = function (value, index) {
	        if (Array.isArray(value)) {
	          forEach(value, function (child, i) {
	            // we create a copy of the index array and append the new index value
	            recurse(child, index.concat(i + 1)); // one based index, hence i+1
	          });
	        }
	        else {
	          // invoke the callback function with the right number of arguments
	          if (args === 1) {
	            callback(value);
	          }
	          else if (args === 2) {
	            callback(value, index);
	          }
	          else { // 3 or -1
	            callback(value, index, array);
	          }
	        }
	      };
	      recurse(array.valueOf(), []); // pass Array
	    }
	  });
	
	  return forEachTransform;
	}
	
	exports.name = 'forEach';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Attach a transform function to math.index
	 * Adds a property transform containing the transform function.
	 *
	 * This transform creates a one-based index instead of a zero-based index
	 */
	function factory (type, config, load) {
	
	  return function indexTransform() {
	    var args = [];
	    for (var i = 0, ii = arguments.length; i < ii; i++) {
	      var arg = arguments[i];
	
	      // change from one-based to zero based, and convert BigNumber to number
	      if (type.isRange(arg)) {
	        arg.start--;
	        arg.end -= (arg.step > 0 ? 0 : 2);
	      }
	      else if (arg && arg.isSet === true) {
	        arg = arg.map(function (v) { return v - 1; });
	      }
	      else if (type.isArray(arg) || type.isMatrix(arg)) {
	        arg = arg.map(function (v) { return v - 1; });
	      }
	      else if (type.isNumber(arg)) {
	        arg--;
	      }
	      else if (type.isBigNumber(arg)) {
	        arg = arg.toNumber() - 1;
	      }
	      else if (typeof arg === 'string') {
	        // leave as is
	      }
	      else {
	        throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
	      }
	
	      args[i] = arg;
	    }
	
	    var res = new type.Index();
	    type.Index.apply(res, args);
	    return res;
	  };
	}
	
	exports.name = 'index';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	var map = __webpack_require__(1357).map;
	
	/**
	 * Attach a transform function to math.map
	 * Adds a property transform containing the transform function.
	 *
	 * This transform creates a one-based index instead of a zero-based index
	 */
	function factory (type, config, load, typed) {
	  var compileInlineExpression = load(__webpack_require__(1656));
	  var matrix = load(__webpack_require__(1368));
	
	  function mapTransform(args, math, scope) {
	    var x, callback;
	
	    if (args[0]) {
	      x = args[0].compile().eval(scope);
	    }
	
	    if (args[1]) {
	      if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
	        // a function pointer, like filter([3, -2, 5], myTestFunction);
	        callback = args[1].compile().eval(scope);
	      }
	      else {
	        // an expression like filter([3, -2, 5], x > 0)
	        callback = compileInlineExpression(args[1], math, scope);
	      }
	    }
	
	    return map(x, callback);
	  }
	  mapTransform.rawArgs = true;
	
	  // one-based version of map function
	  var map = typed('map', {
	    'Array, function': function (x, callback) {
	      return _map(x, callback, x);
	    },
	
	    'Matrix, function': function (x, callback) {
	      return matrix(_map(x.valueOf(), callback, x));
	    }
	  });
	
	  return mapTransform;
	}
	
	/**
	 * Map for a multi dimensional array. One-based indexes
	 * @param {Array} array
	 * @param {function} callback
	 * @param {Array} orig
	 * @return {Array}
	 * @private
	 */
	function _map (array, callback, orig) {
	  // figure out what number of arguments the callback function expects
	  var argsCount = maxArgumentCount(callback);
	
	  function recurse(value, index) {
	    if (Array.isArray(value)) {
	      return map(value, function (child, i) {
	        // we create a copy of the index array and append the new index value
	        return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
	      });
	    }
	    else {
	      // invoke the (typed) callback function with the right number of arguments
	      if (argsCount === 1) {
	        return callback(value);
	      }
	      else if (argsCount === 2) {
	        return callback(value, index);
	      }
	      else { // 3 or -1
	        return callback(value, index, orig);
	      }
	    }
	  }
	
	  return recurse(array, []);
	}
	
	exports.name = 'map';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	var isCollection = __webpack_require__(1661);
	
	/**
	 * Attach a transform function to math.max
	 * Adds a property transform containing the transform function.
	 *
	 * This transform changed the last `dim` parameter of function max
	 * from one-based to zero based
	 */
	function factory (type, config, load, typed) {
	  var max = load(__webpack_require__(1662));
	
	  return typed('max', {
	    '...any': function (args) {
	      // change last argument dim from one-based to zero-based
	      if (args.length == 2 && isCollection(args[0])) {
	        var dim = args[1];
	        if (type.isNumber(dim)) {
	          args[1] = dim - 1;
	        }
	        else if (type.isBigNumber(dim)) {
	          args[1] = dim.minus(1);
	        }
	      }
	
	      try {
	        return max.apply(null, args);
	      }
	      catch (err) {
	        throw errorTransform(err);
	      }
	    }
	  });
	}
	
	exports.name = 'max';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isMatrix = __webpack_require__(1325);
	
	/**
	 * Test whether a value is a collection: an Array or Matrix
	 * @param {*} x
	 * @returns {boolean} isCollection
	 */
	module.exports = function isCollection (x) {
	  return Array.isArray(x) || isMatrix(x);
	};


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepForEach = __webpack_require__(1663);
	var reduce = __webpack_require__(1664);
	var containsCollections = __webpack_require__(1665);
	
	function factory (type, config, load, typed) {
	  var larger = load(__webpack_require__(1380));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the maximum value of a matrix or a  list with values.
	   * In case of a multi dimensional array, the maximum of the flattened array
	   * will be calculated. When `dim` is provided, the maximum over the selected
	   * dimension will be calculated. Parameter `dim` is zero-based.
	   *
	   * Syntax:
	   *
	   *     math.max(a, b, c, ...)
	   *     math.max(A)
	   *     math.max(A, dim)
	   *
	   * Examples:
	   *
	   *     math.max(2, 1, 4, 3);                  // returns 4
	   *     math.max([2, 1, 4, 3]);                // returns 4
	   *
	   *     // maximum over a specified dimension (zero-based)
	   *     math.max([[2, 5], [4, 3], [1, 7]], 0); // returns [4, 7]
	   *     math.max([[2, 5], [4, 3]], [1, 7], 1); // returns [5, 4, 7]
	   *
	   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1);    // returns 7.1
	   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1);    // returns -4.5
	   *
	   * See also:
	   *
	   *    mean, median, min, prod, std, sum, var
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The maximum value
	   */
	  var max = typed('max', {
	    // max([a, b, c, d, ...])
	    'Array | Matrix': _max,
	
	    // max([a, b, c, d, ...], dim)
	    'Array | Matrix, number | BigNumber': function (array, dim) {
	      return reduce(array, dim.valueOf(), _largest);
	    },
	
	    // max(a, b, c, d, ...)
	    '...': function (args) {
	      if (containsCollections(args)) {
	        throw new TypeError('Scalar values expected in function max');
	      }
	
	      return _max(args);
	    }
	  });
	
	  max.toTex = '\\max\\left(${args}\\right)';
	
	  return max;
	
	  /**
	   * Return the largest of two values
	   * @param {*} x
	   * @param {*} y
	   * @returns {*} Returns x when x is largest, or y when y is largest
	   * @private
	   */
	  function _largest(x, y) {
	    try {
	      return larger(x, y) ? x : y;
	    }
	    catch (err) {
	      throw improveErrorMessage(err, 'max', y);
	    }
	  }
	
	  /**
	   * Recursively calculate the maximum value in an n-dimensional array
	   * @param {Array} array
	   * @return {number} max
	   * @private
	   */
	  function _max(array) {
	    var max = undefined;
	
	    deepForEach(array, function (value) {
	      try {
	        if (max === undefined || larger(value, max)) {
	          max = value;
	        }
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'max', value);
	      }
	    });
	
	    if (max === undefined) {
	      throw new Error('Cannot calculate max of an empty array');
	    }
	
	    return max;
	  }
	
	}
	
	exports.name = 'max';
	exports.factory = factory;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isMatrix = __webpack_require__(1325);
	
	/**
	 * Recursively loop over all elements in a given multi dimensional array
	 * and invoke the callback on each of the elements.
	 * @param {Array | Matrix} array
	 * @param {Function} callback     The callback method is invoked with one
	 *                                parameter: the current element in the array
	 */
	module.exports = function deepForEach (array, callback) {
	  if (isMatrix(array)) {
	    array = array.valueOf();
	  }
	
	  for (var i = 0, ii = array.length; i < ii; i++) {
	    var value = array[i];
	
	    if (Array.isArray(value)) {
	      deepForEach(value, callback);
	    }
	    else {
	      callback(value);
	    }
	  }
	};


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var arraySize = __webpack_require__(1357).size;
	var isMatrix = __webpack_require__(1325);
	var IndexError = __webpack_require__(1359);
	
	/**
	 * Reduce a given matrix or array to a new matrix or
	 * array with one less dimension, applying the given
	 * callback in the selected dimension.
	 * @param {Array | Matrix} mat
	 * @param {number} dim
	 * @param {Function} callback
	 * @return {Array | Matrix} res
	 */
	module.exports = function(mat, dim, callback) {
	  var size = Array.isArray(mat) ? arraySize(mat) : mat.size();
	  if (dim < 0 || (dim >= size.length)) {
	    // TODO: would be more clear when throwing a DimensionError here
	    throw new IndexError(dim, size.length);
	  }
	
	  if (isMatrix(mat)) {
	    return mat.create(_reduce(mat.valueOf(), dim, callback));
	  }else {
	    return _reduce(mat, dim, callback);
	  }
	};
	
	/**
	 * Recursively reduce a matrix
	 * @param {Array} mat
	 * @param {number} dim
	 * @param {Function} callback
	 * @returns {Array} ret
	 * @private
	 */
	function _reduce(mat, dim, callback){
	  var i, ret, val, tran;
	
	  if(dim<=0){
	    if( !Array.isArray(mat[0]) ){
	      val = mat[0];
	      for(i=1; i<mat.length; i++){
	        val = callback(val, mat[i]);
	      }
	      return val;
	    }else{
	      tran = _switch(mat);
	      ret = [];
	      for(i=0; i<tran.length; i++){
	        ret[i] = _reduce(tran[i], dim-1, callback);
	      }
	      return ret;
	    }
	  }else{
	    ret = [];
	    for(i=0; i<mat.length; i++){
	      ret[i] = _reduce(mat[i], dim-1, callback);
	    }
	    return ret;
	  }
	}
	
	/**
	 * Transpose a matrix
	 * @param {Array} mat
	 * @returns {Array} ret
	 * @private
	 */
	function _switch(mat){
	  var I = mat.length;
	  var J = mat[0].length;
	  var i, j;
	  var ret = [];
	  for( j=0; j<J; j++) {
	    var tmp = [];
	    for( i=0; i<I; i++) {
	      tmp.push(mat[i][j]);
	    }
	    ret.push(tmp);
	  }
	  return ret;
	}


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isCollection = __webpack_require__(1661);
	
	/**
	 * Test whether an array contains collections
	 * @param {Array} array
	 * @returns {boolean} Returns true when the array contains one or multiple
	 *                    collections (Arrays or Matrices). Returns false otherwise.
	 */
	module.exports = function containsCollections (array) {
	  for (var i = 0; i < array.length; i++) {
	    if (isCollection(array[i])) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	function factory (type, config, load, typed) {
	  var getType = load(__webpack_require__(1409));
	
	  /**
	   * Improve error messages for statistics functions. Errors are typically
	   * thrown in an internally used function like larger, causing the error
	   * not to mention the function (like max) which is actually used by the user.
	   *
	   * @param {Error} err
	   * @param {String} fnName
	   * @param {*} [value]
	   * @return {Error}
	   */
	  return function improveErrorMessage(err, fnName, value) {
	    // TODO: add information with the index (also needs transform in expression parser)
	    var details;
	
	    if (String(err).indexOf('Unexpected type') !== -1) {
	      details = arguments.length > 2
	          ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')'
	          : ' (type: ' + err.data.actual + ')';
	
	      return new TypeError('Cannot calculate ' + fnName + ', unexpected type of argument' + details);
	    }
	
	    if (String(err).indexOf('complex numbers') !== -1) {
	      details = arguments.length > 2
	          ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')'
	          : '';
	
	      return new TypeError('Cannot calculate ' + fnName + ', no ordering relation is defined for complex numbers' + details);
	    }
	
	    return err;
	  }
	}
	
	exports.factory = factory;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	var isCollection = __webpack_require__(1661);
	
	/**
	 * Attach a transform function to math.mean
	 * Adds a property transform containing the transform function.
	 *
	 * This transform changed the last `dim` parameter of function mean
	 * from one-based to zero based
	 */
	function factory (type, config, load, typed) {
	  var mean = load(__webpack_require__(1668));
	
	  return typed('mean', {
	    '...any': function (args) {
	      // change last argument dim from one-based to zero-based
	      if (args.length == 2 && isCollection(args[0])) {
	        var dim = args[1];
	        if (type.isNumber(dim)) {
	          args[1] = dim - 1;
	        }
	        else if (type.isBigNumber(dim)) {
	          args[1] = dim.minus(1);
	        }
	      }
	
	      try {
	        return mean.apply(null, args);
	      }
	      catch (err) {
	        throw errorTransform(err);
	      }
	    }
	  });
	}
	
	exports.name = 'mean';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var size = __webpack_require__(1357).size;
	var deepForEach = __webpack_require__(1663);
	var reduce = __webpack_require__(1664);
	var containsCollections = __webpack_require__(1665);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var divide = load(__webpack_require__(1669));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the mean value of matrix or a list with values.
	   * In case of a multi dimensional array, the mean of the flattened array
	   * will be calculated. When `dim` is provided, the maximum over the selected
	   * dimension will be calculated. Parameter `dim` is zero-based.
	   *
	   * Syntax:
	   *
	   *     math.mean(a, b, c, ...)
	   *     math.mean(A)
	   *     math.mean(A, dim)
	   *
	   * Examples:
	   *
	   *     math.mean(2, 1, 4, 3);                     // returns 2.5
	   *     math.mean([1, 2.7, 3.2, 4]);               // returns 2.725
	   *
	   *     math.mean([[2, 5], [6, 3], [1, 7]], 0);    // returns [3, 5]
	   *     math.mean([[2, 5], [6, 3], [1, 7]], 1);    // returns [3.5, 4.5, 4]
	   *
	   * See also:
	   *
	   *     median, min, max, sum, prod, std, var
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The mean of all values
	   */
	  var mean = typed('mean', {
	      // mean([a, b, c, d, ...])
	    'Array | Matrix': _mean,
	
	      // mean([a, b, c, d, ...], dim)
	    'Array | Matrix, number | BigNumber': _nmeanDim,
	
	    // mean(a, b, c, d, ...)
	    '...': function (args) {
	      if (containsCollections(args)) {
	        throw new TypeError('Scalar values expected in function mean');
	      }
	
	      return _mean(args);
	    }
	  });
	
	  mean.toTex = undefined; // use default template
	
	  return mean;
	
	  /**
	   * Calculate the mean value in an n-dimensional array, returning a
	   * n-1 dimensional array
	   * @param {Array} array
	   * @param {number} dim
	   * @return {number} mean
	   * @private
	   */
	  function _nmeanDim(array, dim) {
	    try {
	      var sum = reduce(array, dim, add);
	      var s = Array.isArray(array) ? size(array) : array.size();
	      return divide(sum, s[dim]);
	    }
	    catch (err) {
	      throw improveErrorMessage(err, 'mean');
	    }
	  }
	
	  /**
	   * Recursively calculate the mean value in an n-dimensional array
	   * @param {Array} array
	   * @return {number} mean
	   * @private
	   */
	  function _mean(array) {
	    var sum = 0;
	    var num = 0;
	
	    deepForEach(array, function (value) {
	      try {
	        sum = add(sum, value);
	        num++;
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'mean', value);
	      }
	    });
	
	    if (num === 0) {
	      throw new Error('Cannot calculate mean of an empty array');
	    }
	
	    return divide(sum, num);
	  }
	}
	
	exports.name = 'mean';
	exports.factory = factory;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(1320).extend;
	
	function factory (type, config, load, typed) {
	
	  var divideScalar = load(__webpack_require__(1397));
	  var multiply     = load(__webpack_require__(1400));
	  var inv          = load(__webpack_require__(1670));
	  var matrix       = load(__webpack_require__(1368));
	
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Divide two values, `x / y`.
	   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
	   *
	   * Syntax:
	   *
	   *    math.divide(x, y)
	   *
	   * Examples:
	   *
	   *    math.divide(2, 3);            // returns number 0.6666666666666666
	   *
	   *    var a = math.complex(5, 14);
	   *    var b = math.complex(4, 1);
	   *    math.divide(a, b);            // returns Complex 2 + 3i
	   *
	   *    var c = [[7, -6], [13, -4]];
	   *    var d = [[1, 2], [4, 3]];
	   *    math.divide(c, d);            // returns Array [[-9, 4], [-11, 6]]
	   *
	   *    var e = math.unit('18 km');
	   *    math.divide(e, 4.5);          // returns Unit 4 km
	   *
	   * See also:
	   *
	   *    multiply
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
	   */
	  var divide = typed('divide', extend({
	    // we extend the signatures of divideScalar with signatures dealing with matrices
	
	    'Array | Matrix, Array | Matrix': function (x, y) {
	      // TODO: implement matrix right division using pseudo inverse
	      // http://www.mathworks.nl/help/matlab/ref/mrdivide.html
	      // http://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
	      // http://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
	      return multiply(x, inv(y));
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, divideScalar, false);
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, divideScalar, false);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, divideScalar, false).valueOf();
	    },
	
	    'any, Array | Matrix': function (x, y) {
	      return multiply(x, inv(y));
	    }
	  }, divideScalar.signatures));
	
	  divide.toTex = {2: '\\frac{${args[0]}}{${args[1]}}'};
	
	  return divide;
	}
	
	exports.name = 'divide';
	exports.factory = factory;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	function factory (type, config, load, typed) {
	  var matrix       = load(__webpack_require__(1368));
	  var divideScalar = load(__webpack_require__(1397));
	  var addScalar    = load(__webpack_require__(1369));
	  var multiply     = load(__webpack_require__(1400));
	  var unaryMinus   = load(__webpack_require__(1394));
	  var det          = load(__webpack_require__(1671));
	  var eye          = load(__webpack_require__(1399));
	  var abs          = load(__webpack_require__(1402));
	
	  /**
	   * Calculate the inverse of a square matrix.
	   *
	   * Syntax:
	   *
	   *     math.inv(x)
	   *
	   * Examples:
	   *
	   *     math.inv([[1, 2], [3, 4]]);  // returns [[-2, 1], [1.5, -0.5]]
	   *     math.inv(4);                 // returns 0.25
	   *     1 / 4;                       // returns 0.25
	   *
	   * See also:
	   *
	   *     det, transpose
	   *
	   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
	   * @return {number | Complex | Array | Matrix} The inverse of `x`.
	   */
	  var inv = typed('inv', {
	    'Array | Matrix': function (x) {
	      var size = type.isMatrix(x) ? x.size() : util.array.size(x);
	      switch (size.length) {
	        case 1:
	          // vector
	          if (size[0] == 1) {
	            if (type.isMatrix(x)) {
	              return matrix([
	                divideScalar(1, x.valueOf()[0])
	              ]);
	            }
	            else {
	              return [
	                divideScalar(1, x[0])
	              ];
	            }
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + util.string.format(size) + ')');
	          }
	
	        case 2:
	          // two dimensional array
	          var rows = size[0];
	          var cols = size[1];
	          if (rows == cols) {
	            if (type.isMatrix(x)) {
	              return matrix(
	                  _inv(x.valueOf(), rows, cols),
	                  x.storage()
	              );
	            }
	            else {
	              // return an Array
	              return _inv(x, rows, cols);
	            }
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + util.string.format(size) + ')');
	          }
	
	        default:
	          // multi dimensional array
	          throw new RangeError('Matrix must be two dimensional ' +
	          '(size: ' + util.string.format(size) + ')');
	      }
	    },
	
	    'any': function (x) {
	      // scalar
	      return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
	    }
	  });
	
	  /**
	   * Calculate the inverse of a square matrix
	   * @param {Array[]} mat     A square matrix
	   * @param {number} rows     Number of rows
	   * @param {number} cols     Number of columns, must equal rows
	   * @return {Array[]} inv    Inverse matrix
	   * @private
	   */
	  function _inv (mat, rows, cols){
	    var r, s, f, value, temp;
	
	    if (rows == 1) {
	      // this is a 1 x 1 matrix
	      value = mat[0][0];
	      if (value == 0) {
	        throw Error('Cannot calculate inverse, determinant is zero');
	      }
	      return [[
	        divideScalar(1, value)
	      ]];
	    }
	    else if (rows == 2) {
	      // this is a 2 x 2 matrix
	      var d = det(mat);
	      if (d == 0) {
	        throw Error('Cannot calculate inverse, determinant is zero');
	      }
	      return [
	        [
	          divideScalar(mat[1][1], d),
	          divideScalar(unaryMinus(mat[0][1]), d)
	        ],
	        [
	          divideScalar(unaryMinus(mat[1][0]), d),
	          divideScalar(mat[0][0], d)
	        ]
	      ];
	    }
	    else {
	      // this is a matrix of 3 x 3 or larger
	      // calculate inverse using gauss-jordan elimination
	      //      http://en.wikipedia.org/wiki/Gaussian_elimination
	      //      http://mathworld.wolfram.com/MatrixInverse.html
	      //      http://math.uww.edu/~mcfarlat/inverse.htm
	
	      // make a copy of the matrix (only the arrays, not of the elements)
	      var A = mat.concat();
	      for (r = 0; r < rows; r++) {
	        A[r] = A[r].concat();
	      }
	
	      // create an identity matrix which in the end will contain the
	      // matrix inverse
	      var B = eye(rows).valueOf();
	
	      // loop over all columns, and perform row reductions
	      for (var c = 0; c < cols; c++) {
	        // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
	        var A_big = abs(A[c][c]);
	        var r_big = c;
	        r = c+1;
	        while (r < rows) {
	          if(abs(A[r][c]) > A_big) {
	            A_big = abs(A[r][c]);
	            r_big = r;
	          }
	          r++;
	        }
	        if(A_big == 0) {
	          throw Error('Cannot calculate inverse, determinant is zero');
	        }
	        r = r_big;
	        if (r != c) {
	          temp = A[c]; A[c] = A[r]; A[r] = temp;
	          temp = B[c]; B[c] = B[r]; B[r] = temp;
	        }
	
	        // eliminate non-zero values on the other rows at column c
	        var Ac = A[c],
	            Bc = B[c];
	        for (r = 0; r < rows; r++) {
	          var Ar = A[r],
	              Br = B[r];
	          if(r != c) {
	            // eliminate value at column c and row r
	            if (Ar[c] != 0) {
	              f = divideScalar(unaryMinus(Ar[c]), Ac[c]);
	
	              // add (f * row c) to row r to eliminate the value
	              // at column c
	              for (s = c; s < cols; s++) {
	                Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
	              }
	              for (s = 0; s < cols; s++) {
	                Br[s] = addScalar(Br[s],  multiply(f, Bc[s]));
	              }
	            }
	          }
	          else {
	            // normalize value at Acc to 1,
	            // divide each value on row r with the value at Acc
	            f = Ac[c];
	            for (s = c; s < cols; s++) {
	              Ar[s] = divideScalar(Ar[s], f);
	            }
	            for (s = 0; s < cols; s++) {
	              Br[s] = divideScalar(Br[s], f);
	            }
	          }
	        }
	      }
	      return B;
	    }
	  }
	
	  inv.toTex = {1: '\\left(${args[0]}\\right)^{-1}'};
	
	  return inv;
	}
	
	exports.name = 'inv';
	exports.factory = factory;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	var object = util.object;
	var string = util.string;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  var add = load(__webpack_require__(1367));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1400));
	  var unaryMinus = load(__webpack_require__(1394));
	  var lup = load(__webpack_require__(1672));
	
	  /**
	   * Calculate the determinant of a matrix.
	   *
	   * Syntax:
	   *
	   *    math.det(x)
	   *
	   * Examples:
	   *
	   *    math.det([[1, 2], [3, 4]]); // returns -2
	   *
	   *    var A = [
	   *      [-2, 2, 3],
	   *      [-1, 1, 3],
	   *      [2, 0, -1]
	   *    ]
	   *    math.det(A); // returns 6
	   *
	   * See also:
	   *
	   *    inv
	   *
	   * @param {Array | Matrix} x  A matrix
	   * @return {number} The determinant of `x`
	   */
	  var det = typed('det', {
	    'any': function (x) {
	      return object.clone(x);
	    },
	
	    'Array | Matrix': function det (x) {
	      var size;
	      if (type.isMatrix(x)) {
	        size = x.size();
	      }
	      else if (Array.isArray(x)) {
	        x = matrix(x);
	        size = x.size();
	      }
	      else {
	        // a scalar
	        size = [];
	      }
	
	      switch (size.length) {
	        case 0:
	          // scalar
	          return object.clone(x);
	
	        case 1:
	          // vector
	          if (size[0] == 1) {
	            return object.clone(x.valueOf()[0]);
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + string.format(size) + ')');
	          }
	
	        case 2:
	          // two dimensional array
	          var rows = size[0];
	          var cols = size[1];
	          if (rows == cols) {
	            return _det(x.clone().valueOf(), rows, cols);
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + string.format(size) + ')');
	          }
	
	        default:
	          // multi dimensional array
	          throw new RangeError('Matrix must be two dimensional ' +
	          '(size: ' + string.format(size) + ')');
	      }
	    }
	  });
	
	  det.toTex = {1: '\\det\\left(${args[0]}\\right)'};
	
	  return det;
	
	  /**
	   * Calculate the determinant of a matrix
	   * @param {Array[]} matrix  A square, two dimensional matrix
	   * @param {number} rows     Number of rows of the matrix (zero-based)
	   * @param {number} cols     Number of columns of the matrix (zero-based)
	   * @returns {number} det
	   * @private
	   */
	  function _det (matrix, rows, cols) {
	    if (rows == 1) {
	      // this is a 1 x 1 matrix
	      return object.clone(matrix[0][0]);
	    }
	    else if (rows == 2) {
	      // this is a 2 x 2 matrix
	      // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
	      return subtract(
	          multiply(matrix[0][0], matrix[1][1]),
	          multiply(matrix[1][0], matrix[0][1])
	      );
	    }
	    else {
	
	      // Compute the LU decomposition
	      var decomp = lup(matrix);
	
	      // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)
	      var det = decomp.U[0][0];
	      for(var i=1; i<rows; i++) {
	        det = multiply(det, decomp.U[i][i]);
	      }
	
	      // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
	      // This can be determined by counting the cycles. This is roughly a linear time algorithm.
	      var evenCycles=0;
	      var i=0;
	      var visited=[];
	      while(true) {
	        while(visited[i]) {
	         i++;
	        }
	        if(i >= rows) break;
	        var j=i;
	        var cycleLen = 0;
	        while(!visited[decomp.p[j]]) {
	          visited[decomp.p[j]] = true;
	          j = decomp.p[j];
	          cycleLen++;
	        }
	        if(cycleLen % 2 === 0) {
	          evenCycles++;
	        }
	      }
	
	      return evenCycles % 2 === 0 ? det : unaryMinus(det);
	
	    }
	  }
	}
	
	exports.name = 'det';
	exports.factory = factory;
	


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	var object = util.object;
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var abs = load(__webpack_require__(1402));
	  var addScalar = load(__webpack_require__(1369));
	  var divideScalar = load(__webpack_require__(1397));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var subtract = load(__webpack_require__(1393));
	  var larger = load(__webpack_require__(1380));
	  var equalScalar = load(__webpack_require__(1364));
	  var unaryMinus = load(__webpack_require__(1394));
	  
	  var SparseMatrix = type.SparseMatrix;
	  var DenseMatrix = type.DenseMatrix;
	  var Spa = type.Spa;
	  
	  /**
	   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
	   * row permutation vector `p` where `A[p,:] = L * U`
	   *
	   * Syntax:
	   *
	   *    math.lup(A);
	   *
	   * Example:
	   *
	   *    var m = [[2, 1], [1, 4]];
	   *    var r = math.lup(m);
	   *    // r = {
	   *    //   L: [[1, 0], [0.5, 1]],
	   *    //   U: [[2, 1], [0, 3.5]],
	   *    //   P: [0, 1]
	   *    // }
	   *
	   * See also:
	   *
	   *    slu, lsolve, lusolve, usolve
	   *
	   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
	   *
	   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
	   */
	  var lup = typed('lup', {
	
	    'DenseMatrix': function (m) {
	      return _denseLUP(m);
	    },
	    
	    'SparseMatrix': function (m) {
	      return _sparseLUP(m);
	    },
	
	    'Array': function (a) {
	      // create dense matrix from array
	      var m = matrix(a);
	      // lup, use matrix implementation
	      var r = _denseLUP(m);
	      // result
	      return {
	        L: r.L.valueOf(),
	        U: r.U.valueOf(),
	        p: r.p
	      };
	    }
	  });
	
	  var _denseLUP = function (m) {
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // minimum rows and columns
	    var n = Math.min(rows, columns);
	    // matrix array, clone original data
	    var data = object.clone(m._data);
	    // l matrix arrays
	    var ldata = [];
	    var lsize = [rows, n];
	    // u matrix arrays
	    var udata = [];
	    var usize = [n, columns];
	    // vars
	    var i, j, k;
	    // permutation vector    
	    var p = [];
	    for (i = 0; i < rows; i++)
	      p[i] = i;    
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // skip first column in upper triangular matrix
	      if (j > 0) {
	        // loop rows
	        for (i = 0; i < rows; i++) {
	          // min i,j
	          var min = Math.min(i, j);
	          // v[i, j]
	          var s = 0;
	          // loop up to min
	          for (k = 0; k < min; k++) {
	            // s = l[i, k] - data[k, j]
	            s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
	          }
	          data[i][j] = subtract(data[i][j], s);
	        }
	      }      
	      // row with larger value in cvector, row >= j
	      var pi = j;
	      var pabsv = 0;
	      var vjj = 0;
	      // loop rows
	      for (i = j; i < rows; i++) {
	        // data @ i, j
	        var v = data[i][j];
	        // absolute value
	        var absv = abs(v);
	        // value is greater than pivote value
	        if (larger(absv, pabsv)) {
	          // store row
	          pi = i;
	          // update max value
	          pabsv = absv;
	          // value @ [j, j]
	          vjj = v;
	        }
	      }
	      // swap rows (j <-> pi)
	      if (j !== pi) {
	        // swap values j <-> pi in p
	        p[j] = [p[pi], p[pi] = p[j]][0];
	        // swap j <-> pi in data
	        DenseMatrix._swapRows(j, pi, data);
	      }
	      // check column is in lower triangular matrix
	      if (j < rows) {
	        // loop rows (lower triangular matrix)
	        for (i = j + 1; i < rows; i++) {
	          // value @ i, j
	          var vij = data[i][j];
	          if (!equalScalar(vij, 0)) {
	            // update data
	            data[i][j] = divideScalar(data[i][j], vjj);
	          }
	        }
	      }
	    }
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // loop rows
	      for (i = 0; i < rows; i++) {
	        // initialize row in arrays
	        if (j === 0) {
	          // check row exists in upper triangular matrix
	          if (i < columns) {
	            // U
	            udata[i] = [];
	          }
	          // L
	          ldata[i] = [];
	        }
	        // check we are in the upper triangular matrix
	        if (i < j) {
	          // check row exists in upper triangular matrix
	          if (i < columns) {
	            // U
	            udata[i][j] = data[i][j];
	          }
	          // check column exists in lower triangular matrix
	          if (j < rows) {
	            // L
	            ldata[i][j] = 0;
	          }
	          continue;
	        }
	        // diagonal value
	        if (i === j) {
	          // check row exists in upper triangular matrix
	          if (i < columns) {
	            // U
	            udata[i][j] = data[i][j];
	          }
	          // check column exists in lower triangular matrix
	          if (j < rows) {
	            // L
	            ldata[i][j] = 1;
	          }
	          continue;
	        }
	        // check row exists in upper triangular matrix
	        if (i < columns) {
	          // U
	          udata[i][j] = 0;
	        }
	        // check column exists in lower triangular matrix
	        if (j < rows) {
	          // L
	          ldata[i][j] = data[i][j];
	        }
	      }
	    }
	    // l matrix
	    var l =  new DenseMatrix({
	      data: ldata,
	      size: lsize
	    });
	    // u matrix
	    var u =  new DenseMatrix({
	      data: udata,
	      size: usize
	    });
	    // p vector
	    var pv = [];
	    for (i = 0, n = p.length; i < n; i++)
	      pv[p[i]] = i;
	    // return matrices
	    return { 
	      L: l, 
	      U: u, 
	      p: pv, 
	      toString: function () {
	        return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
	      }
	    };
	  };
	  
	  var _sparseLUP = function (m) {
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // minimum rows and columns
	    var n = Math.min(rows, columns);
	    // matrix arrays (will not be modified, thanks to permutation vector)
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    // l matrix arrays
	    var lvalues = [];
	    var lindex = [];
	    var lptr = [];
	    var lsize = [rows, n];
	    // u matrix arrays
	    var uvalues = [];
	    var uindex = [];
	    var uptr = [];
	    var usize = [n, columns];
	    // vars
	    var i, j, k;
	    // permutation vectors, (current index -> original index) and (original index -> current index)
	    var pv_co = [];
	    var pv_oc = [];
	    for (i = 0; i < rows; i++) {
	      pv_co[i] = i;
	      pv_oc[i] = i;
	    }
	    // swap indices in permutation vectors (condition x < y)!
	    var swapIndeces = function (x, y) {      
	      // find pv indeces getting data from x and y
	      var kx = pv_oc[x];
	      var ky = pv_oc[y];
	      // update permutation vector current -> original
	      pv_co[kx] = y;
	      pv_co[ky] = x;
	      // update permutation vector original -> current
	      pv_oc[x] = ky;
	      pv_oc[y] = kx;
	    };
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // sparse accumulator
	      var spa = new Spa();            
	      // check lower triangular matrix has a value @ column j
	      if (j < rows) {
	        // update ptr
	        lptr.push(lvalues.length);
	        // first value in j column for lower triangular matrix
	        lvalues.push(1);
	        lindex.push(j);
	      }
	      // update ptr
	      uptr.push(uvalues.length);
	      // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	      var k0 = ptr[j];
	      var k1 = ptr[j + 1];
	      // copy column j into sparse accumulator
	      for (k = k0; k < k1; k++) {
	        // row
	        i = index[k];
	        // copy column values into sparse accumulator (use permutation vector)
	        spa.set(pv_co[i], values[k]);
	      }
	      // skip first column in upper triangular matrix
	      if (j > 0) {
	        // loop rows in column j (above diagonal)
	        spa.forEach(0, j - 1, function (k, vkj) {
	          // loop rows in column k (L)
	          SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function (i, vik) {
	            // check row is below k
	            if (i > k) {
	              // update spa value
	              spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
	            }
	          });
	        });        
	      }
	      // row with larger value in spa, row >= j
	      var pi = j;
	      var vjj = spa.get(j);
	      var pabsv = abs(vjj);      
	      // loop values in spa (order by row, below diagonal)
	      spa.forEach(j + 1, rows - 1, function (x, v) {
	        // absolute value
	        var absv = abs(v);
	        // value is greater than pivote value
	        if (larger(absv, pabsv)) {
	          // store row
	          pi = x;
	          // update max value
	          pabsv = absv;
	          // value @ [j, j]
	          vjj = v;
	        }
	      });
	      // swap rows (j <-> pi)
	      if (j !== pi) {
	        // swap values j <-> pi in L
	        SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr);
	        // swap values j <-> pi in U
	        SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr);
	        // swap values in spa
	        spa.swap(j, pi);
	        // update permutation vector (swap values @ j, pi)
	        swapIndeces(j, pi);
	      }
	      // loop values in spa (order by row)
	      spa.forEach(0, rows - 1, function (x, v) {
	        // check we are above diagonal
	        if (x <= j) {
	          // update upper triangular matrix
	          uvalues.push(v);
	          uindex.push(x);
	        }
	        else {
	          // update value
	          v = divideScalar(v, vjj);
	          // check value is non zero
	          if (!equalScalar(v, 0)) {
	            // update lower triangular matrix
	            lvalues.push(v);
	            lindex.push(x);
	          }
	        }
	      });
	    }
	    // update ptrs
	    uptr.push(uvalues.length);
	    lptr.push(lvalues.length);
	
	    // return matrices
	    return {
	      L: new SparseMatrix({
	        values: lvalues,
	        index: lindex,
	        ptr: lptr,
	        size: lsize
	      }), 
	      U: new SparseMatrix({
	        values: uvalues,
	        index: uindex,
	        ptr: uptr,
	        size: usize
	      }),
	      p: pv_co,
	      toString: function () {
	        return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
	      }
	    };
	  };
	  
	  return lup;
	}
	
	exports.name = 'lup';
	exports.factory = factory;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	var isCollection = __webpack_require__(1661);
	
	/**
	 * Attach a transform function to math.min
	 * Adds a property transform containing the transform function.
	 *
	 * This transform changed the last `dim` parameter of function min
	 * from one-based to zero based
	 */
	function factory (type, config, load, typed) {
	  var min = load(__webpack_require__(1674));
	
	  return typed('min', {
	    '...any': function (args) {
	      // change last argument dim from one-based to zero-based
	      if (args.length == 2 && isCollection(args[0])) {
	        var dim = args[1];
	        if (type.isNumber(dim)) {
	          args[1] = dim - 1;
	        }
	        else if (type.isBigNumber(dim)) {
	          args[1] = dim.minus(1);
	        }
	      }
	
	      try {
	        return min.apply(null, args);
	      }
	      catch (err) {
	        throw errorTransform(err);
	      }
	    }
	  });
	}
	
	exports.name = 'min';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepForEach = __webpack_require__(1663);
	var reduce = __webpack_require__(1664);
	var containsCollections = __webpack_require__(1665);
	
	function factory (type, config, load, typed) {
	  var smaller = load(__webpack_require__(1376));
	  var improveErrorMessage = load(__webpack_require__(1666));
	  
	  /**
	   * Compute the maximum value of a matrix or a  list of values.
	   * In case of a multi dimensional array, the maximum of the flattened array
	   * will be calculated. When `dim` is provided, the maximum over the selected
	   * dimension will be calculated. Parameter `dim` is zero-based.
	   *
	   * Syntax:
	   *
	   *     math.min(a, b, c, ...)
	   *     math.min(A)
	   *     math.min(A, dim)
	   *
	   * Examples:
	   *
	   *     math.min(2, 1, 4, 3);                  // returns 1
	   *     math.min([2, 1, 4, 3]);                // returns 1
	   *
	   *     // maximum over a specified dimension (zero-based)
	   *     math.min([[2, 5], [4, 3], [1, 7]], 0); // returns [1, 3]
	   *     math.min([[2, 5], [4, 3], [1, 7]], 1); // returns [2, 3, 1]
	   *
	   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1);    // returns 7.1
	   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1);    // returns -4.5
	   *
	   * See also:
	   *
	   *    mean, median, max, prod, std, sum, var
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The minimum value
	   */
	  var min = typed('min', {
	    // min([a, b, c, d, ...])
	    'Array | Matrix': _min,
	
	    // min([a, b, c, d, ...], dim)
	    'Array | Matrix, number | BigNumber': function (array, dim) {
	      return reduce(array, dim.valueOf(), _smallest);
	    },
	
	    // min(a, b, c, d, ...)
	    '...': function (args) {
	      if (containsCollections(args)) {
	        throw new TypeError('Scalar values expected in function min');
	      }
	
	      return _min(args);
	    }
	  });
	
	  min.toTex = '\\min\\left(${args}\\right)';
	
	  return min;
	
	  /**
	   * Return the smallest of two values
	   * @param {*} x
	   * @param {*} y
	   * @returns {*} Returns x when x is smallest, or y when y is smallest
	   * @private
	   */
	  function _smallest(x, y) {
	    try {
	      return smaller(x, y) ? x : y;
	    }
	    catch (err) {
	      throw improveErrorMessage(err, 'min', y);
	    }
	  }
	
	  /**
	   * Recursively calculate the minimum value in an n-dimensional array
	   * @param {Array} array
	   * @return {number} min
	   * @private
	   */
	  function _min(array) {
	    var min = undefined;
	
	    deepForEach(array, function (value) {
	      try {
	        if (min === undefined || smaller(value, min)) {
	          min = value;
	        }
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'min', value);
	      }
	    });
	
	    if (min === undefined) {
	      throw new Error('Cannot calculate min of an empty array');
	    }
	
	    return min;
	  }
	}
	
	exports.name = 'min';
	exports.factory = factory;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Attach a transform function to math.range
	 * Adds a property transform containing the transform function.
	 *
	 * This transform creates a range which includes the end value
	 */
	function factory (type, config, load, typed) {
	  var range = load(__webpack_require__(1676));
	
	  return typed('range', {
	    '...any': function (args) {
	      var lastIndex = args.length - 1;
	      var last = args[lastIndex];
	      if (typeof last !== 'boolean') {
	        // append a parameter includeEnd=true
	        args.push(true);
	      }
	
	      return range.apply(null, args);
	    }
	  });
	}
	
	exports.name = 'range';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  var ZERO = new type.BigNumber(0);
	  var ONE = new type.BigNumber(1);
	
	  /**
	   * Create an array from a range.
	   * By default, the range end is excluded. This can be customized by providing
	   * an extra parameter `includeEnd`.
	   *
	   * Syntax:
	   *
	   *     math.range(str [, includeEnd])               // Create a range from a string,
	   *                                                  // where the string contains the
	   *                                                  // start, optional step, and end,
	   *                                                  // separated by a colon.
	   *     math.range(start, end [, includeEnd])        // Create a range with start and
	   *                                                  // end and a step size of 1.
	   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
	   *                                                  // and end.
	   *
	   * Where:
	   *
	   * - `str: string`
	   *   A string 'start:end' or 'start:step:end'
	   * - `start: {number | BigNumber}`
	   *   Start of the range
	   * - `end: number | BigNumber`
	   *   End of the range, excluded by default, included when parameter includeEnd=true
	   * - `step: number | BigNumber`
	   *   Step size. Default value is 1.
	   * - `includeEnd: boolean`
	   *   Option to specify whether to include the end or not. False by default.
	   *
	   * Examples:
	   *
	   *     math.range(2, 6);        // [2, 3, 4, 5]
	   *     math.range(2, -3, -1);   // [2, 1, 0, -1, -2]
	   *     math.range('2:1:6');     // [2, 3, 4, 5]
	   *     math.range(2, 6, true);  // [2, 3, 4, 5, 6]
	   *
	   * See also:
	   *
	   *     ones, zeros, size, subset
	   *
	   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
	   * @return {Array | Matrix} range
	   */
	  var range = typed('range', {
	    // TODO: simplify signatures when typed-function supports default values and optional arguments
	
	    // TODO: a number or boolean should not be converted to string here
	    'string': _strRange,
	    'string, boolean': _strRange,
	
	    'number, number':  function (start, end) {
	      return _out(_rangeEx(start, end, 1));
	    },
	    'number, number, number': function (start, end, step) {
	      return _out(_rangeEx(start, end, step));
	    },
	    'number, number, boolean': function (start, end, includeEnd) {
	      return includeEnd
	          ? _out(_rangeInc(start, end, 1))
	          : _out(_rangeEx(start, end, 1));
	    },
	    'number, number, number, boolean': function (start, end, step, includeEnd) {
	      return includeEnd
	          ? _out(_rangeInc(start, end, step))
	          : _out(_rangeEx(start, end, step));
	    },
	
	    'BigNumber, BigNumber':  function (start, end) {
	      return _out(_bigRangeEx(start, end, ONE));
	    },
	    'BigNumber, BigNumber, BigNumber': function (start, end, step) {
	      return _out(_bigRangeEx(start, end, step));
	    },
	    'BigNumber, BigNumber, boolean': function (start, end, includeEnd) {
	      return includeEnd
	          ? _out(_bigRangeInc(start, end, ONE))
	          : _out(_bigRangeEx(start, end, ONE));
	    },
	    'BigNumber, BigNumber, BigNumber, boolean': function (start, end, step, includeEnd) {
	      return includeEnd
	          ? _out(_bigRangeInc(start, end, step))
	          : _out(_bigRangeEx(start, end, step));
	    }
	
	  });
	
	  range.toTex = undefined; // use default template
	
	  return range;
	
	  function _out(arr) {
	    return config.matrix === 'Array' ? arr : matrix(arr);
	  }
	
	  function _strRange (str, includeEnd) {
	    var r = _parse(str);
	    if (!r){
	      throw new SyntaxError('String "' + str + '" is no valid range');
	    }
	
	    var fn;
	    if (config.number === 'BigNumber') {
	      fn = includeEnd ? _bigRangeInc : _bigRangeEx;
	      return _out(fn(
	          new type.BigNumber(r.start),
	          new type.BigNumber(r.end),
	          new type.BigNumber(r.step)));
	    }
	    else {
	      fn = includeEnd ? _rangeInc : _rangeEx;
	      return _out(fn(r.start, r.end, r.step));
	    }
	  }
	
	  /**
	   * Create a range with numbers. End is excluded
	   * @param {number} start
	   * @param {number} end
	   * @param {number} step
	   * @returns {Array} range
	   * @private
	   */
	  function _rangeEx (start, end, step) {
	    var array = [],
	        x = start;
	    if (step > 0) {
	      while (x < end) {
	        array.push(x);
	        x += step;
	      }
	    }
	    else if (step < 0) {
	      while (x > end) {
	        array.push(x);
	        x += step;
	      }
	    }
	
	    return array;
	  }
	
	  /**
	   * Create a range with numbers. End is included
	   * @param {number} start
	   * @param {number} end
	   * @param {number} step
	   * @returns {Array} range
	   * @private
	   */
	  function _rangeInc (start, end, step) {
	    var array = [],
	        x = start;
	    if (step > 0) {
	      while (x <= end) {
	        array.push(x);
	        x += step;
	      }
	    }
	    else if (step < 0) {
	      while (x >= end) {
	        array.push(x);
	        x += step;
	      }
	    }
	
	    return array;
	  }
	
	  /**
	   * Create a range with big numbers. End is excluded
	   * @param {BigNumber} start
	   * @param {BigNumber} end
	   * @param {BigNumber} step
	   * @returns {Array} range
	   * @private
	   */
	  function _bigRangeEx (start, end, step) {
	    var array = [],
	        x = start;
	    if (step.gt(ZERO)) {
	      while (x.lt(end)) {
	        array.push(x);
	        x = x.plus(step);
	      }
	    }
	    else if (step.lt(ZERO)) {
	      while (x.gt(end)) {
	        array.push(x);
	        x = x.plus(step);
	      }
	    }
	
	    return array;
	  }
	
	  /**
	   * Create a range with big numbers. End is included
	   * @param {BigNumber} start
	   * @param {BigNumber} end
	   * @param {BigNumber} step
	   * @returns {Array} range
	   * @private
	   */
	  function _bigRangeInc (start, end, step) {
	    var array = [],
	        x = start;
	    if (step.gt(ZERO)) {
	      while (x.lte(end)) {
	        array.push(x);
	        x = x.plus(step);
	      }
	    }
	    else if (step.lt(ZERO)) {
	      while (x.gte(end)) {
	        array.push(x);
	        x = x.plus(step);
	      }
	    }
	
	    return array;
	  }
	
	  /**
	   * Parse a string into a range,
	   * The string contains the start, optional step, and end, separated by a colon.
	   * If the string does not contain a valid range, null is returned.
	   * For example str='0:2:11'.
	   * @param {string} str
	   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
	   * @private
	   */
	  function _parse (str) {
	    var args = str.split(':');
	
	    // number
	    var nums = args.map(function (arg) {
	      // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
	      return Number(arg);
	    });
	
	    var invalid = nums.some(function (num) {
	      return isNaN(num);
	    });
	    if(invalid) {
	      return null;
	    }
	
	    switch (nums.length) {
	      case 2:
	        return {
	          start: nums[0],
	          end: nums[1],
	          step: 1
	        };
	
	      case 3:
	        return {
	          start: nums[0],
	          end: nums[2],
	          step: nums[1]
	        };
	
	      default:
	        return null;
	    }
	  }
	
	}
	
	exports.name = 'range';
	exports.factory = factory;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var errorTransform = __webpack_require__(1629).transform;
	
	/**
	 * Attach a transform function to math.subset
	 * Adds a property transform containing the transform function.
	 *
	 * This transform creates a range which includes the end value
	 */
	function factory (type, config, load, typed) {
	  var subset = load(__webpack_require__(1630));
	
	  return typed('subset', {
	    '...any': function (args) {
	      try {
	        return subset.apply(null, args);
	      }
	      catch (err) {
	        throw errorTransform(err);
	      }
	    }
	  });
	}
	
	exports.name = 'subset';
	exports.path = 'expression.transform';
	exports.factory = factory;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object = __webpack_require__(1320);
	var string = __webpack_require__(1341);
	
	function factory (type, config, load, typed) {
	  var parser = load(__webpack_require__(1648))();
	
	  /**
	   * Documentation object
	   * @param {Object} doc  Object containing properties:
	   *                      {string} name
	   *                      {string} category
	   *                      {string} description
	   *                      {string[]} syntax
	   *                      {string[]} examples
	   *                      {string[]} seealso
	   * @constructor
	   */
	  function Help(doc) {
	    if (!(this instanceof Help)) {
	      throw new SyntaxError('Constructor must be called with the new operator');
	    }
	
	    if (!doc)  throw new Error('Argument "doc" missing');
	
	    this.doc = doc;
	  }
	
	  /**
	   * Attach type information
	   */
	  Help.prototype.type = 'Help';
	  Help.prototype.isHelp = true;
	
	  /**
	   * Generate a string representation of the Help object
	   * @return {string} Returns a string
	   * @private
	   */
	  Help.prototype.toString = function () {
	    var doc = this.doc || {};
	    var desc = '\n';
	
	    if (doc.name) {
	      desc += 'Name: ' + doc.name + '\n\n';
	    }
	    if (doc.category) {
	      desc += 'Category: ' + doc.category + '\n\n';
	    }
	    if (doc.description) {
	      desc += 'Description:\n    ' + doc.description + '\n\n';
	    }
	    if (doc.syntax) {
	      desc += 'Syntax:\n    ' + doc.syntax.join('\n    ') + '\n\n';
	    }
	    if (doc.examples) {
	      desc += 'Examples:\n';
	      for (var i = 0; i < doc.examples.length; i++) {
	        var expr = doc.examples[i];
	        desc += '    ' + expr + '\n';
	
	        var res;
	        try {
	          // note: res can be undefined when `expr` is an empty string
	          res = parser.eval(expr);
	        }
	        catch (e) {
	          res = e;
	        }
	        if (res !== undefined && !type.isHelp(res)) {
	          desc += '        ' + string.format(res, {precision: 14}) + '\n';
	        }
	      }
	      desc += '\n';
	    }
	    if (doc.seealso && doc.seealso.length) {
	      desc += 'See also: ' + doc.seealso.join(', ') + '\n';
	    }
	
	    return desc;
	  };
	
	  /**
	   * Export the help object to JSON
	   */
	  Help.prototype.toJSON = function () {
	    var obj = object.clone(this.doc);
	    obj.mathjs = 'Help';
	    return obj;
	  };
	
	  /**
	   * Instantiate a Help object from a JSON object
	   * @param {Object} json
	   * @returns {Help} Returns a new Help object
	   */
	  Help.fromJSON = function (json) {
	    var doc = {};
	    for (var prop in json) {
	      if (prop !== 'mathjs') { // ignore mathjs field
	        doc[prop] = json[prop];
	      }
	    }
	    return new Help(doc);
	  };
	
	  /**
	   * Returns a string representation of the Help object
	   */
	  Help.prototype.valueOf = Help.prototype.toString;
	
	  return Help;
	}
	
	exports.name = 'Help';
	exports.path = 'type';
	exports.factory = factory;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1680),
	  __webpack_require__(1721),
	  __webpack_require__(1750),
	  __webpack_require__(1766),
	  __webpack_require__(1775),
	  __webpack_require__(1779),
	  __webpack_require__(1782),
	  __webpack_require__(1787),
	  __webpack_require__(1808),
	  __webpack_require__(1819),
	  __webpack_require__(1824),
	  __webpack_require__(1835),
	  __webpack_require__(1837),
	  __webpack_require__(1845),
	  __webpack_require__(1847),
	  __webpack_require__(1873),
	  __webpack_require__(1875)
	];


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1681),
	
	  // simplify
	  __webpack_require__(1682),
	
	  // polynomial 
	  __webpack_require__(1688),
	    
	  
	  // decomposition
	  __webpack_require__(1689),
	  __webpack_require__(1672),
	  __webpack_require__(1696),
	
	  // solver
	  __webpack_require__(1716),
	  __webpack_require__(1718),
	  __webpack_require__(1720)
	];


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var parse = load(__webpack_require__(1621));
	  var simplify = load(__webpack_require__(1682));
	  var equal = load(__webpack_require__(1406));
	  var isZero = load(__webpack_require__(1686));
	  var numeric = load(__webpack_require__(1622));
	  var ConstantNode = load(__webpack_require__(1637));
	  var FunctionNode = load(__webpack_require__(1642));
	  var OperatorNode = load(__webpack_require__(1640));
	  var ParenthesisNode = load(__webpack_require__(1641));
	  var SymbolNode = load(__webpack_require__(1643));
	
	  /**
	   * Takes the derivative of an expression expressed in parser Nodes.
	   * The derivative will be taken over the supplied variable in the
	   * second parameter. If there are multiple variables in the expression,
	   * it will return a partial derivative.
	   *
	   * This uses rules of differentiation which can be found here:
	   *
	   * - [Differentiation rules (Wikipedia)](http://en.wikipedia.org/wiki/Differentiation_rules)
	   *
	   * Syntax:
	   *
	   *     derivative(expr, variable)
	   *     derivative(expr, variable, options)
	   *
	   * Examples:
	   *
	   *     math.derivative('x^2', 'x');                     // Node {2 * x}
	   *     math.derivative('x^2', 'x', {simplify: false});  // Node {2 * 1 * x ^ (2 - 1)
	   *     math.derivative('sin(2x)', 'x'));                // Node {2 * cos(2 * x)}
	   *     math.derivative('2*x', 'x').eval();              // number 2
	   *     math.derivative('x^2', 'x').eval({x: 4});        // number 8
	   *     var f = math.parse('x^2');
	   *     var x = math.parse('x');
	   *     math.derivative(f, x);                           // Node {2 * x}
	   *
	   * See also:
	   *
	   *     simplify, parse, eval
	   *
	   * @param  {Node | string} expr           The expression to differentiate
	   * @param  {SymbolNode | string} variable The variable over which to differentiate
	   * @param  {{simplify: boolean}} [options]
	   *                         There is one option available, `simplify`, which
	   *                         is true by default. When false, output will not
	   *                         be simplified.
	   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
	   */
	  var derivative = typed('derivative', {
	    'Node, SymbolNode, Object': function (expr, variable, options) {
	      var constNodes = {};
	      constTag(constNodes, expr, variable.name);
	      var res = _derivative(expr, constNodes);
	      return options.simplify ? simplify(res) : res;
	    },
	    'Node, SymbolNode': function (expr, variable) {
	      return derivative(expr, variable, {simplify: true})
	    },
	
	    'string, SymbolNode': function (expr, variable) {
	      return derivative(parse(expr), variable)
	    },
	    'string, SymbolNode, Object': function (expr, variable, options) {
	      return derivative(parse(expr), variable, options)
	    },
	
	    'string, string': function (expr, variable) {
	      return derivative(parse(expr), parse(variable))
	    },
	    'string, string, Object': function (expr, variable, options) {
	      return derivative(parse(expr), parse(variable), options)
	    },
	
	    'Node, string': function (expr, variable) {
	      return derivative(expr, parse(variable))
	    },
	    'Node, string, Object': function (expr, variable, options) {
	      return derivative(expr, parse(variable), options)
	    }
	
	    // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments
	
	    /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
	    'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
	      var res = expr;
	      for (var i = 0; i < order; i++) {
	        var constNodes = {};
	        constTag(constNodes, expr, variable.name);
	        res = _derivative(res, constNodes);
	      }
	      return res;
	    }
	    */
	  });
	
	  derivative._simplify = true
	
	  derivative.toTex = function(deriv) {
	    return _derivTex.apply(null, deriv.args);
	  }
	
	  var _derivTex = typed('_derivTex', {
	    'Node, SymbolNode': function (expr, x) {
	      return _derivTex(expr.toString(), x.toString(), 1);
	    },
	    'Node, SymbolNode, ConstantNode': function (expr, x, order) {
	      return _derivTex(expr.toString(), x.name, order.value);
	    },
	    'string, string, number': function (expr, x, order) {
	      var d;
	      if (order === 1) {
	        d = "{d\\over d" + x + "}";
	      }
	      else {
	        d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
	      }
	      return d + "\\left[" + expr + "\\right]"
	    }
	  });
	
	  /**
	   * Does a depth-first search on the expression tree to identify what Nodes
	   * are constants (e.g. 2 + 2), and stores the ones that are constants in
	   * constNodes. Classification is done as follows:
	   *
	   *   1. ConstantNodes are constants.
	   *   2. If there exists a SymbolNode, of which we are differentiating over,
	   *      in the subtree it is not constant.
	   *
	   * @param  {Object} constNodes  Holds the nodes that are constant
	   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
	   * @param  {string} varName     Variable that we are differentiating
	   * @return {boolean}  if node is constant
	   */
	  // TODO: can we rewrite constTag into a pure function?
	  var constTag = typed('constTag', {
	    'Object, ConstantNode, string': function (constNodes, node) {
	      return constNodes[node] = true;
	    },
	
	    'Object, SymbolNode, string': function (constNodes, node, varName) {
	      // Treat other variables like constants. For reasoning, see:
	      //   https://en.wikipedia.org/wiki/Partial_derivative
	      if (node.name !== varName) {
	        return constNodes[node] = true;
	      }
	      return false;
	    },
	
	    'Object, ParenthesisNode, string': function (constNodes, node, varName) {
	      return constTag(constNodes, node.content, varName);
	    },
	
	    'Object, FunctionAssignmentNode, string': function (constNodes, node, varName) {
	      if (node.params.indexOf(varName) === -1) {
	        return constNodes[node] = true;
	      }
	      return constTag(constNodes, node.expr, varName);
	    },
	
	    'Object, FunctionNode | OperatorNode, string': function (constNodes, node, varName) {
	      if (node.args.length > 0) {
	        var isConst = constTag(constNodes, node.args[0], varName);
	        for (var i = 1; i < node.args.length; ++i) {
	          isConst = constTag(constNodes, node.args[i], varName) && isConst;
	        }
	
	        if (isConst) {
	          return constNodes[node] = true;
	        }
	      }
	      return false;
	    }
	  });
	
	  /**
	   * Applies differentiation rules.
	   *
	   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
	   * @param  {Object} constNodes  Holds the nodes that are constant
	   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
	   */
	  var _derivative = typed('_derivative', {
	    'ConstantNode, Object': function (node) {
	       return createConstantNode(0);
	    },
	
	    'SymbolNode, Object': function (node, constNodes) {
	      if (constNodes[node] !== undefined) {
	        return createConstantNode(0);
	      }
	      return createConstantNode(1);
	    },
	
	    'ParenthesisNode, Object': function (node, constNodes) {
	      return new ParenthesisNode(_derivative(node.content, constNodes));
	    },
	
	    'FunctionAssignmentNode, Object': function (node, constNodes) {
	      if (constNodes[node] !== undefined) {
	        return createConstantNode(0);
	      }
	      return _derivative(node.expr, constNodes);
	    },
	
	    'FunctionNode, Object': function (node, constNodes) {
	      if (node.args.length !== 1) {
	        funcArgsCheck(node);
	      }
	
	      if (constNodes[node] !== undefined) {
	        return createConstantNode(0);
	      }
	
	      var arg0 = node.args[0];
	      var arg1;
	
	      var div = false;       // is output a fraction?
	      var negative = false;  // is output negative?
	
	      var funcDerivative;
	      switch (node.name) {
	        case 'cbrt':
	          // d/dx(cbrt(x)) = 1 / (3x^(2/3))
	          div = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            createConstantNode(3),
	            new OperatorNode('^', 'pow', [
	              arg0,
	              new OperatorNode('/', 'divide', [
	                createConstantNode(2),
	                createConstantNode(3)
	              ])
	            ])
	          ]);
	          break;
	        case 'sqrt':
	        case 'nthRoot':
	          // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
	          if (node.args.length === 1) {
	            div = true;
	            funcDerivative = new OperatorNode('*', 'multiply', [
	              createConstantNode(2),
	              new FunctionNode('sqrt', [arg0])
	            ]);
	          }
	          else if (node.args.length === 2) {
	            // Rearrange from nthRoot(x, a) -> x^(1/a)
	            arg1 = new OperatorNode('/', 'divide', [
	              createConstantNode(1),
	              node.args[1]
	            ]);
	
	            // Is a variable?
	            constNodes[arg1] = constNodes[node.args[1]];
	
	            return _derivative(new OperatorNode('^', 'pow', [arg0, arg1]), constNodes);
	          }
	          break;
	        case 'log10':
	          arg1 = createConstantNode(10);
	          /* fall through! */
	        case 'log':
	          if (!arg1 && node.args.length === 1) {
	            // d/dx(log(x)) = 1 / x
	            funcDerivative = arg0.clone();
	            div = true;
	          } else if ((node.args.length === 1 && arg1) ||
	              (node.args.length === 2 && constNodes[node.args[1]] !== undefined)) {
	            // d/dx(log(x, c)) = 1 / (x*ln(c))
	            funcDerivative = new OperatorNode('*', 'multiply', [
	              arg0.clone(),
	              new FunctionNode('log', [arg1 || node.args[1]])
	            ]);
	            div = true;
	          } else if (node.args.length === 2) {
	            // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
	            return _derivative(new OperatorNode('/', 'divide', [
	                new FunctionNode('log', [arg0]),
	                new FunctionNode('log', [node.args[1]])
	              ]), constNodes);
	          }
	          break;
	        case 'exp':
	          // d/dx(e^x) = e^x
	          funcDerivative = new FunctionNode('exp', [arg0.clone()]);
	          break;
	        case 'sin':
	          // d/dx(sin(x)) = cos(x)
	          funcDerivative = new FunctionNode('cos', [arg0.clone()]);
	          break;
	        case 'cos':
	          // d/dx(cos(x)) = -sin(x)
	          funcDerivative = new OperatorNode('-', 'unaryMinus', [
	            new FunctionNode('sin', [arg0.clone()])
	          ]);
	          break;
	        case 'tan':
	          // d/dx(tan(x)) = sec(x)^2
	          funcDerivative = new OperatorNode('^', 'pow', [
	            new FunctionNode('sec', [arg0.clone()]),
	            createConstantNode(2)
	          ]);
	          break;
	        case 'sec':
	          // d/dx(sec(x)) = sec(x)tan(x)
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            node,
	            new FunctionNode('tan', [arg0.clone()])
	          ]);
	          break;
	        case 'csc':
	          // d/dx(csc(x)) = -csc(x)cot(x)
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            node,
	            new FunctionNode('cot', [arg0.clone()])
	          ]);
	          break;
	        case 'cot':
	          // d/dx(cot(x)) = -csc(x)^2
	          negative = true;
	          funcDerivative = new OperatorNode('^', 'pow', [
	            new FunctionNode('csc', [arg0.clone()]),
	            createConstantNode(2)
	          ]);
	          break;
	        case 'asin':
	          // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
	          div = true;
	          funcDerivative = new FunctionNode('sqrt', [
	            new OperatorNode('-', 'subtract', [
	              createConstantNode(1),
	              new OperatorNode('^', 'pow', [
	                arg0.clone(),
	                createConstantNode(2)
	              ])
	            ])
	          ]);
	          break;
	        case 'acos':
	          // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
	          div = true;
	          negative = true;
	          funcDerivative = new FunctionNode('sqrt', [
	            new OperatorNode('-', 'subtract', [
	              createConstantNode(1),
	              new OperatorNode('^', 'pow', [
	                arg0.clone(),
	                createConstantNode(2)
	              ])
	            ])
	          ]);
	          break;
	        case 'atan':
	          // d/dx(atan(x)) = 1 / (x^2 + 1)
	          div = true;
	          funcDerivative = new OperatorNode('+', 'add', [
	            new OperatorNode('^', 'pow', [
	              arg0.clone(),
	              createConstantNode(2)
	            ]),
	            createConstantNode(1)
	          ]);
	          break;
	        case 'asec':
	          // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
	          div = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            new FunctionNode('abs', [arg0.clone()]),
	            new FunctionNode('sqrt', [
	              new OperatorNode('-', 'subtract', [
	                new OperatorNode('^', 'pow', [
	                  arg0.clone(),
	                  createConstantNode(2)
	                ]),
	                createConstantNode(1)
	              ])
	            ])
	          ]);
	          break;
	        case 'acsc':
	          // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
	          div = true;
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            new FunctionNode('abs', [arg0.clone()]),
	            new FunctionNode('sqrt', [
	              new OperatorNode('-', 'subtract', [
	                new OperatorNode('^', 'pow', [
	                  arg0.clone(),
	                  createConstantNode(2)
	                ]),
	                createConstantNode(1)
	              ])
	            ])
	          ]);
	          break;
	        case 'acot':
	          // d/dx(acot(x)) = -1 / (x^2 + 1)
	          div = true;
	          negative = true;
	          funcDerivative = new OperatorNode('+', 'add', [
	            new OperatorNode('^', 'pow', [
	              arg0.clone(),
	              createConstantNode(2)
	            ]),
	            createConstantNode(1)
	          ]);
	          break;
	        case 'sinh':
	          // d/dx(sinh(x)) = cosh(x)
	          funcDerivative = new FunctionNode('cosh', [arg0.clone()]);
	          break;
	        case 'cosh':
	          // d/dx(cosh(x)) = sinh(x)
	          funcDerivative = new FunctionNode('sinh', [arg0.clone()]);
	          break;
	        case 'tanh':
	          // d/dx(tanh(x)) = sech(x)^2
	          funcDerivative = new OperatorNode('^', 'pow', [
	            new FunctionNode('sech', [arg0.clone()]),
	            createConstantNode(2)
	          ]);
	          break;
	        case 'sech':
	          // d/dx(sech(x)) = -sech(x)tanh(x)
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            node,
	            new FunctionNode('tanh', [arg0.clone()])
	          ]);
	          break;
	        case 'csch':
	          // d/dx(csch(x)) = -csch(x)coth(x)
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            node,
	            new FunctionNode('coth', [arg0.clone()])
	          ]);
	          break;
	        case 'coth':
	          // d/dx(coth(x)) = -csch(x)^2
	          negative = true;
	          funcDerivative = new OperatorNode('^', 'pow', [
	            new FunctionNode('csch', [arg0.clone()]),
	            createConstantNode(2)
	          ]);
	          break;
	        case 'asinh':
	          // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
	          div = true;
	          funcDerivative = new FunctionNode('sqrt', [
	            new OperatorNode('+', 'add', [
	              new OperatorNode('^', 'pow', [
	                arg0.clone(),
	                createConstantNode(2)
	              ]),
	              createConstantNode(1)
	            ])
	          ]);
	          break;
	        case 'acosh':
	          // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
	          div = true;
	          funcDerivative = new FunctionNode('sqrt', [
	            new OperatorNode('-', 'subtract', [
	              new OperatorNode('^', 'pow', [
	                arg0.clone(),
	                createConstantNode(2)
	              ]),
	              createConstantNode(1)
	            ])
	          ]);
	          break;
	        case 'atanh':
	          // d/dx(atanh(x)) = 1 / (1 - x^2)
	          div = true;
	          funcDerivative = new OperatorNode('-', 'subtract', [
	            createConstantNode(1),
	            new OperatorNode('^', 'pow', [
	              arg0.clone(),
	              createConstantNode(2)
	            ])
	          ]);
	          break;
	        case 'asech':
	          // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
	          div = true;
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            arg0.clone(),
	            new FunctionNode('sqrt', [
	              new OperatorNode('-', 'subtract', [
	                createConstantNode(1),
	                new OperatorNode('^', 'pow', [
	                  arg0.clone(),
	                  createConstantNode(2)
	                ])
	              ])
	            ])
	          ]);
	          break;
	        case 'acsch':
	          // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
	          div = true;
	          negative = true;
	          funcDerivative = new OperatorNode('*', 'multiply', [
	            new FunctionNode('abs', [arg0.clone()]),
	            new FunctionNode('sqrt', [
	              new OperatorNode('+', 'add', [
	                new OperatorNode('^', 'pow', [
	                  arg0.clone(),
	                  createConstantNode(2)
	                ]),
	                createConstantNode(1)
	              ])
	            ])
	          ]);
	          break;
	        case 'acoth':
	          // d/dx(acoth(x)) = -1 / (1 - x^2)
	          div = true;
	          negative = true;
	          funcDerivative = new OperatorNode('-', 'subtract', [
	            createConstantNode(1),
	            new OperatorNode('^', 'pow', [
	              arg0.clone(),
	              createConstantNode(2)
	            ])
	          ]);
	          break;
	        case 'abs':
	          // d/dx(abs(x)) = abs(x)/x
	          funcDerivative = new OperatorNode('/', 'divide', [
	            new FunctionNode(new SymbolNode('abs'), [arg0.clone()]),
	            arg0.clone()
	          ]);
	          break;
	        case 'gamma':  // Needs digamma function, d/dx(gamma(x)) = gamma(x)digamma(x)
	        default: throw new Error('Function "' + node.name + '" is not supported by derivative, or a wrong number of arguments is passed');
	      }
	
	      var op, func;
	      if (div) {
	        op = '/';
	        func = 'divide';
	      } else {
	        op = '*';
	        func = 'multiply';
	      }
	
	      /* Apply chain rule to all functions:
	         F(x)  = f(g(x))
	         F'(x) = g'(x)*f'(g(x)) */
	      var chainDerivative = _derivative(arg0, constNodes);
	      if (negative) {
	        chainDerivative = new OperatorNode('-', 'unaryMinus', [chainDerivative]);
	      }
	      return new OperatorNode(op, func, [chainDerivative, funcDerivative]);
	    },
	
	    'OperatorNode, Object': function (node, constNodes) {
	      if (constNodes[node] !== undefined) {
	        return createConstantNode(0);
	      }
	
	      if (node.op === '+') {
	        // d/dx(sum(f(x)) = sum(f'(x))
	        return new OperatorNode(node.op, node.fn, node.args.map(function(arg) {
	          return _derivative(arg, constNodes);
	        }));
	      }
	
	      if (node.op === '-') {
	        // d/dx(+/-f(x)) = +/-f'(x)
	        if (node.isUnary()) {
	          return new OperatorNode(node.op, node.fn, [
	              _derivative(node.args[0], constNodes)
	          ]);
	        }
	
	        // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
	        if (node.isBinary()) {
	          return new OperatorNode(node.op, node.fn, [
	            _derivative(node.args[0], constNodes),
	            _derivative(node.args[1], constNodes)
	          ]);
	        }
	      }
	
	      if (node.op === '*') {
	        // d/dx(c*f(x)) = c*f'(x)
	        var constantTerms = node.args.filter(function(arg) {
	          return constNodes[arg] !== undefined;
	        });
	
	        if (constantTerms.length > 0) {
	          var nonConstantTerms = node.args.filter(function(arg) {
	            return constNodes[arg] === undefined;
	          });
	
	          var nonConstantNode = nonConstantTerms.length === 1
	              ? nonConstantTerms[0]
	              : new OperatorNode('*', 'multiply', nonConstantTerms);
	
	          var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));
	
	          return new OperatorNode('*', 'multiply', newArgs);
	        }
	
	        // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
	        return new OperatorNode('+', 'add', node.args.map(function(argOuter) {
	          return new OperatorNode('*', 'multiply', node.args.map(function(argInner) {
	            return (argInner === argOuter)
	                ? _derivative(argInner, constNodes)
	                : argInner.clone();
	          }));
	        }));
	      }
	
	      if (node.op === '/' && node.isBinary()) {
	        var arg0 = node.args[0];
	        var arg1 = node.args[1];
	
	        // d/dx(f(x) / c) = f'(x) / c
	        if (constNodes[arg1] !== undefined) {
	          return new OperatorNode('/', 'divide', [_derivative(arg0, constNodes), arg1]);
	        }
	
	        // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
	        if (constNodes[arg0] !== undefined) {
	          return new OperatorNode('*', 'multiply', [
	            new OperatorNode('-', 'unaryMinus', [arg0]),
	            new OperatorNode('/', 'divide', [
	              _derivative(arg1, constNodes),
	              new OperatorNode('^', 'pow', [arg1.clone(), createConstantNode(2)])
	            ])
	          ]);
	        }
	
	        // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
	        return new OperatorNode('/', 'divide', [
	          new OperatorNode('-', 'subtract', [
	            new OperatorNode('*', 'multiply', [_derivative(arg0, constNodes), arg1.clone()]),
	            new OperatorNode('*', 'multiply', [arg0.clone(), _derivative(arg1, constNodes)])
	          ]),
	          new OperatorNode('^', 'pow', [arg1.clone(), createConstantNode(2)])
	        ]);
	      }
	
	      if (node.op === '^' && node.isBinary()) {
	        var arg0 = node.args[0];
	        var arg1 = node.args[1];
	
	        if (constNodes[arg0] !== undefined) {
	          // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
	          if (type.isConstantNode(arg0) && (isZero(arg0.value) || equal(arg0.value, 1))) {
	            return createConstantNode(0);
	          }
	
	          // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
	          return new OperatorNode('*', 'multiply', [
	            node,
	            new OperatorNode('*', 'multiply', [
	              new FunctionNode('log', [arg0.clone()]),
	              _derivative(arg1.clone(), constNodes)
	            ])
	          ]);
	        }
	
	          if (constNodes[arg1] !== undefined) {
	            if (type.isConstantNode(arg1)) {
	              // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
	              if (isZero(arg1.value)) {
	                return createConstantNode(0);
	              }
	              // Ignore exponent; f(x)^1 = f(x)
	              if (equal(arg1.value,1)) {
	                return _derivative(arg0, constNodes);
	              }
	            }
	
	            // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
	            var powMinusOne = new OperatorNode('^', 'pow', [
	              arg0.clone(),
	              new OperatorNode('-', 'subtract', [
	                arg1,
	                createConstantNode(1)
	              ])
	            ]);
	
	          return new OperatorNode('*', 'multiply', [
	            arg1.clone(),
	            new OperatorNode('*', 'multiply', [
	              _derivative(arg0, constNodes),
	              powMinusOne
	            ])
	          ]);
	        }
	
	        // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
	        return new OperatorNode('*', 'multiply', [
	          new OperatorNode('^', 'pow', [arg0.clone(), arg1.clone()]),
	          new OperatorNode('+', 'add', [
	            new OperatorNode('*', 'multiply', [
	              _derivative(arg0, constNodes),
	              new OperatorNode('/', 'divide', [arg1.clone(), arg0.clone()])
	            ]),
	            new OperatorNode('*', 'multiply', [
	              _derivative(arg1, constNodes),
	              new FunctionNode('log', [arg0.clone()])
	            ])
	          ])
	        ]);
	      }
	
	      throw new Error('Operator "' + node.op + '" is not supported by derivative, or a wrong number of arguments is passed');
	    }
	  });
	
	  /**
	   * Ensures the number of arguments for a function are correct,
	   * and will throw an error otherwise.
	   *
	   * @param {FunctionNode} node
	   */
	  function funcArgsCheck(node) {
	    //TODO add min, max etc
	    if ((node.name === 'log' || node.name === 'nthRoot') && node.args.length === 2) {
	      return;
	    }
	
	    // There should be an incorrect number of arguments if we reach here
	
	    // Change all args to constants to avoid unidentified
	    // symbol error when compiling function
	    for (var i = 0; i < node.args.length; ++i) {
	      node.args[i] = createConstantNode(0);
	    }
	
	    node.compile().eval();
	    throw new Error('Expected TypeError, but none found');
	  }
	
	  /**
	   * Helper function to create a constant node with a specific type
	   * (number, BigNumber, Fraction)
	   * @param {number} value
	   * @param {string} [valueType]
	   * @return {ConstantNode}
	   */
	  function createConstantNode(value, valueType) {
	    return new ConstantNode(numeric(value, valueType || config.number));
	  }
	
	  return derivative;
	}
	
	exports.name = 'derivative';
	exports.factory = factory;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	function factory (type, config, load, typed, math) {
	  var parse = load(__webpack_require__(1621));
	  var equal = load(__webpack_require__(1406));
	  var ConstantNode = load(__webpack_require__(1637));
	  var FunctionNode = load(__webpack_require__(1642));
	  var OperatorNode = load(__webpack_require__(1640));
	  var ParenthesisNode = load(__webpack_require__(1641));
	  var SymbolNode = load(__webpack_require__(1643));
	  var Node = load(__webpack_require__(1625));
	  var simplifyConstant = load(__webpack_require__(1683));
	  var simplifyCore = load(__webpack_require__(1685));
	  var resolve = load(__webpack_require__(1687));
	
	  var util = load(__webpack_require__(1684));
	  var isCommutative = util.isCommutative;
	  var isAssociative = util.isAssociative;
	  var flatten = util.flatten;
	  var unflattenr = util.unflattenr;
	  var unflattenl = util.unflattenl;
	  var createMakeNodeFunction = util.createMakeNodeFunction;
	
	  /**
	   * Simplify an expression tree.
	   *
	   * A list of rules are applied to an expression, repeating over the list until
	   * no further changes are made.
	   * It's possible to pass a custom set of rules to the function as second
	   * argument. A rule can be specified as an object, string, or function:
	   *
	   *     var rules = [
	   *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
	   *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
	   *       function (node) {
	   *         // ... return a new node or return the node unchanged
	   *         return node
	   *       }
	   *     ]
	   *
	   * String and object rules consist of a left and right pattern. The left is
	   * used to match against the expression and the right determines what matches
	   * are replaced with. The main difference between a pattern and a normal
	   * expression is that variables starting with the following characters are
	   * interpreted as wildcards:
	   *
	   * - 'n' - matches any Node
	   * - 'c' - matches any ConstantNode
	   * - 'v' - matches any Node that is not a ConstantNode
	   *
	   * The default list of rules is exposed on the function as `simplify.rules`
	   * and can be used as a basis to built a set of custom rules.
	   *
	   * For more details on the theory, see:
	   *
	   * - [Strategies for simplifying math expressions (Stackoverflow)](http://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
	   * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
	   *
	   * Syntax:
	   *
	   *     simplify(expr)
	   *     simplify(expr, rules)
	   *     simplify(expr, rules, scope)
	   *     simplify(expr, scope)
	   *
	   * Examples:
	   *
	   *     math.simplify('2 * 1 * x ^ (2 - 1)');      // Node {2 * x}
	   *     math.simplify('2 * 3 * x', {x: 4});        // Node {24}
	   *     var f = math.parse('2 * 1 * x ^ (2 - 1)');
	   *     math.simplify(f);                          // Node {2 * x}
	   *
	   * See also:
	   *
	   *     derivative, parse, eval
	   *
	   * @param {Node | string} expr
	   *            The expression to be simplified
	   * @param {Array<{l:string, r: string} | string | function>} [rules]
	   *            Optional list with custom rules
	   * @return {Node} Returns the simplified form of `expr`
	   */
	  var simplify = typed('simplify', {
	    'string': function (expr) {
	      return simplify(parse(expr), simplify.rules, {});
	    },
	
	    'string, Object': function (expr, scope) {
	      return simplify(parse(expr), simplify.rules, scope);
	    },
	
	    'string, Array': function (expr, rules) {
	      return simplify(parse(expr), rules, {});
	    },
	
	    'string, Array, Object': function (expr, rules, scope) {
	      return simplify(parse(expr), rules, scope);
	    },
	
	    'Node, Object': function (expr, scope) {
	      return simplify(expr, simplify.rules, scope);
	    },
	
	    'Node': function (expr) {
	      return simplify(expr, simplify.rules, {});
	    },
	
	    'Node, Array': function (expr, rules) {
	      return simplify(expr, rules, {});
	    },
	
	    'Node, Array, Object': function (expr, rules, scope) {
	      rules = _buildRules(rules);
	
	      var res = resolve(expr, scope);
	      var res = removeParens(res);
	      var visited = {};
	
	      var str = res.toString({parenthesis: 'all'});
	      while(!visited[str]) {
	        visited[str] = true;
	        _lastsym = 0; // counter for placeholder symbols
	        for (var i=0; i<rules.length; i++) {
	          if (typeof rules[i] === 'function') {
	            res = rules[i](res);
	          }
	          else {
	            flatten(res);
	            res = applyRule(res, rules[i]);
	          }
	          unflattenl(res); // using left-heavy binary tree here since custom rule functions may expect it
	        }
	        str = res.toString({parenthesis: 'all'});
	      }
	
	      return res;
	    }
	  });
	  simplify.simplifyCore = simplifyCore;
	  simplify.resolve = resolve;
	
	  function removeParens(node) {
	    return node.transform(function(node, path, parent) {
	      return type.isParenthesisNode(node)
	          ? node.content
	          : node;
	    });
	  }
	
	  // All constants that are allowed in rules
	  var SUPPORTED_CONSTANTS = {
	    true: true,
	    false: true,
	    e: true,
	    i: true,
	    Infinity: true,
	    LN2: true,
	    LN10: true,
	    LOG2E: true,
	    LOG10E: true,
	    NaN: true,
	    phi: true,
	    pi: true,
	    SQRT1_2: true,
	    SQRT2: true,
	    tau: true,
	    // null: false,
	    // undefined: false,
	    // version: false,
	  };
	
	  // Array of strings, used to build the ruleSet.
	  // Each l (left side) and r (right side) are parsed by
	  // the expression parser into a node tree.
	  // Left hand sides are matched to subtrees within the
	  // expression to be parsed and replaced with the right
	  // hand side.
	  // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
	  // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
	  // It is possible to get into an infinite loop with conflicting rules
	  simplify.rules = [
	    simplifyCore,
	    //{ l: 'n+0', r: 'n' },     // simplifyCore
	    //{ l: 'n^0', r: '1' },     // simplifyCore
	    //{ l: '0*n', r: '0' },     // simplifyCore
	    //{ l: 'n/n', r: '1'},      // simplifyCore
	    //{ l: 'n^1', r: 'n' },     // simplifyCore
	    //{ l: '+n1', r:'n1' },     // simplifyCore
	    //{ l: 'n--n1', r:'n+n1' }, // simplifyCore
	    { l: 'log(e)', r:'1' },
	
	    // temporary rules
	    { l: 'n-n1', r:'n+-n1' }, // temporarily replace 'subtract' so we can further flatten the 'add' operator
	    { l: '-(c*v)', r: '(-c) * v' }, // make non-constant terms positive
	    { l: '-v', r: '(-1) * v' },
	    { l: 'n/n1^n2', r:'n*n1^-n2' }, // temporarily replace 'divide' so we can further flatten the 'multiply' operator
	    { l: 'n/n1', r:'n*n1^-1' },
	
	    // expand nested exponentiation
	    { l: '(n ^ n1) ^ n2', r: 'n ^ (n1 * n2)'},
	
	    // collect like factors
	    { l: 'n*n', r: 'n^2' },
	    { l: 'n * n^n1', r: 'n^(n1+1)' },
	    { l: 'n^n1 * n^n2', r: 'n^(n1+n2)' },
	
	    // collect like terms
	    { l: 'n+n', r: '2*n' },
	    { l: 'n+-n', r: '0' },
	    { l: 'n1*n2 + n2', r: '(n1+1)*n2' },
	    { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
	
	    // remove parenthesis in the case of negating a quantitiy
	    { l: 'n1 + -1 * (n2 + n3)', r:'n1 + -1 * n2 + -1 * n3' },
	
	    simplifyConstant,
	
	    { l: '(-n)*n1', r: '-(n*n1)' }, // make factors positive (and undo 'make non-constant terms positive')
	
	    // ordering of constants
	    { l: 'c+v', r: 'v+c', context: { 'add': { commutative:false } } },
	    { l: 'v*c', r: 'c*v', context: { 'multiply': { commutative:false } } },
	
	    // undo temporary rules
	    //{ l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
	    { l: 'n+-n1', r:'n-n1' },  // undo replace 'subtract'
	    { l: 'n*(n1^-1)', r:'n/n1' },  // undo replace 'divide'
	    { l: 'n*n1^-n2', r:'n/n1^n2' },
	    { l: 'n1^-1', r:'1/n1' },
	
	    { l: 'n*(n1/n2)', r:'(n*n1)/n2' }, // '*' before '/'
	    { l: 'n-(n1+n2)', r:'n-n1-n2' }, // '-' before '+'
	    // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
	    // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
	
	    { l: '1*n', r: 'n' } // this pattern can be produced by simplifyConstant
	
	  ];
	
	  /**
	   * Parse the string array of rules into nodes
	   *
	   * Example syntax for rules:
	   *
	   * Position constants to the left in a product:
	   * { l: 'n1 * c1', r: 'c1 * n1' }
	   * n1 is any Node, and c1 is a ConstantNode.
	   *
	   * Apply difference of squares formula:
	   * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
	   * n1, n2 mean any Node.
	   *
	   * Short hand notation:
	   * 'n1 * c1 -> c1 * n1'
	   */
	  function _buildRules(rules) {
	    // Array of rules to be used to simplify expressions
	    var ruleSet = [];
	    for(var i=0; i<rules.length; i++) {
	      var rule = rules[i];
	      var newRule;
	      var ruleType = typeof rule;
	      switch (ruleType) {
	        case 'string':
	          var lr = rule.split('->');
	          if (lr.length !== 2) {
	            throw SyntaxError('Could not parse rule: ' + rule);
	          }
	          rule = {l: lr[0], r: lr[1]};
	          /* falls through */
	        case 'object':
	          newRule = {
	            l: removeParens(parse(rule.l)),
	            r: removeParens(parse(rule.r)),
	          }
	          if(rule.context) {
	            newRule.evaluate = rule.context;
	          }
	          if(rule.evaluate) {
	            newRule.evaluate = parse(rule.evaluate);
	          }
	
	          if (isAssociative(newRule.l)) {
	            var makeNode = createMakeNodeFunction(newRule.l);
	            var expandsym = _getExpandPlaceholderSymbol();
	            newRule.expanded = {};
	            newRule.expanded.l = makeNode([newRule.l.clone(), expandsym]);
	            // Push the expandsym into the deepest possible branch.
	            // This helps to match the newRule against nodes returned from getSplits() later on.
	            flatten(newRule.expanded.l);
	            unflattenr(newRule.expanded.l);
	            newRule.expanded.r = makeNode([newRule.r, expandsym]);
	          }
	          break;
	        case 'function':
	          newRule = rule;
	          break;
	        default:
	          throw TypeError('Unsupported type of rule: ' + ruleType);
	      }
	     // console.log('Adding rule: ' + rules[i]);
	     // console.log(newRule);
	      ruleSet.push(newRule);
	    }
	    return ruleSet;
	  }
	
	  var _lastsym = 0;
	  function _getExpandPlaceholderSymbol() {
	    return new SymbolNode('_p' + _lastsym++);
	  }
	
	  /**
	   * Returns a simplfied form of node, or the original node if no simplification was possible.
	   *
	   * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
	   * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
	   */
	  var applyRule = typed('applyRule', {
	    'Node, Object': function (node, rule) {
	
	      //console.log('Entering applyRule(' + node.toString() + ')');
	
	      // Do not clone node unless we find a match
	      var res = node;
	
	      // First replace our child nodes with their simplified versions
	      // If a child could not be simplified, the assignments will have
	      // no effect since the node is returned unchanged
	      if (res instanceof OperatorNode || res instanceof FunctionNode) {
	        if (res.args) {
	          for(var i=0; i<res.args.length; i++) {
	            res.args[i] = applyRule(res.args[i], rule);
	          }
	        }
	      }
	      else if(res instanceof ParenthesisNode) {
	        if(res.content) {
	          res.content = applyRule(res.content, rule);
	        }
	      }
	
	      // Try to match a rule against this node
	      var repl = rule.r;
	      var matches = _ruleMatch(rule.l, res)[0];
	
	      // If the rule is associative operator, we can try matching it while allowing additional terms.
	      // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
	      if (!matches && rule.expanded) {
	        repl = rule.expanded.r;
	        matches = _ruleMatch(rule.expanded.l, res)[0];
	      }
	
	      if (matches) {
	        // var before = res.toString({parenthesis: 'all'});
	
	        // Create a new node by cloning the rhs of the matched rule
	        res = repl.clone();
	
	        // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
	        var _transform = function(node) {
	          if(node.isSymbolNode && matches.placeholders.hasOwnProperty(node.name)) {
	            return matches.placeholders[node.name].clone();
	          }
	          else {
	            return node.map(_transform);
	          }
	        }
	
	        res = _transform(res);
	
	        // var after = res.toString({parenthesis: 'all'});
	        // console.log('Simplified ' + before + ' to ' + after);
	      }
	
	      return res;
	    }
	  });
	
	  /**
	   * Get (binary) combinations of a flattened binary node
	   * e.g. +(node1, node2, node3) -> [
	   *        +(node1,  +(node2, node3)),
	   *        +(node2,  +(node1, node3)),
	   *        +(node3,  +(node1, node2))]
	   *
	   */
	  function getSplits(node, context) {
	    var res = [];
	    var right, rightArgs;
	    var makeNode = createMakeNodeFunction(node);
	    if (isCommutative(node, context)) {
	      for (var i=0; i<node.args.length; i++) {
	        rightArgs = node.args.slice(0);
	        rightArgs.splice(i, 1);
	        right = (rightArgs.length === 1) ? rightArgs[0] : makeNode(rightArgs);
	        res.push(makeNode([node.args[i], right]));
	      }
	    }
	    else {
	      rightArgs = node.args.slice(1);
	      right = (rightArgs.length === 1) ? rightArgs[0] : makeNode(rightArgs);
	      res.push(makeNode([node.args[0], right]));
	    }
	    return res;
	  }
	
	  /**
	   * Returns the set union of two match-placeholders or null if there is a conflict.
	   */
	  function mergeMatch(match1, match2) {
	    var res = {placeholders:{}};
	
	    // Some matches may not have placeholders; this is OK
	    if (!match1.placeholders && !match2.placeholders) {
	      return res;
	    }
	    else if (!match1.placeholders) {
	      return match2;
	    }
	    else if (!match2.placeholders) {
	      return match1;
	    }
	
	    // Placeholders with the same key must match exactly
	    for (var key in match1.placeholders) {
	      res.placeholders[key] = match1.placeholders[key];
	      if (match2.placeholders.hasOwnProperty(key)) {
	        if (!_exactMatch(match1.placeholders[key], match2.placeholders[key] )) {
	          return null;
	        }
	      }
	    }
	
	    for (var key in match2.placeholders) {
	      res.placeholders[key] = match2.placeholders[key];
	    }
	
	    return res;
	  }
	
	  /**
	   * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
	   * Each list represents matches found in one child of a node.
	   */
	  function combineChildMatches(list1, list2) {
	    var res = [];
	
	    if (list1.length === 0 || list2.length === 0) {
	      return res;
	    }
	
	    var merged;
	    for (var i1 = 0; i1 < list1.length; i1++) {
	      for (var i2 = 0; i2 < list2.length; i2++) {
	        merged = mergeMatch(list1[i1], list2[i2]);
	        if (merged) {
	          res.push(merged);
	        }
	      }
	    }
	    return res;
	  }
	
	  /**
	   * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
	   * Each list represents matches found in one child of a node.
	   * Returns a list of unique matches.
	   */
	  function mergeChildMatches(childMatches) {
	    if (childMatches.length === 0) {
	      return childMatches;
	    }
	
	    var sets = childMatches.reduce(combineChildMatches);
	    var uniqueSets = [];
	    var unique = {};
	    for(var i = 0; i < sets.length; i++) {
	      var s = JSON.stringify(sets[i]);
	      if (!unique[s]) {
	        unique[s] = true;
	        uniqueSets.push(sets[i]);
	      }
	    }
	    return uniqueSets;
	  }
	
	  /**
	   * Determines whether node matches rule.
	   *
	   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
	   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
	   * @return {Object} Information about the match, if it exists.
	   */
	  function _ruleMatch(rule, node, isSplit) {
	//    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')');
	//    console.log('rule = ' + rule);
	//    console.log('node = ' + node);
	
	//    console.log('Entering _ruleMatch(' + rule.toString() + ', ' + node.toString() + ')');
	    var res = [{placeholders:{}}];
	
	    if (rule instanceof OperatorNode && node instanceof OperatorNode
	     || rule instanceof FunctionNode && node instanceof FunctionNode) {
	
	      // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
	      if (rule instanceof OperatorNode) {
	        if (rule.op !== node.op || rule.fn !== node.fn) {
	          return [];
	        }
	      }
	      else if (rule instanceof FunctionNode) {
	        if (rule.name !== node.name) {
	          return [];
	        }
	      }
	
	      // rule and node match. Search the children of rule and node.
	      if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node) || isSplit) {
	        // Expect non-associative operators to match exactly
	        var childMatches = [];
	        for (var i = 0; i < rule.args.length; i++) {
	          var childMatch = _ruleMatch(rule.args[i], node.args[i]);
	          if (childMatch.length === 0) {
	            // Child did not match, so stop searching immediately
	            return [];
	          }
	          // The child matched, so add the information returned from the child to our result
	          childMatches.push(childMatch);
	        }
	        res = mergeChildMatches(childMatches);
	      }
	      else if (node.args.length >= 2 && rule.args.length === 2) { // node is flattened, rule is not
	        // Associative operators/functions can be split in different ways so we check if the rule matches each
	        // them and return their union.
	        var splits = getSplits(node, rule.context);
	        var splitMatches = [];
	        for(var i = 0; i < splits.length; i++) {
	          var matchSet = _ruleMatch(rule, splits[i], true); // recursing at the same tree depth here
	          splitMatches = splitMatches.concat(matchSet);
	        }
	        return splitMatches;
	      }
	      else if (rule.args.length > 2) {
	        throw Error('Unexpected non-binary associative function: ' + rule.toString());
	      }
	      else {
	        // Incorrect number of arguments in rule and node, so no match
	        return [];
	      }
	    }
	    else if (rule instanceof SymbolNode) {
	      // If the rule is a SymbolNode, then it carries a special meaning
	      // according to the first character of the symbol node name.
	      // c.* matches a ConstantNode
	      // n.* matches any node
	      if (rule.name.length === 0) {
	        throw new Error('Symbol in rule has 0 length...!?');
	      }
	     if (math.hasOwnProperty(rule.name)) {
	        if (!SUPPORTED_CONSTANTS[rule.name]) {
	          throw new Error('Built in constant: ' + rule.name + ' is not supported by simplify.');
	        }
	
	        // built-in constant must match exactly
	        if(rule.name !== node.name) {
	          return [];
	        }
	      }
	      else if (rule.name[0] === 'n' || rule.name.substring(0,2) === '_p') {
	        // rule matches _anything_, so assign this node to the rule.name placeholder
	        // Assign node to the rule.name placeholder.
	        // Our parent will check for matches among placeholders.
	        res[0].placeholders[rule.name] = node;
	      }
	      else if (rule.name[0] === 'v') {
	        // rule matches any variable thing (not a ConstantNode)
	        if(!type.isConstantNode(node)) {
	          res[0].placeholders[rule.name] = node;
	        }
	        else {
	          // Mis-match: rule was expecting something other than a ConstantNode
	          return [];
	        }
	      }
	      else if (rule.name[0] === 'c') {
	        // rule matches any ConstantNode
	        if(node instanceof ConstantNode) {
	          res[0].placeholders[rule.name] = node;
	        }
	        else {
	          // Mis-match: rule was expecting a ConstantNode
	          return [];
	        }
	      }
	      else {
	        throw new Error('Invalid symbol in rule: ' + rule.name);
	      }
	    }
	    else if (rule instanceof ConstantNode) {
	      // Literal constant must match exactly
	      if(!equal(rule.value, node.value)) {
	        return [];
	      }
	    }
	    else {
	      // Some other node was encountered which we aren't prepared for, so no match
	      return [];
	    }
	
	    // It's a match!
	
	    // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match');
	    return res;
	  }
	
	
	  /**
	   * Determines whether p and q (and all their children nodes) are identical.
	   *
	   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
	   * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
	   * @return {Object} Information about the match, if it exists.
	   */
	  function _exactMatch(p, q) {
	    if(p instanceof ConstantNode && q instanceof ConstantNode) {
	      if(!equal(p.value, q.value)) {
	        return false;
	      }
	    }
	    else if(p instanceof SymbolNode && q instanceof SymbolNode) {
	      if(p.name !== q.name) {
	        return false;
	      }
	    }
	    else if(p instanceof OperatorNode && q instanceof OperatorNode
	         || p instanceof FunctionNode && q instanceof FunctionNode) {
	      if (p instanceof OperatorNode) {
	        if (p.op !== q.op || p.fn !== q.fn) {
	          return false;
	        }
	      }
	      else if (p instanceof FunctionNode) {
	        if (p.name !== q.name) {
	          return false;
	        }
	      }
	
	      if(p.args.length !== q.args.length) {
	        return false;
	      }
	
	      for(var i=0; i<p.args.length; i++) {
	        if(!_exactMatch(p.args[i], q.args[i])) {
	          return false;
	        }
	      }
	    }
	    else {
	      return false;
	    }
	
	    return true;
	  }
	
	  return simplify;
	}
	
	exports.math = true;
	exports.name = 'simplify';
	exports.factory = factory;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var digits = __webpack_require__(1324).digits;
	// TODO this could be improved by simplifying seperated constants under associative and commutative operators
	function factory(type, config, load, typed, math) {
	  var util = load(__webpack_require__(1684));
	  var isNumeric = load(__webpack_require__(1407));
	  var isCommutative = util.isCommutative;
	  var isAssociative = util.isAssociative;
	  var allChildren = util.allChildren;
	  var createMakeNodeFunction = util.createMakeNodeFunction;
	  var ConstantNode = math.expression.node.ConstantNode;
	  var OperatorNode = math.expression.node.OperatorNode;
	  var FunctionNode = math.expression.node.FunctionNode;
	
	  function simplifyConstant(expr) {
	    var res = foldFraction(expr);
	    return type.isNode(res) ? res : _toNode(res);
	  }
	
	  function _eval(fnname, args) {
	    try {
	      return _toNumber(math[fnname].apply(null, args));
	    }
	    catch (ignore) {
	      // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
	      args = args.map(function(x){
	        if (type.isFraction(x)) {
	          return x.valueOf();
	        }
	        return x;
	      });
	      return _toNumber(math[fnname].apply(null, args));
	    }
	  }
	
	  var _toNode = typed({
	    'Fraction': _fractionToNode,
	    'number': function(n) {
	      if (n < 0) {
	        return unaryMinusNode(new ConstantNode(-n));
	      }
	      return new ConstantNode(n);
	    },
	    'BigNumber': function(n) {
	      if (n < 0) {
	        return unaryMinusNode(new ConstantNode(n.negated().toString(), 'number'));
	      }
	      return new ConstantNode(n.toString(), 'number');
	    },
	    'Complex': function(s) {
	      throw 'Cannot convert Complex number to Node';
	    }
	  });
	
	  // convert a number to a fraction only if it can be expressed exactly
	  function _exactFraction(n) {
	    if (isFinite(n)) {
	      var f = math.fraction(n);
	      if (f.valueOf() === n) {
	        return f;
	      }
	    }
	    return n;
	  }
	
	  // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
	  // BigNumbers are left alone
	  var _toNumber = typed({
	    'string': function(s) {
	      if (config.number === 'BigNumber') {
	        return math.bignumber(s);
	      }
	      else if (config.number === 'Fraction') {
	        return math.fraction(s);
	      }
	      else {
	        return _exactFraction(parseFloat(s));
	      }
	    },
	
	    'Fraction': function(s) { return s; },
	
	    'BigNumber': function(s) { return s; },
	
	    'number': function(s) {
	      return _exactFraction(s);
	    },
	
	    'Complex': function(s) {
	      if (s.im !== 0) {
	        return s;
	      }
	      return _exactFraction(s.re);
	    },
	  });
	
	  function unaryMinusNode(n) {
	    return new OperatorNode('-', 'unaryMinus', [n]);
	  }
	
	  function _fractionToNode(f) {
	    var n;
	    var vn = f.s*f.n;
	    if (vn < 0) {
	      n = new OperatorNode('-', 'unaryMinus', [new ConstantNode(-vn)])
	    }
	    else {
	      n = new ConstantNode(vn);
	    }
	
	    if (f.d === 1) {
	      return n;
	    }
	    return new OperatorNode('/', 'divide', [n, new ConstantNode(f.d)]);
	  }
	
	  /*
	   * Create a binary tree from a list of Fractions and Nodes.
	   * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
	   * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
	   * @param args - list of Fractions and Nodes
	   * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
	   * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
	   * if args.length is 1, returns args[0]
	   * @return - Either a Node representing a binary expression or Fraction
	   */
	  function foldOp(fn, args, makeNode) {
	    return args.reduce(function(a, b) {
	      if (!type.isNode(a) && !type.isNode(b)) {
	        try {
	          return _eval(fn, [a,b]);
	        }
	        catch (ignoreandcontinue) {}
	        a = _toNode(a);
	        b = _toNode(b);
	      }
	      else if (!type.isNode(a)) {
	        a = _toNode(a);
	      }
	      else if (!type.isNode(b)) {
	        b = _toNode(b);
	      }
	
	      return makeNode([a, b]);
	    });
	  }
	
	  // destroys the original node and returns a folded one
	  function foldFraction(node) {
	    switch(node.type) {
	      case 'SymbolNode':
	        return node;
	      case 'ConstantNode':
	        if (typeof node.value === 'number') {
	          return _toNumber(node.value);
	        }
	        return node;
	      case 'FunctionNode':
	        if (math[node.name] && math[node.name].rawArgs) {
	          return node;
	        }
	
	        // Process operators as OperatorNode
	        var operatorFunctions = [ 'add', 'multiply' ];
	        if (operatorFunctions.indexOf(node.name) === -1) {
	          var args = node.args.map(foldFraction);
	
	          // If all args are numbers
	          if (!args.some(type.isNode)) {
	            try {
	              return _eval(node.name, args);
	            }
	            catch (ignoreandcontine) {}
	          }
	
	          // Convert all args to nodes and construct a symbolic function call
	          args = args.map(function(arg) {
	            return type.isNode(arg) ? arg : _toNode(arg);
	          });
	          return new FunctionNode(node.name, args);
	        }
	        else {
	          // treat as operator
	        }
	        /* falls through */
	      case 'OperatorNode':
	        var fn = node.fn.toString();
	        var args;
	        var res;
	        var makeNode = createMakeNodeFunction(node);
	        if (node.isUnary()) {
	          args = [foldFraction(node.args[0])];
	          if (!type.isNode(args[0])) {
	            res = _eval(fn, args);
	          }
	          else {
	            res = makeNode(args);
	          }
	        }
	        else if (isAssociative(node)) {
	          args = allChildren(node);
	          args = args.map(foldFraction);
	
	          if (isCommutative(fn)) {
	            // commutative binary operator
	            var consts = [], vars = [];
	
	            for (var i=0; i < args.length; i++) {
	              if (!type.isNode(args[i])) {
	                consts.push(args[i]);
	              }
	              else {
	                vars.push(args[i]);
	              }
	            }
	
	            if (consts.length > 1) {
	              res = foldOp(fn, consts, makeNode);
	              vars.unshift(res);
	              res = foldOp(fn, vars, makeNode);
	            }
	            else {
	              // we won't change the children order since it's not neccessary
	              res = foldOp(fn, args, makeNode);
	            }
	          }
	          else {
	            // non-commutative binary operator
	            res = foldOp(fn, args, makeNode);
	          }
	        }
	        else {
	          // non-associative binary operator
	          args = node.args.map(foldFraction);
	          res = foldOp(fn, args, makeNode);
	        }
	        return res;
	      case 'ParenthesisNode':
	        // remove the uneccessary parenthesis
	        return foldFraction(node.content);
	      case 'AccessorNode':
	        /* falls through */
	      case 'ArrayNode':
	        /* falls through */
	      case 'AssignmentNode':
	        /* falls through */
	      case 'BlockNode':
	        /* falls through */
	      case 'FunctionAssignmentNode':
	        /* falls through */
	      case 'IndexNode':
	        /* falls through */
	      case 'ObjectNode':
	        /* falls through */
	      case 'RangeNode':
	        /* falls through */
	      case 'UpdateNode':
	        /* falls through */
	      case 'ConditionalNode':
	        /* falls through */
	      default:
	        throw 'Unimplemented node type in simplifyConstant: '+node.type;
	    }
	  }
	
	  return simplifyConstant;
	}
	
	exports.math = true;
	exports.name = 'simplifyConstant';
	exports.path = 'algebra.simplify';
	exports.factory = factory;


/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory(type, config, load, typed, math) {
	  var FunctionNode = math.expression.node.FunctionNode;
	  var OperatorNode = math.expression.node.OperatorNode;
	  var SymbolNode = math.expression.node.SymbolNode;
	
	  // TODO commutative/associative properties rely on the arguments
	  // e.g. multiply is not commutative for matrices
	  // The properties should be calculated from an argument to simplify, or possibly something in math.config
	  // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
	  var commutative = {
	    'add': true,
	    'multiply': true
	  }
	  var associative = {
	    'add': true,
	    'multiply': true
	  }
	
	
	  function isCommutative(node, context) {
	    if (!type.isOperatorNode(node)) {
	      return true;
	    }
	    var name = node.fn.toString();
	    if (context && context.hasOwnProperty(name) && context[name].hasOwnProperty('commutative')) {
	      return context[name].commutative;
	    }
	    return commutative[name] || false;
	  }
	
	  function isAssociative(node, context) {
	    if (!type.isOperatorNode(node)) {
	      return false;
	    }
	    var name = node.fn.toString();
	    if (context && context.hasOwnProperty(name) && context[name].hasOwnProperty('associative')) {
	      return context[name].associative;
	    }
	    return associative[name] || false;
	  }
	
	  /**
	   * Flatten all associative operators in an expression tree.
	   * Assumes parentheses have already been removed.
	   */
	  function flatten(node) {
	    if (!node.args || node.args.length === 0) {
	      return node;
	    }
	    node.args = allChildren(node);
	    for (var i=0; i<node.args.length; i++) {
	      flatten(node.args[i]);
	    }
	  }
	
	  /**
	   * Get the children of a node as if it has been flattened.
	   * TODO implement for FunctionNodes
	   */
	  function allChildren(node) {
	    var op;
	    var children = [];
	    var findChildren = function(node) {
	      for (var i = 0; i < node.args.length; i++) {
	        var child = node.args[i];
	        if (type.isOperatorNode(child) && op === child.op) {
	          findChildren(child);
	        }
	        else {
	          children.push(child);
	        }
	      }
	    };
	
	    if (isAssociative(node)) {
	      op = node.op;
	      findChildren(node);
	      return children;
	    }
	    else {
	      return node.args;
	    }
	  }
	
	  /**
	   *  Unflatten all flattened operators to a right-heavy binary tree.
	   */
	  function unflattenr(node) {
	    if (!node.args || node.args.length === 0) {
	      return;
	    }
	    var makeNode = createMakeNodeFunction(node);
	    var l = node.args.length;
	    for (var i = 0; i < l; i++) {
	      unflattenr(node.args[i])
	    }
	    if (l > 2 && isAssociative(node)) {
	      var curnode = node.args.pop();
	      while (node.args.length > 0) {
	        curnode = makeNode([node.args.pop(), curnode]);
	      }
	      node.args = curnode.args;
	    }
	  }
	
	  /**
	   *  Unflatten all flattened operators to a left-heavy binary tree.
	   */
	  function unflattenl(node) {
	    if (!node.args || node.args.length === 0) {
	      return;
	    }
	    var makeNode = createMakeNodeFunction(node);
	    var l = node.args.length;
	    for (var i = 0; i < l; i++) {
	      unflattenl(node.args[i])
	    }
	    if (l > 2 && isAssociative(node)) {
	      var curnode = node.args.shift();
	      while (node.args.length > 0) {
	        curnode = makeNode([curnode, node.args.shift()]);
	      }
	      node.args = curnode.args;
	    }
	  }
	
	  function createMakeNodeFunction(node) {
	    if (type.isOperatorNode(node)) {
	      return function(args){
	        try{
	          return new OperatorNode(node.op, node.fn, args);
	        } catch(err){
	          console.error(err);
	          return [];
	        }
	      };
	    }
	    else {
	      return function(args){
	        return new FunctionNode(new SymbolNode(node.name), args);
	      };
	    }
	  }
	  return {
	    createMakeNodeFunction: createMakeNodeFunction,
	    isCommutative: isCommutative,
	    isAssociative: isAssociative,
	    flatten: flatten,
	    allChildren: allChildren,
	    unflattenr: unflattenr,
	    unflattenl: unflattenl
	  };
	}
	
	exports.factory = factory;
	exports.math = true;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory(type, config, load, typed, math) {
	  var equal = load(__webpack_require__(1406));
	  var isZero = load(__webpack_require__(1686));
	  var isNumeric = load(__webpack_require__(1407));
	  var add = load(__webpack_require__(1367));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1400));
	  var divide = load(__webpack_require__(1669));
	  var pow = load(__webpack_require__(1398));
	
	  var ConstantNode = math.expression.node.ConstantNode;
	  var OperatorNode = math.expression.node.OperatorNode;
	  var FunctionNode = math.expression.node.FunctionNode;
	  var ParenthesisNode = math.expression.node.ParenthesisNode;
	
	  var node0 = new ConstantNode(0);
	  var node1 = new ConstantNode(1);
	
	  /**
	   * simplifyCore() performs single pass simplification suitable for
	   * applications requiring ultimate performance. In contrast, simplify()
	   * extends simplifyCore() with additional passes to provide deeper
	   * simplification.
	   *
	   * Syntax:
	   *
	   *     simplify.simplifyCore(expr)
	   *
	   * Examples:
	   *
	   *     var f = math.parse('2 * 1 * x ^ (2 - 1)');
	   *     math.simplify.simpifyCore(f);                          // Node {2 * x}
	   *     math.simplify('2 * 1 * x ^ (2 - 1)', [math.simplify.simpifyCore]); // Node {2 * x};
	   *
	   * See also:
	   *
	   *     derivative
	   *
	   * @param {Node} node
	   *     The expression to be simplified
	   */
	  function simplifyCore(node) {
	    if (type.isOperatorNode(node) && node.isUnary()) {
	      var a0 = simplifyCore(node.args[0]);
	
	      if (node.op === '+') { // unary plus
	        return a0;
	      }
	
	      if (node.op === '-') { // unary minus
	        if (type.isOperatorNode(a0)) {
	          if (a0.isUnary() && a0.op === '-') {
	            return a0.args[0];
	          } else if (a0.isBinary() && a0.fn === 'subtract') {
	            return new OperatorNode('-', 'subtract', [a0.args[1], a0.args[0]]);
	          }
	        }
	        return new OperatorNode(node.op, node.fn, [a0]);
	      }
	    }
	    else if (type.isOperatorNode(node) && node.isBinary()) {
	      var a0 = simplifyCore(node.args[0]);
	      var a1 = simplifyCore(node.args[1]);
	
	      if (node.op === "+") {
	          if (type.isConstantNode(a0)) {
	              if (isZero(a0.value)) {
	                  return a1;
	              } else if (type.isConstantNode(a1)) {
	                return new ConstantNode(add(a0.value, a1.value));
	              }
	          }
	          if (type.isConstantNode(a1) && isZero(a1.value)) {
	              return a0;
	          }
	          if (type.isOperatorNode(a1) && a1.isUnary() && a1.op === '-') {
	              return new OperatorNode('-', 'subtract', [a0,a1.args[0]]);
	          }
	          return new OperatorNode(node.op, node.fn, a1 ? [a0,a1] : [a0]);
	      } else if (node.op === "-") {
	          if (type.isConstantNode(a0) && a1) {
	              if (type.isConstantNode(a1)) {
	                  return new ConstantNode(subtract(a0.value, a1.value));
	              } else if (isZero(a0.value)) {
	                  return new OperatorNode("-", "unaryMinus", [a1]);
	              }
	          }
	          // if (node.fn === "subtract" && node.args.length === 2) {
	          if (node.fn === "subtract") {
	              if (type.isConstantNode(a1) && isZero(a1.value)) {
	                  return a0;
	              }
	              if (type.isOperatorNode(a1) && a1.isUnary() && a1.op === '-') {
	                  return simplifyCore(new OperatorNode("+", "add", [a0, a1.args[0]]));
	              }
	              return new OperatorNode(node.op, node.fn, [a0,a1]);
	          }
	      } else if (node.op === "*") {
	          if (type.isConstantNode(a0)) {
	              if (isZero(a0.value)) {
	                  return node0;
	              } else if (equal(a0.value, 1)) {
	                  return a1;
	              } else if (type.isConstantNode(a1)) {
	                  return new ConstantNode(multiply(a0.value, a1.value));
	              }
	          }
	          if (type.isConstantNode(a1)) {
	              if (isZero(a1.value)) {
	                  return node0;
	              } else if (equal(a1.value, 1)) {
	                  return a0;
	              } else if (type.isOperatorNode(a0) && a0.isBinary() && a0.op === node.op) {
	                  var a00 = a0.args[0];
	                  if (type.isConstantNode(a00)) {
	                      var a00_a1 =  new ConstantNode(multiply(a00.value, a1.value));
	                      return new OperatorNode(node.op, node.fn, [a00_a1, a0.args[1]]); // constants on left
	                  }
	              }
	              return new OperatorNode(node.op, node.fn, [a1, a0]); // constants on left
	          }
	          return new OperatorNode(node.op, node.fn, [a0, a1]);
	      } else if (node.op === "/") {
	          if (type.isConstantNode(a0)) {
	              if (isZero(a0.value)) {
	                  return node0;
	              } else if (type.isConstantNode(a1) &&
	                      (equal(a1.value, 1) || equal(a1.value, 2) || equal(a1.value, 4))) {
	                  return new ConstantNode(divide(a0.value, a1.value));
	              }
	          }
	          return new OperatorNode(node.op, node.fn, [a0, a1]);
	      } else if (node.op === "^") {
	          if (type.isConstantNode(a1)) {
	              if (isZero(a1.value)) {
	                  return node1;
	              } else if (equal(a1.value, 1)) {
	                  return a0;
	              } else {
	                  if (type.isConstantNode(a0)) {
	                      // fold constant
	                      return new ConstantNode(pow(a0.value, a1.value));
	                  } else if (type.isOperatorNode(a0) && a0.isBinary() && a0.op === "^") {
	                      var a01 = a0.args[1];
	                      if (type.isConstantNode(a01)) {
	                          return new OperatorNode(node.op, node.fn, [
	                              a0.args[0], 
	                              new ConstantNode(multiply(a01.value, a1.value))
	                          ]);
	                      }
	                  }
	              }
	          }
	          return new OperatorNode(node.op, node.fn, [a0, a1]);
	      }
	    } else if (type.isParenthesisNode(node)) {
	        var c = simplifyCore(node.content);
	        if (type.isParenthesisNode(c) || type.isSymbolNode(c) || type.isConstantNode(c)) {
	            return c;
	        }
	        return new ParenthesisNode(c);
	    } else if (type.isFunctionNode(node)) {
	          var args = node.args
	              .map(simplifyCore)
	              .map(function (arg) {
	                return type.isParenthesisNode(arg) ? arg.content : arg;
	              });
	          return new FunctionNode(simplifyCore(node.fn), args);
	    } else {
	        // cannot simplify
	    }
	    return node;
	  }
	
	  return simplifyCore;
	}
	
	exports.math = true;
	exports.name = 'simplifyCore';
	exports.path = 'algebra.simplify';
	exports.factory = factory;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is zero.
	   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
	   * `Complex`, and `Unit`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isZero(x)
	   *
	   * Examples:
	   *
	   *    math.isZero(0);                     // returns true
	   *    math.isZero(2);                     // returns false
	   *    math.isZero(0.5);                   // returns false
	   *    math.isZero(math.bignumber(0));     // returns true
	   *    math.isZero(math.fraction(0));      // returns true
	   *    math.isZero(math.fraction(1,3));    // returns false
	   *    math.isZero(math.complex('2 - 4i'); // returns false
	   *    math.isZero(math.complex('0i');     // returns true
	   *    math.isZero('0');                   // returns true
	   *    math.isZero('2');                   // returns false
	   *    math.isZero([2, 0, -3]');           // returns [false, true, false]
	   *
	   * See also:
	   *
	   *    isNumeric, isPositive, isNegative, isInteger
	   *
	   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
	   * @return {boolean}  Returns true when `x` is zero.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isZero = typed('isZero', {
	    'number': function (x) {
	      return x === 0;
	    },
	
	    'BigNumber': function (x) {
	      return x.isZero();
	    },
	
	    'Complex': function (x) {
	      return x.re === 0 && x.im === 0;
	    },
	
	    'Fraction': function (x) {
	      return x.d === 1 && x.n === 0;
	    },
	
	    'Unit': function (x) {
	      return isZero(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isZero);
	    }
	  });
	
	  return isZero;
	}
	
	exports.name = 'isZero';
	exports.factory = factory;


/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory(type, config, load, typed, math) {
	  var Node = math.expression.node.Node;
	  var OperatorNode = math.expression.node.OperatorNode;
	  var FunctionNode = math.expression.node.FunctionNode;
	  var ParenthesisNode = math.expression.node.ParenthesisNode;
	
	  /**
	   * resolve(expr, scope) replaces variable nodes with their scoped values
	   *
	   * Syntax:
	   *
	   *     simplify.resolve(expr, scope)
	   *
	   * Examples:
	   *
	   *     math.simplify.resolve('x + y', {x:1, y:2}) // Node {1 + 2}
	   *     math.simplify.resolve(math.parse('x+y'), {x:1, y:2}) // Node {1 + 2}
	   *     math.simplify('x+y', {x:2, y:'x+x'}).toString(); // "6"
	   *
	   * @param {Node} node
	   *     The expression tree to be simplified
	   * @param {Object} scope with variables to be resolved
	   */
	  function resolve(node, scope) {
	    if (!scope) {
	        return node;
	    }
	    if (type.isSymbolNode(node)) {
	        var value = scope[node.name];
	        if (value instanceof Node) {
	            return resolve(value, scope);
	        } else if (typeof value === 'number') {
	            return math.parse(String(value));
	        }
	    } else if (type.isOperatorNode(node)) {
	        var args = node.args.map(function (arg) {
	          return resolve(arg, scope)
	        });
	        return new OperatorNode(node.op, node.fn, args);
	    } else if (type.isParenthesisNode(node)) {
	        return new ParenthesisNode(resolve(node.content, scope));
	    } else if (type.isFunctionNode(node)) {
	        var args = node.args.map(function (arg) {
	          return resolve(arg, scope)
	        });
	        return new FunctionNode(node.name, args);
	    }
	    return node;
	  }
	
	  return resolve;
	}
	
	exports.math = true;
	exports.name = 'resolve';
	exports.path = 'algebra.simplify';
	exports.factory = factory;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var simplify = load(__webpack_require__(1682));
	  var simplifyCore = load(__webpack_require__(1685));  
	  var simplifyConstant = load(__webpack_require__(1683));  
	  var ArgumentsError = __webpack_require__(1329);
	  var parse = load(__webpack_require__(1647));
	  var number = __webpack_require__(1324)
	  var ConstantNode = load(__webpack_require__(1637));
	  var OperatorNode = load(__webpack_require__(1640));
	  var SymbolNode = load(__webpack_require__(1643));
	
	  /**
	   * Transform a rationalizable expression in a rational fraction. 
	   * If rational fraction is one variable polynomial then converts
	   * the numerator and denominator in canonical form, with decreasing
	   * exponents, returning the coefficients of numerator. 
	   *
	   * Syntax:
	   *
	   *     rationalize(expr)
	   *     rationalize(expr, detailed)
	   *     rationalize(expr, scope)
	   *     rationalize(expr, scope, detailed)
	   *
	   * Examples:
	   *
	   *     math.rationalize('sin(x)+y')  //  Error: There is an unsolved function call
	   *     math.rationalize('2x/y - y/(x+1)')  // (2*x^2-y^2+2*x)/(x*y+y)
	   *     math.rationalize('(2x+1)^6')  
	   *                   //     64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
	   *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3') 
	   *                   //    -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
	   *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
	   *                   //  (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
	   *                   //   (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
	   *
	   *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
	   *     math.rationalize('x+x+x+y',{})    // 3*x+y
	   *     ret = math.rationalize('x+x+x+y',{},true) 
	   *                          // ret.expression=3*x+y,  ret.variables = ["x","y"]
	   *     ret = math.rationalize('-2+5x^2',{},true) 
	   *                          // ret.expression=5*x^2-2,  ret.variables = ["x"], ret.coefficients=[-2,0,5]
	   *
	   * See also:
	   * 
	   *     simplify
	   * 
	   * @param  {Node|string} expr    The expression to check if is a polynomial expression
	   * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
	   * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default) 
	   *
	   * @return {Object | Expression Node}    The rational polynomial of `expr` or na object
	   *            {Object}
	   *              {Expression Node} expression: node simplified expression
	   *              {Expression Node} numerator: simplified numerator of expression
	   *              {Expression Node | boolean} denominator: simplified denominator or false (if there is no denominator)
	   *              {Array}           variables:  variable names
	   *              {Array}           coefficients: coefficients of numerator sorted by increased exponent 
	   *           {Expression Node}  node simplified expression
	   *   
	   */
	  var rationalize = typed('rationalize', {
	    'string': function (expr) {
	       return rationalize(parse(expr), {}, false);  
	    },
	
	    'string, boolean': function (expr, detailed) {
	       return rationalize(parse(expr), {} , detailed); 
	    },
	
	    'string, Object': function (expr, scope) {
	       return rationalize(parse(expr), scope, false);  
	    },
	
	    'string, Object, boolean': function (expr, scope, detailed) {
	       return rationalize(parse(expr), scope, detailed); 
	    },
	
	    'Node': function (expr) {
	       return rationalize(expr, {}, false);
	    },
	
	    'Node, boolean': function (expr, detailed) {
	      return rationalize(expr, {}, detailed);
	    },
	
	    'Node, Object': function (expr, scope) {
	      return rationalize(expr, scope, false);
	    },
	
	    'Node, Object, boolean': function (expr, scope, detailed) {
	
	      var polyRet = polynomial(expr, scope, true)  // Check if expression is a rationalizable polynomial
	      var nVars =  polyRet.variables.length;
	      var expr = polyRet.expression;         
	           
	      if (nVars>=1) {   // If expression in not a constant
	        var setRules = rulesRationalize();   // Rules for change polynomial in near canonical form
	        expr = expandPower(expr);              // First expand power of polynomials (cannot be made from rules!)
	        var redoInic = true;   // If has change after start, redo the beginning
	        var s = "";            // New expression
	        var sBefore;           // Previous expression
	        var rules;  
	        var eDistrDiv = true  
	
	        expr = simplify(expr, setRules.firstRules);  // Apply the initial rules, including succ div rules
	        s = expr.toString();
	
	
	        while (true) {                  // Apply alternately  successive division rules and distr.div.rules
	          rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules
	          expr = simplify(expr,rules);         // until no more changes
	          eDistrDiv = ! eDistrDiv;    // Swap between Distr.Div and Succ. Div. Rules
	          
	          s = expr.toString();
	          if (s===sBefore) break   // No changes : end of the loop
	          
	          redoInic = true;
	          sBefore = s;
	        }  
	       
	        if (redoInic)  {         // Apply first rules again without succ div rules (if there are changes)
	          expr = simplify(expr,setRules.firstRulesAgain); 
	        }
	        expr = simplify(expr,setRules.finalRules);  // Aplly final rules 
	
	      }  // NVars >= 1
	
	      var coefficients=[];
	      var retRationalize = {};
	
	      if (expr.type === 'OperatorNode' && expr.isBinary() && expr.op === '/')  {   // Separate numerator from denominator
	          if (nVars==1)  {
	             expr.args[0] = polyToCanonical(expr.args[0],coefficients);
	             expr.args[1] = polyToCanonical(expr.args[1]);
	          }
	          if (detailed) {
	            retRationalize.numerator = expr.args[0];
	            retRationalize.denominator = expr.args[1];
	          }
	        } else {
	          if (nVars==1) expr = polyToCanonical(expr,coefficients);
	          if (detailed) { 
	            retRationalize.numerator = expr;
	            retRationalize.denominator = null 
	          }
	      }
	       // nVars
	
	      if (! detailed) return expr;
	      retRationalize.coefficients = coefficients;
	      retRationalize.variables = polyRet.variables;
	      retRationalize.expression = expr;
	      return retRationalize;
	    }  // ^^^^^^^ end of rationalize ^^^^^^^^
	  });  // end of typed rationalize
	
	  /**
	   *  Function to simplify an expression using an optional scope and
	   *  return it if the expression is a polynomial expression, i.e. 
	   *  an expression with one or more variables and the operators
	   *  +, -, *, and ^, where the exponent can only be a positive integer. 
	   *
	   * Syntax:
	   *
	   *     polynomial(expr,scope,extended)
	   *
	   * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
	   * @param  {object} scope           Optional scope for expression simplification
	   * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
	   *
	   *
	   * @return {Object} 
	   *            {Object} node:   node simplified expression
	   *            {Array}  variables:  variable names
	   */             
	  function polynomial (expr, scope, extended) {
	    var variables = [];
	    var node = simplify(expr,scope);  // Resolves any variables and functions with all defined parameters   
	    extended = !! extended
	
	    var oper = '+-*' + (extended ? '/' : '');
	    recPoly(node) 
	    var retFunc ={};
	    retFunc.expression = node;
	    retFunc.variables = variables;
	    return retFunc; 
	
	    //-------------------------------------------------------------------------------------------------------
	
	    /**
	     *  Function to simplify an expression using an optional scope and
	     *  return it if the expression is a polynomial expression, i.e. 
	     *  an expression with one or more variables and the operators
	     *  +, -, *, and ^, where the exponent can only be a positive integer. 
	     *
	     * Syntax:
	     *
	     *     recPoly(node)
	     *
	     *
	     * @param  {Node} node               The current sub tree expression in recursion
	     *
	     * @return                           nothing, throw an exception if error
	     */
	    function recPoly(node) {
	      var tp = node.type;  // node type
	      if (tp==='FunctionNode') 
	        throw new ArgumentsError('There is an unsolved function call')   // No function call in polynomial expression
	      else if (tp==='OperatorNode')  {
	        if (node.op === '^' && node.isBinary())  {
	          if (node.args[1].type!=='ConstantNode' ||  ! number.isInteger(parseFloat(node.args[1].value)))
	            throw new ArgumentsError('There is a non-integer exponent');
	          else
	            recPoly(node.args[0]);      
	        } else  { 
	            if (oper.indexOf(node.op) === -1) throw new ArgumentsError('Operator ' + node.op + ' invalid in polynomial expression');
	            for (var i=0;i<node.args.length;i++) { 
	              recPoly(node.args[i]);
	            }
	        } // type of operator
	
	      } else if (tp==='SymbolNode')  {
	         var name = node.name;   // variable name
	         var pos = variables.indexOf(name); 
	         if (pos===-1)    // new variable in expression
	           variables.push(name);        
	
	      } else if (tp==='ParenthesisNode') 
	         recPoly(node.content);
	
	      else if (tp!=='ConstantNode')   
	         throw new ArgumentsError('type ' + tp + ' is not allowed in polynomial expression')
	         
	    }  // end of recPoly
	
	  }  // end of polynomial 
	
	
	  //---------------------------------------------------------------------------------------
	  /**
	   * Return a rule set to rationalize an polynomial expression in rationalize
	   *
	   * Syntax:
	   *
	   *     rulesRationalize()
	   *
	   * @return {array}        rule set to rationalize an polynomial expression 
	   */
	  function rulesRationalize() {
	    var oldRules = [simplifyCore,  // sCore
	                {l:"n+n",r:"2*n"},
	                {l:"n+-n",r:"0"},
	                simplifyConstant,  // sConstant
	                {l:"n*(n1^-1)",r:"n/n1"},
	                {l:"n*n1^-n2",r:"n/n1^n2"},
	                {l:"n1^-1",r:"1/n1"},
	                {l:"n*(n1/n2)",r:"(n*n1)/n2"},
	                {l:"1*n",r:"n"}]
	
	    var rulesFirst = [
	       { l: '(-n1)/(-n2)', r: 'n1/n2' },  // Unary division
	       { l: '(-n1)*(-n2)', r: 'n1*n2' },  // Unary multiplication
	       { l: 'n1--n2', r:'n1+n2'},        // '--' elimination
	       { l: 'n1-n2', r:'n1+(-n2)'} ,      // Subtraction turn into add with un�ry minus    
	       { l:'(n1+n2)*n3', r:'(n1*n3 + n2*n3)' },     // Distributive 1 
	       { l:'n1*(n2+n3)', r:'(n1*n2+n1*n3)' },       // Distributive 2 
	       { l: 'c1*n + c2*n', r:'(c1+c2)*n'} ,       // Joining constants
	       { l: '-v*-c', r:'c*v'} ,          // Inversion constant and variable 1
	       { l: '-v*c', r:'-c*v'} ,          // Inversion constant and variable 2
	       { l: 'v*-c', r:'-c*v'} ,          // Inversion constant and variable 3
	       { l: 'v*c', r:'c*v'} ,            // Inversion constant and variable 4
	       { l: '-(-n1*n2)', r:'(n1*n2)'} ,  // Unary propagation
	       { l: '-(n1*n2)', r:'(-n1*n2)'} ,  // Unary propagation
	       { l: '-(-n1+n2)', r:'(n1-n2)'} ,  // Unary propagation
	       { l: '-(n1+n2)', r:'(-n1-n2)'} ,  // Unary propagation
	       { l: '(n1^n2)^n3', r:'(n1^(n2*n3))'} ,  // Power to Power
	       { l: '-(-n1/n2)', r:'(n1/n2)'} ,   // Division and Unary
	       { l: '-(n1/n2)', r:'(-n1/n2)'} ];   // Divisao and Unary
	
	    var rulesDistrDiv=[
	       { l:'(n1/n2 + n3/n4)', r:'((n1*n4 + n3*n2)/(n2*n4))' },  // Sum of fractions
	       { l:'(n1/n2 + n3)', r:'((n1 + n3*n2)/n2)' }, // Sum fraction with number 1
	       { l:'(n1 + n2/n3)', r:'((n1*n3 + n2)/n3)' }  ];  // Sum fraction with number 1
	
	    var rulesSucDiv=[
	       { l:'(n1/(n2/n3))', r:'((n1*n3)/n2)'} , // Division simplification
	       { l:'(n1/n2/n3)', r:'(n1/(n2*n3))' } ]
	
	    var setRules={};   // rules set in 4 steps. 
	
	        // All rules => infinite loop
	        // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv);  
	
	    setRules.firstRules =oldRules.concat(rulesFirst,rulesSucDiv);  // First rule set
	    setRules.distrDivRules = rulesDistrDiv;                  // Just distr. div. rules  
	    setRules.sucDivRules = rulesSucDiv;                      // Jus succ. div. rules
	    setRules.firstRulesAgain = oldRules.concat(rulesFirst);  // Last rules set without succ. div. 
	
	           // Division simplification
	          
	         // Second rule set. 
	          // There is no aggregate expression with parentesis, but the only variable can be scattered. 
	    setRules.finalRules=[ simplifyCore,                // simplify.rules[0]
	       { l: 'n*-n', r: '-n^2' },                // Joining multiply with power 1
	       { l: 'n*n', r: 'n^2' },                  // Joining multiply with power 2
	        simplifyConstant,                              // simplify.rules[14] old 3rd index in oldRules
	       { l: 'n*-n^n1', r: '-n^(n1+1)' },        // Joining multiply with power 3
	       { l: 'n*n^n1', r: 'n^(n1+1)' },          // Joining multiply with power 4
	       { l: 'n^n1*-n^n2', r: '-n^(n1+n2)' },    // Joining multiply with power 5
	       { l: 'n^n1*n^n2', r: 'n^(n1+n2)' },      // Joining multiply with power 6
	       { l: 'n^n1*-n', r: '-n^(n1+1)' },        // Joining multiply with power 7
	       { l: 'n^n1*n', r: 'n^(n1+1)' },          // Joining multiply with power 8
	       { l: 'n^n1/-n', r: '-n^(n1-1)' },        // Joining multiply with power 8
	       { l: 'n^n1/n', r: 'n^(n1-1)' },          // Joining division with power 1
	       { l: 'n/-n^n1', r: '-n^(1-n1)' },        // Joining division with power 2
	       { l: 'n/n^n1', r: 'n^(1-n1)' },          // Joining division with power 3
	       { l: 'n^n1/-n^n2', r: 'n^(n1-n2)' },     // Joining division with power 4
	       { l: 'n^n1/n^n2', r: 'n^(n1-n2)' },      // Joining division with power 5
	       { l: 'n1+(-n2*n3)', r: 'n1-n2*n3' },     // Solving useless parenthesis 1 
	       { l: 'v*(-c)', r: '-c*v' },              // Solving useless unary 2 
	       { l: 'n1+-n2', r: 'n1-n2' },             // Solving +- together (new!)
	       { l: 'v*c', r: 'c*v' },                  // inversion constant with variable
	       { l: '(n1^n2)^n3', r:'(n1^(n2*n3))'},    // Power to Power
	       
	    ];                    
	    return setRules;
	  } // End rulesRationalize
	
	  //---------------------------------------------------------------------------------------
	  /**
	   *  Expand recursively a tree node for handling with expressions with exponents
	   *  (it's not for constants, symbols or functions with exponents)
	   *  PS: The other parameters are internal for recursion
	   *
	   * Syntax:
	   *
	   *     expandPower(node)
	   *
	   * @param  {Node} node         Current expression node
	   * @param  {node} parent       Parent current node inside the recursion
	   * @param  (int}               Parent number of chid inside the rercursion 
	   *
	   * @return {node}        node expression with all powers expanded. 
	   */
	  function expandPower(node,parent,indParent) {
	    var tp = node.type; 
	    var internal = (arguments.length>1)   // TRUE in internal calls
	
	    if (tp === 'OperatorNode' && node.isBinary()) {
	      var does = false;
	      if (node.op==='^')  {   // First operator: Parenthesis or UnaryMinus
	        if ( ( node.args[0].type==='ParenthesisNode' ||  
	            node.args[0].type==='OperatorNode' ) 
	            && (node.args[1].type==='ConstantNode') )  {   // Second operator: Constant
	          var val = parseFloat(node.args[1].value);
	          does = (val>=2 && number.isInteger(val));  
	        }
	      } 
	
	      if (does)  {  // Exponent >= 2 
	          //Before:
	          //            operator A --> Subtree
	          // parent pow 
	          //            constant
	          //
	        if (val>2)     {  // Exponent > 2, 
	          //AFTER:  (exponent > 2)
	          //             operator A --> Subtree
	          // parent  * 
	          //                 deep clone (operator A --> Subtree
	          //             pow     
	          //                 constant - 1
	          //
	           var nEsqTopo = node.args[0];  
	           var nDirTopo = new OperatorNode('^', 'pow', [node.args[0].cloneDeep(),new ConstantNode(val-1)]);
	           node = new OperatorNode('*', 'multiply', [nEsqTopo, nDirTopo]);
	        } else   // Expo = 2 - no power
	
	            //AFTER:  (exponent =  2)
	            //             operator A --> Subtree
	            // parent   oper 
	            //            deep clone (operator A --> Subtree)    
	            //                            
	           node = new OperatorNode('*', 'multiply', [node.args[0], node.args[0].cloneDeep()]);
	        
	        if (internal)       // Change parent references in internal recursive calls
	          if (indParent==='content')
	            parent.content = node;
	          else
	            parent.args[indParent] = node
	      } // does
	    } // binary OperatorNode
	
	    if (tp==='ParenthesisNode' )  // Recursion 
	           expandPower(node.content,node,'content');  
	    else if (tp!=='ConstantNode' && tp!=='SymbolNode')  
	      for (var i=0;i<node.args.length;i++)  
	         expandPower(node.args[i],node,i);
	        
	      
	    if (! internal ) return node   // return the root node
	
	  }  // End expandPower
	
	
	  //---------------------------------------------------------------------------------------
	  /**
	   * Auxilary function for rationalize
	   * Convert near canonical polynomial in one variable in a canonical polynomial
	   * with one term for each exponent in decreasing order
	   *
	   * Syntax:
	   *
	   *     polyToCanonical(node [, coefficients])
	   *
	   * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
	   * 
	   *        The string or tree expression needs to be at below syntax, with free spaces:
	   *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
	   *       Where 'var' is one variable with any valid name
	   *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
	   *             'expo' are integers greater than 0. It can be omitted if equal than 1.
	   *
	   * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent 
	   *
	   *
	   * @return {node}        new node tree with one variable polynomial or string error. 
	   */
	  function polyToCanonical(node,coefficients) {
	    var i;
	
	    if (coefficients===undefined)
	       coefficients = []; // coefficients.
	
	    coefficients[0] = 0;   // index is the exponent
	    var o = {};
	    o.cte=1; 
	    o.oper='+'; 
	
	     // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -. 
	     //       It is used to deduce the exponent: 1 for *, 0 for "". 
	    o.fire='';  
	
	    var maxExpo=0;   // maximum exponent
	    var varname='';  // var name 
	
	    recurPol(node,null,o);    
	    maxExpo = coefficients.length-1;
	    var first=true;
	
	    for (i=maxExpo;i>=0 ;i--)  {
	      if (coefficients[i]===0)  continue;
	      var n1  = new ConstantNode(
	                      first ? coefficients[i] : Math.abs(coefficients[i]));
	      var op = coefficients[i]<0  ? '-' : '+';
	
	      if (i>0)   {  // Is not a constant without variable 
	        var n2 = new SymbolNode(varname);    
	        if (i>1)  {
	          var n3 =  new ConstantNode(i);     
	          n2 = new OperatorNode('^', 'pow', [n2, n3]); 
	        }
	        if (coefficients[i]===-1  && first) 
	          n1 = new OperatorNode('-', 'unaryMinus', [n2]);          
	        else if (Math.abs(coefficients[i])===1)  
	          n1 = n2;
	        else
	          n1 = new OperatorNode('*', 'multiply', [n1, n2]); 
	      }
	
	      var no;
	      if (first)   
	        no = n1;
	      else if (op==='+')
	        no = new OperatorNode('+', 'add', [no, n1]);
	      else
	        no = new OperatorNode('-', 'subtract', [no, n1]);
	
	      first = false;
	    }  // for 
	
	    if (first) 
	      return new ConstantNode(0);
	    else
	      return no;
	
	    /**
	     * Recursive auxilary function inside polyToCanonical for
	     * converting expression in canonical form
	     *
	     * Syntax:
	     *
	     *     recurPol(node, noPai, obj)
	     *
	     * @param  {Node} node        The current subpolynomial expression 
	     * @param  {Node | Null}  noPai   The current parent node
	     * @param  {object}    obj        Object with many internal flags
	     *
	     * @return {}                    No return. If error, throws an exception
	     */
	    function recurPol(node,noPai,o) {
	
	      var tp = node.type; 
	      if (tp==='FunctionNode')            // ***** FunctionName *****
	                // No function call in polynomial expression
	        throw new ArgumentsError('There is an unsolved function call')
	
	      else if (tp==='OperatorNode')  {    // ***** OperatorName *****
	        if ('+-*^'.indexOf(node.op) === -1) throw new ArgumentsError('Operator ' + node.op + ' invalid');
	
	        if (noPai!==null)  {
	            // -(unary),^  : children of *,+,-
	          if ( (node.fn==='unaryMinus' || node.fn==='pow') && noPai.fn !=='add' &&  
	                                noPai.fn!=='subtract'  &&  noPai.fn!=='multiply' )
	            throw new ArgumentsError('Invalid ' + node.op +  ' placing')
	
	            // -,+,* : children of +,- 
	          if ((node.fn==='subtract' || node.fn==='add' || node.fn==='multiply')  && 
	              noPai.fn!=='add' &&  noPai.fn!=='subtract' )
	            throw new ArgumentsError('Invalid ' + node.op +  ' placing'); 
	        
	           // -,+ : first child
	        if ((node.fn==='subtract' || node.fn==='add' ||                
	            node.fn==='unaryMinus' )  && o.noFil!==0 )                  
	            throw new ArgumentsError('Invalid ' + node.op +  ' placing')
	         } // Has parent    
	
	        // Firers: ^,*       Old:   ^,&,-(unary): firers
	        if (node.op==='^' || node.op==='*') o.fire = node.op;
	
	        for (var i=0;i<node.args.length;i++)  {
	           // +,-: reset fire
	          if (node.fn==='unaryMinus') o.oper='-';
	          if (node.op==='+' || node.fn==='subtract' ) {    
	            o.fire = '';  
	            o.cte = 1;   // default if there is no constant
	            o.oper = (i===0 ? '+' : node.op);
	          }
	          o.noFil = i;  // number of son
	          recurPol(node.args[i],node,o);
	        } // for in children
	
	      } else if (tp==='SymbolNode') {      // ***** SymbolName *****
	        if (node.name !== varname && varname!=='')
	          throw new ArgumentsError('There is more than one variable')
	        varname = node.name;   
	        if (noPai === null)  {
	            coefficients[1] = 1; 
	            return;
	        }   
	
	          // ^: Symbol is First child
	        if (noPai.op==='^' && o.noFil!==0 ) 
	           throw new ArgumentsError('In power the variable should be the first parameter')
	
	          // *: Symbol is Second child 
	        if (noPai.op==='*' && o.noFil!==1 ) 
	           throw new ArgumentsError('In multiply the variable should be the second parameter')
	
	          // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var) 
	        if (o.fire==='' || o.fire==='*' )   {
	          if (maxExpo<1) coefficients[1]=0;
	          coefficients[1] += o.cte* (o.oper==='+'  ? 1 : -1);
	          maxExpo = Math.max(1,maxExpo);
	        }
	
	      } else if (tp==='ConstantNode') {
	        var valor =  parseFloat(node.value);
	        if (noPai === null)  {
	          coefficients[0] = valor;
	          return;
	        }   
	        if (noPai.op==='^')  {
	           // cte: second  child of power
	          if (o.noFil!==1) throw new ArgumentsError('Constant cannot be powered')
	
	          if (! number.isInteger(valor) || valor<=0 )
	            throw new ArgumentsError('Non-integer exponent is not allowed');
	
	          for (var i=maxExpo+1;i<valor;i++) coefficients[i]=0;
	          if (valor>maxExpo) coefficients[valor]=0;
	          coefficients[valor] += o.cte * (o.oper==='+' ? 1 : -1) 
	          maxExpo = Math.max(valor,maxExpo);
	          return;
	        }
	        o.cte = valor;
	
	        // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0. 
	        if (o.fire==='')  
	          coefficients[0] += o.cte * (o.oper==='+'? 1 : -1);
	
	
	      } else 
	         throw new ArgumentsError('Type ' + tp + ' is not allowed');
	      return;
	    } // End of recurPol
	 
	  } // End of polyToCanonical
	
	  return rationalize;
	} // end of factory
	
	exports.name = 'rationalize';
	exports.factory = factory;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var zeros = load(__webpack_require__(1405));
	  var eye = load(__webpack_require__(1399));
	  var clone = load(__webpack_require__(1690));
	  
	  var isZero = load(__webpack_require__(1686));
	  var isPositive = load(__webpack_require__(1691));
	  var unequal = load(__webpack_require__(1692));
	    
	  var abs = load(__webpack_require__(1402));
	  var sign = load(__webpack_require__(1693));
	  var sqrt = load(__webpack_require__(1694));
	  var conj = load(__webpack_require__(1695));
	  
	  var unaryMinus = load(__webpack_require__(1394)); 
	  var addScalar = load(__webpack_require__(1369));  
	  var divideScalar = load(__webpack_require__(1397));
	  var multiplyScalar = load(__webpack_require__(1396));  
	  var subtract = load(__webpack_require__(1393));
	    
	  
	  /**
	   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in 
	   * two matrices (`Q`, `R`) where `Q` is an 
	   * orthogonal matrix and `R` is an upper triangular matrix.
	   *
	   * Syntax:
	   *
	   *    math.qr(A);
	   *
	   * Example:
	   *
	   *    var m = [
	   *      [1, -1,  4],
	   *      [1,  4, -2],
	   *      [1,  4,  2],
	   *      [1,  -1, 0]
	   *    ];
	   *    var result = math.qr(m);
	   *    // r = {
	   *    //   Q: [
	   *    //     [0.5, -0.5,   0.5],
	   *    //     [0.5,  0.5,  -0.5],
	   *    //     [0.5,  0.5,   0.5],
	   *    //     [0.5, -0.5,  -0.5],
	   *    //   ],
	   *    //   R: [
	   *    //     [2, 3,  2],
	   *    //     [0, 5, -2],
	   *    //     [0, 0,  4],
	   *    //     [0, 0,  0]
	   *    //   ]
	   *    // }
	   *
	   * See also:
	   *
	   *    lu
	   *
	   * @param {Matrix | Array} A    A two dimensional matrix or array 
	   * for which to get the QR decomposition.
	   *
	   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
	   * matrix and R: the upper triangular matrix
	   */
	  var qr = typed('qr', {
	
	    'DenseMatrix': function (m) {
	      return _denseQR(m);
	    },
	    
	    'SparseMatrix': function (m) {
	      return _sparseQR(m);
	    },
	
	    'Array': function (a) {
	      // create dense matrix from array
	      var m = matrix(a);
	      // lup, use matrix implementation
	      var r = _denseQR(m);
	      // result
	      return {
	        Q: r.Q.valueOf(),
	        R: r.R.valueOf()
	      };
	    }
	  });
	
	  var _denseQR = function (m) {
	    
	    // rows & columns (m x n)
	    var rows = m._size[0]; // m
	    var cols = m._size[1]; // n
	            
	    var Q = eye([rows], 'dense');
	    var Qdata = Q._data;
	    
	    var R = m.clone();
	    var Rdata = R._data;
	    
	    // vars
	    var i, j, k;
	        
	    var w = zeros([rows], '');
	    
	    for (k = 0; k < Math.min(cols, rows); ++k) {
	      
	      /*
	       * **k-th Household matrix**
	       *
	       * The matrix I - 2*v*transpose(v)
	       * x     = first column of A
	       * x1    = first element of x
	       * alpha = x1 / |x1| * |x|
	       * e1    = tranpose([1, 0, 0, ...])
	       * u     = x - alpha * e1
	       * v     = u / |u|
	       *
	       * Household matrix = I - 2 * v * tranpose(v)
	       *
	       *  * Initially Q = I and R = A.
	       *  * Household matrix is a reflection in a plane normal to v which 
	       *    will zero out all but the top right element in R.
	       *  * Appplying reflection to both Q and R will not change product.
	       *  * Repeat this process on the (1,1) minor to get R as an upper 
	       *    triangular matrix.
	       *  * Reflections leave the magnitude of the columns of Q unchanged 
	       *    so Q remains othoganal.
	       *
	       */  
	      
	      var pivot = Rdata[k][k];          
	      var sgn = unaryMinus(sign(pivot));
	      var conjSgn = conj(sgn);
	      
	      var alphaSquared = 0;
	
	      for(i = k; i < rows; i++) {
	        alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));        
	      }
	      
	      var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
	      
	      
	      if (!isZero(alpha)) {
	          
	        // first element in vector u
	        var u1 = subtract(pivot, alpha);
	        
	        // w = v * u1 / |u|    (only elements k to (rows-1) are used)    
	        w[k] = 1;
	        
	        for (i = k+1; i < rows; i++) {
	          w[i] = divideScalar(Rdata[i][k], u1);
	        }        
	         
	        // tau = - conj(u1 / alpha)
	        var tau = unaryMinus(conj(divideScalar(u1, alpha)));
	        
	        var s;
	        
	        /*
	         * tau and w have been choosen so that
	         * 
	         * 2 * v * tranpose(v) = tau * w * tranpose(w)
	         */
	         
	        /*
	         * -- calculate R = R - tau * w * tranpose(w) * R --
	         * Only do calculation with rows k to (rows-1)
	         * Additionally columns 0 to (k-1) will not be changed by this
	         *   multiplication so do not bother recalculating them
	         */
	        for (j = k; j < cols; j++) {
	          s = 0.0;
	          
	          // calculate jth element of [tranpose(w) * R]
	          for (i = k; i < rows; i++) {
	            s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
	          }
	          
	          // calculate the jth element of [tau * transpose(w) * R]
	          s = multiplyScalar(s, tau);
	          
	          for (i = k; i < rows; i++) {
	            Rdata[i][j] = multiplyScalar(
	              subtract(Rdata[i][j], multiplyScalar(w[i], s)), 
	              conjSgn
	            );            
	          }          
	        }
	        /*
	         * -- calculate Q = Q - tau * Q * w * transpose(w) --
	         * Q is a square matrix (rows x rows)
	         * Only do calculation with columns k to (rows-1)
	         * Additionally rows 0 to (k-1) will not be changed by this
	         *   multiplication so do not bother recalculating them
	         */
	        for (i = 0; i < rows; i++) {
	          s = 0.0;
	          
	          // calculate ith element of [Q * w]
	          for (j = k; j < rows; j++) {
	            s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
	          }
	          
	          // calculate the ith element of [tau * Q * w]
	          s = multiplyScalar(s, tau);
	          
	          for (j = k; j < rows; ++j) {
	            Qdata[i][j] = divideScalar(
	              subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), 
	              conjSgn
	            );
	          }
	          
	        }
	      }
	      
	    }
	    
	    // coerse almost zero elements to zero
	    // TODO I feel uneasy just zeroing these values
	    for (i = 0; i < rows; ++i) {
	      for (j = 0; j < i && j < cols; ++j) {
	        if (unequal(0, divideScalar(Rdata[i][j], 1e5))) {
	          throw new Error('math.qr(): unknown error - ' + 
	           'R is not lower triangular (element (' + 
	            i + ', ' + j + ')  = ' + Rdata[i][j] + ')'
	          );
	        }
	        Rdata[i][j] = multiplyScalar(Rdata[i][j], 0);
	      }
	    }
	    
	    // return matrices
	    return { 
	      Q: Q,
	      R: R,
	      toString: function () {
	        return 'Q: ' + this.Q.toString() + '\nR: ' + this.R.toString();
	      }
	    };
	  };
	  
	  var _sparseQR = function (m) {
	    
	    throw new Error('qr not implemented for sparse matrices yet');
	  
	  };
	  
	  return qr;
	}
	
	exports.name = 'qr';
	exports.factory = factory;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object= __webpack_require__(1320);
	
	function factory (type, config, load, typed) {
	  /**
	   * Clone an object.
	   *
	   * Syntax:
	   *
	   *     math.clone(x)
	   *
	   * Examples:
	   *
	   *    math.clone(3.5);                   // returns number 3.5
	   *    math.clone(math.complex('2-4i'); // returns Complex 2 - 4i
	   *    math.clone(math.unit(45, 'deg'));  // returns Unit 45 deg
	   *    math.clone([[1, 2], [3, 4]]);      // returns Array [[1, 2], [3, 4]]
	   *    math.clone("hello world");         // returns string "hello world"
	   *
	   * @param {*} x   Object to be cloned
	   * @return {*} A clone of object x
	   */
	  var clone = typed('clone', {
	    'any': object.clone
	  });
	
	  clone.toTex = undefined; // use default template
	
	  return clone;
	}
	
	exports.name = 'clone';
	exports.factory = factory;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is positive: larger than zero.
	   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isPositive(x)
	   *
	   * Examples:
	   *
	   *    math.isPositive(3);                     // returns true
	   *    math.isPositive(-2);                    // returns false
	   *    math.isPositive(0);                     // returns false
	   *    math.isPositive(-0);                    // returns false
	   *    math.isPositive(0.5);                   // returns true
	   *    math.isPositive(math.bignumber(2));     // returns true
	   *    math.isPositive(math.fraction(-2, 5));  // returns false
	   *    math.isPositive(math.fraction(1,3));    // returns false
	   *    math.isPositive('2');                   // returns true
	   *    math.isPositive([2, 0, -3]');           // returns [true, false, false]
	   *
	   * See also:
	   *
	   *    isNumeric, isZero, isNegative, isInteger
	   *
	   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
	   * @return {boolean}  Returns true when `x` is larger than zero.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isPositive = typed('isPositive', {
	    'number': function (x) {
	      return x > 0;
	    },
	
	    'BigNumber': function (x) {
	      return !x.isNeg() && !x.isZero() && !x.isNaN();
	    },
	
	    'Fraction': function (x) {
	      return x.s > 0 && x.n > 0;
	    },
	
	    'Unit': function (x) {
	      return isPositive(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isPositive);
	    }
	  });
	
	  return isPositive;
	}
	
	exports.name = 'isPositive';
	exports.factory = factory;


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether two values are unequal.
	   *
	   * The function tests whether the relative difference between x and y is
	   * larger than the configured epsilon. The function cannot be used to compare
	   * values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
	   * Strings are compared by their numerical value.
	   *
	   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
	   * with everything except `null`, and `undefined` is unequal with everything
	   * except `undefined`.
	   *
	   * Syntax:
	   *
	   *    math.unequal(x, y)
	   *
	   * Examples:
	   *
	   *    math.unequal(2 + 2, 3);       // returns true
	   *    math.unequal(2 + 2, 4);       // returns false
	   *
	   *    var a = math.unit('50 cm');
	   *    var b = math.unit('5 m');
	   *    math.unequal(a, b);           // returns false
	   *
	   *    var c = [2, 5, 1];
	   *    var d = [2, 7, 1];
	   *
	   *    math.unequal(c, d);           // returns [false, true, false]
	   *    math.deepEqual(c, d);         // returns false
	   *
	   *    math.unequal(0, null);        // returns true
	   * See also:
	   *
	   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
	   */
	  var unequal = typed('unequal', {
	    
	    'any, any': function (x, y) {
	      // strict equality for null and undefined?
	      if (x === null) { return y !== null; }
	      if (y === null) { return x !== null; }
	      if (x === undefined) { return y !== undefined; }
	      if (y === undefined) { return x !== undefined; }
	
	      return _unequal(x, y);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, _unequal);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, _unequal, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, _unequal, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, _unequal);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return unequal(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return unequal(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return unequal(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, _unequal, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, _unequal, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, _unequal, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, _unequal, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, _unequal, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, _unequal, true).valueOf();
	    }
	  });
	
	  var _unequal = typed('_unequal', {
	
	    'boolean, boolean': function (x, y) {
	      return x !== y;
	    },
	
	    'number, number': function (x, y) {
	      return !nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return !bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return !x.equals(y);
	    },
	
	    'Complex, Complex': function (x, y) {
	      return !x.equals(y);
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return unequal(x.value, y.value);
	    }
	  });
	
	  unequal.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['unequal'] + '${args[1]}\\right)'
	  };
	
	  return unequal;
	}
	
	exports.name = 'unequal';
	exports.factory = factory;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var number = __webpack_require__(1324);
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the sign of a value. The sign of a value x is:
	   *
	   * -  1 when x > 1
	   * - -1 when x < 0
	   * -  0 when x == 0
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sign(x)
	   *
	   * Examples:
	   *
	   *    math.sign(3.5);               // returns 1
	   *    math.sign(-4.2);              // returns -1
	   *    math.sign(0);                 // returns 0
	   *
	   *    math.sign([3, 5, -2, 0, 2]);  // returns [1, 1, -1, 0, 1]
	   *
	   * See also:
	   *
	   *    abs
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
	   *            The number for which to determine the sign
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
	   *            The sign of `x`
	   */
	  var sign = typed('sign', {
	    'number': number.sign,
	
	    'Complex': function (x) {
	      return x.sign();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(x.cmp(0));
	    },
	
	    'Fraction': function (x) {
	      return new type.Fraction(x.s, 1);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since sign(0) = 0
	      return deepMap(x, sign, true);
	    },
	
	    'Unit': function(x) {
	      return sign(x.value);
	    }
	  });
	
	  sign.toTex = {1: '\\mathrm{${name}}\\left(${args[0]}\\right)'};
	
	  return sign;
	}
	
	exports.name = 'sign';
	exports.factory = factory;
	


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the square root of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sqrt(x)
	   *
	   * Examples:
	   *
	   *    math.sqrt(25);                // returns 5
	   *    math.square(5);               // returns 25
	   *    math.sqrt(-4);                // returns Complex 2i
	   *
	   * See also:
	   *
	   *    square, multiply, cube, cbrt, sqrtm
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
	   *            Value for which to calculate the square root.
	   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
	   *            Returns the square root of `x`
	   */
	  var sqrt = typed('sqrt', {
	    'number': _sqrtNumber,
	
	    'Complex': function (x) {
	        return x.sqrt();
	    },
	
	    'BigNumber': function (x) {
	      if (!x.isNegative() || config.predictable) {
	        return x.sqrt();
	      }
	      else {
	        // negative value -> downgrade to number to do complex value computation
	        return _sqrtNumber(x.toNumber());
	      }
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since sqrt(0) = 0
	      return deepMap(x, sqrt, true);
	    },
	
	    'Unit': function (x) {
	      // Someday will work for complex units when they are implemented
	      return x.pow(0.5);
	    }
	
	  });
	
	  /**
	   * Calculate sqrt for a number
	   * @param {number} x
	   * @returns {number | Complex} Returns the square root of x
	   * @private
	   */
	  function _sqrtNumber(x) {
	    if (x >= 0 || config.predictable) {
	      return Math.sqrt(x);
	    }
	    else {
	      return new type.Complex(x, 0).sqrt();
	    }
	  }
	
	  sqrt.toTex = {1: '\\sqrt{${args[0]}}'};
	
	  return sqrt;
	}
	
	exports.name = 'sqrt';
	exports.factory = factory;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the complex conjugate of a complex value.
	   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.conj(x)
	   *
	   * Examples:
	   *
	   *    math.conj(math.complex('2 + 3i'));  // returns Complex 2 - 3i
	   *    math.conj(math.complex('2 - 3i'));  // returns Complex 2 + 3i
	   *    math.conj(math.complex('-5.2i'));  // returns Complex 5.2i
	   *
	   * See also:
	   *
	   *    re, im, arg, abs
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            A complex number or array with complex numbers
	   * @return {number | BigNumber | Complex | Array | Matrix}
	   *            The complex conjugate of x
	   */
	  var conj = typed('conj', {
	    'number': function (x) {
	      return x;
	    },
	
	    'BigNumber': function (x) {
	      return x;
	    },
	
	    'Complex': function (x) {
	      return x.conjugate();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, conj);
	    }
	  });
	
	  conj.toTex = {1: '\\left(${args[0]}\\right)^*'};
	
	  return conj;
	}
	
	exports.name = 'conj';
	exports.factory = factory;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	var number = util.number,
	    
	    isInteger = number.isInteger;
	
	function factory (type, config, load, typed) {
	
	  var cs_sqr = load(__webpack_require__(1697));
	  var cs_lu = load(__webpack_require__(1708));
	
	  /**
	   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
	   *
	   * `P * A * Q = L * U`
	   *
	   * Syntax:
	   *
	   *    math.slu(A, order, threshold);
	   *
	   * Examples:
	   *
	   *    var A = math.sparse([[4,3], [6, 3]])
	   *    math.slu(A, 1, 0.001)
	   *    // returns:
	   *    // {
	   *    //   L: [[1, 0], [1.5, 1]]
	   *    //   U: [[4, 3], [0, -1.5]]
	   *    //   p: [0, 1]
	   *    //   q: [0, 1]
	   *    // }
	   *
	   * See also:
	   *
	   *    lup, lsolve, usolve, lusolve
	   *
	   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
	   * @param {Number}       order          The Symbolic Ordering and Analysis order:
	   *                                       0 - Natural ordering, no permutation vector q is returned
	   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
	   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'. 
	   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
	   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
	   *                                           A dense row is a row with more than 10*sqr(columns) entries.
	   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
	   *
	   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
	   */
	  var slu = typed('slu', {
	
	    'SparseMatrix, number, number': function (a, order, threshold) {
	      // verify order
	      if (!isInteger(order) || order < 0 || order > 3)
	        throw new Error('Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]');
	      // verify threshold
	      if (threshold < 0 || threshold > 1)
	        throw new Error('Partial pivoting threshold must be a number from 0 to 1');
	      
	      // perform symbolic ordering and analysis
	      var s = cs_sqr(order, a, false);
	      
	      // perform lu decomposition
	      var f = cs_lu(a, s, threshold);
	      
	      // return decomposition
	      return {
	        L: f.L,
	        U: f.U,
	        p: f.pinv,
	        q: s.q,
	        toString: function () {
	          return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\np: ' + this.p.toString() + (this.q ? '\nq: ' + this.q.toString() : '') + '\n';
	        }
	      };
	    }
	  });
	
	  return slu;
	}
	
	exports.name = 'slu';
	exports.factory = factory;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_amd = load(__webpack_require__(1698));
	  var cs_permute = load(__webpack_require__(1703));
	  var cs_etree = load(__webpack_require__(1704));
	  var cs_post = load(__webpack_require__(1705));
	  var cs_counts = load(__webpack_require__(1706));
	
	  /**
	   * Symbolic ordering and analysis for QR and LU decompositions.
	   *
	   * @param {Number}  order           The ordering strategy (see cs_amd for more details)
	   * @param {Matrix}  a               The A matrix
	   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
	   *                                  symbolic ordering and analysis for LU decomposition (false)
	   *
	   * @return {Object}                 The Symbolic ordering and analysis for matrix A
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_sqr = function (order, a, qr) {
	    // a arrays
	    var aptr = a._ptr;
	    var asize = a._size;
	    // columns
	    var n = asize[1];
	    // vars
	    var k;
	    // symbolic analysis result
	    var s = {};    
	    // fill-reducing ordering
	    s.q = cs_amd(order, a);
	    // validate results
	    if (order && !s.q) 
	      return null;
	    // QR symbolic analysis
	    if (qr) {
	      // apply permutations if needed
	      var c = order ? cs_permute(a, null, s.q, 0) : a;
	      // etree of C'*C, where C=A(:,q)
	      s.parent = cs_etree(c, 1);
	      // post order elimination tree
	      var post = cs_post (s.parent, n);
	      // col counts chol(C'*C)
	      s.cp = cs_counts(c, s.parent, post, 1);
	      // check we have everything needed to calculate number of nonzero elements
	      if (c && s.parent && s.cp && _vcount(c, s)) {
	        // calculate number of nonzero elements
	        for (s.unz = 0, k = 0; k < n; k++) 
	          s.unz += s.cp[k];
	      }
	    }
	    else {
	      // for LU factorization only, guess nnz(L) and nnz(U)
	      s.unz = 4 * (aptr[n]) + n;
	      s.lnz = s.unz;
	    }
	    // return result S
	    return s;
	  };
	  
	  /**
	   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
	   */
	  var _vcount = function (a, s) {
	    // a arrays
	    var aptr = a._ptr;
	    var aindex = a._index;
	    var asize = a._size;
	    // rows & columns
	    var m = asize[0];
	    var n = asize[1];
	    // initialize s arrays
	    s.pinv = []; // (m + n);
	    s.leftmost = []; // (m);
	    // vars
	    var parent = s.parent;
	    var pinv = s.pinv;
	    var leftmost = s.leftmost;
	    // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
	    var w = []; // (m + 3 * n);
	    var next = 0;
	    var head = m;
	    var tail = m + n;
	    var nque = m + 2 * n;
	    // vars
	    var i, k, p, p0, p1;
	    // initialize w
	    for (k = 0; k < n; k++) {
	      // queue k is empty
	      w[head + k] = -1;
	      w[tail + k] = -1;
	      w[nque + k] = 0;
	    }
	    // initialize row arrays
	    for (i = 0; i < m; i++) 
	      leftmost[i] = -1;
	    // loop columns backwards    
	    for (k = n - 1; k >= 0; k--) {
	      // values & index for column k
	      for (p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++) {
	        // leftmost[i] = min(find(A(i,:)))
	        leftmost[aindex[p]] = k;
	      }
	    }
	    // scan rows in reverse order
	    for (i = m - 1; i >= 0; i--) {
	      // row i is not yet ordered
	      pinv[i] = -1;
	      k = leftmost[i];
	      // check row i is empty
	      if (k == -1) 
	        continue;
	      // first row in queue k
	      if (w[nque + k]++ === 0) 
	        w[tail + k] = i;
	      // put i at head of queue k
	      w[next + i] = w[head + k];
	      w[head + k] = i;
	    }
	    s.lnz = 0;
	    s.m2 = m;
	    // find row permutation and nnz(V)
	    for (k = 0; k < n; k++) {
	      // remove row i from queue k
	      i = w[head + k];
	      // count V(k,k) as nonzero
	      s.lnz++;
	      // add a fictitious row
	      if (i < 0) 
	        i = s.m2++;
	      // associate row i with V(:,k)
	      pinv[i] = k;
	      // skip if V(k+1:m,k) is empty
	      if (--nque[k] <= 0) 
	        continue;
	      // nque[k] is nnz (V(k+1:m,k))
	      s.lnz += w[nque + k];
	      // move all rows to parent of k
	      var pa = parent[k];
	      if (pa != -1) {
	        if (w[nque + pa] === 0) 
	          w[tail + pa] = w[tail + k];
	        w[next + w[tail + k]] = w[head + pa];
	        w[head + pa] = w[next + i];
	        w[nque + pa] += w[nque + k];
	      }
	    }
	    for (i = 0; i < m; i++) {
	      if (pinv[i] < 0) 
	        pinv[i] = k++;
	    }
	    return true;
	  };
	
	  return cs_sqr;
	}
	
	exports.name = 'cs_sqr';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_flip = load(__webpack_require__(1699));
	  var cs_fkeep = load(__webpack_require__(1700));
	  var cs_tdfs = load(__webpack_require__(1701));
	  
	  var add       = load(__webpack_require__(1367));
	  var multiply  = load(__webpack_require__(1400));
	  var transpose = load(__webpack_require__(1702));
	
	  /**
	   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used 
	   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
	   * than A. It is a gready method that selects the sparsest pivot row and column during the course
	   * of a right looking sparse Cholesky factorization.
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   *
	   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
	   * @param {Matrix} m        Sparse Matrix
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_amd = function (order, a) {
	    // check input parameters
	    if (!a || order <= 0 || order > 3)
	      return null;
	    // a matrix arrays
	    var asize = a._size;
	    // rows and columns
	    var m = asize[0];
	    var n = asize[1];    
	    // initialize vars
	    var lemax = 0;
	    // dense threshold
	    var dense = Math.max(16, 10 * Math.sqrt(n));
	    dense = Math.min(n - 2, dense);
	    // create target matrix C
	    var cm = _createTargetMatrix(order, a, m, n, dense);
	    // drop diagonal entries
	    cs_fkeep(cm, _diag, null);
	    // C matrix arrays
	    var cindex = cm._index;
	    var cptr = cm._ptr;
	
	    // number of nonzero elements in C
	    var cnz = cptr[n];
	    
	    // allocate result (n+1)
	    var P = [];
	    
	    // create workspace (8 * (n + 1))
	    var W = [];
	    var len = 0; // first n + 1 entries
	    var nv = n + 1; // next n + 1 entries
	    var next = 2 * (n + 1); // next n + 1 entries
	    var head = 3 * (n + 1);  // next n + 1 entries
	    var elen = 4 * (n + 1);  // next n + 1 entries
	    var degree = 5 * (n + 1);  // next n + 1 entries
	    var w = 6 * (n + 1);  // next n + 1 entries
	    var hhead = 7 * (n + 1);  // last n + 1 entries    
	
	    // use P as workspace for last
	    var last = P;
	    
	    // initialize quotient graph
	    var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree);
	    
	    // initialize degree lists
	    var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next);
	    
	    // minimum degree node
	    var mindeg = 0;
	    
	    // vars
	    var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d;
	    
	    // while (selecting pivots) do
	    while (nel < n) {
	      // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
	      // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
	      // many nodes have been eliminated.
	      for (k = -1; mindeg < n && (k = W[head + mindeg]) == -1; mindeg++);      
	      if (W[next + k] != -1) 
	        last[W[next + k]] = -1;
	      // remove k from degree list
	      W[head + mindeg] = W[next + k];
	      // elenk = |Ek|
	      var elenk = W[elen + k];
	      // # of nodes k represents
	      var nvk = W[nv + k];
	      // W[nv + k] nodes of A eliminated
	      nel += nvk;
	
	      // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is 
	      // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
	      // degree lists. All elements e in Ek are absorved into element k.
	      var dk = 0;
	      // flag k as in Lk
	      W[nv + k] = -nvk;
	      var p = cptr[k];
	      // do in place if W[elen + k] == 0
	      var pk1 = (elenk === 0) ? p : cnz;
	      var pk2 = pk1;
	      for (k1 = 1; k1 <= elenk + 1; k1++) {
	        if (k1 > elenk) {
	          // search the nodes in k
	          e = k;
	          // list of nodes starts at cindex[pj]
	          pj = p;
	          // length of list of nodes in k
	          ln = W[len + k] - elenk;
	        }
	        else {
	          // search the nodes in e
	          e = cindex[p++];
	          pj = cptr[e];
	          // length of list of nodes in e
	          ln = W[len + e];
	        }
	        for (k2 = 1; k2 <= ln; k2++) {
	          i = cindex[pj++];
	          // check  node i dead, or seen
	          if ((nvi = W[nv + i]) <= 0) 
	            continue;
	          // W[degree + Lk] += size of node i
	          dk += nvi;
	          // negate W[nv + i] to denote i in Lk
	          W[nv + i] = -nvi;
	          // place i in Lk
	          cindex[pk2++] = i;
	          if (W[next + i] != -1) 
	            last[W[next + i]] = last[i];
	          // check we need to remove i from degree list
	          if (last[i] != -1) 
	            W[next + last[i]] = W[next + i];
	          else
	            W[head + W[degree + i]] = W[next + i];
	        }
	        if (e != k) {
	          // absorb e into k
	          cptr[e] = cs_flip(k);
	          // e is now a dead element
	          W[w + e] = 0;
	        }
	      }
	      // cindex[cnz...nzmax] is free
	      if (elenk !== 0) 
	        cnz = pk2;
	      // external degree of k - |Lk\i|
	      W[degree + k] = dk;
	      // element k is in cindex[pk1..pk2-1]
	      cptr[k] = pk1;
	      W[len + k] = pk2 - pk1;
	      // k is now an element
	      W[elen + k] = -2;
	            
	      // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
	      // scan, no entry in the w array is greater than or equal to mark.
	      
	      // clear w if necessary
	      mark = _wclear(mark, lemax, W, w, n);
	      // scan 1: find |Le\Lk|
	      for (pk = pk1; pk < pk2; pk++) {
	        i = cindex[pk];
	        // check if W[elen + i] empty, skip it
	        if ((eln = W[elen + i]) <= 0) 
	          continue;
	        // W[nv + i] was negated
	        nvi = -W[nv + i];
	        var wnvi = mark - nvi;
	        // scan Ei
	        for (p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++) {
	          e = cindex[p];
	          if (W[w + e] >= mark) {
	            // decrement |Le\Lk|
	            W[w + e] -= nvi;
	          }
	          else if (W[w + e] !== 0) {
	            // ensure e is a live element, 1st time e seen in scan 1
	            W[w + e] = W[degree + e] + wnvi;
	          }
	        }
	      }
	      
	      // degree update
	      // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
	      // function h(i) for all nodes in Lk.
	      
	      // scan2: degree update
	      for (pk = pk1; pk < pk2; pk++) {
	        // consider node i in Lk
	        i = cindex[pk];
	        p1 = cptr[i];
	        p2 = p1 + W[elen + i] - 1;
	        pn = p1;
	        // scan Ei
	        for (h = 0, d = 0, p = p1; p <= p2; p++) {
	          e = cindex[p];
	          // check e is an unabsorbed element
	          if (W[w + e] !== 0) {
	            // dext = |Le\Lk|
	            var dext = W[w + e] - mark;
	            if (dext > 0) {
	              // sum up the set differences
	              d += dext;
	              // keep e in Ei
	              cindex[pn++] = e;
	              // compute the hash of node i
	              h += e;
	            }
	            else {
	              // aggressive absorb. e->k
	              cptr[e] = cs_flip(k);
	              // e is a dead element
	              W[w + e] = 0;
	            }
	          }
	        }
	        // W[elen + i] = |Ei|
	        W[elen + i] = pn - p1 + 1;
	        var p3 = pn;
	        var p4 = p1 + W[len + i];
	        // prune edges in Ai
	        for (p = p2 + 1; p < p4; p++) {
	          j = cindex[p];
	          // check node j dead or in Lk
	          var nvj = W[nv + j];
	          if (nvj <= 0) 
	            continue;
	          // degree(i) += |j|
	          d += nvj;
	          // place j in node list of i
	          cindex[pn++] = j;
	          // compute hash for node i
	          h += j;
	        }
	        // check for mass elimination
	        if (d === 0) {
	          // absorb i into k
	          cptr[i] = cs_flip(k);
	          nvi = -W[nv + i];
	          // |Lk| -= |i|
	          dk -= nvi;
	          // |k| += W[nv + i]
	          nvk += nvi;
	          nel += nvi;
	          W[nv + i] = 0;
	          // node i is dead
	          W[elen + i] = -1;
	        }
	        else {
	          // update degree(i)
	          W[degree + i] = Math.min(W[degree + i], d);
	          // move first node to end
	          cindex[pn] = cindex[p3];
	          // move 1st el. to end of Ei
	          cindex[p3] = cindex[p1];
	          // add k as 1st element in of Ei
	          cindex[p1] = k;
	          // new len of adj. list of node i
	          W[len + i] = pn - p1 + 1;
	          // finalize hash of i
	          h = (h < 0 ? -h : h) % n;
	          // place i in hash bucket
	          W[next + i] = W[hhead + h];
	          W[hhead + h] = i;
	          // save hash of i in last[i]
	          last[i] = h;
	        }
	      }
	      // finalize |Lk|
	      W[degree + k] = dk;
	      lemax = Math.max(lemax, dk);
	      // clear w
	      mark = _wclear(mark + lemax, lemax, W, w, n);
	      
	      // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
	      // If two nodes have identical adjacency lists, their hash functions wil be identical.
	      for (pk = pk1; pk < pk2; pk++) {
	        i = cindex[pk];
	        // check i is dead, skip it
	        if (W[nv + i] >= 0) 
	          continue;
	        // scan hash bucket of node i
	        h = last[i];
	        i = W[hhead + h];
	        // hash bucket will be empty
	        W[hhead + h] = -1;
	        for (; i != -1 && W[next + i] != -1; i = W[next + i], mark++) {
	          ln = W[len + i];
	          eln = W[elen + i];
	          for (p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++) 
	            W[w + cindex[p]] = mark;
	          var jlast = i;
	          // compare i with all j
	          for (j = W[next + i]; j != -1; ) {
	            var ok = W[len + j] === ln && W[elen + j] === eln;
	            for (p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++) {
	              // compare i and j
	              if (W[w + cindex[p]] != mark) 
	                ok = 0;
	            }
	            // check i and j are identical
	            if (ok) {
	              // absorb j into i
	              cptr[j] = cs_flip(i);
	              W[nv + i] += W[nv + j];
	              W[nv + j] = 0;
	              // node j is dead
	              W[elen + j] = -1;
	              // delete j from hash bucket
	              j = W[next + j];
	              W[next + jlast] = j;
	            }
	            else {
	              // j and i are different
	              jlast = j;
	              j = W[next + j];
	            }
	          }
	        }
	      }
	      
	      // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
	      // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
	      for (p = pk1, pk = pk1; pk < pk2; pk++) {
	        i = cindex[pk];
	        // check  i is dead, skip it
	        if ((nvi = -W[nv + i]) <= 0) 
	          continue;
	        // restore W[nv + i]
	        W[nv + i] = nvi;
	        // compute external degree(i)
	        d = W[degree + i] + dk - nvi;
	        d = Math.min(d, n - nel - nvi);
	        if (W[head + d] != -1) 
	          last[W[head + d]] = i;
	        // put i back in degree list
	        W[next + i] = W[head + d];
	        last[i] = -1;
	        W[head + d] = i;
	        // find new minimum degree
	        mindeg = Math.min(mindeg, d);
	        W[degree + i] = d;
	        // place i in Lk
	        cindex[p++] = i;
	      }
	      // # nodes absorbed into k
	      W[nv + k] = nvk;
	      // length of adj list of element k
	      if ((W[len + k] = p - pk1) === 0) {
	        // k is a root of the tree
	        cptr[k] = -1;
	        // k is now a dead element
	        W[w + k] = 0;
	      }
	      if (elenk !== 0) {
	        // free unused space in Lk
	        cnz = p;
	      }
	    }
	    
	    // Postordering. The elimination is complete, but no permutation has been computed. All that is left 
	    // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
	    // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
	    // is computed. The tree is restored by unflipping all of ptr.
	    
	    // fix assembly tree
	    for (i = 0; i < n; i++) 
	      cptr[i] = cs_flip(cptr[i]);
	    for (j = 0; j <= n; j++) 
	      W[head + j] = -1;
	    // place unordered nodes in lists
	    for (j = n; j >= 0; j--) {
	      // skip if j is an element
	      if (W[nv + j] > 0)
	        continue;
	      // place j in list of its parent
	      W[next + j] = W[head + cptr[j]];
	      W[head + cptr[j]] = j;
	    }
	    // place elements in lists
	    for (e = n; e >= 0; e--) {
	      // skip unless e is an element
	      if (W[nv + e] <= 0)
	        continue;
	      if (cptr[e] != -1) {
	        // place e in list of its parent
	        W[next + e] = W[head + cptr[e]];
	        W[head + cptr[e]] = e;
	      }
	    }
	    // postorder the assembly tree
	    for (k = 0, i = 0; i <= n; i++) {
	      if (cptr[i] == -1) 
	        k = cs_tdfs(i, k, W, head, next, P, w);
	    }
	    // remove last item in array
	    P.splice(P.length - 1, 1);
	    // return P
	    return P;
	  };
	  
	  /**
	   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
	   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
	   *
	   * Order: 0
	   *   A natural ordering P=null matrix is returned.
	   *
	   * Order: 1
	   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
	   *   P = M + M'
	   *
	   * Order: 2
	   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
	   *   P = M' * M
	   * 
	   * Order: 3
	   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
	   *   P = M' * M
	   */
	  var _createTargetMatrix = function (order, a, m, n, dense) {
	    // compute A'
	    var at = transpose(a);
	
	    // check order = 1, matrix must be square
	    if (order === 1 && n === m) {
	      // C = A + A'
	      return add(a, at);
	    }
	    
	    // check order = 2, drop dense columns from M'
	    if (order == 2) {
	      // transpose arrays
	      var tindex = at._index;
	      var tptr = at._ptr;
	      // new column index
	      var p2 = 0;
	      // loop A' columns (rows)
	      for (var j = 0; j < m; j++) {
	        // column j of AT starts here
	        var p = tptr[j];
	        // new column j starts here
	        tptr[j] = p2;
	        // skip dense col j
	        if (tptr[j + 1] - p > dense) 
	          continue;
	        // map rows in column j of A
	        for (var p1 = tptr[j + 1]; p < p1; p++) 
	          tindex[p2++] = tindex[p];
	      }
	      // finalize AT
	      tptr[m] = p2;
	      // recreate A from new transpose matrix
	      a = transpose(at);
	      // use A' * A
	      return multiply(at, a);
	    }
	    
	    // use A' * A, square or rectangular matrix
	    return multiply(at, a);
	  };
	
	  /**
	   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
	   *
	   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
	   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
	   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
	   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
	   */
	  var _initializeQuotientGraph = function (n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
	    // Initialize quotient graph
	    for (var k = 0; k < n; k++) 
	      W[len + k] = cptr[k + 1] - cptr[k];
	    W[len + n] = 0;
	    // initialize workspace
	    for (var i = 0; i <= n; i++) {
	      // degree list i is empty
	      W[head + i] = -1;
	      last[i] = -1;
	      W[next + i] = -1;
	      // hash list i is empty
	      W[hhead + i] = -1;
	      // node i is just one node
	      W[nv + i] = 1;
	      // node i is alive
	      W[w + i] = 1;
	      // Ek of node i is empty
	      W[elen + i] = 0;
	      // degree of node i
	      W[degree + i] = W[len + i];
	    }
	    // clear w
	    var mark = _wclear(0, 0, W, w, n);
	    // n is a dead element
	    W[elen + n] = -2;
	    // n is a root of assembly tree
	    cptr[n] = -1;
	    // n is a dead element
	    W[w + n] = 0;
	    // return mark
	    return mark;
	  };
	
	  /**
	   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with 
	   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
	   * output permutation p.
	   */
	  var _initializeDegreeLists = function (n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
	    // result
	    var nel = 0;
	    // loop columns
	    for (var i = 0; i < n; i++) {
	      // degree @ i
	      var d = W[degree + i];
	      // check node i is empty
	      if (d === 0) {
	        // element i is dead
	        W[elen + i] = -2;
	        nel++;
	        // i is a root of assembly tree
	        cptr[i] = -1;
	        W[w + i] = 0;
	      }
	      else if (d > dense) {
	        // absorb i into element n
	        W[nv + i] = 0;
	        // node i is dead
	        W[elen + i] = -1;
	        nel++;
	        cptr[i] = cs_flip(n);
	        W[nv + n]++;
	      }
	      else {
	        var h = W[head + d];
	        if (h != -1)
	          last[h] = i;
	        // put node i in degree list d
	        W[next + i] = W[head + d];
	        W[head + d] = i;
	      }
	    }
	    return nel;
	  };
	
	  var _wclear = function(mark, lemax, W, w, n) {
	    if (mark < 2 || (mark + lemax < 0)) {
	      for (var k = 0; k < n; k++) {
	        if (W[w + k] !== 0)
	          W[w + k] = 1;
	      }
	      mark = 2 ;
	    }
	    // at this point, W [0..n-1] < mark holds
	    return mark;
	  };
	  
	  var _diag = function (i, j) { 
	    return i != j;
	  };
	  
	  return cs_amd;
	}
	
	exports.name = 'cs_amd';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * This function "flips" its input about the integer -1.
	   *
	   * @param {Number}  i               The value to flip
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_flip = function (i) {
	    // flip the value
	    return -i - 2;
	  };
	
	  return cs_flip;
	}
	
	exports.name = 'cs_flip';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
	   *
	   * @param {Matrix}   a              The sparse matrix
	   * @param {function} callback       The callback function, function will be invoked with the following args:
	   *                                    - The entry row
	   *                                    - The entry column
	   *                                    - The entry value
	   *                                    - The state parameter
	   * @param {any}      other          The state
	   *
	   * @return                          The number of nonzero elements in the matrix
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_fkeep = function (a, callback, other) {
	    // a arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    // columns
	    var n = asize[1];
	    // nonzero items
	    var nz = 0;
	    // loop columns
	    for (var j = 0; j < n; j++) {
	      // get current location of col j
	      var p = aptr[j];
	      // record new location of col j
	      aptr[j] = nz;
	      for (; p < aptr[j+1]; p++) {
	        // check we need to keep this item
	        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
	          // keep A(i,j)
	          aindex[nz] = aindex[p];
	          // check we need to process values (pattern only)
	          if (avalues) 
	            avalues[nz] = avalues[p];
	          // increment nonzero items
	          nz++;
	        }
	      }
	    }
	    // finalize A
	    aptr[n] = nz;
	    // trim arrays
	    aindex.splice(nz, aindex.length - nz);
	    // check we need to process values (pattern only)
	    if (avalues)
	      avalues.splice(nz, avalues.length - nz);    
	    // return number of nonzero items
	    return (nz);
	  };
	  
	  return cs_fkeep;
	}
	
	exports.name = 'cs_fkeep';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1701 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * Depth-first search and postorder of a tree rooted at node j
	   *
	   * @param {Number}  j               The tree node
	   * @param {Number}  k               
	   * @param {Array}   w               The workspace array
	   * @param {Number}  head            The index offset within the workspace for the head array
	   * @param {Number}  next            The index offset within the workspace for the next array
	   * @param {Array}   post            The post ordering array
	   * @param {Number}  stack           The index offset within the workspace for the stack array
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_tdfs = function (j, k, w, head, next, post, stack) {
	    // variables
	    var top = 0;
	    // place j on the stack
	    w[stack] = j;
	    // while (stack is not empty) 
	    while (top >= 0) {
	      // p = top of stack
	      var p = w[stack + top];
	      // i = youngest child of p
	      var i = w[head + p];
	      if (i == -1) {
	        // p has no unordered children left
	        top--;
	        // node p is the kth postordered node
	        post[k++] = p;
	      }
	      else {
	        // remove i from children of p
	        w[head + p] = w[next + i];
	        // increment top
	        ++top;
	        // start dfs on child node i
	        w[stack + top] = i;
	      }
	    }
	    return k;
	  };
	
	  return cs_tdfs;
	}
	
	exports.name = 'cs_tdfs';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var format = __webpack_require__(1341).format;
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var DenseMatrix = type.DenseMatrix,
	      SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Transpose a matrix. All values of the matrix are reflected over its
	   * main diagonal. Only applicable to two dimensional matrices containing
	   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
	   * vectors and scalars return the input unchanged.
	   *
	   * Syntax:
	   *
	   *     math.transpose(x)
	   *
	   * Examples:
	   *
	   *     var A = [[1, 2, 3], [4, 5, 6]];
	   *     math.transpose(A);               // returns [[1, 4], [2, 5], [3, 6]]
	   *
	   * See also:
	   *
	   *     diag, inv, subset, squeeze
	   *
	   * @param {Array | Matrix} x  Matrix to be transposed
	   * @return {Array | Matrix}   The transposed matrix
	   */
	  var transpose = typed('transpose', {
	
	    'Array': function (x) {
	      // use dense matrix implementation
	      return transpose(matrix(x)).valueOf();
	    },
	
	    'Matrix': function (x) {
	      // matrix size
	      var size = x.size();
	
	      // result
	      var c;
	      
	      // process dimensions
	      switch (size.length) {
	        case 1:
	          // vector
	          c = x.clone();
	          break;
	
	        case 2:
	          // rows and columns
	          var rows = size[0];
	          var columns = size[1];
	
	          // check columns
	          if (columns === 0) {
	            // throw exception
	            throw new RangeError('Cannot transpose a 2D matrix with no columns (size: ' + format(size) + ')');
	          }
	
	          // process storage format
	          switch (x.storage()) {
	            case 'dense':
	              c = _denseTranspose(x, rows, columns);
	              break;
	            case 'sparse':
	              c = _sparseTranspose(x, rows, columns);
	              break;
	          }
	          break;
	          
	        default:
	          // multi dimensional
	          throw new RangeError('Matrix must be a vector or two dimensional (size: ' + format(this._size) + ')');
	      }
	      return c;
	    },
	
	    // scalars
	    'any': function (x) {
	      return clone(x);
	    }
	  });
	
	  var _denseTranspose = function (m, rows, columns) {
	    // matrix array
	    var data = m._data;
	    // transposed matrix data
	    var transposed = [];
	    var transposedRow;
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // initialize row
	      transposedRow = transposed[j] = [];
	      // loop rows
	      for (var i = 0; i < rows; i++) {
	        // set data
	        transposedRow[i] = clone(data[i][j]);
	      }
	    }
	    // return matrix
	    return new DenseMatrix({
	      data: transposed,
	      size: [columns, rows],
	      datatype: m._datatype
	    });
	  };
	
	  var _sparseTranspose = function (m, rows, columns) {
	    // matrix arrays
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    // result matrices
	    var cvalues = values ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // row counts
	    var w = [];
	    for (var x = 0; x < rows; x++)
	      w[x] = 0;
	    // vars
	    var p, l, j;
	    // loop values in matrix
	    for (p = 0, l = index.length; p < l; p++) {
	      // number of values in row
	      w[index[p]]++;
	    }
	    // cumulative sum
	    var sum = 0;
	    // initialize cptr with the cummulative sum of row counts
	    for (var i = 0; i < rows; i++) {
	      // update cptr
	      cptr.push(sum);
	      // update sum
	      sum += w[i];
	      // update w
	      w[i] = cptr[i];
	    }
	    // update cptr
	    cptr.push(sum);
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // values & index in column
	      for (var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++) {
	        // C values & index
	        var q = w[index[k]]++;
	        // C[j, i] = A[i, j]
	        cindex[q] = j;
	        // check we need to process values (pattern matrix)
	        if (values)
	          cvalues[q] = clone(values[k]);
	      }
	    }
	    // return matrix
	    return new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [columns, rows],
	      datatype: m._datatype
	    });
	  };
	
	  transpose.toTex = {1: '\\left(${args[0]}\\right)' + latex.operators['transpose']};
	
	  return transpose;
	}
	
	exports.name = 'transpose';
	exports.factory = factory;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type) {
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Permutes a sparse matrix C = P * A * Q
	   *
	   * @param {Matrix}  a               The Matrix A
	   * @param {Array}   pinv            The row permutation vector
	   * @param {Array}   q               The column permutation vector
	   * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
	   *
	   * @return {Matrix}                 C = P * A * Q, null on error
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_permute = function (a, pinv, q, values) {
	    // a arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    var adt = a._datatype;
	    // rows & columns
	    var m = asize[0];
	    var n = asize[1];
	    // c arrays
	    var cvalues = values && a._values ? [] : null;
	    var cindex = []; // (aptr[n]);
	    var cptr = []; // (n + 1);
	    // initialize vars
	    var nz = 0;
	    // loop columns    
	    for (var k = 0; k < n; k++) {
	      // column k of C is column q[k] of A
	      cptr[k] = nz;
	      // apply column permutation
	      var j = q ? (q[k]) : k;
	      // loop values in column j of A
	      for (var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++) {
	        // row i of A is row pinv[i] of C
	        var r = pinv ? pinv[aindex[t]] : aindex[t];
	        // index
	        cindex[nz] = r;
	        // check we need to populate values
	        if (cvalues) 
	          cvalues[nz] = avalues[t];
	        // increment number of nonzero elements
	        nz++;
	      }
	    }
	    // finalize the last column of C
	    cptr[n] = nz;
	    // return C matrix
	    return new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [m, n],
	      datatype: adt
	    });
	  };
	
	  return cs_permute;
	}
	
	exports.name = 'cs_permute';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * Computes the elimination tree of Matrix A (using triu(A)) or the 
	   * elimination tree of A'A without forming A'A.
	   *
	   * @param {Matrix}  a               The A Matrix
	   * @param {boolean} ata             A value of true the function computes the etree of A'A
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_etree = function (a, ata) {
	    // check inputs
	    if (!a)
	      return null;
	    // a arrays
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    // rows & columns
	    var m = asize[0];
	    var n = asize[1];
	    
	    // allocate result
	    var parent = []; // (n)
	    
	    // allocate workspace
	    var w = []; // (n + (ata ? m : 0))
	    var ancestor = 0; // first n entries in w
	    var prev = n; // last m entries (ata = true)
	    
	    var i, inext;
	    
	    // check we are calculating A'A
	    if (ata) {
	      // initialize workspace
	      for (i = 0; i < m; i++) 
	        w[prev + i] = -1;
	    }
	    // loop columns
	    for (var k = 0; k < n; k++) {
	      // node k has no parent yet
	      parent[k] = -1;
	      // nor does k have an ancestor
	      w[ancestor + k] = -1;
	      // values in column k
	      for (var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++) {
	        // row
	        var r = aindex[p];
	        // node
	        i = ata ? (w[prev + r]) : r;
	        // traverse from i to k 
	        for (; i != -1 && i < k; i = inext) {
	          // inext = ancestor of i
	          inext = w[ancestor + i];
	          // path compression
	          w[ancestor + i] = k;
	          // check no anc., parent is k
	          if (inext == -1) 
	            parent[i] = k;
	        }
	        if (ata) 
	          w[prev + r] = k;
	      }
	    }
	    return parent;
	  };
	
	  return cs_etree;
	}
	
	exports.name = 'cs_etree';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_tdfs = load(__webpack_require__(1701));
	
	  /**
	   * Post order a tree of forest
	   *
	   * @param {Array}   parent          The tree or forest
	   * @param {Number}  n               Number of columns
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_post = function (parent, n) {
	    // check inputs
	    if (!parent) 
	      return null;
	    // vars 
	    var k = 0;
	    var j;
	    // allocate result
	    var post = []; // (n);
	    // workspace, head: first n entries, next: next n entries, stack: last n entries
	    var w = []; // (3 * n);
	    var head = 0; 
	    var next = n; 
	    var stack = 2 * n;
	    // initialize workspace
	    for (j = 0; j < n; j++) {
	      // empty linked lists
	      w[head + j] = -1;
	    }
	    // traverse nodes in reverse order
	    for (j = n-1; j >= 0; j--) {
	      // check j is a root
	      if (parent[j] == -1) 
	        continue;
	      // add j to list of its parent
	      w[next + j] = w[head + parent[j]];
	      w[head + parent[j]] = j;
	    }
	    // loop nodes
	    for (j = 0; j < n; j++) {
	      // skip j if it is not a root
	      if (parent[j] != -1) 
	        continue;
	      // depth-first search
	      k = cs_tdfs(j, k, w, head, next, post, stack);
	    }
	    return post;
	  };
	
	  return cs_post;
	}
	
	exports.name = 'cs_post';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var transpose = load(__webpack_require__(1702));
	  
	  var cs_leaf = load(__webpack_require__(1707));
	
	  /**
	   * Computes the column counts using the upper triangular part of A.
	   * It transposes A internally, none of the input parameters are modified.
	   *
	   * @param {Matrix} a           The sparse matrix A
	   *
	   * @param {Matrix} ata         Count the columns of A'A instead
	   *
	   * @return                     An array of size n of the column counts or null on error
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_counts = function (a, parent, post, ata) {
	    // check inputs
	    if (!a || !parent || !post) 
	      return null;
	    // a matrix arrays
	    var asize = a._size;
	    // rows and columns
	    var m = asize[0];
	    var n = asize[1];   
	    // variables
	    var i, j, k,  J,  p, p0, p1;
	    
	    // workspace size
	    var s = 4 * n + (ata ? (n + m + 1) : 0);
	    // allocate workspace
	    var w = []; // (s)
	    var ancestor = 0; // first n entries
	    var maxfirst = n; // next n entries
	    var prevleaf = 2 * n; // next n entries
	    var first = 3 * n; // next n entries
	    var head = 4 * n; // next n + 1 entries (used when ata is true)
	    var next = 5 * n + 1; // last entries in workspace
	    // clear workspace w[0..s-1]
	    for (k = 0; k < s; k++) 
	      w[k] = -1;
	    
	    // allocate result
	    var colcount = []; // (n);
	    
	    // AT = A'
	    var at = transpose(a);
	    // at arrays
	    var tindex = at._index;
	    var tptr = at._ptr;
	
	    // find w[first + j]
	    for (k = 0; k < n; k++) {
	      j = post[k];
	      // colcount[j]=1 if j is a leaf
	      colcount[j] = (w[first + j] == -1) ? 1 : 0;
	      for (; j != -1 && w[first + j] == -1; j = parent[j]) 
	        w[first + j] = k;
	    }
	
	    // initialize ata if needed
	    if (ata) {
	      // invert post
	      for (k = 0; k < n; k++) 
	        w[post[k]] = k;
	      // loop rows (columns in AT)
	      for (i = 0; i < m; i++) {
	        // values in column i of AT
	        for (k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++) 
	          k = Math.min(k, w[tindex[p]]);
	        // place row i in linked list k
	        w[next + i] = w[head + k];
	        w[head + k] = i;
	      }
	    }
	    
	    // each node in its own set
	    for (i = 0; i < n; i++) 
	      w[ancestor + i] = i;
	    
	    for (k = 0; k < n; k++) {
	      // j is the kth node in postordered etree
	      j = post[k];
	      // check j is not a root
	      if (parent[j] != -1) 
	        colcount[parent[j]]--;
	      
	      // J=j for LL'=A case
	      for (J = (ata ? w[head + k] : j); J != -1; J = (ata ? w[next + J] : -1)) {
	        for (p = tptr[J]; p < tptr[J+1]; p++) {
	          i = tindex[p];
	          var r = cs_leaf(i, j, w, first, maxfirst, prevleaf, ancestor);
	          // check A(i,j) is in skeleton
	          if (r.jleaf >= 1) 
	            colcount[j]++;
	          // check account for overlap in q
	          if (r.jleaf == 2) 
	            colcount[r.q]--;
	        }
	      }
	      if (parent[j] != -1) 
	        w[ancestor + j] = parent[j];
	    }
	    // sum up colcount's of each child
	    for (j = 0; j < n; j++) {
	      if (parent[j] != -1) 
	        colcount[parent[j]] += colcount[j];
	    }
	    return colcount;
	  };
	
	  return cs_counts;
	}
	
	exports.name = 'cs_counts';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * This function determines if j is a leaf of the ith row subtree.
	   * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
	   *
	   * @param {Number}  i               The ith row subtree
	   * @param {Number}  j               The node to test
	   * @param {Array}   w               The workspace array
	   * @param {Number}  first           The index offset within the workspace for the first array
	   * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
	   * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
	   * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
	   *
	   * @return {Object}
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_leaf = function (i, j, w, first, maxfirst, prevleaf, ancestor) {
	    
	    var s, sparent, jprev;
	    
	    // our result
	    var jleaf = 0;
	    var q;
	    
	    // check j is a leaf
	    if (i <= j || w[first + j] <= w[maxfirst + i]) 
	      return (-1);
	    // update max first[j] seen so far
	    w[maxfirst + i] = w[first + j];
	    // jprev = previous leaf of ith subtree
	    jprev = w[prevleaf + i];
	    w[prevleaf + i] = j;
	    
	    // check j is first or subsequent leaf
	    if (jprev === -1) {
	      // 1st leaf, q = root of ith subtree
	      jleaf = 1;
	      q = i;
	    }
	    else {
	      // update jleaf
	      jleaf = 2;
	      // q = least common ancester (jprev,j)
	      for (q = jprev; q != w[ancestor + q]; q = w[ancestor + q]);
	      for (s = jprev; s != q; s = sparent) {
	        // path compression
	        sparent = w[ancestor + s];
	        w[ancestor + s] = q;
	      }      
	    }
	    return {
	      jleaf: jleaf,
	      q: q
	    };
	  };
	
	  return cs_leaf;
	}
	
	exports.name = 'cs_leaf';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var abs = load(__webpack_require__(1402));
	  var divideScalar = load(__webpack_require__(1397));
	  var multiply = load(__webpack_require__(1400));
	  
	  var larger = load(__webpack_require__(1380));
	  var largerEq = load(__webpack_require__(1709));
	  
	  var cs_spsolve = load(__webpack_require__(1710));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
	   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L 
	   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
	   * L * U = A(p, q), where p is the inverse of pinv.
	   *
	   * @param {Matrix}  m               The A Matrix to factorize
	   * @param {Object}  s               The symbolic analysis from cs_sqr(). Provides the fill-reducing 
	   *                                  column ordering q
	   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
	   *
	   * @return {Number}                 The numeric LU factorization of A or null
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_lu = function (m, s, tol) {
	    // validate input
	    if (!m)
	      return null;
	    // m arrays
	    var size = m._size;
	    // columns
	    var n = size[1];
	    // symbolic analysis result
	    var q;
	    var lnz = 100;
	    var unz = 100;
	    // update symbolic analysis parameters
	    if (s) {
	      q = s.q;
	      lnz = s.lnz || lnz;
	      unz = s.unz || unz;
	    }
	    // L arrays
	    var lvalues = []; // (lnz)
	    var lindex = []; // (lnz);
	    var lptr = []; // (n + 1);
	    // L
	    var L = new SparseMatrix({
	      values: lvalues,
	      index: lindex,
	      ptr: lptr,
	      size: [n, n]
	    });
	    // U arrays
	    var uvalues = []; // (unz);
	    var uindex = []; // (unz);
	    var uptr = []; // (n + 1);
	    // U
	    var U = new SparseMatrix({
	      values: uvalues,
	      index: uindex,
	      ptr: uptr,
	      size: [n, n]
	    });
	    // inverse of permutation vector
	    var pinv = []; // (n);
	    // vars 
	    var i, p;
	    // allocate arrays
	    var x = []; // (n);
	    var xi = []; // (2 * n);
	    // initialize variables
	    for (i = 0; i < n; i++) {
	      // clear workspace
	      x[i] = 0;
	      // no rows pivotal yet
	      pinv[i] = -1;
	      // no cols of L yet
	      lptr[i + 1] = 0;
	    }
	    // reset number of nonzero elements in L and U
	    lnz = 0;
	    unz = 0;
	    // compute L(:,k) and U(:,k)
	    for (var k = 0; k < n; k++) {
	      // update ptr
	      lptr[k] = lnz;
	      uptr[k] = unz;
	      // apply column permutations if needed
	      var col = q ? q[k] : k;
	      // solve triangular system, x = L\A(:,col)
	      var top = cs_spsolve(L, m, col, xi, x, pinv, 1);
	      // find pivot
	      var ipiv = -1;
	      var a = -1;
	      // loop xi[] from top -> n
	      for (p = top; p < n; p++) {
	        // x[i] is nonzero
	        i = xi[p];
	        // check row i is not yet pivotal
	        if (pinv[i] < 0) {
	          // absolute value of x[i]          
	          var xabs = abs(x[i]);
	          // check absoulte value is greater than pivot value
	          if (larger(xabs, a)) {
	            // largest pivot candidate so far
	            a = xabs;
	            ipiv = i;
	          }
	        }
	        else {
	          // x(i) is the entry U(pinv[i],k)
	          uindex[unz] = pinv[i];
	          uvalues[unz++] = x[i];
	        }
	      }
	      // validate we found a valid pivot
	      if (ipiv == -1 || a <= 0) 
	        return null;
	      // update actual pivot column, give preference to diagonal value
	      if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol)))
	        ipiv = col;
	      // the chosen pivot
	      var pivot = x[ipiv];
	      // last entry in U(:,k) is U(k,k)
	      uindex[unz] = k;
	      uvalues[unz++] = pivot;
	      // ipiv is the kth pivot row
	      pinv[ipiv] = k;
	      // first entry in L(:,k) is L(k,k) = 1
	      lindex[lnz] = ipiv;
	      lvalues[lnz++] = 1;
	      // L(k+1:n,k) = x / pivot      
	      for (p = top; p < n; p++) {
	        // row
	        i = xi[p];
	        // check x(i) is an entry in L(:,k)
	        if (pinv[i] < 0) {
	          // save unpermuted row in L
	          lindex[lnz] = i;
	          // scale pivot column
	          lvalues[lnz++] = divideScalar(x[i], pivot);
	        }
	        // x[0..n-1] = 0 for next k
	        x[i] = 0;
	      }
	    }
	    // update ptr
	    lptr[n] = lnz;
	    uptr[n] = unz;
	    // fix row indices of L for final pinv
	    for (p = 0; p < lnz; p++) 
	      lindex[p] = pinv[lindex[p]];
	    // trim arrays
	    lvalues.splice(lnz, lvalues.length - lnz);
	    lindex.splice(lnz, lindex.length - lnz);
	    uvalues.splice(unz, uvalues.length - unz);
	    uindex.splice(unz, uindex.length - unz);    
	    // return LU factor
	    return {
	      L: L,
	      U: U,
	      pinv: pinv
	    };
	  };
	
	  return cs_lu;
	}
	
	exports.name = 'cs_lu';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether value x is larger or equal to y.
	   *
	   * The function returns true when x is larger than y or the relative
	   * difference between x and y is smaller than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.largerEq(x, y)
	   *
	   * Examples:
	   *
	   *    math.larger(2, 1 + 1);         // returns false
	   *    math.largerEq(2, 1 + 1);       // returns true
	   *
	   * See also:
	   *
	   *    equal, unequal, smaller, smallerEq, larger, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
	   */
	  var largerEq = typed('largerEq', {
	
	    'boolean, boolean': function (x, y) {
	      return x >= y;
	    },
	
	    'number, number': function (x, y) {
	      return x >= y || nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.gte(y) || bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.compare(y) !== -1;
	    },
	
	    'Complex, Complex': function () {
	      throw new TypeError('No ordering relation is defined for complex numbers');
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return largerEq(x.value, y.value);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, largerEq);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, largerEq, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, largerEq, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, largerEq);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return largerEq(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return largerEq(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return largerEq(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, largerEq, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, largerEq, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, largerEq, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, largerEq, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, largerEq, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, largerEq, true).valueOf();
	    }
	  });
	
	  largerEq.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['largerEq'] + '${args[1]}\\right)'
	  };
	
	  return largerEq;
	}
	
	exports.name = 'largerEq';
	exports.factory = factory;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var divideScalar = load(__webpack_require__(1397));
	  var multiply = load(__webpack_require__(1400));
	  var subtract = load(__webpack_require__(1393));
	
	  var cs_reach = load(__webpack_require__(1711));
	
	  /**
	   * The function cs_spsolve() computes the solution to G * x = bk, where bk is the
	   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
	   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U 
	   * is upper triangular with the diagonal entry as the last entry in each column.
	   *
	   * @param {Matrix}  g               The G matrix
	   * @param {Matrix}  b               The B matrix
	   * @param {Number}  k               The kth column in B
	   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
	   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
	   * @param {Array}   x               The soluton to the linear system G * x = b
	   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
	   * @param {boolean} lo              The lower (true) upper triangular (false) flag
	   *
	   * @return {Number}                 The index for the nonzero pattern
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_spsolve = function (g, b, k, xi, x, pinv, lo) {
	    // g arrays
	    var gvalues = g._values;
	    var gindex = g._index;
	    var gptr = g._ptr;
	    var gsize = g._size;
	    // columns
	    var n = gsize[1];
	    // b arrays
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    // vars
	    var p, p0, p1, q;
	    // xi[top..n-1] = cs_reach(B(:,k))
	    var top = cs_reach(g, b, k, xi, pinv);
	    // clear x
	    for (p = top; p < n; p++) 
	      x[xi[p]] = 0;
	    // scatter b
	    for (p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++) 
	      x[bindex[p]] = bvalues[p];
	    // loop columns
	    for (var px = top; px < n; px++) {
	      // x array index for px
	      var j = xi[px];
	      // apply permutation vector (U x = b), j maps to column J of G
	      var J = pinv ? pinv[j] : j;
	      // check column J is empty
	      if (J < 0)
	        continue;
	      // column value indeces in G, p0 <= p < p1
	      p0 = gptr[J];
	      p1 = gptr[J + 1];
	      // x(j) /= G(j,j)
	      x[j] = divideScalar(x[j], gvalues[lo ? p0 : (p1 - 1)]);
	      // first entry L(j,j)
	      p = lo ? (p0 + 1) : p0;
	      q = lo ? (p1) : (p1 - 1);
	      // loop
	      for ( ; p < q ; p++) {
	        // row
	        var i = gindex[p];
	        // x(i) -= G(i,j) * x(j)
	        x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
	      }
	    }
	    // return top of stack
	    return top;
	  };
	  
	  return cs_spsolve;
	}
	
	exports.name = 'cs_spsolve';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_dfs = load(__webpack_require__(1712));
	  var cs_marked = load(__webpack_require__(1713));
	  var cs_mark = load(__webpack_require__(1714));
	
	  /**
	   * The cs_reach function computes X = Reach(B), where B is the nonzero pattern of the n-by-1 
	   * sparse column of vector b. The function returns the set of nodes reachable from any node in B. The
	   * nonzero pattern xi of the solution x to the sparse linear system Lx=b is given by X=Reach(B).
	   *
	   * @param {Matrix}  g               The G matrix
	   * @param {Matrix}  b               The B matrix
	   * @param {Number}  k               The kth column in B
	   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
	   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
	   * @param {Array}   pinv            The inverse row permutation vector
	   *
	   * @return {Number}                 The index for the nonzero pattern
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_reach = function (g, b, k, xi, pinv) {
	    // g arrays
	    var gptr = g._ptr;
	    var gsize = g._size;
	    // b arrays
	    var bindex = b._index;
	    var bptr = b._ptr;
	    // columns
	    var n = gsize[1];
	    // vars
	    var p, p0, p1;
	    // initialize top
	    var top = n;
	    // loop column indeces in B
	    for (p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++) {
	      // node i
	      var i = bindex[p];
	      // check node i is marked
	      if (!cs_marked(gptr, i)) {
	        // start a dfs at unmarked node i
	        top = cs_dfs(i, g, top, xi, pinv);
	      }
	    }
	    // loop columns from top -> n - 1
	    for (p = top; p < n; p++) {
	      // restore G
	      cs_mark(gptr, xi[p]);
	    }
	    return top;
	  };
	
	  return cs_reach;
	}
	
	exports.name = 'cs_reach';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_marked = load(__webpack_require__(1713));
	  var cs_mark   = load(__webpack_require__(1714));
	  var cs_unflip = load(__webpack_require__(1715));
	
	  /**
	   * Depth-first search computes the nonzero pattern xi of the directed graph G (Matrix) starting
	   * at nodes in B (see cs_reach()).
	   *
	   * @param {Number}  j               The starting node for the DFS algorithm
	   * @param {Matrix}  g               The G matrix to search, ptr array modified, then restored
	   * @param {Number}  top             Start index in stack xi[top..n-1]
	   * @param {Number}  k               The kth column in B
	   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
	   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
	   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
	   *
	   * @return {Number}                 New value of top
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_dfs = function (j, g, top, xi, pinv) {
	    // g arrays
	    var index = g._index;
	    var ptr = g._ptr;
	    var size = g._size;
	    // columns
	    var n = size[1];
	    // vars
	    var i, p, p2;
	    // initialize head
	    var head = 0;
	    // initialize the recursion stack
	    xi[0] = j;
	    // loop
	    while (head >= 0) {
	      // get j from the top of the recursion stack
	      j = xi[head];
	      // apply permutation vector
	      var jnew = pinv ? pinv[j] : j;
	      // check node j is marked
	      if (!cs_marked(ptr, j)) {
	        // mark node j as visited
	        cs_mark(ptr, j);
	        // update stack (last n entries in xi)
	        xi[n + head] = jnew < 0 ? 0 : cs_unflip(ptr[jnew]);
	      }
	      // node j done if no unvisited neighbors
	      var done = 1;
	      // examine all neighbors of j, stack (last n entries in xi)
	      for (p = xi[n + head], p2 = jnew < 0 ? 0 : cs_unflip(ptr[jnew+1]); p < p2; p++) {
	        // consider neighbor node i
	        i = index[p];
	        // check we have visited node i, skip it
	        if (cs_marked(ptr, i)) 
	          continue;
	        // pause depth-first search of node j, update stack (last n entries in xi)
	        xi[n + head] = p;
	        // start dfs at node i
	        xi[++head] = i;
	        // node j is not done
	        done = 0;
	        // break, to start dfs(i)
	        break;
	      }
	      // check depth-first search at node j is done
	      if (done) {
	        // remove j from the recursion stack
	        head--;
	        // and place in the output stack
	        xi[--top] = j;
	      }
	    }
	    return top;    
	  };
	
	  return cs_dfs;
	}
	
	exports.name = 'cs_dfs';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * Checks if the node at w[j] is marked
	   *
	   * @param {Array}   w               The array
	   * @param {Number}  j               The array index
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_marked = function (w, j) {
	    // check node is marked
	    return w[j] < 0;
	  };
	
	  return cs_marked;
	}
	
	exports.name = 'cs_marked';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_flip = load(__webpack_require__(1699));
	
	  /**
	   * Marks the node at w[j]
	   *
	   * @param {Array}   w               The array
	   * @param {Number}  j               The array index
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_mark = function (w, j) {
	    // mark w[j]
	    w[j] = cs_flip(w [j]);
	  };
	
	  return cs_mark;
	}
	
	exports.name = 'cs_mark';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load) {
	
	  var cs_flip = load(__webpack_require__(1699));
	  
	  /**
	   * Flips the value if it is negative of returns the same value otherwise.
	   *
	   * @param {Number}  i               The value to flip
	   *
	   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
	   */
	  var cs_unflip = function (i) {
	    // flip the value if it is negative
	    return i < 0 ? cs_flip(i) : i;
	  };
	
	  return cs_unflip;
	}
	
	exports.name = 'cs_unflip';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var divideScalar = load(__webpack_require__(1397));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var subtract = load(__webpack_require__(1393));
	  var equalScalar = load(__webpack_require__(1364));
	
	  var solveValidation = load(__webpack_require__(1717));
	
	  var DenseMatrix = type.DenseMatrix;
	
	  /** 
	   * Solves the linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
	   *
	   * `L * x = b`
	   *
	   * Syntax:
	   *
	   *    math.lsolve(L, b);
	   *
	   * Examples:
	   *
	   *    var a = [[-2, 3], [2, 1]];
	   *    var b = [11, 9];
	   *    var x = lsolve(a, b);  // [[-5.5], [20]]
	   *
	   * See also:
	   *
	   *    lup, slu, usolve, lusolve
	   *
	   * @param {Matrix, Array} L       A N x N matrix or array (L)
	   * @param {Matrix, Array} b       A column vector with the b values
	   *
	   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
	   */
	  var lsolve = typed('lsolve', {
	
	    'SparseMatrix, Array | Matrix': function (m, b) {
	      // process matrix
	      return _sparseForwardSubstitution(m, b);
	    },
	    
	    'DenseMatrix, Array | Matrix': function (m, b) {
	      // process matrix
	      return _denseForwardSubstitution(m, b);
	    },
	    
	    'Array, Array | Matrix': function (a, b) {
	      // create dense matrix from array
	      var m = matrix(a);
	      // use matrix implementation
	      var r = _denseForwardSubstitution(m, b);
	      // result
	      return r.valueOf();
	    }
	  });
	
	  var _denseForwardSubstitution = function (m, b) {
	    // validate matrix and vector, return copy of column vector b
	    b = solveValidation(m, b, true);
	    // column vector data
	    var bdata = b._data;
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // result
	    var x = [];
	    // data
	    var data = m._data;
	    // forward solve m * x = b, loop columns
	    for (var j = 0; j < columns; j++) {
	      // b[j]
	      var bj = bdata[j][0] || 0;
	      // x[j]
	      var xj;
	      // forward substitution (outer product) avoids inner looping when bj == 0
	      if (!equalScalar(bj, 0)) {
	        // value @ [j, j]
	        var vjj = data[j][j];
	        // check vjj
	        if (equalScalar(vjj, 0)) {
	          // system cannot be solved
	          throw new Error('Linear system cannot be solved since matrix is singular');
	        }
	        // calculate xj
	        xj = divideScalar(bj, vjj);
	        // loop rows
	        for (var i = j + 1; i < rows; i++) {
	          // update copy of b
	          bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))];
	        }
	      }
	      else {
	        // zero @ j
	        xj = 0;
	      }
	      // update x
	      x[j] = [xj];
	    }
	    // return vector
	    return new DenseMatrix({
	      data: x,
	      size: [rows, 1]
	    });
	  };
	
	  var _sparseForwardSubstitution = function (m, b) {
	    // validate matrix and vector, return copy of column vector b
	    b = solveValidation(m, b, true);
	    // column vector data
	    var bdata = b._data;
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // matrix arrays
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    // vars
	    var i, k;
	    // result
	    var x = [];
	    // forward solve m * x = b, loop columns
	    for (var j = 0; j < columns; j++) {
	      // b[j]
	      var bj = bdata[j][0] || 0;
	      // forward substitution (outer product) avoids inner looping when bj == 0
	      if (!equalScalar(bj, 0)) {
	        // value @ [j, j]
	        var vjj = 0;
	        // lower triangular matrix values & index (column j)
	        var jvalues = [];
	        var jindex = [];
	        // last index in column
	        var l = ptr[j + 1];
	        // values in column, find value @ [j, j]
	        for (k = ptr[j]; k < l; k++) {
	          // row
	          i = index[k];
	          // check row (rows are not sorted!)
	          if (i === j) {
	            // update vjj
	            vjj = values[k];
	          }
	          else if (i > j) {
	            // store lower triangular
	            jvalues.push(values[k]);
	            jindex.push(i);
	          }
	        }
	        // at this point we must have a value @ [j, j]
	        if (equalScalar(vjj, 0)) {
	          // system cannot be solved, there is no value @ [j, j]
	          throw new Error('Linear system cannot be solved since matrix is singular');
	        }
	        // calculate xj
	        var xj = divideScalar(bj, vjj);
	        // loop lower triangular
	        for (k = 0, l = jindex.length; k < l; k++) {
	          // row
	          i = jindex[k];
	          // update copy of b
	          bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar(xj, jvalues[k]))];
	        }
	        // update x
	        x[j] = [xj];
	      }
	      else {
	        // update x
	        x[j] = [0];
	      }
	    }
	    // return vector
	    return new DenseMatrix({
	      data: x,
	      size: [rows, 1]
	    });
	  };
	
	  return lsolve;
	}
	
	exports.name = 'lsolve';
	exports.factory = factory;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1356);
	
	var string = util.string;
	var array = util.array;
	
	var isArray = Array.isArray;
	
	function factory (type) {
	  
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Validates matrix and column vector b for backward/forward substitution algorithms.
	   *
	   * @param {Matrix} m            An N x N matrix
	   * @param {Array | Matrix} b    A column vector
	   * @param {Boolean} copy        Return a copy of vector b
	   *
	   * @return {DenseMatrix}        Dense column vector b
	   */
	  var solveValidation = function (m, b, copy) {
	    // matrix size
	    var size = m.size();
	    // validate matrix dimensions
	    if (size.length !== 2)
	      throw new RangeError('Matrix must be two dimensional (size: ' + string.format(size) + ')');
	    // rows & columns
	    var rows = size[0];
	    var columns = size[1];    
	    // validate rows & columns
	    if (rows !== columns) 
	      throw new RangeError('Matrix must be square (size: ' + string.format(size) + ')');
	    // vars
	    var data, i, bdata;
	    // check b is matrix
	    if (type.isMatrix(b)) {
	      // matrix size
	      var msize = b.size();
	      // vector
	      if (msize.length === 1) {
	        // check vector length
	        if (msize[0] !== rows)
	          throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
	        // create data array
	        data = [];
	        // matrix data (DenseMatrix)
	        bdata = b._data;
	        // loop b data
	        for (i = 0; i < rows; i++) {
	          // row array
	          data[i] = [bdata[i]];
	        }
	        // return Dense Matrix
	        return new DenseMatrix({
	          data: data,
	          size: [rows, 1],
	          datatype: b._datatype
	        });
	      }
	      // two dimensions
	      if (msize.length === 2) {
	        // array must be a column vector
	        if (msize[0] !== rows || msize[1] !== 1)
	          throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
	        // check matrix type
	        if (type.isDenseMatrix(b)) {
	          // check a copy is needed
	          if (copy) {
	            // create data array
	            data = [];
	            // matrix data (DenseMatrix)
	            bdata = b._data;
	            // loop b data
	            for (i = 0; i < rows; i++) {
	              // row array
	              data[i] = [bdata[i][0]];
	            }
	            // return Dense Matrix
	            return new DenseMatrix({
	              data: data,
	              size: [rows, 1],
	              datatype: b._datatype
	            });
	          }
	          // b is already a column vector
	          return b;
	        }
	        // create data array
	        data = [];
	        for (i = 0; i < rows; i++)
	          data[i] = [0];
	        // sparse matrix arrays
	        var values = b._values;
	        var index = b._index;
	        var ptr = b._ptr;
	        // loop values in column 0
	        for (var k1 = ptr[1], k = ptr[0]; k < k1; k++) {
	          // row
	          i = index[k];
	          // add to data
	          data[i][0] = values[k]; 
	        }
	        // return Dense Matrix
	        return new DenseMatrix({
	          data: data,
	          size: [rows, 1],
	          datatype: b._datatype
	        });
	      }
	      // throw error
	      throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
	    }
	    // check b is array
	    if (isArray(b)) {
	      // size
	      var asize = array.size(b);
	      // check matrix dimensions, vector
	      if (asize.length === 1) {
	        // check vector length
	        if (asize[0] !== rows)
	          throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');        
	        // create data array
	        data = [];
	        // loop b
	        for (i = 0; i < rows; i++) {
	          // row array
	          data[i] = [b[i]];
	        }
	        // return Dense Matrix
	        return new DenseMatrix({
	          data: data,
	          size: [rows, 1]
	        });
	      }
	      if (asize.length === 2) {
	        // array must be a column vector
	        if (asize[0] !== rows || asize[1] !== 1)
	          throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
	        // create data array
	        data = [];
	        // loop b data
	        for (i = 0; i < rows; i++) {
	          // row array
	          data[i] = [b[i][0]];
	        }
	        // return Dense Matrix
	        return new DenseMatrix({
	          data: data,
	          size: [rows, 1]
	        });
	      }
	      // throw error
	      throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');      
	    }
	  };
	  
	  return solveValidation;
	}
	
	exports.factory = factory;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = Array.isArray;
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	  var lup = load(__webpack_require__(1672));
	  var slu = load(__webpack_require__(1696));
	  var cs_ipvec = load(__webpack_require__(1719));
	
	  var solveValidation = load(__webpack_require__(1717));
	
	  var usolve = load(__webpack_require__(1720));
	  var lsolve = load(__webpack_require__(1716));
	
	  /**
	   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
	   *
	   * Syntax:
	   *
	   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
	   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
	   *
	   * Examples:
	   *
	   *    var m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]];
	   *
	   *    var x = math.lusolve(m, [-1, -1, -1, -1]);        // x = [[-1], [-0.5], [-1/3], [-0.25]]
	   *
	   *    var f = math.lup(m);
	   *    var x1 = math.lusolve(f, [-1, -1, -1, -1]);       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
	   *    var x2 = math.lusolve(f, [1, 2, 1, -1]);          // x2 = [[1], [1], [1/3], [-0.25]]
	   *
	   *    var a = [[-2, 3], [2, 1]];
	   *    var b = [11, 9];
	   *    var x = math.lusolve(a, b);  // [[2], [5]]
	   *
	   * See also:
	   *
	   *    lup, slu, lsolve, usolve
	   *
	   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
	   * @param {Matrix | Array} b               Column Vector
	   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
	   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
	   *
	   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
	   */
	  var lusolve = typed('lusolve', {
	    
	    'Array, Array | Matrix': function (a, b) {
	      // convert a to matrix
	      a = matrix(a);
	      // matrix lup decomposition
	      var d = lup(a);
	      // solve
	      var x = _lusolve(d.L, d.U, d.p, null, b);
	      // convert result to array
	      return x.valueOf();
	    },
	    
	    'DenseMatrix, Array | Matrix': function (a, b) {
	      // matrix lup decomposition
	      var d = lup(a);
	      // solve
	      return _lusolve(d.L, d.U, d.p, null, b);
	    },
	    
	    'SparseMatrix, Array | Matrix': function (a, b) {
	      // matrix lup decomposition
	      var d = lup(a);
	      // solve
	      return _lusolve(d.L, d.U, d.p, null, b);
	    },
	    
	    'SparseMatrix, Array | Matrix, number, number': function (a, b, order, threshold) {
	      // matrix lu decomposition
	      var d = slu(a, order, threshold);
	      // solve
	      return _lusolve(d.L, d.U, d.p, d.q, b);
	    },
	
	    'Object, Array | Matrix': function (d, b) {
	      // solve
	      return _lusolve(d.L, d.U, d.p, d.q, b);
	    }
	  });
	  
	  var _toMatrix = function (a) {
	    // check it is a matrix
	    if (type.isMatrix(a))
	      return a;
	    // check array
	    if (isArray(a))
	      return matrix(a);
	    // throw
	    throw new TypeError('Invalid Matrix LU decomposition');
	  };
	  
	  var _lusolve = function (l, u, p, q, b) {
	    // verify L, U, P
	    l = _toMatrix(l);
	    u = _toMatrix(u);
	    // validate matrix and vector
	    b = solveValidation(l, b, false);
	    // apply row permutations if needed (b is a DenseMatrix)
	    if (p)
	      b._data = cs_ipvec(p, b._data);
	    // use forward substitution to resolve L * y = b
	    var y = lsolve(l, b);
	    // use backward substitution to resolve U * x = y
	    var x = usolve(u, y);
	    // apply column permutations if needed (x is a DenseMatrix)
	    if (q)
	      x._data = cs_ipvec(q, x._data);
	    // return solution
	    return x;
	  };
	
	  return lusolve;
	}
	
	exports.name = 'lusolve';
	exports.factory = factory;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory () {
	
	  /**
	   * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
	   *
	   * @param {Array} p           The permutation vector of length n. null value denotes identity
	   * @param {Array} b           The input vector
	   *
	   * @return {Array}            The output vector x = P'b
	   */
	  var cs_ipvec = function (p, b, n) {
	    // vars 
	    var k;
	    var n = b.length;
	    var x = [];
	    // check permutation vector was provided, p = null denotes identity
	    if (p) {
	      // loop vector
	      for (k = 0; k < n; k++) {
	        // apply permutation
	        x[p[k]] = b[k];
	      }
	    }
	    else {
	      // loop vector
	      for (k = 0; k < n; k++) {
	        // x[i] = b[i]
	        x[k] = b[k];
	      }
	    }
	    return x;
	  };
	
	  return cs_ipvec;
	}
	
	exports.name = 'cs_ipvec';
	exports.path = 'sparse';
	exports.factory = factory;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var divideScalar = load(__webpack_require__(1397));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var subtract = load(__webpack_require__(1393));
	  var equalScalar = load(__webpack_require__(1364));
	
	  var solveValidation = load(__webpack_require__(1717));
	  
	  var DenseMatrix = type.DenseMatrix;
	
	  /**
	   * Solves the linear equation system by backward substitution. Matrix must be an upper triangular matrix.
	   *
	   * `U * x = b`
	   *
	   * Syntax:
	   *
	   *    math.usolve(U, b);
	   *
	   * Examples:
	   *
	   *    var a = [[-2, 3], [2, 1]];
	   *    var b = [11, 9];
	   *    var x = usolve(a, b);  // [[8], [9]]
	   *
	   * See also:
	   *
	   *    lup, slu, usolve, lusolve
	   *
	   * @param {Matrix, Array} U       A N x N matrix or array (U)
	   * @param {Matrix, Array} b       A column vector with the b values
	   *
	   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
	   */
	  var usolve = typed('usolve', {
	    
	    'SparseMatrix, Array | Matrix': function (m, b) {
	      // process matrix
	      return _sparseBackwardSubstitution(m, b);
	    },
	
	    'DenseMatrix, Array | Matrix': function (m, b) {
	      // process matrix
	      return _denseBackwardSubstitution(m, b);
	    },
	
	    'Array, Array | Matrix': function (a, b) {
	      // create dense matrix from array
	      var m = matrix(a);
	      // use matrix implementation
	      var r = _denseBackwardSubstitution(m, b);
	      // result
	      return r.valueOf();
	    }
	  });
	
	  var _denseBackwardSubstitution = function (m, b) {
	    // validate matrix and vector, return copy of column vector b
	    b = solveValidation(m, b, true);
	    // column vector data
	    var bdata = b._data;
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // result
	    var x = [];
	    // arrays
	    var data = m._data;
	    // backward solve m * x = b, loop columns (backwards)
	    for (var j = columns - 1; j >= 0 ; j--) {
	      // b[j]
	      var bj = bdata[j][0] || 0;
	      // x[j]
	      var xj;
	      // backward substitution (outer product) avoids inner looping when bj == 0
	      if (!equalScalar(bj, 0)) {
	        // value @ [j, j]
	        var vjj = data[j][j];
	        // check vjj
	        if (equalScalar(vjj, 0)) {
	          // system cannot be solved
	          throw new Error('Linear system cannot be solved since matrix is singular');
	        }
	        // calculate xj
	        xj = divideScalar(bj, vjj);        
	        // loop rows
	        for (var i = j - 1; i >= 0; i--) {
	          // update copy of b
	          bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar(xj, data[i][j]))];
	        }
	      }
	      else {
	        // zero value @ j
	        xj = 0;
	      }
	      // update x
	      x[j] = [xj];
	    }
	    // return column vector
	    return new DenseMatrix({
	      data: x,
	      size: [rows, 1]
	    });
	  };
	  
	  var _sparseBackwardSubstitution = function (m, b) {
	    // validate matrix and vector, return copy of column vector b
	    b = solveValidation(m, b, true);
	    // column vector data
	    var bdata = b._data;
	    // rows & columns
	    var rows = m._size[0];
	    var columns = m._size[1];
	    // matrix arrays
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    // vars
	    var i, k;
	    // result
	    var x = [];
	    // backward solve m * x = b, loop columns (backwards)
	    for (var j = columns - 1; j >= 0 ; j--) {
	      // b[j]
	      var bj = bdata[j][0] || 0;
	      // backward substitution (outer product) avoids inner looping when bj == 0
	      if (!equalScalar(bj, 0)) {
	        // value @ [j, j]
	        var vjj = 0;
	        // upper triangular matrix values & index (column j)
	        var jvalues = [];
	        var jindex = [];
	        // first & last indeces in column
	        var f = ptr[j];
	        var l = ptr[j + 1];
	        // values in column, find value @ [j, j], loop backwards
	        for (k = l - 1; k >= f; k--) {
	          // row
	          i = index[k];
	          // check row
	          if (i === j) {
	            // update vjj
	            vjj = values[k];
	          }
	          else if (i < j) {
	            // store upper triangular
	            jvalues.push(values[k]);
	            jindex.push(i);
	          }
	        }
	        // at this point we must have a value @ [j, j]
	        if (equalScalar(vjj, 0)) {
	          // system cannot be solved, there is no value @ [j, j]
	          throw new Error('Linear system cannot be solved since matrix is singular');
	        }
	        // calculate xj
	        var xj = divideScalar(bj, vjj);
	        // loop upper triangular
	        for (k = 0, l = jindex.length; k < l; k++) {
	          // row
	          i = jindex[k];
	          // update copy of b
	          bdata[i] = [subtract(bdata[i][0], multiplyScalar(xj, jvalues[k]))];
	        }
	        // update x
	        x[j] = [xj];
	      }
	      else {
	        // update x
	        x[j] = [0];
	      }
	    }
	    // return vector
	    return new DenseMatrix({
	      data: x,
	      size: [rows, 1]
	    });
	  };
	  
	  return usolve;
	}
	
	exports.name = 'usolve';
	exports.factory = factory;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1402),
	  __webpack_require__(1367),
	  __webpack_require__(1369),
	  __webpack_require__(1722),
	  __webpack_require__(1724),
	  __webpack_require__(1725),
	  __webpack_require__(1669),
	  __webpack_require__(1726),
	  __webpack_require__(1728),
	  __webpack_require__(1730),
	  __webpack_require__(1731),
	  __webpack_require__(1732),
	  __webpack_require__(1403),
	  __webpack_require__(1733),
	  __webpack_require__(1734),
	  __webpack_require__(1735),
	  __webpack_require__(1736),
	  __webpack_require__(1739),
	  __webpack_require__(1740),
	  __webpack_require__(1741),
	  __webpack_require__(1742),
	  __webpack_require__(1743),
	  __webpack_require__(1400),
	  __webpack_require__(1744),
	  __webpack_require__(1746),
	  __webpack_require__(1398),
	  __webpack_require__(1404),
	  __webpack_require__(1693),
	  __webpack_require__(1694),
	  __webpack_require__(1747),
	  __webpack_require__(1393),
	  __webpack_require__(1394),
	  __webpack_require__(1748),
	  __webpack_require__(1749)
	];


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var unaryMinus = load(__webpack_require__(1394));
	  var isNegative = load(__webpack_require__(1723));
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Calculate the cubic root of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.cbrt(x)
	   *    math.cbrt(x, allRoots)
	   *
	   * Examples:
	   *
	   *    math.cbrt(27);                  // returns 3
	   *    math.cube(3);                   // returns 27
	   *    math.cbrt(-64);                 // returns -4
	   *    math.cbrt(math.unit('27 m^3')); // returns Unit 3 m
	   *    math.cbrt([27, 64, 125]);       // returns [3, 4, 5]
	   *
	   *    var x = math.complex('8i');
	   *    math.cbrt(x);                   // returns Complex 1.7320508075689 + i
	   *    math.cbrt(x, true);             // returns Matrix [
	   *                                    //    1.7320508075689 + i
	   *                                    //   -1.7320508075689 + i
	   *                                    //   -2i
	   *                                    // ]
	   *
	   * See also:
	   *
	   *    square, sqrt, cube
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
	   *            Value for which to calculate the cubic root.
	   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
	   *            when `x` is a number or complex number. If true, all complex
	   *            roots are returned, if false (default) the principal root is
	   *            returned.
	   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
	   *            Returns the cubic root of `x`
	   */
	  var cbrt = typed('cbrt', {
	    'number': _cbrtNumber,
	    // note: signature 'number, boolean' is also supported,
	    //       created by typed as it knows how to convert number to Complex
	
	    'Complex': _cbrtComplex,
	
	    'Complex, boolean': _cbrtComplex,
	
	    'BigNumber': function (x) {
	      return x.cbrt();
	    },
	
	    'Unit': _cbrtUnit,
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since cbrt(0) = 0
	      return deepMap(x, cbrt, true);
	    }
	  });
	
	  /**
	   * Calculate the cubic root for a complex number
	   * @param {Complex} x
	   * @param {boolean} [allRoots]   If true, the function will return an array
	   *                               with all three roots. If false or undefined,
	   *                               the principal root is returned.
	   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
	   * @private
	   */
	  function _cbrtComplex(x, allRoots) {
	    // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
	
	    var arg_3 = x.arg() / 3;
	    var abs = x.abs();
	
	    // principal root:
	    var principal = new type.Complex(_cbrtNumber(abs), 0).mul(
	        new type.Complex(0, arg_3).exp());
	
	    if (allRoots) {
	      var all = [
	          principal,
	          new type.Complex(_cbrtNumber(abs), 0).mul(
	            new type.Complex(0, arg_3 + Math.PI * 2 / 3).exp()),
	          new type.Complex(_cbrtNumber(abs), 0).mul(
	            new type.Complex(0, arg_3 - Math.PI * 2 / 3).exp())
	      ];
	
	      return (config.matrix === 'Array') ? all : matrix(all);
	    }
	    else {
	      return principal;
	    }
	  }
	
	  /**
	   * Calculate the cubic root for a Unit
	   * @param {Unit} x
	   * @return {Unit} Returns the cubic root of x
	   * @private
	   */
	  function _cbrtUnit(x) {
	    if(x.value && type.isComplex(x.value)) {
	      var result = x.clone();
	      result.value = 1.0;
	      result = result.pow(1.0/3);           // Compute the units
	      result.value = _cbrtComplex(x.value); // Compute the value
	      return result;
	    }
	    else {
	      var negate = isNegative(x.value);
	      if (negate) {
	        x.value = unaryMinus(x.value);
	      }
	
	      // TODO: create a helper function for this
	      var third;
	      if (type.isBigNumber(x.value)) {
	        third = new type.BigNumber(1).div(3);
	      }
	      else if (type.isFraction(x.value)) {
	        third = new type.Fraction(1, 3);
	      }
	      else {
	        third = 1/3;
	      }
	
	      var result = x.pow(third);
	
	      if (negate) {
	        result.value = unaryMinus(result.value);
	      }
	
	      return result;
	    }
	  }
	
	  cbrt.toTex = {1: '\\sqrt[3]{${args[0]}}'};
	
	  return cbrt;
	}
	
	/**
	 * Calculate cbrt for a number
	 *
	 * Code from es6-shim.js:
	 *   https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1564-L1577
	 *
	 * @param {number} x
	 * @returns {number | Complex} Returns the cubic root of x
	 * @private
	 */
	var _cbrtNumber = Math.cbrt || function (x) {
	  if (x === 0) {
	    return x;
	  }
	
	  var negate = x < 0;
	  var result;
	  if (negate) {
	    x = -x;
	  }
	
	  if (isFinite(x)) {
	    result = Math.exp(Math.log(x) / 3);
	    // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
	    result = (x / (result * result) + (2 * result)) / 3;
	  } else {
	    result = x;
	  }
	
	  return negate ? -result : result;
	};
	
	exports.name = 'cbrt';
	exports.factory = factory;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is negative: smaller than zero.
	   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isNegative(x)
	   *
	   * Examples:
	   *
	   *    math.isNegative(3);                     // returns false
	   *    math.isNegative(-2);                    // returns true
	   *    math.isNegative(0);                     // returns false
	   *    math.isNegative(-0);                    // returns false
	   *    math.isNegative(math.bignumber(2));     // returns false
	   *    math.isNegative(math.fraction(-2, 5));  // returns true
	   *    math.isNegative('-2');                  // returns true
	   *    math.isNegative([2, 0, -3]');           // returns [false, false, true]
	   *
	   * See also:
	   *
	   *    isNumeric, isPositive, isZero, isInteger
	   *
	   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
	   * @return {boolean}  Returns true when `x` is larger than zero.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isNegative = typed('isNegative', {
	    'number': function (x) {
	      return x < 0;
	    },
	
	    'BigNumber': function (x) {
	      return x.isNeg() && !x.isZero() && !x.isNaN();
	    },
	
	    'Fraction': function (x) {
	      return x.s < 0; // It's enough to decide on the sign
	    },
	
	    'Unit': function (x) {
	      return isNegative(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isNegative);
	    }
	  });
	
	  return isNegative;
	}
	
	exports.name = 'isNegative';
	exports.factory = factory;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Round a value towards plus infinity
	   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.ceil(x)
	   *
	   * Examples:
	   *
	   *    math.ceil(3.2);               // returns number 4
	   *    math.ceil(3.8);               // returns number 4
	   *    math.ceil(-4.2);              // returns number -4
	   *    math.ceil(-4.7);              // returns number -4
	   *
	   *    var c = math.complex(3.2, -2.7);
	   *    math.ceil(c);                 // returns Complex 4 - 2i
	   *
	   *    math.ceil([3.2, 3.8, -4.7]);  // returns Array [4, 4, -4]
	   *
	   * See also:
	   *
	   *    floor, fix, round
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
	   */
	  var ceil = typed('ceil', {
	    'number': Math.ceil,
	
	    'Complex': function (x) {
	      return x.ceil();
	    },
	
	    'BigNumber': function (x) {
	      return x.ceil();
	    },
	
	    'Fraction': function (x) {
	      return x.ceil();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since ceil(0) = 0
	      return deepMap(x, ceil, true);
	    }
	  });
	
	  ceil.toTex = {1: '\\left\\lceil${args[0]}\\right\\rceil'};
	
	  return ceil;
	}
	
	exports.name = 'ceil';
	exports.factory = factory;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Compute the cube of a value, `x * x * x`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.cube(x)
	   *
	   * Examples:
	   *
	   *    math.cube(2);            // returns number 8
	   *    math.pow(2, 3);          // returns number 8
	   *    math.cube(4);            // returns number 64
	   *    4 * 4 * 4;               // returns number 64
	   *
	   *    math.cube([1, 2, 3, 4]); // returns Array [1, 8, 27, 64]
	   *
	   * See also:
	   *
	   *    multiply, square, pow, cbrt
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
	   */
	  var cube = typed('cube', {
	    'number': function (x) {
	      return x * x * x;
	    },
	
	    'Complex': function (x) {
	      return x.mul(x).mul(x); // Is faster than pow(x, 3)
	    },
	
	    'BigNumber': function (x) {
	      return x.times(x).times(x);
	    },
	
	    'Fraction': function (x) {
	      return x.pow(3); // Is faster than mul()mul()mul()
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since cube(0) = 0
	      return deepMap(x, cube, true);
	    },
	
	    'Unit': function(x) {
	      return x.pow(3);
	    }
	  });
	
	  cube.toTex = {1: '\\left(${args[0]}\\right)^3'};
	
	  return cube;
	}
	
	exports.name = 'cube';
	exports.factory = factory;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var divideScalar = load(__webpack_require__(1397));
	  var latex = __webpack_require__(1348);
	  
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Divide two matrices element wise. The function accepts both matrices and
	   * scalar values.
	   *
	   * Syntax:
	   *
	   *    math.dotDivide(x, y)
	   *
	   * Examples:
	   *
	   *    math.dotDivide(2, 4);   // returns 0.5
	   *
	   *    a = [[9, 5], [6, 1]];
	   *    b = [[3, 2], [5, 2]];
	   *
	   *    math.dotDivide(a, b);   // returns [[3, 2.5], [1.2, 0.5]]
	   *    math.divide(a, b);      // returns [[1.75, 0.75], [-1.75, 2.25]]
	   *
	   * See also:
	   *
	   *    divide, multiply, dotMultiply
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
	   */
	  var dotDivide = typed('dotDivide', {
	    
	    'any, any': divideScalar,
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      return algorithm07(x, y, divideScalar, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      return algorithm02(y, x, divideScalar, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      return algorithm03(x, y, divideScalar, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      return algorithm13(x, y, divideScalar);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return dotDivide(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return dotDivide(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return dotDivide(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, divideScalar, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, divideScalar, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, divideScalar, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, divideScalar, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, divideScalar, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, divideScalar, true).valueOf();
	    }
	  });
	
	  dotDivide.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['dotDivide'] + '${args[1]}\\right)'
	  };
	  
	  return dotDivide;
	}
	
	exports.name = 'dotDivide';
	exports.factory = factory;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij). 
	   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
	   *
	   *
	   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
	   * C(i,j) = ┤
	   *          └  0            ; otherwise
	   *
	   *
	   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
	   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
	   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
	   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
	   */
	  var algorithm02 = function (denseMatrix, sparseMatrix, callback, inverse) {
	    // dense matrix arrays
	    var adata = denseMatrix._data;
	    var asize = denseMatrix._size;
	    var adt = denseMatrix._datatype;
	    // sparse matrix arrays
	    var bvalues = sparseMatrix._values;
	    var bindex = sparseMatrix._index;
	    var bptr = sparseMatrix._ptr;
	    var bsize = sparseMatrix._size;
	    var bdt = sparseMatrix._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!bvalues)
	      throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	    
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result (SparseMatrix)
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	
	    // loop columns in b
	    for (var j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // values in column j
	      for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        var i = bindex[k];
	        // update C(i,j)
	        var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
	        // check for nonzero
	        if (!eq(cij, zero)) {
	          // push i & v
	          cindex.push(i);
	          cvalues.push(cij);
	        }
	      }
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	  };
	  
	  return algorithm02;
	}
	
	exports.name = 'algorithm02';
	exports.factory = factory;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var latex = __webpack_require__(1348);
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm09 = load(__webpack_require__(1729));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Multiply two matrices element wise. The function accepts both matrices and
	   * scalar values.
	   *
	   * Syntax:
	   *
	   *    math.dotMultiply(x, y)
	   *
	   * Examples:
	   *
	   *    math.dotMultiply(2, 4); // returns 8
	   *
	   *    a = [[9, 5], [6, 1]];
	   *    b = [[3, 2], [5, 2]];
	   *
	   *    math.dotMultiply(a, b); // returns [[27, 10], [30, 2]]
	   *    math.multiply(a, b);    // returns [[52, 28], [23, 14]]
	   *
	   * See also:
	   *
	   *    multiply, divide, dotDivide
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
	   */
	  var dotMultiply = typed('dotMultiply', {
	    
	    'any, any': multiplyScalar,
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      return algorithm09(x, y, multiplyScalar, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      return algorithm02(y, x, multiplyScalar, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      return algorithm02(x, y, multiplyScalar, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      return algorithm13(x, y, multiplyScalar);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return dotMultiply(matrix(x), matrix(y)).valueOf();
	    },
	    
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return dotMultiply(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return dotMultiply(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, multiplyScalar, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, multiplyScalar, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm11(y, x, multiplyScalar, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, multiplyScalar, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
	    }
	  });
	
	  dotMultiply.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['dotMultiply'] + '${args[1]}\\right)'
	  };
	  
	  return dotMultiply;
	}
	
	exports.name = 'dotMultiply';
	exports.factory = factory;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked NZA times, number of nonzero elements in A.
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  0            ; otherwise
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm09 = function (a, b, callback) {
	    // sparse matrix arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = avalues && bvalues ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var x = cvalues ? [] : undefined;
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // vars
	    var i, j, k, k0, k1;
	    
	    // loop columns
	    for (j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // column mark
	      var mark = j + 1;
	      // check we need to process values
	      if (x) {
	        // loop B(:,j)
	        for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	          // row
	          i = bindex[k];
	          // update workspace
	          w[i] = mark;
	          x[i] = bvalues[k];
	        }
	      }
	      // loop A(:,j)
	      for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = aindex[k];
	        // check we need to process values
	        if (x) {
	          // b value @ i,j
	          var vb = w[i] === mark ? x[i] : zero;
	          // invoke f
	          var vc = cf(avalues[k], vb);
	          // check zero value
	          if (!eq(vc, zero)) {
	            // push index
	            cindex.push(i);
	            // push value
	            cvalues.push(vc);
	          }
	        }
	        else {
	          // push index
	          cindex.push(i);
	        }
	      }
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	
	  return algorithm09;
	}
	
	exports.name = 'algorithm09';
	exports.factory = factory;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var pow = load(__webpack_require__(1398));
	  var latex = __webpack_require__(1348);
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Calculates the power of x to y element wise.
	   *
	   * Syntax:
	   *
	   *    math.dotPow(x, y)
	   *
	   * Examples:
	   *
	   *    math.dotPow(2, 3);            // returns number 8
	   *
	   *    var a = [[1, 2], [4, 3]];
	   *    math.dotPow(a, 2);            // returns Array [[1, 4], [16, 9]]
	   *    math.pow(a, 2);               // returns Array [[9, 8], [16, 17]]
	   *
	   * See also:
	   *
	   *    pow, sqrt, multiply
	   *
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
	   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
	   */
	  var dotPow = typed('dotPow', {
	    
	    'any, any': pow,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, pow, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, pow, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, pow, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, pow);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return dotPow(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return dotPow(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return dotPow(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, dotPow, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, dotPow, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, dotPow, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, dotPow, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, dotPow, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, dotPow, true).valueOf();
	    }
	  });
	
	  dotPow.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['dotPow'] + '${args[1]}\\right)'
	  };
	  
	  return dotPow;
	}
	
	exports.name = 'dotPow';
	exports.factory = factory;


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the exponent of a value.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.exp(x)
	   *
	   * Examples:
	   *
	   *    math.exp(2);                  // returns number 7.3890560989306495
	   *    math.pow(math.e, 2);          // returns number 7.3890560989306495
	   *    math.log(math.exp(2));        // returns number 2
	   *
	   *    math.exp([1, 2, 3]);
	   *    // returns Array [
	   *    //   2.718281828459045,
	   *    //   7.3890560989306495,
	   *    //   20.085536923187668
	   *    // ]
	   *
	   * See also:
	   *
	   *    expm1, log, pow
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
	   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
	   */
	  var exp = typed('exp', {
	    'number': Math.exp,
	
	    'Complex': function (x) {
	      return x.exp();
	    },
	
	    'BigNumber': function (x) {
	      return x.exp();
	    },
	
	    'Array | Matrix': function (x) {
	      // TODO: exp(sparse) should return a dense matrix since exp(0)==1
	      return deepMap(x, exp);
	    }
	  });
	
	  exp.toTex = {1: '\\exp\\left(${args[0]}\\right)'};
	
	  return exp;
	}
	
	exports.name = 'exp';
	exports.factory = factory;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Calculate the value of subtracting 1 from the exponential value.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.expm1(x)
	   *
	   * Examples:
	   *
	   *    math.expm1(2);                      // returns number 6.38905609893065
	   *    math.pow(math.e, 2) - 1;            // returns number 6.3890560989306495
	   *    math.log(math.expm1(2) + 1);        // returns number 2
	   *
	   *    math.expm1([1, 2, 3]);
	   *    // returns Array [
	   *    //   1.718281828459045,
	   *    //   6.3890560989306495,
	   *    //   19.085536923187668
	   *    // ]
	   *
	   * See also:
	   *
	   *    exp, log, pow
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
	   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
	   */
	  var expm1 = typed('expm1', {
	    'number': Math.expm1 || _expm1,
	
	    'Complex': function (x) {
	      var r = Math.exp(x.re);
	      return new type.Complex(
	          r * Math.cos(x.im) - 1,
	          r * Math.sin(x.im)
	      );
	    },
	
	    'BigNumber': function (x) {
	      return x.exp().minus(1);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, expm1);
	    }
	  });
	
	  /**
	   * Calculates exponentiation minus 1.
	   * @param {number} x
	   * @return {number} res
	   * @private
	   */
	  function _expm1(x) {
	    return (x >= 2e-4 || x <= -2e-4)
	      ? Math.exp(x) - 1
	      : x + x*x/2 + x*x*x/6;
	  }
	
	  expm1.toTex = '\\left(e' + latex.operators['pow'] + '{${args[0]}}-1\\right)';
	
	  return expm1;
	}
	
	exports.name = 'expm1';
	exports.factory = factory;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Round a value towards minus infinity.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.floor(x)
	   *
	   * Examples:
	   *
	   *    math.floor(3.2);              // returns number 3
	   *    math.floor(3.8);              // returns number 3
	   *    math.floor(-4.2);             // returns number -5
	   *    math.floor(-4.7);             // returns number -5
	   *
	   *    var c = math.complex(3.2, -2.7);
	   *    math.floor(c);                // returns Complex 3 - 3i
	   *
	   *    math.floor([3.2, 3.8, -4.7]); // returns Array [3, 3, -5]
	   *
	   * See also:
	   *
	   *    ceil, fix, round
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
	   */
	  var floor = typed('floor', {
	    'number': Math.floor,
	
	    'Complex': function (x) {
	      return x.floor();
	    },
	
	    'BigNumber': function (x) {
	      return x.floor();
	    },
	
	    'Fraction': function (x) {
	      return x.floor();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since floor(0) = 0
	      return deepMap(x, floor, true);
	    }
	  });
	
	  floor.toTex = {1: '\\left\\lfloor${args[0]}\\right\\rfloor'};
	
	  return floor;
	}
	
	exports.name = 'floor';
	exports.factory = factory;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm04 = load(__webpack_require__(1371));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Calculate the greatest common divisor for two or more values or arrays.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.gcd(a, b)
	   *    math.gcd(a, b, c, ...)
	   *
	   * Examples:
	   *
	   *    math.gcd(8, 12);              // returns 4
	   *    math.gcd(-4, 6);              // returns 2
	   *    math.gcd(25, 15, -10);        // returns 5
	   *
	   *    math.gcd([8, -4], [12, 6]);   // returns [4, 2]
	   *
	   * See also:
	   *
	   *    lcm, xgcd
	   *
	   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
	   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
	   */
	  var gcd = typed('gcd', {
	
	    'number, number': _gcd,
	
	    'BigNumber, BigNumber': _gcdBigNumber,
	
	    'Fraction, Fraction': function (x, y) {
	      return x.gcd(y);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm04(x, y, gcd);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm01(y, x, gcd, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm01(x, y, gcd, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, gcd);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return gcd(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return gcd(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return gcd(x, matrix(y));
	    },
	    
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      return algorithm10(x, y, gcd, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      return algorithm14(x, y, gcd, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      return algorithm10(y, x, gcd, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, gcd, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, gcd, false).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, gcd, true).valueOf();
	    },
	
	    // TODO: need a smarter notation here
	    'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function (a, b, args) {
	      var res = gcd(a, b);
	      for (var i = 0; i < args.length; i++) {
	        res = gcd(res, args[i]);
	      }
	      return res;
	    }
	  });
	
	  gcd.toTex = '\\gcd\\left(${args}\\right)';
	
	  return gcd;
	
	  /**
	   * Calculate gcd for BigNumbers
	   * @param {BigNumber} a
	   * @param {BigNumber} b
	   * @returns {BigNumber} Returns greatest common denominator of a and b
	   * @private
	   */
	  function _gcdBigNumber(a, b) {
	    if (!a.isInt() || !b.isInt()) {
	      throw new Error('Parameters in function gcd must be integer numbers');
	    }
	
	    // http://en.wikipedia.org/wiki/Euclidean_algorithm
	    var zero = new type.BigNumber(0);
	    while (!b.isZero()) {
	      var r = a.mod(b);
	      a = b;
	      b = r;
	    }
	    return a.lt(zero) ? a.neg() : a;
	  }
	}
	
	/**
	 * Calculate gcd for numbers
	 * @param {number} a
	 * @param {number} b
	 * @returns {number} Returns the greatest common denominator of a and b
	 * @private
	 */
	function _gcd(a, b) {
	  if (!isInteger(a) || !isInteger(b)) {
	    throw new Error('Parameters in function gcd must be integer numbers');
	  }
	
	  // http://en.wikipedia.org/wiki/Euclidean_algorithm
	  var r;
	  while (b != 0) {
	    r = a % b;
	    a = b;
	    b = r;
	  }
	  return (a < 0) ? -a : a;
	}
	
	exports.name = 'gcd';
	exports.factory = factory;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var abs = load(__webpack_require__(1402));
	  var add = load(__webpack_require__(1369));
	  var divide = load(__webpack_require__(1397));
	  var multiply = load(__webpack_require__(1396));
	  var sqrt = load(__webpack_require__(1694));
	  var smaller = load(__webpack_require__(1376));
	  var isPositive = load(__webpack_require__(1691));
	
	  /**
	   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
	   *
	   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
	   *
	   * For matrix input, the hypotenusa is calculated for all values in the matrix.
	   *
	   * Syntax:
	   *
	   *     math.hypot(a, b, ...)
	   *     math.hypot([a, b, c, ...])
	   *
	   * Examples:
	   *
	   *     math.hypot(3, 4);      // 5
	   *     math.hypot(3, 4, 5);   // 7.0710678118654755
	   *     math.hypot([3, 4, 5]); // 7.0710678118654755
	   *     math.hypot(-2);        // 2
	   *
	   * See also:
	   *
	   *     abs, norm
	   *
	   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
	   *                                                          Matrix and Array input is flattened and returns a
	   *                                                          single number for the whole matrix.
	   * @return {number | BigNumber} Returns the hypothenusa of the input values.
	   */
	  var hypot = typed('hypot', {
	    '... number | BigNumber': _hypot,
	
	    'Array': function (x) {
	      return hypot.apply(hypot, flatten(x));
	    },
	
	    'Matrix': function (x) {
	      return hypot.apply(hypot, flatten(x.toArray()));
	    }
	  });
	
	  /**
	   * Calculate the hypotenusa for an Array with values
	   * @param {Array.<number | BigNumber>} args
	   * @return {number | BigNumber} Returns the result
	   * @private
	   */
	  function _hypot (args) {
	    // code based on `hypot` from es6-shim:
	    // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
	    var result = 0;
	    var largest = 0;
	
	    for (var i = 0; i < args.length; i++) {
	      var value = abs(args[i]);
	      if (smaller(largest, value)) {
	        result = multiply(result, multiply(divide(largest, value), divide(largest, value)));
	        result = add(result, 1);
	        largest = value;
	      } else {
	        result = add(result, isPositive(value) ? multiply(divide(value, largest), divide(value, largest)) : value);
	      }
	    }
	
	    return multiply(largest, sqrt(result));
	  }
	
	  hypot.toTex = '\\hypot\\left(${args}\\right)';
	
	  return hypot;
	}
	
	exports.name = 'hypot';
	exports.factory = factory;


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm06 = load(__webpack_require__(1737));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Calculate the least common multiple for two or more values or arrays.
	   *
	   * lcm is defined as:
	   *
	   *     lcm(a, b) = abs(a * b) / gcd(a, b)
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.lcm(a, b)
	   *    math.lcm(a, b, c, ...)
	   *
	   * Examples:
	   *
	   *    math.lcm(4, 6);               // returns 12
	   *    math.lcm(6, 21);              // returns 42
	   *    math.lcm(6, 21, 5);           // returns 210
	   *
	   *    math.lcm([4, 6], [6, 21]);    // returns [12, 42]
	   *
	   * See also:
	   *
	   *    gcd, xgcd
	   *
	   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
	   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
	   */
	  var lcm = typed('lcm', {
	    'number, number': _lcm,
	
	    'BigNumber, BigNumber': _lcmBigNumber,
	
	    'Fraction, Fraction': function (x, y) {
	
	      return x.lcm(y);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm06(x, y, lcm);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, lcm, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm02(x, y, lcm, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, lcm);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return lcm(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return lcm(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return lcm(x, matrix(y));
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      return algorithm11(x, y, lcm, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      return algorithm14(x, y, lcm, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      return algorithm11(y, x, lcm, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, lcm, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, lcm, false).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, lcm, true).valueOf();
	    },
	
	    // TODO: need a smarter notation here
	    'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function (a, b, args) {
	      var res = lcm(a, b);
	      for (var i = 0; i < args.length; i++) {
	        res = lcm(res, args[i]);
	      }
	      return res;
	    }
	  });
	
	  lcm.toTex = undefined;  // use default template
	
	  return lcm;
	
	  /**
	   * Calculate lcm for two BigNumbers
	   * @param {BigNumber} a
	   * @param {BigNumber} b
	   * @returns {BigNumber} Returns the least common multiple of a and b
	   * @private
	   */
	  function _lcmBigNumber(a, b) {
	    if (!a.isInt() || !b.isInt()) {
	      throw new Error('Parameters in function lcm must be integer numbers');
	    }
	
	    if (a.isZero() || b.isZero()) {
	      return new type.BigNumber(0);
	    }
	
	    // http://en.wikipedia.org/wiki/Euclidean_algorithm
	    // evaluate lcm here inline to reduce overhead
	    var prod = a.times(b);
	    while (!b.isZero()) {
	      var t = b;
	      b = a.mod(t);
	      a = t;
	    }
	    return prod.div(a).abs();
	  }
	}
	
	/**
	 * Calculate lcm for two numbers
	 * @param {number} a
	 * @param {number} b
	 * @returns {number} Returns the least common multiple of a and b
	 * @private
	 */
	function _lcm (a, b) {
	  if (!isInteger(a) || !isInteger(b)) {
	    throw new Error('Parameters in function lcm must be integer numbers');
	  }
	
	  if (a == 0 || b == 0) {
	    return 0;
	  }
	
	  // http://en.wikipedia.org/wiki/Euclidean_algorithm
	  // evaluate lcm here inline to reduce overhead
	  var t;
	  var prod = a * b;
	  while (b != 0) {
	    t = b;
	    b = a % t;
	    a = t;
	  }
	  return Math.abs(prod / a);
	}
	
	exports.name = 'lcm';
	exports.factory = factory;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var scatter = __webpack_require__(1738);
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
	   * C(i,j) = ┤  
	   *          └  0            ; otherwise
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm06 = function (a, b, callback) {
	    // sparse matrix arrays
	    var avalues = a._values;
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bvalues = b._values;
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = avalues && bvalues ? [] : undefined;
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspaces
	    var x = cvalues ? [] : undefined;
	    // marks indicating we have a value in x for a given column
	    var w = [];
	    // marks indicating value in a given row has been updated
	    var u = [];
	
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // columns mark
	      var mark = j + 1;
	      // scatter the values of A(:,j) into workspace
	      scatter(a, j, w, x, u, mark, c, cf);
	      // scatter the values of B(:,j) into workspace
	      scatter(b, j, w, x, u, mark, c, cf);
	      // check we need to process values (non pattern matrix)
	      if (x) {
	        // initialize first index in j
	        var k = cptr[j];
	        // loop index in j
	        while (k < cindex.length) {
	          // row
	          var i = cindex[k];
	          // check function was invoked on current row (Aij !=0 && Bij != 0)
	          if (u[i] === mark) {
	            // value @ i
	            var v = x[i];
	            // check for zero value
	            if (!eq(v, zero)) {
	              // push value
	              cvalues.push(v);
	              // increment pointer
	              k++;
	            }
	            else {
	              // remove value @ i, do not increment pointer
	              cindex.splice(k, 1);
	            }
	          }
	          else {
	            // remove value @ i, do not increment pointer
	            cindex.splice(k, 1);
	          }
	        }
	      }
	      else {
	        // initialize first index in j
	        var p = cptr[j];
	        // loop index in j
	        while (p < cindex.length) {
	          // row
	          var r = cindex[p];
	          // check function was invoked on current row (Aij !=0 && Bij != 0)
	          if (u[r] !== mark) {
	            // remove value @ i, do not increment pointer
	            cindex.splice(p, 1);
	          }
	          else {
	            // increment pointer
	            p++;
	          }
	        }
	      }
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	  
	  return algorithm06;
	}
	
	exports.name = 'algorithm06';
	exports.factory = factory;


/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function scatter(a, j, w, x, u, mark, c, f, inverse, update, value) {
	  // a arrays
	  var avalues = a._values;
	  var aindex = a._index;
	  var aptr = a._ptr;
	  // c arrays
	  var cindex = c._index;
	
	  // vars
	  var k, k0, k1, i;
	
	  // check we need to process values (pattern matrix)
	  if (x) {
	    // values in j
	    for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	      // row
	      i = aindex[k];
	      // check value exists in current j
	      if (w[i] !== mark) {
	        // i is new entry in j
	        w[i] = mark;
	        // add i to pattern of C
	        cindex.push(i);
	        // x(i) = A, check we need to call function this time
	        if (update) {
	          // copy value to workspace calling callback function
	          x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]);
	          // function was called on current row
	          u[i] = mark;
	        }
	        else {
	          // copy value to workspace
	          x[i] = avalues[k];
	        }
	      }
	      else {
	        // i exists in C already
	        x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]);
	        // function was called on current row
	        u[i] = mark;
	      }
	    }
	  }
	  else {
	    // values in j
	    for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	      // row
	      i = aindex[k];
	      // check value exists in current j
	      if (w[i] !== mark) {
	        // i is new entry in j
	        w[i] = mark;
	        // add i to pattern of C
	        cindex.push(i);
	      }
	      else {
	        // indicate function was called on current row
	        u[i] = mark;
	      }
	    }
	  }
	};


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var divideScalar = load(__webpack_require__(1397));
	
	  /**
	   * Calculate the logarithm of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.log(x)
	   *    math.log(x, base)
	   *
	   * Examples:
	   *
	   *    math.log(3.5);                  // returns 1.252762968495368
	   *    math.exp(math.log(2.4));        // returns 2.4
	   *
	   *    math.pow(10, 4);                // returns 10000
	   *    math.log(10000, 10);            // returns 4
	   *    math.log(10000) / math.log(10); // returns 4
	   *
	   *    math.log(1024, 2);              // returns 10
	   *    math.pow(2, 10);                // returns 1024
	   *
	   * See also:
	   *
	   *    exp, log2, log10, log1p
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            Value for which to calculate the logarithm.
	   * @param {number | BigNumber | Complex} [base=e]
	   *            Optional base for the logarithm. If not provided, the natural
	   *            logarithm of `x` is calculated.
	   * @return {number | BigNumber | Complex | Array | Matrix}
	   *            Returns the logarithm of `x`
	   */
	  var log = typed('log', {
	    'number': function (x) {
	      if (x >= 0 || config.predictable) {
	        return Math.log(x);
	      }
	      else {
	        // negative value -> complex value computation
	        return new type.Complex(x, 0).log();
	      }
	    },
	
	    'Complex': function (x) {
	      return x.log();
	    },
	
	    'BigNumber': function (x) {
	      if (!x.isNegative() || config.predictable) {
	        return x.ln();
	      }
	      else {
	        // downgrade to number, return Complex valued result
	        return new type.Complex(x.toNumber(), 0).log();
	      }
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, log);
	    },
	
	    'any, any': function (x, base) {
	      // calculate logarithm for a specified base, log(x, base)
	      return divideScalar(log(x), log(base));
	    }
	  });
	
	  log.toTex = {
	    1: '\\ln\\left(${args[0]}\\right)',
	    2: '\\log_{${args[1]}}\\left(${args[0]}\\right)'
	  };
	
	  return log;
	}
	
	exports.name = 'log';
	exports.factory = factory;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.log10(x)
	   *
	   * Examples:
	   *
	   *    math.log10(0.00001);            // returns -5
	   *    math.log10(10000);              // returns 4
	   *    math.log(10000) / math.log(10); // returns 4
	   *    math.pow(10, 4);                // returns 10000
	   *
	   * See also:
	   *
	   *    exp, log, log1p, log2
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            Value for which to calculate the logarithm.
	   * @return {number | BigNumber | Complex | Array | Matrix}
	   *            Returns the 10-base logarithm of `x`
	   */
	  var log10 = typed('log10', {
	    'number': function (x) {
	      if (x >= 0 || config.predictable) {
	        return _log10(x);
	      }
	      else {
	        // negative value -> complex value computation
	        return new type.Complex(x, 0).log().div(Math.LN10);
	      }
	    },
	
	    'Complex': function (x) {
	      return new type.Complex(x).log().div(Math.LN10);
	    },
	
	    'BigNumber': function (x) {
	      if (!x.isNegative() || config.predictable) {
	        return x.log();
	      }
	      else {
	        // downgrade to number, return Complex valued result
	        return new type.Complex(x.toNumber(), 0).log().div(Math.LN10);
	      }
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, log10);
	    }
	  });
	
	  log10.toTex = {1: '\\log_{10}\\left(${args[0]}\\right)'};
	
	  return log10;
	}
	
	/**
	 * Calculate the 10-base logarithm of a number
	 * @param {number} x
	 * @return {number}
	 * @private
	 */
	var _log10 = Math.log10 || function (x) {
	  return Math.log(x) / Math.LN10;
	};
	
	exports.name = 'log10';
	exports.factory = factory;
	


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var divideScalar = load(__webpack_require__(1397));
	  var log = load(__webpack_require__(1739));
	
	  /**
	   * Calculate the logarithm of a `value+1`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.log1p(x)
	   *    math.log1p(x, base)
	   *
	   * Examples:
	   *
	   *    math.log1p(2.5);                 // returns 1.252762968495368
	   *    math.exp(math.log1p(1.4));       // returns 2.4
	   *
	   *    math.pow(10, 4);                 // returns 10000
	   *    math.log1p(9999, 10);            // returns 4
	   *    math.log1p(9999) / math.log(10); // returns 4
	   *
	   * See also:
	   *
	   *    exp, log, log2, log10
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            Value for which to calculate the logarithm of `x+1`.
	   * @param {number | BigNumber | Complex} [base=e]
	   *            Optional base for the logarithm. If not provided, the natural
	   *            logarithm of `x+1` is calculated.
	   * @return {number | BigNumber | Complex | Array | Matrix}
	   *            Returns the logarithm of `x+1`
	   */
	  var log1p = typed('log1p', {
	    'number': _log1pNumber,
	
	    'Complex': _log1pComplex,
	
	    'BigNumber': function (x) {
	      var y = x.plus(1);
	      if (!y.isNegative() || config.predictable) {
	        return y.ln();
	      }
	      else {
	        // downgrade to number, return Complex valued result
	        return _log1pComplex(new type.Complex(x.toNumber(), 0));
	      }
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, log1p);
	    },
	
	    'any, any': function (x, base) {
	      // calculate logarithm for a specified base, log1p(x, base)
	      return divideScalar(log1p(x), log(base));
	    }
	  });
	
	  /**
	   * Calculate the natural logarithm of a `number+1`
	   * @param {number} x
	   * @returns {number | Complex}
	   * @private
	   */
	  function _log1pNumber(x) {
	    if (x >= -1 || config.predictable) {
	      return (Math.log1p) ? Math.log1p(x) : Math.log(x+1);
	    }
	    else {
	      // negative value -> complex value computation
	      return _log1pComplex(new type.Complex(x, 0));
	    }
	  }
	
	  /**
	   * Calculate the natural logarithm of a complex number + 1
	   * @param {Complex} x
	   * @returns {Complex}
	   * @private
	   */
	  function _log1pComplex(x) {
	    var x_re1p = x.re + 1;
	    return new type.Complex (
	        Math.log(Math.sqrt(x_re1p * x_re1p + x.im * x.im)),
	        Math.atan2(x.im, x_re1p)
	    );
	  }
	
	  log1p.toTex = {
	    1: '\\ln\\left(${args[0]}+1\\right)',
	    2: '\\log_{${args[1]}}\\left(${args[0]}+1\\right)'
	  };
	
	  return log1p;
	}
	
	exports.name = 'log1p';
	exports.factory = factory;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.log2(x)
	   *
	   * Examples:
	   *
	   *    math.log2(0.03125);           // returns -5
	   *    math.log2(16);                // returns 4
	   *    math.log2(16) / math.log2(2); // returns 4
	   *    math.pow(2, 4);               // returns 16
	   *
	   * See also:
	   *
	   *    exp, log, log1p, log10
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            Value for which to calculate the logarithm.
	   * @return {number | BigNumber | Complex | Array | Matrix}
	   *            Returns the 2-base logarithm of `x`
	   */
	  var log2 = typed('log2', {
	    'number': function (x) {
	      if (x >= 0 || config.predictable) {
	        return (Math.log2)
	          ? Math.log2(x)
	          : Math.log(x) / Math.LN2;
	      }
	      else {
	        // negative value -> complex value computation
	        return _log2Complex(new type.Complex(x, 0));
	      }
	    },
	
	    'Complex': _log2Complex,
	
	    'BigNumber': function (x) {
	      if (!x.isNegative() || config.predictable) {
	        return x.log(2);
	      }
	      else {
	        // downgrade to number, return Complex valued result
	        return _log2Complex(new type.Complex(x.toNumber(), 0));
	      }
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, log2);
	    }
	  });
	
	  /**
	   * Calculate log2 for a complex value
	   * @param {Complex} x
	   * @returns {Complex}
	   * @private
	   */
	  function _log2Complex(x) {
	    var newX = Math.sqrt(x.re * x.re + x.im * x.im);
	    return new type.Complex (
	        (Math.log2) ? Math.log2(newX) : Math.log(newX) / Math.LN2,
	        Math.atan2(x.im, x.re) / Math.LN2
	    );
	  }
	
	  log2.toTex = '\\log_{2}\\left(${args[0]}\\right)';
	
	  return log2;
	
	}
	
	exports.name = 'log2';
	exports.factory = factory;
	


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var latex = __webpack_require__(1348);
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm05 = load(__webpack_require__(1395));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Calculates the modulus, the remainder of an integer division.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * The modulus is defined as:
	   *
	   *     x - y * floor(x / y)
	   *
	   * See http://en.wikipedia.org/wiki/Modulo_operation.
	   *
	   * Syntax:
	   *
	   *    math.mod(x, y)
	   *
	   * Examples:
	   *
	   *    math.mod(8, 3);                // returns 2
	   *    math.mod(11, 2);               // returns 1
	   *
	   *    function isOdd(x) {
	   *      return math.mod(x, 2) != 0;
	   *    }
	   *
	   *    isOdd(2);                      // returns false
	   *    isOdd(3);                      // returns true
	   *
	   * See also:
	   *
	   *    divide
	   *
	   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
	   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
	   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
	   */
	  var mod = typed('mod', {
	
	    'number, number': _mod,
	
	    'BigNumber, BigNumber': function (x, y) {
	      return y.isZero() ? x : x.mod(y);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.mod(y);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm05(x, y, mod, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, mod, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, mod, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, mod);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return mod(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return mod(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return mod(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, mod, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, mod, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, mod, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, mod, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, mod, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, mod, true).valueOf();
	    }
	  });
	
	  mod.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['mod'] + '${args[1]}\\right)'
	  };
	
	  return mod;
	
	  /**
	   * Calculate the modulus of two numbers
	   * @param {number} x
	   * @param {number} y
	   * @returns {number} res
	   * @private
	   */
	  function _mod(x, y) {
	    if (y > 0) {
	      // We don't use JavaScript's % operator here as this doesn't work
	      // correctly for x < 0 and x == 0
	      // see http://en.wikipedia.org/wiki/Modulo_operation
	      return x - y * Math.floor(x / y);
	    }
	    else if (y === 0) {
	      return x;
	    }
	    else { // y < 0
	      // TODO: implement mod for a negative divisor
	      throw new Error('Cannot calculate mod for a negative divisor');
	    }
	  }
	}
	
	exports.name = 'mod';
	exports.factory = factory;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  
	  var abs         = load(__webpack_require__(1402));
	  var add         = load(__webpack_require__(1367));
	  var pow         = load(__webpack_require__(1398));
	  var conj        = load(__webpack_require__(1695));
	  var sqrt        = load(__webpack_require__(1694));
	  var multiply    = load(__webpack_require__(1400));
	  var equalScalar = load(__webpack_require__(1364));
	  var larger      = load(__webpack_require__(1380));
	  var smaller     = load(__webpack_require__(1376));
	  var matrix      = load(__webpack_require__(1368));
	  var trace       = load(__webpack_require__(1745));
	  var transpose   = load(__webpack_require__(1702));
	
	
	  /**
	   * Calculate the norm of a number, vector or matrix.
	   *
	   * The second parameter p is optional. If not provided, it defaults to 2.
	   *
	   * Syntax:
	   *
	   *    math.norm(x)
	   *    math.norm(x, p)
	   *
	   * Examples:
	   *
	   *    math.abs(-3.5);                         // returns 3.5
	   *    math.norm(-3.5);                        // returns 3.5
	   *
	   *    math.norm(math.complex(3, -4));         // returns 5
	   *
	   *    math.norm([1, 2, -3], Infinity);        // returns 3
	   *    math.norm([1, 2, -3], -Infinity);       // returns 1
	   *
	   *    math.norm([3, 4], 2);                   // returns 5
	   *
	   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
	   *    math.norm([[1, 2], [3, 4]], 'inf');     // returns 7
	   *    math.norm([[1, 2], [3, 4]], 'fro');     // returns 5.477225575051661
	   *
	   * See also:
	   *
	   *    abs, hypot
	   *
	   * @param  {number | BigNumber | Complex | Array | Matrix} x
	   *            Value for which to calculate the norm
	   * @param  {number | BigNumber | string} [p=2]
	   *            Vector space.
	   *            Supported numbers include Infinity and -Infinity.
	   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
	   * @return {number | BigNumber} the p-norm
	   */
	  var norm = typed('norm', {
	    'number': Math.abs,
	
	    'Complex': function (x) {
	      return x.abs();
	    },
	
	    'BigNumber': function (x) {
	      // norm(x) = abs(x)
	      return x.abs();
	    },
	    
	    'boolean' : function (x) {
	      // norm(x) = abs(x)
	      return Math.abs(x);
	    },
	
	    'Array': function (x) {
	      return _norm(matrix(x), 2);
	    },
	    
	    'Matrix': function (x) {
	      return _norm(x, 2);
	    },
	
	    'number | Complex | BigNumber | boolean, number | BigNumber | string': function (x) {
	      // ignore second parameter, TODO: remove the option of second parameter for these types
	      return norm(x);
	    },
	
	    'Array, number | BigNumber | string': function (x, p) {
	      return _norm(matrix(x), p);
	    },
	    
	    'Matrix, number | BigNumber | string': function (x, p) {
	      return _norm(x, p);
	    }
	  });
	
	  /**
	   * Calculate the norm for an array
	   * @param {Array} x
	   * @param {number | string} p
	   * @returns {number} Returns the norm
	   * @private
	   */
	  function _norm (x, p) {
	    // size
	    var sizeX = x.size();
	    
	    // check if it is a vector
	    if (sizeX.length == 1) {
	      // check p
	      if (p === Number.POSITIVE_INFINITY || p === 'inf') {
	        // norm(x, Infinity) = max(abs(x))
	        var pinf = 0;
	        // skip zeros since abs(0) == 0
	        x.forEach(
	          function (value) {
	            var v = abs(value);
	            if (larger(v, pinf))
	              pinf = v;
	          },
	          true);
	        return pinf;
	      }
	      if (p === Number.NEGATIVE_INFINITY || p === '-inf') {
	        // norm(x, -Infinity) = min(abs(x))
	        var ninf;
	        // skip zeros since abs(0) == 0
	        x.forEach(
	          function (value) {
	            var v = abs(value);
	            if (!ninf || smaller(v, ninf))
	              ninf = v;
	          },
	          true);
	        return ninf || 0;
	      }
	      if (p === 'fro') {
	        return _norm(x, 2);
	      }
	      if (typeof p === 'number' && !isNaN(p)) {
	        // check p != 0
	        if (!equalScalar(p, 0)) {
	          // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
	          var n = 0;
	          // skip zeros since abs(0) == 0
	          x.forEach(
	            function (value) {
	              n = add(pow(abs(value), p), n);
	            },
	            true);
	          return pow(n, 1 / p);
	        }
	        return Number.POSITIVE_INFINITY;
	      }
	      // invalid parameter value
	      throw new Error('Unsupported parameter value');
	    }
	    // MxN matrix
	    if (sizeX.length == 2) {
	      // check p
	      if (p === 1) {
	        // norm(x) = the largest column sum
	        var c = [];
	        // result
	        var maxc = 0;
	        // skip zeros since abs(0) == 0
	        x.forEach(
	          function (value, index) {
	            var j = index[1];
	            var cj = add(c[j] || 0, abs(value));
	            if (larger(cj, maxc))
	              maxc = cj;
	            c[j] = cj;
	          },
	          true);
	        return maxc;
	      }
	      if (p === Number.POSITIVE_INFINITY || p === 'inf') {
	        // norm(x) = the largest row sum
	        var r = [];
	        // result
	        var maxr = 0;
	        // skip zeros since abs(0) == 0
	        x.forEach(
	          function (value, index) {
	            var i = index[0];
	            var ri = add(r[i] || 0, abs(value));
	            if (larger(ri, maxr))
	              maxr = ri;
	            r[i] = ri;
	          },
	          true);
	        return maxr;
	      }
	      if (p === 'fro') {
	        // norm(x) = sqrt(sum(diag(x'x)))
	        var fro = 0;
	        x.forEach(
	          function (value, index) {
	            fro = add( fro, multiply( value, conj(value) ) );
	          });
	        return sqrt(fro);
	      }
	      if (p === 2) {
	        // not implemented
	        throw new Error('Unsupported parameter value, missing implementation of matrix singular value decomposition');
	      }
	      // invalid parameter value
	      throw new Error('Unsupported parameter value');
	    }
	  }
	
	  norm.toTex = {
	    1: '\\left\\|${args[0]}\\right\\|',
	    2: undefined  // use default template
	  };
	
	  return norm;
	}
	
	exports.name = 'norm';
	exports.factory = factory;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var format = __webpack_require__(1341).format;
	
	function factory (type, config, load, typed) {
	  
	  var matrix = load(__webpack_require__(1368));
	  var add = load(__webpack_require__(1367));
	
	  /**
	   * Calculate the trace of a matrix: the sum of the elements on the main
	   * diagonal of a square matrix.
	   *
	   * Syntax:
	   *
	   *    math.trace(x)
	   *
	   * Examples:
	   *
	   *    math.trace([[1, 2], [3, 4]]); // returns 5
	   *
	   *    var A = [
	   *      [1, 2, 3],
	   *      [-1, 2, 3],
	   *      [2, 0, 3]
	   *    ]
	   *    math.trace(A); // returns 6
	   *
	   * See also:
	   *
	   *    diag
	   *
	   * @param {Array | Matrix} x  A matrix
	   *
	   * @return {number} The trace of `x`
	   */
	  var trace = typed('trace', {
	    
	    'Array': function _arrayTrace(x) {
	      // use dense matrix implementation
	      return _denseTrace(matrix(x));
	    },
	
	    'SparseMatrix': _sparseTrace,
	
	    'DenseMatrix': _denseTrace,
	
	    'any': clone
	  });
	  
	  function _denseTrace(m) {
	    // matrix size & data
	    var size = m._size;
	    var data = m._data;
	    
	    // process dimensions
	    switch (size.length) {
	      case 1:
	        // vector
	        if (size[0] === 1) {
	          // return data[0]
	          return clone(data[0]);
	        }
	        throw new RangeError('Matrix must be square (size: ' + format(size) + ')');
	      case 2:
	        // two dimensional
	        var rows = size[0];
	        var cols = size[1];
	        if (rows === cols) {
	          // calulate sum
	          var sum = 0;
	          // loop diagonal
	          for (var i = 0; i < rows; i++)
	            sum = add(sum, data[i][i]);
	          // return trace
	          return sum;
	        }
	        throw new RangeError('Matrix must be square (size: ' + format(size) + ')');        
	      default:
	        // multi dimensional
	        throw new RangeError('Matrix must be two dimensional (size: ' + format(size) + ')');
	    }
	  }
	  
	  function _sparseTrace(m) {
	    // matrix arrays
	    var values = m._values;
	    var index = m._index;
	    var ptr = m._ptr;
	    var size = m._size;
	    // check dimensions
	    var rows = size[0];
	    var columns = size[1];
	    // matrix must be square
	    if (rows === columns) {
	      // calulate sum
	      var sum = 0;
	      // check we have data (avoid looping columns)
	      if (values.length > 0) {
	        // loop columns
	        for (var j = 0; j < columns; j++) {
	          // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
	          var k0 = ptr[j];
	          var k1 = ptr[j + 1];
	          // loop k within [k0, k1[
	          for (var k = k0; k < k1; k++) {
	            // row index
	            var i = index[k];
	            // check row
	            if (i === j) {
	              // accumulate value
	              sum = add(sum, values[k]);
	              // exit loop
	              break;
	            }
	            if (i > j) {
	              // exit loop, no value on the diagonal for column j
	              break;
	            }
	          }
	        }
	      }
	      // return trace
	      return sum;
	    }
	    throw new RangeError('Matrix must be square (size: ' + format(size) + ')');   
	  }
	
	  trace.toTex = {1: '\\mathrm{tr}\\left(${args[0]}\\right)'};
	  
	  return trace;
	}
	
	exports.name = 'trace';
	exports.factory = factory;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm06 = load(__webpack_require__(1737));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Calculate the nth root of a value.
	   * The principal nth root of a positive real number A, is the positive real
	   * solution of the equation
	   *
	   *     x^root = A
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *     math.nthRoot(a)
	   *     math.nthRoot(a, root)
	   *
	   * Examples:
	   *
	   *     math.nthRoot(9, 2);    // returns 3, as 3^2 == 9
	   *     math.sqrt(9);          // returns 3, as 3^2 == 9
	   *     math.nthRoot(64, 3);   // returns 4, as 4^3 == 64
	   *
	   * See also:
	   *
	   *     sqrt, pow
	   *
	   * @param {number | BigNumber | Array | Matrix | Complex} a
	   *              Value for which to calculate the nth root
	   * @param {number | BigNumber} [root=2]    The root.
	   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
	   */
	  var nthRoot = typed('nthRoot', {
	    
	    'number': function (x) {
	      return _nthRoot(x, 2);
	    },
	    'number, number': _nthRoot,
	
	    'BigNumber': function (x) {
	      return _bigNthRoot(x, new type.BigNumber(2));
	    },
	    'Complex' : function(x) {
	      return _nthComplexRoot(x, 2);
	    }, 
	    'Complex, number' : _nthComplexRoot,
	    'BigNumber, BigNumber': _bigNthRoot,
	
	    'Array | Matrix': function (x) {
	      return nthRoot(x, 2);
	    },
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      // density must be one (no zeros in matrix)
	      if (y.density() === 1) {
	        // sparse + sparse
	        return algorithm06(x, y, nthRoot);
	      }
	      else {
	        // throw exception
	        throw new Error('Root must be non-zero');
	      }
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      return algorithm02(y, x, nthRoot, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      // density must be one (no zeros in matrix)
	      if (y.density() === 1) {
	        // dense + sparse
	        return algorithm01(x, y, nthRoot, false);
	      }
	      else {
	        // throw exception
	        throw new Error('Root must be non-zero');
	      }
	    },
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      return algorithm13(x, y, nthRoot);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return nthRoot(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return nthRoot(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return nthRoot(x, matrix(y));
	    },
	    
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      return algorithm11(x, y, nthRoot, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      return algorithm14(x, y, nthRoot, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      // density must be one (no zeros in matrix)
	      if (y.density() === 1) {
	        // sparse - scalar
	        return algorithm11(y, x, nthRoot, true);
	      }
	      else {
	        // throw exception
	        throw new Error('Root must be non-zero');
	      }
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, nthRoot, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return nthRoot(matrix(x), y).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return nthRoot(x, matrix(y)).valueOf();
	    }
	  });
	
	  nthRoot.toTex = {2: '\\sqrt[${args[1]}]{${args[0]}}'};
	
	  return nthRoot;
	
	  /**
	   * Calculate the nth root of a for BigNumbers, solve x^root == a
	   * http://rosettacode.org/wiki/Nth_root#JavaScript
	   * @param {BigNumber} a
	   * @param {BigNumber} root
	   * @private
	   */
	  function _bigNthRoot(a, root) {
	    var precision = type.BigNumber.precision;
	    var Big = type.BigNumber.clone({precision: precision + 2});
	    var zero = new type.BigNumber(0);
	
	    var one = new Big(1);
	    var inv = root.isNegative();
	    if (inv) {
	      root = root.neg();
	    }
	
	    if (root.isZero()) {
	      throw new Error('Root must be non-zero');
	    }
	    if (a.isNegative() && !root.abs().mod(2).equals(1)) {
	      throw new Error('Root must be odd when a is negative.');
	    }
	
	    // edge cases zero and infinity
	    if (a.isZero()) {
	      return inv ? new Big(Infinity) : 0;
	    }
	    if (!a.isFinite()) {
	      return inv ? zero : a;
	    }
	
	    var x = a.abs().pow(one.div(root));
	    // If a < 0, we require that root is an odd integer,
	    // so (-1) ^ (1/root) = -1
	    x = a.isNeg() ? x.neg() : x;
	    return new type.BigNumber((inv ? one.div(x) : x).toPrecision(precision));
	  }
	}
	
	/**
	 * Calculate the nth root of a, solve x^root == a
	 * http://rosettacode.org/wiki/Nth_root#JavaScript
	 * @param {number} a
	 * @param {number} root
	 * @private
	 */
	function _nthRoot(a, root) {
	  var inv = root < 0;
	  if (inv) {
	    root = -root;
	  }
	
	  if (root === 0) {
	    throw new Error('Root must be non-zero');
	  }
	  if (a < 0 && (Math.abs(root) % 2 != 1)) {
	    throw new Error('Root must be odd when a is negative.');
	  }
	
	  // edge cases zero and infinity
	  if (a == 0) {
	    return inv ? Infinity : 0;
	  }
	  if (!isFinite(a)) {
	    return inv ? 0 : a;
	  }
	
	  var x = Math.pow(Math.abs(a), 1/root);
	  // If a < 0, we require that root is an odd integer,
	  // so (-1) ^ (1/root) = -1
	  x = a < 0 ? -x : x;
	  return inv ? 1 / x : x;
	
	  // Very nice algorithm, but fails with nthRoot(-2, 3).
	  // Newton's method has some well-known problems at times:
	  // https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
	  /*
	  var x = 1; // Initial guess
	  var xPrev = 1;
	  var i = 0;
	  var iMax = 10000;
	  do {
	    var delta = (a / Math.pow(x, root - 1) - x) / root;
	    xPrev = x;
	    x = x + delta;
	    i++;
	  }
	  while (xPrev !== x && i < iMax);
	
	  if (xPrev !== x) {
	    throw new Error('Function nthRoot failed to converge');
	  }
	
	  return inv ? 1 / x : x;
	  */
	}
	
	/**
	 * Calculate the nth root of a Complex Number a using De Moviers Theorem.
	 * @param  {Complex} a
	 * @param  {number} root
	 * @return {Array} array or n Complex Roots in Polar Form.
	 */
	function _nthComplexRoot(a, root) {
	  if (root < 0) throw new Error('Root must be greater than zero');
	  if (root === 0) throw new Error('Root must be non-zero');
	  if (root % 1 !== 0) throw new Error('Root must be an integer');  
	  var arg = a.arg();
	  var abs = a.abs();
	  var roots = [];
	  var r = Math.pow(abs, 1/root);
	  for(var k = 0; k < root; k++) {
	    roots.push({r: r, phi: (arg + 2 * Math.PI * k)/root});
	  }
	  return roots;
	}
	
	exports.name = 'nthRoot';
	exports.factory = factory;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the square of a value, `x * x`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.square(x)
	   *
	   * Examples:
	   *
	   *    math.square(2);           // returns number 4
	   *    math.square(3);           // returns number 9
	   *    math.pow(3, 2);           // returns number 9
	   *    math.multiply(3, 3);      // returns number 9
	   *
	   *    math.square([1, 2, 3, 4]);  // returns Array [1, 4, 9, 16]
	   *
	   * See also:
	   *
	   *    multiply, cube, sqrt, pow
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
	   *            Number for which to calculate the square
	   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
	   *            Squared value
	   */
	  var square = typed('square', {
	    'number': function (x) {
	      return x * x;
	    },
	
	    'Complex': function (x) {
	      return x.mul(x);
	    },
	
	    'BigNumber': function (x) {
	      return x.times(x);
	    },
	
	    'Fraction': function (x) {
	      return x.mul(x);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since square(0) = 0
	      return deepMap(x, square, true);
	    },
	
	    'Unit': function(x) {
	      return x.pow(2);
	    }
	  });
	
	  square.toTex = {1: '\\left(${args[0]}\\right)^2'};
	
	  return square;
	}
	
	exports.name = 'square';
	exports.factory = factory;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Unary plus operation.
	   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.unaryPlus(x)
	   *
	   * Examples:
	   *
	   *    math.unaryPlus(3.5);      // returns 3.5
	   *    math.unaryPlus(1);     // returns 1
	   *
	   * See also:
	   *
	   *    unaryMinus, add, subtract
	   *
	   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
	   *            Input value
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
	   *            Returns the input value when numeric, converts to a number when input is non-numeric.
	   */
	  var unaryPlus = typed('unaryPlus', {
	    'number': function (x) {
	      return x;
	    },
	
	    'Complex': function (x) {
	      return x; // complex numbers are immutable
	    },
	
	    'BigNumber': function (x) {
	      return x; // bignumbers are immutable
	    },
	
	    'Fraction': function (x) {
	      return x; // fractions are immutable
	    },
	
	    'Unit': function (x) {
	      return x.clone();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since unaryPlus(0) = 0
	      return deepMap(x, unaryPlus, true);
	    },
	
	    'boolean | string': function (x) {
	      // convert to a number or bignumber
	      return (config.number == 'BigNumber') ? new type.BigNumber(+x): +x;
	    }
	  });
	
	  unaryPlus.toTex = {
	    1: latex.operators['unaryPlus'] + '\\left(${args[0]}\\right)'
	  };
	
	  return unaryPlus;
	}
	
	exports.name = 'unaryPlus';
	exports.factory = factory;


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Calculate the extended greatest common divisor for two values.
	   * See http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
	   *
	   * Syntax:
	   *
	   *    math.xgcd(a, b)
	   *
	   * Examples:
	   *
	   *    math.xgcd(8, 12);             // returns [4, -1, 1]
	   *    math.gcd(8, 12);              // returns 4
	   *    math.xgcd(36163, 21199);      // returns [1247, -7, 12]
	   *
	   * See also:
	   *
	   *    gcd, lcm
	   *
	   * @param {number | BigNumber} a  An integer number
	   * @param {number | BigNumber} b  An integer number
	   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
	   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
	   */
	  var xgcd = typed('xgcd', {
	    'number, number': _xgcd,
	    'BigNumber, BigNumber': _xgcdBigNumber
	    // TODO: implement support for Fraction
	  });
	
	  xgcd.toTex = undefined; // use default template
	
	  return xgcd;
	
	  /**
	   * Calculate xgcd for two numbers
	   * @param {number} a
	   * @param {number} b
	   * @return {number} result
	   * @private
	   */
	  function _xgcd (a, b) {
	    // source: http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
	    var t, // used to swap two variables
	        q, // quotient
	        r, // remainder
	        x = 0, lastx = 1,
	        y = 1, lasty = 0;
	
	    if (!isInteger(a) || !isInteger(b)) {
	      throw new Error('Parameters in function xgcd must be integer numbers');
	    }
	
	    while (b) {
	      q = Math.floor(a / b);
	      r = a - q*b;
	
	      t = x;
	      x = lastx - q * x;
	      lastx = t;
	
	      t = y;
	      y = lasty - q * y;
	      lasty = t;
	
	      a = b;
	      b = r;
	    }
	
	    var res;
	    if (a < 0) {
	      res = [-a, -lastx, -lasty];
	    }
	    else {
	      res = [a, a ? lastx : 0, lasty];
	    }
	    return (config.matrix === 'Array') ? res : matrix(res);
	  }
	
	  /**
	   * Calculate xgcd for two BigNumbers
	   * @param {BigNumber} a
	   * @param {BigNumber} b
	   * @return {BigNumber[]} result
	   * @private
	   */
	  function _xgcdBigNumber(a, b) {
	    // source: http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
	    var t, // used to swap two variables
	        q, // quotient
	        r, // remainder
	        zero = new type.BigNumber(0),
	        one = new type.BigNumber(1),
	        x = zero,
	        lastx = one,
	        y = one,
	        lasty = zero;
	
	    if (!a.isInt() || !b.isInt()) {
	      throw new Error('Parameters in function xgcd must be integer numbers');
	    }
	
	    while (!b.isZero()) {
	      q = a.div(b).floor();
	      r = a.mod(b);
	
	      t = x;
	      x = lastx.minus(q.times(x));
	      lastx = t;
	
	      t = y;
	      y = lasty.minus(q.times(y));
	      lasty = t;
	
	      a = b;
	      b = r;
	    }
	
	    var res;
	    if (a.lt(zero)) {
	      res = [a.neg(), lastx.neg(), lasty.neg()];
	    }
	    else {
	      res = [a, !a.isZero() ? lastx : 0, lasty];
	    }
	    return (config.matrix === 'Array') ? res : matrix(res);
	  }
	}
	
	exports.name = 'xgcd';
	exports.factory = factory;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1751),
	  __webpack_require__(1755),
	  __webpack_require__(1756),
	  __webpack_require__(1758),
	  __webpack_require__(1760),
	  __webpack_require__(1763),
	  __webpack_require__(1765)
	];


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var bigBitAnd = __webpack_require__(1752);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm06 = load(__webpack_require__(1737));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Bitwise AND two values, `x & y`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.bitAnd(x, y)
	   *
	   * Examples:
	   *
	   *    math.bitAnd(53, 131);               // returns number 1
	   *
	   *    math.bitAnd([1, 12, 31], 42);       // returns Array [0, 8, 10]
	   *
	   * See also:
	   *
	   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x First value to and
	   * @param  {number | BigNumber | Array | Matrix} y Second value to and
	   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
	   */
	  var bitAnd = typed('bitAnd', {
	
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function bitAnd');
	      }
	
	      return x & y;
	    },
	
	    'BigNumber, BigNumber': bigBitAnd,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm06(x, y, bitAnd, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, bitAnd, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm02(x, y, bitAnd, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, bitAnd);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return bitAnd(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return bitAnd(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return bitAnd(x, matrix(y));
	    },
	    
	    'SparseMatrix, any': function (x, y) {
	      return algorithm11(x, y, bitAnd, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, bitAnd, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm11(y, x, bitAnd, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, bitAnd, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, bitAnd, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, bitAnd, true).valueOf();
	    }
	  });
	
	  bitAnd.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['bitAnd'] + '${args[1]}\\right)'
	  };
	
	  return bitAnd;
	}
	
	exports.name = 'bitAnd';
	exports.factory = factory;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bitwise = __webpack_require__(1753);
	
	/**
	 * Bitwise and for Bignumbers
	 *
	 * Special Cases:
	 *   N &  n =  N
	 *   n &  0 =  0
	 *   n & -1 =  n
	 *   n &  n =  n
	 *   I &  I =  I
	 *  -I & -I = -I
	 *   I & -I =  0
	 *   I &  n =  n
	 *   I & -n =  I
	 *  -I &  n =  0
	 *  -I & -n = -I
	 *
	 * @param {BigNumber} x
	 * @param {BigNumber} y
	 * @return {BigNumber} Result of `x` & `y`, is fully precise
	 * @private
	 */
	module.exports = function bitAnd(x, y) {
	  if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
	    throw new Error('Integers expected in function bitAnd');
	  }
	
	  var BigNumber = x.constructor;
	  if (x.isNaN() || y.isNaN()) {
	    return new BigNumber(NaN);
	  }
	
	  if (x.isZero() || y.eq(-1) || x.eq(y)) {
	    return x;
	  }
	  if (y.isZero() || x.eq(-1)) {
	    return y;
	  }
	
	  if (!x.isFinite() || !y.isFinite()) {
	    if (!x.isFinite() && !y.isFinite()) {
	      if (x.isNegative() == y.isNegative()) {
	        return x;
	      }
	      return new BigNumber(0);
	    }
	    if (!x.isFinite()) {
	      if (y.isNegative()) {
	        return x;
	      }
	      if (x.isNegative()) {
	        return new BigNumber(0);
	      }
	      return y;
	    }
	    if (!y.isFinite()) {
	      if (x.isNegative()) {
	        return y;
	      }
	      if (y.isNegative()) {
	        return new BigNumber(0);
	      }
	      return x;
	    }
	  }
	  return bitwise(x, y, function (a, b) { return a & b });
	};


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bitNot = __webpack_require__(1754);
	
	/**
	 * Applies bitwise function to numbers
	 * @param {BigNumber} x
	 * @param {BigNumber} y
	 * @param {function (a, b)} func
	 * @return {BigNumber}
	 */
	module.exports = function bitwise(x, y, func) {
	  var BigNumber = x.constructor;
	
	  var xBits, yBits;
	  var xSign = +(x.s < 0);
	  var ySign = +(y.s < 0);
	  if (xSign) {
	    xBits = decCoefficientToBinaryString(bitNot(x));
	    for (var i = 0; i < xBits.length; ++i) {
	      xBits[i] ^= 1;
	    }
	  } else {
	    xBits = decCoefficientToBinaryString(x);
	  }
	  if (ySign) {
	    yBits = decCoefficientToBinaryString(bitNot(y));
	    for (var i = 0; i < yBits.length; ++i) {
	      yBits[i] ^= 1;
	    }
	  } else {
	    yBits = decCoefficientToBinaryString(y);
	  }
	
	  var minBits, maxBits, minSign;
	  if (xBits.length <= yBits.length) {
	    minBits = xBits;
	    maxBits = yBits;
	    minSign = xSign;
	  } else {
	    minBits = yBits;
	    maxBits = xBits;
	    minSign = ySign;
	  }
	
	  var shortLen = minBits.length;
	  var longLen = maxBits.length;
	  var expFuncVal = func(xSign, ySign) ^ 1;
	  var outVal = new BigNumber(expFuncVal ^ 1);
	  var twoPower = new BigNumber(1);
	  var two = new BigNumber(2);
	
	  var prevPrec = BigNumber.precision;
	  BigNumber.config({precision: 1E9});
	
	  while (shortLen > 0) {
	    if (func(minBits[--shortLen], maxBits[--longLen]) == expFuncVal) {
	      outVal = outVal.plus(twoPower);
	    }
	    twoPower = twoPower.times(two);
	  }
	  while (longLen > 0) {
	    if (func(minSign, maxBits[--longLen]) == expFuncVal) {
	      outVal = outVal.plus(twoPower);
	    }
	    twoPower = twoPower.times(two);
	  }
	
	  BigNumber.config({precision: prevPrec});
	
	  if (expFuncVal == 0) {
	    outVal.s = -outVal.s;
	  }
	  return outVal;
	};
	
	/* Extracted from decimal.js, and edited to specialize. */
	function decCoefficientToBinaryString (x) {
	  // Convert to string
	  var a = x.d; // array with digits
	  var r = a[0] + '';
	
	  for (var i = 1; i < a.length; ++i) {
	    var s = a[i] + '';
	    for (var z = 7 - s.length; z--; ) {
	      s = '0' + s;
	    }
	
	    r += s;
	  }
	
	  var j;
	  for (j = r.length - 1; r.charAt(j) == '0'; --j);
	
	  var xe = x.e;
	  var str = r.slice(0, j + 1 || 1);
	  var strL = str.length;
	  if (xe > 0) {
	    if (++xe > strL) {
	      // Append zeros.
	      for (xe -= strL; xe--; str += '0');
	    } else if (xe < strL) {
	      str = str.slice(0, xe) + '.' + str.slice(xe);
	    }
	  }
	
	  // Convert from base 10 (decimal) to base 2
	  var arr = [0];
	  for (var i = 0; i < str.length; ) {
	    for (var arrL = arr.length; arrL--; arr[arrL] *= 10);
	
	    arr[0] += str.charAt(i++) << 0;  // convert to int
	    for (var j = 0; j < arr.length; ++j) {
	      if (arr[j] > 1) {
	        if (arr[j + 1] == null) {
	          arr[j + 1] = 0;
	        }
	
	        arr[j + 1] += arr[j] >> 1;
	        arr[j] &= 1;
	      }
	    }
	  }
	
	  return arr.reverse();
	}


/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	'use strict';
	/**
	 * Bitwise not
	 * @param {BigNumber} value
	 * @return {BigNumber} Result of ~`x`, fully precise
	 *
	 */
	module.exports = function bitNot (x) {
	  if (x.isFinite() && !x.isInteger()) {
	    throw new Error('Integer expected in function bitNot');
	  }
	
	  var BigNumber = x.constructor;
	  var prevPrec = BigNumber.precision;
	  BigNumber.config({precision: 1E9});
	
	  var x = x.plus(new BigNumber(1));
	  x.s = -x.s || null;
	
	  BigNumber.config({precision: prevPrec});
	  return x;
	};


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var bigBitNot = __webpack_require__(1754);
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Bitwise NOT value, `~x`.
	   * For matrices, the function is evaluated element wise.
	   * For units, the function is evaluated on the best prefix base.
	   *
	   * Syntax:
	   *
	   *    math.bitNot(x)
	   *
	   * Examples:
	   *
	   *    math.bitNot(1);               // returns number -2
	   *
	   *    math.bitNot([2, -3, 4]);      // returns Array [-3, 2, 5]
	   *
	   * See also:
	   *
	   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x Value to not
	   * @return {number | BigNumber | Array | Matrix} NOT of `x`
	   */
	  var bitNot = typed('bitNot', {
	    'number': function (x) {
	      if (!isInteger(x)) {
	        throw new Error('Integer expected in function bitNot');
	      }
	
	      return ~x;
	    },
	
	    'BigNumber': bigBitNot,
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, bitNot);
	    }
	  });
	
	  bitNot.toTex = {
	    1: latex.operators['bitNot'] + '\\left(${args[0]}\\right)'
	  };
	
	  return bitNot;
	}
	
	exports.name = 'bitNot';
	exports.factory = factory;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var bigBitOr = __webpack_require__(1757);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm04 = load(__webpack_require__(1371));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Bitwise OR two values, `x | y`.
	   * For matrices, the function is evaluated element wise.
	   * For units, the function is evaluated on the lowest print base.
	   *
	   * Syntax:
	   *
	   *    math.bitOr(x, y)
	   *
	   * Examples:
	   *
	   *    math.bitOr(1, 2);               // returns number 3
	   *
	   *    math.bitOr([1, 2, 3], 4);       // returns Array [5, 6, 7]
	   *
	   * See also:
	   *
	   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x First value to or
	   * @param  {number | BigNumber | Array | Matrix} y Second value to or
	   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
	   */
	  var bitOr = typed('bitOr', {
	
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function bitOr');
	      }
	
	      return x | y;
	    },
	
	    'BigNumber, BigNumber': bigBitOr,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm04(x, y, bitOr);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm01(y, x, bitOr, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm01(x, y, bitOr, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, bitOr);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return bitOr(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return bitOr(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return bitOr(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm10(x, y, bitOr, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, bitOr, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm10(y, x, bitOr, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, bitOr, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, bitOr, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, bitOr, true).valueOf();
	    }
	  });
	
	  bitOr.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['bitOr'] + '${args[1]}\\right)'
	  };
	
	  return bitOr;
	}
	
	exports.name = 'bitOr';
	exports.factory = factory;


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bitwise = __webpack_require__(1753);
	
	/**
	 * Bitwise OR for BigNumbers
	 *
	 * Special Cases:
	 *   N |  n =  N
	 *   n |  0 =  n
	 *   n | -1 = -1
	 *   n |  n =  n
	 *   I |  I =  I
	 *  -I | -I = -I
	 *   I | -n = -1
	 *   I | -I = -1
	 *   I |  n =  I
	 *  -I |  n = -I
	 *  -I | -n = -n
	 *
	 * @param {BigNumber} x
	 * @param {BigNumber} y
	 * @return {BigNumber} Result of `x` | `y`, fully precise
	 */
	module.exports = function bitOr (x, y) {
	  if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
	    throw new Error('Integers expected in function bitOr');
	  }
	
	  var BigNumber = x.constructor;
	  if (x.isNaN() || y.isNaN()) {
	    return new BigNumber(NaN);
	  }
	
	  var negOne = new BigNumber(-1);
	  if (x.isZero() || y.eq(negOne) || x.eq(y)) {
	    return y;
	  }
	  if (y.isZero() || x.eq(negOne)) {
	    return x;
	  }
	
	  if (!x.isFinite() || !y.isFinite()) {
	    if ((!x.isFinite() && !x.isNegative() && y.isNegative()) ||
	        (x.isNegative() && !y.isNegative() && !y.isFinite())) {
	      return negOne;
	    }
	    if (x.isNegative() && y.isNegative()) {
	      return x.isFinite() ? x : y;
	    }
	    return x.isFinite() ? y : x;
	  }
	
	  return bitwise(x, y, function (a, b) { return a | b });
	};


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var bigBitXor = __webpack_require__(1759);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Bitwise XOR two values, `x ^ y`.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.bitXor(x, y)
	   *
	   * Examples:
	   *
	   *    math.bitXor(1, 2);               // returns number 3
	   *
	   *    math.bitXor([2, 3, 4], 4);       // returns Array [6, 7, 0]
	   *
	   * See also:
	   *
	   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x First value to xor
	   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
	   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
	   */
	  var bitXor = typed('bitXor', {
	
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function bitXor');
	      }
	
	      return x ^ y;
	    },
	
	    'BigNumber, BigNumber': bigBitXor,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, bitXor);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, bitXor, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, bitXor, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, bitXor);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return bitXor(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return bitXor(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return bitXor(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, bitXor, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, bitXor, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, bitXor, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, bitXor, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, bitXor, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, bitXor, true).valueOf();
	    }
	  });
	
	  bitXor.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['bitXor'] + '${args[1]}\\right)'
	  };
	
	  return bitXor;
	}
	
	exports.name = 'bitXor';
	exports.factory = factory;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bitwise = __webpack_require__(1753);
	var bitNot = __webpack_require__(1754);
	
	/**
	 * Bitwise XOR for BigNumbers
	 *
	 * Special Cases:
	 *   N ^  n =  N
	 *   n ^  0 =  n
	 *   n ^  n =  0
	 *   n ^ -1 = ~n
	 *   I ^  n =  I
	 *   I ^ -n = -I
	 *   I ^ -I = -1
	 *  -I ^  n = -I
	 *  -I ^ -n =  I
	 *
	 * @param {BigNumber} x
	 * @param {BigNumber} y
	 * @return {BigNumber} Result of `x` ^ `y`, fully precise
	 *
	 */
	module.exports = function bitXor(x, y) {
	  if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
	    throw new Error('Integers expected in function bitXor');
	  }
	
	  var BigNumber = x.constructor;
	  if (x.isNaN() || y.isNaN()) {
	    return new BigNumber(NaN);
	  }
	  if (x.isZero()) {
	    return y;
	  }
	  if (y.isZero()) {
	    return x;
	  }
	
	  if (x.eq(y)) {
	    return new BigNumber(0);
	  }
	
	  var negOne = new BigNumber(-1);
	  if (x.eq(negOne)) {
	    return bitNot(y);
	  }
	  if (y.eq(negOne)) {
	    return bitNot(x);
	  }
	
	  if (!x.isFinite() || !y.isFinite()) {
	    if (!x.isFinite() && !y.isFinite()) {
	      return negOne;
	    }
	    return new BigNumber(x.isNegative() == y.isNegative()
	        ?  Infinity
	        : -Infinity);
	  }
	  return bitwise(x, y, function (a, b) { return a ^ b });
	};


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var bigLeftShift = __webpack_require__(1761);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	  var equalScalar = load(__webpack_require__(1364));
	  var zeros = load(__webpack_require__(1405));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm08 = load(__webpack_require__(1762));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
	   * For matrices, the function is evaluated element wise.
	   * For units, the function is evaluated on the best prefix base.
	   *
	   * Syntax:
	   *
	   *    math.leftShift(x, y)
	   *
	   * Examples:
	   *
	   *    math.leftShift(1, 2);               // returns number 4
	   *
	   *    math.leftShift([1, 2, 3], 4);       // returns Array [16, 32, 64]
	   *
	   * See also:
	   *
	   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
	   * @param  {number | BigNumber} y Amount of shifts
	   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
	   */
	  var leftShift = typed('leftShift', {
	    
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function leftShift');
	      }
	
	      return x << y;
	    },
	
	    'BigNumber, BigNumber': bigLeftShift,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm08(x, y, leftShift, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, leftShift, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm01(x, y, leftShift, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, leftShift);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return leftShift(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return leftShift(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return leftShift(x, matrix(y));
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm11(x, y, leftShift, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm14(x, y, leftShift, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm10(y, x, leftShift, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm14(y, x, leftShift, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return leftShift(matrix(x), y).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return leftShift(x, matrix(y)).valueOf();
	    }
	  });
	
	  leftShift.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['leftShift'] + '${args[1]}\\right)'
	  };
	
	  return leftShift;
	}
	
	exports.name = 'leftShift';
	exports.factory = factory;


/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Bitwise left shift
	 *
	 * Special Cases:
	 *  n << -n = N
	 *  n <<  N = N
	 *  N <<  n = N
	 *  n <<  0 = n
	 *  0 <<  n = 0
	 *  I <<  I = N
	 *  I <<  n = I
	 *  n <<  I = I
	 *
	 * @param {BigNumber} x
	 * @param {BigNumber} y
	 * @return {BigNumber} Result of `x` << `y`
	 *
	 */
	module.exports = function leftShift (x, y) {
	  if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
	    throw new Error('Integers expected in function leftShift');
	  }
	
	  var BigNumber = x.constructor;
	  if (x.isNaN() || y.isNaN() || (y.isNegative() && !y.isZero())) {
	    return new BigNumber(NaN);
	  }
	  if (x.isZero() || y.isZero()) {
	    return x;
	  }
	  if (!x.isFinite() && !y.isFinite()) {
	    return new BigNumber(NaN);
	  }
	
	  // Math.pow(2, y) is fully precise for y < 55, and fast
	  if (y.lt(55)) {
	    return x.times(Math.pow(2, y.toNumber()) + '');
	  }
	  return x.times(new BigNumber(2).pow(y));
	};


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	function factory (type, config, load, typed) {
	
	  var equalScalar = load(__webpack_require__(1364));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
	   * Callback function invoked MAX(NNZA, NNZB) times
	   *
	   *
	   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
	   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
	   *          └  0            ; otherwise
	   *
	   *
	   * @param {Matrix}   a                 The SparseMatrix instance (A)
	   * @param {Matrix}   b                 The SparseMatrix instance (B)
	   * @param {Function} callback          The f(Aij,Bij) operation to invoke
	   *
	   * @return {Matrix}                    SparseMatrix (C)
	   *
	   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
	   */
	  var algorithm08 = function (a, b, callback) {
	    // sparse matrix arrays
	    var avalues = a._values;
	    var aindex = a._index;
	    var aptr = a._ptr;
	    var asize = a._size;
	    var adt = a._datatype;
	    // sparse matrix arrays
	    var bvalues = b._values;
	    var bindex = b._index;
	    var bptr = b._ptr;
	    var bsize = b._size;
	    var bdt = b._datatype;
	
	    // validate dimensions
	    if (asize.length !== bsize.length)
	      throw new DimensionError(asize.length, bsize.length);
	
	    // check rows & columns
	    if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
	      throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
	
	    // sparse matrix cannot be a Pattern matrix
	    if (!avalues || !bvalues)
	      throw new Error('Cannot perform operation on Pattern Sparse Matrices');
	
	    // rows & columns
	    var rows = asize[0];
	    var columns = asize[1];
	
	    // datatype
	    var dt;
	    // equal signature to use
	    var eq = equalScalar;
	    // zero value
	    var zero = 0;
	    // callback signature to use
	    var cf = callback;
	
	    // process data types
	    if (typeof adt === 'string' && adt === bdt) {
	      // datatype
	      dt = adt;
	      // find signature that matches (dt, dt)
	      eq = typed.find(equalScalar, [dt, dt]);
	      // convert 0 to the same datatype
	      zero = typed.convert(0, dt);
	      // callback
	      cf = typed.find(callback, [dt, dt]);
	    }
	
	    // result arrays
	    var cvalues = [];
	    var cindex = [];
	    var cptr = [];
	    // matrix
	    var c = new SparseMatrix({
	      values: cvalues,
	      index: cindex,
	      ptr: cptr,
	      size: [rows, columns],
	      datatype: dt
	    });
	
	    // workspace
	    var x = [];
	    // marks indicating we have a value in x for a given column
	    var w = [];
	
	    // vars
	    var k, k0, k1, i;
	
	    // loop columns
	    for (var j = 0; j < columns; j++) {
	      // update cptr
	      cptr[j] = cindex.length;
	      // columns mark
	      var mark = j + 1;
	      // loop values in a
	      for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = aindex[k];
	        // mark workspace
	        w[i] = mark;
	        // set value
	        x[i] = avalues[k];
	        // add index
	        cindex.push(i);
	      }
	      // loop values in b
	      for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
	        // row
	        i = bindex[k];
	        // check value exists in workspace
	        if (w[i] === mark) {
	          // evaluate callback
	          x[i] = cf(x[i], bvalues[k]);
	        }
	      }
	      // initialize first index in j
	      k = cptr[j];
	      // loop index in j
	      while (k < cindex.length) {
	        // row
	        i = cindex[k];
	        // value @ i
	        var v = x[i];
	        // check for zero value
	        if (!eq(v, zero)) {
	          // push value
	          cvalues.push(v);
	          // increment pointer
	          k++;
	        }
	        else {
	          // remove value @ i, do not increment pointer
	          cindex.splice(k, 1);
	        }
	      }      
	    }
	    // update cptr
	    cptr[columns] = cindex.length;
	
	    // return sparse matrix
	    return c;
	  };
	
	  return algorithm08;
	}
	
	exports.name = 'algorithm08';
	exports.factory = factory;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var bigRightArithShift = __webpack_require__(1764);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	  
	  var matrix = load(__webpack_require__(1368));
	  var equalScalar = load(__webpack_require__(1364));
	  var zeros = load(__webpack_require__(1405));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm08 = load(__webpack_require__(1762));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
	   * For matrices, the function is evaluated element wise.
	   * For units, the function is evaluated on the best prefix base.
	   *
	   * Syntax:
	   *
	   *    math.rightArithShift(x, y)
	   *
	   * Examples:
	   *
	   *    math.rightArithShift(4, 2);               // returns number 1
	   *
	   *    math.rightArithShift([16, -32, 64], 4);   // returns Array [1, -2, 3]
	   *
	   * See also:
	   *
	   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
	   *
	   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
	   * @param  {number | BigNumber} y Amount of shifts
	   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
	   */
	  var rightArithShift = typed('rightArithShift', {
	
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function rightArithShift');
	      }
	
	      return x >> y;
	    },
	
	    'BigNumber, BigNumber': bigRightArithShift,
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm08(x, y, rightArithShift, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, rightArithShift, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm01(x, y, rightArithShift, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, rightArithShift);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return rightArithShift(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return rightArithShift(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return rightArithShift(x, matrix(y));
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm11(x, y, rightArithShift, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm14(x, y, rightArithShift, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm10(y, x, rightArithShift, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm14(y, x, rightArithShift, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return rightArithShift(matrix(x), y).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return rightArithShift(x, matrix(y)).valueOf();
	    }
	  });
	
	  rightArithShift.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['rightArithShift'] + '${args[1]}\\right)'
	  };
	
	  return rightArithShift;
	}
	
	exports.name = 'rightArithShift';
	exports.factory = factory;


/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	'use strict';
	/*
	 * Special Cases:
	 *   n >> -n =  N
	 *   n >>  N =  N
	 *   N >>  n =  N
	 *   I >>  I =  N
	 *   n >>  0 =  n
	 *   I >>  n =  I
	 *  -I >>  n = -I
	 *  -I >>  I = -I
	 *   n >>  I =  I
	 *  -n >>  I = -1
	 *   0 >>  n =  0
	 *
	 * @param {BigNumber} value
	 * @param {BigNumber} value
	 * @return {BigNumber} Result of `x` >> `y`
	 *
	 */
	module.exports = function rightArithShift (x, y) {
	  if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
	    throw new Error('Integers expected in function rightArithShift');
	  }
	
	  var BigNumber = x.constructor;
	  if (x.isNaN() || y.isNaN() || (y.isNegative() && !y.isZero())) {
	    return new BigNumber(NaN);
	  }
	  if (x.isZero() || y.isZero()) {
	    return x;
	  }
	  if (!y.isFinite()) {
	    if (x.isNegative()) {
	      return new BigNumber(-1);
	    }
	    if (!x.isFinite()) {
	      return new BigNumber(NaN);
	    }
	    return new BigNumber(0);
	  }
	
	  // Math.pow(2, y) is fully precise for y < 55, and fast
	  if (y.lt(55)) {
	    return x.div(Math.pow(2, y.toNumber()) + '').floor();
	  }
	  return x.div(new BigNumber(2).pow(y)).floor();
	};


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	  var equalScalar = load(__webpack_require__(1364));
	  var zeros = load(__webpack_require__(1405));
	
	  var algorithm01 = load(__webpack_require__(1370));
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm08 = load(__webpack_require__(1762));
	  var algorithm10 = load(__webpack_require__(1372));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
	   * For matrices, the function is evaluated element wise.
	   * For units, the function is evaluated on the best prefix base.
	   *
	   * Syntax:
	   *
	   *    math.rightLogShift(x, y)
	   *
	   * Examples:
	   *
	   *    math.rightLogShift(4, 2);               // returns number 1
	   *
	   *    math.rightLogShift([16, -32, 64], 4);   // returns Array [1, 2, 3]
	   *
	   * See also:
	   *
	   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
	   *
	   * @param  {number | Array | Matrix} x Value to be shifted
	   * @param  {number} y Amount of shifts
	   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
	   */
	
	  var rightLogShift = typed('rightLogShift', {
	
	    'number, number': function (x, y) {
	      if (!isInteger(x) || !isInteger(y)) {
	        throw new Error('Integers expected in function rightLogShift');
	      }
	
	      return x >>> y;
	    },
	
	    // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm08(x, y, rightLogShift, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, rightLogShift, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm01(x, y, rightLogShift, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, rightLogShift);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return rightLogShift(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return rightLogShift(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return rightLogShift(x, matrix(y));
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm11(x, y, rightLogShift, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      // check scalar
	      if (equalScalar(y, 0)) {
	        return x.clone();
	      }
	      return algorithm14(x, y, rightLogShift, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm10(y, x, rightLogShift, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      // check scalar
	      if (equalScalar(x, 0)) {
	        return zeros(y.size(), y.storage());
	      }
	      return algorithm14(y, x, rightLogShift, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      // use matrix implementation
	      return rightLogShift(matrix(x), y).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      // use matrix implementation
	      return rightLogShift(x, matrix(y)).valueOf();
	    }
	  });
	
	  rightLogShift.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['rightLogShift'] + '${args[1]}\\right)'
	  };
	
	  return rightLogShift;
	}
	
	exports.name = 'rightLogShift';
	exports.factory = factory;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1767),
	  __webpack_require__(1773),
	  __webpack_require__(1768),
	  __webpack_require__(1774)
	];


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var stirlingS2 = load(__webpack_require__(1768));
	  var isNegative = load(__webpack_require__(1723));
	  var isInteger = load(__webpack_require__(1772));
	
	  /**
	   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
	   * bellNumbers only takes integer arguments.
	   * The following condition must be enforced: n >= 0
	   *
	   * Syntax:
	   *
	   *   math.bellNumbers(n)
	   *
	   * Examples:
	   *
	   *    math.bellNumbers(3); // returns 5;
	   *    math.bellNumbers(8); // returns 4140;
	   *
	   * See also:
	   *
	   *    stirlingS2
	   *
	   * @param {Number | BigNumber} n    Total number of objects in the set
	   * @return {Number | BigNumber}     B(n)
	   */
	  var bellNumbers = typed('bellNumbers', {
	    'number | BigNumber': function (n) {
	
	      if (!isInteger(n) || isNegative(n)) {
	        throw new TypeError('Non-negative integer value expected in function bellNumbers');
	      }
	
	      // Sum (k=0, n) S(n,k).
	      var result = 0;
	      for(var i = 0; i <= n; i++) {
	        result = add(result, stirlingS2(n, i));
	      }
	
	      return result;
	    }
	  });
	
	  bellNumbers.toTex = {1: '\\mathrm{B}_{${args[0]}}'};
	
	  return bellNumbers;
	}
	
	exports.name = 'bellNumbers';
	exports.factory = factory;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1400));
	  var divide = load(__webpack_require__(1669));
	  var pow = load(__webpack_require__(1398));
	  var factorial = load(__webpack_require__(1769));
	  var combinations = load(__webpack_require__(1771));
	  var isNegative = load(__webpack_require__(1723));
	  var isInteger = load(__webpack_require__(1772));
	  var larger = load(__webpack_require__(1380));
	
	  /**
	   * The Stirling numbers of the second kind, counts the number of ways to partition
	   * a set of n labelled objects into k nonempty unlabelled subsets.
	   * stirlingS2 only takes integer arguments.
	   * The following condition must be enforced: k <= n.
	   *
	   *  If n = k or k = 1, then s(n,k) = 1
	   *
	   * Syntax:
	   *
	   *   math.stirlingS2(n, k)
	   *
	   * Examples:
	   *
	   *    math.stirlingS2(5, 3); //returns 25
	   *
	   * See also:
	   *
	   *    Bell numbers
	   *
	   * @param {Number | BigNumber} n    Total number of objects in the set
	   * @param {Number | BigNumber} k    Number of objects in the subset
	   * @return {Number | BigNumber}     S(n,k)
	   */
	  var stirlingS2 = typed('stirlingS2', {
	    'number | BigNumber, number | BigNumber': function (n, k) {
	      if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) {
	        throw new TypeError('Non-negative integer value expected in function stirlingS2');
	      }
	      else if (larger(k, n)) {
	        throw new TypeError('k must be less than or equal to n in function stirlingS2');
	      }
	
	      // 1/k! Sum(i=0 -> k) [(-1)^(k-i)*C(k,j)* i^n]
	      var kFactorial = factorial(k);
	      var result = 0;
	      for(var i = 0; i <= k; i++) {
	        var negativeOne = pow(-1, subtract(k,i));
	        var kChooseI = combinations(k,i);
	        var iPower = pow(i,n);
	
	        result = add(result, multiply(multiply(kChooseI, iPower), negativeOne));
	      }
	
	      return divide(result, kFactorial);
	    }
	  });
	
	  stirlingS2.toTex = {2: '\\mathrm{S}\\left(${args}\\right)'};
	
	  return stirlingS2;
	}
	
	exports.name = 'stirlingS2';
	exports.factory = factory;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var gamma = load(__webpack_require__(1770));
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Compute the factorial of a value
	   *
	   * Factorial only supports an integer value as argument.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.factorial(n)
	   *
	   * Examples:
	   *
	   *    math.factorial(5);    // returns 120
	   *    math.factorial(3);    // returns 6
	   *
	   * See also:
	   *
	   *    combinations, gamma, permutations
	   *
	   * @param {number | BigNumber | Array | Matrix} n   An integer number
	   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
	   */
	  var factorial = typed('factorial', {
	    'number': function (n) {
	      if (n < 0) {
	        throw new Error('Value must be non-negative');
	      }
	
	      return gamma(n + 1);
	    },
	
	    'BigNumber': function (n) {
	      if (n.isNegative()) {
	        throw new Error('Value must be non-negative');
	      }
	
	      return gamma(n.plus(1));
	    },
	
	    'Array | Matrix': function (n) {
	      return deepMap(n, factorial);
	    }
	  });
	
	  factorial.toTex = {
	    1: '\\left(${args[0]}\\right)' + latex.operators['factorial']
	  };
	
	  return factorial;
	}
	
	exports.name = 'factorial';
	exports.factory = factory;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var multiply = load(__webpack_require__(1400));
	  var pow = load(__webpack_require__(1398));
	
	  /**
	   * Compute the gamma function of a value using Lanczos approximation for
	   * small values, and an extended Stirling approximation for large values.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.gamma(n)
	   *
	   * Examples:
	   *
	   *    math.gamma(5);       // returns 24
	   *    math.gamma(-0.5);    // returns -3.5449077018110335
	   *    math.gamma(math.i);  // returns -0.15494982830180973 - 0.49801566811835596i
	   *
	   * See also:
	   *
	   *    combinations, factorial, permutations
	   *
	   * @param {number | Array | Matrix} n   A real or complex number
	   * @return {number | Array | Matrix}    The gamma of `n`
	   */
	  var gamma = typed('gamma', {
	    'number': function (n) {
	      var t, x;
	
	      if (isInteger(n)) {
	        if (n <= 0) {
	          return isFinite(n) ? Infinity : NaN;
	        }
	
	        if (n > 171) {
	          return Infinity;                  // Will overflow
	        }
	
	        var value = n - 2;
	        var res = n - 1;
	        while (value > 1) {
	          res *= value;
	          value--;
	        }
	
	        if (res == 0) {
	          res = 1;                          // 0! is per definition 1
	        }
	
	        return res;
	      }
	
	      if (n < 0.5) {
	        return Math.PI / (Math.sin(Math.PI * n) * gamma(1-n));
	      }
	
	      if (n >= 171.35) {
	        return Infinity;                    // will overflow
	      }
	
	      if (n > 85.0) {                       // Extended Stirling Approx
	        var twoN = n*n;
	        var threeN = twoN*n;
	        var fourN = threeN*n;
	        var fiveN = fourN*n;
	        return Math.sqrt(2*Math.PI/n) * Math.pow((n/Math.E), n) *
	            (1 + 1/(12*n) + 1/(288*twoN) - 139/(51840*threeN) -
	            571/(2488320*fourN) + 163879/(209018880*fiveN) +
	            5246819/(75246796800*fiveN*n));
	      }
	
	      --n;
	      x = p[0];
	      for (var i = 1; i < p.length; ++i) {
	        x += p[i] / (n+i);
	      }
	
	      t = n + g + 0.5;
	      return Math.sqrt(2*Math.PI) * Math.pow(t, n+0.5) * Math.exp(-t) * x;
	    },
	
	    'Complex': function (n) {
	      var t, x;
	
	      if (n.im == 0) {
	        return gamma(n.re);
	      }
	
	      n = new type.Complex(n.re - 1, n.im);
	      x = new type.Complex(p[0], 0);
	      for (var i = 1; i < p.length; ++i) {
	        var real = n.re + i;                // x += p[i]/(n+i)
	        var den = real*real + n.im*n.im;
	        if (den != 0) {
	          x.re += p[i] * real / den;
	          x.im += -(p[i] * n.im) / den;
	        } else {
	          x.re = p[i] < 0
	              ? -Infinity
	              :  Infinity;
	        }
	      }
	
	      t = new type.Complex(n.re + g + 0.5, n.im);
	      var twoPiSqrt = Math.sqrt(2*Math.PI);
	
	      n.re += 0.5;
	      var result = pow(t, n);
	      if (result.im == 0) {                 // sqrt(2*PI)*result
	        result.re *= twoPiSqrt;
	      } else if (result.re == 0) {
	        result.im *= twoPiSqrt;
	      } else {
	        result.re *= twoPiSqrt;
	        result.im *= twoPiSqrt;
	      }
	
	      var r = Math.exp(-t.re);              // exp(-t)
	      t.re = r * Math.cos(-t.im);
	      t.im = r * Math.sin(-t.im);
	
	      return multiply(multiply(result, t), x);
	    },
	
	    'BigNumber': function (n) {
	      if (n.isInteger()) {
	        return (n.isNegative() || n.isZero())
	            ? new type.BigNumber(Infinity)
	            : bigFactorial(n.minus(1));
	      }
	
	      if (!n.isFinite()) {
	        return new type.BigNumber(n.isNegative() ? NaN : Infinity);
	      }
	
	      throw new Error('Integer BigNumber expected');
	    },
	
	    'Array | Matrix': function (n) {
	      return deepMap(n, gamma);
	    }
	  });
	
	  /**
	   * Calculate factorial for a BigNumber
	   * @param {BigNumber} n
	   * @returns {BigNumber} Returns the factorial of n
	   */
	  function bigFactorial(n) {
	    if (n.isZero()) {
	      return new type.BigNumber(1); // 0! is per definition 1
	    }
	
	    var precision = config.precision + (Math.log(n.toNumber()) | 0);
	    var Big = type.BigNumber.clone({precision: precision});
	
	    var res = new Big(n);
	    var value = n.toNumber() - 1; // number
	    while (value > 1) {
	      res = res.times(value);
	      value--;
	    }
	
	    return new type.BigNumber(res.toPrecision(type.BigNumber.precision));
	  }
	
	  gamma.toTex = {1: '\\Gamma\\left(${args[0]}\\right)'};
	
	  return gamma;
	}
	
	// TODO: comment on the variables g and p
	
	var g = 4.7421875;
	
	var p = [
	  0.99999999999999709182,
	  57.156235665862923517,
	  -59.597960355475491248,
	  14.136097974741747174,
	  -0.49191381609762019978,
	  0.33994649984811888699e-4,
	  0.46523628927048575665e-4,
	  -0.98374475304879564677e-4,
	  0.15808870322491248884e-3,
	  -0.21026444172410488319e-3,
	  0.21743961811521264320e-3,
	  -0.16431810653676389022e-3,
	  0.84418223983852743293e-4,
	  -0.26190838401581408670e-4,
	  0.36899182659531622704e-5
	];
	
	exports.name = 'gamma';
	exports.factory = factory;


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the number of ways of picking `k` unordered outcomes from `n`
	   * possibilities.
	   *
	   * Combinations only takes integer arguments.
	   * The following condition must be enforced: k <= n.
	   *
	   * Syntax:
	   *
	   *     math.combinations(n, k)
	   *
	   * Examples:
	   *
	   *    math.combinations(7, 5); // returns 21
	   *
	   * See also:
	   *
	   *    permutations, factorial
	   *
	   * @param {number | BigNumber} n    Total number of objects in the set
	   * @param {number | BigNumber} k    Number of objects in the subset
	   * @return {number | BigNumber}     Number of possible combinations.
	   */
	  var combinations = typed('combinations', {
	    'number, number': function (n, k) {
	      var max, result, i;
	
	      if (!isInteger(n) || n < 0) {
	        throw new TypeError('Positive integer value expected in function combinations');
	      }
	      if (!isInteger(k) || k < 0) {
	        throw new TypeError('Positive integer value expected in function combinations');
	      }
	      if (k > n) {
	        throw new TypeError('k must be less than or equal to n');
	      }
	
	      max = Math.max(k, n - k);
	      result = 1;
	      for (i = 1; i <= n - max; i++) {
	        result = result * (max + i) / i;
	      }
	
	      return result;
	    },
	
	    'BigNumber, BigNumber': function (n, k) {
	      var max, result, i, ii;
	      var one = new type.BigNumber(1);
	
	      if (!isPositiveInteger(n) || !isPositiveInteger(k)) {
	        throw new TypeError('Positive integer value expected in function combinations');
	      }
	      if (k.gt(n)) {
	        throw new TypeError('k must be less than n in function combinations');
	      }
	
	      max = n.minus(k);
	      if (k.lt(max)) max = k;
	      result = one;
	      for (i = one, ii = n.minus(max); i.lte(ii); i = i.plus(1)) {
	        result = result.times(max.plus(i)).dividedBy(i);
	      }
	
	      return result;
	    }
	
	    // TODO: implement support for collection in combinations
	  });
	
	  combinations.toTex = {2: '\\binom{${args[0]}}{${args[1]}}'};
	
	  return combinations;
	}
	
	/**
	 * Test whether BigNumber n is a positive integer
	 * @param {BigNumber} n
	 * @returns {boolean} isPositiveInteger
	 */
	function isPositiveInteger(n) {
	  return n.isInteger() && n.gte(0);
	}
	
	exports.name = 'combinations';
	exports.factory = factory;


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is an integer number.
	   * The function supports `number`, `BigNumber`, and `Fraction`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isInteger(x)
	   *
	   * Examples:
	   *
	   *    math.isInteger(2);                     // returns true
	   *    math.isInteger(0);                     // returns true
	   *    math.isInteger(0.5);                   // returns false
	   *    math.isInteger(math.bignumber(500));   // returns true
	   *    math.isInteger(math.fraction(4));      // returns true
	   *    math.isInteger('3');                   // returns true
	   *    math.isInteger([3, 0.5, -2]);          // returns [true, false, true]
	   *    math.isInteger(math.complex('2-4i');   // throws an error
	   *
	   * See also:
	   *
	   *    isNumeric, isPositive, isNegative, isZero
	   *
	   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
	   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isInteger = typed('isInteger', {
	    'number': number.isInteger, // TODO: what to do with isInteger(add(0.1, 0.2))  ?
	
	    'BigNumber': function (x) {
	      return x.isInt();
	    },
	
	    'Fraction': function (x) {
	      return x.d === 1 && isFinite(x.n);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isInteger);
	    }
	  });
	
	  return isInteger;
	}
	
	exports.name = 'isInteger';
	exports.factory = factory;


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var combinations = load(__webpack_require__(1771));
	  var add = load(__webpack_require__(1369));
	  var isPositive = load(__webpack_require__(1691));
	  var isInteger = load(__webpack_require__(1772));
	  var larger = load(__webpack_require__(1380));
	
	  /**
	   * The composition counts of n into k parts.
	   *
	   * composition only takes integer arguments.
	   * The following condition must be enforced: k <= n.
	   *
	   * Syntax:
	   *
	   *   math.composition(n, k)
	   *
	   * Examples:
	   *
	   *    math.composition(5, 3); // returns 6
	   *
	   * See also:
	   *
	   *    combinations
	   *
	   * @param {Number | BigNumber} n    Total number of objects in the set
	   * @param {Number | BigNumber} k    Number of objects in the subset
	   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
	   */
	  var composition =  typed('composition', {
	    'number | BigNumber, number | BigNumber': function (n, k) {
	      if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) {
	        throw new TypeError('Positive integer value expected in function composition');
	      }
	      else if (larger(k, n)) {
	        throw new TypeError('k must be less than or equal to n in function composition');
	      }
	
	      return combinations(add(n, -1), add(k, -1));
	    }
	  });
	
	  composition.toTex = undefined; // use default template
	
	  return composition;
	}
	
	exports.name = 'composition';
	exports.factory = factory;


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var divide = load(__webpack_require__(1669));
	  var multiply = load(__webpack_require__(1400));
	  var combinations = load(__webpack_require__(1771));
	  var isNegative = load(__webpack_require__(1723));
	  var isInteger = load(__webpack_require__(1772));
	
	
	  /**
	   * The Catalan Numbers enumerate combinatorial structures of many different types.
	   * catalan only takes integer arguments.
	   * The following condition must be enforced: n >= 0
	   *
	   * Syntax:
	   *
	   *   math.catalan(n)
	   *
	   * Examples:
	   *
	   *    math.catalan(3); // returns 5;
	   *    math.catalan(8); // returns 1430;
	   *
	   * See also:
	   *
	   *    bellNumbers
	   *
	   * @param {Number | BigNumber} n    nth Catalan number
	   * @return {Number | BigNumber}     Cn(n)
	   */
	  var catalan = typed('catalan', {
	    'number | BigNumber': function (n) {
	
	      if (!isInteger(n) || isNegative(n)) {
	        throw new TypeError('Non-negative integer value expected in function catalan');
	      }
	       
	      return divide(combinations(multiply(n,2), n), add(n,1));
	
	    }
	  });
	
	  catalan.toTex = {1: '\\mathrm{C}_{${args[0]}}'};
	
	  return catalan;
	}
	
	exports.name = 'catalan';
	exports.factory = factory;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1776),
	  __webpack_require__(1695),
	  __webpack_require__(1777),
	  __webpack_require__(1778)
	];


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the argument of a complex value.
	   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.arg(x)
	   *
	   * Examples:
	   *
	   *    var a = math.complex(2, 2);
	   *    math.arg(a) / math.pi;          // returns number 0.25
	   *
	   *    var b = math.complex('2 + 3i');
	   *    math.arg(b);                    // returns number 0.982793723247329
	   *    math.atan2(3, 2);               // returns number 0.982793723247329
	   *
	   * See also:
	   *
	   *    re, im, conj, abs
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            A complex number or array with complex numbers
	   * @return {number | BigNumber | Array | Matrix} The argument of x
	   */
	  var arg = typed('arg', {
	    'number': function (x) {
	      return Math.atan2(0, x);
	    },
	
	    'BigNumber': function (x) {
	      return type.BigNumber.atan2(0, x);
	    },
	
	    'Complex': function (x) {
	      return x.arg();
	    },
	
	    // TODO: implement BigNumber support for function arg
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, arg);
	    }
	  });
	
	  arg.toTex = {1: '\\arg\\left(${args[0]}\\right)'};
	
	  return arg;
	}
	
	exports.name = 'arg';
	exports.factory = factory;


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Get the imaginary part of a complex number.
	   * For a complex number `a + bi`, the function returns `b`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.im(x)
	   *
	   * Examples:
	   *
	   *    var a = math.complex(2, 3);
	   *    math.re(a);                     // returns number 2
	   *    math.im(a);                     // returns number 3
	   *
	   *    math.re(math.complex('-5.2i')); // returns number -5.2
	   *    math.re(math.complex(2.4));     // returns number 0
	   *
	   * See also:
	   *
	   *    re, conj, abs, arg
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            A complex number or array with complex numbers
	   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
	   */
	  var im = typed('im', {
	    'number': function (x) {
	      return 0;
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(0);
	    },
	
	    'Complex': function (x) {
	      return x.im;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, im);
	    }
	  });
	
	  im.toTex = {1: '\\Im\\left\\lbrace${args[0]}\\right\\rbrace'};
	
	  return im;
	}
	
	exports.name = 'im';
	exports.factory = factory;


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Get the real part of a complex number.
	   * For a complex number `a + bi`, the function returns `a`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.re(x)
	   *
	   * Examples:
	   *
	   *    var a = math.complex(2, 3);
	   *    math.re(a);                     // returns number 2
	   *    math.im(a);                     // returns number 3
	   *
	   *    math.re(math.complex('-5.2i')); // returns number 0
	   *    math.re(math.complex(2.4));     // returns number 2.4
	   *
	   * See also:
	   *
	   *    im, conj, abs, arg
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x
	   *            A complex number or array with complex numbers
	   * @return {number | BigNumber | Array | Matrix} The real part of x
	   */
	  var re = typed('re', {
	    'number': function (x) {
	      return x;
	    },
	
	    'BigNumber': function (x) {
	      return x;
	    },
	
	    'Complex': function (x) {
	      return x.re;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, re);
	    }
	  });
	
	  re.toTex = {1: '\\Re\\left\\lbrace${args[0]}\\right\\rbrace'};
	
	  return re;
	}
	
	exports.name = 're';
	exports.factory = factory;


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1780),
	  __webpack_require__(1781)
	];


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var abs = load(__webpack_require__(1402));
	  var add = load(__webpack_require__(1367));
	  var addScalar = load(__webpack_require__(1369));
	  var matrix = load(__webpack_require__(1368));
	  var multiply = load(__webpack_require__(1400));
	  var multiplyScalar = load(__webpack_require__(1396));
	  var divideScalar = load(__webpack_require__(1397));
	  var subtract = load(__webpack_require__(1393));
	  var smaller = load(__webpack_require__(1376));
	  var equalScalar = load(__webpack_require__(1364));
	
	  /**
	   * Calculates the point of intersection of two lines in two or three dimensions
	   * and of a line and a plane in three dimensions. The inputs are in the form of
	   * arrays or 1 dimensional matrices. The line intersection functions return null
	   * if the lines do not meet.
	   *
	   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
	   *
	   * Syntax:
	   *
	   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
	   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
	   *
	   * Examples:
	   *
	   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10]);              // Returns [5, 5]
	   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0]);  // Returns [5, 5, 0]
	   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6]);            // Returns [7, -4, 3]
	   *
	   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
	   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
	   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
	   *                              OR Co-efficients of the plane's equation
	   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
	   *                              OR null if the calculation is for line and plane
	   * @return {Array}              Returns the point of intersection of lines/lines-planes
	   */
	  var intersect = typed('intersect', {
	    'Array, Array, Array': function (x, y, plane) {
	      if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
	      if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
	      if (!_4d(plane)) { throw new TypeError('Array with 4 numbers expected as third argument'); }
	
	      return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
	    },
	
	    'Array, Array, Array, Array': function (w, x, y, z) {
	      if (w.length === 2) {
	        if (!_2d(w)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
	        if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }
	        if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument'); }
	        if (!_2d(z)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for fourth argument'); }
	
	        return _intersect2d(w, x, y, z);
	      }
	      else if (w.length === 3) {
	        if (!_3d(w)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
	        if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
	        if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for third argument'); }
	        if (!_3d(z)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for fourth argument'); }
	
	        return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
	      }
	      else {
	        throw new TypeError('Arrays with two or thee dimensional points expected');
	      }
	    },
	
	    'Matrix, Matrix, Matrix': function (x, y, plane) {
	      return matrix(intersect(x.valueOf(), y.valueOf(), plane.valueOf()));
	    },
	
	    'Matrix, Matrix, Matrix, Matrix': function (w, x, y, z) {
	      // TODO: output matrix type should match input matrix type
	      return matrix(intersect(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf()));
	    }
	  });
	
	  function _isNumber(a) {
	    // intersect supports numbers and bignumbers
	    return (typeof a === 'number' || type.isBigNumber(a));
	  }
	
	  function _2d(x) {
	    return x.length === 2 && _isNumber(x[0]) && _isNumber(x[1]);
	  }
	
	  function _3d(x) {
	    return x.length === 3 && _isNumber(x[0]) && _isNumber(x[1]) && _isNumber(x[2]);
	  }
	
	  function _4d(x) {
	    return x.length === 4 && _isNumber(x[0]) && _isNumber(x[1]) && _isNumber(x[2]) && _isNumber(x[3]);
	  }
	
	  function _intersect2d(p1a, p1b, p2a, p2b){
	    var o1 = p1a;
	    var o2 = p2a;
	    var d1 = subtract(o1, p1b);
	    var d2 = subtract(o2, p2b);
	    var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
	    if (smaller(abs(det), config.epsilon)) {
	      return null;
	    }
	    var d20o11 = multiplyScalar(d2[0], o1[1]);
	    var d21o10 = multiplyScalar(d2[1], o1[0]);
	    var d20o21 = multiplyScalar(d2[0], o2[1]);
	    var d21o20 = multiplyScalar(d2[1], o2[0]);
	    var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
	    return add(multiply(d1, t), o1);
	  }
	
	  function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l){
	      // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
	      var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
	      var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
	      var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
	      return addScalar(addScalar(add1, add2), add3);
	  }
	
	  function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4){
	    var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
	    var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
	    var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
	    var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
	    var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
	    var ta = divideScalar(
	      subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343)),
	      subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321)));
	    var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
	
	    var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
	    var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
	    var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
	    var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
	    var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
	    var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
	    if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)){
	      return [pax, pay, paz];
	    }
	    else{
	      return null;
	    }
	  }
	
	  function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c){
	    var x1x = multiplyScalar(x1, x);
	    var x2x = multiplyScalar(x2, x);
	    var y1y = multiplyScalar(y1, y);
	    var y2y = multiplyScalar(y2, y);
	    var z1z = multiplyScalar(z1, z);
	    var z2z = multiplyScalar(z2, z);
	    var t = divideScalar(
	      subtract(subtract(subtract(c, x1x), y1y), z1z),
	      subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z));
	    var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
	    var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
	    var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
	    return [px, py, pz];
	    // TODO: Add cases when line is parallel to the plane:
	    //       (a) no intersection,
	    //       (b) line contained in plane
	  }
	
	  return intersect;
	}
	
	exports.name = 'intersect';
	exports.factory = factory;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  var add = load(__webpack_require__(1369));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1396));
	  var divide = load(__webpack_require__(1397));
	  var negate = load(__webpack_require__(1394));
	  var sqrt = load(__webpack_require__(1694));
	  var abs = load(__webpack_require__(1402));
	
	  /**
	    * Calculates:
	    *    The eucledian distance between two points in 2 and 3 dimensional spaces.
	    *    Distance between point and a line in 2 and 3 dimensional spaces.
	    *    Pairwise distance between a set of 2D or 3D points
	    * NOTE:
	    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
	    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
	    *
	    * Syntax:
	    *    math.distance([x1, y1], [x2, y2])
	    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
	    *    math.distance([x1, y1, z1], [x2, y2, z2])
	    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
	    *    math.distance([[A], [B], [C]...])
	    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
	    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
	    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
	    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
	    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
	    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
	    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
	    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
	    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
	    *
	    * Examples:
	    *    math.distance([0,0], [4,4])                     // Returns 5.6569
	    *    math.distance(
	    *     {pointOneX: 0, pointOneY: 0},
	    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
	    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
	    *    math.distance(
	    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
	    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
	    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
	    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
	    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
	    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
	    *    math.distance(
	    *     {pointX: 1, pointY: 4},
	    *     {lineOnePtX: 6, lineOnePtY: 3},
	    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
	    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
	    *    math.distance(
	    *     {pointX: 2, pointY: 3, pointZ: 1},
	    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
	    *
	    * @param {Array | Matrix | Object} x    Co-ordinates of first point
	    * @param {Array | Matrix | Object} y    Co-ordinates of second point
	    * @return {Number | BigNumber} Returns the distance from two/three points
	  */
	
	  var distance = typed('distance', {
	    'Array, Array, Array': function(x, y, z){
	      // Point to Line 2D; (x=Point, y=LinePoint1, z=LinePoint2)
	      if (x.length == 2 && y.length == 2 && z.length == 2){
	        if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
	        if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }
	        if (!_2d(z)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument'); }
	        var m = divide(subtract(z[1], z[0]), subtract(y[1], y[0]));
	        var xCoeff = multiply(multiply(m, m), y[0]);
	        var yCoeff = negate(multiply(m, y[0]));
	        var constant = x[1];
	
	        return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
	      }
	      else{
	        throw new TypeError('Invalid Arguments: Try again');
	      }
	    },
	    'Object, Object, Object': function(x, y, z){
	      if (Object.keys(x).length == 2 && Object.keys(y).length == 2 && Object.keys(z).length == 2){
	        if (!_2d(x)) { throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers'); }
	        if (!_2d(y)) { throw new TypeError('Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers'); }
	        if (!_2d(z)) { throw new TypeError('Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers'); }
	        if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('lineOnePtX') &&
	          y.hasOwnProperty('lineOnePtY') && z.hasOwnProperty('lineTwoPtX') && z.hasOwnProperty('lineTwoPtY')){
	          var m = divide(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
	          var xCoeff = multiply(multiply(m, m), y.lineOnePtX);
	          var yCoeff = negate(multiply(m, y.lineOnePtX));
	          var constant = x.pointX;
	
	          return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
	        }
	        else{
	          throw new TypeError('Key names do not match');
	        }
	      }
	      else{
	        throw new TypeError('Invalid Arguments: Try again');
	      }
	    },
	    'Array, Array': function(x, y){
	      // Point to Line 2D; (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
	      if (x.length == 2 && y.length == 3){
	        if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
	        if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
	
	        return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
	      }
	      // Point to Line 3D
	      else if (x.length == 3 && y.length == 6){
	        if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
	        if (!_parametricLine(y)) { throw new TypeError('Array with 6 numbers or BigNumbers expected for second argument'); }
	
	        return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
	      }
	      // Point to Point 2D
	      else if (x.length == 2 && y.length == 2){
	        if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
	        if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }
	
	        return _distance2d(x[0], x[1], y[0], y[1]);
	      }
	      // Point to Point 3D
	      else if(x.length == 3 && y.length == 3){
	        if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
	        if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
	
	        return _distance3d(x[0], x[1], x[2], y[0], y[1], y[2]);
	      }
	      else{
	        throw new TypeError('Invalid Arguments: Try again');
	      }
	    },
	    'Object, Object': function(x, y){
	      if (Object.keys(x).length == 2 && Object.keys(y).length == 3){
	        if (!_2d(x)) { throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers'); }
	        if (!_3d(y)) { throw new TypeError('Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers'); }
	        if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('xCoeffLine') &&
	          y.hasOwnProperty('yCoeffLine') && y.hasOwnProperty('constant')){
	
	          return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
	        }
	        else{
	          throw new TypeError('Key names do not match');
	        }
	      }
	      // Point to Line 3D
	      else if (Object.keys(x).length == 3 && Object.keys(y).length == 6){
	        if (!_3d(x)) { throw new TypeError('Values of pointX, pointY and pointZ should be numbers or BigNumbers'); }
	        if (!_parametricLine(y)) { throw new TypeError('Values of x0, y0, z0, a, b and c should be numbers or BigNumbers'); }
	        if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('x0') &&
	          y.hasOwnProperty('y0') && y.hasOwnProperty('z0') && y.hasOwnProperty('a') &&
	          y.hasOwnProperty('b') && y.hasOwnProperty('c')){
	
	          return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
	        }
	        else{
	          throw new TypeError('Key names do not match');
	        }
	      }
	      // Point to Point 2D
	      else if (Object.keys(x).length == 2 && Object.keys(y).length == 2){
	        if (!_2d(x)) { throw new TypeError('Values of pointOneX and pointOneY should be numbers or BigNumbers'); }
	        if (!_2d(y)) { throw new TypeError('Values of pointTwoX and pointTwoY should be numbers or BigNumbers'); }
	        if (x.hasOwnProperty('pointOneX') && x.hasOwnProperty('pointOneY') &&
	          y.hasOwnProperty('pointTwoX') && y.hasOwnProperty('pointTwoY')){
	
	          return _distance2d(x.pointOneX, x.pointOneY, y.pointTwoX, y.pointTwoY);
	        }
	        else{
	          throw new TypeError('Key names do not match');
	        }
	      }
	      // Point to Point 3D
	      else if(Object.keys(x).length == 3 && Object.keys(y).length == 3){
	        if (!_3d(x)) { throw new TypeError('Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers'); }
	        if (!_3d(y)) { throw new TypeError('Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers'); }
	        if (x.hasOwnProperty('pointOneX') && x.hasOwnProperty('pointOneY') && x.hasOwnProperty('pointOneZ') &&
	          y.hasOwnProperty('pointTwoX') && y.hasOwnProperty('pointTwoY') && y.hasOwnProperty('pointTwoZ')){
	
	          return _distance3d(x.pointOneX, x.pointOneY, x.pointOneZ, y.pointTwoX, y.pointTwoY, y.pointTwoZ);
	        }
	        else {
	          throw new TypeError('Key names do not match');
	        }
	      }
	      else{
	        throw new TypeError('Invalid Arguments: Try again');
	      }
	    },
	    'Array': function(arr){
	      if (!_pairwise(arr)) { throw new TypeError('Incorrect array format entered for pairwise distance calculation'); }
	
	      return _distancePairwise(arr);
	    }
	  });
	
	  function _isNumber(a) {
	    // distance supports numbers and bignumbers
	    return (typeof a === 'number' || type.isBigNumber(a));
	  }
	
	  function _2d(a){
	    // checks if the number of arguments are correct in count and are valid (should be numbers)
	    if (a.constructor !== Array){
	      a = _objectToArray(a);
	    }
	    return _isNumber(a[0]) && _isNumber(a[1]);
	  }
	
	  function _3d(a){
	    // checks if the number of arguments are correct in count and are valid (should be numbers)
	    if (a.constructor !== Array){
	      a = _objectToArray(a);
	    }
	    return _isNumber(a[0]) && _isNumber(a[1]) &&  _isNumber(a[2]);
	  }
	
	  function _parametricLine(a){
	    if (a.constructor !== Array){
	      a = _objectToArray(a);
	    }
	    return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) &&
	      _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
	  }
	
	  function _objectToArray(o){
	    var keys = Object.keys(o);
	    var a = [];
	    for (var i = 0; i < keys.length; i++) {
	      a.push(o[keys[i]]);
	    }
	    return a;
	  }
	
	  function _pairwise(a){
	    //checks for valid arguments passed to _distancePairwise(Array)
	    if (a[0].length == 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])){
	      for(var i in a){
	        if (a[i].length != 2 || !_isNumber(a[i][0]) || !_isNumber(a[i][1])){
	          return false;
	        }
	      }
	    }
	    else if (a[0].length == 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])){
	      for(var i in a){
	        if (a[i].length != 3 || !_isNumber(a[i][0]) || !_isNumber(a[i][1]) || !_isNumber(a[i][2])){
	          return false;
	        }
	      }
	    }
	    else{
	      return false;
	    }
	    return true;
	  }
	
	  function _distancePointLine2D(x, y, a, b, c){
	    var num =  abs(add(add(multiply(a, x), multiply(b, y)), c));
	    var den = sqrt(add(multiply(a, a), multiply(b, b)));
	    var result = divide(num, den);
	    return result;
	  }
	
	  function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c){
	    var num = [ subtract(multiply(subtract(y0, y), c), multiply(subtract(z0, z), b)),
	                subtract(multiply(subtract(z0, z), a), multiply(subtract(x0, x), c)),
	                subtract(multiply(subtract(x0, x), b), multiply(subtract(y0, y), a)) ];
	    num = sqrt(add(add(multiply(num[0], num[0]), multiply(num[1], num[1])), multiply(num[2], num[2])));
	    var den = sqrt(add(add(multiply(a, a), multiply(b, b)), multiply(c, c)));
	    var result = divide(num, den);
	    return result;
	  }
	
	  function _distance2d(x1, y1, x2, y2){
	    var yDiff = subtract(y2, y1);
	    var xDiff = subtract(x2, x1);
	    var radicant = add(multiply(yDiff, yDiff), multiply(xDiff, xDiff));
	    var result = sqrt(radicant);
	    return result;
	  }
	
	  function _distance3d(x1, y1, z1, x2, y2, z2){
	    var zDiff = subtract(z2, z1);
	    var yDiff = subtract(y2, y1);
	    var xDiff = subtract(x2, x1);
	    var radicant = add(add(multiply(zDiff, zDiff), multiply(yDiff, yDiff)), multiply(xDiff, xDiff));
	    var result = sqrt(radicant);
	    return result;
	  }
	
	  function _distancePairwise(a){
	    var result = [];
	    for(var i = 0; i < a.length-1; i++){
	      for(var j = i+1; j < a.length; j++){
	        if (a[0].length == 2){
	          result.push(_distance2d(a[i][0], a[i][1], a[j][0], a[j][1]));
	        }
	        else if (a[0].length == 3){
	          result.push(_distance3d(a[i][0], a[i][1], a[i][2], a[j][0], a[j][1], a[j][2]));
	        }
	      }
	    }
	    return result;
	  }
	
	  return distance;
	}
	
	exports.name = 'distance';
	exports.factory = factory;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1783),
	  __webpack_require__(1784),
	  __webpack_require__(1785),
	  __webpack_require__(1786)
	];


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	  var zeros = load(__webpack_require__(1405));
	  var not = load(__webpack_require__(1784));
	  var isZero = load(__webpack_require__(1686));
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm06 = load(__webpack_require__(1737));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.and(x, y)
	   *
	   * Examples:
	   *
	   *    math.and(2, 4);   // returns true
	   *
	   *    a = [2, 0, 0];
	   *    b = [3, 7, 0];
	   *    c = 0;
	   *
	   *    math.and(a, b);   // returns [true, false, false]
	   *    math.and(a, c);   // returns [false, false, false]
	   *
	   * See also:
	   *
	   *    not, or, xor
	   *
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
	   * @return {boolean | Array | Matrix}
	   *            Returns true when both inputs are defined with a nonzero/nonempty value.
	   */
	  var and = typed('and', {
	
	    'number, number': function (x, y) {
	      return !!(x && y);
	    },
	
	    'Complex, Complex': function (x, y) {
	      return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
	    },
	
	    'Unit, Unit': function (x, y) {
	      return and(x.value || 0, y.value || 0);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm06(x, y, and, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm02(y, x, and, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm02(x, y, and, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, and);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return and(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return and(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return and(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      // check scalar
	      if (not(y)) {
	        // return zero matrix
	        return zeros(x.size(), x.storage());
	      }
	      return algorithm11(x, y, and, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      // check scalar
	      if (not(y)) {
	        // return zero matrix
	        return zeros(x.size(), x.storage());
	      }
	      return algorithm14(x, y, and, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      // check scalar
	      if (not(x)) {
	        // return zero matrix
	        return zeros(x.size(), x.storage());
	      }
	      return algorithm11(y, x, and, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      // check scalar
	      if (not(x)) {
	        // return zero matrix
	        return zeros(x.size(), x.storage());
	      }
	      return algorithm14(y, x, and, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return and(matrix(x), y).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return and(x, matrix(y)).valueOf();
	    }
	  });
	
	  and.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['and'] + '${args[1]}\\right)'
	  };
	
	  return and;
	}
	
	exports.name = 'and';
	exports.factory = factory;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Logical `not`. Flips boolean value of a given parameter.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.not(x)
	   *
	   * Examples:
	   *
	   *    math.not(2);      // returns false
	   *    math.not(0);      // returns true
	   *    math.not(true);   // returns false
	   *
	   *    a = [2, -7, 0];
	   *    math.not(a);      // returns [false, false, true]
	   *
	   * See also:
	   *
	   *    and, or, xor
	   *
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
	   * @return {boolean | Array | Matrix}
	   *            Returns true when input is a zero or empty value.
	   */
	  var not = typed('not', {
	    'number': function (x) {
	      return !x;
	    },
	
	    'Complex': function (x) {
	      return x.re === 0 && x.im === 0;
	    },
	
	    'BigNumber': function (x) {
	      return x.isZero() || x.isNaN();
	    },
	
	    'Unit': function (x) {
	      return x.value !== null ? not(x.value) : true;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, not);
	    }
	  });
	
	  not.toTex = {
	    1: latex.operators['not'] + '\\left(${args[0]}\\right)'
	  };
	
	  return not;
	}
	
	exports.name = 'not';
	exports.factory = factory;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm05 = load(__webpack_require__(1395));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.or(x, y)
	   *
	   * Examples:
	   *
	   *    math.or(2, 4);   // returns true
	   *
	   *    a = [2, 5, 0];
	   *    b = [0, 22, 0];
	   *    c = 0;
	   *
	   *    math.or(a, b);   // returns [true, true, false]
	   *    math.or(b, c);   // returns [false, true, false]
	   *
	   * See also:
	   *
	   *    and, not, xor
	   *
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
	   * @return {boolean | Array | Matrix}
	   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
	   */
	  var or = typed('or', {
	
	    'number, number': function (x, y) {
	      return !!(x || y);
	    },
	
	    'Complex, Complex': function (x, y) {
	      return (x.re !== 0 || x.im !== 0) || (y.re !== 0 || y.im !== 0);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return (!x.isZero() && !x.isNaN()) || (!y.isZero() && !y.isNaN());
	    },
	
	    'Unit, Unit': function (x, y) {
	      return or(x.value || 0, y.value || 0);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm05(x, y, or);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, or, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, or, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, or);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return or(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return or(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return or(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, or, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, or, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, or, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, or, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, or, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, or, true).valueOf();
	    }
	  });
	
	  or.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['or'] + '${args[1]}\\right)'
	  };
	
	  return or;
	}
	
	exports.name = 'or';
	exports.factory = factory;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.xor(x, y)
	   *
	   * Examples:
	   *
	   *    math.xor(2, 4);   // returns false
	   *
	   *    a = [2, 0, 0];
	   *    b = [2, 7, 0];
	   *    c = 0;
	   *
	   *    math.xor(a, b);   // returns [false, true, false]
	   *    math.xor(a, c);   // returns [true, false, false]
	   *
	   * See also:
	   *
	   *    and, not, or
	   *
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
	   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
	   * @return {boolean | Array | Matrix}
	   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
	   */
	  var xor = typed('xor', {
	 
	    'number, number': function (x, y) {
	      return !!x !== !!y;
	    },
	
	    'Complex, Complex': function (x, y) {
	      return ((x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0));
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return ((!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN()));
	    },
	
	    'Unit, Unit': function (x, y) {
	      return xor(x.value || 0, y.value || 0);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, xor);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, xor, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, xor, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, xor);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return xor(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return xor(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return xor(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, xor, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, xor, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, xor, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, xor, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, xor, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, xor, true).valueOf();
	    }
	  });
	
	  xor.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['xor'] + '${args[1]}\\right)'
	  };
	
	  return xor;
	}
	
	exports.name = 'xor';
	exports.factory = factory;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1654),
	  __webpack_require__(1788),
	  __webpack_require__(1671),
	  __webpack_require__(1789),
	  __webpack_require__(1790),
	  __webpack_require__(1399),
	  __webpack_require__(1791),
	  __webpack_require__(1792),
	  __webpack_require__(1793),
	  __webpack_require__(1794),
	  __webpack_require__(1670),
	  __webpack_require__(1795),
	  __webpack_require__(1796),
	  __webpack_require__(1797),
	  __webpack_require__(1798),
	  __webpack_require__(1676),
	  __webpack_require__(1800),
	  __webpack_require__(1801),
	  __webpack_require__(1802),
	  __webpack_require__(1803),
	  __webpack_require__(1806),
	  __webpack_require__(1807),
	  __webpack_require__(1630),
	  __webpack_require__(1745),
	  __webpack_require__(1702),
	  __webpack_require__(1405)
	];


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var matrix   = load(__webpack_require__(1368));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1400));
	
	  /**
	   * Calculate the cross product for two vectors in three dimensional space.
	   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
	   * as:
	   *
	   *    cross(A, B) = [
	   *      a2 * b3 - a3 * b2,
	   *      a3 * b1 - a1 * b3,
	   *      a1 * b2 - a2 * b1
	   *    ]
	   *
	   * If one of the input vectors has a dimension greater than 1, the output
	   * vector will be a 1x3 (2-dimensional) matrix.
	   *
	   * Syntax:
	   *
	   *    math.cross(x, y)
	   *
	   * Examples:
	   *
	   *    math.cross([1, 1, 0],   [0, 1, 1]);       // Returns [1, -1, 1]
	   *    math.cross([3, -3, 1],  [4, 9, 2]);       // Returns [-15, -2, 39]
	   *    math.cross([2, 3, 4],   [5, 6, 7]);       // Returns [-3, 6, -3]
	   *    math.cross([[1, 2, 3]], [[4], [5], [6]]); // Returns [[-3, 6, -3]]
	   *
	   * See also:
	   *
	   *    dot, multiply
	   *
	   * @param  {Array | Matrix} x   First vector
	   * @param  {Array | Matrix} y   Second vector
	   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
	   */
	  var cross = typed('cross', {
	    'Matrix, Matrix': function (x, y) {
	      return matrix(_cross(x.toArray(), y.toArray()));
	    },
	
	    'Matrix, Array': function (x, y) {
	      return matrix(_cross(x.toArray(), y));
	    },
	
	    'Array, Matrix': function (x, y) {
	      return matrix(_cross(x, y.toArray()));
	    },
	
	    'Array, Array': _cross
	  });
	
	  cross.toTex = {
	    2: '\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)'
	  };
	
	  return cross;
	
	  /**
	   * Calculate the cross product for two arrays
	   * @param {Array} x  First vector
	   * @param {Array} y  Second vector
	   * @returns {Array} Returns the cross product of x and y
	   * @private
	   */
	  function _cross(x, y) {
	    var highestDimension = Math.max(array.size(x).length, array.size(y).length);
	
	    x = array.squeeze(x);
	    y = array.squeeze(y);
	
	    var xSize = array.size(x);
	    var ySize = array.size(y);
	
	    if (xSize.length != 1 || ySize.length != 1 || xSize[0] != 3 || ySize[0] != 3) {
	      throw new RangeError('Vectors with length 3 expected ' +
	      '(Size A = [' + xSize.join(', ') + '], B = [' + ySize.join(', ') + '])');
	    }
	
	    var product = [
	      subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
	      subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
	      subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
	    ];
	
	    if (highestDimension > 1) {
	      return [product];
	    } else {
	      return product;
	    }
	  }
	}
	
	exports.name = 'cross';
	exports.factory = factory;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var array     = __webpack_require__(1357);
	var clone     = __webpack_require__(1320).clone;
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  
	  /**
	   * Create a diagonal matrix or retrieve the diagonal of a matrix
	   *
	   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
	   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
	   * When k is positive, the values are placed on the super diagonal.
	   * When k is negative, the values are placed on the sub diagonal.
	   *
	   * Syntax:
	   *
	   *     math.diag(X)
	   *     math.diag(X, format)
	   *     math.diag(X, k)
	   *     math.diag(X, k, format)
	   *
	   * Examples:
	   *
	   *     // create a diagonal matrix
	   *     math.diag([1, 2, 3]);      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
	   *     math.diag([1, 2, 3], 1);   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
	   *     math.diag([1, 2, 3], -1);  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
	   *
	   *    // retrieve the diagonal from a matrix
	   *    var a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]];
	   *    math.diag(a);   // returns [1, 5, 9]
	   *
	   * See also:
	   *
	   *     ones, zeros, eye
	   *
	   * @param {Matrix | Array} x          A two dimensional matrix or a vector
	   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
	   *                                    in or retrieved.
	   * @param {string} [format='dense']   The matrix storage format.
	   *
	   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
	   */
	  var diag = typed('diag', {
	    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
	
	    'Array': function (x) {
	      return _diag(x, 0, array.size(x), null);
	    },
	
	    'Array, number': function (x, k) {
	      return _diag(x, k, array.size(x), null);
	    },
	    
	    'Array, BigNumber': function (x, k) {
	      return _diag(x, k.toNumber(), array.size(x), null);
	    },
	
	    'Array, string': function (x, format) {
	      return _diag(x, 0, array.size(x), format);
	    },
	
	    'Array, number, string': function (x, k, format) {
	      return _diag(x, k, array.size(x), format);
	    },
	
	    'Array, BigNumber, string': function (x, k, format) {
	      return _diag(x, k.toNumber(), array.size(x), format);
	    },
	
	    'Matrix': function (x) {
	      return _diag(x, 0, x.size(), x.storage());
	    },
	
	    'Matrix, number': function (x, k) {
	      return _diag(x, k, x.size(), x.storage());
	    },
	
	    'Matrix, BigNumber': function (x, k) {
	      return _diag(x, k.toNumber(), x.size(), x.storage());
	    },
	
	    'Matrix, string': function (x, format) {
	      return _diag(x, 0, x.size(), format);
	    },
	
	    'Matrix, number, string': function (x, k, format) {
	      return _diag(x, k, x.size(), format);
	    },
	
	    'Matrix, BigNumber, string': function (x, k, format) {
	      return _diag(x, k.toNumber(), x.size(), format);
	    }
	  });
	
	  diag.toTex = undefined; // use default template
	
	  return diag;
	
	  /**
	   * Creeate diagonal matrix from a vector or vice versa
	   * @param {Array | Matrix} x
	   * @param {number} k
	   * @param {string} format Storage format for matrix. If null,
	   *                          an Array is returned
	   * @returns {Array | Matrix}
	   * @private
	   */
	  function _diag (x, k, size, format) {
	    if (!isInteger(k)) {
	      throw new TypeError ('Second parameter in function diag must be an integer');
	    }
	    
	    var kSuper = k > 0 ? k : 0;
	    var kSub = k < 0 ? -k : 0;
	
	    // check dimensions
	    switch (size.length) {
	      case 1:
	        return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
	      case 2:
	        return _getDiagonal(x, k, format, size, kSub, kSuper);
	    }
	    throw new RangeError('Matrix for function diag must be 2 dimensional');
	  }
	  
	  function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
	    // matrix size
	    var ms = [l + kSub, l + kSuper];
	    // get matrix constructor
	    var F = type.Matrix.storage(format || 'dense');
	    // create diagonal matrix
	    var m = F.diagonal(ms, x, k);
	    // check we need to return a matrix
	    return format !== null ? m : m.valueOf();
	  }
	  
	  function _getDiagonal(x, k, format, s, kSub, kSuper) {
	    // check x is a Matrix
	    if (type.isMatrix(x)) {
	      // get diagonal matrix
	      var dm = x.diagonal(k);
	      // check we need to return a matrix
	      if (format !== null) {
	        // check we need to change matrix format
	        if (format !== dm.storage())
	          return matrix(dm, format);
	        return dm;
	      }
	      return dm.valueOf();
	    }
	    // vector size
	    var n = Math.min(s[0] - kSub, s[1] - kSuper);
	    // diagonal values
	    var vector = [];
	    // loop diagonal
	    for (var i = 0; i < n; i++) {
	      vector[i] = x[i + kSub][i + kSuper];
	    }
	    // check we need to return a matrix
	    return format !== null ? matrix(vector) : vector;
	  }
	}
	
	exports.name = 'diag';
	exports.factory = factory;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var size = __webpack_require__(1357).size;
	
	function factory (type, config, load, typed) {
	  var add      = load(__webpack_require__(1367));
	  var multiply = load(__webpack_require__(1400));
	
	  /**
	   * Calculate the dot product of two vectors. The dot product of
	   * `A = [a1, a2, a3, ..., an]` and `B = [b1, b2, b3, ..., bn]` is defined as:
	   *
	   *    dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn
	   *
	   * Syntax:
	   *
	   *    math.dot(x, y)
	   *
	   * Examples:
	   *
	   *    math.dot([2, 4, 1], [2, 2, 3]);       // returns number 15
	   *    math.multiply([2, 4, 1], [2, 2, 3]);  // returns number 15
	   *
	   * See also:
	   *
	   *    multiply, cross
	   *
	   * @param  {Array | Matrix} x     First vector
	   * @param  {Array | Matrix} y     Second vector
	   * @return {number}               Returns the dot product of `x` and `y`
	   */
	  var dot = typed('dot', {
	    'Matrix, Matrix': function (x, y) {
	      return _dot(x.toArray(), y.toArray());
	    },
	
	    'Matrix, Array': function (x, y) {
	      return _dot(x.toArray(), y);
	    },
	
	    'Array, Matrix': function (x, y) {
	      return _dot(x, y.toArray());
	    },
	
	    'Array, Array': _dot
	  });
	  
	  dot.toTex = {2: '\\left(${args[0]}\\cdot${args[1]}\\right)'};
	
	  return dot;
	
	  /**
	   * Calculate the dot product for two arrays
	   * @param {Array} x  First vector
	   * @param {Array} y  Second vector
	   * @returns {number} Returns the dot product of x and y
	   * @private
	   */
	  // TODO: double code with math.multiply
	  function _dot(x, y) {
	    var xSize= size(x);
	    var ySize = size(y);
	    var len = xSize[0];
	
	    if (xSize.length !== 1 || ySize.length !== 1) throw new RangeError('Vector expected'); // TODO: better error message
	    if (xSize[0] != ySize[0]) throw new RangeError('Vectors must have equal length (' + xSize[0] + ' != ' + ySize[0] + ')');
	    if (len == 0) throw new RangeError('Cannot calculate the dot product of empty vectors');
	
	    var prod = 0;
	    for (var i = 0; i < len; i++) {
	      prod = add(prod, multiply(x[i], y[i]));
	    }
	
	    return prod;
	  }
	}
	
	exports.name = 'dot';
	exports.factory = factory;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var format = __webpack_require__(1341).format;
	
	function factory (type, config, load, typed) {
	
	  var abs = load(__webpack_require__(1402));
	  var add = load(__webpack_require__(1367));
	  var eye = load(__webpack_require__(1399));
	  var inv = load(__webpack_require__(1670));
	  var multiply = load(__webpack_require__(1400));
	
	  var SparseMatrix = type.SparseMatrix;
	
	  /**
	   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
	   * Not to be confused with exp(a), which performs element-wise
	   * exponentiation.
	   *
	   * The exponential is calculated using the Padé approximant with scaling and
	   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
	   * Matrix," by Moler and Van Loan.
	   *
	   * Syntax:
	   *
	   *     math.expm(x)
	   *
	   * Examples:
	   *
	   *     var A = [[0,2],[0,0]]
	   *     math.expm(A);        // returns [[1,2],[0,1]]
	   *
	   * See also:
	   *
	   *     exp
	   *
	   * @param {Matrix} x  A square Matrix
	   * @return {Matrix}   The exponential of x
	   */
	  var expm = typed('expm', {
	
	    'Matrix': function (A) {
	
	      // Check matrix size
	      var size = A.size();
	      
	      if(size.length !== 2 || size[0] !== size[1]) {
	        throw new RangeError('Matrix must be square ' +
	          '(size: ' + format(size) + ')');
	      }
	      
	      var n = size[0];
	
	      // Desired accuracy of the approximant (The actual accuracy
	      // will be affected by round-off error)
	      var eps = 1e-15;
	      
	      // The Padé approximant is not so accurate when the values of A
	      // are "large", so scale A by powers of two. Then compute the
	      // exponential, and square the result repeatedly according to
	      // the identity e^A = (e^(A/m))^m 
	      
	      // Compute infinity-norm of A, ||A||, to see how "big" it is
	      var infNorm = infinityNorm(A);
	      
	      // Find the optimal scaling factor and number of terms in the 
	      // Padé approximant to reach the desired accuracy
	      var params = findParams(infNorm, eps);
	      var q = params.q;
	      var j = params.j;
	      
	      // The Pade approximation to e^A is:
	      // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
	      // where
	      // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
	      // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
	     
	      // Scale A by 1 / 2^j
	      var Apos = multiply(A, Math.pow(2, -j));
	     
	      // The i=0 term is just the identity matrix
	      var N = eye(n);
	      var D = eye(n);
	     
	      // Initialization (i=0)
	      var factor = 1;
	     
	      // Initialization (i=1)
	      var Apos_to_i = Apos; // Cloning not necessary
	      var alternate = -1;
	     
	      for(var i=1; i<=q; i++) {
	        if(i>1) {
	          Apos_to_i = multiply(Apos_to_i, Apos);
	          alternate = -alternate;
	        }
	        factor = factor*(q-i+1)/((2*q-i+1)*i);
	        
	        N = add(N, multiply(factor, Apos_to_i));
	        D = add(D, multiply(factor*alternate, Apos_to_i));
	      }
	      
	      var R = multiply(inv(D), N);      
	      
	      // Square j times
	      for(var i=0; i<j; i++) {
	        R = multiply(R, R);
	      }
	
	      return type.isSparseMatrix(A)
	          ? new SparseMatrix(R)
	          : R;
	    }
	    
	  });
	  
	  function infinityNorm(A) {
	    var n = A.size()[0];  
	    var infNorm = 0;  
	    for(var i=0; i<n; i++) {
	      var rowSum = 0;
	      for(var j=0; j<n; j++) {
	        rowSum += abs(A.get([i,j]));
	      }
	      infNorm = Math.max(rowSum, infNorm);
	    }
	    return infNorm;
	  }
	
	  /**
	   * Find the best parameters for the Pade approximant given
	   * the matrix norm and desired accuracy. Returns the first acceptable
	   * combination in order of increasing computational load.
	   */
	  function findParams(infNorm, eps) {
	    var maxSearchSize = 30;
	    for(var k=0; k<maxSearchSize; k++) {
	      for(var q=0; q<=k; q++) {
	        var j = k - q;
	        if(errorEstimate(infNorm, q, j) < eps) {
	          return {q: q, j: j};
	        }
	      }
	    }
	    throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
	  }
	  
	  /**
	   * Returns the estimated error of the Pade approximant for the given
	   * parameters.
	   */
	  function errorEstimate(infNorm, q, j) {
	    
	    var qfac = 1;
	    for(var i=2; i<=q; i++) {
	      qfac *= i;
	    }
	    var twoqfac = qfac;
	    for(var i=q+1; i<=2*q; i++) {
	      twoqfac *= i;
	    }
	    var twoqp1fac = twoqfac * (2*q+1);
	    
	    return 8.0 *
	      Math.pow(infNorm / Math.pow(2, j), 2*q) *
	      qfac*qfac / (twoqfac*twoqp1fac);
	  }
	  
	  expm.toTex = {1: '\\exp\\left(${args[0]}\\right)'};
	
	  return expm;
	}
	
	exports.name = 'expm';
	exports.factory = factory;


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var filter = __webpack_require__(1357).filter;
	var filterRegExp = __webpack_require__(1357).filterRegExp;
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  
	  /**
	   * Filter the items in an array or one dimensional matrix.
	   *
	   * Syntax:
	   *
	   *    math.filter(x, test)
	   *
	   * Examples:
	   *
	   *    function isPositive (x) {
	   *      return x > 0;
	   *    }
	   *    math.filter([6, -2, -1, 4, 3], isPositive); // returns [6, 4, 3]
	   *
	   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/); // returns ["23", "100", "55"]
	   *
	   * See also:
	   *
	   *    forEach, map, sort
	   *
	   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
	   * @param {Function | RegExp} test
	   *        A function or regular expression to test items.
	   *        All entries for which `test` returns true are returned.
	   *        When `test` is a function, it is invoked with three parameters:
	   *        the value of the element, the index of the element, and the
	   *        matrix/array being traversed. The function must return a boolean.
	   * @return {Matrix | Array} Returns the filtered matrix.
	   */
	  var filter = typed('filter', {
	    'Array, function': _filterCallback,
	
	    'Matrix, function': function (x, test) {
	      return matrix(_filterCallback(x.toArray(), test));
	    },
	
	    'Array, RegExp': filterRegExp,
	
	    'Matrix, RegExp': function (x, test) {
	      return matrix(filterRegExp(x.toArray(), test));
	    }
	  });
	
	  filter.toTex = undefined; // use default template
	
	  return filter;
	}
	
	/**
	 * Filter values in a callback given a callback function
	 * @param {Array} x
	 * @param {Function} callback
	 * @return {Array} Returns the filtered array
	 * @private
	 */
	function _filterCallback (x, callback) {
	  // figure out what number of arguments the callback function expects
	  var args = maxArgumentCount(callback);
	
	  return filter(x, function (value, index, array) {
	    // invoke the callback function with the right number of arguments
	    if (args === 1) {
	      return callback(value);
	    }
	    else if (args === 2) {
	      return callback(value, [index]);
	    }
	    else { // 3 or -1
	      return callback(value, [index], array);
	    }
	  });
	}
	
	exports.name = 'filter';
	exports.factory = factory;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var clone = __webpack_require__(1320).clone;
	var _flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Flatten a multi dimensional matrix into a single dimensional matrix.
	   *
	   * Syntax:
	   *
	   *    math.flatten(x)
	   *
	   * Examples:
	   *
	   *    math.flatten([[1,2], [3,4]]);   // returns [1, 2, 3, 4]
	   *
	   * See also:
	   *
	   *    concat, resize, size, squeeze
	   *
	   * @param {Matrix | Array} x   Matrix to be flattened
	   * @return {Matrix | Array} Returns the flattened matrix
	   */
	  var flatten = typed('flatten', {
	    'Array': function (x) {
	      return _flatten(clone(x));
	    },
	
	    'Matrix': function (x) {
	      var flat = _flatten(clone(x.toArray()));
	      // TODO: return the same matrix type as x
	      return matrix(flat);
	    }
	  });
	
	  flatten.toTex = undefined; // use default template
	
	  return flatten;
	}
	
	exports.name = 'flatten';
	exports.factory = factory;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	var forEach = __webpack_require__(1357).forEach;
	
	function factory (type, config, load, typed) {
	  /**
	   * Iterate over all elements of a matrix/array, and executes the given callback function.
	   *
	   * Syntax:
	   *
	   *    math.forEach(x, callback)
	   *
	   * Examples:
	   *
	   *    math.forEach([1, 2, 3], function(value) {
	   *      console.log(value);
	   *    });
	   *    // outputs 1, 2, 3
	   *
	   * See also:
	   *
	   *    filter, map, sort
	   *
	   * @param {Matrix | Array} x    The matrix to iterate on.
	   * @param {Function} callback   The callback function is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the Matrix/array being traversed.
	   */
	  var forEach = typed('forEach', {
	    'Array, function': _forEach,
	
	    'Matrix, function': function (x, callback) {
	      return x.forEach(callback);
	    }
	  });
	
	  forEach.toTex = undefined; // use default template
	
	  return forEach;
	}
	
	/**
	 * forEach for a multi dimensional array
	 * @param {Array} array
	 * @param {Function} callback
	 * @private
	 */
	function _forEach (array, callback) {
	  // figure out what number of arguments the callback function expects
	  var args = maxArgumentCount(callback);
	
	  var recurse = function (value, index) {
	    if (Array.isArray(value)) {
	      forEach(value, function (child, i) {
	        // we create a copy of the index array and append the new index value
	        recurse(child, index.concat(i));
	      });
	    }
	    else {
	      // invoke the callback function with the right number of arguments
	      if (args === 1) {
	        callback(value);
	      }
	      else if (args === 2) {
	        callback(value, index);
	      }
	      else { // 3 or -1
	        callback(value, index, array);
	      }
	    }
	  };
	  recurse(array, []);
	}
	
	exports.name = 'forEach';
	exports.factory = factory;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var size = __webpack_require__(1357).size;
	
	function factory(type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  var multiplyScalar = load(__webpack_require__(1396))
	    /**
	     * Calculates the kronecker product of 2 matrices or vectors.
	     *
	     * NOTE: If a one dimensional vector / matrix is given, it will be
	     * wrapped so its two dimensions.
	     * See the examples.
	     *
	     * Syntax:
	     *
	     *    math.kron(x, y)
	     *
	     * Examples:
	     *
	     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]]);
	     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
	     *
	     *    math.kron([1,1], [2,3,4]);
	     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
	     *
	     * See also:
	     *
	     *    multiply, dot, cross
	     *
	     * @param  {Array | Matrix} x     First vector
	     * @param  {Array | Matrix} y     Second vector
	     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
	     */
	    var kron = typed('kron', {
	        'Matrix, Matrix': function(x, y) {
	            return matrix(_kron(x.toArray(), y.toArray()));
	        },
	
	        'Matrix, Array': function(x, y) {
	            return matrix(_kron(x.toArray(), y));
	        },
	
	        'Array, Matrix': function(x, y) {
	            return matrix(_kron(x, y.toArray()));
	        },
	
	        'Array, Array': _kron
	    });
	
	    return kron;
	
	    /**
	     * Calculate the kronecker product of two matrices / vectors
	     * @param {Array} a  First vector
	     * @param {Array} b  Second vector
	     * @returns {Array} Returns the kronecker product of x and y
	     * @private
	     */
	    function _kron(a, b) {
	        // Deal with the dimensions of the matricies.
	        if (size(a).length === 1) {
	          // Wrap it in a 2D Matrix
	          a = [a];
	        }
	        if (size(b).length === 1) {
	          // Wrap it in a 2D Matrix
	          b = [b]
	        }
	        if (size(a).length > 2 || size(b).length > 2) {
	            throw new RangeError('Vectors with dimensions greater then 2 are not supported expected ' +
	            '(Size x = ' + JSON.stringify(a.length) + ', y = ' + JSON.stringify(b.length) + ')');
	        }
	        var t = [];
	        var r = [];
	
	        return a.map(function(a) {
	            return b.map(function(b) {
	                return a.map(function(y) {
	                    return b.map(function(x) {
	                        return r.push(multiplyScalar(y, x));
	                    });
	                }, t.push(r = []));
	            });
	        }, t = []) && t;
	    }
	}
	
	exports.name = 'kron';
	exports.factory = factory;


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var maxArgumentCount = __webpack_require__(1361).maxArgumentCount;
	
	function factory (type, config, load, typed) {
	  /**
	   * Create a new matrix or array with the results of the callback function executed on
	   * each entry of the matrix/array.
	   *
	   * Syntax:
	   *
	   *    math.map(x, callback)
	   *
	   * Examples:
	   *
	   *    math.map([1, 2, 3], function(value) {
	   *      return value * value;
	   *    });  // returns [1, 4, 9]
	   *
	   * See also:
	   *
	   *    filter, forEach, sort
	   *
	   * @param {Matrix | Array} x    The matrix to iterate on.
	   * @param {Function} callback   The callback method is invoked with three
	   *                              parameters: the value of the element, the index
	   *                              of the element, and the matrix being traversed.
	   * @return {Matrix | array}     Transformed map of x
	   */
	  var map = typed('map', {
	    'Array, function': _map,
	
	    'Matrix, function': function (x, callback) {
	      return x.map(callback);
	    }
	  });
	
	  map.toTex = undefined; // use default template
	
	  return map;
	}
	
	/**
	 * Map for a multi dimensional array
	 * @param {Array} array
	 * @param {Function} callback
	 * @return {Array}
	 * @private
	 */
	function _map (array, callback) {
	  // figure out what number of arguments the callback function expects
	  var args = maxArgumentCount(callback);
	
	  var recurse = function (value, index) {
	    if (Array.isArray(value)) {
	      return value.map(function (child, i) {
	        // we create a copy of the index array and append the new index value
	        return recurse(child, index.concat(i));
	      });
	    }
	    else {
	      // invoke the callback function with the right number of arguments
	      if (args === 1) {
	        return callback(value);
	      }
	      else if (args === 2) {
	        return callback(value, index);
	      }
	      else { // 3 or -1
	        return callback(value, index, array);
	      }
	    }
	  };
	
	  return recurse(array, []);
	}
	
	exports.name = 'map';
	exports.factory = factory;


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var resize = __webpack_require__(1357).resize;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Create a matrix filled with ones. The created matrix can have one or
	   * multiple dimensions.
	   *
	   * Syntax:
	   *
	   *    math.ones(m)
	   *    math.ones(m, format)
	   *    math.ones(m, n)
	   *    math.ones(m, n, format)
	   *    math.ones([m, n])
	   *    math.ones([m, n], format)
	   *    math.ones([m, n, p, ...])
	   *    math.ones([m, n, p, ...], format)
	   *
	   * Examples:
	   *
	   *    math.ones(3);                   // returns [1, 1, 1]
	   *    math.ones(3, 2);                // returns [[1, 1], [1, 1], [1, 1]]
	   *    math.ones(3, 2, 'dense');       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
	   *
	   *    var A = [[1, 2, 3], [4, 5, 6]];
	   *    math.ones(math.size(A));       // returns [[1, 1, 1], [1, 1, 1]]
	   *
	   * See also:
	   *
	   *    zeros, eye, size, range
	   *
	   * @param {...number | Array} size    The size of each dimension of the matrix
	   * @param {string} [format]           The Matrix storage format
	   *
	   * @return {Array | Matrix | number}  A matrix filled with ones
	   */
	  var ones = typed('ones', {
	    '': function () {
	      return (config.matrix === 'Array')
	          ? _ones([])
	          : _ones([], 'default');
	    },
	
	    // math.ones(m, n, p, ..., format)
	    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
	    '...number | BigNumber | string': function (size) {
	      var last = size[size.length - 1];
	      if (typeof last === 'string') {
	        var format = size.pop();
	        return _ones(size, format);
	      }
	      else if (config.matrix === 'Array') {
	        return _ones(size);
	      }
	      else {
	        return _ones(size, 'default');
	      }
	    },
	
	    'Array': _ones,
	
	    'Matrix': function (size) {
	      var format = size.storage();
	      return _ones(size.valueOf(), format);
	    },
	
	    'Array | Matrix, string': function (size, format) {
	      return _ones (size.valueOf(), format);
	    }
	  });
	
	  ones.toTex = undefined; // use default template
	
	  return ones;
	
	  /**
	   * Create an Array or Matrix with ones
	   * @param {Array} size
	   * @param {string} [format='default']
	   * @return {Array | Matrix}
	   * @private
	   */
	  function _ones(size, format) {
	    var hasBigNumbers = _normalize(size);
	    var defaultValue = hasBigNumbers ? new type.BigNumber(1) : 1;
	    _validate(size);
	
	    if (format) {
	      // return a matrix
	      var m = matrix(format);
	      if (size.length > 0) {
	        return m.resize(size, defaultValue);
	      }
	      return m;
	    }
	    else {
	      // return an Array
	      var arr = [];
	      if (size.length > 0) {
	        return resize(arr, size, defaultValue);
	      }
	      return arr;
	    }
	  }
	
	  // replace BigNumbers with numbers, returns true if size contained BigNumbers
	  function _normalize(size) {
	    var hasBigNumbers = false;
	    size.forEach(function (value, index, arr) {
	      if (type.isBigNumber(value)) {
	        hasBigNumbers = true;
	        arr[index] = value.toNumber();
	      }
	    });
	    return hasBigNumbers;
	  }
	
	  // validate arguments
	  function _validate (size) {
	    size.forEach(function (value) {
	      if (typeof value !== 'number' || !isInteger(value) || value < 0) {
	        throw new Error('Parameters in function ones must be positive integers');
	      }
	    });
	  }
	}
	
	exports.name = 'ones';
	exports.factory = factory;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var asc = load(__webpack_require__(1799));
	  function desc(a, b) {
	    return -asc(a, b);
	  }
	
	  /**
	   * Partition-based selection of an array or 1D matrix.
	   * Will find the kth smallest value, and mutates the input array.
	   * Uses Quickselect.
	   *
	   * Syntax:
	   *
	   *    math.partitionSelect(x, k)
	   *    math.partitionSelect(x, k, compare)
	   *
	   * Examples:
	   *
	   *    math.partitionSelect([5, 10, 1], 2);           // returns 10
	   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1); // returns 'B'
	   *
	   *    function sortByLength (a, b) {
	   *      return a.length - b.length;
	   *    }
	   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength); // returns 'Langdon'
	   *
	   * See also:
	   *
	   *    sort
	   *
	   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
	   * @param {Number} k            The kth smallest value to be retrieved; zero-based index
	   * @param {Function | 'asc' | 'desc'} [compare='asc']
	   *        An optional comparator function. The function is called as
	   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
	   *        and 0 when a == b.
	   * @return {*} Returns the kth lowest value.
	   */
	  return typed('partitionSelect', {
	    'Array | Matrix, number': function (x, k) {
	      return _partitionSelect(x, k, asc);
	    },
	
	    'Array | Matrix, number, string': function (x, k, compare) {
	      if (compare === 'asc') {
	        return _partitionSelect(x, k, asc);
	      }
	      else if (compare === 'desc') {
	        return _partitionSelect(x, k, desc);
	      }
	      else {
	        throw new Error('Compare string must be "asc" or "desc"');
	      }
	    },
	
	    'Array | Matrix, number, function': _partitionSelect
	  });
	
	  function _partitionSelect(x, k, compare) {
	    if (!isInteger(k) || k < 0) {
	      throw new Error('k must be a non-negative integer');
	    }
	
	    if (type.isMatrix(x)) {
	      var size = x.size();
	      if (size.length > 1) {
	        throw new Error('Only one dimensional matrices supported');
	      }
	      return quickSelect(x.valueOf(), k, compare);
	    }
	
	    if (Array.isArray(x)) {
	      return quickSelect(x, k, compare);
	    }
	  }
	
	  /**
	   * Quickselect algorithm.
	   * Code adapted from:
	   * http://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
	   *
	   * @param {Array} arr
	   * @param {Number} k
	   * @param {Function} compare
	   * @private
	   */
	  function quickSelect(arr, k, compare) {
	    if (k >= arr.length) {
	      throw new Error('k out of bounds');
	    }
	
	    var from = 0;
	    var to = arr.length - 1;
	
	    // if from == to we reached the kth element
	    while (from < to) {
	      var r = from;
	      var w = to;
	      var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from];
	
	      // stop if the reader and writer meets
	      while (r < w) {
	        // arr[r] >= pivot
	        if (compare(arr[r], pivot) >= 0) { // put the large values at the end
	          var tmp = arr[w];
	          arr[w] = arr[r];
	          arr[r] = tmp;
	          --w;
	        } else { // the value is smaller than the pivot, skip
	          ++r;
	        }
	      }
	
	      // if we stepped up (r++) we need to step one down (arr[r] > pivot)
	      if (compare(arr[r], pivot) > 0) {
	        --r;
	      }
	
	      // the r pointer is on the end of the first k elements
	      if (k <= r) {
	        to = r;
	      } else {
	        from = r + 1;
	      }
	    }
	
	    return arr[k];
	  }
	}
	
	exports.name = 'partitionSelect';
	exports.factory = factory;


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm05 = load(__webpack_require__(1395));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
	   *
	   * x and y are considered equal when the relative difference between x and y
	   * is smaller than the configured epsilon. The function cannot be used to
	   * compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.compare(x, y)
	   *
	   * Examples:
	   *
	   *    math.compare(6, 1);           // returns 1
	   *    math.compare(2, 3);           // returns -1
	   *    math.compare(7, 7);           // returns 0
	   *    math.compare('10', '2');      // returns 1
	   *    math.compare('1000', '1e3');  // returns 0
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('40 mm');
	   *    math.compare(a, b);           // returns 1
	   *
	   *    math.compare(2, [1, 2, 3]);   // returns [1, 0, -1]
	   *
	   * See also:
	   *
	   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
	   *
	   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
	   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
	   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
	   */
	  var compare = typed('compare', {
	
	    'boolean, boolean': function (x, y) {
	      return x === y ? 0 : (x > y ? 1 : -1);
	    },
	
	    'number, number': function (x, y) {
	      return (x === y || nearlyEqual(x, y, config.epsilon))
	          ? 0
	          : (x > y ? 1 : -1);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return (x.eq(y) || bigNearlyEqual(x, y, config.epsilon))
	          ? new type.BigNumber(0)
	          : new type.BigNumber(x.cmp(y));
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return new type.Fraction(x.compare(y));
	    },
	
	    'Complex, Complex': function () {
	      throw new TypeError('No ordering relation is defined for complex numbers');
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return compare(x.value, y.value);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm05(x, y, compare);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, compare, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, compare, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, compare);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return compare(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return compare(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return compare(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, compare, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, compare, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, compare, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, compare, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, compare, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, compare, true).valueOf();
	    }
	  });
	
	  compare.toTex = undefined; // use default template
	
	  return compare;
	}
	
	exports.name = 'compare';
	exports.factory = factory;


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	
	var isInteger = __webpack_require__(1324).isInteger;
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Reshape a multi dimensional array to fit the specified dimensions
	   *
	   * Syntax:
	   *
	   *     math.reshape(x, sizes)
	   *
	   * Examples:
	   *
	   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3]);
	   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
	   *
	   *     math.reshape([[1, 2], [3, 4]], [1, 4]);
	   *     // returns Array  [[1, 2, 3, 4]]
	   *
	   *     math.reshape([[1, 2], [3, 4]], [4]);
	   *     // returns Array [1, 2, 3, 4]
	   *
	   *     var x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8]);
	   *     math.reshape(x, [2, 2, 2]);
	   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
	   *
	   * See also:
	   *
	   *     size, squeeze, resize
	   *
	   * @param {Array | Matrix | *} x  Matrix to be reshaped
	   * @param {number[]} sizes        One dimensional array with integral sizes for
	   *                                each dimension
	   *
	   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
	   *
	   * @throws {TypeError}            If `sizes` does not contain solely integers
	   * @throws {DimensionError}       If the product of the new dimension sizes does
	   *                                not equal that of the old ones
	   */
	  var reshape = typed('reshape', {
	
	    'Matrix, Array': function (x, sizes) {
	      if(x.reshape) {
	        return x.reshape(sizes);
	      } else {
	        return matrix(array.reshape(x.valueOf(), sizes));
	      }
	    },
	
	    'Array, Array': function (x, sizes) {
	      sizes.forEach(function (size) {
	        if (!isInteger(size)) {
	          throw new TypeError('Invalid size for dimension: ' + size);
	        }
	      });
	      return array.reshape(x, sizes);
	    }
	
	  });
	
	  reshape.toTex = undefined; // use default template
	
	  return reshape;
	}
	
	exports.name = 'reshape';
	exports.factory = factory;


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DimensionError = __webpack_require__(1358);
	var ArgumentsError = __webpack_require__(1329);
	
	var isInteger = __webpack_require__(1324).isInteger;
	var format = __webpack_require__(1341).format;
	var clone = __webpack_require__(1320).clone;
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Resize a matrix
	   *
	   * Syntax:
	   *
	   *     math.resize(x, size)
	   *     math.resize(x, size, defaultValue)
	   *
	   * Examples:
	   *
	   *     math.resize([1, 2, 3, 4, 5], [3]); // returns Array  [1, 2, 3]
	   *     math.resize([1, 2, 3], [5], 0);    // returns Array  [1, 2, 3, 0, 0]
	   *     math.resize(2, [2, 3], 0);         // returns Matrix [[2, 0, 0], [0, 0, 0]]
	   *     math.resize("hello", [8], "!");    // returns string 'hello!!!'
	   *
	   * See also:
	   *
	   *     size, squeeze, subset, reshape
	   *
	   * @param {Array | Matrix | *} x             Matrix to be resized
	   * @param {Array | Matrix} size              One dimensional array with numbers
	   * @param {number | string} [defaultValue=0] Zero by default, except in
	   *                                           case of a string, in that case
	   *                                           defaultValue = ' '
	   * @return {* | Array | Matrix} A resized clone of matrix `x`
	   */
	  // TODO: rework resize to a typed-function
	  var resize = function resize (x, size, defaultValue) {
	    if (arguments.length != 2 && arguments.length != 3) {
	      throw new ArgumentsError('resize', arguments.length, 2, 3);
	    }
	
	    if (type.isMatrix(size)) {
	      size = size.valueOf(); // get Array
	    }
	
	    if (type.isBigNumber(size[0])) {
	      // convert bignumbers to numbers
	      size = size.map(function (value) {
	        return type.isBigNumber(value) ? value.toNumber() : value;
	      });
	    }
	    
	    // check x is a Matrix
	    if (type.isMatrix(x)) {
	      // use optimized matrix implementation, return copy
	      return x.resize(size, defaultValue, true);
	    }
	    
	    if (typeof x === 'string') {
	      // resize string
	      return _resizeString(x, size, defaultValue);
	    }
	    
	    // check result should be a matrix
	    var asMatrix = Array.isArray(x) ? false : (config.matrix !== 'Array');
	
	    if (size.length == 0) {
	      // output a scalar
	      while (Array.isArray(x)) {
	        x = x[0];
	      }
	
	      return clone(x);
	    }
	    else {
	      // output an array/matrix
	      if (!Array.isArray(x)) {
	        x = [x];
	      }
	      x = clone(x);
	
	      var res = array.resize(x, size, defaultValue);
	      return asMatrix ? matrix(res) : res;
	    }
	  };
	
	  resize.toTex = undefined; // use default template
	
	  return resize;
	
	  /**
	   * Resize a string
	   * @param {string} str
	   * @param {number[]} size
	   * @param {string} [defaultChar=' ']
	   * @private
	   */
	  function _resizeString(str, size, defaultChar) {
	    if (defaultChar !== undefined) {
	      if (typeof defaultChar !== 'string' || defaultChar.length !== 1) {
	        throw new TypeError('Single character expected as defaultValue');
	      }
	    }
	    else {
	      defaultChar = ' ';
	    }
	
	    if (size.length !== 1) {
	      throw new DimensionError(size.length, 1);
	    }
	    var len = size[0];
	    if (typeof len !== 'number' || !isInteger(len)) {
	      throw new TypeError('Invalid size, must contain positive integers ' +
	          '(size: ' + format(size) + ')');
	    }
	
	    if (str.length > len) {
	      return str.substring(0, len);
	    }
	    else if (str.length < len) {
	      var res = str;
	      for (var i = 0, ii = len - str.length; i < ii; i++) {
	        res += defaultChar;
	      }
	      return res;
	    }
	    else {
	      return str;
	    }
	  }
	}
	
	exports.name = 'resize';
	exports.factory = factory;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Calculate the size of a matrix or scalar.
	   *
	   * Syntax:
	   *
	   *     math.size(x)
	   *
	   * Examples:
	   *
	   *     math.size(2.3);                  // returns []
	   *     math.size('hello world');        // returns [11]
	   *
	   *     var A = [[1, 2, 3], [4, 5, 6]];
	   *     math.size(A);                    // returns [2, 3]
	   *     math.size(math.range(1,6));      // returns [5]
	   *
	   * See also:
	   *
	   *     resize, squeeze, subset
	   *
	   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
	   * @return {Array | Matrix} A vector with size of `x`.
	   */
	  var size = typed('size', {
	    'Matrix': function (x) {
	      // TODO: return the same matrix type as the input
	      return matrix(x.size());
	    },
	
	    'Array': array.size,
	
	    'string': function (x) {
	      return (config.matrix === 'Array') ? [x.length] : matrix([x.length]);
	    },
	
	    'number | Complex | BigNumber | Unit | boolean | null': function (x) {
	      // scalar
	      return (config.matrix === 'Array') ? [] : matrix([]);
	    }
	  });
	
	  size.toTex = undefined; // use default template
	
	  return size;
	}
	
	exports.name = 'size';
	exports.factory = factory;


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var size = __webpack_require__(1357).size;
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	  var compareAsc = load(__webpack_require__(1799));
	  var compareDesc = function (a, b) {
	    return -compareAsc(a, b);
	  };
	  var compareNatural = load(__webpack_require__(1804));
	
	  /**
	   * Sort the items in a matrix.
	   *
	   * Syntax:
	   *
	   *    math.sort(x)
	   *    math.sort(x, compare)
	   *
	   * Examples:
	   *
	   *    math.sort([5, 10, 1]); // returns [1, 5, 10]
	   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural);
	   *    // returns ['A', 'B', 'C', 'D']
	   *
	   *    function sortByLength (a, b) {
	   *      return a.length - b.length;
	   *    }
	   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength);
	   *    // returns ['Tom', 'Sara', 'Langdon']
	   *
	   * See also:
	   *
	   *    filter, forEach, map, compare, compareNatural
	   *
	   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
	   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
	   *        An optional _comparator function or name. The function is called as
	   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
	   *        and 0 when a == b.
	   * @return {Matrix | Array} Returns the sorted matrix.
	   */
	  var sort = typed('sort', {
	    'Array': function (x) {
	      _arrayIsVector(x);
	      return x.sort(compareAsc);
	    },
	
	    'Matrix': function (x) {
	      _matrixIsVector(x);
	      return matrix(x.toArray().sort(compareAsc), x.storage());
	    },
	
	    'Array, function': function (x, _comparator) {
	      _arrayIsVector(x);
	      return x.sort(_comparator);
	    },
	
	    'Matrix, function': function (x, _comparator) {
	      _matrixIsVector(x);
	      return matrix(x.toArray().sort(_comparator), x.storage());
	    },
	
	    'Array, string': function (x, order) {
	      _arrayIsVector(x);
	      return x.sort(_comparator(order));
	    },
	
	    'Matrix, string': function (x, order) {
	      _matrixIsVector(x);
	      return matrix(x.toArray().sort(_comparator(order)), x.storage());
	    }
	  });
	
	  sort.toTex = undefined; // use default template
	
	  /**
	   * Get the comparator for given order ('asc', 'desc', 'natural')
	   * @param {'asc' | 'desc' | 'natural'} order
	   * @return {Function} Returns a _comparator function
	   */
	  function _comparator (order) {
	    if (order === 'asc') {
	      return compareAsc;
	    }
	    else if (order === 'desc') {
	      return compareDesc;
	    }
	    else if (order === 'natural') {
	      return compareNatural;
	    }
	    else {
	      throw new Error('String "asc", "desc", or "natural" expected');
	    }
	  }
	
	  /**
	   * Validate whether an array is one dimensional
	   * Throws an error when this is not the case
	   * @param {Array} array
	   * @private
	   */
	  function _arrayIsVector (array) {
	    if (size(array).length !== 1) {
	      throw new Error('One dimensional array expected');
	    }
	  }
	
	  /**
	   * Validate whether a matrix is one dimensional
	   * Throws an error when this is not the case
	   * @param {Matrix} matrix
	   * @private
	   */
	  function _matrixIsVector (matrix) {
	    if (matrix.size().length !== 1) {
	      throw new Error('One dimensional matrix expected');
	    }
	  }
	
	  return sort;
	}
	
	exports.name = 'sort';
	exports.factory = factory;


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var naturalSort = __webpack_require__(1805);
	
	function factory (type, config, load, typed) {
	  var getTypeOf = load(__webpack_require__(1409));
	  var compare = load(__webpack_require__(1799));
	
	  var compareBooleans = compare.signatures['boolean,boolean']
	
	  /**
	   * Compare two values of any type in a deterministic, natural way.
	   *
	   * For numeric values, the function works the same as `math.compare`.
	   * For types of values that can't be compared mathematically,
	   * the function compares in a natural way.
	   *
	   * For numeric values, x and y are considered equal when the relative
	   * difference between x and y is smaller than the configured epsilon.
	   * The function cannot be used to compare values smaller than
	   * approximately 2.22e-16.
	   *
	   * For Complex numbers, first the real parts are compared. If equal,
	   * the imaginary parts are compared.
	   *
	   * Strings are compared with a natural sorting algorithm, which
	   * orders strings in a "logic" way following some heuristics.
	   * This differs from the function `compare`, which converts the string
	   * into a numeric value and compares that. The function `compareText`
	   * on the other hand compares text lexically.
	   *
	   * Arrays and Matrices are compared value by value until there is an
	   * unequal pair of values encountered. Objects are compared by sorted
	   * keys until the keys or their values are unequal.
	   *
	   * Syntax:
	   *
	   *    math.compareNatural(x, y)
	   *
	   * Examples:
	   *
	   *    math.compareNatural(6, 1);              // returns 1
	   *    math.compareNatural(2, 3);              // returns -1
	   *    math.compareNatural(7, 7);              // returns 0
	   *
	   *    math.compareNatural('10', '2');         // returns 1
	   *    math.compareText('10', '2');            // returns -1
	   *    math.compare('10', '2');                // returns 1
	   *
	   *    math.compareNatural('Answer: 10', 'Answer: 2'); // returns 1
	   *    math.compareText('Answer: 10', 'Answer: 2');    // returns -1
	   *    math.compare('Answer: 10', 'Answer: 2');
	   *        // Error: Cannot convert "Answer: 10" to a number
	   *
	   *    var a = math.unit('5 cm');
	   *    var b = math.unit('40 mm');
	   *    math.compareNatural(a, b);              // returns 1
	   *
	   *    var c = math.complex('2 + 3i');
	   *    var d = math.complex('2 + 4i');
	   *    math.compareNatural(c, d);              // returns -1
	   *
	   *    math.compareNatural([1, 2, 4], [1, 2, 3]); // returns 1
	   *    math.compareNatural([1, 2, 3], [1, 2]);    // returns 1
	   *    math.compareNatural([1, 5], [1, 2, 3]);    // returns 1
	   *    math.compareNatural([1, 2], [1, 2]);       // returns 0
	   *
	   *    math.compareNatural({a: 2}, {a: 4});       // returns -1
	   *
	   * See also:
	   *
	   *    compare, compareText
	   *
	   * @param  {*} x First value to compare
	   * @param  {*} y Second value to compare
	   * @return {number} Returns the result of the comparison:
	   *                  1 when x > y, -1 when x < y, and 0 when x == y.
	   */
	  var compareNatural = typed('compareNatural', {
	    'any, any': function (x, y) {
	      var typeX = getTypeOf(x);
	      var typeY = getTypeOf(y);
	      var c;
	
	      // numeric types
	      if ((typeX === 'number' || typeX === 'BigNumber' || typeX === 'Fraction') &&
	          (typeY === 'number' || typeY === 'BigNumber' || typeY === 'Fraction')) {
	        c = compare(x, y);
	        if (c.toString() !== '0') {
	          // c can be number, BigNumber, or Fraction
	          return c > 0 ? 1 : -1; // return a number
	        }
	        else {
	          return naturalSort(typeX, typeY);
	        }
	      }
	
	      // matrix types
	      if (typeX === 'Array' || typeX === 'Matrix' ||
	          typeY === 'Array' || typeY === 'Matrix') {
	        c = compareMatricesAndArrays (x, y);
	        if (c !== 0) {
	          return c;
	        }
	        else {
	          return naturalSort(typeX, typeY);
	        }
	      }
	
	      // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
	      if (typeX !== typeY) {
	        return naturalSort(typeX, typeY);
	      }
	
	      if (typeX === 'Complex') {
	        return compareComplexNumbers(x, y);
	      }
	
	      if (typeX === 'Unit') {
	        if (x.equalBase(y)) {
	          return compareNatural(x.value, y.value);
	        }
	
	        // compare by units
	        return compareArrays(x.formatUnits(), y.formatUnits());
	      }
	
	      if (typeX === 'boolean') {
	        return compareBooleans(x, y);
	      }
	
	      if (typeX === 'string') {
	        return naturalSort(x, y);
	      }
	
	      if (typeX === 'Object') {
	        return compareObjects(x, y);
	      }
	
	      if (typeX === 'null') {
	        return 0;
	      }
	
	      if (typeX === 'undefined') {
	        return 0;
	      }
	
	      // this should not occur...
	      throw new TypeError('Unsupported type of value "' + typeX + '"');
	    }
	  });
	
	  compareNatural.toTex = undefined; // use default template
	
	  /**
	   * Compare mixed matrix/array types, by converting to same-shaped array.
	   * This comparator is non-deterministic regarding input types.
	   * @param {Array | SparseMatrix | DenseMatrix | *} x
	   * @param {Array | SparseMatrix | DenseMatrix | *} y
	   * @returns {number} Returns the comparison result: -1, 0, or 1
	   */
	  function compareMatricesAndArrays (x, y) {
	    if (type.isSparseMatrix(x) && type.isSparseMatrix(y)) {
	      return compareArrays(x.toJSON().values, y.toJSON().values);
	    }
	    if (type.isSparseMatrix(x)) {
	      // note: convert to array is expensive
	      return compareMatricesAndArrays(x.toArray(), y);
	    }
	    if (type.isSparseMatrix(y)) {
	      // note: convert to array is expensive
	      return compareMatricesAndArrays(x, y.toArray());
	    }
	
	    // convert DenseArray into Array
	    if (type.isDenseMatrix(x)) {
	      return compareMatricesAndArrays(x.toJSON().data, y);
	    }
	    if (type.isDenseMatrix(y)) {
	      return compareMatricesAndArrays(x, y.toJSON().data);
	    }
	
	    // convert scalars to array
	    if (!Array.isArray(x)) {
	      return compareMatricesAndArrays([x], y);
	    }
	    if (!Array.isArray(y)) {
	      return compareMatricesAndArrays(x, [y]);
	    }
	
	    return compareArrays(x, y);
	  }
	
	  /**
	   * Compare two Arrays
	   *
	   * - First, compares value by value
	   * - Next, if all corresponding values are equal,
	   *   look at the length: longest array will be considered largest
	   *
	   * @param {Array} x
	   * @param {Array} y
	   * @returns {number} Returns the comparison result: -1, 0, or 1
	   */
	  function compareArrays (x, y) {
	    // compare each value
	    for (var i = 0, ii = Math.min(x.length, y.length); i < ii; i++) {
	      var v = compareNatural(x[i], y[i]);
	      if (v !== 0) {
	        return v;
	      }
	    }
	
	    // compare the size of the arrays
	    if (x.length > y.length) { return 1; }
	    if (x.length < y.length) { return -1; }
	
	    // both Arrays have equal size and content
	    return 0;
	  }
	
	  /**
	   * Compare two objects
	   *
	   * - First, compare sorted property names
	   * - Next, compare the property values
	   *
	   * @param {Object} x
	   * @param {Object} y
	   * @returns {number} Returns the comparison result: -1, 0, or 1
	   */
	  function compareObjects (x, y) {
	    var keysX = Object.keys(x);
	    var keysY = Object.keys(y);
	
	    // compare keys
	    keysX.sort(naturalSort)
	    keysY.sort(naturalSort)
	    var c = compareArrays(keysX, keysY);
	    if (c !== 0) {
	      return c;
	    }
	
	    // compare values
	    for (var i = 0; i < keysX.length; i++) {
	      var v = compareNatural(x[keysX[i]], y[keysY[i]]);
	      if (v !== 0) {
	        return v;
	      }
	    }
	
	    return 0;
	  }
	
	  return compareNatural;
	}
	
	/**
	 * Compare two complex numbers, `x` and `y`:
	 *
	 * - First, compare the real values of `x` and `y`
	 * - If equal, compare the imaginary values of `x` and `y`
	 * 
	 * @params {Complex} x
	 * @params {Complex} y
	 * @returns {number} Returns the comparison result: -1, 0, or 1
	 */
	function compareComplexNumbers (x, y) {
	  if (x.re > y.re) { return 1; }
	  if (x.re < y.re) { return -1; }
	
	  if (x.im > y.im) { return 1; }
	  if (x.im < y.im) { return -1; }
	
	  return 0;
	}
	
	exports.name = 'compareNatural';
	exports.factory = factory;


/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	/*
	 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
	 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
	 */
	/*jshint unused:false */
	module.exports = function naturalSort (a, b) {
		"use strict";
		var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
			sre = /(^[ ]*|[ ]*$)/g,
			dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
			hre = /^0x[0-9a-f]+$/i,
			ore = /^0/,
			i = function(s) { return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s; },
			// convert all to strings strip whitespace
			x = i(a).replace(sre, '') || '',
			y = i(b).replace(sre, '') || '',
			// chunk/tokenize
			xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
			yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
			// numeric, hex or date detection
			xD = parseInt(x.match(hre), 16) || (xN.length !== 1 && x.match(dre) && Date.parse(x)),
			yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null,
			oFxNcL, oFyNcL;
		// first try and sort Hex codes or Dates
		if (yD) {
			if ( xD < yD ) { return -1; }
			else if ( xD > yD ) { return 1; }
		}
		// natural sorting through split numeric strings and default strings
		for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
			// find floats not starting with '0', string or 0 if not defined (Clint Priest)
			oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
			oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
			// handle numeric vs string comparison - number < string - (Kyle Adams)
			if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
			// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
			else if (typeof oFxNcL !== typeof oFyNcL) {
				oFxNcL += '';
				oFyNcL += '';
			}
			if (oFxNcL < oFyNcL) { return -1; }
			if (oFxNcL > oFyNcL) { return 1; }
		}
		return 0;
	};


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var array  = __webpack_require__(1357);
	var latex  = __webpack_require__(1348);
	var string = __webpack_require__(1341);
	
	function factory(type, config, load, typed) {
	  var matrix   = load(__webpack_require__(1368));
	  var abs      = load(__webpack_require__(1402));
	  var add      = load(__webpack_require__(1367));
	  var divide   = load(__webpack_require__(1669));
	  var multiply = load(__webpack_require__(1400));
	  var sqrt     = load(__webpack_require__(1694));
	  var subtract = load(__webpack_require__(1393));
	  var inv      = load(__webpack_require__(1670));
	  var size     = load(__webpack_require__(1802));
	  var max      = load(__webpack_require__(1662));
	  var eye      = load(__webpack_require__(1399));
	
	  /**
	   * Calculate the principal square root of a square matrix.
	   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
	   *
	   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
	   * 
	   * Syntax:
	   *
	   *     X = math.sqrtm(A)
	   *
	   * Examples:
	   *
	   *     math.sqrtm([[1, 2], [3, 4]]); // returns [[-2, 1], [1.5, -0.5]]
	   *
	   * See also:
	   *
	   *     sqrt, pow
	   *
	   * @param  {Array | Matrix} A   The square matrix `A`
	   * @return {Array | Matrix}     The principal square root of matrix `A`
	   */
	  var sqrtm = typed('sqrtm', {
	    'Array | Matrix': function (A) {
	      var size = type.isMatrix(A) ? A.size() : array.size(A);
	      switch (size.length) {
	        case 1:
	          // Single element Array | Matrix
	          if (size[0] == 1) {
	            return sqrt(A);
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + string.format(size) + ')');
	          }
	
	        case 2:
	          // Two-dimensional Array | Matrix
	          var rows = size[0];
	          var cols = size[1];
	          if (rows == cols) {
	            return _denmanBeavers(A);
	          }
	          else {
	            throw new RangeError('Matrix must be square ' +
	            '(size: ' + string.format(size) + ')');
	          }
	      }
	    }
	  });
	
	  var _maxIterations = 1e3;
	  var _tolerance = 1e-6;
	
	  /**
	   * Calculate the principal square root matrix using the Denman–Beavers iterative method
	   * 
	   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
	   * 
	   * @param  {Array | Matrix} A   The square matrix `A`
	   * @return {Array | Matrix}     The principal square root of matrix `A`
	   * @private
	   */
	  function _denmanBeavers(A) {
	    var error;
	    var iterations = 0;
	
	    var Y = A;
	    var Z = eye(size(A));
	
	    do {
	      var Y_k = Y;
	      Y = multiply(0.5, add(Y_k, inv(Z)));
	      Z = multiply(0.5, add(Z, inv(Y_k)));
	
	      error = max(abs(subtract(Y, Y_k)));
	
	      if (error > _tolerance && ++iterations > _maxIterations) {
	        throw new Error('computing square root of matrix: iterative method could not converge');
	      }
	    } while (error > _tolerance);
	
	    return Y;
	  }
	
	  sqrtm.toTex = {1: '{${args[0]}}' + latex.operators['pow'] + '{\\frac{1}{2}}'};
	
	  return sqrtm;
	}
	
	exports.name = 'sqrtm';
	exports.factory = factory;


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object = __webpack_require__(1320);
	var array = __webpack_require__(1357);
	
	function factory (type, config, load, typed) {
	  var matrix = load(__webpack_require__(1368));
	
	  /**
	   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
	   *
	   * Syntax:
	   *
	   *     math.squeeze(x)
	   *
	   * Examples:
	   *
	   *     math.squeeze([3]);           // returns 3
	   *     math.squeeze([[3]]);         // returns 3
	   *
	   *     var A = math.zeros(3, 1);    // returns [[0], [0], [0]] (size 3x1)
	   *     math.squeeze(A);             // returns [0, 0, 0] (size 3)
	   *
	   *     var B = math.zeros(1, 3);    // returns [[0, 0, 0]] (size 1x3)
	   *     math.squeeze(B);             // returns [0, 0, 0] (size 3)
	   *
	   *     // only inner and outer dimensions are removed
	   *     var C = math.zeros(2, 1, 3); // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
	   *     math.squeeze(C);             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
	   *
	   * See also:
	   *
	   *     subset
	   *
	   * @param {Matrix | Array} x      Matrix to be squeezed
	   * @return {Matrix | Array} Squeezed matrix
	   */
	  var squeeze = typed('squeeze', {
	    'Array': function (x) {
	      return array.squeeze(object.clone(x));
	    },
	
	    'Matrix': function (x) {
	      var res = array.squeeze(x.toArray());
	      // FIXME: return the same type of matrix as the input
	      return Array.isArray(res) ? matrix(res) : res;
	    },
	
	    'any': function (x) {
	      // scalar
	      return object.clone(x);
	    }
	  });
	
	  squeeze.toTex = undefined; // use default template
	
	  return squeeze;
	}
	
	exports.name = 'squeeze';
	exports.factory = factory;


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  //require('./distribution'), // TODO: rethink math.distribution
	  __webpack_require__(1771),
	  __webpack_require__(1769),
	  __webpack_require__(1770),
	  __webpack_require__(1809),
	  __webpack_require__(1811),
	  __webpack_require__(1812),
	  __webpack_require__(1813),
	  __webpack_require__(1817),
	  __webpack_require__(1818)
	];


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	function factory(type, config, load, typed) {
	    var matrix = load(__webpack_require__(1368));
	    var divide = load(__webpack_require__(1669));
	    var sum = load(__webpack_require__(1810));
	    var multiply = load(__webpack_require__(1400));
	    var dotDivide = load(__webpack_require__(1726));
	    var log = load(__webpack_require__(1739));
	    var isNumeric = load(__webpack_require__(1407));
	
	    /**
	     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
	     *
	     * Syntax:
	     *
	     *     math.kldivergence(x, y)
	     *
	     * Examples:
	     *
	     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5]);   //returns 0.24376698773121153
	     *
	     *
	     * @param  {Array | Matrix} q    First vector
	     * @param  {Array | Matrix} p    Second vector
	     * @return {number}              Returns distance between q and p
	     */
	    var kldivergence = typed('kldivergence', {
	        'Array, Array': function(q, p) {
	            return _kldiv(matrix(q), matrix(p));
	        },
	
	        'Matrix, Array': function(q, p) {
	            return _kldiv(q, matrix(p));
	        },
	
	        'Array, Matrix': function(q, p){
	            return _kldiv(matrix(q), p);
	        },
	
	        'Matrix, Matrix': function(q, p){
	            return _kldiv(q, p);
	        }
	
	    });
	
	    function _kldiv(q, p) {
	        var plength = p.size().length;
	        var qlength = q.size().length;
	        if (plength > 1) {
	            throw new Error('first object must be one dimensional');
	        }
	        
	        if (qlength > 1) {
	            throw new Error('second object must be one dimensional');
	        }
	        
	        if(plength !== qlength){
	            throw new Error("Length of two vectors must be equal");
	        }
	        
	        //Before calculation, apply normalization
	        var sumq = sum(q);
	        if (sumq === 0) {
	            throw new Error("Sum of elements in first object must be non zero");
	        }
	
	        var sump = sum(p);
	        if (sump === 0) {
	            throw new Error("Sum of elements in second object must be non zero");
	        }
	        var qnorm = divide(q, sum(q));
	        var pnorm = divide(p, sum(p));
	
	        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
	        if (isNumeric(result)) {
	            return result;
	        }
	        else {
	            return Number.NaN;
	        }
	    }
	
	    return kldivergence;
	}
	
	
	exports.name = 'kldivergence';
	exports.factory = factory;
	 


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepForEach = __webpack_require__(1663);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1369));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the sum of a matrix or a list with values.
	   * In case of a (multi dimensional) array or matrix, the sum of all
	   * elements will be calculated.
	   *
	   * Syntax:
	   *
	   *     math.sum(a, b, c, ...)
	   *     math.sum(A)
	   *
	   * Examples:
	   *
	   *     math.sum(2, 1, 4, 3);               // returns 10
	   *     math.sum([2, 1, 4, 3]);             // returns 10
	   *     math.sum([[2, 5], [4, 3], [1, 7]]); // returns 22
	   *
	   * See also:
	   *
	   *    mean, median, min, max, prod, std, var
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The sum of all values
	   */
	  var sum = typed('sum', {
	    'Array | Matrix': function (args) {
	      // sum([a, b, c, d, ...])
	      return _sum(args);
	    },
	
	    'Array | Matrix, number | BigNumber': function () {
	      // sum([a, b, c, d, ...], dim)
	      // TODO: implement sum(A, dim)
	      throw new Error('sum(A, dim) is not yet supported');
	    },
	
	    '...': function (args) {
	      // sum(a, b, c, d, ...)
	      return _sum(args);
	    }
	  });
	
	  sum.toTex = undefined; // use default template
	
	  return sum;
	
	  /**
	   * Recursively calculate the sum of an n-dimensional array
	   * @param {Array} array
	   * @return {number} sum
	   * @private
	   */
	  function _sum(array) {
	    var sum = undefined;
	
	    deepForEach(array, function (value) {
	      try {
	        sum = (sum === undefined) ? value : add(sum, value);
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'sum', value);
	      }
	    });
	
	    if (sum === undefined) {
	      switch (config.number) {
	        case 'number':
	          return 0;
	        case 'BigNumber':
	          return new type.BigNumber(0);
	        case 'Fraction':
	          return new type.Fraction(0);
	        default:
	          return 0;
	      }
	    }
	
	    return sum;
	  }
	}
	
	exports.name = 'sum';
	exports.factory = factory;


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepForEach = __webpack_require__(1663);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var multiply = load(__webpack_require__(1400));
	  var divide = load(__webpack_require__(1669));
	  var factorial = load(__webpack_require__(1769));
	  var isInteger = load(__webpack_require__(1772));
	  var isPositive = load(__webpack_require__(1691));
	
	  /**
	   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
	   *
	   * multinomial takes one array of integers as an argument.
	   * The following condition must be enforced: every ai <= 0
	   *
	   * Syntax:
	   *
	   *     math.multinomial(a) // a is an array type
	   *
	   * Examples:
	   *
	   *    math.multinomial([1,2,1]); // returns 12
	   *
	   * See also:
	   *
	   *    combinations, factorial
	   *
	   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
	   * @return {Number | BigNumber}         Multinomial coefficient.
	   */
	  return typed('multinomial', {
	    'Array | Matrix': function (a) {
	      var sum = 0;
	      var denom = 1;
	
	      deepForEach(a, function(ai) {
	        if(!isInteger(ai) || !isPositive(ai)) {
	          throw new TypeError('Positive integer value expected in function multinomial');
	        }
	        sum = add(sum, ai);
	        denom = multiply(denom, factorial(ai));
	      });
	
	      return divide(factorial(sum), denom);
	    }
	  });
	}
	
	exports.name = 'multinomial';
	exports.factory = factory;


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	
	function factory (type, config, load, typed) {
	  var factorial = load(__webpack_require__(1769));
	
	  /**
	   * Compute the number of ways of obtaining an ordered subset of `k` elements
	   * from a set of `n` elements.
	   *
	   * Permutations only takes integer arguments.
	   * The following condition must be enforced: k <= n.
	   *
	   * Syntax:
	   *
	   *     math.permutations(n)
	   *     math.permutations(n, k)
	   *
	   * Examples:
	   *
	   *    math.permutations(5);     // 120
	   *    math.permutations(5, 3);  // 60
	   *
	   * See also:
	   *
	   *    combinations, factorial
	   *
	   * @param {number | BigNumber} n   The number of objects in total
	   * @param {number | BigNumber} [k] The number of objects in the subset
	   * @return {number | BigNumber}    The number of permutations
	   */
	  var permutations = typed('permutations', {
	    'number | BigNumber': factorial,
	
	    'number, number': function (n, k) {
	      var result, i;
	
	      if (!isInteger(n) || n < 0) {
	        throw new TypeError('Positive integer value expected in function permutations');
	      }
	      if (!isInteger(k) || k < 0) {
	        throw new TypeError('Positive integer value expected in function permutations');
	      }
	      if (k > n) {
	        throw new TypeError('second argument k must be less than or equal to first argument n');
	      }
	
	      // Permute n objects, k at a time
	      result = 1;
	      for (i = n - k + 1; i <= n; i++) {
	        result = result * i;
	      }
	
	      return result;
	    },
	
	    'BigNumber, BigNumber': function (n, k) {
	      var result, i;
	
	      if (!isPositiveInteger(n) || !isPositiveInteger(k)) {
	        throw new TypeError('Positive integer value expected in function permutations');
	      }
	      if (k.gt(n)) {
	        throw new TypeError('second argument k must be less than or equal to first argument n');
	      }
	
	      result = new type.BigNumber(1);
	      for (i = n.minus(k).plus(1); i.lte(n); i = i.plus(1)) {
	        result = result.times(i);
	      }
	
	      return result;
	    }
	
	    // TODO: implement support for collection in permutations
	  });
	
	  permutations.toTex = undefined; // use default template
	
	  return permutations;
	}
	
	/**
	 * Test whether BigNumber n is a positive integer
	 * @param {BigNumber} n
	 * @returns {boolean} isPositiveInteger
	 */
	function isPositiveInteger(n) {
	  return n.isInteger() && n.gte(0);
	}
	
	exports.name = 'permutations';
	exports.factory = factory;


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var distribution = load(__webpack_require__(1814));
	
	  /**
	   * Random pick one or more values from a one dimensional array.
	   * Array elements are picked using a random function with uniform or weighted distribution.
	   *
	   * Syntax:
	   *
	   *     math.pickRandom(array)
	   *     math.pickRandom(array, number)
	   *     math.pickRandom(array, weights)
	   *     math.pickRandom(array, number, weights)
	   *     math.pickRandom(array, weights, number)
	   *
	   * Examples:
	   *
	   *     math.pickRandom([3, 6, 12, 2]);                  // returns one of the values in the array
	   *     math.pickRandom([3, 6, 12, 2], 2);               // returns an array of two of the values in the array
	   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1]);    // returns one of the values in the array with weighted distribution
	   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]); // returns an array of two of the values in the array with weighted distribution
	   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2); // returns an array of two of the values in the array with weighted distribution
	   *
	   * See also:
	   *
	   *     random, randomInt
	   *
	   * @param {Array} array     A one dimensional array
	   * @param {Int} number      An int or float
	   * @param {Array} weights   An array of ints or floats
	   * @return {number | Array} Returns a single random value from array when number is 1 or undefined.
	   *                          Returns an array with the configured number of elements when number is > 1.
	   */
	  // TODO: rework pickRandom to a typed-function
	  var pickRandom =  distribution('uniform').pickRandom;
	
	  pickRandom.toTex = undefined; // use default template
	
	  return pickRandom;
	}
	
	exports.name = 'pickRandom';
	exports.factory = factory;


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ArgumentsError = __webpack_require__(1329);
	var isCollection = __webpack_require__(1661);
	var isNumber = __webpack_require__(1324).isNumber;
	
	// TODO: rethink math.distribution
	// TODO: rework to a typed function
	function factory (type, config, load, typed, math) {
	  var matrix = load(__webpack_require__(1368));
	  var array = __webpack_require__(1357);
	
	  // seeded pseudo random number generator
	  var rng = load(__webpack_require__(1815));
	
	  /**
	   * Create a distribution object with a set of random functions for given
	   * random distribution.
	   *
	   * Syntax:
	   *
	   *     math.distribution(name)
	   *
	   * Examples:
	   *
	   *     var normalDist = math.distribution('normal'); // create a normal distribution
	   *     normalDist.random(0, 10);                     // get a random value between 0 and 10
	   *
	   * See also:
	   *
	   *     random, randomInt, pickRandom
	   *
	   * @param {string} name   Name of a distribution. Choose from 'uniform', 'normal'.
	   * @return {Object}       Returns a distribution object containing functions:
	   *                        `random([size] [, min] [, max])`,
	   *                        `randomInt([min] [, max])`,
	   *                        `pickRandom(array)`
	   */
	  function distribution(name) {
	    if (!distributions.hasOwnProperty(name))
	      throw new Error('Unknown distribution ' + name);
	
	    var args = Array.prototype.slice.call(arguments, 1),
	        distribution = distributions[name].apply(this, args);
	
	    return (function(distribution) {
	
	      // This is the public API for all distributions
	      var randFunctions = {
	
	        random: function(arg1, arg2, arg3) {
	          var size, min, max;
	
	          if (arguments.length > 3) {
	            throw new ArgumentsError('random', arguments.length, 0, 3);
	          } else if (arguments.length === 1) {
	            // `random(max)` or `random(size)`
	            if (isCollection(arg1)) {
	              size = arg1;
	            } else {
	              max = arg1;
	            }
	          } else if (arguments.length === 2) {
	            // `random(min, max)` or `random(size, max)`
	            if (isCollection(arg1)) {
	              size = arg1;
	              max = arg2;
	            } else {
	              min = arg1;
	              max = arg2;
	            }
	          } else {
	            // `random(size, min, max)`
	            size = arg1;
	            min = arg2;
	            max = arg3;
	          }
	
	          // TODO: validate type of size
	          if ((min !== undefined && !isNumber(min)) || (max !== undefined && !isNumber(max))) {
	            throw new TypeError('Invalid argument in function random');
	          }
	
	          if (max === undefined) max = 1;
	          if (min === undefined) min = 0;
	          if (size !== undefined) {
	            var res = _randomDataForMatrix(size.valueOf(), min, max, _random);
	            return type.isMatrix(size) ? matrix(res) : res;
	          }
	          return _random(min, max);
	        },
	
	        randomInt: typed({
	          'number | Array': function(arg) {
	            var min = 0;
	
	            if (isCollection(arg)) {
	              var size = arg;
	              var max = 1;
	              var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
	              return type.isMatrix(size) ? matrix(res) : res;
	            } else {
	              var max = arg;
	              return _randomInt(min, max);
	            }
	          },
	          'number | Array, number': function(arg1, arg2) {
	            if (isCollection(arg1)) {
	              var size = arg1;
	              var max = arg2;
	              var min = 0;
	              var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
	              return type.isMatrix(size) ? matrix(res) : res;
	            }
	            else {
	              var min = arg1;
	              var max = arg2;
	              return _randomInt(min, max);
	            }
	          },
	          'Array, number, number': function(size, min, max) {
	            var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
	            return (size && size.isMatrix === true) ? matrix(res) : res;
	          }
	        }),
	
	        pickRandom: typed({
	          'Array': function(possibles) {
	            return _pickRandom(possibles);
	          },
	          'Array, number | Array': function(possibles, arg2) {
	            var number, weights;
	
	            if (Array.isArray(arg2)) {
	              weights = arg2;
	            } else if (isNumber(arg2)) {
	              number = arg2;
	            } else {
	              throw new TypeError('Invalid argument in function pickRandom')
	            }
	
	            return _pickRandom(possibles, number, weights);
	          },
	          'Array, number | Array, Array | number': function(possibles, arg2, arg3) {
	            var number, weights;
	
	            if (Array.isArray(arg2)) {
	              weights = arg2;
	              number = arg3;
	            } else {
	              weights = arg3;
	              number = arg2;
	            }
	
	            if (!Array.isArray(weights) || !isNumber(number)) {
	              throw new TypeError('Invalid argument in function pickRandom');
	            }
	
	            return _pickRandom(possibles, number, weights);
	          }
	        })
	      }
	
	      var _pickRandom = function(possibles, number, weights) {
	        var single = (typeof number === 'undefined');
	
	        if (single) {
	          number = 1;
	        }
	
	        if (type.isMatrix(possibles)) {
	          possibles = possibles.valueOf(); // get Array
	        } else if (!Array.isArray(possibles)) {
	          throw new TypeError('Unsupported type of value in function pickRandom');
	        }
	
	        if (array.size(possibles).length > 1) {
	          throw new Error('Only one dimensional vectors supported');
	        }
	
	        if (typeof weights !== 'undefined') {
	          if (weights.length != possibles.length) {
	            throw new Error('Weights must have the same length as possibles');
	          }
	
	          var totalWeights = 0;
	
	          for (var i = 0, len = weights.length; i < len; i++) {
	            if (!isNumber(weights[i]) || weights[i] < 0) {
	              throw new Error('Weights must be an array of positive numbers');
	            }
	
	            totalWeights += weights[i];
	          }
	        }
	
	        var length = possibles.length;
	
	        if (length == 0) {
	          return [];
	        } else if (number >= length) {
	          return number > 1 ? possibles : possibles[0];
	        }
	
	        var result = [];
	        var pick;
	
	        while (result.length < number) {
	          if (typeof weights === 'undefined') {
	            pick = possibles[Math.floor(rng() * length)];
	          } else {
	            var randKey = rng() * totalWeights;
	
	            for (var i = 0, len = possibles.length; i < len; i++) {
	              randKey -= weights[i];
	
	              if (randKey < 0) {
	                pick = possibles[i];
	                break;
	              }
	            }
	          }
	
	          if (result.indexOf(pick) == -1) {
	            result.push(pick);
	          }
	        }
	
	        return single ? result[0] : result;
	
	        // TODO: add support for multi dimensional matrices
	      }
	
	      var _random = function(min, max) {
	        return min + distribution() * (max - min);
	      };
	
	      var _randomInt = function(min, max) {
	        return Math.floor(min + distribution() * (max - min));
	      };
	
	      // This is a function for generating a random matrix recursively.
	      var _randomDataForMatrix = function(size, min, max, randFunc) {
	        var data = [], length, i;
	        size = size.slice(0);
	
	        if (size.length > 1) {
	          for (var i = 0, length = size.shift(); i < length; i++) {
	            data.push(_randomDataForMatrix(size, min, max, randFunc));
	          }
	        } else {
	          for (var i = 0, length = size.shift(); i < length; i++) {
	            data.push(randFunc(min, max));
	          }
	        }
	
	        return data;
	      };
	
	      return randFunctions;
	
	    })(distribution);
	  }
	
	  // Each distribution is a function that takes no argument and when called returns
	  // a number between 0 and 1.
	  var distributions = {
	
	    uniform: function() {
	      return rng;
	    },
	
	    // Implementation of normal distribution using Box-Muller transform
	    // ref : http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
	    // We take : mean = 0.5, standard deviation = 1/6
	    // so that 99.7% values are in [0, 1].
	    normal: function() {
	      return function() {
	        var u1, u2,
	            picked = -1;
	        // We reject values outside of the interval [0, 1]
	        // TODO: check if it is ok to do that?
	        while (picked < 0 || picked > 1) {
	          u1 = rng();
	          u2 = rng();
	          picked = 1/6 * Math.pow(-2 * Math.log(u1), 0.5) * Math.cos(2 * Math.PI * u2) + 0.5;
	        }
	        return picked;
	      }
	    }
	  };
	
	  distribution.toTex = undefined; // use default template
	
	  return distribution;
	}
	
	exports.name = 'distribution';
	exports.factory = factory;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var seedrandom = __webpack_require__(1816);
	
	// create a random seed here to prevent an infinite loop from seed-random
	// inside the factory. Reason is that math.random is defined as a getter/setter
	// and seed-random generates a seed from the local entropy by reading every
	// defined object including `math` itself. That means that whilst getting
	// math.random, it tries to get math.random, etc... an infinite loop.
	// See https://github.com/ForbesLindesay/seed-random/issues/6
	var singletonRandom = seedrandom();
	
	function factory (type, config, load, typed, math) {
	  var random;
	
	  // create a new random generator with given seed
	  function setSeed (seed) {
	    random = seed === null ? singletonRandom : seedrandom(String(seed));
	  }
	
	  // initialize a seeded pseudo random number generator with config's random seed
	  setSeed(config.randomSeed)
	
	  // wrapper function so the rng can be updated via generator
	  function rng() {
	      return random();
	  }
	
	  // updates generator with a new instance of a seeded pseudo random number generator
	  math.on('config', function (curr, prev, changes) {
	    // if the user specified a randomSeed
	    if(changes.randomSeed !== undefined) {
	      // update generator with a new instance of a seeded pseudo random number generator
	      setSeed(curr.randomSeed)
	    }
	  });
	
	  return rng;
	}
	
	exports.factory = factory;
	exports.math = true;


/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var width = 256;// each RC4 output is 0 <= x < 256
	var chunks = 6;// at least six RC4 outputs for each double
	var digits = 52;// there are 52 significant digits in a double
	var pool = [];// pool: entropy pool starts empty
	var GLOBAL = typeof global === 'undefined' ? window : global;
	
	//
	// The following constants are related to IEEE 754 limits.
	//
	var startdenom = Math.pow(width, chunks),
	    significance = Math.pow(2, digits),
	    overflow = significance * 2,
	    mask = width - 1;
	
	
	var oldRandom = Math.random;
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	module.exports = function(seed, options) {
	  if (options && options.global === true) {
	    options.global = false;
	    Math.random = module.exports(seed, options);
	    options.global = true;
	    return Math.random;
	  }
	  var use_entropy = (options && options.entropy) || false;
	  var key = [];
	
	  // Flatten the seed string or build one from local entropy if needed.
	  var shortseed = mixkey(flatten(
	    use_entropy ? [seed, tostring(pool)] :
	    0 in arguments ? seed : autoseed(), 3), key);
	
	  // Use the seed to initialize an ARC4 generator.
	  var arc4 = new ARC4(key);
	
	  // Mix the randomness into accumulated entropy.
	  mixkey(tostring(arc4.S), pool);
	
	  // Override Math.random
	
	  // This function returns a random double in [0, 1) that contains
	  // randomness in every bit of the mantissa of the IEEE 754 value.
	
	  return function() {         // Closure to return a random double:
	    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	        d = startdenom,                 //   and denominator d = 2 ^ 48.
	        x = 0;                          //   and no 'extra last byte'.
	    while (n < significance) {          // Fill up all significant digits by
	      n = (n + x) * width;              //   shifting numerator and
	      d *= width;                       //   denominator and generating a
	      x = arc4.g(1);                    //   new least-significant-byte.
	    }
	    while (n >= overflow) {             // To avoid rounding up, before adding
	      n /= 2;                           //   last byte, shift everything
	      d /= 2;                           //   right using integer Math until
	      x >>>= 1;                         //   we have exactly the desired bits.
	    }
	    return (n + x) / d;                 // Form the number within [0, 1).
	  };
	};
	
	module.exports.resetGlobal = function () {
	  Math.random = oldRandom;
	};
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	/** @constructor */
	function ARC4(key) {
	  var t, keylen = key.length,
	      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	  // The empty key [] is treated as [0].
	  if (!keylen) { key = [keylen++]; }
	
	  // Set up S using the standard key scheduling algorithm.
	  while (i < width) {
	    s[i] = i++;
	  }
	  for (i = 0; i < width; i++) {
	    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	    s[j] = t;
	  }
	
	  // The "g" method returns the next (count) outputs as one number.
	  (me.g = function(count) {
	    // Using instance members instead of closure state nearly doubles speed.
	    var t, r = 0,
	        i = me.i, j = me.j, s = me.S;
	    while (count--) {
	      t = s[i = mask & (i + 1)];
	      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	    }
	    me.i = i; me.j = j;
	    return r;
	    // For robust unpredictability discard an initial batch of values.
	    // See http://www.rsa.com/rsalabs/node.asp?id=2009
	  })(width);
	}
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	function flatten(obj, depth) {
	  var result = [], typ = (typeof obj)[0], prop;
	  if (depth && typ == 'o') {
	    for (prop in obj) {
	      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	    }
	  }
	  return (result.length ? result : typ == 's' ? obj : obj + '\0');
	}
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	function mixkey(seed, key) {
	  var stringseed = seed + '', smear, j = 0;
	  while (j < stringseed.length) {
	    key[mask & j] =
	      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	  }
	  return tostring(key);
	}
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto if available.
	//
	/** @param {Uint8Array=} seed */
	function autoseed(seed) {
	  try {
	    GLOBAL.crypto.getRandomValues(seed = new Uint8Array(width));
	    return tostring(seed);
	  } catch (e) {
	    return [+new Date, GLOBAL, GLOBAL.navigator && GLOBAL.navigator.plugins,
	            GLOBAL.screen, tostring(pool)];
	  }
	}
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	function tostring(a) {
	  return String.fromCharCode.apply(0, a);
	}
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to intefere with determinstic PRNG state later,
	// seedrandom will not call Math.random on its own again after
	// initialization.
	//
	mixkey(Math.random(), pool);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var distribution = load(__webpack_require__(1814));
	
	  /**
	   * Return a random number larger or equal to `min` and smaller than `max`
	   * using a uniform distribution.
	   *
	   * Syntax:
	   *
	   *     math.random()                // generate a random number between 0 and 1
	   *     math.random(max)             // generate a random number between 0 and max
	   *     math.random(min, max)        // generate a random number between min and max
	   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
	   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
	   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
	   *
	   * Examples:
	   *
	   *     math.random();       // returns a random number between 0 and 1
	   *     math.random(100);    // returns a random number between 0 and 100
	   *     math.random(30, 40); // returns a random number between 30 and 40
	   *     math.random([2, 3]); // returns a 2x3 matrix with random numbers between 0 and 1
	   *
	   * See also:
	   *
	   *     randomInt, pickRandom
	   *
	   * @param {Array | Matrix} [size] If provided, an array or matrix with given
	   *                                size and filled with random values is returned
	   * @param {number} [min]  Minimum boundary for the random value, included
	   * @param {number} [max]  Maximum boundary for the random value, excluded
	   * @return {number | Array | Matrix} A random number
	   */
	  // TODO: rework random to a typed-function
	  var random = distribution('uniform').random;
	
	  random.toTex = undefined; // use default template
	
	  return random;
	}
	
	exports.name = 'random';
	exports.factory = factory;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var distribution = load(__webpack_require__(1814));
	
	  /**
	   * Return a random integer number larger or equal to `min` and smaller than `max`
	   * using a uniform distribution.
	   *
	   * Syntax:
	   *
	   *     math.randomInt(max)             // generate a random integer between 0 and max
	   *     math.randomInt(min, max)        // generate a random integer between min and max
	   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
	   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
	   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
	   *
	   * Examples:
	   *
	   *     math.randomInt(100);    // returns a random integer between 0 and 100
	   *     math.randomInt(30, 40); // returns a random integer between 30 and 40
	   *     math.randomInt([2, 3]); // returns a 2x3 matrix with random integers between 0 and 1
	   *
	   * See also:
	   *
	   *     random, pickRandom
	   *
	   * @param {Array | Matrix} [size] If provided, an array or matrix with given
	   *                                size and filled with random values is returned
	   * @param {number} [min]  Minimum boundary for the random value, included
	   * @param {number} [max]  Maximum boundary for the random value, excluded
	   * @return {number | Array | Matrix} A random integer value
	   */
	  // TODO: rework randomInt to a typed-function
	  var randomInt = distribution('uniform').randomInt;
	
	  randomInt.toTex = undefined; // use default template
	
	  return randomInt;
	}
	
	exports.name = 'randomInt';
	exports.factory = factory;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1799),
	  __webpack_require__(1804),
	  __webpack_require__(1820),
	  __webpack_require__(1821),
	  __webpack_require__(1406),
	  __webpack_require__(1822),
	  __webpack_require__(1380),
	  __webpack_require__(1709),
	  __webpack_require__(1376),
	  __webpack_require__(1823),
	  __webpack_require__(1692)
	];


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	  var _typeof = load(__webpack_require__(1409));
	
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	  
	  /**
	   * Compare two strings lexically. Comparison is case sensitive.
	   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.compareText(x, y)
	   *
	   * Examples:
	   *
	   *    math.compareText('B', 'A');     // returns 1
	   *    math.compareText('2', '10');    // returns 1
	   *    math.compare('2', '10');        // returns -1
	   *    math.compareNatural('2', '10'); // returns -1
	   *
	   *    math.compareText('B', ['A', 'B', 'C']); // returns [1, 0, -1]
	   *
	   * See also:
	   *
	   *    equal, equalText, compare, compareNatural
	   *
	   * @param  {string | Array | DenseMatrix} x First string to compare
	   * @param  {string | Array | DenseMatrix} y Second string to compare
	   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
	   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
	   */
	  var compareText = typed('compareText', {
	
	    'any, any': _compareText,
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, _compareText);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return compareText(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return compareText(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return compareText(x, matrix(y));
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, _compareText, false);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, _compareText, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, _compareText, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, _compareText, true).valueOf();
	    }
	  });
	
	  /**
	   * Compare two strings
	   * @param {string} x
	   * @param {string} y
	   * @returns {number}
	   * @private
	   */
	  function _compareText(x, y) {
	    // we don't want to convert numbers to string, only accept string input
	    if (!type.isString(x)) {
	      throw new TypeError('Unexpected type of argument in function compareText ' +
	          '(expected: string or Array or Matrix, actual: ' + _typeof(x) + ', index: 0)');
	    }
	    if (!type.isString(y)) {
	      throw new TypeError('Unexpected type of argument in function compareText ' +
	          '(expected: string or Array or Matrix, actual: ' + _typeof(y) + ', index: 1)');
	    }
	
	    return (x === y)
	        ? 0
	        : (x > y ? 1 : -1);
	  }
	
	  compareText.toTex = undefined; // use default template
	
	  return compareText;
	}
	
	exports.name = 'compareText';
	exports.factory = factory;


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var equal = load(__webpack_require__(1406));
	
	  /**
	   * Test element wise whether two matrices are equal.
	   * The function accepts both matrices and scalar values.
	   *
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.deepEqual(x, y)
	   *
	   * Examples:
	   *
	   *    math.deepEqual(2, 4);   // returns false
	   *
	   *    a = [2, 5, 1];
	   *    b = [2, 7, 1];
	   *
	   *    math.deepEqual(a, b);   // returns false
	   *    math.equal(a, b);       // returns [true, false, true]
	   *
	   * See also:
	   *
	   *    equal, unequal
	   *
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
	   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
	   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
	   *            Returns true when the input matrices have the same size and each of their elements is equal.
	   */
	  var deepEqual = typed('deepEqual', {
	    'any, any': function (x, y) {
	      return _deepEqual(x.valueOf(), y.valueOf());
	    }
	  });
	
	  deepEqual.toTex = undefined; // use default template
	
	  return deepEqual;
	
	  /**
	   * Test whether two arrays have the same size and all elements are equal
	   * @param {Array | *} x
	   * @param {Array | *} y
	   * @return {boolean} Returns true if both arrays are deep equal
	   */
	  function _deepEqual(x, y) {
	    if (Array.isArray(x)) {
	      if (Array.isArray(y)) {
	        var len = x.length;
	        if (len !== y.length) {
	          return false;
	        }
	
	        for (var i = 0; i < len; i++) {
	          if (!_deepEqual(x[i], y[i])) {
	            return false;
	          }
	        }
	
	        return true;
	      }
	      else {
	        return false;
	      }
	    }
	    else {
	      if (Array.isArray(y)) {
	        return false;
	      }
	      else {
	        return equal(x, y);
	      }
	    }
	  }
	}
	
	exports.name = 'deepEqual';
	exports.factory = factory;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var compareText = load(__webpack_require__(1820));
	  var isZero = load(__webpack_require__(1686));
	
	  /**
	   * Check equality of two strings. Comparison is case sensitive.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.equalText(x, y)
	   *
	   * Examples:
	   *
	   *    math.equalText('Hello', 'Hello');     // returns true
	   *    math.equalText('a', 'A');     // returns false
	   *    math.equal('2e3', '2000');        // returns true
	   *    math.equalText('2e3', '2000');        // returns false
	   *
	   *    math.equalText('B', ['A', 'B', 'C']); // returns [false, true, false]
	   *
	   * See also:
	   *
	   *    equal, compareText, compare, compareNatural
	   *
	   * @param  {string | Array | DenseMatrix} x First string to compare
	   * @param  {string | Array | DenseMatrix} y Second string to compare
	   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
	   */
	  var equalText = typed('equalText', {
	
	    'any, any': function (x, y) {
	      return isZero(compareText(x, y));
	    }
	
	  });
	
	  equalText.toTex = undefined; // use default template
	
	  return equalText;
	}
	
	exports.name = 'equalText';
	exports.factory = factory;


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nearlyEqual = __webpack_require__(1324).nearlyEqual;
	var bigNearlyEqual = __webpack_require__(1365);
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm07 = load(__webpack_require__(1378));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  var latex = __webpack_require__(1348);
	
	  /**
	   * Test whether value x is smaller or equal to y.
	   *
	   * The function returns true when x is smaller than y or the relative
	   * difference between x and y is smaller than the configured epsilon. The
	   * function cannot be used to compare values smaller than approximately 2.22e-16.
	   *
	   * For matrices, the function is evaluated element wise.
	   * Strings are compared by their numerical value.
	   *
	   * Syntax:
	   *
	   *    math.smallerEq(x, y)
	   *
	   * Examples:
	   *
	   *    math.smaller(1 + 2, 3);        // returns false
	   *    math.smallerEq(1 + 2, 3);      // returns true
	   *
	   * See also:
	   *
	   *    equal, unequal, smaller, larger, largerEq, compare
	   *
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
	   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
	   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
	   */
	  var smallerEq = typed('smallerEq', {
	
	    'boolean, boolean': function (x, y) {
	      return x <= y;
	    },
	
	    'number, number': function (x, y) {
	      return x <= y || nearlyEqual(x, y, config.epsilon);
	    },
	
	    'BigNumber, BigNumber': function (x, y) {
	      return x.lte(y) || bigNearlyEqual(x, y, config.epsilon);
	    },
	
	    'Fraction, Fraction': function (x, y) {
	      return x.compare(y) !== 1;
	    },
	
	    'Complex, Complex': function () {
	      throw new TypeError('No ordering relation is defined for complex numbers');
	    },
	
	    'Unit, Unit': function (x, y) {
	      if (!x.equalBase(y)) {
	        throw new Error('Cannot compare units with different base');
	      }
	      return smallerEq(x.value, y.value);
	    },
	
	    'SparseMatrix, SparseMatrix': function(x, y) {
	      return algorithm07(x, y, smallerEq);
	    },
	
	    'SparseMatrix, DenseMatrix': function(x, y) {
	      return algorithm03(y, x, smallerEq, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function(x, y) {
	      return algorithm03(x, y, smallerEq, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function(x, y) {
	      return algorithm13(x, y, smallerEq);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return smallerEq(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return smallerEq(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return smallerEq(x, matrix(y));
	    },
	
	    'SparseMatrix, any': function (x, y) {
	      return algorithm12(x, y, smallerEq, false);
	    },
	
	    'DenseMatrix, any': function (x, y) {
	      return algorithm14(x, y, smallerEq, false);
	    },
	
	    'any, SparseMatrix': function (x, y) {
	      return algorithm12(y, x, smallerEq, true);
	    },
	
	    'any, DenseMatrix': function (x, y) {
	      return algorithm14(y, x, smallerEq, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, smallerEq, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, smallerEq, true).valueOf();
	    }
	  });
	
	  smallerEq.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['smallerEq'] + '${args[1]}\\right)'
	  };
	
	  return smallerEq;
	}
	
	exports.name = 'smallerEq';
	exports.factory = factory;


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1825),
	  __webpack_require__(1826),
	  __webpack_require__(1827),
	  __webpack_require__(1828),
	  __webpack_require__(1829),
	  __webpack_require__(1830),
	  __webpack_require__(1831),
	  __webpack_require__(1832),
	  __webpack_require__(1833),
	  __webpack_require__(1834)
	];


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var matrix = load(__webpack_require__(1362));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Create the cartesian product of two (multi)sets.
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setCartesian(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setCartesian([1, 2], [3, 4]);        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
	   *
	   * See also:
	   *
	   *    setUnion, setIntersect, setDifference, setPowerset
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {Array | Matrix}    The cartesian product of two (multi)sets
	   */
	  var setCartesian = typed('setCartesian', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0 || subset(size(a2), new index(0)) === 0) { // if any of them is empty, return empty
	        var result = [];
	      }
	      else {
	        var b1 = flatten(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
	        var b2 = flatten(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
	        var result = [];
	        for (var i=0; i<b1.length; i++) {
	          for (var j=0; j<b2.length; j++) {
	            result.push([b1[i], b2[j]]);
	          }
	        }
	      }
	      // return an array, if both inputs were arrays
	      if (Array.isArray(a1) && Array.isArray(a2)) {
	        return result;
	      }
	      // return a matrix otherwise
	      return new matrix(result);
	    }
	  });
	
	  return setCartesian;
	}
	
	exports.name = 'setCartesian';
	exports.factory = factory;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	var identify = __webpack_require__(1357).identify;
	var generalize = __webpack_require__(1357).generalize;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var matrix = load(__webpack_require__(1362));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setDifference(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2]
	   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2]
	   *
	   * See also:
	   *
	   *    setUnion, setIntersect, setSymDifference
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {Array | Matrix}    The difference of two (multi)sets
	   */
	  var setDifference = typed('setDifference', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0) { // empty-anything=empty
	        var result = [];
	      }
	      else if (subset(size(a2), new index(0)) === 0) { // anything-empty=anything
	        return flatten(a1.toArray());
	      }
	      else {
	        var b1 = identify(flatten(Array.isArray(a1) ? a1: a1.toArray()).sort(compareNatural));
	        var b2 = identify(flatten(Array.isArray(a2) ? a2: a2.toArray()).sort(compareNatural));
	        var result = [];
	        var inb2;
	        for (var i=0; i<b1.length; i++) {
	          inb2 = false;
	          for (var j=0; j<b2.length; j++) {
	            if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
	              inb2 = true;
	              break;
	            }
	          }
	          if (!inb2) {
	            result.push(b1[i]);
	          }
	        }
	      }
	      // return an array, if both inputs were arrays
	      if (Array.isArray(a1) && Array.isArray(a2)) {
	        return generalize(result);
	      }
	      // return a matrix otherwise
	      return new matrix(generalize(result));
	    }
	  });
	
	  return setDifference;
	}
	
	exports.name = 'setDifference';
	exports.factory = factory;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var matrix = load(__webpack_require__(1362));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Collect the distinct elements of a multiset.
	   * A multi-dimension array will be converted to a single-dimension array before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setDistinct(set)
	   *
	   * Examples:
	   *
	   *    math.setDistinct([1, 1, 1, 2, 2, 3]);        // returns [1, 2, 3]
	   *
	   * See also:
	   *
	   *    setMultiplicity
	   *
	   * @param {Array | Matrix}    a  A multiset
	   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
	   */
	  var setDistinct = typed('setDistinct', {
	    'Array | Matrix': function (a) {
	      if (subset(size(a), new index(0)) === 0) { // if empty, return empty
	        var result = [];
	      }
	      else {
	        var b = flatten(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
	        var result = [];
	        result.push(b[0]);
	        for (var i=1; i<b.length; i++) {
	          if (compareNatural(b[i], b[i-1]) !== 0) {
	            result.push(b[i]);
	          }
	        }
	      }
	      // return an array, if the input was an array
	      if (Array.isArray(a)) {
	        return result;
	      }
	      // return a matrix otherwise
	      return new matrix(result);
	    }
	  });
	
	  return setDistinct;
	}
	
	exports.name = 'setDistinct';
	exports.factory = factory;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	var identify = __webpack_require__(1357).identify;
	var generalize = __webpack_require__(1357).generalize;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var matrix = load(__webpack_require__(1362));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Create the intersection of two (multi)sets.
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setIntersect(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [3, 4]
	   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [3, 4]
	   *
	   * See also:
	   *
	   *    setUnion, setDifference
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {Array | Matrix}    The intersection of two (multi)sets
	   */
	  var setIntersect = typed('setIntersect', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0 || subset(size(a2), new index(0)) === 0) { // of any of them is empty, return empty
	        var result = [];
	      }
	      else {
	        var b1 = identify(flatten(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
	        var b2 = identify(flatten(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
	        var result = [];
	        for (var i=0; i<b1.length; i++) {
	          for (var j=0; j<b2.length; j++) {
	              if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
	                result.push(b1[i]);
	                break;
	              }
	          }
	        }
	      }
	      // return an array, if both inputs were arrays
	      if (Array.isArray(a1) && Array.isArray(a2)) {
	        return generalize(result);
	      }
	      // return a matrix otherwise
	      return new matrix(generalize(result));
	    }
	  });
	
	  return setIntersect;
	}
	
	exports.name = 'setIntersect';
	exports.factory = factory;


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	var identify = __webpack_require__(1357).identify;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setIsSubset(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setIsSubset([1, 2], [3, 4, 5, 6]);        // returns false
	   *    math.setIsSubset([3, 4], [3, 4, 5, 6]);        // returns true
	   *
	   * See also:
	   *
	   *    setUnion, setIntersect, setDifference
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {boolean}            true | false
	   */
	  var setIsSubset = typed('setIsSubset', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0) { // empty is a subset of anything
	        return true;
	      }
	      else if (subset(size(a2), new index(0)) === 0) { // anything is not a subset of empty
	        return false;
	      }
	      var b1 = identify(flatten(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
	      var b2 = identify(flatten(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
	      var inb2;
	      for (var i=0; i<b1.length; i++) {
	        inb2 = false;
	        for (var j=0; j<b2.length; j++) {
	          if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
	            inb2 = true;
	            break;
	          }
	        }
	        if (inb2 === false) {
	          return false;
	        }
	      }
	      return true;
	    }
	  });
	
	  return setIsSubset;
	}
	
	exports.name = 'setIsSubset';
	exports.factory = factory;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var compareNatural = load(__webpack_require__(1804));
	  var index = load(__webpack_require__(1382));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  
	  /**
	   * Count the multiplicity of an element in a multiset.
	   * A multi-dimension array will be converted to a single-dimension array before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setMultiplicity(element, set)
	   *
	   * Examples:
	   *
	   *    math.setMultiplicity(1, [1, 2, 2, 4]);    // returns 1
	   *    math.setMultiplicity(2, [1, 2, 2, 4]);    // returns 2
	   *
	   * See also:
	   *
	   *    setDistinct, setSize
	   *
	   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
	   * @param {Array | Matrix}     a  A multiset
	   * @return {number}            The number of how many times the multiset contains the element
	   */
	  var setMultiplicity = typed('setMultiplicity', {
	    'number | BigNumber | Fraction | Complex, Array | Matrix': function (e, a) {
	      if (subset(size(a), new index(0)) === 0) { // if empty, return 0
	        return 0;
	      }
	      var b = flatten(Array.isArray(a) ? a : a.toArray());
	      var count = 0;
	      for (var i=0; i<b.length; i++) {
	        if (compareNatural(b[i], e) === 0) {
	          count++;
	        }
	      }
	      return count;
	    }
	  });
	
	  return setMultiplicity;
	}
	
	exports.name = 'setMultiplicity';
	exports.factory = factory;


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
	   * A multi-dimension array will be converted to a single-dimension array before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setPowerset(set)
	   *
	   * Examples:
	   *
	   *    math.setPowerset([1, 2, 3]);        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
	   *
	   * See also:
	   *
	   *    setCartesian
	   *
	   * @param {Array | Matrix}    a  A (multi)set
	   * @return {Array}    The powerset of the (multi)set
	   */
	  var setPowerset = typed('setPowerset', {
	    'Array | Matrix': function (a) {
	      if (subset(size(a), new index(0)) === 0) { // if empty, return empty
	        return [];
	      }
	      var b = flatten(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
	      var result = [];
	      var number = 0;
	      while (number.toString(2).length <= b.length) {
	        result.push(_subset(b, number.toString(2).split("").reverse()));
	        number++;
	      }
	      // can not return a matrix, because of the different size of the subarrays
	      return _sort(result);
	    }
	  });
	
	  return setPowerset;
	  
	  // create subset
	  function _subset(array, bitarray) {
	    var result = [];
	    for (var i=0; i<bitarray.length; i++) {
	      if (bitarray[i] === "1") {
	        result.push(array[i]);
	      }
	    }
	    return result;
	  }
	  
	  // sort subsests by length
	  function _sort(array) {
	    var temp = [];
	    for (var i=array.length-1; i>0; i--) {
	      for (var j=0; j<i; j++) {
	        if (array[j].length > array[j+1].length) {
	          temp = array[j];
	          array[j] = array[j+1];
	          array[j+1] = temp;
	        }
	      }
	    }
	    return array;
	  }
	}
	
	exports.name = 'setPowerset';
	exports.factory = factory;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var compareNatural = load(__webpack_require__(1804));
	  
	  /**
	   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
	   * A multi-dimension array will be converted to a single-dimension array before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setSize(set)
	   *    math.setSize(set, unique)
	   *
	   * Examples:
	   *
	   *    math.setSize([1, 2, 2, 4]);          // returns 4
	   *    math.setSize([1, 2, 2, 4], true);    // returns 3
	   *
	   * See also:
	   *
	   *    setUnion, setIntersect, setDifference
	   *
	   * @param {Array | Matrix}    a  A multiset
	   * @return {number}            The number of elements of the (multi)set
	   */
	  var setSize = typed('setSize', {
	    'Array | Matrix': function (a) {
	      return Array.isArray(a) ? flatten(a).length : flatten(a.toArray()).length;
	    },
	    'Array | Matrix, boolean': function (a, unique) {
	      if (unique === false || a.length === 0) {
	        return Array.isArray(a) ? flatten(a).length : flatten(a.toArray()).length;
	      }
	      else {
	        var b = flatten(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
	        var count = 1;
	        for (var i=1; i<b.length; i++) {
	          if (compareNatural(b[i], b[i-1]) !== 0) {
	            count++;
	          }
	        }
	        return count;
	      }
	    }
	  });
	
	  return setSize;
	}
	
	exports.name = 'setSize';
	exports.factory = factory;


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var concat = load(__webpack_require__(1654));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var setDifference = load(__webpack_require__(1826));
	  
	  /**
	   * Create the symmetric difference of two (multi)sets.
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setSymDifference(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2, 5, 6]
	   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2, 5, 6]
	   *
	   * See also:
	   *
	   *    setUnion, setIntersect, setDifference
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
	   */
	  var setSymDifference = typed('setSymDifference', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0) { // if any of them is empty, return the other one
	        return flatten(a2);
	      }
	      else if (subset(size(a2), new index(0)) === 0) {
	        return flatten(a1);
	      }
	      var b1 = flatten(a1);
	      var b2 = flatten(a2);
	      return concat(setDifference(b1, b2), setDifference(b2, b1));
	    }
	  });
	
	  return setSymDifference;
	}
	
	exports.name = 'setSymDifference';
	exports.factory = factory;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var index = load(__webpack_require__(1382));
	  var concat = load(__webpack_require__(1654));
	  var size = load(__webpack_require__(1802));
	  var subset = load(__webpack_require__(1630));
	  var setIntersect = load(__webpack_require__(1828));
	  var setSymDifference = load(__webpack_require__(1833));
	  
	  /**
	   * Create the union of two (multi)sets.
	   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
	   *
	   * Syntax:
	   *
	   *    math.setUnion(set1, set2)
	   *
	   * Examples:
	   *
	   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2, 3, 4, 5, 6]
	   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2, 3, 4, 5, 6]
	   *
	   * See also:
	   *
	   *    setIntersect, setDifference
	   *
	   * @param {Array | Matrix}    a1  A (multi)set
	   * @param {Array | Matrix}    a2  A (multi)set
	   * @return {Array | Matrix}    The union of two (multi)sets
	   */
	  var setUnion = typed('setUnion', {
	    'Array | Matrix, Array | Matrix': function (a1, a2) {
	      if (subset(size(a1), new index(0)) === 0) { // if any of them is empty, return the other one
	        return flatten(a2);
	      }
	      else if (subset(size(a2), new index(0)) === 0) {
	        return flatten(a1);
	      }
	      var b1 = flatten(a1);
	      var b2 = flatten(a2);
	      return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
	    }
	  });
	
	  return setUnion;
	}
	
	exports.name = 'setUnion';
	exports.factory = factory;


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1836)
	];


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var sign = __webpack_require__(1324).sign;
	
	
	function factory (type, config, load, typed) {
	  /**
	   * Compute the erf function of a value using a rational Chebyshev
	   * approximations for different intervals of x.
	   *
	   * This is a translation of W. J. Cody's Fortran implementation from 1987
	   * ( http://www.netlib.org/specfun/erf ). See the AMS publication
	   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
	   * for an explanation of this process.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.erf(x)
	   *
	   * Examples:
	   *
	   *    math.erf(0.2);    // returns 0.22270258921047847
	   *    math.erf(-0.5);   // returns -0.5204998778130465
	   *    math.erf(4);      // returns 0.9999999845827421
	   *
	   * @param {number | Array | Matrix} x   A real number
	   * @return {number | Array | Matrix}    The erf of `x`
	   */
	  var erf = typed('erf', {
	    'number': function (x) {
	      var y = Math.abs(x);
	
	      if (y >= MAX_NUM) {
	        return sign(x);
	      }
	      if (y <= THRESH) {
	        return sign(x) * erf1(y);
	      }
	      if (y <= 4.0) {
	        return sign(x) * (1 - erfc2(y));
	      }
	      return sign(x) * (1 - erfc3(y));
	    },
	
	    // TODO: Not sure if there's a way to guarantee some degree of accuracy here.
	    //  Perhaps it would be best to set the precision of the number to that which
	    //  is guaranteed by erf()
	    'BigNumber': function (n) {
	      return new type.BigNumber(erf(n.toNumber()));
	    },
	
	    'Array | Matrix': function (n) {
	      return deepMap(n, erf);
	    }
	
	    // TODO: For complex numbers, use the approximation for the Faddeeva function
	    //  from "More Efficient Computation of the Complex Error Function" (AMS)
	
	  });
	
	  /**
	   * Approximates the error function erf() for x <= 0.46875 using this function:
	   *               n
	   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
	   *              j=0
	   */
	  function erf1(y) {
	    var ysq = y * y;
	    var xnum = P[0][4]*ysq;
	    var xden = ysq;
	    var i;
	
	    for (i = 0; i < 3; i += 1) {
	      xnum = (xnum + P[0][i]) * ysq;
	      xden = (xden + Q[0][i]) * ysq;
	    }
	    return y * (xnum + P[0][3]) / (xden + Q[0][3]);
	  }
	
	  /**
	   * Approximates the complement of the error function erfc() for
	   * 0.46875 <= x <= 4.0 using this function:
	   *                       n
	   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
	   *                      j=0
	   */
	  function erfc2(y) {
	    var xnum = P[1][8] * y;
	    var xden = y;
	    var i;
	
	    for (i = 0; i < 7; i += 1) {
	      xnum = (xnum + P[1][i]) * y;
	      xden = (xden + Q[1][i]) * y;
	    }
	    var result = (xnum + P[1][7]) / (xden + Q[1][7]);
	    var ysq = parseInt(y * 16) / 16;
	    var del = (y - ysq) * (y + ysq);
	    return Math.exp(-ysq*ysq) * Math.exp(-del) * result;
	  }
	
	  /**
	   * Approximates the complement of the error function erfc() for x > 4.0 using
	   * this function:
	   *
	   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
	   *               n
	   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
	   *              j=0
	   */
	  function erfc3(y) {
	    var ysq = 1 / (y * y);
	    var xnum = P[2][5] * ysq;
	    var xden = ysq;
	    var i;
	
	    for (i = 0; i < 4; i += 1) {
	      xnum = (xnum + P[2][i]) * ysq;
	      xden = (xden + Q[2][i]) * ysq;
	    }
	    var result = ysq * (xnum + P[2][4]) / (xden + Q[2][4]);
	    result = (SQRPI - result) / y;
	    ysq = parseInt(y * 16) / 16;
	    var del = (y - ysq) * (y + ysq);
	    return Math.exp(-ysq*ysq) * Math.exp(-del) * result;
	  }
	
	  erf.toTex = {1: 'erf\\left(${args[0]}\\right)'};
	
	  return erf;
	}
	
	/**
	 * Upper bound for the first approximation interval, 0 <= x <= THRESH
	 * @constant
	 */
	var THRESH = 0.46875;
	
	/**
	 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
	 * @constant
	 */
	var SQRPI = 5.6418958354775628695e-1;
	
	/**
	 * Coefficients for each term of the numerator sum (p_j) for each approximation
	 * interval (see W. J. Cody's paper for more details)
	 * @constant
	 */
	var P = [[
	  3.16112374387056560e00, 1.13864154151050156e02,
	  3.77485237685302021e02, 3.20937758913846947e03,
	  1.85777706184603153e-1
	], [
	  5.64188496988670089e-1, 8.88314979438837594e00,
	  6.61191906371416295e01, 2.98635138197400131e02,
	  8.81952221241769090e02, 1.71204761263407058e03,
	  2.05107837782607147e03, 1.23033935479799725e03,
	  2.15311535474403846e-8
	], [
	  3.05326634961232344e-1, 3.60344899949804439e-1,
	  1.25781726111229246e-1, 1.60837851487422766e-2,
	  6.58749161529837803e-4, 1.63153871373020978e-2
	]];
	
	/**
	 * Coefficients for each term of the denominator sum (q_j) for each approximation
	 * interval (see W. J. Cody's paper for more details)
	 * @constant
	 */
	var Q = [[
	  2.36012909523441209e01, 2.44024637934444173e02,
	  1.28261652607737228e03, 2.84423683343917062e03
	], [
	  1.57449261107098347e01, 1.17693950891312499e02,
	  5.37181101862009858e02, 1.62138957456669019e03,
	  3.29079923573345963e03, 4.36261909014324716e03,
	  3.43936767414372164e03, 1.23033935480374942e03
	], [
	  2.56852019228982242e00, 1.87295284992346047e00,
	  5.27905102951428412e-1, 6.05183413124413191e-2,
	  2.33520497626869185e-3
	]];
	
	/**
	 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
	 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
	 * return 1
	 */
	var MAX_NUM = Math.pow(2, 53);
	
	
	exports.name = 'erf';
	exports.factory = factory;


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1838),
	  __webpack_require__(1662),
	  __webpack_require__(1668),
	  __webpack_require__(1839),
	  __webpack_require__(1674),
	  __webpack_require__(1840),
	  __webpack_require__(1841),
	  __webpack_require__(1842),
	  __webpack_require__(1843),
	  __webpack_require__(1810),
	  __webpack_require__(1844)
	];


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	  var abs      = load(__webpack_require__(1402));
	  var map      = load(__webpack_require__(1796));
	  var median   = load(__webpack_require__(1839));
	  var subtract = load(__webpack_require__(1393));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the median absolute deviation of a matrix or a list with values.
	   * The median absolute deviation is defined as the median of the absolute
	   * deviations from the median.
	   *
	   * Syntax:
	   *
	   *     math.mad(a, b, c, ...)
	   *     math.mad(A)
	   *
	   * Examples:
	   *
	   *     math.mad(10, 20, 30);             // returns 10
	   *     math.mad([1, 2, 3]);              // returns 1
	   *     math.mad([[1, 2, 3], [4, 5, 6]]); // returns 1.5
	   *
	   * See also:
	   *
	   *     median, mean, std, abs
	   *
	   * @param {Array | Matrix} array
	   *                        A single matrix or multiple scalar values.
	   * @return {*} The median absolute deviation.
	   */
	  var mad = typed('mad', {
	    // mad([a, b, c, d, ...])
	    'Array | Matrix': _mad,
	
	    // mad(a, b, c, d, ...)
	    '...': function (args) {
	      return _mad(args);
	    }
	  });
	
	  mad.toTex = undefined; // use default template
	
	  return mad;
	
	  function _mad(array) {
	    array = flatten(array.valueOf());
	
	    if (array.length === 0) {
	      throw new Error('Cannot calculate median absolute deviation (mad) of an empty array');
	    }
	
	    try {
	      var med = median(array);
	      return median(map(array, function (value) {
	        return abs(subtract(value, med));
	      }));
	    }
	    catch (err) {
	      if (err instanceof TypeError && err.message.indexOf('median') !== -1) {
	        throw new TypeError(err.message.replace('median', 'mad'));
	      }
	      else {
	        throw improveErrorMessage(err, 'mad');
	      }
	    }
	  }
	}
	
	exports.name = 'mad';
	exports.factory = factory;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	var containsCollections = __webpack_require__(1665);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1369));
	  var divide = load(__webpack_require__(1397));
	  var compare = load(__webpack_require__(1799));
	  var partitionSelect = load(__webpack_require__(1798));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the median of a matrix or a list with values. The values are
	   * sorted and the middle value is returned. In case of an even number of
	   * values, the average of the two middle values is returned.
	   * Supported types of values are: Number, BigNumber, Unit
	   *
	   * In case of a (multi dimensional) array or matrix, the median of all
	   * elements will be calculated.
	   *
	   * Syntax:
	   *
	   *     math.median(a, b, c, ...)
	   *     math.median(A)
	   *
	   * Examples:
	   *
	   *     math.median(5, 2, 7);        // returns 5
	   *     math.median([3, -1, 5, 7]);  // returns 4
	   *
	   * See also:
	   *
	   *     mean, min, max, sum, prod, std, var, quantileSeq
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The median
	   */
	  var median = typed('median', {
	    // median([a, b, c, d, ...])
	    'Array | Matrix': _median,
	
	    // median([a, b, c, d, ...], dim)
	    'Array | Matrix, number | BigNumber': function (array, dim) {
	      // TODO: implement median(A, dim)
	      throw new Error('median(A, dim) is not yet supported');
	      //return reduce(arguments[0], arguments[1], ...);
	    },
	
	    // median(a, b, c, d, ...)
	    '...': function (args) {
	      if (containsCollections(args)) {
	          throw new TypeError('Scalar values expected in function median');
	      }
	
	      return _median(args);
	    }
	  });
	
	
	  /**
	   * Recursively calculate the median of an n-dimensional array
	   * @param {Array} array
	   * @return {Number} median
	   * @private
	   */
	  function _median(array) {
	    try {
	      array = flatten(array.valueOf());
	
	      var num = array.length;
	      if (num == 0) {
	        throw new Error('Cannot calculate median of an empty array');
	      }
	
	      if (num % 2 == 0) {
	        // even: return the average of the two middle values
	        var mid = num / 2 - 1;
	        var right = partitionSelect(array, mid + 1);
	
	        // array now partitioned at mid + 1, take max of left part
	        var left = array[mid];
	        for (var i = 0; i < mid; ++i) {
	          if (compare(array[i], left) > 0) {
	            left = array[i];
	          }
	        }
	
	        return middle2(left, right);
	      }
	      else {
	        // odd: return the middle value
	        var m = partitionSelect(array, (num - 1) / 2);
	
	        return middle(m);
	      }
	    }
	    catch (err) {
	      throw improveErrorMessage(err, 'median');
	    }
	  }
	
	  // helper function to type check the middle value of the array
	  var middle = typed({
	    'number | BigNumber | Complex | Unit': function (value) {
	      return value;
	    }
	  });
	
	  // helper function to type check the two middle value of the array
	  var middle2 = typed({
	    'number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit': function (left, right) {
	      return divide(add(left, right), 2);
	    }
	  });
	
	  median.toTex = undefined; // use default template
	
	  return median;
	}
	
	exports.name = 'median';
	exports.factory = factory;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var flatten = __webpack_require__(1357).flatten;
	
	function factory (type, config, load, typed) {
	
	  /**
	  * Computes the mode of a set of numbers or a list with values(numbers or characters).
	  * If there are more than one modes, it returns a list of those values.
	  *
	  * Syntax:
	  *
	  *     math.mode(a, b, c, ...)
	  *     math.mode(A)
	  *
	  * Examples:
	  *
	  *     math.mode(2, 1, 4, 3, 1);                            // returns [1]
	  *     math.mode([1, 2.7, 3.2, 4, 2.7]);                    // returns [2.7]
	  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
	  *     math.mode('a','a','b','c')                           // returns ["a"]
	  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
	  *
	  * See also:
	  *
	  *     median,
	  *     mean
	  *
	  * @param {... *} args  A single matrix
	  * @return {*} The mode of all values
	  */
	
	  var mode = typed('mode', {
	    'Array | Matrix' : _mode,
	    
	    '...': function (args) {
	      return _mode(args);
	    }
	  });
	  
	  return mode;
	
	  /**
	   * Calculates the mode in an 1-dimensional array
	   * @param {Array} values
	   * @return {number} mode
	   * @private
	   */
	  function _mode(values) {
	    values = flatten(values.valueOf());
	    var num = values.length;
	    if (num == 0) {
	      throw new Error('Cannot calculate mode of an empty array');
	    }
	    
	    var count = {},
	        mode = [],
	        max = 0;
	    for (var i in values) {
	      if (!(values[i] in count)){
	        count[values[i]] = 0;
	      }
	      count[values[i]]++;
	      if (count[values[i]] == max){
	        mode.push(values[i]);
	      }
	      else if (count[values[i]] > max) {
	        max = count[values[i]];
	        mode = [values[i]];
	      }
	    }
	    return mode; 
	  };
	}
	
	exports.name = 'mode';
	exports.factory = factory;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepForEach = __webpack_require__(1663);
	
	function factory (type, config, load, typed) {
	  var multiply = load(__webpack_require__(1396));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the product of a matrix or a list with values.
	   * In case of a (multi dimensional) array or matrix, the sum of all
	   * elements will be calculated.
	   *
	   * Syntax:
	   *
	   *     math.prod(a, b, c, ...)
	   *     math.prod(A)
	   *
	   * Examples:
	   *
	   *     math.multiply(2, 3);           // returns 6
	   *     math.prod(2, 3);               // returns 6
	   *     math.prod(2, 3, 4);            // returns 24
	   *     math.prod([2, 3, 4]);          // returns 24
	   *     math.prod([[2, 5], [4, 3]]);   // returns 120
	   *
	   * See also:
	   *
	   *    mean, median, min, max, sum, std, var
	   *
	   * @param {... *} args  A single matrix or or multiple scalar values
	   * @return {*} The product of all values
	   */
	  var prod = typed('prod', {
	    // prod([a, b, c, d, ...])
	    'Array | Matrix': _prod,
	
	    // prod([a, b, c, d, ...], dim)
	    'Array | Matrix, number | BigNumber': function (array, dim) {
	      // TODO: implement prod(A, dim)
	      throw new Error('prod(A, dim) is not yet supported');
	      //return reduce(arguments[0], arguments[1], math.prod);
	    },
	
	    // prod(a, b, c, d, ...)
	    '...': function (args) {
	      return _prod(args);
	    }
	  });
	
	  prod.toTex = undefined; // use default template
	
	  return prod;
	
	  /**
	   * Recursively calculate the product of an n-dimensional array
	   * @param {Array} array
	   * @return {number} prod
	   * @private
	   */
	  function _prod(array) {
	    var prod = undefined;
	
	    deepForEach(array, function (value) {
	      try {
	        prod = (prod === undefined) ? value : multiply(prod, value);
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'prod', value);
	      }
	    });
	
	    if (prod === undefined) {
	      throw new Error('Cannot calculate prod of an empty array');
	    }
	
	    return prod;
	  }
	}
	
	exports.name = 'prod';
	exports.factory = factory;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isInteger = __webpack_require__(1324).isInteger;
	var isNumber = __webpack_require__(1324).isNumber;
	var flatten = __webpack_require__(1357).flatten;
	var isCollection = __webpack_require__(1661);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1367));
	  var multiply = load(__webpack_require__(1400));
	  var partitionSelect = load(__webpack_require__(1798));
	  var compare = load(__webpack_require__(1799));
	
	  /**
	   * Compute the prob order quantile of a matrix or a list with values.
	   * The sequence is sorted and the middle value is returned.
	   * Supported types of sequence values are: Number, BigNumber, Unit
	   * Supported types of probability are: Number, BigNumber
	   *
	   * In case of a (multi dimensional) array or matrix, the prob order quantile
	   * of all elements will be calculated.
	   *
	   * Syntax:
	   *
	   *     math.quantileSeq(A, prob[, sorted])
	   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
	   *     math.quantileSeq(A, N[, sorted])
	   *
	   * Examples:
	   *
	   *     math.quantileSeq([3, -1, 5, 7], 0.5);         // returns 4
	   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3]);  // returns [3, 5]
	   *     math.quantileSeq([3, -1, 5, 7], 2);           // returns [3, 5]
	   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true);   // returns 4
	   *
	   * See also:
	   *
	   *     median, mean, min, max, sum, prod, std, var
	   *
	   * @param {Array, Matrix} data                A single matrix or Array
	   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
	   *                                            the amount of evenly distributed steps of
	   *                                            probabilities; only one of these options can
	   *                                            be provided
	   * @param {Boolean} sorted=false              is data sorted in ascending order
	   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
	   */
	  function quantileSeq(data, probOrN, sorted) {
	    var probArr, dataArr, one;
	
	    if (arguments.length < 2 || arguments.length > 3) {
	      throw new SyntaxError('Function quantileSeq requires two or three parameters');
	    }
	
	    if (isCollection(data)) {
	      sorted = sorted || false;
	      if (typeof sorted === 'boolean') {
	        dataArr = data.valueOf();
	        if (isNumber(probOrN)) {
	          if (probOrN < 0) {
	            throw new Error('N/prob must be non-negative');
	          }
	
	          if (probOrN <= 1) {
	            // quantileSeq([a, b, c, d, ...], prob[,sorted])
	            return _quantileSeq(dataArr, probOrN, sorted);
	          }
	
	          if (probOrN > 1) {
	            // quantileSeq([a, b, c, d, ...], N[,sorted])
	            if (!isInteger(probOrN)) {
	              throw new Error('N must be a positive integer');
	            }
	
	            var nPlusOne = probOrN + 1;
	            probArr = new Array(probOrN);
	            for (var i = 0; i < probOrN;) {
	              probArr[i] = _quantileSeq(dataArr, (++i) / nPlusOne, sorted);
	            }
	            return probArr;
	          }
	        }
	
	        if (type.isBigNumber(probOrN)) {
	          if (probOrN.isNegative()) {
	            throw new Error('N/prob must be non-negative');
	          }
	
	          one = new probOrN.constructor(1);
	
	          if (probOrN.lte(one)) {
	            // quantileSeq([a, b, c, d, ...], prob[,sorted])
	            return _quantileSeq(dataArr, probOrN, sorted);
	          }
	
	          if (probOrN.gt(one)) {
	            // quantileSeq([a, b, c, d, ...], N[,sorted])
	            if (!probOrN.isInteger()) {
	              throw new Error('N must be a positive integer');
	            }
	
	            // largest possible Array length is 2^32-1;
	            // 2^32 < 10^15, thus safe conversion guaranteed
	            var intN = probOrN.toNumber();
	            if (intN > 4294967295) {
	              throw new Error('N must be less than or equal to 2^32-1, as that is the maximum length of an Array');
	            }
	
	            var nPlusOne = new type.BigNumber(intN + 1);
	            probArr = new Array(intN);
	            for (var i = 0; i < intN;) {
	              probArr[i] = _quantileSeq(dataArr, new type.BigNumber(++i).div(nPlusOne), sorted);
	            }
	            return probArr;
	          }
	        }
	
	        if (Array.isArray(probOrN)) {
	          // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
	          probArr = new Array(probOrN.length);
	          for (var i = 0; i < probArr.length; ++i) {
	            var currProb = probOrN[i];
	            if (isNumber(currProb)) {
	              if (currProb < 0 || currProb > 1) {
	                throw new Error('Probability must be between 0 and 1, inclusive');
	              }
	            } else if (type.isBigNumber(currProb)) {
	              one = new currProb.constructor(1);
	              if (currProb.isNegative() || currProb.gt(one)) {
	                throw new Error('Probability must be between 0 and 1, inclusive');
	              }
	            } else {
	              throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
	            }
	
	            probArr[i] = _quantileSeq(dataArr, currProb, sorted);
	          }
	          return probArr;
	        }
	
	        throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
	      }
	
	      throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
	    }
	
	    throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
	  }
	
	  /**
	   * Calculate the prob order quantile of an n-dimensional array.
	   * 
	   * @param {Array} array
	   * @param {Number, BigNumber} prob
	   * @param {Boolean} sorted
	   * @return {Number, BigNumber, Unit} prob order quantile
	   * @private
	   */
	  function _quantileSeq(array, prob, sorted) {
	    var flat = flatten(array);
	    var len = flat.length;
	    if (len === 0) {
	      throw new Error('Cannot calculate quantile of an empty sequence');
	    }
	
	    if (isNumber(prob)) {
	      var index = prob * (len-1);
	      var fracPart = index % 1;
	      if (fracPart === 0) {
	        var value = sorted ? flat[index] : partitionSelect(flat, index);
	
	        validate(value);
	
	        return value;
	      }
	
	      var integerPart = Math.floor(index);
	
	      var left, right;
	      if (sorted) {
	        left = flat[integerPart];
	        right = flat[integerPart+1];
	      } else {
	        right = partitionSelect(flat, integerPart+1);
	
	        // max of partition is kth largest
	        left = flat[integerPart];
	        for (var i = 0; i < integerPart; ++i) {
	          if (compare(flat[i], left) > 0) {
	            left = flat[i];
	          }
	        }
	      }
	
	      validate(left);
	      validate(right);
	
	      // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
	      return add(multiply(left, 1 - fracPart), multiply(right, fracPart));
	    }
	
	    // If prob is a BigNumber
	    var index = prob.times(len-1);
	    if (index.isInteger()) {
	      index = index.toNumber();
	      var value = sorted ? flat[index] : partitionSelect(flat, index);
	
	      validate(value);
	
	      return value;
	    }
	
	    var integerPart = index.floor();
	    var fracPart = index.minus(integerPart);
	    var integerPartNumber = integerPart.toNumber();
	
	    var left, right;
	    if (sorted) {
	      left = flat[integerPartNumber];
	      right = flat[integerPartNumber+1];
	    } else {
	      right = partitionSelect(flat, integerPartNumber+1);
	
	      // max of partition is kth largest
	      left = flat[integerPartNumber];
	      for (var i = 0; i < integerPartNumber; ++i) {
	        if (compare(flat[i], left) > 0) {
	          left = flat[i];
	        }
	      }
	    }
	
	    validate(left);
	    validate(right);
	
	    // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
	    var one = new fracPart.constructor(1);
	    return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
	  }
	
	  /**
	   * Check if array value types are valid, throw error otherwise.
	   * @param {number | BigNumber | Unit} x
	   * @param {number | BigNumber | Unit} x
	   * @private
	   */
	  var validate = typed({
	    'number | BigNumber | Unit': function (x) {
	      return x;
	    }
	  });
	
	  return quantileSeq;
	}
	
	exports.name = 'quantileSeq';
	exports.factory = factory;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var sqrt       = load(__webpack_require__(1694));
	  var variance   = load(__webpack_require__(1844));
	
	  /**
	   * Compute the standard deviation of a matrix or a  list with values.
	   * The standard deviations is defined as the square root of the variance:
	   * `std(A) = sqrt(var(A))`.
	   * In case of a (multi dimensional) array or matrix, the standard deviation
	   * over all elements will be calculated.
	   *
	   * Optionally, the type of normalization can be specified as second
	   * parameter. The parameter `normalization` can be one of the following values:
	   *
	   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
	   * - 'uncorrected'        The sum of squared errors is divided by n
	   * - 'biased'             The sum of squared errors is divided by (n + 1)
	   *
	   * Syntax:
	   *
	   *     math.std(a, b, c, ...)
	   *     math.std(A)
	   *     math.std(A, normalization)
	   *
	   * Examples:
	   *
	   *     math.std(2, 4, 6);                     // returns 2
	   *     math.std([2, 4, 6, 8]);                // returns 2.581988897471611
	   *     math.std([2, 4, 6, 8], 'uncorrected'); // returns 2.23606797749979
	   *     math.std([2, 4, 6, 8], 'biased');      // returns 2
	   *
	   *     math.std([[1, 2, 3], [4, 5, 6]]);      // returns 1.8708286933869707
	   *
	   * See also:
	   *
	   *    mean, median, max, min, prod, sum, var
	   *
	   * @param {Array | Matrix} array
	   *                        A single matrix or or multiple scalar values
	   * @param {string} [normalization='unbiased']
	   *                        Determines how to normalize the variance.
	   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
	   * @return {*} The standard deviation
	   */
	  var std = typed('std', {
	    // std([a, b, c, d, ...])
	    'Array | Matrix': _std,
	
	    // std([a, b, c, d, ...], normalization)
	    'Array | Matrix, string': _std,
	
	    // std(a, b, c, d, ...)
	    '...': function (args) {
	      return _std(args);
	    }
	  });
	  
	  std.toTex = undefined; // use default template
	
	  return std;
	
	  function _std(array, normalization) {
	    if (array.length == 0) {
	      throw new SyntaxError('Function std requires one or more parameters (0 provided)');
	    }
	
	    try {
	      return sqrt(variance.apply(null, arguments));
	    }
	    catch (err) {
	      if (err instanceof TypeError && err.message.indexOf(' var') !== -1) {
	        throw new TypeError(err.message.replace(' var', ' std'));
	      }
	      else {
	        throw err;
	      }
	    }
	  }
	}
	
	exports.name = 'std';
	exports.factory = factory;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DEFAULT_NORMALIZATION = 'unbiased';
	
	var deepForEach = __webpack_require__(1663);
	
	function factory (type, config, load, typed) {
	  var add = load(__webpack_require__(1369));
	  var subtract = load(__webpack_require__(1393));
	  var multiply = load(__webpack_require__(1396));
	  var divide = load(__webpack_require__(1397));
	  var improveErrorMessage = load(__webpack_require__(1666));
	
	  /**
	   * Compute the variance of a matrix or a  list with values.
	   * In case of a (multi dimensional) array or matrix, the variance over all
	   * elements will be calculated.
	   *
	   * Optionally, the type of normalization can be specified as second
	   * parameter. The parameter `normalization` can be one of the following values:
	   *
	   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
	   * - 'uncorrected'        The sum of squared errors is divided by n
	   * - 'biased'             The sum of squared errors is divided by (n + 1)
	   *
	   * Note that older browser may not like the variable name `var`. In that
	   * case, the function can be called as `math['var'](...)` instead of
	   * `math.var(...)`.
	   *
	   * Syntax:
	   *
	   *     math.var(a, b, c, ...)
	   *     math.var(A)
	   *     math.var(A, normalization)
	   *
	   * Examples:
	   *
	   *     math.var(2, 4, 6);                     // returns 4
	   *     math.var([2, 4, 6, 8]);                // returns 6.666666666666667
	   *     math.var([2, 4, 6, 8], 'uncorrected'); // returns 5
	   *     math.var([2, 4, 6, 8], 'biased');      // returns 4
	   *
	   *     math.var([[1, 2, 3], [4, 5, 6]]);      // returns 3.5
	   *
	   * See also:
	   *
	   *    mean, median, max, min, prod, std, sum
	   *
	   * @param {Array | Matrix} array
	   *                        A single matrix or or multiple scalar values
	   * @param {string} [normalization='unbiased']
	   *                        Determines how to normalize the variance.
	   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
	   * @return {*} The variance
	   */
	  var variance = typed('variance', {
	    // var([a, b, c, d, ...])
	    'Array | Matrix': function (array) {
	      return _var(array, DEFAULT_NORMALIZATION);
	    },
	
	    // var([a, b, c, d, ...], normalization)
	    'Array | Matrix, string': _var,
	
	    // var(a, b, c, d, ...)
	    '...': function (args) {
	      return _var(args, DEFAULT_NORMALIZATION);
	    }
	  });
	
	  variance.toTex = '\\mathrm{Var}\\left(${args}\\right)';
	
	  return variance;
	
	  /**
	   * Recursively calculate the variance of an n-dimensional array
	   * @param {Array} array
	   * @param {string} normalization
	   *                        Determines how to normalize the variance:
	   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
	   *                        - 'uncorrected' The sum of squared errors is divided by n
	   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
	   * @return {number | BigNumber} variance
	   * @private
	   */
	  function _var(array, normalization) {
	    var sum = 0;
	    var num = 0;
	
	    if (array.length == 0) {
	      throw new SyntaxError('Function var requires one or more parameters (0 provided)');
	    }
	
	    // calculate the mean and number of elements
	    deepForEach(array, function (value) {
	      try {
	        sum = add(sum, value);
	        num++;
	      }
	      catch (err) {
	        throw improveErrorMessage(err, 'var', value);
	      }
	    });
	    if (num === 0) throw new Error('Cannot calculate var of an empty array');
	
	    var mean = divide(sum, num);
	
	    // calculate the variance
	    sum = 0;
	    deepForEach(array, function (value) {
	      var diff = subtract(value, mean);
	      sum = add(sum, multiply(diff, diff));
	    });
	
	    switch (normalization) {
	      case 'uncorrected':
	        return divide(sum, num);
	
	      case 'biased':
	        return divide(sum, num + 1);
	
	      case 'unbiased':
	        var zero = type.isBigNumber(sum) ? new type.BigNumber(0) : 0;
	        return (num == 1) ? zero : divide(sum, num - 1);
	
	      default:
	        throw new Error('Unknown normalization "' + normalization + '". ' +
	        'Choose "unbiased" (default), "uncorrected", or "biased".');
	    }
	  }
	}
	
	exports.name = 'var';
	exports.factory = factory;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1408),
	  __webpack_require__(1846)
	];


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isString = __webpack_require__(1341).isString;
	var format = __webpack_require__(1341).format;
	
	function factory (type, config, load, typed) {
	  /**
	   * Interpolate values into a string template.
	   *
	   * Syntax:
	   *
	   *     math.print(template, values)
	   *     math.print(template, values, precision)
	   *     math.print(template, values, options)
	   *
	   * Example usage:
	   *
	   *     // the following outputs: 'Lucy is 5 years old'
	   *     math.print('Lucy is $age years old', {age: 5});
	   *
	   *     // the following outputs: 'The value of pi is 3.141592654'
	   *     math.print('The value of pi is $pi', {pi: math.pi}, 10);
	   *
	   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
	   *     math.print('Hello $user.name! The date is $date', {
	   *       user: {
	   *         name: 'Mary',
	   *       },
	   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
	   *     });
	   *
	   *     // the following outputs: 'My favorite fruits are apples and bananas !'
	   *     math.print('My favorite fruits are $0 and $1 !', [
	   *       'apples',
	   *       'bananas'
	   *     ]);
	   *
	   * See also:
	   *
	   *     format
	   *
	   * @param {string} template       A string containing variable placeholders.
	   * @param {Object | Array | Matrix} values An object or array containing variables
	   *                                which will be filled in in the template.
	   * @param {number | Object} [options]  Formatting options,
	   *                                or the number of digits to format numbers.
	   *                                See function math.format for a description
	   *                                of all options.
	   * @return {string} Interpolated string
	   */
	  var print = typed ('print', {
	    // note: Matrix will be converted automatically to an Array
	    'string, Object | Array': _print,
	    'string, Object | Array, number | Object': _print
	  });
	
	  print.toTex = undefined; // use default template
	
	  return print;
	}
	
	/**
	 * Interpolate values into a string template.
	 * @param {string} template
	 * @param {Object} values
	 * @param {number | Object} [options]
	 * @returns {string} Interpolated string
	 * @private
	 */
	function _print(template, values, options) {
	  return template.replace(/\$([\w\.]+)/g, function (original, key) {
	        var keys = key.split('.');
	        var value = values[keys.shift()];
	        while (keys.length && value !== undefined) {
	          var k = keys.shift();
	          value = k ? value[k] : value + '.';
	        }
	
	        if (value !== undefined) {
	          if (!isString(value)) {
	            return format(value, options);
	          }
	          else {
	            return value;
	          }
	        }
	
	        return original;
	      }
	  );
	}
	
	exports.name = 'print';
	exports.factory = factory;


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1848),
	  __webpack_require__(1849),
	  __webpack_require__(1850),
	  __webpack_require__(1851),
	  __webpack_require__(1852),
	  __webpack_require__(1853),
	  __webpack_require__(1854),
	  __webpack_require__(1855),
	  __webpack_require__(1856),
	  __webpack_require__(1857),
	  __webpack_require__(1858),
	  __webpack_require__(1859),
	  __webpack_require__(1860),
	  __webpack_require__(1861),
	  __webpack_require__(1862),
	  __webpack_require__(1863),
	  __webpack_require__(1864),
	  __webpack_require__(1865),
	  __webpack_require__(1866),
	  __webpack_require__(1867),
	  __webpack_require__(1868),
	  __webpack_require__(1869),
	  __webpack_require__(1870),
	  __webpack_require__(1871),
	  __webpack_require__(1872)
	];


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse cosine of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acos(x)
	   *
	   * Examples:
	   *
	   *    math.acos(0.5);           // returns number 1.0471975511965979
	   *    math.acos(math.cos(1.5)); // returns number 1.5
	   *
	   *    math.acos(2);             // returns Complex 0 + 1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    cos, atan, asin
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
	   */
	  var acos = typed('acos', {
	    'number': function (x) {
	      if ((x >= -1 && x <= 1) || config.predictable) {
	        return Math.acos(x);
	      }
	      else {
	        return new type.Complex(x, 0).acos();
	      }
	    },
	
	    'Complex': function (x) {
	      return x.acos();
	    },
	
	    'BigNumber': function (x) {
	      return x.acos();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acos);
	    }
	  });
	
	  acos.toTex = {1: '\\cos^{-1}\\left(${args[0]}\\right)'};
	
	  return acos;
	}
	
	exports.name = 'acos';
	exports.factory = factory;


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the hyperbolic arccos of a value,
	   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acosh(x)
	   *
	   * Examples:
	   *
	   *    math.acosh(1.5);       // returns 0.9624236501192069
	   *
	   * See also:
	   *
	   *    cosh, asinh, atanh
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
	   */
	  var acosh = typed('acosh', {
	    'number': function (x) {
	      if (x >= 1 || config.predictable) {
	        return _acosh(x);
	      }
	      if (x <= -1) {
	        return new type.Complex(Math.log(Math.sqrt(x*x - 1) - x), Math.PI);
	      }
	      return new type.Complex(x, 0).acosh();
	    },
	
	    'Complex': function (x) {
	      return x.acosh();
	    },
	
	    'BigNumber': function (x) {
	      return x.acosh();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acosh);
	    }
	  });
	
	  acosh.toTex = {1: '\\cosh^{-1}\\left(${args[0]}\\right)'};
	
	  return acosh;
	}
	
	/**
	 * Calculate the hyperbolic arccos of a number
	 * @param {number} x
	 * @return {number}
	 * @private
	 */
	var _acosh = Math.acosh || function (x) {
	  return Math.log(Math.sqrt(x*x - 1) + x)
	};
	
	exports.name = 'acosh';
	exports.factory = factory;


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acot(x)
	   *
	   * Examples:
	   *
	   *    math.acot(0.5);           // returns number 0.4636476090008061
	   *    math.acot(math.cot(1.5)); // returns number 1.5
	   *
	   *    math.acot(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    cot, atan
	   *
	   * @param {number | Complex | Array | Matrix} x   Function input
	   * @return {number | Complex | Array | Matrix} The arc cotangent of x
	   */
	  var acot = typed('acot', {
	    'number': function (x) {
	      return Math.atan(1 / x);
	    },
	
	    'Complex': function (x) {
	      return x.acot();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).atan();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acot);
	    }
	  });
	
	  acot.toTex = {1: '\\cot^{-1}\\left(${args[0]}\\right)'};
	
	  return acot;
	}
	
	exports.name = 'acot';
	exports.factory = factory;


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the hyperbolic arccotangent of a value,
	   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acoth(x)
	   *
	   * Examples:
	   *
	   *    math.acoth(0.5);       // returns 0.8047189562170503
	   *
	   * See also:
	   *
	   *    acsch, asech
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
	   */
	  var acoth = typed('acoth', {
	    'number': function (x) {
	      if (x >= 1 || x <= -1 || config.predictable) {
	        return isFinite(x) ? (Math.log((x+1)/x) + Math.log(x/(x-1))) / 2 : 0;
	      }
	      return new type.Complex(x, 0).acoth();
	    },
	
	    'Complex': function (x) {
	      return x.acoth();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).atanh();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acoth);
	    }
	  });
	
	  acoth.toTex = {1: '\\coth^{-1}\\left(${args[0]}\\right)'};
	
	  return acoth;
	}
	
	exports.name = 'acoth';
	exports.factory = factory;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acsc(x)
	   *
	   * Examples:
	   *
	   *    math.acsc(0.5);           // returns number 0.5235987755982989
	   *    math.acsc(math.csc(1.5)); // returns number ~1.5
	   *
	   *    math.acsc(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    csc, asin, asec
	   *
	   * @param {number | Complex | Array | Matrix} x   Function input
	   * @return {number | Complex | Array | Matrix} The arc cosecant of x
	   */
	  var acsc = typed('acsc', {
	    'number': function (x) {
	      if (x <= -1 || x >= 1 || config.predictable) {
	        return Math.asin(1 / x);
	      }
	      return new type.Complex(x, 0).acsc();
	    },
	
	    'Complex': function (x) {
	      return x.acsc();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).asin();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acsc);
	    }
	  });
	
	  acsc.toTex = {1: '\\csc^{-1}\\left(${args[0]}\\right)'};
	
	  return acsc;
	}
	
	exports.name = 'acsc';
	exports.factory = factory;


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the hyperbolic arccosecant of a value,
	   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.acsch(x)
	   *
	   * Examples:
	   *
	   *    math.acsch(0.5);       // returns 1.4436354751788103
	   *
	   * See also:
	   *
	   *    asech, acoth
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
	   */
	  var acsch = typed('acsch', {
	    'number': function (x) {
	      x = 1 / x;
	      return Math.log(x + Math.sqrt(x*x + 1));
	    },
	
	    'Complex': function (x) {
	      return x.acsch();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).asinh();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, acsch);
	    }
	  });
	
	  acsch.toTex = {1: '\\mathrm{csch}^{-1}\\left(${args[0]}\\right)'};
	
	  return acsch;
	}
	
	exports.name = 'acsch';
	exports.factory = factory;


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.asec(x)
	   *
	   * Examples:
	   *
	   *    math.asec(0.5);           // returns 1.0471975511965979
	   *    math.asec(math.sec(1.5)); // returns 1.5
	   *
	   *    math.asec(2);             // returns 0 + 1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    acos, acot, acsc
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} The arc secant of x
	   */
	  var asec = typed('asec', {
	    'number': function (x) {
	      if (x <= -1 || x >= 1 || config.predictable) {
	        return Math.acos(1 / x);
	      }
	      return new type.Complex(x, 0).asec();
	    },
	
	    'Complex': function (x) {
	      return x.asec();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).acos();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, asec);
	    }
	  });
	
	  asec.toTex = {1: '\\sec^{-1}\\left(${args[0]}\\right)'};
	
	  return asec;
	}
	
	exports.name = 'asec';
	exports.factory = factory;


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  var acosh = typed.find(load(__webpack_require__(1849)), ['Complex']);
	
	  /**
	   * Calculate the hyperbolic arcsecant of a value,
	   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.asech(x)
	   *
	   * Examples:
	   *
	   *    math.asech(0.5);       // returns 1.3169578969248166
	   *
	   * See also:
	   *
	   *    acsch, acoth
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
	   */
	  var asech = typed('asech', {
	    'number': function (x) {
	      if ((x <= 1 && x >= -1) || config.predictable) {
	        x = 1 / x;
	
	        var ret = Math.sqrt(x*x - 1);
	        if (x > 0 || config.predictable) {
	          return Math.log(ret + x);
	        }
	
	        return new type.Complex(Math.log(ret - x), Math.PI);
	      }
	
	      return new type.Complex(x, 0).asech();
	    },
	
	    'Complex': function (x) {
	      return x.asech()
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x).acosh();
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, asech);
	    }
	  });
	
	  asech.toTex = {1: '\\mathrm{sech}^{-1}\\left(${args[0]}\\right)'};
	
	  return asech;
	}
	
	exports.name = 'asech';
	exports.factory = factory;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse sine of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.asin(x)
	   *
	   * Examples:
	   *
	   *    math.asin(0.5);           // returns number 0.5235987755982989
	   *    math.asin(math.sin(1.5)); // returns number ~1.5
	   *
	   *    math.asin(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    sin, atan, acos
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
	   */
	  var asin = typed('asin', {
	    'number': function (x) {
	      if ((x >= -1 && x <= 1) || config.predictable) {
	        return Math.asin(x);
	      }
	      else {
	        return new type.Complex(x, 0).asin();
	      }
	    },
	
	    'Complex': function (x) {
	      return x.asin();
	    },
	
	    'BigNumber': function (x) {
	      return x.asin();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since asin(0) = 0
	      return deepMap(x, asin, true);
	    }
	  });
	
	  asin.toTex = {1: '\\sin^{-1}\\left(${args[0]}\\right)'};
	
	  return asin;
	}
	
	exports.name = 'asin';
	exports.factory = factory;


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the hyperbolic arcsine of a value,
	   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.asinh(x)
	   *
	   * Examples:
	   *
	   *    math.asinh(0.5);       // returns 0.48121182505960347
	   *
	   * See also:
	   *
	   *    acosh, atanh
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
	   */
	  var asinh = typed('asinh', {
	    'number': Math.asinh || function (x) {
	      return Math.log(Math.sqrt(x*x + 1) + x);
	    },
	
	    'Complex': function (x) {
	        return x.asinh();
	    },
	
	    'BigNumber': function (x) {
	      return x.asinh();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since asinh(0) = 0
	      return deepMap(x, asinh, true);
	    }
	  });
	
	  asinh.toTex = {1: '\\sinh^{-1}\\left(${args[0]}\\right)'};
	
	  return asinh;
	}
	
	exports.name = 'asinh';
	exports.factory = factory;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the inverse tangent of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.atan(x)
	   *
	   * Examples:
	   *
	   *    math.atan(0.5);           // returns number 0.4636476090008061
	   *    math.atan(math.tan(1.5)); // returns number 1.5
	   *
	   *    math.atan(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    tan, asin, acos
	   *
	   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
	   */
	  var atan = typed('atan', {
	    'number': function (x) {
	      return Math.atan(x);
	    },
	
	    'Complex': function (x) {
	      return x.atan();
	    },
	
	    'BigNumber': function (x) {
	      return x.atan();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since atan(0) = 0
	      return deepMap(x, atan, true);
	    }
	  });
	
	  atan.toTex = {1: '\\tan^{-1}\\left(${args[0]}\\right)'};
	
	  return atan;
	}
	
	exports.name = 'atan';
	exports.factory = factory;


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm02 = load(__webpack_require__(1727));
	  var algorithm03 = load(__webpack_require__(1377));
	  var algorithm09 = load(__webpack_require__(1729));
	  var algorithm11 = load(__webpack_require__(1401));
	  var algorithm12 = load(__webpack_require__(1379));
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Calculate the inverse tangent function with two arguments, y/x.
	   * By providing two arguments, the right quadrant of the computed angle can be
	   * determined.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.atan2(y, x)
	   *
	   * Examples:
	   *
	   *    math.atan2(2, 2) / math.pi;       // returns number 0.25
	   *
	   *    var angle = math.unit(60, 'deg'); // returns Unit 60 deg
	   *    var x = math.cos(angle);
	   *    var y = math.sin(angle);
	   *
	   *    math.atan(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
	   *
	   * See also:
	   *
	   *    tan, atan, sin, cos
	   *
	   * @param {number | Array | Matrix} y  Second dimension
	   * @param {number | Array | Matrix} x  First dimension
	   * @return {number | Array | Matrix} Four-quadrant inverse tangent
	   */
	  var atan2 = typed('atan2', {
	
	    'number, number': Math.atan2,
	
	    // Complex numbers doesn't seem to have a reasonable implementation of
	    // atan2(). Even Matlab removed the support, after they only calculated
	    // the atan only on base of the real part of the numbers and ignored the imaginary.
	
	    'BigNumber, BigNumber': function (y, x) {
	      return type.BigNumber.atan2(y, x);
	    },
	
	    'SparseMatrix, SparseMatrix': function (x, y) {
	      return algorithm09(x, y, atan2, false);
	    },
	
	    'SparseMatrix, DenseMatrix': function (x, y) {
	      // mind the order of y and x!
	      return algorithm02(y, x, atan2, true);
	    },
	
	    'DenseMatrix, SparseMatrix': function (x, y) {
	      return algorithm03(x, y, atan2, false);
	    },
	
	    'DenseMatrix, DenseMatrix': function (x, y) {
	      return algorithm13(x, y, atan2);
	    },
	
	    'Array, Array': function (x, y) {
	      return atan2(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      return atan2(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      return atan2(x, matrix(y));
	    },
	
	    'SparseMatrix, number | BigNumber': function (x, y) {
	      return algorithm11(x, y, atan2, false);
	    },
	
	    'DenseMatrix, number | BigNumber': function (x, y) {
	      return algorithm14(x, y, atan2, false);
	    },
	
	    'number | BigNumber, SparseMatrix': function (x, y) {
	      // mind the order of y and x
	      return algorithm12(y, x, atan2, true);
	    },
	
	    'number | BigNumber, DenseMatrix': function (x, y) {
	      // mind the order of y and x
	      return algorithm14(y, x, atan2, true);
	    },
	
	    'Array, number | BigNumber': function (x, y) {
	      return algorithm14(matrix(x), y, atan2, false).valueOf();
	    },
	
	    'number | BigNumber, Array': function (x, y) {
	      return algorithm14(matrix(y), x, atan2, true).valueOf();
	    }
	  });
	
	  atan2.toTex = {2: '\\mathrm{atan2}\\left(${args}\\right)'};
	
	  return atan2;
	}
	
	exports.name = 'atan2';
	exports.factory = factory;


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic arctangent of a value,
	   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.atanh(x)
	   *
	   * Examples:
	   *
	   *    math.atanh(0.5);       // returns 0.5493061443340549
	   *
	   * See also:
	   *
	   *    acosh, asinh
	   *
	   * @param {number | Complex | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
	   */
	  var atanh = typed('atanh', {
	    'number': function (x) {
	      if ((x <= 1 && x >= -1) || config.predictable) {
	        return _atanh(x);
	      }
	      return new type.Complex(x, 0).atanh();
	    },
	
	    'Complex': function (x) {
	      return x.atanh();
	    },
	
	    'BigNumber': function (x) {
	      return x.atanh();
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since atanh(0) = 0
	      return deepMap(x, atanh, true);
	    }
	  });
	
	  atanh.toTex = {1: '\\tanh^{-1}\\left(${args[0]}\\right)'};
	
	  return atanh;
	}
	
	/**
	 * Calculate the hyperbolic arctangent of a number
	 * @param {number} x
	 * @return {number}
	 * @private
	 */
	var _atanh = Math.atanh || function (x) {
	  return Math.log((1 + x)/(1 - x)) / 2
	};
	
	exports.name = 'atanh';
	exports.factory = factory;


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the cosine of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.cos(x)
	   *
	   * Examples:
	   *
	   *    math.cos(2);                      // returns number -0.4161468365471422
	   *    math.cos(math.pi / 4);            // returns number  0.7071067811865475
	   *    math.cos(math.unit(180, 'deg'));  // returns number -1
	   *    math.cos(math.unit(60, 'deg'));   // returns number  0.5
	   *
	   *    var angle = 0.2;
	   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2); // returns number ~1
	   *
	   * See also:
	   *
	   *    cos, tan
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
	   */
	  var cos = typed('cos', {
	    'number': Math.cos,
	
	    'Complex': function (x) {
	      return x.cos();
	    },
	
	    'BigNumber': function (x) {
	      return x.cos();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function cos is no angle');
	      }
	      return cos(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, cos);
	    }
	  });
	
	  cos.toTex = {1: '\\cos\\left(${args[0]}\\right)'};
	
	  return cos;
	}
	
	exports.name = 'cos';
	exports.factory = factory;


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic cosine of a value,
	   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.cosh(x)
	   *
	   * Examples:
	   *
	   *    math.cosh(0.5);       // returns number 1.1276259652063807
	   *
	   * See also:
	   *
	   *    sinh, tanh
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
	   */
	  var cosh = typed('cosh', {
	    'number': _cosh,
	
	    'Complex': function (x) {
	      return x.cosh();
	    },
	
	    'BigNumber': function (x) {
	      return x.cosh();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function cosh is no angle');
	      }
	      return cosh(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, cosh);
	    }
	  });
	
	  cosh.toTex = {1: '\\cosh\\left(${args[0]}\\right)'};
	
	  return cosh;
	}
	
	/**
	 * Calculate the hyperbolic cosine of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	var _cosh = Math.cosh || function (x) {
	  return (Math.exp(x) + Math.exp(-x)) / 2;
	};
	
	exports.name = 'cosh';
	exports.factory = factory;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.cot(x)
	   *
	   * Examples:
	   *
	   *    math.cot(2);      // returns number -0.45765755436028577
	   *    1 / math.tan(2);  // returns number -0.45765755436028577
	   *
	   * See also:
	   *
	   *    tan, sec, csc
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Cotangent of x
	   */
	  var cot = typed('cot', {
	    'number': function (x) {
	      return 1 / Math.tan(x);
	    },
	
	    'Complex': function (x) {
	      return x.cot();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.tan());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function cot is no angle');
	      }
	      return cot(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, cot);
	    }
	  });
	
	  cot.toTex = {1: '\\cot\\left(${args[0]}\\right)'};
	
	  return cot;
	}
	
	exports.name = 'cot';
	exports.factory = factory;


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic cotangent of a value,
	   * defined as `coth(x) = 1 / tanh(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.coth(x)
	   *
	   * Examples:
	   *
	   *    // coth(x) = 1 / tanh(x)
	   *    math.coth(2);         // returns 1.0373147207275482
	   *    1 / math.tanh(2);     // returns 1.0373147207275482
	   *
	   * See also:
	   *
	   *    sinh, tanh, cosh
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
	   */
	  var coth = typed('coth', {
	    'number': _coth,
	
	    'Complex': function (x) {
	      return x.coth();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.tanh());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function coth is no angle');
	      }
	      return coth(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, coth);
	    }
	  });
	
	  coth.toTex = {1: '\\coth\\left(${args[0]}\\right)'};
	
	  return coth;
	}
	
	/**
	 * Calculate the hyperbolic cosine of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	function _coth(x) {
	  var e = Math.exp(2 * x);
	  return (e + 1) / (e - 1);
	}
	
	exports.name = 'coth';
	exports.factory = factory;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.csc(x)
	   *
	   * Examples:
	   *
	   *    math.csc(2);      // returns number 1.099750170294617
	   *    1 / math.sin(2);  // returns number 1.099750170294617
	   *
	   * See also:
	   *
	   *    sin, sec, cot
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Cosecant of x
	   */
	  var csc = typed('csc', {
	    'number': function (x) {
	      return 1 / Math.sin(x);
	    },
	
	    'Complex': function (x) {
	      return x.csc();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.sin());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function csc is no angle');
	      }
	      return csc(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, csc);
	    }
	  });
	
	  csc.toTex = {1: '\\csc\\left(${args[0]}\\right)'};
	
	  return csc;
	}
	
	exports.name = 'csc';
	exports.factory = factory;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var sign = __webpack_require__(1324).sign;
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic cosecant of a value,
	   * defined as `csch(x) = 1 / sinh(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.csch(x)
	   *
	   * Examples:
	   *
	   *    // csch(x) = 1/ sinh(x)
	   *    math.csch(0.5);       // returns 1.9190347513349437
	   *    1 / math.sinh(0.5);   // returns 1.9190347513349437
	   *
	   * See also:
	   *
	   *    sinh, sech, coth
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
	   */
	  var csch = typed('csch', {
	    'number': _csch,
	
	    'Complex': function (x) {
	      return x.csch();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.sinh());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function csch is no angle');
	      }
	      return csch(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, csch);
	    }
	  });
	
	  csch.toTex = {1: '\\mathrm{csch}\\left(${args[0]}\\right)'};
	
	  return csch;
	}
	
	/**
	 * Calculate the hyperbolic cosecant of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	function _csch(x) {
	  // consider values close to zero (+/-)
	  if (x == 0) {
	    return Number.POSITIVE_INFINITY;
	  }
	  else {
	    return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * sign(x);
	  }
	}
	
	exports.name = 'csch';
	exports.factory = factory;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sec(x)
	   *
	   * Examples:
	   *
	   *    math.sec(2);      // returns number -2.4029979617223822
	   *    1 / math.cos(2);  // returns number -2.4029979617223822
	   *
	   * See also:
	   *
	   *    cos, csc, cot
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Secant of x
	   */
	  var sec = typed('sec', {
	    'number': function (x) {
	      return 1 / Math.cos(x);
	    },
	
	    'Complex': function (x) {
	      return x.sec();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.cos());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function sec is no angle');
	      }
	      return sec(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, sec);
	    }
	  });
	
	  sec.toTex = {1: '\\sec\\left(${args[0]}\\right)'};
	
	  return sec;
	}
	
	exports.name = 'sec';
	exports.factory = factory;


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic secant of a value,
	   * defined as `sech(x) = 1 / cosh(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sech(x)
	   *
	   * Examples:
	   *
	   *    // sech(x) = 1/ cosh(x)
	   *    math.sech(0.5);       // returns 0.886818883970074
	   *    1 / math.cosh(0.5);   // returns 0.886818883970074
	   *
	   * See also:
	   *
	   *    cosh, csch, coth
	   *
	   * @param {number | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
	   */
	  var sech = typed('sech', {
	    'number': _sech,
	
	    'Complex': function (x) {
	      return x.sech();
	    },
	
	    'BigNumber': function (x) {
	      return new type.BigNumber(1).div(x.cosh());
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function sech is no angle');
	      }
	      return sech(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, sech);
	    }
	  });
	
	  sech.toTex = {1: '\\mathrm{sech}\\left(${args[0]}\\right)'};
	
	  return sech;
	}
	
	/**
	 * Calculate the hyperbolic secant of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	function _sech(x) {
	  return 2 / (Math.exp(x) + Math.exp(-x));
	}
	
	exports.name = 'sech';
	exports.factory = factory;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	
	  /**
	   * Calculate the sine of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sin(x)
	   *
	   * Examples:
	   *
	   *    math.sin(2);                      // returns number 0.9092974268256813
	   *    math.sin(math.pi / 4);            // returns number 0.7071067811865475
	   *    math.sin(math.unit(90, 'deg'));   // returns number 1
	   *    math.sin(math.unit(30, 'deg'));   // returns number 0.5
	   *
	   *    var angle = 0.2;
	   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2); // returns number ~1
	   *
	   * See also:
	   *
	   *    cos, tan
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
	   */
	  var sin = typed('sin', {
	    'number': Math.sin,
	
	    'Complex': function (x) {
	      return x.sin();
	    },
	
	    'BigNumber': function (x) {
	      return x.sin();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function sin is no angle');
	      }
	      return sin(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since sin(0) = 0
	      return deepMap(x, sin, true);
	    }
	  });
	
	  sin.toTex = {1: '\\sin\\left(${args[0]}\\right)'};
	
	  return sin;
	}
	
	exports.name = 'sin';
	exports.factory = factory;


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic sine of a value,
	   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.sinh(x)
	   *
	   * Examples:
	   *
	   *    math.sinh(0.5);       // returns number 0.5210953054937474
	   *
	   * See also:
	   *
	   *    cosh, tanh
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
	   */
	  var sinh = typed('sinh', {
	    'number': _sinh,
	
	    'Complex': function (x) {
	      return x.sinh();
	    },
	
	    'BigNumber': function (x) {
	      return x.sinh();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function sinh is no angle');
	      }
	      return sinh(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since sinh(0) = 0
	      return deepMap(x, sinh, true);
	    }
	  });
	
	  sinh.toTex = {1: '\\sinh\\left(${args[0]}\\right)'};
	
	  return sinh;
	}
	
	/**
	 * Calculate the hyperbolic sine of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	var _sinh = Math.sinh || function (x) {
	  return (Math.exp(x) - Math.exp(-x)) / 2;
	};
	
	exports.name = 'sinh';
	exports.factory = factory;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.tan(x)
	   *
	   * Examples:
	   *
	   *    math.tan(0.5);                    // returns number 0.5463024898437905
	   *    math.sin(0.5) / math.cos(0.5);    // returns number 0.5463024898437905
	   *    math.tan(math.pi / 4);            // returns number 1
	   *    math.tan(math.unit(45, 'deg'));   // returns number 1
	   *
	   * See also:
	   *
	   *    atan, sin, cos
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
	   */
	  var tan = typed('tan', {
	    'number': Math.tan,
	
	    'Complex': function (x) {
	        return x.tan();
	    },
	
	    'BigNumber': function (x) {
	      return x.tan();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function tan is no angle');
	      }
	      return tan(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since tan(0) = 0
	      return deepMap(x, tan, true);
	    }
	  });
	
	  tan.toTex = {1: '\\tan\\left(${args[0]}\\right)'};
	
	  return tan;
	}
	
	exports.name = 'tan';
	exports.factory = factory;


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	function factory (type, config, load, typed) {
	  /**
	   * Calculate the hyperbolic tangent of a value,
	   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.tanh(x)
	   *
	   * Examples:
	   *
	   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
	   *    math.tanh(0.5);                   // returns 0.46211715726000974
	   *    math.sinh(0.5) / math.cosh(0.5);  // returns 0.46211715726000974
	   *    1 / math.coth(0.5);               // returns 0.46211715726000974
	   *
	   * See also:
	   *
	   *    sinh, cosh, coth
	   *
	   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
	   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
	   */
	  var tanh = typed('tanh', {
	    'number': _tanh,
	
	    'Complex': function (x) {
	        return x.tanh();
	    },
	
	    'BigNumber': function (x) {
	      return x.tanh();
	    },
	
	    'Unit': function (x) {
	      if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
	        throw new TypeError ('Unit in function tanh is no angle');
	      }
	      return tanh(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      // deep map collection, skip zeros since tanh(0) = 0
	      return deepMap(x, tanh, true);
	    }
	  });
	
	  tanh.toTex = {1: '\\tanh\\left(${args[0]}\\right)'};
	
	  return tanh;
	}
	
	/**
	 * Calculate the hyperbolic tangent of a number
	 * @param {number} x
	 * @returns {number}
	 * @private
	 */
	var _tanh = Math.tanh || function (x) {
	  var e = Math.exp(2 * x);
	  return (e - 1) / (e + 1);
	};
	
	exports.name = 'tanh';
	exports.factory = factory;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1874)
	];


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function factory (type, config, load, typed) {
	  var latex = __webpack_require__(1348);
	
	  var matrix = load(__webpack_require__(1368));
	
	  var algorithm13 = load(__webpack_require__(1373));
	  var algorithm14 = load(__webpack_require__(1374));
	
	  /**
	   * Change the unit of a value.
	   *
	   * For matrices, the function is evaluated element wise.
	   *
	   * Syntax:
	   *
	   *    math.to(x, unit)
	   *
	   * Examples:
	   *
	   *    math.to(math.unit('2 inch'), 'cm');                   // returns Unit 5.08 cm
	   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'));  // returns Unit 5.08 cm
	   *    math.to(math.unit(16, 'bytes'), 'bits');              // returns Unit 128 bits
	   *
	   * See also:
	   *
	   *    unit
	   *
	   * @param {Unit | Array | Matrix} x     The unit to be converted.
	   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
	   *                                      or a unit without value.
	   * @return {Unit | Array | Matrix} value with changed, fixed unit.
	   */
	  var to = typed('to', {
	
	    'Unit, Unit | string': function (x, unit) {
	      return x.to(unit);
	    },
	
	    'Matrix, Matrix': function (x, y) {
	      // SparseMatrix does not support Units
	      return algorithm13(x, y, to);
	    },
	
	    'Array, Array': function (x, y) {
	      // use matrix implementation
	      return to(matrix(x), matrix(y)).valueOf();
	    },
	
	    'Array, Matrix': function (x, y) {
	      // use matrix implementation
	      return to(matrix(x), y);
	    },
	
	    'Matrix, Array': function (x, y) {
	      // use matrix implementation
	      return to(x, matrix(y));
	    },
	
	    'Matrix, any': function (x, y) {
	      // SparseMatrix does not support Units
	      return algorithm14(x, y, to, false);
	    },
	
	    'any, Matrix': function (x, y) {
	      // SparseMatrix does not support Units
	      return algorithm14(y, x, to, true);
	    },
	
	    'Array, any': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(x), y, to, false).valueOf();
	    },
	
	    'any, Array': function (x, y) {
	      // use matrix implementation
	      return algorithm14(matrix(y), x, to, true).valueOf();
	    }
	  });
	
	  to.toTex = {
	    2: '\\left(${args[0]}' + latex.operators['to'] + '${args[1]}\\right)'
	  };
	
	  return to;
	}
	
	exports.name = 'to';
	exports.factory = factory;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1690),
	  __webpack_require__(1772),
	  __webpack_require__(1723),
	  __webpack_require__(1407),
	  __webpack_require__(1691),
	  __webpack_require__(1876),
	  __webpack_require__(1686),
	  __webpack_require__(1877),
	  __webpack_require__(1409)
	];


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is prime: has no divisors other than itself and one.
	   * The function supports type `number`, `bignumber`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isPrime(x)
	   *
	   * Examples:
	   *
	   *    math.isPrime(3);                     // returns true
	   *    math.isPrime(-2);                    // returns false
	   *    math.isPrime(0);                     // returns false
	   *    math.isPrime(-0);                    // returns false
	   *    math.isPrime(0.5);                   // returns false
	   *    math.isPrime('2');                   // returns true
	   *    math.isPrime([2, 17, 100]);           // returns [true, true, false]
	   *
	   * See also:
	   *
	   *    isNumeric, isZero, isNegative, isInteger
	   *
	   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
	   * @return {boolean}  Returns true when `x` is larger than zero.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isPrime = typed('isPrime', {
	    'number': function (x) {
	      if (x < 2){
	        return false;
	      }
	      if (x == 2){
	        return true;
	      }
	      if (x % 2 == 0){ 
	        return false;
	      }
	      for (var i = 3; i * i <= x; i += 2){
	        if (x % i == 0){
	          return false;
	        }
	      }
	      return true;
	    },
	
	    'BigNumber': function (x) {
	      if (x.lt(2)){
	        return false;
	      }
	      if (x.equals(2)){
	        return true;
	      }
	      if (x.mod(2).isZero()){
	        return false;
	      }
	      for(var i = type.BigNumber(3); i.times(i).lte(x); i = i.plus(1)){
	        if (x.mod(i).isZero()){
	          return false;
	        }
	      }
	      return true;
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, isPrime);
	    }
	  });
	
	  return isPrime;
	}
	
	exports.name = 'isPrime';
	exports.factory = factory;


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deepMap = __webpack_require__(1337);
	var number = __webpack_require__(1324);
	
	function factory (type, config, load, typed) {
	  /**
	   * Test whether a value is NaN (not a number).
	   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
	   *
	   * The function is evaluated element-wise in case of Array or Matrix input.
	   *
	   * Syntax:
	   *
	   *     math.isNaN(x)
	   *
	   * Examples:
	   *
	   *    math.isNaN(3);                     // returns false
	   *    math.isNaN(NaN);                   // returns true
	   *    math.isNaN(0);                     // returns false
	   *    math.isNaN(math.bignumber(NaN));   // returns true
	   *    math.isNaN(math.bignumber(0));     // returns false
	   *    math.isNaN(math.fraction(-2, 5));  // returns false
	   *    math.isNaN('-2');                  // returns false
	   *    math.isNaN([2, 0, -3, NaN]');      // returns [false, false, false, true]
	   *
	   * See also:
	   *
	   *    isNumeric, isNegative, isPositive, isZero, isInteger
	   *
	   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
	   * @return {boolean}  Returns true when `x` is NaN.
	   *                    Throws an error in case of an unknown data type.
	   */
	  var isNaN = typed('isNaN', {
	    'number': function (x) {
	      return Number.isNaN(x);
	    },
	
	    'BigNumber': function (x) {
	      return x.isNaN();
	    },
	
	    'Fraction': function (x) {
	      return false;
	    },
	
	    'Complex': function (x) {
	      return x.isNaN();
	    },
	
	    'Unit': function (x) {
	      return Number.isNaN(x.value);
	    },
	
	    'Array | Matrix': function (x) {
	      return deepMap(x, Number.isNaN);
	    }
	  });
	
	  return isNaN;
	}
	
	exports.name = 'isNaN';
	exports.factory = factory;


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = [
	  __webpack_require__(1879)
	];


/***/ }),
/* 1879 */
/***/ (function(module, exports) {

	'use strict';
	
	function factory (type, config, load, typed, math) {
	  /**
	   * Instantiate mathjs data types from their JSON representation
	   * @param {string} key
	   * @param {*} value
	   * @returns {*} Returns the revived object
	   */
	  return function reviver(key, value) {
	    var constructor = type[value && value.mathjs] ||
	        (math.expression && math.expression.node[value && value.mathjs]);
	    // TODO: instead of checking math.expression.node, expose all Node classes on math.type too
	
	    if (constructor && typeof constructor.fromJSON === 'function') {
	      return constructor.fromJSON(value);
	    }
	
	    return value;
	  }
	}
	
	exports.name = 'reviver';
	exports.path = 'json';
	exports.factory = factory;
	exports.math = true; // request the math namespace as fifth argument


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ArgumentsError = __webpack_require__(1329);
	var DimensionError = __webpack_require__(1358);
	var IndexError = __webpack_require__(1359);
	
	module.exports = [
	  {
	    name: 'ArgumentsError', path: 'error',
	    factory: function () {
	      return ArgumentsError;
	    }
	  },
	  {
	    name: 'DimensionError',
	    path: 'error',
	    factory: function () {
	      return DimensionError;
	    }
	  },
	  {
	    name: 'IndexError',
	    path: 'error',
	    factory: function () {
	      return IndexError;
	    }
	  }
	];
	
	// TODO: implement an InvalidValueError?


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _mathjs = __webpack_require__(1317);
	
	var _mathjs2 = _interopRequireDefault(_mathjs);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var Sensor = (function (_React$Component) {
		_inherits(Sensor, _React$Component);
	
		function Sensor(props) {
			_classCallCheck(this, Sensor);
	
			_get(Object.getPrototypeOf(Sensor.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Sensor, [{
			key: 'valueToColor',
			value: function valueToColor(value) {
				if (value < 0 || value > 1) {
					return "#000";
				}
				var hue = 120 - Math.round(120 * value);
	
				return "hsl(" + hue + ", 100%, 60%)";
			}
		}, {
			key: 'gaussianCDF',
			value: function gaussianCDF(x, mean, std) {
				// Cumulative distribution function of Gaussian distribution
				return (1 + _mathjs2['default'].erf((x - mean) / (std * _mathjs2['default'].sqrt(2)))) / 2;
			}
		}, {
			key: 'checkFilter',
			value: function checkFilter(filter, value) {
				var globalAvg = this.props.normalizer[0];
	
				switch (filter) {
					case "ALL":
						return true;
					case "ABOVE":
						if (value > globalAvg) return true;
						break;
					case "BELOW":
						if (value < globalAvg) return true;
						break;
					case "LOWEST":
						var low = this.props.normalizer[2];
						if (value < low) return true;
						break;
					default:
						return true;
				}
	
				return false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var sensor = this.props.sensor;
				var parentName = null;
				if (sensor.id) {
					if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
						parentName = this.props.nodeMap[sensor.id].parent.info.name;
					}
				}
				var style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
	
				// Heatmap
				var heatNode = null;
				var isHidden = false;
	
				isHidden = sensor.hidden;
	
				// if (!(sensor.id % 5)) {
				// 	 isHidden = true;
				// }
	
				var cond = this.props.average >= 0 && this.props.average <= 1 && // Valid heatnodes
				this.checkFilter(this.props.heatmapFilter, this.props.average) && ( // Filtered
				this.props.showHiddenHeatNodes || !isHidden); // Show hidden if editing, else no
	
				if (cond) {
					var normalizedAverage = this.gaussianCDF(this.props.average, this.props.normalizer[0], this.props.normalizer[1]);
					var glowSize = 2 + Math.ceil(normalizedAverage / 0.2) * 1;
					var glowColor = this.valueToColor(normalizedAverage);
					var sensorSize = this.props.thumbnail && "10px";
					var heatStyle = Object.assign({}, style, {
						backgroundColor: glowColor,
						boxShadow: "0px 0px 16px " + glowSize + "px " + glowColor,
						width: sensorSize,
						height: sensorSize
					});
	
					heatNode = _react2['default'].createElement('div', {
						className: "sensor-heatnode" + (isHidden ? " heat-show-hidden" : ""),
						'data-tooltip': this.props.showHiddenHeatNodes ? isHidden ? "Hidden" : "Visible" : "Average: " + Math.round(this.props.average * 1000) / 10 + "%", style: heatStyle,
						onClick: function (e) {
							_this.props.onClickHeatNode(e, sensor.id);
						}
					});
				}
				if (!this.props.thumbnail) {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						heatNode
					);
				} else {
					return _react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement('div', { className: "sensor-heatnode" + (isHidden ? " heat-show-hidden" : ""), style: heatStyle,
							'data-tip': true, 'data-for': "sensor" + sensor.id
						}),
						_react2['default'].createElement(
							_reactTooltip2['default'],
							{ id: "sensor" + sensor.id, place: 'right', type: 'dark', effect: 'solid' },
							sensor.name,
							_react2['default'].createElement('br', null),
							"Average: " + Math.round(this.props.average * 1000) / 10 + "%",
							_react2['default'].createElement(
								'div',
								null,
								parentName
							)
						)
					);
				}
			}
		}]);
	
		return Sensor;
	})(_react2['default'].Component);
	
	exports.Sensor = Sensor;
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Sensor.propTypes = {
		normalizer: _propTypes2['default'].array.isRequired,
		sensor: _propTypes2['default'].object.isRequired,
		average: _propTypes2['default'].number,
		heatmapFilter: _propTypes2['default'].string.isRequired,
		showHiddenHeatNodes: _propTypes2['default'].bool.isRequired,
		thumbnail: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Sensor);

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactRouter = __webpack_require__(86);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsNode = __webpack_require__(202);
	
	var _floorplan = __webpack_require__(1316);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var Area = (function (_React$Component) {
		_inherits(Area, _React$Component);
	
		function Area(props) {
			_classCallCheck(this, Area);
	
			_get(Object.getPrototypeOf(Area.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Area, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				this.setState({ tooltipOpen: true });
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				this.setState({ tooltipOpen: false });
			}
		}, {
			key: 'getPos',
			value: function getPos(node) {
				if (node.info.xpercent != -1 && node.info.ypercent != -1) {
					return { x: node.info.xpercent, y: node.info.ypercent };
				}
				// Mean position of all sensors
				var res = { x: 0, y: 0 };
				node.children.forEach(function (child) {
					if (child.type == "sensor") {
						res.x += child.info.xpercent;
						res.y += child.info.ypercent;
					}
				});
				res.x /= node.children.length;
				res.y /= node.children.length;
				return res;
			}
		}, {
			key: 'listSensors',
			value: function listSensors(root, res) {
				var self = this;
				if (root) {
					if (root.type == "sensor") {
						res.push(root);
					} else {
						root.children.map(function (x) {
							return self.listSensors(x, res);
						});
					}
				}
			}
		}, {
			key: 'getStatus',
			value: function getStatus(node) {
				var status = {
					inuse: 0,
					faulty: 0,
					total: node.children.length,
					registered: 0,
					standby: 0,
					displayValue: 0,
					type: "free"
				};
				var sensors = [];
				this.listSensors(node, sensors);
				var sensorMap = this.props.sensorMap;
				sensors.forEach(function (sensor) {
					var ss = sensorMap.get(sensor.id);
					if (ss) {
						status.inuse += ss.inuse;
						status.faulty += ss.faulty;
						status.registered += ss.registered;
						status.standby += ss.standby;
					}
				});
				if (status.registered > 0) {
					if (status.faulty == status.registered) {
						status.type = 'faulty';
					} else {
						if (status.inuse > 0) {
							status.type = 'inuse';
						} else if (status.standby) {
							status.type = 'standby';
						}
					}
				} else {
					status.type = 'unregistered';
				}
	
				switch (status.type) {
					case "free":
						status.displayValue = status.total;
						break;
					case "inuse":
						status.displayValue = status.inuse;
						break;
					case "standby":
						status.displayValue = status.total;
						break;
					case "faulty":
						status.displayValue = status.total;
						break;
					case "unregistered":
						status.displayValue = status.total;
				}
	
				return status;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var node = this.props.node;
				var pos = this.getPos(node);
				var status = this.getStatus(node);
	
				var style = { left: pos.x + '%', top: pos.y + '%' };
				var className = 'circle';
				className += " " + status.type;
				if (!this.props.thumbnail) {
					var tooltipPos = "top";
					if (pos.y < 50) {
						tooltipPos = "bottom";
					}
					return _react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'div',
							{ id: "area" + node.id, className: className, style: style,
								// onClick={this.onClick.bind(this)}
								onMouseEnter: function () {
									return _this.onMouseEnter();
								},
								onMouseLeave: function () {
									return _this.onMouseLeave();
								} },
							status.displayValue
						),
						_react2['default'].createElement(
							_reactPortalTooltip2['default'],
							{ active: this.state.tooltipOpen, parent: "#area" + node.id, position: tooltipPos, arrow: 'center',
								style: {
									style: {
										background: "rgba(0,0,0,.8)",
										padding: 10,
										color: "#EEE",
										boxShadow: "5px 5px 3px rgba(0,0,0,.5)",
										borderRadius: 8,
										transition: 'all .2s ease-in-out',
										zIndex: 7091
									},
									arrowStyle: {
										color: 'rgba(0,0,0,.8)',
										borderColor: false,
										transition: 'all .2s ease-in-out'
									}
								},
								tooltipTimeout: 200
							},
							_react2['default'].createElement(
								'div',
								null,
								_react2['default'].createElement(
									'div',
									{ className: 'tooltip-header' },
									node.info.name,
									_react2['default'].createElement('br', null)
								),
								node.info.useownfp && _react2['default'].createElement(
									'div',
									null,
									'This ',
									_config2['default'].textOf[node.type],
									' has its own floorplan :',
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRedux.Provider,
										{ store: _store2['default'] },
										_react2['default'].createElement(_floorplan2['default'], {
											root: node,
											sensorMap: this.props.sensorMap,
											showDetails: true,
											thumbnail: true
										})
									),
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: "/heatmap/" + node.id, target: '_blank' },
										'Detailed floorplan'
									),
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: "/locations?n=" + node.id, target: '_blank' },
										'Edit setting'
									),
									_react2['default'].createElement('br', null)
								)
							)
						)
					);
				} else {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						_react2['default'].createElement(
							'div',
							{
								className: className, style: style,
								'data-tip': true, 'data-for': "area" + node.id,
								onMouseEnter: function () {
									return _this.onMouseEnter();
								},
								onMouseLeave: function () {
									return _this.onMouseLeave();
								}
							},
							status.displayValue
						),
						_react2['default'].createElement(
							_reactTooltip2['default'],
							{ id: "area" + node.id, place: 'top', type: 'dark', effect: 'solid' },
							node.info.name
						)
					);
				}
			}
		}, {
			key: 'setOwnFloorPlan',
			value: function setOwnFloorPlan(node, useownfp) {
				var newNode = { id: node.id, info: { useownfp: useownfp } };
				this.props.dispatch((0, _actionsNode.updateNode)(newNode));
			}
		}]);
	
		return Area;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			sensorMap: state.nodeReducer.map
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Area.propTypes = {
		node: _propTypes2['default'].object.isRequired,
		thumbnail: _propTypes2['default'].bool.isRequired,
		sensorMap: _propTypes2['default'].object.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Area);
	module.exports = exports['default'];

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _actionsStats = __webpack_require__(207);
	
	var _functions = __webpack_require__(1249);
	
	var HeatmapExport = (function (_React$Component) {
	    _inherits(HeatmapExport, _React$Component);
	
	    function HeatmapExport(props, context) {
	        _classCallCheck(this, HeatmapExport);
	
	        _get(Object.getPrototypeOf(HeatmapExport.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loading: false
	        };
	    }
	
	    _createClass(HeatmapExport, [{
	        key: 'downloadPDF',
	        value: function downloadPDF() {
	            var _this = this;
	
	            this.setState({ loading: true }, function () {
	                var images = [];
	                (0, _functions.chainGetPNG)([_this.props.heatmap], images, function () {
	                    _this.setState({ loading: false });
	                    (0, _functions.dumpAllToPDF)(images, _this.getPDFName());
	                });
	            });
	        }
	    }, {
	        key: 'getPDFName',
	        value: function getPDFName() {
	            var settings = (0, _actionsStats.getParams)({
	                querySettings: this.props.querySettings,
	                currentNode: this.props.node
	            });
	            var locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
	            return 'WIDGET_' + locationName + '_' + settings.startdate + '_' + settings.enddate + '_' + settings.starthour + ':00_' + settings.endhour + ':59.pdf';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2['default'].createElement(
	                _componentsCommonDropdowncomponentsDropdown2['default'],
	                { className: this.props.className, header: _react2['default'].createElement(
	                        'div',
	                        { className: "heatmap-export " + (this.state.loading ? "loading" : "") },
	                        this.state.loading ? _react2['default'].createElement('img', { src: 'src/assets/icons/loading.gif' }) : _react2['default'].createElement('span', { 'data-tooltip': 'Export data', className: 'font-icon icon-export' })
	                    ), toggleable: !this.state.loading, noArrow: true },
	                _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: function () {
	                                return _this2.downloadPDF();
	                            } },
	                        'PDF : Picture of heatmap'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeatmapExport;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        tree: state.overviewReducer.customerOverview,
	        nodeMap: state.overviewReducer.nodeMap,
	        querySettings: state.querySettingsReducer,
	        cards: state.defaultSettingsReducer.card
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HeatmapExport);
	module.exports = exports['default'];

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _floorplan = __webpack_require__(1885);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _componentsCommonLivestatsmenuitems = __webpack_require__(1314);
	
	var _componentsCommonLivestatsmenuitems2 = _interopRequireDefault(_componentsCommonLivestatsmenuitems);
	
	var _componentsCommonDropdowncomponentsNodedropdown = __webpack_require__(1304);
	
	var _componentsCommonDropdowncomponentsNodedropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsNodedropdown);
	
	var _componentsCommonDropdowncomponentsListdropdown = __webpack_require__(1305);
	
	var _componentsCommonDropdowncomponentsListdropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsListdropdown);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _actionsNode = __webpack_require__(202);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var DeviceManagement = (function (_React$Component) {
	    _inherits(DeviceManagement, _React$Component);
	
	    function DeviceManagement(props, context) {
	        _classCallCheck(this, DeviceManagement);
	
	        _get(Object.getPrototypeOf(DeviceManagement.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            currentNode: {
	                info: {
	                    name: "",
	                    empty: true
	                },
	                children: [],
	                type: null
	            },
	            path: [],
	            showDetails: true,
	            I: {}
	        };
	    }
	
	    _createClass(DeviceManagement, [{
	        key: 'fetchLive',
	        value: function fetchLive() {
	            this.props.viewFilter.code !== "CONFIGURATION" && this.props.dispatch((0, _actionsNode.fetchLiveData)());
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.prepare(this.props);
	            var I = setInterval(this.fetchLive.bind(this), 5000);
	            this.setState({ I: I });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.I);
	        }
	    }, {
	        key: 'empty',
	        value: function empty(node) {
	            return node.info.empty == true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.prepare(nextProps);
	        }
	    }, {
	        key: 'prepare',
	        value: function prepare(props) {
	            var path = [];
	            var res = { currentNode: {} };
	            this.findNode(props.nodeMap, props.params.id, path, res);
	            this.setState({ currentNode: res.currentNode, path: path });
	
	            var oldnode = this.state.currentNode;
	            var currentNode = res.currentNode;
	
	            var cond1 = oldnode.id != currentNode.id && !this.empty(currentNode);
	            var cond2 = props.nodeFilter.info.empty && !this.empty(currentNode);
	            var cond3 = oldnode.id == currentNode.id && oldnode.children.length != currentNode.children.length;
	            // console.log(oldnode, currentNode, cond1, cond2);
	            if (cond1 || cond2 || cond3) {
	                // either floor changed or no node filter yet => set node filter to all areas.
	                this.props.dispatch((0, _actionsLiveFilter.selectNodeFilter)(currentNode));
	            }
	            if (currentNode.type == _config2['default'].room.MEETINGROOM.code || props.nodeFilter.type == _config2['default'].room.MEETINGROOM.code) {
	                this.setState({
	                    showDetails: true
	                });
	            }
	        }
	    }, {
	        key: 'findNode',
	        value: function findNode(nodeMap, id, path, res) {
	            res.currentNode = nodeMap[id];
	            if (!res.currentNode) {
	                res.currentNode = {};
	                return;
	            }
	            var tmp = [],
	                cur = res.currentNode;
	            while (cur) {
	                tmp.push(cur);
	                cur = cur.parent;
	            }
	            while (tmp.length) {
	                path.push(tmp[tmp.length - 1]);
	                tmp.pop();
	            }
	        }
	    }, {
	        key: 'changeMRMode',
	        value: function changeMRMode() {
	            this.setState({
	                showDetails: !this.state.showDetails
	            });
	        }
	    }, {
	        key: 'listNodeFilter',
	        value: function listNodeFilter(root, res) {
	            var self = this;
	            if (root) {
	                if (root.type == _config2['default'].room.MEETINGROOM.code || root.type == _config2['default'].room.OPENAREA.code) {
	                    res.push(root);
	                }
	                if (root.children) {
	                    root.children.forEach(function (child) {
	                        self.listNodeFilter(child, res);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'live-page overwrite--modal--depth' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: false
	                    },
	                    _react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
	                        leftItemBold: this.state.currentNode.info.name,
	                        leftItems: _react2['default'].createElement(_componentsCommonLivestatsmenuitems2['default'], {
	                            id: this.state.currentNode.id,
	                            node: this.state.currentNode
	                        })
	                    }),
	                    _react2['default'].createElement(_componentsCommonPath2['default'], { path: this.state.path, linkOn: function (x) {
	                            return x.info.hasfloorplan;
	                        }, link: function (x) {
	                            return "devicemanagement/" + x.id;
	                        } })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'device-management-content' },
	                        _react2['default'].createElement(
	                            _floorplan2['default'],
	                            {
	                                changeMRMode: function () {
	                                    _this.changeMRMode();
	                                },
	                                viewFilter: this.props.viewFilter,
	                                root: this.props.nodeMap[this.props.nodeFilter.id],
	                                showDetails: this.state.showDetails,
	                                tooltipGroup: 'index',
	                                thumbnail: false,
	                                currentNode: this.state.currentNode },
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsListdropdown2['default'], {
	                                isConfigurationView: true,
	                                outsideClass: 'view-filter',
	                                items: _config2['default'].viewFilter,
	                                getText: function (x) {
	                                    return x.text;
	                                },
	                                selected: this.props.viewFilter,
	                                click: function (view) {
	                                    _this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(view));
	                                }
	                            }),
	                            _react2['default'].createElement(_componentsCommonDropdowncomponentsNodedropdown2['default'], {
	                                outsideClass: 'view-filter',
	                                root: this.state.currentNode,
	                                nodeFilter: this.props.nodeFilter,
	                                click: function (node) {
	                                    _this.props.dispatch((0, _actionsLiveFilter.selectNodeFilter)(node));
	                                },
	                                list: this.listNodeFilter.bind(this),
	                                header: 'All areas'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeviceManagement;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        nodeMap: state.overviewReducer.nodeMap,
	        nodeFilter: state.liveReducer.nodeFilter,
	        viewFilter: state.liveReducer.viewFilter,
	        user: state.myAccountReducer.user,
	        images: state.floorPlanReducer.images
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeviceManagement);
	module.exports = exports['default'];

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _sensor = __webpack_require__(1886);
	
	var _sensor2 = _interopRequireDefault(_sensor);
	
	var _area = __webpack_require__(1898);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _devicesetting = __webpack_require__(1899);
	
	var _devicesetting2 = _interopRequireDefault(_devicesetting);
	
	var _actionsFloorplan = __webpack_require__(203);
	
	var _actionsStats = __webpack_require__(207);
	
	var _actionsLiveFilter = __webpack_require__(348);
	
	var _reactSelectableFastForked = __webpack_require__(1887);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var FloorPlan = (function (_React$Component) {
	    _inherits(FloorPlan, _React$Component);
	
	    function FloorPlan(props, context) {
	        _classCallCheck(this, FloorPlan);
	
	        _get(Object.getPrototypeOf(FloorPlan.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loading: false,
	            hasPermission: this.hasPermission(),
	            url: "",
	            selectedSensors: [],
	            selectingMode: "view" // selecting, selected, view
	        };
	        this.selectableGroup = _react2['default'].createRef();
	    }
	
	    // default view filter is Configuration View
	
	    _createClass(FloorPlan, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _actionsLiveFilter.selectViewFilter)(_config2['default'].viewFilter[3]));
	        }
	    }, {
	        key: 'getImage',
	        value: function getImage(urlList, node) {
	            while (node) {
	                if (node.info.useownfp) {
	                    return urlList[node.id.toString()];
	                }
	                node = node.parent;
	            }
	            // return undefined
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ hasPermission: this.hasPermission(nextProps) });
	            if (this.state.loading) {
	                var url = this.getImage(nextProps.images, nextProps.root);
	                if (url != this.state.url) {
	                    this.setState({ url: url, loading: false });
	                }
	            }
	        }
	    }, {
	        key: 'fetchSensorAvg',
	        value: function fetchSensorAvg(props) {
	            var params = (0, _actionsStats.getParams)({
	                querySettings: props.query,
	                currentNode: props.root
	            });
	            this.props.dispatch((0, _actionsStats.getSensorAverage)(params, props.root));
	            this.setState({
	                isFetched: !this.state.isFetched
	            });
	        }
	    }, {
	        key: 'querySettingsChanged',
	        value: function querySettingsChanged(q1, q2) {
	            return q1.startdate !== q2.startdate || q1.enddate !== q2.enddate || q1.starthour !== q2.starthour || q1.endhour !== q2.endhour || q1.weekdaymask !== q2.weekdaymask;
	        }
	    }, {
	        key: 'imageError',
	        value: function imageError() {
	            this.setState({
	                loading: true
	            });
	            this.props.dispatch((0, _actionsFloorplan.fetchImage)(this.props.user.companyid));
	        }
	
	        // Multiple selection feature
	    }, {
	        key: 'duringSelection',
	        value: function duringSelection() {
	            this.setState({
	                selectingMode: "selecting"
	            });
	        }
	    }, {
	        key: 'onSelectionFinish',
	        value: function onSelectionFinish(selectedItems) {
	            var _this = this;
	
	            // set selectedSensors
	            var selectedSensors = [];
	            selectedItems.map(function (sensor) {
	                selectedSensors.push({
	                    sensorId: sensor.props.selectableSensors.sensorId,
	                    sensorMac: sensor.props.selectableSensors.macaddress
	                });
	            });
	            this.setState({
	                selectedSensors: selectedSensors
	            }, function () {
	                return console.log("current selected Sensors at timestamp", Date.now(), _this.state.selectedSensors);
	            });
	        }
	    }, {
	        key: 'handleRightClick',
	        value: function handleRightClick(e) {
	
	            var devicemanagementPage = window.location.href.split('#')[1].match(/\/devicemanagement\/\w+/ig);
	            if (devicemanagementPage) {
	                e.preventDefault();e.stopPropagation();
	                this.onSelectionClear();
	                console.log('Cancel selection');
	                this.selectableGroup.current.clearSelection();
	            }
	        }
	    }, {
	        key: 'onSelectionClear',
	        value: function onSelectionClear() {
	            this.setState({
	                selectingMode: "view",
	                selectedSensors: []
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.props.root || !this.props.configMap) {
	                return null;
	            }
	            var areas = [],
	                sensors = [];
	            this.listNodes(this.props.root, areas, sensors);
	
	            if (!this.state.loading && !this.props.root.info.empty) {
	                var url = this.getImage(this.props.images, this.props.root);
	
	                if (url && this.props.root.info.hasfloorplan) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'row no-pad row-eq-height' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (!this.props.thumbnail ? 'col-lg-7' : 'col-lg-12') + ' justify-center' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: "floorplan-outer-container " + (!this.props.thumbnail ? "not-thumbnail_device-managment" : "") },
	                                !this.props.thumbnail && _react2['default'].createElement(
	                                    'div',
	                                    { className: 'floorplan-options-container' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'floorplan-options' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'options-help' },
	                                            _react2['default'].createElement(
	                                                _react2['default'].Fragment,
	                                                null,
	                                                _react2['default'].createElement(
	                                                    'div',
	                                                    { className: 'help-icon ' },
	                                                    _react2['default'].createElement(
	                                                        _componentsCommonModal2['default'],
	                                                        {
	                                                            disableCloseButton: true,
	                                                            ref: function (elem) {
	                                                                _this2.openInfoModal = elem;
	                                                            },
	                                                            clickButton: function () {
	                                                                _this2.openInfoModal.close();
	                                                            },
	                                                            header: 'Multiple sensors selection',
	                                                            buttonText: 'Got it',
	                                                            buttonClass: 'btn-success',
	                                                            entry: _react2['default'].createElement('img', { onClick: function () {
	                                                                    _this2.openInfoModal.open();
	                                                                }, className: 'card-info cursor--pointer', src: 'src/assets/icons/info.svg', alt: 'info-icon' }),
	                                                            className: 'help-icon_modal'
	                                                        },
	                                                        _react2['default'].createElement(
	                                                            'p',
	                                                            null,
	                                                            'Click on the sensor one by one'
	                                                        ),
	                                                        _react2['default'].createElement(
	                                                            'p',
	                                                            null,
	                                                            'Alternatively, left click and drag the cursor around the sensors'
	                                                        ),
	                                                        _react2['default'].createElement(
	                                                            'p',
	                                                            null,
	                                                            'Right click to cancel configuration'
	                                                        ),
	                                                        _react2['default'].createElement(
	                                                            'p',
	                                                            null,
	                                                            'All sensors with same configuration have the same color. If the sensor configuration is being updated (there is a difference between ‘read value’ and ‘sent value’), the sensor will blink.'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2['default'].createElement(
	                                                    'div',
	                                                    { className: this.props.viewFilter.code !== "CONFIGURATION" ? "help-text ht-show" : "help-text ht-hide" },
	                                                    'Hover over a sensor for more info.'
	                                                ),
	                                                this.props.viewFilter.code === "CONFIGURATION" && _react2['default'].createElement(
	                                                    _react2['default'].Fragment,
	                                                    null,
	                                                    _react2['default'].createElement(
	                                                        'div',
	                                                        { className: this.state.selectingMode === "view" || this.state.selectedSensors.length === 0 ? "help-text ht-show" : "help-text ht-hide" },
	                                                        'Left click & drag the cursor around to select multiple sensors'
	                                                    ),
	                                                    this.state.selectedSensors.length > 0 && _react2['default'].createElement(
	                                                        'div',
	                                                        { className: this.state.selectingMode === "selecting" || this.state.selectingMode === "selected" ? "help-text ht-show" : "help-text ht-hide" },
	                                                        'Right click or Press ESC to cancel'
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'options-buttons-container' },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: 'options-buttons-wrapper' },
	                                                this.props.children,
	                                                _react2['default'].createElement(
	                                                    'div',
	                                                    { className: 'options-buttons' },
	                                                    _react2['default'].createElement(
	                                                        'i',
	                                                        {
	                                                            className: 'material-icons',
	                                                            'data-tooltip': this.props.showDetails ? "Showing details" : "Hiding details",
	                                                            onClick: function () {
	                                                                return _this2.props.changeMRMode();
	                                                            }
	                                                        },
	                                                        this.props.showDetails ? "settings_ethernet" : "code"
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2['default'].createElement('div', { className: 'floorplan--divider' })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    {
	                                        ref: function (e) {
	                                            _this2.floorplan = e;
	                                        }, className: 'device-management-floorplan ' + (!this.props.thumbnail ? "floorplan-container" : "floorplan-container-thumbnail") },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        {
	                                            onContextMenu: this.handleRightClick.bind(this),
	                                            style: { position: "relative", width: "100%", height: "100%" } },
	                                        _react2['default'].createElement(
	                                            _reactSelectableFastForked.SelectableGroup,
	                                            {
	                                                selectboxClassName: 'selectbox-device',
	                                                ref: this.selectableGroup,
	                                                mixedDeselect: true,
	                                                enableDeselect: true,
	                                                tolerance: 0,
	                                                deselectOnEsc: true,
	                                                allowClickWithoutSelected: true,
	                                                duringSelection: this.duringSelection.bind(this),
	                                                onSelectionClear: this.onSelectionClear.bind(this),
	                                                onSelectionFinish: this.onSelectionFinish.bind(this),
	                                                ignoreList: ['.not-selectable']
	                                                // disabled={this.props.viewFilter.code === "CONFIGURATION" ? false : true}
	                                            },
	                                            _react2['default'].createElement(
	                                                _react2['default'].Fragment,
	                                                null,
	                                                _react2['default'].createElement('img', {
	                                                    src: url,
	                                                    alt: 'Floorplan',
	                                                    className: 'floorplan-image .not-selectable',
	                                                    ref: 'floorplan-image',
	                                                    onError: this.imageError.bind(this),
	                                                    draggable: 'false',
	                                                    key: 'image'
	                                                }),
	                                                sensors.map(function (sensor) {
	                                                    var ss = _this2.props.sensorMap.get(sensor.id);
	                                                    // defined this var to later access on onSelectionFinish()
	                                                    var selectableSensors = { sensorId: sensor.id, macaddress: sensor.info.details.macaddress };
	                                                    return ss && _react2['default'].createElement(_sensor2['default'], {
	                                                        selectableSensors: selectableSensors,
	                                                        key: sensor.id,
	                                                        selectingMode: _this2.state.selectingMode,
	                                                        sensor: ss,
	                                                        viewFilter: _this2.props.viewFilter,
	                                                        thumbnail: _this2.props.thumbnail,
	                                                        color: _this2.props.colors[ss.macaddress]
	                                                    });
	                                                }),
	                                                areas.map(function (node) {
	                                                    return _react2['default'].createElement(_area2['default'], {
	                                                        viewFilter: _this2.props.viewFilter,
	                                                        key: node.id,
	                                                        node: node,
	                                                        thumbnail: _this2.props.thumbnail
	                                                    });
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        !this.props.thumbnail && _react2['default'].createElement(
	                            'div',
	                            { className: 'col-lg-5 justify-center', style: { paddingLeft: "20px" } },
	                            _react2['default'].createElement(_devicesetting2['default'], {
	                                isClicked: this.state.selectedSensors.length > 0,
	                                selectedSensors: this.state.selectedSensors
	                            })
	                        )
	                    );
	                } else {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'floorplan-error' },
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'Oops ! We can\'t find this location\'s floorplan...'
	                        )
	                    );
	                }
	            } else {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'floorplan-error' },
	                    _react2['default'].createElement('br', null),
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'Loading...'
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'hasPermission',
	        value: function hasPermission(Props) {
	            var props = Props || this.props;
	            var node = props.root;
	            if (props.user.role != "ADMIN" && props.user.role != "SUPPORTUSER") {
	                return false;
	            }
	            while (node) {
	                if (node.id == props.user.rootnodeid) {
	                    return true;
	                }
	                node = node.parent;
	            }
	            return false;
	        }
	    }, {
	        key: 'listNodes',
	        value: function listNodes(root, areas, sensors) {
	            var self = this;
	            if (root) {
	                var isArea = root.type == "meeting_room" && !this.props.showDetails;
	                isArea |= root.id != this.props.root.id && root.info.useownfp && root.type != "sensor";
	                if (isArea) {
	                    areas.push(root);
	                } else {
	                    if (root.type == "sensor") {
	                        sensors.push(root);
	                    }
	                    if (root.children) {
	                        root.children.forEach(function (child) {
	                            self.listNodes(child, areas, sensors);
	                        });
	                    }
	                }
	            }
	        }
	    }]);
	
	    return FloorPlan;
	})(_react2['default'].Component);
	
	exports.FloorPlan = FloorPlan;
	
	function mapStateToProps(state) {
	    return {
	        sensorMap: state.nodeReducer.map,
	        images: state.floorPlanReducer.images,
	        user: state.myAccountReducer.user,
	        configMap: state.devManReducer.configMap,
	        colors: state.devManReducer.colors
	    };
	}
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FloorPlan);

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactTimestamp = __webpack_require__(1311);
	
	var _reactTimestamp2 = _interopRequireDefault(_reactTimestamp);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactSelectableFastForked = __webpack_require__(1887);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(1897);
	
	var Sensor = (function (_React$Component) {
		_inherits(Sensor, _React$Component);
	
		function Sensor(props) {
			_classCallCheck(this, Sensor);
	
			_get(Object.getPrototypeOf(Sensor.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Sensor, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				// only display tooltip on view or selected mode
				if (this.props.selectingMode === "view" || this.props.selectingMode === "selected") {
					this.setState({ tooltipOpen: true });
				}
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				this.setState({ tooltipOpen: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var props = this.props;
				var color = props.color;
				var sensor = props.sensor;
				var viewFilter = props.viewFilter;
				var thumbnail = props.thumbnail;
				var selectableRef = props.selectableRef;
				var selected = props.selected;
	
				var style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
				var className = 'point';
	
				var sensorConfig = this.props.configMap[sensor.macaddress];
	
				// sensor will be blink if there is a difference between ‘read value’ and ‘sent value’
				if (!(0, _lodash.isEmpty)(sensorConfig.pendingConfig)) {
					className += ' pending';
				}
	
				if (selected) {
					className += ' selected';
				}
	
				//------------------------------filter condition------------------------
				// default live view color for sensor
				if (sensor.registered && sensor.lastonl + 24 * 60 * 60 > (0, _moment2['default'])().unix()) {
					if (sensor.faulty) {
						className += ' faulty';
					} else {
						if (sensor.inuse) {
							className += ' inuse';
						} else if (sensor.standby) {
							className += ' standby';
						}
					}
				} else {
					className += ' unregistered';
				}
				// Filter out sensors
				if (viewFilter) {
					if (viewFilter.code == "LIVE" && (!sensor.registered || sensor.faulty)) {
						// hide broken / unregistered sensor in live view.
						className += ' hidden';
					}
					if (viewFilter.code == "MAINTENANCE" && sensor.registered && !sensor.faulty) {
						// hide good and registered sensor in maintenance view.
						className += ' hidden';
					}
				}
				// Filter configuration view
				viewFilter.code === "CONFIGURATION" && (style.backgroundColor = color);
				if (!thumbnail) {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						_react2['default'].createElement('div', {
							ref: selectableRef,
							className: className, style: style,
							id: "sensor" + sensor.id,
							onMouseEnter: function () {
								return _this.onMouseEnter();
							},
							onMouseLeave: function () {
								return _this.onMouseLeave();
							}
							//onClick={(e) => { this.props.onClickNode(e, sensor) }}
						}),
						_react2['default'].createElement(
							_reactPortalTooltip2['default'],
							{
								tooltipTimeout: 100,
								active: this.state.tooltipOpen, parent: "#sensor" + sensor.id, position: 'right', arrow: 'center',
								style: {
									style: {
										background: "rgba(0,0,0,.9)",
										padding: 10,
										color: "#EEE",
										boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
										borderRadius: 4
									},
									arrowStyle: {
										color: 'rgba(0,0,0,.8)',
										borderColor: false
									}
								}
							},
							_react2['default'].createElement(
								'table',
								null,
								_react2['default'].createElement(
									'tbody',
									null,
									_react2['default'].createElement(
										'tr',
										null,
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(
												'div',
												null,
												sensor.name
											),
											_react2['default'].createElement(
												'div',
												null,
												sensor.macaddress.toUpperCase()
											),
											!sensor.registered ? _react2['default'].createElement(
												'div',
												null,
												' Maintenance ',
												' '
											) : sensor.faulty ? _react2['default'].createElement(
												'div',
												null,
												'Offline since ',
												_react2['default'].createElement(_reactTimestamp2['default'], { time: sensor.lastonl })
											) : ""
										)
									)
								)
							)
						)
					);
				} else {
					return _react2['default'].createElement(
						'div',
						{ ref: selectableRef },
						_react2['default'].createElement('div', { className: className, style: style,
							'data-tip': true, 'data-for': "sensor" + sensor.id
						}),
						_react2['default'].createElement(
							_reactTooltip2['default'],
							{ id: "sensor" + sensor.id, place: 'right', type: 'dark', effect: 'solid' },
							sensor.name,
							_react2['default'].createElement('br', null),
							sensor.macaddress.toUpperCase()
						)
					);
				}
			}
		}]);
	
		return Sensor;
	})(_react2['default'].Component);
	
	exports.Sensor = Sensor;
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap,
			configMap: state.devManReducer.configMap
		};
	}
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Sensor.propTypes = {
		nodeMap: _propTypes2['default'].object.isRequired,
		sensor: _propTypes2['default'].object.isRequired,
		viewFilter: _propTypes2['default'].object,
		//onClickNode: PropTypes.func.isRequired,
		thumbnail: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactSelectableFastForked.createSelectable)(Sensor));
	/*Change from Unregistered to Maintenance*/

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SelectableGroup", {
	  enumerable: true,
	  get: function get() {
	    return _SelectableGroup["default"];
	  }
	});
	Object.defineProperty(exports, "createSelectable", {
	  enumerable: true,
	  get: function get() {
	    return _CreateSelectable["default"];
	  }
	});
	Object.defineProperty(exports, "SelectAll", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAll["default"];
	  }
	});
	Object.defineProperty(exports, "DeselectAll", {
	  enumerable: true,
	  get: function get() {
	    return _DeselectAll["default"];
	  }
	});
	
	var _SelectableGroup = _interopRequireDefault(__webpack_require__(1888));
	
	var _CreateSelectable = _interopRequireDefault(__webpack_require__(1894));
	
	var _SelectAll = _interopRequireDefault(__webpack_require__(1895));
	
	var _DeselectAll = _interopRequireDefault(__webpack_require__(1896));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// As early as possible, check for the existence of the JavaScript globals which
	// Relay Runtime relies upon, and produce a clear message if they do not exist.
	if (false) {
	  if (typeof Map !== 'function' || typeof Set !== 'function' || typeof Array.from !== 'function' || typeof Array.isArray !== 'function' || typeof Object.assign !== 'function') {
	    throw new Error("\n      React-Selectable-Fast requires Map, Set, Array.from,\n      Array.isArray, and Object.assign to exist.\n      Use a polyfill to provide these for older browsers.\n    ");
	  }
	}

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = __webpack_require__(53);
	
	var _nodeInRoot = _interopRequireDefault(__webpack_require__(1889));
	
	var _getBoundsForNode = _interopRequireWildcard(__webpack_require__(1890));
	
	var _doObjectsCollide = _interopRequireDefault(__webpack_require__(1891));
	
	var _Selectbox = _interopRequireDefault(__webpack_require__(1892));
	
	var _Context = _interopRequireDefault(__webpack_require__(1893));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var noop = function noop() {};
	
	var SelectableGroup =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(SelectableGroup, _Component);
	
	  function SelectableGroup(props) {
	    var _this;
	
	    _classCallCheck(this, SelectableGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectableGroup).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "setScollTop", function (e) {
	      var scrollTop = _this.scrollContainer.scrollTop;
	
	      _this.checkScrollTop(e, scrollTop);
	
	      _this.checkScrollBottom(e, scrollTop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkScrollTop", function (e, currentTop) {
	      var _this$props = _this.props,
	          minimumSpeedFactor = _this$props.minimumSpeedFactor,
	          scrollSpeed = _this$props.scrollSpeed;
	      var offset = _this.scrollBounds.top - e.clientY;
	
	      if (offset > 0 || e.clientY < 0) {
	        var newTop = currentTop - Math.max(offset, minimumSpeedFactor) * scrollSpeed;
	        _this.scrollContainer.scrollTop = newTop;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkScrollBottom", function (e, currentTop) {
	      var _this$props2 = _this.props,
	          minimumSpeedFactor = _this$props2.minimumSpeedFactor,
	          scrollSpeed = _this$props2.scrollSpeed;
	      var offset = e.clientY - _this.scrollBounds.bottom;
	
	      if (offset > 0 || e.clientY > window.innerHeight) {
	        var newTop = currentTop + Math.max(offset, minimumSpeedFactor) * scrollSpeed;
	        _this.scrollContainer.scrollTop = Math.min(newTop, _this.maxScroll);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateRegistry", function () {
	      var containerScroll = {
	        scrollTop: _this.scrollContainer.scrollTop,
	        scrollLeft: _this.scrollContainer.scrollLeft
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _this.registry.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selectableItem = _step.value;
	          selectableItem.registerSelectable(containerScroll);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "registerSelectable", function (selectableItem) {
	      _this.registry.add(selectableItem);
	
	      if (selectableItem.state.selected) {
	        _this.selectedItems.add(selectableItem);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unregisterSelectable", function (selectableItem) {
	      _this.registry["delete"](selectableItem);
	
	      _this.selectedItems["delete"](selectableItem);
	
	      _this.selectingItems["delete"](selectableItem);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "applyContainerScroll", function (value, scroll) {
	      return value + scroll;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "openSelectbox", function (event) {
	      var e = _this.desktopEventCoords(event);
	
	      _this.setScollTop(e);
	
	      if (_this.mouseMoveStarted) return;
	      _this.mouseMoveStarted = true;
	      _this.mouseMoved = true;
	      var _this$scrollContainer = _this.scrollContainer,
	          scrollTop = _this$scrollContainer.scrollTop,
	          scrollLeft = _this$scrollContainer.scrollLeft;
	      var eventTop = e.pageY;
	      var eventLeft = e.pageX;
	
	      var _getDocumentScroll = (0, _getBoundsForNode.getDocumentScroll)(),
	          documentScrollTop = _getDocumentScroll.documentScrollTop,
	          documentScrollLeft = _getDocumentScroll.documentScrollLeft;
	
	      var top = _this.applyContainerScroll(eventTop - _this.scrollBounds.top, scrollTop - documentScrollTop);
	
	      var boxTop = _this.applyContainerScroll(_this.mouseDownData.boxTop - _this.scrollBounds.top, _this.mouseDownData.scrollTop - documentScrollTop);
	
	      var boxHeight = boxTop - top;
	      boxTop = Math.min(boxTop - boxHeight, boxTop);
	
	      var left = _this.applyContainerScroll(eventLeft - _this.scrollBounds.left, scrollLeft - documentScrollLeft);
	
	      var boxLeft = _this.applyContainerScroll(_this.mouseDownData.boxLeft - _this.scrollBounds.left, _this.mouseDownData.scrollLeft - documentScrollLeft);
	
	      var boxWidth = boxLeft - left;
	      boxLeft = Math.min(boxLeft - boxWidth, boxLeft);
	
	      _this.selectbox.setState({
	        isBoxSelecting: true,
	        boxWidth: Math.abs(boxWidth),
	        boxHeight: Math.abs(boxHeight),
	        boxLeft: boxLeft,
	        boxTop: boxTop
	      }, function () {
	        _this.updateSelecting();
	
	        _this.props.duringSelection(_toConsumableArray(_this.selectingItems));
	
	        _this.mouseMoveStarted = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateSelecting", function () {
	      var selectbox = _this.selectbox.getRef();
	
	      if (!selectbox) return;
	      var selectboxBounds = (0, _getBoundsForNode["default"])(selectbox);
	
	      _this.selectItems(_objectSpread({}, selectboxBounds, {
	        offsetWidth: selectboxBounds.offsetWidth || 1,
	        offsetHeight: selectboxBounds.offsetHeight || 1
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectItems", function (selectboxBounds) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          click = _ref.click;
	
	      var _this$props3 = _this.props,
	          tolerance = _this$props3.tolerance,
	          enableDeselect = _this$props3.enableDeselect,
	          mixedDeselect = _this$props3.mixedDeselect;
	      selectboxBounds.top += _this.scrollContainer.scrollTop;
	      selectboxBounds.left += _this.scrollContainer.scrollLeft;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = _this.registry.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          _this.processItem(item, tolerance, selectboxBounds, click, enableDeselect, mixedDeselect);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
	            _iterator2["return"]();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clearSelection", function () {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = _this.selectedItems.values()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var item = _step3.value;
	          item.setState({
	            selected: false
	          });
	
	          _this.selectedItems["delete"](item);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
	            _iterator3["return"]();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      _this.setState({
	        selectionMode: false
	      });
	
	      _this.props.onSelectionFinish(_toConsumableArray(_this.selectedItems));
	
	      _this.selectbox.setState({
	        isBoxSelecting: false,
	        boxWidth: 0,
	        boxHeight: 0
	      });
	
	      _this.props.onSelectionClear();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
	      _this.updateWhiteListNodes();
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = _this.registry.values()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var item = _step4.value;
	
	          if (!_this.inIgnoreList(item.node) && !item.state.selected) {
	            item.setState({
	              selected: true
	            });
	
	            _this.selectedItems.add(item);
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
	            _iterator4["return"]();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      _this.setState({
	        selectionMode: true
	      });
	
	      _this.props.onSelectionFinish(_toConsumableArray(_this.selectedItems));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mouseDown", function (e) {
	      if (_this.mouseDownStarted || _this.props.disabled || !_this.detectLeftButton(e)) return;
	
	      _this.updateWhiteListNodes();
	
	      if (_this.inIgnoreList(e.target)) {
	        _this.mouseDownStarted = false;
	        return;
	      }
	
	      if (_this.props.resetOnStart) {
	        _this.clearSelection();
	      }
	
	      _this.mouseDownStarted = true;
	      _this.mouseUpStarted = false;
	      e = _this.desktopEventCoords(e);
	
	      if (!_this.props.globalMouse && !(0, _nodeInRoot["default"])(e.target, _this.selectableGroup)) {
	        var offsetData = (0, _getBoundsForNode["default"])(_this.selectableGroup);
	        var collides = (0, _doObjectsCollide["default"])({
	          top: offsetData.top,
	          left: offsetData.left,
	          bottom: offsetData.offsetHeight,
	          right: offsetData.offsetWidth
	        }, {
	          top: e.pageY,
	          left: e.pageX,
	          offsetWidth: 0,
	          offsetHeight: 0
	        });
	        if (!collides) return;
	      }
	
	      _this.updateRootBounds();
	
	      _this.updateRegistry();
	
	      _this.mouseDownData = {
	        boxLeft: e.pageX,
	        boxTop: e.pageY,
	        scrollTop: _this.scrollContainer.scrollTop,
	        scrollLeft: _this.scrollContainer.scrollLeft,
	        target: e.target
	      };
	      e.preventDefault();
	      document.addEventListener('mousemove', _this.openSelectbox);
	      document.addEventListener('touchmove', _this.openSelectbox);
	      document.addEventListener('mouseup', _this.mouseUp);
	      document.addEventListener('touchend', _this.mouseUp);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mouseUp", function (event) {
	      if (_this.mouseUpStarted) return;
	      _this.mouseUpStarted = true;
	      _this.mouseDownStarted = false;
	
	      _this.removeTempEventListeners();
	
	      if (!_this.mouseDownData) return;
	
	      var e = _this.desktopEventCoords(event);
	
	      var eventTop = e.pageY;
	      var eventLeft = e.pageX;
	
	      if (!_this.mouseMoved && (0, _nodeInRoot["default"])(e.target, _this.rootNode)) {
	        _this.handleClick(e, eventTop, eventLeft);
	      } else {
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = _this.selectingItems.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var item = _step5.value;
	            item.setState({
	              selected: true,
	              selecting: false
	            });
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
	              _iterator5["return"]();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	
	        _this.selectedItems = new Set(_toConsumableArray(_this.selectedItems).concat(_toConsumableArray(_this.selectingItems)));
	
	        _this.selectingItems.clear();
	
	        if (e.which === 1 && _this.mouseDownData.target === e.target) {
	          _this.preventEvent(e.target, 'click');
	        }
	
	        _this.props.onSelectionFinish(_toConsumableArray(_this.selectedItems));
	      }
	
	      _this.toggleSelectionMode();
	
	      _this.cleanUp();
	
	      _this.mouseMoved = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyListener", function (e) {
	      if (e.ctrlKey || e.metaKey) {
	        return;
	      }
	
	      if (e.keyCode === 27) {
	        // escape
	        _this.clearSelection();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getGroupRef", function (c) {
	      return _this.selectableGroup = c;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getSelectboxRef", function (c) {
	      return _this.selectbox = c;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "defaultContainerStyle", {
	      position: 'relative'
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "contextValue", {
	      selectable: {
	        register: _this.registerSelectable,
	        unregister: _this.unregisterSelectable,
	        selectAll: _this.selectAll,
	        clearSelection: _this.clearSelection,
	        getScrolledContainer: function getScrolledContainer() {
	          return _this.scrollContainer;
	        }
	      }
	    });
	
	    _this.state = {
	      selectionMode: false
	    };
	    _this.mouseDownStarted = false;
	    _this.mouseMoveStarted = false;
	    _this.mouseUpStarted = false;
	    _this.mouseDownData = null;
	    _this.registry = new Set();
	    _this.selectedItems = new Set();
	    _this.selectingItems = new Set();
	    _this.ignoreCheckCache = new Map();
	    _this.ignoreList = _this.props.ignoreList.concat(['.selectable-select-all', '.selectable-deselect-all']);
	    return _this;
	  }
	
	  _createClass(SelectableGroup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.rootNode = this.selectableGroup;
	      this.scrollContainer = document.querySelector(this.props.scrollContainer) || this.rootNode;
	      this.rootNode.addEventListener('mousedown', this.mouseDown);
	      this.rootNode.addEventListener('touchstart', this.mouseDown);
	
	      if (this.props.deselectOnEsc) {
	        document.addEventListener('keydown', this.keyListener);
	        document.addEventListener('keyup', this.keyListener);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.rootNode.removeEventListener('mousedown', this.mouseDown);
	      this.rootNode.removeEventListener('touchstart', this.mouseDown);
	
	      if (this.props.deselectOnEsc) {
	        document.removeEventListener('keydown', this.keyListener);
	        document.removeEventListener('keyup', this.keyListener);
	      }
	
	      this.removeTempEventListeners();
	    }
	  }, {
	    key: "removeTempEventListeners",
	    value: function removeTempEventListeners() {
	      document.removeEventListener('mousemove', this.openSelectbox);
	      document.removeEventListener('touchmove', this.openSelectbox);
	      document.removeEventListener('mouseup', this.mouseUp);
	      document.removeEventListener('touchend', this.mouseUp);
	    }
	  }, {
	    key: "updateRootBounds",
	    value: function updateRootBounds() {
	      this.scrollBounds = this.scrollContainer.getBoundingClientRect();
	      this.maxScroll = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
	    }
	  }, {
	    key: "toggleSelectionMode",
	    value: function toggleSelectionMode() {
	      var selectedItems = this.selectedItems,
	          selectionMode = this.state.selectionMode;
	
	      if (selectedItems.size && !selectionMode) {
	        this.setState({
	          selectionMode: true
	        });
	      }
	
	      if (!selectedItems.size && selectionMode) {
	        this.setState({
	          selectionMode: false
	        });
	      }
	    }
	  }, {
	    key: "processItem",
	    value: function processItem(item, tolerance, selectboxBounds, click, enableDeselect, mixedDeselect) {
	      if (this.inIgnoreList(item.node)) {
	        return null;
	      }
	
	      var isCollided = (0, _doObjectsCollide["default"])(selectboxBounds, item.bounds, tolerance, this.props.delta);
	      var _item$state = item.state,
	          selecting = _item$state.selecting,
	          selected = _item$state.selected;
	
	      if (click && isCollided) {
	        if (selected) {
	          this.selectedItems["delete"](item);
	        } else {
	          this.selectedItems.add(item);
	        }
	
	        item.setState({
	          selected: !selected
	        });
	        return this.clickedItem = item;
	      }
	
	      if (!click && isCollided) {
	        if (selected && enableDeselect && (!this.selectionStarted || mixedDeselect)) {
	          item.setState({
	            selected: false
	          });
	          item.deselected = true;
	          this.deselectionStarted = true;
	          return this.selectedItems["delete"](item);
	        }
	
	        var canSelect = mixedDeselect ? !item.deselected : !this.deselectionStarted;
	
	        if (!selecting && !selected && canSelect) {
	          item.setState({
	            selecting: true
	          });
	          this.selectionStarted = true;
	          this.selectingItems.add(item);
	          return {
	            updateSelecting: true
	          };
	        }
	      }
	
	      if (!click && !isCollided && selecting) {
	        if (this.selectingItems.has(item)) {
	          item.setState({
	            selecting: false
	          });
	          this.selectingItems["delete"](item);
	          return {
	            updateSelecting: true
	          };
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "inIgnoreList",
	    value: function inIgnoreList(target) {
	      if (this.ignoreCheckCache.get(target) !== undefined) {
	        return this.ignoreCheckCache.get(target);
	      }
	
	      var shouldBeIgnored = this.ignoreListNodes.some(function (ignoredNode) {
	        return target === ignoredNode || ignoredNode.contains(target);
	      });
	      this.ignoreCheckCache.set(target, shouldBeIgnored);
	      return shouldBeIgnored;
	    }
	  }, {
	    key: "updateWhiteListNodes",
	    value: function updateWhiteListNodes() {
	      this.ignoreListNodes = _toConsumableArray(document.querySelectorAll(this.ignoreList.join(', ')));
	    }
	  }, {
	    key: "detectLeftButton",
	    value: function detectLeftButton(event) {
	      if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
	        return false;
	      }
	
	      if ('buttons' in event) {
	        return event.buttons === 1;
	      }
	
	      if ('which' in event) {
	        return event.which === 1;
	      }
	
	      return event.button === 1;
	    }
	  }, {
	    key: "preventEvent",
	    value: function preventEvent(target, type) {
	      var preventHandler = function preventHandler(e) {
	        target.removeEventListener(type, preventHandler, true);
	        e.preventDefault();
	        e.stopPropagation();
	      };
	
	      target.addEventListener(type, preventHandler, true);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(e, top, left) {
	      var classNames = e.target.classList || [];
	      var isMouseUpOnClickElement = _toConsumableArray(classNames).indexOf(this.props.clickClassName) > -1;
	
	      if (this.props.allowClickWithoutSelected || this.selectedItems.size || isMouseUpOnClickElement || this.ctrlPressed) {
	        this.selectItems({
	          top: top,
	          left: left,
	          offsetWidth: 0,
	          offsetHeight: 0
	        }, {
	          click: true
	        });
	        this.props.onSelectionFinish(_toConsumableArray(this.selectedItems), this.clickedItem);
	
	        if (e.which === 1) {
	          this.preventEvent(e.target, 'click');
	        }
	
	        if (e.which === 2 || e.which === 3) {
	          this.preventEvent(e.target, 'contextmenu');
	        }
	      }
	    }
	  }, {
	    key: "cleanUp",
	    value: function cleanUp() {
	      this.deselectionStarted = false;
	      this.selectionStarted = false;
	
	      if (this.props.mixedDeselect) {
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = this.registry.values()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var item = _step6.value;
	            item.deselected = false;
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
	              _iterator6["return"]();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	      }
	    }
	    /**
	     * Used to return event object with desktop (non-touch) format of event
	     * coordinates, regardless of whether the action is from mobile or desktop.
	     */
	
	  }, {
	    key: "desktopEventCoords",
	    value: function desktopEventCoords(e) {
	      if (e.pageX === undefined || e.pageY === undefined) {
	        // Touch-device
	        if (e.targetTouches[0] !== undefined && e.targetTouches[0].pageX !== undefined) {
	          // For touchmove
	          e.pageX = e.targetTouches[0].pageX;
	          e.pageY = e.targetTouches[0].pageY;
	        } else if (e.changedTouches[0] !== undefined && e.changedTouches[0].pageX !== undefined) {
	          // For touchstart
	          e.pageX = e.changedTouches[0].pageX;
	          e.pageY = e.changedTouches[0].pageY;
	        }
	      }
	
	      return e;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_Context["default"].Provider, {
	        value: this.contextValue
	      }, _react["default"].createElement(this.props.component, {
	        ref: this.getGroupRef,
	        style: Object.assign({}, this.defaultContainerStyle, this.props.style),
	        className: "".concat(this.props.className, " ").concat(this.state.selectionMode ? this.props.selectionModeClass : '')
	      }, _react["default"].createElement(_Selectbox["default"], {
	        ref: this.getSelectboxRef,
	        fixedPosition: this.props.fixedPosition,
	        className: this.props.selectboxClassName
	      }), this.props.children));
	    }
	  }]);
	
	  return SelectableGroup;
	}(_react.Component);
	
	_defineProperty(SelectableGroup, "propTypes", {
	  globalMouse: _propTypes.bool,
	  ignoreList: _propTypes.array,
	  scrollSpeed: _propTypes.number,
	  minimumSpeedFactor: _propTypes.number,
	  allowClickWithoutSelected: _propTypes.bool,
	  className: _propTypes.string,
	  selectboxClassName: _propTypes.string,
	  style: _propTypes.object,
	  selectionModeClass: _propTypes.string,
	  onSelectionClear: _propTypes.func,
	  enableDeselect: _propTypes.bool,
	  mixedDeselect: _propTypes.bool,
	  deselectOnEsc: _propTypes.bool,
	  resetOnStart: _propTypes.bool,
	  disabled: _propTypes.bool,
	  delta: _propTypes.number,
	
	  /**
	   * Scroll container selector
	   */
	  scrollContainer: _propTypes.string,
	
	  /**
	   * Event that will fire rapidly during selection (while the selector is
	   * being dragged). Passes an array of keys.
	   */
	  duringSelection: _propTypes.func,
	
	  /**
	   * Event that will fire when items are selected. Passes an array of keys.
	   */
	  onSelectionFinish: _propTypes.func,
	
	  /**
	   * The component that will represent the Selectable DOM node
	   */
	  component: _propTypes.node,
	
	  /**
	   * Amount of forgiveness an item will offer to the selectbox before registering
	   * a selection, i.e. if only 1px of the item is in the selection, it shouldn't be
	   * included.
	   */
	  tolerance: _propTypes.number,
	
	  /**
	   * In some cases, it the bounding box may need fixed positioning, if your layout
	   * is relying on fixed positioned elements, for instance.
	   * @type boolean
	   */
	  fixedPosition: _propTypes.bool
	});
	
	_defineProperty(SelectableGroup, "defaultProps", {
	  component: 'div',
	  tolerance: 0,
	  globalMouse: false,
	  ignoreList: [],
	  scrollSpeed: 0.25,
	  minimumSpeedFactor: 60,
	  duringSelection: noop,
	  onSelectionFinish: noop,
	  onSelectionClear: noop,
	  allowClickWithoutSelected: true,
	  selectionModeClass: 'in-selection-mode',
	  resetOnStart: false,
	  disabled: false,
	  deselectOnEsc: true,
	  delta: 1
	});
	
	var _default = SelectableGroup;
	exports["default"] = _default;

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isNodeInRoot;
	
	function isNodeInRoot(node, root) {
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDocumentScroll = getDocumentScroll;
	exports["default"] = getBoundsForNode;
	
	function getDocumentScroll() {
	  var documentScrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
	  var documentScrollLeft = Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft);
	  return {
	    documentScrollTop: documentScrollTop,
	    documentScrollLeft: documentScrollLeft
	  };
	}
	/**
	 * Given a node, get everything needed to calculate its boundaries
	 * @param  {HTMLElement} node
	 * @return {Object}
	 */
	
	
	function getBoundsForNode(node) {
	  var containerScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    scrollTop: 0,
	    scrollLeft: 0
	  };
	  var scrollTop = containerScroll.scrollTop,
	      scrollLeft = containerScroll.scrollLeft;
	
	  var _getDocumentScroll = getDocumentScroll(),
	      documentScrollTop = _getDocumentScroll.documentScrollTop,
	      documentScrollLeft = _getDocumentScroll.documentScrollLeft;
	
	  var rect = node.getBoundingClientRect();
	  return {
	    top: rect.top + documentScrollTop + scrollTop,
	    left: rect.left + documentScrollLeft + scrollLeft,
	    offsetWidth: node.offsetWidth,
	    offsetHeight: node.offsetHeight,
	    computedWidth: rect.width,
	    computedHeight: rect.height
	  };
	}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _getBoundsForNode = _interopRequireDefault(__webpack_require__(1890));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Given offsets, widths, and heights of two objects, determine if they collide (overlap).
	 * @param  {int} aTop    The top position of the first object
	 * @param  {int} aLeft   The left position of the first object
	 * @param  {int} bTop    The top position of the second object
	 * @param  {int} bLeft   The left position of the second object
	 * @param  {int} aWidth  The width of the first object
	 * @param  {int} aHeight The height of the first object
	 * @param  {int} bWidth  The width of the second object
	 * @param  {int} bHeight The height of the second object
	 * @return {bool}
	 */
	var coordsCollide = function coordsCollide(aTop, aLeft, bTop, bLeft, aWidth, aHeight, bWidth, bHeight, tolerance) {
	  if (typeof tolerance === 'undefined') {
	    tolerance = 0;
	  }
	
	  return !(aTop + aHeight - tolerance < bTop // 'a' top doesn't touch 'b' bottom
	  || aTop + tolerance > bTop + bHeight // 'a' right doesn't touch 'b' left
	  || aLeft + aWidth - tolerance < bLeft // 'a' left doesn't touch 'b' right
	  || aLeft + tolerance > bLeft + bWidth);
	};
	/**
	 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
	 * properties, determine if they collide.
	 * @param  {Object|HTMLElement} a
	 * @param  {Object|HTMLElement} b
	 * @return {bool}
	 */
	
	
	var _default = function _default(a, b, tolerance, delta) {
	  if (typeof delta === 'undefined') {
	    delta = 1;
	  }
	
	  var aObj = a instanceof HTMLElement ? (0, _getBoundsForNode["default"])(a) : a;
	  var bObj = b instanceof HTMLElement ? (0, _getBoundsForNode["default"])(b) : b;
	
	  if (delta === 1) {
	    return coordsCollide(aObj.top, aObj.left, bObj.top, bObj.left, aObj.offsetWidth, aObj.offsetHeight, bObj.offsetWidth, bObj.offsetHeight, tolerance);
	  } // We have a delta and we need to compute the new values
	
	
	  return coordsCollide(aObj.top, aObj.left, bObj.top, bObj.left, aObj.computedWidth, aObj.computedHeight, bObj.computedWidth, bObj.computedHeight, tolerance);
	};
	
	exports["default"] = _default;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = __webpack_require__(53);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Selectbox =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Selectbox, _Component);
	
	  function Selectbox() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Selectbox);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Selectbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      boxTop: 0,
	      boxLeft: 0,
	      boxWidth: 0,
	      boxHeight: 0,
	      isBoxSelecting: false
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getRef", function () {
	      return _this.selectbox;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getSelectboxRef", function (c) {
	      return _this.selectbox = c;
	    });
	
	    return _this;
	  }
	
	  _createClass(Selectbox, [{
	    key: "render",
	    value: function render() {
	      var boxStyle = {
	        left: this.state.boxLeft,
	        top: this.state.boxTop,
	        width: this.state.boxWidth,
	        height: this.state.boxHeight,
	        zIndex: 9000,
	        position: this.props.fixedPosition ? 'fixed' : 'absolute',
	        cursor: 'default'
	      };
	      return _react["default"].createElement("div", null, this.state.isBoxSelecting && _react["default"].createElement("div", {
	        ref: this.getSelectboxRef,
	        style: boxStyle,
	        className: this.props.className
	      }));
	    }
	  }]);
	
	  return Selectbox;
	}(_react.Component);
	
	_defineProperty(Selectbox, "propTypes", {
	  fixedPosition: _propTypes.bool,
	  className: _propTypes.string
	});
	
	_defineProperty(Selectbox, "defaultProps", {
	  className: 'selectable-selectbox'
	});
	
	var _default = Selectbox;
	exports["default"] = _default;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var SelectableGroupContext = _react["default"].createContext({
	  selectable: 'omg'
	});
	
	var _default = SelectableGroupContext;
	exports["default"] = _default;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = __webpack_require__(53);
	
	var _getBoundsForNode = _interopRequireDefault(__webpack_require__(1890));
	
	var _Context = _interopRequireDefault(__webpack_require__(1893));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createSelectable = function createSelectable(WrappedComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(SelectableItem, _Component);
	
	    function SelectableItem() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, SelectableItem);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectableItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_this), "state", {
	        selected: _this.props.selected,
	        selecting: false
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "registerSelectable", function (containerScroll) {
	        _this.bounds = (0, _getBoundsForNode["default"])(_this.node, containerScroll);
	
	        _this.context.selectable.register(_assertThisInitialized(_this));
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "selectableRef", function (ref) {
	        return _this.node = ref;
	      });
	
	      return _this;
	    }
	
	    _createClass(SelectableItem, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.registerSelectable();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.context.selectable.unregister(this);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return _react["default"].createElement(WrappedComponent, _extends({}, this.props, {
	          selected: this.state.selected,
	          selecting: this.state.selecting,
	          selectableRef: this.selectableRef
	        }));
	      }
	    }]);
	
	    return SelectableItem;
	  }(_react.Component), _defineProperty(_class, "contextType", _Context["default"]), _defineProperty(_class, "propTypes", {
	    selected: _propTypes.bool
	  }), _defineProperty(_class, "defaultProps", {
	    selected: false
	  }), _temp;
	};
	
	var _default = createSelectable;
	exports["default"] = _default;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = __webpack_require__(53);
	
	var _Context = _interopRequireDefault(__webpack_require__(1893));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SelectAllButton =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(SelectAllButton, _Component);
	
	  function SelectAllButton() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, SelectAllButton);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectAllButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "getRootRef", function (c) {
	      return _this.root = c;
	    });
	
	    return _this;
	  }
	
	  _createClass(SelectAllButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.root.addEventListener('mousedown', function (e) {
	        return e.stopPropagation();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          rest = _objectWithoutProperties(_this$props, ["children", "className"]);
	
	      return _react["default"].createElement(this.props.component, _extends({
	        ref: this.getRootRef,
	        className: "selectable-select-all ".concat(className),
	        onClick: this.context.selectable.selectAll
	      }, rest), children);
	    }
	  }]);
	
	  return SelectAllButton;
	}(_react.Component);
	
	_defineProperty(SelectAllButton, "contextType", _Context["default"]);
	
	_defineProperty(SelectAllButton, "propTypes", {
	  children: _propTypes.node,
	  component: _propTypes.node
	});
	
	_defineProperty(SelectAllButton, "defaultProps", {
	  component: 'div'
	});
	
	var _default = SelectAllButton;
	exports["default"] = _default;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = __webpack_require__(53);
	
	var _Context = _interopRequireDefault(__webpack_require__(1893));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DeselectAllButton =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DeselectAllButton, _Component);
	
	  function DeselectAllButton() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, DeselectAllButton);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DeselectAllButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "getRootRef", function (c) {
	      return _this.root = c;
	    });
	
	    return _this;
	  }
	
	  _createClass(DeselectAllButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.root.addEventListener('mousedown', function (e) {
	        return e.stopPropagation();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          rest = _objectWithoutProperties(_this$props, ["children", "className"]);
	
	      return _react["default"].createElement(this.props.component, _extends({
	        ref: this.getRootRef,
	        className: "selectable-deselect-all ".concat(className),
	        onClick: this.context.selectable.clearSelection
	      }, rest), children);
	    }
	  }]);
	
	  return DeselectAllButton;
	}(_react.Component);
	
	_defineProperty(DeselectAllButton, "contextType", _Context["default"]);
	
	_defineProperty(DeselectAllButton, "propTypes", {
	  children: _propTypes.node,
	  component: _propTypes.node
	});
	
	_defineProperty(DeselectAllButton, "defaultProps", {
	  component: 'div'
	});
	
	var _default = DeselectAllButton;
	exports["default"] = _default;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(183)(module)))

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactRouter = __webpack_require__(86);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsNode = __webpack_require__(202);
	
	var _floorplan = __webpack_require__(1885);
	
	var _floorplan2 = _interopRequireDefault(_floorplan);
	
	var _store = __webpack_require__(169);
	
	var _store2 = _interopRequireDefault(_store);
	
	var Area = (function (_React$Component) {
		_inherits(Area, _React$Component);
	
		function Area(props) {
			_classCallCheck(this, Area);
	
			_get(Object.getPrototypeOf(Area.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Area, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				this.setState({ tooltipOpen: true });
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				this.setState({ tooltipOpen: false });
			}
		}, {
			key: 'getPos',
			value: function getPos(node) {
				if (node.info.xpercent != -1 && node.info.ypercent != -1) {
					return { x: node.info.xpercent, y: node.info.ypercent };
				}
				// Mean position of all sensors
				var res = { x: 0, y: 0 };
				node.children.forEach(function (child) {
					if (child.type == "sensor") {
						res.x += child.info.xpercent;
						res.y += child.info.ypercent;
					}
				});
				res.x /= node.children.length;
				res.y /= node.children.length;
				return res;
			}
		}, {
			key: 'listSensors',
			value: function listSensors(root, res) {
				var self = this;
				if (root) {
					if (root.type == "sensor") {
						res.push(root);
					} else {
						root.children.map(function (x) {
							return self.listSensors(x, res);
						});
					}
				}
			}
		}, {
			key: 'getStatus',
			value: function getStatus(node) {
				var status = {
					inuse: 0,
					faulty: 0,
					total: node.children.length,
					registered: 0,
					standby: 0,
					displayValue: 0,
					type: "free"
				};
				var sensors = [];
				this.listSensors(node, sensors);
				var sensorMap = this.props.sensorMap;
				sensors.forEach(function (sensor) {
					var ss = sensorMap.get(sensor.id);
					if (ss) {
						status.inuse += ss.inuse;
						status.faulty += ss.faulty;
						status.registered += ss.registered;
						status.standby += ss.standby;
					}
				});
				if (status.registered > 0) {
					if (status.faulty == status.registered) {
						status.type = 'faulty';
					} else {
						if (status.inuse > 0) {
							status.type = 'inuse';
						} else if (status.standby) {
							status.type = 'standby';
						}
					}
				} else {
					status.type = 'unregistered';
				}
	
				switch (status.type) {
					case "free":
						status.displayValue = status.total;
						break;
					case "inuse":
						status.displayValue = status.inuse;
						break;
					case "standby":
						status.displayValue = status.total;
						break;
					case "faulty":
						status.displayValue = status.total;
						break;
					case "unregistered":
						status.displayValue = status.total;
				}
	
				return status;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var node = this.props.node;
				var pos = this.getPos(node);
				var status = this.getStatus(node);
	
				var style = { left: pos.x + '%', top: pos.y + '%' };
				var className = 'circle';
				className += " " + status.type;
				if (this.props.viewFilter.code == "LIVE" && (status.type == "unregistered" || status.type == "faulty")) {
					// hide broken / unregistered meeting room in live view.
					className += ' hidden';
				}
				if (this.props.viewFilter.code == "MAINTENANCE" && status.type != "unregistered" && status.type != "faulty") {
					// hide good and registered meeting room in maintenance view.
					className += ' hidden';
				}
				if (!this.props.thumbnail) {
					var tooltipPos = "top";
					if (pos.y < 50) {
						tooltipPos = "bottom";
					}
					return _react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'div',
							{ id: "area" + node.id, className: className, style: style,
								// onClick={this.onClick.bind(this)}
								onMouseEnter: function () {
									return _this.onMouseEnter();
								},
								onMouseLeave: function () {
									return _this.onMouseLeave();
								} },
							status.displayValue
						),
						_react2['default'].createElement(
							_reactPortalTooltip2['default'],
							{ active: this.state.tooltipOpen, parent: "#area" + node.id, position: tooltipPos, arrow: 'center',
								style: {
									style: {
										background: "rgba(0,0,0,.8)",
										padding: 10,
										color: "#EEE",
										boxShadow: "5px 5px 3px rgba(0,0,0,.5)",
										borderRadius: 8,
										transition: 'all .2s ease-in-out',
										zIndex: 7091
									},
									arrowStyle: {
										color: 'rgba(0,0,0,.8)',
										borderColor: false,
										transition: 'all .2s ease-in-out'
									}
								},
								tooltipTimeout: 200
							},
							_react2['default'].createElement(
								'div',
								null,
								_react2['default'].createElement(
									'div',
									{ className: 'tooltip-header' },
									node.info.name,
									_react2['default'].createElement('br', null)
								),
								node.info.useownfp && _react2['default'].createElement(
									'div',
									null,
									'This ',
									_config2['default'].textOf[node.type],
									' has its own floorplan :',
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRedux.Provider,
										{ store: _store2['default'] },
										_react2['default'].createElement(_floorplan2['default'], {
											viewFilter: this.props.viewFilter,
											root: node,
											sensorMap: this.props.sensorMap,
											showDetails: true,
											thumbnail: true
										})
									),
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: "/devicemanagement/" + node.id, target: '_blank' },
										'Detailed floorplan'
									),
									_react2['default'].createElement('br', null),
									_react2['default'].createElement(
										_reactRouter.Link,
										{ to: "/locations?n=" + node.id, target: '_blank' },
										'Edit setting'
									),
									_react2['default'].createElement('br', null)
								)
							)
						)
					);
				} else {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						_react2['default'].createElement(
							'div',
							{
								className: className, style: style,
								'data-tip': true, 'data-for': "area" + node.id,
								onMouseEnter: function () {
									return _this.onMouseEnter();
								},
								onMouseLeave: function () {
									return _this.onMouseLeave();
								}
							},
							status.displayValue
						),
						_react2['default'].createElement(
							_reactTooltip2['default'],
							{ id: "area" + node.id, place: 'top', type: 'dark', effect: 'solid' },
							node.info.name
						)
					);
				}
			}
		}, {
			key: 'setOwnFloorPlan',
			value: function setOwnFloorPlan(node, useownfp) {
				var newNode = { id: node.id, info: { useownfp: useownfp } };
				this.props.dispatch((0, _actionsNode.updateNode)(newNode));
			}
		}]);
	
		return Area;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			sensorMap: state.nodeReducer.map
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Area.propTypes = {
		viewFilter: _propTypes2['default'].object.isRequired,
		node: _propTypes2['default'].object.isRequired,
		thumbnail: _propTypes2['default'].bool.isRequired,
		sensorMap: _propTypes2['default'].object.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Area);
	module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsDevicemanagement = __webpack_require__(350);
	
	var a = _interopRequireWildcard(_actionsDevicemanagement);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var DeviceSetting = (function (_Component) {
	    _inherits(DeviceSetting, _Component);
	
	    function DeviceSetting(props, context) {
	        _classCallCheck(this, DeviceSetting);
	
	        _get(Object.getPrototypeOf(DeviceSetting.prototype), 'constructor', this).call(this, props, context);
	        this.state = {};
	    }
	
	    _createClass(DeviceSetting, [{
	        key: 'submit',
	        value: function submit(event) {
	            var _this = this;
	
	            if (event) {
	                event.preventDefault();
	            }
	            var ncKey = this.getNewConfigKey();
	
	            var cntDone = 0;
	            var cntTotal = this.props.selectedSensors.length;
	
	            var fClose = function fClose() {
	                // this function is called everytime an update request is done.
	                // it updates the counter and refresh data after counter reach 100%.
	                cntDone += 1;
	                _toastr2['default'].success(cntDone + "/" + cntTotal + " updates have been sent.");
	                if (cntDone == cntTotal) {
	                    // 100%
	                    // Clear the form
	                    _this.setState(_defineProperty({}, ncKey, {}));
	                    // Refresh data
	                    _this.props.dispatch(a.fetchConfig()).then(function () {
	                        _toastr2['default'].success("Update is completed.");
	                    });
	                }
	            };
	
	            // run dispatch(a.updateConfig(...)) in parallel.
	            this.props.selectedSensors.forEach(function (ss) {
	                _this.props.dispatch(a.updateConfig(ss.sensorMac, _this.state[_this.getNewConfigKey()], fClose));
	            });
	        }
	    }, {
	        key: 'changeHandler',
	        value: function changeHandler(event) {
	            var parameter = event.target.name;
	            var value = event.target.value;
	            var tmp = _extends({}, this.state[this.getNewConfigKey()] || {});
	
	            if (value == "") {
	                delete tmp[parameter];
	            } else {
	                if (event.target.type == "number") {
	                    value = parseInt(value);
	                }
	                tmp[parameter] = value;
	            }
	
	            this.setState(_defineProperty({}, this.getNewConfigKey(), tmp));
	        }
	    }, {
	        key: 'getNewConfigKey',
	        value: function getNewConfigKey() {
	            var res = "";
	            this.props.selectedSensors.forEach(function (ss) {
	                return res += ss.sensorId + ":" + ss.sensorMac + ";";
	            });
	            return res;
	        }
	    }, {
	        key: 'renderParameters',
	        value: function renderParameters() {
	            var _this2 = this;
	
	            // Get MAC address list.
	            var macs = [];
	            this.props.selectedSensors.forEach(function (ss) {
	                macs.push(ss.sensorMac);
	            });
	
	            // Get the list of parameter names of all sensors.
	            var parameters = [];
	            macs.forEach(function (mac) {
	                var sensorConfig = _this2.props.configMap[mac];
	                if (sensorConfig.currentConfig) {
	                    parameters = parameters.concat(Object.keys(sensorConfig.currentConfig));
	                }
	                if (sensorConfig.pendingConfig) {
	                    parameters = parameters.concat(Object.keys(sensorConfig.pendingConfig));
	                }
	            });
	            parameters = parameters.filter(function (item, pos) {
	                return parameters.indexOf(item) == pos;
	            });
	            parameters.sort();
	            console.log(parameters);
	
	            var newConfig = this.state[this.getNewConfigKey()] || {};
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                parameters.map(function (parameter) {
	                    var readValues = {};
	                    var sentValues = {};
	                    var valueTypes = {};
	                    var readHasEmpty = false;
	                    var sentHasEmpty = false;
	
	                    macs.forEach(function (mac) {
	                        var sensorConfig = _this2.props.configMap[mac];
	                        // add sent value to map
	
	                        if (sensorConfig.currentConfig) {
	                            if (sensorConfig.currentConfig.hasOwnProperty(parameter)) {
	                                readValues[sensorConfig.currentConfig[parameter]] = true;
	                            } else {
	                                readHasEmpty = true;
	                            }
	                        }
	                        // add sent value to map
	                        if (sensorConfig.pendingConfig) {
	                            if (sensorConfig.pendingConfig.hasOwnProperty(parameter)) {
	                                sentValues[sensorConfig.pendingConfig[parameter]] = true;
	                            } else {
	                                sentHasEmpty = true;
	                            }
	                        }
	                        if (sensorConfig.currentConfig !== null) {
	                            // add the type to map
	                            valueTypes[typeof sensorConfig.currentConfig[parameter]] = true;
	                        }
	                    });
	
	                    // Get array of distinct read values.
	                    readValues = Object.keys(readValues);
	                    /* console.log("readValues", readValues)
	                     console.log("sentValues", sentValues)
	                     console.log("sentValuessentValues", readValues === sentValues)*/
	                    // Get array of distinct sent values.
	                    sentValues = Object.keys(sentValues);
	
	                    // Get array of distince value types
	                    valueTypes = Object.keys(valueTypes);
	
	                    if (readHasEmpty && readValues.length > 0) {
	                        readValues.push(undefined);
	                    }
	                    if (sentHasEmpty && sentValues.length > 0) {
	                        sentValues.push(undefined);
	                    }
	
	                    // Calculate input type
	                    var inputType = "null";
	                    if (valueTypes.length == 0) {
	                        inputType = "empty";
	                    } else if (valueTypes.length == 1) {
	                        switch (valueTypes[0]) {
	                            case "string":
	                                inputType = "text";
	                                break;
	                            case "number":
	                                inputType = "number";
	                                break;
	                            default:
	                        }
	                    } else if (valueTypes.length > 1) {
	                        inputType = "several";
	                    }
	
	                    return _react2['default'].createElement(
	                        'tr',
	                        { key: parameter },
	                        _react2['default'].createElement(
	                            'td',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    parameter
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'td',
	                            null,
	                            readValues.length == 1 ? _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    readValues[0]
	                                )
	                            ) : readValues.length > 1 ? _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    '(Several values)'
	                                )
	                            ) : null
	                        ),
	                        _react2['default'].createElement(
	                            'td',
	                            null,
	                            sentValues.length == 1 ? _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                sentValues[0]
	                            ) : sentValues.length > 1 ? _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    '(Several values)'
	                                )
	                            ) : null
	                        ),
	                        _react2['default'].createElement(
	                            'td',
	                            null,
	                            inputType == "empty" ? null : inputType == "several" ? _react2['default'].createElement(
	                                'div',
	                                { className: 'parameter disabled' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    null,
	                                    '(Several value types)'
	                                )
	                            ) : _react2['default'].createElement('input', { type: inputType,
	                                name: parameter,
	                                value: newConfig[parameter] || "",
	                                onChange: _this2.changeHandler.bind(_this2)
	                            })
	                        )
	                    );
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var buttonDisabled = Object.keys(this.state[this.getNewConfigKey()] || {}).length == 0;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'popup-device-management bg--white ' + (this.props.isClicked ? "" : "popup-device-management_active bg--green") },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h3',
	                        { className: 'font--bold' },
	                        'DEVICE SETTINGS'
	                    ),
	                    this.props.selectedSensors.length > 0 ? _react2['default'].createElement(
	                        'form',
	                        { className: 'device-management-form' },
	                        _react2['default'].createElement(
	                            'table',
	                            null,
	                            _react2['default'].createElement(
	                                'tbody',
	                                null,
	                                _react2['default'].createElement(
	                                    'tr',
	                                    { className: 'header-tr' },
	                                    _react2['default'].createElement(
	                                        'th',
	                                        null,
	                                        'Parameter'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'th',
	                                        null,
	                                        'Read value'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'th',
	                                        null,
	                                        'Sent Value'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'th',
	                                        null,
	                                        'New Value'
	                                    )
	                                ),
	                                this.renderParameters()
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'dev-manage-btn btn btn-success', type: 'button', onClick: this.submit.bind(this), disabled: buttonDisabled },
	                            'Apply'
	                        )
	                    ) : _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Click on the sensor to edit'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeviceSetting;
	})(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        configMap: state.devManReducer.configMap
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeviceSetting);
	module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _userlist = __webpack_require__(1901);
	
	var _userlist2 = _interopRequireDefault(_userlist);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _inviteModalContent = __webpack_require__(1902);
	
	var _inviteModalContent2 = _interopRequireDefault(_inviteModalContent);
	
	var _editModalContent = __webpack_require__(1903);
	
	var _editModalContent2 = _interopRequireDefault(_editModalContent);
	
	var _componentsCommonDropdowncomponentsNodedropdown = __webpack_require__(1304);
	
	var _componentsCommonDropdowncomponentsNodedropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsNodedropdown);
	
	var _componentsCommonDropdowncomponentsListdropdown = __webpack_require__(1305);
	
	var _componentsCommonDropdowncomponentsListdropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsListdropdown);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var _actionsUser = __webpack_require__(356);
	
	var User = (function (_React$Component) {
		_inherits(User, _React$Component);
	
		function User(props, context) {
			_classCallCheck(this, User);
	
			_get(Object.getPrototypeOf(User.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				AAOpen: false, // add account modal open ?
				AArespond: "",
				AArespondClass: "",
				DAOpen: false, // delete account modal open ?
				DArespond: "",
				DArespondClass: "",
				EAOpen: false, // edit account modal open ?
				EArespond: "",
				EArespondClass: "",
	
				interval: {}
			};
		}
	
		_createClass(User, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.props.dispatch((0, _actionsUser.listContact)());
				var itv = setInterval(this.props.dispatch, 3000, (0, _actionsUser.listContact)());
				this.setState({ interval: itv });
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.state.interval);
			}
		}, {
			key: 'AAOpen',
			value: function AAOpen() {
				this.props.dispatch((0, _actionsUser.resetInviteStatus)());
				this.openInviteModal.open();
				this.setState({ AAOpen: true });
			}
		}, {
			key: 'AAClose',
			value: function AAClose() {
				this.props.dispatch((0, _actionsUser.resetInviteStatus)());
				this.setState({ AAOpen: false });
			}
		}, {
			key: 'DAOpen',
			value: function DAOpen() {
				this.setState({ DAOpen: true });
			}
		}, {
			key: 'DAClose',
			value: function DAClose() {
				this.props.dispatch((0, _actionsUser.selectUser)({}));
				this.setState({ DAOpen: false });
			}
		}, {
			key: 'EAOpen',
			value: function EAOpen() {
				this.setState({ EAOpen: true });
				this.openEditModal.open();
			}
		}, {
			key: 'EAClose',
			value: function EAClose() {
				this.props.dispatch((0, _actionsUser.selectUser)({}));
				this.setState({ EAOpen: false });
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// Init nodeFilter
				if (this.props.nodeFilter.id == -2 && nextProps.tree.id != -2) {
					this.props.dispatch((0, _actionsUser.useradSelectNode)(nextProps.tree));
				}
				// Inviting stages
				switch (nextProps.AAstage) {
					case "inviting":
						this.setState({
							AArespond: "Sending...",
							AArespondClass: "text-loading"
						});
						if (nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.needContact)());
						}
						break;
					case "invited":
						if (!nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.listContact)());
						}
						this.setState({
							AArespond: "Invitation email sent.",
							AArespondClass: "text-green"
						});
						break;
					case "invite-failed":
						this.setState({
							AArespond: "Provided information is invalid.",
							AArespondClass: "text-red"
						});
						break;
					default:
						// "nothing"
						this.setState({
							AArespond: "",
							AArespondClass: ""
						});
						break;
				}
				// Editing stages
				switch (nextProps.EAstage) {
					case "editing":
						this.setState({
							EArespond: "Editing...",
							EArespondClass: "text-loading"
						});
						if (nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.needContact)());
						}
						break;
					case "edited":
						this.setState({
							EArespond: "User edited.",
							EArespondClass: "text-green"
						});
						if (!nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.listContact)());
						}
						break;
					case "edit-failed":
						this.setState({
							EArespond: "Failed to edit this user !",
							EArespondClass: "text-red"
						});
						break;
					default:
						// "nothing"
						this.setState({
							EArespond: "",
							EArespondClass: ""
						});
				}
				// Deleting stages
				switch (nextProps.DAstage) {
					case "deleting":
						if (nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.needContact)());
						}
						break;
					case "deleted":
						if (!nextProps.contactFetched) {
							nextProps.dispatch((0, _actionsUser.listContact)());
						}
						this.DAClose();
						break;
					default: // nothing
				}
			}
		}, {
			key: 'listNodes',
			value: function listNodes(root, depth, res) {
				var self = this;
				if (root && root.type != "sensor") {
					res.push({
						node: root,
						padding: '  '.repeat(depth)
					});
					root.children.forEach(function (child) {
						self.listNodes(child, depth + 1, res);
					});
				}
			}
		}, {
			key: 'listNodeFilter',
			value: function listNodeFilter(root, res) {
				var self = this;
				if (root) {
					if (root.type != "sensor") {
						res.push(root);
						root.children.forEach(function (child) {
							self.listNodeFilter(child, res);
						});
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var nodes = [];
				this.listNodes(this.props.nodeMap[this.props.me.rootnodeid], 0, nodes);
				return _react2['default'].createElement(
					'div',
					{ className: 'user-administration-page overwrite--modal--depth' },
					_react2['default'].createElement(
						_componentsCommonStickymenu2['default'],
						{
							withStickyHeader: false
						},
						_react2['default'].createElement(_componentsCommonMainmenu2['default'], {
							overviewIsActive: false,
							comparisonIsActive: false,
							onlyLeftMenu: true
						}),
						_react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
							leftItemBold: this.props.me.role == "ADMIN" ? "User Administration" : "Contact",
							leftItems: _react2['default'].createElement(
								_react2['default'].Fragment,
								null,
								this.props.me.role == "ADMIN" && [_react2['default'].createElement(
									'span',
									{ key: '0', className: 'stats-menu__list-item ' },
									_react2['default'].createElement(
										'div',
										{ key: '0', className: 'stats-menu-btn cursor--pointer', onClick: this.AAOpen.bind(this) },
										_react2['default'].createElement(
											'span',
											{ className: 'display--flex__flex--center cursor--pointer' },
											_react2['default'].createElement('span', { style: { fontSize: 27, marginRight: 8 }, className: 'font-icon icon-addicon' }),
											'Add Account'
										)
									)
								), _react2['default'].createElement(
									'span',
									{ key: '1', className: 'stats-menu__select stats-menu__list-item ' },
									_react2['default'].createElement(_componentsCommonDropdowncomponentsNodedropdown2['default'], {
										key: '1',
										outsideClass: 'dropdown-btn settings-dropdown pull-left',
										root: this.props.tree,
										nodeFilter: this.props.nodeFilter,
										click: function (node) {
											_this.props.dispatch((0, _actionsUser.useradSelectNode)(node));
										},
										list: this.listNodeFilter.bind(this),
										header: 'All locations'
									})
								), _react2['default'].createElement(
									'span',
									{ key: '2', className: 'stats-menu__select stats-menu__list-item ' },
									_react2['default'].createElement(_componentsCommonDropdowncomponentsListdropdown2['default'], {
										key: '2',
										outsideClass: 'dropdown-btn settings-dropdown pull-left',
										items: _config2['default'].userTypeFilter,
										getText: function (x) {
											return x.text;
										},
										selected: this.props.userTypeFilter,
										click: function (code) {
											_this.props.dispatch((0, _actionsUser.useradSelectType)(code));
										}
									})
								)]
							)
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: 'page-content page-content_padding-modifier' },
						_react2['default'].createElement(
							'div',
							{ className: 'display--flex__flex--start--center ' },
							_react2['default'].createElement(_userlist2['default'], {
								contact: this.props.contact,
								openEditModal: this.EAOpen.bind(this),
								nodeFilter: this.props.nodeFilter,
								userTypeFilter: this.props.userTypeFilter,
								tree: this.props.tree
							}),
							_react2['default'].createElement(
								_componentsCommonModal2['default'],
								{
									onClose: this.AAClose.bind(this),
									ref: function (elem) {
										_this.openInviteModal = elem;
									},
									clickButton: function () {
										_this.invite.sendInvitation();
									},
									header: 'Add Account',
									buttonText: 'Send Invitation',
									buttonClass: 'btn-success'
								},
								_react2['default'].createElement(_inviteModalContent2['default'], {
									open: this.state.AAOpen,
									onRef: function (ref) {
										return _this.invite = ref;
									},
									nodes: nodes,
									respond: this.state.AArespond,
									respondClass: this.state.AArespondClass
								})
							),
							_react2['default'].createElement(
								_componentsCommonModal2['default'],
								{
									onClose: this.EAClose.bind(this),
									ref: function (elem) {
										_this.openEditModal = elem;
									},
									clickButton: function () {
										_this.edit.editUser();
									},
									header: 'Edit Account',
									buttonText: 'Save',
									buttonClass: 'btn-success'
								},
								_react2['default'].createElement(_editModalContent2['default'], {
									onRef: function (ref) {
										return _this.edit = ref;
									},
									onOpen: this.state.EAOpen,
									user: this.props.selectedUser,
									contact: this.props.contact,
									nodes: nodes,
									respond: this.state.EArespond,
									respondClass: this.state.EArespondClass
								})
							)
						)
					)
				);
			}
		}]);
	
		return User;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			tree: state.overviewReducer.customerOverview,
			nodeMap: state.overviewReducer.nodeMap,
			me: state.myAccountReducer.user,
	
			AAstage: state.userInviteReducer.stage,
			AArespond: state.userInviteReducer.respond,
	
			EAstage: state.userAdminReducer.EAstage,
			EArespond: state.userAdminReducer.EArespond,
	
			selectedUser: state.userAdminReducer.selectedUser,
			contact: state.userAdminReducer.contact,
			contactFetched: state.userAdminReducer.contactFetched,
			nodeFilter: state.userAdminReducer.nodeFilter,
			userTypeFilter: state.userAdminReducer.userTypeFilter
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(User);
	module.exports = exports['default'];

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsUser = __webpack_require__(356);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var UserList = (function (_React$Component) {
		_inherits(UserList, _React$Component);
	
		function UserList(props, context) {
			_classCallCheck(this, UserList);
	
			_get(Object.getPrototypeOf(UserList.prototype), 'constructor', this).call(this, props, context);
		}
	
		_createClass(UserList, [{
			key: 'openEdit',
			value: function openEdit(user) {
				this.props.dispatch((0, _actionsUser.selectUser)(user));
				this.props.openEditModal();
			}
		}, {
			key: 'isDescendant',
			value: function isDescendant(root, id) {
				var node = this.props.nodeMap[id];
				if (!node) {
					return false;
				}
				while (node.id != root.id) {
					node = node.parent;
					if (!node) {
						return false;
					}
				}
				return true;
			}
		}, {
			key: 'correctType',
			value: function correctType(u, userTypeFilter) {
				var nodeMap = this.props.nodeMap;
				switch (userTypeFilter.code) {
					case "ALL":
						return true;
					case "CADMIN":
						return u.role == _config2['default'].roles[0].rolecode && nodeMap[u.rootnodeid].type == _config2['default'].nodeType.customer.code;
					case "LADMIN":
						return u.role == _config2['default'].roles[1].rolecode && nodeMap[u.rootnodeid].type != _config2['default'].nodeType.customer.code;
					case "LUSER":
						return u.role == _config2['default'].roles[2].rolecode;
					case "SUSER":
						return u.role == _config2['default'].roles[3].rolecode;
				}
			}
		}, {
			key: 'clickDeleteButton',
			value: function clickDeleteButton(user) {
				this.props.dispatch((0, _actionsUser.deleteUser)(user));
			}
		}, {
			key: 'renderUser',
			value: function renderUser(u, nodeNames) {
				var _this = this;
	
				var ok = this.props.nodeFilter == this.props.tree || this.isDescendant(this.props.nodeFilter, u.rootnodeid);
				ok = ok && this.correctType(u, this.props.userTypeFilter);
				if (!ok) {
					return null;
				}
				return _react2['default'].createElement(
					'tr',
					{ key: u.username, className: u.username == this.props.me.username ? "font--bold" : "" },
					_react2['default'].createElement(
						'td',
						{ className: 'tab-left' },
						' ',
						_react2['default'].createElement(
							'span',
							{ className: u.registered ? "active-user" : "pending-user" },
							u.title + " " + u.firstname + " " + u.lastname
						)
					),
					_react2['default'].createElement(
						'td',
						null,
						' ',
						_react2['default'].createElement(
							'a',
							{ className: 'table-email', href: "mailto:" + u.email },
							u.email
						)
					),
					_react2['default'].createElement(
						'td',
						null,
						u.phone
					),
					_react2['default'].createElement(
						'td',
						null,
						nodeNames[String(u.rootnodeid)]
					),
					u.canmodify && u.username != this.props.me.username ? [_react2['default'].createElement(
						'td',
						{ key: '0' },
						_react2['default'].createElement(
							'i',
							{ 'data-tooltip': 'Edit', className: 'material-icons cursor--pointer material-icons_size edit--icons', onClick: function () {
									return _this.openEdit(u);
								} },
							'edit'
						)
					), _react2['default'].createElement(
						'td',
						{ key: '1' },
						_react2['default'].createElement(
							_componentsCommonModal2['default'],
							{
								clickButton: this.clickDeleteButton.bind(this, u),
								header: 'Delete User',
								buttonText: 'Delete',
								buttonClass: 'btn-danger',
								entry: _react2['default'].createElement(
									'i',
									{ 'data-tooltip': 'Delete', className: 'material-icons material-icons_size red-500  cursor--pointer delete--icons' },
									'delete_forever'
								)
							},
							_react2['default'].createElement(
								'p',
								null,
								'Are you sure you want to delete this user account and all related information ?'
							)
						)
					)] : [_react2['default'].createElement('td', { key: '0' }), _react2['default'].createElement('td', { key: '1' })]
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var userRows = [[this.props.contact.companyadmins, "COMPANY ADMINISTRATORS"], [this.props.contact.localadmins, "LOCAL ADMINISTRATORS"], [this.props.contact.localusers, "LOCAL USERS"], [this.props.contact.supportusers, "SUPPORT"]];
				var nodeNames = this.props.contact.nodenames;
				var ok = true;
				userRows.map(function (row) {
					if (!row[0]) {
						ok = false;
					}
				});
				var tableId = 0;
				return ok && nodeNames && _react2['default'].createElement(
					'div',
					{ className: 'users--section' },
					_react2['default'].createElement(
						'div',
						{ className: 'white-box-container box--shadow bg--white' },
						_react2['default'].createElement(
							'table',
							{ className: 'flat-table user-table' },
							_react2['default'].createElement(
								'tbody',
								null,
								userRows.map(function (urow) {
									tableId = tableId + 1;
									return [_react2['default'].createElement(
										'tr',
										{ key: '#table-header-row ' + tableId, className: 'table-header-row' },
										_react2['default'].createElement(
											'th',
											null,
											_react2['default'].createElement(
												'h4',
												null,
												urow[1]
											)
										),
										_react2['default'].createElement(
											'th',
											null,
											'EMAIL'
										),
										_react2['default'].createElement(
											'th',
											null,
											'MOBILE'
										),
										_react2['default'].createElement(
											'th',
											null,
											'LOCATION'
										),
										_react2['default'].createElement('th', { colSpan: '2' })
									), urow[0].map(function (u) {
										return _this2.renderUser(u, nodeNames);
									}), _react2['default'].createElement('tr', { key: '#table-spacing ' + tableId, className: 'table-spacing' })];
								})
							)
						)
					),
					_react2['default'].createElement(
						'table',
						{ className: 'popup-color-note' },
						_react2['default'].createElement(
							'tbody',
							null,
							_react2['default'].createElement(
								'tr',
								null,
								_react2['default'].createElement(
									'td',
									null,
									_react2['default'].createElement(
										'span',
										{ className: 'popup-color-note-td green' },
										'Registered'
									)
								)
							),
							_react2['default'].createElement(
								'tr',
								null,
								_react2['default'].createElement(
									'td',
									null,
									_react2['default'].createElement(
										'span',
										{ className: 'popup-color-note-td brown' },
										'Pending'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return UserList;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	function mapStateToProps(state) {
		return {
			me: state.myAccountReducer.user,
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserList);
	module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsUser = __webpack_require__(356);
	
	var InviteModalContent = (function (_React$Component) {
	    _inherits(InviteModalContent, _React$Component);
	
	    function InviteModalContent(props, context) {
	        _classCallCheck(this, InviteModalContent);
	
	        _get(Object.getPrototypeOf(InviteModalContent.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            loaded: false,
	            role: _config2['default'].roles[0].code,
	            location: {
	                node: {
	                    id: -2
	                }
	            }
	        };
	    }
	
	    _createClass(InviteModalContent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.onRef(this);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.onRef(undefined);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var hasCompany = this.props.nodes.length && this.props.nodes[0].node.type == _config2['default'].nodeType.customer.code;
	
	            if (this.props.open != nextProps.open) {
	                this.setState({
	                    role: _config2['default'].roles[hasCompany ? 0 : 1].code,
	                    loaded: true
	                });
	            }
	            if (!this.state.loaded && nextProps.nodes.length) {
	                this.setState({
	                    location: nextProps.nodes[0]
	                });
	            }
	        }
	    }, {
	        key: 'sendInvitation',
	        value: function sendInvitation() {
	            var _this = this;
	
	            var inv = {
	                rootnodeid: this.state.location.node.id,
	                companyid: this.state.location.node.id,
	                email: this.refs.email.value,
	                role: this.refs.role.value.substring(1)
	            };
	            var resetFunc = function resetFunc() {
	                _this.refs.email.value = "";
	            };
	            this.props.dispatch((0, _actionsUser.inviteUser)(inv, resetFunc, null));
	        }
	    }, {
	        key: 'findCustomerNode',
	        value: function findCustomerNode(nodes) {
	            var res = null;
	            nodes.map(function (x) {
	                if (x.node.type == _config2['default'].nodeType.customer.code) {
	                    res = x;
	                }
	            });
	            return res;
	        }
	    }, {
	        key: 'findNotCustomerNode',
	        value: function findNotCustomerNode(nodes) {
	            var res = null;
	            for (var i = 0; i < nodes.length; i++) {
	                if (nodes[i].node.type != _config2['default'].nodeType.customer.code) {
	                    return nodes[i];
	                }
	            }
	            return res;
	        }
	    }, {
	        key: 'PairOk',
	        value: function PairOk(roleCode, location) {
	            switch (roleCode) {
	                case _config2['default'].roles[0].code:
	                    // Company admin
	                    return location.type == _config2['default'].nodeType.customer.code;
	                case _config2['default'].roles[1].code:
	                    // Local admin
	                    return location.type != _config2['default'].nodeType.customer.code;
	                default:
	                    return true;
	            }
	        }
	    }, {
	        key: 'changeRole',
	        value: function changeRole(e) {
	            var loc = {};
	            switch (e.target.value) {
	                case _config2['default'].roles[0].code:
	                    loc = this.findCustomerNode(this.props.nodes);
	                    break;
	                case _config2['default'].roles[1].code:
	                    loc = this.findNotCustomerNode(this.props.nodes);
	                    break;
	                case _config2['default'].roles[2].code:
	                case _config2['default'].roles[3].code:
	                default:
	                    loc = this.state.location;
	                    break;
	            }
	            this.setState({
	                role: e.target.value,
	                location: loc
	            });
	        }
	    }, {
	        key: 'changeLocation',
	        value: function changeLocation(e) {
	            this.setState({ location: this.props.nodes[e.target.value] });
	        }
	    }, {
	        key: 'findNode',
	        value: function findNode() {
	            var _this2 = this;
	
	            var idx = 0;
	            this.props.nodes.map(function (x, i) {
	                if (x.node.id == _this2.state.location.node.id) {
	                    idx = i;
	                }
	            });
	            return idx;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var hasCompany = this.findCustomerNode(this.props.nodes) != null;
	            var hasNonCompany = this.findNotCustomerNode(this.props.nodes) != null;
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    'Add New'
	                ),
	                _react2['default'].createElement(
	                    'select',
	                    { required: true, ref: 'role', onChange: this.changeRole.bind(this), value: this.state.role },
	                    _config2['default'].roles.map(function (role, i) {
	                        if (!hasCompany && i == 0) {
	                            return null;
	                        }
	                        if (!hasNonCompany && i == 1) {
	                            return null;
	                        }
	                        return _react2['default'].createElement(
	                            'option',
	                            { value: role.code, key: role.text },
	                            ' ',
	                            role.text,
	                            ' '
	                        );
	                    })
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    'Location'
	                ),
	                _react2['default'].createElement(
	                    'select',
	                    { required: true, ref: 'location', value: this.findNode(), onChange: this.changeLocation.bind(this) },
	                    this.props.nodes.map(function (x, i) {
	                        if (x.node.type != "location" && x.node.type != "customer") {
	                            return null;
	                        }
	                        return _react2['default'].createElement(
	                            'option',
	                            { value: i, key: "o" + x.node.id, disabled: !_this3.PairOk(_this3.state.role, x.node) },
	                            x.padding,
	                            x.node.info.name
	                        );
	                    })
	                ),
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    'Email'
	                ),
	                _react2['default'].createElement('input', { type: 'email', placeholder: 'new@user.com', ref: 'email' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: this.props.respondClass },
	                    this.props.respond
	                )
	            );
	        }
	    }]);
	
	    return InviteModalContent;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(InviteModalContent);
	module.exports = exports['default'];

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsUser = __webpack_require__(356);
	
	var EditModalContent = (function (_React$Component) {
		_inherits(EditModalContent, _React$Component);
	
		function EditModalContent(props, context) {
			_classCallCheck(this, EditModalContent);
	
			_get(Object.getPrototypeOf(EditModalContent.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				loaded: false,
				role: _config2['default'].roles[0].code,
				location: {
					node: {
						id: -2
					}
				},
				disabled: true
			};
		}
	
		_createClass(EditModalContent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.onRef(this);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.onRef(undefined);
			}
		}, {
			key: 'editUser',
			value: function editUser() {
				var info = {
					username: this.props.user.username,
					rootnodeid: this.state.location.node.id,
					companyid: this.state.location.node.id,
					role: this.refs.role.value.substring(1)
				};
				this.props.dispatch((0, _actionsUser.editUser)(info));
			}
		}, {
			key: 'findRole',
			value: function findRole(u) {
				// Company admin
				var res = "";
				var allUsers = [this.props.contact.companyadmins, this.props.contact.localadmins, this.props.contact.localusers, this.props.contact.supportusers];
				allUsers.map(function (userlist, i) {
					userlist.map(function (user) {
						if (u.username == user.username) {
							res = _config2['default'].roles[i].code;
						}
					});
				});
				return res;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var hasCompany = nextProps.nodes.length > 0;
				nextProps.nodes.map(function (x) {
					if (x.node.type == _config2['default'].nodeType.customer.code) {
						hasCompany = true;
					}
				});
				this.setState({ hasCompany: hasCompany });
				if (this.props.onOpen !== nextProps.onOpen) {
					var role = this.findRole(nextProps.user);
					this.setState({
						role: this.findRole(nextProps.user),
						location: nextProps.nodes[this.findNode(nextProps.user.rootnodeid)],
						loaded: true,
						disabled: role == _config2['default'].roles[0].code
					});
				}
			}
		}, {
			key: 'findCustomerNode',
			value: function findCustomerNode(nodes) {
				var res = {};
				nodes.map(function (x) {
					if (x.node.type == _config2['default'].nodeType.customer.code) {
						res = x;
					}
				});
				return res;
			}
		}, {
			key: 'findNotCustomerNode',
			value: function findNotCustomerNode(nodes) {
				var res = null;
				for (var i = 0; i < nodes.length; i++) {
					if (nodes[i].node.type != _config2['default'].nodeType.customer.code) {
						return nodes[i];
					}
				}
				return res;
			}
		}, {
			key: 'PairOk',
			value: function PairOk(roleCode, location) {
				switch (roleCode) {
					case _config2['default'].roles[0].code:
						// Company admin
						return location.type == _config2['default'].nodeType.customer.code;
					case _config2['default'].roles[1].code:
						// Local admin
						return location.type != _config2['default'].nodeType.customer.code;
					default:
						return true;
				}
			}
		}, {
			key: 'changeRole',
			value: function changeRole(e) {
				if (e.target.value == _config2['default'].roles[0].code) {
					this.setState({
						role: e.target.value,
						location: this.findCustomerNode(this.props.nodes),
						disabled: true
					});
				} else {
					var loc = this.state.location;
					if (loc.node.type == _config2['default'].nodeType.customer.code) {
						loc = this.findNotCustomerNode(this.props.nodes);
					}
					this.setState({
						role: e.target.value,
						location: loc,
						disabled: false
					});
				}
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(e) {
				this.setState({ location: this.props.nodes[e.target.value] });
			}
		}, {
			key: 'findNode',
			value: function findNode(id) {
				var idx = 0;
				this.props.nodes.map(function (x, i) {
					if (x.node.id == id) {
						idx = i;
					}
				});
				return idx;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement(
						'label',
						null,
						'Change Role'
					),
					_react2['default'].createElement(
						'select',
						{ required: true, ref: 'role', onChange: this.changeRole.bind(this), value: this.state.role },
						_config2['default'].roles.map(function (role, i) {
							if (!_this.state.hasCompany && i == 0) {
								return null;
							}
							return _react2['default'].createElement(
								'option',
								{ value: role.code, key: role.text },
								' ',
								role.text,
								' '
							);
						})
					),
					_react2['default'].createElement(
						'label',
						null,
						'Change Location'
					),
					_react2['default'].createElement(
						'select',
						{ required: true, ref: 'location',
							disabled: this.state.disabled,
							value: this.findNode(this.state.location.node.id),
							onChange: this.changeLocation.bind(this)
						},
						this.props.nodes.map(function (x, i) {
							if (x.node.type != "location" && x.node.type != "customer") {
								return null;
							}
							return _react2['default'].createElement(
								'option',
								{ value: i, key: "o" + x.node.id, disabled: !_this.PairOk(_this.state.role, x.node) },
								x.padding,
								x.node.info.name
							);
						})
					),
					_react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'span',
							{ className: this.props.respondClass },
							this.props.respond
						)
					)
				);
			}
		}]);
	
		return EditModalContent;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditModalContent);
	module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsURLfinalizer = __webpack_require__(168);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _FAQText = __webpack_require__(1905);
	
	var _FAQText2 = _interopRequireDefault(_FAQText);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var FAQ = (function (_React$Component) {
		_inherits(FAQ, _React$Component);
	
		function FAQ(props, context) {
			_classCallCheck(this, FAQ);
	
			_get(Object.getPrototypeOf(FAQ.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				subject: "",
				body: "",
				subjectError: false,
				bodyError: false
			};
		}
	
		_createClass(FAQ, [{
			key: 'submit',
			value: function submit() {
				var ok1 = this.state.subject.length > 0;
				var ok2 = this.state.body.length > 0;
				if (ok1 && ok2) {
					var form = {
						subject: this.state.subject,
						body: this.state.body
					};
					_toastr2['default'].info("Sending...");
					_axios2['default'].post((0, _actionsURLfinalizer.finalize)(_config2['default'].api.root + '/help'), form).then(function (response) {
						_toastr2['default'].remove();
						_toastr2['default'].success("Submit successfully !");
					})['catch'](function (error) {
						_toastr2['default'].remove();
						_toastr2['default'].success("Submit failed !");
					});
				}
				this.setState({
					subjectError: !ok1,
					bodyError: !ok2
				});
			}
		}, {
			key: 'onChange',
			value: function onChange(key, e) {
				var st = {};
				st[key] = e.target.value;
				this.setState(st);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					'div',
					{ className: 'faq-page' },
					_react2['default'].createElement(
						_componentsCommonStickymenu2['default'],
						{
							withStickyHeader: false
						},
						_react2['default'].createElement(_componentsCommonMainmenu2['default'], {
							overviewIsActive: false,
							comparisonIsActive: false,
							onlyLeftMenu: true
						}),
						_react2['default'].createElement(_componentsCommonStatsmenu2['default'], { leftItemBold: 'FAQ' })
					),
					_react2['default'].createElement(
						'div',
						{ className: 'page-content page-content_padding-modifier' },
						_react2['default'].createElement(
							'div',
							{ className: 'clearfix' },
							_react2['default'].createElement(
								'div',
								{ className: 'col-lg-8 no--padding' },
								_react2['default'].createElement(
									'div',
									{ className: 'faq-table box--shadow bg--white' },
									_react2['default'].createElement(
										'div',
										{ className: 'faq-header' },
										_react2['default'].createElement(
											'p',
											null,
											'Frequently asked questions'
										)
									),
									_react2['default'].createElement(
										'table',
										null,
										_react2['default'].createElement(
											'tbody',
											null,
											_FAQText2['default'].map(function (item) {
												return _react2['default'].createElement(
													'tr',
													{ key: item.id },
													_react2['default'].createElement(
														'td',
														null,
														item.question
													),
													_react2['default'].createElement(
														'td',
														{ style: { whiteSpace: 'pre-wrap' } },
														item.answer
													)
												);
											})
										)
									)
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'col-lg-4 no--padding' },
								_react2['default'].createElement(
									'div',
									{ className: 'feedback--container' },
									_react2['default'].createElement(
										'div',
										{ className: 'feedback--container--padding bg--white box--shadow' },
										_react2['default'].createElement(
											'h4',
											null,
											'Contact SenzoLive'
										),
										_react2['default'].createElement(
											'p',
											null,
											'Please send your message to SenzoLive\'s support team.'
										),
										_react2['default'].createElement(
											'form',
											{ className: 'feedback ' },
											_react2['default'].createElement(
												'div',
												{ className: 'feedback-subject' },
												_react2['default'].createElement(
													'label',
													null,
													'Subject',
													_react2['default'].createElement(
														'span',
														{ className: 'required' },
														'*'
													)
												),
												_react2['default'].createElement('input', {
													type: 'text',
													value: this.state.subject,
													className: this.state.subjectError ? "has-error" : "",
													onChange: function (e) {
														return _this.onChange("subject", e);
													}
												})
											),
											_react2['default'].createElement(
												'div',
												{ className: 'feedback-message' },
												_react2['default'].createElement(
													'label',
													null,
													'Message',
													_react2['default'].createElement(
														'span',
														{ className: 'required' },
														'*'
													)
												),
												_react2['default'].createElement('textarea', {
													rows: '4',
													value: this.state.body,
													className: this.state.bodyError ? "has-error" : "",
													onChange: function (e) {
														return _this.onChange("body", e);
													}
												})
											),
											_react2['default'].createElement(
												'div',
												{ className: 'feedback-submit' },
												_react2['default'].createElement(
													'button',
													{ className: 'btn-small', style: { width: "230px" }, onClick: function () {
															return _this.submit();
														} },
													'Send Message'
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return FAQ;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(FAQ);
	module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FAQText = [{
	    id: 0,
	    question: "What is the difference among users' roles?",
	    answer: _react2["default"].createElement(
	        _react.Fragment,
	        null,
	        _react2["default"].createElement(
	            "li",
	            null,
	            "Company Administrators & Local Administrators: Have all the right to CRUD. This is suitable for project managers, team lead. "
	        ),
	        _react2["default"].createElement(
	            "li",
	            null,
	            "Local Users & Support: Have the right to view the Live data and open Livefeed. This is suitable for maitenance purpose (Internal or 3rd-party team)."
	        )
	    )
	}, {
	    id: 1,
	    question: "How to export data to CSV and inspect each individual data?",
	    answer: "From the dashboard, choose the duration of exported data (current day, weeks, months or custom). \nSelect the desired location widget and click \"Export data\" button. Choose the \"CSV: Data of sensors\" option and Save the file to local machines.\nCSV data presents average hourly data of each SenzoUnit from chosen working hours. \nThe average data is calculated from \"Mask\" after formatting the value to binary string."
	}, {
	    id: 2,
	    question: "Could I choose different working hours for each location/building/department?",
	    answer: 'Certainly. From dashboard, choose Settings on the top-right corner and select "Default Settings". User can add and modify the working hours and working days of each location.'
	}, {
	    id: 3,
	    question: "SenzoLive API?",
	    answer: _react2["default"].createElement(
	        _react.Fragment,
	        null,
	        "Please check the SenzoLive API design here ",
	        _react2["default"].createElement("br", null),
	        _react2["default"].createElement(
	            "a",
	            { target: "_blank", rel: "noopener noreferrer", href: "https://app.swaggerhub.com/apis/Senzo_IT_Oy/Senzolive-3.0/1.0.0#/" },
	            "https://app.swaggerhub.com/apis/Senzo_IT_Oy/Senzolive-3.0/1.0.0#/"
	        ),
	        _react2["default"].createElement("br", null),
	        "To generate API key, choose Settings on the top-right corner and select \"SenzoAPI\""
	    )
	}, {
	    id: 4,
	    question: "What are the certifications of the sensor?",
	    answer: "SenzoLive has passed for FCC and CB Testing including SAR Measurement."
	}, {
	    id: 5,
	    question: "What type of data does the sensor collect?",
	    answer: "The technology we use is proximity sensor (P/N: VCNL4010) to measure proximity signal. The data is used to calculate occupancy & efficiency level."
	}, {
	    id: 6,
	    question: "What is the interval of collection data?",
	    answer: 'By default, the SenzoUnit is collecting data every 2 minutes (the interval is adjustable). Once it reach the end of interval, SenzoUnit will send data to the server.'
	}, {
	    id: 7,
	    question: 'What is the difference among "Unoccupied", "Occupied" and "Standby" indicators in Live view?',
	    answer: "Unoccupied means the seat is free and available to use.\nOccupied means the seat is taken and being used.\nStandby means the occupant has left the seat during last 15 minutes (the Standby indication time is adjustable to suit different workspace's purposes)\nAll indicators are real-time value."
	}, {
	    id: 8,
	    question: 'What is the meaning of "Offline" and "Maintenance" indicators in Live view?',
	    answer: 'Offline means the SenzoUnit has connection issue recently up to 24 hours.\nMaintenance means the SenzoUnit has been offline for more than 24 hours and requires attention from technician.'
	}, {
	    id: 9,
	    question: 'What are action points to fix the "Maintenance" sensor?',
	    answer: 'Please check whether there is power is available for the SenzoUnit and micro USB cable is properly connected to it. For indication, the LED will blink once at the startup when plugged in.'
	}, {
	    id: 10,
	    question: 'How to soft reset the sensor?',
	    answer: 'On the back side of the SenzoUnit, (from left to right) there is a switch, micro USB slot, LED and reset button.\nMake sure the cable is attached to SenzoUnit and there is power (sensor will blink once at start up)\nPress and hold the reset button for 20 seconds until the SenzoUnit is blinking green. Switch the SenzoUnit to OFF (to left-hand side) and wait for 10 seconds.\nSwitch the SenzoUnit back to ON.\nCheck from the live view for new update.'
	}];
	exports["default"] = FAQText;
	module.exports = exports["default"];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _api = __webpack_require__(1907);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var APIContainer = function APIContainer() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'overwrite--modal--depth' },
	        _react2['default'].createElement(
	            _componentsCommonStickymenu2['default'],
	            {
	                withStickyHeader: false
	            },
	            _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                overviewIsActive: false,
	                comparisonIsActive: false,
	                onlyLeftMenu: true
	            }),
	            _react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
	                leftItemBold: 'SenzoAPI'
	            })
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'page-content' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'white-box-container box--shadow bg--white api--box' },
	                _react2['default'].createElement(_api2['default'], null)
	            )
	        )
	    );
	};
	exports['default'] = APIContainer;
	module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var API = (function (_React$Component) {
	    _inherits(API, _React$Component);
	
	    function API(props, context) {
	        _classCallCheck(this, API);
	
	        _get(Object.getPrototypeOf(API.prototype), 'constructor', this).call(this, props, context);
	        this.state = {
	            password: ""
	        };
	    }
	
	    _createClass(API, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.dispatch((0, _actionsLivefeedapi.clearAPIKey)());
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.apikey != nextProps.apikey) {
	                this.modal.close();
	            }
	        }
	    }, {
	        key: 'generateAPIKey',
	        value: function generateAPIKey() {
	            this.props.dispatch((0, _actionsLivefeedapi.generateAPIKey)({
	                username: this.props.me.username,
	                old: this.state.password
	            }));
	        }
	    }, {
	        key: 'onPasswordChange',
	        value: function onPasswordChange(e) {
	            this.setState({ password: e.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'SenzoAPI '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'current--api--key' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Attach API key in request : ',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement(
	                            'code',
	                            null,
	                            'https://backend.senzodata.com/api/...?apikey=',
	                            this.props.apikey,
	                            '...'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Generated API key is shown only ',
	                        _react2['default'].createElement(
	                            'b',
	                            null,
	                            'once'
	                        ),
	                        '. So please back it up safely and carefully. If you have lost your API key, please generate a new one. ',
	                        _react2['default'].createElement(
	                            'b',
	                            null,
	                            'Generating new API key would make every previous API keys invalid.'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        ' If you think someone else has unauthorized access to your API key, it\'s best to generate a new one.'
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonModal2['default'],
	                        {
	                            ref: function (modal) {
	                                _this.modal = modal;
	                            },
	                            clickButton: this.generateAPIKey.bind(this),
	                            header: 'Generate New Key',
	                            buttonText: 'Generate',
	                            buttonClass: 'btn-success',
	                            entry: !this.props.generated && _react2['default'].createElement(
	                                'div',
	                                { className: 'btn-small generate--api--btn pull-right' },
	                                'Generate New Key'
	                            )
	                        },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Are you sure you want to generate a new API key ? ',
	                            _react2['default'].createElement(
	                                'b',
	                                null,
	                                'Every previous keys would become invalid.'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            'Password :'
	                        ),
	                        _react2['default'].createElement('input', {
	                            type: 'password',
	                            value: this.state.password,
	                            onChange: this.onPasswordChange.bind(this),
	                            className: this.props.wrongPassword ? "has-error" : ""
	                        })
	                    ),
	                    this.props.generated && _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            'New API key :'
	                        ),
	                        _react2['default'].createElement(
	                            'code',
	                            null,
	                            this.props.apikey
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Please back up this key. You can only see it this time !'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return API;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        me: state.myAccountReducer.user,
	        generated: state.livefeedAPIReducer.generated,
	        wrongPassword: state.livefeedAPIReducer.wrongPassword,
	        apikey: state.livefeedAPIReducer.apikey
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(API);
	module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var _SwitchTab = __webpack_require__(1909);
	
	var _SwitchTab2 = _interopRequireDefault(_SwitchTab);
	
	exports['default'] = function (_ref) {
	    var router = _ref.router;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'livefeed-page overwrite--modal--depth' },
	        _react2['default'].createElement(
	            _componentsCommonStickymenu2['default'],
	            { withStickyHeader: false },
	            _react2['default'].createElement(_componentsCommonMainmenu2['default'], { overviewIsActive: false, comparisonIsActive: false, onlyLeftMenu: true }),
	            _react2['default'].createElement(_componentsCommonStatsmenu2['default'], { leftItemBold: 'Livefeed settings' })
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'page-content page-content_padding-modifier page-content_livefeed' },
	            _react2['default'].createElement(_SwitchTab2['default'], { router: router })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var _LivefeedTableList = __webpack_require__(1910);
	
	var _LivefeedTableList2 = _interopRequireDefault(_LivefeedTableList);
	
	var _TemplateTableList = __webpack_require__(1919);
	
	var _TemplateTableList2 = _interopRequireDefault(_TemplateTableList);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var SwitchTab = function SwitchTab(props) {
	    var _useState = (0, _react.useState)(true);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var isLivefeedTab = _useState2[0];
	    var setIsLivefeedTab = _useState2[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	    dispatch(a.fetchLivefeed());
	    dispatch(a.fetchTemplate());
	
	    (0, _componentsCommonHooks.useInterval)(function () {
	        dispatch(a.fetchLivefeed());
	        dispatch(a.fetchTemplate());
	    }, 6000 * 10); // 1 min
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'switch-tab' },
	            _react2['default'].createElement(
	                'span',
	                { onClick: function () {
	                        return setIsLivefeedTab(true);
	                    },
	                    className: (isLivefeedTab ? 'tab_active' : '') + ' font--proLight' },
	                'Livefeed'
	            ),
	            _react2['default'].createElement('span', { className: 'tab-divider' }),
	            _react2['default'].createElement(
	                'span',
	                { onClick: function () {
	                        return setIsLivefeedTab(false);
	                    },
	                    className: (!isLivefeedTab ? 'tab_active' : '') + ' font--proLight' },
	                'Template'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'table-livefeed-wrapper' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'white-box-container bg--white white-box-container_livefeed ' + (isLivefeedTab ? 'white-box-container_livefeed_active' : '') },
	                _react2['default'].createElement(_LivefeedTableList2['default'], { router: props.router })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'white-box-container bg--white white-box-container_livefeed ' + (!isLivefeedTab ? 'white-box-container_livefeed_active' : '') },
	                _react2['default'].createElement(_TemplateTableList2['default'], { router: props.router })
	            )
	        )
	    );
	};
	SwitchTab.propTypes = {
	    router: _propTypes2['default'].any.isRequired
	};
	exports['default'] = SwitchTab;
	module.exports = exports['default'];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _EditUserForm = __webpack_require__(1911);
	
	var _EditUserForm2 = _interopRequireDefault(_EditUserForm);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactTable = __webpack_require__(1912);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var LivefeedTableList = function LivefeedTableList(props) {
	    var deleteLivefeedModal = (0, _react.useRef)(null);
	    var editUserForm = (0, _react.useRef)(null);
	    var addLivefeedModal = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)({});
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var componentState = _useState2[0];
	    var setComponentState = _useState2[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeedAPIReducer;
	    });
	
	    var urls = _useSelector.urls;
	    var templates = _useSelector.templates;
	
	    var user = (0, _reactRedux.useSelector)(function (state) {
	        return state.myAccountReducer.user;
	    });
	    var isAdmin = user.role === _config2['default'].roles[0].rolecode;
	    (0, _react.useEffect)(function () {
	        _reactTooltip2['default'].rebuild(); // componentDidUpdate()
	    });
	
	    function makeHandlerDelete(index) {
	        return function () {
	            var url = urls[index];
	            setComponentState(_extends({}, componentState, {
	                deletedLivefeedKey: url.key,
	                deletedLivefeedName: url.name
	            }));
	            deleteLivefeedModal.current.open();
	        };
	    }
	    var deleteLivefeed = (0, _react.useCallback)(function (key, fClose) {
	        /*
	            Format :
	                key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
	        */
	        dispatch(a.deleteLivefeed(key, fClose));
	    }, [dispatch]);
	
	    var navigateToEditor = (0, _react.useCallback)(function (mode, index) {
	        switch (mode) {
	            case "createFromTemplate":
	                {
	                    dispatch((0, _actionsLivefeed.setEditorDefaultState)());
	                    var _componentState$template = componentState.template;
	                    var key = _componentState$template.label;
	                    var data = _componentState$template.data;
	
	                    var passedData = data;
	                    passedData.livefeedName = componentState.template.label;
	                    props.router.push({
	                        pathname: '/livefeed/editor',
	                        state: {
	                            mode: "createLivefeed",
	                            key: key,
	                            passedData: passedData,
	                            templateList: templates
	                        }
	                    });
	                }
	                break;
	            case "createBlank":
	                {
	                    dispatch((0, _actionsLivefeed.setEditorDefaultState)());
	                    props.router.push({
	                        pathname: '/livefeed/editor'
	                    });
	                }
	                break;
	            case "edit":
	                {
	                    dispatch((0, _actionsLivefeed.setEditorDefaultState)());
	                    var livefeed = urls[index];
	                    var key = livefeed.key;
	                    var subscribers = livefeed.subscribers;
	
	                    var passedData = livefeed.data;
	                    passedData.livefeedName = livefeed.name;
	                    props.router.push({
	                        pathname: '/livefeed/editor',
	                        state: {
	                            mode: "editLivefeed",
	                            key: key,
	                            passedData: passedData,
	                            subscribers: subscribers,
	                            templateList: templates
	                        }
	                    });
	                }
	                break;
	        }
	    }, [componentState.template, dispatch, props.router, templates, urls]);
	
	    function handleTemplateSelect(key, option) {
	        // Handle changes for Select components
	        if (option.value === "add") {
	            navigateToEditor("createBlank");
	        } else {
	            setComponentState(_extends({}, componentState, _defineProperty({}, key, option)));
	        }
	    }
	    function selectCreateOptions() {
	        var ar = templates.map(function (x) {
	            var a = {
	                value: x.id,
	                label: x.name,
	                data: x.data
	            };
	            return a;
	        });
	
	        ar.push({
	            value: "add",
	            label: "Add without template",
	            data: "",
	            className: "add-template"
	        });
	
	        return ar;
	    }
	    var handlePreviewLivefeed = (0, _react.useCallback)(function (index) {
	        dispatch(a.previewLivefeed(urls[index]));
	    }, [dispatch, urls]);
	
	    //------------------------------------------- CRUD btns fn Render -----------------------------------
	    function renderCellBtn(child) {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'livefeed-child livefeed-child_icons' },
	            child
	        );
	    }
	    var editDeleteBtns = function editDeleteBtns(index) {
	        return _react2['default'].createElement(
	            _react.Fragment,
	            null,
	            renderCellBtn(_react2['default'].createElement(
	                'i',
	                { className: 'material-icons users--icons', 'data-tip': 'Edit users',
	                    onClick: function () {
	                        return editUserForm.current.openEditUserModal(index);
	                    } },
	                'group'
	            )),
	            renderCellBtn(_react2['default'].createElement(
	                'i',
	                { className: 'material-icons edit--icons', 'data-tip': 'Edit livefeed',
	                    onClick: function () {
	                        navigateToEditor("edit", index);
	                    } },
	                'edit'
	            )),
	            renderCellBtn(_react2['default'].createElement(
	                'i',
	                { className: 'material-icons delete--icons', 'data-tip': 'Delete',
	                    onClick: makeHandlerDelete(index) },
	                'clear'
	            ))
	        );
	    };
	    //------------------------------------------- Collumns for table -----------------------------------
	    var columns = [{
	        expander: true,
	        Expander: function Expander(_ref) {
	            var isExpanded = _ref.isExpanded;
	            return _react2['default'].createElement(
	                'i',
	                { 'data-tip': 'Click to see floorplans on this livefeed', className: ' expand-btn ' + (isExpanded ? 'expand-btn_active ' : '') + ' material-icons' },
	                isExpanded ? 'remove_circle_outline' : 'add_circle_outline'
	            );
	        },
	
	        style: {
	            cursor: "pointer", fontSize: 25, padding: "0", justifyContent: "center",
	            alignItems: "center", display: "flex", userSelect: "none"
	        }
	    }, {
	        Header: "Name", accessor: "name",
	        Filter: function Filter(_ref2) {
	            var filter = _ref2.filter;
	            var onChange = _ref2.onChange;
	            return _react2['default'].createElement('input', { type: 'text', placeholder: 'Search livefeed',
	                value: filter ? filter.value : '',
	                onChange: function (event) {
	                    return onChange(event.target.value);
	                }
	            });
	        },
	        Cell: function Cell(_ref3) {
	            var value = _ref3.value;
	            var original = _ref3.original;
	            return _react2['default'].createElement(
	                'div',
	                { 'data-tip': 'Go to livefeed', className: 'livefeed-child livefeed-child_name' },
	                _react2['default'].createElement(
	                    'a',
	                    { href: _config2['default'].livefeed.root + "/#/url?k=" + original.key,
	                        className: 'ellipsis', target: '_blank', rel: 'noopener noreferrer' },
	                    value
	                )
	            );
	        }
	    }, {
	        width: 180, Header: "Creator", accessor: "owner",
	        Cell: function Cell(_ref4) {
	            var value = _ref4.value;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-child' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'ellipsis' },
	                    value,
	                    ' '
	                )
	            );
	        }
	    }, {
	        id: "date", width: 180, Header: "Date",
	        accessor: function accessor(_ref5) {
	            var data = _ref5.data;
	            return data.timestamp;
	        },
	        Cell: function Cell(_ref6) {
	            var value = _ref6.value;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-child' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'ellipsis' },
	                    (0, _moment2['default'])(value).local().format("DD-MM-YYYY HH:mm:ss")
	                )
	            );
	        }
	    }, {
	        Header: "Actions", width: 200, style: { padding: 0, height: 44 }, filterable: false, sortable: false, resizable: false,
	        Cell: function Cell(_ref7) {
	            var index = _ref7.index;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-crud' },
	                renderCellBtn(_react2['default'].createElement(
	                    'i',
	                    { className: 'material-icons preview--icons', 'data-tip': 'Preview',
	                        onClick: function () {
	                            return handlePreviewLivefeed(index);
	                        } },
	                    ''
	                )),
	                isAdmin ? _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    editDeleteBtns(index)
	                ) : _react2['default'].createElement(
	                    'span',
	                    { className: 'livefeed-child_disabled', 'data-tip': 'Only Admins can edit and delete' },
	                    editDeleteBtns(index)
	                )
	            );
	        }
	    }];
	    function addLivefeed() {
	        if (isAdmin) {
	            // only admin can add
	            templates.length > 0 ? addLivefeedModal.current.open() : navigateToEditor("createBlank");
	        }
	    }
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'h3',
	            { className: 'live-feed-title' },
	            'Livefeeds'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { 'data-tip': '' + (!isAdmin ? 'Only Admins can add' : ''),
	                className: 'button btn--green add-livefeed-btn ' + (!isAdmin ? 'add-livefeed-btn_disabled' : ''),
	                onClick: function () {
	                    return addLivefeed();
	                } },
	            _react2['default'].createElement('span', { className: 'font-icon icon-addicon' }),
	            'Add Livefeed'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'all-feed-container' },
	            urls.length <= 0 ? _react2['default'].createElement(
	                'div',
	                null,
	                'No livefeed has been created yet'
	            ) : _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(_reactTooltip2['default'], { place: 'top', type: 'dark', effect: 'solid' }),
	                _react2['default'].createElement(_reactTable2['default'], {
	                    data: urls, columns: columns,
	                    style: {
	                        height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
	                    },
	                    defaultSorted: [{
	                        id: "date",
	                        desc: true
	                    }],
	                    filterable: true,
	                    defaultPageSize: 10,
	                    freezeWhenExpanded: true,
	                    SubComponent: function (_ref8) {
	                        var _ref8$original = _ref8.original;
	                        var name = _ref8$original.name;
	                        var locations = _ref8$original.locations;
	                        return _react2['default'].createElement(
	                            'div',
	                            { className: "location-list" },
	                            locations.length > 1 ? 'These locations are displayed in ' + name : 'This location is displayed in ' + name,
	                            _react2['default'].createElement(
	                                'ul',
	                                null,
	                                locations.map(function (location, index) {
	                                    return _react2['default'].createElement(
	                                        'li',
	                                        { key: index },
	                                        location.locationName
	                                    );
	                                })
	                            )
	                        );
	                    },
	                    className: '-highlight livefeed-list-table'
	                })
	            )
	        ),
	        _react2['default'].createElement(_EditUserForm2['default'], {
	            ref: editUserForm
	        }),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                ref: addLivefeedModal,
	                clickButton: function () {
	                    return navigateToEditor("createFromTemplate");
	                },
	                header: 'Add Livefeed',
	                buttonText: 'Continue',
	                buttonClass: 'btn-success',
	                buttonHide: true,
	                entry: null
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'add-feed-modal' },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Please select a template for your new Livefeed or ',
	                        _react2['default'].createElement(
	                            'a',
	                            { onClick: function () {
	                                    return navigateToEditor("createBlank");
	                                },
	                                className: 'add-template live-feed-button' },
	                            'Add without template'
	                        )
	                    ),
	                    _react2['default'].createElement(_reactSelect2['default'], {
	                        autoFocus: true,
	                        openOnFocus: true,
	                        openOnClick: true,
	                        closeOnSelect: true,
	                        clearable: false,
	                        onChange: function (option) {
	                            handleTemplateSelect("template", option);
	                        },
	                        options: selectCreateOptions(),
	                        placeholder: 'Select template for livefeed',
	                        value: componentState.template
	                    })
	                ),
	                _react2['default'].createElement('div', { style: { height: "0px" } })
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                ref: deleteLivefeedModal,
	                clickButton: function () {
	                    return deleteLivefeed(componentState.deletedLivefeedKey, deleteLivefeedModal.current.close());
	                },
	                header: 'Delete livefeed',
	                buttonText: 'Delete',
	                buttonClass: 'btn-danger',
	                entry: null
	            },
	            _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                    'b',
	                    null,
	                    'All invited users will no longer have access to this livefeed view.'
	                ),
	                _react2['default'].createElement('br', null),
	                'Are you sure you want to delete livefeed',
	                _react2['default'].createElement(
	                    'b',
	                    null,
	                    ' ',
	                    componentState.deletedLivefeedName
	                ),
	                ' ?'
	            )
	        )
	    );
	};
	LivefeedTableList.propTypes = {
	    router: _propTypes2['default'].any.isRequired
	};
	exports['default'] = LivefeedTableList;
	module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var EditUserForm = (0, _react.forwardRef)(function (props, ref) {
		var dispatch = (0, _reactRedux.useDispatch)();
	
		var _useSelector = (0, _reactRedux.useSelector)(function (state) {
			return state.livefeedAPIReducer;
		});
	
		var urls = _useSelector.urls;
	
		var deleteUserModal = (0, _react.useRef)(null);
		var editUserModal = (0, _react.useRef)(null);
	
		var _useState = (0, _react.useState)({
			livefeedName: null, index: null, key: null, subscribers: [],
			prevSubscribers: null, isLoading: false, deletedUser: null
		});
	
		var _useState2 = _slicedToArray(_useState, 2);
	
		var componentState = _useState2[0];
		var setComponentState = _useState2[1];
	
		(0, _react.useImperativeHandle)(ref, function () {
			return {
				openEditUserModal: function openEditUserModal(index) {
					var _urls$index = urls[index];
					var key = _urls$index.key;
					var subscribers = _urls$index.subscribers;
					var name = _urls$index.name;
	
					setComponentState(_extends({}, componentState, {
						livefeedName: name,
						index: index,
						key: key,
						subscribers: [],
						prevSubscribers: subscribers
					}));
					editUserModal.current.open();
				}
			};
		});
		//----------------------------------------- delete user functions  handle
		function makeHandlerUserDelete(email) {
			setComponentState(_extends({}, componentState, {
				isLoading: true
			}));
			setComponentState(_extends({}, componentState, {
				deletedUser: email
			}));
			deleteUserModal.current.open();
		}
		function handleDeleteUser(key, email) {
			/*
	  	Format :
	  		key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
	  		email : "quangdel@gmail.com" // must be one string.
	  */
			dispatch(a.removeUserFromURL(key, email, function () {
				setComponentState(_extends({}, componentState, {
					isLoading: false
				}));
				deleteUserModal.current.close();
			}));
		}
		//----------------------------------------- add user function  handle
		function handleAddUser(key, emails) {
			/*
	  	Format :
	  		key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
	  		emails : ["quangdel@gmail.com"] // must be an array of strings.
	  */
			emails = emails.map(function (x) {
				return x.value;
			});
	
			dispatch(a.addUsersToURL(key, emails, function () {
				setComponentState(_extends({}, componentState, {
					isLoading: false
				}));
			}));
		}
	
		(0, _react.useEffect)(function () {
			// update prevSubscribers if there is changes from urls[componentState.index].subscribers.length
			if (urls[componentState.index] && urls[componentState.index].subscribers.length !== componentState.prevSubscribers.length) {
				var prevSubscribers = urls[componentState.index].subscribers;
	
				setComponentState(_extends({}, componentState, {
					prevSubscribers: prevSubscribers,
					subscribers: []
				}));
			}
		}, [componentState, urls]);
		return _react2['default'].createElement(
			_componentsCommonModal2['default'],
			{
				ref: editUserModal,
				clickButton: function () {
					if (!componentState.isLoading && componentState.subscribers.length > 0) {
						setComponentState(_extends({}, componentState, { isLoading: true }));
						handleAddUser(componentState.key, componentState.subscribers);
					}
				},
				header: "Edit users",
				buttonText: "Add",
				buttonClass: 'btn-success ' + (componentState.subscribers.length > 0 ? '' : 'btn-disabled'),
				disableCloseButton: true,
				entry: null
			},
			_react2['default'].createElement(
				'div',
				{ className: 'live-feed-form' },
				_react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'p',
						null,
						'Livefeed name : ',
						componentState.livefeedName
					),
					_react2['default'].createElement(
						'span',
						{ className: 'input-label' },
						'Current user(s)'
					),
					_react2['default'].createElement(
						'div',
						{ className: 'input-current-container' },
						componentState.prevSubscribers && componentState.prevSubscribers.map(function (subscriber, i) {
							return _react2['default'].createElement(
								'div',
								{ key: "key-user-" + subscriber, className: 'input-current-user' },
								subscriber,
								_react2['default'].createElement(
									'i',
									{ className: 'material-icons', onClick: function () {
											return makeHandlerUserDelete(subscriber);
										} },
									'clear'
								)
							);
						})
					)
				),
				_react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'span',
						{ className: 'input-label' },
						'Add user(s)'
					),
					_react2['default'].createElement(_reactSelect2['default'].Creatable, {
						multi: true,
						closeOnSelect: true,
						onChange: function (value) {
							return setComponentState(_extends({}, componentState, { subscribers: value }));
						},
						options: [],
						placeholder: 'viewing@user.com',
						removeSelected: true,
						value: componentState.subscribers,
						arrowRenderer: function () {},
						noResultsText: "Enter each email then press 'Enter'"
					}),
					componentState.isLoading && "Please Wait..."
				),
				_react2['default'].createElement(
					_componentsCommonModal2['default'],
					{
						ref: deleteUserModal,
						clickButton: function () {
							return handleDeleteUser(componentState.key, componentState.deletedUser);
						},
						header: 'Remove user',
						buttonText: 'Delete',
						buttonClass: 'btn-danger',
						entry: null
					},
					_react2['default'].createElement(
						'p',
						null,
						_react2['default'].createElement(
							'b',
							null,
							'Removing and re-adding the same users can cause errors.'
						),
						_react2['default'].createElement('br', null),
						'Are you sure you want to remove user "',
						componentState.deletedUser,
						'" from the livefeed ?'
					)
				)
			)
		);
	});
	exports['default'] = EditUserForm;
	module.exports = exports['default'];

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactTableDefaults = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(1913);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _lifecycle = __webpack_require__(1914);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	var _methods = __webpack_require__(1915);
	
	var _methods2 = _interopRequireDefault(_methods);
	
	var _defaultProps = __webpack_require__(1916);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _propTypes = __webpack_require__(1918);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//
	
	
	var ReactTableDefaults = exports.ReactTableDefaults = _defaultProps2.default;
	
	var ReactTable = function (_Methods) {
	  _inherits(ReactTable, _Methods);
	
	  function ReactTable(props) {
	    _classCallCheck(this, ReactTable);
	
	    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this, props));
	
	    _this.getResolvedState = _this.getResolvedState.bind(_this);
	    _this.getDataModel = _this.getDataModel.bind(_this);
	    _this.getSortedData = _this.getSortedData.bind(_this);
	    _this.fireFetchData = _this.fireFetchData.bind(_this);
	    _this.getPropOrState = _this.getPropOrState.bind(_this);
	    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
	    _this.filterData = _this.filterData.bind(_this);
	    _this.sortData = _this.sortData.bind(_this);
	    _this.getMinRows = _this.getMinRows.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
	    _this.sortColumn = _this.sortColumn.bind(_this);
	    _this.filterColumn = _this.filterColumn.bind(_this);
	    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
	    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
	    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var resolvedState = this.getResolvedState();
	      var children = resolvedState.children,
	          className = resolvedState.className,
	          style = resolvedState.style,
	          getProps = resolvedState.getProps,
	          getTableProps = resolvedState.getTableProps,
	          getTheadGroupProps = resolvedState.getTheadGroupProps,
	          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
	          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
	          getTheadProps = resolvedState.getTheadProps,
	          getTheadTrProps = resolvedState.getTheadTrProps,
	          getTheadThProps = resolvedState.getTheadThProps,
	          getTheadFilterProps = resolvedState.getTheadFilterProps,
	          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
	          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
	          getTbodyProps = resolvedState.getTbodyProps,
	          getTrGroupProps = resolvedState.getTrGroupProps,
	          getTrProps = resolvedState.getTrProps,
	          getTdProps = resolvedState.getTdProps,
	          getTfootProps = resolvedState.getTfootProps,
	          getTfootTrProps = resolvedState.getTfootTrProps,
	          getTfootTdProps = resolvedState.getTfootTdProps,
	          getPaginationProps = resolvedState.getPaginationProps,
	          getLoadingProps = resolvedState.getLoadingProps,
	          getNoDataProps = resolvedState.getNoDataProps,
	          getResizerProps = resolvedState.getResizerProps,
	          showPagination = resolvedState.showPagination,
	          showPaginationTop = resolvedState.showPaginationTop,
	          showPaginationBottom = resolvedState.showPaginationBottom,
	          manual = resolvedState.manual,
	          loadingText = resolvedState.loadingText,
	          noDataText = resolvedState.noDataText,
	          sortable = resolvedState.sortable,
	          multiSort = resolvedState.multiSort,
	          resizable = resolvedState.resizable,
	          filterable = resolvedState.filterable,
	          pivotIDKey = resolvedState.pivotIDKey,
	          pivotValKey = resolvedState.pivotValKey,
	          pivotBy = resolvedState.pivotBy,
	          subRowsKey = resolvedState.subRowsKey,
	          aggregatedKey = resolvedState.aggregatedKey,
	          originalKey = resolvedState.originalKey,
	          indexKey = resolvedState.indexKey,
	          groupedByPivotKey = resolvedState.groupedByPivotKey,
	          loading = resolvedState.loading,
	          pageSize = resolvedState.pageSize,
	          page = resolvedState.page,
	          sorted = resolvedState.sorted,
	          filtered = resolvedState.filtered,
	          resized = resolvedState.resized,
	          expanded = resolvedState.expanded,
	          pages = resolvedState.pages,
	          onExpandedChange = resolvedState.onExpandedChange,
	          TableComponent = resolvedState.TableComponent,
	          TheadComponent = resolvedState.TheadComponent,
	          TbodyComponent = resolvedState.TbodyComponent,
	          TrGroupComponent = resolvedState.TrGroupComponent,
	          TrComponent = resolvedState.TrComponent,
	          ThComponent = resolvedState.ThComponent,
	          TdComponent = resolvedState.TdComponent,
	          TfootComponent = resolvedState.TfootComponent,
	          PaginationComponent = resolvedState.PaginationComponent,
	          LoadingComponent = resolvedState.LoadingComponent,
	          SubComponent = resolvedState.SubComponent,
	          NoDataComponent = resolvedState.NoDataComponent,
	          ResizerComponent = resolvedState.ResizerComponent,
	          ExpanderComponent = resolvedState.ExpanderComponent,
	          PivotValueComponent = resolvedState.PivotValueComponent,
	          PivotComponent = resolvedState.PivotComponent,
	          AggregatedComponent = resolvedState.AggregatedComponent,
	          FilterComponent = resolvedState.FilterComponent,
	          PadRowComponent = resolvedState.PadRowComponent,
	          resolvedData = resolvedState.resolvedData,
	          allVisibleColumns = resolvedState.allVisibleColumns,
	          headerGroups = resolvedState.headerGroups,
	          hasHeaderGroups = resolvedState.hasHeaderGroups,
	          sortedData = resolvedState.sortedData,
	          currentlyResizing = resolvedState.currentlyResizing;
	
	      // Pagination
	
	      var startRow = pageSize * page;
	      var endRow = startRow + pageSize;
	      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
	      var minRows = this.getMinRows();
	      var padRows = _utils2.default.range(Math.max(minRows - pageRows.length, 0));
	
	      var hasColumnFooter = allVisibleColumns.some(function (d) {
	        return d.Footer;
	      });
	      var hasFilters = filterable || allVisibleColumns.some(function (d) {
	        return d.filterable;
	      });
	
	      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
	        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	        return [rows.map(function (row, i) {
	          index += 1;
	          var rowWithViewIndex = _extends({}, row, {
	            _viewIndex: index
	          });
	          var newPath = path.concat([i]);
	          if (rowWithViewIndex[subRowsKey] && _utils2.default.get(expanded, newPath)) {
	            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);
	
	            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);
	
	            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
	            index = _recurseRowsViewIndex2[1];
	          }
	          return rowWithViewIndex;
	        }), index];
	      };
	
	      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);
	
	      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);
	
	      pageRows = _recurseRowsViewIndex4[0];
	
	
	      var canPrevious = page > 0;
	      var canNext = page + 1 < pages;
	
	      var rowMinWidth = _utils2.default.sum(allVisibleColumns.map(function (d) {
	        var resizedColumn = resized.find(function (x) {
	          return x.id === d.id;
	        }) || {};
	        return _utils2.default.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
	      }));
	
	      var rowIndex = -1;
	
	      var finalState = _extends({}, resolvedState, {
	        startRow: startRow,
	        endRow: endRow,
	        pageRows: pageRows,
	        minRows: minRows,
	        padRows: padRows,
	        hasColumnFooter: hasColumnFooter,
	        canPrevious: canPrevious,
	        canNext: canNext,
	        rowMinWidth: rowMinWidth
	      });
	
	      var rootProps = _utils2.default.splitProps(getProps(finalState, undefined, undefined, this));
	      var tableProps = _utils2.default.splitProps(getTableProps(finalState, undefined, undefined, this));
	      var tBodyProps = _utils2.default.splitProps(getTbodyProps(finalState, undefined, undefined, this));
	      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
	      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);
	
	      // Visual Components
	
	      var makeHeaderGroup = function makeHeaderGroup(column, i) {
	        var resizedValue = function resizedValue(col) {
	          return (resized.find(function (x) {
	            return x.id === col.id;
	          }) || {}).value;
	        };
	        var flex = _utils2.default.sum(column.columns.map(function (col) {
	          return col.width || resizedValue(col) ? 0 : col.minWidth;
	        }));
	        var width = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.minWidth);
	        }));
	        var maxWidth = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
	        }));
	
	        var theadGroupThProps = _utils2.default.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);
	
	        var flexStyles = {
	          flex: flex + ' 0 auto',
	          width: _utils2.default.asPx(width),
	          maxWidth: _utils2.default.asPx(maxWidth)
	        };
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, flexStyles)
	          }, rest),
	          _utils2.default.normalizeComponent(column.Header, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeHeaderGroups = function makeHeaderGroups() {
	        var theadGroupProps = _utils2.default.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
	        var theadGroupTrProps = _utils2.default.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-headerGroups', theadGroupProps.className),
	            style: _extends({}, theadGroupProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadGroupProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadGroupTrProps.className,
	              style: theadGroupTrProps.style
	            }, theadGroupTrProps.rest),
	            headerGroups.map(makeHeaderGroup)
	          )
	        );
	      };
	
	      var makeHeader = function makeHeader(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var sort = sorted.find(function (d) {
	          return d.id === column.id;
	        });
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadThProps = _utils2.default.splitProps(getTheadThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);
	
	        var isResizable = _utils2.default.getFirstDefined(column.resizable, resizable, false);
	        var resizer = isResizable ? _react2.default.createElement(ResizerComponent, _extends({
	          onMouseDown: function onMouseDown(e) {
	            return _this2.resizeColumnStart(e, column, false);
	          },
	          onTouchStart: function onTouchStart(e) {
	            return _this2.resizeColumnStart(e, column, true);
	          }
	        }, getResizerProps('finalState', undefined, column, _this2))) : null;
	
	        var isSortable = _utils2.default.getFirstDefined(column.sortable, sortable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            }),
	            toggleSort: function toggleSort(e) {
	              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
	            }
	          }, rest),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(isResizable && 'rt-resizable-header-content') },
	            _utils2.default.normalizeComponent(column.Header, {
	              data: sortedData,
	              column: column
	            })
	          ),
	          resizer
	        );
	      };
	
	      var makeHeaders = function makeHeaders() {
	        var theadProps = _utils2.default.splitProps(getTheadProps(finalState, undefined, undefined, _this2));
	        var theadTrProps = _utils2.default.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-header', theadProps.className),
	            style: _extends({}, theadProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadTrProps.className,
	              style: theadTrProps.style
	            }, theadTrProps.rest),
	            allVisibleColumns.map(makeHeader)
	          )
	        );
	      };
	
	      var makeFilter = function makeFilter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadFilterThProps = _utils2.default.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);
	
	        var filter = filtered.find(function (filter) {
	          return filter.id === column.id;
	        });
	
	        var ResolvedFilterComponent = column.Filter || FilterComponent;
	
	        var isFilterable = _utils2.default.getFirstDefined(column.filterable, filterable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, rest),
	          isFilterable ? _utils2.default.normalizeComponent(ResolvedFilterComponent, {
	            column: column,
	            filter: filter,
	            onChange: function onChange(value) {
	              return _this2.filterColumn(column, value);
	            }
	          }, _defaultProps2.default.column.Filter) : null
	        );
	      };
	
	      var makeFilters = function makeFilters() {
	        var theadFilterProps = _utils2.default.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
	        var theadFilterTrProps = _utils2.default.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-filters', theadFilterProps.className),
	            style: _extends({}, theadFilterProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadFilterProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadFilterTrProps.className,
	              style: theadFilterTrProps.style
	            }, theadFilterTrProps.rest),
	            allVisibleColumns.map(makeFilter)
	          )
	        );
	      };
	
	      var makePageRow = function makePageRow(row, i) {
	        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        var rowInfo = {
	          original: row[originalKey],
	          row: row,
	          index: row[indexKey],
	          viewIndex: rowIndex += 1,
	          pageSize: pageSize,
	          page: page,
	          level: path.length,
	          nestingPath: path.concat([i]),
	          aggregated: row[aggregatedKey],
	          groupedByPivot: row[groupedByPivotKey],
	          subRows: row[subRowsKey]
	        };
	        var isExpanded = _utils2.default.get(expanded, rowInfo.nestingPath);
	        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
	              style: trProps.style
	            }, trProps.rest),
	            allVisibleColumns.map(function (column, i2) {
	              var resizedCol = resized.find(function (x) {
	                return x.id === column.id;
	              }) || {};
	              var show = typeof column.show === 'function' ? column.show() : column.show;
	              var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	              var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	              var tdProps = _utils2.default.splitProps(getTdProps(finalState, rowInfo, column, _this2));
	              var columnProps = _utils2.default.splitProps(column.getProps(finalState, rowInfo, column, _this2));
	
	              var classes = [tdProps.className, column.className, columnProps.className];
	
	              var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	              var cellInfo = _extends({}, rowInfo, {
	                isExpanded: isExpanded,
	                column: _extends({}, column),
	                value: rowInfo.row[column.id],
	                pivoted: column.pivoted,
	                expander: column.expander,
	                resized: resized,
	                show: show,
	                width: width,
	                maxWidth: maxWidth,
	                tdProps: tdProps,
	                columnProps: columnProps,
	                classes: classes,
	                styles: styles
	              });
	
	              var value = cellInfo.value;
	
	              var useOnExpanderClick = void 0;
	              var isBranch = void 0;
	              var isPreview = void 0;
	
	              var onExpanderClick = function onExpanderClick(e) {
	                var newExpanded = _utils2.default.clone(expanded);
	                if (isExpanded) {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, false);
	                } else {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, {});
	                }
	
	                return _this2.setStateWithData({
	                  expanded: newExpanded
	                }, function () {
	                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e, cellInfo);
	                });
	              };
	
	              // Default to a standard cell
	              var resolvedCell = _utils2.default.normalizeComponent(column.Cell, cellInfo, value);
	
	              // Resolve Renderers
	              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
	              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
	              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
	              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(ResolvedExpanderComponent, props),
	                  _react2.default.createElement(ResolvedPivotValueComponent, props)
	                );
	              };
	              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;
	
	              // Is this cell expandable?
	              if (cellInfo.pivoted || cellInfo.expander) {
	                // Make it expandable by defualt
	                cellInfo.expandable = true;
	                useOnExpanderClick = true;
	                // If pivoted, has no subRows, and does not have a subComponent,
	                // do not make expandable
	                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
	                  cellInfo.expandable = false;
	                }
	              }
	
	              if (cellInfo.pivoted) {
	                // Is this column a branch?
	                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
	                // Should this column be blank?
	                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
	                // Pivot Cell Render Override
	                if (isBranch) {
	                  // isPivot
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
	                    value: row[pivotValKey]
	                  }), row[pivotValKey]);
	                } else if (isPreview) {
	                  // Show the pivot preview
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	                } else {
	                  resolvedCell = null;
	                }
	              } else if (cellInfo.aggregated) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	              }
	
	              if (cellInfo.expander) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
	                if (pivotBy) {
	                  if (cellInfo.groupedByPivot) {
	                    resolvedCell = null;
	                  }
	                  if (!cellInfo.subRows && !SubComponent) {
	                    resolvedCell = null;
	                  }
	                }
	              }
	
	              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};
	
	              // If there are multiple onClick events, make sure they don't
	              // override eachother. This should maybe be expanded to handle all
	              // function attributes
	              var interactionProps = {
	                onClick: resolvedOnExpanderClick
	              };
	
	              if (tdProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  tdProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              if (columnProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  columnProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              // Return the cell
	              return _react2.default.createElement(
	                TdComponent
	                // eslint-disable-next-line react/no-array-index-key
	                ,
	                _extends({ key: i2 + '-' + column.id,
	                  className: (0, _classnames2.default)(classes, !cellInfo.expandable && !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
	                  style: _extends({}, styles, {
	                    flex: width + ' 0 auto',
	                    width: _utils2.default.asPx(width),
	                    maxWidth: _utils2.default.asPx(maxWidth)
	                  })
	                }, tdProps.rest, columnProps.rest, interactionProps),
	                resolvedCell
	              );
	            })
	          ),
	          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
	            return makePageRow(d, i, rowInfo.nestingPath);
	          }),
	          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo, function () {
	            var newExpanded = _utils2.default.clone(expanded);
	
	            _utils2.default.set(newExpanded, rowInfo.nestingPath, false);
	          })
	        );
	      };
	
	      var makePadColumn = function makePadColumn(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var flex = width;
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tdProps = _utils2.default.splitProps(getTdProps(finalState, undefined, column, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	
	        var classes = [tdProps.className, column.className, columnProps.className];
	
	        var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: flex + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, tdProps.rest),
	          _utils2.default.normalizeComponent(PadRowComponent)
	        );
	      };
	
	      var makePadRow = function makePadRow(row, i) {
	        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: 'pad-' + i }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            {
	              className: (0, _classnames2.default)('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
	              style: trProps.style || {}
	            },
	            allVisibleColumns.map(makePadColumn)
	          )
	        );
	      };
	
	      var makeColumnFooter = function makeColumnFooter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tFootTdProps = _utils2.default.splitProps(getTfootTdProps(finalState, undefined, column, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	        var columnFooterProps = _utils2.default.splitProps(column.getFooterProps(finalState, undefined, column, _this2));
	
	        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];
	
	        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
	          _utils2.default.normalizeComponent(column.Footer, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeColumnFooters = function makeColumnFooters() {
	        var tFootProps = _utils2.default.splitProps(getTfootProps(finalState, undefined, undefined, _this2));
	        var tFootTrProps = _utils2.default.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TfootComponent,
	          _extends({
	            className: tFootProps.className,
	            style: _extends({}, tFootProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, tFootProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(tFootTrProps.className),
	              style: tFootTrProps.style
	            }, tFootTrProps.rest),
	            allVisibleColumns.map(makeColumnFooter)
	          )
	        );
	      };
	
	      var makePagination = function makePagination(isTop) {
	        var paginationProps = _utils2.default.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(PaginationComponent, _extends({}, resolvedState, {
	          pages: pages,
	          canPrevious: canPrevious,
	          canNext: canNext,
	          onPageChange: _this2.onPageChange,
	          onPageSizeChange: _this2.onPageSizeChange,
	          className: paginationProps.className,
	          style: paginationProps.style,
	          isTop: isTop
	        }, paginationProps.rest));
	      };
	
	      var makeTable = function makeTable() {
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('ReactTable', className, rootProps.className),
	            style: _extends({}, style, rootProps.style)
	          }, rootProps.rest),
	          showPagination && showPaginationTop ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-top' },
	            makePagination(true)
	          ) : null,
	          _react2.default.createElement(
	            TableComponent,
	            _extends({
	              className: (0, _classnames2.default)(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
	              style: tableProps.style
	            }, tableProps.rest),
	            hasHeaderGroups ? makeHeaderGroups() : null,
	            makeHeaders(),
	            hasFilters ? makeFilters() : null,
	            _react2.default.createElement(
	              TbodyComponent,
	              _extends({
	                className: (0, _classnames2.default)(tBodyProps.className),
	                style: _extends({}, tBodyProps.style, {
	                  minWidth: rowMinWidth + 'px'
	                })
	              }, tBodyProps.rest),
	              pageRows.map(function (d, i) {
	                return makePageRow(d, i);
	              }),
	              padRows.map(makePadRow)
	            ),
	            hasColumnFooter ? makeColumnFooters() : null
	          ),
	          showPagination && showPaginationBottom ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-bottom' },
	            makePagination(false)
	          ) : null,
	          !pageRows.length && _react2.default.createElement(
	            NoDataComponent,
	            noDataProps,
	            _utils2.default.normalizeComponent(noDataText)
	          ),
	          _react2.default.createElement(LoadingComponent, _extends({ loading: loading, loadingText: loadingText }, loadingProps))
	        );
	      };
	
	      // childProps are optionally passed to a function-as-a-child
	      return children ? children(finalState, makeTable, this) : makeTable();
	    }
	  }]);
	
	  return ReactTable;
	}((0, _methods2.default)((0, _lifecycle2.default)(_react.Component)));
	
	ReactTable.propTypes = _propTypes2.default;
	ReactTable.defaultProps = _defaultProps2.default;
	exports.default = ReactTable;
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIs = __webpack_require__(64);
	
	var ReactIs = _interopRequireWildcard(_reactIs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	//
	exports.default = {
	  get: get,
	  set: set,
	  takeRight: takeRight,
	  last: last,
	  orderBy: orderBy,
	  range: range,
	  remove: remove,
	  clone: clone,
	  getFirstDefined: getFirstDefined,
	  sum: sum,
	  makeTemplateComponent: makeTemplateComponent,
	  groupBy: groupBy,
	  isArray: isArray,
	  splitProps: splitProps,
	  compactObject: compactObject,
	  isSortingDesc: isSortingDesc,
	  normalizeComponent: normalizeComponent,
	  asPx: asPx
	};
	
	
	function get(obj, path, def) {
	  if (!path) {
	    return obj;
	  }
	  var pathObj = makePathArray(path);
	  var val = void 0;
	  try {
	    val = pathObj.reduce(function (current, pathPart) {
	      return current[pathPart];
	    }, obj);
	  } catch (e) {
	    // continue regardless of error
	  }
	  return typeof val !== 'undefined' ? val : def;
	}
	
	function set() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var path = arguments[1];
	  var value = arguments[2];
	
	  var keys = makePathArray(path);
	  var keyPart = void 0;
	  var cursor = obj;
	  while ((keyPart = keys.shift()) && keys.length) {
	    if (!cursor[keyPart]) {
	      cursor[keyPart] = {};
	    }
	    cursor = cursor[keyPart];
	  }
	  cursor[keyPart] = value;
	  return obj;
	}
	
	function takeRight(arr, n) {
	  var start = n > arr.length ? 0 : arr.length - n;
	  return arr.slice(start);
	}
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function range(n) {
	  var arr = [];
	  for (var i = 0; i < n; i += 1) {
	    arr.push(n);
	  }
	  return arr;
	}
	
	function orderBy(arr, funcs, dirs, indexKey) {
	  return arr.sort(function (rowA, rowB) {
	    for (var i = 0; i < funcs.length; i += 1) {
	      var comp = funcs[i];
	      var desc = dirs[i] === false || dirs[i] === 'desc';
	      var sortInt = comp(rowA, rowB);
	      if (sortInt) {
	        return desc ? -sortInt : sortInt;
	      }
	    }
	    // Use the row index for tie breakers
	    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
	  });
	}
	
	function remove(a, b) {
	  return a.filter(function (o, i) {
	    var r = b(o);
	    if (r) {
	      a.splice(i, 1);
	      return true;
	    }
	    return false;
	  });
	}
	
	function clone(a) {
	  try {
	    return JSON.parse(JSON.stringify(a, function (key, value) {
	      if (typeof value === 'function') {
	        return value.toString();
	      }
	      return value;
	    }));
	  } catch (e) {
	    return a;
	  }
	}
	
	function getFirstDefined() {
	  for (var i = 0; i < arguments.length; i += 1) {
	    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
	      return arguments.length <= i ? undefined : arguments[i];
	    }
	  }
	}
	
	function sum(arr) {
	  return arr.reduce(function (a, b) {
	    return a + b;
	  }, 0);
	}
	
	function makeTemplateComponent(compClass, displayName) {
	  if (!displayName) {
	    throw new Error('No displayName found for template component:', compClass);
	  }
	  var cmp = function cmp(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)(compClass, className) }, rest),
	      children
	    );
	  };
	  cmp.displayName = displayName;
	  return cmp;
	}
	
	function groupBy(xs, key) {
	  return xs.reduce(function (rv, x, i) {
	    var resKey = typeof key === 'function' ? key(x, i) : x[key];
	    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
	    rv[resKey].push(x);
	    return rv;
	  }, {});
	}
	
	function asPx(value) {
	  value = Number(value);
	  return Number.isNaN(value) ? null : value + 'px';
	}
	
	function isArray(a) {
	  return Array.isArray(a);
	}
	
	// ########################################################################
	// Non-exported Helpers
	// ########################################################################
	
	function makePathArray(obj) {
	  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
	}
	
	function flattenDeep(arr) {
	  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (!isArray(arr)) {
	    newArr.push(arr);
	  } else {
	    for (var i = 0; i < arr.length; i += 1) {
	      flattenDeep(arr[i], newArr);
	    }
	  }
	  return newArr;
	}
	
	function splitProps(_ref2) {
	  var className = _ref2.className,
	      style = _ref2.style,
	      rest = _objectWithoutProperties(_ref2, ['className', 'style']);
	
	  return {
	    className: className,
	    style: style,
	    rest: rest || {}
	  };
	}
	
	function compactObject(obj) {
	  var newObj = {};
	  if (obj) {
	    Object.keys(obj).map(function (key) {
	      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
	        newObj[key] = obj[key];
	      }
	      return true;
	    });
	  }
	  return newObj;
	}
	
	function isSortingDesc(d) {
	  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
	}
	
	function normalizeComponent(Comp, props) {
	  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
	
	  if (ReactIs.isElement(Comp) || typeof Comp === 'string') {
	    return Comp;
	  } else if (ReactIs.isValidElementType(Comp)) {
	    return _react2.default.createElement(Comp, props);
	  }
	
	  return fallback;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      var defaultState = {
	        page: props.defaultPage,
	        pageSize: props.defaultPageSize,
	        sorted: props.defaultSorted,
	        expanded: props.defaultExpanded,
	        filtered: props.defaultFiltered,
	        resized: props.defaultResized,
	        currentlyResizing: false,
	        skipNextSort: false
	      };
	      var resolvedState = _this.getResolvedState(props, defaultState);
	      var dataModel = _this.getDataModel(resolvedState, true);
	
	      _this.state = _this.calculateNewResolvedState(dataModel);
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.fireFetchData();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var oldState = this.getResolvedState(prevProps, prevState);
	        var newState = this.getResolvedState(this.props, this.state);
	
	        // Do a deep compare of new and old `defaultOption` and
	        // if they are different reset `option = defaultOption`
	        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
	        defaultableOptions.forEach(function (x) {
	          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
	          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
	            newState[x] = newState[defaultName];
	          }
	        });
	
	        // If they change these table options, we need to reset defaults
	        // or else we could get into a state where the user has changed the UI
	        // and then disabled the ability to change it back.
	        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
	        var resettableOptions = ['sortable', 'filterable', 'resizable'];
	        resettableOptions.forEach(function (x) {
	          if (oldState[x] !== newState[x]) {
	            var baseName = x.replace('able', '');
	            var optionName = baseName + 'ed';
	            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
	            newState[optionName] = newState[defaultName];
	          }
	        });
	
	        // Props that trigger a data update
	        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
	          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
	        }
	      }
	    }, {
	      key: 'calculateNewResolvedState',
	      value: function calculateNewResolvedState(dataModel) {
	        var oldState = this.getResolvedState();
	        var newResolvedState = this.getResolvedState({}, dataModel);
	        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;
	
	        // Default to unfrozen state
	
	        newResolvedState.frozen = false;
	
	        // If freezeWhenExpanded is set, check for frozen conditions
	        if (freezeWhenExpanded) {
	          // if any rows are expanded, freeze the existing data and sorting
	          var keys = Object.keys(newResolvedState.expanded);
	          for (var i = 0; i < keys.length; i += 1) {
	            if (newResolvedState.expanded[keys[i]]) {
	              newResolvedState.frozen = true;
	              break;
	            }
	          }
	        }
	
	        // If the data isn't frozen and either the data or
	        // sorting model has changed, update the data
	        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
	          // Handle collapseOnsortedChange & collapseOnDataChange
	          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
	            newResolvedState.expanded = {};
	          }
	
	          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
	        }
	
	        // Set page to 0 if filters change
	        if (oldState.filtered !== newResolvedState.filtered) {
	          newResolvedState.page = 0;
	        }
	
	        // Calculate pageSize all the time
	        if (newResolvedState.sortedData) {
	          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
	          newResolvedState.page = newResolvedState.manual ? newResolvedState.page : Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
	        }
	
	        return newResolvedState;
	      }
	    }, {
	      key: 'setStateWithData',
	      value: function setStateWithData(dataModel, cb) {
	        var _this2 = this;
	
	        var oldState = this.getResolvedState();
	        var newResolvedState = this.calculateNewResolvedState(dataModel);
	
	        return this.setState(newResolvedState, function () {
	          if (cb) {
	            cb();
	          }
	          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
	            _this2.fireFetchData();
	          }
	        });
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(1913);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'getResolvedState',
	      value: function getResolvedState(props, state) {
	        var resolvedState = _extends({}, _utils2.default.compactObject(this.state), _utils2.default.compactObject(this.props), _utils2.default.compactObject(state), _utils2.default.compactObject(props));
	        return resolvedState;
	      }
	    }, {
	      key: 'getDataModel',
	      value: function getDataModel(newState, dataChanged) {
	        var _this2 = this;
	
	        var columns = newState.columns,
	            _newState$pivotBy = newState.pivotBy,
	            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
	            data = newState.data,
	            resolveData = newState.resolveData,
	            pivotIDKey = newState.pivotIDKey,
	            pivotValKey = newState.pivotValKey,
	            subRowsKey = newState.subRowsKey,
	            aggregatedKey = newState.aggregatedKey,
	            nestingLevelKey = newState.nestingLevelKey,
	            originalKey = newState.originalKey,
	            indexKey = newState.indexKey,
	            groupedByPivotKey = newState.groupedByPivotKey,
	            SubComponent = newState.SubComponent;
	
	        // Determine Header Groups
	
	        var hasHeaderGroups = false;
	        columns.forEach(function (column) {
	          if (column.columns) {
	            hasHeaderGroups = true;
	          }
	        });
	
	        var columnsWithExpander = [].concat(_toConsumableArray(columns));
	
	        var expanderColumn = columns.find(function (col) {
	          return col.expander || col.columns && col.columns.some(function (col2) {
	            return col2.expander;
	          });
	        });
	        // The actual expander might be in the columns field of a group column
	        if (expanderColumn && !expanderColumn.expander) {
	          expanderColumn = expanderColumn.columns.find(function (col) {
	            return col.expander;
	          });
	        }
	
	        // If we have SubComponent's we need to make sure we have an expander column
	        if (SubComponent && !expanderColumn) {
	          expanderColumn = { expander: true };
	          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
	        }
	
	        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
	          var dcol = void 0;
	          if (column.expander) {
	            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
	          } else {
	            dcol = _extends({}, _this2.props.column, column);
	          }
	
	          // Ensure minWidth is not greater than maxWidth if set
	          if (dcol.maxWidth < dcol.minWidth) {
	            dcol.minWidth = dcol.maxWidth;
	          }
	
	          if (parentColumn) {
	            dcol.parentColumn = parentColumn;
	          }
	
	          // First check for string accessor
	          if (typeof dcol.accessor === 'string') {
	            dcol.id = dcol.id || dcol.accessor;
	            var accessorString = dcol.accessor;
	            dcol.accessor = function (row) {
	              return _utils2.default.get(row, accessorString);
	            };
	            return dcol;
	          }
	
	          // Fall back to functional accessor (but require an ID)
	          if (dcol.accessor && !dcol.id) {
	            console.warn(dcol);
	            throw new Error('A column id is required if using a non-string accessor for column above.');
	          }
	
	          // Fall back to an undefined accessor
	          if (!dcol.accessor) {
	            dcol.accessor = function () {
	              return undefined;
	            };
	          }
	
	          return dcol;
	        };
	
	        var allDecoratedColumns = [];
	
	        // Decorate the columns
	        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
	          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
	          allDecoratedColumns.push(decoratedColumn);
	          return decoratedColumn;
	        };
	
	        var decoratedColumns = columnsWithExpander.map(function (column) {
	          if (column.columns) {
	            return _extends({}, column, {
	              columns: column.columns.map(function (d) {
	                return decorateAndAddToAll(d, column);
	              })
	            });
	          }
	          return decorateAndAddToAll(column);
	        });
	
	        // Build the visible columns, headers and flat column list
	        var visibleColumns = decoratedColumns.slice();
	        var allVisibleColumns = [];
	
	        visibleColumns = visibleColumns.map(function (column) {
	          if (column.columns) {
	            var visibleSubColumns = column.columns.filter(function (d) {
	              return pivotBy.indexOf(d.id) > -1 ? false : _utils2.default.getFirstDefined(d.show, true);
	            });
	            return _extends({}, column, {
	              columns: visibleSubColumns
	            });
	          }
	          return column;
	        });
	
	        visibleColumns = visibleColumns.filter(function (column) {
	          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : _utils2.default.getFirstDefined(column.show, true);
	        });
	
	        // Find any custom pivot location
	        var pivotIndex = visibleColumns.findIndex(function (col) {
	          return col.pivot;
	        });
	
	        // Handle Pivot Columns
	        if (pivotBy.length) {
	          // Retrieve the pivot columns in the correct pivot order
	          var pivotColumns = [];
	          pivotBy.forEach(function (pivotID) {
	            var found = allDecoratedColumns.find(function (d) {
	              return d.id === pivotID;
	            });
	            if (found) {
	              pivotColumns.push(found);
	            }
	          });
	
	          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
	            return prev && prev === current.parentColumn && current.parentColumn;
	          }, pivotColumns[0].parentColumn);
	
	          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
	          PivotGroupHeader = PivotGroupHeader || function () {
	            return _react2.default.createElement(
	              'strong',
	              null,
	              'Pivoted'
	            );
	          };
	
	          var pivotColumnGroup = {
	            Header: PivotGroupHeader,
	            columns: pivotColumns.map(function (col) {
	              return _extends({}, _this2.props.pivotDefaults, col, {
	                pivoted: true
	              });
	            })
	
	            // Place the pivotColumns back into the visibleColumns
	          };if (pivotIndex >= 0) {
	            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
	            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
	          } else {
	            visibleColumns.unshift(pivotColumnGroup);
	          }
	        }
	
	        // Build Header Groups
	        var headerGroups = [];
	        var currentSpan = [];
	
	        // A convenience function to add a header and reset the currentSpan
	        var addHeader = function addHeader(columns, column) {
	          headerGroups.push(_extends({}, _this2.props.column, column, {
	            columns: columns
	          }));
	          currentSpan = [];
	        };
	
	        // Build flast list of allVisibleColumns and HeaderGroups
	        visibleColumns.forEach(function (column) {
	          if (column.columns) {
	            allVisibleColumns = allVisibleColumns.concat(column.columns);
	            if (currentSpan.length > 0) {
	              addHeader(currentSpan);
	            }
	            addHeader(column.columns, column);
	            return;
	          }
	          allVisibleColumns.push(column);
	          currentSpan.push(column);
	        });
	        if (hasHeaderGroups && currentSpan.length > 0) {
	          addHeader(currentSpan);
	        }
	
	        // Access the data
	        var accessRow = function accessRow(d, i) {
	          var _row;
	
	          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
	          allDecoratedColumns.forEach(function (column) {
	            if (column.expander) return;
	            row[column.id] = column.accessor(d);
	          });
	          if (row[subRowsKey]) {
	            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
	              return accessRow(d, i, level + 1);
	            });
	          }
	          return row;
	        };
	
	        // // If the data hasn't changed, just use the cached data
	        var resolvedData = this.resolvedData;
	        // If the data has changed, run the data resolver and cache the result
	        if (!this.resolvedData || dataChanged) {
	          resolvedData = resolveData(data);
	          this.resolvedData = resolvedData;
	        }
	        // Use the resolved data
	        resolvedData = resolvedData.map(function (d, i) {
	          return accessRow(d, i);
	        });
	
	        // TODO: Make it possible to fabricate nested rows without pivoting
	        var aggregatingColumns = allVisibleColumns.filter(function (d) {
	          return !d.expander && d.aggregate;
	        });
	
	        // If pivoting, recursively group the data
	        var aggregate = function aggregate(rows) {
	          var aggregationValues = {};
	          aggregatingColumns.forEach(function (column) {
	            var values = rows.map(function (d) {
	              return d[column.id];
	            });
	            aggregationValues[column.id] = column.aggregate(values, rows);
	          });
	          return aggregationValues;
	        };
	        if (pivotBy.length) {
	          var groupRecursively = function groupRecursively(rows, keys) {
	            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            // This is the last level, just return the rows
	            if (i === keys.length) {
	              return rows;
	            }
	            // Group the rows together for this level
	            var groupedRows = Object.entries(_utils2.default.groupBy(rows, keys[i])).map(function (_ref) {
	              var _ref3;
	
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];
	
	              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
	            });
	            // Recurse into the subRows
	            groupedRows = groupedRows.map(function (rowGroup) {
	              var _extends2;
	
	              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
	              return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
	            });
	            return groupedRows;
	          };
	          resolvedData = groupRecursively(resolvedData, pivotBy);
	        }
	
	        return _extends({}, newState, {
	          resolvedData: resolvedData,
	          allVisibleColumns: allVisibleColumns,
	          headerGroups: headerGroups,
	          allDecoratedColumns: allDecoratedColumns,
	          hasHeaderGroups: hasHeaderGroups
	        });
	      }
	    }, {
	      key: 'getSortedData',
	      value: function getSortedData(resolvedState) {
	        var manual = resolvedState.manual,
	            sorted = resolvedState.sorted,
	            filtered = resolvedState.filtered,
	            defaultFilterMethod = resolvedState.defaultFilterMethod,
	            resolvedData = resolvedState.resolvedData,
	            allDecoratedColumns = resolvedState.allDecoratedColumns;
	
	
	        var sortMethodsByColumnID = {};
	
	        allDecoratedColumns.filter(function (col) {
	          return col.sortMethod;
	        }).forEach(function (col) {
	          sortMethodsByColumnID[col.id] = col.sortMethod;
	        });
	
	        // Resolve the data from either manual data or sorted data
	        return {
	          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allDecoratedColumns), sorted, sortMethodsByColumnID)
	        };
	      }
	    }, {
	      key: 'fireFetchData',
	      value: function fireFetchData() {
	        // determine the current state, preferring certain state values over props
	        var currentState = _extends({}, this.getResolvedState(), {
	          page: this.getStateOrProp('page'),
	          pageSize: this.getStateOrProp('pageSize'),
	          filtered: this.getStateOrProp('filtered')
	        });
	
	        this.props.onFetchData(currentState, this);
	      }
	    }, {
	      key: 'getPropOrState',
	      value: function getPropOrState(key) {
	        return _utils2.default.getFirstDefined(this.props[key], this.state[key]);
	      }
	    }, {
	      key: 'getStateOrProp',
	      value: function getStateOrProp(key) {
	        return _utils2.default.getFirstDefined(this.state[key], this.props[key]);
	      }
	    }, {
	      key: 'filterData',
	      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
	        var _this3 = this;
	
	        var filteredData = data;
	
	        if (filtered.length) {
	          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
	            var column = allVisibleColumns.find(function (x) {
	              return x.id === nextFilter.id;
	            });
	
	            // Don't filter hidden columns or columns that have had their filters disabled
	            if (!column || column.filterable === false) {
	              return filteredSoFar;
	            }
	
	            var filterMethod = column.filterMethod || defaultFilterMethod;
	
	            // If 'filterAll' is set to true, pass the entire dataset to the filter method
	            if (column.filterAll) {
	              return filterMethod(nextFilter, filteredSoFar, column);
	            }
	            return filteredSoFar.filter(function (row) {
	              return filterMethod(nextFilter, row, column);
	            });
	          }, filteredData);
	
	          // Apply the filter to the subrows if we are pivoting, and then
	          // filter any rows without subcolumns because it would be strange to show
	          filteredData = filteredData.map(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return row;
	            }
	            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
	          }).filter(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return true;
	            }
	            return row[_this3.props.subRowsKey].length > 0;
	          });
	        }
	
	        return filteredData;
	      }
	    }, {
	      key: 'sortData',
	      value: function sortData(data, sorted) {
	        var _this4 = this;
	
	        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        if (!sorted.length) {
	          return data;
	        }
	
	        var sortedData = (this.props.orderByMethod || _utils2.default.orderBy)(data, sorted.map(function (sort) {
	          // Support custom sorting methods for each column
	          if (sortMethodsByColumnID[sort.id]) {
	            return function (a, b) {
	              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
	            };
	          }
	          return function (a, b) {
	            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
	          };
	        }), sorted.map(function (d) {
	          return !d.desc;
	        }), this.props.indexKey);
	
	        sortedData.forEach(function (row) {
	          if (!row[_this4.props.subRowsKey]) {
	            return;
	          }
	          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
	        });
	
	        return sortedData;
	      }
	    }, {
	      key: 'getMinRows',
	      value: function getMinRows() {
	        return _utils2.default.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
	      }
	
	      // User actions
	
	    }, {
	      key: 'onPageChange',
	      value: function onPageChange(page) {
	        var _props = this.props,
	            onPageChange = _props.onPageChange,
	            collapseOnPageChange = _props.collapseOnPageChange;
	
	
	        var newState = { page: page };
	        if (collapseOnPageChange) {
	          newState.expanded = {};
	        }
	        this.setStateWithData(newState, function () {
	          return onPageChange && onPageChange(page);
	        });
	      }
	    }, {
	      key: 'onPageSizeChange',
	      value: function onPageSizeChange(newPageSize) {
	        var onPageSizeChange = this.props.onPageSizeChange;
	
	        var _getResolvedState = this.getResolvedState(),
	            pageSize = _getResolvedState.pageSize,
	            page = _getResolvedState.page;
	
	        // Normalize the page to display
	
	
	        var currentRow = pageSize * page;
	        var newPage = Math.floor(currentRow / newPageSize);
	
	        this.setStateWithData({
	          pageSize: newPageSize,
	          page: newPage
	        }, function () {
	          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
	        });
	      }
	    }, {
	      key: 'sortColumn',
	      value: function sortColumn(column, additive) {
	        var _getResolvedState2 = this.getResolvedState(),
	            sorted = _getResolvedState2.sorted,
	            skipNextSort = _getResolvedState2.skipNextSort,
	            defaultSortDesc = _getResolvedState2.defaultSortDesc;
	
	        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
	        var secondSortDirection = !firstSortDirection;
	
	        // we can't stop event propagation from the column resize move handlers
	        // attached to the document because of react's synthetic events
	        // so we have to prevent the sort function from actually sorting
	        // if we click on the column resize element within a header.
	        if (skipNextSort) {
	          this.setStateWithData({
	            skipNextSort: false
	          });
	          return;
	        }
	
	        var onSortedChange = this.props.onSortedChange;
	
	
	        var newSorted = _utils2.default.clone(sorted || []).map(function (d) {
	          d.desc = _utils2.default.isSortingDesc(d);
	          return d;
	        });
	        if (!_utils2.default.isArray(column)) {
	          // Single-Sort
	          var existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column.id;
	          });
	          if (existingIndex > -1) {
	            var existing = newSorted[existingIndex];
	            if (existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(existingIndex, 1);
	              } else {
	                existing.desc = firstSortDirection;
	                newSorted = [existing];
	              }
	            } else {
	              existing.desc = secondSortDirection;
	              if (!additive) {
	                newSorted = [existing];
	              }
	            }
	          } else if (additive) {
	            newSorted.push({
	              id: column.id,
	              desc: firstSortDirection
	            });
	          } else {
	            newSorted = [{
	              id: column.id,
	              desc: firstSortDirection
	            }];
	          }
	        } else {
	          // Multi-Sort
	          var _existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column[0].id;
	          });
	          // Existing Sorted Column
	          if (_existingIndex > -1) {
	            var _existing = newSorted[_existingIndex];
	            if (_existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(_existingIndex, column.length);
	              } else {
	                column.forEach(function (d, i) {
	                  newSorted[_existingIndex + i].desc = firstSortDirection;
	                });
	              }
	            } else {
	              column.forEach(function (d, i) {
	                newSorted[_existingIndex + i].desc = secondSortDirection;
	              });
	            }
	            if (!additive) {
	              newSorted = newSorted.slice(_existingIndex, column.length);
	            }
	            // New Sort Column
	          } else if (additive) {
	            newSorted = newSorted.concat(column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            }));
	          } else {
	            newSorted = column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            });
	          }
	        }
	
	        this.setStateWithData({
	          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
	          sorted: newSorted
	        }, function () {
	          return onSortedChange && onSortedChange(newSorted, column, additive);
	        });
	      }
	    }, {
	      key: 'filterColumn',
	      value: function filterColumn(column, value) {
	        var _getResolvedState3 = this.getResolvedState(),
	            filtered = _getResolvedState3.filtered;
	
	        var onFilteredChange = this.props.onFilteredChange;
	
	        // Remove old filter first if it exists
	
	        var newFiltering = (filtered || []).filter(function (x) {
	          return x.id !== column.id;
	        });
	
	        if (value !== '') {
	          newFiltering.push({
	            id: column.id,
	            value: value
	          });
	        }
	
	        this.setStateWithData({
	          filtered: newFiltering
	        }, function () {
	          return onFilteredChange && onFilteredChange(newFiltering, column, value);
	        });
	      }
	    }, {
	      key: 'resizeColumnStart',
	      value: function resizeColumnStart(event, column, isTouch) {
	        var _this5 = this;
	
	        event.stopPropagation();
	        var parentWidth = event.target.parentElement.getBoundingClientRect().width;
	
	        var pageX = void 0;
	        if (isTouch) {
	          pageX = event.changedTouches[0].pageX;
	        } else {
	          pageX = event.pageX;
	        }
	
	        this.trapEvents = true;
	        this.setStateWithData({
	          currentlyResizing: {
	            id: column.id,
	            startX: pageX,
	            parentWidth: parentWidth
	          }
	        }, function () {
	          if (isTouch) {
	            document.addEventListener('touchmove', _this5.resizeColumnMoving);
	            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
	            document.addEventListener('touchend', _this5.resizeColumnEnd);
	          } else {
	            document.addEventListener('mousemove', _this5.resizeColumnMoving);
	            document.addEventListener('mouseup', _this5.resizeColumnEnd);
	            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
	          }
	        });
	      }
	    }, {
	      key: 'resizeColumnMoving',
	      value: function resizeColumnMoving(event) {
	        event.stopPropagation();
	        var _props2 = this.props,
	            onResizedChange = _props2.onResizedChange,
	            column = _props2.column;
	
	        var _getResolvedState4 = this.getResolvedState(),
	            resized = _getResolvedState4.resized,
	            currentlyResizing = _getResolvedState4.currentlyResizing,
	            columns = _getResolvedState4.columns;
	
	        var currentColumn = columns.find(function (c) {
	          return c.accessor === currentlyResizing.id || c.id === currentlyResizing.id;
	        });
	        var minResizeWidth = currentColumn && currentColumn.minResizeWidth != null ? currentColumn.minResizeWidth : column.minResizeWidth;
	
	        // Delete old value
	        var newResized = resized.filter(function (x) {
	          return x.id !== currentlyResizing.id;
	        });
	
	        var pageX = void 0;
	
	        if (event.type === 'touchmove') {
	          pageX = event.changedTouches[0].pageX;
	        } else if (event.type === 'mousemove') {
	          pageX = event.pageX;
	        }
	
	        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, minResizeWidth);
	
	        newResized.push({
	          id: currentlyResizing.id,
	          value: newWidth
	        });
	
	        this.setStateWithData({
	          resized: newResized
	        }, function () {
	          return onResizedChange && onResizedChange(newResized, event);
	        });
	      }
	    }, {
	      key: 'resizeColumnEnd',
	      value: function resizeColumnEnd(event) {
	        event.stopPropagation();
	        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';
	
	        if (isTouch) {
	          document.removeEventListener('touchmove', this.resizeColumnMoving);
	          document.removeEventListener('touchcancel', this.resizeColumnEnd);
	          document.removeEventListener('touchend', this.resizeColumnEnd);
	        }
	
	        // If its a touch event clear the mouse one's as well because sometimes
	        // the mouseDown event gets called as well, but the mouseUp event doesn't
	        document.removeEventListener('mousemove', this.resizeColumnMoving);
	        document.removeEventListener('mouseup', this.resizeColumnEnd);
	        document.removeEventListener('mouseleave', this.resizeColumnEnd);
	
	        // The touch events don't propagate up to the sorting's onMouseDown event so
	        // no need to prevent it from happening or else the first click after a touch
	        // event resize will not sort the column.
	        if (!isTouch) {
	          this.setStateWithData({
	            skipNextSort: true,
	            currentlyResizing: false
	          });
	        }
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(1913);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _pagination = __webpack_require__(1917);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	//
	
	
	var emptyObj = function emptyObj() {
	  return {};
	};
	
	exports.default = {
	  // General
	  data: [],
	  resolveData: function resolveData(data) {
	    return data;
	  },
	  loading: false,
	  showPagination: true,
	  showPaginationTop: false,
	  showPaginationBottom: true,
	  showPageSizeOptions: true,
	  pageSizeOptions: [5, 10, 20, 25, 50, 100],
	  defaultPage: 0,
	  defaultPageSize: 20,
	  showPageJump: true,
	  collapseOnSortingChange: true,
	  collapseOnPageChange: true,
	  collapseOnDataChange: true,
	  freezeWhenExpanded: false,
	  sortable: true,
	  multiSort: true,
	  resizable: true,
	  filterable: false,
	  defaultSortDesc: false,
	  defaultSorted: [],
	  defaultFiltered: [],
	  defaultResized: [],
	  defaultExpanded: {},
	  // eslint-disable-next-line no-unused-vars
	  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
	    var id = filter.pivotId || filter.id;
	    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
	  },
	  // eslint-disable-next-line no-unused-vars
	  defaultSortMethod: function defaultSortMethod(a, b, desc) {
	    // force null and undefined to the bottom
	    a = a === null || a === undefined ? '' : a;
	    b = b === null || b === undefined ? '' : b;
	    // force any string values to lowercase
	    a = typeof a === 'string' ? a.toLowerCase() : a;
	    b = typeof b === 'string' ? b.toLowerCase() : b;
	    // Return either 1 or -1 to indicate a sort priority
	    if (a > b) {
	      return 1;
	    }
	    if (a < b) {
	      return -1;
	    }
	    // returning 0, undefined or any falsey value will use subsequent sorts or
	    // the index as a tiebreaker
	    return 0;
	  },
	
	  // Controlled State Props
	  // page: undefined,
	  // pageSize: undefined,
	  // sorted: [],
	  // filtered: [],
	  // resized: [],
	  // expanded: {},
	
	  // Controlled State Callbacks
	  onPageChange: undefined,
	  onPageSizeChange: undefined,
	  onSortedChange: undefined,
	  onFilteredChange: undefined,
	  onResizedChange: undefined,
	  onExpandedChange: undefined,
	
	  // Pivoting
	  pivotBy: undefined,
	
	  // Key Constants
	  pivotValKey: '_pivotVal',
	  pivotIDKey: '_pivotID',
	  subRowsKey: '_subRows',
	  aggregatedKey: '_aggregated',
	  nestingLevelKey: '_nestingLevel',
	  originalKey: '_original',
	  indexKey: '_index',
	  groupedByPivotKey: '_groupedByPivot',
	
	  // Server-side Callbacks
	  onFetchData: function onFetchData() {
	    return null;
	  },
	
	  // Classes
	  className: '',
	  style: {},
	
	  // Component decorators
	  getProps: emptyObj,
	  getTableProps: emptyObj,
	  getTheadGroupProps: emptyObj,
	  getTheadGroupTrProps: emptyObj,
	  getTheadGroupThProps: emptyObj,
	  getTheadProps: emptyObj,
	  getTheadTrProps: emptyObj,
	  getTheadThProps: emptyObj,
	  getTheadFilterProps: emptyObj,
	  getTheadFilterTrProps: emptyObj,
	  getTheadFilterThProps: emptyObj,
	  getTbodyProps: emptyObj,
	  getTrGroupProps: emptyObj,
	  getTrProps: emptyObj,
	  getTdProps: emptyObj,
	  getTfootProps: emptyObj,
	  getTfootTrProps: emptyObj,
	  getTfootTdProps: emptyObj,
	  getPaginationProps: emptyObj,
	  getLoadingProps: emptyObj,
	  getNoDataProps: emptyObj,
	  getResizerProps: emptyObj,
	
	  // Global Column Defaults
	  column: {
	    // Renderers
	    Cell: undefined,
	    Header: undefined,
	    Footer: undefined,
	    Aggregated: undefined,
	    Pivot: undefined,
	    PivotValue: undefined,
	    Expander: undefined,
	    Filter: undefined,
	    Placeholder: undefined,
	    // All Columns
	    sortable: undefined, // use table default
	    resizable: undefined, // use table default
	    filterable: undefined, // use table default
	    show: true,
	    minWidth: 100,
	    minResizeWidth: 11,
	    // Cells only
	    className: '',
	    style: {},
	    getProps: emptyObj,
	    // Pivot only
	    aggregate: undefined,
	    // Headers only
	    headerClassName: '',
	    headerStyle: {},
	    getHeaderProps: emptyObj,
	    // Footers only
	    footerClassName: '',
	    footerStyle: {},
	    getFooterProps: emptyObj,
	    filterMethod: undefined,
	    filterAll: false,
	    sortMethod: undefined
	  },
	
	  // Global Expander Column Defaults
	  expanderDefaults: {
	    sortable: false,
	    resizable: false,
	    filterable: false,
	    width: 35
	  },
	
	  pivotDefaults: {
	    // extend the defaults for pivoted columns here
	  },
	
	  // Text
	  previousText: 'Previous',
	  nextText: 'Next',
	  loadingText: 'Loading...',
	  noDataText: 'No rows found',
	  pageText: 'Page',
	  ofText: 'of',
	  rowsText: 'rows',
	  pageJumpText: 'jump to page',
	  rowsSelectorText: 'rows per page',
	
	  // Components
	  TableComponent: function TableComponent(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        className: (0, _classnames2.default)('rt-table', className),
	        role: 'grid'
	        // tabIndex='0'
	      }, rest),
	      children
	    );
	  },
	  TheadComponent: _utils2.default.makeTemplateComponent('rt-thead', 'Thead'),
	  TbodyComponent: _utils2.default.makeTemplateComponent('rt-tbody', 'Tbody'),
	  TrGroupComponent: function TrGroupComponent(_ref2) {
	    var children = _ref2.children,
	        className = _ref2.className,
	        rest = _objectWithoutProperties(_ref2, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr-group', className), role: 'rowgroup' }, rest),
	      children
	    );
	  },
	  TrComponent: function TrComponent(_ref3) {
	    var children = _ref3.children,
	        className = _ref3.className,
	        rest = _objectWithoutProperties(_ref3, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr', className), role: 'row' }, rest),
	      children
	    );
	  },
	  ThComponent: function ThComponent(_ref4) {
	    var toggleSort = _ref4.toggleSort,
	        className = _ref4.className,
	        children = _ref4.children,
	        rest = _objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);
	
	    return (
	      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
	      _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('rt-th', className),
	          onClick: function onClick(e) {
	            return toggleSort && toggleSort(e);
	          },
	          role: 'columnheader',
	          tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
	        }, rest),
	        children
	      )
	    );
	  },
	  TdComponent: function TdComponent(_ref5) {
	    var toggleSort = _ref5.toggleSort,
	        className = _ref5.className,
	        children = _ref5.children,
	        rest = _objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-td', className), role: 'gridcell' }, rest),
	      children
	    );
	  },
	  TfootComponent: _utils2.default.makeTemplateComponent('rt-tfoot', 'Tfoot'),
	  FilterComponent: function FilterComponent(_ref6) {
	    var filter = _ref6.filter,
	        _onChange = _ref6.onChange,
	        column = _ref6.column;
	    return _react2.default.createElement('input', {
	      type: 'text',
	      style: {
	        width: '100%'
	      },
	      placeholder: column.Placeholder,
	      value: filter ? filter.value : '',
	      onChange: function onChange(event) {
	        return _onChange(event.target.value);
	      }
	    });
	  },
	  ExpanderComponent: function ExpanderComponent(_ref7) {
	    var isExpanded = _ref7.isExpanded;
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('rt-expander', isExpanded && '-open') },
	      '\u2022'
	    );
	  },
	  PivotValueComponent: function PivotValueComponent(_ref8) {
	    var subRows = _ref8.subRows,
	        value = _ref8.value;
	    return _react2.default.createElement(
	      'span',
	      null,
	      value,
	      ' ',
	      subRows && '(' + subRows.length + ')'
	    );
	  },
	  AggregatedComponent: function AggregatedComponent(_ref9) {
	    var subRows = _ref9.subRows,
	        column = _ref9.column;
	
	    var previewValues = subRows.filter(function (d) {
	      return typeof d[column.id] !== 'undefined';
	    }).map(function (row, i) {
	      return (
	        // eslint-disable-next-line react/no-array-index-key
	        _react2.default.createElement(
	          'span',
	          { key: i },
	          row[column.id],
	          i < subRows.length - 1 ? ', ' : ''
	        )
	      );
	    });
	    return _react2.default.createElement(
	      'span',
	      null,
	      previewValues
	    );
	  },
	  PivotComponent: undefined, // this is a computed default generated using
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _pagination2.default,
	  PreviousComponent: undefined,
	  NextComponent: undefined,
	  LoadingComponent: function LoadingComponent(_ref10) {
	    var className = _ref10.className,
	        loading = _ref10.loading,
	        loadingText = _ref10.loadingText,
	        rest = _objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('-loading', { '-active': loading }, className) }, rest),
	      _react2.default.createElement(
	        'div',
	        { className: '-loading-inner' },
	        loadingText
	      )
	    );
	  },
	  NoDataComponent: _utils2.default.makeTemplateComponent('rt-noData', 'NoData'),
	  ResizerComponent: _utils2.default.makeTemplateComponent('rt-resizer', 'Resizer'),
	  PadRowComponent: function PadRowComponent() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      '\xA0'
	    );
	  }
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(420);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultButton = function defaultButton(props) {
	  return _react2.default.createElement(
	    'button',
	    _extends({ type: 'button' }, props, { className: '-btn' }),
	    props.children
	  );
	};
	
	var ReactTablePagination = function (_Component) {
	  _inherits(ReactTablePagination, _Component);
	
	  function ReactTablePagination(props) {
	    _classCallCheck(this, ReactTablePagination);
	
	    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this, props));
	
	    _this.getSafePage = _this.getSafePage.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.applyPage = _this.applyPage.bind(_this);
	
	    _this.state = {
	      page: props.page
	    };
	    return _this;
	  }
	
	  _createClass(ReactTablePagination, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.page !== this.props.page && prevState.page !== this.state.page) {
	        // this is probably safe because we only update when old/new state.page are different
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          page: this.props.page
	        });
	      }
	    }
	  }, {
	    key: 'getSafePage',
	    value: function getSafePage(page) {
	      if (Number.isNaN(page)) {
	        page = this.props.page;
	      }
	      return Math.min(Math.max(page, 0), this.props.pages - 1);
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(page) {
	      page = this.getSafePage(page);
	      this.setState({ page: page });
	      if (this.props.page !== page) {
	        this.props.onPageChange(page);
	      }
	    }
	  }, {
	    key: 'applyPage',
	    value: function applyPage(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var page = this.state.page;
	      this.changePage(page === '' ? this.props.page : page);
	    }
	  }, {
	    key: 'getPageJumpProperties',
	    value: function getPageJumpProperties() {
	      var _this2 = this;
	
	      return {
	        onKeyPress: function onKeyPress(e) {
	          if (e.which === 13 || e.keyCode === 13) {
	            _this2.applyPage();
	          }
	        },
	        onBlur: this.applyPage,
	        value: this.state.page === '' ? '' : this.state.page + 1,
	        onChange: function onChange(e) {
	          var val = e.target.value;
	          var page = val - 1;
	          if (val === '') {
	            return _this2.setState({ page: val });
	          }
	          _this2.setState({ page: _this2.getSafePage(page) });
	        },
	        inputType: this.state.page === '' ? 'text' : 'number',
	        pageJumpText: this.props.pageJumpText
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          pages = _props.pages,
	          page = _props.page,
	          showPageSizeOptions = _props.showPageSizeOptions,
	          pageSizeOptions = _props.pageSizeOptions,
	          pageSize = _props.pageSize,
	          showPageJump = _props.showPageJump,
	          canPrevious = _props.canPrevious,
	          canNext = _props.canNext,
	          onPageSizeChange = _props.onPageSizeChange,
	          className = _props.className,
	          PreviousComponent = _props.PreviousComponent,
	          NextComponent = _props.NextComponent,
	          renderPageJump = _props.renderPageJump,
	          renderCurrentPage = _props.renderCurrentPage,
	          renderTotalPagesCount = _props.renderTotalPagesCount,
	          renderPageSizeOptions = _props.renderPageSizeOptions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, '-pagination'), style: this.props.style },
	        _react2.default.createElement(
	          'div',
	          { className: '-previous' },
	          _react2.default.createElement(
	            PreviousComponent,
	            {
	              onClick: function onClick() {
	                if (!canPrevious) return;
	                _this3.changePage(page - 1);
	              },
	              disabled: !canPrevious
	            },
	            this.props.previousText
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-center' },
	          _react2.default.createElement(
	            'span',
	            { className: '-pageInfo' },
	            this.props.pageText,
	            ' ',
	            showPageJump ? renderPageJump(this.getPageJumpProperties()) : renderCurrentPage(page),
	            ' ',
	            this.props.ofText,
	            ' ',
	            renderTotalPagesCount(pages)
	          ),
	          showPageSizeOptions && renderPageSizeOptions({
	            pageSize: pageSize,
	            rowsSelectorText: this.props.rowsSelectorText,
	            pageSizeOptions: pageSizeOptions,
	            onPageSizeChange: onPageSizeChange,
	            rowsText: this.props.rowsText
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-next' },
	          _react2.default.createElement(
	            NextComponent,
	            {
	              onClick: function onClick() {
	                if (!canNext) return;
	                _this3.changePage(page + 1);
	              },
	              disabled: !canNext
	            },
	            this.props.nextText
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReactTablePagination;
	}(_react.Component);
	
	ReactTablePagination.defaultProps = {
	  PreviousComponent: defaultButton,
	  NextComponent: defaultButton,
	  renderPageJump: function renderPageJump(_ref) {
	    var onChange = _ref.onChange,
	        value = _ref.value,
	        onBlur = _ref.onBlur,
	        onKeyPress = _ref.onKeyPress,
	        inputType = _ref.inputType,
	        pageJumpText = _ref.pageJumpText;
	    return _react2.default.createElement(
	      'div',
	      { className: '-pageJump' },
	      _react2.default.createElement('input', {
	        'aria-label': pageJumpText,
	        type: inputType,
	        onChange: onChange,
	        value: value,
	        onBlur: onBlur,
	        onKeyPress: onKeyPress
	      })
	    );
	  },
	  renderCurrentPage: function renderCurrentPage(page) {
	    return _react2.default.createElement(
	      'span',
	      { className: '-currentPage' },
	      page + 1
	    );
	  },
	  renderTotalPagesCount: function renderTotalPagesCount(pages) {
	    return _react2.default.createElement(
	      'span',
	      { className: '-totalPages' },
	      pages || 1
	    );
	  },
	  renderPageSizeOptions: function renderPageSizeOptions(_ref2) {
	    var pageSize = _ref2.pageSize,
	        pageSizeOptions = _ref2.pageSizeOptions,
	        rowsSelectorText = _ref2.rowsSelectorText,
	        onPageSizeChange = _ref2.onPageSizeChange,
	        rowsText = _ref2.rowsText;
	    return _react2.default.createElement(
	      'span',
	      { className: 'select-wrap -pageSizeOptions' },
	      _react2.default.createElement(
	        'select',
	        {
	          'aria-label': rowsSelectorText,
	          onChange: function onChange(e) {
	            return onPageSizeChange(Number(e.target.value));
	          },
	          value: pageSize
	        },
	        pageSizeOptions.map(function (option, i) {
	          return (
	            // eslint-disable-next-line react/no-array-index-key
	            _react2.default.createElement(
	              'option',
	              { key: i, value: option },
	              option + ' ' + rowsText
	            )
	          );
	        })
	      )
	    );
	  }
	};
	exports.default = ReactTablePagination;
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9wYWdpbmF0aW9uLmpzIl0sIm5hbWVzIjpbImRlZmF1bHRCdXR0b24iLCJwcm9wcyIsImNoaWxkcmVuIiwiUmVhY3RUYWJsZVBhZ2luYXRpb24iLCJnZXRTYWZlUGFnZSIsImJpbmQiLCJjaGFuZ2VQYWdlIiwiYXBwbHlQYWdlIiwic3RhdGUiLCJwYWdlIiwicHJldlByb3BzIiwicHJldlN0YXRlIiwic2V0U3RhdGUiLCJOdW1iZXIiLCJpc05hTiIsIk1hdGgiLCJtaW4iLCJtYXgiLCJwYWdlcyIsIm9uUGFnZUNoYW5nZSIsImUiLCJwcmV2ZW50RGVmYXVsdCIsIm9uS2V5UHJlc3MiLCJ3aGljaCIsImtleUNvZGUiLCJvbkJsdXIiLCJ2YWx1ZSIsIm9uQ2hhbmdlIiwidmFsIiwidGFyZ2V0IiwiaW5wdXRUeXBlIiwicGFnZUp1bXBUZXh0Iiwic2hvd1BhZ2VTaXplT3B0aW9ucyIsInBhZ2VTaXplT3B0aW9ucyIsInBhZ2VTaXplIiwic2hvd1BhZ2VKdW1wIiwiY2FuUHJldmlvdXMiLCJjYW5OZXh0Iiwib25QYWdlU2l6ZUNoYW5nZSIsImNsYXNzTmFtZSIsIlByZXZpb3VzQ29tcG9uZW50IiwiTmV4dENvbXBvbmVudCIsInJlbmRlclBhZ2VKdW1wIiwicmVuZGVyQ3VycmVudFBhZ2UiLCJyZW5kZXJUb3RhbFBhZ2VzQ291bnQiLCJyZW5kZXJQYWdlU2l6ZU9wdGlvbnMiLCJzdHlsZSIsInByZXZpb3VzVGV4dCIsInBhZ2VUZXh0IiwiZ2V0UGFnZUp1bXBQcm9wZXJ0aWVzIiwib2ZUZXh0Iiwicm93c1NlbGVjdG9yVGV4dCIsInJvd3NUZXh0IiwibmV4dFRleHQiLCJDb21wb25lbnQiLCJkZWZhdWx0UHJvcHMiLCJtYXAiLCJvcHRpb24iLCJpIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsZ0JBQWdCLFNBQWhCQSxhQUFnQjtBQUFBLFNBQ3BCO0FBQUE7QUFBQSxlQUFRLE1BQUssUUFBYixJQUEwQkMsS0FBMUIsSUFBaUMsV0FBVSxNQUEzQztBQUNHQSxVQUFNQztBQURULEdBRG9CO0FBQUEsQ0FBdEI7O0lBTXFCQyxvQjs7O0FBNENuQixnQ0FBYUYsS0FBYixFQUFvQjtBQUFBOztBQUFBLDRJQUNaQSxLQURZOztBQUdsQixVQUFLRyxXQUFMLEdBQW1CLE1BQUtBLFdBQUwsQ0FBaUJDLElBQWpCLE9BQW5CO0FBQ0EsVUFBS0MsVUFBTCxHQUFrQixNQUFLQSxVQUFMLENBQWdCRCxJQUFoQixPQUFsQjtBQUNBLFVBQUtFLFNBQUwsR0FBaUIsTUFBS0EsU0FBTCxDQUFlRixJQUFmLE9BQWpCOztBQUVBLFVBQUtHLEtBQUwsR0FBYTtBQUNYQyxZQUFNUixNQUFNUTtBQURELEtBQWI7QUFQa0I7QUFVbkI7Ozs7dUNBRW1CQyxTLEVBQVdDLFMsRUFBVztBQUN4QyxVQUFJRCxVQUFVRCxJQUFWLEtBQW1CLEtBQUtSLEtBQUwsQ0FBV1EsSUFBOUIsSUFBc0NFLFVBQVVGLElBQVYsS0FBbUIsS0FBS0QsS0FBTCxDQUFXQyxJQUF4RSxFQUE4RTtBQUM1RTtBQUNBO0FBQ0EsYUFBS0csUUFBTCxDQUFjO0FBQ1pILGdCQUFNLEtBQUtSLEtBQUwsQ0FBV1E7QUFETCxTQUFkO0FBR0Q7QUFDRjs7O2dDQUVZQSxJLEVBQU07QUFDakIsVUFBSUksT0FBT0MsS0FBUCxDQUFhTCxJQUFiLENBQUosRUFBd0I7QUFDdEJBLGVBQU8sS0FBS1IsS0FBTCxDQUFXUSxJQUFsQjtBQUNEO0FBQ0QsYUFBT00sS0FBS0MsR0FBTCxDQUFTRCxLQUFLRSxHQUFMLENBQVNSLElBQVQsRUFBZSxDQUFmLENBQVQsRUFBNEIsS0FBS1IsS0FBTCxDQUFXaUIsS0FBWCxHQUFtQixDQUEvQyxDQUFQO0FBQ0Q7OzsrQkFFV1QsSSxFQUFNO0FBQ2hCQSxhQUFPLEtBQUtMLFdBQUwsQ0FBaUJLLElBQWpCLENBQVA7QUFDQSxXQUFLRyxRQUFMLENBQWMsRUFBRUgsVUFBRixFQUFkO0FBQ0EsVUFBSSxLQUFLUixLQUFMLENBQVdRLElBQVgsS0FBb0JBLElBQXhCLEVBQThCO0FBQzVCLGFBQUtSLEtBQUwsQ0FBV2tCLFlBQVgsQ0FBd0JWLElBQXhCO0FBQ0Q7QUFDRjs7OzhCQUVVVyxDLEVBQUc7QUFDWixVQUFJQSxDQUFKLEVBQU87QUFDTEEsVUFBRUMsY0FBRjtBQUNEO0FBQ0QsVUFBTVosT0FBTyxLQUFLRCxLQUFMLENBQVdDLElBQXhCO0FBQ0EsV0FBS0gsVUFBTCxDQUFnQkcsU0FBUyxFQUFULEdBQWMsS0FBS1IsS0FBTCxDQUFXUSxJQUF6QixHQUFnQ0EsSUFBaEQ7QUFDRDs7OzRDQUV3QjtBQUFBOztBQUN2QixhQUFPO0FBQ0xhLG9CQUFZLHVCQUFLO0FBQ2YsY0FBSUYsRUFBRUcsS0FBRixLQUFZLEVBQVosSUFBa0JILEVBQUVJLE9BQUYsS0FBYyxFQUFwQyxFQUF3QztBQUN0QyxtQkFBS2pCLFNBQUw7QUFDRDtBQUNGLFNBTEk7QUFNTGtCLGdCQUFRLEtBQUtsQixTQU5SO0FBT0xtQixlQUFPLEtBQUtsQixLQUFMLENBQVdDLElBQVgsS0FBb0IsRUFBcEIsR0FBeUIsRUFBekIsR0FBOEIsS0FBS0QsS0FBTCxDQUFXQyxJQUFYLEdBQWtCLENBUGxEO0FBUUxrQixrQkFBVSxxQkFBSztBQUNiLGNBQU1DLE1BQU1SLEVBQUVTLE1BQUYsQ0FBU0gsS0FBckI7QUFDQSxjQUFNakIsT0FBT21CLE1BQU0sQ0FBbkI7QUFDQSxjQUFJQSxRQUFRLEVBQVosRUFBZ0I7QUFDZCxtQkFBTyxPQUFLaEIsUUFBTCxDQUFjLEVBQUVILE1BQU1tQixHQUFSLEVBQWQsQ0FBUDtBQUNEO0FBQ0QsaUJBQUtoQixRQUFMLENBQWMsRUFBRUgsTUFBTSxPQUFLTCxXQUFMLENBQWlCSyxJQUFqQixDQUFSLEVBQWQ7QUFDRCxTQWZJO0FBZ0JMcUIsbUJBQVcsS0FBS3RCLEtBQUwsQ0FBV0MsSUFBWCxLQUFvQixFQUFwQixHQUF5QixNQUF6QixHQUFrQyxRQWhCeEM7QUFpQkxzQixzQkFBYyxLQUFLOUIsS0FBTCxDQUFXOEI7QUFqQnBCLE9BQVA7QUFtQkQ7Ozs2QkFFUztBQUFBOztBQUFBLG1CQW9CSixLQUFLOUIsS0FwQkQ7QUFBQSxVQUdOaUIsS0FITSxVQUdOQSxLQUhNO0FBQUEsVUFLTlQsSUFMTSxVQUtOQSxJQUxNO0FBQUEsVUFNTnVCLG1CQU5NLFVBTU5BLG1CQU5NO0FBQUEsVUFPTkMsZUFQTSxVQU9OQSxlQVBNO0FBQUEsVUFRTkMsUUFSTSxVQVFOQSxRQVJNO0FBQUEsVUFTTkMsWUFUTSxVQVNOQSxZQVRNO0FBQUEsVUFVTkMsV0FWTSxVQVVOQSxXQVZNO0FBQUEsVUFXTkMsT0FYTSxVQVdOQSxPQVhNO0FBQUEsVUFZTkMsZ0JBWk0sVUFZTkEsZ0JBWk07QUFBQSxVQWFOQyxTQWJNLFVBYU5BLFNBYk07QUFBQSxVQWNOQyxpQkFkTSxVQWNOQSxpQkFkTTtBQUFBLFVBZU5DLGFBZk0sVUFlTkEsYUFmTTtBQUFBLFVBZ0JOQyxjQWhCTSxVQWdCTkEsY0FoQk07QUFBQSxVQWlCTkMsaUJBakJNLFVBaUJOQSxpQkFqQk07QUFBQSxVQWtCTkMscUJBbEJNLFVBa0JOQSxxQkFsQk07QUFBQSxVQW1CTkMscUJBbkJNLFVBbUJOQSxxQkFuQk07OztBQXNCUixhQUNFO0FBQUE7QUFBQSxVQUFLLFdBQVcsMEJBQVdOLFNBQVgsRUFBc0IsYUFBdEIsQ0FBaEIsRUFBc0QsT0FBTyxLQUFLdEMsS0FBTCxDQUFXNkMsS0FBeEU7QUFDRTtBQUFBO0FBQUEsWUFBSyxXQUFVLFdBQWY7QUFDRTtBQUFDLDZCQUFEO0FBQUE7QUFDRSx1QkFBUyxtQkFBTTtBQUNiLG9CQUFJLENBQUNWLFdBQUwsRUFBa0I7QUFDbEIsdUJBQUs5QixVQUFMLENBQWdCRyxPQUFPLENBQXZCO0FBQ0QsZUFKSDtBQUtFLHdCQUFVLENBQUMyQjtBQUxiO0FBT0csaUJBQUtuQyxLQUFMLENBQVc4QztBQVBkO0FBREYsU0FERjtBQVlFO0FBQUE7QUFBQSxZQUFLLFdBQVUsU0FBZjtBQUNFO0FBQUE7QUFBQSxjQUFNLFdBQVUsV0FBaEI7QUFDRyxpQkFBSzlDLEtBQUwsQ0FBVytDLFFBRGQ7QUFDd0IsZUFEeEI7QUFFR2IsMkJBQWVPLGVBQWUsS0FBS08scUJBQUwsRUFBZixDQUFmLEdBQThETixrQkFBa0JsQyxJQUFsQixDQUZqRTtBQUUwRixlQUYxRjtBQUdHLGlCQUFLUixLQUFMLENBQVdpRCxNQUhkO0FBQUE7QUFHdUJOLGtDQUFzQjFCLEtBQXRCO0FBSHZCLFdBREY7QUFNR2MsaUNBQ0NhLHNCQUFzQjtBQUNwQlgsOEJBRG9CO0FBRXBCaUIsOEJBQWtCLEtBQUtsRCxLQUFMLENBQVdrRCxnQkFGVDtBQUdwQmxCLDRDQUhvQjtBQUlwQkssOENBSm9CO0FBS3BCYyxzQkFBVSxLQUFLbkQsS0FBTCxDQUFXbUQ7QUFMRCxXQUF0QjtBQVBKLFNBWkY7QUEyQkU7QUFBQTtBQUFBLFlBQUssV0FBVSxPQUFmO0FBQ0U7QUFBQyx5QkFBRDtBQUFBO0FBQ0UsdUJBQVMsbUJBQU07QUFDYixvQkFBSSxDQUFDZixPQUFMLEVBQWM7QUFDZCx1QkFBSy9CLFVBQUwsQ0FBZ0JHLE9BQU8sQ0FBdkI7QUFDRCxlQUpIO0FBS0Usd0JBQVUsQ0FBQzRCO0FBTGI7QUFPRyxpQkFBS3BDLEtBQUwsQ0FBV29EO0FBUGQ7QUFERjtBQTNCRixPQURGO0FBeUNEOzs7O0VBOUsrQ0MsZ0I7O0FBQTdCbkQsb0IsQ0FDWm9ELFksR0FBZTtBQUNwQmYscUJBQW1CeEMsYUFEQztBQUVwQnlDLGlCQUFlekMsYUFGSztBQUdwQjBDLGtCQUFnQjtBQUFBLFFBQ2RmLFFBRGMsUUFDZEEsUUFEYztBQUFBLFFBQ0pELEtBREksUUFDSkEsS0FESTtBQUFBLFFBQ0dELE1BREgsUUFDR0EsTUFESDtBQUFBLFFBQ1dILFVBRFgsUUFDV0EsVUFEWDtBQUFBLFFBQ3VCUSxTQUR2QixRQUN1QkEsU0FEdkI7QUFBQSxRQUNrQ0MsWUFEbEMsUUFDa0NBLFlBRGxDO0FBQUEsV0FHZDtBQUFBO0FBQUEsUUFBSyxXQUFVLFdBQWY7QUFDRTtBQUNFLHNCQUFZQSxZQURkO0FBRUUsY0FBTUQsU0FGUjtBQUdFLGtCQUFVSCxRQUhaO0FBSUUsZUFBT0QsS0FKVDtBQUtFLGdCQUFRRCxNQUxWO0FBTUUsb0JBQVlIO0FBTmQ7QUFERixLQUhjO0FBQUEsR0FISTtBQWlCcEJxQixxQkFBbUI7QUFBQSxXQUFRO0FBQUE7QUFBQSxRQUFNLFdBQVUsY0FBaEI7QUFBZ0NsQyxhQUFPO0FBQXZDLEtBQVI7QUFBQSxHQWpCQztBQWtCcEJtQyx5QkFBdUI7QUFBQSxXQUFTO0FBQUE7QUFBQSxRQUFNLFdBQVUsYUFBaEI7QUFBK0IxQixlQUFTO0FBQXhDLEtBQVQ7QUFBQSxHQWxCSDtBQW1CcEIyQix5QkFBdUI7QUFBQSxRQUNyQlgsUUFEcUIsU0FDckJBLFFBRHFCO0FBQUEsUUFFckJELGVBRnFCLFNBRXJCQSxlQUZxQjtBQUFBLFFBR3JCa0IsZ0JBSHFCLFNBR3JCQSxnQkFIcUI7QUFBQSxRQUlyQmIsZ0JBSnFCLFNBSXJCQSxnQkFKcUI7QUFBQSxRQUtyQmMsUUFMcUIsU0FLckJBLFFBTHFCO0FBQUEsV0FPckI7QUFBQTtBQUFBLFFBQU0sV0FBVSw4QkFBaEI7QUFDRTtBQUFBO0FBQUE7QUFDRSx3QkFBWUQsZ0JBRGQ7QUFFRSxvQkFBVTtBQUFBLG1CQUFLYixpQkFBaUJ6QixPQUFPTyxFQUFFUyxNQUFGLENBQVNILEtBQWhCLENBQWpCLENBQUw7QUFBQSxXQUZaO0FBR0UsaUJBQU9RO0FBSFQ7QUFLR0Qsd0JBQWdCdUIsR0FBaEIsQ0FBb0IsVUFBQ0MsTUFBRCxFQUFTQyxDQUFUO0FBQUE7QUFDbkI7QUFDQTtBQUFBO0FBQUEsZ0JBQVEsS0FBS0EsQ0FBYixFQUFnQixPQUFPRCxNQUF2QjtBQUNNQSxvQkFETixTQUNnQkw7QUFEaEI7QUFGbUI7QUFBQSxTQUFwQjtBQUxIO0FBREYsS0FQcUI7QUFBQTtBQW5CSCxDO2tCQURIakQsb0IiLCJmaWxlIjoicGFnaW5hdGlvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnXG5cbmNvbnN0IGRlZmF1bHRCdXR0b24gPSBwcm9wcyA9PiAoXG4gIDxidXR0b24gdHlwZT1cImJ1dHRvblwiIHsuLi5wcm9wc30gY2xhc3NOYW1lPVwiLWJ0blwiPlxuICAgIHtwcm9wcy5jaGlsZHJlbn1cbiAgPC9idXR0b24+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFJlYWN0VGFibGVQYWdpbmF0aW9uIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBQcmV2aW91c0NvbXBvbmVudDogZGVmYXVsdEJ1dHRvbixcbiAgICBOZXh0Q29tcG9uZW50OiBkZWZhdWx0QnV0dG9uLFxuICAgIHJlbmRlclBhZ2VKdW1wOiAoe1xuICAgICAgb25DaGFuZ2UsIHZhbHVlLCBvbkJsdXIsIG9uS2V5UHJlc3MsIGlucHV0VHlwZSwgcGFnZUp1bXBUZXh0LFxuICAgIH0pID0+IChcbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiLXBhZ2VKdW1wXCI+XG4gICAgICAgIDxpbnB1dFxuICAgICAgICAgIGFyaWEtbGFiZWw9e3BhZ2VKdW1wVGV4dH1cbiAgICAgICAgICB0eXBlPXtpbnB1dFR5cGV9XG4gICAgICAgICAgb25DaGFuZ2U9e29uQ2hhbmdlfVxuICAgICAgICAgIHZhbHVlPXt2YWx1ZX1cbiAgICAgICAgICBvbkJsdXI9e29uQmx1cn1cbiAgICAgICAgICBvbktleVByZXNzPXtvbktleVByZXNzfVxuICAgICAgICAvPlxuICAgICAgPC9kaXY+XG4gICAgKSxcbiAgICByZW5kZXJDdXJyZW50UGFnZTogcGFnZSA9PiA8c3BhbiBjbGFzc05hbWU9XCItY3VycmVudFBhZ2VcIj57cGFnZSArIDF9PC9zcGFuPixcbiAgICByZW5kZXJUb3RhbFBhZ2VzQ291bnQ6IHBhZ2VzID0+IDxzcGFuIGNsYXNzTmFtZT1cIi10b3RhbFBhZ2VzXCI+e3BhZ2VzIHx8IDF9PC9zcGFuPixcbiAgICByZW5kZXJQYWdlU2l6ZU9wdGlvbnM6ICh7XG4gICAgICBwYWdlU2l6ZSxcbiAgICAgIHBhZ2VTaXplT3B0aW9ucyxcbiAgICAgIHJvd3NTZWxlY3RvclRleHQsXG4gICAgICBvblBhZ2VTaXplQ2hhbmdlLFxuICAgICAgcm93c1RleHQsXG4gICAgfSkgPT4gKFxuICAgICAgPHNwYW4gY2xhc3NOYW1lPVwic2VsZWN0LXdyYXAgLXBhZ2VTaXplT3B0aW9uc1wiPlxuICAgICAgICA8c2VsZWN0XG4gICAgICAgICAgYXJpYS1sYWJlbD17cm93c1NlbGVjdG9yVGV4dH1cbiAgICAgICAgICBvbkNoYW5nZT17ZSA9PiBvblBhZ2VTaXplQ2hhbmdlKE51bWJlcihlLnRhcmdldC52YWx1ZSkpfVxuICAgICAgICAgIHZhbHVlPXtwYWdlU2l6ZX1cbiAgICAgICAgPlxuICAgICAgICAgIHtwYWdlU2l6ZU9wdGlvbnMubWFwKChvcHRpb24sIGkpID0+IChcbiAgICAgICAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSByZWFjdC9uby1hcnJheS1pbmRleC1rZXlcbiAgICAgICAgICAgIDxvcHRpb24ga2V5PXtpfSB2YWx1ZT17b3B0aW9ufT5cbiAgICAgICAgICAgICAge2Ake29wdGlvbn0gJHtyb3dzVGV4dH1gfVxuICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgKSl9XG4gICAgICAgIDwvc2VsZWN0PlxuICAgICAgPC9zcGFuPlxuICAgICksXG4gIH1cblxuICBjb25zdHJ1Y3RvciAocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcylcblxuICAgIHRoaXMuZ2V0U2FmZVBhZ2UgPSB0aGlzLmdldFNhZmVQYWdlLmJpbmQodGhpcylcbiAgICB0aGlzLmNoYW5nZVBhZ2UgPSB0aGlzLmNoYW5nZVBhZ2UuYmluZCh0aGlzKVxuICAgIHRoaXMuYXBwbHlQYWdlID0gdGhpcy5hcHBseVBhZ2UuYmluZCh0aGlzKVxuXG4gICAgdGhpcy5zdGF0ZSA9IHtcbiAgICAgIHBhZ2U6IHByb3BzLnBhZ2UsXG4gICAgfVxuICB9XG5cbiAgY29tcG9uZW50RGlkVXBkYXRlIChwcmV2UHJvcHMsIHByZXZTdGF0ZSkge1xuICAgIGlmIChwcmV2UHJvcHMucGFnZSAhPT0gdGhpcy5wcm9wcy5wYWdlICYmIHByZXZTdGF0ZS5wYWdlICE9PSB0aGlzLnN0YXRlLnBhZ2UpIHtcbiAgICAgIC8vIHRoaXMgaXMgcHJvYmFibHkgc2FmZSBiZWNhdXNlIHdlIG9ubHkgdXBkYXRlIHdoZW4gb2xkL25ldyBzdGF0ZS5wYWdlIGFyZSBkaWZmZXJlbnRcbiAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSByZWFjdC9uby1kaWQtdXBkYXRlLXNldC1zdGF0ZVxuICAgICAgdGhpcy5zZXRTdGF0ZSh7XG4gICAgICAgIHBhZ2U6IHRoaXMucHJvcHMucGFnZSxcbiAgICAgIH0pXG4gICAgfVxuICB9XG5cbiAgZ2V0U2FmZVBhZ2UgKHBhZ2UpIHtcbiAgICBpZiAoTnVtYmVyLmlzTmFOKHBhZ2UpKSB7XG4gICAgICBwYWdlID0gdGhpcy5wcm9wcy5wYWdlXG4gICAgfVxuICAgIHJldHVybiBNYXRoLm1pbihNYXRoLm1heChwYWdlLCAwKSwgdGhpcy5wcm9wcy5wYWdlcyAtIDEpXG4gIH1cblxuICBjaGFuZ2VQYWdlIChwYWdlKSB7XG4gICAgcGFnZSA9IHRoaXMuZ2V0U2FmZVBhZ2UocGFnZSlcbiAgICB0aGlzLnNldFN0YXRlKHsgcGFnZSB9KVxuICAgIGlmICh0aGlzLnByb3BzLnBhZ2UgIT09IHBhZ2UpIHtcbiAgICAgIHRoaXMucHJvcHMub25QYWdlQ2hhbmdlKHBhZ2UpXG4gICAgfVxuICB9XG5cbiAgYXBwbHlQYWdlIChlKSB7XG4gICAgaWYgKGUpIHtcbiAgICAgIGUucHJldmVudERlZmF1bHQoKVxuICAgIH1cbiAgICBjb25zdCBwYWdlID0gdGhpcy5zdGF0ZS5wYWdlXG4gICAgdGhpcy5jaGFuZ2VQYWdlKHBhZ2UgPT09ICcnID8gdGhpcy5wcm9wcy5wYWdlIDogcGFnZSlcbiAgfVxuXG4gIGdldFBhZ2VKdW1wUHJvcGVydGllcyAoKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgIG9uS2V5UHJlc3M6IGUgPT4ge1xuICAgICAgICBpZiAoZS53aGljaCA9PT0gMTMgfHwgZS5rZXlDb2RlID09PSAxMykge1xuICAgICAgICAgIHRoaXMuYXBwbHlQYWdlKClcbiAgICAgICAgfVxuICAgICAgfSxcbiAgICAgIG9uQmx1cjogdGhpcy5hcHBseVBhZ2UsXG4gICAgICB2YWx1ZTogdGhpcy5zdGF0ZS5wYWdlID09PSAnJyA/ICcnIDogdGhpcy5zdGF0ZS5wYWdlICsgMSxcbiAgICAgIG9uQ2hhbmdlOiBlID0+IHtcbiAgICAgICAgY29uc3QgdmFsID0gZS50YXJnZXQudmFsdWVcbiAgICAgICAgY29uc3QgcGFnZSA9IHZhbCAtIDFcbiAgICAgICAgaWYgKHZhbCA9PT0gJycpIHtcbiAgICAgICAgICByZXR1cm4gdGhpcy5zZXRTdGF0ZSh7IHBhZ2U6IHZhbCB9KVxuICAgICAgICB9XG4gICAgICAgIHRoaXMuc2V0U3RhdGUoeyBwYWdlOiB0aGlzLmdldFNhZmVQYWdlKHBhZ2UpIH0pXG4gICAgICB9LFxuICAgICAgaW5wdXRUeXBlOiB0aGlzLnN0YXRlLnBhZ2UgPT09ICcnID8gJ3RleHQnIDogJ251bWJlcicsXG4gICAgICBwYWdlSnVtcFRleHQ6IHRoaXMucHJvcHMucGFnZUp1bXBUZXh0LFxuICAgIH1cbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3Qge1xuICAgICAgLy8gQ29tcHV0ZWRcbiAgICAgIHBhZ2VzLFxuICAgICAgLy8gUHJvcHNcbiAgICAgIHBhZ2UsXG4gICAgICBzaG93UGFnZVNpemVPcHRpb25zLFxuICAgICAgcGFnZVNpemVPcHRpb25zLFxuICAgICAgcGFnZVNpemUsXG4gICAgICBzaG93UGFnZUp1bXAsXG4gICAgICBjYW5QcmV2aW91cyxcbiAgICAgIGNhbk5leHQsXG4gICAgICBvblBhZ2VTaXplQ2hhbmdlLFxuICAgICAgY2xhc3NOYW1lLFxuICAgICAgUHJldmlvdXNDb21wb25lbnQsXG4gICAgICBOZXh0Q29tcG9uZW50LFxuICAgICAgcmVuZGVyUGFnZUp1bXAsXG4gICAgICByZW5kZXJDdXJyZW50UGFnZSxcbiAgICAgIHJlbmRlclRvdGFsUGFnZXNDb3VudCxcbiAgICAgIHJlbmRlclBhZ2VTaXplT3B0aW9ucyxcbiAgICB9ID0gdGhpcy5wcm9wc1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXYgY2xhc3NOYW1lPXtjbGFzc25hbWVzKGNsYXNzTmFtZSwgJy1wYWdpbmF0aW9uJyl9IHN0eWxlPXt0aGlzLnByb3BzLnN0eWxlfT5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCItcHJldmlvdXNcIj5cbiAgICAgICAgICA8UHJldmlvdXNDb21wb25lbnRcbiAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IHtcbiAgICAgICAgICAgICAgaWYgKCFjYW5QcmV2aW91cykgcmV0dXJuXG4gICAgICAgICAgICAgIHRoaXMuY2hhbmdlUGFnZShwYWdlIC0gMSlcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgICBkaXNhYmxlZD17IWNhblByZXZpb3VzfVxuICAgICAgICAgID5cbiAgICAgICAgICAgIHt0aGlzLnByb3BzLnByZXZpb3VzVGV4dH1cbiAgICAgICAgICA8L1ByZXZpb3VzQ29tcG9uZW50PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCItY2VudGVyXCI+XG4gICAgICAgICAgPHNwYW4gY2xhc3NOYW1lPVwiLXBhZ2VJbmZvXCI+XG4gICAgICAgICAgICB7dGhpcy5wcm9wcy5wYWdlVGV4dH17JyAnfVxuICAgICAgICAgICAge3Nob3dQYWdlSnVtcCA/IHJlbmRlclBhZ2VKdW1wKHRoaXMuZ2V0UGFnZUp1bXBQcm9wZXJ0aWVzKCkpIDogcmVuZGVyQ3VycmVudFBhZ2UocGFnZSl9eycgJ31cbiAgICAgICAgICAgIHt0aGlzLnByb3BzLm9mVGV4dH0ge3JlbmRlclRvdGFsUGFnZXNDb3VudChwYWdlcyl9XG4gICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgIHtzaG93UGFnZVNpemVPcHRpb25zICYmXG4gICAgICAgICAgICByZW5kZXJQYWdlU2l6ZU9wdGlvbnMoe1xuICAgICAgICAgICAgICBwYWdlU2l6ZSxcbiAgICAgICAgICAgICAgcm93c1NlbGVjdG9yVGV4dDogdGhpcy5wcm9wcy5yb3dzU2VsZWN0b3JUZXh0LFxuICAgICAgICAgICAgICBwYWdlU2l6ZU9wdGlvbnMsXG4gICAgICAgICAgICAgIG9uUGFnZVNpemVDaGFuZ2UsXG4gICAgICAgICAgICAgIHJvd3NUZXh0OiB0aGlzLnByb3BzLnJvd3NUZXh0LFxuICAgICAgICAgICAgfSl9XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cIi1uZXh0XCI+XG4gICAgICAgICAgPE5leHRDb21wb25lbnRcbiAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IHtcbiAgICAgICAgICAgICAgaWYgKCFjYW5OZXh0KSByZXR1cm5cbiAgICAgICAgICAgICAgdGhpcy5jaGFuZ2VQYWdlKHBhZ2UgKyAxKVxuICAgICAgICAgICAgfX1cbiAgICAgICAgICAgIGRpc2FibGVkPXshY2FuTmV4dH1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7dGhpcy5wcm9wcy5uZXh0VGV4dH1cbiAgICAgICAgICA8L05leHRDb21wb25lbnQ+XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgKVxuICB9XG59XG4iXX0=

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  // General
	  data: _propTypes2.default.any,
	  loading: _propTypes2.default.bool,
	  showPagination: _propTypes2.default.bool,
	  showPaginationTop: _propTypes2.default.bool,
	  showPaginationBottom: _propTypes2.default.bool,
	  showPageSizeOptions: _propTypes2.default.bool,
	  pageSizeOptions: _propTypes2.default.array,
	  defaultPageSize: _propTypes2.default.number,
	  showPageJump: _propTypes2.default.bool,
	  collapseOnSortingChange: _propTypes2.default.bool,
	  collapseOnPageChange: _propTypes2.default.bool,
	  collapseOnDataChange: _propTypes2.default.bool,
	  freezeWhenExpanded: _propTypes2.default.bool,
	  sortable: _propTypes2.default.bool,
	  resizable: _propTypes2.default.bool,
	  filterable: _propTypes2.default.bool,
	  defaultSortDesc: _propTypes2.default.bool,
	  defaultSorted: _propTypes2.default.array,
	  defaultFiltered: _propTypes2.default.array,
	  defaultResized: _propTypes2.default.array,
	  defaultExpanded: _propTypes2.default.object,
	  defaultFilterMethod: _propTypes2.default.func,
	  defaultSortMethod: _propTypes2.default.func,
	
	  // Controlled State Callbacks
	  onPageChange: _propTypes2.default.func,
	  onPageSizeChange: _propTypes2.default.func,
	  onSortedChange: _propTypes2.default.func,
	  onFilteredChange: _propTypes2.default.func,
	  onResizedChange: _propTypes2.default.func,
	  onExpandedChange: _propTypes2.default.func,
	
	  // Pivoting
	  pivotBy: _propTypes2.default.array,
	
	  // Key Constants
	  pivotValKey: _propTypes2.default.string,
	  pivotIDKey: _propTypes2.default.string,
	  subRowsKey: _propTypes2.default.string,
	  aggregatedKey: _propTypes2.default.string,
	  nestingLevelKey: _propTypes2.default.string,
	  originalKey: _propTypes2.default.string,
	  indexKey: _propTypes2.default.string,
	  groupedByPivotKey: _propTypes2.default.string,
	
	  // Server-side Callbacks
	  onFetchData: _propTypes2.default.func,
	
	  // Classes
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  // Component decorators
	  getProps: _propTypes2.default.func,
	  getTableProps: _propTypes2.default.func,
	  getTheadGroupProps: _propTypes2.default.func,
	  getTheadGroupTrProps: _propTypes2.default.func,
	  getTheadGroupThProps: _propTypes2.default.func,
	  getTheadProps: _propTypes2.default.func,
	  getTheadTrProps: _propTypes2.default.func,
	  getTheadThProps: _propTypes2.default.func,
	  getTheadFilterProps: _propTypes2.default.func,
	  getTheadFilterTrProps: _propTypes2.default.func,
	  getTheadFilterThProps: _propTypes2.default.func,
	  getTbodyProps: _propTypes2.default.func,
	  getTrGroupProps: _propTypes2.default.func,
	  getTrProps: _propTypes2.default.func,
	  getTdProps: _propTypes2.default.func,
	  getTfootProps: _propTypes2.default.func,
	  getTfootTrProps: _propTypes2.default.func,
	  getTfootTdProps: _propTypes2.default.func,
	  getPaginationProps: _propTypes2.default.func,
	  getLoadingProps: _propTypes2.default.func,
	  getNoDataProps: _propTypes2.default.func,
	  getResizerProps: _propTypes2.default.func,
	
	  // Global Column Defaults
	  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    // Renderers
	    Cell: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Aggregated: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Pivot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    PivotValue: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Expander: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.elementType]),
	    Filter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.elementType]),
	
	    // All Columns
	    sortable: _propTypes2.default.bool, // use table default
	    resizable: _propTypes2.default.bool, // use table default
	    filterable: _propTypes2.default.bool, // use table default
	    show: _propTypes2.default.bool,
	    minWidth: _propTypes2.default.number,
	    minResizeWidth: _propTypes2.default.number,
	
	    // Cells only
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    getProps: _propTypes2.default.func,
	
	    // Pivot only
	    aggregate: _propTypes2.default.func,
	
	    // Headers only
	    headerClassName: _propTypes2.default.string,
	    headerStyle: _propTypes2.default.object,
	    getHeaderProps: _propTypes2.default.func,
	
	    // Footers only
	    footerClassName: _propTypes2.default.string,
	    footerStyle: _propTypes2.default.object,
	    getFooterProps: _propTypes2.default.func,
	    filterMethod: _propTypes2.default.func,
	    filterAll: _propTypes2.default.bool,
	    sortMethod: _propTypes2.default.func
	  })),
	
	  // Global Expander Column Defaults
	  expanderDefaults: _propTypes2.default.shape({
	    sortable: _propTypes2.default.bool,
	    resizable: _propTypes2.default.bool,
	    filterable: _propTypes2.default.bool,
	    width: _propTypes2.default.number
	  }),
	
	  pivotDefaults: _propTypes2.default.object,
	
	  // Text
	  previousText: _propTypes2.default.node,
	  nextText: _propTypes2.default.node,
	  loadingText: _propTypes2.default.node,
	  noDataText: _propTypes2.default.node,
	  pageText: _propTypes2.default.node,
	  ofText: _propTypes2.default.node,
	  rowsText: _propTypes2.default.node,
	  pageJumpText: _propTypes2.default.node,
	  rowsSelectorText: _propTypes2.default.node,
	
	  // Components
	  TableComponent: _propTypes2.default.elementType,
	  TheadComponent: _propTypes2.default.elementType,
	  TbodyComponent: _propTypes2.default.elementType,
	  TrGroupComponent: _propTypes2.default.elementType,
	  TrComponent: _propTypes2.default.elementType,
	  ThComponent: _propTypes2.default.elementType,
	  TdComponent: _propTypes2.default.elementType,
	  TfootComponent: _propTypes2.default.elementType,
	  FilterComponent: _propTypes2.default.elementType,
	  ExpanderComponent: _propTypes2.default.elementType,
	  PivotValueComponent: _propTypes2.default.elementType,
	  AggregatedComponent: _propTypes2.default.elementType,
	  // this is a computed default generated using
	  PivotComponent: _propTypes2.default.elementType,
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _propTypes2.default.elementType,
	  PreviousComponent: _propTypes2.default.elementType,
	  NextComponent: _propTypes2.default.elementType,
	  LoadingComponent: _propTypes2.default.elementType,
	  NoDataComponent: _propTypes2.default.elementType,
	  ResizerComponent: _propTypes2.default.elementType,
	  PadRowComponent: _propTypes2.default.elementType
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactTable = __webpack_require__(1912);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var TemplateTableList = function TemplateTableList(props) {
	    var deleteTemplateModal = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)({});
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var componentState = _useState2[0];
	    var setComponentState = _useState2[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeedAPIReducer;
	    });
	
	    var templates = _useSelector.templates;
	
	    var user = (0, _reactRedux.useSelector)(function (state) {
	        return state.myAccountReducer.user;
	    });
	    var isAdmin = user.role === _config2['default'].roles[0].rolecode;
	    (0, _react.useEffect)(function () {
	        _reactTooltip2['default'].rebuild(); // componentDidUpdate()
	    });
	
	    var deleteTemplate = (0, _react.useCallback)(function (templateId, fClose) {
	        dispatch(a.deleteTemplate(templateId, fClose));
	    }, [dispatch]);
	
	    var openEditor = (0, _react.useCallback)(function (index) {
	        dispatch((0, _actionsLivefeed.setEditorDefaultState)());
	        var template = templates[index];
	
	        var id = template.id;
	        var data = template.data;
	        var name = template.name;
	
	        var passedData = data;
	        passedData.livefeedName = name;
	        props.router.push({
	            pathname: '/livefeed/editor',
	            state: {
	                mode: "editTemplate",
	                key: id,
	                passedData: passedData,
	                templateList: templates
	            }
	        });
	    }, [dispatch, props.router, templates]);
	
	    function makehandlerDelete(index) {
	        var currentTemplate = templates[index];
	
	        setComponentState({
	            deletedTemplateId: currentTemplate.id,
	            deletedTemplateName: currentTemplate.name
	        });
	
	        deleteTemplateModal.current.open();
	    }
	    //------------------------------------------- CRUD btns fn Render -----------------------------------
	    function renderCellBtn(child) {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'livefeed-child livefeed-child_icons' },
	            child
	        );
	    }
	    var editDeleteBtns = function editDeleteBtns(index) {
	        return _react2['default'].createElement(
	            _react.Fragment,
	            null,
	            renderCellBtn(_react2['default'].createElement(
	                'i',
	                { className: 'material-icons edit--icons', 'data-tip': 'Edit template',
	                    onClick: function () {
	                        openEditor(index);
	                    } },
	                'edit'
	            )),
	            renderCellBtn(_react2['default'].createElement(
	                'i',
	                { className: 'material-icons delete--icons', 'data-tip': 'Delete',
	                    onClick: function () {
	                        return makehandlerDelete(index);
	                    } },
	                'clear'
	            ))
	        );
	    };
	    //------------------------------------------- Collumns for table -----------------------------------
	    var columns = [{
	        Header: "Name", accessor: "name",
	        Filter: function Filter(_ref) {
	            var filter = _ref.filter;
	            var onChange = _ref.onChange;
	            return _react2['default'].createElement('input', { type: 'text', placeholder: 'Search template', value: filter ? filter.value : '',
	                onChange: function (event) {
	                    return onChange(event.target.value);
	                }
	            });
	        },
	        Cell: function Cell(_ref2) {
	            var value = _ref2.value;
	            var index = _ref2.index;
	            var id = _ref2.original.id;
	            return _react2['default'].createElement(
	                'div',
	                { 'data-tip': '' + (isAdmin ? 'Create new livefeed using this template' : ''),
	                    onClick: function () {
	                        if (isAdmin) {
	                            var passedData = templates[index].data;
	                            passedData.livefeedName = templates[index].name;
	                            props.router.push({
	                                pathname: '/livefeed/editor',
	                                state: {
	                                    mode: "createLivefeed", key: id, passedData: passedData, templateList: templates
	                                }
	                            });
	                        }
	                    },
	                    className: 'livefeed-child ' + (isAdmin ? 'livefeed-child_name' : '') },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'ellipsis' },
	                    value
	                )
	            );
	        }
	    }, {
	        width: 200, Header: "Creator", accessor: "data.owner",
	        Cell: function Cell(_ref3) {
	            var value = _ref3.value;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-child' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'ellipsis' },
	                    value
	                )
	            );
	        }
	    }, {
	        id: "date", width: 180, Header: "Date",
	        accessor: function accessor(_ref4) {
	            var data = _ref4.data;
	            return data.timestamp;
	        },
	        Cell: function Cell(_ref5) {
	            var value = _ref5.value;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-child' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'ellipsis' },
	                    (0, _moment2['default'])(value).local().format("DD-MM-YYYY HH:mm:ss")
	                )
	            );
	        }
	    }, {
	        Header: "Actions", width: 100, style: { padding: 0, height: 44 }, filterable: false, sortable: false, resizable: false,
	        Cell: function Cell(_ref6) {
	            var index = _ref6.index;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-crud' },
	                isAdmin ? _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    editDeleteBtns(index)
	                ) : _react2['default'].createElement(
	                    'span',
	                    { className: 'livefeed-child_disabled', 'data-tip': 'Only Admins can edit and delete' },
	                    editDeleteBtns(index)
	                )
	            );
	        }
	    }];
	    var addNewTemplate = (0, _react.useCallback)(function () {
	        dispatch((0, _actionsLivefeed.setEditorDefaultState)()), props.router.push({
	            pathname: '/livefeed/editor',
	            state: {
	                mode: "createTemplate"
	            }
	        });
	    }, [dispatch, props.router]);
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'h3',
	            { className: 'live-feed-title' },
	            'Templates'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { 'data-tip': '' + (!isAdmin ? 'Only Admins can add' : ''),
	                className: 'button btn--green add-livefeed-btn ' + (!isAdmin ? 'add-livefeed-btn_disabled' : ''),
	
	                onClick: function () {
	                    return isAdmin ? addNewTemplate() : null;
	                } },
	            _react2['default'].createElement('span', { className: 'font-icon icon-addicon' }),
	            'Add Template'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'all-feed-container' },
	            templates.length > 0 ? _react2['default'].createElement(
	                _react.Fragment,
	                null,
	                _react2['default'].createElement(_reactTooltip2['default'], { place: 'top', type: 'dark', effect: 'solid' }),
	                _react2['default'].createElement(_reactTable2['default'], {
	                    data: templates,
	                    columns: columns,
	                    style: {
	                        height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
	                    },
	                    filterable: true,
	                    defaultSorted: [{
	                        id: "date",
	                        desc: true
	                    }],
	                    defaultPageSize: 10,
	                    className: '-highlight livefeed-list-table'
	                })
	            ) : _react2['default'].createElement(
	                'div',
	                null,
	                'No template has been saved yet.'
	            ),
	            _react2['default'].createElement(
	                _componentsCommonModal2['default'],
	                {
	                    ref: deleteTemplateModal,
	                    clickButton: function () {
	                        deleteTemplate(componentState.deletedTemplateId, deleteTemplateModal.current.close());
	                    },
	                    header: 'Delete template',
	                    buttonText: 'Delete',
	                    buttonClass: 'btn-danger',
	                    entry: null
	                },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'delete-template-modal' },
	                    'Are you sure you want to delete template',
	                    _react2['default'].createElement(
	                        'b',
	                        null,
	                        ' ',
	                        componentState.deletedTemplateName
	                    ),
	                    '?'
	                )
	            )
	        )
	    );
	};
	TemplateTableList.propTypes = {
	    router: _propTypes2['default'].any.isRequired
	};
	exports['default'] = TemplateTableList;
	module.exports = exports['default'];

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(1921);
	
	var _TopMenuContainer = __webpack_require__(1922);
	
	var _TopMenuContainer2 = _interopRequireDefault(_TopMenuContainer);
	
	var _EditorContainer = __webpack_require__(2239);
	
	var _EditorContainer2 = _interopRequireDefault(_EditorContainer);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var Editor = function Editor(props) {
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _ref = props.location.state || { mode: "createLivefeed", passedData: null };
	
	    var mode = _ref.mode;
	    var passedData = _ref.passedData;
	    var key = _ref.key;
	
	    var fallbackModal = (0, _react.useRef)(null);
	    var handlePassingData = (0, _react.useCallback)(function () {
	        if (passedData !== undefined && passedData !== null) {
	            dispatch((0, _actionsLivefeed.mergeSlidesData)(passedData));
	        }
	    }, [dispatch, passedData]);
	
	    (0, _react.useEffect)(function () {
	        handlePassingData();
	    }, [handlePassingData]);
	
	    // The livefeed version 1 doesn't contain slideType key on livefeedSlide object
	    var isLivefeedV2 = passedData ? (0, _utils.detectLivefeedV2)(passedData.livefeedSlides) : true; // if no passedData means creating new livefeed mode
	
	    (0, _react.useEffect)(function () {
	        if (!isLivefeedV2) {
	            fallbackModal.current.open();
	        }
	    }, [isLivefeedV2]);
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'template-editor-page overwrite--modal--depth' },
	        _react2['default'].createElement(_TopMenuContainer2['default'], {
	            editorMode: mode,
	            editorKey: key,
	            router: props.router
	        }),
	        _react2['default'].createElement(
	            'div',
	            { className: 'page-content page-content_template-editor_padding' },
	            isLivefeedV2 ? _react2['default'].createElement(
	                'div',
	                { className: 'editor-box bg--white box--shadow' },
	                _react2['default'].createElement(_EditorContainer2['default'], {
	                    editorMode: mode
	                })
	            ) : _react2['default'].createElement(
	                _componentsCommonModal2['default'],
	                {
	                    disableCloseButton: true,
	                    ref: fallbackModal,
	                    onClose: function () {
	                        return props.router.push({ pathname: '/livefeed' });
	                    },
	                    clickButton: function () {
	                        return fallbackModal.current.close();
	                    },
	                    header: 'Incompatible version',
	                    buttonText: 'Got it',
	                    buttonClass: 'btn-success',
	                    entry: null
	                },
	                _react2['default'].createElement(
	                    'p',
	                    { style: { textAlign: "left" } },
	                    'This livefeed/template is incompatible with our recent update, please contact ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'mailto:support@steerpath.com?subject=Livefeed Error' },
	                        'support@steerpath.com'
	                    ),
	                    ' or create a new livefeed/template again'
	                )
	            )
	        )
	    );
	};
	
	Editor.propTypes = {
	    router: _propTypes2['default'].object.isRequired
	};
	
	exports['default'] = Editor;
	module.exports = exports['default'];

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.parseJwtToken = parseJwtToken;
	exports.detectLivefeedV2 = detectLivefeedV2;
	
	var _lodash = __webpack_require__(1897);
	
	function parseJwtToken(token) {
	    try {
	        var base64Url = token.split('.')[1];
	        var base64 = base64Url.replace('-', '+').replace('_', '/');
	        return JSON.parse(window.atob(base64));
	    } catch (e) {
	        return null;
	    }
	}
	
	function detectLivefeedV2(livefeedSlides) {
	    // The livefeed version 1 doesn't contain slideType key on livefeedSlide object
	    var isLivefeedV2 = true; // create new livefeed mode
	
	    isLivefeedV2 = (0, _lodash.has)(livefeedSlides[0], 'slideType');
	    // new update for livefeed V2 which has steerpath mapConfig
	    var slideshow1stIndex = undefined;
	    if (isLivefeedV2) {
	        for (var i = 0; i < livefeedSlides.length; i++) {
	            if (livefeedSlides[i].slideType === "slideshow") {
	                slideshow1stIndex = i;
	            }
	        }
	        isLivefeedV2 = (0, _lodash.has)(livefeedSlides[slideshow1stIndex].floorplanOptions, 'mapConfig');
	    }
	
	    return isLivefeedV2;
	}

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TopMenu = __webpack_require__(1923);
	
	var _TopMenu2 = _interopRequireDefault(_TopMenu);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _reactRedux = __webpack_require__(47);
	
	var _TemplateModal = __webpack_require__(2235);
	
	var _TemplateModal2 = _interopRequireDefault(_TemplateModal);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _LivefeedModal = __webpack_require__(2238);
	
	var _LivefeedModal2 = _interopRequireDefault(_LivefeedModal);
	
	var TopMenuContainer = function TopMenuContainer(props) {
	  // passedProps
	  var router = props.router;
	  var editorMode = props.editorMode;
	  var editorKey = props.editorKey;
	
	  var _useState = (0, _react.useState)('');
	
	  var _useState2 = _slicedToArray(_useState, 2);
	
	  var savingType = _useState2[0];
	  var setSavingType = _useState2[1];
	  // mode to save
	
	  var _useState3 = (0, _react.useState)([{}]);
	
	  var _useState32 = _slicedToArray(_useState3, 2);
	
	  var nullLocationSlides = _useState32[0];
	  var setNullLocationSlides = _useState32[1];
	
	  var _useState4 = (0, _react.useState)([{}]);
	
	  var _useState42 = _slicedToArray(_useState4, 2);
	
	  var slideShowDontHaveMapAPI = _useState42[0];
	  var setSlideShowDontHaveMapAPI = _useState42[1];
	
	  var livefeedModal = (0, _react.useRef)(null);
	  var templateModal = (0, _react.useRef)(null);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var nodeMap = (0, _reactRedux.useSelector)(function (state) {
	    return state.overviewReducer.nodeMap;
	  });
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.livefeededitor;
	  });
	
	  var livefeedSlides = _useSelector.livefeedSlides;
	  var livefeedName = _useSelector.livefeedName;
	
	  var user = (0, _reactRedux.useSelector)(function (state) {
	    return state.myAccountReducer.user;
	  });
	
	  var _useState5 = (0, _react.useState)('');
	
	  var _useState52 = _slicedToArray(_useState5, 2);
	
	  var creatorEmail = _useState52[0];
	  var setCreatorEmail = _useState52[1];
	
	  (0, _react.useEffect)(function () {
	    setCreatorEmail(user.email);
	  }, [user.email]);
	
	  // livefeed conditon save
	  function livefeedConditionsCheck() {
	    var nullLocationArrObj = [];
	    var slideShowArrObj = [];
	
	    livefeedSlides.slice().map(function (slide, index) {
	      if (slide.slideType !== "locationsList") {
	        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	        var refinedLocationsID = slide.floorplanOptions.locationsID.filter(function (id) {
	          return nodeMap[id];
	        });
	
	        if (!refinedLocationsID.length > 0) {
	          nullLocationArrObj.push({ id: index, slideType: slide.slideType });
	        }
	        if (slide.slideType === "slideshow" && slide.floorplanOptions.mapApiKey === "") {
	          slideShowArrObj.push({ id: index, slideType: slide.slideType });
	        }
	      }
	    });
	    setNullLocationSlides(nullLocationArrObj);
	    setSlideShowDontHaveMapAPI(slideShowArrObj);
	  }
	
	  //-------------------------------------------function handle Save -----------------------------------
	  function handleSave(mode) {
	    // check condition before submit editTemplate or editLivefeed
	    switch (mode) {
	      case "template":
	        {
	          setSavingType("template");
	          templateModal.current.open();
	        }
	        break;
	      case "livefeed":
	        {
	          setSavingType("livefeed");
	          livefeedConditionsCheck();
	          livefeedModal.current.open();
	        }
	        break;
	      case "update":
	        {
	          setSavingType("update");
	          livefeedConditionsCheck();
	          editorMode === "editTemplate" ? templateModal.current.open() : livefeedModal.current.open();
	        }
	        break;
	    }
	  }
	
	  var breadcrumbs = [{
	    path: "/livefeed",
	    name: "Livefeed"
	  }, {
	    shouldReload: true,
	    path: "/livefeed/editor",
	    name: pageTitle(editorMode, true)
	  }];
	
	  var dropdownSave = _react2["default"].createElement(
	    _componentsCommonDropdowncomponentsDropdown2["default"],
	    {
	      className: "dropdown-save",
	      noArrow: true,
	      header: _react2["default"].createElement(
	        "div",
	        { className: "justify-center dropdown-header-text" },
	        _react2["default"].createElement(
	          "span",
	          { className: "cursor--pointer" },
	          _react2["default"].createElement(
	            "i",
	            { className: "material-icons material-icons_size save--icons" },
	            "save"
	          ),
	          "Save",
	          _react2["default"].createElement(
	            "i",
	            { style: { marginLeft: 5, marginBottom: 4, fontSize: "24px" }, className: "material-icons" },
	            "keyboard_arrow_down"
	          )
	        )
	      ),
	      toggleable: true
	    },
	    _react2["default"].createElement(
	      _react.Fragment,
	      null,
	      (editorMode === "editTemplate" || editorMode === "editLivefeed") && _react2["default"].createElement(
	        _componentsCommonDropdowncomponentsDropdownitem2["default"],
	        null,
	        _react2["default"].createElement(
	          "div",
	          { onClick: function () {
	              return handleSave("update");
	            } },
	          "Update"
	        )
	      ),
	      _react2["default"].createElement(
	        _componentsCommonDropdowncomponentsDropdownitem2["default"],
	        null,
	        _react2["default"].createElement(
	          "div",
	          { onClick: function () {
	              return handleSave("livefeed");
	            } },
	          "Save as Livefeed..."
	        )
	      ),
	      _react2["default"].createElement(
	        _componentsCommonDropdowncomponentsDropdownitem2["default"],
	        null,
	        _react2["default"].createElement(
	          "div",
	          { onClick: function () {
	              return handleSave("template");
	            } },
	          "Save as Template..."
	        )
	      )
	    )
	  );
	
	  function pageTitle(editorMode, isBc) {
	    switch (editorMode) {
	      case "editTemplate":
	        return "" + (isBc ? "Edit " + livefeedName + " [Template]" : "Edit Template");
	      case "editLivefeed":
	        return "" + (isBc ? "Edit " + livefeedName + " [Livefeed]" : "Edit Livefeed");
	      case "createLivefeed":
	        return "Create Livefeed";
	      case "createTemplate":
	        return "Create Template";
	    }
	  }
	
	  var isCreateMode = editorMode === "createTemplate" || editorMode === "createLivefeed";
	  // if user edits existing livefeed or template, then choose to save as new
	  if (savingType === "template" | savingType === "livefeed") {
	    isCreateMode = true;
	  }
	  return _react2["default"].createElement(
	    _TopMenu2["default"],
	    {
	      pageTitle: pageTitle(editorMode, false),
	      saveBtnText: "Save changes",
	      onClickCancel: function () {
	        return router.push({
	          pathname: "/livefeed"
	        });
	      },
	      cancelBtnText: "Cancel",
	      onSaveDropdown: dropdownSave
	    },
	    _react2["default"].createElement(
	      _react.Fragment,
	      null,
	      _react2["default"].createElement(_componentsCommonPath2["default"], { regularBc: true, path: breadcrumbs }),
	      _react2["default"].createElement(_LivefeedModal2["default"], {
	        livefeedName: livefeedName,
	        nullLocationSlides: nullLocationSlides,
	        slideShowDontHaveMapAPI: slideShowDontHaveMapAPI,
	        livefeedSlides: livefeedSlides,
	        nodeMap: nodeMap,
	        creatorEmail: creatorEmail,
	        editorMode: editorMode,
	        savingType: savingType,
	        dispatch: dispatch,
	        router: router,
	        editorKey: editorKey,
	        isCreateMode: isCreateMode,
	        ref: livefeedModal
	      }),
	      _react2["default"].createElement(_TemplateModal2["default"], {
	        dispatch: dispatch,
	        isCreateMode: isCreateMode,
	        savingType: savingType,
	        creatorEmail: creatorEmail,
	        router: router,
	        editorMode: editorMode,
	        editorKey: editorKey,
	        ref: templateModal,
	        livefeedSlides: livefeedSlides,
	        livefeedName: livefeedName
	      })
	    )
	  );
	};
	
	TopMenuContainer.propTypes = {
	  router: _propTypes2["default"].object.isRequired,
	  editorMode: _propTypes2["default"].string
	};
	
	exports["default"] = TopMenuContainer;
	module.exports = exports["default"];
	/*--------------------------------------Livefeed modal------------------------------------------- */

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _ChooseLayout = __webpack_require__(1924);
	
	var _ChooseLayout2 = _interopRequireDefault(_ChooseLayout);
	
	var TopMenu = function TopMenu(props) {
	    return _react2["default"].createElement(
	        _componentsCommonStickymenu2["default"],
	        { withStickyHeader: false },
	        _react2["default"].createElement(_componentsCommonMainmenu2["default"], {
	            overviewIsActive: false,
	            comparisonIsActive: false,
	            onlyLeftMenu: true
	        }),
	        _react2["default"].createElement(_componentsCommonStatsmenu2["default"], {
	            leftItemBold: props.pageTitle,
	            leftItems: _react2["default"].createElement(
	                _react2["default"].Fragment,
	                null,
	                _react2["default"].createElement(
	                    "span",
	                    { className: "stats-menu__list-item  ", onClick: props.onClickSave },
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "stats-menu-btn cursor--pointer" },
	                        props.onSaveDropdown
	                    )
	                ),
	                _react2["default"].createElement(
	                    "span",
	                    { className: "stats-menu__list-item ", onClick: props.onClickCancel },
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "stats-menu-btn cursor--pointer" },
	                        _react2["default"].createElement(
	                            "span",
	                            { className: "cursor--pointer" },
	                            _react2["default"].createElement(
	                                "i",
	                                { className: "material-icons material-icons_size cancel--icons" },
	                                "cancel"
	                            ),
	                            props.cancelBtnText
	                        )
	                    )
	                ),
	                _react2["default"].createElement(_ChooseLayout2["default"], null)
	            )
	        }),
	        props.children
	    );
	};
	
	exports["default"] = TopMenu;
	module.exports = exports["default"];

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _componentsCommonCustomTickBox = __webpack_require__(1925);
	
	var _componentsCommonCustomTickBox2 = _interopRequireDefault(_componentsCommonCustomTickBox);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _componentsPagesLivefeedUtils = __webpack_require__(1921);
	
	var _SnapshotSlidesCarousel = __webpack_require__(1928);
	
	var _SnapshotSlidesCarousel2 = _interopRequireDefault(_SnapshotSlidesCarousel);
	
	__webpack_require__(2233);
	
	exports['default'] = function () {
	    //-------------------------------------------Choose layout template functions hanlde -----------------------------------
	    // fetchTemplate once
	    var fetchTemplateOnce = (0, _react.useCallback)(function () {
	        dispatch(a.fetchTemplate());
	    }, [dispatch]);
	
	    (0, _react.useEffect)(function () {
	        fetchTemplateOnce();
	    }, [fetchTemplateOnce]);
	
	    var templatesListModal = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)(null);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var chosenTemplate = _useState2[0];
	    var setChosenTemplate = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var chosenLayout = _useState32[0];
	    var setChosenLayout = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(false);
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var layoutAllSlides = _useState42[0];
	    var setLayoutAllSlides = _useState42[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var mapConfigMode = _useSelector.mapConfigMode;
	    var stepNumberState = _useSelector.stepNumberState;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	
	    var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeedAPIReducer;
	    });
	
	    var templates = _useSelector2.templates;
	
	    var handleMergeLayout = (0, _react.useCallback)(function (i, layout) {
	        dispatch((0, _actionsLivefeedHistoryActions.handleClearHistory)(i));
	        stepNumberState !== 0 && dispatch((0, _actionsLivefeedHistoryActions.setStepNumberState)(0));
	        dispatch((0, _actionsLivefeed.mergeLayout)(i, layout));
	    }, [dispatch, stepNumberState]);
	
	    function mergeLayoutHandle() {
	        var layout = chosenLayout;
	        console.log("chosenLayout", chosenLayout);
	        if (layout) {
	            if (layoutAllSlides) {
	                for (var i = 0; i < livefeedSlides.length; i++) {
	                    // assign current floorplanOptions with index to layout.floorplanOptions
	                    var currentFloorplanOptions = livefeedSlides[i].floorplanOptions;
	                    layout.floorplanOptions = currentFloorplanOptions;
	                    // keep style color only
	                    var newTextContainers = [];
	                    for (var n = 0; n < livefeedSlides[i].textContainer.length; n++) {
	                        var textContainer = livefeedSlides[i].textContainer[n];
	                        textContainer.color = layout.textContainer[0].color;
	                        newTextContainers.push(textContainer);
	                    }
	                    layout.textContainer = newTextContainers;
	                    // Merge layout to the right slideType
	                    switch (layout.slideType) {
	                        case "summary":
	                            livefeedSlides[i].slideType === "summary" && handleMergeLayout(i, layout);
	                            break;
	                        case "locationsList":
	                            livefeedSlides[i].slideType === "locationsList" && handleMergeLayout(i, layout);
	                            break;
	                        case "slideshow":
	                            livefeedSlides[i].slideType === "slideshow" && handleMergeLayout(i, layout);
	                            break;
	                    }
	                }
	            } else {
	                // assign current floorplanOptions to layout.floorplanOptions
	                var currentFloorplanOptions = livefeedSlides[slideCurrentIndex].floorplanOptions;
	                layout.floorplanOptions = currentFloorplanOptions;
	                // keep style color only
	                var newTextContainers = [];
	                for (var i = 0; i < livefeedSlides[slideCurrentIndex].textContainer.length; ++i) {
	                    var textContainer = livefeedSlides[slideCurrentIndex].textContainer[i];
	                    textContainer.color = layout.textContainer[0].color;
	                    newTextContainers.push(textContainer);
	                }
	                layout.textContainer = newTextContainers;
	                handleMergeLayout(slideCurrentIndex, layout);
	            }
	            // trigger rerender the map when merging layout
	            if (mapConfigMode === "user_input") {
	                dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)("map_interact")); // this won't rerender
	            }
	            dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)("user_input"));
	        }
	    }
	
	    function selectCreateOptions() {
	        var ar = [];
	        templates.map(function (x) {
	            if ((0, _componentsPagesLivefeedUtils.detectLivefeedV2)(x.data.livefeedSlides)) {
	                return ar.push({
	                    value: x.id,
	                    label: x.name,
	                    data: x.data
	                });
	            }
	        });
	        return ar;
	    }
	
	    var _useState5 = (0, _react.useState)(null);
	
	    var _useState52 = _slicedToArray(_useState5, 2);
	
	    var currentSlideTypeState = _useState52[0];
	    var setCurrentSlideTypeState = _useState52[1];
	
	    (0, _react.useEffect)(function () {
	        setCurrentSlideTypeState(livefeedSlides[slideCurrentIndex].slideType);
	    }, [livefeedSlides, slideCurrentIndex]);
	
	    var nodeMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.nodeMap;
	    });
	    var sensorMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.nodeReducer.map;
	    });
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'span',
	            { className: 'stats-menu__list-item ', onClick: function () {
	                    return templatesListModal.current.open();
	                } },
	            _react2['default'].createElement(
	                'div',
	                { className: 'stats-menu-btn cursor--pointer' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'cursor--pointer' },
	                    _react2['default'].createElement(
	                        'i',
	                        { style: { marginRight: 5 }, className: 'material-icons material-icons_size' },
	                        'insert_drive_file'
	                    ),
	                    'Choose Template layout'
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                ref: templatesListModal,
	                clickButton: function () {
	                    templatesListModal.current.close();mergeLayoutHandle();
	                },
	                header: 'Choose layout template',
	                buttonText: 'Confirm',
	                buttonClass: 'btn-success ' + (!chosenLayout ? 'btn-disabled' : ''),
	                buttonHide: true,
	                entry: null,
	                className: 'livefeed-preview__floorplan-modal'
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'add-feed-modal' },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Please select a layout/template for your slide.'
	                    )
	                ),
	                chosenTemplate && _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'floorplan-preview-carousel' },
	                        livefeedSlides[slideCurrentIndex].slideType === currentSlideTypeState ? _react2['default'].createElement(_SnapshotSlidesCarousel2['default'], {
	                            currentSlideTypeState: currentSlideTypeState,
	                            dispatch: dispatch,
	                            nodeMap: nodeMap,
	                            sensorMap: sensorMap,
	                            setChosenLayout: setChosenLayout,
	                            chosenTemplate: chosenTemplate,
	                            slideCurrentIndex: slideCurrentIndex
	                        }) : _react2['default'].createElement(
	                            'p',
	                            null,
	                            'There is no layout slide available for this slide  '
	                        )
	                    ),
	                    _react2['default'].createElement('br', null)
	                ),
	                _react2['default'].createElement(_reactSelect2['default'], {
	                    autoFocus: true,
	                    openOnFocus: true,
	                    openOnClick: true,
	                    closeOnSelect: true,
	                    clearable: false,
	                    onChange: function (option) {
	                        return setChosenTemplate(option);
	                    },
	                    options: selectCreateOptions(),
	                    placeholder: 'Select template for livefeed',
	                    value: chosenTemplate
	                }),
	                livefeedSlides[slideCurrentIndex].slideType === "slideshow" && _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2['default'].createElement('br', null),
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Select this checkbox to apply layout to all slideshow slides'
	                    ),
	                    _react2['default'].createElement(_componentsCommonCustomTickBox2['default'], {
	                        onClick: function () {
	                            return setLayoutAllSlides(!layoutAllSlides);
	                        },
	                        label: 'Apply to all slideshow slides',
	                        isActive: layoutAllSlides
	                    })
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1926);
	
	var CustomTickBox = function CustomTickBox(_ref) {
	    var className = _ref.className;
	    var onClick = _ref.onClick;
	    var label = _ref.label;
	    var isActive = _ref.isActive;
	
	    return _react2['default'].createElement(
	        'span',
	        {
	            onClick: onClick,
	            className: 'checkbox-container ' + className },
	        _react2['default'].createElement('span', { className: 'checkmark ' + (isActive ? 'checkmark_active' : '') }),
	        label !== "" && label
	    );
	};
	
	CustomTickBox.propTypes = {
	    onClick: _propTypes2['default'].func.isRequired,
	    label: _propTypes2['default'].string.isRequired,
	    isActive: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = CustomTickBox;
	module.exports = exports['default'];

/***/ }),
/* 1926 */
[2370, 1927],
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".checkbox-container{display:block;position:relative;padding-left:28px;margin-top:12px;margin-bottom:12px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkmark{position:absolute;top:0;left:0;height:20px;width:20px;background-color:#eee;transition:all .3s ease}.checkmark:hover{background-color:#ccc}.checkmark:after{content:\"\";position:absolute;display:none;left:7px;top:3px;width:7px;height:12px;border:solid #fff;border-width:0 3px 3px 0;transform:rotate(45deg)}.checkmark_active{background-color:#3cb449}.checkmark_active:after{display:block}.checkmark_active:hover{background-color:#2f8e39}.checkmark:focus{outline:5px auto #3cb449;outline-offset:-2px}", ""]);
	
	// exports


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _reactSlick = __webpack_require__(1930);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _EditorContainerLivefeedPreview = __webpack_require__(1948);
	
	var _EditorContainerLivefeedPreview2 = _interopRequireDefault(_EditorContainerLivefeedPreview);
	
	var _lodash = __webpack_require__(1897);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var SnapshotSlidesCarousel = function SnapshotSlidesCarousel(props) {
	    var dispatch = props.dispatch;
	    var nodeMap = props.nodeMap;
	    var sensorMap = props.sensorMap;
	    var chosenTemplate = props.chosenTemplate;
	    var setChosenLayout = props.setChosenLayout;
	    var currentSlideTypeState = props.currentSlideTypeState;
	    var slideCurrentIndex = props.slideCurrentIndex;
	
	    var _useState = (0, _react.useState)([]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var snapshotSlides = _useState2[0];
	    var setSnapshotSlides = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(0);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var chosenLayoutIndex = _useState32[0];
	    var setChosenLayoutIndex = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(_lodash2['default'].uniqueId('snapshotCarousel_'));
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var uniqueId = _useState42[0];
	    var setUniqueId = _useState42[1];
	
	    var settings = {
	        dots: true,
	        arrows: true,
	        infinite: true,
	        autoplay: false,
	        fade: true,
	        speed: 600,
	        pauseOnHover: false,
	        swipe: false,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        adaptiveHeight: true,
	        afterChange: function afterChange(current) {
	            setChosenLayoutIndex(current);
	        }
	    };
	
	    (0, _react.useEffect)(function () {
	        var arr = [];
	        for (var i = 0; i < chosenTemplate.data.livefeedSlides.length; ++i) {
	            if (chosenTemplate.data.livefeedSlides[i].slideType === currentSlideTypeState) {
	                arr.push(chosenTemplate.data.livefeedSlides[i]);
	            }
	        }
	        for (var i = 0; i < arr.length; ++i) {
	            arr[i].id = i;
	        }
	
	        setSnapshotSlides(arr);
	        setUniqueId(_lodash2['default'].uniqueId('snapshotCarousel_'));
	    }, [chosenTemplate.data.livefeedSlides, currentSlideTypeState, slideCurrentIndex]);
	
	    (0, _react.useEffect)(function () {
	        setChosenLayout(snapshotSlides[chosenLayoutIndex]);
	    }, [chosenLayoutIndex, setChosenLayout, snapshotSlides, slideCurrentIndex]);
	
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        snapshotSlides.length > 0 ? _react2['default'].createElement(
	            'p',
	            null,
	            'All styles on chosen slide layout: ',
	            (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.generateSlideName)(snapshotSlides, snapshotSlides[chosenLayoutIndex]),
	            'will be applied'
	        ) : _react2['default'].createElement(
	            'p',
	            null,
	            'There is no layout slide available for this slide  '
	        ),
	        _react2['default'].createElement(
	            _reactSlick2['default'],
	            _extends({
	                key: uniqueId
	            }, settings),
	            snapshotSlides.length > 0 && snapshotSlides.map(function (_, index) {
	                return _react2['default'].createElement(
	                    'div',
	                    { key: index, className: 'selected-slide' },
	                    _react2['default'].createElement(_EditorContainerLivefeedPreview2['default'], {
	                        scaleMode: true,
	                        dispatch: dispatch,
	                        livefeedSlides: snapshotSlides,
	                        slideCurrentIndex: index,
	                        nodeMap: nodeMap,
	                        stepNumberState: 0,
	                        editorView: false,
	                        sensorMap: sensorMap,
	                        mapConfigMode: 'user_input',
	                        focusMapApiInput: function (e) {
	                            e.stopPropagation();
	                        },
	                        handleOpenLocationModal: function (e) {
	                            e.stopPropagation();
	                        }
	                    })
	                );
	            })
	        )
	    );
	};
	
	exports['default'] = SnapshotSlidesCarousel;
	module.exports = exports['default'];

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.getPosition = getPosition;
	exports.handleSetCurrentEntity = handleSetCurrentEntity;
	exports.generateSlideName = generateSlideName;
	exports.treatStandbySensor = treatStandbySensor;
	exports.getStats = getStats;
	exports.constructOptions = constructOptions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var _lodash = __webpack_require__(1897);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function getPosition(pos) {
	    return (0, _immutabilityHelper2['default'])(pos, {
	        x: { $set: pos.x + 6 }, //plus padding+border
	        y: { $set: pos.y + 6 }
	    });
	}
	
	function handleSetCurrentEntity(currentEntity, newEntity, dispatch) {
	    return (0, _lodash.isEqual)(currentEntity, newEntity) === false && dispatch((0, _actionsLivefeedHistoryActions.updateCurrentEntity)(newEntity));
	}
	
	function generateSlideName(livefeedSlides, slide) {
	    var hasSummarySlide = false;
	    var hasLocationsListSlide = false;
	    var slideShowCount = 0;
	    var slideShow = [];
	    for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	        switch (livefeedSlides[i].slideType) {
	            case "summary":
	                hasSummarySlide = true;
	                break;
	            case "locationsList":
	                hasLocationsListSlide = true;
	                break;
	            default:
	                slideShowCount += 1;
	                slideShow.push({ index: i, num: slideShowCount });
	        }
	    }
	    var slideShowMap = new Map();
	    slideShow.forEach(function (element) {
	        return slideShowMap.set(element.index, element);
	    });
	    var slideName = slideShowMap.get(slide.id) ? 'Slideshow ' + slideShowMap.get(slide.id).num : '';
	
	    if (hasSummarySlide && hasLocationsListSlide) {
	        switch (slide.slideType) {
	            case "summary":
	                slideName = "Summary";
	                break;
	            case "locationsList":
	                slideName = "Locations List";
	                break;
	        }
	    } else if (hasSummarySlide && !hasLocationsListSlide) {
	        switch (slide.slideType) {
	            case "summary":
	                slideName = "Summary";
	                break;
	        }
	    }
	
	    return slideName;
	}
	
	function countTreeStatistic(root, map, isStandbyAsUnOccupied) {
	    var statistic = {
	        meetingRooms: 0,
	        meetingRoomsInuse: 0,
	        mrDesksInUse: 0,
	        mrGoodSensors: 0,
	
	        openAreaRooms: 0,
	        openAreaRoomsInUse: 0,
	        oaDesksInUse: 0,
	        oaGoodSensors: 0,
	
	        allGoodSensors: 0,
	        allSensors: 0, // all include falty sensors, and not registered
	        allDesksInUse: 0 // only good sensors,
	    };
	    count(root, statistic, map, isStandbyAsUnOccupied);
	    return statistic;
	}
	
	function treatStandbySensor(isStandbyAsUnOccupied, standbyStatus) {
	    // treat standby as occupied
	
	    if (!isStandbyAsUnOccupied) {
	        if (standbyStatus === true) {
	            return true;
	        }
	    } else {
	        // treat standby as unoccupied
	        if (standbyStatus === true) {
	            return false;
	        }
	    }
	}
	
	/*
	IMPORTANT things,
	the node object received in ttps://backend.senzodata.com/livefeedapi
	for node that doesn't have children node, its default value is null
	While on https://backend.senzodata.com/api, the default value is an empty array
	so the condition for looping the count() is different
	*/
	function count(root, statistic, map, isStandbyAsUnOccupied) {
	    if (root != null && root.children != null) {
	        // get allGoodSensors and allSensors
	        if (root.type == 'open_area' || root.type == "meeting_room") {
	            root.children.forEach(function (sensor) {
	                var status = map.get(sensor.id);
	                if (status.registered && status.lastonl + 24 * 60 * 60 > (0, _moment2['default'])().unix() && !status.faulty) {
	                    statistic.allGoodSensors++;
	                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
	                        statistic.allDesksInUse++;
	                    }
	                }
	                statistic.allSensors++;
	            });
	        }
	        // count either open_area or meeting_room
	        if (root.type == 'open_area') {
	            statistic.openAreaRooms++;
	            var occupied = false;
	            root.children.forEach(function (sensor) {
	                var status = map.get(sensor.id);
	                if (status) {
	                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
	                        occupied = true;
	                        statistic.oaDesksInUse++;
	                    }
	                }
	                if (status.registered && status.lastonl + 24 * 60 * 60 > (0, _moment2['default'])().unix() && !status.faulty) {
	                    statistic.oaGoodSensors++;
	                }
	            });
	            if (occupied) {
	                statistic.openAreaRoomsInUse++;
	            }
	        } else if (root.type == "meeting_room") {
	            statistic.meetingRooms++;
	            var occupied = false;
	            root.children.forEach(function (sensor) {
	                var status = map.get(sensor.id);
	                if (status) {
	                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
	                        occupied = true;
	                        statistic.mrDesksInUse++;
	                    }
	                }
	                if (status.registered && status.lastonl + 24 * 60 * 60 > (0, _moment2['default'])().unix() && !status.faulty) {
	                    statistic.mrGoodSensors++;
	                }
	            });
	            if (occupied) {
	                statistic.meetingRoomsInuse++;
	            }
	        }
	    }
	    // else recursive loop through children
	    else if (root.children != null && root.children.length > 0) {
	            root.children.forEach(function (node) {
	                count(node, statistic, map, isStandbyAsUnOccupied);
	            });
	        }
	}
	
	function getStats(node, allSensors, isStandbyAsUnOccupied) {
	    var stats = countTreeStatistic(node, allSensors, isStandbyAsUnOccupied);
	    return stats;
	}
	
	function constructOptions(tree, options) {
	    if (tree.type !== 'customer' && tree.info.hasfloorplan) {
	        options.push({ label: tree.info.name, values: tree, useownfp: tree.info.useownfp, id: tree.id });
	    }
	    if (tree.children && tree.type !== 'meeting_room' && tree.type !== 'open_area') {
	        tree.children.forEach(function (element) {
	            if (element.type !== "sensor") {
	                constructOptions(element, options);
	            }
	        });
	    }
	}

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1931));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _slider.default;
	exports.default = _default;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _innerSlider = __webpack_require__(1932);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(1940));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(1942));
	
	var _innerSliderUtils = __webpack_require__(1935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1943);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq.default)({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq.default)({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq.default)({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps.default, this.props, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps.default, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react.default.cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react.default.createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react.default.createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react.default.createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react.default.createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react.default.createElement(_innerSlider.InnerSlider, _extends({
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	var _initialState = _interopRequireDefault(__webpack_require__(1933));
	
	var _lodash = _interopRequireDefault(__webpack_require__(1934));
	
	var _classnames = _interopRequireDefault(__webpack_require__(420));
	
	var _innerSliderUtils = __webpack_require__(1935);
	
	var _track = __webpack_require__(1936);
	
	var _dots = __webpack_require__(1937);
	
	var _arrows = __webpack_require__(1938);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1939));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	
	      var setTrackStyle = false;
	
	      var _arr = Object.keys(_this.props);
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var key = _arr[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom.default.findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react.default.Children.count(_this.props.children) !== _react.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react.default.Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== _this.state.currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
	      var className = (0, _classnames.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react.default.createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react.default.createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react.default.Component);
	
	exports.InnerSlider = InnerSlider;

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports.default = _default;

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react.default.Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom.default.findDOMNode(spec.listRef) && getHeight(_reactDom.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom.default.findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom.default.findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _classnames = _interopRequireDefault(__webpack_require__(420));
	
	var _innerSliderUtils = __webpack_require__(1935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react.default.Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react.default.Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react.default.createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react.default.createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react.default.PureComponent);
	
	exports.Track = Track;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _classnames = _interopRequireDefault(__webpack_require__(420));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames.default)({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react.default.createElement("li", {
	          key: i,
	          className: className
	        }, _react.default.cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react.default.cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react.default.PureComponent);
	
	exports.Dots = Dots;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	var _classnames = _interopRequireDefault(__webpack_require__(420));
	
	var _innerSliderUtils = __webpack_require__(1935);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames.default)(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react.default.cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, customProps));
	      } else {
	        prevArrow = _react.default.createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react.default.PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames.default)(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react.default.cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, customProps));
	      } else {
	        nextArrow = _react.default.createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react.default.PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1941);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react.default.createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react.default.createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports.default = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1944);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1945);
	var Util = __webpack_require__(1947);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1946);
	var each = __webpack_require__(1947).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 1947 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeftPaneView = __webpack_require__(1949);
	
	var _LeftPaneView2 = _interopRequireDefault(_LeftPaneView);
	
	var _RightPanel = __webpack_require__(2232);
	
	var _RightPanel2 = _interopRequireDefault(_RightPanel);
	
	exports['default'] = function (_ref) {
	    var scaleMode = _ref.scaleMode;
	    var livefeedSlides = _ref.livefeedSlides;
	    var slideCurrentIndex = _ref.slideCurrentIndex;
	    var nodeMap = _ref.nodeMap;
	    var stepNumberState = _ref.stepNumberState;
	    var editorView = _ref.editorView;
	    var sensorMap = _ref.sensorMap;
	    var mapConfigMode = _ref.mapConfigMode;
	    var dispatch = _ref.dispatch;
	    var handleOpenLocationModal = _ref.handleOpenLocationModal;
	    var focusMapApiInput = _ref.focusMapApiInput;
	
	    //scaleMode: for "Choose Template layout" feature, a snapshot/ scale version of livefeed will be rendered
	    return _react2['default'].createElement(
	        'div',
	        { className: 'livefeed-preview-wrapper' + (scaleMode ? '-scaleMode' : '') },
	        _react2['default'].createElement(
	            'div',
	            { className: 'livefeed-preview' },
	            _react2['default'].createElement(_LeftPaneView2['default'], {
	                scaleMode: scaleMode,
	                dispatch: dispatch,
	                livefeedSlides: livefeedSlides,
	                slideCurrentIndex: slideCurrentIndex,
	                nodeMap: nodeMap,
	                stepNumberState: stepNumberState,
	                editorView: editorView,
	                sensorMap: sensorMap,
	                mapConfigMode: mapConfigMode,
	                focusMapApiInput: focusMapApiInput,
	                handleOpenLocationModal: handleOpenLocationModal }),
	            _react2['default'].createElement(_RightPanel2['default'], {
	                scaleMode: scaleMode,
	                dispatch: dispatch,
	                livefeedSlide: livefeedSlides[slideCurrentIndex],
	                editorView: editorView,
	                stepNumberState: stepNumberState,
	                nodeMap: nodeMap,
	                sensorMap: sensorMap,
	                handleOpenLocationModal: handleOpenLocationModal
	            })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(1897);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _actionsLivefeedLivefeedOptions = __webpack_require__(377);
	
	var _entityLogoContainer = __webpack_require__(1950);
	
	var _entityLogoContainer2 = _interopRequireDefault(_entityLogoContainer);
	
	var _entityLineContainer = __webpack_require__(1964);
	
	var _entityLineContainer2 = _interopRequireDefault(_entityLineContainer);
	
	var _entityTextContainer = __webpack_require__(1965);
	
	var _entityTextContainer2 = _interopRequireDefault(_entityTextContainer);
	
	var _entityLocationsList = __webpack_require__(1967);
	
	var _entityLocationsList2 = _interopRequireDefault(_entityLocationsList);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _Widgets = __webpack_require__(1985);
	
	var _Widgets2 = _interopRequireDefault(_Widgets);
	
	var _FloorplanSteerPathMap = __webpack_require__(2225);
	
	var _FloorplanSteerPathMap2 = _interopRequireDefault(_FloorplanSteerPathMap);
	
	__webpack_require__(2230);
	
	exports['default'] = function (_ref) {
	    var scaleMode = _ref.scaleMode;
	    var dispatch = _ref.dispatch;
	    var livefeedSlides = _ref.livefeedSlides;
	    var slideCurrentIndex = _ref.slideCurrentIndex;
	    var nodeMap = _ref.nodeMap;
	    var stepNumberState = _ref.stepNumberState;
	    var editorView = _ref.editorView;
	    var sensorMap = _ref.sensorMap;
	    var mapConfigMode = _ref.mapConfigMode;
	    var handleOpenLocationModal = _ref.handleOpenLocationModal;
	    var focusMapApiInput = _ref.focusMapApiInput;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var textContainer = _livefeedSlides$slideCurrentIndex.textContainer;
	    var slideType = _livefeedSlides$slideCurrentIndex.slideType;
	    var locationsID = _livefeedSlides$slideCurrentIndex.floorplanOptions.locationsID;
	
	    var refinedLocationsID = [];
	    if (locationsID) {
	        refinedLocationsID = locationsID.filter(function (id) {
	            return nodeMap[id];
	        });
	    }
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(_entityLogoContainer2['default'], {
	            editorView: editorView,
	            scaleMode: scaleMode,
	            dispatch: dispatch,
	            stepNumberState: stepNumberState,
	            slideCurrentIndex: slideCurrentIndex,
	            livefeedSlides: livefeedSlides
	        }),
	        _react2['default'].createElement(_entityLineContainer2['default'], {
	            editorView: editorView,
	            scaleMode: scaleMode,
	            dispatch: dispatch,
	            stepNumberState: stepNumberState,
	            slideCurrentIndex: slideCurrentIndex,
	            livefeedSlides: livefeedSlides
	        }),
	        textContainer.length > 0 && _react2['default'].createElement(_entityTextContainer2['default'], {
	            editorView: editorView,
	            scaleMode: scaleMode,
	            dispatch: dispatch,
	            stepNumberState: stepNumberState,
	            slideCurrentIndex: slideCurrentIndex,
	            livefeedSlides: livefeedSlides
	        }),
	        slideType === "locationsList" && _react2['default'].createElement(_entityLocationsList2['default'], { scaleMode: scaleMode }),
	        slideType === "summary" && _react2['default'].createElement(
	            _react.Fragment,
	            null,
	            _react2['default'].createElement(_Widgets2['default'], {
	                dispatch: dispatch,
	                scaleMode: scaleMode,
	                livefeedSlides: livefeedSlides,
	                slideCurrentIndex: slideCurrentIndex,
	                sensorMap: sensorMap,
	                nodeMap: nodeMap,
	                editorView: editorView,
	                stepNumberState: stepNumberState
	            }),
	            !refinedLocationsID.length > 0 && _react2['default'].createElement(
	                'div',
	                { className: 'summary-location', onClick: handleOpenLocationModal },
	                'Choose locations to be displayed on slide show'
	            )
	        ),
	        _react2['default'].createElement(LeftPanelContainer, {
	            scaleMode: scaleMode,
	            nodeMap: nodeMap,
	            sensorMap: sensorMap,
	            livefeedSlide: livefeedSlides[slideCurrentIndex],
	            handleOpenLocationModal: handleOpenLocationModal,
	            focusMapApiInput: focusMapApiInput,
	            mapConfigMode: mapConfigMode,
	            editorView: editorView,
	            stepNumberState: stepNumberState,
	            dispatch: dispatch,
	            slideCurrentIndex: slideCurrentIndex
	        })
	    );
	};
	
	var LeftPanelContainer = function LeftPanelContainer(_ref2) {
	    var scaleMode = _ref2.scaleMode;
	    var dispatch = _ref2.dispatch;
	    var mapConfigMode = _ref2.mapConfigMode;
	    var focusMapApiInput = _ref2.focusMapApiInput;
	    var livefeedSlide = _ref2.livefeedSlide;
	    var editorView = _ref2.editorView;
	    var stepNumberState = _ref2.stepNumberState;
	    var slideCurrentIndex = _ref2.slideCurrentIndex;
	    var nodeMap = _ref2.nodeMap;
	    var handleOpenLocationModal = _ref2.handleOpenLocationModal;
	    var slideBg = livefeedSlide.slideBg;
	    var leftPanelBg = livefeedSlide.leftPanelBg;
	    var _livefeedSlide$floorplanOptions = livefeedSlide.floorplanOptions;
	    _livefeedSlide$floorplanOptions = _livefeedSlide$floorplanOptions === undefined ? {} : _livefeedSlide$floorplanOptions;
	    var locationsID = _livefeedSlide$floorplanOptions.locationsID;
	    var fontFamily = livefeedSlide.fontFamily;
	    var historyEntities = livefeedSlide.historyEntities;
	    var slideType = livefeedSlide.slideType;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	
	    var removeCurrentEntitty = (0, _react.useCallback)(function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var emptyEntity = { id: null, fontFamily: fontFamily }; // Prevent duplicate dispatch
	        (0, _lodash.isEqual)(emptyEntity, currentEntity) === false && dispatch((0, _actionsLivefeed.updateEmptyEntity)());
	    }, [currentEntity, dispatch, fontFamily]);
	
	    var handleRightClick = (0, _react.useCallback)(function (e) {
	        e.stopPropagation();e.preventDefault();
	        dispatch((0, _actionsLivefeed.setEditorView)(!editorView));
	        removeCurrentEntitty(e);
	    }, [dispatch, editorView, removeCurrentEntitty]);
	
	    // single option
	    var setLivefeedOptionsHandle = (0, _react.useCallback)(function (type, value) {
	        dispatch((0, _actionsLivefeedLivefeedOptions.setLivefeedOptions)(type, value));
	    }, [dispatch]);
	
	    function renderFloorplan() {
	        if (slideType !== "summary" && slideType !== "locationsList") {
	            var _livefeedSlide$floorplanOptions2 = livefeedSlide.floorplanOptions;
	            var mapApiKey = _livefeedSlide$floorplanOptions2.mapApiKey;
	            var liveApiKey = _livefeedSlide$floorplanOptions2.liveApiKey;
	            var mapConfig = _livefeedSlide$floorplanOptions2.mapConfig;
	
	            var refinedLocationsID = [];
	            if (locationsID) {
	                refinedLocationsID = locationsID.filter(function (id) {
	                    return nodeMap[id];
	                });
	            }
	            return _react2['default'].createElement(
	                'div',
	                { className: 'floorplan-preview',
	                    style: {
	                        top: 126 * (scaleMode ? 0.375 : 1),
	                        bottom: 33 * (scaleMode ? 0.375 : 1),
	                        left: 33 * (scaleMode ? 0.375 : 1),
	                        right: 33 * (scaleMode ? 0.375 : 1)
	                    } },
	                mapApiKey ? !scaleMode ? _react2['default'].createElement(_FloorplanSteerPathMap2['default'], {
	                    dispatch: dispatch,
	                    setLivefeedOptionsHandle: setLivefeedOptionsHandle,
	                    mapApiKey: mapApiKey,
	                    liveApiKey: liveApiKey,
	                    mapConfigMode: mapConfigMode,
	                    mapConfig: mapConfig,
	                    slideCurrentIndex: slideCurrentIndex
	                }) : _react2['default'].createElement('div', { className: 'map-placeholder', style: {
	                        width: '100%',
	                        height: '100%',
	                        backgroundColor: '#9b9b9b'
	                    } }) : _react2['default'].createElement(
	                    _react2['default'].Fragment,
	                    null,
	                    refinedLocationsID && refinedLocationsID.length > 0 && _react2['default'].createElement(
	                        'div',
	                        { style: { fontSize: 20 * (scaleMode ? 0.375 : 1) }, onClick: focusMapApiInput,
	                            className: 'floorplan-info' },
	                        'Please set map API key first'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'floorplan-info',
	                        style: {
	                            fontSize: 20 * (scaleMode ? 0.375 : 1)
	                        },
	                        onClick: handleOpenLocationModal
	                    },
	                    refinedLocationsID && !refinedLocationsID.length > 0 && "No chosen senzolive locations. Click to choose locations"
	                )
	            );
	        }
	    }
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'pane left',
	                onClick: function (e) {
	                    return !scaleMode ? removeCurrentEntitty(e) : null;
	                },
	                onContextMenu: function (e) {
	                    return ("production") === 'production' && !scaleMode && handleRightClick(e);
	                },
	                style: {
	                    zIndex: 0,
	                    width: slideType === "summary" || slideType === "locationsList" ? "100%" : _componentsPagesLivefeedDefaultstate.livefeedStyle.leftPaneWidth + "%",
	                    backgroundColor: slideType === "summary" || slideType === "locationsList" ? slideBg.color : leftPanelBg.color
	                } },
	            renderFloorplan()
	        )
	    );
	};
	module.exports = exports['default'];
	/* Only display if senzolive locations have been chosen */

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _RndStyle = __webpack_require__(1963);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	/*
	Special rule for using react-rnd
	If the entity has padding and border: for example padding 5, border 1
	then onDragStop or onResizeStop will return x,y and width include padding + border
	So,if the padding and border for are added for editor view only,
	the actual value need to be calculated. ( minos 6 for x,y and minos 12 for width)
	But the position value props and size set on react-rnd component need to plus 6 for x,y and 12 for width from state,.
	*/
	var LogoContainer = function LogoContainer(_ref) {
	    var editorView = _ref.editorView;
	    var scaleMode = _ref.scaleMode;
	    var dispatch = _ref.dispatch;
	    var stepNumberState = _ref.stepNumberState;
	    var slideCurrentIndex = _ref.slideCurrentIndex;
	    var livefeedSlides = _ref.livefeedSlides;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var logoState = _livefeedSlides$slideCurrentIndex.logoState;
	    var historyEntities = _livefeedSlides$slideCurrentIndex.historyEntities;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	
	    var isLogoUploaded = logoState.url ? true : false;
	    var enableResizing = {
	        bottom: isLogoUploaded, bottomLeft: isLogoUploaded, bottomRight: isLogoUploaded,
	        left: isLogoUploaded, right: isLogoUploaded, top: isLogoUploaded,
	        topLeft: isLogoUploaded, topRight: isLogoUploaded
	    };
	
	    var setLogoPos = (0, _react.useCallback)(function (newPosition) {
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        // prevent duplicate dispatch
	        if (logoState.left !== x || logoState.top !== y) {
	            var newLogoState = (0, _immutabilityHelper2['default'])(logoState, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: "" },
	                activeToolbarItems: _defineProperty({}, 0, { align: { $set: "" } })
	            });
	            dispatch((0, _actionsLivefeed.updateLogo)(newLogoState));
	        }
	    }, [dispatch, logoState]);
	
	    var setLogoSize = (0, _react.useCallback)(function (width, newPosition) {
	        var newWidth = width > 534 ? 534 : width; // maximum width 534
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        var align = '' + (logoState.left === x ? '' + logoState.activeToolbarItems[0].align : ""); // if x doesn't change, keep toolbar active
	        if (logoState.width !== width || logoState.left !== newPosition.x) {
	            var newLogoState = (0, _immutabilityHelper2['default'])(logoState, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: align },
	                width: { $set: newWidth },
	                activeToolbarItems: _defineProperty({}, 0, {
	                    align: { $set: align }
	                })
	            });
	            dispatch((0, _actionsLivefeed.updateLogo)(newLogoState));
	        }
	    }, [dispatch, logoState]);
	
	    var logoUploadHandler = (0, _react.useCallback)(function (e) {
	        var reader = new FileReader();
	        var file = e.target.files[0];
	        reader.onloadend = function () {
	            dispatch(a.uploadLogo(file));
	        };
	        file && reader.readAsDataURL(file);
	    }, [dispatch]);
	    var handleSetCurrentEntityCallback = (0, _react.useCallback)(function () {
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, logoState, dispatch);
	    }, [currentEntity, dispatch, logoState]);
	
	    var _useHover = (0, _componentsCommonHooks.useHover)();
	
	    var _useHover2 = _slicedToArray(_useHover, 2);
	
	    var logoHoverRef = _useHover2[0];
	    var isLogoHovered = _useHover2[1];
	
	    var fixZindexIssue = isLogoHovered ? { zIndex: 3 } : {};
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        logoState.show && (editorView ? _react2['default'].createElement(
	            _reactRnd.Rnd,
	            {
	                bounds: ".livefeed-preview-wrapper",
	                'data-tooltip': '' + (!isLogoUploaded ? 'Click upload icon to upload \n Recommended file type: PNG\n To delete Logo Placeholder, simply click the text then click Delete icon on the toolbar ' : 'Click on the corner and drag to resize \n Click and drag to the desired position\n Current width ' + logoState.width + 'px'),
	                style: _extends({
	                    padding: isLogoUploaded ? '5px' : 0
	                }, fixZindexIssue),
	                enableResizing: enableResizing,
	                disableDragging: !isLogoUploaded,
	                className: 'entity-resizable ' + (isLogoUploaded ? '' : 'logo-resizable_bg') + ' ' + (currentEntity.id === 'logo' ? 'entity-active' : '') + ' ',
	                lockAspectRatio: true,
	                resizeHandleWrapperClass: "resizers",
	                resizeHandleStyles: {
	                    topRight: _RndStyle.RndStyle.topRight, topLeft: _RndStyle.RndStyle.topLeft,
	                    bottomLeft: _RndStyle.RndStyle.bottomLeft, bottomRight: _RndStyle.RndStyle.bottomRight
	                },
	                // Size width need to plus 12 due to padding 5 and border 1
	                size: { width: logoState.url ? logoState.width * (scaleMode ? 0.375 : 1) + 12 : 180 * (scaleMode ? 0.375 : 1), height: "auto" },
	                position: { x: logoState.left * (scaleMode ? 0.375 : 1) - 6, y: logoState.top * (scaleMode ? 0.375 : 1) - 6 }, // minus padding+border
	                onClick: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onDragStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onDragStop: function (e, d) {
	                    return setLogoPos((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(d));
	                },
	                onResizeStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onResizeStop: function (e, direction, ref, delta, position) {
	                    return position.x !== 0 && setLogoSize(ref.offsetWidth - 12, (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(position));
	                }
	            },
	            _react2['default'].createElement(
	                'div',
	                { ref: logoHoverRef, className: 'logo-wrapper ' + (!isLogoUploaded && "upload-btn") },
	                isLogoUploaded ? _react2['default'].createElement('img', { alt: 'Logo Placeholder', id: logoState.id, draggable: 'false', src: logoState.url }) : _react2['default'].createElement(
	                    _react2['default'].Fragment,
	                    null,
	                    _react2['default'].createElement('input', { id: 'logo', type: 'file', onChange: function (e) {
	                            return logoUploadHandler(e);
	                        } }),
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        'Logo Placeholder'
	                    ),
	                    ' ',
	                    _react2['default'].createElement(
	                        'label',
	                        { htmlFor: 'logo' },
	                        _react2['default'].createElement(
	                            'i',
	                            { className: 'material-icons' },
	                            'backup'
	                        )
	                    )
	                )
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            {
	                style: {
	                    padding: logoState.url ? 5 : 0,
	                    position: "absolute",
	                    width: logoState.url ? logoState.width * (scaleMode ? 0.375 : 1) + 12 : 180 * (scaleMode ? 0.375 : 1),
	                    height: "auto",
	                    pointerEvents: "none",
	                    left: logoState.left * (scaleMode ? 0.375 : 1) - 6,
	                    top: logoState.top * (scaleMode ? 0.375 : 1) - 6
	                },
	                className: 'entity-resizable ' + (isLogoUploaded ? '' : 'logo-resizable_bg') + ' editor-view_false'
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'logo-wrapper ' + (!isLogoUploaded && "upload-btn") },
	                isLogoUploaded ? _react2['default'].createElement('img', { id: logoState.id, draggable: 'false', src: logoState.url }) : _react2['default'].createElement(
	                    _react2['default'].Fragment,
	                    null,
	                    _react2['default'].createElement('input', { id: 'logo', disabled: true, type: 'file', readOnly: true }),
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        'Logo Placeholder'
	                    ),
	                    ' ',
	                    _react2['default'].createElement(
	                        'i',
	                        { className: 'material-icons' },
	                        'backup'
	                    )
	                )
	            )
	        ))
	    );
	};
	exports['default'] = LogoContainer;
	module.exports = exports['default'];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(38);
	var DraggableRoot = _interopDefault(__webpack_require__(1952));
	var reResizable = __webpack_require__(1961);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}
	
	var Draggable = DraggableRoot;
	var resizableStyle = {
	    width: "auto",
	    height: "auto",
	    display: "inline-block",
	    position: "absolute",
	    top: 0,
	    left: 0,
	};
	var getEnableResizingByFlag = function (flag) { return ({
	    bottom: flag,
	    bottomLeft: flag,
	    bottomRight: flag,
	    left: flag,
	    right: flag,
	    top: flag,
	    topLeft: flag,
	    topRight: flag,
	}); };
	var Rnd = /** @class */ (function (_super) {
	    __extends(Rnd, _super);
	    function Rnd(props) {
	        var _this = _super.call(this, props) || this;
	        _this.resizingPosition = { x: 0, y: 0 };
	        _this.offsetFromParent = { left: 0, top: 0 };
	        _this.resizableElement = { current: null };
	        _this.originalPosition = { x: 0, y: 0 };
	        _this.refDraggable = function (c) {
	            if (!c)
	                return;
	            _this.draggable = c;
	        };
	        _this.refResizable = function (c) {
	            if (!c)
	                return;
	            _this.resizable = c;
	            _this.resizableElement.current = c.resizable;
	        };
	        _this.state = {
	            resizing: false,
	            bounds: {
	                top: 0,
	                right: 0,
	                bottom: 0,
	                left: 0,
	            },
	            maxWidth: props.maxWidth,
	            maxHeight: props.maxHeight,
	        };
	        _this.onResizeStart = _this.onResizeStart.bind(_this);
	        _this.onResize = _this.onResize.bind(_this);
	        _this.onResizeStop = _this.onResizeStop.bind(_this);
	        _this.onDragStart = _this.onDragStart.bind(_this);
	        _this.onDrag = _this.onDrag.bind(_this);
	        _this.onDragStop = _this.onDragStop.bind(_this);
	        _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
	        return _this;
	    }
	    Rnd.prototype.componentDidMount = function () {
	        this.updateOffsetFromParent();
	        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
	        var _b = this.getDraggablePosition(), x = _b.x, y = _b.y;
	        this.draggable.setState({
	            x: x - left,
	            y: y - top,
	        });
	        // HACK: Apply position adjustment
	        this.forceUpdate();
	    };
	    // HACK: To get `react-draggable` state x and y.
	    Rnd.prototype.getDraggablePosition = function () {
	        var _a = this.draggable.state, x = _a.x, y = _a.y;
	        return { x: x, y: y };
	    };
	    Rnd.prototype.getParent = function () {
	        return this.resizable && this.resizable.parentNode;
	    };
	    Rnd.prototype.getParentSize = function () {
	        return this.resizable.getParentSize();
	    };
	    Rnd.prototype.getMaxSizesFromProps = function () {
	        var maxWidth = typeof this.props.maxWidth === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
	        var maxHeight = typeof this.props.maxHeight === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
	        return { maxWidth: maxWidth, maxHeight: maxHeight };
	    };
	    Rnd.prototype.getSelfElement = function () {
	        return this.resizable && this.resizable.resizable;
	    };
	    Rnd.prototype.getOffsetHeight = function (boundary) {
	        var scale = this.props.scale;
	        switch (this.props.bounds) {
	            case "window":
	                return window.innerHeight / scale;
	            case "body":
	                return document.body.offsetHeight / scale;
	            default:
	                return boundary.offsetHeight;
	        }
	    };
	    Rnd.prototype.getOffsetWidth = function (boundary) {
	        var scale = this.props.scale;
	        switch (this.props.bounds) {
	            case "window":
	                return window.innerWidth / scale;
	            case "body":
	                return document.body.offsetWidth / scale;
	            default:
	                return boundary.offsetWidth;
	        }
	    };
	    Rnd.prototype.onDragStart = function (e, data) {
	        if (this.props.onDragStart) {
	            this.props.onDragStart(e, data);
	        }
	        var pos = this.getDraggablePosition();
	        this.originalPosition = pos;
	        if (!this.props.bounds)
	            return;
	        var parent = this.getParent();
	        var scale = this.props.scale;
	        var boundary;
	        if (this.props.bounds === "parent") {
	            boundary = parent;
	        }
	        else if (this.props.bounds === "body") {
	            var parentRect_1 = parent.getBoundingClientRect();
	            var parentLeft_1 = parentRect_1.left;
	            var parentTop_1 = parentRect_1.top;
	            var bodyRect = document.body.getBoundingClientRect();
	            var left_1 = -(parentLeft_1 - parent.offsetLeft * scale - bodyRect.left) / scale;
	            var top_1 = -(parentTop_1 - parent.offsetTop * scale - bodyRect.top) / scale;
	            var right = (document.body.offsetWidth - this.resizable.size.width * scale) / scale + left_1;
	            var bottom = (document.body.offsetHeight - this.resizable.size.height * scale) / scale + top_1;
	            return this.setState({ bounds: { top: top_1, right: right, bottom: bottom, left: left_1 } });
	        }
	        else if (this.props.bounds === "window") {
	            if (!this.resizable)
	                return;
	            var parentRect_2 = parent.getBoundingClientRect();
	            var parentLeft_2 = parentRect_2.left;
	            var parentTop_2 = parentRect_2.top;
	            var left_2 = -(parentLeft_2 - parent.offsetLeft * scale) / scale;
	            var top_2 = -(parentTop_2 - parent.offsetTop * scale) / scale;
	            var right = (window.innerWidth - this.resizable.size.width * scale) / scale + left_2;
	            var bottom = (window.innerHeight - this.resizable.size.height * scale) / scale + top_2;
	            return this.setState({ bounds: { top: top_2, right: right, bottom: bottom, left: left_2 } });
	        }
	        else {
	            boundary = document.querySelector(this.props.bounds);
	        }
	        if (!(boundary instanceof HTMLElement) || !(parent instanceof HTMLElement)) {
	            return;
	        }
	        var boundaryRect = boundary.getBoundingClientRect();
	        var boundaryLeft = boundaryRect.left;
	        var boundaryTop = boundaryRect.top;
	        var parentRect = parent.getBoundingClientRect();
	        var parentLeft = parentRect.left;
	        var parentTop = parentRect.top;
	        var left = (boundaryLeft - parentLeft) / scale;
	        var top = boundaryTop - parentTop;
	        if (!this.resizable)
	            return;
	        this.updateOffsetFromParent();
	        var offset = this.offsetFromParent;
	        this.setState({
	            bounds: {
	                top: top - offset.top,
	                right: left + (boundary.offsetWidth - this.resizable.size.width) - offset.left / scale,
	                bottom: top + (boundary.offsetHeight - this.resizable.size.height) - offset.top,
	                left: left - offset.left / scale,
	            },
	        });
	    };
	    Rnd.prototype.onDrag = function (e, data) {
	        if (!this.props.onDrag)
	            return;
	        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
	        if (!this.props.dragAxis || this.props.dragAxis === "both") {
	            return this.props.onDrag(e, __assign(__assign({}, data), { x: data.x - left, y: data.y - top }));
	        }
	        else if (this.props.dragAxis === "x") {
	            return this.props.onDrag(e, __assign(__assign({}, data), { x: data.x + left, y: this.originalPosition.y + top, deltaY: 0 }));
	        }
	        else if (this.props.dragAxis === "y") {
	            return this.props.onDrag(e, __assign(__assign({}, data), { x: this.originalPosition.x + left, y: data.y + top, deltaX: 0 }));
	        }
	    };
	    Rnd.prototype.onDragStop = function (e, data) {
	        if (!this.props.onDragStop)
	            return;
	        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
	        if (!this.props.dragAxis || this.props.dragAxis === "both") {
	            return this.props.onDragStop(e, __assign(__assign({}, data), { x: data.x + left, y: data.y + top }));
	        }
	        else if (this.props.dragAxis === "x") {
	            return this.props.onDragStop(e, __assign(__assign({}, data), { x: data.x + left, y: this.originalPosition.y + top, deltaY: 0 }));
	        }
	        else if (this.props.dragAxis === "y") {
	            return this.props.onDragStop(e, __assign(__assign({}, data), { x: this.originalPosition.x + left, y: data.y + top, deltaX: 0 }));
	        }
	    };
	    Rnd.prototype.onResizeStart = function (e, dir, elementRef) {
	        e.stopPropagation();
	        this.setState({
	            resizing: true,
	        });
	        var scale = this.props.scale;
	        var offset = this.offsetFromParent;
	        var pos = this.getDraggablePosition();
	        this.resizingPosition = { x: pos.x + offset.left, y: pos.y + offset.top };
	        this.originalPosition = pos;
	        if (this.props.bounds) {
	            var parent_1 = this.getParent();
	            var boundary = void 0;
	            if (this.props.bounds === "parent") {
	                boundary = parent_1;
	            }
	            else if (this.props.bounds === "body") {
	                boundary = document.body;
	            }
	            else if (this.props.bounds === "window") {
	                boundary = window;
	            }
	            else {
	                boundary = document.querySelector(this.props.bounds);
	            }
	            var self_1 = this.getSelfElement();
	            if (self_1 instanceof Element &&
	                (boundary instanceof HTMLElement || boundary === window) &&
	                parent_1 instanceof HTMLElement) {
	                var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
	                var parentSize = this.getParentSize();
	                if (maxWidth && typeof maxWidth === "string") {
	                    if (maxWidth.endsWith("%")) {
	                        var ratio = Number(maxWidth.replace("%", "")) / 100;
	                        maxWidth = parentSize.width * ratio;
	                    }
	                    else if (maxWidth.endsWith("px")) {
	                        maxWidth = Number(maxWidth.replace("px", ""));
	                    }
	                }
	                if (maxHeight && typeof maxHeight === "string") {
	                    if (maxHeight.endsWith("%")) {
	                        var ratio = Number(maxHeight.replace("%", "")) / 100;
	                        maxHeight = parentSize.width * ratio;
	                    }
	                    else if (maxHeight.endsWith("px")) {
	                        maxHeight = Number(maxHeight.replace("px", ""));
	                    }
	                }
	                var selfRect = self_1.getBoundingClientRect();
	                var selfLeft = selfRect.left;
	                var selfTop = selfRect.top;
	                var boundaryRect = this.props.bounds === "window" ? { left: 0, top: 0 } : boundary.getBoundingClientRect();
	                var boundaryLeft = boundaryRect.left;
	                var boundaryTop = boundaryRect.top;
	                var offsetWidth = this.getOffsetWidth(boundary);
	                var offsetHeight = this.getOffsetHeight(boundary);
	                var hasLeft = dir.toLowerCase().endsWith("left");
	                var hasRight = dir.toLowerCase().endsWith("right");
	                var hasTop = dir.startsWith("top");
	                var hasBottom = dir.startsWith("bottom");
	                if ((hasLeft || hasTop) && this.resizable) {
	                    var max = (selfLeft - boundaryLeft) / scale + this.resizable.size.width;
	                    this.setState({ maxWidth: max > Number(maxWidth) ? maxWidth : max });
	                }
	                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
	                if (hasRight || (this.props.lockAspectRatio && !hasLeft && !hasTop)) {
	                    var max = offsetWidth + (boundaryLeft - selfLeft) / scale;
	                    this.setState({ maxWidth: max > Number(maxWidth) ? maxWidth : max });
	                }
	                if ((hasTop || hasLeft) && this.resizable) {
	                    var max = (selfTop - boundaryTop) / scale + this.resizable.size.height;
	                    this.setState({
	                        maxHeight: max > Number(maxHeight) ? maxHeight : max,
	                    });
	                }
	                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
	                if (hasBottom || (this.props.lockAspectRatio && !hasTop && !hasLeft)) {
	                    var max = offsetHeight + (boundaryTop - selfTop) / scale;
	                    this.setState({
	                        maxHeight: max > Number(maxHeight) ? maxHeight : max,
	                    });
	                }
	            }
	        }
	        else {
	            this.setState({
	                maxWidth: this.props.maxWidth,
	                maxHeight: this.props.maxHeight,
	            });
	        }
	        if (this.props.onResizeStart) {
	            this.props.onResizeStart(e, dir, elementRef);
	        }
	    };
	    Rnd.prototype.onResize = function (e, direction, elementRef, delta) {
	        // INFO: Apply x and y position adjustments caused by resizing to draggable
	        var newPos = { x: this.originalPosition.x, y: this.originalPosition.y };
	        var left = -delta.width;
	        var top = -delta.height;
	        var directions = ["top", "left", "topLeft", "bottomLeft", "topRight"];
	        if (directions.indexOf(direction) !== -1) {
	            if (direction === "bottomLeft") {
	                newPos.x += left;
	            }
	            else if (direction === "topRight") {
	                newPos.y += top;
	            }
	            else {
	                newPos.x += left;
	                newPos.y += top;
	            }
	        }
	        if (newPos.x !== this.draggable.state.x || newPos.y !== this.draggable.state.y) {
	            this.draggable.setState(newPos);
	        }
	        this.updateOffsetFromParent();
	        var offset = this.offsetFromParent;
	        var x = this.getDraggablePosition().x + offset.left;
	        var y = this.getDraggablePosition().y + offset.top;
	        this.resizingPosition = { x: x, y: y };
	        if (!this.props.onResize)
	            return;
	        this.props.onResize(e, direction, elementRef, delta, {
	            x: x,
	            y: y,
	        });
	    };
	    Rnd.prototype.onResizeStop = function (e, direction, elementRef, delta) {
	        this.setState({
	            resizing: false,
	        });
	        var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
	        this.setState({ maxWidth: maxWidth, maxHeight: maxHeight });
	        if (this.props.onResizeStop) {
	            this.props.onResizeStop(e, direction, elementRef, delta, this.resizingPosition);
	        }
	    };
	    Rnd.prototype.updateSize = function (size) {
	        if (!this.resizable)
	            return;
	        this.resizable.updateSize({ width: size.width, height: size.height });
	    };
	    Rnd.prototype.updatePosition = function (position) {
	        this.draggable.setState(position);
	    };
	    Rnd.prototype.updateOffsetFromParent = function () {
	        var scale = this.props.scale;
	        var parent = this.getParent();
	        var self = this.getSelfElement();
	        if (!parent || self === null) {
	            return {
	                top: 0,
	                left: 0,
	            };
	        }
	        var parentRect = parent.getBoundingClientRect();
	        var parentLeft = parentRect.left;
	        var parentTop = parentRect.top;
	        var selfRect = self.getBoundingClientRect();
	        var position = this.getDraggablePosition();
	        var scrollLeft = parent.scrollLeft;
	        var scrollTop = parent.scrollTop;
	        this.offsetFromParent = {
	            left: selfRect.left - parentLeft + scrollLeft - position.x * scale,
	            top: selfRect.top - parentTop + scrollTop - position.y * scale,
	        };
	    };
	    Rnd.prototype.render = function () {
	        var _a = this.props, disableDragging = _a.disableDragging, style = _a.style, dragHandleClassName = _a.dragHandleClassName, position = _a.position, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, dragAxis = _a.dragAxis, dragGrid = _a.dragGrid, bounds = _a.bounds, enableUserSelectHack = _a.enableUserSelectHack, cancel = _a.cancel, children = _a.children, onResizeStart = _a.onResizeStart, onResize = _a.onResize, onResizeStop = _a.onResizeStop, onDragStart = _a.onDragStart, onDrag = _a.onDrag, onDragStop = _a.onDragStop, resizeHandleStyles = _a.resizeHandleStyles, resizeHandleClasses = _a.resizeHandleClasses, resizeHandleComponent = _a.resizeHandleComponent, enableResizing = _a.enableResizing, resizeGrid = _a.resizeGrid, resizeHandleWrapperClass = _a.resizeHandleWrapperClass, resizeHandleWrapperStyle = _a.resizeHandleWrapperStyle, scale = _a.scale, allowAnyClick = _a.allowAnyClick, resizableProps = __rest(_a, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick"]);
	        var defaultValue = this.props.default ? __assign({}, this.props.default) : undefined;
	        // Remove unknown props, see also https://reactjs.org/warnings/unknown-prop.html
	        delete resizableProps.default;
	        var cursorStyle = disableDragging || dragHandleClassName ? { cursor: "auto" } : { cursor: "move" };
	        var innerStyle = __assign(__assign(__assign({}, resizableStyle), cursorStyle), style);
	        var _b = this.offsetFromParent, left = _b.left, top = _b.top;
	        var draggablePosition;
	        if (position) {
	            draggablePosition = {
	                x: position.x - left,
	                y: position.y - top,
	            };
	        }
	        // INFO: Make uncontorolled component when resizing to control position by setPostion.
	        var pos = this.state.resizing ? undefined : draggablePosition;
	        var dragAxisOrUndefined = this.state.resizing ? "both" : dragAxis;
	        return (React.createElement(Draggable, { ref: this.refDraggable, handle: dragHandleClassName ? ".".concat(dragHandleClassName) : undefined, defaultPosition: defaultValue, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop, axis: dragAxisOrUndefined, disabled: disableDragging, grid: dragGrid, bounds: bounds ? this.state.bounds : undefined, position: pos, enableUserSelectHack: enableUserSelectHack, cancel: cancel, scale: scale, allowAnyClick: allowAnyClick, nodeRef: this.resizableElement },
	            React.createElement(reResizable.Resizable, __assign({}, resizableProps, { ref: this.refResizable, defaultSize: defaultValue, size: this.props.size, enable: typeof enableResizing === "boolean" ? getEnableResizingByFlag(enableResizing) : enableResizing, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: innerStyle, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight, grid: resizeGrid, handleWrapperClass: resizeHandleWrapperClass, handleWrapperStyle: resizeHandleWrapperStyle, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: resizeHandleStyles, handleClasses: resizeHandleClasses, handleComponent: resizeHandleComponent, scale: this.props.scale }), children)));
	    };
	    Rnd.defaultProps = {
	        maxWidth: Number.MAX_SAFE_INTEGER,
	        maxHeight: Number.MAX_SAFE_INTEGER,
	        scale: 1,
	        onResizeStart: function () { },
	        onResize: function () { },
	        onResizeStop: function () { },
	        onDragStart: function () { },
	        onDrag: function () { },
	        onDragStop: function () { },
	    };
	    return Rnd;
	}(React.PureComponent));
	
	exports.Rnd = Rnd;


/***/ }),
/* 1952 */
[2371, 1953],
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function get() {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(53));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	var _clsx2 = _interopRequireDefault(__webpack_require__(1954));
	
	var _domFns = __webpack_require__(1955);
	
	var _positionFns = __webpack_require__(1958);
	
	var _shims = __webpack_require__(1956);
	
	var _DraggableCore = _interopRequireDefault(__webpack_require__(1959));
	
	var _log = _interopRequireDefault(__webpack_require__(1960));
	
	var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//
	// Define <Draggable>
	//
	var Draggable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  var _super = _createSuper(Draggable);
	
	  function Draggable(props
	  /*: DraggableProps*/
	  ) {
	    var _this;
	
	    _classCallCheck(this, Draggable);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
	
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
	
	
	      if (shouldStart === false) return false;
	
	      _this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        x: uiData.x,
	        y: uiData.y
	      }; // Keep within bounds.
	
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var x = newState.x,
	            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
	
	        newState.slackX = _this.state.slackX + (x - newState.x);
	        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
	
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      } // Short-circuit if user's callback killed it.
	
	
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
	      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
	
	      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));
	
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      }; // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	
	      var controlled = Boolean(_this.props.position);
	
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            x = _this$props$position.x,
	            y = _this$props$position.y;
	        newState.x = x;
	        newState.y = y;
	      }
	
	      _this.setState(newState);
	    });
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: _objectSpread({}, props.position),
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	        this.setState({
	          isElementSVG: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        dragging: false
	      }); // prevents invariant if unmounted while dragging
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: ReactElement<any>*/
	    {
	      var _clsx;
	
	      var _this$props2 = this.props,
	          axis = _this$props2.axis,
	          bounds = _this$props2.bounds,
	          children = _this$props2.children,
	          defaultPosition = _this$props2.defaultPosition,
	          defaultClassName = _this$props2.defaultClassName,
	          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
	          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
	          position = _this$props2.position,
	          positionOffset = _this$props2.positionOffset,
	          scale = _this$props2.scale,
	          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
	
	      var style = {};
	      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
	
	      var controlled = Boolean(position);
	      var draggable = !controlled || this.state.dragging;
	      var validPosition = position || defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	      }; // If this element was SVG, we use the `transform` attribute.
	
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	      } // Mark with class while dragging
	
	
	      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	
	      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	        onStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onStop: this.onDragStop
	      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	        className: className,
	        style: _objectSpread(_objectSpread({}, children.props.style), style),
	        transform: svgTransform
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: // React 16.3+
	    // Arity (props, state)
	    function getDerivedStateFromProps(_ref, _ref2)
	    /*: ?$Shape<DraggableState>*/
	    {
	      var position = _ref.position;
	      var prevPropsPosition = _ref2.prevPropsPosition;
	
	      // Set x/y if a new position is provided in props that is different than the previous.
	      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	          position: position,
	          prevPropsPosition: prevPropsPosition
	        });
	        return {
	          x: position.x,
	          y: position.y,
	          prevPropsPosition: _objectSpread({}, position)
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	exports.default = Draggable;
	
	_defineProperty(Draggable, "displayName", 'Draggable');
	
	_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	}));
	
	_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}));

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
	
		if (typeof mix === 'string' || typeof mix === 'number') {
			str += mix;
		} else if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k]) {
						if (y = toVal(mix[k])) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else {
				for (k in mix) {
					if (mix[k]) {
						str && (str += ' ');
						str += k;
					}
				}
			}
		}
	
		return str;
	}
	
	module.exports = function () {
		var i=0, tmp, x, str='';
		while (i < arguments.length) {
			if (tmp = arguments[i++]) {
				if (x = toVal(tmp)) {
					str && (str += ' ');
					str += x
				}
			}
		}
		return str;
	}


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTranslation = getTranslation;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	exports.addClassName = addClassName;
	exports.removeClassName = removeClassName;
	
	var _shims = __webpack_require__(1956);
	
	var _getPrefix = _interopRequireWildcard(__webpack_require__(1957));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var matchesSelectorFunc = '';
	
	function matchesSelector(el
	/*: Node*/
	, selector
	/*: string*/
	)
	/*: boolean*/
	{
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  } // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	
	
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
	
	  return el[matchesSelectorFunc](selector);
	} // Works up the tree to the draggable itself attempting to match selector.
	
	
	function matchesSelectorAndParentsTo(el
	/*: Node*/
	, selector
	/*: string*/
	, baseNode
	/*: Node*/
	)
	/*: boolean*/
	{
	  var node = el;
	
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.addEventListener) {
	    el.addEventListener(event, handler, options);
	  } else if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.removeEventListener) {
	    el.removeEventListener(event, handler, options);
	  } else if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	
	function innerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	/*:: interface EventWithOffset {
	  clientX: number, clientY: number
	}*/
	
	
	// Get from offsetParent
	function offsetXYFromParent(evt
	/*: EventWithOffset*/
	, offsetParent
	/*: HTMLElement*/
	, scale
	/*: number*/
	)
	/*: ControlPosition*/
	{
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
	  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
	  return {
	    x: x,
	    y: y
	  };
	}
	
	function createCSSTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: Object*/
	{
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
	}
	
	function createSVGTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: string*/
	{
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	
	function getTranslation(_ref2, positionOffset
	/*: PositionOffsetControlPosition*/
	, unitSuffix
	/*: string*/
	)
	/*: string*/
	{
	  var x = _ref2.x,
	      y = _ref2.y;
	  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
	
	  if (positionOffset) {
	    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
	  }
	
	  return translation;
	}
	
	function getTouch(e
	/*: MouseTouchEvent*/
	, identifier
	/*: number*/
	)
	/*: ?{clientX: number, clientY: number}*/
	{
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e
	/*: MouseTouchEvent*/
	)
	/*: ?number*/
	{
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	} // User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	// Note we're passing `document` b/c we could be iframed
	
	
	function addUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	
	  try {
	    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
	
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      // Remove selection caused by scroll, unless it's a focused input
	      // (we use doc.defaultView in case we're in an iframe)
	      var selection = (doc.defaultView || window).getSelection();
	
	      if (selection && selection.type !== 'Caret') {
	        selection.removeAllRanges();
	      }
	    }
	  } catch (e) {// probably IE
	  }
	}
	
	function addClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
	      el.className += " ".concat(className);
	    }
	  }
	}
	
	function removeClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
	  }
	}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findInArray = findInArray;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	exports.int = int;
	exports.dontSetMe = dontSetMe;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array
	/*: Array<any> | TouchList*/
	, callback
	/*: Function*/
	)
	/*: any*/
	{
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  // $FlowIgnore[method-unbinding]
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a
	/*: string*/
	)
	/*: number*/
	{
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props
	/*: Object*/
	, propName
	/*: string*/
	, componentName
	/*: string*/
	)
	/*: ?Error*/
	{
	  if (props[propName]) {
	    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
	  }
	}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPrefix = getPrefix;
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	exports.default = void 0;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	
	function getPrefix()
	/*: string*/
	{
	  var _window$document, _window$document$docu;
	
	  var prop
	  /*: string*/
	  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	  // Ensure we're running in an environment where there is actually a global
	  // `window` obj
	  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
	  // path may not exist, so bail out if it doesn't.
	
	  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
	  if (!style) return '';
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
	}
	
	function browserPrefixToStyle(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
	}
	
	function kebabToTitleCase(str
	/*: string*/
	)
	/*: string*/
	{
	  var out = '';
	  var shouldCapitalize = true;
	
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	
	  return out;
	} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	
	
	var _default = (getPrefix()
	/*: string*/
	);
	
	exports.default = _default;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBoundPosition = getBoundPosition;
	exports.snapToGrid = snapToGrid;
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.getControlPosition = getControlPosition;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	
	var _shims = __webpack_require__(1956);
	
	var _domFns = __webpack_require__(1955);
	
	function getBoundPosition(draggable
	/*: Draggable*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: [number, number]*/
	{
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y]; // Clone new bounds
	
	  var bounds = draggable.props.bounds;
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode;
	
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	
	    var boundNodeEl
	    /*: HTMLElement*/
	    = boundNode; // for Flow, can't seem to refine correctly
	
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  } // Keep x and y below right and bottom limits...
	
	
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
	
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	  return [x, y];
	}
	
	function snapToGrid(grid
	/*: [number, number]*/
	, pendingX
	/*: number*/
	, pendingY
	/*: number*/
	)
	/*: [number, number]*/
	{
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	} // Get {x, y} positions from event.
	
	
	function getControlPosition(e
	/*: MouseTouchEvent*/
	, touchIdentifier
	/*: ?number*/
	, draggableCore
	/*: DraggableCore*/
	)
	/*: ?ControlPosition*/
	{
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	
	  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.
	
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
	} // Create an data object exposed by <DraggableCore>'s events
	
	
	function createCoreData(draggable
	/*: DraggableCore*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: DraggableData*/
	{
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX,
	      deltaY: y - state.lastY,
	      lastX: state.lastX,
	      lastY: state.lastY,
	      x: x,
	      y: y
	    };
	  }
	} // Create an data exposed by <Draggable>'s events
	
	
	function createDraggableData(draggable
	/*: Draggable*/
	, coreData
	/*: DraggableData*/
	)
	/*: DraggableData*/
	{
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	} // A lot faster than stringify/parse
	
	
	function cloneBounds(bounds
	/*: Bounds*/
	)
	/*: Bounds*/
	{
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable
	/*: Draggable | DraggableCore*/
	)
	/*: HTMLElement*/
	{
	  var node = draggable.findDOMNode();
	
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	
	
	  return node;
	}

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(53));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	var _domFns = __webpack_require__(1955);
	
	var _positionFns = __webpack_require__(1958);
	
	var _shims = __webpack_require__(1956);
	
	var _log = _interopRequireDefault(__webpack_require__(1960));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Simple abstraction for dragging events names.
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	}; // Default to mouse events.
	
	var dragEventFor = eventsFor.mouse;
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
	
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	/*:: export type DraggableCoreDefaultProps = {
	  allowAnyClick: boolean,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	  scale: number,
	};*/
	
	/*:: export type DraggableCoreProps = {
	  ...DraggableCoreDefaultProps,
	  cancel: string,
	  children: ReactElement<any>,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  nodeRef?: ?React.ElementRef<any>,
	};*/
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	var DraggableCore = /*#__PURE__*/function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  var _super = _createSuper(DraggableCore);
	
	  function DraggableCore() {
	    var _this;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN,
	      lastY: NaN,
	      touchIdentifier: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e); // Only accept left-clicks.
	
	
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
	
	      var thisNode = _this.findDOMNode();
	
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	
	      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      } // Prevent scrolling on mobile devices, like ipad/iphone.
	      // Important that this is after handle/cancel.
	
	
	      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	
	      _this.setState({
	        touchIdentifier: touchIdentifier
	      }); // Get the current drag point from the event. This is used as the offset.
	
	
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
	
	      (0, _log.default)('calling', _this.props.onStart);
	
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	
	      _this.setState({
	        dragging: true,
	        lastX: x,
	        lastY: y
	      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	
	
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX,
	            deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        deltaX = _snapToGrid2[0];
	        deltaY = _snapToGrid2[1];
	        if (!deltaX && !deltaY) return; // skip useless drag
	
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
	
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents')
	          /*: any*/
	          )
	          /*: MouseTouchEvent*/
	          ); // I see why this insanity was deprecated
	          // $FlowIgnore
	
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	          _this.handleDragStop(event);
	        }
	
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
	      if (!_this.state.dragging) return;
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler
	
	      var shouldContinue = _this.props.onStop(e, coreEvent);
	
	      if (shouldContinue === false || _this.mounted === false) return false;
	
	      var thisNode = _this.findDOMNode();
	
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
	
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
	      dragEventFor = eventsFor.mouse;
	      return _this.handleDragStop(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStop(e);
	    });
	
	    return _this;
	  }
	
	  _createClass(DraggableCore, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
	      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: React.Element<any>*/
	    {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onMouseUp: this.onMouseUp,
	        // onTouchStart is added on `componentDidMount` so they can be added with
	        // {passive: false}, which allows it to cancel. See
	        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(React.Component);
	
	exports.default = DraggableCore;
	
	_defineProperty(DraggableCore, "displayName", 'DraggableCore');
	
	_defineProperty(DraggableCore, "propTypes", {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props
	  /*: DraggableCoreProps*/
	  , propName
	  /*: $Keys<DraggableCoreProps>*/
	  ) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes.default.string,
	
	  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
	   * Unfortunately, in order for <Draggable> to work properly, we need raw access
	   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
	   * as in this example:
	   *
	   * function MyComponent() {
	   *   const nodeRef = React.useRef(null);
	   *   return (
	   *     <Draggable nodeRef={nodeRef}>
	   *       <div ref={nodeRef}>Example Target</div>
	   *     </Draggable>
	   *   );
	   * }
	   *
	   * This can be used for arbitrarily nested components, so long as the ref ends up
	   * pointing to the actual child DOM node and not a custom component.
	   */
	  nodeRef: _propTypes.default.object,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * `scale`, if set, applies scaling while dragging an element
	   */
	  scale: _propTypes.default.number,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	
	_defineProperty(DraggableCore, "defaultProps", {
	  allowAnyClick: false,
	  // by default only accept left click
	  disabled: false,
	  enableUserSelectHack: true,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {},
	  scale: 1
	});

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	/*eslint no-console:0*/
	function log() {
	  var _console;
	
	  if (undefined) (_console = console).log.apply(_console, arguments);
	}

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(38);
	var memoize = _interopDefault(__webpack_require__(1962));
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	var styles = {
	    top: {
	        width: '100%',
	        height: '10px',
	        top: '-5px',
	        left: '0px',
	        cursor: 'row-resize',
	    },
	    right: {
	        width: '10px',
	        height: '100%',
	        top: '0px',
	        right: '-5px',
	        cursor: 'col-resize',
	    },
	    bottom: {
	        width: '100%',
	        height: '10px',
	        bottom: '-5px',
	        left: '0px',
	        cursor: 'row-resize',
	    },
	    left: {
	        width: '10px',
	        height: '100%',
	        top: '0px',
	        left: '-5px',
	        cursor: 'col-resize',
	    },
	    topRight: {
	        width: '20px',
	        height: '20px',
	        position: 'absolute',
	        right: '-10px',
	        top: '-10px',
	        cursor: 'ne-resize',
	    },
	    bottomRight: {
	        width: '20px',
	        height: '20px',
	        position: 'absolute',
	        right: '-10px',
	        bottom: '-10px',
	        cursor: 'se-resize',
	    },
	    bottomLeft: {
	        width: '20px',
	        height: '20px',
	        position: 'absolute',
	        left: '-10px',
	        bottom: '-10px',
	        cursor: 'sw-resize',
	    },
	    topLeft: {
	        width: '20px',
	        height: '20px',
	        position: 'absolute',
	        left: '-10px',
	        top: '-10px',
	        cursor: 'nw-resize',
	    },
	};
	var Resizer = /** @class */ (function (_super) {
	    __extends(Resizer, _super);
	    function Resizer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onMouseDown = function (e) {
	            _this.props.onResizeStart(e, _this.props.direction);
	        };
	        _this.onTouchStart = function (e) {
	            _this.props.onResizeStart(e, _this.props.direction);
	        };
	        return _this;
	    }
	    Resizer.prototype.render = function () {
	        return (React.createElement("div", { className: this.props.className || '', style: __assign(__assign({ position: 'absolute', userSelect: 'none' }, styles[this.props.direction]), (this.props.replaceStyles || {})), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children));
	    };
	    return Resizer;
	}(React.PureComponent));
	
	var DEFAULT_SIZE = {
	    width: 'auto',
	    height: 'auto',
	};
	var clamp = memoize(function (n, min, max) { return Math.max(Math.min(n, max), min); });
	var snap = memoize(function (n, size) { return Math.round(n / size) * size; });
	var hasDirection = memoize(function (dir, target) {
	    return new RegExp(dir, 'i').test(target);
	});
	// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
	var isTouchEvent = function (event) {
	    return Boolean(event.touches && event.touches.length);
	};
	var isMouseEvent = function (event) {
	    return Boolean((event.clientX || event.clientX === 0) &&
	        (event.clientY || event.clientY === 0));
	};
	var findClosestSnap = memoize(function (n, snapArray, snapGap) {
	    if (snapGap === void 0) { snapGap = 0; }
	    var closestGapIndex = snapArray.reduce(function (prev, curr, index) { return (Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev); }, 0);
	    var gap = Math.abs(snapArray[closestGapIndex] - n);
	    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
	});
	var endsWith = memoize(function (str, searchStr) {
	    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
	});
	var getStringSize = memoize(function (n) {
	    n = n.toString();
	    if (n === 'auto') {
	        return n;
	    }
	    if (endsWith(n, 'px')) {
	        return n;
	    }
	    if (endsWith(n, '%')) {
	        return n;
	    }
	    if (endsWith(n, 'vh')) {
	        return n;
	    }
	    if (endsWith(n, 'vw')) {
	        return n;
	    }
	    if (endsWith(n, 'vmax')) {
	        return n;
	    }
	    if (endsWith(n, 'vmin')) {
	        return n;
	    }
	    return n + "px";
	});
	var getPixelSize = function (size, parentSize, innerWidth, innerHeight) {
	    if (size && typeof size === 'string') {
	        if (endsWith(size, 'px')) {
	            return Number(size.replace('px', ''));
	        }
	        if (endsWith(size, '%')) {
	            var ratio = Number(size.replace('%', '')) / 100;
	            return parentSize * ratio;
	        }
	        if (endsWith(size, 'vw')) {
	            var ratio = Number(size.replace('vw', '')) / 100;
	            return innerWidth * ratio;
	        }
	        if (endsWith(size, 'vh')) {
	            var ratio = Number(size.replace('vh', '')) / 100;
	            return innerHeight * ratio;
	        }
	    }
	    return size;
	};
	var calculateNewMax = memoize(function (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
	    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
	    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
	    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
	    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
	    return {
	        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
	        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
	        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
	        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight),
	    };
	});
	var definedProps = [
	    'as',
	    'style',
	    'className',
	    'grid',
	    'snap',
	    'bounds',
	    'boundsByDirection',
	    'size',
	    'defaultSize',
	    'minWidth',
	    'minHeight',
	    'maxWidth',
	    'maxHeight',
	    'lockAspectRatio',
	    'lockAspectRatioExtraWidth',
	    'lockAspectRatioExtraHeight',
	    'enable',
	    'handleStyles',
	    'handleClasses',
	    'handleWrapperStyle',
	    'handleWrapperClass',
	    'children',
	    'onResizeStart',
	    'onResize',
	    'onResizeStop',
	    'handleComponent',
	    'scale',
	    'resizeRatio',
	    'snapGap',
	];
	// HACK: This class is used to calculate % size.
	var baseClassName = '__resizable_base__';
	var Resizable = /** @class */ (function (_super) {
	    __extends(Resizable, _super);
	    function Resizable(props) {
	        var _this = _super.call(this, props) || this;
	        _this.ratio = 1;
	        _this.resizable = null;
	        // For parent boundary
	        _this.parentLeft = 0;
	        _this.parentTop = 0;
	        // For boundary
	        _this.resizableLeft = 0;
	        _this.resizableRight = 0;
	        _this.resizableTop = 0;
	        _this.resizableBottom = 0;
	        // For target boundary
	        _this.targetLeft = 0;
	        _this.targetTop = 0;
	        _this.appendBase = function () {
	            if (!_this.resizable || !_this.window) {
	                return null;
	            }
	            var parent = _this.parentNode;
	            if (!parent) {
	                return null;
	            }
	            var element = _this.window.document.createElement('div');
	            element.style.width = '100%';
	            element.style.height = '100%';
	            element.style.position = 'absolute';
	            element.style.transform = 'scale(0, 0)';
	            element.style.left = '0';
	            element.style.flex = '0 0 100%';
	            if (element.classList) {
	                element.classList.add(baseClassName);
	            }
	            else {
	                element.className += baseClassName;
	            }
	            parent.appendChild(element);
	            return element;
	        };
	        _this.removeBase = function (base) {
	            var parent = _this.parentNode;
	            if (!parent) {
	                return;
	            }
	            parent.removeChild(base);
	        };
	        _this.ref = function (c) {
	            if (c) {
	                _this.resizable = c;
	            }
	        };
	        _this.state = {
	            isResizing: false,
	            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined'
	                ? 'auto'
	                : _this.propsSize && _this.propsSize.width,
	            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined'
	                ? 'auto'
	                : _this.propsSize && _this.propsSize.height,
	            direction: 'right',
	            original: {
	                x: 0,
	                y: 0,
	                width: 0,
	                height: 0,
	            },
	            backgroundStyle: {
	                height: '100%',
	                width: '100%',
	                backgroundColor: 'rgba(0,0,0,0)',
	                cursor: 'auto',
	                opacity: 0,
	                position: 'fixed',
	                zIndex: 9999,
	                top: '0',
	                left: '0',
	                bottom: '0',
	                right: '0',
	            },
	            flexBasis: undefined,
	        };
	        _this.onResizeStart = _this.onResizeStart.bind(_this);
	        _this.onMouseMove = _this.onMouseMove.bind(_this);
	        _this.onMouseUp = _this.onMouseUp.bind(_this);
	        return _this;
	    }
	    Object.defineProperty(Resizable.prototype, "parentNode", {
	        get: function () {
	            if (!this.resizable) {
	                return null;
	            }
	            return this.resizable.parentNode;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Resizable.prototype, "window", {
	        get: function () {
	            if (!this.resizable) {
	                return null;
	            }
	            if (!this.resizable.ownerDocument) {
	                return null;
	            }
	            return this.resizable.ownerDocument.defaultView;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Resizable.prototype, "propsSize", {
	        get: function () {
	            return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Resizable.prototype, "size", {
	        get: function () {
	            var width = 0;
	            var height = 0;
	            if (this.resizable && this.window) {
	                var orgWidth = this.resizable.offsetWidth;
	                var orgHeight = this.resizable.offsetHeight;
	                // HACK: Set position `relative` to get parent size.
	                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
	                var orgPosition = this.resizable.style.position;
	                if (orgPosition !== 'relative') {
	                    this.resizable.style.position = 'relative';
	                }
	                // INFO: Use original width or height if set auto.
	                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
	                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
	                // Restore original position
	                this.resizable.style.position = orgPosition;
	            }
	            return { width: width, height: height };
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Resizable.prototype, "sizeStyle", {
	        get: function () {
	            var _this = this;
	            var size = this.props.size;
	            var getSize = function (key) {
	                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') {
	                    return 'auto';
	                }
	                if (_this.propsSize && _this.propsSize[key] && endsWith(_this.propsSize[key].toString(), '%')) {
	                    if (endsWith(_this.state[key].toString(), '%')) {
	                        return _this.state[key].toString();
	                    }
	                    var parentSize = _this.getParentSize();
	                    var value = Number(_this.state[key].toString().replace('px', ''));
	                    var percent = (value / parentSize[key]) * 100;
	                    return percent + "%";
	                }
	                return getStringSize(_this.state[key]);
	            };
	            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing
	                ? getStringSize(size.width)
	                : getSize('width');
	            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing
	                ? getStringSize(size.height)
	                : getSize('height');
	            return { width: width, height: height };
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Resizable.prototype.getParentSize = function () {
	        if (!this.parentNode) {
	            if (!this.window) {
	                return { width: 0, height: 0 };
	            }
	            return { width: this.window.innerWidth, height: this.window.innerHeight };
	        }
	        var base = this.appendBase();
	        if (!base) {
	            return { width: 0, height: 0 };
	        }
	        // INFO: To calculate parent width with flex layout
	        var wrapChanged = false;
	        var wrap = this.parentNode.style.flexWrap;
	        if (wrap !== 'wrap') {
	            wrapChanged = true;
	            this.parentNode.style.flexWrap = 'wrap';
	            // HACK: Use relative to get parent padding size
	        }
	        base.style.position = 'relative';
	        base.style.minWidth = '100%';
	        base.style.minHeight = '100%';
	        var size = {
	            width: base.offsetWidth,
	            height: base.offsetHeight,
	        };
	        if (wrapChanged) {
	            this.parentNode.style.flexWrap = wrap;
	        }
	        this.removeBase(base);
	        return size;
	    };
	    Resizable.prototype.bindEvents = function () {
	        if (this.window) {
	            this.window.addEventListener('mouseup', this.onMouseUp);
	            this.window.addEventListener('mousemove', this.onMouseMove);
	            this.window.addEventListener('mouseleave', this.onMouseUp);
	            this.window.addEventListener('touchmove', this.onMouseMove, {
	                capture: true,
	                passive: false,
	            });
	            this.window.addEventListener('touchend', this.onMouseUp);
	        }
	    };
	    Resizable.prototype.unbindEvents = function () {
	        if (this.window) {
	            this.window.removeEventListener('mouseup', this.onMouseUp);
	            this.window.removeEventListener('mousemove', this.onMouseMove);
	            this.window.removeEventListener('mouseleave', this.onMouseUp);
	            this.window.removeEventListener('touchmove', this.onMouseMove, true);
	            this.window.removeEventListener('touchend', this.onMouseUp);
	        }
	    };
	    Resizable.prototype.componentDidMount = function () {
	        if (!this.resizable || !this.window) {
	            return;
	        }
	        var computedStyle = this.window.getComputedStyle(this.resizable);
	        this.setState({
	            width: this.state.width || this.size.width,
	            height: this.state.height || this.size.height,
	            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined,
	        });
	    };
	    Resizable.prototype.componentWillUnmount = function () {
	        if (this.window) {
	            this.unbindEvents();
	        }
	    };
	    Resizable.prototype.createSizeForCssProperty = function (newSize, kind) {
	        var propsSize = this.propsSize && this.propsSize[kind];
	        return this.state[kind] === 'auto' &&
	            this.state.original[kind] === newSize &&
	            (typeof propsSize === 'undefined' || propsSize === 'auto')
	            ? 'auto'
	            : newSize;
	    };
	    Resizable.prototype.calculateNewMaxFromBoundary = function (maxWidth, maxHeight) {
	        var boundsByDirection = this.props.boundsByDirection;
	        var direction = this.state.direction;
	        var widthByDirection = boundsByDirection && hasDirection('left', direction);
	        var heightByDirection = boundsByDirection && hasDirection('top', direction);
	        var boundWidth;
	        var boundHeight;
	        if (this.props.bounds === 'parent') {
	            var parent_1 = this.parentNode;
	            if (parent_1) {
	                boundWidth = widthByDirection
	                    ? this.resizableRight - this.parentLeft
	                    : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
	                boundHeight = heightByDirection
	                    ? this.resizableBottom - this.parentTop
	                    : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
	            }
	        }
	        else if (this.props.bounds === 'window') {
	            if (this.window) {
	                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
	                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
	            }
	        }
	        else if (this.props.bounds) {
	            boundWidth = widthByDirection
	                ? this.resizableRight - this.targetLeft
	                : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
	            boundHeight = heightByDirection
	                ? this.resizableBottom - this.targetTop
	                : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
	        }
	        if (boundWidth && Number.isFinite(boundWidth)) {
	            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
	        }
	        if (boundHeight && Number.isFinite(boundHeight)) {
	            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
	        }
	        return { maxWidth: maxWidth, maxHeight: maxHeight };
	    };
	    Resizable.prototype.calculateNewSizeFromDirection = function (clientX, clientY) {
	        var scale = this.props.scale || 1;
	        var resizeRatio = this.props.resizeRatio || 1;
	        var _a = this.state, direction = _a.direction, original = _a.original;
	        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
	        var newWidth = original.width;
	        var newHeight = original.height;
	        var extraHeight = lockAspectRatioExtraHeight || 0;
	        var extraWidth = lockAspectRatioExtraWidth || 0;
	        if (hasDirection('right', direction)) {
	            newWidth = original.width + ((clientX - original.x) * resizeRatio) / scale;
	            if (lockAspectRatio) {
	                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
	            }
	        }
	        if (hasDirection('left', direction)) {
	            newWidth = original.width - ((clientX - original.x) * resizeRatio) / scale;
	            if (lockAspectRatio) {
	                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
	            }
	        }
	        if (hasDirection('bottom', direction)) {
	            newHeight = original.height + ((clientY - original.y) * resizeRatio) / scale;
	            if (lockAspectRatio) {
	                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
	            }
	        }
	        if (hasDirection('top', direction)) {
	            newHeight = original.height - ((clientY - original.y) * resizeRatio) / scale;
	            if (lockAspectRatio) {
	                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
	            }
	        }
	        return { newWidth: newWidth, newHeight: newHeight };
	    };
	    Resizable.prototype.calculateNewSizeFromAspectRatio = function (newWidth, newHeight, max, min) {
	        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
	        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
	        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
	        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
	        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
	        var extraHeight = lockAspectRatioExtraHeight || 0;
	        var extraWidth = lockAspectRatioExtraWidth || 0;
	        if (lockAspectRatio) {
	            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
	            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
	            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
	            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
	            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
	            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
	            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
	            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
	            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
	            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
	        }
	        else {
	            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
	            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
	        }
	        return { newWidth: newWidth, newHeight: newHeight };
	    };
	    Resizable.prototype.setBoundingClientRect = function () {
	        // For parent boundary
	        if (this.props.bounds === 'parent') {
	            var parent_2 = this.parentNode;
	            if (parent_2) {
	                var parentRect = parent_2.getBoundingClientRect();
	                this.parentLeft = parentRect.left;
	                this.parentTop = parentRect.top;
	            }
	        }
	        // For target(html element) boundary
	        if (this.props.bounds && typeof this.props.bounds !== 'string') {
	            var targetRect = this.props.bounds.getBoundingClientRect();
	            this.targetLeft = targetRect.left;
	            this.targetTop = targetRect.top;
	        }
	        // For boundary
	        if (this.resizable) {
	            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
	            this.resizableLeft = left;
	            this.resizableRight = right;
	            this.resizableTop = top_1;
	            this.resizableBottom = bottom;
	        }
	    };
	    Resizable.prototype.onResizeStart = function (event, direction) {
	        if (!this.resizable || !this.window) {
	            return;
	        }
	        var clientX = 0;
	        var clientY = 0;
	        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
	            clientX = event.nativeEvent.clientX;
	            clientY = event.nativeEvent.clientY;
	        }
	        else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
	            clientX = event.nativeEvent.touches[0].clientX;
	            clientY = event.nativeEvent.touches[0].clientY;
	        }
	        if (this.props.onResizeStart) {
	            if (this.resizable) {
	                var startResize = this.props.onResizeStart(event, direction, this.resizable);
	                if (startResize === false) {
	                    return;
	                }
	            }
	        }
	        // Fix #168
	        if (this.props.size) {
	            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
	                this.setState({ height: this.props.size.height });
	            }
	            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
	                this.setState({ width: this.props.size.width });
	            }
	        }
	        // For lockAspectRatio case
	        this.ratio =
	            typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
	        var flexBasis;
	        var computedStyle = this.window.getComputedStyle(this.resizable);
	        if (computedStyle.flexBasis !== 'auto') {
	            var parent_3 = this.parentNode;
	            if (parent_3) {
	                var dir = this.window.getComputedStyle(parent_3).flexDirection;
	                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
	                flexBasis = computedStyle.flexBasis;
	            }
	        }
	        // For boundary
	        this.setBoundingClientRect();
	        this.bindEvents();
	        var state = {
	            original: {
	                x: clientX,
	                y: clientY,
	                width: this.size.width,
	                height: this.size.height,
	            },
	            isResizing: true,
	            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(event.target).cursor || 'auto' }),
	            direction: direction,
	            flexBasis: flexBasis,
	        };
	        this.setState(state);
	    };
	    Resizable.prototype.onMouseMove = function (event) {
	        if (!this.state.isResizing || !this.resizable || !this.window) {
	            return;
	        }
	        if (this.window.TouchEvent && isTouchEvent(event)) {
	            try {
	                event.preventDefault();
	                event.stopPropagation();
	            }
	            catch (e) {
	                // Ignore on fail
	            }
	        }
	        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
	        var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
	        var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
	        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
	        var parentSize = this.getParentSize();
	        var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
	        maxWidth = max.maxWidth;
	        maxHeight = max.maxHeight;
	        minWidth = max.minWidth;
	        minHeight = max.minHeight;
	        // Calculate new size
	        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
	        // Calculate max size from boundary settings
	        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
	        if (this.props.snap && this.props.snap.x) {
	            newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
	        }
	        if (this.props.snap && this.props.snap.y) {
	            newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
	        }
	        // Calculate new size from aspect ratio
	        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, { width: boundaryMax.maxWidth, height: boundaryMax.maxHeight }, { width: minWidth, height: minHeight });
	        newWidth = newSize.newWidth;
	        newHeight = newSize.newHeight;
	        if (this.props.grid) {
	            var newGridWidth = snap(newWidth, this.props.grid[0]);
	            var newGridHeight = snap(newHeight, this.props.grid[1]);
	            var gap = this.props.snapGap || 0;
	            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
	            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
	        }
	        var delta = {
	            width: newWidth - original.width,
	            height: newHeight - original.height,
	        };
	        if (width && typeof width === 'string') {
	            if (endsWith(width, '%')) {
	                var percent = (newWidth / parentSize.width) * 100;
	                newWidth = percent + "%";
	            }
	            else if (endsWith(width, 'vw')) {
	                var vw = (newWidth / this.window.innerWidth) * 100;
	                newWidth = vw + "vw";
	            }
	            else if (endsWith(width, 'vh')) {
	                var vh = (newWidth / this.window.innerHeight) * 100;
	                newWidth = vh + "vh";
	            }
	        }
	        if (height && typeof height === 'string') {
	            if (endsWith(height, '%')) {
	                var percent = (newHeight / parentSize.height) * 100;
	                newHeight = percent + "%";
	            }
	            else if (endsWith(height, 'vw')) {
	                var vw = (newHeight / this.window.innerWidth) * 100;
	                newHeight = vw + "vw";
	            }
	            else if (endsWith(height, 'vh')) {
	                var vh = (newHeight / this.window.innerHeight) * 100;
	                newHeight = vh + "vh";
	            }
	        }
	        var newState = {
	            width: this.createSizeForCssProperty(newWidth, 'width'),
	            height: this.createSizeForCssProperty(newHeight, 'height'),
	        };
	        if (this.flexDir === 'row') {
	            newState.flexBasis = newState.width;
	        }
	        else if (this.flexDir === 'column') {
	            newState.flexBasis = newState.height;
	        }
	        this.setState(newState);
	        if (this.props.onResize) {
	            this.props.onResize(event, direction, this.resizable, delta);
	        }
	    };
	    Resizable.prototype.onMouseUp = function (event) {
	        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
	        if (!isResizing || !this.resizable) {
	            return;
	        }
	        var delta = {
	            width: this.size.width - original.width,
	            height: this.size.height - original.height,
	        };
	        if (this.props.onResizeStop) {
	            this.props.onResizeStop(event, direction, this.resizable, delta);
	        }
	        if (this.props.size) {
	            this.setState(this.props.size);
	        }
	        this.unbindEvents();
	        this.setState({
	            isResizing: false,
	            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: 'auto' }),
	        });
	    };
	    Resizable.prototype.updateSize = function (size) {
	        this.setState({ width: size.width, height: size.height });
	    };
	    Resizable.prototype.renderResizer = function () {
	        var _this = this;
	        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
	        if (!enable) {
	            return null;
	        }
	        var resizers = Object.keys(enable).map(function (dir) {
	            if (enable[dir] !== false) {
	                return (React.createElement(Resizer, { key: dir, direction: dir, onResizeStart: _this.onResizeStart, replaceStyles: handleStyles && handleStyles[dir], className: handleClasses && handleClasses[dir] }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null));
	            }
	            return null;
	        });
	        // #93 Wrap the resize box in span (will not break 100% width/height)
	        return (React.createElement("div", { className: handleWrapperClass, style: handleWrapperStyle }, resizers));
	    };
	    Resizable.prototype.render = function () {
	        var _this = this;
	        var extendsProps = Object.keys(this.props).reduce(function (acc, key) {
	            if (definedProps.indexOf(key) !== -1) {
	                return acc;
	            }
	            acc[key] = _this.props[key];
	            return acc;
	        }, {});
	        var style = __assign(__assign(__assign({ position: 'relative', userSelect: this.state.isResizing ? 'none' : 'auto' }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: 'border-box', flexShrink: 0 });
	        if (this.state.flexBasis) {
	            style.flexBasis = this.state.flexBasis;
	        }
	        var Wrapper = this.props.as || 'div';
	        return (React.createElement(Wrapper, __assign({ ref: this.ref, style: style, className: this.props.className }, extendsProps),
	            this.state.isResizing && React.createElement("div", { style: this.state.backgroundStyle }),
	            this.props.children,
	            this.renderResizer()));
	    };
	    Resizable.defaultProps = {
	        as: 'div',
	        onResizeStart: function () { },
	        onResize: function () { },
	        onResizeStop: function () { },
	        enable: {
	            top: true,
	            right: true,
	            bottom: true,
	            left: true,
	            topRight: true,
	            bottomRight: true,
	            bottomLeft: true,
	            topLeft: true,
	        },
	        style: {},
	        grid: [1, 1],
	        lockAspectRatio: false,
	        lockAspectRatioExtraWidth: 0,
	        lockAspectRatioExtraHeight: 0,
	        scale: 1,
	        resizeRatio: 1,
	        snapGap: 0,
	    };
	    return Resizable;
	}(React.PureComponent));
	
	exports.Resizable = Resizable;


/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	//
	// Main
	//
	
	function memoize (fn, options) {
	  var cache = options && options.cache
	    ? options.cache
	    : cacheDefault
	
	  var serializer = options && options.serializer
	    ? options.serializer
	    : serializerDefault
	
	  var strategy = options && options.strategy
	    ? options.strategy
	    : strategyDefault
	
	  return strategy(fn, {
	    cache: cache,
	    serializer: serializer
	  })
	}
	
	//
	// Strategy
	//
	
	function isPrimitive (value) {
	  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
	}
	
	function monadic (fn, cache, serializer, arg) {
	  var cacheKey = isPrimitive(arg) ? arg : serializer(arg)
	
	  var computedValue = cache.get(cacheKey)
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.call(this, arg)
	    cache.set(cacheKey, computedValue)
	  }
	
	  return computedValue
	}
	
	function variadic (fn, cache, serializer) {
	  var args = Array.prototype.slice.call(arguments, 3)
	  var cacheKey = serializer(args)
	
	  var computedValue = cache.get(cacheKey)
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.apply(this, args)
	    cache.set(cacheKey, computedValue)
	  }
	
	  return computedValue
	}
	
	function assemble (fn, context, strategy, cache, serialize) {
	  return strategy.bind(
	    context,
	    fn,
	    cache,
	    serialize
	  )
	}
	
	function strategyDefault (fn, options) {
	  var strategy = fn.length === 1 ? monadic : variadic
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyVariadic (fn, options) {
	  var strategy = variadic
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyMonadic (fn, options) {
	  var strategy = monadic
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	//
	// Serializer
	//
	
	function serializerDefault () {
	  return JSON.stringify(arguments)
	}
	
	//
	// Cache
	//
	
	function ObjectWithoutPrototypeCache () {
	  this.cache = Object.create(null)
	}
	
	ObjectWithoutPrototypeCache.prototype.has = function (key) {
	  return (key in this.cache)
	}
	
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	  return this.cache[key]
	}
	
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	  this.cache[key] = value
	}
	
	var cacheDefault = {
	  create: function create () {
	    return new ObjectWithoutPrototypeCache()
	  }
	}
	
	//
	// API
	//
	
	module.exports = memoize
	module.exports.strategies = {
	  variadic: strategyVariadic,
	  monadic: strategyMonadic
	}


/***/ }),
/* 1963 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var resizerStyle = {
	    width: "7px",
	    height: "7px",
	    borderRadius: "25%",
	    background: "white",
	    border: "1px solid #60aff4"
	};
	var topRight = _extends({}, resizerStyle, {
	    right: "-3.5px",
	    top: "-3.5px"
	});
	var topLeft = _extends({}, resizerStyle, {
	    left: "-3.5px",
	    top: "-3.5px"
	});
	var bottomLeft = _extends({}, resizerStyle, {
	    left: "-3.5px",
	    bottom: "-3.5px"
	});
	var bottomRight = _extends({}, resizerStyle, {
	    right: "-3.5px",
	    bottom: "-3.5px"
	});
	var left = _extends({}, resizerStyle, {
	    left: "-3.5px",
	    top: "calc(50% - 3.5px)"
	});
	var right = _extends({}, resizerStyle, {
	    right: "-3.5px",
	    top: "calc(50% - 3.5px)"
	});
	var top = _extends({}, resizerStyle, {
	    left: "calc(50% - 3.5px)",
	    top: "-3.5px"
	});
	var bottom = _extends({}, resizerStyle, {
	    left: "calc(50% - 3.5px)",
	    bottom: "-3.5px"
	});
	var RndStyle = { top: top, bottom: bottom, left: left, right: right, topRight: topRight, topLeft: topLeft, bottomLeft: bottomLeft, bottomRight: bottomRight };
	module.exports = {
	    RndStyle: RndStyle
	};

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _RndStyle = __webpack_require__(1963);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	/*
	Special rule for using react-rnd
	If the entity has padding and border: for example padding 5, border 1
	then onDragStop or onResizeStop will return x,y and width include padding + border
	So,if the padding and border for are added for editor view only,
	the actual value need to be calculated. ( minos 6 for x,y and minos 12 for width)
	But the position value props and size set on react-rnd component need to plus 6 for x,y and 12 for width from state,.
	*/
	
	var LineContainer = function LineContainer(_ref) {
	    var editorView = _ref.editorView;
	    var scaleMode = _ref.scaleMode;
	    var dispatch = _ref.dispatch;
	    var stepNumberState = _ref.stepNumberState;
	    var slideCurrentIndex = _ref.slideCurrentIndex;
	    var livefeedSlides = _ref.livefeedSlides;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var lineState = _livefeedSlides$slideCurrentIndex.lineState;
	    var historyEntities = _livefeedSlides$slideCurrentIndex.historyEntities;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	
	    var isLineShown = lineState.show ? true : false;
	    var enableResizing = {
	        bottom: isLineShown,
	        bottomLeft: false,
	        bottomRight: false,
	        left: isLineShown,
	        right: isLineShown,
	        top: isLineShown,
	        topLeft: false,
	        topRight: false
	    };
	    var setLinePos = (0, _react.useCallback)(function (newPosition) {
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        // prevent duplicate dispatch
	        if (lineState.left !== x || lineState.top !== y) {
	            // Don't mutate it :)
	            var newLine = (0, _immutabilityHelper2['default'])(lineState, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: "" },
	                activeToolbarItems: _defineProperty({}, 0, { align: { $set: "" } })
	            });
	
	            dispatch((0, _actionsLivefeed.updateLine)(newLine));
	        }
	    }, [dispatch, lineState]);
	
	    var setLineSize = (0, _react.useCallback)(function (length, thickness, newPosition) {
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        var align = '' + (lineState.left === x ? '' + lineState.activeToolbarItems[0].align : "");
	        // prevent duplicate dispatch
	        if (lineState.length !== length || lineState.thickness !== thickness || lineState.left !== newPosition.x) {
	            var newLine = (0, _immutabilityHelper2['default'])(lineState, {
	                length: { $set: length },
	                thickness: { $set: thickness },
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: align },
	                activeToolbarItems: _defineProperty({}, 0, {
	                    align: {
	                        $set: align
	                    }
	                })
	            });
	            dispatch((0, _actionsLivefeed.updateLine)(newLine));
	        }
	    }, [dispatch, lineState]);
	
	    var handleSetCurrentEntityCallback = (0, _react.useCallback)(function () {
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, lineState, dispatch);
	    }, [currentEntity, dispatch, lineState]);
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        isLineShown ? editorView && !scaleMode ? _react2['default'].createElement(
	            _reactRnd.Rnd,
	            {
	                bounds: ".livefeed-preview-wrapper",
	                'data-tooltip': (isLineShown && 'Click on the edge and drag to resize \n Click and drag to the desired position') + '\n Current length ' + lineState.length + 'px\n Current thickness ' + lineState.thickness + 'px',
	                enableResizing: enableResizing,
	                className: 'entity-resizable  ' + (currentEntity.id === 'line' ? 'entity-active' : '') + ' ',
	                lockAspectRatio: false,
	                resizeHandleWrapperClass: "resizers",
	                resizeHandleStyles: {
	                    left: _RndStyle.RndStyle.left, right: _RndStyle.RndStyle.right,
	                    top: _RndStyle.RndStyle.top, bottom: _RndStyle.RndStyle.bottom
	                },
	                //  width need lineState.length to be plus 12 due to padding 5 and border 1
	                size: { width: lineState.length + 12, height: "auto" },
	                position: { x: lineState.left - 6, y: lineState.top - 6 }, // minus padding+border
	                onDragStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onDragStop: function (e, d) {
	                    return setLinePos((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(d));
	                },
	                onResizeStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onResizeStop: function (e, direction, ref, delta, position) {
	                    return position.x !== 0 && setLineSize(ref.offsetWidth - 12, ref.offsetHeight - 12, (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(position));
	                }
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'line-wrapper' },
	                _react2['default'].createElement('div', { className: "line",
	                    style: {
	                        width: lineState.length, height: lineState.thickness + "px",
	                        backgroundColor: lineState.color, top: lineState.top + "px",
	                        left: lineState.left + "px"
	                    } })
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            {
	                style: {
	                    padding: 5, position: "absolute", width: lineState.length * (scaleMode ? 0.375 : 1) + 12, height: "auto",
	                    pointerEvents: "none", transform: 'translate(' + (lineState.left * (scaleMode ? 0.375 : 1) - 6) + 'px, ' + (lineState.top * (scaleMode ? 0.375 : 1) - 6) + 'px)'
	                },
	                className: 'entity-resizable editor-view_false'
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'line-wrapper' },
	                _react2['default'].createElement('div', { className: "line",
	                    style: {
	                        width: lineState.length, height: lineState.thickness + "px",
	                        backgroundColor: lineState.color, top: lineState.top * (scaleMode ? 0.375 : 1) + "px",
	                        left: lineState.left * (scaleMode ? 0.375 : 1) + "px"
	                    } })
	            )
	        ) : null
	    );
	};
	exports['default'] = LineContainer;
	module.exports = exports['default'];

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _webfontloader = __webpack_require__(1966);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	/*
	Special rule for using react-rnd
	If the entity has padding and border: for example padding 5
	then onDragStop or onResizeStop will return x,y and width include padding + border
	So,if the padding and border for are added for editor view only,
	the actual value need to be calculated. ( minos 5 for x,y and minos 10 for width)
	But the position value props and size set on react-rnd component need to plus 5 for x,y and 10 for width from state,.
	###Special rule for using AutosizeInput
	Width of the enity is controlled by AutosizeInput, not by react-rnd since I disabled resizing function
	width returns from AutosizeInput is the actual width of the input content without border, padding, so let it be
	*/
	var TextContainer = function TextContainer(props) {
	    var editorView = props.editorView;
	    var scaleMode = props.scaleMode;
	    var dispatch = props.dispatch;
	    var livefeedSlides = props.livefeedSlides;
	    var slideCurrentIndex = props.slideCurrentIndex;
	    var stepNumberState = props.stepNumberState;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var slideType = _livefeedSlides$slideCurrentIndex.slideType;
	    var fontFamily = _livefeedSlides$slideCurrentIndex.fontFamily;
	    var historyEntities = _livefeedSlides$slideCurrentIndex.historyEntities;
	    var textContainer = _livefeedSlides$slideCurrentIndex.textContainer;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	
	    /* Let's generate dynamic Input Text, I use $splice on reducer to remove item from array
	    check https://github.com/kolodny/immutability-helper on $splice section
	    */
	
	    // Here generate dynamic ID when textContainer change, here I mutate it on purpose
	    textContainer.map(function (obj, i) {
	        obj.id = i;
	        return obj;
	    });
	
	    var textWrapperRefs = (0, _react.useRef)([(0, _react.createRef)(), (0, _react.createRef)()]); // use textWrapperRefs to detect click outside
	
	    function updateLength(value) {
	        textWrapperRefs.current = textWrapperRefs.current.splice(0, value);
	        for (var i = 0; i < value; i++) {
	            textWrapperRefs.current[i] = textWrapperRefs.current[i] || (0, _react.createRef)();
	        }
	        textWrapperRefs.current = textWrapperRefs.current.map(function (item) {
	            return item || (0, _react.createRef)();
	        });
	    }
	
	    // call every time textContainer length change
	    (0, _react.useEffect)(function () {
	        updateLength(textContainer.length);
	    }, [textContainer]);
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        textContainer.map(function (objectText, index) {
	            return _react2['default'].createElement(
	                'div',
	                { ref: textWrapperRefs.current[index], key: index },
	                _react2['default'].createElement(InputText, {
	                    scaleMode: scaleMode,
	                    dispatch: dispatch,
	                    textContainer: textContainer,
	                    index: index, inputRefs: textWrapperRefs,
	                    fontFamily: fontFamily, editorView: editorView,
	                    currentEntity: currentEntity,
	                    objectText: objectText,
	                    slideType: slideType,
	                    slideCurrentIndex: slideCurrentIndex
	                })
	            );
	        })
	    );
	};
	
	exports['default'] = TextContainer;
	var InputText = function InputText(_ref) {
	    var scaleMode = _ref.scaleMode;
	    var slideCurrentIndex = _ref.slideCurrentIndex;
	    var dispatch = _ref.dispatch;
	    var slideType = _ref.slideType;
	    var textContainer = _ref.textContainer;
	    var fontFamily = _ref.fontFamily;
	    var inputRefs = _ref.inputRefs;
	    var editorView = _ref.editorView;
	    var currentEntity = _ref.currentEntity;
	    var objectText = _ref.objectText;
	    var index = _ref.index;
	
	    var _useState = (0, _react.useState)(null);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var inputRefState = _useState2[0];
	    var setInputRefState = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var spanInputRefState = _useState32[0];
	    var setSpanInputRefState = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(false);
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var isEditMode = _useState42[0];
	    var setisEditMode = _useState42[1];
	    // default able to drag
	    var enableResizing = {
	        bottom: false, bottomLeft: false, bottomRight: false, left: false,
	        right: false, top: false, topLeft: false, topRight: false
	    };
	    // Respond on inputWidth change
	    (0, _react.useEffect)(function () {
	        if (!scaleMode) {
	            // can not fetch GTWalsheimProRegular on google server.
	            if (fontFamily !== undefined) {
	                fontFamily !== "GTWalsheimProRegular" && _webfontloader2['default'].load({
	                    google: {
	                        families: ['' + fontFamily]
	                    },
	                    active: function active() {
	                        // respond when font-family changes update all textboxes
	                        textContainer.map(function (textBox) {
	                            var el = document.getElementById('slide-' + slideCurrentIndex + '-span-text-' + textBox.id);
	                            if (el) {
	                                var newWidth = el.offsetWidth; // get the width from the span
	                                if (textBox.textStyle.italic || textBox.textStyle.bold) {
	                                    newWidth = el.offsetWidth + 1;
	                                }
	                                if (newWidth !== textBox.width) {
	                                    dispatch((0, _actionsLivefeed.textboxAlignRespond)(textBox, newWidth)); // textboxAlignRespond(objectText,newWidth)
	                                }
	                            }
	                        });
	                    },
	                    timeout: 500
	                });
	            }
	        }
	        // only need to watch on fontFamily
	    }, [scaleMode, dispatch, fontFamily, index, textContainer, slideCurrentIndex]);
	
	    var textboxOnDragStop = (0, _react.useCallback)(function (newPosition) {
	
	        var newWidth = spanInputRefState.offsetWidth; // get the width from the span
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        // prevent duplicate dispatch
	        if (objectText.left !== x || objectText.top !== y) {
	            var newobjectText = (0, _immutabilityHelper2['default'])(objectText, {
	                top: { $set: y },
	                left: { $set: x },
	                width: { $set: newWidth },
	                align: { $set: "" },
	                activeToolbarItems: _defineProperty({}, 0, { align: { $set: "" } })
	            });
	            dispatch((0, _actionsLivefeed.updateText)(newobjectText));
	        }
	    }, [dispatch, spanInputRefState, objectText]);
	
	    (0, _react.useEffect)(function () {
	        if (!scaleMode) {
	            inputRefState && inputRefState.setAttribute('disabled', true); // Disable input
	            inputRefState && inputRefState.setAttribute('autocomplete', "off");
	        }
	    }, [scaleMode, inputRefState]);
	
	    function inputDoubleClick(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        setisEditMode(true);
	        inputRefState && (inputRefState.removeAttribute('disabled'), //Enable input;
	        inputRefState.focus());
	    }
	    (0, _componentsCommonHooks.useOnClickOutside)(inputRefs.current[index], function () {
	        if (!scaleMode) {
	            setisEditMode(false); // enable dragging
	            inputRefState && inputRefState.setAttribute('disabled', "disabled"); //Disable input
	        }
	    });
	
	    var inputOnchange = (0, _react.useCallback)(function (e) {
	        if (isEditMode && !scaleMode) {
	            spanInputRefState.innerText = e.target.value; // the hidden span takes the value of the input;
	            var newWidth = spanInputRefState.offsetWidth; // get the width from the span
	            var newLeft = undefined;
	            switch (objectText.align) {
	                case "center":
	                    newLeft = slideType === "summary" ? _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryCenter - newWidth / 2 : _componentsPagesLivefeedDefaultstate.livefeedStyle.align.center - newWidth / 2;
	                    break;
	                case "right":
	                    newLeft = slideType === "summary" ? _componentsPagesLivefeedDefaultstate.livefeedStyle.align.summaryRight - newWidth : _componentsPagesLivefeedDefaultstate.livefeedStyle.align.right - newWidth;
	                    break;
	                case "left":
	                    newLeft = _componentsPagesLivefeedDefaultstate.livefeedStyle.align.left;
	                    break;
	            }
	
	            var newobjectText = (0, _immutabilityHelper2['default'])(objectText, {
	                content: { $set: e.target.value },
	                width: { $set: newWidth },
	                left: { $set: newLeft !== undefined ? newLeft : objectText.left }
	            });
	            dispatch((0, _actionsLivefeed.updateText)(newobjectText));
	            dispatch((0, _actionsLivefeed.textboxAlignRespond)(newobjectText, newWidth)); // textboxAlignRespond(objectText,newWidth)
	        }
	    }, [scaleMode, dispatch, isEditMode, objectText, slideType, spanInputRefState]);
	
	    var handleSetCurrentEntityCallback = (0, _react.useCallback)(function () {
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, objectText, dispatch);
	    }, [currentEntity, dispatch, objectText]);
	
	    var inputStyle = {
	        width: objectText.width,
	        fontFamily: fontFamily,
	        fontWeight: objectText.textStyle.bold ? 'bold' : 'unset',
	        fontStyle: objectText.textStyle.italic ? 'italic' : 'unset',
	        textDecoration: objectText.textStyle.underline ? 'underline' : 'unset',
	        fontSize: objectText.size,
	        color: objectText.color
	    };
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        editorView && !scaleMode ? _react2['default'].createElement(
	            _reactRnd.Rnd,
	            {
	                bounds: ".livefeed-preview-wrapper",
	                'data-tooltip': 'Double click to edit text',
	                className: 'entity-resizable entity-resizable_no_padding ' + (currentEntity.id === index ? 'input-entity-active' : ''),
	                resizeHandleWrapperClass: "resizers",
	                enableResizing: enableResizing,
	                size: { width: "auto", height: "auto" },
	                position: {
	                    x: objectText.left * (scaleMode ? 0.375 : 1) - 5, y: objectText.top * (scaleMode ? 0.375 : 1) - 6
	                },
	                onDragStart: function (e) {
	                    e.preventDefault();handleSetCurrentEntityCallback();
	                },
	                onDragStop: function (e, d) {
	                    e.preventDefault();
	                    var position = (0, _immutabilityHelper2['default'])(d, {
	                        x: { $set: d.x + 5 }, //plus padding+border
	                        y: { $set: d.y + 6 }
	                    });
	                    textboxOnDragStop(position);
	                },
	                disableDragging: isEditMode
	            },
	            _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { ref: inputRefs.current[index],
	                        draggable: false,
	                        onDoubleClick: function (e) {
	                            return inputDoubleClick(e);
	                        }
	                    },
	                    _react2['default'].createElement('input', {
	                        draggable: false,
	                        style: _extends({}, inputStyle, {
	                            pointerEvents: '' + (isEditMode ? 'all' : 'none'),
	                            cursor: '' + (isEditMode ? 'text' : 'move'),
	                            height: 'auto'
	                        }),
	                        value: objectText.content,
	                        name: objectText.id,
	                        ref: function (node) {
	                            return setInputRefState(node);
	                        },
	                        onChange: function (e) {
	                            return inputOnchange(e);
	                        }, type: 'text' }),
	                    _react2['default'].createElement(
	                        'span',
	                        {
	                            id: 'slide-' + slideCurrentIndex + '-span-text-' + index,
	                            style: {
	                                height: 36,
	                                display: 'inline-block',
	                                fontFamily: fontFamily,
	                                fontWeight: objectText.textStyle.bold ? 'bold' : 'unset',
	                                fontStyle: objectText.textStyle.italic ? 'italic' : 'unset',
	                                textDecoration: objectText.textStyle.underline ? 'underline' : 'unset',
	                                fontSize: objectText.size
	                            }, ref: function (node) {
	                                return setSpanInputRefState(node);
	                            }, className: 'measure' },
	                        objectText.content
	                    )
	                )
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            { className: 'entity-resizable entity-resizable_no_padding ' },
	            _react2['default'].createElement('input', {
	                type: 'text',
	                draggable: false,
	                style: _extends({}, inputStyle, {
	                    zIndex: 1,
	                    position: 'absolute',
	                    height: 'auto',
	                    left: objectText.left * (scaleMode ? 0.375 : 1) - 5,
	                    top: objectText.top * (scaleMode ? 0.375 : 1) - 6,
	                    pointerEvents: 'none',
	                    cursor: '' + (isEditMode ? 'text' : 'move')
	                }),
	                value: objectText.content,
	                name: objectText.id,
	                readOnly: true })
	        )
	    );
	};
	exports.InputText = InputText;
	InputText.propTypes = {
	    fontFamily: _propTypes2['default'].string.isRequired,
	    textContainer: _propTypes2['default'].array.isRequired,
	    editorView: _propTypes2['default'].bool.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired,
	    objectText: _propTypes2['default'].object.isRequired,
	    index: _propTypes2['default'].number.isRequired,
	    inputRefs: _propTypes2['default'].any.isRequired,
	    dispatch: _propTypes2['default'].func.isRequired
	};

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
	O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
	function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
	function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
	ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
	d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
	var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
	Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _reactRedux = __webpack_require__(47);
	
	var _RndStyle = __webpack_require__(1963);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactResizeDetector = __webpack_require__(1968);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _AnimateScrollList = __webpack_require__(1982);
	
	var _AnimateScrollList2 = _interopRequireDefault(_AnimateScrollList);
	
	__webpack_require__(1983);
	
	var LocationsList = function LocationsList(_ref) {
	    var scaleMode = _ref.scaleMode;
	
	    _react2['default'].useEffect(function () {
	        _reactTooltip2['default'].rebuild(); // componentDidUpdate()
	    });
	
	    var _React$useState = _react2['default'].useState([]);
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var summaryLocationsID = _React$useState2[0];
	    var setSummaryLocationsID = _React$useState2[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var editorView = _useSelector.editorView;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	    var stepNumberState = _useSelector.stepNumberState;
	
	    var nodeMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.nodeMap;
	    });
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var duration = _livefeedSlides$slideCurrentIndex.floorplanOptions.duration;
	    var locationsListStyle = _livefeedSlides$slideCurrentIndex.locationsListStyle;
	    var historyEntities = _livefeedSlides$slideCurrentIndex.historyEntities;
	    var fontFamily = _livefeedSlides$slideCurrentIndex.fontFamily;
	
	    _react2['default'].useEffect(function () {
	        var hasSummaryPage = false;
	        var locationsID = [];
	        for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	            if (livefeedSlides[i].slideType === "summary") {
	                hasSummaryPage = true;
	                locationsID = livefeedSlides[i].floorplanOptions.locationsID;
	            }
	        }
	        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	        var refinedLocationsID = locationsID.filter(function (id) {
	            return nodeMap[id];
	        });
	
	        hasSummaryPage ? setSummaryLocationsID(refinedLocationsID) : setSummaryLocationsID([]);
	    }, [livefeedSlides, nodeMap]);
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	
	    var setLocationsListPos = (0, _react.useCallback)(function (newPosition) {
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        // prevent duplicate dispatch
	        if (locationsListStyle.left !== x || locationsListStyle.top !== y) {
	            var newPos = (0, _immutabilityHelper2['default'])(locationsListStyle, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: "" },
	                activeToolbarItems: _defineProperty({}, 0, { align: { $set: "" } })
	            });
	            dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newPos));
	        }
	    }, [dispatch, locationsListStyle]);
	
	    var setLocationsListSize = (0, _react.useCallback)(function (width, newPosition) {
	        var newWidth = width > 734 ? 734 : width; // maximum width 734
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        var align = '' + (locationsListStyle.left === x ? '' + locationsListStyle.activeToolbarItems[0].align : ""); // if x doesn't change, keep toolbar active
	        if (locationsListStyle.width !== width || locationsListStyle.left !== newPosition.x) {
	            var newSize = (0, _immutabilityHelper2['default'])(locationsListStyle, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: align },
	                width: { $set: newWidth },
	                activeToolbarItems: _defineProperty({}, 0, {
	                    align: { $set: align }
	                })
	            });
	            dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newSize));
	        }
	    }, [dispatch, locationsListStyle]);
	
	    var enableResizing = {
	        bottom: false, bottomLeft: editorView, bottomRight: editorView,
	        left: editorView, right: editorView, top: false,
	        topLeft: editorView, topRight: editorView
	    };
	    var handleSetCurrentEntityCb = (0, _react.useCallback)(function () {
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, locationsListStyle, dispatch);
	    }, [currentEntity, dispatch, locationsListStyle]);
	
	    var color = locationsListStyle.color;
	    var size = locationsListStyle.size;
	    var textStyle = locationsListStyle.textStyle;
	
	    var style = {
	        fontFamily: fontFamily,
	        fontWeight: textStyle.bold ? 'bold' : 'unset',
	        fontStyle: textStyle.italic ? 'italic' : 'unset',
	        textDecoration: textStyle.underline ? 'underline' : 'unset',
	        fontSize: size * (scaleMode ? 0.375 : 1),
	        color: color
	    };
	
	    var locationsName = [];
	
	    if (summaryLocationsID.length > 0) {
	        for (var i = 0, n = summaryLocationsID.length; i < n; i++) {
	            locationsName.push(nodeMap[summaryLocationsID[i]].info.name);
	        }
	    }
	
	    var _useState = (0, _react.useState)(null);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var locationsListWidth = _useState2[0];
	    var setLocationsListWidth = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        if (locationsListWidth) {
	            if (locationsListWidth < 350) {
	                var newCol = (0, _immutabilityHelper2['default'])(locationsListStyle, {
	                    locationCol: { $set: 12 }
	                });
	                dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newCol));
	                dispatch((0, _actionsLivefeed.updateEmptyEntity)());
	            } else if (locationsListWidth >= 350 && locationsListWidth < 500) {
	                var newCol = (0, _immutabilityHelper2['default'])(locationsListStyle, {
	                    locationCol: { $set: 6 }
	                });
	                dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newCol));
	                dispatch((0, _actionsLivefeed.updateEmptyEntity)());
	            } else {
	                var newCol = (0, _immutabilityHelper2['default'])(locationsListStyle, {
	                    locationCol: { $set: 4 }
	                });
	                dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newCol));
	                dispatch((0, _actionsLivefeed.updateEmptyEntity)());
	            }
	        }
	    }, [dispatch, locationsListStyle, locationsListWidth]);
	
	    var titleTip = summaryLocationsID.length > 0 ? 'Click and choose toolbar options to change text style \n        <br />Click on the edge and drag to change columns layout' : 'No chosen locations, select locations in Summary slide';
	
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        editorView && !scaleMode ? _react2['default'].createElement(
	            _reactRnd.Rnd,
	            {
	                'data-tip': '' + (editorView && titleTip),
	                bounds: ".livefeed-preview-wrapper",
	                enableResizing: enableResizing,
	                disableDragging: !editorView,
	                style: {
	                    pointerEvents: editorView ? 'all' : 'none',
	                    border: !editorView && 'none'
	                },
	                className: 'entity-resizable ' + (currentEntity.id === 'locationsListStyle' ? 'entity-active' : '') + ' ',
	                lockAspectRatio: false,
	                resizeHandleWrapperClass: "resizers",
	                resizeHandleStyles: {
	                    topRight: _RndStyle.RndStyle.topRight, topLeft: _RndStyle.RndStyle.topLeft,
	                    left: _RndStyle.RndStyle.left, right: _RndStyle.RndStyle.right,
	                    bottomLeft: _RndStyle.RndStyle.bottomLeft, bottomRight: _RndStyle.RndStyle.bottomRight
	                },
	                size: { width: locationsListStyle.width + 12, height: "auto" },
	                position: { x: locationsListStyle.left - 6, y: locationsListStyle.top - 6 },
	                onClick: function () {
	                    return handleSetCurrentEntityCb();
	                },
	                onDragStart: function () {
	                    return handleSetCurrentEntityCb();
	                },
	                onDragStop: function (e, d) {
	                    return setLocationsListPos((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(d));
	                },
	                onResizeStart: function () {
	                    return handleSetCurrentEntityCb();
	                },
	                onResizeStop: function (e, direction, ref, delta, position) {
	                    return position.x !== 0 && setLocationsListSize(ref.offsetWidth - 12, (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(position));
	                }
	            },
	            _react2['default'].createElement(
	                _reactResizeDetector2['default'],
	                { handleWidth: true },
	                function (_ref2) {
	                    var width = _ref2.width;
	
	                    setLocationsListWidth(width);
	                    return _react2['default'].createElement(_AnimateScrollList2['default'], {
	                        ulStyle: style,
	                        locationsName: locationsName,
	                        locationCol: locationsListStyle.locationCol,
	                        duration: duration
	                    });
	                }
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            {
	                style: {
	                    position: "absolute",
	                    width: (locationsListStyle.width + 12) * (scaleMode ? 0.375 : 1),
	                    height: "auto",
	                    pointerEvents: "none",
	                    overflow: "hidden",
	                    transform: 'translate(' + (locationsListStyle.left - 6) * (scaleMode ? 0.375 : 1) + 'px, ' + (locationsListStyle.top - 6) * (scaleMode ? 0.375 : 1) + 'px)'
	                },
	                className: 'entity-resizable  editor-view_false'
	            },
	            _react2['default'].createElement(_AnimateScrollList2['default'], {
	                ulStyle: style,
	                locationsName: locationsName,
	                locationCol: locationsListStyle.locationCol,
	                duration: duration
	            })
	        ),
	        _react2['default'].createElement(_reactTooltip2['default'], { multiline: true, place: 'top', type: 'dark', effect: 'solid' })
	    );
	};
	
	exports['default'] = LocationsList;
	module.exports = exports['default'];

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "withResizeDetector", {
	  enumerable: true,
	  get: function get() {
	    return _withResizeDetector["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _ResizeDetector = _interopRequireDefault(__webpack_require__(1969));
	
	var _withResizeDetector = _interopRequireDefault(__webpack_require__(1981));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _ResizeDetector["default"];
	exports["default"] = _default;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _reactDom = __webpack_require__(41);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1939));
	
	var _rafSchd = _interopRequireDefault(__webpack_require__(1970));
	
	var _propTypes = __webpack_require__(53);
	
	var _utils = __webpack_require__(1971);
	
	var _ChildWrapper = _interopRequireDefault(__webpack_require__(1980));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ResizeDetector = /*#__PURE__*/function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  var _super = _createSuper(ResizeDetector);
	
	  function ResizeDetector(props) {
	    var _this;
	
	    _classCallCheck(this, ResizeDetector);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "cancelHandler", function () {
	      if (_this.resizeHandler && _this.resizeHandler.cancel) {
	        // cancel debounced handler
	        _this.resizeHandler.cancel();
	
	        _this.resizeHandler = null;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "rafClean", function () {
	      if (_this.raf && _this.raf.cancel) {
	        _this.raf.cancel();
	
	        _this.raf = null;
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "toggleObserver", function (type) {
	      var element = _this.getElement();
	
	      if (!element || !_this.resizeObserver[type]) return;
	
	      _this.resizeObserver[type](element);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getElement", function () {
	      var _this$props = _this.props,
	          querySelector = _this$props.querySelector,
	          targetDomEl = _this$props.targetDomEl;
	      if ((0, _utils.isSSR)()) return undefined;
	      if (querySelector) return document.querySelector(querySelector);
	      if (targetDomEl && (0, _utils.isDOMElement)(targetDomEl)) return targetDomEl; // eslint-disable-next-line react/no-find-dom-node
	
	      var currentElement = _this.element && (0, _reactDom.findDOMNode)(_this.element);
	      if (!currentElement) return undefined;
	      return currentElement.parentElement;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "createUpdater", function () {
	      _this.rafClean();
	
	      _this.raf = (0, _rafSchd["default"])(function (_ref) {
	        var width = _ref.width,
	            height = _ref.height;
	        var onResize = _this.props.onResize;
	
	        if ((0, _utils.isFunction)(onResize)) {
	          onResize(width, height);
	        }
	
	        _this.setState({
	          width: width,
	          height: height
	        });
	      });
	      return _this.raf;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "createResizeHandler", function (entries) {
	      var _this$state = _this.state,
	          widthCurrent = _this$state.width,
	          heightCurrent = _this$state.height;
	      var _this$props2 = _this.props,
	          handleWidth = _this$props2.handleWidth,
	          handleHeight = _this$props2.handleHeight;
	      if (!handleWidth && !handleHeight) return;
	
	      var updater = _this.createUpdater();
	
	      entries.forEach(function (entry) {
	        var _ref2 = entry && entry.contentRect || {},
	            width = _ref2.width,
	            height = _ref2.height;
	
	        var isWidthChanged = handleWidth && widthCurrent !== width;
	        var isHeightChanged = handleHeight && heightCurrent !== height;
	        var isSizeChanged = isWidthChanged || isHeightChanged;
	        var shouldSetSize = !_this.skipOnMount && isSizeChanged && !(0, _utils.isSSR)();
	
	        if (shouldSetSize) {
	          updater({
	            width: width,
	            height: height
	          });
	        }
	
	        _this.skipOnMount = false;
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onRef", function (el) {
	      _this.element = el;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getRenderType", function () {
	      var _this$props3 = _this.props,
	          render = _this$props3.render,
	          children = _this$props3.children;
	
	      if ((0, _utils.isFunction)(render)) {
	        return 'renderProp';
	      }
	
	      if ((0, _utils.isFunction)(children)) {
	        return 'childFunction';
	      }
	
	      if ((0, _react.isValidElement)(children)) {
	        return 'child';
	      }
	
	      if (Array.isArray(children)) {
	        return 'childArray';
	      }
	
	      return 'parent';
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getTargetComponent", function () {
	      var _this$props4 = _this.props,
	          render = _this$props4.render,
	          children = _this$props4.children,
	          nodeType = _this$props4.nodeType;
	      var _this$state2 = _this.state,
	          width = _this$state2.width,
	          height = _this$state2.height;
	      var childProps = {
	        width: width,
	        height: height
	      };
	
	      var renderType = _this.getRenderType();
	
	      switch (renderType) {
	        case 'renderProp':
	          return (0, _react.cloneElement)(render(childProps), {
	            key: 'resize-detector'
	          });
	
	        case 'childFunction':
	          return (0, _react.cloneElement)(children(childProps));
	
	        case 'child':
	          return (0, _react.cloneElement)(children, childProps);
	
	        case 'childArray':
	          return children.map(function (el) {
	            return !!el && (0, _react.cloneElement)(el, childProps);
	          });
	
	        default:
	          return (0, _react.createElement)(nodeType);
	      }
	    });
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate,
	        refreshOptions = props.refreshOptions;
	    _this.state = {
	      width: undefined,
	      height: undefined
	    };
	    _this.skipOnMount = skipOnMount;
	    _this.raf = null;
	    _this.element = null;
	    _this.unmounted = false;
	    var handle = (0, _utils.getHandle)(refreshMode);
	    _this.resizeHandler = handle ? handle(_this.createResizeHandler, refreshRate, refreshOptions) : _this.createResizeHandler;
	    _this.resizeObserver = new _resizeObserverPolyfill["default"](_this.resizeHandler);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.toggleObserver('observe');
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.toggleObserver('unobserve');
	      this.rafClean();
	      this.cancelHandler();
	      this.unmounted = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/_react["default"].createElement(_ChildWrapper["default"], {
	        ref: this.onRef
	      }, this.getTargetComponent());
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes.bool,
	  handleHeight: _propTypes.bool,
	  skipOnMount: _propTypes.bool,
	  refreshRate: _propTypes.number,
	  refreshMode: _propTypes.string,
	  refreshOptions: (0, _propTypes.shape)({
	    leading: _propTypes.bool,
	    trailing: _propTypes.bool
	  }),
	  querySelector: _propTypes.string,
	  targetDomEl: _propTypes.any,
	  // eslint-disable-line react/forbid-prop-types
	  onResize: _propTypes.func,
	  render: _propTypes.func,
	  children: _propTypes.any,
	  // eslint-disable-line react/forbid-prop-types
	  nodeType: _propTypes.node
	};
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  refreshOptions: undefined,
	  querySelector: null,
	  targetDomEl: null,
	  onResize: null,
	  render: undefined,
	  children: null,
	  nodeType: 'div'
	};
	var _default = ResizeDetector;
	exports["default"] = _default;

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

	'use strict';
	
	var rafSchd = function rafSchd(fn) {
	  var lastArgs = [];
	  var frameId = null;
	
	  var wrapperFn = function wrapperFn() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    lastArgs = args;
	
	    if (frameId) {
	      return;
	    }
	
	    frameId = requestAnimationFrame(function () {
	      frameId = null;
	      fn.apply(void 0, lastArgs);
	    });
	  };
	
	  wrapperFn.cancel = function () {
	    if (!frameId) {
	      return;
	    }
	
	    cancelAnimationFrame(frameId);
	    frameId = null;
	  };
	
	  return wrapperFn;
	};
	
	module.exports = rafSchd;


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDOMElement = exports.isSSR = exports.isFunction = exports.getHandle = exports.listHandle = void 0;
	
	var _debounce = _interopRequireDefault(__webpack_require__(1972));
	
	var _throttle = _interopRequireDefault(__webpack_require__(1979));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var listHandle = {
	  debounce: _debounce["default"],
	  throttle: _throttle["default"]
	};
	exports.listHandle = listHandle;
	
	var getHandle = function getHandle(type) {
	  return listHandle[type];
	};
	
	exports.getHandle = getHandle;
	
	var isFunction = function isFunction(fn) {
	  return typeof fn === 'function';
	};
	
	exports.isFunction = isFunction;
	
	var isSSR = function isSSR() {
	  return typeof window === 'undefined';
	};
	
	exports.isSSR = isSSR;
	
	var isDOMElement = function isDOMElement(element) {
	  return element instanceof Element || element instanceof HTMLDocument;
	};
	
	exports.isDOMElement = isDOMElement;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1973),
	    now = __webpack_require__(1974),
	    toNumber = __webpack_require__(1975);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(175);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1976),
	    isObject = __webpack_require__(1973),
	    isSymbol = __webpack_require__(1978);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1977);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 1977 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1972),
	    isObject = __webpack_require__(1973);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(38);
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ChildWrapper = /*#__PURE__*/function (_PureComponent) {
	  _inherits(ChildWrapper, _PureComponent);
	
	  var _super = _createSuper(ChildWrapper);
	
	  function ChildWrapper() {
	    _classCallCheck(this, ChildWrapper);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ChildWrapper, [{
	    key: "render",
	    value: function render() {
	      // eslint-disable-next-line react/prop-types
	      return this.props.children;
	    }
	  }]);
	
	  return ChildWrapper;
	}(_react.PureComponent);
	
	var _default = ChildWrapper;
	exports["default"] = _default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(38));
	
	var _ResizeDetector = _interopRequireDefault(__webpack_require__(1969));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var withResizeDetector = function withResizeDetector(WrappedComponent) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    handleWidth: true,
	    handleHeight: true
	  };
	  return (
	    /*#__PURE__*/
	    // eslint-disable-next-line
	    function (_Component) {
	      _inherits(ResizeDetectorHOC, _Component);
	
	      var _super = _createSuper(ResizeDetectorHOC);
	
	      function ResizeDetectorHOC() {
	        _classCallCheck(this, ResizeDetectorHOC);
	
	        return _super.apply(this, arguments);
	      }
	
	      _createClass(ResizeDetectorHOC, [{
	        key: "render",
	        value: function render() {
	          return /*#__PURE__*/_react["default"].createElement(_ResizeDetector["default"], props, /*#__PURE__*/_react["default"].createElement(WrappedComponent, this.props));
	        }
	      }]);
	
	      return ResizeDetectorHOC;
	    }(_react.Component)
	  );
	};
	
	var _default = withResizeDetector;
	exports["default"] = _default;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var AnimateScrollList = function AnimateScrollList(props) {
	    var ulStyle = props.ulStyle;
	    var locationsName = props.locationsName;
	    var locationCol = props.locationCol;
	    var duration = props.duration;
	
	    var durationTime = (duration * 1000 - 1500) / 2; // miliseconds
	
	    var scrollListRef = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)(0);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var scrollValue = _useState2[0];
	    var setScrollValue = _useState2[1];
	
	    var _useState3 = (0, _react.useState)("down");
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var scrollState = _useState32[0];
	    var setScrollState = _useState32[1];
	
	    var _useState4 = (0, _react.useState)(0);
	
	    var _useState42 = _slicedToArray(_useState4, 2);
	
	    var scrollHeight = _useState42[0];
	    var setScrollHeight = _useState42[1];
	
	    var _useState5 = (0, _react.useState)(0);
	
	    var _useState52 = _slicedToArray(_useState5, 2);
	
	    var offsetHeight = _useState52[0];
	    var setOffsetHeight = _useState52[1];
	
	    var prevScrollState = (0, _componentsCommonHooks.usePrevious)(scrollState);
	
	    var isUp = (0, _react.useMemo)(function () {
	        return scrollState === "up";
	    }, [scrollState]);
	
	    var _useAnimation = (0, _componentsCommonHooks.useAnimation)("linear", durationTime, isUp ? 501 : 500 // definitely a hack
	    );
	
	    var scrollAnimation = _useAnimation.value;
	    var animationState = _useAnimation.animationState;
	
	    var scrollMax = (0, _react.useMemo)(function () {
	        return scrollHeight - offsetHeight;
	    }, [scrollHeight, offsetHeight]);
	
	    (0, _react.useEffect)(function () {
	        if (!scrollMax) return;
	
	        if (scrollValue === 0 && scrollState !== "down") {
	            setScrollState("down");
	        } else if (scrollValue >= scrollMax && scrollState !== "up") {
	            setScrollState("up");
	        }
	    }, [scrollValue, scrollMax, animationState, scrollState]);
	
	    (0, _react.useEffect)(function () {
	        if (animationState === "idle") return;
	
	        var value = scrollMax * scrollAnimation;
	
	        var isSameScroll = prevScrollState === scrollState;
	
	        if (animationState === "finished" && isSameScroll) {
	            var finishedValue = isUp ? 0 : scrollMax;
	            if (value !== finishedValue) {
	                setScrollValue(finishedValue);
	                return;
	            }
	        }
	        if (animationState !== "started") return;
	
	        setScrollValue(isUp ? scrollMax - value : value);
	    }, [scrollAnimation, scrollMax, isUp, animationState, prevScrollState, scrollState]);
	
	    (0, _react.useEffect)(function () {
	        var current = scrollListRef.current;
	
	        if (!current) return;
	
	        current.scrollTop = scrollValue;
	    }, [scrollValue]);
	
	    (0, _react.useEffect)(function () {
	        var current = scrollListRef.current;
	
	        if (current !== null) {
	            setScrollHeight(current.scrollHeight);
	            setOffsetHeight(current.offsetHeight);
	        }
	    }, [locationCol, locationsName]);
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'locationsList-container' },
	        _react2['default'].createElement(
	            'ul',
	            {
	                className: "row ul-list list-scroll",
	                ref: scrollListRef,
	                style: ulStyle },
	            locationsName.map(function (name, i) {
	                return _react2['default'].createElement(
	                    'li',
	                    { key: i, className: 'col-xs-' + locationCol },
	                    ' ',
	                    name
	                );
	            })
	        )
	    );
	};
	
	AnimateScrollList.propTypes = {
	    ulStyle: _propTypes2['default'].object.isRequired,
	    locationsName: _propTypes2['default'].array.isRequired,
	    locationCol: _propTypes2['default'].number.isRequired,
	    duration: _propTypes2['default'].number.isRequired
	};
	exports['default'] = AnimateScrollList;
	module.exports = exports['default'];

/***/ }),
/* 1983 */
[2372, 1984],
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".ul-list{padding:0;margin-bottom:0;margin-right:-5px;margin-left:-5px}.ul-list li{list-style-type:none;letter-spacing:-.75px;padding-right:5px;padding-left:5px}.ul-list li:before{content:\"\\2022\";font-size:inherit;margin-right:2px;display:inline-block}.locationsList-container{overflow:hidden;background:transparent}.locationsList-container .list-scroll{position:relative;overflow:auto;max-height:320px;margin:0 -10px 0 -5px}.locationsList-container .list-scroll .ul-list{width:100%}", ""]);
	
	// exports


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entityGaugeCard = __webpack_require__(1986);
	
	var _entityGaugeCard2 = _interopRequireDefault(_entityGaugeCard);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker = __webpack_require__(1992);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker);
	
	var Widgets = function Widgets(props) {
	    var dispatch = props.dispatch;
	    var scaleMode = props.scaleMode;
	    var nodeMap = props.nodeMap;
	    var sensorMap = props.sensorMap;
	    var livefeedSlides = props.livefeedSlides;
	    var editorView = props.editorView;
	    var stepNumberState = props.stepNumberState;
	    var slideCurrentIndex = props.slideCurrentIndex;
	
	    var colorPickerRef = _react2['default'].useRef(null);
	
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var fontFamily = _livefeedSlides$slideCurrentIndex.fontFamily;
	    var gauge0 = _livefeedSlides$slideCurrentIndex.gauge0;
	    var gauge1 = _livefeedSlides$slideCurrentIndex.gauge1;
	    var gauge2 = _livefeedSlides$slideCurrentIndex.gauge2;
	    var _livefeedSlides$slideCurrentIndex$floorplanOptions = _livefeedSlides$slideCurrentIndex.floorplanOptions;
	    var locationsID = _livefeedSlides$slideCurrentIndex$floorplanOptions.locationsID;
	    var isStandbyAsUnOccupied = _livefeedSlides$slideCurrentIndex$floorplanOptions.isStandbyAsUnOccupied;
	
	    var isAllAreas = undefined;var isMR = false;var isOA = false; // isMeetingRooms// isOpenAreas
	    var stats = [];
	    // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	    var refinedLocationsID = locationsID.filter(function (id) {
	        return nodeMap[id];
	    });
	
	    for (var i = 0, n = refinedLocationsID.length; i < n; i++) {
	        if (refinedLocationsID[i] !== undefined) {
	            var node = nodeMap[refinedLocationsID[i]];
	            switch (node.type) {
	                case "meeting_room":
	                    isMR = true;
	                    stats.push((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getStats)(node, sensorMap, isStandbyAsUnOccupied));
	                    break;
	                case "open_area":
	                    isOA = true;
	                    stats.push((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getStats)(node, sensorMap, isStandbyAsUnOccupied));
	                    break;
	            }
	        }
	        if (isOA && isMR) {
	            isAllAreas = true;
	        } else {
	            isAllAreas = false;
	        }
	    }
	
	    var renderGaugeCards = (0, _react.useCallback)(function () {
	        if (stats.length > 0) {
	            var sumMr = 0;var sumOARooms = 0;var sumSensors = 0;
	            var sumInUsedDesks = 0;var sumInUsedMr = 0;var sumInUsedOA = 0;
	            for (var i = 0, n = stats.length; i < n; i++) {
	                var _stats$i = stats[i];
	                var allSensors = _stats$i.allSensors;
	                var allDesksInUse = _stats$i.allDesksInUse;
	                var meetingRooms = _stats$i.meetingRooms;
	                var meetingRoomsInuse = _stats$i.meetingRoomsInuse;
	                var openAreaRooms = _stats$i.openAreaRooms;
	                var openAreaRoomsInUse = _stats$i.openAreaRoomsInUse;
	
	                sumMr += meetingRooms;
	                sumSensors += allSensors;
	                sumOARooms += openAreaRooms;
	                sumInUsedDesks += allDesksInUse;
	                sumInUsedMr += meetingRoomsInuse;
	                sumInUsedOA += openAreaRoomsInUse;
	            }
	
	            // let totalRoomsValues = [50, 100]; // default
	            var oaValues = [sumOARooms - sumInUsedOA, sumOARooms];
	            var mrValues = [sumMr - sumInUsedMr, sumMr];
	            var deskValues = [sumSensors - sumInUsedDesks, sumSensors];
	            if (isAllAreas) {
	                // totalRoomsValues = [(sumMr + sumOARooms) - (sumInUsedMr + sumInUsedOA), sumMr + sumOARooms];
	                return _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        dispatch: dispatch,
	                        scaleMode: scaleMode,
	                        values: deskValues,
	                        gauge: gauge0,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge0.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    }),
	                    sumOARooms ? _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        dispatch: dispatch,
	                        scaleMode: scaleMode,
	                        values: oaValues,
	                        gauge: gauge1,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge1.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    }) : _react2['default'].createElement('div', null),
	                    sumMr && _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        dispatch: dispatch,
	                        scaleMode: scaleMode,
	                        values: mrValues,
	                        gauge: gauge2,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge2.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    })
	                );
	            }
	            if (isMR) {
	                return _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    sumSensors && _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        scaleMode: scaleMode,
	                        dispatch: dispatch,
	                        values: deskValues,
	                        gauge: gauge0,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge0.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    }),
	                    sumMr && _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        scaleMode: scaleMode,
	                        dispatch: dispatch,
	                        values: mrValues,
	                        gauge: gauge2,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge2.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    })
	                );
	            }
	            if (isOA) {
	                return _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    sumSensors && _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        scaleMode: scaleMode,
	                        dispatch: dispatch,
	                        values: deskValues,
	                        gauge: gauge0,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge0.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    }),
	                    sumOARooms && _react2['default'].createElement(_entityGaugeCard2['default'], {
	                        dispatch: dispatch,
	                        scaleMode: scaleMode,
	                        values: oaValues,
	                        gauge: gauge1,
	                        colorPickerRef: colorPickerRef,
	                        title: gauge1.label,
	                        livefeedSlides: livefeedSlides,
	                        editorView: editorView,
	                        slideCurrentIndex: slideCurrentIndex,
	                        stepNumberState: stepNumberState
	                    })
	                );
	            }
	        }
	    }, [editorView, stepNumberState, gauge0, gauge1, gauge2, isAllAreas, scaleMode, dispatch, isMR, isOA, stats, livefeedSlides, slideCurrentIndex]);
	
	    return _react2['default'].createElement(
	        'span',
	        { style: { fontFamily: fontFamily } },
	        renderGaugeCards(),
	        _react2['default'].createElement(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker2['default'], { ref: colorPickerRef })
	    );
	};
	
	exports['default'] = Widgets;
	module.exports = exports['default'];

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonGauge = __webpack_require__(1987);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonGauge2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonGauge);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _RndStyle = __webpack_require__(1963);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	__webpack_require__(1990);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var GaugeCard = function GaugeCard(props) {
	    _react2['default'].useEffect(function () {
	        _reactTooltip2['default'].rebuild(); // componentDidUpdate()
	    });
	    var dispatch = props.dispatch;
	    var livefeedSlides = props.livefeedSlides;
	    var editorView = props.editorView;
	    var slideCurrentIndex = props.slideCurrentIndex;
	    var stepNumberState = props.stepNumberState;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var widgetLabelType = _livefeedSlides$slideCurrentIndex.floorplanOptions.widgetLabelType;
	    var historyEntities = _livefeedSlides$slideCurrentIndex.historyEntities;
	    var rightPanelGaugeOffsetdBg = _livefeedSlides$slideCurrentIndex.rightPanelGaugeOffsetdBg;
	    var rightPanelGaugeOccupiedBg = _livefeedSlides$slideCurrentIndex.rightPanelGaugeOccupiedBg;
	    var rightPanelGaugeNeedle = _livefeedSlides$slideCurrentIndex.rightPanelGaugeNeedle;
	    var rightPanelTextTitle = _livefeedSlides$slideCurrentIndex.rightPanelTextTitle;
	    var rightPanelGaugeValueLabel = _livefeedSlides$slideCurrentIndex.rightPanelGaugeValueLabel;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	    var scaleMode = props.scaleMode;
	    var values = props.values;
	    var colorPickerRef = props.colorPickerRef;
	    var title = props.title;
	    var gauge = props.gauge;
	
	    var setCurrentEntitySwitch = (0, _react.useCallback)(function (e, entity) {
	        e.preventDefault();
	        e.stopPropagation();
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, entity, dispatch);
	    }, [currentEntity, dispatch]);
	
	    var setGaugePos = (0, _react.useCallback)(function (newPosition) {
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        // prevent duplicate dispatch
	        if (gauge.left !== x || gauge.top !== y) {
	            var newGaugePos = (0, _immutabilityHelper2['default'])(gauge, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: "" },
	                activeToolbarItems: _defineProperty({}, 0, { align: { $set: "" } })
	            });
	            dispatch((0, _actionsLivefeed.updateGauge)(newGaugePos));
	        }
	    }, [dispatch, gauge]);
	
	    var setGaugeSize = (0, _react.useCallback)(function (width, newPosition) {
	        var newWidth = width > 534 ? 534 : width; // maximum width 534
	        var x = newPosition.x;
	        var y = newPosition.y;
	
	        var align = '' + (gauge.left === x ? '' + gauge.activeToolbarItems[0].align : ""); // if x doesn't change, keep toolbar active
	        if (gauge.width !== width || gauge.left !== newPosition.x) {
	            var newGaugeSize = (0, _immutabilityHelper2['default'])(gauge, {
	                top: { $set: y },
	                left: { $set: x },
	                align: { $set: align },
	                width: { $set: newWidth },
	                activeToolbarItems: _defineProperty({}, 0, {
	                    align: { $set: align }
	                })
	            });
	            dispatch((0, _actionsLivefeed.updateGauge)(newGaugeSize));
	        }
	    }, [dispatch, gauge]);
	
	    var gaugeValueLabelAlign = undefined;
	    switch (rightPanelGaugeValueLabel.align) {
	        case "left":
	            gaugeValueLabelAlign = "flex-start";
	            break;
	        case "right":
	            gaugeValueLabelAlign = "flex-end";
	            break;
	        case "center":
	            gaugeValueLabelAlign = "center";
	            break;
	    }
	    var enableResizing = {
	        bottom: false, bottomLeft: editorView, bottomRight: editorView,
	        left: false, right: false, top: false,
	        topLeft: editorView, topRight: editorView
	    };
	    var handleSetCurrentEntityCallback = (0, _react.useCallback)(function () {
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, gauge, dispatch);
	    }, [currentEntity, dispatch, gauge]);
	
	    var gaugeTitleModalRef = _react2['default'].useRef(null);
	
	    var _React$useState = _react2['default'].useState('');
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var gaugeTitleState = _React$useState2[0];
	    var setGaugeTitleState = _React$useState2[1];
	
	    var _React$useState3 = _react2['default'].useState(false);
	
	    var _React$useState32 = _slicedToArray(_React$useState3, 2);
	
	    var isEditMode = _React$useState32[0];
	    var setEditMode = _React$useState32[1];
	
	    var inputOnchange = (0, _react.useCallback)(function (e) {
	        if (isEditMode) {
	            setGaugeTitleState(e.target.value);
	        }
	    }, [isEditMode]);
	
	    function inputDoubleClick(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        setEditMode(true);
	        gaugeTitleModalRef.current.open();
	    }
	
	    _react2['default'].useEffect(function () {
	        setGaugeTitleState(title);
	    }, [title, rightPanelTextTitle.contents]);
	
	    var confirmEditTitle = (0, _react.useCallback)(function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        var newTitle = (0, _immutabilityHelper2['default'])(gauge, {
	            label: { $set: gaugeTitleState }
	        });
	        dispatch((0, _actionsLivefeed.updateGauge)(newTitle));
	        gaugeTitleModalRef.current.close();
	    }, [dispatch, gauge, gaugeTitleState]);
	
	    var titleTip = 'Click and choose toolbar options to change text style <br /> Double click to edit text';
	
	    function renderGaugeCards() {
	        return _react2['default'].createElement(
	            _react.Fragment,
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'card-container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'card-svg',
	                        style: { justifyContent: gaugeValueLabelAlign, userSelect: 'none' } },
	                    _react2['default'].createElement(
	                        'div',
	                        { style: { borderColor: '' + (editorView ? '' + rightPanelTextTitle.color : 'none') },
	                            className: 'card-svg__editor ' + (editorView ? '' : 'card-svg__preview') },
	                        editorView && _react2['default'].createElement(
	                            _react2['default'].Fragment,
	                            null,
	                            _react2['default'].createElement('div', { className: 'rect rect_occupied ' + (currentEntity.id === "rightPanelGaugeOccupiedBg" ? 'rect_occupied_active' : ''),
	                                'data-tip': 'Click to change gauge\'s occupied color',
	                                onClick: function (e) {
	                                    setCurrentEntitySwitch(e, rightPanelGaugeOccupiedBg);
	                                    colorPickerRef.current.openColorPicker();
	                                }
	                            }),
	                            _react2['default'].createElement('div', { className: 'rect ' + (currentEntity.id === "rightPanelGaugeOffsetdBg" ? 'rect_active' : ''),
	                                'data-tip': 'Click to change gauge\'s offset color',
	                                onClick: function (e) {
	                                    setCurrentEntitySwitch(e, rightPanelGaugeOffsetdBg);
	                                    colorPickerRef.current.openColorPicker();
	                                }
	                            }),
	                            _react2['default'].createElement('div', { className: 'needle ' + (currentEntity.id === "rightPanelGaugeNeedle" ? 'needle_active' : ''),
	                                'data-tip': 'Click to change the needle\'s color',
	                                onClick: function (e) {
	                                    setCurrentEntitySwitch(e, rightPanelGaugeNeedle);
	                                    colorPickerRef.current.openColorPicker();
	                                }
	                            })
	                        )
	                    ),
	                    _react2['default'].createElement(_componentsPagesLivefeedEditorEditorContainerCommonGauge2['default'], {
	                        values: values,
	                        rightPanelGaugeOffsetdBg: rightPanelGaugeOffsetdBg,
	                        rightPanelGaugeOccupiedBg: rightPanelGaugeOccupiedBg,
	                        rightPanelGaugeNeedle: rightPanelGaugeNeedle,
	                        widgetLabelType: widgetLabelType,
	                        currentEntity: currentEntity,
	                        widgetStyle: {
	                            borderColor: '' + (editorView ? '' + rightPanelGaugeValueLabel.color : 'transparent'),
	                            color: rightPanelGaugeValueLabel.color,
	                            fontSize: rightPanelGaugeValueLabel.size * (props.scaleMode ? 0.375 : 1),
	                            fontWeight: rightPanelGaugeValueLabel.textStyle.bold ? 'bold' : 'unset',
	                            fontStyle: rightPanelGaugeValueLabel.textStyle.italic ? 'italic' : 'unset',
	                            textDecoration: rightPanelGaugeValueLabel.textStyle.underline ? 'underline' : 'unset'
	                        },
	                        setCurrentEntitySwitch: function (e) {
	                            return setCurrentEntitySwitch(e, rightPanelGaugeValueLabel);
	                        }
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'card-bottom', style: { textAlign: rightPanelTextTitle.align } },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            'data-tip': titleTip,
	                            className: 'card-title',
	                            onClick: function (e) {
	                                return setCurrentEntitySwitch(e, rightPanelTextTitle);
	                            },
	                            onDoubleClick: function (e) {
	                                return inputDoubleClick(e);
	                            },
	                            style: {
	                                zIndex: 3,
	                                color: rightPanelTextTitle.color,
	                                fontSize: rightPanelTextTitle.size * (props.scaleMode ? 0.375 : 1),
	                                fontWeight: rightPanelTextTitle.textStyle.bold ? 'bold' : 'unset',
	                                fontStyle: rightPanelTextTitle.textStyle.italic ? 'italic' : 'unset',
	                                textDecoration: rightPanelTextTitle.textStyle.underline ? 'underline' : 'unset'
	                            } },
	                        title,
	                        _react2['default'].createElement('span', { className: (editorView ? 'card-title__editor-border' : 'card-title__preview') + ' ' + (currentEntity.id === "rightPanelTextTitle" ? 'card-title__editor-border_active' : '') })
	                    )
	                )
	            )
	        );
	    }
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        editorView ? _react2['default'].createElement(
	            _reactRnd.Rnd,
	            {
	                bounds: ".livefeed-preview-wrapper",
	                enableResizing: enableResizing,
	                disableDragging: !editorView,
	                style: {
	                    pointerEvents: editorView ? 'all' : 'none',
	                    border: !editorView && 'none'
	                },
	                className: 'entity-resizable  ' + (currentEntity.id === 'gauge' ? 'entity-active' : '') + ' ',
	                lockAspectRatio: true,
	                resizeHandleWrapperClass: "resizers",
	                resizeHandleStyles: {
	                    topRight: _RndStyle.RndStyle.topRight, topLeft: _RndStyle.RndStyle.topLeft,
	                    bottomLeft: _RndStyle.RndStyle.bottomLeft, bottomRight: _RndStyle.RndStyle.bottomRight
	                },
	                size: { width: gauge.width * (scaleMode ? 0.375 : 1) + 12, height: "auto" },
	                position: { x: gauge.left * (scaleMode ? 0.375 : 1) - 6, y: gauge.top * (scaleMode ? 0.375 : 1) - 6 },
	                onClick: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onDragStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onDragStop: function (e, d) {
	                    return setGaugePos((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(d));
	                },
	                onResizeStart: function () {
	                    return handleSetCurrentEntityCallback();
	                },
	                onResizeStop: function (e, direction, ref, delta, position) {
	                    return position.x !== 0 && setGaugeSize(ref.offsetWidth - 12, (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getPosition)(position));
	                }
	            },
	            renderGaugeCards()
	        ) : _react2['default'].createElement(
	            'div',
	            {
	                style: {
	                    position: "absolute",
	                    width: gauge.width * (scaleMode ? 0.375 : 1) + 12,
	                    height: "auto",
	                    pointerEvents: "none",
	                    transform: 'translate(' + (gauge.left * (scaleMode ? 0.375 : 1) - 6) + 'px, ' + (gauge.top * (scaleMode ? 0.375 : 1) - 6) + 'px)'
	                },
	                className: 'entity-resizable editor-view_false'
	            },
	            renderGaugeCards()
	        ),
	        _react2['default'].createElement(_reactTooltip2['default'], { multiline: true, place: 'top', type: 'dark', effect: 'solid' }),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                ref: gaugeTitleModalRef,
	                onClose: function () {
	                    return setGaugeTitleState(title);
	                },
	                clickButton: function (e) {
	                    return confirmEditTitle(e);
	                },
	                header: 'Edit gauge chart title',
	                buttonText: 'Confirm',
	                buttonClass: 'btn-success',
	                entry: null
	            },
	            _react2['default'].createElement('input', {
	                value: gaugeTitleState,
	                name: gaugeTitleState,
	                onChange: function (e) {
	                    return inputOnchange(e);
	                }, type: 'text' })
	        )
	    );
	};
	
	exports['default'] = GaugeCard;
	module.exports = exports['default'];
	/* click able svg areas */

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1988);
	
	var Gauge = function Gauge(props) {
	    var _useState = (0, _react.useState)([0, 100]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var stateValues = _useState2[0];
	    var setStateValues = _useState2[1];
	    var rightPanelGaugeOffsetdBg = props.rightPanelGaugeOffsetdBg;
	    var rightPanelGaugeOccupiedBg = props.rightPanelGaugeOccupiedBg;
	    var rightPanelGaugeNeedle = props.rightPanelGaugeNeedle;
	
	    _react2['default'].useEffect(function () {
	        var timer = setTimeout(function () {
	            updateGauge();
	            setStateValues(props.values);
	        }, 600);
	        return function () {
	            clearTimeout(timer);
	        };
	    }, [props.values, updateGauge]);
	
	    var RADIUS = 75;
	    var STROKE_WIDTH = 5;
	    var GAUGE_DIAMETER = 2 * RADIUS * Math.PI; // Diameter of the circle
	    var ARC_ANGLE = 110;
	    var SQ_VIEW_BOX = 150;
	    var ARC_ROTATE = (180 - ARC_ANGLE) / 2 + ARC_ANGLE;
	    var FULL_DASH_LENG = GAUGE_DIAMETER * ((360 - ARC_ANGLE) / 360);
	    var STROKE_DASH_ARRAY_TOTAL = [FULL_DASH_LENG, GAUGE_DIAMETER];
	
	    var updateGauge = _react2['default'].useCallback(function () {
	        var occupiedPercent = stateValues[0] / stateValues[1]; // get the percent occupied
	        var occupiedArcLength = FULL_DASH_LENG * occupiedPercent;
	
	        var strokeDasharrayOccupied = [occupiedArcLength, GAUGE_DIAMETER]; // calculate the occupied value
	        var needleAngle = ARC_ROTATE + (360 - ARC_ANGLE) * occupiedPercent;
	        return {
	            strokeDasharrayOccupied: strokeDasharrayOccupied,
	            needleAngle: needleAngle
	        };
	    }, [ARC_ROTATE, FULL_DASH_LENG, GAUGE_DIAMETER, stateValues]);
	
	    _react2['default'].useEffect(function () {
	        var txts = document.getElementsByClassName("txt");
	        var rcts = document.getElementsByClassName("rct");
	        for (var i = 0; i < txts.length; i++) {
	            var txt = txts.item(i);
	            var rct = rcts.item(i);
	            var bbox = txt.getBBox();
	            rct.setAttribute("x", bbox.x - 2);
	            rct.setAttribute("y", bbox.y);
	            rct.setAttribute("width", bbox.width + 2 * 2);
	            rct.setAttribute("height", bbox.height);
	        }
	    });
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'svg',
	            { className: 'livefeed-svg-gauge', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 ' + SQ_VIEW_BOX + ' ' + SQ_VIEW_BOX },
	            _react2['default'].createElement(
	                'g',
	                { className: 'gauge-arc', transform: 'rotate(' + ARC_ROTATE + ', ' + SQ_VIEW_BOX / 2 + ', ' + SQ_VIEW_BOX / 2 + ')' },
	                _react2['default'].createElement('circle', { strokeLinecap: 'round', fill: 'none', cx: '50%', cy: '50%', r: RADIUS, strokeDasharray: STROKE_DASH_ARRAY_TOTAL,
	                    stroke: rightPanelGaugeOffsetdBg.color, strokeWidth: STROKE_WIDTH }),
	                _react2['default'].createElement('circle', { strokeLinecap: 'round', fill: 'none', cx: '50%', cy: '50%', r: RADIUS, strokeDasharray: updateGauge().strokeDasharrayOccupied,
	                    stroke: rightPanelGaugeOccupiedBg.color, strokeWidth: STROKE_WIDTH })
	            ),
	            _react2['default'].createElement(
	                'g',
	                { className: 'needle', transform: 'rotate(' + updateGauge().needleAngle + ', ' + SQ_VIEW_BOX / 2 + ', ' + SQ_VIEW_BOX / 2 + ')' },
	                _react2['default'].createElement('line', { strokeLinecap: 'round', stroke: rightPanelGaugeNeedle.color, strokeWidth: '3', x1: SQ_VIEW_BOX / 2, y1: SQ_VIEW_BOX / 2, x2: SQ_VIEW_BOX - 15, y2: SQ_VIEW_BOX / 2 }),
	                _react2['default'].createElement('circle', { cx: SQ_VIEW_BOX / 2, cy: SQ_VIEW_BOX / 2, r: '11', fill: rightPanelGaugeNeedle.color,
	                    stroke: 'none' })
	            )
	        ),
	        _react2['default'].createElement(
	            'svg',
	            { className: 'livefeed-svg-gauge-label', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 ' + SQ_VIEW_BOX + ' ' + SQ_VIEW_BOX, style: { position: "absolute" } },
	            _react2['default'].createElement(
	                'g',
	                {
	                    style: { cursor: "pointer" },
	                    onClick: function (e) {
	                        return props.setCurrentEntitySwitch(e);
	                    }
	                },
	                _react2['default'].createElement('rect', {
	                    className: 'rct',
	                    x: SQ_VIEW_BOX / 4,
	                    y: 100,
	                    width: SQ_VIEW_BOX / 2,
	                    height: 40,
	                    style: {
	                        stroke: props.widgetStyle.borderColor,
	                        strokeWidth: 1,
	                        strokeDasharray: props.currentEntity.id === "rightPanelGaugeValueLabel" ? "1 0" : "1 1",
	                        fill: "none"
	                    } }),
	                _react2['default'].createElement(
	                    'text',
	                    {
	                        className: 'txt',
	                        'data-tip': 'Click and choose toolbar options to change text style',
	                        style: {
	                            fill: props.widgetStyle.color,
	                            fontSize: props.widgetStyle.fontSize,
	                            fontWeight: props.widgetStyle.fontWeight,
	                            fontStyle: props.widgetStyle.fontStyle,
	                            textDecoration: props.widgetStyle.textDecoration
	                        },
	                        x: SQ_VIEW_BOX / 2,
	                        y: SQ_VIEW_BOX / 2 + 50
	                    },
	                    props.widgetLabelType ? stateValues[0] + '/' + stateValues[1] : '' + stateValues[0]
	                )
	            )
	        )
	    );
	};
	exports['default'] = Gauge;
	module.exports = exports['default'];

/***/ }),
/* 1988 */
[2373, 1989],
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".livefeed-svg-gauge,.livefeed-svg-gauge-label{width:100%;overflow:visible!important;top:0;left:0;transition:all .4s ease}.livefeed-svg-gauge-label .needle,.livefeed-svg-gauge-label circle,.livefeed-svg-gauge .needle,.livefeed-svg-gauge circle{transition:all .4s ease}.livefeed-svg-gauge-label text,.livefeed-svg-gauge text{text-anchor:middle;alignment-baseline:middle;dominant-baseline:middle;transition:all .4s ease}", ""]);
	
	// exports


/***/ }),
/* 1990 */
[2372, 1991],
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".card-container{text-align:center;vertical-align:middle;width:100%;z-index:3}.card-container .card-bottom{padding:0 10px;margin-top:-15px}.card-container .gaugle-label{transform:translateY(-10%)}.card-container .card-title,.card-container .gaugle-label{position:relative;display:inline-block;transition:all .2s ease;cursor:pointer;padding:5px;line-height:100%}.card-container .card-title__editor-border,.card-container .gaugle-label__editor-border{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px dotted;display:block}.card-container .card-title__editor-border_active,.card-container .gaugle-label__editor-border_active{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px solid}.card-container .card-title__preview,.card-container .gaugle-label__preview{position:absolute;width:100%;height:100%;transform:translate(-5px,-85%);border:1px dotted;border-color:transparent!important}.card-container .card-svg{display:flex;align-items:center;position:relative;margin:auto;transition:all .2s ease;width:100%}.card-container .card-svg__editor{width:105%;height:100%;position:absolute}.card-container .card-svg__editor .needle{width:30%;position:absolute;transition:all .2s ease;display:inline-flex;justify-content:center;z-index:3;height:50%;top:8%;left:35%;cursor:pointer}.card-container .card-svg__editor .needle:hover,.card-container .card-svg__editor .needle_active{background:rgba(0,0,0,.5)}.card-container .card-svg__editor .rect{height:70%;width:35%;position:absolute;right:0;top:10%;z-index:3;transition:all .2s ease;cursor:pointer}.card-container .card-svg__editor .rect:hover,.card-container .card-svg__editor .rect_active{background:rgba(0,0,0,.5)}.card-container .card-svg__editor .rect_occupied{left:0}.card-container .card-svg__editor .rect_occupied_active{background:rgba(0,0,0,.5)}.card-container .card-svg__preview{width:115%;height:110%;border-width:1px;border-style:dotted;position:absolute;border-color:transparent!important}", ""]);
	
	// exports


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1993);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _reactColor = __webpack_require__(1995);
	
	var _reactRnd = __webpack_require__(1951);
	
	var _reactRedux = __webpack_require__(47);
	
	var ColorPicker = (0, _react.forwardRef)(function (props, ref) {
	    var _React$useState = _react2['default'].useState(false);
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var displayColorPicker = _React$useState2[0];
	    var setDisplayColorPicker = _React$useState2[1];
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var colorPickerPos = _useSelector.colorPickerPos;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	    var stepNumberState = _useSelector.stepNumberState;
	    var historyEntities = livefeedSlides[slideCurrentIndex].historyEntities;
	
	    var history = historyEntities.slice();
	    var currentEntity = history[stepNumberState];
	    var onChangeComplete = (0, _react.useCallback)(function (color) {
	        var id = currentEntity.id;
	        var rgba = color.rgb;
	        var processColor = 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')';
	        var newColor = processColor;
	        dispatch((0, _actionsLivefeed.colorisingEntity)(id, newColor));
	    }, [currentEntity.id, dispatch]);
	
	    function _openColorPicker() {
	        setDisplayColorPicker(true);
	    }
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            openColorPicker: function openColorPicker() {
	                _openColorPicker();
	            }
	        };
	    });
	
	    var onDragStop = (0, _react.useCallback)(function (_ref) {
	        var x = _ref.x;
	        var y = _ref.y;
	
	        dispatch((0, _actionsLivefeed.updateColorPickerPos)({ x: x, y: y }));
	    }, [dispatch]);
	
	    var enableResizing = {
	        bottom: false, bottomLeft: false, bottomRight: false, left: false,
	        right: false, top: false, topLeft: false, topRight: false
	    };
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            {
	                className: props.className,
	                onClick: function () {
	                    return props.clickable ? _openColorPicker() : null;
	                }
	            },
	            props.children
	        ),
	        displayColorPicker && _react2['default'].createElement(
	            _react.Fragment,
	            null,
	            _react2['default'].createElement('div', {
	                style: {
	                    position: 'fixed', top: 0, bottom: 0, left: 0,
	                    right: 0, zIndex: 7091
	                },
	                onClick: function (e) {
	                    e.stopPropagation();
	                    e.preventDefault();
	                    setDisplayColorPicker(false);
	                } }),
	            _react2['default'].createElement(
	                'div',
	                { style: { position: 'fixed', width: 250, height: 350.5, right: 50, top: '25%', zIndex: 7093 } },
	                _react2['default'].createElement(
	                    _reactRnd.Rnd,
	                    {
	                        className: 'color-picker-drag',
	                        dragHandleClassName: 'draggable-place',
	                        enableResizing: enableResizing,
	                        'default': {
	                            x: colorPickerPos.x,
	                            y: colorPickerPos.y,
	                            width: 250,
	                            height: "auto"
	                        },
	                        onDragStop: function (e, d) {
	                            return onDragStop({ x: d.x, y: d.y });
	                        }
	                    },
	                    _react2['default'].createElement(
	                        _react.Fragment,
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'draggable-place' },
	                            _react2['default'].createElement(
	                                'i',
	                                { onClick: function () {
	                                        return setDisplayColorPicker(false);
	                                    },
	                                    className: 'material-icons delete--icons', 'data-tip': 'Delete', currentitem: 'false' },
	                                'clear'
	                            )
	                        ),
	                        _react2['default'].createElement(_reactColor.SketchPicker, {
	                            width: 230,
	                            color: currentEntity.color, onChangeComplete: function (color) {
	                                return onChangeComplete(color);
	                            } })
	                    )
	                )
	            )
	        )
	    );
	});
	
	ColorPicker.propTypes = {
	    className: _propTypes2['default'].any
	};
	exports['default'] = ColorPicker;
	module.exports = exports['default'];

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1994);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../node_modules/less-loader/index.js!./ColorPicker.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../node_modules/less-loader/index.js!./ColorPicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".color-picker-drag{z-index:7091;box-shadow:0 4px 12px 1px rgba(0,0,0,.5);border-radius:4px}.color-picker-drag .draggable-place{z-index:7091;width:250px;padding-top:0;background:#f0f0f0;height:25px;border-radius:4px 4px 0 0;cursor:move;display:flex;align-items:center}.color-picker-drag .draggable-place i{height:16px;width:16px;font-size:16px;cursor:pointer;margin-left:calc(100% - 20px)}.color-picker-drag .draggable-place i:hover{border-radius:50%;color:#fff;background-color:#ef5350}.color-picker-drag .sketch-picker{border-radius:0 0 4px 4px!important;box-shadow:none!important;background:#f9f9f9!important}", ""]);
	
	// exports


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.GooglePicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(1996);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(2184);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(2186);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(2189);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(2195);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(2198);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(2200);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(2202);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(2203);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(2209);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(2212);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(2216);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(2220);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _Google = __webpack_require__(2221);
	
	Object.defineProperty(exports, 'GooglePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Google).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(2176);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2149);
	
	var _AlphaPointer = __webpack_require__(2183);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker ' + className },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(1998);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(2113);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(2145);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(2146);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(2147);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(2148);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(1999);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(2001);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(172);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(2025);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    isArray = __webpack_require__(2000),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 2000 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(2002),
	    castFunction = __webpack_require__(2023);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(2003),
	    keys = __webpack_require__(2005);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(2004);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 2004 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(2006),
	    baseKeys = __webpack_require__(2018),
	    isArrayLike = __webpack_require__(2021);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2007),
	    isArguments = __webpack_require__(2008),
	    isArray = __webpack_require__(2000),
	    isBuffer = __webpack_require__(2010),
	    isIndex = __webpack_require__(2012),
	    isTypedArray = __webpack_require__(2013);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(2009),
	    isObjectLike = __webpack_require__(181);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(175),
	    stubFalse = __webpack_require__(2011);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 2012 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(2014),
	    baseUnary = __webpack_require__(2016),
	    nodeUtil = __webpack_require__(2017);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    isLength = __webpack_require__(2015),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(176);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(2019),
	    nativeKeys = __webpack_require__(2020);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(180);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(2022),
	    isLength = __webpack_require__(2015);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(173),
	    isObject = __webpack_require__(1973);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(2024);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(2026),
	    baseIteratee = __webpack_require__(2027),
	    baseMap = __webpack_require__(2110),
	    isArray = __webpack_require__(2000);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(2028),
	    baseMatchesProperty = __webpack_require__(2093),
	    identity = __webpack_require__(2024),
	    isArray = __webpack_require__(2000),
	    property = __webpack_require__(2107);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(2029),
	    getMatchData = __webpack_require__(2090),
	    matchesStrictComparable = __webpack_require__(2092);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(2030),
	    baseIsEqual = __webpack_require__(2066);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(2031),
	    stackClear = __webpack_require__(2039),
	    stackDelete = __webpack_require__(2040),
	    stackGet = __webpack_require__(2041),
	    stackHas = __webpack_require__(2042),
	    stackSet = __webpack_require__(2043);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2032),
	    listCacheDelete = __webpack_require__(2033),
	    listCacheGet = __webpack_require__(2036),
	    listCacheHas = __webpack_require__(2037),
	    listCacheSet = __webpack_require__(2038);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(2034);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(2035);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(2034);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(2034);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(2034);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(2031);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(2031),
	    Map = __webpack_require__(2044),
	    MapCache = __webpack_require__(2051);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045),
	    root = __webpack_require__(175);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(2046),
	    getValue = __webpack_require__(2050);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(2022),
	    isMasked = __webpack_require__(2047),
	    isObject = __webpack_require__(1973),
	    toSource = __webpack_require__(2049);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(2048);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(175);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2052),
	    mapCacheDelete = __webpack_require__(2060),
	    mapCacheGet = __webpack_require__(2063),
	    mapCacheHas = __webpack_require__(2064),
	    mapCacheSet = __webpack_require__(2065);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(2053),
	    ListCache = __webpack_require__(2031),
	    Map = __webpack_require__(2044);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(2054),
	    hashDelete = __webpack_require__(2056),
	    hashGet = __webpack_require__(2057),
	    hashHas = __webpack_require__(2058),
	    hashSet = __webpack_require__(2059);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(2055);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 2056 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(2055);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(2055);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(2055);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(2061);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(2062);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(2061);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(2061);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(2061);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(2067),
	    isObjectLike = __webpack_require__(181);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(2030),
	    equalArrays = __webpack_require__(2068),
	    equalByTag = __webpack_require__(2074),
	    equalObjects = __webpack_require__(2078),
	    getTag = __webpack_require__(2085),
	    isArray = __webpack_require__(2000),
	    isBuffer = __webpack_require__(2010),
	    isTypedArray = __webpack_require__(2013);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(2069),
	    arraySome = __webpack_require__(2072),
	    cacheHas = __webpack_require__(2073);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(2051),
	    setCacheAdd = __webpack_require__(2070),
	    setCacheHas = __webpack_require__(2071);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 2070 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(174),
	    Uint8Array = __webpack_require__(2075),
	    eq = __webpack_require__(2035),
	    equalArrays = __webpack_require__(2068),
	    mapToArray = __webpack_require__(2076),
	    setToArray = __webpack_require__(2077);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(175);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 2076 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(2079);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(2080),
	    getSymbols = __webpack_require__(2082),
	    keys = __webpack_require__(2005);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(2081),
	    isArray = __webpack_require__(2000);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(2083),
	    stubArray = __webpack_require__(2084);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2086),
	    Map = __webpack_require__(2044),
	    Promise = __webpack_require__(2087),
	    Set = __webpack_require__(2088),
	    WeakMap = __webpack_require__(2089),
	    baseGetTag = __webpack_require__(173),
	    toSource = __webpack_require__(2049);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045),
	    root = __webpack_require__(175);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045),
	    root = __webpack_require__(175);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045),
	    root = __webpack_require__(175);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045),
	    root = __webpack_require__(175);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(2091),
	    keys = __webpack_require__(2005);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1973);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 2092 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(2066),
	    get = __webpack_require__(2094),
	    hasIn = __webpack_require__(2104),
	    isKey = __webpack_require__(2097),
	    isStrictComparable = __webpack_require__(2091),
	    matchesStrictComparable = __webpack_require__(2092),
	    toKey = __webpack_require__(2103);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(2095);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(2096),
	    toKey = __webpack_require__(2103);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2000),
	    isKey = __webpack_require__(2097),
	    stringToPath = __webpack_require__(2098),
	    toString = __webpack_require__(2101);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2000),
	    isSymbol = __webpack_require__(1978);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2099);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(2100);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(2051);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(2102);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(174),
	    arrayMap = __webpack_require__(2026),
	    isArray = __webpack_require__(2000),
	    isSymbol = __webpack_require__(1978);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(1978);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(2105),
	    hasPath = __webpack_require__(2106);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 2105 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(2096),
	    isArguments = __webpack_require__(2008),
	    isArray = __webpack_require__(2000),
	    isIndex = __webpack_require__(2012),
	    isLength = __webpack_require__(2015),
	    toKey = __webpack_require__(2103);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(2108),
	    basePropertyDeep = __webpack_require__(2109),
	    isKey = __webpack_require__(2097),
	    toKey = __webpack_require__(2103);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(2095);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(2111),
	    isArrayLike = __webpack_require__(2021);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(2002),
	    createBaseEach = __webpack_require__(2112);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(2021);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(2001);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(2114);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(2115);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(2030),
	    arrayEach = __webpack_require__(2116),
	    assignValue = __webpack_require__(2117),
	    baseAssign = __webpack_require__(2120),
	    baseAssignIn = __webpack_require__(2122),
	    cloneBuffer = __webpack_require__(2126),
	    copyArray = __webpack_require__(2127),
	    copySymbols = __webpack_require__(2128),
	    copySymbolsIn = __webpack_require__(2129),
	    getAllKeys = __webpack_require__(2079),
	    getAllKeysIn = __webpack_require__(2131),
	    getTag = __webpack_require__(2085),
	    initCloneArray = __webpack_require__(2132),
	    initCloneByTag = __webpack_require__(2133),
	    initCloneObject = __webpack_require__(2139),
	    isArray = __webpack_require__(2000),
	    isBuffer = __webpack_require__(2010),
	    isMap = __webpack_require__(2141),
	    isObject = __webpack_require__(1973),
	    isSet = __webpack_require__(2143),
	    keys = __webpack_require__(2005),
	    keysIn = __webpack_require__(2123);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 2116 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(2118),
	    eq = __webpack_require__(2035);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(2119);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2045);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2121),
	    keys = __webpack_require__(2005);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(2117),
	    baseAssignValue = __webpack_require__(2118);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2121),
	    keysIn = __webpack_require__(2123);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(2006),
	    baseKeysIn = __webpack_require__(2124),
	    isArrayLike = __webpack_require__(2021);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1973),
	    isPrototype = __webpack_require__(2019),
	    nativeKeysIn = __webpack_require__(2125);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 2125 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(175);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(183)(module)))

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2121),
	    getSymbols = __webpack_require__(2082);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2121),
	    getSymbolsIn = __webpack_require__(2130);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(2081),
	    getPrototype = __webpack_require__(179),
	    getSymbols = __webpack_require__(2082),
	    stubArray = __webpack_require__(2084);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(2080),
	    getSymbolsIn = __webpack_require__(2130),
	    keysIn = __webpack_require__(2123);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 2132 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(2134),
	    cloneDataView = __webpack_require__(2135),
	    cloneRegExp = __webpack_require__(2136),
	    cloneSymbol = __webpack_require__(2137),
	    cloneTypedArray = __webpack_require__(2138);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(2075);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(2134);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 2136 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(174);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(2134);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(2140),
	    getPrototype = __webpack_require__(179),
	    isPrototype = __webpack_require__(2019);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1973);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(2142),
	    baseUnary = __webpack_require__(2016),
	    nodeUtil = __webpack_require__(2017);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(2085),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(2144),
	    baseUnary = __webpack_require__(2016),
	    nodeUtil = __webpack_require__(2017);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(2085),
	    isObjectLike = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(2001);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(2150);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(2152);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(2154);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(2155);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Raised = __webpack_require__(2157);
	
	Object.defineProperty(exports, 'Raised', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Raised).default;
	  }
	});
	
	var _Saturation = __webpack_require__(2174);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(2176);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(2181);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(2151);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(2152);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden',
	            borderRadius: this.props.radius
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (hsl.a !== a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (initialA !== _a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(2153);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow,
	      children = _ref.children;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkboardCache = {};
	
	var render = exports.render = function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) {
	    return null;
	  }
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) {
	    return null;
	  } // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	};
	
	var get = exports.get = function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	
	  var checkboard = render(c1, c2, size, serverCanvas);
	  checkboardCache[key] = checkboard;
	  return checkboard;
	};

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_ARROW_OFFSET = 1;
	
	var UP_KEY_CODE = 38;
	var DOWN_KEY_CODE = 40;
	var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
	var isValidKeyCode = function isValidKeyCode(keyCode) {
	  return VALID_KEY_CODES.indexOf(keyCode) > -1;
	};
	var getNumberValue = function getNumberValue(value) {
	  return Number(String(value).replace(/%/g, ''));
	};
	
	var idCounter = 1;
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      _this.setUpdatedValue(e.target.value, e);
	    };
	
	    _this.handleKeyDown = function (e) {
	      // In case `e.target.value` is a percentage remove the `%` character
	      // and update accordingly with a percentage
	      // https://github.com/casesandberg/react-color/issues/383
	      var value = getNumberValue(e.target.value);
	      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
	        var offset = _this.getArrowOffset();
	        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
	
	        _this.setUpdatedValue(updatedValue, e);
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	
	    _this.inputId = 'rc-editable-input-' + idCounter++;
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
	        if (this.input === document.activeElement) {
	          this.setState({ blurValue: String(this.props.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getValueObjectWithLabel',
	    value: function getValueObjectWithLabel(value) {
	      return _defineProperty({}, this.props.label, value);
	    }
	  }, {
	    key: 'getArrowOffset',
	    value: function getArrowOffset() {
	      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
	    }
	  }, {
	    key: 'setUpdatedValue',
	    value: function setUpdatedValue(value, e) {
	      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
	      this.props.onChange && this.props.onChange(onChangeValue, e);
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          id: this.inputId,
	          style: styles.input,
	          ref: function ref(input) {
	            return _this2.input = input;
	          },
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder,
	          spellCheck: 'false'
	        }),
	        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
	          'label',
	          {
	            htmlFor: this.inputId,
	            style: styles.label,
	            onMouseDown: this.handleMouseDown
	          },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(2156);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$direction = this.props.direction,
	          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
	
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            padding: '0 2px',
	            position: 'relative',
	            height: '100%',
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'hue-' + direction,
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (hsl.h !== h) {
	      return {
	        h: h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (hsl.h !== _h) {
	      return {
	        h: _h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raised = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Raised = exports.Raised = function Raised(_ref) {
	  var zDepth = _ref.zDepth,
	      radius = _ref.radius,
	      background = _ref.background,
	      children = _ref.children,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      wrap: {
	        position: 'relative',
	        display: 'inline-block'
	      },
	      content: {
	        position: 'relative'
	      },
	      bg: {
	        absolute: '0px 0px 0px 0px',
	        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
	        borderRadius: radius,
	        background: background
	      }
	    },
	    'zDepth-0': {
	      bg: {
	        boxShadow: 'none'
	      }
	    },
	
	    'zDepth-1': {
	      bg: {
	        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	      }
	    },
	    'zDepth-2': {
	      bg: {
	        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	      }
	    },
	    'zDepth-3': {
	      bg: {
	        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	      }
	    },
	    'zDepth-4': {
	      bg: {
	        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	      }
	    },
	    'zDepth-5': {
	      bg: {
	        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	      }
	    },
	    'square': {
	      bg: {
	        borderRadius: '0'
	      }
	    },
	    'circle': {
	      bg: {
	        borderRadius: '50%'
	      }
	    }
	  }, passedStyles), { 'zDepth-1': zDepth === 1 });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap },
	    _react2.default.createElement('div', { style: styles.bg }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.content },
	      children
	    )
	  );
	};
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: 1,
	  radius: 2,
	  styles: {}
	};
	
	exports.default = Raised;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(2159),
	    createAssigner = __webpack_require__(2165);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(2030),
	    assignMergeValue = __webpack_require__(2160),
	    baseFor = __webpack_require__(2003),
	    baseMergeDeep = __webpack_require__(2161),
	    isObject = __webpack_require__(1973),
	    keysIn = __webpack_require__(2123),
	    safeGet = __webpack_require__(2163);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(2118),
	    eq = __webpack_require__(2035);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(2160),
	    cloneBuffer = __webpack_require__(2126),
	    cloneTypedArray = __webpack_require__(2138),
	    copyArray = __webpack_require__(2127),
	    initCloneObject = __webpack_require__(2139),
	    isArguments = __webpack_require__(2008),
	    isArray = __webpack_require__(2000),
	    isArrayLikeObject = __webpack_require__(2162),
	    isBuffer = __webpack_require__(2010),
	    isFunction = __webpack_require__(2022),
	    isObject = __webpack_require__(1973),
	    isPlainObject = __webpack_require__(172),
	    isTypedArray = __webpack_require__(2013),
	    safeGet = __webpack_require__(2163),
	    toPlainObject = __webpack_require__(2164);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(2021),
	    isObjectLike = __webpack_require__(181);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 2163 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2121),
	    keysIn = __webpack_require__(2123);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(2166),
	    isIterateeCall = __webpack_require__(2173);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(2024),
	    overRest = __webpack_require__(2167),
	    setToString = __webpack_require__(2169);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(2168);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 2168 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(2170),
	    shortOut = __webpack_require__(2172);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2171),
	    defineProperty = __webpack_require__(2119),
	    identity = __webpack_require__(2024);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 2171 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 2172 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(2035),
	    isArrayLike = __webpack_require__(2021),
	    isIndex = __webpack_require__(2012),
	    isObject = __webpack_require__(1973);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(1979);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(2175);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e) {
	      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      var renderWindow = _this.getContainerRenderWindow();
	      renderWindow.addEventListener('mousemove', _this.handleChange);
	      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.throttle.cancel();
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getContainerRenderWindow',
	    value: function getContainerRenderWindow() {
	      var container = this.container;
	
	      var renderWindow = window;
	      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
	        renderWindow = renderWindow.parent;
	      }
	      return renderWindow;
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      var renderWindow = this.getContainerRenderWindow();
	      renderWindow.removeEventListener('mousemove', this.handleChange);
	      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: function ref(container) {
	            return _this2.container = container;
	          },
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.white, className: 'saturation-white' },
	          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  }
	
	  if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left / containerWidth;
	  var bright = 1 - top / containerHeight;
	
	  return {
	    h: hsl.h,
	    s: saturation,
	    v: bright,
	    a: hsl.a,
	    source: 'hsv'
	  };
	};

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(1972);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.handleSwatchHover = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, color.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'render',
	      value: function render() {
	        var optionalEvents = {};
	        if (this.props.onSwatchHover) {
	          optionalEvents.onSwatchHover = this.handleSwatchHover;
	        }
	
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
	          onChange: this.handleChange
	        }, optionalEvents));
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(nextProps, state) {
	        return _extends({}, color.toState(nextProps.color, state.oldHue));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.propTypes = _extends({}, Picker.propTypes);
	
	  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  });
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isvalidColorString = exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;
	
	var _each = __webpack_require__(2178);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(2180);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
	  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
	  var checked = 0;
	  var passed = 0;
	  (0, _each2.default)(keysToCheck, function (letter) {
	    if (data[letter]) {
	      checked += 1;
	      if (!isNaN(data[letter])) {
	        passed += 1;
	      }
	      if (letter === 's' || letter === 'l') {
	        var percentPatt = /^\d+%$/;
	        if (percentPatt.test(data[letter])) {
	          passed += 1;
	        }
	      }
	    }
	  });
	  return checked === passed ? data : false;
	};
	
	var toState = exports.toState = function toState(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  var rgb = color.toRgb();
	  var hex = color.toHex();
	  if (hsl.s === 0) {
	    hsl.h = oldHue || 0;
	    hsv.h = oldHue || 0;
	  }
	  var transparent = hex === '000000' && rgb.a === 0;
	
	  return {
	    hsl: hsl,
	    hex: transparent ? 'transparent' : '#' + hex,
	    rgb: rgb,
	    hsv: hsv,
	    oldHue: data.h || oldHue || hsl.h,
	    source: data.source
	  };
	};
	
	var isValidHex = exports.isValidHex = function isValidHex(hex) {
	  if (hex === 'transparent') {
	    return true;
	  }
	  // disable hex4 and hex8
	  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
	  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
	};
	
	var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
	  if (!data) {
	    return '#fff';
	  }
	  var col = toState(data);
	  if (col.hex === 'transparent') {
	    return 'rgba(0,0,0,0.4)';
	  }
	  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
	  return yiq >= 128 ? '#000' : '#fff';
	};
	
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};
	
	var isvalidColorString = exports.isvalidColorString = function isvalidColorString(string, type) {
	  var stringWithoutDegree = string.replace('°', '');
	  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
	};

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2179);


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(2116),
	    baseEach = __webpack_require__(2111),
	    castFunction = __webpack_require__(2023),
	    isArray = __webpack_require__(2000);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__(2182);
	
	var _Checkboard = __webpack_require__(2152);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onHover = _ref.onHover,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	  var handleHover = function handleHover(e) {
	    return onHover(color, e);
	  };
	
	  var optionalEvents = {};
	  if (onHover) {
	    optionalEvents.onMouseOver = handleHover;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    }, optionalEvents),
	    children,
	    transparent && _react2.default.createElement(_Checkboard2.default, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */
	
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Focus, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: this.handleFocus, onBlur: this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, this.props, this.state))
	        );
	      }
	    }]);
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	var _BlockSwatches = __webpack_require__(2185);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    color.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: color.getContrastingColor(hex),
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['top', 'hide']),
	  styles: _propTypes2.default.object
	};
	
	Block.defaultProps = {
	  width: 170,
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        onHover: onSwatchHover,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(2187);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(2149);
	
	var _CircleSwatch = __webpack_require__(2188);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      circleSpacing = _ref.circleSpacing,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker ' + className },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  circleSize: _propTypes2.default.number,
	  circleSpacing: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Circle.defaultProps = {
	  width: 252,
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _ChromeFields = __webpack_require__(2190);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(2193);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(2194);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      defaultView = _ref.defaultView;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        view: defaultView,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	Chrome.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  disableAlpha: _propTypes2.default.bool,
	  styles: _propTypes2.default.object,
	  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
	};
	
	Chrome.defaultProps = {
	  width: 225,
	  disableAlpha: false,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _isUndefined = __webpack_require__(2191);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _common = __webpack_require__(2149);
	
	var _UnfoldMoreHorizontalIcon = __webpack_require__(2192);
	
	var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(_UnfoldMoreHorizontalIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields(props) {
	    _classCallCheck(this, ChromeFields);
	
	    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
	
	    _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    };
	
	    _this.handleChange = function (data, e) {
	      if (data.hex) {
	        color.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        // Remove any occurances of '%'.
	        if (typeof data.s === 'string' && data.s.includes('%')) {
	          data.s = data.s.replace('%', '');
	        }
	        if (typeof data.l === 'string' && data.l.includes('%')) {
	          data.l = data.l.replace('%', '');
	        }
	
	        // We store HSL as a unit interval so we need to override the 1 input to 0.01
	        if (data.s == 1) {
	          data.s = 0.01;
	        } else if (data.l == 1) {
	          data.l = 0.01;
	        }
	
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
	          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
	          source: 'hsl'
	        }, e);
	      }
	    };
	
	    _this.showHighlight = function (e) {
	      e.currentTarget.style.background = '#eee';
	    };
	
	    _this.hideHighlight = function (e) {
	      e.currentTarget.style.background = 'transparent';
	    };
	
	    if (props.hsl.a !== 1 && props.view === "hex") {
	      _this.state = {
	        view: "rgb"
	      };
	    } else {
	      _this.state = {
	        view: props.view
	      };
	    }
	    return _this;
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            fill: '#333',
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
	                return _this2.icon = icon;
	              } },
	            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
	              style: styles.svg,
	              onMouseOver: this.showHighlight,
	              onMouseEnter: this.showHighlight,
	              onMouseOut: this.hideHighlight
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, state) {
	      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
	        return { view: 'rgb' };
	      }
	      return null;
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	ChromeFields.defaultProps = {
	  view: "hex"
	};
	
	exports.default = ChromeFields;

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
	  );
	};

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	var _CompactColor = __webpack_require__(2196);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(2197);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { style: styles.Compact, styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker ' + className },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange,
	            onSwatchHover: onSwatchHover
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: colorUtils.getContrastingColor(color),
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _GithubSwatch = __webpack_require__(2199);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-left-triangle': {
	      triangle: {
	        top: '35px',
	        left: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        left: '9px',
	        transform: 'rotate(180deg)'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-left-triangle': triangle === 'bottom-left',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, {
	        color: c,
	        key: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	Github.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
	  styles: _propTypes2.default.object
	};
	
	Github.defaultProps = {
	  width: 200,
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px',
	        fontSize: '0'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: hoverSwatch
	    })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _HuePointer = __webpack_require__(2201);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker ' + className },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.propTypes = {
	  styles: _propTypes2.default.object
	};
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker ' + className },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _PhotoshopFields = __webpack_require__(2204);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(2205);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(2206);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(2207);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(2208);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$styles = _props.styles,
	          passedStyles = _props$styles === undefined ? {} : _props$styles,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className;
	
	      var styles = (0, _reactcss2.default)((0, _merge2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      }, passedStyles));
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker ' + className },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.propTypes = {
	  header: _propTypes2.default.string,
	  styles: _propTypes2.default.object
	};
	
	Photoshop.defaultProps = {
	  header: 'Color Picker',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        top: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      color.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopButton = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopButton;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _SketchFields = __webpack_require__(2210);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(2211);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': _extends({
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    }, passedStyles),
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, {
	      colors: presetColors,
	      onClick: onChange,
	      onSwatchHover: onSwatchHover
	    })
	  );
	};
	
	Sketch.propTypes = {
	  disableAlpha: _propTypes2.default.bool,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object
	};
	
	Sketch.defaultProps = {
	  disableAlpha: false,
	  width: 200,
	  styles: {},
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchFields = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var SketchFields = exports.SketchFields = function SketchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a /= 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = SketchFields;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      var key = '' + c.color + (c.title || '');
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })])).isRequired
	};
	
	exports.default = SketchPresetColors;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _SliderSwatches = __webpack_require__(2213);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(2215);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap || {}, className: 'slider-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.propTypes = {
	  styles: _propTypes2.default.object
	};
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(2214);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  // Acceptible difference in floating point equality
	  var epsilon = 0.1;
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(2187);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(2149);
	
	var _SwatchesGroup = __webpack_require__(2217);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    return onChange({ hex: data, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker ' + className },
	    _react2.default.createElement(
	      _common.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange,
	              onSwatchHover: onSwatchHover
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	Swatches.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
	  styles: _propTypes2.default.object
	
	  /* eslint-disable max-len */
	};Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(2218);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	var _CheckIcon = __webpack_require__(2219);
	
	var _CheckIcon2 = _interopRequireDefault(_CheckIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        color: colorUtils.getContrastingColor(color),
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        color: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        color: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(_CheckIcon2.default, null)
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	  );
	};

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(2025);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        boxSizing: 'content-box',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    color.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        label: null,
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Twitter.defaultProps = {
	  width: 276,
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Google = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(2158);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(2149);
	
	var _GooglePointerCircle = __webpack_require__(2222);
	
	var _GooglePointerCircle2 = _interopRequireDefault(_GooglePointerCircle);
	
	var _GooglePointer = __webpack_require__(2223);
	
	var _GooglePointer2 = _interopRequireDefault(_GooglePointer);
	
	var _GoogleFields = __webpack_require__(2224);
	
	var _GoogleFields2 = _interopRequireDefault(_GoogleFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Google = exports.Google = function Google(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      header = _ref.header,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        border: '1px solid #dfe1e5',
	        boxSizing: 'initial',
	        display: 'flex',
	        flexWrap: 'wrap',
	        borderRadius: '8px 8px 0px 0px'
	      },
	      head: {
	        height: '57px',
	        width: '100%',
	        paddingTop: '16px',
	        paddingBottom: '16px',
	        paddingLeft: '16px',
	        fontSize: '20px',
	        boxSizing: 'border-box',
	        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
	      },
	      saturation: {
	        width: '70%',
	        padding: '0px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      swatch: {
	        width: '30%',
	        height: '228px',
	        padding: '0px',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      body: {
	        margin: 'auto',
	        width: '95%'
	      },
	      controls: {
	        display: 'flex',
	        boxSizing: 'border-box',
	        height: '52px',
	        paddingTop: '22px'
	      },
	      color: {
	        width: '32px'
	      },
	      hue: {
	        height: '8px',
	        position: 'relative',
	        margin: '0px 16px 0px 16px',
	        width: '100%'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'google-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      header
	    ),
	    _react2.default.createElement('div', { style: styles.swatch }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _GooglePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            radius: '4px',
	            pointer: _GooglePointer2.default,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(_GoogleFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        hsv: hsv,
	        onChange: onChange
	      })
	    )
	  );
	};
	
	Google.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object,
	  header: _propTypes2.default.string
	
	};
	
	Google.defaultProps = {
	  width: 652,
	  styles: {},
	  header: 'Color picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Google);

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointerCircle = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointerCircle = exports.GooglePointerCircle = function GooglePointerCircle(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        border: '2px #fff solid',
	        transform: 'translate(-12px, -13px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointerCircle.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointerCircle.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointerCircle;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointer = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointer = exports.GooglePointer = function GooglePointer(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        transform: 'translate(-10px, -7px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
	        border: '2px white solid'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointer.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointer.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointer;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoogleFields = undefined;
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1997);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(2177);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(2149);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleFields = exports.GoogleFields = function GoogleFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      hsv = _ref.hsv;
	
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.rgb) {
	      var values = data.rgb.split(',');
	      color.isvalidColorString(data.rgb, 'rgb') && onChange({
	        r: values[0],
	        g: values[1],
	        b: values[2],
	        a: 1,
	        source: 'rgb'
	      }, e);
	    } else if (data.hsv) {
	      var _values = data.hsv.split(',');
	      if (color.isvalidColorString(data.hsv, 'hsv')) {
	        _values[2] = _values[2].replace('%', '');
	        _values[1] = _values[1].replace('%', '');
	        _values[0] = _values[0].replace('°', '');
	        if (_values[1] == 1) {
	          _values[1] = 0.01;
	        } else if (_values[2] == 1) {
	          _values[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values[0]),
	          s: Number(_values[1]),
	          v: Number(_values[2]),
	          source: 'hsv'
	        }, e);
	      }
	    } else if (data.hsl) {
	      var _values2 = data.hsl.split(',');
	      if (color.isvalidColorString(data.hsl, 'hsl')) {
	        _values2[2] = _values2[2].replace('%', '');
	        _values2[1] = _values2[1].replace('%', '');
	        _values2[0] = _values2[0].replace('°', '');
	        if (hsvValue[1] == 1) {
	          hsvValue[1] = 0.01;
	        } else if (hsvValue[2] == 1) {
	          hsvValue[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values2[0]),
	          s: Number(_values2[1]),
	          v: Number(_values2[2]),
	          source: 'hsl'
	        }, e);
	      }
	    }
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      wrap: {
	        display: 'flex',
	        height: '100px',
	        marginTop: '4px'
	      },
	      fields: {
	        width: '100%'
	      },
	      column: {
	        paddingTop: '10px',
	        display: 'flex',
	        justifyContent: 'space-between'
	      },
	      double: {
	        padding: '0px 4.4px',
	        boxSizing: 'border-box'
	      },
	      input: {
	        width: '100%',
	        height: '38px',
	        boxSizing: 'border-box',
	        padding: '4px 10% 3px',
	        textAlign: 'center',
	        border: '1px solid #dadce0',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      input2: {
	        height: '38px',
	        width: '100%',
	        border: '1px solid #dadce0',
	        boxSizing: 'border-box',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        paddingLeft: '10px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label: {
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '35px',
	        top: '-6px',
	        left: '0',
	        right: '0',
	        marginLeft: 'auto',
	        marginRight: 'auto',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label2: {
	        left: '10px',
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '32px',
	        top: '-6px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      single: {
	        flexGrow: '1',
	        margin: '0px 4.4px'
	      }
	    }
	  });
	
	  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
	  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
	  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.fields },
	      _react2.default.createElement(
	        'div',
	        { style: styles.double },
	        _react2.default.createElement(_common.EditableInput, {
	          style: { input: styles.input, label: styles.label },
	          label: 'hex',
	          value: hex,
	          onChange: handleChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.column },
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'rgb',
	            value: rgbValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsv',
	            value: hsvValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsl',
	            value: hslValue,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = GoogleFields;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	__webpack_require__(2226);
	
	var geoViewport = __webpack_require__(2228);
	
	var SteerPathMap = function SteerPathMap(props) {
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var dispatch = props.dispatch;
	    var mapApiKey = props.mapApiKey;
	    var liveApiKey = props.liveApiKey;
	    var mapConfig = props.mapConfig;
	    var mapConfigMode = props.mapConfigMode;
	    var slideCurrentIndex = props.slideCurrentIndex;
	
	    var styleFile = mapConfig.use3dMap ? "default.json" : "default_simplified.json";
	    var mapboxMap = (0, _react.useRef)(null);
	    var steerpathMap = (0, _react.useRef)(null);
	    var steerpathLive = (0, _react.useRef)(null);
	    var center = mapConfig.center;
	    var zoom = mapConfig.zoom;
	    var bearing = mapConfig.bearing;
	    var pitch = mapConfig.pitch;
	    var hash = mapConfig.hash;
	    var attributionControl = mapConfig.attributionControl;
	    var bearingSnap = mapConfig.bearingSnap;
	    var buildingRef = mapConfig.buildingRef;
	    var layerIndex = mapConfig.layerIndex;
	
	    // Map initialise
	    (0, _react.useEffect)(function () {
	        // check mapConfigMode, No need to reload the map when dragend or zoomend event changes
	        if (mapApiKey && mapConfigMode === "user_input") {
	            console.log("initialise Map");
	            var styleUrl = "https://mapdata.eu.steerpath.com/style/" + styleFile + "?access_token=" + mapApiKey;
	            mapboxMap.current = new mapboxgl.Map({
	                container: 'mapboxMap',
	                style: styleUrl,
	                center: center, // [24.8123896, 60.2209478],
	                zoom: zoom,
	                bearing: bearing,
	                pitch: pitch,
	                hash: hash,
	                attributionControl: attributionControl,
	                bearingSnap: bearingSnap
	            });
	            if (mapboxMap.current) {
	                steerpathMap.current = new steerpath.SteerpathMap(mapboxMap.current, mapApiKey); //create instance of SteerpathMap
	                steerpathMap.current.setBuildingDefaultLayerIndex(buildingRef, layerIndex);
	                var floorSwitcher = new steerpath.FloorSwitcherControl(steerpathMap.current);
	                mapboxMap.current.addControl(floorSwitcher, 'bottom-left');
	                mapboxMap.current.on("load", function () {
	                    addLive(); //once map is loaded init the live service
	                });
	                mapboxMap.current.on("moveend", function () {
	                    console.log("moveend e ");
	                    storeLatestMapView();
	                });
	                mapboxMap.current.on("steerpathLayerIndexChanged", function () {
	                    console.log("start steerpathLayerIndexChanged e ");
	                    storeLatestLayerIndexChanged();
	                });
	            }
	        }
	    }, [addLive, attributionControl, bearing, bearingSnap, buildingRef, center, hash, mapApiKey, mapConfigMode, layerIndex, pitch, zoom, storeLatestMapView, slideCurrentIndex, storeLatestLayerIndexChanged, styleFile]);
	    // CLEAN UP
	    // when slideCurrentIndex and mapApiKey changes, remove steerpathMap instance as well as steerpathMap and steerpathLive
	    (0, _react.useEffect)(function () {
	        return function () {
	            if (mapboxMap.current) {
	                console.log("remove moveend ");
	                mapboxMap.current.off("moveend");
	                console.log("remove steerpathLayerIndexChanged ");
	                mapboxMap.current.off("steerpathLayerIndexChanged");
	
	                console.log("steerpathLive stop live, empty steerpathMap instance, remove mapboxMap ");
	                steerpathLive.current && steerpathLive.current.stopLive();
	                mapboxMap.current && mapboxMap.current.remove();
	                steerpathMap.current = null;
	            }
	        };
	    }, [mapApiKey, slideCurrentIndex]);
	
	    // getBounds when user_input mode is on
	    (0, _react.useEffect)(function () {
	        if (mapConfigMode === "user_input") {
	            var _mapboxMap$current$getCenter = mapboxMap.current.getCenter();
	
	            var lat = _mapboxMap$current$getCenter.lat;
	            var lng = _mapboxMap$current$getCenter.lng;
	
	            // get bounds based on geoViewport
	
	            var _mapboxMap$current$getCanvas$getBoundingClientRect = mapboxMap.current.getCanvas().getBoundingClientRect();
	
	            var width = _mapboxMap$current$getCanvas$getBoundingClientRect.width;
	            var height = _mapboxMap$current$getCanvas$getBoundingClientRect.height;
	
	            var boundsArr = geoViewport.bounds([lng, lat], mapboxMap.current.getZoom(), [width, height], 512);
	            var bounds = [[boundsArr[0], boundsArr[1]], [boundsArr[2], boundsArr[3]]];
	            var obj = {
	                bounds: bounds
	            };
	            setLivefeedOptionsHandle("mapConfig", obj);
	        }
	    }, [mapConfig.center, mapConfig.zoom, mapConfigMode, setLivefeedOptionsHandle]);
	
	    // storeLatestMapView when map_interact mode is on
	    var storeLatestMapView = (0, _react.useCallback)(function () {
	        var _mapboxMap$current$getCenter2 = mapboxMap.current.getCenter();
	
	        var lat = _mapboxMap$current$getCenter2.lat;
	        var lng = _mapboxMap$current$getCenter2.lng;
	
	        // get bounds based on geoViewport
	
	        var _mapboxMap$current$getCanvas$getBoundingClientRect2 = mapboxMap.current.getCanvas().getBoundingClientRect();
	
	        var width = _mapboxMap$current$getCanvas$getBoundingClientRect2.width;
	        var height = _mapboxMap$current$getCanvas$getBoundingClientRect2.height;
	
	        var boundsArr = geoViewport.bounds([lng, lat], mapboxMap.current.getZoom(), [width, height], 512);
	        var bounds = [[boundsArr[0], boundsArr[1]], [boundsArr[2], boundsArr[3]]];
	        var obj = {
	            zoom: mapboxMap.current.getZoom().toFixed(4),
	            center: [lng.toFixed(7), lat.toFixed(7)],
	            bearing: mapboxMap.current.getBearing().toFixed(4),
	            pitch: mapboxMap.current.getPitch().toFixed(4),
	            bounds: bounds
	        };
	        setLivefeedOptionsHandle("mapConfig", obj);
	        if (mapConfigMode === "user_input") {
	            var _mapConfigMode = "map_interact";
	            dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)(_mapConfigMode));
	        }
	    }, [dispatch, mapConfigMode, setLivefeedOptionsHandle]);
	
	    var storeLatestLayerIndexChanged = (0, _react.useCallback)(function () {
	        var latestLayerIndex = steerpathMap.current.getActiveBuildingLayerIndex();
	        var latestBuildingRef = steerpathMap.current.getActiveBuildingBuildingRef();
	        var obj = {
	            buildingRef: latestBuildingRef,
	            layerIndex: latestLayerIndex
	        };
	        setLivefeedOptionsHandle("mapConfig", obj);
	        if (mapConfigMode === "user_input") {
	            var _mapConfigMode2 = "map_interact";
	            dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)(_mapConfigMode2));
	        }
	    }, [dispatch, mapConfigMode, setLivefeedOptionsHandle]);
	
	    var addLive = (0, _react.useCallback)(function () {
	        if (mapApiKey) {
	            //console.log("addLive")
	            var liveUrls = {
	                "defaultUrl": "https://live-eu3.steerpath.com/sdk-data"
	            };
	            if (liveApiKey) {
	                var liveOptions = {
	                    "apiKey": liveApiKey,
	                    "interval": 2000, //milliseconds
	                    "liveDataTitles": {},
	                    "liveUrl": liveUrls.defaultUrl
	                };
	                steerpathLive.current = new steerpath.SteerpathLive(mapboxMap.current, liveOptions);
	            }
	        }
	    }, [liveApiKey, mapApiKey]);
	
	    return _react2['default'].createElement(
	        'div',
	        { id: 'mapboxMap' },
	        _react2['default'].createElement(
	            'div',
	            { id: 'attribution' },
	            _react2['default'].createElement(
	                'a',
	                { href: 'https://www.steerpath.com/', target: '_blank', rel: 'noopener noreferrer' },
	                '© Steerpath '
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: 'https://www.maptiler.com/copyright/', target: '_blank', rel: 'noopener noreferrer' },
	                '© MapTiler'
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: 'https://www.openstreetmap.org/copyright', target: '_blank', rel: 'noopener noreferrer' },
	                '© OpenStreetMap contributors'
	            )
	        )
	    );
	};
	
	exports['default'] = SteerPathMap;
	module.exports = exports['default'];

/***/ }),
/* 2226 */
[2372, 2227],
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, "#mapboxMap{position:absolute;width:100%;height:100%}#attribution{position:absolute;bottom:0;right:0;z-index:2;padding-right:50px;padding-left:10px;border-radius:20px;background-color:hsla(0,0%,100%,.5);margin:0}", ""]);
	
	// exports


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	var SphericalMercator = __webpack_require__(2229);
	
	// The SphericalMercator library only accepts a variable
	// tileSize on instantiation, which it uses to pre-cache
	// calculations by zoom level.
	// We cache each instantiation, keyed by tile size, to avoid
	// repeating this cost when working with a single tile size
	// (assumed to be the most-common use case).
	var smCache = {};
	
	module.exports.viewport = viewport;
	module.exports.bounds = bounds;
	
	function fetchMerc(tileSize) {
	    tileSize = tileSize || 256;
	
	    if (!smCache[tileSize]) {
	        smCache[tileSize] = new SphericalMercator({ size: tileSize });
	    }
	
	    return smCache[tileSize];
	}
	
	function getAdjusted(base, ratios, allowFloat) {
	    var adjusted = Math.min(
	            base - (Math.log(ratios[0]) / Math.log(2)),
	            base - (Math.log(ratios[1]) / Math.log(2)));
	    
	    return allowFloat ? adjusted : Math.floor(adjusted);
	}
	
	function viewport(bounds, dimensions, minzoom, maxzoom, tileSize, allowFloat) {
	    minzoom = (minzoom === undefined) ? 0 : minzoom;
	    maxzoom = (maxzoom === undefined) ? 20 : maxzoom;
	    var merc = fetchMerc(tileSize);
	    var base = maxzoom,
	        bl = merc.px([bounds[0], bounds[1]], base),
	        tr = merc.px([bounds[2], bounds[3]], base),
	        width = tr[0] - bl[0],
	        height = bl[1] - tr[1],
	        ratios = [width / dimensions[0], height / dimensions[1]],
	        center = [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2],
	        adjusted = getAdjusted(base, ratios, allowFloat),
	        zoom = Math.max(minzoom, Math.min(maxzoom, adjusted));
	
	    return { center: center, zoom: zoom };
	}
	
	function bounds(viewport, zoom, dimensions, tileSize) {
	    if (viewport.lon !== undefined) {
	        viewport = [
	            viewport.lon,
	            viewport.lat
	        ];
	    }
	
	    var merc = fetchMerc(tileSize);
	    var px = merc.px(viewport, zoom);
	    var tl = merc.ll([
	        px[0] - (dimensions[0] / 2),
	        px[1] - (dimensions[1] / 2)
	    ], zoom);
	    var br = merc.ll([
	        px[0] + (dimensions[0] / 2),
	        px[1] + (dimensions[1] / 2)
	    ], zoom);
	    return [tl[0], br[1], br[0], tl[1]];
	}


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	var SphericalMercator = (function(){
	
	// Closures including constants and other precalculated values.
	var cache = {},
	    EPSLN = 1.0e-10,
	    D2R = Math.PI / 180,
	    R2D = 180 / Math.PI,
	    // 900913 properties.
	    A = 6378137.0,
	    MAXEXTENT = 20037508.342789244;
	
	function isFloat(n){
	    return Number(n) === n && n % 1 !== 0;
	}
	
	// SphericalMercator constructor: precaches calculations
	// for fast tile lookups.
	function SphericalMercator(options) {
	    options = options || {};
	    this.size = options.size || 256;
	    if (!cache[this.size]) {
	        var size = this.size;
	        var c = cache[this.size] = {};
	        c.Bc = [];
	        c.Cc = [];
	        c.zc = [];
	        c.Ac = [];
	        for (var d = 0; d < 30; d++) {
	            c.Bc.push(size / 360);
	            c.Cc.push(size / (2 * Math.PI));
	            c.zc.push(size / 2);
	            c.Ac.push(size);
	            size *= 2;
	        }
	    }
	    this.Bc = cache[this.size].Bc;
	    this.Cc = cache[this.size].Cc;
	    this.zc = cache[this.size].zc;
	    this.Ac = cache[this.size].Ac;
	};
	
	// Convert lon lat to screen pixel value
	//
	// - `ll` {Array} `[lon, lat]` array of geographic coordinates.
	// - `zoom` {Number} zoom level.
	SphericalMercator.prototype.px = function(ll, zoom) {
	  if (isFloat(zoom)) {
	    var size = this.size * Math.pow(2, zoom);
	    var d = size / 2;
	    var bc = (size / 360);
	    var cc = (size / (2 * Math.PI));
	    var ac = size;
	    var f = Math.min(Math.max(Math.sin(D2R * ll[1]), -0.9999), 0.9999);
	    var x = d + ll[0] * bc;
	    var y = d + 0.5 * Math.log((1 + f) / (1 - f)) * -cc;
	    (x > ac) && (x = ac);
	    (y > ac) && (y = ac);
	    //(x < 0) && (x = 0);
	    //(y < 0) && (y = 0);
	    return [x, y];
	  } else {
	    var d = this.zc[zoom];
	    var f = Math.min(Math.max(Math.sin(D2R * ll[1]), -0.9999), 0.9999);
	    var x = Math.round(d + ll[0] * this.Bc[zoom]);
	    var y = Math.round(d + 0.5 * Math.log((1 + f) / (1 - f)) * (-this.Cc[zoom]));
	    (x > this.Ac[zoom]) && (x = this.Ac[zoom]);
	    (y > this.Ac[zoom]) && (y = this.Ac[zoom]);
	    //(x < 0) && (x = 0);
	    //(y < 0) && (y = 0);
	    return [x, y];
	  }
	};
	
	// Convert screen pixel value to lon lat
	//
	// - `px` {Array} `[x, y]` array of geographic coordinates.
	// - `zoom` {Number} zoom level.
	SphericalMercator.prototype.ll = function(px, zoom) {
	  if (isFloat(zoom)) {
	    var size = this.size * Math.pow(2, zoom);
	    var bc = (size / 360);
	    var cc = (size / (2 * Math.PI));
	    var zc = size / 2;
	    var g = (px[1] - zc) / -cc;
	    var lon = (px[0] - zc) / bc;
	    var lat = R2D * (2 * Math.atan(Math.exp(g)) - 0.5 * Math.PI);
	    return [lon, lat];
	  } else {
	    var g = (px[1] - this.zc[zoom]) / (-this.Cc[zoom]);
	    var lon = (px[0] - this.zc[zoom]) / this.Bc[zoom];
	    var lat = R2D * (2 * Math.atan(Math.exp(g)) - 0.5 * Math.PI);
	    return [lon, lat];
	  }
	};
	
	// Convert tile xyz value to bbox of the form `[w, s, e, n]`
	//
	// - `x` {Number} x (longitude) number.
	// - `y` {Number} y (latitude) number.
	// - `zoom` {Number} zoom.
	// - `tms_style` {Boolean} whether to compute using tms-style.
	// - `srs` {String} projection for resulting bbox (WGS84|900913).
	// - `return` {Array} bbox array of values in form `[w, s, e, n]`.
	SphericalMercator.prototype.bbox = function(x, y, zoom, tms_style, srs) {
	    // Convert xyz into bbox with srs WGS84
	    if (tms_style) {
	        y = (Math.pow(2, zoom) - 1) - y;
	    }
	    // Use +y to make sure it's a number to avoid inadvertent concatenation.
	    var ll = [x * this.size, (+y + 1) * this.size]; // lower left
	    // Use +x to make sure it's a number to avoid inadvertent concatenation.
	    var ur = [(+x + 1) * this.size, y * this.size]; // upper right
	    var bbox = this.ll(ll, zoom).concat(this.ll(ur, zoom));
	
	    // If web mercator requested reproject to 900913.
	    if (srs === '900913') {
	        return this.convert(bbox, '900913');
	    } else {
	        return bbox;
	    }
	};
	
	// Convert bbox to xyx bounds
	//
	// - `bbox` {Number} bbox in the form `[w, s, e, n]`.
	// - `zoom` {Number} zoom.
	// - `tms_style` {Boolean} whether to compute using tms-style.
	// - `srs` {String} projection of input bbox (WGS84|900913).
	// - `@return` {Object} XYZ bounds containing minX, maxX, minY, maxY properties.
	SphericalMercator.prototype.xyz = function(bbox, zoom, tms_style, srs) {
	    // If web mercator provided reproject to WGS84.
	    if (srs === '900913') {
	        bbox = this.convert(bbox, 'WGS84');
	    }
	
	    var ll = [bbox[0], bbox[1]]; // lower left
	    var ur = [bbox[2], bbox[3]]; // upper right
	    var px_ll = this.px(ll, zoom);
	    var px_ur = this.px(ur, zoom);
	    // Y = 0 for XYZ is the top hence minY uses px_ur[1].
	    var x = [ Math.floor(px_ll[0] / this.size), Math.floor((px_ur[0] - 1) / this.size) ];
	    var y = [ Math.floor(px_ur[1] / this.size), Math.floor((px_ll[1] - 1) / this.size) ];
	    var bounds = {
	        minX: Math.min.apply(Math, x) < 0 ? 0 : Math.min.apply(Math, x),
	        minY: Math.min.apply(Math, y) < 0 ? 0 : Math.min.apply(Math, y),
	        maxX: Math.max.apply(Math, x),
	        maxY: Math.max.apply(Math, y)
	    };
	    if (tms_style) {
	        var tms = {
	            minY: (Math.pow(2, zoom) - 1) - bounds.maxY,
	            maxY: (Math.pow(2, zoom) - 1) - bounds.minY
	        };
	        bounds.minY = tms.minY;
	        bounds.maxY = tms.maxY;
	    }
	    return bounds;
	};
	
	// Convert projection of given bbox.
	//
	// - `bbox` {Number} bbox in the form `[w, s, e, n]`.
	// - `to` {String} projection of output bbox (WGS84|900913). Input bbox
	//   assumed to be the "other" projection.
	// - `@return` {Object} bbox with reprojected coordinates.
	SphericalMercator.prototype.convert = function(bbox, to) {
	    if (to === '900913') {
	        return this.forward(bbox.slice(0, 2)).concat(this.forward(bbox.slice(2,4)));
	    } else {
	        return this.inverse(bbox.slice(0, 2)).concat(this.inverse(bbox.slice(2,4)));
	    }
	};
	
	// Convert lon/lat values to 900913 x/y.
	SphericalMercator.prototype.forward = function(ll) {
	    var xy = [
	        A * ll[0] * D2R,
	        A * Math.log(Math.tan((Math.PI*0.25) + (0.5 * ll[1] * D2R)))
	    ];
	    // if xy value is beyond maxextent (e.g. poles), return maxextent.
	    (xy[0] > MAXEXTENT) && (xy[0] = MAXEXTENT);
	    (xy[0] < -MAXEXTENT) && (xy[0] = -MAXEXTENT);
	    (xy[1] > MAXEXTENT) && (xy[1] = MAXEXTENT);
	    (xy[1] < -MAXEXTENT) && (xy[1] = -MAXEXTENT);
	    return xy;
	};
	
	// Convert 900913 x/y values to lon/lat.
	SphericalMercator.prototype.inverse = function(xy) {
	    return [
	        (xy[0] * R2D / A),
	        ((Math.PI*0.5) - 2.0 * Math.atan(Math.exp(-xy[1] / A))) * R2D
	    ];
	};
	
	return SphericalMercator;
	
	})();
	
	if (true) {
	    module.exports = exports = SphericalMercator;
	}


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2231);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./summary.less", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./summary.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".summary-location{display:inline-block;top:50%;left:50%;transform:translate(-50%,-50%);font-size:24px;position:absolute;z-index:5;text-align:center;width:80%;margin:auto;white-space:normal;cursor:pointer;color:#fff;background-color:rgba(0,0,0,.5)}.summary-location:hover{color:#3cb449}", ""]);
	
	// exports


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker = __webpack_require__(1992);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonGauge = __webpack_require__(1987);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonGauge2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonGauge);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsCommonUtils = __webpack_require__(444);
	
	var RightPanel = function RightPanel(_ref) {
	    var scaleMode = _ref.scaleMode;
	    var dispatch = _ref.dispatch;
	    var livefeedSlide = _ref.livefeedSlide;
	    var editorView = _ref.editorView;
	    var stepNumberState = _ref.stepNumberState;
	    var nodeMap = _ref.nodeMap;
	    var sensorMap = _ref.sensorMap;
	    var handleOpenLocationModal = _ref.handleOpenLocationModal;
	
	    function renderView() {
	        var fontFamily = livefeedSlide.fontFamily;
	        var historyEntities = livefeedSlide.historyEntities;
	        var rightPanelTextTitle = livefeedSlide.rightPanelTextTitle;
	        var rightPanelBg = livefeedSlide.rightPanelBg;
	        var rightPanelGaugeValueLabel = livefeedSlide.rightPanelGaugeValueLabel;
	        var rightPanelGaugeOccupiedBg = livefeedSlide.rightPanelGaugeOccupiedBg;
	        var rightPanelGaugeOffsetdBg = livefeedSlide.rightPanelGaugeOffsetdBg;
	        var rightPanelGaugeNeedle = livefeedSlide.rightPanelGaugeNeedle;
	        var _livefeedSlide$floorplanOptions = livefeedSlide.floorplanOptions;
	        var locationsID = _livefeedSlide$floorplanOptions.locationsID;
	        var widgetLabelType = _livefeedSlide$floorplanOptions.widgetLabelType;
	        var isStandbyAsUnOccupied = _livefeedSlide$floorplanOptions.isStandbyAsUnOccupied;
	
	        var history = historyEntities.slice();
	        var currentEntity = history[stepNumberState];
	        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	        var refinedLocationsID = locationsID.filter(function (id) {
	            return nodeMap[id];
	        });
	        var setCurrentEntitySwitch = function setCurrentEntitySwitch(e, entity) {
	            e.preventDefault();
	            e.stopPropagation();
	            (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, entity, dispatch);
	        };
	        return _react2['default'].createElement(RightPanelView, {
	            handleOpenLocationModal: handleOpenLocationModal,
	            setCurrentEntitySwitch: function (e, entity) {
	                return setCurrentEntitySwitch(e, entity);
	            },
	            fontFamily: fontFamily,
	            currentEntity: currentEntity,
	            editorView: editorView,
	            rightPanelBg: rightPanelBg,
	            rightPanelTextTitle: rightPanelTextTitle,
	            rightPanelGaugeOccupiedBg: rightPanelGaugeOccupiedBg,
	            rightPanelGaugeOffsetdBg: rightPanelGaugeOffsetdBg,
	            rightPanelGaugeNeedle: rightPanelGaugeNeedle,
	            rightPanelGaugeValueLabel: rightPanelGaugeValueLabel,
	            widgetLabelType: widgetLabelType,
	            isStandbyAsUnOccupied: isStandbyAsUnOccupied,
	            locationsID: refinedLocationsID,
	            nodeMap: nodeMap,
	            sensorMap: sensorMap,
	            dispatch: dispatch,
	            scaleMode: scaleMode
	        });
	    }
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        livefeedSlide.slideType !== "summary" && livefeedSlide.slideType !== "locationsList" && renderView()
	    );
	};
	exports['default'] = RightPanel;
	
	var RightPanelView = function RightPanelView(props) {
	    var scaleMode = props.scaleMode;
	    var dispatch = props.dispatch;
	    var nodeMap = props.nodeMap;
	    var locationsID = props.locationsID;
	    var sensorMap = props.sensorMap;
	    var widgetLabelType = props.widgetLabelType;
	    var setCurrentEntitySwitch = props.setCurrentEntitySwitch;
	    var currentEntity = props.currentEntity;
	    var editorView = props.editorView;
	    var rightPanelTextTitle = props.rightPanelTextTitle;
	    var rightPanelBg = props.rightPanelBg;
	    var rightPanelGaugeValueLabel = props.rightPanelGaugeValueLabel;
	    var isStandbyAsUnOccupied = props.isStandbyAsUnOccupied;
	    var rightPanelGaugeOccupiedBg = props.rightPanelGaugeOccupiedBg;
	    var rightPanelGaugeOffsetdBg = props.rightPanelGaugeOffsetdBg;
	    var rightPanelGaugeNeedle = props.rightPanelGaugeNeedle;
	    var fontFamily = props.fontFamily;
	    var handleOpenLocationModal = props.handleOpenLocationModal;
	
	    var colorPickerRef = (0, _react.useRef)(null);
	
	    var isAllAreas = false;var isMR = false;var isOA = false; // isMeetingRooms// isOpenAreas
	    var stats = [];
	    var i = 0;
	    if (locationsID) {
	        while (i < locationsID.length) {
	            if (locationsID[i] !== undefined) {
	                var node = nodeMap[locationsID[i]];
	                switch (node.type) {
	                    case "meeting_room":
	                        isMR = true;
	                        stats.push((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getStats)(node, sensorMap, isStandbyAsUnOccupied));
	                        i++;
	                        break;
	                    case "open_area":
	                        isOA = true;
	                        stats.push((0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.getStats)(node, sensorMap, isStandbyAsUnOccupied));
	                        i++;
	                        break;
	                    default:
	                        i++;
	                }
	            }
	            if (isOA && isMR) {
	                isAllAreas = true;
	            }
	        }
	    }
	    var sumMr = 0;var sumOARooms = 0;var sumSensors = 0;
	    var sumInUsedDesks = 0;var sumInUsedMr = 0;var sumInUsedOA = 0;
	    for (var _i = 0, n = stats.length; _i < n; _i++) {
	        var _stats$_i = stats[_i];
	        var allSensors = _stats$_i.allSensors;
	        var allDesksInUse = _stats$_i.allDesksInUse;
	        var meetingRooms = _stats$_i.meetingRooms;
	        var meetingRoomsInuse = _stats$_i.meetingRoomsInuse;
	        var openAreaRooms = _stats$_i.openAreaRooms;
	        var openAreaRoomsInUse = _stats$_i.openAreaRoomsInUse;
	
	        sumMr += meetingRooms;
	        sumSensors += allSensors;
	        sumOARooms += openAreaRooms;
	        sumInUsedDesks += allDesksInUse;
	        sumInUsedMr += meetingRoomsInuse;
	        sumInUsedOA += openAreaRoomsInUse;
	    }
	
	    var roomsValues = [50, 100];
	    var totalMeetingRooms = null;
	    if (stats.length > 0) {
	        if (isMR) {
	            totalMeetingRooms = sumMr;
	            roomsValues = [sumMr - sumInUsedMr, sumMr];
	        }
	        if (isOA) {
	            // dont assign value to totalMeetingRooms since we only need to display
	            // the second widget for meeting_room type for now
	            roomsValues = [sumOARooms - sumInUsedOA, sumOARooms];
	        }
	        if (isAllAreas) {
	            totalMeetingRooms = sumMr;
	            roomsValues = [sumMr - sumInUsedMr, totalMeetingRooms];
	        }
	    }
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            {
	                className: 'pane right',
	                style: {
	                    pointerEvents: '' + (editorView && !scaleMode ? 'all' : 'none'),
	                    backgroundColor: rightPanelBg.color,
	                    fontFamily: fontFamily,
	                    width: _componentsPagesLivefeedDefaultstate.livefeedStyle.rightPaneWidth + "%"
	                } },
	            _react2['default'].createElement(
	                'div',
	                { className: 'card-outer-container',
	                    style: {
	                        marginTop: 18 * (scaleMode ? 0.375 : 1),
	                        height: 'calc(100% - ' + 51.7 * (scaleMode ? 0.375 : 1) + 'px)'
	                    }
	                },
	                sumSensors ? _react2['default'].createElement(GaugeCard, {
	                    scaleMode: scaleMode,
	                    widgetLabelType: widgetLabelType,
	                    rightPanelGaugeValueLabel: rightPanelGaugeValueLabel,
	                    rightPanelTextTitle: rightPanelTextTitle,
	                    editorView: editorView,
	                    currentEntity: currentEntity,
	                    setCurrentEntitySwitch: setCurrentEntitySwitch,
	                    rightPanelGaugeOccupiedBg: rightPanelGaugeOccupiedBg,
	                    colorPickerRef: colorPickerRef,
	                    rightPanelGaugeOffsetdBg: rightPanelGaugeOffsetdBg,
	                    rightPanelGaugeNeedle: rightPanelGaugeNeedle,
	                    index: 0,
	                    values: sumSensors ? [sumSensors - sumInUsedDesks, sumSensors] : [50, 100],
	                    dispatch: dispatch
	                }) : _react2['default'].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2['default'].createElement(
	                        'p',
	                        { onClick: handleOpenLocationModal,
	                            style: {
	                                cursor: 'pointer',
	                                textAlign: 'center',
	                                width: '80%',
	                                margin: 'auto auto',
	                                color: (0, _componentsCommonUtils.isLightColor)(rightPanelBg.color) ? 'black' : 'white'
	                            }
	                        },
	                        'Please, click to choose Senzolive Location'
	                    )
	                ),
	                totalMeetingRooms ? _react2['default'].createElement(GaugeCard, {
	                    scaleMode: scaleMode,
	                    widgetLabelType: widgetLabelType,
	                    rightPanelGaugeValueLabel: rightPanelGaugeValueLabel,
	                    rightPanelTextTitle: rightPanelTextTitle,
	                    editorView: editorView,
	                    currentEntity: currentEntity,
	                    setCurrentEntitySwitch: setCurrentEntitySwitch,
	                    rightPanelGaugeOccupiedBg: rightPanelGaugeOccupiedBg,
	                    colorPickerRef: colorPickerRef,
	                    rightPanelGaugeOffsetdBg: rightPanelGaugeOffsetdBg,
	                    rightPanelGaugeNeedle: rightPanelGaugeNeedle,
	                    index: 1,
	                    values: roomsValues,
	                    dispatch: dispatch
	                }) : null
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'logo-outer-container', style: {
	                        bottom: 13.5 * (scaleMode ? 0.375 : 1)
	                    } },
	                _react2['default'].createElement('img', { style: {
	                        width: 45.83 * (scaleMode ? 0.375 : 1)
	                    }, src: 'src/assets/icons/senzolive-logo.svg', alt: 'senzolive-logo' })
	            ),
	            _react2['default'].createElement(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker2['default'], {
	                ref: colorPickerRef
	            })
	        )
	    );
	};
	var GaugeCard = function GaugeCard(props) {
	    _react2['default'].useEffect(function () {
	        _reactTooltip2['default'].rebuild(); // componentDidUpdate()
	    });
	    var scaleMode = props.scaleMode;
	    var index = props.index;
	    var dispatch = props.dispatch;
	    var values = props.values;
	    var widgetLabelType = props.widgetLabelType;
	    var rightPanelGaugeValueLabel = props.rightPanelGaugeValueLabel;
	    var rightPanelTextTitle = props.rightPanelTextTitle;
	    var editorView = props.editorView;
	    var currentEntity = props.currentEntity;
	    var setCurrentEntitySwitch = props.setCurrentEntitySwitch;
	    var rightPanelGaugeOccupiedBg = props.rightPanelGaugeOccupiedBg;
	    var colorPickerRef = props.colorPickerRef;
	    var rightPanelGaugeOffsetdBg = props.rightPanelGaugeOffsetdBg;
	    var rightPanelGaugeNeedle = props.rightPanelGaugeNeedle;
	
	    var _useState = (0, _react.useState)('');
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var rightPanelTextTitleState = _useState2[0];
	    var setGaugleTitleState = _useState2[1];
	
	    var rightPanelTextTitleRef = (0, _react.useRef)(null);
	
	    /*Fallback for old previous livefeeds */
	    var defaultTitle = rightPanelTextTitle.contents ? rightPanelTextTitle.contents[index] : index === 0 ? 'Available desks' : 'Available meeting rooms';
	
	    (0, _react.useEffect)(function () {
	        setGaugleTitleState(defaultTitle);
	    }, [defaultTitle, index, rightPanelTextTitle.contents]);
	
	    var _useState3 = (0, _react.useState)(false);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var isEditMode = _useState32[0];
	    var setisEditMode = _useState32[1];
	
	    var inputOnchange = (0, _react.useCallback)(function (e) {
	        if (isEditMode) {
	            setGaugleTitleState(e.target.value);
	        }
	    }, [isEditMode]);
	
	    var confirmEditTitle = (0, _react.useCallback)(function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        var newobjectText = (0, _immutabilityHelper2['default'])(rightPanelTextTitle, {
	            contents: _defineProperty({}, index, { $set: rightPanelTextTitleState })
	        });
	        dispatch((0, _actionsLivefeed.updateGaugleTitle)(newobjectText));
	        rightPanelTextTitleRef.current.close();
	    }, [dispatch, index, rightPanelTextTitle, rightPanelTextTitleState]);
	
	    function inputDoubleClick(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        setisEditMode(true);
	        rightPanelTextTitleRef.current.open();
	    }
	    var gaugeValueLabelAlign = undefined;
	    switch (rightPanelGaugeValueLabel.align) {
	        case "left":
	            gaugeValueLabelAlign = "flex-start";
	            break;
	        case "right":
	            gaugeValueLabelAlign = "flex-end";
	            break;
	        case "center":
	            gaugeValueLabelAlign = "center";
	            break;
	    }
	    var titleTip = 'Click and choose toolbar options to change text style <br /> Double click to edit text';
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'card-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'card-top', style: {
	                        textAlign: rightPanelTextTitle.align,
	                        padding: '0 ' + 10 * (scaleMode ? 0.375 : 1) + 'px',
	                        marginBottom: 10 * (scaleMode ? 0.375 : 1)
	                    } },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        'data-tip': titleTip,
	                        className: 'card-title',
	                        onClick: function (e) {
	                            return setCurrentEntitySwitch(e, rightPanelTextTitle);
	                        },
	                        onDoubleClick: function (e) {
	                            return inputDoubleClick(e);
	                        },
	                        style: {
	                            zIndex: 3,
	                            color: rightPanelTextTitle.color,
	                            fontSize: rightPanelTextTitle.size * (scaleMode ? 0.375 : 1),
	                            fontWeight: rightPanelTextTitle.textStyle.bold ? 'bold' : 'unset',
	                            fontStyle: rightPanelTextTitle.textStyle.italic ? 'italic' : 'unset',
	                            textDecoration: rightPanelTextTitle.textStyle.underline ? 'underline' : 'unset'
	                        } },
	                    defaultTitle,
	                    _react2['default'].createElement('span', { className: (editorView ? 'card-title__editor-border' : 'card-title__preview') + ' ' + (currentEntity.id === "rightPanelTextTitle" ? 'card-title__editor-border_active' : '') })
	                )
	            ),
	            _react2['default'].createElement(_reactTooltip2['default'], { multiline: true, place: 'top', type: 'dark', effect: 'solid' }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'card-svg',
	                    style: {
	                        justifyContent: gaugeValueLabelAlign,
	                        userSelect: 'none',
	                        width: 50 + ' % '
	                    } },
	                _react2['default'].createElement(
	                    'div',
	                    { style: { borderColor: '' + (editorView ? '' + rightPanelTextTitle.color : 'none') },
	                        className: 'card-svg__editor ' + (editorView ? '' : 'card-svg__preview') },
	                    editorView && _react2['default'].createElement(
	                        _react2['default'].Fragment,
	                        null,
	                        _react2['default'].createElement('div', { className: 'rect rect_occupied ' + (currentEntity.id === "rightPanelGaugeOccupiedBg" ? 'rect_occupied_active' : ''),
	                            'data-tip': 'Click to change gauge\'s occupied color',
	                            onClick: function (e) {
	                                setCurrentEntitySwitch(e, rightPanelGaugeOccupiedBg);
	                                colorPickerRef.current.openColorPicker();
	                            }
	                        }),
	                        _react2['default'].createElement('div', { className: 'rect ' + (currentEntity.id === "rightPanelGaugeOffsetdBg" ? 'rect_active' : ''),
	                            'data-tip': 'Click to change gauge\'s offset color',
	                            onClick: function (e) {
	                                setCurrentEntitySwitch(e, rightPanelGaugeOffsetdBg);
	                                colorPickerRef.current.openColorPicker();
	                            }
	                        }),
	                        _react2['default'].createElement('div', { className: 'needle ' + (currentEntity.id === "rightPanelGaugeNeedle" ? 'needle_active' : ''),
	                            'data-tip': 'Click to change the needle\'s color',
	                            onClick: function (e) {
	                                setCurrentEntitySwitch(e, rightPanelGaugeNeedle);
	                                colorPickerRef.current.openColorPicker();
	                            }
	                        })
	                    )
	                ),
	                _react2['default'].createElement(_componentsPagesLivefeedEditorEditorContainerCommonGauge2['default'], {
	                    values: values,
	                    rightPanelGaugeOffsetdBg: rightPanelGaugeOffsetdBg,
	                    rightPanelGaugeOccupiedBg: rightPanelGaugeOccupiedBg,
	                    rightPanelGaugeNeedle: rightPanelGaugeNeedle,
	                    widgetLabelType: widgetLabelType,
	                    currentEntity: currentEntity,
	                    widgetStyle: {
	                        borderColor: '' + (editorView ? '' + rightPanelGaugeValueLabel.color : 'transparent'),
	                        color: rightPanelGaugeValueLabel.color,
	                        fontSize: rightPanelGaugeValueLabel.size,
	                        fontWeight: rightPanelGaugeValueLabel.textStyle.bold ? 'bold' : 'unset',
	                        fontStyle: rightPanelGaugeValueLabel.textStyle.italic ? 'italic' : 'unset',
	                        textDecoration: rightPanelGaugeValueLabel.textStyle.underline ? 'underline' : 'unset'
	                    },
	                    setCurrentEntitySwitch: function (e) {
	                        return setCurrentEntitySwitch(e, rightPanelGaugeValueLabel);
	                    }
	                })
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                ref: rightPanelTextTitleRef,
	                onClose: function () {
	                    return setGaugleTitleState(defaultTitle);
	                },
	                clickButton: function (e) {
	                    return confirmEditTitle(e);
	                },
	                header: 'Edit gauge chart title',
	                buttonText: 'Confirm',
	                buttonClass: 'btn-success',
	                entry: null
	            },
	            _react2['default'].createElement('input', {
	                value: rightPanelTextTitleState,
	                name: rightPanelTextTitleState,
	                onChange: function (e) {
	                    return inputOnchange(e);
	                }, type: 'text' })
	        )
	    );
	};
	module.exports = exports['default'];
	/* click able svg areas */

/***/ }),
/* 2233 */
[2374, 2234],
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".livefeed-preview__floorplan-modal .modals__content{width:400px;z-index:9999!important}.livefeed-preview__floorplan-modal .modals__content .livefeed-preview-wrapper-scaleMode{height:171.28125px;display:flex;justify-content:center;width:100%;margin:0;padding-left:0}.livefeed-preview__floorplan-modal .modals__content .livefeed-preview-wrapper-scaleMode .livefeed-preview{width:300px;height:168.75px;box-shadow:0 1.5px 4.5px .375px rgba(0,0,0,.5)}.livefeed-preview__floorplan-modal .modals__content .selected-slide{outline:none}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel{padding:10px}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-active{z-index:2!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-current{opacity:1!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-next,.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-prev{opacity:.75!important;width:0!important;height:0!important;border-top:15px solid transparent!important;border-bottom:15px solid transparent!important;transition:all .3s linear!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-next:hover,.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-prev:hover{opacity:1!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-prev{border-right:15px solid #3cb449!important;left:-15px!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-next{right:-15px!important;border-left:15px solid #3cb449!important}.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-next:before,.livefeed-preview__floorplan-modal .modals__content .floorplan-preview-carousel .slick-prev:before{display:none}", ""]);
	
	// exports


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(2236);
	
	var TemplateModal = (0, _react.forwardRef)(function (props, ref) {
	    // passedProps
	    var router = props.router;
	    var editorMode = props.editorMode;
	    var editorKey = props.editorKey;
	    var savingType = props.savingType;
	    var creatorEmail = props.creatorEmail;
	    var dispatch = props.dispatch;
	    var livefeedSlides = props.livefeedSlides;
	    var livefeedName = props.livefeedName;
	    var isCreateMode = props.isCreateMode;
	
	    var templateModal = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)([]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var templateOptions = _useState2[0];
	    var setTemplateOptions = _useState2[1];
	
	    var _useState3 = (0, _react.useState)();
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var chosenTemplate = _useState32[0];
	    var setChosenTemplate = _useState32[1];
	
	    (0, _react.useEffect)(function () {
	        var templateOptions = livefeedSlides.map(function (slide, index) {
	            return { label: (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.generateSlideName)(livefeedSlides, slide), value: index };
	        });
	        setTemplateOptions(templateOptions);
	        setChosenTemplate(templateOptions);
	    }, [livefeedSlides]);
	
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            open: function open() {
	                templateModal.current.open();
	            }
	        };
	    });
	
	    //-------------------------------------------Function create schema before submit -----------------------------------
	    var createTemplateSchema = (0, _react.useCallback)(function () {
	        var processedTemplate = [];
	        for (var i = 0; i < chosenTemplate.length; i++) {
	            processedTemplate.push(livefeedSlides[chosenTemplate[i].value]); // save only chosen index slides
	            processedTemplate = (0, _immutabilityHelper2["default"])(processedTemplate, _defineProperty({}, [i], {
	                // clear historyEntities on every slide
	                historyEntities: {
	                    $set: [{
	                        id: null
	                    }]
	                },
	                logoState: {
	                    file: { $set: null }
	                }
	            }));
	        }
	        return processedTemplate; // array of an object
	    }, [livefeedSlides, chosenTemplate]);
	
	    //------------------------------------------------------ SUBMIT TEMPLATE -------------------------
	    var submitTemplate = (0, _react.useCallback)(function () {
	        if (livefeedName) {
	            var newTemplate = {
	                name: livefeedName,
	                owner: creatorEmail,
	                data: {
	                    owner: creatorEmail,
	                    timestamp: Date.now(),
	                    containerHeight: _componentsPagesLivefeedDefaultstate.livefeedStyle.containerHeight,
	                    containerWidth: _componentsPagesLivefeedDefaultstate.livefeedStyle.containerWidth,
	                    // save chosen slide or save all
	                    livefeedSlides: createTemplateSchema() // array of an object
	                }
	            };
	            //-------------------------- create dispatch -------------------------
	            // in case editorMode is createLivefeed, but user choose to save as template
	            if (editorMode === "createTemplate" || editorMode === "createLivefeed" ||
	            // in case user edits template, but then  choose to save as a new template
	            savingType === "template") {
	                dispatch(a.createTemplate(newTemplate, function () {
	                    templateModal.current.close();
	                    router.push({
	                        pathname: "/livefeed"
	                    });
	                })); /**/
	            }
	            //-------------------------- editor dispatch (AKA update) -------------------------
	            else if (editorMode === "editTemplate" && savingType === "update") {
	                    newTemplate.key = editorKey;
	                    dispatch(a.updateTemplate(newTemplate, function () {
	                        templateModal.current.close();
	                        router.push({
	                            pathname: "/livefeed"
	                        });
	                    }));
	                }
	        }
	    }, [createTemplateSchema, creatorEmail, dispatch, editorKey, editorMode, livefeedName, router, savingType]);
	
	    var liveFeedNameChangeHandler = (0, _react.useCallback)(function (e) {
	        var name = e.target.value;
	        dispatch((0, _actionsLivefeed.setLivefeedName)(name));
	    }, [dispatch]);
	    var isTemplateSubmittable = livefeedName;
	
	    return _react2["default"].createElement(
	        _componentsCommonModal2["default"],
	        {
	            ref: templateModal,
	            clickButton: function () {
	                return isTemplateSubmittable ? submitTemplate() : null;
	            },
	            header: "" + (isCreateMode ? "Save as Template" : "Update Template"),
	            buttonText: "" + (isCreateMode ? "Save" : "Confirm"),
	            buttonClass: isTemplateSubmittable ? "btn-success" : "btn-success disabled",
	            entry: null
	        },
	        _react2["default"].createElement(
	            "div",
	            { className: "save-form" },
	            _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement(
	                    "span",
	                    { className: "input-label" },
	                    "Template name:"
	                ),
	                _react2["default"].createElement("input", {
	                    type: "text",
	                    id: "name",
	                    value: livefeedName,
	                    onChange: function (e) {
	                        liveFeedNameChangeHandler(e);
	                    },
	                    required: true
	                })
	            ),
	            _react2["default"].createElement(
	                "p",
	                null,
	                "Choose desired slides below to be saved"
	            ),
	            _react2["default"].createElement(
	                "div",
	                { "data-tooltip": "Chosen template", className: "reactSelect-dropdown-wrapper" },
	                _react2["default"].createElement(_reactSelect2["default"], {
	                    className: "reactSelect-template-layout",
	                    options: templateOptions,
	                    onChange: function (slide) {
	                        return setChosenTemplate(slide);
	                    },
	                    value: chosenTemplate,
	                    openOnClick: true,
	                    closeOnSelect: true,
	                    multi: true,
	                    removeSelected: true
	                })
	            ),
	            _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement(
	                    "span",
	                    { className: "save-note good" },
	                    "Your Template is ready to be ",
	                    isCreateMode ? "created" : "updated",
	                    ":"
	                )
	            )
	        )
	    );
	});
	
	TemplateModal.propTypes = {
	    router: _propTypes2["default"].object.isRequired,
	    editorMode: _propTypes2["default"].string,
	    editorKey: _propTypes2["default"].any,
	    savingType: _propTypes2["default"].string.isRequired,
	    creatorEmail: _propTypes2["default"].string.isRequired,
	    dispatch: _propTypes2["default"].func.isRequired,
	    livefeedSlides: _propTypes2["default"].array.isRequired,
	    livefeedName: _propTypes2["default"].string.isRequired
	};
	
	exports["default"] = TemplateModal;
	module.exports = exports["default"];

/***/ }),
/* 2236 */
[2374, 2237],
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".reactSelect-template-layout{width:270px}", ""]);
	
	// exports


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _actionsLivefeedapi = __webpack_require__(364);
	
	var a = _interopRequireWildcard(_actionsLivefeedapi);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var LivefeedModal = (0, _react.forwardRef)(function (props, ref) {
	    // passedProps
	    var livefeedSlides = props.livefeedSlides;
	    var nodeMap = props.nodeMap;
	    var creatorEmail = props.creatorEmail;
	    var editorMode = props.editorMode;
	    var savingType = props.savingType;
	    var dispatch = props.dispatch;
	    var nullLocationSlides = props.nullLocationSlides;
	    var slideShowDontHaveMapAPI = props.slideShowDontHaveMapAPI;
	    var livefeedName = props.livefeedName;
	    var isCreateMode = props.isCreateMode;
	    var router = props.router;
	    var editorKey = props.editorKey;
	
	    var livefeedModal = (0, _react.useRef)(null);
	
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            open: function open() {
	                livefeedModal.current.open();
	            }
	        };
	    });
	    //-------------------------------------------Function create schema before submit -----------------------------------
	    var createLivefeedSchema = (0, _react.useCallback)(function () {
	        // array of locations, each object in array is the locations of each slide
	        var processedLivefeedSlides = livefeedSlides.slice();
	        for (var i = 0; i < processedLivefeedSlides.length; i++) {
	            processedLivefeedSlides = (0, _immutabilityHelper2["default"])(processedLivefeedSlides, _defineProperty({}, i, {
	                // clear historyEntities on every slide
	                historyEntities: {
	                    $set: [{
	                        id: null
	                    }]
	                },
	                logoState: {
	                    file: { $set: null }
	                }
	            }));
	        }
	        return processedLivefeedSlides;
	    }, [livefeedSlides]);
	
	    //------------------------------------------------------ SUBMIT LIVEFEED -----------------------------------------
	    var submitLivefeed = (0, _react.useCallback)(function () {
	        if (livefeedName) {
	            (function () {
	                var locations = [];
	                livefeedSlides.slice().map(function (slide) {
	                    if (slide.slideType !== "locationsList") {
	                        locations = locations.concat(slide.floorplanOptions.locationsID);
	                    }
	                });
	                var refinedLocationsID = locations.filter(function (id) {
	                    return nodeMap[id];
	                });
	                var uniqueLocations = new Set(refinedLocationsID);
	                // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	
	                var locationsArr = [].concat(_toConsumableArray(uniqueLocations));
	                var locationsArrObj = [];
	                for (var i = 0, n = locationsArr.length; i < n; i++) {
	                    var node = nodeMap[locationsArr[i]];
	                    locationsArrObj.push({ locationId: locationsArr[i], locationName: node.info.name });
	                }
	                var livefeedData = {
	                    name: livefeedName,
	                    owner: creatorEmail,
	                    locations: locationsArrObj,
	                    data: {
	                        timestamp: Date.now(),
	                        containerHeight: _componentsPagesLivefeedDefaultstate.livefeedStyle.containerHeight,
	                        containerWidth: _componentsPagesLivefeedDefaultstate.livefeedStyle.containerWidth,
	                        livefeedSlides: createLivefeedSchema()
	                    }
	                };
	                //-------------------------- create dispatch -------------------------
	
	                if (editorMode === "createLivefeed" && nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0 ||
	                // in case editorMode is createTemplate, but user choose to save as livefeed
	                editorMode === "createTemplate" ||
	                // in case user edits livefeed, but then  choose to save as a new livefeed
	                savingType === "livefeed") {
	                    var subscribers = [creatorEmail];
	                    dispatch(a.createLivefeed(livefeedData, subscribers, function () {
	                        livefeedModal.current.close();
	                        router.push({
	                            pathname: "/livefeed"
	                        });
	                    }));
	                }
	                //-------------------------- editor dispatch (AKA update) -------------------------
	                else if (editorMode === "editLivefeed" && savingType === "update") {
	                        livefeedData.key = editorKey;
	                        dispatch(a.updateLivefeed(livefeedData, function () {
	                            livefeedModal.current.close();
	                            router.push({
	                                pathname: "/livefeed"
	                            });
	                        }));
	                    }
	            })();
	        }
	    }, [createLivefeedSchema, creatorEmail, dispatch, editorKey, editorMode, livefeedName, livefeedSlides, nodeMap, nullLocationSlides.length, slideShowDontHaveMapAPI.length, router, savingType]);
	
	    var liveFeedNameChangeHandler = (0, _react.useCallback)(function (e) {
	        var name = e.target.value;
	        dispatch((0, _actionsLivefeed.setLivefeedName)(name));
	    }, [dispatch]);
	    var isLivefeedSubmittable = livefeedName && nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0;
	    return _react2["default"].createElement(
	        _componentsCommonModal2["default"],
	        {
	            ref: livefeedModal,
	            clickButton: function () {
	                return isLivefeedSubmittable ? submitLivefeed() : null;
	            },
	            header: "" + (isCreateMode ? "Save as Livefeed" : "Update Livefeed"),
	            buttonText: "" + (isCreateMode ? "Save" : "Confirm"),
	            buttonClass: isLivefeedSubmittable ? "btn-success" : "btn-success disabled",
	            entry: null
	        },
	        _react2["default"].createElement(
	            "div",
	            { className: "save-form" },
	            _react2["default"].createElement(
	                "div",
	                null,
	                _react2["default"].createElement(
	                    "span",
	                    { className: "input-label" },
	                    "Livefeed Name:"
	                ),
	                _react2["default"].createElement("input", {
	                    type: "text",
	                    value: livefeedName,
	                    onChange: function (e) {
	                        liveFeedNameChangeHandler(e);
	                    },
	                    required: true
	                })
	            ),
	            _react2["default"].createElement(
	                "div",
	                null,
	                nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0 ? _react2["default"].createElement(
	                    "span",
	                    { className: "save-note good" },
	                    "Your Livefeed is ready to be ",
	                    isCreateMode ? "created" : "updated",
	                    ":"
	                ) : _react2["default"].createElement(
	                    "span",
	                    { className: "save-note bad" },
	                    "Please fulfil all the requirements before saving your Livefeed"
	                ),
	                nullLocationSlides.length === 0 ? _react2["default"].createElement(
	                    "div",
	                    { className: "save-point good" },
	                    _react2["default"].createElement(
	                        "i",
	                        { className: "material-icons" },
	                        ""
	                    ),
	                    "You slides have locations."
	                ) : _react2["default"].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "save-point bad" },
	                        _react2["default"].createElement(
	                            "i",
	                            { className: "material-icons" },
	                            ""
	                        ),
	                        "You haven't chosen Senzolive location",
	                        nullLocationSlides.length > 1 ? "s " : " ",
	                        "on the following slide."
	                    ),
	                    _react2["default"].createElement("br", null),
	                    _react2["default"].createElement(
	                        "ul",
	                        null,
	                        nullLocationSlides.map(function (slide, index) {
	                            return _react2["default"].createElement(
	                                "li",
	                                { key: index },
	                                (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.generateSlideName)(livefeedSlides, slide)
	                            );
	                        })
	                    )
	                ),
	                slideShowDontHaveMapAPI.length === 0 ? _react2["default"].createElement(
	                    "div",
	                    { className: "save-point good" },
	                    _react2["default"].createElement(
	                        "i",
	                        { className: "material-icons" },
	                        ""
	                    ),
	                    "You slides have Steerpath Map API."
	                ) : _react2["default"].createElement(
	                    _react.Fragment,
	                    null,
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "save-point bad" },
	                        _react2["default"].createElement(
	                            "i",
	                            { className: "material-icons" },
	                            ""
	                        ),
	                        "You haven't entered Steerpath Map API",
	                        slideShowDontHaveMapAPI.length > 1 ? "s " : " ",
	                        "on the following slide."
	                    ),
	                    _react2["default"].createElement("br", null),
	                    _react2["default"].createElement(
	                        "ul",
	                        null,
	                        slideShowDontHaveMapAPI.map(function (slide, index) {
	                            return _react2["default"].createElement(
	                                "li",
	                                { key: index },
	                                (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.generateSlideName)(livefeedSlides, slide)
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	LivefeedModal.propTypes = {
	    livefeedSlides: _propTypes2["default"].array.isRequired,
	    nodeMap: _propTypes2["default"].object.isRequired,
	    creatorEmail: _propTypes2["default"].string.isRequired,
	    editorMode: _propTypes2["default"].string,
	    savingType: _propTypes2["default"].string.isRequired,
	    dispatch: _propTypes2["default"].func.isRequired,
	    nullLocationSlides: _propTypes2["default"].array.isRequired,
	    slideShowDontHaveMapAPI: _propTypes2["default"].array.isRequired,
	    livefeedName: _propTypes2["default"].string.isRequired,
	    isCreateMode: _propTypes2["default"].bool.isRequired,
	    router: _propTypes2["default"].object.isRequired
	};
	
	exports["default"] = LivefeedModal;
	module.exports = exports["default"];
	/* If savingType==="livefeed" then check nullLocationSlides and slideShowDontHaveMapAPI */

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToolbarContainer = __webpack_require__(2240);
	
	var _ToolbarContainer2 = _interopRequireDefault(_ToolbarContainer);
	
	var _LivefeedPreview = __webpack_require__(1948);
	
	var _LivefeedPreview2 = _interopRequireDefault(_LivefeedPreview);
	
	var _SlidesContainer = __webpack_require__(2257);
	
	var _SlidesContainer2 = _interopRequireDefault(_SlidesContainer);
	
	var _FloorplanOptionContainer = __webpack_require__(2263);
	
	var _FloorplanOptionContainer2 = _interopRequireDefault(_FloorplanOptionContainer);
	
	var _reactRedux = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var EditorContainer = function EditorContainer(_ref) {
	    var editorMode = _ref.editorMode;
	
	    var locationOptionRef = _react2['default'].useRef(null);
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var mapConfigMode = _useSelector.mapConfigMode;
	    var stepNumberState = _useSelector.stepNumberState;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var editorView = _useSelector.editorView;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	
	    var nodeMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.nodeMap;
	    });
	    var sensorMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.nodeReducer.map;
	    });
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(_ToolbarContainer2['default'], null),
	        _react2['default'].createElement(
	            'div',
	            { className: 'livefeed-editor-main flex--center' },
	            _react2['default'].createElement(_SlidesContainer2['default'], null),
	            _react2['default'].createElement(_LivefeedPreview2['default'], {
	                scaleMode: false,
	                livefeedSlides: livefeedSlides,
	                slideCurrentIndex: slideCurrentIndex,
	                nodeMap: nodeMap,
	                stepNumberState: stepNumberState,
	                editorView: editorView,
	                sensorMap: sensorMap,
	                mapConfigMode: mapConfigMode,
	                dispatch: dispatch,
	                focusMapApiInput: function (e) {
	                    e.stopPropagation();locationOptionRef.current.focusMapApiInput();
	                },
	                handleOpenLocationModal: function (e) {
	                    e.stopPropagation();locationOptionRef.current.openLocationsModal();
	                }
	            }),
	            _react2['default'].createElement(_FloorplanOptionContainer2['default'], {
	                editorMode: editorMode,
	                ref: locationOptionRef
	            })
	        )
	    );
	};
	EditorContainer.propTypes = {
	    editorMode: _propTypes2['default'].string.isRequired
	};
	
	exports['default'] = EditorContainer;
	module.exports = exports['default'];

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _ToolbarOptionsEditorToggleButton = __webpack_require__(2241);
	
	var _ToolbarOptionsEditorToggleButton2 = _interopRequireDefault(_ToolbarOptionsEditorToggleButton);
	
	var _ToolbarOptionsAlignButton = __webpack_require__(2245);
	
	var _ToolbarOptionsAlignButton2 = _interopRequireDefault(_ToolbarOptionsAlignButton);
	
	var _ToolbarOptionsReUnDoButton = __webpack_require__(2246);
	
	var _ToolbarOptionsReUnDoButton2 = _interopRequireDefault(_ToolbarOptionsReUnDoButton);
	
	var _ToolbarOptionsDeleteOptionButton = __webpack_require__(2247);
	
	var _ToolbarOptionsDeleteOptionButton2 = _interopRequireDefault(_ToolbarOptionsDeleteOptionButton);
	
	var _ToolbarOptionsAddEntityButton = __webpack_require__(2248);
	
	var _ToolbarOptionsAddEntityButton2 = _interopRequireDefault(_ToolbarOptionsAddEntityButton);
	
	var _ToolbarOptionsFontSizeDropdown = __webpack_require__(2249);
	
	var _ToolbarOptionsFontSizeDropdown2 = _interopRequireDefault(_ToolbarOptionsFontSizeDropdown);
	
	var _ToolbarOptionsFontFamilyDropdown = __webpack_require__(2250);
	
	var _ToolbarOptionsFontFamilyDropdown2 = _interopRequireDefault(_ToolbarOptionsFontFamilyDropdown);
	
	var _ToolbarOptionsFormatColor = __webpack_require__(2252);
	
	var _ToolbarOptionsFormatColor2 = _interopRequireDefault(_ToolbarOptionsFormatColor);
	
	var _ToolbarOptionsTextOption = __webpack_require__(2253);
	
	var _ToolbarOptionsTextOption2 = _interopRequireDefault(_ToolbarOptionsTextOption);
	
	var _ToolbarOptionsBgColorOption = __webpack_require__(2254);
	
	var _ToolbarOptionsBgColorOption2 = _interopRequireDefault(_ToolbarOptionsBgColorOption);
	
	__webpack_require__(2255);
	
	var ToolbarContainer = function ToolbarContainer() {
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var livefeedName = _useSelector.livefeedName;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var editorView = _useSelector.editorView;
	    var stepNumberState = _useSelector.stepNumberState;
	    var _livefeedSlides$slice$slideCurrentIndex = livefeedSlides.slice()[slideCurrentIndex];
	    var slideType = _livefeedSlides$slice$slideCurrentIndex.slideType;
	    var historyEntities = _livefeedSlides$slice$slideCurrentIndex.historyEntities;
	    var fontFamily = _livefeedSlides$slice$slideCurrentIndex.fontFamily;
	    var leftPanelBg = _livefeedSlides$slice$slideCurrentIndex.leftPanelBg;
	    var rightPanelBg = _livefeedSlides$slice$slideCurrentIndex.rightPanelBg;
	    var slideBg = _livefeedSlides$slice$slideCurrentIndex.slideBg;
	
	    var history = historyEntities.slice(0);
	    var currentEntity = history[stepNumberState];
	    function liveFeedNameChangeHandler(e) {
	        var name = e.target.value;
	        dispatch((0, _actionsLivefeed.setLivefeedName)(name));
	    }
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'tool-bar-row' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'flex--center' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'livefeed-name-col ' },
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    ' ',
	                    _react2['default'].createElement(
	                        'b',
	                        null,
	                        'Name:'
	                    )
	                ),
	                _react2['default'].createElement('input', { id: 'livefeed-editor-input-name', value: livefeedName, type: 'text', onChange: function (e) {
	                        return liveFeedNameChangeHandler(e);
	                    }, required: true })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-toolbar flex--center' },
	                _react2['default'].createElement(_ToolbarOptionsAlignButton2['default'], {
	                    currentEntity: currentEntity,
	                    dispatch: dispatch
	                }),
	                _react2['default'].createElement(_ToolbarOptionsDeleteOptionButton2['default'], {
	                    currentEntity: currentEntity,
	                    dispatch: dispatch
	                }),
	                _react2['default'].createElement(_ToolbarOptionsAddEntityButton2['default'], {
	                    editorView: editorView,
	                    livefeedSlides: livefeedSlides,
	                    slideCurrentIndex: slideCurrentIndex,
	                    dispatch: dispatch
	                }),
	                _react2['default'].createElement(_ToolbarOptionsReUnDoButton2['default'], {
	                    stepNumberState: stepNumberState,
	                    historyLength: history.length,
	                    dispatch: dispatch,
	                    editorView: editorView
	                }),
	                _react2['default'].createElement('div', { className: 'editor-toolbar__divider' }),
	                _react2['default'].createElement(_ToolbarOptionsFontFamilyDropdown2['default'], {
	                    editorView: editorView,
	                    livefeedSlides: livefeedSlides,
	                    slideCurrentIndex: slideCurrentIndex,
	                    dispatch: dispatch
	                }),
	                _react2['default'].createElement(_ToolbarOptionsFontSizeDropdown2['default'], {
	                    currentEntity: currentEntity,
	                    dispatch: dispatch
	                }),
	                _react2['default'].createElement(_ToolbarOptionsBgColorOption2['default'], {
	                    editorView: editorView,
	                    currentEntity: currentEntity,
	                    dispatch: dispatch,
	                    leftPanelBg: leftPanelBg,
	                    rightPanelBg: rightPanelBg,
	                    slideType: slideType,
	                    slideBg: slideBg
	                }),
	                _react2['default'].createElement(_ToolbarOptionsTextOption2['default'], {
	                    dispatch: dispatch,
	                    currentEntity: currentEntity
	                }),
	                _react2['default'].createElement(_ToolbarOptionsFormatColor2['default'], {
	                    currentEntity: currentEntity
	                }),
	                _react2['default'].createElement(_ToolbarOptionsEditorToggleButton2['default'], {
	                    currentEntity: currentEntity,
	                    editorView: editorView,
	                    slideCurrentIndex: slideCurrentIndex,
	                    dispatch: dispatch,
	                    fontFamily: fontFamily
	                })
	            )
	        )
	    );
	};
	
	exports['default'] = ToolbarContainer;
	module.exports = exports['default'];
	/* ------------------------ Align Toolbar options -------------------- */ /* ------------------------ Delete,Add Toolbar options -------------------- */ /* ------------------------ Redo Undo Toolbar options -------------------- */ /* ------------------------ Text related Toolbar options -------------------- */ /* ------------------------ Toggle Editor view -------------------- */

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _lodash = __webpack_require__(1897);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var EditorToggleButton = function EditorToggleButton(props) {
	    var currentEntity = props.currentEntity;
	    var fontFamily = props.fontFamily;
	    var editorView = props.editorView;
	    var dispatch = props.dispatch;
	
	    var toggleEditorView = (0, _react.useCallback)(function () {
	        dispatch((0, _actionsLivefeed.setEditorView)((0, _immutabilityHelper2['default'])(editorView, { $set: !editorView })));
	        var emptyEntity = { id: null, fontFamily: fontFamily }; // Prevent duplicate dispatch
	        (0, _lodash.isEqual)(emptyEntity, currentEntity) === false && props.dispatch((0, _actionsLivefeed.updateEmptyEntity)()) // if there is chosen entity, dispatch empty
	        ;
	    }, [currentEntity, dispatch, editorView, fontFamily, props]);
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            {
	                id: 'editor-guide',
	                style: { display: "flex" },
	                className: 'justify-center', onClick: function () {
	                    return toggleEditorView();
	                } },
	            _react2['default'].createElement(_componentsCommonToggle2['default'], { style: { marginLeft: 10 }, isActive: editorView })
	        ),
	        _react2['default'].createElement(
	            _reactPortalTooltip2['default'],
	            { active: true, parent: "#editor-guide", position: 'right', arrow: 'center',
	                style: {
	                    style: {
	                        background: "rgba(20, 20, 20, 0.9)",
	                        padding: 10,
	                        color: "#EEE",
	                        boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
	                        fontSize: 12
	                    },
	                    arrowStyle: {
	                        color: 'rgba(20, 20, 20, 0.9)',
	                        borderColor: false
	                    }
	                }
	            },
	            editorView ? 'Click to disable Editor View' : 'Click to enable Editor View',
	            _react2['default'].createElement('br', null),
	            'Or right click on the floorplan to toggle view'
	        )
	    );
	};
	EditorToggleButton.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    fontFamily: _propTypes2['default'].string.isRequired,
	    editorView: _propTypes2['default'].bool.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = EditorToggleButton;
	module.exports = exports['default'];

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2243);
	
	var Toggle = function Toggle(_ref) {
	    var style = _ref.style;
	    var isActive = _ref.isActive;
	    return _react2['default'].createElement('div', { style: style, className: 'toggle-box ' + (isActive ? 'on' : 'off') });
	};
	
	Toggle.propTypes = {
	    isActive: _propTypes2['default'].bool.isRequired,
	    style: _propTypes2['default'].object
	};
	exports['default'] = Toggle;
	module.exports = exports['default'];

/***/ }),
/* 2243 */
[2370, 2244],
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".toggle-box{cursor:pointer;vertical-align:middle;height:20px;width:34px;background-color:#bdbdbd;border-radius:10px;position:relative;margin-left:auto}.toggle-box,.toggle-box:after{display:inline-block;transition:all .2s ease}.toggle-box:after{content:\"\";position:absolute;height:16px;width:16px;border-radius:8px;top:2px;background-color:#fff}.toggle-box.off{background-color:#bdbdbd}.toggle-box.off:after{left:2px}.toggle-box.on{background-color:#3cb449}.toggle-box.on:after{left:16px}", ""]);
	
	// exports


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var AlignButton = function AlignButton(props) {
	    var currentEntity = props.currentEntity;
	    var dispatch = props.dispatch;
	
	    var activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
	    var isAbleToAlign = currentEntity && currentEntity.id !== null && (activeToolbarItems[2].isText || currentEntity.id === "line" || currentEntity.id === "logo" || currentEntity.id === "gauge0" || currentEntity.id === "gauge1" || currentEntity.id === "gauge2") && currentEntity.id !== "rightPanelGaugeValueLabel";
	
	    function activeAlignClass(item) {
	        var classes = 'icon-wrapper justify-center';
	        if (currentEntity.id !== null) {
	            classes += ' ' + (activeToolbarItems[0].align === item ? 'icon-wrapper_active' : '');
	        }
	        return classes;
	    }
	    // ------------------------ shortcut key keyHandlerAlign for Aligning functions --------------------
	    (0, _react.useEffect)(function () {
	        var keyHandlerAlign = function keyHandlerAlign(event) {
	            // ----------------------- Align keys hanlde ---------------------------
	            if (event.ctrlKey && event.key === "l") {
	                alignEntityHandle("left");
	            } else if (event.ctrlKey && event.key === "e") {
	                alignEntityHandle("center");
	            } else if (event.ctrlKey && event.key === "r") {
	                alignEntityHandle("right");
	            }
	            // for mac
	            if (event.metaKey && event.key === "l") {
	                alignEntityHandle("left");
	            } else if (event.metaKey && event.key === "e") {
	                alignEntityHandle("center");
	            }
	            // shortkey for aligning right for mac ?? cmd r will reload page, preventDefault is bad for UX. just let it be :), nobody would use this function at all
	        };
	        window.addEventListener("keydown", keyHandlerAlign);
	        return function () {
	            window.removeEventListener("keydown", keyHandlerAlign);
	        };
	    }, [alignEntityHandle, currentEntity.id, dispatch]);
	
	    var alignEntityHandle = (0, _react.useCallback)(function (mode) {
	        currentEntity.id !== null && dispatch((0, _actionsLivefeed.alignEntity)(currentEntity.id, mode));
	    }, [currentEntity.id, dispatch]);
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { onClick: function () {
	                    return isAbleToAlign ? alignEntityHandle("left") : null;
	                }, className: activeAlignClass("left") + ' ' + (isAbleToAlign ? '' : 'icon-wrapper_disable') },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Align Left', className: 'material-icons' },
	                ''
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { onClick: function () {
	                    return isAbleToAlign ? alignEntityHandle("center") : null;
	                }, className: activeAlignClass("center") + ' ' + (isAbleToAlign ? '' : 'icon-wrapper_disable') },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Align Center', className: 'material-icons' },
	                ''
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { onClick: function () {
	                    return isAbleToAlign ? alignEntityHandle("right") : null;
	                }, className: activeAlignClass("right") + ' ' + (isAbleToAlign ? '' : 'icon-wrapper_disable') },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Align Right', className: 'material-icons' },
	                ''
	            )
	        )
	    );
	};
	
	AlignButton.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = AlignButton;
	module.exports = exports['default'];

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var ReUnDoButton = function ReUnDoButton(props) {
	    var stepNumberState = props.stepNumberState;
	    var historyLength = props.historyLength;
	    var dispatch = props.dispatch;
	    var editorView = props.editorView;
	
	    var isUndoable = stepNumberState > 0;
	    var isRedoable = stepNumberState >= 0 && stepNumberState < historyLength - 1;
	    // ----------------------- Redo/Undo keys hanlde ---------------------
	    (0, _react.useEffect)(function () {
	        var keyHandlerReUnDo = function keyHandlerReUnDo(event) {
	
	            if (event.ctrlKey && event.key === "z") {
	                handleUnRedo("undo");
	            } else if (event.ctrlKey && event.key === "y") {
	                handleUnRedo("redo");
	            }
	            // for mac
	            if (event.metaKey && event.shiftKey && event.key === "z") {
	                handleUnRedo("redo");
	            } else if (event.metaKey && event.key === "z") {
	                handleUnRedo("undo");
	            }
	        };
	        window.addEventListener("keydown", keyHandlerReUnDo);
	        return function () {
	            window.removeEventListener("keydown", keyHandlerReUnDo);
	        };
	    }, [dispatch, isRedoable, isUndoable, handleUnRedo, stepNumberState]);
	
	    var handleUnRedo = (0, _react.useCallback)(function (mode) {
	        switch (mode) {
	            case "undo":
	                isUndoable && dispatch((0, _actionsLivefeedHistoryActions.changeHistory)(stepNumberState - 1));
	                break;
	            case "redo":
	                isRedoable && dispatch((0, _actionsLivefeedHistoryActions.changeHistory)(stepNumberState + 1));
	                break;
	            default:
	        }
	    }, [dispatch, isRedoable, isUndoable, stepNumberState]);
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'icon-wrapper justify-center ' + (isUndoable && editorView ? '' : 'icon-wrapper_disable'), onClick: function () {
	                    return editorView ? handleUnRedo("undo") : null;
	                } },
	            _react2['default'].createElement(
	                'i',
	                { style: { fontSize: "24px" }, 'data-tooltip': 'Undo', className: 'material-icons' },
	                'undo'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'icon-wrapper justify-center ' + (isRedoable && editorView ? '' : 'icon-wrapper_disable'), onClick: function () {
	                    return editorView ? handleUnRedo("redo") : null;
	                } },
	            _react2['default'].createElement(
	                'i',
	                { style: { fontSize: "24px" }, 'data-tooltip': 'Redo', className: 'material-icons' },
	                'redo'
	            )
	        )
	    );
	};
	ReUnDoButton.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    historyLength: _propTypes2['default'].number.isRequired,
	    editorView: _propTypes2['default'].bool.isRequired,
	    stepNumberState: _propTypes2['default'].number.isRequired
	};
	exports['default'] = ReUnDoButton;
	module.exports = exports['default'];

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var DeleteOptionButton = function DeleteOptionButton(props) {
	    var currentEntity = props.currentEntity;
	    var dispatch = props.dispatch;
	
	    var activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
	    var isDeleteable = currentEntity !== undefined && currentEntity.id !== null && activeToolbarItems[1].deletable;
	
	    var deleteHandle = (0, _react.useCallback)(function () {
	        dispatch((0, _actionsLivefeed.removeEntity)(currentEntity.id));
	    }, [currentEntity.id, dispatch]);
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'icon-wrapper justify-center icon-wrapper_delete  ' + (isDeleteable ? '' : 'icon-wrapper_disable'),
	            onClick: function () {
	                return isDeleteable ? deleteHandle() : undefined;
	            } },
	        _react2['default'].createElement(
	            'i',
	            { 'data-tooltip': 'Delete', style: { fontSize: "32px" }, className: 'material-icons' },
	            'delete_forever'
	        )
	    );
	};
	DeleteOptionButton.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = DeleteOptionButton;
	module.exports = exports['default'];

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var AddEntityButton = function AddEntityButton(props) {
	    var slideCurrentIndex = props.slideCurrentIndex;
	    var livefeedSlides = props.livefeedSlides;
	    var editorView = props.editorView;
	    var dispatch = props.dispatch;
	    var _livefeedSlides$slice$slideCurrentIndex = livefeedSlides.slice()[slideCurrentIndex];
	    var lineState = _livefeedSlides$slice$slideCurrentIndex.lineState;
	    var logoState = _livefeedSlides$slice$slideCurrentIndex.logoState;
	
	    // -------------------------------- Adding functions ---------------------------
	    var addEntityHandle = (0, _react.useCallback)(function (e, type) {
	        dispatch((0, _actionsLivefeed.addEntity)(e, type));
	    }, [dispatch]);
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { 'data-tooltip': 'Add Text Box', className: 'add-text-dropdown-wrapper' },
	            _react2['default'].createElement(
	                _componentsCommonDropdowncomponentsDropdown2['default'],
	                {
	                    className: 'toolbar-dropdown',
	                    noArrow: true,
	                    header: _react2['default'].createElement(
	                        'div',
	                        { className: 'justify-center dropdown-header-text ' + (editorView === true ? '' : 'dropdown-header-text_disable') },
	                        _react2['default'].createElement(
	                            'span',
	                            { style: { fontSize: 14 } },
	                            'Insert'
	                        ),
	                        _react2['default'].createElement(
	                            'i',
	                            { style: { fontSize: "24px" }, className: 'material-icons' },
	                            'add'
	                        )
	                    ),
	                    toggleable: editorView
	                },
	                !logoState.show && _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                    null,
	                    _react2['default'].createElement('input', { style: { display: "none" }, id: 'addLogo', type: 'file', onChange: function (e) {
	                            return addEntityHandle(e, "logo");
	                        } }),
	                    _react2['default'].createElement(
	                        'label',
	                        { style: { display: "block" }, className: 'cursor--pointer', htmlFor: 'addLogo' },
	                        'Logo'
	                    )
	                ),
	                lineState.show === false ? _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: function (e) {
	                                return addEntityHandle(e, "line");
	                            } },
	                        'Divider Line'
	                    )
	                ) : null,
	                _react2['default'].createElement(
	                    _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: function (e) {
	                                return addEntityHandle(e, "textObj");
	                            } },
	                        'Text Box'
	                    )
	                )
	            )
	        )
	    );
	};
	
	AddEntityButton.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    livefeedSlides: _propTypes2['default'].array.isRequired, // array with 1 object is considered to be a template.
	    editorView: _propTypes2['default'].bool.isRequired,
	    slideCurrentIndex: _propTypes2['default'].number.isRequired
	};
	exports['default'] = AddEntityButton;
	module.exports = exports['default'];

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var FontSizeDropdown = function FontSizeDropdown(props) {
	    var currentEntity = props.currentEntity;
	    var dispatch = props.dispatch;
	
	    var activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
	    var isText = currentEntity !== undefined && currentEntity.id !== null && activeToolbarItems[2].isText;
	
	    var _React$useState = _react2['default'].useState(currentEntity.size);
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var value = _React$useState2[0];
	    var setValue = _React$useState2[1];
	
	    var fontSizeHandle = (0, _react.useCallback)(function (value) {
	        var newState = (0, _immutabilityHelper2['default'])(currentEntity, {
	            size: { $set: value }
	        });
	        typeof currentEntity.id == 'number' && dispatch((0, _actionsLivefeed.updateText)(newState)); // if entity is an obj in textContainer arr
	        switch (currentEntity.id) {
	            case "rightPanelTextTitle":
	                dispatch((0, _actionsLivefeed.updateGaugleTitle)(newState));
	                break;
	            case "rightPanelGaugeValueLabel":
	                dispatch((0, _actionsLivefeed.updateGaugeLabel)(newState));
	                break;
	            case "locationsListStyle":
	                dispatch((0, _actionsLivefeed.updateLocationsListStyle)(newState));
	                break;
	        }
	    }, [currentEntity, dispatch]);
	
	    (0, _react.useEffect)(function () {
	        setValue(currentEntity.size);
	    }, [currentEntity.size]);
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'justify-center font-size-dropdown-wrapper' },
	        _react2['default'].createElement(
	            _componentsCommonDropdowncomponentsDropdown2['default'],
	            {
	                'data-tooltip': 'Font-size',
	                className: 'toolbar-dropdown justify-center',
	                noArrow: true,
	                header: _react2['default'].createElement(
	                    'div',
	                    { className: 'justify-center dropdown-header-text ' + (isText ? '' : 'dropdown-header-text_disable') },
	                    isText ? _react2['default'].createElement('input', {
	                        name: "font-size",
	                        onChange: function (e) {
	                            return setValue(Number(e.target.value));
	                        },
	                        value: value || currentEntity.size,
	                        onBlur: function (e) {
	                            return fontSizeHandle(Number(e.target.value));
	                        }
	                    }) : _react2['default'].createElement(
	                        'span',
	                        null,
	                        'Font Size'
	                    ),
	                    _react2['default'].createElement(
	                        'i',
	                        { style: { fontSize: "24px" }, className: 'material-icons' },
	                        'keyboard_arrow_down'
	                    )
	                ),
	                toggleable: isText
	            },
	            [].concat(_toConsumableArray(Array(41).keys())).slice(8).map(function (x) {
	                return _react2['default'].createElement(
	                    _react2['default'].Fragment,
	                    { key: x },
	                    _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function () {
	                                    return fontSizeHandle(x);
	                                } },
	                            x
	                        )
	                    )
	                );
	            })
	        )
	    );
	};
	
	FontSizeDropdown.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = FontSizeDropdown;
	module.exports = exports['default'];

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var _googleFonts = __webpack_require__(2251);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var FontFamilyDropdown = function FontFamilyDropdown(props) {
	    var slideCurrentIndex = props.slideCurrentIndex;
	    var livefeedSlides = props.livefeedSlides;
	    var dispatch = props.dispatch;
	    var editorView = props.editorView;
	    var fontFamily = livefeedSlides.slice()[slideCurrentIndex].fontFamily;
	
	    var fontsList = [];
	    _googleFonts.googleFonts.map(function (value) {
	        return fontsList.push({ values: value, label: value });
	    });
	    var handleSelect = (0, _react.useCallback)(function (font) {
	        // currentFont
	        var entityFont = {
	            slideCurrentIndex: slideCurrentIndex,
	            id: null,
	            fontFamily: fontFamily
	        };
	
	        dispatch((0, _actionsLivefeed.updateEntityFont)(entityFont)); // use this for history matter
	        dispatch((0, _actionsLivefeed.updateFontFamily)(font));
	    }, [dispatch, fontFamily, slideCurrentIndex]);
	
	    return _react2['default'].createElement(
	        'div',
	        { 'data-tooltip': 'Font Family', className: 'reactSelect-dropdown-wrapper ' + (editorView ? '' : 'font-family-dropdown-wrapper_disable') },
	        _react2['default'].createElement(_reactSelect2['default'], {
	            className: 'reactSelect-fontFamily-dropdown',
	            options: fontsList,
	            onChange: function (font) {
	                handleSelect(font.values);
	            },
	            placeholder: fontFamily,
	            value: fontFamily,
	            openOnClick: true
	        })
	    );
	};
	FontFamilyDropdown.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    livefeedSlides: _propTypes2['default'].array.isRequired, // array with 1 object is considered to be a template.
	    editorView: _propTypes2['default'].bool.isRequired,
	    slideCurrentIndex: _propTypes2['default'].number.isRequired
	};
	exports['default'] = FontFamilyDropdown;
	module.exports = exports['default'];

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

	//https://dev.to/ycmjason/here-is-a-little-script-to-grab-a-list-of-all-font-names-on-google-fonts--4b81
	// Here I filter ther most common fonts
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var googleFonts = ["Alegreya", "Alegreya SC", "Alegreya Sans", "Alegreya Sans SC", "Muli", "Titillium Web", "Varela", "Varela Round", "Volkhov", "Vollkorn", "Vollkorn SC", "IBM Plex Mono", "IBM Plex Sans", "IBM Plex Sans Condensed", "IBM Plex Serif", "Crimson Text", "Cairo", "BioRhyme", "BioRhyme Expanded", "Karla", "Lora", "Frank Ruhl Libre", "Playfair Display", "Playfair Display SC", "Archivo", "Archivo Black", "Archivo Narrow", "Spectral", "Spectral SC", "Fjalla One", "Roboto", "Roboto Condensed", "Roboto Mono", "Roboto Slab", "Montserrat", "Montserrat Alternates", "Montserrat Subrayada", "Rubik", "Rubik Mono One", "Source Code Pro", "Source Sans Pro", "Source Serif Pro", "Cardo", "Cormorant", "Cormorant Garamond", "Cormorant Infant", "Cormorant SC", "Cormorant Unicase", "Cormorant Upright", "Work Sans", "Rakkas", "Concert One", "Yatra One", "Arvo", "Lato", "Abril Fatface", "Ubuntu", "Ubuntu Condensed", "Ubuntu Mono", "PT Mono", "PT Sans", "PT Sans Caption", "PT Sans Narrow", "PT Serif", "PT Serif Caption", "Old Standard TT", "Oswald", "Poppins", "Fira Mono", "Fira Sans", "Fira Sans Condensed", "Fira Sans Extra Condensed", "Nunito", "Nunito Sans", "Oxygen", "Oxygen Mono", "Exo", "Exo 2", "Open Sans", "Open Sans Condensed", "Merriweather", "Merriweather Sans", "Noto Sans", "Noto Sans HK", "Noto Sans JP", "Noto Sans KR", "Noto Sans SC", "Noto Sans TC", "Noto Serif", "Noto Serif JP", "Noto Serif KR", "Noto Serif SC", "Noto Serif TC", "GTWalsheimProRegular"];
	exports.googleFonts = googleFonts;
	googleFonts.sort();

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker = __webpack_require__(1992);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker);
	
	var FormatColor = function FormatColor(props) {
	    var currentEntity = props.currentEntity;
	
	    var activeToolbarItems = currentEntity && currentEntity.activeToolbarItems;
	    var shouldShow = currentEntity.id !== null && (activeToolbarItems[2].isText || currentEntity.id === "line");
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            _componentsPagesLivefeedEditorEditorContainerCommonColorPicker2['default'],
	            {
	                className: 'icon-wrapper justify-center icon-wrapper_color ' + (shouldShow ? '' : 'icon-wrapper_color_disable'),
	                clickable: shouldShow
	            },
	            _react2['default'].createElement(
	                'span',
	                { style: { display: "inline-flex" }, 'data-tooltip': "Text color" },
	                _react2['default'].createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
	                    _react2['default'].createElement('path', { className: 'shape', d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' }),
	                    _react2['default'].createElement('path', { fill: currentEntity.color, className: 'Color-Line', d: 'M0 20h24v4H0z' })
	                )
	            )
	        )
	    );
	};
	
	FormatColor.propTypes = {
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = FormatColor;
	module.exports = exports['default'];

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var TextOption = function TextOption(props) {
	    var currentEntity = props.currentEntity;
	    var dispatch = props.dispatch;
	
	    var activeToolbarItems = currentEntity && currentEntity.activeToolbarItems;
	    var isText = currentEntity && currentEntity.id !== null && activeToolbarItems[2].isText;
	
	    function handleFormatText(type) {
	        var style = {};
	        switch (type) {
	            case "bold":
	                // toggle style
	                style.bold = !currentEntity.textStyle.bold;
	                break;
	            case "italic":
	                style.italic = !currentEntity.textStyle.italic;
	                break;
	            case "underline":
	                style.underline = !currentEntity.textStyle.underline;
	                break;
	        }
	        dispatch((0, _actionsLivefeed.stylingText)(style));
	    }
	
	    function multileActiveItem(item) {
	        if (currentEntity.id !== null) {
	            if (activeToolbarItems[2].bold && item === "bold") {
	                return 'icon-wrapper_active';
	            } else if (activeToolbarItems[2].italic && item === "italic") {
	                return 'icon-wrapper_active';
	            } else if (activeToolbarItems[2].underline && item === "underline") {
	                return 'icon-wrapper_active';
	            } else return '';
	        }
	    }
	
	    function activeTextClass(item) {
	        var classes = 'icon-wrapper justify-center ' + multileActiveItem(item) + ' ' + (isText ? '' : 'icon-wrapper_disable');
	        return classes;
	    }
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: activeTextClass("bold"), onClick: function () {
	                    return isText ? handleFormatText("bold") : null;
	                } },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Bold Text', style: { fontSize: "24px" }, className: 'material-icons' },
	                'format_bold'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: activeTextClass("italic"), onClick: function () {
	                    return isText ? handleFormatText("italic") : null;
	                } },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Italic Text', style: { fontSize: "24px" }, className: 'material-icons' },
	                'format_italic'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: activeTextClass("underline"), onClick: function () {
	                    return isText ? handleFormatText("underline") : null;
	                } },
	            _react2['default'].createElement(
	                'i',
	                { 'data-tooltip': 'Underline Text', style: { fontSize: "24px" }, className: 'material-icons' },
	                'format_underlined'
	            )
	        )
	    );
	};
	
	TextOption.propTypes = {
	    dispatch: _propTypes2['default'].func.isRequired,
	    currentEntity: _propTypes2['default'].object.isRequired
	};
	exports['default'] = TextOption;
	module.exports = exports['default'];

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker = __webpack_require__(1992);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonColorPicker2 = _interopRequireDefault(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker);
	
	var BgColorOption = function BgColorOption(props) {
	    var colorPickerRef = (0, _react.useRef)(null);
	    var slideType = props.slideType;
	    var dispatch = props.dispatch;
	    var currentEntity = props.currentEntity;
	    var leftPanelBg = props.leftPanelBg;
	    var slideBg = props.slideBg;
	    var rightPanelBg = props.rightPanelBg;
	    var editorView = props.editorView;
	
	    var setEntity = (0, _react.useCallback)(function (e, entity) {
	        e.preventDefault();
	        e.stopPropagation();
	        (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.handleSetCurrentEntity)(currentEntity, entity, dispatch);
	    }, [currentEntity, dispatch]);
	
	    function handleChangeBg(e, entity) {
	        setEntity(e, entity);
	        colorPickerRef.current.openColorPicker();
	    }
	    var fillLineColor = undefined;
	    if (currentEntity.id === "leftPanelBg" || currentEntity.id === "rightPanelBg" || currentEntity.id === "rightPanelGaugeOccupiedBg" || currentEntity.id === "rightPanelGaugeOffsetdBg" || currentEntity.id === "rightPanelGaugeNeedle") {
	        fillLineColor = currentEntity.color;
	    } else {
	        fillLineColor = "#aaaaaa";
	    }
	    var toggleable = undefined;
	    if (currentEntity.id === "rightPanelGaugeOccupiedBg" || currentEntity.id === "rightPanelGaugeOffsetdBg" || currentEntity.id === "rightPanelGaugeNeedle" || editorView === false) {
	        toggleable = false;
	    } else {
	        toggleable = true;
	    }
	
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        toggleable === false ? _react2['default'].createElement(
	            'div',
	            {
	                onClick: function () {
	                    return editorView ? colorPickerRef.current.openColorPicker() : null;
	                },
	                'data-tooltip': 'Change background color' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'icon-wrapper justify-center icon-wrapper_color ' + (editorView ? '' : 'icon-wrapper_color_disable') },
	                _react2['default'].createElement(
	                    'svg',
	                    { width: '24', height: '24', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24' },
	                    _react2['default'].createElement('path', { className: 'shape', d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
	                    _react2['default'].createElement('path', { className: 'Color-Line', fill: fillLineColor, d: 'M0 20h24v4H0z' })
	                )
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            { 'data-tooltip': 'Change livefeed background color', style: { zIndex: 3 } },
	            _react2['default'].createElement(
	                _componentsCommonDropdowncomponentsDropdown2['default'],
	                {
	                    className: 'toolbar-dropdown',
	                    noArrow: true,
	                    header: _react2['default'].createElement(
	                        'div',
	                        { className: 'icon-wrapper justify-center icon-wrapper_color ' + (editorView ? '' : 'icon-wrapper_color_disable') },
	                        _react2['default'].createElement(
	                            'svg',
	                            { width: '24', height: '24', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24' },
	                            _react2['default'].createElement('path', { className: 'shape', d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
	                            _react2['default'].createElement('path', { className: 'Color-Line', fill: fillLineColor, d: 'M0 20h24v4H0z' })
	                        )
	                    ),
	                    toggleable: toggleable,
	                    dropdownItemsWrapperStyle: { width: "unset" }
	                },
	                _react2['default'].createElement(
	                    _react2['default'].Fragment,
	                    null,
	                    slideType === "summary" || slideType === "locationsList" ? _react2['default'].createElement(
	                        _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { onClick: function (e) {
	                                    return handleChangeBg(e, slideBg);
	                                } },
	                            'Change background color'
	                        )
	                    ) : _react2['default'].createElement(
	                        _react2['default'].Fragment,
	                        null,
	                        _react2['default'].createElement(
	                            _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { onClick: function (e) {
	                                        return handleChangeBg(e, leftPanelBg);
	                                    } },
	                                'Change Panel Left background color'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _componentsCommonDropdowncomponentsDropdownitem2['default'],
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { onClick: function (e) {
	                                        return handleChangeBg(e, rightPanelBg);
	                                    } },
	                                'Change Panel Right background color'
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2['default'].createElement(_componentsPagesLivefeedEditorEditorContainerCommonColorPicker2['default'], {
	            clickable: editorView,
	            ref: colorPickerRef,
	            dispatch: dispatch
	        })
	    );
	};
	
	exports['default'] = BgColorOption;
	module.exports = exports['default'];

/***/ }),
/* 2255 */
[2374, 2256],
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".tool-bar-row{margin-bottom:20px;width:100%}.tool-bar-row .livefeed-name-col{padding-right:20px;display:inline-block;margin-left:-15px}.tool-bar-row #livefeed-editor-input-name{width:135px;margin-left:10px;font-size:16px;padding-right:10px}.tool-bar-row .editor-toolbar{margin-left:10px;width:800px;height:66px;background-color:#f4f4f4;justify-content:center;padding-right:10px;box-shadow:2px 4px 10px rgba(0,0,0,.2)}.tool-bar-row .editor-toolbar .icon-wrapper{width:35px;height:35px;cursor:pointer}.tool-bar-row .editor-toolbar .icon-wrapper i{font-size:24px;color:#3f5043;line-height:normal;white-space:pre-line}.tool-bar-row .editor-toolbar .icon-wrapper i:not(:last-child){margin-right:15px}.tool-bar-row .editor-toolbar .icon-wrapper:hover{background-color:#e1dfdd}.tool-bar-row .editor-toolbar .icon-wrapper:hover i{color:#000}.tool-bar-row .editor-toolbar .icon-wrapper_active{background-color:#d2d0ce}.tool-bar-row .editor-toolbar .icon-wrapper_delete i{transition:all .2s ease;color:#ef5350}.tool-bar-row .editor-toolbar .icon-wrapper_delete:hover i{color:#c71612}.tool-bar-row .editor-toolbar .icon-wrapper_disable{cursor:not-allowed;color:#aaa}.tool-bar-row .editor-toolbar .icon-wrapper_disable:hover i{color:#aaa}.tool-bar-row .editor-toolbar .icon-wrapper_disable img{pointer-events:none}.tool-bar-row .editor-toolbar .icon-wrapper_disable i{color:#aaa;pointer-events:none}.tool-bar-row .editor-toolbar .icon-wrapper_color{position:relative}.tool-bar-row .editor-toolbar .icon-wrapper_color svg{z-index:1}.tool-bar-row .editor-toolbar .icon-wrapper_color svg .shape{fill:#3f5043}.tool-bar-row .editor-toolbar .icon-wrapper_color:hover svg .shape{fill:#000}.tool-bar-row .editor-toolbar .icon-wrapper_color_disable{cursor:not-allowed}.tool-bar-row .editor-toolbar .icon-wrapper_color_disable *{pointer-events:none}.tool-bar-row .editor-toolbar .icon-wrapper_color_disable:hover svg .Color-Line,.tool-bar-row .editor-toolbar .icon-wrapper_color_disable:hover svg .shape,.tool-bar-row .editor-toolbar .icon-wrapper_color_disable svg .Color-Line,.tool-bar-row .editor-toolbar .icon-wrapper_color_disable svg .shape{fill:#aaa}.tool-bar-row .editor-toolbar .icon-wrapper_color input{z-index:2;position:absolute;left:0;top:0;opacity:0;width:100%;height:100%;cursor:pointer}.tool-bar-row .editor-toolbar__divider{margin-left:15px;margin-right:15px;height:35px;width:2px;background-color:#3f5043}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper{padding-left:8px;padding-right:5px}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .toolbar-dropdown,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .toolbar-dropdown{z-index:3}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .toolbar-dropdown.open,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .toolbar-dropdown.open{z-index:4}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown-header-text,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text{color:#3f5043}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown-header-text:hover,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text:hover{color:#000}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown-header-text_disable,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text_disable{cursor:not-allowed;color:#aaa}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown-header-text_disable:hover,.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown-header-text_disable:hover i,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text_disable:hover,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text_disable:hover i{color:#aaa}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .dropdown__items,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown__items{margin-left:-8px}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper:hover,.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper:hover{background-color:#e1dfdd}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper{z-index:3}.tool-bar-row .editor-toolbar .add-text-dropdown-wrapper .toolbar-dropdown{z-index:0}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper{height:35px;transition:all .5s ease}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper:hover{background-color:transparent}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown.open i{transform:rotate(180deg)}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown-header-text input{text-align:center;width:60px}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown__items{margin-left:0;width:60px}.tool-bar-row .editor-toolbar .font-size-dropdown-wrapper .dropdown__items .dropdown__item{transition:all .2s;text-align:center;line-height:15px}.tool-bar-row .reactSelect-dropdown-wrapper .reactSelect-fontFamily-dropdown{width:120px}", ""]);
	
	// exports


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(365);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsLivefeedHistoryActions = __webpack_require__(368);
	
	var _actionsLivefeedSlideCrudActions = __webpack_require__(372);
	
	var _reactSmoothDnd = __webpack_require__(2258);
	
	var _componentsPagesLivefeedDefaultstate = __webpack_require__(367);
	
	var _componentsPagesLivefeedDefaultstate2 = _interopRequireDefault(_componentsPagesLivefeedDefaultstate);
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	var _SlideTypesAdd = __webpack_require__(2260);
	
	var _SlideTypesAdd2 = _interopRequireDefault(_SlideTypesAdd);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var SlidesContainer = function SlidesContainer() {
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var stepNumberState = _useSelector.stepNumberState;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	
	    // add dynamic slide id
	    livefeedSlides.map(function (obj, i) {
	        obj.id = i;
	        return obj;
	    });
	
	    var moveToSlide = (0, _react.useCallback)(function (e, index) {
	        if (livefeedSlides[index].slideType === "slideshow") {
	            // prevent duplicate dispatch
	            var mapConfigMode = "user_input";
	            dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)(mapConfigMode));
	        }
	        if (slideCurrentIndex !== index) {
	            // Move to slide index
	            e !== null && e.stopPropagation();
	            /*First clear history of the slideCurrentIndex and setStepNumberState to 0
	             Then goToSlide to the target slide
	            */
	            dispatch((0, _actionsLivefeedHistoryActions.handleClearHistory)(slideCurrentIndex));
	            stepNumberState !== 0 && dispatch((0, _actionsLivefeedHistoryActions.setStepNumberState)(0));
	            dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(index));
	        }
	    }, [dispatch, livefeedSlides, stepNumberState, slideCurrentIndex]);
	
	    var removeSlideHandle = (0, _react.useCallback)(function (e, index) {
	        //remove slide
	        e !== null && e.stopPropagation();
	        /*First clear history of the slideCurrentIndex and setStepNumberState to 0
	        Then goToSlide to the target slide
	        */
	        dispatch((0, _actionsLivefeedHistoryActions.handleClearHistory)(slideCurrentIndex));
	        dispatch((0, _actionsLivefeedHistoryActions.setStepNumberState)(0));
	        dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(index));
	        //Target slide to be deleted is  1 and  0, goToSlide to 0
	        if (index <= 1) {
	            dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(0));
	        }
	        // Target slide to be deleted is the last slide, then just goToSlide minus 1
	        else if (livefeedSlides.length - 1 === index) {
	                dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(index - 1));
	            }
	
	        var pairedSlideIndex = null; // summary & locationsList slide
	        if (livefeedSlides[index].slideType === "summary") {
	            for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	                if (livefeedSlides[i].slideType === "locationsList") {
	                    pairedSlideIndex = i;
	                }
	            }
	        }
	
	        if (pairedSlideIndex !== null) {
	            (function () {
	                var valuesArr = livefeedSlides.slice();
	                var removeValFromIndex = [index, pairedSlideIndex];
	                var indexSet = new Set(removeValFromIndex);
	                var arrayWithValuesRemoved = valuesArr.filter(function (_, i) {
	                    return !indexSet.has(i);
	                });
	                dispatch((0, _actionsLivefeedSlideCrudActions.setNewSlideOrder)(arrayWithValuesRemoved));
	            })();
	        } else {
	            dispatch((0, _actionsLivefeedSlideCrudActions.removeSlide)(index));
	        }
	    }, [dispatch, livefeedSlides, slideCurrentIndex]);
	
	    var summaryPageIndex = undefined;
	    var firstSlideShowIndex = undefined;
	    var locationsListIndex = undefined;
	    for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	        livefeedSlides[i].slideType === "summary" && (summaryPageIndex = i);
	        livefeedSlides[i].slideType === "slideshow" && (firstSlideShowIndex = i);
	        livefeedSlides[i].slideType === "locationsList" && (locationsListIndex = i);
	    }
	
	    var addSlideHandle = (0, _react.useCallback)(function (e, type) {
	        e.stopPropagation();
	        dispatch((0, _actionsLivefeedHistoryActions.handleClearHistory)(0));
	        dispatch((0, _actionsLivefeedHistoryActions.setStepNumberState)(0));
	        var template = undefined;
	
	        switch (type) {
	            case "locationsList":
	                {
	                    template = _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides.slice();
	                    var locationsList = (0, _immutabilityHelper2['default'])(template[1], {
	                        historyEntities: [{
	                            fontFamily: { $set: livefeedSlides[0].fontFamily } // get fontFamily of summary slide
	                        }],
	                        logoState: {
	                            slideCurrentIndex: { $set: livefeedSlides.length },
	                            url: { $set: livefeedSlides.slice()[0].logoState.url }
	                        }
	                    });
	                    var newArrOrder = livefeedSlides.slice();
	                    newArrOrder.splice(1, 0, locationsList);
	                    dispatch((0, _actionsLivefeedSlideCrudActions.setNewSlideOrder)(newArrOrder)); // push to index 1
	                    dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(1));
	                }
	                break;
	            case "summary":
	                {
	                    template = _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides.slice();
	                    dispatch((0, _actionsLivefeedSlideCrudActions.addSumSlide)(template[1])); // unshift to the begining
	                    dispatch((0, _actionsLivefeedSlideCrudActions.addSumSlide)(template[0])); // unshift to the begining
	                    dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(0));
	                }
	                break;
	            case "slideshow":
	                {
	                    // get firstSlideShow as template if exits, otherwise get template from defaultEditorState
	                    template = firstSlideShowIndex !== undefined ? livefeedSlides.slice()[firstSlideShowIndex] : _componentsPagesLivefeedDefaultstate2['default'].livefeedSlides.slice()[2];
	                    // specific objects need to be updated only for slideshow template
	                    template = (0, _immutabilityHelper2['default'])(template, {
	                        leftPanelBg: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        rightPanelBg: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        }
	                    });
	                    var _template = template;
	                    var fontFamily = _template.fontFamily;
	                    var textContainer = _template.textContainer;
	
	                    template = (0, _immutabilityHelper2['default'])(template, {
	                        historyEntities: {
	                            $set: [{
	                                id: null,
	                                fontFamily: fontFamily // get font family of the first slide as template
	                            }]
	                        },
	                        floorplanOptions: {
	                            location: { $set: { value: null, label: null } }
	                        },
	                        logoState: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        lineState: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	
	                        rightPanelTextTitle: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        rightPanelGaugeValueLabel: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        rightPanelGaugeOccupiedBg: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        rightPanelGaugeOffsetdBg: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        },
	                        rightPanelGaugeNeedle: {
	                            slideCurrentIndex: { $set: livefeedSlides.length }
	                        }
	                    });
	                    for (var i = 0; i < textContainer.length; i++) {
	                        template = (0, _immutabilityHelper2['default'])(template, {
	                            textContainer: _defineProperty({}, i, { slideCurrentIndex: { $set: livefeedSlides.length } })
	                        });
	                    }
	                    dispatch((0, _actionsLivefeedSlideCrudActions.addSlide)(template));
	                    dispatch((0, _actionsLivefeedSlideCrudActions.goToSlide)(livefeedSlides.length));
	                }
	                break;
	        }
	    }, [dispatch, firstSlideShowIndex, livefeedSlides]);
	
	    var applyDrag = (0, _react.useCallback)(function (arr, dragResult) {
	        var removedIndex = dragResult.removedIndex;
	        var addedIndex = dragResult.addedIndex;
	        var payload = dragResult.payload;
	
	        if (removedIndex === null && addedIndex === null) return arr;
	
	        var result = [].concat(_toConsumableArray(arr));
	        var itemToAdd = payload;
	
	        if (removedIndex !== null) {
	            itemToAdd = result.splice(removedIndex, 1)[0];
	        }
	
	        if (addedIndex !== null) {
	            result.splice(addedIndex, 0, itemToAdd);
	        }
	        return { result: result, addedIndex: addedIndex };
	    }, []);
	
	    var onMouseDownDragHandle = (0, _react.useCallback)(function (e, slideId) {
	        moveToSlide(e, slideId);
	    }, [moveToSlide]);
	
	    var sortSlideHandle = (0, _react.useCallback)(function (dropResult) {
	        var _applyDrag = applyDrag(livefeedSlides, dropResult);
	
	        var result = _applyDrag.result;
	        var addedIndex = _applyDrag.addedIndex;
	
	        dispatch((0, _actionsLivefeedSlideCrudActions.setNewSlideOrder)(result));
	        moveToSlide(null, addedIndex);
	    }, [applyDrag, dispatch, livefeedSlides, moveToSlide]);
	
	    //----------------------------------render functions
	
	    function renderDeleteBtn(slide) {
	        if (livefeedSlides.length > 1) {
	            var slideDeletable = true;
	            var length2 = livefeedSlides.length === 2; // if there are 2 slides;
	            var isPairedSlide = summaryPageIndex !== undefined && locationsListIndex !== undefined;
	            if (slide.slideType === "summary" && isPairedSlide && length2) {
	                slideDeletable = false; // summary page can not be deleted
	            }
	            if (slideDeletable) {
	                return _react2['default'].createElement(
	                    'i',
	                    { className: 'material-icons slide_delete',
	                        onClick: function (e) {
	                            return removeSlideHandle(e, slide.id);
	                        } },
	                    ''
	                );
	            }
	        }
	    }
	
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { className: 'slide-preview' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'slide-scroll' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'slide-header' },
	                    'Slide No.'
	                ),
	                _react2['default'].createElement(
	                    _reactSmoothDnd.Container,
	                    {
	                        dragClass: 'opacity-ghost',
	                        dropClass: 'opacity-ghost-drop',
	                        animationDuration: 500,
	                        dropPlaceholder: {
	                            animationDuration: 150,
	                            showOnTop: true,
	                            className: 'drop-preview'
	                        },
	                        dropPlaceholderAnimationDuration: 200,
	                        dragHandleSelector: '.column-drag-handle',
	                        onDrop: function (dropResult) {
	                            return sortSlideHandle(dropResult);
	                        }
	                    },
	                    livefeedSlides.map(function (slide) {
	                        return _react2['default'].createElement(
	                            _reactSmoothDnd.Draggable,
	                            { key: slide.id },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'slide ' + (slide.id === slideCurrentIndex ? 'current' : ''),
	                                    onClick: function (e) {
	                                        return moveToSlide(e, slide.id);
	                                    } },
	                                _react2['default'].createElement(
	                                    'i',
	                                    { onMouseDown: function (e) {
	                                            return onMouseDownDragHandle(e, slide.id);
	                                        },
	                                        className: 'column-drag-handle material-icons' },
	                                    'drag_handle'
	                                ),
	                                renderDeleteBtn(slide),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { style: { letterSpacing: -1 } },
	                                    (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.generateSlideName)(livefeedSlides, slide)
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2['default'].createElement(_SlideTypesAdd2['default'], {
	                    dispatch: dispatch,
	                    slideType: livefeedSlides[slideCurrentIndex].slideType,
	                    locationsListIndex: locationsListIndex,
	                    summaryPageIndex: summaryPageIndex,
	                    addSlideHandle: function (e, type) {
	                        return addSlideHandle(e, type);
	                    }
	                })
	            )
	        )
	    );
	};
	exports['default'] = SlidesContainer;
	module.exports = exports['default'];

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,n){ true?n(exports,__webpack_require__(38),__webpack_require__(53),__webpack_require__(2259)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","smooth-dnd"],n):n((e=e||self).ReactSmoothDnD={},e.React,e.PropTypes,e.SmoothDnD)}(this,function(n,r,e,o){"use strict";var i="default"in r?r.default:r;function a(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}function s(e,n){for(var t=0;t<n.length;t++){var r=n[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function c(e,n,t){return n&&s(e.prototype,n),t&&s(e,t),e}function p(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function t(){return(t=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}function u(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(n&&n.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),n&&f(e,n)}function l(e){return(l=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e,n){return(f=Object.setPrototypeOf||function(e,n){return e.__proto__=n,e})(e,n)}function h(e,n){if(null==e)return{};var t,r,o=function(e,n){if(null==e)return{};var t,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)t=i[r],0<=n.indexOf(t)||(o[t]=e[t]);return o}(e,n);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)t=i[r],0<=n.indexOf(t)||Object.prototype.propertyIsEnumerable.call(e,t)&&(o[t]=e[t])}return o}function d(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function y(e,n){return!n||"object"!=typeof n&&"function"!=typeof n?d(e):n}e=e&&e.hasOwnProperty("default")?e.default:e,o.smoothDnD.dropHandler=o.dropHandlers.reactDropHandler().handler,o.smoothDnD.wrapChild=!1;var g=function(e){function t(e){var n;return a(this,t),p(d(n=y(this,l(t).call(this,e))),"prevContainer",void 0),p(d(n),"container",null),p(d(n),"containerRef",i.createRef()),n.getContainerOptions=n.getContainerOptions.bind(d(n)),n.getContainer=n.getContainer.bind(d(n)),n.isObjectTypePropsChanged=n.isObjectTypePropsChanged.bind(d(n)),n.prevContainer=null,n}return u(t,r.Component),c(t,[{key:"componentDidMount",value:function(){this.prevContainer=this.getContainer(),this.container=o.smoothDnD(this.getContainer(),this.getContainerOptions())}},{key:"componentWillUnmount",value:function(){this.container.dispose(),this.container=null}},{key:"componentDidUpdate",value:function(e){if(this.getContainer()){if(this.prevContainer&&this.prevContainer!==this.getContainer())return this.container.dispose(),this.container=o.smoothDnD(this.getContainer(),this.getContainerOptions()),void(this.prevContainer=this.getContainer());this.isObjectTypePropsChanged(e)&&this.container.setOptions(this.getContainerOptions())}}},{key:"isObjectTypePropsChanged",value:function(e){var n=this.props,t=(n.render,n.children,n.style,h(n,["render","children","style"]));for(var r in t){var o=r;if(t.hasOwnProperty(o)){var i=t[o];if("function"!=typeof i&&i!==e[o])return!0}}return!1}},{key:"render",value:function(){return this.props.render?this.props.render(this.containerRef):i.createElement("div",{style:this.props.style,ref:this.containerRef},this.props.children)}},{key:"getContainer",value:function(){return this.containerRef.current}},{key:"getContainerOptions",value:function(){var o=this;return Object.keys(this.props).reduce(function(e,n){var t=n,r=o.props[t];return e[t]="function"==typeof r?function(){return o.props[t].apply(void 0,arguments)}:r,e},{})}}]),t}();p(g,"propTypes",{behaviour:e.oneOf(["move","copy","drop-zone","contain"]),groupName:e.string,orientation:e.oneOf(["horizontal","vertical"]),style:e.object,dragHandleSelector:e.string,nonDragAreaSelector:e.string,dragBeginDelay:e.number,animationDuration:e.number,autoScrollEnabled:e.bool,lockAxis:e.string,dragClass:e.string,dropClass:e.string,onDragStart:e.func,onDragEnd:e.func,onDrop:e.func,getChildPayload:e.func,shouldAnimateDrop:e.func,shouldAcceptDrop:e.func,onDragEnter:e.func,onDragLeave:e.func,render:e.func,getGhostParent:e.func,removeOnDropOut:e.bool,dropPlaceholder:e.oneOfType([e.shape({className:e.string,animationDuration:e.number,showOnTop:e.bool}),e.bool])}),p(g,"defaultProps",{behaviour:"move",orientation:"vertical"});var b=o.constants.wrapperClass,v=function(e){function n(){return a(this,n),y(this,l(n).apply(this,arguments))}return u(n,r.Component),c(n,[{key:"render",value:function(){if(this.props.render)return i.cloneElement(this.props.render(),{className:b});var e="".concat(this.props.className?this.props.className+" ":"");return i.createElement("div",t({},this.props,{className:"".concat(e).concat(b)}),this.props.children)}}]),n}();p(v,"propsTypes",{render:e.func,className:e.string}),Object.keys(o).forEach(function(e){n[e]=o[e]}),n.Container=g,n.Draggable=v,Object.defineProperty(n,"__esModule",{value:!0})});


/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e=e||self).SmoothDnD={})}(this,function(e){"use strict";var l,t,r="smooth-dnd-container-instance",f="smooth-dnd-draggable-wrapper",o="animated",p="__smooth_dnd_draggable_translation_value",u="__smooth_dnd_draggable_visibility_value",v="smooth-dnd-ghost",g="smooth-dnd-container",d="smooth-dnd-extra-size-for-insertion",h="smooth-dnd-stretcher-element",y="smooth-dnd-stretcher-instance",s="smooth-dnd-disable-touch-action",c="smooth-dnd-no-user-select",i="smooth-dnd-prevent-auto-scroll-class",b="smooth-dnd-drop-preview-default-class",w="smooth-dnd-drop-preview-inner-class",x="smooth-dnd-drop-preview-constant-class",E="smooth-dnd-drop-preview-flex-container-class",n=Object.freeze({containerInstance:r,defaultGroupName:"@@smooth-dnd-default-group@@",wrapperClass:f,defaultGrabHandleClass:"smooth-dnd-default-grap-handle",animationClass:o,translationValue:p,visibilityValue:u,ghostClass:v,containerClass:g,extraSizeForInsertion:d,stretcherElementClass:h,stretcherElementInstance:y,isDraggableDetached:"smoth-dnd-is-draggable-detached",disbaleTouchActions:s,noUserSelectClass:c,preventAutoScrollClass:i,dropPlaceholderDefaultClass:b,dropPlaceholderInnerClass:w,dropPlaceholderWrapperClass:x,dropPlaceholderFlexContainerClass:E}),C={groupName:void 0,behaviour:"move",orientation:"vertical",getChildPayload:void 0,animationDuration:250,autoScrollEnabled:!0,shouldAcceptDrop:void 0,shouldAnimateDrop:void 0};function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function m(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function D(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}(t=l||(l={})).x="x",t.y="y",t.xy="xy";function S(e,t,n){return"x"===n?{left:Math.max(e.left,t.left),top:e.top,right:Math.min(e.right,t.right),bottom:e.bottom}:{left:e.left,top:Math.max(e.top,t.top),right:e.right,bottom:Math.min(e.bottom,t.bottom)}}function O(e){var t=window.getComputedStyle(e),n=t.overflow;if("auto"===n||"scroll"===n)return l.xy;var o=t["overflow-x"],r="auto"===o||"scroll"===o,i=t["overflow-y"],a="auto"===i||"scroll"===i;return r&&a?l.xy:r?l.x:a?l.y:null}function R(e,t){var n=window.getComputedStyle(e),o=n.overflow,r=n["overflow-".concat(t)];return"auto"===o||"scroll"===o||("auto"===r||"scroll"===r)}var A=function(e,t){return{left:Math.max(e.left,t.left),top:Math.max(e.top,t.top),right:Math.min(e.right,t.right),bottom:Math.min(e.bottom,t.bottom)}},I=function(e){var t=e.getBoundingClientRect(),n={left:t.left,right:t.right,top:t.top,bottom:t.bottom};if(P(e,"x")&&!B(e,"x")){var o=n.right-n.left;n.right=n.right+e.scrollWidth-o}if(P(e,"y")&&!B(e,"y")){var r=n.bottom-n.top;n.bottom=n.bottom+e.scrollHeight-r}return n},B=function(e,t){var n=window.getComputedStyle(e),o=n.overflow,r=n["overflow-".concat(t)];return"auto"===o||"scroll"===o||"hidden"===o||("auto"===r||"scroll"===r||"hidden"===r)},P=function(e,t){return"x"===t?e.scrollWidth>e.clientWidth:e.scrollHeight>e.clientHeight},T=function(e,t){var n=e,o=t||I(e);for(n=e.parentElement;n;)P(n,"x")&&B(n,"x")&&(o=S(o,n.getBoundingClientRect(),"x")),P(n,"y")&&B(n,"y")&&(o=S(o,n.getBoundingClientRect(),"y")),n=n.parentElement;return o},z=function(e,n){for(var o=e;o;){if(o[r]){var t=function(){var t=o[r];if(n.some(function(e){return e===t}))return{v:t}}();if("object"===a(t))return t.v}o=o.parentElement}return null},N=function(e,t){for(var n=e;n;){if(n.matches(t))return n;n=n.parentElement}return null},L=function(e,t){return-1<e.className.split(" ").map(function(e){return e}).indexOf(t)},M=function(e,t){if(e){var n=e.className.split(" ").filter(function(e){return e});-1===n.indexOf(t)&&(n.unshift(t),e.className=n.join(" "))}},j=function(e,t){if(e){var n=e.className.split(" ").filter(function(e){return e&&e!==t});e.className=n.join(" ")}},_=function(e,t){return e.removeChild(e.children[t])},F=function(e,t,n){n>=e.children.length?e.appendChild(t):e.insertBefore(t,e.children[n])},V=function(){window.getSelection?window.getSelection().empty?window.getSelection().empty():window.getSelection().removeAllRanges&&window.getSelection().removeAllRanges():window.document.selection&&window.document.selection.empty()},X=function(e){if(e){var t=window.getComputedStyle(e);if(t)return t.cursor}return null};function H(e){return!(e.bottom<=e.top||e.right<=e.left)}function Y(e){var s=e.element,c=e.draggables;return function(e,t){var n=e,o=n.removedIndex,r=n.addedIndex,i=n.droppedElement,a=null;if(null!==o&&(a=_(s,o),c.splice(o,1)),null!==r){var l=window.document.createElement("div");l.className="".concat(f),l.appendChild(a&&a.firstElementChild?a.firstElementChild:i),F(s,l,r),r>=c.length?c.push(l):c.splice(r,0,l)}t&&t(e)}}var k=Object.freeze({domDropHandler:Y,reactDropHandler:function(){return{handler:function(){return function(e,t){t&&t(e)}}}}}),G={size:"offsetWidth",distanceToParent:"offsetLeft",translate:"transform",begin:"left",end:"right",dragPosition:"x",scrollSize:"scrollWidth",offsetSize:"offsetWidth",scrollValue:"scrollLeft",scale:"scaleX",setSize:"width",setters:{translate:function(e){return"translate3d(".concat(e,"px, 0, 0)")}}},W={size:"offsetHeight",distanceToParent:"offsetTop",translate:"transform",begin:"top",end:"bottom",dragPosition:"y",scrollSize:"scrollHeight",offsetSize:"offsetHeight",scrollValue:"scrollTop",scale:"scaleY",setSize:"height",setters:{translate:function(e){return"translate3d(0,".concat(e,"px, 0)")}}};function q(n,s,e){n[d]=0;var o=function(o){return{get:function(e,t){return e[o[t]||t]},set:function(e,t,n){e[o[t]]=o.setters[t]?o.setters[t](n):n}}}("horizontal"===s?G:W),c={translation:0};function t(){r(n),function(e){var t=e.getBoundingClientRect();c.scaleX=e.offsetWidth?(t.right-t.left)/e.offsetWidth:1,c.scaleY=e.offsetHeight?(t.bottom-t.top)/e.offsetHeight:1}(n)}function r(e){c.rect=I(e);var t=T(e,c.rect);H(t)&&(c.lastVisibleRect=c.visibleRect),c.visibleRect=t}function i(e){var t=e;if(t.tagName){var n=t.getBoundingClientRect();return"vertical"===s?n.bottom-n.top:n.right-n.left}return o.get(e,"size")*o.get(c,"scale")}function a(e){return o.get(e,"dragPosition")}return window.addEventListener("resize",function(){r(n)}),setTimeout(function(){t()},10),{getSize:i,getContainerRectangles:function(){return{rect:c.rect,visibleRect:c.visibleRect,lastVisibleRect:c.lastVisibleRect}},getBeginEndOfDOMRect:function(e){return{begin:o.get(e,"begin"),end:o.get(e,"end")}},getBeginEndOfContainer:function(){return{begin:o.get(c.rect,"begin")+c.translation,end:o.get(c.rect,"end")+c.translation}},getBeginEndOfContainerVisibleRect:function(){return{begin:o.get(c.visibleRect,"begin")+c.translation,end:o.get(c.visibleRect,"end")+c.translation}},getBeginEnd:function(e){var t=function(e){return(o.get(e,"distanceToParent")+(e[p]||0))*o.get(c,"scale")}(e)+(o.get(c.rect,"begin")+c.translation)-o.get(n,"scrollValue");return{begin:t,end:t+i(e)*o.get(c,"scale")}},getAxisValue:a,setTranslation:function(e,t){t?o.set(e.style,"translate",t):e.style.removeProperty("transform"),e[p]=t},getTranslation:function(e){return e[p]},setVisibility:function(e,t){void 0!==e[u]&&e[u]===t||(t?e.style.removeProperty("visibility"):e.style.visibility="hidden",e[u]=t)},isVisible:function(e){return void 0===e[u]||e[u]},isInVisibleRect:function(e,t){var n=c.visibleRect,o=n.left,r=n.top,i=n.right,a=n.bottom;a-r<2&&(a=r+30);var l=c.rect;return"vertical"===s?e>l.left&&e<l.right&&r<t&&t<a:o<e&&e<i&&t>l.top&&t<l.bottom},setSize:function(e,t){o.set(e,"setSize",t)},getTopLeftOfElementBegin:function(e){var t=0;return{top:"horizontal"===s?(t=e,c.rect.top):(t=c.rect.left,e),left:t}},getScrollSize:function(e){return o.get(e,"scrollSize")},getScrollValue:function(e){return o.get(e,"scrollValue")},setScrollValue:function(e,t){return o.set(e,"scrollValue",t)},invalidate:t,invalidateRects:function(){r(n)},getPosition:function(e){return a(e)},setBegin:function(e,t){o.set(e,"begin",t)}}}function U(e,t,n){var o,r,i,a=n.left,l=n.right,s=n.top,c=n.bottom,u=e.x,d=e.y;if(u<a||l<u||d<s||c<d)return null;i="x"===t?(o=a,r=l,u):(o=s,r=c,d);var f=r-o,g=400<f?100:f/4;return r-i<g?{direction:"end",speedFactor:(g-(r-i))/g}:i-o<g?{direction:"begin",speedFactor:(g-(i-o))/g}:null}function J(l){var s=1<arguments.length&&void 0!==arguments[1]?arguments[1]:"y",c=null,u=null,d=null,f=null;return{animate:function(e,t){d=e,f=t,function a(){null===c&&(c=requestAnimationFrame(function(e){null===u&&(u=e);var t=e-u;u=e;var n,o,r,i=t/1e3*f;o=s,r=i="begin"===d?0-i:i,(n=l)&&(n!==window?"x"===o?n.scrollLeft+=r:n.scrollTop+=r:"x"===o?n.scrollBy(r,0):n.scrollBy(0,r)),c=null,a()}))}()},stop:function(){null!==c&&(cancelAnimationFrame(c),c=null),u=null}}}function K(e){return function(){return T(e,e.getBoundingClientRect())}}var Q,Z,$,ee=function(e){var u=1<arguments.length&&void 0!==arguments[1]?arguments[1]:1500,r=e.reduce(function(e,t){var n=function(e){for(var t=[],n=e.element;n;){var o=O(n);if(o&&!L(n,i)){var r={};switch(o){case l.xy:r.x={animator:J(n,"x")},r.y={animator:J(n,"y")};break;case l.x:r.x={animator:J(n,"x")};break;case l.y:r.y={animator:J(n,"y")}}t.push({axisAnimations:r,getRect:K(n),scrollerElement:n})}n=n.parentElement}return t}(t).filter(function(t){return!e.find(function(e){return e.scrollerElement===t.scrollerElement})});return[].concat(D(e),D(n))},[]);return function(e){var t=e.draggableInfo;if(e.reset)r.forEach(function(e){e.axisAnimations.x&&e.axisAnimations.x.animator.stop(),e.axisAnimations.y&&e.axisAnimations.y.animator.stop()});else if(t){!function(e,o){e.forEach(function(e){var t=e.axisAnimations,n=(0,e.getRect)();t.x&&(t.x.scrollParams=U(o,"x",n),e.cachedRect=n),t.y&&(t.y.scrollParams=U(o,"y",n),e.cachedRect=n)})}(r,t.mousePosition),r.forEach(function(e){var t=e.axisAnimations,n=t.x,o=t.y;if(n)if(n.scrollParams){var r=n.scrollParams,i=r.direction,a=r.speedFactor;n.animator.animate(i,a*u)}else n.animator.stop();if(o)if(o.scrollParams){var l=o.scrollParams,s=l.direction,c=l.speedFactor;o.animator.animate(s,c*u)}else o.animator.stop()});var n=r.filter(function(e){return e.cachedRect});if(n.length&&1<n.length){var o=function(e,t){for(var n=document.elementFromPoint(t.x,t.y);n;){var o=e.find(function(e){return e.scrollerElement===n});if(o)return o;n=n.parentElement}return null}(n,t.mousePosition);o&&n.forEach(function(e){e!==o&&(e.axisAnimations.x&&e.axisAnimations.x.animator.stop(),e.axisAnimations.y&&e.axisAnimations.y.animator.stop())})}}}};"undefined"!=typeof window&&((Q=Element)&&Q.prototype&&!Q.prototype.matches&&(Q.prototype.matches=Q.prototype.matchesSelector||Q.prototype.mozMatchesSelector||Q.prototype.msMatchesSelector||Q.prototype.oMatchesSelector||Q.prototype.webkitMatchesSelector||function(e){for(var t=(this.document||this.ownerDocument).querySelectorAll(e),n=t.length;0<=--n&&t.item(n)!==this;);return-1<n}),(Z=Node||Element)&&Z.prototype&&null==Z.prototype.firstElementChild&&Object.defineProperty(Z.prototype,"firstElementChild",{get:function(){for(var e,t=this.childNodes,n=0;e=t[n++];)if(1===e.nodeType)return e;return null}}),Array.prototype.some||(Array.prototype.some=function(e){if(null==this)throw new TypeError("Array.prototype.some called on null or undefined");if("function"!=typeof e)throw new TypeError;for(var t=Object(this),n=t.length>>>0,o=2<=arguments.length?arguments[1]:void 0,r=0;r<n;r++)if(r in t&&e.call(o,t[r],r,t))return!0;return!1}));var te={overflow:"hidden",display:"block"},ne={height:"100%",display:"table-cell","vertical-align":"top"},oe=(m($={},".".concat(g),{position:"relative","min-height":"30px","min-width":"30px"}),m($,".".concat(g,".horizontal"),{display:"table"}),m($,".".concat(g,".horizontal > .").concat(h),{display:"inline-block"}),m($,".".concat(g,".horizontal > .").concat(f),ne),m($,".".concat(g,".vertical > .").concat(f),te),m($,".".concat(f),{"box-sizing":"border-box"}),m($,".".concat(f,".horizontal"),ne),m($,".".concat(f,".vertical"),te),m($,".".concat(f,".animated"),{transition:"transform ease"}),m($,".".concat(v),{"box-sizing":"border-box"}),m($,".".concat(v,".animated"),{transition:"all ease-in-out"}),m($,".".concat(v," *"),{"pointer-events":"none"}),m($,".".concat(s," *"),{"touch-action":"none","-ms-touch-action":"none"}),m($,".".concat(c),{"-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}),m($,".".concat(w),{flex:"1"}),m($,".".concat(g,".horizontal > .").concat(x),{height:"100%",overflow:"hidden",display:"table-cell","vertical-align":"top"}),m($,".".concat(g,".vertical > .").concat(x),{overflow:"hidden",display:"block",width:"100%"}),m($,".".concat(E),{width:"100%",height:"100%",display:"flex","justify-content":"stretch","align-items":"stretch"}),m($,".".concat(b),{"background-color":"rgba(150, 150, 150, 0.1)",border:"1px solid #ccc"}),$);function re(o){return Object.keys(o).reduce(function(e,t){var n=o[t];return"object"===a(n)?"".concat(e).concat(t,"{").concat(re(n),"}"):"".concat(e).concat(t,":").concat(n,";")},"")}function ie(e){if(e&&"undefined"!=typeof window){var t=window.document.head||window.document.getElementsByTagName("head")[0],n=window.document.createElement("style"),o=re({"body *":{cursor:"".concat(e," !important")}});return n.type="text/css",n.styleSheet?n.styleSheet.cssText=o:n.appendChild(window.document.createTextNode(o)),t.appendChild(n),n}return null}var ae,le,se=["mousedown","touchstart"],ce=["mousemove","touchmove"],ue=["mouseup","touchend"],de=null,fe=null,ge=null,me=null,pe=[],ve=!1,he=!1,ye=!1,be=!1,we=null,xe=null,Ee=null,Ce=null,De=(ae=null,le=!1,{start:function(){le||(le=!0,function e(){ae=requestAnimationFrame(function(){de.forEach(function(e){return e.layout.invalidateRects()}),setTimeout(function(){null!==ae&&e()},50)})}())},stop:function(){null!==ae&&(cancelAnimationFrame(ae),ae=null),le=!1}}),Se="undefined"!=typeof window&&!!(window.navigator.userAgent.match(/Android/i)||window.navigator.userAgent.match(/webOS/i)||window.navigator.userAgent.match(/iPhone/i)||window.navigator.userAgent.match(/iPad/i)||window.navigator.userAgent.match(/iPod/i)||window.navigator.userAgent.match(/BlackBerry/i)||window.navigator.userAgent.match(/Windows Phone/i));function Oe(){"undefined"!=typeof window&&se.forEach(function(e){window.document.addEventListener(e,Ve,{passive:!1})})}function Re(){return me&&me.ghostParent?me.ghostParent:fe&&fe.parentElement||window.document.body}var Ae,Ie,Be,Pe,Te,ze,Ne=(Pe=null,Te=1,ze=5,function(e,t,n){Ae=Je(e),Be=n,(Ie="number"==typeof t?t:Se?200:0)&&(Pe=setTimeout(Fe,Ie)),ce.forEach(function(e){return window.document.addEventListener(e,Le)},{passive:!1}),ue.forEach(function(e){return window.document.addEventListener(e,Me)},{passive:!1}),window.document.addEventListener("drag",je,{passive:!1})});function Le(e){var t=Je(e),n=t.clientX,o=t.clientY;if(Ie)(Math.abs(Ae.clientX-n)>ze||Math.abs(Ae.clientY-o)>ze)&&_e();else if(Math.abs(Ae.clientX-n)>Te||Math.abs(Ae.clientY-o)>Te)return Fe()}function Me(){_e()}function je(){_e()}function _e(){clearTimeout(Pe),ce.forEach(function(e){return window.document.removeEventListener(e,Le)},{passive:!1}),ue.forEach(function(e){return window.document.removeEventListener(e,Me)},{passive:!1}),window.document.removeEventListener("drag",je,{passive:!1})}function Fe(){clearTimeout(Pe),_e(),Be()}function Ve(e){var t=Je(e);if(!ve&&(void 0===t.button||0===t.button)&&(fe=N(t.target,"."+f))){var n=N(fe,"."+g),o=pe.filter(function(e){return e.element===n})[0],r=o.getOptions().dragHandleSelector,i=o.getOptions().nonDragAreaSelector,a=!0;if(r&&!N(t.target,r)&&(a=!1),i&&N(t.target,i)&&(a=!1),a){o.layout.invalidate(),M(window.document.body,s),M(window.document.body,c);window.document.addEventListener("mouseup",function e(){j(window.document.body,s),j(window.document.body,c),window.document.removeEventListener("mouseup",e)})}a&&Ne(t,o.getOptions().dragBeginDelay,function(){V(),et(t,X(e.target)),ce.forEach(function(e){window.document.addEventListener(e,Xe,{passive:!1})}),ue.forEach(function(e){window.document.addEventListener(e,Ue,{passive:!1})})})}}function Xe(e){e.preventDefault();var t=Je(e);if(me){var n=me.container.getOptions();"contain"===n.behaviour?function(e){var t,n,o,r,i=e.clientX,a=e.clientY,l=1<arguments.length&&void 0!==arguments[1]?arguments[1]:"vertical",s=me.container.layout.getBeginEndOfContainerVisibleRect();r="vertical"===l?(t=a,n="y",o="top",me.size.offsetHeight):(t=i,n="x",o="left",me.size.offsetWidth);var c=s.begin,u=s.end-r,d=Math.max(c,Math.min(u,t+ge.positionDelta[o]));ge.topLeft[n]=d,me.position[n]=Math.max(s.begin,Math.min(s.end,t+ge.centerDelta[n])),me.mousePosition[n]=Math.max(s.begin,Math.min(s.end,t)),me.position[n]<s.begin+r/2&&(me.position[n]=s.begin+2),me.position[n]>s.end-r/2&&(me.position[n]=s.end-2)}(t,n.orientation):Ee?"y"===Ee?(ge.topLeft.y=t.clientY+ge.positionDelta.top,me.position.y=t.clientY+ge.centerDelta.y,me.mousePosition.y=t.clientY):"x"===Ee&&(ge.topLeft.x=t.clientX+ge.positionDelta.left,me.position.x=t.clientX+ge.centerDelta.x,me.mousePosition.x=t.clientX):(ge.topLeft.x=t.clientX+ge.positionDelta.left,ge.topLeft.y=t.clientY+ge.positionDelta.top,me.position.x=t.clientX+ge.centerDelta.x,me.position.y=t.clientY+ge.centerDelta.y,me.mousePosition.x=t.clientX,me.mousePosition.y=t.clientY),nt(),(be=!we(me))&&We()}else et(t,X(e.target))}var He,Ye,ke,Ge,We=(He=qe,ke=!(Ye=20),Ge=null,function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];Ge&&clearTimeout(Ge),ke&&!Ge?He.call.apply(He,[null].concat(t)):Ge=setTimeout(function(){Ge=null,He.call.apply(He,[null].concat(t))},Ye)});function qe(){be&&(be=!1,Ke(me,de))}function Ue(){ce.forEach(function(e){window.document.removeEventListener(e,Xe,{passive:!1})}),ue.forEach(function(e){window.document.removeEventListener(e,Ue,{passive:!1})}),xe({reset:!0}),Ce&&(function(e){e&&"undefined"!=typeof window&&(window.document.head||window.document.getElementsByTagName("head")[0]).removeChild(e)}(Ce),Ce=null),me&&(De.stop(),qe(),ye=!0,function(e){function i(){j(ge.ghost,"animated"),ge.ghost.style.transitionDuration=null,Re().removeChild(ge.ghost),e()}function t(e,t,n){var o=e.top,r=e.left;M(ge.ghost,"animated"),n&&M(ge.ghost.firstElementChild,n),ge.topLeft.x=r,ge.topLeft.y=o,nt(t),setTimeout(function(){i()},t+20)}function n(e,t){M(ge.ghost,"animated"),nt(e,.9,!0),setTimeout(function(){t()},e+20)}if(me.targetElement){var o=pe.filter(function(e){return e.element===me.targetElement})[0];if(!(p=o.getOptions()).shouldAnimateDrop||p.shouldAnimateDrop(me.container.getOptions(),me.payload))t(o.getDragResult().shadowBeginEnd.rect,Math.max(150,o.getOptions().animationDuration/2),o.getOptions().dropClass);else i()}else{var r=pe.filter(function(e){return e===me.container})[0];if(r){var a=r.getOptions(),l=a.behaviour,s=a.removeOnDropOut;if("move"!==l&&"contain"!==l||!he&&s||!r.getDragResult())n(r.getOptions().animationDuration,i);else{var c=r.layout.getContainerRectangles();if(!H(c.visibleRect)&&H(c.lastVisibleRect))t({top:c.lastVisibleRect.top,left:c.lastVisibleRect.left},r.getOptions().animationDuration,r.getOptions().dropClass);else{var u=r.getDragResult(),d=u.removedIndex,f=u.elementSize,g=r.layout;r.getTranslateCalculator({dragResult:{removedIndex:d,addedIndex:d,elementSize:f,pos:void 0,shadowBeginEnd:void 0}});var m=0<d?g.getBeginEnd(r.draggables[d-1]).end:g.getBeginEndOfContainer().begin;t(g.getTopLeftOfElementBegin(m),r.getOptions().animationDuration,r.getOptions().dropClass)}}}else n(C.animationDuration,i)}var p}(function(){$e(ve=!1);for(var e=de||[],t=e.shift();void 0!==t;)t.handleDrop(me),t=e.shift();we=Ee=me=ge=fe=de=null,ye=!1}))}function Je(e){return e.touches?e.touches[0]:e}function Ke(n,e){var o=!1;e.forEach(function(e){var t=e.handleDrag(n);o=!!t.containerBoxChanged||!1,t.containerBoxChanged=!1}),o&&(o=!1,requestAnimationFrame(function(){pe.forEach(function(e){e.layout.invalidateRects(),e.onTranslated()})}))}function Qe(e){var t=e,n=null;return function(e){return!(null!==n||!ve||ye)&&(n=requestAnimationFrame(function(){ve&&!ye&&(Ke(e,t),xe({draggableInfo:e})),n=null}),!0)}}function Ze(e,t){return e.getOptions().autoScrollEnabled?ee(t,e.getScrollMaxSpeed()):function(e){return null}}function $e(o){pe.forEach(function(e){var t=o?e.getOptions().onDragStart:e.getOptions().onDragEnd;if(t){var n={isSource:e===me.container,payload:me.payload};e.isDragRelevant(me.container,me.payload)?n.willAcceptDrop=!0:n.willAcceptDrop=!1,t(n)}})}function et(e,t){if(null!==fe){ve=!0;var n=pe.filter(function(e){return fe.parentElement===e.element})[0];n.setDraggables(),Ee=n.getOptions().lockAxis?n.getOptions().lockAxis.toLowerCase():null,me=function(t){var e=pe.filter(function(e){return t.parentElement===e.element})[0],n=e.draggables.indexOf(t),o=e.getOptions().getGhostParent,r=t.getBoundingClientRect();return{container:e,element:t,size:{offsetHeight:r.bottom-r.top,offsetWidth:r.right-r.left},elementIndex:n,payload:e.getOptions().getChildPayload?e.getOptions().getChildPayload(n):void 0,targetElement:null,position:{x:0,y:0},groupName:e.getOptions().groupName,ghostParent:o?o():null,invalidateShadow:null,mousePosition:null,relevantContainers:null}}(fe),ge=function(e,t,n,o){var r=t.x,i=t.y,a=e.getBoundingClientRect(),l=a.left,s=a.top,c=a.right,u=a.bottom,d=A(n.layout.getContainerRectangles().visibleRect,a),f=d.left+(d.right-d.left)/2,g=d.top+(d.bottom-d.top)/2,m=e.cloneNode(!0);return m.style.zIndex="1000",m.style.boxSizing="border-box",m.style.position="fixed",m.style.top="0px",m.style.left="0px",m.style.transform=null,m.style.removeProperty("transform"),n.shouldUseTransformForGhost()?m.style.transform="translate3d(".concat(l,"px, ").concat(s,"px, 0)"):(m.style.top="".concat(s,"px"),m.style.left="".concat(l,"px")),m.style.width=c-l+"px",m.style.height=u-s+"px",m.style.overflow="visible",m.style.transition=null,m.style.removeProperty("transition"),m.style.pointerEvents="none",m.style.userSelect="none",n.getOptions().dragClass?setTimeout(function(){M(m.firstElementChild,n.getOptions().dragClass);var e=window.getComputedStyle(m.firstElementChild).cursor;Ce=ie(e)}):Ce=ie(o),M(m,n.getOptions().orientation||"vertical"),M(m,v),{ghost:m,centerDelta:{x:f-r,y:g-i},positionDelta:{left:l-r,top:s-i},topLeft:{x:l,y:s}}}(fe,{x:e.clientX,y:e.clientY},me.container,t),me.position={x:e.clientX+ge.centerDelta.x,y:e.clientY+ge.centerDelta.y},me.mousePosition={x:e.clientX,y:e.clientY},de=pe.filter(function(e){return e.isDragRelevant(n,me.payload)}),me.relevantContainers=de,we=Qe(de),xe&&xe({reset:!0,draggableInfo:void 0}),xe=Ze(n,de),de.forEach(function(e){return e.prepareDrag(e,de)}),$e(!0),we(me),Re().appendChild(ge.ghost),De.start()}}var tt=null;function nt(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:1,n=2<arguments.length&&void 0!==arguments[2]&&arguments[2],o=ge,r=o.ghost,i=o.topLeft,a=i.x,l=i.y,s=!me.container||me.container.shouldUseTransformForGhost(),c=s?"translate3d(".concat(a,"px,").concat(l,"px, 0)"):null;if(1!==t&&(c=c?"".concat(c," scale(").concat(t,")"):"scale(".concat(t,")")),0<e)return ge.ghost.style.transitionDuration=e+"ms",void requestAnimationFrame(function(){c&&(r.style.transform=c),s||(r.style.left=a+"px",r.style.top=l+"px"),tt=null,n&&(r.style.opacity="0")});null===tt&&(tt=requestAnimationFrame(function(){c&&(r.style.transform=c),s||(r.style.left=a+"px",r.style.top=l+"px"),tt=null,n&&(r.style.opacity="0")}))}function ot(){if(ve&&!he&&!ye){be=!(he=!0);var t=Object.assign({},me,{targetElement:null,position:{x:Number.MAX_SAFE_INTEGER,y:Number.MAX_SAFE_INTEGER},mousePosition:{x:Number.MAX_SAFE_INTEGER,y:Number.MAX_SAFE_INTEGER}});de.forEach(function(e){e.handleDrag(t)}),me.targetElement=null,me.cancelDrop=!0,Ue(),he=!1}}"undefined"!=typeof window&&function(){if("undefined"!=typeof window){var e=window.document.head||window.document.getElementsByTagName("head")[0],t=window.document.createElement("style");t.id="smooth-dnd-style-definitions";var n=re(oe);t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(window.document.createTextNode(n)),e.appendChild(t)}}();var rt=(Oe(),{register:function(e){!function(e){pe.push(e),ve&&me&&e.isDragRelevant(me.container,me.payload)&&(de.push(e),e.prepareDrag(e,de),xe&&xe({reset:!0,draggableInfo:void 0}),xe=Ze(e,de),we=Qe(de),e.handleDrag(me))}(e)},unregister:function(e){!function(e){if(pe.splice(pe.indexOf(e),1),ve&&me){me.container===e&&e.fireRemoveElement(),me.targetElement===e.element&&(me.targetElement=null);var t=de.indexOf(e);-1<t&&(de.splice(t,1),xe&&xe({reset:!0,draggableInfo:void 0}),xe=Ze(e,de),we=Qe(de))}}(e)},isDragging:function(){return ve},cancelDrag:ot});function it(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:C.animationDuration;t?(M(e,o),e.style.transitionDuration=n+"ms"):(j(e,o),e.style.removeProperty("transition-duration"))}function at(n){var o=[];return Array.prototype.forEach.call(n.children,function(e){if(e.nodeType===Node.ELEMENT_NODE){var t=e;L(e,f)||(t=function(e){if(It.wrapChild){var t=window.document.createElement("div");return t.className="".concat(f),e.parentElement.insertBefore(t,e),t.appendChild(e),t}return e}(e)),t[p]=0,o.push(t)}else n.removeChild(e)}),o}function lt(e){var g=e.layout;return function(e,t){var n=2<arguments.length&&void 0!==arguments[2]&&arguments[2];return function e(t,n,o,r){var i=4<arguments.length&&void 0!==arguments[4]&&arguments[4];if(r<o)return o;if(o===r){var a=g.getBeginEnd(t[o]),l=a.begin,s=a.end;return i?n<(s+l)/2?o:o+1:o}var c=Math.floor((r+o)/2),u=g.getBeginEnd(t[c]),d=u.begin,f=u.end;return n<d?e(t,n,o,c-1,i):f<n?e(t,n,c+1,r,i):i?n<(f+d)/2?c:c+1:c}(e,t,0,e.length-1,n)}}function st(e){var t=e.element,n=e.draggables,o=e.layout,a=e.getOptions,l=function(e){var t=e.element,n=e.draggables,o=e.layout;return function(){n.forEach(function(e){it(e,!1),o.setTranslation(e,0),o.setVisibility(e,!0)}),t[y]&&(t[y].parentNode.removeChild(t[y]),t[y]=null)}}({element:t,draggables:n,layout:o,getOptions:a}),s=(It.dropHandler||Y)({element:t,draggables:n,layout:o,getOptions:a});return function(e,t){var n=t.addedIndex,o=t.removedIndex,r=2<arguments.length&&void 0!==arguments[2]&&arguments[2];if(l(),!e.cancelDrop&&(e.targetElement||a().removeOnDropOut||r)){var i={removedIndex:o,addedIndex:null!==n?null!==o&&o<n?n-1:n:null,payload:e.payload};s(i,a().onDrop)}}}function ct(e){var o=e.element,r=e.getOptions,i=null;return function(e){var t=e.draggableInfo,n=i;return null==i&&t.container.element===o&&"copy"!==r().behaviour&&(n=i=t.elementIndex),{removedIndex:n}}}function ut(e){var n=e.draggables,o=e.layout;return function(e){var t=e.dragResult;null!==t.removedIndex&&o.setVisibility(n[t.removedIndex],!1)}}function dt(e){var r=e.element,i=e.layout;return function(e){var t=e.draggableInfo,n=document.elementFromPoint(t.position.x,t.position.y);if(n){var o=z(n,t.relevantContainers);if(o&&o.element===r)return{pos:i.getPosition(t.position)}}return{pos:null}}}function ft(e){var n=e.layout,o=null;return function(e){var t=e.draggableInfo;return null===e.dragResult.pos?o=null:{elementSize:o=o||n.getSize(t.size)}}}function gt(e){var o=e.element;return function(e){var t=e.draggableInfo,n=e.dragResult;!function(e,t){var n=!(2<arguments.length&&void 0!==arguments[2])||arguments[2];t&&n?e.targetElement=t:e.targetElement===t&&(e.targetElement=null)}(t,o,!!n.pos)}}function mt(){return function(e){return null!==e.dragResult.pos?{addedIndex:0}:{addedIndex:null}}}function pt(e){var r=e.layout,i=null;return function(e){var t=e.dragResult.addedIndex;if(t===i)return null;i=t;var n=r.getBeginEndOfContainer(),o=n.begin;n.end;return{shadowBeginEnd:{rect:r.getTopLeftOfElementBegin(o)}}}}function vt(e){var g=e.layout,m=e.element,p=e.getOptions,v=null;return function(e){var t=e.dragResult,n=t.elementSize,o=t.shadowBeginEnd,r=t.addedIndex,i=t.dropPlaceholderContainer,a=p();if(a.dropPlaceholder){var l="boolean"==typeof a.dropPlaceholder?{}:a.dropPlaceholder,s=l.animationDuration,c=l.className,u=l.showOnTop;if(null===r)return i&&null!==v&&m.removeChild(i),v=null,{dropPlaceholderContainer:void 0};if(!i){var d=document.createElement("div"),f=document.createElement("div");f.className=E,d.className="".concat(w," ").concat(c||b),(i=document.createElement("div")).className="".concat(x),i.style.position="absolute",void 0!==s&&(i.style.transition="all ".concat(s,"ms ease")),i.appendChild(f),f.appendChild(d),g.setSize(i.style,n+"px"),i.style.pointerEvents="none",u?m.appendChild(i):m.insertBefore(i,m.firstElementChild)}return v!==r&&o.dropArea&&g.setBegin(i.style,o.dropArea.begin-g.getBeginEndOfContainer().begin+"px"),v=r,{dropPlaceholderContainer:i}}return null}}function ht(e){var o=Et(e);return function(e){var t=e.draggableInfo,n=e.dragResult;return t.invalidateShadow?o({draggableInfo:t,dragResult:n}):null}}function yt(e){var o=function(e){var i=e.draggables,a=lt({layout:e.layout});return function(e){var t=e.dragResult,n=t.shadowBeginEnd,o=t.pos;if(n)return n.begin+n.beginAdjustment<=o&&n.end>=o?null:o<n.begin+n.beginAdjustment?a(i,o):o>n.end?a(i,o)+1:i.length;var r=a(i,o,!0);return null!==r?r:i.length}}(e);return function(e){var t=e.dragResult,n=null;return null!==t.pos&&null===(n=o({dragResult:t}))&&(n=t.addedIndex),{addedIndex:n}}}function bt(){var r=null;return function(e){var t=e.dragResult,n=t.addedIndex,o=t.shadowBeginEnd;n!==r&&null!==r&&o&&(o.beginAdjustment=0),r=n}}function wt(e){var u=e.element,d=e.draggables,f=e.layout,g=e.getOptions,m=null;return function(e){var t=e.dragResult,n=t.addedIndex,o=t.removedIndex,r=t.elementSize;if(null===o)if(null!==n){if(!m){var i=f.getBeginEndOfContainer();i.end=i.begin+f.getSize(u);var a=f.getScrollSize(u)>f.getSize(u)?i.begin+f.getScrollSize(u)-f.getScrollValue(u):i.end,l=0<d.length?f.getBeginEnd(d[d.length-1]).end-d[d.length-1][p]:i.begin;if(a<l+r){(m=window.document.createElement("div")).className=h+" "+g().orientation;var s=0<d.length?r+l-a:r;return f.setSize(m.style,"".concat(s,"px")),u.appendChild(m),u[y]=m,{containerBoxChanged:!0}}}}else if(m){f.setTranslation(m,0);var c=m;return m=null,u.removeChild(c),{containerBoxChanged:!(u[y]=null)}}}}function xt(e){var s=e.draggables,c=e.layout,u=null,d=null;return function(e){var t=e.dragResult,n=t.addedIndex,o=t.removedIndex,r=t.elementSize;if(n!==u||o!==d){for(var i=0;i<s.length;i++)if(i!==o){var a=s[i],l=0;null!==o&&o<i&&(l-=r),null!==n&&n<=i&&(l+=r),c.setTranslation(a,l)}return{addedIndex:u=n,removedIndex:d=o}}}}function Et(e){var x=e.draggables,E=e.layout,C=null;return function(e){var t=e.draggableInfo,n=e.dragResult,o=n.addedIndex,r=n.removedIndex,i=n.elementSize,a=n.pos,l=n.shadowBeginEnd;if(null===a)return{shadowBeginEnd:C=null};if(null===o||!t.invalidateShadow&&o===C)return null;var s=o-1,c=Number.MIN_SAFE_INTEGER,u=0,d=0,f=null,g=null;if(s===r&&s--,-1<s){var m=E.getSize(x[s]);if(g=E.getBeginEnd(x[s]),i<m){var p=(m-i)/2;c=g.end-p}else c=g.end;u=g.end}else g={end:E.getBeginEndOfContainer().begin},u=E.getBeginEndOfContainer().begin;var v=Number.MAX_SAFE_INTEGER,h=o;if(h===r&&h++,h<x.length){var y=E.getSize(x[h]);if(f=E.getBeginEnd(x[h]),i<y){var b=(y-i)/2;v=f.begin+b}else v=f.begin;d=f.begin}else f={begin:E.getContainerRectangles().rect.end},d=E.getContainerRectangles().rect.end-E.getContainerRectangles().rect.begin;var w=g&&f?E.getTopLeftOfElementBegin(g.end):null;return C=o,{shadowBeginEnd:{dropArea:{begin:u,end:d},begin:c,end:v,rect:w,beginAdjustment:l?l.beginAdjustment:0}}}}function Ct(){var a=null;return function(e){var t=e.dragResult,n=t.pos,o=t.addedIndex,r=t.shadowBeginEnd;if(null!==n){if(null!=o&&null===a){if(n<r.begin){var i=n-r.begin-5;r.beginAdjustment=i}a=o}}else a=null}}function Dt(e){var t=e.getOptions,n=!1,o=t();return function(e){var t=!!e.dragResult.pos;t!==n&&((n=t)?o.onDragEnter&&o.onDragEnter():o.onDragLeave&&o.onDragLeave())}}function St(e){var t=e.getOptions,s=null,c=t();return function(e){var t=e.dragResult,n=t.addedIndex,o=t.removedIndex,r=e.draggableInfo,i=r.payload,a=r.element;if(c.onDropReady&&null!==n&&s!==n){var l=s=n;null!==o&&o<n&&l--,c.onDropReady({addedIndex:l,removedIndex:o,payload:i,element:a?a.firstElementChild:void 0})}}}function Ot(e){return"drop-zone"===e.getOptions().behaviour?Rt(e)(ct,ut,dt,ft,gt,mt,pt,Dt,St):Rt(e)(ct,ut,dt,ft,gt,ht,yt,bt,wt,xt,Et,vt,Ct,Dt,St)}function Rt(i){return function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];var o=t.map(function(e){return e(i)}),r=null;return function(n){return r=o.reduce(function(e,t){return Object.assign(e,t({draggableInfo:n,dragResult:e}))},r||{addedIndex:null,removedIndex:null,elementSize:null,pos:null,shadowBeginEnd:null})}}}function At(d){return function(e){var n=Object.assign({},C,e),t=null,o=null,r=function(e,t){var n=at(e),o=t();return M(e,"".concat(g," ").concat(o.orientation)),{element:e,draggables:n,getOptions:t,layout:q(e,o.orientation,o.animationDuration)}}(d,u),i=Ot(r),a=st(r),l=function(t,n){var o=[];function e(){o&&(o.forEach(function(e){return e.removeEventListener("scroll",n)}),window.removeEventListener("scroll",n))}return function(){var e=t;for(;e;)(R(e,"x")||R(e,"y"))&&o.push(e),e=e.parentElement}(),{dispose:function(){e(),o=null},start:function(){o&&(o.forEach(function(e){return e.addEventListener("scroll",n)}),window.addEventListener("scroll",n))},stop:e}}(d,function(){r.layout.invalidateRects(),s()});function s(){null!==o&&(o.invalidateShadow=!0,t=i(o),o.invalidateShadow=!1)}function c(e,t){for(var n=at(t),o=0;o<n.length;o++)e[o]=n[o];for(var r=0;r<e.length-n.length;r++)e.pop()}function u(){return n}return{element:d,draggables:r.draggables,isDragRelevant:function(e){var r=e.element,i=e.getOptions;return function(e,t){var n=i();if(n.shouldAcceptDrop)return n.shouldAcceptDrop(e.getOptions(),t);var o=e.getOptions();return"copy"!==n.behaviour&&(N(r,"."+f)!==e.element&&(e.element===r||!(!o.groupName||o.groupName!==n.groupName)))}}(r),layout:r.layout,dispose:function(e){l.dispose(),function(t){It.wrapChild&&Array.prototype.forEach.call(t.children,function(e){e.nodeType===Node.ELEMENT_NODE&&L(e,f)&&(t.insertBefore(e.firstElementChild,e),t.removeChild(e))})}(e.element)},prepareDrag:function(e,t){var n=e.element,o=r.draggables;c(o,n),e.layout.invalidateRects(),o.forEach(function(e){return it(e,!0,u().animationDuration)}),l.start()},handleDrag:function(e){return t=i(o=e)},handleDrop:function(e){l.stop(),t&&t.dropPlaceholderContainer&&d.removeChild(t.dropPlaceholderContainer),o=null,i=Ot(r),a(e,t),t=null},fireRemoveElement:function(){a(o,Object.assign({},t,{addedIndex:null}),!0),t=null},getDragResult:function(){return t},getTranslateCalculator:function(e){return xt(r)(e)},onTranslated:function(){s()},setDraggables:function(){c(r.draggables,d)},getScrollMaxSpeed:function(){return It.maxScrollSpeed},shouldUseTransformForGhost:function(){return!0===It.useTransformForGhost},getOptions:u,setOptions:function(e){var t=!(1<arguments.length&&void 0!==arguments[1])||arguments[1];n=!1===t?Object.assign({},C,e):Object.assign({},C,n,e)}}}}var It=function(e,t){var n=At(e)(t);return e[r]=n,rt.register(n),{dispose:function(){rt.unregister(n),n.dispose(n)},setOptions:function(e,t){n.setOptions(e,t)}}};function Bt(e,t,n){Object.defineProperty(e,n,{set:function(e){t[n]=e},get:function(){return t[n]}})}It.wrapChild=!0,It.cancelDrag=function(){rt.cancelDrag()},It.isDragging=function(){return rt.isDragging()};function Pt(e,t){return console.warn('default export is deprecated. please use named export "smoothDnD"'),It(e,t)}Pt.cancelDrag=function(){It.cancelDrag()},Pt.isDragging=function(){return It.isDragging()},Bt(Pt,It,"useTransformForGhost"),Bt(Pt,It,"maxScrollSpeed"),Bt(Pt,It,"wrapChild"),Bt(Pt,It,"dropHandler"),e.smoothDnD=It,e.constants=n,e.dropHandlers=k,e.default=Pt,Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2261);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsCommonHooks = __webpack_require__(1241);
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	var SlideTypesAdd = function SlideTypesAdd(_ref) {
	    var dispatch = _ref.dispatch;
	    var slideType = _ref.slideType;
	    var summaryPageIndex = _ref.summaryPageIndex;
	    var locationsListIndex = _ref.locationsListIndex;
	    var addSlideHandle = _ref.addSlideHandle;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var ddVisible = _useState2[0];
	    var setDdVisible = _useState2[1];
	
	    var summaryInfoModal = (0, _react.useRef)(null);
	    var locationListInfoModal = (0, _react.useRef)(null);
	    var slideAdd = (0, _react.useRef)(null);
	
	    function addSlideTypeHandle(e, type) {
	        if (slideType === "slideshow") {
	            // prevent duplicate dispatch
	            var mapConfigMode = "user_input";
	            dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)(mapConfigMode));
	        }
	        e.stopPropagation();
	        e.preventDefault();
	        addSlideHandle(e, type);
	        setDdVisible(false);
	    }
	    (0, _componentsCommonHooks.useOnClickOutside)(slideAdd, function () {
	        ddVisible && setDdVisible(false);
	    });
	
	    var noSumPage = summaryPageIndex === undefined;
	    var noLocationsListPage = locationsListIndex === undefined;
	    return _react2['default'].createElement(
	        _react.Fragment,
	        null,
	        _react2['default'].createElement(
	            'div',
	            { ref: slideAdd, className: 'slide slide_add' },
	            _react2['default'].createElement('i', {
	                id: 'slide-type',
	                onClick: function (e) {
	                    return noSumPage || noLocationsListPage ? setDdVisible(!ddVisible) : addSlideHandle(e, "slideshow");
	                },
	                className: 'font-icon icon-addicon'
	            }),
	            _react2['default'].createElement(_reactTooltip2['default'], { id: 'slide_add', place: 'right', type: 'dark', effect: 'solid' })
	        ),
	        _react2['default'].createElement(
	            _reactPortalTooltip2['default'],
	            {
	                group: "add-slide-type",
	                active: ddVisible, position: 'right', arrow: 'center',
	                parent: "#slide-type",
	                style: {
	                    style: {
	                        background: "white",
	                        padding: 0,
	                        boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
	                        borderRadius: 0
	                    },
	                    arrowStyle: {
	                        color: 'white',
	                        borderColor: false
	                    }
	                },
	                tooltipTimeout: 100
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'slide-types' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'slide-types__header' },
	                    'Add slide type'
	                ),
	                noSumPage && _react2['default'].createElement(
	                    'span',
	                    { className: 'slide-types__option',
	                        onClick: function (e) {
	                            return addSlideTypeHandle(e, "summary");
	                        } },
	                    'Summary slide',
	                    _react2['default'].createElement('i', { onClick: function (e) {
	                            e.stopPropagation();
	                            summaryInfoModal.current.open();
	                        },
	                        className: 'summary_info font-icon icon-infoIcon' })
	                ),
	                !noSumPage && noLocationsListPage && _react2['default'].createElement(
	                    'span',
	                    { className: 'slide-types__option',
	                        onClick: function (e) {
	                            return addSlideTypeHandle(e, "locationsList");
	                        } },
	                    'Locations List slide',
	                    _react2['default'].createElement('i', { onClick: function (e) {
	                            e.stopPropagation();
	                            locationListInfoModal.current.open();
	                        },
	                        className: 'summary_info font-icon icon-infoIcon' })
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'slide-types__option',
	                        onClick: function (e) {
	                            return addSlideTypeHandle(e, "slideshow");
	                        } },
	                    'Slide show'
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                disableCloseButton: true,
	                ref: locationListInfoModal,
	                clickButton: function () {
	                    return locationListInfoModal.current.close();
	                },
	                header: 'Locations List Slide',
	                buttonText: 'Got it',
	                buttonClass: 'btn-success',
	                entry: null
	            },
	            _react2['default'].createElement(
	                'p',
	                { style: { textAlign: "left" } },
	                'Locations List slide page will list all locations chosen on the summary slide page',
	                _react2['default'].createElement('br', null),
	                'You can delete this slide and add it later'
	            )
	        ),
	        _react2['default'].createElement(
	            _componentsCommonModal2['default'],
	            {
	                disableCloseButton: true,
	                ref: summaryInfoModal,
	                clickButton: function () {
	                    return summaryInfoModal.current.close();
	                },
	                header: 'Summary Slide',
	                buttonText: 'Got it',
	                buttonClass: 'btn-success',
	                entry: null
	            },
	            _react2['default'].createElement(
	                'p',
	                { style: { textAlign: "left" } },
	                'Summary slide page will contain overall information about the slides.',
	                _react2['default'].createElement('br', null),
	                'When using summary slide page, the locations need to be chosen in order to display on slide show, if omit, the slide show will use default locations',
	                _react2['default'].createElement('br', null),
	                'When deleting this slide, it will also delete List Slide page if exists'
	            )
	        )
	    );
	};
	
	exports['default'] = SlideTypesAdd;
	module.exports = exports['default'];

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./slideTypes.less", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./slideTypes.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".slide-types__header{margin:0 12px;padding:6px 0;line-height:20px;color:#939598;font-size:14px;font-family:GTWalsheimProBold;letter-spacing:0}.slide-types span:first-of-type{border-top:1px solid #939598}.slide-types span:first-of-type:hover{border-top-color:transparent}.slide-types__option{display:block;padding:6px 12px;cursor:pointer;line-height:20px;color:#939598;font-size:12px;letter-spacing:0}.slide-types__option:hover{background-color:#3cb449;color:#fff}.slide-types__option:hover .summary_info:before{color:#fff}.slide-types__option .summary_info{margin-left:5px;vertical-align:middle;cursor:pointer;font-size:15px}.slide-types__option .summary_info:before{color:#939598}.slide-types__option .summary_info:hover{font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsLivefeedLivefeedOptions = __webpack_require__(377);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonCustomScrollBar = __webpack_require__(2264);
	
	var _componentsCommonCustomScrollBar2 = _interopRequireDefault(_componentsCommonCustomScrollBar);
	
	var _reactTooltip = __webpack_require__(1310);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _WidgetOption = __webpack_require__(2278);
	
	var _WidgetOption2 = _interopRequireDefault(_WidgetOption);
	
	var _LocationOption = __webpack_require__(2279);
	
	var _LocationOption2 = _interopRequireDefault(_LocationOption);
	
	var _DurationOption = __webpack_require__(2284);
	
	var _DurationOption2 = _interopRequireDefault(_DurationOption);
	
	var _ScrollOption = __webpack_require__(2285);
	
	var _ScrollOption2 = _interopRequireDefault(_ScrollOption);
	
	var _SensorOption = __webpack_require__(2286);
	
	var _SensorOption2 = _interopRequireDefault(_SensorOption);
	
	var _MapConfig = __webpack_require__(2287);
	
	var _MapConfig2 = _interopRequireDefault(_MapConfig);
	
	__webpack_require__(2291);
	
	var FloorplanOptionContainer = (0, _react.forwardRef)(function (_ref, ref) {
	    var editorMode = _ref.editorMode;
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.livefeededitor;
	    });
	
	    var mapConfigMode = _useSelector.mapConfigMode;
	    var livefeedSlides = _useSelector.livefeedSlides;
	    var slideCurrentIndex = _useSelector.slideCurrentIndex;
	    var _livefeedSlides$slideCurrentIndex = livefeedSlides[slideCurrentIndex];
	    var slideType = _livefeedSlides$slideCurrentIndex.slideType;
	    var _livefeedSlides$slideCurrentIndex$floorplanOptions = _livefeedSlides$slideCurrentIndex.floorplanOptions;
	    var locationsID = _livefeedSlides$slideCurrentIndex$floorplanOptions.locationsID;
	    var slideDuration = _livefeedSlides$slideCurrentIndex$floorplanOptions.duration;
	    var widgetLabelType = _livefeedSlides$slideCurrentIndex$floorplanOptions.widgetLabelType;
	    var sensorFilterType = _livefeedSlides$slideCurrentIndex$floorplanOptions.sensorFilterType;
	    var isStandbyAsUnOccupied = _livefeedSlides$slideCurrentIndex$floorplanOptions.isStandbyAsUnOccupied;
	    var lockScroll = _livefeedSlides$slideCurrentIndex$floorplanOptions.lockScroll;
	
	    var tree = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.customerOverview;
	    });
	    var nodeMap = (0, _reactRedux.useSelector)(function (state) {
	        return state.overviewReducer.nodeMap;
	    });
	
	    // -------------- forwardRef
	    var locationOptionRef = (0, _react.useRef)(null);
	    var apiInputRef = (0, _react.useRef)(null);
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            openLocationsModal: function openLocationsModal() {
	                locationOptionRef.current.openLocationsModal();
	            },
	            focusMapApiInput: function focusMapApiInput() {
	                apiInputRef.current.focusMapApiInput();
	            }
	        };
	    });
	
	    // single option
	    var setLivefeedOptionsHandle = (0, _react.useCallback)(function (type, value) {
	        dispatch((0, _actionsLivefeedLivefeedOptions.setLivefeedOptions)(type, value));
	    }, [dispatch]);
	
	    // global option
	    var setLivefeedGlobalOptionsHandle = (0, _react.useCallback)(function (type, value) {
	        dispatch((0, _actionsLivefeedLivefeedOptions.setLivefeedGlobalOptions)(type, value));
	    }, [dispatch]);
	
	    var renderOptions = function renderOptions() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'editor-pane-container' },
	            slideType !== "summary" && slideType !== "locationsList" && _react2['default'].createElement(_MapConfig2['default'], {
	                dispatch: dispatch,
	                ref: apiInputRef,
	                mapConfigMode: mapConfigMode,
	                livefeedSlides: livefeedSlides,
	                slideCurrentIndex: slideCurrentIndex,
	                setLivefeedOptionsHandle: function (type, value) {
	                    return setLivefeedOptionsHandle(type, value);
	                },
	                setLivefeedGlobalOptionsHandle: function (mapConfig) {
	                    return setLivefeedGlobalOptionsHandle("globalMapConfig", mapConfig);
	                }
	            }),
	            slideType !== "locationsList" && _react2['default'].createElement(_LocationOption2['default'], {
	                editorMode: editorMode,
	                dispatch: dispatch,
	                nodeMap: nodeMap,
	                livefeedSlides: livefeedSlides,
	                slideType: slideType,
	                locationsID: locationsID,
	                tree: tree,
	                ref: locationOptionRef,
	                setLivefeedOptionsHandle: function (type, value) {
	                    return setLivefeedOptionsHandle(type, value);
	                }
	            }),
	            _react2['default'].createElement(_DurationOption2['default'], {
	                slideDuration: slideDuration,
	                setLivefeedOptionsHandle: function (value) {
	                    return setLivefeedOptionsHandle("slideDuration", value);
	                },
	                setLivefeedGlobalOptionsHandle: function (value) {
	                    return setLivefeedGlobalOptionsHandle("globalSlideDuration", value);
	                }
	            }),
	            slideType !== "summary" && slideType !== "locationsList" && _react2['default'].createElement(_ScrollOption2['default'], {
	                lockScroll: lockScroll,
	                setLivefeedOptionsHandle: function (value) {
	                    return setLivefeedOptionsHandle("lockscroll", value);
	                },
	                setLivefeedGlobalOptionsHandle: function (value) {
	                    return setLivefeedGlobalOptionsHandle("globalLockScroll", value);
	                }
	            }),
	            slideType !== "locationsList" && _react2['default'].createElement(_WidgetOption2['default'], {
	                widgetLabelType: widgetLabelType,
	                setLivefeedOptionsHandle: function (value) {
	                    return setLivefeedOptionsHandle("widgetLabelType", value);
	                },
	                setLivefeedGlobalOptionsHandle: function (value) {
	                    return setLivefeedGlobalOptionsHandle("globalWidget", value);
	                }
	            }),
	            slideType !== "locationsList" && _react2['default'].createElement(_SensorOption2['default'], {
	                slideType: slideType,
	                isStandbyAsUnOccupied: isStandbyAsUnOccupied,
	                sensorFilterType: sensorFilterType,
	                setLivefeedOptionsHandle: function (type, value) {
	                    return setLivefeedOptionsHandle(type, value);
	                },
	                setLivefeedGlobalOptionsHandle: function (value) {
	                    return setLivefeedGlobalOptionsHandle("globalSensorFilter", value);
	                }
	            }),
	            _react2['default'].createElement(_reactTooltip2['default'], { id: 'floorplanOptionsTooltip', place: 'top', type: 'dark', effect: 'solid' })
	        );
	    };
	    return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        slideType !== "locationsList" ? _react2['default'].createElement(
	            _componentsCommonCustomScrollBar2['default'],
	            { className: 'scrollbar-container', noScrollX: true, containerStyle: { height: 450, marginLeft: 20 } },
	            renderOptions()
	        ) : _react2['default'].createElement(
	            'div',
	            { style: { marginLeft: 20 } },
	            renderOptions()
	        )
	    );
	});
	exports['default'] = FloorplanOptionContainer;
	module.exports = exports['default'];

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScrollbarsCustom = __webpack_require__(2265);
	
	var _reactScrollbarsCustom2 = _interopRequireDefault(_reactScrollbarsCustom);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(2276);
	
	var CustomScrollBar = function CustomScrollBar(props) {
	    return _react2['default'].createElement(
	        'div',
	        { style: props.containerStyle, className: props.className },
	        _react2['default'].createElement(
	            _reactScrollbarsCustom2['default'],
	            {
	                noScrollX: props.noScrollX, noDefaultStyles: true, disableTracksWidthCompensation: true, style: { position: "" } },
	            props.children
	        )
	    );
	};
	CustomScrollBar.propTypes = {
	    children: _propTypes2['default'].any.isRequired,
	    noScrollX: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = CustomScrollBar;
	module.exports = exports['default'];

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var cnbuilder = __webpack_require__(2266);
	var React = __webpack_require__(38);
	var zoomLevel = __webpack_require__(2267);
	var reactDraggable = __webpack_require__(2268);
	
	function _interopNamespace(e) {
	    if (e && e.__esModule) return e;
	    var n = Object.create(null);
	    if (e) {
	        Object.keys(e).forEach(function (k) {
	            if (k !== 'default') {
	                var d = Object.getOwnPropertyDescriptor(e, k);
	                Object.defineProperty(n, k, d.get ? d : {
	                    enumerable: true,
	                    get: function () {
	                        return e[k];
	                    }
	                });
	            }
	        });
	    }
	    n['default'] = e;
	    return Object.freeze(n);
	}
	
	var React__namespace = /*#__PURE__*/_interopNamespace(React);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	var doc = (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object" ? document : null;
	var isUndef = function isUndef(v) {
	  return typeof v === "undefined";
	};
	var isFun = function isFun(v) {
	  return typeof v === "function";
	};
	var isNum = function isNum(v) {
	  return typeof v === "number";
	};
	/**
	 * @description Will return renderer result if presented, div element otherwise.
	 * If renderer is presented it'll receive `elementRef` function which should be used as HTMLElement's ref.
	 *
	 * @param props {ElementPropsWithElementRefAndRenderer}
	 * @param elementRef {ElementRef}
	 */
	
	var renderDivWithRenderer = function renderDivWithRenderer(props, elementRef) {
	  if (isFun(props.renderer)) {
	    props.elementRef = elementRef;
	    var renderer = props.renderer;
	    delete props.renderer;
	    return renderer(props);
	  }
	
	  delete props.elementRef;
	  return React__namespace.createElement("div", __assign({}, props, {
	    ref: elementRef
	  }));
	};
	
	var getInnerSize = function getInnerSize(el, dimension, padding1, padding2) {
	  var styles = getComputedStyle(el);
	
	  if (styles.boxSizing === "border-box") {
	    return Math.max(0, (parseFloat(styles[dimension]) || 0) - (parseFloat(styles[padding1]) || 0) - (parseFloat(styles[padding2]) || 0));
	  }
	
	  return parseFloat(styles[dimension]) || 0;
	};
	/**
	 * @description Return element's height without padding
	 */
	
	
	var getInnerHeight = function getInnerHeight(el) {
	  return getInnerSize(el, "height", "paddingTop", "paddingBottom");
	};
	/**
	 * @description Return element's width without padding
	 */
	
	var getInnerWidth = function getInnerWidth(el) {
	  return getInnerSize(el, "width", "paddingLeft", "paddingRight");
	};
	/**
	 * @description Return unique UUID v4
	 */
	
	var uuid = function uuid() {
	  var uuid = "";
	
	  for (var i = 0; i < 32; i++) {
	    if (i === 8 || i === 20) {
	      uuid += "-" + (Math.random() * 16 | 0).toString(16);
	    } else if (i === 12) {
	      uuid += "-4";
	    } else if (i === 16) {
	      uuid += "-" + (Math.random() * 16 | 0 & 3 | 8).toString(16);
	    } else {
	      uuid += (Math.random() * 16 | 0).toString(16);
	    }
	  }
	
	  return uuid;
	};
	/**
	 * @description Calculate thumb size for given viewport and track parameters
	 *
	 * @param {number} contentSize - Scrollable content size
	 * @param {number} viewportSize - Viewport size
	 * @param {number} trackSize - Track size thumb can move
	 * @param {number} minimalSize - Minimal thumb's size
	 * @param {number} maximalSize - Maximal thumb's size
	 */
	
	var calcThumbSize = function calcThumbSize(contentSize, viewportSize, trackSize, minimalSize, maximalSize) {
	  if (viewportSize >= contentSize) {
	    return 0;
	  }
	
	  var thumbSize = viewportSize / contentSize * trackSize;
	  isNum(maximalSize) && (thumbSize = Math.min(maximalSize, thumbSize));
	  isNum(minimalSize) && (thumbSize = Math.max(minimalSize, thumbSize));
	  return thumbSize;
	};
	/**
	 * @description Calculate thumb offset for given viewport, track and thumb parameters
	 *
	 * @param {number} contentSize - Scrollable content size
	 * @param {number} viewportSize - Viewport size
	 * @param {number} trackSize - Track size thumb can move
	 * @param {number} thumbSize - Thumb size
	 * @param {number} scroll - Scroll value to represent
	 */
	
	var calcThumbOffset = function calcThumbOffset(contentSize, viewportSize, trackSize, thumbSize, scroll) {
	  if (!scroll || !thumbSize || viewportSize >= contentSize) {
	    return 0;
	  }
	
	  return (trackSize - thumbSize) * scroll / (contentSize - viewportSize);
	};
	/**
	 * @description Calculate scroll for given viewport, track and thumb parameters
	 *
	 * @param {number} contentSize - Scrollable content size
	 * @param {number} viewportSize - Viewport size
	 * @param {number} trackSize - Track size thumb can move
	 * @param {number} thumbSize - Thumb size
	 * @param {number} thumbOffset - Thumb's offset representing the scroll
	 */
	
	var calcScrollForThumbOffset = function calcScrollForThumbOffset(contentSize, viewportSize, trackSize, thumbSize, thumbOffset) {
	  if (!thumbOffset || !thumbSize || viewportSize >= contentSize) {
	    return 0;
	  }
	
	  return thumbOffset * (contentSize - viewportSize) / (trackSize - thumbSize);
	};
	/**
	 * @description Returns scrollbar width specific for current environment. Can return undefined if DOM is not ready yet.
	 */
	
	var getScrollbarWidth = function getScrollbarWidth(force) {
	  if (force === void 0) {
	    force = false;
	  }
	
	  if (!doc) {
	    return getScrollbarWidth._cache = 0;
	  }
	
	  if (!force && !isUndef(getScrollbarWidth._cache)) {
	    return getScrollbarWidth._cache;
	  }
	
	  var el = doc.createElement("div");
	  el.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;");
	  doc.body.appendChild(el);
	  /* istanbul ignore next */
	
	  if (el.clientWidth === 0) {
	    // Do not even cache this value because there is no calculations. Issue https://github.com/xobotyi/react-scrollbars-custom/issues/123
	    doc.body.removeChild(el);
	    return;
	  }
	
	  getScrollbarWidth._cache = 100 - el.clientWidth;
	  doc.body.removeChild(el);
	  return getScrollbarWidth._cache;
	};
	/**
	 * @description Detect need of horizontal scroll reverse while RTL.
	 */
	
	var shouldReverseRtlScroll = function shouldReverseRtlScroll(force) {
	  if (force === void 0) {
	    force = false;
	  }
	
	  if (!force && !isUndef(shouldReverseRtlScroll._cache)) {
	    return shouldReverseRtlScroll._cache;
	  }
	
	  if (!doc) {
	    return shouldReverseRtlScroll._cache = false;
	  }
	
	  var el = doc.createElement("div");
	  var child = doc.createElement("div");
	  el.appendChild(child);
	  el.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;direction:rtl");
	  child.setAttribute("style", "width:1000px;height:1000px");
	  doc.body.appendChild(el);
	  el.scrollLeft = -50;
	  shouldReverseRtlScroll._cache = el.scrollLeft === -50;
	  doc.body.removeChild(el);
	  return shouldReverseRtlScroll._cache;
	};
	
	var Emittr = function () {
	  function Emittr(maxHandlers) {
	    if (maxHandlers === void 0) {
	      maxHandlers = 10;
	    }
	
	    this.setMaxHandlers(maxHandlers);
	    this._handlers = Object.create(null);
	  }
	
	  Emittr._callEventHandlers = function (emitter, handlers, args) {
	    if (!handlers.length) {
	      return;
	    }
	
	    if (handlers.length === 1) {
	      Reflect.apply(handlers[0], emitter, args);
	      return;
	    }
	
	    handlers = __spreadArrays(handlers);
	    var idx;
	
	    for (idx = 0; idx < handlers.length; idx++) {
	      Reflect.apply(handlers[idx], emitter, args);
	    }
	  };
	
	  Emittr.prototype.setMaxHandlers = function (count) {
	    if (!isNum(count) || count <= 0) {
	      throw new TypeError("Expected maxHandlers to be a positive number, got '" + count + "' of type " + _typeof(count));
	    }
	
	    this._maxHandlers = count;
	    return this;
	  };
	
	  Emittr.prototype.getMaxHandlers = function () {
	    return this._maxHandlers;
	  };
	
	  Emittr.prototype.emit = function (name) {
	    var args = [];
	
	    for (var _i = 1; _i < arguments.length; _i++) {
	      args[_i - 1] = arguments[_i];
	    }
	
	    if (_typeof(this._handlers[name]) !== "object" || !Array.isArray(this._handlers[name])) {
	      return false;
	    }
	
	    Emittr._callEventHandlers(this, this._handlers[name], args);
	
	    return true;
	  };
	
	  Emittr.prototype.on = function (name, handler) {
	    Emittr._addHandler(this, name, handler);
	
	    return this;
	  };
	
	  Emittr.prototype.prependOn = function (name, handler) {
	    Emittr._addHandler(this, name, handler, true);
	
	    return this;
	  };
	
	  Emittr.prototype.once = function (name, handler) {
	    if (!isFun(handler)) {
	      throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
	    }
	
	    Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler));
	
	    return this;
	  };
	
	  Emittr.prototype.prependOnce = function (name, handler) {
	    if (!isFun(handler)) {
	      throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
	    }
	
	    Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler), true);
	
	    return this;
	  };
	
	  Emittr.prototype.off = function (name, handler) {
	    Emittr._removeHandler(this, name, handler);
	
	    return this;
	  };
	
	  Emittr.prototype.removeAllHandlers = function () {
	    var handlers = this._handlers;
	    this._handlers = Object.create(null);
	    var removeHandlers = handlers["removeHandler"];
	    delete handlers["removeHandler"];
	    var idx, eventName;
	
	    for (eventName in handlers) {
	      for (idx = handlers[eventName].length - 1; idx >= 0; idx--) {
	        Emittr._callEventHandlers(this, removeHandlers, [eventName, handlers[eventName][idx].handler || handlers[eventName][idx]]);
	      }
	    }
	
	    return this;
	  };
	
	  Emittr.prototype._wrapOnceHandler = function (name, handler) {
	    var onceState = {
	      fired: false,
	      handler: handler,
	      wrappedHandler: undefined,
	      emitter: this,
	      event: name
	    };
	
	    var wrappedHandler = Emittr._onceWrapper.bind(onceState);
	
	    onceState.wrappedHandler = wrappedHandler;
	    wrappedHandler.handler = handler;
	    wrappedHandler.event = name;
	    return wrappedHandler;
	  };
	
	  Emittr._addHandler = function (emitter, name, handler, prepend) {
	    if (prepend === void 0) {
	      prepend = false;
	    }
	
	    if (!isFun(handler)) {
	      throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
	    }
	
	    emitter._handlers[name] = emitter._handlers[name] || [];
	    emitter.emit("addHandler", name, handler);
	    prepend ? emitter._handlers[name].unshift(handler) : emitter._handlers[name].push(handler);
	    return emitter;
	  };
	
	  Emittr._onceWrapper = function _onceWrapper() {
	    var args = [];
	
	    for (var _i = 0; _i < arguments.length; _i++) {
	      args[_i] = arguments[_i];
	    }
	
	    if (!this.fired) {
	      this.fired = true;
	      this.emitter.off(this.event, this.wrappedHandler);
	      Reflect.apply(this.handler, this.emitter, args);
	    }
	  };
	
	  Emittr._removeHandler = function (emitter, name, handler) {
	    if (!isFun(handler)) {
	      throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
	    }
	
	    if (isUndef(emitter._handlers[name]) || !emitter._handlers[name].length) {
	      return emitter;
	    }
	
	    var idx = -1;
	
	    if (emitter._handlers[name].length === 1) {
	      if (emitter._handlers[name][0] === handler || emitter._handlers[name][0].handler === handler) {
	        idx = 0;
	        handler = emitter._handlers[name][0].handler || emitter._handlers[name][0];
	      }
	    } else {
	      for (idx = emitter._handlers[name].length - 1; idx >= 0; idx--) {
	        if (emitter._handlers[name][idx] === handler || emitter._handlers[name][idx].handler === handler) {
	          handler = emitter._handlers[name][idx].handler || emitter._handlers[name][idx];
	          break;
	        }
	      }
	    }
	
	    if (idx === -1) {
	      return emitter;
	    }
	
	    idx === 0 ? emitter._handlers[name].shift() : emitter._handlers[name].splice(idx, 1);
	    emitter.emit("removeHandler", name, handler);
	    return emitter;
	  };
	
	  return Emittr;
	}();
	
	var RAFLoop = function () {
	  function RAFLoop() {
	    var _this = this;
	    /**
	     * @description List of targets to update
	     */
	
	
	    this.targets = [];
	    /**
	     * @description ID of requested animation frame. Valuable only if loop is active and has items to iterate.
	     */
	
	    this.animationFrameID = 0;
	    /**
	     * @description Loop's state.
	     */
	
	    this._isActive = false;
	    /**
	     * @description Start the loop if it wasn't yet.
	     */
	
	    this.start = function () {
	      if (!_this._isActive && _this.targets.length) {
	        _this._isActive = true;
	        _this.animationFrameID && cancelAnimationFrame(_this.animationFrameID);
	        _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
	      }
	
	      return _this;
	    };
	    /**
	     * @description Stop the loop if is was active.
	     */
	
	
	    this.stop = function () {
	      if (_this._isActive) {
	        _this._isActive = false;
	        _this.animationFrameID && cancelAnimationFrame(_this.animationFrameID);
	        _this.animationFrameID = 0;
	      }
	
	      return _this;
	    };
	    /**
	     * @description Add target to the iteration list if it's not there.
	     */
	
	
	    this.addTarget = function (target, silent) {
	      if (silent === void 0) {
	        silent = false;
	      }
	
	      if (_this.targets.indexOf(target) === -1) {
	        _this.targets.push(target);
	
	        _this.targets.length === 1 && !silent && _this.start();
	      }
	
	      return _this;
	    };
	    /**
	     * @description Remove target from iteration list if it was there.
	     */
	
	
	    this.removeTarget = function (target) {
	      var idx = _this.targets.indexOf(target);
	
	      if (idx !== -1) {
	        _this.targets.splice(idx, 1);
	
	        _this.targets.length === 0 && _this.stop();
	      }
	
	      return _this;
	    };
	    /**
	     * @description Callback that called each animation frame.
	     */
	
	
	    this.rafCallback = function () {
	      if (!_this._isActive) {
	        return 0;
	      }
	
	      for (var i = 0; i < _this.targets.length; i++) {
	        !_this.targets[i]._unmounted && _this.targets[i].update();
	      }
	
	      return _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
	    };
	  }
	
	  Object.defineProperty(RAFLoop.prototype, "isActive", {
	    /**
	     * @description Loop's state.
	     */
	    get: function get() {
	      return this._isActive;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  return RAFLoop;
	}();
	var Loop = new RAFLoop();
	
	var AXIS_DIRECTION;
	
	(function (AXIS_DIRECTION) {
	  AXIS_DIRECTION["X"] = "x";
	  AXIS_DIRECTION["Y"] = "y";
	})(AXIS_DIRECTION || (AXIS_DIRECTION = {}));
	
	var TRACK_CLICK_BEHAVIOR;
	
	(function (TRACK_CLICK_BEHAVIOR) {
	  TRACK_CLICK_BEHAVIOR["JUMP"] = "jump";
	  TRACK_CLICK_BEHAVIOR["STEP"] = "step";
	})(TRACK_CLICK_BEHAVIOR || (TRACK_CLICK_BEHAVIOR = {}));
	
	var ScrollbarThumb = function (_super) {
	  __extends(ScrollbarThumb, _super);
	
	  function ScrollbarThumb() {
	    var _this = _super !== null && _super.apply(this, arguments) || this;
	
	    _this.initialOffsetX = 0;
	    _this.initialOffsetY = 0;
	    _this.lastDragData = {
	      x: 0,
	      y: 0,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: 0,
	      lastY: 0
	    };
	    _this.element = null;
	    _this.elementRefHack = React__namespace.createRef();
	
	    _this.handleOnDragStart = function (ev, data) {
	      if (!_this.element) {
	        _this.handleOnDragStop(ev, data);
	
	        return;
	      }
	
	      if (global.document) {
	        _this.prevUserSelect = global.document.body.style.userSelect;
	        global.document.body.style.userSelect = "none";
	        _this.prevOnSelectStart = global.document.onselectstart;
	        global.document.onselectstart = ScrollbarThumb.selectStartReplacer;
	      }
	
	      _this.props.onDragStart && _this.props.onDragStart(_this.lastDragData = {
	        x: data.x - _this.initialOffsetX,
	        y: data.y - _this.initialOffsetY,
	        lastX: data.lastX - _this.initialOffsetX,
	        lastY: data.lastY - _this.initialOffsetY,
	        deltaX: data.deltaX,
	        deltaY: data.deltaY
	      });
	
	      _this.element.classList.add("dragging");
	    };
	
	    _this.handleOnDrag = function (ev, data) {
	      if (!_this.element) {
	        _this.handleOnDragStop(ev, data);
	
	        return;
	      }
	
	      _this.props.onDrag && _this.props.onDrag(_this.lastDragData = {
	        x: data.x - _this.initialOffsetX,
	        y: data.y - _this.initialOffsetY,
	        lastX: data.lastX - _this.initialOffsetX,
	        lastY: data.lastY - _this.initialOffsetY,
	        deltaX: data.deltaX,
	        deltaY: data.deltaY
	      });
	    };
	
	    _this.handleOnDragStop = function (ev, data) {
	      var resultData = data ? {
	        x: data.x - _this.initialOffsetX,
	        y: data.y - _this.initialOffsetY,
	        lastX: data.lastX - _this.initialOffsetX,
	        lastY: data.lastY - _this.initialOffsetY,
	        deltaX: data.deltaX,
	        deltaY: data.deltaY
	      } : _this.lastDragData;
	      _this.props.onDragEnd && _this.props.onDragEnd(resultData);
	      _this.element && _this.element.classList.remove("dragging");
	
	      if (global.document) {
	        global.document.body.style.userSelect = _this.prevUserSelect;
	        global.document.onselectstart = _this.prevOnSelectStart;
	        _this.prevOnSelectStart = null;
	      }
	
	      _this.initialOffsetX = 0;
	      _this.initialOffsetY = 0;
	      _this.lastDragData = {
	        x: 0,
	        y: 0,
	        deltaX: 0,
	        deltaY: 0,
	        lastX: 0,
	        lastY: 0
	      };
	    };
	
	    _this.handleOnMouseDown = function (ev) {
	      if (!_this.element) {
	        return;
	      }
	
	      ev.preventDefault();
	      ev.stopPropagation();
	
	      if (!isUndef(ev.offsetX)) {
	        /* istanbul ignore next */
	        _this.initialOffsetX = ev.offsetX;
	        /* istanbul ignore next */
	
	        _this.initialOffsetY = ev.offsetY;
	      } else {
	        var rect = _this.element.getBoundingClientRect();
	
	        _this.initialOffsetX = (ev.clientX || ev.touches[0].clientX) - rect.left;
	        _this.initialOffsetY = (ev.clientY || ev.touches[0].clientY) - rect.top;
	      }
	    };
	
	    _this.elementRef = function (ref) {
	      isFun(_this.props.elementRef) && _this.props.elementRef(ref);
	      _this.element = ref; // @ts-ignore
	
	      _this.elementRefHack["current"] = ref;
	    };
	
	    return _this;
	  }
	
	  ScrollbarThumb.prototype.componentDidMount = function () {
	    if (!this.element) {
	      this.setState(function () {
	        throw new Error("<ScrollbarThumb> Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	      });
	      return;
	    }
	  };
	
	  ScrollbarThumb.prototype.componentWillUnmount = function () {
	    this.handleOnDragStop();
	    this.elementRef(null);
	  };
	
	  ScrollbarThumb.prototype.render = function () {
	    var _a = this.props;
	        _a.elementRef;
	        var axis = _a.axis;
	        _a.onDrag;
	        _a.onDragEnd;
	        _a.onDragStart;
	        var props = __rest(_a, ["elementRef", "axis", "onDrag", "onDragEnd", "onDragStart"]);
	
	    props.className = cnbuilder.cnb("ScrollbarsCustom-Thumb", axis === AXIS_DIRECTION.X ? "ScrollbarsCustom-ThumbX" : "ScrollbarsCustom-ThumbY", props.className);
	
	    if (props.renderer) {
	      props.axis = axis;
	    }
	
	    return React__namespace.createElement(reactDraggable.DraggableCore, {
	      allowAnyClick: false,
	      enableUserSelectHack: false,
	      onMouseDown: this.handleOnMouseDown,
	      onDrag: this.handleOnDrag,
	      onStart: this.handleOnDragStart,
	      onStop: this.handleOnDragStop,
	      // ToDo: Fixit!
	      // react-draggable developers did not update typings so there is no appropriate prop
	      // @ts-ignore
	      nodeRef: this.elementRefHack
	    }, renderDivWithRenderer(props, this.elementRef));
	  };
	
	  ScrollbarThumb.selectStartReplacer = function () {
	    return false;
	  };
	
	  return ScrollbarThumb;
	}(React__namespace.Component);
	
	var ScrollbarTrack = function (_super) {
	  __extends(ScrollbarTrack, _super);
	
	  function ScrollbarTrack() {
	    var _this = _super !== null && _super.apply(this, arguments) || this;
	
	    _this.element = null;
	
	    _this.elementRef = function (ref) {
	      isFun(_this.props.elementRef) && _this.props.elementRef(ref);
	      _this.element = ref;
	    };
	
	    _this.handleClick = function (ev) {
	      if (!ev || !_this.element || ev.button !== 0) {
	        return;
	      }
	
	      if (isFun(_this.props.onClick) && ev.target === _this.element) {
	        if (!isUndef(ev.offsetX)) {
	          _this.props.onClick(ev, {
	            axis: _this.props.axis,
	            offset: _this.props.axis === AXIS_DIRECTION.X ? ev.offsetX : ev.offsetY
	          });
	        } else {
	          // support for old browsers
	
	          /* istanbul ignore next */
	          var rect = _this.element.getBoundingClientRect();
	          /* istanbul ignore next */
	
	
	          _this.props.onClick(ev, {
	            axis: _this.props.axis,
	            offset: _this.props.axis === AXIS_DIRECTION.X ? (ev.clientX || ev.touches[0].clientX) - rect.left : (ev.clientY || ev.touches[0].clientY) - rect.top
	          });
	        }
	      }
	
	      return true;
	    };
	
	    return _this;
	  }
	
	  ScrollbarTrack.prototype.componentDidMount = function () {
	    if (!this.element) {
	      this.setState(function () {
	        throw new Error("Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	      });
	      return;
	    }
	
	    this.element.addEventListener("click", this.handleClick);
	  };
	
	  ScrollbarTrack.prototype.componentWillUnmount = function () {
	    if (this.element) {
	      this.element.removeEventListener("click", this.handleClick);
	      this.element = null;
	      this.elementRef(null);
	    }
	  };
	
	  ScrollbarTrack.prototype.render = function () {
	    var _a = this.props;
	        _a.elementRef;
	        var axis = _a.axis;
	        _a.onClick;
	        var props = __rest(_a, ["elementRef", "axis", "onClick"]);
	
	    props.className = cnbuilder.cnb("ScrollbarsCustom-Track", axis === AXIS_DIRECTION.X ? "ScrollbarsCustom-TrackX" : "ScrollbarsCustom-TrackY", props.className);
	
	    if (props.renderer) {
	      props.axis = axis;
	    }
	
	    return renderDivWithRenderer(props, this.elementRef);
	  };
	
	  return ScrollbarTrack;
	}(React__namespace.Component);
	
	var style = {
	  holder: {
	    position: "relative",
	    width: "100%",
	    height: "100%"
	  },
	  wrapper: {
	    position: "absolute",
	    top: 0,
	    left: 0,
	    bottom: 0,
	    right: 0
	  },
	  content: {
	    boxSizing: "border-box"
	  },
	  track: {
	    common: {
	      position: "absolute",
	      overflow: "hidden",
	      borderRadius: 4,
	      background: "rgba(0,0,0,.1)",
	      userSelect: "none"
	    },
	    x: {
	      height: 10,
	      width: "calc(100% - 20px)",
	      bottom: 0,
	      left: 10
	    },
	    y: {
	      width: 10,
	      height: "calc(100% - 20px)",
	      top: 10
	    }
	  },
	  thumb: {
	    common: {
	      cursor: "pointer",
	      borderRadius: 4,
	      background: "rgba(0,0,0,.4)"
	    },
	    x: {
	      height: "100%",
	      width: 0
	    },
	    y: {
	      width: "100%",
	      height: 0
	    }
	  }
	};
	
	var pageZoomLevel = global.window ? zoomLevel.zoomLevel() : 1;
	global.window && global.window.addEventListener("resize", function () {
	  return pageZoomLevel = zoomLevel.zoomLevel();
	}, {
	  passive: true
	});
	var ScrollbarContext = React__namespace.createContext({
	  parentScrollbar: null
	});
	
	var Scrollbar = function (_super) {
	  __extends(Scrollbar, _super);
	
	  function Scrollbar(props) {
	    var _this = _super.call(this, props) || this;
	    /**
	     * @description Get current scroll-related values.<br/>
	     * If <i>force</i> if truthy - will recalculate them instead of returning cached values.
	     *
	     * @return ScrollState
	     */
	
	
	    _this.getScrollState = function (force) {
	      if (force === void 0) {
	        force = false;
	      }
	
	      if (_this.scrollValues && !force) {
	        return __assign({}, _this.scrollValues);
	      }
	
	      var scrollState = {
	        clientHeight: 0,
	        clientWidth: 0,
	        contentScrollHeight: 0,
	        contentScrollWidth: 0,
	        scrollHeight: 0,
	        scrollWidth: 0,
	        scrollTop: 0,
	        scrollLeft: 0,
	        scrollYBlocked: false,
	        scrollXBlocked: false,
	        scrollYPossible: false,
	        scrollXPossible: false,
	        trackYVisible: false,
	        trackXVisible: false,
	        zoomLevel: pageZoomLevel * 1,
	        isRTL: undefined
	      };
	      var props = _this.props;
	      scrollState.isRTL = _this.state.isRTL;
	      scrollState.scrollYBlocked = props.noScroll || props.noScrollY;
	      scrollState.scrollXBlocked = props.noScroll || props.noScrollX;
	
	      if (_this.scrollerElement) {
	        scrollState.clientHeight = _this.scrollerElement.clientHeight;
	        scrollState.clientWidth = _this.scrollerElement.clientWidth;
	        scrollState.scrollHeight = _this.scrollerElement.scrollHeight;
	        scrollState.scrollWidth = _this.scrollerElement.scrollWidth;
	        scrollState.scrollTop = _this.scrollerElement.scrollTop;
	        scrollState.scrollLeft = _this.scrollerElement.scrollLeft;
	        scrollState.scrollYPossible = !scrollState.scrollYBlocked && scrollState.scrollHeight > scrollState.clientHeight;
	        scrollState.scrollXPossible = !scrollState.scrollXBlocked && scrollState.scrollWidth > scrollState.clientWidth;
	        scrollState.trackYVisible = scrollState.scrollYPossible || props.permanentTracks || props.permanentTrackY;
	        scrollState.trackXVisible = scrollState.scrollXPossible || props.permanentTracks || props.permanentTrackX;
	      }
	
	      if (_this.contentElement) {
	        scrollState.contentScrollHeight = _this.contentElement.scrollHeight;
	        scrollState.contentScrollWidth = _this.contentElement.scrollWidth;
	      }
	
	      return scrollState;
	    };
	    /**
	     * @description Scroll to top border
	     */
	
	
	    _this.scrollToTop = function () {
	      if (_this.scrollerElement) {
	        _this.scrollerElement.scrollTop = 0;
	      }
	
	      return _this;
	    };
	    /**
	     * @description Scroll to left border
	     */
	
	
	    _this.scrollToLeft = function () {
	      if (_this.scrollerElement) {
	        _this.scrollerElement.scrollLeft = 0;
	      }
	
	      return _this;
	    };
	    /**
	     * @description Scroll to bottom border
	     */
	
	
	    _this.scrollToBottom = function () {
	      if (_this.scrollerElement) {
	        _this.scrollerElement.scrollTop = _this.scrollerElement.scrollHeight - _this.scrollerElement.clientHeight;
	      }
	
	      return _this;
	    };
	    /**
	     * @description Scroll to right border
	     */
	
	
	    _this.scrollToRight = function () {
	      if (_this.scrollerElement) {
	        _this.scrollerElement.scrollLeft = _this.scrollerElement.scrollWidth - _this.scrollerElement.clientWidth;
	      }
	
	      return _this;
	    };
	    /**
	     * @description Set the scrolls at given coordinates.<br/>
	     * If coordinate is undefined - current scroll value will persist.
	     */
	
	
	    _this.scrollTo = function (x, y) {
	      if (_this.scrollerElement) {
	        isNum(x) && (_this.scrollerElement.scrollLeft = x);
	        isNum(y) && (_this.scrollerElement.scrollTop = y);
	      }
	
	      return _this;
	    };
	    /**
	     * @description Center the viewport at given coordinates.<br/>
	     * If coordinate is undefined - current scroll value will persist.
	     */
	
	
	    _this.centerAt = function (x, y) {
	      if (_this.scrollerElement) {
	        isNum(x) && (_this.scrollerElement.scrollLeft = x - _this.scrollerElement.clientWidth / 2);
	        isNum(y) && (_this.scrollerElement.scrollTop = y - _this.scrollerElement.clientHeight / 2);
	      }
	
	      return _this;
	    };
	
	    _this.update = function (force) {
	      if (force === void 0) {
	        force = false;
	      }
	
	      if (!_this.scrollerElement) {
	        return;
	      } // autodetect direction if not defined
	
	
	      if (isUndef(_this.state.isRTL)) {
	        _this.setState({
	          isRTL: getComputedStyle(_this.scrollerElement).direction === "rtl"
	        });
	
	        return _this.getScrollState();
	      }
	
	      var scrollState = _this.getScrollState(true);
	
	      var prevScrollState = __assign({}, _this.scrollValues);
	
	      var props = _this.props;
	      var bitmask = 0;
	
	      if (!force) {
	        prevScrollState.clientHeight !== scrollState.clientHeight && (bitmask |= 1 << 0);
	        prevScrollState.clientWidth !== scrollState.clientWidth && (bitmask |= 1 << 1);
	        prevScrollState.scrollHeight !== scrollState.scrollHeight && (bitmask |= 1 << 2);
	        prevScrollState.scrollWidth !== scrollState.scrollWidth && (bitmask |= 1 << 3);
	        prevScrollState.scrollTop !== scrollState.scrollTop && (bitmask |= 1 << 4);
	        prevScrollState.scrollLeft !== scrollState.scrollLeft && (bitmask |= 1 << 5);
	        prevScrollState.scrollYBlocked !== scrollState.scrollYBlocked && (bitmask |= 1 << 6);
	        prevScrollState.scrollXBlocked !== scrollState.scrollXBlocked && (bitmask |= 1 << 7);
	        prevScrollState.scrollYPossible !== scrollState.scrollYPossible && (bitmask |= 1 << 8);
	        prevScrollState.scrollXPossible !== scrollState.scrollXPossible && (bitmask |= 1 << 9);
	        prevScrollState.trackYVisible !== scrollState.trackYVisible && (bitmask |= 1 << 10);
	        prevScrollState.trackXVisible !== scrollState.trackXVisible && (bitmask |= 1 << 11);
	        prevScrollState.isRTL !== scrollState.isRTL && (bitmask |= 1 << 12);
	        prevScrollState.contentScrollHeight !== scrollState.contentScrollHeight && (bitmask |= 1 << 13);
	        prevScrollState.contentScrollWidth !== scrollState.contentScrollWidth && (bitmask |= 1 << 14);
	        prevScrollState.zoomLevel !== scrollState.zoomLevel && (bitmask |= 1 << 15); // if not forced and nothing has changed - skip this update
	
	        if (bitmask === 0) {
	          return prevScrollState;
	        }
	      } else {
	        bitmask = 32767;
	      }
	
	      if (!props.native && _this.holderElement) {
	        if (bitmask & 1 << 13 && (props.translateContentSizesToHolder || props.translateContentSizeYToHolder)) {
	          _this.holderElement.style.height = scrollState.contentScrollHeight + "px";
	        }
	
	        if (bitmask & 1 << 14 && (props.translateContentSizesToHolder || props.translateContentSizeXToHolder)) {
	          _this.holderElement.style.width = scrollState.contentScrollWidth + "px";
	        }
	
	        if (props.translateContentSizesToHolder || props.translateContentSizeYToHolder || props.translateContentSizeXToHolder) {
	          if (!scrollState.clientHeight && scrollState.contentScrollHeight || !scrollState.clientWidth && scrollState.contentScrollWidth) {
	            return;
	          }
	        }
	      } // if scrollbars visibility has changed
	
	
	      if (bitmask & 1 << 10 || bitmask & 1 << 11) {
	        prevScrollState.scrollYBlocked = scrollState.scrollYBlocked;
	        prevScrollState.scrollXBlocked = scrollState.scrollXBlocked;
	        prevScrollState.scrollYPossible = scrollState.scrollYPossible;
	        prevScrollState.scrollXPossible = scrollState.scrollXPossible;
	
	        if (_this.trackYElement && bitmask & 1 << 10) {
	          _this.trackYElement.style.display = scrollState.trackYVisible ? "" : "none";
	        }
	
	        if (_this.trackXElement && bitmask & 1 << 11) {
	          _this.trackXElement.style.display = scrollState.trackXVisible ? "" : "none";
	        }
	
	        _this.scrollValues = prevScrollState;
	
	        _this.setState({
	          trackYVisible: _this.scrollValues.trackYVisible = scrollState.trackYVisible,
	          trackXVisible: _this.scrollValues.trackXVisible = scrollState.trackXVisible
	        });
	
	        return;
	      }
	
	      (props.native ? _this.updaterNative : _this.updaterCustom)(bitmask, scrollState);
	      _this.scrollValues = scrollState;
	
	      if (!props.native && bitmask & 1 << 15) {
	        getScrollbarWidth(true);
	
	        _this.forceUpdate();
	      }
	
	      _this.eventEmitter.emit("update", __assign({}, scrollState), prevScrollState);
	
	      (bitmask & 1 << 4 || bitmask & 1 << 5) && _this.eventEmitter.emit("scroll", __assign({}, scrollState), prevScrollState);
	      return _this.scrollValues;
	    };
	
	    _this.updaterNative = function () {
	      // just for future
	      return true;
	    };
	
	    _this.updaterCustom = function (bitmask, scrollValues) {
	      var props = _this.props;
	
	      if (_this.trackYElement) {
	        if (_this.thumbYElement && (bitmask & 1 << 0 || bitmask & 1 << 2 || bitmask & 1 << 4 || bitmask & 1 << 6 || bitmask & 1 << 8)) {
	          if (scrollValues.scrollYPossible) {
	            var trackInnerSize = getInnerHeight(_this.trackYElement);
	            var thumbSize = calcThumbSize(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, props.minimalThumbYSize || props.minimalThumbSize, props.maximalThumbYSize || props.maximalThumbSize);
	            var thumbOffset = calcThumbOffset(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, thumbSize, scrollValues.scrollTop);
	            _this.thumbYElement.style.transform = "translateY(" + thumbOffset + "px)";
	            _this.thumbYElement.style.height = thumbSize + "px";
	            _this.thumbYElement.style.display = "";
	          } else {
	            _this.thumbYElement.style.transform = "";
	            _this.thumbYElement.style.height = "0px";
	            _this.thumbYElement.style.display = "none";
	          }
	        }
	      }
	
	      if (_this.trackXElement) {
	        if (_this.thumbXElement && (bitmask & 1 << 1 || bitmask & 1 << 3 || bitmask & 1 << 5 || bitmask & 1 << 7 || bitmask & 1 << 9 || bitmask & 1 << 12)) {
	          if (scrollValues.scrollXPossible) {
	            var trackInnerSize = getInnerWidth(_this.trackXElement);
	            var thumbSize = calcThumbSize(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, props.minimalThumbXSize || props.minimalThumbSize, props.maximalThumbXSize || props.maximalThumbSize);
	            var thumbOffset = calcThumbOffset(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, thumbSize, scrollValues.scrollLeft);
	
	            if (_this.state.isRTL && shouldReverseRtlScroll()) {
	              thumbOffset += trackInnerSize - thumbSize;
	            }
	
	            _this.thumbXElement.style.transform = "translateX(" + thumbOffset + "px)";
	            _this.thumbXElement.style.width = thumbSize + "px";
	            _this.thumbXElement.style.display = "";
	          } else {
	            _this.thumbXElement.style.transform = "";
	            _this.thumbXElement.style.width = "0px";
	            _this.thumbXElement.style.display = "none";
	          }
	        }
	      }
	
	      return true;
	    };
	
	    _this.elementRefHolder = function (ref) {
	      _this.holderElement = ref;
	      isFun(_this.props.elementRef) && _this.props.elementRef(ref);
	    };
	
	    _this.elementRefWrapper = function (ref) {
	      _this.wrapperElement = ref;
	      isFun(_this.props.wrapperProps.elementRef) && _this.props.wrapperProps.elementRef(ref);
	    };
	
	    _this.elementRefScroller = function (ref) {
	      _this.scrollerElement = ref;
	      isFun(_this.props.scrollerProps.elementRef) && _this.props.scrollerProps.elementRef(ref);
	    };
	
	    _this.elementRefContent = function (ref) {
	      _this.contentElement = ref;
	      isFun(_this.props.contentProps.elementRef) && _this.props.contentProps.elementRef(ref);
	    };
	
	    _this.elementRefTrackX = function (ref) {
	      _this.trackXElement = ref;
	      isFun(_this.props.trackXProps.elementRef) && _this.props.trackXProps.elementRef(ref);
	    };
	
	    _this.elementRefTrackY = function (ref) {
	      _this.trackYElement = ref;
	      isFun(_this.props.trackYProps.elementRef) && _this.props.trackYProps.elementRef(ref);
	    };
	
	    _this.elementRefThumbX = function (ref) {
	      _this.thumbXElement = ref;
	      isFun(_this.props.thumbXProps.elementRef) && _this.props.thumbXProps.elementRef(ref);
	    };
	
	    _this.elementRefThumbY = function (ref) {
	      _this.thumbYElement = ref;
	      isFun(_this.props.thumbYProps.elementRef) && _this.props.thumbYProps.elementRef(ref);
	    };
	
	    _this.handleTrackXClick = function (ev, values) {
	      _this.props.trackXProps.onClick && _this.props.trackXProps.onClick(ev, values);
	
	      if (!_this.scrollerElement || !_this.trackXElement || !_this.thumbXElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      var thumbSize = _this.thumbXElement.clientWidth;
	      var trackInnerSize = getInnerWidth(_this.trackXElement);
	      var thumbOffset = (_this.scrollValues.isRTL && shouldReverseRtlScroll() ? values.offset + thumbSize / 2 - trackInnerSize : values.offset - thumbSize / 2) - (parseFloat(getComputedStyle(_this.trackXElement).paddingLeft) || 0);
	      var target = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, thumbOffset);
	
	      if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.STEP) {
	        target = (_this.scrollValues.isRTL ? _this.scrollValues.scrollLeft > target : _this.scrollValues.scrollLeft < target) ? _this.scrollValues.scrollLeft + _this.scrollValues.clientWidth : _this.scrollValues.scrollLeft - _this.scrollValues.clientWidth;
	      }
	
	      _this.scrollerElement.scrollLeft = target;
	    };
	
	    _this.handleTrackYClick = function (ev, values) {
	      _this.props.trackYProps.onClick && _this.props.trackYProps.onClick(ev, values);
	
	      if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      var thumbSize = _this.thumbYElement.clientHeight;
	      var target = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, getInnerHeight(_this.trackYElement), thumbSize, values.offset - thumbSize / 2) - (parseFloat(getComputedStyle(_this.trackYElement).paddingTop) || 0);
	
	      if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.JUMP) {
	        _this.scrollerElement.scrollTop = target;
	      } else {
	        _this.scrollerElement.scrollTop = _this.scrollValues.scrollTop < target ? _this.scrollValues.scrollTop + _this.scrollValues.clientHeight : _this.scrollValues.scrollTop - _this.scrollValues.clientHeight;
	      }
	    };
	
	    _this.handleTrackYMouseWheel = function (ev) {
	      var props = _this.props;
	      props.trackYProps && props.trackYProps.onWheel && props.trackYProps.onWheel(ev);
	
	      if (props.disableTracksMousewheelScrolling || props.disableTrackYMousewheelScrolling) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      if (!_this.scrollerElement || _this.scrollValues.scrollYBlocked) {
	        return;
	      }
	
	      _this.scrollTop += ev.deltaY;
	    };
	
	    _this.handleTrackXMouseWheel = function (ev) {
	      var props = _this.props;
	      props.trackXProps && props.trackXProps.onWheel && props.trackXProps.onWheel(ev);
	
	      if (props.disableTracksMousewheelScrolling || props.disableTrackXMousewheelScrolling) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      if (!_this.scrollerElement || _this.scrollValues.scrollXBlocked) {
	        return;
	      }
	
	      _this.scrollLeft += ev.deltaX;
	    };
	
	    _this.handleThumbXDrag = function (data) {
	      var _a;
	
	      if (!_this.trackXElement || !_this.thumbXElement || !_this.scrollerElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      var trackRect = _this.trackXElement.getBoundingClientRect();
	
	      var styles = getComputedStyle(_this.trackXElement);
	      var paddingLeft = parseFloat(styles.paddingLeft) || 0;
	      var paddingRight = parseFloat(styles.paddingRight) || 0;
	      var trackInnerSize = trackRect.width - paddingLeft - paddingRight;
	      var thumbSize = _this.thumbXElement.clientWidth;
	      var offset = _this.scrollValues.isRTL && shouldReverseRtlScroll() ? data.x + thumbSize - trackInnerSize + paddingLeft : data.lastX - paddingLeft;
	      _this.scrollerElement.scrollLeft = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, offset);
	
	      if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDrag) {
	        _this.props.thumbXProps.onDrag(data);
	      }
	    };
	
	    _this.handleThumbXDragEnd = function (data) {
	      var _a;
	
	      _this.handleThumbXDrag(data);
	
	      if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) {
	        _this.props.thumbXProps.onDragEnd(data);
	      }
	    };
	
	    _this.handleThumbYDrag = function (data) {
	      var _a;
	
	      if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
	        return;
	      }
	
	      _this._scrollDetection();
	
	      var trackRect = _this.trackYElement.getBoundingClientRect();
	
	      var styles = getComputedStyle(_this.trackYElement);
	      var paddingTop = parseFloat(styles.paddingTop) || 0;
	      var paddingBottom = parseFloat(styles.paddingBottom) || 0;
	      var trackInnerSize = trackRect.height - paddingTop - paddingBottom;
	      var thumbSize = _this.thumbYElement.clientHeight;
	      var offset = data.y - paddingTop;
	      _this.scrollerElement.scrollTop = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, trackInnerSize, thumbSize, offset);
	
	      if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDrag) {
	        _this.props.thumbYProps.onDrag(data);
	      }
	    };
	
	    _this.handleThumbYDragEnd = function (data) {
	      var _a;
	
	      _this.handleThumbYDrag(data);
	
	      if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) {
	        _this.props.thumbYProps.onDragEnd(data);
	      }
	    };
	
	    _this.handleScrollerScroll = function () {
	      _this._scrollDetection();
	    };
	
	    _this._scrollDetection = function () {
	      !_this._scrollDetectionTO && _this.eventEmitter.emit("scrollStart", _this.getScrollState());
	      _this._scrollDetectionTO && global.window && global.window.clearTimeout(_this._scrollDetectionTO);
	      _this._scrollDetectionTO = global.window ? global.window.setTimeout(_this._scrollDetectionCallback, _this.props.scrollDetectionThreshold || 0) : null;
	    };
	
	    _this._scrollDetectionCallback = function () {
	      _this._scrollDetectionTO = null;
	
	      _this.eventEmitter.emit("scrollStop", _this.getScrollState());
	    };
	
	    _this.state = {
	      trackXVisible: false,
	      trackYVisible: false,
	      isRTL: props.rtl
	    };
	    _this.scrollValues = _this.getScrollState(true);
	    _this.eventEmitter = new Emittr(15);
	    props.onUpdate && _this.eventEmitter.on("update", props.onUpdate);
	    props.onScroll && _this.eventEmitter.on("scroll", props.onScroll);
	    props.onScrollStart && _this.eventEmitter.on("scrollStart", props.onScrollStart);
	    props.onScrollStop && _this.eventEmitter.on("scrollStop", props.onScrollStop);
	    _this.id = uuid();
	    return _this;
	  }
	
	  Object.defineProperty(Scrollbar.prototype, "scrollTop", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.scrollTop;
	      }
	
	      return 0;
	    },
	    set: function set(top) {
	      if (this.scrollerElement) {
	        this.scrollerElement.scrollTop = top;
	        this.update();
	      }
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.scrollLeft;
	      }
	
	      return 0;
	    },
	    set: function set(left) {
	      if (this.scrollerElement) {
	        this.scrollerElement.scrollLeft = left;
	      }
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Scrollbar.prototype, "scrollHeight", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.scrollHeight;
	      }
	
	      return 0;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Scrollbar.prototype, "scrollWidth", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.scrollWidth;
	      }
	
	      return 0;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Scrollbar.prototype, "clientHeight", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.clientHeight;
	      }
	
	      return 0;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Scrollbar.prototype, "clientWidth", {
	    get: function get() {
	      if (this.scrollerElement) {
	        return this.scrollerElement.clientWidth;
	      }
	
	      return 0;
	    },
	    enumerable: false,
	    configurable: true
	  });
	
	  Scrollbar.calculateStyles = function (props, state, scrollValues, scrollbarWidth) {
	    var _a, _b, _c, _d;
	
	    var useDefaultStyles = !props.noDefaultStyles;
	    return {
	      holder: __assign(__assign(__assign({}, useDefaultStyles && style.holder), {
	        position: "relative"
	      }), props.style),
	      wrapper: __assign(__assign(__assign({}, useDefaultStyles && __assign(__assign(__assign({}, style.wrapper), !props.disableTracksWidthCompensation && !props.disableTrackYWidthCompensation && (_a = {}, _a[state.isRTL ? "left" : "right"] = state.trackYVisible ? 10 : 0, _a)), !props.disableTracksWidthCompensation && !props.disableTrackXWidthCompensation && {
	        bottom: state.trackXVisible ? 10 : 0
	      })), props.wrapperProps.style), {
	        position: "absolute",
	        overflow: "hidden"
	      }),
	      content: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.content), props.translateContentSizesToHolder || props.translateContentSizeYToHolder || props.translateContentSizeXToHolder ? {
	        display: "table-cell"
	      } : {
	        padding: 0.05
	      }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeYToHolder) && {
	        minHeight: "100%"
	      }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeXToHolder) && {
	        minWidth: "100%"
	      }), props.contentProps.style),
	      scroller: __assign(__assign(__assign(__assign((_b = {
	        position: "absolute",
	        top: 0,
	        left: 0,
	        bottom: 0,
	        right: 0,
	        paddingBottom: !scrollbarWidth && scrollValues.scrollXPossible ? props.fallbackScrollbarWidth : undefined
	      }, _b[state.isRTL ? "paddingLeft" : "paddingRight"] = !scrollbarWidth && scrollValues.scrollYPossible ? props.fallbackScrollbarWidth : undefined, _b), props.scrollerProps.style), !isUndef(props.rtl) && {
	        direction: props.rtl ? "rtl" : "ltr"
	      }), props.momentum && {
	        WebkitOverflowScrolling: "touch"
	      }), (_c = {
	        overflowY: scrollValues.scrollYPossible ? "scroll" : "hidden",
	        overflowX: scrollValues.scrollXPossible ? "scroll" : "hidden",
	        marginBottom: scrollValues.scrollXPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined
	      }, _c[state.isRTL ? "marginLeft" : "marginRight"] = scrollValues.scrollYPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined, _c)),
	      trackX: __assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.x), props.trackXProps.style), !state.trackXVisible && {
	        display: "none"
	      }),
	      trackY: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.y), useDefaultStyles && (_d = {}, _d[state.isRTL ? "left" : "right"] = 0, _d)), props.trackYProps.style), !state.trackYVisible && {
	        display: "none"
	      }),
	      thumbX: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.x), props.thumbXProps.style),
	      thumbY: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.y), props.thumbYProps.style)
	    };
	  };
	
	  Scrollbar.prototype.componentDidMount = function () {
	    if (!this.scrollerElement) {
	      this.setState(function () {
	        throw new Error("scroller element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	      });
	      return;
	    }
	
	    if (!this.contentElement) {
	      this.setState(function () {
	        throw new Error("content element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	      });
	      return;
	    }
	
	    var props = this.props;
	
	    if (!props.native && !props.mobileNative) {
	      //ToDo: move native state to the state so it can be synchronized
	      if (!this.holderElement) {
	        this.setState(function () {
	          throw new Error("holder element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	        });
	        return;
	      }
	
	      if (!this.wrapperElement) {
	        this.setState(function () {
	          throw new Error("wrapper element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
	        });
	        return;
	      }
	    }
	
	    Loop.addTarget(this);
	
	    if (!isUndef(props.scrollTop)) {
	      this.scrollerElement.scrollTop = props.scrollTop;
	    }
	
	    if (!isUndef(props.scrollLeft)) {
	      this.scrollerElement.scrollLeft = props.scrollLeft;
	    }
	
	    this.update(true);
	  };
	
	  Scrollbar.prototype.componentWillUnmount = function () {
	    Loop.removeTarget(this);
	  };
	
	  Scrollbar.prototype.componentDidUpdate = function (prevProps, prevState) {
	    if (!this.scrollerElement) {
	      return;
	    }
	
	    var props = this.props;
	
	    if (props.rtl !== prevProps.rtl && props.rtl !== this.state.isRTL) {
	      this.setState({
	        isRTL: props.rtl
	      });
	    }
	
	    if (this.state.isRTL !== prevState.isRTL) {
	      this.update();
	    }
	
	    if (!isUndef(props.scrollTop) && props.scrollTop !== this.scrollerElement.scrollTop) {
	      this.scrollerElement.scrollTop = props.scrollTop;
	    }
	
	    if (!isUndef(props.scrollLeft) && props.scrollLeft !== this.scrollerElement.scrollLeft) {
	      this.scrollerElement.scrollLeft = props.scrollLeft;
	    }
	
	    if (prevProps.onUpdate !== props.onUpdate) {
	      prevProps.onUpdate && this.eventEmitter.off("update", prevProps.onUpdate);
	      props.onUpdate && this.eventEmitter.on("update", props.onUpdate);
	    }
	
	    if (prevProps.onScroll !== props.onScroll) {
	      prevProps.onScroll && this.eventEmitter.off("scroll", prevProps.onScroll);
	      props.onScroll && this.eventEmitter.on("scroll", props.onScroll);
	    }
	
	    if (prevProps.onScrollStart !== props.onScrollStart) {
	      prevProps.onScrollStart && this.eventEmitter.off("scrollStart", prevProps.onScrollStart);
	      props.onScrollStart && this.eventEmitter.on("scrollStart", props.onScrollStart);
	    }
	
	    if (prevProps.onScrollStop !== props.onScrollStop) {
	      prevProps.onScrollStop && this.eventEmitter.off("scrollStop", prevProps.onScrollStop);
	      props.onScrollStop && this.eventEmitter.on("scrollStop", props.onScrollStop);
	    }
	  };
	
	  Scrollbar.prototype.render = function () {
	    var _a = this.props,
	        createContext = _a.createContext,
	        rtl = _a.rtl,
	        native = _a.native,
	        mobileNative = _a.mobileNative,
	        momentum = _a.momentum;
	        _a.noDefaultStyles;
	        var disableTracksMousewheelScrolling = _a.disableTracksMousewheelScrolling,
	        disableTrackXMousewheelScrolling = _a.disableTrackXMousewheelScrolling,
	        disableTrackYMousewheelScrolling = _a.disableTrackYMousewheelScrolling;
	        _a.disableTracksWidthCompensation;
	        _a.disableTrackXWidthCompensation;
	        _a.disableTrackYWidthCompensation;
	        var noScrollX = _a.noScrollX,
	        noScrollY = _a.noScrollY,
	        noScroll = _a.noScroll,
	        permanentTrackX = _a.permanentTrackX,
	        permanentTrackY = _a.permanentTrackY,
	        permanentTracks = _a.permanentTracks,
	        removeTracksWhenNotUsed = _a.removeTracksWhenNotUsed,
	        removeTrackYWhenNotUsed = _a.removeTrackYWhenNotUsed,
	        removeTrackXWhenNotUsed = _a.removeTrackXWhenNotUsed;
	        _a.minimalThumbSize;
	        _a.maximalThumbSize;
	        _a.minimalThumbXSize;
	        _a.maximalThumbXSize;
	        _a.minimalThumbYSize;
	        _a.maximalThumbYSize;
	        _a.fallbackScrollbarWidth;
	        _a.scrollTop;
	        _a.scrollLeft;
	        _a.trackClickBehavior;
	        _a.scrollDetectionThreshold;
	        var propsWrapperProps = _a.wrapperProps,
	        propsScrollerProps = _a.scrollerProps,
	        propsContentProps = _a.contentProps,
	        propsTrackXProps = _a.trackXProps,
	        propsTrackYProps = _a.trackYProps,
	        propsThumbXProps = _a.thumbXProps,
	        propsThumbYProps = _a.thumbYProps,
	        propsScrollbarWidth = _a.scrollbarWidth;
	        _a.elementRef;
	        _a.onUpdate;
	        _a.onScroll;
	        _a.onScrollStart;
	        _a.onScrollStop;
	        _a.translateContentSizesToHolder;
	        _a.translateContentSizeYToHolder;
	        _a.translateContentSizeXToHolder;
	        var children = _a.children,
	        propsHolderProps = __rest(_a, ["createContext", "rtl", "native", "mobileNative", "momentum", "noDefaultStyles", "disableTracksMousewheelScrolling", "disableTrackXMousewheelScrolling", "disableTrackYMousewheelScrolling", "disableTracksWidthCompensation", "disableTrackXWidthCompensation", "disableTrackYWidthCompensation", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "minimalThumbSize", "maximalThumbSize", "minimalThumbXSize", "maximalThumbXSize", "minimalThumbYSize", "maximalThumbYSize", "fallbackScrollbarWidth", "scrollTop", "scrollLeft", "trackClickBehavior", "scrollDetectionThreshold", "wrapperProps", "scrollerProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "scrollbarWidth", "elementRef", "onUpdate", "onScroll", "onScrollStart", "onScrollStop", "translateContentSizesToHolder", "translateContentSizeYToHolder", "translateContentSizeXToHolder", "children"]);
	
	    var scrollbarWidth = !isUndef(propsScrollbarWidth) ? propsScrollbarWidth : getScrollbarWidth() || 0;
	
	    if (native || !scrollbarWidth && mobileNative) {
	      this.elementRefHolder(null);
	      this.elementRefWrapper(null);
	      this.elementRefTrackX(null);
	      this.elementRefTrackY(null);
	      this.elementRefThumbX(null);
	      this.elementRefThumbY(null);
	
	      var contentProps_1 = __assign(__assign({}, propsContentProps), {
	        key: "ScrollbarsCustom-Content",
	        className: cnbuilder.cnb("ScrollbarsCustom-Content", propsContentProps.className),
	        children: children
	      });
	
	      var scrollerProps_1 = __assign(__assign({}, propsHolderProps), {
	        className: cnbuilder.cnb("ScrollbarsCustom native", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", propsHolderProps.className),
	        style: __assign(__assign(__assign(__assign({}, propsHolderProps.style), !isUndef(rtl) && {
	          direction: rtl ? "rtl" : "ltr"
	        }), momentum && {
	          WebkitOverflowScrolling: "touch"
	        }), {
	          overflowX: noScroll || noScrollX ? "hidden" : permanentTracks || permanentTrackX ? "scroll" : "auto",
	          overflowY: noScroll || noScrollY ? "hidden" : permanentTracks || permanentTrackY ? "scroll" : "auto"
	        }),
	        onScroll: this.handleScrollerScroll,
	        children: renderDivWithRenderer(contentProps_1, this.elementRefContent),
	        renderer: propsScrollerProps.renderer,
	        elementRef: propsScrollerProps.elementRef
	      });
	
	      return renderDivWithRenderer(scrollerProps_1, this.elementRefScroller);
	    }
	
	    var styles = Scrollbar.calculateStyles(this.props, this.state, this.scrollValues, scrollbarWidth);
	    var holderChildren = [];
	
	    var contentProps = __assign(__assign({}, propsContentProps), {
	      key: "ScrollbarsCustom-Content",
	      className: cnbuilder.cnb("ScrollbarsCustom-Content", propsContentProps.className),
	      style: styles.content,
	      children: createContext ? React__namespace.createElement(ScrollbarContext.Provider, {
	        value: {
	          parentScrollbar: this
	        },
	        children: children
	      }) : children
	    });
	
	    var scrollerProps = __assign(__assign({}, propsScrollerProps), {
	      key: "ScrollbarsCustom-Scroller",
	      className: cnbuilder.cnb("ScrollbarsCustom-Scroller", propsScrollerProps.className),
	      style: styles.scroller,
	      children: renderDivWithRenderer(contentProps, this.elementRefContent),
	      onScroll: this.handleScrollerScroll
	    });
	
	    var wrapperProps = __assign(__assign({}, propsWrapperProps), {
	      key: "ScrollbarsCustom-Wrapper",
	      className: cnbuilder.cnb("ScrollbarsCustom-Wrapper", propsWrapperProps.className),
	      style: styles.wrapper,
	      children: renderDivWithRenderer(scrollerProps, this.elementRefScroller)
	    });
	
	    holderChildren.push(renderDivWithRenderer(wrapperProps, this.elementRefWrapper));
	
	    if (this.state.trackYVisible || !removeTracksWhenNotUsed && !removeTrackYWhenNotUsed) {
	      var thumbYProps = __assign(__assign({}, propsThumbYProps), {
	        key: "ScrollbarsCustom-ThumbY",
	        style: styles.thumbY,
	        elementRef: this.elementRefThumbY,
	        onDrag: this.handleThumbYDrag,
	        onDragEnd: this.handleThumbYDragEnd,
	        axis: AXIS_DIRECTION.Y
	      });
	
	      var trackYProps = __assign(__assign(__assign(__assign({}, propsTrackYProps), {
	        key: "ScrollbarsCustom-TrackY",
	        style: styles.trackY,
	        elementRef: this.elementRefTrackY,
	        onClick: this.handleTrackYClick
	      }), (disableTracksMousewheelScrolling || disableTrackYMousewheelScrolling) && {
	        onWheel: this.handleTrackYMouseWheel
	      }), {
	        axis: AXIS_DIRECTION.Y
	      });
	
	      trackYProps.children = React__namespace.createElement(ScrollbarThumb, __assign({}, thumbYProps));
	      holderChildren.push(React__namespace.createElement(ScrollbarTrack, __assign({}, trackYProps)));
	    } else {
	      this.elementRefTrackY(null);
	      this.elementRefThumbY(null);
	    }
	
	    if (this.state.trackXVisible || !removeTracksWhenNotUsed && !removeTrackXWhenNotUsed) {
	      var thumbXProps = __assign(__assign({}, propsThumbXProps), {
	        key: "ScrollbarsCustom-ThumbX",
	        style: styles.thumbX,
	        elementRef: this.elementRefThumbX,
	        onDrag: this.handleThumbXDrag,
	        onDragEnd: this.handleThumbXDragEnd,
	        axis: AXIS_DIRECTION.X
	      });
	
	      var trackXProps = __assign(__assign(__assign(__assign({}, propsTrackXProps), {
	        key: "ScrollbarsCustom-TrackX",
	        style: styles.trackX,
	        elementRef: this.elementRefTrackX,
	        onClick: this.handleTrackXClick
	      }), (disableTracksMousewheelScrolling || disableTrackXMousewheelScrolling) && {
	        onWheel: this.handleTrackXMouseWheel
	      }), {
	        axis: AXIS_DIRECTION.X
	      });
	
	      trackXProps.children = React__namespace.createElement(ScrollbarThumb, __assign({}, thumbXProps));
	      holderChildren.push(React__namespace.createElement(ScrollbarTrack, __assign({}, trackXProps)));
	    } else {
	      this.elementRefTrackX(null);
	      this.elementRefThumbX(null);
	    }
	
	    var holderProps = __assign(__assign({}, propsHolderProps), {
	      className: cnbuilder.cnb("ScrollbarsCustom", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", propsHolderProps.className),
	      style: styles.holder,
	      children: holderChildren
	    });
	
	    return renderDivWithRenderer(holderProps, this.elementRefHolder);
	  };
	
	  Scrollbar.contextType = ScrollbarContext;
	  Scrollbar.defaultProps = {
	    momentum: true,
	    minimalThumbSize: 30,
	    fallbackScrollbarWidth: 20,
	    trackClickBehavior: TRACK_CLICK_BEHAVIOR.JUMP,
	    scrollDetectionThreshold: 100,
	    wrapperProps: {},
	    scrollerProps: {},
	    contentProps: {},
	    trackXProps: {},
	    trackYProps: {},
	    thumbXProps: {},
	    thumbYProps: {}
	  };
	  return Scrollbar;
	}(React__namespace.Component);
	
	exports.Scrollbar = Scrollbar;
	exports.ScrollbarContext = ScrollbarContext;
	exports.default = Scrollbar;
	//# sourceMappingURL=rsc.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=Array.isArray,e=function(t){if("string"==typeof t)return t;if("object"!=typeof t)return"";var n,o="";if(r(t))for(var f=0;f<t.length;)(n=e(t[f++]))&&(o+=(o&&" ")+n);else for(n in t)t[n]&&n&&(o+=(o&&" ")+n);return o};var t=/\s+/,n=Object.create,o=Array.isArray;function f(){}function i(r,e){var n;if(r)if("string"!=typeof r){if("object"==typeof r)if(o(r)){n=r.length;for(var f=0;f<n;f++)i(r[f],e)}else{var a;for(a in r)e[a]=!!r[a]}}else{n=(r=r.split(t)).length;for(var s=0;s<n;s++)e[r[s]]=!0}}f.prototype=n(null),exports.cnb=function(){for(var r,t=0,n="";t<arguments.length;)(r=e(arguments[t++]))&&(n+=(n&&" ")+r);return n},exports.dcnb=function(){for(var r=new f,e=0;e<arguments.length;)i(arguments[e++],r);var t="";for(e in r)r[e]&&e&&(t+=(t&&" ")+e);return t};


/***/ }),
/* 2267 */
/***/ (function(module, exports) {

	"use strict";function e(e,o,t,i){for(;o>=t&&!e("(min-resolution: "+o/i+"dppx)").matches;)o--;return o}function o(o){if(void 0===o&&(o=window),!o)return 1;if(void 0!==o.devicePixelRatio)return o.devicePixelRatio;var t=o.document.frames;return void 0!==t?void 0!==t.devicePixelRatio?t.devicePixelRatio:t.screen.deviceXDPI/t.screen.systemXDPI:void 0!==o.matchMedia?function(o){for(var t=o.matchMedia,i=10,r=.1,n=1,c=i,d=0;d<4;d++)i=(c=10*e(t,i,r,n))+9,r=c,n*=10;return c/n}(o):1}Object.defineProperty(exports,"__esModule",{value:!0}),exports.elementZoomLevel=function(e,t){var i=(e instanceof Element?getComputedStyle(e).zoom:e.zoom)||1;return o(t)*("string"==typeof i?parseFloat(i):i)},exports.zoomLevel=o;


/***/ }),
/* 2268 */
[2371, 2269],
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function get() {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(53));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	var _clsx2 = _interopRequireDefault(__webpack_require__(1954));
	
	var _domFns = __webpack_require__(2270);
	
	var _positionFns = __webpack_require__(2273);
	
	var _shims = __webpack_require__(2271);
	
	var _DraggableCore = _interopRequireDefault(__webpack_require__(2274));
	
	var _log = _interopRequireDefault(__webpack_require__(2275));
	
	var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//
	// Define <Draggable>
	//
	var Draggable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  var _super = _createSuper(Draggable);
	
	  function Draggable(props
	  /*: DraggableProps*/
	  ) {
	    var _this;
	
	    _classCallCheck(this, Draggable);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
	
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
	
	
	      if (shouldStart === false) return false;
	
	      _this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        x: uiData.x,
	        y: uiData.y
	      }; // Keep within bounds.
	
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var x = newState.x,
	            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
	
	        newState.slackX = _this.state.slackX + (x - newState.x);
	        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
	
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      } // Short-circuit if user's callback killed it.
	
	
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
	      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
	
	      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));
	
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      }; // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	
	      var controlled = Boolean(_this.props.position);
	
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            x = _this$props$position.x,
	            y = _this$props$position.y;
	        newState.x = x;
	        newState.y = y;
	      }
	
	      _this.setState(newState);
	    });
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: _objectSpread({}, props.position),
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	        this.setState({
	          isElementSVG: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        dragging: false
	      }); // prevents invariant if unmounted while dragging
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: ReactElement<any>*/
	    {
	      var _clsx;
	
	      var _this$props2 = this.props,
	          axis = _this$props2.axis,
	          bounds = _this$props2.bounds,
	          children = _this$props2.children,
	          defaultPosition = _this$props2.defaultPosition,
	          defaultClassName = _this$props2.defaultClassName,
	          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
	          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
	          position = _this$props2.position,
	          positionOffset = _this$props2.positionOffset,
	          scale = _this$props2.scale,
	          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
	
	      var style = {};
	      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
	
	      var controlled = Boolean(position);
	      var draggable = !controlled || this.state.dragging;
	      var validPosition = position || defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	      }; // If this element was SVG, we use the `transform` attribute.
	
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	      } // Mark with class while dragging
	
	
	      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	
	      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	        onStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onStop: this.onDragStop
	      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	        className: className,
	        style: _objectSpread(_objectSpread({}, children.props.style), style),
	        transform: svgTransform
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: // React 16.3+
	    // Arity (props, state)
	    function getDerivedStateFromProps(_ref, _ref2)
	    /*: ?$Shape<DraggableState>*/
	    {
	      var position = _ref.position;
	      var prevPropsPosition = _ref2.prevPropsPosition;
	
	      // Set x/y if a new position is provided in props that is different than the previous.
	      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	          position: position,
	          prevPropsPosition: prevPropsPosition
	        });
	        return {
	          x: position.x,
	          y: position.y,
	          prevPropsPosition: _objectSpread({}, position)
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	exports.default = Draggable;
	
	_defineProperty(Draggable, "displayName", 'Draggable');
	
	_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	}));
	
	_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}));

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addClassName = addClassName;
	exports.addEvent = addEvent;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.getTranslation = getTranslation;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.removeClassName = removeClassName;
	exports.removeEvent = removeEvent;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	
	var _shims = __webpack_require__(2271);
	
	var _getPrefix = _interopRequireWildcard(__webpack_require__(2272));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var matchesSelectorFunc = '';
	
	function matchesSelector(el
	/*: Node*/
	, selector
	/*: string*/
	)
	/*: boolean*/
	{
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  } // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	
	
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
	
	  return el[matchesSelectorFunc](selector);
	} // Works up the tree to the draggable itself attempting to match selector.
	
	
	function matchesSelectorAndParentsTo(el
	/*: Node*/
	, selector
	/*: string*/
	, baseNode
	/*: Node*/
	)
	/*: boolean*/
	{
	  var node = el;
	
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.addEventListener) {
	    el.addEventListener(event, handler, options);
	  } else if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.removeEventListener) {
	    el.removeEventListener(event, handler, options);
	  } else if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	
	function innerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	/*:: interface EventWithOffset {
	  clientX: number, clientY: number
	}*/
	
	
	// Get from offsetParent
	function offsetXYFromParent(evt
	/*: EventWithOffset*/
	, offsetParent
	/*: HTMLElement*/
	, scale
	/*: number*/
	)
	/*: ControlPosition*/
	{
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
	  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
	  return {
	    x: x,
	    y: y
	  };
	}
	
	function createCSSTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: Object*/
	{
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
	}
	
	function createSVGTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: string*/
	{
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	
	function getTranslation(_ref2, positionOffset
	/*: PositionOffsetControlPosition*/
	, unitSuffix
	/*: string*/
	)
	/*: string*/
	{
	  var x = _ref2.x,
	      y = _ref2.y;
	  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
	
	  if (positionOffset) {
	    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
	  }
	
	  return translation;
	}
	
	function getTouch(e
	/*: MouseTouchEvent*/
	, identifier
	/*: number*/
	)
	/*: ?{clientX: number, clientY: number}*/
	{
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e
	/*: MouseTouchEvent*/
	)
	/*: ?number*/
	{
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	} // User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	// Note we're passing `document` b/c we could be iframed
	
	
	function addUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	
	  try {
	    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
	
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      // Remove selection caused by scroll, unless it's a focused input
	      // (we use doc.defaultView in case we're in an iframe)
	      var selection = (doc.defaultView || window).getSelection();
	
	      if (selection && selection.type !== 'Caret') {
	        selection.removeAllRanges();
	      }
	    }
	  } catch (e) {// probably IE
	  }
	}
	
	function addClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
	      el.className += " ".concat(className);
	    }
	  }
	}
	
	function removeClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
	  }
	}

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dontSetMe = dontSetMe;
	exports.findInArray = findInArray;
	exports.int = int;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array
	/*: Array<any> | TouchList*/
	, callback
	/*: Function*/
	)
	/*: any*/
	{
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  // $FlowIgnore[method-unbinding]
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a
	/*: string*/
	)
	/*: number*/
	{
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props
	/*: Object*/
	, propName
	/*: string*/
	, componentName
	/*: string*/
	)
	/*: ?Error*/
	{
	  if (props[propName]) {
	    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
	  }
	}

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	exports.default = void 0;
	exports.getPrefix = getPrefix;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	
	function getPrefix()
	/*: string*/
	{
	  var _window$document, _window$document$docu;
	
	  var prop
	  /*: string*/
	  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	  // Ensure we're running in an environment where there is actually a global
	  // `window` obj
	  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
	  // path may not exist, so bail out if it doesn't.
	
	  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
	  if (!style) return '';
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
	}
	
	function browserPrefixToStyle(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
	}
	
	function kebabToTitleCase(str
	/*: string*/
	)
	/*: string*/
	{
	  var out = '';
	  var shouldCapitalize = true;
	
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	
	  return out;
	} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	
	
	var _default = (getPrefix()
	/*: string*/
	);
	
	exports.default = _default;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	exports.getBoundPosition = getBoundPosition;
	exports.getControlPosition = getControlPosition;
	exports.snapToGrid = snapToGrid;
	
	var _shims = __webpack_require__(2271);
	
	var _domFns = __webpack_require__(2270);
	
	function getBoundPosition(draggable
	/*: Draggable*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: [number, number]*/
	{
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y]; // Clone new bounds
	
	  var bounds = draggable.props.bounds;
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode;
	
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	
	    var boundNodeEl
	    /*: HTMLElement*/
	    = boundNode; // for Flow, can't seem to refine correctly
	
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  } // Keep x and y below right and bottom limits...
	
	
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
	
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	  return [x, y];
	}
	
	function snapToGrid(grid
	/*: [number, number]*/
	, pendingX
	/*: number*/
	, pendingY
	/*: number*/
	)
	/*: [number, number]*/
	{
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	} // Get {x, y} positions from event.
	
	
	function getControlPosition(e
	/*: MouseTouchEvent*/
	, touchIdentifier
	/*: ?number*/
	, draggableCore
	/*: DraggableCore*/
	)
	/*: ?ControlPosition*/
	{
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	
	  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.
	
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
	} // Create an data object exposed by <DraggableCore>'s events
	
	
	function createCoreData(draggable
	/*: DraggableCore*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: DraggableData*/
	{
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX,
	      deltaY: y - state.lastY,
	      lastX: state.lastX,
	      lastY: state.lastY,
	      x: x,
	      y: y
	    };
	  }
	} // Create an data exposed by <Draggable>'s events
	
	
	function createDraggableData(draggable
	/*: Draggable*/
	, coreData
	/*: DraggableData*/
	)
	/*: DraggableData*/
	{
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	} // A lot faster than stringify/parse
	
	
	function cloneBounds(bounds
	/*: Bounds*/
	)
	/*: Bounds*/
	{
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable
	/*: Draggable | DraggableCore*/
	)
	/*: HTMLElement*/
	{
	  var node = draggable.findDOMNode();
	
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	
	
	  return node;
	}

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(38));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(53));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(41));
	
	var _domFns = __webpack_require__(2270);
	
	var _positionFns = __webpack_require__(2273);
	
	var _shims = __webpack_require__(2271);
	
	var _log = _interopRequireDefault(__webpack_require__(2275));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Simple abstraction for dragging events names.
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	}; // Default to mouse events.
	
	var dragEventFor = eventsFor.mouse;
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
	
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	/*:: export type DraggableCoreDefaultProps = {
	  allowAnyClick: boolean,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	  scale: number,
	};*/
	
	/*:: export type DraggableCoreProps = {
	  ...DraggableCoreDefaultProps,
	  cancel: string,
	  children: ReactElement<any>,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  nodeRef?: ?React.ElementRef<any>,
	};*/
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	var DraggableCore = /*#__PURE__*/function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  var _super = _createSuper(DraggableCore);
	
	  function DraggableCore() {
	    var _this;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN,
	      lastY: NaN,
	      touchIdentifier: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e); // Only accept left-clicks.
	
	
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
	
	      var thisNode = _this.findDOMNode();
	
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	
	      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      } // Prevent scrolling on mobile devices, like ipad/iphone.
	      // Important that this is after handle/cancel.
	
	
	      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	
	      _this.setState({
	        touchIdentifier: touchIdentifier
	      }); // Get the current drag point from the event. This is used as the offset.
	
	
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
	
	      (0, _log.default)('calling', _this.props.onStart);
	
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	
	      _this.setState({
	        dragging: true,
	        lastX: x,
	        lastY: y
	      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	
	
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX,
	            deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        deltaX = _snapToGrid2[0];
	        deltaY = _snapToGrid2[1];
	        if (!deltaX && !deltaY) return; // skip useless drag
	
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
	
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents')
	          /*: any*/
	          )
	          /*: MouseTouchEvent*/
	          ); // I see why this insanity was deprecated
	          // $FlowIgnore
	
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	          _this.handleDragStop(event);
	        }
	
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
	      if (!_this.state.dragging) return;
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX || 0;
	        var deltaY = y - _this.state.lastY || 0;
	
	        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);
	
	        deltaX = _snapToGrid4[0];
	        deltaY = _snapToGrid4[1];
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler
	
	      var shouldContinue = _this.props.onStop(e, coreEvent);
	
	      if (shouldContinue === false || _this.mounted === false) return false;
	
	      var thisNode = _this.findDOMNode();
	
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
	
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
	      dragEventFor = eventsFor.mouse;
	      return _this.handleDragStop(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStop(e);
	    });
	
	    return _this;
	  }
	
	  _createClass(DraggableCore, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
	      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props, _this$props2, _this$props2$nodeRef;
	
	      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: React.Element<any>*/
	    {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onMouseUp: this.onMouseUp,
	        // onTouchStart is added on `componentDidMount` so they can be added with
	        // {passive: false}, which allows it to cancel. See
	        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(React.Component);
	
	exports.default = DraggableCore;
	
	_defineProperty(DraggableCore, "displayName", 'DraggableCore');
	
	_defineProperty(DraggableCore, "propTypes", {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props
	  /*: DraggableCoreProps*/
	  , propName
	  /*: $Keys<DraggableCoreProps>*/
	  ) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes.default.string,
	
	  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
	   * Unfortunately, in order for <Draggable> to work properly, we need raw access
	   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
	   * as in this example:
	   *
	   * function MyComponent() {
	   *   const nodeRef = React.useRef(null);
	   *   return (
	   *     <Draggable nodeRef={nodeRef}>
	   *       <div ref={nodeRef}>Example Target</div>
	   *     </Draggable>
	   *   );
	   * }
	   *
	   * This can be used for arbitrarily nested components, so long as the ref ends up
	   * pointing to the actual child DOM node and not a custom component.
	   */
	  nodeRef: _propTypes.default.object,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * `scale`, if set, applies scaling while dragging an element
	   */
	  scale: _propTypes.default.number,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	
	_defineProperty(DraggableCore, "defaultProps", {
	  allowAnyClick: false,
	  // by default only accept left click
	  disabled: false,
	  enableUserSelectHack: true,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {},
	  scale: 1
	});

/***/ }),
/* 2275 */
1960,
/* 2276 */
[2370, 2277],
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".scrollbar-container{padding-top:6px;display:inline-grid;grid-template-columns:260px;color:#000;position:relative;vertical-align:middle}.scrollbar-container .ScrollbarsCustom{max-width:calc(100% - 2rem);max-height:43rem;margin-right:2rem;margin-bottom:2rem}.scrollbar-container .ScrollbarsCustom-Wrapper{top:0;right:0;bottom:0;left:0}.scrollbar-container .ScrollbarsCustom-Wrapper .ScrollbarsCustom-Scroller .ScrollbarsCustom-Content{display:table-cell;padding:.05px}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-Track{position:absolute;border-radius:.25rem}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-Thumb{background:#c8c8c8;cursor:pointer;border-radius:20px}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-Thumb.dragging,.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-Thumb:hover{background:#aeaeae}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-ThumbY{width:100%}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-ThumbX{height:100%}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-TrackY{width:1rem;height:calc(100% - 2rem);top:1rem;right:-2rem;background:hsla(0,0%,100%,.04)}.scrollbar-container .ScrollbarsCustom .ScrollbarsCustom-TrackX{height:1rem;width:calc(100% - 2rem);bottom:-2rem;left:1rem;background:hsla(0,0%,100%,.04)}", ""]);
	
	// exports


/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	var _componentsCommonCustomTickBox = __webpack_require__(1925);
	
	var _componentsCommonCustomTickBox2 = _interopRequireDefault(_componentsCommonCustomTickBox);
	
	var WidgetOption = function WidgetOption(props) {
	    var widgetLabelType = props.widgetLabelType;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var setLivefeedGlobalOptionsHandle = props.setLivefeedGlobalOptionsHandle;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var globalWidget = _useState2[0];
	    var setGlobalWidget = _useState2[1];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'gauge-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                'WIDGET'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'editor-text grid-item grid-item__title',
	                    'data-tip': 'Option to choose the number of available units either as one figure ("50") or two ("50/75").',
	                    'data-for': 'floorplanOptionsTooltip',
	                    style: { whiteSpace: "normal" } },
	                'Show available rooms/desks'
	            ),
	            _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item ' },
	                    _react2['default'].createElement(_componentsCommonCustomTickBox2['default'], {
	                        className: 'widget-label-setting',
	                        onClick: function () {
	                            /* if globalWidget is enabled, then when the widgetLabelType is modified, set globalWidget to be false*/
	                            globalWidget === true && setGlobalWidget(false);
	                            setLivefeedOptionsHandle(!widgetLabelType);
	                        },
	                        label: 'Including total value ( 50/100 )',
	                        isActive: widgetLabelType
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item global-toggle-item' },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            'data-for': 'floorplanOptionsTooltip',
	                            style: { whiteSpace: "normal" },
	                            'data-tip': 'Apply this setting to all slides',
	                            className: 'global-option-toggle',
	                            onClick: function () {
	                                setGlobalWidget(!globalWidget);
	                                setLivefeedGlobalOptionsHandle(widgetLabelType);
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'toggle-text' },
	                            'Apply to all slides'
	                        ),
	                        _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: globalWidget })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports['default'] = WidgetOption;
	module.exports = exports['default'];

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2280);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _CheckBoxTreeLocation = __webpack_require__(2282);
	
	var _CheckBoxTreeLocation2 = _interopRequireDefault(_CheckBoxTreeLocation);
	
	var _componentsPagesLivefeedEditorEditorContainerCommonCommonFn = __webpack_require__(1929);
	
	var _actionsLivefeed = __webpack_require__(366);
	
	var LocationOption = _react2['default'].forwardRef(function (props, ref) {
	    var editorMode = props.editorMode;
	    var dispatch = props.dispatch;
	    var nodeMap = props.nodeMap;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var tree = props.tree;
	    var livefeedSlides = props.livefeedSlides;
	    var slideType = props.slideType;
	    var locationsID = props.locationsID;
	
	    var locationOptionRef = (0, _react.useRef)(null);
	    var treeLocationModal = (0, _react.useRef)(null);
	
	    var _React$useState = _react2['default'].useState([]);
	
	    var _React$useState2 = _slicedToArray(_React$useState, 2);
	
	    var summaryLocationsID = _React$useState2[0];
	    var setSummaryLocationsID = _React$useState2[1];
	
	    var _useState = (0, _react.useState)(null);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var sumPageIndex = _useState2[0];
	    var setSumPageIndex = _useState2[1];
	
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            openLocationsModal: function openLocationsModal() {
	                _openLocationsModal();
	            }
	        };
	    });
	    function _openLocationsModal() {
	        treeLocationModal.current.open();
	    }
	
	    var arrLocations = [];
	    (0, _componentsPagesLivefeedEditorEditorContainerCommonCommonFn.constructOptions)(tree, arrLocations);
	
	    // the value is always from summary page
	    //summaryLocationsID is use for slideShow page
	
	    (0, _react.useEffect)(function () {
	        var hasSummaryPage = false;
	        var locationsID = [];
	        var sumIndex = null;
	        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
	
	        for (var i = 0, n = livefeedSlides.length; i < n; i++) {
	            if (livefeedSlides[i].slideType === "summary") {
	                hasSummaryPage = true;
	                sumIndex = i;
	                locationsID = livefeedSlides[i].floorplanOptions.locationsID;
	            }
	        }
	        var refinedLocationsID = locationsID.filter(function (id) {
	            return nodeMap[id];
	        });
	        if (hasSummaryPage) {
	            setSummaryLocationsID(refinedLocationsID);
	            setSumPageIndex(sumIndex);
	        } else {
	            setSummaryLocationsID([]);
	            setSumPageIndex(null);
	        }
	    }, [livefeedSlides, nodeMap]);
	
	    var isAllAreas = undefined;var isMR = false;var isOA = false; // isMeetingRooms// isOpenAreas
	    if (sumPageIndex !== null) {
	        for (var i = 0, n = summaryLocationsID.length; i < n; i++) {
	            if (summaryLocationsID[i] !== undefined) {
	                var node = nodeMap[summaryLocationsID[i]];
	                switch (node.type) {
	                    case "meeting_room":
	                        isMR = true;
	                        break;
	                    case "open_area":
	                        isOA = true;
	                        break;
	                }
	            }
	            if (isOA && isMR) {
	                isAllAreas = true;
	            } else {
	                isAllAreas = false;
	            }
	        }
	    }
	
	    (0, _react.useEffect)(function () {
	        console.log("editorMode", editorMode);
	        if (sumPageIndex !== null && editorMode !== "editTemplate" && editorMode !== "editLivefeed") {
	            if (isAllAreas) {
	                dispatch((0, _actionsLivefeed.alignGaugeCards)("all", sumPageIndex));
	            } else {
	                if (isMR) {
	                    dispatch((0, _actionsLivefeed.alignGaugeCards)("mr", sumPageIndex));
	                } else if (isOA) {
	                    dispatch((0, _actionsLivefeed.alignGaugeCards)("oa", sumPageIndex));
	                }
	            }
	        }
	    }, [editorMode, dispatch, isAllAreas, isMR, isOA, sumPageIndex]);
	
	    return _react2['default'].createElement(
	        'div',
	        { ref: locationOptionRef, className: 'location-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                slideType !== "summary" ? 'SENZOLIVE LOCATION' : 'SENZOLIVE LOCATIONS'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'editor-text grid-item grid-item__title',
	                    'data-for': 'floorplanOptionsTooltip',
	                    'data-tip': 'Data of the chosen location will be displayed in this slide', style: { whiteSpace: "normal" } },
	                slideType !== "summary" ? 'Choose locations' : 'Choose locations will be shown on livefeed slides'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item livefeed-editor-location' },
	                _react2['default'].createElement(
	                    _componentsCommonModal2['default'],
	                    {
	                        ref: treeLocationModal,
	                        clickButton: function () {
	                            return treeLocationModal.current.close();
	                        },
	                        header: 'Choose locations',
	                        buttonText: 'Done',
	                        buttonClass: 'btn-success hidden',
	                        disableCloseButton: true,
	                        entry: _react2['default'].createElement(
	                            'button',
	                            { className: 'btn btn-success', onClick: function () {
	                                    return _openLocationsModal();
	                                } },
	                            'Click to see options'
	                        )
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'location-dropdown' },
	                        _react2['default'].createElement(_CheckBoxTreeLocation2['default'], {
	                            arrLocations: arrLocations,
	                            onlyLeafCheckboxes: false,
	                            slideType: slideType,
	                            summaryLocationsID: summaryLocationsID,
	                            locationsID: locationsID,
	                            setLivefeedOptionsHandle: function (value) {
	                                return setLivefeedOptionsHandle(slideType !== "summary" ? "slideshowLocations" : "summaryLocations", value);
	                            }
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports['default'] = LocationOption;
	module.exports = exports['default'];

/***/ }),
/* 2280 */
[2373, 2281],
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".livefeed-editor-location .modals__content{width:unset;min-width:300px;text-align:left}.livefeed-editor-location .location-dropdown .react-checkbox-tree{display:flex;flex-direction:row-reverse;font-size:14px}.livefeed-editor-location .location-dropdown .react-checkbox-tree>ol{flex:1 1 auto}.livefeed-editor-location .location-dropdown .react-checkbox-tree ol{margin:0;padding-left:0;list-style-type:none;background-color:transparent}.livefeed-editor-location .location-dropdown .react-checkbox-tree ol ol{max-height:300px;overflow:auto;padding-left:15px;background-color:rgba(0,0,0,.03)}.livefeed-editor-location .location-dropdown .react-checkbox-tree button{line-height:normal;color:inherit}.livefeed-editor-location .location-dropdown .react-checkbox-tree button:focus{outline:none}.livefeed-editor-location .location-dropdown .react-checkbox-tree button:disabled{cursor:not-allowed}.livefeed-editor-location .location-dropdown .react-checkbox-tree .rct-bare-label{cursor:default;margin-right:auto}.livefeed-editor-location .location-dropdown .react-checkbox-tree label{margin-bottom:0;cursor:pointer;margin-right:auto}.livefeed-editor-location .location-dropdown .react-checkbox-tree:not(.rct-native-display) input{display:none}.livefeed-editor-location .location-dropdown .react-checkbox-tree.rct-native-display input{margin:0 5px}.livefeed-editor-location .location-dropdown .rct-disabled>.rct-text>label{opacity:.75;cursor:not-allowed}.livefeed-editor-location .location-dropdown .rct-disabled>.rct-text>label:active,.livefeed-editor-location .location-dropdown .rct-disabled>.rct-text>label:hover{background:transparent}.livefeed-editor-location .location-dropdown .rct-text{display:flex;align-items:center;line-height:24px;padding:12px 10px;flex-direction:row-reverse}.livefeed-editor-location .location-dropdown .rct-text:active,.livefeed-editor-location .location-dropdown .rct-text:hover{background-color:rgba(0,0,0,.06)}.livefeed-editor-location .location-dropdown .rct-checkbox .checked{color:#3cb449}.livefeed-editor-location .location-dropdown .rct-checkbox i{color:#585e66;transition:all .2s ease-in-out}.livefeed-editor-location .location-dropdown .rct-checkbox i:hover{font-weight:700}.livefeed-editor-location .location-dropdown .rct-title{padding:0 5px;color:#585e66}.livefeed-editor-location .location-dropdown .rct-collapse{border:0;background:none;line-height:normal;font-size:12px;padding:0}.livefeed-editor-location .location-dropdown .rct-collapse.rct-collapse-btn{cursor:pointer}.livefeed-editor-location .location-dropdown .rct-collapse.rct-collapse-btn .expand{transform-origin:50% 50%;transition:transform .4s ease-in-out,font-weight .2s;color:#585e66;font-weight:400}.livefeed-editor-location .location-dropdown .rct-collapse.rct-collapse-btn .expand:hover{font-weight:700}.livefeed-editor-location .location-dropdown .rct-collapse.rct-collapse-btn .expand-active{font-weight:700;transform:scaleX(-1)}", ""]);
	
	// exports


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCheckboxTree = __webpack_require__(2283);
	
	var _reactCheckboxTree2 = _interopRequireDefault(_reactCheckboxTree);
	
	var CheckBoxTreeLocation = function CheckBoxTreeLocation(props) {
	    var slideType = props.slideType;
	    var onlyLeafCheckboxes = props.onlyLeafCheckboxes;
	    var arrLocations = props.arrLocations;
	    var summaryLocationsID = props.summaryLocationsID;
	    var locationsID = props.locationsID;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	
	    var _useState = (0, _react.useState)([]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var expanded = _useState2[0];
	    var setExpanded = _useState2[1];
	
	    // filter out node if slideType is slideShow page
	    // filter arrLocations based on summaryLocationsID, if summaryLocationsID is empty, then there is no summary page, no need to filter
	    var arrLocationsFiltered = arrLocations.filter(function (item) {
	        if (slideType !== "summary") {
	            return summaryLocationsID.length > 0 ? summaryLocationsID.includes(item.id) : item;
	        } else {
	            return item;
	        }
	    });
	
	    var itemsByID = [];
	    arrLocationsFiltered.forEach(function (item, index) {
	        return itemsByID[index] = {
	            useownfp: item.useownfp,
	            value: item.id,
	            label: item.label,
	            children: [],
	            parentID: item.values.parent ? item.values.parent.id : null,
	            type: item.values.type
	        };
	    });
	    var delItems = [];
	    itemsByID.forEach(function (item) {
	        if (item.parentID !== null) {
	            for (var i = 0, n = itemsByID.length; i < n; i++) {
	                if (itemsByID[i].value === item.parentID) {
	                    itemsByID[i].children.push(item);
	                    delItems.push(item);
	                }
	            }
	        }
	    });
	    var newTree = null;
	
	    if (slideType === "summary") {
	        newTree = itemsByID.filter(function (item) {
	            return item.parentID === null;
	        });
	    }
	    newTree = itemsByID.filter(function (obj) {
	        return delItems.indexOf(obj) == -1;
	    });
	
	    itemsByID.forEach(function (item) {
	        delete item.parentID;
	    });
	
	    function onCheckHandle(checked, targetNode) {
	        // console.log("targetNode", targetNode)
	        var arraryNums = [];
	        for (var i = 0, n = checked.length; i < n; i++) {
	            arraryNums.push(Number(checked[i]));
	        }
	        setLivefeedOptionsHandle(arraryNums);
	    }
	
	    return _react2['default'].createElement(_reactCheckboxTree2['default'], {
	        checkModel: 'all',
	        onlyLeafCheckboxes: onlyLeafCheckboxes,
	        nodes: newTree,
	        checked: locationsID,
	        expanded: expanded,
	        onCheck: function (checked, targetNode) {
	            return onCheckHandle(checked, targetNode);
	        },
	        onExpand: function (expanded) {
	            return setExpanded(expanded);
	        },
	        icons: {
	            check: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons checked' },
	                'check_box'
	            ),
	            uncheck: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons' },
	                'check_box_outline_blank'
	            ),
	            halfCheck: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons' },
	                'check_box_outline_blank'
	            ),
	            expandClose: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons expand' },
	                'add_circle_outline'
	            ),
	            expandOpen: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons expand expand-active' },
	                'remove_circle_outline'
	            ),
	
	            expandAll: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons hidden' },
	                'remove_circle_outline'
	            ),
	            collapseAll: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons hidden' },
	                'remove_circle_outline'
	            ),
	            parentClose: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons hidden' },
	                'remove_circle_outline'
	            ),
	            parentOpen: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons hidden' },
	                'remove_circle_outline'
	            ),
	            leaf: _react2['default'].createElement(
	                'i',
	                { className: 'material-icons hidden' },
	                'remove_circle_outline'
	            )
	        }
	    });
	};
	
	exports['default'] = CheckBoxTreeLocation;
	module.exports = exports['default'];

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	/*! react-checkbox-tree - v1.6.0-alpha.2 | 2019 */
	!function(e,t){ true?module.exports=t(__webpack_require__(38)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactCheckboxTree=t(require("react")):e.ReactCheckboxTree=t(e.React)}(window,function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=27)}([function(e,t,n){e.exports=n(96)()},function(t,n){t.exports=e},function(e,t,n){var r=n(16),o="object"==typeof self&&self&&self.Object===Object&&self,a=r||o||Function("return this")();e.exports=a},function(e,t,n){var r=n(41),o=n(47);e.exports=function(e,t){var n=o(e,t);return r(n)?n:void 0}},function(e,t,n){var r=n(31),o=n(32),a=n(33),i=n(34),c=n(35);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=a,l.prototype.has=i,l.prototype.set=c,e.exports=l},function(e,t,n){var r=n(14);e.exports=function(e,t){for(var n=e.length;n--;)if(r(e[n][0],t))return n;return-1}},function(e,t,n){var r=n(12),o=n(43),a=n(44),i="[object Null]",c="[object Undefined]",l=r?r.toStringTag:void 0;e.exports=function(e){return null==e?void 0===e?c:i:l&&l in Object(e)?o(e):a(e)}},function(e,t,n){var r=n(3)(Object,"create");e.exports=r},function(e,t,n){var r=n(56);e.exports=function(e,t){var n=e.__data__;return r(t)?n["string"==typeof t?"string":"hash"]:n.map}},function(e,t){e.exports=function(e){return null!=e&&"object"==typeof e}},function(e,t,n){var r;
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	!function(){"use strict";var n={}.hasOwnProperty;function o(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var a=typeof r;if("string"===a||"number"===a)e.push(r);else if(Array.isArray(r)&&r.length){var i=o.apply(null,r);i&&e.push(i)}else if("object"===a)for(var c in r)n.call(r,c)&&r[c]&&e.push(c)}}return e.join(" ")}e.exports?(o.default=o,e.exports=o):void 0===(r=function(){return o}.apply(t,[]))||(e.exports=r)}()},function(e,t,n){var r=n(3)(n(2),"Map");e.exports=r},function(e,t,n){var r=n(2).Symbol;e.exports=r},function(e,t){var n=Array.isArray;e.exports=n},function(e,t){e.exports=function(e,t){return e===t||e!=e&&t!=t}},function(e,t,n){var r=n(6),o=n(17),a="[object AsyncFunction]",i="[object Function]",c="[object GeneratorFunction]",l="[object Proxy]";e.exports=function(e){if(!o(e))return!1;var t=r(e);return t==i||t==c||t==a||t==l}},function(e,t,n){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.exports=n}).call(this,n(42))},function(e,t){e.exports=function(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}},function(e,t){var n=Function.prototype.toString;e.exports=function(e){if(null!=e){try{return n.call(e)}catch(e){}try{return e+""}catch(e){}}return""}},function(e,t,n){var r=n(48),o=n(55),a=n(57),i=n(58),c=n(59);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=a,l.prototype.has=i,l.prototype.set=c,e.exports=l},function(e,t,n){var r=n(60),o=n(63),a=n(64),i=1,c=2;e.exports=function(e,t,n,l,u,s){var p=n&i,f=e.length,d=t.length;if(f!=d&&!(p&&d>f))return!1;var h=s.get(e);if(h&&s.get(t))return h==t;var b=-1,y=!0,v=n&c?new r:void 0;for(s.set(e,t),s.set(t,e);++b<f;){var x=e[b],g=t[b];if(l)var m=p?l(g,x,b,t,e,s):l(x,g,b,e,t,s);if(void 0!==m){if(m)continue;y=!1;break}if(v){if(!o(t,function(e,t){if(!a(v,t)&&(x===e||u(x,e,n,l,s)))return v.push(t)})){y=!1;break}}else if(x!==g&&!u(x,g,n,l,s)){y=!1;break}}return s.delete(e),s.delete(t),y}},function(e,t,n){(function(e){var r=n(2),o=n(81),a=t&&!t.nodeType&&t,i=a&&"object"==typeof e&&e&&!e.nodeType&&e,c=i&&i.exports===a?r.Buffer:void 0,l=(c?c.isBuffer:void 0)||o;e.exports=l}).call(this,n(22)(e))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t,n){var r=n(83),o=n(84),a=n(85),i=a&&a.isTypedArray,c=i?o(i):r;e.exports=c},function(e,t){var n=9007199254740991;e.exports=function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=n}},function(e,t,n){var r=n(28);e.exports=function(e,t){return r(e,t)}},function(e,t,n){var r=self.crypto||self.msCrypto;e.exports=function(e){e=e||21;for(var t="",n=r.getRandomValues(new Uint8Array(e));0<e--;)t+="Uint8ArdomValuesObj012345679BCDEFGHIJKLMNPQRSTWXYZ_cfghkpqvwxyz-"[63&n[e]];return t}},function(e,t,n){e.exports=n(98).default},function(e,t,n){var r=n(29),o=n(9);e.exports=function e(t,n,a,i,c){return t===n||(null==t||null==n||!o(t)&&!o(n)?t!=t&&n!=n:r(t,n,a,i,e,c))}},function(e,t,n){var r=n(30),o=n(20),a=n(65),i=n(69),c=n(91),l=n(13),u=n(21),s=n(23),p=1,f="[object Arguments]",d="[object Array]",h="[object Object]",b=Object.prototype.hasOwnProperty;e.exports=function(e,t,n,y,v,x){var g=l(e),m=l(t),k=g?d:c(e),O=m?d:c(t),_=(k=k==f?h:k)==h,j=(O=O==f?h:O)==h,C=k==O;if(C&&u(e)){if(!u(t))return!1;g=!0,_=!1}if(C&&!_)return x||(x=new r),g||s(e)?o(e,t,n,y,v,x):a(e,t,k,n,y,v,x);if(!(n&p)){var w=_&&b.call(e,"__wrapped__"),E=j&&b.call(t,"__wrapped__");if(w||E){var P=w?e.value():e,N=E?t.value():t;return x||(x=new r),v(P,N,n,y,x)}}return!!C&&(x||(x=new r),i(e,t,n,y,v,x))}},function(e,t,n){var r=n(4),o=n(36),a=n(37),i=n(38),c=n(39),l=n(40);function u(e){var t=this.__data__=new r(e);this.size=t.size}u.prototype.clear=o,u.prototype.delete=a,u.prototype.get=i,u.prototype.has=c,u.prototype.set=l,e.exports=u},function(e,t){e.exports=function(){this.__data__=[],this.size=0}},function(e,t,n){var r=n(5),o=Array.prototype.splice;e.exports=function(e){var t=this.__data__,n=r(t,e);return!(n<0||(n==t.length-1?t.pop():o.call(t,n,1),--this.size,0))}},function(e,t,n){var r=n(5);e.exports=function(e){var t=this.__data__,n=r(t,e);return n<0?void 0:t[n][1]}},function(e,t,n){var r=n(5);e.exports=function(e){return r(this.__data__,e)>-1}},function(e,t,n){var r=n(5);e.exports=function(e,t){var n=this.__data__,o=r(n,e);return o<0?(++this.size,n.push([e,t])):n[o][1]=t,this}},function(e,t,n){var r=n(4);e.exports=function(){this.__data__=new r,this.size=0}},function(e,t){e.exports=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n}},function(e,t){e.exports=function(e){return this.__data__.get(e)}},function(e,t){e.exports=function(e){return this.__data__.has(e)}},function(e,t,n){var r=n(4),o=n(11),a=n(19),i=200;e.exports=function(e,t){var n=this.__data__;if(n instanceof r){var c=n.__data__;if(!o||c.length<i-1)return c.push([e,t]),this.size=++n.size,this;n=this.__data__=new a(c)}return n.set(e,t),this.size=n.size,this}},function(e,t,n){var r=n(15),o=n(45),a=n(17),i=n(18),c=/^\[object .+?Constructor\]$/,l=Function.prototype,u=Object.prototype,s=l.toString,p=u.hasOwnProperty,f=RegExp("^"+s.call(p).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=function(e){return!(!a(e)||o(e))&&(r(e)?f:c).test(i(e))}},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){var r=n(12),o=Object.prototype,a=o.hasOwnProperty,i=o.toString,c=r?r.toStringTag:void 0;e.exports=function(e){var t=a.call(e,c),n=e[c];try{e[c]=void 0;var r=!0}catch(e){}var o=i.call(e);return r&&(t?e[c]=n:delete e[c]),o}},function(e,t){var n=Object.prototype.toString;e.exports=function(e){return n.call(e)}},function(e,t,n){var r,o=n(46),a=(r=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+r:"";e.exports=function(e){return!!a&&a in e}},function(e,t,n){var r=n(2)["__core-js_shared__"];e.exports=r},function(e,t){e.exports=function(e,t){return null==e?void 0:e[t]}},function(e,t,n){var r=n(49),o=n(4),a=n(11);e.exports=function(){this.size=0,this.__data__={hash:new r,map:new(a||o),string:new r}}},function(e,t,n){var r=n(50),o=n(51),a=n(52),i=n(53),c=n(54);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=a,l.prototype.has=i,l.prototype.set=c,e.exports=l},function(e,t,n){var r=n(7);e.exports=function(){this.__data__=r?r(null):{},this.size=0}},function(e,t){e.exports=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}},function(e,t,n){var r=n(7),o="__lodash_hash_undefined__",a=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;if(r){var n=t[e];return n===o?void 0:n}return a.call(t,e)?t[e]:void 0}},function(e,t,n){var r=n(7),o=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;return r?void 0!==t[e]:o.call(t,e)}},function(e,t,n){var r=n(7),o="__lodash_hash_undefined__";e.exports=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=r&&void 0===t?o:t,this}},function(e,t,n){var r=n(8);e.exports=function(e){var t=r(this,e).delete(e);return this.size-=t?1:0,t}},function(e,t){e.exports=function(e){var t=typeof e;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}},function(e,t,n){var r=n(8);e.exports=function(e){return r(this,e).get(e)}},function(e,t,n){var r=n(8);e.exports=function(e){return r(this,e).has(e)}},function(e,t,n){var r=n(8);e.exports=function(e,t){var n=r(this,e),o=n.size;return n.set(e,t),this.size+=n.size==o?0:1,this}},function(e,t,n){var r=n(19),o=n(61),a=n(62);function i(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new r;++t<n;)this.add(e[t])}i.prototype.add=i.prototype.push=o,i.prototype.has=a,e.exports=i},function(e,t){var n="__lodash_hash_undefined__";e.exports=function(e){return this.__data__.set(e,n),this}},function(e,t){e.exports=function(e){return this.__data__.has(e)}},function(e,t){e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}},function(e,t){e.exports=function(e,t){return e.has(t)}},function(e,t,n){var r=n(12),o=n(66),a=n(14),i=n(20),c=n(67),l=n(68),u=1,s=2,p="[object Boolean]",f="[object Date]",d="[object Error]",h="[object Map]",b="[object Number]",y="[object RegExp]",v="[object Set]",x="[object String]",g="[object Symbol]",m="[object ArrayBuffer]",k="[object DataView]",O=r?r.prototype:void 0,_=O?O.valueOf:void 0;e.exports=function(e,t,n,r,O,j,C){switch(n){case k:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case m:return!(e.byteLength!=t.byteLength||!j(new o(e),new o(t)));case p:case f:case b:return a(+e,+t);case d:return e.name==t.name&&e.message==t.message;case y:case x:return e==t+"";case h:var w=c;case v:var E=r&u;if(w||(w=l),e.size!=t.size&&!E)return!1;var P=C.get(e);if(P)return P==t;r|=s,C.set(e,t);var N=i(w(e),w(t),r,O,j,C);return C.delete(e),N;case g:if(_)return _.call(e)==_.call(t)}return!1}},function(e,t,n){var r=n(2).Uint8Array;e.exports=r},function(e,t){e.exports=function(e){var t=-1,n=Array(e.size);return e.forEach(function(e,r){n[++t]=[r,e]}),n}},function(e,t){e.exports=function(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}},function(e,t,n){var r=n(70),o=1,a=Object.prototype.hasOwnProperty;e.exports=function(e,t,n,i,c,l){var u=n&o,s=r(e),p=s.length;if(p!=r(t).length&&!u)return!1;for(var f=p;f--;){var d=s[f];if(!(u?d in t:a.call(t,d)))return!1}var h=l.get(e);if(h&&l.get(t))return h==t;var b=!0;l.set(e,t),l.set(t,e);for(var y=u;++f<p;){var v=e[d=s[f]],x=t[d];if(i)var g=u?i(x,v,d,t,e,l):i(v,x,d,e,t,l);if(!(void 0===g?v===x||c(v,x,n,i,l):g)){b=!1;break}y||(y="constructor"==d)}if(b&&!y){var m=e.constructor,k=t.constructor;m!=k&&"constructor"in e&&"constructor"in t&&!("function"==typeof m&&m instanceof m&&"function"==typeof k&&k instanceof k)&&(b=!1)}return l.delete(e),l.delete(t),b}},function(e,t,n){var r=n(71),o=n(73),a=n(76);e.exports=function(e){return r(e,a,o)}},function(e,t,n){var r=n(72),o=n(13);e.exports=function(e,t,n){var a=t(e);return o(e)?a:r(a,n(e))}},function(e,t){e.exports=function(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;)e[o+n]=t[n];return e}},function(e,t,n){var r=n(74),o=n(75),a=Object.prototype.propertyIsEnumerable,i=Object.getOwnPropertySymbols,c=i?function(e){return null==e?[]:(e=Object(e),r(i(e),function(t){return a.call(e,t)}))}:o;e.exports=c},function(e,t){e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length,o=0,a=[];++n<r;){var i=e[n];t(i,n,e)&&(a[o++]=i)}return a}},function(e,t){e.exports=function(){return[]}},function(e,t,n){var r=n(77),o=n(86),a=n(90);e.exports=function(e){return a(e)?r(e):o(e)}},function(e,t,n){var r=n(78),o=n(79),a=n(13),i=n(21),c=n(82),l=n(23),u=Object.prototype.hasOwnProperty;e.exports=function(e,t){var n=a(e),s=!n&&o(e),p=!n&&!s&&i(e),f=!n&&!s&&!p&&l(e),d=n||s||p||f,h=d?r(e.length,String):[],b=h.length;for(var y in e)!t&&!u.call(e,y)||d&&("length"==y||p&&("offset"==y||"parent"==y)||f&&("buffer"==y||"byteLength"==y||"byteOffset"==y)||c(y,b))||h.push(y);return h}},function(e,t){e.exports=function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}},function(e,t,n){var r=n(80),o=n(9),a=Object.prototype,i=a.hasOwnProperty,c=a.propertyIsEnumerable,l=r(function(){return arguments}())?r:function(e){return o(e)&&i.call(e,"callee")&&!c.call(e,"callee")};e.exports=l},function(e,t,n){var r=n(6),o=n(9),a="[object Arguments]";e.exports=function(e){return o(e)&&r(e)==a}},function(e,t){e.exports=function(){return!1}},function(e,t){var n=9007199254740991,r=/^(?:0|[1-9]\d*)$/;e.exports=function(e,t){var o=typeof e;return!!(t=null==t?n:t)&&("number"==o||"symbol"!=o&&r.test(e))&&e>-1&&e%1==0&&e<t}},function(e,t,n){var r=n(6),o=n(24),a=n(9),i={};i["[object Float32Array]"]=i["[object Float64Array]"]=i["[object Int8Array]"]=i["[object Int16Array]"]=i["[object Int32Array]"]=i["[object Uint8Array]"]=i["[object Uint8ClampedArray]"]=i["[object Uint16Array]"]=i["[object Uint32Array]"]=!0,i["[object Arguments]"]=i["[object Array]"]=i["[object ArrayBuffer]"]=i["[object Boolean]"]=i["[object DataView]"]=i["[object Date]"]=i["[object Error]"]=i["[object Function]"]=i["[object Map]"]=i["[object Number]"]=i["[object Object]"]=i["[object RegExp]"]=i["[object Set]"]=i["[object String]"]=i["[object WeakMap]"]=!1,e.exports=function(e){return a(e)&&o(e.length)&&!!i[r(e)]}},function(e,t){e.exports=function(e){return function(t){return e(t)}}},function(e,t,n){(function(e){var r=n(16),o=t&&!t.nodeType&&t,a=o&&"object"==typeof e&&e&&!e.nodeType&&e,i=a&&a.exports===o&&r.process,c=function(){try{var e=a&&a.require&&a.require("util").types;return e||i&&i.binding&&i.binding("util")}catch(e){}}();e.exports=c}).call(this,n(22)(e))},function(e,t,n){var r=n(87),o=n(88),a=Object.prototype.hasOwnProperty;e.exports=function(e){if(!r(e))return o(e);var t=[];for(var n in Object(e))a.call(e,n)&&"constructor"!=n&&t.push(n);return t}},function(e,t){var n=Object.prototype;e.exports=function(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||n)}},function(e,t,n){var r=n(89)(Object.keys,Object);e.exports=r},function(e,t){e.exports=function(e,t){return function(n){return e(t(n))}}},function(e,t,n){var r=n(15),o=n(24);e.exports=function(e){return null!=e&&o(e.length)&&!r(e)}},function(e,t,n){var r=n(92),o=n(11),a=n(93),i=n(94),c=n(95),l=n(6),u=n(18),s=u(r),p=u(o),f=u(a),d=u(i),h=u(c),b=l;(r&&"[object DataView]"!=b(new r(new ArrayBuffer(1)))||o&&"[object Map]"!=b(new o)||a&&"[object Promise]"!=b(a.resolve())||i&&"[object Set]"!=b(new i)||c&&"[object WeakMap]"!=b(new c))&&(b=function(e){var t=l(e),n="[object Object]"==t?e.constructor:void 0,r=n?u(n):"";if(r)switch(r){case s:return"[object DataView]";case p:return"[object Map]";case f:return"[object Promise]";case d:return"[object Set]";case h:return"[object WeakMap]"}return t}),e.exports=b},function(e,t,n){var r=n(3)(n(2),"DataView");e.exports=r},function(e,t,n){var r=n(3)(n(2),"Promise");e.exports=r},function(e,t,n){var r=n(3)(n(2),"Set");e.exports=r},function(e,t,n){var r=n(3)(n(2),"WeakMap");e.exports=r},function(e,t,n){"use strict";var r=n(97);function o(){}e.exports=function(){function e(e,t,n,o,a,i){if(i!==r){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";n.r(t);var r=n(10),o=n.n(r),a=n(25),i=n.n(a),c=n(26),l=n.n(c),u=n(0),s=n.n(u),p=n(1),f=n.n(p);function d(e){return(d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function h(){return(h=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function b(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},a=Object.keys(e);for(r=0;r<a.length;r++)n=a[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(r=0;r<a.length;r++)n=a[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function y(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function v(e,t){return!t||"object"!==d(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function x(e){return(x=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function g(e,t){return(g=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function m(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var k=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),v(this,x(t).apply(this,arguments))}var n,r,o;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&g(e,t)}(t,f.a.PureComponent),n=t,(r=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.title,r=b(e,["children","title"]);return f.a.createElement("button",h({"aria-label":n,title:n,type:"button"},r),t)}}])&&y(n.prototype,r),o&&y(n,o),t}();m(k,"propTypes",{children:s.a.node.isRequired,title:s.a.string}),m(k,"defaultProps",{title:null});var O=k,_={ALL:"all",PARENT:"parent",LEAF:"leaf"};function j(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function C(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var w=_,E=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.props=t,this.flatNodes=n}var t,n,r;return t=e,(n=[{key:"setProps",value:function(e){this.props=e}},{key:"clone",value:function(){var t=this,n={};return Object.keys(this.flatNodes).forEach(function(e){var r=t.flatNodes[e];n[e]=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){j(e,t,n[t])})}return e}({},r)}),new e(this.props,n)}},{key:"getNode",value:function(e){return this.flatNodes[e]}},{key:"flattenNodes",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;if(Array.isArray(e)&&0!==e.length){var o=this.props,a=o.disabled,i=o.noCascade;e.forEach(function(e,o){var c=t.nodeHasChildren(e);t.flatNodes[e.value]={label:e.label,value:e.value,children:e.children,parent:n,isChild:void 0!==n.value,isParent:c,isLeaf:!c,showCheckbox:void 0===e.showCheckbox||e.showCheckbox,disabled:t.getDisabledState(e,n,a,i),treeDepth:r,index:o},t.flattenNodes(e.children,e,r+1)})}}},{key:"nodeHasChildren",value:function(e){return Array.isArray(e.children)&&e.children.length>0}},{key:"getDisabledState",value:function(e,t,n,r){return!!n||(!(r||!t.disabled)||Boolean(e.disabled))}},{key:"deserializeLists",value:function(e){var t=this,n=["checked","expanded"];Object.keys(this.flatNodes).forEach(function(e){n.forEach(function(n){t.flatNodes[e][n]=!1})}),n.forEach(function(n){e[n].forEach(function(e){void 0!==t.flatNodes[e]&&(t.flatNodes[e][n]=!0)})})}},{key:"serializeList",value:function(e){var t=this,n=[];return Object.keys(this.flatNodes).forEach(function(r){t.flatNodes[r][e]&&n.push(r)}),n}},{key:"expandAllNodes",value:function(e){var t=this;return Object.keys(this.flatNodes).forEach(function(n){t.flatNodes[n].isParent&&(t.flatNodes[n].expanded=e)}),this}},{key:"toggleChecked",value:function(e,t,n,r){var o=this,a=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],i=this.flatNodes[e.value],c=[w.PARENT,w.ALL].indexOf(n)>-1,l=[w.LEAF,w.ALL].indexOf(n)>-1;if(i.isLeaf||r){if(e.disabled)return this;this.toggleNode(e.value,"checked",t)}else c&&this.toggleNode(e.value,"checked",t),l&&i.children.forEach(function(e){o.toggleChecked(e,t,n,r,!1)});return a&&!r&&i.isChild&&c&&this.toggleParentStatus(i.parent,n),this}},{key:"toggleParentStatus",value:function(e,t){var n=this.flatNodes[e.value];n.isChild?(t===w.ALL&&this.toggleNode(e.value,"checked",this.isEveryChildChecked(n)),this.toggleParentStatus(n.parent,t)):this.toggleNode(e.value,"checked",this.isEveryChildChecked(n))}},{key:"isEveryChildChecked",value:function(e){var t=this;return e.children.every(function(e){return t.getNode(e.value).checked})}},{key:"toggleNode",value:function(e,t,n){return this.flatNodes[e][t]=n,this}}])&&C(t.prototype,n),r&&C(t,r),e}();function P(e){return(P="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function N(){return(N=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function A(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function S(e,t){return!t||"object"!==P(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function T(e){return(T=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function L(e,t){return(L=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function R(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var I=function(e){function t(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),S(this,T(t).apply(this,arguments))}var n,r,o;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&L(e,t)}(t,f.a.PureComponent),n=t,(r=[{key:"componentDidMount",value:function(){this.updateDeterminateProperty()}},{key:"componentDidUpdate",value:function(){this.updateDeterminateProperty()}},{key:"updateDeterminateProperty",value:function(){var e=this.props.indeterminate;this.checkbox.indeterminate=e}},{key:"render",value:function(){var e=this,t=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){R(e,t,n[t])})}return e}({},this.props);return delete t.indeterminate,f.a.createElement("input",N({},t,{ref:function(t){e.checkbox=t},type:"checkbox"}))}}])&&A(n.prototype,r),o&&A(n,o),t}();R(I,"propTypes",{indeterminate:s.a.bool}),R(I,"defaultProps",{indeterminate:!1});var z=I,q=s.a.shape({check:s.a.node,uncheck:s.a.node,halfCheck:s.a.node,expandClose:s.a.node,expandOpen:s.a.node,expandAll:s.a.node,collapseAll:s.a.node,parentClose:s.a.node,parentOpen:s.a.node,leaf:s.a.node}),D=s.a.shape({collapseAll:s.a.string.isRequired,expandAll:s.a.string.isRequired,toggle:s.a.string.isRequired});function F(e){return(F="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function M(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function B(e){return(B=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function U(e,t){return(U=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function H(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function V(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var $=function(e){function t(e){var n,r,o;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,(n=!(o=B(t).call(this,e))||"object"!==F(o)&&"function"!=typeof o?H(r):o).onCheck=n.onCheck.bind(H(H(n))),n.onClick=n.onClick.bind(H(H(n))),n.onExpand=n.onExpand.bind(H(H(n))),n}var n,r,a;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&U(e,t)}(t,f.a.Component),n=t,(r=[{key:"onCheck",value:function(){var e=this.props,t=e.value,n=e.onCheck;n({value:t,checked:this.getCheckState({toggle:!0})})}},{key:"onClick",value:function(){var e=this.props,t=e.expandOnClick,n=e.isParent,r=e.value,o=e.onClick;n&&t&&this.onExpand(),o({value:r,checked:this.getCheckState({toggle:!1})})}},{key:"onExpand",value:function(){var e=this.props,t=e.expanded,n=e.value,r=e.onExpand;r({value:n,expanded:!t})}},{key:"getCheckState",value:function(e){var t=e.toggle,n=this.props,r=n.checked,o=n.optimisticToggle;return!(0!==r||!t)||(1===r&&!t||2===r&&o)}},{key:"renderCollapseButton",value:function(){var e=this.props,t=e.expandDisabled,n=e.isLeaf,r=e.lang;return n?f.a.createElement("span",{className:"rct-collapse"},f.a.createElement("span",{className:"rct-icon"})):f.a.createElement(O,{className:"rct-collapse rct-collapse-btn",disabled:t,title:r.toggle,onClick:this.onExpand},this.renderCollapseIcon())}},{key:"renderCollapseIcon",value:function(){var e=this.props,t=e.expanded,n=e.icons,r=n.expandClose,o=n.expandOpen;return t?o:r}},{key:"renderCheckboxIcon",value:function(){var e=this.props,t=e.checked,n=e.icons,r=n.uncheck,o=n.check,a=n.halfCheck;return 0===t?r:1===t?o:a}},{key:"renderNodeIcon",value:function(){var e=this.props,t=e.expanded,n=e.icon,r=e.icons,o=r.leaf,a=r.parentClose,i=r.parentOpen,c=e.isLeaf;return null!==n?n:c?o:t?i:a}},{key:"renderBareLabel",value:function(e){var t=this.props,n=t.onClick,r=t.title,o=null!==n;return f.a.createElement("span",{className:"rct-bare-label",title:r},o?f.a.createElement("span",{className:"rct-node-clickable",onClick:this.onClick,onKeyPress:this.onClick,role:"button",tabIndex:0},e):e)}},{key:"renderCheckboxLabel",value:function(e){var t=this.props,n=t.checked,r=t.disabled,o=t.title,a=t.treeId,i=t.value,c=null!==t.onClick,l="".concat(a,"-").concat(String(i).split(" ").join("_")),u=[f.a.createElement("label",{key:0,htmlFor:l,title:o},f.a.createElement(z,{checked:1===n,disabled:r,id:l,indeterminate:2===n,onClick:this.onCheck,onChange:function(){}}),f.a.createElement("span",{className:"rct-checkbox"},this.renderCheckboxIcon()),c?null:e)];return c&&u.push(f.a.createElement("span",{key:1,className:"rct-node-clickable",onClick:this.onClick,onKeyPress:this.onClick,role:"link",tabIndex:0},e)),u}},{key:"renderLabel",value:function(){var e=this.props,t=e.label,n=e.showCheckbox,r=[e.showNodeIcon?f.a.createElement("span",{key:0,className:"rct-node-icon"},this.renderNodeIcon()):null,f.a.createElement("span",{key:1,className:"rct-title"},t)];return n?this.renderCheckboxLabel(r):this.renderBareLabel(r)}},{key:"renderChildren",value:function(){return this.props.expanded?this.props.children:null}},{key:"render",value:function(){var e=this.props,t=e.className,n=e.disabled,r=e.expanded,a=e.isLeaf,i=o()({"rct-node":!0,"rct-node-leaf":a,"rct-node-parent":!a,"rct-node-expanded":!a&&r,"rct-node-collapsed":!a&&!r,"rct-disabled":n},t);return f.a.createElement("li",{className:i},f.a.createElement("span",{className:"rct-text"},this.renderCollapseButton(),this.renderLabel()),this.renderChildren())}}])&&M(n.prototype,r),a&&M(n,a),t}();V($,"propTypes",{checked:s.a.number.isRequired,disabled:s.a.bool.isRequired,expandDisabled:s.a.bool.isRequired,expanded:s.a.bool.isRequired,icons:q.isRequired,isLeaf:s.a.bool.isRequired,isParent:s.a.bool.isRequired,label:s.a.node.isRequired,lang:D.isRequired,optimisticToggle:s.a.bool.isRequired,showNodeIcon:s.a.bool.isRequired,treeId:s.a.string.isRequired,value:s.a.oneOfType([s.a.string,s.a.number]).isRequired,onCheck:s.a.func.isRequired,onExpand:s.a.func.isRequired,children:s.a.node,className:s.a.string,expandOnClick:s.a.bool,icon:s.a.node,showCheckbox:s.a.bool,title:s.a.string,onClick:s.a.func}),V($,"defaultProps",{children:null,className:null,expandOnClick:!1,icon:null,showCheckbox:!0,title:null,onClick:function(){}});var W=$,J=s.a.oneOfType([s.a.arrayOf(s.a.string),s.a.arrayOf(s.a.number)]);function K(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var G={label:s.a.node.isRequired,value:s.a.oneOfType([s.a.string,s.a.number]).isRequired,disabled:s.a.bool,icon:s.a.node,showCheckbox:s.a.bool,title:s.a.string},Y=s.a.oneOfType([s.a.shape(G),s.a.shape(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){K(e,t,n[t])})}return e}({},G,{children:s.a.arrayOf(G).isRequired}))]);function Q(e){return(Q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function X(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){re(e,t,n[t])})}return e}function Z(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function ee(e){return(ee=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function te(e,t){return(te=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ne(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function re(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var oe=function(e){function t(e){var n,r,o;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,n=!(o=ee(t).call(this,e))||"object"!==Q(o)&&"function"!=typeof o?ne(r):o;var a=new E(e);return a.flattenNodes(e.nodes),a.deserializeLists({checked:e.checked,expanded:e.expanded}),n.state={id:e.id||"rct-".concat(l()(7)),model:a,prevProps:e},n.onCheck=n.onCheck.bind(ne(ne(n))),n.onExpand=n.onExpand.bind(ne(ne(n))),n.onNodeClick=n.onNodeClick.bind(ne(ne(n))),n.onExpandAll=n.onExpandAll.bind(ne(ne(n))),n.onCollapseAll=n.onCollapseAll.bind(ne(ne(n))),n}var n,r,a;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&te(e,t)}(t,f.a.Component),n=t,a=[{key:"getDerivedStateFromProps",value:function(e,t){var n=t.model,r=t.prevProps,o=e.disabled,a=e.id,c=e.nodes,l=X({},t,{prevProps:e});return n.setProps(e),i()(r.nodes,c)&&r.disabled===o||n.flattenNodes(c),null!==a&&(l=X({},l,{id:a})),n.deserializeLists({checked:e.checked,expanded:e.expanded}),l}}],(r=[{key:"onCheck",value:function(e){var t=this.props,n=t.checkModel,r=t.noCascade,o=t.onCheck,a=this.state.model.clone(),i=a.getNode(e.value);a.toggleChecked(e,e.checked,n,r),o(a.serializeList("checked"),X({},i,e))}},{key:"onExpand",value:function(e){var t=this.props.onExpand,n=this.state.model.clone(),r=n.getNode(e.value);n.toggleNode(e.value,"expanded",e.expanded),t(n.serializeList("expanded"),X({},r,e))}},{key:"onNodeClick",value:function(e){(0,this.props.onClick)(X({},this.state.model.getNode(e.value),e))}},{key:"onExpandAll",value:function(){this.expandAllNodes()}},{key:"onCollapseAll",value:function(){this.expandAllNodes(!1)}},{key:"expandAllNodes",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];(0,this.props.onExpand)(this.state.model.clone().expandAllNodes(e).serializeList("expanded"))}},{key:"determineShallowCheckState",value:function(e,t){var n=this.state.model.getNode(e.value);return n.isLeaf||t?n.checked?1:0:this.isEveryChildChecked(e)?1:this.isSomeChildChecked(e)?2:0}},{key:"isEveryChildChecked",value:function(e){var t=this;return e.children.every(function(e){return 1===t.state.model.getNode(e.value).checkState})}},{key:"isSomeChildChecked",value:function(e){var t=this;return e.children.some(function(e){return t.state.model.getNode(e.value).checkState>0})}},{key:"renderTreeNodes",value:function(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=this.props,a=o.expandDisabled,i=o.expandOnClick,c=o.icons,l=o.lang,u=o.noCascade,s=o.onClick,p=o.onlyLeafCheckboxes,d=o.optimisticToggle,h=o.showNodeTitle,b=o.showNodeIcon,y=this.state,v=y.id,x=y.model,g=t.defaultProps.icons,m=e.map(function(e){var t=e.value,o=x.getNode(e.value),y=o.isParent?n.renderTreeNodes(e.children,e):null;o.checkState=n.determineShallowCheckState(e,u);var m=p?o.isLeaf:o.showCheckbox;return!r.value||x.getNode(r.value).expanded?f.a.createElement(W,{key:t,checked:o.checkState,className:e.className,disabled:o.disabled,expandDisabled:a,expandOnClick:i,expanded:o.expanded,icon:e.icon,icons:X({},g,c),label:e.label,lang:l,optimisticToggle:d,isLeaf:o.isLeaf,isParent:o.isParent,showCheckbox:m,showNodeIcon:b,title:h?e.title||e.label:e.title,treeId:v,value:e.value,onCheck:n.onCheck,onClick:s&&n.onNodeClick,onExpand:n.onExpand},y):null});return f.a.createElement("ol",null,m)}},{key:"renderExpandAll",value:function(){var e=this.props,t=e.icons,n=t.expandAll,r=t.collapseAll,o=e.lang;return e.showExpandAll?f.a.createElement("div",{className:"rct-options"},f.a.createElement(O,{className:"rct-option rct-option-expand-all",title:o.expandAll,onClick:this.onExpandAll},n),f.a.createElement(O,{className:"rct-option rct-option-collapse-all",title:o.collapseAll,onClick:this.onCollapseAll},r)):null}},{key:"renderHiddenInput",value:function(){var e=this.props,t=e.name,n=e.nameAsArray;return void 0===t?null:n?this.renderArrayHiddenInput():this.renderJoinedHiddenInput()}},{key:"renderArrayHiddenInput",value:function(){var e=this.props,t=e.checked,n=e.name;return t.map(function(e){var t="".concat(n,"[]");return f.a.createElement("input",{key:e,name:t,type:"hidden",value:e})})}},{key:"renderJoinedHiddenInput",value:function(){var e=this.props,t=e.checked,n=e.name,r=t.join(",");return f.a.createElement("input",{name:n,type:"hidden",value:r})}},{key:"render",value:function(){var e,t=this.props,n=t.disabled,r=t.iconsClass,a=t.nodes,i=t.nativeCheckboxes,c=this.renderTreeNodes(a),l=o()((re(e={"react-checkbox-tree":!0,"rct-disabled":n},"rct-icons-".concat(r),!0),re(e,"rct-native-display",i),e));return f.a.createElement("div",{className:l},this.renderExpandAll(),this.renderHiddenInput(),c)}}])&&Z(n.prototype,r),a&&Z(n,a),t}();re(oe,"propTypes",{nodes:s.a.arrayOf(Y).isRequired,checkModel:s.a.oneOf([_.LEAF,_.ALL]),checked:J,disabled:s.a.bool,expandDisabled:s.a.bool,expandOnClick:s.a.bool,expanded:J,icons:q,iconsClass:s.a.string,id:s.a.string,lang:D,name:s.a.string,nameAsArray:s.a.bool,nativeCheckboxes:s.a.bool,noCascade:s.a.bool,onlyLeafCheckboxes:s.a.bool,optimisticToggle:s.a.bool,showExpandAll:s.a.bool,showNodeIcon:s.a.bool,showNodeTitle:s.a.bool,onCheck:s.a.func,onClick:s.a.func,onExpand:s.a.func}),re(oe,"defaultProps",{checkModel:_.LEAF,checked:[],disabled:!1,expandDisabled:!1,expandOnClick:!1,expanded:[],icons:{check:f.a.createElement("span",{className:"rct-icon rct-icon-check"}),uncheck:f.a.createElement("span",{className:"rct-icon rct-icon-uncheck"}),halfCheck:f.a.createElement("span",{className:"rct-icon rct-icon-half-check"}),expandClose:f.a.createElement("span",{className:"rct-icon rct-icon-expand-close"}),expandOpen:f.a.createElement("span",{className:"rct-icon rct-icon-expand-open"}),expandAll:f.a.createElement("span",{className:"rct-icon rct-icon-expand-all"}),collapseAll:f.a.createElement("span",{className:"rct-icon rct-icon-collapse-all"}),parentClose:f.a.createElement("span",{className:"rct-icon rct-icon-parent-close"}),parentOpen:f.a.createElement("span",{className:"rct-icon rct-icon-parent-open"}),leaf:f.a.createElement("span",{className:"rct-icon rct-icon-leaf"})},iconsClass:"fa4",id:null,lang:{collapseAll:"Collapse all",expandAll:"Expand all",toggle:"Toggle"},name:void 0,nameAsArray:!1,nativeCheckboxes:!1,noCascade:!1,onlyLeafCheckboxes:!1,optimisticToggle:!0,showExpandAll:!1,showNodeIcon:!0,showNodeTitle:!1,onCheck:function(){},onClick:null,onExpand:function(){}});t.default=oe}])});

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	var DurationOption = function DurationOption(props) {
	    var slideDuration = props.slideDuration;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var setLivefeedGlobalOptionsHandle = props.setLivefeedGlobalOptionsHandle;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var globalDuration = _useState2[0];
	    var setGlobalDuration = _useState2[1];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'duration-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                'DURATION'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'editor-text grid-item grid-item__title',
	                    'data-for': 'floorplanOptionsTooltip',
	                    'data-tip': 'Duration (in seconds) before changing to next slide',
	                    style: { whiteSpace: "normal" } },
	                'Choose slide duration: ',
	                slideDuration,
	                ' s'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item duration-button' },
	                _react2['default'].createElement('input', { type: 'range', id: 'slideDuration', min: '5', max: '45',
	                    onChange: function (event) {
	                        /* if globalDuration is enabled, then when the duration is modified, set globalDuration to be false*/
	                        globalDuration === true && setGlobalDuration(false);
	                        setLivefeedOptionsHandle(parseInt(event.target.value));
	                    },
	                    value: slideDuration }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'indicator' },
	                    slideDuration,
	                    ' seconds'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'marker pull-left' },
	                    '5'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'marker pull-right' },
	                    '45'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item global-toggle-item' },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        'data-tip': 'Apply this slide duration to all slides',
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" },
	                        className: 'global-option-toggle',
	                        onClick: function () {
	                            setGlobalDuration(!globalDuration);
	                            setLivefeedGlobalOptionsHandle(slideDuration);
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'toggle-text' },
	                        'Apply to all slides'
	                    ),
	                    _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: globalDuration })
	                )
	            )
	        )
	    );
	};
	
	exports['default'] = DurationOption;
	module.exports = exports['default'];

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	var ScrollOption = function ScrollOption(props) {
	    var lockScroll = props.lockScroll;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var setLivefeedGlobalOptionsHandle = props.setLivefeedGlobalOptionsHandle;
	
	    //---------------------- component's ref & state
	    var lockScrollModalRef = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)(true);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var globalLockScroll = _useState2[0];
	    var setGlobalLockScroll = _useState2[1];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'scroll-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                'FLOORPLAN SCROLL'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item' },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'scroll-toggle',
	                            onClick: function (e) {
	                                e.stopPropagation();
	                                /* if globalLockScroll is enabled, then when the duration is modified, set globalLockScroll to be false*/
	                                globalLockScroll === false && setGlobalLockScroll(true);
	                                // enable scrolling means lockScroll is set to be false
	                                setLivefeedOptionsHandle(!lockScroll);
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'toggle-text' },
	                            'Enable scrolling'
	                        ),
	                        _react2['default'].createElement('span', { onClick: function (e) {
	                                e.stopPropagation();lockScrollModalRef.current.open();
	                            },
	                            className: 'scroll-help font-icon icon-infoIcon' }),
	                        _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: !lockScroll })
	                    ),
	                    _react2['default'].createElement(
	                        _componentsCommonModal2['default'],
	                        {
	                            ref: lockScrollModalRef,
	                            clickButton: function () {
	                                return lockScrollModalRef.current.close();
	                            },
	                            header: 'Floorplan scroll',
	                            buttonText: 'Got it',
	                            buttonClass: 'btn-success',
	                            entry: null
	                        },
	                        _react2['default'].createElement(
	                            'p',
	                            { style: { textAlign: "left" } },
	                            'When enabled, floorplans will be zoomed in and scrolled up/down to show all sensors at a visible scale.',
	                            _react2['default'].createElement('br', null),
	                            'Disable scrolling for smaller floorplans that do not require zooming will make the floorplans scale to fit the display area fully.',
	                            _react2['default'].createElement('br', null),
	                            'You can have different scrolling settings for different slides'
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item global-toggle-item' },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" },
	                        'data-tip': 'Apply this scroll settings to all slides',
	                        className: 'global-scroll-toggle',
	                        onClick: function () {
	                            setGlobalLockScroll(!globalLockScroll);
	                            setLivefeedGlobalOptionsHandle(lockScroll);
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { style: { marginRight: 4 }, className: 'toggle-text' },
	                        'Apply to all slides'
	                    ),
	                    _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: !globalLockScroll })
	                )
	            )
	        )
	    );
	};
	
	exports['default'] = ScrollOption;
	module.exports = exports['default'];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	var _componentsCommonCustomTickBox = __webpack_require__(1925);
	
	var _componentsCommonCustomTickBox2 = _interopRequireDefault(_componentsCommonCustomTickBox);
	
	var SensorOption = function SensorOption(props) {
	    var slideType = props.slideType;
	    var isStandbyAsUnOccupied = props.isStandbyAsUnOccupied;
	    var sensorFilterType = props.sensorFilterType;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var setLivefeedGlobalOptionsHandle = props.setLivefeedGlobalOptionsHandle;
	
	    var _useState = (0, _react.useState)(false);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var globalSetting = _useState2[0];
	    var setGlobalSetting = _useState2[1];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'gauge-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                'SENSORS'
	            ),
	            slideType !== "summary" && _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'editor-text grid-item grid-item__title',
	                        'data-tip': 'Option to choose the number of available units either as one figure ("50") or two ("50/75").',
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" } },
	                    'Sensors filtering  '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item ' },
	                    _react2['default'].createElement(_componentsCommonCustomTickBox2['default'], {
	                        className: 'widget-label-setting',
	                        onClick: function () {
	                            /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
	                            globalSetting === true && setGlobalSetting(false);
	                            setLivefeedOptionsHandle("sensorFilterType", "occupied-unOccupied");
	                        },
	                        label: 'Show all units',
	                        isActive: sensorFilterType === "occupied-unOccupied"
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item ' },
	                    _react2['default'].createElement(_componentsCommonCustomTickBox2['default'], {
	                        className: 'widget-label-setting',
	                        onClick: function () {
	                            /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
	                            globalSetting === true && setGlobalSetting(false);
	                            setLivefeedOptionsHandle("sensorFilterType", "unOccupied");
	                        },
	                        label: 'Show available units only',
	                        isActive: sensorFilterType === "unOccupied"
	                    })
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item grid-item_divider-line' },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Treat standby sensors as'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        style: { whiteSpace: "normal" },
	                        className: 'occupied-toggle',
	                        onClick: function () {
	                            /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
	                            globalSetting === true && setGlobalSetting(false);
	                            setLivefeedOptionsHandle("treatStandbySensor", !isStandbyAsUnOccupied);
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'toggle-text' },
	                        ' Occupied'
	                    ),
	                    _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: isStandbyAsUnOccupied }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'toggle-text' },
	                        ' Unoccupied'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item global-toggle-item' },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" },
	                        'data-tip': 'Apply this setting to all slides',
	                        className: 'global-option-toggle',
	                        onClick: function () {
	                            setGlobalSetting(!globalSetting);
	                            setLivefeedGlobalOptionsHandle({ sensorFilterType: sensorFilterType, isStandbyAsUnOccupied: isStandbyAsUnOccupied });
	                        } },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'toggle-text' },
	                        'Apply to all slides'
	                    ),
	                    _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: globalSetting })
	                )
	            )
	        )
	    );
	};
	
	exports['default'] = SensorOption;
	module.exports = exports['default'];

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsLivefeedSteerpathMapActions = __webpack_require__(375);
	
	var _componentsCommonToggle = __webpack_require__(2242);
	
	var _componentsCommonToggle2 = _interopRequireDefault(_componentsCommonToggle);
	
	//import { parseJwtToken } from 'components/pages/livefeed/utils'
	
	var _componentsCommonDelayInput = __webpack_require__(2288);
	
	var _componentsCommonDelayInput2 = _interopRequireDefault(_componentsCommonDelayInput);
	
	var _componentsCommonCustomTickBox = __webpack_require__(1925);
	
	var _componentsCommonCustomTickBox2 = _interopRequireDefault(_componentsCommonCustomTickBox);
	
	var _reactSelect = __webpack_require__(417);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(2289);
	
	var MapConfig = (0, _react.forwardRef)(function (props, ref) {
	    var dispatch = props.dispatch;
	    var livefeedSlides = props.livefeedSlides;
	    var mapConfigMode = props.mapConfigMode;
	    var slideCurrentIndex = props.slideCurrentIndex;
	    var setLivefeedOptionsHandle = props.setLivefeedOptionsHandle;
	    var setLivefeedGlobalOptionsHandle = props.setLivefeedGlobalOptionsHandle;
	    var _livefeedSlides$slideCurrentIndex$floorplanOptions = livefeedSlides[slideCurrentIndex].floorplanOptions;
	    var slideDuration = _livefeedSlides$slideCurrentIndex$floorplanOptions.duration;
	    var mapConfig = _livefeedSlides$slideCurrentIndex$floorplanOptions.mapConfig;
	    var liveApiKey = _livefeedSlides$slideCurrentIndex$floorplanOptions.liveApiKey;
	    var mapApiKey = _livefeedSlides$slideCurrentIndex$floorplanOptions.mapApiKey;
	
	    var _useState = (0, _react.useState)([0, 0]);
	
	    var _useState2 = _slicedToArray(_useState, 2);
	
	    var centerArr = _useState2[0];
	    var setCenterArr = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false);
	
	    var _useState32 = _slicedToArray(_useState3, 2);
	
	    var globalMapConfig = _useState32[0];
	    var setGlobalMapConfig = _useState32[1];
	
	    var mapApiInputRef = (0, _react.useRef)(null);
	
	    (0, _react.useImperativeHandle)(ref, function () {
	        return {
	            focusMapApiInput: function focusMapApiInput() {
	                _focusMapApiInput();
	            }
	        };
	    });
	    function _focusMapApiInput() {
	        mapApiInputRef.current.focus();
	    }
	    function handleInput(value, type) {
	        globalMapConfig === true && setGlobalMapConfig(false);
	        var floatValue = value ? value : 0;
	        var floatNum = value;
	        if (type === 'lng' || type === 'lat' || type === 'zoom' || type === 'bearing' || type === 'pitch') {
	            floatNum = floatValue ? parseFloat(floatNum) : floatValue;
	        }
	        switch (type) {
	            case 'map':
	                setLivefeedOptionsHandle('mapApiKey', value);
	                break;
	            case 'live':
	                setLivefeedOptionsHandle('liveApiKey', value);
	                break;
	            case 'zoom':
	                setLivefeedOptionsHandle('mapConfig', { zoom: floatNum });
	                break;
	            case 'bearing':
	                setLivefeedOptionsHandle('mapConfig', { bearing: floatNum });
	                break;
	            case 'pitch':
	                setLivefeedOptionsHandle('mapConfig', { pitch: floatNum });
	                break;
	            case 'aniDuration':
	                setLivefeedOptionsHandle('mapConfig', { aniDuration: value });
	                break;
	            case 'use3dMap':
	                setLivefeedOptionsHandle('mapConfig', { use3dMap: value });
	                break;
	            case 'animationType':
	                setLivefeedOptionsHandle('mapConfig', { animationType: value });
	                break;
	
	        }
	        if (type === 'lat' || type === 'lng') {
	            var arr = [];
	            type === 'lng' ? arr = [floatNum, centerArr[1]] : arr = [centerArr[0], floatNum];
	            setCenterArr(arr);
	            setLivefeedOptionsHandle('mapConfig', { center: arr });
	        }
	        if (mapConfigMode === 'map_interact') {
	            // don't need to rerender for aniDuration || animationType
	            if (type === 'aniDuration' || type === 'animationType') {
	                dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)("map_interact"));
	            } else {
	                dispatch((0, _actionsLivefeedSteerpathMapActions.setMapConfigMode)("user_input"));
	            }
	        }
	    }
	    var animationTypes = [{ value: 'flyTo', label: 'Fly To', dataTip: 'Configure animated transition options ' }, { value: 'panTo', label: 'Pan To' }, { value: 'jumpTo', label: 'Jump To' }, { value: 'easeTo', label: 'Ease To' }];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'gauge-grid-item' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'editor-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header grid-item' },
	                'Steerpath Map Config'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'editor-text grid-item grid-item__title',
	                    'data-tip': 'Configure animated transition options ',
	                    'data-for': 'floorplanOptionsTooltip',
	                    style: { whiteSpace: "normal" } },
	                'API inputs'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item grid-item_flex' },
	                _react2['default'].createElement(
	                    'label',
	                    { className: 'api-label' },
	                    'Map Api Key'
	                ),
	                _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                    refProp: mapApiInputRef,
	                    className: 'api-input',
	                    value: mapApiKey,
	                    onChange: function (value) {
	                        return handleInput(value, "map");
	                    },
	                    required: true
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'editor-text grid-item grid-item_flex' },
	                _react2['default'].createElement(
	                    'label',
	                    { className: 'api-label' },
	                    'Live Api Key'
	                ),
	                _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                    className: 'api-input',
	                    value: liveApiKey,
	                    onChange: function (value) {
	                        return handleInput(value, "live");
	                    },
	                    required: true
	                })
	            ),
	            mapApiKey && _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'editor-text grid-item grid-item__title grid-item_divider-line',
	                        'data-tip': 'Configure animated transition options ',
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" } },
	                    'Map View Configuration'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Longitude'
	                    ),
	                    _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                        className: 'api-input',
	                        value: mapConfig.center[0],
	                        onChange: function (value) {
	                            return handleInput(value, "lng");
	                        },
	                        required: true
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Latitude'
	                    ),
	                    _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                        className: 'api-input',
	                        value: mapConfig.center[1],
	                        onChange: function (value) {
	                            return handleInput(value, "lat");
	                        },
	                        required: true
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Zoom'
	                    ),
	                    _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                        className: 'api-input',
	                        value: mapConfig.zoom,
	                        onChange: function (value) {
	                            return handleInput(value, "zoom");
	                        },
	                        required: true
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Bearing'
	                    ),
	                    _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                        className: 'api-input',
	                        value: mapConfig.bearing,
	                        onChange: function (value) {
	                            return handleInput(value, "bearing");
	                        },
	                        required: true
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Pitch'
	                    ),
	                    _react2['default'].createElement(_componentsCommonDelayInput2['default'], {
	                        placeholder: '0-60',
	                        className: 'api-input',
	                        value: mapConfig.pitch,
	                        onChange: function (value) {
	                            return handleInput(value, "pitch");
	                        },
	                        required: true
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        'data-tip': 'Uncheck this checkbox if you encounter slow, lag in map transition animation',
	                        'data-for': 'floorplanOptionsTooltip',
	                        className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(_componentsCommonCustomTickBox2['default'], {
	                        className: 'widget-label-setting',
	                        onClick: function () {
	                            handleInput(!mapConfig.use3dMap, "use3dMap");
	                        },
	                        label: 'Use 3D map',
	                        isActive: mapConfig.use3dMap
	                    })
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'editor-text grid-item grid-item__title grid-item_divider-line',
	                        'data-tip': 'Configure animated transition options ',
	                        'data-for': 'floorplanOptionsTooltip',
	                        style: { whiteSpace: "normal" } },
	                    'Map Transition Animation'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item grid-item_flex' },
	                    _react2['default'].createElement(
	                        'label',
	                        {
	                            style: {
	                                textAlign: 'left',
	                                letterSpacing: '-0.3px',
	                                padding: 0, whiteSpace: 'normal'
	                            },
	                            className: 'editor-text grid-item',
	                            'data-tip': 'Map transition animation type when changing between locations',
	                            'data-for': 'floorplanOptionsTooltip'
	                        },
	                        'Animation type'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'editor-text grid-item reactSelect-dropdown-wrapper',
	                            style: {
	                                width: "55%",
	                                paddingRight: 0,
	                                paddingLeft: 10
	                            } },
	                        _react2['default'].createElement(_reactSelect2['default'], {
	                            className: "location-dropdown reactSelect-aniType-dropdown",
	                            openOnFocus: true,
	                            clearable: false,
	                            closeOnSelect: true,
	                            onChange: function (value) {
	                                return handleInput(value, "animationType");
	                            },
	                            placeholder: mapConfig.animationType === null && "Click to see options",
	                            value: mapConfig.animationType,
	                            options: animationTypes
	                        })
	                    )
	                ),
	                mapConfig.animationType.value !== "jumpTo" && _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item duration-button' },
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'api-label' },
	                        'Animate Duration : ',
	                        mapConfig.aniDuration,
	                        's'
	                    ),
	                    _react2['default'].createElement('input', { type: 'range', id: 'aniDuration',
	                        step: 0.1,
	                        min: 1, max: Math.floor(slideDuration / 2),
	                        onChange: function (_ref) {
	                            var value = _ref.target.value;
	
	                            handleInput(value, "aniDuration");
	                        },
	                        value: mapConfig.aniDuration }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'indicator' },
	                        mapConfig.aniDuration,
	                        ' seconds'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'marker pull-left' },
	                        '1'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'marker pull-right' },
	                        Math.floor(slideDuration / 2)
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editor-text grid-item global-toggle-item grid-item_divider-line' },
	                    _react2['default'].createElement(
	                        'div',
	                        {
	                            'data-tip': 'Apply this map config to all slides',
	                            'data-for': 'floorplanOptionsTooltip',
	                            style: { whiteSpace: "normal" },
	                            className: 'global-option-toggle',
	                            onClick: function () {
	                                setGlobalMapConfig(!globalMapConfig);
	                                setLivefeedGlobalOptionsHandle(mapConfig);
	                            } },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'toggle-text' },
	                            'Apply to all slides'
	                        ),
	                        _react2['default'].createElement(_componentsCommonToggle2['default'], { isActive: globalMapConfig })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports['default'] = MapConfig;
	module.exports = exports['default'];
	/*------------------------------- MAP API------------------------ */ /*------------------------------- MAP VIEW CONFIG------------------------ */ /* Use 3D Map */ /*------------------------------- MAP TRANSITION ANIMATION------------------------ */ /*Ani Duration max value is equal to half of slideDuration  */ /*Ani Duration max value is equal to half of slideDuration  */ /*-------------------------------GLOBAL CONFIG APPLY ------------------------ */

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var WAIT_INTERVAL = 1000;
	var ENTER_KEY = 13;
	
	var DelayInput = (function (_Component) {
	    _inherits(DelayInput, _Component);
	
	    function DelayInput(props) {
	        _classCallCheck(this, DelayInput);
	
	        _get(Object.getPrototypeOf(DelayInput.prototype), 'constructor', this).call(this);
	        this.state = {
	            value: props.value
	        };
	        this.triggerChange = this.triggerChange.bind(this);
	        this.handleChange = this.handleChange.bind(this);
	        this.handleKeyDown = this.handleKeyDown.bind(this);
	    }
	
	    _createClass(DelayInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.timer = null;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value !== this.props.value) {
	                this.setState({ value: nextProps.value });
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            clearTimeout(this.timer);
	
	            this.setState({ value: e.target.value });
	
	            this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (e.keyCode === ENTER_KEY) {
	                this.triggerChange();
	            }
	        }
	    }, {
	        key: 'triggerChange',
	        value: function triggerChange() {
	            var value = this.state.value;
	
	            this.props.onChange(value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var refProp = _props.refProp;
	            var className = _props.className;
	            var placeholder = _props.placeholder;
	            var required = _props.required;
	
	            return _react2['default'].createElement('input', {
	                ref: refProp,
	                required: required,
	                className: className,
	                placeholder: placeholder,
	                value: this.state.value,
	                onChange: this.handleChange,
	                onKeyDown: this.handleKeyDown
	            });
	        }
	    }]);
	
	    return DelayInput;
	})(_react.Component);
	
	exports['default'] = DelayInput;
	module.exports = exports['default'];

/***/ }),
/* 2289 */
[2373, 2290],
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".api-label{flex:.5;justify-content:flex-start;font-weight:400}.api-input,.api-label{display:flex;align-items:center}.api-input{flex:.8;justify-content:flex-end;width:145px;padding:0 5px;font-size:14px}.reactSelect-dropdown-wrapper .reactSelect-aniType-dropdown{width:120px}", ""]);
	
	// exports


/***/ }),
/* 2291 */
[2374, 2292],
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(381)();
	// imports
	
	
	// module
	exports.push([module.id, ".editor-pane-container{padding-top:6px;display:inline-grid;vertical-align:middle;grid-template-columns:260px;color:#000}.editor-pane-container .editor-container{margin-bottom:20px;border-radius:2px;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);display:grid;margin-left:3px;margin-right:3px}.editor-pane-container .editor-container .editor-text{text-align:center;margin:0;padding:6px 10px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:400;background-color:#e8f7ea}.editor-pane-container .editor-container .grid-item{grid-column-start:1;grid-column-end:5}.editor-pane-container .editor-container .grid-item_divider-line{border-top:1px solid #bdbdbd}.editor-pane-container .editor-container .grid-item_flex{display:flex;align-items:center}.editor-pane-container .editor-container .grid-item__title{font-weight:700}.editor-pane-container .editor-container .header{width:100%;background-color:#3cb449;color:#f2f2f2;text-align:center;padding:3px 6px}.editor-pane-container .duration-button{position:relative}.editor-pane-container .duration-button .marker{display:inline-block}.editor-pane-container .duration-button input[type=range]{margin-top:4px;margin-bottom:8px;-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;height:7px;border-radius:4px;background:#bdbdbd;outline:none;cursor:pointer}.editor-pane-container .duration-button input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:18px;height:18px;border-radius:50%;background:#3cb449;cursor:pointer}.editor-pane-container .duration-button input[type=range]:active+.indicator,.editor-pane-container .duration-button input[type=range]:hover+.indicator{opacity:1}.editor-pane-container .duration-button .indicator{font-size:.8em;color:#fff;left:50%;position:absolute;padding:4px 10px;background-color:rgba(0,0,0,.7);transform:translateX(-50%);opacity:0;transition:opacity .2s ease}.editor-pane-container .global-toggle-item{border-top:1px solid #bdbdbd;padding-top:6px}.editor-pane-container .occupied-toggle{display:flex;justify-content:center;align-items:center;white-space:normal;padding:0 20px}.editor-pane-container .occupied-toggle .toggle-text{font-size:14px;cursor:pointer;vertical-align:middle;display:inline-block}.editor-pane-container .occupied-toggle .toggle-box{margin-right:auto}.editor-pane-container .global-option-toggle,.editor-pane-container .global-scroll-toggle,.editor-pane-container .scroll-toggle{display:flex;justify-content:center;align-items:center;padding:0 25px 0 35px}.editor-pane-container .global-option-toggle .toggle-text,.editor-pane-container .global-scroll-toggle .toggle-text,.editor-pane-container .scroll-toggle .toggle-text{font-size:14px;cursor:pointer;vertical-align:middle;display:inline-block}.editor-pane-container .global-option-toggle .scroll-help,.editor-pane-container .global-scroll-toggle .scroll-help,.editor-pane-container .scroll-toggle .scroll-help{vertical-align:middle;cursor:pointer;font-size:14px;margin-left:6px}.editor-pane-container .widget-label-setting{text-align:left;margin-top:0}.editor-pane-container .widget-label-setting:first-of-type{margin-bottom:0}.editor-pane-container .widget-label-setting .checkmark{background-color:#fff}.editor-pane-container .widget-label-setting .checkmark:hover{background-color:#f2f2f2}.editor-pane-container .widget-label-setting .checkmark_active{background-color:#3cb449}.editor-pane-container .widget-label-setting .checkmark_active:after{display:block}.editor-pane-container .widget-label-setting .checkmark_active:hover{background-color:#2f8e39}.editor-pane-container .widget-label-setting .checkmark:focus{outline:5px auto #3cb449;outline-offset:-2px}", ""]);
	
	// exports


/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _card = __webpack_require__(2294);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _actionsDefaultsettings = __webpack_require__(362);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var DefaultSettings = (function (_React$Component) {
		_inherits(DefaultSettings, _React$Component);
	
		function DefaultSettings() {
			_classCallCheck(this, DefaultSettings);
	
			_get(Object.getPrototypeOf(DefaultSettings.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(DefaultSettings, [{
			key: 'defaultCard',
			value: function defaultCard(cards) {
				var res = {};
				Object.keys(cards).map(function (key) {
					if (cards[key].isdefault) {
						res = cards[key];
					}
				});
				return res;
			}
		}, {
			key: 'addCard',
			value: function addCard() {
				this.props.dispatch((0, _actionsDefaultsettings.addCard)({
					starthour: 8,
					endhour: 17,
					weekdaymask: "0111110"
				}));
				_toastr2['default'].success("New user settings card is added successfully !");
			}
		}, {
			key: 'isCompanyAdmin',
			value: function isCompanyAdmin(user) {
				var node = this.props.nodeMap[this.props.me.rootnodeid];
				return user.role == "ADMIN" && node && node.type == "customer";
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var editable = this.isCompanyAdmin(this.props.me);
				return _react2['default'].createElement(
					'div',
					{ className: 'default-settings-page overwrite--modal--depth' },
					_react2['default'].createElement(
						_componentsCommonStickymenu2['default'],
						{
							withStickyHeader: false
						},
						_react2['default'].createElement(_componentsCommonMainmenu2['default'], {
							overviewIsActive: false,
							comparisonIsActive: false,
							onlyLeftMenu: true
						}),
						_react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
							leftItemBold: 'Default Settings',
							leftItems: _react2['default'].createElement(
								_react2['default'].Fragment,
								null,
								editable && _react2['default'].createElement(
									'span',
									{ className: 'stats-menu__list-item  cursor--pointer', onClick: this.addCard.bind(this) },
									_react2['default'].createElement(
										'div',
										{ className: 'stats-menu-btn display--flex__flex--center' },
										_react2['default'].createElement('span', { style: { fontSize: 27, marginRight: 8 }, className: 'font-icon icon-addicon' }),
										_react2['default'].createElement(
											'span',
											{ className: 'stats-menu-btn__label' },
											'Add Local Settings Card'
										)
									)
								)
							)
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: 'page-content page-content_padding-modifier display--flex__flex--center', style: { flexWrap: "wrap" } },
						Object.keys(this.props.cards).map(function (key) {
							if (key == "default") {
								// Default card (company card) has 2 instances : cards[$id] and card["default"]
								return null;
							}
							var card = _this.props.cards[key];
							return _react2['default'].createElement(_card2['default'], {
								key: card.id,
								card: card,
								root: _this.props.root,
								disabled: card.isdefault == 1,
								editable: editable,
								defaultCard: _this.defaultCard(_this.props.cards)
							});
						})
					)
				);
			}
		}]);
	
		return DefaultSettings;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			root: state.overviewReducer.customerOverview,
			cards: state.defaultSettingsReducer.card,
			me: state.myAccountReducer.user,
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DefaultSettings);
	module.exports = exports['default'];

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _componentsCommonTimepicker = __webpack_require__(1234);
	
	var _componentsCommonTimepicker2 = _interopRequireDefault(_componentsCommonTimepicker);
	
	var _componentsCommonAutosaveinput = __webpack_require__(2295);
	
	var _componentsCommonAutosaveinput2 = _interopRequireDefault(_componentsCommonAutosaveinput);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var _actionsDefaultsettings = __webpack_require__(362);
	
	var _LocationPicker = __webpack_require__(2296);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _componentsCommonDropdowncomponentsDropdown = __webpack_require__(1240);
	
	var _componentsCommonDropdowncomponentsDropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdown);
	
	var _componentsCommonDropdowncomponentsDropdownitem = __webpack_require__(1242);
	
	var _componentsCommonDropdowncomponentsDropdownitem2 = _interopRequireDefault(_componentsCommonDropdowncomponentsDropdownitem);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var Card = (function (_React$Component) {
		_inherits(Card, _React$Component);
	
		function Card(props, context) {
			_classCallCheck(this, Card);
	
			_get(Object.getPrototypeOf(Card.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				starthour: this.props.card.starthour,
				endhour: this.props.card.endhour
			};
		}
	
		_createClass(Card, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.card.starthour != this.state.starthour || nextProps.card.endhour != this.state.endhour) {
					this.setState({
						starthour: nextProps.card.starthour,
						endhour: nextProps.card.endhour,
						weekdaymask: nextProps.card.weekdaymask
					});
				}
			}
		}, {
			key: 'maskChecked',
			value: function maskChecked(pos) {
				if (!this.props.card.weekdaymask) {
					return false;
				}
				return this.props.card.weekdaymask[pos] == "1";
			}
		}, {
			key: 'changeHour',
			value: function changeHour(hours) {
				var newCard = {
					id: this.props.card.id,
					starthour: hours[0],
					endhour: hours[1] - 1
				};
				this.props.dispatch((0, _actionsDefaultsettings.updateCard)(newCard));
			}
		}, {
			key: 'replaceAt',
			value: function replaceAt(s, index, replacement) {
				return s.substr(0, index) + replacement + s.substr(index + replacement.length);
			}
		}, {
			key: 'changeWeekday',
			value: function changeWeekday(pos) {
				var newCard = {
					id: this.props.card.id,
					weekdaymask: this.replaceAt(this.props.card.weekdaymask, pos, this.props.card.weekdaymask[pos] == "0" ? "1" : "0")
				};
				this.props.dispatch((0, _actionsDefaultsettings.updateCard)(newCard));
			}
		}, {
			key: 'deleteCard',
			value: function deleteCard() {
				this.props.dispatch((0, _actionsDefaultsettings.deleteCard)(this.props.card));
			}
		}, {
			key: 'addNodeToCardfn',
			value: function addNodeToCardfn(node, Card) {
				var card = Card;
				if (node.info.cardid == card.id) {
					card = this.props.defaultCard;
				}
				this.props.dispatch((0, _actionsDefaultsettings.addNodeToCard)(node, card));
			}
		}, {
			key: 'onSave',
			value: function onSave(idKey, value) {
				if (idKey == "standbytime") {
					var newCard = {
						id: this.props.card.id,
						standbytime: value * 60
					};
					this.props.dispatch((0, _actionsDefaultsettings.updateCard)(newCard));
				}
			}
		}, {
			key: 'renderWeekdays',
			value: function renderWeekdays() {
				var _this = this;
	
				var items = [].concat(_toConsumableArray(Array(7).keys())).slice(0).map(function (index) {
					var weekdays = new Array(7);
					weekdays[0] = "Sunday";
					weekdays[1] = "Monday";
					weekdays[2] = "Tuesday";
					weekdays[3] = "Wednesday";
					weekdays[4] = "Thursday";
					weekdays[5] = "Friday";
					weekdays[6] = "Saturday";
					return _react2['default'].createElement(
						'label',
						{ className: 'text-center', key: index },
						_react2['default'].createElement('input', { className: 'chbx', type: 'checkbox', checked: _this.maskChecked(index), onChange: _this.changeWeekday.bind(_this, index), disabled: !_this.props.editable }),
						_react2['default'].createElement('span', { className: 'custom-checkbox' }),
						_react2['default'].createElement(
							'span',
							{ className: 'week-day' },
							weekdays[index]
						)
					);
				});
				items.push(items.shift());
				return items;
			}
		}, {
			key: 'render',
			value: function render() {
				var header = this.props.card.isdefault ? "Company Settings" : "Local Settings";
				var editable = this.props.editable;
				var deletable = editable && this.props.card.isdefault == 0;
	
				return _react2['default'].createElement(
					'div',
					{ className: 'default-settings-card box--shadow bg--white clearfix' },
					_react2['default'].createElement(
						'div',
						{ className: 'card-heading clearfix' },
						_react2['default'].createElement(
							'h3',
							{ className: 'pull-left' },
							header
						),
						_react2['default'].createElement(_LocationPicker2['default'], {
							root: this.props.root,
							card: this.props.card,
							disabled: this.props.disabled || !editable,
							defaultCard: this.props.defaultCard,
							handleChange: this.addNodeToCardfn.bind(this)
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: 'working-hours' },
						_react2['default'].createElement(
							'h4',
							null,
							'Working Hours'
						),
						_react2['default'].createElement(
							'div',
							{ className: 'hours-picker' },
							_react2['default'].createElement(_componentsCommonTimepicker2['default'], {
								disabled: !editable,
								nSegments: 24,
								values: [this.props.card.starthour, this.props.card.endhour + 1],
								onChange: this.changeHour.bind(this)
							})
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'working-days', style: { marginTop: 50 } },
						_react2['default'].createElement(
							'h4',
							null,
							'Working Days'
						),
						_react2['default'].createElement(
							'div',
							{ className: 'days-picker clearfix' },
							this.renderWeekdays()
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'box-settings' },
						_react2['default'].createElement(
							'div',
							{ className: 'box-settings__child display--flex__flex--center' },
							_react2['default'].createElement(
								'label',
								null,
								'Stand By Time (minutes)'
							),
							_react2['default'].createElement(_componentsCommonAutosaveinput2['default'], {
								className: 'input--minute',
								type: 'number',
								idKey: 'standbytime',
								value: Math.round(this.props.card.standbytime / 60),
								style: {
									width: "60px", paddingLeft: 10,
									textAlign: "center"
								},
								editable: editable,
								onSave: this.onSave.bind(this)
							})
						),
						_config2['default'].api.root === 'https://backend-dev.senzodata.com/api' && _react2['default'].createElement(
							_react2['default'].Fragment,
							null,
							_react2['default'].createElement(TimeInterval, {
								editable: editable,
								card: this.props.card
							}),
							_react2['default'].createElement(OccupancyThreshold, {
								editable: editable,
								card: this.props.card
							})
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'default-settings-bottom' },
						_react2['default'].createElement(
							'div',
							{ className: 'pull-right' },
							deletable && _react2['default'].createElement(
								_componentsCommonModal2['default'],
								{
									clickButton: this.deleteCard.bind(this),
									header: 'Delete Card',
									buttonText: 'Delete',
									buttonClass: 'btn-danger',
									entry: _react2['default'].createElement(
										'i',
										{ 'data-tooltip': 'Delete', className: 'material-icons_size material-icons cursor--pointer red-500 pull-left' },
										'delete_forever'
									)
								},
								_react2['default'].createElement(
									'p',
									null,
									'Are you sure you want to delete this setting card ?'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Card;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			me: state.myAccountReducer.user,
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Card);
	
	var TimeInterval = function TimeInterval(props) {
		//const dispatch = useDispatch();
	
		var _useState = (0, _react.useState)(60);
	
		var _useState2 = _slicedToArray(_useState, 2);
	
		var intervalVal = _useState2[0];
		var setIntervalVal = _useState2[1];
		var card = props.card;
		var editable = props.editable;
	
		function handleUpdateTimeInterval() {
			var newCard = {
				id: card.id,
				intervalVal: intervalVal
			};
			//dispatch(updateCard(newCard));
		}
		var intervalValueArr = [10, 30, 60, 86400];
		return _react2['default'].createElement(
			'div',
			{ className: 'box-settings__child display--flex__flex--center' },
			_react2['default'].createElement(
				'label',
				null,
				'Time Interval'
			),
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdown2['default'],
				{
					noArrow: true,
					className: 'box-settings__child__dropdown',
					header: _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						intervalVal !== 86400 ? intervalVal + ' min' : "Full day",
						_react2['default'].createElement(
							'i',
							{ className: 'material-icons' },
							'keyboard_arrow_down'
						)
					),
					toggleable: editable
				},
				intervalValueArr.map(function (x) {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						{ key: x },
						_react2['default'].createElement(
							_componentsCommonDropdowncomponentsDropdownitem2['default'],
							null,
							_react2['default'].createElement(
								'div',
								{ onClick: function () {
										setIntervalVal(x);
										handleUpdateTimeInterval();
									} },
								x !== 86400 ? x + ' min' : "Full day"
							)
						)
					);
				})
			)
		);
	};
	
	var OccupancyThreshold = function OccupancyThreshold(props) {
		//const dispatch = useDispatch();
	
		var _useState3 = (0, _react.useState)(0);
	
		var _useState32 = _slicedToArray(_useState3, 2);
	
		var occupancyThreshold = _useState32[0];
		var setOccupancyThreshold = _useState32[1];
		var card = props.card;
		var editable = props.editable;
	
		function handleUpdateThreshold() {
			var newCard = {
				id: card.id,
				occupancyThreshold: occupancyThreshold
			};
			//dispatch(updateCard(newCard));
		}
		var thresholdValueArr = [0, 10, 20];
		return _react2['default'].createElement(
			'div',
			{ className: 'box-settings__child display--flex__flex--end--center' },
			_react2['default'].createElement(
				'label',
				null,
				'Occupancy Threshold'
			),
			_react2['default'].createElement(
				_componentsCommonDropdowncomponentsDropdown2['default'],
				{
					noArrow: true,
					className: 'box-settings__child__dropdown',
					header: _react2['default'].createElement(
						_react2['default'].Fragment,
						null,
						(occupancyThreshold !== 0 ? '>=' + occupancyThreshold : '>' + occupancyThreshold) + ' %',
						_react2['default'].createElement(
							'i',
							{ className: 'material-icons' },
							'keyboard_arrow_down'
						)
					),
					toggleable: editable
				},
				thresholdValueArr.map(function (value) {
					return _react2['default'].createElement(
						_react2['default'].Fragment,
						{ key: value },
						_react2['default'].createElement(
							_componentsCommonDropdowncomponentsDropdownitem2['default'],
							{ style: { textAlign: "center" } },
							_react2['default'].createElement(
								'div',
								{ onClick: function () {
										setOccupancyThreshold(value);
										handleUpdateThreshold();
									} },
								(value !== 0 ? '>=' + value : '>' + value) + ' %'
							)
						)
					);
				})
			)
		);
	};
	module.exports = exports['default'];

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClickOutside = __webpack_require__(1255);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var AutoSaveInput = (function (_Component) {
		_inherits(AutoSaveInput, _Component);
	
		function AutoSaveInput(props, context) {
			_classCallCheck(this, AutoSaveInput);
	
			_get(Object.getPrototypeOf(AutoSaveInput.prototype), "constructor", this).call(this, props, context);
			this.state = {
				open: false,
				value: this.props.value
			};
		}
	
		_createClass(AutoSaveInput, [{
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps) {
				if (!this.state.open) {
					this.setState({ value: nextProps.value });
				}
			}
		}, {
			key: "onChange",
			value: function onChange(e) {
				this.setState({
					value: e.target.value
				});
			}
		}, {
			key: "onClick",
			value: function onClick(e) {
				if (this.props.editable) {
					this.setState({
						open: true
					});
				}
			}
		}, {
			key: "handleClickOutside",
			value: function handleClickOutside() {
				if (this.state.open) {
					// will close
					this.setState({
						open: false
					});
					if (typeof this.props.onSave == "function" && this.props.value != this.state.value) {
						this.props.onSave(this.props.idKey, this.state.value);
					}
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps, prevState) {
				if (!prevState.open && this.state.open) {
					this.input.focus();
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this = this;
	
				return _react2["default"].createElement(
					"span",
					{ onClick: function (e) {
							return _this.onClick(e);
						} },
					_react2["default"].createElement("input", {
						ref: function (me) {
							_this.input = me;
						},
						type: this.props.type,
						value: this.state.value,
						className: this.props.className + " " + (this.props.editable ? "editable" : "uneditable"),
						style: this.props.style,
						disabled: this.props.editable ? false : !this.state.open,
						onChange: function (e) {
							return _this.onChange(e);
						}
					})
				);
			}
		}]);
	
		return AutoSaveInput;
	})(_react.Component);
	
	exports["default"] = (0, _reactClickOutside2["default"])(AutoSaveInput);
	module.exports = exports["default"];

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClickOutside = __webpack_require__(1255);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var LocationPicker = (function (_React$Component) {
	    _inherits(LocationPicker, _React$Component);
	
	    function LocationPicker(props, context) {
	        _classCallCheck(this, LocationPicker);
	
	        _get(Object.getPrototypeOf(LocationPicker.prototype), "constructor", this).call(this, props, context);
	        this.state = {
	            open: false
	        };
	    }
	
	    _createClass(LocationPicker, [{
	        key: "toggle",
	        value: function toggle() {
	            this.setState({ open: !this.state.open });
	        }
	    }, {
	        key: "handleClickOutside",
	        value: function handleClickOutside() {
	            if (this.state.open) {
	                this.toggle();
	            }
	        }
	    }, {
	        key: "renderTree",
	        value: function renderTree(root) {
	            var _this = this;
	
	            var self = this;
	            if (!root) {
	                return null;
	            }
	            /*  for (var i = 0; i < root.children.length; i++) {
	                  if (root.children[i].type == "sensor") {
	                      return null;
	                  }
	              }*/
	            return _react2["default"].createElement(
	                "div",
	                { className: "location-picker-dropdown", key: root.id },
	                root.type != "customer" ? _react2["default"].createElement(
	                    "label",
	                    null,
	                    _react2["default"].createElement("input", {
	                        type: "checkbox",
	                        disabled: this.props.disabled,
	                        checked: root.info.cardid == this.props.card.id,
	                        onChange: function () {
	                            return _this.props.handleChange(root, _this.props.card);
	                        }
	                    }),
	                    _react2["default"].createElement(
	                        "span",
	                        { className: this.props.disabled ? "disabled" : "" },
	                        root.info.name
	                    )
	                ) : null,
	                root.children.map(function (x) {
	                    if (x.type != "sensor") {
	                        return self.renderTree(x);
	                    } else {
	                        return null;
	                    }
	                })
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2["default"].createElement(
	                "div",
	                { className: "pull-right location-picker" },
	                _react2["default"].createElement(
	                    "a",
	                    { type: "button", className: "", onClick: this.toggle.bind(this) },
	                    "Locations "
	                ),
	                _react2["default"].createElement("i", { className: "fa fa-chevron-down", "aria-hidden": "true" }),
	                _react2["default"].createElement(
	                    "div",
	                    { className: "dropdown-menu " + (this.state.open ? "" : "hidden"),
	                        style: {
	                            maxHeight: 300,
	                            minWidth: 370,
	                            overflow: "auto",
	                            zIndex: 1001 // display in front of TimeInterval & OccupancyThreshold
	                        },
	                        "aria-labelledby": "loc-picker" },
	                    this.renderTree(this.props.root)
	                )
	            );
	        }
	    }]);
	
	    return LocationPicker;
	})(_react2["default"].Component);
	
	exports["default"] = (0, _reactClickOutside2["default"])(LocationPicker);
	module.exports = exports["default"];

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionsSensorsettings = __webpack_require__(360);
	
	var _actionsNode = __webpack_require__(202);
	
	var _componentsCommonDropdowncomponentsNodedropdown = __webpack_require__(1304);
	
	var _componentsCommonDropdowncomponentsNodedropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsNodedropdown);
	
	var _componentsCommonDropdowncomponentsListdropdown = __webpack_require__(1305);
	
	var _componentsCommonDropdowncomponentsListdropdown2 = _interopRequireDefault(_componentsCommonDropdowncomponentsListdropdown);
	
	var _componentsCommonPath = __webpack_require__(1302);
	
	var _componentsCommonPath2 = _interopRequireDefault(_componentsCommonPath);
	
	var _sensorlist = __webpack_require__(2298);
	
	var _sensorlist2 = _interopRequireDefault(_sensorlist);
	
	var _editModal = __webpack_require__(2300);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _deleteModal = __webpack_require__(2301);
	
	var _deleteModal2 = _interopRequireDefault(_deleteModal);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var SensorSettings = (function (_React$Component) {
		_inherits(SensorSettings, _React$Component);
	
		function SensorSettings(props, context) {
			_classCallCheck(this, SensorSettings);
	
			_get(Object.getPrototypeOf(SensorSettings.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				I: {},
				DOpen: false, // delete sensor modal open ?
				Drespond: "",
				DrespondClass: "",
	
				EOpen: false, // edit sensor modal open ?
				Erespond: "",
				ErespondClass: ""
			};
		}
	
		_createClass(SensorSettings, [{
			key: 'DOpen',
			value: function DOpen() {
				this.setState({ DOpen: true });
			}
		}, {
			key: 'DClose',
			value: function DClose() {
				this.props.dispatch((0, _actionsSensorsettings.selectSensorButton)({}));
				this.setState({ DOpen: false });
			}
		}, {
			key: 'EOpen',
			value: function EOpen() {
				this.setState({ EOpen: true });
			}
		}, {
			key: 'EClose',
			value: function EClose() {
				this.props.dispatch((0, _actionsSensorsettings.selectSensorButton)({}));
				this.setState({ EOpen: false });
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				this.props.dispatch((0, _actionsNode.fetchLiveData)());
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.fetchData();
				var self = this;
				var I = setInterval(function () {
					self.fetchData();
				}, 5000);
				this.setState({ I: I });
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.state.I);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// Init nodeFilter
				if (this.props.nodeFilter.id == -2 && nextProps.tree.id != -2) {
					this.props.dispatch((0, _actionsSensorsettings.selectNodeFilter)(nextProps.tree));
				}
				// Editing stages
				switch (nextProps.Estage) {
					case "editing":
						this.setState({
							Erespond: "Editing...",
							ErespondClass: "text-loading"
						});
						if (nextProps.fetched) {
							this.props.dispatch((0, _actionsSensorsettings.needData)());
						}
						break;
					case "edited":
						this.setState({
							Erespond: "Sensor edited.",
							ErespondClass: "text-green"
						});
						if (!nextProps.fetched) {
							this.fetchData();
						}
						break;
					case "edit-failed":
						this.setState({
							Erespond: "Failed to edit this sensor !",
							ErespondClass: "text-red"
						});
						break;
					default:
						// "nothing"
						this.setState({
							Erespond: "",
							ErespondClass: ""
						});
				}
				// Deleting stages
				switch (nextProps.Dstage) {
					case "deleting":
						if (nextProps.fetched) {
							this.props.dispatch((0, _actionsSensorsettings.needData)());
						}
						break;
					case "deleted":
						if (!nextProps.fetched) {
							this.fetchData();
						}
						this.DClose();
						break;
					default: // nothing
				}
			}
		}, {
			key: 'getPath',
			value: function getPath() {
				var cur = this.props.nodeFilter,
				    tmp = [],
				    path = [];
				while (cur) {
					tmp.push(cur);
					cur = cur.parent;
				}
				// reverse tmp to get the path.
				while (tmp.length) {
					path.push(tmp[tmp.length - 1]);
					tmp.pop();
				}
				return path;
			}
		}, {
			key: 'listNodeFilter',
			value: function listNodeFilter(root, res) {
				var self = this;
				if (root) {
					if (root.type != "sensor") {
						res.push(root);
						root.children.forEach(function (child) {
							self.listNodeFilter(child, res);
						});
					}
				}
			}
		}, {
			key: 'clickDeleteButton',
			value: function clickDeleteButton() {
				this.props.dispatch((0, _actionsSensorsettings.deleteSensor)(this.props.selectedSensor));
			}
		}, {
			key: 'linkOn',
			value: function linkOn(x) {
				return true;
			}
		}, {
			key: 'link',
			value: function link(x) {
				return null;
			}
		}, {
			key: 'onClick',
			value: function onClick(e, x) {
				e.preventDefault();
				this.props.dispatch((0, _actionsSensorsettings.selectNodeFilter)(x));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					'div',
					{ className: 'sensor-settings-page overwrite--modal--depth' },
					_react2['default'].createElement(
						_componentsCommonStickymenu2['default'],
						{
							withStickyHeader: false
						},
						_react2['default'].createElement(_componentsCommonMainmenu2['default'], {
							overviewIsActive: false,
							comparisonIsActive: false,
							onlyLeftMenu: true
						}),
						_react2['default'].createElement(_componentsCommonStatsmenu2['default'], {
							leftItemBold: 'Sensor Settings',
							leftItems: _react2['default'].createElement(
								_react2['default'].Fragment,
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'stats-menu__select stats-menu__list-item ' },
									_react2['default'].createElement(_componentsCommonDropdowncomponentsNodedropdown2['default'], {
										outsideClass: 'dropdown-btn settings-dropdown pull-left',
										root: this.props.tree,
										nodeFilter: this.props.nodeFilter,
										click: function (node) {
											_this.props.dispatch((0, _actionsSensorsettings.selectNodeFilter)(node));
										} /* this.props.dispatch(useradSelectNode(node)) }*/
										,
										list: this.listNodeFilter.bind(this),
										header: 'All locations'
									})
								),
								_react2['default'].createElement(
									'span',
									{ className: 'stats-menu__select stats-menu__list-item ' },
									_react2['default'].createElement(_componentsCommonDropdowncomponentsListdropdown2['default'], {
										outsideClass: 'dropdown-btn settings-dropdown pull-left',
										items: _config2['default'].sensorStatusFilter,
										getText: function (x) {
											return x.text;
										},
										selected: this.props.sensorStatusFilter,
										click: function (status) {
											_this.props.dispatch((0, _actionsSensorsettings.selectSensorStatusFilter)(status));
										}
									})
								)
							)
						}),
						_react2['default'].createElement(_componentsCommonPath2['default'], {
							path: this.getPath(),
							linkOn: this.linkOn.bind(this),
							link: this.link.bind(this),
							onClick: this.onClick.bind(this)
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: 'page-content page-content_padding-modifier' },
						_react2['default'].createElement(
							'div',
							{ className: 'display--flex__flex--start--center' },
							_react2['default'].createElement(
								'div',
								{ className: 'sensors-table-wrapper' },
								_react2['default'].createElement(_sensorlist2['default'], {
									root: this.props.nodeFilter,
									statusFilter: this.props.sensorStatusFilter,
									sensorMap: this.props.sensorMap,
									nodeMap: this.props.nodeMap,
									openDeleteModal: this.DOpen.bind(this),
									openEditModal: this.EOpen.bind(this),
									selectedSensor: this.props.selectedSensor
								}),
								_react2['default'].createElement(_editModal2['default'], {
									open: this.state.EOpen,
									closeModal: this.EClose.bind(this),
									sensor: this.props.selectedSensor,
									respond: this.state.Erespond,
									respondClass: this.state.ErespondClass
								}),
								_react2['default'].createElement(_deleteModal2['default'], {
									open: this.state.DOpen,
									closeModal: this.DClose.bind(this),
									respond: this.state.Drespond,
									respondClass: this.state.DrespondClass,
									clickButton: this.clickDeleteButton.bind(this)
								})
							)
						)
					)
				);
			}
		}]);
	
		return SensorSettings;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
		return {
			tree: state.overviewReducer.customerOverview,
			nodeMap: state.overviewReducer.nodeMap,
			sensorMap: state.nodeReducer.map,
			me: state.myAccountReducer.user,
	
			selectedSensor: state.sensorSettingsReducer.selectedSensor,
			nodeFilter: state.sensorSettingsReducer.nodeFilter,
			sensorStatusFilter: state.sensorSettingsReducer.sensorStatusFilter,
	
			Estage: state.sensorSettingsReducer.Estage,
			Erespond: state.sensorSettingsReducer.Erespond,
	
			Dstage: state.sensorSettingsReducer.Dstage,
			Drespond: state.sensorSettingsReducer.Drespond,
			fetched: state.sensorSettingsReducer.fetched
	
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SensorSettings);
	module.exports = exports['default'];

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactRouter = __webpack_require__(86);
	
	var _config = __webpack_require__(163);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactTimestamp = __webpack_require__(1311);
	
	var _reactTimestamp2 = _interopRequireDefault(_reactTimestamp);
	
	var _sensor = __webpack_require__(2299);
	
	var _sensor2 = _interopRequireDefault(_sensor);
	
	var _componentsCommonColornote = __webpack_require__(1306);
	
	var _componentsCommonColornote2 = _interopRequireDefault(_componentsCommonColornote);
	
	var _actionsSensorsettings = __webpack_require__(360);
	
	// SELECT_SENSOR
	
	var SensorList = (function (_React$Component) {
		_inherits(SensorList, _React$Component);
	
		function SensorList(props, context) {
			_classCallCheck(this, SensorList);
	
			_get(Object.getPrototypeOf(SensorList.prototype), 'constructor', this).call(this, props, context);
		}
	
		_createClass(SensorList, [{
			key: 'openEdit',
			value: function openEdit(sensor) {
				this.props.dispatch((0, _actionsSensorsettings.selectSensorButton)(sensor));
				this.props.openEditModal();
			}
		}, {
			key: 'openDelete',
			value: function openDelete(sensor) {
				this.props.dispatch((0, _actionsSensorsettings.selectSensorButton)(sensor));
				this.props.openDeleteModal();
			}
		}, {
			key: 'getStatus',
			value: function getStatus(ss) {
				var status = "free";
				if (ss.registered) {
					if (ss.faulty) {
						status = "faulty";
					} else {
						if (ss.inuse) {
							status = "inuse";
						} else if (ss.standby) {
							status = "standby";
						}
					}
				} else {
					status = "unregistered";
				}
				return status;
			}
		}, {
			key: 'filter',
			value: function filter(sensor) {
				var ss = this.props.sensorMap.get(sensor.id);
				if (!ss) {
					return false;
				}
				var status = this.getStatus(ss);
				switch (this.props.statusFilter.code) {
					case _config2['default'].sensorStatusFilter[0].code:
						// All
						return true;
					case _config2['default'].sensorStatusFilter[1].code:
						// Online
						return status == "free" || status == "inuse" || status == "standby";
					case _config2['default'].sensorStatusFilter[2].code:
						// Offine
						return status == "faulty" || status == "unregistered";
					// case "UNREG":
					// 	return status=="unregistered";
					default:
						return false;
				}
			}
		}, {
			key: 'OfflineSince',
			value: function OfflineSince(ss) {
				if (!ss) {
					return null;
				}
				var status = this.getStatus(ss);
				switch (status) {
					case "faulty":
						return _react2['default'].createElement(_reactTimestamp2['default'], { time: ss.lastonl });
					default:
						return _react2['default'].createElement(
							'span',
							{ className: 'dash-dash' },
							'--'
						);
				}
			}
		}, {
			key: 'listSensors',
			value: function listSensors(root, res) {
				var self = this;
				if (root) {
					if (root.type == "sensor" && this.filter(root)) {
						res.push(root);
					} else {
						root.children.map(function (x) {
							return self.listSensors(x, res);
						});
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var sensors = [];
				this.listSensors(this.props.root, sensors);
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement(
						'div',
						{ className: 'white-box-container box--shadow bg--white' },
						_react2['default'].createElement(
							'table',
							{ className: 'flat-table sensor-table' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(
									'tr',
									{ className: 'table-header-row' },
									_react2['default'].createElement('th', null),
									_react2['default'].createElement(
										'th',
										null,
										'MAC ADDRESS'
									),
									_react2['default'].createElement(
										'th',
										null,
										'NAME'
									),
									_react2['default'].createElement(
										'th',
										null,
										'LOCATION'
									),
									_react2['default'].createElement(
										'th',
										null,
										'OFFLINE SINCE'
									),
									_react2['default'].createElement('th', { colSpan: '3' })
								),
								sensors.map(function (x, idx) {
									var ss = Object.assign({}, _this.props.sensorMap.get(x.id));
									if (!ss) {
										return null;
									}
									ss.xpercent = 50;
									ss.ypercent = 50;
									var par = _this.props.nodeMap[x.id].parent;
									return _react2['default'].createElement(
										'tr',
										{ key: idx, className: _this.props.selectedSensor.id == x.id ? "bold" : "" },
										_react2['default'].createElement(
											'td',
											{ className: 'sensor-color-note__td' },
											_react2['default'].createElement(_sensor2['default'], { sensor: ss })
										),
										_react2['default'].createElement(
											'td',
											null,
											ss.macaddress
										),
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(
												_reactRouter.Link,
												{ to: "/live/" + par.id, target: '_blank' },
												ss.name
											)
										),
										_react2['default'].createElement(
											'td',
											null,
											par.info.name
										),
										_react2['default'].createElement(
											'td',
											null,
											_this.OfflineSince(ss)
										),
										_react2['default'].createElement(
											'td',
											{ className: 'button-holder' },
											_react2['default'].createElement(
												'i',
												{ 'data-tooltip': 'Edit', className: 'material-icons edit--icons  material-icons_size', onClick: function () {
														return _this.openEdit(ss);
													} },
												'edit'
											)
										),
										_react2['default'].createElement(
											'td',
											{ className: 'button-holder' },
											_react2['default'].createElement(
												_reactRouter.Link,
												{ to: "/live/" + par.id, target: '_blank', style: { color: "inherit" } },
												_react2['default'].createElement(
													'i',
													{ 'data-tooltip': 'Floorplan', className: 'material-icons layers--icons material-icons_size' },
													'layers'
												)
											)
										),
										_react2['default'].createElement(
											'td',
											{ className: 'button-holder' },
											_react2['default'].createElement(
												'i',
												{ 'data-tooltip': 'Delete', className: 'material-icons delete--icons material-icons_size', onClick: function () {
														return _this.openDelete(ss);
													} },
												"delete_forever"
											)
										)
									);
								})
							)
						)
					),
					_react2['default'].createElement(_componentsCommonColornote2['default'], { mode: "sensors" })
				);
			}
		}]);
	
		return SensorList;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	function mapStateToProps(state) {
		return {};
	}
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SensorList);
	module.exports = exports['default'];

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _reactPortalTooltip = __webpack_require__(1245);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _reactTimestamp = __webpack_require__(1311);
	
	var _reactTimestamp2 = _interopRequireDefault(_reactTimestamp);
	
	var _moment = __webpack_require__(209);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(53);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var Sensor = (function (_React$Component) {
		_inherits(Sensor, _React$Component);
	
		function Sensor(props) {
			_classCallCheck(this, Sensor);
	
			_get(Object.getPrototypeOf(Sensor.prototype), 'constructor', this).call(this, props);
			this.state = {
				tooltipOpen: false
			};
		}
	
		_createClass(Sensor, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				this.setState({ tooltipOpen: true });
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				this.setState({ tooltipOpen: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var sensor = this.props.sensor;
				var parentName = null;
				if (sensor.id) {
					if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
						parentName = this.props.nodeMap[sensor.id].parent.info.name;
					}
				}
				var style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
				var className = 'point';
				if (sensor.registered && sensor.lastonl + 24 * 60 * 60 > (0, _moment2['default'])().unix()) {
					if (sensor.faulty) {
						className += ' faulty';
					} else {
						if (sensor.inuse) {
							className += ' inuse';
						} else if (sensor.standby) {
							className += ' standby';
						}
					}
				} else {
					className += ' unregistered';
				}
				return _react2['default'].createElement(
					_react2['default'].Fragment,
					null,
					_react2['default'].createElement('div', { className: className, style: style,
						id: "sensor" + sensor.id,
						onMouseEnter: function () {
							return _this.onMouseEnter();
						},
						onMouseLeave: function () {
							return _this.onMouseLeave();
						}
					}),
					_react2['default'].createElement(
						_reactPortalTooltip2['default'],
						{ active: this.state.tooltipOpen, parent: "#sensor" + sensor.id, position: 'right', arrow: 'center',
							style: {
								style: {
									background: "rgba(0,0,0,.9)",
									padding: 10,
									color: "#EEE",
									boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
									borderRadius: 4
								},
								arrowStyle: {
									color: 'rgba(0,0,0,.8)',
									borderColor: false
								}
							}
						},
						_react2['default'].createElement(
							'table',
							null,
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(
									'tr',
									null,
									_react2['default'].createElement(
										'td',
										null,
										_react2['default'].createElement(
											'div',
											null,
											sensor.name
										),
										_react2['default'].createElement(
											'div',
											null,
											sensor.macaddress.toUpperCase()
										),
										_react2['default'].createElement(
											'div',
											null,
											parentName
										),
										!sensor.registered ? _react2['default'].createElement(
											'div',
											null,
											' Maintenance ',
											' '
										) : sensor.faulty ? _react2['default'].createElement(
											'div',
											null,
											'Offline since ',
											_react2['default'].createElement(_reactTimestamp2['default'], { time: sensor.lastonl })
										) : ""
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Sensor;
	})(_react2['default'].Component);
	
	exports.Sensor = Sensor;
	
	function mapStateToProps(state) {
		return {
			nodeMap: state.overviewReducer.nodeMap
		};
	}
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	Sensor.propTypes = {
		nodeMap: _propTypes2['default'].object.isRequired,
		sensor: _propTypes2['default'].object.isRequired
	};
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Sensor);
	/*Change from Unregistered to Maintenance*/

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsSensorsettings = __webpack_require__(360);
	
	var EditModal = (function (_React$Component) {
		_inherits(EditModal, _React$Component);
	
		function EditModal(props, context) {
			_classCallCheck(this, EditModal);
	
			_get(Object.getPrototypeOf(EditModal.prototype), 'constructor', this).call(this, props, context);
			this.state = {
				macaddress: '',
				name: '',
				loaded: false
			};
		}
	
		_createClass(EditModal, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.open != nextProps.open) {
					this.setState({
						macaddress: nextProps.sensor.macaddress,
						name: nextProps.sensor.name,
						loaded: true
					});
				}
			}
		}, {
			key: 'editSensorHandle',
			value: function editSensorHandle() {
				var ss = {
					id: this.props.sensor.id,
					macaddress: this.state.macaddress,
					name: this.state.name
				};
				this.props.dispatch((0, _actionsSensorsettings.editSensor)(ss));
			}
		}, {
			key: 'changeMacAddress',
			value: function changeMacAddress(e) {
				this.setState({ macaddress: e.target.value });
				e.preventDefault();
			}
		}, {
			key: 'changeName',
			value: function changeName(e) {
				this.setState({ name: e.target.value });
				e.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				var type = "hidden";
				if (this.state.loaded) {
					type = this.props.open ? "open" : "closed";
				}
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement('div', { className: "modals__overlay " + type, onClick: this.props.closeModal }),
					_react2['default'].createElement(
						'div',
						{ className: "edit-sensor-wrapper modals__content " + type },
						_react2['default'].createElement(
							'div',
							{ className: 'modals__content__header' },
							_react2['default'].createElement(
								'button',
								{ className: 'close', onClick: this.props.closeModal },
								'×'
							),
							_react2['default'].createElement(
								'h4',
								{ className: 'modals__content__header__title' },
								'Edit Sensor'
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: 'modals__content__body' },
							_react2['default'].createElement(
								'label',
								null,
								'MAC Address'
							),
							_react2['default'].createElement('input', { type: 'text', placeholder: 'f8:f0:05:f7:fc:cc', value: this.state.macaddress, onChange: this.changeMacAddress.bind(this) }),
							_react2['default'].createElement(
								'label',
								null,
								'Name'
							),
							_react2['default'].createElement('input', { type: 'text', placeholder: 'ZA1', value: this.state.name, onChange: this.changeName.bind(this) }),
							_react2['default'].createElement(
								'div',
								null,
								_react2['default'].createElement(
									'span',
									{ className: this.props.respondClass },
									this.props.respond
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: 'modal-footer' },
							_react2['default'].createElement(
								'button',
								{ className: 'btn btn-default', type: 'button', onClick: this.props.closeModal },
								'Cancel'
							),
							_react2['default'].createElement(
								'button',
								{ className: 'btn btn-success', type: 'button', onClick: this.editSensorHandle.bind(this) },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return EditModal;
	})(_react2['default'].Component);
	
	function mapDispatchToProps(dispatch) {
		return {
			dispatch: dispatch
		};
	}
	
	exports['default'] = (0, _reactRedux.connect)(null, mapDispatchToProps)(EditModal);
	module.exports = exports['default'];

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DeleteModal = (function (_React$Component) {
		_inherits(DeleteModal, _React$Component);
	
		function DeleteModal(props, context) {
			_classCallCheck(this, DeleteModal);
	
			_get(Object.getPrototypeOf(DeleteModal.prototype), "constructor", this).call(this, props, context);
			this.state = {
				loaded: false
			};
		}
	
		_createClass(DeleteModal, [{
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.open != nextProps.open) {
					this.setState({
						loaded: true
					});
				}
			}
		}, {
			key: "render",
			value: function render() {
				var type = "hidden";
				if (this.state.loaded) {
					type = this.props.open ? "open" : "closed";
				}
				return _react2["default"].createElement(
					"div",
					null,
					_react2["default"].createElement("div", { className: "modals__overlay " + type, onClick: this.props.closeModal }),
					_react2["default"].createElement(
						"div",
						{ className: "modals__content " + type },
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__header" },
							_react2["default"].createElement(
								"button",
								{ className: "close", onClick: this.props.closeModal },
								"×"
							),
							_react2["default"].createElement(
								"h4",
								{ className: "modals__content__header__title" },
								"Delete User"
							)
						),
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__body" },
							_react2["default"].createElement(
								"p",
								null,
								"Are you sure you want to delete this sensor and all related data ?"
							)
						),
						_react2["default"].createElement(
							"div",
							{ className: "modals__content__footer" },
							_react2["default"].createElement(
								"button",
								{ className: "btn btn-default", type: "button", onClick: this.props.closeModal },
								"Cancel"
							),
							_react2["default"].createElement(
								"button",
								{ className: "btn btn-danger", type: "button", onClick: this.props.clickButton },
								"Delete"
							)
						)
					)
				);
			}
		}]);
	
		return DeleteModal;
	})(_react2["default"].Component);
	
	exports["default"] = DeleteModal;
	module.exports = exports["default"];

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var _componentsCommonMainmenu = __webpack_require__(455);
	
	var _componentsCommonMainmenu2 = _interopRequireDefault(_componentsCommonMainmenu);
	
	var _password = __webpack_require__(2303);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _componentsCommonStickymenu = __webpack_require__(1257);
	
	var _componentsCommonStickymenu2 = _interopRequireDefault(_componentsCommonStickymenu);
	
	var _componentsCommonStatsmenu = __webpack_require__(1269);
	
	var _componentsCommonStatsmenu2 = _interopRequireDefault(_componentsCommonStatsmenu);
	
	var Index = (function (_React$Component) {
	    _inherits(Index, _React$Component);
	
	    function Index(props) {
	        _classCallCheck(this, Index);
	
	        _get(Object.getPrototypeOf(Index.prototype), 'constructor', this).call(this, props);
	        this.state = Object.assign(props.user);
	    }
	
	    _createClass(Index, [{
	        key: 'submit',
	        value: function submit() {
	            this.props.dispatch((0, _actionsMyaccount.updateUser)(this.props.user.username, this.state)).then(function () {
	                _toastr2['default'].success('Update User Successfully');
	            })['catch'](function (error) {
	                _toastr2['default'].error(error);
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var self = this;
	            this.props.dispatch((0, _actionsMyaccount.fetchCurrentUser)()).then(function () {
	                var user = self.props.user;
	                _this.setState({
	                    username: user.username,
	                    title: user.title,
	                    firstname: user.firstname,
	                    lastname: user.lastname,
	                    phone: user.phone,
	                    position: user.position,
	                    address: user.address
	                });
	            });
	        }
	    }, {
	        key: 'changeHandler',
	        value: function changeHandler(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, value));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	            return _react2['default'].createElement(
	                'div',
	                { className: 'own-account-page overwrite--modal--depth' },
	                _react2['default'].createElement(
	                    _componentsCommonStickymenu2['default'],
	                    {
	                        withStickyHeader: false
	                    },
	                    _react2['default'].createElement(_componentsCommonMainmenu2['default'], {
	                        overviewIsActive: false,
	                        comparisonIsActive: false,
	                        onlyLeftMenu: true
	                    }),
	                    _react2['default'].createElement(_componentsCommonStatsmenu2['default'], { leftItemBold: 'Own Account' })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page-content page-content_padding-modifier' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'display--flex__flex--center' },
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'white-box-container box--shadow bg--white' },
	                                _react2['default'].createElement(
	                                    'form',
	                                    { className: 'account-form' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'form-col' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-email' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Email Address'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'email', id: 'email', value: user.email, disabled: 'disabled' })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-username' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Username'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'text', id: 'username', value: user.username, disabled: 'disabled' })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-firstname' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'First Name'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'text', id: 'firstname', value: this.state.firstname, onChange: this.changeHandler.bind(this) })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-lastname' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Last Name'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'text', id: 'lastname', value: this.state.lastname, onChange: this.changeHandler.bind(this) })
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'form-col' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account--form__title' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Title'
	                                            ),
	                                            _react2['default'].createElement(
	                                                'select',
	                                                { id: 'title', value: this.state.title, onChange: this.changeHandler.bind(this) },
	                                                _react2['default'].createElement(
	                                                    'option',
	                                                    { value: 'Mr' },
	                                                    'Mr'
	                                                ),
	                                                _react2['default'].createElement(
	                                                    'option',
	                                                    { value: 'Ms/Mrs.' },
	                                                    'Ms/Mrs.'
	                                                )
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-phone' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Phone'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'tel', id: 'phone', value: this.state.phone, onChange: this.changeHandler.bind(this) })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-position' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Position'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'text', id: 'position', value: this.state.position, onChange: this.changeHandler.bind(this) })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-location' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Address'
	                                            ),
	                                            _react2['default'].createElement('input', { type: 'text', id: 'address', value: this.state.address, onChange: this.changeHandler.bind(this) })
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account-password' },
	                                            _react2['default'].createElement(
	                                                'label',
	                                                null,
	                                                'Password'
	                                            ),
	                                            _react2['default'].createElement(_password2['default'], null)
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'display--flex__flex--end--center', style: { marginTop: 10 } },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'account--btn__flat btn-small', type: 'button', onClick: this.submit.bind(this) },
	                                            'Save Changes'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Index;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        user: state.myAccountReducer.user,
	        auth: state.authReducer
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Index);
	module.exports = exports['default'];

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(38);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _actionsMyaccount = __webpack_require__(354);
	
	var _toastr = __webpack_require__(165);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var _componentsCommonModal = __webpack_require__(443);
	
	var _componentsCommonModal2 = _interopRequireDefault(_componentsCommonModal);
	
	var Password = (function (_React$Component) {
	    _inherits(Password, _React$Component);
	
	    function Password() {
	        _classCallCheck(this, Password);
	
	        _get(Object.getPrototypeOf(Password.prototype), 'constructor', this).call(this);
	        this.displayName = 'Change Password';
	        this.state = {};
	    }
	
	    _createClass(Password, [{
	        key: 'changePassword',
	        value: function changePassword() {
	            if (this.state['new'] != "") {
	                if (this.state['new'] === this.state.confirm) {
	                    var data = {
	                        username: this.props.auth.username,
	                        old: this.state.old,
	                        'new': this.state['new']
	                    };
	                    this.props.dispatch((0, _actionsMyaccount.updatePassword)(data));
	                } else {
	                    _toastr2['default'].error("Password does not match! ");
	                }
	            } else {
	                _toastr2['default'].error("Please provide password !");
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            var key = e.target.id;
	            var value = e.target.value;
	            this.setState(_defineProperty({}, key, value));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            return _react2['default'].createElement(
	                _react2['default'].Fragment,
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    { onClick: function () {
	                            return _this.modal.open();
	                        }, style: { width: 230 }, className: 'account--btn__flat btn-small' },
	                    'Change Password'
	                ),
	                _react2['default'].createElement(
	                    _componentsCommonModal2['default'],
	                    {
	                        ref: function (elem) {
	                            _this.modal = elem;
	                        },
	                        clickButton: function (e) {
	                            _this.changePassword();
	                        },
	                        header: "Change Password",
	                        buttonText: "Change",
	                        buttonClass: 'btn-success',
	                        entry: null
	                    },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'label',
	                            { style: { textAlign: "left" } },
	                            'Old Password'
	                        ),
	                        _react2['default'].createElement('input', { type: 'password', id: 'old', onChange: this.handleChange.bind(this) })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'label',
	                            { style: { textAlign: "left" } },
	                            'New Password'
	                        ),
	                        _react2['default'].createElement('input', { type: 'password', id: 'new', onChange: this.handleChange.bind(this) })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'label',
	                            { style: { textAlign: "left" } },
	                            'Confirm Password'
	                        ),
	                        _react2['default'].createElement('input', { type: 'password', id: 'confirm', onChange: this.handleChange.bind(this) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Password;
	})(_react2['default'].Component);
	
	function mapStateToProps(state) {
	    return {
	        auth: state.myAccountReducer.user,
	        user: state.myAccountReducer.user
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        dispatch: dispatch
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Password);
	module.exports = exports['default'];

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var fabric_icons_1 = __webpack_require__(2305);
	var fabric_icons_0_1 = __webpack_require__(2353);
	var fabric_icons_1_1 = __webpack_require__(2354);
	var fabric_icons_2_1 = __webpack_require__(2355);
	var fabric_icons_3_1 = __webpack_require__(2356);
	var fabric_icons_4_1 = __webpack_require__(2357);
	var fabric_icons_5_1 = __webpack_require__(2358);
	var fabric_icons_6_1 = __webpack_require__(2359);
	var fabric_icons_7_1 = __webpack_require__(2360);
	var fabric_icons_8_1 = __webpack_require__(2361);
	var fabric_icons_9_1 = __webpack_require__(2362);
	var fabric_icons_10_1 = __webpack_require__(2363);
	var fabric_icons_11_1 = __webpack_require__(2364);
	var fabric_icons_12_1 = __webpack_require__(2365);
	var fabric_icons_13_1 = __webpack_require__(2366);
	var fabric_icons_14_1 = __webpack_require__(2367);
	__webpack_require__(2368);
	var DEFAULT_BASE_URL = 'https://spoprod-a.akamaihd.net/files/fabric/assets/icons/';
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = DEFAULT_BASE_URL; }
	    [fabric_icons_1.initializeIcons, fabric_icons_0_1.initializeIcons, fabric_icons_1_1.initializeIcons, fabric_icons_2_1.initializeIcons, fabric_icons_3_1.initializeIcons, fabric_icons_4_1.initializeIcons, fabric_icons_5_1.initializeIcons, fabric_icons_6_1.initializeIcons, fabric_icons_7_1.initializeIcons, fabric_icons_8_1.initializeIcons, fabric_icons_9_1.initializeIcons, fabric_icons_10_1.initializeIcons, fabric_icons_11_1.initializeIcons, fabric_icons_12_1.initializeIcons, fabric_icons_13_1.initializeIcons, fabric_icons_14_1.initializeIcons].forEach(function (initialize) { return initialize(baseUrl, options); });
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons\"",
	            src: "url('" + baseUrl + "fabric-icons-a13498cf.woff') format('woff')"
	        },
	        icons: {
	            'GlobalNavButton': '\uE700',
	            'ChevronDown': '\uE70D',
	            'ChevronUp': '\uE70E',
	            'Edit': '\uE70F',
	            'Add': '\uE710',
	            'Cancel': '\uE711',
	            'More': '\uE712',
	            'Settings': '\uE713',
	            'Mail': '\uE715',
	            'Filter': '\uE71C',
	            'Search': '\uE721',
	            'Share': '\uE72D',
	            'BlockedSite': '\uE72F',
	            'FavoriteStar': '\uE734',
	            'FavoriteStarFill': '\uE735',
	            'CheckMark': '\uE73E',
	            'Delete': '\uE74D',
	            'ChevronLeft': '\uE76B',
	            'ChevronRight': '\uE76C',
	            'Calendar': '\uE787',
	            'Megaphone': '\uE789',
	            'Undo': '\uE7A7',
	            'Flag': '\uE7C1',
	            'Page': '\uE7C3',
	            'Pinned': '\uE840',
	            'View': '\uE890',
	            'Clear': '\uE894',
	            'Download': '\uE896',
	            'Upload': '\uE898',
	            'Folder': '\uE8B7',
	            'Sort': '\uE8CB',
	            'AlignRight': '\uE8E2',
	            'AlignLeft': '\uE8E4',
	            'Tag': '\uE8EC',
	            'AddFriend': '\uE8FA',
	            'Info': '\uE946',
	            'SortLines': '\uE9D0',
	            'List': '\uEA37',
	            'CircleRing': '\uEA3A',
	            'Heart': '\uEB51',
	            'HeartFill': '\uEB52',
	            'Tiles': '\uECA5',
	            'Embed': '\uECCE',
	            'Glimmer': '\uECF4',
	            'Ascending': '\uEDC0',
	            'Descending': '\uEDC1',
	            'SortUp': '\uEE68',
	            'SortDown': '\uEE69',
	            'SyncToPC': '\uEE6E',
	            'LargeGrid': '\uEECB',
	            'SkypeCheck': '\uEF80',
	            'SkypeClock': '\uEF81',
	            'SkypeMinus': '\uEF82',
	            'ClearFilter': '\uEF8F',
	            'Flow': '\uEF90',
	            'StatusCircleCheckmark': '\uF13E',
	            'MoreVertical': '\uF2BC'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons.js.map

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	tslib_1.__exportStar(__webpack_require__(2307), exports);
	tslib_1.__exportStar(__webpack_require__(2330), exports);
	tslib_1.__exportStar(__webpack_require__(2309), exports);
	tslib_1.__exportStar(__webpack_require__(2311), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AnimationClassNames_1 = __webpack_require__(2308);
	exports.AnimationClassNames = AnimationClassNames_1.AnimationClassNames;
	var FontClassNames_1 = __webpack_require__(2351);
	exports.FontClassNames = FontClassNames_1.FontClassNames;
	var ColorClassNames_1 = __webpack_require__(2352);
	exports.ColorClassNames = ColorClassNames_1.ColorClassNames;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2309);
	var index_2 = __webpack_require__(2330);
	exports.AnimationClassNames = index_1.buildClassMap(index_2.AnimationStyles);
	//# sourceMappingURL=AnimationClassNames.js.map

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var buildClassMap_1 = __webpack_require__(2310);
	exports.buildClassMap = buildClassMap_1.buildClassMap;
	var icons_1 = __webpack_require__(2326);
	exports.getIcon = icons_1.getIcon;
	exports.registerIcons = icons_1.registerIcons;
	exports.registerIconAlias = icons_1.registerIconAlias;
	exports.setIconOptions = icons_1.setIconOptions;
	var getIconClassName_1 = __webpack_require__(2329);
	exports.getIconClassName = getIconClassName_1.getIconClassName;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MergeStyles_1 = __webpack_require__(2311);
	/**
	 * Builds a class names object from a given map.
	 *
	 * @param styles - Map of unprocessed styles.
	 * @returns Map of property name to class name.
	 */
	function buildClassMap(styles) {
	    var classes = {};
	    var _loop_1 = function (styleName) {
	        if (styles.hasOwnProperty(styleName)) {
	            var className_1;
	            Object.defineProperty(classes, styleName, {
	                get: function () {
	                    if (className_1 === undefined) {
	                        // tslint:disable-next-line:no-any
	                        className_1 = MergeStyles_1.mergeStyles(styles[styleName]).toString();
	                    }
	                    return className_1;
	                },
	                enumerable: true,
	                configurable: true
	            });
	        }
	    };
	    for (var styleName in styles) {
	        _loop_1(styleName);
	    }
	    return classes;
	}
	exports.buildClassMap = buildClassMap;
	//# sourceMappingURL=buildClassMap.js.map

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2312);
	exports.InjectionMode = index_1.InjectionMode;
	exports.Stylesheet = index_1.Stylesheet;
	exports.concatStyleSets = index_1.concatStyleSets;
	exports.fontFace = index_1.fontFace;
	exports.keyframes = index_1.keyframes;
	exports.mergeStyleSets = index_1.mergeStyleSets;
	exports.mergeStyles = index_1.mergeStyles;
	//# sourceMappingURL=MergeStyles.js.map

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeStyles_1 = __webpack_require__(2313);
	exports.mergeStyles = mergeStyles_1.mergeStyles;
	var mergeStyleSets_1 = __webpack_require__(2322);
	exports.mergeStyleSets = mergeStyleSets_1.mergeStyleSets;
	var concatStyleSets_1 = __webpack_require__(2323);
	exports.concatStyleSets = concatStyleSets_1.concatStyleSets;
	var fontFace_1 = __webpack_require__(2324);
	exports.fontFace = fontFace_1.fontFace;
	var keyframes_1 = __webpack_require__(2325);
	exports.keyframes = keyframes_1.keyframes;
	var Stylesheet_1 = __webpack_require__(2315);
	exports.InjectionMode = Stylesheet_1.InjectionMode;
	exports.Stylesheet = Stylesheet_1.Stylesheet;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var styleToClassName_1 = __webpack_require__(2314);
	var extractStyleParts_1 = __webpack_require__(2321);
	/**
	 * Concatination helper, which can merge class names together. Skips over falsey values.
	 *
	 * @public
	 */
	function mergeStyles() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var _a = extractStyleParts_1.extractStyleParts(args), classes = _a.classes, objects = _a.objects;
	    if (objects.length) {
	        classes.push(styleToClassName_1.styleToClassName(objects));
	    }
	    return classes.join(' ');
	}
	exports.mergeStyles = mergeStyles;
	//# sourceMappingURL=mergeStyles.js.map

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(2315);
	var kebabRules_1 = __webpack_require__(2316);
	var prefixRules_1 = __webpack_require__(2317);
	var provideUnits_1 = __webpack_require__(2319);
	var rtlifyRules_1 = __webpack_require__(2320);
	var DISPLAY_NAME = 'displayName';
	function getDisplayName(rules) {
	    var rootStyle = rules && rules['&'];
	    return rootStyle ? rootStyle.displayName : undefined;
	}
	function extractRules(args, rules, currentSelector) {
	    if (rules === void 0) { rules = { __order: [] }; }
	    if (currentSelector === void 0) { currentSelector = '&'; }
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var currentRules = rules[currentSelector];
	    if (!currentRules) {
	        currentRules = {};
	        rules[currentSelector] = currentRules;
	        rules.__order.push(currentSelector);
	    }
	    for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
	        var arg = args_1[_i];
	        // If the arg is a string, we need to look up the class map and merge.
	        if (typeof arg === 'string') {
	            var expandedRules = stylesheet.argsFromClassName(arg);
	            if (expandedRules) {
	                extractRules(expandedRules, rules, currentSelector);
	            }
	            // Else if the arg is an array, we need to recurse in.
	        }
	        else if (Array.isArray(arg)) {
	            extractRules(arg, rules, currentSelector);
	        }
	        else {
	            // tslint:disable-next-line:no-any
	            for (var prop in arg) {
	                if (prop === 'selectors') {
	                    // tslint:disable-next-line:no-any
	                    var selectors = arg.selectors;
	                    for (var newSelector in selectors) {
	                        if (selectors.hasOwnProperty(newSelector)) {
	                            var selectorValue = selectors[newSelector];
	                            if (newSelector.indexOf(':global(') === 0) {
	                                newSelector = newSelector.replace(/:global\(|\)$/g, '');
	                            }
	                            else if (newSelector.indexOf('@media') === 0) {
	                                newSelector = newSelector + '{' + currentSelector;
	                            }
	                            else if (newSelector.indexOf(':') === 0) {
	                                newSelector = currentSelector + newSelector;
	                            }
	                            else if (newSelector.indexOf('&') < 0) {
	                                newSelector = currentSelector + ' ' + newSelector;
	                            }
	                            extractRules([selectorValue], rules, newSelector);
	                        }
	                    }
	                }
	                else {
	                    // Else, add the rule to the currentSelector.
	                    if (prop === 'margin' || prop === 'padding') {
	                        // tslint:disable-next-line:no-any
	                        expandQuads(currentRules, prop, arg[prop]);
	                    }
	                    else {
	                        // tslint:disable-next-line:no-any
	                        currentRules[prop] = arg[prop];
	                    }
	                }
	            }
	        }
	    }
	    return rules;
	}
	function expandQuads(currentRules, name, value) {
	    var parts = (typeof value === 'string') ? value.split(' ') : [value];
	    currentRules[name + 'Top'] = parts[0];
	    currentRules[name + 'Right'] = parts[1] || parts[0];
	    currentRules[name + 'Bottom'] = parts[2] || parts[0];
	    currentRules[name + 'Left'] = parts[3] || parts[1] || parts[0];
	}
	function getKeyForRules(rules) {
	    var serialized = [];
	    var hasProps = false;
	    for (var _i = 0, _a = rules.__order; _i < _a.length; _i++) {
	        var selector = _a[_i];
	        serialized.push(selector);
	        var rulesForSelector = rules[selector];
	        for (var propName in rulesForSelector) {
	            if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
	                hasProps = true;
	                serialized.push(propName, rulesForSelector[propName]);
	            }
	        }
	    }
	    return hasProps ? serialized.join('') : undefined;
	}
	function serializeRuleEntries(ruleEntries) {
	    if (!ruleEntries) {
	        return '';
	    }
	    var allEntries = [];
	    for (var entry in ruleEntries) {
	        if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME && ruleEntries[entry] !== undefined) {
	            allEntries.push(entry, ruleEntries[entry]);
	        }
	    }
	    // Apply transforms.
	    for (var i = 0; i < allEntries.length; i += 2) {
	        kebabRules_1.kebabRules(allEntries, i);
	        provideUnits_1.provideUnits(allEntries, i);
	        rtlifyRules_1.rtlifyRules(allEntries, i);
	        prefixRules_1.prefixRules(allEntries, i);
	    }
	    // Apply punctuation.
	    for (var i = 1; i < allEntries.length; i += 4) {
	        allEntries.splice(i, 1, ':', allEntries[i], ';');
	    }
	    return allEntries.join('');
	}
	exports.serializeRuleEntries = serializeRuleEntries;
	function styleToRegistration() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var rules = extractRules(args);
	    var key = getKeyForRules(rules);
	    if (key) {
	        var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	        var registration = {
	            className: stylesheet.classNameFromKey(key),
	            key: key,
	            args: args
	        };
	        if (!registration.className) {
	            registration.className = stylesheet.getClassName(getDisplayName(rules));
	            var rulesToInsert = [];
	            for (var _a = 0, _b = rules.__order; _a < _b.length; _a++) {
	                var selector = _b[_a];
	                rulesToInsert.push(selector, serializeRuleEntries(rules[selector]));
	            }
	            registration.rulesToInsert = rulesToInsert;
	        }
	        return registration;
	    }
	}
	exports.styleToRegistration = styleToRegistration;
	function applyRegistration(registration, classMap) {
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
	    if (rulesToInsert) {
	        // rulesToInsert is an ordered array of selector/rule pairs.
	        for (var i = 0; i < rulesToInsert.length; i += 2) {
	            var rules = rulesToInsert[i + 1];
	            if (rules) {
	                var selector = rulesToInsert[i];
	                // Fix selector using map.
	                selector = selector.replace(/(&)|\$([\w-]+)\b/g, function (match, amp, cn) {
	                    if (amp) {
	                        return '.' + registration.className;
	                    }
	                    else if (cn) {
	                        return '.' + ((classMap && classMap[cn]) || cn);
	                    }
	                    return '';
	                });
	                // Insert. Note if a media query, we must close the query with a final bracket.
	                var processedRule = selector + "{" + rules + "}" + ((selector.indexOf('@media') === 0) ? '}' : '');
	                stylesheet.insertRule(processedRule);
	            }
	        }
	        stylesheet.cacheClassName(className, key, args, rulesToInsert);
	    }
	}
	exports.applyRegistration = applyRegistration;
	function styleToClassName() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var registration = styleToRegistration.apply(void 0, args);
	    if (registration) {
	        applyRegistration(registration);
	        return registration.className;
	    }
	    return '';
	}
	exports.styleToClassName = styleToClassName;
	//# sourceMappingURL=styleToClassName.js.map

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	/**
	 * Injection mode for the stylesheet.
	 *
	 * @public
	 */
	var InjectionMode;
	(function (InjectionMode) {
	    /**
	     * Avoids style injection, use getRules() to read the styles.
	     */
	    InjectionMode[InjectionMode["none"] = 0] = "none";
	    /**
	     * Inserts rules using the insertRule api.
	     */
	    InjectionMode[InjectionMode["insertNode"] = 1] = "insertNode";
	    /**
	     * Appends rules using appendChild.
	     */
	    InjectionMode[InjectionMode["appendChild"] = 2] = "appendChild";
	})(InjectionMode = exports.InjectionMode || (exports.InjectionMode = {}));
	var STYLESHEET_SETTING = '__stylesheet__';
	var _stylesheet;
	/**
	 * Represents the state of styles registered in the page. Abstracts
	 * the surface for adding styles to the stylesheet, exposes helpers
	 * for reading the styles registered in server rendered scenarios.
	 *
	 * @public
	 */
	var Stylesheet = /** @class */ (function () {
	    function Stylesheet(config) {
	        this._rules = [];
	        this._rulesToInsert = [];
	        this._counter = 0;
	        this._keyToClassName = {};
	        // tslint:disable-next-line:no-any
	        this._classNameToArgs = {};
	        this._config = tslib_1.__assign({ injectionMode: 1 /* insertNode */, defaultPrefix: 'css' }, config);
	    }
	    /**
	     * Gets the singleton instance.
	     */
	    Stylesheet.getInstance = function () {
	        // tslint:disable-next-line:no-any
	        var win = typeof window !== 'undefined' ? window : {};
	        _stylesheet = win[STYLESHEET_SETTING];
	        if (!_stylesheet) {
	            // tslint:disable-next-line:no-string-literal
	            var fabricConfig = (win && win['FabricConfig']) || {};
	            _stylesheet = win[STYLESHEET_SETTING] = new Stylesheet(fabricConfig.mergeStyles);
	        }
	        return _stylesheet;
	    };
	    /**
	     * Configures the stylesheet.
	     */
	    Stylesheet.prototype.setConfig = function (config) {
	        this._config = tslib_1.__assign({}, this._config, config);
	    };
	    /**
	     * Generates a unique classname.
	     *
	     * @param displayName - Optional value to use as a prefix.
	     */
	    Stylesheet.prototype.getClassName = function (displayName) {
	        var prefix = displayName || this._config.defaultPrefix;
	        return prefix + "-" + this._counter++;
	    };
	    /**
	     * Used internally to cache information about a class which was
	     * registered with the stylesheet.
	     */
	    Stylesheet.prototype.cacheClassName = function (className, key, args, rules) {
	        this._keyToClassName[key] = className;
	        this._classNameToArgs[className] = {
	            args: args,
	            rules: rules
	        };
	    };
	    /**
	     * Gets the appropriate classname given a key which was previously
	     * registered using cacheClassName.
	     */
	    Stylesheet.prototype.classNameFromKey = function (key) {
	        return this._keyToClassName[key];
	    };
	    /**
	     * Gets the arguments associated with a given classname which was
	     * previously registered using cacheClassName.
	     */
	    Stylesheet.prototype.argsFromClassName = function (className) {
	        var entry = this._classNameToArgs[className];
	        return (entry && entry.args);
	    };
	    /**
	   * Gets the arguments associated with a given classname which was
	   * previously registered using cacheClassName.
	   */
	    Stylesheet.prototype.insertedRulesFromClassName = function (className) {
	        var entry = this._classNameToArgs[className];
	        return (entry && entry.rules);
	    };
	    /**
	     * Inserts a css rule into the stylesheet.
	     */
	    Stylesheet.prototype.insertRule = function (rule) {
	        var injectionMode = this._config.injectionMode;
	        var element = injectionMode !== 0 /* none */ ? this._getStyleElement() : undefined;
	        if (element) {
	            switch (this._config.injectionMode) {
	                case 1 /* insertNode */:
	                    var sheet = element.sheet;
	                    try {
	                        sheet.insertRule(rule, sheet.cssRules.length);
	                    }
	                    catch (e) {
	                        // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
	                        // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
	                        // which could be slower and bulkier.
	                    }
	                    break;
	                case 2 /* appendChild */:
	                    element.appendChild(document.createTextNode(rule));
	                    break;
	            }
	        }
	        else {
	            this._rules.push(rule);
	        }
	        if (this._config.onInsertRule) {
	            this._config.onInsertRule(rule);
	        }
	    };
	    /**
	     * Gets all rules registered with the stylesheet; only valid when
	     * using InsertionMode.none.
	     */
	    Stylesheet.prototype.getRules = function () {
	        return (this._rules.join('') || '') + (this._rulesToInsert.join('') || '');
	    };
	    /**
	     * Resets the internal state of the stylesheet. Only used in server
	     * rendered scenarios where we're using InsertionMode.none.
	     */
	    Stylesheet.prototype.reset = function () {
	        this._rules = [];
	        this._rulesToInsert = [];
	        this._counter = 0;
	        this._classNameToArgs = {};
	        this._keyToClassName = {};
	    };
	    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
	    Stylesheet.prototype.resetKeys = function () {
	        this._keyToClassName = {};
	    };
	    Stylesheet.prototype._getStyleElement = function () {
	        var _this = this;
	        if (!this._styleElement && typeof document !== 'undefined') {
	            this._styleElement = this._createStyleElement();
	            // Reset the style element on the next frame.
	            window.requestAnimationFrame(function () {
	                _this._styleElement = undefined;
	            });
	        }
	        return this._styleElement;
	    };
	    Stylesheet.prototype._createStyleElement = function () {
	        var styleElement = document.createElement('style');
	        styleElement.setAttribute('data-merge-styles', 'true');
	        styleElement.type = 'text/css';
	        if (this._lastStyleElement && this._lastStyleElement.nextElementSibling) {
	            document.head.insertBefore(styleElement, this._lastStyleElement.nextElementSibling);
	        }
	        else {
	            document.head.appendChild(styleElement);
	        }
	        this._lastStyleElement = styleElement;
	        return styleElement;
	    };
	    return Stylesheet;
	}());
	exports.Stylesheet = Stylesheet;
	//# sourceMappingURL=Stylesheet.js.map

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function kebabRules(rulePairs, index) {
	    rulePairs[index] = rulePairs[index].replace(/([A-Z])/g, '-$1').toLowerCase();
	}
	exports.kebabRules = kebabRules;
	//# sourceMappingURL=kebabRules.js.map

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getVendorSettings_1 = __webpack_require__(2318);
	var autoPrefixNames = {
	    'user-select': 1
	};
	function prefixRules(rulePairs, index) {
	    var vendorSettings = getVendorSettings_1.getVendorSettings();
	    var name = rulePairs[index];
	    if (autoPrefixNames[name]) {
	        var value = rulePairs[index + 1];
	        if (autoPrefixNames[name]) {
	            if (vendorSettings.isWebkit) {
	                rulePairs.push('-webkit-' + name, value);
	            }
	            if (vendorSettings.isMoz) {
	                rulePairs.push('-moz-' + name, value);
	            }
	            if (vendorSettings.isMs) {
	                rulePairs.push('-ms-' + name, value);
	            }
	            if (vendorSettings.isOpera) {
	                rulePairs.push('-o-' + name, value);
	            }
	        }
	    }
	}
	exports.prefixRules = prefixRules;
	//# sourceMappingURL=prefixRules.js.map

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _vendorSettings;
	function getVendorSettings() {
	    if (!_vendorSettings) {
	        var doc = typeof document !== 'undefined' ? document : undefined;
	        var nav = typeof navigator !== 'undefined' ? navigator : undefined;
	        var userAgent = nav ? nav.userAgent.toLowerCase() : undefined;
	        if (!doc) {
	            _vendorSettings = {
	                isWebkit: true,
	                isMoz: true,
	                isOpera: true,
	                isMs: true
	            };
	        }
	        else {
	            _vendorSettings = {
	                isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
	                isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
	                isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
	                isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
	            };
	        }
	    }
	    return _vendorSettings;
	}
	exports.getVendorSettings = getVendorSettings;
	/**
	 * Sets the vendor settings for prefixing and vendor specific operations.
	 */
	function setVendorSettings(vendorSettings) {
	    _vendorSettings = vendorSettings;
	}
	exports.setVendorSettings = setVendorSettings;
	//# sourceMappingURL=getVendorSettings.js.map

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NON_PIXEL_NUMBER_PROPS = [
	    'column-count',
	    'font-weight',
	    'flex-basis',
	    'flex',
	    'flex-grow',
	    'flex-shrink',
	    'fill-opacity',
	    'opacity',
	    'order',
	    'z-index',
	    'zoom'
	];
	function provideUnits(rulePairs, index) {
	    var name = rulePairs[index];
	    var value = rulePairs[index + 1];
	    if (typeof value === 'number') {
	        var unit = (NON_PIXEL_NUMBER_PROPS.indexOf(name) === -1) ? 'px' : '';
	        rulePairs[index + 1] = "" + value + unit;
	    }
	}
	exports.provideUnits = provideUnits;
	//# sourceMappingURL=provideUnits.js.map

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(2315);
	var LEFT = 'left';
	var RIGHT = 'right';
	var NO_FLIP = '@noflip';
	var NAME_REPLACEMENTS = (_a = {},
	    _a[LEFT] = RIGHT,
	    _a[RIGHT] = LEFT,
	    _a);
	var VALUE_REPLACEMENTS = {
	    'w-resize': 'e-resize',
	    'sw-resize': 'se-resize',
	    'nw-resize': 'ne-resize'
	};
	var _rtl = getRTL();
	/**
	 * Sets the current RTL value.
	 */
	function setRTL(isRTL) {
	    if (_rtl !== isRTL) {
	        Stylesheet_1.Stylesheet.getInstance().resetKeys();
	        _rtl = isRTL;
	    }
	}
	exports.setRTL = setRTL;
	/**
	 * Gets the current RTL value.
	 */
	function getRTL() {
	    if (_rtl === undefined) {
	        _rtl = (typeof document !== 'undefined' &&
	            !!document.documentElement &&
	            document.documentElement.getAttribute('dir') === 'rtl');
	    }
	    return _rtl;
	}
	exports.getRTL = getRTL;
	/**
	 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
	 * reasons.
	 */
	function rtlifyRules(rulePairs, index) {
	    if (getRTL()) {
	        var name_1 = rulePairs[index];
	        if (!name_1) {
	            return;
	        }
	        var value = rulePairs[index + 1];
	        if (typeof value === 'string' && value.indexOf(NO_FLIP) >= 0) {
	            rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
	        }
	        else if (name_1.indexOf(LEFT) >= 0) {
	            rulePairs[index] = name_1.replace(LEFT, RIGHT);
	        }
	        else if (name_1.indexOf(RIGHT) >= 0) {
	            rulePairs[index] = name_1.replace(RIGHT, LEFT);
	        }
	        else if (String(value).indexOf(LEFT) >= 0) {
	            rulePairs[index + 1] = value.replace(LEFT, RIGHT);
	        }
	        else if (String(value).indexOf(RIGHT) >= 0) {
	            rulePairs[index + 1] = value.replace(RIGHT, LEFT);
	        }
	        else if (NAME_REPLACEMENTS[name_1]) {
	            rulePairs[index] = NAME_REPLACEMENTS[name_1];
	        }
	        else if (VALUE_REPLACEMENTS[value]) {
	            rulePairs[index + 1] = VALUE_REPLACEMENTS[value];
	        }
	        else {
	            switch (name_1) {
	                case 'margin':
	                case 'padding':
	                    rulePairs[index + 1] = flipQuad(value);
	                    break;
	                case 'box-shadow':
	                    rulePairs[index + 1] = negateNum(value, 0);
	                    break;
	            }
	        }
	    }
	}
	exports.rtlifyRules = rtlifyRules;
	/**
	 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
	 */
	function negateNum(value, partIndex) {
	    var parts = value.split(' ');
	    var numberVal = parseInt(parts[partIndex], 10);
	    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
	    return parts.join(' ');
	}
	/**
	 * Given a string quad, flips the left and right values.
	 */
	function flipQuad(value) {
	    if (typeof value === 'string') {
	        var parts = value.split(' ');
	        if (parts.length === 4) {
	            return parts[0] + " " + parts[3] + " " + parts[2] + " " + parts[1];
	        }
	    }
	    return value;
	}
	var _a;
	//# sourceMappingURL=rtlifyRules.js.map

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(2315);
	/**
	 * Separates the classes and style objects. Any classes that are pre-registered
	 * args are auto expanded into objects.
	 */
	function extractStyleParts() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    var objects = [];
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    function _processArgs(argsList) {
	        for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
	            var arg = argsList_1[_i];
	            if (arg) {
	                if (typeof arg === 'string') {
	                    if (arg.indexOf(' ') >= 0) {
	                        _processArgs(arg.split(' '));
	                    }
	                    else {
	                        var translatedArgs = stylesheet.argsFromClassName(arg);
	                        if (translatedArgs) {
	                            _processArgs(translatedArgs);
	                        }
	                        else {
	                            // Avoid adding the same class twice.
	                            if (classes.indexOf(arg) === -1) {
	                                classes.push(arg);
	                            }
	                        }
	                    }
	                }
	                else if (Array.isArray(arg)) {
	                    _processArgs(arg);
	                }
	                else if (typeof arg === 'object') {
	                    objects.push(arg);
	                }
	            }
	        }
	    }
	    _processArgs(args);
	    return {
	        classes: classes,
	        objects: objects
	    };
	}
	exports.extractStyleParts = extractStyleParts;
	//# sourceMappingURL=extractStyleParts.js.map

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var extractStyleParts_1 = __webpack_require__(2321);
	var concatStyleSets_1 = __webpack_require__(2323);
	var styleToClassName_1 = __webpack_require__(2314);
	/**
	 * Allows you to pass in 1 or more sets of areas which will return a merged
	 * set of classes.
	 *
	 * @public
	 */
	function mergeStyleSets() {
	    var cssSets = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        cssSets[_i] = arguments[_i];
	    }
	    // tslint:disable-next-line:no-any
	    var classNameSet = {};
	    var classMap = {};
	    var cssSet = cssSets[0];
	    if (cssSet) {
	        if (cssSets.length > 1) {
	            cssSet = concatStyleSets_1.concatStyleSets.apply(void 0, cssSets);
	        }
	        var registrations = [];
	        for (var prop in cssSet) {
	            if (cssSet.hasOwnProperty(prop)) {
	                var args = cssSet[prop];
	                // tslint:disable-next-line:no-any
	                var _a = extractStyleParts_1.extractStyleParts(args), classes = _a.classes, objects = _a.objects;
	                var registration = styleToClassName_1.styleToRegistration({ displayName: prop }, objects);
	                registrations.push(registration);
	                if (registration) {
	                    classMap[prop] = registration.className;
	                    classNameSet[prop] = classes.concat([registration.className]).join(' ');
	                }
	            }
	        }
	        for (var _b = 0, registrations_1 = registrations; _b < registrations_1.length; _b++) {
	            var registration = registrations_1[_b];
	            if (registration) {
	                styleToClassName_1.applyRegistration(registration, classMap);
	            }
	        }
	    }
	    return classNameSet;
	}
	exports.mergeStyleSets = mergeStyleSets;
	//# sourceMappingURL=mergeStyleSets.js.map

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Combine a set of styles together (but does not register css classes.)
	 * @public
	 */
	function concatStyleSets() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // tslint:disable-next-line:no-any
	    var mergedSet = {};
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var currentSet = args_1[_a];
	        if (currentSet) {
	            for (var prop in currentSet) {
	                if (currentSet.hasOwnProperty(prop)) {
	                    var mergedValue = mergedSet[prop];
	                    var currentValue = currentSet[prop];
	                    if (mergedValue === undefined) {
	                        mergedSet[prop] = currentValue;
	                    }
	                    else {
	                        mergedSet[prop] = (Array.isArray(mergedValue) ? mergedValue : [mergedValue]).concat((Array.isArray(currentValue) ? currentValue : [currentValue]));
	                    }
	                }
	            }
	        }
	    }
	    return mergedSet;
	}
	exports.concatStyleSets = concatStyleSets;
	//# sourceMappingURL=concatStyleSets.js.map

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(2315);
	var styleToClassName_1 = __webpack_require__(2314);
	/**
	 * Registers a font face.
	 * @public
	 */
	function fontFace(font) {
	    Stylesheet_1.Stylesheet.getInstance().insertRule("@font-face{" + styleToClassName_1.serializeRuleEntries(font) + "}");
	}
	exports.fontFace = fontFace;
	//# sourceMappingURL=fontFace.js.map

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Stylesheet_1 = __webpack_require__(2315);
	var styleToClassName_1 = __webpack_require__(2314);
	/**
	 * Registers keyframe definitions.
	 *
	 * @public
	 */
	function keyframes(timeline) {
	    var stylesheet = Stylesheet_1.Stylesheet.getInstance();
	    var name = stylesheet.getClassName();
	    var rulesArray = [];
	    for (var prop in timeline) {
	        if (timeline.hasOwnProperty(prop)) {
	            rulesArray.push(prop, '{', styleToClassName_1.serializeRuleEntries(timeline[prop]), '}');
	        }
	    }
	    var rules = rulesArray.join('');
	    stylesheet.insertRule("@keyframes " + name + "{" + rules + "}");
	    stylesheet.cacheClassName(name, rules, [], ['keyframes', rules]);
	    return name;
	}
	exports.keyframes = keyframes;
	//# sourceMappingURL=keyframes.js.map

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var warn_1 = __webpack_require__(2327);
	var GlobalSettings_1 = __webpack_require__(2328);
	var index_1 = __webpack_require__(2312);
	var ICON_SETTING_NAME = 'icons';
	var _iconSettings = GlobalSettings_1.GlobalSettings.getValue(ICON_SETTING_NAME, {
	    __options: {
	        disableWarnings: false,
	        warnOnMissingIcons: true
	    },
	    __remapped: {}
	});
	/**
	 * Registers a given subset of icons.
	 *
	 * @param iconSubset - the icon subset definition.
	 */
	function registerIcons(iconSubset, options) {
	    var subset = tslib_1.__assign({}, iconSubset, { isRegistered: false, className: undefined });
	    var icons = iconSubset.icons;
	    // Grab options, optionally mix user provided ones on top.
	    options = options ? tslib_1.__assign({}, _iconSettings.__options, options) : _iconSettings.__options;
	    for (var iconName in icons) {
	        if (icons.hasOwnProperty(iconName)) {
	            var code = icons[iconName];
	            var normalizedIconName = iconName.toLowerCase();
	            if (_iconSettings[normalizedIconName]) {
	                _warnDuplicateIcon(iconName);
	            }
	            else {
	                _iconSettings[normalizedIconName] = {
	                    code: code,
	                    subset: subset
	                };
	            }
	        }
	    }
	}
	exports.registerIcons = registerIcons;
	/**
	 * Remaps one icon name to another.
	 */
	function registerIconAlias(iconName, mappedToName) {
	    _iconSettings.__remapped[iconName.toLowerCase()] = mappedToName.toLowerCase();
	}
	exports.registerIconAlias = registerIconAlias;
	/**
	 * Gets an icon definition. If an icon is requested but the subset has yet to be registered,
	 * it will get registered immediately.
	 *
	 * @public
	 * @param name - Name of icon.
	 */
	function getIcon(name) {
	    var icon = undefined;
	    var options = _iconSettings.__options;
	    name = name ? name.toLowerCase() : '';
	    name = _iconSettings.__remapped[name] || name;
	    if (name) {
	        icon = _iconSettings[name];
	        if (icon) {
	            var subset = icon.subset;
	            if (subset.fontFace && !subset.isRegistered) {
	                // Register font face for given icons.
	                index_1.fontFace(subset.fontFace);
	                // Generate a base class name for the given font.
	                subset.className = index_1.mergeStyles(subset.style, {
	                    fontFamily: subset.fontFace.fontFamily,
	                    fontWeight: subset.fontFace.fontWeight || 'normal',
	                    fontStyle: subset.fontFace.fontStyle || 'normal'
	                }).toString();
	                subset.isRegistered = true;
	            }
	        }
	        else {
	            if (!options.disableWarnings && options.warnOnMissingIcons) {
	                warn_1.warn("The icon \"" + name + "\" was used but not registered. See http://aka.ms/fabric-icon-usage for more information.");
	            }
	        }
	    }
	    return icon;
	}
	exports.getIcon = getIcon;
	/**
	 * Sets the icon options.
	 *
	 * @public
	 */
	function setIconOptions(options) {
	    _iconSettings.__options = tslib_1.__assign({}, _iconSettings.__options, options);
	}
	exports.setIconOptions = setIconOptions;
	var _missingIcons = [];
	var _missingIconsTimer = undefined;
	function _warnDuplicateIcon(iconName) {
	    var options = _iconSettings.__options;
	    var warningDelay = 2000;
	    var maxIconsInMessage = 10;
	    if (!options.disableWarnings) {
	        _missingIcons.push(iconName);
	        if (_missingIconsTimer === undefined) {
	            _missingIconsTimer = setTimeout(function () {
	                warn_1.warn("Some icons were re-registered. Applications should only call registerIcons for any given " +
	                    "icon once. Redefining what an icon is may have unintended consequences. Duplicates " +
	                    "include: \n" +
	                    _missingIcons.slice(0, maxIconsInMessage).join(', ') +
	                    (_missingIcons.length > maxIconsInMessage ? " (+ " + (_missingIcons.length - maxIconsInMessage) + " more)" : ''));
	                _missingIconsTimer = undefined;
	                _missingIcons = [];
	            }, warningDelay);
	        }
	    }
	}
	//# sourceMappingURL=icons.js.map

/***/ }),
/* 2327 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _warningCallback = undefined;
	/**
	 * Warns when a deprecated props are being used.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
	 * either null or a replacement prop name.
	 */
	function warnDeprecations(componentName, props, deprecationMap) {
	    for (var propName in deprecationMap) {
	        if (props && propName in props) {
	            var deprecationMessage = componentName + " property '" + propName + "' was used but has been deprecated.";
	            var replacementPropName = deprecationMap[propName];
	            if (replacementPropName) {
	                deprecationMessage += " Use '" + replacementPropName + "' instead.";
	            }
	            warn(deprecationMessage);
	        }
	    }
	}
	exports.warnDeprecations = warnDeprecations;
	/**
	 * Warns when two props which are mutually exclusive are both being used.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param exclusiveMap - A map where the key is a parameter, and the value is the other parameter.
	 */
	function warnMutuallyExclusive(componentName, props, exclusiveMap) {
	    for (var propName in exclusiveMap) {
	        if (props && propName in props) {
	            var propInExclusiveMapValue = exclusiveMap[propName];
	            if (propInExclusiveMapValue && propInExclusiveMapValue in props) {
	                warn(componentName + " property '" + propName + "' is mutually exclusive with '" + exclusiveMap[propName] + "'. Use one or the other.");
	            }
	        }
	    }
	}
	exports.warnMutuallyExclusive = warnMutuallyExclusive;
	/**
	 * Warns when props are required if a condition is met.
	 *
	 * @public
	 * @param componentName - The name of the component being used.
	 * @param props - The props passed into the component.
	 * @param requiredProps - The name of the props that are required when the condition is met.
	 * @param conditionalPropName - The name of the prop that the condition is based on.
	 * @param condition - Whether the condition is met.
	*/
	function warnConditionallyRequiredProps(componentName, props, requiredProps, conditionalPropName, condition) {
	    if (condition === true) {
	        for (var _i = 0, requiredProps_1 = requiredProps; _i < requiredProps_1.length; _i++) {
	            var requiredPropName = requiredProps_1[_i];
	            if (!(requiredPropName in props)) {
	                warn(componentName + " property '" + requiredPropName + "' is required when '" + conditionalPropName + "' is used.'");
	            }
	        }
	    }
	}
	exports.warnConditionallyRequiredProps = warnConditionallyRequiredProps;
	/**
	 * Sends a warning to console, if the api is present.
	 *
	 * @public
	 * @param message - Warning message.
	 */
	function warn(message) {
	    if (_warningCallback) {
	        _warningCallback(message);
	    }
	    else if (console && console.warn) {
	        console.warn(message);
	    }
	}
	exports.warn = warn;
	/**
	 * Configures the warning callback. Passing in undefined will reset it to use the default
	 * console.warn function.
	 *
	 * @public
	 * @param warningCallback - Callback to override the generated warnings.
	 */
	function setWarningCallback(warningCallback) {
	    _warningCallback = warningCallback;
	}
	exports.setWarningCallback = setWarningCallback;
	//# sourceMappingURL=warn.js.map

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Storing global state in local module variables has issues when more than one copy
	 * if the module gets loaded on the page (due to a bundling error or simply by consuming
	 * a prebundled script.)
	 *
	 * This file contains helpers to deal with the getting and setting local state, and allows
	 * callers to get called back when it mutates.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var GLOBAL_SETTINGS_PROP_NAME = '__globalSettings__';
	var CALLBACK_STATE_PROP_NAME = '__callbacks__';
	// tslint:disable-next-line:no-any
	var _globalSettings = {};
	var _counter = 0;
	if (typeof window !== 'undefined') {
	    // tslint:disable-next-line:no-any
	    var win = window;
	    _globalSettings = win[GLOBAL_SETTINGS_PROP_NAME] = win[GLOBAL_SETTINGS_PROP_NAME] || (_a = {},
	        _a[CALLBACK_STATE_PROP_NAME] = {},
	        _a);
	}
	var _callbacks = _globalSettings[CALLBACK_STATE_PROP_NAME];
	/**
	 * Global settings helper, which stores settings in the global (window) namespace.
	 * If window is not provided, it will store settings in module scope. Provides a
	 * way to observe changes as well when their values change.
	 *
	 * @public
	 */
	var GlobalSettings = /** @class */ (function () {
	    function GlobalSettings() {
	    }
	    GlobalSettings.getValue = function (key, defaultValue) {
	        if (_globalSettings[key] === undefined) {
	            _globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
	        }
	        return _globalSettings[key];
	    };
	    GlobalSettings.setValue = function (key, value) {
	        var oldValue = _globalSettings[key];
	        if (value !== oldValue) {
	            _globalSettings[key] = value;
	            var changeDescription = {
	                oldValue: oldValue,
	                value: value,
	                key: key
	            };
	            for (var id in _callbacks) {
	                if (_callbacks.hasOwnProperty(id)) {
	                    _callbacks[id](changeDescription);
	                }
	            }
	        }
	        return value;
	    };
	    GlobalSettings.addChangeListener = function (cb) {
	        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
	        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
	        var id = cb.__id__;
	        if (!id) {
	            id = cb.__id__ = String(_counter++);
	        }
	        _callbacks[id] = cb;
	    };
	    GlobalSettings.removeChangeListener = function (cb) {
	        delete _callbacks[cb.__id__];
	    };
	    return GlobalSettings;
	}());
	exports.GlobalSettings = GlobalSettings;
	var _a;
	//# sourceMappingURL=GlobalSettings.js.map

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2312);
	var icons_1 = __webpack_require__(2326);
	var defaultIconStyles = {
	    display: 'inline-block'
	};
	/**
	 * Gets an icon classname. You should be able to add this classname to an I tag with no
	 * additional classnames, and render the icon.
	 *
	 * @public
	 */
	function getIconClassName(name) {
	    var className = '';
	    var icon = icons_1.getIcon(name);
	    if (icon) {
	        className = index_1.mergeStyles(icon.subset.className, defaultIconStyles, {
	            selectors: {
	                '::before': {
	                    content: "\"" + icon.code + "\""
	                }
	            }
	        });
	    }
	    return className;
	}
	exports.getIconClassName = getIconClassName;
	//# sourceMappingURL=getIconClassName.js.map

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var AnimationStyles_1 = __webpack_require__(2331);
	exports.AnimationStyles = AnimationStyles_1.AnimationStyles;
	exports.AnimationVariables = AnimationStyles_1.AnimationVariables;
	var DefaultPalette_1 = __webpack_require__(2332);
	exports.DefaultPalette = DefaultPalette_1.DefaultPalette;
	var DefaultFontStyles_1 = __webpack_require__(2333);
	exports.DefaultFontStyles = DefaultFontStyles_1.DefaultFontStyles;
	exports.registerDefaultFontFaces = DefaultFontStyles_1.registerDefaultFontFaces;
	var fonts_1 = __webpack_require__(2334);
	exports.FontSizes = fonts_1.FontSizes;
	exports.FontWeights = fonts_1.FontWeights;
	exports.IconFontSizes = fonts_1.IconFontSizes;
	exports.createFontStyles = fonts_1.createFontStyles;
	var getFocusStyle_1 = __webpack_require__(2338);
	exports.getFocusStyle = getFocusStyle_1.getFocusStyle;
	exports.focusClear = getFocusStyle_1.focusClear;
	var hiddenContentStyle_1 = __webpack_require__(2343);
	exports.hiddenContentStyle = hiddenContentStyle_1.hiddenContentStyle;
	var PulsingBeaconAnimationStyles_1 = __webpack_require__(2344);
	exports.PulsingBeaconAnimationStyles = PulsingBeaconAnimationStyles_1.PulsingBeaconAnimationStyles;
	var getGlobalClassNames_1 = __webpack_require__(2345);
	exports.getGlobalClassNames = getGlobalClassNames_1.getGlobalClassNames;
	var theme_1 = __webpack_require__(2346);
	exports.ThemeSettingName = theme_1.ThemeSettingName;
	exports.getTheme = theme_1.getTheme;
	exports.loadTheme = theme_1.loadTheme;
	exports.createTheme = theme_1.createTheme;
	exports.registerOnThemeChangeCallback = theme_1.registerOnThemeChangeCallback;
	exports.removeOnThemeChangeCallback = theme_1.removeOnThemeChangeCallback;
	tslib_1.__exportStar(__webpack_require__(2339), exports);
	tslib_1.__exportStar(__webpack_require__(2350), exports);
	tslib_1.__exportStar(__webpack_require__(2342), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2312);
	/* Register the keyframes */
	var EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
	var EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
	var DURATION_1 = '0.167s';
	var DURATION_2 = '0.267s';
	var DURATION_3 = '0.367s';
	var DURATION_4 = '0.467s';
	var FADE_IN = index_1.keyframes({
	    from: { opacity: 0 },
	    to: { opacity: 1 }
	});
	var FADE_OUT = index_1.keyframes({
	    from: { opacity: 1 },
	    to: { opacity: 0 }
	});
	var SLIDE_RIGHT_IN10 = _createSlideInX(-10);
	var SLIDE_RIGHT_IN20 = _createSlideInX(-20);
	var SLIDE_RIGHT_IN40 = _createSlideInX(-40);
	var SLIDE_RIGHT_IN400 = _createSlideInX(-400);
	var SLIDE_LEFT_IN10 = _createSlideInX(10);
	var SLIDE_LEFT_IN20 = _createSlideInX(20);
	var SLIDE_LEFT_IN40 = _createSlideInX(40);
	var SLIDE_LEFT_IN400 = _createSlideInX(400);
	var SLIDE_UP_IN10 = _createSlideInY(10);
	var SLIDE_UP_IN20 = _createSlideInY(20);
	var SLIDE_DOWN_IN10 = _createSlideInY(-10);
	var SLIDE_DOWN_IN20 = _createSlideInY(-20);
	var SLIDE_RIGHT_OUT10 = _createSlideOutX(10);
	var SLIDE_RIGHT_OUT20 = _createSlideOutX(20);
	var SLIDE_RIGHT_OUT40 = _createSlideOutX(40);
	var SLIDE_RIGHT_OUT400 = _createSlideOutX(400);
	var SLIDE_LEFT_OUT10 = _createSlideOutX(-10);
	var SLIDE_LEFT_OUT20 = _createSlideOutX(-20);
	var SLIDE_LEFT_OUT40 = _createSlideOutX(-40);
	var SLIDE_LEFT_OUT400 = _createSlideOutX(-400);
	var SLIDE_UP_OUT10 = _createSlideOutY(-10);
	var SLIDE_UP_OUT20 = _createSlideOutY(-20);
	var SLIDE_DOWN_OUT10 = _createSlideOutY(10);
	var SLIDE_DOWN_OUT20 = _createSlideOutY(20);
	var SCALE_UP100 = index_1.keyframes({
	    from: { transform: 'scale3d(.98,.98,1)' },
	    to: { transform: 'scale3d(1,1,1)' }
	});
	var SCALE_DOWN98 = index_1.keyframes({
	    from: { transform: 'scale3d(1,1,1)' },
	    to: { transform: 'scale3d(.98,.98,1)' },
	});
	var SCALE_DOWN100 = index_1.keyframes({
	    from: { transform: 'scale3d(1.03,1.03,1)' },
	    to: { transform: 'scale3d(1,1,1)' }
	});
	var SCALE_UP103 = index_1.keyframes({
	    from: { transform: 'scale3d(1,1,1)' },
	    to: { transform: 'scale3d(1.03,1.03,1)' }
	});
	var ROTATE90 = index_1.keyframes({
	    from: { transform: 'rotateZ(0deg)' },
	    to: { transform: 'rotateZ(90deg)' }
	});
	var ROTATE_N90 = index_1.keyframes({
	    from: { transform: 'rotateZ(0deg)' },
	    to: { transform: 'rotateZ(-90deg)' }
	});
	/**
	 * Exporting raw duraction values and easing functions to be used in custom animations
	 */
	exports.AnimationVariables = {
	    easeFunction1: EASING_FUNCTION_1,
	    easeFunction2: EASING_FUNCTION_2,
	    durationValue1: DURATION_1,
	    durationValue2: DURATION_2,
	    durationValue3: DURATION_3,
	    durationValue4: DURATION_4
	};
	/**
	 * All Fabric standard animations, exposed as json objects referencing predefined
	 * keyframes. These objects can be mixed in with other class definitions.
	 */
	exports.AnimationStyles = {
	    slideRightIn10: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn20: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn40: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN40, DURATION_3, EASING_FUNCTION_1),
	    slideRightIn400: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN400, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn10: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn20: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn40: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN40, DURATION_3, EASING_FUNCTION_1),
	    slideLeftIn400: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN400, DURATION_3, EASING_FUNCTION_1),
	    slideUpIn10: _createAnimation(FADE_IN + "," + SLIDE_UP_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideUpIn20: _createAnimation(FADE_IN + "," + SLIDE_UP_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideDownIn10: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN10, DURATION_3, EASING_FUNCTION_1),
	    slideDownIn20: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN20, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut10: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut20: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut40: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT40, DURATION_3, EASING_FUNCTION_1),
	    slideRightOut400: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT400, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut10: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut20: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut40: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT40, DURATION_3, EASING_FUNCTION_1),
	    slideLeftOut400: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT400, DURATION_3, EASING_FUNCTION_1),
	    slideUpOut10: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideUpOut20: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT20, DURATION_3, EASING_FUNCTION_1),
	    slideDownOut10: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT10, DURATION_3, EASING_FUNCTION_1),
	    slideDownOut20: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT20, DURATION_3, EASING_FUNCTION_1),
	    scaleUpIn100: _createAnimation(FADE_IN + "," + SCALE_UP100, DURATION_3, EASING_FUNCTION_1),
	    scaleDownIn100: _createAnimation(FADE_IN + "," + SCALE_DOWN100, DURATION_3, EASING_FUNCTION_1),
	    scaleUpOut103: _createAnimation(FADE_OUT + "," + SCALE_UP103, DURATION_1, EASING_FUNCTION_2),
	    scaleDownOut98: _createAnimation(FADE_OUT + "," + SCALE_DOWN98, DURATION_1, EASING_FUNCTION_2),
	    fadeIn100: _createAnimation(FADE_IN, DURATION_1, EASING_FUNCTION_2),
	    fadeIn200: _createAnimation(FADE_IN, DURATION_2, EASING_FUNCTION_2),
	    fadeIn400: _createAnimation(FADE_IN, DURATION_3, EASING_FUNCTION_2),
	    fadeIn500: _createAnimation(FADE_IN, DURATION_4, EASING_FUNCTION_2),
	    fadeOut100: _createAnimation(FADE_OUT, DURATION_1, EASING_FUNCTION_2),
	    fadeOut200: _createAnimation(FADE_OUT, DURATION_2, EASING_FUNCTION_2),
	    fadeOut400: _createAnimation(FADE_OUT, DURATION_3, EASING_FUNCTION_2),
	    fadeOut500: _createAnimation(FADE_OUT, DURATION_4, EASING_FUNCTION_2),
	    rotate90deg: _createAnimation(ROTATE90, '0.1s', EASING_FUNCTION_2),
	    rotateN90deg: _createAnimation(ROTATE_N90, '0.1s', EASING_FUNCTION_2)
	    // expandCollapse 100/200/400, delay 100/200
	};
	function _createAnimation(animationName, animationDuration, animationTimingFunction) {
	    return {
	        animationName: animationName,
	        animationDuration: animationDuration,
	        animationTimingFunction: animationTimingFunction,
	        animationFillMode: 'both'
	    };
	}
	function _createSlideInX(fromX) {
	    return index_1.keyframes({
	        from: { transform: "translate3d(" + fromX + "px,0,0)" },
	        to: { transform: "translate3d(0,0,0)" }
	    });
	}
	function _createSlideInY(fromY) {
	    return index_1.keyframes({
	        from: { transform: "translate3d(0," + fromY + "px,0)" },
	        to: { transform: "translate3d(0,0,0)" }
	    });
	}
	function _createSlideOutX(toX) {
	    return index_1.keyframes({
	        from: { transform: "translate3d(0,0,0)" },
	        to: { transform: "translate3d(" + toX + "px,0,0)" }
	    });
	}
	function _createSlideOutY(toY) {
	    return index_1.keyframes({
	        from: { transform: "translate3d(0,0,0)" },
	        to: { transform: "translate3d(0," + toY + "px,0)" }
	    });
	}
	//# sourceMappingURL=AnimationStyles.js.map

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// When adding or removing a color, make sure you keep this consistent with IColorClassNames by adding the color variants.
	exports.DefaultPalette = {
	    themeDarker: '#004578',
	    themeDark: '#005a9e',
	    themeDarkAlt: '#106ebe',
	    themePrimary: '#0078d4',
	    themeSecondary: '#2b88d8',
	    themeTertiary: '#71afe5',
	    themeLight: '#c7e0f4',
	    themeLighter: '#deecf9',
	    themeLighterAlt: '#eff6fc',
	    black: '#000000',
	    blackTranslucent40: 'rgba(0,0,0,.4)',
	    neutralDark: '#212121',
	    neutralPrimary: '#333333',
	    neutralPrimaryAlt: '#3c3c3c',
	    neutralSecondary: '#666666',
	    neutralTertiary: '#a6a6a6',
	    neutralTertiaryAlt: '#c8c8c8',
	    neutralQuaternary: '#d0d0d0',
	    neutralQuaternaryAlt: '#dadada',
	    neutralLight: '#eaeaea',
	    neutralLighter: '#f4f4f4',
	    neutralLighterAlt: '#f8f8f8',
	    accent: '#0078d4',
	    white: '#ffffff',
	    whiteTranslucent40: 'rgba(255,255,255,.4)',
	    yellow: '#ffb900',
	    yellowLight: '#fff100',
	    orange: '#d83b01',
	    orangeLight: '#ea4300',
	    orangeLighter: '#ff8c00',
	    redDark: '#a80000',
	    red: '#e81123',
	    magentaDark: '#5c005c',
	    magenta: '#b4009e',
	    magentaLight: '#e3008c',
	    purpleDark: '#32145a',
	    purple: '#5c2d91',
	    purpleLight: '#b4a0ff',
	    blueDark: '#002050',
	    blueMid: '#00188f',
	    blue: '#0078d4',
	    blueLight: '#00bcf2',
	    tealDark: '#004b50',
	    teal: '#008272',
	    tealLight: '#00b294',
	    greenDark: '#004b1c',
	    green: '#107c10',
	    greenLight: '#bad80a',
	};
	//# sourceMappingURL=DefaultPalette.js.map

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2312);
	var fonts_1 = __webpack_require__(2334);
	var language_1 = __webpack_require__(2335);
	// Default urls.
	var DefaultBaseUrl = 'https://static2.sharepointonline.com/files/fabric/assets';
	// Standard font styling.
	exports.DefaultFontStyles = fonts_1.createFontStyles(language_1.getLanguage());
	function _registerFontFace(fontFamily, url, fontWeight, localFontName) {
	    fontFamily = "'" + fontFamily + "'";
	    var localFontSrc = localFontName !== undefined ? "local('" + localFontName + "')," : '';
	    index_1.fontFace({
	        fontFamily: fontFamily,
	        src: localFontSrc +
	            ("url('" + url + ".woff2') format('woff2'),") +
	            ("url('" + url + ".woff') format('woff')"),
	        fontWeight: fontWeight,
	        fontStyle: 'normal'
	    });
	}
	function _registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
	    if (cdnFontName === void 0) { cdnFontName = 'segoeui'; }
	    var urlBase = baseUrl + "/" + cdnFolder + "/" + cdnFontName;
	    _registerFontFace(fontFamily, urlBase + '-light', fonts_1.FontWeights.light, localFontName && localFontName + ' Light');
	    _registerFontFace(fontFamily, urlBase + '-semilight', fonts_1.FontWeights.semilight, localFontName && localFontName + ' SemiLight');
	    _registerFontFace(fontFamily, urlBase + '-regular', fonts_1.FontWeights.regular, localFontName);
	    _registerFontFace(fontFamily, urlBase + '-semibold', fonts_1.FontWeights.semibold, localFontName && localFontName + ' SemiBold');
	}
	function registerDefaultFontFaces(baseUrl) {
	    if (baseUrl) {
	        var fontUrl = baseUrl + "/fonts";
	        // Produce @font-face definitions for all supported web fonts.
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Thai, 'leelawadeeui-thai', 'leelawadeeui');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Arabic, 'segoeui-arabic');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Cyrillic, 'segoeui-cyrillic');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.EastEuropean, 'segoeui-easteuropean');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Greek, 'segoeui-greek');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Hebrew, 'segoeui-hebrew');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.Vietnamese, 'segoeui-vietnamese');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontNames.WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');
	        _registerFontFaceSet(fontUrl, fonts_1.LocalizedFontFamilies.Selawik, 'selawik', 'selawik');
	        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
	        // the font-face generated above to use the 'semilight' weight instead.
	        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-semilight", fonts_1.FontWeights.light);
	        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
	        // the font-face generated above to use the 'bold' weight instead.
	        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-bold", fonts_1.FontWeights.semibold);
	    }
	}
	exports.registerDefaultFontFaces = registerDefaultFontFaces;
	/**
	 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
	 */
	function _getFontBaseUrl() {
	    var win = typeof window !== 'undefined' ? window : undefined;
	    // tslint:disable-next-line:no-string-literal no-any
	    var fabricConfig = win ? win['FabricConfig'] : undefined;
	    return (fabricConfig && fabricConfig.fontBaseUrl !== undefined) ? fabricConfig.fontBaseUrl : DefaultBaseUrl;
	}
	/**
	 * Register the font faces.
	 */
	registerDefaultFontFaces(_getFontBaseUrl());
	//# sourceMappingURL=DefaultFontStyles.js.map

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Fallback fonts, if specified system or web fonts are unavailable.
	var FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
	// Font face names to be registered.
	var LocalizedFontNames;
	(function (LocalizedFontNames) {
	    LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
	    LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
	    LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
	    LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
	    LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
	    LocalizedFontNames.Thai = 'Leelawadee UI Web';
	    LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
	    LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
	    LocalizedFontNames.Selawik = 'Selawik Web';
	})(LocalizedFontNames = exports.LocalizedFontNames || (exports.LocalizedFontNames = {}));
	// Font families with fallbacks, for the general regions.
	var LocalizedFontFamilies;
	(function (LocalizedFontFamilies) {
	    LocalizedFontFamilies.Arabic = "'" + LocalizedFontNames.Arabic + "'";
	    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
	    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
	    LocalizedFontFamilies.Cyrillic = "'" + LocalizedFontNames.Cyrillic + "'";
	    LocalizedFontFamilies.EastEuropean = "'" + LocalizedFontNames.EastEuropean + "'";
	    LocalizedFontFamilies.Greek = "'" + LocalizedFontNames.Greek + "'";
	    LocalizedFontFamilies.Hebrew = "'" + LocalizedFontNames.Hebrew + "'";
	    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
	    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
	    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
	    LocalizedFontFamilies.Selawik = "'" + LocalizedFontNames.Selawik + "'";
	    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
	    LocalizedFontFamilies.Vietnamese = "'" + LocalizedFontNames.Vietnamese + "'";
	    LocalizedFontFamilies.WestEuropean = "'" + LocalizedFontNames.WestEuropean + "'";
	})(LocalizedFontFamilies = exports.LocalizedFontFamilies || (exports.LocalizedFontFamilies = {}));
	// By default, we favor system fonts for the default.
	// All localized fonts use a web font and never use the system font.
	var defaultFontFamily = "'Segoe UI', '" + LocalizedFontNames.WestEuropean + "'";
	// Mapping of language prefix to to font family.
	var LanguageToFontMap = {
	    'ar': LocalizedFontFamilies.Arabic,
	    'bg': LocalizedFontFamilies.Cyrillic,
	    'cs': LocalizedFontFamilies.EastEuropean,
	    'el': LocalizedFontFamilies.Greek,
	    'et': LocalizedFontFamilies.EastEuropean,
	    'he': LocalizedFontFamilies.Hebrew,
	    'hi': LocalizedFontFamilies.Hindi,
	    'hr': LocalizedFontFamilies.EastEuropean,
	    'hu': LocalizedFontFamilies.EastEuropean,
	    'ja': LocalizedFontFamilies.Japanese,
	    'kk': LocalizedFontFamilies.EastEuropean,
	    'ko': LocalizedFontFamilies.Korean,
	    'lt': LocalizedFontFamilies.EastEuropean,
	    'lv': LocalizedFontFamilies.EastEuropean,
	    'pl': LocalizedFontFamilies.EastEuropean,
	    'ru': LocalizedFontFamilies.Cyrillic,
	    'sk': LocalizedFontFamilies.EastEuropean,
	    'sr-latn': LocalizedFontFamilies.EastEuropean,
	    'th': LocalizedFontFamilies.Thai,
	    'tr': LocalizedFontFamilies.EastEuropean,
	    'uk': LocalizedFontFamilies.Cyrillic,
	    'vi': LocalizedFontFamilies.Vietnamese,
	    'zh-hans': LocalizedFontFamilies.ChineseSimplified,
	    'zh-hant': LocalizedFontFamilies.ChineseTraditional,
	};
	// Standard font sizes.
	var FontSizes;
	(function (FontSizes) {
	    FontSizes.mini = '10px';
	    FontSizes.xSmall = '11px';
	    FontSizes.small = '12px';
	    FontSizes.smallPlus = '13px';
	    FontSizes.medium = '14px';
	    FontSizes.mediumPlus = '15px';
	    FontSizes.icon = '16px';
	    FontSizes.large = '17px';
	    FontSizes.xLarge = '21px';
	    FontSizes.xxLarge = '28px';
	    FontSizes.superLarge = '42px';
	    FontSizes.mega = '72px';
	})(FontSizes = exports.FontSizes || (exports.FontSizes = {}));
	// Standard font weights.
	var FontWeights;
	(function (FontWeights) {
	    FontWeights.light = 100;
	    FontWeights.semilight = 300;
	    FontWeights.regular = 400;
	    FontWeights.semibold = 600;
	    FontWeights.bold = 700;
	})(FontWeights = exports.FontWeights || (exports.FontWeights = {}));
	// Standard Icon Sizes.
	var IconFontSizes;
	(function (IconFontSizes) {
	    IconFontSizes.xSmall = '10px';
	    IconFontSizes.small = '12px';
	    IconFontSizes.medium = '16px';
	    IconFontSizes.large = '20px';
	})(IconFontSizes = exports.IconFontSizes || (exports.IconFontSizes = {}));
	function _fontFamilyWithFallbacks(fontFamily) {
	    return fontFamily + ", " + FontFamilyFallbacks;
	}
	function createFontStyles(localeCode) {
	    var localizedFont = _getLocalizedFontFamily(localeCode);
	    var fontFamilyWithFallback = _fontFamilyWithFallbacks(localizedFont);
	    var semilightFontFamilyWithFallback = fontFamilyWithFallback;
	    // Chrome has a bug where it does not render Segoe UI Semilight correctly, so we force the webfont to be used in that case
	    if (localizedFont === defaultFontFamily) {
	        semilightFontFamilyWithFallback = _fontFamilyWithFallbacks(LocalizedFontFamilies.WestEuropean);
	    }
	    var fontStyles = {
	        tiny: _createFont(FontSizes.mini, FontWeights.semibold, fontFamilyWithFallback),
	        xSmall: _createFont(FontSizes.xSmall, FontWeights.regular, fontFamilyWithFallback),
	        small: _createFont(FontSizes.small, FontWeights.regular, fontFamilyWithFallback),
	        smallPlus: _createFont(FontSizes.smallPlus, FontWeights.regular, fontFamilyWithFallback),
	        medium: _createFont(FontSizes.medium, FontWeights.regular, fontFamilyWithFallback),
	        mediumPlus: _createFont(FontSizes.mediumPlus, FontWeights.regular, fontFamilyWithFallback),
	        large: _createFont(FontSizes.large, FontWeights.semilight, semilightFontFamilyWithFallback),
	        xLarge: _createFont(FontSizes.xLarge, FontWeights.light, fontFamilyWithFallback),
	        xxLarge: _createFont(FontSizes.xxLarge, FontWeights.light, fontFamilyWithFallback),
	        superLarge: _createFont(FontSizes.superLarge, FontWeights.light, fontFamilyWithFallback),
	        mega: _createFont(FontSizes.mega, FontWeights.light, fontFamilyWithFallback)
	    };
	    return fontStyles;
	}
	exports.createFontStyles = createFontStyles;
	/**
	 * If there is a localized font for this language, return that. Returns undefined if there is no localized font for that language.
	 */
	function _getLocalizedFontFamily(language) {
	    for (var lang in LanguageToFontMap) {
	        if (LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
	            // tslint:disable-next-line:no-any
	            return LanguageToFontMap[lang];
	        }
	    }
	    return defaultFontFamily;
	}
	function _createFont(size, weight, fontFamily) {
	    return {
	        fontFamily: fontFamily,
	        MozOsxFontSmoothing: 'grayscale',
	        WebkitFontSmoothing: 'antialiased',
	        fontSize: size,
	        fontWeight: weight
	    };
	}
	//# sourceMappingURL=fonts.js.map

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_1 = __webpack_require__(2336);
	var localStorage_1 = __webpack_require__(2337);
	// Default to undefined so that we initialize on first read.
	var _language;
	/**
	 * Gets the rtl state of the page (returns true if in rtl.)
	 *
	 * @public
	 */
	function getLanguage() {
	    if (_language === undefined) {
	        var doc = dom_1.getDocument();
	        var savedLanguage = localStorage_1.getItem('language');
	        if (savedLanguage !== null) {
	            _language = savedLanguage;
	        }
	        if (_language === undefined && doc) {
	            _language = doc.documentElement.getAttribute('lang');
	        }
	        if (_language === undefined) {
	            _language = 'en';
	        }
	    }
	    return _language;
	}
	exports.getLanguage = getLanguage;
	/**
	 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
	 *
	 * @public
	 */
	function setLanguage(language, avoidPersisting) {
	    if (avoidPersisting === void 0) { avoidPersisting = false; }
	    var doc = dom_1.getDocument();
	    if (doc) {
	        doc.documentElement.setAttribute('lang', language);
	    }
	    if (!avoidPersisting) {
	        localStorage_1.setItem('language', language);
	    }
	    _language = language;
	}
	exports.setLanguage = setLanguage;
	//# sourceMappingURL=language.js.map

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Sets the virtual parent of an element.
	 * Pass `undefined` as the `parent` to clear the virtual parent.
	 *
	 * @public
	 */
	function setVirtualParent(child, parent) {
	    var virtualChild = child;
	    var virtualParent = parent;
	    if (!virtualChild._virtual) {
	        virtualChild._virtual = {
	            children: []
	        };
	    }
	    var oldParent = virtualChild._virtual.parent;
	    if (oldParent && oldParent !== parent) {
	        // Remove the child from its old parent.
	        var index = oldParent._virtual.children.indexOf(virtualChild);
	        if (index > -1) {
	            oldParent._virtual.children.splice(index, 1);
	        }
	    }
	    virtualChild._virtual.parent = virtualParent || undefined;
	    if (virtualParent) {
	        if (!virtualParent._virtual) {
	            virtualParent._virtual = {
	                children: []
	            };
	        }
	        virtualParent._virtual.children.push(virtualChild);
	    }
	}
	exports.setVirtualParent = setVirtualParent;
	/**
	 * Gets the virtual parent given the child element, if it exists.
	 *
	 * @public
	 */
	function getVirtualParent(child) {
	    var parent;
	    if (child && isVirtualElement(child)) {
	        parent = child._virtual.parent;
	    }
	    return parent;
	}
	exports.getVirtualParent = getVirtualParent;
	/**
	 * Gets the element which is the parent of a given element.
	 * If `allowVirtuaParents` is `true`, this method prefers the virtual parent over
	 * real DOM parent when present.
	 *
	 * @public
	 */
	function getParent(child, allowVirtualParents) {
	    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
	    return child && (allowVirtualParents && getVirtualParent(child) ||
	        child.parentNode && child.parentNode);
	}
	exports.getParent = getParent;
	/**
	 * Gets the elements which are child elements of the given element.
	 * If `allowVirtualChildren` is `true`, this method enumerates virtual child elements
	 * after the original children.
	 * @param parent
	 * @param allowVirtualChildren
	 */
	function getChildren(parent, allowVirtualChildren) {
	    if (allowVirtualChildren === void 0) { allowVirtualChildren = true; }
	    var children = [];
	    if (parent) {
	        for (var i = 0; i < parent.children.length; i++) {
	            children.push(parent.children.item(i));
	        }
	        if (allowVirtualChildren && isVirtualElement(parent)) {
	            children.push.apply(children, parent._virtual.children);
	        }
	    }
	    return children;
	}
	exports.getChildren = getChildren;
	/**
	 * Determines whether or not a parent element contains a given child element.
	 * If `allowVirtualParents` is true, this method may return `true` if the child
	 * has the parent in its virtual element hierarchy.
	 *
	 * @public
	 */
	function elementContains(parent, child, allowVirtualParents) {
	    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
	    var isContained = false;
	    if (parent && child) {
	        if (allowVirtualParents) {
	            isContained = false;
	            while (child) {
	                var nextParent = getParent(child);
	                if (nextParent === parent) {
	                    isContained = true;
	                    break;
	                }
	                child = nextParent;
	            }
	        }
	        else if (parent.contains) {
	            isContained = parent.contains(child);
	        }
	    }
	    return isContained;
	}
	exports.elementContains = elementContains;
	var _isSSR = false;
	/**
	 * Helper to set ssr mode to simulate no window object returned from getWindow helper.
	 *
	 * @public
	 */
	function setSSR(isEnabled) {
	    _isSSR = isEnabled;
	}
	exports.setSSR = setSSR;
	/**
	 * Helper to get the window object.
	 *
	 * @public
	 */
	function getWindow(rootElement) {
	    if (_isSSR || typeof window === 'undefined') {
	        return undefined;
	    }
	    else {
	        return (rootElement &&
	            rootElement.ownerDocument &&
	            rootElement.ownerDocument.defaultView ?
	            rootElement.ownerDocument.defaultView :
	            window);
	    }
	}
	exports.getWindow = getWindow;
	/**
	 * Helper to get the document object.
	 *
	 * @public
	 */
	function getDocument(rootElement) {
	    if (_isSSR || typeof document === 'undefined') {
	        return undefined;
	    }
	    else {
	        return rootElement && rootElement.ownerDocument ? rootElement.ownerDocument : document;
	    }
	}
	exports.getDocument = getDocument;
	/**
	 * Helper to get bounding client rect, works with window.
	 *
	 * @public
	 */
	function getRect(element) {
	    var rect;
	    if (element) {
	        if (element === window) {
	            rect = {
	                left: 0,
	                top: 0,
	                width: window.innerWidth,
	                height: window.innerHeight,
	                right: window.innerWidth,
	                bottom: window.innerHeight
	            };
	        }
	        else if (element.getBoundingClientRect) {
	            rect = element.getBoundingClientRect();
	        }
	    }
	    return rect;
	}
	exports.getRect = getRect;
	/**
	 * Finds the first parent element where the matchFunction returns true
	 * @param element element to start searching at
	 * @param matchFunction the function that determines if the element is a match
	 * @returns the matched element or null no match was found
	 */
	function findElementRecursive(element, matchFunction) {
	    if (!element || element === document.body) {
	        return null;
	    }
	    return matchFunction(element) ? element : findElementRecursive(getParent(element), matchFunction);
	}
	exports.findElementRecursive = findElementRecursive;
	/**
	 * Determines if an element, or any of its ancestors, contian the given attribute
	 * @param element - element to start searching at
	 * @param attribute - the attribute to search for
	 * @returns the value of the first instance found
	 */
	function elementContainsAttribute(element, attribute) {
	    var elementMatch = findElementRecursive(element, function (testElement) { return testElement.hasAttribute(attribute); });
	    return elementMatch && elementMatch.getAttribute(attribute);
	}
	exports.elementContainsAttribute = elementContainsAttribute;
	/**
	 * Determines whether or not an element has the virtual hierarchy extension.
	 *
	 * @public
	 */
	function isVirtualElement(element) {
	    return element && !!element._virtual;
	}
	//# sourceMappingURL=dom.js.map

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Fetches an item from local storage without throwing an exception
	 * @param key The key of the item to fetch from local storage
	 */
	function getItem(key) {
	    var result = null;
	    try {
	        result = window.localStorage.getItem(key);
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	    return result;
	}
	exports.getItem = getItem;
	/**
	 * Inserts an item into local storage without throwing an exception
	 * @param key The key of the item to add to local storage
	 * @param data The data to put into local storage
	 */
	function setItem(key, data) {
	    try {
	        window.localStorage.setItem(key, data);
	    }
	    catch (e) {
	        /* Eat the exception */
	    }
	}
	exports.setItem = setItem;
	//# sourceMappingURL=localStorage.js.map

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommonStyles_1 = __webpack_require__(2339);
	var initializeFocusRects_1 = __webpack_require__(2340);
	var zIndexes_1 = __webpack_require__(2342);
	/**
	 * Generates a focus style which can be used to define an :after focus border.
	 *
	 * @param theme - The theme object to use.
	 * @param inset - The number of pixels to inset the border.
	 * @param color - The color for the border.
	 * @param position - The positioning applied to the container. Must
	 * be 'relative' or 'absolute' so that the focus border can live around it.
	 * @param highContrastStyle - Style for high contrast mode.
	 * @returns The style object.
	 */
	function getFocusStyle(theme, inset, position, highContrastStyle) {
	    if (inset === void 0) { inset = 0; }
	    if (position === void 0) { position = 'relative'; }
	    if (highContrastStyle === void 0) { highContrastStyle = undefined; }
	    return {
	        outline: 'transparent',
	        position: position,
	        selectors: (_a = {
	                '::-moz-focus-inner': {
	                    border: '0'
	                }
	            },
	            _a["." + initializeFocusRects_1.IsFocusVisibleClassName + " &:focus:after"] = {
	                content: '""',
	                position: 'absolute',
	                left: inset + 1,
	                top: inset + 1,
	                bottom: inset + 1,
	                right: inset + 1,
	                border: '1px solid ' + theme.palette.white,
	                outline: '1px solid ' + theme.palette.neutralSecondary,
	                zIndex: zIndexes_1.ZIndexes.FocusStyle,
	                selectors: (_b = {},
	                    _b[CommonStyles_1.HighContrastSelector] = highContrastStyle,
	                    _b)
	            },
	            _a)
	    };
	    var _a, _b;
	}
	exports.getFocusStyle = getFocusStyle;
	/**
	 * Generates style to clear browser specific focus styles.
	 */
	function focusClear() {
	    return {
	        selectors: {
	            '&::-moz-focus-inner': {
	                // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
	                border: 0
	            },
	            '&': {
	                // Clear browser specific focus styles and use transparent as placeholder for focus style
	                outline: 'transparent'
	            }
	        }
	    };
	}
	exports.focusClear = focusClear;
	//# sourceMappingURL=getFocusStyle.js.map

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HighContrastSelector = '@media screen and (-ms-high-contrast: active)';
	exports.ScreenWidthMinSmall = 320;
	exports.ScreenWidthMinMedium = 480;
	exports.ScreenWidthMinLarge = 640;
	exports.ScreenWidthMinXLarge = 1024;
	exports.ScreenWidthMinXXLarge = 1366;
	exports.ScreenWidthMinXXXLarge = 1920;
	exports.ScreenWidthMaxSmall = exports.ScreenWidthMinMedium - 1;
	exports.ScreenWidthMaxMedium = exports.ScreenWidthMinLarge - 1;
	exports.ScreenWidthMaxLarge = exports.ScreenWidthMinXLarge - 1;
	exports.ScreenWidthMaxXLarge = exports.ScreenWidthMinXXLarge - 1;
	exports.ScreenWidthMaxXXLarge = exports.ScreenWidthMinXXXLarge - 1;
	function getScreenSelector(min, max) {
	    return "@media only screen and (min-width: " + min + "px) and (max-width: " + max + "px)";
	}
	exports.getScreenSelector = getScreenSelector;
	//# sourceMappingURL=CommonStyles.js.map

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_1 = __webpack_require__(2336);
	var keyboard_1 = __webpack_require__(2341);
	exports.IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
	/**
	 * Initializes the logic which:
	 *
	 * 1. Subscribes keydown and mousedown events. (It will only do it once per window,
	 *    so it's safe to call this method multiple times.)
	 * 2. When the user presses directional keyboard keys, adds the 'is-focusVisible' classname
	 *    to the document body.
	 * 3. When the user clicks a mouse button, we remove the classname if it exists.
	 *
	 * This logic allows components on the page to conditionally render focus treatments only
	 * if the global classname exists, which simplifies logic overall.
	 *
	 * @param window
	 */
	function initializeFocusRects(window) {
	    var win = (window || dom_1.getWindow());
	    if (win && !win.__hasInitializeFocusRects__) {
	        win.__hasInitializeFocusRects__ = true;
	        win.addEventListener('mousedown', _onMouseDown, true);
	        win.addEventListener('keydown', _onKeyDown, true);
	    }
	}
	exports.initializeFocusRects = initializeFocusRects;
	function _onMouseDown(ev) {
	    var win = dom_1.getWindow(ev.target);
	    if (win) {
	        var classList = win.document.body.classList;
	        if (classList.contains(exports.IsFocusVisibleClassName)) {
	            classList.remove(exports.IsFocusVisibleClassName);
	        }
	    }
	}
	function _onKeyDown(ev) {
	    var win = dom_1.getWindow(ev.target);
	    if (win) {
	        var classList = win.document.body.classList;
	        if (keyboard_1.isDirectionalKeyCode(ev.which) && !classList.contains(exports.IsFocusVisibleClassName)) {
	            classList.add(exports.IsFocusVisibleClassName);
	        }
	    }
	}
	//# sourceMappingURL=initializeFocusRects.js.map

/***/ }),
/* 2341 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DirectionalKeyCodes = (_a = {},
	    _a[38 /* up */] = 1,
	    _a[40 /* down */] = 1,
	    _a[37 /* left */] = 1,
	    _a[39 /* right */] = 1,
	    _a[36 /* home */] = 1,
	    _a[35 /* end */] = 1,
	    _a[9 /* tab */] = 1,
	    _a[33 /* pageUp */] = 1,
	    _a[34 /* pageDown */] = 1,
	    _a);
	/**
	 * Returns true if the keycode is a directional keyboard key.
	 */
	function isDirectionalKeyCode(which) {
	    return !!DirectionalKeyCodes[which];
	}
	exports.isDirectionalKeyCode = isDirectionalKeyCode;
	/**
	 * Adds a keycode to the list of keys that, when pressed, should cause the focus outlines to be visible.
	 * This can be used to add global shortcut keys that directionally move from section to section within
	 * an app or between focus trap zones.
	 */
	function addDirectionalKeyCode(which) {
	    DirectionalKeyCodes[which] = 1;
	}
	exports.addDirectionalKeyCode = addDirectionalKeyCode;
	var _a;
	//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ZIndexes;
	(function (ZIndexes) {
	    ZIndexes.Nav = 1;
	    ZIndexes.ScrollablePane = 1;
	    ZIndexes.FocusStyle = 1;
	    ZIndexes.Coachmark = 1000;
	    ZIndexes.Layer = 1000000;
	    ZIndexes.KeytipLayer = 1000001;
	})(ZIndexes = exports.ZIndexes || (exports.ZIndexes = {}));
	//# sourceMappingURL=zIndexes.js.map

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.hiddenContentStyle = {
	    position: 'absolute',
	    width: 1,
	    height: 1,
	    margin: -1,
	    padding: 0,
	    border: 0,
	    overflow: 'hidden'
	};
	//# sourceMappingURL=hiddenContentStyle.js.map

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var index_1 = __webpack_require__(2312);
	var DEFAULT_DURATION = '14s';
	var DEFAULT_DELAY = '2s';
	var DEFAULT_ITERATION_COUNT = '1';
	function _continuousPulseStepOne(beaconColorOne, innerDimension) {
	    return {
	        borderColor: beaconColorOne,
	        borderWidth: '0px',
	        width: innerDimension,
	        height: innerDimension
	    };
	}
	function _continuousPulseStepTwo(borderWidth) {
	    return {
	        opacity: 1,
	        borderWidth: borderWidth
	    };
	}
	function _continuousPulseStepThree() {
	    return {
	        opacity: 1
	    };
	}
	function _continuousPulseStepFour(beaconColorTwo, outerDimension) {
	    return {
	        borderWidth: '0',
	        width: outerDimension,
	        height: outerDimension,
	        opacity: 0,
	        borderColor: beaconColorTwo
	    };
	}
	function _continuousPulseStepFive(beaconColorOne, innerDimension) {
	    return tslib_1.__assign({}, _continuousPulseStepOne(beaconColorOne, innerDimension), {
	        opacity: 0
	    });
	}
	function _continuousPulseAnimationDouble(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
	    return index_1.keyframes({
	        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '1.42%': _continuousPulseStepTwo(borderWidth),
	        '3.57%': _continuousPulseStepThree(),
	        '7.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '8%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '29.99%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '30%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '31.42%': _continuousPulseStepTwo(borderWidth),
	        '33.57%': _continuousPulseStepThree(),
	        '37.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '38%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '79.42%': _continuousPulseStepFive(beaconColorOne, innerDimension),
	        '79.43': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '81.85': _continuousPulseStepTwo(borderWidth),
	        '83.42': _continuousPulseStepThree(),
	        '87%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '100%': {}
	    });
	}
	function _continuousPulseAnimationSingle(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
	    return index_1.keyframes({
	        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
	        '14.2%': _continuousPulseStepTwo(borderWidth),
	        '35.7%': _continuousPulseStepThree(),
	        '71.4%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
	        '100%': {}
	    });
	}
	function _createDefaultAnimation(animationName) {
	    return {
	        animationName: animationName,
	        animationIterationCount: DEFAULT_ITERATION_COUNT,
	        animationDuration: DEFAULT_DURATION,
	        animationDelay: DEFAULT_DELAY
	    };
	}
	exports.PulsingBeaconAnimationStyles = {
	    continuousPulseAnimationDouble: _continuousPulseAnimationDouble,
	    continuousPulseAnimationSingle: _continuousPulseAnimationSingle,
	    createDefaultAnimation: _createDefaultAnimation,
	};
	//# sourceMappingURL=PulsingBeaconAnimationStyles.js.map

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks for the `disableGlobalClassNames` property on the `theme` to determine if it should return `classNames`
	 *
	 * @param theme The theme to check the flag on
	 * @param classNames The global class names that apply when the flag is false
	 */
	function getGlobalClassNames(classNames, theme) {
	    if (theme.disableGlobalClassNames) {
	        return {};
	    }
	    return classNames;
	}
	exports.getGlobalClassNames = getGlobalClassNames;
	//# sourceMappingURL=getGlobalClassNames.js.map

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var Customizations_1 = __webpack_require__(2347);
	var DefaultFontStyles_1 = __webpack_require__(2333);
	var DefaultPalette_1 = __webpack_require__(2332);
	var load_themed_styles_1 = __webpack_require__(584);
	var _theme = {
	    palette: DefaultPalette_1.DefaultPalette,
	    semanticColors: _makeSemanticColorsFromPalette(DefaultPalette_1.DefaultPalette, false, false),
	    fonts: DefaultFontStyles_1.DefaultFontStyles,
	    isInverted: false,
	    disableGlobalClassNames: false
	};
	var _onThemeChangeCallbacks = [];
	exports.ThemeSettingName = 'theme';
	if (!Customizations_1.Customizations.getSettings([exports.ThemeSettingName]).theme) {
	    var win = typeof window !== 'undefined' ? window : undefined;
	    // tslint:disable:no-string-literal no-any
	    if (win &&
	        win['FabricConfig'] &&
	        win['FabricConfig'].theme) {
	        _theme = createTheme(win['FabricConfig'].theme);
	    }
	    // tslint:enable:no-string-literal no-any
	    // Set the default theme.
	    Customizations_1.Customizations.applySettings((_a = {}, _a[exports.ThemeSettingName] = _theme, _a));
	}
	/**
	 * Gets the theme object
	 * @param {boolean} depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function getTheme(depComments) {
	    if (depComments === void 0) { depComments = false; }
	    if (depComments === true) {
	        _theme = createTheme({}, depComments);
	    }
	    return _theme;
	}
	exports.getTheme = getTheme;
	/**
	 * Registers a callback that gets called whenever the theme changes.
	 * This should only be used when the component cannot automatically get theme changes through its state.
	 * This will not register duplicate callbacks.
	 */
	function registerOnThemeChangeCallback(callback) {
	    if (_onThemeChangeCallbacks.indexOf(callback) === -1) {
	        _onThemeChangeCallbacks.push(callback);
	    }
	}
	exports.registerOnThemeChangeCallback = registerOnThemeChangeCallback;
	/**
	 * See registerOnThemeChangeCallback().
	 * Removes previously registered callbacks.
	 */
	function removeOnThemeChangeCallback(callback) {
	    var i = _onThemeChangeCallbacks.indexOf(callback);
	    if (i === -1) {
	        return;
	    }
	    _onThemeChangeCallbacks.splice(i, 1);
	}
	exports.removeOnThemeChangeCallback = removeOnThemeChangeCallback;
	/**
	 * Applies the theme, while filling in missing slots.
	 * @param {object} theme - Partial theme object.
	 * @param {boolean} depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function loadTheme(theme, depComments) {
	    if (depComments === void 0) { depComments = false; }
	    _theme = createTheme(theme, depComments);
	    // Invoke the legacy method of theming the page as well.
	    load_themed_styles_1.loadTheme(tslib_1.__assign({}, _theme.palette, _theme.semanticColors));
	    Customizations_1.Customizations.applySettings((_a = {}, _a[exports.ThemeSettingName] = _theme, _a));
	    _onThemeChangeCallbacks.forEach(function (callback) {
	        try {
	            callback(_theme);
	        }
	        catch (e) {
	            // don't let a bad callback break everything else
	        }
	    });
	    return _theme;
	    var _a;
	}
	exports.loadTheme = loadTheme;
	/**
	 * Creates a custom theme definition which can be used with the Customizer.
	 * @param {object} theme - Partial theme object.
	 * @param {boolean} depComments - Whether to include deprecated tags as comments for deprecated slots.
	 */
	function createTheme(theme, depComments) {
	    if (depComments === void 0) { depComments = false; }
	    var newPalette = tslib_1.__assign({}, DefaultPalette_1.DefaultPalette, theme.palette);
	    if (!theme.palette || !theme.palette.accent) {
	        newPalette.accent = newPalette.themePrimary;
	    }
	    // mix in custom overrides with good slots first, since custom overrides might be used in fixing deprecated slots
	    var newSemanticColors = tslib_1.__assign({}, _makeSemanticColorsFromPalette(newPalette, !!theme.isInverted, depComments), theme.semanticColors);
	    return {
	        palette: newPalette,
	        fonts: tslib_1.__assign({}, DefaultFontStyles_1.DefaultFontStyles, theme.fonts),
	        semanticColors: newSemanticColors,
	        isInverted: !!theme.isInverted,
	        disableGlobalClassNames: !!theme.disableGlobalClassNames
	    };
	}
	exports.createTheme = createTheme;
	// Generates all the semantic slot colors based on the Fabric palette.
	// We'll use these as fallbacks for semantic slots that the passed in theme did not define.
	function _makeSemanticColorsFromPalette(p, isInverted, depComments) {
	    var toReturn = {
	        bodyBackground: p.white,
	        bodyStandoutBackground: p.neutralLighterAlt,
	        bodyFrameBackground: p.white,
	        bodyFrameDivider: p.neutralLight,
	        bodyText: p.neutralPrimary,
	        bodyTextChecked: p.black,
	        bodySubtext: p.neutralSecondary,
	        bodyDivider: p.neutralLight,
	        disabledBackground: p.neutralLighter,
	        disabledText: p.neutralTertiary,
	        disabledBodyText: p.neutralTertiary,
	        disabledSubtext: p.neutralQuaternary,
	        disabledBodySubtext: p.neutralTertiaryAlt,
	        focusBorder: p.neutralSecondary,
	        variantBorder: p.neutralLight,
	        variantBorderHovered: p.neutralTertiary,
	        defaultStateBackground: p.neutralLighterAlt,
	        errorText: !isInverted ? p.redDark : '#ff5f5f',
	        warningText: !isInverted ? '#333333' : '#ffffff',
	        errorBackground: !isInverted ? 'rgba(232, 17, 35, .2)' : 'rgba(232, 17, 35, .5)',
	        blockingBackground: !isInverted ? 'rgba(234, 67, 0, .2)' : 'rgba(234, 67, 0, .5)',
	        warningBackground: !isInverted ? 'rgba(255, 185, 0, .2)' : 'rgba(255, 251, 0, .6)',
	        warningHighlight: !isInverted ? '#ffb900' : '#fff100',
	        successBackground: !isInverted ? 'rgba(186, 216, 10, .2)' : 'rgba(186, 216, 10, .4)',
	        inputBorder: p.neutralTertiary,
	        inputBorderHovered: p.neutralPrimary,
	        inputBackground: p.white,
	        inputBackgroundChecked: p.themePrimary,
	        inputBackgroundCheckedHovered: p.themeDarkAlt,
	        inputForegroundChecked: p.white,
	        inputFocusBorderAlt: p.themePrimary,
	        smallInputBorder: p.neutralSecondary,
	        inputText: p.neutralPrimary,
	        inputTextHovered: p.neutralDark,
	        inputPlaceholderText: p.neutralSecondary,
	        buttonBackground: p.neutralLighter,
	        buttonBackgroundChecked: p.neutralTertiaryAlt,
	        buttonBackgroundHovered: p.neutralLight,
	        buttonBackgroundCheckedHovered: p.neutralLight,
	        buttonBackgroundPressed: p.neutralLight,
	        buttonBackgroundDisabled: p.neutralLighter,
	        buttonBorder: 'transparent',
	        buttonText: p.neutralPrimary,
	        buttonTextHovered: p.neutralDark,
	        buttonTextChecked: p.neutralDark,
	        buttonTextCheckedHovered: p.black,
	        buttonTextPressed: p.neutralDark,
	        buttonTextDisabled: p.neutralTertiary,
	        buttonBorderDisabled: 'transparent',
	        primaryButtonBackground: p.themePrimary,
	        primaryButtonBackgroundHovered: p.themeDarkAlt,
	        primaryButtonBackgroundPressed: p.themeDark,
	        primaryButtonBackgroundDisabled: p.neutralLighter,
	        primaryButtonBorder: 'transparent',
	        primaryButtonText: p.white,
	        primaryButtonTextHovered: p.white,
	        primaryButtonTextPressed: p.white,
	        primaryButtonTextDisabled: p.neutralQuaternary,
	        accentButtonBackground: p.accent,
	        accentButtonText: p.white,
	        menuBackground: p.white,
	        menuDivider: p.neutralTertiaryAlt,
	        menuIcon: p.themePrimary,
	        menuHeader: p.themePrimary,
	        menuItemBackgroundHovered: p.neutralLighter,
	        menuItemBackgroundPressed: p.neutralLight,
	        menuItemText: p.neutralPrimary,
	        menuItemTextHovered: p.neutralDark,
	        listBackground: p.white,
	        listText: p.neutralPrimary,
	        listItemBackgroundHovered: p.neutralLighter,
	        listItemBackgroundChecked: p.neutralLight,
	        listItemBackgroundCheckedHovered: p.neutralQuaternaryAlt,
	        listHeaderBackgroundHovered: p.neutralLighter,
	        listHeaderBackgroundPressed: p.neutralLight,
	        actionLink: p.neutralPrimary,
	        actionLinkHovered: p.neutralDark,
	        link: p.themePrimary,
	        linkHovered: p.themeDarker,
	        // Deprecated slots, second pass by _fixDeprecatedSlots() later for self-referential slots
	        listTextColor: '',
	        menuItemBackgroundChecked: p.neutralLight
	    };
	    return _fixDeprecatedSlots(toReturn, depComments);
	}
	function _fixDeprecatedSlots(s, depComments) {
	    // Add @deprecated tag as comment if enabled
	    var dep = '';
	    if (depComments === true) {
	        dep = ' /* @deprecated */';
	    }
	    s.listTextColor = s.listText + dep;
	    s.menuItemBackgroundChecked += dep;
	    return s;
	}
	var _a;
	//# sourceMappingURL=theme.js.map

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(458);
	var GlobalSettings_1 = __webpack_require__(2328);
	var EventGroup_1 = __webpack_require__(2348);
	var CustomizationsGlobalKey = 'customizations';
	var NO_CUSTOMIZATIONS = { settings: {}, scopedSettings: {} };
	var _allSettings = GlobalSettings_1.GlobalSettings.getValue(CustomizationsGlobalKey, {
	    settings: {},
	    scopedSettings: {}
	});
	var _events = new EventGroup_1.EventGroup(_allSettings);
	var Customizations = /** @class */ (function () {
	    function Customizations() {
	    }
	    Customizations.reset = function () {
	        _allSettings.settings = {};
	        _allSettings.scopedSettings = {};
	    };
	    // tslint:disable-next-line:no-any
	    Customizations.applySettings = function (settings) {
	        _allSettings.settings = tslib_1.__assign({}, _allSettings.settings, settings);
	        Customizations._raiseChange();
	    };
	    // tslint:disable-next-line:no-any
	    Customizations.applyScopedSettings = function (scopeName, settings) {
	        _allSettings.scopedSettings[scopeName] = tslib_1.__assign({}, _allSettings.scopedSettings[scopeName], settings);
	        Customizations._raiseChange();
	    };
	    Customizations.getSettings = function (properties, scopeName, localSettings
	    // tslint:disable-next-line:no-any
	    ) {
	        if (localSettings === void 0) { localSettings = NO_CUSTOMIZATIONS; }
	        // tslint:disable-next-line:no-any
	        var settings = {};
	        var localScopedSettings = (scopeName && localSettings.scopedSettings[scopeName]) || {};
	        var globalScopedSettings = (scopeName && _allSettings.scopedSettings[scopeName]) || {};
	        for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
	            var property = properties_1[_i];
	            settings[property] = (localScopedSettings[property] ||
	                localSettings.settings[property] ||
	                globalScopedSettings[property] ||
	                _allSettings.settings[property]);
	        }
	        return settings;
	    };
	    Customizations.observe = function (onChange) {
	        _events.on(_allSettings, 'change', onChange);
	    };
	    Customizations.unobserve = function (onChange) {
	        _events.off(_allSettings, 'change', onChange);
	    };
	    Customizations._raiseChange = function () {
	        _events.raise('change');
	    };
	    return Customizations;
	}());
	exports.Customizations = Customizations;
	//# sourceMappingURL=Customizations.js.map

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:no-string-literal */
	var object_1 = __webpack_require__(2349);
	/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
	 *  If the target is an HTMLElement, the event will be attached to the element and can be
	 *  triggered as usual (like clicking for onclick).
	 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
	 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
	 *  handled here in EventGroup, and the handler is called in the context of the parent
	 *  (which is passed in in the constructor).
	 *
	 * @public
	 */
	var EventGroup = /** @class */ (function () {
	    /** parent: the context in which events attached to non-HTMLElements are called */
	    // tslint:disable-next-line:no-any
	    function EventGroup(parent) {
	        this._id = EventGroup._uniqueId++;
	        this._parent = parent;
	        this._eventRecords = [];
	    }
	    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
	     *  Events raised here by default have bubbling set to false and cancelable set to true.
	     *  This applies also to built-in events being raised manually here on HTMLElements,
	     *  which may lead to unexpected behavior if it differs from the defaults.
	     *
	     */
	    EventGroup.raise = function (
	    // tslint:disable-next-line:no-any
	    target, eventName, 
	    // tslint:disable-next-line:no-any
	    eventArgs, bubbleEvent) {
	        var retVal;
	        if (EventGroup._isElement(target)) {
	            if (document.createEvent) {
	                var ev = document.createEvent('HTMLEvents');
	                ev.initEvent(eventName, bubbleEvent || false, true);
	                object_1.assign(ev, eventArgs);
	                retVal = target.dispatchEvent(ev);
	                // tslint:disable-next-line:no-any
	            }
	            else if (document['createEventObject']) { // IE8
	                // tslint:disable-next-line:no-any
	                var evObj = document['createEventObject'](eventArgs);
	                // cannot set cancelBubble on evObj, fireEvent will overwrite it
	                target.fireEvent('on' + eventName, evObj);
	            }
	        }
	        else {
	            while (target && retVal !== false) {
	                var events = target.__events__;
	                var eventRecords = events ? events[eventName] : null;
	                if (eventRecords) {
	                    for (var id in eventRecords) {
	                        if (eventRecords.hasOwnProperty(id)) {
	                            var eventRecordList = eventRecords[id];
	                            for (var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++) {
	                                var record = eventRecordList[listIndex];
	                                if (record.objectCallback) {
	                                    retVal = record.objectCallback.call(record.parent, eventArgs);
	                                }
	                            }
	                        }
	                    }
	                }
	                // If the target has a parent, bubble the event up.
	                target = bubbleEvent ? target.parent : null;
	            }
	        }
	        return retVal;
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.isObserved = function (target, eventName) {
	        var events = target && target.__events__;
	        return !!events && !!events[eventName];
	    };
	    /** Check to see if the target has declared support of the given event. */
	    // tslint:disable-next-line:no-any
	    EventGroup.isDeclared = function (target, eventName) {
	        var declaredEvents = target && target.__declaredEvents;
	        return !!declaredEvents && !!declaredEvents[eventName];
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.stopPropagation = function (event) {
	        if (event.stopPropagation) {
	            event.stopPropagation();
	        }
	        else { // IE8
	            event.cancelBubble = true;
	        }
	    };
	    EventGroup._isElement = function (target) {
	        return (!!target && (!!target.addEventListener ||
	            (typeof HTMLElement !== 'undefined' && target instanceof HTMLElement)));
	    };
	    EventGroup.prototype.dispose = function () {
	        if (!this._isDisposed) {
	            this._isDisposed = true;
	            this.off();
	            this._parent = null;
	        }
	    };
	    /** On the target, attach a set of events, where the events object is a name to function mapping. */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.onAll = function (target, events, useCapture) {
	        for (var eventName in events) {
	            if (events.hasOwnProperty(eventName)) {
	                this.on(target, eventName, events[eventName], useCapture);
	            }
	        }
	    };
	    /** On the target, attach an event whose handler will be called in the context of the parent
	     * of this instance of EventGroup.
	     */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.on = function (target, eventName, callback, useCapture) {
	        var _this = this;
	        if (eventName.indexOf(',') > -1) {
	            var events = eventName.split(/[ ,]+/);
	            for (var i = 0; i < events.length; i++) {
	                this.on(target, events[i], callback, useCapture);
	            }
	        }
	        else {
	            var parent_1 = this._parent;
	            var eventRecord = {
	                target: target,
	                eventName: eventName,
	                parent: parent_1,
	                callback: callback,
	                useCapture: useCapture || false
	            };
	            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
	            var events = (target.__events__ = target.__events__ || {});
	            events[eventName] = events[eventName] || {
	                count: 0
	            };
	            events[eventName][this._id] = events[eventName][this._id] || [];
	            events[eventName][this._id].push(eventRecord);
	            events[eventName].count++;
	            if (EventGroup._isElement(target)) {
	                // tslint:disable-next-line:no-any
	                var processElementEvent = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    if (_this._isDisposed) {
	                        return;
	                    }
	                    var result;
	                    try {
	                        result = callback.apply(parent_1, args);
	                        if (result === false && args[0]) {
	                            var e = args[0];
	                            if (e.preventDefault) {
	                                e.preventDefault();
	                            }
	                            if (e.stopPropagation) {
	                                e.stopPropagation();
	                            }
	                            e.cancelBubble = true;
	                        }
	                    }
	                    catch (e) {
	                        /* ErrorHelper.log(e); */
	                    }
	                    return result;
	                };
	                eventRecord.elementCallback = processElementEvent;
	                if (target.addEventListener) {
	                    /* tslint:disable:ban-native-functions */
	                    target.addEventListener(eventName, processElementEvent, useCapture);
	                    /* tslint:enable:ban-native-functions */
	                }
	                else if (target.attachEvent) { // IE8
	                    target.attachEvent('on' + eventName, processElementEvent);
	                }
	            }
	            else {
	                // tslint:disable-next-line:no-any
	                var processObjectEvent = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    if (_this._isDisposed) {
	                        return;
	                    }
	                    return callback.apply(parent_1, args);
	                };
	                eventRecord.objectCallback = processObjectEvent;
	            }
	            // Remember the record locally, so that it can be removed.
	            this._eventRecords.push(eventRecord);
	        }
	    };
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.off = function (target, eventName, callback, useCapture) {
	        for (var i = 0; i < this._eventRecords.length; i++) {
	            var eventRecord = this._eventRecords[i];
	            if ((!target || target === eventRecord.target) &&
	                (!eventName || eventName === eventRecord.eventName) &&
	                (!callback || callback === eventRecord.callback) &&
	                ((typeof useCapture !== 'boolean') || useCapture === eventRecord.useCapture)) {
	                var events = eventRecord.target.__events__;
	                var targetArrayLookup = events[eventRecord.eventName];
	                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
	                // We may have already target's entries, so check for null.
	                if (targetArray) {
	                    if (targetArray.length === 1 || !callback) {
	                        targetArrayLookup.count -= targetArray.length;
	                        delete events[eventRecord.eventName][this._id];
	                    }
	                    else {
	                        targetArrayLookup.count--;
	                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
	                    }
	                    if (!targetArrayLookup.count) {
	                        delete events[eventRecord.eventName];
	                    }
	                }
	                if (eventRecord.elementCallback) {
	                    if (eventRecord.target.removeEventListener) {
	                        eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.useCapture);
	                    }
	                    else if (eventRecord.target.detachEvent) { // IE8
	                        eventRecord.target.detachEvent('on' + eventRecord.eventName, eventRecord.elementCallback);
	                    }
	                }
	                this._eventRecords.splice(i--, 1);
	            }
	        }
	    };
	    /** Trigger the given event in the context of this instance of EventGroup. */
	    // tslint:disable-next-line:no-any
	    EventGroup.prototype.raise = function (eventName, eventArgs, bubbleEvent) {
	        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
	    };
	    /** Declare an event as being supported by this instance of EventGroup. */
	    EventGroup.prototype.declare = function (event) {
	        var declaredEvents = this._parent.__declaredEvents = this._parent.__declaredEvents || {};
	        if (typeof event === 'string') {
	            declaredEvents[event] = true;
	        }
	        else {
	            for (var i = 0; i < event.length; i++) {
	                declaredEvents[event[i]] = true;
	            }
	        }
	    };
	    // tslint:disable-next-line:no-inferrable-types
	    EventGroup._uniqueId = 0;
	    return EventGroup;
	}());
	exports.EventGroup = EventGroup;
	//# sourceMappingURL=EventGroup.js.map

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Initialize global window id.
	var CURRENT_ID_PROPERTY = '__currentId__';
	var DEFAULT_ID_STRING = 'id__';
	// tslint:disable-next-line:no-any
	var _global = (typeof window !== 'undefined' && window) || process;
	if (_global[CURRENT_ID_PROPERTY] === undefined) {
	    _global[CURRENT_ID_PROPERTY] = 0;
	}
	// tslint:disable-next-line:no-any
	function checkProperties(a, b) {
	    for (var propName in a) {
	        if (a.hasOwnProperty(propName)) {
	            if (!b.hasOwnProperty(propName) || (b[propName] !== a[propName])) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	/**
	 * Compares a to b and b to a.
	 *
	 * @public
	 */
	function shallowCompare(a, b) {
	    return checkProperties(a, b) && checkProperties(b, a);
	}
	exports.shallowCompare = shallowCompare;
	/**
	 * Makes a resulting merge of a bunch of objects. Pass in the target object followed by 1 or more
	 * objects as arguments and they will be merged sequentially into the target. Note that this will
	 * shallow merge; it will not create new cloned values for target members.
	 *
	 * @public
	 * @param target - Target object to merge following object arguments into.
	 * @param args - One or more objects that will be mixed into the target in the order they are provided.
	 * @returns Resulting merged target.
	 */
	// tslint:disable-next-line:no-any
	function assign(target) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    return filteredAssign.apply(this, [null, target].concat(args));
	}
	exports.assign = assign;
	/**
	 * Makes a resulting merge of a bunch of objects, but allows a filter function to be passed in to filter
	 * the resulting merges. This allows for scenarios where you want to merge "everything except that one thing"
	 * or "properties that start with data-". Note that this will shallow merge; it will not create new cloned
	 * values for target members.
	 *
	 * @public
	 * @param isAllowed - Callback to determine if the given propName is allowed in the result.
	 * @param target - Target object to merge following object arguments into.
	 * @param args - One or more objects that will be mixed into the target in the order they are provided.
	 * @returns Resulting merged target.
	 */
	// tslint:disable-next-line:no-any
	function filteredAssign(isAllowed, target) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    target = target || {};
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var sourceObject = args_1[_a];
	        if (sourceObject) {
	            for (var propName in sourceObject) {
	                if (sourceObject.hasOwnProperty(propName) &&
	                    (!isAllowed || isAllowed(propName))) {
	                    target[propName] = sourceObject[propName];
	                }
	            }
	        }
	    }
	    return target;
	}
	exports.filteredAssign = filteredAssign;
	/**
	 * Generates a unique id in the global scope (this spans across duplicate copies of the same library.)
	 *
	 * @public
	 */
	function getId(prefix) {
	    var index = _global[CURRENT_ID_PROPERTY]++;
	    return (prefix || DEFAULT_ID_STRING) + index;
	}
	exports.getId = getId;
	/* Takes an enum and iterates over each value of the enum (as a string), running the callback on each, returning a mapped array.
	 * The callback takes as a first parameter the string that represents the name of the entry, and the second parameter is the
	 * value of that entry, which is the value you'd normally use when using the enum (usually a number).
	 * */
	function mapEnumByName(
	// tslint:disable-next-line:no-any
	theEnum, callback) {
	    // map<any> to satisfy compiler since it doesn't realize we strip out undefineds in the .filter() call
	    return Object.keys(theEnum).map(function (p) {
	        if (String(Number(p)) !== p) { // if the property is not just a number (because enums in TypeScript will map both ways)
	            return callback(p, theEnum[p]);
	        }
	    }).filter(function (v) { return !!v; }); // only return elements with values
	}
	exports.mapEnumByName = mapEnumByName;
	/**
	 * Get all values in an object dictionary
	 *
	 * @param obj - The dictionary to get values for
	 */
	// tslint:disable-next-line:no-any
	function values(obj) {
	    return Object.keys(obj).reduce(function (arr, key) {
	        arr.push(obj[key]);
	        return arr;
	    }, []);
	}
	exports.values = values;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)))

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

	"use strict";
	// This file mimics styles and mixins from _General.Mixins.scss
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.normalize = {
	    boxShadow: 'none',
	    margin: 0,
	    padding: 0,
	    boxSizing: 'border-box'
	};
	exports.noWrap = {
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	};
	//# sourceMappingURL=GeneralStyles.js.map

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2309);
	var index_2 = __webpack_require__(2330);
	exports.FontClassNames = index_1.buildClassMap(index_2.DefaultFontStyles);
	//# sourceMappingURL=FontClassNames.js.map

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2312);
	var DefaultPalette_1 = __webpack_require__(2332);
	var index_2 = __webpack_require__(2330);
	exports.ColorClassNames = {};
	for (var colorName in DefaultPalette_1.DefaultPalette) {
	    if (DefaultPalette_1.DefaultPalette.hasOwnProperty(colorName)) {
	        // Foreground color
	        _defineGetter(exports.ColorClassNames, colorName, '', false, 'color');
	        // Hover color
	        _defineGetter(exports.ColorClassNames, colorName, 'Hover', true, 'color');
	        // Background color
	        _defineGetter(exports.ColorClassNames, colorName, 'Background', false, 'background');
	        // Background hover
	        _defineGetter(exports.ColorClassNames, colorName, 'BackgroundHover', true, 'background');
	        // Border color
	        _defineGetter(exports.ColorClassNames, colorName, 'Border', false, 'borderColor');
	        // Border hover color
	        _defineGetter(exports.ColorClassNames, colorName, 'BorderHover', true, 'borderColor');
	    }
	}
	/**
	 * Defines a getter for the given class configuration.
	 */
	function _defineGetter(obj, colorName, suffix, isHover, cssProperty) {
	    Object.defineProperty(obj, colorName + suffix, {
	        get: function () {
	            // tslint:disable-next-line:no-any
	            var style = (_a = {}, _a[cssProperty] = index_2.getTheme().palette[colorName], _a);
	            return index_1.mergeStyles(isHover ? { selectors: { ':hover': style } } : style).toString();
	            var _a;
	        },
	        enumerable: true,
	        configurable: true
	    });
	}
	//# sourceMappingURL=ColorClassNames.js.map

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-0\"",
	            src: "url('" + baseUrl + "fabric-icons-0-29734c63.woff') format('woff')"
	        },
	        icons: {
	            'DecreaseIndentLegacy': '\uE290',
	            'IncreaseIndentLegacy': '\uE291',
	            'SizeLegacy': '\uE2B2',
	            'InternetSharing': '\uE704',
	            'Brightness': '\uE706',
	            'MapPin': '\uE707',
	            'Airplane': '\uE709',
	            'Tablet': '\uE70A',
	            'QuickNote': '\uE70B',
	            'Video': '\uE714',
	            'People': '\uE716',
	            'Phone': '\uE717',
	            'Pin': '\uE718',
	            'Shop': '\uE719',
	            'Stop': '\uE71A',
	            'Link': '\uE71B',
	            'AllApps': '\uE71D',
	            'Zoom': '\uE71E',
	            'ZoomOut': '\uE71F',
	            'Microphone': '\uE720',
	            'Camera': '\uE722',
	            'Attach': '\uE723',
	            'Send': '\uE724',
	            'FavoriteList': '\uE728',
	            'PageSolid': '\uE729',
	            'Forward': '\uE72A',
	            'Back': '\uE72B',
	            'Refresh': '\uE72C',
	            'Lock': '\uE72E',
	            'ReportHacked': '\uE730',
	            'EMI': '\uE731',
	            'MiniLink': '\uE732',
	            'Blocked': '\uE733',
	            'ReadingMode': '\uE736',
	            'Favicon': '\uE737',
	            'Remove': '\uE738',
	            'Checkbox': '\uE739',
	            'CheckboxComposite': '\uE73A',
	            'CheckboxIndeterminate': '\uE73C',
	            'CheckboxCompositeReversed': '\uE73D',
	            'BackToWindow': '\uE73F',
	            'FullScreen': '\uE740',
	            'Print': '\uE749',
	            'Up': '\uE74A',
	            'Down': '\uE74B',
	            'OEM': '\uE74C',
	            'Save': '\uE74E',
	            'Cloud': '\uE753',
	            'CommandPrompt': '\uE756',
	            'Sad': '\uE757',
	            'SIPMove': '\uE759',
	            'EraseTool': '\uE75C',
	            'GripperTool': '\uE75E',
	            'Dialpad': '\uE75F',
	            'PageLeft': '\uE760',
	            'PageRight': '\uE761',
	            'MultiSelect': '\uE762',
	            'KeyboardClassic': '\uE765',
	            'Play': '\uE768',
	            'Pause': '\uE769',
	            'Emoji2': '\uE76E',
	            'GripperBarHorizontal': '\uE76F',
	            'System': '\uE770',
	            'Personalize': '\uE771',
	            'SearchAndApps': '\uE773',
	            'Globe': '\uE774',
	            'ContactInfo': '\uE779',
	            'Unpin': '\uE77A',
	            'Contact': '\uE77B',
	            'Memo': '\uE77C',
	            'Paste': '\uE77F',
	            'WindowsLogo': '\uE782',
	            'Error': '\uE783',
	            'GripperBarVertical': '\uE784',
	            'Unlock': '\uE785',
	            'AutoEnhanceOn': '\uE78D',
	            'AutoEnhanceOff': '\uE78E',
	            'Color': '\uE790',
	            'SaveAs': '\uE792',
	            'Light': '\uE793',
	            'Filters': '\uE795',
	            'AspectRatio': '\uE799',
	            'Contrast': '\uE7A1',
	            'Redo': '\uE7A6',
	            'Crop': '\uE7A8',
	            'PhotoCollection': '\uE7AA',
	            'Album': '\uE7AB',
	            'Rotate': '\uE7AD',
	            'PanoIndicator': '\uE7B0',
	            'RedEye': '\uE7B3',
	            'ThumbnailView': '\uE7B6',
	            'Package': '\uE7B8',
	            'Warning': '\uE7BA',
	            'Financial': '\uE7BB',
	            'Education': '\uE7BE',
	            'ShoppingCart': '\uE7BF',
	            'Train': '\uE7C0',
	            'Move': '\uE7C2',
	            'TouchPointer': '\uE7C9',
	            'Merge': '\uE7D5'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-0.js.map

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-1\"",
	            src: "url('" + baseUrl + "fabric-icons-1-a653c37c.woff') format('woff')"
	        },
	        icons: {
	            'TurnRight': '\uE7DB',
	            'Ferry': '\uE7E3',
	            'Highlight': '\uE7E6',
	            'PowerButton': '\uE7E8',
	            'Tab': '\uE7E9',
	            'Admin': '\uE7EF',
	            'TVMonitor': '\uE7F4',
	            'Speakers': '\uE7F5',
	            'StackIndicator': '\uE7FF',
	            'Nav2DMapView': '\uE800',
	            'Car': '\uE804',
	            'Bus': '\uE806',
	            'EatDrink': '\uE807',
	            'LocationCircle': '\uE80E',
	            'Home': '\uE80F',
	            'SwitcherStartEnd': '\uE810',
	            'ParkingLocation': '\uE811',
	            'IncidentTriangle': '\uE814',
	            'Touch': '\uE815',
	            'MapDirections': '\uE816',
	            'CaretHollow': '\uE817',
	            'CaretSolid': '\uE818',
	            'History': '\uE81C',
	            'Location': '\uE81D',
	            'Work': '\uE821',
	            'Recent': '\uE823',
	            'Hotel': '\uE824',
	            'LocationDot': '\uE827',
	            'Dictionary': '\uE82D',
	            'ChromeBack': '\uE830',
	            'FolderOpen': '\uE838',
	            'PinnedFill': '\uE842',
	            'RevToggleKey': '\uE845',
	            'Previous': '\uE892',
	            'Next': '\uE893',
	            'Sync': '\uE895',
	            'Help': '\uE897',
	            'Emoji': '\uE899',
	            'MailForward': '\uE89C',
	            'ClosePane': '\uE89F',
	            'OpenPane': '\uE8A0',
	            'PreviewLink': '\uE8A1',
	            'ZoomIn': '\uE8A3',
	            'Bookmarks': '\uE8A4',
	            'Document': '\uE8A5',
	            'ProtectedDocument': '\uE8A6',
	            'OpenInNewWindow': '\uE8A7',
	            'MailFill': '\uE8A8',
	            'ViewAll': '\uE8A9',
	            'Switch': '\uE8AB',
	            'Rename': '\uE8AC',
	            'Remote': '\uE8AF',
	            'SelectAll': '\uE8B3',
	            'Orientation': '\uE8B4',
	            'Import': '\uE8B5',
	            'Picture': '\uE8B9',
	            'ChromeClose': '\uE8BB',
	            'ShowResults': '\uE8BC',
	            'Message': '\uE8BD',
	            'CalendarDay': '\uE8BF',
	            'CalendarWeek': '\uE8C0',
	            'MailReplyAll': '\uE8C2',
	            'Read': '\uE8C3',
	            'Cut': '\uE8C6',
	            'PaymentCard': '\uE8C7',
	            'Copy': '\uE8C8',
	            'Important': '\uE8C9',
	            'MailReply': '\uE8CA',
	            'GotoToday': '\uE8D1',
	            'Font': '\uE8D2',
	            'FontColor': '\uE8D3',
	            'FolderFill': '\uE8D5',
	            'Permissions': '\uE8D7',
	            'DisableUpdates': '\uE8D8',
	            'Unfavorite': '\uE8D9',
	            'Italic': '\uE8DB',
	            'Underline': '\uE8DC',
	            'Bold': '\uE8DD',
	            'MoveToFolder': '\uE8DE',
	            'Dislike': '\uE8E0',
	            'Like': '\uE8E1',
	            'AlignCenter': '\uE8E3',
	            'OpenFile': '\uE8E5',
	            'FontDecrease': '\uE8E7',
	            'FontIncrease': '\uE8E8',
	            'FontSize': '\uE8E9',
	            'CellPhone': '\uE8EA',
	            'Calculator': '\uE8EF',
	            'Library': '\uE8F1',
	            'PostUpdate': '\uE8F3',
	            'NewFolder': '\uE8F4',
	            'CalendarReply': '\uE8F5',
	            'UnsyncFolder': '\uE8F6',
	            'SyncFolder': '\uE8F7',
	            'BlockContact': '\uE8F8',
	            'Accept': '\uE8FB',
	            'BulletedList': '\uE8FD',
	            'Preview': '\uE8FF',
	            'News': '\uE900',
	            'Chat': '\uE901'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-1.js.map

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-2\"",
	            src: "url('" + baseUrl + "fabric-icons-2-b9379dbc.woff') format('woff')"
	        },
	        icons: {
	            'Group': '\uE902',
	            'World': '\uE909',
	            'Comment': '\uE90A',
	            'DockLeft': '\uE90C',
	            'DockRight': '\uE90D',
	            'Repair': '\uE90F',
	            'Accounts': '\uE910',
	            'RadioBullet': '\uE915',
	            'Stopwatch': '\uE916',
	            'Clock': '\uE917',
	            'WorldClock': '\uE918',
	            'AlarmClock': '\uE919',
	            'Photo': '\uE91B',
	            'Hospital': '\uE91D',
	            'Timer': '\uE91E',
	            'FullCircleMask': '\uE91F',
	            'LocationFill': '\uE920',
	            'ChromeMinimize': '\uE921',
	            'Annotation': '\uE924',
	            'Fingerprint': '\uE928',
	            'Handwriting': '\uE929',
	            'Completed': '\uE930',
	            'Label': '\uE932',
	            'FlickDown': '\uE935',
	            'FlickUp': '\uE936',
	            'FlickLeft': '\uE937',
	            'FlickRight': '\uE938',
	            'MiniExpand': '\uE93A',
	            'MiniContract': '\uE93B',
	            'Streaming': '\uE93E',
	            'MusicInCollection': '\uE940',
	            'OneDriveLogo': '\uE941',
	            'CompassNW': '\uE942',
	            'Code': '\uE943',
	            'LightningBolt': '\uE945',
	            'CalculatorMultiply': '\uE947',
	            'CalculatorAddition': '\uE948',
	            'CalculatorSubtract': '\uE949',
	            'CalculatorEqualTo': '\uE94E',
	            'PrintfaxPrinterFile': '\uE956',
	            'Communications': '\uE95A',
	            'Headset': '\uE95B',
	            'Health': '\uE95E',
	            'ChevronUpSmall': '\uE96D',
	            'ChevronDownSmall': '\uE96E',
	            'ChevronLeftSmall': '\uE96F',
	            'ChevronRightSmall': '\uE970',
	            'ChevronUpMed': '\uE971',
	            'ChevronDownMed': '\uE972',
	            'ChevronLeftMed': '\uE973',
	            'ChevronRightMed': '\uE974',
	            'PC1': '\uE977',
	            'PresenceChickletVideo': '\uE979',
	            'Reply': '\uE97A',
	            'HalfAlpha': '\uE97E',
	            'ConstructionCone': '\uE98F',
	            'DoubleChevronLeftMed': '\uE991',
	            'Volume0': '\uE992',
	            'Volume1': '\uE993',
	            'Volume2': '\uE994',
	            'Volume3': '\uE995',
	            'Chart': '\uE999',
	            'Robot': '\uE99A',
	            'Manufacturing': '\uE99C',
	            'LockSolid': '\uE9A2',
	            'BidiLtr': '\uE9AA',
	            'BidiRtl': '\uE9AB',
	            'RightDoubleQuote': '\uE9B1',
	            'Sunny': '\uE9BD',
	            'CloudWeather': '\uE9BE',
	            'Cloudy': '\uE9BF',
	            'PartlyCloudyDay': '\uE9C0',
	            'PartlyCloudyNight': '\uE9C1',
	            'ClearNight': '\uE9C2',
	            'RainShowersDay': '\uE9C3',
	            'Rain': '\uE9C4',
	            'Thunderstorms': '\uE9C6',
	            'RainSnow': '\uE9C7',
	            'Snow': '\uE9C8',
	            'BlowingSnow': '\uE9C9',
	            'Frigid': '\uE9CA',
	            'Fog': '\uE9CB',
	            'Squalls': '\uE9CC',
	            'Duststorm': '\uE9CD',
	            'Unknown': '\uE9CE',
	            'Precipitation': '\uE9CF',
	            'Ribbon': '\uE9D1',
	            'AreaChart': '\uE9D2',
	            'Assign': '\uE9D3',
	            'CheckList': '\uE9D5',
	            'Diagnostic': '\uE9D9',
	            'Generate': '\uE9DA',
	            'LineChart': '\uE9E6',
	            'Equalizer': '\uE9E9',
	            'BarChartHorizontal': '\uE9EB',
	            'BarChartVertical': '\uE9EC',
	            'Freezing': '\uE9EF',
	            'Processing': '\uE9F5',
	            'SnowShowerDay': '\uE9FD',
	            'HailDay': '\uEA00'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-2.js.map

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-3\"",
	            src: "url('" + baseUrl + "fabric-icons-3-ef2110da.woff') format('woff')"
	        },
	        icons: {
	            'WorkFlow': '\uEA01',
	            'HourGlass': '\uEA03',
	            'StoreLogoMed20': '\uEA04',
	            'TimeSheet': '\uEA05',
	            'TriangleSolid': '\uEA08',
	            'VideoSolid': '\uEA0C',
	            'RainShowersNight': '\uEA0F',
	            'SnowShowerNight': '\uEA11',
	            'Teamwork': '\uEA12',
	            'HailNight': '\uEA13',
	            'PeopleAdd': '\uEA15',
	            'Glasses': '\uEA16',
	            'DateTime2': '\uEA17',
	            'Shield': '\uEA18',
	            'Header1': '\uEA19',
	            'PageAdd': '\uEA1A',
	            'NumberedList': '\uEA1C',
	            'PowerBILogo': '\uEA1E',
	            'Info2': '\uEA1F',
	            'MusicInCollectionFill': '\uEA36',
	            'Asterisk': '\uEA38',
	            'ErrorBadge': '\uEA39',
	            'CircleFill': '\uEA3B',
	            'Record2': '\uEA3F',
	            'AllAppsMirrored': '\uEA40',
	            'BookmarksMirrored': '\uEA41',
	            'BulletedListMirrored': '\uEA42',
	            'CaretHollowMirrored': '\uEA45',
	            'CaretSolidMirrored': '\uEA46',
	            'ChromeBackMirrored': '\uEA47',
	            'ClosePaneMirrored': '\uEA49',
	            'DockLeftMirrored': '\uEA4C',
	            'DoubleChevronLeftMedMirrored': '\uEA4D',
	            'HelpMirrored': '\uEA51',
	            'ImportMirrored': '\uEA52',
	            'ListMirrored': '\uEA55',
	            'MailForwardMirrored': '\uEA56',
	            'MailReplyMirrored': '\uEA57',
	            'MailReplyAllMirrored': '\uEA58',
	            'OpenPaneMirrored': '\uEA5B',
	            'ParkingLocationMirrored': '\uEA5E',
	            'SendMirrored': '\uEA63',
	            'ShowResultsMirrored': '\uEA65',
	            'ThumbnailViewMirrored': '\uEA67',
	            'Devices3': '\uEA6C',
	            'Lightbulb': '\uEA80',
	            'StatusTriangle': '\uEA82',
	            'VolumeDisabled': '\uEA85',
	            'Puzzle': '\uEA86',
	            'EmojiNeutral': '\uEA87',
	            'EmojiDisappointed': '\uEA88',
	            'HomeSolid': '\uEA8A',
	            'Ringer': '\uEA8F',
	            'PDF': '\uEA90',
	            'HeartBroken': '\uEA92',
	            'StoreLogo16': '\uEA96',
	            'MultiSelectMirrored': '\uEA98',
	            'Broom': '\uEA99',
	            'Cocktails': '\uEA9D',
	            'Wines': '\uEABF',
	            'Articles': '\uEAC1',
	            'Cycling': '\uEAC7',
	            'DietPlanNotebook': '\uEAC8',
	            'Pill': '\uEACB',
	            'ExerciseTracker': '\uEACC',
	            'HandsFree': '\uEAD0',
	            'Medical': '\uEAD4',
	            'Running': '\uEADA',
	            'Weights': '\uEADB',
	            'Trackers': '\uEADF',
	            'AddNotes': '\uEAE3',
	            'AllCurrency': '\uEAE4',
	            'BarChart4': '\uEAE7',
	            'CirclePlus': '\uEAEE',
	            'Coffee': '\uEAEF',
	            'Cotton': '\uEAF3',
	            'Market': '\uEAFC',
	            'Money': '\uEAFD',
	            'PieDouble': '\uEB04',
	            'PieSingle': '\uEB05',
	            'RemoveFilter': '\uEB08',
	            'Savings': '\uEB0B',
	            'Sell': '\uEB0C',
	            'StockDown': '\uEB0F',
	            'StockUp': '\uEB11',
	            'Lamp': '\uEB19',
	            'Source': '\uEB1B',
	            'MSNVideos': '\uEB1C',
	            'Cricket': '\uEB1E',
	            'Golf': '\uEB1F',
	            'Baseball': '\uEB20',
	            'Soccer': '\uEB21',
	            'MoreSports': '\uEB22',
	            'AutoRacing': '\uEB24',
	            'CollegeHoops': '\uEB25',
	            'CollegeFootball': '\uEB26',
	            'ProFootball': '\uEB27',
	            'ProHockey': '\uEB28',
	            'Rugby': '\uEB2D',
	            'SubstitutionsIn': '\uEB31'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-3.js.map

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-4\"",
	            src: "url('" + baseUrl + "fabric-icons-4-aeecd474.woff') format('woff')"
	        },
	        icons: {
	            'Tennis': '\uEB33',
	            'Arrivals': '\uEB34',
	            'Design': '\uEB3C',
	            'Website': '\uEB41',
	            'Drop': '\uEB42',
	            'SkiResorts': '\uEB45',
	            'Snowflake': '\uEB46',
	            'BusSolid': '\uEB47',
	            'FerrySolid': '\uEB48',
	            'AirplaneSolid': '\uEB4C',
	            'TrainSolid': '\uEB4D',
	            'Ticket': '\uEB54',
	            'Devices4': '\uEB66',
	            'AzureLogo': '\uEB6A',
	            'BingLogo': '\uEB6B',
	            'MSNLogo': '\uEB6C',
	            'OutlookLogoInverse': '\uEB6D',
	            'OfficeLogo': '\uEB6E',
	            'SkypeLogo': '\uEB6F',
	            'Door': '\uEB75',
	            'EditMirrored': '\uEB7E',
	            'GiftCard': '\uEB8E',
	            'DoubleBookmark': '\uEB8F',
	            'StatusErrorFull': '\uEB90',
	            'Certificate': '\uEB95',
	            'FastForward': '\uEB9D',
	            'Rewind': '\uEB9E',
	            'Photo2': '\uEB9F',
	            'OpenSource': '\uEBC2',
	            'Movers': '\uEBCD',
	            'CloudDownload': '\uEBD3',
	            'Family': '\uEBDA',
	            'WindDirection': '\uEBE6',
	            'Bug': '\uEBE8',
	            'SiteScan': '\uEBEC',
	            'BrowserScreenShot': '\uEBED',
	            'F12DevTools': '\uEBEE',
	            'CSS': '\uEBEF',
	            'JS': '\uEBF0',
	            'DeliveryTruck': '\uEBF4',
	            'ReminderPerson': '\uEBF7',
	            'ReminderGroup': '\uEBF8',
	            'TabletMode': '\uEBFC',
	            'Umbrella': '\uEC04',
	            'NetworkTower': '\uEC05',
	            'CityNext': '\uEC06',
	            'Section': '\uEC0C',
	            'OneNoteLogoInverse': '\uEC0D',
	            'ToggleFilled': '\uEC11',
	            'ToggleBorder': '\uEC12',
	            'SliderThumb': '\uEC13',
	            'ToggleThumb': '\uEC14',
	            'Documentation': '\uEC17',
	            'Badge': '\uEC1B',
	            'Giftbox': '\uEC1F',
	            'VisualStudioLogo': '\uEC22',
	            'ExcelLogoInverse': '\uEC28',
	            'WordLogoInverse': '\uEC29',
	            'PowerPointLogoInverse': '\uEC2A',
	            'Cafe': '\uEC32',
	            'SpeedHigh': '\uEC4A',
	            'Commitments': '\uEC4D',
	            'ThisPC': '\uEC4E',
	            'MusicNote': '\uEC4F',
	            'MicOff': '\uEC54',
	            'EdgeLogo': '\uEC60',
	            'CompletedSolid': '\uEC61',
	            'AlbumRemove': '\uEC62',
	            'MessageFill': '\uEC70',
	            'TabletSelected': '\uEC74',
	            'MobileSelected': '\uEC75',
	            'LaptopSelected': '\uEC76',
	            'TVMonitorSelected': '\uEC77',
	            'DeveloperTools': '\uEC7A',
	            'InsertTextBox': '\uEC7D',
	            'LowerBrightness': '\uEC8A',
	            'DOM': '\uEC8D',
	            'CloudUpload': '\uEC8E',
	            'ScrollUpDown': '\uEC8F',
	            'DateTime': '\uEC92',
	            'Event': '\uECA3',
	            'Cake': '\uECA4',
	            'Org': '\uECA6',
	            'PartyLeader': '\uECA7',
	            'DRM': '\uECA8',
	            'CloudAdd': '\uECA9',
	            'AppIconDefault': '\uECAA',
	            'Photo2Add': '\uECAB',
	            'Photo2Remove': '\uECAC',
	            'POI': '\uECAF',
	            'AddTo': '\uECC8',
	            'RadioBtnOff': '\uECCA',
	            'RadioBtnOn': '\uECCB',
	            'ExploreContent': '\uECCD',
	            'Product': '\uECDC',
	            'ProgressLoopInner': '\uECDE',
	            'ProgressLoopOuter': '\uECDF',
	            'Blocked2': '\uECE4',
	            'FangBody': '\uECEB',
	            'ChatInviteFriend': '\uECFE'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-4.js.map

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-5\"",
	            src: "url('" + baseUrl + "fabric-icons-5-f6547654.woff') format('woff')"
	        },
	        icons: {
	            'Crown': '\uED01',
	            'Diamond': '\uED02',
	            'ScaleUp': '\uED09',
	            'Feedback': '\uED15',
	            'SharepointLogoInverse': '\uED18',
	            'YammerLogo': '\uED19',
	            'Hide': '\uED1A',
	            'Uneditable': '\uED1D',
	            'ReturnToSession': '\uED24',
	            'OpenFolderHorizontal': '\uED25',
	            'CalendarMirrored': '\uED28',
	            'SwayLogoInverse': '\uED29',
	            'OutOfOffice': '\uED34',
	            'Trophy': '\uED3F',
	            'ReopenPages': '\uED50',
	            'EmojiTabSymbols': '\uED58',
	            'AADLogo': '\uED68',
	            'AccessLogo': '\uED69',
	            'AdminALogoInverse32': '\uED6A',
	            'AdminCLogoInverse32': '\uED6B',
	            'AdminDLogoInverse32': '\uED6C',
	            'AdminELogoInverse32': '\uED6D',
	            'AdminLLogoInverse32': '\uED6E',
	            'AdminMLogoInverse32': '\uED6F',
	            'AdminOLogoInverse32': '\uED70',
	            'AdminPLogoInverse32': '\uED71',
	            'AdminSLogoInverse32': '\uED72',
	            'AdminYLogoInverse32': '\uED73',
	            'DelveLogoInverse': '\uED76',
	            'ExchangeLogoInverse': '\uED78',
	            'LyncLogo': '\uED79',
	            'OfficeVideoLogoInverse': '\uED7A',
	            'SocialListeningLogo': '\uED7C',
	            'VisioLogoInverse': '\uED7D',
	            'Balloons': '\uED7E',
	            'Cat': '\uED7F',
	            'MailAlert': '\uED80',
	            'MailCheck': '\uED81',
	            'MailLowImportance': '\uED82',
	            'MailPause': '\uED83',
	            'MailRepeat': '\uED84',
	            'SecurityGroup': '\uED85',
	            'Table': '\uED86',
	            'VoicemailForward': '\uED87',
	            'VoicemailReply': '\uED88',
	            'Waffle': '\uED89',
	            'RemoveEvent': '\uED8A',
	            'EventInfo': '\uED8B',
	            'ForwardEvent': '\uED8C',
	            'WipePhone': '\uED8D',
	            'AddOnlineMeeting': '\uED8E',
	            'JoinOnlineMeeting': '\uED8F',
	            'RemoveLink': '\uED90',
	            'PeopleBlock': '\uED91',
	            'PeopleRepeat': '\uED92',
	            'PeopleAlert': '\uED93',
	            'PeoplePause': '\uED94',
	            'TransferCall': '\uED95',
	            'AddPhone': '\uED96',
	            'UnknownCall': '\uED97',
	            'NoteReply': '\uED98',
	            'NoteForward': '\uED99',
	            'NotePinned': '\uED9A',
	            'RemoveOccurrence': '\uED9B',
	            'Timeline': '\uED9C',
	            'EditNote': '\uED9D',
	            'CircleHalfFull': '\uED9E',
	            'Room': '\uED9F',
	            'Unsubscribe': '\uEDA0',
	            'Subscribe': '\uEDA1',
	            'HardDrive': '\uEDA2',
	            'RecurringTask': '\uEDB2',
	            'TaskManager': '\uEDB7',
	            'TaskManagerMirrored': '\uEDB8',
	            'Combine': '\uEDBB',
	            'Split': '\uEDBC',
	            'DoubleChevronUp': '\uEDBD',
	            'DoubleChevronLeft': '\uEDBE',
	            'DoubleChevronRight': '\uEDBF',
	            'TextBox': '\uEDC2',
	            'TextField': '\uEDC3',
	            'NumberField': '\uEDC4',
	            'Dropdown': '\uEDC5',
	            'BookingsLogo': '\uEDC7',
	            'ClassNotebookLogoInverse': '\uEDC8',
	            'DelveAnalyticsLogo': '\uEDCA',
	            'DocsLogoInverse': '\uEDCB',
	            'Dynamics365Logo': '\uEDCC',
	            'DynamicSMBLogo': '\uEDCD',
	            'OfficeAssistantLogo': '\uEDCE',
	            'OfficeStoreLogo': '\uEDCF',
	            'OneNoteEduLogoInverse': '\uEDD0',
	            'PlannerLogo': '\uEDD1',
	            'PowerApps': '\uEDD2',
	            'Suitcase': '\uEDD3',
	            'ProjectLogoInverse': '\uEDD4',
	            'CaretLeft8': '\uEDD5',
	            'CaretRight8': '\uEDD6',
	            'CaretUp8': '\uEDD7',
	            'CaretDown8': '\uEDD8'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-5.js.map

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-6\"",
	            src: "url('" + baseUrl + "fabric-icons-6-3954c770.woff') format('woff')"
	        },
	        icons: {
	            'CaretLeftSolid8': '\uEDD9',
	            'CaretRightSolid8': '\uEDDA',
	            'CaretUpSolid8': '\uEDDB',
	            'CaretDownSolid8': '\uEDDC',
	            'ClearFormatting': '\uEDDD',
	            'Superscript': '\uEDDE',
	            'Subscript': '\uEDDF',
	            'Strikethrough': '\uEDE0',
	            'Export': '\uEDE1',
	            'ExportMirrored': '\uEDE2',
	            'SingleBookmark': '\uEDFF',
	            'SingleBookmarkSolid': '\uEE00',
	            'DoubleChevronDown': '\uEE04',
	            'FollowUser': '\uEE05',
	            'ReplyAll': '\uEE0A',
	            'WorkforceManagement': '\uEE0F',
	            'RecruitmentManagement': '\uEE12',
	            'Questionnaire': '\uEE19',
	            'ManagerSelfService': '\uEE23',
	            'ReplyMirrored': '\uEE35',
	            'ReplyAllMirrored': '\uEE36',
	            'Medal': '\uEE38',
	            'AddGroup': '\uEE3D',
	            'QuestionnaireMirrored': '\uEE4B',
	            'TemporaryUser': '\uEE58',
	            'CaretSolid16': '\uEE62',
	            'GroupedDescending': '\uEE66',
	            'GroupedAscending': '\uEE67',
	            'AwayStatus': '\uEE6A',
	            'MyMoviesTV': '\uEE6C',
	            'GenericScan': '\uEE6F',
	            'AustralianRules': '\uEE70',
	            'WifiEthernet': '\uEE77',
	            'TrackersMirrored': '\uEE92',
	            'DateTimeMirrored': '\uEE93',
	            'StopSolid': '\uEE95',
	            'DoubleChevronUp12': '\uEE96',
	            'DoubleChevronDown12': '\uEE97',
	            'DoubleChevronLeft12': '\uEE98',
	            'DoubleChevronRight12': '\uEE99',
	            'CalendarAgenda': '\uEE9A',
	            'AddEvent': '\uEEB5',
	            'AssetLibrary': '\uEEB6',
	            'DataConnectionLibrary': '\uEEB7',
	            'DocLibrary': '\uEEB8',
	            'FormLibrary': '\uEEB9',
	            'FormLibraryMirrored': '\uEEBA',
	            'ReportLibrary': '\uEEBB',
	            'ReportLibraryMirrored': '\uEEBC',
	            'ContactCard': '\uEEBD',
	            'CustomList': '\uEEBE',
	            'CustomListMirrored': '\uEEBF',
	            'IssueTracking': '\uEEC0',
	            'IssueTrackingMirrored': '\uEEC1',
	            'PictureLibrary': '\uEEC2',
	            'OfficeAddinsLogo': '\uEEC7',
	            'OfflineOneDriveParachute': '\uEEC8',
	            'OfflineOneDriveParachuteDisabled': '\uEEC9',
	            'TriangleSolidUp12': '\uEECC',
	            'TriangleSolidDown12': '\uEECD',
	            'TriangleSolidLeft12': '\uEECE',
	            'TriangleSolidRight12': '\uEECF',
	            'TriangleUp12': '\uEED0',
	            'TriangleDown12': '\uEED1',
	            'TriangleLeft12': '\uEED2',
	            'TriangleRight12': '\uEED3',
	            'ArrowUpRight8': '\uEED4',
	            'ArrowDownRight8': '\uEED5',
	            'DocumentSet': '\uEED6',
	            'DelveAnalytics': '\uEEEE',
	            'ArrowUpRightMirrored8': '\uEEEF',
	            'ArrowDownRightMirrored8': '\uEEF0',
	            'CompanyDirectory': '\uEF0D',
	            'CompanyDirectoryMirrored': '\uEF2B',
	            'OneDriveAdd': '\uEF32',
	            'ProfileSearch': '\uEF35',
	            'Header2': '\uEF36',
	            'Header3': '\uEF37',
	            'Header4': '\uEF38',
	            'Eyedropper': '\uEF3C',
	            'MarketDown': '\uEF42',
	            'CalendarWorkWeek': '\uEF51',
	            'SidePanel': '\uEF52',
	            'GlobeFavorite': '\uEF53',
	            'CaretTopLeftSolid8': '\uEF54',
	            'CaretTopRightSolid8': '\uEF55',
	            'ViewAll2': '\uEF56',
	            'DocumentReply': '\uEF57',
	            'PlayerSettings': '\uEF58',
	            'ReceiptForward': '\uEF59',
	            'ReceiptReply': '\uEF5A',
	            'ReceiptCheck': '\uEF5B',
	            'Fax': '\uEF5C',
	            'RecurringEvent': '\uEF5D',
	            'ReplyAlt': '\uEF5E',
	            'ReplyAllAlt': '\uEF5F',
	            'EditStyle': '\uEF60',
	            'EditMail': '\uEF61',
	            'Lifesaver': '\uEF62',
	            'LifesaverLock': '\uEF63'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-6.js.map

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-7\"",
	            src: "url('" + baseUrl + "fabric-icons-7-02107cf8.woff') format('woff')"
	        },
	        icons: {
	            'InboxCheck': '\uEF64',
	            'FolderSearch': '\uEF65',
	            'CollapseMenu': '\uEF66',
	            'ExpandMenu': '\uEF67',
	            'Boards': '\uEF68',
	            'SunAdd': '\uEF69',
	            'SunQuestionMark': '\uEF6A',
	            'LandscapeOrientation': '\uEF6B',
	            'DocumentSearch': '\uEF6C',
	            'PublicCalendar': '\uEF6D',
	            'PublicContactCard': '\uEF6E',
	            'PublicEmail': '\uEF6F',
	            'PublicFolder': '\uEF70',
	            'WordDocument': '\uEF71',
	            'PowerPointDocument': '\uEF72',
	            'ExcelDocument': '\uEF73',
	            'GroupedList': '\uEF74',
	            'ClassroomLogo': '\uEF75',
	            'Sections': '\uEF76',
	            'EditPhoto': '\uEF77',
	            'Starburst': '\uEF78',
	            'ShareiOS': '\uEF79',
	            'AirTickets': '\uEF7A',
	            'PencilReply': '\uEF7B',
	            'Tiles2': '\uEF7C',
	            'SkypeCircleCheck': '\uEF7D',
	            'SkypeCircleClock': '\uEF7E',
	            'SkypeCircleMinus': '\uEF7F',
	            'SkypeMessage': '\uEF83',
	            'ClosedCaption': '\uEF84',
	            'ATPLogo': '\uEF85',
	            'OfficeFormsLogoInverse': '\uEF86',
	            'RecycleBin': '\uEF87',
	            'EmptyRecycleBin': '\uEF88',
	            'Hide2': '\uEF89',
	            'Breadcrumb': '\uEF8C',
	            'BirthdayCake': '\uEF8D',
	            'TimeEntry': '\uEF95',
	            'PageEdit': '\uEFB6',
	            'PageRemove': '\uEFBA',
	            'Database': '\uEFC7',
	            'EditContact': '\uEFD3',
	            'ConnectContacts': '\uEFD4',
	            'ActivateOrders': '\uEFE0',
	            'DeactivateOrders': '\uEFE1',
	            'DocumentManagement': '\uEFFC',
	            'CRMReport': '\uEFFE',
	            'ZipFolder': '\uF012',
	            'SurveyQuestions': '\uF01B',
	            'TextDocument': '\uF029',
	            'TextDocumentShared': '\uF02B',
	            'PageCheckedOut': '\uF02C',
	            'SaveAndClose': '\uF038',
	            'Script': '\uF03A',
	            'Archive': '\uF03F',
	            'ActivityFeed': '\uF056',
	            'EventDate': '\uF059',
	            'ArrowUpRight': '\uF069',
	            'CaretRight': '\uF06B',
	            'SetAction': '\uF071',
	            'CaretSolidLeft': '\uF08D',
	            'CaretSolidDown': '\uF08E',
	            'CaretSolidRight': '\uF08F',
	            'CaretSolidUp': '\uF090',
	            'PowerAppsLogo': '\uF091',
	            'PowerApps2Logo': '\uF092',
	            'SearchIssue': '\uF09A',
	            'SearchIssueMirrored': '\uF09B',
	            'FabricAssetLibrary': '\uF09C',
	            'FabricDataConnectionLibrary': '\uF09D',
	            'FabricDocLibrary': '\uF09E',
	            'FabricFormLibrary': '\uF09F',
	            'FabricFormLibraryMirrored': '\uF0A0',
	            'FabricReportLibrary': '\uF0A1',
	            'FabricReportLibraryMirrored': '\uF0A2',
	            'FabricPublicFolder': '\uF0A3',
	            'FabricFolderSearch': '\uF0A4',
	            'FabricMovetoFolder': '\uF0A5',
	            'FabricUnsyncFolder': '\uF0A6',
	            'FabricSyncFolder': '\uF0A7',
	            'FabricOpenFolderHorizontal': '\uF0A8',
	            'FabricFolder': '\uF0A9',
	            'FabricFolderFill': '\uF0AA',
	            'FabricNewFolder': '\uF0AB',
	            'FabricPictureLibrary': '\uF0AC',
	            'AddFavorite': '\uF0C8',
	            'AddFavoriteFill': '\uF0C9',
	            'BufferTimeBefore': '\uF0CF',
	            'BufferTimeAfter': '\uF0D0',
	            'BufferTimeBoth': '\uF0D1',
	            'CannedChat': '\uF0F2',
	            'SkypeForBusinessLogo': '\uF0FC',
	            'PageCheckedin': '\uF104',
	            'ReadOutLoud': '\uF112',
	            'CaretBottomLeftSolid8': '\uF121',
	            'CaretBottomRightSolid8': '\uF122',
	            'FolderHorizontal': '\uF12B',
	            'MicrosoftStaffhubLogo': '\uF130',
	            'GiftboxOpen': '\uF133',
	            'StatusCircleOuter': '\uF136'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-7.js.map

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-8\"",
	            src: "url('" + baseUrl + "fabric-icons-8-645fa64e.woff') format('woff')"
	        },
	        icons: {
	            'StatusCircleInner': '\uF137',
	            'StatusCircleRing': '\uF138',
	            'StatusTriangleOuter': '\uF139',
	            'StatusTriangleInner': '\uF13A',
	            'StatusTriangleExclamation': '\uF13B',
	            'StatusCircleExclamation': '\uF13C',
	            'StatusCircleErrorX': '\uF13D',
	            'StatusCircleInfo': '\uF13F',
	            'StatusCircleBlock2': '\uF141',
	            'StatusCircleQuestionMark': '\uF142',
	            'Toll': '\uF160',
	            'ExploreContentSingle': '\uF164',
	            'CollapseContent': '\uF165',
	            'CollapseContentSingle': '\uF166',
	            'InfoSolid': '\uF167',
	            'ProgressRingDots': '\uF16A',
	            'CaloriesAdd': '\uF172',
	            'BranchFork': '\uF173',
	            'MobileReport': '\uF18A',
	            'HardDriveGroup': '\uF18F',
	            'FastMode': '\uF19A',
	            'ToggleOn': '\uF19E',
	            'ToggleOff': '\uF19F',
	            'Trophy2': '\uF1AE',
	            'BucketColor': '\uF1B6',
	            'BucketColorFill': '\uF1B7',
	            'Taskboard': '\uF1C2',
	            'SingleColumn': '\uF1D3',
	            'DoubleColumn': '\uF1D4',
	            'TripleColumn': '\uF1D5',
	            'ColumnLeftTwoThirds': '\uF1D6',
	            'ColumnRightTwoThirds': '\uF1D7',
	            'AccessLogoFill': '\uF1DB',
	            'AnalyticsLogo': '\uF1DE',
	            'AnalyticsQuery': '\uF1DF',
	            'NewAnalyticsQuery': '\uF1E0',
	            'AnalyticsReport': '\uF1E1',
	            'WordLogo': '\uF1E3',
	            'WordLogoFill': '\uF1E4',
	            'ExcelLogo': '\uF1E5',
	            'ExcelLogoFill': '\uF1E6',
	            'OneNoteLogo': '\uF1E7',
	            'OneNoteLogoFill': '\uF1E8',
	            'OutlookLogo': '\uF1E9',
	            'OutlookLogoFill': '\uF1EA',
	            'PowerPointLogo': '\uF1EB',
	            'PowerPointLogoFill': '\uF1EC',
	            'PublisherLogo': '\uF1ED',
	            'PublisherLogoFill': '\uF1EE',
	            'ScheduleEventAction': '\uF1EF',
	            'FlameSolid': '\uF1F3',
	            'ServerProcesses': '\uF1FE',
	            'Server': '\uF201',
	            'SaveAll': '\uF203',
	            'LinkedInLogo': '\uF20A',
	            'Decimals': '\uF218',
	            'SidePanelMirrored': '\uF221',
	            'ProtectRestrict': '\uF22A',
	            'UnknownMirrored': '\uF22E',
	            'PublicContactCardMirrored': '\uF230',
	            'GridViewSmall': '\uF232',
	            'GridViewMedium': '\uF233',
	            'GridViewLarge': '\uF234',
	            'Step': '\uF241',
	            'StepInsert': '\uF242',
	            'StepShared': '\uF243',
	            'StepSharedAdd': '\uF244',
	            'StepSharedInsert': '\uF245',
	            'ViewDashboard': '\uF246',
	            'ViewList': '\uF247',
	            'ViewListGroup': '\uF248',
	            'ViewListTree': '\uF249',
	            'TriggerAuto': '\uF24A',
	            'TriggerUser': '\uF24B',
	            'PivotChart': '\uF24C',
	            'StackedBarChart': '\uF24D',
	            'StackedLineChart': '\uF24E',
	            'BuildQueue': '\uF24F',
	            'BuildQueueNew': '\uF250',
	            'UserFollowed': '\uF25C',
	            'ContactLink': '\uF25F',
	            'Stack': '\uF26F',
	            'Bullseye': '\uF272',
	            'VennDiagram': '\uF273',
	            'FiveTileGrid': '\uF274',
	            'FocalPoint': '\uF277',
	            'RingerRemove': '\uF279',
	            'TeamsLogoInverse': '\uF27A',
	            'TeamsLogo': '\uF27B',
	            'TeamsLogoFill': '\uF27C',
	            'SkypeForBusinessLogoFill': '\uF27D',
	            'SharepointLogo': '\uF27E',
	            'SharepointLogoFill': '\uF27F',
	            'DelveLogo': '\uF280',
	            'DelveLogoFill': '\uF281',
	            'OfficeVideoLogo': '\uF282',
	            'OfficeVideoLogoFill': '\uF283',
	            'ExchangeLogo': '\uF284',
	            'ExchangeLogoFill': '\uF285',
	            'DocumentApproval': '\uF28B'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-8.js.map

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-9\"",
	            src: "url('" + baseUrl + "fabric-icons-9-53746c82.woff') format('woff')"
	        },
	        icons: {
	            'CloneToDesktop': '\uF28C',
	            'InstallToDrive': '\uF28D',
	            'Blur': '\uF28E',
	            'Build': '\uF28F',
	            'ProcessMetaTask': '\uF290',
	            'BranchFork2': '\uF291',
	            'BranchLocked': '\uF292',
	            'BranchCommit': '\uF293',
	            'BranchCompare': '\uF294',
	            'BranchMerge': '\uF295',
	            'BranchPullRequest': '\uF296',
	            'BranchSearch': '\uF297',
	            'BranchShelveset': '\uF298',
	            'RawSource': '\uF299',
	            'MergeDuplicate': '\uF29A',
	            'RowsGroup': '\uF29B',
	            'RowsChild': '\uF29C',
	            'Deploy': '\uF29D',
	            'Redeploy': '\uF29E',
	            'ServerEnviroment': '\uF29F',
	            'VisioDiagram': '\uF2A0',
	            'HighlightMappedShapes': '\uF2A1',
	            'TextCallout': '\uF2A2',
	            'IconSetsFlag': '\uF2A4',
	            'VisioLogo': '\uF2A7',
	            'VisioLogoFill': '\uF2A8',
	            'VisioDocument': '\uF2A9',
	            'TimelineProgress': '\uF2AA',
	            'TimelineDelivery': '\uF2AB',
	            'Backlog': '\uF2AC',
	            'TeamFavorite': '\uF2AD',
	            'TaskGroup': '\uF2AE',
	            'TaskGroupMirrored': '\uF2AF',
	            'ScopeTemplate': '\uF2B0',
	            'AssessmentGroupTemplate': '\uF2B1',
	            'NewTeamProject': '\uF2B2',
	            'CommentAdd': '\uF2B3',
	            'CommentNext': '\uF2B4',
	            'CommentPrevious': '\uF2B5',
	            'ShopServer': '\uF2B6',
	            'LocaleLanguage': '\uF2B7',
	            'QueryList': '\uF2B8',
	            'UserSync': '\uF2B9',
	            'UserPause': '\uF2BA',
	            'StreamingOff': '\uF2BB',
	            'ArrowTallUpLeft': '\uF2BD',
	            'ArrowTallUpRight': '\uF2BE',
	            'ArrowTallDownLeft': '\uF2BF',
	            'ArrowTallDownRight': '\uF2C0',
	            'FieldEmpty': '\uF2C1',
	            'FieldFilled': '\uF2C2',
	            'FieldChanged': '\uF2C3',
	            'FieldNotChanged': '\uF2C4',
	            'RingerOff': '\uF2C5',
	            'PlayResume': '\uF2C6',
	            'BulletedList2': '\uF2C7',
	            'BulletedList2Mirrored': '\uF2C8',
	            'ImageCrosshair': '\uF2C9',
	            'GitGraph': '\uF2CA',
	            'Repo': '\uF2CB',
	            'RepoSolid': '\uF2CC',
	            'FolderQuery': '\uF2CD',
	            'FolderList': '\uF2CE',
	            'FolderListMirrored': '\uF2CF',
	            'LocationOutline': '\uF2D0',
	            'POISolid': '\uF2D1',
	            'CalculatorNotEqualTo': '\uF2D2',
	            'BoxSubtractSolid': '\uF2D3',
	            'BoxAdditionSolid': '\uF2D4',
	            'BoxMultiplySolid': '\uF2D5',
	            'BoxPlaySolid': '\uF2D6',
	            'BoxCheckmarkSolid': '\uF2D7',
	            'CirclePauseSolid': '\uF2D8',
	            'CirclePause': '\uF2D9',
	            'MSNVideosSolid': '\uF2DA',
	            'CircleStopSolid': '\uF2DB',
	            'CircleStop': '\uF2DC',
	            'NavigateBack': '\uF2DD',
	            'NavigateBackMirrored': '\uF2DE',
	            'NavigateForward': '\uF2DF',
	            'NavigateForwardMirrored': '\uF2E0',
	            'UnknownSolid': '\uF2E1',
	            'UnknownMirroredSolid': '\uF2E2',
	            'CircleAddition': '\uF2E3',
	            'CircleAdditionSolid': '\uF2E4',
	            'FilePDB': '\uF2E5',
	            'FileTemplate': '\uF2E6',
	            'FileSQL': '\uF2E7',
	            'FileJAVA': '\uF2E8',
	            'FileASPX': '\uF2E9',
	            'FileCSS': '\uF2EA',
	            'FileSass': '\uF2EB',
	            'FileLess': '\uF2EC',
	            'FileHTML': '\uF2ED',
	            'JavaScriptLanguage': '\uF2EE',
	            'CSharpLanguage': '\uF2EF',
	            'CSharp': '\uF2F0',
	            'VisualBasicLanguage': '\uF2F1',
	            'VB': '\uF2F2',
	            'CPlusPlusLanguage': '\uF2F3'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-9.js.map

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-10\"",
	            src: "url('" + baseUrl + "fabric-icons-10-fb519450.woff') format('woff')"
	        },
	        icons: {
	            'CPlusPlus': '\uF2F4',
	            'FSharpLanguage': '\uF2F5',
	            'FSharp': '\uF2F6',
	            'TypeScriptLanguage': '\uF2F7',
	            'PythonLanguage': '\uF2F8',
	            'PY': '\uF2F9',
	            'CoffeeScript': '\uF2FA',
	            'MarkDownLanguage': '\uF2FB',
	            'FullWidth': '\uF2FE',
	            'FullWidthEdit': '\uF2FF',
	            'Plug': '\uF300',
	            'PlugSolid': '\uF301',
	            'PlugConnected': '\uF302',
	            'PlugDisconnected': '\uF303',
	            'UnlockSolid': '\uF304',
	            'Variable': '\uF305',
	            'Parameter': '\uF306',
	            'CommentUrgent': '\uF307',
	            'Storyboard': '\uF308',
	            'DiffInline': '\uF309',
	            'DiffSideBySide': '\uF30A',
	            'ImageDiff': '\uF30B',
	            'ImagePixel': '\uF30C',
	            'FileBug': '\uF30D',
	            'FileCode': '\uF30E',
	            'FileComment': '\uF30F',
	            'BusinessHoursSign': '\uF310',
	            'FileImage': '\uF311',
	            'FileSymlink': '\uF312',
	            'AutoFillTemplate': '\uF313',
	            'WorkItem': '\uF314',
	            'WorkItemBug': '\uF315',
	            'LogRemove': '\uF316',
	            'ColumnOptions': '\uF317',
	            'Packages': '\uF318',
	            'BuildIssue': '\uF319',
	            'AssessmentGroup': '\uF31A',
	            'VariableGroup': '\uF31B',
	            'FullHistory': '\uF31C',
	            'SingleColumnEdit': '\uF321',
	            'DoubleColumnEdit': '\uF322',
	            'TripleColumnEdit': '\uF323',
	            'ColumnLeftTwoThirdsEdit': '\uF324',
	            'ColumnRightTwoThirdsEdit': '\uF325',
	            'StreamLogo': '\uF329',
	            'PassiveAuthentication': '\uF32A',
	            'AlertSolid': '\uF331',
	            'MegaphoneSolid': '\uF332',
	            'TaskSolid': '\uF333',
	            'ConfigurationSolid': '\uF334',
	            'BugSolid': '\uF335',
	            'CrownSolid': '\uF336',
	            'Trophy2Solid': '\uF337',
	            'QuickNoteSolid': '\uF338',
	            'ConstructionConeSolid': '\uF339',
	            'PageListSolid': '\uF33A',
	            'PageListMirroredSolid': '\uF33B',
	            'StarburstSolid': '\uF33C',
	            'ReadingModeSolid': '\uF33D',
	            'SadSolid': '\uF33E',
	            'HealthSolid': '\uF33F',
	            'ShieldSolid': '\uF340',
	            'GiftBoxSolid': '\uF341',
	            'ShoppingCartSolid': '\uF342',
	            'MailSolid': '\uF343',
	            'ChatSolid': '\uF344',
	            'RibbonSolid': '\uF345',
	            'FinancialSolid': '\uF346',
	            'FinancialMirroredSolid': '\uF347',
	            'HeadsetSolid': '\uF348',
	            'PermissionsSolid': '\uF349',
	            'ParkingSolid': '\uF34A',
	            'ParkingMirroredSolid': '\uF34B',
	            'DiamondSolid': '\uF34C',
	            'AsteriskSolid': '\uF34D',
	            'OfflineStorageSolid': '\uF34E',
	            'BankSolid': '\uF34F',
	            'DecisionSolid': '\uF350',
	            'Parachute': '\uF351',
	            'ParachuteSolid': '\uF352',
	            'FiltersSolid': '\uF353',
	            'ColorSolid': '\uF354',
	            'ReviewSolid': '\uF355',
	            'ReviewRequestSolid': '\uF356',
	            'ReviewRequestMirroredSolid': '\uF357',
	            'ReviewResponseSolid': '\uF358',
	            'FeedbackRequestSolid': '\uF359',
	            'FeedbackRequestMirroredSolid': '\uF35A',
	            'FeedbackResponseSolid': '\uF35B',
	            'WorkItemBar': '\uF35C',
	            'WorkItemBarSolid': '\uF35D',
	            'Separator': '\uF35E',
	            'NavigateExternalInline': '\uF35F',
	            'PlanView': '\uF360',
	            'TimelineMatrixView': '\uF361',
	            'EngineeringGroup': '\uF362',
	            'ProjectCollection': '\uF363',
	            'CaretBottomRightCenter8': '\uF364',
	            'CaretBottomLeftCenter8': '\uF365',
	            'CaretTopRightCenter8': '\uF366'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-10.js.map

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-11\"",
	            src: "url('" + baseUrl + "fabric-icons-11-a4026982.woff') format('woff')"
	        },
	        icons: {
	            'CaretTopLeftCenter8': '\uF367',
	            'DonutChart': '\uF368',
	            'ChevronUnfold10': '\uF369',
	            'ChevronFold10': '\uF36A',
	            'DoubleChevronDown8': '\uF36B',
	            'DoubleChevronUp8': '\uF36C',
	            'DoubleChevronLeft8': '\uF36D',
	            'DoubleChevronRight8': '\uF36E',
	            'ChevronDownEnd6': '\uF36F',
	            'ChevronUpEnd6': '\uF370',
	            'ChevronLeftEnd6': '\uF371',
	            'ChevronRightEnd6': '\uF372',
	            'ContextMenu': '\uF37C',
	            'AzureAPIManagement': '\uF37F',
	            'AzureServiceEndpoint': '\uF380',
	            'VSTSLogo': '\uF381',
	            'VSTSAltLogo1': '\uF382',
	            'VSTSAltLogo2': '\uF383',
	            'FileTypeSolution': '\uF387',
	            'WordLogoInverse16': '\uF390',
	            'WordLogo16': '\uF391',
	            'WordLogoFill16': '\uF392',
	            'PowerPointLogoInverse16': '\uF393',
	            'PowerPointLogo16': '\uF394',
	            'PowerPointLogoFill16': '\uF395',
	            'ExcelLogoInverse16': '\uF396',
	            'ExcelLogo16': '\uF397',
	            'ExcelLogoFill16': '\uF398',
	            'OneNoteLogoInverse16': '\uF399',
	            'OneNoteLogo16': '\uF39A',
	            'OneNoteLogoFill16': '\uF39B',
	            'OutlookLogoInverse16': '\uF39C',
	            'OutlookLogo16': '\uF39D',
	            'OutlookLogoFill16': '\uF39E',
	            'PublisherLogoInverse16': '\uF39F',
	            'PublisherLogo16': '\uF3A0',
	            'PublisherLogoFill16': '\uF3A1',
	            'VisioLogoInverse16': '\uF3A2',
	            'VisioLogo16': '\uF3A3',
	            'VisioLogoFill16': '\uF3A4',
	            'TestBeaker': '\uF3A5',
	            'TestBeakerSolid': '\uF3A6',
	            'TestExploreSolid': '\uF3A7',
	            'TestAutoSolid': '\uF3A8',
	            'TestUserSolid': '\uF3A9',
	            'TestImpactSolid': '\uF3AA',
	            'TestPlan': '\uF3AB',
	            'TestStep': '\uF3AC',
	            'TestParameter': '\uF3AD',
	            'TestSuite': '\uF3AE',
	            'TestCase': '\uF3AF',
	            'Sprint': '\uF3B0',
	            'SignOut': '\uF3B1',
	            'TriggerApproval': '\uF3B2',
	            'Rocket': '\uF3B3',
	            'AzureKeyVault': '\uF3B4',
	            'Transition': '\uF3BC',
	            'LikeSolid': '\uF3BF',
	            'DislikeSolid': '\uF3C0',
	            'UnSetColor': '\uF3F9',
	            'DeclineCall': '\uF405',
	            'RectangularClipping': '\uF407',
	            'TeamsLogo16': '\uF40A',
	            'TeamsLogoFill16': '\uF40B',
	            'Spacer': '\uF40D',
	            'SkypeLogo16': '\uF40E',
	            'SkypeForBusinessLogo16': '\uF40F',
	            'SkypeForBusinessLogoFill16': '\uF410',
	            'FilterSolid': '\uF412',
	            'MailUndelivered': '\uF415',
	            'MailTentative': '\uF416',
	            'MailTentativeMirrored': '\uF417',
	            'MailReminder': '\uF418',
	            'ReceiptUndelivered': '\uF419',
	            'ReceiptTentative': '\uF41A',
	            'ReceiptTentativeMirrored': '\uF41B',
	            'Inbox': '\uF41C',
	            'IRMReply': '\uF41D',
	            'IRMReplyMirrored': '\uF41E',
	            'IRMForward': '\uF41F',
	            'IRMForwardMirrored': '\uF420',
	            'VoicemailIRM': '\uF421',
	            'EventAccepted': '\uF422',
	            'EventTentative': '\uF423',
	            'EventTentativeMirrored': '\uF424',
	            'EventDeclined': '\uF425',
	            'IDBadge': '\uF427',
	            'BackgroundColor': '\uF42B',
	            'OfficeFormsLogoInverse16': '\uF433',
	            'OfficeFormsLogo': '\uF434',
	            'OfficeFormsLogoFill': '\uF435',
	            'OfficeFormsLogo16': '\uF436',
	            'OfficeFormsLogoFill16': '\uF437',
	            'OfficeFormsLogoInverse24': '\uF43A',
	            'OfficeFormsLogo24': '\uF43B',
	            'OfficeFormsLogoFill24': '\uF43C',
	            'PageLock': '\uF43F',
	            'NotExecuted': '\uF440',
	            'NotImpactedSolid': '\uF441',
	            'FieldReadOnly': '\uF442'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-11.js.map

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-12\"",
	            src: "url('" + baseUrl + "fabric-icons-12-e6882c74.woff') format('woff')"
	        },
	        icons: {
	            'FieldRequired': '\uF443',
	            'BacklogBoard': '\uF444',
	            'ExternalBuild': '\uF445',
	            'ExternalTFVC': '\uF446',
	            'ExternalXAML': '\uF447',
	            'IssueSolid': '\uF448',
	            'DefectSolid': '\uF449',
	            'LadybugSolid': '\uF44A',
	            'NugetLogo': '\uF44C',
	            'TFVCLogo': '\uF44D',
	            'ProjectLogo32': '\uF47E',
	            'ProjectLogoFill32': '\uF47F',
	            'ProjectLogo16': '\uF480',
	            'ProjectLogoFill16': '\uF481',
	            'SwayLogo32': '\uF482',
	            'SwayLogoFill32': '\uF483',
	            'SwayLogo16': '\uF484',
	            'SwayLogoFill16': '\uF485',
	            'ClassNotebookLogo32': '\uF486',
	            'ClassNotebookLogoFill32': '\uF487',
	            'ClassNotebookLogo16': '\uF488',
	            'ClassNotebookLogoFill16': '\uF489',
	            'ClassNotebookLogoInverse32': '\uF48A',
	            'ClassNotebookLogoInverse16': '\uF48B',
	            'StaffNotebookLogo32': '\uF48C',
	            'StaffNotebookLogoFill32': '\uF48D',
	            'StaffNotebookLogo16': '\uF48E',
	            'StaffNotebookLogoFill16': '\uF48F',
	            'StaffNotebookLogoInverted32': '\uF490',
	            'StaffNotebookLogoInverted16': '\uF491',
	            'KaizalaLogo': '\uF492',
	            'TaskLogo': '\uF493',
	            'ProtectionCenterLogo32': '\uF494',
	            'GallatinLogo': '\uF496',
	            'Globe2': '\uF49A',
	            'Guitar': '\uF49B',
	            'Breakfast': '\uF49C',
	            'Brunch': '\uF49D',
	            'BeerMug': '\uF49E',
	            'Vacation': '\uF49F',
	            'Teeth': '\uF4A0',
	            'Taxi': '\uF4A1',
	            'Chopsticks': '\uF4A2',
	            'SyncOccurence': '\uF4A3',
	            'UnsyncOccurence': '\uF4A4',
	            'PrimaryCalendar': '\uF4AE',
	            'SearchCalendar': '\uF4AF',
	            'VideoOff': '\uF4B0',
	            'MicrosoftFlowLogo': '\uF4B1',
	            'BusinessCenterLogo': '\uF4B2',
	            'ToDoLogoBottom': '\uF4B3',
	            'ToDoLogoTop': '\uF4B4',
	            'EditSolid12': '\uF4B5',
	            'EditSolidMirrored12': '\uF4B6',
	            'UneditableSolid12': '\uF4B7',
	            'UneditableSolidMirrored12': '\uF4B8',
	            'UneditableMirrored': '\uF4B9',
	            'AdminALogo32': '\uF4BA',
	            'AdminALogoFill32': '\uF4BB',
	            'ToDoLogoInverse': '\uF4BC',
	            'Snooze': '\uF4BD',
	            'WaffleOffice365': '\uF4E0',
	            'ImageSearch': '\uF4E8',
	            'NewsSearch': '\uF4E9',
	            'VideoSearch': '\uF4EA',
	            'R': '\uF4EB',
	            'FontColorA': '\uF4EC',
	            'FontColorSwatch': '\uF4ED',
	            'LightWeight': '\uF4EE',
	            'NormalWeight': '\uF4EF',
	            'SemiboldWeight': '\uF4F0',
	            'GroupObject': '\uF4F1',
	            'UngroupObject': '\uF4F2',
	            'AlignHorizontalLeft': '\uF4F3',
	            'AlignHorizontalCenter': '\uF4F4',
	            'AlignHorizontalRight': '\uF4F5',
	            'AlignVerticalTop': '\uF4F6',
	            'AlignVerticalCenter': '\uF4F7',
	            'AlignVerticalBottom': '\uF4F8',
	            'HorizontalDistributeCenter': '\uF4F9',
	            'VerticalDistributeCenter': '\uF4FA',
	            'Ellipse': '\uF4FB',
	            'Line': '\uF4FC',
	            'Octagon': '\uF4FD',
	            'Hexagon': '\uF4FE',
	            'Pentagon': '\uF4FF',
	            'RightTriangle': '\uF500',
	            'HalfCircle': '\uF501',
	            'QuarterCircle': '\uF502',
	            'ThreeQuarterCircle': '\uF503',
	            '6PointStar': '\uF504',
	            '12PointStar': '\uF505',
	            'ArrangeBringToFront': '\uF506',
	            'ArrangeSendToBack': '\uF507',
	            'ArrangeSendBackward': '\uF508',
	            'ArrangeBringForward': '\uF509',
	            'BorderDash': '\uF50A',
	            'BorderDot': '\uF50B',
	            'LineStyle': '\uF50C',
	            'LineThickness': '\uF50D'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-12.js.map

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-13\"",
	            src: "url('" + baseUrl + "fabric-icons-13-0980cd6d.woff') format('woff')"
	        },
	        icons: {
	            'WindowEdit': '\uF50E',
	            'HintText': '\uF50F',
	            'MediaAdd': '\uF510',
	            'AnchorLock': '\uF511',
	            'AutoHeight': '\uF512',
	            'ChartSeries': '\uF513',
	            'ChartXAngle': '\uF514',
	            'ChartYAngle': '\uF515',
	            'Combobox': '\uF516',
	            'LineSpacing': '\uF517',
	            'Padding': '\uF518',
	            'PaddingTop': '\uF519',
	            'PaddingBottom': '\uF51A',
	            'PaddingLeft': '\uF51B',
	            'PaddingRight': '\uF51C',
	            'NavigationFlipper': '\uF51D',
	            'AlignJustify': '\uF51E',
	            'TextOverflow': '\uF51F',
	            'VisualsFolder': '\uF520',
	            'VisualsStore': '\uF521',
	            'PictureCenter': '\uF522',
	            'PictureFill': '\uF523',
	            'PicturePosition': '\uF524',
	            'PictureStretch': '\uF525',
	            'PictureTile': '\uF526',
	            'Slider': '\uF527',
	            'SliderHandleSize': '\uF528',
	            'DefaultRatio': '\uF529',
	            'NumberSequence': '\uF52A',
	            'GUID': '\uF52B',
	            'ReportAdd': '\uF52C',
	            'DashboardAdd': '\uF52D',
	            'MapPinSolid': '\uF52E',
	            'WebPublish': '\uF52F',
	            'PieSingleSolid': '\uF530',
	            'BlockedSolid': '\uF531',
	            'DrillDown': '\uF532',
	            'DrillDownSolid': '\uF533',
	            'DrillExpand': '\uF534',
	            'DrillShow': '\uF535',
	            'OneDriveFolder16': '\uF53B',
	            'FunctionalManagerDashboard': '\uF542',
	            'BIDashboard': '\uF543',
	            'CodeEdit': '\uF544',
	            'RenewalCurrent': '\uF545',
	            'RenewalFuture': '\uF546',
	            'SplitObject': '\uF547',
	            'BulkUpload': '\uF548',
	            'DownloadDocument': '\uF549',
	            'WaitlistConfirm': '\uF550',
	            'WaitlistConfirmMirrored': '\uF551',
	            'LaptopSecure': '\uF552',
	            'DragObject': '\uF553',
	            'EntryView': '\uF554',
	            'EntryDecline': '\uF555',
	            'ContactCardSettings': '\uF556',
	            'ContactCardSettingsMirrored': '\uF557',
	            'CalendarSettings': '\uF558',
	            'CalendarSettingsMirrored': '\uF559',
	            'HardDriveLock': '\uF55A',
	            'HardDriveUnlock': '\uF55B',
	            'AccountManagement': '\uF55C',
	            'TransitionPop': '\uF5B2',
	            'TransitionPush': '\uF5B3',
	            'TransitionEffect': '\uF5B4',
	            'LookupEntities': '\uF5B5',
	            'ExploreData': '\uF5B6',
	            'AddBookmark': '\uF5B7',
	            'SearchBookmark': '\uF5B8',
	            'DrillThrough': '\uF5B9',
	            'MasterDatabase': '\uF5BA',
	            'CertifiedDatabase': '\uF5BB',
	            'MaximumValue': '\uF5BC',
	            'MinimumValue': '\uF5BD',
	            'VisualStudioIDELogo32': '\uF5D0',
	            'PasteAsText': '\uF5D5',
	            'PasteAsCode': '\uF5D6',
	            'BrowserTab': '\uF5D7',
	            'BrowserTabScreenshot': '\uF5D8',
	            'DesktopScreenshot': '\uF5D9',
	            'FileYML': '\uF5DA',
	            'ClipboardSolid': '\uF5DC',
	            'AnalyticsView': '\uF5F1',
	            'Leave': '\uF627',
	            'Trending12': '\uF62D',
	            'Blocked12': '\uF62E',
	            'Warning12': '\uF62F',
	            'CheckedOutByOther12': '\uF630',
	            'CheckedOutByYou12': '\uF631',
	            'CircleShapeSolid': '\uF63C',
	            'SquareShapeSolid': '\uF63D',
	            'TriangleShapeSolid': '\uF63E',
	            'DropShapeSolid': '\uF63F',
	            'RectangleShapeSolid': '\uF640',
	            'InsertColumnsLeft': '\uF64A',
	            'InsertColumnsRight': '\uF64B',
	            'InsertRowsAbove': '\uF64C',
	            'InsertRowsBelow': '\uF64D',
	            'DeleteColumns': '\uF64E',
	            'DeleteRows': '\uF64F'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-13.js.map

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:max-line-length
	var index_1 = __webpack_require__(2306);
	function initializeIcons(baseUrl, options) {
	    if (baseUrl === void 0) { baseUrl = ''; }
	    var subset = {
	        style: {
	            MozOsxFontSmoothing: 'grayscale',
	            WebkitFontSmoothing: 'antialiased',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            speak: 'none'
	        },
	        fontFace: {
	            fontFamily: "\"FabricMDL2Icons-14\"",
	            src: "url('" + baseUrl + "fabric-icons-14-eb4d1150.woff') format('woff')"
	        },
	        icons: {
	            'DeleteRowsMirrored': '\uF650',
	            'DeleteTable': '\uF651',
	            'VersionControlPush': '\uF664',
	            'WhiteBoardApp16': '\uF673',
	            'WhiteBoardApp32': '\uF674',
	            'InsertSignatureLine': '\uF677',
	            'ArrangeByFrom': '\uF678',
	            'Phishing': '\uF679',
	            'CreateMailRule': '\uF67A',
	            'PublishCourse': '\uF699',
	            'DictionaryRemove': '\uF69A',
	            'UserRemove': '\uF69B',
	            'UserEvent': '\uF69C',
	            'Encryption': '\uF69D',
	            'D365TalentLearn': '\uF6BB',
	            'D365TalentInsight': '\uF6BC',
	            'D365TalentHRCore': '\uF6BD',
	            'BacklogList': '\uF6BF',
	            'ButtonControl': '\uF6C0',
	            'TableGroup': '\uF6D9',
	            'MountainClimbing': '\uF6DB',
	            'TagUnknown': '\uF6DF',
	            'TagUnknownMirror': '\uF6E0',
	            'TagUnknown12': '\uF6E1',
	            'TagUnknown12Mirror': '\uF6E2',
	            'Link12': '\uF6E3',
	            'Presentation': '\uF6E4',
	            'Presentation12': '\uF6E5',
	            'Lock12': '\uF6E6',
	            'BuildDefinition': '\uF6E9',
	            'ReleaseDefinition': '\uF6EA',
	            'SaveTemplate': '\uF6EC',
	            'UserGauge': '\uF6ED',
	            'BlockedSiteSolid12': '\uF70A',
	            'TagSolid': '\uF70E',
	            'OfficeChat': '\uF70F',
	            'OfficeChatSolid': '\uF710',
	            'MailSchedule': '\uF72E'
	        }
	    };
	    index_1.registerIcons(subset, options);
	}
	exports.initializeIcons = initializeIcons;
	//# sourceMappingURL=fabric-icons-14.js.map

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2306);
	index_1.registerIconAlias('trash', 'delete');
	index_1.registerIconAlias('onedrive', 'onedrivelogo');
	//# sourceMappingURL=iconAliases.js.map

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _require = __webpack_require__(__webpack_module_template_argument_0__),
	    Draggable = _require.default,
	    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	
	
	module.exports = Draggable;
	module.exports.default = Draggable;
	module.exports.DraggableCore = DraggableCore;

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../../../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../../../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(411)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../../../node_modules/postcss-loader/src/index.js!../../../../../../../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.min.js